webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	module.exports = __webpack_require__(148);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _angular = __webpack_require__(151);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(153);
	
	__webpack_require__(156);
	
	var _app = __webpack_require__(158);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _projects = __webpack_require__(182);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _asideCtrl = __webpack_require__(860);
	
	var _asideCtrl2 = _interopRequireDefault(_asideCtrl);
	
	var _welcomeCtrl = __webpack_require__(861);
	
	var _welcomeCtrl2 = _interopRequireDefault(_welcomeCtrl);
	
	var _headerCtrl = __webpack_require__(862);
	
	var _headerCtrl2 = _interopRequireDefault(_headerCtrl);
	
	var _globalSrv = __webpack_require__(324);
	
	var _globalSrv2 = _interopRequireDefault(_globalSrv);
	
	var _modalSrv = __webpack_require__(839);
	
	var _modalSrv2 = _interopRequireDefault(_modalSrv);
	
	var _ramda = __webpack_require__(866);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _app3 = __webpack_require__(1175);
	
	var _userAuthDirective = __webpack_require__(1176);
	
	var _userAuthDirective2 = _interopRequireDefault(_userAuthDirective);
	
	var _powerbi = __webpack_require__(1177);
	
	var pbi = _interopRequireWildcard(_powerbi);
	
	var _powerBiSrv = __webpack_require__(1178);
	
	var _powerBiSrv2 = _interopRequireDefault(_powerBiSrv);
	
	var _loginController = __webpack_require__(1179);
	
	var _loginController2 = _interopRequireDefault(_loginController);
	
	var _loginErrorMessageController = __webpack_require__(1183);
	
	var _loginErrorMessageController2 = _interopRequireDefault(_loginErrorMessageController);
	
	var _helpers = __webpack_require__(1184);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localenvjson = __webpack_require__(159);
	var globalConfig = __webpack_require__(238);
	var cssClasses = __webpack_require__(1186);
	
	// require("fullcalendar");
	// require('./srcangularUtils.directives.dirPagination')
	// require('../bower_components/angular-file-upload/angular-file-upload.min.js');
	// require('../bower_components/textAngular/dist/textAngular.min.js');
	// require('../bower_components/venturocket-angular-slider/build/angular-slider.js');
	// require('moment');
	// require('../bower_components/angular-dragdrop/src/angular-dragdrop.js');
	// require('../bower_components/slick-carousel/slick/slick.js');
	// require('../bower_components/select2/select2.css');
	// require('../bower_components/select2/select2.js');
	// require('../bower_components/angular-ui-select2/src/select2.js');
	// require('../bower_components/angular-ui-select/dist/select.js');
	
	__webpack_require__(1187);
	__webpack_require__(1189);
	__webpack_require__(1197);
	__webpack_require__(1201);
	__webpack_require__(1204);
	__webpack_require__(1213);
	__webpack_require__(1221);
	__webpack_require__(1225);
	__webpack_require__(1229);
	__webpack_require__(1233);
	__webpack_require__(1239);
	__webpack_require__(1245);
	__webpack_require__(1252);
	__webpack_require__(1382);
	__webpack_require__(1386);
	__webpack_require__(1389);
	__webpack_require__(1237);
	__webpack_require__(1391);
	__webpack_require__(1393);
	__webpack_require__(1395);
	__webpack_require__(1397);
	__webpack_require__(1229);
	__webpack_require__(1399);
	__webpack_require__(1403);
	__webpack_require__(1407);
	__webpack_require__(1411);
	__webpack_require__(1415);
	__webpack_require__(1417);
	__webpack_require__(1419);
	__webpack_require__(1421);
	__webpack_require__(1423);
	__webpack_require__(1425);
	__webpack_require__(1429);
	__webpack_require__(1431);
	__webpack_require__(1435);
	__webpack_require__(1437);
	__webpack_require__(1439);
	__webpack_require__(1441);
	__webpack_require__(1443);
	__webpack_require__(1403);
	__webpack_require__(1407);
	__webpack_require__(1445);
	__webpack_require__(1447);
	__webpack_require__(1449);
	__webpack_require__(1451);
	__webpack_require__(1453);
	__webpack_require__(1455);
	__webpack_require__(1457);
	__webpack_require__(1459);
	__webpack_require__(1461);
	__webpack_require__(1463);
	__webpack_require__(1465);
	__webpack_require__(1467);
	__webpack_require__(1469);
	__webpack_require__(1472);
	__webpack_require__(1474);
	__webpack_require__(1476);
	__webpack_require__(1478);
	__webpack_require__(1480);
	__webpack_require__(1483);
	// Licensed Services
	__webpack_require__(1485);
	__webpack_require__(1486);
	
	// Bower Modules
	__webpack_require__(1487);
	__webpack_require__(1488);
	__webpack_require__(1494);
	__webpack_require__(1495);
	__webpack_require__(1496);
	// require('../bower_components/font-awesome/css/font-awesome.css')
	__webpack_require__(1497);
	__webpack_require__(1499);
	__webpack_require__(1501);
	__webpack_require__(1503);
	__webpack_require__(1505);
	__webpack_require__(1507);
	__webpack_require__(1509);
	__webpack_require__(1511);
	__webpack_require__(1513);
	__webpack_require__(1515);
	__webpack_require__(1517);
	__webpack_require__(1519);
	__webpack_require__(1521);
	__webpack_require__(1523);
	__webpack_require__(1499);
	__webpack_require__(1525);
	__webpack_require__(1527);
	
	window.pdfmake = {};
	
	window.taTools = {};
	__webpack_require__(1243);
	__webpack_require__(1529);
	
	__webpack_require__(1531);
	__webpack_require__(1533);
	// require('angular-chat')
	
	// funcionalidad para exportal una tabla html a excel
	__webpack_require__(1535);
	
	//require file script and variable for switch styles according to customer
	var clientName = localenvjson.clientName;
	
	try {
		__webpack_require__(1537)("./app-" + clientName + '.less');
	} catch (error) {
		__webpack_require__(1554);
	}
	
	window['powerbi-client'] = pbi;
	
	_angular2.default.module('app', [
	// 'ui.load',
	// 'ui.jp',
	'chat', 'btford.socket-io', 'validation.match', 'pascalprecht.translate', 'angular-loading-bar', 'angular.filter', 'textAngular', 'xeditable', 'highcharts-ng', 'treeGrid', 'angularUtils.directives.dirPagination', 'daterangepicker', 'disableAll', 'slick', 'uplannerPermission', 'angularFileUpload', 'mwl.calendar', 'ngNotify', 'ngCsv', 'ngAnimate', 'ngAria', 'ngCookies', 'ngMessages', 'ngMaterial', 'ngResource', 'ngSanitize', 'ngTouch', 'ngMaterial', 'ngStorage', 'ngBreadCrumb', 'ui.router', 'ui.select2', 'ui.select', 'ui.router', 'ui.utils', 'ui.bootstrap', 'ui.map', 'ui.grid', 'ui.grid.selection', 'ui.grid.treeView', 'ui.grid.grouping', 'ui.grid.exporter', 'ui.bootstrap.contextMenu', 'ui.grid.expandable', 'ui.grid.pinning', 'ui.grid.pagination', 'luegg.directives', 'ngYoutubeEmbed', 'ngFileUpload', 'wu.masonry', 'angular-clipboard', 'base64', _projects2.default, _globalSrv2.default, _modalSrv2.default, 'report', _powerBiSrv2.default, _helpers2.default]).config(_app2.default) // router for the aside menu of the app
	.controller('AsideCtrl', _asideCtrl2.default) // controller for the aside menu of the app
	.controller('HeaderCtrl', _headerCtrl2.default) // controller for the header of the app
	.controller('welcomeCtrl', _welcomeCtrl2.default) // controller for the header of the app
	.controller('loginController', _loginController2.default).controller('loginErrorMessageController', _loginErrorMessageController2.default).value('permissionList', [{ details: [] }]) // user permissions list
	.constant('Ramda', _ramda2.default).constant('MenuConstant', [{ menu: [] }]).constant('ClientBaseFilePathConstant', [{ constant_url: [] }]).constant('UserInfoConstant', [{ details: [] }]).constant('GlobalConfig', globalConfig).constant('CssClasses', cssClasses).constant('SERVICE_URL_CONSTANT', localenvjson.SERVICE_URL_CONSTANT).constant('LOCAL_ENV_CONSTANT', localenvjson).run(['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'permissions', 'permissionList', '$location', function ($rootScope, $templateCache, $state, $stateParams, $timeout, permissions, permissionList, $location) {
		// console.log('permissions', permissions)
		$templateCache.put('aside.nav.uikit.html', __webpack_require__(1558));
		$templateCache.put('ngBreadCrumbTemplate.html', __webpack_require__(1559));
		$templateCache.put('setupErrorModal', __webpack_require__(705));
		$rootScope.$state = $state;
		$rootScope.$stateParams = $stateParams;
	
		if ($location.path() == '/' || $location.path() == '/app') {
			$location.path('/app/welcomeHome');
		}
	}]).directive('onlyInteger', _app3.onlyInteger).directive('errSrc', _app3.errSrc);
	_angular2.default.module('chat').constant('config', {
		rltm: {
			service: 'pubnub',
			config: {
				publishKey: 'pub-c-a911f2d1-f798-4bea-beb9-2417ca348fe9',
				subscribeKey: 'sub-c-3f8e8e40-f201-11e6-bba1-0619f8945a4f'
			}
		}
	}).directive('powerbiScopeWithController', function () {
		var controller = ['$scope', '$http', '$timeout', '$localStorage', 'LOCAL_ENV_CONSTANT', function ($scope, $http, $timeout, $localStorage, LOCAL_ENV_CONSTANT) {
			function init() {
				if (typeof $scope.WORKSPACEID === 'undefined') {
					return false;
				}
	
				var selectedWorkspace = $scope.WORKSPACEID;
	
				if (typeof $localStorage.embeded === 'undefined') var expiry = false;else var expiry = parseInt($localStorage.embeded.expires_on);
	
				var offset = 300;
	
				// expiry=1511196676 
				console.log(expiry, 'expirytime', Math.round(new Date().getTime() / 1000.0) + offset);
	
				if (expiry && expiry > Math.round(new Date().getTime() / 1000.0) + offset) {
					// console.log(expiry,'tttt',Math.round(new Date().getTime() / 1000.0) + offset)
					// return true
					// delete $localStorage.embeded
				} else {
					delete $localStorage.embeded;
				}
	
				var getItems = $localStorage.embeded;
	
				if (typeof getItems === 'undefined') {
					$http({
						crossDomain: true,
						xhrFields: { withCredentials: false },
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
						},
						method: 'POST',
						// data:$.param(param),
						url: LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.API_URL
					}).then(function (response) {
						var data = response.data.data;
						// console.log("sample: "+JSON.stringify(data));
						var tokenAttributes = JSON.parse(data);
						var token = tokenAttributes.access_token;
	
						$localStorage.embeded = tokenAttributes;
	
						getReport(selectedWorkspace, token);
	
						//  // Get the list of reports
					}, function (response) {
						console.log('Error:   ' + JSON.stringify(response));
					});
				} else {
					getReport(selectedWorkspace, getItems.access_token);
				}
			}
	
			init();
	
			function getReport(selectedWorkspace, token) {
				$timeout(function () {
					$http.get('https://api.powerbi.com/v1.0/myorg/' + (selectedWorkspace ? 'groups/' + selectedWorkspace + '/reports' : 'reports'), {
						headers: {
							'Authorization': 'Bearer  ' + token,
							'Content-Type': 'application/json; charset=utf-8'
						}
					}).then(function (response) {
						$scope.reports = response.data.value;
	
						for (var i in $scope.reports) {
							//'U-Forecast Datos'
							if ($scope.reports[i].name == $scope.REPORTID) {
								$scope.selectedReport = $scope.reports[i];
							}
						}
						// $scope.selectedReport = $scope.reports[0].embedUrl;
	
						var models = window['powerbi-client'].models;
						var embedConfiguration = {
							type: 'report',
							accessToken: token,
							embedUrl: $scope.selectedReport.embedUrl,
							permissions: models.Permissions.All,
							settings: {
								filterPaneEnabled: false,
								navContentPaneEnabled: true
							},
							pageView: 'fitToWidth'
						};
	
						var $reportContainer = $('#embedContainer');
	
						var report = powerbi.embedNew($reportContainer.get(0), embedConfiguration);
	
						$timeout(function () {
							document.getElementById('embedContainer').style.height = window.innerHeight - 10 + 'px';
						}, 1000);
	
						$(window).resize(function () {
							document.getElementById('embedContainer').style.height = window.innerHeight - 10 + 'px';
						});
					}, function (error) {
						$scope.reportError = error;
					});
				}, 2000);
			}
		}],
		    template = '<div id="embedContainer" style="height: 600.823px;"></div>';
	
		return {
			restrict: 'EA', //Default in 1.3+
			scope: {
				datasource: '=',
				add: '&',
				WORKSPACEID: '@workspaceid',
				REPORTID: '@reportid'
			},
			controller: controller,
			template: template
		};
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(152);
	module.exports = angular;


/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(155))

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		function log(error) {
			(typeof console !== "undefined")
			&& (console.error || console.log)("[Script Loader]", error);
		}
	
		// Check for IE =< 8
		function isIE() {
			return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
		}
	
		try {
			if (typeof execScript !== "undefined" && isIE()) {
				execScript(src);
			} else if (typeof eval !== "undefined") {
				eval.call(null, src);
			} else {
				log("EvalError: No eval function available");
			}
		} catch (error) {
			log(error);
		}
	}


/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports = "(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require==\"function\"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error(\"Cannot find module '\"+o+\"'\");throw f.code=\"MODULE_NOT_FOUND\",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require==\"function\"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){\nfunction corslite(n,t,o){function e(n){return n>=200&&300>n||304===n}function i(){void 0===r.status||e(r.status)?t.call(r,null,r):t.call(r,r,null)}var l=!1;if(\"undefined\"==typeof window.XMLHttpRequest)return t(Error(\"Browser not supported\"));if(\"undefined\"==typeof o){var u=n.match(/^\\s*https?:\\/\\/[^\\/]*/);o=u&&u[0]!==location.protocol+\"//\"+location.domain+(location.port?\":\"+location.port:\"\")}var r=new window.XMLHttpRequest;if(o&&!(\"withCredentials\"in r)){r=new window.XDomainRequest;var a=t;t=function(){if(l)a.apply(this,arguments);else{var n=this,t=arguments;setTimeout(function(){a.apply(n,t)},0)}}}return\"onload\"in r?r.onload=i:r.onreadystatechange=function(){4===r.readyState&&i()},r.onerror=function(n){t.call(this,n||!0,null),t=function(){}},r.onprogress=function(){},r.ontimeout=function(n){t.call(this,n,null),t=function(){}},r.onabort=function(n){t.call(this,n,null),t=function(){}},r.open(\"GET\",n,!0),r.send(null),l=!0,r}\"undefined\"!=typeof module&&(module.exports=corslite);\n},{}],2:[function(require,module,exports){\nmodule.exports=Array.isArray||function(r){return\"[object Array]\"==Object.prototype.toString.call(r)};\n},{}],3:[function(require,module,exports){\n!function(t,e,i){var n=t.L,o={};o.version=\"0.7.7\",\"object\"==typeof module&&\"object\"==typeof module.exports?module.exports=o:\"function\"==typeof define&&define.amd&&define(o),o.noConflict=function(){return t.L=n,this},t.L=o,o.Util={extend:function(t){var e,i,n,o,s=Array.prototype.slice.call(arguments,1);for(i=0,n=s.length;n>i;i++){o=s[i]||{};for(e in o)o.hasOwnProperty(e)&&(t[e]=o[e])}return t},bind:function(t,e){var i=arguments.length>2?Array.prototype.slice.call(arguments,2):null;return function(){return t.apply(e,i||arguments)}},stamp:function(){var t=0,e=\"_leaflet_id\";return function(i){return i[e]=i[e]||++t,i[e]}}(),invokeEach:function(t,e,i){var n,o;if(\"object\"==typeof t){o=Array.prototype.slice.call(arguments,3);for(n in t)e.apply(i,[n,t[n]].concat(o));return!0}return!1},limitExecByInterval:function(t,e,i){var n,o;return function s(){var a=arguments;return n?void(o=!0):(n=!0,setTimeout(function(){n=!1,o&&(s.apply(i,a),o=!1)},e),void t.apply(i,a))}},falseFn:function(){return!1},formatNum:function(t,e){var i=Math.pow(10,e||5);return Math.round(t*i)/i},trim:function(t){return t.trim?t.trim():t.replace(/^\\s+|\\s+$/g,\"\")},splitWords:function(t){return o.Util.trim(t).split(/\\s+/)},setOptions:function(t,e){return t.options=o.extend({},t.options,e),t.options},getParamString:function(t,e,i){var n=[];for(var o in t)n.push(encodeURIComponent(i?o.toUpperCase():o)+\"=\"+encodeURIComponent(t[o]));return(e&&-1!==e.indexOf(\"?\")?\"&\":\"?\")+n.join(\"&\")},template:function(t,e){return t.replace(/\\{ *([\\w_]+) *\\}/g,function(t,n){var o=e[n];if(o===i)throw new Error(\"No value provided for variable \"+t);return\"function\"==typeof o&&(o=o(e)),o})},isArray:Array.isArray||function(t){return\"[object Array]\"===Object.prototype.toString.call(t)},emptyImageUrl:\"data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=\"},function(){function e(e){var i,n,o=[\"webkit\",\"moz\",\"o\",\"ms\"];for(i=0;i<o.length&&!n;i++)n=t[o[i]+e];return n}function i(e){var i=+new Date,o=Math.max(0,16-(i-n));return n=i+o,t.setTimeout(e,o)}var n=0,s=t.requestAnimationFrame||e(\"RequestAnimationFrame\")||i,a=t.cancelAnimationFrame||e(\"CancelAnimationFrame\")||e(\"CancelRequestAnimationFrame\")||function(e){t.clearTimeout(e)};o.Util.requestAnimFrame=function(e,n,a,r){return e=o.bind(e,n),a&&s===i?void e():s.call(t,e,r)},o.Util.cancelAnimFrame=function(e){e&&a.call(t,e)}}(),o.extend=o.Util.extend,o.bind=o.Util.bind,o.stamp=o.Util.stamp,o.setOptions=o.Util.setOptions,o.Class=function(){},o.Class.extend=function(t){var e=function(){this.initialize&&this.initialize.apply(this,arguments),this._initHooks&&this.callInitHooks()},i=function(){};i.prototype=this.prototype;var n=new i;n.constructor=e,e.prototype=n;for(var s in this)this.hasOwnProperty(s)&&\"prototype\"!==s&&(e[s]=this[s]);t.statics&&(o.extend(e,t.statics),delete t.statics),t.includes&&(o.Util.extend.apply(null,[n].concat(t.includes)),delete t.includes),t.options&&n.options&&(t.options=o.extend({},n.options,t.options)),o.extend(n,t),n._initHooks=[];var a=this;return e.__super__=a.prototype,n.callInitHooks=function(){if(!this._initHooksCalled){a.prototype.callInitHooks&&a.prototype.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,e=n._initHooks.length;e>t;t++)n._initHooks[t].call(this)}},e},o.Class.include=function(t){o.extend(this.prototype,t)},o.Class.mergeOptions=function(t){o.extend(this.prototype.options,t)},o.Class.addInitHook=function(t){var e=Array.prototype.slice.call(arguments,1),i=\"function\"==typeof t?t:function(){this[t].apply(this,e)};this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(i)};var s=\"_leaflet_events\";o.Mixin={},o.Mixin.Events={addEventListener:function(t,e,i){if(o.Util.invokeEach(t,this.addEventListener,this,e,i))return this;var n,a,r,h,l,u,c,d=this[s]=this[s]||{},p=i&&i!==this&&o.stamp(i);for(t=o.Util.splitWords(t),n=0,a=t.length;a>n;n++)r={action:e,context:i||this},h=t[n],p?(l=h+\"_idx\",u=l+\"_len\",c=d[l]=d[l]||{},c[p]||(c[p]=[],d[u]=(d[u]||0)+1),c[p].push(r)):(d[h]=d[h]||[],d[h].push(r));return this},hasEventListeners:function(t){var e=this[s];return!!e&&(t in e&&e[t].length>0||t+\"_idx\"in e&&e[t+\"_idx_len\"]>0)},removeEventListener:function(t,e,i){if(!this[s])return this;if(!t)return this.clearAllEventListeners();if(o.Util.invokeEach(t,this.removeEventListener,this,e,i))return this;var n,a,r,h,l,u,c,d,p,_=this[s],m=i&&i!==this&&o.stamp(i);for(t=o.Util.splitWords(t),n=0,a=t.length;a>n;n++)if(r=t[n],u=r+\"_idx\",c=u+\"_len\",d=_[u],e){if(h=m&&d?d[m]:_[r]){for(l=h.length-1;l>=0;l--)h[l].action!==e||i&&h[l].context!==i||(p=h.splice(l,1),p[0].action=o.Util.falseFn);i&&d&&0===h.length&&(delete d[m],_[c]--)}}else delete _[r],delete _[u],delete _[c];return this},clearAllEventListeners:function(){return delete this[s],this},fireEvent:function(t,e){if(!this.hasEventListeners(t))return this;var i,n,a,r,h,l=o.Util.extend({},e,{type:t,target:this}),u=this[s];if(u[t])for(i=u[t].slice(),n=0,a=i.length;a>n;n++)i[n].action.call(i[n].context,l);r=u[t+\"_idx\"];for(h in r)if(i=r[h].slice())for(n=0,a=i.length;a>n;n++)i[n].action.call(i[n].context,l);return this},addOneTimeEventListener:function(t,e,i){if(o.Util.invokeEach(t,this.addOneTimeEventListener,this,e,i))return this;var n=o.bind(function(){this.removeEventListener(t,e,i).removeEventListener(t,n,i)},this);return this.addEventListener(t,e,i).addEventListener(t,n,i)}},o.Mixin.Events.on=o.Mixin.Events.addEventListener,o.Mixin.Events.off=o.Mixin.Events.removeEventListener,o.Mixin.Events.once=o.Mixin.Events.addOneTimeEventListener,o.Mixin.Events.fire=o.Mixin.Events.fireEvent,function(){var n=\"ActiveXObject\"in t,s=n&&!e.addEventListener,a=navigator.userAgent.toLowerCase(),r=-1!==a.indexOf(\"webkit\"),h=-1!==a.indexOf(\"chrome\"),l=-1!==a.indexOf(\"phantom\"),u=-1!==a.indexOf(\"android\"),c=-1!==a.search(\"android [23]\"),d=-1!==a.indexOf(\"gecko\"),p=typeof orientation!=i+\"\",_=!t.PointerEvent&&t.MSPointerEvent,m=t.PointerEvent&&t.navigator.pointerEnabled||_,f=\"devicePixelRatio\"in t&&t.devicePixelRatio>1||\"matchMedia\"in t&&t.matchMedia(\"(min-resolution:144dpi)\")&&t.matchMedia(\"(min-resolution:144dpi)\").matches,g=e.documentElement,v=n&&\"transition\"in g.style,y=\"WebKitCSSMatrix\"in t&&\"m11\"in new t.WebKitCSSMatrix&&!c,P=\"MozPerspective\"in g.style,L=\"OTransition\"in g.style,x=!t.L_DISABLE_3D&&(v||y||P||L)&&!l,w=!t.L_NO_TOUCH&&!l&&(m||\"ontouchstart\"in t||t.DocumentTouch&&e instanceof t.DocumentTouch);o.Browser={ie:n,ielt9:s,webkit:r,gecko:d&&!r&&!t.opera&&!n,android:u,android23:c,chrome:h,ie3d:v,webkit3d:y,gecko3d:P,opera3d:L,any3d:x,mobile:p,mobileWebkit:p&&r,mobileWebkit3d:p&&y,mobileOpera:p&&t.opera,touch:w,msPointer:_,pointer:m,retina:f}}(),o.Point=function(t,e,i){this.x=i?Math.round(t):t,this.y=i?Math.round(e):e},o.Point.prototype={clone:function(){return new o.Point(this.x,this.y)},add:function(t){return this.clone()._add(o.point(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(o.point(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){return this.x*=t,this.y*=t,this},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},distanceTo:function(t){t=o.point(t);var e=t.x-this.x,i=t.y-this.y;return Math.sqrt(e*e+i*i)},equals:function(t){return t=o.point(t),t.x===this.x&&t.y===this.y},contains:function(t){return t=o.point(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return\"Point(\"+o.Util.formatNum(this.x)+\", \"+o.Util.formatNum(this.y)+\")\"}},o.point=function(t,e,n){return t instanceof o.Point?t:o.Util.isArray(t)?new o.Point(t[0],t[1]):t===i||null===t?t:new o.Point(t,e,n)},o.Bounds=function(t,e){if(t)for(var i=e?[t,e]:t,n=0,o=i.length;o>n;n++)this.extend(i[n])},o.Bounds.prototype={extend:function(t){return t=o.point(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new o.Point((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new o.Point(this.min.x,this.max.y)},getTopRight:function(){return new o.Point(this.max.x,this.min.y)},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var e,i;return t=\"number\"==typeof t[0]||t instanceof o.Point?o.point(t):o.bounds(t),t instanceof o.Bounds?(e=t.min,i=t.max):e=i=t,e.x>=this.min.x&&i.x<=this.max.x&&e.y>=this.min.y&&i.y<=this.max.y},intersects:function(t){t=o.bounds(t);var e=this.min,i=this.max,n=t.min,s=t.max,a=s.x>=e.x&&n.x<=i.x,r=s.y>=e.y&&n.y<=i.y;return a&&r},isValid:function(){return!(!this.min||!this.max)}},o.bounds=function(t,e){return!t||t instanceof o.Bounds?t:new o.Bounds(t,e)},o.Transformation=function(t,e,i,n){this._a=t,this._b=e,this._c=i,this._d=n},o.Transformation.prototype={transform:function(t,e){return this._transform(t.clone(),e)},_transform:function(t,e){return e=e||1,t.x=e*(this._a*t.x+this._b),t.y=e*(this._c*t.y+this._d),t},untransform:function(t,e){return e=e||1,new o.Point((t.x/e-this._b)/this._a,(t.y/e-this._d)/this._c)}},o.DomUtil={get:function(t){return\"string\"==typeof t?e.getElementById(t):t},getStyle:function(t,i){var n=t.style[i];if(!n&&t.currentStyle&&(n=t.currentStyle[i]),(!n||\"auto\"===n)&&e.defaultView){var o=e.defaultView.getComputedStyle(t,null);n=o?o[i]:null}return\"auto\"===n?null:n},getViewportOffset:function(t){var i,n=0,s=0,a=t,r=e.body,h=e.documentElement;do{if(n+=a.offsetTop||0,s+=a.offsetLeft||0,n+=parseInt(o.DomUtil.getStyle(a,\"borderTopWidth\"),10)||0,s+=parseInt(o.DomUtil.getStyle(a,\"borderLeftWidth\"),10)||0,i=o.DomUtil.getStyle(a,\"position\"),a.offsetParent===r&&\"absolute\"===i)break;if(\"fixed\"===i){n+=r.scrollTop||h.scrollTop||0,s+=r.scrollLeft||h.scrollLeft||0;break}if(\"relative\"===i&&!a.offsetLeft){var l=o.DomUtil.getStyle(a,\"width\"),u=o.DomUtil.getStyle(a,\"max-width\"),c=a.getBoundingClientRect();(\"none\"!==l||\"none\"!==u)&&(s+=c.left+a.clientLeft),n+=c.top+(r.scrollTop||h.scrollTop||0);break}a=a.offsetParent}while(a);a=t;do{if(a===r)break;n-=a.scrollTop||0,s-=a.scrollLeft||0,a=a.parentNode}while(a);return new o.Point(s,n)},documentIsLtr:function(){return o.DomUtil._docIsLtrCached||(o.DomUtil._docIsLtrCached=!0,o.DomUtil._docIsLtr=\"ltr\"===o.DomUtil.getStyle(e.body,\"direction\")),o.DomUtil._docIsLtr},create:function(t,i,n){var o=e.createElement(t);return o.className=i,n&&n.appendChild(o),o},hasClass:function(t,e){if(t.classList!==i)return t.classList.contains(e);var n=o.DomUtil._getClass(t);return n.length>0&&new RegExp(\"(^|\\\\s)\"+e+\"(\\\\s|$)\").test(n)},addClass:function(t,e){if(t.classList!==i)for(var n=o.Util.splitWords(e),s=0,a=n.length;a>s;s++)t.classList.add(n[s]);else if(!o.DomUtil.hasClass(t,e)){var r=o.DomUtil._getClass(t);o.DomUtil._setClass(t,(r?r+\" \":\"\")+e)}},removeClass:function(t,e){t.classList!==i?t.classList.remove(e):o.DomUtil._setClass(t,o.Util.trim((\" \"+o.DomUtil._getClass(t)+\" \").replace(\" \"+e+\" \",\" \")))},_setClass:function(t,e){t.className.baseVal===i?t.className=e:t.className.baseVal=e},_getClass:function(t){return t.className.baseVal===i?t.className:t.className.baseVal},setOpacity:function(t,e){if(\"opacity\"in t.style)t.style.opacity=e;else if(\"filter\"in t.style){var i=!1,n=\"DXImageTransform.Microsoft.Alpha\";try{i=t.filters.item(n)}catch(o){if(1===e)return}e=Math.round(100*e),i?(i.Enabled=100!==e,i.Opacity=e):t.style.filter+=\" progid:\"+n+\"(opacity=\"+e+\")\"}},testProp:function(t){for(var i=e.documentElement.style,n=0;n<t.length;n++)if(t[n]in i)return t[n];return!1},getTranslateString:function(t){var e=o.Browser.webkit3d,i=\"translate\"+(e?\"3d\":\"\")+\"(\",n=(e?\",0\":\"\")+\")\";return i+t.x+\"px,\"+t.y+\"px\"+n},getScaleString:function(t,e){var i=o.DomUtil.getTranslateString(e.add(e.multiplyBy(-1*t))),n=\" scale(\"+t+\") \";return i+n},setPosition:function(t,e,i){t._leaflet_pos=e,!i&&o.Browser.any3d?t.style[o.DomUtil.TRANSFORM]=o.DomUtil.getTranslateString(e):(t.style.left=e.x+\"px\",t.style.top=e.y+\"px\")},getPosition:function(t){return t._leaflet_pos}},o.DomUtil.TRANSFORM=o.DomUtil.testProp([\"transform\",\"WebkitTransform\",\"OTransform\",\"MozTransform\",\"msTransform\"]),o.DomUtil.TRANSITION=o.DomUtil.testProp([\"webkitTransition\",\"transition\",\"OTransition\",\"MozTransition\",\"msTransition\"]),o.DomUtil.TRANSITION_END=\"webkitTransition\"===o.DomUtil.TRANSITION||\"OTransition\"===o.DomUtil.TRANSITION?o.DomUtil.TRANSITION+\"End\":\"transitionend\",function(){if(\"onselectstart\"in e)o.extend(o.DomUtil,{disableTextSelection:function(){o.DomEvent.on(t,\"selectstart\",o.DomEvent.preventDefault)},enableTextSelection:function(){o.DomEvent.off(t,\"selectstart\",o.DomEvent.preventDefault)}});else{var i=o.DomUtil.testProp([\"userSelect\",\"WebkitUserSelect\",\"OUserSelect\",\"MozUserSelect\",\"msUserSelect\"]);o.extend(o.DomUtil,{disableTextSelection:function(){if(i){var t=e.documentElement.style;this._userSelect=t[i],t[i]=\"none\"}},enableTextSelection:function(){i&&(e.documentElement.style[i]=this._userSelect,delete this._userSelect)}})}o.extend(o.DomUtil,{disableImageDrag:function(){o.DomEvent.on(t,\"dragstart\",o.DomEvent.preventDefault)},enableImageDrag:function(){o.DomEvent.off(t,\"dragstart\",o.DomEvent.preventDefault)}})}(),o.LatLng=function(t,e,n){if(t=parseFloat(t),e=parseFloat(e),isNaN(t)||isNaN(e))throw new Error(\"Invalid LatLng object: (\"+t+\", \"+e+\")\");this.lat=t,this.lng=e,n!==i&&(this.alt=parseFloat(n))},o.extend(o.LatLng,{DEG_TO_RAD:Math.PI/180,RAD_TO_DEG:180/Math.PI,MAX_MARGIN:1e-9}),o.LatLng.prototype={equals:function(t){if(!t)return!1;t=o.latLng(t);var e=Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng));return e<=o.LatLng.MAX_MARGIN},toString:function(t){return\"LatLng(\"+o.Util.formatNum(this.lat,t)+\", \"+o.Util.formatNum(this.lng,t)+\")\"},distanceTo:function(t){t=o.latLng(t);var e=6378137,i=o.LatLng.DEG_TO_RAD,n=(t.lat-this.lat)*i,s=(t.lng-this.lng)*i,a=this.lat*i,r=t.lat*i,h=Math.sin(n/2),l=Math.sin(s/2),u=h*h+l*l*Math.cos(a)*Math.cos(r);return 2*e*Math.atan2(Math.sqrt(u),Math.sqrt(1-u))},wrap:function(t,e){var i=this.lng;return t=t||-180,e=e||180,i=(i+e)%(e-t)+(t>i||i===e?e:t),new o.LatLng(this.lat,i)}},o.latLng=function(t,e){return t instanceof o.LatLng?t:o.Util.isArray(t)?\"number\"==typeof t[0]||\"string\"==typeof t[0]?new o.LatLng(t[0],t[1],t[2]):null:t===i||null===t?t:\"object\"==typeof t&&\"lat\"in t?new o.LatLng(t.lat,\"lng\"in t?t.lng:t.lon):e===i?null:new o.LatLng(t,e)},o.LatLngBounds=function(t,e){if(t)for(var i=e?[t,e]:t,n=0,o=i.length;o>n;n++)this.extend(i[n])},o.LatLngBounds.prototype={extend:function(t){if(!t)return this;var e=o.latLng(t);return t=null!==e?e:o.latLngBounds(t),t instanceof o.LatLng?this._southWest||this._northEast?(this._southWest.lat=Math.min(t.lat,this._southWest.lat),this._southWest.lng=Math.min(t.lng,this._southWest.lng),this._northEast.lat=Math.max(t.lat,this._northEast.lat),this._northEast.lng=Math.max(t.lng,this._northEast.lng)):(this._southWest=new o.LatLng(t.lat,t.lng),this._northEast=new o.LatLng(t.lat,t.lng)):t instanceof o.LatLngBounds&&(this.extend(t._southWest),this.extend(t._northEast)),this},pad:function(t){var e=this._southWest,i=this._northEast,n=Math.abs(e.lat-i.lat)*t,s=Math.abs(e.lng-i.lng)*t;return new o.LatLngBounds(new o.LatLng(e.lat-n,e.lng-s),new o.LatLng(i.lat+n,i.lng+s))},getCenter:function(){return new o.LatLng((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new o.LatLng(this.getNorth(),this.getWest())},getSouthEast:function(){return new o.LatLng(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t=\"number\"==typeof t[0]||t instanceof o.LatLng?o.latLng(t):o.latLngBounds(t);var e,i,n=this._southWest,s=this._northEast;return t instanceof o.LatLngBounds?(e=t.getSouthWest(),i=t.getNorthEast()):e=i=t,e.lat>=n.lat&&i.lat<=s.lat&&e.lng>=n.lng&&i.lng<=s.lng},intersects:function(t){t=o.latLngBounds(t);var e=this._southWest,i=this._northEast,n=t.getSouthWest(),s=t.getNorthEast(),a=s.lat>=e.lat&&n.lat<=i.lat,r=s.lng>=e.lng&&n.lng<=i.lng;return a&&r},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(\",\")},equals:function(t){return t?(t=o.latLngBounds(t),this._southWest.equals(t.getSouthWest())&&this._northEast.equals(t.getNorthEast())):!1},isValid:function(){return!(!this._southWest||!this._northEast)}},o.latLngBounds=function(t,e){return!t||t instanceof o.LatLngBounds?t:new o.LatLngBounds(t,e)},o.Projection={},o.Projection.SphericalMercator={MAX_LATITUDE:85.0511287798,project:function(t){var e=o.LatLng.DEG_TO_RAD,i=this.MAX_LATITUDE,n=Math.max(Math.min(i,t.lat),-i),s=t.lng*e,a=n*e;return a=Math.log(Math.tan(Math.PI/4+a/2)),new o.Point(s,a)},unproject:function(t){var e=o.LatLng.RAD_TO_DEG,i=t.x*e,n=(2*Math.atan(Math.exp(t.y))-Math.PI/2)*e;return new o.LatLng(n,i)}},o.Projection.LonLat={project:function(t){return new o.Point(t.lng,t.lat)},unproject:function(t){return new o.LatLng(t.y,t.x)}},o.CRS={latLngToPoint:function(t,e){var i=this.projection.project(t),n=this.scale(e);return this.transformation._transform(i,n)},pointToLatLng:function(t,e){var i=this.scale(e),n=this.transformation.untransform(t,i);return this.projection.unproject(n)},project:function(t){return this.projection.project(t)},scale:function(t){return 256*Math.pow(2,t)},getSize:function(t){var e=this.scale(t);return o.point(e,e)}},o.CRS.Simple=o.extend({},o.CRS,{projection:o.Projection.LonLat,transformation:new o.Transformation(1,0,-1,0),scale:function(t){return Math.pow(2,t)}}),o.CRS.EPSG3857=o.extend({},o.CRS,{code:\"EPSG:3857\",projection:o.Projection.SphericalMercator,transformation:new o.Transformation(.5/Math.PI,.5,-.5/Math.PI,.5),project:function(t){var e=this.projection.project(t),i=6378137;return e.multiplyBy(i)}}),o.CRS.EPSG900913=o.extend({},o.CRS.EPSG3857,{code:\"EPSG:900913\"}),o.CRS.EPSG4326=o.extend({},o.CRS,{code:\"EPSG:4326\",projection:o.Projection.LonLat,transformation:new o.Transformation(1/360,.5,-1/360,.5)}),o.Map=o.Class.extend({includes:o.Mixin.Events,options:{crs:o.CRS.EPSG3857,fadeAnimation:o.DomUtil.TRANSITION&&!o.Browser.android23,trackResize:!0,markerZoomAnimation:o.DomUtil.TRANSITION&&o.Browser.any3d},initialize:function(t,e){e=o.setOptions(this,e),this._initContainer(t),this._initLayout(),this._onResize=o.bind(this._onResize,this),this._initEvents(),e.maxBounds&&this.setMaxBounds(e.maxBounds),e.center&&e.zoom!==i&&this.setView(o.latLng(e.center),e.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._tileLayersNum=0,this.callInitHooks(),this._addLayers(e.layers)},setView:function(t,e){return e=e===i?this.getZoom():e,this._resetView(o.latLng(t),this._limitZoom(e)),this},setZoom:function(t,e){return this._loaded?this.setView(this.getCenter(),t,{zoom:e}):(this._zoom=this._limitZoom(t),this)},zoomIn:function(t,e){return this.setZoom(this._zoom+(t||1),e)},zoomOut:function(t,e){return this.setZoom(this._zoom-(t||1),e)},setZoomAround:function(t,e,i){var n=this.getZoomScale(e),s=this.getSize().divideBy(2),a=t instanceof o.Point?t:this.latLngToContainerPoint(t),r=a.subtract(s).multiplyBy(1-1/n),h=this.containerPointToLatLng(s.add(r));return this.setView(h,e,{zoom:i})},fitBounds:function(t,e){e=e||{},t=t.getBounds?t.getBounds():o.latLngBounds(t);var i=o.point(e.paddingTopLeft||e.padding||[0,0]),n=o.point(e.paddingBottomRight||e.padding||[0,0]),s=this.getBoundsZoom(t,!1,i.add(n));s=e.maxZoom?Math.min(e.maxZoom,s):s;var a=n.subtract(i).divideBy(2),r=this.project(t.getSouthWest(),s),h=this.project(t.getNorthEast(),s),l=this.unproject(r.add(h).divideBy(2).add(a),s);return this.setView(l,s,e)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,e){return this.setView(t,this._zoom,{pan:e})},panBy:function(t){return this.fire(\"movestart\"),this._rawPanBy(o.point(t)),this.fire(\"move\"),this.fire(\"moveend\")},setMaxBounds:function(t){return t=o.latLngBounds(t),this.options.maxBounds=t,t?(this._loaded&&this._panInsideMaxBounds(),this.on(\"moveend\",this._panInsideMaxBounds,this)):this.off(\"moveend\",this._panInsideMaxBounds,this)},panInsideBounds:function(t,e){var i=this.getCenter(),n=this._limitCenter(i,this._zoom,t);return i.equals(n)?this:this.panTo(n,e)},addLayer:function(t){var e=o.stamp(t);return this._layers[e]?this:(this._layers[e]=t,!t.options||isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[e]=t,this._updateZoomLevels()),this.options.zoomAnimation&&o.TileLayer&&t instanceof o.TileLayer&&(this._tileLayersNum++,this._tileLayersToLoad++,t.on(\"load\",this._onTileLayerLoad,this)),this._loaded&&this._layerAdd(t),this)},removeLayer:function(t){var e=o.stamp(t);return this._layers[e]?(this._loaded&&t.onRemove(this),delete this._layers[e],this._loaded&&this.fire(\"layerremove\",{layer:t}),this._zoomBoundLayers[e]&&(delete this._zoomBoundLayers[e],this._updateZoomLevels()),this.options.zoomAnimation&&o.TileLayer&&t instanceof o.TileLayer&&(this._tileLayersNum--,this._tileLayersToLoad--,t.off(\"load\",this._onTileLayerLoad,this)),this):this},hasLayer:function(t){return t?o.stamp(t)in this._layers:!1},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},invalidateSize:function(t){if(!this._loaded)return this;t=o.extend({animate:!1,pan:!0},t===!0?{animate:!0}:t);var e=this.getSize();this._sizeChanged=!0,this._initialCenter=null;var i=this.getSize(),n=e.divideBy(2).round(),s=i.divideBy(2).round(),a=n.subtract(s);return a.x||a.y?(t.animate&&t.pan?this.panBy(a):(t.pan&&this._rawPanBy(a),this.fire(\"move\"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(o.bind(this.fire,this,\"moveend\"),200)):this.fire(\"moveend\")),this.fire(\"resize\",{oldSize:e,newSize:i})):this},addHandler:function(t,e){if(!e)return this;var i=this[t]=new e(this);return this._handlers.push(i),this.options[t]&&i.enable(),this},remove:function(){this._loaded&&this.fire(\"unload\"),this._initEvents(\"off\");try{delete this._container._leaflet}catch(t){this._container._leaflet=i}return this._clearPanes(),this._clearControlPos&&this._clearControlPos(),this._clearHandlers(),this},getCenter:function(){return this._checkIfLoaded(),this._initialCenter&&!this._moved()?this._initialCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds(),e=this.unproject(t.getBottomLeft()),i=this.unproject(t.getTopRight());return new o.LatLngBounds(e,i)},getMinZoom:function(){return this.options.minZoom===i?this._layersMinZoom===i?0:this._layersMinZoom:this.options.minZoom},getMaxZoom:function(){return this.options.maxZoom===i?this._layersMaxZoom===i?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,e,i){t=o.latLngBounds(t);var n,s=this.getMinZoom()-(e?1:0),a=this.getMaxZoom(),r=this.getSize(),h=t.getNorthWest(),l=t.getSouthEast(),u=!0;i=o.point(i||[0,0]);do s++,n=this.project(l,s).subtract(this.project(h,s)).add(i),u=e?n.x<r.x||n.y<r.y:r.contains(n);while(u&&a>=s);return u&&e?null:e?s:s-1},getSize:function(){return(!this._size||this._sizeChanged)&&(this._size=new o.Point(this._container.clientWidth,this._container.clientHeight),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(){var t=this._getTopLeftPoint();return new o.Bounds(t,t.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._initialTopLeftPoint},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t){var e=this.options.crs;return e.scale(t)/e.scale(this._zoom)},getScaleZoom:function(t){return this._zoom+Math.log(t)/Math.LN2},project:function(t,e){return e=e===i?this._zoom:e,this.options.crs.latLngToPoint(o.latLng(t),e)},unproject:function(t,e){return e=e===i?this._zoom:e,this.options.crs.pointToLatLng(o.point(t),e)},layerPointToLatLng:function(t){var e=o.point(t).add(this.getPixelOrigin());return this.unproject(e)},latLngToLayerPoint:function(t){var e=this.project(o.latLng(t))._round();return e._subtract(this.getPixelOrigin())},containerPointToLayerPoint:function(t){return o.point(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return o.point(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){var e=this.containerPointToLayerPoint(o.point(t));return this.layerPointToLatLng(e)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(o.latLng(t)))},mouseEventToContainerPoint:function(t){return o.DomEvent.getMousePosition(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){var e=this._container=o.DomUtil.get(t);if(!e)throw new Error(\"Map container not found.\");if(e._leaflet)throw new Error(\"Map container is already initialized.\");e._leaflet=!0},_initLayout:function(){var t=this._container;o.DomUtil.addClass(t,\"leaflet-container\"+(o.Browser.touch?\" leaflet-touch\":\"\")+(o.Browser.retina?\" leaflet-retina\":\"\")+(o.Browser.ielt9?\" leaflet-oldie\":\"\")+(this.options.fadeAnimation?\" leaflet-fade-anim\":\"\"));var e=o.DomUtil.getStyle(t,\"position\");\"absolute\"!==e&&\"relative\"!==e&&\"fixed\"!==e&&(t.style.position=\"relative\"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._mapPane=t.mapPane=this._createPane(\"leaflet-map-pane\",this._container),this._tilePane=t.tilePane=this._createPane(\"leaflet-tile-pane\",this._mapPane),t.objectsPane=this._createPane(\"leaflet-objects-pane\",this._mapPane),t.shadowPane=this._createPane(\"leaflet-shadow-pane\"),t.overlayPane=this._createPane(\"leaflet-overlay-pane\"),t.markerPane=this._createPane(\"leaflet-marker-pane\"),t.popupPane=this._createPane(\"leaflet-popup-pane\");var e=\" leaflet-zoom-hide\";this.options.markerZoomAnimation||(o.DomUtil.addClass(t.markerPane,e),o.DomUtil.addClass(t.shadowPane,e),o.DomUtil.addClass(t.popupPane,e))},_createPane:function(t,e){return o.DomUtil.create(\"div\",t,e||this._panes.objectsPane)},_clearPanes:function(){this._container.removeChild(this._mapPane)},_addLayers:function(t){t=t?o.Util.isArray(t)?t:[t]:[];for(var e=0,i=t.length;i>e;e++)this.addLayer(t[e])},_resetView:function(t,e,i,n){var s=this._zoom!==e;n||(this.fire(\"movestart\"),s&&this.fire(\"zoomstart\")),this._zoom=e,this._initialCenter=t,this._initialTopLeftPoint=this._getNewTopLeftPoint(t),i?this._initialTopLeftPoint._add(this._getMapPanePos()):o.DomUtil.setPosition(this._mapPane,new o.Point(0,0)),this._tileLayersToLoad=this._tileLayersNum;var a=!this._loaded;this._loaded=!0,this.fire(\"viewreset\",{hard:!i}),a&&(this.fire(\"load\"),this.eachLayer(this._layerAdd,this)),this.fire(\"move\"),(s||n)&&this.fire(\"zoomend\"),this.fire(\"moveend\",{hard:!i})},_rawPanBy:function(t){o.DomUtil.setPosition(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_updateZoomLevels:function(){var t,e=1/0,n=-(1/0),o=this._getZoomSpan();for(t in this._zoomBoundLayers){var s=this._zoomBoundLayers[t];isNaN(s.options.minZoom)||(e=Math.min(e,s.options.minZoom)),isNaN(s.options.maxZoom)||(n=Math.max(n,s.options.maxZoom))}t===i?this._layersMaxZoom=this._layersMinZoom=i:(this._layersMaxZoom=n,this._layersMinZoom=e),o!==this._getZoomSpan()&&this.fire(\"zoomlevelschange\")},_panInsideMaxBounds:function(){this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error(\"Set map center and zoom first.\")},_initEvents:function(e){if(o.DomEvent){e=e||\"on\",o.DomEvent[e](this._container,\"click\",this._onMouseClick,this);var i,n,s=[\"dblclick\",\"mousedown\",\"mouseup\",\"mouseenter\",\"mouseleave\",\"mousemove\",\"contextmenu\"];for(i=0,n=s.length;n>i;i++)o.DomEvent[e](this._container,s[i],this._fireMouseEvent,this);this.options.trackResize&&o.DomEvent[e](t,\"resize\",this._onResize,this)}},_onResize:function(){o.Util.cancelAnimFrame(this._resizeRequest),this._resizeRequest=o.Util.requestAnimFrame(function(){this.invalidateSize({debounceMoveend:!0})},this,!1,this._container)},_onMouseClick:function(t){!this._loaded||!t._simulated&&(this.dragging&&this.dragging.moved()||this.boxZoom&&this.boxZoom.moved())||o.DomEvent._skipped(t)||(this.fire(\"preclick\"),this._fireMouseEvent(t))},_fireMouseEvent:function(t){if(this._loaded&&!o.DomEvent._skipped(t)){var e=t.type;if(e=\"mouseenter\"===e?\"mouseover\":\"mouseleave\"===e?\"mouseout\":e,this.hasEventListeners(e)){\"contextmenu\"===e&&o.DomEvent.preventDefault(t);var i=this.mouseEventToContainerPoint(t),n=this.containerPointToLayerPoint(i),s=this.layerPointToLatLng(n);this.fire(e,{latlng:s,layerPoint:n,containerPoint:i,originalEvent:t})}}},_onTileLayerLoad:function(){this._tileLayersToLoad--,this._tileLayersNum&&!this._tileLayersToLoad&&this.fire(\"tilelayersload\")},_clearHandlers:function(){for(var t=0,e=this._handlers.length;e>t;t++)this._handlers[t].disable()},whenReady:function(t,e){return this._loaded?t.call(e||this,this):this.on(\"load\",t,e),this},_layerAdd:function(t){t.onAdd(this),this.fire(\"layeradd\",{layer:t})},_getMapPanePos:function(){return o.DomUtil.getPosition(this._mapPane)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(){return this.getPixelOrigin().subtract(this._getMapPanePos())},_getNewTopLeftPoint:function(t,e){var i=this.getSize()._divideBy(2);return this.project(t,e)._subtract(i)._round()},_latLngToNewLayerPoint:function(t,e,i){var n=this._getNewTopLeftPoint(i,e).add(this._getMapPanePos());return this.project(t,e)._subtract(n)},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,e,i){if(!i)return t;var n=this.project(t,e),s=this.getSize().divideBy(2),a=new o.Bounds(n.subtract(s),n.add(s)),r=this._getBoundsOffset(a,i,e);return this.unproject(n.add(r),e)},_limitOffset:function(t,e){if(!e)return t;var i=this.getPixelBounds(),n=new o.Bounds(i.min.add(t),i.max.add(t));return t.add(this._getBoundsOffset(n,e))},_getBoundsOffset:function(t,e,i){var n=this.project(e.getNorthWest(),i).subtract(t.min),s=this.project(e.getSouthEast(),i).subtract(t.max),a=this._rebound(n.x,-s.x),r=this._rebound(n.y,-s.y);return new o.Point(a,r)},_rebound:function(t,e){return t+e>0?Math.round(t-e)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(e))},_limitZoom:function(t){var e=this.getMinZoom(),i=this.getMaxZoom();return Math.max(e,Math.min(i,t))}}),o.map=function(t,e){return new o.Map(t,e)},o.Projection.Mercator={MAX_LATITUDE:85.0840591556,R_MINOR:6356752.314245179,R_MAJOR:6378137,project:function(t){var e=o.LatLng.DEG_TO_RAD,i=this.MAX_LATITUDE,n=Math.max(Math.min(i,t.lat),-i),s=this.R_MAJOR,a=this.R_MINOR,r=t.lng*e*s,h=n*e,l=a/s,u=Math.sqrt(1-l*l),c=u*Math.sin(h);c=Math.pow((1-c)/(1+c),.5*u);var d=Math.tan(.5*(.5*Math.PI-h))/c;return h=-s*Math.log(d),new o.Point(r,h)},unproject:function(t){for(var e,i=o.LatLng.RAD_TO_DEG,n=this.R_MAJOR,s=this.R_MINOR,a=t.x*i/n,r=s/n,h=Math.sqrt(1-r*r),l=Math.exp(-t.y/n),u=Math.PI/2-2*Math.atan(l),c=15,d=1e-7,p=c,_=.1;Math.abs(_)>d&&--p>0;)e=h*Math.sin(u),_=Math.PI/2-2*Math.atan(l*Math.pow((1-e)/(1+e),.5*h))-u,u+=_;return new o.LatLng(u*i,a)}},o.CRS.EPSG3395=o.extend({},o.CRS,{code:\"EPSG:3395\",projection:o.Projection.Mercator,\ntransformation:function(){var t=o.Projection.Mercator,e=t.R_MAJOR,i=.5/(Math.PI*e);return new o.Transformation(i,.5,-i,.5)}()}),o.TileLayer=o.Class.extend({includes:o.Mixin.Events,options:{minZoom:0,maxZoom:18,tileSize:256,subdomains:\"abc\",errorTileUrl:\"\",attribution:\"\",zoomOffset:0,opacity:1,unloadInvisibleTiles:o.Browser.mobile,updateWhenIdle:o.Browser.mobile},initialize:function(t,e){e=o.setOptions(this,e),e.detectRetina&&o.Browser.retina&&e.maxZoom>0&&(e.tileSize=Math.floor(e.tileSize/2),e.zoomOffset++,e.minZoom>0&&e.minZoom--,this.options.maxZoom--),e.bounds&&(e.bounds=o.latLngBounds(e.bounds)),this._url=t;var i=this.options.subdomains;\"string\"==typeof i&&(this.options.subdomains=i.split(\"\"))},onAdd:function(t){this._map=t,this._animated=t._zoomAnimated,this._initContainer(),t.on({viewreset:this._reset,moveend:this._update},this),this._animated&&t.on({zoomanim:this._animateZoom,zoomend:this._endZoomAnim},this),this.options.updateWhenIdle||(this._limitedUpdate=o.Util.limitExecByInterval(this._update,150,this),t.on(\"move\",this._limitedUpdate,this)),this._reset(),this._update()},addTo:function(t){return t.addLayer(this),this},onRemove:function(t){this._container.parentNode.removeChild(this._container),t.off({viewreset:this._reset,moveend:this._update},this),this._animated&&t.off({zoomanim:this._animateZoom,zoomend:this._endZoomAnim},this),this.options.updateWhenIdle||t.off(\"move\",this._limitedUpdate,this),this._container=null,this._map=null},bringToFront:function(){var t=this._map._panes.tilePane;return this._container&&(t.appendChild(this._container),this._setAutoZIndex(t,Math.max)),this},bringToBack:function(){var t=this._map._panes.tilePane;return this._container&&(t.insertBefore(this._container,t.firstChild),this._setAutoZIndex(t,Math.min)),this},getAttribution:function(){return this.options.attribution},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},setUrl:function(t,e){return this._url=t,e||this.redraw(),this},redraw:function(){return this._map&&(this._reset({hard:!0}),this._update()),this},_updateZIndex:function(){this._container&&this.options.zIndex!==i&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t,e){var i,n,o,s=t.children,a=-e(1/0,-(1/0));for(n=0,o=s.length;o>n;n++)s[n]!==this._container&&(i=parseInt(s[n].style.zIndex,10),isNaN(i)||(a=e(a,i)));this.options.zIndex=this._container.style.zIndex=(isFinite(a)?a:0)+e(1,-1)},_updateOpacity:function(){var t,e=this._tiles;if(o.Browser.ielt9)for(t in e)o.DomUtil.setOpacity(e[t],this.options.opacity);else o.DomUtil.setOpacity(this._container,this.options.opacity)},_initContainer:function(){var t=this._map._panes.tilePane;if(!this._container){if(this._container=o.DomUtil.create(\"div\",\"leaflet-layer\"),this._updateZIndex(),this._animated){var e=\"leaflet-tile-container\";this._bgBuffer=o.DomUtil.create(\"div\",e,this._container),this._tileContainer=o.DomUtil.create(\"div\",e,this._container)}else this._tileContainer=this._container;t.appendChild(this._container),this.options.opacity<1&&this._updateOpacity()}},_reset:function(t){for(var e in this._tiles)this.fire(\"tileunload\",{tile:this._tiles[e]});this._tiles={},this._tilesToLoad=0,this.options.reuseTiles&&(this._unusedTiles=[]),this._tileContainer.innerHTML=\"\",this._animated&&t&&t.hard&&this._clearBgBuffer(),this._initContainer()},_getTileSize:function(){var t=this._map,e=t.getZoom()+this.options.zoomOffset,i=this.options.maxNativeZoom,n=this.options.tileSize;return i&&e>i&&(n=Math.round(t.getZoomScale(e)/t.getZoomScale(i)*n)),n},_update:function(){if(this._map){var t=this._map,e=t.getPixelBounds(),i=t.getZoom(),n=this._getTileSize();if(!(i>this.options.maxZoom||i<this.options.minZoom)){var s=o.bounds(e.min.divideBy(n)._floor(),e.max.divideBy(n)._floor());this._addTilesFromCenterOut(s),(this.options.unloadInvisibleTiles||this.options.reuseTiles)&&this._removeOtherTiles(s)}}},_addTilesFromCenterOut:function(t){var i,n,s,a=[],r=t.getCenter();for(i=t.min.y;i<=t.max.y;i++)for(n=t.min.x;n<=t.max.x;n++)s=new o.Point(n,i),this._tileShouldBeLoaded(s)&&a.push(s);var h=a.length;if(0!==h){a.sort(function(t,e){return t.distanceTo(r)-e.distanceTo(r)});var l=e.createDocumentFragment();for(this._tilesToLoad||this.fire(\"loading\"),this._tilesToLoad+=h,n=0;h>n;n++)this._addTile(a[n],l);this._tileContainer.appendChild(l)}},_tileShouldBeLoaded:function(t){if(t.x+\":\"+t.y in this._tiles)return!1;var e=this.options;if(!e.continuousWorld){var i=this._getWrapTileNum();if(e.noWrap&&(t.x<0||t.x>=i.x)||t.y<0||t.y>=i.y)return!1}if(e.bounds){var n=this._getTileSize(),o=t.multiplyBy(n),s=o.add([n,n]),a=this._map.unproject(o),r=this._map.unproject(s);if(e.continuousWorld||e.noWrap||(a=a.wrap(),r=r.wrap()),!e.bounds.intersects([a,r]))return!1}return!0},_removeOtherTiles:function(t){var e,i,n,o;for(o in this._tiles)e=o.split(\":\"),i=parseInt(e[0],10),n=parseInt(e[1],10),(i<t.min.x||i>t.max.x||n<t.min.y||n>t.max.y)&&this._removeTile(o)},_removeTile:function(t){var e=this._tiles[t];this.fire(\"tileunload\",{tile:e,url:e.src}),this.options.reuseTiles?(o.DomUtil.removeClass(e,\"leaflet-tile-loaded\"),this._unusedTiles.push(e)):e.parentNode===this._tileContainer&&this._tileContainer.removeChild(e),o.Browser.android||(e.onload=null,e.src=o.Util.emptyImageUrl),delete this._tiles[t]},_addTile:function(t,e){var i=this._getTilePos(t),n=this._getTile();o.DomUtil.setPosition(n,i,o.Browser.chrome),this._tiles[t.x+\":\"+t.y]=n,this._loadTile(n,t),n.parentNode!==this._tileContainer&&e.appendChild(n)},_getZoomForUrl:function(){var t=this.options,e=this._map.getZoom();return t.zoomReverse&&(e=t.maxZoom-e),e+=t.zoomOffset,t.maxNativeZoom?Math.min(e,t.maxNativeZoom):e},_getTilePos:function(t){var e=this._map.getPixelOrigin(),i=this._getTileSize();return t.multiplyBy(i).subtract(e)},getTileUrl:function(t){return o.Util.template(this._url,o.extend({s:this._getSubdomain(t),z:t.z,x:t.x,y:t.y},this.options))},_getWrapTileNum:function(){var t=this._map.options.crs,e=t.getSize(this._map.getZoom());return e.divideBy(this._getTileSize())._floor()},_adjustTilePoint:function(t){var e=this._getWrapTileNum();this.options.continuousWorld||this.options.noWrap||(t.x=(t.x%e.x+e.x)%e.x),this.options.tms&&(t.y=e.y-t.y-1),t.z=this._getZoomForUrl()},_getSubdomain:function(t){var e=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[e]},_getTile:function(){if(this.options.reuseTiles&&this._unusedTiles.length>0){var t=this._unusedTiles.pop();return this._resetTile(t),t}return this._createTile()},_resetTile:function(){},_createTile:function(){var t=o.DomUtil.create(\"img\",\"leaflet-tile\");return t.style.width=t.style.height=this._getTileSize()+\"px\",t.galleryimg=\"no\",t.onselectstart=t.onmousemove=o.Util.falseFn,o.Browser.ielt9&&this.options.opacity!==i&&o.DomUtil.setOpacity(t,this.options.opacity),o.Browser.mobileWebkit3d&&(t.style.WebkitBackfaceVisibility=\"hidden\"),t},_loadTile:function(t,e){t._layer=this,t.onload=this._tileOnLoad,t.onerror=this._tileOnError,this._adjustTilePoint(e),t.src=this.getTileUrl(e),this.fire(\"tileloadstart\",{tile:t,url:t.src})},_tileLoaded:function(){this._tilesToLoad--,this._animated&&o.DomUtil.addClass(this._tileContainer,\"leaflet-zoom-animated\"),this._tilesToLoad||(this.fire(\"load\"),this._animated&&(clearTimeout(this._clearBgBufferTimer),this._clearBgBufferTimer=setTimeout(o.bind(this._clearBgBuffer,this),500)))},_tileOnLoad:function(){var t=this._layer;this.src!==o.Util.emptyImageUrl&&(o.DomUtil.addClass(this,\"leaflet-tile-loaded\"),t.fire(\"tileload\",{tile:this,url:this.src})),t._tileLoaded()},_tileOnError:function(){var t=this._layer;t.fire(\"tileerror\",{tile:this,url:this.src});var e=t.options.errorTileUrl;e&&(this.src=e),t._tileLoaded()}}),o.tileLayer=function(t,e){return new o.TileLayer(t,e)},o.TileLayer.WMS=o.TileLayer.extend({defaultWmsParams:{service:\"WMS\",request:\"GetMap\",version:\"1.1.1\",layers:\"\",styles:\"\",format:\"image/jpeg\",transparent:!1},initialize:function(t,e){this._url=t;var i=o.extend({},this.defaultWmsParams),n=e.tileSize||this.options.tileSize;e.detectRetina&&o.Browser.retina?i.width=i.height=2*n:i.width=i.height=n;for(var s in e)this.options.hasOwnProperty(s)||\"crs\"===s||(i[s]=e[s]);this.wmsParams=i,o.setOptions(this,e)},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var e=this._wmsVersion>=1.3?\"crs\":\"srs\";this.wmsParams[e]=this._crs.code,o.TileLayer.prototype.onAdd.call(this,t)},getTileUrl:function(t){var e=this._map,i=this.options.tileSize,n=t.multiplyBy(i),s=n.add([i,i]),a=this._crs.project(e.unproject(n,t.z)),r=this._crs.project(e.unproject(s,t.z)),h=this._wmsVersion>=1.3&&this._crs===o.CRS.EPSG4326?[r.y,a.x,a.y,r.x].join(\",\"):[a.x,r.y,r.x,a.y].join(\",\"),l=o.Util.template(this._url,{s:this._getSubdomain(t)});return l+o.Util.getParamString(this.wmsParams,l,!0)+\"&BBOX=\"+h},setParams:function(t,e){return o.extend(this.wmsParams,t),e||this.redraw(),this}}),o.tileLayer.wms=function(t,e){return new o.TileLayer.WMS(t,e)},o.TileLayer.Canvas=o.TileLayer.extend({options:{async:!1},initialize:function(t){o.setOptions(this,t)},redraw:function(){this._map&&(this._reset({hard:!0}),this._update());for(var t in this._tiles)this._redrawTile(this._tiles[t]);return this},_redrawTile:function(t){this.drawTile(t,t._tilePoint,this._map._zoom)},_createTile:function(){var t=o.DomUtil.create(\"canvas\",\"leaflet-tile\");return t.width=t.height=this.options.tileSize,t.onselectstart=t.onmousemove=o.Util.falseFn,t},_loadTile:function(t,e){t._layer=this,t._tilePoint=e,this._redrawTile(t),this.options.async||this.tileDrawn(t)},drawTile:function(){},tileDrawn:function(t){this._tileOnLoad.call(t)}}),o.tileLayer.canvas=function(t){return new o.TileLayer.Canvas(t)},o.ImageOverlay=o.Class.extend({includes:o.Mixin.Events,options:{opacity:1},initialize:function(t,e,i){this._url=t,this._bounds=o.latLngBounds(e),o.setOptions(this,i)},onAdd:function(t){this._map=t,this._image||this._initImage(),t._panes.overlayPane.appendChild(this._image),t.on(\"viewreset\",this._reset,this),t.options.zoomAnimation&&o.Browser.any3d&&t.on(\"zoomanim\",this._animateZoom,this),this._reset()},onRemove:function(t){t.getPanes().overlayPane.removeChild(this._image),t.off(\"viewreset\",this._reset,this),t.options.zoomAnimation&&t.off(\"zoomanim\",this._animateZoom,this)},addTo:function(t){return t.addLayer(this),this},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},bringToFront:function(){return this._image&&this._map._panes.overlayPane.appendChild(this._image),this},bringToBack:function(){var t=this._map._panes.overlayPane;return this._image&&t.insertBefore(this._image,t.firstChild),this},setUrl:function(t){this._url=t,this._image.src=this._url},getAttribution:function(){return this.options.attribution},_initImage:function(){this._image=o.DomUtil.create(\"img\",\"leaflet-image-layer\"),this._map.options.zoomAnimation&&o.Browser.any3d?o.DomUtil.addClass(this._image,\"leaflet-zoom-animated\"):o.DomUtil.addClass(this._image,\"leaflet-zoom-hide\"),this._updateOpacity(),o.extend(this._image,{galleryimg:\"no\",onselectstart:o.Util.falseFn,onmousemove:o.Util.falseFn,onload:o.bind(this._onImageLoad,this),src:this._url})},_animateZoom:function(t){var e=this._map,i=this._image,n=e.getZoomScale(t.zoom),s=this._bounds.getNorthWest(),a=this._bounds.getSouthEast(),r=e._latLngToNewLayerPoint(s,t.zoom,t.center),h=e._latLngToNewLayerPoint(a,t.zoom,t.center)._subtract(r),l=r._add(h._multiplyBy(.5*(1-1/n)));i.style[o.DomUtil.TRANSFORM]=o.DomUtil.getTranslateString(l)+\" scale(\"+n+\") \"},_reset:function(){var t=this._image,e=this._map.latLngToLayerPoint(this._bounds.getNorthWest()),i=this._map.latLngToLayerPoint(this._bounds.getSouthEast())._subtract(e);o.DomUtil.setPosition(t,e),t.style.width=i.x+\"px\",t.style.height=i.y+\"px\"},_onImageLoad:function(){this.fire(\"load\")},_updateOpacity:function(){o.DomUtil.setOpacity(this._image,this.options.opacity)}}),o.imageOverlay=function(t,e,i){return new o.ImageOverlay(t,e,i)},o.Icon=o.Class.extend({options:{className:\"\"},initialize:function(t){o.setOptions(this,t)},createIcon:function(t){return this._createIcon(\"icon\",t)},createShadow:function(t){return this._createIcon(\"shadow\",t)},_createIcon:function(t,e){var i=this._getIconUrl(t);if(!i){if(\"icon\"===t)throw new Error(\"iconUrl not set in Icon options (see the docs).\");return null}var n;return n=e&&\"IMG\"===e.tagName?this._createImg(i,e):this._createImg(i),this._setIconStyles(n,t),n},_setIconStyles:function(t,e){var i,n=this.options,s=o.point(n[e+\"Size\"]);i=\"shadow\"===e?o.point(n.shadowAnchor||n.iconAnchor):o.point(n.iconAnchor),!i&&s&&(i=s.divideBy(2,!0)),t.className=\"leaflet-marker-\"+e+\" \"+n.className,i&&(t.style.marginLeft=-i.x+\"px\",t.style.marginTop=-i.y+\"px\"),s&&(t.style.width=s.x+\"px\",t.style.height=s.y+\"px\")},_createImg:function(t,i){return i=i||e.createElement(\"img\"),i.src=t,i},_getIconUrl:function(t){return o.Browser.retina&&this.options[t+\"RetinaUrl\"]?this.options[t+\"RetinaUrl\"]:this.options[t+\"Url\"]}}),o.icon=function(t){return new o.Icon(t)},o.Icon.Default=o.Icon.extend({options:{iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],shadowSize:[41,41]},_getIconUrl:function(t){var e=t+\"Url\";if(this.options[e])return this.options[e];o.Browser.retina&&\"icon\"===t&&(t+=\"-2x\");var i=o.Icon.Default.imagePath;if(!i)throw new Error(\"Couldn't autodetect L.Icon.Default.imagePath, set it manually.\");return i+\"/marker-\"+t+\".png\"}}),o.Icon.Default.imagePath=function(){var t,i,n,o,s,a=e.getElementsByTagName(\"script\"),r=/[\\/^]leaflet[\\-\\._]?([\\w\\-\\._]*)\\.js\\??/;for(t=0,i=a.length;i>t;t++)if(n=a[t].src,o=n.match(r))return s=n.split(r)[0],(s?s+\"/\":\"\")+\"images\"}(),o.Marker=o.Class.extend({includes:o.Mixin.Events,options:{icon:new o.Icon.Default,title:\"\",alt:\"\",clickable:!0,draggable:!1,keyboard:!0,zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250},initialize:function(t,e){o.setOptions(this,e),this._latlng=o.latLng(t)},onAdd:function(t){this._map=t,t.on(\"viewreset\",this.update,this),this._initIcon(),this.update(),this.fire(\"add\"),t.options.zoomAnimation&&t.options.markerZoomAnimation&&t.on(\"zoomanim\",this._animateZoom,this)},addTo:function(t){return t.addLayer(this),this},onRemove:function(t){this.dragging&&this.dragging.disable(),this._removeIcon(),this._removeShadow(),this.fire(\"remove\"),t.off({viewreset:this.update,zoomanim:this._animateZoom},this),this._map=null},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=o.latLng(t),this.update(),this.fire(\"move\",{latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update(),this},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup),this},update:function(){return this._icon&&this._setPos(this._map.latLngToLayerPoint(this._latlng).round()),this},_initIcon:function(){var t=this.options,e=this._map,i=e.options.zoomAnimation&&e.options.markerZoomAnimation,n=i?\"leaflet-zoom-animated\":\"leaflet-zoom-hide\",s=t.icon.createIcon(this._icon),a=!1;s!==this._icon&&(this._icon&&this._removeIcon(),a=!0,t.title&&(s.title=t.title),t.alt&&(s.alt=t.alt)),o.DomUtil.addClass(s,n),t.keyboard&&(s.tabIndex=\"0\"),this._icon=s,this._initInteraction(),t.riseOnHover&&o.DomEvent.on(s,\"mouseover\",this._bringToFront,this).on(s,\"mouseout\",this._resetZIndex,this);var r=t.icon.createShadow(this._shadow),h=!1;r!==this._shadow&&(this._removeShadow(),h=!0),r&&o.DomUtil.addClass(r,n),this._shadow=r,t.opacity<1&&this._updateOpacity();var l=this._map._panes;a&&l.markerPane.appendChild(this._icon),r&&h&&l.shadowPane.appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&o.DomEvent.off(this._icon,\"mouseover\",this._bringToFront).off(this._icon,\"mouseout\",this._resetZIndex),this._map._panes.markerPane.removeChild(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&this._map._panes.shadowPane.removeChild(this._shadow),this._shadow=null},_setPos:function(t){o.DomUtil.setPosition(this._icon,t),this._shadow&&o.DomUtil.setPosition(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon.style.zIndex=this._zIndex+t},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(e)},_initInteraction:function(){if(this.options.clickable){var t=this._icon,e=[\"dblclick\",\"mousedown\",\"mouseover\",\"mouseout\",\"contextmenu\"];o.DomUtil.addClass(t,\"leaflet-clickable\"),o.DomEvent.on(t,\"click\",this._onMouseClick,this),o.DomEvent.on(t,\"keypress\",this._onKeyPress,this);for(var i=0;i<e.length;i++)o.DomEvent.on(t,e[i],this._fireMouseEvent,this);o.Handler.MarkerDrag&&(this.dragging=new o.Handler.MarkerDrag(this),this.options.draggable&&this.dragging.enable())}},_onMouseClick:function(t){var e=this.dragging&&this.dragging.moved();(this.hasEventListeners(t.type)||e)&&o.DomEvent.stopPropagation(t),e||(this.dragging&&this.dragging._enabled||!this._map.dragging||!this._map.dragging.moved())&&this.fire(t.type,{originalEvent:t,latlng:this._latlng})},_onKeyPress:function(t){13===t.keyCode&&this.fire(\"click\",{originalEvent:t,latlng:this._latlng})},_fireMouseEvent:function(t){this.fire(t.type,{originalEvent:t,latlng:this._latlng}),\"contextmenu\"===t.type&&this.hasEventListeners(t.type)&&o.DomEvent.preventDefault(t),\"mousedown\"!==t.type?o.DomEvent.stopPropagation(t):o.DomEvent.preventDefault(t)},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){o.DomUtil.setOpacity(this._icon,this.options.opacity),this._shadow&&o.DomUtil.setOpacity(this._shadow,this.options.opacity)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)}}),o.marker=function(t,e){return new o.Marker(t,e)},o.DivIcon=o.Icon.extend({options:{iconSize:[12,12],className:\"leaflet-div-icon\",html:!1},createIcon:function(t){var i=t&&\"DIV\"===t.tagName?t:e.createElement(\"div\"),n=this.options;return n.html!==!1?i.innerHTML=n.html:i.innerHTML=\"\",n.bgPos&&(i.style.backgroundPosition=-n.bgPos.x+\"px \"+-n.bgPos.y+\"px\"),this._setIconStyles(i,\"icon\"),i},createShadow:function(){return null}}),o.divIcon=function(t){return new o.DivIcon(t)},o.Map.mergeOptions({closePopupOnClick:!0}),o.Popup=o.Class.extend({includes:o.Mixin.Events,options:{minWidth:50,maxWidth:300,autoPan:!0,closeButton:!0,offset:[0,7],autoPanPadding:[5,5],keepInView:!1,className:\"\",zoomAnimation:!0},initialize:function(t,e){o.setOptions(this,t),this._source=e,this._animated=o.Browser.any3d&&this.options.zoomAnimation,this._isOpen=!1},onAdd:function(t){this._map=t,this._container||this._initLayout();var e=t.options.fadeAnimation;e&&o.DomUtil.setOpacity(this._container,0),t._panes.popupPane.appendChild(this._container),t.on(this._getEvents(),this),this.update(),e&&o.DomUtil.setOpacity(this._container,1),this.fire(\"open\"),t.fire(\"popupopen\",{popup:this}),this._source&&this._source.fire(\"popupopen\",{popup:this})},addTo:function(t){return t.addLayer(this),this},openOn:function(t){return t.openPopup(this),this},onRemove:function(t){t._panes.popupPane.removeChild(this._container),o.Util.falseFn(this._container.offsetWidth),t.off(this._getEvents(),this),t.options.fadeAnimation&&o.DomUtil.setOpacity(this._container,0),this._map=null,this.fire(\"close\"),t.fire(\"popupclose\",{popup:this}),this._source&&this._source.fire(\"popupclose\",{popup:this})},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=o.latLng(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},update:function(){this._map&&(this._container.style.visibility=\"hidden\",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility=\"\",this._adjustPan())},_getEvents:function(){var t={viewreset:this._updatePosition};return this._animated&&(t.zoomanim=this._zoomAnimation),(\"closeOnClick\"in this.options?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this._close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var t,e=\"leaflet-popup\",i=e+\" \"+this.options.className+\" leaflet-zoom-\"+(this._animated?\"animated\":\"hide\"),n=this._container=o.DomUtil.create(\"div\",i);this.options.closeButton&&(t=this._closeButton=o.DomUtil.create(\"a\",e+\"-close-button\",n),t.href=\"#close\",t.innerHTML=\"&#215;\",o.DomEvent.disableClickPropagation(t),o.DomEvent.on(t,\"click\",this._onCloseButtonClick,this));var s=this._wrapper=o.DomUtil.create(\"div\",e+\"-content-wrapper\",n);o.DomEvent.disableClickPropagation(s),this._contentNode=o.DomUtil.create(\"div\",e+\"-content\",s),o.DomEvent.disableScrollPropagation(this._contentNode),o.DomEvent.on(s,\"contextmenu\",o.DomEvent.stopPropagation),this._tipContainer=o.DomUtil.create(\"div\",e+\"-tip-container\",n),this._tip=o.DomUtil.create(\"div\",e+\"-tip\",this._tipContainer)},_updateContent:function(){if(this._content){if(\"string\"==typeof this._content)this._contentNode.innerHTML=this._content;else{for(;this._contentNode.hasChildNodes();)this._contentNode.removeChild(this._contentNode.firstChild);this._contentNode.appendChild(this._content)}this.fire(\"contentupdate\")}},_updateLayout:function(){var t=this._contentNode,e=t.style;e.width=\"\",e.whiteSpace=\"nowrap\";var i=t.offsetWidth;i=Math.min(i,this.options.maxWidth),i=Math.max(i,this.options.minWidth),e.width=i+1+\"px\",e.whiteSpace=\"\",e.height=\"\";var n=t.offsetHeight,s=this.options.maxHeight,a=\"leaflet-popup-scrolled\";s&&n>s?(e.height=s+\"px\",o.DomUtil.addClass(t,a)):o.DomUtil.removeClass(t,a),this._containerWidth=this._container.offsetWidth},_updatePosition:function(){if(this._map){var t=this._map.latLngToLayerPoint(this._latlng),e=this._animated,i=o.point(this.options.offset);e&&o.DomUtil.setPosition(this._container,t),this._containerBottom=-i.y-(e?0:t.y),this._containerLeft=-Math.round(this._containerWidth/2)+i.x+(e?0:t.x),this._container.style.bottom=this._containerBottom+\"px\",this._container.style.left=this._containerLeft+\"px\"}},_zoomAnimation:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);o.DomUtil.setPosition(this._container,e)},_adjustPan:function(){if(this.options.autoPan){var t=this._map,e=this._container.offsetHeight,i=this._containerWidth,n=new o.Point(this._containerLeft,-e-this._containerBottom);this._animated&&n._add(o.DomUtil.getPosition(this._container));var s=t.layerPointToContainerPoint(n),a=o.point(this.options.autoPanPadding),r=o.point(this.options.autoPanPaddingTopLeft||a),h=o.point(this.options.autoPanPaddingBottomRight||a),l=t.getSize(),u=0,c=0;s.x+i+h.x>l.x&&(u=s.x+i-l.x+h.x),s.x-u-r.x<0&&(u=s.x-r.x),s.y+e+h.y>l.y&&(c=s.y+e-l.y+h.y),s.y-c-r.y<0&&(c=s.y-r.y),(u||c)&&t.fire(\"autopanstart\").panBy([u,c])}},_onCloseButtonClick:function(t){this._close(),o.DomEvent.stop(t)}}),o.popup=function(t,e){return new o.Popup(t,e)},o.Map.include({openPopup:function(t,e,i){if(this.closePopup(),!(t instanceof o.Popup)){var n=t;t=new o.Popup(i).setLatLng(e).setContent(n)}return t._isOpen=!0,this._popup=t,this.addLayer(t)},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&(this.removeLayer(t),t._isOpen=!1),this}}),o.Marker.include({openPopup:function(){return this._popup&&this._map&&!this._map.hasLayer(this._popup)&&(this._popup.setLatLng(this._latlng),this._map.openPopup(this._popup)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(){return this._popup&&(this._popup._isOpen?this.closePopup():this.openPopup()),this},bindPopup:function(t,e){var i=o.point(this.options.icon.options.popupAnchor||[0,0]);return i=i.add(o.Popup.prototype.options.offset),e&&e.offset&&(i=i.add(e.offset)),e=o.extend({offset:i},e),this._popupHandlersAdded||(this.on(\"click\",this.togglePopup,this).on(\"remove\",this.closePopup,this).on(\"move\",this._movePopup,this),this._popupHandlersAdded=!0),t instanceof o.Popup?(o.setOptions(t,e),this._popup=t,t._source=this):this._popup=new o.Popup(e,this).setContent(t),this},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},unbindPopup:function(){return this._popup&&(this._popup=null,this.off(\"click\",this.togglePopup,this).off(\"remove\",this.closePopup,this).off(\"move\",this._movePopup,this),this._popupHandlersAdded=!1),this},getPopup:function(){return this._popup},_movePopup:function(t){this._popup.setLatLng(t.latlng)}}),o.LayerGroup=o.Class.extend({initialize:function(t){this._layers={};var e,i;if(t)for(e=0,i=t.length;i>e;e++)this.addLayer(t[e])},addLayer:function(t){var e=this.getLayerId(t);return this._layers[e]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){var e=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[e]&&this._map.removeLayer(this._layers[e]),delete this._layers[e],this},hasLayer:function(t){return t?t in this._layers||this.getLayerId(t)in this._layers:!1},clearLayers:function(){return this.eachLayer(this.removeLayer,this),this},invoke:function(t){var e,i,n=Array.prototype.slice.call(arguments,1);for(e in this._layers)i=this._layers[e],i[t]&&i[t].apply(i,n);return this},onAdd:function(t){this._map=t,this.eachLayer(t.addLayer,t)},onRemove:function(t){this.eachLayer(t.removeLayer,t),this._map=null},addTo:function(t){return t.addLayer(this),this},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];for(var e in this._layers)t.push(this._layers[e]);return t},setZIndex:function(t){return this.invoke(\"setZIndex\",t)},getLayerId:function(t){return o.stamp(t)}}),o.layerGroup=function(t){return new o.LayerGroup(t)},o.FeatureGroup=o.LayerGroup.extend({includes:o.Mixin.Events,statics:{EVENTS:\"click dblclick mouseover mouseout mousemove contextmenu popupopen popupclose\"},addLayer:function(t){return this.hasLayer(t)?this:(\"on\"in t&&t.on(o.FeatureGroup.EVENTS,this._propagateEvent,this),o.LayerGroup.prototype.addLayer.call(this,t),this._popupContent&&t.bindPopup&&t.bindPopup(this._popupContent,this._popupOptions),this.fire(\"layeradd\",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?(t in this._layers&&(t=this._layers[t]),\"off\"in t&&t.off(o.FeatureGroup.EVENTS,this._propagateEvent,this),o.LayerGroup.prototype.removeLayer.call(this,t),this._popupContent&&this.invoke(\"unbindPopup\"),this.fire(\"layerremove\",{layer:t})):this},bindPopup:function(t,e){return this._popupContent=t,this._popupOptions=e,this.invoke(\"bindPopup\",t,e)},openPopup:function(t){for(var e in this._layers){this._layers[e].openPopup(t);break}return this},setStyle:function(t){return this.invoke(\"setStyle\",t)},bringToFront:function(){return this.invoke(\"bringToFront\")},bringToBack:function(){return this.invoke(\"bringToBack\")},getBounds:function(){var t=new o.LatLngBounds;return this.eachLayer(function(e){t.extend(e instanceof o.Marker?e.getLatLng():e.getBounds())}),t},_propagateEvent:function(t){t=o.extend({layer:t.target,target:this},t),this.fire(t.type,t)}}),o.featureGroup=function(t){return new o.FeatureGroup(t)},o.Path=o.Class.extend({includes:[o.Mixin.Events],statics:{CLIP_PADDING:function(){var e=o.Browser.mobile?1280:2e3,i=(e/Math.max(t.outerWidth,t.outerHeight)-1)/2;return Math.max(0,Math.min(.5,i))}()},options:{stroke:!0,color:\"#0033ff\",dashArray:null,lineCap:null,lineJoin:null,weight:5,opacity:.5,fill:!1,fillColor:null,fillOpacity:.2,clickable:!0},initialize:function(t){o.setOptions(this,t)},onAdd:function(t){this._map=t,this._container||(this._initElements(),this._initEvents()),this.projectLatlngs(),this._updatePath(),this._container&&this._map._pathRoot.appendChild(this._container),this.fire(\"add\"),t.on({viewreset:this.projectLatlngs,moveend:this._updatePath},this)},addTo:function(t){return t.addLayer(this),this},onRemove:function(t){t._pathRoot.removeChild(this._container),this.fire(\"remove\"),this._map=null,o.Browser.vml&&(this._container=null,this._stroke=null,this._fill=null),t.off({viewreset:this.projectLatlngs,moveend:this._updatePath},this)},projectLatlngs:function(){},setStyle:function(t){return o.setOptions(this,t),this._container&&this._updateStyle(),this},redraw:function(){return this._map&&(this.projectLatlngs(),this._updatePath()),this}}),o.Map.include({_updatePathViewport:function(){var t=o.Path.CLIP_PADDING,e=this.getSize(),i=o.DomUtil.getPosition(this._mapPane),n=i.multiplyBy(-1)._subtract(e.multiplyBy(t)._round()),s=n.add(e.multiplyBy(1+2*t)._round());this._pathViewport=new o.Bounds(n,s)}}),o.Path.SVG_NS=\"http://www.w3.org/2000/svg\",o.Browser.svg=!(!e.createElementNS||!e.createElementNS(o.Path.SVG_NS,\"svg\").createSVGRect),o.Path=o.Path.extend({statics:{SVG:o.Browser.svg},bringToFront:function(){var t=this._map._pathRoot,e=this._container;return e&&t.lastChild!==e&&t.appendChild(e),this},bringToBack:function(){var t=this._map._pathRoot,e=this._container,i=t.firstChild;return e&&i!==e&&t.insertBefore(e,i),this},getPathString:function(){},_createElement:function(t){return e.createElementNS(o.Path.SVG_NS,t)},_initElements:function(){this._map._initPathRoot(),this._initPath(),this._initStyle()},_initPath:function(){this._container=this._createElement(\"g\"),this._path=this._createElement(\"path\"),this.options.className&&o.DomUtil.addClass(this._path,this.options.className),this._container.appendChild(this._path)},_initStyle:function(){this.options.stroke&&(this._path.setAttribute(\"stroke-linejoin\",\"round\"),this._path.setAttribute(\"stroke-linecap\",\"round\")),this.options.fill&&this._path.setAttribute(\"fill-rule\",\"evenodd\"),this.options.pointerEvents&&this._path.setAttribute(\"pointer-events\",this.options.pointerEvents),this.options.clickable||this.options.pointerEvents||this._path.setAttribute(\"pointer-events\",\"none\"),this._updateStyle()},_updateStyle:function(){this.options.stroke?(this._path.setAttribute(\"stroke\",this.options.color),this._path.setAttribute(\"stroke-opacity\",this.options.opacity),this._path.setAttribute(\"stroke-width\",this.options.weight),this.options.dashArray?this._path.setAttribute(\"stroke-dasharray\",this.options.dashArray):this._path.removeAttribute(\"stroke-dasharray\"),this.options.lineCap&&this._path.setAttribute(\"stroke-linecap\",this.options.lineCap),this.options.lineJoin&&this._path.setAttribute(\"stroke-linejoin\",this.options.lineJoin)):this._path.setAttribute(\"stroke\",\"none\"),this.options.fill?(this._path.setAttribute(\"fill\",this.options.fillColor||this.options.color),this._path.setAttribute(\"fill-opacity\",this.options.fillOpacity)):this._path.setAttribute(\"fill\",\"none\")},_updatePath:function(){var t=this.getPathString();t||(t=\"M0 0\"),this._path.setAttribute(\"d\",t)},_initEvents:function(){if(this.options.clickable){(o.Browser.svg||!o.Browser.vml)&&o.DomUtil.addClass(this._path,\"leaflet-clickable\"),o.DomEvent.on(this._container,\"click\",this._onMouseClick,this);for(var t=[\"dblclick\",\"mousedown\",\"mouseover\",\"mouseout\",\"mousemove\",\"contextmenu\"],e=0;e<t.length;e++)o.DomEvent.on(this._container,t[e],this._fireMouseEvent,this)}},_onMouseClick:function(t){this._map.dragging&&this._map.dragging.moved()||this._fireMouseEvent(t)},_fireMouseEvent:function(t){if(this._map&&this.hasEventListeners(t.type)){var e=this._map,i=e.mouseEventToContainerPoint(t),n=e.containerPointToLayerPoint(i),s=e.layerPointToLatLng(n);this.fire(t.type,{latlng:s,layerPoint:n,containerPoint:i,originalEvent:t}),\"contextmenu\"===t.type&&o.DomEvent.preventDefault(t),\"mousemove\"!==t.type&&o.DomEvent.stopPropagation(t)}}}),o.Map.include({_initPathRoot:function(){this._pathRoot||(this._pathRoot=o.Path.prototype._createElement(\"svg\"),this._panes.overlayPane.appendChild(this._pathRoot),this.options.zoomAnimation&&o.Browser.any3d?(o.DomUtil.addClass(this._pathRoot,\"leaflet-zoom-animated\"),\nthis.on({zoomanim:this._animatePathZoom,zoomend:this._endPathZoom})):o.DomUtil.addClass(this._pathRoot,\"leaflet-zoom-hide\"),this.on(\"moveend\",this._updateSvgViewport),this._updateSvgViewport())},_animatePathZoom:function(t){var e=this.getZoomScale(t.zoom),i=this._getCenterOffset(t.center)._multiplyBy(-e)._add(this._pathViewport.min);this._pathRoot.style[o.DomUtil.TRANSFORM]=o.DomUtil.getTranslateString(i)+\" scale(\"+e+\") \",this._pathZooming=!0},_endPathZoom:function(){this._pathZooming=!1},_updateSvgViewport:function(){if(!this._pathZooming){this._updatePathViewport();var t=this._pathViewport,e=t.min,i=t.max,n=i.x-e.x,s=i.y-e.y,a=this._pathRoot,r=this._panes.overlayPane;o.Browser.mobileWebkit&&r.removeChild(a),o.DomUtil.setPosition(a,e),a.setAttribute(\"width\",n),a.setAttribute(\"height\",s),a.setAttribute(\"viewBox\",[e.x,e.y,n,s].join(\" \")),o.Browser.mobileWebkit&&r.appendChild(a)}}}),o.Path.include({bindPopup:function(t,e){return t instanceof o.Popup?this._popup=t:((!this._popup||e)&&(this._popup=new o.Popup(e,this)),this._popup.setContent(t)),this._popupHandlersAdded||(this.on(\"click\",this._openPopup,this).on(\"remove\",this.closePopup,this),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this._popup=null,this.off(\"click\",this._openPopup).off(\"remove\",this.closePopup),this._popupHandlersAdded=!1),this},openPopup:function(t){return this._popup&&(t=t||this._latlng||this._latlngs[Math.floor(this._latlngs.length/2)],this._openPopup({latlng:t})),this},closePopup:function(){return this._popup&&this._popup._close(),this},_openPopup:function(t){this._popup.setLatLng(t.latlng),this._map.openPopup(this._popup)}}),o.Browser.vml=!o.Browser.svg&&function(){try{var t=e.createElement(\"div\");t.innerHTML='<v:shape adj=\"1\"/>';var i=t.firstChild;return i.style.behavior=\"url(#default#VML)\",i&&\"object\"==typeof i.adj}catch(n){return!1}}(),o.Path=o.Browser.svg||!o.Browser.vml?o.Path:o.Path.extend({statics:{VML:!0,CLIP_PADDING:.02},_createElement:function(){try{return e.namespaces.add(\"lvml\",\"urn:schemas-microsoft-com:vml\"),function(t){return e.createElement(\"<lvml:\"+t+' class=\"lvml\">')}}catch(t){return function(t){return e.createElement(\"<\"+t+' xmlns=\"urn:schemas-microsoft.com:vml\" class=\"lvml\">')}}}(),_initPath:function(){var t=this._container=this._createElement(\"shape\");o.DomUtil.addClass(t,\"leaflet-vml-shape\"+(this.options.className?\" \"+this.options.className:\"\")),this.options.clickable&&o.DomUtil.addClass(t,\"leaflet-clickable\"),t.coordsize=\"1 1\",this._path=this._createElement(\"path\"),t.appendChild(this._path),this._map._pathRoot.appendChild(t)},_initStyle:function(){this._updateStyle()},_updateStyle:function(){var t=this._stroke,e=this._fill,i=this.options,n=this._container;n.stroked=i.stroke,n.filled=i.fill,i.stroke?(t||(t=this._stroke=this._createElement(\"stroke\"),t.endcap=\"round\",n.appendChild(t)),t.weight=i.weight+\"px\",t.color=i.color,t.opacity=i.opacity,i.dashArray?t.dashStyle=o.Util.isArray(i.dashArray)?i.dashArray.join(\" \"):i.dashArray.replace(/( *, *)/g,\" \"):t.dashStyle=\"\",i.lineCap&&(t.endcap=i.lineCap.replace(\"butt\",\"flat\")),i.lineJoin&&(t.joinstyle=i.lineJoin)):t&&(n.removeChild(t),this._stroke=null),i.fill?(e||(e=this._fill=this._createElement(\"fill\"),n.appendChild(e)),e.color=i.fillColor||i.color,e.opacity=i.fillOpacity):e&&(n.removeChild(e),this._fill=null)},_updatePath:function(){var t=this._container.style;t.display=\"none\",this._path.v=this.getPathString()+\" \",t.display=\"\"}}),o.Map.include(o.Browser.svg||!o.Browser.vml?{}:{_initPathRoot:function(){if(!this._pathRoot){var t=this._pathRoot=e.createElement(\"div\");t.className=\"leaflet-vml-container\",this._panes.overlayPane.appendChild(t),this.on(\"moveend\",this._updatePathViewport),this._updatePathViewport()}}}),o.Browser.canvas=function(){return!!e.createElement(\"canvas\").getContext}(),o.Path=o.Path.SVG&&!t.L_PREFER_CANVAS||!o.Browser.canvas?o.Path:o.Path.extend({statics:{CANVAS:!0,SVG:!1},redraw:function(){return this._map&&(this.projectLatlngs(),this._requestUpdate()),this},setStyle:function(t){return o.setOptions(this,t),this._map&&(this._updateStyle(),this._requestUpdate()),this},onRemove:function(t){t.off(\"viewreset\",this.projectLatlngs,this).off(\"moveend\",this._updatePath,this),this.options.clickable&&(this._map.off(\"click\",this._onClick,this),this._map.off(\"mousemove\",this._onMouseMove,this)),this._requestUpdate(),this.fire(\"remove\"),this._map=null},_requestUpdate:function(){this._map&&!o.Path._updateRequest&&(o.Path._updateRequest=o.Util.requestAnimFrame(this._fireMapMoveEnd,this._map))},_fireMapMoveEnd:function(){o.Path._updateRequest=null,this.fire(\"moveend\")},_initElements:function(){this._map._initPathRoot(),this._ctx=this._map._canvasCtx},_updateStyle:function(){var t=this.options;t.stroke&&(this._ctx.lineWidth=t.weight,this._ctx.strokeStyle=t.color),t.fill&&(this._ctx.fillStyle=t.fillColor||t.color),t.lineCap&&(this._ctx.lineCap=t.lineCap),t.lineJoin&&(this._ctx.lineJoin=t.lineJoin)},_drawPath:function(){var t,e,i,n,s,a;for(this._ctx.beginPath(),t=0,i=this._parts.length;i>t;t++){for(e=0,n=this._parts[t].length;n>e;e++)s=this._parts[t][e],a=(0===e?\"move\":\"line\")+\"To\",this._ctx[a](s.x,s.y);this instanceof o.Polygon&&this._ctx.closePath()}},_checkIfEmpty:function(){return!this._parts.length},_updatePath:function(){if(!this._checkIfEmpty()){var t=this._ctx,e=this.options;this._drawPath(),t.save(),this._updateStyle(),e.fill&&(t.globalAlpha=e.fillOpacity,t.fill(e.fillRule||\"evenodd\")),e.stroke&&(t.globalAlpha=e.opacity,t.stroke()),t.restore()}},_initEvents:function(){this.options.clickable&&(this._map.on(\"mousemove\",this._onMouseMove,this),this._map.on(\"click dblclick contextmenu\",this._fireMouseEvent,this))},_fireMouseEvent:function(t){this._containsPoint(t.layerPoint)&&this.fire(t.type,t)},_onMouseMove:function(t){this._map&&!this._map._animatingZoom&&(this._containsPoint(t.layerPoint)?(this._ctx.canvas.style.cursor=\"pointer\",this._mouseInside=!0,this.fire(\"mouseover\",t)):this._mouseInside&&(this._ctx.canvas.style.cursor=\"\",this._mouseInside=!1,this.fire(\"mouseout\",t)))}}),o.Map.include(o.Path.SVG&&!t.L_PREFER_CANVAS||!o.Browser.canvas?{}:{_initPathRoot:function(){var t,i=this._pathRoot;i||(i=this._pathRoot=e.createElement(\"canvas\"),i.style.position=\"absolute\",t=this._canvasCtx=i.getContext(\"2d\"),t.lineCap=\"round\",t.lineJoin=\"round\",this._panes.overlayPane.appendChild(i),this.options.zoomAnimation&&(this._pathRoot.className=\"leaflet-zoom-animated\",this.on(\"zoomanim\",this._animatePathZoom),this.on(\"zoomend\",this._endPathZoom)),this.on(\"moveend\",this._updateCanvasViewport),this._updateCanvasViewport())},_updateCanvasViewport:function(){if(!this._pathZooming){this._updatePathViewport();var t=this._pathViewport,e=t.min,i=t.max.subtract(e),n=this._pathRoot;o.DomUtil.setPosition(n,e),n.width=i.x,n.height=i.y,n.getContext(\"2d\").translate(-e.x,-e.y)}}}),o.LineUtil={simplify:function(t,e){if(!e||!t.length)return t.slice();var i=e*e;return t=this._reducePoints(t,i),t=this._simplifyDP(t,i)},pointToSegmentDistance:function(t,e,i){return Math.sqrt(this._sqClosestPointOnSegment(t,e,i,!0))},closestPointOnSegment:function(t,e,i){return this._sqClosestPointOnSegment(t,e,i)},_simplifyDP:function(t,e){var n=t.length,o=typeof Uint8Array!=i+\"\"?Uint8Array:Array,s=new o(n);s[0]=s[n-1]=1,this._simplifyDPStep(t,s,e,0,n-1);var a,r=[];for(a=0;n>a;a++)s[a]&&r.push(t[a]);return r},_simplifyDPStep:function(t,e,i,n,o){var s,a,r,h=0;for(a=n+1;o-1>=a;a++)r=this._sqClosestPointOnSegment(t[a],t[n],t[o],!0),r>h&&(s=a,h=r);h>i&&(e[s]=1,this._simplifyDPStep(t,e,i,n,s),this._simplifyDPStep(t,e,i,s,o))},_reducePoints:function(t,e){for(var i=[t[0]],n=1,o=0,s=t.length;s>n;n++)this._sqDist(t[n],t[o])>e&&(i.push(t[n]),o=n);return s-1>o&&i.push(t[s-1]),i},clipSegment:function(t,e,i,n){var o,s,a,r=n?this._lastCode:this._getBitCode(t,i),h=this._getBitCode(e,i);for(this._lastCode=h;;){if(!(r|h))return[t,e];if(r&h)return!1;o=r||h,s=this._getEdgeIntersection(t,e,o,i),a=this._getBitCode(s,i),o===r?(t=s,r=a):(e=s,h=a)}},_getEdgeIntersection:function(t,e,i,n){var s=e.x-t.x,a=e.y-t.y,r=n.min,h=n.max;return 8&i?new o.Point(t.x+s*(h.y-t.y)/a,h.y):4&i?new o.Point(t.x+s*(r.y-t.y)/a,r.y):2&i?new o.Point(h.x,t.y+a*(h.x-t.x)/s):1&i?new o.Point(r.x,t.y+a*(r.x-t.x)/s):void 0},_getBitCode:function(t,e){var i=0;return t.x<e.min.x?i|=1:t.x>e.max.x&&(i|=2),t.y<e.min.y?i|=4:t.y>e.max.y&&(i|=8),i},_sqDist:function(t,e){var i=e.x-t.x,n=e.y-t.y;return i*i+n*n},_sqClosestPointOnSegment:function(t,e,i,n){var s,a=e.x,r=e.y,h=i.x-a,l=i.y-r,u=h*h+l*l;return u>0&&(s=((t.x-a)*h+(t.y-r)*l)/u,s>1?(a=i.x,r=i.y):s>0&&(a+=h*s,r+=l*s)),h=t.x-a,l=t.y-r,n?h*h+l*l:new o.Point(a,r)}},o.Polyline=o.Path.extend({initialize:function(t,e){o.Path.prototype.initialize.call(this,e),this._latlngs=this._convertLatLngs(t)},options:{smoothFactor:1,noClip:!1},projectLatlngs:function(){this._originalPoints=[];for(var t=0,e=this._latlngs.length;e>t;t++)this._originalPoints[t]=this._map.latLngToLayerPoint(this._latlngs[t])},getPathString:function(){for(var t=0,e=this._parts.length,i=\"\";e>t;t++)i+=this._getPathPartStr(this._parts[t]);return i},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._latlngs=this._convertLatLngs(t),this.redraw()},addLatLng:function(t){return this._latlngs.push(o.latLng(t)),this.redraw()},spliceLatLngs:function(){var t=[].splice.apply(this._latlngs,arguments);return this._convertLatLngs(this._latlngs,!0),this.redraw(),t},closestLayerPoint:function(t){for(var e,i,n=1/0,s=this._parts,a=null,r=0,h=s.length;h>r;r++)for(var l=s[r],u=1,c=l.length;c>u;u++){e=l[u-1],i=l[u];var d=o.LineUtil._sqClosestPointOnSegment(t,e,i,!0);n>d&&(n=d,a=o.LineUtil._sqClosestPointOnSegment(t,e,i))}return a&&(a.distance=Math.sqrt(n)),a},getBounds:function(){return new o.LatLngBounds(this.getLatLngs())},_convertLatLngs:function(t,e){var i,n,s=e?t:[];for(i=0,n=t.length;n>i;i++){if(o.Util.isArray(t[i])&&\"number\"!=typeof t[i][0])return;s[i]=o.latLng(t[i])}return s},_initEvents:function(){o.Path.prototype._initEvents.call(this)},_getPathPartStr:function(t){for(var e,i=o.Path.VML,n=0,s=t.length,a=\"\";s>n;n++)e=t[n],i&&e._round(),a+=(n?\"L\":\"M\")+e.x+\" \"+e.y;return a},_clipPoints:function(){var t,e,i,n=this._originalPoints,s=n.length;if(this.options.noClip)return void(this._parts=[n]);this._parts=[];var a=this._parts,r=this._map._pathViewport,h=o.LineUtil;for(t=0,e=0;s-1>t;t++)i=h.clipSegment(n[t],n[t+1],r,t),i&&(a[e]=a[e]||[],a[e].push(i[0]),(i[1]!==n[t+1]||t===s-2)&&(a[e].push(i[1]),e++))},_simplifyPoints:function(){for(var t=this._parts,e=o.LineUtil,i=0,n=t.length;n>i;i++)t[i]=e.simplify(t[i],this.options.smoothFactor)},_updatePath:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),o.Path.prototype._updatePath.call(this))}}),o.polyline=function(t,e){return new o.Polyline(t,e)},o.PolyUtil={},o.PolyUtil.clipPolygon=function(t,e){var i,n,s,a,r,h,l,u,c,d=[1,4,2,8],p=o.LineUtil;for(n=0,l=t.length;l>n;n++)t[n]._code=p._getBitCode(t[n],e);for(a=0;4>a;a++){for(u=d[a],i=[],n=0,l=t.length,s=l-1;l>n;s=n++)r=t[n],h=t[s],r._code&u?h._code&u||(c=p._getEdgeIntersection(h,r,u,e),c._code=p._getBitCode(c,e),i.push(c)):(h._code&u&&(c=p._getEdgeIntersection(h,r,u,e),c._code=p._getBitCode(c,e),i.push(c)),i.push(r));t=i}return t},o.Polygon=o.Polyline.extend({options:{fill:!0},initialize:function(t,e){o.Polyline.prototype.initialize.call(this,t,e),this._initWithHoles(t)},_initWithHoles:function(t){var e,i,n;if(t&&o.Util.isArray(t[0])&&\"number\"!=typeof t[0][0])for(this._latlngs=this._convertLatLngs(t[0]),this._holes=t.slice(1),e=0,i=this._holes.length;i>e;e++)n=this._holes[e]=this._convertLatLngs(this._holes[e]),n[0].equals(n[n.length-1])&&n.pop();t=this._latlngs,t.length>=2&&t[0].equals(t[t.length-1])&&t.pop()},projectLatlngs:function(){if(o.Polyline.prototype.projectLatlngs.call(this),this._holePoints=[],this._holes){var t,e,i,n;for(t=0,i=this._holes.length;i>t;t++)for(this._holePoints[t]=[],e=0,n=this._holes[t].length;n>e;e++)this._holePoints[t][e]=this._map.latLngToLayerPoint(this._holes[t][e])}},setLatLngs:function(t){return t&&o.Util.isArray(t[0])&&\"number\"!=typeof t[0][0]?(this._initWithHoles(t),this.redraw()):o.Polyline.prototype.setLatLngs.call(this,t)},_clipPoints:function(){var t=this._originalPoints,e=[];if(this._parts=[t].concat(this._holePoints),!this.options.noClip){for(var i=0,n=this._parts.length;n>i;i++){var s=o.PolyUtil.clipPolygon(this._parts[i],this._map._pathViewport);s.length&&e.push(s)}this._parts=e}},_getPathPartStr:function(t){var e=o.Polyline.prototype._getPathPartStr.call(this,t);return e+(o.Browser.svg?\"z\":\"x\")}}),o.polygon=function(t,e){return new o.Polygon(t,e)},function(){function t(t){return o.FeatureGroup.extend({initialize:function(t,e){this._layers={},this._options=e,this.setLatLngs(t)},setLatLngs:function(e){var i=0,n=e.length;for(this.eachLayer(function(t){n>i?t.setLatLngs(e[i++]):this.removeLayer(t)},this);n>i;)this.addLayer(new t(e[i++],this._options));return this},getLatLngs:function(){var t=[];return this.eachLayer(function(e){t.push(e.getLatLngs())}),t}})}o.MultiPolyline=t(o.Polyline),o.MultiPolygon=t(o.Polygon),o.multiPolyline=function(t,e){return new o.MultiPolyline(t,e)},o.multiPolygon=function(t,e){return new o.MultiPolygon(t,e)}}(),o.Rectangle=o.Polygon.extend({initialize:function(t,e){o.Polygon.prototype.initialize.call(this,this._boundsToLatLngs(t),e)},setBounds:function(t){this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return t=o.latLngBounds(t),[t.getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}}),o.rectangle=function(t,e){return new o.Rectangle(t,e)},o.Circle=o.Path.extend({initialize:function(t,e,i){o.Path.prototype.initialize.call(this,i),this._latlng=o.latLng(t),this._mRadius=e},options:{fill:!0},setLatLng:function(t){return this._latlng=o.latLng(t),this.redraw()},setRadius:function(t){return this._mRadius=t,this.redraw()},projectLatlngs:function(){var t=this._getLngRadius(),e=this._latlng,i=this._map.latLngToLayerPoint([e.lat,e.lng-t]);this._point=this._map.latLngToLayerPoint(e),this._radius=Math.max(this._point.x-i.x,1)},getBounds:function(){var t=this._getLngRadius(),e=this._mRadius/40075017*360,i=this._latlng;return new o.LatLngBounds([i.lat-e,i.lng-t],[i.lat+e,i.lng+t])},getLatLng:function(){return this._latlng},getPathString:function(){var t=this._point,e=this._radius;return this._checkIfEmpty()?\"\":o.Browser.svg?\"M\"+t.x+\",\"+(t.y-e)+\"A\"+e+\",\"+e+\",0,1,1,\"+(t.x-.1)+\",\"+(t.y-e)+\" z\":(t._round(),e=Math.round(e),\"AL \"+t.x+\",\"+t.y+\" \"+e+\",\"+e+\" 0,23592600\")},getRadius:function(){return this._mRadius},_getLatRadius:function(){return this._mRadius/40075017*360},_getLngRadius:function(){return this._getLatRadius()/Math.cos(o.LatLng.DEG_TO_RAD*this._latlng.lat)},_checkIfEmpty:function(){if(!this._map)return!1;var t=this._map._pathViewport,e=this._radius,i=this._point;return i.x-e>t.max.x||i.y-e>t.max.y||i.x+e<t.min.x||i.y+e<t.min.y}}),o.circle=function(t,e,i){return new o.Circle(t,e,i)},o.CircleMarker=o.Circle.extend({options:{radius:10,weight:2},initialize:function(t,e){o.Circle.prototype.initialize.call(this,t,null,e),this._radius=this.options.radius},projectLatlngs:function(){this._point=this._map.latLngToLayerPoint(this._latlng)},_updateStyle:function(){o.Circle.prototype._updateStyle.call(this),this.setRadius(this.options.radius)},setLatLng:function(t){return o.Circle.prototype.setLatLng.call(this,t),this._popup&&this._popup._isOpen&&this._popup.setLatLng(t),this},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius}}),o.circleMarker=function(t,e){return new o.CircleMarker(t,e)},o.Polyline.include(o.Path.CANVAS?{_containsPoint:function(t,e){var i,n,s,a,r,h,l,u=this.options.weight/2;for(o.Browser.touch&&(u+=10),i=0,a=this._parts.length;a>i;i++)for(l=this._parts[i],n=0,r=l.length,s=r-1;r>n;s=n++)if((e||0!==n)&&(h=o.LineUtil.pointToSegmentDistance(t,l[s],l[n]),u>=h))return!0;return!1}}:{}),o.Polygon.include(o.Path.CANVAS?{_containsPoint:function(t){var e,i,n,s,a,r,h,l,u=!1;if(o.Polyline.prototype._containsPoint.call(this,t,!0))return!0;for(s=0,h=this._parts.length;h>s;s++)for(e=this._parts[s],a=0,l=e.length,r=l-1;l>a;r=a++)i=e[a],n=e[r],i.y>t.y!=n.y>t.y&&t.x<(n.x-i.x)*(t.y-i.y)/(n.y-i.y)+i.x&&(u=!u);return u}}:{}),o.Circle.include(o.Path.CANVAS?{_drawPath:function(){var t=this._point;this._ctx.beginPath(),this._ctx.arc(t.x,t.y,this._radius,0,2*Math.PI,!1)},_containsPoint:function(t){var e=this._point,i=this.options.stroke?this.options.weight/2:0;return t.distanceTo(e)<=this._radius+i}}:{}),o.CircleMarker.include(o.Path.CANVAS?{_updateStyle:function(){o.Path.prototype._updateStyle.call(this)}}:{}),o.GeoJSON=o.FeatureGroup.extend({initialize:function(t,e){o.setOptions(this,e),this._layers={},t&&this.addData(t)},addData:function(t){var e,i,n,s=o.Util.isArray(t)?t:t.features;if(s){for(e=0,i=s.length;i>e;e++)n=s[e],(n.geometries||n.geometry||n.features||n.coordinates)&&this.addData(s[e]);return this}var a=this.options;if(!a.filter||a.filter(t)){var r=o.GeoJSON.geometryToLayer(t,a.pointToLayer,a.coordsToLatLng,a);return r.feature=o.GeoJSON.asFeature(t),r.defaultOptions=r.options,this.resetStyle(r),a.onEachFeature&&a.onEachFeature(t,r),this.addLayer(r)}},resetStyle:function(t){var e=this.options.style;e&&(o.Util.extend(t.options,t.defaultOptions),this._setLayerStyle(t,e))},setStyle:function(t){this.eachLayer(function(e){this._setLayerStyle(e,t)},this)},_setLayerStyle:function(t,e){\"function\"==typeof e&&(e=e(t.feature)),t.setStyle&&t.setStyle(e)}}),o.extend(o.GeoJSON,{geometryToLayer:function(t,e,i,n){var s,a,r,h,l=\"Feature\"===t.type?t.geometry:t,u=l.coordinates,c=[];switch(i=i||this.coordsToLatLng,l.type){case\"Point\":return s=i(u),e?e(t,s):new o.Marker(s);case\"MultiPoint\":for(r=0,h=u.length;h>r;r++)s=i(u[r]),c.push(e?e(t,s):new o.Marker(s));return new o.FeatureGroup(c);case\"LineString\":return a=this.coordsToLatLngs(u,0,i),new o.Polyline(a,n);case\"Polygon\":if(2===u.length&&!u[1].length)throw new Error(\"Invalid GeoJSON object.\");return a=this.coordsToLatLngs(u,1,i),new o.Polygon(a,n);case\"MultiLineString\":return a=this.coordsToLatLngs(u,1,i),new o.MultiPolyline(a,n);case\"MultiPolygon\":return a=this.coordsToLatLngs(u,2,i),new o.MultiPolygon(a,n);case\"GeometryCollection\":for(r=0,h=l.geometries.length;h>r;r++)c.push(this.geometryToLayer({geometry:l.geometries[r],type:\"Feature\",properties:t.properties},e,i,n));return new o.FeatureGroup(c);default:throw new Error(\"Invalid GeoJSON object.\")}},coordsToLatLng:function(t){return new o.LatLng(t[1],t[0],t[2])},coordsToLatLngs:function(t,e,i){var n,o,s,a=[];for(o=0,s=t.length;s>o;o++)n=e?this.coordsToLatLngs(t[o],e-1,i):(i||this.coordsToLatLng)(t[o]),a.push(n);return a},latLngToCoords:function(t){var e=[t.lng,t.lat];return t.alt!==i&&e.push(t.alt),e},latLngsToCoords:function(t){for(var e=[],i=0,n=t.length;n>i;i++)e.push(o.GeoJSON.latLngToCoords(t[i]));return e},getFeature:function(t,e){return t.feature?o.extend({},t.feature,{geometry:e}):o.GeoJSON.asFeature(e)},asFeature:function(t){return\"Feature\"===t.type?t:{type:\"Feature\",properties:{},geometry:t}}});var a={toGeoJSON:function(){return o.GeoJSON.getFeature(this,{type:\"Point\",coordinates:o.GeoJSON.latLngToCoords(this.getLatLng())})}};o.Marker.include(a),o.Circle.include(a),o.CircleMarker.include(a),o.Polyline.include({toGeoJSON:function(){return o.GeoJSON.getFeature(this,{type:\"LineString\",coordinates:o.GeoJSON.latLngsToCoords(this.getLatLngs())})}}),o.Polygon.include({toGeoJSON:function(){var t,e,i,n=[o.GeoJSON.latLngsToCoords(this.getLatLngs())];if(n[0].push(n[0][0]),this._holes)for(t=0,e=this._holes.length;e>t;t++)i=o.GeoJSON.latLngsToCoords(this._holes[t]),i.push(i[0]),n.push(i);return o.GeoJSON.getFeature(this,{type:\"Polygon\",coordinates:n})}}),function(){function t(t){return function(){var e=[];return this.eachLayer(function(t){e.push(t.toGeoJSON().geometry.coordinates)}),o.GeoJSON.getFeature(this,{type:t,coordinates:e})}}o.MultiPolyline.include({toGeoJSON:t(\"MultiLineString\")}),o.MultiPolygon.include({toGeoJSON:t(\"MultiPolygon\")}),o.LayerGroup.include({toGeoJSON:function(){var e,i=this.feature&&this.feature.geometry,n=[];if(i&&\"MultiPoint\"===i.type)return t(\"MultiPoint\").call(this);var s=i&&\"GeometryCollection\"===i.type;return this.eachLayer(function(t){t.toGeoJSON&&(e=t.toGeoJSON(),n.push(s?e.geometry:o.GeoJSON.asFeature(e)))}),s?o.GeoJSON.getFeature(this,{geometries:n,type:\"GeometryCollection\"}):{type:\"FeatureCollection\",features:n}}})}(),o.geoJson=function(t,e){return new o.GeoJSON(t,e)},o.DomEvent={addListener:function(t,e,i,n){var s,a,r,h=o.stamp(i),l=\"_leaflet_\"+e+h;return t[l]?this:(s=function(e){return i.call(n||t,e||o.DomEvent._getEvent())},o.Browser.pointer&&0===e.indexOf(\"touch\")?this.addPointerListener(t,e,s,h):(o.Browser.touch&&\"dblclick\"===e&&this.addDoubleTapListener&&this.addDoubleTapListener(t,s,h),\"addEventListener\"in t?\"mousewheel\"===e?(t.addEventListener(\"DOMMouseScroll\",s,!1),t.addEventListener(e,s,!1)):\"mouseenter\"===e||\"mouseleave\"===e?(a=s,r=\"mouseenter\"===e?\"mouseover\":\"mouseout\",s=function(e){return o.DomEvent._checkMouse(t,e)?a(e):void 0},t.addEventListener(r,s,!1)):\"click\"===e&&o.Browser.android?(a=s,s=function(t){return o.DomEvent._filterClick(t,a)},t.addEventListener(e,s,!1)):t.addEventListener(e,s,!1):\"attachEvent\"in t&&t.attachEvent(\"on\"+e,s),t[l]=s,this))},removeListener:function(t,e,i){var n=o.stamp(i),s=\"_leaflet_\"+e+n,a=t[s];return a?(o.Browser.pointer&&0===e.indexOf(\"touch\")?this.removePointerListener(t,e,n):o.Browser.touch&&\"dblclick\"===e&&this.removeDoubleTapListener?this.removeDoubleTapListener(t,n):\"removeEventListener\"in t?\"mousewheel\"===e?(t.removeEventListener(\"DOMMouseScroll\",a,!1),t.removeEventListener(e,a,!1)):\"mouseenter\"===e||\"mouseleave\"===e?t.removeEventListener(\"mouseenter\"===e?\"mouseover\":\"mouseout\",a,!1):t.removeEventListener(e,a,!1):\"detachEvent\"in t&&t.detachEvent(\"on\"+e,a),t[s]=null,this):this},stopPropagation:function(t){return t.stopPropagation?t.stopPropagation():t.cancelBubble=!0,o.DomEvent._skipped(t),this},disableScrollPropagation:function(t){var e=o.DomEvent.stopPropagation;return o.DomEvent.on(t,\"mousewheel\",e).on(t,\"MozMousePixelScroll\",e)},disableClickPropagation:function(t){for(var e=o.DomEvent.stopPropagation,i=o.Draggable.START.length-1;i>=0;i--)o.DomEvent.on(t,o.Draggable.START[i],e);return o.DomEvent.on(t,\"click\",o.DomEvent._fakeStop).on(t,\"dblclick\",e)},preventDefault:function(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this},stop:function(t){return o.DomEvent.preventDefault(t).stopPropagation(t)},getMousePosition:function(t,e){if(!e)return new o.Point(t.clientX,t.clientY);var i=e.getBoundingClientRect();return new o.Point(t.clientX-i.left-e.clientLeft,t.clientY-i.top-e.clientTop)},getWheelDelta:function(t){var e=0;return t.wheelDelta&&(e=t.wheelDelta/120),t.detail&&(e=-t.detail/3),e},_skipEvents:{},_fakeStop:function(t){o.DomEvent._skipEvents[t.type]=!0},_skipped:function(t){var e=this._skipEvents[t.type];return this._skipEvents[t.type]=!1,e},_checkMouse:function(t,e){var i=e.relatedTarget;if(!i)return!0;try{for(;i&&i!==t;)i=i.parentNode}catch(n){return!1}return i!==t},_getEvent:function(){var e=t.event;if(!e)for(var i=arguments.callee.caller;i&&(e=i.arguments[0],!e||t.Event!==e.constructor);)i=i.caller;return e},_filterClick:function(t,e){var i=t.timeStamp||t.originalEvent.timeStamp,n=o.DomEvent._lastClick&&i-o.DomEvent._lastClick;return n&&n>100&&500>n||t.target._simulatedClick&&!t._simulated?void o.DomEvent.stop(t):(o.DomEvent._lastClick=i,e(t))}},o.DomEvent.on=o.DomEvent.addListener,o.DomEvent.off=o.DomEvent.removeListener,o.Draggable=o.Class.extend({includes:o.Mixin.Events,statics:{START:o.Browser.touch?[\"touchstart\",\"mousedown\"]:[\"mousedown\"],END:{mousedown:\"mouseup\",touchstart:\"touchend\",pointerdown:\"touchend\",MSPointerDown:\"touchend\"},MOVE:{mousedown:\"mousemove\",touchstart:\"touchmove\",pointerdown:\"touchmove\",MSPointerDown:\"touchmove\"}},initialize:function(t,e){this._element=t,this._dragStartTarget=e||t},enable:function(){if(!this._enabled){for(var t=o.Draggable.START.length-1;t>=0;t--)o.DomEvent.on(this._dragStartTarget,o.Draggable.START[t],this._onDown,this);this._enabled=!0}},disable:function(){if(this._enabled){for(var t=o.Draggable.START.length-1;t>=0;t--)o.DomEvent.off(this._dragStartTarget,o.Draggable.START[t],this._onDown,this);this._enabled=!1,this._moved=!1}},_onDown:function(t){if(this._moved=!1,!t.shiftKey&&(1===t.which||1===t.button||t.touches)&&(o.DomEvent.stopPropagation(t),!o.Draggable._disabled&&(o.DomUtil.disableImageDrag(),o.DomUtil.disableTextSelection(),!this._moving))){var i=t.touches?t.touches[0]:t;this._startPoint=new o.Point(i.clientX,i.clientY),this._startPos=this._newPos=o.DomUtil.getPosition(this._element),o.DomEvent.on(e,o.Draggable.MOVE[t.type],this._onMove,this).on(e,o.Draggable.END[t.type],this._onUp,this)}},_onMove:function(t){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var i=t.touches&&1===t.touches.length?t.touches[0]:t,n=new o.Point(i.clientX,i.clientY),s=n.subtract(this._startPoint);(s.x||s.y)&&(o.Browser.touch&&Math.abs(s.x)+Math.abs(s.y)<3||(o.DomEvent.preventDefault(t),this._moved||(this.fire(\"dragstart\"),this._moved=!0,this._startPos=o.DomUtil.getPosition(this._element).subtract(s),o.DomUtil.addClass(e.body,\"leaflet-dragging\"),this._lastTarget=t.target||t.srcElement,o.DomUtil.addClass(this._lastTarget,\"leaflet-drag-target\")),this._newPos=this._startPos.add(s),this._moving=!0,o.Util.cancelAnimFrame(this._animRequest),this._animRequest=o.Util.requestAnimFrame(this._updatePosition,this,!0,this._dragStartTarget)))},_updatePosition:function(){this.fire(\"predrag\"),o.DomUtil.setPosition(this._element,this._newPos),this.fire(\"drag\")},_onUp:function(){o.DomUtil.removeClass(e.body,\"leaflet-dragging\"),this._lastTarget&&(o.DomUtil.removeClass(this._lastTarget,\"leaflet-drag-target\"),this._lastTarget=null);for(var t in o.Draggable.MOVE)o.DomEvent.off(e,o.Draggable.MOVE[t],this._onMove).off(e,o.Draggable.END[t],this._onUp);o.DomUtil.enableImageDrag(),o.DomUtil.enableTextSelection(),this._moved&&this._moving&&(o.Util.cancelAnimFrame(this._animRequest),this.fire(\"dragend\",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1}}),o.Handler=o.Class.extend({initialize:function(t){this._map=t},enable:function(){this._enabled||(this._enabled=!0,this.addHooks())},disable:function(){this._enabled&&(this._enabled=!1,this.removeHooks())},enabled:function(){return!!this._enabled}}),o.Map.mergeOptions({dragging:!0,inertia:!o.Browser.android23,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,inertiaThreshold:o.Browser.touch?32:18,easeLinearity:.25,worldCopyJump:!1}),o.Map.Drag=o.Handler.extend({addHooks:function(){if(!this._draggable){var t=this._map;this._draggable=new o.Draggable(t._mapPane,t._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),t.options.worldCopyJump&&(this._draggable.on(\"predrag\",this._onPreDrag,this),t.on(\"viewreset\",this._onViewReset,this),t.whenReady(this._onViewReset,this))}this._draggable.enable()},removeHooks:function(){this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},_onDragStart:function(){var t=this._map;t._panAnim&&t._panAnim.stop(),t.fire(\"movestart\").fire(\"dragstart\"),t.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(){if(this._map.options.inertia){var t=this._lastTime=+new Date,e=this._lastPos=this._draggable._newPos;this._positions.push(e),this._times.push(t),t-this._times[0]>200&&(this._positions.shift(),this._times.shift())}this._map.fire(\"move\").fire(\"drag\")},_onViewReset:function(){var t=this._map.getSize()._divideBy(2),e=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=e.subtract(t).x,this._worldWidth=this._map.project([0,180]).x},_onPreDrag:function(){var t=this._worldWidth,e=Math.round(t/2),i=this._initialWorldOffset,n=this._draggable._newPos.x,o=(n-e+i)%t+e-i,s=(n+e+i)%t-e-i,a=Math.abs(o+i)<Math.abs(s+i)?o:s;this._draggable._newPos.x=a},_onDragEnd:function(t){var e=this._map,i=e.options,n=+new Date-this._lastTime,s=!i.inertia||n>i.inertiaThreshold||!this._positions[0];if(e.fire(\"dragend\",t),s)e.fire(\"moveend\");else{var a=this._lastPos.subtract(this._positions[0]),r=(this._lastTime+n-this._times[0])/1e3,h=i.easeLinearity,l=a.multiplyBy(h/r),u=l.distanceTo([0,0]),c=Math.min(i.inertiaMaxSpeed,u),d=l.multiplyBy(c/u),p=c/(i.inertiaDeceleration*h),_=d.multiplyBy(-p/2).round();_.x&&_.y?(_=e._limitOffset(_,e.options.maxBounds),o.Util.requestAnimFrame(function(){e.panBy(_,{duration:p,easeLinearity:h,noMoveStart:!0})})):e.fire(\"moveend\")}}}),o.Map.addInitHook(\"addHandler\",\"dragging\",o.Map.Drag),o.Map.mergeOptions({doubleClickZoom:!0}),o.Map.DoubleClickZoom=o.Handler.extend({addHooks:function(){this._map.on(\"dblclick\",this._onDoubleClick,this)},removeHooks:function(){this._map.off(\"dblclick\",this._onDoubleClick,this)},_onDoubleClick:function(t){var e=this._map,i=e.getZoom()+(t.originalEvent.shiftKey?-1:1);\"center\"===e.options.doubleClickZoom?e.setZoom(i):e.setZoomAround(t.containerPoint,i)}}),o.Map.addInitHook(\"addHandler\",\"doubleClickZoom\",o.Map.DoubleClickZoom),o.Map.mergeOptions({scrollWheelZoom:!0}),o.Map.ScrollWheelZoom=o.Handler.extend({addHooks:function(){o.DomEvent.on(this._map._container,\"mousewheel\",this._onWheelScroll,this),o.DomEvent.on(this._map._container,\"MozMousePixelScroll\",o.DomEvent.preventDefault),this._delta=0},removeHooks:function(){o.DomEvent.off(this._map._container,\"mousewheel\",this._onWheelScroll),o.DomEvent.off(this._map._container,\"MozMousePixelScroll\",o.DomEvent.preventDefault)},_onWheelScroll:function(t){var e=o.DomEvent.getWheelDelta(t);this._delta+=e,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date);var i=Math.max(40-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(o.bind(this._performZoom,this),i),o.DomEvent.preventDefault(t),o.DomEvent.stopPropagation(t)},_performZoom:function(){var t=this._map,e=this._delta,i=t.getZoom();e=e>0?Math.ceil(e):Math.floor(e),e=Math.max(Math.min(e,4),-4),e=t._limitZoom(i+e)-i,this._delta=0,this._startTime=null,e&&(\"center\"===t.options.scrollWheelZoom?t.setZoom(i+e):t.setZoomAround(this._lastMousePos,i+e))}}),o.Map.addInitHook(\"addHandler\",\"scrollWheelZoom\",o.Map.ScrollWheelZoom),o.extend(o.DomEvent,{_touchstart:o.Browser.msPointer?\"MSPointerDown\":o.Browser.pointer?\"pointerdown\":\"touchstart\",_touchend:o.Browser.msPointer?\"MSPointerUp\":o.Browser.pointer?\"pointerup\":\"touchend\",addDoubleTapListener:function(t,i,n){function s(t){var e;if(o.Browser.pointer?(_.push(t.pointerId),e=_.length):e=t.touches.length,!(e>1)){var i=Date.now(),n=i-(r||i);h=t.touches?t.touches[0]:t,l=n>0&&u>=n,r=i}}function a(t){if(o.Browser.pointer){var e=_.indexOf(t.pointerId);if(-1===e)return;_.splice(e,1)}if(l){if(o.Browser.pointer){var n,s={};for(var a in h)n=h[a],\"function\"==typeof n?s[a]=n.bind(h):s[a]=n;h=s}h.type=\"dblclick\",i(h),r=null}}var r,h,l=!1,u=250,c=\"_leaflet_\",d=this._touchstart,p=this._touchend,_=[];t[c+d+n]=s,t[c+p+n]=a;var m=o.Browser.pointer?e.documentElement:t;return t.addEventListener(d,s,!1),m.addEventListener(p,a,!1),o.Browser.pointer&&m.addEventListener(o.DomEvent.POINTER_CANCEL,a,!1),this},removeDoubleTapListener:function(t,i){var n=\"_leaflet_\";return t.removeEventListener(this._touchstart,t[n+this._touchstart+i],!1),(o.Browser.pointer?e.documentElement:t).removeEventListener(this._touchend,t[n+this._touchend+i],!1),o.Browser.pointer&&e.documentElement.removeEventListener(o.DomEvent.POINTER_CANCEL,t[n+this._touchend+i],!1),this}}),o.extend(o.DomEvent,{POINTER_DOWN:o.Browser.msPointer?\"MSPointerDown\":\"pointerdown\",POINTER_MOVE:o.Browser.msPointer?\"MSPointerMove\":\"pointermove\",POINTER_UP:o.Browser.msPointer?\"MSPointerUp\":\"pointerup\",POINTER_CANCEL:o.Browser.msPointer?\"MSPointerCancel\":\"pointercancel\",_pointers:[],_pointerDocumentListener:!1,addPointerListener:function(t,e,i,n){switch(e){case\"touchstart\":return this.addPointerListenerStart(t,e,i,n);\ncase\"touchend\":return this.addPointerListenerEnd(t,e,i,n);case\"touchmove\":return this.addPointerListenerMove(t,e,i,n);default:throw\"Unknown touch event type\"}},addPointerListenerStart:function(t,i,n,s){var a=\"_leaflet_\",r=this._pointers,h=function(t){\"mouse\"!==t.pointerType&&t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&o.DomEvent.preventDefault(t);for(var e=!1,i=0;i<r.length;i++)if(r[i].pointerId===t.pointerId){e=!0;break}e||r.push(t),t.touches=r.slice(),t.changedTouches=[t],n(t)};if(t[a+\"touchstart\"+s]=h,t.addEventListener(this.POINTER_DOWN,h,!1),!this._pointerDocumentListener){var l=function(t){for(var e=0;e<r.length;e++)if(r[e].pointerId===t.pointerId){r.splice(e,1);break}};e.documentElement.addEventListener(this.POINTER_UP,l,!1),e.documentElement.addEventListener(this.POINTER_CANCEL,l,!1),this._pointerDocumentListener=!0}return this},addPointerListenerMove:function(t,e,i,n){function o(t){if(t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&\"mouse\"!==t.pointerType||0!==t.buttons){for(var e=0;e<a.length;e++)if(a[e].pointerId===t.pointerId){a[e]=t;break}t.touches=a.slice(),t.changedTouches=[t],i(t)}}var s=\"_leaflet_\",a=this._pointers;return t[s+\"touchmove\"+n]=o,t.addEventListener(this.POINTER_MOVE,o,!1),this},addPointerListenerEnd:function(t,e,i,n){var o=\"_leaflet_\",s=this._pointers,a=function(t){for(var e=0;e<s.length;e++)if(s[e].pointerId===t.pointerId){s.splice(e,1);break}t.touches=s.slice(),t.changedTouches=[t],i(t)};return t[o+\"touchend\"+n]=a,t.addEventListener(this.POINTER_UP,a,!1),t.addEventListener(this.POINTER_CANCEL,a,!1),this},removePointerListener:function(t,e,i){var n=\"_leaflet_\",o=t[n+e+i];switch(e){case\"touchstart\":t.removeEventListener(this.POINTER_DOWN,o,!1);break;case\"touchmove\":t.removeEventListener(this.POINTER_MOVE,o,!1);break;case\"touchend\":t.removeEventListener(this.POINTER_UP,o,!1),t.removeEventListener(this.POINTER_CANCEL,o,!1)}return this}}),o.Map.mergeOptions({touchZoom:o.Browser.touch&&!o.Browser.android23,bounceAtZoomLimits:!0}),o.Map.TouchZoom=o.Handler.extend({addHooks:function(){o.DomEvent.on(this._map._container,\"touchstart\",this._onTouchStart,this)},removeHooks:function(){o.DomEvent.off(this._map._container,\"touchstart\",this._onTouchStart,this)},_onTouchStart:function(t){var i=this._map;if(t.touches&&2===t.touches.length&&!i._animatingZoom&&!this._zooming){var n=i.mouseEventToLayerPoint(t.touches[0]),s=i.mouseEventToLayerPoint(t.touches[1]),a=i._getCenterLayerPoint();this._startCenter=n.add(s)._divideBy(2),this._startDist=n.distanceTo(s),this._moved=!1,this._zooming=!0,this._centerOffset=a.subtract(this._startCenter),i._panAnim&&i._panAnim.stop(),o.DomEvent.on(e,\"touchmove\",this._onTouchMove,this).on(e,\"touchend\",this._onTouchEnd,this),o.DomEvent.preventDefault(t)}},_onTouchMove:function(t){var e=this._map;if(t.touches&&2===t.touches.length&&this._zooming){var i=e.mouseEventToLayerPoint(t.touches[0]),n=e.mouseEventToLayerPoint(t.touches[1]);this._scale=i.distanceTo(n)/this._startDist,this._delta=i._add(n)._divideBy(2)._subtract(this._startCenter),1!==this._scale&&(e.options.bounceAtZoomLimits||!(e.getZoom()===e.getMinZoom()&&this._scale<1||e.getZoom()===e.getMaxZoom()&&this._scale>1))&&(this._moved||(o.DomUtil.addClass(e._mapPane,\"leaflet-touching\"),e.fire(\"movestart\").fire(\"zoomstart\"),this._moved=!0),o.Util.cancelAnimFrame(this._animRequest),this._animRequest=o.Util.requestAnimFrame(this._updateOnMove,this,!0,this._map._container),o.DomEvent.preventDefault(t))}},_updateOnMove:function(){var t=this._map,e=this._getScaleOrigin(),i=t.layerPointToLatLng(e),n=t.getScaleZoom(this._scale);t._animateZoom(i,n,this._startCenter,this._scale,this._delta,!1,!0)},_onTouchEnd:function(){if(!this._moved||!this._zooming)return void(this._zooming=!1);var t=this._map;this._zooming=!1,o.DomUtil.removeClass(t._mapPane,\"leaflet-touching\"),o.Util.cancelAnimFrame(this._animRequest),o.DomEvent.off(e,\"touchmove\",this._onTouchMove).off(e,\"touchend\",this._onTouchEnd);var i=this._getScaleOrigin(),n=t.layerPointToLatLng(i),s=t.getZoom(),a=t.getScaleZoom(this._scale)-s,r=a>0?Math.ceil(a):Math.floor(a),h=t._limitZoom(s+r),l=t.getZoomScale(h)/this._scale;t._animateZoom(n,h,i,l)},_getScaleOrigin:function(){var t=this._centerOffset.subtract(this._delta).divideBy(this._scale);return this._startCenter.add(t)}}),o.Map.addInitHook(\"addHandler\",\"touchZoom\",o.Map.TouchZoom),o.Map.mergeOptions({tap:!0,tapTolerance:15}),o.Map.Tap=o.Handler.extend({addHooks:function(){o.DomEvent.on(this._map._container,\"touchstart\",this._onDown,this)},removeHooks:function(){o.DomEvent.off(this._map._container,\"touchstart\",this._onDown,this)},_onDown:function(t){if(t.touches){if(o.DomEvent.preventDefault(t),this._fireClick=!0,t.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var i=t.touches[0],n=i.target;this._startPos=this._newPos=new o.Point(i.clientX,i.clientY),n.tagName&&\"a\"===n.tagName.toLowerCase()&&o.DomUtil.addClass(n,\"leaflet-active\"),this._holdTimeout=setTimeout(o.bind(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent(\"contextmenu\",i))},this),1e3),o.DomEvent.on(e,\"touchmove\",this._onMove,this).on(e,\"touchend\",this._onUp,this)}},_onUp:function(t){if(clearTimeout(this._holdTimeout),o.DomEvent.off(e,\"touchmove\",this._onMove,this).off(e,\"touchend\",this._onUp,this),this._fireClick&&t&&t.changedTouches){var i=t.changedTouches[0],n=i.target;n&&n.tagName&&\"a\"===n.tagName.toLowerCase()&&o.DomUtil.removeClass(n,\"leaflet-active\"),this._isTapValid()&&this._simulateEvent(\"click\",i)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(t){var e=t.touches[0];this._newPos=new o.Point(e.clientX,e.clientY)},_simulateEvent:function(i,n){var o=e.createEvent(\"MouseEvents\");o._simulated=!0,n.target._simulatedClick=!0,o.initMouseEvent(i,!0,!0,t,1,n.screenX,n.screenY,n.clientX,n.clientY,!1,!1,!1,!1,0,null),n.target.dispatchEvent(o)}}),o.Browser.touch&&!o.Browser.pointer&&o.Map.addInitHook(\"addHandler\",\"tap\",o.Map.Tap),o.Map.mergeOptions({boxZoom:!0}),o.Map.BoxZoom=o.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane,this._moved=!1},addHooks:function(){o.DomEvent.on(this._container,\"mousedown\",this._onMouseDown,this)},removeHooks:function(){o.DomEvent.off(this._container,\"mousedown\",this._onMouseDown),this._moved=!1},moved:function(){return this._moved},_onMouseDown:function(t){return this._moved=!1,!t.shiftKey||1!==t.which&&1!==t.button?!1:(o.DomUtil.disableTextSelection(),o.DomUtil.disableImageDrag(),this._startLayerPoint=this._map.mouseEventToLayerPoint(t),void o.DomEvent.on(e,\"mousemove\",this._onMouseMove,this).on(e,\"mouseup\",this._onMouseUp,this).on(e,\"keydown\",this._onKeyDown,this))},_onMouseMove:function(t){this._moved||(this._box=o.DomUtil.create(\"div\",\"leaflet-zoom-box\",this._pane),o.DomUtil.setPosition(this._box,this._startLayerPoint),this._container.style.cursor=\"crosshair\",this._map.fire(\"boxzoomstart\"));var e=this._startLayerPoint,i=this._box,n=this._map.mouseEventToLayerPoint(t),s=n.subtract(e),a=new o.Point(Math.min(n.x,e.x),Math.min(n.y,e.y));o.DomUtil.setPosition(i,a),this._moved=!0,i.style.width=Math.max(0,Math.abs(s.x)-4)+\"px\",i.style.height=Math.max(0,Math.abs(s.y)-4)+\"px\"},_finish:function(){this._moved&&(this._pane.removeChild(this._box),this._container.style.cursor=\"\"),o.DomUtil.enableTextSelection(),o.DomUtil.enableImageDrag(),o.DomEvent.off(e,\"mousemove\",this._onMouseMove).off(e,\"mouseup\",this._onMouseUp).off(e,\"keydown\",this._onKeyDown)},_onMouseUp:function(t){this._finish();var e=this._map,i=e.mouseEventToLayerPoint(t);if(!this._startLayerPoint.equals(i)){var n=new o.LatLngBounds(e.layerPointToLatLng(this._startLayerPoint),e.layerPointToLatLng(i));e.fitBounds(n),e.fire(\"boxzoomend\",{boxZoomBounds:n})}},_onKeyDown:function(t){27===t.keyCode&&this._finish()}}),o.Map.addInitHook(\"addHandler\",\"boxZoom\",o.Map.BoxZoom),o.Map.mergeOptions({keyboard:!0,keyboardPanOffset:80,keyboardZoomOffset:1}),o.Map.Keyboard=o.Handler.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,173]},initialize:function(t){this._map=t,this._setPanOffset(t.options.keyboardPanOffset),this._setZoomOffset(t.options.keyboardZoomOffset)},addHooks:function(){var t=this._map._container;-1===t.tabIndex&&(t.tabIndex=\"0\"),o.DomEvent.on(t,\"focus\",this._onFocus,this).on(t,\"blur\",this._onBlur,this).on(t,\"mousedown\",this._onMouseDown,this),this._map.on(\"focus\",this._addHooks,this).on(\"blur\",this._removeHooks,this)},removeHooks:function(){this._removeHooks();var t=this._map._container;o.DomEvent.off(t,\"focus\",this._onFocus,this).off(t,\"blur\",this._onBlur,this).off(t,\"mousedown\",this._onMouseDown,this),this._map.off(\"focus\",this._addHooks,this).off(\"blur\",this._removeHooks,this)},_onMouseDown:function(){if(!this._focused){var i=e.body,n=e.documentElement,o=i.scrollTop||n.scrollTop,s=i.scrollLeft||n.scrollLeft;this._map._container.focus(),t.scrollTo(s,o)}},_onFocus:function(){this._focused=!0,this._map.fire(\"focus\")},_onBlur:function(){this._focused=!1,this._map.fire(\"blur\")},_setPanOffset:function(t){var e,i,n=this._panKeys={},o=this.keyCodes;for(e=0,i=o.left.length;i>e;e++)n[o.left[e]]=[-1*t,0];for(e=0,i=o.right.length;i>e;e++)n[o.right[e]]=[t,0];for(e=0,i=o.down.length;i>e;e++)n[o.down[e]]=[0,t];for(e=0,i=o.up.length;i>e;e++)n[o.up[e]]=[0,-1*t]},_setZoomOffset:function(t){var e,i,n=this._zoomKeys={},o=this.keyCodes;for(e=0,i=o.zoomIn.length;i>e;e++)n[o.zoomIn[e]]=t;for(e=0,i=o.zoomOut.length;i>e;e++)n[o.zoomOut[e]]=-t},_addHooks:function(){o.DomEvent.on(e,\"keydown\",this._onKeyDown,this)},_removeHooks:function(){o.DomEvent.off(e,\"keydown\",this._onKeyDown,this)},_onKeyDown:function(t){var e=t.keyCode,i=this._map;if(e in this._panKeys){if(i._panAnim&&i._panAnim._inProgress)return;i.panBy(this._panKeys[e]),i.options.maxBounds&&i.panInsideBounds(i.options.maxBounds)}else{if(!(e in this._zoomKeys))return;i.setZoom(i.getZoom()+this._zoomKeys[e])}o.DomEvent.stop(t)}}),o.Map.addInitHook(\"addHandler\",\"keyboard\",o.Map.Keyboard),o.Handler.MarkerDrag=o.Handler.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new o.Draggable(t,t)),this._draggable.on(\"dragstart\",this._onDragStart,this).on(\"drag\",this._onDrag,this).on(\"dragend\",this._onDragEnd,this),this._draggable.enable(),o.DomUtil.addClass(this._marker._icon,\"leaflet-marker-draggable\")},removeHooks:function(){this._draggable.off(\"dragstart\",this._onDragStart,this).off(\"drag\",this._onDrag,this).off(\"dragend\",this._onDragEnd,this),this._draggable.disable(),o.DomUtil.removeClass(this._marker._icon,\"leaflet-marker-draggable\")},moved:function(){return this._draggable&&this._draggable._moved},_onDragStart:function(){this._marker.closePopup().fire(\"movestart\").fire(\"dragstart\")},_onDrag:function(){var t=this._marker,e=t._shadow,i=o.DomUtil.getPosition(t._icon),n=t._map.layerPointToLatLng(i);e&&o.DomUtil.setPosition(e,i),t._latlng=n,t.fire(\"move\",{latlng:n}).fire(\"drag\")},_onDragEnd:function(t){this._marker.fire(\"moveend\").fire(\"dragend\",t)}}),o.Control=o.Class.extend({options:{position:\"topright\"},initialize:function(t){o.setOptions(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var e=this._map;return e&&e.removeControl(this),this.options.position=t,e&&e.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this._map=t;var e=this._container=this.onAdd(t),i=this.getPosition(),n=t._controlCorners[i];return o.DomUtil.addClass(e,\"leaflet-control\"),-1!==i.indexOf(\"bottom\")?n.insertBefore(e,n.firstChild):n.appendChild(e),this},removeFrom:function(t){var e=this.getPosition(),i=t._controlCorners[e];return i.removeChild(this._container),this._map=null,this.onRemove&&this.onRemove(t),this},_refocusOnMap:function(){this._map&&this._map.getContainer().focus()}}),o.control=function(t){return new o.Control(t)},o.Map.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.removeFrom(this),this},_initControlPos:function(){function t(t,s){var a=i+t+\" \"+i+s;e[t+s]=o.DomUtil.create(\"div\",a,n)}var e=this._controlCorners={},i=\"leaflet-\",n=this._controlContainer=o.DomUtil.create(\"div\",i+\"control-container\",this._container);t(\"top\",\"left\"),t(\"top\",\"right\"),t(\"bottom\",\"left\"),t(\"bottom\",\"right\")},_clearControlPos:function(){this._container.removeChild(this._controlContainer)}}),o.Control.Zoom=o.Control.extend({options:{position:\"topleft\",zoomInText:\"+\",zoomInTitle:\"Zoom in\",zoomOutText:\"-\",zoomOutTitle:\"Zoom out\"},onAdd:function(t){var e=\"leaflet-control-zoom\",i=o.DomUtil.create(\"div\",e+\" leaflet-bar\");return this._map=t,this._zoomInButton=this._createButton(this.options.zoomInText,this.options.zoomInTitle,e+\"-in\",i,this._zoomIn,this),this._zoomOutButton=this._createButton(this.options.zoomOutText,this.options.zoomOutTitle,e+\"-out\",i,this._zoomOut,this),this._updateDisabled(),t.on(\"zoomend zoomlevelschange\",this._updateDisabled,this),i},onRemove:function(t){t.off(\"zoomend zoomlevelschange\",this._updateDisabled,this)},_zoomIn:function(t){this._map.zoomIn(t.shiftKey?3:1)},_zoomOut:function(t){this._map.zoomOut(t.shiftKey?3:1)},_createButton:function(t,e,i,n,s,a){var r=o.DomUtil.create(\"a\",i,n);r.innerHTML=t,r.href=\"#\",r.title=e;var h=o.DomEvent.stopPropagation;return o.DomEvent.on(r,\"click\",h).on(r,\"mousedown\",h).on(r,\"dblclick\",h).on(r,\"click\",o.DomEvent.preventDefault).on(r,\"click\",s,a).on(r,\"click\",this._refocusOnMap,a),r},_updateDisabled:function(){var t=this._map,e=\"leaflet-disabled\";o.DomUtil.removeClass(this._zoomInButton,e),o.DomUtil.removeClass(this._zoomOutButton,e),t._zoom===t.getMinZoom()&&o.DomUtil.addClass(this._zoomOutButton,e),t._zoom===t.getMaxZoom()&&o.DomUtil.addClass(this._zoomInButton,e)}}),o.Map.mergeOptions({zoomControl:!0}),o.Map.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new o.Control.Zoom,this.addControl(this.zoomControl))}),o.control.zoom=function(t){return new o.Control.Zoom(t)},o.Control.Attribution=o.Control.extend({options:{position:\"bottomright\",prefix:'<a href=\"http://leafletjs.com\" title=\"A JS library for interactive maps\">Leaflet</a>'},initialize:function(t){o.setOptions(this,t),this._attributions={}},onAdd:function(t){this._container=o.DomUtil.create(\"div\",\"leaflet-control-attribution\"),o.DomEvent.disableClickPropagation(this._container);for(var e in t._layers)t._layers[e].getAttribution&&this.addAttribution(t._layers[e].getAttribution());return t.on(\"layeradd\",this._onLayerAdd,this).on(\"layerremove\",this._onLayerRemove,this),this._update(),this._container},onRemove:function(t){t.off(\"layeradd\",this._onLayerAdd).off(\"layerremove\",this._onLayerRemove)},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t?(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update(),this):void 0},removeAttribution:function(t){return t?(this._attributions[t]&&(this._attributions[t]--,this._update()),this):void 0},_update:function(){if(this._map){var t=[];for(var e in this._attributions)this._attributions[e]&&t.push(e);var i=[];this.options.prefix&&i.push(this.options.prefix),t.length&&i.push(t.join(\", \")),this._container.innerHTML=i.join(\" | \")}},_onLayerAdd:function(t){t.layer.getAttribution&&this.addAttribution(t.layer.getAttribution())},_onLayerRemove:function(t){t.layer.getAttribution&&this.removeAttribution(t.layer.getAttribution())}}),o.Map.mergeOptions({attributionControl:!0}),o.Map.addInitHook(function(){this.options.attributionControl&&(this.attributionControl=(new o.Control.Attribution).addTo(this))}),o.control.attribution=function(t){return new o.Control.Attribution(t)},o.Control.Scale=o.Control.extend({options:{position:\"bottomleft\",maxWidth:100,metric:!0,imperial:!0,updateWhenIdle:!1},onAdd:function(t){this._map=t;var e=\"leaflet-control-scale\",i=o.DomUtil.create(\"div\",e),n=this.options;return this._addScales(n,e,i),t.on(n.updateWhenIdle?\"moveend\":\"move\",this._update,this),t.whenReady(this._update,this),i},onRemove:function(t){t.off(this.options.updateWhenIdle?\"moveend\":\"move\",this._update,this)},_addScales:function(t,e,i){t.metric&&(this._mScale=o.DomUtil.create(\"div\",e+\"-line\",i)),t.imperial&&(this._iScale=o.DomUtil.create(\"div\",e+\"-line\",i))},_update:function(){var t=this._map.getBounds(),e=t.getCenter().lat,i=6378137*Math.PI*Math.cos(e*Math.PI/180),n=i*(t.getNorthEast().lng-t.getSouthWest().lng)/180,o=this._map.getSize(),s=this.options,a=0;o.x>0&&(a=n*(s.maxWidth/o.x)),this._updateScales(s,a)},_updateScales:function(t,e){t.metric&&e&&this._updateMetric(e),t.imperial&&e&&this._updateImperial(e)},_updateMetric:function(t){var e=this._getRoundNum(t);this._mScale.style.width=this._getScaleWidth(e/t)+\"px\",this._mScale.innerHTML=1e3>e?e+\" m\":e/1e3+\" km\"},_updateImperial:function(t){var e,i,n,o=3.2808399*t,s=this._iScale;o>5280?(e=o/5280,i=this._getRoundNum(e),s.style.width=this._getScaleWidth(i/e)+\"px\",s.innerHTML=i+\" mi\"):(n=this._getRoundNum(o),s.style.width=this._getScaleWidth(n/o)+\"px\",s.innerHTML=n+\" ft\")},_getScaleWidth:function(t){return Math.round(this.options.maxWidth*t)-10},_getRoundNum:function(t){var e=Math.pow(10,(Math.floor(t)+\"\").length-1),i=t/e;return i=i>=10?10:i>=5?5:i>=3?3:i>=2?2:1,e*i}}),o.control.scale=function(t){return new o.Control.Scale(t)},o.Control.Layers=o.Control.extend({options:{collapsed:!0,position:\"topright\",autoZIndex:!0},initialize:function(t,e,i){o.setOptions(this,i),this._layers={},this._lastZIndex=0,this._handlingClick=!1;for(var n in t)this._addLayer(t[n],n);for(n in e)this._addLayer(e[n],n,!0)},onAdd:function(t){return this._initLayout(),this._update(),t.on(\"layeradd\",this._onLayerChange,this).on(\"layerremove\",this._onLayerChange,this),this._container},onRemove:function(t){t.off(\"layeradd\",this._onLayerChange,this).off(\"layerremove\",this._onLayerChange,this)},addBaseLayer:function(t,e){return this._addLayer(t,e),this._update(),this},addOverlay:function(t,e){return this._addLayer(t,e,!0),this._update(),this},removeLayer:function(t){var e=o.stamp(t);return delete this._layers[e],this._update(),this},_initLayout:function(){var t=\"leaflet-control-layers\",e=this._container=o.DomUtil.create(\"div\",t);e.setAttribute(\"aria-haspopup\",!0),o.Browser.touch?o.DomEvent.on(e,\"click\",o.DomEvent.stopPropagation):o.DomEvent.disableClickPropagation(e).disableScrollPropagation(e);var i=this._form=o.DomUtil.create(\"form\",t+\"-list\");if(this.options.collapsed){o.Browser.android||o.DomEvent.on(e,\"mouseover\",this._expand,this).on(e,\"mouseout\",this._collapse,this);var n=this._layersLink=o.DomUtil.create(\"a\",t+\"-toggle\",e);n.href=\"#\",n.title=\"Layers\",o.Browser.touch?o.DomEvent.on(n,\"click\",o.DomEvent.stop).on(n,\"click\",this._expand,this):o.DomEvent.on(n,\"focus\",this._expand,this),o.DomEvent.on(i,\"click\",function(){setTimeout(o.bind(this._onInputClick,this),0)},this),this._map.on(\"click\",this._collapse,this)}else this._expand();this._baseLayersList=o.DomUtil.create(\"div\",t+\"-base\",i),this._separator=o.DomUtil.create(\"div\",t+\"-separator\",i),this._overlaysList=o.DomUtil.create(\"div\",t+\"-overlays\",i),e.appendChild(i)},_addLayer:function(t,e,i){var n=o.stamp(t);this._layers[n]={layer:t,name:e,overlay:i},this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex))},_update:function(){if(this._container){this._baseLayersList.innerHTML=\"\",this._overlaysList.innerHTML=\"\";var t,e,i=!1,n=!1;for(t in this._layers)e=this._layers[t],this._addItem(e),n=n||e.overlay,i=i||!e.overlay;this._separator.style.display=n&&i?\"\":\"none\"}},_onLayerChange:function(t){var e=this._layers[o.stamp(t.layer)];if(e){this._handlingClick||this._update();var i=e.overlay?\"layeradd\"===t.type?\"overlayadd\":\"overlayremove\":\"layeradd\"===t.type?\"baselayerchange\":null;i&&this._map.fire(i,e)}},_createRadioElement:function(t,i){var n='<input type=\"radio\" class=\"leaflet-control-layers-selector\" name=\"'+t+'\"';i&&(n+=' checked=\"checked\"'),n+=\"/>\";var o=e.createElement(\"div\");return o.innerHTML=n,o.firstChild},_addItem:function(t){var i,n=e.createElement(\"label\"),s=this._map.hasLayer(t.layer);t.overlay?(i=e.createElement(\"input\"),i.type=\"checkbox\",i.className=\"leaflet-control-layers-selector\",i.defaultChecked=s):i=this._createRadioElement(\"leaflet-base-layers\",s),i.layerId=o.stamp(t.layer),o.DomEvent.on(i,\"click\",this._onInputClick,this);var a=e.createElement(\"span\");a.innerHTML=\" \"+t.name,n.appendChild(i),n.appendChild(a);var r=t.overlay?this._overlaysList:this._baseLayersList;return r.appendChild(n),n},_onInputClick:function(){var t,e,i,n=this._form.getElementsByTagName(\"input\"),o=n.length;for(this._handlingClick=!0,t=0;o>t;t++)e=n[t],i=this._layers[e.layerId],e.checked&&!this._map.hasLayer(i.layer)?this._map.addLayer(i.layer):!e.checked&&this._map.hasLayer(i.layer)&&this._map.removeLayer(i.layer);this._handlingClick=!1,this._refocusOnMap()},_expand:function(){o.DomUtil.addClass(this._container,\"leaflet-control-layers-expanded\")},_collapse:function(){this._container.className=this._container.className.replace(\" leaflet-control-layers-expanded\",\"\")}}),o.control.layers=function(t,e,i){return new o.Control.Layers(t,e,i)},o.PosAnimation=o.Class.extend({includes:o.Mixin.Events,run:function(t,e,i,n){this.stop(),this._el=t,this._inProgress=!0,this._newPos=e,this.fire(\"start\"),t.style[o.DomUtil.TRANSITION]=\"all \"+(i||.25)+\"s cubic-bezier(0,0,\"+(n||.5)+\",1)\",o.DomEvent.on(t,o.DomUtil.TRANSITION_END,this._onTransitionEnd,this),o.DomUtil.setPosition(t,e),o.Util.falseFn(t.offsetWidth),this._stepTimer=setInterval(o.bind(this._onStep,this),50)},stop:function(){this._inProgress&&(o.DomUtil.setPosition(this._el,this._getPos()),this._onTransitionEnd(),o.Util.falseFn(this._el.offsetWidth))},_onStep:function(){var t=this._getPos();return t?(this._el._leaflet_pos=t,void this.fire(\"step\")):void this._onTransitionEnd()},_transformRe:/([-+]?(?:\\d*\\.)?\\d+)\\D*, ([-+]?(?:\\d*\\.)?\\d+)\\D*\\)/,_getPos:function(){var e,i,n,s=this._el,a=t.getComputedStyle(s);if(o.Browser.any3d){if(n=a[o.DomUtil.TRANSFORM].match(this._transformRe),!n)return;e=parseFloat(n[1]),i=parseFloat(n[2])}else e=parseFloat(a.left),i=parseFloat(a.top);return new o.Point(e,i,!0)},_onTransitionEnd:function(){o.DomEvent.off(this._el,o.DomUtil.TRANSITION_END,this._onTransitionEnd,this),this._inProgress&&(this._inProgress=!1,this._el.style[o.DomUtil.TRANSITION]=\"\",this._el._leaflet_pos=this._newPos,clearInterval(this._stepTimer),this.fire(\"step\").fire(\"end\"))}}),o.Map.include({setView:function(t,e,n){if(e=e===i?this._zoom:this._limitZoom(e),t=this._limitCenter(o.latLng(t),e,this.options.maxBounds),n=n||{},this._panAnim&&this._panAnim.stop(),this._loaded&&!n.reset&&n!==!0){n.animate!==i&&(n.zoom=o.extend({animate:n.animate},n.zoom),n.pan=o.extend({animate:n.animate},n.pan));var s=this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,n.zoom):this._tryAnimatedPan(t,n.pan);if(s)return clearTimeout(this._sizeTimer),this}return this._resetView(t,e),this},panBy:function(t,e){if(t=o.point(t).round(),e=e||{},!t.x&&!t.y)return this;if(this._panAnim||(this._panAnim=new o.PosAnimation,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),e.noMoveStart||this.fire(\"movestart\"),e.animate!==!1){o.DomUtil.addClass(this._mapPane,\"leaflet-pan-anim\");var i=this._getMapPanePos().subtract(t);this._panAnim.run(this._mapPane,i,e.duration||.25,e.easeLinearity)}else this._rawPanBy(t),this.fire(\"move\").fire(\"moveend\");return this},_onPanTransitionStep:function(){this.fire(\"move\")},_onPanTransitionEnd:function(){o.DomUtil.removeClass(this._mapPane,\"leaflet-pan-anim\"),this.fire(\"moveend\")},_tryAnimatedPan:function(t,e){var i=this._getCenterOffset(t)._floor();return(e&&e.animate)===!0||this.getSize().contains(i)?(this.panBy(i,e),!0):!1}}),o.PosAnimation=o.DomUtil.TRANSITION?o.PosAnimation:o.PosAnimation.extend({run:function(t,e,i,n){this.stop(),this._el=t,this._inProgress=!0,this._duration=i||.25,this._easeOutPower=1/Math.max(n||.5,.2),this._startPos=o.DomUtil.getPosition(t),this._offset=e.subtract(this._startPos),this._startTime=+new Date,this.fire(\"start\"),this._animate()},stop:function(){this._inProgress&&(this._step(),this._complete())},_animate:function(){this._animId=o.Util.requestAnimFrame(this._animate,this),this._step()},_step:function(){var t=+new Date-this._startTime,e=1e3*this._duration;e>t?this._runFrame(this._easeOut(t/e)):(this._runFrame(1),this._complete())},_runFrame:function(t){var e=this._startPos.add(this._offset.multiplyBy(t));o.DomUtil.setPosition(this._el,e),this.fire(\"step\")},_complete:function(){o.Util.cancelAnimFrame(this._animId),this._inProgress=!1,this.fire(\"end\")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),o.Map.mergeOptions({zoomAnimation:!0,zoomAnimationThreshold:4}),o.DomUtil.TRANSITION&&o.Map.addInitHook(function(){this._zoomAnimated=this.options.zoomAnimation&&o.DomUtil.TRANSITION&&o.Browser.any3d&&!o.Browser.android23&&!o.Browser.mobileOpera,this._zoomAnimated&&o.DomEvent.on(this._mapPane,o.DomUtil.TRANSITION_END,this._catchTransitionEnd,this)}),o.Map.include(o.DomUtil.TRANSITION?{_catchTransitionEnd:function(t){this._animatingZoom&&t.propertyName.indexOf(\"transform\")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName(\"leaflet-zoom-animated\").length},_tryAnimatedZoom:function(t,e,i){if(this._animatingZoom)return!0;if(i=i||{},!this._zoomAnimated||i.animate===!1||this._nothingToAnimate()||Math.abs(e-this._zoom)>this.options.zoomAnimationThreshold)return!1;var n=this.getZoomScale(e),o=this._getCenterOffset(t)._divideBy(1-1/n),s=this._getCenterLayerPoint()._add(o);return i.animate===!0||this.getSize().contains(o)?(this.fire(\"movestart\").fire(\"zoomstart\"),this._animateZoom(t,e,s,n,null,!0),!0):!1},_animateZoom:function(t,e,i,n,s,a,r){r||(this._animatingZoom=!0),o.DomUtil.addClass(this._mapPane,\"leaflet-zoom-anim\"),this._animateToCenter=t,this._animateToZoom=e,o.Draggable&&(o.Draggable._disabled=!0),o.Util.requestAnimFrame(function(){this.fire(\"zoomanim\",{center:t,zoom:e,origin:i,scale:n,delta:s,backwards:a}),setTimeout(o.bind(this._onZoomTransitionEnd,this),250)},this)},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._animatingZoom=!1,o.DomUtil.removeClass(this._mapPane,\"leaflet-zoom-anim\"),o.Util.requestAnimFrame(function(){this._resetView(this._animateToCenter,this._animateToZoom,!0,!0),o.Draggable&&(o.Draggable._disabled=!1)},this))}}:{}),o.TileLayer.include({_animateZoom:function(t){this._animating||(this._animating=!0,this._prepareBgBuffer());var e=this._bgBuffer,i=o.DomUtil.TRANSFORM,n=t.delta?o.DomUtil.getTranslateString(t.delta):e.style[i],s=o.DomUtil.getScaleString(t.scale,t.origin);e.style[i]=t.backwards?s+\" \"+n:n+\" \"+s},_endZoomAnim:function(){var t=this._tileContainer,e=this._bgBuffer;t.style.visibility=\"\",t.parentNode.appendChild(t),o.Util.falseFn(e.offsetWidth);var i=this._map.getZoom();(i>this.options.maxZoom||i<this.options.minZoom)&&this._clearBgBuffer(),this._animating=!1},_clearBgBuffer:function(){var t=this._map;!t||t._animatingZoom||t.touchZoom._zooming||(this._bgBuffer.innerHTML=\"\",this._bgBuffer.style[o.DomUtil.TRANSFORM]=\"\")},_prepareBgBuffer:function(){var t=this._tileContainer,e=this._bgBuffer,i=this._getLoadedTilesPercentage(e),n=this._getLoadedTilesPercentage(t);return e&&i>.5&&.5>n?(t.style.visibility=\"hidden\",void this._stopLoadingImages(t)):(e.style.visibility=\"hidden\",e.style[o.DomUtil.TRANSFORM]=\"\",this._tileContainer=e,e=this._bgBuffer=t,this._stopLoadingImages(e),void clearTimeout(this._clearBgBufferTimer))},_getLoadedTilesPercentage:function(t){var e,i,n=t.getElementsByTagName(\"img\"),o=0;for(e=0,i=n.length;i>e;e++)n[e].complete&&o++;return o/i},_stopLoadingImages:function(t){var e,i,n,s=Array.prototype.slice.call(t.getElementsByTagName(\"img\"));for(e=0,i=s.length;i>e;e++)n=s[e],n.complete||(n.onload=o.Util.falseFn,n.onerror=o.Util.falseFn,n.src=o.Util.emptyImageUrl,n.parentNode.removeChild(n))}}),o.Map.include({_defaultLocateOptions:{watch:!1,setView:!1,maxZoom:1/0,timeout:1e4,maximumAge:0,enableHighAccuracy:!1},locate:function(t){if(t=this._locateOptions=o.extend(this._defaultLocateOptions,t),!navigator.geolocation)return this._handleGeolocationError({code:0,message:\"Geolocation not supported.\"}),this;var e=o.bind(this._handleGeolocationResponse,this),i=o.bind(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(e,i,t):navigator.geolocation.getCurrentPosition(e,i,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var e=t.code,i=t.message||(1===e?\"permission denied\":2===e?\"position unavailable\":\"timeout\");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire(\"locationerror\",{code:e,message:\"Geolocation error: \"+i+\".\"})},_handleGeolocationResponse:function(t){var e=t.coords.latitude,i=t.coords.longitude,n=new o.LatLng(e,i),s=180*t.coords.accuracy/40075017,a=s/Math.cos(o.LatLng.DEG_TO_RAD*e),r=o.latLngBounds([e-s,i-a],[e+s,i+a]),h=this._locateOptions;if(h.setView){var l=Math.min(this.getBoundsZoom(r),h.maxZoom);this.setView(n,l)}var u={latlng:n,bounds:r,timestamp:t.timestamp};for(var c in t.coords)\"number\"==typeof t.coords[c]&&(u[c]=t.coords[c]);this.fire(\"locationfound\",u)}})}(window,document);\n},{}],4:[function(require,module,exports){\n!function(e,t){\"object\"==typeof exports&&exports&&\"string\"!=typeof exports.nodeName?t(exports):\"function\"==typeof define&&define.amd?define([\"exports\"],t):(e.Mustache={},t(e.Mustache))}(this,function(e){function t(e){return\"function\"==typeof e}function n(e){return g(e)?\"array\":typeof e}function r(e){return e.replace(/[\\-\\[\\]{}()*+?.,\\\\\\^$|#\\s]/g,\"\\\\$&\")}function i(e,t){return null!=e&&\"object\"==typeof e&&t in e}function o(e,t){return v.call(e,t)}function s(e){return!o(w,e)}function a(e){return String(e).replace(/[&<>\"'`=\\/]/g,function(e){return y[e]})}function u(t,n){function i(){if(w&&!y)for(;v.length;)delete d[v.pop()];else v=[];w=!1,y=!1}function o(e){if(\"string\"==typeof e&&(e=e.split(k,2)),!g(e)||2!==e.length)throw new Error(\"Invalid tags: \"+e);a=new RegExp(r(e[0])+\"\\\\s*\"),u=new RegExp(\"\\\\s*\"+r(e[1])),h=new RegExp(\"\\\\s*\"+r(\"}\"+e[1]))}if(!t)return[];var a,u,h,f=[],d=[],v=[],w=!1,y=!1;o(n||e.tags);for(var U,T,j,S,V,C,A=new l(t);!A.eos();){if(U=A.pos,j=A.scanUntil(a))for(var I=0,R=j.length;R>I;++I)S=j.charAt(I),s(S)?v.push(d.length):y=!0,d.push([\"text\",S,U,U+1]),U+=1,\"\\n\"===S&&i();if(!A.scan(a))break;if(w=!0,T=A.scan(E)||\"name\",A.scan(x),\"=\"===T?(j=A.scanUntil(b),A.scan(b),A.scanUntil(u)):\"{\"===T?(j=A.scanUntil(h),A.scan(m),A.scanUntil(u),T=\"&\"):j=A.scanUntil(u),!A.scan(u))throw new Error(\"Unclosed tag at \"+A.pos);if(V=[T,j,U,A.pos],d.push(V),\"#\"===T||\"^\"===T)f.push(V);else if(\"/\"===T){if(C=f.pop(),!C)throw new Error('Unopened section \"'+j+'\" at '+U);if(C[1]!==j)throw new Error('Unclosed section \"'+C[1]+'\" at '+U)}else\"name\"===T||\"{\"===T||\"&\"===T?y=!0:\"=\"===T&&o(j)}if(C=f.pop())throw new Error('Unclosed section \"'+C[1]+'\" at '+A.pos);return p(c(d))}function c(e){for(var t,n,r=[],i=0,o=e.length;o>i;++i)t=e[i],t&&(\"text\"===t[0]&&n&&\"text\"===n[0]?(n[1]+=t[1],n[3]=t[3]):(r.push(t),n=t));return r}function p(e){for(var t,n,r=[],i=r,o=[],s=0,a=e.length;a>s;++s)switch(t=e[s],t[0]){case\"#\":case\"^\":i.push(t),o.push(t),i=t[4]=[];break;case\"/\":n=o.pop(),n[5]=t[2],i=o.length>0?o[o.length-1][4]:r;break;default:i.push(t)}return r}function l(e){this.string=e,this.tail=e,this.pos=0}function h(e,t){this.view=e,this.cache={\".\":this.view},this.parent=t}function f(){this.cache={}}var d=Object.prototype.toString,g=Array.isArray||function(e){return\"[object Array]\"===d.call(e)},v=RegExp.prototype.test,w=/\\S/,y={\"&\":\"&amp;\",\"<\":\"&lt;\",\">\":\"&gt;\",'\"':\"&quot;\",\"'\":\"&#39;\",\"/\":\"&#x2F;\",\"`\":\"&#x60;\",\"=\":\"&#x3D;\"},x=/\\s*/,k=/\\s+/,b=/\\s*=/,m=/\\s*\\}/,E=/#|\\^|\\/|>|\\{|&|=|!/;l.prototype.eos=function(){return\"\"===this.tail},l.prototype.scan=function(e){var t=this.tail.match(e);if(!t||0!==t.index)return\"\";var n=t[0];return this.tail=this.tail.substring(n.length),this.pos+=n.length,n},l.prototype.scanUntil=function(e){var t,n=this.tail.search(e);switch(n){case-1:t=this.tail,this.tail=\"\";break;case 0:t=\"\";break;default:t=this.tail.substring(0,n),this.tail=this.tail.substring(n)}return this.pos+=t.length,t},h.prototype.push=function(e){return new h(e,this)},h.prototype.lookup=function(e){var n,r=this.cache;if(r.hasOwnProperty(e))n=r[e];else{for(var o,s,a=this,u=!1;a;){if(e.indexOf(\".\")>0)for(n=a.view,o=e.split(\".\"),s=0;null!=n&&s<o.length;)s===o.length-1&&(u=i(n,o[s])),n=n[o[s++]];else n=a.view[e],u=i(a.view,e);if(u)break;a=a.parent}r[e]=n}return t(n)&&(n=n.call(this.view)),n},f.prototype.clearCache=function(){this.cache={}},f.prototype.parse=function(e,t){var n=this.cache,r=n[e];return null==r&&(r=n[e]=u(e,t)),r},f.prototype.render=function(e,t,n){var r=this.parse(e),i=t instanceof h?t:new h(t);return this.renderTokens(r,i,n,e)},f.prototype.renderTokens=function(e,t,n,r){for(var i,o,s,a=\"\",u=0,c=e.length;c>u;++u)s=void 0,i=e[u],o=i[0],\"#\"===o?s=this.renderSection(i,t,n,r):\"^\"===o?s=this.renderInverted(i,t,n,r):\">\"===o?s=this.renderPartial(i,t,n,r):\"&\"===o?s=this.unescapedValue(i,t):\"name\"===o?s=this.escapedValue(i,t):\"text\"===o&&(s=this.rawValue(i)),void 0!==s&&(a+=s);return a},f.prototype.renderSection=function(e,n,r,i){function o(e){return s.render(e,n,r)}var s=this,a=\"\",u=n.lookup(e[1]);if(u){if(g(u))for(var c=0,p=u.length;p>c;++c)a+=this.renderTokens(e[4],n.push(u[c]),r,i);else if(\"object\"==typeof u||\"string\"==typeof u||\"number\"==typeof u)a+=this.renderTokens(e[4],n.push(u),r,i);else if(t(u)){if(\"string\"!=typeof i)throw new Error(\"Cannot use higher-order sections without the original template\");u=u.call(n.view,i.slice(e[3],e[5]),o),null!=u&&(a+=u)}else a+=this.renderTokens(e[4],n,r,i);return a}},f.prototype.renderInverted=function(e,t,n,r){var i=t.lookup(e[1]);return!i||g(i)&&0===i.length?this.renderTokens(e[4],t,n,r):void 0},f.prototype.renderPartial=function(e,n,r){if(r){var i=t(r)?r(e[1]):r[e[1]];return null!=i?this.renderTokens(this.parse(i),n,r,i):void 0}},f.prototype.unescapedValue=function(e,t){var n=t.lookup(e[1]);return null!=n?n:void 0},f.prototype.escapedValue=function(t,n){var r=n.lookup(t[1]);return null!=r?e.escape(r):void 0},f.prototype.rawValue=function(e){return e[1]},e.name=\"mustache.js\",e.version=\"2.2.1\",e.tags=[\"{{\",\"}}\"];var U=new f;e.clearCache=function(){return U.clearCache()},e.parse=function(e,t){return U.parse(e,t)},e.render=function(e,t,r){if(\"string\"!=typeof e)throw new TypeError('Invalid template! Template should be a \"string\" but \"'+n(e)+'\" was given as the first argument for mustache#render(template, view, partials)');return U.render(e,t,r)},e.to_html=function(n,r,i,o){var s=e.render(n,r,i);return t(o)?void o(s):s},e.escape=a,e.Scanner=l,e.Context=h,e.Writer=f});\n},{}],5:[function(require,module,exports){\nfunction cleanUrl(t){\"use strict\";return/^https?/.test(t.getScheme())?t.toString():/^mailto?/.test(t.getScheme())?t.toString():\"data\"==t.getScheme()&&/^image/.test(t.getPath())?t.toString():void 0}function cleanId(t){return t}var html_sanitize=require(\"./sanitizer-bundle.js\");module.exports=function(t){return t?html_sanitize(t,cleanUrl,cleanId):\"\"};\n},{\"./sanitizer-bundle.js\":6}],6:[function(require,module,exports){\nvar URI=function(){function e(e){var t=(\"\"+e).match(p);return t?new s(c(t[1]),c(t[2]),c(t[3]),c(t[4]),c(t[5]),c(t[6]),c(t[7])):null}function t(e,t,o,i,l,c,m){var u=new s(n(e,d),n(t,d),a(o),i>0?i.toString():null,n(l,f),null,a(m));return c&&(\"string\"==typeof c?u.setRawQuery(c.replace(/[^?&=0-9A-Za-z_\\-~.%]/g,r)):u.setAllParameters(c)),u}function a(e){return\"string\"==typeof e?encodeURIComponent(e):null}function n(e,t){return\"string\"==typeof e?encodeURI(e).replace(t,r):null}function r(e){var t=e.charCodeAt(0);return\"%\"+\"0123456789ABCDEF\".charAt(t>>4&15)+\"0123456789ABCDEF\".charAt(15&t)}function o(e){return e.replace(/(^|\\/)\\.(?:\\/|$)/g,\"$1\").replace(/\\/{2,}/g,\"/\")}function i(e){if(null===e)return null;for(var t,a=o(e),n=u;(t=a.replace(n,\"$1\"))!=a;a=t);return a}function l(e,t){var a=e.clone(),n=t.hasScheme();n?a.setRawScheme(t.getRawScheme()):n=t.hasCredentials(),n?a.setRawCredentials(t.getRawCredentials()):n=t.hasDomain(),n?a.setRawDomain(t.getRawDomain()):n=t.hasPort();var r=t.getRawPath(),o=i(r);if(n)a.setPort(t.getPort()),o=o&&o.replace(h,\"\");else if(n=!!r){if(47!==o.charCodeAt(0)){var l=i(a.getRawPath()||\"\").replace(h,\"\"),s=l.lastIndexOf(\"/\")+1;o=i((s?l.substring(0,s):\"\")+i(r)).replace(h,\"\")}}else o=o&&o.replace(h,\"\"),o!==r&&a.setRawPath(o);return n?a.setRawPath(o):n=t.hasQuery(),n?a.setRawQuery(t.getRawQuery()):n=t.hasFragment(),n&&a.setRawFragment(t.getRawFragment()),a}function s(e,t,a,n,r,o,i){this.scheme_=e,this.credentials_=t,this.domain_=a,this.port_=n,this.path_=r,this.query_=o,this.fragment_=i,this.paramCache_=null}function c(e){return\"string\"==typeof e&&e.length>0?e:null}var m=new RegExp(\"(/|^)(?:[^./][^/]*|\\\\.{2,}(?:[^./][^/]*)|\\\\.{3,}[^/]*)/\\\\.\\\\.(?:/|$)\"),u=new RegExp(m),h=/^(?:\\.\\.\\/)*(?:\\.\\.$)?/;s.prototype.toString=function(){var e=[];return null!==this.scheme_&&e.push(this.scheme_,\":\"),null!==this.domain_&&(e.push(\"//\"),null!==this.credentials_&&e.push(this.credentials_,\"@\"),e.push(this.domain_),null!==this.port_&&e.push(\":\",this.port_.toString())),null!==this.path_&&e.push(this.path_),null!==this.query_&&e.push(\"?\",this.query_),null!==this.fragment_&&e.push(\"#\",this.fragment_),e.join(\"\")},s.prototype.clone=function(){return new s(this.scheme_,this.credentials_,this.domain_,this.port_,this.path_,this.query_,this.fragment_)},s.prototype.getScheme=function(){return this.scheme_&&decodeURIComponent(this.scheme_).toLowerCase()},s.prototype.getRawScheme=function(){return this.scheme_},s.prototype.setScheme=function(e){return this.scheme_=n(e,d),this},s.prototype.setRawScheme=function(e){return this.scheme_=e?e:null,this},s.prototype.hasScheme=function(){return null!==this.scheme_},s.prototype.getCredentials=function(){return this.credentials_&&decodeURIComponent(this.credentials_)},s.prototype.getRawCredentials=function(){return this.credentials_},s.prototype.setCredentials=function(e){return this.credentials_=n(e,d),this},s.prototype.setRawCredentials=function(e){return this.credentials_=e?e:null,this},s.prototype.hasCredentials=function(){return null!==this.credentials_},s.prototype.getDomain=function(){return this.domain_&&decodeURIComponent(this.domain_)},s.prototype.getRawDomain=function(){return this.domain_},s.prototype.setDomain=function(e){return this.setRawDomain(e&&encodeURIComponent(e))},s.prototype.setRawDomain=function(e){return this.domain_=e?e:null,this.setRawPath(this.path_)},s.prototype.hasDomain=function(){return null!==this.domain_},s.prototype.getPort=function(){return this.port_&&decodeURIComponent(this.port_)},s.prototype.setPort=function(e){if(e){if(e=Number(e),e!==(65535&e))throw new Error(\"Bad port number \"+e);this.port_=\"\"+e}else this.port_=null;return this},s.prototype.hasPort=function(){return null!==this.port_},s.prototype.getPath=function(){return this.path_&&decodeURIComponent(this.path_)},s.prototype.getRawPath=function(){return this.path_},s.prototype.setPath=function(e){return this.setRawPath(n(e,f))},s.prototype.setRawPath=function(e){return e?(e=String(e),this.path_=!this.domain_||/^\\//.test(e)?e:\"/\"+e):this.path_=null,this},s.prototype.hasPath=function(){return null!==this.path_},s.prototype.getQuery=function(){return this.query_&&decodeURIComponent(this.query_).replace(/\\+/g,\" \")},s.prototype.getRawQuery=function(){return this.query_},s.prototype.setQuery=function(e){return this.paramCache_=null,this.query_=a(e),this},s.prototype.setRawQuery=function(e){return this.paramCache_=null,this.query_=e?e:null,this},s.prototype.hasQuery=function(){return null!==this.query_},s.prototype.setAllParameters=function(e){if(\"object\"==typeof e&&!(e instanceof Array)&&(e instanceof Object||\"[object Array]\"!==Object.prototype.toString.call(e))){var t=[],a=-1;for(var n in e){var r=e[n];\"string\"==typeof r&&(t[++a]=n,t[++a]=r)}e=t}this.paramCache_=null;for(var o=[],i=\"\",l=0;l<e.length;){var n=e[l++],r=e[l++];o.push(i,encodeURIComponent(n.toString())),i=\"&\",r&&o.push(\"=\",encodeURIComponent(r.toString()))}return this.query_=o.join(\"\"),this},s.prototype.checkParameterCache_=function(){if(!this.paramCache_){var e=this.query_;if(e){for(var t=e.split(/[&\\?]/),a=[],n=-1,r=0;r<t.length;++r){var o=t[r].match(/^([^=]*)(?:=(.*))?$/);a[++n]=decodeURIComponent(o[1]).replace(/\\+/g,\" \"),a[++n]=decodeURIComponent(o[2]||\"\").replace(/\\+/g,\" \")}this.paramCache_=a}else this.paramCache_=[]}},s.prototype.setParameterValues=function(e,t){\"string\"==typeof t&&(t=[t]),this.checkParameterCache_();for(var a=0,n=this.paramCache_,r=[],o=0;o<n.length;o+=2)e===n[o]?a<t.length&&r.push(e,t[a++]):r.push(n[o],n[o+1]);for(;a<t.length;)r.push(e,t[a++]);return this.setAllParameters(r),this},s.prototype.removeParameter=function(e){return this.setParameterValues(e,[])},s.prototype.getAllParameters=function(){return this.checkParameterCache_(),this.paramCache_.slice(0,this.paramCache_.length)},s.prototype.getParameterValues=function(e){this.checkParameterCache_();for(var t=[],a=0;a<this.paramCache_.length;a+=2)e===this.paramCache_[a]&&t.push(this.paramCache_[a+1]);return t},s.prototype.getParameterMap=function(e){this.checkParameterCache_();for(var t={},a=0;a<this.paramCache_.length;a+=2){var n=this.paramCache_[a++],r=this.paramCache_[a++];n in t?t[n].push(r):t[n]=[r]}return t},s.prototype.getParameterValue=function(e){this.checkParameterCache_();for(var t=0;t<this.paramCache_.length;t+=2)if(e===this.paramCache_[t])return this.paramCache_[t+1];return null},s.prototype.getFragment=function(){return this.fragment_&&decodeURIComponent(this.fragment_)},s.prototype.getRawFragment=function(){return this.fragment_},s.prototype.setFragment=function(e){return this.fragment_=e?encodeURIComponent(e):null,this},s.prototype.setRawFragment=function(e){return this.fragment_=e?e:null,this},s.prototype.hasFragment=function(){return null!==this.fragment_};var p=new RegExp(\"^(?:([^:/?#]+):)?(?://(?:([^/?#]*)@)?([^/?#:@]*)(?::([0-9]+))?)?([^?#]+)?(?:\\\\?([^#]*))?(?:#(.*))?$\"),d=/[#\\/\\?@]/g,f=/[\\#\\?]/g;return s.parse=e,s.create=t,s.resolve=l,s.collapse_dots=i,s.utils={mimeTypeOf:function(t){var a=e(t);return/\\.html$/.test(a.getPath())?\"text/html\":\"application/javascript\"},resolve:function(t,a){return t?l(e(t),e(a)).toString():\"\"+a}},s}(),html4={};if(html4.atype={NONE:0,URI:1,URI_FRAGMENT:11,SCRIPT:2,STYLE:3,HTML:12,ID:4,IDREF:5,IDREFS:6,GLOBAL_NAME:7,LOCAL_NAME:8,CLASSES:9,FRAME_TARGET:10,MEDIA_QUERY:13},html4.atype=html4.atype,html4.ATTRIBS={\"*::class\":9,\"*::dir\":0,\"*::draggable\":0,\"*::hidden\":0,\"*::id\":4,\"*::inert\":0,\"*::itemprop\":0,\"*::itemref\":6,\"*::itemscope\":0,\"*::lang\":0,\"*::onblur\":2,\"*::onchange\":2,\"*::onclick\":2,\"*::ondblclick\":2,\"*::onfocus\":2,\"*::onkeydown\":2,\"*::onkeypress\":2,\"*::onkeyup\":2,\"*::onload\":2,\"*::onmousedown\":2,\"*::onmousemove\":2,\"*::onmouseout\":2,\"*::onmouseover\":2,\"*::onmouseup\":2,\"*::onreset\":2,\"*::onscroll\":2,\"*::onselect\":2,\"*::onsubmit\":2,\"*::onunload\":2,\"*::spellcheck\":0,\"*::style\":3,\"*::title\":0,\"*::translate\":0,\"a::accesskey\":0,\"a::coords\":0,\"a::href\":1,\"a::hreflang\":0,\"a::name\":7,\"a::onblur\":2,\"a::onfocus\":2,\"a::shape\":0,\"a::tabindex\":0,\"a::target\":10,\"a::type\":0,\"area::accesskey\":0,\"area::alt\":0,\"area::coords\":0,\"area::href\":1,\"area::nohref\":0,\"area::onblur\":2,\"area::onfocus\":2,\"area::shape\":0,\"area::tabindex\":0,\"area::target\":10,\"audio::controls\":0,\"audio::loop\":0,\"audio::mediagroup\":5,\"audio::muted\":0,\"audio::preload\":0,\"bdo::dir\":0,\"blockquote::cite\":1,\"br::clear\":0,\"button::accesskey\":0,\"button::disabled\":0,\"button::name\":8,\"button::onblur\":2,\"button::onfocus\":2,\"button::tabindex\":0,\"button::type\":0,\"button::value\":0,\"canvas::height\":0,\"canvas::width\":0,\"caption::align\":0,\"col::align\":0,\"col::char\":0,\"col::charoff\":0,\"col::span\":0,\"col::valign\":0,\"col::width\":0,\"colgroup::align\":0,\"colgroup::char\":0,\"colgroup::charoff\":0,\"colgroup::span\":0,\"colgroup::valign\":0,\"colgroup::width\":0,\"command::checked\":0,\"command::command\":5,\"command::disabled\":0,\"command::icon\":1,\"command::label\":0,\"command::radiogroup\":0,\"command::type\":0,\"data::value\":0,\"del::cite\":1,\"del::datetime\":0,\"details::open\":0,\"dir::compact\":0,\"div::align\":0,\"dl::compact\":0,\"fieldset::disabled\":0,\"font::color\":0,\"font::face\":0,\"font::size\":0,\"form::accept\":0,\"form::action\":1,\"form::autocomplete\":0,\"form::enctype\":0,\"form::method\":0,\"form::name\":7,\"form::novalidate\":0,\"form::onreset\":2,\"form::onsubmit\":2,\"form::target\":10,\"h1::align\":0,\"h2::align\":0,\"h3::align\":0,\"h4::align\":0,\"h5::align\":0,\"h6::align\":0,\"hr::align\":0,\"hr::noshade\":0,\"hr::size\":0,\"hr::width\":0,\"iframe::align\":0,\"iframe::frameborder\":0,\"iframe::height\":0,\"iframe::marginheight\":0,\"iframe::marginwidth\":0,\"iframe::width\":0,\"img::align\":0,\"img::alt\":0,\"img::border\":0,\"img::height\":0,\"img::hspace\":0,\"img::ismap\":0,\"img::name\":7,\"img::src\":1,\"img::usemap\":11,\"img::vspace\":0,\"img::width\":0,\"input::accept\":0,\"input::accesskey\":0,\"input::align\":0,\"input::alt\":0,\"input::autocomplete\":0,\"input::checked\":0,\"input::disabled\":0,\"input::inputmode\":0,\"input::ismap\":0,\"input::list\":5,\"input::max\":0,\"input::maxlength\":0,\"input::min\":0,\"input::multiple\":0,\"input::name\":8,\"input::onblur\":2,\"input::onchange\":2,\"input::onfocus\":2,\"input::onselect\":2,\"input::placeholder\":0,\"input::readonly\":0,\"input::required\":0,\"input::size\":0,\"input::src\":1,\"input::step\":0,\"input::tabindex\":0,\"input::type\":0,\"input::usemap\":11,\"input::value\":0,\"ins::cite\":1,\"ins::datetime\":0,\"label::accesskey\":0,\"label::for\":5,\"label::onblur\":2,\"label::onfocus\":2,\"legend::accesskey\":0,\"legend::align\":0,\"li::type\":0,\"li::value\":0,\"map::name\":7,\"menu::compact\":0,\"menu::label\":0,\"menu::type\":0,\"meter::high\":0,\"meter::low\":0,\"meter::max\":0,\"meter::min\":0,\"meter::value\":0,\"ol::compact\":0,\"ol::reversed\":0,\"ol::start\":0,\"ol::type\":0,\"optgroup::disabled\":0,\"optgroup::label\":0,\"option::disabled\":0,\"option::label\":0,\"option::selected\":0,\"option::value\":0,\"output::for\":6,\"output::name\":8,\"p::align\":0,\"pre::width\":0,\"progress::max\":0,\"progress::min\":0,\"progress::value\":0,\"q::cite\":1,\"select::autocomplete\":0,\"select::disabled\":0,\"select::multiple\":0,\"select::name\":8,\"select::onblur\":2,\"select::onchange\":2,\"select::onfocus\":2,\"select::required\":0,\"select::size\":0,\"select::tabindex\":0,\"source::type\":0,\"table::align\":0,\"table::bgcolor\":0,\"table::border\":0,\"table::cellpadding\":0,\"table::cellspacing\":0,\"table::frame\":0,\"table::rules\":0,\"table::summary\":0,\"table::width\":0,\"tbody::align\":0,\"tbody::char\":0,\"tbody::charoff\":0,\"tbody::valign\":0,\"td::abbr\":0,\"td::align\":0,\"td::axis\":0,\"td::bgcolor\":0,\"td::char\":0,\"td::charoff\":0,\"td::colspan\":0,\"td::headers\":6,\"td::height\":0,\"td::nowrap\":0,\"td::rowspan\":0,\"td::scope\":0,\"td::valign\":0,\"td::width\":0,\"textarea::accesskey\":0,\"textarea::autocomplete\":0,\"textarea::cols\":0,\"textarea::disabled\":0,\"textarea::inputmode\":0,\"textarea::name\":8,\"textarea::onblur\":2,\"textarea::onchange\":2,\"textarea::onfocus\":2,\"textarea::onselect\":2,\"textarea::placeholder\":0,\"textarea::readonly\":0,\"textarea::required\":0,\"textarea::rows\":0,\"textarea::tabindex\":0,\"textarea::wrap\":0,\"tfoot::align\":0,\"tfoot::char\":0,\"tfoot::charoff\":0,\"tfoot::valign\":0,\"th::abbr\":0,\"th::align\":0,\"th::axis\":0,\"th::bgcolor\":0,\"th::char\":0,\"th::charoff\":0,\"th::colspan\":0,\"th::headers\":6,\"th::height\":0,\"th::nowrap\":0,\"th::rowspan\":0,\"th::scope\":0,\"th::valign\":0,\"th::width\":0,\"thead::align\":0,\"thead::char\":0,\"thead::charoff\":0,\"thead::valign\":0,\"tr::align\":0,\"tr::bgcolor\":0,\"tr::char\":0,\"tr::charoff\":0,\"tr::valign\":0,\"track::default\":0,\"track::kind\":0,\"track::label\":0,\"track::srclang\":0,\"ul::compact\":0,\"ul::type\":0,\"video::controls\":0,\"video::height\":0,\"video::loop\":0,\"video::mediagroup\":5,\"video::muted\":0,\"video::poster\":1,\"video::preload\":0,\"video::width\":0},html4.ATTRIBS=html4.ATTRIBS,html4.eflags={OPTIONAL_ENDTAG:1,EMPTY:2,CDATA:4,RCDATA:8,UNSAFE:16,FOLDABLE:32,SCRIPT:64,STYLE:128,VIRTUALIZED:256},html4.eflags=html4.eflags,html4.ELEMENTS={a:0,abbr:0,acronym:0,address:0,applet:272,area:2,article:0,aside:0,audio:0,b:0,base:274,basefont:274,bdi:0,bdo:0,big:0,blockquote:0,body:305,br:2,button:0,canvas:0,caption:0,center:0,cite:0,code:0,col:2,colgroup:1,command:2,data:0,datalist:0,dd:1,del:0,details:0,dfn:0,dialog:272,dir:0,div:0,dl:0,dt:1,em:0,fieldset:0,figcaption:0,figure:0,font:0,footer:0,form:0,frame:274,frameset:272,h1:0,h2:0,h3:0,h4:0,h5:0,h6:0,head:305,header:0,hgroup:0,hr:2,html:305,i:0,iframe:16,img:2,input:2,ins:0,isindex:274,kbd:0,keygen:274,label:0,legend:0,li:1,link:274,map:0,mark:0,menu:0,meta:274,meter:0,nav:0,nobr:0,noembed:276,noframes:276,noscript:276,object:272,ol:0,optgroup:0,option:1,output:0,p:1,param:274,pre:0,progress:0,q:0,s:0,samp:0,script:84,section:0,select:0,small:0,source:2,span:0,strike:0,strong:0,style:148,sub:0,summary:0,sup:0,table:0,tbody:1,td:1,textarea:8,tfoot:1,th:1,thead:1,time:0,title:280,tr:1,track:2,tt:0,u:0,ul:0,\"var\":0,video:0,wbr:2},html4.ELEMENTS=html4.ELEMENTS,html4.ELEMENT_DOM_INTERFACES={a:\"HTMLAnchorElement\",abbr:\"HTMLElement\",acronym:\"HTMLElement\",address:\"HTMLElement\",applet:\"HTMLAppletElement\",area:\"HTMLAreaElement\",article:\"HTMLElement\",aside:\"HTMLElement\",audio:\"HTMLAudioElement\",b:\"HTMLElement\",base:\"HTMLBaseElement\",basefont:\"HTMLBaseFontElement\",bdi:\"HTMLElement\",bdo:\"HTMLElement\",big:\"HTMLElement\",blockquote:\"HTMLQuoteElement\",body:\"HTMLBodyElement\",br:\"HTMLBRElement\",button:\"HTMLButtonElement\",canvas:\"HTMLCanvasElement\",caption:\"HTMLTableCaptionElement\",center:\"HTMLElement\",cite:\"HTMLElement\",code:\"HTMLElement\",col:\"HTMLTableColElement\",colgroup:\"HTMLTableColElement\",command:\"HTMLCommandElement\",data:\"HTMLElement\",datalist:\"HTMLDataListElement\",dd:\"HTMLElement\",del:\"HTMLModElement\",details:\"HTMLDetailsElement\",dfn:\"HTMLElement\",dialog:\"HTMLDialogElement\",dir:\"HTMLDirectoryElement\",div:\"HTMLDivElement\",dl:\"HTMLDListElement\",dt:\"HTMLElement\",em:\"HTMLElement\",fieldset:\"HTMLFieldSetElement\",figcaption:\"HTMLElement\",figure:\"HTMLElement\",font:\"HTMLFontElement\",footer:\"HTMLElement\",form:\"HTMLFormElement\",frame:\"HTMLFrameElement\",frameset:\"HTMLFrameSetElement\",h1:\"HTMLHeadingElement\",h2:\"HTMLHeadingElement\",h3:\"HTMLHeadingElement\",h4:\"HTMLHeadingElement\",h5:\"HTMLHeadingElement\",h6:\"HTMLHeadingElement\",head:\"HTMLHeadElement\",header:\"HTMLElement\",hgroup:\"HTMLElement\",hr:\"HTMLHRElement\",html:\"HTMLHtmlElement\",i:\"HTMLElement\",iframe:\"HTMLIFrameElement\",img:\"HTMLImageElement\",input:\"HTMLInputElement\",ins:\"HTMLModElement\",isindex:\"HTMLUnknownElement\",kbd:\"HTMLElement\",keygen:\"HTMLKeygenElement\",label:\"HTMLLabelElement\",legend:\"HTMLLegendElement\",li:\"HTMLLIElement\",link:\"HTMLLinkElement\",map:\"HTMLMapElement\",mark:\"HTMLElement\",menu:\"HTMLMenuElement\",meta:\"HTMLMetaElement\",meter:\"HTMLMeterElement\",nav:\"HTMLElement\",nobr:\"HTMLElement\",noembed:\"HTMLElement\",noframes:\"HTMLElement\",noscript:\"HTMLElement\",object:\"HTMLObjectElement\",ol:\"HTMLOListElement\",optgroup:\"HTMLOptGroupElement\",option:\"HTMLOptionElement\",output:\"HTMLOutputElement\",p:\"HTMLParagraphElement\",param:\"HTMLParamElement\",pre:\"HTMLPreElement\",progress:\"HTMLProgressElement\",q:\"HTMLQuoteElement\",s:\"HTMLElement\",samp:\"HTMLElement\",script:\"HTMLScriptElement\",section:\"HTMLElement\",select:\"HTMLSelectElement\",small:\"HTMLElement\",source:\"HTMLSourceElement\",span:\"HTMLSpanElement\",strike:\"HTMLElement\",strong:\"HTMLElement\",style:\"HTMLStyleElement\",sub:\"HTMLElement\",summary:\"HTMLElement\",sup:\"HTMLElement\",table:\"HTMLTableElement\",tbody:\"HTMLTableSectionElement\",td:\"HTMLTableDataCellElement\",textarea:\"HTMLTextAreaElement\",tfoot:\"HTMLTableSectionElement\",th:\"HTMLTableHeaderCellElement\",thead:\"HTMLTableSectionElement\",time:\"HTMLTimeElement\",title:\"HTMLTitleElement\",tr:\"HTMLTableRowElement\",track:\"HTMLTrackElement\",tt:\"HTMLElement\",u:\"HTMLElement\",ul:\"HTMLUListElement\",\"var\":\"HTMLElement\",video:\"HTMLVideoElement\",wbr:\"HTMLElement\"},html4.ELEMENT_DOM_INTERFACES=html4.ELEMENT_DOM_INTERFACES,html4.ueffects={NOT_LOADED:0,SAME_DOCUMENT:1,NEW_DOCUMENT:2},html4.ueffects=html4.ueffects,html4.URIEFFECTS={\"a::href\":2,\"area::href\":2,\"blockquote::cite\":0,\"command::icon\":1,\"del::cite\":0,\"form::action\":2,\"img::src\":1,\"input::src\":1,\"ins::cite\":0,\"q::cite\":0,\"video::poster\":1},html4.URIEFFECTS=html4.URIEFFECTS,html4.ltypes={UNSANDBOXED:2,SANDBOXED:1,DATA:0},html4.ltypes=html4.ltypes,html4.LOADERTYPES={\"a::href\":2,\"area::href\":2,\"blockquote::cite\":2,\"command::icon\":1,\"del::cite\":2,\"form::action\":2,\"img::src\":1,\"input::src\":1,\"ins::cite\":2,\"q::cite\":2,\"video::poster\":1},html4.LOADERTYPES=html4.LOADERTYPES,\"i\"!==\"I\".toLowerCase())throw\"I/i problem\";var html=function(e){function t(e){if(S.hasOwnProperty(e))return S[e];var t=e.match(P);if(t)return String.fromCharCode(parseInt(t[1],10));if(t=e.match(D))return String.fromCharCode(parseInt(t[1],16));if(I&&k.test(e)){I.innerHTML=\"&\"+e+\";\";var a=I.textContent;return S[e]=a,a}return\"&\"+e+\";\"}function a(e,a){return t(a)}function n(e){return e.replace(x,\"\")}function r(e){return e.replace(N,a)}function o(e){return(\"\"+e).replace(F,\"&amp;\").replace(B,\"&lt;\").replace(q,\"&gt;\").replace(z,\"&#34;\")}function i(e){return e.replace(U,\"&amp;$1\").replace(B,\"&lt;\").replace(q,\"&gt;\")}function l(e){var t={cdata:e.cdata||e.cdata,comment:e.comment||e.comment,endDoc:e.endDoc||e.endDoc,endTag:e.endTag||e.endTag,pcdata:e.pcdata||e.pcdata,rcdata:e.rcdata||e.rcdata,startDoc:e.startDoc||e.startDoc,startTag:e.startTag||e.startTag};return function(e,a){return s(e,t,a)}}function s(e,t,a){var n=u(e),r={noMoreGT:!1,noMoreEndComments:!1};m(t,n,0,r,a)}function c(e,t,a,n,r){return function(){m(e,t,a,n,r)}}function m(t,a,n,r,o){try{t.startDoc&&0==n&&t.startDoc(o);for(var i,l,s,m=n,u=a.length;u>m;){var f=a[m++],g=a[m];switch(f){case\"&\":O.test(g)?(t.pcdata&&t.pcdata(\"&\"+g,o,Y,c(t,a,m,r,o)),m++):t.pcdata&&t.pcdata(\"&amp;\",o,Y,c(t,a,m,r,o));break;case\"</\":(i=/^([-\\w:]+)[^\\'\\\"]*/.exec(g))?i[0].length===g.length&&\">\"===a[m+1]?(m+=2,s=i[1].toLowerCase(),t.endTag&&t.endTag(s,o,Y,c(t,a,m,r,o))):m=h(a,m,t,o,Y,r):t.pcdata&&t.pcdata(\"&lt;/\",o,Y,c(t,a,m,r,o));break;case\"<\":if(i=/^([-\\w:]+)\\s*\\/?/.exec(g))if(i[0].length===g.length&&\">\"===a[m+1]){m+=2,s=i[1].toLowerCase(),t.startTag&&t.startTag(s,[],o,Y,c(t,a,m,r,o));var E=e.ELEMENTS[s];if(E&j){var T={name:s,next:m,eflags:E};m=d(a,T,t,o,Y,r)}}else m=p(a,m,t,o,Y,r);else t.pcdata&&t.pcdata(\"&lt;\",o,Y,c(t,a,m,r,o));break;case\"<!--\":if(!r.noMoreEndComments){for(l=m+1;u>l&&(\">\"!==a[l]||!/--$/.test(a[l-1]));l++);if(u>l){if(t.comment){var L=a.slice(m,l).join(\"\");t.comment(L.substr(0,L.length-2),o,Y,c(t,a,l+1,r,o))}m=l+1}else r.noMoreEndComments=!0}r.noMoreEndComments&&t.pcdata&&t.pcdata(\"&lt;!--\",o,Y,c(t,a,m,r,o));break;case\"<!\":if(/^\\w/.test(g)){if(!r.noMoreGT){for(l=m+1;u>l&&\">\"!==a[l];l++);u>l?m=l+1:r.noMoreGT=!0}r.noMoreGT&&t.pcdata&&t.pcdata(\"&lt;!\",o,Y,c(t,a,m,r,o))}else t.pcdata&&t.pcdata(\"&lt;!\",o,Y,c(t,a,m,r,o));break;case\"<?\":if(!r.noMoreGT){for(l=m+1;u>l&&\">\"!==a[l];l++);u>l?m=l+1:r.noMoreGT=!0}r.noMoreGT&&t.pcdata&&t.pcdata(\"&lt;?\",o,Y,c(t,a,m,r,o));break;case\">\":t.pcdata&&t.pcdata(\"&gt;\",o,Y,c(t,a,m,r,o));break;case\"\":break;default:t.pcdata&&t.pcdata(f,o,Y,c(t,a,m,r,o))}}t.endDoc&&t.endDoc(o)}catch(M){if(M!==Y)throw M}}function u(e){var t=/(<\\/|<\\!--|<[!?]|[&<>])/g;if(e+=\"\",$)return e.split(t);for(var a,n=[],r=0;null!==(a=t.exec(e));)n.push(e.substring(r,a.index)),n.push(a[0]),r=a.index+a[0].length;return n.push(e.substring(r)),n}function h(e,t,a,n,r,o){var i=f(e,t);return i?(a.endTag&&a.endTag(i.name,n,r,c(a,e,t,o,n)),i.next):e.length}function p(e,t,a,n,r,o){var i=f(e,t);return i?(a.startTag&&a.startTag(i.name,i.attrs,n,r,c(a,e,i.next,o,n)),i.eflags&j?d(e,i,a,n,r,o):i.next):e.length}function d(t,a,n,r,o,l){var s=t.length;Q.hasOwnProperty(a.name)||(Q[a.name]=new RegExp(\"^\"+a.name+\"(?:[\\\\s\\\\/]|$)\",\"i\"));for(var m=Q[a.name],u=a.next,h=a.next+1;s>h&&(\"</\"!==t[h-1]||!m.test(t[h]));h++);s>h&&(h-=1);var p=t.slice(u,h).join(\"\");if(a.eflags&e.eflags.CDATA)n.cdata&&n.cdata(p,r,o,c(n,t,h,l,r));else{if(!(a.eflags&e.eflags.RCDATA))throw new Error(\"bug\");n.rcdata&&n.rcdata(i(p),r,o,c(n,t,h,l,r))}return h}function f(t,a){var n=/^([-\\w:]+)/.exec(t[a]),r={};r.name=n[1].toLowerCase(),r.eflags=e.ELEMENTS[r.name];for(var o=t[a].substr(n[0].length),i=a+1,l=t.length;l>i&&\">\"!==t[i];i++)o+=t[i];if(i>=l)return void 0;for(var s=[];\"\"!==o;)if(n=G.exec(o)){if(n[4]&&!n[5]||n[6]&&!n[7]){for(var c=n[4]||n[6],m=!1,u=[o,t[i++]];l>i;i++){if(m){if(\">\"===t[i])break}else 0<=t[i].indexOf(c)&&(m=!0);u.push(t[i])}if(i>=l)break;o=u.join(\"\");continue}var h=n[1].toLowerCase(),p=n[2]?g(n[3]):\"\";s.push(h,p),o=o.substr(n[0].length)}else o=o.replace(/^[\\s\\S][^a-z\\s]*/,\"\");return r.attrs=s,r.next=i+1,r}function g(e){var t=e.charCodeAt(0);return(34===t||39===t)&&(e=e.substr(1,e.length-2)),r(n(e))}function E(t){var a,n,r=function(e,t){n||t.push(e)};return l({startDoc:function(e){a=[],n=!1},startTag:function(r,i,l){if(!n&&e.ELEMENTS.hasOwnProperty(r)){var s=e.ELEMENTS[r];if(!(s&e.eflags.FOLDABLE)){var c=t(r,i);if(!c)return void(n=!(s&e.eflags.EMPTY));if(\"object\"!=typeof c)throw new Error(\"tagPolicy did not return object (old API?)\");if(!(\"attribs\"in c))throw new Error(\"tagPolicy gave no attribs\");i=c.attribs;var m,u;if(\"tagName\"in c?(u=c.tagName,m=e.ELEMENTS[u]):(u=r,m=s),s&e.eflags.OPTIONAL_ENDTAG){var h=a[a.length-1];!h||h.orig!==r||h.rep===u&&r===u||l.push(\"</\",h.rep,\">\")}s&e.eflags.EMPTY||a.push({orig:r,rep:u}),l.push(\"<\",u);for(var p=0,d=i.length;d>p;p+=2){var f=i[p],g=i[p+1];null!==g&&void 0!==g&&l.push(\" \",f,'=\"',o(g),'\"')}l.push(\">\"),s&e.eflags.EMPTY&&!(m&e.eflags.EMPTY)&&l.push(\"</\",u,\">\")}}},endTag:function(t,r){if(n)return void(n=!1);if(e.ELEMENTS.hasOwnProperty(t)){var o=e.ELEMENTS[t];if(!(o&(e.eflags.EMPTY|e.eflags.FOLDABLE))){var i;if(o&e.eflags.OPTIONAL_ENDTAG)for(i=a.length;--i>=0;){var l=a[i].orig;if(l===t)break;if(!(e.ELEMENTS[l]&e.eflags.OPTIONAL_ENDTAG))return}else for(i=a.length;--i>=0&&a[i].orig!==t;);if(0>i)return;for(var s=a.length;--s>i;){var c=a[s].rep;e.ELEMENTS[c]&e.eflags.OPTIONAL_ENDTAG||r.push(\"</\",c,\">\")}i<a.length&&(t=a[i].rep),a.length=i,r.push(\"</\",t,\">\")}}},pcdata:r,rcdata:r,cdata:r,endDoc:function(e){for(;a.length;a.length--)e.push(\"</\",a[a.length-1].rep,\">\")}})}function T(e,t,a,n,r){if(!r)return null;try{var o=URI.parse(\"\"+e);if(o&&(!o.hasScheme()||V.test(o.getScheme()))){var i=r(o,t,a,n);return i?i.toString():null}}catch(l){return null}return null}function L(e,t,a,n,r){if(a||e(t+\" removed\",{change:\"removed\",tagName:t}),n!==r){var o=\"changed\";n&&!r?o=\"removed\":!n&&r&&(o=\"added\"),e(t+\".\"+a+\" \"+o,{change:o,tagName:t,attribName:a,oldValue:n,newValue:r})}}function M(e,t,a){var n;return n=t+\"::\"+a,e.hasOwnProperty(n)?e[n]:(n=\"*::\"+a,e.hasOwnProperty(n)?e[n]:void 0)}function b(t,a){return M(e.LOADERTYPES,t,a)}function y(t,a){return M(e.URIEFFECTS,t,a)}function v(t,a,n,r,o){for(var i=0;i<a.length;i+=2){var l,s=a[i],c=a[i+1],m=c,u=null;if(l=t+\"::\"+s,(e.ATTRIBS.hasOwnProperty(l)||(l=\"*::\"+s,e.ATTRIBS.hasOwnProperty(l)))&&(u=e.ATTRIBS[l]),null!==u)switch(u){case e.atype.NONE:break;case e.atype.SCRIPT:c=null,o&&L(o,t,s,m,c);break;case e.atype.STYLE:if(\"undefined\"==typeof A){c=null,o&&L(o,t,s,m,c);break}var h=[];A(c,{declaration:function(t,a){var r=t.toLowerCase(),o=C[r];o&&(R(r,o,a,n?function(t){return T(t,e.ueffects.SAME_DOCUMENT,e.ltypes.SANDBOXED,{TYPE:\"CSS\",CSS_PROP:r},n)}:null),h.push(t+\": \"+a.join(\" \")))}}),c=h.length>0?h.join(\" ; \"):null,o&&L(o,t,s,m,c);break;case e.atype.ID:case e.atype.IDREF:case e.atype.IDREFS:case e.atype.GLOBAL_NAME:case e.atype.LOCAL_NAME:case e.atype.CLASSES:c=r?r(c):c,o&&L(o,t,s,m,c);break;case e.atype.URI:c=T(c,y(t,s),b(t,s),{TYPE:\"MARKUP\",XML_ATTR:s,XML_TAG:t},n),o&&L(o,t,s,m,c);break;case e.atype.URI_FRAGMENT:c&&\"#\"===c.charAt(0)?(c=c.substring(1),c=r?r(c):c,null!==c&&void 0!==c&&(c=\"#\"+c)):c=null,o&&L(o,t,s,m,c);break;default:c=null,o&&L(o,t,s,m,c)}else c=null,o&&L(o,t,s,m,c);a[i+1]=c}return a}function H(t,a,n){return function(r,o){return e.ELEMENTS[r]&e.eflags.UNSAFE?void(n&&L(n,r,void 0,void 0,void 0)):{attribs:v(r,o,t,a,n)}}}function _(e,t){var a=[];return E(t)(e,a),a.join(\"\")}function w(e,t,a,n){var r=H(t,a,n);return _(e,r)}var A,R,C;\"undefined\"!=typeof window&&(A=window.parseCssDeclarations,R=window.sanitizeCssProperty,C=window.cssSchema);var S={lt:\"<\",LT:\"<\",gt:\">\",GT:\">\",amp:\"&\",AMP:\"&\",quot:'\"',apos:\"'\",nbsp:\" \"},P=/^#(\\d+)$/,D=/^#x([0-9A-Fa-f]+)$/,k=/^[A-Za-z][A-za-z0-9]+$/,I=\"undefined\"!=typeof window&&window.document?window.document.createElement(\"textarea\"):null,x=/\\0/g,N=/&(#[0-9]+|#[xX][0-9A-Fa-f]+|\\w+);/g,O=/^(#[0-9]+|#[xX][0-9A-Fa-f]+|\\w+);/,F=/&/g,U=/&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi,B=/[<]/g,q=/>/g,z=/\\\"/g,G=new RegExp(\"^\\\\s*([-.:\\\\w]+)(?:\\\\s*(=)\\\\s*((\\\")[^\\\"]*(\\\"|$)|(')[^']*('|$)|(?=[a-z][-\\\\w]*\\\\s*=)|[^\\\"'\\\\s]*))?\",\"i\"),$=3===\"a,b\".split(/(,)/).length,j=e.eflags.CDATA|e.eflags.RCDATA,Y={},Q={},V=/^(?:https?|mailto|data)$/i,X={};return X.escapeAttrib=X.escapeAttrib=o,X.makeHtmlSanitizer=X.makeHtmlSanitizer=E,X.makeSaxParser=X.makeSaxParser=l,X.makeTagPolicy=X.makeTagPolicy=H,X.normalizeRCData=X.normalizeRCData=i,X.sanitize=X.sanitize=w,X.sanitizeAttribs=X.sanitizeAttribs=v,X.sanitizeWithPolicy=X.sanitizeWithPolicy=_,X.unescapeEntities=X.unescapeEntities=r,X}(html4),html_sanitize=html.sanitize;html4.ATTRIBS[\"*::style\"]=0,html4.ELEMENTS.style=0,html4.ATTRIBS[\"a::target\"]=0,html4.ELEMENTS.video=0,html4.ATTRIBS[\"video::src\"]=0,html4.ATTRIBS[\"video::poster\"]=0,html4.ATTRIBS[\"video::controls\"]=0,html4.ELEMENTS.audio=0,html4.ATTRIBS[\"audio::src\"]=0,html4.ATTRIBS[\"video::autoplay\"]=0,html4.ATTRIBS[\"video::controls\"]=0,\"undefined\"!=typeof module&&(module.exports=html_sanitize);\n},{}],7:[function(require,module,exports){\nmodule.exports={\"author\":\"Mapbox\",\"name\":\"mapbox.js\",\"description\":\"mapbox javascript api\",\"version\":\"2.4.0\",\"homepage\":\"http://mapbox.com/\",\"repository\":{\"type\":\"git\",\"url\":\"git://github.com/mapbox/mapbox.js.git\"},\"main\":\"src/index.js\",\"dependencies\":{\"corslite\":\"0.0.6\",\"isarray\":\"0.0.1\",\"leaflet\":\"0.7.7\",\"mustache\":\"2.2.1\",\"sanitize-caja\":\"0.1.3\"},\"scripts\":{\"test\":\"eslint --no-eslintrc -c .eslintrc src && mocha-phantomjs test/index.html\"},\"license\":\"BSD-3-Clause\",\"devDependencies\":{\"browserify\":\"^13.0.0\",\"clean-css\":\"~2.0.7\",\"eslint\":\"^0.23.0\",\"expect.js\":\"0.3.1\",\"happen\":\"0.1.3\",\"leaflet-fullscreen\":\"0.0.4\",\"leaflet-hash\":\"0.2.1\",\"marked\":\"~0.3.0\",\"minifyify\":\"^6.1.0\",\"minimist\":\"0.0.5\",\"mocha\":\"2.4.5\",\"mocha-phantomjs\":\"4.0.2\",\"sinon\":\"1.10.2\"},\"optionalDependencies\":{},\"engines\":{\"node\":\"*\"}}\n},{}],8:[function(require,module,exports){\n\"use strict\";module.exports={HTTP_URL:\"http://a.tiles.mapbox.com/v4\",HTTPS_URL:\"https://a.tiles.mapbox.com/v4\",FORCE_HTTPS:!1,REQUIRE_ACCESS_TOKEN:!0};\n},{}],9:[function(require,module,exports){\n\"use strict\";var util=require(\"./util\"),format_url=require(\"./format_url\"),request=require(\"./request\"),marker=require(\"./marker\"),simplestyle=require(\"./simplestyle\"),FeatureLayer=L.FeatureGroup.extend({options:{filter:function(){return!0},sanitizer:require(\"sanitize-caja\"),style:simplestyle.style,popupOptions:{closeButton:!1}},initialize:function(e,t){L.setOptions(this,t),this._layers={},\"string\"==typeof e?util.idUrl(e,this):e&&\"object\"==typeof e&&this.setGeoJSON(e)},setGeoJSON:function(e){return this._geojson=e,this.clearLayers(),this._initialize(e),this},getGeoJSON:function(){return this._geojson},loadURL:function(e){return this._request&&\"abort\"in this._request&&this._request.abort(),this._request=request(e,L.bind(function(t,i){this._request=null,t&&\"abort\"!==t.type?(util.log(\"could not load features at \"+e),this.fire(\"error\",{error:t})):i&&(this.setGeoJSON(i),this.fire(\"ready\"))},this)),this},loadID:function(e){return this.loadURL(format_url(\"/v4/\"+e+\"/features.json\",this.options.accessToken))},setFilter:function(e){return this.options.filter=e,this._geojson&&(this.clearLayers(),this._initialize(this._geojson)),this},getFilter:function(){return this.options.filter},_initialize:function(e){var t,i,r=L.Util.isArray(e)?e:e.features;if(r)for(t=0,i=r.length;i>t;t++)(r[t].geometries||r[t].geometry||r[t].features)&&this._initialize(r[t]);else if(this.options.filter(e)){var s={accessToken:this.options.accessToken},o=this.options.pointToLayer||function(e,t){return marker.style(e,t,s)},n=L.GeoJSON.geometryToLayer(e,o),u=marker.createPopup(e,this.options.sanitizer),a=this.options.style,l=a===simplestyle.style;!(a&&\"setStyle\"in n)||l&&(n instanceof L.Circle||n instanceof L.CircleMarker)||(\"function\"==typeof a&&(a=a(e)),n.setStyle(a)),n.feature=e,u&&n.bindPopup(u,this.options.popupOptions),this.addLayer(n)}}});module.exports.FeatureLayer=FeatureLayer,module.exports.featureLayer=function(e,t){return new FeatureLayer(e,t)};\n},{\"./format_url\":11,\"./marker\":25,\"./request\":26,\"./simplestyle\":28,\"./util\":31,\"sanitize-caja\":5}],10:[function(require,module,exports){\n\"use strict\";var Feedback=L.Class.extend({includes:L.Mixin.Events,data:{},record:function(e){L.extend(this.data,e),this.fire(\"change\")}});module.exports=new Feedback;\n},{}],11:[function(require,module,exports){\n\"use strict\";var config=require(\"./config\"),version=require(\"../package.json\").version;module.exports=function(e,o){if(o=o||L.mapbox.accessToken,!o&&config.REQUIRE_ACCESS_TOKEN)throw new Error(\"An API access token is required to use Mapbox.js. See https://www.mapbox.com/mapbox.js/api/v\"+version+\"/api-access-tokens/\");var t=\"https:\"===document.location.protocol||config.FORCE_HTTPS?config.HTTPS_URL:config.HTTP_URL;if(t=t.replace(/\\/v4$/,\"\"),t+=e,config.REQUIRE_ACCESS_TOKEN){if(\"s\"===o[0])throw new Error(\"Use a public access token (pk.*) with Mapbox.js, not a secret access token (sk.*). See https://www.mapbox.com/mapbox.js/api/v\"+version+\"/api-access-tokens/\");t+=-1!==t.indexOf(\"?\")?\"&access_token=\":\"?access_token=\",t+=o}return t},module.exports.tileJSON=function(e,o){if(0===e.indexOf(\"mapbox://styles\"))throw new Error(\"Styles created with Mapbox Studio need to be used with L.mapbox.styleLayer, not L.mapbox.tileLayer\");if(-1!==e.indexOf(\"/\"))return e;var t=module.exports(\"/v4/\"+e+\".json\",o);return 0===t.indexOf(\"https\")&&(t+=\"&secure\"),t},module.exports.style=function(e,o){if(-1===e.indexOf(\"mapbox://styles/\"))throw new Error(\"Incorrectly formatted Mapbox style at \"+e);var t=e.split(\"mapbox://styles/\")[1],s=module.exports(\"/styles/v1/\"+t,o).replace(\"http://\",\"https://\");return s};\n},{\"../package.json\":7,\"./config\":8}],12:[function(require,module,exports){\n\"use strict\";var isArray=require(\"isarray\"),util=require(\"./util\"),format_url=require(\"./format_url\"),feedback=require(\"./feedback\"),request=require(\"./request\");module.exports=function(e,t){function r(e,t){var r=Math.pow(10,t);return e.lat=Math.round(e.lat*r)/r,e.lng=Math.round(e.lng*r)/r,e}t||(t={});var n={};return util.strict(e,\"string\"),-1===e.indexOf(\"/\")&&(e=format_url(\"/geocoding/v5/\"+e+\"/{query}.json\",t.accessToken,5)),n.getURL=function(){return e},n.queryURL=function(e){var t=!(isArray(e)||\"string\"==typeof e),u=t?e.query:e;if(isArray(u)){for(var o=[],i=0;i<u.length;i++)o[i]=encodeURIComponent(u[i]);u=o.join(\";\")}else u=encodeURIComponent(u);feedback.record({geocoding:u});var a=L.Util.template(n.getURL(),{query:u});if(t){if(e.types&&(a+=isArray(e.types)?\"&types=\"+e.types.join():\"&types=\"+e.types),e.country&&(a+=isArray(e.country)?\"&country=\"+e.country.join():\"&country=\"+e.country),e.proximity){var l=r(L.latLng(e.proximity),3);a+=\"&proximity=\"+l.lng+\",\"+l.lat}\"boolean\"==typeof e.autocomplete&&(a+=\"&autocomplete=\"+e.autocomplete)}return a},n.query=function(e,t){return util.strict(t,\"function\"),request(n.queryURL(e),function(e,r){if(r&&(r.length||r.features)){var n={results:r};r.features&&r.features.length&&(n.latlng=[r.features[0].center[1],r.features[0].center[0]],r.features[0].bbox&&(n.bounds=r.features[0].bbox,n.lbounds=util.lbounds(n.bounds))),t(null,n)}else t(e||!0)}),n},n.reverseQuery=function(e,t){function u(e){var t;return t=void 0!==e.lat&&void 0!==e.lng?L.latLng(e.lat,e.lng):void 0!==e.lat&&void 0!==e.lon?L.latLng(e.lat,e.lon):L.latLng(e[1],e[0]),t=r(t,5),t.lng+\",\"+t.lat}var o=\"\";if(e.length&&e[0].length){for(var i=0,a=[];i<e.length;i++)a.push(u(e[i]));o=a.join(\";\")}else o=u(e);return request(n.queryURL(o),function(e,r){t(e,r)}),n},n};\n},{\"./feedback\":10,\"./format_url\":11,\"./request\":26,\"./util\":31,\"isarray\":2}],13:[function(require,module,exports){\n\"use strict\";var geocoder=require(\"./geocoder\"),util=require(\"./util\"),GeocoderControl=L.Control.extend({includes:L.Mixin.Events,options:{proximity:!0,position:\"topleft\",pointZoom:16,keepOpen:!1,autocomplete:!1,queryOptions:{}},initialize:function(t,e){L.Util.setOptions(this,e),this.setURL(t),this._updateSubmit=L.bind(this._updateSubmit,this),this._updateAutocomplete=L.bind(this._updateAutocomplete,this),this._chooseResult=L.bind(this._chooseResult,this)},setURL:function(t){return this.geocoder=geocoder(t,{accessToken:this.options.accessToken}),this},getURL:function(){return this.geocoder.getURL()},setID:function(t){return this.setURL(t)},setTileJSON:function(t){return this.setURL(t.geocoder)},_toggle:function(t){t&&L.DomEvent.stop(t),L.DomUtil.hasClass(this._container,\"active\")?(L.DomUtil.removeClass(this._container,\"active\"),this._results.innerHTML=\"\",this._input.blur()):(L.DomUtil.addClass(this._container,\"active\"),this._input.focus(),this._input.select())},_closeIfOpen:function(){L.DomUtil.hasClass(this._container,\"active\")&&!this.options.keepOpen&&(L.DomUtil.removeClass(this._container,\"active\"),this._results.innerHTML=\"\",this._input.blur())},onAdd:function(t){var e=L.DomUtil.create(\"div\",\"leaflet-control-mapbox-geocoder leaflet-bar leaflet-control\"),i=L.DomUtil.create(\"a\",\"leaflet-control-mapbox-geocoder-toggle mapbox-icon mapbox-icon-geocoder\",e),o=L.DomUtil.create(\"div\",\"leaflet-control-mapbox-geocoder-results\",e),s=L.DomUtil.create(\"div\",\"leaflet-control-mapbox-geocoder-wrap\",e),n=L.DomUtil.create(\"form\",\"leaflet-control-mapbox-geocoder-form\",s),r=L.DomUtil.create(\"input\",\"\",n);return i.href=\"#\",i.innerHTML=\"&nbsp;\",r.type=\"text\",r.setAttribute(\"placeholder\",\"Search\"),L.DomEvent.addListener(n,\"submit\",this._geocode,this),L.DomEvent.addListener(r,\"keyup\",this._autocomplete,this),L.DomEvent.disableClickPropagation(e),this._map=t,this._results=o,this._input=r,this._form=n,this.options.keepOpen?L.DomUtil.addClass(e,\"active\"):(this._map.on(\"click\",this._closeIfOpen,this),L.DomEvent.addListener(i,\"click\",this._toggle,this)),e},_updateSubmit:function(t,e){if(L.DomUtil.removeClass(this._container,\"searching\"),this._results.innerHTML=\"\",t||!e)this.fire(\"error\",{error:t});else{var i=[];e.results&&e.results.features&&(i=e.results.features),1===i.length?(this.fire(\"autoselect\",{feature:i[0]}),this.fire(\"found\",{results:e.results}),this._chooseResult(i[0]),this._closeIfOpen()):i.length>1?(this.fire(\"found\",{results:e.results}),this._displayResults(i)):(this.fire(\"notfound\"),this._displayResults(i))}},_updateAutocomplete:function(t,e){if(this._results.innerHTML=\"\",t||!e)this.fire(\"error\",{error:t});else{var i=[];e.results&&e.results.features&&(i=e.results.features),i.length?this.fire(\"found\",{results:e.results}):this.fire(\"notfound\"),this._displayResults(i)}},_displayResults:function(t){for(var e=0,i=Math.min(t.length,5);i>e;e++){var o=t[e],s=o.place_name;if(s.length){var n=L.DomUtil.create(\"a\",\"\",this._results),r=\"innerText\"in n?\"innerText\":\"textContent\";n[r]=s,n.setAttribute(\"title\",s),n.href=\"#\",L.bind(function(t){L.DomEvent.addListener(n,\"click\",function(e){this._chooseResult(t),L.DomEvent.stop(e),this.fire(\"select\",{feature:t})},this)},this)(o)}}if(t.length>5){var l=L.DomUtil.create(\"span\",\"\",this._results);l.innerHTML=\"Top 5 of \"+t.length+\"  results\"}},_chooseResult:function(t){t.bbox?this._map.fitBounds(util.lbounds(t.bbox)):t.center&&this._map.setView([t.center[1],t.center[0]],void 0===this._map.getZoom()?this.options.pointZoom:Math.max(this._map.getZoom(),this.options.pointZoom))},_geocode:function(t){return L.DomEvent.preventDefault(t),\"\"===this._input.value?this._updateSubmit():(L.DomUtil.addClass(this._container,\"searching\"),void this.geocoder.query(L.Util.extend({query:this._input.value,proximity:this.options.proximity?this._map.getCenter():!1},this.options.queryOptions),this._updateSubmit))},_autocomplete:function(){return this.options.autocomplete?\"\"===this._input.value?this._updateAutocomplete():void this.geocoder.query(L.Util.extend({query:this._input.value,proximity:this.options.proximity?this._map.getCenter():!1},this.options.queryOptions),this._updateAutocomplete):void 0}});module.exports.GeocoderControl=GeocoderControl,module.exports.geocoderControl=function(t,e){return new GeocoderControl(t,e)};\n},{\"./geocoder\":12,\"./util\":31}],14:[function(require,module,exports){\n\"use strict\";function utfDecode(t){return t>=93&&t--,t>=35&&t--,t-32}module.exports=function(t){return function(e,r){if(t){var u=utfDecode(t.grid[r].charCodeAt(e)),n=t.keys[u];return t.data[n]}}};\n},{}],15:[function(require,module,exports){\n\"use strict\";var util=require(\"./util\"),Mustache=require(\"mustache\"),GridControl=L.Control.extend({options:{pinnable:!0,follow:!1,sanitizer:require(\"sanitize-caja\"),touchTeaser:!0,location:!0},_currentContent:\"\",_pinned:!1,initialize:function(t,o){L.Util.setOptions(this,o),util.strict_instance(t,L.Class,\"L.mapbox.gridLayer\"),this._layer=t},setTemplate:function(t){return util.strict(t,\"string\"),this.options.template=t,this},_template:function(t,o){if(o){var i=this.options.template||this._layer.getTileJSON().template;if(i){var e={};return e[\"__\"+t+\"__\"]=!0,this.options.sanitizer(Mustache.to_html(i,L.extend(e,o)))}}},_show:function(t,o){t!==this._currentContent&&(this._currentContent=t,this.options.follow?(this._popup.setContent(t).setLatLng(o.latLng),this._map._popup!==this._popup&&this._popup.openOn(this._map)):(this._container.style.display=\"block\",this._contentWrapper.innerHTML=t))},hide:function(){return this._pinned=!1,this._currentContent=\"\",this._map.closePopup(),this._container.style.display=\"none\",this._contentWrapper.innerHTML=\"\",L.DomUtil.removeClass(this._container,\"closable\"),this},_mouseover:function(t){if(t.data?L.DomUtil.addClass(this._map._container,\"map-clickable\"):L.DomUtil.removeClass(this._map._container,\"map-clickable\"),!this._pinned){var o=this._template(\"teaser\",t.data);o?this._show(o,t):this.hide()}},_mousemove:function(t){this._pinned||this.options.follow&&this._popup.setLatLng(t.latLng)},_navigateTo:function(t){window.top.location.href=t},_click:function(t){var o=this._template(\"location\",t.data);if(this.options.location&&o&&0===o.search(/^https?:/))return this._navigateTo(this._template(\"location\",t.data));if(this.options.pinnable){var i=this._template(\"full\",t.data);!i&&this.options.touchTeaser&&L.Browser.touch&&(i=this._template(\"teaser\",t.data)),i?(L.DomUtil.addClass(this._container,\"closable\"),this._pinned=!0,this._show(i,t)):this._pinned&&(L.DomUtil.removeClass(this._container,\"closable\"),this._pinned=!1,this.hide())}},_onPopupClose:function(){this._currentContent=null,this._pinned=!1},_createClosebutton:function(t,o){var i=L.DomUtil.create(\"a\",\"close\",t);return i.innerHTML=\"close\",i.href=\"#\",i.title=\"close\",L.DomEvent.on(i,\"click\",L.DomEvent.stopPropagation).on(i,\"mousedown\",L.DomEvent.stopPropagation).on(i,\"dblclick\",L.DomEvent.stopPropagation).on(i,\"click\",L.DomEvent.preventDefault).on(i,\"click\",o,this),i},onAdd:function(t){this._map=t;var o=\"leaflet-control-grid map-tooltip\",i=L.DomUtil.create(\"div\",o),e=L.DomUtil.create(\"div\",\"map-tooltip-content\");return i.style.display=\"none\",this._createClosebutton(i,this.hide),i.appendChild(e),this._contentWrapper=e,this._popup=new L.Popup({autoPan:!1,closeOnClick:!1}),t.on(\"popupclose\",this._onPopupClose,this),L.DomEvent.disableClickPropagation(i).addListener(i,\"mousewheel\",L.DomEvent.stopPropagation),this._layer.on(\"mouseover\",this._mouseover,this).on(\"mousemove\",this._mousemove,this).on(\"click\",this._click,this),i},onRemove:function(t){t.off(\"popupclose\",this._onPopupClose,this),this._layer.off(\"mouseover\",this._mouseover,this).off(\"mousemove\",this._mousemove,this).off(\"click\",this._click,this)}});module.exports.GridControl=GridControl,module.exports.gridControl=function(t,o){return new GridControl(t,o)};\n},{\"./util\":31,\"mustache\":4,\"sanitize-caja\":5}],16:[function(require,module,exports){\n\"use strict\";var util=require(\"./util\"),request=require(\"./request\"),grid=require(\"./grid\"),GridLayer=L.Class.extend({includes:[L.Mixin.Events,require(\"./load_tilejson\")],options:{template:function(){return\"\"}},_mouseOn:null,_tilejson:{},_cache:{},initialize:function(t,i){L.Util.setOptions(this,i),this._loadTileJSON(t)},_setTileJSON:function(t){return util.strict(t,\"object\"),L.extend(this.options,{grids:t.grids,minZoom:t.minzoom,maxZoom:t.maxzoom,bounds:t.bounds&&util.lbounds(t.bounds)}),this._tilejson=t,this._cache={},this._update(),this},getTileJSON:function(){return this._tilejson},active:function(){return!!(this._map&&this.options.grids&&this.options.grids.length)},addTo:function(t){return t.addLayer(this),this},onAdd:function(t){this._map=t,this._update(),this._map.on(\"click\",this._click,this).on(\"mousemove\",this._move,this).on(\"moveend\",this._update,this)},onRemove:function(){this._map.off(\"click\",this._click,this).off(\"mousemove\",this._move,this).off(\"moveend\",this._update,this)},getData:function(t,i){if(this.active()){var e=this._map,o=e.project(t.wrap()),s=256,n=4,a=Math.floor(o.x/s),h=Math.floor(o.y/s),r=e.options.crs.scale(e.getZoom())/s;return a=(a+r)%r,h=(h+r)%r,this._getTile(e.getZoom(),a,h,function(t){var e=Math.floor((o.x-a*s)/n),r=Math.floor((o.y-h*s)/n);i(t(e,r))}),this}},_click:function(t){this.getData(t.latlng,L.bind(function(i){this.fire(\"click\",{latLng:t.latlng,data:i})},this))},_move:function(t){this.getData(t.latlng,L.bind(function(i){i!==this._mouseOn?(this._mouseOn&&this.fire(\"mouseout\",{latLng:t.latlng,data:this._mouseOn}),this.fire(\"mouseover\",{latLng:t.latlng,data:i}),this._mouseOn=i):this.fire(\"mousemove\",{latLng:t.latlng,data:i})},this))},_getTileURL:function(t){var i=this.options.grids,e=(t.x+t.y)%i.length,o=i[e];return L.Util.template(o,t)},_update:function(){if(this.active()){var t=this._map.getPixelBounds(),i=this._map.getZoom(),e=256;if(!(i>this.options.maxZoom||i<this.options.minZoom))for(var o=L.bounds(t.min.divideBy(e)._floor(),t.max.divideBy(e)._floor()),s=this._map.options.crs.scale(i)/e,n=o.min.x;n<=o.max.x;n++)for(var a=o.min.y;a<=o.max.y;a++)this._getTile(i,(n%s+s)%s,(a%s+s)%s)}},_getTile:function(t,i,e,o){var s=t+\"_\"+i+\"_\"+e,n=L.point(i,e);if(n.z=t,this._tileShouldBeLoaded(n)){if(s in this._cache){if(!o)return;return void(\"function\"==typeof this._cache[s]?o(this._cache[s]):this._cache[s].push(o))}this._cache[s]=[],o&&this._cache[s].push(o),request(this._getTileURL(n),L.bind(function(t,i){var e=this._cache[s];this._cache[s]=grid(i);for(var o=0;o<e.length;++o)e[o](this._cache[s])},this))}},_tileShouldBeLoaded:function(t){if(t.z>this.options.maxZoom||t.z<this.options.minZoom)return!1;if(this.options.bounds){var i=256,e=t.multiplyBy(i),o=e.add(new L.Point(i,i)),s=this._map.unproject(e),n=this._map.unproject(o),a=new L.LatLngBounds([s,n]);if(!this.options.bounds.intersects(a))return!1}return!0}});module.exports.GridLayer=GridLayer,module.exports.gridLayer=function(t,i){return new GridLayer(t,i)};\n},{\"./grid\":14,\"./load_tilejson\":21,\"./request\":26,\"./util\":31}],17:[function(require,module,exports){\n\"use strict\";var leaflet=require(\"./leaflet\");require(\"./mapbox\"),module.exports=leaflet;\n},{\"./leaflet\":19,\"./mapbox\":23}],18:[function(require,module,exports){\n\"use strict\";var InfoControl=L.Control.extend({options:{position:\"bottomright\",sanitizer:require(\"sanitize-caja\")},initialize:function(t){L.setOptions(this,t),this._info={},console.warn(\"infoControl has been deprecated and will be removed in mapbox.js v3.0.0. Use the default attribution control instead, which is now responsive.\")},onAdd:function(t){this._container=L.DomUtil.create(\"div\",\"mapbox-control-info mapbox-small\"),this._content=L.DomUtil.create(\"div\",\"map-info-container\",this._container);var i=L.DomUtil.create(\"a\",\"mapbox-info-toggle mapbox-icon mapbox-icon-info\",this._container);i.href=\"#\",L.DomEvent.addListener(i,\"click\",this._showInfo,this),L.DomEvent.disableClickPropagation(this._container);for(var n in t._layers)t._layers[n].getAttribution&&this.addInfo(t._layers[n].getAttribution());return t.on(\"layeradd\",this._onLayerAdd,this).on(\"layerremove\",this._onLayerRemove,this),this._update(),this._container},onRemove:function(t){t.off(\"layeradd\",this._onLayerAdd,this).off(\"layerremove\",this._onLayerRemove,this)},addInfo:function(t){return t?(this._info[t]||(this._info[t]=0),this._info[t]=!0,this._update()):this},removeInfo:function(t){return t?(this._info[t]&&(this._info[t]=!1),this._update()):this},_showInfo:function(t){return L.DomEvent.preventDefault(t),this._active===!0?this._hidecontent():(L.DomUtil.addClass(this._container,\"active\"),this._active=!0,void this._update())},_hidecontent:function(){this._content.innerHTML=\"\",this._active=!1,L.DomUtil.removeClass(this._container,\"active\")},_update:function(){if(!this._map)return this;this._content.innerHTML=\"\";var t=\"none\",i=[];for(var n in this._info)this._info.hasOwnProperty(n)&&this._info[n]&&(i.push(this.options.sanitizer(n)),t=\"block\");return this._content.innerHTML+=i.join(\" | \"),this._container.style.display=t,this},_onLayerAdd:function(t){t.layer.getAttribution&&t.layer.getAttribution()?this.addInfo(t.layer.getAttribution()):\"on\"in t.layer&&t.layer.getAttribution&&t.layer.on(\"ready\",L.bind(function(){this.addInfo(t.layer.getAttribution())},this))},_onLayerRemove:function(t){t.layer.getAttribution&&this.removeInfo(t.layer.getAttribution())}});module.exports.InfoControl=InfoControl,module.exports.infoControl=function(t){return new InfoControl(t)};\n},{\"sanitize-caja\":5}],19:[function(require,module,exports){\nmodule.exports=window.L=require(\"leaflet/dist/leaflet-src\");\n},{\"leaflet/dist/leaflet-src\":3}],20:[function(require,module,exports){\n\"use strict\";var LegendControl=L.Control.extend({options:{position:\"bottomright\",sanitizer:require(\"sanitize-caja\")},initialize:function(e){L.setOptions(this,e),this._legends={}},onAdd:function(){return this._container=L.DomUtil.create(\"div\",\"map-legends wax-legends\"),L.DomEvent.disableClickPropagation(this._container),this._update(),this._container},addLegend:function(e){return e?(this._legends[e]||(this._legends[e]=0),this._legends[e]++,this._update()):this},removeLegend:function(e){return e?(this._legends[e]&&this._legends[e]--,this._update()):this},_update:function(){if(!this._map)return this;this._container.innerHTML=\"\";var e=\"none\";for(var t in this._legends)if(this._legends.hasOwnProperty(t)&&this._legends[t]){var n=L.DomUtil.create(\"div\",\"map-legend wax-legend\",this._container);n.innerHTML=this.options.sanitizer(t),e=\"block\"}return this._container.style.display=e,this}});module.exports.LegendControl=LegendControl,module.exports.legendControl=function(e){return new LegendControl(e)};\n},{\"sanitize-caja\":5}],21:[function(require,module,exports){\n\"use strict\";var request=require(\"./request\"),format_url=require(\"./format_url\"),util=require(\"./util\");module.exports={_loadTileJSON:function(e){\"string\"==typeof e?(e=format_url.tileJSON(e,this.options&&this.options.accessToken),request(e,L.bind(function(t,r){t?(util.log(\"could not load TileJSON at \"+e),this.fire(\"error\",{error:t})):r&&(this._setTileJSON(r),this.fire(\"ready\"))},this))):e&&\"object\"==typeof e&&this._setTileJSON(e)}};\n},{\"./format_url\":11,\"./request\":26,\"./util\":31}],22:[function(require,module,exports){\n\"use strict\";function withAccessToken(t,o){return!o||t.accessToken?t:L.extend({accessToken:o},t)}var tileLayer=require(\"./tile_layer\").tileLayer,featureLayer=require(\"./feature_layer\").featureLayer,gridLayer=require(\"./grid_layer\").gridLayer,gridControl=require(\"./grid_control\").gridControl,infoControl=require(\"./info_control\").infoControl,shareControl=require(\"./share_control\").shareControl,legendControl=require(\"./legend_control\").legendControl,mapboxLogoControl=require(\"./mapbox_logo\").mapboxLogoControl,feedback=require(\"./feedback\"),LMap=L.Map.extend({includes:[require(\"./load_tilejson\")],options:{tileLayer:{},featureLayer:{},gridLayer:{},legendControl:{},gridControl:{},infoControl:!1,shareControl:!1,sanitizer:require(\"sanitize-caja\")},_tilejson:{},initialize:function(t,o,e){if(L.Map.prototype.initialize.call(this,t,L.extend({},L.Map.prototype.options,e)),this.attributionControl){this.attributionControl.setPrefix(\"\");var i=this.options.attributionControl.compact;(i||i!==!1&&this._container.offsetWidth<=640)&&L.DomUtil.addClass(this.attributionControl._container,\"leaflet-compact-attribution\"),void 0===i&&this.on(\"resize\",function(){this._container.offsetWidth>640?L.DomUtil.removeClass(this.attributionControl._container,\"leaflet-compact-attribution\"):L.DomUtil.addClass(this.attributionControl._container,\"leaflet-compact-attribution\")})}this.options.tileLayer&&(this.tileLayer=tileLayer(void 0,withAccessToken(this.options.tileLayer,this.options.accessToken)),this.addLayer(this.tileLayer)),this.options.featureLayer&&(this.featureLayer=featureLayer(void 0,withAccessToken(this.options.featureLayer,this.options.accessToken)),this.addLayer(this.featureLayer)),this.options.gridLayer&&(this.gridLayer=gridLayer(void 0,withAccessToken(this.options.gridLayer,this.options.accessToken)),this.addLayer(this.gridLayer)),this.options.gridLayer&&this.options.gridControl&&(this.gridControl=gridControl(this.gridLayer,this.options.gridControl),this.addControl(this.gridControl)),this.options.infoControl&&(this.infoControl=infoControl(this.options.infoControl),this.addControl(this.infoControl)),this.options.legendControl&&(this.legendControl=legendControl(this.options.legendControl),this.addControl(this.legendControl)),this.options.shareControl&&(this.shareControl=shareControl(void 0,withAccessToken(this.options.shareControl,this.options.accessToken)),this.addControl(this.shareControl)),this._mapboxLogoControl=mapboxLogoControl(this.options.mapboxLogoControl),this.addControl(this._mapboxLogoControl),this._loadTileJSON(o),this.on(\"layeradd\",this._onLayerAdd,this).on(\"layerremove\",this._onLayerRemove,this).on(\"moveend\",this._updateMapFeedbackLink,this),this.whenReady(function(){feedback.on(\"change\",this._updateMapFeedbackLink,this)}),this.on(\"unload\",function(){feedback.off(\"change\",this._updateMapFeedbackLink,this)})},_setTileJSON:function(t){return this._tilejson=t,this._initialize(t),this},getTileJSON:function(){return this._tilejson},_initialize:function(t){if(this.tileLayer&&(this.tileLayer._setTileJSON(t),this._updateLayer(this.tileLayer)),this.featureLayer&&!this.featureLayer.getGeoJSON()&&t.data&&t.data[0]&&this.featureLayer.loadURL(t.data[0]),this.gridLayer&&(this.gridLayer._setTileJSON(t),this._updateLayer(this.gridLayer)),this.infoControl&&t.attribution&&(this.infoControl.addInfo(this.options.sanitizer(t.attribution)),this._updateMapFeedbackLink()),this.legendControl&&t.legend&&this.legendControl.addLegend(t.legend),this.shareControl&&this.shareControl._setTileJSON(t),this._mapboxLogoControl._setTileJSON(t),!this._loaded&&t.center){var o=void 0!==this.getZoom()?this.getZoom():t.center[2],e=L.latLng(t.center[1],t.center[0]);this.setView(e,o)}},_updateMapFeedbackLink:function(){if(this._controlContainer.getElementsByClassName){var t=this._controlContainer.getElementsByClassName(\"mapbox-improve-map\");if(t.length&&this._loaded){var o=this.getCenter().wrap(),e=this._tilejson||{},i=e.id||\"\",n=\"#\"+i+\"/\"+o.lng.toFixed(3)+\"/\"+o.lat.toFixed(3)+\"/\"+this.getZoom();for(var r in feedback.data)n+=\"/\"+r+\"=\"+feedback.data[r];for(var a=0;a<t.length;a++)t[a].hash=n}}},_onLayerAdd:function(t){\"on\"in t.layer&&t.layer.on(\"ready\",this._onLayerReady,this),window.setTimeout(L.bind(this._updateMapFeedbackLink,this),0)},_onLayerRemove:function(t){\"on\"in t.layer&&t.layer.off(\"ready\",this._onLayerReady,this),window.setTimeout(L.bind(this._updateMapFeedbackLink,this),0)},_onLayerReady:function(t){this._updateLayer(t.target)},_updateLayer:function(t){t.options&&(this.infoControl&&this._loaded&&this.infoControl.addInfo(t.options.infoControl),this.attributionControl&&this._loaded&&t.getAttribution&&this.attributionControl.addAttribution(t.getAttribution()),L.stamp(t)in this._zoomBoundLayers||!t.options.maxZoom&&!t.options.minZoom||(this._zoomBoundLayers[L.stamp(t)]=t),this._updateMapFeedbackLink(),this._updateZoomLevels())}});module.exports.Map=LMap,module.exports.map=function(t,o,e){return new LMap(t,o,e)};\n},{\"./feature_layer\":9,\"./feedback\":10,\"./grid_control\":15,\"./grid_layer\":16,\"./info_control\":18,\"./legend_control\":20,\"./load_tilejson\":21,\"./mapbox_logo\":24,\"./share_control\":27,\"./tile_layer\":30,\"sanitize-caja\":5}],23:[function(require,module,exports){\n\"use strict\";var geocoderControl=require(\"./geocoder_control\"),gridControl=require(\"./grid_control\"),featureLayer=require(\"./feature_layer\"),legendControl=require(\"./legend_control\"),shareControl=require(\"./share_control\"),tileLayer=require(\"./tile_layer\"),infoControl=require(\"./info_control\"),map=require(\"./map\"),gridLayer=require(\"./grid_layer\"),styleLayer=require(\"./style_layer\");L.mapbox=module.exports={VERSION:require(\"../package.json\").version,geocoder:require(\"./geocoder\"),marker:require(\"./marker\"),simplestyle:require(\"./simplestyle\"),tileLayer:tileLayer.tileLayer,TileLayer:tileLayer.TileLayer,styleLayer:styleLayer.styleLayer,StyleLayer:styleLayer.StyleLayer,infoControl:infoControl.infoControl,InfoControl:infoControl.InfoControl,shareControl:shareControl.shareControl,ShareControl:shareControl.ShareControl,legendControl:legendControl.legendControl,LegendControl:legendControl.LegendControl,geocoderControl:geocoderControl.geocoderControl,GeocoderControl:geocoderControl.GeocoderControl,gridControl:gridControl.gridControl,GridControl:gridControl.GridControl,gridLayer:gridLayer.gridLayer,GridLayer:gridLayer.GridLayer,featureLayer:featureLayer.featureLayer,FeatureLayer:featureLayer.FeatureLayer,map:map.map,Map:map.Map,config:require(\"./config\"),sanitize:require(\"sanitize-caja\"),template:require(\"mustache\").to_html,feedback:require(\"./feedback\")},window.L.Icon.Default.imagePath=(\"https:\"===document.location.protocol||\"http:\"===document.location.protocol?\"\":\"https:\")+\"//api.tiles.mapbox.com/mapbox.js/v\"+require(\"../package.json\").version+\"/images\";\n},{\"../package.json\":7,\"./config\":8,\"./feature_layer\":9,\"./feedback\":10,\"./geocoder\":12,\"./geocoder_control\":13,\"./grid_control\":15,\"./grid_layer\":16,\"./info_control\":18,\"./legend_control\":20,\"./map\":22,\"./marker\":25,\"./share_control\":27,\"./simplestyle\":28,\"./style_layer\":29,\"./tile_layer\":30,\"mustache\":4,\"sanitize-caja\":5}],24:[function(require,module,exports){\n\"use strict\";var MapboxLogoControl=L.Control.extend({options:{position:\"bottomleft\"},initialize:function(o){L.setOptions(this,o)},onAdd:function(){return this._container=L.DomUtil.create(\"div\",\"mapbox-logo\"),this._container},_setTileJSON:function(o){o.mapbox_logo&&L.DomUtil.addClass(this._container,\"mapbox-logo-true\")}});module.exports.MapboxLogoControl=MapboxLogoControl,module.exports.mapboxLogoControl=function(o){return new MapboxLogoControl(o)};\n},{}],25:[function(require,module,exports){\n\"use strict\";function icon(r,e){r=r||{};var i={small:[20,50],medium:[30,70],large:[35,90]},t=r[\"marker-size\"]||\"medium\",o=\"marker-symbol\"in r&&\"\"!==r[\"marker-symbol\"]?\"-\"+r[\"marker-symbol\"]:\"\",s=(r[\"marker-color\"]||\"7e7e7e\").replace(\"#\",\"\");return L.icon({iconUrl:format_url(\"/v4/marker/pin-\"+t.charAt(0)+o+\"+\"+s+(L.Browser.retina?\"@2x\":\"\")+\".png\",e&&e.accessToken),iconSize:i[t],iconAnchor:[i[t][0]/2,i[t][1]/2],popupAnchor:[0,-i[t][1]/2]})}function style(r,e,i){return L.marker(e,{icon:icon(r.properties,i),title:util.strip_tags(sanitize(r.properties&&r.properties.title||\"\"))})}function createPopup(r,e){if(!r||!r.properties)return\"\";var i=\"\";return r.properties.title&&(i+='<div class=\"marker-title\">'+r.properties.title+\"</div>\"),r.properties.description&&(i+='<div class=\"marker-description\">'+r.properties.description+\"</div>\"),(e||sanitize)(i)}var format_url=require(\"./format_url\"),util=require(\"./util\"),sanitize=require(\"sanitize-caja\");module.exports={icon:icon,style:style,createPopup:createPopup};\n},{\"./format_url\":11,\"./util\":31,\"sanitize-caja\":5}],26:[function(require,module,exports){\n\"use strict\";var corslite=require(\"corslite\"),strict=require(\"./util\").strict,config=require(\"./config\"),protocol=/^(https?:)?(?=\\/\\/(.|api)\\.tiles\\.mapbox\\.com\\/)/;module.exports=function(t,o){function r(t,r){!t&&r&&(r=JSON.parse(r.responseText)),o(t,r)}return strict(t,\"string\"),strict(o,\"function\"),t=t.replace(protocol,function(t,o){return\"withCredentials\"in new window.XMLHttpRequest?\"https:\"===o||\"https:\"===document.location.protocol||config.FORCE_HTTPS?\"https:\":\"http:\":document.location.protocol}),corslite(t,r)};\n},{\"./config\":8,\"./util\":31,\"corslite\":1}],27:[function(require,module,exports){\n\"use strict\";var format_url=require(\"./format_url\"),ShareControl=L.Control.extend({includes:[require(\"./load_tilejson\")],options:{position:\"topleft\",url:\"\"},initialize:function(t,e){L.setOptions(this,e),this._loadTileJSON(t)},_setTileJSON:function(t){this._tilejson=t},onAdd:function(t){this._map=t;var e=L.DomUtil.create(\"div\",\"leaflet-control-mapbox-share leaflet-bar\"),o=L.DomUtil.create(\"a\",\"mapbox-share mapbox-icon mapbox-icon-share\",e);return o.href=\"#\",this._modal=L.DomUtil.create(\"div\",\"mapbox-modal\",this._map._container),this._mask=L.DomUtil.create(\"div\",\"mapbox-modal-mask\",this._modal),this._content=L.DomUtil.create(\"div\",\"mapbox-modal-content\",this._modal),L.DomEvent.addListener(o,\"click\",this._shareClick,this),L.DomEvent.disableClickPropagation(e),this._map.on(\"mousedown\",this._clickOut,this),e},_clickOut:function(t){return this._sharing?(L.DomEvent.preventDefault(t),L.DomUtil.removeClass(this._modal,\"active\"),this._content.innerHTML=\"\",void(this._sharing=null)):void 0},_shareClick:function(t){function e(t,e,o){var i=document.createElement(\"a\");return i.setAttribute(\"class\",t),i.setAttribute(\"href\",e),i.setAttribute(\"target\",\"_blank\"),o=document.createTextNode(o),i.appendChild(o),i}if(L.DomEvent.stop(t),this._sharing)return this._clickOut(t);var o=this._tilejson||this._map._tilejson||{},i=encodeURIComponent(this.options.url||o.webpage||window.location),a=encodeURIComponent(o.name),n=format_url(\"/v4/\"+o.id+\"/\"+this._map.getCenter().lng+\",\"+this._map.getCenter().lat+\",\"+this._map.getZoom()+\"/600x600.png\",this.options.accessToken),r=format_url(\"/v4/\"+o.id+\".html\",this.options.accessToken),s=\"//twitter.com/intent/tweet?status=\"+a+\" \"+i,l=\"//www.facebook.com/sharer.php?u=\"+i+\"&t=\"+a,m=\"//www.pinterest.com/pin/create/button/?url=\"+i+\"&media=\"+n+\"&description=\"+a,c='<iframe width=\"100%\" height=\"500px\" frameBorder=\"0\" src=\"'+r+'\"></iframe>',h=\"Copy and paste this <strong>HTML code</strong> into documents to embed this map on web pages.\";L.DomUtil.addClass(this._modal,\"active\"),this._sharing=L.DomUtil.create(\"div\",\"mapbox-modal-body\",this._content);var p=e(\"mapbox-button mapbox-button-icon mapbox-icon-twitter\",s,\"Twitter\"),d=e(\"mapbox-button mapbox-button-icon mapbox-icon-facebook\",l,\"Facebook\"),u=e(\"mapbox-button mapbox-button-icon mapbox-icon-pinterest\",m,\"Pinterest\"),b=document.createElement(\"h3\"),_=document.createTextNode(\"Share this map\");b.appendChild(_);var v=document.createElement(\"div\");v.setAttribute(\"class\",\"mapbox-share-buttons\"),v.appendChild(d),v.appendChild(p),v.appendChild(u),this._sharing.appendChild(b),this._sharing.appendChild(v);var x=L.DomUtil.create(\"input\",\"mapbox-embed\",this._sharing);x.type=\"text\",x.value=c;var f=L.DomUtil.create(\"label\",\"mapbox-embed-description\",this._sharing);f.innerHTML=h;var g=L.DomUtil.create(\"a\",\"leaflet-popup-close-button\",this._sharing);g.href=\"#\",L.DomEvent.disableClickPropagation(this._sharing),L.DomEvent.addListener(g,\"click\",this._clickOut,this),L.DomEvent.addListener(x,\"click\",function(t){t.target.focus(),t.target.select()})}});module.exports.ShareControl=ShareControl,module.exports.shareControl=function(t,e){return new ShareControl(t,e)};\n},{\"./format_url\":11,\"./load_tilejson\":21}],28:[function(require,module,exports){\n\"use strict\";function fallback(t,l){var i={};for(var r in l)void 0===t[r]?i[r]=l[r]:i[r]=t[r];return i}function remap(t){for(var l={},i=0;i<mapping.length;i++)l[mapping[i][1]]=t[mapping[i][0]];return l}function style(t){return remap(fallback(t.properties||{},defaults))}var defaults={stroke:\"#555555\",\"stroke-width\":2,\"stroke-opacity\":1,fill:\"#555555\",\"fill-opacity\":.5},mapping=[[\"stroke\",\"color\"],[\"stroke-width\",\"weight\"],[\"stroke-opacity\",\"opacity\"],[\"fill\",\"fillColor\"],[\"fill-opacity\",\"fillOpacity\"]];module.exports={style:style,defaults:defaults};\n},{}],29:[function(require,module,exports){\n\"use strict\";var util=require(\"./util\"),format_url=require(\"./format_url\"),request=require(\"./request\"),StyleLayer=L.TileLayer.extend({options:{sanitizer:require(\"sanitize-caja\")},initialize:function(t,i){L.TileLayer.prototype.initialize.call(this,void 0,i),this.options.tiles=this._formatTileURL(t),this.options.tileSize=512,this.options.zoomOffset=-1,this.options.tms=!1,this._getAttribution(t)},_getAttribution:function(t){var i=format_url.style(t,this.options&&this.options.accessToken);request(i,L.bind(function(e,r){e&&(util.log(\"could not load Mapbox style at \"+i),this.fire(\"error\",{error:e}));var o=[];for(var s in r.sources){var l=r.sources[s].url.split(\"mapbox://\")[1];o.push(l)}request(format_url.tileJSON(o.join(),this.options.accessToken),L.bind(function(i,e){i?(util.log(\"could not load TileJSON at \"+t),this.fire(\"error\",{error:i})):e&&(util.strict(e,\"object\"),this.options.attribution=this.options.sanitizer(e.attribution),this._tilejson=e,this.fire(\"ready\"))},this))},this))},setUrl:null,_formatTileURL:function(t){var i=L.Browser.retina?\"@2x\":\"\";if(\"string\"==typeof t){-1===t.indexOf(\"mapbox://styles/\")&&(util.log(\"Incorrectly formatted Mapbox style at \"+t),this.fire(\"error\"));var e=t.split(\"mapbox://styles/\")[1];return format_url(\"/styles/v1/\"+e+\"/tiles/{z}/{x}/{y}\"+i,this.options.accessToken)}return\"object\"==typeof t?format_url(\"/styles/v1/\"+t.owner+\"/\"+t.id+\"/tiles/{z}/{x}/{y}\"+i,this.options.accessToken):void 0},getTileUrl:function(t){var i=L.Util.template(this.options.tiles,t);return i}});module.exports.StyleLayer=StyleLayer,module.exports.styleLayer=function(t,i){return new StyleLayer(t,i)};\n},{\"./format_url\":11,\"./request\":26,\"./util\":31,\"sanitize-caja\":5}],30:[function(require,module,exports){\n\"use strict\";var util=require(\"./util\"),formatPattern=/\\.((?:png|jpg)\\d*)(?=$|\\?)/,TileLayer=L.TileLayer.extend({includes:[require(\"./load_tilejson\")],options:{sanitizer:require(\"sanitize-caja\")},formats:[\"png\",\"jpg\",\"png32\",\"png64\",\"png128\",\"png256\",\"jpg70\",\"jpg80\",\"jpg90\"],scalePrefix:\"@2x.\",initialize:function(t,i){L.TileLayer.prototype.initialize.call(this,void 0,i),this._tilejson={},i&&i.format&&util.strict_oneof(i.format,this.formats),this._loadTileJSON(t)},setFormat:function(t){return util.strict(t,\"string\"),this.options.format=t,this.redraw(),this},setUrl:null,_setTileJSON:function(t){return util.strict(t,\"object\"),this.options.format=this.options.format||t.tiles[0].match(formatPattern)[1],L.extend(this.options,{tiles:t.tiles,attribution:this.options.sanitizer(t.attribution),minZoom:t.minzoom||0,maxZoom:t.maxzoom||18,tms:\"tms\"===t.scheme,bounds:t.bounds&&util.lbounds(t.bounds)}),this._tilejson=t,this.redraw(),this},getTileJSON:function(){return this._tilejson},getTileUrl:function(t){var i=this.options.tiles,e=Math.floor(Math.abs(t.x+t.y)%i.length),o=i[e],r=L.Util.template(o,t);return r?r.replace(formatPattern,(L.Browser.retina?this.scalePrefix:\".\")+this.options.format):r},_update:function(){this.options.tiles&&L.TileLayer.prototype._update.call(this)}});module.exports.TileLayer=TileLayer,module.exports.tileLayer=function(t,i){return new TileLayer(t,i)};\n},{\"./load_tilejson\":21,\"./util\":31,\"sanitize-caja\":5}],31:[function(require,module,exports){\n\"use strict\";function contains(n,t){if(!t||!t.length)return!1;for(var r=0;r<t.length;r++)if(t[r]===n)return!0;return!1}module.exports={idUrl:function(n,t){-1===n.indexOf(\"/\")?t.loadID(n):t.loadURL(n)},log:function(n){\"object\"==typeof console&&\"function\"==typeof console.error&&console.error(n)},strict:function(n,t){if(typeof n!==t)throw new Error(\"Invalid argument: \"+t+\" expected\")},strict_instance:function(n,t,r){if(!(n instanceof t))throw new Error(\"Invalid argument: \"+r+\" expected\")},strict_oneof:function(n,t){if(!contains(n,t))throw new Error(\"Invalid argument: \"+n+\" given, valid values are \"+t.join(\", \"))},strip_tags:function(n){return n.replace(/<[^<]+>/g,\"\")},lbounds:function(n){return new L.LatLngBounds([[n[1],n[0]],[n[3],n[2]]])}};\n},{}]},{},[17])\n\n\n//# sourceMappingURL=mapbox.js.map"

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(157))

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = "/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */\n!function(e,t){\"use strict\";\"object\"==typeof module&&\"object\"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error(\"jQuery requires a window with a document\");return t(e)}:t(e)}(\"undefined\"!=typeof window?window:this,function(e,t){\"use strict\";var n=[],r=e.document,i=Object.getPrototypeOf,o=n.slice,a=n.concat,s=n.push,u=n.indexOf,l={},c=l.toString,f=l.hasOwnProperty,p=f.toString,d=p.call(Object),h={},g=function e(t){return\"function\"==typeof t&&\"number\"!=typeof t.nodeType},y=function e(t){return null!=t&&t===t.window},v={type:!0,src:!0,noModule:!0};function m(e,t,n){var i,o=(t=t||r).createElement(\"script\");if(o.text=e,n)for(i in v)n[i]&&(o[i]=n[i]);t.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+\"\":\"object\"==typeof e||\"function\"==typeof e?l[c.call(e)]||\"object\":typeof e}var b=\"3.3.1\",w=function(e,t){return new w.fn.init(e,t)},T=/^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g;w.fn=w.prototype={jquery:\"3.3.1\",constructor:w,length:0,toArray:function(){return o.call(this)},get:function(e){return null==e?o.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=w.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return w.each(this,e)},map:function(e){return this.pushStack(w.map(this,function(t,n){return e.call(t,n,t)}))},slice:function(){return this.pushStack(o.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:n.sort,splice:n.splice},w.extend=w.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for(\"boolean\"==typeof a&&(l=a,a=arguments[s]||{},s++),\"object\"==typeof a||g(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)n=a[t],a!==(r=e[t])&&(l&&r&&(w.isPlainObject(r)||(i=Array.isArray(r)))?(i?(i=!1,o=n&&Array.isArray(n)?n:[]):o=n&&w.isPlainObject(n)?n:{},a[t]=w.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},w.extend({expando:\"jQuery\"+(\"3.3.1\"+Math.random()).replace(/\\D/g,\"\"),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||\"[object Object]\"!==c.call(e))&&(!(t=i(e))||\"function\"==typeof(n=f.call(t,\"constructor\")&&t.constructor)&&p.call(n)===d)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e){m(e)},each:function(e,t){var n,r=0;if(C(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},trim:function(e){return null==e?\"\":(e+\"\").replace(T,\"\")},makeArray:function(e,t){var n=t||[];return null!=e&&(C(Object(e))?w.merge(n,\"string\"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:u.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r,i=[],o=0,a=e.length,s=!n;o<a;o++)(r=!t(e[o],o))!==s&&i.push(e[o]);return i},map:function(e,t,n){var r,i,o=0,s=[];if(C(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&s.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&s.push(i);return a.apply([],s)},guid:1,support:h}),\"function\"==typeof Symbol&&(w.fn[Symbol.iterator]=n[Symbol.iterator]),w.each(\"Boolean Number String Function Array Date RegExp Object Error Symbol\".split(\" \"),function(e,t){l[\"[object \"+t+\"]\"]=t.toLowerCase()});function C(e){var t=!!e&&\"length\"in e&&e.length,n=x(e);return!g(e)&&!y(e)&&(\"array\"===n||0===t||\"number\"==typeof t&&t>0&&t-1 in e)}var E=function(e){var t,n,r,i,o,a,s,u,l,c,f,p,d,h,g,y,v,m,x,b=\"sizzle\"+1*new Date,w=e.document,T=0,C=0,E=ae(),k=ae(),S=ae(),D=function(e,t){return e===t&&(f=!0),0},N={}.hasOwnProperty,A=[],j=A.pop,q=A.push,L=A.push,H=A.slice,O=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},P=\"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped\",M=\"[\\\\x20\\\\t\\\\r\\\\n\\\\f]\",R=\"(?:\\\\\\\\.|[\\\\w-]|[^\\0-\\\\xa0])+\",I=\"\\\\[\"+M+\"*(\"+R+\")(?:\"+M+\"*([*^$|!~]?=)\"+M+\"*(?:'((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\"|(\"+R+\"))|)\"+M+\"*\\\\]\",W=\":(\"+R+\")(?:\\\\((('((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\")|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|\"+I+\")*)|.*)\\\\)|)\",$=new RegExp(M+\"+\",\"g\"),B=new RegExp(\"^\"+M+\"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)\"+M+\"+$\",\"g\"),F=new RegExp(\"^\"+M+\"*,\"+M+\"*\"),_=new RegExp(\"^\"+M+\"*([>+~]|\"+M+\")\"+M+\"*\"),z=new RegExp(\"=\"+M+\"*([^\\\\]'\\\"]*?)\"+M+\"*\\\\]\",\"g\"),X=new RegExp(W),U=new RegExp(\"^\"+R+\"$\"),V={ID:new RegExp(\"^#(\"+R+\")\"),CLASS:new RegExp(\"^\\\\.(\"+R+\")\"),TAG:new RegExp(\"^(\"+R+\"|[*])\"),ATTR:new RegExp(\"^\"+I),PSEUDO:new RegExp(\"^\"+W),CHILD:new RegExp(\"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\(\"+M+\"*(even|odd|(([+-]|)(\\\\d*)n|)\"+M+\"*(?:([+-]|)\"+M+\"*(\\\\d+)|))\"+M+\"*\\\\)|)\",\"i\"),bool:new RegExp(\"^(?:\"+P+\")$\",\"i\"),needsContext:new RegExp(\"^\"+M+\"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\(\"+M+\"*((?:-\\\\d)?\\\\d*)\"+M+\"*\\\\)|)(?=[^-]|$)\",\"i\")},G=/^(?:input|select|textarea|button)$/i,Y=/^h\\d$/i,Q=/^[^{]+\\{\\s*\\[native \\w/,J=/^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,K=/[+~]/,Z=new RegExp(\"\\\\\\\\([\\\\da-f]{1,6}\"+M+\"?|(\"+M+\")|.)\",\"ig\"),ee=function(e,t,n){var r=\"0x\"+t-65536;return r!==r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320)},te=/([\\0-\\x1f\\x7f]|^-?\\d)|^-$|[^\\0-\\x1f\\x7f-\\uFFFF\\w-]/g,ne=function(e,t){return t?\"\\0\"===e?\"\\ufffd\":e.slice(0,-1)+\"\\\\\"+e.charCodeAt(e.length-1).toString(16)+\" \":\"\\\\\"+e},re=function(){p()},ie=me(function(e){return!0===e.disabled&&(\"form\"in e||\"label\"in e)},{dir:\"parentNode\",next:\"legend\"});try{L.apply(A=H.call(w.childNodes),w.childNodes),A[w.childNodes.length].nodeType}catch(e){L={apply:A.length?function(e,t){q.apply(e,H.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function oe(e,t,r,i){var o,s,l,c,f,h,v,m=t&&t.ownerDocument,T=t?t.nodeType:9;if(r=r||[],\"string\"!=typeof e||!e||1!==T&&9!==T&&11!==T)return r;if(!i&&((t?t.ownerDocument||t:w)!==d&&p(t),t=t||d,g)){if(11!==T&&(f=J.exec(e)))if(o=f[1]){if(9===T){if(!(l=t.getElementById(o)))return r;if(l.id===o)return r.push(l),r}else if(m&&(l=m.getElementById(o))&&x(t,l)&&l.id===o)return r.push(l),r}else{if(f[2])return L.apply(r,t.getElementsByTagName(e)),r;if((o=f[3])&&n.getElementsByClassName&&t.getElementsByClassName)return L.apply(r,t.getElementsByClassName(o)),r}if(n.qsa&&!S[e+\" \"]&&(!y||!y.test(e))){if(1!==T)m=t,v=e;else if(\"object\"!==t.nodeName.toLowerCase()){(c=t.getAttribute(\"id\"))?c=c.replace(te,ne):t.setAttribute(\"id\",c=b),s=(h=a(e)).length;while(s--)h[s]=\"#\"+c+\" \"+ve(h[s]);v=h.join(\",\"),m=K.test(e)&&ge(t.parentNode)||t}if(v)try{return L.apply(r,m.querySelectorAll(v)),r}catch(e){}finally{c===b&&t.removeAttribute(\"id\")}}}return u(e.replace(B,\"$1\"),t,r,i)}function ae(){var e=[];function t(n,i){return e.push(n+\" \")>r.cacheLength&&delete t[e.shift()],t[n+\" \"]=i}return t}function se(e){return e[b]=!0,e}function ue(e){var t=d.createElement(\"fieldset\");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function le(e,t){var n=e.split(\"|\"),i=n.length;while(i--)r.attrHandle[n[i]]=t}function ce(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function fe(e){return function(t){return\"input\"===t.nodeName.toLowerCase()&&t.type===e}}function pe(e){return function(t){var n=t.nodeName.toLowerCase();return(\"input\"===n||\"button\"===n)&&t.type===e}}function de(e){return function(t){return\"form\"in t?t.parentNode&&!1===t.disabled?\"label\"in t?\"label\"in t.parentNode?t.parentNode.disabled===e:t.disabled===e:t.isDisabled===e||t.isDisabled!==!e&&ie(t)===e:t.disabled===e:\"label\"in t&&t.disabled===e}}function he(e){return se(function(t){return t=+t,se(function(n,r){var i,o=e([],n.length,t),a=o.length;while(a--)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}function ge(e){return e&&\"undefined\"!=typeof e.getElementsByTagName&&e}n=oe.support={},o=oe.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return!!t&&\"HTML\"!==t.nodeName},p=oe.setDocument=function(e){var t,i,a=e?e.ownerDocument||e:w;return a!==d&&9===a.nodeType&&a.documentElement?(d=a,h=d.documentElement,g=!o(d),w!==d&&(i=d.defaultView)&&i.top!==i&&(i.addEventListener?i.addEventListener(\"unload\",re,!1):i.attachEvent&&i.attachEvent(\"onunload\",re)),n.attributes=ue(function(e){return e.className=\"i\",!e.getAttribute(\"className\")}),n.getElementsByTagName=ue(function(e){return e.appendChild(d.createComment(\"\")),!e.getElementsByTagName(\"*\").length}),n.getElementsByClassName=Q.test(d.getElementsByClassName),n.getById=ue(function(e){return h.appendChild(e).id=b,!d.getElementsByName||!d.getElementsByName(b).length}),n.getById?(r.filter.ID=function(e){var t=e.replace(Z,ee);return function(e){return e.getAttribute(\"id\")===t}},r.find.ID=function(e,t){if(\"undefined\"!=typeof t.getElementById&&g){var n=t.getElementById(e);return n?[n]:[]}}):(r.filter.ID=function(e){var t=e.replace(Z,ee);return function(e){var n=\"undefined\"!=typeof e.getAttributeNode&&e.getAttributeNode(\"id\");return n&&n.value===t}},r.find.ID=function(e,t){if(\"undefined\"!=typeof t.getElementById&&g){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode(\"id\"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode(\"id\"))&&n.value===e)return[o]}return[]}}),r.find.TAG=n.getElementsByTagName?function(e,t){return\"undefined\"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):n.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if(\"*\"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},r.find.CLASS=n.getElementsByClassName&&function(e,t){if(\"undefined\"!=typeof t.getElementsByClassName&&g)return t.getElementsByClassName(e)},v=[],y=[],(n.qsa=Q.test(d.querySelectorAll))&&(ue(function(e){h.appendChild(e).innerHTML=\"<a id='\"+b+\"'></a><select id='\"+b+\"-\\r\\\\' msallowcapture=''><option selected=''></option></select>\",e.querySelectorAll(\"[msallowcapture^='']\").length&&y.push(\"[*^$]=\"+M+\"*(?:''|\\\"\\\")\"),e.querySelectorAll(\"[selected]\").length||y.push(\"\\\\[\"+M+\"*(?:value|\"+P+\")\"),e.querySelectorAll(\"[id~=\"+b+\"-]\").length||y.push(\"~=\"),e.querySelectorAll(\":checked\").length||y.push(\":checked\"),e.querySelectorAll(\"a#\"+b+\"+*\").length||y.push(\".#.+[+~]\")}),ue(function(e){e.innerHTML=\"<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>\";var t=d.createElement(\"input\");t.setAttribute(\"type\",\"hidden\"),e.appendChild(t).setAttribute(\"name\",\"D\"),e.querySelectorAll(\"[name=d]\").length&&y.push(\"name\"+M+\"*[*^$|!~]?=\"),2!==e.querySelectorAll(\":enabled\").length&&y.push(\":enabled\",\":disabled\"),h.appendChild(e).disabled=!0,2!==e.querySelectorAll(\":disabled\").length&&y.push(\":enabled\",\":disabled\"),e.querySelectorAll(\"*,:x\"),y.push(\",.*:\")})),(n.matchesSelector=Q.test(m=h.matches||h.webkitMatchesSelector||h.mozMatchesSelector||h.oMatchesSelector||h.msMatchesSelector))&&ue(function(e){n.disconnectedMatch=m.call(e,\"*\"),m.call(e,\"[s!='']:x\"),v.push(\"!=\",W)}),y=y.length&&new RegExp(y.join(\"|\")),v=v.length&&new RegExp(v.join(\"|\")),t=Q.test(h.compareDocumentPosition),x=t||Q.test(h.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},D=t?function(e,t){if(e===t)return f=!0,0;var r=!e.compareDocumentPosition-!t.compareDocumentPosition;return r||(1&(r=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!n.sortDetached&&t.compareDocumentPosition(e)===r?e===d||e.ownerDocument===w&&x(w,e)?-1:t===d||t.ownerDocument===w&&x(w,t)?1:c?O(c,e)-O(c,t):0:4&r?-1:1)}:function(e,t){if(e===t)return f=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e===d?-1:t===d?1:i?-1:o?1:c?O(c,e)-O(c,t):0;if(i===o)return ce(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?ce(a[r],s[r]):a[r]===w?-1:s[r]===w?1:0},d):d},oe.matches=function(e,t){return oe(e,null,null,t)},oe.matchesSelector=function(e,t){if((e.ownerDocument||e)!==d&&p(e),t=t.replace(z,\"='$1']\"),n.matchesSelector&&g&&!S[t+\" \"]&&(!v||!v.test(t))&&(!y||!y.test(t)))try{var r=m.call(e,t);if(r||n.disconnectedMatch||e.document&&11!==e.document.nodeType)return r}catch(e){}return oe(t,d,null,[e]).length>0},oe.contains=function(e,t){return(e.ownerDocument||e)!==d&&p(e),x(e,t)},oe.attr=function(e,t){(e.ownerDocument||e)!==d&&p(e);var i=r.attrHandle[t.toLowerCase()],o=i&&N.call(r.attrHandle,t.toLowerCase())?i(e,t,!g):void 0;return void 0!==o?o:n.attributes||!g?e.getAttribute(t):(o=e.getAttributeNode(t))&&o.specified?o.value:null},oe.escape=function(e){return(e+\"\").replace(te,ne)},oe.error=function(e){throw new Error(\"Syntax error, unrecognized expression: \"+e)},oe.uniqueSort=function(e){var t,r=[],i=0,o=0;if(f=!n.detectDuplicates,c=!n.sortStable&&e.slice(0),e.sort(D),f){while(t=e[o++])t===e[o]&&(i=r.push(o));while(i--)e.splice(r[i],1)}return c=null,e},i=oe.getText=function(e){var t,n=\"\",r=0,o=e.nodeType;if(o){if(1===o||9===o||11===o){if(\"string\"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=i(e)}else if(3===o||4===o)return e.nodeValue}else while(t=e[r++])n+=i(t);return n},(r=oe.selectors={cacheLength:50,createPseudo:se,match:V,attrHandle:{},find:{},relative:{\">\":{dir:\"parentNode\",first:!0},\" \":{dir:\"parentNode\"},\"+\":{dir:\"previousSibling\",first:!0},\"~\":{dir:\"previousSibling\"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(Z,ee),e[3]=(e[3]||e[4]||e[5]||\"\").replace(Z,ee),\"~=\"===e[2]&&(e[3]=\" \"+e[3]+\" \"),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),\"nth\"===e[1].slice(0,3)?(e[3]||oe.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*(\"even\"===e[3]||\"odd\"===e[3])),e[5]=+(e[7]+e[8]||\"odd\"===e[3])):e[3]&&oe.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return V.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||\"\":n&&X.test(n)&&(t=a(n,!0))&&(t=n.indexOf(\")\",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(Z,ee).toLowerCase();return\"*\"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=E[e+\" \"];return t||(t=new RegExp(\"(^|\"+M+\")\"+e+\"(\"+M+\"|$)\"))&&E(e,function(e){return t.test(\"string\"==typeof e.className&&e.className||\"undefined\"!=typeof e.getAttribute&&e.getAttribute(\"class\")||\"\")})},ATTR:function(e,t,n){return function(r){var i=oe.attr(r,e);return null==i?\"!=\"===t:!t||(i+=\"\",\"=\"===t?i===n:\"!=\"===t?i!==n:\"^=\"===t?n&&0===i.indexOf(n):\"*=\"===t?n&&i.indexOf(n)>-1:\"$=\"===t?n&&i.slice(-n.length)===n:\"~=\"===t?(\" \"+i.replace($,\" \")+\" \").indexOf(n)>-1:\"|=\"===t&&(i===n||i.slice(0,n.length+1)===n+\"-\"))}},CHILD:function(e,t,n,r,i){var o=\"nth\"!==e.slice(0,3),a=\"last\"!==e.slice(-4),s=\"of-type\"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,u){var l,c,f,p,d,h,g=o!==a?\"nextSibling\":\"previousSibling\",y=t.parentNode,v=s&&t.nodeName.toLowerCase(),m=!u&&!s,x=!1;if(y){if(o){while(g){p=t;while(p=p[g])if(s?p.nodeName.toLowerCase()===v:1===p.nodeType)return!1;h=g=\"only\"===e&&!h&&\"nextSibling\"}return!0}if(h=[a?y.firstChild:y.lastChild],a&&m){x=(d=(l=(c=(f=(p=y)[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]||[])[0]===T&&l[1])&&l[2],p=d&&y.childNodes[d];while(p=++d&&p&&p[g]||(x=d=0)||h.pop())if(1===p.nodeType&&++x&&p===t){c[e]=[T,d,x];break}}else if(m&&(x=d=(l=(c=(f=(p=t)[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]||[])[0]===T&&l[1]),!1===x)while(p=++d&&p&&p[g]||(x=d=0)||h.pop())if((s?p.nodeName.toLowerCase()===v:1===p.nodeType)&&++x&&(m&&((c=(f=p[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]=[T,x]),p===t))break;return(x-=i)===r||x%r==0&&x/r>=0}}},PSEUDO:function(e,t){var n,i=r.pseudos[e]||r.setFilters[e.toLowerCase()]||oe.error(\"unsupported pseudo: \"+e);return i[b]?i(t):i.length>1?(n=[e,e,\"\",t],r.setFilters.hasOwnProperty(e.toLowerCase())?se(function(e,n){var r,o=i(e,t),a=o.length;while(a--)e[r=O(e,o[a])]=!(n[r]=o[a])}):function(e){return i(e,0,n)}):i}},pseudos:{not:se(function(e){var t=[],n=[],r=s(e.replace(B,\"$1\"));return r[b]?se(function(e,t,n,i){var o,a=r(e,null,i,[]),s=e.length;while(s--)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),t[0]=null,!n.pop()}}),has:se(function(e){return function(t){return oe(e,t).length>0}}),contains:se(function(e){return e=e.replace(Z,ee),function(t){return(t.textContent||t.innerText||i(t)).indexOf(e)>-1}}),lang:se(function(e){return U.test(e||\"\")||oe.error(\"unsupported lang: \"+e),e=e.replace(Z,ee).toLowerCase(),function(t){var n;do{if(n=g?t.lang:t.getAttribute(\"xml:lang\")||t.getAttribute(\"lang\"))return(n=n.toLowerCase())===e||0===n.indexOf(e+\"-\")}while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===h},focus:function(e){return e===d.activeElement&&(!d.hasFocus||d.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:de(!1),disabled:de(!0),checked:function(e){var t=e.nodeName.toLowerCase();return\"input\"===t&&!!e.checked||\"option\"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!r.pseudos.empty(e)},header:function(e){return Y.test(e.nodeName)},input:function(e){return G.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return\"input\"===t&&\"button\"===e.type||\"button\"===t},text:function(e){var t;return\"input\"===e.nodeName.toLowerCase()&&\"text\"===e.type&&(null==(t=e.getAttribute(\"type\"))||\"text\"===t.toLowerCase())},first:he(function(){return[0]}),last:he(function(e,t){return[t-1]}),eq:he(function(e,t,n){return[n<0?n+t:n]}),even:he(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:he(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:he(function(e,t,n){for(var r=n<0?n+t:n;--r>=0;)e.push(r);return e}),gt:he(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=r.pseudos.eq;for(t in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})r.pseudos[t]=fe(t);for(t in{submit:!0,reset:!0})r.pseudos[t]=pe(t);function ye(){}ye.prototype=r.filters=r.pseudos,r.setFilters=new ye,a=oe.tokenize=function(e,t){var n,i,o,a,s,u,l,c=k[e+\" \"];if(c)return t?0:c.slice(0);s=e,u=[],l=r.preFilter;while(s){n&&!(i=F.exec(s))||(i&&(s=s.slice(i[0].length)||s),u.push(o=[])),n=!1,(i=_.exec(s))&&(n=i.shift(),o.push({value:n,type:i[0].replace(B,\" \")}),s=s.slice(n.length));for(a in r.filter)!(i=V[a].exec(s))||l[a]&&!(i=l[a](i))||(n=i.shift(),o.push({value:n,type:a,matches:i}),s=s.slice(n.length));if(!n)break}return t?s.length:s?oe.error(e):k(e,u).slice(0)};function ve(e){for(var t=0,n=e.length,r=\"\";t<n;t++)r+=e[t].value;return r}function me(e,t,n){var r=t.dir,i=t.next,o=i||r,a=n&&\"parentNode\"===o,s=C++;return t.first?function(t,n,i){while(t=t[r])if(1===t.nodeType||a)return e(t,n,i);return!1}:function(t,n,u){var l,c,f,p=[T,s];if(u){while(t=t[r])if((1===t.nodeType||a)&&e(t,n,u))return!0}else while(t=t[r])if(1===t.nodeType||a)if(f=t[b]||(t[b]={}),c=f[t.uniqueID]||(f[t.uniqueID]={}),i&&i===t.nodeName.toLowerCase())t=t[r]||t;else{if((l=c[o])&&l[0]===T&&l[1]===s)return p[2]=l[2];if(c[o]=p,p[2]=e(t,n,u))return!0}return!1}}function xe(e){return e.length>1?function(t,n,r){var i=e.length;while(i--)if(!e[i](t,n,r))return!1;return!0}:e[0]}function be(e,t,n){for(var r=0,i=t.length;r<i;r++)oe(e,t[r],n);return n}function we(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Te(e,t,n,r,i,o){return r&&!r[b]&&(r=Te(r)),i&&!i[b]&&(i=Te(i,o)),se(function(o,a,s,u){var l,c,f,p=[],d=[],h=a.length,g=o||be(t||\"*\",s.nodeType?[s]:s,[]),y=!e||!o&&t?g:we(g,p,e,s,u),v=n?i||(o?e:h||r)?[]:a:y;if(n&&n(y,v,s,u),r){l=we(v,d),r(l,[],s,u),c=l.length;while(c--)(f=l[c])&&(v[d[c]]=!(y[d[c]]=f))}if(o){if(i||e){if(i){l=[],c=v.length;while(c--)(f=v[c])&&l.push(y[c]=f);i(null,v=[],l,u)}c=v.length;while(c--)(f=v[c])&&(l=i?O(o,f):p[c])>-1&&(o[l]=!(a[l]=f))}}else v=we(v===a?v.splice(h,v.length):v),i?i(null,a,v,u):L.apply(a,v)})}function Ce(e){for(var t,n,i,o=e.length,a=r.relative[e[0].type],s=a||r.relative[\" \"],u=a?1:0,c=me(function(e){return e===t},s,!0),f=me(function(e){return O(t,e)>-1},s,!0),p=[function(e,n,r){var i=!a&&(r||n!==l)||((t=n).nodeType?c(e,n,r):f(e,n,r));return t=null,i}];u<o;u++)if(n=r.relative[e[u].type])p=[me(xe(p),n)];else{if((n=r.filter[e[u].type].apply(null,e[u].matches))[b]){for(i=++u;i<o;i++)if(r.relative[e[i].type])break;return Te(u>1&&xe(p),u>1&&ve(e.slice(0,u-1).concat({value:\" \"===e[u-2].type?\"*\":\"\"})).replace(B,\"$1\"),n,u<i&&Ce(e.slice(u,i)),i<o&&Ce(e=e.slice(i)),i<o&&ve(e))}p.push(n)}return xe(p)}function Ee(e,t){var n=t.length>0,i=e.length>0,o=function(o,a,s,u,c){var f,h,y,v=0,m=\"0\",x=o&&[],b=[],w=l,C=o||i&&r.find.TAG(\"*\",c),E=T+=null==w?1:Math.random()||.1,k=C.length;for(c&&(l=a===d||a||c);m!==k&&null!=(f=C[m]);m++){if(i&&f){h=0,a||f.ownerDocument===d||(p(f),s=!g);while(y=e[h++])if(y(f,a||d,s)){u.push(f);break}c&&(T=E)}n&&((f=!y&&f)&&v--,o&&x.push(f))}if(v+=m,n&&m!==v){h=0;while(y=t[h++])y(x,b,a,s);if(o){if(v>0)while(m--)x[m]||b[m]||(b[m]=j.call(u));b=we(b)}L.apply(u,b),c&&!o&&b.length>0&&v+t.length>1&&oe.uniqueSort(u)}return c&&(T=E,l=w),x};return n?se(o):o}return s=oe.compile=function(e,t){var n,r=[],i=[],o=S[e+\" \"];if(!o){t||(t=a(e)),n=t.length;while(n--)(o=Ce(t[n]))[b]?r.push(o):i.push(o);(o=S(e,Ee(i,r))).selector=e}return o},u=oe.select=function(e,t,n,i){var o,u,l,c,f,p=\"function\"==typeof e&&e,d=!i&&a(e=p.selector||e);if(n=n||[],1===d.length){if((u=d[0]=d[0].slice(0)).length>2&&\"ID\"===(l=u[0]).type&&9===t.nodeType&&g&&r.relative[u[1].type]){if(!(t=(r.find.ID(l.matches[0].replace(Z,ee),t)||[])[0]))return n;p&&(t=t.parentNode),e=e.slice(u.shift().value.length)}o=V.needsContext.test(e)?0:u.length;while(o--){if(l=u[o],r.relative[c=l.type])break;if((f=r.find[c])&&(i=f(l.matches[0].replace(Z,ee),K.test(u[0].type)&&ge(t.parentNode)||t))){if(u.splice(o,1),!(e=i.length&&ve(u)))return L.apply(n,i),n;break}}}return(p||s(e,d))(i,t,!g,n,!t||K.test(e)&&ge(t.parentNode)||t),n},n.sortStable=b.split(\"\").sort(D).join(\"\")===b,n.detectDuplicates=!!f,p(),n.sortDetached=ue(function(e){return 1&e.compareDocumentPosition(d.createElement(\"fieldset\"))}),ue(function(e){return e.innerHTML=\"<a href='#'></a>\",\"#\"===e.firstChild.getAttribute(\"href\")})||le(\"type|href|height|width\",function(e,t,n){if(!n)return e.getAttribute(t,\"type\"===t.toLowerCase()?1:2)}),n.attributes&&ue(function(e){return e.innerHTML=\"<input/>\",e.firstChild.setAttribute(\"value\",\"\"),\"\"===e.firstChild.getAttribute(\"value\")})||le(\"value\",function(e,t,n){if(!n&&\"input\"===e.nodeName.toLowerCase())return e.defaultValue}),ue(function(e){return null==e.getAttribute(\"disabled\")})||le(P,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),oe}(e);w.find=E,w.expr=E.selectors,w.expr[\":\"]=w.expr.pseudos,w.uniqueSort=w.unique=E.uniqueSort,w.text=E.getText,w.isXMLDoc=E.isXML,w.contains=E.contains,w.escapeSelector=E.escape;var k=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&w(e).is(n))break;r.push(e)}return r},S=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},D=w.expr.match.needsContext;function N(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var A=/^<([a-z][^\\/\\0>:\\x20\\t\\r\\n\\f]*)[\\x20\\t\\r\\n\\f]*\\/?>(?:<\\/\\1>|)$/i;function j(e,t,n){return g(t)?w.grep(e,function(e,r){return!!t.call(e,r,e)!==n}):t.nodeType?w.grep(e,function(e){return e===t!==n}):\"string\"!=typeof t?w.grep(e,function(e){return u.call(t,e)>-1!==n}):w.filter(t,e,n)}w.filter=function(e,t,n){var r=t[0];return n&&(e=\":not(\"+e+\")\"),1===t.length&&1===r.nodeType?w.find.matchesSelector(r,e)?[r]:[]:w.find.matches(e,w.grep(t,function(e){return 1===e.nodeType}))},w.fn.extend({find:function(e){var t,n,r=this.length,i=this;if(\"string\"!=typeof e)return this.pushStack(w(e).filter(function(){for(t=0;t<r;t++)if(w.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)w.find(e,i[t],n);return r>1?w.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,\"string\"==typeof e&&D.test(e)?w(e):e||[],!1).length}});var q,L=/^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]+))$/;(w.fn.init=function(e,t,n){var i,o;if(!e)return this;if(n=n||q,\"string\"==typeof e){if(!(i=\"<\"===e[0]&&\">\"===e[e.length-1]&&e.length>=3?[null,e,null]:L.exec(e))||!i[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(i[1]){if(t=t instanceof w?t[0]:t,w.merge(this,w.parseHTML(i[1],t&&t.nodeType?t.ownerDocument||t:r,!0)),A.test(i[1])&&w.isPlainObject(t))for(i in t)g(this[i])?this[i](t[i]):this.attr(i,t[i]);return this}return(o=r.getElementById(i[2]))&&(this[0]=o,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):g(e)?void 0!==n.ready?n.ready(e):e(w):w.makeArray(e,this)}).prototype=w.fn,q=w(r);var H=/^(?:parents|prev(?:Until|All))/,O={children:!0,contents:!0,next:!0,prev:!0};w.fn.extend({has:function(e){var t=w(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(w.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a=\"string\"!=typeof e&&w(e);if(!D.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?a.index(n)>-1:1===n.nodeType&&w.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(o.length>1?w.uniqueSort(o):o)},index:function(e){return e?\"string\"==typeof e?u.call(w(e),this[0]):u.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(w.uniqueSort(w.merge(this.get(),w(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}});function P(e,t){while((e=e[t])&&1!==e.nodeType);return e}w.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return k(e,\"parentNode\")},parentsUntil:function(e,t,n){return k(e,\"parentNode\",n)},next:function(e){return P(e,\"nextSibling\")},prev:function(e){return P(e,\"previousSibling\")},nextAll:function(e){return k(e,\"nextSibling\")},prevAll:function(e){return k(e,\"previousSibling\")},nextUntil:function(e,t,n){return k(e,\"nextSibling\",n)},prevUntil:function(e,t,n){return k(e,\"previousSibling\",n)},siblings:function(e){return S((e.parentNode||{}).firstChild,e)},children:function(e){return S(e.firstChild)},contents:function(e){return N(e,\"iframe\")?e.contentDocument:(N(e,\"template\")&&(e=e.content||e),w.merge([],e.childNodes))}},function(e,t){w.fn[e]=function(n,r){var i=w.map(this,t,n);return\"Until\"!==e.slice(-5)&&(r=n),r&&\"string\"==typeof r&&(i=w.filter(r,i)),this.length>1&&(O[e]||w.uniqueSort(i),H.test(e)&&i.reverse()),this.pushStack(i)}});var M=/[^\\x20\\t\\r\\n\\f]+/g;function R(e){var t={};return w.each(e.match(M)||[],function(e,n){t[n]=!0}),t}w.Callbacks=function(e){e=\"string\"==typeof e?R(e):w.extend({},e);var t,n,r,i,o=[],a=[],s=-1,u=function(){for(i=i||e.once,r=t=!0;a.length;s=-1){n=a.shift();while(++s<o.length)!1===o[s].apply(n[0],n[1])&&e.stopOnFalse&&(s=o.length,n=!1)}e.memory||(n=!1),t=!1,i&&(o=n?[]:\"\")},l={add:function(){return o&&(n&&!t&&(s=o.length-1,a.push(n)),function t(n){w.each(n,function(n,r){g(r)?e.unique&&l.has(r)||o.push(r):r&&r.length&&\"string\"!==x(r)&&t(r)})}(arguments),n&&!t&&u()),this},remove:function(){return w.each(arguments,function(e,t){var n;while((n=w.inArray(t,o,n))>-1)o.splice(n,1),n<=s&&s--}),this},has:function(e){return e?w.inArray(e,o)>-1:o.length>0},empty:function(){return o&&(o=[]),this},disable:function(){return i=a=[],o=n=\"\",this},disabled:function(){return!o},lock:function(){return i=a=[],n||t||(o=n=\"\"),this},locked:function(){return!!i},fireWith:function(e,n){return i||(n=[e,(n=n||[]).slice?n.slice():n],a.push(n),t||u()),this},fire:function(){return l.fireWith(this,arguments),this},fired:function(){return!!r}};return l};function I(e){return e}function W(e){throw e}function $(e,t,n,r){var i;try{e&&g(i=e.promise)?i.call(e).done(t).fail(n):e&&g(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}w.extend({Deferred:function(t){var n=[[\"notify\",\"progress\",w.Callbacks(\"memory\"),w.Callbacks(\"memory\"),2],[\"resolve\",\"done\",w.Callbacks(\"once memory\"),w.Callbacks(\"once memory\"),0,\"resolved\"],[\"reject\",\"fail\",w.Callbacks(\"once memory\"),w.Callbacks(\"once memory\"),1,\"rejected\"]],r=\"pending\",i={state:function(){return r},always:function(){return o.done(arguments).fail(arguments),this},\"catch\":function(e){return i.then(null,e)},pipe:function(){var e=arguments;return w.Deferred(function(t){w.each(n,function(n,r){var i=g(e[r[4]])&&e[r[4]];o[r[1]](function(){var e=i&&i.apply(this,arguments);e&&g(e.promise)?e.promise().progress(t.notify).done(t.resolve).fail(t.reject):t[r[0]+\"With\"](this,i?[e]:arguments)})}),e=null}).promise()},then:function(t,r,i){var o=0;function a(t,n,r,i){return function(){var s=this,u=arguments,l=function(){var e,l;if(!(t<o)){if((e=r.apply(s,u))===n.promise())throw new TypeError(\"Thenable self-resolution\");l=e&&(\"object\"==typeof e||\"function\"==typeof e)&&e.then,g(l)?i?l.call(e,a(o,n,I,i),a(o,n,W,i)):(o++,l.call(e,a(o,n,I,i),a(o,n,W,i),a(o,n,I,n.notifyWith))):(r!==I&&(s=void 0,u=[e]),(i||n.resolveWith)(s,u))}},c=i?l:function(){try{l()}catch(e){w.Deferred.exceptionHook&&w.Deferred.exceptionHook(e,c.stackTrace),t+1>=o&&(r!==W&&(s=void 0,u=[e]),n.rejectWith(s,u))}};t?c():(w.Deferred.getStackHook&&(c.stackTrace=w.Deferred.getStackHook()),e.setTimeout(c))}}return w.Deferred(function(e){n[0][3].add(a(0,e,g(i)?i:I,e.notifyWith)),n[1][3].add(a(0,e,g(t)?t:I)),n[2][3].add(a(0,e,g(r)?r:W))}).promise()},promise:function(e){return null!=e?w.extend(e,i):i}},o={};return w.each(n,function(e,t){var a=t[2],s=t[5];i[t[1]]=a.add,s&&a.add(function(){r=s},n[3-e][2].disable,n[3-e][3].disable,n[0][2].lock,n[0][3].lock),a.add(t[3].fire),o[t[0]]=function(){return o[t[0]+\"With\"](this===o?void 0:this,arguments),this},o[t[0]+\"With\"]=a.fireWith}),i.promise(o),t&&t.call(o,o),o},when:function(e){var t=arguments.length,n=t,r=Array(n),i=o.call(arguments),a=w.Deferred(),s=function(e){return function(n){r[e]=this,i[e]=arguments.length>1?o.call(arguments):n,--t||a.resolveWith(r,i)}};if(t<=1&&($(e,a.done(s(n)).resolve,a.reject,!t),\"pending\"===a.state()||g(i[n]&&i[n].then)))return a.then();while(n--)$(i[n],s(n),a.reject);return a.promise()}});var B=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;w.Deferred.exceptionHook=function(t,n){e.console&&e.console.warn&&t&&B.test(t.name)&&e.console.warn(\"jQuery.Deferred exception: \"+t.message,t.stack,n)},w.readyException=function(t){e.setTimeout(function(){throw t})};var F=w.Deferred();w.fn.ready=function(e){return F.then(e)[\"catch\"](function(e){w.readyException(e)}),this},w.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--w.readyWait:w.isReady)||(w.isReady=!0,!0!==e&&--w.readyWait>0||F.resolveWith(r,[w]))}}),w.ready.then=F.then;function _(){r.removeEventListener(\"DOMContentLoaded\",_),e.removeEventListener(\"load\",_),w.ready()}\"complete\"===r.readyState||\"loading\"!==r.readyState&&!r.documentElement.doScroll?e.setTimeout(w.ready):(r.addEventListener(\"DOMContentLoaded\",_),e.addEventListener(\"load\",_));var z=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if(\"object\"===x(n)){i=!0;for(s in n)z(e,t,s,n[s],!0,o,a)}else if(void 0!==r&&(i=!0,g(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(w(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},X=/^-ms-/,U=/-([a-z])/g;function V(e,t){return t.toUpperCase()}function G(e){return e.replace(X,\"ms-\").replace(U,V)}var Y=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Q(){this.expando=w.expando+Q.uid++}Q.uid=1,Q.prototype={cache:function(e){var t=e[this.expando];return t||(t={},Y(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if(\"string\"==typeof t)i[G(t)]=n;else for(r in t)i[G(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][G(t)]},access:function(e,t,n){return void 0===t||t&&\"string\"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(G):(t=G(t))in r?[t]:t.match(M)||[]).length;while(n--)delete r[t[n]]}(void 0===t||w.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!w.isEmptyObject(t)}};var J=new Q,K=new Q,Z=/^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,ee=/[A-Z]/g;function te(e){return\"true\"===e||\"false\"!==e&&(\"null\"===e?null:e===+e+\"\"?+e:Z.test(e)?JSON.parse(e):e)}function ne(e,t,n){var r;if(void 0===n&&1===e.nodeType)if(r=\"data-\"+t.replace(ee,\"-$&\").toLowerCase(),\"string\"==typeof(n=e.getAttribute(r))){try{n=te(n)}catch(e){}K.set(e,t,n)}else n=void 0;return n}w.extend({hasData:function(e){return K.hasData(e)||J.hasData(e)},data:function(e,t,n){return K.access(e,t,n)},removeData:function(e,t){K.remove(e,t)},_data:function(e,t,n){return J.access(e,t,n)},_removeData:function(e,t){J.remove(e,t)}}),w.fn.extend({data:function(e,t){var n,r,i,o=this[0],a=o&&o.attributes;if(void 0===e){if(this.length&&(i=K.get(o),1===o.nodeType&&!J.get(o,\"hasDataAttrs\"))){n=a.length;while(n--)a[n]&&0===(r=a[n].name).indexOf(\"data-\")&&(r=G(r.slice(5)),ne(o,r,i[r]));J.set(o,\"hasDataAttrs\",!0)}return i}return\"object\"==typeof e?this.each(function(){K.set(this,e)}):z(this,function(t){var n;if(o&&void 0===t){if(void 0!==(n=K.get(o,e)))return n;if(void 0!==(n=ne(o,e)))return n}else this.each(function(){K.set(this,e,t)})},null,t,arguments.length>1,null,!0)},removeData:function(e){return this.each(function(){K.remove(this,e)})}}),w.extend({queue:function(e,t,n){var r;if(e)return t=(t||\"fx\")+\"queue\",r=J.get(e,t),n&&(!r||Array.isArray(n)?r=J.access(e,t,w.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||\"fx\";var n=w.queue(e,t),r=n.length,i=n.shift(),o=w._queueHooks(e,t),a=function(){w.dequeue(e,t)};\"inprogress\"===i&&(i=n.shift(),r--),i&&(\"fx\"===t&&n.unshift(\"inprogress\"),delete o.stop,i.call(e,a,o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+\"queueHooks\";return J.get(e,n)||J.access(e,n,{empty:w.Callbacks(\"once memory\").add(function(){J.remove(e,[t+\"queue\",n])})})}}),w.fn.extend({queue:function(e,t){var n=2;return\"string\"!=typeof e&&(t=e,e=\"fx\",n--),arguments.length<n?w.queue(this[0],e):void 0===t?this:this.each(function(){var n=w.queue(this,e,t);w._queueHooks(this,e),\"fx\"===e&&\"inprogress\"!==n[0]&&w.dequeue(this,e)})},dequeue:function(e){return this.each(function(){w.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||\"fx\",[])},promise:function(e,t){var n,r=1,i=w.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};\"string\"!=typeof e&&(t=e,e=void 0),e=e||\"fx\";while(a--)(n=J.get(o[a],e+\"queueHooks\"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var re=/[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source,ie=new RegExp(\"^(?:([+-])=|)(\"+re+\")([a-z%]*)$\",\"i\"),oe=[\"Top\",\"Right\",\"Bottom\",\"Left\"],ae=function(e,t){return\"none\"===(e=t||e).style.display||\"\"===e.style.display&&w.contains(e.ownerDocument,e)&&\"none\"===w.css(e,\"display\")},se=function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];i=n.apply(e,r||[]);for(o in t)e.style[o]=a[o];return i};function ue(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return w.css(e,t,\"\")},u=s(),l=n&&n[3]||(w.cssNumber[t]?\"\":\"px\"),c=(w.cssNumber[t]||\"px\"!==l&&+u)&&ie.exec(w.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)w.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,w.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var le={};function ce(e){var t,n=e.ownerDocument,r=e.nodeName,i=le[r];return i||(t=n.body.appendChild(n.createElement(r)),i=w.css(t,\"display\"),t.parentNode.removeChild(t),\"none\"===i&&(i=\"block\"),le[r]=i,i)}function fe(e,t){for(var n,r,i=[],o=0,a=e.length;o<a;o++)(r=e[o]).style&&(n=r.style.display,t?(\"none\"===n&&(i[o]=J.get(r,\"display\")||null,i[o]||(r.style.display=\"\")),\"\"===r.style.display&&ae(r)&&(i[o]=ce(r))):\"none\"!==n&&(i[o]=\"none\",J.set(r,\"display\",n)));for(o=0;o<a;o++)null!=i[o]&&(e[o].style.display=i[o]);return e}w.fn.extend({show:function(){return fe(this,!0)},hide:function(){return fe(this)},toggle:function(e){return\"boolean\"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?w(this).show():w(this).hide()})}});var pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]+)/i,he=/^$|^module$|\\/(?:java|ecma)script/i,ge={option:[1,\"<select multiple='multiple'>\",\"</select>\"],thead:[1,\"<table>\",\"</table>\"],col:[2,\"<table><colgroup>\",\"</colgroup></table>\"],tr:[2,\"<table><tbody>\",\"</tbody></table>\"],td:[3,\"<table><tbody><tr>\",\"</tr></tbody></table>\"],_default:[0,\"\",\"\"]};ge.optgroup=ge.option,ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td;function ye(e,t){var n;return n=\"undefined\"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||\"*\"):\"undefined\"!=typeof e.querySelectorAll?e.querySelectorAll(t||\"*\"):[],void 0===t||t&&N(e,t)?w.merge([e],n):n}function ve(e,t){for(var n=0,r=e.length;n<r;n++)J.set(e[n],\"globalEval\",!t||J.get(t[n],\"globalEval\"))}var me=/<|&#?\\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if(\"object\"===x(o))w.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement(\"div\")),s=(de.exec(o)||[\"\",\"\"])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+w.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;w.merge(p,a.childNodes),(a=f.firstChild).textContent=\"\"}else p.push(t.createTextNode(o));f.textContent=\"\",d=0;while(o=p[d++])if(r&&w.inArray(o,r)>-1)i&&i.push(o);else if(l=w.contains(o.ownerDocument,o),a=ye(f.appendChild(o),\"script\"),l&&ve(a),n){c=0;while(o=a[c++])he.test(o.type||\"\")&&n.push(o)}return f}!function(){var e=r.createDocumentFragment().appendChild(r.createElement(\"div\")),t=r.createElement(\"input\");t.setAttribute(\"type\",\"radio\"),t.setAttribute(\"checked\",\"checked\"),t.setAttribute(\"name\",\"t\"),e.appendChild(t),h.checkClone=e.cloneNode(!0).cloneNode(!0).lastChild.checked,e.innerHTML=\"<textarea>x</textarea>\",h.noCloneChecked=!!e.cloneNode(!0).lastChild.defaultValue}();var be=r.documentElement,we=/^key/,Te=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,Ce=/^([^.]*)(?:\\.(.+)|)/;function Ee(){return!0}function ke(){return!1}function Se(){try{return r.activeElement}catch(e){}}function De(e,t,n,r,i,o){var a,s;if(\"object\"==typeof t){\"string\"!=typeof n&&(r=r||n,n=void 0);for(s in t)De(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&(\"string\"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=ke;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return w().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=w.guid++)),e.each(function(){w.event.add(this,t,i,r,n)})}w.event={global:{},add:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=J.get(e);if(y){n.handler&&(n=(o=n).handler,i=o.selector),i&&w.find.matchesSelector(be,i),n.guid||(n.guid=w.guid++),(u=y.events)||(u=y.events={}),(a=y.handle)||(a=y.handle=function(t){return\"undefined\"!=typeof w&&w.event.triggered!==t.type?w.event.dispatch.apply(e,arguments):void 0}),l=(t=(t||\"\").match(M)||[\"\"]).length;while(l--)d=g=(s=Ce.exec(t[l])||[])[1],h=(s[2]||\"\").split(\".\").sort(),d&&(f=w.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=w.event.special[d]||{},c=w.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&w.expr.match.needsContext.test(i),namespace:h.join(\".\")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(e,r,h,a)||e.addEventListener&&e.addEventListener(d,a)),f.add&&(f.add.call(e,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),w.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=J.hasData(e)&&J.get(e);if(y&&(u=y.events)){l=(t=(t||\"\").match(M)||[\"\"]).length;while(l--)if(s=Ce.exec(t[l])||[],d=g=s[1],h=(s[2]||\"\").split(\".\").sort(),d){f=w.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp(\"(^|\\\\.)\"+h.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&(\"**\"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,y.handle)||w.removeEvent(e,d,y.handle),delete u[d])}else for(d in u)w.event.remove(e,d+t[l],n,r,!0);w.isEmptyObject(u)&&J.remove(e,\"handle events\")}},dispatch:function(e){var t=w.event.fix(e),n,r,i,o,a,s,u=new Array(arguments.length),l=(J.get(this,\"events\")||{})[t.type]||[],c=w.event.special[t.type]||{};for(u[0]=t,n=1;n<arguments.length;n++)u[n]=arguments[n];if(t.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,t)){s=w.event.handlers.call(this,t,l),n=0;while((o=s[n++])&&!t.isPropagationStopped()){t.currentTarget=o.elem,r=0;while((a=o.handlers[r++])&&!t.isImmediatePropagationStopped())t.rnamespace&&!t.rnamespace.test(a.namespace)||(t.handleObj=a,t.data=a.data,void 0!==(i=((w.event.special[a.origType]||{}).handle||a.handler).apply(o.elem,u))&&!1===(t.result=i)&&(t.preventDefault(),t.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,t),t.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!(\"click\"===e.type&&e.button>=1))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&(\"click\"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+\" \"]&&(a[i]=r.needsContext?w(i,this).index(l)>-1:w.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(e,t){Object.defineProperty(w.Event.prototype,e,{enumerable:!0,configurable:!0,get:g(t)?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[w.expando]?e:new w.Event(e)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==Se()&&this.focus)return this.focus(),!1},delegateType:\"focusin\"},blur:{trigger:function(){if(this===Se()&&this.blur)return this.blur(),!1},delegateType:\"focusout\"},click:{trigger:function(){if(\"checkbox\"===this.type&&this.click&&N(this,\"input\"))return this.click(),!1},_default:function(e){return N(e.target,\"a\")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},w.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},w.Event=function(e,t){if(!(this instanceof w.Event))return new w.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ee:ke,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&w.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[w.expando]=!0},w.Event.prototype={constructor:w.Event,isDefaultPrevented:ke,isPropagationStopped:ke,isImmediatePropagationStopped:ke,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ee,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ee,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ee,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},w.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,\"char\":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(e){var t=e.button;return null==e.which&&we.test(e.type)?null!=e.charCode?e.charCode:e.keyCode:!e.which&&void 0!==t&&Te.test(e.type)?1&t?1:2&t?3:4&t?2:0:e.which}},w.event.addProp),w.each({mouseenter:\"mouseover\",mouseleave:\"mouseout\",pointerenter:\"pointerover\",pointerleave:\"pointerout\"},function(e,t){w.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,o=e.handleObj;return i&&(i===r||w.contains(r,i))||(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),w.fn.extend({on:function(e,t,n,r){return De(this,e,t,n,r)},one:function(e,t,n,r){return De(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,w(e.delegateTarget).off(r.namespace?r.origType+\".\"+r.namespace:r.origType,r.selector,r.handler),this;if(\"object\"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&\"function\"!=typeof t||(n=t,t=void 0),!1===n&&(n=ke),this.each(function(){w.event.remove(this,e,n,t)})}});var Ne=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]*)[^>]*)\\/>/gi,Ae=/<script|<style|<link/i,je=/checked\\s*(?:[^=]|=\\s*.checked.)/i,qe=/^\\s*<!(?:\\[CDATA\\[|--)|(?:\\]\\]|--)>\\s*$/g;function Le(e,t){return N(e,\"table\")&&N(11!==t.nodeType?t:t.firstChild,\"tr\")?w(e).children(\"tbody\")[0]||e:e}function He(e){return e.type=(null!==e.getAttribute(\"type\"))+\"/\"+e.type,e}function Oe(e){return\"true/\"===(e.type||\"\").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute(\"type\"),e}function Pe(e,t){var n,r,i,o,a,s,u,l;if(1===t.nodeType){if(J.hasData(e)&&(o=J.access(e),a=J.set(t,o),l=o.events)){delete a.handle,a.events={};for(i in l)for(n=0,r=l[i].length;n<r;n++)w.event.add(t,i,l[i][n])}K.hasData(e)&&(s=K.access(e),u=w.extend({},s),K.set(t,u))}}function Me(e,t){var n=t.nodeName.toLowerCase();\"input\"===n&&pe.test(e.type)?t.checked=e.checked:\"input\"!==n&&\"textarea\"!==n||(t.defaultValue=e.defaultValue)}function Re(e,t,n,r){t=a.apply([],t);var i,o,s,u,l,c,f=0,p=e.length,d=p-1,y=t[0],v=g(y);if(v||p>1&&\"string\"==typeof y&&!h.checkClone&&je.test(y))return e.each(function(i){var o=e.eq(i);v&&(t[0]=y.call(this,i,o.html())),Re(o,t,n,r)});if(p&&(i=xe(t,e[0].ownerDocument,!1,e,r),o=i.firstChild,1===i.childNodes.length&&(i=o),o||r)){for(u=(s=w.map(ye(i,\"script\"),He)).length;f<p;f++)l=i,f!==d&&(l=w.clone(l,!0,!0),u&&w.merge(s,ye(l,\"script\"))),n.call(e[f],l,f);if(u)for(c=s[s.length-1].ownerDocument,w.map(s,Oe),f=0;f<u;f++)l=s[f],he.test(l.type||\"\")&&!J.access(l,\"globalEval\")&&w.contains(c,l)&&(l.src&&\"module\"!==(l.type||\"\").toLowerCase()?w._evalUrl&&w._evalUrl(l.src):m(l.textContent.replace(qe,\"\"),c,l))}return e}function Ie(e,t,n){for(var r,i=t?w.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||w.cleanData(ye(r)),r.parentNode&&(n&&w.contains(r.ownerDocument,r)&&ve(ye(r,\"script\")),r.parentNode.removeChild(r));return e}w.extend({htmlPrefilter:function(e){return e.replace(Ne,\"<$1></$2>\")},clone:function(e,t,n){var r,i,o,a,s=e.cloneNode(!0),u=w.contains(e.ownerDocument,e);if(!(h.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||w.isXMLDoc(e)))for(a=ye(s),r=0,i=(o=ye(e)).length;r<i;r++)Me(o[r],a[r]);if(t)if(n)for(o=o||ye(e),a=a||ye(s),r=0,i=o.length;r<i;r++)Pe(o[r],a[r]);else Pe(e,s);return(a=ye(s,\"script\")).length>0&&ve(a,!u&&ye(e,\"script\")),s},cleanData:function(e){for(var t,n,r,i=w.event.special,o=0;void 0!==(n=e[o]);o++)if(Y(n)){if(t=n[J.expando]){if(t.events)for(r in t.events)i[r]?w.event.remove(n,r):w.removeEvent(n,r,t.handle);n[J.expando]=void 0}n[K.expando]&&(n[K.expando]=void 0)}}}),w.fn.extend({detach:function(e){return Ie(this,e,!0)},remove:function(e){return Ie(this,e)},text:function(e){return z(this,function(e){return void 0===e?w.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return Re(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Le(this,e).appendChild(e)})},prepend:function(){return Re(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Le(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return Re(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return Re(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(w.cleanData(ye(e,!1)),e.textContent=\"\");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return w.clone(this,e,t)})},html:function(e){return z(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if(\"string\"==typeof e&&!Ae.test(e)&&!ge[(de.exec(e)||[\"\",\"\"])[1].toLowerCase()]){e=w.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(w.cleanData(ye(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var e=[];return Re(this,arguments,function(t){var n=this.parentNode;w.inArray(this,e)<0&&(w.cleanData(ye(this)),n&&n.replaceChild(t,this))},e)}}),w.each({appendTo:\"append\",prependTo:\"prepend\",insertBefore:\"before\",insertAfter:\"after\",replaceAll:\"replaceWith\"},function(e,t){w.fn[e]=function(e){for(var n,r=[],i=w(e),o=i.length-1,a=0;a<=o;a++)n=a===o?this:this.clone(!0),w(i[a])[t](n),s.apply(r,n.get());return this.pushStack(r)}});var We=new RegExp(\"^(\"+re+\")(?!px)[a-z%]+$\",\"i\"),$e=function(t){var n=t.ownerDocument.defaultView;return n&&n.opener||(n=e),n.getComputedStyle(t)},Be=new RegExp(oe.join(\"|\"),\"i\");!function(){function t(){if(c){l.style.cssText=\"position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0\",c.style.cssText=\"position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%\",be.appendChild(l).appendChild(c);var t=e.getComputedStyle(c);i=\"1%\"!==t.top,u=12===n(t.marginLeft),c.style.right=\"60%\",s=36===n(t.right),o=36===n(t.width),c.style.position=\"absolute\",a=36===c.offsetWidth||\"absolute\",be.removeChild(l),c=null}}function n(e){return Math.round(parseFloat(e))}var i,o,a,s,u,l=r.createElement(\"div\"),c=r.createElement(\"div\");c.style&&(c.style.backgroundClip=\"content-box\",c.cloneNode(!0).style.backgroundClip=\"\",h.clearCloneStyle=\"content-box\"===c.style.backgroundClip,w.extend(h,{boxSizingReliable:function(){return t(),o},pixelBoxStyles:function(){return t(),s},pixelPosition:function(){return t(),i},reliableMarginLeft:function(){return t(),u},scrollboxSize:function(){return t(),a}}))}();function Fe(e,t,n){var r,i,o,a,s=e.style;return(n=n||$e(e))&&(\"\"!==(a=n.getPropertyValue(t)||n[t])||w.contains(e.ownerDocument,e)||(a=w.style(e,t)),!h.pixelBoxStyles()&&We.test(a)&&Be.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+\"\":a}function _e(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}var ze=/^(none|table(?!-c[ea]).+)/,Xe=/^--/,Ue={position:\"absolute\",visibility:\"hidden\",display:\"block\"},Ve={letterSpacing:\"0\",fontWeight:\"400\"},Ge=[\"Webkit\",\"Moz\",\"ms\"],Ye=r.createElement(\"div\").style;function Qe(e){if(e in Ye)return e;var t=e[0].toUpperCase()+e.slice(1),n=Ge.length;while(n--)if((e=Ge[n]+t)in Ye)return e}function Je(e){var t=w.cssProps[e];return t||(t=w.cssProps[e]=Qe(e)||e),t}function Ke(e,t,n){var r=ie.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||\"px\"):t}function Ze(e,t,n,r,i,o){var a=\"width\"===t?1:0,s=0,u=0;if(n===(r?\"border\":\"content\"))return 0;for(;a<4;a+=2)\"margin\"===n&&(u+=w.css(e,n+oe[a],!0,i)),r?(\"content\"===n&&(u-=w.css(e,\"padding\"+oe[a],!0,i)),\"margin\"!==n&&(u-=w.css(e,\"border\"+oe[a]+\"Width\",!0,i))):(u+=w.css(e,\"padding\"+oe[a],!0,i),\"padding\"!==n?u+=w.css(e,\"border\"+oe[a]+\"Width\",!0,i):s+=w.css(e,\"border\"+oe[a]+\"Width\",!0,i));return!r&&o>=0&&(u+=Math.max(0,Math.ceil(e[\"offset\"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))),u}function et(e,t,n){var r=$e(e),i=Fe(e,t,r),o=\"border-box\"===w.css(e,\"boxSizing\",!1,r),a=o;if(We.test(i)){if(!n)return i;i=\"auto\"}return a=a&&(h.boxSizingReliable()||i===e.style[t]),(\"auto\"===i||!parseFloat(i)&&\"inline\"===w.css(e,\"display\",!1,r))&&(i=e[\"offset\"+t[0].toUpperCase()+t.slice(1)],a=!0),(i=parseFloat(i)||0)+Ze(e,t,n||(o?\"border\":\"content\"),a,r,i)+\"px\"}w.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Fe(e,\"opacity\");return\"\"===n?\"1\":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=G(t),u=Xe.test(t),l=e.style;if(u||(t=Je(s)),a=w.cssHooks[t]||w.cssHooks[s],void 0===n)return a&&\"get\"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];\"string\"==(o=typeof n)&&(i=ie.exec(n))&&i[1]&&(n=ue(e,t,i),o=\"number\"),null!=n&&n===n&&(\"number\"===o&&(n+=i&&i[3]||(w.cssNumber[s]?\"\":\"px\")),h.clearCloneStyle||\"\"!==n||0!==t.indexOf(\"background\")||(l[t]=\"inherit\"),a&&\"set\"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=G(t);return Xe.test(t)||(t=Je(s)),(a=w.cssHooks[t]||w.cssHooks[s])&&\"get\"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Fe(e,t,r)),\"normal\"===i&&t in Ve&&(i=Ve[t]),\"\"===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),w.each([\"height\",\"width\"],function(e,t){w.cssHooks[t]={get:function(e,n,r){if(n)return!ze.test(w.css(e,\"display\"))||e.getClientRects().length&&e.getBoundingClientRect().width?et(e,t,r):se(e,Ue,function(){return et(e,t,r)})},set:function(e,n,r){var i,o=$e(e),a=\"border-box\"===w.css(e,\"boxSizing\",!1,o),s=r&&Ze(e,t,r,a,o);return a&&h.scrollboxSize()===o.position&&(s-=Math.ceil(e[\"offset\"+t[0].toUpperCase()+t.slice(1)]-parseFloat(o[t])-Ze(e,t,\"border\",!1,o)-.5)),s&&(i=ie.exec(n))&&\"px\"!==(i[3]||\"px\")&&(e.style[t]=n,n=w.css(e,t)),Ke(e,n,s)}}}),w.cssHooks.marginLeft=_e(h.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Fe(e,\"marginLeft\"))||e.getBoundingClientRect().left-se(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+\"px\"}),w.each({margin:\"\",padding:\"\",border:\"Width\"},function(e,t){w.cssHooks[e+t]={expand:function(n){for(var r=0,i={},o=\"string\"==typeof n?n.split(\" \"):[n];r<4;r++)i[e+oe[r]+t]=o[r]||o[r-2]||o[0];return i}},\"margin\"!==e&&(w.cssHooks[e+t].set=Ke)}),w.fn.extend({css:function(e,t){return z(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=$e(e),i=t.length;a<i;a++)o[t[a]]=w.css(e,t[a],!1,r);return o}return void 0!==n?w.style(e,t,n):w.css(e,t)},e,t,arguments.length>1)}});function tt(e,t,n,r,i){return new tt.prototype.init(e,t,n,r,i)}w.Tween=tt,tt.prototype={constructor:tt,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||w.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(w.cssNumber[n]?\"\":\"px\")},cur:function(){var e=tt.propHooks[this.prop];return e&&e.get?e.get(this):tt.propHooks._default.get(this)},run:function(e){var t,n=tt.propHooks[this.prop];return this.options.duration?this.pos=t=w.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):tt.propHooks._default.set(this),this}},tt.prototype.init.prototype=tt.prototype,tt.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=w.css(e.elem,e.prop,\"\"))&&\"auto\"!==t?t:0},set:function(e){w.fx.step[e.prop]?w.fx.step[e.prop](e):1!==e.elem.nodeType||null==e.elem.style[w.cssProps[e.prop]]&&!w.cssHooks[e.prop]?e.elem[e.prop]=e.now:w.style(e.elem,e.prop,e.now+e.unit)}}},tt.propHooks.scrollTop=tt.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},w.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:\"swing\"},w.fx=tt.prototype.init,w.fx.step={};var nt,rt,it=/^(?:toggle|show|hide)$/,ot=/queueHooks$/;function at(){rt&&(!1===r.hidden&&e.requestAnimationFrame?e.requestAnimationFrame(at):e.setTimeout(at,w.fx.interval),w.fx.tick())}function st(){return e.setTimeout(function(){nt=void 0}),nt=Date.now()}function ut(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i[\"margin\"+(n=oe[r])]=i[\"padding\"+n]=e;return t&&(i.opacity=i.width=e),i}function lt(e,t,n){for(var r,i=(pt.tweeners[t]||[]).concat(pt.tweeners[\"*\"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function ct(e,t,n){var r,i,o,a,s,u,l,c,f=\"width\"in t||\"height\"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),y=J.get(e,\"fxshow\");n.queue||(null==(a=w._queueHooks(e,\"fx\")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,w.queue(e,\"fx\").length||a.empty.fire()})}));for(r in t)if(i=t[r],it.test(i)){if(delete t[r],o=o||\"toggle\"===i,i===(g?\"hide\":\"show\")){if(\"show\"!==i||!y||void 0===y[r])continue;g=!0}d[r]=y&&y[r]||w.style(e,r)}if((u=!w.isEmptyObject(t))||!w.isEmptyObject(d)){f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=y&&y.display)&&(l=J.get(e,\"display\")),\"none\"===(c=w.css(e,\"display\"))&&(l?c=l:(fe([e],!0),l=e.style.display||l,c=w.css(e,\"display\"),fe([e]))),(\"inline\"===c||\"inline-block\"===c&&null!=l)&&\"none\"===w.css(e,\"float\")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l=\"none\"===c?\"\":c)),h.display=\"inline-block\")),n.overflow&&(h.overflow=\"hidden\",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1;for(r in d)u||(y?\"hidden\"in y&&(g=y.hidden):y=J.access(e,\"fxshow\",{display:l}),o&&(y.hidden=!g),g&&fe([e],!0),p.done(function(){g||fe([e]),J.remove(e,\"fxshow\");for(r in d)w.style(e,r,d[r])})),u=lt(g?y[r]:0,r,p),r in y||(y[r]=u.start,g&&(u.end=u.start,u.start=0))}}function ft(e,t){var n,r,i,o,a;for(n in e)if(r=G(n),i=t[r],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=w.cssHooks[r])&&\"expand\"in a){o=a.expand(o),delete e[r];for(n in o)n in e||(e[n]=o[n],t[n]=i)}else t[r]=i}function pt(e,t,n){var r,i,o=0,a=pt.prefilters.length,s=w.Deferred().always(function(){delete u.elem}),u=function(){if(i)return!1;for(var t=nt||st(),n=Math.max(0,l.startTime+l.duration-t),r=1-(n/l.duration||0),o=0,a=l.tweens.length;o<a;o++)l.tweens[o].run(r);return s.notifyWith(e,[l,r,n]),r<1&&a?n:(a||s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l]),!1)},l=s.promise({elem:e,props:w.extend({},t),opts:w.extend(!0,{specialEasing:{},easing:w.easing._default},n),originalProperties:t,originalOptions:n,startTime:nt||st(),duration:n.duration,tweens:[],createTween:function(t,n){var r=w.Tween(e,l.opts,t,n,l.opts.specialEasing[t]||l.opts.easing);return l.tweens.push(r),r},stop:function(t){var n=0,r=t?l.tweens.length:0;if(i)return this;for(i=!0;n<r;n++)l.tweens[n].run(1);return t?(s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l,t])):s.rejectWith(e,[l,t]),this}}),c=l.props;for(ft(c,l.opts.specialEasing);o<a;o++)if(r=pt.prefilters[o].call(l,e,c,l.opts))return g(r.stop)&&(w._queueHooks(l.elem,l.opts.queue).stop=r.stop.bind(r)),r;return w.map(c,lt,l),g(l.opts.start)&&l.opts.start.call(e,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),w.fx.timer(w.extend(u,{elem:e,anim:l,queue:l.opts.queue})),l}w.Animation=w.extend(pt,{tweeners:{\"*\":[function(e,t){var n=this.createTween(e,t);return ue(n.elem,e,ie.exec(t),n),n}]},tweener:function(e,t){g(e)?(t=e,e=[\"*\"]):e=e.match(M);for(var n,r=0,i=e.length;r<i;r++)n=e[r],pt.tweeners[n]=pt.tweeners[n]||[],pt.tweeners[n].unshift(t)},prefilters:[ct],prefilter:function(e,t){t?pt.prefilters.unshift(e):pt.prefilters.push(e)}}),w.speed=function(e,t,n){var r=e&&\"object\"==typeof e?w.extend({},e):{complete:n||!n&&t||g(e)&&e,duration:e,easing:n&&t||t&&!g(t)&&t};return w.fx.off?r.duration=0:\"number\"!=typeof r.duration&&(r.duration in w.fx.speeds?r.duration=w.fx.speeds[r.duration]:r.duration=w.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue=\"fx\"),r.old=r.complete,r.complete=function(){g(r.old)&&r.old.call(this),r.queue&&w.dequeue(this,r.queue)},r},w.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css(\"opacity\",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=w.isEmptyObject(e),o=w.speed(t,n,r),a=function(){var t=pt(this,w.extend({},e),o);(i||J.get(this,\"finish\"))&&t.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(e,t,n){var r=function(e){var t=e.stop;delete e.stop,t(n)};return\"string\"!=typeof e&&(n=t,t=e,e=void 0),t&&!1!==e&&this.queue(e||\"fx\",[]),this.each(function(){var t=!0,i=null!=e&&e+\"queueHooks\",o=w.timers,a=J.get(this);if(i)a[i]&&a[i].stop&&r(a[i]);else for(i in a)a[i]&&a[i].stop&&ot.test(i)&&r(a[i]);for(i=o.length;i--;)o[i].elem!==this||null!=e&&o[i].queue!==e||(o[i].anim.stop(n),t=!1,o.splice(i,1));!t&&n||w.dequeue(this,e)})},finish:function(e){return!1!==e&&(e=e||\"fx\"),this.each(function(){var t,n=J.get(this),r=n[e+\"queue\"],i=n[e+\"queueHooks\"],o=w.timers,a=r?r.length:0;for(n.finish=!0,w.queue(this,e,[]),i&&i.stop&&i.stop.call(this,!0),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;t<a;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}}),w.each([\"toggle\",\"show\",\"hide\"],function(e,t){var n=w.fn[t];w.fn[t]=function(e,r,i){return null==e||\"boolean\"==typeof e?n.apply(this,arguments):this.animate(ut(t,!0),e,r,i)}}),w.each({slideDown:ut(\"show\"),slideUp:ut(\"hide\"),slideToggle:ut(\"toggle\"),fadeIn:{opacity:\"show\"},fadeOut:{opacity:\"hide\"},fadeToggle:{opacity:\"toggle\"}},function(e,t){w.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),w.timers=[],w.fx.tick=function(){var e,t=0,n=w.timers;for(nt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||w.fx.stop(),nt=void 0},w.fx.timer=function(e){w.timers.push(e),w.fx.start()},w.fx.interval=13,w.fx.start=function(){rt||(rt=!0,at())},w.fx.stop=function(){rt=null},w.fx.speeds={slow:600,fast:200,_default:400},w.fn.delay=function(t,n){return t=w.fx?w.fx.speeds[t]||t:t,n=n||\"fx\",this.queue(n,function(n,r){var i=e.setTimeout(n,t);r.stop=function(){e.clearTimeout(i)}})},function(){var e=r.createElement(\"input\"),t=r.createElement(\"select\").appendChild(r.createElement(\"option\"));e.type=\"checkbox\",h.checkOn=\"\"!==e.value,h.optSelected=t.selected,(e=r.createElement(\"input\")).value=\"t\",e.type=\"radio\",h.radioValue=\"t\"===e.value}();var dt,ht=w.expr.attrHandle;w.fn.extend({attr:function(e,t){return z(this,w.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){w.removeAttr(this,e)})}}),w.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return\"undefined\"==typeof e.getAttribute?w.prop(e,t,n):(1===o&&w.isXMLDoc(e)||(i=w.attrHooks[t.toLowerCase()]||(w.expr.match.bool.test(t)?dt:void 0)),void 0!==n?null===n?void w.removeAttr(e,t):i&&\"set\"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+\"\"),n):i&&\"get\"in i&&null!==(r=i.get(e,t))?r:null==(r=w.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!h.radioValue&&\"radio\"===t&&N(e,\"input\")){var n=e.value;return e.setAttribute(\"type\",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(M);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),dt={set:function(e,t,n){return!1===t?w.removeAttr(e,n):e.setAttribute(n,n),n}},w.each(w.expr.match.bool.source.match(/\\w+/g),function(e,t){var n=ht[t]||w.find.attr;ht[t]=function(e,t,r){var i,o,a=t.toLowerCase();return r||(o=ht[a],ht[a]=i,i=null!=n(e,t,r)?a:null,ht[a]=o),i}});var gt=/^(?:input|select|textarea|button)$/i,yt=/^(?:a|area)$/i;w.fn.extend({prop:function(e,t){return z(this,w.prop,e,t,arguments.length>1)},removeProp:function(e){return this.each(function(){delete this[w.propFix[e]||e]})}}),w.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&w.isXMLDoc(e)||(t=w.propFix[t]||t,i=w.propHooks[t]),void 0!==n?i&&\"set\"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&\"get\"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=w.find.attr(e,\"tabindex\");return t?parseInt(t,10):gt.test(e.nodeName)||yt.test(e.nodeName)&&e.href?0:-1}}},propFix:{\"for\":\"htmlFor\",\"class\":\"className\"}}),h.optSelected||(w.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),w.each([\"tabIndex\",\"readOnly\",\"maxLength\",\"cellSpacing\",\"cellPadding\",\"rowSpan\",\"colSpan\",\"useMap\",\"frameBorder\",\"contentEditable\"],function(){w.propFix[this.toLowerCase()]=this});function vt(e){return(e.match(M)||[]).join(\" \")}function mt(e){return e.getAttribute&&e.getAttribute(\"class\")||\"\"}function xt(e){return Array.isArray(e)?e:\"string\"==typeof e?e.match(M)||[]:[]}w.fn.extend({addClass:function(e){var t,n,r,i,o,a,s,u=0;if(g(e))return this.each(function(t){w(this).addClass(e.call(this,t,mt(this)))});if((t=xt(e)).length)while(n=this[u++])if(i=mt(n),r=1===n.nodeType&&\" \"+vt(i)+\" \"){a=0;while(o=t[a++])r.indexOf(\" \"+o+\" \")<0&&(r+=o+\" \");i!==(s=vt(r))&&n.setAttribute(\"class\",s)}return this},removeClass:function(e){var t,n,r,i,o,a,s,u=0;if(g(e))return this.each(function(t){w(this).removeClass(e.call(this,t,mt(this)))});if(!arguments.length)return this.attr(\"class\",\"\");if((t=xt(e)).length)while(n=this[u++])if(i=mt(n),r=1===n.nodeType&&\" \"+vt(i)+\" \"){a=0;while(o=t[a++])while(r.indexOf(\" \"+o+\" \")>-1)r=r.replace(\" \"+o+\" \",\" \");i!==(s=vt(r))&&n.setAttribute(\"class\",s)}return this},toggleClass:function(e,t){var n=typeof e,r=\"string\"===n||Array.isArray(e);return\"boolean\"==typeof t&&r?t?this.addClass(e):this.removeClass(e):g(e)?this.each(function(n){w(this).toggleClass(e.call(this,n,mt(this),t),t)}):this.each(function(){var t,i,o,a;if(r){i=0,o=w(this),a=xt(e);while(t=a[i++])o.hasClass(t)?o.removeClass(t):o.addClass(t)}else void 0!==e&&\"boolean\"!==n||((t=mt(this))&&J.set(this,\"__className__\",t),this.setAttribute&&this.setAttribute(\"class\",t||!1===e?\"\":J.get(this,\"__className__\")||\"\"))})},hasClass:function(e){var t,n,r=0;t=\" \"+e+\" \";while(n=this[r++])if(1===n.nodeType&&(\" \"+vt(mt(n))+\" \").indexOf(t)>-1)return!0;return!1}});var bt=/\\r/g;w.fn.extend({val:function(e){var t,n,r,i=this[0];{if(arguments.length)return r=g(e),this.each(function(n){var i;1===this.nodeType&&(null==(i=r?e.call(this,n,w(this).val()):e)?i=\"\":\"number\"==typeof i?i+=\"\":Array.isArray(i)&&(i=w.map(i,function(e){return null==e?\"\":e+\"\"})),(t=w.valHooks[this.type]||w.valHooks[this.nodeName.toLowerCase()])&&\"set\"in t&&void 0!==t.set(this,i,\"value\")||(this.value=i))});if(i)return(t=w.valHooks[i.type]||w.valHooks[i.nodeName.toLowerCase()])&&\"get\"in t&&void 0!==(n=t.get(i,\"value\"))?n:\"string\"==typeof(n=i.value)?n.replace(bt,\"\"):null==n?\"\":n}}}),w.extend({valHooks:{option:{get:function(e){var t=w.find.attr(e,\"value\");return null!=t?t:vt(w.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a=\"select-one\"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!N(n.parentNode,\"optgroup\"))){if(t=w(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=w.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=w.inArray(w.valHooks.option.get(r),o)>-1)&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),w.each([\"radio\",\"checkbox\"],function(){w.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=w.inArray(w(e).val(),t)>-1}},h.checkOn||(w.valHooks[this].get=function(e){return null===e.getAttribute(\"value\")?\"on\":e.value})}),h.focusin=\"onfocusin\"in e;var wt=/^(?:focusinfocus|focusoutblur)$/,Tt=function(e){e.stopPropagation()};w.extend(w.event,{trigger:function(t,n,i,o){var a,s,u,l,c,p,d,h,v=[i||r],m=f.call(t,\"type\")?t.type:t,x=f.call(t,\"namespace\")?t.namespace.split(\".\"):[];if(s=h=u=i=i||r,3!==i.nodeType&&8!==i.nodeType&&!wt.test(m+w.event.triggered)&&(m.indexOf(\".\")>-1&&(m=(x=m.split(\".\")).shift(),x.sort()),c=m.indexOf(\":\")<0&&\"on\"+m,t=t[w.expando]?t:new w.Event(m,\"object\"==typeof t&&t),t.isTrigger=o?2:3,t.namespace=x.join(\".\"),t.rnamespace=t.namespace?new RegExp(\"(^|\\\\.)\"+x.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"):null,t.result=void 0,t.target||(t.target=i),n=null==n?[t]:w.makeArray(n,[t]),d=w.event.special[m]||{},o||!d.trigger||!1!==d.trigger.apply(i,n))){if(!o&&!d.noBubble&&!y(i)){for(l=d.delegateType||m,wt.test(l+m)||(s=s.parentNode);s;s=s.parentNode)v.push(s),u=s;u===(i.ownerDocument||r)&&v.push(u.defaultView||u.parentWindow||e)}a=0;while((s=v[a++])&&!t.isPropagationStopped())h=s,t.type=a>1?l:d.bindType||m,(p=(J.get(s,\"events\")||{})[t.type]&&J.get(s,\"handle\"))&&p.apply(s,n),(p=c&&s[c])&&p.apply&&Y(s)&&(t.result=p.apply(s,n),!1===t.result&&t.preventDefault());return t.type=m,o||t.isDefaultPrevented()||d._default&&!1!==d._default.apply(v.pop(),n)||!Y(i)||c&&g(i[m])&&!y(i)&&((u=i[c])&&(i[c]=null),w.event.triggered=m,t.isPropagationStopped()&&h.addEventListener(m,Tt),i[m](),t.isPropagationStopped()&&h.removeEventListener(m,Tt),w.event.triggered=void 0,u&&(i[c]=u)),t.result}},simulate:function(e,t,n){var r=w.extend(new w.Event,n,{type:e,isSimulated:!0});w.event.trigger(r,null,t)}}),w.fn.extend({trigger:function(e,t){return this.each(function(){w.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return w.event.trigger(e,t,n,!0)}}),h.focusin||w.each({focus:\"focusin\",blur:\"focusout\"},function(e,t){var n=function(e){w.event.simulate(t,e.target,w.event.fix(e))};w.event.special[t]={setup:function(){var r=this.ownerDocument||this,i=J.access(r,t);i||r.addEventListener(e,n,!0),J.access(r,t,(i||0)+1)},teardown:function(){var r=this.ownerDocument||this,i=J.access(r,t)-1;i?J.access(r,t,i):(r.removeEventListener(e,n,!0),J.remove(r,t))}}});var Ct=e.location,Et=Date.now(),kt=/\\?/;w.parseXML=function(t){var n;if(!t||\"string\"!=typeof t)return null;try{n=(new e.DOMParser).parseFromString(t,\"text/xml\")}catch(e){n=void 0}return n&&!n.getElementsByTagName(\"parsererror\").length||w.error(\"Invalid XML: \"+t),n};var St=/\\[\\]$/,Dt=/\\r?\\n/g,Nt=/^(?:submit|button|image|reset|file)$/i,At=/^(?:input|select|textarea|keygen)/i;function jt(e,t,n,r){var i;if(Array.isArray(t))w.each(t,function(t,i){n||St.test(e)?r(e,i):jt(e+\"[\"+(\"object\"==typeof i&&null!=i?t:\"\")+\"]\",i,n,r)});else if(n||\"object\"!==x(t))r(e,t);else for(i in t)jt(e+\"[\"+i+\"]\",t[i],n,r)}w.param=function(e,t){var n,r=[],i=function(e,t){var n=g(t)?t():t;r[r.length]=encodeURIComponent(e)+\"=\"+encodeURIComponent(null==n?\"\":n)};if(Array.isArray(e)||e.jquery&&!w.isPlainObject(e))w.each(e,function(){i(this.name,this.value)});else for(n in e)jt(n,e[n],t,i);return r.join(\"&\")},w.fn.extend({serialize:function(){return w.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=w.prop(this,\"elements\");return e?w.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!w(this).is(\":disabled\")&&At.test(this.nodeName)&&!Nt.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=w(this).val();return null==n?null:Array.isArray(n)?w.map(n,function(e){return{name:t.name,value:e.replace(Dt,\"\\r\\n\")}}):{name:t.name,value:n.replace(Dt,\"\\r\\n\")}}).get()}});var qt=/%20/g,Lt=/#.*$/,Ht=/([?&])_=[^&]*/,Ot=/^(.*?):[ \\t]*([^\\r\\n]*)$/gm,Pt=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Mt=/^(?:GET|HEAD)$/,Rt=/^\\/\\//,It={},Wt={},$t=\"*/\".concat(\"*\"),Bt=r.createElement(\"a\");Bt.href=Ct.href;function Ft(e){return function(t,n){\"string\"!=typeof t&&(n=t,t=\"*\");var r,i=0,o=t.toLowerCase().match(M)||[];if(g(n))while(r=o[i++])\"+\"===r[0]?(r=r.slice(1)||\"*\",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function _t(e,t,n,r){var i={},o=e===Wt;function a(s){var u;return i[s]=!0,w.each(e[s]||[],function(e,s){var l=s(t,n,r);return\"string\"!=typeof l||o||i[l]?o?!(u=l):void 0:(t.dataTypes.unshift(l),a(l),!1)}),u}return a(t.dataTypes[0])||!i[\"*\"]&&a(\"*\")}function zt(e,t){var n,r,i=w.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&w.extend(!0,e,r),e}function Xt(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while(\"*\"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader(\"Content-Type\"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+\" \"+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}function Ut(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if(\"*\"===o)o=u;else if(\"*\"!==u&&u!==o){if(!(a=l[u+\" \"+o]||l[\"* \"+o]))for(i in l)if((s=i.split(\" \"))[1]===o&&(a=l[u+\" \"+s[0]]||l[\"* \"+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e[\"throws\"])t=a(t);else try{t=a(t)}catch(e){return{state:\"parsererror\",error:a?e:\"No conversion from \"+u+\" to \"+o}}}return{state:\"success\",data:t}}w.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Ct.href,type:\"GET\",isLocal:Pt.test(Ct.protocol),global:!0,processData:!0,async:!0,contentType:\"application/x-www-form-urlencoded; charset=UTF-8\",accepts:{\"*\":$t,text:\"text/plain\",html:\"text/html\",xml:\"application/xml, text/xml\",json:\"application/json, text/javascript\"},contents:{xml:/\\bxml\\b/,html:/\\bhtml/,json:/\\bjson\\b/},responseFields:{xml:\"responseXML\",text:\"responseText\",json:\"responseJSON\"},converters:{\"* text\":String,\"text html\":!0,\"text json\":JSON.parse,\"text xml\":w.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?zt(zt(e,w.ajaxSettings),t):zt(w.ajaxSettings,e)},ajaxPrefilter:Ft(It),ajaxTransport:Ft(Wt),ajax:function(t,n){\"object\"==typeof t&&(n=t,t=void 0),n=n||{};var i,o,a,s,u,l,c,f,p,d,h=w.ajaxSetup({},n),g=h.context||h,y=h.context&&(g.nodeType||g.jquery)?w(g):w.event,v=w.Deferred(),m=w.Callbacks(\"once memory\"),x=h.statusCode||{},b={},T={},C=\"canceled\",E={readyState:0,getResponseHeader:function(e){var t;if(c){if(!s){s={};while(t=Ot.exec(a))s[t[1].toLowerCase()]=t[2]}t=s[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return c?a:null},setRequestHeader:function(e,t){return null==c&&(e=T[e.toLowerCase()]=T[e.toLowerCase()]||e,b[e]=t),this},overrideMimeType:function(e){return null==c&&(h.mimeType=e),this},statusCode:function(e){var t;if(e)if(c)E.always(e[E.status]);else for(t in e)x[t]=[x[t],e[t]];return this},abort:function(e){var t=e||C;return i&&i.abort(t),k(0,t),this}};if(v.promise(E),h.url=((t||h.url||Ct.href)+\"\").replace(Rt,Ct.protocol+\"//\"),h.type=n.method||n.type||h.method||h.type,h.dataTypes=(h.dataType||\"*\").toLowerCase().match(M)||[\"\"],null==h.crossDomain){l=r.createElement(\"a\");try{l.href=h.url,l.href=l.href,h.crossDomain=Bt.protocol+\"//\"+Bt.host!=l.protocol+\"//\"+l.host}catch(e){h.crossDomain=!0}}if(h.data&&h.processData&&\"string\"!=typeof h.data&&(h.data=w.param(h.data,h.traditional)),_t(It,h,n,E),c)return E;(f=w.event&&h.global)&&0==w.active++&&w.event.trigger(\"ajaxStart\"),h.type=h.type.toUpperCase(),h.hasContent=!Mt.test(h.type),o=h.url.replace(Lt,\"\"),h.hasContent?h.data&&h.processData&&0===(h.contentType||\"\").indexOf(\"application/x-www-form-urlencoded\")&&(h.data=h.data.replace(qt,\"+\")):(d=h.url.slice(o.length),h.data&&(h.processData||\"string\"==typeof h.data)&&(o+=(kt.test(o)?\"&\":\"?\")+h.data,delete h.data),!1===h.cache&&(o=o.replace(Ht,\"$1\"),d=(kt.test(o)?\"&\":\"?\")+\"_=\"+Et+++d),h.url=o+d),h.ifModified&&(w.lastModified[o]&&E.setRequestHeader(\"If-Modified-Since\",w.lastModified[o]),w.etag[o]&&E.setRequestHeader(\"If-None-Match\",w.etag[o])),(h.data&&h.hasContent&&!1!==h.contentType||n.contentType)&&E.setRequestHeader(\"Content-Type\",h.contentType),E.setRequestHeader(\"Accept\",h.dataTypes[0]&&h.accepts[h.dataTypes[0]]?h.accepts[h.dataTypes[0]]+(\"*\"!==h.dataTypes[0]?\", \"+$t+\"; q=0.01\":\"\"):h.accepts[\"*\"]);for(p in h.headers)E.setRequestHeader(p,h.headers[p]);if(h.beforeSend&&(!1===h.beforeSend.call(g,E,h)||c))return E.abort();if(C=\"abort\",m.add(h.complete),E.done(h.success),E.fail(h.error),i=_t(Wt,h,n,E)){if(E.readyState=1,f&&y.trigger(\"ajaxSend\",[E,h]),c)return E;h.async&&h.timeout>0&&(u=e.setTimeout(function(){E.abort(\"timeout\")},h.timeout));try{c=!1,i.send(b,k)}catch(e){if(c)throw e;k(-1,e)}}else k(-1,\"No Transport\");function k(t,n,r,s){var l,p,d,b,T,C=n;c||(c=!0,u&&e.clearTimeout(u),i=void 0,a=s||\"\",E.readyState=t>0?4:0,l=t>=200&&t<300||304===t,r&&(b=Xt(h,E,r)),b=Ut(h,b,E,l),l?(h.ifModified&&((T=E.getResponseHeader(\"Last-Modified\"))&&(w.lastModified[o]=T),(T=E.getResponseHeader(\"etag\"))&&(w.etag[o]=T)),204===t||\"HEAD\"===h.type?C=\"nocontent\":304===t?C=\"notmodified\":(C=b.state,p=b.data,l=!(d=b.error))):(d=C,!t&&C||(C=\"error\",t<0&&(t=0))),E.status=t,E.statusText=(n||C)+\"\",l?v.resolveWith(g,[p,C,E]):v.rejectWith(g,[E,C,d]),E.statusCode(x),x=void 0,f&&y.trigger(l?\"ajaxSuccess\":\"ajaxError\",[E,h,l?p:d]),m.fireWith(g,[E,C]),f&&(y.trigger(\"ajaxComplete\",[E,h]),--w.active||w.event.trigger(\"ajaxStop\")))}return E},getJSON:function(e,t,n){return w.get(e,t,n,\"json\")},getScript:function(e,t){return w.get(e,void 0,t,\"script\")}}),w.each([\"get\",\"post\"],function(e,t){w[t]=function(e,n,r,i){return g(n)&&(i=i||r,r=n,n=void 0),w.ajax(w.extend({url:e,type:t,dataType:i,data:n,success:r},w.isPlainObject(e)&&e))}}),w._evalUrl=function(e){return w.ajax({url:e,type:\"GET\",dataType:\"script\",cache:!0,async:!1,global:!1,\"throws\":!0})},w.fn.extend({wrapAll:function(e){var t;return this[0]&&(g(e)&&(e=e.call(this[0])),t=w(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(e){return g(e)?this.each(function(t){w(this).wrapInner(e.call(this,t))}):this.each(function(){var t=w(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=g(e);return this.each(function(n){w(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(e){return this.parent(e).not(\"body\").each(function(){w(this).replaceWith(this.childNodes)}),this}}),w.expr.pseudos.hidden=function(e){return!w.expr.pseudos.visible(e)},w.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},w.ajaxSettings.xhr=function(){try{return new e.XMLHttpRequest}catch(e){}};var Vt={0:200,1223:204},Gt=w.ajaxSettings.xhr();h.cors=!!Gt&&\"withCredentials\"in Gt,h.ajax=Gt=!!Gt,w.ajaxTransport(function(t){var n,r;if(h.cors||Gt&&!t.crossDomain)return{send:function(i,o){var a,s=t.xhr();if(s.open(t.type,t.url,t.async,t.username,t.password),t.xhrFields)for(a in t.xhrFields)s[a]=t.xhrFields[a];t.mimeType&&s.overrideMimeType&&s.overrideMimeType(t.mimeType),t.crossDomain||i[\"X-Requested-With\"]||(i[\"X-Requested-With\"]=\"XMLHttpRequest\");for(a in i)s.setRequestHeader(a,i[a]);n=function(e){return function(){n&&(n=r=s.onload=s.onerror=s.onabort=s.ontimeout=s.onreadystatechange=null,\"abort\"===e?s.abort():\"error\"===e?\"number\"!=typeof s.status?o(0,\"error\"):o(s.status,s.statusText):o(Vt[s.status]||s.status,s.statusText,\"text\"!==(s.responseType||\"text\")||\"string\"!=typeof s.responseText?{binary:s.response}:{text:s.responseText},s.getAllResponseHeaders()))}},s.onload=n(),r=s.onerror=s.ontimeout=n(\"error\"),void 0!==s.onabort?s.onabort=r:s.onreadystatechange=function(){4===s.readyState&&e.setTimeout(function(){n&&r()})},n=n(\"abort\");try{s.send(t.hasContent&&t.data||null)}catch(e){if(n)throw e}},abort:function(){n&&n()}}}),w.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),w.ajaxSetup({accepts:{script:\"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript\"},contents:{script:/\\b(?:java|ecma)script\\b/},converters:{\"text script\":function(e){return w.globalEval(e),e}}}),w.ajaxPrefilter(\"script\",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type=\"GET\")}),w.ajaxTransport(\"script\",function(e){if(e.crossDomain){var t,n;return{send:function(i,o){t=w(\"<script>\").prop({charset:e.scriptCharset,src:e.url}).on(\"load error\",n=function(e){t.remove(),n=null,e&&o(\"error\"===e.type?404:200,e.type)}),r.head.appendChild(t[0])},abort:function(){n&&n()}}}});var Yt=[],Qt=/(=)\\?(?=&|$)|\\?\\?/;w.ajaxSetup({jsonp:\"callback\",jsonpCallback:function(){var e=Yt.pop()||w.expando+\"_\"+Et++;return this[e]=!0,e}}),w.ajaxPrefilter(\"json jsonp\",function(t,n,r){var i,o,a,s=!1!==t.jsonp&&(Qt.test(t.url)?\"url\":\"string\"==typeof t.data&&0===(t.contentType||\"\").indexOf(\"application/x-www-form-urlencoded\")&&Qt.test(t.data)&&\"data\");if(s||\"jsonp\"===t.dataTypes[0])return i=t.jsonpCallback=g(t.jsonpCallback)?t.jsonpCallback():t.jsonpCallback,s?t[s]=t[s].replace(Qt,\"$1\"+i):!1!==t.jsonp&&(t.url+=(kt.test(t.url)?\"&\":\"?\")+t.jsonp+\"=\"+i),t.converters[\"script json\"]=function(){return a||w.error(i+\" was not called\"),a[0]},t.dataTypes[0]=\"json\",o=e[i],e[i]=function(){a=arguments},r.always(function(){void 0===o?w(e).removeProp(i):e[i]=o,t[i]&&(t.jsonpCallback=n.jsonpCallback,Yt.push(i)),a&&g(o)&&o(a[0]),a=o=void 0}),\"script\"}),h.createHTMLDocument=function(){var e=r.implementation.createHTMLDocument(\"\").body;return e.innerHTML=\"<form></form><form></form>\",2===e.childNodes.length}(),w.parseHTML=function(e,t,n){if(\"string\"!=typeof e)return[];\"boolean\"==typeof t&&(n=t,t=!1);var i,o,a;return t||(h.createHTMLDocument?((i=(t=r.implementation.createHTMLDocument(\"\")).createElement(\"base\")).href=r.location.href,t.head.appendChild(i)):t=r),o=A.exec(e),a=!n&&[],o?[t.createElement(o[1])]:(o=xe([e],t,a),a&&a.length&&w(a).remove(),w.merge([],o.childNodes))},w.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(\" \");return s>-1&&(r=vt(e.slice(s)),e=e.slice(0,s)),g(t)?(n=t,t=void 0):t&&\"object\"==typeof t&&(i=\"POST\"),a.length>0&&w.ajax({url:e,type:i||\"GET\",dataType:\"html\",data:t}).done(function(e){o=arguments,a.html(r?w(\"<div>\").append(w.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},w.each([\"ajaxStart\",\"ajaxStop\",\"ajaxComplete\",\"ajaxError\",\"ajaxSuccess\",\"ajaxSend\"],function(e,t){w.fn[t]=function(e){return this.on(t,e)}}),w.expr.pseudos.animated=function(e){return w.grep(w.timers,function(t){return e===t.elem}).length},w.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l,c=w.css(e,\"position\"),f=w(e),p={};\"static\"===c&&(e.style.position=\"relative\"),s=f.offset(),o=w.css(e,\"top\"),u=w.css(e,\"left\"),(l=(\"absolute\"===c||\"fixed\"===c)&&(o+u).indexOf(\"auto\")>-1)?(a=(r=f.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),g(t)&&(t=t.call(e,n,w.extend({},s))),null!=t.top&&(p.top=t.top-s.top+a),null!=t.left&&(p.left=t.left-s.left+i),\"using\"in t?t.using.call(e,p):f.css(p)}},w.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each(function(t){w.offset.setOffset(this,e,t)});var t,n,r=this[0];if(r)return r.getClientRects().length?(t=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if(\"fixed\"===w.css(r,\"position\"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&\"static\"===w.css(e,\"position\"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=w(e).offset()).top+=w.css(e,\"borderTopWidth\",!0),i.left+=w.css(e,\"borderLeftWidth\",!0))}return{top:t.top-i.top-w.css(r,\"marginTop\",!0),left:t.left-i.left-w.css(r,\"marginLeft\",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&\"static\"===w.css(e,\"position\"))e=e.offsetParent;return e||be})}}),w.each({scrollLeft:\"pageXOffset\",scrollTop:\"pageYOffset\"},function(e,t){var n=\"pageYOffset\"===t;w.fn[e]=function(r){return z(this,function(e,r,i){var o;if(y(e)?o=e:9===e.nodeType&&(o=e.defaultView),void 0===i)return o?o[t]:e[r];o?o.scrollTo(n?o.pageXOffset:i,n?i:o.pageYOffset):e[r]=i},e,r,arguments.length)}}),w.each([\"top\",\"left\"],function(e,t){w.cssHooks[t]=_e(h.pixelPosition,function(e,n){if(n)return n=Fe(e,t),We.test(n)?w(e).position()[t]+\"px\":n})}),w.each({Height:\"height\",Width:\"width\"},function(e,t){w.each({padding:\"inner\"+e,content:t,\"\":\"outer\"+e},function(n,r){w.fn[r]=function(i,o){var a=arguments.length&&(n||\"boolean\"!=typeof i),s=n||(!0===i||!0===o?\"margin\":\"border\");return z(this,function(t,n,i){var o;return y(t)?0===r.indexOf(\"outer\")?t[\"inner\"+e]:t.document.documentElement[\"client\"+e]:9===t.nodeType?(o=t.documentElement,Math.max(t.body[\"scroll\"+e],o[\"scroll\"+e],t.body[\"offset\"+e],o[\"offset\"+e],o[\"client\"+e])):void 0===i?w.css(t,n,s):w.style(t,n,i,s)},t,a?i:void 0,a)}})}),w.each(\"blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu\".split(\" \"),function(e,t){w.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),w.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),w.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,\"**\"):this.off(t,e||\"**\",n)}}),w.proxy=function(e,t){var n,r,i;if(\"string\"==typeof t&&(n=e[t],t=e,e=n),g(e))return r=o.call(arguments,2),i=function(){return e.apply(t||this,r.concat(o.call(arguments)))},i.guid=e.guid=e.guid||w.guid++,i},w.holdReady=function(e){e?w.readyWait++:w.ready(!0)},w.isArray=Array.isArray,w.parseJSON=JSON.parse,w.nodeName=N,w.isFunction=g,w.isWindow=y,w.camelCase=G,w.type=x,w.now=Date.now,w.isNumeric=function(e){var t=w.type(e);return(\"number\"===t||\"string\"===t)&&!isNaN(e-parseFloat(e))},\"function\"==typeof define&&define.amd&&define(\"jquery\",[],function(){return w});var Jt=e.jQuery,Kt=e.$;return w.noConflict=function(t){return e.$===w&&(e.$=Kt),t&&e.jQuery===w&&(e.jQuery=Jt),w},t||(e.jQuery=e.$=w),w});\n"

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = routing;
	routing.$inject = ['$urlRouterProvider', '$locationProvider', '$stateProvider', '$translateProvider'];
	
	function routing($urlRouterProvider, $locationProvider, $stateProvider, $translateProvider) {
		var config = __webpack_require__(159);
		var clientName = config.clientName;
	
		config.AVAILABLE_LANG = config.AVAILABLE_LANG || ['es'];
	
		// Global site tag - Google Analytics 
		var newScript = document.createElement('script');
	
		newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + config.analyticKey;
		document.head.appendChild(newScript);
		var newScript = document.createElement('script');
		var inlineText = '    window.dataLayer = window.dataLayer || [];\n                        function gtag (){dataLayer.push (arguments);}\n                        gtag (\'js\', new Date ());\n                        gtag (\'config\',"' + config.analyticKey + '");';
		var inlineScript = document.createTextNode(inlineText);
	
		newScript.appendChild(inlineScript);
		document.head.appendChild(newScript);
	
		//
	
		var translationsConfig = {};
	
		for (var i in config.AVAILABLE_LANG) {
			try {
				translationsConfig[config.AVAILABLE_LANG[i]] = __webpack_require__(160)("./" + config.clientName + '_' + config.AVAILABLE_LANG[i] + '.json');
			} catch (error) {
				translationsConfig[config.AVAILABLE_LANG[i]] = __webpack_require__(167)("./uplanner_" + config.AVAILABLE_LANG[i] + '.json');
			}
		}
	
		for (var lang in translationsConfig) {
			$translateProvider.translations(lang, translationsConfig[lang]);
		}
	
		$translateProvider.preferredLanguage('es');
	
		$locationProvider.html5Mode(true);
		$urlRouterProvider.otherwise('/app/welcomeHome');
		$stateProvider.state('app', {
			url: '/app',
			abstract: false,
			views: {
				'': {
					template: __webpack_require__(168)
				},
				'content': {
					template: __webpack_require__(169)
				},
				'aside': {
					template: __webpack_require__(170),
					controller: 'AsideCtrl'
				},
				'header': {
					template: __webpack_require__(171),
					controller: 'HeaderCtrl'
				},
				'chatbox': {
					template: __webpack_require__(172),
					controller: 'ChatboxController',
					controllerAs: 'chatbox'
				}
			}
		}).state('fullscreen', {
			url: '/app',
			abstract: false,
			views: {
				'': {
					template: __webpack_require__(173)
				},
				'content': {
					template: __webpack_require__(174)
				},
				'aside': {
					template: __webpack_require__(175),
					controller: 'AsideCtrl'
				},
				'header': {
					template: __webpack_require__(176),
					controller: 'HeaderCtrl'
				},
				'chatbox': {
					template: __webpack_require__(172),
					controller: 'ChatboxController',
					controllerAs: 'chatbox'
				},
				'footer': {
					template: __webpack_require__(177)
				}
			}
		}).state('app.unauthorized', {
			abstract: false,
			url: '/unauthorized',
			template: __webpack_require__(178),
			data: { displayName: ' ' }
		}).state('fullscreen.welcomeHome', {
			abstract: false,
			url: '/welcomeHome',
			template: __webpack_require__(179),
			controller: 'welcomeCtrl',
			controllerAs: 'wCtrl'
		}).state('login', {
			abstract: false,
			url: '/login',
			content: {
				template: ''
			},
			aside: {
				template: ''
			},
			header: {
				template: '',
				controller: 'HeaderCtrl'
			},
			template: __webpack_require__(180),
			controller: 'loginController',
			controllerAs: '$ctrl'
		}).state('loginMessage', {
			abstract: false,
			url: '/login-message/:message',
			controller: 'loginErrorMessageController',
			controllerAs: '$ctrl',
			template: __webpack_require__(181)
		});
	}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports = {"SERVER_NAME":"https://rosario-uf-demo.u-planner.com/","STATIC_IMAGE_URL":"https://urosariostoragetest.blob.core.windows.net","SERVICE_URL_CONSTANT":{"rosario":"https://rosario-uf-demo-api.u-planner.com/api/rosario-api","adminPanel":"https://rosario-uf-demo-api.u-planner.com/api","userApi":"https://rosario-uf-demo-api.u-planner.com","dataExecution":"https://rosario-uf-demo-api.u-planner.com/api/integration-api/shellexecution"},"PORT":"8080","PRODUCTION_HOST":"0.0.0.0","USER_API_URL":"https://rosario-uf-demo-api.u-planner.com","LANGUAGE_LAYER":false,"productionEnv":"server","clientName":"rosario","AVAILABLE_LANG":["en","es","por"],"loginType":"adal","POWERBI_CONSTANT":{"ANALYSIS_URL":"https://analysis.windows.net/powerbi/api","CLIENT_GROUP_ID":"4b63b8e4-cad1-4318-802f-efd3c2e11cb3","POWERBI_API":"https://api.powerbi.com/v1.0/myorg/","CLIENT_REPORT":{"REPORT_FACULTY1":"Rosario U-Faculty - Portafolio de Profesores [DEMO]","REPORT_FACULTY2":"Rosario U-Faculty - Perfil de Profesores [DEMO]","REPORT_FACULTY3":"Rosario U-Faculty - Plan de Trabajo Profesores [DEMO]"},"CLIENT_DATASET":{"DATASET_FACULTY1":"5551dced-f3bc-4074-9fb2-e3a48c78ec69","DATASET_FACULTY2":"daed30a4-2add-413e-9f58-256e04df87d6","DATASET_FACULTY3":"2e0e4101-52ed-4ff4-8c37-d72720521081"},"API_URL":"https://rosario-uf-demo-api.u-planner.com/api/user-api/powerbiCredential"}}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./rosario_en.json": 161,
		"./rosario_es.json": 162,
		"./rosario_por.json": 163,
		"./uplanner_en.json": 164,
		"./uplanner_es.json": 165,
		"./uplanner_por.json": 166
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 160;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = {"ACCESS_CONFIG":"Access configuration","ADMIN_GRUPOS":"Group administrator","ADMIN_PANEL":"Admin panel","ADMIN_ROLES":"Role administrator","ADMIN_USUARIOS":"User administrator","ASSOCIATED_GROUPS":"Associated groups","CREATE_NEW_GROUP":"Create new group","CREATE_NEW_ROLE":"Create new role","CREATE_NEW_USER":"Create new user","DATE_LAST_ENTRY":"Date of last entry","DEACTIVATE_GROUP":"Deactivate group","DEACTIVATE_REGISTRY_MSJ":"¿Do you want to deactivate this registry?","DEACTIVATE_ROLE":"Deactivate role","DEACTIVATE_USER":"Deactivate user","EDIT_ASSIGNMENT":"Edit assignment","EDIT_USER":"Edit user","EMAIL_NOT_VALID_MSJ":"The e-mail is not valid","GENERATED_GROUPS":"Generated groups","GROUP_ADMIN":"Group Administration","GROUP_NAME":"Group name","INSERT_FULL_NAME_MSJ":"Please, insert the full name","INSERT_INSTITUTION_MSJ":"Please, select a institution","INSERT_PASSWORD_AGAIN_MSJ":"Please, repeat the password","INSERT_PASSWORD_MSJ":"Please, insert a password","INSERT_USER_NAME_MSJ":"Please, insert the user name","PASSWORD_NOT_MATCH_MSJ":"The passwords do not match","PERSONAL_INFO":"Personal information","REPEAT_PASSWORD":"Repeat password","ROLE_ADMIN":"Role Administration","ROLE_NAME":"Role name","SECTIONS":"Sections","SELECT_GROUP_TYPE_PLACEHOLD":"Select group type...","SELECT_INSTITUTION_PLACEHOLD":"Select institution...","TYPE_OF_USER":"Type of user","USER_ADMIN":"User Administration","USER_ROLES":"User roles","USERNAME":"User name","absence-percentage":"Absence Percentage","acceso-a-tablas-de-filtrado":"Filter table access","acceso-administracion-grupos":"Group admin access","acceso-administracion-roles":"Role admin access","acceso-administracion-usuarios":"User admin access","acceso-carga-demand-global":"Load global demand access","acceso-carga-disponibilidad-docente":"Load teacher availability access","acceso-carga-grupos":"Load group access","acceso-carga-listas-cruzadas":"Load cross-list access","acceso-mantenedor-cargo-docente":"Teacher role management access","acceso-mantenedor-de-costo-eva-docente":"Teacher evaluation cost management access","acceso-mantenedor-de-jornadas":"Shift management access","acceso-mantenedor-disponibilidad-docente":"Teacher availability access","acceso-mantenedor-docente-materia-actividad":"Teacher activity course management access","acceso-mantenedores-de-recursos":"Resource management access","acceso-mantenedores-de-tipo-de-uso":"Usage type management access","acceso-pantalla-inicio":"Home access","acceso-perfil":"Perfil access","acceso-programacion-academica":"Academic programming access","acceso-restriccion-ubicacion-actividad":"Location activity restriction access","acceso-simulacion-forecast":"Forecast simulation access","acceso-simulacion-group":"Group simulation access","acceso-simulacion-schedule":"Schedule simulation access","acceso-simulacion-teacher":"Teacher simulation access","acceso-simulaciones":"Simulation access","acceso-syllabus":"Syllabus access","acceso-tiempo-de-traslado":"Transfer time access","acciones-materias":"Course actions","actividades-extracurriculares":"Extracurricular activities","activos-de-aula":"Classroom assets","actualizacion-contenido":"Content update","actualizacion-notas":"Grades update","administar-publicidad":"Advertising administration","alertas-individuales":"Individual alerts","algorithm-log":"Algorithm log","apertura-clases":"Open classes","aplicaciones-virtuales":"Virtual apps","apuntes":"Notes","asignaciones-app.v-por-curso":"","asignaturas-con-mayor-cantidad-de-alumnos":"Courses with highest amount of students","asistencia-clase-actual":"Current class attendance","asistencia-docentes":"Teacher attendance","asistencia-estudiantes":"Student attendance","assisted-classes":"Assisted Classes","attendance":"Attendance","attendance-percentage":"Attendance Percentage","auto-attendance":"Auto Attendance","backend-log":"Backend log","bitacora-de-contactos":"Contact binnacle","buscar-reserva":"Search booking","calendario-academico":"Academic schedule","calibracion-del-modelo":"Model calibration","carga-listas-cruzadas":"Loading cross list","carga-nuevos-estudiantes":"Loading new students","carga-periodo-anterior":"Load previous period","carga-restriccion-salas":"Load classroom restriction","carrera/edificio":"Career/Building","carreras":"Career","competencias-avance-curricular":"Curriculum advance competency","configuracion":"Configuration","configuracion-listas-cruzadas":"Cross-list config","configuracion-matricula-óptima":"Optimum enrollment config","configuracion-programacion-academica":"Academic programming config","configurar-disponibilidad-docente":"Teacher availability config","configurar-funcion-objetivo":"Objective function config","confirmacion":"Confirmation","content":"Content","costo-curso-actividad":"Activity course cost","cuadro-de-mando":"Control panel","cupo-academico":"Academic quota","current-class-content":"Current class content","current-class-notes":"Current class notes","curso/edificio":"Course/Building","datos-de-contacto":"Contact information","dictated-classes":"Dictated Classes","docentes":"Teachers","encuestas":"Surveys","encuestas-de-preferencia":"Preference surveys","estructuras-evaluacion":"Structure evaluation","estructuras-evaluacion-por-seccion":"Structure evaluation by section","evidencia-logro-competencias":"Competency achievements evidence","evolucion-de-la-desercion-historica":"Historical desertion evolution","exportar-datos":"Export data","factor":"Factor","facultades":"Faculties","finish-class":"Finish Class","generator-random-code":"Generator random code","generator-random-code-courses":"Generator random code courses","generator-random-code-periods":"Generator random code periods","grade-calculator":"Grade calculator","grade-official":"Grade official","grade-percentaje":"Grade percentaje","grade-progress":"Grade progress","grade-unofficial":"Grade unofficial","grades":"Grades","grades-access":"Grades access","grades-formula":"Grades formula","grafico-de-estudiantes-en-riesgo-por-periodo":"Student risk by period's graphic","historic-attendance":"Historic Attendance","historic-classes-notes":"Historic classes notes","historic-content":"Historic content","holgura-cupo-academico":"Academic quota leeway","inicio-class":"Class home","inicio-planning":"Planning home","inicio-retention":"Retention Home","inicio-suite":"Suite home","inputs-del-modelo":"Model input","integration-booking":"Booking Integration","integration-class":"Class Integration","integration-enrollment":"Enrollment Integration","integration-faculty":"Faculty Integration","integration-forecast":"Forecast Integration","integration-improve":"Improve Integration","integration-planning":"Planning Integration","integration-retention":"Retention Integration","listado-escenarios":"Scenario list","listado-estudiantes-curso":"Course student list","logro-competencias-estudiantes":"Student's competency achievement","mantenedor-curso-actividad":"Course activity management","mantenedor-matrices-competencia":"Competency matrix management","mantenedor-plan-de-estudios":"Study plan management","mantenedor-valor-curso-actividad":"Activitie course value management","menu-lateral-izquierdo":"Left sidebar","niveles-de-desarrollo-de-competencias":"Competency development levels","operaciones-manuales":"Manual operations","option-repeat":"Option repeat","periodos":"Periods","permisos-estructura-workflow":"Workflow structure permissions","plan-curso-electivo":"Elective course plan","porcentaje-uso-de-sillas":"Chair use percentage","power-bi":"Power Bi","probabilidad-historica":"Historical probability","profesores-con-mayor-cantidad-de-alumnos-en-r":"Teachers with highest amount of students in risk","razones-de-desercion":"Desertion reasons","recursos":"Resources","registro-de-asistencia":"Attendance registration","registro-de-contenido":"Content registration","registro-de-notas":"Grade records","registro-de-observaciones":"Observations registry","reporte-asistencia-docente":"Teacher attendance report","reporte-de-comparacion":"Comparison report","reporte-de-uso-de-infraestructura":"Infrastructure use report","reporte-de-utilizacion-de-salas":"Classroom use report","reporte-detalle":"Detail report","reporte-estado-eventos":"Event status report","reporte-planificacion-diaria":"Daily planning report","reporte-por-curso":"Report by course","reporte-por-estudiante":"By student report","reporte-por-profesor":"Report by teacher","reporte-power-bi":"Power Bi report","reporte-realizacion-actividades":"Activities report","reporte-tiempo-confirmacion":"Confirmation/Time report","reserva":"Reservation","restriccion-horario-salas":"Schedule and classroom restriction","resultado-de-carga-de-datos":"Loading data result","scheduled-classes":"Scheduled Classes","seguimiento-syllabus":"Syllabus tracking","tabla-actividad":"Activity table","tabla-actividad-asignatura-detalle":"Activity course detail table","tabla-actividad-asignatura-tipo-uso":"Activitie course usage type table","tabla-arancel-carrera":"Career tariff table","tabla-campus":"Campus table","tabla-campus-bdi":"BDI campus table","tabla-carrera":"Career table","tabla-departamento":"Department table","tabla-docente":"Teacher table","tabla-docente-asignatura-actividad-sede":"Course activity campus teacher table","tabla-docente-valor-hora-evaluacion":"Hour cost evaluation teacher table","tabla-hora-clase":"Hour class table","tabla-infraestructura":"Infrastructure table","tabla-infraestructura-tipo-uso":"Usage type infrastructure table","tabla-institucion":"Institution table","tabla-jornada":"Shift table","tabla-materia-departamento":"Department course table","tabla-materia-plan":"Study plan course table","tabla-modulos-jornada":"Shift modules table","tabla-nota-clase":"Grade course table","tabla-periodo":"Period table","tabla-periodo-bdi":"BDI period table","tabla-pivote":"Pivot table","tabla-plan-estudio":"Study plan table","tabla-plan-estudio-asignatura":"Study plan course table","tabla-plan-estudio-turno":"Study plan turn table","tabla-planes-campus":"Study plan campus table","tabla-valor-hora-asignatura":"Price hour course table","tasa-de-aprobacion":"Approval rate","tipo-contrato-docente":"Teacher contract type","tipo-de-recurso":"Resource type","tributacion-de-curso-a-competencias":"Competency course tribute","ubicacion":"Location","utilizar-disponibilidad-docente":"Use teacher availability","vista-coordinador":"Coordinator view","vista-estudiante":"Student view","workflow":"Workflow","ACTIVE_PL":"Active","ACTIVITY_MANAGEMENT":"Activity management","ACTIVITY_VISUALIZATION":"activity visualization","ADD_ADVERTISING":"Add advertising","ADD_CLASSROOM_ASSET":"Add classrom asset","ADD_COURSE":"Add course","ADD_EDIT_COURSES_FOR_APP_VIRTUAL":"Add/Edit courses for app virtual","ADD_EDIT_COURSES_FOR_VIRTUAL_APP":"Add / Edit courses for Virtual App","ADD_RESOURCE_TYPE":"Add resource type","ADD_STATIONS":"Add stations","ADMIN_SCREENS":"Admin rotary screens","ADVERTISING":"Advertising","ADVERTISING_TYPE":"Advertising type","AFTER_START":"After start","ALLOW_RESERVATIONS_IN":"Allow reservations in","APPLICANT":"Applicant","APPLICATION":"Application","ASSETS":"Classroom assets","ASSIGN_RESOURCE":"Assign resource","ASSIGN_SCHEDULE":"Assign schedule","ATTACH_TO":"Attach to","ATTACH_TO_ROTARY_SCREEN":"Attach to rotary screen","AVAILABLE_TO_DISABLED_PEOPLE":"Available to disabled people","BEFORE_START":"Before start","BLOCKED_SCHEDULE":"Blocked schedule","BOOKING_DETAIL":"Booking detail","BOOKING_DONE":"Booking done successfully","BOOKING_FAILURE":"Booking failure","BOOKING_FREE":"Booking free","BUILDING_NAME":"Building Name","CALENDAR_CONFIRM_PROFILE":"Calendar (Confirm profile)","CALENDAR_RESERVATION_PROFILE":"Calendar (Reservation profile)","CAMPUS_ORIGIN_OF_THE_ROLE":"Campus origin of the role","CANCELED_EVENT":"Cancelled event","CLASSROOM_ASSET_IN_USE":"Class assets in use","CLASSROOM_ASSETS":"Classroom assets","CLONE_PERIOD":"Clone period","CONFIRM_CLASSROOM_ASSET_IN_USE_ADD":"The asset is being used by the resource '{{resourceName}}', \n adding it will remove the previous association. Do you want to continue?","CONFIRM_DELETE":"Confirm Delete","CONFIRM_DELETE_RESERVATIONS_MSJ":"Are you sure you want to delete the selected reservations?","CONFIRM_INACTIVATE":"confirm inactivate","CONFIRM_RESERVATION":"confirm reservation","CONFIRMED_EVENT":"Confirmed event","CONTROL_PANEL":"Control panel","COURSE_CODE":"Code","COURSE_NAME":"Name","COURSES_ADDED":"courses added","CREATE_BUILDING":"Create Building","CREATE_BUILDING_FOR":"Create Building for","CREATE_CATEGORY":"Create Category","CREATE_CLASSROOM_ASSETS":"Create classroom assets","CREATE_EDIT_RESOURCE":"Create/Edit resource","CREATE_EDIT_VIRTUAL_APP":"Create/Edit virtual app","CREATE_FLOOR":"Create Floor","CREATE_FLOOR_FOR":"Create Floor for","CREATE_NEW_RESERVATION":"Create new reservation","CREATE_RESOURCE_TYPE":"Create Resource Type","CREATE_SCREEN":"Create screen","CREATE_USAGE_TYPE":"Create Usage Type","CREATE_VIRTUAL_APP":"Create Virtual App","CREATED_BY":"created by","CREATION_DATE":"Creation date","CURRENT_AND_FOLLOWING_RESERVATIONS":"Current and following reservations","CURRENT_RESERVED":"Hours to reserve","CURRICULAR_EVENTS":"Curricular Events","DEFINE_RESERVATION":"Define reservation","DELETE_EVENT":"Delete event","DELETE_RESERVATION_MSJ":"Are you sure you want to delete the reservation?","DELETE_RESERVATIONS":"Delete reservations","DELETE_SCREEN_CONFIG":"Delete screen configuration","DESCRIPTION_ACTIVE_RESOURCE":"The resource is available for use ","DESCRIPTION_REAL_RESOURCE":"The resource is tangible in the institution","DESCRIPTION_RESOURCE_WITH_UNIVERSAL_ACCESSIBILITY":"Usable resource for people with special needs","DESCRIPTION_SYNCHRONIZABLE_RESOURCE":"The resource comes by integration","DESCRIPTION_VIRTUAL_RESOURCE":"The resource will be used in virtual contexts","DETAIL_APPLICATION":"Detail application","DETAILS_RESERVATION":"Details of the reservation","EDIT_CLASSROOM_ASSETS":"Edit classroom assets","EDIT_CONFIRM_RESERVATION_MSJ":"The applicant and responsible will be notified by email","EDIT_RESERVE":"Edit reserve","EDIT_RESOURCE":"Edit resource","EDIT_SCREEN":"Edit screen","EDITED_BY":"Edited by","ELIMINATE_MASSIVE":"Eliminate massive","END_DATE":"End date","END_MODULE":"End module","END_TIME":"End time","ENTER_CATEGORY_MSJ":"Please enter category","ENTER_CODE_MSJ":"Please enter code","ENTER_DATE_MSJ":"Please select start date","ENTER_NAME_MSJ":"Please enter name","ENTER_RESOURCE_MSJ":"Please enter resource","EVENT":"Event","EVENT_DELAYED":"Event delayed","EVENT_NAME":"Name event","EVENTS_DISPLAY_TIME_PER_PAGE":"Events display time per page","EXCEPTIONS":"Exceptions","EXTRACURRICULAR_ACTIVITIES":"Extracurricular activities","EXTRACURRICULAR_EVENTS":"Extracurricular Events","FAILED_CLONING":"Failed clonning","FILE_FORMAT_IMAGE_MSJ":"The files must be JPG, TIFF format","FILE_FORMAT_VIDEO_MSJ":"The files must be MOV, MP4 format","FILTER_PER_HOUR":"Filter per hour","FILTERS_FOR_SECTION":"filters for section","FLOOR_NAME":"Floor Name","FONT_SIZE":"Font size","INACTIVE_PL":"Inactive","INFORMATION_VISIBLE_IN_ROTARY_SCREEN_NOTE_MSJ":"Note: This info will be visible in rotary screen","INSERT_ADVERTISING_BETWEEN_ACTIVITIES":"Insert advertising between activities","IT_IS_NOT_POSSIBLE_INACTIVE_BUILDING":"It is not possible to inactivate the building","IT_IS_NOT_POSSIBLE_INACTIVE_FLOOR":"It is not possible to inactivate the floor","IT_IS_NOT_POSSIBLE_INACTIVE_RESOURCE_TYPE":"It is not possible to inactivate the Resource Type","MANAGE_ADVERTISING":"Manage advertising","MANAGE_VIRTUAL_APPLICATIONS":"Administrar Aplicaciones Virtuales","MAXIMUM_ANTICIPATION_TIME_PER_RESERVATION":"Maximum anticipation time per reservation","MAXIMUM_OF_RESPONSIBLE":"Maximum of responsible","MAXIMUM_RESERVATION_TIME_PER_DAY":"Maximum reservation time per day","MAXIMUM_TIME_TO_ACTIVATE":"Maximum time to activate","MINIMUM_ANTICIPATION_TIME_PER_RESERVATION":"Minimum anticipation time per reservation","MINIMUM_NUMBER_OF_USERS_PER_RESERVATION":"Minimum number of users per reservation","MINIMUM_RESERVATION_TIME_PER_DAY":"Minimum reservation time per day","MINIMUM_TIME_TO_ACTIVATE":"Minimum time to activate","MODIFICATION_DATE":"Modification_date","MSJ_APP_VIRTUAL_CREATED_SUCCESS":"App Virtual created successfully","MSJ_BOOKING_DONE_AND_CODE":"Booking done successfully. booking code is","MSJ_BUILDING_CODE_ALREADY_EXISTS":"Code already exists","MSJ_BUILDING_CREATED_SUCCESSFULLY":"Building created successfully","MSJ_BUILDING_DELETED_SUCCESSFULLY":"Building deleted successfully","MSJ_BUILDING_UPDATED_SUCCESSFULLY":"Building updated successfully","MSJ_CLONE_PERIOD_VIRTUAL_APP":"Replace courses and Virtual Apps from an existing academic period to a new period","MSJ_CONFIRM_INACTIVATE_BUILDING":"Are you sure you want to inactivate this building? You can have associated floors.","MSJ_CONFIRM_INACTIVATE_FLOOR":"Are you sure you want to inactivate this floor?","MSJ_DELETE_BUILDING":"Are you sure to delete this building?","MSJ_DELETE_FLOOR":"Are you sure to delete this floor?","MSJ_DELETE_RESOURCE_TYPE":"Are you sure to delete this resource type?","MSJ_DELETE_USAGE_TYPE":"Are you sure to delete this usage type?","MSJ_ENTER_REQUERID_FIELD":"Please enter the requerid field","MSJ_FLOOR_CODE_ALREADY_EXISTS":"Code already exists","MSJ_FLOOR_CREATED_SUCCESSFULLY":"Floor deleted successfully","MSJ_FLOOR_DELETED_SUCCESSFULLY":"Floor created successfully","MSJ_FLOOR_UPDATED_SUCCESSFULLY":"Floor updated successfully","MSJ_MAXIMUM_RESERVATION_TIME_EXCEEDED":"Maximum reservation time exceeded","MSJ_NO_DATA_ROTATIVE":"","MSJ_PLEASE_ENTER_NAME_AND_CODE":"Please enter name and code","MSJ_PLEASE_SELECT_A_COURSE_TO_ASSOCIATE":"Please select a course to associate","MSJ_PLEASE_SELECT_DIFFERENT_PERIOD":"Please select different target period to clone","MSJ_PLEASE_SELECT_RESOURCE_USAGETYPE":"Please select resource and usage type","MSJ_PLEASE_SELECT_USAGETYPE":"Please select usage type","MSJ_RESERVATION_SUCCESSFUL":"Reservation sucessful","MSJ_SELECT_ONE_ROW_TO_DELETE":"Select atleast one row to delete","MSJ_THERE_NO_DATA_RELATED_TO_YOU_SEARCH":"There is no data related to your search criteria","MULTICAMPUS":"Multicampus","MULTIMEDIA_LIBRARY":"Multimedia library","MY_RESERVATIONS":"My Reservations","N_OF_ROWS_PER_SCREEN":"N° rows per screen","NOTIFY_BY_EMAIL_APPLICANT_TEACHER_SECTION_STUDENTS_MSJ":"It will notify by email to applicant, teacher, and section's students","NUMBER_OF_LICENSES":"Number of licenses","ONLY_THIS_RESERVATION":"Only this reservation","ORDER":"Order","PER_PAGE":"per page","PERIOD_OF_ORIGIN":"period of origin","PERIOD_TO_LINK":"Period to link","PERIOD_TO_REPLACE":"Period to replace","PERMISSIONS_FOR":"Permissions for","REPEATS_UNTIL_THE":"Repeats until the","RESERVATION_DATE":"Reservation date","RESERVATION_PERIOD":"Reservation period","RESERVATION_TYPE":"Reservation type","RESERVATIONS_PARAMETERS":"Reservation parameters","RESERVE":"Reserve","RESERVED_SCHEDULE":"Reserved schedule","ROTARY_SCREEN":"Rotary screen","ROTARY_SCREENS_CONFIG":"Rotary screens configuration","SCHEDULE_ASSIGNMENT":"Schedule assignment","SCHEDULE_BY_CAREER":"Schedule by career","SCHEDULE_BY_RESOURCE":"Schedule by resource","SCREEN_LIST":"Screen list","SCREENS_LIST":"Rotary screens list","SEARCH_BY_HOURS":"Search by hours","SEARCH_EVENT":"Search event","SEARCH_FOR":"Search for","SEARCH_RESERVATION":"Search Reservation","SEC":"Sec.","SELECT_ACTIVITY":"Select activity","SELECT_ATTENDANCE_STATUS":"Select Attendance Status","SELECT_BUILDING":"Select building","SELECT_CATEGORY":"Select category","SELECT_CLASSROOM_ASSETS":"Select classroom assets","SELECT_FLOOR":"Select floor","SELECT_RESOURCE_TYPE":"Select resource type","SELECT_TYPE_ACTIVITY":"Select type activity","SELECT_USAGE_TYPE":"Select usage type","SHOW_AVAILABILITY_BY":"Show availability by","SHOW_CANCELED_EVENTS":"Show canceled events","START_DATE":"Start date","START_MODULE":"Start module","START_TIME":"Start time ","STATION":"Station","STATIONS":"Stations","SUMMARY_BOOKING":"Summary booking","SURE_TO_DELETE_CONFIG_MSJ":"Are you sure to delete this configuration?","TEACHER_ABSENT":"Teacher absent","TEACHER_PRESENT":"Teacher attends","TEACHER_REPLACEMENT":"Teacher replacement","TEACHER_SUBSTITUTE":"Substitute teacher","THERE_ARE_ASSOCIATED_RESOURCES":"There are associated resources","THERE_ARE_FLOORS_WITH_ASSOCIATED_RESOURCES":"There are the following floors with associated resources:","THERE_ARE_RESOURCES_ASSOCIATED":"There are the following associated resources:","TIME":"Time","U_BOOKING":"u-booking","UNIVERSAL_ACCESSIBILITY":"Universal accessibility","UNLIMITED":"unlimited","UPDATE_CURRICULAR_ACTIVITY":"update curricular activity","UPDATE_EXTRACURRICULAR_ACTIVITY":"Update extracurricular activity","VIRTUAL_APP_ASSOCIATIONS_PER_COURSE":"Virtual app associations per course","VIRTUAL_APPS":"Virtual apps","VIRTUAL_APPS_ASSOCIATION":"Virtual apps association","VIRTUAL_APPS_RESERVE":"Virtual apps reservation","VIRTUAL_LAB":"Laboratorio virtual","ABSENCES":"Absences","ABSENT":"Absent","ABSENT_LABEL":"A","ACADEMIC_SECRETARY":"Academic secretary","ADD_STUDENT_TO_LIST":"Add student to list","ALREADY_GENERATED":"Generated Code","APPROVED":"Approved","ASIGNED":"Asigned","ASSIGN_SECTIONS_TO_STRUCTURE":"Assign sections to structure","ASSISTED":"Assisted","ATTENDANCE":"Attendance","ATTENDANCE_AVERAGE":"Average attendance","ATTENDANCE_AVERAGE_LAST_WEEK":"Average attendance last week","ATTENDANCE_CHART":"Attendance chart","ATTENDANCE_DETAIL_BY_DATE":"Attendance detail by date","ATTENDANCE_PERCENTAGE":"Attendance percentage","ATTENDANCE_PERCENTAGE_LAST_WEEK":"Percentage of attendance of the section","ATTENDANCE_RATE":"Attendance rate","ATTENDANCE_REGISTRATION":"Attendance registration","ATTENDANCE_RISK_STUDENTS":"Attendance risk students","AUTHENTICATION":"Authentication","AVAILABLE_EVALUATIONS":"Available evaluations","CAL":"Calification","CLASS_NOTES":"Class Notes","CLASSES_WITH_ATTENDANCE":"Classes with attendance","COMPONENT_NAME":"Component name","COURSE_ATTENDANCE_REPORT":"Attendance report by course","COURSE_IN_PROGRESS":"In progress","COURSE_INFO":"Course info","COURSE_STUDENT_LIST":"Student list","COURSES_INFO":"Courses info","CREATE_EVALUATION_ESTRUCTURE":"Create evaluation estructure","CURRENT":"Current","CURRENT_CLASS":"Current class","DEL":"Delegado","DELEGATE":"Delegate","DELEGATES_ASSIGNMENT":"Student list","DICTATED":"Dictated","DOWNLOAD_RECORDS":"Download records","DPI":"Disapproved for not attendance","EDIT_ATTENDANCE":"Edit attendance","ENTER_GRADES":"Enter Grades","EVALUATION_STRUCTURE_EMPTY_STATE":"Select a structure to see details...","EXECUTED_CLASSES":"Executed classes","FINISH_CLASS":"Finish class","FINISH_CLASS_ASK":"Do you want to finish the class?","FORMULA":"Formula","GENERATE_RANDOM_CODE":"Generate random code","GENERATE_RANDOM_CODES":"Generate random codes","GRADE":"Grade","GRADES_REGISTERED":"Grades registered","HISTOGRAM":"Histogram","INDICATORS":"Indicators","INDICATORS_BY_COURSE":"Course indicator","INDICATORS_BY_STUDENT":"Student indicators","INDICATORS_BY_TEACHER":"Teacher indicators","INFO_ATTENDANCE_RISK_STUDENTS":"Info attendance risk students","INFO_GRADES":"Grades information","INITIATED_CLASSES":"Initiated classes","JUSTIFIED":"Justified","JUSTIFIED_LABEL":"J","LEVEL_SCHEME":"Levels of competence development","LIST_OF_COURSES":"List of courses","LIST_OF_ONE":"List of 1","LIST_OF_STUDENTS":"List of students","LIST_OF_TEACHERS":"List of teachers","MANUAL_LABEL":"Manual","MANUALLY_REGISTERED":"Manually registered","MASSIVE_STATUS_EDITOR":"Massive status editor","MAX_ABSENCES":"Max absences","MAXIMUM":"Maximum","MENU_ACHIEVEMENT_OF_COMPETENCIES":"Achievement of competencies","MENU_CONTENT_RECORDS":"Content record","MENU_EVALUATION_STRUCTURES":"Evaluation structures","MENU_EVALUATIONS":"Evaluations","MENU_GRADE_RECORDS":"Grade records","MENU_HISTORICAL_ATTENDANCE":"Historical attendance","MENU_OPENING_OF_CLASES":"Opening of classes","MENU_RANDOM_CODE_GENERATOR":"Random Code Generator","MENU_RANDOM_CODE_GENERATOR_BY_COURSE":"Generate codes by course","MENU_RANDOM_CODE_GENERATOR_BY_PERIOD":"Generate codes by period","MENU_RANDOM_CODE_VIEW":"View generated codes","MENU_STRUCTURES_BY_SECTION":"Structures by section","MENU_STUDENT_ATTENDANCE":"Student attendance","MENU_STUDENT_STATUS":"Student status","MENU_TEACHER_ATTENDANCE":"Teacher attendance","MINIMUM":"Minimum","MODIFY_ATTENDANCE":"Modify attendance","MODULE_DAY":"Module/Day","MSJ_DEFINITIVE_SENDING_OF_GRADES":"Are you sure to send the grades? After that, you can't edit.","MSJ_DOESNT_HAVE_RANDOM_CODE":"In this evaluation doesn't have generate the random code. You can't upload or edit grades yet.","MSJ_GRADES_WITH_TWO_DECIMALS":"Las notas deben ser con dos decimales","MSJ_RESULT_CERO":"Student get a 0","MSJ_SELECT_REASON_FOR_GRADE":"Select the reason for the grade","MSJ_SENDING_SUCCEFULL_GRADES":"The record of grades in the Portal has been confirmed.","MSJ_STUDENT_DID_NOT_EVALUATION":"The student didn't the evaluation","MSJ_STUDENTS_WITHOUT_GRADES_TO_NR":"Students doesn't take the tests","MUST_DICTATE_CLASS":"Must dictate class","MUST_PROGRAM_NEXT_CLASS":"Must program next class","N_ABSENTS_MIN":"N° A","N_OF_ASSISTANTS":"N° of assistants","N_OF_CLASSES":"N° Classes","N_OF_CLASSES_DICTATED":"N° of classes dictated","N_OF_NRCS":"N° NRCs","N_PRESENTS_MIN":"N° P","NEXT_CLASS":"Next class","NO_ATTENDANCE_PERCENTAGE":"% No Attendance","NO_NEXT_CLASS":"Does not contain next class","NOT_REGISTERED":"Not registered","NOT_REGISTERED_LABEL":"N","NOT_STARTED_CLASSES":"Not started classes","NR":"Did not take the test","NRC_ATTENDANCE_AVERAGE":"Average total attendance NRCs","NRC_ATTENDANCE_AVERAGE_LAST_WEEK":"Average total attendance NRCs last week","NUM_OF_INSCRIPTIONS":"N° of inscriptions","OFFICIAL_GRADE":"Official Grade","PERIOD_ATTENDANCE":"Period attendance","PLANNED_CLASSES":"Planned classes until date","PRESENT":"Present","PRESENT_LABEL":"P","PROFESSOR_ATTENDANCE_REPORT":"Attendance report by teacher","PROM_ABSENTS_MIN":"Prom. A","PROM_PRESENTS_MIN":"Prom. P","RANDOM_CODE":"Random code","RANDOM_CODE_GENERATED":"Generated Code","RANDOM_CODE_GENERATOR_BY_COURSE":"Random code generator by course","RANDOM_CODE_GENERATOR_BY_PERIOD":"Random code generator by period","RANDOM_CODE_VIEW":"Random code view","REGISTER_ATTENDANCE":"Register attendance","REGISTER_CONTENT_EDIT":"Register content","REGISTER_CONTENTS":"Register contents","REGISTER_NOTES":"Register notes","REGISTRO_DE_NOTAS":"Grade records","RESUME_GRADES":"Grades Summary","RET":"Retired","RETIRED":"Alumno retirado","RETIRED_LABEL":"Retirado","SAN":"Sanctioned","SANCTIONED":"Alumno sancionado","SANCTIONED_LABEL":"Sancionado","SCHEDULED_CLASSES":"Scheduled classes","SECTION_ATTENDANCE_PERCENTAGE":"Percentage of attendance of the section","SECTION_ATTENDANCE_PERCENTAGE_LAST_WEEK":"Percentage of attendance of the section in the last week","SECTION_INFORMATION":"Section information","SECTIONS_BY_COURSES":"Section by courses","SECTIONS_INFORMATION":"Sections information","SEE_GRADES":"View grades","SEE_RECORDS":"See records","SELECCIONE_LA_ESTRUCTURA_QUE_DESEA_ASIGNAR":"","SHOW_GRAPHIC_BY":"Show graphic by","SIMULATED_RESULT":"Simulated result","START_CLASS":"Start class","STARTED_CLASSES":"Initiated classes","STUDENT_ATTENDANCE_INFO_FOR_SECTION":"Student attendance information for the section","STUDENT_ATTENDANCE_REPORT":"Attendance report by student","STUDENT_BELONGS_ANOTHER_SECTION":"Student belongs another section","STUDENT_DETAIL":"Student detail","STUDENT_EXISTS_IN_CLASS":"Student exists in class","STUDENT_IN_DPI":"Student with DPI","STUDENT_INFO":"Student info","STUDENT_LIST":"Student list","STUDENT_NOT_FOUND":"Student not found","SUBJECTS_INFORMATION":"Subjects information","SUM":"Sum","SUMAXIMUMM":"Maximum","TARDINESS":"Tardiness","TARDY":"Tardy","TARDY_LABEL":"D","TEACHER_CLASS_NOTES":"Teacher class notes","TEACHER_DETAIL":"Teacher detail","TEACHER_INFO":"Teacher info","TOTAL_ABSENT_STUDENTS":"Total absent students","TOTAL_CLASSES_IN_PERIOD":"Total classes in period","TOTAL_CLASSES_INITIATED":"Total classes initiated","TOTAL_CLASSES_NOT_INITIATED_WITH_ATTENDANCE":"Total classes not initiated with attendance","TOTAL_CLASSES_NOT_INITIATED_WITHOUT_ATTENDANCE":"Total classes not initiated without attendance","TOTAL_CLASSES_TO_DATE":"Total classes to date","TOTAL_PLANNED_CLASSES":"Total planned classes","TOTAL_PRESENT_STUDENTS":"Total present students","TOTAL_TARDY_STUDENTS":"Total tardy students","U_CLASS":"u-class","U_GRADES":"Grade records","UPLOAD_FILES_OF":"Upload files of","UPLOAD_RECORDS":"Upload records","UPLOAD_RESULTS":"Upload results","USE_IN_ANY_FORMULA":"Use in any fórmula","VALID_STUDENT":"Valid student","VIEW_CONSOLIDATED_GRADES":"View consolidated grades","VIEW_EDIT_ATTENDANCE":"View edit attendance","VIEW_EDIT_CONTENT":"View and edit contents","VIEW_EDIT_CONTENTS":"View edit contents","VIEW_EDIT_GRADES":"View edit grades","WARNING_GRADE_OUT_MIN_MAX":"Entered grade out of the allowed range","WITHOUT_CLASS":"Without class","WORKFLOW_FLOW":"Workflows","YEAR_OF_ENTRY":"Year of entry","ZERO_DIFFERENTIATION":"Zero differentiation","ACADEMIC_UNIT_ROLE":"Academic Unit Role","ADD_ACADEMIC_UNIT":"Add academic unit","ADD_CONTRACT_TYPE":"Add contract type","ASSIGNED_MODULES":"Assigned modules","ASSIGNED_SECTIONS":"Assigned sections","CALENDAR_INFORMATION":"Calendar information","CONTRACT_CODE":"Conttract code","CONTRACT_NAME":"Conttract name","CONTRACT_TYPE":"Contract type","COURSE_ACTIVITY_HOUR_COST":"Cost hour course activity","COURSES_LIST":"Course List","CREATE_ACADEMIC_CALENDAR":"Create academic calendar","CREATE_NEW_ELECTIVE_BLOCK":"Create new elective block","CREATE_SCHEME":"Create scheme","CREATE_TEACHER":"Create teacher","DEPARTMENT_POSITION":"","EDIT_SCHEME":"Edit scheme","EDIT_TEACHER":"Edit teacher","ELECTIVE_BLOCK_MANAGEMENT":"Elective block management","ELECTIVE_BLOCK_PLAN":"Elective block plan","FACULTY_MANAGEMENT":"Faculties","HELP_COURSE_ACTIVITY_HOUR_COST":"Hepl tex to course, activity, hour, cost","HELP_EDIT_ACADEMIC_CALENDAR":"Select the weeks that will make up the new academic calendar.","HELP_EDIT_ADD_TEACHER":"On this screen you can create, edit, and view the teachers in the system. You can assign them to a department and campus when defining a type of contract, and mark them as active or inactive for simulations. The teacher's information may or may not be syncronizable with the data updated through integration.","HELP_ELECTIVE_BLOCK_MANAGEMENT":"Help text block management","HOUR_COST":"Hour cost","INFRASTRUCTURE":"Infrastructure","LEVEL_SCHEME_MANAGER":"Level scheme manager","LEVELS":"Levels","MAX_AVAILABLE_MODULES":"Maximum available modules","MAX_CAMPUS_PER_DAY":"Maximum of daily campus","MAX_CAMPUS_PER_WEEK":"Maximum of weekly campus","MAX_CONSECUTIVE_MODULES":"Maximum of consecutive modules","MAX_MODULES_PER_DAY":"Maximum of daily modules","MAX_MODULES_PER_WEEK":"Maximum of weekly modules","MAX_PAUSED_MODULES":"Maximum of paused modules","MAX_SECTIONS_PER_DAY":"Maximum of daily sections","MAX_SECTIONS_PER_WEEK":"Maximum of weekly sections","MSJ_ACADEMIC_CALENDAR":"Utiliza el Calendario Académico para determinar un rango de tiempo de Semanas - Días - Módulos en un espacio determinado por Campus - Periodo - Jornada para luego asignarlos a determinadas secciones y mejorar su organización.","MSJ_ACADEMIC_CALENDAR_CREATED_SUCCESS":"Academic calendar created successfully","N_OF_IMPLICATED_MODULES":"Number of implicated modules","N_OF_IMPLICATED_SECTIONS":"Number of implicated sections","NEW_ACADEMIC_CALENDAR":"New academic calendar","NEW_SCHEME":"New scheme","PERIODS_MANAGEMENT":"Periods (Cycles)","PRIORITY":"Priority","SELECT_ACADEMIC_PLAN":"Select academic plan","TEACHER_PROFILE":"Teacher profile","U_CORE":"Configuration","MENU_REFERENCE_SURVEYS":"Reference surveys","MENU_SURVEYS":"Surveys","U_ENROLLMENT":"u-enrollment","ACADEMIC_SCHEDULE_SELECTION":"Academic schedule selection","ADVANCE_ASSIGNATION_SECTION":"Advance Assignation by section","ADVANCE_ASSIGNATION_SUBJECT":"Advance Assignation by Subject","ALL_SECTIONS":"All sections","AUTOMATIC_ASSIGNATION":"Automatic assignation","CONFIRM_DELETE_SCENARIO_MSJ":"Are you sure you want to delete the selection?","CONFIRM_UNASSIGN_RESOURCE":"Confirm unassign resource","CONFIRM_UNASSIGN_SCHEDULE":"Confirm Unassign Schedule","CONFIRM_UNASSIGN_SUPERVISOR":"Confirm unassign supervisor","CREATE_SCENARIO":"Create scenario","CREATE_SCENARIO_BY_SECTION":"Create scenario by section","CREATE_SCENARIO_BY_STUDENT":"Create scenario by student","CREATE_STAGE":"Create scenario","DELETE_SCENARIO":"Are you sure you want to delete {{scenarioName}}","ENTER_MANIMUM_CAPACITY":"Enter minimum capacity","ENTER_MAXIMUM_CAPACITY":"Enter maximum capacity","EVALUATION_MANAGEMENT":"Evaluations Management","EVALUATION_TYPE":"Evaluation Type","EXAM-NAME":"Exam name","GROUP":"Group","MANUAL_ASSIGNATION":"Manual assignment","MANUAL_ASSIGNMENT_RESOURCE":"Manual assignment of resource","MANUAL_SUPERVISOR_ASSIGNMENT":"Manual supervisor assignment","MAXIMUM_CAPACITY":"Maximum capacity","MAXIMUM_DAILY_EXAMS_PER_STUDENT":"Maximum daily exams per student","MSJ_AUTOMATIC_ASSIGNMENT_STARTED_CORRECTLY":"Automatic assignment has been started correctly","MSJ_CAN_NOT_SHOW_CALENDER":"Can not show calendar because it does not have weeks","MSJ_CONFIRM_UNASSIGN_RESOURCE":"Are you sure you want to eliminate the resource assigned for the selection?","MSJ_CONFIRM_UNASSIGN_SCHEDULE":"You are sure you want to delete the schedule assignment for the selection?. This implies de-allocation of Resource and Supervisor.","MSJ_CONFIRM_UNASSIGN_SUPERVISOR":"Are you sure you want to eliminate the supervisor assigned for the selection?","MSJ_CONFLICTS_OCCURED_FOR":"Note: conflicts occured for","MSJ_DOWNLOADED_SUCESSFULLY":"Downloaded successfully","MSJ_MODULE_INSERTED_SUCCESSFULLY":"Module Inserted successfully","MSJ_MODULE_SHOULD_BE_CONSECUTIVE":"module should be consecutive","MSJ_NO_ASSIGNED_WEEKS_FOUND":"No assigned weeks were found","MSJ_SCHEDULE_IS_NOT_YET_CREATED":"Schedule is not yet created","MSJ_THE_CHANGES_HAVE_NOT_BEEN_EXECUTED":"The changes have not been executed","MSJ_THERE_ARE_NO_AVAILABLE_WEEK":"There are no available weeks for the selected filters","MSJ_YOU_MUST_ASSIGN_SCHEDULE_BEFORE":"You must assign a schedule before assigning a resource or supervisor","NAME_EVALUATION":"Evaluation name","REP_ASSIGNMENT_RESULTS":"Assignment Results","REP_DATA_VALIDATION":"Data Validation","REP_LOADED_DATA":"Loaded Data","RESOURCE_ASSIGNATION":"Resource assignation","RESOURCE_CONFLICT":"Resource conflict","RESOURCE_DELETED_SUCCESSFULLY":"Resource deleted successfully","RESOURCE_SCHEDULE_BASELINE":"Resource/Schedule baseline","SCENARIO":"Scenario","SCENARIO_INFO":"Scenario information","SCENARIOS":"Scenarios","SCENARIOS_INFO":"Scenarios information","SCHEDULE_AND_RESOURCE":"Schedule and Resource","SCHEDULE_ASSIGNATION":"Schedule assignation","SCHEDULE_DELETED_SUCCESSFULLY":"Schedule deleted successfully","SCHEDULE_RANK":"Schedule Rank","SCHEDULE_RANK_SELECT":"Selection Schedule Rank","SCHEDULE_RESOURCE_AND_SUPERVISOR":"Schedule, resource and supervisor","SEARCH_RESOURCE":"Search resource","SECTION_ASSIGNATION":"Section assignation","SECTION_DETAILS":"Section details","SECTIONS_WITH_ASSIGNED_SCHEDULE_ONLY":"Sections with assigned schedule only","SECTIONS_WITH_ONLY_RESOURCE_ASSIGNED":"Sections with only resource assigned","SECTIONS_WITH_ONLY_SUPERVISORS_ASSIGNED":"Sections with only supervisors assigned","SECTIONS_WITH_SCHEDULE_AND_ASSIGNED_RESOURCE":"Sections with schedule and assigned resource","SECTIONS_WITH_SCHEDULE_AND_SUPERVISOR_ASSIGNED":"Sections with schedule and supervisor assigned","SECTIONS_WITH_SCHEDULE_RESOURCE_AND_SUPERVISOR_ASSIGNED":"Sections with schedule, resource and supervisor assigned","SECTIONS_WITHOUT_ASSIGNMENTS":"Sections without assignments","SEE_EDIT_SCENARIO":"See/Edit Scenario","SELECT_AUTOMATIC_ASSIGNMENT":"Select automatic assignment ","SELECT_BASE_LINE":"Select base line","SELECT_EVALUATION_TYPE":"Select the evaluation type","SELECT_MANUAL_ASSIGNMENT":"Select manual assignment ","SELECT_RESOURCE_MSJ":"Select a resource","STUDENTS_WITH_A_GROUP_ASSOCIATED":"Students with a group associated","STUDENTS_WITHOUT_A_GROUP_ASSOCIATED":"Students without a group associated","SUBJECT_ASSIGNATION":"Subject assignation","SUPERVISOR":"Supervisor","SUPERVISOR_ASSIGNATION":"Supervisor Assignation","SUPERVISOR_ASSIGNED_SUCCESSFULLY":"Supervisor assigned successfully","SUPERVISOR_BASELINE":"Supervisor_baseline","SUPERVISOR_DELETED_SUCCESSFULLY":"Supervisor deleted successfully","SUPERVISOR_SEARCH_INFORMATION":"Supervisor search information","U_EXAM":"u-exam","UNASSIGN_MANUAL":"Unassign manual","UNASSIGNED_STUDENTS":"Unassigned students","UNSELECT_BASE_LINE":"Unselect base line","ACADEMIC_PERIOD":"Imparted period","ACADEMIC_PERIOD_TYPE":"Tipo de periodo","ACADEMIC_QUOTA":"Academic cuota","ACTIVITIES":"Activities","ADD":"Add","ADD_BLOCK":"Add block","ADD_ESPECIALITIES":"Add especialities","ADD_NEW_PERIOD":"Agregar nuevo periodo","ADD_THEME":"Add theme","AGREE":"Acept","APA_LIBRARY":"","ATTITUDINAL_KNOWLEDGE":"Saber actitudinal","AUTOMATIC_ATTENDANCE":"Automatic attendance","BASIC_BIBLIOGRAPHY":"Basic bibliography","BLOCK_CODE":"Block code","BLOCK_END_LEVEL":"End level","BLOCK_MIN_CREDITS":"Min credits","BLOCK_NAME":"Block name","BLOCK_START_LEVEL":"Start level","BLOCK_SUBJECTS":"Cursos de bloque","BOOK_ELECTRONIC_VERSION":"","BOOK_MORE_THAN_FIVE_AUTHORS":"","BOOK_UP_TO_FIVE_AUTHORS":"","CANT":"Quantity","CAREER_CODE":"Career code","CAREER_NAME":"Career name","CAREER_PENSUM":"Career","CHANGES":"Changes","CLONING":"Cloning","CO_REQUIREMENTS":"Co-requirements","COMPETENCE_PENSUM_PROGRESS":"Competence pensum progress","COMPETENCIES":"Competences","COMPETENCIES_COMPETENCY_LEVELS_VIEW":"","COMPETENCY":"Competence","COMPETENCY_ACHIEVEMENTS_EVALUATION":"Competence achievements evaluation","COMPETENCY_CODE":"Competency code","COMPETENCY_COMPETENCY_LEVEL":"","COMPETENCY_DESCRIPTION":"","COMPETENCY_ID":"ID Competence","COMPETENCY_LEVEL_CODE":"","COMPETENCY_LEVEL_DESCRIPTION":"Description","COMPETENCY_LEVEL_ID":"","COMPETENCY_LEVEL_NAME":"Level name","COMPETENCY_LEVELS":"Levels","COMPETENCY_LEVELS_PANEL":"Competency scope","COMPETENCY_MATRIX_CODE":"Code","COMPETENCY_MATRIX_ID":"ID Matrix","COMPETENCY_MATRIX_MAINTAINER":"Competition Matrix Maintainer","COMPETENCY_MATRIX_NAME":"Matrix","COMPETENCY_NAME":"Competences","COMPETENCY_SCOPE":"Competency scope ","COMPETENCY_SCOPE_ID":"Competency","COMPETENCY_SCOPE_NAME":"Competency Scope","COMPLETE_WEBSITE":"","COMPONENT_CODE":"Component code","componentCode":"Code","componentDate":"","componentName":"","componentWeight":"","CONCEPTUAL_KNOWLEDGE":"Saber conceptual","CONFIG_WORKFLOW_PERMISSIONS":"Configuration of workflow permissions","CONSECUTIVE_HOURS":"Consecutive hours","CONTENT":"","CONTENTS_OCURRENCE":"","CONTENTS_PANEL":"","COURSE_ACADEMIC_INTEGRITY":"Academic integrity","COURSE_ACHIEVEMENT_DESCRIPTOR":"","COURSE_ACHIEVEMENT_DESCRIPTOR_ID":"","COURSE_ACTIVITIES":"Activities","COURSE_ACTIVITY":"Activity","COURSE_ACTIVITY_TYPE":"Activity type","COURSE_APROVAL_CONDITIONS":"","COURSE_ATTENDANCE_RULES":"","COURSE_CHANGES_HISTORY":"","COURSE_COMPETENCIES":"Competences to which this subject contributes","COURSE_COMPETENCIES_PANEL":"","COURSE_COMPETENCIES_SECTION":"","COURSE_COMPETENCY_TRIBUTE":"Course to competency tribute","COURSE_CONTENTS":"","COURSE_CREDITS":"Credits","COURSE_DESCRIPTION":"Subject Description","COURSE_DESCRIPTION_PANEL":"Subject Description","COURSE_DESCRIPTION_SECTION":"Subject Description","COURSE_DISCIPLINE":"","COURSE_EDUCATION_LEVEL":"Education level","COURSE_ENGLISH_NAME":"","COURSE_EVALUATION":"","COURSE_EVALUATION_ID":"","COURSE_EVALUATION_METHOD":"Means of evaluation","COURSE_EVALUATION_METHOD_ID":"","COURSE_EVALUATION_PROCEDURES":"","COURSE_EVALUATION_STRUCTURE":"","COURSE_EVALUATIONS":"","COURSE_EVIDENCES":"Course evidences","COURSE_EVIDENCES_GRID":"","COURSE_EVIDENCES_TABLE":"","COURSE_GENERAL_DATA":"","COURSE_GENERAL_INFO":"General information","COURSE_HOURS":"","COURSE_HRS_ACTIVITY_STUDENT":"Student activity hours","COURSE_HRS_STUDENT":"Student study hours","COURSE_HRS_TEACHER":"Hours with teacher","COURSE_LANGUAGE":"Language","COURSE_LEARNING_EVIDENCES":"","COURSE_MARK_TYPE":"","COURSE_METHODOLOGY":"","COURSE_MODALITIES":"Course modalities","COURSE_MODALITIES_ACTIVITIES":"","COURSE_MODALITY":"Modalidad","COURSE_OBJECTIVES":"","COURSE_OBJECTIVES_PANEL":"","COURSE_OBJECTIVES_SECTION":"","COURSE_OTHERS":"Others","COURSE_OTHERS_PANEL":"Others","COURSE_OUTCOMES":"Learning outcomes of the subject","COURSE_OUTCOMES_CONTENT_PANEL":"","COURSE_OUTCOMES_ID":"","COURSE_OUTCOMES_PANEL":"","COURSE_OUTCOMES_SELECT":"Learning outcomes of the subject","COURSE_POLICIES":"Inclusion and diversity policy","COURSE_POLICIES_PANEL":"Course policies","COURSE_PREVIOUS_KNOWLEDGE":"","COURSE_PREVIOUS_KNOWLEDGE_PANEL":"Suggested prior knowledge","COURSE_PROFESSIONAL_LINKING":"Professional link","COURSE_REFERENCE_CATEGORY":"","COURSE_REFERENCES":"bibliographic references and websites","COURSE_REFERENCES_NOTES":"Notes on bibliography and websites","COURSE_REFERENCES_NOTES_PANEL":"Notes on bibliography and websites","COURSE_REQUIREMENTS":"Pre-requirements","COURSE_REQUIREMENTS_NOTES":"","COURSE_REQUIREMENTS_NOTES_PANEL":"Additional notes","COURSE_RULES":"Class rules","COURSE_SESSIONS":"","COURSE_SUBTHEMES":"","COURSE_SUCCESS_SUGGESTIONS":"Suggestions for success in the subject","COURSE_THEME":"","COURSE_THEME_DESCRIPTION":"Theme description","COURSE_TYPE_IN_PENSUM":"","COURSE_VOCATIONAL_MATTER":"Importance for the training","COURSES_COREQUISITES":"Co-requirements","COURSES_PREREQUISITES":"Pre-requirements","CREATE_MATRIX":"Create Matrix","CREATE_NEW_ONE":"Create new one","CREATE_PERIOD_TYPE":"Create period type","CREDITS":"Créditos","CURRICULAR_PROGRESS":"Curricular progress","CYCLES":"Cycles","DATABASE_THESIS":"","DATE":"Date","DEPARTMENT":"Departamento","DESCRIPTION_MESSAGE_DEFAULT":"Ingrese Descripción","DESTINY_SECTIONS_LIST":"Destino","DETAIL":"Detalle","DOWNLOAD_REPORT":"Download report","EBOOK":"","EDIT_MATRIX":"","EDIT_STUDYPLAN":"Edit study plan","EDIT_TRIBUTES":"Edit tribute","END_MESSAGE_EXPLAIN_CLONING":"para ejecutar la clonación","ENTER_REQUEST_COMMENTS":"","EQUIVALENT_COMPETENCES":"Equivalent competencies","ERROR_CLONING_PROCESS":"Imposible conectar con servicio","ERROR_GREATER_THAN":"Value has to be greater than","ERROR_GREATER_THAN_EQUAL":"Value has to be greater than or equal to","ERROR_LESS_THAN":"Value has to be less than","ERROR_LESS_THAN_EQUAL":"Value has to be less than or equal to","EVALUATION_CODE":"Code","EVALUATION_DATE":"Date","EVALUATION_IS_ATTITUDE":"Actitudes","EVALUATION_IS_KNOWLEDGE":"Conocimientos","EVALUATION_IS_PRACTICE":"Procedimientos","EVALUATION_IS_PROCESS":"Process","EVALUATION_IS_PRODUCT":"Product","EVALUATION_METHODS":"Evaluation Method","EVALUATION_PERCENTAGE":"Percentage","EVALUATION_STRUCTURE":"","EVALUATIONS_COMMENTS":"Comentarios generales sobre la Evaluación","EVALUATIONS_COMMENTS_PANEL":"Evaluations","EVALUATIONS_NOTE1":"Nota","EVALUATIONS_NOTE2":"Nota","EVIDENCE_TRACKING":"Tracking","EVIDENCES":"Evidences","EVIDENCES_CARD_PANEL":"Evidencias del logro de los resultados de aprendizaje ","FACULTY":"School / Faculty","FACULTY_CODE":"","FACULTY_DEPARTMENT":"Facultad - Departamento","FACULTY_INSTITUTION":"","FACULTY_NAME":"","FILE_PANEL":"File panel","FILL_REQUIRED_INPUTS":"You must fill out all the required inputs","FILTER_AS":"Filter as","FILTER_MAIN_PANEL":"","FINAL_COLLEGIATE":"Colegiada Final","FINISH_CLONING_PROCESS":"Proceso finalizado","FRECUENCY":"Frecuency","GENERIC_WARNING":"Warning","HALF_LENGTH":"Medio término","HOURS_PER_WEEK":"Hours per week","IFR_TYPE_RESOURCE_ID":"","IFR_TYPE_RESOURCE_NAME":"Type of resource","IFR_USE_TYPE_ID":"","IFR_USE_TYPE_NAME":"","IMPROVE_ACTIVITY":"Activity","IMPROVE_ADD_ACTIVITY":"Add activity","IMPROVE_ADD_MODALITY":"Add modality","IMPROVE_ALL_COURSES":"All the asignatures","IMPROVE_CAPTURED":"Captured","IMPROVE_CAPTURED_DESCRIPTION":"Captured and complete teaching programs","IMPROVE_CAREER":"Career","IMPROVE_CAREER_LIST":"","IMPROVE_CARRER_TYPE":"","IMPROVE_CHARGE":"Charge","IMPROVE_COMPETENCY_MATRIX":"Competencies","IMPROVE_COURSE_NAME":"Nombre del curso","IMPROVE_COURSE_PROGRAM":"Course Program","IMPROVE_COURSES":"Subjects list","IMPROVE_CREATE_CAREER":"","IMPROVE_CREATE_COURSE":"Create matter","IMPROVE_CREATE_FACULTY":"","IMPROVE_CREDITS_BY_PERIODS":"Credits per period","IMPROVE_CURRICULAR_SYNTHESIS":"Curricular synthesis","IMPROVE_CYCLES":"","IMPROVE_DELETE":"","IMPROVE_DEPARTMENT":"Department","IMPROVE_DOWNLOAD_REPORT":"Download report","IMPROVE_EDIT_CAREER":"Edit career","IMPROVE_EMAIL":"Email","IMPROVE_EVALUATION_MOMENTS":"Moment when evaluating","IMPROVE_EVALUATION_OR_STRATEGY":"Strategy or mean of evaluation","IMPROVE_EVALUATION_RESULTS":"Evaluation results","IMPROVE_EVALUATION_TYPE":"Evaluation type","IMPROVE_FACULTY":"","IMPROVE_FACULTY_LIST":"","IMPROVE_FILE_NAME":"File name","IMPROVE_FRECUENCY":"Frecuency","IMPROVE_GOAL_LEVEL":"Achievement level","IMPROVE_GRADUATION_COMPETITION":"Graduation competitions","IMPROVE_INFO":"Course info","IMPROVE_INFO_CAREER":"","IMPROVE_INFO_FACULTY":"","IMPROVE_INFORMATION_PERIOD":"Period information","IMPROVE_KEY":"Code","IMPROVE_LOAD_FILE":"Load file","IMPROVE_MAINTAINER":"Maintainers","IMPROVE_MONITORING_EVIDENCES":"Evidencies","IMPROVE_MY_ACCOUNT":"My account","IMPROVE_MY_PROFILE":"My u-improve profile","IMPROVE_NEW_CAREER":"","IMPROVE_NEW_COURSE":"Create new course","IMPROVE_NEW_FACULTY":"","IMPROVE_PASSWORD":"Password","IMPROVE_PASSWORD_CONFIRM":"Confirm password","IMPROVE_PENDING":"Pending","IMPROVE_PENDING_DESCRIPTION":"Magisterial programs to be captured","IMPROVE_PERIOD":"Period","IMPROVE_PERIOD_NAME":"Nombre del periodo","IMPROVE_PERIOD_TYPE":"Type of period","IMPROVE_PHONE":"Phone number","IMPROVE_PROFESSOR":"Teacher","IMPROVE_PROGRESS":"Progress","IMPROVE_PROPOSED_MONITORING":"Proposed monitoring","IMPROVE_PUBLISHED":"Published","IMPROVE_PUBLISHED_DESCRIPTION":"Approved by the coordinator and visible to students","IMPROVE_REPORTS":"Reports","IMPROVE_RESPONSABLE":"Responsable","IMPROVE_SECTION":"Section","IMPROVE_SECTION_CAPTURED":"Capturado","IMPROVE_SECTION_OPEN":"Abierto","IMPROVE_SECTION_PENDING":"Pendiente","IMPROVE_SECTION_PROGRESS":"En curso","IMPROVE_SECTION_PUBLISHED":"Publicado","IMPROVE_SECTION_STRUCTURE_IN":"Con estructura","IMPROVE_SECTION_STRUCTURE_OUT":"Sin estructura","IMPROVE_SECTION_TRACKING":"En seguimiento","IMPROVE_SECTION_WAITING":"En espera","IMPROVE_SELECT_SECTION":"Select a section","IMPROVE_SHOW_ONLY_TRACKING":"Show only subjects in follow-up","IMPROVE_SIZE":"Size","IMPROVE_STATE":"State","IMPROVE_STUDY_PLAN":"Study plan","IMPROVE_STUDY_PROGRAM":"Study Program","IMPROVE_SUBJECTS_LIST":"Subjects list","IMPROVE_SYLLABUS":"Syllabus","IMPROVE_SYLLABUS_TRACKING":"Syllabus tracking","IMPROVE_TITLE":"u-improve","IMPROVE_TRACKING":"Tracking","IMPROVE_UPDATE_ACTIONS":"Update actions","IMPROVE_USAGE_TYPE":"Type of use","IMPROVE_USERNAME":"Username","IMPROVE_VERSION":"Version","IMPROVE_WAITING":"Waiting","IMPROVE_WAITING_DESCRIPTION":"Waiting for approval from the coordinator","IMPROVE_WEEKS_NUMBER":"Weeks number","INDICADORES_DE_LOGROS":"Logro de competencias","INFRAESTRUCTURE_REQUIREMENTS":"","INFRAESTRUCTURE_REQUIREMENTS_TABLE":"","INSERT_COMPETENCY_CODE":"Insert competency code","INSERT_COMPETENCY_NAME":"","INSERT_COURSE_OUTCOMES":"","INSERT_COURSE_SUBTHEMES":"","INSERT_LEARNING_STRATEGIES":"","INSERT_NEW_RECORD":"Add evidence","INSERT_REFERENCE_ADDED":"Insert aditional reference","INSERT_REFERENCE_NAME":"","INSERT_SECTION_LEARNING_STRATEGIES":"","INSERT_SESSION_LEARNING_STRATEGIES":"Insert learning strategies","INSERT_SESSION_LEARNING_STRATEGIES_ADD":"","INSERT_SESSION_RESOURCES":"","INSERT_SESSION_SUBTHEMES_ADDED":"","INSERT_SESSION_SUBTHEMES_ADDED_ADD":"","INSTITUTIONAL_THESIS":"","INSTRUMENT":"Instrument","INTERNATIONAL_STRATEGIES":"","IS_CLASSRROM_REQUIRED":"Requires lounge","IS_CONTRIBUTING":"Competency tribute","IS_GROUP_EVALUATION ":"Group","IS_ONLINE":"Online activity","IS_SCHEDULE_REQUIRED":"It requires a schedule","IS_TEACHER_REQUIRED":"Teacher required","isGruopEvaluation":"","KEY_WORDS":"Keywords","LABEL_ADMIN":"","LABEL_COORD":"","LABEL_STUDENT":"","LABEL_TEACHER":"","LAW":"","LEARNING_AREA":"","LEARNING_EVIDENCES":"Learning evidences","LEARNING_STRATEGIES":"","LEARNING_STRATEGIES_PANEL":"Estrategias de aprendizaje","LEARNING_SUBAREA":"Learning Sub-area","MAGAZINE_ARTICLE_IN_DATABASE":"","MAIN_SECTION_TEACHER":"Holder teacher","MAIN_SECTION_TEACHER_MAIL":"Holder teacher email","MAIN_SECTION_TEACHER_PHONE":"Holder teacher phone","MATRIX_CAREER_CODE":"Cod. Carrera","MATRIX_CAREER_NAME":"Carrera","MATRIX_DESCRIPTION":"","MATRIX_FACULTY_CODE":"Cod. Facultad","MATRIX_FACULTY_NAME":"Facultad","MATRIX_GENERAL_DATA":"","MATRIX_GENERAL_INFO":"","MATRIX_PENSUM_CODE":"Cod. Pensum","MATRIX_PENSUM_NAME":"Pensum","MATRIX_STUDYPLAN_ASSOCIATED":"Associated study plans","MATRIX_TYPE":"Matrix Type","MESSAGE_EXPLAIN_CLONING":"","MIN_CREDITS":"Créditos mínimos","MODALITIES":"","MOMENT":"Moment","MOVIE":"","NEW_STUDYPLAN":"Create Study plan","NEWSLETTER_ARTICLE":"","NEWSLETTER_ARTICLE_NO_AUTHOR":"","OBLIGATORY_SUBJECTS":"Cursos obligatorios","ONLINE_THESIS":"","OUTCOME_KNOWLEDGE":"Saberes del resultado de aprendizaje","OUTCOME_NAME":"Resultado de aprendizaje","PART_OF_A_BOOK":"","PENSUM_ACADEMIC_INFO":"Academic Information","PENSUM_ADMISSION_PROFILE":"Perfil de ingreso","PENSUM_BLOCKS":"Cursos de bloque","PENSUM_CAMPUS":"Campus","PENSUM_CODE":"","PENSUM_GENERAL_DATA":"Información general ","PENSUM_GENERAL_INFO":"Datos generales del plan de estudio","PENSUM_GRADUATE_PROFILE":"Perfil de egreso","PENSUM_ID":"ID Plan","PENSUM_IMPARTITION_MODE":"Modo de impartición","PENSUM_MODALITY":"Modalidad","PENSUM_NAME":"Plan","PENSUM_PUBLICATION_DATE":"Fecha de publicación","PENSUM_SIGNATURES":"Cursos obligatorios","PENSUM_SPECIALTIES":"Cursos de especialidad","PENSUM_VALIDITY_END_DATE":"Fecha de término","PENSUM_VALIDITY_START_DATE":"Fecha de inicio","PENSUM_VIGENCY_INFO":"Información de vigencia","PERIOD_TYPE":"Tipo de periodo","PLAN_SUBJECT":"Plan courses","PRE_REQUIREMENTS":"Pre-requirements","PREPARING_TO_PRINT":"Preparing to print...","PRINT_LINK_PROMPT":"Click here if your print does not start automatically:","PROCEDURAL_KNOWLEDGE":"Saber procedimental","REFERENCE_ADDED":"Referencias adicionales","REFERENCE_ARTICLE_TITLE":"","REFERENCE_AUTHOR":"Author","REFERENCE_CHAPTER_TITLE":"","REFERENCE_COURT":"","REFERENCE_DATABASE":"","REFERENCE_DOI":"","REFERENCE_EDITOR":"Editor","REFERENCE_EDITOR_MENTION":"","REFERENCE_EDITORIAL":"Editorial","REFERENCE_FIFTH_AUTHOR":"","REFERENCE_FORMAT":"","REFERENCE_FOURTH_AUTHOR":"","REFERENCE_ID":"","REFERENCE_INFO_TITLE":"","REFERENCE_ISBN":"ISBN code","REFERENCE_LAST_AUTHOR":"","REFERENCE_LAW_TITLE":"","REFERENCE_MAGAZINE_NAME":"","REFERENCE_MOVIE_DIRECTOR":"","REFERENCE_MOVIE_PRODUCER":"","REFERENCE_MOVIE_STUDIO":"","REFERENCE_MOVIE_TITLE":"","REFERENCE_NAME":"Referencia","REFERENCE_NEWSLETTER_NAME":"","REFERENCE_OFFICIAL_SOURCE":"","REFERENCE_ORIGIN":"","REFERENCE_PAGES":"","REFERENCE_PUB_CITY":"","REFERENCE_PUB_COUNTRY":"","REFERENCE_PUB_DATA":"","REFERENCE_PUB_MONTH":"","REFERENCE_PUB_PLACE":"Publication place","REFERENCE_PUB_YEAR":"","REFERENCE_PUBLISHER":"","REFERENCE_RECOVERED_DATE":"","REFERENCE_SEARCH":"Reference search","REFERENCE_SECOND_AUTHOR":"","REFERENCE_SENTENCE_COUNTRY":"","REFERENCE_SENTENCE_DATE":"","REFERENCE_SENTENCE_NUMBER":"","REFERENCE_SOFTWARE_DESCRIPTION":"","REFERENCE_SOFTWARE_TITLE":"","REFERENCE_TABLE":"Reference table","REFERENCE_TABLE_ADDED":"Reference table added","REFERENCE_THESIS_CATEGORY":"","REFERENCE_THESIS_DATABASE":"","REFERENCE_THESIS_INSTITUTION":"","REFERENCE_THESIS_TITLE":"","REFERENCE_THIRD_AUTHOR":"","REFERENCE_TITLE":"","REFERENCE_URL":"Url","REFERENCE_VERSION":"","REFERENCE_VIDEO_PRODUCER":"","REFERENCE_VIDEO_TITLE":"","REFERENCE_VOLUME":"","REFERENCE_WEBSITE_NAME":"","REFERENCE_YEAR":"Year","REQUIREMENTS":"","REQUIREMENTS_NOTES":"","REQUIREMENTS_NOTES_PANEL":"Additional notes","REREFENCE_UMI":"","ROLE":"Role","SAVE_CHANGES":"Save changes","SEARCH_TEXT":"Search text","SECONDARY_BIBLIOGRAPHY":"Secondary bibliography","SECTION_ACTIVITIES":"Activities","SECTION_APROVAL_CONDITIONS":"","SECTION_ASSISTANTS":"Assistants or co-holders","SECTION_CHANGES_HISTORY":"Changes history","SECTION_COMPETENCIES":"Competences to which this subject contributes","SECTION_COMPETENCIES_PANEL":"","SECTION_COMPETENCIES_SECTION":"","SECTION_CONTENTS":"","SECTION_COORDINATOR":"Coordinator","SECTION_COREQUISITES":"Co-requirements","SECTION_DESCRIPTION":"Subject Description","SECTION_DESCRIPTION_PANEL":"Subject Description","SECTION_DESCRIPTION_SECTION":"Subject Description","SECTION_EVALUATION":"Type of evaluation","SECTION_EVALUATION_COMMENTS":"Evaluations","SECTION_EVALUATION_COMMENTS_PANEL":"Evaluations","SECTION_EVALUATION_ID":"","SECTION_EVALUATION_METHOD":"Means of evaluation","SECTION_EVALUATION_METHOD_ID":"","SECTION_EVALUATION_PROCEDURES":"","SECTION_EVALUATION_STRUCTURE":"Evaluation","SECTION_EVALUATIONS":"Criteria for evaluation and accreditation","SECTION_EVIDENCES_PANEL":"Course evidences","SECTION_EVIDENCES_TABLE":"","SECTION_GENERAL_DATA":"General data","SECTION_IMPARTITION_MODE":"Modo en que se imparte","SECTION_LEARNING_EVIDENCES":"","SECTION_LEARNING_STRATEGIES":"Learning strategies ","SECTION_MAIN_TEACHER":"Holder teacher","SECTION_MAIN_TEACHER_MAIL":"Holder teacher email","SECTION_METHODOLOGY":"","SECTION_METHODOLOGY_PANEL":"Methodology","SECTION_MODALITIES_ACTIVITIES":"","SECTION_MODALITY":"Course modalities","SECTION_NAME":"Sección","SECTION_OBJECTIVES":"","SECTION_OBJECTIVES_PANEL":"","SECTION_OBJECTIVES_SECTION":"","SECTION_OTHER_CONDITIONS":"Other conditions","SECTION_OTHERS":"Others","SECTION_OTHERS_PANEL":"Others","SECTION_OUTCOMES":"Learning outcomes of the subject","SECTION_OUTCOMES_ID":"","SECTION_OUTCOMES_PANEL":"","SECTION_PREREQUISITES":"Pre-requirements","SECTION_REFERENCE_CATEGORY":"","SECTION_REFERENCES":"","SECTION_REFERENCES_NOTES_PANEL":"Notes on bibliography and websites","SECTION_REQUIREMENTS_NOTES":"","SECTION_REQUIREMENTS_NOTES_PANEL":"Additional notes","SECTION_REQUIREMENTS_PANEL":"","SECTION_SESSION_NAME":"Subject planning","SECTION_SESSIONS":"Subject planning","SECTION_SESSIONS_PANEL":"","SECTION_TEACHING_TEAM":"Teacher team","SECTION_TYPE_IN_PENSUM":"","SEE_ON_PLAN":"Ver en el plan","SELECT_A_STRUCTURE":"","SELECT_DESTINATION":"Seleccione destino","SELECT_FILES":"Select files...","SEMESTER":"Semestre","SENTENCE":"","SESSION_ACTIVITY":"","SESSION_ACTIVITY_DESCRIPTION":"","SESSION_COURSE_OUTCOMES":"","SESSION_DESCRIPTION":"Description","SESSION_END_TIMING":"End date","SESSION_EVALUATION_COMPONENTS":"Session evaluation components","SESSION_EVALUATION_METHODS":"Means of evaluation","SESSION_EVALUATION_METHODS_ADD":"","SESSION_LEARNING_RESULTS":"Learning results of the subject","SESSION_LEARNING_RESULTS_ADD":"","SESSION_LEARNING_STRATEGIES":"Educational strategies","SESSION_LEARNING_STRATEGIES_ADD":"","SESSION_NAME":"","SESSION_NAME_ADD":"Additional theme","SESSION_REFERENCES":"Session references","SESSION_RESOURCES":"Session resources","SESSION_RESOURCES_ADD":"","SESSION_SUBTHEMES":"Subtopics","SESSION_SUBTHEMES_ADDED":"Aditional subtopics","SESSION_SUBTHEMES_ADDED_ADD":"","SESSION_TEACHERS":"Session teachers","SESSION_THEME":"Theme","SESSION_THEME_ADD":"","SESSION_TIMING":"Schedule","SESSION_TIMING_ADD":"","SOFTWARE":"Software","SPECIALITY_SUBJECTS":"Cursos de especialidad","START_MESSAGE_EXPLAIN_CLONING":"Presione el botón ","STATISTICAL_DATABASE":"","STRICT_FIELD_REQUIREMENT":"Strict field requirement","STRICT_FIELD_REQUIREMENT_HELP":"Will require the user to complete all mandatory fields in order to ejecute this transition.","STRUCTURE":"Structure","STRUCTURES":"","STUDENT_HISTORICAL_PROGRESS":"Historical progress","STUDY_PLAN_CREATE_SUCCESS":"","STUDYPLAN_CODE":"","STUDYPLAN_GENERAL_INFO":"","STUDYPLAN_NAME":"","SYLLABUS_GENERAL_DATA":"General data","SYLLABUS_REFERENCES":"","THESIS":"","TOGGLE_COLAPSE":"Collapse","TOTAL_HOURS":"Total hours","TOTAL_WEEKS":"","UPDATE_SUCCESS_MESSAGE":"Registros actualizados exitosamente","UPLOAD":"Upload","UPLOAD_ALL":"Upload all","UPLOAD_FILE":"Upload file","UPLOADING_FILE":"Uploading file ","USER":"User","WARNING_CLONING_PROCESS":"Ocurrió un error","WARNING_MESSAGE":"Warning message","WARNING_MESSAGE_DELETE_DEFAULT":"Are you sure to delete?","WEB_MAGAZINE_ARTICLE":"","WEBSITE":"","WEBSITE_NO_AUTHOR":"","WORKFLOW":"Workflow","YEAR":"Year","YOUTUBE_VIDEO":"","ACADEMIC":"Academic","ACADEMIC_CALENDAR":"Academic calendar","ACADEMIC_CALENDAR_TO_CLONE":"Academic calendars to clone","ACADEMIC_CALENDAR_VISUALIZATION":"Academic calendar visualization","ACADEMIC_PROGRAM_SUMMARY":"Academic program summary","ACADEMIC_PROGRAMMING":"Academic program","ACADEMIC_PROGRAMMING_PLURAL":"Academic program","ACADEMIC_QUOTA_LEEWAY":"Academic quota leeway","ADD_INTEGRATION_CODE":"Add integration code","ADD_NAME_RESOURCE_TYPE":"Add name of resource type","ADD_USAGE_TYPE":"Add usage type","ADD_USAGE_TYPE_NAME":"Add usage type name","ADVANCE_GROUP":"Advance of Group","AFFECTED":"affected","APARTAMENT":"Apartament","APPROVAL_RATE":"Approval rate","APPROVE_REQUEST_N":"Approve request N° {{listRequestCount}}","APPROVED_COURSE_CYCLE":"Approved course cycle","APPROVED_COURSES":"Approved courses","APPROVED_CREDITS":"Approved credits","ASSIGN_RESOURCE_TYPE":"Assign resource type","ASSIGN_SAME_DAY":"assign same day","ASSIGN_SCHEDULE_CLASSROOMS":"Assign schedule and classrooms","ASSIGNAMENT_PREDEFINED_TEACHER_TO_SECTIONS":"Assignment of predefined teacher to sections","ASSIGNED_CLASSROOMS":"assigned classrooms","ASSING_ACADEMIC_CALENDAR":"Assign Academic Calendar","ATENTION":"Atention","AVARAGE_STUDENTS_SECTIONS":"Average number of students in the sections","BACK_TO_SIMULATION_LIST":"Back to simulation list","BACKGROUND":"background","BASE_LINE":"Base Line","BASE_SIMULATION":"base simulation","CALCULATED_DEMAND":"Calculated demand","CAMPUS_PERIOD_SHIFT_INDICATORS":"indicators per campus -period - shift","CAMPUSES":"Campus","CANDIDATE_CLASSROOM":"Candidate classroom","CANDIDATE_SCHEDULE_CLASSROOM":"Schedule / candidate classrooms","CANDIDATE_SCHEDULE_CLASSROOM_RESTRICTION":"Candidate schedule/classroom restriction","CANDIDATES":"Candidates","CANT_RECORDS":"Cant of records","CAREER":"Career","CAREER_BUILDING_PREFERENCE":"Career building preference","CAREERS":"Careers","CHAIR_USAGE_PERCENTAGE_RESTRICTION":"Chairs usage restriction percentage ","CHAIR_USE_PERCENTAGE":"Chair use percentage","CHECK_UNCHECK_ALL":"Chech/Uncheck all","CLASSROOM":"classroom","CLASSROOM_RESTRICTION":"Classroom restriction","CLASSROOM_RESTRICTION_LIST":"Classroom restriction list","CLONE_ACADEMIC_CALENDAR":"Clone academic calendar","CLONE_CROSS_LISTS":"Clone cross lists","COEFF_ASSIGNED_MODULES":"Coefficient of assigned modules","COEFF_COURSE":"Coefficient of courses","COEFF_POSITION":"Coefficient of position","COEFF_TEACHER_EVALUATION":"Teacher evaluation coefficient","COEFF_VALUE_HOUR":"Hour value coefficient","COMPACT":"Compact","COMPACT_RECORD_CLASS_GROUP":"Compact by record class group","COMPACT_RETURN":"Compact and return","COMPACTION_INDEX_ACADEMIC_QUOTA":"Compaction index by academic quota","COMPACTION_OPPORTUNITY":"Compaction opportunity","COMPACTION_PERCENTAGE_ACADEMIC_QUOTA":"Compaction percentage by academic quota","COMPATIBILITY_GROUP_NUMBER":"Compatibility group number","CONFIG":"Set up","CONFIG_CROSS_LISTS":"Config cross lists","CONFIGURATION_PER_WEEKS":"Configuration per weeks","CONTINUE":"Continue","COORDINATOR_VIEW":"Coordinator view","COST_MAINTAINER_TEACHER_EVALUATION":"Cost maintainer and teacher evaluation","COURSE_ACTIVITY_DATA":"Course activity data","COURSE_ACTIVITY_EMPTY_STATE":"Click on a course activity to access the information of this...","COURSE_ACTIVITY_MAINTAINERS":"Course activity mainteiners","COURSE_BUILDING_PREFERENCE":"Course building preference","COURSE_DUPLICATED_IN_NEXT_CROSS_LIST":"The course {string} i'ts duplicated in the next cross lists","COURSED_CYCLE":"Coursed cycle","COURSED_ELECTIVES":"Coursed electives","COURSES":"Courses","COURSES_IN_THIS_CROSS_LIST":"Courses in this cross list","CREATE":"Create","CREATE_ACADEMIC_PROGRAMMING":"Create Academic program","CREATE_CROSS_LIST":"Create cross list","CREATE_DEMAND_SIMULATION":"Create demand simulation","CREATE_GROUP_SIMULATION":"Create Group Simulation","CREATE_REQUEST":"Create request","CREATE_RESOURCE":"Create resource","CREATE_RESTRICTION":"Create restriction","CREATE_SCHEDULE_CLASSROOM_SIMULATION":"Create Simulation Schedule","CREATE_TEACHER_SIMULATION":"Create Simulation Teacher","CREATE_VIRTUAL_SIMULATION":"Create virtual simulation","CREATING":"Creating","CROSS_LIST_LOEADED":"Cross lists loaded","CROSS_LISTS_CONFIGURATION":"Cross lists configuration","CROSS_LISTS_DEFINITION":"Cross lists definition","CROSS_LISTS_TO_CLONE":"Cross lists to clone","CROSS_LISTS_TO_MERGE":"Cross lists to merge","CROSS_LISTS_WITH_CONFLICT":"Cross lists with conflict","CURRENT_VALUE":"Current value","DEFINE_A_COURSE":"Define a course","DEFINE_GENERIC_GROUP":"Define generic group","DELETE_SIMULATION":"Delete simulation","DEMAND":"Demand","DEMAND_MATRIX_CALENDAR":"Demand matrix by calendar","DEMAND_SIMULATION":"Demand simulation","DEPENDENT_SIMULATION":"Dependent Simulations","DESERTION_RATE":"Desertion rate","DICTATE":"Dictate","DIFFERENT_ACTIVITIES_IN_NEXT_CROSS_LIST":"The activities are different in the next cross lists","DIFFERENT_ACTIVITY_SCHEDULE":"Diferent activity type/schedule","DISTRIBUTION_AUTO":"Automatic distribution","DOWNLOAD":"Download","DOWNLOAD_BY_CAMPUS":"Download report by campus","DOWNLOAD_BY_PLAN":"Download by plan","DOWNLOAD_BY_STUDENT":"Download by student","DOWNLOAD_HISTORICAL_RPC":"Download historical RPC","DUPLICATED_COURSES":"Duplicated courses","EDIT_ACADEMIC_QUOTA":"Edit academic quota","EDIT_ACADEMIC_QUOTA_LEEWAY":"Edit academic quota leeway","EDIT_CROSS_LIST":"Edit cross list","EDIT_GLOBAL_DEMAND":"Edit global demand","EDIT_NEW_STUDENTS":"Edit new students","EDIT_PREVIOUS_PERIOD":"Edit previous period","EDIT_RESTRICTION":"Edit restriction","EDITED":"Edited","EMPTY":"empty","END_WEEK":"End week","ENROLLMENT_CYCLE":"Enrollment cycle","ENTRY_CICLE":"Entry cicle","EXECUTE":"Run","EXECUTE_IN_BACKGROUND":"Execute in background","EXECUTING":"Executing","FINAL_DEMAND":"Final demand","FIND_WEEKS":"Find weeks ","FINISHED":"Finalized","FIXED_CURRICULAR_PROGRESS":"Fixed curricular progress","FLEXIBLE_CURRICULAR_PROGRESS":"Flexible curricular progress","FRI":"Friday","FUNCTION_OBJECTIVE":"Function objective","FUNCTION_OBJECTIVE_CONFIGURATION_TEACHER":"Configuration Function Objective: Teacher Assignment Function","GENERAL_INDICATORS":"General indicators","GO_BACK_GROUP_SIMULATIONS":"Go back to group simulations","GO_BACK_SIMULATION":"Go back to simulation","GROUP_SIMULATION":"Group simulation","GROUP_SIZE":"Group size","GROUPS_INDEX_VIEW":"Groups index view","GROUPS_TABLE_VIEW":"Groups table view","HEADER_STEP_5":"Dictation in previous equivalent period","HISTORIC_ENROLLMENT":"Historical inscriptions","HISTORY":"History","HOLYDAYS":"Holydays","ID_CROSS_LIST":"ID cross list","ID_PUBLIC":"Public id","ID_UPL":"ID U-Planner","IN_PROGRESS":"In Progress","INDEX_COMPACTION_INFRASTRUCTURE":"Index of compaction by infrastructure","INFRASTRUCTURE_OCCUPATION PERCENTAGE RESTRICTION":"Infrastructure occupation percentage restriction","INSTITUTION":"Institution","INTEGRATION_WARNING_TEXT":"If you continue with the editing / deletion the following simulations will be obsolete:","INTEGRATION_WARNING_TITLE":"Integration Warning","LAST_DATA_LOAD":"Data of the last load","LOAD_ACADEMIC_QUOTA":"Load academic quota","LOAD_ANOTHER_FILE":"Load another file","LOAD_CLASSROOM_RESTRICTIONS":"Load classroom restrictions","LOAD_FILE":"Load File","LOAD_PREVIOUS_PERIOD":"Load Previous period","LOAD_QUOTA":"Load quota","LOADED_CAREERS":"Loaded careers","LOADED_COURSES":"Loaded courses","LOADED_PLANS":"Loaded plans","LOADED_SECTIONS":"Loaded sections","MASSIVE_CLONING":"Massive cloning","MAXIMUM_GROUP_SIZE":"Tamanho Máximo do Grupo","MENU_ACADEMIC_PERIOD":"Academic period","MENU_ACTIVITY":"Activity","MENU_ACTIVITY_SUBJECT_DETAIL":"Activity Subject Detail","MENU_ACTIVITY_SUBJECT_TYPE_USE":"Activity Subject Type Use","MENU_CAREER_TARIFF":"Career Tariff","MENU_CLASS_NOTE":"Class note","MENU_CLASS_TIME":"Class Time","MENU_COMPARISON_REPORT":"Comparison Report","MENU_CONFERENCE_MANAGER":"Conference Manager","MENU_COORDINATOR":"Coordinator","MENU_COURSE_ACTIVITY":"Course Activity","MENU_CROSS_LIST":"Cross Lists","MENU_DEMAND_MATRIX":"Matrix of Demand","MENU_DETAIL_REPORT":"Detail Report","MENU_DISPLAY":"Display","MENU_ENTRY_NEW_STUDENTS":"Entry of New Students","MENU_FILE_UPLOAD":"File Upload","MENU_GLOBAL_DEMAND":"Global demand","MENU_INFRASTRUCTURE":"Infrastructure","MENU_INFRASTRUCTURE_TYPE_USE":"Infrastructure Type Use","MENU_INTEGRATION_TABLES":"Integration Tables","MENU_LOAD_GROUP":"Load Group","MENU_LOAD_SCHEDULE":"Load schedule","MENU_LOADED_DATA":"Loaded Data","MENU_MAINTAINERS":"Maintainers","MENU_MODULES_DAY":"Modules per day","MENU_PLANS_CAMPUS":"Plans in campus","MENU_REPORTS":"Reports","MENU_STUDY_PLAN":"Study plan","MENU_STUDY_PLAN_SHIFT":"Study Plan Shift","MENU_STUDY_PLAN_SUBJECT":"Study Plan Subject","MENU_SUBJECTS_BY_DEPARTAMENT":"Subjects by department","MENU_SUBJECTS_BY_PLAN":"Subjects by plan","MENU_TEACHER":"Teacher","MENU_TEACHER_ACTIVITY_SUBJECT":"Teacher Subject Activity Venue","MENU_TEACHER_COORDINATOR":"Teacher-Coordinator","MENU_TEACHER_COST_MATTER_ACTIVITY":"Teaching cost Matter Activity","MENU_TEACHER_SUBJECT_ACTIVITY":"Teacher Subject Activity","MENU_TEACHER_VALUE_TIME_EVALUATION":"Teacher Value Time Evaluation","MENU_TEACHING_AVAILABILITY":"Teaching Availability","MENU_TIME_AVAILABILITY":"Time availability","MENU_TIME_TRANSFER":"Time Transfer","MENU_TYPE_USE":"Types of Use","MENU_USE_INFRASTRUCTURE":"Use of Infrastructure","MENU_USE_ROOMS":"Use of Rooms","MENU_VALUE_TIME_SUBJECT":"Value Time Subject","MERGE_CROSS_LISTS":"Merge cross lists","MERGE_SECTIONS_BY_CROSS_LISTS":"Merge sections by cross lists","MERGE_SECTIONS_BY_GRADE_GROUP":"Merge sections by grade group","MERGE_SECTIONS_BY_MODALITY":"Merge sections by modality","MERGE_SECTIONS_BY_PLANS":"Merge sections by plans","MERGE_SECTIONS_BY_SHIFT":"Merge sections by shift","MERGE_SECTIONS_OPPORTUNITY":"Merge sectons opportunity","MERGE_SECTIONS_RESULTS":"Merge sections results","MERGED_COURSES_IN_CROSS_LIST":"Merged courses in this cross list","MINIMUM_GROUP_SIZE":"Tamanho Mínimo do Grupo","MIXED":"Mixed","MOD":"Mod","MODIFY_BASELINE":"Modify baseline","MON":"Monday","MSG_MODIFICATION_BASE_LINE_1":"If you perform this action, it will be visible to users","MSG_MODIFICATION_BASE_LINE_2":"If you perform this action, it will no longer be visible to users","MSG_STATUS_SIMULATION":"To view the status of your simulation, you must go to the Simulation section","MSJ_CLASSROOM_RESTRICTION_INSTRUCTION":"Check the detail of file uploads, successfully loaded data and those with some type of error","MSJ_CLONE_MODAL":"A name has been assigned by default, you have the option to modify it if you think it is convenient","MSJ_ERROR":"Failed to connect to service","MSJ_ERROR_MODAL_CLONE":"The cloning could not be executed","MSJ_ERROR_MODAL_STATUS":"The progress bar tells you the state in which the simulation is, it is advisable not to cancel, to carry out another flow you just have to click on the button to execute in 2nd plane.","MSJ_ERROR_SIMULATION_STATUS":"the simulation could not be executed","MSJ_NO_RECORDS_AVAILABLE":"No records available yet. Click on the 'Create' button to start","MSJ_OPTIMAL_OFFER_SUCCES_COMMENT":"Comment Save Successfull","MSJ_SUCCESS":"Changes updated successfully ","MSJ_SUCCESS_RESTRICTION_CANDIDATE_CLASSTOOMS":"Restriction of candidate rooms successfully created","N_CLASSROOM":"Number of classroom","N_CROSS_LISTED_SECTIONS":"Number of cross-listed sections","N_GENERATED_SECTIONS":"Number of generated sections","N_IDENTIFICATION":"Nº Identification","N_MIXED_SECTIONS":"Number of mixed sections","N_PURE_SECTIONS":"Number of pure sections","N_SECTIONS":"Number of sections","NAME_CROSS_LIST":"Name cross list","NAME_PROGRAMMING":"Academic program Name","NEW_ENTRIES":"New entries","NEW_ENTRIES_FOR_MAX_COMPRESSION":"New entries for max compression","NEW_ENTRIES_FOR_MIN_DESIRED":"New entries for min desired","NEW_POSITION":"New position","NEW_PROGRAMMING":"New program","NEXT":"Next","NO_ASSIGNED_CLASSROOMS":"No assignes classrooms","NO_DATA":"No data Available","NOT_EXECUTED":"Not Executed","NUMBER_OF_CAMPUS":"Number of campus","NUMBER_OF_COMPATIBILITY_GROUPS":"Compatibility group number","NUMBER_OF_GROUPS":"Number of groups","OCCUPATION":"occupation","OPTATIVE_SELECT":"Select Optional Subjects","OPTATIVE_SUBJECT":"Optative Subject","OPTIMAL_ENROLLMENT":"Optimal enrollment","OPTIMAL_OFFER":"Optimal offer","PARALLEL_BY_COURSE_ACTIVITY":"Parallel by Course-Activity","PARALLEL_RESTRICTION":"Parallel restriction","PERCENTAGE_ASSIGNMENTS":"Percentage assignments","PERCENTAGE_ASSIGNMENTS_SECTION_TYPE":"Percentage of assignments as section type","PERCENTAGE_COMPACTION_INFRASTRUCTURE":"percentage of compaction by infrastructure","PLANS":"Study Plan/s","POSITION":"Position","POSITION_CODE":"Position code","POSITION_NAME":"Position name","PREDEFINED":"Pre-defined","PREDEFINED_CANDIDATE_SCHEDULE_CLASSROOM":"Schedules/predefined classrooms and candidates","PREDEFINED_CLASSROOM":"Pre-defined classroom","PREDEFINED_SCHEDULE_CLASSROOM_RESTRICTION":"Pre-defined schedule/classroom restriction","PREDEFINED_TEACHING_ASSIGNAMENT":"Pre-defined teaching assignment","PREFEFINED_SCHEDULE_CLASSROOM":"Schedule / predefined classrooms","PREVIOUS":"Previous","PREVIOUS_PERIOD":"Previous Period","PROGRAMMING":"program","PROGRESS":"progress","PURE":"Pure","QUICK_ACCESS":"Quick Access","QUOTA":"Quota","QUOTAS_USED":"Quotas used","RE_ENTRIES":"Re entries","RE_SIMULATE":"Re-Simulate","REAL_FICTIONAL":"Real/Fictional","RECONFIGURE":"Reconfigure","RECONFIGURE_MSJ":"When reconfiguring you will lose the results of the simulation. You can also clone this simulation to avoid losing these results. What action do you want to take?","RECONFIGURE_SIMULATION":"Reconfigure simulation","RECORDS":"Records","RECORDS_LOADED":"Registros Cargados","RECORDS_REJECTED":"Registros Rechazados","REQUEST_DATE":"Request date","REQUEST_DETAILS":"Request details","REQUEST_LIST":"Request list","RESOLUTION":"Resolution","RESOLUTION_DATE":"Resolution date","RESOLVE_CONFLICTS_IN_CROSS_LISTS":"Resolve conflicts in cross lists","RESOLVE_CONFLICTS_IN_CROSS_LISTS_MESSAGE":"The cross list {string} presents the next conflicts","RESOURCE_DATA":"Resource data","RESOURCE_EMPTY_STATE":"Haga click en un recurso para acceder a la información de este...","RESOURCE_TYPE":"Resource type","RESTRICTION_CANDIDATE_CLASSTOOMS":"Restriction of candidate classrooms","RESTRICTION_LOCATION_ACTIVITY":"Restriction Location/Activity","RESULTS_LOADED_FILE":"Resultados de Carga","ROOT_COURSE":"Root course","SAT":"Saturday","SAVE_NEXT":"Save and Next","SCHEDULE_CLASSROOM_SIMULATION":"Schedule simulation","SCHEDULE_INDEX_VIEW":"Schedule index view","SCHEDULE_TABLE_VIEW":"Schedule table view","SEARCH":"Search","SEARCH_AND_ADD_COURSES":"Search and add courses","SEE_LOAD_CLASSROOM_RESTRICTIONS":"See load restriction classrooms","SEE_LOAD_PREVIOUS_PERIOD":"See load previous period","SEE_RESTRICTION_EXTISTING_CLASSROOM":"See restriction of existing classooms","SEE_RESULTS":"See Results","SEE_SCHEDULE_CLASSROOM_RESTRICTION":"See schedule restrictions classrooms","SEE_STATUS":"See Status","SELECT_ACADEMIC_UNIT":"Select academic unit","SELECT_DEMAND_SIMULATION":"Select a demand simulation","SELECT_LOCATION":"Select locacion","SELECT_LOCATION_AND_STAGE":"Select location and stage","SELECT_ROOM":"Select room","SELECT_SHIFT":"Select shift","SELECT_TEACHER":"Select teacher ","SELECT_TYPE_ACTIVITY_INSTRUCTIONS":"Select the type of activity to which you want to assign schedule and classroom","SELECT_TYPE_OF_EXISTING_RESOURCE":"Select type of existing resource","SELECT_TYPE_RESTRICTION_INSTRUCTIONS":"Select type of restriction to which you want to assign schedule and classroom","SELECTED_CONFIGURATION":"Selected configuration","SESION":"Sesion","SESSION":"Session","SET_UP":"Set Up","SHIFT_NAME":"Shift name","SHIFTS_AVAILALED":"Shifts Available","SIMULATE":"Simulate","SIMULATE_PREVIOUS_POINT":"Simulate in previous point","SIMULATE_SCHEDULE":"Simulate schedule","SIMULATE_SCHEDULE_WITH_THIS_SIM":"Simulate schedule with this Simulation","SIMULATE_TEACHER":"Simulate teacher","SIMULATE_TEACHER_WITH_THIS_SIM":"Simulate teacher with this Simulation","SIMULATION":"Simulation","SIMULATION_CONFIGURATION":"Simulation configuration","SIMULATION_CONFIGURE":"Simulation configuration","SIMULATION_CREATE_SUCCESS":"Simulation created successfully","SIMULATION_DEMAND":"Demand Simulation","SIMULATION_FINISHED":"Simulation finished","SIMULATION_GROUPS":"Group simulation","SIMULATION_INDICATORS":"Simulation indicators","SIMULATION_NAME":"Simulation name","SIMULATION_PROGRESS":"Simulation progress","SIMULATION_SCHEDULE":"Time simulation","SIMULATION_TEACHER":"Teacher simulation","SIMULATIONS":"Simulations","STAGE":"Stage","START_VIRTUAL_GROUP_SIMULATION":"Start virtual group simulation","START_WEEK":"Start week","STATE_OF_PROGRESS":"State of progress","STEP":"Step","STUDENT_PROGRESS":"Student progress","STUDENT_QUOTE":"Student quote","STUDENT_VIEW":"Student view","SUBJECT":"Subject","SUBJECTS":"Subjects","SUN":"Sunday","TEACHER_CONTRACT_TYPE":"Teacher contract type","TEACHER_CONTRACT_TYPE_INSTRUCTION":"Fill in the information in the following form to create a new position. The priority of the charges is generated automatically, if you want to add a manual priority to the new charge there is a field available. Keep in mind that adding a priority manually will change the priority of all charges that come after it. Fields with a (*) are required","TEACHER_EVALUATION_MINIMUN_VALUE":"Teacher evaluation minimum value","TEACHER_INDEX_VIEW":"Teacher index view","TEACHER_POSITION_MAINTAINERS":"Teacher position maintainers","TEACHER_RPC_TABLE_VIEW":"Teacher RPC table view","TEACHER_SIMULATION":"Teacher simulation","TEACHER_SIMULATION_CONFIGURATION":"Teacher simulation configuration","TEACHER_SIMULATION_PROGRESS":"Teacher simulation progress","TEACHER_TABLE_VIEW":"Teacher table view","THU":"Thursday","TIME_RANGES":"Academic calendar","TITLE_CLONE_MODAL":"Cloning progress","TITLE_ERROR_CREATION":"Errors have been detected in the selected infrastructure of the Academic program","TITLE_ERROR_CREATION_2":"Errors have been detected in the existing data of Academic program","TITLE_ERROR_CREATION_SCHEDULE":"Existen @nn secciones que no se asignaran docente por no tener horario y/o sala","TITLE_ERROR_CREATION_SCHEDULE_PARENT":"There are exist @nn sections that don't assign teachers because isn't have virtual activity","TITLE_FORECAST_CREATION":"Simulation will be executed in the next universe of data","TITLE_FORECAST_CREATION_2":"Summary of configuration of parameters","TITLE_SIMULATION":"Review the list of created simulations or create a new simulation","TITLE_STEP_2":"Select type of period and shifts that you want to include in the schedule","TITLE_STEP_5":"Select the subjects to dictate, you can also filter the data to obtain a more accurate result","TITLE_STEP_6":"Select the optative subjects to dictate, you can also filter the data to obtain a more accurate result","TO_DELETE_ASK":"Do you really want to delete?","TOTAL_LOADED_COURSES":"Total loaded courses","TOTAL_MAX_GROUP_COMPRESSION":"Total max group compression","TOTAL_MIN_DESIRED_COMPRESSION":"Total min desired compression","TUE":"Tuesday","TURNS":"Turns","TYPE":"Type","TYPE_OF_ACTIVITY":"Type of Activity","U_FORECAST":"u-forecast","U_PLANNING":"u-planning","UNASSIGNED_SECTIONS":"Unassigned sections","UNMERGE_SUCCESSFUL":"Unmerge performed successfully","UPLOAD_CROSS_LISTS":"Upload cross lists","UPLOAD_DEMAND":"Upload demand","UPLOAD_HISTORY":"Upload history","USAGE_TYPE":"Usage type","USAGE_TYPE_DETAILED":"Usage type detailed","USAGE_TYPE_EMPTY_STATE":"Click on a Type of resource or Type of Use to access the information of this ","USAGE_TYPE_MANTAINERS":"Usage type manteiners","USE_TEACHER_AVAILABILITY":"Use teacher availability","USED":"Used","VALIDATE_DATA_DOWNLOAD_XLS":"Validate data (download in xls)","VALIDATION_LOADED_DATA":"Validation of loaded data","VIEW_CROSS_LIST":"View cross list","VIEW_CROSS_LISTS":"View cross lists","VIEW_GLOSSARY":"See Glossary","VIEW_STATE_OF_PROGRESS_HELP":"Review your courses. In case of inconsistencies, you can submit a request for approval clicking on the corresponding courses.","VIEW_USER_MANUAL":"See User's Manual","VISUALIZE_BY":"Visualize by","WED":"Wednesday","WEEKS_INFORMATION":"Weeks information","WITHOUT":"Without","WITHOUT ASSIGNED_MODULES":"Without assigned modules","YOU_WANT":"You want","80_LIM_INF":"80% del Límite Inferior","80_LIM_SUP":"80% del Límite Superior","ACADEMIC_PERFORMANCE_FIRST_YEAR_FACTOR_DESCRIPTION":"For second year students onwards, average of all first courses taken in the first year of studies.","ACADEMIC_PERFORMANCE_FIRST_YEAR_FACTOR_NAME":"First year average grades.","ACADEMIC_PERFORMANCE_TREND_FACTOR_DESCRIPTION":"Trend in the student's average grades from past periods","ACADEMIC_PERFORMANCE_TREND_FACTOR_NAME":"Trend in the student's average grades","ACCIONES_RAPIDAS":"Shortcuts","ACTIVE_CAREERS_IN_PERIOD_FACTOR_DESCRIPTION":"Number of active majors on the current academic term.","ACTIVE_CAREERS_IN_PERIOD_FACTOR_NAME":"Active majors on academic term.","ADMIN_CARRERA":"Major","ADMISSION_TYPE_FACTOR_DESCRIPTION":"Admission type (Regular admission exam, special admission, transfered, etc)","ADMISSION_TYPE_FACTOR_NAME":"Admission type","AGE_AT_ADMISSION_FACTOR_DESCRIPTION":"Age of the student at the moment of admission. Relevant to the level of maturity of the student during their first year, which is the year with highest risk.","AGE_AT_ADMISSION_FACTOR_NAME":"Age at admission","AGE_AT_PREDICTION_FACTOR_DESCRIPTION":"Student's age at time of prediction","AGE_AT_PREDICTION_FACTOR_NAME":"Age at prediction time","ALERTAS_ALUMNOS_RIESGO":"Percentage of students at risk","ALERTAS_ESTUDIANTES_SUBHEADING":"Active students in this major","ALERTAS_EVOLUCION_DESERCION":"Student's historical status evolution","ALERTAS_EVOLUCION_RAZONES_DESERCION":"Reasons for desertion","ALERTAS_EVOLUCION_SUBHEADING":"Last @year regular academic periods","ALERTAS_GROUPALES_FACTOR":"FACTOR","ALERTAS_GROUPALES_HEADER1":"Group alerts","ALERTAS_GRUPALES":"Group alerts","ALERTAS_INDIVIDUAL_CAMPUS":"Campus","ALERTAS_INDIVIDUAL_CARRER":"Major","ALERTAS_INDIVIDUAL_COHOR":"Cohort","ALERTAS_INDIVIDUAL_CORDIGO":"Student ID","ALERTAS_INDIVIDUAL_EDAD":"Age","ALERTAS_INDIVIDUAL_FICHA":"Profile","ALERTAS_INDIVIDUAL_FICHA_BUTTON":"View Profile","ALERTAS_INDIVIDUAL_HEADLINE1":"Student Search Panel","ALERTAS_INDIVIDUAL_INDEX":"Index","ALERTAS_INDIVIDUAL_MODALIDAD":"Modality","ALERTAS_INDIVIDUAL_NAME":"Name","ALERTAS_INDIVIDUAL_RIESGO":"Risk","ALERTAS_INDIVIDUAL_SEXO":"Sex","ALERTAS_INDIVIDUAL_SUBHEADLINE1":"Students at risk","ALERTAS_INDIVIDUAL_TELEPHONE":"Telephone","ALERTAS_INDIVIDUALES":"Individual alerts","ALERTAS_NIVEL_DE_RIESGO_MAIN_HEADING":"","ALERTAS_NUMERO_ALUMNOS_RIESGO":"","ALUMNO_DESERTADO":"Student has deserted","ALUMNOS_RIESGO":"Risk level per student","ANALISIS":"Analysis","ANALISIS_EXPORTAR_DATOS":"Export Data","ANALISIS_HEADER":"Analysis","ANNO_INGRESO":"Admission year","AUTOR":"Author","AVERAGE_CREDITS_SEMESTER_FACTOR_DESCRIPTION":"Average number of course credits taken by the student, in each academic period.","AVERAGE_CREDITS_SEMESTER_FACTOR_NAME":"Average number of course credits by period","AVERAGE_HIGH_SCHOOL_GRADES_FACTOR_DESCRIPTION":"Average grades (GPA) received by the student in high school.","AVERAGE_HIGH_SCHOOL_GRADES_FACTOR_NAME":"High School average grades","AVERAGE_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indicates, on a percentage scale, the average grade obtained by the student during the academic term.","AVERAGE_PARTIAL_GRADE_FACTOR_NAME":"Average of partial grades","BIENVENIDO":"Welcome to u-retention","BITACORA_CONTACTOS":"Contact log","BUSCAR_FACTOR":"Search factor","CALIBRACION_MODELO":"Model Calibration","CARGA_DATOS":"Data Load","CARRERAS":"Majors","CHILDRENS_INDICATOR_FACTOR_DESCRIPTION":"Has relevance because of economic pressure and effect on academic results, among others.","CHILDRENS_INDICATOR_FACTOR_NAME":"Student has children","CODIGO_ALUMNO":"Student code","CONT_FRACC_COL":"Conteo como Fracción de las Columnas","CONT_FRACC_FILAS":"Conteo como Fracción de las Filas","CONT_FRACC_TOTAL":"Conteo como Fracción del Total","CONT_VALORES_UNICOS":"Conteo de Valores Únicos","CONTEO":"Conteo","CORREO":"Email","CREDIT_INDICATOR_FACTOR_DESCRIPTION":"The student has a private or state credit to pay for tuition.","CREDIT_INDICATOR_FACTOR_NAME":"Student has credit","CREDIT_PERCENTAGE_FACTOR_DESCRIPTION":"Percentage of tuition covered by the credit, if the student has one.","CREDIT_PERCENTAGE_FACTOR_NAME":"Credit percentage","CUMULATIVE_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Cumulative average attendance over every academic period.","CUMULATIVE_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Cumulative class attendance","CUMULATIVE_COURSES_FAILED_ONCE_FACTOR_DESCRIPTION":"Total number of courses the student has failed when enrolling them for the first time.","CUMULATIVE_COURSES_FAILED_ONCE_FACTOR_NAME":"Total courses failed on first time","CUMULATIVE_COURSES_FAILED_THRICE_FACTOR_DESCRIPTION":"Total number of courses the student has failed when enrolling them for the third time.","CUMULATIVE_COURSES_FAILED_THRICE_FACTOR_NAME":"Total courses failed on the third time","CUMULATIVE_COURSES_FAILED_TWICE_FACTOR_DESCRIPTION":"Total number of courses the student has failed when enrolling them for the second time.","CUMULATIVE_COURSES_FAILED_TWICE_FACTOR_NAME":"Total courses failed on the second time","CUMULATIVE_NUMBER_NEGATIVE_CONTACTS_FACTOR_DESCRIPTION":"Total number of contacts that resulted in a negative outcome.","CUMULATIVE_NUMBER_NEGATIVE_CONTACTS_FACTOR_NAME":"Number of negative contacts","CUMULATIVE_NUMBER_OF_STATES_AB_FACTOR_DESCRIPTION":"Number of times the student has had an 'abandon' status in previous academic periods.","CUMULATIVE_NUMBER_OF_STATES_AB_FACTOR_NAME":"Number of abandon status","CUMULATIVE_NUMBER_OF_STATES_RE_FACTOR_DESCRIPTION":"Number of times the student has had a 'reserved' status in previous academic periods.","CUMULATIVE_NUMBER_OF_STATES_RE_FACTOR_NAME":"Number of reserved status","CUMULATIVE_NUMBER_POSITIVE_CONTACTS_FACTOR_DESCRIPTION":"Total number of contacts that resulted in a positive outcome.","CUMULATIVE_NUMBER_POSITIVE_CONTACTS_FACTOR_NAME":"Number of positive contacts","CUMULATIVE_PAST_ACADEMIC_PERFORMANCE_FACTOR_DESCRIPTION":"Cumulative average of student's grades in past academic periods.","CUMULATIVE_PAST_ACADEMIC_PERFORMANCE_FACTOR_NAME":"Cumulative past academic performance","CUMULATIVE_PAST_DESERTION_STATUSES_FACTOR_DESCRIPTION":"Total number of desertion statuses in past academic periods.","CUMULATIVE_PAST_DESERTION_STATUSES_FACTOR_NAME":"Cumulative past desertion statuses","CUMULATIVE_TOTAL_CONTACTS_FACTOR_DESCRIPTION":"Total number of times the student was contacted by the institution.","CUMULATIVE_TOTAL_CONTACTS_FACTOR_NAME":"Cumulative number of contacts","CURRENT_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Average class attendance from the current academic period.","CURRENT_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Class attendance percentage","CURRENT_MIN_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Minimum class attendance from the current academic period","CURRENT_MIN_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Minimum class attendance percentage","DATOS_DE_CONTACTO":"Contact information","DESCRIPCION":"Description","DESERTED_CAREERS_IN_PERIOD_FACTOR_DESCRIPTION":"Number of deserted majors on the current academic term.","DESERTED_CAREERS_IN_PERIOD_FACTOR_NAME":"Deserted majors on academic term.","DESV_ESTAND_MUESTRA":"Desviación Estándas de la Muestra","DIAGNOSTIC_EXAM_SCORE_FACTOR_DESCRIPTION":"Grades received in the institution's diagnostic tests, when applied.","DIAGNOSTIC_EXAM_SCORE_FACTOR_NAME":"Diagnostic test results","DIRECCION":"Address","DISPERSITY_AVERAGE_CREDITS_FACTOR_DESCRIPTION":"","DISPERSITY_AVERAGE_CREDITS_FACTOR_NAME":"","DISPERSITY_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Variation (dispersion) observed in the student's partial grades.","DISPERSITY_PARTIAL_GRADE_FACTOR_NAME":"Variation in the partial grades","DOWNLOAD_ACTIVE_REPORTS":"Active Data Report","EDAD":"Age","ENTRY_EXAM_SCORE_FACTOR_DESCRIPTION":"Grade received in the institution's admission test, when applied.","ENTRY_EXAM_SCORE_FACTOR_NAME":"Admission test results","ENUMERAR_VALORES_UNICOS":"Enumerar Valores Únicos","ESCRIBA_OBSERVACION":"Register observation...","ESTUDIANTES_ACTIVOS_CARRERA":"Major's active students","EVOLUCION_ESTADOS_HIST_ESTUD":"Students status history","EXPECTATIONS_CAREER_FACTOR_DESCRIPTION":"Comparison of the student's expectations and their actual experience. In relation to the major and the institution.","EXPECTATIONS_CAREER_FACTOR_NAME":"Expectation assessment","EXPORT_FILTERED_DATA":"Export filtered data","EXPORTAR_DATOS":"Export data","EXPORTAR_TSV":"Exportar TSV","EXTRACURRICULAR_ACTIVITIES_PARTICIPATION_INDICATOR_FACTOR_DESCRIPTION":"Student participates or skips on activities without credits such as parties, trips, etc.","EXTRACURRICULAR_ACTIVITIES_PARTICIPATION_INDICATOR_FACTOR_NAME":"Extracurricular activities participation","FACTOR":"Factor","FACTORES_INCIDENTES_PRINCIPALES":"Major incident factors","FALSOS_NEGATIVOS":"False negatives","FALSOS_POSITIVOS":"False positives","FAMILY_ENVIROMENT_FACTOR_DESCRIPTION":"Type of family, father and mother present, lives with grandparents, etc.","FAMILY_ENVIROMENT_FACTOR_NAME":"Familiar background","FAMILY_GROUP_QUINTILE_FACTOR_DESCRIPTION":"Student's socioeconomic classification in a common scale, usually given by each country.","FAMILY_GROUP_QUINTILE_FACTOR_NAME":"Socioeconomic level","FAMILY_INCOME_FACTOR_DESCRIPTION":"Total income for the family group, considering incomes from all the family members.","FAMILY_INCOME_FACTOR_NAME":"Family income","FAMILY_OUTCOME_FACTOR_DESCRIPTION":"Total outcome for the family group, considering outcomes from all the family members.","FAMILY_OUTCOME_FACTOR_NAME":"Family Outcomes","FATHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_DESCRIPTION":"Indicates if the father has received (not necessarily completed) higher education studies. Allows to detect first generation students.","FATHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_NAME":"Father has higher education studies","FATHER_HAS_WORK_FACTOR_DESCRIPTION":"Indicates if the father is under employment. Reveals if the family group has a steady income.","FATHER_HAS_WORK_FACTOR_NAME":"Father is employed","FECHA":"Date","FECHA_CALIBRACION_MODELO":"Model Calibration Date","FECHA_CARGA":"Load date","FICHA":"File","FICHA_AURTHOR":"Author","FICHA_BITACORA_CONTACTOS":"Contact Data","FICHA_COHORTE":"Cohort","FICHA_CORREO":"E-mail","FICHA_DATOS_DE_CONTACTO":"Contact Information","FICHA_DESCRIPTION":"Description","FICHA_DIRECTION":"Address","FICHA_FACTOR":"Factor","FICHA_FACTORES_INCIDENTES":"Most incident factors","FICHA_OBSERVATION":"Observation","FICHA_OPERACION_DESERTADO":"Student has deserted","FICHA_OPERACION_MANUALES":"Manual Operations","FICHA_OPERACION_RIESGO":"Mark 'At Risk'","FICHA_PROBABILIDAD":"Historical probability","FICHA_REGISTER_BUTTON":"Register","FICHA_REGISTER_OBSERVATION":"Observations registry","FICHA_TABLE_FICHA":"Date","FICHA_TELEFONO":"Telephone","FICHA_VALUE":"Value","FICHA_VOLVER_ALERTAS_INDIVIDUAL":"Back to Student Search Panel","FIRST_HIGH_EDUCATION_STUDENT_IN_FAMILY_FACTOR_DESCRIPTION":"Indicates if the student belongs to the first generation in his family to access higher education.","FIRST_HIGH_EDUCATION_STUDENT_IN_FAMILY_FACTOR_NAME":"First generation","FIRST_YEAR_STUDENT_FACTOR_DESCRIPTION":"Indicates if the students is a freshman.","FIRST_YEAR_STUDENT_FACTOR_NAME":"First year student","GRAFICO_BARRAS_API_HOR":"Gráfico de Barras Aplidadas Horizontales","GRAFICO_BARRAS_HOR":"Gráfico de Barras Horizontales","GRAFICO_DE_AREA":"Gráfico de Área","GRAFICO_DE_BARRAS":"Gráfico de Barras","GRAFICO_DE_BARRAS_APILADAS":"Gráfico de Barras Apiladas","GRAFICO_DE_DISPERCION":"Gráfico de Disperción","GRAFICO_DE_LINEA":"Gráfico de Línea","HEALTH_PROBLEMS_INDICATOR_FACTOR_DESCRIPTION":"Student presents health related problems. A student with health issues may be incapable to continue their studies.","HEALTH_PROBLEMS_INDICATOR_FACTOR_NAME":"Health problems","HIGH_RISK":"High Risk","HIGHEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indicates, in percentage scale, the highest grade obtained by the student during the academic term.","HIGHEST_PARTIAL_GRADE_FACTOR_NAME":"Highest partial grade","HISTORICAL_MIN_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Minimum class attendance percentage over every academic period.","HISTORICAL_MIN_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Historical minimum attendance percentage","IMPORTANCIA":"Importance","INCIDENCIA":"Incidence","INCOMPATIBILITY_WITH_EXTRACURRICULAR_ACTIVITIES_FACTOR_DESCRIPTION":"The student only has time to go to his classes but can't assist support sessions or other activities. Usually because of work, children or other personal issues. Important to student integration.","INCOMPATIBILITY_WITH_EXTRACURRICULAR_ACTIVITIES_FACTOR_NAME":"Incompatibility with extracurricular activities","INDICATOR":"Indicator","INDICE":"Index","INICIO":"Home","INPUTS_MODELO":"Model Inputs","INSTITUTIONAL_CONDITIONS_FACTOR_DESCRIPTION":"Problems or special conditions the institution may have during the period that affect the students, such as infrastructure issues, conflicts within the academic community, etc.","INSTITUTIONAL_CONDITIONS_FACTOR_NAME":"Institutional conditions","INSTITUTIONAL_INDICATORS":"Institutional Indicators","INTEGRATION_FACTOR_DESCRIPTION":"Sense of belonging to the institution, to their peers and to the overall situation. Particularly relevant to high risk groups (first generation, lower income).","INTEGRATION_FACTOR_NAME":"Integration","LAST_PERIOD_ACADEMIC_PERFORMANCE_FACTOR_DESCRIPTION":"Average grade from the student's last period grades","LAST_PERIOD_ACADEMIC_PERFORMANCE_FACTOR_NAME":"Average grade from last period","LATEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indicates, in percentage scale, the last grade obtained by the student during the academic term.","LATEST_PARTIAL_GRADE_FACTOR_NAME":"Last partial grade","LEVEL_OF_ECONOMIC_DEPENDENCE_FACTOR_DESCRIPTION":"Student economically depends on their family group or has a job to pay for sustain, rent, etc.","LEVEL_OF_ECONOMIC_DEPENDENCE_FACTOR_NAME":"Level of economic dependence","LIBRARY_ACCESSES_FACTOR_DESCRIPTION":"Number and frequency of interactions with the library to borrow physical and digital resources. Used to measure engagement and academic momentum.","LIBRARY_ACCESSES_FACTOR_NAME":"Library interactions","LIVE_WITH_PARENTS_FACTOR_DESCRIPTION":"Related to the degree of independence of the student and the support provided by the parents.","LIVE_WITH_PARENTS_FACTOR_NAME":"Lives with parents","LMS_AVERAGE_ACCESSES_FACTOR_DESCRIPTION":"History of access from the students to the courses on the learning managment system platform. Used to measure engagement, academic momentum and variations on the frequency and type of use.","LMS_AVERAGE_ACCESSES_FACTOR_NAME":"Average access to LMS","LOW_RISK":"Low Risk","LOWEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indicates, on a percentage scale, the lowest grade obtained by the student during the academic term","LOWEST_PARTIAL_GRADE_FACTOR_NAME":"Lowest partial grade","MACROECONOMIC_ENVIROMENT_FACTOR_DESCRIPTION":"Macroeconomic conditons during the period that may affect the students such as recessions and emergencies.","MACROECONOMIC_ENVIROMENT_FACTOR_NAME":"Country's macroeconomic background","MAPA_DE_CALOR":"Mapa de Calor","MAPA_DE_CALOR_COL":"Mapa de Calor por Columna","MAPA_DE_CALOR_FILA":"Mapa de Calor por Fila","MARCAR_RIESGO":"Mark at-risk","MAX_FAILING_GRADE_FACTOR_DESCRIPTION":"Maximum grade obtained in a course the student failed in their history.","MAX_FAILING_GRADE_FACTOR_NAME":"Maximum grade obtained in a course the student failed","MAX_FINAL_GRADE_FACTOR_DESCRIPTION":"Maximum grade obtained in a course in the student's record.","MAX_FINAL_GRADE_FACTOR_NAME":"Maximum grade obtained in a course","MAXIMO":"Máximo","MEDIA":"Media","MEDIO_CONTACTO":"Form of contact","MEDIUM_RISK":"Medium Risk","MENU1":"Data Load","MENU2":"Model Calibration","MENU3":"Student Search Panel","MENU4":"Group Alerts","MENU5":"Pivot Table","MENU6":"Data Load Report","MENU7":"u-retention Reports","MIN_FINAL_GRADE_FACTOR_DESCRIPTION":"Minimum grade obtained in a course in the student's record.","MIN_FINAL_GRADE_FACTOR_NAME":"Minimum grade obtained in a course","MIN_PASSING_GRADE_FACTOR_DESCRIPTION":"Minimum grade obtained in a course the student passed in their history.","MIN_PASSING_GRADE_FACTOR_NAME":"Minimum grade obtained in a course the student passed","MINDSET_FACTOR_DESCRIPTION":"Personal sense about the origin of talents, categorized as 'fixed mentality' or 'growth mentality'.","MINDSET_FACTOR_NAME":"Mentality","MINIMO":"Mínimo","MODEL_RETENTION":"u-retention model","MOTHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_DESCRIPTION":"Indicates if the mother has received (not necessarily completed) higher education studies. Allows to detect first generation students.","MOTHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_NAME":"Mother has higher education studies","MOTHER_HAS_WORK_FACTOR_DESCRIPTION":"Indicates if the mother is under employment. Reveals if the family group has a steady income.","MOTHER_HAS_WORK_FACTOR_NAME":"Mother is employed","NIVEL_RIESGO_DESERCION_COHORTE":"Dropout risk according to admission cohort","NOMBRE":"Name","NOMINATION_PREFERENCE_NUMBER_FACTOR_DESCRIPTION":"Preference order for the career or institution in the student college preference lists. Relevant to quantify the level of initial satisfaction.","NOMINATION_PREFERENCE_NUMBER_FACTOR_NAME":"College preference","NON_REGULAR_PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Number of regular terms in the institution. This counts, for example, the summer terms.","NON_REGULAR_PERIODS_IN_INSTITUTION_FACTOR_NAME":"Number of extraordinary class periods","NUMBER_COURSES_TAKEN_IN_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Number of courses enrolled on the current academic term","NUMBER_COURSES_TAKEN_IN_ACADEMIC_PERIOD_FACTOR_NAME":"Number of courses in term","NUMBER_COURSES_TAKEN_IN_PAST_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Cumulative total number of courses enrolled on previous academic terms","NUMBER_COURSES_TAKEN_IN_PAST_ACADEMIC_PERIOD_FACTOR_NAME":"Number of courses on previous terms","NUMBER_FAILED_COURSES_IN_PAST_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Cumulative total number of failed courses on previous academic terms","NUMBER_FAILED_COURSES_IN_PAST_ACADEMIC_PERIOD_FACTOR_NAME":"Number of failed courses on previous terms","NUMBER_NEGATIVE_CONTACTS_FACTOR_DESCRIPTION":"Number of contacts that resulted in a negative outcome during the current academic period","NUMBER_NEGATIVE_CONTACTS_FACTOR_NAME":"Number of negative contacts during the current academic period","NUMBER_OF_DEPENDENTS_FACTOR_DESCRIPTION":"Student has to provide support to others: family group, children, etc. Relevant to know additional responsibilities and economic pressure.","NUMBER_OF_DEPENDENTS_FACTOR_NAME":"In charge of people","NUMBER_OF_SIBLINGS_FACTOR_DESCRIPTION":"How many siblings the student has, including those not necessarily blood related but that play a similar role","NUMBER_OF_SIBLINGS_FACTOR_NAME":"Number of siblings","NUMBER_POSITIVE_CONTACTS_FACTOR_DESCRIPTION":"Number of contacts that resulted in a positive outcome during the current academic period","NUMBER_POSITIVE_CONTACTS_FACTOR_NAME":"Number of positive contacts during the current academic period","NUMBER_QUOTA_PAYMENTS_FACTOR_DESCRIPTION":"Number of yearly quotas paid by the student.","NUMBER_QUOTA_PAYMENTS_FACTOR_NAME":"Number of quota payements","NUMBER_TUITION_PAYMENTS_FACTOR_DESCRIPTION":"Number of payments from the student for the yearly tuition","NUMBER_TUITION_PAYMENTS_FACTOR_NAME":"Number of tuition payments","NUMERO_ALUMNOS":"Number of students","NUMERO_ALUMNOS_ACTIVOS":"Number of active students","NUMERO_ALUMNOS_HISTORICOS":"Number of historical students","NUMERO_ALUMNOS_RIESGO":"Number of students at risk","OBSERVACION":"Observation","OPERACION_MANUALES":"Manual Operation","ORIGIN_SCHOOL_TYPE_FACTOR_DESCRIPTION":"Public or private high school, homeschool, among others options.","ORIGIN_SCHOOL_TYPE_FACTOR_NAME":"High school type","OUTLIERS":"Outliers","PER_CAPITA_INCOME_FACTOR_DESCRIPTION":"Total incomes of the family group, divided by the number of family members, including the student. A family member is defined as someone that depends on the family incomes.","PER_CAPITA_INCOME_FACTOR_NAME":"Per capita income","PER_CAPITA_OUTCOME_FACTOR_DESCRIPTION":"Total outcomes of the family group, divided by the number of family members, including the student. A family member is defined as someone that depends on the family incomes.","PER_CAPITA_OUTCOME_FACTOR_NAME":"Per capita outcome","PERCENTAGE_APPROVED_CREDITS_IN_STUDY_PLAN_FACTOR_DESCRIPTION":"Percentage of credits passed by the student out of the total credits on the curriculum","PERCENTAGE_APPROVED_CREDITS_IN_STUDY_PLAN_FACTOR_NAME":"Percentage of credits passed on the curriculum","PERCENTAGE_APPROVED_CREDITS_ON_FIRST_YEAR_FACTOR_DESCRIPTION":"Percentage of credits passed during the first academic year out of the total credits enrolled.","PERCENTAGE_APPROVED_CREDITS_ON_FIRST_YEAR_FACTOR_NAME":"Percentage of credits passed during the first academic year","PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Number of academic periods the student has been in the institution studying their current major. Student risk is higher for newer students and for students with an extremely high number of periods in the institution.","PERIODS_IN_INSTITUTION_FACTOR_NAME":"Number of periods in the institution","PHYSICAL_RESOURCE_USAGE_FACTOR_DESCRIPTION":"Amount of physical resources used by the student.","PHYSICAL_RESOURCE_USAGE_FACTOR_NAME":"Physical resources usage","PLAN_ESTADO_ACTUAL":"Study plan and current status","PORCENT_ALUMNOS_RIESGO":"Percentage of students at risk","PREGNANCY_INDICATOR_FACTOR_DESCRIPTION":"Pregnancy of student or student's partner. Relevant because of economic pressure and effect on academical results, among others.","PREGNANCY_INDICATOR_FACTOR_NAME":"Pregnancy","PREGRADO":"Undergraduate","PREVIOUS_ACADEMIC_EXPERIENCE_INDICATOR_FACTOR_DESCRIPTION":"The student has a previous studies in higher education degree.","PREVIOUS_ACADEMIC_EXPERIENCE_INDICATOR_FACTOR_NAME":"Previous academic experience","PREVIOUSLY_FAILED_COURSES_TAKEN_IN_SEMESTER_FACTOR_DESCRIPTION":"Number of courses enrolled on the current academic period that the student has previously failed.","PREVIOUSLY_FAILED_COURSES_TAKEN_IN_SEMESTER_FACTOR_NAME":"Number of courses enrolled this period that the student has previously failed","PRIMERO":"Primero","PROBABILIDAD_DESERCION":"Historical probability","PROBABILIDAD_HISTORICA":"Risk history","PROGRAM_EVALUATION_FACTOR_DESCRIPTION":"Student's opinion on the quality of the study program and the institution's service (separate from vocation).","PROGRAM_EVALUATION_FACTOR_NAME":"Opinion on the study program","PSYCHOLOGICAL_HELP_INDICATOR_FACTOR_DESCRIPTION":"The student has required psychological support during their time at the institution.","PSYCHOLOGICAL_HELP_INDICATOR_FACTOR_NAME":"Psychological help","RAZONES_DESERCION":"Risk factors","REG_INCOMPLETOS":"Incomplete Records","REGISTRAR":"Register","REGISTRO_OBSERVACIONES":"Observation registry","REGULAR_PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Number of regular terms in the institution. This doesn't includes for example, the summer terms.","REGULAR_PERIODS_IN_INSTITUTION_FACTOR_NAME":"Number of regular class periods","REP_DATOS_CARGADOS":"Data Report","REP_RETENTION":"u-retention Reports","RESULTADO_CALIBRACION":"Calibration results","RESULTADO_CARGA_DATOS":"Data Load results","RESULTADO_CONTACTO":"Contact results","RIESGO":"Risk","RISK_PROFILE":"Risk Profile","SCHOLARSHIP_INDICATOR_FACTOR_DESCRIPTION":"Type of scholarship the student has, used to group similar students.","SCHOLARSHIP_INDICATOR_FACTOR_NAME":"Student has scholarship","SCHOLARSHIP_PERCENTAGE_FACTOR_DESCRIPTION":"Percentage of tuition covered by the scholarship, if the student has one.","SCHOLARSHIP_PERCENTAGE_FACTOR_NAME":"Scholarship percentage","SEGUIR_ESTUDIANTE":"Track Students","SELECT_SUBMODEL_CARREER":"","SELECTION_EXAM_SCORE_FACTOR_DESCRIPTION":"Grade received in standard college tests, at national or regional organization.","SELECTION_EXAM_SCORE_FACTOR_NAME":"Selection tests results","SEX_FACTOR_DESCRIPTION":"Related to behavior and learning differences due to gender characteristics.","SEX_FACTOR_NAME":"Sex","SEXO":"Sex","SHOW_ALL_INSTITUTIONAL_INDICATORS":"Show all institutional indicators","SHOW_TRACKED_STUDENTS":"Show tracked students","SIBLING_POSITION_FACTOR_DESCRIPTION":"Position number among the siblings, if any.","SIBLING_POSITION_FACTOR_NAME":"Position among siblings","SPECIAL_ADMISSION_FACTOR_DESCRIPTION":"Indicates if, according to the records of the institution, the student has entered a career at a different level than the initial one.","SPECIAL_ADMISSION_FACTOR_NAME":"Entry in higher level","STARTING_SEMESTER_FACTOR_DESCRIPTION":"Academic term when student was admitted to the institution.","STARTING_SEMESTER_FACTOR_NAME":"Admission term","STOP_TRACKING":"Stop Tracking","STUDENT_DETAILS":"Student details","STUDENT_DOESNT_HAVE_INDICATORS":"Student doesn't have indicators","STUDENT_FROM_ANOTHER_CITY_FACTOR_DESCRIPTION":"Relevant because of the effect of changing support nets, friends and family.","STUDENT_FROM_ANOTHER_CITY_FACTOR_NAME":"Student comes from city different to campus location","STUDENT_IS_SINGLE_FACTOR_DESCRIPTION":"Has relevance due to the support net and level of responsibilities outside the studies.","STUDENT_IS_SINGLE_FACTOR_NAME":"Student is single","STUDENT_WORKS_INDICATOR_FACTOR_DESCRIPTION":"Student works or is a full-time student.","STUDENT_WORKS_INDICATOR_FACTOR_NAME":"Student's employment situation","STUDY_HABITS_FACTOR_DESCRIPTION":"Studies alone or in group. Use of LMS (Learning Management System) as support, borrowing books from the library.","STUDY_HABITS_FACTOR_NAME":"Study methods","SUBMODEL":"Institutional Submodel","SUBMODEL_CONFIG":"Submodel config","SUM_ENTERA":"Suma Entera","SUM_FRACC_COL":"Suma como Fracción de las Columnas","SUM_FRACC_FILAS":"Suma como Fracción de las Filas","SUM_FRACC_TOTAL":"Suma como Fracción del Total","SUM_SOBR_SUM":"Suma sobre Suma","SUMA":"Suma","TABLA":"Tabla","TABLA_DINAMICA":"Pivot Table","TABLA_GRAFICO_BARRAS":"Tabla con Gráfico de Barras","TELEFONO":"Telephone","TELEFONOS":"Telephone","TIME_BETWEEN_SCHOOL_GRADUATION_AND_HIGHER_EDUCATION_ENTRANCE_FACTOR_DESCRIPTION":"Years passed between the student finishing high school and entering higher education.","TIME_BETWEEN_SCHOOL_GRADUATION_AND_HIGHER_EDUCATION_ENTRANCE_FACTOR_NAME":"Time between high school graduation and higher education enrollment","TOTAL_CONTACTS_FACTOR_DESCRIPTION":"Total number of times the student was contacted by the institution during the current academic period.","TOTAL_CONTACTS_FACTOR_NAME":"Total number of contacts during the current academic period","TOTAL_CREDITS_FIRST_YEAR_FACTOR_DESCRIPTION":"Number of credits coursed on the first year.","TOTAL_CREDITS_FIRST_YEAR_FACTOR_NAME":"Number of credits coursed on the first academic year","TOTAL_CREDITS_SEMESTER_FACTOR_DESCRIPTION":"Total amount of credits enrolled in the current academic period.","TOTAL_CREDITS_SEMESTER_FACTOR_NAME":"Total credits in current academic period","TOTAL_REGISTROS_PRUEBA":"All registers","TRACK":"Track","TRACK_STUDENT":"Track student","TREEMAP":"Treemap","TREND_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Trend observed in the grades (positive, negative or neutral).","TREND_PARTIAL_GRADE_FACTOR_NAME":"Trend of partial grades","U_RETENTION":"u-retention","ULTIMO":"Último","ULTIMOS_X_SEMESTRES_REG":"Last @year regular academic periods","VALOR":"Value","VAR_DE_MUESTRA":"Varianza de la Muestra","VARIABILIDAD":"Variability","VER_FICHA":"View Profile","VOCATIONAL_CAREER_RELATIONSHIP_INDICATOR_FACTOR_DESCRIPTION":"Major the student enrolled in versus the one they declared as their vocation if there is one.","VOCATIONAL_CAREER_RELATIONSHIP_INDICATOR_FACTOR_NAME":"Vocation/enrolled major relation","VOLVER_ALERTAS_INDIVIDUAL":"Return to Student Search Panel","ACADEMIC_CALENDAR_DETAIL":"Academic calendar detail","ACADEMIC_PLAN":"Academic plan","ACADEMIC_UNIT":"Academic unit","ACCEPT":"Accept","ACTIONS":"Actions","ACTIVATE":"Activate","ACTIVATE_DEACTIVATE":"Activate deactivate","ACTIVE":"Active","ACTIVITY":"Activity","ACTIVITY_NAME":"Activity","ACTIVITY_TYPE":"Activity type","ADD_CANDIDATE":"Add candidate","ADDED_CANDIDATES":"Added candidates","ADDRESS":"Address","ADVANCED_OPTIONS":"Advanced options","ADVANCED_SEARCH":"Advanced search","AGENDA":"Agenda","ALL":"All","ALL_THE":"All the","AMOUNT_DESTINY":"Amount of destiny","AMOUNT_ORIGIN":"Amount of origin","ANONYMOUS":"Anonymous","API_VERSION":"API version","APPROVE":"Approve","Apr":"Apr","April":"April","ASIGNATURE":"Subject","ASK_FOR_CONTINUE":"Are you sure to continue?","ASSIGNATION_CODE":"Assignation code","ASSIGNATION_SCHEDULE_ROOM":"Assignation schule and room","ATTACHED_FILES":"Attached files","ATTACHED_TO":"Attached to","ATTENDANCE_QUESTION":"Attendance?","Aug":"Aug","August":"August","AUTHOR":"Author","AVERAGE":"Average","BACK":"Go back","BATCH_UPLOAD":"Batch upload","BLOCKS_USED_WEEKLY":"Blocks used weekly","BUILDING":"Building","CALCULATION_TYPE":"Calculation type","CALENDAR":"Calendar","CALENDAR_VIEW":"Calendar view","CAMPUS":"Campus","CAMPUS_CODE":"Campus code","CAMPUS_ID":"Campus ID","CAMPUS_NAME":"Campus name","CAMPUS_PERIOD_SHIFT":"Campus - Period - Shift","CANCEL":"Cancel","CANCEL_SIMULATION":"Cancel simulation","CANDIDATE":"Candidate","CANT_CAREERS":"","CANT_COURSES":"","CANT_STUDENTS":"Cant students","CAPACITY":"Capacity","CAPTURE":"Edit","CATEGORY":"Category","CHANGE":"Change","CLASSROOMS":"Classrooms","CLICK_TO_SEE_MORE":"click to see more","CLIENT_NICENAME":"u-planner","CLONE":"Clone","CLOSE":"Close","CODE":"Code","COHORTE":"Cohort","COMMENT":"Comment","COMMENTS":"Comments","COMMONS_COURSES":"Commons courses","COMPACTED_GROUPS":"Compacted groups","COMPATIBILITY_GROUP":"Grupo compatibilidad","COMPETENCY_MATRIX":"Competency matrix","COMPONENT_TYPE":"Component type","COMPONENT_WEIGHT":"Weight","CONFIGURE":"Configure","CONFIRM":"Confirm","CONFIRMED":"Confirmed","CONSECUTIVE_BLOCKS":"Consecutive blocks","CONSECUTIVE_MODULES":"Consecutive modules","CONTACT_NUMBER":"Contact number","COORDINATOR":"Coordinator","COURSE":"Course","COURSE_DETAIL":"Course detail","COURSE_DETAILS":"Course details","COURSE_MATTER":"Course/matter","CREATE_CAMPUS":"Create campus","CREATE_FACULTY":"Create faculty","CREATE_STATE":"Create state","CREATED_AT":"Created at","CREATION":"Creation","CREATOR_USER":"Creator user","CURRICULAR":"Curricular","CUSTOM":"Custom","CYCLE":"Cycle","CYCLE_PASSED":"Cycle passed","DATA":"Data","DATA_INTEGRATION":"Data integration","DATA_INTEGRATION_EXECUTE":"Data integration execute","DATA_LOADED_CORRECTLY":"Data loaded correctly","DATA_NOT_LOADED":"Data not loaded correctly","DATES":"Dates","DAY":"Day","DAY_MODULES":"Days / Modules","DAYS":"Days","DEADLINE":"Deadline","Dec":"Dec","December":"December","DEFINE_SCHEDULE":"Define schedule","DELAY":"Delay","DELAY_QUESTION":"Delay?","DELETE":"Delete","DESCRIPTION":"Description","DESIGNATIONS":"Designations","DESTINY":"Destiny","DETAILS":"Details","DIMENSION":"Dimension","DISABLE_CAMPUS_PROMPT":"Are you sure you wish to disable this campus?","DO_UPLOAD_DATA":"Upload data","DOWNLOAD_FORMAT":"Download format","DRAG_FILES":"Drag files here","EDIT":"Edit","EDIT_ACADEMIC_CALENDAR":"Edit academic calendar","EDIT_COURSE_COMPETENCY_TRIBUTE":"Edit course tribute to competency","EDIT_FACULTY":"Edit faculty","EDIT_LIST":"Edit list","EMAIL":"Email","END_HOUR":"End hour","ENTER":"Ingresar","ENTER_PASSWORD":"Ingrese su contraseña","ENTER_VALID_USERNAME":"Ingrese un nombre de usuario válido","ENTER_YOUR_REQUIREMENTS_AND_COMMENTS":"enter your requirements and / or comments here","ERROR":"Error","ERRORS_REPORT":"Error report","EVALUATION_CRITERIA":"Criterios de Evaluación","EVALUATION_NAME":"Name evaluation","EVERY":"Every","EXPORT":"Export","EXPORT_CSV":"Export to CSV","EXPORT_XLS":"Export to XLS","EXTRACURRICULAR":"Extracurricular","Feb":"Feb","February":"February","FICTIONAL":"Fictional","FILE":"File","FILTER":"Filter","FILTER_INFO_NOT_FOUND":"Filter info not found","FILTER_TO_SEE":"Filter to see","FILTERS":"Filters","FINAL":"Final","FINAL_EVALUATION":"Final evaluation","FINISH":"Finish","FLOOR":"Floor","Fri":"Fri","Friday":"Friday","FROM":"From","FRONT_VERSION":"Front version","FUNCTIONS":"Functions","GENERAL":"General","GENERAL_DATA":"General data","GENERANTING_CODES":"Generating codes","GO_BACK":"Go back","GROUPS":"Groups","HEIGHT":"Height","HELP":"Help","HIDE":"Hide","HIDE_FILTERS":"Hide filters","HOURS":"Hours","ID_FATHER":"Id father","IDLE_CAPACITY":"Idle capacity","IMAGE":"Image","IMPLEMENTS":"Implements","INACTIVE":"Inactive","INFO_NOT_FOUND":"No existe información","INFORMATION":"Information","INFRASTRUCTURE_QUOTA":"Infrastructure quota","INITIAL":"Initial","INITIATE_DATA_INTEGRATION":"Initiate data integration","INITIATE_UPLOAD_DATA":"Initiate upload data","INSERT_END_DATE":"Insert end date","INSERT_START_DATE":"Insert start date","INVALID":"invalid","IS_REQUIRED":"Is required","Jan":"Jan","January":"January","Jul":"Jul","July":"July","Jun":"Jun","June":"June","LAST_15_DAYS":"Last 15 days","LAST_30_DAYS":"Last 30 days","LAST_7_DAYS":"Last 7 days","LAST_WEEK":"Last week","LENGTH":"Length","LEVEL":"Level","LEVEL_SCHEMA":"Competency development scheme","LOADING":"Loading","LOADING_AFFECTED_SIMULATIONS":"Load affected simulations","LOADING_INDICATORS":"Loading indicators","LOCATION":"Location","LOGIN_PROMPT":"Ingrese sus datos de acceso","MANAGE":"Manage","MANAGEMENT":"Management","MANAGEMENTS":"Managements","Mar":"Mar","March":"March","MAX_WEEKLY_BLOCKS":"Max weekly blocks","May":"May","MENU_COLLAPSE":"Collapse menu","MENU_LANG":"Language","MENU_LOGOUT":"Log out","MENU_MY_PROFILE":"My profile","MENU_OPTIONS":"Options","MENU_START":"Home","MERGE":"Merge","MERGE_SECTIONS":"Merge sections","MIN_BLOCK_CREDITS":"Minimum block credits","MINUTES":"Minutes","MINUTES_AFTER":"Minutes after","MINUTES_BEFORE":"Minutes before","MODALITY":"Modality","MODIFICATION":"Modification","MODIFICATOR_USER":"Modificator user","MODULE":"Module","MODULE_COMPONENT":"Module","MODULES":"Modules","MODULES_PER_WEEK":"Modules per week","MODULES_ROOMS":"Modules / rooms","Mon":"Mon","Monday":"Monday","MONTH":"Month","MORE_INFORMATION":"More information","MSJ_ACADEMIC_CALENDAR_DAY_MODULES":"Seleccione los días y módulos que conformarán el nuevo Calendario Académico","MSJ_ACADEMIC_CALENDAR_WEEKS":"Seleccione las semanas que conformarán el nuevo calendario académico.","MSJ_ALL_CHANGES_ARE_SAVED_AUTOMATICALLY":"All changes are saved automatically","MSJ_CODE_EXISTS":"Code already exists","MSJ_CREATION_SUCCESS":"Action success","MSJ_DEFINITIVE_SENDING_OF_GRADES ":"","MSJ_DELETE":"The records have been deleted","MSJ_FAIL_TO_UPLOAD":"Fail to upload","MSJ_INCORRECT_USER_PASS":"Incorrect user / password","MSJ_MAINTENANCE_NOTIFICATION":"The next maintenance of the application will be","MSJ_NO_DATA_RELATED_YOUR_SEARCH":"There is no data related to your search criteria","MSJ_PARAMETERS_SAVED_CORRECTLY":"Parameters saved correctly","MSJ_PLEASE_WAIT_WHILE_PROCESSING_FILE":"Please, wait while the file is processing. You'll redirect to results screen","MSJ_REQUIRED_FIELDS_MISSING":"Required fields missing","MSJ_SCHEDULE_SAVED_SUCCESSFULLY":"Schedule saved successfully","MSJ_SUCCESFUL_UPLOAD_FILES":"successful upload files","MSJ_TEACHER_SIMULATION_PROGRESS":"The progress bar indicates the state in which the simulation is, you should not cancel, to carry out another stream should only click on the run button in 2nd plane.","MSJ_UPDATED_SUCCESSFULLY":"Updated successfully","MSJ_UPLOADED_SUCCESSFULLY":"Uploaded successfully","MSJ_USER_DOESNT_MATCH_WITH_LOGGED_IN":"This user does not match with the logged in","N_ENROLLED":"Nº Enrolled","N_LINE":"Nº Line","N_OF_LICENCES":"Number of licences","N_OF_PERIOD":"Nº Period","N_OF_SECTIONS":"N° Sections","N_OF_STUDENTS":"N° of students","N_PLAN":"Nº Plans","N_STUDENTS":"N° students","NAME":"Name","NAME_STAGE":"Stage Name","NAMES":"Names","NEXT_DAYS":"Next days","NO":"No","NO_NAME":"No name","NO_NOTES":"No notes","NO_OFFICIAL_GRADE":"No official grade","NOT_STARTED":"Not started","NOT_SYNCHRONIZABLE":"Not sinchronizable","NOT_TRACKING":"Not Tracking","Nov":"Nov","November":"November","NRC":"NRC","NUMBER_OF":"N°","OBSERVATION":"Observation","OBSERVATION_DESCRIPTION":"Observation / Description","OBSERVATIONS":"Observations","Oct":"Oct","October":"October","OF":"of","OPERATION":"Operation","ORIGIN":"Origin","ORIGINAL_AMOUNT":"Original amount","PARAMETERIZATION":"Parameterization","PASSWORD":"Contraseña","PENDING":"Pending","PERCENTAGE":"Percentage","PERCENTAGE_ASSIGNATION_SCHEDULE_ROOM":"Percentage assignment schedule rooms","PERCENTAGE_OCCUPIED_CAPACITY":"Percentage occupied capacity","PERIOD":"Period","PERIOD_CODE":"Period Code","PERIOD_CREATE":"Period Name","PERIOD_NAME":"Period Name","PERIODS":"Periods","PERMISSIONS":"permissions","PERSONAL_ID":"ID","PLAN":"Plan","PREVIOUS_DAYS":"Previours days","PRIVACY_POLICIES":"Privacy Policies","PRODUCT":"Product","PROGRAMMABLE":"Programmable","PROGRAMMED":"Programmed","PROGRESS_SUGGEST":"Progress Suggest","PROPERTIES":"Properties","REAL":"Real","REGENERATE_CODES":"Regenerate codes","REJECT":"REJECT","REJECTED":"Rejected","REPEAT":"Repeat","REPLACEMENT":"Peplacement","REPLACEMENT_QUESTION":"Replacement?","REQUEST":"Request","REQUEST_ACCEPTED":"Request accepted","REQUEST_STATE":"Request state","REQUIRED":"Required","RESOURCE":"Resource","RESOURCES":"Means","RESPONSIBLE":"Responsible","RESTORE":"Restore","RESULTS":"Results","ROLES":"Roles","ROOT":"Root ","Sat":"Sat","Saturday":"Saturday","SAVE":"Save","SAVE_RETURN":"Save and return","SCALE_MAX":"Scale max","SCALE_MIN":"Scale min","SCHEDULE":"Schedule","SCHEDULE_BATCH_UPLOAD":"Schedule batch upload","SCHEDULE_SIMULATION_PROGRESS":"Schedule simulation progress","SCHEDULE_TYPE":"Schedule type","SEARCH_SECTIONS":"Search sections","SECTION":"Section","SECTION_CODE":"Section code","SECTION_DETAIL":"Section detail","SECTION_ID":"ID de Sección","SEE":"See","SEE_DETAIL":"See detail","SEE_DETAILS":"See details","SEE_EDIT":"See/Edit","SELECT":"Select","SELECT_ALL":"Select All","SELECT_APPLICATION":"Select application","SELECT_CAMPUS":"","SELECT_COURSE":"Select course","SELECT_DAY":"Select day","SELECT_LEVEL_IN_COMPETENCY":"Select the competency level development","SELECT_MODULE":"Select module","SELECT_NAME_EVALUATION":"Select evaluation name","SELECT_ONE_SUPERVISOR_MSJ":"Select atleast one supervisor","SELECT_PERIOD":"Select period","SELECT_PERIODS":"Select periods","SELECT_PROGRAMMING":"Select program","SELECT_SCHEDULE_SIMULATION":"Select schedule simulation","SELECT_SIMULATION":"Select simulation","SELECT_SPECIALTY":"Select specialty","SELECT_SUBJECT":"Select subject","SELECT_SUPERVISOR":"Select supervisor","SELECT_WEEK":"Select week","SELECTED_WEEK":"Selected week","SEND":"Enviar","Sep":"Sep","September":"September","SETTINGS":"Ajustes","SHIFT":"Shift","SHOW":"Show","SHOW_ADVANCED_FILTERS":"Show/hide advanced filters","SHOW_FILTERS":"Show filters","SIMBOLIZATION":"Simbolization","SIMULATED_GRADE":"Simulated grade","SQUARE_METERS":"square meters","START_END_HOUR":"Start/End hour","START_HOUR":"Start hour","STARTED":"Started","STATE":"Estate","STATE_LIST":"State list","STATES":"Estates","STATUS":"Status","STUDENT":"Student","STUDENTS":"Students","STUDENTS_LEVEL":"Students level","STUDY_PLAN":"Study plan","Sun":"Sun","Sunday":"Sunday","SURNAME":"Surname ","SURNAMES":"Surnames","SYNCHRONIZABLE":"synchronizable","SYNCHRONIZED":"synchronized","TEACHER":"Teacher","TEACHER_EVALUATION":"Teacher evaluation","TEACHER_NAME":"Teacher name","TEACHER_ROLE":"Teacher role","Thu":"Thu","Thursday":"Thursday","TO_ASSIGN":"Assign","TO_UNASSIGN":"Unassign","TODAY":"Today","TOTAL":"Total","TOTAL_CANDIDATES":"Total candidates","TOTAL_CLASS":"Total class","TOTAL_MODULES":"Total modules","TOTAL_PREDEFINED":"Total predefined","TOTAL_STUDENTS":"Total students","TRACKING":"Tracking","TRANSFER_STUDENTS":"Transfer students","TRANSITION":"Transition","TRANSITION_FUNCTION":"Transition Function","Tue":"Tue","Tuesday":"Tuesday","U_ANALYTICS":"u-analytics","U_FACULTY":"u-faculty","U_LEARNING":"u-learning","U_SUITE":"u-suite","U_SUITE_ABOUT":"u-suite about","UNIQUE_GROUP":"Unique group","UNLOCK":"Unlock","UNTIL":"Until","UPDATE":"Update","UPDATE_CANCEL":"Update/Cancel","UPDATE_CANCEL_EVENT":"Update/Cancel event","UPDATE_DATE":"Update date","UPDATED":"Updated","UPLOAD_DATA_ERROR_MSJ":"¡ERROR! data error","UPLOAD_FILES":"Upload files","UPLOAD_IMAGE":"Upload image","UPLOAD_VIDEO":"Upload video","USAGE":"Usage","VERSION":"Version","VIDEO":"Video","VIEW":"To See","VIRTUAL":"Virtual","VISUALIZATION":"Visualization","VISUALIZATIONS":"Visualizations","WARNING_INPUTS_REQUIRED":"* Is required","WARNING_MESSAGE_EDIT_DEFAULT":"","WEB_SITES":"Web sites","Wed":"Wed","Wednesday":"Wednesday","WEEK":"Week","WEEK_MONTH":"Week/Month","WEEKLY_BLOCKS":"Weekly blocks","WEEKLY_HOURS":"Weekly hours","WEEKS":"Weeks","WEIGHT":"Weight","WELCOME":"Welcome","WIDTH":"Width","WITHOUT_AFFECTED_SIMULATIONS":"Without affected simulations","WITHOUT_CODE":"Without code","YES":"Yes","YES_NO":"Yes/No"}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports = {"ACCESS_CONFIG":"Configuración de acceso","ADMIN_GRUPOS":"Administración de grupos","ADMIN_PANEL":"Admin panel","ADMIN_ROLES":"Administración de roles","ADMIN_USUARIOS":"Administración de usuarios","ASSOCIATED_GROUPS":"Grupos asociados","CREATE_NEW_GROUP":"Crear nuevo grupo","CREATE_NEW_ROLE":"Crear nuevo rol","CREATE_NEW_USER":"Crear nuevo usuario","DATE_LAST_ENTRY":"Fecha último ingreso","DEACTIVATE_GROUP":"Desactivar grupo","DEACTIVATE_REGISTRY_MSJ":"¿Desea desactivar ese registro?","DEACTIVATE_ROLE":"Desactivar rol","DEACTIVATE_USER":"Desactivar usuario","EDIT_ASSIGNMENT":"Editar Asignación ","EDIT_USER":"Editar usuario","EMAIL_NOT_VALID_MSJ":"El e-mail ingresado no es válido","GENERATED_GROUPS":"Grupos generados","GROUP_ADMIN":"Administración de Grupos","GROUP_NAME":"Nombre del grupo","INSERT_FULL_NAME_MSJ":"Por favor, ingresa el nombre completo","INSERT_INSTITUTION_MSJ":"Por favor seleccione una institución","INSERT_PASSWORD_AGAIN_MSJ":"Por favor, repita la contraseña","INSERT_PASSWORD_MSJ":"Por favor, ingresa una contraseña","INSERT_USER_NAME_MSJ":"Por favor, ingresa el nombre de usuario","PASSWORD_NOT_MATCH_MSJ":"Las contraseñas no coinciden","PERSONAL_INFO":"Información personal","REPEAT_PASSWORD":"Repetir contraseña","ROLE_ADMIN":"Administración de Roles","ROLE_NAME":"Nombre del rol","SECTIONS":"Secciones","SELECT_GROUP_TYPE_PLACEHOLD":"Seleccione tipo de grupo...","SELECT_INSTITUTION_PLACEHOLD":"Seleccionar institución...","TYPE_OF_USER":"Tipo de usuario","USER_ADMIN":"Administración de Usuarios","USER_ROLES":"Roles de usuario","USERNAME":"Nombre de usuario","absence-percentage":"Porcentaje de inasistencia","acceso-a-tablas-de-filtrado":"Acceso a Tablas de Filtrado","acceso-administracion-grupos":"Acceso Administración Grupos","acceso-administracion-roles":"Acceso Administración Roles","acceso-administracion-usuarios":"Acceso Administración Usuarios","acceso-carga-demand-global":"Acceso Carga Demanda Global","acceso-carga-disponibilidad-docente":"Acceso Carga Disponibilidad Docente","acceso-carga-grupos":"Acceso Carga Grupos","acceso-carga-listas-cruzadas":"Acceso Carga Listas Cruzadas","acceso-mantenedor-cargo-docente":"Acceso mantenedor cargo docente","acceso-mantenedor-de-costo-eva-docente":"Acceso Mantenedor de Costo Evaluación Docente","acceso-mantenedor-de-jornadas":"Acceso Mantenedor de Jornadas","acceso-mantenedor-disponibilidad-docente":"Acceso mantenedor disponibilidad docente","acceso-mantenedor-docente-materia-actividad":"Acceso mantenedor docente materia actividad","acceso-mantenedores-de-recursos":"Acceso Mantenedores De Recursos","acceso-mantenedores-de-tipo-de-uso":"Acceso Mantenedores De Tipo de Uso","acceso-pantalla-inicio":"Acceso Pantalla Inicio","acceso-perfil":"Acceso Perfil","acceso-programacion-academica":"Acceso Programación Académica","acceso-restriccion-ubicacion-actividad":"Acceso Restriccion Ubicación Actividad","acceso-simulacion-forecast":"Acceso Simulación Forecast","acceso-simulacion-group":"Acceso Simulación Group","acceso-simulacion-schedule":"Acceso Simulacion Horario","acceso-simulacion-teacher":"Acceso Simulación Docente","acceso-simulaciones":"Acceso Simulaciones","acceso-syllabus":"Acceso Syllabus","acceso-tiempo-de-traslado":"Acceso Tiempo de Traslado","acciones-materias":"Acciones Materias","actividades-extracurriculares":"Actividades Extracurriculares","activos-de-aula":"Activos de Aula","actualizacion-contenido":"Actualización Contenido","actualizacion-notas":"Actualización Notas","administar-publicidad":"Administar Publicidad","alertas-individuales":"Alertas Individuales","algorithm-log":"Log de algoritmo","apertura-clases":"Apertura Clases","aplicaciones-virtuales":"Aplicaciones Virtuales","apuntes":"Apuntes","asignaciones-app.v-por-curso":"Asignaciones App.V por Curso","asignaturas-con-mayor-cantidad-de-alumnos":"Asignaturas con mayor cantidad de alumnos","asistencia-clase-actual":"Asistencia clase Actual","asistencia-docentes":"Asistencia Docentes","asistencia-estudiantes":"Asistencia Estudiantes","assisted-classes":"Clases asistidas","attendance":"Asistencia","attendance-percentage":"Porcentaje de asistencia","auto-attendance":"Asistencia automática","backend-log":"Log del backend","bitacora-de-contactos":"Bitácora de contactos","buscar-reserva":"Buscar Reserva","calendario-academico":"Calendario Académico","calibracion-del-modelo":"Calibración del modelo","carga-listas-cruzadas":"Carga Listas Cruzadas","carga-nuevos-estudiantes":"Carga Nuevos Estudiantes","carga-periodo-anterior":"Carga Periodo Anterior","carga-restriccion-salas":"Carga Restricción Salas","carrera/edificio":"Carrera/Edificio","carreras":"Carreras","competencias-avance-curricular":"Competencias Avance Curricular","configuracion":"Configuración","configuracion-listas-cruzadas":"Configuración Listas Cruzadas","configuracion-matricula-óptima":"Configuración Matrícula Óptima","configuracion-programacion-academica":"Configuración Programación Académica","configurar-disponibilidad-docente":"Configurar Disponibilidad Docente","configurar-funcion-objetivo":"Configurar Función Objetivo","confirmacion":"Confirmación","content":"Contenido","costo-curso-actividad":"Costo Curso Actividad","cuadro-de-mando":"Cuadro de Mando","cupo-academico":"Cupo Académico","current-class-content":"Contenido clase actual","current-class-notes":"Notas clase actual","curso/edificio":"Curso/Edificio","datos-de-contacto":"Datos de contacto","dictated-classes":"Clases dictadas","docentes":"Docentes","encuestas":"Encuestas","encuestas-de-preferencia":"Encuestas de Preferencia","estructuras-evaluacion":"Estructuras Evaluación","estructuras-evaluacion-por-seccion":"Estructuras evaluación por Sección","evidencia-logro-competencias":"Evidencia Logro Competencias","evolucion-de-la-desercion-historica":"Evolución de la deserción histórica","exportar-datos":"Exportar datos","factor":"Factor","facultades":"Facultades","finish-class":"Finalizar Clase","generator-random-code":"Generador código aleatorio","generator-random-code-courses":"Generador código aleatorio por cursos","generator-random-code-periods":"Generador código aleatorio por periodos","grade-calculator":"Calculadora","grade-official":"Nota oficial","grade-percentaje":"Porcentaje notas","grade-progress":"Nota progreso","grade-unofficial":"Nota no oficial","grades":"Notas","grades-access":"Acceso Grades","grades-formula":"Formula notas","grafico-de-estudiantes-en-riesgo-por-periodo":"Gráfico de estudiantes en riesgo por periodo","historic-attendance":"Asistencia histórica","historic-classes-notes":"Histórico de notas","historic-content":"Contenido histórico","holgura-cupo-academico":"Holgura Cupo Academico","inicio-class":"Inicio Class","inicio-planning":"Inicio Planning","inicio-retention":"Inicio Retention","inicio-suite":"Inicio Suite","inputs-del-modelo":"Inputs del modelo","integration-booking":"Integration Booking","integration-class":"Integration Class","integration-enrollment":"Integration Enrollment","integration-faculty":"Integration Faculty","integration-forecast":"Integration Forecast","integration-improve":"Integration Improve","integration-planning":"Integration Planning","integration-retention":"Integration Retention","listado-escenarios":"Listado Escenarios","listado-estudiantes-curso":"Listado Estudiantes Curso","logro-competencias-estudiantes":"Logro Competencias Estudiantes","mantenedor-curso-actividad":"Mantenedor Curso actividad","mantenedor-matrices-competencia":"Mantenedor Matrices Competencia","mantenedor-plan-de-estudios":"Mantenedor Plan de Estudios","mantenedor-valor-curso-actividad":"Mantenedor Valor Curso Actividad","menu-lateral-izquierdo":"Menú lateral izquierdo","niveles-de-desarrollo-de-competencias":"Niveles de desarrollo de Competencias","operaciones-manuales":"Operaciones manuales","option-repeat":"Opcion de repetición","periodos":"Periodos","permisos-estructura-workflow":"Permisos Estructura WorkFlow","plan-curso-electivo":"Plan Curso Electivo","porcentaje-uso-de-sillas":"Porcentaje Uso de Sillas","power-bi":"Power Bi","probabilidad-historica":"Probabilidad histórica","profesores-con-mayor-cantidad-de-alumnos-en-r":"Profesores con mayor cantidad de alumnos en r","razones-de-desercion":"Razones de deserción","recursos":"Recursos","registro-de-asistencia":"Registro de Asistencia","registro-de-contenido":"Registro de Contenido","registro-de-notas":"Registro de Notas","registro-de-observaciones":"Registro de observaciones","reporte-asistencia-docente":"Reporte Asistencia Docente","reporte-de-comparacion":"Reporte de Comparación","reporte-de-uso-de-infraestructura":"Reporte de Uso de Infraestructura","reporte-de-utilizacion-de-salas":"Reporte de Utilización de Salas","reporte-detalle":"Reporte Detalle","reporte-estado-eventos":"Reporte Estado Eventos","reporte-planificacion-diaria":"Reporte Planificacion Diaria","reporte-por-curso":"Reporte por Curso","reporte-por-estudiante":"Reporte por Estudiante","reporte-por-profesor":"Reporte por Profesor","reporte-power-bi":"Reporte Power Bi","reporte-realizacion-actividades":"Reporte Realización Actividades","reporte-tiempo-confirmacion":"Reporte Tiempo Confirmación","reserva":"Reserva","restriccion-horario-salas":"Restriccion Horario Salas","resultado-de-carga-de-datos":"Resultado de carga de datos","scheduled-classes":"Clases programadas","seguimiento-syllabus":"Seguimiento Syllabus","tabla-actividad":"Tabla Actividad","tabla-actividad-asignatura-detalle":"Tabla Actividad Asignatura Detalle","tabla-actividad-asignatura-tipo-uso":"Tabla Actividad Asignatura Tipo Uso","tabla-arancel-carrera":"Tabla Arancel Carrera","tabla-campus":"Tabla Campus","tabla-campus-bdi":"Tabla Campus BDI","tabla-carrera":"Tabla Carrera","tabla-departamento":"Tabla Departamento","tabla-docente":"Tabla Docente","tabla-docente-asignatura-actividad-sede":"Tabla Docente Asignatura Actividad Sede","tabla-docente-valor-hora-evaluacion":"Tabla Docente Valor Hora Evaluación","tabla-hora-clase":"Tabla Hora Clase","tabla-infraestructura":"Tabla Infraestructura","tabla-infraestructura-tipo-uso":"Tabla Infraestructura Tipo Uso","tabla-institucion":"Tabla Institución","tabla-jornada":"Tabla Jornada","tabla-materia-departamento":"Tabla Materia Departamento","tabla-materia-plan":"Tabla Materia Plan","tabla-modulos-jornada":"Tabla Modulos Jornada","tabla-nota-clase":"Tabla Nota Clase","tabla-periodo":"Tabla Periodo","tabla-periodo-bdi":"Tabla Periodo BDI","tabla-pivote":"Tabla Pivote","tabla-plan-estudio":"Tabla Plan Estudio","tabla-plan-estudio-asignatura":"Tabla Plan Estudio Asignatura","tabla-plan-estudio-turno":"Tabla Plan Estudio Turno","tabla-planes-campus":"Tabla Planes Campus","tabla-valor-hora-asignatura":"Tabla Valor Hora Asignatura","tasa-de-aprobacion":"Tasa de Aprobación","tipo-contrato-docente":"Tipo Contrato docente","tipo-de-recurso":"Tipo de Recurso","tributacion-de-curso-a-competencias":"Tributación de curso a competencias","ubicacion":"Ubicación","utilizar-disponibilidad-docente":"Utilizar Disponibilidad Docente","vista-coordinador":"Vista Coordinador","vista-estudiante":"Vista Estudiante","workflow":"Flujo de trabajo","ACTIVE_PL":"Activos","ACTIVITY_MANAGEMENT":"Mantenedor de actividad","ACTIVITY_VISUALIZATION":"Visualización de la actividad","ADD_ADVERTISING":"Agregar publicidad","ADD_CLASSROOM_ASSET":"Agregar activo de aula","ADD_COURSE":"Agregar curso","ADD_EDIT_COURSES_FOR_APP_VIRTUAL":"Agregar/ Editar cursos para app virtual","ADD_EDIT_COURSES_FOR_VIRTUAL_APP":"Agregar/Editar Courses para App Virtual","ADD_RESOURCE_TYPE":"Agregar tipo de recurso","ADD_STATIONS":"Agregar estaciones","ADMIN_SCREENS":"Administrar pantallas","ADVERTISING":"Publicidad","ADVERTISING_TYPE":"Tipo de publicidad","AFTER_START":"Después del inicio","ALLOW_RESERVATIONS_IN":"Permitir reservas en","APPLICANT":"Solicitante","APPLICATION":"Aplicación","ASSETS":"Activos de aula","ASSIGN_RESOURCE":"Asignar recurso","ASSIGN_SCHEDULE":"Asignar horario","ATTACH_TO":"Adjuntar a","ATTACH_TO_ROTARY_SCREEN":"Adjuntar a pantalla rotativa","AVAILABLE_TO_DISABLED_PEOPLE":"Apto para personas con necesidades especiales","BEFORE_START":"Antes del inicio","BLOCKED_SCHEDULE":"Horario bloqueado","BOOKING_DETAIL":"Detalle de reserva","BOOKING_DONE":"Reserva hecha satisfactoriamente","BOOKING_FAILURE":"Error en la reserva","BOOKING_FREE":"Horario disponible","BUILDING_NAME":"Nombre Edificio","CALENDAR_CONFIRM_PROFILE":"Agenda de eventos (Confirmador)","CALENDAR_RESERVATION_PROFILE":"Agenda de eventos (Reserva)","CAMPUS_ORIGIN_OF_THE_ROLE":"Campus origen del rol","CANCELED_EVENT":"Evento Cancelado","CLASSROOM_ASSET_IN_USE":"Activos en uso","CLASSROOM_ASSETS":"Activos de aula","CLONE_PERIOD":"Clonar periodo","CONFIRM_CLASSROOM_ASSET_IN_USE_ADD":"El activo está siendo utilizado por el recurso '{{resourceName}}', \n al agregarlo eliminará la asociación anterior ¿Desea continuar?","CONFIRM_DELETE":"Confirmar Eliminar","CONFIRM_DELETE_RESERVATIONS_MSJ":"¿Está seguro que desea eliminar las reservas seleccionadas?","CONFIRM_INACTIVATE":"Confirmar inactivar","CONFIRM_RESERVATION":"Confirmar reserva","CONFIRMED_EVENT":"Evento Confirmado","CONTROL_PANEL":"Cuadro de mando","COURSE_CODE":"Código del curso","COURSE_NAME":"Nombre del Curso","COURSES_ADDED":"Cursos agregados","CREATE_BUILDING":"Crear Edificio","CREATE_BUILDING_FOR":"Crear Edificio para","CREATE_CATEGORY":"Crear Categoría","CREATE_CLASSROOM_ASSETS":"Crear activos de aula","CREATE_EDIT_RESOURCE":"Crear/Editar recurso","CREATE_EDIT_VIRTUAL_APP":"Crear/Editar app virtual","CREATE_FLOOR":"Crear Piso","CREATE_FLOOR_FOR":"Crear Piso para","CREATE_NEW_RESERVATION":"Crear nueva reserva","CREATE_RESOURCE_TYPE":"Crear Tipo de Recurso","CREATE_SCREEN":"Crear pantalla","CREATE_USAGE_TYPE":"Crear Tipo de Uso","CREATE_VIRTUAL_APP":"Crear App Virtual","CREATED_BY":"Creado por","CREATION_DATE":"Fecha de creación","CURRENT_AND_FOLLOWING_RESERVATIONS":"Reserva actual y siguientes","CURRENT_RESERVED":"Hora a reservar","CURRICULAR_EVENTS":"Eventos Curriculares ","DEFINE_RESERVATION":"Definir reserva","DELETE_EVENT":"Eliminar evento","DELETE_RESERVATION_MSJ":"¿Está seguro que desea eliminar la reserva?","DELETE_RESERVATIONS":"Eliminar reservas","DELETE_SCREEN_CONFIG":"Eliminar Configuracion de pantalla","DESCRIPTION_ACTIVE_RESOURCE":"El recurso se encuentra disponible para su utilización","DESCRIPTION_REAL_RESOURCE":"El recurso es tangible en la institución","DESCRIPTION_RESOURCE_WITH_UNIVERSAL_ACCESSIBILITY":"Recurso utilizable para personas con necesidades especiales","DESCRIPTION_SYNCHRONIZABLE_RESOURCE":"El recurso proviene por integración","DESCRIPTION_VIRTUAL_RESOURCE":"El recurso se utilizará en contextos virtuales","DETAIL_APPLICATION":"Detalle solicitud","DETAILS_RESERVATION":"Detalles de la reserva","EDIT_CLASSROOM_ASSETS":"Editar activos de aula","EDIT_CONFIRM_RESERVATION_MSJ":"Se notificará por email al solicitante y al responsable","EDIT_RESERVE":"Editar reserva","EDIT_RESOURCE":"Editar recurso","EDIT_SCREEN":"Editar pantalla","EDITED_BY":"Editado por","ELIMINATE_MASSIVE":"Eliminar masivo","END_DATE":"Fecha fin","END_MODULE":"Módulo fin","END_TIME":"Hora fin","ENTER_CATEGORY_MSJ":"Por favor ingrese categoría","ENTER_CODE_MSJ":"Por favor ingrese código","ENTER_DATE_MSJ":"Por favor seleccione fecha de inicio","ENTER_NAME_MSJ":"Por favor ingrese nombre","ENTER_RESOURCE_MSJ":"Por favor ingrese recurso","EVENT":"Evento","EVENT_DELAYED":"Evento con atraso","EVENT_NAME":"Nombre evento","EVENTS_DISPLAY_TIME_PER_PAGE":"Tiempo de duración por página","EXCEPTIONS":"Excepciones","EXTRACURRICULAR_ACTIVITIES":"Actividades extracurriculares","EXTRACURRICULAR_EVENTS":"Eventos ExtraCurriculares ","FAILED_CLONING":"Clonación fallida","FILE_FORMAT_IMAGE_MSJ":"Los archivos deben ser formato JPG, TIFF...","FILE_FORMAT_VIDEO_MSJ":"Los archivos deben ser formato MOV, MP4...","FILTER_PER_HOUR":"Filtrar por hora","FILTERS_FOR_SECTION":"Filtros para sección","FLOOR_NAME":"Nombre Piso","FONT_SIZE":"Tamaño tipografía","INACTIVE_PL":"Inactivos","INFORMATION_VISIBLE_IN_ROTARY_SCREEN_NOTE_MSJ":"Nota: Esta información sera visible en pantalla rotativa","INSERT_ADVERTISING_BETWEEN_ACTIVITIES":"Intercalar Publicidad / Actividades","IT_IS_NOT_POSSIBLE_INACTIVE_BUILDING":"No es posible inactivar el edificio","IT_IS_NOT_POSSIBLE_INACTIVE_FLOOR":"No es posible inactivar el piso","IT_IS_NOT_POSSIBLE_INACTIVE_RESOURCE_TYPE":"No es posible inactivar el Tipo de recurso","MANAGE_ADVERTISING":"Archivos multimedia","MANAGE_VIRTUAL_APPLICATIONS":"Administrar Aplicaciones Virtuales","MAXIMUM_ANTICIPATION_TIME_PER_RESERVATION":"Máximo tiempo de anticipación por reserva","MAXIMUM_OF_RESPONSIBLE":"Máximo de responsables","MAXIMUM_RESERVATION_TIME_PER_DAY":"Máximo tiempo de reserva por día","MAXIMUM_TIME_TO_ACTIVATE":"Tiempo máximo para activar","MINIMUM_ANTICIPATION_TIME_PER_RESERVATION":"Mínimo tiempo de anticipación por reserva","MINIMUM_NUMBER_OF_USERS_PER_RESERVATION":"Mínimo número de usuarios por reserva","MINIMUM_RESERVATION_TIME_PER_DAY":"Mínimo tiempo de reserva por día","MINIMUM_TIME_TO_ACTIVATE":"Tiempo mínimo para activar","MODIFICATION_DATE":"Fecha de modificación","MSJ_APP_VIRTUAL_CREATED_SUCCESS":"App Virtual creada correctamente","MSJ_BOOKING_DONE_AND_CODE":"Reserva hecha satisfactoriamente, el código de reserva es","MSJ_BUILDING_CODE_ALREADY_EXISTS":"El código ya existe","MSJ_BUILDING_CREATED_SUCCESSFULLY":"Edificio creado correctamente","MSJ_BUILDING_DELETED_SUCCESSFULLY":"Edificio eliminado correctamente","MSJ_BUILDING_UPDATED_SUCCESSFULLY":"Edificio actualizado correctamente","MSJ_CLONE_PERIOD_VIRTUAL_APP":"Reemplazar cursos y Apps Virtuales de un periodo académico existente a un periodo nuevo","MSJ_CONFIRM_INACTIVATE_BUILDING":"¿Esta seguro que desea inactivar este edificio? puede tener pisos asociados.","MSJ_CONFIRM_INACTIVATE_FLOOR":"¿Esta seguro que desea inactivar este piso?","MSJ_DELETE_BUILDING":"¿Está seguro de eliminar este edificio? puede tener pisos asociados.","MSJ_DELETE_FLOOR":"¿Está seguro de eliminar este piso?","MSJ_DELETE_RESOURCE_TYPE":"Estás a punto de eliminar un tipo de recurso que puede que tenga tipos de usos asociados. ¿Está seguro/a?","MSJ_DELETE_USAGE_TYPE":"¿Está seguro/a de eliminar este tipo de uso?","MSJ_ENTER_REQUERID_FIELD":"Por favor ingrese los campos requeridos","MSJ_FLOOR_CODE_ALREADY_EXISTS":"El código ya existe","MSJ_FLOOR_CREATED_SUCCESSFULLY":"Piso creado correctamente","MSJ_FLOOR_DELETED_SUCCESSFULLY":"Piso eliminado correctamente","MSJ_FLOOR_UPDATED_SUCCESSFULLY":"Piso actualizado correctamente","MSJ_MAXIMUM_RESERVATION_TIME_EXCEEDED":"Tiempo máximo de reserva superado","MSJ_NO_DATA_ROTATIVE":"No existen pantalla para mostrar","MSJ_PLEASE_ENTER_NAME_AND_CODE":"Por favor ingrese nombre y código","MSJ_PLEASE_SELECT_A_COURSE_TO_ASSOCIATE":"Por favor seleccione un curso para asociar","MSJ_PLEASE_SELECT_DIFFERENT_PERIOD":"Por favor, seleccione diferentes períodos de destino para clonar","MSJ_PLEASE_SELECT_RESOURCE_USAGETYPE":"Por favor selecione recurso y tipo de uso","MSJ_PLEASE_SELECT_USAGETYPE":"Por favor selecione tipo de uso","MSJ_RESERVATION_SUCCESSFUL":"Reserva exitosa","MSJ_SELECT_ONE_ROW_TO_DELETE":"Seleccione al menos una fila para eliminar","MSJ_THERE_NO_DATA_RELATED_TO_YOU_SEARCH":"No hay datos relacionados con sus criterios de búsqueda.","MULTICAMPUS":"Multisede","MULTIMEDIA_LIBRARY":"Librería multimedia","MY_RESERVATIONS":"Mis Reservas","N_OF_ROWS_PER_SCREEN":"N° filas por pantalla","NOTIFY_BY_EMAIL_APPLICANT_TEACHER_SECTION_STUDENTS_MSJ":"Se notificara por email a solicitante, docente y alumnos de la sección.","NUMBER_OF_LICENSES":"Número de licencias","ONLY_THIS_RESERVATION":"Solo esta reserva","ORDER":"Orden","PER_PAGE":"Por página","PERIOD_OF_ORIGIN":"Periodo de origen","PERIOD_TO_LINK":"Periodo a vincular","PERIOD_TO_REPLACE":"Periodo a reemplazar","PERMISSIONS_FOR":"Permisos para","REPEATS_UNTIL_THE":"Se repite hasta el","RESERVATION_DATE":"Fecha de reserva","RESERVATION_PERIOD":"Periodo de reserva","RESERVATION_TYPE":"Tipo de reserva","RESERVATIONS_PARAMETERS":"Parámetros de reserva","RESERVE":"Reservar","RESERVED_SCHEDULE":"Horario reservado","ROTARY_SCREEN":"Pantalla rotativa","ROTARY_SCREENS_CONFIG":"Configurar pantalla rotativa","SCHEDULE_ASSIGNMENT":"Asignación de horario","SCHEDULE_BY_CAREER":"Horarios por carrera","SCHEDULE_BY_RESOURCE":"Horarios por recurso","SCREEN_LIST":"Lista de pantallas","SCREENS_LIST":"Lista de pantallas existentes","SEARCH_BY_HOURS":"Busqueda por horas","SEARCH_EVENT":"Buscar evento","SEARCH_FOR":"Buscar por","SEARCH_RESERVATION":"Buscar Reserva","SEC":"Seg.","SELECT_ACTIVITY":"Seleccionar actividad","SELECT_ATTENDANCE_STATUS":"Seleccione el estado de asistencia","SELECT_BUILDING":"Seleccionar edificio","SELECT_CATEGORY":"Seleccionar Categoría","SELECT_CLASSROOM_ASSETS":"Seleccione activos de aula","SELECT_FLOOR":"Seleccionar Piso","SELECT_RESOURCE_TYPE":"Seleccione tipo de recurso","SELECT_TYPE_ACTIVITY":"Seleccionar tipo de actividad","SELECT_USAGE_TYPE":"Seleccione tipo de uso","SHOW_AVAILABILITY_BY":"Mostrar disponibilidad por","SHOW_CANCELED_EVENTS":"Mostrar eventos cancelados","START_DATE":"Fecha inicio","START_MODULE":"Módulo inicio ","START_TIME":"Hora inicio","STATION":"Estación","STATIONS":"Estaciones","SUMMARY_BOOKING":"Resumen de la reserva","SURE_TO_DELETE_CONFIG_MSJ":"¿Esta seguro que desea eliminar esta configuracion?","TEACHER_ABSENT":"Profesor no asiste","TEACHER_PRESENT":"Profesor asiste","TEACHER_REPLACEMENT":"Reemplazar docente","TEACHER_SUBSTITUTE":"Profesor reemplazo","THERE_ARE_ASSOCIATED_RESOURCES":"Existen recursos asociados:","THERE_ARE_FLOORS_WITH_ASSOCIATED_RESOURCES":"Existen los siguientes pisos con recursos asociados:","THERE_ARE_RESOURCES_ASSOCIATED":"Existen los siguientes recursos asociados:","TIME":"Tiempo","U_BOOKING":"u-booking","UNIVERSAL_ACCESSIBILITY":"Accesibilidad universal","UNLIMITED":"Sin límite","UPDATE_CURRICULAR_ACTIVITY":"Actualizar actividad curricular","UPDATE_EXTRACURRICULAR_ACTIVITY":"Actualizar actividad extracurricular","VIRTUAL_APP_ASSOCIATIONS_PER_COURSE":"Asociaciones de app virtual por curso","VIRTUAL_APPS":"Aplicaciones virtuales","VIRTUAL_APPS_ASSOCIATION":"Asociación de aplicaciones virtuales","VIRTUAL_APPS_RESERVE":"Reserva de aplicaciones virtuales","VIRTUAL_LAB":"Laboratorio virtual","ABSENCES":"Ausencias","ABSENT":"Ausente","ABSENT_LABEL":"A","ACADEMIC_SECRETARY":"Secretario académico","ADD_STUDENT_TO_LIST":"Agregar estudiante a la lista","ALREADY_GENERATED":"Código Generado","APPROVED":"Aprobado","ASIGNED":"Asignado","ASSIGN_SECTIONS_TO_STRUCTURE":"Asignar sección a estructura","ASSISTED":"Asistidas","ATTENDANCE":"Asistencia","ATTENDANCE_AVERAGE":"Promedio asistencia","ATTENDANCE_AVERAGE_LAST_WEEK":"Promedio asistencia última semana","ATTENDANCE_CHART":"Gráfico de asistencia","ATTENDANCE_DETAIL_BY_DATE":"Detalle de asistencia por fecha","ATTENDANCE_PERCENTAGE":"% Asistencia","ATTENDANCE_PERCENTAGE_LAST_WEEK":"% Asistencia última semana","ATTENDANCE_RATE":"Promedio de asistencia","ATTENDANCE_REGISTRATION":"Registro de Asistencia","ATTENDANCE_RISK_STUDENTS":"Estudiantes con riesgo de asistencia","AUTHENTICATION":"Autenticación","AVAILABLE_EVALUATIONS":"Evaluaciones disponibles","CAL":"Calificación","CLASS_NOTES":"Apuntes de clases","CLASSES_WITH_ATTENDANCE":"Clases con asistencia","COMPONENT_NAME":"Nombre componente","COURSE_ATTENDANCE_REPORT":"Asistencia por Curso","COURSE_IN_PROGRESS":"En curso","COURSE_INFO":"Información del curso","COURSE_STUDENT_LIST":"Lista de estudiantes","COURSES_INFO":"Información de los cursos","CREATE_EVALUATION_ESTRUCTURE":"Crear estructura de evaluación","CURRENT":"Actual","CURRENT_CLASS":"Actualmente estás dictando la clase","DEL":"Delegado","DELEGATE":"Delegado","DELEGATES_ASSIGNMENT":"Lista de estudiantes","DICTATED":"Dictadas","DOWNLOAD_RECORDS":"Descargar notas","DPI":"Desaprobado por Inasistencia","EDIT_ATTENDANCE":"Editar asistencia","ENTER_GRADES":"Ingresar calificación","EVALUATION_STRUCTURE_EMPTY_STATE":"Seleccione una estructura de evaluación para ver su detalle...","EXECUTED_CLASSES":"Clases pasadas","FINISH_CLASS":"Finalizar clase","FINISH_CLASS_ASK":"¿Quieres finalizar la clase?","FORMULA":"Formula","GENERATE_RANDOM_CODE":"Generar código aleatorio","GENERATE_RANDOM_CODES":"Generar códigos aleatorios","GRADE":"Nota","GRADES_REGISTERED":"Registro de notas ya confirmado","HISTOGRAM":"Histograma","INDICATORS":"Indicadores","INDICATORS_BY_COURSE":"Indicadores por curso","INDICATORS_BY_STUDENT":"Indicadores por estudiante","INDICATORS_BY_TEACHER":"Indicadores por profesor","INFO_ATTENDANCE_RISK_STUDENTS":"Información de alumnos con riesgo de asistencia","INFO_GRADES":"Información de las notas","INITIATED_CLASSES":"Clases iniciadas","JUSTIFIED":"Justificado","JUSTIFIED_LABEL":"J","LEVEL_SCHEME":"Niveles de desarrollo de competencias","LIST_OF_COURSES":"Lista de cursos","LIST_OF_ONE":"Lista de 1","LIST_OF_STUDENTS":"Lista de estudiantes","LIST_OF_TEACHERS":"Lista de profesores","MANUAL_LABEL":"Manual","MANUALLY_REGISTERED":"Ingresado manualmente","MASSIVE_STATUS_EDITOR":"Editor masivo de estados","MAX_ABSENCES":"Máximo de ausencias","MAXIMUM":"Máximo","MENU_ACHIEVEMENT_OF_COMPETENCIES":"Logro de competencias","MENU_CONTENT_RECORDS":"Registro de Contenidos","MENU_EVALUATION_STRUCTURES":"Estructuras de evaluación","MENU_EVALUATIONS":"Evaluaciones","MENU_GRADE_RECORDS":"Registro de notas","MENU_HISTORICAL_ATTENDANCE":"Asistencia histórica","MENU_OPENING_OF_CLASES":"Apertura de clases","MENU_RANDOM_CODE_GENERATOR":"Generador de códigos aleatorios","MENU_RANDOM_CODE_GENERATOR_BY_COURSE":"Generar códigos por curso","MENU_RANDOM_CODE_GENERATOR_BY_PERIOD":"Generar códigos por periodo","MENU_RANDOM_CODE_VIEW":"Visualizar códigos generados","MENU_STRUCTURES_BY_SECTION":"Estructuras por sección","MENU_STUDENT_ATTENDANCE":"Asistencia estudiantes","MENU_STUDENT_STATUS":"Estado de estudiantes","MENU_TEACHER_ATTENDANCE":"Asistencia de docentes","MINIMUM":"Mínimo","MODIFY_ATTENDANCE":"Modificar asistencia","MODULE_DAY":"Día/Módulo","MSJ_DEFINITIVE_SENDING_OF_GRADES":"¿Esta seguro de enviar las calificaciones? Después de esta acción no las podrá editar.","MSJ_DOESNT_HAVE_RANDOM_CODE":"En esta evaluación no hay un código aleatorio. No puedes subir o editar notas aún.","MSJ_GRADES_WITH_TWO_DECIMALS":"Las notas deben ser con dos decimales","MSJ_RESULT_CERO":"Estudiante obtuvo un 0 en su calificación","MSJ_SELECT_REASON_FOR_GRADE":"Seleccione la justificación para la nota","MSJ_SENDING_SUCCEFULL_GRADES":"Se ha confirmado el registro de notas en el Portal.","MSJ_STUDENT_DID_NOT_EVALUATION":"El estudiante no rindió la evaluación","MSJ_STUDENTS_WITHOUT_GRADES_TO_NR":"Estudiantes que no rindieron evaluaciones","MUST_DICTATE_CLASS":"Próxima clase a dictar","MUST_PROGRAM_NEXT_CLASS":"Debe programar la próxima clase","N_ABSENTS_MIN":"N° A","N_OF_ASSISTANTS":"N° Asistentes","N_OF_CLASSES":"N° de clases","N_OF_CLASSES_DICTATED":"N° de clases dictadas","N_OF_NRCS":"N° NRCs","N_PRESENTS_MIN":"N° P","NEXT_CLASS":"Próxima Clase","NO_ATTENDANCE_PERCENTAGE":"% Inasistencia ","NO_NEXT_CLASS":"No posee próxima clase","NOT_REGISTERED":"No registrado","NOT_REGISTERED_LABEL":"N","NOT_STARTED_CLASSES":"Clases no iniciadas","NR":"No rindió","NRC_ATTENDANCE_AVERAGE":"Promedio asistencia total NRCs","NRC_ATTENDANCE_AVERAGE_LAST_WEEK":"Promedio asistencia total NRCs última semana","NUM_OF_INSCRIPTIONS":"N° de inscripciones","OFFICIAL_GRADE":"Nota oficial","PERIOD_ATTENDANCE":"Asistencia en función del tiempo","PLANNED_CLASSES":"Clases programadas hasta la fecha","PRESENT":"Presente","PRESENT_LABEL":"P","PROFESSOR_ATTENDANCE_REPORT":"Asistencia de Cursos por Profesor","PROM_ABSENTS_MIN":"Prom. A","PROM_PRESENTS_MIN":"Prom. P","RANDOM_CODE":"Código aleatorio","RANDOM_CODE_GENERATED":"Lista de Códigos Generados","RANDOM_CODE_GENERATOR_BY_COURSE":"Generador de códigos aleatorios por curso","RANDOM_CODE_GENERATOR_BY_PERIOD":"Generador de códigos aleatorios por periodo","RANDOM_CODE_VIEW":"Visualización de códigos aleatorios","REGISTER_ATTENDANCE":"Registrar asistencia","REGISTER_CONTENT_EDIT":"Registrar más contenidos","REGISTER_CONTENTS":"Registrar contenidos","REGISTER_NOTES":"Registrar apuntes","REGISTRO_DE_NOTAS":"Registro de notas","RESUME_GRADES":"Resumen de Notas","RET":"Retirado","RETIRED":"Alumno retirado","RETIRED_LABEL":"Retirado","SAN":"Sancionado","SANCTIONED":"Alumno sancionado","SANCTIONED_LABEL":"Sancionado","SCHEDULED_CLASSES":"Clases programadas","SECTION_ATTENDANCE_PERCENTAGE":"% de asistencia de la sección","SECTION_ATTENDANCE_PERCENTAGE_LAST_WEEK":"% de asistencia de la sección en la última semana","SECTION_INFORMATION":"Información de la sección","SECTIONS_BY_COURSES":"Secciones por cursos","SECTIONS_INFORMATION":"Información de las secciones","SEE_GRADES":"Ver notas","SEE_RECORDS":"Ver notas","SELECCIONE_LA_ESTRUCTURA_QUE_DESEA_ASIGNAR":"Seleccione la estructura que desea asignar","SHOW_GRAPHIC_BY":"Mostrar gráfico por","SIMULATED_RESULT":"Resultado simulado","START_CLASS":"Iniciar clase","STARTED_CLASSES":"Clases iniciadas","STUDENT_ATTENDANCE_INFO_FOR_SECTION":"Información de asistencia de alumnos de la sección","STUDENT_ATTENDANCE_REPORT":"Asistencia por Estudiante","STUDENT_BELONGS_ANOTHER_SECTION":"Estudiante pertenece a otra sección del mismo curso","STUDENT_DETAIL":"Detalle de estudiante","STUDENT_EXISTS_IN_CLASS":"Ya se encuentra agregado el estudiante a la clase actual","STUDENT_IN_DPI":"Estudiante con DPI","STUDENT_INFO":"Información del estudiante","STUDENT_LIST":"Lista de estudiantes","STUDENT_NOT_FOUND":"No se encontró el estudiante","SUBJECTS_INFORMATION":"Información de los cursos","SUM":"Total","SUMAXIMUMM":"Máximo","TARDINESS":"Atrasos","TARDY":"Atrasado","TARDY_LABEL":"D","TEACHER_CLASS_NOTES":"Apuntes de clases de profesor","TEACHER_DETAIL":"Detalle de profesor","TEACHER_INFO":"Información del profesor","TOTAL_ABSENT_STUDENTS":"Total Estudiantes ausentes","TOTAL_CLASSES_IN_PERIOD":"Total clases del periodo","TOTAL_CLASSES_INITIATED":"Total clases iniciadas","TOTAL_CLASSES_NOT_INITIATED_WITH_ATTENDANCE":"Total clases no iniciadas con asistencia","TOTAL_CLASSES_NOT_INITIATED_WITHOUT_ATTENDANCE":"Total clases no iniciadas sin asistencia","TOTAL_CLASSES_TO_DATE":"Total clases hasta la fecha","TOTAL_PLANNED_CLASSES":"Clases programadas totales","TOTAL_PRESENT_STUDENTS":"Total estudiantes presentes","TOTAL_TARDY_STUDENTS":"Total Estudiantes atrasados","U_CLASS":"u-class","U_GRADES":"Registro de notas","UPLOAD_FILES_OF":"Cara de archivos de","UPLOAD_RECORDS":"Subir notas","UPLOAD_RESULTS":"Subir resultados","USE_IN_ANY_FORMULA":"Incluir en cualquier fórmula","VALID_STUDENT":"Este Estudiante es Válido","VIEW_CONSOLIDATED_GRADES":"Ver notas consolidadas","VIEW_EDIT_ATTENDANCE":"Ver y editar asistencia","VIEW_EDIT_CONTENT":"Ver y editar contenidos","VIEW_EDIT_CONTENTS":"Ver y editar contenidos","VIEW_EDIT_GRADES":"Ver y editar notas","WARNING_GRADE_OUT_MIN_MAX":"Nota ingresada fuera del rango permitido","WITHOUT_CLASS":"Sin clase actualmente","WORKFLOW_FLOW":"Workflows","YEAR_OF_ENTRY":"Año de ingreso","ZERO_DIFFERENTIATION":"Diferenciación de 0","ACADEMIC_UNIT_ROLE":"Cargo Unidad Académica","ADD_ACADEMIC_UNIT":"Agregar unidad académica","ADD_CONTRACT_TYPE":"Agregar tipo contrato","ASSIGNED_MODULES":"Módulos asignados","ASSIGNED_SECTIONS":"Secciones asignadas","CALENDAR_INFORMATION":"Información del calendario","CONTRACT_CODE":"Código del contrato","CONTRACT_NAME":"Nombre del contrato","CONTRACT_TYPE":"Tipo de contrato","COURSE_ACTIVITY_HOUR_COST":"Valor hora curso actividad","COURSES_LIST":"Lista de cursos","CREATE_ACADEMIC_CALENDAR":"Crear calendario académico","CREATE_NEW_ELECTIVE_BLOCK":"Crear un nuevo bloque electivo","CREATE_SCHEME":"Crear esquema","CREATE_TEACHER":"Crear docente","DEPARTMENT_POSITION":"Puesto departamento","EDIT_SCHEME":"Editar esquema","EDIT_TEACHER":"Editar docente","ELECTIVE_BLOCK_MANAGEMENT":"Mantenedor de bloques electivos","ELECTIVE_BLOCK_PLAN":"Plan curso electivo","FACULTY_MANAGEMENT":"Facultades","HELP_COURSE_ACTIVITY_HOUR_COST":"Texto de ayuda para Valor hora curso actividad","HELP_EDIT_ACADEMIC_CALENDAR":"Seleccione las semanas que conformarán el nuevo calendario académico","HELP_EDIT_ADD_TEACHER":"Desde esta pantalla es posible la creación, edición, y consulta de docentes en el sistema. Es posible asociar éstos a un departamento y campus mediante la definición de un tipo de contrato, y activar o desactivar el uso de este docente para las simulaciones. La información del docente puede mantenerse sincronizada o desincronizada de las actualizaciones de integración de datos.","HELP_ELECTIVE_BLOCK_MANAGEMENT":"Texto de ayuda para bloques electivos","HOUR_COST":"Hora costo","INFRASTRUCTURE":"Infraestructura","LEVEL_SCHEME_MANAGER":"Mantenedor de esquemas de niveles","LEVELS":"Niveles","MAX_AVAILABLE_MODULES":"Máximo módulos libres","MAX_CAMPUS_PER_DAY":"Máximo de campus por día","MAX_CAMPUS_PER_WEEK":"Máximo de campus por semana","MAX_CONSECUTIVE_MODULES":"Máximo de módulos consecutivos","MAX_MODULES_PER_DAY":"Máximo de módulos por día","MAX_MODULES_PER_WEEK":"Máximo de módulos por semana","MAX_PAUSED_MODULES":"Máximo de módulos de pausa","MAX_SECTIONS_PER_DAY":"Secciones máximas por día","MAX_SECTIONS_PER_WEEK":"Máximo de secciones por semana","MSJ_ACADEMIC_CALENDAR":"Utiliza el Calendario Académico para determinar un rango de tiempo de Semanas - Días - Módulos en un espacio determinado por Campus - Periodo - Jornada para luego asignarlos a determinadas secciones y mejorar su organización.","MSJ_ACADEMIC_CALENDAR_CREATED_SUCCESS":"Calendario académico creado exitosamente","N_OF_IMPLICATED_MODULES":"Cantidad de módulos comprometidos","N_OF_IMPLICATED_SECTIONS":"Cantidad de secciones comprometidas","NEW_ACADEMIC_CALENDAR":"Nuevo calendario académico","NEW_SCHEME":"Nuevo esquema","PERIODS_MANAGEMENT":"Periodos (Ciclos)","PRIORITY":"Prioridad","SELECT_ACADEMIC_PLAN":"Seleccionar plan académico","TEACHER_PROFILE":"Perfil docente","U_CORE":"Configuración","MENU_REFERENCE_SURVEYS":"Encuestas de referencia","MENU_SURVEYS":"Encuestas","U_ENROLLMENT":"u-enrollment","ACADEMIC_SCHEDULE_SELECTION":"Selección de horario académico","ADVANCE_ASSIGNATION_SECTION":"Avance asignación por sección","ADVANCE_ASSIGNATION_SUBJECT":"Avance asignación por materia","ALL_SECTIONS":"Todas las secciones","AUTOMATIC_ASSIGNATION":"Asignación automática","CONFIRM_DELETE_SCENARIO_MSJ":"¿Está seguro que desea eliminar la selección?","CONFIRM_UNASSIGN_RESOURCE":"Confirmar desasignar recurso","CONFIRM_UNASSIGN_SCHEDULE":"Confirmar desasignar horario","CONFIRM_UNASSIGN_SUPERVISOR":"Confirmar desasignar supervisor","CREATE_SCENARIO":"Crear Escenario","CREATE_SCENARIO_BY_SECTION":"Crear escenario por sección","CREATE_SCENARIO_BY_STUDENT":"Crear escenario por estudiante","CREATE_STAGE":"Crear Escenario","DELETE_SCENARIO":"¿Está seguro que desea eliminar estos registros?","ENTER_MANIMUM_CAPACITY":"Ingrese capacidad mínima","ENTER_MAXIMUM_CAPACITY":"Ingrese capacidad máxima","EVALUATION_MANAGEMENT":"Administrador de evaluaciones","EVALUATION_TYPE":"Tipo de Evaluación","EXAM-NAME":"Nombre examen","GROUP":"Grupos","MANUAL_ASSIGNATION":"Asignación Manual","MANUAL_ASSIGNMENT_RESOURCE":"Asignación manual de recurso","MANUAL_SUPERVISOR_ASSIGNMENT":"Asignación manual de supervisor","MAXIMUM_CAPACITY":"Capacidad máxima","MAXIMUM_DAILY_EXAMS_PER_STUDENT":"Máximo exámenes diarios por alumno","MSJ_AUTOMATIC_ASSIGNMENT_STARTED_CORRECTLY":"Asignación automática ha sido iniciada correctamente","MSJ_CAN_NOT_SHOW_CALENDER":"No se puede mostrar calendario debido a que no posee semanas","MSJ_CONFIRM_UNASSIGN_RESOURCE":"¿Está seguro de que desea eliminar la asignación de recurso para la selección?","MSJ_CONFIRM_UNASSIGN_SCHEDULE":"¿Está seguro de que desea eliminar la asignación de horario para la selección?. Esto implica la desasignación de Recursos y Supervisor.","MSJ_CONFIRM_UNASSIGN_SUPERVISOR":"¿Está seguro de que desea eliminar la asignación de supervisor para la selección?","MSJ_CONFLICTS_OCCURED_FOR":"Nota: se produjeron conflictos por","MSJ_DOWNLOADED_SUCESSFULLY":"Descargado exitosamente","MSJ_MODULE_INSERTED_SUCCESSFULLY":"Módulo insertado con éxito","MSJ_MODULE_SHOULD_BE_CONSECUTIVE":"El módulo debe ser consecutivo","MSJ_NO_ASSIGNED_WEEKS_FOUND":"No se encontraron semanas asignadas","MSJ_SCHEDULE_IS_NOT_YET_CREATED":"El horario no se ha creado","MSJ_THE_CHANGES_HAVE_NOT_BEEN_EXECUTED":"Los cambios no han sido ejecutados","MSJ_THERE_ARE_NO_AVAILABLE_WEEK":"No existen semanas disponibles para los filtros seleccionados","MSJ_YOU_MUST_ASSIGN_SCHEDULE_BEFORE":"Debe asignar un horario antes de asignar un recurso o supervisor","NAME_EVALUATION":"Nombre evaluación","REP_ASSIGNMENT_RESULTS":"Resultado Asignación","REP_DATA_VALIDATION":"Validación de Datos","REP_LOADED_DATA":"Datos Cargados","RESOURCE_ASSIGNATION":"Asignación recurso","RESOURCE_CONFLICT":"Conflicto de recurso","RESOURCE_DELETED_SUCCESSFULLY":"Recurso desasignado con éxito","RESOURCE_SCHEDULE_BASELINE":"Línea base recurso/horario","SCENARIO":"Escenario","SCENARIO_INFO":"Información de escenario","SCENARIOS":"Escenarios","SCENARIOS_INFO":"Información de escenarios","SCHEDULE_AND_RESOURCE":"Horario y Recurso","SCHEDULE_ASSIGNATION":"Asignación horario","SCHEDULE_DELETED_SUCCESSFULLY":"Horario desasignado con éxito","SCHEDULE_RANK":"Rango Horario","SCHEDULE_RANK_SELECT":"Seleccionar Rango Horario","SCHEDULE_RESOURCE_AND_SUPERVISOR":"Horario, Recurso y Supervisor","SEARCH_RESOURCE":"Buscar recurso","SECTION_ASSIGNATION":"Asignación sección","SECTION_DETAILS":"Detalle Secciones","SECTIONS_WITH_ASSIGNED_SCHEDULE_ONLY":"Secciones con horarios asignados","SECTIONS_WITH_ONLY_RESOURCE_ASSIGNED":"Secciones con recursos asignados","SECTIONS_WITH_ONLY_SUPERVISORS_ASSIGNED":"Secciones con supervisores asignados","SECTIONS_WITH_SCHEDULE_AND_ASSIGNED_RESOURCE":"Secciones con horarios y recursos asignados","SECTIONS_WITH_SCHEDULE_AND_SUPERVISOR_ASSIGNED":"Secciones con horarios y supervisores asignados","SECTIONS_WITH_SCHEDULE_RESOURCE_AND_SUPERVISOR_ASSIGNED":"Secciones con horarios, recursos y supervisores asignados","SECTIONS_WITHOUT_ASSIGNMENTS":"Secciones sin asignación","SEE_EDIT_SCENARIO":"Ver/Editar Escenario","SELECT_AUTOMATIC_ASSIGNMENT":"Seleccionar asignación automática","SELECT_BASE_LINE":"Seleccionar línea base","SELECT_EVALUATION_TYPE":"Seleccione el tipo de evaluación","SELECT_MANUAL_ASSIGNMENT":"Seleccionar asignación manual","SELECT_RESOURCE_MSJ":"Seleccione un recurso","STUDENTS_WITH_A_GROUP_ASSOCIATED":"Estudiantes con un grupo asociado","STUDENTS_WITHOUT_A_GROUP_ASSOCIATED":"Estudiantes sin un grupo asociado","SUBJECT_ASSIGNATION":"Asignación materia","SUPERVISOR":"Supervisor","SUPERVISOR_ASSIGNATION":"Asignación supervisores","SUPERVISOR_ASSIGNED_SUCCESSFULLY":"Supervisor asignado con éxito","SUPERVISOR_BASELINE":"Línea base supervisor","SUPERVISOR_DELETED_SUCCESSFULLY":"Supervisor desasignado con éxito","SUPERVISOR_SEARCH_INFORMATION":"Información busqueda de supervisor","U_EXAM":"u-exam","UNASSIGN_MANUAL":"Desasignar Manual","UNASSIGNED_STUDENTS":"Estudiantes no asignados","UNSELECT_BASE_LINE":"deseleccionar línea base","ACADEMIC_PERIOD":"Periodo Académico","ACADEMIC_PERIOD_TYPE":"Tipo de periodo","ACADEMIC_QUOTA":"Cupo Académico","ACTIVITIES":"Actividades","ADD":"Agregar","ADD_BLOCK":"Añadir bloque","ADD_ESPECIALITIES":"Añadir especialidad","ADD_NEW_PERIOD":"Agregar nuevo periodo","ADD_THEME":"Agregar tema","AGREE":"Aceptar","APA_LIBRARY":"Referencias APA","ATTITUDINAL_KNOWLEDGE":"Saber actitudinal","AUTOMATIC_ATTENDANCE":"Asistencia automática","BASIC_BIBLIOGRAPHY":"Bibliografía básica","BLOCK_CODE":"Código del bloque","BLOCK_END_LEVEL":"Nivel final","BLOCK_MIN_CREDITS":"Créditos mínimos","BLOCK_NAME":"Nombre del bloque","BLOCK_START_LEVEL":"Nivel inicial","BLOCK_SUBJECTS":"Cursos de bloque","BOOK_ELECTRONIC_VERSION":"Libro en versión electrónica ","BOOK_MORE_THAN_FIVE_AUTHORS":"Libro con más de cinco autores ","BOOK_UP_TO_FIVE_AUTHORS":"Libros con hasta cinco autores","CANT":"Cantidad","CAREER_CODE":"Código Carrera","CAREER_NAME":"Nombre Carrera","CAREER_PENSUM":"Carrera","CHANGES":"Cambios","CLONING":"Clonación","CO_REQUIREMENTS":"Co-requisitos","COMPETENCE_PENSUM_PROGRESS":"Logro de competencias","COMPETENCIES":"Competencias","COMPETENCIES_COMPETENCY_LEVELS_VIEW":"Competencias y Niveles de Desarrollo","COMPETENCY":"Competencia","COMPETENCY_ACHIEVEMENTS_EVALUATION":"Evaluación Logros de Competencia","COMPETENCY_CODE":"Código Competencia ","COMPETENCY_COMPETENCY_LEVEL":"Competencia Nivel","COMPETENCY_DESCRIPTION":"Descripción de la Competencia","COMPETENCY_ID":"Competencia","COMPETENCY_LEVEL_CODE":"Código del Nivel de Desarrollo","COMPETENCY_LEVEL_DESCRIPTION":"Descripción del Nivel de Desarrollo","COMPETENCY_LEVEL_ID":"Competencia","COMPETENCY_LEVEL_NAME":"Nombre del Nivel de Desarrollo","COMPETENCY_LEVELS":"Niveles de Desarrollo","COMPETENCY_LEVELS_PANEL":"Panel de niveles de competencias","COMPETENCY_MATRIX_CODE":"Código de Matriz","COMPETENCY_MATRIX_ID":"Matriz","COMPETENCY_MATRIX_MAINTAINER":"Mantenedor de matrices de Competencia","COMPETENCY_MATRIX_NAME":"Nombre de Matriz","COMPETENCY_NAME":"Nombre de Competencia","COMPETENCY_SCOPE":"Ámbito de Acción ","COMPETENCY_SCOPE_ID":"Competencia ","COMPETENCY_SCOPE_NAME":"Ámbito de Acción","COMPLETE_WEBSITE":"Sitio web completo ","COMPONENT_CODE":"Código evaluación","componentCode":"Código ","componentDate":"Fecha","componentName":"Evaluación","componentWeight":"Porcentaje","CONCEPTUAL_KNOWLEDGE":"Saber conceptual","CONFIG_WORKFLOW_PERMISSIONS":"Configuracion de permisos de workflow","CONSECUTIVE_HOURS":"Horas consecutivas","CONTENT":"Contenido","CONTENTS_OCURRENCE":"Contenido","CONTENTS_PANEL":"Contenido","COURSE_ACADEMIC_INTEGRITY":"Integridad académica","COURSE_ACHIEVEMENT_DESCRIPTOR":"Descriptor de Logro","COURSE_ACHIEVEMENT_DESCRIPTOR_ID":"Descriptor de Logro","COURSE_ACTIVITIES":"Actividad","COURSE_ACTIVITY":"Actividades","COURSE_ACTIVITY_TYPE":"Tipo de actividad","COURSE_APROVAL_CONDITIONS":"Condiciones de Aprobación","COURSE_ATTENDANCE_RULES":"Reglas de Asistencia","COURSE_CHANGES_HISTORY":"Historial de cambios","COURSE_COMPETENCIES":"Competencias a las que tributa el Curso","COURSE_COMPETENCIES_PANEL":"Competencias","COURSE_COMPETENCIES_SECTION":"Competencias","COURSE_COMPETENCY_TRIBUTE":"Tributación de curso a competencias","COURSE_CONTENTS":"Contenidos del Curso","COURSE_CREDITS":"Créditos","COURSE_DESCRIPTION":"Descripción del Curso","COURSE_DESCRIPTION_PANEL":"Descripción del Curso","COURSE_DESCRIPTION_SECTION":"Descripción del Curso","COURSE_DISCIPLINE":"Disciplina","COURSE_EDUCATION_LEVEL":"Nivel educativo","COURSE_ENGLISH_NAME":"Nombre en Inglés","COURSE_EVALUATION":"Evaluación","COURSE_EVALUATION_ID":"Evaluación","COURSE_EVALUATION_METHOD":"Medios de evaluación","COURSE_EVALUATION_METHOD_ID":"Método de Evaluación","COURSE_EVALUATION_PROCEDURES":"Procedimientos de Evaluación","COURSE_EVALUATION_STRUCTURE":"Estructura de Evaluación","COURSE_EVALUATIONS":"Evaluaciones","COURSE_EVIDENCES":"Evidencias del Curso","COURSE_EVIDENCES_GRID":"Evidencias","COURSE_EVIDENCES_TABLE":"Evidencias","COURSE_GENERAL_DATA":"Datos Generales del Curso","COURSE_GENERAL_INFO":"Información General del Curso","COURSE_HOURS":"Horas del Curso","COURSE_HRS_ACTIVITY_STUDENT":"Horas actividad alumno","COURSE_HRS_STUDENT":"Horas estudio alumno","COURSE_HRS_TEACHER":"Horas con docente","COURSE_LANGUAGE":"Idioma","COURSE_LEARNING_EVIDENCES":"Evidencias de Aprendizaje","COURSE_MARK_TYPE":"Tipo de Calificación","COURSE_METHODOLOGY":"Metodología","COURSE_MODALITIES":"Modalidad del curso","COURSE_MODALITIES_ACTIVITIES":"Modalidades y Actividades del Curso","COURSE_MODALITY":"Modalidad","COURSE_OBJECTIVES":"Objetivos del Curso","COURSE_OBJECTIVES_PANEL":"Objetivos del Curso","COURSE_OBJECTIVES_SECTION":"Objetivos del Curso","COURSE_OTHERS":"Otros","COURSE_OTHERS_PANEL":"Otros","COURSE_OUTCOMES":"Resultados de Aprendizaje del Curso","COURSE_OUTCOMES_CONTENT_PANEL":"Aprendizajes esperados y unidades de contenido","COURSE_OUTCOMES_ID":"Resultados de Aprendizaje del Curso","COURSE_OUTCOMES_PANEL":"Resultados de aprendizaje","COURSE_OUTCOMES_SELECT":"Resultados de Aprendizaje del Curso","COURSE_POLICIES":"Políticas del Curso","COURSE_POLICIES_PANEL":"Políticas del curso","COURSE_PREVIOUS_KNOWLEDGE":"Conocimiento previo sugerido","COURSE_PREVIOUS_KNOWLEDGE_PANEL":"Conocimiento previo sugerido","COURSE_PROFESSIONAL_LINKING":"Vinculación profesional","COURSE_REFERENCE_CATEGORY":"Categoría de Bibliografía","COURSE_REFERENCES":"Referencias bibliográficas y sitios web","COURSE_REFERENCES_NOTES":"Notas sobre la bibliografía y sitios web","COURSE_REFERENCES_NOTES_PANEL":"Notas sobre la bibliografía y sitios web","COURSE_REQUIREMENTS":"Pre-requisitos","COURSE_REQUIREMENTS_NOTES":"Notas de los Requisitos del Curso","COURSE_REQUIREMENTS_NOTES_PANEL":"Notas adicionales","COURSE_RULES":"Reglas de la clase","COURSE_SESSIONS":"Clases","COURSE_SUBTHEMES":"Subtemas","COURSE_SUCCESS_SUGGESTIONS":"Sugerencias para tener éxito en el Curso","COURSE_THEME":"Temas","COURSE_THEME_DESCRIPTION":"Descripción del tema","COURSE_TYPE_IN_PENSUM":"Tipo de Curso","COURSE_VOCATIONAL_MATTER":"Importancia para la formación","COURSES_COREQUISITES":"Co-requisitos","COURSES_PREREQUISITES":"Pre-requisitos","CREATE_MATRIX":"Crear Matriz de Competencia","CREATE_NEW_ONE":"Crear nuevo","CREATE_PERIOD_TYPE":"Crear tipo de periodo","CREDITS":"Créditos","CURRICULAR_PROGRESS":"Seguimiento","CYCLES":"Ciclos","DATABASE_THESIS":"Tesis en base de datos ","DATE":"Fecha","DEPARTMENT":"Departamento","DESCRIPTION_MESSAGE_DEFAULT":"Ingrese Descripción","DESTINY_SECTIONS_LIST":"Lista de secciones destino","DETAIL":"Detalle","DOWNLOAD_REPORT":"Descargar reporte","EBOOK":"eBook","EDIT_MATRIX":"Editar Matriz de Competencia","EDIT_STUDYPLAN":"Editar Plan de estudio","EDIT_TRIBUTES":"Editar tributación","END_MESSAGE_EXPLAIN_CLONING":"para ejecutar la clonación","ENTER_REQUEST_COMMENTS":"Ingrese comentarios sobre solicitud","EQUIVALENT_COMPETENCES":"Competencia equivalente","ERROR_CLONING_PROCESS":"Imposible conectar con servicio","ERROR_GREATER_THAN":"Valor debe ser mayor que","ERROR_GREATER_THAN_EQUAL":"Valor debe ser mayor o igual a","ERROR_LESS_THAN":"Valor debe ser menor que","ERROR_LESS_THAN_EQUAL":"Valor debe ser menor o igual a","EVALUATION_CODE":"Código","EVALUATION_DATE":"Fecha","EVALUATION_IS_ATTITUDE":"Actitudes","EVALUATION_IS_KNOWLEDGE":"Conocimientos","EVALUATION_IS_PRACTICE":"Procedimientos","EVALUATION_IS_PROCESS":"De proceso","EVALUATION_IS_PRODUCT":"De producto ","EVALUATION_METHODS":"Métodos de evaluación","EVALUATION_PERCENTAGE":"Porcentaje","EVALUATION_STRUCTURE":"Estructura de Evaluación","EVALUATIONS_COMMENTS":"Comentarios generales sobre la Evaluación","EVALUATIONS_COMMENTS_PANEL":"Evaluaciones","EVALUATIONS_NOTE1":"Nota","EVALUATIONS_NOTE2":"Nota","EVIDENCE_TRACKING":"Seguimiento","EVIDENCES":"Evidencias","EVIDENCES_CARD_PANEL":"Evidencias del logro de los resultados de aprendizaje ","FACULTY":"Facultad / Escuela","FACULTY_CODE":"Código de Facultad / Escuela","FACULTY_DEPARTMENT":"Facultad - Departamento","FACULTY_INSTITUTION":"Institución","FACULTY_NAME":"Nombre de Facultad / Escuela","FILE_PANEL":"Panel de archivos","FILL_REQUIRED_INPUTS":"Debe llenar todos los campos obligatorios","FILTER_AS":"Filtrar por","FILTER_MAIN_PANEL":"Referencias","FINAL_COLLEGIATE":"Colegiada Final","FINISH_CLONING_PROCESS":"Proceso finalizado","FRECUENCY":"Frecuencia","GENERIC_WARNING":"Alerta","HALF_LENGTH":"Medio término","HOURS_PER_WEEK":"Horas por semana","IFR_TYPE_RESOURCE_ID":"Tipo de Recurso","IFR_TYPE_RESOURCE_NAME":"Tipo de Recurso","IFR_USE_TYPE_ID":"Tipo de Uso","IFR_USE_TYPE_NAME":"Tipo de Uso","IMPROVE_ACTIVITY":"Actividad","IMPROVE_ADD_ACTIVITY":"Agregar actividad","IMPROVE_ADD_MODALITY":"Agregar modalidad","IMPROVE_ALL_COURSES":"Todos los cursos","IMPROVE_CAPTURED":"Capturados","IMPROVE_CAPTURED_DESCRIPTION":"Programas magisteriales capturados y completos","IMPROVE_CAREER":"Carrera","IMPROVE_CAREER_LIST":"Carrera","IMPROVE_CARRER_TYPE":"Tipo Carrera","IMPROVE_CHARGE":"Cargo","IMPROVE_COMPETENCY_MATRIX":"Competencias","IMPROVE_COURSE_NAME":"Nombre del curso","IMPROVE_COURSE_PROGRAM":"Programa de curso","IMPROVE_COURSES":"Lista de Cursos","IMPROVE_CREATE_CAREER":"Crear Carrera","IMPROVE_CREATE_COURSE":"Crear Materia","IMPROVE_CREATE_FACULTY":"Crear Facultad","IMPROVE_CREDITS_BY_PERIODS":"Créditos por periodo","IMPROVE_CURRICULAR_SYNTHESIS":"Síntesis curricular","IMPROVE_CYCLES":"Ciclos","IMPROVE_DELETE":"Eliminar","IMPROVE_DEPARTMENT":"Departamento","IMPROVE_DOWNLOAD_REPORT":"Descargar reporte","IMPROVE_EDIT_CAREER":"Editar carrera","IMPROVE_EMAIL":"Email","IMPROVE_EVALUATION_MOMENTS":"Momento en que se evalúa","IMPROVE_EVALUATION_OR_STRATEGY":"Estrategia o medio de evaluación","IMPROVE_EVALUATION_RESULTS":"Resultados de la evaluación","IMPROVE_EVALUATION_TYPE":"Tipo de evaluación","IMPROVE_FACULTY":"Facultades","IMPROVE_FACULTY_LIST":"Facultad","IMPROVE_FILE_NAME":"Nombre de Archivo","IMPROVE_FRECUENCY":"Frecuencia","IMPROVE_GOAL_LEVEL":"Nivel de logro","IMPROVE_GRADUATION_COMPETITION":"Competencia de Egreso","IMPROVE_INFO":"Información de la materia","IMPROVE_INFO_CAREER":"Información de la carrera","IMPROVE_INFO_FACULTY":"Información de la facultad","IMPROVE_INFORMATION_PERIOD":"Información del periodo","IMPROVE_KEY":"Clave","IMPROVE_LOAD_FILE":"Cargar archivo","IMPROVE_MAINTAINER":"Mantenedores","IMPROVE_MONITORING_EVIDENCES":"Evidencias de logros de competencias","IMPROVE_MY_ACCOUNT":"Mi cuenta","IMPROVE_MY_PROFILE":"Mi perfil u-improve","IMPROVE_NEW_CAREER":"Crear nueva carrera","IMPROVE_NEW_COURSE":"Crear nueva materia","IMPROVE_NEW_FACULTY":"Crear nueva facultad","IMPROVE_PASSWORD":"Contraseña","IMPROVE_PASSWORD_CONFIRM":"Confirmar contraseña","IMPROVE_PENDING":"Pendientes","IMPROVE_PENDING_DESCRIPTION":"Programas magisteriales por capturar","IMPROVE_PERIOD":"Periodo","IMPROVE_PERIOD_NAME":"Nombre del periodo","IMPROVE_PERIOD_TYPE":"Tipo de periodo","IMPROVE_PHONE":"Teléfono","IMPROVE_PROFESSOR":"Profesor","IMPROVE_PROGRESS":"Progreso","IMPROVE_PROPOSED_MONITORING":"Monitoreo propuesto","IMPROVE_PUBLISHED":"Publicados","IMPROVE_PUBLISHED_DESCRIPTION":"Aprobados por el coordinador y visibles para los alumnos","IMPROVE_REPORTS":"Reportes","IMPROVE_RESPONSABLE":"Responsable","IMPROVE_SECTION":"Sección","IMPROVE_SECTION_CAPTURED":"Capturado","IMPROVE_SECTION_OPEN":"Abierto","IMPROVE_SECTION_PENDING":"Pendiente","IMPROVE_SECTION_PROGRESS":"En curso","IMPROVE_SECTION_PUBLISHED":"Publicado","IMPROVE_SECTION_STRUCTURE_IN":"Con estructura","IMPROVE_SECTION_STRUCTURE_OUT":"Sin estructura","IMPROVE_SECTION_TRACKING":"En seguimiento","IMPROVE_SECTION_WAITING":"En espera","IMPROVE_SELECT_SECTION":"Seleccione una sección","IMPROVE_SHOW_ONLY_TRACKING":"Mostrar solo cursos en seguimiento","IMPROVE_SIZE":"Tamaño","IMPROVE_STATE":"Estado","IMPROVE_STUDY_PLAN":"Plan de estudio","IMPROVE_STUDY_PROGRAM":"Plan de Estudio","IMPROVE_SUBJECTS_LIST":"Lista de Cursos","IMPROVE_SYLLABUS":"Syllabus","IMPROVE_SYLLABUS_TRACKING":"Seguimiento Syllabus","IMPROVE_TITLE":"u-improve","IMPROVE_TRACKING":"Seguimiento","IMPROVE_UPDATE_ACTIONS":"Acciones de actualización","IMPROVE_USAGE_TYPE":"Tipo de uso","IMPROVE_USERNAME":"Nombre de usuario","IMPROVE_VERSION":"Versión","IMPROVE_WAITING":"En espera","IMPROVE_WAITING_DESCRIPTION":"En espera de visto bueno del coordinador","IMPROVE_WEEKS_NUMBER":"N° Semanas","INDICADORES_DE_LOGROS":"Logro de competencias","INFRAESTRUCTURE_REQUIREMENTS":"Requerimientos de Infraestructura","INFRAESTRUCTURE_REQUIREMENTS_TABLE":"Requerimientos de Infraestructura","INSERT_COMPETENCY_CODE":"Inserta código de competencia","INSERT_COMPETENCY_NAME":"Nombre de Competencia","INSERT_COURSE_OUTCOMES":"Insertar resultados de aprendizaje","INSERT_COURSE_SUBTHEMES":"Insertar Subtemas ","INSERT_LEARNING_STRATEGIES":"Insertar estrategias educativas","INSERT_NEW_RECORD":"Agregar evidencia","INSERT_REFERENCE_ADDED":"Insertar referencia adicional ","INSERT_REFERENCE_NAME":"Insertar referencia","INSERT_SECTION_LEARNING_STRATEGIES":"Insertar estrategias educativas","INSERT_SESSION_LEARNING_STRATEGIES":"Insertar estrategias educativas","INSERT_SESSION_LEARNING_STRATEGIES_ADD":"Insertar estrategias educativas","INSERT_SESSION_RESOURCES":"Insertar recursos ","INSERT_SESSION_SUBTHEMES_ADDED":"Insertar subtemas adicionales","INSERT_SESSION_SUBTHEMES_ADDED_ADD":"Insertar subtemas adicionales","INSTITUTIONAL_THESIS":"Tesis institucional ","INSTRUMENT":"Instrumento","INTERNATIONAL_STRATEGIES":"Estrategias para favorecer la internacionalización","IS_CLASSRROM_REQUIRED":"Requiere salón","IS_CONTRIBUTING":"Tributa a las Competencias","IS_GROUP_EVALUATION ":"Grupo ","IS_ONLINE":"Actividad online","IS_SCHEDULE_REQUIRED":"Requiere horario","IS_TEACHER_REQUIRED":"Requiere profesor","isGruopEvaluation":"Evaluación Grupal","KEY_WORDS":"Palabras clave","LABEL_ADMIN":"Administrador","LABEL_COORD":"Coordinador","LABEL_STUDENT":"Estudiante","LABEL_TEACHER":"Profesor","LAW":"Ley ","LEARNING_AREA":"Área de Aprendizaje","LEARNING_EVIDENCES":"Evidencias de Aprendizaje","LEARNING_STRATEGIES":"Estrategias de Aprendizaje","LEARNING_STRATEGIES_PANEL":"Estrategias de aprendizaje","LEARNING_SUBAREA":"Sub-área de aprendizaje","MAGAZINE_ARTICLE_IN_DATABASE":"Artículo de revista extraido de base de datos","MAIN_SECTION_TEACHER":"Maestro titular","MAIN_SECTION_TEACHER_MAIL":"Email maestro titular","MAIN_SECTION_TEACHER_PHONE":"Teléfono maestro titular","MATRIX_CAREER_CODE":"Cod. Carrera","MATRIX_CAREER_NAME":"Carrera","MATRIX_DESCRIPTION":"Descripción de la Matriz de Competencias","MATRIX_FACULTY_CODE":"Cod. Facultad","MATRIX_FACULTY_NAME":"Facultad","MATRIX_GENERAL_DATA":"Datos Generales","MATRIX_GENERAL_INFO":"Información General de la Matriz de Competencias","MATRIX_PENSUM_CODE":"Cod. Plan de Estudio","MATRIX_PENSUM_NAME":"Plan de Esudio","MATRIX_STUDYPLAN_ASSOCIATED":"Planes de estudio asociados","MATRIX_TYPE":"Tipo Matriz","MESSAGE_EXPLAIN_CLONING":"Con esta acción usted podrá clonar el Syllabus desde la sección seleccionada a la sección destino a través del botón 'Clonar'","MIN_CREDITS":"Créditos mínimos","MODALITIES":"Modalidades","MOMENT":"Momento","MOVIE":"Película ","NEW_STUDYPLAN":"Crear Plan de estudio","NEWSLETTER_ARTICLE":"Artículo de boletín","NEWSLETTER_ARTICLE_NO_AUTHOR":"Artículo de boletín sin autor","OBLIGATORY_SUBJECTS":"Cursos obligatorios","ONLINE_THESIS":"Tesis online ","OUTCOME_KNOWLEDGE":"Saberes del resultado de aprendizaje","OUTCOME_NAME":"Resultado de aprendizaje","PART_OF_A_BOOK":"Parte de un libro ","PENSUM_ACADEMIC_INFO":"Información académica","PENSUM_ADMISSION_PROFILE":"Perfil de ingreso","PENSUM_BLOCKS":"Cursos de bloque","PENSUM_CAMPUS":"Campus","PENSUM_CODE":"Código Plan de Estudio","PENSUM_GENERAL_DATA":"Información general ","PENSUM_GENERAL_INFO":"Datos generales del plan de estudio","PENSUM_GRADUATE_PROFILE":"Perfil de egreso","PENSUM_ID":"Plan de Estudio","PENSUM_IMPARTITION_MODE":"Modo de impartición","PENSUM_MODALITY":"Modalidad","PENSUM_NAME":"Nombre Plan de Estudio","PENSUM_PUBLICATION_DATE":"Fecha de publicación","PENSUM_SIGNATURES":"Cursos obligatorios","PENSUM_SPECIALTIES":"Cursos de especialidad","PENSUM_VALIDITY_END_DATE":"Fecha de término","PENSUM_VALIDITY_START_DATE":"Fecha de inicio","PENSUM_VIGENCY_INFO":"Información de vigencia","PERIOD_TYPE":"Tipo de periodo","PLAN_SUBJECT":"Cursos del plan","PRE_REQUIREMENTS":"Pre-requisitos","PREPARING_TO_PRINT":"Preparando impresión...","PRINT_LINK_PROMPT":"Si su impresión no comienza automáticamente, haga clic en el siguiente enlace:","PROCEDURAL_KNOWLEDGE":"Saber procedimental","REFERENCE_ADDED":"Referencias adicionales","REFERENCE_ARTICLE_TITLE":"Título del artículo ","REFERENCE_AUTHOR":"Autor ","REFERENCE_CHAPTER_TITLE":"Título del capítulo ","REFERENCE_COURT":"Corte","REFERENCE_DATABASE":"Base de datos ","REFERENCE_DOI":"DOI (Digital Object Identifier)","REFERENCE_EDITOR":"Editor","REFERENCE_EDITOR_MENTION":"Mención de responsabilidad del editor","REFERENCE_EDITORIAL":"Editorial","REFERENCE_FIFTH_AUTHOR":"Quinto autor","REFERENCE_FORMAT":"Formato","REFERENCE_FOURTH_AUTHOR":"Cuarto autor","REFERENCE_ID":"Código ","REFERENCE_INFO_TITLE":"Información del título","REFERENCE_ISBN":"Código ISBN","REFERENCE_LAST_AUTHOR":"Último autor","REFERENCE_LAW_TITLE":"Título de la ley ","REFERENCE_MAGAZINE_NAME":"Revista","REFERENCE_MOVIE_DIRECTOR":"Director","REFERENCE_MOVIE_PRODUCER":"Productor","REFERENCE_MOVIE_STUDIO":"Estudio ","REFERENCE_MOVIE_TITLE":"Título de la película ","REFERENCE_NAME":"Referencia","REFERENCE_NEWSLETTER_NAME":"Nombre del boletín","REFERENCE_OFFICIAL_SOURCE":"Fuente oficial","REFERENCE_ORIGIN":"Origen","REFERENCE_PAGES":"Página ","REFERENCE_PUB_CITY":"Ciudad de publicación","REFERENCE_PUB_COUNTRY":"País de publicacón","REFERENCE_PUB_DATA":"Fecha de publicación","REFERENCE_PUB_MONTH":"Mes de publicación","REFERENCE_PUB_PLACE":"Lugar de publicación","REFERENCE_PUB_YEAR":"Año de publicación ","REFERENCE_PUBLISHER":"Editorial ","REFERENCE_RECOVERED_DATE":"Fecha de recuperación","REFERENCE_SEARCH":"Buscador de referencias","REFERENCE_SECOND_AUTHOR":"Segundo autor","REFERENCE_SENTENCE_COUNTRY":"País de la sentencia","REFERENCE_SENTENCE_DATE":"Fecha de la sentencia","REFERENCE_SENTENCE_NUMBER":"Número de sentencia","REFERENCE_SOFTWARE_DESCRIPTION":"Descripción del software","REFERENCE_SOFTWARE_TITLE":"Título el Software","REFERENCE_TABLE":"Referencias","REFERENCE_TABLE_ADDED":"Referencias adicionales","REFERENCE_THESIS_CATEGORY":"Categoría ","REFERENCE_THESIS_DATABASE":"Nombre de la base de datos","REFERENCE_THESIS_INSTITUTION":"Nombre de la institución","REFERENCE_THESIS_TITLE":"Título de la tesis","REFERENCE_THIRD_AUTHOR":"Tercer autor ","REFERENCE_TITLE":"Título ","REFERENCE_URL":"Url","REFERENCE_VERSION":"Versión","REFERENCE_VIDEO_PRODUCER":"Productor","REFERENCE_VIDEO_TITLE":"Título del video ","REFERENCE_VOLUME":"Volumen ","REFERENCE_WEBSITE_NAME":"Nombre del sitio web","REFERENCE_YEAR":"Año","REQUIREMENTS":"Requisitos del Curso","REQUIREMENTS_NOTES":"Notas de los Requisitos del Curso","REQUIREMENTS_NOTES_PANEL":"Notas adicionales","REREFENCE_UMI":"Número UMI","ROLE":"Rol","SAVE_CHANGES":"Guardar cambios","SEARCH_TEXT":"Buscar texto","SECONDARY_BIBLIOGRAPHY":"Bibliografía complementaria","SECTION_ACTIVITIES":"Actividad","SECTION_APROVAL_CONDITIONS":"Condiciones de aprobación","SECTION_ASSISTANTS":"Asistentes o co-titulares","SECTION_CHANGES_HISTORY":"Historial de cambios","SECTION_COMPETENCIES":"Competencias a las que tributa el Curso","SECTION_COMPETENCIES_PANEL":"Competencias","SECTION_COMPETENCIES_SECTION":"Competencias","SECTION_CONTENTS":"Aprendizajes esperados y unidades de contenido","SECTION_COORDINATOR":"Coordinador","SECTION_COREQUISITES":"Co-requisitos","SECTION_DESCRIPTION":"Descripción del Curso","SECTION_DESCRIPTION_PANEL":"Descripción del Curso","SECTION_DESCRIPTION_SECTION":"Descripción del Curso","SECTION_EVALUATION":"Tipo de evaluación","SECTION_EVALUATION_COMMENTS":"Evaluaciones","SECTION_EVALUATION_COMMENTS_PANEL":"Evaluaciones","SECTION_EVALUATION_ID":"Evaluación","SECTION_EVALUATION_METHOD":"Medios de evaluación","SECTION_EVALUATION_METHOD_ID":"Método de Evaluación","SECTION_EVALUATION_PROCEDURES":"Procedimientos de Evaluación","SECTION_EVALUATION_STRUCTURE":"Evaluación","SECTION_EVALUATIONS":"Criterios de evaluación y acreditación","SECTION_EVIDENCES_PANEL":"Evidencias del Curso","SECTION_EVIDENCES_TABLE":"Evidencias de Aprendizaje","SECTION_GENERAL_DATA":"Datos generales","SECTION_IMPARTITION_MODE":"Modo en que se imparte","SECTION_LEARNING_EVIDENCES":"Evidencias de Aprendizaje","SECTION_LEARNING_STRATEGIES":"Estrategias de aprendizaje","SECTION_MAIN_TEACHER":"Profesor titular","SECTION_MAIN_TEACHER_MAIL":"Email profesor titular","SECTION_METHODOLOGY":"Metodología","SECTION_METHODOLOGY_PANEL":"Metodología","SECTION_MODALITIES_ACTIVITIES":"Modalidades y Actividades","SECTION_MODALITY":"Modalidad del curso","SECTION_NAME":"Sección","SECTION_OBJECTIVES":"Objetivos del Curso","SECTION_OBJECTIVES_PANEL":"Objetivos del Curso","SECTION_OBJECTIVES_SECTION":"Objetivos","SECTION_OTHER_CONDITIONS":"Otras condiciones","SECTION_OTHERS":"Otros","SECTION_OTHERS_PANEL":"Otros","SECTION_OUTCOMES":"Resultados de Aprendizaje del Curso","SECTION_OUTCOMES_ID":"Resultados de Aprendizaje del Curso","SECTION_OUTCOMES_PANEL":"Resultados de aprendizaje","SECTION_PREREQUISITES":"Pre-requisitos","SECTION_REFERENCE_CATEGORY":"Categoría de Bibliografía","SECTION_REFERENCES":"Bibliografía","SECTION_REFERENCES_NOTES_PANEL":"Notas sobre la bibliografía y sitios web","SECTION_REQUIREMENTS_NOTES":"Notas de los Requisitos del Curso","SECTION_REQUIREMENTS_NOTES_PANEL":"Notas adicionales","SECTION_REQUIREMENTS_PANEL":"Requisitos del Curso","SECTION_SESSION_NAME":"Planeación del Curso","SECTION_SESSIONS":"Planeación del Curso","SECTION_SESSIONS_PANEL":"Temas y subtemas","SECTION_TEACHING_TEAM":"Equipo docente","SECTION_TYPE_IN_PENSUM":"Tipo de Curso","SEE_ON_PLAN":"Ver en el plan","SELECT_A_STRUCTURE":"Seleccione un tipo de referencia (libro, revista, artículo, etc.) ","SELECT_DESTINATION":"Seleccionar sección de destino","SELECT_FILES":"Seleccionar archivos...","SEMESTER":"Semestre","SENTENCE":"Resolución o sentencia","SESSION_ACTIVITY":"Actividad de la sesión","SESSION_ACTIVITY_DESCRIPTION":"Descripción de la actividad","SESSION_COURSE_OUTCOMES":"Aprendizajes esperados","SESSION_DESCRIPTION":"Descripción","SESSION_END_TIMING":"Fecha Fin","SESSION_EVALUATION_COMPONENTS":"Componentes de evaluación de la sesión","SESSION_EVALUATION_METHODS":"Medios de evaluación","SESSION_EVALUATION_METHODS_ADD":"Medios de evaluación","SESSION_LEARNING_RESULTS":"Resultados de aprendizaje del tema","SESSION_LEARNING_RESULTS_ADD":"Resultados de aprendizaje del tema","SESSION_LEARNING_STRATEGIES":"Estrategias educativas","SESSION_LEARNING_STRATEGIES_ADD":"Estrategias educativas","SESSION_NAME":"Nombre de la Sesión","SESSION_NAME_ADD":"Tema Adicional","SESSION_REFERENCES":"Referencias de la sesión","SESSION_RESOURCES":"Recursos y Materiales","SESSION_RESOURCES_ADD":"Recursos y materiales","SESSION_SUBTHEMES":"Subtemas","SESSION_SUBTHEMES_ADDED":"Subtemas adicionales","SESSION_SUBTHEMES_ADDED_ADD":"Subtemas","SESSION_TEACHERS":"Docentes de la sesión","SESSION_THEME":"Tema","SESSION_THEME_ADD":"Tema Adicional","SESSION_TIMING":"Calendarización","SESSION_TIMING_ADD":"Calendarización","SOFTWARE":"Software","SPECIALITY_SUBJECTS":"Cursos de especialidad","START_MESSAGE_EXPLAIN_CLONING":"Presione el botón","STATISTICAL_DATABASE":"Base de datos con estadística","STRICT_FIELD_REQUIREMENT":"Obligatoriedad de campos requeridos","STRICT_FIELD_REQUIREMENT_HELP":"Obligará al usuario a completar todos los datos requeridos para ejecutar esta transición.","STRUCTURE":"Estructura","STRUCTURES":"Tipo de referencia","STUDENT_HISTORICAL_PROGRESS":"Avance curricular","STUDY_PLAN_CREATE_SUCCESS":"Plan de estudio creado correctamente","STUDYPLAN_CODE":"Código del Plan de estudio","STUDYPLAN_GENERAL_INFO":"Información General del Plan de estudio","STUDYPLAN_NAME":"Nombre del Plan de estudio","SYLLABUS_GENERAL_DATA":"Datos Generales","SYLLABUS_REFERENCES":"Referencias bibliográficas y sitios web","THESIS":"Tesis","TOGGLE_COLAPSE":"Colapsar","TOTAL_HOURS":"Horas totales","TOTAL_WEEKS":"Semanas Totales","UPDATE_SUCCESS_MESSAGE":"Actualizado exitosamente","UPLOAD":"Subir","UPLOAD_ALL":"Subir todos","UPLOAD_FILE":"Subir archivo ","UPLOADING_FILE":"Archivos subidos ","USER":"Usuario","WARNING_CLONING_PROCESS":"Ocurrió un error","WARNING_MESSAGE":"Mensaje de alerta","WARNING_MESSAGE_DELETE_DEFAULT":"¿Está seguro de eliminar este registro?","WEB_MAGAZINE_ARTICLE":"Artículo de revista web","WEBSITE":"Sitio web ","WEBSITE_NO_AUTHOR":"Sitio web sin autor ","WORKFLOW":"Workflow","YEAR":"Año","YOUTUBE_VIDEO":"Video de Youtube","ACADEMIC":"Académico","ACADEMIC_CALENDAR":"Calendario académico","ACADEMIC_CALENDAR_TO_CLONE":"Calendarios académicos a clonar","ACADEMIC_CALENDAR_VISUALIZATION":"Visualización calendario académico","ACADEMIC_PROGRAM_SUMMARY":"Resumen programación académica","ACADEMIC_PROGRAMMING":"Programación académica","ACADEMIC_PROGRAMMING_PLURAL":"Programaciones académicas","ACADEMIC_QUOTA_LEEWAY":"Holgura de cupo académico","ADD_INTEGRATION_CODE":"Agregar código de integración","ADD_NAME_RESOURCE_TYPE":"Agregar nombre de tipo de recurso","ADD_USAGE_TYPE":"Agregar tipo de uso","ADD_USAGE_TYPE_NAME":"Agregar nombre de tipo de uso","ADVANCE_GROUP":"Avance de grupo","AFFECTED":"afectadas","APARTAMENT":"Departamento","APPROVAL_RATE":"Tasa de aprobación","APPROVE_REQUEST_N":"Solicitud de aprobación N° {{listRequestCount}}","APPROVED_COURSE_CYCLE":"Ciclo en que se aprobó materia","APPROVED_COURSES":"Cursos aprobados","APPROVED_CREDITS":"Créditos aprobados","ASSIGN_RESOURCE_TYPE":"Asignar tipo de recurso","ASSIGN_SAME_DAY":"Asignar mismo día","ASSIGN_SCHEDULE_CLASSROOMS":"Asignar horario y salas","ASSIGNAMENT_PREDEFINED_TEACHER_TO_SECTIONS":"Asignación de Profesor predefinido a secciones","ASSIGNED_CLASSROOMS":"Salas asignadas","ASSING_ACADEMIC_CALENDAR":"Asignar Calendario Académico","ATENTION":"Atención","AVARAGE_STUDENTS_SECTIONS":"Prom. de estudiantes de la secciones","BACK_TO_SIMULATION_LIST":"Volver a la lista de simulaciones","BACKGROUND":"2do Plano","BASE_LINE":"Línea Base","BASE_SIMULATION":"Simulación base","CALCULATED_DEMAND":"Demanda calculata","CAMPUS_PERIOD_SHIFT_INDICATORS":"Indicadores por campus - periodo - jornada","CAMPUSES":"Campus","CANDIDATE_CLASSROOM":"Salas candidatas","CANDIDATE_SCHEDULE_CLASSROOM":"Horario/salas candidatas","CANDIDATE_SCHEDULE_CLASSROOM_RESTRICTION":"Restricción Horarios/Salas Candidatas","CANDIDATES":"Candidatas","CANT_RECORDS":"Cantidad de registros","CAREER":"Carrera","CAREER_BUILDING_PREFERENCE":"Restricción Carrera - Edificio","CAREERS":"Carreras","CHAIR_USAGE_PERCENTAGE_RESTRICTION":"Restricción de porcentaje uso de sillas","CHAIR_USE_PERCENTAGE":"Porcentaje uso de sillas","CHECK_UNCHECK_ALL":"Marcar/Desmarcar todo","CLASSROOM":"Salas","CLASSROOM_RESTRICTION":"Restricción de salas","CLASSROOM_RESTRICTION_LIST":"Listado restricción de salas","CLONE_ACADEMIC_CALENDAR":"Clonar calendarios académicos","CLONE_CROSS_LISTS":"Clonar listas cruzadas","COEFF_ASSIGNED_MODULES":"Coeficiente de Módulos Asignados","COEFF_COURSE":"Coeficiente de Asignaturas","COEFF_POSITION":"Coeficiente de Puesto","COEFF_TEACHER_EVALUATION":"Coeficiente de Evaluación Docente","COEFF_VALUE_HOUR":"Coeficiente de Valor Hora","COMPACT":"Compactar","COMPACT_RECORD_CLASS_GROUP":"Compactar por grupo nota clase","COMPACT_RETURN":"Compactar y volver","COMPACTION_INDEX_ACADEMIC_QUOTA":"Índice de compactación por cupo académico","COMPACTION_OPPORTUNITY":"Oportunidad de compactación","COMPACTION_PERCENTAGE_ACADEMIC_QUOTA":"% de compactación por cupo académico","COMPATIBILITY_GROUP_NUMBER":"Nº de grupo de compatibilidad","CONFIG":"Configurar","CONFIG_CROSS_LISTS":"Configurar listas cruzadas","CONFIGURATION_PER_WEEKS":"Configuración por semanas","CONTINUE":"Continuar","COORDINATOR_VIEW":"Coordinador","COST_MAINTAINER_TEACHER_EVALUATION":"Mantenedor de costo y evaluación docente","COURSE_ACTIVITY_DATA":"Datos de curso actividad","COURSE_ACTIVITY_EMPTY_STATE":"Haga click en un Curso Actividad para acceder a la información de este...","COURSE_ACTIVITY_MAINTAINERS":"Mantenedor de curso actividad","COURSE_BUILDING_PREFERENCE":"Restricción curso - edificio","COURSE_DUPLICATED_IN_NEXT_CROSS_LIST":"El curso {string} está duplicado en las siguientes listas cruzadas","COURSED_CYCLE":"Ciclo en que cursó","COURSED_ELECTIVES":"Optativos cursados","COURSES":"Cursos","COURSES_IN_THIS_CROSS_LIST":"Cursos en esta lista cruzada","CREATE":"Crear","CREATE_ACADEMIC_PROGRAMMING":"Crear programación académica","CREATE_CROSS_LIST":"Crear lista cruzada","CREATE_DEMAND_SIMULATION":"Crear simulación de demanda","CREATE_GROUP_SIMULATION":"Crear Simulación Grupo","CREATE_REQUEST":"Crear solicitud","CREATE_RESOURCE":"Crear recurso","CREATE_RESTRICTION":"Crear restricción","CREATE_SCHEDULE_CLASSROOM_SIMULATION":"Crear Simulación Horario","CREATE_TEACHER_SIMULATION":"Crear Simulación Docente","CREATE_VIRTUAL_SIMULATION":"Crear simulación virtual","CREATING":"Creando","CROSS_LIST_LOEADED":"Listas cruzadas cargadas","CROSS_LISTS_CONFIGURATION":"Configuración de listas cruzadas","CROSS_LISTS_DEFINITION":"Definición de listas cruzadas","CROSS_LISTS_TO_CLONE":"Listar cruzadas a clonar","CROSS_LISTS_TO_MERGE":"Listas cruzadas a fusionar","CROSS_LISTS_WITH_CONFLICT":"Listas cruzadas con conflicto","CURRENT_VALUE":"Valor Actual","DEFINE_A_COURSE":"Defina un curso","DEFINE_GENERIC_GROUP":"Define grupo genérico","DELETE_SIMULATION":"Borrar simulación","DEMAND":"Demanda","DEMAND_MATRIX_CALENDAR":"Matriz de Demanda por calendarios","DEMAND_SIMULATION":"Simulación de Demanda","DEPENDENT_SIMULATION":"Simulaciones Dependientes","DESERTION_RATE":"Tasa de deserción","DICTATE":"Dictar","DIFFERENT_ACTIVITIES_IN_NEXT_CROSS_LIST":"Las actividades son diferentes en las siguientes listas cruzadas","DIFFERENT_ACTIVITY_SCHEDULE":"Tipo actividad/horario diferentes","DISTRIBUTION_AUTO":"Distribución automática","DOWNLOAD":"Descargar","DOWNLOAD_BY_CAMPUS":"Descargar por campus","DOWNLOAD_BY_PLAN":"Descargar por plan","DOWNLOAD_BY_STUDENT":"Descarga por Estudiante","DOWNLOAD_HISTORICAL_RPC":"Descargar histórico RPC","DUPLICATED_COURSES":"Cursos duplicados","EDIT_ACADEMIC_QUOTA":"Editar cupo académico","EDIT_ACADEMIC_QUOTA_LEEWAY":"Editar Holgura de cupo académico","EDIT_CROSS_LIST":"Editar lista cruzada","EDIT_GLOBAL_DEMAND":"Editar demanda global","EDIT_NEW_STUDENTS":"Editar nuevos estudiantes","EDIT_PREVIOUS_PERIOD":"Editar Periodo Anterior","EDIT_RESTRICTION":"Editar restricción","EDITED":"Editados","EMPTY":"Vacio","END_WEEK":"Fin semana","ENROLLMENT_CYCLE":"Ciclo ingreso","ENTRY_CICLE":"Ciclo ingreso","EXECUTE":"Ejecutar","EXECUTE_IN_BACKGROUND":"Ejecutar en segundo plano","EXECUTING":"Ejecutando","FINAL_DEMAND":"Demanda final","FIND_WEEKS":"Encontrar semanas","FINISHED":"Finalizadas","FIXED_CURRICULAR_PROGRESS":"Avance curricular","FLEXIBLE_CURRICULAR_PROGRESS":"Avance curricular","FRI":"Viernes","FUNCTION_OBJECTIVE":"Función Objetivo","FUNCTION_OBJECTIVE_CONFIGURATION_TEACHER":"Configuración Función Objetivo: Función de Asignación Docente","GENERAL_INDICATORS":"Indicadores generales","GO_BACK_GROUP_SIMULATIONS":"Volver a la simulación de grupo","GO_BACK_SIMULATION":"Volver a la simulación","GROUP_SIMULATION":"Simulación de Grupo","GROUP_SIZE":"Tamaño grupo","GROUPS_INDEX_VIEW":"Vista de indicadores grupos","GROUPS_TABLE_VIEW":"Vista tabla grupos","HEADER_STEP_5":"Dictado en periodo equivalente anterior","HISTORIC_ENROLLMENT":"Inscripciones historicas","HISTORY":"Historia","HOLYDAYS":"Feriado","ID_CROSS_LIST":"ID lista cruzada","ID_PUBLIC":"Id público","ID_UPL":"ID U-Planner","IN_PROGRESS":"En Curso","INDEX_COMPACTION_INFRASTRUCTURE":"Índice de compactación por infraestructura","INFRASTRUCTURE_OCCUPATION PERCENTAGE RESTRICTION":"Restricción % ocupación infraestructura","INSTITUTION":"Institución","INTEGRATION_WARNING_TEXT":"Si continúa con la edición/eliminación quedarán obsoletas las siguientes simulaciones:","INTEGRATION_WARNING_TITLE":"Advertencia de Integración","LAST_DATA_LOAD":"Datos de la última carga","LOAD_ACADEMIC_QUOTA":"Cupo Académico Cargado","LOAD_ANOTHER_FILE":"Cargar otro archivo","LOAD_CLASSROOM_RESTRICTIONS":"Cargar restricción de salas","LOAD_FILE":"Carga de archivo","LOAD_PREVIOUS_PERIOD":"Cargar Periodo Anterior","LOAD_QUOTA":"Cupo cargado","LOADED_CAREERS":"Carreras cargadas","LOADED_COURSES":"Cursos cargados","LOADED_PLANS":"Planes cargados","LOADED_SECTIONS":"Secciones cargadas","MASSIVE_CLONING":"Clonación masiva","MAXIMUM_GROUP_SIZE":"Tamaño Máximo de Grupo","MENU_ACADEMIC_PERIOD":"Periodo académico","MENU_ACTIVITY":"Actividad","MENU_ACTIVITY_SUBJECT_DETAIL":"Actividad curso detalle","MENU_ACTIVITY_SUBJECT_TYPE_USE":"Actividad curso tipo uso","MENU_CAREER_TARIFF":"Arancel carrera","MENU_CLASS_NOTE":"Nota clase","MENU_CLASS_TIME":"Hora clase","MENU_COMPARISON_REPORT":"Reporte de Comparación","MENU_CONFERENCE_MANAGER":"Administrador de Jornadas","MENU_COORDINATOR":"Coordinador","MENU_COURSE_ACTIVITY":"Curso Actividad","MENU_CROSS_LIST":"Listas Cruzadas","MENU_DEMAND_MATRIX":"Matriz de Demanda","MENU_DETAIL_REPORT":"Reporte Detalle","MENU_DISPLAY":"Visualización","MENU_ENTRY_NEW_STUDENTS":"Ingreso de Nuevos Estudiantes","MENU_FILE_UPLOAD":"Carga de Archivos","MENU_GLOBAL_DEMAND":"Demanda global","MENU_INFRASTRUCTURE":"Infraestructura","MENU_INFRASTRUCTURE_TYPE_USE":"Infraestructura tipo uso","MENU_INTEGRATION_TABLES":"Tablas Integración","MENU_LOAD_GROUP":"Grupos","MENU_LOAD_SCHEDULE":"Carga horario","MENU_LOADED_DATA":"Datos Cargados","MENU_MAINTAINERS":"Mantenedores","MENU_MODULES_DAY":"Módulos por jornada","MENU_PLANS_CAMPUS":"Planes en campus","MENU_REPORTS":"Reportes","MENU_STUDY_PLAN":"Plan de estudio","MENU_STUDY_PLAN_SHIFT":"Plan estudio turno","MENU_STUDY_PLAN_SUBJECT":"Plan estudio curso","MENU_SUBJECTS_BY_DEPARTAMENT":"Materias por departamento","MENU_SUBJECTS_BY_PLAN":"Materias por plan","MENU_TEACHER":"Docente","MENU_TEACHER_ACTIVITY_SUBJECT":"Docente curso actividad sede","MENU_TEACHER_COORDINATOR":"Dip. Docente-Coordinador","MENU_TEACHER_COST_MATTER_ACTIVITY":"Costo Docente Materia Actividad","MENU_TEACHER_SUBJECT_ACTIVITY":"Docente Materia Actividad","MENU_TEACHER_VALUE_TIME_EVALUATION":"Docente valor hora evaluacion","MENU_TEACHING_AVAILABILITY":"Disponibilidad Docente","MENU_TIME_AVAILABILITY":"Disponibilidad Horaria","MENU_TIME_TRANSFER":"Tiempo Traslado","MENU_TYPE_USE":"Tipos Uso","MENU_USE_INFRASTRUCTURE":"Uso de Infraestructura","MENU_USE_ROOMS":"Utilización de Salas","MENU_VALUE_TIME_SUBJECT":"Valor hora curso","MERGE_CROSS_LISTS":"Fusionar listas cruzadas","MERGE_SECTIONS_BY_CROSS_LISTS":"Compactar por listas cruzadas","MERGE_SECTIONS_BY_GRADE_GROUP":"Compactar por grupo nota clase","MERGE_SECTIONS_BY_MODALITY":"Compactar por modalidad","MERGE_SECTIONS_BY_PLANS":"Compactar por planes","MERGE_SECTIONS_BY_SHIFT":"Compactar por jornada","MERGE_SECTIONS_OPPORTUNITY":"Oportunidad de compactación","MERGE_SECTIONS_RESULTS":"Resultados de compactación","MERGED_COURSES_IN_CROSS_LIST":"Materias fusionadas en esta lista cruzada","MINIMUM_GROUP_SIZE":"Tamaño Mínimo de Grupo","MIXED":"Mixtas","MOD":"Mod","MODIFY_BASELINE":"Modificar línea base","MON":"Lunes","MSG_MODIFICATION_BASE_LINE_1":"Si realiza esta acción quedará visible para los usuarios","MSG_MODIFICATION_BASE_LINE_2":"Si realiza esta acción dejará de estar visible para los usuarios","MSG_STATUS_SIMULATION":"Para visualizar el estado de su simulación, debe dirigirse a sección Simulación.","MSJ_CLASSROOM_RESTRICTION_INSTRUCTION":"Revisa el detalle de la carga de archivos, los datos cargados exitosamente y los que presentan algún tipo de error","MSJ_CLONE_MODAL":"Se ha asignado un nombre por defecto, tiene la opción de modificar si lo estima conveniente.","MSJ_ERROR":"Error al conectar al servicio","MSJ_ERROR_MODAL_CLONE":"La clonación no ha podido ser ejecutada","MSJ_ERROR_MODAL_STATUS":"La barra de progreso le indica el estado en el cual se encuentra la simulación, es recomendable no cancelar , para llevar a cabo otro flujo sólo debe hacer clic en el botón de ejecutar en 2° plano.","MSJ_ERROR_SIMULATION_STATUS":"La simulación no ha podido ser ejecutada","MSJ_NO_RECORDS_AVAILABLE":"No hay registros disponibles aún. Haz click en el botón 'Crear' para comenzar","MSJ_OPTIMAL_OFFER_SUCCES_COMMENT":"Comentario realizado exitosamente","MSJ_SUCCESS":"Cambios realizados correctamente","MSJ_SUCCESS_RESTRICTION_CANDIDATE_CLASSTOOMS":"Restricción salas candidatas creada exitosamente","N_CLASSROOM":"Nº de salones","N_CROSS_LISTED_SECTIONS":"Nº de secciones listas cruzadas","N_GENERATED_SECTIONS":"Nº de secciones generadas","N_IDENTIFICATION":"Nº de Identificación","N_MIXED_SECTIONS":"Nº de secciones mixtas","N_PURE_SECTIONS":"Nº de secciones puras","N_SECTIONS":"Nº de secciones","NAME_CROSS_LIST":"Nombre lista cruzada","NAME_PROGRAMMING":"Nombre programación Académica","NEW_ENTRIES":"NI","NEW_ENTRIES_FOR_MAX_COMPRESSION":"Ni para máxima compactación","NEW_ENTRIES_FOR_MIN_DESIRED":"Ni para mínimo deseable","NEW_POSITION":"Nuevo cargo","NEW_PROGRAMMING":"Nueva Programación","NEXT":"Siguiente","NO_ASSIGNED_CLASSROOMS":"Sin salas asignadas","NO_DATA":"No hay datos disponibles","NOT_EXECUTED":"No Ejecutadas","NUMBER_OF_CAMPUS":"Nº Campus","NUMBER_OF_COMPATIBILITY_GROUPS":"N° de grupo de compatibilidad","NUMBER_OF_GROUPS":"Nº grupos","OCCUPATION":"Ocupación","OPTATIVE_SELECT":"Seleccione Materias Optativas","OPTATIVE_SUBJECT":"Cursos optativos","OPTIMAL_ENROLLMENT":"Matrícula óptima","OPTIMAL_OFFER":"Oferta óptima","PARALLEL_BY_COURSE_ACTIVITY":"Paralelas por Curso-Actividad","PARALLEL_RESTRICTION":"Restricción paralelas","PERCENTAGE_ASSIGNMENTS":"% de asignaciones","PERCENTAGE_ASSIGNMENTS_SECTION_TYPE":"Porcentaje de asignaciones según tipo de sección","PERCENTAGE_COMPACTION_INFRASTRUCTURE":"% de compactación por infraestructura","PLANS":"Plan/es","POSITION":"Ubicación","POSITION_CODE":"Código cargo","POSITION_NAME":"Nombre cargo","PREDEFINED":"Predefinidas","PREDEFINED_CANDIDATE_SCHEDULE_CLASSROOM":"Horarios/Salas predefinidas y candidatas","PREDEFINED_CLASSROOM":"Salas predefinidas","PREDEFINED_SCHEDULE_CLASSROOM_RESTRICTION":"Restricción Horarios/Salas Predefinidas","PREDEFINED_TEACHING_ASSIGNAMENT":"Asignación Docente Predefinido","PREFEFINED_SCHEDULE_CLASSROOM":"Horario/salas predefinidas","PREVIOUS":"Anterior","PREVIOUS_PERIOD":"Periodo Anterior","PROGRAMMING":"Programación","PROGRESS":"Avance","PURE":"Puras","QUICK_ACCESS":"Acciones Rápidas","QUOTA":"Cuota","QUOTAS_USED":"Cupos utilizados","RE_ENTRIES":"RI","RE_SIMULATE":"Re-Simular","REAL_FICTIONAL":"Real/Ficticio","RECONFIGURE":"Reconfigurar","RECONFIGURE_MSJ":"Al reconfigurar perderás los resultados de la simulación. También puedes clonar esta simulación para no perder estos resultados ¿Qué acción desea realizar?","RECONFIGURE_SIMULATION":"Reconfigurar simulación","RECORDS":"Registros","RECORDS_LOADED":"Registros Cargados","RECORDS_REJECTED":"Registros Rechazados","REQUEST_DATE":"Fecha solicitud","REQUEST_DETAILS":"Detalle de la solicitud","REQUEST_LIST":"Lista solicitudes","RESOLUTION":"Resolución","RESOLUTION_DATE":"Fecha resolución","RESOLVE_CONFLICTS_IN_CROSS_LISTS":"Resolver conflictos en listas cruzadas","RESOLVE_CONFLICTS_IN_CROSS_LISTS_MESSAGE":"La lista cruzada {string} presenta los siguientes conflictos:","RESOURCE_DATA":"Datos del recurso","RESOURCE_EMPTY_STATE":"Haga click en un recurso para acceder a la información de este...","RESOURCE_TYPE":"Tipo de recurso","RESTRICTION_CANDIDATE_CLASSTOOMS":"Restricción salas candidatas","RESTRICTION_LOCATION_ACTIVITY":"Restricción Ubicación/Actividad","RESULTS_LOADED_FILE":"Resultados de Carga","ROOT_COURSE":"Curso raíz","SAT":"Sábado","SAVE_NEXT":"Guardar y seguir","SCHEDULE_CLASSROOM_SIMULATION":"Simulación horario","SCHEDULE_INDEX_VIEW":"Vista de indicadores horario","SCHEDULE_TABLE_VIEW":"Vista tabla horario","SEARCH":"Buscar","SEARCH_AND_ADD_COURSES":"Buscar y agregar materias","SEE_LOAD_CLASSROOM_RESTRICTIONS":"Ver carga restricción salas","SEE_LOAD_PREVIOUS_PERIOD":"Ver carga Periodo Anterior","SEE_RESTRICTION_EXTISTING_CLASSROOM":"Ver restricción salas existentes","SEE_RESULTS":"Ver Resultados","SEE_SCHEDULE_CLASSROOM_RESTRICTION":"Ver restricciones Horario Salas","SEE_STATUS":"Ver Estado","SELECT_ACADEMIC_UNIT":"Seleccione unidad académica","SELECT_DEMAND_SIMULATION":"Seleccione una simulación de demanda","SELECT_LOCATION":"Seleccione ubicación","SELECT_LOCATION_AND_STAGE":"Seleccione ubicación y escenario","SELECT_ROOM":"Seleccione un aula","SELECT_SHIFT":"Seleccione jornada","SELECT_TEACHER":"Seleccione docente","SELECT_TYPE_ACTIVITY_INSTRUCTIONS":"Seleccione el tipo de actividad a la que desea asignar horario y sala","SELECT_TYPE_OF_EXISTING_RESOURCE":"Seleccione tipo de recurso existente","SELECT_TYPE_RESTRICTION_INSTRUCTIONS":"Seleccione tipo de restricción a la que desea asignar horario y sala","SELECTED_CONFIGURATION":"Configuración seleccionada","SESION":"Sesión","SESSION":"Sesión","SET_UP":"Configurar","SHIFT_NAME":"Nombre de la jornada","SHIFTS_AVAILALED":"Turnos Disponibles","SIMULATE":"Simular","SIMULATE_PREVIOUS_POINT":"Simular en punto anterior","SIMULATE_SCHEDULE":"Simular horario","SIMULATE_SCHEDULE_WITH_THIS_SIM":"Simular horario con esta Simulación","SIMULATE_TEACHER":"Simular docente","SIMULATE_TEACHER_WITH_THIS_SIM":"Simular docente con esta Simulación","SIMULATION":"Simulación","SIMULATION_CONFIGURATION":"Configuración de simulación","SIMULATION_CONFIGURE":"Configurar simulación","SIMULATION_CREATE_SUCCESS":"Simulación creada exitosamente","SIMULATION_DEMAND":"Simulación de Demanda","SIMULATION_FINISHED":"Simulación finalizada","SIMULATION_GROUPS":"Simulación de grupos","SIMULATION_INDICATORS":"Indicadores de simulación","SIMULATION_NAME":"Nombre de la simulación","SIMULATION_PROGRESS":"Progreso de la simulación","SIMULATION_SCHEDULE":"Simulación de horario","SIMULATION_TEACHER":"Simulación docente","SIMULATIONS":"Simulaciones","STAGE":"Escenario","START_VIRTUAL_GROUP_SIMULATION":"Simulación de grupo virtual","START_WEEK":"Inicio semana","STATE_OF_PROGRESS":"Estado de avance","STEP":"Paso","STUDENT_PROGRESS":"Avance del estudiante","STUDENT_QUOTE":"Cupo estudiantes","STUDENT_VIEW":"Estudiante","SUBJECT":"Curso","SUBJECTS":"Cursos","SUN":"Domingo","TEACHER_CONTRACT_TYPE":"Tipo de contrato docente","TEACHER_CONTRACT_TYPE_INSTRUCTION":"Rellene los datos del siguiente formulario para crear un nuevo cargo. La prioridad de los cargos se genera de manera automática, si desea agregar una prioridad manual al nuevo cargo hay un campo disponible. Tenga en cuenta que al agregar una prioridad de manera manual estará cambiando la prioridad de todos los cargos que vengan después de él. Los campos con un (*) son obligatorios","TEACHER_EVALUATION_MINIMUN_VALUE":"Valor mínimo evaluación docente","TEACHER_INDEX_VIEW":"Vista de indicadores docente","TEACHER_POSITION_MAINTAINERS":"Mantenedor cargo docente","TEACHER_RPC_TABLE_VIEW":"Vista tabla RPC docente","TEACHER_SIMULATION":"Simulación docente","TEACHER_SIMULATION_CONFIGURATION":"Configurar simulación docente","TEACHER_SIMULATION_PROGRESS":"Progreso simulación docente","TEACHER_TABLE_VIEW":"Vista tabla docente","THU":"Jueves","TIME_RANGES":"Calendarios académicos","TITLE_CLONE_MODAL":"Progreso Clonación","TITLE_ERROR_CREATION":"Se han detectado errores en la infraestructura seleccionada de la Programación académica","TITLE_ERROR_CREATION_2":"Se han detectado errores en los datos existentes de la Programación Académica","TITLE_ERROR_CREATION_SCHEDULE":"Existen @nn secciones que no se asignaran docente por no tener horario y/o sala","TITLE_ERROR_CREATION_SCHEDULE_PARENT":"Existen @nn secciones que no se asignaran docente por tener actividad virtual","TITLE_FORECAST_CREATION":"La simulación se ejecutará en el siguiente universo de datos","TITLE_FORECAST_CREATION_2":"Resumen de configuración de parámetros","TITLE_SIMULATION":"Revisa el listado de simulaciones creadas o bien crea una nueva simulación","TITLE_STEP_2":"Seleccione tipo de periodo y turnos que desea incluir en la programación","TITLE_STEP_5":"Seleccione los cursos a dictar, también puede filtrar los datos para obtener un resultado más certero","TITLE_STEP_6":"Seleccione los cursos optativos a dictar, también puede filtrar los datos para obtener un resultado más certero","TO_DELETE_ASK":"¿Realmente Desea Eliminar?","TOTAL_LOADED_COURSES":"Total cursos cargados","TOTAL_MAX_GROUP_COMPRESSION":"Max total compactable en grupos","TOTAL_MIN_DESIRED_COMPRESSION":"Min total deseable compactación grupo","TUE":"Martes","TURNS":"Turnos","TYPE":"Tipo","TYPE_OF_ACTIVITY":"Tipo de Actividad","U_FORECAST":"u-forecast","U_PLANNING":"u-planning","UNASSIGNED_SECTIONS":"Secciones no asignadas","UNMERGE_SUCCESSFUL":"Descompactación realizada exitosamente","UPLOAD_CROSS_LISTS":"Subir listas cruzadas","UPLOAD_DEMAND":"Subir demanda","UPLOAD_HISTORY":"Historial de cargas","USAGE_TYPE":"Tipo de uso","USAGE_TYPE_DETAILED":"Tipo de uso detallado","USAGE_TYPE_EMPTY_STATE":"Haga click en un Tipo de recurso o Tipo de Uso para acceder a la información de este...","USAGE_TYPE_MANTAINERS":"Mantenedor de tipo de uso","USE_TEACHER_AVAILABILITY":"Utilizar disponibilidad docente","USED":"Utilizados","VALIDATE_DATA_DOWNLOAD_XLS":"Validar datos (descargar en XLS)","VALIDATION_LOADED_DATA":"Validación de datos cargados","VIEW_CROSS_LIST":"Ver lista cruzada","VIEW_CROSS_LISTS":"Ver listas cruzadas","VIEW_GLOSSARY":"Ver Glosario","VIEW_STATE_OF_PROGRESS_HELP":"Revise sus cursos. En caso de inconsistencias, puede enviar una solicitud de aprobación pinchando sobre los cursos en cuestión.","VIEW_USER_MANUAL":"Ver Manual de Uso","VISUALIZE_BY":"Visualizar por","WED":"Miércoles","WEEKS_INFORMATION":"Información semanas","WITHOUT":"Sin","WITHOUT ASSIGNED_MODULES":"Sin módulos asignados","YOU_WANT":"¿Deseas Realmente","80_LIM_INF":"80% del Límite Inferior","80_LIM_SUP":"80% del Límite Superior","ACADEMIC_PERFORMANCE_FIRST_YEAR_FACTOR_DESCRIPTION":"Para los casos de alumnos de segundo semestre en adelante, promedio de calificaciones individuales por materia del primer año cursado.","ACADEMIC_PERFORMANCE_FIRST_YEAR_FACTOR_NAME":"Rendimiento académico en primer año","ACADEMIC_PERFORMANCE_TREND_FACTOR_DESCRIPTION":"Tendencia en el promedio de notas de los periodos históricos del estudiante.","ACADEMIC_PERFORMANCE_TREND_FACTOR_NAME":"Tendencia de promedio de notas","ACCIONES_RAPIDAS":"Acciones Rápidas","ACTIVE_CAREERS_IN_PERIOD_FACTOR_DESCRIPTION":"Cantidad de carreras activas en periodo académico actual.","ACTIVE_CAREERS_IN_PERIOD_FACTOR_NAME":"Carreras activas en periodo académico","ADMIN_CARRERA":"Carrera","ADMISSION_TYPE_FACTOR_DESCRIPTION":"Tipo de admisión (Examen ordinario, admisión especial, traslado interno, etc)","ADMISSION_TYPE_FACTOR_NAME":"Tipo de admisión","AGE_AT_ADMISSION_FACTOR_DESCRIPTION":"Edad del alumno al ingresar a la institución. Relevante por nivel de madurez durante primer año, que corresponde al de mayor riesgo.","AGE_AT_ADMISSION_FACTOR_NAME":"Edad de ingreso a la institución","AGE_AT_PREDICTION_FACTOR_DESCRIPTION":"Edad del alumno en el momento de la predicción.","AGE_AT_PREDICTION_FACTOR_NAME":"Edad al tiempo de predicción","ALERTAS_ALUMNOS_RIESGO":"Porcentaje de alumnos en riesgo","ALERTAS_ESTUDIANTES_SUBHEADING":"Estudiantes activos en la Carrera","ALERTAS_EVOLUCION_DESERCION":"Evolución de estados históricos de los estudiantes","ALERTAS_EVOLUCION_RAZONES_DESERCION":"Razones de deserción","ALERTAS_EVOLUCION_SUBHEADING":"Últimos @year semestres regulares","ALERTAS_GROUPALES_FACTOR":"FACTOR","ALERTAS_GROUPALES_HEADER1":"Alertas Grupales","ALERTAS_GRUPALES":"Alertas Grupales","ALERTAS_INDIVIDUAL_CAMPUS":"Campus","ALERTAS_INDIVIDUAL_CARRER":"Carrera","ALERTAS_INDIVIDUAL_COHOR":"Cohorte","ALERTAS_INDIVIDUAL_CORDIGO":"Código de alumno","ALERTAS_INDIVIDUAL_EDAD":"Edad","ALERTAS_INDIVIDUAL_FICHA":"Ficha","ALERTAS_INDIVIDUAL_FICHA_BUTTON":"Ver Ficha","ALERTAS_INDIVIDUAL_HEADLINE1":"Alertas Individuales","ALERTAS_INDIVIDUAL_INDEX":"Índice","ALERTAS_INDIVIDUAL_MODALIDAD":"Modalidad","ALERTAS_INDIVIDUAL_NAME":"Nombre","ALERTAS_INDIVIDUAL_RIESGO":"Riesgo","ALERTAS_INDIVIDUAL_SEXO":"Sexo","ALERTAS_INDIVIDUAL_SUBHEADLINE1":"Alumnos en riesgo","ALERTAS_INDIVIDUAL_TELEPHONE":"Telefonos","ALERTAS_INDIVIDUALES":"Alertas Individuales","ALERTAS_NIVEL_DE_RIESGO_MAIN_HEADING":"Nivel de riesgo de deserción según cohorte de ingreso","ALERTAS_NUMERO_ALUMNOS_RIESGO":"Número de alumnos en riesgo","ALUMNO_DESERTADO":"Alumno ha desertado","ALUMNOS_RIESGO":"Alumnos en riesgo","ANALISIS":"Análisis","ANALISIS_EXPORTAR_DATOS":"Exportar datos","ANALISIS_HEADER":"Análisis","ANNO_INGRESO":"Año de ingreso","AUTOR":"Autor","AVERAGE_CREDITS_SEMESTER_FACTOR_DESCRIPTION":"Cantidad promedio de créditos cursados cada semestre regular.","AVERAGE_CREDITS_SEMESTER_FACTOR_NAME":"Número de créditos promedio cursadas por periodo académico","AVERAGE_HIGH_SCHOOL_GRADES_FACTOR_DESCRIPTION":"Calificación promedio obtenida por el estudiante en sus estudios de educación secundaria (escuela).","AVERAGE_HIGH_SCHOOL_GRADES_FACTOR_NAME":"Promedio de notas en educación secundaria","AVERAGE_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, en escala porcentual, el promedio de notas obtenido por el alumno durante el periodo académico.","AVERAGE_PARTIAL_GRADE_FACTOR_NAME":"Promedio de notas parciales","BIENVENIDO":"¡Bienvenido a u-retention!","BITACORA_CONTACTOS":"Bitácora de contactos","BUSCAR_FACTOR":"Buscar un factor","CALIBRACION_MODELO":"Calibración del Modelo","CARGA_DATOS":"Carga de Datos","CARRERAS":"Carreras","CHILDRENS_INDICATOR_FACTOR_DESCRIPTION":"Estudiante posee hijos. Relevante por presión económica, efecto sobre resultados académicos, entre otros.","CHILDRENS_INDICATOR_FACTOR_NAME":"Estudiante tiene hijos","CODIGO_ALUMNO":"Código de alumno","CONT_FRACC_COL":"Conteo como Fracción de las Columnas","CONT_FRACC_FILAS":"Conteo como Fracción de las Filas","CONT_FRACC_TOTAL":"Conteo como Fracción del Total","CONT_VALORES_UNICOS":"Conteo de Valores Únicos","CONTEO":"Conteo","CORREO":"Correo","CREDIT_INDICATOR_FACTOR_DESCRIPTION":"Alumno cuenta con créditos particulares de la banca o de entidades del Estado.","CREDIT_INDICATOR_FACTOR_NAME":"Alumno posee crédito","CREDIT_PERCENTAGE_FACTOR_DESCRIPTION":"Porcentaje de crédito otorgado por banca o entidades del estado, en caso que alumno posea crédito.","CREDIT_PERCENTAGE_FACTOR_NAME":"Porcentaje de crédito","CUMULATIVE_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Promedio acumulado de asistencia a clases en el total de los periodos académicos cursados.","CUMULATIVE_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentaje de asistencia a clases acumulativo","CUMULATIVE_COURSES_FAILED_ONCE_FACTOR_DESCRIPTION":"Cantidad total de cursos que el estudiante ha reprobado la primera vez que los ha inscrito","CUMULATIVE_COURSES_FAILED_ONCE_FACTOR_NAME":"Total de cursos reprobados en la primera instancia","CUMULATIVE_COURSES_FAILED_THRICE_FACTOR_DESCRIPTION":"Cantidad total de cursos que el estudiante ha reprobado la tercera vez que los ha inscrito","CUMULATIVE_COURSES_FAILED_THRICE_FACTOR_NAME":"Total de cursos reprobados en la tercera instancia","CUMULATIVE_COURSES_FAILED_TWICE_FACTOR_DESCRIPTION":"Cantidad total de cursos que el estudiante ha reprobado la segunda vez que los ha inscrito","CUMULATIVE_COURSES_FAILED_TWICE_FACTOR_NAME":"Total de cursos reprobados en la segunda instancia","CUMULATIVE_NUMBER_NEGATIVE_CONTACTS_FACTOR_DESCRIPTION":"Cantidad total de veces que se ha contactado al estudiante con resultado negativo.","CUMULATIVE_NUMBER_NEGATIVE_CONTACTS_FACTOR_NAME":"Número de contactos con resultado negativo","CUMULATIVE_NUMBER_OF_STATES_AB_FACTOR_DESCRIPTION":"Cantidad de veces que el estudiante tiene un estado de abandono en periodos anteriores","CUMULATIVE_NUMBER_OF_STATES_AB_FACTOR_NAME":"Número de abandonos previos","CUMULATIVE_NUMBER_OF_STATES_RE_FACTOR_DESCRIPTION":"Cantidad de veces que el estudiante tiene un estado de reserva en periodos anteriores","CUMULATIVE_NUMBER_OF_STATES_RE_FACTOR_NAME":"Número de reservas previos","CUMULATIVE_NUMBER_POSITIVE_CONTACTS_FACTOR_DESCRIPTION":"Cantidad total de veces que se ha contactado al estudiante con resultado positivo.","CUMULATIVE_NUMBER_POSITIVE_CONTACTS_FACTOR_NAME":"Número de contactos con resultado positivo","CUMULATIVE_PAST_ACADEMIC_PERFORMANCE_FACTOR_DESCRIPTION":"Promedio de notas acumulado de periodos académicos anteriores del estudiante.","CUMULATIVE_PAST_ACADEMIC_PERFORMANCE_FACTOR_NAME":"Rendimiento académico acumulado de periodos académicos anteriores","CUMULATIVE_PAST_DESERTION_STATUSES_FACTOR_DESCRIPTION":"Cantidad total acumulada de estados de deserción en periodos anteriores.","CUMULATIVE_PAST_DESERTION_STATUSES_FACTOR_NAME":"Total de estados de deserción anteriores","CUMULATIVE_TOTAL_CONTACTS_FACTOR_DESCRIPTION":"Cantidad total de veces que el estudiante ha sido contactado por la institución.","CUMULATIVE_TOTAL_CONTACTS_FACTOR_NAME":"Número total de contactos acumulativo","CURRENT_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Promedio de los porcentajes de asistencia a clases de las asignaturas que está cursando.","CURRENT_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentaje de asistencia a clases","CURRENT_MIN_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"El menor de los porcentajes de asistencia entre todos las asignaturas que está cursando.","CURRENT_MIN_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentaje mínimo de asistencia a clases","DATOS_DE_CONTACTO":"Datos de contacto","DESCRIPCION":"Descripción","DESERTED_CAREERS_IN_PERIOD_FACTOR_DESCRIPTION":"Cantidad de carreras desertadas en periodo académico actual.","DESERTED_CAREERS_IN_PERIOD_FACTOR_NAME":"Carreras desertadas en periodo académico","DESV_ESTAND_MUESTRA":"Desviación Estándas de la Muestra","DIAGNOSTIC_EXAM_SCORE_FACTOR_DESCRIPTION":"Calificaciones en evaluaciones destinadas a medir nivel verbal y matemático de alumnos por parte de la propia institución.","DIAGNOSTIC_EXAM_SCORE_FACTOR_NAME":"Resultado de pruebas de diagnóstico","DIRECCION":"Dirección","DISPERSITY_AVERAGE_CREDITS_FACTOR_DESCRIPTION":"","DISPERSITY_AVERAGE_CREDITS_FACTOR_NAME":"","DISPERSITY_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Variación (dispersión) observada en las notas parciales del estudiante.","DISPERSITY_PARTIAL_GRADE_FACTOR_NAME":"Variación en las notas parciales","DOWNLOAD_ACTIVE_REPORTS":"Reporte Datos Activos","EDAD":"Edad","ENTRY_EXAM_SCORE_FACTOR_DESCRIPTION":"Calificación obtenida en la evaluación particular para el ingreso a la institución, en caso de existir.","ENTRY_EXAM_SCORE_FACTOR_NAME":"Resultado en el examen de ingreso","ENUMERAR_VALORES_UNICOS":"Enumerar Valores Únicos","ESCRIBA_OBSERVACION":"Escriba su observación...","ESTUDIANTES_ACTIVOS_CARRERA":"Estudiantes activos en la Carrera","EVOLUCION_ESTADOS_HIST_ESTUD":"Evolución de estados históricos de los estudiantes","EXPECTATIONS_CAREER_FACTOR_DESCRIPTION":"Relación entre lo que el alumno esperaba obtener versus lo que está efectivamente viviendo, tanto en función de la carrera elegida como de la Institución.","EXPECTATIONS_CAREER_FACTOR_NAME":"Evaluación de expectativas","EXPORT_FILTERED_DATA":"Exportar datos filtrados","EXPORTAR_DATOS":"Exportar datos","EXPORTAR_TSV":"Exportar TSV","EXTRACURRICULAR_ACTIVITIES_PARTICIPATION_INDICATOR_FACTOR_DESCRIPTION":"Alumno participa o no de actividades sin efectos en créditos, como fiestas universitarias, paseos, entre otros.","EXTRACURRICULAR_ACTIVITIES_PARTICIPATION_INDICATOR_FACTOR_NAME":"Participación en actividades extraprogramáticas","FACTOR":"Factor","FACTORES_INCIDENTES_PRINCIPALES":"Factores incidentes principales","FALSOS_NEGATIVOS":"Falsos negativos","FALSOS_POSITIVOS":"Falsos positivos","FAMILY_ENVIROMENT_FACTOR_DESCRIPTION":"Tipo de grupo familiar base, padre/madre presentes, abuelos como figura principal.","FAMILY_ENVIROMENT_FACTOR_NAME":"Entorno familiar","FAMILY_GROUP_QUINTILE_FACTOR_DESCRIPTION":"Nivel socioeconómico de origen del alumno según la calificación de cada país.","FAMILY_GROUP_QUINTILE_FACTOR_NAME":"Estrato socioeconómico","FAMILY_INCOME_FACTOR_DESCRIPTION":"Ingresos totales del grupo familiar.","FAMILY_INCOME_FACTOR_NAME":"Ingresos familiares","FAMILY_OUTCOME_FACTOR_DESCRIPTION":"Monto total destinado a egresos del grupo familiar.","FAMILY_OUTCOME_FACTOR_NAME":"Egresos familiares","FATHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_DESCRIPTION":"Indica si el padre ha realizado estudios superiores. Permite detectar estudiantes de primera generación.","FATHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_NAME":"Padre posee educación superior","FATHER_HAS_WORK_FACTOR_DESCRIPTION":"Indica si el padre trabaja. Interesa saber en particular si el grupo familiar tiene sustento estable.","FATHER_HAS_WORK_FACTOR_NAME":"Padre tiene trabajo","FECHA":"Fecha","FECHA_CALIBRACION_MODELO":"Fecha Calibración del Modelo","FECHA_CARGA":"Fecha de carga","FICHA":"Ficha","FICHA_AURTHOR":"Autor","FICHA_BITACORA_CONTACTOS":"Bitácora de contactos","FICHA_COHORTE":"Cohorte","FICHA_CORREO":"Correo","FICHA_DATOS_DE_CONTACTO":"Datos de contacto","FICHA_DESCRIPTION":"Descripción","FICHA_DIRECTION":"Dirección","FICHA_FACTOR":"Factor","FICHA_FACTORES_INCIDENTES":"Factores incidentes principales","FICHA_OBSERVATION":"Observación","FICHA_OPERACION_DESERTADO":"Alumno ha desertado","FICHA_OPERACION_MANUALES":"Operaciones Manuales","FICHA_OPERACION_RIESGO":"Marcar 'En Riesgo'","FICHA_PROBABILIDAD":"Probabilidad histórica","FICHA_REGISTER_BUTTON":"Registrar","FICHA_REGISTER_OBSERVATION":"Registro de Observaciones","FICHA_TABLE_FICHA":"Fecha","FICHA_TELEFONO":"Teléfono","FICHA_VALUE":"Valor","FICHA_VOLVER_ALERTAS_INDIVIDUAL":"Volver a Alertas Individuales","FIRST_HIGH_EDUCATION_STUDENT_IN_FAMILY_FACTOR_DESCRIPTION":"Indica si el estudiante pertenece a la primera generación de su familia en realizar estudios superiores.","FIRST_HIGH_EDUCATION_STUDENT_IN_FAMILY_FACTOR_NAME":"Primera generación","FIRST_YEAR_STUDENT_FACTOR_DESCRIPTION":"Indica si el estudiante se encuentra cursando su primer año en la institución.","FIRST_YEAR_STUDENT_FACTOR_NAME":"Estudiante de primer año","GRAFICO_BARRAS_API_HOR":"Gráfico de Barras Aplidadas Horizontales","GRAFICO_BARRAS_HOR":"Gráfico de Barras Horizontales","GRAFICO_DE_AREA":"Gráfico de Área","GRAFICO_DE_BARRAS":"Gráfico de Barras","GRAFICO_DE_BARRAS_APILADAS":"Gráfico de Barras Apiladas","GRAFICO_DE_DISPERCION":"Gráfico de Disperción","GRAFICO_DE_LINEA":"Gráfico de Línea","HEALTH_PROBLEMS_INDICATOR_FACTOR_DESCRIPTION":"Estudiante presenta problemas de salud. Un alumno con problemas graves de salud puede verse impedido de continuar sus estudios.","HEALTH_PROBLEMS_INDICATOR_FACTOR_NAME":"Problemas de salud","HIGH_RISK":"Riesgo alto","HIGHEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, en escala porcentual, la nota más alta obtenida por el alumno durante el periodo académico.","HIGHEST_PARTIAL_GRADE_FACTOR_NAME":"Nota parcial más alta","HISTORICAL_MIN_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"El menor de los porcentajes de asistencia entre todas las asignaturas que ha tomado el estudiante dentro de su plan de estudios.","HISTORICAL_MIN_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentaje mínimo histórico de asistencia a clases","IMPORTANCIA":"Importancia","INCIDENCIA":"Incidencia","INCOMPATIBILITY_WITH_EXTRACURRICULAR_ACTIVITIES_FACTOR_DESCRIPTION":"El alumno sólo tiene tiempo disponible para sus clases, pero no puede asistir a sesiones de apoyo o actividades anexas, normalmente por trabajo o cuidado de hijos, entre otros. Relevante en relación a Integración.","INCOMPATIBILITY_WITH_EXTRACURRICULAR_ACTIVITIES_FACTOR_NAME":"Incompatibilidad horaria con actividades extra curriculares","INDICATOR":"Indicador","INDICE":"Índice","INICIO":"Inicio","INPUTS_MODELO":"Inputs del modelo","INSTITUTIONAL_CONDITIONS_FACTOR_DESCRIPTION":"Problemas o condiciones especiales que la Institución pueda estar teniendo en el periodo de medición y que haya tenido anteriormente, como problemas de infraestructura, conflictos de la comunidad académica, entre otros.","INSTITUTIONAL_CONDITIONS_FACTOR_NAME":"Condiciones institucionales","INSTITUTIONAL_INDICATORS":"Indicadores Institucionales","INTEGRATION_FACTOR_DESCRIPTION":"Percepción de pertenencia a la institución, al grupo humano y a la situación en general. Relevante en particular para grupo de alto riesgo (primera generación, bajos recursos).","INTEGRATION_FACTOR_NAME":"Integración","LAST_PERIOD_ACADEMIC_PERFORMANCE_FACTOR_DESCRIPTION":"Promedio de notas del periodo anterior del estudiante.","LAST_PERIOD_ACADEMIC_PERFORMANCE_FACTOR_NAME":"Promedio de notas del periodo anterior","LATEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, en escala porcentual, la última nota obtenida por el alumno durante el periodo académico.","LATEST_PARTIAL_GRADE_FACTOR_NAME":"Última nota parcial","LEVEL_OF_ECONOMIC_DEPENDENCE_FACTOR_DESCRIPTION":"Alumno depende de grupo familiar para subsistencia o paga con su trabajo arriendo, comida, etc.","LEVEL_OF_ECONOMIC_DEPENDENCE_FACTOR_NAME":"Nivel de dependencia económica","LIBRARY_ACCESSES_FACTOR_DESCRIPTION":"Número y frecuencia de obtención de libros físicos o recursos digitales desde biblioteca como medida de engagement y momentum académico.","LIBRARY_ACCESSES_FACTOR_NAME":"Interacciones en biblioteca","LIVE_WITH_PARENTS_FACTOR_DESCRIPTION":"Relacionado con el grado de independencia del estudiante.","LIVE_WITH_PARENTS_FACTOR_NAME":"Vive con los padres durante periodo académico","LMS_AVERAGE_ACCESSES_FACTOR_DESCRIPTION":"Historial de acceso a los cursos en línea de la Institución, para medir engagement, momentum académico y variaciones en la frecuencia y tipo de uso.","LMS_AVERAGE_ACCESSES_FACTOR_NAME":"Accesos promedio a LMS","LOW_RISK":"Riesgo bajo","LOWEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, en escala porcentual, la nota más baja obtenida por el alumno durante el periodo académico.","LOWEST_PARTIAL_GRADE_FACTOR_NAME":"Nota parcial más baja","MACROECONOMIC_ENVIROMENT_FACTOR_DESCRIPTION":"Situaciones particulares macroeconómicas que puedan afectar a los alumnos como grupo: recesiones, emergencias a escala regional.","MACROECONOMIC_ENVIROMENT_FACTOR_NAME":"Entorno macroeconómico del país","MAPA_DE_CALOR":"Mapa de Calor","MAPA_DE_CALOR_COL":"Mapa de Calor por Columna","MAPA_DE_CALOR_FILA":"Mapa de Calor por Fila","MARCAR_RIESGO":"Marcar 'en riesgo'","MAX_FAILING_GRADE_FACTOR_DESCRIPTION":"Nota final máxima obtenida en una asignatura reprobada en la historia del estudiante.","MAX_FAILING_GRADE_FACTOR_NAME":"Nota final máxima en una asignatura reprobada","MAX_FINAL_GRADE_FACTOR_DESCRIPTION":"Nota final máxima obtenida en una asignatura en la historia del estudiante.","MAX_FINAL_GRADE_FACTOR_NAME":"Nota final máxima en una asignatura","MAXIMO":"Máximo","MEDIA":"Media","MEDIO_CONTACTO":"Medio de contacto","MEDIUM_RISK":"Riesgo medio","MENU1":"Carga de Datos","MENU2":"Calibración de Modelo","MENU3":"Alertas Individuales","MENU4":"Alertas Grupales","MENU5":"Tabla Dinámica","MENU6":"Reporte de Datos Cargados","MENU7":"Reportes de u-retention","MIN_FINAL_GRADE_FACTOR_DESCRIPTION":"Nota final mínima obtenida en una asignatura en la historia del estudiante.","MIN_FINAL_GRADE_FACTOR_NAME":"Nota final mínima en una asignatura","MIN_PASSING_GRADE_FACTOR_DESCRIPTION":"Nota final mínima obtenida en una asignatura aprobada en la historia del estudiante.","MIN_PASSING_GRADE_FACTOR_NAME":"Nota final mínima en una asignatura aprobada","MINDSET_FACTOR_DESCRIPTION":"Idea personal sobre el origen de los talentos, categorizado como 'mentalidad fija' o 'mentalidad de crecimiento'.","MINDSET_FACTOR_NAME":"Mentalidad","MINIMO":"Mínimo","MODEL_RETENTION":"Modelo u-retention","MOTHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_DESCRIPTION":"Indica si la madre ha realizado estudios superiores. Permite detectar estudiantes de primera generación.","MOTHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_NAME":"Madre posee educación superior","MOTHER_HAS_WORK_FACTOR_DESCRIPTION":"Indica si la madre trabaja. Interesa saber en particular si el grupo familiar tiene sustento estable.","MOTHER_HAS_WORK_FACTOR_NAME":"Madre tiene trabajo","NIVEL_RIESGO_DESERCION_COHORTE":"Nivel de riesgo de deserción según cohorte de ingreso","NOMBRE":"Nombre","NOMINATION_PREFERENCE_NUMBER_FACTOR_DESCRIPTION":"Lugar de preferencia de la carrera e institución actual en la lista de preferencias del alumno (oficiales reportadas o declaradas). Relevante para nivel de satisfacción e integración.","NOMINATION_PREFERENCE_NUMBER_FACTOR_NAME":"Preferencia en postulación","NON_REGULAR_PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Número de periodos no regulares en la institución, como por ejemplo los semestres de verano.","NON_REGULAR_PERIODS_IN_INSTITUTION_FACTOR_NAME":"Cantidad de Periodos no Regulares","NUMBER_COURSES_TAKEN_IN_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Total de cursos inscritos por el estudiante en el periodo académico.","NUMBER_COURSES_TAKEN_IN_ACADEMIC_PERIOD_FACTOR_NAME":"Cursos tomados en periodo académico","NUMBER_COURSES_TAKEN_IN_PAST_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Total acumulado de cursos inscritos por el estudiante en periodos académicos anteriores.","NUMBER_COURSES_TAKEN_IN_PAST_ACADEMIC_PERIOD_FACTOR_NAME":"Cursos tomados en periodo académicos anteriores","NUMBER_FAILED_COURSES_IN_PAST_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Total acumulado de cursos reprobados por el estudiante en periodos académicos anteriores.","NUMBER_FAILED_COURSES_IN_PAST_ACADEMIC_PERIOD_FACTOR_NAME":"Cursos reprobados en periodo académicos anteriores","NUMBER_NEGATIVE_CONTACTS_FACTOR_DESCRIPTION":"Cantidad de veces que se ha contactado al estudiante con resultado negativo durante el último semestre.","NUMBER_NEGATIVE_CONTACTS_FACTOR_NAME":"Número de contactos con resultado negativo en el último periodo académico","NUMBER_OF_DEPENDENTS_FACTOR_DESCRIPTION":"Alumno tiene personas a cargo económicamente: hijos, su grupo familiar, etc. Interesa saber rango de cantidades de dinero que entrega, o al menos si tiene dependientes.","NUMBER_OF_DEPENDENTS_FACTOR_NAME":"Personas a cargo","NUMBER_OF_SIBLINGS_FACTOR_DESCRIPTION":"Cantidad de hermanos que posee el estudiante.","NUMBER_OF_SIBLINGS_FACTOR_NAME":"Número de hermanos","NUMBER_POSITIVE_CONTACTS_FACTOR_DESCRIPTION":"Cantidad de veces que se ha contactado al estudiante con resultado positivo durante el último semestre.","NUMBER_POSITIVE_CONTACTS_FACTOR_NAME":"Número de contactos con resultado positivo en el último periodo académico","NUMBER_QUOTA_PAYMENTS_FACTOR_DESCRIPTION":"Cantidad de cuotas pagadas por el estudiante.","NUMBER_QUOTA_PAYMENTS_FACTOR_NAME":"Número de pagos de cuotas","NUMBER_TUITION_PAYMENTS_FACTOR_DESCRIPTION":"Cantidad de pagos realizados por el estudiante por concepto de matrícula.","NUMBER_TUITION_PAYMENTS_FACTOR_NAME":"Número de pagos de matrícula","NUMERO_ALUMNOS":"Número de estudiantes","NUMERO_ALUMNOS_ACTIVOS":"Número de alumnos activos","NUMERO_ALUMNOS_HISTORICOS":"Número de alumnos históricos","NUMERO_ALUMNOS_RIESGO":"Número de alumnos en riesgo","OBSERVACION":"Observación","OPERACION_MANUALES":"Operaciones Manuales","ORIGIN_SCHOOL_TYPE_FACTOR_DESCRIPTION":"Escuela pública, privada, de recuperación de educación adulta, entre otras.","ORIGIN_SCHOOL_TYPE_FACTOR_NAME":"Tipo de escuela de origen","OUTLIERS":"Outliers","PER_CAPITA_INCOME_FACTOR_DESCRIPTION":"Ingresos totales del grupo familiar divididos por la cantidad de miembros que dependen de dichos ingresos, incluyendo al alumno.","PER_CAPITA_INCOME_FACTOR_NAME":"Ingreso per cápita familiar","PER_CAPITA_OUTCOME_FACTOR_DESCRIPTION":"Gastos totales del grupo familiar divididos por la cantidad de miembros que dependen de dichos ingresos, incluyendo al alumno.","PER_CAPITA_OUTCOME_FACTOR_NAME":"Egreso per cápita familiar","PERCENTAGE_APPROVED_CREDITS_IN_STUDY_PLAN_FACTOR_DESCRIPTION":"Porcentaje de créditos aprobados por el alumno respecto al total de créditos del plan de estudios.","PERCENTAGE_APPROVED_CREDITS_IN_STUDY_PLAN_FACTOR_NAME":"Porcentaje de créditos aprobados del plan de estudios","PERCENTAGE_APPROVED_CREDITS_ON_FIRST_YEAR_FACTOR_DESCRIPTION":"Porcentaje de créditos aprobados por el alumno respecto al total de créditos inscritos en primer año.","PERCENTAGE_APPROVED_CREDITS_ON_FIRST_YEAR_FACTOR_NAME":"Porcentaje de créditos aprobados en el primer año académico","PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Cantidad de periodos académicos que el estudiante ha estado en la institución en la carrera actual. El riesgo de deserción es alto para un número bajo de periodos de pertenencia o para valores extremadamente altos.","PERIODS_IN_INSTITUTION_FACTOR_NAME":"Número de periodos en la institución","PHYSICAL_RESOURCE_USAGE_FACTOR_DESCRIPTION":"Número de recursos físicos utilizados por el alumno durante el periodo académico","PHYSICAL_RESOURCE_USAGE_FACTOR_NAME":"Utilización de Recusos Fisicos","PLAN_ESTADO_ACTUAL":"Plan de estudio y estado actual","PORCENT_ALUMNOS_RIESGO":"Porcentaje de alumnos en riesgo","PREGNANCY_INDICATOR_FACTOR_DESCRIPTION":"Embarazo de alumna o de su pareja. Relevante por presión económica, efecto sobre resultados académicos, entre otros.","PREGNANCY_INDICATOR_FACTOR_NAME":"Embarazo","PREGRADO":"Pregrado","PREVIOUS_ACADEMIC_EXPERIENCE_INDICATOR_FACTOR_DESCRIPTION":"El estudiante ha realizado estudios superiores con anterioridad.","PREVIOUS_ACADEMIC_EXPERIENCE_INDICATOR_FACTOR_NAME":"Experiencia académica anterior","PREVIOUSLY_FAILED_COURSES_TAKEN_IN_SEMESTER_FACTOR_DESCRIPTION":"Número de asignaturas inscritas por el estudiante en periodo académico en curso, que han sido reprobadas por el estudiante con anterioridad.","PREVIOUSLY_FAILED_COURSES_TAKEN_IN_SEMESTER_FACTOR_NAME":"Numero de cursos inscritos en periodo académico que han sido reprobados previamente","PRIMERO":"Primero","PROBABILIDAD_DESERCION":"Probabilidad de deserción","PROBABILIDAD_HISTORICA":"Riesgo histórico","PROGRAM_EVALUATION_FACTOR_DESCRIPTION":"Opinión del alumno sobre calidad entregada por la Institución y el programa en particular, en términos de servicio (aparte de vocación).","PROGRAM_EVALUATION_FACTOR_NAME":"Opinión sobre el programa cursado","PSYCHOLOGICAL_HELP_INDICATOR_FACTOR_DESCRIPTION":"Estudiante ha requerido apoyo psicológico durante su estadía en la institución.","PSYCHOLOGICAL_HELP_INDICATOR_FACTOR_NAME":"Ayuda psicológica","RAZONES_DESERCION":"Razones de deserción","REG_INCOMPLETOS":"Registros Incompletos","REGISTRAR":"Registrar","REGISTRO_OBSERVACIONES":"Registro de Observaciones","REGULAR_PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Número de periodos regulares en la institución. Esto no incluye, por ejemplo, semestres de verano.","REGULAR_PERIODS_IN_INSTITUTION_FACTOR_NAME":"Cantidad de Periodos Regulares","REP_DATOS_CARGADOS":"Reporte de Datos Cargados","REP_RETENTION":"Reportes de u-retention","RESULTADO_CALIBRACION":"Resultado de calibración","RESULTADO_CARGA_DATOS":"Resultado de carga de datos","RESULTADO_CONTACTO":"Resultado del contacto","RIESGO":"Riesgo","RISK_PROFILE":"Perfil de Riesgo","SCHOLARSHIP_INDICATOR_FACTOR_DESCRIPTION":"Identificación del tipo de apoyo de beca que el alumno tiene, de manera de poder agrupar estudiantes similares.","SCHOLARSHIP_INDICATOR_FACTOR_NAME":"Alumno posee beca","SCHOLARSHIP_PERCENTAGE_FACTOR_DESCRIPTION":"Porcentaje de beca que ha sido asignado al alumno, en caso que posea beca.","SCHOLARSHIP_PERCENTAGE_FACTOR_NAME":"Porcentaje de beca","SEGUIR_ESTUDIANTE":"Seguimiento de estudiantes","SELECT_SUBMODEL_CARREER":"Seleccionar submodelo - carrera","SELECTION_EXAM_SCORE_FACTOR_DESCRIPTION":"Calificación obtenida en los exámenes de selección de ingreso a la universidad.","SELECTION_EXAM_SCORE_FACTOR_NAME":"Resultados en exámenes de selección","SEX_FACTOR_DESCRIPTION":"Relevante puesto que resultados de estudios muestran diferencias en indices de permanencia por género.","SEX_FACTOR_NAME":"Sexo","SEXO":"Sexo","SHOW_ALL_INSTITUTIONAL_INDICATORS":"Mostrar todos los indicadores institucionales","SHOW_TRACKED_STUDENTS":"Mostrar estudiantes en seguimiento","SIBLING_POSITION_FACTOR_DESCRIPTION":"Número de posición entre sus hermanos, si los tiene.","SIBLING_POSITION_FACTOR_NAME":"Posición entre hermanos","SPECIAL_ADMISSION_FACTOR_DESCRIPTION":"Indica si, de acuerdo a los registros de la institución, el alumno ha ingresado a una carrera en un nivel distinto al inicial.","SPECIAL_ADMISSION_FACTOR_NAME":"Ingreso en nivel superior","STARTING_SEMESTER_FACTOR_DESCRIPTION":"Semestre en el cual ingresa el estudiante a la institución.","STARTING_SEMESTER_FACTOR_NAME":"Semestre de Ingreso","STOP_TRACKING":"Dejar de seguir","STUDENT_DETAILS":"Detalle de estudiante","STUDENT_DOESNT_HAVE_INDICATORS":"El estudiante no posee indicadores","STUDENT_FROM_ANOTHER_CITY_FACTOR_DESCRIPTION":"Se registra en la literatura y en el análisis de múltiples instituciones el efecto del cambio de ciudad, con la consiguiente pérdida de redes de apoyo y el desafío adicional de acostumbramiento al nuevo ambiente.","STUDENT_FROM_ANOTHER_CITY_FACTOR_NAME":"Alumno proviene de otra ciudad","STUDENT_IS_SINGLE_FACTOR_DESCRIPTION":"Tiene relevancia por red de apoyo y nivel de responsabilidades fuera de los estudios.","STUDENT_IS_SINGLE_FACTOR_NAME":"Estudiante es soltero","STUDENT_WORKS_INDICATOR_FACTOR_DESCRIPTION":"Estudiante trabaja o se dedica completamente a los estudios.","STUDENT_WORKS_INDICATOR_FACTOR_NAME":"Situación laboral del estudiante","STUDY_HABITS_FACTOR_DESCRIPTION":"Alumno estudia sólo o en grupo. Uso de LMS (Learning management system) como apoyo, obtención de libros de biblioteca.","STUDY_HABITS_FACTOR_NAME":"Métodos de estudio","SUBMODEL":"Submodelo Institucional","SUBMODEL_CONFIG":"Configuración del submodelo","SUM_ENTERA":"Suma Entera","SUM_FRACC_COL":"Suma como Fracción de las Columnas","SUM_FRACC_FILAS":"Suma como Fracción de las Filas","SUM_FRACC_TOTAL":"Suma como Fracción del Total","SUM_SOBR_SUM":"Suma sobre Suma","SUMA":"Suma","TABLA":"Tabla","TABLA_DINAMICA":"Tabla Dinámica","TABLA_GRAFICO_BARRAS":"Tabla con Gráfico de Barras","TELEFONO":"Teléfono","TELEFONOS":"Telefonos","TIME_BETWEEN_SCHOOL_GRADUATION_AND_HIGHER_EDUCATION_ENTRANCE_FACTOR_DESCRIPTION":"Cantidad de años entre que el alumno terminó educación escolar e ingresó a la educación superior.","TIME_BETWEEN_SCHOOL_GRADUATION_AND_HIGHER_EDUCATION_ENTRANCE_FACTOR_NAME":"Tiempo entre egreso educación escolar e ingreso a educación superior","TOTAL_CONTACTS_FACTOR_DESCRIPTION":"Cantidad total de veces que el estudiante ha sido contactado por la institución en el periodo académico en curso.","TOTAL_CONTACTS_FACTOR_NAME":"Número total de contactos en el periodo académico actual","TOTAL_CREDITS_FIRST_YEAR_FACTOR_DESCRIPTION":"Cantidad de créditos cursados el primer año.","TOTAL_CREDITS_FIRST_YEAR_FACTOR_NAME":"Número de créditos cursados en el primer año académico","TOTAL_CREDITS_SEMESTER_FACTOR_DESCRIPTION":"Cantidad total de créditos inscritos en el periodo académico.","TOTAL_CREDITS_SEMESTER_FACTOR_NAME":"Total de créditos en el periodo académico","TOTAL_REGISTROS_PRUEBA":"Total de registros de prueba","TRACK":"Seguir","TRACK_STUDENT":"Seguir estudiante","TREEMAP":"Treemap","TREND_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Tendencia observada en las notas (positiva, negativa o neutra).","TREND_PARTIAL_GRADE_FACTOR_NAME":"Tendencia de notas parciales","U_RETENTION":"u-retention","ULTIMO":"Último","ULTIMOS_X_SEMESTRES_REG":"Últimos @year semestres regulares","VALOR":"Valor","VAR_DE_MUESTRA":"Varianza de la Muestra","VARIABILIDAD":"Variabilidad","VER_FICHA":"Ver Ficha","VOCATIONAL_CAREER_RELATIONSHIP_INDICATOR_FACTOR_DESCRIPTION":"Carrera que el alumno cursa versus la que declara como su vocación, en caso de tenerla.","VOCATIONAL_CAREER_RELATIONSHIP_INDICATOR_FACTOR_NAME":"Relación vocación/carrera cursada","VOLVER_ALERTAS_INDIVIDUAL":"Volver a Alertas Individuales","ACADEMIC_CALENDAR_DETAIL":"Detalle de calendario académico","ACADEMIC_PLAN":"Plan académico","ACADEMIC_UNIT":"Unidad académica","ACCEPT":"Aceptar","ACTIONS":"Acciones","ACTIVATE":"Activar","ACTIVATE_DEACTIVATE":"Activar/Inactivar","ACTIVE":"Activo","ACTIVITY":"Actividad","ACTIVITY_NAME":"Actividad","ACTIVITY_TYPE":"Tipo de actividad","ADD_CANDIDATE":"Añadir candidato","ADDED_CANDIDATES":"Candidatos añadidos","ADDRESS":"Dirección","ADVANCED_OPTIONS":"Opciones avanzadas","ADVANCED_SEARCH":"Busqueda avanzada","AGENDA":"Agenda","ALL":"Todos los","ALL_THE":"Todos los","AMOUNT_DESTINY":"Cantidad destino","AMOUNT_ORIGIN":"Cantidad origen","ANONYMOUS":"Anónimo","API_VERSION":"Versión API","APPROVE":"Aprobar","Apr":"Abr","April":"Abril","ASIGNATURE":"Curso","ASK_FOR_CONTINUE":"¿Esta seguro de continuar?","ASSIGNATION_CODE":"Código de asignación","ASSIGNATION_SCHEDULE_ROOM":"Asignación de horario y sala","ATTACHED_FILES":"Archivos adjuntos","ATTACHED_TO":"Adjunto a","ATTENDANCE_QUESTION":"¿Asistencia?","Aug":"Ago","August":"Agosto","AUTHOR":"Autor","AVERAGE":"Promedio","BACK":"Atrás","BATCH_UPLOAD":"Carga masiva","BLOCKS_USED_WEEKLY":"Bloques utilizados semanales","BUILDING":"Edificio","CALCULATION_TYPE":"Tipo de cálculo","CALENDAR":"Calendario","CALENDAR_VIEW":"Vista de calendario","CAMPUS":"Campus","CAMPUS_CODE":"Código del campus","CAMPUS_ID":"ID del campus","CAMPUS_NAME":"Nombre del campus","CAMPUS_PERIOD_SHIFT":"Campus - Periodo - Jornada","CANCEL":"Cancelar","CANCEL_SIMULATION":"Cancelar simulación","CANDIDATE":"Candidato","CANT_CAREERS":"Cantidad de carreras","CANT_COURSES":"Cantidad de cursos","CANT_STUDENTS":"Cantidad de estudiantes","CAPACITY":"Capacidad","CAPTURE":"Editar","CATEGORY":"Categoría","CHANGE":"Cambiar","CLASSROOMS":"Salas","CLICK_TO_SEE_MORE":"Haga click para ver más","CLIENT_NICENAME":"u-planner","CLONE":"Clonar","CLOSE":"Cerrar","CODE":"Código","COHORTE":"Cohorte","COMMENT":"Comentario","COMMENTS":"Comentarios","COMMONS_COURSES":"Cursos comunes","COMPACTED_GROUPS":"Grupos compactados","COMPATIBILITY_GROUP":"Grupo compatibilidad","COMPETENCY_MATRIX":"Matriz de competencia","COMPONENT_TYPE":"Tipo de componente","COMPONENT_WEIGHT":"Peso","CONFIGURE":"Configurar","CONFIRM":"Confirmar acción","CONFIRMED":"Confirmada","CONSECUTIVE_BLOCKS":"Bloques consecutivos","CONSECUTIVE_MODULES":"Módulos consecutivos","CONTACT_NUMBER":"Teléfono de contacto","COORDINATOR":"Coordinador","COURSE":"Curso","COURSE_DETAIL":"Detalle del curso","COURSE_DETAILS":"Detalle de los cursos","COURSE_MATTER":"Curso/materia","CREATE_CAMPUS":"Crear campus","CREATE_FACULTY":"Crear facultad","CREATE_STATE":"Crear estado","CREATED_AT":"Fecha de creación","CREATION":"Creación","CREATOR_USER":"Usuario creador","CURRICULAR":"Curricular","CUSTOM":"Personalizado","CYCLE":"Ciclo","CYCLE_PASSED":"Ciclo en que aprobó","DATA":"Datos","DATA_INTEGRATION":"Integración de datos","DATA_INTEGRATION_EXECUTE":"Ejecutar integración de datos","DATA_LOADED_CORRECTLY":"Datos cargados correctamente","DATA_NOT_LOADED":"Datos no cargados","DATES":"Fechas","DAY":"Día","DAY_MODULES":"Días / Módulos","DAYS":"Días","DEADLINE":"Fecha límite","Dec":"Dic","December":"Diciembre","DEFINE_SCHEDULE":"Definir horario","DELAY":"Atraso","DELAY_QUESTION":"¿Atraso?","DELETE":"Eliminar","DESCRIPTION":"Descripción","DESIGNATIONS":"Asignaciones","DESTINY":"Destino","DETAILS":"Detalles","DIMENSION":"Dimensión","DISABLE_CAMPUS_PROMPT":"¿Esta seguro que desea desactivar este campus?","DO_UPLOAD_DATA":"Realizar carga de datos","DOWNLOAD_FORMAT":"Descargar formato","DRAG_FILES":"Arrastrar archivos aquí","EDIT":"Editar","EDIT_ACADEMIC_CALENDAR":"Editar calendario acádemico","EDIT_COURSE_COMPETENCY_TRIBUTE":"Editar tributación de cursos a competencias","EDIT_FACULTY":"Editar facultad","EDIT_LIST":"Editar lista","EMAIL":"Correo","END_HOUR":"Hora fin","ENTER":"Ingresar","ENTER_PASSWORD":"Ingrese su contraseña","ENTER_VALID_USERNAME":"Ingrese un nombre de usuario válido","ENTER_YOUR_REQUIREMENTS_AND_COMMENTS":"Ingrese aquí sus requerimientos y/o comentarios","ERROR":"Error","ERRORS_REPORT":"Reporte de errores","EVALUATION_CRITERIA":"Criterios deEvualción","EVALUATION_NAME":"Nombre evaluación","EVERY":"Cada","EXPORT":"Exportar","EXPORT_CSV":"Exportar a CSV","EXPORT_XLS":"Exportar a XLS","EXTRACURRICULAR":"Extracurricular","Feb":"Feb","February":"Febrero","FICTIONAL":"Ficticio","FILE":"Archivo","FILTER":"Filtrar","FILTER_INFO_NOT_FOUND":"No existe información para el filtro seleccionado","FILTER_TO_SEE":"Filtre para visualizar","FILTERS":"Filtros","FINAL":"Final","FINAL_EVALUATION":"Evaluación Final","FINISH":"Finalizar","FLOOR":"Piso","Fri":"Vie","Friday":"Viernes","FROM":"Desde","FRONT_VERSION":"Versión front","FUNCTIONS":"Funciones","GENERAL":"General","GENERAL_DATA":"Datos generales","GENERANTING_CODES":"Generando códigos","GO_BACK":"Volver","GROUPS":"Grupos","HEIGHT":"Alto","HELP":"Ayuda","HIDE":"Ocultar","HIDE_FILTERS":"Ocultar filtros","HOURS":"Horas","ID_FATHER":"Id padre","IDLE_CAPACITY":"Capacidad ociosa","IMAGE":"Imágen","IMPLEMENTS":"Implemento","INACTIVE":"Inactivo","INFO_NOT_FOUND":"No existe información","INFORMATION":"Información","INFRASTRUCTURE_QUOTA":"Cupo infraestructura","INITIAL":"Inicial","INITIATE_DATA_INTEGRATION":"Ejecutar integración de datos","INITIATE_UPLOAD_DATA":"Iniciar carga","INSERT_END_DATE":"Ingrese fecha de fin","INSERT_START_DATE":"Ingrese fecha de Inicio","INVALID":"Invalido","IS_REQUIRED":"Es requerido","Jan":"Ene","January":"Enero","Jul":"Jul","July":"Julio","Jun":"Jun","June":"Junio","LAST_15_DAYS":"Últimos 15 días","LAST_30_DAYS":"Últimos 30 días","LAST_7_DAYS":"Últimos 7 días","LAST_WEEK":"Última semana","LENGTH":"Largo","LEVEL":"Nivel","LEVEL_SCHEMA":"Esquema de desarrollo de competencias","LOADING":"Cargando","LOADING_AFFECTED_SIMULATIONS":"Cargando simulaciones afectadas","LOADING_INDICATORS":"Cargando indicadores","LOCATION":"Ubicación","LOGIN_PROMPT":"Ingrese sus datos de acceso","MANAGE":"Administrar","MANAGEMENT":"Mantenedor","MANAGEMENTS":"Mantenedores","Mar":"Mar","March":"Marzo","MAX_WEEKLY_BLOCKS":"Max bloques semanales ","May":"Mayo","MENU_COLLAPSE":"Colapsar menú","MENU_LANG":"Idioma","MENU_LOGOUT":"Salir","MENU_MY_PROFILE":"Mi perfil","MENU_OPTIONS":"Opciones","MENU_START":"Inicio","MERGE":"Fusionar","MERGE_SECTIONS":"Compactación de Secciones","MIN_BLOCK_CREDITS":"Créditos mínimos del bloque","MINUTES":"Minutos","MINUTES_AFTER":"Minutos después","MINUTES_BEFORE":"Minutos antes","MODALITY":"Modalidad","MODIFICATION":"Modificación","MODIFICATOR_USER":"Usuario modificador","MODULE":"Módulo","MODULE_COMPONENT":"Módulo","MODULES":"Módulos","MODULES_PER_WEEK":"Módulos por semana","MODULES_ROOMS":"Módulos/Salones","Mon":"Lun","Monday":"Lunes","MONTH":"Mes","MORE_INFORMATION":"Más información","MSJ_ACADEMIC_CALENDAR_DAY_MODULES":"Seleccione los días y módulos que conformarán el nuevo Calendario Académico","MSJ_ACADEMIC_CALENDAR_WEEKS":"Seleccione las semanas que conformarán el nuevo calendario académico.","MSJ_ALL_CHANGES_ARE_SAVED_AUTOMATICALLY":"Todos los cambios son guardados automáticamente","MSJ_CODE_EXISTS":"El código ya existe","MSJ_CREATION_SUCCESS":"Acción finalizada correctamente","MSJ_DEFINITIVE_SENDING_OF_GRADES ":"Se confirmará el registro de notas en el Portal. Recuerde que al confirmar el registro de notas Ud. no podrá modificarlo, si desea alguna corrección deberá acercarse a las oficinas de registros académicos.","MSJ_DELETE":"Los registros han sido eliminados","MSJ_FAIL_TO_UPLOAD":"Error al subir","MSJ_INCORRECT_USER_PASS":"Usuario / Contraseña incorrecta","MSJ_MAINTENANCE_NOTIFICATION":"El próximo mantenimiento de la aplicación será","MSJ_NO_DATA_RELATED_YOUR_SEARCH":"No existen datos relacionados a tu busqueda","MSJ_PARAMETERS_SAVED_CORRECTLY":"Parámetros guardados correctamente","MSJ_PLEASE_WAIT_WHILE_PROCESSING_FILE":"Por favor espere mientras el archivo es procesado, será redirigido a la pantalla de resultados","MSJ_REQUIRED_FIELDS_MISSING":"Faltan datos requeridos","MSJ_SCHEDULE_SAVED_SUCCESSFULLY":"Horario guardado satisfactoriamente","MSJ_SUCCESFUL_UPLOAD_FILES":"Archivo/s cargados con éxito","MSJ_TEACHER_SIMULATION_PROGRESS":"La barra de progreso le indica el estado en el cual se encuentra la simulación, es recomendable no cancelar , para llevar a cabo otro flujo sólo debe hacer clic en el botón de ejecutar en 2° plano.","MSJ_UPDATED_SUCCESSFULLY":"Actualizado correctamente","MSJ_UPLOADED_SUCCESSFULLY":"Subida correctamente","MSJ_USER_DOESNT_MATCH_WITH_LOGGED_IN":"El usuario ingresado no coincide con el autenticado","N_ENROLLED":"Nº Inscritos","N_LINE":"Nº Línea","N_OF_LICENCES":"Cantidad de licencias","N_OF_PERIOD":"Nº Periodo","N_OF_SECTIONS":"N° Secciones","N_OF_STUDENTS":"N° Alumnos","N_PLAN":"Nº Planes","N_STUDENTS":"N° estudiantes","NAME":"Nombre","NAME_STAGE":"Nombre Escenario","NAMES":"Nombres","NEXT_DAYS":"Días siguientes","NO":"No","NO_NAME":"Sin nombre","NO_NOTES":"No hay apuntes","NO_OFFICIAL_GRADE":"Nota no oficial","NOT_STARTED":"No iniciada","NOT_SYNCHRONIZABLE":"No sincronizable","NOT_TRACKING":"Sin seguimiento","Nov":"Nov","November":"Noviembre","NRC":"NRC","NUMBER_OF":"N°","OBSERVATION":"Observación","OBSERVATION_DESCRIPTION":"Observación / Descripción","OBSERVATIONS":"Observaciones","Oct":"Oct","October":"Octubre","OF":"de","OPERATION":"Operación","ORIGIN":"Origen","ORIGINAL_AMOUNT":"Cantidad original","PARAMETERIZATION":"Parametrización","PASSWORD":"Contraseña","PENDING":"Pendiente","PERCENTAGE":"Porcentaje","PERCENTAGE_ASSIGNATION_SCHEDULE_ROOM":"% Asignación horario salas","PERCENTAGE_OCCUPIED_CAPACITY":"Porcentaje de capacidad ocupada","PERIOD":"Periodo","PERIOD_CODE":"Código del periodo","PERIOD_CREATE":"Crear periodo","PERIOD_NAME":"Nombre del periodo","PERIODS":"Periodos","PERMISSIONS":"Permisos","PERSONAL_ID":"Rut","PLAN":"Plan","PREVIOUS_DAYS":"Días anteriores","PRIVACY_POLICIES":"Políticas de Privacidad","PRODUCT":"Producto","PROGRAMMABLE":"Programable","PROGRAMMED":"Programada","PROGRESS_SUGGEST":"Avance Sugerido","PROPERTIES":"Características","REAL":"Real","REGENERATE_CODES":"Regenerar códigos actuales","REJECT":"Rechazar","REJECTED":"Rechazado","REPEAT":"Repetir","REPLACEMENT":"Reemplazo","REPLACEMENT_QUESTION":"¿Reemplazo?","REQUEST":"Solicitud","REQUEST_ACCEPTED":"Solicitud aceptada","REQUEST_STATE":"Estado solicitud","REQUIRED":"Requerido","RESOURCE":"Recurso","RESOURCES":"Recursos","RESPONSIBLE":"Responsable","RESTORE":"Restaurar","RESULTS":"Resultados","ROLES":"Roles","ROOT":"Raíz","Sat":"Sab","Saturday":"Sábado","SAVE":"Guardar","SAVE_RETURN":"Guardar y volver","SCALE_MAX":"Escala max.","SCALE_MIN":"Escala min.","SCHEDULE":"Horario","SCHEDULE_BATCH_UPLOAD":"Carga masiva de horarios","SCHEDULE_SIMULATION_PROGRESS":"Progreso simulación horario","SCHEDULE_TYPE":"Tipo de calendario","SEARCH_SECTIONS":"Buscar secciones","SECTION":"Sección","SECTION_CODE":"Código Sección","SECTION_DETAIL":"Detalle de sección","SECTION_ID":"ID de Sección","SEE":"Ver","SEE_DETAIL":"Ver Detalle","SEE_DETAILS":"Ver Detalles","SEE_EDIT":"Ver/Editar","SELECT":"Seleccione","SELECT_ALL":"Seleccionar Todo","SELECT_APPLICATION":"Seleccione aplicación","SELECT_CAMPUS":"Seleccione campus","SELECT_COURSE":"Seleccione curso","SELECT_DAY":"Seleccione día","SELECT_LEVEL_IN_COMPETENCY":"Seleccione el nivel de desarrollo de la competencia","SELECT_MODULE":"Seleccione módulo","SELECT_NAME_EVALUATION":"Seleccionar nombre evaluación","SELECT_ONE_SUPERVISOR_MSJ":"Seleccione al menos un Supervisor","SELECT_PERIOD":"Seleccione periodo","SELECT_PERIODS":"Seleccione periodos","SELECT_PROGRAMMING":"Seleccione programación","SELECT_SCHEDULE_SIMULATION":"Seleccione simulación horario","SELECT_SIMULATION":"Seleccione Simulación","SELECT_SPECIALTY":"Seleccionar especialidad","SELECT_SUBJECT":"Seleccione asignatura","SELECT_SUPERVISOR":"Seleccionar supervisor","SELECT_WEEK":"Seleccione semana","SELECTED_WEEK":"Semana seleccionada","SEND":"Enviar","Sep":"Sep","September":"Septiembre","SETTINGS":"Ajustes","SHIFT":"Jornada","SHOW":"Mostrar","SHOW_ADVANCED_FILTERS":"Mostrar/ocultar filtros avanzados","SHOW_FILTERS":"Mostrar filtros","SIMBOLIZATION":"Simbología","SIMULATED_GRADE":"Nota simulada","SQUARE_METERS":"m2","START_END_HOUR":"Hora inicio/fin","START_HOUR":"Hora inicio","STARTED":"Iniciada","STATE":"Estado","STATE_LIST":"Lista de estados","STATES":"Estados","STATUS":"Estado","STUDENT":"Estudiante","STUDENTS":"Estudiantes","STUDENTS_LEVEL":"Nivel estudiante","STUDY_PLAN":"Plan de estudio","Sun":"Dom","Sunday":"Domingo","SURNAME":"Apellido","SURNAMES":"Apellidos","SYNCHRONIZABLE":"Sincronizable","SYNCHRONIZED":"Sincronizado","TEACHER":"Docente","TEACHER_EVALUATION":"Evaluación docente","TEACHER_NAME":"Nombre docente","TEACHER_ROLE":"Cargo docente","Thu":"Jue","Thursday":"Jueves","TO_ASSIGN":"Asignar","TO_UNASSIGN":"Desasignar","TODAY":"Hoy","TOTAL":"Total","TOTAL_CANDIDATES":"Total Candidatas","TOTAL_CLASS":"Total clase","TOTAL_MODULES":"Módulos total","TOTAL_PREDEFINED":"Total Predefinidas","TOTAL_STUDENTS":"Total estudiantes","TRACKING":"Seguimiento","TRANSFER_STUDENTS":"Transferir alumnos","TRANSITION":"Transición","TRANSITION_FUNCTION":"Función de la Transición","Tue":"Mar","Tuesday":"Martes","U_ANALYTICS":"u-analytics","U_FACULTY":"u-faculty","U_LEARNING":"u-learning","U_SUITE":"u-suite","U_SUITE_ABOUT":"Acerca de u-suite","UNIQUE_GROUP":"Grupo único","UNLOCK":"Des-Asignar","UNTIL":"Hasta","UPDATE":"Actualizar","UPDATE_CANCEL":"Actualizar/Cancelar","UPDATE_CANCEL_EVENT":"Actualizar/Cancelar evento","UPDATE_DATE":"Fecha actualización","UPDATED":"Actualizado","UPLOAD_DATA_ERROR_MSJ":"¡Error! Los datos no se han cargado correctamente","UPLOAD_FILES":"Subir archivos","UPLOAD_IMAGE":"Subir imágen","UPLOAD_VIDEO":"Subir video","USAGE":"Uso","VERSION":"Versión","VIDEO":"Video","VIEW":"Ver","VIRTUAL":"Virtual","VISUALIZATION":"Visualización","VISUALIZATIONS":"Visualizaciones","WARNING_INPUTS_REQUIRED":"* El campo es requerido","WARNING_MESSAGE_EDIT_DEFAULT":"¿Desea guardar cambios?","WEB_SITES":"Sitios web","Wed":"Mie","Wednesday":"Miércoles","WEEK":"Semana","WEEK_MONTH":"Semana/Mes","WEEKLY_BLOCKS":"Bloques semanales","WEEKLY_HOURS":"Horas semanales","WEEKS":"Semanas","WEIGHT":"Peso","WELCOME":"Bienvenido","WIDTH":"Ancho","WITHOUT_AFFECTED_SIMULATIONS":"Sin simulaciones afectadas","WITHOUT_CODE":"Sin código","YES":"Sí","YES_NO":"Si/No","RECOGNITION_INCENTIVES_MSG_FORM":"Registre en los siguientes campos la información de los premios y reconocimientos otorgados por instancias externas a URosario. La Universidad registrará en su perfil los premios y reconocimientos otorgados a nivel institucional.","SEARCH_PROFILE_DASH":"Ingrese el nombre o número de identificación del profesor que desea buscar. La información se desplegará si usted cuenta con permisos de consulta.","NOT_ACTIVE":"Inactivo","DOES_NOT_APLLY":"No Aplica","TWO_STEP_FLOW":"Flujo de dos pasos","REVIEWERS":"Revisores","APPROVERS":"Aprobadores","PROFILE_WORKFLOW_EDIT":"Edición de flujo perfil","USERS_WITH_NAME_NOT_FOUND":"No se encontraron profesores con nombre","ASSIGNATION_SUCCESSFUL":"¡Asignación exitosa!","CHANGES_SAVED_SUCCESFULLY":"Se han guarcado los cambios con éxito"}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = {"ACCESS_CONFIG":"Configuração de acesso","ADMIN_GRUPOS":"Administração de grupos","ADMIN_PANEL":"Admin panel","ADMIN_ROLES":"Administração de funções","ADMIN_USUARIOS":"Administração de usuários","ASSOCIATED_GROUPS":"Grupos associados","CREATE_NEW_GROUP":"Criar novo grupo","CREATE_NEW_ROLE":"Criar nova função","CREATE_NEW_USER":"Criar novo usuário","DATE_LAST_ENTRY":"Data da última entrada","DEACTIVATE_GROUP":"Desativar grupo","DEACTIVATE_REGISTRY_MSJ":"Você deseja desativar esse registro?","DEACTIVATE_ROLE":"Desativar função","DEACTIVATE_USER":"Desativar usuário","EDIT_ASSIGNMENT":"Editar atribuição","EDIT_USER":"Editar usuário","EMAIL_NOT_VALID_MSJ":"O e-mail informado não é válido","GENERATED_GROUPS":"","GROUP_ADMIN":"Administração de Grupo","GROUP_NAME":"Nome do grupo","INSERT_FULL_NAME_MSJ":"Por favor, digite o nome completo","INSERT_INSTITUTION_MSJ":"Por favor selecione uma instituição","INSERT_PASSWORD_AGAIN_MSJ":"Por favor, repita a senha","INSERT_PASSWORD_MSJ":"Por favor, insira uma senha","INSERT_USER_NAME_MSJ":"Por favor insira o nome de usuário","PASSWORD_NOT_MATCH_MSJ":"As senhas não correspondem","PERSONAL_INFO":"Informação pessoal","REPEAT_PASSWORD":"repetir a senha","ROLE_ADMIN":"Administração de Funções","ROLE_NAME":"Nome da função","SECTIONS":"Seções","SELECT_GROUP_TYPE_PLACEHOLD":"Selecione o tipo de grupo ...","SELECT_INSTITUTION_PLACEHOLD":"Selecione uma instituição ...","TYPE_OF_USER":"Tipo de usuário","USER_ADMIN":"Administração de usuários","USER_ROLES":"Funções do usuário","USERNAME":"Nome de usuário","absence-percentage":"Porcentagem de ausência","acceso-a-tablas-de-filtrado":"Acesso a tabelas de filtragem","acceso-administracion-grupos":"Acesso Administração Grupos","acceso-administracion-roles":"Acesso Administração Funções","acceso-administracion-usuarios":"Acesso Administração Usuários","acceso-carga-demand-global":"Acesso Carga de Demanda Global","acceso-carga-disponibilidad-docente":"Acesso Carga de Disponibilidade Docente","acceso-carga-grupos":"Acesso Carga de Grupos","acceso-carga-listas-cruzadas":"Acesso Carga de listas cruzadas","acceso-mantenedor-cargo-docente":"Acesso Administrador cargo docente","acceso-mantenedor-de-costo-eva-docente":"Acesso Administrador de Custo Avaliação Docente","acceso-mantenedor-de-jornadas":"Acesso Administrador de Dias","acceso-mantenedor-disponibilidad-docente":"Acesso Administrador disponibilidad docente","acceso-mantenedor-docente-materia-actividad":"Acesso Administrador docente matéria atividade","acceso-mantenedores-de-recursos":"Acesso Administradores de Recursos","acceso-mantenedores-de-tipo-de-uso":"Acesso Administradores de Tipo de Uso","acceso-pantalla-inicio":"Acesso Tela Início","acceso-perfil":"Acesso Perfil","acceso-programacion-academica":"Acesso Programação Acadêmica","acceso-restriccion-ubicacion-actividad":"Acesso Restrição Localização Atividade","acceso-simulacion-forecast":"Acesso Simulação Forecast","acceso-simulacion-group":"Acesso Simulação Group","acceso-simulacion-schedule":"Acesso Simulação Schedule","acceso-simulacion-teacher":"Acesso Simulação Teacher","acceso-simulaciones":"Acesse Simulações","acceso-syllabus":"Acesso Syllabus","acceso-tiempo-de-traslado":"Acesso Tempo de Transferência","acciones-materias":"Ações Matérias","actividades-extracurriculares":"Atividades extracurriculares","activos-de-aula":"Ativos de Aula","actualizacion-contenido":"Atualização Conteúdo","actualizacion-notas":"Atualização Notas","administar-publicidad":"Gerenciar Publicidade","alertas-individuales":"Alertas Individuais","algorithm-log":"Log de algoritmo","apertura-clases":"Abertura Classes","aplicaciones-virtuales":"Aplicações Virtuais","apuntes":"Anotações","asignaciones-app.v-por-curso":"Atribuições App.V por Curso","asignaturas-con-mayor-cantidad-de-alumnos":"Disciplinas com maior quantidade de alunos","asistencia-clase-actual":"Assistência Classe Atual","asistencia-docentes":"Assistência Docentes","asistencia-estudiantes":"Assistência Estudantes","assisted-classes":"Classes Assistidas","attendance":"Assistência","attendance-percentage":"Porcentagem de assistência","auto-attendance":"Assistência automática","backend-log":"Log do backend","bitacora-de-contactos":"Log de contatos","buscar-reserva":"Pesquisar Reserva","calendario-academico":"Calendário Acadêmico","calibracion-del-modelo":"Calibração do modelo","carga-listas-cruzadas":"Carregar Lista Cruzada","carga-nuevos-estudiantes":"Carregar Novos Estudantes","carga-periodo-anterior":"Carregar Período Anterior","carga-restriccion-salas":"Carregar Restrição Salas","carrera/edificio":"Carreira / Edifício","carreras":"Carreiras","competencias-avance-curricular":"Competências Progresso Curricular","configuracion":"Configuração","configuracion-listas-cruzadas":"Configuração Listas Cruzadas","configuracion-matricula-óptima":"Configuração Matrícula Ideal","configuracion-programacion-academica":"Configuração Programação Acadêmica","configurar-disponibilidad-docente":"Configurar Disponibilidade Docente","configurar-funcion-objetivo":"Configurar Função Objetivo","confirmacion":"Confirmação","content":"Conteúdo","costo-curso-actividad":"Custo Curso Atividade","cuadro-de-mando":"Painel de Controle","cupo-academico":"Quota Acadêmica","current-class-content":"","current-class-notes":"","curso/edificio":"Curso / Edíficio","datos-de-contacto":"Dados de contato","dictated-classes":"Classes ditadas","docentes":"Docentes","encuestas":"Pesquisas","encuestas-de-preferencia":"Pesquisas de Preferência","estructuras-evaluacion":"Estruturas Avaliação","estructuras-evaluacion-por-seccion":"Estruturas Avaliação por Seção","evidencia-logro-competencias":"Evidência Realização Conpetências","evolucion-de-la-desercion-historica":"Evolução da Deserção Histórica","exportar-datos":"Exportar dados","factor":"Fator","facultades":"Faculdades","finish-class":"","generator-random-code":"","generator-random-code-courses":"","generator-random-code-periods":"","grade-calculator":"","grade-official":"","grade-percentaje":"","grade-progress":"","grade-unofficial":"","grades":"Notas","grades-access":"","grades-formula":"","grafico-de-estudiantes-en-riesgo-por-periodo":"Gráfico de estudantes em risco por período","historic-attendance":"Assistência histórica","historic-classes-notes":"","historic-content":"","holgura-cupo-academico":"Folga Quota Acadêmica","inicio-class":"Início Class","inicio-planning":"Início Planning","inicio-retention":"Início Retention","inicio-suite":"Início Suíte","inputs-del-modelo":"Inputs do modelo","integration-booking":"Integration Booking","integration-class":"Integration Class","integration-enrollment":"Integration Enrollment","integration-faculty":"Integration Faculty","integration-forecast":"Integration Forecast","integration-improve":"Integration Improve","integration-planning":"Integration Planning","integration-retention":"Integration Retention","listado-escenarios":"Lista Cenários","listado-estudiantes-curso":"Lista Estudantes Curso","logro-competencias-estudiantes":"Realização Conpetências Estudantes","mantenedor-curso-actividad":"Administrador Cuso atividade","mantenedor-matrices-competencia":"Administrador Matriz Conpetências","mantenedor-plan-de-estudios":"Administrador Plano de Estudos","mantenedor-valor-curso-actividad":"Administrador Valor Curso Atividade","menu-lateral-izquierdo":"Menu Lateral Esquerdo","niveles-de-desarrollo-de-competencias":"Níveis de desenvolvimento de Conpetências","operaciones-manuales":"Operações manuais","option-repeat":"","periodos":"Períodos","permisos-estructura-workflow":"Permissões Estrutura WorkFlow","plan-curso-electivo":"Plano Curso Eletivo","porcentaje-uso-de-sillas":"Porcentagem Uso de Cadeiras","power-bi":"Power Bi","probabilidad-historica":"Probabilidade histórica","profesores-con-mayor-cantidad-de-alumnos-en-r":"Professores com o maior número de alunos em r","razones-de-desercion":"Razões de deserção","recursos":"Recursos","registro-de-asistencia":"Registro de Assistência","registro-de-contenido":"Registro de Conteúdo","registro-de-notas":"Registro de Notas","registro-de-observaciones":"Registro de observações","reporte-asistencia-docente":"Relatório Assistência Docente","reporte-de-comparacion":"Relatório de Comparação","reporte-de-uso-de-infraestructura":"Relatório de uso de infraestrutura","reporte-de-utilizacion-de-salas":"Relatório de utilização da sala","reporte-detalle":"Relatório detalhado","reporte-estado-eventos":"Relatório Estado Eventos","reporte-planificacion-diaria":"Relatório Planejamento Diário","reporte-por-curso":"Relatório por curso","reporte-por-estudiante":"Relatório do Estudante","reporte-por-profesor":"Relatório do Professor","reporte-power-bi":"Relatório do Power Bi","reporte-realizacion-actividades":"Relatório Realização Atividades","reporte-tiempo-confirmacion":"Relatório Tempo Confirmação","reserva":"Reserva","restriccion-horario-salas":"Restrição Horário Salas","resultado-de-carga-de-datos":"Resultado do carregamento de dados","scheduled-classes":"Classes agendadas","seguimiento-syllabus":"Acompanhamento Syllabus","tabla-actividad":"Tabela Atividade","tabla-actividad-asignatura-detalle":"Tabela Atividade Disciplina Detalhe","tabla-actividad-asignatura-tipo-uso":"Tabela Atividade Disciplina Tipo Uso","tabla-arancel-carrera":"Tabela Tarifa Carreira","tabla-campus":"Tabela Campus","tabla-campus-bdi":"Tabela Campus BDI","tabla-carrera":"Tabela Carreira","tabla-departamento":"Tabela Departamento","tabla-docente":"Tabela Docente","tabla-docente-asignatura-actividad-sede":"Tabela Docente Disciplina Atividade Sede","tabla-docente-valor-hora-evaluacion":"Tabela Valor Hora Avaliação","tabla-hora-clase":"Tabela Hora Classe","tabla-infraestructura":"Tabela Infraestrutura","tabla-infraestructura-tipo-uso":"Tabela Infraestrutura Tipo Uso","tabla-institucion":"Tabela Instituição","tabla-jornada":"Tabela Jornada","tabla-materia-departamento":"Tabela Matéria Departamento","tabla-materia-plan":"Tabela Matéria Plano","tabla-modulos-jornada":"Tabela Módulos Jornada","tabla-nota-clase":"Tabela Nota Classe","tabla-periodo":"Tabela Período","tabla-periodo-bdi":"Tablea Período BDI","tabla-pivote":"Tabela Dinâmica","tabla-plan-estudio":"Tabela Plano Estudo","tabla-plan-estudio-asignatura":"Tabela Plano Estudo Disciplina","tabla-plan-estudio-turno":"Tabela Plano Estudo Turno","tabla-planes-campus":"Tabela Planos Campus","tabla-valor-hora-asignatura":"Tabela Valor Hora Disciplina","tasa-de-aprobacion":"Taxa de aprovação","tipo-contrato-docente":"Tipo Contrato Docente","tipo-de-recurso":"Tipo de Recurso","tributacion-de-curso-a-competencias":"Tributação de curso a conpetências","ubicacion":"Localização","utilizar-disponibilidad-docente":"Utilizar Disponibilidade Docente","vista-coordinador":"Vista Coordenador","vista-estudiante":"Vista Estudante","workflow":"Fluxo de trabalho","ACTIVE_PL":"","ACTIVITY_MANAGEMENT":"Administrador de atividade","ACTIVITY_VISUALIZATION":"Visualização da atividade","ADD_ADVERTISING":"Adicionar publicidade","ADD_CLASSROOM_ASSET":"Adicionar ativos de sala de aula","ADD_COURSE":"Adicionar curso","ADD_EDIT_COURSES_FOR_APP_VIRTUAL":"Adicionar / editar cursos para app virtual","ADD_EDIT_COURSES_FOR_VIRTUAL_APP":"Adicionar / Editar Cursos para App Virtual","ADD_RESOURCE_TYPE":"Adicionar tipo de recurso","ADD_STATIONS":"Adicionar estações","ADMIN_SCREENS":"","ADVERTISING":"Publicidade","ADVERTISING_TYPE":"Tipo de publicidade","AFTER_START":"Depois do início","ALLOW_RESERVATIONS_IN":"","APPLICANT":"Requerente","APPLICATION":"Aplicação","ASSETS":"Ativos de sala de aula","ASSIGN_RESOURCE":"Atribuir recurso","ASSIGN_SCHEDULE":"","ATTACH_TO":"Anexar a","ATTACH_TO_ROTARY_SCREEN":"Anexar a tela rotativa","AVAILABLE_TO_DISABLED_PEOPLE":"Adequado para pessoas com necessidades especiais","BEFORE_START":"Antes do início","BLOCKED_SCHEDULE":"","BOOKING_DETAIL":"","BOOKING_DONE":"Reserva feita satisfatoriamente, o código de reserva é","BOOKING_FAILURE":"","BOOKING_FREE":"Horas disponíveis","BUILDING_NAME":"Nome Edifício","CALENDAR_CONFIRM_PROFILE":"Agenda de eventos (Confirmação)","CALENDAR_RESERVATION_PROFILE":"Agenda de eventos (Reserva)","CAMPUS_ORIGIN_OF_THE_ROLE":"","CANCELED_EVENT":"","CLASSROOM_ASSET_IN_USE":"","CLASSROOM_ASSETS":"Ativos de sala de aula","CLONE_PERIOD":"Clonar Período","CONFIRM_CLASSROOM_ASSET_IN_USE_ADD":"","CONFIRM_DELETE":"Confirmar Eliminar","CONFIRM_DELETE_RESERVATIONS_MSJ":"Tem certeza de que deseja excluir as reservas selecionadas?","CONFIRM_INACTIVATE":"","CONFIRM_RESERVATION":"Confirmar Reserva","CONFIRMED_EVENT":"","CONTROL_PANEL":"Painel de Controle","COURSE_CODE":"Código do Curso","COURSE_NAME":"Nome do curso","COURSES_ADDED":"Cursos adicionados","CREATE_BUILDING":"Criar Edifício","CREATE_BUILDING_FOR":"Criar Edifício para","CREATE_CATEGORY":"Criar Categoria","CREATE_CLASSROOM_ASSETS":"Criar/Editar ativos de sala de aula","CREATE_EDIT_RESOURCE":"Criar/Editar recurso","CREATE_EDIT_VIRTUAL_APP":"Criar/Editar app virtual","CREATE_FLOOR":"Criar Piso","CREATE_FLOOR_FOR":"Criar Piso para","CREATE_NEW_RESERVATION":"Criar nova reserva","CREATE_RESOURCE_TYPE":"Criar tipo de recurso","CREATE_SCREEN":"Criar tela","CREATE_USAGE_TYPE":"Criar tipo de uso","CREATE_VIRTUAL_APP":"Criar App Virtual","CREATED_BY":"Criado por","CREATION_DATE":"Data de criação","CURRENT_AND_FOLLOWING_RESERVATIONS":"Reserva atual e seguinte","CURRENT_RESERVED":"Hora a reservar","CURRICULAR_EVENTS":"Eventos Curriculares","DEFINE_RESERVATION":"Definir reserva","DELETE_EVENT":"Excluir evento","DELETE_RESERVATION_MSJ":"","DELETE_RESERVATIONS":"Excluir reservas","DELETE_SCREEN_CONFIG":"Excluir Configuração de tela","DESCRIPTION_ACTIVE_RESOURCE":"","DESCRIPTION_REAL_RESOURCE":"","DESCRIPTION_RESOURCE_WITH_UNIVERSAL_ACCESSIBILITY":"","DESCRIPTION_SYNCHRONIZABLE_RESOURCE":"","DESCRIPTION_VIRTUAL_RESOURCE":"","DETAIL_APPLICATION":"Detalhe Solicitação","DETAILS_RESERVATION":"","EDIT_CLASSROOM_ASSETS":"","EDIT_CONFIRM_RESERVATION_MSJ":"O candidato e a parte responsável serão notificados por email","EDIT_RESERVE":"Editar reserva","EDIT_RESOURCE":"Editar recurso","EDIT_SCREEN":"Editar tela","EDITED_BY":"Editado por","ELIMINATE_MASSIVE":"Excluir massivo","END_DATE":"Data final","END_MODULE":"Módulo final","END_TIME":"Hora final","ENTER_CATEGORY_MSJ":"Por favor insira categoria","ENTER_CODE_MSJ":"Por favor digite código","ENTER_DATE_MSJ":"Por favor selecione data de início","ENTER_NAME_MSJ":"Por favor insira nome","ENTER_RESOURCE_MSJ":"Por favor insira recurso","EVENT":"Evento","EVENT_DELAYED":"","EVENT_NAME":"Nome evento","EVENTS_DISPLAY_TIME_PER_PAGE":"Tempo de duração por página","EXCEPTIONS":"","EXTRACURRICULAR_ACTIVITIES":"Atividades extracurriculares","EXTRACURRICULAR_EVENTS":"Eventos extra-curriculares","FAILED_CLONING":"Clonagem falhada","FILE_FORMAT_IMAGE_MSJ":"Os arquivos devem estar no formato JPG, TIFF...","FILE_FORMAT_VIDEO_MSJ":"Os arquivos devem estar no formato MOV, MP4 ...","FILTER_PER_HOUR":"","FILTERS_FOR_SECTION":"","FLOOR_NAME":"Nome Piso","FONT_SIZE":"Tamanho Tipografia","INACTIVE_PL":"","INFORMATION_VISIBLE_IN_ROTARY_SCREEN_NOTE_MSJ":"Nota: Esta informação será visível em uma tela rotativa","INSERT_ADVERTISING_BETWEEN_ACTIVITIES":"Intercalar Publicidade/Atividades","IT_IS_NOT_POSSIBLE_INACTIVE_BUILDING":"","IT_IS_NOT_POSSIBLE_INACTIVE_FLOOR":"","IT_IS_NOT_POSSIBLE_INACTIVE_RESOURCE_TYPE":"","MANAGE_ADVERTISING":"Arquivos multimídia","MANAGE_VIRTUAL_APPLICATIONS":"Gerenciar Aplicativos Virtuais","MAXIMUM_ANTICIPATION_TIME_PER_RESERVATION":"","MAXIMUM_OF_RESPONSIBLE":"","MAXIMUM_RESERVATION_TIME_PER_DAY":"","MAXIMUM_TIME_TO_ACTIVATE":"","MINIMUM_ANTICIPATION_TIME_PER_RESERVATION":"","MINIMUM_NUMBER_OF_USERS_PER_RESERVATION":"","MINIMUM_RESERVATION_TIME_PER_DAY":"","MINIMUM_TIME_TO_ACTIVATE":"","MODIFICATION_DATE":"Data da modificação","MSJ_APP_VIRTUAL_CREATED_SUCCESS":"App Virtual criada corretamente","MSJ_BOOKING_DONE_AND_CODE":"","MSJ_BUILDING_CODE_ALREADY_EXISTS":"","MSJ_BUILDING_CREATED_SUCCESSFULLY":"","MSJ_BUILDING_DELETED_SUCCESSFULLY":"","MSJ_BUILDING_UPDATED_SUCCESSFULLY":"","MSJ_CLONE_PERIOD_VIRTUAL_APP":"Substituir cursos e Apps virtuais de um período acadêmico existente por um novo período","MSJ_CONFIRM_INACTIVATE_BUILDING":"","MSJ_CONFIRM_INACTIVATE_FLOOR":"","MSJ_DELETE_BUILDING":"Você está prestes a excluir um edifício que pode ter pisos associados. Tem certeza?","MSJ_DELETE_FLOOR":"Você tem certeza de que deseja remover este piso?","MSJ_DELETE_RESOURCE_TYPE":"Você está prestes a excluir um tipo de recurso que pode ter tipos de uso associados. Tem certeza?","MSJ_DELETE_USAGE_TYPE":"Você tem certeza de que deseja eliminar esse tipo de uso?","MSJ_ENTER_REQUERID_FIELD":"Por favor insira os campos obrigatórios","MSJ_FLOOR_CODE_ALREADY_EXISTS":"O código já existe","MSJ_FLOOR_CREATED_SUCCESSFULLY":"Edifício criado corretamente","MSJ_FLOOR_DELETED_SUCCESSFULLY":"Edifício removido corretamente","MSJ_FLOOR_UPDATED_SUCCESSFULLY":"Edifício atualizado corretamente","MSJ_MAXIMUM_RESERVATION_TIME_EXCEEDED":"","MSJ_NO_DATA_ROTATIVE":"Não existe tela para mostrar","MSJ_PLEASE_ENTER_NAME_AND_CODE":"Por favor, insira nome e código","MSJ_PLEASE_SELECT_A_COURSE_TO_ASSOCIATE":"Por favor, selecione um curso para associar","MSJ_PLEASE_SELECT_DIFFERENT_PERIOD":"Por favor, selecione diferentes períodos de destino para clonar","MSJ_PLEASE_SELECT_RESOURCE_USAGETYPE":"Por favor selecione recurso e tipo de uso","MSJ_PLEASE_SELECT_USAGETYPE":"Por favor, selecione tipo de uso","MSJ_RESERVATION_SUCCESSFUL":"","MSJ_SELECT_ONE_ROW_TO_DELETE":"Selecione pelo menos uma linha para excluir","MSJ_THERE_NO_DATA_RELATED_TO_YOU_SEARCH":"Não há dados relacionados aos seus critérios de pesquisa.","MULTICAMPUS":"","MULTIMEDIA_LIBRARY":"Biblioteca multimídia","MY_RESERVATIONS":"Minhas Reservas","N_OF_ROWS_PER_SCREEN":"N ° linhas por tela","NOTIFY_BY_EMAIL_APPLICANT_TEACHER_SECTION_STUDENTS_MSJ":"O solicitante, docente e alunos da seção serão notificados por email.","NUMBER_OF_LICENSES":"Nº de licenças","ONLY_THIS_RESERVATION":"Apenas esta reserva","ORDER":"Ordem","PER_PAGE":"Por página","PERIOD_OF_ORIGIN":"Período de origem","PERIOD_TO_LINK":"Período a vincular","PERIOD_TO_REPLACE":"Período a substituir","PERMISSIONS_FOR":"","REPEATS_UNTIL_THE":"","RESERVATION_DATE":"Data da reserva","RESERVATION_PERIOD":"Período de reserva","RESERVATION_TYPE":"Tipo de reserva","RESERVATIONS_PARAMETERS":"","RESERVE":"Reservar","RESERVED_SCHEDULE":"","ROTARY_SCREEN":"Tela rotativa","ROTARY_SCREENS_CONFIG":"Configurar tela rotativa","SCHEDULE_ASSIGNMENT":"","SCHEDULE_BY_CAREER":"","SCHEDULE_BY_RESOURCE":"","SCREEN_LIST":"Lista de telas","SCREENS_LIST":"Lista de telas existentes","SEARCH_BY_HOURS":"Pesquisar por horas","SEARCH_EVENT":"Pesquisar evento","SEARCH_FOR":"Pesquisar por","SEARCH_RESERVATION":"Pesquisar Reserva","SEC":"Seg.","SELECT_ACTIVITY":"Selecionar atividade","SELECT_ATTENDANCE_STATUS":"","SELECT_BUILDING":"Selecionar edifício","SELECT_CATEGORY":"Selecionar Categoria","SELECT_CLASSROOM_ASSETS":"Selecione ativos de sala de aula","SELECT_FLOOR":"Selecionar Piso","SELECT_RESOURCE_TYPE":"Seleciones tipo de recurso","SELECT_TYPE_ACTIVITY":"Selecionar tipo de atividade","SELECT_USAGE_TYPE":"Seleciones tipo de uso","SHOW_AVAILABILITY_BY":"Mostrar disponibilidade para","SHOW_CANCELED_EVENTS":"Mostrar eventos cancelados","START_DATE":"Data início","START_MODULE":"Módulo início","START_TIME":"Hora início","STATION":"Estação","STATIONS":"Estações","SUMMARY_BOOKING":"","SURE_TO_DELETE_CONFIG_MSJ":"Você tem certeza de que deseja excluir esta configuração?","TEACHER_ABSENT":"","TEACHER_PRESENT":"","TEACHER_REPLACEMENT":"Substituir docente","TEACHER_SUBSTITUTE":"","THERE_ARE_ASSOCIATED_RESOURCES":"","THERE_ARE_FLOORS_WITH_ASSOCIATED_RESOURCES":"","THERE_ARE_RESOURCES_ASSOCIATED":"","TIME":"Tempo","U_BOOKING":"u-booking","UNIVERSAL_ACCESSIBILITY":"","UNLIMITED":"Sem limite","UPDATE_CURRICULAR_ACTIVITY":"Atualizar atividade curricular","UPDATE_EXTRACURRICULAR_ACTIVITY":"Atualizar atividade extracurricular","VIRTUAL_APP_ASSOCIATIONS_PER_COURSE":"Associações de app virtual por curso","VIRTUAL_APPS":"Aplicações virtuais","VIRTUAL_APPS_ASSOCIATION":"Associação de aplicativos virtuais","VIRTUAL_APPS_RESERVE":"Reserva de aplicativos virtuais","VIRTUAL_LAB":"Laboratório virtual","ABSENCES":"Ausências","ABSENT":"Ausente","ABSENT_LABEL":"A","ACADEMIC_SECRETARY":"Secretário Acadêmico","ADD_STUDENT_TO_LIST":"Adicionar estudante à lista","ALREADY_GENERATED":"Código Gerado","APPROVED":"Aprovado","ASIGNED":"Atribuído","ASSIGN_SECTIONS_TO_STRUCTURE":"Atribuir seção a estruturar","ASSISTED":"Assistida","ATTENDANCE":"Assistência","ATTENDANCE_AVERAGE":"Média de assistência","ATTENDANCE_AVERAGE_LAST_WEEK":"Média de assistência última semana","ATTENDANCE_CHART":"","ATTENDANCE_DETAIL_BY_DATE":"Detalhe de assistência por data","ATTENDANCE_PERCENTAGE":"% Assistência","ATTENDANCE_PERCENTAGE_LAST_WEEK":"% Assistência última semana","ATTENDANCE_RATE":"Média de assistência","ATTENDANCE_REGISTRATION":"Registro de Assistência","ATTENDANCE_RISK_STUDENTS":"Estudantes com risco de assistência","AUTHENTICATION":"Autenticação","AVAILABLE_EVALUATIONS":"Avaliações disponíveis","CAL":"Qualificação","CLASS_NOTES":"Anotações de classe","CLASSES_WITH_ATTENDANCE":"Classes com assistência","COMPONENT_NAME":"Nome componente","COURSE_ATTENDANCE_REPORT":"Assistência por Curso","COURSE_IN_PROGRESS":"Em curso","COURSE_INFO":"Informação do curso","COURSE_STUDENT_LIST":"Lista de estudantes","COURSES_INFO":"Informação dos cursos","CREATE_EVALUATION_ESTRUCTURE":"Criar estrutura de avaliação","CURRENT":"Atual","CURRENT_CLASS":"Atualmente você está ditando a classe","DEL":"Delegado","DELEGATE":"Delegado","DELEGATES_ASSIGNMENT":"Lista de estudantes","DICTATED":"Ditadas","DOWNLOAD_RECORDS":"Baixar notas","DPI":"Reprovado por ausência","EDIT_ATTENDANCE":"Editar assistência","ENTER_GRADES":"Insira qualificação","EVALUATION_STRUCTURE_EMPTY_STATE":"Selecione uma estrutura de avaliação para ver os detalhes ...","EXECUTED_CLASSES":"Classes passadas","FINISH_CLASS":"Finalizar classe","FINISH_CLASS_ASK":"Você quer terminar a classe?","FORMULA":"Fórmula","GENERATE_RANDOM_CODE":"Gerar código aleatório","GENERATE_RANDOM_CODES":"","GRADE":"Nota","GRADES_REGISTERED":"Registro de notas já confirmado","HISTOGRAM":"Histograma","INDICATORS":"Indicadores","INDICATORS_BY_COURSE":"","INDICATORS_BY_STUDENT":"","INDICATORS_BY_TEACHER":"","INFO_ATTENDANCE_RISK_STUDENTS":"Informação de estudantes com risco de frequência","INFO_GRADES":"Informação das notas","INITIATED_CLASSES":"Classes iniciadas","JUSTIFIED":"Justificado","JUSTIFIED_LABEL":"J","LEVEL_SCHEME":"Níveis de desenvolvimento de conpetências","LIST_OF_COURSES":"Lista de cursos","LIST_OF_ONE":"Lista de 1","LIST_OF_STUDENTS":"Lista de estudantes","LIST_OF_TEACHERS":"Lista de professores","MANUAL_LABEL":"Manual","MANUALLY_REGISTERED":"Inserido manualmente","MASSIVE_STATUS_EDITOR":"","MAX_ABSENCES":"Máximo de ausências","MAXIMUM":"Máximo","MENU_ACHIEVEMENT_OF_COMPETENCIES":"Realização de competências","MENU_CONTENT_RECORDS":"Registro de Conteúdos","MENU_EVALUATION_STRUCTURES":"Estruturas de avaliação","MENU_EVALUATIONS":"Avaliações","MENU_GRADE_RECORDS":"Registro de notas","MENU_HISTORICAL_ATTENDANCE":"Assistência histórica","MENU_OPENING_OF_CLASES":"Abertura de classes","MENU_RANDOM_CODE_GENERATOR":"Gerador de códigos aleatórios","MENU_RANDOM_CODE_GENERATOR_BY_COURSE":"","MENU_RANDOM_CODE_GENERATOR_BY_PERIOD":"","MENU_RANDOM_CODE_VIEW":"","MENU_STRUCTURES_BY_SECTION":"Estruturas por seção","MENU_STUDENT_ATTENDANCE":"Assistência estudantes","MENU_STUDENT_STATUS":"Status de estudantes","MENU_TEACHER_ATTENDANCE":"Assistência de docentes","MINIMUM":"Mínimo","MODIFY_ATTENDANCE":"Modificar Assistência","MODULE_DAY":"Dia / Módulo","MSJ_DEFINITIVE_SENDING_OF_GRADES":"Você tem certeza de que enviou as notas? Após essa ação, você não poderá editá-las.","MSJ_DOESNT_HAVE_RANDOM_CODE":"Nesta avaliação não há um código aleatório. Você não pode carregar ou editar notas ainda.","MSJ_GRADES_WITH_TWO_DECIMALS":"As notas devem estar com dois decimais","MSJ_RESULT_CERO":"Estudante obteve um 0 em sua qualificação","MSJ_SELECT_REASON_FOR_GRADE":"Selecione a justificativa para a nota","MSJ_SENDING_SUCCEFULL_GRADES":"O registro de notas no Portal foi confirmado.","MSJ_STUDENT_DID_NOT_EVALUATION":"O estudante não fez a avaliação","MSJ_STUDENTS_WITHOUT_GRADES_TO_NR":"Estudantes que não fizeram avaliações","MUST_DICTATE_CLASS":"Próxima classe a ditar","MUST_PROGRAM_NEXT_CLASS":"Você deve agendar a próxima aula","N_ABSENTS_MIN":"N° A","N_OF_ASSISTANTS":"N° Participantes","N_OF_CLASSES":"N° de classes","N_OF_CLASSES_DICTATED":"N° de classes ditadas","N_OF_NRCS":"N° NRCs","N_PRESENTS_MIN":"N° P","NEXT_CLASS":"Próxima classe","NO_ATTENDANCE_PERCENTAGE":"% Ausência","NO_NEXT_CLASS":"Não contém próxima aula","NOT_REGISTERED":"Não registrado","NOT_REGISTERED_LABEL":"N","NOT_STARTED_CLASSES":"","NR":"Não fez","NRC_ATTENDANCE_AVERAGE":"Média assistência total NRCs","NRC_ATTENDANCE_AVERAGE_LAST_WEEK":"Média assistência total NRCs última semana","NUM_OF_INSCRIPTIONS":"N° de inscrições","OFFICIAL_GRADE":"Nota oficial","PERIOD_ATTENDANCE":"Assistência baseada no tempo","PLANNED_CLASSES":"Aulas planejadas até o momento","PRESENT":"Presente","PRESENT_LABEL":"P","PROFESSOR_ATTENDANCE_REPORT":"Assistência de Curso por Professor","PROM_ABSENTS_MIN":"Prom. A","PROM_PRESENTS_MIN":"Prom. P","RANDOM_CODE":"Código aleatório","RANDOM_CODE_GENERATED":"Lista de Códigos Gerados","RANDOM_CODE_GENERATOR_BY_COURSE":"","RANDOM_CODE_GENERATOR_BY_PERIOD":"","RANDOM_CODE_VIEW":"","REGISTER_ATTENDANCE":"Registrar assistência","REGISTER_CONTENT_EDIT":"Registrar mais conteúdos","REGISTER_CONTENTS":"Registrar conteúdos","REGISTER_NOTES":"Registrar anotações","REGISTRO_DE_NOTAS":"Registro de notas","RESUME_GRADES":"Resumo de Notas","RET":"Retirado","RETIRED":"Aluno retirado","RETIRED_LABEL":"Retirado","SAN":"Sancionado","SANCTIONED":"Aluno sancionado","SANCTIONED_LABEL":"Sancionado","SCHEDULED_CLASSES":"Classes agendadas para a data","SECTION_ATTENDANCE_PERCENTAGE":"% de assistência da seção","SECTION_ATTENDANCE_PERCENTAGE_LAST_WEEK":"% de assistência da seção na última semana","SECTION_INFORMATION":"Informação da seção","SECTIONS_BY_COURSES":"","SECTIONS_INFORMATION":"Informação das secções","SEE_GRADES":"Ver notas","SEE_RECORDS":"Ver notas","SELECCIONE_LA_ESTRUCTURA_QUE_DESEA_ASIGNAR":"Selecione a estrutura que você desejar designar","SHOW_GRAPHIC_BY":"Mostrar gráfico por","SIMULATED_RESULT":"Resultado simulado","START_CLASS":"Iniciar classe","STARTED_CLASSES":"","STUDENT_ATTENDANCE_INFO_FOR_SECTION":"Informação de assistência de alunos da seção","STUDENT_ATTENDANCE_REPORT":"Assistência por Estudante","STUDENT_BELONGS_ANOTHER_SECTION":"Estudante pertence a outra seção do mesmo curso","STUDENT_DETAIL":"Detalhe do Estudante","STUDENT_EXISTS_IN_CLASS":"O Estudante já está adicionado à classe atual","STUDENT_IN_DPI":"Estudante com DPI","STUDENT_INFO":"Informação do Estudante","STUDENT_LIST":"Lista de estudantes","STUDENT_NOT_FOUND":"O estudante não foi encontrado","SUBJECTS_INFORMATION":"Informação dos cursos","SUM":"Total","SUMAXIMUMM":"Máximo","TARDINESS":"Atrasos","TARDY":"Atrasado","TARDY_LABEL":"D","TEACHER_CLASS_NOTES":"Anotações de classes de professor","TEACHER_DETAIL":"Detalhe do professor","TEACHER_INFO":"Informação do professor","TOTAL_ABSENT_STUDENTS":"Total Estudantes ausentes","TOTAL_CLASSES_IN_PERIOD":"Total classes do período","TOTAL_CLASSES_INITIATED":"Total classes iniciadas","TOTAL_CLASSES_NOT_INITIATED_WITH_ATTENDANCE":"Total classes não iniciadas com assistência","TOTAL_CLASSES_NOT_INITIATED_WITHOUT_ATTENDANCE":"Total classes não iniciadas sem assistência","TOTAL_CLASSES_TO_DATE":"Total classes até a data","TOTAL_PLANNED_CLASSES":"Classes totais planejadas","TOTAL_PRESENT_STUDENTS":"Total estudantes presentes","TOTAL_TARDY_STUDENTS":"Total Estudantes atrasados","U_CLASS":"u-class","U_GRADES":"Registro de notas","UPLOAD_FILES_OF":"Face de arquivos de","UPLOAD_RECORDS":"Carregar notas","UPLOAD_RESULTS":"Carregar resultados","USE_IN_ANY_FORMULA":"Incluir em qualquer fórmula","VALID_STUDENT":"Este Estudante é válido","VIEW_CONSOLIDATED_GRADES":"","VIEW_EDIT_ATTENDANCE":"Visualizar e editar assistência","VIEW_EDIT_CONTENT":"Visualizar e editar conteúdo","VIEW_EDIT_CONTENTS":"Visualizar e editar conteúdo","VIEW_EDIT_GRADES":"Visualizar e editar notas","WARNING_GRADE_OUT_MIN_MAX":"","WITHOUT_CLASS":"Sem classe atualmente","WORKFLOW_FLOW":"Workflows","YEAR_OF_ENTRY":"Ano de entrada","ZERO_DIFFERENTIATION":"Diferenciação de 0","ACADEMIC_UNIT_ROLE":"Cargo Unidade Acadêmica","ADD_ACADEMIC_UNIT":"Adicionar unidade acadêmica","ADD_CONTRACT_TYPE":"Adicionar tipo de contrato","ASSIGNED_MODULES":"Módulos atribuídos","ASSIGNED_SECTIONS":"","CALENDAR_INFORMATION":"Informação do calendário","CONTRACT_CODE":"Código do contrato","CONTRACT_NAME":"Nome do contrato","CONTRACT_TYPE":"Tipo de contrato","COURSE_ACTIVITY_HOUR_COST":"Valor hora curso atividade","COURSES_LIST":"Lista de cursos","CREATE_ACADEMIC_CALENDAR":"Criar calendário académico","CREATE_NEW_ELECTIVE_BLOCK":"Criar um novo bloco eletivo","CREATE_SCHEME":"","CREATE_TEACHER":"Criar docente","DEPARTMENT_POSITION":"","EDIT_SCHEME":"","EDIT_TEACHER":"Editar docente","ELECTIVE_BLOCK_MANAGEMENT":"Administrador de blocos eletivos","ELECTIVE_BLOCK_PLAN":"Plano curso eletivo","FACULTY_MANAGEMENT":"Faculdades","HELP_COURSE_ACTIVITY_HOUR_COST":"Texto de ajuda para Valor hora curso actividade","HELP_EDIT_ACADEMIC_CALENDAR":"Seleccione las semanas que conformarán el nuevo calendario académico","HELP_EDIT_ADD_TEACHER":"A partir desta tela é possível criar, editar e consultar docentes no sistema. É possível associá-los a um departamento e campus, definindo um tipo de contrato e ativando ou desativando o uso desse docente para simulações. As informações do docente podem ser mantidas sincronizadas ou fora de sincronia com as atualizações de integração de dados.","HELP_ELECTIVE_BLOCK_MANAGEMENT":"Texto de ajuda para blocos eletivos","HOUR_COST":"Hora custo","INFRASTRUCTURE":"Infraestrutura","LEVEL_SCHEME_MANAGER":"","LEVELS":"","MAX_AVAILABLE_MODULES":"Máximo módulos livres","MAX_CAMPUS_PER_DAY":"Máximo de campus por dia","MAX_CAMPUS_PER_WEEK":"Máximo de campus por semana","MAX_CONSECUTIVE_MODULES":"Máximo de módulos consecutivos","MAX_MODULES_PER_DAY":"Máximo de módulos por dia","MAX_MODULES_PER_WEEK":"Máximo de módulos por semana","MAX_PAUSED_MODULES":"Máximo de módulos de pausa","MAX_SECTIONS_PER_DAY":"Máximo de seções por dia","MAX_SECTIONS_PER_WEEK":"Máximo de seções por semana","MSJ_ACADEMIC_CALENDAR":"Use o Calendário Acadêmico para determinar um intervalo de tempo de Semanas - Dias - Módulos em um espaço determinado pelo Campus - Período - Seminário e, em seguida, atribua-os a determinadas seções e melhore sua organização.","MSJ_ACADEMIC_CALENDAR_CREATED_SUCCESS":"","N_OF_IMPLICATED_MODULES":"Número de módulos comprometidos","N_OF_IMPLICATED_SECTIONS":"Número de seções comprometidas","NEW_ACADEMIC_CALENDAR":"","NEW_SCHEME":"","PERIODS_MANAGEMENT":"Períodos (Ciclos)","PRIORITY":"Prioridade","SELECT_ACADEMIC_PLAN":"","TEACHER_PROFILE":"Perfil docente","U_CORE":"configuração","MENU_REFERENCE_SURVEYS":"Pesquisas de referência","MENU_SURVEYS":"Pesquisas","U_ENROLLMENT":"u-enrollment","ACADEMIC_SCHEDULE_SELECTION":"Seleção de horário académico","ADVANCE_ASSIGNATION_SECTION":"","ADVANCE_ASSIGNATION_SUBJECT":"Progresso atribuição por matéria","ALL_SECTIONS":"Todas as seções","AUTOMATIC_ASSIGNATION":"Atribuição automática","CONFIRM_DELETE_SCENARIO_MSJ":"Você tem certeza de que deseja excluir a seleção?","CONFIRM_UNASSIGN_RESOURCE":"Confirmar retirar recurso","CONFIRM_UNASSIGN_SCHEDULE":"Confirmar retirar horário","CONFIRM_UNASSIGN_SUPERVISOR":"Confirmar retirar supervisor","CREATE_SCENARIO":"Criar cenário","CREATE_SCENARIO_BY_SECTION":"Criar cenário por seção","CREATE_SCENARIO_BY_STUDENT":"Criar cenário por Estudante","CREATE_STAGE":"Criar cenário","DELETE_SCENARIO":"Você tem certeza de que deseja excluir esses registros?","ENTER_MANIMUM_CAPACITY":"Insira capacidade mínima","ENTER_MAXIMUM_CAPACITY":"Insira capacidade máxima","EVALUATION_MANAGEMENT":"Evaluations Management","EVALUATION_TYPE":"Tipo de Avaliação","EXAM-NAME":"Nome exame","GROUP":"Grupos","MANUAL_ASSIGNATION":"Atribuição manual","MANUAL_ASSIGNMENT_RESOURCE":"Atribuição manual de recurso","MANUAL_SUPERVISOR_ASSIGNMENT":"Atribuição manual de supervisor","MAXIMUM_CAPACITY":"Capacidade máxima","MAXIMUM_DAILY_EXAMS_PER_STUDENT":"Máximo exames diários por aluno","MSJ_AUTOMATIC_ASSIGNMENT_STARTED_CORRECTLY":"","MSJ_CAN_NOT_SHOW_CALENDER":"Não é possível mostrar o calendário porque não tem semanas","MSJ_CONFIRM_UNASSIGN_RESOURCE":"Você tem certeza de que deseja eliminar a atribuição de recurso para a seleção ?","MSJ_CONFIRM_UNASSIGN_SCHEDULE":"Você tem certeza de que deseja eliminar a atribuição de horário para a seleção? Isto implica desfazer a atribuição de Recursos e Supervisor","MSJ_CONFIRM_UNASSIGN_SUPERVISOR":"Você tem certeza de que deseja eliminar a atribuição de supervisor da seleção?","MSJ_CONFLICTS_OCCURED_FOR":"Nota: houveram conflitos por","MSJ_DOWNLOADED_SUCESSFULLY":"Download com sucesso","MSJ_MODULE_INSERTED_SUCCESSFULLY":"Módulo inserido com sucesso","MSJ_MODULE_SHOULD_BE_CONSECUTIVE":"O módulo deve ser consecutivo","MSJ_NO_ASSIGNED_WEEKS_FOUND":"Nenhuma semana atribuída foi encontrada","MSJ_SCHEDULE_IS_NOT_YET_CREATED":"O horário não foi criado","MSJ_THE_CHANGES_HAVE_NOT_BEEN_EXECUTED":"As alterações não foram executadas","MSJ_THERE_ARE_NO_AVAILABLE_WEEK":"Não há semanas disponíveis para os filtros selecionados","MSJ_YOU_MUST_ASSIGN_SCHEDULE_BEFORE":"","NAME_EVALUATION":"Nome avaliação","REP_ASSIGNMENT_RESULTS":"Resultados de Atribuição","REP_DATA_VALIDATION":"Validação de Dados","REP_LOADED_DATA":"Dados Carregados","RESOURCE_ASSIGNATION":"Atribuição recurso","RESOURCE_CONFLICT":"Conflito de recurso","RESOURCE_DELETED_SUCCESSFULLY":"Recurso retirado com sucesso","RESOURCE_SCHEDULE_BASELINE":"Linha base recurso/horário","SCENARIO":"Cenário","SCENARIO_INFO":"Informação de cenário","SCENARIOS":"Cenários","SCENARIOS_INFO":"Informação de cenários","SCHEDULE_AND_RESOURCE":"Horário e Recurso","SCHEDULE_ASSIGNATION":"Atribuição horário","SCHEDULE_DELETED_SUCCESSFULLY":"Horário retirado com sucesso","SCHEDULE_RANK":"Intervalo Horário","SCHEDULE_RANK_SELECT":"Selecionar Intervalo Horário","SCHEDULE_RESOURCE_AND_SUPERVISOR":"Horário, Recurso e Supervisor","SEARCH_RESOURCE":"Pesquisar recurso","SECTION_ASSIGNATION":"Atribuição seção","SECTION_DETAILS":"Detalhe Seções","SECTIONS_WITH_ASSIGNED_SCHEDULE_ONLY":"Seções com horários atribuídos","SECTIONS_WITH_ONLY_RESOURCE_ASSIGNED":"Seções com recursos atribuídos","SECTIONS_WITH_ONLY_SUPERVISORS_ASSIGNED":"Seções com supervisores atribuídos","SECTIONS_WITH_SCHEDULE_AND_ASSIGNED_RESOURCE":"Seções com horários e recursos atribuídos","SECTIONS_WITH_SCHEDULE_AND_SUPERVISOR_ASSIGNED":"Seções com horários e supervisores atribuídos","SECTIONS_WITH_SCHEDULE_RESOURCE_AND_SUPERVISOR_ASSIGNED":"Seções com horários, recursos e supervisores atribuídos","SECTIONS_WITHOUT_ASSIGNMENTS":"Seções sem atribuição","SEE_EDIT_SCENARIO":"Visualizar / editar cenário","SELECT_AUTOMATIC_ASSIGNMENT":"Selecionar atribuição automática","SELECT_BASE_LINE":"","SELECT_EVALUATION_TYPE":"Selecione o tipo de avaliação","SELECT_MANUAL_ASSIGNMENT":"Selecionar atribuição manual","SELECT_RESOURCE_MSJ":"Selecione um recurso","STUDENTS_WITH_A_GROUP_ASSOCIATED":"","STUDENTS_WITHOUT_A_GROUP_ASSOCIATED":"","SUBJECT_ASSIGNATION":"Atribuição matéria","SUPERVISOR":"Supervisor","SUPERVISOR_ASSIGNATION":"Atribuição supervisores","SUPERVISOR_ASSIGNED_SUCCESSFULLY":"Supervisor atribuído com sucesso","SUPERVISOR_BASELINE":"Linha base supervisor","SUPERVISOR_DELETED_SUCCESSFULLY":"Supervisor retirado com sucesso","SUPERVISOR_SEARCH_INFORMATION":"Informação pesquisa de supervisor","U_EXAM":"u-exam","UNASSIGN_MANUAL":"Retirar Manual","UNASSIGNED_STUDENTS":"","UNSELECT_BASE_LINE":"","ACADEMIC_PERIOD":"Período Acadêmico","ACADEMIC_PERIOD_TYPE":"Tipo de período","ACADEMIC_QUOTA":"Quota Acadêmica","ACTIVITIES":"Atividades","ADD":"Adicionar","ADD_BLOCK":"Adicionar bloco","ADD_ESPECIALITIES":"Adicionar especialidade","ADD_NEW_PERIOD":"Adicionar novo período","ADD_THEME":"Adicionar tema","AGREE":"Aceitar","APA_LIBRARY":"","ATTITUDINAL_KNOWLEDGE":"Conhecer atitude","AUTOMATIC_ATTENDANCE":"Assistência automática","BASIC_BIBLIOGRAPHY":"Bibliografia básica","BLOCK_CODE":"Código do bloco","BLOCK_END_LEVEL":"Nível final","BLOCK_MIN_CREDITS":"Créditos mínimos","BLOCK_NAME":"Nome do bloco","BLOCK_START_LEVEL":"Nível inicial","BLOCK_SUBJECTS":"Cursos do bloco","BOOK_ELECTRONIC_VERSION":"","BOOK_MORE_THAN_FIVE_AUTHORS":"","BOOK_UP_TO_FIVE_AUTHORS":"","CANT":"Quantidade","CAREER_CODE":"Código Carreira","CAREER_NAME":"Nome Carreira","CAREER_PENSUM":"Carreira","CHANGES":"Alterações","CLONING":"Clonagem","CO_REQUIREMENTS":"Co-requisitos","COMPETENCE_PENSUM_PROGRESS":"Realização de competências","COMPETENCIES":"Competências","COMPETENCIES_COMPETENCY_LEVELS_VIEW":"Competências e níveis de desenvolvimento","COMPETENCY":"Competência","COMPETENCY_ACHIEVEMENTS_EVALUATION":"Avaliação Realizações de Competências","COMPETENCY_CODE":"Código Competência","COMPETENCY_COMPETENCY_LEVEL":"Compêtencia Nível","COMPETENCY_DESCRIPTION":"Descrição da competência","COMPETENCY_ID":"Competência","COMPETENCY_LEVEL_CODE":"Código do nível de desenvolvimento","COMPETENCY_LEVEL_DESCRIPTION":"Descrição do nível de desenvolvimento","COMPETENCY_LEVEL_ID":"Competência","COMPETENCY_LEVEL_NAME":"Nome do nível de desenvolvimento","COMPETENCY_LEVELS":"Níveis de Desenvolvimento","COMPETENCY_LEVELS_PANEL":"Painel de níveis de competências","COMPETENCY_MATRIX_CODE":"Código de Matriz","COMPETENCY_MATRIX_ID":"Matriz","COMPETENCY_MATRIX_MAINTAINER":"Administrador de matrizes de competência","COMPETENCY_MATRIX_NAME":"Nome da Matriz","COMPETENCY_NAME":"Nome da competência","COMPETENCY_SCOPE":"Âmbito de ação","COMPETENCY_SCOPE_ID":"Competência","COMPETENCY_SCOPE_NAME":"Âmbito de ação","COMPLETE_WEBSITE":"","COMPONENT_CODE":"Código Avaliação","componentCode":"","componentDate":"","componentName":"","componentWeight":"","CONCEPTUAL_KNOWLEDGE":"Conhecimento conceitual","CONFIG_WORKFLOW_PERMISSIONS":"Configuração de permissão de workflow","CONSECUTIVE_HOURS":"Horas consecutivas","CONTENT":"Conteúdo","CONTENTS_OCURRENCE":"","CONTENTS_PANEL":"Conteúdo","COURSE_ACADEMIC_INTEGRITY":"Integridade Acadêmica","COURSE_ACHIEVEMENT_DESCRIPTOR":"Descritor de Realização","COURSE_ACHIEVEMENT_DESCRIPTOR_ID":"Descritor de Realização","COURSE_ACTIVITIES":"Atividade","COURSE_ACTIVITY":"Atividades","COURSE_ACTIVITY_TYPE":"Tipo de atividade","COURSE_APROVAL_CONDITIONS":"Condições de aprovação","COURSE_ATTENDANCE_RULES":"Regras de Assistência","COURSE_CHANGES_HISTORY":"Histórico de Mudanças","COURSE_COMPETENCIES":"Competências que o curso contribui","COURSE_COMPETENCIES_PANEL":"Competências","COURSE_COMPETENCIES_SECTION":"Competências","COURSE_COMPETENCY_TRIBUTE":"Contribuição do curso a competências","COURSE_CONTENTS":"Conteúdos do curso","COURSE_CREDITS":"Créditos","COURSE_DESCRIPTION":"Descrição do Curso","COURSE_DESCRIPTION_PANEL":"Descrição do Curso","COURSE_DESCRIPTION_SECTION":"Descrição do Curso","COURSE_DISCIPLINE":"Disciplina","COURSE_EDUCATION_LEVEL":"Nivel educativo","COURSE_ENGLISH_NAME":"Nome em inglês","COURSE_EVALUATION":"Avaliação","COURSE_EVALUATION_ID":"Avaliação","COURSE_EVALUATION_METHOD":"Meios de avaliação","COURSE_EVALUATION_METHOD_ID":"Método de avaliação","COURSE_EVALUATION_PROCEDURES":"Procedimentos de avaliação","COURSE_EVALUATION_STRUCTURE":"Estrutura de Avaliação","COURSE_EVALUATIONS":"Avaliações","COURSE_EVIDENCES":"Evidências do Curso","COURSE_EVIDENCES_GRID":"Evidências","COURSE_EVIDENCES_TABLE":"Evidências","COURSE_GENERAL_DATA":"Informações Gerais do Curso","COURSE_GENERAL_INFO":"Informação Geral do Curso","COURSE_HOURS":"Horas de curso","COURSE_HRS_ACTIVITY_STUDENT":"Horas atividade aluno","COURSE_HRS_STUDENT":"Horas estudo aluno","COURSE_HRS_TEACHER":"Horas com docente","COURSE_LANGUAGE":"Idioma","COURSE_LEARNING_EVIDENCES":"Evidência de Aprendizagem","COURSE_MARK_TYPE":"Tipo de Qualificação","COURSE_METHODOLOGY":"Metodologia","COURSE_MODALITIES":"Modalidade do curso","COURSE_MODALITIES_ACTIVITIES":"Modalidades e Atividades do Curso","COURSE_MODALITY":"Modalidade","COURSE_OBJECTIVES":"Objetivos do Curso","COURSE_OBJECTIVES_PANEL":"Objetivos do Curso","COURSE_OBJECTIVES_SECTION":"Objetivos do Curso","COURSE_OTHERS":"","COURSE_OTHERS_PANEL":"","COURSE_OUTCOMES":"Resultados de Aprendizagem do Curso","COURSE_OUTCOMES_CONTENT_PANEL":"Aprendizagens esperadas e unidades de conteúdo","COURSE_OUTCOMES_ID":"Resultados de Aprendizagem do Curso","COURSE_OUTCOMES_PANEL":"Resultados de aprendizagem","COURSE_OUTCOMES_SELECT":"Resultados de Aprendizagem do Curso","COURSE_POLICIES":"Políticas do curso","COURSE_POLICIES_PANEL":"Políticas do curso","COURSE_PREVIOUS_KNOWLEDGE":"Conhecimento prévio sugerido","COURSE_PREVIOUS_KNOWLEDGE_PANEL":"Conhecimento prévio sugerido","COURSE_PROFESSIONAL_LINKING":"Ligação profissional","COURSE_REFERENCE_CATEGORY":"Categoria de Bibliografia","COURSE_REFERENCES":"Referências bibliográficas e websites","COURSE_REFERENCES_NOTES":"Notas sobre bibliografia e websites","COURSE_REFERENCES_NOTES_PANEL":"Notas sobre bibliografia e websites","COURSE_REQUIREMENTS":"Pré-requisitos","COURSE_REQUIREMENTS_NOTES":"Notas dos Requisitos do Curso","COURSE_REQUIREMENTS_NOTES_PANEL":"Notas adicionais","COURSE_RULES":"Regras da classe","COURSE_SESSIONS":"Classes","COURSE_SUBTHEMES":"Subtemas","COURSE_SUCCESS_SUGGESTIONS":"Sugestões para ter sucesso no curso","COURSE_THEME":"Temas","COURSE_THEME_DESCRIPTION":"Descrição do tema","COURSE_TYPE_IN_PENSUM":"Tipo de Curso","COURSE_VOCATIONAL_MATTER":"Importância para a formação","COURSES_COREQUISITES":"Co-requisitos","COURSES_PREREQUISITES":"Pré-requisitos","CREATE_MATRIX":"Criar matriz de competência","CREATE_NEW_ONE":"Criar novo","CREATE_PERIOD_TYPE":"Criar tipo de período","CREDITS":"Créditos","CURRICULAR_PROGRESS":"Acompanhamento","CYCLES":"Ciclos","DATABASE_THESIS":"","DATE":"Data","DEPARTMENT":"Departamento","DESCRIPTION_MESSAGE_DEFAULT":"Digite a descrição","DESTINY_SECTIONS_LIST":"Lista de seções de destino","DETAIL":"Detalhe","DOWNLOAD_REPORT":"Download do relatório","EBOOK":"","EDIT_MATRIX":"Edite a matriz da competição","EDIT_STUDYPLAN":"Editar plano de estudo","EDIT_TRIBUTES":"Editar tributação","END_MESSAGE_EXPLAIN_CLONING":"para executar a clonagem","ENTER_REQUEST_COMMENTS":"Insira comentários a pedido","EQUIVALENT_COMPETENCES":"Competência Equivalente","ERROR_CLONING_PROCESS":"Impossível conectar-se ao serviço","ERROR_GREATER_THAN":"","ERROR_GREATER_THAN_EQUAL":"","ERROR_LESS_THAN":"","ERROR_LESS_THAN_EQUAL":"","EVALUATION_CODE":"Código","EVALUATION_DATE":"Data","EVALUATION_IS_ATTITUDE":"Atitudes","EVALUATION_IS_KNOWLEDGE":"Conhecimento","EVALUATION_IS_PRACTICE":"Procedimentos","EVALUATION_IS_PROCESS":"De processo","EVALUATION_IS_PRODUCT":"Do produto","EVALUATION_METHODS":"Métodos de avaliação","EVALUATION_PERCENTAGE":"Percentagem","EVALUATION_STRUCTURE":"Estrutura de Avaliação","EVALUATIONS_COMMENTS":"Comentários gerais sobre a avaliação","EVALUATIONS_COMMENTS_PANEL":"","EVALUATIONS_NOTE1":"Nota","EVALUATIONS_NOTE2":"Nota","EVIDENCE_TRACKING":"Acompanhamento","EVIDENCES":"Evidências","EVIDENCES_CARD_PANEL":"Evidências das realizações dos resultados de aprendizagem","FACULTY":"Faculdade / Escola","FACULTY_CODE":"Código de Faculdade / Escola","FACULTY_DEPARTMENT":"Faculdade - Departamento","FACULTY_INSTITUTION":"Instituição","FACULTY_NAME":"Nome da Faculdade / Escola","FILE_PANEL":"","FILL_REQUIRED_INPUTS":"Você deve preencher todos os campos obrigatórios","FILTER_AS":"Filtrar por","FILTER_MAIN_PANEL":"","FINAL_COLLEGIATE":"Colegiado final","FINISH_CLONING_PROCESS":"Processo concluído","FRECUENCY":"Freqüência","GENERIC_WARNING":"Alerta","HALF_LENGTH":"Médio prazo","HOURS_PER_WEEK":"Horas por semana","IFR_TYPE_RESOURCE_ID":"Tipo de Recurso","IFR_TYPE_RESOURCE_NAME":"Tipo de Recurso","IFR_USE_TYPE_ID":"Tipo de uso","IFR_USE_TYPE_NAME":"Tipo de uso","IMPROVE_ACTIVITY":"Atividade","IMPROVE_ADD_ACTIVITY":"Adicionar atividade","IMPROVE_ADD_MODALITY":"Adicionar modalidade","IMPROVE_ALL_COURSES":"Todos os cursos","IMPROVE_CAPTURED":"Capturado","IMPROVE_CAPTURED_DESCRIPTION":"Programas de ensino capturados e completos","IMPROVE_CAREER":"Carreira","IMPROVE_CAREER_LIST":"Carreira","IMPROVE_CARRER_TYPE":"Tipo de carreira","IMPROVE_CHARGE":"Cargo","IMPROVE_COMPETENCY_MATRIX":"Competências","IMPROVE_COURSE_NAME":"Nome do curso","IMPROVE_COURSE_PROGRAM":"Programa do curso","IMPROVE_COURSES":"Lista de Cursos","IMPROVE_CREATE_CAREER":"Criar carreira","IMPROVE_CREATE_COURSE":"Criar matéria","IMPROVE_CREATE_FACULTY":"Criar Faculdade","IMPROVE_CREDITS_BY_PERIODS":"Créditos por período","IMPROVE_CURRICULAR_SYNTHESIS":"Síntese curricular","IMPROVE_CYCLES":"Ciclos","IMPROVE_DELETE":"Excluir","IMPROVE_DEPARTMENT":"Departamento","IMPROVE_DOWNLOAD_REPORT":"Download relatório","IMPROVE_EDIT_CAREER":"","IMPROVE_EMAIL":"Email","IMPROVE_EVALUATION_MOMENTS":"Momento em que se avalia","IMPROVE_EVALUATION_OR_STRATEGY":"Estratégia ou meios de avaliação","IMPROVE_EVALUATION_RESULTS":"Resultados da avaliação","IMPROVE_EVALUATION_TYPE":"Tipo de avaliação","IMPROVE_FACULTY":"Faculdades","IMPROVE_FACULTY_LIST":"Faculdade","IMPROVE_FILE_NAME":"Nome do arquivo","IMPROVE_FRECUENCY":"Freqüência","IMPROVE_GOAL_LEVEL":"Nível de realização","IMPROVE_GRADUATION_COMPETITION":"Competências Formadas","IMPROVE_INFO":"Informação da matéria","IMPROVE_INFO_CAREER":"Informação da carreira","IMPROVE_INFO_FACULTY":"Informação da faculdade","IMPROVE_INFORMATION_PERIOD":"Informação do período","IMPROVE_KEY":"Chave","IMPROVE_LOAD_FILE":"Carregar arquivo","IMPROVE_MAINTAINER":"Administradores","IMPROVE_MONITORING_EVIDENCES":"Evidência de realizações de competências","IMPROVE_MY_ACCOUNT":"Minha conta","IMPROVE_MY_PROFILE":"Meu perfil u-improve","IMPROVE_NEW_CAREER":"Criar nova carreira","IMPROVE_NEW_COURSE":"Criar nova matéria","IMPROVE_NEW_FACULTY":"Criar nova faculdade","IMPROVE_PASSWORD":"Senha","IMPROVE_PASSWORD_CONFIRM":"Confirmar senha","IMPROVE_PENDING":"Pendências","IMPROVE_PENDING_DESCRIPTION":"Programas magisteriais a serem capturados","IMPROVE_PERIOD":"Período","IMPROVE_PERIOD_NAME":"Nome do período","IMPROVE_PERIOD_TYPE":"Tipo de período","IMPROVE_PHONE":"Telefone","IMPROVE_PROFESSOR":"Professor","IMPROVE_PROGRESS":"Progresso","IMPROVE_PROPOSED_MONITORING":"Monitoramento proposto","IMPROVE_PUBLISHED":"Publicados","IMPROVE_PUBLISHED_DESCRIPTION":"Aprovados pelo coordenador e visíveis para os alunos","IMPROVE_REPORTS":"Relatórios","IMPROVE_RESPONSABLE":"Responsável","IMPROVE_SECTION":"Seção","IMPROVE_SECTION_CAPTURED":"Capturado","IMPROVE_SECTION_OPEN":"Aberto","IMPROVE_SECTION_PENDING":"Pendente","IMPROVE_SECTION_PROGRESS":"Em curso","IMPROVE_SECTION_PUBLISHED":"Publicado","IMPROVE_SECTION_STRUCTURE_IN":"Com estrutura","IMPROVE_SECTION_STRUCTURE_OUT":"Sem estrutura","IMPROVE_SECTION_TRACKING":"Em acompanhamento","IMPROVE_SECTION_WAITING":"Em espera","IMPROVE_SELECT_SECTION":"Selecione uma seção","IMPROVE_SHOW_ONLY_TRACKING":"Mostrar apenas cursos em acompanhamento","IMPROVE_SIZE":"Tamanho","IMPROVE_STATE":"Estado","IMPROVE_STUDY_PLAN":"Plano de estudo","IMPROVE_STUDY_PROGRAM":"Plano de estudo","IMPROVE_SUBJECTS_LIST":"Lista de Cursos","IMPROVE_SYLLABUS":"Syllabus","IMPROVE_SYLLABUS_TRACKING":"Acompanhamento Syllabus","IMPROVE_TITLE":"u-improve","IMPROVE_TRACKING":"Acompanhamento","IMPROVE_UPDATE_ACTIONS":"Ações de atualização","IMPROVE_USAGE_TYPE":"Tipo de uso","IMPROVE_USERNAME":"Nome de usuário","IMPROVE_VERSION":"Versão","IMPROVE_WAITING":"Em espera","IMPROVE_WAITING_DESCRIPTION":"Aguardando aprovação do coordenador","IMPROVE_WEEKS_NUMBER":"N° Semanas","INDICADORES_DE_LOGROS":"Realização de competências","INFRAESTRUCTURE_REQUIREMENTS":"Requisitos de infraestrutura","INFRAESTRUCTURE_REQUIREMENTS_TABLE":"Requisitos de infraestrutura","INSERT_COMPETENCY_CODE":"Inserir código de competências","INSERT_COMPETENCY_NAME":"Nome de Competência","INSERT_COURSE_OUTCOMES":"","INSERT_COURSE_SUBTHEMES":"","INSERT_LEARNING_STRATEGIES":"","INSERT_NEW_RECORD":"Adicionar evidência","INSERT_REFERENCE_ADDED":"","INSERT_REFERENCE_NAME":"","INSERT_SECTION_LEARNING_STRATEGIES":"","INSERT_SESSION_LEARNING_STRATEGIES":"","INSERT_SESSION_LEARNING_STRATEGIES_ADD":"","INSERT_SESSION_RESOURCES":"","INSERT_SESSION_SUBTHEMES_ADDED":"","INSERT_SESSION_SUBTHEMES_ADDED_ADD":"","INSTITUTIONAL_THESIS":"","INSTRUMENT":"Instrumento","INTERNATIONAL_STRATEGIES":"Estratégias para favorecer a internacionalização","IS_CLASSRROM_REQUIRED":"Requer Sala","IS_CONTRIBUTING":"Tributa às Competências","IS_GROUP_EVALUATION ":"Grupo","IS_ONLINE":"Atividade on-line","IS_SCHEDULE_REQUIRED":"Requer horário","IS_TEACHER_REQUIRED":"Requer professor","isGruopEvaluation":"","KEY_WORDS":"Palavras chave","LABEL_ADMIN":"Administrador","LABEL_COORD":"Coordenador","LABEL_STUDENT":"Estudante","LABEL_TEACHER":"Professor","LAW":"","LEARNING_AREA":"Área de Aprendizagem","LEARNING_EVIDENCES":"Evidência de Aprendizagem","LEARNING_STRATEGIES":"Estratégias de Aprendizagem","LEARNING_STRATEGIES_PANEL":"Estratégias de aprendizagem","LEARNING_SUBAREA":"Sub-área de aprendizagem","MAGAZINE_ARTICLE_IN_DATABASE":"","MAIN_SECTION_TEACHER":"Professor mestre","MAIN_SECTION_TEACHER_MAIL":"E-mail professor titular","MAIN_SECTION_TEACHER_PHONE":"Telefone professor titular","MATRIX_CAREER_CODE":"Cód. Carreira","MATRIX_CAREER_NAME":"Carreira","MATRIX_DESCRIPTION":"Descrição da Matriz de Competências","MATRIX_FACULTY_CODE":"Cód. Faculdade","MATRIX_FACULTY_NAME":"Faculdade","MATRIX_GENERAL_DATA":"Dados gerais","MATRIX_GENERAL_INFO":"Informação Geral da Matriz de Competências","MATRIX_PENSUM_CODE":"Cód. Plano de Estudo","MATRIX_PENSUM_NAME":"Plano de Estudo","MATRIX_STUDYPLAN_ASSOCIATED":"Planos de estudo associados","MATRIX_TYPE":"Tipo Matriz","MESSAGE_EXPLAIN_CLONING":"Com esta ação, você pode clonar o Syllabus da seção selecionada até a seção de destino através do botão 'Clone'","MIN_CREDITS":"Créditos mínimos","MODALITIES":"Modalidades","MOMENT":"Momento","MOVIE":"","NEW_STUDYPLAN":"Criar Plano de Estudo","NEWSLETTER_ARTICLE":"","NEWSLETTER_ARTICLE_NO_AUTHOR":"","OBLIGATORY_SUBJECTS":"Cursos obrigatórios","ONLINE_THESIS":"","OUTCOME_KNOWLEDGE":"Conhecimento do resultado da aprendizagem","OUTCOME_NAME":"Resultado de aprendizagem","PART_OF_A_BOOK":"","PENSUM_ACADEMIC_INFO":"Informação acadêmica","PENSUM_ADMISSION_PROFILE":"Perfil de entrada","PENSUM_BLOCKS":"Cursos do bloco","PENSUM_CAMPUS":"Campus","PENSUM_CODE":"Código Plano de Estudo","PENSUM_GENERAL_DATA":"Informação Geral","PENSUM_GENERAL_INFO":"Dados gerais do plano de estudo","PENSUM_GRADUATE_PROFILE":"Perfil de graduação","PENSUM_ID":"Plano de estudo","PENSUM_IMPARTITION_MODE":"Modo de ensino","PENSUM_MODALITY":"Modalidade","PENSUM_NAME":"Nome Plano de Estudo","PENSUM_PUBLICATION_DATE":"Data de publicação","PENSUM_SIGNATURES":"Cursos obrigatórios","PENSUM_SPECIALTIES":"Cursos de especialidade","PENSUM_VALIDITY_END_DATE":"Data de término","PENSUM_VALIDITY_START_DATE":"Data de início","PENSUM_VIGENCY_INFO":"Informação de vigência","PERIOD_TYPE":"Tipo de período","PLAN_SUBJECT":"Cursos do Plano","PRE_REQUIREMENTS":"Pré-requisitos","PREPARING_TO_PRINT":"Preparando a impressão ...","PRINT_LINK_PROMPT":"Se a sua impressão não iniciar automaticamente, clique no seguinte link:","PROCEDURAL_KNOWLEDGE":"Conhecimento processual","REFERENCE_ADDED":"Referências adicionais","REFERENCE_ARTICLE_TITLE":"","REFERENCE_AUTHOR":"Autor","REFERENCE_CHAPTER_TITLE":"","REFERENCE_COURT":"","REFERENCE_DATABASE":"","REFERENCE_DOI":"","REFERENCE_EDITOR":"Editor","REFERENCE_EDITOR_MENTION":"","REFERENCE_EDITORIAL":"Editorial","REFERENCE_FIFTH_AUTHOR":"","REFERENCE_FORMAT":"","REFERENCE_FOURTH_AUTHOR":"","REFERENCE_ID":"","REFERENCE_INFO_TITLE":"","REFERENCE_ISBN":"Código ISBN","REFERENCE_LAST_AUTHOR":"","REFERENCE_LAW_TITLE":"","REFERENCE_MAGAZINE_NAME":"","REFERENCE_MOVIE_DIRECTOR":"","REFERENCE_MOVIE_PRODUCER":"","REFERENCE_MOVIE_STUDIO":"","REFERENCE_MOVIE_TITLE":"","REFERENCE_NAME":"Referência","REFERENCE_NEWSLETTER_NAME":"","REFERENCE_OFFICIAL_SOURCE":"","REFERENCE_ORIGIN":"","REFERENCE_PAGES":"","REFERENCE_PUB_CITY":"","REFERENCE_PUB_COUNTRY":"","REFERENCE_PUB_DATA":"","REFERENCE_PUB_MONTH":"","REFERENCE_PUB_PLACE":"Lugar de publicação","REFERENCE_PUB_YEAR":"","REFERENCE_PUBLISHER":"","REFERENCE_RECOVERED_DATE":"","REFERENCE_SEARCH":"Pesquisa de referências","REFERENCE_SECOND_AUTHOR":"","REFERENCE_SENTENCE_COUNTRY":"","REFERENCE_SENTENCE_DATE":"","REFERENCE_SENTENCE_NUMBER":"","REFERENCE_SOFTWARE_DESCRIPTION":"","REFERENCE_SOFTWARE_TITLE":"","REFERENCE_TABLE":"Referências","REFERENCE_TABLE_ADDED":"Referências adicionais","REFERENCE_THESIS_CATEGORY":"","REFERENCE_THESIS_DATABASE":"","REFERENCE_THESIS_INSTITUTION":"","REFERENCE_THESIS_TITLE":"","REFERENCE_THIRD_AUTHOR":"","REFERENCE_TITLE":"","REFERENCE_URL":"URL","REFERENCE_VERSION":"","REFERENCE_VIDEO_PRODUCER":"","REFERENCE_VIDEO_TITLE":"","REFERENCE_VOLUME":"","REFERENCE_WEBSITE_NAME":"","REFERENCE_YEAR":"Year","REQUIREMENTS":"Requisitos do curso","REQUIREMENTS_NOTES":"Notas dos Requisitos do Curso","REQUIREMENTS_NOTES_PANEL":"Notas adicionais","REREFENCE_UMI":"","ROLE":"função","SAVE_CHANGES":"Guardar mudanças","SEARCH_TEXT":"Pesquisar texto","SECONDARY_BIBLIOGRAPHY":"Bibliografia complementar","SECTION_ACTIVITIES":"Atividade","SECTION_APROVAL_CONDITIONS":"Condições de aprovação","SECTION_ASSISTANTS":"Participantes ou co-titulares","SECTION_CHANGES_HISTORY":"Histórico de mudanças","SECTION_COMPETENCIES":"Competências para as quais o curso é tributado","SECTION_COMPETENCIES_PANEL":"Competências","SECTION_COMPETENCIES_SECTION":"Competências","SECTION_CONTENTS":"Aprendizagens esperadas e unidades de conteúdo","SECTION_COORDINATOR":"Coordenador","SECTION_COREQUISITES":"Co-requisitos","SECTION_DESCRIPTION":"Descrição do Curso","SECTION_DESCRIPTION_PANEL":"Descrição do Curso","SECTION_DESCRIPTION_SECTION":"Descrição do Curso","SECTION_EVALUATION":"Tipo de avaliação","SECTION_EVALUATION_COMMENTS":"Avaliações","SECTION_EVALUATION_COMMENTS_PANEL":"Avaliação","SECTION_EVALUATION_ID":"Meios de avaliação","SECTION_EVALUATION_METHOD":"Método de avaliação","SECTION_EVALUATION_METHOD_ID":"Procedimentos de avaliação","SECTION_EVALUATION_PROCEDURES":"Avaliação","SECTION_EVALUATION_STRUCTURE":"Critérios de avaliação e acreditação","SECTION_EVALUATIONS":"Evidências do Curso","SECTION_EVIDENCES_PANEL":"Evidências de Aprendizagem","SECTION_EVIDENCES_TABLE":"Dados gerais","SECTION_GENERAL_DATA":"Modo em que se ensina","SECTION_IMPARTITION_MODE":"Evidências de Aprendizagem","SECTION_LEARNING_EVIDENCES":"","SECTION_LEARNING_STRATEGIES":"Estratégias de Aprendizagem","SECTION_MAIN_TEACHER":"Professor titular","SECTION_MAIN_TEACHER_MAIL":"Email professor titular","SECTION_METHODOLOGY":"Metodologia","SECTION_METHODOLOGY_PANEL":"","SECTION_MODALITIES_ACTIVITIES":"Modalidades e Atividades","SECTION_MODALITY":"Modalidade do curso","SECTION_NAME":"Seção","SECTION_OBJECTIVES":"Objetivos do Curso","SECTION_OBJECTIVES_PANEL":"Objetivos do Curso","SECTION_OBJECTIVES_SECTION":"Objetivos","SECTION_OTHER_CONDITIONS":"Outras condições","SECTION_OTHERS":"","SECTION_OTHERS_PANEL":"","SECTION_OUTCOMES":"Resultados de Aprendizagem do Curso","SECTION_OUTCOMES_ID":"Resultados de Aprendizagem do Curso","SECTION_OUTCOMES_PANEL":"Resultados de aprendizagem","SECTION_PREREQUISITES":"Pré-requisitos","SECTION_REFERENCE_CATEGORY":"Categoria de Bibliografia","SECTION_REFERENCES":"Bibliografia","SECTION_REFERENCES_NOTES_PANEL":"Notas sobre bibliografia e websites","SECTION_REQUIREMENTS_NOTES":"Notas dos Requisitos do Curso","SECTION_REQUIREMENTS_NOTES_PANEL":"Notas adicionais","SECTION_REQUIREMENTS_PANEL":"Requisitos do curso","SECTION_SESSION_NAME":"Planejamento de Curso","SECTION_SESSIONS":"Planejamento de Curso","SECTION_SESSIONS_PANEL":"Temas e subtemas","SECTION_TEACHING_TEAM":"Equipe docente","SECTION_TYPE_IN_PENSUM":"Tipo de Curso","SEE_ON_PLAN":"Visualizar no plano","SELECT_A_STRUCTURE":"","SELECT_DESTINATION":"Selecionar seção de destino","SELECT_FILES":"Selecionar arquivos...","SEMESTER":"Semestre","SENTENCE":"","SESSION_ACTIVITY":"Atividade da sessão","SESSION_ACTIVITY_DESCRIPTION":"Descrição da atividade","SESSION_COURSE_OUTCOMES":"Aprendizagens esperada","SESSION_DESCRIPTION":"Descrição","SESSION_END_TIMING":"Data final","SESSION_EVALUATION_COMPONENTS":"Componentes de avaliação da sessão","SESSION_EVALUATION_METHODS":"Meios de avaliação","SESSION_EVALUATION_METHODS_ADD":"Meios de avaliação","SESSION_LEARNING_RESULTS":"Resultados de aprendizagem do tema","SESSION_LEARNING_RESULTS_ADD":"Resultados de aprendizagem do tema","SESSION_LEARNING_STRATEGIES":"Estratégias educacionais","SESSION_LEARNING_STRATEGIES_ADD":"Estratégias educacionais","SESSION_NAME":"Nome da Sessão","SESSION_NAME_ADD":"Tema Adicional","SESSION_REFERENCES":"Referências da sessão","SESSION_RESOURCES":"Recursos e Materiais","SESSION_RESOURCES_ADD":"Recursos e materiais","SESSION_SUBTHEMES":"Subtemas","SESSION_SUBTHEMES_ADDED":"Subtemas adicionas","SESSION_SUBTHEMES_ADDED_ADD":"Subtemas","SESSION_TEACHERS":"Docentes da seção","SESSION_THEME":"Tema","SESSION_THEME_ADD":"Tema Adicional","SESSION_TIMING":"Agendamento","SESSION_TIMING_ADD":"Agendamento","SOFTWARE":"Software","SPECIALITY_SUBJECTS":"Cursos de especialidade","START_MESSAGE_EXPLAIN_CLONING":"Pressione o botão","STATISTICAL_DATABASE":"","STRICT_FIELD_REQUIREMENT":"Obrigatoriedade de campos requeridos","STRICT_FIELD_REQUIREMENT_HELP":"Obrigará ao usuário preencher todos os dados necessários para executar essa transição.","STRUCTURE":"Estrutura","STRUCTURES":"","STUDENT_HISTORICAL_PROGRESS":"Progresso curricular","STUDY_PLAN_CREATE_SUCCESS":"Plano de estudo criado corretamente","STUDYPLAN_CODE":"Código do Plano de Estudo","STUDYPLAN_GENERAL_INFO":"Informação Geral do Plano de estudo","STUDYPLAN_NAME":"Nome do Plano de Estudo","SYLLABUS_GENERAL_DATA":"Dados gerais","SYLLABUS_REFERENCES":"Referências bibliográficas e websites","THESIS":"","TOGGLE_COLAPSE":"Colapsar","TOTAL_HOURS":"Horas totais","TOTAL_WEEKS":"Semanas totais","UPDATE_SUCCESS_MESSAGE":"Atualizado com sucesso","UPLOAD":"Carregar","UPLOAD_ALL":"Carregar tudo","UPLOAD_FILE":"Carregar arquivo","UPLOADING_FILE":"Arquivos carregados","USER":"Usuário","WARNING_CLONING_PROCESS":"Ocorreu um erro","WARNING_MESSAGE":"Mensagem de aviso","WARNING_MESSAGE_DELETE_DEFAULT":"Você tem certeza de que deseja excluir este registro?","WEB_MAGAZINE_ARTICLE":"","WEBSITE":"","WEBSITE_NO_AUTHOR":"","WORKFLOW":"Workflow","YEAR":"Ano","YOUTUBE_VIDEO":"","ACADEMIC":"Acadêmico","ACADEMIC_CALENDAR":"Calendário Acadêmico","ACADEMIC_CALENDAR_TO_CLONE":"Calendários acadêmicos a clonar","ACADEMIC_CALENDAR_VISUALIZATION":"","ACADEMIC_PROGRAM_SUMMARY":"","ACADEMIC_PROGRAMMING":"Programação Acadêmica","ACADEMIC_PROGRAMMING_PLURAL":"Programações Acadêmicas","ACADEMIC_QUOTA_LEEWAY":"Folga de vaga acadêmica","ADD_INTEGRATION_CODE":"","ADD_NAME_RESOURCE_TYPE":"","ADD_USAGE_TYPE":"","ADD_USAGE_TYPE_NAME":"","ADVANCE_GROUP":"","AFFECTED":"Afetadas","APARTAMENT":"Departamento","APPROVAL_RATE":"","APPROVE_REQUEST_N":"Pedido de aprovação N ° {{listRequestCount}}","APPROVED_COURSE_CYCLE":"Ciclo em que a matéria foi aprovada","APPROVED_COURSES":"Cursos aprovados","APPROVED_CREDITS":"Créditos aprovados","ASSIGN_RESOURCE_TYPE":"","ASSIGN_SAME_DAY":"","ASSIGN_SCHEDULE_CLASSROOMS":"","ASSIGNAMENT_PREDEFINED_TEACHER_TO_SECTIONS":"","ASSIGNED_CLASSROOMS":"","ASSING_ACADEMIC_CALENDAR":"","ATENTION":"Atenção","AVARAGE_STUDENTS_SECTIONS":"","BACK_TO_SIMULATION_LIST":"","BACKGROUND":"2º plano","BASE_LINE":"Linha Base","BASE_SIMULATION":"Simulação Base","CALCULATED_DEMAND":"","CAMPUS_PERIOD_SHIFT_INDICATORS":"","CAMPUSES":"Campus","CANDIDATE_CLASSROOM":"","CANDIDATE_SCHEDULE_CLASSROOM":"","CANDIDATE_SCHEDULE_CLASSROOM_RESTRICTION":"","CANDIDATES":"","CANT_RECORDS":"","CAREER":"Carreira","CAREER_BUILDING_PREFERENCE":"Restrição carreiras no edifício","CAREERS":"Carreiras","CHAIR_USAGE_PERCENTAGE_RESTRICTION":"","CHAIR_USE_PERCENTAGE":"","CHECK_UNCHECK_ALL":"Marcar/Desmarcar tudo","CLASSROOM":"Salas","CLASSROOM_RESTRICTION":"","CLASSROOM_RESTRICTION_LIST":"","CLONE_ACADEMIC_CALENDAR":"Clonar calendários acadêmicos","CLONE_CROSS_LISTS":"Clonar listas cruzadas","COEFF_ASSIGNED_MODULES":"","COEFF_COURSE":"","COEFF_POSITION":"","COEFF_TEACHER_EVALUATION":"","COEFF_VALUE_HOUR":"","COMPACT":"Compactar","COMPACT_RECORD_CLASS_GROUP":"Compactar por grupo nota classe","COMPACT_RETURN":"Compactar e voltar","COMPACTION_INDEX_ACADEMIC_QUOTA":"","COMPACTION_OPPORTUNITY":"Oportunidade de compactação","COMPACTION_PERCENTAGE_ACADEMIC_QUOTA":"","COMPATIBILITY_GROUP_NUMBER":"","CONFIG":"","CONFIG_CROSS_LISTS":"Configurar listas cruzadas","CONFIGURATION_PER_WEEKS":"","CONTINUE":"Continuar","COORDINATOR_VIEW":"Coordenador","COST_MAINTAINER_TEACHER_EVALUATION":"","COURSE_ACTIVITY_DATA":"","COURSE_ACTIVITY_EMPTY_STATE":"","COURSE_ACTIVITY_MAINTAINERS":"","COURSE_BUILDING_PREFERENCE":"Restrição cursos no edifício","COURSE_DUPLICATED_IN_NEXT_CROSS_LIST":"O curso {string} está duplicado nas seguintes listas cruzadas","COURSED_CYCLE":"Ciclo em que estudou","COURSED_ELECTIVES":"Eletivas cursadas","COURSES":"Cursos","COURSES_IN_THIS_CROSS_LIST":"Cursos nesta lista cruzada","CREATE":"Criar","CREATE_ACADEMIC_PROGRAMMING":"Criar programação acadêmica","CREATE_CROSS_LIST":"Criar lista cruzada","CREATE_DEMAND_SIMULATION":"Criar simulação de demanda","CREATE_GROUP_SIMULATION":"Criar Simulação group","CREATE_REQUEST":"Criar pedido","CREATE_RESOURCE":"Criar recurso","CREATE_RESTRICTION":"","CREATE_SCHEDULE_CLASSROOM_SIMULATION":"Criar Simulação Horário","CREATE_TEACHER_SIMULATION":"Criar Simulação Teacher","CREATE_VIRTUAL_SIMULATION":"Criar simulação virtual","CREATING":"Criando","CROSS_LIST_LOEADED":"","CROSS_LISTS_CONFIGURATION":"","CROSS_LISTS_DEFINITION":"","CROSS_LISTS_TO_CLONE":"Listar cruzadas a clonar","CROSS_LISTS_TO_MERGE":"Listas cruzadas a mesclar","CROSS_LISTS_WITH_CONFLICT":"","CURRENT_VALUE":"","DEFINE_A_COURSE":"Defina um curso","DEFINE_GENERIC_GROUP":"","DELETE_SIMULATION":"Apagar simulação","DEMAND":"Demanda","DEMAND_MATRIX_CALENDAR":"","DEMAND_SIMULATION":"Simulação de demanda","DEPENDENT_SIMULATION":"","DESERTION_RATE":"","DICTATE":"Ditar","DIFFERENT_ACTIVITIES_IN_NEXT_CROSS_LIST":"As atividades são diferentes nas seguintes listas cruzadas","DIFFERENT_ACTIVITY_SCHEDULE":"Tipo atividade/horários diferentes","DISTRIBUTION_AUTO":"Distribuição automática","DOWNLOAD":"Baixar","DOWNLOAD_BY_CAMPUS":"","DOWNLOAD_BY_PLAN":"","DOWNLOAD_BY_STUDENT":"","DOWNLOAD_HISTORICAL_RPC":"","DUPLICATED_COURSES":"Cursos Duplicados","EDIT_ACADEMIC_QUOTA":"Editar cupo académico","EDIT_ACADEMIC_QUOTA_LEEWAY":"","EDIT_CROSS_LIST":"Editar lista cruzada","EDIT_GLOBAL_DEMAND":"","EDIT_NEW_STUDENTS":"Editar novos Estudantes","EDIT_PREVIOUS_PERIOD":"","EDIT_RESTRICTION":"","EDITED":"","EMPTY":"Vazio","END_WEEK":"","ENROLLMENT_CYCLE":"Ciclo entrada","ENTRY_CICLE":"Ciclo entrada","EXECUTE":"Executar","EXECUTE_IN_BACKGROUND":"Executar em segundo plano","EXECUTING":"Executando","FINAL_DEMAND":"","FIND_WEEKS":"","FINISHED":"Finalizadas","FIXED_CURRICULAR_PROGRESS":"Progresso curricular","FLEXIBLE_CURRICULAR_PROGRESS":"Progresso curricular","FRI":"Sexta-feira","FUNCTION_OBJECTIVE":"","FUNCTION_OBJECTIVE_CONFIGURATION_TEACHER":"","GENERAL_INDICATORS":"","GO_BACK_GROUP_SIMULATIONS":"Retornar a simulação de grupo","GO_BACK_SIMULATION":"Retornar a simulação","GROUP_SIMULATION":"Simulação de grupo","GROUP_SIZE":"","GROUPS_INDEX_VIEW":"","GROUPS_TABLE_VIEW":"","HEADER_STEP_5":"Ditado em período equivalente anterior","HISTORIC_ENROLLMENT":"Inscrições históricas","HISTORY":"História","HOLYDAYS":"","ID_CROSS_LIST":"","ID_PUBLIC":"","ID_UPL":"ID U-Planner","IN_PROGRESS":"No curso","INDEX_COMPACTION_INFRASTRUCTURE":"","INFRASTRUCTURE_OCCUPATION PERCENTAGE RESTRICTION":"","INSTITUTION":"Instituição","INTEGRATION_WARNING_TEXT":"Se você continuar com a edição / exclusão, as seguintes simulações se tornarão obsoletas:","INTEGRATION_WARNING_TITLE":"Aviso de Integração","LAST_DATA_LOAD":"","LOAD_ACADEMIC_QUOTA":"","LOAD_ANOTHER_FILE":"","LOAD_CLASSROOM_RESTRICTIONS":"","LOAD_FILE":"Carregamento de arquivo","LOAD_PREVIOUS_PERIOD":"","LOAD_QUOTA":"","LOADED_CAREERS":"","LOADED_COURSES":"","LOADED_PLANS":"","LOADED_SECTIONS":"","MASSIVE_CLONING":"Clonagem massiva","MAXIMUM_GROUP_SIZE":"Tamanho Máximo do Grupo","MENU_ACADEMIC_PERIOD":"Período Acadêmico","MENU_ACTIVITY":"Atividade","MENU_ACTIVITY_SUBJECT_DETAIL":"Atividade curso detalhe","MENU_ACTIVITY_SUBJECT_TYPE_USE":"Atividade curso tipo uso","MENU_CAREER_TARIFF":"Taxa de carreira","MENU_CLASS_NOTE":"Nota classe","MENU_CLASS_TIME":"Hora classe","MENU_COMPARISON_REPORT":"Relatório de Comparação","MENU_CONFERENCE_MANAGER":"Administrador de dias","MENU_COORDINATOR":"Coordenador","MENU_COURSE_ACTIVITY":"Curso Atividade","MENU_CROSS_LIST":"Listas Cruzadas","MENU_DEMAND_MATRIX":"Matriz de Demanda","MENU_DETAIL_REPORT":"Relatório detalhado","MENU_DISPLAY":"Visualização","MENU_ENTRY_NEW_STUDENTS":"Entrada de novos estudantes","MENU_FILE_UPLOAD":"Carregamento de arquivos","MENU_GLOBAL_DEMAND":"Demanda Global","MENU_INFRASTRUCTURE":"Infraestrutura","MENU_INFRASTRUCTURE_TYPE_USE":"Infraestrutura Tipo Uso","MENU_INTEGRATION_TABLES":"Tebelas Integração","MENU_LOAD_GROUP":"Grupos","MENU_LOAD_SCHEDULE":"Carga horário","MENU_LOADED_DATA":"Dados Carregados","MENU_MAINTAINERS":"Administradores","MENU_MODULES_DAY":"Módulos por dia","MENU_PLANS_CAMPUS":"Planos no campus","MENU_REPORTS":"Relatórios","MENU_STUDY_PLAN":"Plano de estudo","MENU_STUDY_PLAN_SHIFT":"Plano Estudo Turno","MENU_STUDY_PLAN_SUBJECT":"Plano Estudo curso","MENU_SUBJECTS_BY_DEPARTAMENT":"Matérias por departamento","MENU_SUBJECTS_BY_PLAN":"Matérias por plano","MENU_TEACHER":"Docente","MENU_TEACHER_ACTIVITY_SUBJECT":"Teacher curso atividade sede","MENU_TEACHER_COORDINATOR":"Dip. Docente-Coordenador","MENU_TEACHER_COST_MATTER_ACTIVITY":"Custo Docente Matéria Atividade","MENU_TEACHER_SUBJECT_ACTIVITY":"Docente Matéria Atividade","MENU_TEACHER_VALUE_TIME_EVALUATION":"Teacher Valor Hora Avaliação","MENU_TEACHING_AVAILABILITY":"Disponibilidade Docente","MENU_TIME_AVAILABILITY":"Disponibilidade Horária","MENU_TIME_TRANSFER":"Tempo Transferência","MENU_TYPE_USE":"Tipos uso","MENU_USE_INFRASTRUCTURE":"Uso de infraestrutura","MENU_USE_ROOMS":"Utilização de Salas","MENU_VALUE_TIME_SUBJECT":"Valor hora curso","MERGE_CROSS_LISTS":"Mesclar listas cruzadas","MERGE_SECTIONS_BY_CROSS_LISTS":"Compactar por listas cruzadas","MERGE_SECTIONS_BY_GRADE_GROUP":"Compactar por grupo nota classe","MERGE_SECTIONS_BY_MODALITY":"Compactar por modalidade","MERGE_SECTIONS_BY_PLANS":"Compactar por planos","MERGE_SECTIONS_BY_SHIFT":"Compactar por dia","MERGE_SECTIONS_OPPORTUNITY":"Oportunidade de compactação","MERGE_SECTIONS_RESULTS":"Resultados de compactação","MERGED_COURSES_IN_CROSS_LIST":"Matérias mescladas nesta lista cruzada","MINIMUM_GROUP_SIZE":"Tamanho Mínimo do Grupo","MIXED":"","MOD":"Mod","MODIFY_BASELINE":"Modificar linha base","MON":"Segunda-feira","MSG_MODIFICATION_BASE_LINE_1":"Se você realizar esta ação, os usuários poderão ver","MSG_MODIFICATION_BASE_LINE_2":"Se você realizar esta ação, os usuários não poderão mais ver","MSG_STATUS_SIMULATION":"Para visualizar o status de sua simulação, você deve ir a seção Simulação","MSJ_CLASSROOM_RESTRICTION_INSTRUCTION":"","MSJ_CLONE_MODAL":"Um nome foi atribuído por padrão, você tem a opção de modificá-lo se achar conveniente.","MSJ_ERROR":"Erro ao conectar-se ao serviço","MSJ_ERROR_MODAL_CLONE":"A clonagem não pôde ser executada","MSJ_ERROR_MODAL_STATUS":"A barra de progresso indica o estado em que se encontra a simulação, é recomendável não cancelar, para realizar outro fluxo só deve clicar no botão de executar em 2° plano.","MSJ_ERROR_SIMULATION_STATUS":"A simulação não pôde ser executada","MSJ_NO_RECORDS_AVAILABLE":"","MSJ_OPTIMAL_OFFER_SUCCES_COMMENT":"","MSJ_SUCCESS":"Mudanças realizadas corretamente","MSJ_SUCCESS_RESTRICTION_CANDIDATE_CLASSTOOMS":"","N_CLASSROOM":"","N_CROSS_LISTED_SECTIONS":"","N_GENERATED_SECTIONS":"","N_IDENTIFICATION":"","N_MIXED_SECTIONS":"","N_PURE_SECTIONS":"","N_SECTIONS":"","NAME_CROSS_LIST":"","NAME_PROGRAMMING":"Nome programação Acadêmica","NEW_ENTRIES":"NI","NEW_ENTRIES_FOR_MAX_COMPRESSION":"Nem para máxima compactação","NEW_ENTRIES_FOR_MIN_DESIRED":"Nem para mínimo desejado","NEW_POSITION":"","NEW_PROGRAMMING":"Nova Programação","NEXT":"Próximo","NO_ASSIGNED_CLASSROOMS":"","NO_DATA":"Não há dados disponíveis","NOT_EXECUTED":"Não Executadas","NUMBER_OF_CAMPUS":"Nº Campus","NUMBER_OF_COMPATIBILITY_GROUPS":"","NUMBER_OF_GROUPS":"Nº grupos","OCCUPATION":"","OPTATIVE_SELECT":"Selecione Matérias Optativas","OPTATIVE_SUBJECT":"Cursos Optativos","OPTIMAL_ENROLLMENT":"Matrícula ideal","OPTIMAL_OFFER":"Oferta ideal","PARALLEL_BY_COURSE_ACTIVITY":"","PARALLEL_RESTRICTION":"","PERCENTAGE_ASSIGNMENTS":"","PERCENTAGE_ASSIGNMENTS_SECTION_TYPE":"","PERCENTAGE_COMPACTION_INFRASTRUCTURE":"","PLANS":"Plano/os","POSITION":"Posição","POSITION_CODE":"","POSITION_NAME":"","PREDEFINED":"","PREDEFINED_CANDIDATE_SCHEDULE_CLASSROOM":"","PREDEFINED_CLASSROOM":"","PREDEFINED_SCHEDULE_CLASSROOM_RESTRICTION":"","PREDEFINED_TEACHING_ASSIGNAMENT":"","PREFEFINED_SCHEDULE_CLASSROOM":"","PREVIOUS":"Anterior","PREVIOUS_PERIOD":"","PROGRAMMING":"Programação","PROGRESS":"Progresso","PURE":"","QUICK_ACCESS":"Ações rápidas","QUOTA":"Quota","QUOTAS_USED":"","RE_ENTRIES":"RI","RE_SIMULATE":"Re-Simular","REAL_FICTIONAL":"Real / Fictício","RECONFIGURE":"Reconfigurar","RECONFIGURE_MSJ":"Ao reconfigurar, você perderá os resultados da simulação. Você também pode clonar essa simulação para evitar a perda desses resultados. Que ação você deseja realizar?","RECONFIGURE_SIMULATION":"Reconfigurar simulação","RECORDS":"","RECORDS_LOADED":"Registros Carregados","RECORDS_REJECTED":"Registros Rejeitados","REQUEST_DATE":"Data solicitação","REQUEST_DETAILS":"Detalhe da solicitação","REQUEST_LIST":"Lista solicitações","RESOLUTION":"Resolução","RESOLUTION_DATE":"Data resolução","RESOLVE_CONFLICTS_IN_CROSS_LISTS":"Resolver conflitos em listas cruzadas","RESOLVE_CONFLICTS_IN_CROSS_LISTS_MESSAGE":"A lista cruzada {string} apresenta os seguintes conflitos:","RESOURCE_DATA":"Dados do recurso","RESOURCE_EMPTY_STATE":"Clique em um recurso para acessar as informações deste ...","RESOURCE_TYPE":"Tipo de recurso","RESTRICTION_CANDIDATE_CLASSTOOMS":"","RESTRICTION_LOCATION_ACTIVITY":"Restrição Localização/Atividade","RESULTS_LOADED_FILE":"Resultados de Carregamento","ROOT_COURSE":"Curso raíz","SAT":"Sábado","SAVE_NEXT":"Salvar e continuar","SCHEDULE_CLASSROOM_SIMULATION":"Simulação Schedule","SCHEDULE_INDEX_VIEW":"","SCHEDULE_TABLE_VIEW":"","SEARCH":"Pesquisar","SEARCH_AND_ADD_COURSES":"Pesquisar e adicionar materiais","SEE_LOAD_CLASSROOM_RESTRICTIONS":"","SEE_LOAD_PREVIOUS_PERIOD":"","SEE_RESTRICTION_EXTISTING_CLASSROOM":"","SEE_RESULTS":"Visualizar Resultados","SEE_SCHEDULE_CLASSROOM_RESTRICTION":"","SEE_STATUS":"Visualizar Estado","SELECT_ACADEMIC_UNIT":"","SELECT_DEMAND_SIMULATION":"Selecione uma simulação de demanda","SELECT_LOCATION":"","SELECT_LOCATION_AND_STAGE":"Selecione local e cenário","SELECT_ROOM":"","SELECT_SHIFT":"Selecione dia","SELECT_TEACHER":"","SELECT_TYPE_ACTIVITY_INSTRUCTIONS":"","SELECT_TYPE_OF_EXISTING_RESOURCE":"","SELECT_TYPE_RESTRICTION_INSTRUCTIONS":"","SELECTED_CONFIGURATION":"","SESION":"","SESSION":"Sessão","SET_UP":"Configurar","SHIFT_NAME":"Nombre de la jornada","SHIFTS_AVAILALED":"Turnos disponíveis","SIMULATE":"Simular","SIMULATE_PREVIOUS_POINT":"","SIMULATE_SCHEDULE":"Simular horário","SIMULATE_SCHEDULE_WITH_THIS_SIM":"Simular horário com esta Simulação","SIMULATE_TEACHER":"Simular Docente","SIMULATE_TEACHER_WITH_THIS_SIM":"Simular Docente com esta Simulação","SIMULATION":"Simulação","SIMULATION_CONFIGURATION":"","SIMULATION_CONFIGURE":"","SIMULATION_CREATE_SUCCESS":"","SIMULATION_DEMAND":"Simulação de demanda","SIMULATION_FINISHED":"Simulação Finalizada","SIMULATION_GROUPS":"Simulação de grupos","SIMULATION_INDICATORS":"","SIMULATION_NAME":"Nome da simulação","SIMULATION_PROGRESS":"Progresso da simulação","SIMULATION_SCHEDULE":"Simulação de horário","SIMULATION_TEACHER":"Simulação docente","SIMULATIONS":"Simulações","STAGE":"Cenário","START_VIRTUAL_GROUP_SIMULATION":"Simulação de grupo virtual","START_WEEK":"","STATE_OF_PROGRESS":"Estado de Progresso","STEP":"Passo","STUDENT_PROGRESS":"Progresso do estudante","STUDENT_QUOTE":"","STUDENT_VIEW":"Estudante","SUBJECT":"Curso","SUBJECTS":"Cursos","SUN":"Domingo","TEACHER_CONTRACT_TYPE":"Tipo de contrato docente","TEACHER_CONTRACT_TYPE_INSTRUCTION":"","TEACHER_EVALUATION_MINIMUN_VALUE":"","TEACHER_INDEX_VIEW":"","TEACHER_POSITION_MAINTAINERS":"","TEACHER_RPC_TABLE_VIEW":"","TEACHER_SIMULATION":"Simulação Teacher","TEACHER_SIMULATION_CONFIGURATION":"","TEACHER_SIMULATION_PROGRESS":"Progresso simulação docente","TEACHER_TABLE_VIEW":"","THU":"Quinta-feira","TIME_RANGES":"Calendários acadêmicos","TITLE_CLONE_MODAL":"Progresso Clonagem","TITLE_ERROR_CREATION":"Foram detectados erros na infraestrutura selecionada da Programação Acadêmica","TITLE_ERROR_CREATION_2":"Foram detectados erros nos dados existentes da Programação Acadêmica","TITLE_ERROR_CREATION_SCHEDULE":"Existem @nn seções que não serão designadas a um docente por não ter horário e/ou sala","TITLE_ERROR_CREATION_SCHEDULE_PARENT":"Existem @nn seções que não serão designadas a um docente por ter atividade virtual","TITLE_FORECAST_CREATION":"A simulação será executada no seguinte universo de dados","TITLE_FORECAST_CREATION_2":"Resumo da configuração de parâmetros","TITLE_SIMULATION":"Verifique a lista de simulações criadas ou crie uma nova simulação","TITLE_STEP_2":"Selecione o tipo de período e turnos que você deseja incluir na programação","TITLE_STEP_5":"Selecione os cursos para ditar, você também pode filtrar os dados para obter um resultado mais preciso","TITLE_STEP_6":"Selecione os cursos optativos para ditar, você também pode filtrar os dados para obter um resultado mais preciso","TO_DELETE_ASK":"Você realmente deseja eliminar?","TOTAL_LOADED_COURSES":"","TOTAL_MAX_GROUP_COMPRESSION":"Max total compactado em grupos","TOTAL_MIN_DESIRED_COMPRESSION":"Min total desejável compactação grupo","TUE":"Terça-feira","TURNS":"Turnos","TYPE":"Tipo","TYPE_OF_ACTIVITY":"Tipo de atividade","U_FORECAST":"u-forecast","U_PLANNING":"u-planning","UNASSIGNED_SECTIONS":"","UNMERGE_SUCCESSFUL":"","UPLOAD_CROSS_LISTS":"Carregar listas cruzadas","UPLOAD_DEMAND":"Carregar demanda","UPLOAD_HISTORY":"Histórico de carregamentos","USAGE_TYPE":"Tipo de uso","USAGE_TYPE_DETAILED":"Tipo de uso detalhado","USAGE_TYPE_EMPTY_STATE":"","USAGE_TYPE_MANTAINERS":"","USE_TEACHER_AVAILABILITY":"","USED":"Utilizados","VALIDATE_DATA_DOWNLOAD_XLS":"","VALIDATION_LOADED_DATA":"","VIEW_CROSS_LIST":"Visualizar lista cruzada","VIEW_CROSS_LISTS":"","VIEW_GLOSSARY":"Visualizar Glossário","VIEW_STATE_OF_PROGRESS_HELP":"Verifique seus cursos. Em caso de inconsistências, você pode enviar uma solicitação de aprovação clicando nos cursos em questão.","VIEW_USER_MANUAL":"Visualizar Manual de Uso","VISUALIZE_BY":"","WED":"Quarta-feira","WEEKS_INFORMATION":"","WITHOUT":"Sem","WITHOUT ASSIGNED_MODULES":"","YOU_WANT":"Você Deseja Realmente","80_LIM_INF":"80% do limite inferior","80_LIM_SUP":"80% do limite superior","ACADEMIC_PERFORMANCE_FIRST_YEAR_FACTOR_DESCRIPTION":"Para os casos de alunos do segundo semestre em diante, média de notas individuais por matéria do primeiro ano estudado.","ACADEMIC_PERFORMANCE_FIRST_YEAR_FACTOR_NAME":"Desempenho acadêmico no primeiro ano","ACADEMIC_PERFORMANCE_TREND_FACTOR_DESCRIPTION":"Tendência nas notas médias dos períodos históricos do estudante.","ACADEMIC_PERFORMANCE_TREND_FACTOR_NAME":"Tendência média das notas","ACCIONES_RAPIDAS":"Ações Rápidas","ACTIVE_CAREERS_IN_PERIOD_FACTOR_DESCRIPTION":"Número de carreiras ativas no atual período acadêmico.","ACTIVE_CAREERS_IN_PERIOD_FACTOR_NAME":"Carreiras ativas no período acadêmico","ADMIN_CARRERA":"Carreira","ADMISSION_TYPE_FACTOR_DESCRIPTION":"Tipo de admissão (exame ordinário, admissão especial, transferência interna, etc.)","ADMISSION_TYPE_FACTOR_NAME":"Tipo de admissão","AGE_AT_ADMISSION_FACTOR_DESCRIPTION":"Idade do aluno ao entrar na instituição. Relevante por nível de maturidade durante o primeiro ano, o que corresponde ao maior risco.","AGE_AT_ADMISSION_FACTOR_NAME":"Idade de admissão à instituição","AGE_AT_PREDICTION_FACTOR_DESCRIPTION":"Idade do aluno no momento da previsão.","AGE_AT_PREDICTION_FACTOR_NAME":"Idade no tempo de previsão","ALERTAS_ALUMNOS_RIESGO":"Porcentagem de alunos em risco","ALERTAS_ESTUDIANTES_SUBHEADING":"Estudantes ativos na carreira","ALERTAS_EVOLUCION_DESERCION":"Evolução dos estados históricos dos estudantes","ALERTAS_EVOLUCION_RAZONES_DESERCION":"Razões de deserção","ALERTAS_EVOLUCION_SUBHEADING":"Último @year semestres regulares","ALERTAS_GROUPALES_FACTOR":"FATOR","ALERTAS_GROUPALES_HEADER1":"Alertas Grupais","ALERTAS_GRUPALES":"Alertas Grupais","ALERTAS_INDIVIDUAL_CAMPUS":"Campus","ALERTAS_INDIVIDUAL_CARRER":"Carreira","ALERTAS_INDIVIDUAL_COHOR":"Coorte","ALERTAS_INDIVIDUAL_CORDIGO":"Código do aluno","ALERTAS_INDIVIDUAL_EDAD":"Idade","ALERTAS_INDIVIDUAL_FICHA":"Ficha","ALERTAS_INDIVIDUAL_FICHA_BUTTON":"Visualizar Ficha","ALERTAS_INDIVIDUAL_HEADLINE1":"Alertas Individuais","ALERTAS_INDIVIDUAL_INDEX":"Índice","ALERTAS_INDIVIDUAL_MODALIDAD":"Modalidade","ALERTAS_INDIVIDUAL_NAME":"Nome","ALERTAS_INDIVIDUAL_RIESGO":"Risco","ALERTAS_INDIVIDUAL_SEXO":"Sexo","ALERTAS_INDIVIDUAL_SUBHEADLINE1":"Alunos em risco","ALERTAS_INDIVIDUAL_TELEPHONE":"Telefones","ALERTAS_INDIVIDUALES":"Alertas Individuais","ALERTAS_NIVEL_DE_RIESGO_MAIN_HEADING":"Nível de risco de deserção segundo Coorte de entrada","ALERTAS_NUMERO_ALUMNOS_RIESGO":"Número de alunos em risco","ALUMNO_DESERTADO":"Aluno desertou","ALUMNOS_RIESGO":"Alunos em risco","ANALISIS":"Análise","ANALISIS_EXPORTAR_DATOS":"Exportar dados","ANALISIS_HEADER":"Análise","ANNO_INGRESO":"Ano de entrada","AUTOR":"Autor","AVERAGE_CREDITS_SEMESTER_FACTOR_DESCRIPTION":"Número médio de créditos cursados em cada semestre regular.","AVERAGE_CREDITS_SEMESTER_FACTOR_NAME":"Número de créditos médios cursados por período acadêmico","AVERAGE_HIGH_SCHOOL_GRADES_FACTOR_DESCRIPTION":"Nota média obtida pelo Estudante nos estudos do ensino secundário (escola).","AVERAGE_HIGH_SCHOOL_GRADES_FACTOR_NAME":"Média de notas no ensino secundário","AVERAGE_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, em escala percentual, a média de notas obtidas pelo aluno durante o período acadêmico.","AVERAGE_PARTIAL_GRADE_FACTOR_NAME":"Média de notas parciais","BIENVENIDO":"Bem-vindo a u-retention","BITACORA_CONTACTOS":"Log de contatos","BUSCAR_FACTOR":"Pesquisar um fator","CALIBRACION_MODELO":"Calibração do modelo","CARGA_DATOS":"Carregamento de dados","CARRERAS":"Carreiras","CHILDRENS_INDICATOR_FACTOR_DESCRIPTION":"Estudante tem filhos. Relevante devido à pressão econômica, efeito nos resultados acadêmicos, entre outros.","CHILDRENS_INDICATOR_FACTOR_NAME":"Estudante tem filhos","CODIGO_ALUMNO":"Código do aluno","CONT_FRACC_COL":"Contagem como Fração das Colunas","CONT_FRACC_FILAS":"Contagem como Fração das Filas","CONT_FRACC_TOTAL":"Contagem como Fração do Total","CONT_VALORES_UNICOS":"Contagem de Valores Únicos","CONTEO":"Contagem","CORREO":"Correio","CREDIT_INDICATOR_FACTOR_DESCRIPTION":"Aluno conta com créditos privados de bancos ou entidades estatais.","CREDIT_INDICATOR_FACTOR_NAME":"Aluno possui crédito","CREDIT_PERCENTAGE_FACTOR_DESCRIPTION":"Percentual de crédito concedido por entidades bancárias ou estaduais, caso o aluno tenha crédito.","CREDIT_PERCENTAGE_FACTOR_NAME":"Porcentagem de crédito","CUMULATIVE_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Média acumulada de assistência às classes no total dos períodos acadêmicos estudados.","CUMULATIVE_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentagem de assistência à classes acumulativa","CUMULATIVE_COURSES_FAILED_ONCE_FACTOR_DESCRIPTION":"Número total de cursos que o Estudante foi reprovado na primeira vez em que se matriculou","CUMULATIVE_COURSES_FAILED_ONCE_FACTOR_NAME":"Total de cursos reprovados na primeira instância","CUMULATIVE_COURSES_FAILED_THRICE_FACTOR_DESCRIPTION":"Número total de cursos que o Estudante foi reprovado na terceira vez em que se matriculou","CUMULATIVE_COURSES_FAILED_THRICE_FACTOR_NAME":"Total de cursos reprovados na terceira instância","CUMULATIVE_COURSES_FAILED_TWICE_FACTOR_DESCRIPTION":"Número total de cursos que o Estudante foi reprovado na primeira vez em que se matriculou","CUMULATIVE_COURSES_FAILED_TWICE_FACTOR_NAME":"Total de cursos reprovados na segunda instância","CUMULATIVE_NUMBER_NEGATIVE_CONTACTS_FACTOR_DESCRIPTION":"Número total de vezes que o Estudante foi contatado com um resultado negativo.","CUMULATIVE_NUMBER_NEGATIVE_CONTACTS_FACTOR_NAME":"Número de contatos com resultado negativo","CUMULATIVE_NUMBER_OF_STATES_AB_FACTOR_DESCRIPTION":"Número de vezes que o Estudante tem um estado de abandono em períodos anteriores","CUMULATIVE_NUMBER_OF_STATES_AB_FACTOR_NAME":"Número de abandonos prévios","CUMULATIVE_NUMBER_OF_STATES_RE_FACTOR_DESCRIPTION":"Número de vezes que o Estudante tem um status de reserva em períodos anteriores","CUMULATIVE_NUMBER_OF_STATES_RE_FACTOR_NAME":"Número de reservas prévias","CUMULATIVE_NUMBER_POSITIVE_CONTACTS_FACTOR_DESCRIPTION":"Número total de vezes que o Estudante foi contatado com um resultado positivo.","CUMULATIVE_NUMBER_POSITIVE_CONTACTS_FACTOR_NAME":"Número de contatos com resultado positivo","CUMULATIVE_PAST_ACADEMIC_PERFORMANCE_FACTOR_DESCRIPTION":"Média de notas acumuladas de períodos acadêmicos anteriores do Estudante.","CUMULATIVE_PAST_ACADEMIC_PERFORMANCE_FACTOR_NAME":"Desempenho acadêmico acumulado de períodos acadêmicos anteriores","CUMULATIVE_PAST_DESERTION_STATUSES_FACTOR_DESCRIPTION":"Número total acumulado de estados de deserção em períodos anteriores.","CUMULATIVE_PAST_DESERTION_STATUSES_FACTOR_NAME":"Total de estados de deserção anteriores","CUMULATIVE_TOTAL_CONTACTS_FACTOR_DESCRIPTION":"Número total de vezes que o estudante foi contatado pela instituição.","CUMULATIVE_TOTAL_CONTACTS_FACTOR_NAME":"Número total de contatos acumulados","CURRENT_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"Médias de porcentagens de assistência à classes de disciplinas que está cursando","CURRENT_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentagem de assistência à classes","CURRENT_MIN_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"O menor percentual de assistência entre todas as disciplinas que está cursando","CURRENT_MIN_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentagem mínima de assistência à classes","DATOS_DE_CONTACTO":"Dados de contato","DESCRIPCION":"Descrição","DESERTED_CAREERS_IN_PERIOD_FACTOR_DESCRIPTION":"Número de carreiras desertadas em período acadêmico atual","DESERTED_CAREERS_IN_PERIOD_FACTOR_NAME":"Carreiras desertadas em período acadêmico","DESV_ESTAND_MUESTRA":"Desvio de Padrões de Amostra","DIAGNOSTIC_EXAM_SCORE_FACTOR_DESCRIPTION":"Qualificações em avaliações destinadas a medir o nível verbal e matemático dos alunos pela própria instituição.","DIAGNOSTIC_EXAM_SCORE_FACTOR_NAME":"Resultado de provas de diagnóstico","DIRECCION":"Endereço","DISPERSITY_AVERAGE_CREDITS_FACTOR_DESCRIPTION":"","DISPERSITY_AVERAGE_CREDITS_FACTOR_NAME":"","DISPERSITY_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Variação (dispersão) observada nas notas parciais do Estudante.","DISPERSITY_PARTIAL_GRADE_FACTOR_NAME":"Variação nas notas parciais","DOWNLOAD_ACTIVE_REPORTS":"Relatório Dados Ativos","EDAD":"Idade","ENTRY_EXAM_SCORE_FACTOR_DESCRIPTION":"Qualificação obtida na avaliação específica para admissão na instituição, se houver.","ENTRY_EXAM_SCORE_FACTOR_NAME":"Resultado no exame de admissão","ENUMERAR_VALORES_UNICOS":"Listar valores exclusivos","ESCRIBA_OBSERVACION":"Escreva sua observação ...","ESTUDIANTES_ACTIVOS_CARRERA":"Estudantes ativos na Carreira","EVOLUCION_ESTADOS_HIST_ESTUD":"Evolução dos estados históricos dos estudantes","EXPECTATIONS_CAREER_FACTOR_DESCRIPTION":"Relação entre o que o aluno esperava obter versus o que realmente está vivendo, dependendo da carreira escolhida e da Instituição.","EXPECTATIONS_CAREER_FACTOR_NAME":"Avaliação de expectativas","EXPORT_FILTERED_DATA":"Exportar datos filtrados","EXPORTAR_DATOS":"Exportar dados","EXPORTAR_TSV":"Exportar TSV","EXTRACURRICULAR_ACTIVITIES_PARTICIPATION_INDICATOR_FACTOR_DESCRIPTION":"O aluno participa ou não de atividades sem efeitos de crédito, como festas universitárias, viagens de campo, entre outras.","EXTRACURRICULAR_ACTIVITIES_PARTICIPATION_INDICATOR_FACTOR_NAME":"Participação em atividades extra-programa","FACTOR":"Fator","FACTORES_INCIDENTES_PRINCIPALES":"Fatores incidentes principais","FALSOS_NEGATIVOS":"Falsos negativos","FALSOS_POSITIVOS":"Falsos positivos","FAMILY_ENVIROMENT_FACTOR_DESCRIPTION":"Tipo de grupo familiar base, pai / mãe presentes, avós como figura principal.","FAMILY_ENVIROMENT_FACTOR_NAME":"Entorno familiar","FAMILY_GROUP_QUINTILE_FACTOR_DESCRIPTION":"Nível socioeconômico de origem do aluno de acordo com a qualificação de cada país.","FAMILY_GROUP_QUINTILE_FACTOR_NAME":"Estrato socioeconômico","FAMILY_INCOME_FACTOR_DESCRIPTION":"Ingresso total do grupo familiar.","FAMILY_INCOME_FACTOR_NAME":"Ingresso familiares","FAMILY_OUTCOME_FACTOR_DESCRIPTION":"Valor total destinado a formação do grupo familiar.","FAMILY_OUTCOME_FACTOR_NAME":"Formação Familiares","FATHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_DESCRIPTION":"Indica se o pai concluiu o ensino superior. Permite detectar Estudantes da primeira geração.","FATHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_NAME":"Pai tem ensino superior","FATHER_HAS_WORK_FACTOR_DESCRIPTION":"Indica se o pai trabalha. É interessante saber, em particular, se o grupo familiar tem um sustento estável.","FATHER_HAS_WORK_FACTOR_NAME":"Pai tem trabalho","FECHA":"Data","FECHA_CALIBRACION_MODELO":"Data Calibração do Modelo","FECHA_CARGA":"Data de carregamento","FICHA":"Ficha","FICHA_AURTHOR":"Autor","FICHA_BITACORA_CONTACTOS":"Log de contatos","FICHA_COHORTE":"Coorte","FICHA_CORREO":"Correio","FICHA_DATOS_DE_CONTACTO":"Dados de contato","FICHA_DESCRIPTION":"Descrição","FICHA_DIRECTION":"Endereço","FICHA_FACTOR":"Fator","FICHA_FACTORES_INCIDENTES":"Fatores incidentes principais","FICHA_OBSERVATION":"Observação","FICHA_OPERACION_DESERTADO":"Aluno desertou","FICHA_OPERACION_MANUALES":"Operações manuais","FICHA_OPERACION_RIESGO":"Marcar  'em risco'","FICHA_PROBABILIDAD":"Probabilidade histórica","FICHA_REGISTER_BUTTON":"Registrar","FICHA_REGISTER_OBSERVATION":"Registro de observações","FICHA_TABLE_FICHA":"Data","FICHA_TELEFONO":"Telefone","FICHA_VALUE":"Valor","FICHA_VOLVER_ALERTAS_INDIVIDUAL":"Voltar a Alertas Individuais","FIRST_HIGH_EDUCATION_STUDENT_IN_FAMILY_FACTOR_DESCRIPTION":"Indica se o Estudante pertence à primeira geração de sua família no ensino superior.","FIRST_HIGH_EDUCATION_STUDENT_IN_FAMILY_FACTOR_NAME":"Primeira geração","FIRST_YEAR_STUDENT_FACTOR_DESCRIPTION":"Indica se o aluno está estudando seu primeiro ano na instituição.","FIRST_YEAR_STUDENT_FACTOR_NAME":"Estudante de primeiro ano","GRAFICO_BARRAS_API_HOR":"Gráfico de Barras Empilhadas Horizontais","GRAFICO_BARRAS_HOR":"Gráfico de Barras Horizontais","GRAFICO_DE_AREA":"Gráfico de área","GRAFICO_DE_BARRAS":"Gráfico de barras","GRAFICO_DE_BARRAS_APILADAS":"Gráfico de Barras Empilhadas","GRAFICO_DE_DISPERCION":"Gráfico de Dispersão","GRAFICO_DE_LINEA":"Gráfico de linhas","HEALTH_PROBLEMS_INDICATOR_FACTOR_DESCRIPTION":"O Estudante apresenta problemas de saúde. Um aluno com sérios problemas de saúde pode ser impedido de continuar seus estudos.","HEALTH_PROBLEMS_INDICATOR_FACTOR_NAME":"Problemas de saúde","HIGH_RISK":"Risco alto","HIGHEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, em escala percentual, a maior nota obtida pelo aluno durante o período acadêmico.","HIGHEST_PARTIAL_GRADE_FACTOR_NAME":"Nota parcial mais alta","HISTORICAL_MIN_ATTENDANCE_PERCENTAGE_FACTOR_DESCRIPTION":"A mais baixa das porcentagens de assistência entre todas as matérias que o aluno frequentou no seu plano de estudos","HISTORICAL_MIN_ATTENDANCE_PERCENTAGE_FACTOR_NAME":"Porcentagem mínima histórico de assistência à classes","IMPORTANCIA":"Importância","INCIDENCIA":"Incidência","INCOMPATIBILITY_WITH_EXTRACURRICULAR_ACTIVITIES_FACTOR_DESCRIPTION":"O aluno só tem tempo disponível para as classes, mas não pode participar de sessões de apoio ou atividades em anexo, geralmente por trabalho ou por ter que cuidar dos filhos, entre outros. Relevante em relação à Integração.","INCOMPATIBILITY_WITH_EXTRACURRICULAR_ACTIVITIES_FACTOR_NAME":"Impatibilidade horária com atividades extra curriculares","INDICATOR":"Indicador","INDICE":"Índice","INICIO":"Início","INPUTS_MODELO":"Imputs do modelo","INSTITUTIONAL_CONDITIONS_FACTOR_DESCRIPTION":"Problemas ou condições especiais que a Instituição pode estar tendo no período de mensuração e que já teve anteriormente, como problemas de infraestrutura, conflitos da comunidade acadêmica, entre outros.","INSTITUTIONAL_CONDITIONS_FACTOR_NAME":"Condições institucionais","INSTITUTIONAL_INDICATORS":"Indicadores Institucionales","INTEGRATION_FACTOR_DESCRIPTION":"Percepção de pertencimento à instituição, ao grupo humano e à situação em geral. Relevante em particular para grupo de alto risco (primeira geração, recursos baixos).","INTEGRATION_FACTOR_NAME":"Integração","LAST_PERIOD_ACADEMIC_PERFORMANCE_FACTOR_DESCRIPTION":"Média de notas do período anterior do Estudante.","LAST_PERIOD_ACADEMIC_PERFORMANCE_FACTOR_NAME":"Média das notas do período anterior","LATEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, em escala percentual, a última série obtida pelo aluno durante o período acadêmico.","LATEST_PARTIAL_GRADE_FACTOR_NAME":"Última nota parcial","LEVEL_OF_ECONOMIC_DEPENDENCE_FACTOR_DESCRIPTION":"Aluno depende do grupo familiar para subsistência ou paga com o aluguel do trabalho, alimentação, etc.","LEVEL_OF_ECONOMIC_DEPENDENCE_FACTOR_NAME":"Nível de dependência econômica","LIBRARY_ACCESSES_FACTOR_DESCRIPTION":"Número e frequência de obtenção de livros físicos ou recursos digitais da biblioteca como medida de engajamento e impulso acadêmico.","LIBRARY_ACCESSES_FACTOR_NAME":"Interações na biblioteca","LIVE_WITH_PARENTS_FACTOR_DESCRIPTION":"Relacionado com o grau de independência do Estudante.","LIVE_WITH_PARENTS_FACTOR_NAME":"Vive com os pais durante o período acadêmico","LMS_AVERAGE_ACCESSES_FACTOR_DESCRIPTION":"Histórico de acesso aos cursos online da Instituição, para medir o engajamento, o momento acadêmico e as variações na frequência e no tipo de uso.","LMS_AVERAGE_ACCESSES_FACTOR_NAME":"Acesso médio ao LMS","LOW_RISK":"Risco baixo","LOWEST_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Indica, em escala percentual, a nota mais baixa obtida pelo aluno durante o período acadêmico.","LOWEST_PARTIAL_GRADE_FACTOR_NAME":"Nota parcial mais baixa","MACROECONOMIC_ENVIROMENT_FACTOR_DESCRIPTION":"Situações macroeconômicas particulares que podem afetar os alunos como um grupo: recessões, emergências em escala regional.","MACROECONOMIC_ENVIROMENT_FACTOR_NAME":"Ambiente macroeconômico do país","MAPA_DE_CALOR":"Mapa de Calor","MAPA_DE_CALOR_COL":"Mapa de Calor por Coluna","MAPA_DE_CALOR_FILA":"Mapa de Calor por Fila","MARCAR_RIESGO":"Marcar  'em risco'","MAX_FAILING_GRADE_FACTOR_DESCRIPTION":"Nota final máxima obtida em uma disciplina reprovada no histórico do estudante","MAX_FAILING_GRADE_FACTOR_NAME":"Nota final máxima em uma disciplina reprovada","MAX_FINAL_GRADE_FACTOR_DESCRIPTION":"Nota final máxima obtida em uma disciplina no histórico do estudante","MAX_FINAL_GRADE_FACTOR_NAME":"Nota final máxima em uma disciplina","MAXIMO":"Máximo","MEDIA":"Média","MEDIO_CONTACTO":"Meio de contato","MEDIUM_RISK":"Risco médio","MENU1":"Carregamento de Dados","MENU2":"Calibração de Modelo","MENU3":"Avisos Individuais","MENU4":"Avisos Grupais","MENU5":"Tabela Dinâmica","MENU6":"Relatório de dados carregados","MENU7":"Relatório de u-retention","MIN_FINAL_GRADE_FACTOR_DESCRIPTION":"Nota final mínima obtida em uma disciplina no histórico do estudante","MIN_FINAL_GRADE_FACTOR_NAME":"Nota final mínima em uma disciplina","MIN_PASSING_GRADE_FACTOR_DESCRIPTION":"Nota final mínima obtida em uma disciplina aprovada no histórico do estudante","MIN_PASSING_GRADE_FACTOR_NAME":"Nota final mínima em uma disciplina aprovada","MINDSET_FACTOR_DESCRIPTION":"Ideia pessoal sobre a origem dos talentos, categorizada como \"mentalidade fixa\" ou \"mentalidade de crescimento\".","MINDSET_FACTOR_NAME":"Mentalidade","MINIMO":"Mínimo","MODEL_RETENTION":"Modelo u-retention","MOTHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_DESCRIPTION":"Indica se a mãe recebeu estudos de ensino superior. Permite detectar estudantes de primeira geração.","MOTHER_HAS_HIGHER_EDUCATION_STUDIES_FACTOR_NAME":"Mãe possui estudos de ensino superior","MOTHER_HAS_WORK_FACTOR_DESCRIPTION":"Indica se a mãe trabalha. Revela se o grupo familiar tem uma renda estável.","MOTHER_HAS_WORK_FACTOR_NAME":"Mãe tem trabalho","NIVEL_RIESGO_DESERCION_COHORTE":"Nível de risco de deserção segundo Coorte de entrada","NOMBRE":"Nome","NOMINATION_PREFERENCE_NUMBER_FACTOR_DESCRIPTION":"Lugar de preferência para a carreira ou instituição nas listas de preferências do aluno (Oficiais constatadas ou declaradas). Relevante para nível de satisfação e integração.","NOMINATION_PREFERENCE_NUMBER_FACTOR_NAME":"Preferência de faculdade","NON_REGULAR_PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Número de períodos não regulares na instituição, como por exemplo, nos semestres de verão.","NON_REGULAR_PERIODS_IN_INSTITUTION_FACTOR_NAME":"Número de Períodos não Regulares","NUMBER_COURSES_TAKEN_IN_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Número total de cursos matriculados pelo estudante no período acadêmico","NUMBER_COURSES_TAKEN_IN_ACADEMIC_PERIOD_FACTOR_NAME":"Cursos realizados em período acadêmico","NUMBER_COURSES_TAKEN_IN_PAST_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Total acumulado de cursos matriculados pelo estudante em períodos acadêmicos anteriores","NUMBER_COURSES_TAKEN_IN_PAST_ACADEMIC_PERIOD_FACTOR_NAME":"Cursos realizados em períodos acadêmicos anteriores","NUMBER_FAILED_COURSES_IN_PAST_ACADEMIC_PERIOD_FACTOR_DESCRIPTION":"Total acumulado de cursos reprovados pelo estudante em períodos acadêmicos anteriores.","NUMBER_FAILED_COURSES_IN_PAST_ACADEMIC_PERIOD_FACTOR_NAME":"Cursos reprovados em períodos acadêmicos anteriores","NUMBER_NEGATIVE_CONTACTS_FACTOR_DESCRIPTION":"Número de vezes que o estudante foi contatado com resultado negativo durante o último semestre","NUMBER_NEGATIVE_CONTACTS_FACTOR_NAME":"Número de contatos com resultado negativo no último período acadêmico","NUMBER_OF_DEPENDENTS_FACTOR_DESCRIPTION":"O aluno tem pessoas a cargo economicamente: filhos, seu grupo familiar, etc. Relevante saber a média de dinheiro disponível, ou ao menos se tem dependentes.","NUMBER_OF_DEPENDENTS_FACTOR_NAME":"Pessoas a cargo","NUMBER_OF_SIBLINGS_FACTOR_DESCRIPTION":"Quantidade de irmãos que o estudante possui","NUMBER_OF_SIBLINGS_FACTOR_NAME":"Número de irmãos","NUMBER_POSITIVE_CONTACTS_FACTOR_DESCRIPTION":"Número de vezes que o estudante foi contatado com um resultado positivo durante o último semestre.","NUMBER_POSITIVE_CONTACTS_FACTOR_NAME":"Número de contatos com resultados positivos no último período acadêmico","NUMBER_QUOTA_PAYMENTS_FACTOR_DESCRIPTION":"Quantidade de parcelas pagas pelo estudante.","NUMBER_QUOTA_PAYMENTS_FACTOR_NAME":"Número de parcelas pagas","NUMBER_TUITION_PAYMENTS_FACTOR_DESCRIPTION":"Quantidade de pagamentos realizados pelo estudante por matrícula","NUMBER_TUITION_PAYMENTS_FACTOR_NAME":"Número de pagamentos de matrícula","NUMERO_ALUMNOS":"Número de estudantes","NUMERO_ALUMNOS_ACTIVOS":"Número de alunos ativos","NUMERO_ALUMNOS_HISTORICOS":"Número de alunos históricos","NUMERO_ALUMNOS_RIESGO":"Número de alunos em risco","OBSERVACION":"Observação","OPERACION_MANUALES":"Operações manuais","ORIGIN_SCHOOL_TYPE_FACTOR_DESCRIPTION":"Escola pública, privada, de recuperação de educação adulta, entre outros.","ORIGIN_SCHOOL_TYPE_FACTOR_NAME":"Tipo de escola de origem","OUTLIERS":"Outliers","PER_CAPITA_INCOME_FACTOR_DESCRIPTION":"Renda total do grupo familiar dividido pela quantidade de membros que dependem desta renda, incluindo o aluno","PER_CAPITA_INCOME_FACTOR_NAME":"Renda familiar per capita","PER_CAPITA_OUTCOME_FACTOR_DESCRIPTION":"Despesa total do grupo familiar dividido pela quantidade de membros que dependem da renda, incluindo o estudante.","PER_CAPITA_OUTCOME_FACTOR_NAME":"Formação familiar per capita","PERCENTAGE_APPROVED_CREDITS_IN_STUDY_PLAN_FACTOR_DESCRIPTION":"Porcentagem de créditos aprovados pelo aluno em relação ao total de créditos do plano de estudos.","PERCENTAGE_APPROVED_CREDITS_IN_STUDY_PLAN_FACTOR_NAME":"Porcentagem de créditos aprovados do plano de estudos","PERCENTAGE_APPROVED_CREDITS_ON_FIRST_YEAR_FACTOR_DESCRIPTION":"Porcentagem de créditos aprovados pelo aluno em relação ao total de créditos inscritos no primeiro ano.","PERCENTAGE_APPROVED_CREDITS_ON_FIRST_YEAR_FACTOR_NAME":"Porcentagem de créditos aprovados no primeiro ano acadêmico","PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Número de períodos acadêmicos em que o estudante esteve na instituição na carreira atual. O risco de abandono é alto por um número baixo de períodos de associação ou por valores extremamente altos.","PERIODS_IN_INSTITUTION_FACTOR_NAME":"Número de períodos na instituição","PHYSICAL_RESOURCE_USAGE_FACTOR_DESCRIPTION":"Número de recursos físicos utilizados pelo aluno durante o período acadêmico","PHYSICAL_RESOURCE_USAGE_FACTOR_NAME":"Uso de recursos físicos","PLAN_ESTADO_ACTUAL":"Plano de estudo e estado atual","PORCENT_ALUMNOS_RIESGO":"Porcentagem de alunos em risco","PREGNANCY_INDICATOR_FACTOR_DESCRIPTION":"Gravidez de aluna ou de seu parceiro. Relevante devido à pressão econômica, efeito nos resultados acadêmicos, entre outros.","PREGNANCY_INDICATOR_FACTOR_NAME":"Gravidez","PREGRADO":"Graduação","PREVIOUS_ACADEMIC_EXPERIENCE_INDICATOR_FACTOR_DESCRIPTION":"O aluno concluiu estudos superiores antes.","PREVIOUS_ACADEMIC_EXPERIENCE_INDICATOR_FACTOR_NAME":"Experiência acadêmica anterior","PREVIOUSLY_FAILED_COURSES_TAKEN_IN_SEMESTER_FACTOR_DESCRIPTION":"Número de disciplinas matriculadas pelo aluno durante o período acadêmico atual, que foram previamente reprovadas pelo aluno.","PREVIOUSLY_FAILED_COURSES_TAKEN_IN_SEMESTER_FACTOR_NAME":"Número de cursos matriculados no período acadêmico que foram previamente reprovados","PRIMERO":"Primeiro","PROBABILIDAD_DESERCION":"Probabilidade de deserção","PROBABILIDAD_HISTORICA":"Risco histórico","PROGRAM_EVALUATION_FACTOR_DESCRIPTION":"Opinião do aluno sobre a qualidade da instituição e do programa em particular, em termos de serviço (além da vocação).","PROGRAM_EVALUATION_FACTOR_NAME":"Opinião sobre o programa cursado","PSYCHOLOGICAL_HELP_INDICATOR_FACTOR_DESCRIPTION":"O aluno solicitou apoio psicológico durante sua permanência na instituição.","PSYCHOLOGICAL_HELP_INDICATOR_FACTOR_NAME":"Ajuda psicológica","RAZONES_DESERCION":"Razões de deserção","REG_INCOMPLETOS":"Registros Incompletos","REGISTRAR":"Registrar","REGISTRO_OBSERVACIONES":"Registro de observações","REGULAR_PERIODS_IN_INSTITUTION_FACTOR_DESCRIPTION":"Número de períodos regulares na instituição. Isso não inclui, por exemplo, semestres de verão.","REGULAR_PERIODS_IN_INSTITUTION_FACTOR_NAME":"Número de Períodos Regulares","REP_DATOS_CARGADOS":"Relatório de dados carregados","REP_RETENTION":"Relatórios de u-retention","RESULTADO_CALIBRACION":"Resultado de calibração","RESULTADO_CARGA_DATOS":"Resultado do carregamento de dados","RESULTADO_CONTACTO":"Resultado de contato","RIESGO":"Risco","RISK_PROFILE":"Perfil de risco","SCHOLARSHIP_INDICATOR_FACTOR_DESCRIPTION":"Identificação do tipo de bolsa de estudos que o aluno possui, para agrupar alunos semelhantes.","SCHOLARSHIP_INDICATOR_FACTOR_NAME":"Aluno possui bolsa de estudos","SCHOLARSHIP_PERCENTAGE_FACTOR_DESCRIPTION":"Porcentagem de bolsa de estudos que foi atribuída ao aluno, caso ele tenha uma bolsa de estudos.","SCHOLARSHIP_PERCENTAGE_FACTOR_NAME":"Porcentagem de bolsa de estudos","SEGUIR_ESTUDIANTE":"Acompanhamento de estudantes","SELECT_SUBMODEL_CARREER":"Selecionar submodelo - carreira","SELECTION_EXAM_SCORE_FACTOR_DESCRIPTION":"Qualificação obtida nos exames de admissão à universidade.","SELECTION_EXAM_SCORE_FACTOR_NAME":"Resultados em exames de seleção","SEX_FACTOR_DESCRIPTION":"Relevante já que os resultados dos estudos mostram diferenças nos índices de permanência por gênero.","SEX_FACTOR_NAME":"Sexo","SEXO":"Sexo","SHOW_ALL_INSTITUTIONAL_INDICATORS":"Mostrar todos los indicadores institucionales","SHOW_TRACKED_STUDENTS":"Mostrar estudiantes en seguimiento","SIBLING_POSITION_FACTOR_DESCRIPTION":"Número de posição entre seus irmãos, se tiver.","SIBLING_POSITION_FACTOR_NAME":"Posição entre irmãos","SPECIAL_ADMISSION_FACTOR_DESCRIPTION":"Indica se, de acordo com os registros da instituição, o aluno ingressou em uma carreira em um nível diferente do inicial.","SPECIAL_ADMISSION_FACTOR_NAME":"Entrada em nível superior","STARTING_SEMESTER_FACTOR_DESCRIPTION":"Semestre em que o aluno ingressa na instituição.","STARTING_SEMESTER_FACTOR_NAME":"Semestre de Ingresso","STOP_TRACKING":"","STUDENT_DETAILS":"Detalhe do estudante","STUDENT_DOESNT_HAVE_INDICATORS":"El estudiante no posee indicadores","STUDENT_FROM_ANOTHER_CITY_FACTOR_DESCRIPTION":"O efeito da mudança de cidade é registrado na literatura e na análise de múltiplas instituições, com a consequente perda de redes de apoio e o desafio adicional de se acostumar com o novo ambiente.","STUDENT_FROM_ANOTHER_CITY_FACTOR_NAME":"Aluno vem de outra cidade","STUDENT_IS_SINGLE_FACTOR_DESCRIPTION":"Tem relevância para rede de apoio e nível de responsabilidades fora dos estudos.","STUDENT_IS_SINGLE_FACTOR_NAME":"Estudante é solteiro","STUDENT_WORKS_INDICATOR_FACTOR_DESCRIPTION":"Estudante trabalha ou se dedica completamente aos estudos","STUDENT_WORKS_INDICATOR_FACTOR_NAME":"Situação laboral do estudante","STUDY_HABITS_FACTOR_DESCRIPTION":"Aluno estuda sozinho ou em grupo. Uso de LMS (Learning Management System) como suporte, obtendo livros da biblioteca.","STUDY_HABITS_FACTOR_NAME":"Métodos de estudo","SUBMODEL":"Submodelo Institucional","SUBMODEL_CONFIG":"Configuração do submodelo","SUM_ENTERA":"Soma Total","SUM_FRACC_COL":"Soma como Fração das Colunas","SUM_FRACC_FILAS":"Soma como fração das filas","SUM_FRACC_TOTAL":"Soma como fração do total","SUM_SOBR_SUM":"Soma sobre soma","SUMA":"Soma","TABLA":"Tabela","TABLA_DINAMICA":"Tabela dinâmica","TABLA_GRAFICO_BARRAS":"Tabela com Gráfico de Barras","TELEFONO":"Telefone","TELEFONOS":"Telefones","TIME_BETWEEN_SCHOOL_GRADUATION_AND_HIGHER_EDUCATION_ENTRANCE_FACTOR_DESCRIPTION":"Quantidade de anos entre os quais o aluno terminou o ensino escolar e ingressou no ensino superior.","TIME_BETWEEN_SCHOOL_GRADUATION_AND_HIGHER_EDUCATION_ENTRANCE_FACTOR_NAME":"Tempo entre o ensino médio e a admissão no ensino superior","TOTAL_CONTACTS_FACTOR_DESCRIPTION":"Número total de vezes que o estudante foi contatado pela instituição no atual período acadêmico.","TOTAL_CONTACTS_FACTOR_NAME":"Número total de contatos no período acadêmico atual","TOTAL_CREDITS_FIRST_YEAR_FACTOR_DESCRIPTION":"Quantidade de créditos cursados no primeiro ano.","TOTAL_CREDITS_FIRST_YEAR_FACTOR_NAME":"Número de créditos cursados no primeiro ano acadêmico","TOTAL_CREDITS_SEMESTER_FACTOR_DESCRIPTION":"Número total de créditos inscritos no período acadêmico.","TOTAL_CREDITS_SEMESTER_FACTOR_NAME":"Total de créditos no período acadêmico","TOTAL_REGISTROS_PRUEBA":"Total de registros de prueba","TRACK":"Acompanhar","TRACK_STUDENT":"Acompanhamento de estudante","TREEMAP":"Treemap","TREND_PARTIAL_GRADE_FACTOR_DESCRIPTION":"Tendência observada nas notas (positiva, negativa ou neutra).","TREND_PARTIAL_GRADE_FACTOR_NAME":"Tendência de notas parciais","U_RETENTION":"u-retention","ULTIMO":"Último","ULTIMOS_X_SEMESTRES_REG":"Últimos @year semestres regulares","VALOR":"Valor","VAR_DE_MUESTRA":"Variação da Amostra","VARIABILIDAD":"Variabilidade","VER_FICHA":"Visualizar Ficha","VOCATIONAL_CAREER_RELATIONSHIP_INDICATOR_FACTOR_DESCRIPTION":"Carreira que o aluno estuda versus o que ele declara como sua vocação, no caso de tê-lo.","VOCATIONAL_CAREER_RELATIONSHIP_INDICATOR_FACTOR_NAME":"Relação vocação/carreira cursada","VOLVER_ALERTAS_INDIVIDUAL":"Voltar a Alertas Individuais","ACADEMIC_CALENDAR_DETAIL":"Detalhe do calendário acadêmico","ACADEMIC_PLAN":"Plano acadêmico","ACADEMIC_UNIT":"Unidade acadêmica","ACCEPT":"Aceitar","ACTIONS":"Ações","ACTIVATE":"","ACTIVATE_DEACTIVATE":"Ativar / Desativar","ACTIVE":"Ativo","ACTIVITY":"Atividade","ACTIVITY_NAME":"Atividade","ACTIVITY_TYPE":"Tipo de atividade","ADD_CANDIDATE":"","ADDED_CANDIDATES":"","ADDRESS":"Endereço","ADVANCED_OPTIONS":"Opções avançadas","ADVANCED_SEARCH":"Pesquisa avançada","AGENDA":"Agenda","ALL":"Todos los","ALL_THE":"Todos os","AMOUNT_DESTINY":"Quantidade de destino","AMOUNT_ORIGIN":"Quantidade de origem","ANONYMOUS":"Anônimo","API_VERSION":"Versión API","APPROVE":"Aprovar","Apr":"Abr","April":"Abril","ASIGNATURE":"Curso","ASK_FOR_CONTINUE":"Você tem certeza de que quer continuar?","ASSIGNATION_CODE":"Código de atribuição","ASSIGNATION_SCHEDULE_ROOM":"Atribuição de tempo e sala","ATTACHED_FILES":"Arquivos anexados","ATTACHED_TO":"Anexado a","ATTENDANCE_QUESTION":"Assistência?","Aug":"Ago","August":"Agosto","AUTHOR":"Autor","AVERAGE":"Média","BACK":"Voltar","BATCH_UPLOAD":"Carregamento massivo","BLOCKS_USED_WEEKLY":"Blocos usados ​​semanalmente","BUILDING":"Edifício","CALCULATION_TYPE":"Tipo de cálculo","CALENDAR":"Calendário","CALENDAR_VIEW":"","CAMPUS":"Campus","CAMPUS_CODE":"Código do campus","CAMPUS_ID":"ID do Campus","CAMPUS_NAME":"Nome do campus","CAMPUS_PERIOD_SHIFT":"Campus - Período - Dia","CANCEL":"Cancelar","CANCEL_SIMULATION":"Cancelar simulação","CANDIDATE":"","CANT_CAREERS":"Quantidade de carreiras","CANT_COURSES":"Quantidade de cursos","CANT_STUDENTS":"Quantidade de estudantes","CAPACITY":"Capacidade","CAPTURE":"Editar","CATEGORY":"categoria","CHANGE":"Alterar","CLASSROOMS":"Salas","CLICK_TO_SEE_MORE":"","CLIENT_NICENAME":"u-planner","CLONE":"Clonar","CLOSE":"Fechar","CODE":"Código","COHORTE":"","COMMENT":"Comentário","COMMENTS":"Comentários","COMMONS_COURSES":"Cursos comuns","COMPACTED_GROUPS":"Grupos compactados","COMPATIBILITY_GROUP":"Grupo de compatibilidade","COMPETENCY_MATRIX":"Matriz de Competência","COMPONENT_TYPE":"Tipo de componente","COMPONENT_WEIGHT":"","CONFIGURE":"Configurar","CONFIRM":"Confirmar ação","CONFIRMED":"Confirmada","CONSECUTIVE_BLOCKS":"","CONSECUTIVE_MODULES":"Módulos Consecutivos","CONTACT_NUMBER":"Telefone de contato","COORDINATOR":"Coordenador","COURSE":"Curso","COURSE_DETAIL":"Detalhe do curso","COURSE_DETAILS":"Detalhe dos cursos","COURSE_MATTER":"Curso/matéria","CREATE_CAMPUS":"Criar campus","CREATE_FACULTY":"Criar faculdade","CREATE_STATE":"Criar estado","CREATED_AT":"Data de criação","CREATION":"Criação","CREATOR_USER":"","CURRICULAR":"Curricular","CUSTOM":"Personalizado","CYCLE":"Ciclo","CYCLE_PASSED":"Ciclo em que foi aprovado","DATA":"Dados","DATA_INTEGRATION":"","DATA_INTEGRATION_EXECUTE":"","DATA_LOADED_CORRECTLY":"","DATA_NOT_LOADED":"","DATES":"Datas","DAY":"Dia","DAY_MODULES":"Dias / módulos","DAYS":"Dias","DEADLINE":"Data limite","Dec":"Dic","December":"Dezembro","DEFINE_SCHEDULE":"Definir horário","DELAY":"Atraso","DELAY_QUESTION":"Atraso?","DELETE":"Excluir","DESCRIPTION":"Descrição","DESIGNATIONS":"","DESTINY":"Destino","DETAILS":"","DIMENSION":"Dimensão","DISABLE_CAMPUS_PROMPT":"Você tem certeza de que deseja desativar este campus?","DO_UPLOAD_DATA":"","DOWNLOAD_FORMAT":"Baixar formato","DRAG_FILES":"Arrastar arquivos aqui","EDIT":"Editar","EDIT_ACADEMIC_CALENDAR":"Editar calendário acadêmico","EDIT_COURSE_COMPETENCY_TRIBUTE":"Editar tributação de cursos a competências","EDIT_FACULTY":"Editar faculdade","EDIT_LIST":"Editar lista","EMAIL":"Correio","END_HOUR":"Hora término","ENTER":"Entrar","ENTER_PASSWORD":"Digite sua senha","ENTER_VALID_USERNAME":"Digite um nome de usuário válido","ENTER_YOUR_REQUIREMENTS_AND_COMMENTS":"","ERROR":"Error","ERRORS_REPORT":"Relatório de erros","EVALUATION_CRITERIA":"Critérios de Avaliação","EVALUATION_NAME":"Nome Avaliação","EVERY":"Cada","EXPORT":"Exportar","EXPORT_CSV":"","EXPORT_XLS":"","EXTRACURRICULAR":"Extracurricular","Feb":"Fev","February":"Fevereiro","FICTIONAL":"Fictício","FILE":"Arquivo","FILTER":"Filtrar","FILTER_INFO_NOT_FOUND":"Não há informações para o filtro selecionado","FILTER_TO_SEE":"Filtre para visualizar","FILTERS":"","FINAL":"Final","FINAL_EVALUATION":"","FINISH":"Finalizar","FLOOR":"Piso","Fri":"Sex","Friday":"Sexta-feira","FROM":"Desde","FRONT_VERSION":"Versión front","FUNCTIONS":"Funções","GENERAL":"","GENERAL_DATA":"Dados gerais","GENERANTING_CODES":"","GO_BACK":"Voltar","GROUPS":"Grupos","HEIGHT":"Alto","HELP":"Ajuda","HIDE":"Ocultar","HIDE_FILTERS":"","HOURS":"Horas","ID_FATHER":"ID Pai","IDLE_CAPACITY":"Capacidade ociosa","IMAGE":"Imagem","IMPLEMENTS":"Implemento","INACTIVE":"Inativo","INFO_NOT_FOUND":"Não há informação","INFORMATION":"","INFRASTRUCTURE_QUOTA":"Quota infraestrutura","INITIAL":"Inicial","INITIATE_DATA_INTEGRATION":"","INITIATE_UPLOAD_DATA":"","INSERT_END_DATE":"Insira data de término","INSERT_START_DATE":"Insira data de início","INVALID":"Inválido","IS_REQUIRED":"É necessário","Jan":"Jan","January":"Janeiro","Jul":"Jul","July":"Julho","Jun":"Jun","June":"Junho","LAST_15_DAYS":"Últimos 15 dias","LAST_30_DAYS":"Últimos 30 dias","LAST_7_DAYS":"Últimos 7 dias","LAST_WEEK":"Semana passada","LENGTH":"Longo","LEVEL":"Nível","LEVEL_SCHEMA":"Esquema de desenvolvimento de competências","LOADING":"Carregando","LOADING_AFFECTED_SIMULATIONS":"Carregando simulações afetadas","LOADING_INDICATORS":"","LOCATION":"Localização","LOGIN_PROMPT":"Digite seus dados de acesso","MANAGE":"Administrar","MANAGEMENT":"Administrador","MANAGEMENTS":"Administradores","Mar":"Mar","March":"Março","MAX_WEEKLY_BLOCKS":"Max blocos semanais","May":"Maio","MENU_COLLAPSE":"Colapsar menu","MENU_LANG":"Idioma","MENU_LOGOUT":"Sair","MENU_MY_PROFILE":"Meu perfil","MENU_OPTIONS":"Opções","MENU_START":"Início","MERGE":"Mesclar","MERGE_SECTIONS":"Compactação de Seções","MIN_BLOCK_CREDITS":"Créditos mínimos do bloco","MINUTES":"Minutos","MINUTES_AFTER":"","MINUTES_BEFORE":"","MODALITY":"Modalidade","MODIFICATION":"Modificação","MODIFICATOR_USER":"","MODULE":"Módulo","MODULE_COMPONENT":"","MODULES":"Módulos","MODULES_PER_WEEK":"Módulos por semana","MODULES_ROOMS":"Módulos / Salões","Mon":"Seg","Monday":"Segunda-feira","MONTH":"Mês","MORE_INFORMATION":"More information","MSJ_ACADEMIC_CALENDAR_DAY_MODULES":"","MSJ_ACADEMIC_CALENDAR_WEEKS":"Selecione as semanas que constituirão o novo calendário acadêmico.","MSJ_ALL_CHANGES_ARE_SAVED_AUTOMATICALLY":"Todas as alterações são salvas automaticamente","MSJ_CODE_EXISTS":"","MSJ_CREATION_SUCCESS":"Ação finalizada corretamente","MSJ_DEFINITIVE_SENDING_OF_GRADES ":"O registro de notas no Portal será confirmado. Lembre-se que ao confirmar o registro de notas você não poderá modificá-lo, se você quiser alguma correção você deve ir aos escritórios de registros acadêmicos.","MSJ_DELETE":"Os registros foram excluídos","MSJ_FAIL_TO_UPLOAD":"Erro ao carregar","MSJ_INCORRECT_USER_PASS":"Nome de usuário / senha incorreta","MSJ_MAINTENANCE_NOTIFICATION":"","MSJ_NO_DATA_RELATED_YOUR_SEARCH":"Não há dados relacionados à sua pesquisa","MSJ_PARAMETERS_SAVED_CORRECTLY":"","MSJ_PLEASE_WAIT_WHILE_PROCESSING_FILE":"Por favor, aguarde enquanto o arquivo é processado, você será redirecionado para a tela de resultados","MSJ_REQUIRED_FIELDS_MISSING":"","MSJ_SCHEDULE_SAVED_SUCCESSFULLY":"","MSJ_SUCCESFUL_UPLOAD_FILES":"Arquivo/s carregados com sucesso","MSJ_TEACHER_SIMULATION_PROGRESS":"A barra de progresso informa o estado em que a simulação está, é aconselhável não cancelar, para realizar outro fluxo basta clicar no botão para executar no 2º plano.","MSJ_UPDATED_SUCCESSFULLY":"Carregada corretamente","MSJ_UPLOADED_SUCCESSFULLY":"","MSJ_USER_DOESNT_MATCH_WITH_LOGGED_IN":"O usuário inserido não corresponde ao autenticado","N_ENROLLED":"Nº Inscritos","N_LINE":"","N_OF_LICENCES":"Número de licenças","N_OF_PERIOD":"Nº Período","N_OF_SECTIONS":"Nº Seções","N_OF_STUDENTS":"Nº Alunos","N_PLAN":"","N_STUDENTS":"Nº Estudantes","NAME":"Nome","NAME_STAGE":"Nome Cenário","NAMES":"Nomes","NEXT_DAYS":"Dias seguintes","NO":"Não","NO_NAME":"Sem nome","NO_NOTES":"Sem anotações","NO_OFFICIAL_GRADE":"Nota não oficial","NOT_STARTED":"","NOT_SYNCHRONIZABLE":"Não sincronizável","NOT_TRACKING":"Sem acompanhamento","Nov":"Nov","November":"Novembro","NRC":"NRC","NUMBER_OF":"Nº","OBSERVATION":"Observação","OBSERVATION_DESCRIPTION":"Observação / Descrição","OBSERVATIONS":"Observações","Oct":"Out","October":"Outubro","OF":"de","OPERATION":"Operação","ORIGIN":"Origem","ORIGINAL_AMOUNT":"","PARAMETERIZATION":"","PASSWORD":"Senha","PENDING":"Pendente","PERCENTAGE":"Percentagem","PERCENTAGE_ASSIGNATION_SCHEDULE_ROOM":"","PERCENTAGE_OCCUPIED_CAPACITY":"Percentagem de capacidade ocupada","PERIOD":"Período","PERIOD_CODE":"Código do Período","PERIOD_CREATE":"Criar período","PERIOD_NAME":"Nome do período","PERIODS":"Períodos","PERMISSIONS":"Permissões","PERSONAL_ID":"RUT","PLAN":"Plano","PREVIOUS_DAYS":"Dias anteriores","PRIVACY_POLICIES":"Políticas de privacidade","PRODUCT":"Produto","PROGRAMMABLE":"Programável","PROGRAMMED":"","PROGRESS_SUGGEST":"Progresso Sugerido","PROPERTIES":"Características","REAL":"Real","REGENERATE_CODES":"","REJECT":"Rejeitar","REJECTED":"Rejeitado","REPEAT":"Repetir","REPLACEMENT":"Substituição","REPLACEMENT_QUESTION":"Substituição?","REQUEST":"Pedido","REQUEST_ACCEPTED":"Pedido aceito","REQUEST_STATE":"Estado Pedido","REQUIRED":"Obrigatório","RESOURCE":"Recurso","RESOURCES":"Recursos","RESPONSIBLE":"Responsável","RESTORE":"Restaurar","RESULTS":"Resultados","ROLES":"funções","ROOT":"Raiz","Sat":"Sab","Saturday":"Sábado","SAVE":"Salvar","SAVE_RETURN":"Salvar e voltar","SCALE_MAX":"","SCALE_MIN":"","SCHEDULE":"Horário","SCHEDULE_BATCH_UPLOAD":"Carga masiva de horarios","SCHEDULE_SIMULATION_PROGRESS":"Progresso simulação horário","SCHEDULE_TYPE":"Tipo de calendário","SEARCH_SECTIONS":"","SECTION":"Seção","SECTION_CODE":"Código Seção","SECTION_DETAIL":"Detalhe da seção","SECTION_ID":"ID de seção","SEE":"Visualizar","SEE_DETAIL":"Visualizar Detalhe","SEE_DETAILS":"Visualizar Detalhes","SEE_EDIT":"Visualizar / Editar","SELECT":"Selecione","SELECT_ALL":"Selecionar tudo","SELECT_APPLICATION":"Selecione aplicação","SELECT_CAMPUS":"Selecione Campus","SELECT_COURSE":"Selecione curso","SELECT_DAY":"Selecione dia","SELECT_LEVEL_IN_COMPETENCY":"Selecione o nível de desenvolvimento de competência","SELECT_MODULE":"Selecione módulo","SELECT_NAME_EVALUATION":"Selecionar nome avaliação","SELECT_ONE_SUPERVISOR_MSJ":"Selecione pelo menos um supervisor","SELECT_PERIOD":"Selecione período","SELECT_PERIODS":"Selecione períodos","SELECT_PROGRAMMING":"Selecione programação","SELECT_SCHEDULE_SIMULATION":"","SELECT_SIMULATION":"","SELECT_SPECIALTY":"","SELECT_SUBJECT":"Selecione disciplina","SELECT_SUPERVISOR":"Selecionar Supervisor","SELECT_WEEK":"Selecione semana","SELECTED_WEEK":"Semana selecionada","SEND":"Enviar","Sep":"Set","September":"Setembro","SETTINGS":"Ajustes","SHIFT":"Dia","SHOW":"Mostrar","SHOW_ADVANCED_FILTERS":"Mostrar / ocultar filtros avançados","SHOW_FILTERS":"Mostrar filtros","SIMBOLIZATION":"Simbologia","SIMULATED_GRADE":"Nota simulada","SQUARE_METERS":"m2","START_END_HOUR":"Hora início/fim","START_HOUR":"Hora início","STARTED":"Iniciada","STATE":"Estado","STATE_LIST":"Lista de estados","STATES":"Estados","STATUS":"Estado","STUDENT":"Estudante","STUDENTS":"Estudantes","STUDENTS_LEVEL":"Nivel estudiante","STUDY_PLAN":"Plano de estudo","Sun":"Dom","Sunday":"Domingo","SURNAME":"Sobrenome","SURNAMES":"Sobrenome","SYNCHRONIZABLE":"Sincronizável","SYNCHRONIZED":"Sincronizado","TEACHER":"Docente","TEACHER_EVALUATION":"Avaliação Docente","TEACHER_NAME":"","TEACHER_ROLE":"Cargo Docente","Thu":"Qui","Thursday":"Quinta-feira","TO_ASSIGN":"Atribuir","TO_UNASSIGN":"Retirar atribuição","TODAY":"Hoje","TOTAL":"Total","TOTAL_CANDIDATES":"","TOTAL_CLASS":"Total Classe","TOTAL_MODULES":"","TOTAL_PREDEFINED":"","TOTAL_STUDENTS":"Total Estudantes","TRACKING":"Acompanhamento","TRANSFER_STUDENTS":"Transferir alunos","TRANSITION":"Transição","TRANSITION_FUNCTION":"Função da Transição","Tue":"Ter","Tuesday":"Terça-feira","U_ANALYTICS":"u-analytics","U_FACULTY":"u-faculty","U_LEARNING":"u-learning","U_SUITE":"u-suite","U_SUITE_ABOUT":"","UNIQUE_GROUP":"Grupo único","UNLOCK":"Retirar atribuição","UNTIL":"Até","UPDATE":"Atualização","UPDATE_CANCEL":"Atualizar / Cancelar","UPDATE_CANCEL_EVENT":"Atualizar / Cancelar evento","UPDATE_DATE":"","UPDATED":"Atualizado","UPLOAD_DATA_ERROR_MSJ":"Erro! Os dados não foram carregados corretamente","UPLOAD_FILES":"","UPLOAD_IMAGE":"Carregar imagem","UPLOAD_VIDEO":"Carregar vídeo","USAGE":"Uso","VERSION":"Versão","VIDEO":"Video","VIEW":"Visualizar","VIRTUAL":"Virtual","VISUALIZATION":"Visualização","VISUALIZATIONS":"Visualizações","WARNING_INPUTS_REQUIRED":"* O campo é obrigatório","WARNING_MESSAGE_EDIT_DEFAULT":"Você deseja salvar as alterações?","WEB_SITES":"Websites","Wed":"Qua","Wednesday":"Quarta-feira","WEEK":"Semana","WEEK_MONTH":"Semana / mês","WEEKLY_BLOCKS":"Blocos semanais","WEEKLY_HOURS":"Horas semanais","WEEKS":"Semanas","WEIGHT":"Peso","WELCOME":"Bem vindo","WIDTH":"Largura","WITHOUT_AFFECTED_SIMULATIONS":"Sem simulações afetadas","WITHOUT_CODE":"Sem código","YES":"Sim","YES_NO":"Sim / não"}

/***/ }),
/* 164 */
161,
/* 165 */
162,
/* 166 */
163,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./uplanner_en.json": 164,
		"./uplanner_es.json": 165,
		"./uplanner_por.json": 166
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 167;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	module.exports = " <div id=header class=app-content-header role=main ui-view=header@> </div> <md-sidenav id=aside class=\"app-aside md-sidenav-left\" ng-class=\"{'folded': folded}\" ui-view=aside@ md-component-id=aside> </md-sidenav> <div id=content class=app-content role=main ui-view=content@> </div> <div id=chatbox role=main ui-view=chatbox@ ng-show=showChat> </div> <div id=reflections role=main ui-view=reflections@ ng-show=showReflections> </div> <div id=comments role=main ui-view=comments@ ng-show=showComments> </div> <div id=footer ui-view=footer@> </div> ";

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "<div class=box> <div class=\"breadcrumb exo p-h-lg\"> <div> <ui-breadcrumbs displayname-property=data.displayName abstract-proxy-property=data.proxy template-url=ngBreadCrumbTemplate.html></ui-breadcrumbs> </div> </div> <div class=\"box-row content-box\"> <div class=box-cell> <div class=\"box-inner padding-box no-padding\" ui-view id=view> </div> </div> </div> </div> ";

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"box sidebar-menu exo\"> <div class=box-row> <div class=box-cell> <div class=box-inner> <div class=\"p hidden-folded leftbarbg\"> <div> <div class=\"img-responsive rounded\"> </div> <img ng-src={{picture}} class=\"img-responsive rounded image_portal\" err-src={{pictureRosario}} err-src-resolve=onUserPictureError> <div class=\"p-b-md pull-right\"> <label class=\"icon mdi-image-edit i-20\"> <span class=hiddenFileInput> <input class=\"\" type=file nv-file-select=\"\" name=sampleFile uploader=uploader onchange=angular.element(this).scope().uploader.uploadAll() /> </span> </label> </div> </div> <a class=\"block m-t-sm account_settings font-small\" ng-click=toogleAccountClass() ui-toggle-class=\"hide, show\" target=\"#nav, #account\"> <span class=\"block text-gris-light font-small\" style=color:#ccd0db!important> {{admin.name}} ({{rolActive}}) </span> <span class=\"pull-right auto\"> <i class=\"fa inline fa-caret-down\"></i> <i class=\"fa none fa-caret-up\"></i> </span> {{admin.email}} </a> </div> <div id=nav ng-include=\"'aside.nav.uikit.html'\"></div> <div id=account class=\"hide m-v-xs\"> <nav ui-nav> <ul class=nav> <li> <a md-ink-ripple ui-sref=page.settings> <i class=\"icon mdi-action-settings i-20\"></i> <span class=font-small>Opciones</span> </a> </li> <li> <a md-ink-ripple ng-click=menuLogout()> <i class=\"icon mdi-action-exit-to-app i-20\"></i> <span class=font-small>Salir</span> </a> </li> <li class=\"m-v-sm b-b b\"></li> </ul> </nav> </div> </div> </div> </div> <nav> <div has-permission=configuracion-view> <ul class=\"nav b-t b negro-darker\"> <li> <a class=text-center ui-sref=generalSettings.main md-ink-ripple> <i class=\"text-center icon mdi-action-settings i-20\" style=text-align:center!important;width:100%;display:block></i> <span class=font-small>Configuración</span> </a> </li> </ul> </div> </nav> </div> <style type=text/css>.hiddenFileInput>input{height:100%;width:100;opacity:0;cursor:pointer}.hiddenFileInput{width:0;height:0;display:inline-block;overflow:hidden;background:center center no-repeat;background-size:75% 75%}.customfileupload{position:absolute;top:61px;left:71px}</style>";

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"navbar md-whiteframe-z1 no-radius\" ng-class=\"$state.current.data.theme ? $state.current.data.theme.primary : app.setting.theme.primary\"> <a md-ink-ripple ng-click=asideParentClick() id=menubaritem class=\"navbar-item pull-left menu-right\"><i class=\"mdi-navigation-menu i-28\"></i> MEN&#218; </a> <h5 id=menubaritem2 class=\"navbar-item pull-left menu-right-2 no-margin\">{{ menuTitle }}</h5> <a md-ink-ripple class=\"navbar-item pull-left\" ng-click=goBack() ng-show=$state.current.data.child><i class=\"mdi-navigation-arrow-back i-24\"></i></a> <ul class=\"nav nav-sm navbar-tool pull-right\"> <li class=dropdown> <a md-ink-ripple data-toggle=dropdown class=\"\" style=padding-left:20px;padding-right:20px> <md-tooltip md-direction=bottom>Chat</md-tooltip> <i class=\"fa icon mdi-communication-forum faa-pulse animated-hover i-24\"></i> <b class=\"badge bg-danger up\" style=background-color:#000 ng-hide=\"totalNotifications == 0\">{{totalNotifications}}</b> </a> <ul class=\"dropdown-menu dropdown-menu-scale pull-right text-color\" style=min-width:110px!important> <li><a ng-click=openChat() class=\"p pointer\" style=opacity:{};>Abrir Chat</a></li> <li class=divider></li> <li><a ng-click=openComments() class=\"p pointer\" style=opacity:{};>Cerrar Chat</a></li> </ul> </li> </ul> <ul class=\"nav nav-sm navbar-tool pull-right\"> <li class=dropdown> <a md-ink-ripple data-toggle=dropdown class=\"\" style=padding-left:20px;padding-right:20px> <i class=\"fa icon mdi-action-account-circle faa-pulse animated-hover i-24\"></i> </a> <md-tooltip md-direction=bottom>Roles</md-tooltip> <ul class=\"dropdown-menu dropdown-menu-scale pull-right text-color\"> <li ng-repeat=\"item in roles[0].items\" ui-sref-active=active id=super_menu_li_{{$index}} class=super_menu_li> <a md-ink-ripple ng-click=roleClick(item)> {{item.role_name | translate}} </a> </li> </ul> </li> </ul> <ul class=\"nav nav-sm navbar-tool pull-right\"> <li class=dropdown> <a md-ink-ripple data-toggle=dropdown class=\"\" style=padding-left:20px;padding-right:20px> <md-tooltip md-direction=bottom>Notificaciones</md-tooltip> <i class=\"icon glyphicon glyphicon-bell i-24\"></i> <b class=\"badge bg-danger up\">{{countNotificationsUserInboxNoRead}}</b> </a> <ul class=\"notifications dropdown-menu dropdown-menu-scale pull-right text-color\"> <div class=scrollable-dropdown> <li ng-repeat=\"var in notificationUserInbox\" ui-sref-active=active id=super_menu_li_{{$index}} class=super_menu_li ng-if=\"countNotificationsUserInboxNoRead > 0\"> <a md-ink-ripple ng-click=notificationUserInboxClick(var)> {{var.dt_creationDate | date:'yyyy-MM-dd'}} - {{var.ds_name}} </a> </li> <li ui-sref-active=active id=no_notification_read class=super_menu_li ng-if=\"countNotificationsUserInboxNoRead === 0\"> <p class=\"p-md text-center\"> No tiene notificaciones pendientes </p> </li> </div> <li class=divider ng-if=\"countNotificationsUserInboxNoRead > 0\"></li> <li ui-sref-active=active id=super_menu_li_all_notification class=super_menu_li ng-if=\"countNotificationsUserInboxNoRead > 0\"> <a md-ink-ripple ng-click=notificationUserInboxAllClick(notificationUserInbox[0].id_user)> <p class=text-center>Ver m�s</p> </a> </li> </ul> </li> </ul> <div class=\"v-line pull-right\"> <a class=\"\" ui-sref=app.inicio> <div alt=. class=\"navbar-brand navbar-brand-top-menu\"></div> </a> </div> <div class=pull-right ui-view=navbar@></div> </div> <style type=text/css>#header{overflow:inherit!important}.no-radius{border-radius:0!important;height:inherit}.notifications.notifications.dropdown-menu{width:350px}.notifications.dropdown-menu>.scrollable-dropdown>li>a{color:inherit;width:100%;overflow:hidden;height:auto;padding:16px;display:block;border-bottom:1px solid rgba(229,229,229,.86)}.notifications.dropdown-menu>.scrollable-dropdown>li>a:hover{background:rgba(229,229,229,.86)}.notifications.dropdown-menu>.scrollable-dropdown>li:last-child>a{color:inherit;padding:16px;border-bottom:1px solid transparent}.main-title{margin-left:350px;margin-top:24px}.scrollable-dropdown{height:auto;max-height:350px;overflow-x:hidden;overflow-y:auto}</style> ";

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = "<div class=container_main> <div class=container_firts ng-show=chatbox.openChatBox> <div class=chat_opened ng-if=\"chatbox.conversations.length > 3 ? true:false\"> <div class=contatcs_child> <div class=\"view-messageBoxes shadow-body\" ng-hide=chatbox.showMessageBoxes> <ul class=list-messageBoxes> <li ng-repeat=\"chatsOpened in chatbox.conversations | limitTo : chatbox.conversations.length - 1 : 3 \"><span ng-click=chatbox.openedChat(chatsOpened)>{{chatsOpened.userFullName}}</span><a href=\"\" ng-click=chatbox.closedChat(chatsOpened)>X</a></li> </ul> </div> <div class=f-c-h ng-click=\"chatbox.showChatsBoxes(chatbox.showMessageBoxes = !chatbox.showMessageBoxes)\"> <i class=\"fa fa-comment item-count\"></i> </div> </div> </div> <div class=container_contacts style=display:{};> <div class=contatcs_child> <div class=\"row shadow-body\" ng-show=chatbox.minimizeContact> <div class=c-d-c> <div class=t-c-c> <p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"chatbox.chatUser[0].onLine == 0 ? 'text-gris':'text-success'\" ng-show=chatbox.minimizeContact></p><a ng-show=chatbox.minimizeContact style=font-size:90%><strong>{{chatbox.chatUser[0].userFullName}}</strong></a> </div> <div class=\"col-md-1 t-c itms\"> <a href=\"\" ng-click=chatbox.minimizeContacs(false) class=\"fa fa-caret-down\"></a> </div> <div class=\"col-md-1 t-c itms pos_div\"> <a ng-click=chatbox.closeContacts()>X</a> </div> </div> <div class=\"col-md-12 c-l-c\"> <div class=\"chat friend contact\" ng-repeat=\"contacts in chatbox.chatContacts\" ng-click=chatbox.newChat(contacts)> <div class=user-photo><img ng-src={{contacts.userPicture}} err-src={{chatbox.defaultProfileImage}}></div> <a class=\"fa fa-fw fa-circle m-r-sm icon-pos\" ng-class=\"contacts.onLine == 0 ? 'text-gris':'text-success'\"></a> <div class=nm> <a>{{contacts.userFullName}}</a><br> <p>{{contacts.status}}</p> </div> </div> </div> </div> <div class=\"col-md-12 f-c\" ng-click=chatbox.minimizeContacs(true) style=width:220px> <p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"chatbox.chatUser[0].onLine == 0 ? 'text-gris':'text-success'\" ng-show=!chatbox.minimizeContact></p><a class=inf-lab ng-show=!chatbox.minimizeContact><strong>{{chatbox.chatUser[0].userFullName}}</strong></a> </div> </div> </div> <div class=container_chats ng-repeat=\"messageWindow in chatbox.conversations | limitTo : 3\"> <div class=contatcs_child> <div class=\"row shadow-body\" ng-show=messageWindow.showMessageWindow scroll-glue> <div class=c-d-c-c> <div class=\"col-md-10 t-c-con\"> <p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"messageWindow.onLine == 0 ? 'text-gris':'text-success'\"></p><a><strong>{{messageWindow.userFullName}}</strong></a> </div> <div class=\"col-md-1 t-c-a itms\"> <a ng-click=chatbox.showMessageWindowChat(messageWindow) class=\"fa fa-caret-down\"></a> </div> <div class=\"col-md-1 t-c-a itms\"> <a ng-click=chatbox.closedChat(messageWindow)>X</a> </div> </div> <div class=\"col-md-12 chatlogs c-t\" scroll-glue> <div ng-repeat=\"(key, value) in messageWindow.information | groupBy: 'dateDay'\"> <div class=time_class><a class=timeStamp>{{ key }}</a></div> <div class=chat ng-class=chatsTimes.classChat ng-repeat=\"chatsTimes in value\"> <div class=user-photo><img ng-src={{chatsTimes.from}} err-src={{chatbox.defaultProfileImage}}></div> <p class=chat-message>{{chatsTimes.data}}<br> <i ng-if=\"chatsTimes.senderId === chatbox.userLogin.id\" class=\"fa fa-remove delet_pos\" ng-click=\"chatbox.deleteAlertMessage(chatsTimes.messageId, messageWindow.idUser)\"> </i> </p> <div ng-hide=\"chatsTimes.send == 0\" class=chat-time> <p>{{chatsTimes.dateTime |date: 'dd/MM/yyyy hh:mma'}}</p> </div> <div ng-hide=\"!chatsTimes.send == 0\" class=icon-load> <p class=\"fa fa-spinner fa-pulse\"></p> </div> </div> </div> <div class=snackbar ng-show=messageWindow.delete> <p href=\"\" class=delete_message><a class=\"text-sm color-text-alert\">¿Desea eliminar el mensaje?</a><br><a href=\"\" ng-click=chatbox.deleteMessage(true) class=text-si>SI</a><a href=\"\" ng-click=chatbox.deleteMessage(false) class=text-no>NO</a></p> </div> <div class=delete_container ng-show=messageWindow.deleteSuccess> <p href=\"\" class=delete_message><a class=\"text-sm color-text-alert\">Eliminado!</a></p> </div> </div> <div class=\"col-md-9 chat-form-textarea back-textarea\"> <textarea type=text ng-model=messageWindow.newComment ng-keydown=\"chatbox.sendMessage($event, messageWindow.idUser, messageWindow.newComment)\" placeholder=\"Escribe tu mensaje...\" ng-model-options=\"{ debounce: 300 }\"></textarea> </div> <div class=\"col-md-3 chat-form-button back-button\"> <button ng-click=\"chatbox.sendMessage(chatbox.btnSend,messageWindow.idUser, messageWindow.newComment)\" type=button name=button>Enviar</button> </div> </div> <div class=\"col-md-12 f-c c-d-f\" ng-click=chatbox.showMessage(messageWindow)> <div class=\"pos-label truncate\" ng-show=!messageWindow.showMessageWindow> <p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"messageWindow.onLine == 0 ? 'text-gris':'text-success'\"></p><a class=inf-lab><strong>{{messageWindow.userFullName}}</strong></a></div> <div class=\"itms msj_new\"> <i class=\"fa fa-exclamation-circle alert_icon\" ng-if=messageWindow.new></i> </div> <div class=f-m-n style=\"\"> <a ng-click=chatbox.closedChat(messageWindow) ng-show=!messageWindow.showMessageWindow>X</a> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"fullscreen h-full w-full-sm\" ng-class=fullscreenClass> <div id=header class=app-content-header role=main ui-view=header@> </div> <md-sidenav id=aside class=\"app-aside md-sidenav-left\" ng-class=\"{'folded': !fullyFolded}\" ui-view=aside@ md-component-id=aside> </md-sidenav> <div id=content class=app-content role=main ui-view=content@> </div> <div id=chatbox role=main ui-view=chatbox@> </div> <div id=reflections role=main ui-view=reflections@ ng-show=showReflections> </div> <div id=comments role=main ui-view=comments@ ng-show=showComments> </div> <div id=footer ui-view=footer@> </div> </div> ";

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	module.exports = "<div class=box> <div class=box-row> <div class=box-cell> <div class=\"box-inner padding-box\" ui-view id=view> </div> </div> </div> </div> ";

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"box sidebar-menu exo\"> <div class=box-row> <div class=box-cell> <div class=box-inner> <div class=\"p hidden-folded leftbarbg sample\" style=\"\"> <div class=\"\"> <div class=\"img-responsive rounded\"> </div> <img ng-src={{picture}} class=\"img-responsive rounded image_portal\" err-src={{pictureRosario}} err-src-resolve=onUserPictureError> <div class=\"p-b-md filetype_upload\"> <label class=\"customfileupload icon mdi-image-edit i-20\"> <span class=hiddenFileInput> <input class=\"\" type=file nv-file-select=\"\" name=sampleFile uploader=uploader onchange=angular.element(this).scope().uploader.uploadAll() /> </span> </label> </div> </div> <a class=\"block m-t-sm account_settings font-small\" ng-click=toogleAccountClass() ui-toggle-class=\"hide, show\" target=\"#nav, #account\"> <span class=\"block text-gris-light font-small\" style=color:#ccd0db!important> {{admin.name}} ({{rolActive}}) </span> <span class=\"pull-right auto\"> <i class=\"fa inline fa-caret-down\"></i> <i class=\"fa none fa-caret-up\"></i> </span> {{admin.email}} </a> </div> <div id=nav ng-include=\"'aside.nav.uikit.html'\"></div> <div id=account class=\"hide m-v-xs\"> <nav> <ul class=nav> <li ng-repeat=\"items in roles\" ui-sref-active=active ng-click=\"menuClick($event, $index)\" id=parent_li_{{$index}} class=parent_li> <a md-ink-ripple> <span class=\"pull-right text-muted\"> <i class=\"fa fa-caret-down\"></i> </span> <i class=\"icon mdi-action-perm-contact-cal i-20\"></i> <span class=\"font-normal menu_title\">{{ 'ROLES' | translate }}</span> </a> <ul class=\"nav nav-sub\"> <li ng-repeat=\"item in items.items\" ui-sref-active=active id=super_menu_li_{{$index}} class=super_menu_li> <a md-ink-ripple ng-click=roleClick(item)> {{item.role_name | translate}} </a> </li> </ul> </li> <li> <a class=\"\" md-ink-ripple ui-sref=page.settings> <i class=\"icon mdi-action-settings i-20\"></i> <span class=font-small>{{ 'MENU_OPTIONS' | translate }}</span> </a> </li> <li class=parent_li ui-sref-active=active ng-click=\"menuClickLang($event,'language')\" id=parent_li_language> <a md-ink-ripple> <span class=\"pull-right text-muted\"> <i class=\"fa fa-caret-down\"></i> </span> <i class=\"icon mdi-action-translate i-20\"></i> <span class=font-small>{{ 'MENU_LANG' | translate }}</span> </a> <ul class=\"nav nav-sub\"> <li ng-repeat=\"lang_value in languages\" id=super_menu_li_lang_{{$index}} ng-click=super_menu_language($event,$index)> <a href=# ng-click=updateLanguage1(lang_value.key)> {{lang_value.value}} </a> </li> </ul> </li> <li> <a class=\"\" md-ink-ripple ng-click=menuLogout()> <i class=\"icon mdi-action-exit-to-app i-20\"></i> <span class=font-small>{{ 'MENU_LOGOUT' | translate }}</span> </a> </li> <li class=\"m-v-sm b-b b\"></li> </ul> </nav> </div> </div> </div> </div> <nav> <div has-permission=configuracion-view> <ul class=\"nav b-t b negro-darker\"> <li> <a class=text-center ui-sref=generalSettings.main md-ink-ripple> <i class=\"text-center icon mdi-action-settings i-20\" style=text-align:center!important;width:100%;display:block></i> <span class=font-small>Configuración</span> </a> </li> </ul> </div> </nav> </div> <style type=text/css>.hiddenFileInput>input{height:100%;width:100;opacity:0;cursor:pointer}.hiddenFileInput{width:0;height:0;display:inline-block;overflow:hidden;background:center center no-repeat;background-size:75% 75%}.customfileupload{position:absolute;top:61px;left:71px}</style>";

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = " <div id=transparentMenu class=navbar ng-class=\"$state.current.data.theme ? $state.current.data.theme.primary : app.setting.theme.primary\"> <a md-ink-ripple ng-click=asideParentClickfullScreen() id=menubaritem1 class=\"navbar-item pull-left menu-left\"><i class=\"mdi-navigation-menu i-28\"></i> MENÚ </a> <a md-ink-ripple class=\"navbar-item pull-left\" ng-click=goBack() ng-show=$state.current.data.child><i class=\"mdi-navigation-arrow-back i-28\"></i></a> <ul class=\"nav nav-sm navbar-tool pull-right\"> <li class=dropdown> <a md-ink-ripple data-toggle=dropdown class=\"\" style=padding-left:20px;padding-right:20px> <md-tooltip md-direction=bottom>Chat</md-tooltip> <i class=\"fa icon mdi-communication-forum faa-pulse animated-hover i-24\"></i> <b class=\"badge bg-danger up\" ng-hide=\"totalNotifications == 0\">{{totalNotifications}}</b> </a> <ul class=\"dropdown-menu dropdown-menu-scale pull-right text-color\" style=min-width:110px!important> <li><a ng-click=openChat() class=\"p pointer\" style=opacity:{};>Abrir Chat</a></li> <li class=divider></li> <li><a ng-click=openComments() class=\"p pointer\" style=opacity:{};>Cerrar Chat</a></li> </ul> </li> </ul> <ul class=\"nav nav-sm navbar-tool pull-right\"> <li class=dropdown> <a md-ink-ripple data-toggle=dropdown class=\"\" style=padding-left:20px;padding-right:20px> <md-tooltip md-direction=bottom>Roles</md-tooltip> <i class=\"fa icon mdi-action-account-circle faa-pulse animated-hover i-24\"></i> </a> <ul class=\"dropdown-menu dropdown-menu-scale pull-right text-color\"> <li ng-repeat=\"item in roles[0].items\" ui-sref-active=active id=super_menu_li_{{$index}} class=super_menu_li> <a md-ink-ripple ng-click=roleClick(item)> {{item.role_name | translate}} </a> </li> </ul> </li> </ul> <ul class=\"nav nav-sm navbar-tool pull-right\"> <li class=dropdown> <a md-ink-ripple data-toggle=dropdown class=\"\" style=padding-left:20px;padding-right:20px> <md-tooltip md-direction=bottom>Notificaciones</md-tooltip> <i class=\"icon glyphicon glyphicon-bell i-24\"></i> <b class=\"badge bg-danger up\">{{countNotificationsUserInboxNoRead}}</b> </a> <ul class=\"notifications dropdown-menu dropdown-menu-scale pull-right text-color\"> <div class=scrollable-dropdown> <li ng-repeat=\"var in notificationUserInbox\" ui-sref-active=active id=super_menu_li_{{$index}} class=super_menu_li ng-if=\"countNotificationsUserInboxNoRead > 0\"> <a md-ink-ripple ng-click=notificationUserInboxClick(var)> {{var.dt_creationDate | date:'yyyy-MM-dd'}} - {{var.ds_name}} </a> </li> <li ui-sref-active=active id=no_notification_read class=super_menu_li ng-if=\"countNotificationsUserInboxNoRead === 0\"> <p class=\"p-md text-center\"> No tiene notificaciones pendientes </p> </li> </div> <li class=divider ng-if=\"countNotificationsUserInboxNoRead > 0\"></li> <li ui-sref-active=active id=super_menu_li_all_notification class=super_menu_li ng-if=\"countNotificationsUserInboxNoRead > 0\"> <a md-ink-ripple ng-click=notificationUserInboxAllClick(notificationUserInbox[0].id_user)> <p class=text-center>Ver más</p> </a> </li> </ul> </li> </ul> <div class=\"v-line pull-right\"> <a class=\"\" ui-sref=app.inicio> <div alt=. class=\"narvar-brand navbar-brand-top-menu\"></div> </a> </div> <div class=pull-right ui-view=navbar@></div> </div> <style type=text/css>#header{overflow:inherit!important}.no-radius{border-radius:0!important;height:inherit}.dropdown-menu>li>a{color:inherit;padding:8px 16px;color:#000}.notifications.notifications.dropdown-menu{width:350px}.notifications.dropdown-menu>.scrollable-dropdown>li>a{color:inherit;width:100%;overflow:hidden;height:auto;padding:16px;display:block;border-bottom:1px solid rgba(229,229,229,.86)}.notifications.dropdown-menu>.scrollable-dropdown>li>a:hover{background:rgba(229,229,229,.86)}.notifications.dropdown-menu>.scrollable-dropdown>li:last-child>a{color:inherit;padding:16px;border-bottom:1px solid transparent}.main-title{margin-left:350px;margin-top:24px}.scrollable-dropdown{height:auto;max-height:350px;overflow-x:hidden;overflow-y:auto}</style>";

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"footer text-xs no-radius text-white text-center\"> version </div> ";

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> </div> <div class=container-fluid> <div class=row-fluid> <div class=col-lg-12> <div class=\"centering text-center error-container\"> <div class=text-center> <h2 class=without-margin>Lo Sentimos , no tiene <span class=text-warning><big>Permisos</big></span> para este módulo</h2> <h4 class=text-warning>Acceso Denegado</h4> </div> <div class=text-center> <h3><small>Contactese con el administrador del sistema para poder acceder a esta función.</small></h3> </div> <hr> </div> </div> </div> </div> ";

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row gutter-10\"> <div class=\"intro-message m-b-lg\"> <div class=col-md-12 style=padding-top:20vh> <h1 class=\"text-blanco text-center no-m-t\">{{ 'WELCOME' | translate }} al Sistema de Gestión Integral del Profesor</h1> <h3 class=\"text-blanco text-center m-t proxima font-normal m-b-md\">{{adminName}} - {{roleName}}</h3> <h3 class=\"text-blanco text-center m-t-xs proxima font-normal\">Haga clic en el ícono de menú a su izquierda <i class=\"mdi-navigation-menu i-24\"></i> para dirigirse al módulo que desee. Si quiere cambiar de rol <i class=\"fa icon mdi-action-account-circle faa-pulse animated-hover i-24\"></i>, ver sus notificaciones <i class=\"fa fa-bell i-24\"></i>, o Chat <i class=\"fa icon mdi-communication-forum faa-pulse animated-hover i-24\"></i> puede dirigirse al menú de la derecha</h3> </div> </div> </div>";

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	module.exports = "<style>.g-signin2{display:flex;justify-content:center}</style> <div ui-view=\"\" class=\"fade-in-down smooth ng-scope suite-login\"> <div class=\"row w-full\"> <div class=\"col-sm-4 col-sm-offset-4\"> <div class=\"panel m-t-xlg\"> <div class=\"panel-heading bg-primary\"> <div class=text-center> <img src={{clientLogo}} height=45px> <h1 class=\"text-lg no-margin p-t-sm\">{{ 'WELCOME' | translate }}</h1> </div> </div> <div class=\"panel-body text-center\"> <div ng-show=$ctrl.appConfig.GOOGLE_ACCOUNT_KEY> <div class=\"row gutter-10\"> <div class=\"text-center col-xs-12\"> <div class=\"g-signin2 m-b-md\" data-theme=dark></div> </div> </div> <h4>{{ 'OR' | translate }} </h4></div> <h4>{{ 'LOGIN_PROMPT' | translate }}</h4> <form class=\"form-horizontal m m-b-lg\" ng-submit=$ctrl.onSubmit(loginForm.$valid) name=loginForm novalidate ng-controller=\"loginController as $ctrl\"> <div class=\"md-form-group float-label\" ng-class=\"{'has-error': loginForm.name.$invalid && loginForm.name.$dirty, 'has-success': loginForm.name.$valid }\"> <input type=text ng-disabled=isLoading class=\"p md-input ng-pristine ng-untouched\" name=name ng-model=user.name required/> <label>{{ 'USER' | translate }}</label> <p class=help-block ng-if=\"loginForm.name.$invalid && loginForm.name.$dirty\">{{ 'ENTER_VALID_USERNAME' | translate }}</p> </div> <div class=\"md-form-group float-label\" ng-class=\"{'has-error': loginForm.password.$invalid && loginForm.password.$dirty, 'has-success': loginForm.password.$valid}\"> <input type=password ng-disabled=isLoading class=\"p md-input ng-pristine ng-untouched\" name=password ng-model=user.password ng-minlength=3 required/> <label>{{ 'PASSWORD' | translate }}</label> <p class=help-block ng-if=\"loginForm.password.$invalid && loginForm.password.$dirty\"> {{ 'ENTER_PASSWORD' | translate }}</p> </div> <button md-ink-ripple=\"\" class=\"md-btn md-raised bg-accent p-h-md\" ng-disabled=isLoading> <div style=display:flex;justify-content:space-around> <div class=\"text-center m-r-sm\" ng-if=isLoading> <md-progress-circular style=display:inline-block class=md-hue-2 md-diameter=18px></md-progress-circular> </div> <div>{{ 'ENTER' | translate }}</div> </div> </button> </form> </div> </div> </div> </div> </div> ";

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid> <div class=row-fluid> <div class=col-lg-12> <div class=\"centering text-center error-container m-t-xlg\"> <div class=text-center> <i class=\"fal fa-user-lock text-warning\" style=font-size:5em></i> <h1>{{ ':::Acceso denegado' | translate }}</h1> <h4 class=without-margin> {{ $ctrl.message.username }} <br> {{ $ctrl.message.message }} </h4> </div> <div class=text-center> <h3><small>{{ ':::Contacte con el administrador del sistema' | translate }}.</small></h3> </div> <br> <div class=button-group> <button md-ink-ripple class=\"md-btn bg-accent md-raised\" ng-click=$ctrl.goToLoggin()> <i class=\"fal fal-sign-in i-20\"></i> {{ ':::Probar con otro usuario' | translate }} </button> </div> </div> </div> </div> </div> ";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uFaculty = __webpack_require__(183);
	
	var _uFaculty2 = _interopRequireDefault(_uFaculty);
	
	var _adminPanelFrontDev = __webpack_require__(501);
	
	var _adminPanelFrontDev2 = _interopRequireDefault(_adminPanelFrontDev);
	
	var _strategicTracking = __webpack_require__(528);
	
	var _strategicTracking2 = _interopRequireDefault(_strategicTracking);
	
	var _integralEvaluation = __webpack_require__(541);
	
	var _integralEvaluation2 = _interopRequireDefault(_integralEvaluation);
	
	var _workplan = __webpack_require__(567);
	
	var _workplan2 = _interopRequireDefault(_workplan);
	
	var _integrationFront = __webpack_require__(844);
	
	var _integrationFront2 = _interopRequireDefault(_integrationFront);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import reportes from './app/u-faculty/reportes'
	
	// import demo from './app/demo';
	exports.default = angular.module('app.uplanner', [
	// demo,
	_workplan2.default, _uFaculty2.default, _strategicTracking2.default, _integralEvaluation2.default, _adminPanelFrontDev2.default, _integrationFront2.default]).name;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _workPlanParametrization = __webpack_require__(184);
	
	var _workPlanParametrization2 = _interopRequireDefault(_workPlanParametrization);
	
	var _generalSettings = __webpack_require__(239);
	
	var _generalSettings2 = _interopRequireDefault(_generalSettings);
	
	var _chatbox = __webpack_require__(292);
	
	var _chatbox2 = _interopRequireDefault(_chatbox);
	
	var _portfolio = __webpack_require__(297);
	
	var _portfolio2 = _interopRequireDefault(_portfolio);
	
	var _report = __webpack_require__(344);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _perfil = __webpack_require__(367);
	
	var _perfil2 = _interopRequireDefault(_perfil);
	
	var _validations = __webpack_require__(433);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _setters = __webpack_require__(434);
	
	var _setters2 = _interopRequireDefault(_setters);
	
	var _requests = __webpack_require__(435);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _util = __webpack_require__(437);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _periodPicker = __webpack_require__(439);
	
	var _searchBar = __webpack_require__(441);
	
	var _activitiesReview = __webpack_require__(443);
	
	var _history = __webpack_require__(446);
	
	var _header = __webpack_require__(451);
	
	var _activitiesList = __webpack_require__(454);
	
	var _handAvatar = __webpack_require__(456);
	
	var _medalAvatar = __webpack_require__(457);
	
	var _listData = __webpack_require__(458);
	
	var _activityTag = __webpack_require__(459);
	
	var _projectTypeTag = __webpack_require__(462);
	
	var _projectStateTag = __webpack_require__(463);
	
	var _projectVisibilityTag = __webpack_require__(464);
	
	var _addActivity = __webpack_require__(465);
	
	var _addActivityExtension = __webpack_require__(467);
	
	var _activityDetails = __webpack_require__(469);
	
	var _detailsHeader = __webpack_require__(471);
	
	var _mainInfo = __webpack_require__(473);
	
	var _childrenActivities = __webpack_require__(475);
	
	var _entriesList = __webpack_require__(477);
	
	var _plannedActivities = __webpack_require__(479);
	
	var _studentAttention = __webpack_require__(481);
	
	var _subject = __webpack_require__(483);
	
	var _listPanel = __webpack_require__(485);
	
	var _indicator = __webpack_require__(493);
	
	var _panelRouter = __webpack_require__(494);
	
	var _panelRouterEvaluation = __webpack_require__(495);
	
	var _executionEntries = __webpack_require__(496);
	
	var _registerExecution = __webpack_require__(497);
	
	var _addCustom = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.ufaculty', [_workPlanParametrization2.default, _generalSettings2.default, _portfolio2.default, _validations2.default, _setters2.default, _requests2.default, _chatbox2.default, _util2.default, _perfil2.default, _report2.default]).component('periodPicker', _periodPicker.periodPicker).component('searchBar', _searchBar.searchBar).component('activitiesReview', _activitiesReview.activitiesReview).component('history', _history.history).component('addActivity', _addActivity.addActivity).component('addActivityExtension', _addActivityExtension.addActivityExtension).component('header', _header.header).component('activitiesList', _activitiesList.activitiesList).component('handAvatar', _handAvatar.handAvatar).component('medalAvatar', _medalAvatar.medalAvatar).component('listData', _listData.listData).component('activityTag', _activityTag.activityTag).component('projectTypeTag', _projectTypeTag.projectTypeTag).component('projectStateTag', _projectStateTag.projectStateTag).component('projectVisibilityTag', _projectVisibilityTag.projectVisibilityTag).component('activityDetails', _activityDetails.activityDetails).component('detailsHeader', _detailsHeader.detailsHeader).component('mainInfo', _mainInfo.mainInfo).component('childrenActivities', _childrenActivities.childrenActivities).component('entriesList', _entriesList.entriesList).component('plannedActivities', _plannedActivities.plannedActivities).component('studentAttention', _studentAttention.studentAttention).component('subject', _subject.subject).component('listPanel', _listPanel.listPanel).component('indicator', _indicator.indicator).component('panelRouter', _panelRouter.panelRouter).component('panelRouterEvaluation', _panelRouterEvaluation.panelRouterEvaluation).component('executionEntries', _executionEntries.executionEntries).component('registerExecution', _registerExecution.registerExecution).component('addCustom', _addCustom.addCustom).name;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _workPlanParametrization = __webpack_require__(185);
	
	var _workPlanParametrization2 = _interopRequireDefault(_workPlanParametrization);
	
	var _workPlanParametrization3 = __webpack_require__(199);
	
	var _workPlanParametrization4 = _interopRequireDefault(_workPlanParametrization3);
	
	var _workPlanParametrizationListCtrl = __webpack_require__(200);
	
	var _workPlanParametrizationListCtrl2 = _interopRequireDefault(_workPlanParametrizationListCtrl);
	
	var _workPlanCreateCtrl = __webpack_require__(203);
	
	var _workPlanCreateCtrl2 = _interopRequireDefault(_workPlanCreateCtrl);
	
	var _workPlanViewCtrl = __webpack_require__(205);
	
	var _workPlanViewCtrl2 = _interopRequireDefault(_workPlanViewCtrl);
	
	var _workPlanParametrizationSrv = __webpack_require__(206);
	
	var _workPlanParametrizationSrv2 = _interopRequireDefault(_workPlanParametrizationSrv);
	
	var _workPlanHoursOfDedicatedViewCtrl = __webpack_require__(207);
	
	var _workPlanHoursOfDedicatedViewCtrl2 = _interopRequireDefault(_workPlanHoursOfDedicatedViewCtrl);
	
	var _workPlanAssignmentOfEvaluatorsCtrl = __webpack_require__(209);
	
	var _workPlanAssignmentOfEvaluatorsCtrl2 = _interopRequireDefault(_workPlanAssignmentOfEvaluatorsCtrl);
	
	var _workPlanCreateModalCtrl = __webpack_require__(213);
	
	var _workPlanCreateModalCtrl2 = _interopRequireDefault(_workPlanCreateModalCtrl);
	
	var _setupTeacherActivitiesCtrl = __webpack_require__(214);
	
	var _setupTeacherActivitiesCtrl2 = _interopRequireDefault(_setupTeacherActivitiesCtrl);
	
	var _criteriaListViewCtrl = __webpack_require__(217);
	
	var _criteriaListViewCtrl2 = _interopRequireDefault(_criteriaListViewCtrl);
	
	var _specialSituationsCtrl = __webpack_require__(226);
	
	var _specialSituationsCtrl2 = _interopRequireDefault(_specialSituationsCtrl);
	
	var _activateWorkPlanCtrl = __webpack_require__(231);
	
	var _activateWorkPlanCtrl2 = _interopRequireDefault(_activateWorkPlanCtrl);
	
	var _setupTeacherTypeModulesCtrl = __webpack_require__(235);
	
	var _setupTeacherTypeModulesCtrl2 = _interopRequireDefault(_setupTeacherTypeModulesCtrl);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import datelocale from './workPlanParametrization.datelocale'
	exports.default = angular.module('workPlanParametrization.workPlanParametrization', [_workPlanParametrizationSrv2.default]).config(_workPlanParametrization2.default)
	// .config(datelocale)
	.controller('WorkPlanParametrizationListCtrl', _workPlanParametrizationListCtrl2.default).controller('WorkPlanCreateCtrl', _workPlanCreateCtrl2.default).controller('WorkPlanViewCtrl', _workPlanViewCtrl2.default).controller('WorkPlanHoursOfDedicatedViewCtrl', _workPlanHoursOfDedicatedViewCtrl2.default).controller('WorkPlanAssignmentOfEvaluatorsCtrl', _workPlanAssignmentOfEvaluatorsCtrl2.default).controller('workPlanCreateModalCtrl', _workPlanCreateModalCtrl2.default).controller('SetupTeacherActivitiesCtrl', _setupTeacherActivitiesCtrl2.default).controller('CriteriaListViewCtrl', _criteriaListViewCtrl2.default).controller('SpecialSituationsCtrl', _specialSituationsCtrl2.default).controller('SetupTeacherTypeModulesCtrl', _setupTeacherTypeModulesCtrl2.default).controller('ActivateWorkPlanCtrl', _activateWorkPlanCtrl2.default).run(_workPlanParametrization4.default).constant('workPlanParametrization', [{
	  'title': 'Parametrización',
	  'icon': 'mdi-image-tune',
	  'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.profileAdmin, _globalConfig2.default.userRolesIds.adminPortfolio],
	  'subMenu': [{
	    'title': 'Parametrización del Plan de Trabajo',
	    'url': 'fullscreen.workPlanParametrization',
	    'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.gerencialConsultant]
	  }, {
	    'title': 'Crear plan',
	    'url': '#',
	    'onclick': 'showModalCreateWorkplan',
	    'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin]
	  }, {
	    'title': 'Criterios de evaluación',
	    'url': 'workPlanParametrization.criteriaListView',
	    'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.unitAdmin]
	  }, {
	    'title': 'Asignación de evaluadores',
	    'url': 'workPlanParametrization.workPlanAssignmentOfEvaluators',
	    'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.unitAdmin]
	  }, {
	    'title': 'Situaciones especiales',
	    'url': 'workPlanParametrization.specialSituationsView',
	    'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.unitAdmin]
	  }, {
	    'title': 'Activar plan de trabajo',
	    'url': 'workPlanParametrization.activateWorkPlan',
	    'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.unitAdmin]
	  }, {
	    'title': 'Módulos',
	    'url': 'workPlanParametrization.modules',
	    'rolesAllowed': [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.profileAdmin, _globalConfig2.default.userRolesIds.adminPortfolio]
	  }]
	}]).name; // import uirouter from 'angular-ui-router';

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$mdDateLocaleProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider, $mdDateLocaleProvider) {
	
	  $mdDateLocaleProvider.formatDate = function (date) {
	    var m = moment(date);
	    return m.isValid() ? m.format('DD/MM/YYYY') : '';
	  };
	
	  $mdDateLocaleProvider.parseDate = function (dateString) {
	    var m = moment(dateString, 'DD/MM/YYYY', true);
	    return m.isValid() ? m.toDate() : new Date(NaN);
	  };
	
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workPlanParametrization', {
	    abstract: false,
	    url: '/app/workPlanParametrization',
	    redirectTo: 'fullscreen.workPlanParametrization',
	    views: {
	      '': {
	        template: __webpack_require__(168)
	      },
	      'content': {
	        template: __webpack_require__(169)
	      },
	      'aside': {
	        template: __webpack_require__(170),
	        controller: 'AsideCtrl'
	      },
	      'header': {
	        template: __webpack_require__(171),
	        controller: 'HeaderCtrl'
	      },
	      'chatbox': {
	        template: __webpack_require__(172),
	        controller: 'ChatboxController',
	        controllerAs: 'chatbox'
	      },
	      'comments': {
	        template: __webpack_require__(186),
	        controller: 'CommentsController',
	        controllerAs: 'chatbox'
	      },
	      'footer': {
	        template: __webpack_require__(177)
	      }
	    },
	    data: {
	      displayName: 'Volver a Parametrización del Plan de Trabajo'
	    }
	  }).state('fullscreen.workPlanParametrization', {
	    abstract: false,
	    url: '/workPlanParametrizationList',
	    template: __webpack_require__(187),
	    controller: 'WorkPlanParametrizationListCtrl',
	    controllerAs: 'parametrizationListVM',
	    data: {
	      displayName: 'Parametrización plan de trabajo'
	    }
	  }).state('workPlanParametrization.workPlanCreate', {
	    abstract: false,
	    url: '/workPlanCreate',
	    template: __webpack_require__(188),
	    controller: 'WorkPlanCreateCtrl',
	    controllerAs: 'createVM',
	    data: {
	      displayName: 'Configuración inicial',
	      order: 1,
	      siblings: [{
	        name: 'workPlanParametrization.setupTeacherActivities',
	        hideLink: true,
	        order: 2
	      }, {
	        name: 'workPlanParametrization.workPlanHoursOfDedicated',
	        hideLink: true,
	        order: 3
	      }]
	    }
	  }).state('workPlanParametrization.workPlanAssignmentOfEvaluators', {
	    abstract: false,
	    url: '/workPlanAssignmentOfEvaluators',
	    template: __webpack_require__(189),
	    controller: 'WorkPlanAssignmentOfEvaluatorsCtrl',
	    controllerAs: 'reviewersVM',
	    data: {
	      displayName: 'Asignación de evaluadores',
	      order: 1
	    }
	  }).state('workPlanParametrization.activateWorkPlan', {
	    abstract: false,
	    url: '/activateWorkPlan',
	    template: __webpack_require__(190),
	    controller: 'ActivateWorkPlanCtrl',
	    controllerAs: 'activateWorkPlanVM',
	    data: {
	      displayName: 'Activar plan de trabajo',
	      order: 1
	    }
	  }).state('workPlanParametrization.workPlanHoursOfDedicated', {
	    abstract: false,
	    url: '/workPlanHoursOfDedicated/:id',
	    template: __webpack_require__(191),
	    controller: 'WorkPlanHoursOfDedicatedViewCtrl',
	    controllerAs: 'hoursOfDedicationVM',
	    data: {
	      displayName: 'Horas de dedicación',
	      order: 3,
	      siblings: [{
	        name: 'workPlanParametrization.workPlanViewSetup',
	        order: 1,
	        params: { id: 'id' }
	      }, {
	        name: 'workPlanParametrization.setupTeacherActivities',
	        order: 2,
	        params: { workPlanId: 'id' }
	      }]
	    }
	  }).state('workPlanParametrization.workPlanClone', {
	    abstract: false,
	    url: '/cloneWorkplan/:workPlanId',
	    template: __webpack_require__(188),
	    controller: 'WorkPlanCreateCtrl',
	    controllerAs: 'createVM',
	    data: {
	      displayName: 'Clonar plan de trabajo',
	      order: 1,
	      siblings: [{
	        name: 'workPlanParametrization.setupTeacherActivities',
	        hideLink: true,
	        order: 2
	      }, {
	        name: 'workPlanParametrization.workPlanHoursOfDedicated',
	        hideLink: true,
	        order: 3
	      }]
	    }
	  }).state('workPlanParametrization.workPlanView', {
	    abstract: false,
	    url: '/workPlan/:id/view',
	    template: __webpack_require__(192),
	    controller: 'WorkPlanViewCtrl',
	    controllerAs: 'wpViewVM',
	    data: {
	      displayName: 'Configuración inicial',
	      order: 1,
	      siblings: [{
	        name: 'workPlanParametrization.viewTeacherActivities',
	        hideLink: false,
	        order: 2,
	        params: { workPlanId: 'id' }
	      }, {
	        name: 'workPlanParametrization.viewHoursOfDedicated',
	        hideLink: false,
	        order: 3,
	        params: { id: 'id' }
	      }]
	    }
	  }).state('workPlanParametrization.workPlanViewSetup', {
	    abstract: false,
	    url: '/workPlan/:id/viewSetup',
	    template: __webpack_require__(192),
	    controller: 'WorkPlanViewCtrl',
	    controllerAs: 'wpViewVM',
	    data: {
	      displayName: 'Configuración inicial',
	      order: 1,
	      siblings: [{
	        name: 'workPlanParametrization.setupTeacherActivities',
	        hideLink: false,
	        order: 2,
	        params: { workPlanId: 'id' }
	      }, {
	        name: 'workPlanParametrization.workPlanHoursOfDedicated',
	        hideLink: false,
	        order: 3,
	        params: { id: 'id' }
	      }]
	    }
	  }).state('workPlanParametrization.setupTeacherActivities', {
	    abstract: false,
	    url: '/setupTeacherActivities/:workPlanId',
	    template: __webpack_require__(193),
	    controller: 'SetupTeacherActivitiesCtrl',
	    controllerAs: 'setupVM',
	    data: {
	      displayName: 'Config. actividades',
	      order: 2,
	      siblings: [{
	        name: 'workPlanParametrization.workPlanViewSetup',
	        order: 1,
	        params: { id: 'workPlanId' }
	      }, {
	        name: 'workPlanParametrization.workPlanHoursOfDedicated',
	        order: 3,
	        params: { id: 'workPlanId' }
	      }]
	    }
	  }).state('workPlanParametrization.viewTeacherActivities', {
	    abstract: false,
	    url: '/viewTeacherActivities/:workPlanId',
	    template: __webpack_require__(194),
	    controller: 'SetupTeacherActivitiesCtrl',
	    controllerAs: 'setupVM',
	    data: {
	      displayName: 'Config. actividades',
	      order: 2,
	      siblings: [{
	        name: 'workPlanParametrization.workPlanView',
	        order: 1,
	        params: { id: 'workPlanId' }
	      }, {
	        name: 'workPlanParametrization.viewHoursOfDedicated',
	        order: 3,
	        params: { id: 'workPlanId' }
	      }]
	    }
	  }).state('workPlanParametrization.viewHoursOfDedicated', {
	    abstract: false,
	    url: '/viewHoursOfDedicated/:id',
	    template: __webpack_require__(195),
	    controller: 'WorkPlanHoursOfDedicatedViewCtrl',
	    controllerAs: 'hoursOfDedicationVM',
	    data: {
	      displayName: 'Horas de dedicación',
	      order: 3,
	      siblings: [{
	        name: 'workPlanParametrization.workPlanView',
	        order: 1,
	        params: { id: 'id' }
	      }, {
	        name: 'workPlanParametrization.viewTeacherActivities',
	        order: 2,
	        params: { workPlanId: 'id' }
	      }]
	    }
	  }).state('workPlanParametrization.criteriaListView', {
	    abstract: false,
	    url: '/criteriaLists',
	    template: __webpack_require__(196),
	    controller: 'CriteriaListViewCtrl',
	    controllerAs: 'criteriaListVM',
	    data: {
	      displayName: 'Criterios de revisión/aprobación',
	      order: 1,
	      siblings: [{
	        name: 'workPlanParametrization.evaluationCriteriaList',
	        order: 2
	      }]
	    },
	    params: {
	      categoryId: { value: '1' }
	    }
	  }).state('workPlanParametrization.evaluationCriteriaList', {
	    abstract: false,
	    url: '/evaluationCriteriaLists',
	    template: __webpack_require__(196),
	    controller: 'CriteriaListViewCtrl',
	    controllerAs: 'criteriaListVM',
	    data: {
	      displayName: 'Criterios de evaluación',
	      order: 2,
	      siblings: [{
	        name: 'workPlanParametrization.criteriaListView',
	        order: 1
	      }]
	    },
	    params: {
	      categoryId: { value: '2' }
	    }
	  }).state('workPlanParametrization.specialSituationsView', {
	    abstract: false,
	    url: '/specialSituations',
	    template: __webpack_require__(197),
	    controller: 'SpecialSituationsCtrl',
	    controllerAs: 'specialSituationVM',
	    data: {
	      displayName: 'Situaciones Especiales',
	      order: 1
	    }
	  }).state('workPlanParametrization.modules', {
	    abstract: false,
	    url: '/modules',
	    template: __webpack_require__(198),
	    controller: 'SetupTeacherTypeModulesCtrl',
	    controllerAs: 'setupTeacherTypeModulesVM',
	    data: {
	      displayName: 'Módulos',
	      order: 1
	    }
	  });
	}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = "<div class=container_main> <div class=container_firts id=1> <div class=container_contacts ng-hide=chatbox.closeContact style=display:block id=2> <div class=\"row shadow-body\" ng-show=chatbox.minimizeContact> <div class=c-d-c> <div class=t-c-c> <p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"chatbox.chatUser[0].onLine == 0 ? 'text-gris':'text-success'\" ng-show=chatbox.minimizeContact></p><a ng-show=chatbox.minimizeContact style=font-size:90%><strong>{{chatbox.chatUser[0].userName}}</strong></a> </div> <div class=\"col-md-1 t-c itms\"> <a href=\"\" ng-click=chatbox.minimizeContacs(false) class=\"fa fa-caret-down\"></a> </div> <div class=\"col-md-1 t-c itms pos_div\"> <a ng-click=chatbox.closeContacts(true)>X</a> </div> </div> <div class=\"col-md-12 c-l-c\"> <div class=\"chat friend contact\" ng-repeat=\"contacts in chatbox.chatContacts\" ng-click=chatbox.newChat(contacts)> <div class=user-photo><img src={{contacts.userPicture}}></div> <a class=\"fa fa-fw fa-circle m-r-sm icon-pos\" ng-class=\"contacts.onLine == 0 ? 'text-gris':'text-success'\"></a> <div class=nm> <a>{{contacts.userName}} holaaaaaa</a><br> <a style=font-size:11.5px>{{contacts.status}}</a> </div> </div> </div> </div> <div class=\"col-md-12 f-c\" ng-click=chatbox.minimizeContacs(true)> <p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"chatbox.chatUser[0].onLine == 0 ? 'text-gris':'text-success'\" ng-show=!chatbox.minimizeContact></p><a class=inf-lab ng-show=!chatbox.minimizeContact><strong>{{chatbox.chatUser[0].userName}}</strong></a> </div> </div> <div class=container_chats ng-repeat=\"messageWindow in chatbox.conversations | limitTo : 3\"> <div class=\"row shadow-body\" ng-show=messageWindow.showMessageWindow scroll-glue> <div class=c-d-c-c> <div class=\"col-md-10 t-c\"> <p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"messageWindow.onLine == 0 ? 'text-gris':'text-success'\"></p><a style=font-size:90%><strong>{{messageWindow.userName}}</strong></a> </div> <div class=\"col-md-1 t-c itms\"> <a ng-click=\"messageWindow.showMessageWindow = false\" class=\"fa fa-caret-down\"></a> </div> <div class=\"col-md-1 t-c itms\" style=right:7px> <a ng-click=chatbox.closedChat(messageWindow)>X</a> </div> </div> <div class=\"col-md-12 chatlogs c-t\" scroll-glue> <div ng-repeat=\"(key, value) in messageWindow.information | groupBy: 'dateDay'\"> <div class=time_class><a class=timeStamp>{{ key }}</a></div> <div class=chat ng-class=chatsTimes.classChat ng-repeat=\"chatsTimes in value\"> <div class=user-photo><img src={{chatsTimes.from}}></div> <p class=chat-message>{{chatsTimes.data}}<br><i class=\"fa fa-remove delet_pos\" ng-click=\"chatbox.deleteMessage(chatsTimes.messageId, messageWindow.idUser)\"></i></p> <div ng-hide=\"chatsTimes.send == 0\" class=chat-time><p>{{chatsTimes.dateTime |date: 'dd-MM-yyyy hh:mma'}}</p></div> <div ng-hide=\"!chatsTimes.send == 0\" class=icon-load><p class=\"fa fa-spinner fa-pulse\"></p></div> <div class=\"\" ng-show=messageWindow.delete> <a href=\"\">HOLA</a> </div> </div> </div> </div> <div class=\"col-md-9 chat-form-textarea back-textarea\"> <textarea type=text ng-model=messageWindow.newComment ng-keydown=\"chatbox.sendMessage($event, messageWindow.idUser, messageWindow.newComment)\" placeholder=\"Escribe tu mensaje...\" ng-model-options=\"{ debounce: 300 }\"></textarea> </div> <div class=\"col-md-3 chat-form-button back-button\"> <button ng-click=\"chatbox.sendMessage(chatbox.btnSend,messageWindow.idUser, messageWindow.newComment)\" type=button name=button>Enviar</button> </div> </div> <div class=\"col-md-12 f-c c-d-f\" ng-click=chatbox.showMessage(messageWindow)> <div class=\"pos-label truncate\" ng-show=!messageWindow.showMessageWindow><p class=\"fa fa-fw fa-circle m-r-sm\" ng-class=\"messageWindow.onLine == 0 ? 'text-gris':'text-success'\"></p><a class=inf-lab><strong>{{messageWindow.userName}}</strong></a></div> <div class=\"itms msj_new\"> <i class=\"fa fa-exclamation-circle alert_icon\" ng-if=messageWindow.new></i> </div> <div class=f-m-n> <a ng-click=chatbox.closedChat(messageWindow) ng-show=!messageWindow.showMessageWindow>X</a> </div> </div> </div> <div class=chat_opened ng-if=\"chatbox.conversations.length > 3 ? true:false\"> <div class=\"view-messageBoxes shadow-body\" ng-hide=chatbox.showMessageBoxes> <ul class=list-messageBoxes> <li ng-repeat=\"chatsOpened in chatbox.conversations | limitTo : chatbox.conversations.length - 1 : 3 \"><span ng-click=chatbox.openedChat(chatsOpened)>{{chatsOpened.userName}}</span><a href=\"\" ng-click=chatbox.closedChat(chatsOpened)>X</a></li> </ul> </div> <div class=f-c-h ng-click=\"chatbox.showChatsBoxes(chatbox.showMessageBoxes = !chatbox.showMessageBoxes)\"> <i class=\"fa fa-comment item-count\"></i> </div> </div> </div> </div>";

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = "<style>.ui-grid-viewport{overflow-anchor:none}.grid-workplan{width:100%;min-height:350px!important;max-height:550px!important}.grid-workplan .ui-grid-row{display:flex;min-height:30px!important;height:auto!important;padding-top:5px;padding-bottom:5px;border-bottom:1px solid rgba(255,255,255,.4)}</style> <div class=\"row gutter-10\"> <div class=\"intro-message m-b-lg\"> <div class=col-xs-12> <h1 class=\"text-blanco text-center\"><span>Bienvenido a la</span> parametrización del plan de trabajo</h1> </div> </div> <div class=\"col-xs-offset-1 col-xs-10 m-t-lg\"> <div class=grid-workplan ui-grid=parametrizationListVM.gridOptions ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns></div> <div has-permission=inicio-parametrizacion-edit> <md-button class=\"btn btn-success btn-lg p-h-lg text-md font-bold p-v btn-fullscreen\" ng-click=parametrizationListVM.showModalCreateWorkplan($event)>Crear plan de trabajo</md-button> </div> </div> </div> ";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Configuración inicial - {{createVM.showWorkPlanName()}}</h3> <p class=text-base>{{createVM.subTitle}}</p> </div> </div> <div ng-if=createVM.showPage(0)> <div class=row> <div class=\"col-md-8 m-h-lg no-padding\"> <form name=newWorkPlanForm novalidate> <h5 class=\"text-azul p-v-xs\"><b>Información general</b></h5> <div class=row> <div class=col-md-6> <div class=form-group ng-class=createVM.hasError(newWorkPlanForm.plan_name)> <label class=control-label for=plan_name>Nombre del plan</label> <input type=text ng-model=createVM.workplan.plan_name ng-model-options=\"{ debounce: 300 }\" name=plan_name class=form-control required> <div class=control-label ng-messages=newWorkPlanForm.plan_name.$error ng-show=createVM.showErrorMessages(newWorkPlanForm.plan_name)> <div ng-message=required>El nombre es requerido</div> </div> </div> </div> <div class=col-md-3> <div class=form-group ng-class=createVM.hasError(newWorkPlanForm.start_date)> <label class=\"control-label col-md-12\" for=start_date>Fecha inicio</label> <md-datepicker ng-model=createVM.workplan.start_date name=start_date ng-keydown=createVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa required ng-change=createVM.startDateChange() md-min-date=createVM.minStartDate min=\"{{createVM.minStartDate | date: 'dd/MM/yyyy' }}\"></md-datepicker> <div class=control-label ng-messages=newWorkPlanForm.start_date.$error ng-show=createVM.showErrorMessages(newWorkPlanForm.start_date)> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha de inicio es requerida</div> <div ng-message=mindate>La fecha de inicio debe ser mayor a la fecha actual</div> </div> </div> </div> <div class=col-md-3> <div class=form-group ng-class=createVM.hasError(newWorkPlanForm.end_date)> <label class=\"control-label col-md-12\" for=end_date>Fecha fin</label> <md-datepicker ng-model=createVM.workplan.end_date name=end_date ng-keydown=createVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa required md-min-date=createVM.minDateEndDate min={{createVM.minDateEndDate}} ng-change=createVM.startDateChange()></md-datepicker> <div class=control-label ng-messages=newWorkPlanForm.end_date.$error ng-show=createVM.showErrorMessages(newWorkPlanForm.end_date)> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha fin es requerida</div> <div ng-message=mindate>La fecha fin debe ser mayor a la fecha inicio</div> </div> </div> </div> </div> <h5 class=\"text-azul p-v-xs\"><b>Periodicidad</b></h5> <p>Seleccione el o los períodos que desea incluir dentro del plan</p> <div class=row> <div class=col-md-12> <div class=\"form-group select-inline\" ng-class=createVM.hasError(newWorkPlanForm.periodSelect)> <div class=\"col-md-4 no-padding\"> <label class=control-label for=periodSelect>Período</label> <select ng-model=createVM.workplan.period name=periodSelect ng-options=\"obj.ds_name for obj in createVM.periods track by obj.id_code\" class=form-control ng-change=createVM.periodSelected(createVM.workplan.period) required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=newWorkPlanForm.periodSelect.$error ng-show=createVM.showErrorMessages(newWorkPlanForm.periodSelect)> <div ng-message=required>El período es requerido</div> </div> </div> <div class=\"radio-options col-md-8\"> <div ng-if=\"createVM.subPeriods.length > 1 && !createVM.subPeriods.showOnlyDateInputs\" ng-repeat=\"period in createVM.subPeriods\"> <input type=radio name=subperiod ng-value=period.id_code ng-model=createVM.workplan.subperiod.id_code ng-change=createVM.subPeriodSelected(period) required/> <i class=radio-green></i> <label>{{ period.ds_name }}</label> </div> </div> </div> </div> </div> <div class=\"form-group select-inline\"> <div class=col-md-10> <div class=row ng-if=\"createVM.workplan.subperiod.id_code != null || createVM.subPeriods.showOnlyDateInputs\"> <p>Ingresar fechas de inicio y fin de cada período</p> <pre>{{createVM.datePeriod[period.id_code].minStartDate}}</pre> </div> <div ng-repeat=\"period in createVM.subPeriods\"> <div ng-if=\"period.id_code === createVM.workplan.subperiod.id_code || createVM.subPeriods.showOnlyDateInputs\"> <div class=row> <div class=\"col-md-4 p-t-md\"> <label class=\"control-label exo text-sm font-bold\" for=date>{{ period.ds_name }}</label> </div> <div class=col-md-4> <div class=form-group ng-class=\"createVM.hasError(createVM.getFormAttribute(newWorkPlanForm, 'period_start_date_', period.id_code) )\"> <label class=control-label for=periodSelect>Fecha inicio</label> <md-datepicker type=date name=period_start_date_{{period.id_code}} ng-change=createVM.periodSelected(createVM.workplan.period) ng-model=period.start_date md-placeholder=dd/mm/aaaa md-min-date=createVM.datePeriod[period.id_code].minStartDate min={{createVM.datePeriod[period.id_code].minStartDate}} md-max-date=createVM.datePeriod[period.id_code].maxStartDate max={{createVM.datePeriod[period.id_code].maxStartDate}} ng-change=createVM.validateDates() required> </md-datepicker> <div class=control-label ng-messages=\"createVM.getFormAttribute(newWorkPlanForm, 'period_start_date_', period.id_code).$error\" ng-show=\"createVM.showErrorMessages(createVM.getFormAttribute(newWorkPlanForm, 'period_start_date_', period.id_code) )\"> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha no se encuentra dentro del rango</div> <div ng-message=maxdate>La fecha no se encuentra dentro del rango</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=\"createVM.hasError(createVM.getFormAttribute(newWorkPlanForm, 'period_end_date_', period.id_code))\"> <label class=control-label for=periodSelect>Fecha fin</label> <md-datepicker type=date name=period_end_date_{{period.id_code}} ng-change=createVM.periodSelected(createVM.workplan.period) ng-model=period.end_date md-placeholder=dd/mm/aaaa md-min-date=createVM.datePeriod[period.id_code].minEndDate min={{createVM.datePeriod[period.id_code].minEndDate}} md-max-date=createVM.datePeriod[period.id_code].maxEndDate max={{createVM.datePeriod[period.id_code].maxEndDate}} ng-change=createVM.validateDates() required></md-datepicker> <div class=control-label ng-messages=\"createVM.getFormAttribute(newWorkPlanForm, 'period_end_date_', period.id_code).$error\" ng-show=\"createVM.showErrorMessages(createVM.getFormAttribute(newWorkPlanForm, 'period_end_date_', period.id_code) )\"> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha no se encuentra dentro del rango</div> <div ng-message=maxdate>La fecha no se encuentra dentro del rango</div> </div> </div> </div> </div> </div> </div> </div> </div> </form> <div class=row> </div> <div class=row> <div class=\"col-md-6 m-b-lg\"> <a ui-sref=fullscreen.workPlanParametrization> <md-button class=\"btn btn-fw btn-cancel no-margin\">Cancelar</md-button> </a> </div> <div class=col-md-6> <md-button class=\"btn btn-success btn-default no-margin pull-right\" ng-click=createVM.moveToPage(1) ng-disabled=createVM.validateForm(newWorkPlanForm)>Configuración de etapas</md-button> </div> </div> </div> </div> </div> <div ng-if=createVM.showPage(1)> <div class=row> <div class=\"col-md-12 p-h-lg\"> <h5 class=\"text-azul p-v-xs\"><b>Configuración de etapas</b></h5> <p class=p-b-md>Configure la fecha de inicio y fin de cada etapa. Recuerde que las etapas deben estar dentro del rango del tiempo del plan</p> </div> </div> <div class=row> <div class=\"col-md-8 m-h-lg no-padding\"> <form novalidate class=p-b name=formStage> <div class=row> <div class=\"col-md-4 col-md-offset-4 text-center\"> <label class=p-b>Fecha inicio</label> </div> <div class=\"col-md-4 text-center\"> <label class=p-b>Fecha fin</label> </div> </div> <div class=\"row m-v-xs\" ng-repeat=\"stage in createVM.stages\"> <div class=\"col-md-4 p-t-xs\"> <div class=\"form-group no-margin\"> <label for=\"\" class=\"text-sm font-bold exo\">{{stage.ds_name}}</label> </div> </div> <div class=col-md-4> <div class=form-group ng-class=\"createVM.hasError(createVM.getFormAttribute(formStage, 'stage_start_date_', stage.id_code))\"> <md-datepicker name=stage_start_date_{{stage.id_code}} type=date ng-model=createVM.workplan.stages[stage.id_code].start_date md-min-date=createVM.stageDates[stage.id_code].minStartDate min={{createVM.stageDates[stage.id_code].minStartDate}} md-max-date=createVM.stageDates[stage.id_code].maxStartDate max={{createVM.stageDates[stage.id_code].maxStartDate}} ng-change=createVM.validateStagesDates() md-placeholder=dd/mm/aaaa required> </md-datepicker> <div class=control-label ng-messages=\"createVM.getFormAttribute(formStage, 'stage_start_date_', stage.id_code).$error\" ng-show=\"createVM.showErrorMessages(createVM.getFormAttribute(formStage, 'stage_start_date_', stage.id_code))\"> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha no se encuentra dentro del rango</div> <div ng-message=maxdate>La fecha no se encuentra dentro del rango</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=\"createVM.hasError(createVM.getFormAttribute(formStage, 'stage_end_date_', stage.id_code))\"> <md-datepicker name=stage_end_date_{{stage.id_code}} type=date ng-model=createVM.workplan.stages[stage.id_code].end_date md-min-date=createVM.stageDates[stage.id_code].minEndDate min={{createVM.stageDates[stage.id_code].minEndDate}} md-max-date=createVM.stageDates[stage.id_code].maxEndDate max={{createVM.stageDates[stage.id_code].maxEndDate}} ng-change=createVM.validateStagesDates() md-placeholder=dd/mm/aaaa required> </md-datepicker> <div class=control-label ng-messages=\"getFormAttribute(formStage, 'stage_end_date_', stage.id_code).$error\" ng-show=\"createVM.showErrorMessages(createVM.getFormAttribute(formStage, 'stage_end_date_', stage.id_code))\"> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha no se encuentra dentro del rango</div> <div ng-message=maxdate>La fecha no se encuentra dentro del rango</div> </div> </div> </div> </div> </form> <div class=\"row m-b-md\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel no-margin\" ng-click=createVM.moveToPage(0)>Paso anterior</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success no-margin pull-right\" ng-click=createVM.moveToPage(2) ng-disabled=createVM.validateForm(formStage)>Confirmar</md-button> </div> </div> </div> </div> </div> <div ng-if=createVM.showPage(2)> <div class=row> <div class=\"col-md-7 m-h-lg m-b-lg no-padding\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs\"><b>Datos de plan</b></h5> </div> </div> <div class=row> <div class=col-md-12> <div class=\"row m-v-sm\"> <div class=col-sm-4><b>Fecha Inicio</b></div> <div class=col-sm-8>{{createVM.workplan.start_date | date:'dd/MM/yyyy'}}</div> </div> <div class=\"row m-v-sm\"> <div class=col-sm-4><b>Fecha Fin</b></div> <div class=col-sm-8>{{createVM.workplan.end_date | date:'dd/MM/yyyy'}}</div> </div> <div class=\"row m-v-sm\"> <div class=col-sm-4><b>Periodicidad</b></div> <div class=col-sm-8>{{createVM.workplan.subperiod.ds_name}}</div> </div> <div class=\"row m-v-sm\"> <div class=col-sm-4><h5 class=\"text-azul p-v-xs\"><b>Etapas</b></h5></div> <div class=col-sm-8></div> </div> <div class=\"row m-v-sm\" ng-repeat=\"stage in createVM.stages\"> <div class=col-sm-4><b>{{stage.ds_name}}</b></div> <div class=col-sm-8>{{createVM.workplan.stages[stage.id_code].start_date | date:'dd/MM/yyyy'}} - {{createVM.workplan.stages[stage.id_code].end_date | date:'dd/MM/yyyy'}}</div> </div> </div> </div> <div class=row> <div class=\"col-md-8 m-v-lg\"> <div class=row> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel no-margin\" ng-click=createVM.moveToPage(1)>Paso anterior</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-primary pull-right no-margin\" ng-disabled=createVM.isDisabled ng-click=createVM.saveWorkplan()>Guardar plan</md-button> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Asignaci&oacute;n de evaluadores</h3> <p class=text-xs>Seleccione profesores de la tabla y haga clic en asignar evaluadores para configurar. Tambi&eacute;n puede ver y editar las asignaciones ya configuradas</p> </div> </div> <div class=\"row p-t search\"> <div class=\"col-md-9 no-padding-r p-l-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=reviewersVM.workPlanAssignmentOfEvaluatorFilter ng-model-options=\"{ debounce: 300 }\" ng-change=reviewersVM.filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> <div class=col-md-3> <md-button class=\"btn btn-fw btn-success no-margin\" ng-click=reviewersVM.showModalAssignmentOfEvaluators() ng-show=reviewersVM.isVisible ng-disabled=reviewersVM.validateForm(formCheck)> Asignar evaluador </md-button> </div> </div> <div class=\"row p-t\"> <div class=\"col-md-9 m-l\"> <div ng-if=!reviewersVM.editEvaluator class=\"grid grid-blue\" ui-grid=gridAssignmentOfEvaluators ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination> </div> </div> </div> <button class=\"btn btn-fw btn-cancel md-button md-ink-ripple m-t-md\" type=button ng-click=reviewersVM.returnBack()>Volver</button>";

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Activar plan de trabajo</h3> <p>En esta secci&oacute;n puede revisar todos los profesores que tienen bloqueado su plan de trabajo y reactivar o activarlo nuevamente.</p> </div> </div> <div class=\"row p-t search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=activateWorkPlanVM.activateWorkPlanFilter ng-model-options=\"{ debounce: 300 }\" ng-change=activateWorkPlanVM.filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn p-xs\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row p-t\"> <div class=\"col-md-12 m-l\"> <div class=m-r-lg> <div class=\"grid grid-blue grid-with-button\" ui-grid=activateWorkPlanVM.gridActivateWorkPlan ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination> </div> </div> </div> </div> <button class=\"btn btn-fw btn-cancel md-button md-ink-ripple m-t-md\" type=button ng-click=activateWorkPlanVM.returnBack()>Volver</button> ";

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Horas de dedicaci&oacute;n - {{hoursOfDedicationVM.workplan.plan_name}}</h3> <p>Diligencie los datos en el siguiente formulario para crear un nuevo plan</p> </div> </div> <div class=\"row p-t\"> <div class=col-md-8> <form novalidate name=formHours> <div class=\"row p-h\"> <div class=\"col-md-4 col-md-offset-4 text-center\"> <label class=text-azul>Requisito m&iacute;nimo de horas</label> </div> <div class=\"col-md-4 text-center\"> <label class=text-azul>Requisito m&aacute;ximo de horas</label> </div> </div> <div class=\"row p-h\" ng-repeat=\"hours in hoursOfDedicationVM.workplanHours\"> <div class=col-md-4> <div style=height:34px;display:flex;flex-direction:column;justify-content:center> <div ng-if=hours.parent> {{hours.parent}} </div> <div class=\"exo text-xs font-bold\" style=white-space:nowrap;overflow:hidden;text-overflow:ellipsis> {{hours.ds_name}} </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=\"hoursOfDedicationVM.hasError(hoursOfDedicationVM.getFormAttribute(formHours, 'num_min_hours_', hours.id_teacher_type))\"> <input type=number only-integer ng-if=!hoursOfDedicationVM.isDisabledInput(hours.Pid) ng-model=hours.num_min_hours name=num_min_hours_{{hours.id_teacher_type}} class=form-control ng-pattern=/^\\d+$/ required min=1 /> <input type=number disabled=true ng-if=hoursOfDedicationVM.isDisabledInput(hours.Pid) ng-model=hours.num_min_hours name=num_min_hours_{{hours.id_teacher_type}} class=form-control /> <div class=control-label ng-messages=\"hoursOfDedicationVM.getFormAttribute(formHours, 'num_min_hours_', hours.id_teacher_type).$error\" ng-show=\"hoursOfDedicationVM.showErrorMessages(hoursOfDedicationVM.getFormAttribute(formHours, 'num_min_hours_', hours.id_teacher_type))\"> <div ng-message=required>Las horas mínimas son requeridas</div> <div ng-message=pattern>Las horas deben ser enteras</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=\"hoursOfDedicationVM.hasError(hoursOfDedicationVM.getFormAttribute(formHours, 'num_max_hours_', hours.id_teacher_type))\"> <input type=number ng-model=hours.num_max_hours ng-if=!hoursOfDedicationVM.isDisabledInput(hours.Pid) name=num_max_hours_{{hours.id_teacher_type}} min={{hours.num_min_hours+1}} class=form-control ng-pattern=/^\\d+$/ required/> <input type=number ng-model=hours.num_max_hours ng-if=hoursOfDedicationVM.isDisabledInput(hours.Pid) disabled=true name=num_max_hours_{{hours.id_teacher_type}} class=form-control only-integer/> <div class=control-label ng-messages=\"hoursOfDedicationVM.getFormAttribute(formHours, 'num_max_hours_', hours.id_teacher_type).$error\" ng-show=\"hoursOfDedicationVM.showErrorMessages(hoursOfDedicationVM.getFormAttribute(formHours, 'num_max_hours_', hours.id_teacher_type))\"> <div ng-message=required>Las horas máximas son requeridas</div> <div ng-message=pattern>Las horas deben ser enteras</div> <div ng-message=min>Las horas máximas deben ser mayor que las horas mínimas</div> </div> </div> </div> </div> <div class=\"row titleSecond m-h m-v-sm\"> <div class=\"col-md-12 p-t\"> <div class=\"form-group col-md-7 no-padding\"> <label for=\"\" class=col-md-8>{{hoursOfDedicationVM.hoursControlLabel}}</label> <label class=\"md-switch col-md-2\"> <input type=checkbox ng-model=hoursOfDedicationVM.workplan.is_control_hours_active ng-true-value=1 ng-false-value=0 ng-change=hoursOfDedicationVM.hoursControlChange()> <i class=radio-green></i> </label> </div> </div> </div> </form> <div class=\"row m-v-sm p-h-sm\"> <div class=col-md-6> <a ui-sref=\"workPlanParametrization.setupTeacherActivities({workPlanId: hoursOfDedicationVM.workplan.id_code})\"> <md-button class=\"btn btn-fw btn-cancel text-xs\">Cancelar</md-button> </a> </div> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-primary text-xs\" ng-click=hoursOfDedicationVM.saveWorkplanHoursOfDedicated() ng-disabled=\"(hoursOfDedicationVM.validateForm(formHours)) || (hoursOfDedicationVM.countWorkplanHours === 0 ? true : false)\">Guardar datos</md-button> </div> </div> </div> </div> ";

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=no-margin>Plan de trabajo - {{wpViewVM.workplan.plan_name}}</h3> </div> </div> <div ng-if=wpViewVM.showPage(0)> <div class=row> <div class=\"col-md-8 m-h-lg no-padding\"> <form name=newWorkPlanForm novalidate> <h5 class=\"text-azul p-v-xs\"><b>Información general</b></h5> <div class=row> <div class=col-md-6> <div class=form-group> <label class=control-label for=plan_name>Nombre del plan</label> <input type=text ng-model=wpViewVM.workplan.plan_name ng-model-options=\"{ debounce: 300 }\" name=plan_name class=form-control required ng-disabled=wpViewVM.workplan.plan_name> </div> </div> <div class=col-md-3> <div class=form-group> <label class=\"control-label col-md-12\" for=start_date>Fecha de inicio</label> <md-datepicker ng-model=wpViewVM.workplan.start_date name=start_date ng-keydown=wpViewVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa required ng-change=wpViewVM.startDateChange() ng-disabled=wpViewVM.workplan.start_date></md-datepicker> </div> </div> <div class=col-md-3> <div class=form-group> <label class=\"control-label col-md-12\" for=end_date>Fecha fin</label> <md-datepicker ng-model=wpViewVM.workplan.end_date name=end_date ng-keydown=wpViewVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa required md-min-date=wpViewVM.minDateEndDate ng-disabled=wpViewVM.workplan.end_date></md-datepicker> </div> </div> </div> <h5 class=\"text-azul p-v-xs\"><b>Periodicidad</b></h5> <div class=row> <div class=col-md-12> <div class=\"form-group select-inline\"> <div class=\"col-md-4 no-padding\"> <label class=control-label for=periodSelect>Período</label> <select ng-model=wpViewVM.workplan.period name=periodSelect ng-options=\"obj.ds_name for obj in wpViewVM.periods track by obj.id_code\" class=form-control ng-change=wpViewVM.periodSelected(workplan.period) required ng-disabled=wpViewVM.workplan.period> <option value=\"\">Seleccione</option> </select> </div> <div class=\"radio-options col-md-8\"> <div ng-if=\"wpViewVM.subPeriods.length > 1 && !wpViewVM.subPeriods.showOnlyDateInputs\" ng-repeat=\"period in wpViewVM.subPeriods\"> <input type=radio name=subperiod ng-value=period.id_code ng-model=wpViewVM.workplan.subperiod.id_code ng-change=wpViewVM.subPeriodSelected(period.ds_name) required ng-disabled=period.id_code /> <i class=radio-green></i> <label>{{ period.ds_name }}</label> </div> </div> </div> </div> </div> <div class=row ng-if=wpViewVM.workplan.subperiod.id_code> <div class=\"col-md-4 col-md-offset-4\"> <h5 class=\"text-azul p-v-xs text-center\"><b>Fecha inicio</b></h5> </div> <div class=col-md-4> <h5 class=\"text-azul p-v-xs text-center\"><b>Fecha fin</b></h5> </div> </div> <div class=\"form-group select-inline\"> <div class=col-md-12> <div ng-repeat=\"period in wpViewVM.workplan.subperiod.dates\"> <div ng-if=\"wpViewVM.workplan.subperiod.ds_name == 'Anual'\"> <div class=row> <div class=\"col-md-4 p-t-sm\"> <label class=control-label for=periodLabel>{{ period.ds_period }}</label> </div> <div class=col-md-4> <md-datepicker type=date ng-keydown=wpViewVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-model=period.start_date md-placeholder=dd/mm/aaaa required ng-disabled=period.start_date> </md-datepicker> </div> <div class=col-md-4> <md-datepicker type=date ng-keydown=wpViewVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-model=period.end_date md-placeholder=dd/mm/aaaa required ng-disabled=period.end_date></md-datepicker> </div> </div> </div> </div> </div> </div> </form> <div class=row> <div class=\"col-md-6 m-b-lg\"> <a ui-sref=fullscreen.workPlanParametrization> <md-button class=\"btn btn-fw btn-cancel no-margin\">Volver a inicio</md-button> </a> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success no-margin pull-right\" ng-click=wpViewVM.moveToPage(1)>Ver etapas</md-button> </div> </div> </div> </div> </div> <div ng-if=wpViewVM.showPage(1)> <div class=row> <div class=\"col-md-12 p-h-lg\"> <h5 class=\"text-azul p-v-xs\"><b>Configuración de etapas</b></h5> </div> </div> <div class=row> <div class=\"col-md-8 m-h-lg no-padding\"> <form novalidate class=p-b name=formStage> <div class=row> <div class=\"col-md-4 col-md-offset-4 text-center\"> <label class=\"text-azul p-b\">Fecha inicio</label> </div> <div class=\"col-md-4 text-center\"> <label class=\"text-azul p-b\">Fecha fin</label> </div> </div> <div class=row ng-repeat=\"stage in wpViewVM.stages\"> <div class=col-md-4> <div class=form-group> <label for=\"\"><b>{{stage.ds_name}}</b></label> </div> </div> <div class=col-md-4> <md-datepicker type=date ng-model=wpViewVM.workplan.stages[stage.id_code].start_date name=\"\" onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" required ng-disabled=wpViewVM.workplan.stages[stage.id_code].start_date md-placeholder=dd/mm/aaaa> </md-datepicker> </div> <div class=col-md-4> <md-datepicker type=date ng-model=wpViewVM.workplan.stages[stage.id_code].end_date name=\"\" required onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-disabled=wpViewVM.workplan.stages[stage.id_code].end_date md-placeholder=dd/mm/aaaa> </md-datepicker> </div> </div> </form> <div class=\"row m-b-md\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel no-margin\" ng-click=wpViewVM.moveToPage(0)>Volver</md-button> </div> <div class=col-md-6> <md-button ng-if=\"wpViewVM.workplan.id_work_plan_state == 3\" class=\"btn btn-fw btn-success no-margin pull-right\" ui-sref=\"workPlanParametrization.setupTeacherActivities({workPlanId: wpViewVM.workplan.id_code})\">Editar actividades</md-button> <md-button ng-if=\"wpViewVM.workplan.id_work_plan_state != 3\" class=\"btn btn-fw btn-success no-margin pull-right\" ui-sref=\"workPlanParametrization.viewTeacherActivities({workPlanId: wpViewVM.workplan.id_code})\">Ver actividades</md-button> </div> </div> </div> </div> </div>";

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Configuración de actividades - {{setupVM.workplan.plan_name}}</h3> <p>Active o inactive si el profesor realiza el plan de trabajo para luego seleccionar las actividades que debe realizar de acuerdo a su tipología o categoría</p> </div> </div> <div class=\"row p-h-lg\"> <div class=col-md-10> <div class=\"row p-h-lg\"> <div class=\"col-md-8 col-md-offset-4 no-padding\"> <div ng-repeat=\"submodule in setupVM.submodules\"> <div class=col-md-2> <p class=\"text-azul text-xxs text-center\">{{submodule.ds_name}}</p> </div> </div> </div> </div> </div> </div> <div class=\"row p-h-lg\"> <div class=\"col-md-10 no-padding\"> <div class=\"row p-h-lg categories exo font-bold\"> <div ng-repeat=\"category in setupVM.teacherCategories\"> <div class=\"row p-v-xs\" ng-style=\"$index % 2 == 0 && {'background-color':'#f2f5f7'}  || {'background-color':'white'}\"> <div class=col-md-4> <p class=\"text-xs no-margin\">{{category.ds_name}} <a ng-click=setupVM.toggleSubcategories(category) ng-if=category.visibleChilds> <i ng-if=!category.showChilds class=\"icon mdi-content-add i-20 pull-right\"></i> <i ng-if=category.showChilds class=\"icon mdi-content-remove i-20 pull-right\"></i> </a> </p> </div> <div class=col-md-8> <div ng-repeat=\"submodule in setupVM.submodules\"> <div class=\"col-md-2 text-center\"> <md-checkbox ng-model=setupVM.teachertype[category.id_code][submodule.id_code] ng-true-value={{category.id_code}} class=\"md-green no-margin\" aria-label=module ng-change=setupVM.checkDoWorkplan(submodule.id_code,category.id_code)></md-checkbox> </div> </div> </div> </div> <div class=\"row p-v-xs\" ng-repeat=\"subcategory in category.childs\" ng-if=\"category.showChilds && subcategory.is_visible\" ng-style=\"$parent.$index % 2 == 0 && {'background-color':'white'} || {'background-color':'#f2f5f7'}\"> <div class=col-md-4> <p class=\"text-xs p-h-md no-margin\">{{subcategory.ds_name}}</p> </div> <div class=col-md-8> <div ng-repeat=\"submodule in setupVM.submodules\"> <div class=\"col-md-2 text-center\"> <md-checkbox ng-model=setupVM.teachertype[subcategory.id_code][submodule.id_code] ng-true-value={{subcategory.id_code}} class=\"md-green no-margin\" aria-label=module ng-change=setupVM.checkDoWorkplan(submodule.id_code,subcategory.id_code)></md-checkbox> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row p-h-lg m-v-md\"> <div class=\"col-md-10 no-padding\"> <div class=row> <div class=col-md-6> <a ui-sref=fullscreen.workPlanParametrization> <md-button class=\"btn btn-fw btn-cancel pull-left text-xs no-margin\"> Cancelar </md-button> </a> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-primary pull-right text-xs no-margin\" ng-click=setupVM.saveTeacherActivities() ng-disabled=setupVM.isButtonDisabled> Guardar datos </md-button> </div> </div> </div> </div> ";

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Configuración de actividades - {{setupVM.workplan.plan_name}}</h3> <p>Actividades realizadas de acuerdo a tipología o categoría</p> </div> </div> <div class=\"row p-h-lg\"> <div class=col-md-10> <div class=\"row p-h-lg\"> <div class=\"col-md-8 col-md-offset-4 no-padding\"> <div ng-repeat=\"submodule in setupVM.submodules\"> <div class=col-md-2> <p class=\"text-azul text-xxs text-center\">{{submodule.ds_name}}</p> </div> </div> </div> </div> </div> </div> <div class=\"row p-h-lg\"> <div class=\"col-md-10 no-padding\"> <div class=\"row p-h-lg categories exo text-xs font-bold\"> <div ng-repeat=\"category in setupVM.teacherCategories\"> <div class=\"row p-v-xs\" ng-style=\"$index % 2 == 0 && {'background-color':'#f2f5f7'}  || {'background-color':'white'}\"> <div class=col-md-4> <p class=\"text-xs no-margin\">{{category.ds_name}} <a ng-click=setupVM.toggleSubcategories(category) ng-if=category.visibleChilds> <i ng-if=!category.showChilds class=\"icon mdi-content-add i-20 pull-right\"></i> <i ng-if=category.showChilds class=\"icon mdi-content-remove i-20 pull-right\"></i> </a> </p> </div> <div class=col-md-8> <div ng-repeat=\"submodule in setupVM.submodules\"> <div class=\"col-md-2 text-center\"> <md-checkbox ng-model=setupVM.teachertype[category.id_code][submodule.id_code] ng-true-value={{category.id_code}} class=\"md-green no-margin\" aria-label=module ng-disabled=true></md-checkbox> </div> </div> </div> </div> <div class=\"row p-v-xs\" ng-repeat=\"subcategory in category.childs\" ng-if=\"category.showChilds && subcategory.is_visible\" ng-style=\"$parent.$index % 2 == 0 && {'background-color':'white'} || {'background-color':'#f2f5f7'}\"> <div class=col-md-4> <p class=\"text-xs p-h-md no-margin\">{{subcategory.ds_name}}</p> </div> <div class=col-md-8> <div ng-repeat=\"submodule in setupVM.submodules\"> <div class=\"col-md-2 text-center\"> <md-checkbox ng-model=setupVM.teachertype[subcategory.id_code][submodule.id_code] ng-true-value={{subcategory.id_code}} class=\"md-green no-margin\" aria-label=module ng-disabled=true></md-checkbox> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row p-h-lg m-v-md\"> <div class=\"col-md-10 no-padding\"> <div class=row> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel pull-left text-xs no-margin\" ui-sref=\"workPlanParametrization.workPlanView({id: setupVM.workplan.id_code})\"> Volver </md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success pull-right text-xs no-margin\" ui-sref=\"workPlanParametrization.viewHoursOfDedicated({id: setupVM.workplan.id_code})\"> Ver Horas de dedicación </md-button> </div> </div> </div> </div> ";

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Horas de dedicaci&oacute;n - {{hoursOfDedicationVM.workplan.plan_name}}</h3> <p>Horas de dedicaci&oacute;n m&iacute;nimas y m&aacute;ximas seg&uacute;n tipolog&iacute;a del profesor</p> </div> </div> <div class=\"row p-t\"> <div class=col-md-8> <form novalidate name=formHours> <div class=\"row p-h\"> <div class=\"col-md-4 col-md-offset-4 text-center\"> <label class=text-azul>Requisito m&iacute;nimo de horas</label> </div> <div class=\"col-md-4 text-center\"> <label class=text-azul>Requisito m&aacute;ximo de horas</label> </div> </div> <div class=\"row p-h m-b-sm\" ng-repeat=\"hours in hoursOfDedicationVM.workplanHours\"> <div class=col-md-4> <div style=height:34px;display:flex;flex-direction:column;justify-content:center> <div ng-if=hours.parent> {{hours.parent}} </div> <div class=\"exo text-xs font-bold\" style=white-space:nowrap;overflow:hidden;text-overflow:ellipsis> {{hours.ds_name}} </div> </div> </div> <div class=col-md-4> <input type=number ng-model=hours.num_min_hours name=plan_name class=form-control ng-disabled=true /> </div> <div class=col-md-4> <input type=number ng-model=hours.num_max_hours name=plan_name class=form-control ng-disabled=true /> </div> </div> <div class=\"row titleSecond m-h m-v-sm\"> <div class=\"col-md-12 p-t\"> <div class=form-group> <label for=\"\">{{ hoursOfDedicationVM.hoursControlLabel }}</label> <label class=md-switch> <input type=checkbox ng-model=hoursOfDedicationVM.workplan.is_control_hours_active ng-disabled=true ng-true-value=1 ng-false-value=0> <i class=radio-green></i> </label> </div> </div> </div> </form> <div class=\"row m-v-sm p-h-sm\"> <div class=\"col-md-12 text-center\"> <md-button class=\"btn btn-fw btn-cancel\" ui-sref=\"workPlanParametrization.viewTeacherActivities({workPlanId: hoursOfDedicationVM.workplan.id_code})\">Volver</md-button> </div> </div> </div> </div> ";

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title p-v-sm\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>{{ criteriaListVM.mainLabel }}</h3> <p class=text-xs>Navegue por las pestañas para revisar los criterios disponibles en cada categoría, crear un nuevo criterio o asociar criterios a planes.</p> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-primary text-xs p-h-md\" ng-click=criteriaListVM.createCriteria() has-permission=criterios-revision/aprobacion-edit>Crear criterios</md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=criteriaListVM.criteriaFilter class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar propuestas...\" ng-change=criteriaListVM.updateSearchView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <slick class=\"slider single-item\" current-index=index ng-if=\"criteriaListVM.criteriaList.length && criteriaListVM.viewLoaded\" responsive=criteriaListVM.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"list in criteriaListVM.criteriaList | filter: criteriaListVM.criteriaFilter | orderBy: 'list_name'\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5\" ng-class=criteriaListVM.gradCriteriaClass> <div> <span ng-if=\"list.is_editable == false\" class=\"badge verde m-b-sm\">Por Defecto</span> <p class=\"m-t text-md exo\">{{list.list_name}}</p> <a class=text-sm ng-click=criteriaListVM.associatedPlans(list)> <u>{{list.workplans.length}} Planes asociados</u> </a> </div> <div class=\"row m-t-md\" ng-if=\"list.is_editable == true && !criteriaListVM.checkIsInicializated(list, true)\"> <div class=col-md-6> <a href ng-click=criteriaListVM.createCriteria(list.id_list) class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href ng-click=\"criteriaListVM.confirmDeleteCriteriaList(list, list.id_list, list.list_name, list.id_type_list)\" class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-8\"> <p class=\"text-md text-gris-dark exo\">Listado de Criterios</p> <ul class=\"list-items no-padding max-height\"> <li class=\"text-sm m-b-sm\" ng-repeat=\"item in list.items | orderBy: 'nm_order'\"> {{item.nm_order + \".- \" + item.lists_item_name}} </li> </ul> <md-button has-permission=criterios-revision/aprobacion-edit class=\"btn btn-fw btn-success text-xs p-h-md no-margin\" ng-click=criteriaListVM.associateCriteria(list)>Asociar plan</md-button> </div> </div> </div> </slick> <button class=\"btn btn-fw btn-cancel md-button md-ink-ripple m-t-md\" type=button ng-click=criteriaListVM.returnBack()>Volver</button> </div> </div> ";

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Situaciones especiales</h3> <p class=text-xs>En esta sección puede visualizar un listado de profesores a los que puede agregar una situación especial para su plan de trabajo</p> </div> </div> <div class=\"row p-t search\"> <div class=\"col-md-9 p-h-lg no-padding-r\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-init=specialSituationVM.teachersFilter ng-model=specialSituationVM.teachersFilter ng-model-options=\"{ debounce: 300 }\" ng-change=specialSituationVM.filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn p-xs\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> <div class=col-md-3> <a href=# ng-click=specialSituationVM.toggleChevron()> <h5 class=\"text-azul col-md-9\">Indicadores</h5> <span ng-class=specialSituationVM.class class=\"icon i-28 col-md-3 text-gris-dark\"></span> </a> </div> </div> <div class=\"row p-t\"> <div class=\"col-md-9 p-l-lg no-padding-r\"> <div class=\"grid grid-blue grid-with-button\" ui-grid=specialSituationVM.gridSpecialSituations ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-selection ui-grid-pagination></div> </div> <div class=\"col-md-3 p-l-lg\"> <div ng-if=specialSituationVM.dropdownMenu> <h1 class=\"text-gris-dark no-margin\">{{specialSituationVM.teachers.length}}</h1> <h5>Total profesores</h5> <h1 class=\"text-gris-dark no-margin\">{{specialSituationVM.specialSituations}}</h1> <h5>Total situaciones especiales</h5> <h1 class=\"text-gris-dark no-margin\">{{specialSituationVM.situationsPercentage + '%'}}</h1> <h5>Porcentaje equivalente</h5> </div> </div> </div> <button class=\"btn btn-fw btn-cancel md-button md-ink-ripple m-t-md\" type=button ng-click=specialSituationVM.returnBack()>Volver</button> ";

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Configuración de Módulos</h3> <p>Módulos de acuerdo a tipología o categoría</p> </div> </div> <div class=\"row p-h-lg\"> <div class=col-md-10> <div class=\"row p-h-lg\"> <div class=\"col-md-8 col-md-offset-4 no-padding\"> <div ng-repeat=\"submodule in setupTeacherTypeModulesVM.submodules\"> <div class=col-md-2 has-permission={{submodule.hasPermission}}> <p class=\"text-azul text-xxs text-center\">{{submodule.ds_name}}</p> </div> </div> </div> </div> </div> </div> <div class=\"row p-h-lg\"> <div class=\"col-md-10 no-padding\"> <div class=\"row p-h-lg categories exo font-bold\"> <div ng-repeat=\"category in setupTeacherTypeModulesVM.teacherCategories\"> <div class=\"row p-v-xs\" ng-style=\"$index % 2 == 0 && {'background-color':'#f2f5f7'}  || {'background-color':'white'}\"> <div class=col-md-4> <p class=\"text-xs no-margin\">{{category.ds_name}} <a ng-click=setupTeacherTypeModulesVM.toggleSubcategories(category) ng-if=\"category.childs.length > 0 && category.is_visible == 1\"> <i ng-if=!category.showChilds class=\"icon mdi-content-add i-20 pull-right\"></i> <i ng-if=category.showChilds class=\"icon mdi-content-remove i-20 pull-right\"></i> </a> </p> </div> <div class=col-md-8 ng-if=!setupTeacherTypeModulesVM.blockCheckboxes> <div ng-repeat=\"submodule in setupTeacherTypeModulesVM.submodules\"> <div class=\"col-md-2 text-center\" has-permission={{submodule.hasPermission}}> <md-checkbox ng-model=setupTeacherTypeModulesVM.teachertype[category.id_code][submodule.id_code] ng-true-value={{category.id_code}} class=\"md-green no-margin\" aria-label=module ng-change=setupTeacherTypeModulesVM.checkDoWorkplan(submodule.id_code,category.id_code) ng-disabled=setupTeacherTypeModulesVM.blockCheckboxes></md-checkbox> </div> </div> </div> </div> <div class=\"row p-v-xs\" ng-repeat=\"subcategory in category.childs\" ng-if=category.showChilds ng-style=\"$parent.$index % 2 == 0 && {'background-color':'white'} || {'background-color':'#f2f5f7'}\"> <div class=col-md-4> <p class=\"text-xs p-h-md no-margin\">{{subcategory.ds_name}}</p> </div> <div class=col-md-8 ng-if=!setupTeacherTypeModulesVM.blockCheckboxes> <div ng-repeat=\"submodule in setupTeacherTypeModulesVM.submodules\"> <div class=\"col-md-2 text-center\" has-permission={{submodule.hasPermission}}> <md-checkbox ng-model=setupTeacherTypeModulesVM.teachertype[subcategory.id_code][submodule.id_code] ng-true-value={{subcategory.id_code}} class=\"md-green no-margin\" aria-label=module ng-change=setupTeacherTypeModulesVM.checkDoWorkplan(submodule.id_code,subcategory.id_code) ng-disabled=setupTeacherTypeModulesVM.blockCheckboxes></md-checkbox> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row p-h-lg m-v-md\"> <div class=\"col-md-10 no-padding\"> <div class=row> <div class=col-md-6> <a ui-sref=fullscreen.workPlanParametrization> <md-button class=\"btn btn-fw btn-cancel pull-left text-xs no-margin\"> Volver </md-button> </a> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-primary pull-right text-xs no-margin\" ng-click=setupTeacherTypeModulesVM.saveTeacherActivities() ng-disabled=setupTeacherTypeModulesVM.isButtonDisabled ng-if=!setupTeacherTypeModulesVM.blockCheckboxes> Guardar </md-button> </div> </div> </div> </div> ";

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	                value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workPlanParametrization'];
	
	//funcion donde se definen la run
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workPlanParametrization) {
	                MenuConstant[0]['menu'].push(workPlanParametrization);
	}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanParametrizationListCtrl = function WorkPlanParametrizationListCtrl($scope, $resource, WorkPlanParametrizationSrv, uiGridConstants, $rootScope, $interval, $mdDialog) {
	  _classCallCheck(this, WorkPlanParametrizationListCtrl);
	
	  // Constants
	  var parametrizationListVM = this;
	  // Methods
	  parametrizationListVM.showModalCreateWorkplan = showModalCreateWorkplan;
	
	  $rootScope.fullscreenClass = 'background-planning';
	  // Grid definition
	  parametrizationListVM.gridOptions = {
	    columnDefs: [{
	      name: 'Nombre del plan de trabajo',
	      displayName: 'Nombre del plan de trabajo',
	      field: 'ds_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Período',
	      displayName: 'Período',
	      field: 'periodicity_name',
	      width: '15%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Fecha inicio',
	      displayName: 'Fecha inicio',
	      field: 'dt_startdate',
	      width: '12%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: true,
	      sort: { direction: uiGridConstants.DESC },
	      cellFilter: "date: 'dd/MM/yyyy': 'UTC'"
	    }, {
	      name: 'Fecha fin',
	      displayName: 'Fecha fin',
	      field: 'dt_enddate',
	      width: '12%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellFilter: "date: 'dd/MM/yyyy': 'UTC'"
	    }, {
	      name: 'Estado',
	      displayName: 'Estado',
	      field: 'state_name',
	      width: '20%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      field: 'id_state',
	      width: '15%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: __webpack_require__(201)
	    }],
	    sortInfo: { fields: ['dt_startdate'], directions: ['desc'] },
	    onRegisterApi: function onRegisterApi(gridApi) {
	      parametrizationListVM.gridApi = gridApi;
	      $interval(function () {
	        parametrizationListVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	    // Method definitions
	  };function activate() {
	    return getListItems();
	  }
	
	  function getListItems() {
	    WorkPlanParametrizationSrv.getWorkPlans.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        parametrizationListVM.gridOptions.data = dataReturn.data;
	      } else {
	        console.log(dataReturn);
	      }
	    }).catch(function (err) {
	      console.log('Error: ', err);
	    });
	  }
	
	  function showModalCreateWorkplan() {
	    $mdDialog.show({
	      template: __webpack_require__(202),
	      controller: 'workPlanCreateModalCtrl',
	      clickOutsideToClose: true,
	      fullscreen: parametrizationListVM.customFullscreen
	    });
	  }
	  // Initialization
	  activate();
	};
	
	exports.default = WorkPlanParametrizationListCtrl;
	
	
	WorkPlanParametrizationListCtrl.$inject = ['$scope', '$resource', 'WorkPlanParametrizationSrv', 'uiGridConstants', '$rootScope', '$interval', '$mdDialog'];

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.id_work_plan_state == 3\"> <a ui-sref=\"workPlanParametrization.setupTeacherActivities({workPlanId: row.entity.id_code})\"> <i class=\"icon mdi-action-settings i-20\" style=padding-right:5px;opacity:1></i> </a> <a ui-sref=\"workPlanParametrization.setupTeacherActivities({workPlanId: row.entity.id_code})\" style=opacity:.85;text-decoration:underline>Parametrizar </a> </div> <div ng-if=\"row.entity.id_work_plan_state != 3\"> <a ui-sref=\"workPlanParametrization.workPlanView({id: row.entity.id_code})\"> <i class=\"icon mdi-action-search i-20\" style=padding-right:5px;opacity:1></i> </a> <a style=opacity:.85;text-decoration:underline ui-sref=\"workPlanParametrization.workPlanView({id: row.entity.id_code})\">Ver más</a> </div> </div>";

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row col-md-12 text-center\"> <h3 class=text-verde>Crear plan</h3> <p>Para crear un nuevo plan tiene dos opciones disponibles<br> copiar una parametrización de otro plan a su elección o bien crear una nueva parametrización</p> </div> <div class=\"row col-md-12\"> <div class=\"col-md-6 clone\"> <a ng-show=!clonePlan href=# ng-click=selectWorkPlan()> <i class=\"icon mdi-editor-insert-drive-file\"></i> <span class=exo>Clonar parametrización</span> </a> <div ng-show=clonePlan class=\"col-md-12 no-padding\"> <label class=\"col-md-12 text-left no-padding\">Seleccione plan a clonar</label> <select ng-model=selectedWorkPlan ng-options=\"workplan.ds_name for workplan in workPlanList\" class=\"col-md-12 form-control m-b-sm\"> <option value=\"\" class=col-md-12>Seleccione</option> </select> <md-button class=\"btn btn-fw btn-primary\" ng-click=close() ui-sref=\"workPlanParametrization.workPlanClone({workPlanId: selectedWorkPlan.id_code})\" ng-disabled=!selectedWorkPlan.id_code> Clonar plan </md-button> </div> </div> <div class=\"col-md-6 create\"> <a ui-sref=workPlanParametrization.workPlanCreate ng-click=close() class=exo> <i class=\"icon mdi-action-note-add\"></i> <span>Crear plan</span> </a> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanCreateCtrl = function () {
		function WorkPlanCreateCtrl($scope, $resource, WorkPlanParametrizationSrv, $stateParams, $mdDialog) {
			_classCallCheck(this, WorkPlanCreateCtrl);
	
			var createVM = this;
	
			// VARIABLES
			createVM.subTitle = 'Diligencie los datos en el siguiente formulario.';
			createVM.workplan = {};
			createVM.currentPage = 0;
			createVM.subPeriods = null;
			createVM.minStartDate = moment().toDate();
			createVM.minDateEndDate = new Date();
			createVM.workplan.start_date = null;
			createVM.workplan.end_date = null;
			createVM.isDisabled = false;
			createVM.stages = [];
			createVM.periods = [];
			var cloning = false;
	
			// METHODS
			createVM.hasError = hasError;
			createVM.showErrorMessages = showErrorMessages;
			createVM.validateDates = validateDates;
			createVM.validateStagesDates = validateStagesDates;
			createVM.getPreviousStage = getPreviousStage;
			createVM.startDateChange = startDateChange;
			createVM.getFormAttribute = getFormAttribute;
			createVM.initStages = initStages;
			createVM.moveToPage = moveToPage;
			createVM.periodSelected = periodSelected;
			createVM.validateForm = validateForm;
			createVM.subPeriodSelected = subPeriodSelected;
			createVM.showWorkPlanName = showWorkPlanName;
			createVM.showPage = showPage;
			createVM.saveWorkplan = saveWorkplan;
			createVM.showModalWorkPlanCreated = showModalWorkPlanCreated;
			createVM.formatDates = formatDates;
	
			// SERVICES DEFINITION
			function activate() {
				return getStage().then(getPeriodicity().then(cloneWP()));
			}
	
			function getStage() {
				return WorkPlanParametrizationSrv.getStage.get().$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						createVM.stages = dataReturn.data;
						createVM.initStages();
					}
				});
			}
	
			function getPeriodicity() {
				return WorkPlanParametrizationSrv.getPeriodicity.get().$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						createVM.periods = dataReturn.data;
					}
				});
			}
	
			// for cloning a workplan
			function cloneWP() {
				var header = { id: $stateParams.workPlanId };
	
				if ($stateParams != null && $stateParams.workPlanId != null) {
					cloning = true;
	
					return WorkPlanParametrizationSrv.getWorkPlan.get(header).$promise.then(function (dataReturn) {
						if (dataReturn.status === true) {
							createVM.workplan = dataReturn.data;
							createVM.workplan.start_date = moment(dataReturn.data.start_date).toDate();
							createVM.workplan.end_date = moment(dataReturn.data.end_date).toDate();
							createVM.workplan.plan_name = '';
							createVM.subPeriods = createVM.workplan.period.options;
							periodSelectedCloning(createVM.workplan.period);
							for (var period in createVM.workplan.subperiod.dates) {
								createVM.workplan.subperiod.dates[period].start_date = moment(createVM.workplan.subperiod.dates[period].start_date).toDate();
								createVM.workplan.subperiod.dates[period].end_date = moment(createVM.workplan.subperiod.dates[period].end_date).toDate();
								createVM.subPeriods[period].start_date = moment(createVM.workplan.subperiod.dates[period].start_date).toDate();
								createVM.subPeriods[period].end_date = moment(createVM.workplan.subperiod.dates[period].end_date).toDate();
							}
							for (var stage in createVM.workplan.stages) {
								createVM.workplan.stages[stage].start_date = moment(createVM.workplan.stages[stage].start_date).toDate();
								createVM.workplan.stages[stage].end_date = moment(createVM.workplan.stages[stage].end_date).toDate();
							}
						}
					});
				}
			}
	
			// METHODS DEFINITION
			function hasError(input) {
				if (input.$invalid && (input.$dirty || input.$touched)) {
					return 'has-error';
				}
			}
	
			function showErrorMessages(input) {
				return input.$dirty || input.$touched;
			}
	
			function validateDates() {
				if (createVM.subPeriods) {
					if (createVM.subPeriods.showOnlyDateInputs) {
						createVM.datePeriod = {};
						var subPeriod = void 0;
	
						for (subPeriod in createVM.subPeriods) {
							if (createVM.subPeriods[subPeriod].id_code) {
								var periodId = createVM.subPeriods[subPeriod].id_code;
								var minStartDate = void 0,
								    maxStartDate = void 0,
								    minEndDate = void 0,
								    maxEndDate = void 0;
								var m = moment(createVM.workplan.end_date);
	
								maxStartDate = m.isValid() ? m.subtract(1, 'days').toDate() : null;
								m = moment(createVM.workplan.end_date);
								maxEndDate = m.isValid() ? m.toDate() : null;
								m = moment(createVM.workplan.subperiod.dates[periodId].start_date);
								minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null;
	
								if (createVM.datePeriod[periodId - 1]) {
									m = moment(createVM.workplan.subperiod.dates[periodId - 1].end_date);
									minStartDate = m.isValid() ? m.toDate() : null;
								} else {
									m = moment(createVM.workplan.start_date);
									minStartDate = m.isValid() ? m.toDate() : null;
								}
	
								createVM.datePeriod[periodId] = {
									minStartDate: minStartDate,
									maxStartDate: maxStartDate,
									minEndDate: minEndDate,
									maxEndDate: maxEndDate
								};
							}
						}
					} else {
						var subPeriodId = createVM.workplan.subperiod.id_code;
	
						createVM.datePeriod = {};
						var _m = moment(createVM.workplan.start_date);
						var _minStartDate = _m.isValid() ? _m.toDate() : null;
	
						_m = moment(createVM.workplan.end_date);
						var _maxStartDate = _m.isValid() ? _m.subtract(1, 'days').toDate() : null;
	
						_m = moment(createVM.workplan.subperiod.dates[subPeriodId].start_date);
						var _minEndDate = _m.isValid() ? _m.add(1, 'days').toDate() : null;
	
						_m = moment(createVM.workplan.end_date);
						var _maxEndDate = _m.isValid() ? _m.toDate() : null;
	
						createVM.datePeriod[subPeriodId] = {
							minStartDate: _minStartDate,
							maxStartDate: _maxStartDate,
							minEndDate: _minEndDate,
							maxEndDate: _maxEndDate
						};
					}
				}
			}
	
			function validateStagesDates() {
				createVM.stageDates = {};
				for (var i = createVM.stages.length - 1; i >= 0; i--) {
					var stageCode = createVM.stages[i].id_code;
					var stageName = createVM.stages[i].ds_name;
					var m = void 0,
					    minStartDate = void 0,
					    maxStartDate = void 0,
					    minEndDate = void 0,
					    maxEndDate = void 0;
	
					m = moment(createVM.workplan.end_date);
					maxStartDate = m.isValid() ? m.subtract(1, 'days').toDate() : null;
					m = moment(createVM.workplan.stages[stageCode].start_date);
					minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null;
					m = moment(createVM.workplan.end_date);
					maxEndDate = m.isValid() ? m.toDate() : null;
					switch (stageName) {
	
						case 'Planeación':
							m = moment(createVM.workplan.start_date);
							minStartDate = m.isValid() ? m.toDate() : null;
							break;
						case 'Revisión de planeación':
							m = moment(createVM.workplan.stages[createVM.stageCodes['Planeación'].id_code].start_date);
							minStartDate = m.isValid() ? m.toDate() : null;
							break;
						case 'Aprobación':
							m = moment(createVM.workplan.stages[createVM.stageCodes['Planeación'].id_code].start_date);
							minStartDate = m.isValid() ? m.toDate() : null;
							break;
						case 'Ejecución':
							m = moment.max(moment(createVM.workplan.stages[createVM.stageCodes['Planeación'].id_code].end_date), moment(createVM.workplan.stages[createVM.stageCodes['Revisión de planeación'].id_code].end_date), moment(createVM.workplan.stages[createVM.stageCodes['Aprobación'].id_code].end_date));
							minStartDate = m.isValid() ? m.add(1, 'days').toDate() : null;
							break;
						case 'Revisión de la ejecución':
							m = moment.max(moment(createVM.workplan.stages[createVM.stageCodes['Planeación'].id_code].end_date), moment(createVM.workplan.stages[createVM.stageCodes['Revisión de planeación'].id_code].end_date), moment(createVM.workplan.stages[createVM.stageCodes['Aprobación'].id_code].end_date));
							minStartDate = m.isValid() ? m.add(1, 'days').toDate() : null;
							break;
						case 'Seguimiento':
							m = moment(createVM.workplan.start_date);
							minStartDate = m.isValid() ? m.toDate() : null;
							break;
						case 'Evaluación':
							m = moment(createVM.workplan.stages[createVM.stageCodes['Ejecución'].id_code].end_date);
							minStartDate = m.isValid() ? m.add(1, 'days').toDate() : null;
							break;
						default:
							var previousStage = createVM.getPreviousStage(createVM.stages[i]);
	
							if (previousStage) {
								m = moment(createVM.workplan.stages[previousStage.id_code].end_date);
							} else {
								m = moment(createVM.workplan.start_date);
							}
	
							minStartDate = m.isValid() ? m.toDate() : null;
							break;
	
					}
					createVM.stageDates[stageCode] = {
						minStartDate: minStartDate,
						maxStartDate: maxStartDate,
						minEndDate: minEndDate,
						maxEndDate: maxEndDate
					};
				}
			}
	
			function getPreviousStage(currentStage) {
				var element = createVM.stages.filter(function (stage) {
					return stage.nm_order === currentStage.nm_order - 1;
				});
	
				return element.length === 1 ? element[0] : null;
			}
	
			function startDateChange() {
				var m = moment(createVM.workplan.start_date);
	
				createVM.minDateEndDate = m.isValid() ? m.add(1, 'days').toDate() : null;
				createVM.validateDates();
				createVM.validateStagesDates();
			}
	
			function getFormAttribute(form, attr, index) {
				attr = attr + index;
	
				return form[attr];
			}
	
			function initStages() {
				createVM.workplan.stages = {};
				createVM.stageCodes = {};
				createVM.stages.sort(function (a, b) {
					return a.nm_order - b.nm_order;
				});
				for (var i = createVM.stages.length - 1; i >= 0; i--) {
					var stageId = createVM.stages[i].id_code;
					var stageName = createVM.stages[i].ds_name;
	
					createVM.stageCodes[stageName] = createVM.stages[i];
					createVM.workplan.stages[stageId] = {
						start_date: null,
						end_date: null
					};
				}
			}
	
			function moveToPage(pageNumber) {
				if (pageNumber && pageNumber >= 0) {
					createVM.currentPage = pageNumber;
				} else {
					createVM.currentPage = 0;
				}
			}
	
			function periodSelected(period) {
				createVM.subPeriods = period.options;
	
				if (!createVM.workplan.subperiod) {
					createVM.workplan.subperiod = {};
				}
	
				if (period.ds_name === 'Anual') {
					createVM.subPeriods.showOnlyDateInputs = true;
					createVM.workplan.subperiod.id_code = period.id_code;
					createVM.workplan.subperiod.ds_name = period.ds_name;
					createVM.workplan.subperiod.dates = {};
					var subPeriod = void 0;
	
					for (subPeriod in createVM.subPeriods) {
						if (createVM.subPeriods[subPeriod].id_code) {
							var periodId = createVM.subPeriods[subPeriod].id_code;
	
							createVM.workplan.subperiod.dates[periodId] = {
								start_date: moment(createVM.subPeriods[subPeriod].start_date).format('YYYY-MM-DD'),
								end_date: moment(createVM.subPeriods[subPeriod].end_date).format('YYYY-MM-DD')
							};
						}
					}
					createVM.validateDates();
				} else {
					createVM.subPeriods.showOnlyDateInputs = false;
					var _subPeriod = void 0;
	
					for (_subPeriod in createVM.subPeriods) {
						if (createVM.subPeriods[_subPeriod] && createVM.subPeriods[_subPeriod].id_code == createVM.workplan.subperiod.id_code) {
							var _periodId = createVM.subPeriods[_subPeriod].id_code;
	
							createVM.workplan.subperiod.dates[_periodId] = {
								start_date: moment(createVM.subPeriods[_subPeriod].start_date).format('YYYY-MM-DD'),
								end_date: moment(createVM.subPeriods[_subPeriod].end_date).format('YYYY-MM-DD')
							};
						}
					}
	
					if (createVM.workplan.subperiod.id_code) {
						createVM.validateDates();
					}
				}
			}
	
			function periodSelectedCloning(period) {
				if (period.ds_name === 'Anual') {
					createVM.subPeriods.showOnlyDateInputs = true;
					createVM.workplan.subperiod.id_code = period.id_code;
					createVM.workplan.subperiod.ds_name = period.ds_name;
				} else {
					createVM.subPeriods.showOnlyDateInputs = false;
				}
			}
	
			function validateForm(form) {
				return form.$invalid;
			}
	
			function subPeriodSelected(subPeriod) {
				createVM.workplan.subperiod.ds_name = subPeriod.ds_name;
				createVM.workplan.subperiod.dates = {};
				createVM.workplan.subperiod.dates[subPeriod.id_code] = {
					start_date: null,
					end_date: null
				};
				createVM.validateDates();
			}
	
			function showWorkPlanName() {
				var planName = 'Nuevo Plan';
	
				if (createVM.workplan && createVM.workplan.plan_name && createVM.workplan.plan_name !== '') {
					planName = createVM.workplan.plan_name;
				}
	
				return planName;
			}
	
			function showPage(page) {
				if (createVM.currentPage === 1) {
					createVM.subTitle = 'Verifique las fechas correspondientes a las etapas del plan de trabajo.';
				}
	
				return page === createVM.currentPage;
			}
	
			function saveWorkplan() {
				createVM.isDisabled = true;
				var workplan = createVM.formatDates();
	
				if (cloning) {
					workplan.workPlanIdCloned = $stateParams.workPlanId;
					WorkPlanParametrizationSrv.cloneWorkPlan.add(workplan).$promise.then(function (dataReturn) {
						if (dataReturn.status === true) {
							createVM.workplan.id_code = dataReturn.data[0].insertId;
							createVM.showModalWorkPlanCreated();
						} else {
							createVM.isDisabled = false;
						}
					});
				} else {
					WorkPlanParametrizationSrv.addWorkplan.add(workplan).$promise.then(function (dataReturn) {
						if (dataReturn.status === true) {
							createVM.workplan.id_code = dataReturn.data[0].insertId;
							createVM.showModalWorkPlanCreated();
						} else {
							createVM.isDisabled = false;
						}
					});
				}
			}
	
			function showModalWorkPlanCreated() {
				var planName = createVM.workplan.plan_name;
				var workPlanId = createVM.workplan.id_code;
	
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
						$scope.planName = planName;
						$scope.workPlanId = workPlanId;
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(204),
					clickOutsideToClose: false
				});
			}
	
			function formatDates() {
				var workplan = angular.copy(createVM.workplan);
	
				workplan.start_date = moment(workplan.start_date).format('YYYY-MM-DD');
				workplan.end_date = moment(workplan.end_date).format('YYYY-MM-DD');
				var subperiodDate = void 0;
	
				for (subperiodDate in workplan.subperiod.dates) {
					workplan.subperiod.dates[subperiodDate].start_date = moment(workplan.subperiod.dates[subperiodDate].start_date).format('YYYY-MM-DD');
					workplan.subperiod.dates[subperiodDate].end_date = moment(workplan.subperiod.dates[subperiodDate].end_date).format('YYYY-MM-DD');
				}
				var stage = void 0;
	
				for (stage in workplan.stages) {
					workplan.stages[stage].start_date = moment(workplan.stages[stage].start_date).format('YYYY-MM-DD');
					workplan.stages[stage].end_date = moment(workplan.stages[stage].end_date).format('YYYY-MM-DD');
				}
	
				return workplan;
			}
	
			// INITIALIZATION
			activate();
		} //FIN DEL CONSTRUCTOR
	
	
		_createClass(WorkPlanCreateCtrl, [{
			key: 'preventInput',
			value: function preventInput(event) {
				var vKey = 86;
	
				if (event.keyCode == vKey) event.preventDefault();
	
				return;
			}
		}]);
	
		return WorkPlanCreateCtrl;
	}();
	
	exports.default = WorkPlanCreateCtrl;
	
	
	WorkPlanCreateCtrl.$inject = ['$scope', '$resource', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog'];

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creaci&oacute;n exitosa!</h3> <p>Su plan \"{{planName}}\" se ha creado con éxito</p> <p>¿Desea parametrizar este plan de inmediato?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close() ui-sref=fullscreen.workPlanParametrization>No, gracias</md-button> <md-button class=\"btn btn-fw btn-success\" ui-sref=\"workPlanParametrization.setupTeacherActivities({workPlanId: workPlanId})\" ng-click=close()>Sí, ir a parametrización</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanViewCtrl = function () {
	  function WorkPlanViewCtrl($scope, $stateParams, WorkPlanParametrizationSrv) {
	    _classCallCheck(this, WorkPlanViewCtrl);
	
	    this.WorkPlanParametrizationSrv = WorkPlanParametrizationSrv;
	    this.$stateParams = $stateParams;
	    this.workplan = {};
	    this.stages = [];
	    this.periods = [];
	    this.currentPage = 0;
	    this.subPeriods = {};
	    this.subPeriods.showOnlyDateInputs = false;
	    this.minDateEndDate = new Date();
	
	    this.activate();
	  } //FIN DEL CONSTRUCTOR
	
	  _createClass(WorkPlanViewCtrl, [{
	    key: 'activate',
	    value: function activate() {
	      return this.getWorkPlan().then(this.getStage().then(this.getPeriodicity()));
	    }
	  }, {
	    key: 'getWorkPlan',
	    value: function getWorkPlan() {
	      var _this = this;
	
	      var header = { id: this.$stateParams.id };
	      return this.WorkPlanParametrizationSrv.getWorkPlan.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status === true) {
	          _this.workplan = dataReturn.data;
	          _this.workplan.id_code = _this.$stateParams.id;
	          _this.workplan.start_date = moment(_this.workplan.start_date, 'YYYY-MM-DD').toDate();
	          _this.workplan.end_date = moment(_this.workplan.end_date, 'YYYY-MM-DD').toDate();
	
	          _this.periodSelected(_this.workplan.period);
	          for (var period in _this.workplan.subperiod.dates) {
	            _this.workplan.subperiod.dates[period].start_date = moment(_this.workplan.subperiod.dates[period].start_date, 'YYYY-MM-DD').toDate();
	            _this.workplan.subperiod.dates[period].end_date = moment(_this.workplan.subperiod.dates[period].end_date, 'YYYY-MM-DD').toDate();
	          }
	          for (var stage in _this.workplan.stages) {
	            _this.workplan.stages[stage].start_date = moment(_this.workplan.stages[stage].start_date, 'YYYY-MM-DD').toDate();
	            _this.workplan.stages[stage].end_date = moment(_this.workplan.stages[stage].end_date, 'YYYY-MM-DD').toDate();
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getStage',
	    value: function getStage() {
	      var _this2 = this;
	
	      return this.WorkPlanParametrizationSrv.getStage.get().$promise.then(function (dataReturn) {
	        if (dataReturn.status === true) {
	          _this2.stages = dataReturn.data;
	        }
	      });
	    }
	  }, {
	    key: 'getPeriodicity',
	    value: function getPeriodicity() {
	      var _this3 = this;
	
	      this.WorkPlanParametrizationSrv.getPeriodicity.get().$promise.then(function (dataReturn) {
	        if (dataReturn.status === true) {
	          _this3.periods = dataReturn.data;
	        }
	      });
	    }
	  }, {
	    key: 'moveToPage',
	    value: function moveToPage(pageNumber) {
	      if (pageNumber && pageNumber >= 0) {
	        this.currentPage = pageNumber;
	      } else {
	        this.currentPage = 0;
	      }
	    }
	  }, {
	    key: 'periodSelected',
	    value: function periodSelected(period) {
	      if (period.ds_name === 'Anual' && period !== undefined) {
	        this.subPeriods.showOnlyDateInputs = true;
	      } else {
	        this.subPeriods.showOnlyDateInputs = false;
	      }
	    }
	  }, {
	    key: 'showPage',
	    value: function showPage(page) {
	      return page === this.currentPage;
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return WorkPlanViewCtrl;
	}();
	
	exports.default = WorkPlanViewCtrl;
	
	
	WorkPlanViewCtrl.$inject = ['$scope', '$stateParams', 'WorkPlanParametrizationSrv'];

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanParametrizationSrv = function WorkPlanParametrizationSrv($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, WorkPlanParametrizationSrv);
	
	  // PARAMETRIZATION LIST SERVICE
	  var getWorkPlans = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/:id', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getPeriodicity = $resource(SERVICE_URL_CONSTANT.rosario + '/periodicity', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getStage = $resource(SERVICE_URL_CONSTANT.rosario + '/stage', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var hoursOfDedicated = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeacherWorkplan/:workplanId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var addWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/saveAllDataWorkPlan', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var addWorkplanHoursOfDedicated = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addHoursTeacherWorkplan', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var addTeacherEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/addTeacherEvaluator', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var getWorkPlanHeader = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/header/:workplanId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getAssignmentOfEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getListTeacherEvaluator', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getTeacherEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getTeacherEvaluator/:idTeacher', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getUsers', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getRoles = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getRole', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var disableTeacherEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/disableTeacherEvaluator', {}, {
	    set: {
	      method: 'POST'
	    }
	  });
	
	  var getTeacherSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/submodules', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getTeacherCategories = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/categories', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var addTeacherSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addRelationTeacherSubmodule', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  // WORKPLAN ACTIVITIES SERVICES
	  var getRelationTeacherSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getRelationTeacherSubmodule/:workplanId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  // SPECIAL SITUATION SERVICES
	  var getSpecialSituationData = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getSpecialSituationData', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getTeachersDetails = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeachersDetails/:idTeacher/:idWorkplan', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var addSpecialSituationTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addSpecialSituationTeacher', {}, {
	    set: {
	      method: 'POST'
	    }
	  });
	
	  // CRITERIA LIST SERVICES
	  var criteriaListService = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getCriteriaWorkplanCategory', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var criteriaItemService = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getsItems/:categoryId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var createCriterias = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/addCriteria', {}, {
	    create: {
	      method: 'POST'
	    }
	  });
	
	  var associatePlanToCriterias = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/associateCriteria', {}, {
	    associate: {
	      method: 'POST'
	    }
	  });
	
	  var deleteCriteriaListItem = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/deleteCriteria', {}, {
	    delete: {
	      method: 'POST'
	    }
	  });
	
	  var workplanListAssociation = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getWorkplanCriteriaAll', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var disassociateCriteria = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/disassociateCriteria', {}, {
	    disassociate: {
	      method: 'POST'
	    }
	  });
	
	  var workplanByCategory = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/getWorkplanByCategory/:categoryId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  // WORKPLAN ACTIVATION SERVICES
	
	  var getTeacherStateList = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeacherStateList', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getTeacherSubmoduleList = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getListWpSubmoduleTeacherActivate/:idTeacher', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  // OTHER SERVICES
	  var updateCriteria = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/updateCriteria', {}, {
	    update: {
	      method: 'POST'
	    }
	  });
	
	  var cloneWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/cloneWorkPlan', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var activateWpSubmoduleTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/setActivateWpSubmoduleTeacher', {}, {
	    set: {
	      method: 'POST'
	    }
	  });
	
	  var getTeacherSubmodulesWithDoWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getSubmodulesWithWorkplan', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getAllActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getAllActivities/:workplanId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getTeachertypeModules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeachertypeModules', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var addRelationTeachertypeModules = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addRelationTeachertypeModules', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  // SERVICES DEFINITIONS
	  return {
	    getWorkPlans: getWorkPlans,
	    getWorkPlan: getWorkPlan,
	    hoursOfDedicated: hoursOfDedicated,
	    getPeriodicity: getPeriodicity,
	    getStage: getStage,
	    addWorkplan: addWorkplan,
	    addWorkplanHoursOfDedicated: addWorkplanHoursOfDedicated,
	    getWorkPlanHeader: getWorkPlanHeader,
	    getTeacherSubmodules: getTeacherSubmodules,
	    getTeacherCategories: getTeacherCategories,
	    addTeacherSubmodules: addTeacherSubmodules,
	    getRelationTeacherSubmodules: getRelationTeacherSubmodules,
	    criteriaListService: criteriaListService,
	    criteriaItemService: criteriaItemService,
	    deleteCriteriaListItem: deleteCriteriaListItem,
	    associatePlanToCriterias: associatePlanToCriterias,
	    createCriterias: createCriterias,
	    workplanByCategory: workplanByCategory,
	    workplanListAssociation: workplanListAssociation,
	    getAssignmentOfEvaluator: getAssignmentOfEvaluator,
	    disassociateCriteria: disassociateCriteria,
	    updateCriteria: updateCriteria,
	    getTeacherSubmodulesWithDoWorkplan: getTeacherSubmodulesWithDoWorkplan,
	    getAllActivities: getAllActivities,
	    // WORKPLAN ACTIVATION SERVICES
	    getTeacherStateList: getTeacherStateList,
	    getUsers: getUsers,
	    cloneWorkPlan: cloneWorkPlan,
	    getRoles: getRoles,
	    getTeacherEvaluator: getTeacherEvaluator,
	    getTeacherSubmoduleList: getTeacherSubmoduleList,
	    // SPECIAL SITUATION SERVICES
	    getSpecialSituationData: getSpecialSituationData,
	    getTeachersDetails: getTeachersDetails,
	    addSpecialSituationTeacher: addSpecialSituationTeacher,
	    addTeacherEvaluator: addTeacherEvaluator,
	    activateWpSubmoduleTeacher: activateWpSubmoduleTeacher,
	    disableTeacherEvaluator: disableTeacherEvaluator,
	    getTeachertypeModules: getTeachertypeModules,
	    addRelationTeachertypeModules: addRelationTeachertypeModules
	  };
	};
	
	WorkPlanParametrizationSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	exports.default = angular.module('services.WorkPlanParametrizationSrv', []).service('WorkPlanParametrizationSrv', WorkPlanParametrizationSrv).name;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanHoursOfDedicatedViewCtrl = function WorkPlanHoursOfDedicatedViewCtrl($scope, WorkPlanParametrizationSrv, $stateParams, $mdDialog, GlobalConfig) {
	  _classCallCheck(this, WorkPlanHoursOfDedicatedViewCtrl);
	
	  var hoursOfDedicationVM = this;
	  hoursOfDedicationVM.workplanHours = [];
	  hoursOfDedicationVM.workplan = {};
	  hoursOfDedicationVM.saveWorkplanHoursOfDedicated = saveWorkplanHoursOfDedicated;
	  hoursOfDedicationVM.validateForm = validateForm;
	  hoursOfDedicationVM.hasError = hasError;
	  hoursOfDedicationVM.showErrorMessages = showErrorMessages;
	  hoursOfDedicationVM.getFormAttribute = getFormAttribute;
	  hoursOfDedicationVM.hoursControlChange = hoursControlChange;
	  hoursOfDedicationVM.isDisabledInput = isDisabledInput;
	  hoursOfDedicationVM.countWorkplanHours = 0;
	
	  // SERVICES
	  function activate() {
	    return hoursOfDedicated().then(getWorkPlanHeader());
	  }
	
	  function hoursOfDedicated() {
	    return WorkPlanParametrizationSrv.hoursOfDedicated.get({ workplanId: $stateParams.id }).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        hoursOfDedicationVM.workplanHours = dataReturn.values;
	        hoursOfDedicationVM.countWorkplanHours = hoursOfDedicationVM.workplanHours.length;
	      }
	    });
	  }
	
	  function getWorkPlanHeader() {
	    return WorkPlanParametrizationSrv.getWorkPlanHeader.get({ workplanId: $stateParams.id }).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        hoursOfDedicationVM.workplan = dataReturn.data;
	        hoursOfDedicationVM.workplan.id_code = $stateParams.id;
	        hoursOfDedicationVM.hoursControlChange();
	      }
	    });
	  }
	
	  // METHOD DEFINITIONS
	  function saveWorkplanHoursOfDedicated() {
	    var post = {
	      id_work_plan: $stateParams.id,
	      is_control_hours_active: hoursOfDedicationVM.workplan.is_control_hours_active,
	      values: hoursOfDedicationVM.workplanHours
	    };
	
	    WorkPlanParametrizationSrv.addWorkplanHoursOfDedicated.add(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        // todo manage to show popup
	        showModalHoursSetedUp();
	      }
	    });
	  }
	
	  function showModalHoursSetedUp() {
	    var planName = hoursOfDedicationVM.workplan.plan_name;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.planName = planName;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(208),
	      clickOutsideToClose: false
	    });
	  };
	
	  function validateForm(form) {
	    return form.$invalid;
	  }
	
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function getFormAttribute(form, attr, index) {
	    attr = attr + index;
	    return form[attr];
	  }
	
	  function hoursControlChange() {
	    hoursOfDedicationVM.hoursControlLabel = 'Control de horas ';
	    hoursOfDedicationVM.hoursControlLabel += hoursOfDedicationVM.workplan.is_control_hours_active === 1 ? 'activado' : 'desactivado';
	  }
	
	  function isDisabledInput(pid) {
	    if (pid == GlobalConfig.notAloweedHours.idDocenteCatedra) {
	      return true;
	    }
	    return false;
	  }
	
	  // INITIALIZE
	  activate();
	};
	
	exports.default = WorkPlanHoursOfDedicatedViewCtrl;
	
	
	WorkPlanHoursOfDedicatedViewCtrl.$inject = ['$scope', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', 'GlobalConfig'];

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creación exitosa!</h3> <p>Las horas de dedicación de su plan \"{{planName}}\" se han configurado con éxito</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close() ui-sref=fullscreen.workPlanParametrization>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanAssignmentOfEvaluatorsCtrl = function () {
	  function WorkPlanAssignmentOfEvaluatorsCtrl($scope, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, $state, GlobalConfig, $cookies, Validations) {
	    var _this = this;
	
	    _classCallCheck(this, WorkPlanAssignmentOfEvaluatorsCtrl);
	
	    this.WorkPlanParametrizationSrv = WorkPlanParametrizationSrv;
	    this.Validations = Validations;
	    this.$scope = $scope;
	    this.$mdDialog = $mdDialog;
	    this.GlobalConfig = GlobalConfig;
	    this.$interval = $interval;
	    this.gridApi = {};
	    this.listTeacher = {};
	    this.listRoles = [];
	    this.listSubModules = [];
	    this.listEvaluators = [];
	    this.isVisible = false;
	    this.workPlanAssignmentOfEvaluatorFilter = '';
	    i18nService.setCurrentLang('es');
	
	    this.user = JSON.parse($cookies.get('currentUser'));
	    this.currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
	    var singleFilter = function singleFilter(renderableRows) {
	      var matcher = new RegExp(_this.workPlanAssignmentOfEvaluatorFilter, 'i');
	      renderableRows.forEach(function (row) {
	        var match = false;
	        ['teacher_name', 'academic_unit_name', 'id_identification', 'teacher_type'].forEach(function (field) {
	          if (row && row.entity[field] && row.entity[field].match(matcher)) {
	            match = true;
	          }
	        });
	        if (!match) {
	          row.visible = false;
	        }
	      });
	      return renderableRows;
	    };
	
	    this.$scope.gridAssignmentOfEvaluators = {
	      enableRowSelection: true,
	      enableRowHeaderSelection: false,
	      multiSelect: false,
	      modifierKeysToMultiSelect: false,
	      noUnselect: true,
	      enableFiltering: true,
	      columnDefs: [_defineProperty({
	        name: 'Nombre de profesor',
	        displayName: 'Nombre de profesor',
	        field: 'teacher_name',
	        width: '25%',
	        headerCellClass: this.highlightFilteredHeader,
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs'
	      }, 'headerCellClass', 'font-normal text-xs'), {
	        name: 'Unidad académica',
	        displayName: 'Unidad académica',
	        field: 'academic_unit_name',
	        width: '22%',
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs',
	        headerCellClass: 'font-normal text-xs'
	      }, {
	        name: 'Cédula',
	        displayName: 'Cédula',
	        field: 'id_identification',
	        width: '15%',
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs',
	        headerCellClass: 'font-normal text-xs'
	      }, {
	        name: 'Tipo profesor',
	        displayName: 'Tipo profesor',
	        field: 'teacher_type',
	        width: '25%',
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs',
	        headerCellClass: 'font-normal text-xs'
	      }, {
	        name: 'Acciones',
	        displayName: 'Acciones',
	        field: 'evaluator',
	        width: '15%',
	        enableGridMenu: false,
	        enableFiltering: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'column-center text-xs text-azul',
	        headerCellClass: 'column-center font-normal text-xs',
	        cellTemplate: __webpack_require__(210)
	      }],
	      onRegisterApi: function onRegisterApi(gridApi) {
	        _this.gridApi = gridApi;
	        _this.gridApi.grid.registerRowsProcessor(singleFilter, 200);
	        $interval(function () {
	          _this.gridApi.core.handleWindowResize();
	        }, 500, 10);
	      }
	
	      // INITIALIZATION
	    };this.activate();
	  } //***************************Fin del construcctor***************************
	
	  _createClass(WorkPlanAssignmentOfEvaluatorsCtrl, [{
	    key: 'activate',
	    value: function activate() {
	      this.getAssignmentOfEvaluator();
	      this.getUsers();
	    }
	  }, {
	    key: 'getAssignmentOfEvaluator',
	    value: function getAssignmentOfEvaluator() {
	      var _this2 = this;
	
	      if (this.Validations.isAdminUnit(this.currentRoleId) || this.Validations.isGerencialConsultant(this.currentRoleId)) {
	        var _header = {
	          userId: this.user.id,
	          rolId: this.currentRoleId
	        };
	      }
	      return this.WorkPlanParametrizationSrv.getAssignmentOfEvaluator.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          _this2.$scope.gridAssignmentOfEvaluators.data = dataReturn.data;
	          return _this2.getTeacherSubmodules().then(_this2.getRoles());
	        }
	      });
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      var _this3 = this;
	
	      this.editEvaluator = true;
	      this.WorkPlanParametrizationSrv.getUsers.get().$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          _this3.listEvaluators = dataReturn.data;
	          _this3.editEvaluator = false;
	        }
	      });
	    }
	  }, {
	    key: 'checked',
	    value: function checked(entity) {
	      for (var idx in this.listTeacher) {
	        if (this.listTeacher[idx] == entity) return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'getTeacherSubmodules',
	    value: function getTeacherSubmodules() {
	      var _this4 = this;
	
	      return this.WorkPlanParametrizationSrv.getTeacherSubmodules.get().$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          _this4.listSubModules = dataReturn.data;
	        }
	      });
	    }
	  }, {
	    key: 'getRoles',
	    value: function getRoles() {
	      var _this5 = this;
	
	      return this.WorkPlanParametrizationSrv.getRoles.get().$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          _this5.listRoles = dataReturn.data;
	        }
	      });
	    }
	
	    // METHOD DEFINITIONS
	
	  }, {
	    key: 'highlightFilteredHeader',
	    value: function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
	      if (col.filters[0].term) {
	        return 'header-filtered';
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'filter',
	    value: function filter() {
	      this.gridApi.grid.refresh();
	    }
	  }, {
	    key: 'returnBack',
	    value: function returnBack() {
	      window.history.back();
	    }
	  }, {
	    key: 'catchRow',
	    value: function catchRow(teacher) {
	      if (this.listTeacher[teacher.teacher_code]) {
	        delete this.listTeacher[teacher.teacher_code];
	      } else {
	        this.listTeacher[teacher.teacher_code] = teacher;
	      }
	      if (this.isVisible === false && !angular.equals(this.listTeacher, {})) {
	        this.isVisible = true;
	      } else if (this.isVisible === true && angular.equals(this.listTeacher, {})) {
	        this.isVisible = false;
	      }
	    }
	  }, {
	    key: 'showModalAssignmentOfEvaluators',
	    value: function showModalAssignmentOfEvaluators(teacher) {
	      var listTeacher = {};
	      if (teacher) {
	        listTeacher[teacher.teacher_code] = teacher;
	      } else {
	        listTeacher = this.listTeacher;
	      }
	      var listEvaluators = this.listEvaluators;
	      var listSubModules = this.listSubModules;
	      var listRoles = this.listRoles;
	      var WorkPlanParametrizationSrv = this.WorkPlanParametrizationSrv;
	      var $interval = this.$interval;
	      var GlobalConfig = this.GlobalConfig;
	      var editEvaluator = this.editEvaluator;
	      this.$mdDialog.show({
	        controller: ['$scope', '$mdDialog', '$state', function modalAssignmentOfEvaluators($scope, $mdDialog, $state) {
	          var _this6 = this;
	
	          $scope.saveButtonDisabled = true;
	          $scope.row = null;
	          $scope.listRoles = listRoles;
	          $scope.listEvaluatorsModal = [];
	          $scope.listEvaluators = [];
	          $scope.listEvaluatorsDelete = [];
	          $scope.listTeacherSelected = listTeacher;
	          $scope.rolSelected = {};
	          $scope.subModule = {};
	          $scope.listSubModules = listSubModules;
	          $scope.WorkPlanParametrizationSrv = WorkPlanParametrizationSrv;
	          $scope.$interval = $interval;
	          $scope.GlobalConfig = GlobalConfig;
	          $scope.editEvaluator = editEvaluator;
	
	          if (teacher) {
	            // List evaluators
	            $scope.WorkPlanParametrizationSrv.getTeacherEvaluator.get({ idTeacher: teacher.teacher_code }).$promise.then(function (dataReturn) {
	              if (dataReturn.status) {
	                $scope.listEvaluatorsModal = dataReturn.data;
	                for (var evaluator in $scope.listEvaluatorsModal) {
	                  var idEvaluator = $scope.listEvaluatorsModal[evaluator].id_evaluator;
	                  var arrayIdSubModules = $scope.listEvaluatorsModal[evaluator].id_submodule.split(',');
	                  var arrayNameSubModules = $scope.listEvaluatorsModal[evaluator].submodule.split(',');
	                  var submodules = [];
	                  for (var count in arrayIdSubModules) {
	                    var objectSubmodules = {
	                      id_submodule: arrayIdSubModules[count],
	                      submodule: arrayNameSubModules[count]
	                    };
	                    submodules.push(objectSubmodules);
	                  }
	                  var evaluators = [{
	                    id_evaluator: idEvaluator,
	                    submodules: submodules
	                  }];
	                  $scope.listEvaluatorsModal[evaluator].evaluators = evaluators;
	                  if ($scope.listEvaluatorsModal[evaluator].id_role === $scope.GlobalConfig.userRolesIds.approver) {
	                    var roleId = $scope.listRoles.findIndex(function (role) {
	                      return role.id_code === $scope.GlobalConfig.userRolesIds.approver;
	                    });
	                    $scope.listRoles[roleId].disable = true;
	                  }
	                }
	              } else {
	                $scope.listEvaluatorsModal = {};
	              }
	            });
	          }
	          $scope.close = function () {
	            $scope.listRoles = $scope.listRoles.map(function (role) {
	              role.disable = false;
	              return role;
	            });
	            $mdDialog.hide();
	          };
	
	          $scope.gridModalEvaluators = {
	            enableFiltering: false,
	            enableRowSelection: true,
	            enableRowHeaderSelection: false,
	            multiSelect: false,
	            modifierKeysToMultiSelect: false,
	            noUnselect: true,
	            columnDefs: [_defineProperty({
	              name: 'Nombre',
	              displayName: 'Nombre',
	              field: 'ds_fullname',
	              width: '60%',
	              headerCellClass: $scope.highlightFilteredHeader,
	              enableGridMenu: false,
	              enableHiding: false,
	              enablePinning: false,
	              enableColumnMenu: false,
	              enableSorting: false,
	              cellClass: 'column-left'
	            }, 'headerCellClass', 'column-left font-normal exo'), {
	              name: 'Cédula',
	              displayName: 'Cédula',
	              field: 'ds_identification',
	              width: '40%',
	              enableGridMenu: false,
	              enableHiding: false,
	              enablePinning: false,
	              enableColumnMenu: false,
	              enableSorting: false,
	              cellClass: 'column-center',
	              headerCellClass: 'column-center font-normal exo'
	            }],
	            onRegisterApi: function onRegisterApi(gridApi) {
	              $scope.gridApi = gridApi;
	              $scope.gridApi.grid.registerRowsProcessor($scope.modalSingleFilter, 200);
	              $interval(function () {
	                $scope.gridApi.core.handleWindowResize();
	              }, 500, 10);
	              gridApi.selection.on.rowSelectionChanged($scope, function (row) {
	                $scope.row = row.entity; // User Selected
	              });
	
	              // gridApi.core.on.filterChanged( this.$scope, () => {
	              //   var grid = gridApi.grid.renderContainers.body.grid;
	              //   var filters={}
	
	              //   for(let i in grid.columns){
	              //     if ((grid.columns[i].filters[0].term!='')&&(grid.columns[i].filters[0].term!=undefined)){
	              //       filters[grid.columns[i].field]=grid.columns[i].filters[0].term;
	              //     }
	              //   }
	
	              //   this.gridOptions.paginationNumber=1;
	              //   this.filtered = {
	              //     ID_SIMULACION: this.simulation.id, 
	              //     newPage: 1,
	              //     pageSize: this.gridOptions.paginationPageSize,
	              //     filters: filters
	              //   }
	              //   console.log('-------------------------------------------------------------');
	              //   console.log('this.inExecution->', this.inExecution);
	              //   if (!this.inExecution) {
	              //     console.log('entro');
	              //     this.inExecution = true
	              //     this.$timeout(() => {
	              //       console.log('estoy en el timeout');
	              //       console.log('this.filtered->', this.filtered); 
	              //       this.services.getDataReport(this.filtered).$promise.then((response) => {
	              //         console.log('se ejecuto');
	              //         this.inExecution = false
	              //         this.agregaPadre(response);
	              //         this.gridOptions.data = response.data;
	              //       }, (err) => {
	              //         this.inExecution = false
	              //       });
	
	              //     }, 600);
	              //   }
	              //   console.log('-------------------------------------------------------------');   
	              // });
	
	              gridApi.pagination.on.paginationChanged(_this6.$scope, function (newPage, pageSize) {
	                console.log('-------------------------------------------------------------');
	                console.log('newPage ->', newPage);
	                console.log('pageSize ->', pageSize);
	                console.log('-------------------------------------------------------------');
	                // var grid = gridApi.grid.renderContainers.body.grid;
	                // var filters={}
	                // for(let i in grid.columns){
	                //   if ((grid.columns[i].filters[0].term!='')&&(grid.columns[i].filters[0].term!=undefined)){
	                //     filters[grid.columns[i].field]=grid.columns[i].filters[0].term;
	                //   }
	                // }
	
	                // let params = {
	                //   ID_SIMULACION: this.simulation.id, 
	                //   newPage:newPage,
	                //   pageSize:pageSize,
	                //   filters:filters
	                // }
	
	                // this.services.getDataReport(params).$promise.then((response) => {
	                //   this.agregaPadre(response);
	                // });
	              });
	            }
	          };
	
	          $scope.gridModalEvaluators.data = listEvaluators;
	
	          $scope.onRoleSelected = function (rolSelected) {
	            clearSelectedActivities();
	            if (rolSelected && rolSelected.id_code === $scope.GlobalConfig.userRolesIds.approver) {
	              selectAllActivities();
	            }
	          };
	
	          function selectAllActivities() {
	            $scope.listSubModules.forEach(function (listModules) {
	              $scope.subModule[listModules.id_code] = true;
	            });
	          }
	
	          function clearSelectedActivities() {
	            $scope.listSubModules.forEach(function (listModules) {
	              $scope.subModule[listModules.id_code] = false;
	            });
	          }
	
	          $scope.isSubModuleDisabled = function (listModules) {
	            if ($scope.rolSelected) {
	              if (!$scope.rolSelected.id_code || $scope.rolSelected.id_code === $scope.GlobalConfig.userRolesIds.approver) {
	                return true;
	              } else {
	                if ($scope.rolSelected.id_code === $scope.GlobalConfig.userRolesIds.reviewer) {
	                  return activityExist(listModules.id_code);
	                }
	              }
	            } else {
	              return true;
	            }
	            return false;
	          };
	
	          function activityExist(activityId) {
	            if ($scope.listEvaluatorsModal) {
	              var found = $scope.listEvaluatorsModal.find(function (evaluator) {
	                if (evaluator.is_active === 1 && evaluator.id_role === $scope.GlobalConfig.userRolesIds.reviewer) {
	                  return evaluator.evaluators.find(function (object) {
	                    var a = object.submodules.find(function (submodule) {
	                      return submodule.id_submodule == activityId;
	                    });
	                    if (a) return a;
	                  });
	                }
	              });
	              if (found) {
	                return true;
	              } else {
	                return false;
	              }
	            }
	            return false;
	          }
	
	          $scope.subModuleEmpty = function () {
	            for (var id in $scope.subModule) {
	              if ($scope.subModule[id]) return false;
	            }
	            return true;
	          };
	
	          // Function Add Evaluators
	          $scope.addEvaluators = function () {
	            $scope.saveButtonDisabled = false;
	            if (!$scope.row || !$scope.rolSelected.id_code || $scope.subModuleEmpty()) return;
	            // disable specific role
	            if ($scope.rolSelected.id_code === $scope.GlobalConfig.userRolesIds.approver) {
	              var roleId = $scope.listRoles.findIndex(function (role) {
	                return role.id_code === $scope.GlobalConfig.userRolesIds.approver;
	              });
	              $scope.listRoles[roleId].disable = true;
	            }
	            var userTemp = [];
	            var userRoleTemp = [];
	
	            for (var idTeacher in $scope.listTeacherSelected) {
	              var assignment = {
	                evaluator_name: $scope.row.ds_fullname,
	                id_teacher: $scope.listTeacherSelected[idTeacher].teacher_code,
	                is_active: $scope.row.is_active,
	                role_name: $scope.rolSelected.ds_name,
	                id_role: $scope.rolSelected.id_code,
	                id_identification: $scope.listTeacherSelected[idTeacher].id_identification
	              };
	
	              var array = [];
	              var submoduleNames = '';
	              var idSubModules = '';
	
	              var _loop = function _loop(id) {
	                if ($scope.subModule[id]) {
	
	                  var object = $scope.listSubModules.find(function (element) {
	                    return element.id_code == id;
	                  });
	
	                  array.push({
	                    id_submodule: object.id_code,
	                    submodule: object.ds_name
	                  });
	
	                  if (submoduleNames === '' && idSubModules === '') {
	                    idSubModules = object.id_code;
	                    submoduleNames = object.ds_name;
	                  } else {
	                    idSubModules = idSubModules + ', ' + object.id_code;
	                    submoduleNames = submoduleNames + ', ' + object.ds_name;
	                  }
	                }
	              };
	
	              for (var id in $scope.subModule) {
	                _loop(id);
	              }
	              var evaluator = [{ id_evaluator: $scope.row.id_code,
	                submodules: array }];
	              assignment.evaluators = evaluator;
	              assignment.submodule = submoduleNames;
	
	              $scope.listEvaluators.push(assignment);
	
	              if ($.inArray($scope.listTeacherSelected[idTeacher].id_identification, userTemp) == -1 && $.inArray($scope.rolSelected.id_code, userRoleTemp) == -1) {
	                $scope.listEvaluatorsModal.push(assignment);
	              }
	
	              userTemp.push($scope.listTeacherSelected[idTeacher].id_identification);
	              userRoleTemp.push($scope.rolSelected.id_code);
	            }
	
	            $scope.row = null;
	            $scope.subModule = {};
	            $scope.gridApi.selection.clearSelectedRows();
	          };
	
	          $scope.listEvaluatorsModalEmpty = function () {
	            if ($scope.listEvaluatorsModal.length === 0) {
	              return true;
	            } else {
	              return !$scope.listEvaluatorsModal.find(function (evaluator) {
	                if (evaluator.is_active === 1) return true;
	              });
	            }
	            return true;
	          };
	
	          $scope.filter = function () {
	            $scope.gridApi.grid.refresh();
	          };
	
	          $scope.modalSingleFilter = function (renderableRows) {
	            var matcher = new RegExp($scope.gridModalAssignmentOfEvaluators, 'i');
	            renderableRows.forEach(function (row) {
	              var match = false;
	              ['ds_fullname', 'ds_name', 'ds_identification'].forEach(function (field) {
	                if (row.entity[field] && row.entity[field].match(matcher)) {
	                  match = true;
	                }
	              });
	              if (!match) {
	                row.visible = false;
	              }
	            });
	            return renderableRows;
	          };
	
	          function showModalSucess() {
	            $mdDialog.show({
	              controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	                var ctrlModal = this;
	
	                $scope.close = function () {
	                  $mdDialog.hide();
	                };
	              }],
	              controllerAs: 'ctrlModal',
	              template: __webpack_require__(211),
	              clickOutsideToClose: false
	            });
	          }
	
	          $scope.saveAssignment = function () {
	            $scope.saveButtonDisabled = true;
	            var header = {
	              values: $scope.listEvaluators,
	              listDisableEvaluators: $scope.listEvaluatorsDelete
	            };
	            $scope.WorkPlanParametrizationSrv.addTeacherEvaluator.add(header).$promise.then(function (dataReturn) {
	              if (dataReturn.status) {
	                $state.reload();
	                $mdDialog.hide();
	                showModalSucess();
	              } else {
	                $scope.saveButtonDisabled = false;
	              }
	            });
	          };
	
	          $scope.deleteAssociation = function (evaluator) {
	            if (evaluator.id_role === $scope.GlobalConfig.userRolesIds.approver) {
	              var roleId = $scope.listRoles.findIndex(function (role) {
	                return role.id_code === $scope.GlobalConfig.userRolesIds.approver;
	              });
	              $scope.listRoles[roleId].disable = false;
	            }
	            evaluator.is_active = 0;
	            $scope.listEvaluatorsDelete.push(evaluator);
	            $scope.saveButtonDisabled = false;
	          };
	        }],
	        template: __webpack_require__(212),
	        clickOutsideToClose: false
	      });
	    }
	  }]);
	
	  return WorkPlanAssignmentOfEvaluatorsCtrl;
	}();
	
	exports.default = WorkPlanAssignmentOfEvaluatorsCtrl;
	
	WorkPlanAssignmentOfEvaluatorsCtrl.$inject = ['$scope', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', 'GlobalConfig', '$cookies', 'Validations'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=row.entity.evaluator> <button ng-disabled=grid.appScope.reviewersVM.editEvaluator md-ink-ripple class=\"btn btn-accent sm-btn p-xs\" type=button ng-click=grid.appScope.reviewersVM.showModalAssignmentOfEvaluators(row.entity) style=padding-top:0;height:20px>Ver/Editar</button> </div> <div ng-if=!row.entity.evaluator> <md-checkbox ng-checked=grid.appScope.reviewersVM.checked(row.entity) class=\"md-green no-margin\" ng-click=grid.appScope.reviewersVM.catchRow(row.entity) required></md-checkbox> </div> </div> ";

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Asignación exitosa!</h3> <p>Los responsables han sido actualizados con éxito</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-azul>Asignar evaluadores</h3> <p class=proxima>Seleccione que evaluadores ser&aacute;n asignados a los profesores seleccionados y luego haga clic en el bot&oacute;n guardar.</p> </div> </div> <div class=row> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-3 no-padding-l p-r-lg\"> <h5 class=\"text-left no-m-t font-bold text-xs\">Profesores seleccionados</h5> <ul class=\"p-l with-bullets\" ng-repeat=\"teacherList in listTeacherSelected\"> <li><p class=\"text-left text-xs\">{{teacherList.teacher_name}}</p></li> </ul> <h5 class=\"p-v-xs text-left p-t-md font-bold text-xs\">Responsables asignados</h5> <ul class=\"p-l with-bullets\" ng-repeat=\"evaluatorsList in listEvaluatorsModal | filter:{ is_active: 1 }\"> <li> <p class=\"font-bold text-xs text-left m-b-xs\"> {{evaluatorsList.evaluator_name}}<i class=\"icon mdi-content-clear i-10 pull-right\" ng-click=deleteAssociation(evaluatorsList)></i> </p> <p class=\"text-xxs text-left p-r\">{{evaluatorsList.role_name}} - {{evaluatorsList.submodule}}</p> </li> </ul> </div> <div class=\"col-md-6 no-padding\"> <div class=\"col-md-12 search no-padding\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=gridModalAssignmentOfEvaluators ng-model-options=\"{ debounce: 300 }\" ng-change=filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> <div class=\"col-md-12 no-padding\"> <div class=\"grid text-xs p-t grid-darker-gray\" ui-grid=gridModalEvaluators ui-grid-resize-columns ui-grid-selection ui-grid-pagination> </div> </div> </div> </div> <div class=\"col-md-3 text-left no-margin p-l-md\" has-permission=asignar-jefes-evaluadores-edit> <h5 class=\"text-left no-m-t font-bold text-xs\">Seleccione rol</h5> <select ng-model=rolSelected ng-change=onRoleSelected(rolSelected) name=role ng-options=\"role.ds_name disable when role.disable for role in listRoles\" class=\"form-control col-md-12 m-b-md\" required> <option value=\"\">Seleccione</option> </select> <h5 class=\"p-v-xs text-left font-bold col-md-12 no-padding text-xs\">Seleccione actividades</h5> <div ng-repeat=\"listModules in listSubModules\" class=\"text-xs text-left\"> <md-checkbox class=md-green ng-model=subModule[listModules.id_code] ng-disabled=isSubModuleDisabled(listModules)>{{listModules.ds_name}}</md-checkbox> </div> <md-button class=\"btn btn-fw btn-success no-margin\" ng-disabled=\"!row || !rolSelected.id_code || subModuleEmpty()\" ng-click=addEvaluators()>Agregar</md-button> </div> </div> </div> <div class=\"row text-center\"> <div class=\"col-md-12 m-t-md\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" ng-click=close()>Volver</md-button> <md-button class=\"btn btn-fw btn-primary no-margin\" ng-click=saveAssignment() ng-disabled=saveButtonDisabled has-permission=asignar-jefes-evaluadores-edit>Guardar asignación</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var workPlanCreateModalCtrl = function workPlanCreateModalCtrl($scope, $mdDialog, WorkPlanParametrizationSrv) {
	  _classCallCheck(this, workPlanCreateModalCtrl);
	
	  $scope.workPlanId;
	  $scope.clonePlan = false;
	
	  $scope.close = function () {
	    $mdDialog.hide();
	  };
	
	  $scope.getWorkPlanList = function () {
	    WorkPlanParametrizationSrv.getWorkPlans.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        $scope.workPlanList = dataReturn.data;
	      } else {
	        console.log(dataReturn);
	      }
	    });
	  };
	
	  $scope.selectWorkPlan = function () {
	    $scope.getWorkPlanList();
	    $scope.clonePlan = true;
	  };
	};
	
	exports.default = workPlanCreateModalCtrl;
	
	
	workPlanCreateModalCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanParametrizationSrv'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SetupTeacherActivitiesCtrl = function SetupTeacherActivitiesCtrl($scope, $resource, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $timeout) {
		_classCallCheck(this, SetupTeacherActivitiesCtrl);
	
		// CONSTANTS
		var setupVM = this;
	
		setupVM.workplan = {};
		setupVM.submodules = [];
		// VARIABLES
		setupVM.teachertype = [];
		setupVM.teacherCategories = [];
		setupVM.isButtonDisabled = false;
		// METHODS
		setupVM.checkDoWorkplan = checkDoWorkplan;
		setupVM.toggleSubcategories = toggleSubcategories;
		setupVM.saveTeacherActivities = saveTeacherActivities;
		setupVM.categorySubmodule = {};
	
		function activate() {
			var header = { workplanId: $stateParams.workPlanId };
	
			return getAllTeachersActivities(header);
		}
	
		// SERVICES METHODS
	
		function getWorkPlanHeader(header) {
			return WorkPlanParametrizationSrv.getWorkPlanHeader.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					setupVM.workplan = dataReturn.data;
					setupVM.workplan.id_code = $stateParams.workPlanId;
				}
			});
		}
	
		function saveTeacherActivities() {
			setupVM.information = processActivitiesInformation();
			setupVM.isButtonDisabled = true;
			var header = {
				id_work_plan: setupVM.workplan.id_code,
				teachertype: setupVM.information
			};
	
			WorkPlanParametrizationSrv.addTeacherSubmodules.add(header).$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					showModalActivitesSetedUp();
					setupVM.isButtonDisabled = false;
				} else {
					showModalActivitesSetedUpError(dataReturn.message);
					setupVM.isButtonDisabled = true;
				}
			});
		}
	
		// METHODS
		function processActivitiesInformation() {
			var result = [];
	
			setupVM.teachertype.forEach(function (teacherType) {
				var professorType = {};
	
				if (teacherType) {
					professorType['submodule'] = [];
					for (var association in teacherType) {
						if (association && teacherType[association]) {
							professorType['id_code'] = teacherType[association];
							professorType['submodule'].push({ id_code: association, is_checked: 1 });
						}
					}
				}
	
				if (professorType['submodule'] && professorType['submodule'].length > 0) {
					result.push(professorType);
				}
			});
	
			return result;
		}
	
		function checkDoWorkplan(subModuleId, teachertype) {
			if (setupVM.teachertype[teachertype]) {
				var isChecked = setupVM.teachertype[teachertype][subModuleId];
	
				if (isChecked) {
					var object = isTeacherTypeChild(teachertype);
	
					if (object) {
						enableParentModuleForTeacher(subModuleId, teachertype, object);
					} else {
						enableChildModulesForTeacher(subModuleId, teachertype);
					}
				} else {
					disableChildModulesForTeacher(subModuleId, teachertype);
				}
			}
	
			// selección de realiza plan de trabajo o no
			if (subModuleId === 1) {
				// todo change this to match don't do workplan
				if (setupVM.teachertype[teachertype]) {
					for (var association in setupVM.teachertype[teachertype]) {
						if (association && association == 1) {
							if (!setupVM.teachertype[teachertype][association]) {
								toggleModulesForTeacher(teachertype, false);
							} else {
								toggleModulesForTeacher(teachertype, teachertype);
								enableParentModuleForTeacher(subModuleId, teachertype, null);
							}
						}
					}
				}
			} else {
				if (setupVM.teachertype[teachertype][subModuleId]) enableModulesForTeacher(subModuleId, teachertype); // colocamos realiza plan de trabajo seleccionado
				else checkDisableModuleForTeacher(subModuleId, teachertype);
			}
	
			// validaciones del formulario
			if (isEmptyTeachertype() || !isActivitySelected()) setupVM.isButtonDisabled = true;else setupVM.isButtonDisabled = false;
	
			//setupVM.categorySubmodule
			var count = {},
			    count1 = {};
	
			for (var i in setupVM.categorySubmodule) {
				if (setupVM.categorySubmodule[i] != false) {
					var parent_id = i;
	
					for (var k1 in setupVM.teachertype[parent_id]) {
						if (setupVM.teachertype[parent_id][k1] != false) {
							if (typeof count1[parent_id] === 'undefined') {
								count1[parent_id] = {};
							}
	
							count1[parent_id] = setupVM.teachertype[parent_id];
						}
					}
	
					if (typeof count1[parent_id] !== 'undefined') {
						count1[parent_id] = {};
						for (var j in setupVM.categorySubmodule[i]) {
							var id_code = setupVM.categorySubmodule[i][j].id_code;
	
							for (var k in setupVM.teachertype[id_code]) {
								if (setupVM.teachertype[id_code][k] != false) {
									if (typeof count1[parent_id][id_code] === 'undefined') {
										count1[parent_id][j] = {};
									}
	
									count1[parent_id][id_code] = setupVM.categorySubmodule[i][j];
								}
							}
						}
					}
				}
			}
	
			for (var t in count1) {
				var size = Object.keys(count1[t]).length;
	
				if (size <= 0) {
					setupVM.isButtonDisabled = true;
				}
			}
		}
	
		function enableParentModuleForTeacher(subModuleId, teachertype, object) {
			if (object) {
				enable(object, subModuleId);
			} else {
				if (setupVM.teachertype[teachertype][subModuleId]) {
					var _object = isTeacherTypeChild(teachertype);
	
					if (_object) {
						enable(_object, subModuleId);
					}
				}
			}
	
			function enable(object, subModuleId) {
				var parent = object.parent;
	
				setupVM.teachertype[parent.id_code][subModuleId] = parent.id_code;
	
				if (subModuleId == 1) {
					for (var t in setupVM.teachertype[parent.id_code]) {
						setupVM.teachertype[parent.id_code][t] = parent.id_code;
					}
				}
	
				enableModulesForTeacher(subModuleId, parent.id_code);
			}
		}
	
		function isTeacherTypeChild(teachertype) {
			var result = false;
	
			setupVM.teacherCategories.forEach(function (object) {
				if (object.childs && object.childs.length > 0) {
					var isChild = object.childs.find(function (child) {
						return child.id_code === teachertype;
					});
	
					if (isChild) {
						result = {
							parent: object,
							child: isChild
						};
	
						return;
					}
				}
			});
	
			return result;
		}
	
		function disableChildModulesForTeacher(subModuleId, teachertype) {
			var row = setupVM.teacherCategories.find(function (object) {
				return object.id_code === teachertype;
			});
	
			if (row && row.childs && row.childs.length > 0) {
				var isParentCheckActive = setupVM.teachertype[teachertype][subModuleId];
	
				row.childs.forEach(function (child) {
					if (!isParentCheckActive) {
						if (subModuleId === 1) {
							toggleModulesForTeacher(child.id_code, false);
						} else {
							setupVM.teachertype[child.id_code][subModuleId] = false;
						}
					}
	
					checkDisableModuleForTeacher(subModuleId, child.id_code);
				});
			}
		}
	
		function enableChildModulesForTeacher(subModuleId, teachertype) {
			var row = setupVM.teacherCategories.find(function (object) {
				return object.id_code === teachertype;
			});
	
			if (row && row.childs && row.childs.length > 0) {
				row.childs.forEach(function (child) {
					setupVM.teachertype[child.id_code][subModuleId] = child.id_code;
					setupVM.teachertype[child.id_code]['1'] = child.id_code;
	
					if (subModuleId == 1) toggleModulesForTeacher(child.id_code, child.id_code);
				});
			}
		}
	
		function isEmptyTeachertype() {
			var arr = processActivitiesInformation();
	
			return arr.length === 0;
		}
	
		function toggleModulesForTeacher(teachertype, value) {
			for (var association in setupVM.teachertype[teachertype]) {
				setupVM.teachertype[teachertype][association] = value;
			}
		}
	
		function enableModulesForTeacher(subModuleId, teachertype) {
			for (var association in setupVM.teachertype[teachertype]) {
				setupVM.teachertype[teachertype]['1'] = teachertype; // todo change this to match a variable
			}
		}
	
		function setAllProfessorChecked(check) {
			var result = [];
	
			setupVM.teacherCategories.forEach(function (teacherType) {
				if (teacherType) {
					result[teacherType.id_code] = {};
					setupVM.submodules.forEach(function (module) {
						if (check) result[teacherType.id_code][module.id_code] = teacherType.id_code;else result[teacherType.id_code][module.id_code] = false;
					});
	
					if (teacherType.childs.length > 0) {
						teacherType.childs.forEach(function (child) {
							if (child) {
								result[child.id_code] = {};
								setupVM.submodules.forEach(function (module) {
									if (check) result[child.id_code][module.id_code] = child.id_code;else result[child.id_code][module.id_code] = false;
								});
							}
						});
					}
				}
			});
	
			return result;
		}
	
		function setWorkplanAlreadyChecked(teacherSubmoduleRelation) {
			teacherSubmoduleRelation.forEach(function (relation) {
				setupVM.teachertype[relation.id_teacher_type][relation.id_submodule.toString()] = relation.id_teacher_type;
			});
		}
	
		function toggleSubcategories(category) {
			if (category.showChilds) {
				category.showChilds = false;
			} else {
				category.showChilds = true;
			}
		}
		// MODAL DEFINITIONS
		function showModalActivitesSetedUp() {
			var planName = setupVM.workplan.plan_name;
			var workPlanId = $stateParams.workPlanId;
			var workPlanIdCloned = $stateParams.workPlanIdCloned;
	
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.planName = planName;
					$scope.workPlanId = workPlanId;
					$scope.workPlanIdCloned = workPlanIdCloned;
					$scope.close = function () {
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(215),
				clickOutsideToClose: false
			});
		}
	
		function showModalActivitesSetedUpError(message) {
			var errorMessage = message;
	
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.errorMessage = errorMessage;
					$scope.close = function () {
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(216),
				clickOutsideToClose: false
			});
		}
	
		function isActivitySelected() {
			var BreakException = {};
	
			try {
				setupVM.teachertype.forEach(function (teacherType) {
					if (teacherType) {
						var count = Object.values(teacherType).reduce(function (n, val) {
							return n + (val === false);
						}, 0);
	
						if (count == 5) {
							throw BreakException;
						}
					}
				});
	
				return true;
			} catch (e) {
				if (e == BreakException) {
					return false;
				}
			}
		}
	
		function checkDisableModuleForTeacher(subModuleId, teachertype) {
			var count = Object.values(setupVM.teachertype[teachertype]).reduce(function (n, val) {
				return n + (val === false);
			}, 0);
			var parent = isTeacherTypeChild(teachertype);
	
			if (parent) {
				if (count == 5) {
					setupVM.teachertype[teachertype]['1'] = false;
					checkDisableParentModuleForTeacher('1', parent);
				}
	
				checkDisableParentModuleForTeacher(subModuleId, parent);
			} else {
				checkDisableDoWorkPlan(subModuleId, teachertype);
			}
		}
	
		function checkDisableParentModuleForTeacher(subModuleId, object) {
			var teachers = getTeacherTypeChilds(object.parent.id_code);
			var count = 0;
	
			teachers.childs.forEach(function (child) {
				if (setupVM.teachertype[child.id_code] && setupVM.teachertype[child.id_code][subModuleId]) {
					count = count + 1;
				}
			});
	
			if (count == 0) disable(subModuleId, object);
		}
	
		function checkDisableDoWorkPlan(subModuleId, teachertype) {
			var count = 0;
	
			for (var association in setupVM.teachertype[teachertype]) {
				if (setupVM.teachertype[teachertype][association]) count = count + 1;
			}
	
			if (count == 1) setupVM.teachertype[teachertype]['1'] = false;
		}
	
		function disable(subModuleId, object) {
			var parent = object.parent;
	
			setupVM.teachertype[parent.id_code][subModuleId] = false;
		}
	
		function getTeacherTypeChilds(teachertype) {
			var result = [];
	
			setupVM.teacherCategories.forEach(function (object) {
				if (object.id_code == teachertype && object.childs.length > 0) {
					result = object;
	
					return;
				}
			});
	
			return result;
		}
	
		function getAllTeachersActivities(header) {
			return WorkPlanParametrizationSrv.getAllActivities.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					setupVM.submodules = dataReturn.submodules;
					setupVM.teacherCategories = dataReturn.categories;
					setupVM.workplan = dataReturn.workPlan;
					setupVM.workplan.id_code = header.workplanId;
					for (var i in setupVM.teacherCategories) {
						if (typeof setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] === 'undefined') {
							setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] = {};
	
							if (setupVM.teacherCategories[i].childs.length > 0) {
								setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] = setupVM.teacherCategories[i].childs;
							} else {
								setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] = false;
							}
						}
					}
					getRelationTeacherSubmodules(dataReturn.relationTeacherSubmodule);
				}
			});
		}
	
		function getRelationTeacherSubmodules(header) {
			if (header) {
				if (header.length > 0) {
					setupVM.teachertype = setAllProfessorChecked(false);
					setWorkplanAlreadyChecked(header);
				} else {
					setupVM.teachertype = setAllProfessorChecked(true);
				}
	
				setupVM.isButtonDisabled = !isActivitySelected() && !isEmptyTeachertype();
			} else {
				console.log('error receiving getRelationTeacherSubmodules');
			}
		}
	
		// INITIALIZATION
		activate();
	};
	
	exports.default = SetupTeacherActivitiesCtrl;
	
	
	SetupTeacherActivitiesCtrl.$inject = ['$scope', '$resource', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', '$timeout'];

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creación exitosa!</h3> <p>Las actividades de su plan \"{{planName}}\" se han configurado con éxito. ¿Desea configurar las horas de dedicación?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close() ui-sref=fullscreen.workPlanParametrization>No, gracias</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=close() ng-if=!workPlanIdCloned ui-sref=\"workPlanParametrization.workPlanHoursOfDedicated({id: workPlanId})\">Sí, ir a horas de dedicación</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=close() ng-if=workPlanIdCloned ui-sref=\"workPlanParametrization.cloneHoursOfDedicated({id: workPlanId,workPlanIdCloned: workPlanIdCloned})\">Si, ir a horas de dedicación</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-azul>¡Atención!</h3> <p>{{errorMessage}}</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Volver</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CriteriaListViewCtrl = function CriteriaListViewCtrl($scope, $resource, $stateParams, WorkPlanParametrizationSrv, $mdDialog, $timeout, $state, $window, $filter) {
	  _classCallCheck(this, CriteriaListViewCtrl);
	
	  // CONSTANTS
	  var criteriaListVM = this;
	  var categoryId = $stateParams.categoryId;
	  criteriaListVM.allLists = [];
	  criteriaListVM.criteriaList = {};
	  criteriaListVM.workplans = [];
	  criteriaListVM.associations = {};
	  criteriaListVM.workplansInitiated = [];
	  criteriaListVM.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	  if (categoryId === '1') {
	    criteriaListVM.mainLabel = 'Criterios de revisión/aprobación';
	    criteriaListVM.gradCriteriaClass = 'grad-1';
	  } else {
	    criteriaListVM.mainLabel = 'Criterios de evaluación';
	    criteriaListVM.gradCriteriaClass = 'grad-3';
	  }
	
	  // VARIABLES
	  criteriaListVM.viewLoaded = true;
	
	  // METHODS
	  criteriaListVM.contains = contains;
	  criteriaListVM.updateView = updateView;
	  criteriaListVM.updateSearchView = updateSearchView;
	  criteriaListVM.numerize = numerize;
	  criteriaListVM.hasError = hasError;
	  criteriaListVM.showErrorMessages = showErrorMessages;
	  criteriaListVM.returnBack = returnBack;
	  criteriaListVM.checkIsInicializated = checkIsInicializated;
	
	  // MODALS
	  criteriaListVM.createCriteria = createCriteria;
	  criteriaListVM.associateCriteria = associateCriteria;
	  criteriaListVM.associatedPlans = associatedPlans;
	  criteriaListVM.confirmDeleteCriteriaList = confirmDeleteCriteriaList;
	
	  function activate(id) {
	    return getCriteriaListData(id).then(getWorkplans(id));
	  }
	
	  // SERVICES
	  function getCriteriaListData(id) {
	    return WorkPlanParametrizationSrv.criteriaListService.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        if (id === '1') {
	          criteriaListVM.criteriaList = dataReturn.data.crt1;
	          dataReturn.data.crt1.forEach(function (list) {
	            criteriaListVM.allLists.push(list);
	          });
	          dataReturn.data.crt2.forEach(function (list) {
	            criteriaListVM.allLists.push(list);
	          });
	        } else {
	          criteriaListVM.criteriaList = dataReturn.data.crt2;
	          dataReturn.data.crt2.forEach(function (list) {
	            criteriaListVM.allLists.push(list);
	          });
	          dataReturn.data.crt1.forEach(function (list) {
	            criteriaListVM.allLists.push(list);
	          });
	        }
	      }
	    }).catch(function (error) {
	      console.log(error);
	    });
	  }
	
	  function getWorkplans(id) {
	    var header = { categoryId: id };
	    return WorkPlanParametrizationSrv.workplanByCategory.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        var workPlansAdd = dataReturn.data;
	        workPlansAdd.forEach(function (plan) {
	          delete plan.dt_start_date;
	          delete plan.category;
	          criteriaListVM.workplans.push(plan);
	        });
	      }
	    }).catch(function (error) {
	      console.log(error);
	    });
	  }
	
	  function associateToDefaultSet(workplan) {
	    for (var pos in criteriaListVM.criteriaList) {
	      if (criteriaListVM.criteriaList[pos].is_editable === 'false') {
	        if (!Array.isArray(workplan)) {
	          criteriaListVM.criteriaList[pos].workplans.push(workplan);
	        } else {
	          criteriaListVM.criteriaList[pos].workplans = criteriaListVM.criteriaList[pos].workplans.concat(workplan);
	        }
	        break;
	      }
	    }
	  }
	
	  function returnBack() {
	    window.history.back();
	  }
	
	  // METHODS
	  function hasError(input) {
	    if (typeof input !== 'undefined' && input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    if (typeof input !== 'undefined') return input.$dirty || input.$touched;
	  }
	
	  function contains(collection, value) {
	    for (var i = 0; i < collection.length; i++) {
	      if (collection[i].id_work_plan === value.id_work_plan) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function updateView() {
	    criteriaListVM.viewLoaded = true;
	    $state.reload();
	    // $window.location.href =  $window.location;
	    criteriaListVM.viewLoaded = false;
	    $timeout(function () {
	      criteriaListVM.viewLoaded = true;
	    }, 100);
	  }
	
	  function updateSearchView() {
	    criteriaListVM.viewLoaded = true;
	    criteriaListVM.viewLoaded = false;
	    $timeout(function () {
	      criteriaListVM.viewLoaded = true;
	    }, 100);
	  }
	
	  function numerize(string) {
	    return parseInt(string, 10);
	  }
	
	  // MODAL DEFINITIONS
	  function createCriteria(idList) {
	    // CRITERIA EDITS ALSO INSIDE
	    var updateView = criteriaListVM.updateView;
	    var criteriaList = criteriaListVM.criteriaList;
	    var numerize = criteriaListVM.numerize;
	    var hasError = criteriaListVM.hasError;
	    var showErrorMessages = criteriaListVM.showErrorMessages;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.criteriaList = criteriaList;
	        $scope.numerize = numerize;
	        $scope.updateView = updateView;
	        $scope.deletedItems = [];
	        $scope.hasError = hasError;
	        $scope.showErrorMessages = showErrorMessages;
	        $scope.description = '';
	        $scope.name = '';
	        if ($stateParams.categoryId === '1') {
	          $scope.mainLabel = ' de revisión/aprobación';
	        } else {
	          $scope.mainLabel = ' de evaluación';
	        }
	
	        $scope.isDisabled = function (form) {
	          if (typeof $scope.items !== 'undefined' && $scope.items.length > 0 && typeof form !== 'undefined' && !form.$invalid) {
	            return false;
	          }
	          return true;
	        };
	
	        $scope.requireDetails = function (form) {
	          if (typeof $scope.ds_description !== 'undefined' && $scope.ds_description.length > 0 && typeof form !== 'undefined' && !form.$invalid) {
	            return false;
	          }
	          return true;
	        };
	
	        function updateCreateCriteriaModal(idList) {
	          $scope.newList = {}; // variable to transport new list
	          if (!idList) {
	            $scope.items = [];
	            $scope.workplans = [];
	            $scope.category = $stateParams.categoryId; // To preselect the category options
	            $scope.position = 0;
	          } else {
	            for (var pos in $scope.criteriaList) {
	              if (idList === $scope.criteriaList[pos].id_list) {
	                $scope.positionInList = pos;
	                $scope.idList = idList;
	                $scope.name = $scope.criteriaList[pos].list_name;
	                $scope.description = $scope.criteriaList[pos].ds_description;
	                $scope.category = $scope.criteriaList[pos].id_type_list;
	                $scope.items = [];
	                for (var i = 0; i < $scope.criteriaList[pos].items.length; i++) {
	                  var objElem = {
	                    id_lists_item: $scope.criteriaList[pos].items[i].id_lists_item,
	                    lists_item_name: $scope.criteriaList[pos].items[i].lists_item_name,
	                    nm_order: $scope.criteriaList[pos].items[i].nm_order,
	                    ds_description: $scope.criteriaList[pos].items[i].ds_description,
	                    is_active: $scope.criteriaList[pos].items[i].is_active
	                  };
	                  $scope.items.push(objElem);
	                }
	                $scope.position = $scope.criteriaList[pos].items.length;
	                $scope.workplans = $scope.criteriaList[pos].workplans;
	                $scope.criteriaList[pos].is_editable == 1 ? $scope.criterio = '' : $scope.criterio = true;
	                // $scope.criterio= $scope.criteriaList[pos].is_editable
	                break;
	              }
	            }
	          }
	        }
	
	        updateCreateCriteriaModal(idList);
	        $scope.addToItems = function (item, items, criteriaDescription) {
	          if (item && !itemIsAlreadyAdded(item, items, criteriaDescription)) {
	            if (!items[$scope.position]) {
	              items[$scope.position] = {};
	            }
	
	            items[$scope.position].lists_item_name = item;
	            items[$scope.position].nm_order = $scope.position + 1;
	            items[$scope.position].ds_description = criteriaDescription;
	            items[$scope.position].is_active = 1;
	
	            $scope.position = items.length;
	            $scope.item = '';
	            $scope.ds_description = '';
	            $scope.addCriteria.$setPristine();
	            return items;
	          }
	        };
	        $scope.editItem = function (item, items, criteriaDescription) {
	          $scope.item = item.lists_item_name;
	          $scope.ds_description = item.ds_description;
	          $scope.position = items.indexOf(item);
	        };
	
	        $scope.removeFromItems = function (item, items, criteriaDescription) {
	          var workplansInitiated = [];
	          var nameCriterio = item.lists_item_name;
	
	          //Revisa si tiene planes activos
	          var tieneActivos = false;
	
	          var workpl = []; //Empty array
	          workpl = $scope.workplans;
	
	          var dateToday = $filter('date')(new Date(), 'yyyy-MM-dd');
	          for (var i = 0; i < workpl.length; i++) {
	            var dateStart = $filter('date')(workpl[i].start_date, 'yyyy-MM-dd');
	
	            //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
	            if (dateStart <= dateToday) {
	              tieneActivos = true;
	              workplansInitiated.push(workpl[i]);
	            }
	          }
	
	          if (tieneActivos === false) {
	            var index = items.indexOf(item);
	            if (index > -1) {
	              if (typeof items[index].id_lists_item !== 'undefined') {
	                items[index].is_active = 0;
	                $scope.deletedItems.push(items[index]);
	              }
	              items.splice(index, 1);
	            }
	
	            items.forEach(function (item) {
	              if (items.indexOf(item) >= index) {
	                item.nm_order = item.nm_order - 1;
	              }
	            });
	            $scope.position = items.length;
	            return items;
	          } else {
	            //Show modal with validation message
	            $mdDialog.show({
	              controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	                $scope.nameCriterio = nameCriterio;
	                $scope.workplansInitiated = workplansInitiated;
	                $scope.close = function () {
	                  $mdDialog.hide();
	                };
	              }],
	              template: __webpack_require__(218),
	              clickOutsideToClose: true
	            });
	          }
	        };
	
	        $scope.close = function () {
	          $mdDialog.hide();
	          $state.reload();
	        };
	
	        $scope.createCriteriaList = function (idList) {
	          $scope.isDisabled = function (form) {
	            return true;
	          };
	          typeof $scope.criterio === 'undefined' || $scope.criterio == '' ? $scope.criterio = 1 : $scope.criterio = 0;
	          $scope.newList = {
	            list_name: $scope.name,
	            is_visible: 1,
	            ds_description: $scope.description,
	            is_editable: $scope.criterio,
	            id_type_list: $scope.category,
	            items: $scope.items,
	            workplans: $scope.workplans,
	            criterio: $scope.criterio
	          };
	          if (idList) {
	            // editing
	            $scope.newList['id_list'] = idList;
	            var data = angular.copy($scope.newList);
	            data['items'] = data['items'].concat($scope.deletedItems);
	            WorkPlanParametrizationSrv.updateCriteria.update(data).$promise.then(function (dataReturn) {
	              if (dataReturn.status === true) {
	                $scope.criteriaList[$scope.positionInList] = $scope.newList;
	                $mdDialog.hide();
	                updateView();
	              }
	              $scope.isDisabled = function (form) {
	                return false;
	              };
	            });
	          } else {
	            WorkPlanParametrizationSrv.createCriterias.create($scope.newList).$promise.then(function (dataReturn) {
	              if (dataReturn.status === true) {
	                $mdDialog.hide();
	                $state.reload();
	              }
	              $scope.isDisabled = function (form) {
	                return false;
	              };
	            });
	          }
	        };
	      }],
	      template: __webpack_require__(219),
	      clickOutsideToClose: true,
	      preserveScope: true
	    });
	  }
	
	  function associateCriteria(list) {
	    var criteriaList = criteriaListVM.allLists;
	    var workplans = criteriaListVM.workplans;
	    var numerize = criteriaListVM.numerize;
	    var contains = criteriaListVM.contains;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function associateCriteriaModal($scope, $mdDialog) {
	        $scope.criteriaList = criteriaList;
	        $scope.workplans = workplans;
	        $scope.numerize = numerize;
	        $scope.contains = contains;
	        $scope.category = list.id_type_list; // To preselect the category options
	        $scope.listing = list;
	        $scope.isDisabled = false;
	        $scope.close = close;
	        $scope.postAssociation = postAssociation;
	        if (categoryId === '1') {
	          $scope.mainLabel = ' revisión/aprobación';
	        } else {
	          $scope.mainLabel = ' evaluación';
	        }
	
	        $scope.compare = function (list, item) {
	          var arr = list.map(function (wp) {
	            return angular.equals(wp, item);
	          });
	          return arr.includes(true);
	        };
	
	        function close() {
	          $mdDialog.hide();
	        }
	
	        function associatePlanToCriterias(header) {
	          WorkPlanParametrizationSrv.associatePlanToCriterias.associate(header).$promise.then(function (dataReturn) {
	            if (dataReturn.status === true) {
	              $scope.criteriaList.forEach(function (list) {
	                if (list.id_list === header.id_list) {
	                  $scope.workplans.forEach(function (plan) {
	                    if (plan.id_work_plan === header.id_work_plan && !$scope.contains(list.workplans, plan)) {
	                      list.workplans.push(plan);
	                    }
	                  });
	                } else {
	                  list.workplans.forEach(function (plan, idx) {
	                    if (plan.id_work_plan === header.id_work_plan && $scope.contains(list.workplans, plan)) {
	                      list.workplans.splice(idx, 1);
	                    }
	                  });
	                }
	              });
	              $mdDialog.hide();
	            } else {
	              $scope.isDisabled = false;
	            }
	          });
	        }
	
	        function postAssociation() {
	          $scope.isDisabled = true;
	          var newAssociation = {
	            id_category: $scope.category,
	            id_list: $scope.listing.id_list,
	            id_work_plan: $scope.plans.id_work_plan
	          };
	          associatePlanToCriterias(newAssociation);
	        }
	      }],
	      template: __webpack_require__(220),
	      clickOutsideToClose: true
	    });
	  };
	
	  function associatedPlans(list) {
	    var currentCategory = categoryId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function associatedPlansModal($scope, $mdDialog) {
	        $scope.currentCategory = currentCategory;
	        $scope.checkIsInicializated = checkIsInicializated;
	        $scope.checkIsInicializatedWorkPlan = checkIsInicializatedWorkPlan;
	        if (currentCategory === '1') {
	          $scope.modalName = 'revisión/aprobación';
	        } else {
	          $scope.modalName = 'evaluación';
	        }
	        $scope.list = list;
	        $scope.close = function () {
	          $mdDialog.hide();
	          $state.reload();
	        };
	        $scope.disassociate = function (index, workplan) {
	          var hasActives = false;
	          var workplansInitiated = [];
	          var id_list = $scope.list.id_list;
	          var id_type_list = $scope.list.id_type_list;
	          var list = $scope.list;
	
	          $mdDialog.show({
	            controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	              $scope.workplanName = workplan.workplan_name;
	              $scope.id_list = id_list;
	              $scope.id_type_list = id_type_list;
	              $scope.list = list;
	              $scope.disassociateWorkPlan = function () {
	                WorkPlanParametrizationSrv.disassociateCriteria.disassociate({
	                  id_work_plan: workplan.id_work_plan,
	                  id_list: $scope.id_list,
	                  id_category: $scope.id_type_list
	                }).$promise.then(function (dataReturn) {
	                  if (dataReturn.status === true) {
	                    associateToDefaultSet($scope.list.workplans[index]);
	                    $scope.list.workplans.splice(index, 1);
	                    $mdDialog.hide();
	                    $state.reload();
	                  }
	                });
	              };
	              $scope.close = function () {
	                $mdDialog.hide();
	              };
	            }],
	            template: __webpack_require__(221),
	            clickOutsideToClose: true
	          });
	        };
	      }],
	      template: __webpack_require__(222),
	      clickOutsideToClose: false
	    });
	  };
	
	  function confirmDeleteCriteriaList(list, criteriaListId, criteriaListName, categoryTypeListId) {
	    var criteriaList = criteriaListVM.criteriaList;
	    var updateView = criteriaListVM.updateView;
	    var workplansInitiated = [];
	
	    //Revisa si tiene planes activos
	    var tieneActivos = false;
	
	    var workpl = []; //Empty array
	    workpl = list.workplans;
	
	    var dateToday = $filter('date')(new Date(), 'yyyy-MM-dd');
	    for (var i = 0; i < workpl.length; i++) {
	      var dateStart = $filter('date')(workpl[i].start_date, 'yyyy-MM-dd');
	
	      //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
	      if (dateStart <= dateToday) {
	        tieneActivos = true;
	        workplansInitiated.push(workpl[i]);
	      }
	    }
	
	    if (tieneActivos === false) {
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	          $scope.updateView = updateView;
	          $scope.criteriaList = criteriaList;
	          $scope.criteriaListId = criteriaListId;
	          $scope.criteriaListName = criteriaListName;
	          $scope.categoryTypeListId = categoryTypeListId;
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	
	          $scope.deleteCriteriaList = function (criteriaListId, categoryTypeListId) {
	            WorkPlanParametrizationSrv.deleteCriteriaListItem.delete({
	              id_list: criteriaListId,
	              id_category: categoryTypeListId
	            }).$promise.then(function (dataReturn) {
	              if (dataReturn.status === true) {
	                $scope.criteriaList.forEach(function (list, index) {
	                  if (list.id_list === criteriaListId) {
	                    associateToDefaultSet(list.workplans);
	                    $scope.criteriaList.splice(index, 1);
	                  }
	                });
	                updateView();
	                $mdDialog.hide();
	                showCriteriaListDeletedModal(criteriaListName);
	              }
	            }, function (data) {
	              console.log(data);
	            });
	          };
	        }],
	        template: __webpack_require__(223),
	        clickOutsideToClose: true
	      });
	    } else {
	      //Show modal with validation message
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	          $scope.updateView = updateView;
	          $scope.criteriaList = criteriaList;
	          $scope.criteriaListId = criteriaListId;
	          $scope.criteriaListName = criteriaListName;
	          $scope.categoryTypeListId = categoryTypeListId;
	          $scope.workplansInitiated = workplansInitiated;
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	        }],
	        template: __webpack_require__(224),
	        clickOutsideToClose: true
	      });
	    }
	  }
	
	  function showCriteriaListDeletedModal(criteriaListName) {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.criteriaListName = criteriaListName;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(225),
	      clickOutsideToClose: true
	    });
	  }
	
	  function itemIsAlreadyAdded(item, items, criteriaDescription) {
	    for (var pos in items) {
	      console.log(items[pos].lists_item_name.toLowerCase(), items);
	      console.log(criteriaDescription);
	      if (items[pos].lists_item_name.toLowerCase().replace(/ /g, '') === item.toLowerCase().replace(/ /g, '') && items[pos].ds_description == criteriaDescription) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function checkIsInicializated(criteria, fastQuit) {
	    var hasActive = false;
	    criteriaListVM.workplansInitiated = []; //Empty array
	    var workpl = criteria.workplans;
	    var dateToday = $filter('date')(new Date(), 'yyyy-MM-dd');
	    for (var i = 0; i < workpl.length; i++) {
	      var dateStart = $filter('date')(workpl[i].start_date, 'yyyy-MM-dd');
	      //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
	      if (dateStart <= dateToday) {
	        hasActive = true;
	        if (fastQuit) {
	          return hasActive;
	        }
	        criteriaListVM.workplansInitiated.push(workpl[i]);
	      }
	    }
	    return hasActive;
	  }
	
	  function checkIsInicializatedWorkPlan(workPlan) {
	    var dateToday = $filter('date')(new Date(), 'yyyy-MM-dd');
	    var dateStart = $filter('date')(workPlan.start_date, 'yyyy-MM-dd');
	    //Si la fecha es menor o igual a fecha actual, entonces está activo y no se puede eliminar.
	    if (dateStart <= dateToday) {
	      return false;
	    }
	    return true;
	  }
	
	  // INTIALIZATION
	  activate(categoryId);
	};
	
	exports.default = CriteriaListViewCtrl;
	
	
	CriteriaListViewCtrl.$inject = ['$scope', '$resource', '$stateParams', 'WorkPlanParametrizationSrv', '$mdDialog', '$timeout', '$state', '$window', '$filter'];

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>No se puede eliminar el criterio \"{{nameCriterio}}\" debido a que tiene los siguientes planes de trabajo ya iniciados:</p> </div> </div> <div class=row> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"workplan in workplansInitiated track by $index\" class=m-v-sm> <p class=\"text-left text-md p-l-sm\"> {{workplan.workplan_name}} </p> </li> </ul> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <h3 class=\"text-center text-azul\"> <span ng-if=!idList>Crear criterios {{mainLabel}}</span> <span ng-if=idList>Editar criterios {{mainLabel}}</span> </h3> <p class=\"text-center text-xs\">Configure los siguientes parámetros para crear un nuevo set de criterios.</p> </div> <div class=row> <form name=newCriteriaList novalidate> <div class=\"form-group col-md-12 text-left\" ng-class=hasError(newCriteriaList.listName)> <label class=\"control-label text-sm\" for=listName>Nombre</label> <input type=text class=form-control ng-model=name ng-model-options=\"{ debounce: 300 }\" name=listName required> <div class=control-label ng-messages=newCriteriaList.listName.$error ng-show=showErrorMessages(newCriteriaList.listName)> <div ng-message=required>El nombre es requerido</div> </div> </div> <div class=\"form-group col-md-12 text-left\" ng-class=hasError(newCriteriaList.description)> <label class=\"control-label text-sm\" for=description>Descripción <span class=\"text-gris-dark m-l-xs\" ng-show=\"items.length === 0\"> (140 caracteres)</span> </label> <md-input-container class=control-label> <textarea class=form-control md-maxlength=155 maxlength=155 style=height:90px ng-model=description name=description ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-9 no-padding\"> <div class=control-label ng-messages=newCriteriaList.description.$error ng-show=showErrorMessages(newCriteriaList.description)> <div ng-message=required>La descripción es requerida</div> </div> </div> <div class=\"col-md-3 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </form> <div class=\"col-md-12 text-left\"> <form ng-submit=\"addToItems(item, items,ds_description)\" name=addCriteria> <label class=text-sm for=criteria> Ingresar criterios <span class=\"text-gris-dark m-l-xs\" ng-show=\"items.length === 0\"> (Ingrese al menos un criterio) </span> </label> <div class=\"form-group col-md-12 no-padding\"> <input type=text class=form-control id=criteria ng-model=item ng-model-options=\"{ debounce: 300 }\"> </div> <div layout-gt-sm=row class=\"form-group col-md-12 no-padding\"> <md-input-container class=\"md-block no-margin p-r-md\" flex-gt-sm> <label> Descripción <span class=\"text-gris-dark m-l-xs\" ng-show=\"item.length > 0\"> (Debe agregarle descripción al criterio) </span> </label> <input ng-model=ds_description name=description ng-required=\"item.length > 0\"> </md-input-container> <button type=submit class=\"btn btn-sm btn-success add-button\" ng-disabled=requireDetails(addCriteria) style=max-height:32px> <i class=\"icon mdi-content-add i-20\"></i> </button> </div> </form> </div> <ul class=\"without-bullets col-md-12 m-t-sm\"> <li ng-repeat=\"item in items\" class=\"list text-md\"> <p class=\"text-sm no-margin text-left col-md-3 no-padding\"> {{item.nm_order + \".- \" + item.lists_item_name}}</p> <p class=\"text-sm no-margin text-left col-md-5 no-padding\"> {{item.ds_description}}</p> <a href ng-click=\"editItem(item, items,ds_description)\" class=\"icon col-md-1 col-md-offset-1 p-xs\"> <span class=\"icon i-20 mdi-content-create\"></span> </a> <a href ng-click=\"removeFromItems(item, items, ds_description)\" class=\"icon col-md-1 p-xs\"> <span class=\"icon i-20 mdi-action-delete\"></span> </a> </li> </ul> <div flex-gt-sm=50 class=criterio_checkbox> <md-checkbox name=criterio ng-disabled=false aria-label=checkbox ng-model=criterio> Es criterio por defecto </md-checkbox> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-primary\" ng-disabled=isDisabled(newCriteriaList) ng-if=!idList ng-click=createCriteriaList()>Crear</md-button> <md-button class=\"btn btn-fw btn-primary\" ng-disabled=isDisabled(newCriteriaList) ng-if=idList ng-click=createCriteriaList(idList)>Guardar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button aria-label class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <h3 class=\"text-center text-azul\">Asociar plan</h3> <p class=\"text-center text-xs\">Configure los siguientes par&aacute;metros para asociar un listado de criterios a un plan de trabajo</p> </div> <div class=row style=text-align:left> <div class=col-md-12> <p class=\"text-sm text-left\">Categoría de asociación: {{mainLabel}}</p> </div> <div class=col-md-12> <p class=\"text-sm text-left\">Listado de criterios a asociar:</p> <label class=text-xs>{{listing.list_name}}</label> </div> <div class=col-md-12> <p class=\"text-sm text-left\">Seleccione Plan a asociar:</p> </div> <div class=col-md-12> <md-select ng-model=plans ng-model-options=\"{trackBy: '$value.id_work_plan'}\"> <md-option ng-repeat=\"plan in workplans track by plan.id_work_plan\" ng-value=plan ng-show=\"!compare(listing.workplans, plan)\"> {{plan.workplan_name}} </md-option> </md-select> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-disabled=isDisabled ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-primary\" ng-disabled=\"isDisabled || !plans\" ng-click=postAssociation()>Asociar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>¿Está seguro que desea eliminar el plan de trabajo \"{{workplanName}}\"? El plan usará la lista de criterios por defecto</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=disassociateWorkPlan()>Eliminar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <h3 class=\"text-center text-azul\">Planes asociados</h3> <p class=\"text-center text-md p-h\" ng-if=\"list.workplans.length > 0\"> El criterio de <b>{{modalName}}</b> \"{{list.list_name}}\" está asociado a los siguientes planes: </p> <p class=\"text-center text-md p-h\" ng-if=\"list.workplans.length <= 0\"> El criterio de {{modalName}} \"{{list.list_name}}\" no está asociado a ningún plan. </p> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"workplan in list.workplans track by $index\" class=m-v-sm> <p class=\"text-left text-md p-l-sm\"> {{workplan.workplan_name}} <span ng-if=!checkIsInicializatedWorkPlan(workplan) class=\"badge orange pull-right pointer p-xs\">Plan iniciado</span> <i class=\"icon mdi-content-clear i-10 pull-right pointer p-xs\" ng-if=\"list.is_editable == true && checkIsInicializatedWorkPlan(workplan)\" ng-click=\"disassociate($index, workplan)\" role=button tabindex=0></i> </p> </li> </ul> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>¿Está seguro que desea eliminar la lista de criterios \"{{criteriaListName}}\"? Los planes relacionados usarán la lista de criterios por defecto</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=deleteCriteriaList(criteriaListId,categoryTypeListId)>Eliminar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>No se puede eliminar la lista de criterios \"{{criteriaListName}}\" debido a que tiene los siguientes planes de trabajo ya iniciados:</p> </div> </div> <div class=row> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"workplan in workplansInitiated track by $index\" class=m-v-sm> <p class=\"text-left text-md p-l-sm\"> {{workplan.workplan_name}} </p> </li> </ul> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Eliminaci&oacute;n existosa!</h3> <p>La lista \"{{criteriaListName}}\" ha sido eliminada satisfactoriamente</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cerrar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SpecialSituationsCtrl = function () {
		function SpecialSituationsCtrl($scope, WorkPlanParametrizationSrv, $timeout, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, GlobalSrv, GlobalConfig, $cookies, Validations) {
			_classCallCheck(this, SpecialSituationsCtrl);
	
			// CONSTANTS
			var specialSituationVM = this;
			var user = JSON.parse($cookies.get('currentUser'));
			var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
			specialSituationVM.gridApi = {};
			specialSituationVM.teachers = {};
			specialSituationVM.list = {};
			specialSituationVM.submodules = {};
			specialSituationVM.workplan = {};
			specialSituationVM.specialSituations = 0;
			specialSituationVM.situationsPercentage = 0;
			i18nService.setCurrentLang('es');
			specialSituationVM.gridSpecialSituations = {
				enableFiltering: true,
				enableRowSelection: true,
				enableRowHeaderSelection: false,
				noUnselect: true,
				multiSelect: false,
				modifierKeysToMultiSelect: false,
				columnDefs: [_defineProperty({
					name: 'Nombre de profesor',
					displayName: 'Nombre de profesor',
					field: 'teacher_name',
					width: '32%',
					headerCellClass: specialSituationVM.highlightFilteredHeader,
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					enableCellEdit: true,
					cellClass: 'text-xs'
				}, 'headerCellClass', 'font-normal text-xs'), {
					name: 'Tipo profesor',
					displayName: 'Tipo profesor',
					field: 'teacher_type',
					width: '25%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					enableCellEdit: true,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs'
				}, {
					name: 'Estado del plan',
					displayName: 'Estado del plan',
					field: 'workplan_state',
					width: '23%',
					SenableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					enableCellEdit: true,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs'
				}, {
					name: 'Acciones',
					displayName: 'Acciones',
					field: 'id_state',
					width: '20%',
					enableGridMenu: false,
					enableFiltering: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: true,
					cellClass: 'column-center text-xs text-azul proxima',
					headerCellClass: 'column-center font-normal text-xs',
					cellTemplate: __webpack_require__(227)
				}],
				selectedItem: [],
				onRegisterApi: function onRegisterApi(gridApi) {
					specialSituationVM.gridApi = gridApi;
					specialSituationVM.gridApi.grid.registerRowsProcessor(specialSituationVM.singleFilter, 200);
					$interval(function () {
						specialSituationVM.gridApi.core.handleWindowResize();
						specialSituationVM.gridApi.selection.selectRow(specialSituationVM.gridSpecialSituations.data[0]);
					}, 500, 10);
				}
			};
	
			var iconClasses = ['mdi-hardware-keyboard-arrow-down', 'mdi-hardware-keyboard-arrow-up'];
	
			// VARIABLES
			specialSituationVM.teachersFilter = '';
			specialSituationVM.class = iconClasses[0];
			specialSituationVM.dropdownMenu = false;
	
			// METHODS
			specialSituationVM.toggleChevron = toggleChevron;
			specialSituationVM.singleFilter = singleFilter;
			specialSituationVM.highlightFilteredHeader = highlightFilteredHeader;
			specialSituationVM.filter = filter;
			specialSituationVM.updateView = updateView;
			specialSituationVM.returnBack = returnBack;
	
			// MODALS
			specialSituationVM.showAddSituationModal = showAddSituationModal;
			specialSituationVM.showDetailsModal = showDetailsModal;
	
			// METHODS DEFINITIONS
			function activate() {
				return getSpecialSituationData();
			}
	
			function getSpecialSituationData() {
				var header = {};
	
				if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
					header.userId = user.id;
					header.rolId = currentRoleId;
				}
	
				return WorkPlanParametrizationSrv.getSpecialSituationData.get(header).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						specialSituationVM.teachers = dataReturn.teacher;
						specialSituationVM.list = dataReturn.list;
						specialSituationVM.submodules = dataReturn.submodules;
						specialSituationVM.gridSpecialSituations.data = specialSituationVM.teachers;
						specialSituationVM.teachers.forEach(function (teacher) {
							if (teacher.id_state === 2) {
								++specialSituationVM.specialSituations;
							}
						});
						specialSituationVM.situationsPercentage = Math.round(specialSituationVM.specialSituations / specialSituationVM.teachers.length * 100).toString();
					} else {
						console.log('communications failure with server');
						specialSituationVM.teachers = [];
						specialSituationVM.gridSpecialSituations.data = specialSituationVM.teachers;
					}
				});
			}
	
			function getTeachersDetails(teacher) {
				var header = { idTeacher: teacher.id_teacher,
					idWorkplan: teacher.id_work_plan };
	
				return WorkPlanParametrizationSrv.getTeachersDetails.get(header).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						$mdDialog.show({
							controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
								$scope.teacher = teacher;
								$scope.info = dataReturn.data[0];
								$scope.startDate = moment($scope.info.dt_start_date, 'YYYY-MM-DD').toDate();
								$scope.endDate = moment($scope.info.dt_end_date, 'YYYY-MM-DD').toDate();
								$scope.items = $scope.info.submodule.split(',');
								$scope.validateDate = function (date) {
									return isNaN(date);
								};
								$scope.close = function () {
									$mdDialog.hide();
								};
							}],
							template: __webpack_require__(228),
							clickOutsideToClose: true
						});
					}
				});
			}
	
			function returnBack() {
				window.history.back();
			}
	
			function toggleChevron() {
				if (specialSituationVM.class === iconClasses[0]) {
					specialSituationVM.class = iconClasses[1];
					specialSituationVM.dropdownMenu = true;
				} else {
					specialSituationVM.class = iconClasses[0];
					specialSituationVM.dropdownMenu = false;
				}
			}
	
			function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
				if (col.filters[0].term) {
					return 'header-filtered';
				} else {
					return '';
				}
			}
	
			function filter() {
				specialSituationVM.gridApi.grid.refresh();
			}
	
			function singleFilter(renderableRows) {
				var matcher = new RegExp(specialSituationVM.teachersFilter, 'i');
	
				renderableRows.forEach(function (row) {
					var match = false;
	
					['teacher_name', 'teacher_type', 'workplan_state'].forEach(function (field) {
						if (row.entity[field].match(matcher)) {
							match = true;
						}
					});
	
					if (!match) {
						row.visible = false;
					}
				});
	
				return renderableRows;
			}
	
			function updateView() {
				specialSituationVM.viewLoaded = false;
				$timeout(function () {
					specialSituationVM.viewLoaded = true;
				}, 1);
			}
	
			// MODAL DEFINITIONS
			function showAddSituationModal(teacher) {
				var list = specialSituationVM.list;
				var submodules = specialSituationVM.submodules;
				var updateView = specialSituationVM.updateView;
				var params = {
					workplanId: teacher.id_work_plan
				};
	
				WorkPlanParametrizationSrv.getWorkPlanHeader.get(params).$promise.then(function (dataReturn) {
					if (dataReturn.status == true) {
						specialSituationVM.workplan = dataReturn.data;
					}
	
					var workplan = specialSituationVM.workplan;
	
					$mdDialog.show({
						controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
							$scope.workplan = workplan;
							$scope.teacher = teacher;
							$scope.workplans = {};
							$scope.list = list;
							$scope.items = submodules;
							$scope.isDisabled = false;
							$scope.addingEnabled = false;
							$scope.selected = [];
							$scope.submodules = [];
							$scope.updateView = updateView;
							$scope.startDate = null;
							$scope.endDate = null;
							$scope.details = '';
							$scope.situationData = '';
							$scope.validateForm = validateForm;
							$scope.hasError = hasError;
							$scope.showErrorMessages = showErrorMessages;
							$scope.startDateChange = startDateChange;
							$scope.minStartDate = new Date(workplan.start_date);
							$scope.minEndDate = new Date(workplan.start_date);
							$scope.maxEndDate = new Date(workplan.end_date);
							var colCounter = 1;
							var colLimit = 4;
	
							angular.forEach($scope.items, function (item, index) {
								if ((index + 1) % (colLimit + 1) == 0) {
									colCounter++;
								}
	
								item.col = colCounter;
							});
	
							$scope.toggle = function (item, list) {
								var idx = list.indexOf(item);
	
								if (idx > -1) {
									list.splice(idx, 1);
									$scope.submodules.splice(idx, 1);
								} else {
									list.push(item);
									$scope.submodules.push(item.id_code);
								}
							};
	
							$scope.exists = function (item, list) {
								return list.indexOf(item) > -1;
							};
	
							$scope.isIndeterminate = function () {
								return $scope.selected.length !== 0 && $scope.selected.length !== $scope.items.length;
							};
	
							$scope.isChecked = function () {
								return $scope.selected.length === $scope.items.length;
							};
	
							$scope.toggleAll = function () {
								if ($scope.selected.length === $scope.items.length) {
									$scope.selected = [];
									$scope.submodules = [];
								} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
									$scope.selected = $scope.items.slice(0);
									$scope.submodules = $scope.items.slice(0).map(function (option) {
										return option.id_code;
									});
								}
							};
	
							$scope.close = function () {
								$mdDialog.hide();
							};
	
							function aggregateToStatistic() {
								teacher.id_state = 2;
								++specialSituationVM.specialSituations;
								specialSituationVM.situationsPercentage = Math.round(specialSituationVM.specialSituations / specialSituationVM.teachers.length * 100).toString();
							}
	
							$scope.addSituation = function () {
								var newSituation = {
									id_teacher: $scope.teacher.id_teacher,
									id_work_plan: $scope.teacher.id_work_plan,
									ds_description: $scope.details,
									dt_start_date: moment(new Date($scope.startDate)).format('YYYY-MM-DD'),
									id_list_item_situation_type: $scope.situationData.id_lists_item,
									id_teacher_type: $scope.teacher.id_teacher_type,
									id_submodule: $scope.submodules.join(','),
									id_user: user.id
								};
	
								$scope.addingEnabled = true;
	
								if ($scope.isDisabled === true) {
									newSituation.dt_end_date = '';
								} else {
									newSituation.dt_end_date = moment(new Date($scope.endDate)).format('YYYY-MM-DD');
								}
	
								WorkPlanParametrizationSrv.addSpecialSituationTeacher.set(newSituation).$promise.then(function (dataReturn) {
									if (dataReturn.status === true) {
										$scope.teacher.id_state = 2;
	
										getSendNotifyAdmin(newSituation.id_teacher, GlobalConfig.notificationType.inbox);
										getSendNotifyAdmin(newSituation.id_teacher, GlobalConfig.notificationType.email);
										getSpecialSituationNotify($scope.teacher.teacher_userId, GlobalConfig.notificationType.email);
										getSpecialSituationNotify($scope.teacher.teacher_userId, GlobalConfig.notificationType.inbox);
	
										if (newSituation.dt_end_date !== '') {
											var dateToSend = moment(newSituation.dt_end_date).subtract(1, 'days').toDate();
	
											getSendNotifyRemainderAdmin(GlobalConfig.notificationType.inbox, dateToSend);
										}
	
										aggregateToStatistic();
										$mdDialog.hide();
										showSpecialSituationAdded(teacher);
									} else {
										console.log(dataReturn);
										$scope.addingEnabled = false;
									}
								}).catch(function (error) {
									console.log(error.data);
									$scope.addingEnabled = false;
								});
							};
	
							function getSpecialSituationNotify(teacher_userId, notificationType) {
								var data = {
									idUser: teacher_userId,
									dsName: 'Notificación, situación especial',
									dsDescription: ' Profesor, se le ha creado una situación especial. Debe comunicarse con su administrador para activar su plan de trabajo',
									idNotification_delivery_type: notificationType,
									is_grouped: 0
								};
	
								GlobalSrv.sendNotification(data);
							}
	
							function getSendNotifyAdmin(teacherId, notificationType) {
								var data = {
									idTeacher: teacherId,
									dsName: 'Notificación, se agregó una situación especial',
									dsDescription: 'Se ha creado una situación especial para el profesor ' + teacher.teacher_name,
									idNotification_delivery_type: notificationType,
									is_grouped: 0
								};
	
								GlobalSrv.sendNotificationsToAdminEvaluator(data);
							}
	
							function getSendNotifyRemainderAdmin(notificationType, date) {
								var data = {
									rolesId: [GlobalConfig.userRolesIds.workPlanAdmin],
									dsName: 'Notificación, situación especial está por finalizar',
									dsDescription: 'La situación especial del profesor "' + teacher.teacher_name + '" está por finalizar por lo que debe estar pendiente de la activación de su plan de trabajo',
									idNotification_delivery_type: notificationType,
									is_grouped: 1,
									sendDate: date
								};
	
								GlobalSrv.addNotificationToAdminWorkPlan.add(data);
							}
	
							function validateForm(form) {
								return form.$invalid;
							}
	
							function hasError(input) {
								if (typeof input !== 'undefined' && input.$invalid && (input.$dirty || input.$touched)) {
									return 'has-error';
								}
							}
	
							function showErrorMessages(input) {
								return input && (input.$dirty || input.$touched);
							}
	
							function startDateChange() {
								var m = moment($scope.startDate);
	
								$scope.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null;
							}
						}],
						template: __webpack_require__(229),
						clickOutsideToClose: true
					});
				});
			}
	
			function showDetailsModal(teacher) {
				getTeachersDetails(teacher);
			}
	
			function showSpecialSituationAdded(teacher) {
				var infoAdded = teacher;
	
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
						$scope.infoAdded = infoAdded;
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(230),
					clickOutsideToClose: true
				});
			}
	
			// INITIALIZATION
			activate();
		} //FIN DEL CONSTRUCTOR
	
	
		_createClass(SpecialSituationsCtrl, [{
			key: 'preventInput',
			value: function preventInput(event) {
				var vKey = 86;
	
				if (event.keyCode == vKey) event.preventDefault();
	
				return;
			}
		}]);
	
		return SpecialSituationsCtrl;
	}();
	
	exports.default = SpecialSituationsCtrl;
	
	
	SpecialSituationsCtrl.$inject = ['$scope', 'WorkPlanParametrizationSrv', '$timeout', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', 'GlobalSrv', 'GlobalConfig', '$cookies', 'Validations'];

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.id_state !== 1\"> <a class=text-center style=opacity:.85;text-decoration:underline ng-click=grid.appScope.specialSituationVM.showDetailsModal(row.entity)> Ver detalles </a> </div> <div ng-if=\"row.entity.id_state === 1\"> <md-button has-permission=situaciones-especiales-edit class=\"btn btn-success text-xs grid-btn\" ng-click=grid.appScope.specialSituationVM.showAddSituationModal(row.entity)> Agregar situación </md-button> </div> </div>";

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=50> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=close ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-azul>Detalle situación especial</h3> </div> </div> <div class=row> <div class=\"col-md-4 text-left\"> <label class=\"font-bold text-xs exo col-md-12 text-left no-padding\">Nombre profesor</label> <p class=\"text-azul text-sm\">{{teacher.teacher_name}}</p> </div> <div class=\"col-md-4 text-left\"> <label class=\"font-bold text-xs exo col-md-12 text-left no-padding\">Tipo de situacion especial</label> <p class=\"text-azul text-sm\">{{info.item_name}}</p> </div> <div class=\"col-md-4 text-left\"> <label class=\"font-bold text-xs exo col-md-12 text-left no-padding\">Rango estimado de tiempo</label> <p class=\"text-azul text-sm col-md-12 no-padding m-b-xs\">Fecha inicio: {{startDate | date:'dd/MM/yyyy'}}</p> <p class=\"text-azul text-sm col-md-12 no-padding\" ng-show=!validateDate(endDate)>Fecha fin: {{endDate | date:'dd/MM/yyyy'}}</p> </div> </div> <div class=row> <div class=\"col-md-5 text-left p-t-sm\"> <label class=\"font-bold text-xs exo col-md-12 text-left no-padding m-b-sm\" for=start_date>Actividades bloqueadas</label> <div class=\"col-md-12 no-padding\" ng-repeat=\"item in items\"> <md-checkbox class=\"md-green text-sm m-b-sm\" ng-checked=true disabled=disabled> {{ item }} </md-checkbox> </div> </div> <div class=\"col-md-7 text-left p-t-sm\"> <label class=\"font-bold text-xs exo col-md-12 text-left no-padding m-b-sm\">Detalle de la situación especial</label> <p class=text-base>{{info.ds_description}}</p> </div> </div> <div class=\"row text-center\"> <div class=\"col-md-12 m-t-md\"> <md-button class=\"btn btn-fw btn-primary no-margin\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-azul>Agregar situación especial</h3> <p class=proxima>Configure los siguientes par&aacute;metros para agregar una situación especial a un profesor.</p> </div> </div> <form name=specialSituationForm novalidate> <div class=row> <div class=\"col-md-2 text-left no-padding\"> <label class=\"control-label font-bold text-xs exo col-md-12 text-left no-padding\">Nombre del profesor</label> <p class=\"p-v-xs text-azul text-sm font-normal\">{{teacher.teacher_name}}</p> </div> <div class=\"form-group col-md-4 text-left no-padding\" ng-class=hasError(specialSituationForm.situationData)> <label class=\"control-label font-bold text-xs exo col-md-12 text-left no-padding\" for=situationData>Tipo de situación especial</label> <select class=form-control name=situationData placeholder=Seleccione ng-model=situationData ng-options=\"situation.lists_item_name for situation in list\" name=situationData required> <option value=\"\" selected=selected>Seleccione</option> </select> <div class=control-label ng-messages=specialSituationForm.situationData.$error ng-show=showErrorMessages(specialSituationForm.situationData)> <div ng-message=required>El tipo de situación especial es requerio</div> </div> </div> <div class=col-md-6> <div class=\"col-md-12 text-left m-t-sm\"> <div class=row> <label class=\"font-bold text-xs exo col-md-12 text-left no-padding\">Rango estimado de tiempo</label> </div> <div class=row> <div class=col-md-6 ng-class=hasError(specialSituationForm.startDate)> <md-datepicker ng-model=startDate name=startDate md-placeholder=dd/mm/aaaa ng-change=startDateChange() required> </md-datepicker> <div class=\"control-label text-xs\" ng-messages=specialSituationForm.startDate.$error role=alert ng-show=showErrorMessages(specialSituationForm.startDate) multiple=multiple> <div ng-message=required class=\"my-message font-color: @danger\">Debe completar la fecha de inicio</div> </div> </div> <div class=col-md-6 ng-class=hasError(specialSituationForm.endDate) ng-if=!isDisabled> <md-datepicker ng-model=$parent.endDate name=endDate md-placeholder=dd/mm/aaaa md-min-date=minEndDate min={{minEndDate}} ng-change=startDateChange() required> </md-datepicker> <div class=\"control-label text-xs\" ng-messages=specialSituationForm.endDate.$error role=alert ng-show=showErrorMessages(specialSituationForm.endDate) multiple=multiple> <div ng-message=required class=\"my-message font-color: @danger\">Debe completar la fecha de fin</div> </div> </div> </div> </div> <div class=\"col-md-12 text-left m-t-sm\"> <md-checkbox class=\"md-green text-sm\" type=checkbox ng-model=isDisabled> Sólo fecha de inicio </md-checkbox> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6 text-left no-padding\"> <label class=\"control-label font-bold text-xs exo col-md-12 text-left no-padding m-b-sm\" for=start_date>Seleccione actividades que desea bloquear</label> <md-checkbox class=\"md-green m-v-xs text-xs proxima font-normal col-md-6 no-padding\" aria-label=\"Select All\" ng-checked=isChecked() md-indeterminate=isIndeterminate() ng-click=toggleAll()> Todas </md-checkbox> <div class=\"col-md-6 no-padding m-v-xs\" ng-repeat=\"item in items | filter: { col: 1 }\"> <md-checkbox class=\"md-green no-margin text-xs proxima font-normal\" ng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected)\"> {{ item.ds_name }} </md-checkbox> </div> <div class=\"col-md-6 no-padding m-v-xs\" ng-repeat=\"item in items | filter: { col: 2 }\"> <md-checkbox class=\"md-green no-margin text-xs proxima font-normal\" ng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected)\"> {{ item.ds_name }} </md-checkbox> </div> </div> <div class=\"form-group col-md-6\"> <div class=form-group ng-class=hasError(specialSituationForm.description)> <label class=\"control-label font-bold text-xs exo col-md-12 text-left no-padding\" for=description>Ingrese un detalle de la situación especial</label> <md-input-container class=control-label> <textarea class=form-control id=description maxlength=155 md-maxlength=155 ng-model-options=\"{ debounce: 300 }\" ng-model=details name=description required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-8 no-padding text-left\"> <div class=control-label ng-messages=specialSituationForm.description.$error ng-show=showErrorMessages(specialSituationForm.description)> <div ng-message=required>El detalle es requerido</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </form> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-disabled=\"(validateForm(specialSituationForm) || selected.length === 0) || addingEnabled\" ng-click=addSituation() has-permission=situaciones-especiales-edit>Agregar situación</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creación exitosa!</h3> <p>La situación especial para el profesor \"{{infoAdded.teacher_name}}\" se ha guardado con éxito</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActivateWorkPlanCtrl = function () {
	  function ActivateWorkPlanCtrl($scope, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, $cookies, Validations) {
	    _classCallCheck(this, ActivateWorkPlanCtrl);
	
	    // CONSTANTS
	    var activateWorkPlanVM = this;
	    i18nService.setCurrentLang('es');
	    activateWorkPlanVM.gridActivateWorkPlan = {
	      enableFiltering: true,
	      columnDefs: [_defineProperty({
	        name: 'Nombre de profesor',
	        displayName: 'Nombre de profesor',
	        field: 'teacher_name',
	        width: '25%',
	        headerCellClass: activateWorkPlanVM.highlightFilteredHeader,
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs'
	      }, 'headerCellClass', 'font-normal text-xs'), {
	        name: 'Tipo profesor',
	        displayName: 'Tipo profesor',
	        field: 'teacher_type',
	        width: '25%',
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs',
	        headerCellClass: 'font-normal text-xs'
	      }, {
	        name: 'Unidad académica',
	        displayName: 'Unidad académica',
	        field: 'academic_unit_name',
	        width: '20%',
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs',
	        headerCellClass: 'font-normal text-xs'
	      }, {
	        name: 'Motivo de bloqueo',
	        displayName: 'Motivo de bloqueo',
	        field: 'reason',
	        width: '15%',
	        enableGridMenu: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'text-xs',
	        headerCellClass: 'font-normal text-xs'
	      }, {
	        name: 'Acciones',
	        displayName: 'Acciones',
	        field: 'id_state',
	        width: '15%',
	        enableGridMenu: false,
	        enableFiltering: false,
	        enableHiding: false,
	        enablePinning: false,
	        enableColumnMenu: false,
	        enableSorting: false,
	        cellClass: 'column-center text-xs p-xs cell-button',
	        headerCellClass: 'font-normal text-xs column-center',
	        cellTemplate: __webpack_require__(232)
	      }],
	      onRegisterApi: function onRegisterApi(gridApi) {
	        activateWorkPlanVM.gridApi = gridApi;
	        activateWorkPlanVM.gridApi.grid.registerRowsProcessor(activateWorkPlanVM.singleFilter, 200);
	        $interval(function () {
	          activateWorkPlanVM.gridApi.core.handleWindowResize();
	        }, 500, 10);
	      }
	
	      // VARIABLES
	    };activateWorkPlanVM.activateWorkPlanFilter = '';
	    var user = JSON.parse($cookies.get('currentUser'));
	    var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
	    // METHODS
	    activateWorkPlanVM.singleFilter = singleFilter;
	    activateWorkPlanVM.filter = filter;
	    activateWorkPlanVM.returnBack = returnBack;
	
	    // MODALS
	    activateWorkPlanVM.activateModal = activateModal;
	
	    // METHODS DEFINITIONS
	    function activate() {
	      return getTeacherStateList();
	    }
	
	    function getTeacherStateList() {
	      var header = {};
	      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
	        header.userId = user.id;
	        header.rolId = currentRoleId;
	      }
	      return WorkPlanParametrizationSrv.getTeacherStateList.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status === true) {
	          activateWorkPlanVM.gridActivateWorkPlan.data = dataReturn.data;
	        } else {
	          activateWorkPlanVM.gridActivateWorkPlan.data = [];
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	
	    function filter() {
	      activateWorkPlanVM.gridApi.grid.refresh();
	    }
	    function returnBack() {
	      window.history.back();
	    }
	
	    function singleFilter(renderableRows) {
	      var matcher = new RegExp(activateWorkPlanVM.activateWorkPlanFilter, 'i');
	      renderableRows.forEach(function (row) {
	        var match = false;
	        ['teacher_name', 'teacher_type', 'academic_unit_name', 'reason'].forEach(function (field) {
	          if (row.entity[field].match(matcher)) {
	            match = true;
	          }
	        });
	        if (!match) {
	          row.visible = false;
	        }
	      });
	      return renderableRows;
	    }
	
	    // MODAL DEFINITIONS
	    function activateModal(teacher) {
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', '$state', function ($scope, $mdDialog, $state) {
	          if (teacher.id_state !== 3) {
	            $scope.modalHeader = 'Reactivar';
	          } else {
	            $scope.modalHeader = 'Activar';
	          }
	
	          $scope.workplans = [];
	          $scope.workplan = {};
	          $scope.workplanSelected = null;
	          $scope.workplan.ds_comments = '';
	          $scope.submodulesSelected = [];
	          $scope.selectAllSubmodules = {
	            value1: true,
	            value2: false
	          };
	          $scope.workplan.dt_limit_for_planning = null;
	          $scope.workplan.dt_limit_for_approval = null;
	
	          $scope.minStarDateApproval = moment().toDate();
	          $scope.minStartDatePlanning = moment().toDate();
	
	          $scope.workplan.id_teacher = teacher.teacher_code;
	          $scope.workplan.teacher_name = teacher.teacher_name;
	          $scope.workplan.teacher_type = teacher.teacher_type;
	          $scope.workplan.id_teacher_type = teacher.id_teacher_type;
	          $scope.workplan.academic_unit = teacher.academic_unit_name;
	          $scope.workplan.id_academic_unit = teacher.id_academic_unit;
	
	          function activate() {
	            return getModalData();
	          }
	
	          function getModalData() {
	            return WorkPlanParametrizationSrv.getTeacherSubmoduleList.get({ idTeacher: teacher.teacher_code }).$promise.then(function (dataReturn) {
	              if (dataReturn.status === true) {
	                $scope.workplans = getWorkplans(dataReturn.data);
	              } else {
	                $scope.workplans = [];
	              }
	            });
	          }
	
	          function getWorkplans(data) {
	            var result = [];
	            data.forEach(function (professor) {
	              var temp = {
	                id_work_plan: professor.id_work_plan,
	                workplan_name: professor.workplan_name,
	                submodules: processSubmoduleInfo(professor.id_submodule.split(','), professor.submodule.split(',')),
	                startdate: new Date(professor.startdate),
	                enddate: new Date(professor.enddate)
	              };
	              result.push(temp);
	            });
	            return result;
	          }
	
	          function processSubmoduleInfo(submoduleIds, submodules) {
	            var result = [];
	            for (var i in submodules) {
	              var temp = {
	                submodule_id: submoduleIds[i],
	                submodule_name: submodules[i]
	              };
	              result.push(temp);
	            }
	            return result;
	          }
	
	          function processSubmodulesSelected() {
	            var ids = [];
	            var submoduleNames = [];
	            $scope.submodulesSelected.forEach(function (submodule) {
	              for (var subm in $scope.submodules) {
	                if ($scope.submodules[subm].submodule_id == submodule.submodule_id) {
	                  ids.push($scope.submodules[subm].submodule_id);
	                  submoduleNames.push($scope.submodules[subm].submodule_name);
	                  break;
	                }
	              }
	            });
	            $scope.workplan.id_submodule = ids.toString();
	            $scope.workplan.submodule = submoduleNames.toString();
	          }
	
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	
	          $scope.onWorkplanSelected = function (workplan) {
	            if (workplan) {
	              for (var wp in $scope.workplans) {
	                if ($scope.workplans[wp].id_work_plan == workplan.id_work_plan) {
	                  $scope.workplan.id_work_plan = workplan.id_work_plan;
	                  $scope.workplan.workplan_name = workplan.workplan_name;
	                  $scope.submodules = $scope.workplans[wp].submodules;
	                  $scope.workplan.startdate = workplan.startdate;
	                  $scope.workplan.enddate = workplan.enddate;
	                  break;
	                }
	              }
	
	              if ($scope.workplan.startdate < moment().toDate()) {
	                $scope.workplan.startdate = moment().toDate();
	              }
	            } else {
	              $scope.submodules = null;
	              $scope.submodulesSelected = [];
	            }
	          };
	
	          $scope.activateOrReactivate = function () {
	            processSubmodulesSelected();
	            $scope.workplan.dt_limit_for_approval = moment($scope.workplan.dt_limit_for_approval).format('YYYY-MM-DD');
	            $scope.workplan.dt_limit_for_planning = moment($scope.workplan.dt_limit_for_planning).format('YYYY-MM-DD');
	            $scope.workplan.startdate = moment($scope.workplan.startdate).format('YYYY-MM-DD');
	            $scope.workplan.enddate = moment($scope.workplan.enddate).format('YYYY-MM-DD');
	            WorkPlanParametrizationSrv.activateWpSubmoduleTeacher.set($scope.workplan).$promise.then(function (dataReturn) {
	              if (dataReturn.status === true) {
	                $state.reload();
	                $mdDialog.hide();
	                showModalSuccess();
	              } else {
	                console.log('ERROR');
	              }
	            });
	          };
	
	          $scope.onSelectAllSubmodules = function (selected) {
	            for (var subm in $scope.submodules) {
	              $scope.submodulesSelected[subm] = {};
	              if (selected.value2 === true) {
	                $scope.submodulesSelected[subm].submodule_id = parseInt($scope.submodules[subm].submodule_id);
	              } else {
	                $scope.submodulesSelected[subm].submodule_id = false;
	              }
	            }
	          };
	
	          $scope.onSubmoduleSelected = function (submodule) {
	            if (!submodule.submodule_id) {
	              $scope.selectAllSubmodules.value2 = false;
	            }
	            var todosCheck = true;
	            for (var subm in $scope.submodules) {
	              if ($scope.submodulesSelected[subm].submodule_id === false) {
	                todosCheck = false;
	              }
	            }
	            if (todosCheck === true) {
	              $scope.selectAllSubmodules.value2 = true;
	            }
	          };
	
	          $scope.planningDateChanged = function () {
	            var m = moment($scope.workplan.dt_limit_for_planning);
	            $scope.minStarDateApproval = m.isValid() ? m.add(1, 'days').toDate() : null;
	          };
	
	          $scope.submodulesSelectedEmpty = function () {
	            var len = $scope.submodulesSelected.length;
	            if (len === 0) return true;
	
	            for (var i = 0; i < len; i++) {
	              if ($scope.submodulesSelected[i] && $scope.submodulesSelected[i].submodule_id) return false;
	            }
	            return true;
	          };
	
	          $scope.hasError = function (input) {
	            if (input.$invalid && (input.$dirty || input.$touched)) {
	              return 'has-error';
	            }
	          };
	
	          $scope.showErrorMessages = function (input) {
	            if (input !== undefined) {
	              return input.$dirty || input.$touched;
	            } else {
	              return false;
	            }
	          };
	
	          activate();
	        }],
	        template: __webpack_require__(233),
	        clickOutsideToClose: false
	      });
	    }
	
	    function showModalSuccess() {
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	          var ctrlModal = this;
	
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	        }],
	        controllerAs: 'ctrlModal',
	        template: __webpack_require__(234),
	        clickOutsideToClose: false
	      });
	    }
	
	    // INITIALIZATION
	    activate();
	  } // FIN DEL CONStRUCTOR
	
	
	  _createClass(ActivateWorkPlanCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return ActivateWorkPlanCtrl;
	}();
	
	exports.default = ActivateWorkPlanCtrl;
	
	
	ActivateWorkPlanCtrl.$inject = ['$scope', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$cookies', 'Validations'];

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.id_state == 3\"> <md-button has-permission=activar-plan-de-trabajo-edit aria-label=activate class=\"btn-success grid-btn\" ng-click=grid.appScope.activateWorkPlanVM.activateModal(row.entity)> Activar </md-button> </div> <div ng-if=\"row.entity.id_state != 3\"> <md-button has-permission=activar-plan-de-trabajo-edit aria-label=reactivate class=\"btn-primary grid-btn\" ng-click=grid.appScope.activateWorkPlanVM.activateModal(row.entity)> Reactivar </md-button> </div> </div> ";

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close() aria-label=cerrar> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-azul>{{modalHeader}} plan de trabajo</h3> <p class=proxima>Configure los siguientes parámetros para reactivar el plan de trabajo.</p> </div> </div> <div class=row> <div class=\"col-md-4 text-left\"> <p class=\"p-v-xs exo text-xs font-bold\">Nombre del profesor<span class=\"text-azul p-l proxima text-sm font-normal\">{{workplan.teacher_name}}</span></p> </div> <div class=\"col-md-4 text-left\"> <p class=\"p-v-xs exo text-xs font-bold\">Unidad académica<span class=\"text-azul p-l proxima text-sm font-normal\">{{workplan.academic_unit}}</span></p> </div> <div class=\"col-md-4 text-left\"> <p class=\"p-v-xs exo text-xs font-bold\">Categoría<span class=\"text-azul p-l proxima text-sm font-normal\">{{workplan.teacher_type}}</span></p> </div> </div> <form name=activeWorkPlanForm novalidate> <div class=row> <div class=\"col-md-6 text-left\"> <div class=form-group ng-class=hasError(activeWorkPlanForm.workplan)> <label class=\"control-label text-xs font-bold\" for=workplan>Seleccione el plan de trabajo</label> <select ng-model=workplanSelected name=workplan ng-options=\"obj.workplan_name for obj in workplans track by obj.id_work_plan\" class=form-control ng-change=onWorkplanSelected(workplanSelected) required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-xs\" ng-messages=activeWorkPlanForm.workplan.$error ng-show=showErrorMessages(activeWorkPlanForm.workplan)> <div ng-message=required>El plan es requerido</div> </div> </div> </div> <div class=\"col-md-6 text-left\"> <div class=col-md-6> <div class=form-group ng-class=hasError(activeWorkPlanForm.dt_limit_for_planning)> <label class=\"control-label text-xs font-bold\" for=dt_limit_for_planning>Fecha límite para planear plan de trabajo</label> <md-datepicker ng-model=workplan.dt_limit_for_planning md-min-date=workplan.startdate min=\"{{workplan.startdate | date: 'dd/MM/yyyy'}}\" max=\"{{workplan.enddate | date: 'dd/MM/yyyy'}}\" md-max-date=workplan.enddate name=dt_limit_for_planning ng-keydown=activeWorkPlanForm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa ng-disabled=!workplanSelected required> </md-datepicker> <div class=\"control-label text-xs\" ng-messages=activeWorkPlanForm.dt_limit_for_planning.$error ng-show=showErrorMessages(activeWorkPlanForm.dt_limit_for_planning)> <div ng-message=required>La fecha es requerida</div> <div ng-message=valid>El formato de la fecha es inválido</div> <div ng-message=mindate>La fecha debe ser mayor a la fecha actual y/o de inicio del plan de trabajo</div> <div ng-message=maxdate>La fecha debe ser menor a la fecha fin del plan de trabajo</div> </div> </div> </div> <div class=col-md-6> <div class=form-group ng-class=hasError(activeWorkPlanForm.dt_limit_for_approval)> <label class=\"control-label text-xs font-bold\" for=dt_limit_for_approval>Fecha límite para aprobación de plan de trabajo</label> <md-datepicker ng-model=workplan.dt_limit_for_approval md-min-date=workplan.startdate min=\"{{workplan.startdate | date: 'dd/MM/yyyy'}}\" max=\"{{workplan.enddate | date: 'dd/MM/yyyy'}}\" md-max-date=workplan.enddate name=dt_limit_for_approval md-placeholder=dd/mm/aaaa ng-keydown=activeWorkPlanForm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-disabled=!workplanSelected required> </md-datepicker> <div class=\"control-label text-xs\" ng-messages=activeWorkPlanForm.dt_limit_for_approval.$error ng-show=showErrorMessages(activeWorkPlanForm.dt_limit_for_approval)> <div ng-message=required>La fecha es requerida</div> <div ng-message=valid>El formato de la fecha es inválido</div> <div ng-message=mindate>La fecha debe ser mayor a la fecha límite para aprobación y/o de inicio del plan de trabajo</div> <div ng-message=maxdate>La fecha debe ser menor a la fecha fin del plan de trabajo</div> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"row no-padding\"> <div class=\"col-md-12 text-left no-padding-l\"> <label class=\"text-xs font-bold\" ng-if=submodules>Reactivar las siguientes actividades</label> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-12 content-activities no-padding-l\"> <div class=\"inline-activity m-v-xs\"> <md-checkbox ng-model=selectAllSubmodules.value2 ng-if=submodules ng-checked=true ng-disabled=true class=\"md-green no-margin\" aria-label=submodule ng-true-value=true ng-false-value=true ng-change=onSelectAllSubmodules(selectAllSubmodules)></md-checkbox> <label ng-if=submodules class=\"proxima text-sm no-margin\">Todas</label> </div> <div ng-if=submodules ng-repeat=\"submodule in submodules\" ng-checked=true class=\"inline-activity m-v-xs\"> <md-checkbox ng-model=submodulesSelected[$index].submodule_id class=\"md-green no-margin\" aria-label=submodule ng-true-value={{submodule.submodule_id}} ng-change=onSubmoduleSelected(submodulesSelected[$index]) ng-disabled=true></md-checkbox> <label class=\"proxima text-sm no-margin\">{{ submodule.submodule_name }}</label> </div> </div> </div> </div> <div class=\"col-md-6 text-left\"> <div class=form-group ng-class=hasError(activeWorkPlanForm.comment)> <label class=\"control-label text-xs font-bold col-md-12\" for=comment>Comentario</label> <md-input-container class=control-label> <textarea ng-model=workplan.ds_comments name=comment class=\"col-md-12 no-padding m-h\" md-maxlength=500 maxlength=500 ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=col-md-10> <div class=\"col-md-8 no-padding\"> <div class=\"control-label text-xs\" ng-messages=activeWorkPlanForm.comment.$error ng-show=showErrorMessages(activeWorkPlanForm.comment)> <div ng-message=required>El comentario es requerido</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=\"row text-center\"> <div class=\"col-md-12 m-t-md\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-primary no-margin\" ng-disabled=\"activeWorkPlanForm.$invalid || submodulesSelectedEmpty()\" ng-click=activateOrReactivate()>{{modalHeader}}</md-button> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <div ng-if=\"row.entity.id_state == 3\"> <h3 class=text-verde>¡Activación exitosa!</h3> <p>El plan se ha activado con éxito</p> </div> <div ng-if=\"row.entity.id_state != 3\"> <h3 class=text-verde>¡Reactivación exitosa!</h3> <p>El plan se ha reactivado con éxito</p> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close() ui-sref=workPlanParametrization.activateWorkPlan>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SetupTeacherActivitiesCtrl = function SetupTeacherActivitiesCtrl($scope, $resource, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $timeout, $cookies) {
	  _classCallCheck(this, SetupTeacherActivitiesCtrl);
	
	  // CONSTANTS
	  var setupTeacherTypeModulesVM = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  setupTeacherTypeModulesVM.workplan = {};
	  setupTeacherTypeModulesVM.submodules = [{ ds_name: 'Perfil', id_code: 0, id_submodule: 'isprofile', hasPermission: "modulo-perfil-edit" }, { ds_name: 'Portafolio', id_code: 1, id_submodule: 'isPortfolio', hasPermission: "modulo-portafolio-edit" }];
	  console.log(setupTeacherTypeModulesVM.submodules);
	  // VARIABLES
	  setupTeacherTypeModulesVM.teachertype = [];
	  setupTeacherTypeModulesVM.teacherCategories = [];
	  setupTeacherTypeModulesVM.isButtonDisabled = false;
	  // METHODS
	  setupTeacherTypeModulesVM.checkDoWorkplan = checkDoWorkplan;
	  setupTeacherTypeModulesVM.toggleSubcategories = toggleSubcategories;
	  setupTeacherTypeModulesVM.saveTeacherActivities = saveTeacherActivities;
	  setupTeacherTypeModulesVM.categorySubmodule = {};
	  setupTeacherTypeModulesVM.blockCheckboxes = true;
	
	  function activate() {
	    return getAllTeachersActivities();
	  }
	
	  // SERVICES METHODS
	
	  function getWorkPlanHeader(header) {
	    return WorkPlanParametrizationSrv.getWorkPlanHeader.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        setupTeacherTypeModulesVM.workplan = dataReturn.data;
	        setupTeacherTypeModulesVM.workplan.id_code = $stateParams.workPlanId;
	      }
	    });
	  }
	
	  function saveTeacherActivities() {
	    setupTeacherTypeModulesVM.information = processActivitiesInformation();
	    setupTeacherTypeModulesVM.isButtonDisabled = true;
	    var header = {
	      modules: setupTeacherTypeModulesVM.information
	    };
	    WorkPlanParametrizationSrv.addRelationTeachertypeModules.add(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        showModalActivitesSetedUp();
	        setupTeacherTypeModulesVM.isButtonDisabled = false;
	      } else {
	        showModalActivitesSetedUpError(dataReturn.message);
	        setupTeacherTypeModulesVM.isButtonDisabled = true;
	      }
	    });
	  }
	
	  // MODAL DEFINITIONS
	  function showModalActivitesSetedUp() {
	    var planName = setupTeacherTypeModulesVM.workplan.plan_name;
	    var workPlanId = $stateParams.workPlanId;
	    var workPlanIdCloned = $stateParams.workPlanIdCloned;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.planName = planName;
	        $scope.workPlanId = workPlanId;
	        $scope.workPlanIdCloned = workPlanIdCloned;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(236),
	      clickOutsideToClose: false
	    });
	  };
	
	  function showModalActivitesSetedUpError(message) {
	    var errorMessage = message;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.errorMessage = errorMessage;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(237),
	      clickOutsideToClose: false
	    });
	  }
	
	  // METHODS
	  function processActivitiesInformation() {
	    var result = [];
	    setupTeacherTypeModulesVM.teachertype.forEach(function (teacherType) {
	      var professorType = {};
	      if (teacherType) {
	        if (teacherType[0] != false || teacherType[1] != false) {
	          professorType['isProfile'] = teacherType[0] != false ? 1 : 0;
	          professorType['isPortfolio'] = teacherType[1] != false ? 1 : 0;
	          professorType['teacherTypeId'] = teacherType[0] != false ? teacherType[0] : teacherType[1];
	          result.push(professorType);
	        }
	      }
	    });
	    return result;
	  }
	
	  function checkDoWorkplan(subModuleId, teachertype) {
	    if (setupTeacherTypeModulesVM.teachertype[teachertype]) {
	      var isChecked = setupTeacherTypeModulesVM.teachertype[teachertype][subModuleId];
	      if (isChecked) {
	        var object = isTeacherTypeChild(teachertype);
	        if (object) {
	          enableParentModuleForTeacher(subModuleId, teachertype, object);
	        } else {
	          enableChildModulesForTeacher(subModuleId, teachertype);
	        }
	      } else {
	        disableChildModulesForTeacher(subModuleId, teachertype);
	      }
	    }
	
	    // validaciones del formulario
	    if (isEmptyTeachertype() || !isActivitySelected()) setupTeacherTypeModulesVM.isButtonDisabled = true;else setupTeacherTypeModulesVM.isButtonDisabled = false;
	
	    //setupVM.categorySubmodule
	    var count = {},
	        count1 = {};
	    for (var i in setupTeacherTypeModulesVM.categorySubmodule) {
	
	      if (setupTeacherTypeModulesVM.categorySubmodule[i] != false) {
	        var parent_id = i;
	
	        for (var k1 in setupTeacherTypeModulesVM.teachertype[parent_id]) {
	          if (setupTeacherTypeModulesVM.teachertype[parent_id][k1] != false) {
	            if (typeof count1[parent_id] === 'undefined') {
	              count1[parent_id] = {};
	            }
	            count1[parent_id] = setupTeacherTypeModulesVM.teachertype[parent_id];
	          }
	        }
	
	        if (typeof count1[parent_id] !== 'undefined') {
	          count1[parent_id] = {};
	          for (var j in setupTeacherTypeModulesVM.categorySubmodule[i]) {
	            var id_code = setupTeacherTypeModulesVM.categorySubmodule[i][j].id_code;
	            for (var k in setupTeacherTypeModulesVM.teachertype[id_code]) {
	              if (setupTeacherTypeModulesVM.teachertype[id_code][k] != false) {
	                if (typeof count1[parent_id][id_code] === 'undefined') {
	                  count1[parent_id][j] = {};
	                }
	                count1[parent_id][id_code] = setupTeacherTypeModulesVM.categorySubmodule[i][j];
	              }
	            }
	          }
	        }
	      }
	    }
	
	    for (var t in count1) {
	      var size = Object.keys(count1[t]).length;
	      if (size <= 0) {
	        setupTeacherTypeModulesVM.isButtonDisabled = true;
	      }
	    }
	  }
	
	  function isEnableAllChilds(teachertype, subModuleId) {
	    var cant = 0;
	    var row = {};
	
	    setupTeacherTypeModulesVM.teacherCategories.forEach(function (parent) {
	
	      if (setupTeacherTypeModulesVM.teacherCategories.find(function (object) {
	        return object.id_code === teachertype;
	      })) {
	        row = setupTeacherTypeModulesVM.teacherCategories.find(function (object) {
	          return object.id_code === teachertype;
	        });
	        isParentDisable = true;
	      } else if (parent.childs.find(function (object) {
	        return object.id_code == teachertype;
	      })) {
	        row = parent;
	      }
	    });
	
	    row.childs.forEach(function (child) {
	      cant += setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId] != false ? 1 : 0;
	    });
	
	    if (row.childs.length == cant) return true;else return false;
	  }
	
	  function enableParentModuleForTeacher(subModuleId, teachertype, object) {
	    if (object) {
	      if (isEnableAllChilds(teachertype, subModuleId)) enable(object, subModuleId);
	    } else {
	      if (setupTeacherTypeModulesVM.teachertype[teachertype][subModuleId]) {
	        var _object = isTeacherTypeChild(teachertype);
	        if (_object) {
	          if (isEnableAllChilds(teachertype, subModuleId)) enable(_object, subModuleId);
	        }
	      }
	    }
	  }
	
	  function enable(object, subModuleId) {
	    var parent = object.parent;
	    setupTeacherTypeModulesVM.teachertype[parent.id_code][subModuleId] = parent.id_code;
	  }
	
	  function isTeacherTypeChild(teachertype) {
	    var result = false;
	    setupTeacherTypeModulesVM.teacherCategories.forEach(function (object) {
	      if (object.childs && object.childs.length > 0) {
	        var isChild = object.childs.find(function (child) {
	          return child.id_code === teachertype;
	        });
	        if (isChild) {
	          result = {
	            parent: object,
	            child: isChild
	          };
	          return;
	        }
	      }
	    });
	    return result;
	  }
	
	  function disableChildModulesForTeacher(subModuleId, teachertype) {
	
	    var row = {};
	    var isParentDisable = false;
	
	    setupTeacherTypeModulesVM.teacherCategories.forEach(function (parent) {
	
	      if (setupTeacherTypeModulesVM.teacherCategories.find(function (object) {
	        return object.id_code === teachertype;
	      })) {
	        row = setupTeacherTypeModulesVM.teacherCategories.find(function (object) {
	          return object.id_code === teachertype;
	        });
	        isParentDisable = true;
	      } else if (parent.childs.find(function (object) {
	        return object.id_code == teachertype;
	      })) {
	        row = parent;
	      }
	    });
	
	    if (row && row.childs && row.childs.length > 0) {
	      var isParentCheckActive = setupTeacherTypeModulesVM.teachertype[row.id_code][subModuleId];
	
	      row.childs.forEach(function (child) {
	        if (!isParentCheckActive && isParentDisable) {
	          setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId] = false;
	        } else setupTeacherTypeModulesVM.teachertype[row.id_code][subModuleId] = false;
	        checkDisableModuleForTeacher(subModuleId, child.id_code);
	      });
	
	      setupTeacherTypeModulesVM.teachertype[teachertype][subModuleId] = false;
	    }
	  }
	
	  function enableChildModulesForTeacher(subModuleId, teachertype) {
	    var row = setupTeacherTypeModulesVM.teacherCategories.find(function (object) {
	      return object.id_code === teachertype;
	    });
	    if (row && row.childs && row.childs.length > 0) {
	      row.childs.forEach(function (child) {
	        setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId] = child.id_code;
	      });
	    }
	  }
	
	  function isEmptyTeachertype() {
	    var arr = processActivitiesInformation();
	    return arr.length === 0;
	  }
	
	  function toggleModulesForTeacher(teachertype, value) {
	    for (var association in setupTeacherTypeModulesVM.teachertype[teachertype]) {
	      setupTeacherTypeModulesVM.teachertype[teachertype][association] = value;
	    }
	  }
	
	  function enableModulesForTeacher(subModuleId, teachertype) {
	    for (var association in setupTeacherTypeModulesVM.teachertype[teachertype]) {
	      setupTeacherTypeModulesVM.teachertype[teachertype]['1'] = teachertype; // todo change this to match a variable
	    }
	  }
	
	  function setAllProfessorChecked(check) {
	    var result = [];
	    result[0] = null;
	    var index = 1;
	    setupTeacherTypeModulesVM.teacherCategories.forEach(function (teacherType) {
	      if (teacherType) {
	        result[index] = {};
	        setupTeacherTypeModulesVM.submodules.forEach(function (module) {
	          if (check) result[index][module.id_code] = index;else result[index][module.id_code] = false;
	        });
	        if (teacherType.childs.length > 0) {
	          teacherType.childs.forEach(function (child) {
	            if (child) {
	              index = index + 1;
	              result[index] = {};
	              setupTeacherTypeModulesVM.submodules.forEach(function (module) {
	                if (check) result[index][module.id_code] = index;else result[index][module.id_code] = false;
	              });
	            }
	          });
	        }
	      }
	      index = index + 1;
	    });
	    return result;
	  }
	
	  function setWorkplanAlreadyChecked(teacherSubmoduleRelation) {
	    teacherSubmoduleRelation.forEach(function (relation) {
	      if (setupTeacherTypeModulesVM.teachertype[relation.teacherTypeId]) {
	        if (relation.isprofile) setupTeacherTypeModulesVM.teachertype[relation.teacherTypeId][0] = relation.teacherTypeId;
	        if (relation.isPortfolio) setupTeacherTypeModulesVM.teachertype[relation.teacherTypeId][1] = relation.teacherTypeId;
	      }
	    });
	  }
	
	  function toggleSubcategories(category) {
	    if (category.showChilds) {
	      category.showChilds = false;
	    } else {
	      category.showChilds = true;
	    }
	  }
	
	  function isActivitySelected() {
	    var BreakException = {};
	    try {
	      setupTeacherTypeModulesVM.teachertype.forEach(function (teacherType) {
	        if (teacherType) {
	          var count = Object.values(teacherType).reduce(function (n, val) {
	            return n + (val === false);
	          }, 0);
	          if (count == 5) {
	            throw BreakException;
	          }
	        }
	      });
	      return true;
	    } catch (e) {
	      if (e == BreakException) {
	        return false;
	      }
	    }
	  }
	
	  function checkDisableModuleForTeacher(subModuleId, teachertype) {
	    var count = Object.values(setupTeacherTypeModulesVM.teachertype[teachertype]).reduce(function (n, val) {
	      return n + (val === false);
	    }, 0);
	    var parent = isTeacherTypeChild(teachertype);
	    if (parent) {
	      /*if(count == 5){
	        setupTeacherTypeModulesVM.teachertype[teachertype]['1'] = false
	        checkDisableParentModuleForTeacher('1',parent)
	      }*/
	      checkDisableParentModuleForTeacher(subModuleId, parent);
	    } else {
	      checkDisableDoWorkPlan(subModuleId, teachertype);
	    }
	  }
	
	  function checkDisableParentModuleForTeacher(subModuleId, object) {
	    var teachers = getTeacherTypeChilds(object.parent.id_code);
	    var count = 0;
	
	    teachers.childs.forEach(function (child) {
	      if (setupTeacherTypeModulesVM.teachertype[child.id_code] && setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId]) {
	        count = count + 1;
	      }
	    });
	
	    if (count == 0) disable(subModuleId, object);
	  }
	
	  function checkDisableDoWorkPlan(subModuleId, teachertype) {
	    var count = 0;
	    for (var association in setupTeacherTypeModulesVM.teachertype[teachertype]) {
	      if (setupTeacherTypeModulesVM.teachertype[teachertype][association]) count = count + 1;
	    }
	    if (count == 1) setupTeacherTypeModulesVM.teachertype[teachertype]['1'] = false;
	  }
	
	  function disable(subModuleId, object) {
	    var parent = object.parent;
	    setupTeacherTypeModulesVM.teachertype[parent.id_code][subModuleId] = false;
	  }
	
	  function getTeacherTypeChilds(teachertype) {
	    var result = [];
	    setupTeacherTypeModulesVM.teacherCategories.forEach(function (object) {
	      if (object.id_code == teachertype && object.childs.length > 0) {
	        result = object;
	        return;
	      }
	    });
	    return result;
	  }
	
	  function getAllTeachersActivities() {
	    return WorkPlanParametrizationSrv.getTeachertypeModules.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        setupTeacherTypeModulesVM.teacherCategories = dataReturn.teacherCategories;
	        getRelationTeacherSubmodules(dataReturn.relationTeacherModule);
	      }
	    });
	  }
	
	  function getRelationTeacherSubmodules(header) {
	    if (header) {
	      if (header.length > 0) {
	        setupTeacherTypeModulesVM.teachertype = setAllProfessorChecked(false);
	        setWorkplanAlreadyChecked(header);
	      } else {
	        setupTeacherTypeModulesVM.teachertype = setAllProfessorChecked(true);
	      }
	      setupTeacherTypeModulesVM.isButtonDisabled = !isActivitySelected() && !isEmptyTeachertype();
	      setupTeacherTypeModulesVM.blockCheckboxes = false;
	    } else {
	      console.log('error receiving getRelationTeacherSubmodules');
	    }
	  }
	
	  // INITIALIZATION
	  activate();
	};
	
	exports.default = SetupTeacherActivitiesCtrl;
	
	
	SetupTeacherActivitiesCtrl.$inject = ['$scope', '$resource', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', '$timeout', '$cookies'];

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creación exitosa!</h3> <p>Los permisos a los modulos se han configurado con éxito.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 237 */
216,
/* 238 */
/***/ (function(module, exports) {

	module.exports = {"indicatorsType":{"teaching":2,"academicManagement":3,"consolidationCP":5,"research":6,"extension":4},"userRolesIds":{"adminUnit":1,"adminModule":2,"consultant":3,"committee":4,"support":5,"institutionalCommittee":6,"unitCommittee":7,"approver":8,"reviewer":9,"teacher":13,"generalAdmin":15,"workPlanAdmin":16,"generalConsultant":18,"reviewerUpdatePerfil":21,"approverUpdatePerfil":22,"adminFacultyScienciePolitics":23,"adminFacultySciencieNaturals":24,"adminFacultyEconomy":25,"menuRoleId":25,"unitAdmin":26,"profileAdmin":27,"adminPortfolio":28,"strategicAdmin":29,"comitePortfolio":32,"humanDeployment":33,"academicDirection":34,"workplanConsultant":36,"gerencialConsultant":37,"comiteeAdmin":39},"modules":{"indexOption":-1,"planning":1,"teaching":2,"investigation":6,"extentionAndVisibility":4,"academicManagement":3,"consolidation":5,"execution":7},"modulesNames":{"teaching":"Docencia","investigation":"Investigación e innovación","extentionAndVisibility":"Extensión y visibilidad","academicManagement":"Gestión académica","consolidation":"Consolidación de cuerpo profesoral","execution":"Ejecución"},"modulesRoutes":[{"id":2,"route":"workplan.executionTeaching"},{"id":6,"route":"workplan.executionInvestigation"},{"id":4,"route":"workplan.executionExtension"},{"id":3,"route":"workplan.executionAcademicManagement"},{"id":5,"route":"workplan.executionConsolidation"}],"minorActivityId":{"directTeaching":23,"planning":25,"teaching":26,"doctorate":37,"courses":38,"learningComunity":39,"itemRequiredTeaching":651,"participation":29,"roles":28,"proposal":48,"counseling":52,"extensionProjectParent":49,"extensionProjectChild":50,"visibility":51,"shortCourse":53,"project":40,"projectParent":41,"projectChild":42,"productParent":43,"productChild":44,"space":45,"training":46,"transfer":47,"projectCrossParent":55,"projectCrossChild":56,"trainningResearchType":338},"activityTypeId":{"activities":1,"subject":3,"studentAttention":4,"positionsByDelegation":5,"roles":6,"committeeParticipation":7,"otherActivities":8,"doctoralEducation":10,"teacherDevelopment":11,"community":12,"projectDesign":13,"projects":14,"products":15,"colaborationSpace":16,"investigation":17,"resultsTransfer":18,"internalProjectsFormulation":19,"extensionProjects":20,"visibility":21,"consultancy":22,"shortCourses":23,"crossProjectFormulation":24,"crossExtensionProjects":25,"originActivityPlanning":1,"originActivityExecution":2},"scheduleTypeId":{"presencial":1,"virtual":2},"workplanStages":{"planning":"planning","review":"review","approval":"approval","execution":"execution","reviewExecution":"reviewExecution","evaluation":"evaluation","consultant":"consultant"},"workplanStagesNames":{"planning":"Planeación","review":"Revisión","approval":"Aprobación","execution":"Ejecución","reviewExecution":"Revisión de Ejecución","evaluation":"Evaluación","planningText":"Revise los datos mostrados a continuación para asegurar que desea finalizar su Planeación","executionText":"Recuerde finalizar la ejecución de su plan de trabajo teniendo en cuenta las fechas establecidas por su unidad académica, accediendo al botón <<Finalizar >> ubicado en esta ventana."},"workplanIdStages":{"planning":1,"review":2,"approval":3,"execution":4,"reviewExecution":5,"evaluation":6,"end":7,"consultant":10,"adminConsultantUnit":11},"workplanReview":{"idRol":1,"idEvaluator":1,"idStage":2},"notAloweedHours":{"idDocenteCatedra":9},"charges":{"emptyDescriptionMessage":"No hay observación"},"itemListConfig":{"idListPortfolio":187,"idStatement":615,"idReflection":616,"nameReflection":"Reflexión","idComments":617,"idEvidence":618,"nameEvidence":"Evidencia","idVideo":636,"idImagenJpg":637,"idImagenPng":638,"idPdf":639,"idAudio":640},"periods":{"rangeType":1,"list":[{"periodId":4,"periodName":"Semestre 1"},{"periodId":5,"periodName":"Intersemestral"},{"periodId":6,"periodName":"Semestre 2"}]},"hoursChildren":{"generalProject":0,"daughterActivities":1},"rangeTypes":{"periods":1,"custom":2},"typeListId":{"teaching":4,"academicManagement":5},"listId":{"teachingOtherActivities":56,"academicManagementotherActivities":60},"generals":{"active":1,"notActive":0},"courseType":{"courseInternal":729,"courseExternal":730},"typeProject":{"internalProject":19,"crossProject":24,"internal":20,"cross":1},"visibilityType":[{"idVisibility":1,"nameVisibility":"Medio de comunicación"},{"idVisibility":2,"nameVisibility":"Redes, asociaciones y relaciones interinstitucionales"},{"idVisibility":3,"nameVisibility":"Organización de eventos"}],"portfolioConfig":{"fileTypes":{"image":5,"document":6,"video":7,"audio":8}},"trainingResearch":{"pregrado":1,"postgrado":2,"doctoral":3},"appTexts":{"createDialog":"¡Registro satisfactorio!","editDialog":"¡Edición satisfactoria!","deleteDialog":"¡Registro eliminado!","saved":"guardado","modified":"modificado","deleted":"realizado ","modalTypeId":{"default":-1,"activity":3,"product":1,"project":2,"collaborationSpace":4,"projectFormulation":5,"resultsTransfer":6,"trainingResearch":7,"projectFormulationExt":8,"counselingConsultancy":9,"shortCourses":10,"extensionProject":11,"visibility":12,"doctoralFormation":13,"learningComunity":14,"teachingDev":15,"comiteeParticipation":16,"roleAcademicManagement":17,"otherActivityAM":18,"teachingSubject":19},"modalTypeName":{"deleted":"La eliminación de","activity":"La actividad","product":"El producto","project":"El proyecto","collaborationSpace":"El espacio de colaboración","projectFormulation":"La propuesta","resultsTransfer":"La actividad de transferencia","trainingResearch":"La formación de investigación","projectFormulationExt":"La formulación de proyecto interno","counselingConsultancy":"La asesoría/consultoría","shortCourses":"El curso corto","extensionProject":"El proyecto de extensión","visibility":"La visibilidad","doctoralFormation":"El doctorado","learningComunity":"La comunidad","teachingDev":"El curso","comiteeParticipation":"La participación","roleAcademicManagement":"El rol","schedule":"El horario de","teachingSubject":"La planificación de la asignatura"},"filterResult":{"unSatisfactory":"¡Aún no se ha registrado información en esta sección!","satisfactory":"¡No hay ningun resultados con el texto introducido!"}},"idUpdateProfile":{"docencia":1,"investigacion":2,"extension":3,"trayectoria_UR":4,"reconocimiento":5,"trayectoria_previa":6,"perfil_formacion":7},"orderProfiles":{"investigacion":"2","extension":"3","perfil_formacion":"4","docencia":"1","trayectoria_UR":"5","reconocimiento":"6"},"notificationType":{"inbox":1,"email":2},"initStageUpdate":{"wfCorto":9,"wfLargo":13,"wfComplete":15},"notificationTypeLibre":{"libre":4},"azureProfilePicturePath":"https://urosariostorage.blob.core.windows.net/profilepicture/","indicatorStages":{"review":{"noReviewed":{"id":1,"description":"No Revisados"},"newReview":{"id":2,"description":"Pendientes nueva revisión"},"withAdjustments":{"id":3,"description":"Con ajustes pendientes"},"reviewed":{"id":4,"description":"Revisados"}}},"menuModulesId":{"Portfolio":3,"Profile":4,"StrategicTracking":5,"Reportes":6},"generalSettings":{"notificationsType":{"rules":1,"custom":2,"startMessage":3}},"staticReportName":[{"id":"659","name":"Revisores y usuarios de consulta del plan de trabajo","noView":[13,9,8]},{"id":"660","name":"Profesores en situaciones especiales"},{"id":"661","name":"Etapas no completadas del plan de trabajo"},{"id":"668","name":"Plan de trabajo del profesor"},{"id":"669","name":"Actividades por unidad académica","noView":[13]},{"id":"670","name":"Seguimiento a la Revisión y aprobación"},{"id":"672","name":"Reporte integral plan de trabajo"},{"id":"673","name":"Estados de aprobación por etapas","noView":[13,9,8]},{"id":"674","name":"Resumen Detallado de Actividades por Unidad Académica","noView":[13]},{"id":"675","name":"Profesores activos e inactivos","noView":[13]},{"id":"676","name":"Control Horas Planeadas vs Ejecutadas"},{"id":"677","name":"Estados del plan de trabajo por Profesor","noView":[13,9,8]},{"id":"678","name":"Resumen de actividades en seguimiento estratégico","noView":[13,9,8]},{"id":"679","name":"Observaciones al plan de trabajo"}],"externalURLs":{"integralEvaluationURL":"https://sgi.urosario.edu.co"}}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _generalSettings = __webpack_require__(240);
	
	var _generalSettings2 = _interopRequireDefault(_generalSettings);
	
	var _notifications = __webpack_require__(245);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _users = __webpack_require__(253);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _generalSettingsSrv = __webpack_require__(259);
	
	var _generalSettingsSrv2 = _interopRequireDefault(_generalSettingsSrv);
	
	var _notificationsListCtrl = __webpack_require__(260);
	
	var _notificationsListCtrl2 = _interopRequireDefault(_notificationsListCtrl);
	
	var _customNotificationCtrl = __webpack_require__(263);
	
	var _customNotificationCtrl2 = _interopRequireDefault(_customNotificationCtrl);
	
	var _notificationRuleCtrl = __webpack_require__(264);
	
	var _notificationRuleCtrl2 = _interopRequireDefault(_notificationRuleCtrl);
	
	var _startMessageNotificationCtrl = __webpack_require__(265);
	
	var _startMessageNotificationCtrl2 = _interopRequireDefault(_startMessageNotificationCtrl);
	
	var _notificationRuleDetailCtrl = __webpack_require__(267);
	
	var _notificationRuleDetailCtrl2 = _interopRequireDefault(_notificationRuleDetailCtrl);
	
	var _customNotificationDetailCtrl = __webpack_require__(268);
	
	var _customNotificationDetailCtrl2 = _interopRequireDefault(_customNotificationDetailCtrl);
	
	var _startMessageNotificationDetailCtrl = __webpack_require__(269);
	
	var _startMessageNotificationDetailCtrl2 = _interopRequireDefault(_startMessageNotificationDetailCtrl);
	
	var _usersCtrl = __webpack_require__(270);
	
	var _usersCtrl2 = _interopRequireDefault(_usersCtrl);
	
	var _createUsersCtrl = __webpack_require__(275);
	
	var _createUsersCtrl2 = _interopRequireDefault(_createUsersCtrl);
	
	var _createCommitteeCtrl = __webpack_require__(280);
	
	var _createCommitteeCtrl2 = _interopRequireDefault(_createCommitteeCtrl);
	
	var _editCommitteeCtrl = __webpack_require__(281);
	
	var _editCommitteeCtrl2 = _interopRequireDefault(_editCommitteeCtrl);
	
	var _listCommitteCtrl = __webpack_require__(282);
	
	var _listCommitteCtrl2 = _interopRequireDefault(_listCommitteCtrl);
	
	var _listParamsCtrl = __webpack_require__(284);
	
	var _listParamsCtrl2 = _interopRequireDefault(_listParamsCtrl);
	
	var _listSubjectCtrl = __webpack_require__(285);
	
	var _listSubjectCtrl2 = _interopRequireDefault(_listSubjectCtrl);
	
	var _createSubjectCtrl = __webpack_require__(289);
	
	var _createSubjectCtrl2 = _interopRequireDefault(_createSubjectCtrl);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	var _generalSettings3 = __webpack_require__(291);
	
	var _generalSettings4 = _interopRequireDefault(_generalSettings3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// subjects controllers
	
	// users controllers
	
	//import run from './generalSettings.run';
	exports.default = angular.module('generalSettings.generalSettings', [_generalSettingsSrv2.default]).config(_generalSettings2.default).config(_notifications2.default).config(_users2.default).run(_generalSettings4.default).controller('NotificationsListCtrl', _notificationsListCtrl2.default).controller('CustomNotificationCtrl', _customNotificationCtrl2.default).controller('NotificationRuleCtrl', _notificationRuleCtrl2.default).controller('StartMessageNotificationCtrl', _startMessageNotificationCtrl2.default).controller('NotificationRuleDetailCtrl', _notificationRuleDetailCtrl2.default).controller('CustomNotificationDetailCtrl', _customNotificationDetailCtrl2.default).controller('StartMessageNotificationDetailCtrl', _startMessageNotificationDetailCtrl2.default).controller('UsersCtrl', _usersCtrl2.default).controller('CreateUsersCtrl', _createUsersCtrl2.default).controller('CreateCommitteeCtrl', _createCommitteeCtrl2.default).controller('EditCommitteeCtrl', _editCommitteeCtrl2.default).controller('listParamsCtrl', _listParamsCtrl2.default).controller('ListSubjectCtrl', _listSubjectCtrl2.default).controller('createSubjectCtrl', _createSubjectCtrl2.default).controller('ListCommitteeCtrl', _listCommitteCtrl2.default).constant('comite', [{
		title: 'Comité',
		icon: 'mdi-image-tune',
		moduleId: _globalConfig2.default.menuModulesId.committee,
		subMenu: [{
			title: 'Administración de Comité',
			url: 'generalSettings.users',
			rolesAllowed: [_globalConfig2.default.userRolesIds.comiteeAdmin]
		}]
	
	}]).name;
	
	// parameters list controllers
	
	
	// controllers
	// notification controllers
	// import uirouter from 'angular-ui-router';

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('generalSettings', {
	    abstract: false,
	    url: '/app/generalSettings',
	    redirectTo: 'generalSettings.main',
	    views: {
	      '': {
	        template: __webpack_require__(168)
	      },
	      'content': {
	        template: __webpack_require__(169)
	      },
	      'aside': {
	        template: __webpack_require__(170),
	        controller: 'AsideCtrl'
	      },
	      'header': {
	        template: __webpack_require__(171),
	        controller: 'HeaderCtrl'
	      },
	      'chatbox': {
	        template: __webpack_require__(172),
	        controller: 'ChatboxController',
	        controllerAs: 'chatbox'
	      },
	      'footer': {
	        template: __webpack_require__(177)
	      }
	    },
	    data: { displayName: 'Inicio' }
	  }).state('generalSettings.main', {
	    abstract: false,
	    url: '/main',
	    template: __webpack_require__(241),
	    data: {
	      displayName: 'Inicio',
	      order: 0,
	      siblings: [{
	        name: 'generalSettings.notificationsManagement',
	        order: 1
	      }, {
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.listParams', {
	    abstract: false,
	    url: '/parameters',
	    template: __webpack_require__(242),
	    controller: 'listParamsCtrl',
	    controllerAs: 'listParams',
	    data: {
	      displayName: 'Parámetros de listas',
	      rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	      order: 2,
	      siblings: [{
	        name: 'generalSettings.notificationsManagement',
	        order: 1
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.listSubject', {
	    abstract: false,
	    url: '/listSubject',
	    template: __webpack_require__(243),
	    controller: 'ListSubjectCtrl',
	    controllerAs: 'subjectListVM',
	    data: {
	      displayName: 'Asignaturas médico quirúrgicas',
	      rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	      order: 4,
	      siblings: [{
	        name: 'generalSettings.notificationsManagement',
	        order: 1
	      }, {
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }]
	    }
	  }).state('generalSettings.createSubject', {
	    abstract: false,
	    url: '/createSubject',
	    template: __webpack_require__(244),
	    controller: 'createSubjectCtrl',
	    controllerAs: 'createSubject',
	    data: {
	      displayName: 'Asignaturas médico quirúrgicas',
	      rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	      order: 4,
	      siblings: [{
	        name: 'generalSettings.notificationsManagement',
	        order: 1
	      }, {
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }]
	    }
	  }).state('generalSettings.editSubject', {
	    abstract: false,
	    url: '/editSubject/:subjectId',
	    template: __webpack_require__(244),
	    controller: 'createSubjectCtrl',
	    controllerAs: 'createSubject',
	    data: {
	      displayName: 'Asignaturas médico quirúrgicas',
	      rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	      order: 4,
	      siblings: [{
	        name: 'generalSettings.notificationsManagement',
	        order: 1
	      }, {
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }]
	    }
	  });
	}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Configuración</h3> <p class=text-base>En esta sección podrás encontrar todas las opciones de configuración dependiendo de tu rol.</p> </div> </div> <div class=\"row p-h-md p-t-md color-cards\" has-permission=gestion-de-notificaciones-edit> <div class=\"col-md-11 gutter-10\"> <div class=col-md-3 ui-sref=generalSettings.notificationsManagement> <a href=#> <div class=\"card brd-md box-shadow\"> <div class=\"card-heading grad-1 p-v-lg text-center text-blanco\"> <i class=\"icon mdi-social-notifications i-40\"></i> </div> <div class=card-body> <h5 class=\"text-center font-bold\">Gestión de notificaciones</h5> </div> </div> </a> </div> <div class=col-md-3 ui-sref=generalSettings.listParams has-permission=parametros-de-listas-edit> <a href=#> <div class=\"card brd-md box-shadow\"> <div class=\"card-heading grad-2 p-v-lg text-center text-blanco\"> <i class=\"icon mdi-action-list i-40\"></i> </div> <div class=card-body> <h5 class=\"text-center font-bold\">Parámetros de listas</h5> </div> </div> </a> </div> <div class=col-md-3 ui-sref=generalSettings.users has-permission=usuarios-edit> <a href=#> <div class=\"card brd-md box-shadow\"> <div class=\"card-heading grad-3 p-v-lg text-center text-blanco\"> <i class=\"icon mdi-social-group i-40\"></i> </div> <div class=card-body> <h5 class=\"text-center font-bold\">Usuarios</h5> </div> </div> </a> </div> <div class=col-md-3 ui-sref=generalSettings.listSubject has-permission=crear-asignatura-mq-edit> <a href=#> <div class=\"card brd-md box-shadow\"> <div class=\"card-heading grad-4 p-v-lg text-center text-blanco\"> <i class=\"icon mdi-maps-local-hospital i-40\"></i> </div> <div class=card-body> <h5 class=\"text-center font-bold\">Asignaturas médico quirúrgicas</h5> </div> </div> </a> </div> </div> </div> <button class=\"btn btn-fw btn-cancel md-button md-ink-ripple m-t-md\" type=button onclick=window.history.back()>Volver</button> ";

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>Parámetros de listas</h3> <p class=text-xs>En esta sección puede revisar y agregar nuevos parámetros a las listas de los submódulos de plan de trabajo, para visualizarlos navegue por las pestañas</p> </div> <div class=\"col-md-2 p-h-lg no-padding-r\"> <div class=flex> <div ng-style=set_indicator_style(false)></div> <p class=\"text-xs p-h-sm\">No obligatorio</p> </div> <div class=flex> <div ng-style=set_indicator_style(true)></div> <p class=\"text-xs p-h-sm\">Obligatorio</p> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-l-lg\"> <div class=loading-details ng-if=load> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=\"col-md-12 no-padding\" ng-cloak md-whiteframe=4> <md-content> <md-tabs class=\"capitalize blanco default-tabs\" md-stretch-tabs=\"\" md-dynamic-height md-border-bottom> <md-tab label={{submodule.ds_name}} ng-repeat=\"submodule in submodules\" ng-click=getData(submodule)> <form name=newParamForm novalidate> <div class=\"col-md-3 p-h-lg no-padding-r\" ng-repeat=\"list in currentSubmoduleData\"> <h5 class=\"p-v no-margin text-base\">{{list.listName}}</h5> <div class=\"row p-h\"> <div class=form-group ng-class=hasError(newParamForm.param_{{$index}})> <label class=control-label for=param_{{$index}}>Ingrese parámetro</label> <input class=\"text-xs form-control\" name=param_{{$index}} type=text ng-model=models[$index] ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=\"newParamForm['param_'+$index].$error\" ng-show=showErrorMessages(newParamForm.param_{{$index}})> <div ng-message=required>El parámetro es requerido</div> </div> </div> <button type=submit class=\"btn btn-sm btn-success p-xs m-r-lg\" ng-disabled=disableButton ng-click=\"addItem(models[$index], list, $index, enforce)\"> <i class=\"icon mdi-content-add i-20\"></i> </button> <md-checkbox class=\"md-green text-xs m-v-sm\" ng-model=enforce>Obligatorio</md-checkbox> </div> <div class=\"parametersLister flex align-items-center\" ng-repeat=\"item in list.items\"> <div class=bullet ng-style=set_color_required(item)></div> <p class=\"text-xs p-h-sm\">{{item.listItemName}}</p> <md-switch class=no-margin ng-init=\"status = !!item.isActive\" ng-model=status aria-label=isActive ng-click=\"changeStatus(item, list, status)\"> </md-switch> </div> </div> </form> </md-tab> </md-tabs> </md-content> </div> </div> </div>";

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>Asignaturas de postgrados m&eacute;dicos quir&uacute;rgicos</h3> <p class=text-xs> En esta secci&oacute;n puede crear asignaturas medico quir&uacute;rgicas y consultar la informaci&oacute;n de aquellas creadas previamente </p></div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success no-margin\" ui-sref=generalSettings.createSubject>Crear asignatura</md-button><p></p> </div> </div> <div> <div class=\"row p-t search\"> <div class=\"col-md-12 no-paddin p-l-lg\"> <div class=\"input-group stylish-input-group m-r-md\"> <input type=text ng-model=subjectListVM.listSubjectsFilter ng-model-options=\"{ debounce: 300 }\" ng-change=subjectListVM.filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row p-t m-r-md\"> <div class=\"col-md-12 m-l\"> <div class=\"grid grid-blue\" ui-grid=subjectListVM.gridListSubjects ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination> </div> </div> </div> </div> ";

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>{{mainLabel}}</h3> <p class=text-base> Para crear una nueva asignatura m&eacute;dico quir&uacute;rgica, diligencie los datos en el formulario. Todos los datos ser&aacute;n editables posteriormente, exceptuando nombre y c&oacute;digo de la asignatura. </p> </div> </div> <form name=createSubject novalidate> <div class=row> <div class=\"col-md-6 b-r-gris-light\"> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Configuración general</h5> <div class=row> <div class=col-md-9> <div class=form-group ng-class=hasError(createSubject.name)> <label for=name class=control-label>Nombre</label> <input type=text name=name ng-model=nameSubject ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createSubject.name.$error ng-show=showErrorMessages(createSubject.name)> <div ng-message=required>El nombre es requerido</div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group ng-class=hasError(createSubject.codigo)> <label for=id class=control-label>C&oacute;digo</label> <input type=text name=codigo ng-model=codigoSubject ng-model-options=\"{ debounce: 300 }\" class=form-control required/> <div class=control-label ng-messages=createSubject.codigo.$error ng-show=showErrorMessages(createSubject.codigo)> <div ng-message=required>El código es requerido</div> </div> </div> </div> </div> <div class=row> <div class=\"form-group col-md-12\" ng-class=hasError(createSubject.specialization)> <label for=specialization class=control-label>Especializaci&oacute;n</label> <select name=specialization ng-model=specializationModel ng-options=\"listSpecialization.specialization_name for listSpecialization in specialization\" class=form-control required> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <div class=control-label ng-messages=createSubject.specialization.$error ng-show=showErrorMessages(createSubject.specialization)> <div ng-message=required>La especializaci&oacute;n es requerida</div> </div> </div> </div> <div class=\"row no-margin-l\"> <div class=\"col-md-12 no-padding\"> <div class=col-md-6> <label class=\"control-label col-md-12 no-padding\">Estado</label> <div class=\"col-md-6 p-l-md\"> <div class=\"radio-options no-margin\"> <input type=radio name=active ng-model=state value=active> <i class=radio-green></i> <label>Activo</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=inactive ng-model=state value=inactive> <i class=radio-green></i> <label>Inactivo</label> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=hasError(createSubject.hours)> <label for=hours class=control-label>Horas sugeridas</label> <input type=number only-integer min=1 name=hours ng-model=hoursSubject class=form-control required> <div class=control-label ng-messages=createSubject.hours.$error ng-show=showErrorMessages(createSubject.hours)> <div ng-message=required>Las horas son requeridas</div> </div> </div> </div> </div> </div> <div class=\"row m-t-sm\"> <div class=col-md-12> <label for=period class=control-label>Período</label> <div class=\"row p-l\"> <div class=\"no-padding col-md-4\" ng-repeat=\"listPeriod in period\"> <md-checkbox class=\"md-green no-margin text-sm\" ng-model=periodChecked[listPeriod.periodicity_id] ng-required=isPeriodEmpty() name=period_{{listPeriod.periodicity_id}} ng-change=\"selectedPeriod(listPeriod, periodChecked[listPeriod.periodicity_id])\"> {{listPeriod.periodicity_name}}</md-checkbox> </div> </div> </div> </div> </div> </div> <div class=col-md-5> <div class=row> <div class=\"col-md-12 m-v\"> <h5 class=\"text-azul p-v-xs font-bold col-md-12 no-padding-l\">Profesores asignados <br><small>(La búsqueda se puede realizar por nombre o cédula)</small></h5> <input type=text style=display:none class=autocomplete ng-model=inputHidden ng-model-options=\"{ debounce: 300 }\" ng-required=isTeacherEmpty()> <md-autocomplete class=\"no-padding autocomplete col-md-7 m-r-xs\" md-clear-button=false md-item-text=\"teacher.teacher_name + teacher.teacher_identification\" md-min-length=0 md-selected-item=selectedItem md-search-text=searchText md-items=\"teacher in searchTeacher(searchText)\" placeholder=\"Buscar profesor...\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{teacher.teacher_name +\" / \"+ teacher.teacher_identification}}</span> </md-item-template> <md-not-found> No se encontraron usuarios... </md-not-found> </md-autocomplete> <div class=\"col-md-2 no-padding\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=addTeacher(selectedItem)></i> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v\"> <ul class=\"without-bullets col-md-12 no-padding\"> <li ng-repeat=\"selected in selectedTeachers\" class=\"teacherList text-md\"> <p class=\"text-sm no-margin\">{{selected.teacher_name}}</p> <md-button class=\"md-icon-button no-margin\" ng-click=removeTeacher(selected)> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> </div> </div> <div class=\"row m-t\"> <div class=\"col-md-12 text-center no-padding\"> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=generalSettings.listSubject>Cancelar</md-button> </div> <div class=\"col-md-6 text-left\"> <md-button class=\"btn btn-fw btn-success no-margin\" ng-click=addSubject() ng-disabled=validateForm(createSubject)>{{textButton}}</md-button> </div> </div> </div> </form>";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('generalSettings.notificationsManagement', {
	    abstract: false,
	    url: '/notificationsManagement',
	    template: __webpack_require__(246),
	    controller: 'NotificationsListCtrl',
	    controllerAs: 'notificationListVM',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.customNotification', {
	    abstract: false,
	    url: '/customNotification',
	    template: __webpack_require__(247),
	    controller: 'CustomNotificationCtrl',
	    controllerAs: 'customNotificationVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.customNotificationDetail', {
	    abstract: false,
	    url: '/customNotification/:notificationId/view',
	    template: __webpack_require__(248),
	    controller: 'CustomNotificationDetailCtrl',
	    controllerAs: 'customNotificationVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.notificationRule', {
	    abstract: false,
	    url: '/notificationRule',
	    template: __webpack_require__(249),
	    controller: 'NotificationRuleCtrl',
	    controllerAs: 'notificationRuleVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.editNotificationRule', {
	    abstract: false,
	    url: '/notificationRule/:notificationId/edit',
	    template: __webpack_require__(249),
	    controller: 'NotificationRuleCtrl',
	    controllerAs: 'notificationRuleVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.notificationRuleDetail', {
	    abstract: false,
	    url: '/notificationRule/:notificationId/view',
	    template: __webpack_require__(250),
	    controller: 'NotificationRuleDetailCtrl',
	    controllerAs: 'notificationRuleVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.initialMessageNotification', {
	    abstract: false,
	    url: '/initialMessageNotification',
	    template: __webpack_require__(251),
	    controller: 'StartMessageNotificationCtrl',
	    controllerAs: 'startMessageVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.startMessageNotificationDetail', {
	    abstract: false,
	    url: '/startMessageNotification/:notificationId/view',
	    template: __webpack_require__(252),
	    controller: 'StartMessageNotificationDetailCtrl',
	    controllerAs: 'startMessageNotificationVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.editStartMessageNotification', {
	    abstract: false,
	    url: '/startMessageNotification/:notificationId/edit',
	    template: __webpack_require__(251),
	    controller: 'StartMessageNotificationCtrl',
	    controllerAs: 'startMessageVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  }).state('generalSettings.editCustomNotification', {
	    abstract: false,
	    url: '/customNotification/:notificationId/edit',
	    template: __webpack_require__(247),
	    controller: 'CustomNotificationCtrl',
	    controllerAs: 'customNotificationVm',
	    data: {
	      displayName: 'Gestión de notificaciones',
	      order: 1,
	      siblings: [{
	        name: 'generalSettings.listParams',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
	        order: 2
	      }, {
	        name: 'generalSettings.users',
	        order: 3
	      }, {
	        name: 'generalSettings.listSubject',
	        rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
	        order: 4
	      }]
	    }
	  });
	}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs gutter-10\"> <div class=col-md-6> <h3 class=p-t>Gestión de notificaciones</h3> </div> <div class=col-md-2 ng-show=!notificationListVM.isAdminOrGerencialConsultant> <md-button ui-sref=generalSettings.notificationRule class=\"btn btn-fw btn-info text-xs p-h-md no-margin col-md-12\"> Crear notificación<br>masiva </md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success text-xs p-h-md no-margin col-md-12\" ui-sref=generalSettings.customNotification> Crear notificación<br>personalizada </md-button> </div> <div class=col-md-2 ng-show=!notificationListVM.isAdminOrGerencialConsultant> <md-button class=\"btn btn-fw btn-primary text-xs p-h-md no-margin col-md-12\" ui-sref=generalSettings.initialMessageNotification has-permission=mensajes-de-inicio-edit> Crear mensaje<br>de inicio </md-button> </div> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <h4 class=text-azul>Listado de notificaciones creadas</h4> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=notificationListVM.searchFilter ng-model-options=\"{ debounce: 300 }\" ng-change=notificationListVM.filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-h-lg m-t-sm\"> <div class=\"grid grid-blue\" ui-grid=notificationListVM.gridNotifications ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination> </div> </div> </div> ";

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Gestión de notificaciones - Crear y editar notificación personalizada</h3> </div> </div> <form name=customNotificationForm novalidate> <div class=row> <div class=\"col-md-6 b-r-gris-light p-h-lg\"> <h5 class=\"text-azul p-v-xs font-bold\">Configuración general</h5> <div class=row> <div class=col-md-6> <div class=form-group ng-class=customNotificationVm.hasError(customNotificationForm.selectedNotificationType)> <label class=control-label>Tipo de notificación</label> <select class=form-control name=selectedNotificationType ng-model=customNotificationVm.selectedNotificationType ng-options=\"type.notification_type for type in customNotificationVm.notificationTypes\" required> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <div class=control-label ng-messages=customNotificationForm.selectedNotificationType.$error ng-show=customNotificationVm.showErrorMessages(customNotificationForm.selectedNotificationType)> <div ng-message=required>El campo es requerido</div> </div> </div> <div class=form-group ng-class=customNotificationVm.hasError(customNotificationForm.selectedFaculty)> <label class=control-label>Unidad a notificar</label> <select class=form-control name=selectedFaculty ng-model=customNotificationVm.selectedFaculty ng-options=\"faculty.faculty_name for faculty in customNotificationVm.faculties\" ng-change=customNotificationVm.getTeacher(customNotificationVm.selectedFaculty) required> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <div class=control-label ng-messages=customNotificationForm.selectedFaculty.$error ng-show=customNotificationVm.showErrorMessages(customNotificationForm.selectedFaculty)> <div ng-message=required>El campo es requerido</div> </div> </div> </div> <div class=col-md-6> <div class=form-group ng-class=customNotificationVm.hasError(customNotificationForm.deliveryDate)> <label class=control-label>Fecha de envío de la notificación</label> <md-datepicker name=deliveryDate class=text-left ng-model=customNotificationVm.deliveryDate ng-keydown=customNotificationVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa min=\"{{customNotificationVm.minDate | date : 'yyyy-MM-dd'}}\" md-min-date=customNotificationVm.minDate required> </md-datepicker> <div class=control-label ng-messages=customNotificationForm.deliveryDate.$error ng-show=customNotificationVm.showErrorMessages(customNotificationForm.deliveryDate)> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha debe ser mayor o igual a la fecha actual</div> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Usuarios a notificar</h5> <div class=row> <div class=\"col-md-9 search-autocomplete no-padding-r\"> <div class=form-group> <md-autocomplete md-clear-button=false md-item-text=teacher.teacher_name md-min-length=0 md-selected-item=selectedItem md-search-text=searchText md-items=\"teacher in customNotificationVm.searchTeacher(searchText)\" , md-no-cache=true placeholder=\"Buscar usuarios\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{teacher.teacher_name}}</span> </md-item-template> <md-not-found> No se encontraron usuarios... </md-not-found> </md-autocomplete> <i class=\"mdi-action-search i-24\"></i> <input type=hidden name=teachers ng-model=teachers ng-required=\"customNotificationVm.selectedTeachers.length == 0\"> </div> </div> <div class=col-md-3> <md-button class=\"btn btn-primary text-xs p-h-md no-margin\" ng-click=customNotificationVm.addTeacher(selectedItem) ng-disabled=!selectedItem>Agregar</md-button> </div> </div> <div class=\"col-md-12 m-v no-padding\"> <ul class=\"no-padding p-l with-bullets\"> <li class=\"teacherList text-md\" ng-repeat=\"selected in customNotificationVm.selectedTeachers\"> <p class=\"text-sm p-l-md\">{{selected.teacher_name}}</p> <md-button class=\"md-icon-button no-margin\" ng-click=customNotificationVm.removeTeacher(selected)> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> </div> <div class=row> <div class=col-md-12> <label>Tipo de envío</label> <div class=form-group> <div class=\"col-md-6 no-padding\" ng-repeat=\"type in customNotificationVm.deliveryType\" style=width:80px> <md-checkbox class=\"md-green no-margin text-sm\" ng-model=selectedDeliveryType ng-required=\"customNotificationVm.selectedDeliveryType.length == 0\" ng-click=customNotificationVm.toggle(type) ng-checked=customNotificationVm.exists(type)> {{ type.delivery_type }} </md-checkbox> </div> </div> </div> </div> </div> <div class=col-md-6> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Cuerpo de notificación</h5> <p class=\"col-md-12 no-padding\">Seleccione una plantilla para ser aplicada a su notificación</p> </div> </div> <div class=row> <div class=\"col-md-12 flex align-items-center\"> <label for=selectedTemplate class=m-r-sm>Plantilla</label> <select name=selectedTemplate ng-model=customNotificationVm.selectedTemplate ng-options=\"template.ds_name for template in customNotificationVm.templates\" class=\"form-control m-r-sm\"> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <md-button class=\"btn btn-fw btn-info no-margin\" ng-click=\"customNotificationVm.changeTemplate( customNotificationVm.selectedTemplate )\" ng-disabled=!customNotificationVm.selectedTemplate>Aplicar plantilla</md-button> </div> </div> <div class=\"row mdinputcontainerwrapper\"> <div class=\"col-md-12 flex align-items-center\" layout-gt-sm=row> <md-input-container class=md-block flex-gt-sm> <label for=selectedTemplate class=m-r-sm>Asunto</label> <input type=text ng-required=customNotificationVm.isSubjectEmpty() ng-model=customNotificationVm.asunto ng-model-options=\"{ debounce: 300 }\"> </md-input-container> </div> </div> <div class=row> <div class=col-md-12> <div class=form-group ng-class=customNotificationVm.hasError(customNotificationForm.comments)> <div class=\"m-b-sm webeditor\" name=comments text-angular ng-model=customNotificationVm.comments ta-toolbar=\"[['bold','italics', 'underline'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['ul', 'quote', 'html'], ['insertImage','insertLink'], ['undo', 'redo']]\" required></div> <div class=control-label ng-messages=customNotificationForm.comments.$error ng-show=customNotificationVm.showErrorMessages(customNotificationForm.comments)> <div ng-message=required>El campo es requerido</div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel text-xs p-h-md pull-right\" ui-sref=generalSettings.notificationsManagement> <div class=p-v-sm>Cancelar</div> </md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-success text-xs p-h-md pull-left\" ng-disabled=\"customNotificationVm.validateForm(customNotificationForm) || customNotificationVm.isDisabled\" ng-click=customNotificationVm.saveCustomNotification()>Guardar notificación <br>personalizada</md-button> </div> </div> </form>";

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Gestión de notificaciones - Notificación personalizada</h3> </div> </div> <form name=customNotificationForm novalidate> <div class=row> <div class=\"col-md-6 b-r-gris-light p-h-lg\"> <h5 class=\"text-azul p-v-xs font-bold\">Configuración general</h5> <div class=row> <div class=col-md-6> <div class=form-group> <label class=control-label>Tipo de notificación</label> <select class=form-control name=selectedNotificationType ng-model=customNotificationVm.selectedNotificationType ng-options=\"type.notification_type_id as type.notification_type for type in customNotificationVm.notificationTypes\" disabled=disabled> </select> </div> <div class=form-group> <label class=control-label>Unidad a notificar</label> <select class=form-control name=selectedFaculty ng-model=customNotificationVm.selectedFaculty ng-options=\"faculty.faculty_id as faculty.faculty_name for faculty in customNotificationVm.faculties\" disabled=disabled> </select> </div> </div> <div class=col-md-6> <div class=form-group> <label class=control-label>Fecha de envío de la notificación</label> <md-datepicker name=deliveryDate ng-keydown=customNotificationVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" class=text-left ng-model=customNotificationVm.deliveryDate md-placeholder=dd/mm/aaaa disabled=disabled> </md-datepicker> </div> </div> </div> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Usuarios a notificar</h5> </div> </div> <div class=\"col-md-12 m-v no-padding\"> <ul class=\"col-md-9 no-padding p-l with-bullets\"> <li class=\"teacherList text-md\" ng-repeat=\"teacher in customNotificationVm.selectedTeachers\"> <p class=\"text-sm p-l-md\">{{teacher}}</p> </li> </ul> </div> <div class=row> <div class=col-md-12> <label>Tipo de envío</label> <div class=form-group> <div class=\"col-md-6 no-padding\" ng-repeat=\"type in customNotificationVm.deliveryType\" style=width:80px> <md-checkbox class=\"md-green no-margin text-sm\" ng-disabled=\"customNotificationVm.selectedDeliveryType.length == 0\" ng-checked=customNotificationVm.exists(type.delivery_type_id)> {{ type.delivery_type }} </md-checkbox> </div> </div> </div> </div> </div> <div class=col-md-6> <div class=\"row mdinputcontainerwrapper\"> <div class=\"col-md-12 flex align-items-center\" layout-gt-sm=row> <label for=selectedTemplate class=m-r-sm>Asunto</label> </div> <div class=\"col-md-12 flex align-items-center\" layout-gt-sm=row> <p class=\"text-sm p-l-md\">{{customNotificationVm.asunto}}</p> </div> </div> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Cuerpo de notificación</h5> <div class=form-group> <div class=\"m-b-sm webeditor\" name=comments text-angular ng-model=customNotificationVm.comments ta-toolbar=\"[['bold','italics', 'underline'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['ul', 'quote', 'html'], ['insertImage','insertLink'], ['undo', 'redo']]\" ta-disabled=true></div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-b-md text-center\"> <md-button class=\"btn btn-fw btn-cancel text-xs p-h-md\" ui-sref=generalSettings.notificationsManagement> Volver </md-button> </div> </div> </form>";

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v\"> <h3>Gestión de notificaciones - Crear notificación masiva</h3> </div> </div> <form name=createNotificationRule novalidate> <div class=\"row m-h-md no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-6 no-padding-l b-r-gris-light\"> <h5 class=\"text-azul p-v-xs font-bold\">Configuración general</h5> <div class=row> <div class=col-md-5> <div class=form-group ng-class=notificationRuleVm.hasError(createNotificationRule.notification_type)> <label for=notification_type class=control-label>Tipo de notificación</label> <select name=notification_type ng-model=notificationRuleVm.notification.id_notificationType ng-change=notificationRuleVm.checkIsLibre() ng-options=\"notificationType.id_code as notificationType.ds_name for notificationType in notificationRuleVm.notificationType\" class=form-control required> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <div class=control-label ng-messages=createNotificationRule.notification_type.$error ng-show=notificationRuleVm.showErrorMessages(createNotificationRule.notification_type)> <div ng-message=required>La Tipo de notificación es requerida</div> </div> </div> <div class=form-group> <label class=control-label>Roles a enviar notificación</label> <div class=\"col-md-12 text-sm no-padding m-v-xs\" ng-repeat=\"role in notificationRuleVm.roles\"> <md-checkbox name=rol_{{role.id_code}} ng-model=\"notificationRuleVm.notification.roles[ role.id_code ]\" class=\"md-green no-margin\">{{ role.ds_name }}</md-checkbox> </div> <input type=hidden ng-model=roleEmpty name=isRoleEmpty ng-required=notificationRuleVm.isRoleEmpty()> </div> </div> <div class=col-md-7> <div class=form-group> <label class=\"control-label col-md-12 no-padding m-b-sm\">Tiempo de envío</label> <div class=row> <div class=\"col-md-12 no-padding\"> <div class=\"radio-options no-margin\"> <div class=p-l-xl> <input type=radio name=shipping_time ng-model=notificationRuleVm.notification.shipping_time value=dependent> <i class=radio-green></i> <label>Dependiente del evento</label> </div> <div class=p-l-xl> <input type=radio name=notification.shipping_time ng-model=notificationRuleVm.notification.shipping_time value=weekly ng-disabled=notificationRuleVm.isLibre> <i class=radio-green></i> <label>Semanal</label> </div> </div> </div> </div> </div> <div class=\"form-group text-sm\" ng-show=\"notificationRuleVm.notification.shipping_time == 'dependent'\"> <div class=row ng-show=!notificationRuleVm.isLibre> <div class=\"col-md-12 m-v-xs\"> <md-checkbox ng-model=notificationRuleVm.notification.is_at_sending_moment name=is_at_sending_moment ng-true-value=1 class=\"md-green no-margin\" ng-required=notificationRuleVm.isRequiredEventDependent()>Al momento del envío</md-checkbox> </div> </div> <div class=row ng-show=!notificationRuleVm.isLibre> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=oneDayBefore ng-model=notificationRuleVm.notification.daysBefore[1] class=\"md-green no-margin\" ng-required=notificationRuleVm.isRequiredEventDependent()>1 día antes</md-checkbox> </div> </div> <div class=row ng-show=!notificationRuleVm.isLibre> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=twoDaysBefore ng-model=notificationRuleVm.notification.daysBefore[2] class=\"md-green no-margin\" ng-required=notificationRuleVm.isRequiredEventDependent()>2 días antes</md-checkbox> </div> </div> <div class=row ng-show=!notificationRuleVm.isLibre> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=fiveDaysBefore ng-model=notificationRuleVm.notification.daysBefore[5] class=\"md-green no-margin\" ng-required=notificationRuleVm.isRequiredEventDependent()>5 días antes</md-checkbox> </div> </div> <div class=row ng-show=!notificationRuleVm.isLibre> <div class=\"col-md-8 m-v-xs\"> <md-checkbox name=check_n_days_before ng-model=notificationRuleVm.checkNDaysBefore ng-change=notificationRuleVm.changedCheckNDaysBefore(notificationRuleVm.checkNDaysBefore) class=\"md-green no-margin\">Cantidad de días antes</md-checkbox> </div> <div class=\"col-md-4 m-v-xs\" ng-show=notificationRuleVm.checkNDaysBefore> <div class=form-group ng-class=notificationRuleVm.hasError(createNotificationRule.n_days_before)> <input type=number min=1 name=n_days_before ng-model=notificationRuleVm.nDaysBefore class=form-control ng-pattern=/^\\d+$/ ng-required=\"notificationRuleVm.notification.shipping_time == 'dependent' && notificationRuleVm.checkNDaysBefore\"> <div class=control-label ng-messages=createNotificationRule.n_days_before.$error ng-show=notificationRuleVm.showErrorMessages(createNotificationRule.n_days_before)> <div ng-message=required>Campo requerido</div> <div ng-message=min>La cantidad de días debe ser mayor o igual 1</div> <div ng-message=pattern>El número debe ser entero</div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=specific_date_check ng-model=notificationRuleVm.specific_date_check ng-change=notificationRuleVm.changedSpecificDateCheck(notificationRuleVm.specific_date_check) class=\"md-green no-margin\">Fecha de envío</md-checkbox> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\" ng-if=notificationRuleVm.specific_date_check> <div class=form-group ng-class=notificationRuleVm.hasError(createNotificationRule.specific_date)> <md-datepicker ng-model=notificationRuleVm.notification.specific_date name=specific_date ng-keydown=notificationRuleVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-required=\"notificationRuleVm.notification.shipping_time == 'dependent' && notificationRuleVm.specific_date_check\" min=\"{{notificationRuleVm.minDate | date: 'yyyy-MM-dd'}}\" md-min-date=notificationRuleVm.minDate md-placeholder=dd/mm/aaaa></md-datepicker> <div class=control-label ng-messages=createNotificationRule.specific_date.$error ng-show=notificationRuleVm.showErrorMessages(createNotificationRule.specific_date)> <div ng-message=mindate>La fecha debe ser mayor o igual a la fecha actual</div> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha es requerida</div> </div> </div> </div> </div> </div> <div class=\"form-group text-sm\" ng-show=\"notificationRuleVm.notification.shipping_time == 'weekly'\"> <div class=row ng-repeat=\"day in notificationRuleVm.weekdays\"> <div class=\"col-md-12 m-v-xs\"> <md-checkbox ng-model=\"notificationRuleVm.notification.days[$index + 1]\" name=weekday_{{$index}} class=\"md-green no-margin\" ng-required=\"notificationRuleVm.notification.shipping_time == 'weekly' && notificationRuleVm.isDaysEmpty()\">{{day}}</md-checkbox> </div> </div> </div> <div class=form-group> <label>Tipo de envío </label> <div class=row ng-repeat=\"deliveryType in notificationRuleVm.deliveryTypes\"> <div class=\"col-md-12 m-v-xs text-sm\"> <md-checkbox name=\"delivery_type_{{ deliveryType.id_code}}\" ng-model=\"notificationRuleVm.notification.deliveryTypes[ deliveryType.id_code ]\" class=\"md-green no-margin\">{{ deliveryType.ds_name }}</md-checkbox> </div> </div> <input type=hidden name=validateDeliveryType ng-model=validateDeliveryType ng-required=notificationRuleVm.isDeliveryTypeEmpty()> </div> </div> </div> </div> <div class=\"col-md-6 m-b-md\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Cuerpo de notificación</h5> <p class=\"col-md-12 no-padding\">Seleccione una plantilla para ser aplicada a su notificación</p> </div> </div> <div class=row> <div class=\"col-md-12 flex align-items-center\"> <label for=selectedTemplate class=m-r-sm>Plantilla</label> <select name=selectedTemplate ng-model=notificationRuleVm.selectedTemplate ng-options=\"template.ds_name for template in notificationRuleVm.templates\" class=\"form-control m-r-sm\"> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <md-button class=\"btn btn-fw btn-info no-margin\" ng-click=\"notificationRuleVm.changeTemplate( notificationRuleVm.selectedTemplate )\" ng-disabled=!notificationRuleVm.selectedTemplate>Aplicar plantilla</md-button> </div> </div> <div class=\"row mdinputcontainerwrapper\"> <div class=\"col-md-12 flex align-items-center\" layout-gt-sm=row> <md-input-container class=md-block flex-gt-sm> <label for=selectedTemplate class=m-r-sm>Asunto</label> <input type=text ng-required=notificationRuleVm.isSubjectEmpty() ng-model=notificationRuleVm.notification.asunto ng-model-options=\"{ debounce: 300 }\"> </md-input-container> </div> </div> <div class=\"row m-t-lg1\"> <div class=col-md-12> <div class=form-group ng-class=notificationRuleVm.hasError(createNotificationRule.ds_description)> <div class=\"m-b-sm webeditor\" text-angular name=ds_description ng-model=notificationRuleVm.notification.ds_description ta-toolbar=\"[['bold','italics', 'underline'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['ul', 'quote', 'html'], ['insertImage','insertLink'], ['undo', 'redo']]\" required></div> <div class=control-label ng-messages=createNotificationRule.ds_description.$error ng-show=notificationRuleVm.showErrorMessages(createNotificationRule.ds_description)> <div ng-message=required>El campo es requerido</div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row m-h-md no-padding\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel no-margin pull-right\" ui-sref=generalSettings.notificationsManagement>Cancelar</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success no-margin pull-left\" ng-click=notificationRuleVm.saveNotification() ng-disabled=\"notificationRuleVm.validateForm(createNotificationRule) || notificationRuleVm.isSaveButtonDisabled \">Guardar notificación</md-button> </div> </div> </form>";

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v\"> <h3>Gestión de notificaciones - Crear regla de notificación</h3> </div> </div> <form name=createNotificationRule novalidate> <div class=\"row m-h-md no-padding\"> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-6 no-padding-l\"> <h5 class=\"text-azul p-v-xs font-bold\">Configuración general</h5> <div class=row> <div class=col-md-5> <div class=form-group> <label for=notification_type class=control-label>Tipo de notificación</label> <select name=notification_type ng-model=notificationRuleVm.notification.id_notificationType ng-options=\"notificationType.id_code as notificationType.ds_name for notificationType in notificationRuleVm.notificationType\" class=form-control disabled=true> <option value=\"\" selected=selected>Seleccione</option> </select> </div> <div class=form-group> <label class=control-label>Roles a enviar notificación</label> <div class=\"col-md-12 text-sm no-padding m-v-xs\" ng-repeat=\"role in notificationRuleVm.roles\"> <md-checkbox name=rol_{{role.id_code}} class=\"md-green no-margin\" ng-checked=\"notificationRuleVm.isRoleChecked( role.id_code )\" disabled=disabled>{{ role.ds_name }}</md-checkbox> </div> </div> </div> <div class=col-md-7> <div class=form-group> <label class=\"control-label col-md-12 no-padding m-b-sm\">Tiempo de envío</label> <div class=row> <div class=\"col-md-12 no-padding\"> <div class=\"radio-options no-margin\"> <div class=p-l-xl> <input type=radio name=shipping_time ng-model=notificationRuleVm.notification.shipping_time value=dependent disabled=disabled> <i class=radio-green></i> <label>Dependiente del evento</label> </div> <div class=p-l-xl> <input type=radio name=notification.shipping_time ng-model=notificationRuleVm.notification.shipping_time value=weekly disabled=disabled> <i class=radio-green></i> <label>Semanal</label> </div> </div> </div> </div> </div> <div class=\"form-group text-sm\" ng-show=\"notificationRuleVm.notification.shipping_time == 'dependent'\"> <div class=row> <div class=\"col-md-12 m-v-xs\"> <md-checkbox ng-model=notificationRuleVm.notification.is_at_sending_moment ng-checked=notificationRuleVm.notification.is_at_sending_moment name=is_at_sending_moment ng-true-value=1 class=\"md-green no-margin\" disabled=disabled>Al momento del envío</md-checkbox> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=one_day_before ng-checked=notificationRuleVm.notification.oneDayBefore class=\"md-green no-margin\" disabled=disabled>1 día antes</md-checkbox> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=two_days_before ng-checked=notificationRuleVm.notification.twoDaysBefore class=\"md-green no-margin\" disabled=disabled>2 días antes</md-checkbox> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=five_days_before ng-model=notificationRuleVm.notification.fiveDaysBefore class=\"md-green no-margin\" disabled=disabled>5 días antes</md-checkbox> </div> </div> <div class=row> <div class=\"col-md-8 m-v-xs\"> <md-checkbox name=check_n_days_before ng-model=checkNDaysBefore ng-checked=notificationRuleVm.notification.nDaysBefore class=\"md-green no-margin\" disabled=disabled>Cantidad de días antes</md-checkbox> </div> <div class=\"col-md-4 m-v-xs\" ng-show=checkNDaysBefore> <div class=form-group> <input type=number name=n_days_before ng-model=notificationRuleVm.notification.nDaysBefore class=form-control disabled=disabled> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <md-checkbox name=specific_date_check ng-model=notificationRuleVm.specific_date_check ng-checked=notificationRuleVm.notification.specific_date class=\"md-green no-margin\" disabled=disabled>Fecha de envío</md-checkbox> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\" ng-if=notificationRuleVm.specific_date_check> <div class=form-group> <md-datepicker ng-model=notificationRuleVm.notification.specific_date name=specific_date ng-keydown=notificationRuleVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa disabled=disabled></md-datepicker> </div> </div> </div> </div> <div class=\"form-group text-sm\" ng-show=\"notificationRuleVm.notification.shipping_time == 'weekly'\"> <div class=row ng-repeat=\"day in notificationRuleVm.weekdays\"> <div class=col-md-12> <md-checkbox name=weekday_{{$index}} ng-checked=\"notificationRuleVm.isDayChecked( $index + 1)\" class=\"md-green no-margin\" disabled=disabled>{{day}}</md-checkbox> </div> </div> </div> <div class=form-group> <label>Tipo de envío </label> <div class=row ng-repeat=\"deliveryType in notificationRuleVm.deliveryTypes\"> <div class=\"col-md-12 m-v-xs text-sm\"> <md-checkbox name=\"delivery_type_{{ deliveryType.id_code}}\" class=\"md-green no-margin\" ng-checked=notificationRuleVm.isDeliveryTypeChecked(deliveryType.id_code) disabled=disabled>{{ deliveryType.ds_name }}</md-checkbox> </div> </div> </div> </div> </div> </div> <div class=\"col-md-6 b-l-gris-light m-b-md\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Cuerpo de notificación</h5> </div> </div> <div class=\"row mdinputcontainerwrapper\"> <div class=\"col-md-12 flex align-items-center\" layout-gt-sm=row> <label for=selectedTemplate class=m-r-sm>Asunto</label> </div> <div class=\"col-md-12 flex align-items-center\" layout-gt-sm=row> <p class=\"text-sm p-l-md\">{{notificationRuleVm.notification.asunto}}</p> </div> </div> <div class=\"row m-t-lg\"> <div class=col-md-12> <div class=\"m-b-sm webeditor\" text-angular ng-model=notificationRuleVm.notification.ds_description ta-toolbar=\"[['bold','italics', 'underline'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['ul', 'quote', 'html'], ['insertImage','insertLink'], ['undo', 'redo']]\" ta-disabled=true></div> </div> </div> </div> </div> </div> <div class=\"row m-h-md no-padding\"> <div class=\"col-md-11 no-padding text-center\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" ui-sref=generalSettings.notificationsManagement>Volver</md-button> </div> </div> </form>";

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h3>Gestión de notificaciones - Crear mensaje de inicio</h3> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Configuración general</h5> </div> </div> </div> <form name=startMessageForm> <div class=row> <div class=\"col-md-6 p-h-lg\"> <div class=form-group ng-class=startMessageVm.hasError(startMessageForm.asunto)> <label class=control-label for=asunto>Asunto</label> <input type=text ng-model=startMessageVm.message.asunto ng-model-options=\"{ debounce: 300 }\" name=asunto class=form-control required> <div class=control-label ng-messages=startMessageForm.asunto.$error ng-show=startMessageVm.showErrorMessages(startMessageForm.asunto)> <div ng-message=required>El asunto es requerido</div> </div> </div> <div class=form-group ng-class=startMessageVm.hasError(startMessageForm.dsDescription)> <div class=\"m-v-md webeditor\" text-angular name=dsDescription ng-model=startMessageVm.message.dsDescription ta-toolbar=\"[['bold','italics', 'underline'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['ul', 'quote', 'html'], ['insertImage','insertLink'], ['undo', 'redo']]\" required></div> <div class=control-label ng-messages=startMessageForm.dsDescription.$error ng-show=startMessageVm.showErrorMessages(startMessageForm.dsDescription)> <div ng-message=required>La descripcion es requerida</div> </div> </div> </div> <div class=col-md-6> <div class=row> <label>Tiempo de envío</label> <div class=\"form-group select-inline\"> <div class=\"radio-options col-md-4\" ng-repeat=\"schedule in startMessageVm.schedules\"> <input type=radio name=scheduleNotificationTypeId ng-value=schedule.scheduleNotificationTypeId ng-model=startMessageVm.message.scheduleNotificationTypeId ng-change=startMessageVm.scheduleNotificationTypeSelected(schedule.scheduleNotificationType) required/> <i class=radio-green></i> <label>{{schedule.scheduleNotificationType}}</label> </div> </div> </div> <div ng-if=startMessageVm.showInputDates> <div class=row> <div class=\"form-group m-l-n\" ng-class=startMessageVm.hasError(startMessageForm.startDate)> <label class=\"control-label col-md-12\" for=startDate>Fecha inicio</label> <md-datepicker ng-model=startMessageVm.message.startDate min=\"{{startMessageVm.minDate | date : 'yyyy-MM-dd'}}\" md-min-date=startMessageVm.minDate name=startDate ng-keydown=startMessageVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa ng-required=startMessageVm.isDateRequired() ng-change=startMessageVm.startDateChanged() class=m-l-sm></md-datepicker> <div class=control-label ng-messages=startMessageForm.startDate.$error ng-show=startMessageVm.showErrorMessages(startMessageForm.startDate)> <div ng-message=mindate>La fecha debe ser mayor o igual a la fecha actual</div> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha es requerida</div> </div> </div> </div> <div class=row> <div class=\"form-group m-l-n\" ng-class=startMessageVm.hasError(startMessageForm.endDate)> <label class=\"control-label col-md-12\" for=endDate>Fecha fin</label> <md-datepicker ng-model=startMessageVm.message.endDate name=endDate ng-keydown=startMessageVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-min-date=startMessageVm.minEndDate min={{startMessageVm.minEndDate}} md-placeholder=dd/mm/aaaa ng-required=startMessageVm.isDateRequired() ng-change=\"\" class=m-l-sm></md-datepicker> <div class=control-label ng-messages=startMessageForm.endDate.$error ng-show=startMessageVm.showErrorMessages(startMessageForm.endDate)> <div ng-message=valid>La fecha no es válida</div> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha fin debe ser mayor a la fecha inicio</div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-11 m-b-md\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel no-margin pull-right\" ui-sref=generalSettings.notificationsManagement>Cancelar</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success no-margin pull-left\" ng-disabled=\"startMessageVm.validateForm(startMessageForm) || startMessageVm.saveButtonDisabled\" ng-click=startMessageVm.saveStartMessage()>Guardar mensaje</md-button> </div> </div> </div> </form>";

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h3>Gestión de notificaciones - Mensaje de inicio</h3> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Configuración general</h5> </div> </div> </div> <form name=startMessageForm> <div class=row> <div class=\"col-md-6 p-h-lg\"> <div class=form-group> <label class=control-label for=dsName>Asunto</label> <input type=text ng-model=startMessageNotificationVm.message.dsName ng-model-options=\"{ debounce: 300 }\" name=dsName class=form-control disabled=disabled /> </div> <div class=form-group> <div class=\"m-v-md webeditor\" text-angular name=dsDescription ng-model=startMessageNotificationVm.message.dsDescription ta-toolbar=\"[['bold','italics', 'underline'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['ul', 'quote', 'html'], ['insertImage','insertLink'], ['undo', 'redo']]\" ta-disabled=true> </div> </div> </div> <div class=col-md-6> <div class=row> <label>Tiempo de envío</label> <div class=\"form-group select-inline\"> <div class=\"radio-options col-md-4\" ng-repeat=\"schedule in startMessageNotificationVm.schedules\"> <input type=radio name=scheduleNotificationTypeId ng-value=schedule.scheduleNotificationTypeId ng-model=startMessageNotificationVm.message.scheduleNotificationTypeId disabled=disabled /> <i class=radio-green></i> <label>{{schedule.scheduleNotificationType}}</label> </div> </div> </div> <div ng-if=startMessageNotificationVm.showInputDates> <div class=row> <div class=\"form-group m-l-n\"> <label class=\"control-label col-md-12\" for=startDate>Fecha inicio</label> <md-datepicker ng-model=startMessageNotificationVm.message.startDate name=startDate ng-keydown=startMessageNotificationVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa class=m-l-sm disabled=disabled></md-datepicker> </div> </div> <div class=row> <div class=\"form-group m-l-n\"> <label class=\"control-label col-md-12\" for=endDate>Fecha fin</label> <md-datepicker ng-model=startMessageNotificationVm.message.endDate name=endDate ng-keydown=startMessageNotificationVm.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" min={{startMessageNotificationVm.minEndDate}} md-placeholder=dd/mm/aaaa class=m-l-sm disabled=disabled></md-datepicker> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-b-md text-center\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" ui-sref=generalSettings.notificationsManagement>Volver</md-button> </div> </div> </form>";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
		$locationProvider.html5Mode(true);
		$stateProvider.state('generalSettings.users', {
			abstract: false,
			url: '/users',
			template: __webpack_require__(254),
			controller: 'UsersCtrl',
			controllerAs: 'usrVM',
			data: {
				displayName: 'Usuarios',
				order: 3,
				siblings: [{
					name: 'generalSettings.notificationsManagement',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 1
				}, {
					name: 'generalSettings.listParams',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
					order: 2
				}, {
					name: 'generalSettings.listSubject',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 4
				}]
			}
		}).state('generalSettings.createUsers', {
			abstract: false,
			url: '/createUsers/:roleId',
			template: __webpack_require__(255),
			controller: 'CreateUsersCtrl',
			controllerAs: 'createUserVM',
			redirectTo: 'generalSettings.users',
			data: {
				displayName: 'Usuarios',
				order: 3,
				siblings: [{
					name: 'generalSettings.notificationsManagement',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 1
				}, {
					name: 'generalSettings.listParams',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
					order: 2
				}, {
					name: 'generalSettings.listSubject',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 4
				}]
			}
		}).state('generalSettings.createCommittee', {
			abstract: false,
			url: '/createCommittee',
			template: __webpack_require__(256),
			controller: 'CreateCommitteeCtrl',
			controllerAs: 'createCommitteeVM',
			redirectTo: 'generalSettings.users',
			data: {
				displayName: 'Usuarios',
				order: 3,
				siblings: [{
					name: 'generalSettings.notificationsManagement',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 1
				}, {
					name: 'generalSettings.listParams',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
					order: 2
				}, {
					name: 'generalSettings.listSubject',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 4
				}]
			}
		}).state('generalSettings.editCommittee', {
			abstract: false,
			url: '/editCommittee/:committeeId',
			template: __webpack_require__(257),
			controller: 'EditCommitteeCtrl',
			controllerAs: 'editCommitteeVM',
			redirectTo: 'generalSettings.users',
			data: {
				displayName: 'Usuarios',
				order: 3,
				siblings: [{
					name: 'generalSettings.notificationsManagement',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 1
				}, {
					name: 'generalSettings.listParams',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin],
					order: 2
				}, {
					name: 'generalSettings.listSubject',
					rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant],
					order: 4
				}]
			}
		}).state('fullscreen.listCommittee', {
			abstract: false,
			url: '/listCommittee',
			template: __webpack_require__(258),
			controller: 'ListCommitteeCtrl',
			controllerAs: 'listCommVM',
			data: {
				displayName: 'Listado comités por usuario'
			}
		});
	}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\" has-permission=acceso-administracion-roles-view> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <h3>Gestión de usuarios</h3> <p class=text-xs>En esta sección puede revisar y asignar roles a usuarios</p> </div> <div class=\"col-md-4 p tab-title-with-form flex align-items-center m-r-md\"> <label class=\"control-label text-base text-gris-dark\">Nuevo</label> <select class=\"form-control m-sm p-xs\" ng-model=usrVM.selectedRole ng-options=\"role.ds_name for role in usrVM.roles\"> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <md-button class=\"btn btn-fw btn-success no-margin\" ng-click=usrVM.router(usrVM.selectedRole) ng-disabled=!usrVM.selectedRole>Crear permisos</md-button> </div> </div> <div> <div class=\"row p-t search\" has-permission=acceso-administracion-roles-view> <div class=\"col-md-12 no-paddin p-l-lg\"> <div class=\"input-group stylish-input-group m-r-md\"> <input type=text ng-model=usrVM.usersFilter ng-model-options=\"{ debounce: 300 }\" ng-change=usrVM.filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row p-t m-r-md\" has-permission=acceso-administracion-roles-view> <div class=\"col-md-12 m-l\"> <div class=\"grid grid-blue\" ui-grid=usrVM.usersGrid ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination> </div> </div> </div> <div class=\"row title\" style=margin-top:13px> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>Gestión de comités</h3> <p class=text-xs>En esta secci&oacute;n puede gestionar comités</p> </div> <div class=\"col-md-4 p tab-title-with-form flex align-items-center m-r-md\" has-permission=crear-comite-edit> <md-button class=\"btn btn-fw btn-success m-xs pull-right\" ng-click=usrVM.router(usrVM.rolescomitee)>Crear comité</md-button> </div> </div> <div class=\"row p-t search\"> <div class=\"col-md-12 no-paddin p-l-lg\"> <div class=\"input-group stylish-input-group m-r-md\"> <input type=text ng-model=usrVM.usersFiltercomitee ng-model-options=\"{ debounce: 300 }\" ng-change=usrVM.filtercomitee() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row p-t m-r-md\"> <div class=\"col-md-12 m-l\"> <div class=\"grid text-xs\" ui-grid=usrVM.usersComiteeGrid ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination> </div> </div> </div> </div> ";

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Asignar {{createUserVM.role.ds_name}}</h3> <p class=text-xs>Diligencie los datos en el formulario para asignar el rol a un usuario. Puede hacer esto cuantas veces sea necesario.</p> </div> </div> <div class=\"row m-l-sm\"> <div class=col-md-7> <p class=\"text-azul text-md m-v\">Configuracion general</p> <div class=row> <div class=col-md-7> <div ng-if=\"createUserVM.showAcademicUnit === true\"> <p>Unidades académicas disponibles</p> <select class=\"form-control m-t-sm m-b-lg p-xs\" ng-model=createUserVM.selectedUnit ng-options=\"unit.ds_name for unit in createUserVM.academicUnits\" ng-disabled=\"createUserVM.uaIdDefault != 0\"> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> <p>Usuario a asignar</p> <p class=\"text-sm text-gris-darker\">Buscar por:</p> <div class=\"radio-options no-margin\"> <div class=p-l-xl> <input type=radio name=shipping_time ng-model=createUserVM.searchBy value=1> <i class=radio-green></i> <label>Nombre</label> </div> <div class=p-l-xl> <input type=radio name=notification.shipping_time ng-model=createUserVM.searchBy value=2> <i class=radio-green></i> <label>Cédula</label> </div> </div> <div class=\"col-md-12 no-padding m-v-sm\"> <input type=hidden name=users ng-model=user ng-required=\"createUserVM.selectedUsers.length == 0\"> <md-autocomplete class=\"autocomplete no-padding m-r-xs\" md-item-text=users.ds_fullname md-min-length=0 md-selected-item=createUserVM.selectedUser md-search-text=searchText md-items=\"users in createUserVM.searchUsers(searchText)\" placeholder=Buscar> <md-item-template> <span ng-if=\"createUserVM.searchBy === '1'\" md-highlight-text=searchText md-highlight-flags=^i>{{users.ds_fullname}}</span> <span ng-if=\"createUserVM.searchBy === '2'\" md-highlight-text=searchText md-highlight-flags=^i>{{users.ds_identification}}</span> </md-item-template> <md-not-found> No se encontró profesores con nombre \"{{searchText}}\" </md-not-found> </md-autocomplete> </div> </div> <div class=col-md-5> <p>Permisos asignados</p> <ul> <div class=\"no-padding m-v-sm\" ng-repeat=\"feature in createUserVM.features\"> <li class=text-xs ng-if=createUserVM.exists(feature)>{{feature.ds_name}}</li> </div> </ul> </div> </div> <div class=row> <div class=\"col-md-12 m-t-md\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" ui-sref=generalSettings.users>Volver</md-button> <md-button class=\"btn btn-success text-xs p-h-md no-margin\" ng-disabled=\"createUserVM.isDisabled || createUserVM.validateForm() || createUserVM.checkIsOverMax()\" ng-click=createUserVM.addPermissionToUser()>Asignar {{createUserVM.role.ds_name}}</md-button> </div> </div> </div> <div class=\"col-md-1 verticalDivider no-padding m-l-md\" style=width:10px></div> <div class=\"col-md-4 m-v\"> <p class=\"text-azul text-md m-v\">Usuarios asignados</p> <div class=row ng-repeat=\"assignment in createUserVM.listOfAssignments track by $index\"> <div class=col-md-10> <p class=\"text-xs p-sm text-gris-darker\"> {{assignment.ds_fullname}} - {{assignment.academicName }} </p> </div> <div class=col-md-2> <md-button class=md-icon-button ng-click=createUserVM.confirmDisableUser(assignment,$index) aria-label=confirmDisabled> <i class=\"icon mdi-navigation-close i-20 text-gris-darker\"></i> </md-button> </div> </div> </div> </div>";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Asignación de usuarios a comités evaluadores</h3> <p class=text-xs>Indique en el siguiente formulario los datos del nuevo comité y de los profesores cuya información podrá ser consultada por esta nueva instancia.</p> </div> </div> <form name=committeeForm> <div class=\"row m-l-sm\"> <div class=col-md-6> <h5 class=\"text-azul font-bold p-v-xs\">Crear comité</h5> <div class=row> <div class=col-md-7> <div class=form-group ng-class=createCommitteeVM.hasError(committeeForm.newCommittee)> <label class=\"control-label col-md-12 no-padding\" for=newCommittee>Nombre comité</label> <input class=\"p-h-sm p-v-xs text-xs form-control\" type=text name=newCommittee ng-model=createCommitteeVM.newCommittee ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=committeeForm.newCommittee.$error ng-show=createCommitteeVM.showErrorMessages(committeeForm.newCommittee)> <div ng-message=required>El nombre es requerido</div> </div> </div> <div class=m-v-sm> <div class=form-group ng-class=createCommitteeVM.hasError(committeeForm.startDate)> <label class=\"control-label col-md-12 no-padding\" for=startDate>Fecha inicio</label> <md-datepicker min=\"{{createCommitteeVM.minStartDate | date : 'dd/MM/yyyy'}}\" md-min-date=createCommitteeVM.minStartDate ng-model=createCommitteeVM.startDate name=startDate ng-keydown=createCommitteeVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-change=createCommitteeVM.startDateChanged() md-placeholder=dd/mm/aaaa required> </md-datepicker> <div class=control-label ng-messages=committeeForm.startDate.$error ng-show=createCommitteeVM.showErrorMessages(committeeForm.startDate)> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha debe ser mayor o igual a la fecha actual</div> <div ng-message=valid>El formato de la fecha no es válido</div> </div> </div> <div class=form-group ng-class=createCommitteeVM.hasError(committeeForm.endDate)> <label for=endDate class=\"control-label col-md-12 no-padding\">Fecha fin</label> <md-datepicker name=endDate ng-keydown=createCommitteeVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-model=createCommitteeVM.endDate min={{createCommitteeVM.minEndDate}} md-min-date=createCommitteeVM.minEndDate md-placeholder=dd/mm/aaaa required> </md-datepicker> <div class=control-label ng-messages=committeeForm.endDate.$error ng-show=createCommitteeVM.showErrorMessages(committeeForm.endDate)> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha debe ser mayor o igual a la fecha inicio</div> <div ng-message=valid>El formato de la fecha no es válido</div> </div> </div> </div> </div> <div class=col-md-5> <label class=control-label>Actividades visibles para el comité</label> <md-checkbox class=\"md-green m-v-xs text-xs custom-checkbox\" aria-label=\"Select All\" ng-checked=createCommitteeVM.isChecked() md-indeterminate=createCommitteeVM.isIndeterminate() ng-click=createCommitteeVM.toggleAll()> Todos </md-checkbox> <div class=\"col-md-12 no-padding text-xs text-left\" ng-repeat=\"submodule in createCommitteeVM.submodules\"> <md-checkbox class=\"md-green m-v-xs text-xs custom-checkbox\" ng-model=selectedSubmodules ng-click=createCommitteeVM.toggle(submodule) ng-checked=createCommitteeVM.exists(submodule)> {{ submodule.ds_name }} </md-checkbox> </div> </div> </div> <div class=row> <div class=\"col-md-7 no-padding-r m-v-xs\"> <div class=\"form-group col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\">Agregar administrador de comité</label> <md-autocomplete class=\"custom-autoselect autocomplete col-md-9 no-padding m-r-xs\" md-item-text=users.ds_fullname md-min-length=0 md-selected-item=createCommitteeVM.selectedAdminUser md-search-text=createCommitteeVM.searchAdminText md-items=\"users in createCommitteeVM.searchUsers(createCommitteeVM.searchAdminText)\" md-clear-button=false placeholder=Buscar> <md-item-template> <span ng-if=\"createCommitteeVM.searchBy === '1'\" md-highlight-text=createCommitteeVM.searchAdminText md-highlight-flags=^i>{{users.ds_fullname}}</span> <span ng-if=\"createCommitteeVM.searchBy === '2'\" md-highlight-text=createCommitteeVM.searchAdminText md-highlight-flags=^i>{{users.ds_identification}}</span> </md-item-template> <md-not-found> No se encontraron profesores con nombre \"{{createCommitteeVM.searchAdminText}}\" </md-not-found> </md-autocomplete> <div class=\"col-md-2 no-padding\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=createCommitteeVM.addAdminUsertoComittee(createCommitteeVM.selectedAdminUser)></i> </div> </div> </div> <div class=\"col-md-4 m-t\"> <p class=\"text-sm text-gris-darker no-margin\">Buscar por:</p> <div class=\"radio-options no-margin\"> <div class=no-padding-v> <input type=radio ng-model=createCommitteeVM.searchAdminBy value=1> <i class=radio-green></i> <label class=\"m-xs text-xs\">Nombre</label> </div> <div class=no-padding-v> <input type=radio ng-model=createCommitteeVM.searchAdminBy value=2> <i class=radio-green></i> <label class=\"m-xs text-xs\">Cédula</label> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <ul class=\"without-bullets col-md-12 no-padding\"> <li class=\"teacherList text-md\"> <p class=\"text-sm no-margin\">{{createCommitteeVM.committeeAdminUser.ds_fullname}}</p> <md-button class=\"md-icon-button no-margin\" aria-label=dropUser ng-click=createCommitteeVM.dropAdminUser()> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> <div class=row> <div class=\"col-md-7 no-padding-r m-v-xs\"> <div class=\"form-group col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\">Agregar usuarios al comité</label> <md-autocomplete class=\"custom-autoselect autocomplete col-md-9 no-padding m-r-xs\" md-item-text=users.ds_fullname md-min-length=0 md-selected-item=createCommitteeVM.selectedUser md-search-text=createCommitteeVM.searchText md-items=\"users in createCommitteeVM.searchUsers(createCommitteeVM.searchText)\" md-clear-button=false placeholder=Buscar> <md-item-template> <span ng-if=\"createCommitteeVM.searchBy === '1'\" md-highlight-text=createCommitteeVM.searchText md-highlight-flags=^i>{{users.ds_fullname}}</span> <span ng-if=\"createCommitteeVM.searchBy === '2'\" md-highlight-text=createCommitteeVM.searchText md-highlight-flags=^i>{{users.ds_identification}}</span> </md-item-template> <md-not-found> No se encontraron profesores con nombre \"{{createCommitteeVM.searchText}}\" </md-not-found> </md-autocomplete> <div class=\"col-md-2 no-padding\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=createCommitteeVM.addUserToCommittee(createCommitteeVM.selectedUser)></i> </div> </div> </div> <div class=\"col-md-4 m-t\"> <p class=\"text-sm text-gris-darker no-margin\">Buscar por:</p> <div class=\"radio-options no-margin\"> <div class=no-padding-v> <input type=radio ng-model=createCommitteeVM.searchBy value=1> <i class=radio-green></i> <label class=\"m-xs text-xs\">Nombre</label> </div> <div class=no-padding-v> <input type=radio ng-model=createCommitteeVM.searchBy value=2> <i class=radio-green></i> <label class=\"m-xs text-xs\">Cédula</label> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <ul class=\"without-bullets col-md-12 no-padding\"> <li ng-repeat=\"user in createCommitteeVM.committeeUsers track by $index\" class=\"teacherList text-md\"> <p class=\"text-sm no-margin\">{{user.ds_fullname}}</p> <md-button class=\"md-icon-button no-margin\" aria-label=dropUser ng-click=createCommitteeVM.dropUser($index)> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> </div> <div class=\"col-md-5 no-padding-r b-l-gris-light\"> <div class=row> <div class=\"col-md-12 m-l no-padding\"> <h5 class=\"text-azul font-bold\"> Usuarios a consultar</h5> <p class=\"text-sm text-gris-darker\">Seleccione en la tabla los usuarios que serán consultados en el comité que está creando</p> <div class=\"grid grid-blue\" ui-grid=createCommitteeVM.committeeGrid ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination ui-grid-selection> </div> </div> </div> </div> </div> <div class=row> <div class=\"text-center m-t-md\"> <md-button aria-label class=\"btn btn-fw btn-cancel no-margin\" ui-sref=generalSettings.users>Cancelar</md-button> <md-button class=\"btn btn-success text-xs p-h-md no-margin\" ng-disabled=\"createCommitteeVM.isDisabled ||\n      committeeForm.$invalid ||\n      createCommitteeVM.committeeUsers.length == 0 ||\n      createCommitteeVM.selectedTeachers.length == 0 ||\n      createCommitteeVM.selectedSubmodules.length == 0\" ng-click=createCommitteeVM.saveCommitteeConfig()> Guardar configuración de comité </md-button> </div> </div> </form>";

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Asignación de usuarios a comités evaluadores</h3> <p class=text-xs>Indique en el siguiente formulario los datos del comité y de los profesores cuya información podrá ser consultada por esta nueva instancia.</p> </div> </div> <form name=committeeForm> <div class=\"row m-l-sm\"> <div class=col-md-6> <h5 class=\"text-azul font-bold p-v-xs\">Editar comité</h5> <div class=row> <div class=col-md-7> <div class=form-group ng-class=editCommitteeVM.hasError(committeeForm.newCommittee)> <label for=newCommittee class=\"control-label col-md-12 no-padding\">Nombre comité</label> <input class=\"p-h-sm p-v-xs text-xs form-control\" type=text name=newCommittee ng-model=editCommitteeVM.newCommittee ng-model-options=\"{ debounce: 300 }\" required ng-disabled=editCommitteeVM.isCommitteeAdminUser> <div class=control-label ng-messages=committeeForm.newCommittee.$error ng-show=editCommitteeVM.showErrorMessages(committeeForm.newCommittee)> <div ng-message=required>El nombre es requerido</div> </div> </div> <div class=m-v-sm> <div class=form-group ng-class=editCommitteeVM.hasError(committeeForm.startDate)> <label class=\"control-label col-md-12 no-padding\" for=startDate>Fecha inicio</label> <md-datepicker ng-disabled=editCommitteeVM.isCommitteeAdminUser class=\"text-left datepicker-select no-padding no-m-t m-b-sm\" name=startDate ng-keydown=editCommitteeVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-model=editCommitteeVM.startDate min=\"{{editCommitteeVM.startDate | date : 'dd/MM/yyyy'}}\" md-min-date=editCommitteeVM.startDate ng-change=editCommitteeVM.startDateChanged() md-placeholder=dd/mm/aaaa md-hide-icons=calendar required> </md-datepicker> <div class=control-label ng-messages=committeeForm.startDate.$error ng-show=editCommitteeVM.showErrorMessages(committeeForm.startDate) has-permission=crear-comite-edit> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha debe ser mayor o igual a la fecha actual</div> <div ng-message=valid>El formato de la fecha no es válido</div> </div> </div> <div class=form-group ng-class=editCommitteeVM.hasError(committeeForm.endDate)> <label for=endDate class=\"control-label col-md-12 no-padding\">Fecha fin</label> <md-datepicker ng-disabled=editCommitteeVM.isCommitteeAdminUser class=\"text-left datepicker-select no-padding no-m-t m-b-sm\" name=endDate ng-keydown=editCommitteeVM.preventInput($event) onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-model=editCommitteeVM.endDate min={{editCommitteeVM.minEndDate}} md-min-date=editCommitteeVM.minEndDate md-placeholder=dd/mm/aaaa md-hide-icons=calendar required> </md-datepicker> <div class=control-label ng-messages=committeeForm.endDate.$error ng-show=editCommitteeVM.showErrorMessages(committeeForm.endDate) has-permission=crear-comite-edit> <div ng-message=required>La fecha es requerida</div> <div ng-message=mindate>La fecha debe ser mayor o igual a la fecha inicio</div> <div ng-message=valid>El formato de la fecha no es válido</div> </div> </div> </div> </div> <div class=col-md-5> <label class=control-label>Actividades visibles para el comité</label> <md-checkbox class=\"md-green m-v-xs text-xs custom-checkbox\" aria-label=\"Select All\" ng-checked=editCommitteeVM.isChecked() md-indeterminate=editCommitteeVM.isIndeterminate() ng-click=editCommitteeVM.toggleAll() has-disabled=crear-comite-edit> Todos </md-checkbox> <div class=\"col-md-12 no-padding text-xs text-left\" ng-repeat=\"submodule in editCommitteeVM.submodules\"> <md-checkbox class=\"md-green m-v-xs text-xs custom-checkbox\" ng-model=selectedSubmodules ng-click=editCommitteeVM.toggle(submodule) ng-checked=editCommitteeVM.exists(submodule) has-disabled=crear-comite-edit> {{ submodule.ds_name }} </md-checkbox> </div> </div> </div> <div class=row> <div class=\"col-md-7 no-padding-r m-v-xs\"> <div class=\"form-group col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\">Agregar administrador de comité</label> <md-autocomplete ng-disabled=editCommitteeVM.isCommitteeAdminUser class=\"custom-autoselect autocomplete col-md-9 no-padding m-r-xs\" md-item-text=users.ds_fullname md-min-length=0 md-selected-item=editCommitteeVM.selectedAdminUser md-search-text=editCommitteeVM.searchAdminText md-items=\"users in editCommitteeVM.searchUsers(editCommitteeVM.searchAdminText)\" md-clear-button=false placeholder=Buscar> <md-item-template> <span ng-if=\"editCommitteeVM.searchBy === '1'\" md-highlight-text=editCommitteeVM.searchAdminText md-highlight-flags=^i>{{users.ds_fullname}}</span> <span ng-if=\"editCommitteeVM.searchBy === '2'\" md-highlight-text=editCommitteeVM.searchAdminText md-highlight-flags=^i>{{users.ds_identification}}</span> </md-item-template> <md-not-found> No se encontraron profesores con nombre \"{{editCommitteeVM.searchAdminText}}\" </md-not-found> </md-autocomplete> <div class=\"col-md-2 no-padding\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=editCommitteeVM.addAdminUsertoComittee(editCommitteeVM.selectedAdminUser)></i> </div> </div> </div> <div class=\"col-md-4 m-t\"> <p class=\"text-sm text-gris-darker no-margin\">Buscar por:</p> <div class=\"radio-options no-margin\"> <div class=no-padding-v> <input type=radio ng-model=editCommitteeVM.searchAdminBy value=1> <i class=radio-green></i> <label class=\"m-xs text-xs\">Nombre</label> </div> <div class=no-padding-v> <input type=radio ng-model=editCommitteeVM.searchAdminBy value=2> <i class=radio-green></i> <label class=\"m-xs text-xs\">Cédula</label> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <ul class=\"without-bullets col-md-12 no-padding\"> <li class=\"teacherList text-md\" ng-if=editCommitteeVM.committeeAdminUser> <p class=\"text-sm no-margin\">{{editCommitteeVM.committeeAdminUser.ds_fullname}}</p> <md-button class=\"md-icon-button no-margin\" aria-label=dropUser ng-click=editCommitteeVM.dropAdminUser()> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> <div class=row> <div class=\"col-md-7 no-padding-r m-v-xs\"> <div class=\"form-group col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\">Agregar usuarios al comité</label> <md-autocomplete class=\"custom-autoselect autocomplete col-md-9 no-padding m-r-xs\" md-item-text=users.ds_fullname md-min-length=0 md-selected-item=editCommitteeVM.selectedUser md-search-text=editCommitteeVM.searchText md-items=\"users in editCommitteeVM.searchUsers(editCommitteeVM.searchText)\" md-clear-button=false placeholder=Buscar> <md-item-template> <span ng-if=\"editCommitteeVM.searchBy === '1'\" md-highlight-text=editCommitteeVM.searchText md-highlight-flags=^i>{{users.ds_fullname}}</span> <span ng-if=\"editCommitteeVM.searchBy === '2'\" md-highlight-text=editCommitteeVM.searchText md-highlight-flags=^i>{{users.ds_identification}}</span> </md-item-template> <md-not-found> No se encontraron profesores con nombre \"{{editCommitteeVM.searchText}}\" </md-not-found> </md-autocomplete> <div class=\"col-md-2 no-padding\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=editCommitteeVM.addUserToCommittee(editCommitteeVM.selectedUser)></i> </div> </div> </div> <div class=\"col-md-4 m-t\"> <p class=\"text-sm text-gris-darker no-margin\">Buscar por:</p> <div class=\"radio-options no-margin\"> <div class=no-padding-v> <input type=radio ng-model=editCommitteeVM.searchBy value=1> <i class=radio-green></i> <label class=\"m-xs text-xs\">Nombre</label> </div> <div class=no-padding-v> <input type=radio ng-model=editCommitteeVM.searchBy value=2> <i class=radio-green></i> <label class=\"m-xs text-xs\">Cédula</label> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <ul class=\"without-bullets col-md-12 no-padding\"> <li ng-repeat=\"user in editCommitteeVM.committeeUsers track by $index\" class=\"teacherList text-md\"> <p class=\"text-sm no-margin\">{{user.ds_fullname}}</p> <md-button class=\"md-icon-button no-margin\" aria-label=dropUser ng-click=editCommitteeVM.dropUser($index)> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> </div> <div class=\"col-md-5 no-padding-r b-l-gris-light\"> <div class=row> <div class=\"col-md-12 m-l no-padding\"> <h5 class=\"text-azul font-bold\"> Usuarios a consultar</h5> <p class=\"text-sm text-gris-darker\">Seleccione en la tabla los usuarios que serán consultados en el comité que está editando</p> <div class=\"grid grid-blue\" ui-grid=editCommitteeVM.committeeGrid ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination ui-grid-selection> </div> </div> </div> </div> </div> <div class=row> <div class=\"text-center m-t-md\"> <md-button aria-label class=\"btn btn-fw btn-cancel no-margin\" ui-sref=generalSettings.users>Cancelar</md-button> <md-button class=\"btn btn-success text-xs p-h-md no-margin\" ng-disabled=\"editCommitteeVM.isDisabled ||\n      committeeForm.$invalid ||\n      editCommitteeVM.committeeUsers.length === 0 ||\n      editCommitteeVM.selectedTeachers.length === 0 ||\n      editCommitteeVM.selectedSubmodules.length === 0\" ng-click=editCommitteeVM.saveCommitteeConfig()> Guardar configuración de comité </md-button> </div> </div> </form>";

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = "<style>.ui-grid-viewport{overflow-anchor:none}</style> <div class=\"col-md-3 text-blanco\"> <div class=row> <div class=col-md-12> <h4>Comite de usuario</h4> <ul class=\"m-t text-blanco list-vert-trans\"> <li ng-repeat=\"committee in listCommVM.listCommiters track by $index\" ng-class=listCommVM.isActive($index) class=b-b ng-click=listCommVM.selectCommittee($index)> <i class=\"mdi-action-group-work i-24\"></i> <p> {{committee.commitee.ds_name}} </p> </li> </ul> </div> </div> </div> <div class=col-md-9> <div class=\"row title p-v-sm\"> <div class=col-md-12> <div class=col-md-12> <h1 class=\"text-blanco text-left\">Bienvenido a los comités por usuario <span class=text-md></span> </h1> </div> </div> </div> <div class=row> <div class=col-xs-12> <div class=m-t-lg> <div class=grid-workplan ui-grid=listCommVM.gridOptions ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns> <div class=no-rows ng-if=listCommVM.noData> <div class=msg> <span>El comité no tiene profesores asociados</span> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GeneralSettingsSrv = function GeneralSettingsSrv($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, GeneralSettingsSrv);
	
	  // NOTIFICATIONS SERVICES
	  var notification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification', {}, {
	    getList: {
	      method: 'POST'
	    }
	  });
	
	  var getTeacherByfacultyId = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getTeacherByfacultyId', {}, {
	    getTeacherByfacultyId: {
	      method: 'GET'
	    }
	  });
	
	  var scheduleNotificationType = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/scheduleNotifications', {}, {
	    getList: {
	      method: 'GET'
	    }
	  });
	
	  var getSubjects = $resource(SERVICE_URL_CONSTANT.rosario + '/subject', {}, {
	    getList: {
	      method: 'POST'
	    }
	  });
	
	  var getInfoCreateNewSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getInfoCreateNewSubject', {}, {
	    getList: {
	      method: 'GET'
	    }
	  });
	
	  var createStartMessage = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/createStartMessage', {}, {
	    save: {
	      method: 'POST'
	    }
	  });
	
	  var updateSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/updateSubject', {}, {
	    update: {
	      method: 'POST'
	    }
	  });
	
	  var addNewSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/addNewSubject', {}, {
	    save: {
	      method: 'POST'
	    }
	  });
	
	  var customNotificationData = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/customNotificationData', {}, {
	    getList: {
	      method: 'POST'
	    }
	  });
	
	  var createCustomNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/createCustomNotification', {}, {
	    save: {
	      method: 'POST'
	    }
	  });
	
	  var disableSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/disableSubject', {}, {
	    disable: {
	      method: 'POST'
	    }
	  });
	
	  var getAllDataNotificationRules = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getAllDataNotificationRules', {}, {
	    getList: {
	      method: 'GET'
	    }
	  });
	
	  var createNotificationRule = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/createNotificationRule', {}, {
	    save: {
	      method: 'POST'
	    }
	  });
	
	  var getNotificationById = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getNotificationById/:notificationId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var updateNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/updateNotification', {}, {
	    update: {
	      method: 'POST'
	    }
	  });
	
	  //  PARAMETERS SERVICES
	  var getSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/list/getTypeList', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getListData = $resource(SERVICE_URL_CONSTANT.rosario + '/list/getLists/:idTypeList', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getSubject/:subjectId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var addListItem = $resource(SERVICE_URL_CONSTANT.rosario + '/list/addListItem', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var changeStatus = $resource(SERVICE_URL_CONSTANT.rosario + '/list/changeListItemStatus', {}, {
	    change: {
	      method: 'POST'
	    }
	  });
	
	  var disableNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/deleteNotification', {}, {
	    disable: {
	      method: 'POST'
	    }
	  });
	
	  // USERS SERVICES
	  var getUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/user', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getUsersWithRole = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getUsersWithRole', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getRoles = $resource(SERVICE_URL_CONSTANT.rosario + '/role/getSecRole', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var disableCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/disableComiteeForUser', {}, {
	    post: {
	      method: 'POST'
	    }
	  });
	
	  var disablePermit = $resource(SERVICE_URL_CONSTANT.rosario + '/user/disablePermissionForUser', {}, {
	    post: {
	      method: 'POST'
	    }
	  });
	
	  // CREATE USERS SERVICES
	  var getFormData = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getDataFormUsers', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var addPermission = $resource(SERVICE_URL_CONSTANT.rosario + '/user/addPermissionUsers', {}, {
	    post: {
	      method: 'POST'
	    }
	  });
	
	  // CREATE COMMITTEE SERVICES
	  var getCommitteeFormData = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getDataFormComitee', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var addCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/addComitee', {}, {
	    post: {
	      method: 'POST'
	    }
	  });
	
	  // EDIT COMMITTEE SERVICES
	  var getCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getComiteeById/:comiteeId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var updateCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/updateComitee', {}, {
	    post: {
	      method: 'POST'
	    }
	  });
	  //COMMITTEE BY USER
	  var getCommitteersByUser = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getCommittersAndTeacherByUser/:idUser', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getCommittersByUserId = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getCommittersByUserId/:idUser', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  // Services Declarations
	  return {
	    // NOTIFICATIONS
	    notification: notification,
	    scheduleNotificationType: scheduleNotificationType,
	    createStartMessage: createStartMessage,
	    customNotificationData: customNotificationData,
	    createCustomNotification: createCustomNotification,
	    getInfoCreateNewSubject: getInfoCreateNewSubject,
	    getAllDataNotificationRules: getAllDataNotificationRules,
	    getSubjects: getSubjects,
	    disableSubject: disableSubject,
	    createNotificationRule: createNotificationRule,
	    disableNotification: disableNotification,
	    getNotificationById: getNotificationById,
	    updateNotification: updateNotification,
	    // PARAMETERS
	    getSubmodules: getSubmodules,
	    getListData: getListData,
	    addListItem: addListItem,
	    getSubject: getSubject,
	    updateSubject: updateSubject,
	    addNewSubject: addNewSubject,
	    changeStatus: changeStatus,
	    // USERS
	    getUsers: getUsers,
	    getUsersWithRole: getUsersWithRole,
	    getRoles: getRoles,
	    disableCommittee: disableCommittee,
	    disablePermit: disablePermit,
	    // CREATE USER
	    getFormData: getFormData,
	    addPermission: addPermission,
	    // CREATE COMMETTEE
	    getCommitteeFormData: getCommitteeFormData,
	    addCommittee: addCommittee,
	    // EDIT COMMITTEE SERVICES
	    getCommittee: getCommittee,
	    updateCommittee: updateCommittee,
	    getTeacherByfacultyId: getTeacherByfacultyId,
	    //COMMITTEE BY USER
	    getCommitteersByUser: getCommitteersByUser,
	    getCommittersByUserId: getCommittersByUserId
	  };
	};
	
	GeneralSettingsSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	exports.default = angular.module('services.GeneralSettingsSrv', []).service('GeneralSettingsSrv', GeneralSettingsSrv).name;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NotificationsListCtrl = function NotificationsListCtrl($scope, uiGridConstants, $interval, GeneralSettingsSrv, i18nService, $mdDialog, $cookies, Validations, permissions, GlobalConfig) {
	  _classCallCheck(this, NotificationsListCtrl);
	
	  var notificationListVM = this;
	  var user = JSON.parse($cookies.get('currentUser'));
	  var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	  var startMessageId = GlobalConfig.generalSettings.notificationsType.startMessage;
	
	  $scope.$on('permissionsChanged', filterGridData);
	
	  i18nService.setCurrentLang('es');
	
	  notificationListVM.filter = filter;
	  notificationListVM.singleFilter = singleFilter;
	  notificationListVM.disableNotification = disableNotification;
	  notificationListVM.isAdminOrGerencialConsultant = Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId);
	
	  notificationListVM.gridNotifications = {
	    enableFiltering: true,
	    columnDefs: [_defineProperty({
	      name: 'Nombre',
	      displayName: 'Nombre',
	      field: 'notification_name',
	      width: '15%',
	      headerCellClass: notificationListVM.highlightFilteredHeader,
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs'
	    }, 'headerCellClass', 'font-normal text-xs'), {
	      name: 'Tipo notificación',
	      displayName: 'Tipo notificación',
	      field: 'notification_type',
	      width: '15%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs',
	      headerCellClass: 'font-normal text-xs'
	    }, {
	      name: 'Fecha de envío',
	      displayName: 'Fecha de envío',
	      field: 'delivery_date',
	      width: '15%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs',
	      headerCellClass: 'font-normal text-xs',
	      cellFilter: "date: 'dd/MM/yyyy': 'UTC'"
	    }, {
	      name: 'Tipo de envío',
	      displayName: 'Tipo de envío',
	      field: 'delivery_type',
	      width: '15%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs',
	      headerCellClass: 'font-normal text-xs'
	    }, {
	      name: 'Roles de envío',
	      displayName: 'Roles de envío',
	      field: 'role_name',
	      width: '15%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs',
	      headerCellClass: 'font-normal text-xs',
	      cellTemplate: '<div class="ui-grid-cell-contents">' + '<a href="#" data-toggle="tooltip" data-placement="bottom" title="{{row.entity.role_name}}">{{row.entity.role_name}}</a>' + '</div>'
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      field: '',
	      width: '25%',
	      enableFiltering: false,
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'column-center text-xs',
	      headerCellClass: 'column-center font-normal text-xs',
	      cellTemplate: __webpack_require__(261)
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      notificationListVM.gridApi = gridApi;
	      notificationListVM.gridApi.grid.registerRowsProcessor(notificationListVM.singleFilter, 200);
	      $interval(function () {
	        notificationListVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	
	  activate();
	
	  function activate() {
	    return getNotifications().then(function () {});
	  }
	
	  function getNotifications() {
	    var header = {};
	
	    if (notificationListVM.isAdminOrGerencialConsultant) {
	      header.userId = user.id;
	      header.rolId = currentRoleId;
	    }
	
	    return GeneralSettingsSrv.notification.getList(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        notificationListVM.gridData = dataReturn.data;
	        filterGridData();
	      } else {
	        notificationListVM.gridNotifications.data = [];
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function filter() {
	    notificationListVM.gridApi.grid.refresh();
	  };
	
	  function singleFilter(renderableRows) {
	    var matcher = new RegExp(notificationListVM.searchFilter, 'i');
	    renderableRows.forEach(function (row) {
	      var match = false;
	      ['notification_type', 'stage_name', 'delivery_type', 'role_name'].forEach(function (field) {
	        if (row.entity[field] && row.entity[field].match(matcher)) {
	          match = true;
	        }
	      });
	      if (!match) {
	        row.visible = false;
	      }
	    });
	    return renderableRows;
	  };
	
	  function disableNotification(row) {
	    var notificationName = row.entity.notification_name;
	    var notificationType = row.entity.notification_type;
	    var notificationId = row.entity.notification_id;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.notificationName = notificationName;
	        $scope.notificationType = notificationType;
	        $scope.notificationId = notificationId;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	
	        $scope.disable = function (notificationId) {
	          GeneralSettingsSrv.disableNotification.disable({ idNotification: notificationId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status == true) {
	              var index = notificationListVM.gridNotifications.data.indexOf(row.entity);
	              notificationListVM.gridNotifications.data.splice(index, 1);
	              notificationListVM.gridApi.grid.refresh();
	              $mdDialog.hide();
	            } else {}
	          }, function (data) {
	            console.log(data);
	          });
	        };
	      }],
	      template: __webpack_require__(262),
	      clickOutsideToClose: true
	    });
	  }
	
	  function filterGridData() {
	    if (notificationListVM.gridData) {
	      if (permissions.hasPermission('mensajes-de-inicio-edit')) {
	        notificationListVM.gridNotifications.data = angular.copy(notificationListVM.gridData);
	      } else {
	        notificationListVM.gridNotifications.data = notificationListVM.gridData.filter(function (notification) {
	          return notification.notification_type_id !== startMessageId;
	        });
	      }
	    }
	  }
	};
	
	exports.default = NotificationsListCtrl;
	
	
	NotificationsListCtrl.$inject = ['$scope', 'uiGridConstants', '$interval', 'GeneralSettingsSrv', 'i18nService', '$mdDialog', '$cookies', 'Validations', 'permissions', 'GlobalConfig'];

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <a ng-if=\"row.entity.notification_type_id == 1\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.notificationRuleDetail({notificationId : row.entity.notification_id})\"> <i class=\"icon mdi-action-visibility i-16 dark-icon m-r-xs\"></i> Ver </a> <a ng-if=\"row.entity.notification_type_id == 3\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.startMessageNotificationDetail({notificationId : row.entity.notification_id})\"> <i class=\"icon mdi-action-visibility i-16 dark-icon m-r-xs\"></i> Ver </a> <a ng-if=\"row.entity.notification_type_id != 3 && row.entity.notification_type_id != 1\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.customNotificationDetail({notificationId : row.entity.notification_id})\"> <i class=\"icon mdi-action-visibility i-16 dark-icon m-r-xs\"></i> Ver </a> <a ng-if=\"row.entity.notification_type_id == 1\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.editNotificationRule({notificationId : row.entity.notification_id})\"> <i class=\"icon mdi-editor-border-color i-16 dark-icon m-r-xs\"></i> Editar </a> <a ng-if=\"row.entity.notification_type_id == 3\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.editStartMessageNotification({notificationId : row.entity.notification_id})\"> <i class=\"icon mdi-editor-border-color i-16 dark-icon m-r-xs\"></i> Editar </a> <a ng-if=\"row.entity.notification_type_id != 3 && row.entity.notification_type_id != 1\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.editCustomNotification({notificationId : row.entity.notification_id})\"> <i class=\"icon mdi-editor-border-color i-16 dark-icon m-r-xs\"></i> Editar </a> <a class=\"text-xs m-r-md\" ng-click=grid.appScope.notificationListVM.disableNotification(row)> <i class=\"icon mdi-action-delete i-16 dark-icon m-r-xs\"></i> Eliminar </a> </div>";

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Está a punto de eliminar la {{notificationType}} \"{{notificationName}}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=disable(notificationId)>Sí, eliminar notificación</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CustomNotificationCtrl = function () {
	  function CustomNotificationCtrl($scope, $state, GeneralSettingsSrv, $stateParams, $timeout, $cookies, Validations) {
	    _classCallCheck(this, CustomNotificationCtrl);
	
	    var customNotificationVm = this;
	    var user = JSON.parse($cookies.get('currentUser'));
	    var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
	    customNotificationVm.faculties = {};
	    customNotificationVm.teachers = {};
	    customNotificationVm.deliveryType = {};
	    customNotificationVm.submodules = {};
	    customNotificationVm.notificationTypes = {};
	    customNotificationVm.selectedDeliveryType = [];
	    customNotificationVm.isDisabled = false;
	    customNotificationVm.selectedTeachers = []; // Autocomplete
	    customNotificationVm.deliveryDate = null;
	    customNotificationVm.minDate = new Date();
	
	    customNotificationVm.toggle = toggle;
	    customNotificationVm.exists = exists;
	    customNotificationVm.saveCustomNotification = saveCustomNotification;
	    customNotificationVm.addTeacher = addTeacher;
	    customNotificationVm.removeTeacher = removeTeacher;
	    customNotificationVm.searchTeacher = searchTeacher;
	    customNotificationVm.hasError = hasError;
	    customNotificationVm.showErrorMessages = showErrorMessages;
	    customNotificationVm.validateForm = validateForm;
	    customNotificationVm.changeTemplate = changeTemplate;
	    customNotificationVm.isSubjectEmpty = isSubjectEmpty;
	    customNotificationVm.getTeacher = getTeacher;
	
	    activate();
	
	    function activate() {
	      return getCustomNotificationData().then(function () {
	        if ($stateParams.notificationId) {
	
	          getNotification($stateParams.notificationId);
	        } else {
	          // $scope.selectedDeliveryType=true
	          // console.log('ggg',customNotificationVm.selectedDeliveryType);
	        }
	      });
	    }
	
	    function getCustomNotificationData() {
	      var header = {};
	      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
	        header.userId = user.id;
	        header.rolId = currentRoleId;
	      }
	      return GeneralSettingsSrv.customNotificationData.getList(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          customNotificationVm.faculties = dataReturn.data.faculties;
	          customNotificationVm.teachers = dataReturn.data.teachers;
	          customNotificationVm.deliveryType = dataReturn.data.deliveryType;
	          customNotificationVm.submodules = dataReturn.data.submodules;
	          customNotificationVm.notificationTypes = dataReturn.data.notificationTypes;
	          customNotificationVm.templates = dataReturn.data.templates;
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function toggle(item) {
	      var idx = customNotificationVm.selectedDeliveryType.indexOf(item);
	      if (idx > -1) {
	        customNotificationVm.selectedDeliveryType.splice(idx, 1);
	      } else {
	        customNotificationVm.selectedDeliveryType.push(item);
	      }
	    }
	
	    function exists(item) {
	      return customNotificationVm.selectedDeliveryType.indexOf(item) > -1;
	    }
	
	    function saveCustomNotification() {
	      customNotificationVm.isDisabled = true;
	      var data = {
	        "asunto": customNotificationVm.asunto,
	        "ds_description": customNotificationVm.comments,
	        "id_create_notification_type": 2,
	        "id_faculty": customNotificationVm.selectedFaculty.faculty_id,
	        "dt_sending": moment(new Date(customNotificationVm.deliveryDate)).format('YYYY-MM-DD'),
	        "ds_description_custom": customNotificationVm.comments,
	        // "id_submodule": customNotificationVm.selectedModule.id_code,
	        "id_teacher": customNotificationVm.selectedTeachers.map(function (teacher) {
	          return teacher.teacher_id;
	        }).join(','),
	        "specific_date": moment(new Date(customNotificationVm.deliveryDate)).format('YYYY-MM-DD'),
	        "ds_days": "",
	        "ds_days_before": "",
	        "is_at_sending_moment": true,
	        "id_schedule_notification_type": customNotificationVm.scheduleType,
	        "start_date": "",
	        "end_date": "",
	        "is_undefined": false,
	        "id_notificationType": customNotificationVm.selectedNotificationType.notification_type_id,
	        "id_notification_delivery_type": customNotificationVm.selectedDeliveryType.map(function (deliveryType) {
	          return deliveryType.delivery_type_id;
	        }).join(',')
	      };
	
	      if ($stateParams.notificationId) editCustomNotification(data);else createCustomNotification(data);
	    }
	
	    function createCustomNotification(notification) {
	      GeneralSettingsSrv.createCustomNotification.save(notification).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          $state.go('generalSettings.notificationsManagement');
	        } else {
	          customNotificationVm.isDisabled = false;
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        customNotificationVm.isDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function editCustomNotification(notification) {
	      notification.id_notification = $stateParams.notificationId;
	      GeneralSettingsSrv.updateNotification.save(notification).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          $state.go('generalSettings.notificationsManagement');
	        } else {
	          customNotificationVm.isDisabled = false;
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        customNotificationVm.isDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function addTeacher(teacher) {
	
	      var flag = false;
	      for (var i in customNotificationVm.selectedTeachers) {
	        if (customNotificationVm.selectedTeachers[i].teacher_id == teacher.teacher_id) {
	          flag = true;
	        }
	      }
	      if (teacher && flag == false) {
	        customNotificationVm.selectedTeachers.push(teacher);
	        $scope.selectedItem = null;
	      }
	    }
	
	    function removeTeacher(teacher) {
	      var idx = customNotificationVm.selectedTeachers.indexOf(teacher);
	      customNotificationVm.selectedTeachers.splice(idx, 1);
	
	      // customNotificationVm.teachers.shift(teacher);
	      // console.log(customNotificationVm.teachers)
	    }
	
	    function searchTeacher(teacher) {
	      var matcher = new RegExp(teacher, 'i');
	      var arr = [];
	      if (typeof customNotificationVm.selectedFaculty !== 'undefined') {
	        return GeneralSettingsSrv.getTeacherByfacultyId.get({ ID_FACULTY: customNotificationVm.selectedFaculty.faculty_id, TEXT: teacher }).$promise.then(function (dataReturn) {
	          if (dataReturn.status == true) {
	            customNotificationVm.teachers = dataReturn.data.faculties;
	            customNotificationVm.teachers.forEach(function (teacher) {
	              if (teacher.teacher_name.match(matcher)) {
	                arr.push(teacher);
	              }
	            });
	            return arr;
	          } else {}
	        }, function (data) {
	          console.log(data);
	        });
	      } else {
	        return arr;
	      }
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) return 'has-error';
	    }
	
	    function changeTemplate(selectedTemplate) {
	      customNotificationVm.comments = selectedTemplate.ds_description;
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function validateForm(form) {
	      return form.$invalid;
	    }
	
	    function isSubjectEmpty() {
	
	      if (customNotificationVm.asunto) {
	        return false;
	      }
	      return true;
	    }
	
	    function getNotification(notificationId) {
	      return GeneralSettingsSrv.getNotificationById.get({ notificationId: notificationId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          if (dataReturn.data) formatNotification(dataReturn.data[0]);
	        } else {}
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function formatNotification(notification) {
	      customNotificationVm.deliveryDate = moment(notification.dt_sending, 'YYYY-MM-DD').toDate();
	      customNotificationVm.asunto = notification.asunto;
	      customNotificationVm.comments = notification.ds_description_custom;
	      customNotificationVm.selectedNotificationType = getNotificationTypeSelected(notification);
	      customNotificationVm.selectedFaculty = getFacultySelected(notification);
	      // customNotificationVm.selectedModule = getSubmoduleSelected(notification)
	      console.log('ffff', setDeliveryTypeSelected(notification));
	      customNotificationVm.selectedDeliveryType = setDeliveryTypeSelected(notification);
	      customNotificationVm.selectedTeachers = setSelectedTeachers(notification);
	      customNotificationVm.scheduleType = notification.id_schedule_notification_type;
	    }
	
	    function getTeacher(selectedFaculty) {
	      // alert(JSON.stringify(selectedFaculty));
	      if (typeof selectedFaculty !== 'undefined') {
	        GeneralSettingsSrv.getTeacherByfacultyId.get({ ID_FACULTY: selectedFaculty.faculty_id }).$promise.then(function (dataReturn) {
	          if (dataReturn.status == true) {
	
	            // $scope.searchText = undefined;  
	            customNotificationVm.teachers = [];
	            customNotificationVm.teachers = dataReturn.data.faculties;
	            customNotificationVm.teachertemp = dataReturn.data.faculties;
	            customNotificationVm.selectedTeachers = dataReturn.data.faculties;
	            $scope.selectedItem = null;
	          } else {}
	        }, function (data) {
	          console.log(data);
	        });
	      }
	    }
	
	    function setSelectedTeachers(notification) {
	      var teacherArray = [];
	      console.log(notification);
	      if (notification.id_teacher) {
	        teacherArray = notification.id_teacher.split(',');
	        teacherArray = teacherArray.map(function (teacherId) {
	          return parseInt(teacherId);
	        });
	      }
	      return customNotificationVm.teachers.filter(function (teacher) {
	        return teacherArray.includes(teacher.teacher_id);
	      });
	    }
	
	    function getNotificationTypeSelected(notification) {
	      for (var index in customNotificationVm.notificationTypes) {
	        if (customNotificationVm.notificationTypes[index].notification_type_id == notification.id_notificationType) return customNotificationVm.notificationTypes[index];
	      }
	    }
	
	    function getFacultySelected(notification) {
	      for (var index in customNotificationVm.faculties) {
	        if (customNotificationVm.faculties[index].faculty_id == notification.id_faculty) return customNotificationVm.faculties[index];
	      }
	    }
	
	    function getSubmoduleSelected(notification) {
	      for (var index in customNotificationVm.submodules) {
	        if (customNotificationVm.submodules[index].id_code == notification.id_submodule) return customNotificationVm.submodules[index];
	      }
	    }
	
	    function setDeliveryTypeSelected(notification) {
	      var result = [];
	      var idsSelected = [];
	      if (notification.id_notification_delivery_type.indexOf(",") > -1) idsSelected = notification.id_notification_delivery_type.split(",");else idsSelected.push(notification.id_notification_delivery_type);
	
	      for (var index in customNotificationVm.deliveryType) {
	        if (idsSelected.indexOf(customNotificationVm.deliveryType[index].delivery_type_id.toString()) > -1) result.push(customNotificationVm.deliveryType[index]);
	      }
	      return result;
	    }
	  } //FIN DEL CONSTRUCTOR
	
	  _createClass(CustomNotificationCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return CustomNotificationCtrl;
	}();
	
	exports.default = CustomNotificationCtrl;
	
	
	CustomNotificationCtrl.$inject = ['$scope', '$state', 'GeneralSettingsSrv', '$stateParams', '$timeout', '$cookies', 'Validations'];

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NotificationsRuleCtrl = function () {
		function NotificationsRuleCtrl($scope, $state, $stateParams, GeneralSettingsSrv, GlobalConfig) {
			_classCallCheck(this, NotificationsRuleCtrl);
	
			var notificationRuleVm = this;
	
			notificationRuleVm.config = GlobalConfig;
			notificationRuleVm.isSaveButtonDisabled = false;
			notificationRuleVm.minDate = new Date();
	
			notificationRuleVm.notification = {};
			notificationRuleVm.notification.shipping_time = 'dependent';
			notificationRuleVm.notification.roles = {};
			notificationRuleVm.notification.days = {};
			notificationRuleVm.notification.daysBefore = {
				1: false,
				2: false,
				5: false
			};
			notificationRuleVm.notification.deliveryTypes = {};
			notificationRuleVm.notification.specific_date = null;
	
			notificationRuleVm.stages = [];
			notificationRuleVm.academicUnits = [];
			notificationRuleVm.roles = [];
			notificationRuleVm.activities = [];
			notificationRuleVm.deliveryTypes = [];
			notificationRuleVm.templates = [];
			notificationRuleVm.weekdays = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes'];
			notificationRuleVm.isLibre = false;
	
			// VM methods
			notificationRuleVm.hasError = hasError;
			notificationRuleVm.showErrorMessages = showErrorMessages;
			notificationRuleVm.getFormAttribute = getFormAttribute;
			notificationRuleVm.changedSpecificDateCheck = changedSpecificDateCheck;
			notificationRuleVm.changedCheckNDaysBefore = changedCheckNDaysBefore;
			notificationRuleVm.isRoleEmpty = isRoleEmpty;
			notificationRuleVm.isDeliveryTypeEmpty = isDeliveryTypeEmpty;
			notificationRuleVm.isDaysEmpty = isDaysEmpty;
			notificationRuleVm.isRequiredEventDependent = isRequiredEventDependent;
			notificationRuleVm.validateForm = validateForm;
			notificationRuleVm.saveNotification = saveNotification;
			notificationRuleVm.changeTemplate = changeTemplate;
			notificationRuleVm.isSubjectEmpty = isSubjectEmpty;
			notificationRuleVm.checkIsLibre = checkIsLibre;
	
			activate();
	
			function activate() {
				if ($stateParams.notificationId) return getFormData().then(getNotification($stateParams.notificationId).then(function () {}));
	
				return getFormData().then(function () {});
			}
	
			function hasError(input) {
				if (input.$invalid && (input.$dirty || input.$touched)) return 'has-error';
			}
	
			function showErrorMessages(input) {
				return input.$dirty || input.$touched;
			}
	
			function getFormAttribute(form, attr, index) {
				attr = attr + index;
	
				return form[attr];
			}
	
			function getFormData() {
				return GeneralSettingsSrv.getAllDataNotificationRules.getList().$promise.then(function (dataReturn) {
					if (dataReturn.status == true) {
						// notificationRuleVm.stages = ( dataReturn.stages )? dataReturn.stages : []
						// notificationRuleVm.academicUnits = ( dataReturn.academic_units )? dataReturn.academic_units : []
	
						notificationRuleVm.roles = dataReturn.role ? dataReturn.role : [];
	
						if (!notificationRuleVm.notification.roles) {
							notificationRuleVm.roles.forEach(function (role) {
								notificationRuleVm.notification.roles[role.id_code] = false;
							});
						}
	
						// notificationRuleVm.activities = ( dataReturn.submodules )? dataReturn.submodules : []
						notificationRuleVm.deliveryTypes = dataReturn.delivery_type ? dataReturn.delivery_type : [];
	
						if (!notificationRuleVm.notification.deliveryTypes) {
							notificationRuleVm.deliveryTypes.forEach(function (deliveryType) {
								notificationRuleVm.notification.deliveryTypes[deliveryType.id_code] = false;
							});
						} else {
							notificationRuleVm.notification.deliveryTypes[notificationRuleVm.deliveryTypes[0].id_code] = true;
						}
	
						notificationRuleVm.templates = dataReturn.templates ? dataReturn.templates : [];
					} else {
						notificationRuleVm.stages = [];
					}
	
					notificationRuleVm.notificationType = dataReturn.notification_type ? dataReturn.notification_type : [];
				}, function (data) {
					console.log(data);
				});
			}
	
			function getNotification(notificationId) {
				return GeneralSettingsSrv.getNotificationById.get({ notificationId: notificationId }).$promise.then(function (dataReturn) {
					if (dataReturn.status == true) {
						if (dataReturn.data) {
							if (!dataReturn.data[0] || dataReturn.data[0].id_create_notification_type != 1) $state.go('generalSettings.notificationsManagement');
	
							notificationRuleVm.notification = formatNotificationIn(dataReturn.data[0]);
						}
					}
				}, function (data) {
					console.log(data);
				});
			}
	
			function changedSpecificDateCheck(checked) {
				if (!checked) notificationRuleVm.notification.specific_date = null;
			}
	
			function changedCheckNDaysBefore(checked) {
				if (!checked) notificationRuleVm.nDaysBefore = null;
			}
	
			function isRoleEmpty() {
				for (var role in notificationRuleVm.notification.roles) {
					if (notificationRuleVm.notification.roles[role]) return false;
				}
	
				return true;
			}
	
			function isDeliveryTypeEmpty() {
				for (var deliveryType in notificationRuleVm.notification.deliveryTypes) {
					if (notificationRuleVm.notification.deliveryTypes[deliveryType]) return false;
				}
	
				return true;
			}
	
			function isSubjectEmpty() {
				if (notificationRuleVm.notification.asunto) {
					return false;
				}
	
				return true;
			}
	
			function isDaysEmpty() {
				for (var day in notificationRuleVm.notification.days) {
					if (notificationRuleVm.notification.days[day]) return false;
				}
	
				return true;
			}
	
			function isRequiredEventDependent() {
				return notificationRuleVm.notification.shipping_time == 'dependent' && !(notificationRuleVm.notification.is_at_sending_moment || !isDaysBeforeEmpty() || notificationRuleVm.nDaysBefore || notificationRuleVm.notification.specific_date);
			}
	
			function isDaysBeforeEmpty() {
				for (var day in notificationRuleVm.notification.daysBefore) {
					if (notificationRuleVm.notification.daysBefore[day]) return false;
				}
	
				return true;
			}
	
			function validateForm(form) {
				return form.$invalid;
			}
	
			function saveNotification() {
				notificationRuleVm.isSaveButtonDisabled = true;
				var notification = formatNotification(notificationRuleVm.notification);
	
				// console.log('......',notification);
				if ($stateParams.notificationId) editNotification(notification);else createNotification(notification);
			}
	
			function createNotification(notification) {
				GeneralSettingsSrv.createNotificationRule.save(notification).$promise.then(function (dataReturn) {
					if (dataReturn.status == true) {
						$state.go('generalSettings.notificationsManagement');
					} else {
						notificationRuleVm.isSaveButtonDisabled = false;
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
	
			function editNotification(notification) {
				notification.id_notification = notification.id_code;
				GeneralSettingsSrv.updateNotification.save(notification).$promise.then(function (dataReturn) {
					if (dataReturn.status == true) {
						$state.go('generalSettings.notificationsManagement');
					} else {
						notificationRuleVm.isSaveButtonDisabled = false;
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
	
			function changeTemplate(selectedTemplate) {
				notificationRuleVm.notification.ds_description = selectedTemplate.ds_description;
			}
	
			function formatNotificationIn(notification) {
				notification.roles = {};
				notification.daysBefore = {};
				notification.deliveryTypes = {};
				notification.days = {};
	
				if (notification.specific_date) {
					var m = moment(notification.specific_date, 'YYYY-MM-DD');
	
					notification.specific_date = m.isValid() ? m.toDate() : null;
					notificationRuleVm.specific_date_check = true;
				} else {
					notification.specific_date = null;
				}
	
				if (notification.id_role) {
					var rolesArray = [];
	
					rolesArray = notification.id_role.split(',');
					rolesArray = rolesArray.map(function (roleId) {
						return parseInt(roleId);
					});
					rolesArray.forEach(function (rol) {
						return notification.roles[rol] = true;
					});
				}
	
				if (notification.id_notification_delivery_type) {
					var deliveryTypesArray = [];
	
					notification.deliveryTypes = {};
					deliveryTypesArray = notification.id_notification_delivery_type.split(',');
	
					deliveryTypesArray = deliveryTypesArray.map(function (deliveryTypeId) {
						return parseInt(deliveryTypeId);
					});
					deliveryTypesArray.forEach(function (deliveryTypeId) {
						return notification.deliveryTypes[deliveryTypeId] = true;
					});
				}
	
				if (notification.id_schedule_notification_type == 3) {
					notification.shipping_time = 'dependent';
	
					if (notification.ds_days_before) {
						var daysBeforeArray = notification.ds_days_before.split(',');
	
						daysBeforeArray = daysBeforeArray.map(function (day) {
							return parseInt(day);
						});
						notificationRuleVm.nDaysBefore = daysBeforeArray.find(function (day) {
							return ![1, 2, 5].includes(day);
						});
	
						if (notificationRuleVm.nDaysBefore) {
							notificationRuleVm.checkNDaysBefore = true;
							var index = daysBeforeArray.indexOf(notificationRuleVm.nDaysBefore);
	
							if (index != -1) daysBeforeArray.splice(index, 1);
						}
	
						daysBeforeArray.forEach(function (day) {
							return notification.daysBefore[day] = true;
						});
					}
				} else if (notification.id_schedule_notification_type === 2) {
					notification.shipping_time = 'weekly';
	
					if (notification.ds_days) {
						var daysArray = notification.ds_days.split(',');
	
						daysArray = daysArray.map(function (day) {
							return parseInt(day);
						});
						daysArray.forEach(function (day) {
							return notification.days[day] = true;
						});
					}
				}
	
				return notification;
			}
	
			var formatNotification = function formatNotification(notification) {
				notification.id_create_notification_type = 1;
				// notification.ds_name =""
	
				var rolesArray = [];
	
				for (var role in notification.roles) {
					if (notification.roles[role]) rolesArray.push(role);
				}
	
				notification.id_role = rolesArray.join(',');
	
				var deliveryTypesArray = [];
	
				for (var deliveryType in notification.deliveryTypes) {
					if (notification.deliveryTypes[deliveryType]) deliveryTypesArray.push(deliveryType);
				}
	
				notification.id_notification_delivery_type = deliveryTypesArray.join(',');
	
				notification.id_template = notificationRuleVm.selectedTemplate ? notificationRuleVm.selectedTemplate.id_code : null;
	
				if (notification.shipping_time == 'dependent') {
					notification.id_schedule_notification_type = 3;
					notification.ds_days = '';
	
					var daysBeforeArray = [];
	
					for (var day in notification.daysBefore) {
						if (notification.daysBefore[day]) daysBeforeArray.push(parseInt(day));
					}
	
					if (notificationRuleVm.checkNDaysBefore && notificationRuleVm.nDaysBefore && !daysBeforeArray.includes(notificationRuleVm.nDaysBefore)) {
						daysBeforeArray.push(notificationRuleVm.nDaysBefore);
					}
	
					notification.ds_days_before = daysBeforeArray.join(',');
	
					if (notification.specific_date) {
						notification.specific_date = moment(notification.specific_date).format('YYYY-MM-DD hh:mm:ss');
					}
				} else if (notification.shipping_time == 'weekly') {
					notification.id_schedule_notification_type = 2;
					notification.ds_days_before = '';
					notification.specific_date = '';
					notification.is_at_sending_moment = '';
					var daysArray = [];
	
					for (var _day in notification.days) {
						if (notification.days[_day]) daysArray.push(parseInt(_day));
					}
	
					notification.ds_days = daysArray.join(',');
				}
	
				return notification;
			};
	
			function checkIsLibre() {
				if (notificationRuleVm.config.notificationTypeLibre.libre === notificationRuleVm.notification.id_notificationType) {
					notificationRuleVm.isLibre = true;
				} else {
					notificationRuleVm.isLibre = false;
				}
			}
		} //FIN DEL CONSTRUCTOR
	
		_createClass(NotificationsRuleCtrl, [{
			key: 'preventInput',
			value: function preventInput(event) {
				var vKey = 86;
	
				if (event.keyCode == vKey) event.preventDefault();
	
				return;
			}
		}]);
	
		return NotificationsRuleCtrl;
	}();
	
	exports.default = NotificationsRuleCtrl;
	
	
	NotificationsRuleCtrl.$inject = ['$scope', '$state', '$stateParams', 'GeneralSettingsSrv', 'GlobalConfig'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StartMessageNotificationCtrl = function () {
	  function StartMessageNotificationCtrl($scope, GeneralSettingsSrv, $stateParams, $mdDialog) {
	    _classCallCheck(this, StartMessageNotificationCtrl);
	
	    var startMessageVm = this;
	
	    startMessageVm.message = {};
	    startMessageVm.showInputDates = false;
	    startMessageVm.message.startDate = null;
	    startMessageVm.message.endDate = null;
	    startMessageVm.saveButtonDisabled = false;
	    startMessageVm.message.isUndefined = true;
	    startMessageVm.minDate = new Date();
	
	    startMessageVm.scheduleNotificationTypeSelected = scheduleNotificationTypeSelected;
	    startMessageVm.saveStartMessage = saveStartMessage;
	    startMessageVm.hasError = hasError;
	    startMessageVm.showErrorMessages = showErrorMessages;
	    startMessageVm.validateForm = validateForm;
	    startMessageVm.isDateRequired = isDateRequired;
	    startMessageVm.startDateChanged = startDateChanged;
	    var editingNotification = false;
	
	    activate();
	
	    function activate() {
	      return getScheduleNotificationType().then(function () {
	        if ($stateParams.notificationId) {
	          editingNotification = true;
	          getNotification($stateParams.notificationId);
	        }
	      });
	    }
	
	    function getScheduleNotificationType() {
	
	      return GeneralSettingsSrv.scheduleNotificationType.getList().$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          startMessageVm.schedules = dataReturn.data;
	          startMessageVm.message.scheduleNotificationTypeId = startMessageVm.schedules[1].scheduleNotificationTypeId;
	        } else {
	          console.log(dataReturn);
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getNotification(notificationId) {
	      return GeneralSettingsSrv.getNotificationById.get({ notificationId: notificationId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          if (dataReturn.data) startMessageVm.message = formatNotification(dataReturn.data[0]);
	        } else {}
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function scheduleNotificationTypeSelected(scheduleName) {
	      if (scheduleName.toLowerCase().indexOf("indefinido") >= 0) {
	        startMessageVm.showInputDates = false;
	        startMessageVm.message.isUndefined = true;
	        startMessageVm.message.startDate = null;
	        startMessageVm.message.endDate = null;
	      } else {
	        startMessageVm.showInputDates = true;
	        startMessageVm.message.isUndefined = false;
	      }
	    }
	
	    function saveStartMessage() {
	      startMessageVm.saveButtonDisabled = true;
	      if (startMessageVm.showInputDates) {
	        startMessageVm.message.startDate = new Date(startMessageVm.message.startDate);
	        startMessageVm.message.endDate = new Date(startMessageVm.message.endDate);
	        startMessageVm.message.isUndefined = false;
	      } else {
	        startMessageVm.message.startDate = null;
	        startMessageVm.message.endDate = null;
	        startMessageVm.message.isUndefined = true;
	      }
	      if (!editingNotification) save(startMessageVm.message);else edit(formatNotificationToEdit(startMessageVm.message));
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) return 'has-error';
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function validateForm(form) {
	      return form.$invalid;
	    }
	
	    function isDateRequired() {
	      return startMessageVm.message.scheduleNotificationTypeId == startMessageVm.schedules[0].scheduleNotificationTypeId;
	    }
	
	    function startDateChanged() {
	      var m = moment(startMessageVm.message.startDate);
	      startMessageVm.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null;
	    }
	
	    function showModalStartMessageCreated() {
	      var startMessageName = startMessageVm.message.asunto;
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	          $scope.startMessageName = startMessageName;
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	        }],
	        template: __webpack_require__(266),
	        clickOutsideToClose: false
	      });
	    }
	
	    function formatNotification(notification) {
	      if (notification.ds_name) notification.dsName = notification.ds_name;
	      if (notification.ds_description) notification.dsDescription = notification.ds_description;
	      if (notification.id_schedule_notification_type) notification.scheduleNotificationTypeId = notification.id_schedule_notification_type;
	      if (notification.start_date && moment(notification.start_date).isValid() && notification.end_date && moment(notification.end_date).isValid()) {
	        notification.startDate = moment(notification.start_date, 'YYYY-MM-DD').toDate();
	        notification.endDate = moment(notification.end_date, 'YYYY-MM-DD').toDate();
	        startMessageVm.message.isUndefined = false;
	        startMessageVm.showInputDates = true;
	      } else {
	        startMessageVm.message.isUndefined = true;
	        startMessageVm.showInputDates = false;
	      }
	      if (notification.id_code) notification.idCode = notification.id_code;
	
	      return notification;
	    }
	
	    function formatNotificationToEdit(notification) {
	      notification.ds_name = notification.dsName;
	      notification.ds_description = notification.dsDescription;
	      notification.id_schedule_notification_type = notification.scheduleNotificationTypeId;
	      notification.id_notification = notification.idCode;
	      notification.is_undefined = notification.isUndefined;
	      notification.id_notification = notification.id_code;
	      if (!notification.isUndefined) {
	        notification.start_date = new Date(notification.startDate);
	        notification.end_date = new Date(notification.endDate);
	      } else {
	        notification.start_date = null;
	        notification.end_date = null;
	      }
	      return notification;
	    }
	
	    function save(message) {
	      GeneralSettingsSrv.createStartMessage.save({ message: message }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          showModalStartMessageCreated();
	        } else {
	          startMessageVm.saveButtonDisabled = false;
	          console.log(dataReturn);
	        }
	      }, function (data) {
	        startMessageVm.saveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function edit(message) {
	      GeneralSettingsSrv.updateNotification.update(message).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          showModalStartMessageCreated();
	        } else {
	          startMessageVm.saveButtonDisabled = false;
	          console.log(dataReturn);
	        }
	      }, function (data) {
	        startMessageVm.saveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(StartMessageNotificationCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return StartMessageNotificationCtrl;
	}();
	
	exports.default = StartMessageNotificationCtrl;
	
	
	StartMessageNotificationCtrl.$inject = ['$scope', 'GeneralSettingsSrv', '$stateParams', '$mdDialog'];

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creaci&oacute;n exitosa!</h3> <p>Su mensaje de inicio \"{{startMessageName}}\" se ha creado con éxito</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ui-sref=generalSettings.notificationsManagement ng-click=close()>Volver</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NotificationRuleDetailCtrl = function () {
	  function NotificationRuleDetailCtrl($scope, $state, $stateParams, GeneralSettingsSrv) {
	    _classCallCheck(this, NotificationRuleDetailCtrl);
	
	    var notificationRuleVm = this;
	
	    notificationRuleVm.notification = {};
	
	    notificationRuleVm.notification.roles = [];
	    notificationRuleVm.notification.days = [];
	    notificationRuleVm.notification.daysBefore = [];
	    notificationRuleVm.notification.deliveryTypes = [];
	    notificationRuleVm.notification.specific_date = null;
	
	    notificationRuleVm.stages = [];
	    notificationRuleVm.academicUnits = [];
	    notificationRuleVm.roles = [];
	    notificationRuleVm.activities = [];
	    notificationRuleVm.deliveryTypes = [];
	    notificationRuleVm.templates = [];
	    notificationRuleVm.weekdays = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes'];
	    notificationRuleVm.notificationType = [];
	
	    notificationRuleVm.isRoleChecked = isRoleChecked;
	    notificationRuleVm.isDeliveryTypeChecked = isDeliveryTypeChecked;
	    notificationRuleVm.isDayChecked = isDayChecked;
	
	    activate();
	
	    function activate() {
	
	      if (!$stateParams.notificationId) $state.go('generalSettings.notificationsManagement');
	
	      return getAllDataNotificationRules().then(getNotification($stateParams.notificationId).then(function () {}));
	    }
	
	    function isRoleChecked(roleId) {
	      return notificationRuleVm.notification.roles ? notificationRuleVm.notification.roles.includes(roleId.toString()) : false;
	    }
	
	    function isDeliveryTypeChecked(deliveryTypeId) {
	      return notificationRuleVm.notification.deliveryTypes ? notificationRuleVm.notification.deliveryTypes.includes(deliveryTypeId.toString()) : false;
	    }
	
	    function isDayChecked(day) {
	      return notificationRuleVm.notification.days ? notificationRuleVm.notification.days.includes(day.toString()) : false;
	    }
	
	    function getAllDataNotificationRules() {
	      return GeneralSettingsSrv.getAllDataNotificationRules.getList().$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	
	          loadFormData(dataReturn);
	        } else {
	          notificationRuleVm.stages = [];
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getNotification(notificationId) {
	      return GeneralSettingsSrv.getNotificationById.get({ notificationId: notificationId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          if (dataReturn.data) {
	            if (!dataReturn.data[0] || dataReturn.data[0].id_create_notification_type != 1) $state.go('generalSettings.notificationsManagement');
	
	            notificationRuleVm.notification = formatNotification(dataReturn.data[0]);
	            console.log(notificationRuleVm.notification);
	          }
	        } else {}
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function loadFormData(data) {
	      notificationRuleVm.stages = data.stages ? data.stages : [];
	      notificationRuleVm.academicUnits = data.academic_units ? data.academic_units : [];
	      notificationRuleVm.roles = data.role ? data.role : [];
	      notificationRuleVm.activities = data.submodules ? data.submodules : [];
	      notificationRuleVm.deliveryTypes = data.delivery_type ? data.delivery_type : [];
	      notificationRuleVm.templates = data.templates ? data.templates : [];
	      notificationRuleVm.notificationType = data.notification_type ? data.notification_type : [];
	    }
	
	    function formatNotification(notification) {
	
	      if (notification.id_role) notification.roles = notification.id_role.split(',');
	
	      if (notification.id_schedule_notification_type == 3) {
	        notification.shipping_time = 'dependent';
	      } else {
	        notification.shipping_time = 'weekly';
	      }
	
	      if (notification.ds_days_before) {
	
	        notification.daysBefore = notification.ds_days_before.split(',');
	
	        if (notification.daysBefore.includes('1')) notification.oneDayBefore = true;
	        if (notification.daysBefore.includes('2')) notification.twoDaysBefore = true;
	        if (notification.daysBefore.includes('5')) notification.fiveDaysBefore = true;
	
	        var nDays = null;
	        if (nDays = notification.daysBefore.find(function (day) {
	          return !["1", "2", "5"].includes(day);
	        })) notification.nDaysBefore = parseInt(nDays);
	      }
	
	      if (notification.ds_days) notification.days = notification.ds_days.split(',');
	
	      if (notification.id_notification_delivery_type) notification.deliveryTypes = notification.id_notification_delivery_type.split(',');
	
	      if (notification.specific_date) notification.specific_date = moment(notification.specific_date, 'YYYY-MM-DD').toDate();
	
	      return notification;
	    }
	  } //FIN DEL CONSTRUCTOR
	
	  _createClass(NotificationRuleDetailCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return NotificationRuleDetailCtrl;
	}();
	
	exports.default = NotificationRuleDetailCtrl;
	
	
	NotificationRuleDetailCtrl.$inject = ['$scope', '$state', '$stateParams', 'GeneralSettingsSrv'];

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CustomNotificationDetailCtrl = function () {
	  function CustomNotificationDetailCtrl($scope, $state, $stateParams, GeneralSettingsSrv, $cookies, Validations) {
	    _classCallCheck(this, CustomNotificationDetailCtrl);
	
	    var customNotificationVm = this;
	    var user = JSON.parse($cookies.get('currentUser'));
	    var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
	    customNotificationVm.faculties = {};
	    customNotificationVm.teachers = {};
	    customNotificationVm.deliveryType = {};
	    customNotificationVm.submodules = {};
	    customNotificationVm.notificationTypes = {};
	    customNotificationVm.selectedDeliveryType = [];
	    customNotificationVm.selectedTeachers = [];
	    customNotificationVm.deliveryDate = null;
	
	    customNotificationVm.exists = exists;
	
	    activate();
	
	    function activate() {
	
	      if (!$stateParams.notificationId) $state.go('generalSettings.notificationsManagement');
	
	      return getCustomNotificationData().then(getNotification($stateParams.notificationId).then(function () {}));
	    }
	
	    function getCustomNotificationData() {
	      var header = {};
	      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
	        header.userId = user.id;
	        header.rolId = currentRoleId;
	      }
	      return GeneralSettingsSrv.customNotificationData.getList(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          loadFormData(dataReturn.data);
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getNotification(notificationId) {
	      return GeneralSettingsSrv.getNotificationById.get({ notificationId: notificationId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          if (dataReturn.data && dataReturn.data[0]) {
	            formatCustomNotification(dataReturn.data[0]);
	          }
	        } else {}
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function exists(item) {
	      return customNotificationVm.selectedDeliveryType.indexOf(item.toString()) > -1;
	    }
	
	    function formatCustomNotification(customNotification) {
	      customNotificationVm.selectedNotificationType = customNotification.id_notificationType;
	      customNotificationVm.selectedFaculty = customNotification.id_faculty;
	      customNotificationVm.deliveryDate = moment(customNotification.dt_sending, 'YYYY-MM-DD').toDate();
	      customNotificationVm.selectedModule = customNotification.id_submodule;
	      customNotificationVm.comments = customNotification.ds_description_custom;
	      customNotificationVm.asunto = customNotification.asunto;
	
	      if (customNotification.id_notification_delivery_type) customNotificationVm.selectedDeliveryType = customNotification.id_notification_delivery_type.split(',');
	
	      if (customNotification.id_teacher) customNotificationVm.selectedTeachers.push(customNotification.teacher_name);
	    }
	
	    function loadFormData(data) {
	      customNotificationVm.faculties = data.faculties;
	      customNotificationVm.teachers = data.teachers;
	      customNotificationVm.deliveryType = data.deliveryType;
	      customNotificationVm.submodules = data.submodules;
	      customNotificationVm.notificationTypes = data.notificationTypes;
	    }
	  } //FIN DEL CONSTRUCTOR
	
	  _createClass(CustomNotificationDetailCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return CustomNotificationDetailCtrl;
	}();
	
	exports.default = CustomNotificationDetailCtrl;
	
	
	CustomNotificationDetailCtrl.$inject = ['$scope', '$state', '$stateParams', 'GeneralSettingsSrv', '$cookies', 'Validations'];

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StartMessageNotificationDetailCtrl = function () {
	  function StartMessageNotificationDetailCtrl($scope, $state, $stateParams, GeneralSettingsSrv) {
	    _classCallCheck(this, StartMessageNotificationDetailCtrl);
	
	    var startMessageNotificationVm = this;
	    startMessageNotificationVm.showInputDates = false;
	
	    activate();
	
	    function activate() {
	
	      if (!$stateParams.notificationId) $state.go('generalSettings.notificationsManagement');
	
	      return getScheduleNotificationType().then(getNotification($stateParams.notificationId).then(function () {}));
	    }
	
	    function getScheduleNotificationType() {
	
	      return GeneralSettingsSrv.scheduleNotificationType.getList().$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) startMessageNotificationVm.schedules = dataReturn.data;else console.log(dataReturn);
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getNotification(notificationId) {
	      return GeneralSettingsSrv.getNotificationById.get({ notificationId: notificationId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          if (dataReturn.data) startMessageNotificationVm.message = formatNotification(dataReturn.data[0]);
	        } else {}
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function formatNotification(notification) {
	      if (notification.asunto) notification.dsName = notification.asunto;
	      if (notification.ds_description) notification.dsDescription = notification.ds_description;
	      if (notification.id_schedule_notification_type) notification.scheduleNotificationTypeId = notification.id_schedule_notification_type;
	      if (notification.start_date && moment(notification.start_date).isValid() && notification.end_date && moment(notification.end_date).isValid()) {
	        notification.startDate = moment(notification.start_date, 'YYYY-MM-DD').toDate();
	        notification.endDate = moment(notification.end_date, 'YYYY-MM-DD').toDate();
	        startMessageNotificationVm.showInputDates = true;
	      }
	      return notification;
	    }
	  } //FIN DEL CONSTRUCTOR
	
	  _createClass(StartMessageNotificationDetailCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return StartMessageNotificationDetailCtrl;
	}();
	
	exports.default = StartMessageNotificationDetailCtrl;
	
	
	StartMessageNotificationDetailCtrl.$inject = ['$scope', '$state', '$stateParams', 'GeneralSettingsSrv'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsersCtrl = function UsersCtrl($rootScope, $scope, GeneralSettingsSrv, $mdDialog, $interval, $uiGridConstants, i18nService, $state, $cookies, Validations, GlobalConfig) {
		_classCallCheck(this, UsersCtrl);
	
		var usrVM = this;
		var user = JSON.parse($cookies.get('currentUser'));
		var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
		i18nService.setCurrentLang('es');
		usrVM.currentPage = 0;
		usrVM.roles = [];
		usrVM.rolescomitee = { id_code: '' };
		usrVM.rolesGridcomitee = [];
		usrVM.rolesGrid = [];
		usrVM.unitAdmin = GlobalConfig.userRolesIds.unitAdmin;
		usrVM.generalConsultant = GlobalConfig.userRolesIds.generalConsultant;
		usrVM.workplanConsultant = GlobalConfig.userRolesIds.workplanConsultant;
		usrVM.gerencialConsultant = GlobalConfig.userRolesIds.gerencialConsultant;
		// usrVM.roles = {}
		usrVM.confirmDisableUser = confirmDisableUser;
		usrVM.roleId = currentRoleId;
		usrVM.confirmDisableComite = confirmDisableComite;
		usrVM.intialize = intialize;
	
		function intialize() {
			var header = {};
	
			if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId) || Validations.isCommitteeAdmin(currentRoleId)) {
				header.userId = user.id;
				header.rolId = currentRoleId;
			}
	
			GeneralSettingsSrv.getUsers.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					usrVM.usersGrid.data = dataReturn.data;
					usrVM.usersComiteeGrid.data = dataReturn.commite;
				} else {
					console.log('communications failure with server');
				}
			}).then(function () {
				GeneralSettingsSrv.getRoles.get().$promise.then(function (dataReturn) {
					if (dataReturn.status == true) {
						for (var i in dataReturn.data) {
							if (!angular.equals(dataReturn.data[i].ds_name, 'Comité')) {
								usrVM.roles = [];
							}
						}
						for (var i in dataReturn.data) {
							if (angular.equals(dataReturn.data[i].ds_name, 'Comité')) {
								usrVM.rolescomitee.id_code = dataReturn.data[i].id_code;
							} else {
								if (angular.equals(currentRoleId, usrVM.unitAdmin)) {
									if (angular.equals(dataReturn.data[i].id_code, usrVM.workplanConsultant) || angular.equals(dataReturn.data[i].id_code, usrVM.gerencialConsultant)) {
										usrVM.roles.push(dataReturn.data[i]);
									}
								} else {
									usrVM.roles.push(dataReturn.data[i]);
								}
							}
						}
					} else {
						console.log('Comunications failure with the server');
					}
				});
			});
		}
	
		usrVM.restructureDate = function (user) {
			var day = user.comiteeEndDate.substring(8, 10);
			var month = user.comiteeEndDate.substring(5, 7);
			var year = user.comiteeEndDate.substring(0, 4);
	
			return day + '/' + month + '/' + year;
		};
	
		usrVM.highlightFilteredHeader = function (row, rowRenderIndex, col, colRenderIndex) {
			if (col.filters[0].term) {
				return 'header-filtered';
			} else {
				return '';
			}
		};
	
		usrVM.usersGrid = {
			enableFiltering: true,
			columnDefs: [_defineProperty({
				name: 'Nombre',
				displayName: 'Nombre',
				field: 'userName',
				width: '20%',
				headerCellClass: usrVM.highlightFilteredHeader,
				enableGridMenu: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellClass: 'text-xs'
			}, 'headerCellClass', 'font-normal text-xs'), {
				name: 'Unidad académica',
				displayName: 'Unidad académica',
				field: 'academicName',
				width: '20%',
				enableGridMenu: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellClass: 'text-xs',
				headerCellClass: 'font-normal text-xs'
			}, {
				name: 'Tipo',
				displayName: 'Tipo',
				field: 'userRole',
				width: '20%',
				enableGridMenu: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellClass: 'text-xs',
				headerCellClass: 'font-normal text-xs'
			}, {
				name: 'Fecha de vencimiento',
				displayName: 'Fecha de vencimiento',
				field: 'comiteeEndDate',
				width: '20%',
				enableGridMenu: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellFilter: "date: 'dd/MM/yyyy': 'UTC'",
				cellClass: 'text-xs',
				headerCellClass: 'font-normal text-xs'
			}, {
				name: 'Acciones',
				displayName: 'Acciones',
				field: '',
				width: '20%',
				enableGridMenu: false,
				enableFiltering: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellClass: 'column-right text-xs',
				headerCellClass: 'column-center font-normal text-xs',
				cellTemplate: __webpack_require__(271)
			}],
			onRegisterApi: function onRegisterApi(gridApi) {
				usrVM.gridApi = gridApi;
				usrVM.gridApi.grid.registerRowsProcessor(usrVM.singleFilter, 200);
				$interval(function () {
					usrVM.gridApi.core.handleWindowResize();
				}, 500, 10);
			}
		};
	
		usrVM.usersComiteeGrid = {
			enableFiltering: true,
			columnDefs: [_defineProperty({
				name: 'Nombre del comité',
				displayName: 'Nombre del comité',
				field: 'comiteeName',
				width: '40%',
				headerCellClass: usrVM.highlightFilteredHeader,
				enableGridMenu: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellClass: 'text-xs'
			}, 'headerCellClass', 'font-normal text-xs'), {
				name: 'Tipo',
				displayName: 'Tipo',
				field: 'userRole',
				width: '20%',
				enableGridMenu: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellClass: 'text-xs',
				headerCellClass: 'font-normal text-xs'
			}, {
				name: 'Fecha de vencimiento',
				displayName: 'Fecha de vencimiento',
				field: 'comiteeEndDate',
				width: '20%',
				enableGridMenu: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellFilter: "date: 'dd/MM/yyyy': 'UTC'",
				cellClass: 'text-xs',
				headerCellClass: 'font-normal text-xs'
			}, {
				name: 'Acciones',
				displayName: 'Acciones',
				field: '',
				width: '20%',
				enableGridMenu: false,
				enableFiltering: false,
				enableHiding: false,
				enablePinning: false,
				enableColumnMenu: false,
				enableSorting: false,
				cellClass: 'column-right text-xs',
				headerCellClass: 'column-center font-normal text-xs',
				cellTemplate: __webpack_require__(272)
			}],
	
			onRegisterApi: function onRegisterApi(gridApi) {
				usrVM.gridApi1 = gridApi;
				usrVM.gridApi1.grid.registerRowsProcessor(usrVM.singleFiltercomitee, 200);
				$interval(function () {
					usrVM.gridApi1.core.handleWindowResize();
				}, 500, 10);
			}
		};
	
		usrVM.filtercomitee = function () {
			usrVM.gridApi1.grid.refresh();
		};
	
		usrVM.singleFiltercomitee = function (renderableRows) {
			var matcher = new RegExp(usrVM.usersFiltercomitee, 'i');
	
			renderableRows.forEach(function (row) {
				var match = false;
	
				['comiteeName', 'comiteeEndDate'].forEach(function (field) {
					if (row.entity[field].match(matcher)) {
						match = true;
					}
				});
	
				if (!match) {
					row.visible = false;
				}
			});
	
			return renderableRows;
		};
	
		usrVM.filter = function () {
			usrVM.gridApi.grid.refresh();
		};
	
		usrVM.singleFilter = function (renderableRows) {
			var matcher = new RegExp(usrVM.usersFilter, 'i');
	
			renderableRows.forEach(function (row) {
				var match = false;
	
				['userName', 'academicName', 'userRole'].forEach(function (field) {
					if (row.entity[field].match(matcher)) {
						match = true;
					}
				});
	
				if (!match) {
					row.visible = false;
				}
			});
	
			return renderableRows;
		};
	
		usrVM.router = function (route) {
			if (route.id_code !== 4) {
				$state.go('generalSettings.createUsers', { roleId: usrVM.selectedRole.id_code });
			} else {
				$state.go('generalSettings.createCommittee');
			}
		};
	
		function disableCommittee(params, row, dialog) {
			return GeneralSettingsSrv.disableCommittee.post(params).$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					removeRow(row);
					dialog.hide();
					$rootScope.$emit('$disablePermit');
				}
			}).catch(function (error) {
				console.log('communications failure with server');
			});
		}
	
		function disablePermit(params, row, dialog) {
			return GeneralSettingsSrv.disablePermit.post(params).$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					removeRow(row);
					dialog.hide();
					$rootScope.$emit('$disablePermit');
				}
			}).catch(function (error) {
				console.log('communications failure with server');
			});
		}
	
		$rootScope.$on('$disablePermit', function (event, data) {
			console.log('disablePermit');
			// $state.reload()
	
			intialize();
		});
	
		function removeRow(entity) {
			var index = usrVM.usersGrid.data.indexOf(entity);
	
			usrVM.usersGrid.data.splice(index, 1);
		}
	
		function eliminatePermit(entity, dialog) {
			if (entity.userRoleId === 4) {
				var params = {
					userId: entity.userId,
					comiteeId: entity.comiteeId,
					roleId: entity.userRoleId
				};
	
				disableCommittee(params, entity, dialog);
			} else {
				var _params = {
					userId: entity.userId,
					roleId: entity.userRoleId,
					academicUnitId: entity.academicId
				};
	
				disablePermit(_params, entity, dialog);
			}
		}
	
		function confirmDisableUser(userEntity) {
			var user = userEntity;
	
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.user = user;
					$scope.userName = user.userName;
					$scope.close = function () {
						$mdDialog.hide();
					};
					$scope.disableUser = function (entity) {
						eliminatePermit(entity, $mdDialog);
					};
				}],
				template: __webpack_require__(273),
				clickOutsideToClose: false
			});
		}
	
		function confirmDisableComite(userEntity) {
			var user = userEntity;
	
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.user = user;
					$scope.comiteeName = user.comiteeName;
					$scope.close = function () {
						$mdDialog.hide();
					};
					$scope.disableUser = function (entity) {
						eliminatePermit(entity, $mdDialog);
					};
				}],
				template: __webpack_require__(274),
				clickOutsideToClose: false
			});
		}
	
		intialize();
	};
	
	exports.default = UsersCtrl;
	
	
	UsersCtrl.$inject = ['$rootScope', '$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', '$cookies', 'Validations', 'GlobalConfig'];

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <a class=\"text-xs m-r-md\" ng-click=grid.appScope.usrVM.confirmDisableUser(row.entity) ng-if=\"row.entity.userRoleId == 36 || row.entity.userRoleId == 37 || grid.appScope.usrVM.roleId == 15\"> <i class=\"icon mdi-action-delete i-16 dark-icon m-r-xs\"></i> Eliminar </a> </div> ";

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <a ng-if=\"row.entity.userRoleId === 4\" class=\"text-xs m-r-md\" ui-sref=\"generalSettings.editCommittee({committeeId: row.entity.comiteeId})\"> <i class=\"icon mdi-editor-border-color i-16 dark-icon m-r-xs\"></i> Editar </a> <a class=\"text-xs m-r-md\" ng-click=grid.appScope.usrVM.confirmDisableComite(row.entity) has-permission=crear-comite-edit> <i class=\"icon mdi-action-delete i-16 dark-icon m-r-xs\"></i> Eliminar </a> </div>";

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close() aria-label=cancelDisable> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Está a punto de eliminar el usuario \"{{userName}}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close() aria-label=cancelDisable>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=disableUser(user) aria-label=disable>Sí, eliminar usuario</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close() aria-label=cancelDisable> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Está a punto de eliminar el comité \"{{comiteeName}}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close() aria-label=cancelDisable>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=disableUser(user) aria-label=disable>Sí, eliminar comité</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateUsersCtrl = function CreateUsersCtrl($scope, GeneralSettingsSrv, $interval, $state, $stateParams, $mdDialog, GlobalConfig, $cookies, Validations) {
	  _classCallCheck(this, CreateUsersCtrl);
	
	  var createUserVM = this;
	  var user = JSON.parse($cookies.get('currentUser'));
	  var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	  // constants
	  createUserVM.academicUnits = {};
	  createUserVM.features = {};
	  createUserVM.users = {};
	  createUserVM.role = {};
	  createUserVM.listOfAssignments = [];
	  createUserVM.constraints = [];
	
	  // variables
	  createUserVM.selectedUnit = null;
	  createUserVM.selectedFeatures = [];
	  createUserVM.searchBy = "1";
	  createUserVM.selectedUser = "";
	  createUserVM.mappedFeatures = [];
	  createUserVM.isDisabled = false;
	  createUserVM.dataUsersGrid = {};
	  createUserVM.showAcademicUnit = false;
	  createUserVM.saveNewUser = false;
	  createUserVM.checkIsOverMax = checkIsOverMax;
	  createUserVM.numberMaxUser = 0;
	  createUserVM.uaIdDefault = 0;
	
	  // methods
	  createUserVM.searchUsers = searchUsers;
	  createUserVM.exists = exists;
	  createUserVM.addPermissionToUser = addPermissionToUser;
	  createUserVM.validateForm = validateForm;
	  createUserVM.confirmDisableUser = confirmDisableUser;
	
	  // local variables
	  var roleSelected = parseInt($stateParams.roleId);
	
	  activate();
	  getAssignedUsers();
	
	  function activate() {
	    return getFormData();
	  }
	
	  function getAssignedUsers() {
	    return GeneralSettingsSrv.getUsersWithRole.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        createUserVM.listOfAssignments = [];
	        dataReturn.data.forEach(function (user) {
	          if (user.userRoleId == roleSelected) {
	            createUserVM.listOfAssignments.push(user);
	          }
	        });
	        checkIsOverMax();
	      } else {
	        console.log(dataReturn);
	      }
	    }).catch(function (err) {
	      console.log("communications failure with server: ", err);
	    });
	  }
	
	  function getFormData() {
	    return GeneralSettingsSrv.getFormData.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        createUserVM.academicUnits = dataReturn.academicUnits;
	        createUserVM.features = dataReturn.features;
	        createUserVM.users = dataReturn.users;
	
	        _updateSelectedFeatures(dataReturn.permissions);
	
	        dataReturn.roles.forEach(function (role) {
	          if (role.id_code === roleSelected) {
	            createUserVM.role = role;
	          }
	        });
	
	        if (createUserVM.role.is_required_academicUnit == 1) {
	          createUserVM.showAcademicUnit = true;
	        } else {
	          createUserVM.showAcademicUnit = false;
	        }
	
	        if (createUserVM.role.id_code === GlobalConfig.userRolesIds.adminUnit) {
	          validateUsersLimitsConstrains(dataReturn.countUsers, GlobalConfig.userRolesIds.adminUnit, 2);
	        } else if (createUserVM.role.id_code === GlobalConfig.userRolesIds.adminModule) {
	          validateUsersLimitsConstrains(dataReturn.countUsers, GlobalConfig.userRolesIds.adminModule, 2);
	        }
	
	        createUserVM.numberMaxUser = createUserVM.role.nm_maxUsers;
	        if (createUserVM.role.id_academicUnit !== null) {
	          createUserVM.uaIdDefault = createUserVM.role.id_academicUnit;
	          createUserVM.academicUnits.forEach(function (au) {
	            if (au.id_code == createUserVM.uaIdDefault) createUserVM.selectedUnit = au;
	          });
	        }
	      } else {
	        console.log(dataReturn);
	      }
	    }).catch(function (err) {
	      console.log("communications failure with server: ", err);
	    });
	  }
	
	  function _showAddUserExists(userName) {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.userName = userName;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(276),
	      clickOutsideToClose: false
	    });
	  }
	
	  function addPermission(params, assignment) {
	    var userExist = false;
	    createUserVM.saveNewUser = false;
	
	    var header = {};
	    if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
	      header.userId = user.id;
	      header.rolId = currentRoleId;
	    }
	
	    return GeneralSettingsSrv.getUsers.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        createUserVM.dataUsersGrid = dataReturn.data;
	        if (createUserVM.role.is_required_academicUnit === 1) {
	          createUserVM.dataUsersGrid.forEach(function (dataUser) {
	            if (dataUser.userId === assignment.user.id_code && dataUser.academicId === assignment.academicUnitId.id_code && dataUser.userRoleId === createUserVM.role.id_code) {
	              userExist = true;
	              $scope.userName = dataUser.userName;
	            }
	          });
	        } else {
	          createUserVM.dataUsersGrid.forEach(function (dataUser) {
	            if (dataUser.userId === assignment.user.id_code && dataUser.userRoleId === createUserVM.role.id_code) {
	              userExist = true;
	              $scope.userName = dataUser.userName;
	            }
	          });
	        }
	        if (userExist) {
	          _updateUsersPermissionsAdded();
	          _showAddUserExists($scope.userName);
	          _resetForm();
	        } else {
	          return GeneralSettingsSrv.addPermission.post(params).$promise.then(function (dataReturn) {
	            if (dataReturn.status === true) {
	              _updateUsersPermissionsAdded();
	              createUserVM.saveNewUser = true;
	              _resetForm();
	              getAssignedUsers();
	            } else {
	              createUserVM.isDisabled = false;
	            }
	          }).catch(function (err) {
	            console.log("communications failure with server: ", err);
	          });
	        }
	      } else {
	        console.log(dataReturn);
	      }
	    }).catch(function (err) {
	      console.log("communications failure with server: ", err);
	    });
	  }
	
	  function searchUsers(text) {
	    var matcher = new RegExp(text, 'i');
	    var arr = [];
	    createUserVM.users.forEach(function (user) {
	      if (createUserVM.searchBy === "1") {
	        if (user.ds_fullname.match(matcher)) {
	          arr.push(user);
	        }
	      } else {
	        if (user.ds_identification.match(matcher)) {
	          arr.push(user);
	        }
	      }
	    });
	    return arr;
	  }
	
	  function exists(item) {
	    return createUserVM.selectedFeatures.indexOf(item.id_feature + '') > -1;
	  }
	
	  function validateForm() {
	    if (createUserVM.selectedUnit === null && createUserVM.showAcademicUnit || createUserVM.selectedUser == "" || createUserVM.selectedUser === null) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  function addPermissionToUser() {
	    createUserVM.isDisabled = true;
	    var valueSelAcademicUnitId = null;
	    var valueSelAcademicUnit = null;
	
	    if (createUserVM.role.is_required_academicUnit === 1) {
	      valueSelAcademicUnitId = createUserVM.selectedUnit.id_code;
	      valueSelAcademicUnit = createUserVM.selectedUnit;
	    }
	
	    var params = [{
	      roleId: createUserVM.role.id_code,
	      academicUnitId: valueSelAcademicUnitId,
	      userId: createUserVM.selectedUser.id_code
	    }];
	    var assignment = {
	      academicUnitId: valueSelAcademicUnit,
	      user: createUserVM.selectedUser
	    };
	
	    addPermission(params, assignment);
	  }
	
	  function _updateSelectedFeatures(data) {
	    for (var pos in data) {
	      if (data[pos].roleId === roleSelected) {
	        if (data[pos].featuresIds.indexOf(',') > -1) createUserVM.selectedFeatures = data[pos].featuresIds.split(',');else createUserVM.selectedFeatures = data[pos].featuresIds;
	        return;
	      }
	    }
	  }
	
	  function _showLimitOfUserReached() {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.rolName = createUserVM.role.ds_name;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(277),
	      clickOutsideToClose: false
	    });
	  }
	
	  function validateUsersLimitsConstrains(restrictions, roleId, restrictionAmount) {
	    restrictions.forEach(function (constraint) {
	      if (constraint.id_role === roleId) {
	        createUserVM.constraints.push(constraint);
	        createUserVM.academicUnits.forEach(function (unit) {
	          if (unit.id_code === constraint.id_academicunits && constraint.quantityUsers === restrictionAmount) {
	            createUserVM.academicUnits.splice(createUserVM.academicUnits.indexOf(unit), 1);
	          }
	        });
	      }
	    });
	    isEmptyAcademicUnits(createUserVM.academicUnits);
	  }
	
	  function _updateUsersPermissionsAdded() {
	    if (createUserVM.role.is_required_academicUnit === 1) {
	      createUserVM.constraints.forEach(function (constraint) {
	        if (constraint.id_academicunits === createUserVM.selectedUnit.id_code) {
	          constraint.quantityUsers++;
	          if (createUserVM.role.id_code === GlobalConfig.userRolesIds.adminUnit && constraint.quantityUsers === 2 || createUserVM.role.id_code === GlobalConfig.userRolesIds.adminModule && constraint.quantityUsers === 2) {
	            createUserVM.academicUnits.splice(createUserVM.academicUnits.indexOf(createUserVM.selectedUnit), 1);
	          }
	        }
	      });
	    }
	  }
	
	  function confirmDisableUser(userAssigned, positionInArray) {
	    var user = userAssigned;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.user = user;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	
	        if (createUserVM.role.is_required_academicUnit === 1) {
	          $scope.disableUser = function (entity) {
	            var params = {
	              userId: entity.id_code,
	              roleId: roleSelected,
	              academicUnitId: entity.academicId
	            };
	            disablePermit(params, positionInArray, $mdDialog);
	          };
	        } else {
	          $scope.disableUser = function (entity) {
	            var params = {
	              userId: entity.id_code,
	              roleId: roleSelected,
	              academicUnitId: null
	            };
	            disablePermit(params, positionInArray, $mdDialog);
	          };
	        }
	      }],
	      template: __webpack_require__(273),
	      clickOutsideToClose: false
	    });
	  }
	
	  function disablePermit(params, pos, dialog) {
	    return GeneralSettingsSrv.disablePermit.post(params).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        _resetForm();
	        createUserVM.listOfAssignments.splice(pos, 1);
	        dialog.hide();
	      }
	    }).catch(function (error) {
	      console.log("communications failure with server");
	    });
	  }
	
	  /*
	  //No use, update method for utilization
	  function isAlreadyAdded(){
	    for(var elem in createUserVM.listOfAssignments){
	      if(createUserVM.listOfAssignments[elem].academicUnitId.id_code == createUserVM.selectedUnit.id_code 
	        && createUserVM.listOfAssignments[elem].user.id_code == createUserVM.selectedUser.id_code){
	        return true
	      }
	    }
	    return false
	  }
	  */
	
	  function _resetForm() {
	    createUserVM.selectedUnit = null;
	    createUserVM.selectedUser = "";
	    createUserVM.isDisabled = false;
	    getFormData();
	  }
	
	  function isEmptyAcademicUnits(units) {
	    if (units.length === 0) {
	      if (createUserVM.saveNewUser === true) {
	        _showAddedPermissionAndLimitOfUserReached();
	        createUserVM.saveNewUser = false;
	      } else {
	        _showLimitOfUserReached();
	      }
	    } else {
	      if (createUserVM.saveNewUser === true) {
	        _showAddedPermissionModal();
	        createUserVM.saveNewUser = false;
	      }
	    }
	  }
	
	  function _showAddedPermissionModal() {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.rolName = createUserVM.role.ds_name;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(278),
	      clickOutsideToClose: false
	    });
	  }
	
	  function _showAddedPermissionAndLimitOfUserReached() {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.rolName = createUserVM.role.ds_name;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(279),
	      clickOutsideToClose: false
	    });
	  }
	
	  function checkIsOverMax() {
	    if (!_typeof(createUserVM.listOfAssignments) != 'undefined' && createUserVM.numberMaxUser !== null && createUserVM.listOfAssignments.length >= createUserVM.numberMaxUser) {
	      return true;
	    }
	  }
	};
	
	exports.default = CreateUsersCtrl;
	
	
	CreateUsersCtrl.$inject = ['$scope', 'GeneralSettingsSrv', '$interval', '$state', '$stateParams', '$mdDialog', 'GlobalConfig', '$cookies', 'Validations'];

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>El usuario \"{{userName}}\" ya existe para el rol y la unidad académica seleccionada.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>El rol de \"{{rolName}}\" ha alcanzado la cantidad máxima de usuarios permitidos.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close() ui-sref=generalSettings.users>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creaci&oacute;n exitosa!</h3> <p>Se ha asignado el rol de \"{{rolName}}\" satisfactoriamente.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Creaci&oacute;n exitosa!</h3> <p>Se ha asignado el rol de \"{{rolName}}\" satisfactoriamente.</p> </div> </div> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>El rol de \"{{rolName}}\" ha alcanzado la cantidad máxima de usuarios permitidos.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close() ui-sref=generalSettings.users>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateCommitteeCtrl = function () {
		function CreateCommitteeCtrl($scope, GeneralSettingsSrv, $mdDialog, $interval, uiGridConstants, i18nService, $state, $timeout, $cookies, Validations, GlobalConfig, GlobalSrv, ngNotify) {
			_classCallCheck(this, CreateCommitteeCtrl);
	
			i18nService.setCurrentLang('es');
	
			// constants
			var createCommitteeVM = this;
			var user = JSON.parse($cookies.get('currentUser'));
			var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
			createCommitteeVM.submodules = {};
			createCommitteeVM.users = {};
			createCommitteeVM.minStartDate = moment().toDate();
	
			// variables
			createCommitteeVM.usersFilter = '';
			createCommitteeVM.searchBy = '1';
			createCommitteeVM.searchAdminBy = '1';
			createCommitteeVM.selectedUser = '';
			createCommitteeVM.newCommittee = '';
			createCommitteeVM.committeeUsers = [];
			createCommitteeVM.committeeAdminUser = {};
			createCommitteeVM.mappedUsers = [];
			createCommitteeVM.selectedTeachers = [];
			createCommitteeVM.mappedTeachers = [];
			createCommitteeVM.isDisabled = false;
			createCommitteeVM.startDate = null;
			createCommitteeVM.endDate = null;
			createCommitteeVM.selectedSubmodules = [];
			createCommitteeVM.mappedSubmodules = [];
			createCommitteeVM.minEndDate = moment().toDate();
	
			// methods
			createCommitteeVM.searchUsers = searchUsers;
			createCommitteeVM.highlightFilteredHeader = highlightFilteredHeader;
			createCommitteeVM.filter = filter;
			createCommitteeVM.singleFilter = singleFilter;
			createCommitteeVM.toggle = toggle;
			createCommitteeVM.exists = exists;
			createCommitteeVM.isIndeterminate = isIndeterminate;
			createCommitteeVM.isChecked = isChecked;
			createCommitteeVM.toggleAll = toggleAll;
			createCommitteeVM.addUserToCommittee = addUserToCommittee;
			createCommitteeVM.addAdminUsertoComittee = addAdminUsertoComittee;
			createCommitteeVM.dropUser = dropUser;
			createCommitteeVM.dropAdminUser = dropAdminUser;
			createCommitteeVM.validateForm = validateForm;
			createCommitteeVM.saveCommitteeConfig = saveCommitteeConfig;
			createCommitteeVM.startDateChanged = startDateChanged;
			createCommitteeVM.hasError = hasError;
			createCommitteeVM.showErrorMessages = showErrorMessages;
	
			// grid object configuration
			createCommitteeVM.committeeGrid = {
				enableRowHeaderSelection: true,
				enableRowSelection: true,
				enableSelectAll: false,
				showGridFooter: true,
				selectionRowHeaderWidth: 35,
				rowHeight: 35,
				enableFiltering: true,
				multiSelect: true,
				columnDefs: [_defineProperty({
					name: 'Nombre',
					displayName: 'Nombre',
					field: 'teacherName',
					width: '30%',
					headerCellClass: createCommitteeVM.highlightFilteredHeader,
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs'
				}, 'headerCellClass', 'font-normal text-xs'), {
					name: 'Unidad académica',
					displayName: 'Unidad académica',
					field: 'academicUnitName',
					width: '35%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs'
				}, {
					name: 'Cédula',
					displayName: 'Cédula',
					field: 'identification',
					width: '25%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs'
				}],
				onRegisterApi: function onRegisterApi(gridApi) {
					createCommitteeVM.gridApi = gridApi;
					createCommitteeVM.gridApi.grid.registerRowsProcessor(createCommitteeVM.singleFilter, 200);
					gridApi.selection.on.rowSelectionChanged($scope, function (row) {
						if (createCommitteeVM.selectedTeachers.includes(row.entity.teacherId)) {
							var idx = createCommitteeVM.selectedTeachers.indexOf(row.entity.teacherId);
	
							createCommitteeVM.selectedTeachers.splice(idx, 1);
						} else {
							createCommitteeVM.selectedTeachers.push(row.entity.teacherId);
						}
					});
					$interval(function () {
						createCommitteeVM.gridApi.core.handleWindowResize();
					}, 500, 10);
				}
	
				// methods declaration
			};function activate() {
				return getCommitteeFormData();
			}
	
			function getCommitteeFormData() {
				var header = {};
	
				if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
					header.userId = user.id;
					header.rolId = currentRoleId;
				}
	
				return GeneralSettingsSrv.getCommitteeFormData.get(header).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						createCommitteeVM.submodules = dataReturn.submodules;
						createCommitteeVM.users = dataReturn.users;
						createCommitteeVM.committeeGrid.data = dataReturn.teachers;
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
	
			function getNotifyAdmin(rolesId) {
				getSendNotifyAdmin(rolesId);
			}
	
			function getSendNotifyAdmin(rolesId) {
				var data = {
					rolesId: rolesId,
					idTeacher: null,
					dsName: 'Notificación, se agregó un comité',
					dsDescription: 'Administrador de unidad ó modulo: se ha creado el comité "' + createCommitteeVM.newCommittee + '" con las siguientes fechas de inicio: ' + moment(createCommitteeVM.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(createCommitteeVM.endDate).format('DD/MM/YYYY'),
					idNotification_delivery_type: GlobalConfig.notificationType.inbox,
					is_grouped: 1
				};
	
				GlobalSrv.addNotificationToAdminWorkPlan.add(data).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						console.log('Notificación exitosa', dataReturn);
					} else {
						console.log('Error de comunicación en la notificación');
					}
				}).catch(function (error) {
					console.error(error);
				});
				//GlobalSrv.sendNotificationAdmin(data)
			}
	
			function getNotifyExceed(idRole) {
				var reviewers = GlobalSrv.getReviewers(idRole);
	
				reviewers.forEach(function (reviewer) {
					getSendNotifyExceed(reviewer);
				});
			}
	
			function getSendNotifyExceed(idUser) {
				var data = {
					idUser: idUser,
					dsName: 'Notificación, se agregó un comité que excede los lineamientos institucionales',
					dsDescription: 'Sr. Administrador de unidad, el comité "' + createCommitteeVM.newCommittee + '" que editó excede los lineamientos institucionales, se modificaron as fechas de inicio: ' + moment(createCommitteeVM.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(createCommitteeVM.endDate).format('DD/MM/YYYY'),
					idNotification_delivery_type: GlobalConfig.notificationType.inbox
				};
	
				console.log('getSendNotifyExceed--->', data);
				GlobalSrv.sendNotification(data);
			}
	
			function addCommittee(params) {
				return GeneralSettingsSrv.addCommittee.post(params).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						//Notificación excede
						//getNotifyExceed(GlobalConfig.userRolesIds.adminUnit)
						getNotifyAdmin([GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.adminUnit, GlobalConfig.userRolesIds.adminModule]);
	
						$state.go('generalSettings.users');
					} else {
						console.log(dataReturn);
						createCommitteeVM.isDisabled = false;
						ngNotify.set('No se ha podido conectar con el servicio', 'error');
					}
				}).catch(function (err) {
					createCommitteeVM.isDisabled = false;
					console.log(err);
					ngNotify.set('No se ha podido conectar con el servicio', 'error');
				});
			}
	
			function searchUsers(text) {
				var matcher = new RegExp(text, 'i');
				var arr = [];
	
				createCommitteeVM.users.forEach(function (user) {
					if (createCommitteeVM.searchBy === '1') {
						if (user.ds_fullname.match(matcher)) {
							arr.push(user);
						}
					} else {
						if (user.ds_identification.match(matcher)) {
							arr.push(user);
						}
					}
				});
	
				return arr;
			}
	
			function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
				if (col.filters[0].term) {
					return 'header-filtered';
				} else {
					return '';
				}
			}
	
			function filter() {
				createCommitteeVM.gridApi.grid.refresh();
			}
	
			function singleFilter(renderableRows) {
				var matcher = new RegExp(createCommitteeVM.usersFilter, 'i');
	
				renderableRows.forEach(function (row) {
					var match = false;
	
					['teacherName', 'academicUnitName', 'identification'].forEach(function (field) {
						if (row.entity[field].match(matcher)) {
							match = true;
						}
					});
	
					if (!match) {
						row.visible = false;
					}
				});
	
				return renderableRows;
			}
	
			function toggle(item) {
				var idx = createCommitteeVM.selectedSubmodules.indexOf(item);
	
				if (idx > -1) {
					createCommitteeVM.selectedSubmodules.splice(idx, 1);
				} else {
					createCommitteeVM.selectedSubmodules.push(item);
				}
	
				createCommitteeVM.mappedSubmodules = createCommitteeVM.selectedSubmodules.map(function (submodule) {
					return { submoduleId: submodule.id_code };
				});
			}
	
			function exists(item) {
				return createCommitteeVM.selectedSubmodules.indexOf(item) > -1;
			}
	
			function isIndeterminate() {
				return createCommitteeVM.selectedSubmodules.length !== 0 && createCommitteeVM.selectedSubmodules.length !== createCommitteeVM.submodules.length;
			}
	
			function isChecked() {
				return createCommitteeVM.selectedSubmodules.length === createCommitteeVM.submodules.length;
			}
	
			function toggleAll() {
				if (createCommitteeVM.selectedSubmodules.length === createCommitteeVM.submodules.length) {
					createCommitteeVM.selectedSubmodules = [];
					createCommitteeVM.mappedSubmodules = [];
				} else if (createCommitteeVM.selectedSubmodules.length === 0 || createCommitteeVM.selectedSubmodules.length > 0) {
					createCommitteeVM.selectedSubmodules = createCommitteeVM.submodules.slice(0);
					createCommitteeVM.mappedSubmodules = createCommitteeVM.submodules.slice(0).map(function (submodule) {
						return { submoduleId: submodule.id_code };
					});
				}
			}
	
			function addUserToCommittee(user) {
				if (user && !createCommitteeVM.committeeUsers.includes(user)) {
					createCommitteeVM.committeeUsers.push(user);
					createCommitteeVM.mappedUsers.push({ userId: user.id_code });
				}
	
				createCommitteeVM.searchText = '';
			}
			function addAdminUsertoComittee(user) {
				if (user && createCommitteeVM.committeeAdminUser !== user) {
					createCommitteeVM.committeeAdminUser = user;
				}
	
				createCommitteeVM.searchAdminText = '';
			}
	
			function dropUser(idx) {
				createCommitteeVM.committeeUsers.splice(idx, 1);
				createCommitteeVM.mappedUsers.splice(idx, 1);
			}
			function dropAdminUser() {
				createCommitteeVM.committeeAdminUser = {};
			}
	
			function saveCommitteeConfig() {
				createCommitteeVM.isDisabled = true;
				createCommitteeVM.selectedTeachers = createCommitteeVM.selectedTeachers.map(function (id) {
					return { teacherId: id };
				});
				var params = {
					comiteeAdminUser: createCommitteeVM.committeeAdminUser.id_code || null,
					roleId: 4,
					comiteeName: createCommitteeVM.newCommittee,
					comiteeTypeId: 1,
					startDate: moment(new Date(createCommitteeVM.startDate)).format('YYYY-MM-DD hh:mm:ss'),
					endDate: moment(new Date(createCommitteeVM.endDate)).format('YYYY-MM-DD hh:mm:ss'),
					users: createCommitteeVM.mappedUsers,
					submodules: createCommitteeVM.mappedSubmodules,
					teachers: createCommitteeVM.selectedTeachers
				};
	
				addCommittee(params);
			}
	
			function startDateChanged() {
				var m = moment(createCommitteeVM.startDate);
	
				createCommitteeVM.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : moment().toDate();
			}
	
			function hasError(input) {
				if (input.$invalid && (input.$dirty || input.$touched)) return 'has-error';
			}
	
			function showErrorMessages(input) {
				return input.$dirty || input.$touched;
			}
	
			function validateForm() {}
	
			// initialization
			activate();
		} //FIN DEL CONSTRUCTOR
	
		_createClass(CreateCommitteeCtrl, [{
			key: 'preventInput',
			value: function preventInput(event) {
				var vKey = 86;
	
				if (event.keyCode == vKey) event.preventDefault();
	
				return;
			}
		}]);
	
		return CreateCommitteeCtrl;
	}();
	
	exports.default = CreateCommitteeCtrl;
	
	
	CreateCommitteeCtrl.$inject = ['$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', '$timeout', '$cookies', 'Validations', 'GlobalConfig', 'GlobalSrv', 'ngNotify'];

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditCommitteeCtrl = function () {
		function EditCommitteeCtrl($scope, GeneralSettingsSrv, $mdDialog, $interval, uiGridConstants, i18nService, $state, $stateParams, $cookies, Validations, GlobalConfig, GlobalSrv) {
			_classCallCheck(this, EditCommitteeCtrl);
	
			i18nService.setCurrentLang('es');
			// constants
			var editCommitteeVM = this;
	
			editCommitteeVM.submodules = {};
			editCommitteeVM.users = {};
			editCommitteeVM.committeeId = {};
			editCommitteeVM.minStartDate = moment().toDate();
			var user = JSON.parse($cookies.get('currentUser'));
			var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
			editCommitteeVM.isCommitteeAdminUser = Validations.isCommitteeAdmin(currentRoleId);
	
			// variables
			editCommitteeVM.usersFilter = '';
			editCommitteeVM.searchBy = '1';
			editCommitteeVM.searchAdminBy = '1';
			editCommitteeVM.selectedUser = '';
			editCommitteeVM.newCommittee = '';
			editCommitteeVM.committeeUsers = [];
			editCommitteeVM.committeeAdminUser = {};
			editCommitteeVM.mappedUsers = [];
			editCommitteeVM.selectedTeachers = [];
			editCommitteeVM.mappedTeachers = [];
			editCommitteeVM.isDisabled = false;
			editCommitteeVM.startDate = null;
			editCommitteeVM.endDate = null;
			editCommitteeVM.selectedSubmodules = [];
			editCommitteeVM.mappedSubmodules = [];
			editCommitteeVM.minEndDate = moment().toDate();
	
			// methods
			editCommitteeVM.searchUsers = searchUsers;
			editCommitteeVM.highlightFilteredHeader = highlightFilteredHeader;
			editCommitteeVM.filter = filter;
			editCommitteeVM.singleFilter = singleFilter;
			editCommitteeVM.toggle = toggle;
			editCommitteeVM.exists = exists;
			editCommitteeVM.isIndeterminate = isIndeterminate;
			editCommitteeVM.isChecked = isChecked;
			editCommitteeVM.toggleAll = toggleAll;
			editCommitteeVM.addUserToCommittee = addUserToCommittee;
			editCommitteeVM.addAdminUsertoComittee = addAdminUsertoComittee;
			editCommitteeVM.dropUser = dropUser;
			editCommitteeVM.dropAdminUser = dropAdminUser;
			editCommitteeVM.validateForm = validateForm;
			editCommitteeVM.saveCommitteeConfig = saveCommitteeConfig;
			editCommitteeVM.startDateChanged = startDateChanged;
			editCommitteeVM.hasError = hasError;
			editCommitteeVM.showErrorMessages = showErrorMessages;
	
			// grid object configuration
			editCommitteeVM.committeeGrid = {
				enableRowHeaderSelection: true,
				enableRowSelection: true,
				enableSelectAll: false,
				showGridFooter: true,
				selectionRowHeaderWidth: 35,
				rowHeight: 35,
				enableFiltering: true,
				multiSelect: true,
				columnDefs: [_defineProperty({
					name: 'Nombre',
					displayName: 'Nombre',
					field: 'teacherName',
					width: '30%',
					headerCellClass: editCommitteeVM.highlightFilteredHeader,
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs'
				}, 'headerCellClass', 'font-normal text-xs'), {
					name: 'Unidad académica',
					displayName: 'Unidad académica',
					field: 'academicUnitName',
					width: '35%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs'
				}, {
					name: 'Cédula',
					displayName: 'Cédula',
					field: 'identification',
					width: '25%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs'
				}],
				onRegisterApi: function onRegisterApi(gridApi) {
					editCommitteeVM.gridApi = gridApi;
					editCommitteeVM.gridApi.grid.registerRowsProcessor(editCommitteeVM.singleFilter, 200);
					gridApi.selection.on.rowSelectionChanged($scope, function (row) {
						if (row.isSelected) {
							if (!editCommitteeVM.selectedTeachers.includes(row.entity.teacherId)) editCommitteeVM.selectedTeachers.push(row.entity.teacherId);
						} else {
							if (editCommitteeVM.selectedTeachers.includes(row.entity.teacherId)) {
								var idx = editCommitteeVM.selectedTeachers.indexOf(row.entity.teacherId);
	
								editCommitteeVM.selectedTeachers.splice(idx, 1);
							}
						}
					});
					$interval(function () {
						editCommitteeVM.gridApi.core.handleWindowResize();
					}, 500, 10);
				}
	
				// methods declaration
			};function activate() {
				return getCommitteeFormData();
			}
	
			function getCommitteeFormData() {
				var header = {};
	
				if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
					header.userId = user.id;
					header.rolId = currentRoleId;
				}
	
				return GeneralSettingsSrv.getCommitteeFormData.get(header).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						editCommitteeVM.submodules = dataReturn.submodules;
						editCommitteeVM.users = dataReturn.users;
						editCommitteeVM.committeeGrid.data = dataReturn.teachers;
						getCommittee({ comiteeId: $stateParams.committeeId });
					}
				}).catch(function (error) {
					console.log('getCommitteeFormData -> communications failure with server', error);
				});
			}
	
			function getCommittee(params) {
				return GeneralSettingsSrv.getCommittee.get(params).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						editCommitteeVM.newCommittee = dataReturn.data[0].comiteeName;
						editCommitteeVM.committeeId = dataReturn.data[0].comiteeId;
						editCommitteeVM.startDate = moment(dataReturn.data[0].startDate, 'YYYY-MM-DD').toDate();
						editCommitteeVM.endDate = moment(dataReturn.data[0].endDate, 'YYYY-MM-DD').toDate();
						editCommitteeVM.userAdmin = dataReturn.data[0].adminUser;
						// editCommitteeVM.selectedTeachers = dataReturn.data[0].teachers
						editCommitteeVM.users.forEach(function (user) {
							var arr = dataReturn.data[0].users.split(',').map(function (x) {
								return parseInt(x);
							});
	
							arr.forEach(function (id) {
								if (user.id_code === id) {
									addUserToCommittee(user);
								}
							});
						});
						editCommitteeVM.submodules.forEach(function (submodule) {
							var arr = dataReturn.data[0].submodules.split(',').map(function (x) {
								return parseInt(x);
							});
	
							arr.forEach(function (id) {
								if (submodule.id_code === id) {
									toggle(submodule);
								}
							});
						});
	
						editCommitteeVM.selectedTeachers = dataReturn.data[0].teachers.split(',').map(function (teacherId) {
							return parseInt(teacherId);
						});
	
						editCommitteeVM.committeeGrid.data.forEach(function (professor) {
							if (editCommitteeVM.selectedTeachers.includes(professor.teacherId)) {
								editCommitteeVM.gridApi.selection.selectRow(professor);
							}
						});
	
						if (editCommitteeVM.userAdmin) {
							var admin = editCommitteeVM.users.find(function (usr) {
								return usr.id_code === editCommitteeVM.userAdmin;
							});
	
							editCommitteeVM.committeeAdminUser = admin;
						}
	
						startDateChanged();
					}
				}).catch(function (error) {
					console.log('getCommittee -> communications failure with server', error);
				});
			}
	
			function getNotifyAdmin(params) {
				getSendNotifyAdmin(params);
			}
	
			function getSendNotifyAdmin(params) {
				var data = {
					rolesId: params.rolesId,
					idTeacher: null,
					dsName: 'Notificación, se editó un comité',
					dsDescription: 'Administrador de unidad ó modulo: se editó el comité "' + params.comiteeName + '" con las siguientes fechas de inicio: ' + moment(params.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(params.endDate).format('DD/MM/YYYY'),
					idNotification_delivery_type: GlobalConfig.notificationType.inbox,
					is_grouped: 1
				};
	
				GlobalSrv.addNotificationToAdminWorkPlan.add(data).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						console.log('Notificación exitosa', dataReturn);
					} else {
						console.log('Error de comunicación en la notificación');
					}
				}).catch(function (error) {
					console.error(error);
				});
				//GlobalSrv.sendNotificationAdmin(data)
			}
	
			function getSendNotifyExceed(params) {
				var data = {
					idUser: user.id,
					idTeacher: null,
					dsName: 'Notificación, se editó un comité que excede los lineamientos institucionales',
					dsDescription: 'Sr. Administrador de unidad, el comité "' + params.comiteeName + '" que editó excede los lineamientos institucionales, se modificaron as fechas de inicio: ' + moment(params.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(params.endDate).format('DD/MM/YYYY'),
					idNotification_delivery_type: GlobalConfig.notificationType.inbox
				};
	
				GlobalSrv.sendNotificationAdmin(data);
			}
	
			function updateCommittee(params) {
				return GeneralSettingsSrv.updateCommittee.post(params).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						getNotifyAdmin(params);
						$state.go('generalSettings.users');
						console.log('Permit actualized');
					} else {
						console.log(dataReturn);
					}
				}).catch(function (error) {
					editCommitteeVM.isDisabled = false;
					console.log('communications failure with server');
				});
			}
	
			function searchUsers(text) {
				var matcher = new RegExp(text, 'i');
				var arr = [];
	
				editCommitteeVM.users.forEach(function (user) {
					if (editCommitteeVM.searchBy === '1') {
						if (user.ds_fullname.match(matcher)) {
							arr.push(user);
						}
					} else {
						if (user.ds_identification.match(matcher)) {
							arr.push(user);
						}
					}
				});
	
				return arr;
			}
	
			function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
				if (col.filters[0].term) {
					return 'header-filtered';
				} else {
					return '';
				}
			}
	
			function filter() {
				editCommitteeVM.gridApi.grid.refresh();
			}
	
			function singleFilter(renderableRows) {
				var matcher = new RegExp(editCommitteeVM.usersFilter, 'i');
	
				renderableRows.forEach(function (row) {
					var match = false;
	
					['teacherName', 'academicUnitName', 'identification'].forEach(function (field) {
						if (row.entity[field].match(matcher)) {
							match = true;
						}
					});
	
					if (!match) {
						row.visible = false;
					}
				});
	
				return renderableRows;
			}
	
			function toggle(item) {
				var idx = editCommitteeVM.selectedSubmodules.indexOf(item);
	
				if (idx > -1) {
					editCommitteeVM.selectedSubmodules.splice(idx, 1);
				} else {
					editCommitteeVM.selectedSubmodules.push(item);
				}
	
				editCommitteeVM.mappedSubmodules = editCommitteeVM.selectedSubmodules.map(function (submodule) {
					return { submoduleId: submodule.id_code };
				});
			}
	
			function exists(item) {
				return editCommitteeVM.selectedSubmodules.indexOf(item) > -1;
			}
	
			function isIndeterminate() {
				return editCommitteeVM.selectedSubmodules.length !== 0 && editCommitteeVM.selectedSubmodules.length !== editCommitteeVM.submodules.length;
			}
	
			function isChecked() {
				return editCommitteeVM.selectedSubmodules.length === editCommitteeVM.submodules.length;
			}
	
			function toggleAll() {
				if (editCommitteeVM.selectedSubmodules.length === editCommitteeVM.submodules.length) {
					editCommitteeVM.selectedSubmodules = [];
					editCommitteeVM.mappedSubmodules = [];
				} else if (editCommitteeVM.selectedSubmodules.length === 0 || editCommitteeVM.selectedSubmodules.length > 0) {
					editCommitteeVM.selectedSubmodules = editCommitteeVM.submodules.slice(0);
					editCommitteeVM.mappedSubmodules = editCommitteeVM.submodules.slice(0).map(function (submodule) {
						return { submoduleId: submodule.id_code };
					});
				}
			}
	
			function addUserToCommittee(user) {
				if (user && !editCommitteeVM.committeeUsers.includes(user)) {
					editCommitteeVM.committeeUsers.push(user);
					editCommitteeVM.mappedUsers.push({ userId: user.id_code });
				}
	
				editCommitteeVM.searchText = '';
			}
	
			function addAdminUsertoComittee(user) {
				if (user && editCommitteeVM.committeeAdminUser !== user) {
					editCommitteeVM.committeeAdminUser = user;
				}
	
				editCommitteeVM.searchAdminText = '';
			}
	
			function dropUser(idx) {
				editCommitteeVM.committeeUsers.splice(idx, 1);
				editCommitteeVM.mappedUsers.splice(idx, 1);
			}
			function dropAdminUser() {
				editCommitteeVM.comitteeAdmin = {};
			}
	
			function saveCommitteeConfig() {
				editCommitteeVM.isDisabled = true;
				editCommitteeVM.selectedTeachers = editCommitteeVM.selectedTeachers.map(function (id) {
					return { teacherId: id };
				});
				var params = {
					comiteeAdminUser: editCommitteeVM.committeeAdminUser.id_code || null,
					comiteeId: editCommitteeVM.committeeId,
					roleId: 4,
					comiteeName: editCommitteeVM.newCommittee,
					comiteeTypeId: 1,
					startDate: moment(new Date(editCommitteeVM.startDate)).format('YYYY-MM-DD hh:mm:ss'),
					endDate: moment(new Date(editCommitteeVM.endDate)).format('YYYY-MM-DD hh:mm:ss'),
					users: editCommitteeVM.mappedUsers,
					submodules: editCommitteeVM.mappedSubmodules,
					teachers: editCommitteeVM.selectedTeachers,
					rolesId: [GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.adminUnit, GlobalConfig.userRolesIds.adminModule]
				};
	
				updateCommittee(params);
			}
	
			function startDateChanged() {
				var m = moment(editCommitteeVM.startDate);
	
				editCommitteeVM.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : moment().toDate();
			}
	
			function hasError(input) {
				if (input.$invalid && (input.$dirty || input.$touched)) return 'has-error';
			}
	
			function showErrorMessages(input) {
				return input.$dirty || input.$touched;
			}
	
			function validateForm() {}
	
			// initialization
			activate();
		} //FIN DEL CONSTRUCTOR
	
		_createClass(EditCommitteeCtrl, [{
			key: 'preventInput',
			value: function preventInput(event) {
				var vKey = 86;
	
				if (event.keyCode == vKey) event.preventDefault();
	
				return;
			}
		}]);
	
		return EditCommitteeCtrl;
	}();
	
	exports.default = EditCommitteeCtrl;
	
	
	EditCommitteeCtrl.$inject = ['$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', '$stateParams', '$cookies', 'Validations', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListCommitterCtrl = function ListCommitterCtrl($rootScope, $scope, GeneralSettingsSrv, $mdDialog, $interval, $uiGridConstants, i18nService, $state, $cookies) {
	  _classCallCheck(this, ListCommitterCtrl);
	
	  var listCommVM = this;
	  listCommVM.listCommiters = [];
	  listCommVM.usuario = JSON.parse($cookies.get('currentUser'));
	  $rootScope.fullscreenClass = 'background-planning';
	  listCommVM.filter = filter;
	  listCommVM.singleFilter = singleFilter;
	  listCommVM.isActive = isActive;
	  listCommVM.selectCommittee = selectCommittee;
	  listCommVM.selectedCommittee = 0;
	  listCommVM.noData = false;
	
	  // Grid definition
	
	  listCommVM.gridOptions = {
	    enableFiltering: true,
	    columnDefs: [{
	      displayName: 'Nombre Profesor',
	      name: 'Nombre Profesor',
	      field: 'teacherName',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Plan de Trabajo asignado',
	      name: 'Plan de Trabajo asignado',
	      field: 'workplanName',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Estado',
	      name: 'Estado',
	      field: 'stageName',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: true
	    }, {
	      displayName: 'Acciones',
	      name: 'Acciones',
	      field: 'stageId',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: __webpack_require__(283)
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      listCommVM.gridApi = gridApi;
	      listCommVM.gridApi.grid.registerRowsProcessor(listCommVM.singleFilter, 200);
	      $interval(function () {
	        listCommVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	
	  function filter() {
	    listCommVM.gridApi.grid.refresh();
	  }
	
	  function singleFilter(renderableRows) {
	    var matcher = new RegExp(listCommVM.committeerFilter, 'i');
	    renderableRows.forEach(function (row) {
	      var match = false;
	      ['teacherName', 'workplanName'].forEach(function (field) {
	        if (row.entity[field] && row.entity[field].match(matcher)) {
	          match = true;
	        }
	      });
	      if (!match) {
	        row.visible = false;
	      }
	    });
	    return renderableRows;
	  };
	
	  activate();
	
	  function activate() {
	    var requestHeader = {
	      idUser: listCommVM.usuario.id
	    };
	    GeneralSettingsSrv.getCommitteersByUser.get(requestHeader).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        listCommVM.listCommiters = dataReturn.data;
	        listCommVM.gridOptions.data = listCommVM.listCommiters[0].teacher;
	        if (!listCommVM.gridOptions.data.length) listCommVM.noData = true;else listCommVM.noData = false;
	      }
	    });
	  }
	  function selectCommittee(index) {
	    listCommVM.selectedCommittee = index;
	    listCommVM.gridOptions.data = listCommVM.listCommiters[index].teacher;
	    if (!listCommVM.gridOptions.data.length) listCommVM.noData = true;else listCommVM.noData = false;
	  }
	
	  function isActive(index) {
	    if (listCommVM.selectedCommittee == index) return "active";
	  }
	};
	
	exports.default = ListCommitterCtrl;
	
	ListCommitterCtrl.$inject = ['$rootScope', '$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', '$cookies'];

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.id_work_plan_state == 3\"> <a ui-sref=\"reviewPhaseVM.setupTeacherActivities({workPlanId: row.entity.id_code})\"> <i class=\"icon mdi-action-settings i-20\" style=padding-right:5px;opacity:1></i> </a> <a ui-sref=\"reviewPhaseVM.setupTeacherActivities({workPlanId: row.entity.id_code})\" style=opacity:.85;text-decoration:underline>Revisar </a> </div> <div ng-if=\"row.entity.id_work_plan_state != 3\"> <a ui-sref=\"reviewPhaseVM.workPlanView({id: row.entity.id_code})\"> <i class=\"icon mdi-action-search i-20\" style=padding-right:5px;opacity:1></i> </a> <a style=opacity:.85;text-decoration:underline ui-sref=\"reviewPhaseVM.workPlanView({id: row.entity.id_code})\">Revisar nuevamente</a> </div> </div>";

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var listParamsCtrl = function listParamsCtrl($scope, GeneralSettingsSrv, $interval, $state, $timeout) {
	  _classCallCheck(this, listParamsCtrl);
	
	  $scope.submodules = {};
	  $scope.currentSubmoduleData = {};
	  $scope.models = {};
	  $scope.enforce = true;
	  $scope.disableButton = false;
	  $scope.load = true;
	
	  GeneralSettingsSrv.getSubmodules.get().$promise.then(function (dataReturn) {
	    if (dataReturn.status == true) {
	      $scope.submodules = dataReturn.data;
	    } else {
	      console.log("Comunications problem with the server");
	    }
	  }).then(function () {
	    GeneralSettingsSrv.getListData.get({ idTypeList: $scope.submodules[0].id_code }).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        $scope.currentSubmoduleData = dataReturn.data;
	        $scope.load = false;
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    });
	  });
	
	  $scope.set_color = function (item, list) {
	    var colors = [{ background: "#0D47A1" }, { background: "#1565C0" }, { background: "#1976D2" }, { background: "#1E88E5" }, { background: "#2196F3" }, { background: "#42A5F5" }, { background: "#64B5F6" }, { background: "#90CAF9" }, { background: "#B3E5FC" }, { background: "#E1F5FE" }, { background: "#ECEFF1" }, { background: "#EEEEEE" }, { background: "#FAFAFA" }];
	    var idx = list.indexOf(item) % 12;
	    return colors[idx];
	  };
	
	  $scope.set_color_required = function (item) {
	    if (item.isRequired == 0) {
	      return { background: "#1E88E5" };
	    } else {
	      return { background: "#EF7955" };
	    }
	  };
	
	  $scope.set_indicator_style = function (isRequired) {
	    if (isRequired == true) {
	      return { borderRadius: "50%", width: "15px", height: "15px", background: "#EF7955" };
	    } else {
	      return { borderRadius: "50%", width: "15px", height: "15px", background: "#1E88E5" };
	    }
	  };
	
	  $scope.getData = function (list) {
	    $scope.load = true;
	    $scope.currentSubmoduleData = [];
	    GeneralSettingsSrv.getListData.get({ idTypeList: list.id_code }).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        $scope.currentSubmoduleData = dataReturn.data;
	        $scope.load = false;
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    });
	  };
	
	  $scope.updateView = function () {
	    $scope.viewLoaded = false;
	    $timeout(function () {
	      $scope.viewLoaded = true;
	    }, 1);
	  };
	
	  $scope.changeStatus = function (item, list, status) {
	    GeneralSettingsSrv.changeStatus.change({ listId: list.idList, itemId: item.idListItem, isActive: !status }).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        list.items[list.items.indexOf(item)].isActive = !status ? 1 : 0;
	        console.log(list.items[list.items.indexOf(item)].isActive);
	      } else {
	        console.log("Problems with server item isActive was not changed");
	      }
	    });
	  };
	
	  $scope.addItem = function (data, list, idx, flag) {
	    if (data == null || data.length == 0) {
	      return;
	    } else {
	      $scope.disableButton = true;
	      GeneralSettingsSrv.addListItem.add({ idList: list.idList, dsName: data, isRequired: flag }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          $scope.models[idx] = null;
	          list.items.push({
	            "idListItem": dataReturn.data[0].insertId,
	            "listItemName": data,
	            "isRequired": flag,
	            "nmOrder": list.items.length + 1,
	            "isActive": 1
	          });
	        } else {
	          console.log("Comunications problem with the server");
	        }
	        $scope.disableButton = false;
	      });
	    }
	  };
	
	  $scope.hasError = function (input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  };
	
	  $scope.showErrorMessages = function (input) {
	    return input.$dirty || input.$touched;
	  };
	};
	
	exports.default = listParamsCtrl;
	
	
	listParamsCtrl.$inject = ['$scope', 'GeneralSettingsSrv', '$interval', '$state', '$timeout'];

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListSubjectCtrl = function ListSubjectCtrl($scope, GeneralSettingsSrv, $mdDialog, $interval, $uiGridConstants, i18nService, $cookies, Validations) {
	  _classCallCheck(this, ListSubjectCtrl);
	
	  var subjectListVM = this;
	  i18nService.setCurrentLang('es');
	  var user = JSON.parse($cookies.get('currentUser'));
	  var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
	  subjectListVM.highlightFilteredHeader = highlightFilteredHeader;
	  subjectListVM.filter = filter;
	  subjectListVM.singleFilter = singleFilter;
	  subjectListVM.confirmDisableSubject = confirmDisableSubject;
	
	  function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
	    if (col.filters[0].term) {
	      return 'header-filtered';
	    } else {
	      return '';
	    }
	  };
	
	  subjectListVM.gridListSubjects = {
	    enableFiltering: true,
	    columnDefs: [_defineProperty({
	      name: 'Nombre asignatura',
	      displayName: 'Nombre asignatura',
	      field: 'subject_name',
	      width: '35%',
	      headerCellClass: subjectListVM.highlightFilteredHeader,
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs'
	    }, 'headerCellClass', 'font-normal text-xs'), {
	      name: 'Especialización',
	      displayName: 'Especialización',
	      field: 'specialization_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs',
	      headerCellClass: 'font-normal text-xs'
	    }, {
	      name: 'Estado',
	      displayName: 'Estado',
	      field: 'subject_status_name',
	      width: '20%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'text-xs',
	      headerCellClass: 'font-normal text-xs',
	      cellTemplate: __webpack_require__(286)
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      width: '20%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      cellClass: 'column-center text-xs',
	      headerCellClass: 'column-center font-normal text-xs',
	      cellTemplate: __webpack_require__(287)
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      subjectListVM.gridApi = gridApi;
	      subjectListVM.gridApi.grid.registerRowsProcessor(subjectListVM.singleFilter, 200);
	      $interval(function () {
	        subjectListVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	
	  function filter() {
	    subjectListVM.gridApi.grid.refresh();
	  };
	
	  function singleFilter(renderableRows) {
	    var matcher = new RegExp(subjectListVM.listSubjectsFilter, 'i');
	    renderableRows.forEach(function (row) {
	      var match = false;
	      ['subject_name', 'specialization_name', 'subject_status_name'].forEach(function (field) {
	        if (row.entity[field].match(matcher)) {
	          match = true;
	        }
	      });
	      if (!match) {
	        row.visible = false;
	      }
	    });
	    return renderableRows;
	  };
	
	  function confirmDisableSubject(row) {
	    var subject = row.entity;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.subject = subject;
	        $scope.subjectName = subject.subject_name;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	        $scope.disableSubject = function (id) {
	          GeneralSettingsSrv.disableSubject.disable({ subjectId: id }).$promise.then(function (dataReturn) {
	            if (dataReturn.status == true) {
	              row.entity.subject_status_name = "Inactivo";
	              subjectListVM.gridApi.grid.refresh();
	              $mdDialog.hide();
	            } else {}
	          }, function (data) {});
	        };
	      }],
	      template: __webpack_require__(288),
	      clickOutsideToClose: false
	    });
	  }
	
	  activate();
	
	  function activate() {
	    return getSubjectList();
	  }
	
	  function getSubjectList() {
	    var header = {};
	    if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
	      header.userId = user.id;
	      header.rolId = currentRoleId;
	    }
	    GeneralSettingsSrv.getSubjects.getList(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        subjectListVM.gridListSubjects.data = dataReturn.data;
	      } else {
	        subjectListVM.gridListSubjects.data = [];
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	};
	
	exports.default = ListSubjectCtrl;
	
	
	ListSubjectCtrl.$inject = ['$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$cookies', 'Validations'];

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-class=\"(row.entity.subject_status_name == 'Activo') ? 'text-verde' : ''\"> <p>{{row.entity.subject_status_name}}</p> </div> </div> ";

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.is_editable === 1\" style=text-align:left!important> <a class=\"text-xs m-r-md\" ui-sref=\"generalSettings.editSubject({subjectId: row.entity.subject_code})\"> <i class=\"icon mdi-editor-border-color i-16 dark-icon m-r-xs\"></i> Editar </a> <a ng-if=\"row.entity.subject_status === 1\" class=\"text-xs m-r-md\" ng-click=grid.appScope.subjectListVM.confirmDisableSubject(row)> <i class=\"icon mdi-action-delete i-16 dark-icon m-r-xs\"></i> Desactivar </a> </div> </div> ";

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Está a punto de desactivar la asignatura \"{{subjectName}}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=disableSubject(subject.subject_code)>Sí, desactivar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var createSubjectCtrl = function createSubjectCtrl($scope, GeneralSettingsSrv, $mdDialog, $stateParams) {
	  _classCallCheck(this, createSubjectCtrl);
	
	  $scope.specialization = {};
	  $scope.searchNameRut = 'name';
	  $scope.state = 'active';
	  $scope.editOrCreated = "";
	  $scope.textButton = "";
	  $scope.teachers = {};
	  $scope.periodArray = [];
	  $scope.selectedTeachers = [];
	  $scope.newSubject = {};
	  $scope.editNewSubject = {};
	  $scope.periodChecked = {};
	
	  var edit = $stateParams.subjectId ? true : false;
	
	  if (edit) {
	    $scope.textButton = "Guardar asignatura";
	    $scope.mainLabel = 'Editar asignatura';
	    $scope.editOrCreated = "modificado";
	  } else {
	    $scope.textButton = "Guardar nueva asignatura";
	    $scope.mainLabel = 'Ingreso de nuevas asignaturas';
	    $scope.editOrCreated = "creado";
	    console.log($scope.editOrCreated);
	  }
	
	  $scope.hasError = function (input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) return 'has-error';
	  };
	
	  $scope.showErrorMessages = function (input) {
	    return input.$dirty || input.$touched;
	  };
	
	  $scope.searchTeacher = function (teacher) {
	    var matcher = new RegExp(teacher, 'i');
	    var arr = [];
	
	    $scope.teachers.forEach(function (teacher) {
	      if (teacher["teacher_name"].match(matcher) || teacher["teacher_identification"].match(matcher)) {
	        arr.push(teacher);
	      }
	    });
	    return arr;
	  };
	
	  $scope.isTeacherEmpty = function () {
	    return $scope.selectedTeachers.length == 0;
	  };
	
	  $scope.isPeriodEmpty = function () {
	    return $scope.periodArray.length == 0;
	  };
	
	  $scope.selectedPeriod = function (listPeriod, checked) {
	
	    if (checked) {
	      if (!$scope.periodArray.includes(listPeriod.periodicity_id)) $scope.periodArray.push(listPeriod.periodicity_id);
	    } else {
	      var index = $scope.periodArray.indexOf(listPeriod.periodicity_id);
	      if (index != -1) $scope.periodArray.splice(index, 1);
	    }
	  };
	
	  function editNewSubject() {
	    console.log("$scope.editNewSubject.subjectCode");
	    console.log($scope.editNewSubject.subjectCode);
	    $scope.periodArray = [];
	    $scope.nameSubject = $scope.editNewSubject.subjectName;
	    $scope.codigoSubject = $scope.editNewSubject.subjectCode;
	    for (var index in $scope.specialization) {
	      if ($scope.specialization[index].specialization_id == $scope.editNewSubject.subjectSpecializationId) {
	        $scope.specializationModel = $scope.specialization[index];
	      }
	    }
	    $scope.hoursSubject = $scope.editNewSubject.subjectHours;
	    if ($scope.editNewSubject.isActive == 1) {
	      $scope.state = "active";
	    } else {
	      if ($scope.editNewSubject.isActive == 0) {
	        $scope.state = "inactive";
	      }
	    }
	    var arrayPeriod = $scope.editNewSubject.periodsId.split(",");
	    for (var indexarr = 0; indexarr < arrayPeriod.length; indexarr++) {
	      for (var index in $scope.period) {
	        if ($scope.period[index].periodicity_id == arrayPeriod[indexarr]) {
	          $scope.periodArray.push($scope.period[index].periodicity_id);
	        }
	      }
	    }
	    var periodSelected = {};
	    var aux = 0;
	    for (var index = 0; index < arrayPeriod.length; index++) {
	      aux = arrayPeriod[index];
	      periodSelected[aux] = true;
	    }
	    $scope.periodChecked = periodSelected;
	    var arrayTeacher = $scope.editNewSubject.teachersId.split(",");
	    for (var indexarr = 0; indexarr < arrayTeacher.length; indexarr++) {
	      for (var index in $scope.teachers) {
	        if ($scope.teachers[index].teacher_id == arrayTeacher[indexarr]) {
	          $scope.selectedTeachers.push($scope.teachers[index]);
	        }
	      }
	    }
	  }
	
	  $scope.addSubject = function () {
	    createJson();
	  };
	
	  function createJson() {
	    if ($scope.state == "active") {
	      $scope.state = 1;
	    } else {
	      if ($scope.state == "inactive") {
	        $scope.state = 0;
	      }
	    }
	    var assignment = {
	      subjectId: $stateParams.subjectId,
	      subjectName: $scope.nameSubject,
	      isActive: $scope.state,
	      subjectCode: $scope.codigoSubject,
	      subjectSpecializationId: $scope.specializationModel.specialization_id,
	      subjectHours: $scope.hoursSubject
	    };
	    var arrayTeacher = [];
	    for (var index in $scope.selectedTeachers) {
	      var temp = {
	        teacherId: $scope.selectedTeachers[index].teacher_id
	      };
	      arrayTeacher.push(temp);
	    }
	    var arrayPeriod = [];
	    for (var index in $scope.periodArray) {
	      var temp = {
	        periodId: $scope.periodArray[index]
	      };
	      arrayPeriod.push(temp);
	    }
	    assignment.teachers = arrayTeacher;
	    assignment.periods = arrayPeriod;
	    $scope.newSubject = assignment;
	    if (edit) {
	      callServiceEditNewSubject($scope.newSubject);
	    } else {
	      callServiceAddNewSubject($scope.newSubject);
	    }
	  }
	
	  function callServiceEditNewSubject(newSubject) {
	    GeneralSettingsSrv.updateSubject.update({ subject: newSubject }).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        showModalSubjectCreated();
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function callServiceAddNewSubject(newSubject) {
	    GeneralSettingsSrv.addNewSubject.save({ subject: newSubject }).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        showModalSubjectCreated();
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function showModalSubjectCreated() {
	    var subjectName = $scope.nameSubject;
	    var actionName = $scope.editOrCreated;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function showModalSubjectCreated($scope, $mdDialog) {
	        $scope.nameSubjectModal = subjectName;
	        $scope.actionName = actionName;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(290),
	      clickOutsideToClose: false
	    });
	  }
	
	  $scope.addTeacher = function (teacher) {
	    if (teacher) {
	      var idx = $scope.selectedTeachers.indexOf(teacher);
	      if (idx === -1) {
	        $scope.selectedTeachers.push(teacher);
	        $scope.searchText = null;
	      }
	    }
	  };
	
	  $scope.removeTeacher = function (teacher) {
	    var idx = $scope.selectedTeachers.indexOf(teacher);
	    $scope.selectedTeachers.splice(idx, 1);
	  };
	
	  $scope.validateForm = function (form) {
	    return form.$invalid;
	  };
	
	  // List new subjects
	  GeneralSettingsSrv.getInfoCreateNewSubject.getList().$promise.then(function (dataReturn) {
	    if (dataReturn.status == true) {
	      $scope.specialization = dataReturn.data.specialization;
	      $scope.teachers = dataReturn.data.teachers;
	      $scope.period = dataReturn.data.periodicities;
	    } else {
	      $scope.specialization = [];
	      $scope.teachers = [];
	      $scope.period = [];
	    }
	  }, function (data) {
	    console.log(data);
	  }).then(function () {
	
	    if ($stateParams.subjectId) {
	      GeneralSettingsSrv.getSubject.get({ subjectId: $stateParams.subjectId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          console.log("dataReturn");
	          console.log(dataReturn);
	          $scope.editNewSubject = dataReturn.data[0];
	          editNewSubject();
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	  });
	};
	
	exports.default = createSubjectCtrl;
	
	
	createSubjectCtrl.$inject = ['$scope', 'GeneralSettingsSrv', '$mdDialog', '$stateParams'];

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Éxito!</h3> <p>La asignatura \"{{nameSubjectModal}}\" se ha {{actionName}} con éxito</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close() ui-sref=generalSettings.listSubject>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = run;
	run.$inject = ['MenuConstant', 'comite'];
	
	function run(MenuConstant, comite) {
		MenuConstant[0]['menu'].push(comite);
	}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chatboxController = __webpack_require__(293);
	
	var _chatboxController2 = _interopRequireDefault(_chatboxController);
	
	var _commentsController = __webpack_require__(295);
	
	var _commentsController2 = _interopRequireDefault(_commentsController);
	
	var _chatboxServices = __webpack_require__(296);
	
	var _chatboxServices2 = _interopRequireDefault(_chatboxServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.chatbox', [_chatboxServices2.default]).controller('ChatboxController', _chatboxController2.default).controller('CommentsController', _commentsController2.default).name;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP ClassPanel
	* @autor pedro.rivera@dbaccess.com
	* @description
	* # name controller --> chatboxController
	* # As Controller --> chatbox
	* brief comment controller view assistance page app classPanel
	*/
	
	var chatboxController = function () {
	  function chatboxController($scope, $interval, $timeout, $cookieStore, $cookies, $location, $filter, $rootScope, chatboxServices, Messages, GlobalConfig) {
	    var _this = this;
	
	    _classCallCheck(this, chatboxController);
	
	    // Variables declaradas
	    $rootScope.chatNotifications = 0;
	    this.$rootScope = $rootScope;
	    this.$cookies = $cookies;
	    this.Messages = Messages;
	    this.chatboxServices = chatboxServices;
	    this.GlobalConfig = GlobalConfig;
	    this.closeContact = true;
	    this.minimizeContact = true;
	    this.id = 0;
	    this.showMessageBoxes = true;
	    this.showMessageWindow = true;
	    this.messageWindow = {};
	    this.conversations = [];
	    this.messageReceive = {};
	    this.messageHistory = [];
	    this.messageHistoryReceive = [];
	    this.btnSend = { 'keyCode': 13 };
	    this.dataMessage = {};
	    this.notifications = {};
	    this.defaultProfileImage = __webpack_require__(294);
	
	    this.getCurrentTime = $interval(function () {
	      _this.currentTime = new Date();
	    }, 1);
	
	    this.getCurrentUser = $interval(function () {
	      var cookieUser = $cookies.get('currentUser');
	      if (cookieUser) {
	        _this.userLogin = JSON.parse(cookieUser);
	        Messages.user({ id: _this.userLogin.id, name: _this.userLogin.name });
	        _this.idRol = $cookies.getObject('hasRoleId');
	        $timeout(function () {
	          _this.activate();
	        }, 15000);
	        $interval.cancel(_this.getCurrentUser);
	      }
	    }, 1000);
	
	    this.getShowChat = $interval(function () {
	      _this.openChatBox = $rootScope.showChat;
	      _this.closeContact = $rootScope.openContacts;
	    }, 500);
	  } // Fin del constructor
	
	  _createClass(chatboxController, [{
	    key: 'activate',
	    value: function activate() {
	      this.getChatUser();
	    }
	  }, {
	    key: 'receiveData',
	    value: function receiveData() {
	      var _this2 = this;
	
	      this.Messages.receive(function (message, isPrivate) {
	        var i = _this2.chatContacts.findIndex(function (chat) {
	          return chat.contactUserId == message.user.id;
	        });
	
	        if (!_this2.messageWindow[message.user.id]) {
	          _this2.messageWindow[message.user.id] = {
	            idUser: message.user.id, // Consulta completa de contactos
	            userFullName: _this2.chatContacts[i].userFullName,
	            onLine: _this2.chatContacts[i].onLine, // Debe estar integrado con la consulta del contacto
	            information: [],
	            showMessageWindow: false,
	            delete: false,
	            deleteSuccess: false,
	            new: 1
	          };
	
	          _this2.id = message.user.id;
	          _this2.messageHistoryReceive = _this2.messageHistory.filter(menssages);
	
	          if (_this2.messageHistoryReceive.length != 0) {
	            _this2.messageHistoryReceive = _this2.messageHistoryReceive.map(function (objeto) {
	              objeto.from = objeto.senderId != message.user.id ? _this2.chatContacts[i].userPicture : _this2.chatUser[0].userPicture;
	              objeto.classChat = objeto.senderId == message.user.id ? 'friend' : 'self';
	              objeto.send = 1;
	              return objeto;
	            });
	            _this2.messageWindow[message.user.id].information = _this2.messageHistoryReceive;
	          }
	
	          _this2.messageReceive = {
	            'from': _this2.chatContacts[i].userPicture,
	            'classChat': 'friend',
	            'dateTime': _this2.currentTime,
	            'dateDay': _this2.checktime(_this2.currentTime),
	            'data': message.data,
	            'send': 1
	          };
	
	          _this2.messageWindow[message.user.id].information.push(_this2.messageReceive);
	
	          _this2.conversations.unshift(_this2.messageWindow[message.user.id]);
	          _this2.countNotifications();
	          return;
	        }
	
	        _this2.messageReceive = {
	          'from': _this2.chatContacts[i].userPicture,
	          'classChat': 'friend',
	          'dateTime': _this2.currentTime,
	          'dateDay': _this2.checktime(_this2.currentTime),
	          'data': message.data,
	          'send': 1
	        };
	
	        _this2.messageWindow[message.user.id].new = _this2.messageWindow[message.user.id].showMessageWindow ? 0 : 1;
	        _this2.messageWindow[message.user.id].information.push(_this2.messageReceive);
	
	        _this2.$rootScope.showChat = true;
	        _this2.$rootScope.openContacts = true;
	
	        var indx = _this2.conversations.findIndex(function (chat) {
	          return chat.idUser == message.user.id;
	        });
	
	        if (indx >= 3) {
	          _this2.conversations.splice(indx, 1);
	          _this2.conversations.unshift(_this2.messageWindow[message.user.id]);
	        }
	
	        if (indx == -1) {
	          _this2.conversations.unshift(_this2.messageWindow[message.user.id]);
	        }
	
	        _this2.countNotifications();
	      });
	    }
	  }, {
	    key: 'getChatUser',
	    value: function getChatUser() {
	      var _this3 = this;
	
	      return this.chatboxServices.getChatUserById.get({ userId: this.Messages.user().id }).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          if (dataResult.data.length == 0) {
	            console.log("El usuario logueado no posee un rol para utilizar el chat");
	            $interval.cancel(_this3.getCurrentTime);
	            $interval.cancel(_this3.getShowChat);
	            $interval.cancel(_this3.getCurrentUser);
	            return;
	          }
	          _this3.chatUser = dataResult.data;
	          _this3.chatUser[0].onLine = 1;
	          _this3.updateStatus(true);
	          _this3.getChatContacts();
	        } else {
	          _this3.chatUser = [];
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'getChatContacts',
	    value: function getChatContacts() {
	      var _this4 = this;
	
	      if (this.idRol == 3 || this.idRol == 8 || this.idRol == 9) {
	        var rol = "EVALUATOR";
	      } else if (this.idRol == 13) {
	        var rol = "TEACHER";
	      } else {
	        return;
	      }
	
	      var params = {
	        userId: this.Messages.user().id,
	        rolName: rol
	      };
	
	      return this.chatboxServices.getChatContacts.get(params).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          _this4.chatContacts = dataResult.data.chatContacts.map(function (chatContact) {
	            chatContact.status = chatContact.onLine == 1 ? 'Conectado' : 'Desconectado';
	            if (chatContact.userIdentification) {
	              chatContact.userPicture = _this4.getFullpathUserImage(chatContact.userIdentification);
	            }
	            return chatContact;
	          });
	          _this4.messageHistory = dataResult.data.messageHistory;
	          _this4.receiveData();
	        } else {
	          _this4.chatContacts = [];
	          _this4.messageHistory = [];
	        }
	        if (dataResult.data.workplan != undefined && dataResult.data.workplan.length > 0) {
	          _this4.wp = dataResult.data.workplan[0];
	          _this4.$cookies.put('wp_start', _this4.wp.dt_startdate);
	          _this4.$cookies.put('wp_end', _this4.wp.dt_enddate);
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'sendMessage',
	    value: function sendMessage(event, to, text) {
	      var _this5 = this;
	
	      if (!text) return;
	      if (event.keyCode != 13) return;
	      var message = {
	        from: this.chatUser[0].userPicture,
	        to: to,
	        data: text,
	        user: this.Messages.user(),
	        senderId: this.Messages.user().id,
	        receiverId: to,
	        classChat: 'self',
	        dateTime: this.currentTime,
	        dateDay: this.checktime(this.currentTime),
	        send: 0
	      };
	      this.messageWindow[to].information.push(message);
	      this.messageWindow[to].newComment = '';
	      this.messageWindow[to].new = 0;
	
	      var post = {
	        chatMessage: text,
	        receiverUser: to,
	        senderUser: this.Messages.user().id
	      };
	
	      return this.chatboxServices.addUserMessage.post(post).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          message.send = 1;
	          message.messageId = dataResult.data.messageId;
	          _this5.Messages.send(message);
	        } else {
	          console.log("Error de servidor PubNub");
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'deleteAlertMessage',
	    value: function deleteAlertMessage(messageId, idUser) {
	      this.idUserDel = idUser;
	      this.dataMessage = {
	        messageId: messageId,
	        userId: this.Messages.user().id
	      };
	      this.messageWindow[idUser].delete = true;
	    }
	  }, {
	    key: 'deleteMessage',
	    value: function deleteMessage(bool) {
	      var _this6 = this;
	
	      this.messageWindow[this.idUserDel].delete = false;
	
	      if (!bool) return;
	
	      var indx = this.messageWindow[this.idUserDel].information.findIndex(function (message) {
	        return message.messageId === _this6.dataMessage.messageId;
	      });
	
	      return this.chatboxServices.updateMessage.post(this.dataMessage).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          _this6.messageWindow[_this6.idUserDel].information.splice(indx, 1);
	          _this6.succesDeleteMessage();
	        } else {
	          console.log("Error al eliminar el mensaje");
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'succesDeleteMessage',
	    value: function succesDeleteMessage() {
	      var _this7 = this;
	
	      this.messageWindow[this.idUserDel].deleteSuccess = true;
	      $timeout(function () {
	        _this7.messageWindow[_this7.idUserDel].deleteSuccess = false;
	      }, 800);
	    }
	  }, {
	    key: 'closeContacts',
	    value: function closeContacts() {
	      this.$rootScope.openContacts = false;
	    }
	  }, {
	    key: 'menssages',
	    value: function menssages(objeto) {
	      return objeto.senderId == this.id || objeto.receiverId == this.id;
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus(value) {
	      var _this8 = this;
	
	      var post = {
	        userId: this.Messages.user().id,
	        onLine: value ? 1 : 0
	      };
	      return this.chatboxServices.updateChatStatus.post(post).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          _this8.chatUser[0].onLine = post.onLine;
	        } else {
	          console.log("Error al actualizar el estado del usuario");
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'checktimeHistory',
	    value: function checktimeHistory(diffTime, time) {
	      var dia = "";
	      switch (diffTime) {
	        case 0:
	          dia = "HOY";
	          break;
	        case 1:
	          dia = "AYER";
	          break;
	        default:
	          dia = time.split(' ')[0];
	      }
	      return dia;
	    }
	  }, {
	    key: 'checktime',
	    value: function checktime(time) {
	      this.currentTime = moment(this.currentTime).format('YYYY-MM-DD');
	      time = moment(time).format('YYYY-MM-DD');
	      var dia = "";
	      var init = moment(this.currentTime);
	      var end = moment(time);
	      var diff = init.diff(end, 'days');
	
	      switch (diff) {
	        case 0:
	          dia = "HOY";
	          break;
	        case 1:
	          dia = "AYER";
	          break;
	        default:
	          dia = moment(time).format('DD/MM/YYYY');
	      }
	      return dia;
	    }
	  }, {
	    key: 'filterchat',
	    value: function filterchat(data) {
	      return data.new == 1;
	    }
	  }, {
	    key: 'countNotifications',
	    value: function countNotifications() {
	      this.notifications = this.conversations.filter(filterchat);
	      this.$rootScope.chatNotifications = this.notifications.length;
	    }
	  }, {
	    key: 'getFullpathUserImage',
	    value: function getFullpathUserImage(identification) {
	      return this.GlobalConfig.azureProfilePicturePath + identification + '.jpg';
	    }
	  }, {
	    key: 'showMessageWindowChat',
	    value: function showMessageWindowChat(data) {
	      this.messageWindow[data.idUser].showMessageWindow = false;
	      this.messageWindow[data.idUser].delete = false;
	    }
	  }, {
	    key: 'minimizeContacs',
	    value: function minimizeContacs(bool) {
	      this.minimizeContact = bool;
	    }
	  }, {
	    key: 'newChat',
	    value: function newChat(data) {
	      var _this9 = this;
	
	      if (!this.messageWindow[data.contactUserId]) {
	        this.messageWindow[data.contactUserId] = {
	          idUser: data.contactUserId, // Consulta completa de contactos
	          userFullName: data.userFullName,
	          onLine: data.onLine,
	          information: [],
	          showMessageWindow: true,
	          delete: false,
	          deleteSuccess: false,
	          new: 0
	        };
	
	        this.id = data.contactUserId;
	        this.messageHistoryCreate = this.messageHistory.filter(this.menssages);
	
	        if (this.messageHistoryCreate.length != 0) {
	          this.messageHistoryCreate = this.messageHistoryCreate.map(function (objeto) {
	            objeto.from = objeto.senderId != data.contactUserId ? data.userPicture : _this9.chatUser[0].userPicture;
	            objeto.classChat = objeto.senderId == data.contactUserId ? 'friend' : 'self';
	            objeto.dateDay = _this9.checktimeHistory(objeto.dateDay, objeto.dateTime);
	            objeto.send = 1;
	            return objeto;
	          });
	          this.messageWindow[data.contactUserId].information = this.messageHistoryCreate;
	        }
	        this.conversations.unshift(this.messageWindow[data.contactUserId]);
	      } else {
	        var i = this.conversations.findIndex(function (chat) {
	          return chat.idUser === data.contactUserId;
	        });
	
	        if (i >= 3) {
	          this.conversations.splice(i, 1);
	          this.conversations.unshift(this.messageWindow[data.contactUserId]);
	        }
	
	        if (i == -1) {
	          this.conversations.unshift(this.messageWindow[data.contactUserId]);
	        }
	
	        this.messageWindow[data.contactUserId].showMessageWindow = true;
	      }
	    }
	  }, {
	    key: 'minimizeChats',
	    value: function minimizeChats(bool) {
	      this.showMessageWindow = bool;
	    }
	  }, {
	    key: 'closedChat',
	    value: function closedChat(data) {
	      var i = this.conversations.findIndex(function (chat) {
	        return chat.idUser === data.idUser;
	      });
	      this.conversations.splice(i, 1);
	    }
	  }, {
	    key: 'openedChat',
	    value: function openedChat(data) {
	      var i = this.conversations.findIndex(function (chat) {
	        return chat.idUser === data.idUser;
	      });
	
	      this.conversations.splice(i, 1);
	      this.conversations.unshift(this.messageWindow[data.idUser]);
	    }
	  }, {
	    key: 'showChatsBoxes',
	    value: function showChatsBoxes(bool) {}
	  }, {
	    key: 'showMessage',
	    value: function showMessage(data) {
	      data.showMessageWindow = true;
	      data.new = 0;
	      this.countNotifications();
	    }
	  }]);
	
	  return chatboxController;
	}();
	
	exports.default = chatboxController;
	
	
	chatboxController.$inject = ['$scope', '$interval', '$timeout', '$cookieStore', '$cookies', '$location', '$filter', '$rootScope', 'chatboxServices', 'Messages', 'GlobalConfig'];

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c1e2f5ff9245c1893edb13cb4748b1b4.png";

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommentsController = function () {
	  function CommentsController($scope, $interval, $cookies, chatboxServices, Messages) {
	    _classCallCheck(this, CommentsController);
	
	    var vm = this;
	
	    // Variables declaradas
	    vm.minimizeContact = true;
	    vm.id = 0;
	    vm.showMessageBoxes = true;
	    vm.messages = [];
	    vm.showMessageWindow = true;
	    vm.messageWindow = {};
	    vm.conversations = [];
	    vm.messageReceive = {};
	    vm.chatsWindows = [];
	    vm.messageHistoryReceive = [];
	    vm.btnSend = { 'keyCode': 13 };
	    vm.messageBoxes = true;
	
	    $interval(function () {
	      vm.currentTime = new Date();
	    }, 1);
	
	    var getCurrentUser = $interval(function () {
	      var cookieUser = $cookies.getObject('currentUser');
	      if (cookieUser) {
	        vm.userLogin = cookieUser;
	        Messages.user({ id: 'comments_' + vm.userLogin.id, name: vm.userLogin.name });
	        vm.idRol = $cookies.getObject('hasRoleId');
	        activate();
	        $interval.cancel(getCurrentUser);
	      }
	    }, 1000);
	
	    // Funciones
	    vm.sendMessage = sendMessage;
	    vm.menssages = menssages;
	    vm.checktime = checktime;
	    vm.closeContacts = closeContacts;
	
	    Messages.receive(function (message, isPrivate) {
	      var i = vm.chatContacts.findIndex(function (chat) {
	        return chat.contactUserId === message.user.id;
	      });
	
	      if (!vm.messageWindow[message.user.id]) {
	        vm.messageWindow[message.user.id] = {
	          idUser: message.user.id, // Consulta completa de contactos
	          userName: vm.chatContacts[i].userName,
	          onLine: vm.chatContacts[i].onLine, // Debe estar integrado con la consulta del contacto
	          information: [],
	          showMessageWindow: false,
	          delete: false,
	          new: 1
	        };
	
	        vm.id = message.user.id;
	        vm.messageHistoryReceive = vm.messageHistory.filter(menssages);
	
	        if (vm.messageHistoryReceive.length !== 0) {
	          vm.messageHistoryReceive = vm.messageHistoryReceive.map(function (objeto) {
	            objeto.from = objeto.senderId !== message.user.id ? vm.chatContacts[i].userPicture : vm.chatUser[0].userPicture;
	            objeto.classChat = objeto.senderId !== message.user.id ? 'friend' : 'self';
	            objeto.send = 1;
	            return objeto;
	          });
	
	          vm.messageWindow[message.user.id].information = vm.messageHistoryReceive;
	        }
	
	        vm.messageReceive = {
	          'from': vm.chatContacts[i].userPicture,
	          'classChat': 'friend',
	          'dateTime': vm.currentTime,
	          'dateDay': checktime(vm.currentTime),
	          'data': message.data,
	          'send': 1
	        };
	
	        vm.messageWindow[message.user.id].information.push(vm.messageReceive);
	
	        vm.conversations.unshift(vm.messageWindow[message.user.id]);
	        return;
	      }
	
	      vm.messageReceive = {
	        'from': vm.chatContacts[i].userPicture,
	        'classChat': 'friend',
	        'dateTime': vm.currentTime,
	        'dateDay': checktime(vm.currentTime),
	        'data': message.data,
	        'send': 1
	      };
	
	      vm.messageWindow[message.user.id].new = vm.messageWindow[message.user.id].showMessageWindow ? 0 : 1;
	      vm.messageWindow[message.user.id].information.push(vm.messageReceive);
	
	      var indx = vm.conversations.findIndex(function (chat) {
	        return chat.idUser === message.user.id;
	      });
	
	      if (indx >= 3) {
	        vm.conversations.splice(indx, 1);
	        vm.conversations.unshift(vm.messageWindow[message.user.id]);
	      }
	
	      if (indx === -1) {
	        vm.conversations.unshift(vm.messageWindow[message.user.id]);
	      }
	    });
	
	    function activate() {
	      getChatUser();
	      getChatContacts();
	    }
	
	    function getChatUser() {
	      return chatboxServices.getChatUserById.get({ userId: vm.userLogin.id }).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          vm.chatUser = dataResult.data;
	          vm.chatUser[0].onLine = 1;
	        } else {
	          vm.chatUser = [];
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	
	    function getChatContacts() {
	      var rol = void 0;
	      if (vm.idRol === 3 || vm.idRol === 8 || vm.idRol === 9) {
	        rol = 'EVALUATOR';
	      } else if (vm.idRol === 13) {
	        rol = 'TEACHER';
	      } else {
	        return;
	      }
	
	      var params = {
	        userId: vm.userLogin.id,
	        rolName: rol
	      };
	      return chatboxServices.getChatContacts.get(params).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          vm.chatContacts = dataResult.data.chatContacts.map(function (chatContact) {
	            chatContact.status = chatContact.onLine === 1 ? 'Conectado' : 'Desconectado';
	            return chatContact;
	          });
	          vm.messageHistory = dataResult.data.messageHistory;
	        } else {
	          vm.chatContacts = [];
	          vm.messageHistory = [];
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	
	    function sendMessage(event, to, text) {
	      if (!text) return;
	      if (event.keyCode !== 13) return;
	      var message = {
	        from: vm.chatUser[0].userPicture,
	        to: to,
	        data: text,
	        user: Messages.user(),
	        classChat: 'self',
	        dateTime: vm.currentTime,
	        dateDay: checktime(vm.currentTime),
	        send: 0
	      };
	      vm.messageWindow[to].information.push(message);
	      vm.messageWindow[to].newComment = '';
	      vm.messageWindow[to].new = 0;
	
	      var post = {
	        chatMessage: text,
	        senderUser: to,
	        receiverUser: vm.userLogin.id
	      };
	
	      return chatboxServices.addUserMessage.post(post).$promise.then(function (dataResult) {
	        if (dataResult.status === true) {
	          message.send = 1;
	          Messages.send(message);
	        } else {
	          vm.chatContacts = [];
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	
	    function closeContacts(bool) {
	      vm.closeContact = bool;
	    }
	
	    function menssages(objeto) {
	      return objeto.senderId === vm.id || objeto.receiverId === vm.id;
	    }
	
	    function checktime(time) {
	      vm.currentTime = moment(vm.currentTime).format('YYYY-MM-DD');
	      time = moment(time).format('YYYY-MM-DD');
	      var dia = '';
	      var init = moment(vm.currentTime);
	      var end = moment(time);
	      var diff = init.diff(end, 'days');
	
	      switch (diff) {
	        case 0:
	          dia = 'HOY';
	          break;
	        case 1:
	          dia = 'AYER';
	          break;
	        default:
	          dia = moment(time).format('DD-MM-YYYY');
	      }
	      return dia;
	    }
	  } // Fin del constructor
	
	  _createClass(CommentsController, [{
	    key: 'minimizeContacs',
	    value: function minimizeContacs(bool) {
	      console.log('holaaaaaa');
	      this.minimizeContact = bool;
	    }
	  }, {
	    key: 'newChat',
	    value: function newChat(data) {
	      var _this = this;
	
	      if (!this.messageWindow[data.contactUserId]) {
	        this.messageWindow[data.contactUserId] = {
	          idUser: data.contactUserId, // Consulta completa de contactos
	          userName: data.userName,
	          onLine: data.onLine,
	          information: [],
	          showMessageWindow: true,
	          delete: false,
	          new: 0
	        };
	
	        this.id = data.contactUserId;
	        this.messageHistoryCreate = this.messageHistory.filter(this.menssages);
	
	        if (this.messageHistoryCreate.length !== 0) {
	          this.messageHistoryCreate = this.messageHistoryCreate.map(function (objeto) {
	            objeto.from = objeto.senderId !== data.contactUserId ? data.userPicture : _this.chatUser[0].userPicture;
	            objeto.classChat = objeto.senderId !== data.contactUserId ? 'friend' : 'self';
	            objeto.dateDay = _this.checktime(objeto.dateTime);
	            objeto.send = 1;
	            return objeto;
	          });
	          this.messageWindow[data.contactUserId].information = this.messageHistoryCreate;
	        }
	        this.conversations.unshift(this.messageWindow[data.contactUserId]);
	      } else {
	        var i = this.conversations.findIndex(function (chat) {
	          return chat.idUser === data.contactUserId;
	        });
	
	        if (i >= 3) {
	          this.conversations.splice(i, 1);
	          this.conversations.unshift(this.messageWindow[data.contactUserId]);
	        }
	
	        if (i === -1) {
	          this.conversations.unshift(this.messageWindow[data.contactUserId]);
	        }
	
	        this.messageWindow[data.contactUserId].showMessageWindow = true;
	      }
	    }
	  }, {
	    key: 'minimizeChats',
	    value: function minimizeChats(bool) {
	      this.showMessageWindow = bool;
	    }
	  }, {
	    key: 'closedChat',
	    value: function closedChat(data) {
	      var i = this.conversations.findIndex(function (chat) {
	        return chat.idUser === data.idUser;
	      });
	      this.conversations.splice(i, 1);
	    }
	  }, {
	    key: 'openedChat',
	    value: function openedChat(data) {
	      var i = this.conversations.findIndex(function (chat) {
	        return chat.idUser === data.idUser;
	      });
	
	      this.conversations.splice(i, 1);
	      this.conversations.unshift(this.messageWindow[data.idUser]);
	    }
	  }, {
	    key: 'showChatsBoxes',
	    value: function showChatsBoxes(bool) {}
	  }, {
	    key: 'showMessage',
	    value: function showMessage(data) {
	      data.showMessageWindow = true;
	      data.new = 0;
	    }
	  }]);
	
	  return CommentsController;
	}();
	
	exports.default = CommentsController;
	
	
	CommentsController.$inject = ['$scope', '$interval', '$cookies', 'chatboxServices', 'Messages'];

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP Sigepur
	* @autor pedro.rivera@dbaccess.com
	* @description
	* # name Services --> chatboxServices
	* file for call at services for assistance page
	*/
	var chatboxServices = function chatboxServices($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, chatboxServices);
	
	  var getChatUserById = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getChatUserById', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getChatContacts = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getChatContacts', {}, {
	    get: {
	      method: 'GET'
	    },
	    timeout: 10000
	  });
	
	  var getMessageHistory = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getMessageHistory', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getMessageById = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getMessageById', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var addUserMessage = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/addUserMessage', {}, {
	    post: {
	      method: 'POST'
	    }
	  });
	
	  var updateMessage = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/updateMessage', {}, {
	    post: {
	      method: 'POST'
	    }
	  });
	
	  var updateChatStatus = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/updateChatStatus', {}, {
	    post: {
	      method: 'POST'
	    }, timeout: 10000
	  });
	  return {
	    getChatUserById: getChatUserById,
	    getChatContacts: getChatContacts,
	    getMessageHistory: getMessageHistory,
	    getMessageById: getMessageById,
	    addUserMessage: addUserMessage,
	    updateMessage: updateMessage,
	    updateChatStatus: updateChatStatus
	  };
	};
	
	chatboxServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	exports.default = angular.module('services.chatboxServices', []).service('chatboxServices', chatboxServices).name;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _portfolio = __webpack_require__(298);
	
	var _portfolio2 = _interopRequireDefault(_portfolio);
	
	var _portfolio3 = __webpack_require__(308);
	
	var _portfolio4 = _interopRequireDefault(_portfolio3);
	
	var _portfolioSrv = __webpack_require__(309);
	
	var _portfolioSrv2 = _interopRequireDefault(_portfolioSrv);
	
	var _portfolioModalSrv = __webpack_require__(310);
	
	var _portfolioModalSrv2 = _interopRequireDefault(_portfolioModalSrv);
	
	var _globalSrv = __webpack_require__(324);
	
	var _globalSrv2 = _interopRequireDefault(_globalSrv);
	
	var _myPortfolioCtrl = __webpack_require__(325);
	
	var _myPortfolioCtrl2 = _interopRequireDefault(_myPortfolioCtrl);
	
	var _sharedPortfolioCtrl = __webpack_require__(326);
	
	var _sharedPortfolioCtrl2 = _interopRequireDefault(_sharedPortfolioCtrl);
	
	var _otherPortfolioCtrl = __webpack_require__(327);
	
	var _otherPortfolioCtrl2 = _interopRequireDefault(_otherPortfolioCtrl);
	
	var _powerbiPortfolioCtrl = __webpack_require__(328);
	
	var _powerbiPortfolioCtrl2 = _interopRequireDefault(_powerbiPortfolioCtrl);
	
	var _evaluationPortfolioCtrl = __webpack_require__(329);
	
	var _evaluationPortfolioCtrl2 = _interopRequireDefault(_evaluationPortfolioCtrl);
	
	var _portfolioParametrizationCtrl = __webpack_require__(330);
	
	var _portfolioParametrizationCtrl2 = _interopRequireDefault(_portfolioParametrizationCtrl);
	
	var _addUserCommentCtrl = __webpack_require__(331);
	
	var _addUserCommentCtrl2 = _interopRequireDefault(_addUserCommentCtrl);
	
	var _addReflectionCommentCtrl = __webpack_require__(332);
	
	var _addReflectionCommentCtrl2 = _interopRequireDefault(_addReflectionCommentCtrl);
	
	var _addNewRegistryCtrl = __webpack_require__(333);
	
	var _addNewRegistryCtrl2 = _interopRequireDefault(_addNewRegistryCtrl);
	
	var _evidenceLinksCtrl = __webpack_require__(334);
	
	var _evidenceLinksCtrl2 = _interopRequireDefault(_evidenceLinksCtrl);
	
	var _disableEvidenceCtrl = __webpack_require__(335);
	
	var _disableEvidenceCtrl2 = _interopRequireDefault(_disableEvidenceCtrl);
	
	var _editEvidenceCtrl = __webpack_require__(336);
	
	var _editEvidenceCtrl2 = _interopRequireDefault(_editEvidenceCtrl);
	
	var _editStatementCtrl = __webpack_require__(337);
	
	var _editStatementCtrl2 = _interopRequireDefault(_editStatementCtrl);
	
	var _historyStatementCtrl = __webpack_require__(338);
	
	var _historyStatementCtrl2 = _interopRequireDefault(_historyStatementCtrl);
	
	var _commentDetailsCtrl = __webpack_require__(339);
	
	var _commentDetailsCtrl2 = _interopRequireDefault(_commentDetailsCtrl);
	
	var _editReflectionCtrl = __webpack_require__(340);
	
	var _editReflectionCtrl2 = _interopRequireDefault(_editReflectionCtrl);
	
	var _deleteReflectionCtrl = __webpack_require__(341);
	
	var _deleteReflectionCtrl2 = _interopRequireDefault(_deleteReflectionCtrl);
	
	var _confirmDialogCtrl = __webpack_require__(342);
	
	var _confirmDialogCtrl2 = _interopRequireDefault(_confirmDialogCtrl);
	
	var _guidelineDetailsCtrl = __webpack_require__(343);
	
	var _guidelineDetailsCtrl2 = _interopRequireDefault(_guidelineDetailsCtrl);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//modals controllers
	
	
	// controllers
	
	
	// runs
	exports.default = angular.module('app.portfolio', [_portfolioSrv2.default, _portfolioModalSrv2.default, _globalSrv2.default]).config(_portfolio2.default).run(_portfolio4.default).controller('MyPortfolioCtrl', _myPortfolioCtrl2.default).controller('SharedPortfolioCtrl', _sharedPortfolioCtrl2.default).controller('OtherPortfolioCtrl', _otherPortfolioCtrl2.default).controller('powerbiPortfolioCtrl', _powerbiPortfolioCtrl2.default).controller('PortfolioParametrizationCtrl', _portfolioParametrizationCtrl2.default)
	
	//modals portfolio
	.controller('AddUserCommentCtrl', _addUserCommentCtrl2.default).controller('AddReflectionCommentCtrl', _addReflectionCommentCtrl2.default).controller('AddNewRegistryCtrl', _addNewRegistryCtrl2.default).controller('EvidenceLinksCtrl', _evidenceLinksCtrl2.default).controller('DisableEvidenceCtrl', _disableEvidenceCtrl2.default).controller('EditEvidenceCtrl', _editEvidenceCtrl2.default).controller('EditStatementCtrl', _editStatementCtrl2.default).controller('HistoryStatementCtrl', _historyStatementCtrl2.default).controller('EvaluationPortfolioCtrl', _evaluationPortfolioCtrl2.default).controller('CommentDetailsCtrl', _commentDetailsCtrl2.default).controller('EditReflectionCtrl', _editReflectionCtrl2.default).controller('DeleteReflectionCtrl', _deleteReflectionCtrl2.default).controller('ConfirmDialogCtrl', _confirmDialogCtrl2.default).controller('GuidelineDetailsCtrl', _guidelineDetailsCtrl2.default)
	
	//nav bar
	.constant('portfolio', [{
		title: 'Portafolio',
		icon: 'mdi-file-folder-shared',
		moduleId: _globalConfig2.default.menuModulesId.Portfolio,
		subMenu: [{
			title: 'Mi portafolio',
			url: 'portfolio.myPortfolio',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.generalConsultant]
		}, {
			title: 'Otros portafolios',
			url: 'portfolio.otherPortfolio',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.generalConsultant]
		}, {
			title: 'Reporte portafolio de Profesores',
			url: 'portfolio.powerbi',
			rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin]
		}, {
			title: 'Compartir mi portafolio',
			url: 'portfolio.sharedPortfolio',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
		}, {
			title: 'Evaluar portafolios',
			url: 'portfolio.listEvaluationPortfolio',
			rolesAllowed: [_globalConfig2.default.userRolesIds.comitePortfolio, _globalConfig2.default.userRolesIds.committee]
		}, {
			title: 'Parametrización',
			url: 'portfolio.parametrization',
			rolesAllowed: [_globalConfig2.default.userRolesIds.adminPortfolio, _globalConfig2.default.userRolesIds.adminPortfolio]
		}]
	}]).name;
	
	// config file
	
	
	// services
	// routers

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	
	  $stateProvider.state('portfolio', {
	    abstract: false,
	    url: '/app/portfolio',
	    views: {
	      '': {
	        template: __webpack_require__(168)
	      },
	      'content': {
	        template: __webpack_require__(299)
	      },
	      'aside': {
	        template: __webpack_require__(170),
	        controller: 'AsideCtrl'
	      },
	      'header': {
	        template: __webpack_require__(171),
	        controller: 'HeaderCtrl'
	      },
	      'chatbox': {
	        template: __webpack_require__(172),
	        controller: 'ChatboxController',
	        controllerAs: 'chatbox'
	      },
	      'footer': {
	        template: __webpack_require__(177)
	      }
	    }
	  }).state('portfolio.myPortfolio', {
	    abstract: false,
	    url: '/myPortfolio',
	    template: __webpack_require__(300),
	    controller: 'MyPortfolioCtrl',
	    controllerAs: 'portfolioVm',
	    params: {
	      haveGuest: false,
	      isOnEvaluation: false,
	      isExternal: false
	    }
	  }).state('portfolio.sharedPortfolio', {
	    abstract: false,
	    url: '/sharedPortfolio',
	    template: __webpack_require__(301),
	    controller: 'SharedPortfolioCtrl',
	    controllerAs: 'sharedPortfolioVm'
	  }).state('portfolio.otherPortfolio', {
	    abstract: false,
	    url: '/otherPortfolio',
	    template: __webpack_require__(302),
	    controller: 'OtherPortfolioCtrl',
	    controllerAs: 'otherPortfolioVm'
	  }).state('portfolio.powerbi', {
	    abstract: false,
	    url: '/portfolioPowerbi',
	    template: __webpack_require__(303),
	    controller: 'powerbiPortfolioCtrl',
	    controllerAs: 'powerbiCtrl'
	  }).state('portfolio.visitPortfolio', {
	    abstract: false,
	    url: '/visitPortfolio',
	    template: __webpack_require__(300),
	    controller: 'MyPortfolioCtrl',
	    controllerAs: 'portfolioVm',
	    params: {
	      haveGuest: true,
	      isOnEvaluation: false,
	      isExternal: false
	    }
	  }).state('portfolio.evaluationOfPortfolio', {
	    abstract: false,
	    url: '/evaluationOfPortfolio',
	    template: __webpack_require__(300),
	    controller: 'MyPortfolioCtrl',
	    controllerAs: 'portfolioVm',
	    params: {
	      haveGuest: true,
	      isOnEvaluation: true,
	      isExternal: false
	    }
	  }).state('portfolio.listEvaluationPortfolio', {
	    abstract: false,
	    url: '/listEvaluationPortfolio',
	    template: __webpack_require__(304),
	    controller: 'EvaluationPortfolioCtrl',
	    controllerAs: 'evaluationVm'
	  }).state('portfolio.parametrization', {
	    abstract: false,
	    url: '/portfolioParametrization',
	    template: __webpack_require__(305),
	    controller: 'PortfolioParametrizationCtrl',
	    controllerAs: 'parametrizationVm'
	  }).state('fullscreenPortfolio', {
	    url: '/app/portfolio',
	    abstract: false,
	    views: {
	      '': {
	        template: __webpack_require__(306)
	      },
	      'content': {
	        template: __webpack_require__(174)
	      },
	      'aside': {
	        template: __webpack_require__(307),
	        controller: 'AsideCtrl'
	      }
	    }
	  }).state('fullscreenPortfolio.externalVisitPortfolio', {
	    abstract: false,
	    url: '/public?ownerPortfolio=:userId&external',
	    template: __webpack_require__(300),
	    controller: 'MyPortfolioCtrl',
	    controllerAs: 'portfolioVm',
	    params: {
	      haveGuest: true,
	      isOnEvaluation: false,
	      isExternal: true
	    }
	  });
	}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = "<div class=box> <div class=\"box-row content-box\"> <div class=box-cell> <div class=\"box-inner padding-box\" ui-view id=view> </div> </div> </div> </div> ";

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = " <style>.tooltip-multiline{height:auto}</style> <div class=\"row gris-base p-h-lg p-v\"> <div class=col-md-12> <div class=row> <div class=\"col-xs-12 col-md-5 col-lg-6 title\"> <h3 class=p-t>{{portfolioVm.mainText}} <i class=\"mdi-action-info-outline text-lg text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-center\"> El statement es una declaración del profesor sobre la docencia y lo que pone en juego como profesor. <br/> Refleja su filosofía sobre lo que significa enseñar y aprender. </md-tooltip> </i> </h3> </div> <div class=\"col-xs-12 col-md-3 col-lg-3 text-right\"> <md-button class=\"btn btn-fw btn-success text-xs\" ng-click=portfolioVm.addNewRegistry() ng-if=!portfolioVm.haveGuest> Nuevo Registro </md-button> <md-button class=\"btn btn-fw btn-primary text-xs\" ng-click=portfolioVm.evalComment() ng-if=portfolioVm.isOnEvaluation> Evaluar </md-button> </div> <div class=\"col-xs-12 col-md-4 col-lg-3\"> <div class=card> <div class=\"card-body p\"> <div class=\"row no-gutter\"> <div class=\"col-md-5 text-xxs text-right\"> <p class=\"m-r text-right text-xxs\">Visualización de reflexiones del año</p> </div> <div class=\"col-md-1 no-padding text-left\"> <i class=\"icon mdi-editor-insert-invitation m-t-sm i-24 text-negro-opacity right pointer\"></i> </div> <div class=\"col-md-6 p-h-xs\"> <select name=year ng-model=portfolioVm.selectedYear ng-options=\"year for year in portfolioVm.years\" class=form-control ng-change=portfolioVm.getPortfolioBasics() required> </select> </div> </div> </div> </div> </div> </div> <div class=row> <div class=col-xs-12> <div class=card style=height:280px> <div class=\"col-md-2 p-v bg-rojo-dark text-center\" style=height:100%> <div class=\"card-heading no-padding\"> <img src={{picture}} class=\"img-responsive rounded image_profile_blog align_center\" err-src={{pictureRosario}} err-src-resolve=onUserPictureError> <br/> <div class=\"font-bold text-sm font-bold text-blanco\"> {{portfolioVm.profesor.teacherName}} <br/> </div> <div class=\"font-italic text-xs text-blanco\"> {{portfolioVm.profesor.teacherHierarchy}} <br/> {{portfolioVm.profesor.academicName}} </div> <div class=\"text-xxs text-blanco m-t-sm\"> Última modficación: {{portfolioVm.profesor.lastUpdate}} </div> </div> </div> <div class=\"col-md-10 p-v m-b-xs html-text no-padding-t\" style=height:100%> <div class=card-body> <div class=col-xs-12 style=max-height:150px;overflow-y:auto> <div ta-bind=text ng-model=portfolioVm.actualStatement.blogDescription ta-readonly=disabled></div> </div> <div class=col-md-12 ng-if=\"portfolioVm.actualStatement.externalUrlFiles.length > 0\"> <h5 class=text-azul>Archivos Adjuntos</h5> </div> <div class=col-md-12> <p><span class=m-r-xs ng-repeat=\"file in portfolioVm.actualStatement.externalUrlFiles\"><a class=underscore ng-href={{file.externalUrlFile}} download={{file.filename}}>{{file.filename}} </a></span> </p> </div> </div> </div> <div class=card-tools ng-if=!portfolioVm.haveGuest> <ul class=list-inline> <li class=dropdown> <a md-ink-ripple=\"\" data-toggle=dropdown class=\"md-btn md-flat md-btn-circle\" aria-expanded=false> <i class=\"mdi-navigation-more-vert text-md\"></i> <div class=md-ripple-container></div></a> <ul class=\"dropdown-menu dropdown-menu-scale pull-right pull-up top text-color\"> <li><a href=\"\" ng-click=portfolioVm.editStatement(portfolioVm.actualStatement)>Editar Statement</a></li> <li><a href=\"\" ng-click=portfolioVm.historyStatement()>Ver Resumen</a></li> </ul> </li> </ul> </div> </div> </div> </div> <div class=row> <div class=\"col-md-7 m-t-md\"> <div class=row> <div class=col-md-12> <h4> <i class=\"icon mdi-communication-chat i-20 text-azul text-left\"></i> Reflexiones <i class=\"mdi-action-info-outline text-lg text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-center\"> Reflexiones del profesor sobre su práctica docente: Aspectos a destacar, experiencias <br/>que requieren ajustes, experimentación de nuevas metodologías, identificación de avances <br/>y posibles mejoras, etc. </md-tooltip> </i> </h4> </div> <div class=col-md-12> <div class=card> <div class=\"card-body p\"> <div class=\"row no-gutter\"> <div class=\"col-md-6 search no-padding-l p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=portfolioVm.reflectionFilter ng-model-options=\"{ debounce: 300 }\" class=\"form-control b-white\" placeholder=Buscar... ng-change=portfolioVm.updateView()> <div class=\"input-group-btn b-white\"> <button class=\"btn btn-default search-btn b-white no-border\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=\"col-md-3 search no-padding-l p-v-sm\"> <select class=form-control ng-model=portfolioVm.selectedOrderReflection ng-change=portfolioVm.getFilterOrderDataReflection()> <option ng-repeat=\"filter in portfolioVm.filtersOrderReflections\" value={{filter.filterId}}> {{filter.filterName}} </option> </select> </div> <div class=\"col-md-3 search p-v-sm\" style=padding-left:6px> <select class=form-control ng-model=portfolioVm.selectedIsEnlightedFilter ng-change=portfolioVm.getFilterOrderDataReflection()> <option ng-repeat=\"filter in portfolioVm.isEnlightedFilter\" value={{filter.filterId}}> {{filter.filterName}} </option> </select> </div> </div> </div> </div> </div> <div class=\"col-md-12 m-t-md profile-cards\"> <div class=grad-white></div> <div class=\"no-padding fixed-height-800\"> <div class=masonry-cols-2> <div class=\"col-md-12 masonry-break p-xs\" ng-model=portfolioVm.selectedReflection ng-repeat=\"reflection in portfolioVm.reflections | \n                                filter: portfolioVm.reflectionFilter  | \n                                filterBy: ['blogIsEnlighted'] : portfolioVm.selectedIsEnlightedFilter |  \n                                orderBy : portfolioVm.selectedOrderReflection\"> <div class=\"card masonry-break\"> <div class=\"card-heading p-h-xs\"> <div dropdown dropdown-append-to-body ng-if=!portfolioVm.haveGuest> <i class=\"icon mdi-navigation-more-vert i-16 text-gris right dropdown-toggle pointer\" dropdown-toggle></i> <ul class=\"dropdown-menu dropdown-menu-right m-t-md m-r-xs\" role=menu> <li class=\"pointer p-xs\" ng-click=portfolioVm.editReflection(reflection)>Editar</li> <li class=\"pointer p-xs\" ng-click=portfolioVm.deleteReflection(reflection) ng-if=reflection.current>Eliminar</li> </ul> </div> <i class=\"icon mdi-action-grade i-16 text-gris right pointer\" ng-if=\"reflection.blogIsEnlighted == 0\" ng-click=portfolioVm.setEnlighted(reflection)></i> <i class=\"icon mdi-action-grade i-16 text-amarillo right pointer\" ng-if=\"reflection.blogIsEnlighted == 1\" ng-click=portfolioVm.setEnlighted(reflection)></i> <h6 class=\"text-azul-light text-xs p-h-xs font-bold\">{{reflection.blogTitle}}</h6> <h6 class=\"text-gris p-h-xs font-italic proxima\">{{reflection.blogUpdatedDate}}</h6> </div> <div class=\"card-body no-padding-t horizontalDivider p-h-xs\"> <div class=\"row no-gutter\"> <div class=col-xs-12> <p class=p-h-sm>{{reflection.blogDescription}}</p> <div ng-if=\"reflection.totalLinks > 0\"> <div ng-if=\"reflection.evidences[0].evidenceFileType == portfolioVm.filetypes.image\"> <img class=\"col-md-12 m-v-sm no-padding\" class=\"img-responsive align_left\" ng-src={{reflection.evidences[0].evidenceUrlFile}}> </div> <div ng-if=\"reflection.evidences[0].evidenceFileType == portfolioVm.filetypes.video\"> <video class=\"col-md-12 m-v-sm no-padding\" controls ng-src={{reflection.evidences[0].evidenceUrlFile}}></video> </div> </div> </div> </div> <div class=\"row no-gutter p-l-sm\" ng-if=\"reflection.totalLinks > 0\"> <div class=col-xs-12> <h6 class=font-bold>Evidencias Enlazadas</h6> <div class=\"row no-gutter text-xxs\" ng-model=portfolioVm.selectedReflection1 ng-repeat=\"evi in reflection.evidences\"> <div class=\"no-margin-t no-padding col-md-1\"> <i class=\"icon mdi-image-image i-24 text-gris-dark left\" ng-if=\"evi.evidenceFileType == portfolioVm.filetypes.image\"></i> <i class=\"icon mdi-editor-insert-drive-file i-24 text-gris-dark left\" ng-if=\"evi.evidenceFileType == portfolioVm.filetypes.document\"></i> <i class=\"icon mdi-image-audiotrack i-24 text-gris-dark left\" ng-if=\"evi.evidenceFileType == portfolioVm.filetypes.audio\"></i> <i class=\"icon mdi-av-videocam i-24 text-gris-dark left\" ng-if=\"evi.evidenceFileType == portfolioVm.filetypes.video\"></i> </div> <div class=\"col-md-11 m-t-xs text-left\"> <a ng-href={{evi.evidenceUrlFile}} download={{evi.evidenceFileName}}> {{evi.evidenceFileName}}</a> </div> </div> </div> </div> <div class=\"row no-gutter p-t-sm p-h-sm m-t-sm b-t\"> <div class=\"col-md-6 text-xxs no-padding\"> <md-checkbox class=\"no-margin md-green\" type=checkbox ng-model=reflection.blogIsInput name=insumo ng-checked=\"reflection.blogIsInput == 1\" ng-click=portfolioVm.setInput(reflection) ng-if=!portfolioVm.haveGuest> Incluir como insumo </md-checkbox> </div> <div class=\"col-md-6 text-xxs text-right no-padding pointer\" ng-click=portfolioVm.addReflectionComment(reflection)> <i class=\"icon mdi-communication-forum i-16 text-negro-opacity text-left\"></i> {{reflection.totalComments}} Comentarios </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-5 m-t-md\"> <div class=row> <div class=col-md-12> <h4> <i class=\"icon mdi-editor-attach-file i-20 text-azul text-left\"></i> Colección de Evidencias <i class=\"mdi-action-info-outline text-lg text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-center\"> Evidencias medibles u observables que podrían dar soporte a las reflexiones del profesor<br/> sobre su práctica. Ejm: resultados de los estudiantes, videos de clase, <br/> guía de asignatura, formato de rediseño de actividades, etc. </md-tooltip> </i> </h4> </div> <div class=col-md-12> <div class=card> <div class=\"card-body p-sm\"> <div class=\"row gutter-10\"> <div class=\"col-md-4 search p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=portfolioVm.evidenceFilter ng-model-options=\"{ debounce: 300 }\" class=\"form-control b-white\" placeholder=Buscar... ng-change=portfolioVm.updateView()> <div class=\"input-group-btn b-white\"> <button class=\"btn btn-default search-btn b-white no-border\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=\"col-md-4 search no-padding-l p-v-sm\"> <select class=form-control ng-model=portfolioVm.selectedFilterEvidence ng-change=portfolioVm.getFilterOrderDataReflection()> <option ng-repeat=\"filter in portfolioVm.filtersEvidences\" value={{filter.filterId}}> {{filter.filterName}} </option> </select> </div> <div class=\"col-md-4 search no-padding-l p-v-sm\"> <select class=form-control ng-model=portfolioVm.selectedOrderEvidence ng-change=portfolioVm.getFilterOrderDataReflection()> <option ng-repeat=\"filter in portfolioVm.filtersOrderEvidences\" value={{filter.filterId}}> {{filter.filterName}} </option> </select> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 profile-cards\"> <div class=grad-white></div> <div class=\"col-md-12 m-t-md no-padding fixed-height-300\"> <div class=masonry-cols-2> <div class=\"col-md-12 p-xs masonry-break\" ng-model=portfolioVm.selectedEvidence ng-repeat=\"evidence in portfolioVm.evidences | \n                                filter: portfolioVm.evidenceFilter | \n                                filterBy: ['blogFileType']: portfolioVm.selectedFilterEvidence |  \n                                orderBy : portfolioVm.selectedOrderEvidence\"> <div class=\"card masonry-break\"> <div class=\"card-heading no-padding-b p-h-xs\"> <i class=\"icon mdi-action-delete m-r-sm i-16 text-negro-opacity right pointer\" ng-click=portfolioVm.disableEvidence(evidence) ng-if=\"evidence.totalLinks == 0 && !portfolioVm.haveGuest\"></i> <i class=\"icon mdi-editor-mode-edit m-r-sm i-16 text-negro-opacity right m-r-sm pointer\" ng-click=portfolioVm.editEvidence(evidence) ng-if=\"evidence.totalLinks == 0 && !portfolioVm.haveGuest\"></i> <i class=\"icon mdi-image-image m-r-sm i-28 text-gris-dark left\" ng-if=\"evidence.blogFileType == portfolioVm.filetypes.image\"></i> <i class=\"icon mdi-editor-insert-drive-file m-r-sm i-28 text-gris-dark left\" ng-if=\"evidence.blogFileType == portfolioVm.filetypes.document\"></i> <i class=\"icon mdi-image-audiotrack m-r-sm i-28 text-gris-dark left\" ng-if=\"evidence.blogFileType == portfolioVm.filetypes.audio\"></i> <i class=\"icon mdi-av-videocam m-r-sm i-28 text-gris-dark left\" ng-if=\"evidence.blogFileType == portfolioVm.filetypes.video\"></i> <h6 class=\"text-azul-light p-h-xs font-bold text-xxs m-v-sm\">{{evidence.blogTitle}}</h6> <p class=\"text-gris p-h-xs font-italic proxima text-xxs m-v-xs\">{{evidence.blogUpdatedDate}}</p> </div> <div class=\"card-body p-sm\"> <div class=\"row no-gutter\"> <div class=\"col-md-12 p-v-xs horizontalDivider p-h-xs\"> <p>{{evidence.blogDescription}}</p> </div> <div class=\"col-md-12 p-v-xs m-t-sm p-h-xs\"> <div class=\"col-md-6 text-xxs underscore no-padding\"> <a ng-href={{evidence.blogUrlFile}} download={{evidence.fileName}}>Descargar</a> </div> <div class=\"col-md-6 text-xxs text-right no-padding pointer\" ng-click=portfolioVm.evidenceLinks(evidence)> <i class=\"icon mdi-communication-forum i-16 text-negro-opacity text-left\" ng-if=\"evidence.totalLinks > 0\"></i> <span ng-if=\"evidence.totalLinks > 1\">{{evidence.totalLinks}} veces enlazada</span> <span ng-if=\"evidence.totalLinks == 1\">{{evidence.totalLinks}} vez enlazada</span> <span ng-if=\"evidence.totalLinks == 0\">No hay reflexiones enlazadas</span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v\"> <h4> <i class=\"icon mdi-communication-forum i-20 text-azul text-left\"></i> Comentarios</h4> </div> <div class=col-xs-12> <div class=card> <div class=\"card-body no-padding\"> <md-tabs class=p-sm md-stretch-tabs=always md-dynamic-height md-border-bottom> <md-tab md-selected label=Portafolio> <div class=\"col-md-12 m-t-md no-padding fixed-height-345\"> <div ng-model=portfolioVm.selectedComment ng-repeat=\"comment in portfolioVm.commentsUsers\"> <div class=\"col-md-2 p-h-xs\"> <img class=\"img-responsive rounded image_profile_blog_comments align_left\" ng-src={{comment.commentUserPicture}}> </div> <div class=\"col-md-10 no-padding-l\"> <span class=\"font-bold text-xs\">{{comment.commentUserName}}</span> <br/> <span class=\"text-gris text-xxs\">{{comment.commentCreationDate}}</span> </div> <div class=\"col-md-12 p-v-sm horizontalDivider p-h-xs m-b-sm\"> {{comment.commentDescription}} </div> </div> </div> <div class=\"col-md-12 p-v-xs text-center\" ng-if=!portfolioVm.isExternal> <md-button class=\"btn btn-fw btn-success text-xs\" ng-click=portfolioVm.addUserComment()> Comentar </md-button> </div> </md-tab> <md-tab ng-if=\"(!portfolioVm.haveGuest && \n                                  !portfolioVm.isExternal) || \n                                  portfolioVm.isOnEvaluation\"> <md-tab-label> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-center\"> El portafolio solo será evaluado cuando el profesor se postule en convocatorias de promoción o premios de docencia. <br/>En cualquier caso, solo el profesor y el comité asignado tendrán acceso a los comentarios de la evaluación. </md-tooltip> Evaluaciones </md-tab-label> <div class=\"col-md-12 m-t-md no-padding fixed-height-345\"> <div ng-model=portfolioVm.selectedCommentEval ng-repeat=\"comment in portfolioVm.commentsEvals\"> <div class=\"col-md-2 p-h-xs\"> <i class=\"icon mdi-action-group-work i-28 vertical-align-sm text-azul\"></i> </div> <div class=\"col-md-9 no-padding-l\"> <span class=\"font-bold text-xs\">{{comment.comiteeName}}</span> <br/> <span class=\"text-gris text-xxs\">{{comment.commentCreationDate}}</span> </div> <div class=\"col-md-12 p-v-sm p-h-xs\"> {{comment.shortComment}} </div> <div class=\"col-md-12 text-right horizontalDivider underscore m-b-sm text-xxs text-azul p-h-xs p-b-xs\" ng-click=portfolioVm.commentDetails(comment)> Ver más... </div> </div> </div> </md-tab> </md-tabs> </div> </div> </div> </div> </div> </div> </div> </div>  <div class=\"row gris-base\"> <div class=col-md-12> <br> <br> </div> </div> ";

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row gris-base\"> <div class=\"col-md-8 title p-h-lg p-v\"> <h3>Compartir mi portafolio</h3> <p class=\"text-justify text-16-important\"> Las personas con las que comparta su portafolio podrán consultar el texto de su Statement, sus reflexiones y las evidencias enlazadas a las reflexiones. Podrá compartir su portafolio con usuarios externos por medio de un enlace, aunque estos no podrán registrar comentarios. En ninguno de los casos los invitados podrán consultar los resultados de evaluación de su portafolio </p> </div> </div> <div class=\"row blanco p-b-md p-h-md\" style=\"display:block;height:calc(100% - 78px)\"> <div class=\"col-md-6 m-t-md\"> <div class=\"col-md-12 no-padding\"> <h4 class=text-azul> Compartir </h4> <h5 class=\"text-negro proxima\"> Ingrese el nombre de la persona con la que quiere compartir este portafolio</h5> </div> <form name=sharedForm> <div class=row> <div class=\"form-group col-md-9\"> <div class=\"text-left text-xs\"> <label class=control-label for=name>Nombre</label> <md-autocomplete required class=\"autocomplete col-md-12 m-r-xs\" md-clear-button=false md-item-text=user.ds_fullname md-min-length=0 md-no-cache=true md-selected-item-change=sharedPortfolioVm.changeSharedUser() md-selected-item=sharedPortfolioVm.selectedSharedUser md-search-text=sharedPortfolioVm.searchText placeholder=\"Buscar usuario...\" md-items=\"user in sharedPortfolioVm.searchUsers(sharedPortfolioVm.searchText)\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{user.ds_fullname}}</span> </md-item-template> </md-autocomplete> <div class=\"col-md-12 has-error no-padding-h\" ng-show=sharedPortfolioVm.invalidText> <label class=\"col-md-12 control-label no-padding-h\"> {{sharedPortfolioVm.msgInvalidText}} </label> </div> </div> </div> <div class=\"col-md-3 no-padding align-self-end text-center\" style=margin-top:30px> <i class=\"icon mdi-content-add i-20 btn btn-primary\" ng-click=sharedPortfolioVm.setUser() ng-disabled=sharedPortfolioVm.validateForm()></i> </div> <div class=\"col-md-12 text-left text-xs\"> <label class=control-label for=shared>Compartidos con:</label> </div> <div class=\"col-md-12 text-left text-xs\"> <div class=\"col-md-4 no-padding\" ng-model=sharedPortfolioVm.userInArrayOfUser ng-repeat=\"user in sharedPortfolioVm.arrayOfUsers \"> <div class=\"col-md-4 p-h-xs\"> <img class=\"img-responsive rounded image_profile_blog_comments align_left\" ng-src={{user.ds_picture}}> </div> <div class=\"col-md-8 no-padding-l m-t-sm\"> <span class=\"font-bold text-xxs\">{{user.ds_fullname}}</span> </div> </div> </div> </div> </form> <div class=\"col-md-12 no-padding-h m-t text-center\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=sharedPortfolioVm.cleanForm()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-click=sharedPortfolioVm.addSharedUsers() ng-disabled=\"sharedPortfolioVm.arrayOfUsers.length == 0 || sharedPortfolioVm.disableButton\"> Agregar</md-button> </div> <div class=\"col-md-12 no-padding-h m-t text-left\"> <div class=\"form-group col-md-8\"> <input type=text class=form-control ng-model=sharedPortfolioVm.sharedLink ng-model-options=\"{ debounce: 300 }\"/> </div> <div class=col-md-4> <md-button clipboard text=sharedPortfolioVm.sharedLink aria-label class=\"btn btn-fw btn-primary no-m-t\"> Copiar Link </md-button> </div> </div> </div> <div class=\"col-md-6 m-t-md no-padding\"> <div class=\"col-md-12 no-padding\"> <h4 class=text-azul> Usuarios con quienes ha compartido su portafolio </h4> </div> <div class=\"col-md-12 search no-padding-l p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=sharedPortfolioVm.usersFilter ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=Buscar... ng-change=sharedPortfolioVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=\"col-xs-12 scroll-55vh\"> <div class=row> <div class=col-md-12 ng-model=sharedPortfolioVm.selectedUser ng-repeat=\"user in sharedPortfolioVm.usersWithSharedPermission | filter: sharedPortfolioVm.usersFilter \"> <div class=\"row gutter-10\"> <div class=\"col-md-2 p-t p-h-xs\"> <img class=\"img-responsive rounded image_profile_blog_comments align_left\" ng-src={{user.userImage}}> </div> <div class=\"col-md-6 p-t no-padding-l\"> <span class=\"font-bold text-xs\">{{user.userName}}</span> <br/> <span class=text-xs>{{user.creationDate}}</span> </div> <div class=\"col-md-4 p-t text-left no-padding-l\"> <md-button class=\"btn btn-fw btn-danger text-xs\" ng-click=sharedPortfolioVm.showConfirmDialog(user)> Eliminar Acceso </md-button> </div> <div class=\"col-md-12 horizontalDivider p-v-xs p-h-xs p-b\"> {{user.userDescription}} </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row gris-base title\"> <div class=\"col-md-8 p-h-lg p-v\"> <h3>Otros Portafolios</h3> </div> </div> <div class=\"row blanco\"> <div class=\"col-md-6 m-t-md no-padding\"> <div class=\"col-md-12 search p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=otherPortfolioVm.usersFilter ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=Buscar... ng-change=otherPortfolioVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=\"col-md-12 p-v-sm text-center text-gris proxima\" ng-if=\"otherPortfolioVm.users.length == 0\"> <h4>Aún no le han compartido ningún portafolio</h4> </div> <div class=col-md-12 ng-model=otherPortfolioVm.selectedUser ng-repeat=\"user in otherPortfolioVm.users | filter: otherPortfolioVm.usersFilter \"> <div class=\"col-md-2 p-h-xs\"> <img class=\"img-responsive rounded image_profile_blog_comments align_left\" ng-src={{user.userImage}}> </div> <div class=\"col-md-6 no-padding-l\"> <span class=\"font-bold text-xs\">{{user.userName}}</span> <br/> <span class=text-xs>{{user.creationDate}}</span> </div> <div class=\"col-md-4 no-padding-r text-right\"> <md-button class=\"btn btn-fw btn-success text-xs no-m-r\" ng-click=otherPortfolioVm.visitPortfolio(user)> Ver </md-button> </div> <div class=\"col-md-12 horizontalDivider p-v-xs p-h-xs\"> {{user.userDescription}} </div> </div> </div> </div> ";

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = "<div> <div class=main-title> <div class=title> <h1>{{title}}</h1> </div> </div> <div class=panel style=overflow:visible> <div class=panel-body> <div powerbi-scope-with-controller workspaceid={{workspaceId}} reportid={{reportId}}></div> </div> </div> </div> ";

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row gris-base title\"> <div class=\"col-md-8 p-h-lg p-v\"> <h3>Evaluar Portafolios</h3> </div> </div> <div class=\"row blanco m-l-sm m-r-lg\"> <div class=\"col-md-6 m-t-md no-padding\"> <div class=\"col-md-12 search no-padding-l p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=evaluationVm.usersFilter ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=Buscar... ng-change=evaluationVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=\"col-md-12 no-padding\" ng-model=evaluationVm.selectedUser ng-repeat=\"user in evaluationVm.users | filter: evaluationVm.usersFilter \"> <div class=\"col-md-2 p-h-xs\"> <img class=\"img-responsive rounded image_profile_blog_comments align_left\" ng-src={{evaluationVm.getCachedImages(user.identification)}}> </div> <div class=\"col-md-6 no-padding-l\"> <span class=\"font-bold text-xs\">{{user.userName}}</span> <br/> <span class=text-xs>{{user.creationDate}}</span> </div> <div class=\"col-md-4 text-left no-padding-l\"> <md-button class=\"btn btn-fw btn-success text-xs\" ng-click=evaluationVm.evalPortfolio(user)> Evaluar </md-button> </div> <div class=\"col-md-12 horizontalDivider p-v-xs p-h-xs\"> {{user.userDescription}} </div> </div> </div> </div> ";

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row gris-base title\"> <div class=\"col-md-8 p-h-lg p-v\"> <h3>Parametrización de pautas de evaluación de Portafolio</h3> </div> </div> <div class=\"row blanco\"> <div class=\"col-md-6 m-t-md p-l-md m-b-md no-padding\"> <div class=\"col-md-12 no-padding\"> <h4 class=text-azul> Listado de pautas publicadas <i class=\"mdi-action-info-outline text-lg text-left text-azul i-24\" aria-label=info> <md-tooltip md-direction=bottom>Sólo puede haber una pauta activa a la vez</md-tooltip> </i> </h4> </div> <div class=\"col-md-12 search no-padding-l p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=parametrizationVm.patternsFilter ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=Buscar... ng-change=parametrizationVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=col-md-12 ng-model=parametrizationVm.selectedUser ng-repeat=\"guideline in parametrizationVm.guidelines | filter: parametrizationVm.guidelinesFilter \"> <div class=\"col-md-8 no-padding-l p-t-sm\"> <span class=\"font-bold text-xs\">{{guideline.title}}</span> </div> <div class=\"col-md-2 text-left no-padding-l\"> <i class=\"icon mdi-navigation-check m-t-sm i-24 text-negro-opacity right pointer\" ng-click=parametrizationVm.setActiveList(guideline,$index) ng-if=\"guideline.active == 0\"></i> <i class=\"icon mdi-navigation-check m-t-sm i-24 text-verde right pointer\" ng-if=\"guideline.active == 1\"></i> </div> <div class=\"col-md-2 text-left no-padding-l\"> <i class=\"icon mdi-action-visibility m-t-sm i-24 text-negro-opacity right pointer\" ng-click=parametrizationVm.showModal(guideline)></i> </div> <div class=\"col-md-12 horizontalDivider p-v-xs p-h-xs\"> </div> </div> </div> <div class=\"col-md-6 m-t-md p-r-md\"> <form name=parametrizationForm> <div class=row> <div class=\"form-group col-md-12\"> <div class=\"text-left text-xs\"> <label class=control-label for=name>Titulo</label> </div> </div> <div class=\"form-group col-md-8\" ng-class=parametrizationVm.hasError(parametrizationForm.title)> <div class=\"text-left text-xs\"> <input type=text name=title ng-model=parametrizationVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=parametrizationForm.title.$error ng-show=\"\n                 parametrizationVm.showErrorMessages(parametrizationForm.title)\"> <div ng-message=required class=text-xs>El titulo es requerido.</div> </div> </div> </div> <div class=\"form-group col-md-4\"> <md-checkbox class=\"no-margin md-green text-xs\" type=checkbox ng-model=parametrizationVm.active ng-click=parametrizationVm.setActive() ng-checked=\"parametrizationVm.active == 1\" name=active value=1> Activo por defecto </md-checkbox> </div> <div class=\"form-group col-md-12\" ng-class=parametrizationVm.hasError(parametrizationForm.description)> <label for=description class=control-label>Pautas</label> <textarea name=description ng-model=parametrizationVm.description rows=6 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=control-label ng-messages=parametrizationForm.description.$error ng-show=parametrizationVm.showErrorMessages(parametrizationForm.description)> <div ng-message=required class=text-xs>Las pautas son requeridas.</div> </div> </div> </div> </form> <div class=\"col-md-12 no-padding-h m-t m-b text-left\"> <md-button aria-label class=\"btn btn-fw btn-success no-margin\" ng-click=parametrizationVm.addGuideline(parametrizationForm) ng-disabled=parametrizationVm.validateForm(parametrizationForm)> Guardar</md-button> </div> </div> </div> ";

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"fullscreen h-full w-full-sm\" ng-class=fullscreenClass> <md-sidenav id=aside class=\"app-aside md-sidenav-left\" ng-class=\"{'folded': !fullyFolded}\" ui-view=aside@ md-component-id=aside> </md-sidenav> <div id=content class=app-content role=main ui-view=content@> </div> </div> ";

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = "";

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'portfolio'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, portfolio) {
	  MenuConstant[0]['menu'].push(portfolio);
	}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PortfolioSrv = function PortfolioSrv($resource, SERVICE_URL_CONSTANT) {
		_classCallCheck(this, PortfolioSrv);
	
		// PORTFOLIO SERVICES
		var getPortfolioBasics = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getPortfolioBasics', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getStatements = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getStatements', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getPortfolioComitee = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getPortfolioComitee', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getEvalComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getEvalComment', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getCommentsUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getCommentsUsers', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getCommentsEvals = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getCommentsEvals', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getReflectionCommentById = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getReflectionCommentById', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getEvidences = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getEvidences', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getReflections = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getReflections', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getBasicsRegistry = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getBasicsRegistry', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getGuidelines = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getGuidelines', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var addGuideline = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addGuideline', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addUserComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addUserComment', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addEvalComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addEvalComment', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addReflectionComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addReflectionComment', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addSharedUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addRelationSharedPortfolio', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addReflection = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addReflection', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addEvidence = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addEvidence', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addStatement = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/addStatement', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var setInput = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/setInput', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var setEnlighted = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/setEnlighted', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var updateGuideline = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateGuideline', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var getSharedPortfolioUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getSharedPortfolioUsers', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getSharedPortfolio = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getSharedPortfolio', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getTeacherToEvaluation = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/getTeacherToEvaluation', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var disableEvidence = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/disableEvidence', {}, {
			disable: {
				method: 'POST'
			}
		});
	
		var disableUserAccess = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/disableUserAccess', {}, {
			disable: {
				method: 'POST'
			}
		});
	
		var updateEvidence = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateEvidence', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var updateEvalComment = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateEvalComment', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var updateReflection = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/updateReflection', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var deleteReflection = $resource(SERVICE_URL_CONSTANT.rosario + '/portfolio/deleteReflection', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var getPerfilDash = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/perfil_dash/:teacherId', {}, {
			get: {
				method: 'GET'
			}
		});
	
		// SERVICES INJECTION
		return {
			getPortfolioBasics: getPortfolioBasics,
			getBasicsRegistry: getBasicsRegistry,
			getGuidelines: getGuidelines,
			addGuideline: addGuideline,
			addUserComment: addUserComment,
			addReflectionComment: addReflectionComment,
			setInput: setInput,
			setEnlighted: setEnlighted,
			addReflection: addReflection,
			addEvidence: addEvidence,
			getSharedPortfolioUsers: getSharedPortfolioUsers,
			getSharedPortfolio: getSharedPortfolio,
			disableEvidence: disableEvidence,
			updateEvidence: updateEvidence,
			getCommentsUsers: getCommentsUsers,
			getReflectionCommentById: getReflectionCommentById,
			getEvidences: getEvidences,
			addStatement: addStatement,
			getTeacherToEvaluation: getTeacherToEvaluation,
			getPortfolioComitee: getPortfolioComitee,
			getEvalComment: getEvalComment,
			addEvalComment: addEvalComment,
			updateEvalComment: updateEvalComment,
			addSharedUsers: addSharedUsers,
			disableUserAccess: disableUserAccess,
			updateReflection: updateReflection,
			deleteReflection: deleteReflection,
			getReflections: getReflections,
			getCommentsEvals: getCommentsEvals,
			getStatements: getStatements,
			updateGuideline: updateGuideline,
			addNotificationsTransactions: addNotificationsTransactions,
			getPerfilDash: getPerfilDash
		};
	};
	
	PortfolioSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	exports.default = angular.module('services.PortfolioSrv', []).service('PortfolioSrv', PortfolioSrv).name;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PortfolioModalSrv = function PortfolioModalSrv($mdDialog) {
		_classCallCheck(this, PortfolioModalSrv);
	
		var addUserComment = function addUserComment() {
			return $mdDialog.show({
				controller: 'AddUserCommentCtrl',
				controllerAs: 'commentUserVm',
				template: __webpack_require__(311),
				clickOutsideToClose: false
			});
		};
	
		var addReflectionComment = function addReflectionComment() {
			return $mdDialog.show({
				controller: 'AddReflectionCommentCtrl',
				controllerAs: 'reflectionCommentVm',
				template: __webpack_require__(312),
				clickOutsideToClose: false
			});
		};
	
		var addNewRegistry = function addNewRegistry() {
			return $mdDialog.show({
				controller: 'AddNewRegistryCtrl',
				controllerAs: 'registryVm',
				template: __webpack_require__(313),
				clickOutsideToClose: false
			});
		};
	
		var evidenceLinks = function evidenceLinks() {
			return $mdDialog.show({
				controller: 'EvidenceLinksCtrl',
				controllerAs: 'linksVm',
				template: __webpack_require__(314),
				clickOutsideToClose: false
			});
		};
	
		var disableEvidence = function disableEvidence() {
			return $mdDialog.show({
				controller: 'DisableEvidenceCtrl',
				controllerAs: 'disableVm',
				template: __webpack_require__(315),
				clickOutsideToClose: false
			});
		};
	
		var editEvidence = function editEvidence() {
			return $mdDialog.show({
				controller: 'EditEvidenceCtrl',
				controllerAs: 'editEvidenceVm',
				template: __webpack_require__(316),
				clickOutsideToClose: false
			});
		};
	
		var editStatement = function editStatement() {
			return $mdDialog.show({
				controller: 'EditStatementCtrl',
				controllerAs: 'statementVm',
				template: __webpack_require__(317),
				clickOutsideToClose: false
			});
		};
	
		var historyStatement = function historyStatement() {
			return $mdDialog.show({
				controller: 'HistoryStatementCtrl',
				controllerAs: 'historyVm',
				template: __webpack_require__(318),
				clickOutsideToClose: false
			});
		};
	
		var commentDetails = function commentDetails() {
			return $mdDialog.show({
				controller: 'CommentDetailsCtrl',
				controllerAs: 'commentDetailVm',
				template: __webpack_require__(319),
				clickOutsideToClose: false
			});
		};
	
		var confirmDialog = function confirmDialog() {
			return $mdDialog.show({
				controller: 'ConfirmDialogCtrl',
				controllerAs: 'disableAccessVm',
				template: __webpack_require__(320),
				clickOutsideToClose: false
			});
		};
	
		var editReflection = function editReflection() {
			return $mdDialog.show({
				controller: 'EditReflectionCtrl',
				controllerAs: 'editReflectionVm',
				template: __webpack_require__(321),
				clickOutsideToClose: false
			});
		};
	
		var deleteReflection = function deleteReflection() {
			return $mdDialog.show({
				controller: 'DeleteReflectionCtrl',
				controllerAs: 'deleteReflectionVm',
				template: __webpack_require__(322),
				clickOutsideToClose: false
			});
		};
	
		var showGuidelineDetails = function showGuidelineDetails() {
			return $mdDialog.show({
				controller: 'GuidelineDetailsCtrl',
				controllerAs: 'guidelineVm',
				template: __webpack_require__(323),
				clickOutsideToClose: false
			});
		};
	
		// forma para pasar valores entre modales. El set desde el padre,
		// el get desde el hijo (modal)
		var reusableVariable = null;
	
		function setVariable(variable) {
			reusableVariable = variable;
	
			return reusableVariable;
		}
	
		function getVariable() {
			var unload = reusableVariable;
	
			reusableVariable = null;
	
			return unload;
		}
	
		return {
			addUserComment: addUserComment,
			addReflectionComment: addReflectionComment,
			addNewRegistry: addNewRegistry,
			setVariable: setVariable,
			getVariable: getVariable,
			evidenceLinks: evidenceLinks,
			disableEvidence: disableEvidence,
			editEvidence: editEvidence,
			editStatement: editStatement,
			historyStatement: historyStatement,
			commentDetails: commentDetails,
			confirmDialog: confirmDialog,
			editReflection: editReflection,
			deleteReflection: deleteReflection,
			showGuidelineDetails: showGuidelineDetails
		};
	};
	
	PortfolioModalSrv.$inject = ['$mdDialog'];
	
	exports.default = angular.module('services.PortfolioModalSrv', []).service('PortfolioModalSrv', PortfolioModalSrv).name;

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-toolbar> <div class=\"md-toolbar-tools m-v-sm\"> <md-button class=md-icon-button ng-click=commentUserVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-center font-medium text-negro-darker\">Comentar Portafolio </h4></div> </md-toolbar> <md-dialog-content> <form name=addCommentForm> <div class=\"row p-h-lg m-h-lg\"> <div class=\"col-md-12 p-t\" ng-class=commentUserVm.hasError(addCommentForm.comment)> <md-input-container class=control-label> <textarea type=text class=form-control name=comment rows=2 ng-model=commentUserVm.comment maxlength=150 md-maxlength=150 ng-model-options=\"{ debounce: 300 }\" required>\n            </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=addCommentForm.comment.$error ng-show=commentUserVm.showErrorMessages(addCommentForm.comment)> <div ng-message=required> Debe agregar un comentario </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=row> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=commentUserVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"commentUserVm.validateForm(addCommentForm) || commentUserVm.disableButton\" ng-click=commentUserVm.addComment()>Agregar</md-button> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=50> <md-toolbar> <div class=\"md-toolbar-tools m-v-sm\"> <md-button class=md-icon-button ng-click=reflectionCommentVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-center font-medium text-negro-darker\">Comentarios</h4> </div> </md-toolbar> <md-dialog-content> <div class=row> <div class=\"col-md-12 fixed-height-250\"> <div class=\"\" ng-model=portfolioVm.selectedComment ng-repeat=\"comment in reflectionCommentVm.reflection.comments\"> <div class=\"m-t-sm col-md-2 p-h-xs\"> <img class=\"img-responsive rounded image_profile_blog_comments align_left\" ng-src={{comment.commentUserPicture}}> </div> <div class=\"m-t-sm col-md-9 no-padding-l text-left\"> <span class=\"font-bold text-xs\">{{comment.commentUserName}}</span> <br/> <span class=\"text-gris text-xxs\">{{comment.commentCreation}}</span> </div> <div class=\"col-md-12 p-v-sm horizontalDivider p-h-xs text-left\"> {{comment.commentDescription}} </div> </div> </div> </div> <form name=addCommentForm class=m-t-sm ng-if=!reflectionCommentVm.isExternal> <div class=row> <div class=\"col-md-12 m-t-lg\" ng-class=reflectionCommentVm.hasError(addCommentForm.comment)> <md-input-container class=control-label> <textarea type=text class=form-control name=comment rows=2 ng-model=reflectionCommentVm.comment maxlength=150 md-maxlength=150 ng-model-options=\"{ debounce: 300 }\" required>\n            </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=addCommentForm.comment.$error ng-show=reflectionCommentVm.showErrorMessages(addCommentForm.comment)> <div ng-message=required> Debe agregar un comentario </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=reflectionCommentVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"reflectionCommentVm.validateForm(addCommentForm) || reflectionCommentVm.disableButton\" ng-click=reflectionCommentVm.addComment()>Agregar</md-button> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-toolbar> <div class=\"md-toolbar-tools m-v-sm\"> <md-button class=md-icon-button ng-click=registryVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 ng-if=registryVm.isRegistry class=\"col-xs-12 text-center font-medium text-negro-darker\">Nuevo Registro</h4> <h4 ng-if=registryVm.isLinking class=\"col-xs-12 text-center font-medium text-negro-darker\">Enlazar Evidencias</h4> <h4 ng-if=registryVm.isAddingEvidence class=\"col-xs-12 text-center font-medium text-negro-darker\">Crear Nueva Evidencia para Enlazar a Reflexión</h4> </div> </md-toolbar> <md-dialog-content style=min-height:40vh;max-height:70vh> <form name=registryForm ng-if=registryVm.isRegistry> <div class=row> <div class=\"col-md-12 text-left\"> <p> Seleccione el tipo de registro que desea agregar a su portafolio docente e ingrese los datos solicitados en el siguiente formulario </p> </div> <div class=\"col-md-3 form-group\"> <div class=\"text-left text-xs\" ng-class=registryVm.hasError(registryForm.typeRegistry)> <label for=typeRegistry class=control-label>Tipo de Registro</label> <select name=typeRegistry ng-model=registryVm.registryId ng-options=\"registries.registryId as registries.registryName\n                          for registries in registryVm.registryTypes\" class=form-control ng-change=registryVm.setClassTitle() required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=registryForm.typeRegistry.$error ng-show=registryVm.showErrorMessages(registryForm.typeRegistry)> <div ng-message=required>El registro es requerido</div> </div> </div> </div> <div class=form-group ng-class=registryVm.classTitle> <div class=\"text-left text-xs\" ng-class=registryVm.hasError(registryForm.title)> <label class=control-label for=title>Titulo</label> <input class=form-control name=title ng-model=registryVm.title required/> <div class=\"control-label text-xs\" ng-messages=registryForm.title.$error ng-show=registryVm.showErrorMessages(registryForm.title)> <div ng-message=required>El titulo es requerido</div> </div> </div> </div> <div ng-if=\"registryVm.itemConfig.idEvidence == registryVm.registryId\"> <div class=\"col-md-3 form-group\"> <div class=\"text-left text-xs\" ng-class=registryVm.hasError(registryForm.fileType)> <label for=fileType class=control-label>Archivo</label> <select name=fileType ng-model=registryVm.fileTypeId ng-options=\"fileType.fileTypeId as fileType.fileTypeName\n                            for fileType in registryVm.fileTypes\" class=form-control ng-change=registryVm.setFilterUploader() required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=registryForm.fileType.$error ng-show=registryVm.showErrorMessages(registryForm.fileType)> <div ng-message=required>El tipo de archivo es requerido</div> </div> </div> </div> <div class=\"col-md-3 form-group\"> <div class=\"text-left text-xs\" ng-class=registryVm.hasError(registryForm.typeEvidence)> <label for=typeEvidence class=control-label>Tipo de Evidencia</label> <select name=typeEvidence ng-model=registryVm.evidenceType ng-options=\"evidencesType.evidenceTypeId as evidencesType.evidenceTypeName\n                            for evidencesType in registryVm.evidencesTypes\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=registryForm.typeEvidence.$error ng-show=registryVm.showErrorMessages(registryForm.typeEvidence)> <div ng-message=required>El tipo de evidencia es requerido</div> </div> </div> </div> <div class=\"col-md-12 form-group p-t-12\" ng-if=registryVm.showUploader> <div class=\"p-b-md filetype_upload\"> <div class=\"col-md-6 text-left flex-row\"> <input type=file style=display:none nv-file-select=\"\" uploader=uploader accept={{registryVm.acceptFileType}} id=inputFileUpload /> <button type=button class=\"btn btn-primary md-raised m-b btn-fw\" ng-click=registryVm.openFileSelector() ng-if=\"registryVm.STATIC_IMAGE_URL && !registryVm.loading\"> <span class=\"glyphicon glyphicon-upload\"></span> Adjuntar Archivo </button> <div ng-if=registryVm.loading class=loader></div> <button type=button class=\"btn btn-danger md-raised m-b btn-fw\" ng-click=registryVm.remove() ng-if=\"!registryVm.STATIC_IMAGE_URL && !registryVm.loading\"> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> <div class=\"col-md-12 no-padding has-error text-left\"> <label class=control-label> {{registryVm.errorMsgFileType}} </label> </div> <div ng-if=registryVm.errorMsg class=\"col-md-12 has-error\"> <label class=control-label> Ha ocurrido un error con el archivo. Intente de nuevo. </label> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\"> <h4 class=\"text-negro font-bold\">Archivos Adjuntos</h4> <h4>{{registryVm.attachFile}}</h4> </div> </div> </div> <div ng-if=\"registryVm.itemConfig.idReflection == registryVm.registryId\"> <div class=\"col-md-3 form-group p-t-md\"> <md-checkbox class=\"no-margin md-green text-xxs\" type=checkbox ng-model=registryVm.blogIsEnlighted name=insumo ng-value=registryVm.blogIsEnlighted> Destacar Reflexión </md-checkbox> </div> <div class=\"col-md-3 form-group p-t-12\"> <md-button aria-label class=\"btn btn-fw btn-primary text-xxs\" ng-click=registryVm.showEvidencesToLink()>Enlazar Evidencia</md-button> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\"> <h5 class=\"text-negro font-bold\">Evidencias Enlazadas</h5> </div> <div class=\"col-md-6 m-v-sm no-padding\" ng-repeat=\"item in registryVm.evidencesLinks\"> <div class=\"col-md-8 p-h-xs text-left\"> {{item.title}} </div> <div class=\"col-md-4 no-padding text-right\"> <button type=button class=\"btn btn-danger btn-xs\" ng-click=registryVm.removeLink($index)> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\" ng-class=registryVm.hasError(registryForm.description)> <label class=control-label for=description>Descripción</label> <div ng-if=\"registryVm.itemConfig.idEvidence != registryVm.registryId\"> <md-input-container class=control-label> <textarea type=text class=form-control name=description rows=2 placeholder=\"Favor de ingresar una descripción\" ng-model=registryVm.description maxlength=10000 md-maxlength=10000 ng-model-options=\"{ debounce: 300 }\" required>\n\t\t\t\t\t\t</textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-left\" ng-messages=registryForm.description.$error ng-show=registryVm.showErrorMessages(registryForm.description)> <div ng-message=required> Debe agregar un descripción </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> <div ng-if=\"registryVm.itemConfig.idEvidence == registryVm.registryId\"> <md-input-container class=control-label> <textarea type=text class=form-control name=description rows=2 placeholder=\"Favor de ingresar una descripción\" ng-model=registryVm.description maxlength=1200 md-maxlength=1200 ng-model-options=\"{ debounce: 300 }\" required>\n\t\t\t\t\t\t</textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-left\" ng-messages=registryForm.description.$error ng-show=registryVm.showErrorMessages(registryForm.description)> <div ng-message=required> Debe agregar un descripción </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=registryVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"registryVm.validateForm(registryForm) || registryVm.disableButtonAdd\" ng-click=registryVm.addRegistry()>Agregar</md-button> </div> </div> </form> <form name=linkEvidenceForm ng-if=registryVm.isLinking> <div class=row> <div class=\"col-md-9 text-left m-t-sm\"> <p>Seleccione las evidencias que enlazará a la reflexión a crear</p> </div> <div class=\"col-md-3 text-right\"> <md-button aria-label class=\"btn btn-fw btn-primary text-xxs\" ng-click=registryVm.showAddEvidenceToLink()>Crear Nueva Evidencia</md-button> </div> <div class=\"col-md-12 search p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=registryVm.linkEvidenceFilter ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=Buscar... ng-change=registryVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=\"col-md-12 profile-cards\"> <div class=\"col-md-12 no-padding fixed-height-300\"> <div class=masonry-cols-4> <div class=\"col-md-12 masonry-break p-xs pointer\" ng-click=registryVm.setEvidence(evidence,$index) ng-model=registryVm.selectedEvidence ng-repeat=\"evidence in registryVm.evidences |\n                              filter: registryVm.linkEvidenceFilter\"> <div ng-class=evidence.isSelected class=\"card masonry-break\"> <div class=\"card-heading p-sm\"> <i class=\"icon mdi-image-image i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == registryVm.globalFileTypes.image\"></i> <i class=\"icon mdi-editor-insert-drive-file i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == registryVm.globalFileTypes.document\"></i> <i class=\"icon mdi-image-audiotrack i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == registryVm.globalFileTypes.audio\"></i> <i class=\"icon mdi-av-videocam i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == registryVm.globalFileTypes.video\"></i> <h6 ng-class=evidence.isSelected class=\"text-azul p-h-xs font-bold text-xs m-v-sm text-left\">{{evidence.blogTitle}}</h6> </div> <div class=clearfix></div> <div class=\"card-body p-sm text-left\"> <p>{{evidence.blogDescription}}</p> </div> </div> </div> </div> </div> </div> </div> <div class=row> <div ng-if=registryVm.errorMsgLinkEvidence class=\"text-center col-md-12 has-error\"> <label class=control-label> Debe seleccionar una evidencia </label> </div> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=registryVm.cancel()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-click=registryVm.linkEvidence()>Enlazar</md-button> </div> </div> </form> <form name=addingEvidenceForm ng-if=registryVm.isAddingEvidence> <div class=row> <div class=\"form-group col-md-4\"> <div class=\"text-left text-xs\" ng-class=registryVm.hasError(addingEvidenceForm.titleLinkEvidence)> <label class=control-label for=titleLinkEvidence>Titulo</label> <input class=form-control name=titleLinkEvidence ng-model=registryVm.titleLinkEvidence required/> <div class=\"control-label text-xs\" ng-messages=addingEvidenceForm.titleLinkEvidence.$error ng-show=registryVm.showErrorMessages(addingEvidenceForm.titleLinkEvidence)> <div ng-message=required>El titulo es requerido</div> </div> </div> </div> <div class=\"col-md-4 form-group\"> <div class=\"text-left text-xs\" ng-class=registryVm.hasError(addingEvidenceForm.fileType)> <label for=fileType class=control-label>Archivo</label> <select name=fileType ng-model=registryVm.fileTypeId ng-options=\"fileType.fileTypeId as fileType.fileTypeName\n                          for fileType in registryVm.fileTypes\" class=form-control ng-change=registryVm.setFilterUploader() required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=addingEvidenceForm.fileType.$error ng-show=registryVm.showErrorMessages(addingEvidenceForm.fileType)> <div ng-message=required>El tipo de archivo es requerido</div> </div> </div> </div> <div class=\"col-md-4 form-group\"> <div class=\"text-left text-xs\" ng-class=registryVm.hasError(addingEvidenceForm.typeEvidence)> <label for=typeEvidence class=control-label>Tipo de Evidencia</label> <select name=typeEvidence ng-model=registryVm.evidenceType ng-options=\"evidencesType.evidenceTypeId as evidencesType.evidenceTypeName\n                          for evidencesType in registryVm.evidencesTypes\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=addingEvidenceForm.typeEvidence.$error ng-show=registryVm.showErrorMessages(addingEvidenceForm.typeEvidence)> <div ng-message=required>El tipo de evidencia es requerido</div> </div> </div> </div> <div class=\"col-md-12 form-group p-t-12\" ng-if=registryVm.showUploader> <div class=\"p-b-md filetype_upload\"> <div class=\"col-md-6 text-left flex-row\"> <input type=file style=display:none nv-file-select=\"\" uploader=uploader accept={{registryVm.acceptFileType}} id=inputFileUpload2 /> <button type=button class=\"btn btn-primary md-raised m-b btn-fw\" ng-click=registryVm.openFileSelector() ng-if=\"registryVm.STATIC_IMAGE_URL && !registryVm.loading\"> <span class=\"glyphicon glyphicon-upload\"></span> Adjuntar Archivo </button> <div ng-if=registryVm.loading class=loader></div> <button type=button class=\"btn btn-danger md-raised m-b btn-fw\" ng-click=registryVm.remove() ng-if=\"!registryVm.STATIC_IMAGE_URL && !registryVm.loading\"> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> <div class=\"col-md-12 no-padding has-error text-left\"> <label class=control-label> {{registryVm.errorMsgFileType}} </label> </div> <div ng-if=registryVm.errorMsg class=\"col-md-12 has-error\"> <label class=control-label> Ha ocurrido un error con el archivo. Intente de nuevo. </label> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\"> <h5 class=\"text-negro font-bold\">Archivos Adjuntos</h5> <h5>{{registryVm.attachFile}}</h5> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\" ng-class=registryVm.hasError(addingEvidenceForm.descriptionLinkEvidence)> <label class=control-label for=descriptionLinkEvidence>Descripción</label> <md-input-container class=control-label> <textarea type=text class=form-control name=descriptionLinkEvidence rows=2 placeholder=\"Favor de ingresar una descripción\" ng-model=registryVm.descriptionLinkEvidence maxlength=1200 md-maxlength=1200 ng-model-options=\"{ debounce: 300 }\" required>\n              </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-left\" ng-messages=addingEvidenceForm.descriptionLinkEvidence.$error ng-show=registryVm.showErrorMessages(addingEvidenceForm.descriptionLinkEvidence)> <div ng-message=required> Debe agregar una descripción </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=registryVm.cancel()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"registryVm.validateForm(addingEvidenceForm) || registryVm.disableButtonAdd\" ng-click=registryVm.addLinkToReflection()>Agregar y Enlazar</md-button> </div> </div> </form> </md-dialog-content> </md-dialog> <style>.flex-row{display:flex}.mg-5{padding-left:5px}</style> ";

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-toolbar> <div class=\"md-toolbar-tools m-v-sm\"> <md-button class=md-icon-button ng-click=linksVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-center font-medium text-negro-darker\">Reflexiones Enlazadas</h4> </div> </md-toolbar> <md-dialog-content> <div class=row> <div class=\"col-md-12 horizontalDivider text-left p-v no-padding-h\"> <i class=\"icon mdi-image-image i-24 text-negro-opacity left m-r-sm\" ng-if=\"linksVm.evidence.blogFileType == linksVm.filetypes.image\"></i> <i class=\"icon mdi-editor-insert-drive-file i-24 text-negro-opacity left m-r-sm\" ng-if=\"linksVm.evidence.blogFileType == linksVm.filetypes.document\"></i> <i class=\"icon mdi-image-audiotrack i-24 text-negro-opacity left m-r-sm\" ng-if=\"linksVm.evidence.blogFileType == linksVm.filetypes.audio\"></i> <i class=\"icon mdi-av-videocam i-24 text-negro-opacity left m-r-sm\" ng-if=\"linksVm.evidence.blogFileType == linksVm.filetypes.video\"></i> {{linksVm.evidence.blogTitle}} </div> <div ng-model=linksVm.selectedReflection ng-repeat=\"reflection in linksVm.evidence.reflections\"> <div class=\"col-md-12 horizontalDivider p-v\"> <div class=\"col-md-8 text-left\"> {{reflection.reflectionTitle}} </div> <div class=\"col-md-4 text-right font-italic proxima\"> {{reflection.reflectionUpdated}} </div> </div> </div> </div> <div class=row> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=linksVm.close()>Cerrar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-toolbar> <div class=\"md-toolbar-tools p-v\"> <md-button class=md-icon-button ng-click=disableVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"row title\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>¿Está seguro que desea eliminar esta evidencia?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=disableVm.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=disableVm.disableEvidence()>Eliminar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=editEvidenceVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-center font-medium text-negro-darker\">Editar Evidencia</h4> </div> </md-toolbar> <md-dialog-content> <form name=registryForm> <div class=row> <div class=\"form-group col-md-4\"> <div class=\"text-left text-xs\" ng-class=editEvidenceVm.hasError(registryForm.title)> <label class=control-label for=title>Titulo</label> <input class=form-control name=title ng-model=editEvidenceVm.title required/> <div class=\"control-label text-xs\" ng-messages=registryForm.title.$error ng-show=editEvidenceVm.showErrorMessages(registryForm.title)> <div ng-message=required>El titulo es requerido</div> </div> </div> </div> <div class=\"col-md-4 form-group\"> <div class=\"text-left text-xs\" ng-class=editEvidenceVm.hasError(registryForm.fileType)> <label for=fileType class=control-label>Archivo</label> <select name=fileType ng-model=editEvidenceVm.fileTypeId ng-options=\"fileType.fileTypeId as fileType.fileTypeName \n                          for fileType in editEvidenceVm.fileTypes\" class=form-control ng-change=editEvidenceVm.setFilterUploader() required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=registryForm.fileType.$error ng-show=editEvidenceVm.showErrorMessages(registryForm.fileType)> <div ng-message=required>El tipo de archivo es requerido</div> </div> </div> </div> <div class=\"col-md-4 form-group\"> <div class=\"text-left text-xs\" ng-class=editEvidenceVm.hasError(registryForm.typeEvidence)> <label for=typeEvidence class=control-label>Tipo de Evidencia</label> <select name=typeEvidence ng-model=editEvidenceVm.evidenceType ng-options=\"evidencesType.evidenceTypeId as evidencesType.evidenceTypeName \n                          for evidencesType in editEvidenceVm.evidencesTypes\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=registryForm.typeEvidence.$error ng-show=editEvidenceVm.showErrorMessages(registryForm.typeEvidence)> <div ng-message=required>El tipo de evidencia es requerido</div> </div> </div> </div> <div class=\"col-md-12 form-group p-t-12\" ng-if=editEvidenceVm.showUploader> <div class=filetype_upload> <div class=\"col-md-6 no-padding\"> <input type=file nv-file-select=\"\" uploader=uploader accept={{editEvidenceVm.acceptFileType}} id=inputFileUpload2 /> </div> <div class=\"col-md-6 text-left\"> <button type=button class=\"btn btn-primary md-raised m-b btn-fw\" ng-click=uploader.queue[0].upload() ng-hide=\"editEvidenceVm.STATIC_IMAGE_URL || editEvidenceVm.loading\" ng-disabled=editEvidenceVm.disableButtonUpload> <span class=\"glyphicon glyphicon-upload\"></span> Adjuntar Archivo </button> <div ng-if=editEvidenceVm.loading class=loader></div> <button type=button class=\"btn btn-danger md-raised m-b btn-fw\" ng-click=editEvidenceVm.remove() ng-hide=!editEvidenceVm.STATIC_IMAGE_URL> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> <div class=\"col-md-12 no-padding has-error text-left\"> <label class=control-label> {{editEvidenceVm.errorMsgFileType}} </label> </div> <div ng-if=editEvidenceVm.errorMsg class=\"col-md-12 has-error\"> <label class=control-label> Ha ocurrido un error con el archivo. Intente de nuevo. </label> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\"> <h5 class=\"text-negro font-bold\">Archivos Adjuntos</h5> <p>{{editEvidenceVm.attachFile}}</p> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\" ng-class=editEvidenceVm.hasError(registryForm.description)> <label class=control-label for=description>Descripción</label> <md-input-container class=control-label> <textarea type=text class=form-control name=description rows=2 ng-model=editEvidenceVm.description maxlength=1200 md-maxlength=1200 ng-model-options=\"{ debounce: 300 }\" required>\n              </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-left\" ng-messages=registryForm.description.$error ng-show=editEvidenceVm.showErrorMessages(registryForm.description)> <div ng-message=required> Debe agregar una descripción </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=editEvidenceVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"editEvidenceVm.validateForm(registryForm) || editEvidenceVm.disableButtonAdd\" ng-click=editEvidenceVm.updateEvidence()>Editar Evidencia</md-button> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-toolbar> <div class=\"md-toolbar-tools m-v\"> <md-button class=md-icon-button ng-click=statementVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-center font-medium text-negro-darker\">Editar Statement</h4> </div> </md-toolbar> <md-dialog-content style=max-height:500px> <form name=registryForm> <div class=row> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\" ng-class=statementVm.hasError(registryForm.description)> <div class=\"form-group webeditor\" ng-class=statementVm.hasError(registryForm.description)> <div class=m-b-sm text-angular name=description ng-model=statementVm.description ta-toolbar=\"[\n                      ['bold','italics', 'underline'], \n                      ['justifyLeft', 'justifyCenter', 'justifyRight'], \n                      ['ul', 'quote', 'html'], \n                      ['insertImage', 'insertVideo','insertLink'], \n                      ['undo', 'redo']]\" required></div> <div class=control-label ng-messages=registryForm.description.$error ng-show=statementVm.showErrorMessages(registryForm.description)> <div ng-message=required>Este campo es requerido</div> </div> </div> </div> </div> <div class=\"col-md-12 form-group p-t-12\"> <div class=\"p-b-md filetype_upload\"> <div class=\"col-md-6 no-padding\"> <input type=file nv-file-select=\"\" uploader=uploader /> </div> <div class=\"col-md-6 text-left\"> <button type=button class=\"btn btn-primary md-raised m-b btn-fw\" ng-click=uploader.queue[0].upload() ng-hide=statementVm.loading> <span class=\"glyphicon glyphicon-upload\"></span> Adjuntar Archivo </button> <div ng-if=statementVm.loading class=loader></div> </div> <div ng-if=statementVm.errorMsg class=\"col-md-12 has-error\"> <label class=control-label> Ha ocurrido un error con el archivo. Intente de nuevo. </label> </div> </div> <div class=\"col-md-6 m-v-sm no-padding\" ng-repeat=\"item in statementVm.attachFile\"> <div class=\"col-md-8 p-h-xs text-left\"> {{item.filename}} </div> <div class=\"col-md-4 no-padding text-right\"> <button type=button class=\"btn btn-danger btn-xs\" ng-click=statementVm.remove($index)> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=statementVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-show=!statementVm.loading ng-disabled=statementVm.validateForm(registryForm) ng-click=statementVm.addStatement()>Agregar</md-button> </div> </div> </form> </md-dialog-content> </md-dialog>";

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=50 class=p-b-0> <md-toolbar> <div class=\"md-toolbar-tools p-v\"> <md-button class=md-icon-button ng-click=historyVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-center font-medium text-negro-darker\">Historial de Statements</h4> </div> </md-toolbar> <md-dialog-content style=height:70vh> <div class=row> <div ng-model=historyVm.selectedStatement ng-repeat=\"statement in historyVm.statements\"> <div class=\"col-md-12 horizontalDivider p-v\"> <div class=row> <div class=\"col-md-8 text-left pointer\" ng-click=historyVm.showStatement(statement)> {{statement.blogCreationDate}} </div> <div class=\"col-md-4 text-right\"> <i ng-class=historyVm.showDescription class=\"icon i-16 text-gris-dark right pointer\" ng-click=historyVm.showStatement(statement)></i> </div> </div> <div class=\"row dialog-statement\" ng-if=!statement.isHidden> <div class=col-md-12 ta-bind=text ng-model=statement.blogDescription ta-readonly=disabled></div> <div class=col-md-12 ng-if=\"statement.externalUrlFiles.length > 0\"> <h5 class=\"text-azul m-t\">Archivos Adjuntos</h5> </div> <div class=col-md-12 ng-repeat=\"file in statement.externalUrlFiles\"> <a ng-href={{file.externalUrlFile}} download={{file.filename}}>{{file.filename}}</a> </div> </div> </div> </div> </div> </md-dialog-content> <md-dialog-actions layout=column> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=historyVm.close()>Cerrar</md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-toolbar> <div class=\"md-toolbar-tools m-v\"> <md-button class=md-icon-button ng-click=commentDetailVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-lg text-center font-medium text-azul\">Evaluación de Portafolio<br><span class=\"text-negro-darker proxima text-md\">Comité Evaluador: {{commentDetailVm.comment.comiteeName}}</span> </h4></div> </md-toolbar> <md-dialog-content> <div class=row> <div class=\"col-md-12 text-left text-azul exo no-padding-h p-v-sm\"> Parámetros de Evaluación </div> <div class=\"col-md-12 text-left no-padding-h p-v-sm\"> {{commentDetailVm.comment.guidelineDescription}} </div> <div class=\"col-md-12 text-left text-azul p-v-sm no-padding-h\" ng-if=commentDetailVm.isOnEvaluation> Últimos cambios </div> <div class=\"col-md-12 text-left no-padding-h p-v-sm\" ng-if=commentDetailVm.isOnEvaluation> <div class=\"col-md-4 no-padding-h\" ng-repeat=\"user in commentDetailVm.comment.users\"> <div class=\"col-md-4 p-h-xs\"> <img class=\"img-responsive rounded image_profile_blog_comments align_left\" ng-src={{user.commentUserPicture}}> </div> <div class=\"col-md-8 no-padding-l m-t-sm\"> <span class=text-xs>{{user.commentUserName}}</span> </div> </div> </div> <div class=\"col-md-12 text-left exo text-azul p-v-sm no-padding-h\"> Evaluación </div> <div class=\"col-md-12 text-left no-padding-h p-v-sm\" ng-if=!commentDetailVm.isOnEvaluation> {{commentDetailVm.comment.commentDescription}} </div> <div class=row ng-if=!commentDetailVm.isOnEvaluation> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=commentDetailVm.close()>Cerrar</md-button> </div> </div> <form name=addCommentForm class=m-t-sm ng-if=commentDetailVm.isOnEvaluation> <div class=\"col-md-12 no-padding\" ng-class=commentDetailVm.hasError(addCommentForm.comment)> <textarea type=text class=form-control name=comment rows=5 ng-model=commentDetailVm.comment.commentDescription ng-model-options=\"{ debounce: 300 }\" required>\n            </textarea> <div class=control-label ng-messages=addCommentForm.comment.$error ng-show=commentDetailVm.showErrorMessages(addCommentForm.comment)> <div ng-message=required> No puede dejar este campo vacio </div> </div> </div> <div class=\"col-md-12 no-padding has-error\" ng-if=commentDetailVm.showErrorMsg> <div class=control-label> Favor comuníquese con el administrador del módulo para parametrizar la pauta de evaluación </div> </div> <div class=\"col-md-12 no-padding\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=commentDetailVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-primary\" ng-disabled=\"commentDetailVm.validateForm(addCommentForm) || commentDetailVm.disabledButton\" ng-click=commentDetailVm.save()>Guardar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"commentDetailVm.validateForm(addCommentForm) || commentDetailVm.disabledButton\" ng-click=commentDetailVm.publicComment()>Publicar</md-button> </div> </form> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=disableAccessVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-rojo>Eliminar Acceso </h3> <p class=m-t-md>¿Desea dejar de compartir su portafolio con <strong>\"{{ disableAccessVm.user.userName }}\"</strong> </p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=disableAccessVm.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-danger\" ng-click=disableAccessVm.disableAccess()>Eliminar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-toolbar class=\"m-v no-m-b\"> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=editReflectionVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 ng-if=editReflectionVm.isRegistry class=\"col-xs-12 text-center font-medium text-negro-darker\">Editar Reflexión</h4> <h4 ng-if=editReflectionVm.isLinking class=\"col-xs-12 text-center font-medium text-negro-darker\">Enlazar Evidencias</h4> </div> </md-toolbar> <md-dialog-content> <form name=registryForm ng-if=editReflectionVm.isRegistry> <div class=row> <div class=\"form-group col-md-4\"> <div class=\"text-left text-xs\" ng-class=editReflectionVm.hasError(registryForm.title)> <label class=control-label for=title>Titulo</label> <input class=form-control name=title ng-model=editReflectionVm.title required/> <div class=\"control-label text-xs\" ng-messages=registryForm.title.$error ng-show=editReflectionVm.showErrorMessages(registryForm.title)> <div ng-message=required>El titulo es requerido</div> </div> </div> </div> <div class=\"col-md-4 form-group p-t-md\"> <md-checkbox class=\"no-margin md-green text-xxs\" type=checkbox ng-model=editReflectionVm.blogIsEnlighted ng-click=\"editReflectionVm.blogIsEnlighted = (editReflectionVm.blogIsEnlighted == 1) ? 0 : 1\" ng-checked=\"editReflectionVm.blogIsEnlighted == 1\" name=enlighted> Destacar Reflexión </md-checkbox> </div> <div class=\"col-md-4 form-group p-t-12\"> <md-button aria-label class=\"btn btn-fw btn-primary text-xxs\" ng-click=editReflectionVm.showEvidencesToLink()>Enlazar Evidencia</md-button> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\"> <h5 class=\"text-negro font-bold\">Evidencias Enlazadas</h5> </div> <div class=\"col-md-6 m-v-sm no-padding\" ng-repeat=\"item in editReflectionVm.evidencesLinks\"> <div class=\"col-md-8 p-h-xs text-left\"> {{item.evidenceFileName}} </div> <div class=\"col-md-4 no-padding text-right\"> <button type=button class=\"btn btn-danger btn-xs\" ng-click=editReflectionVm.removeLink($index)> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\" ng-class=editReflectionVm.hasError(registryForm.description)> <label class=control-label for=description>Descripción</label> <md-input-container class=control-label> <textarea type=text class=form-control name=description rows=2 ng-model=editReflectionVm.description maxlength=10000 md-maxlength=10000 ng-model-options=\"{ debounce: 300 }\" required>\n              </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-left\" ng-messages=registryForm.description.$error ng-show=editReflectionVm.showErrorMessages(registryForm.description)> <div ng-message=required> Debe agregar una descripción </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=editReflectionVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"editReflectionVm.validateForm(registryForm) || editReflectionVm.disableButtonAdd\" ng-click=editReflectionVm.editReflection()>Guardar</md-button> </div> </div> </form> <form name=linkEvidenceForm ng-if=editReflectionVm.isLinking> <div class=row> <div class=\"col-md-9 text-left m-t-sm\"> <p> Seleccione las evidencias que enlazará a la reflexión a crear </p> </div> <div class=\"col-md-3 text-right\"> <md-button aria-label class=\"btn btn-fw btn-primary text-xxs\" ng-click=editReflectionVm.showAddEvidenceToLink()>Crear Nueva Evidencia</md-button> </div> <div class=\"col-md-12 search p-v-sm\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=editReflectionVm.linkEvidenceFilter ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=Buscar... ng-change=editReflectionVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> <div class=\"col-md-12 profile-cards\"> <div class=\"col-md-12 no-padding fixed-height-300\"> <div class=masonry-cols-4> <div class=\"col-md-12 p-xs masonry-break pointer\" ng-click=editReflectionVm.setEvidence(evidence,$index) ng-model=editReflectionVm.selectedEvidence ng-repeat=\"evidence in editReflectionVm.evidences | \n                              filter: editReflectionVm.linkEvidenceFilter\"> <div ng-class=evidence.isSelected class=\"card masonry-break\"> <div class=\"card-heading p-sm\"> <i class=\"icon mdi-image-image i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == editReflectionVm.globalFileTypes.image\"></i> <i class=\"icon mdi-editor-insert-drive-file i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == editReflectionVm.global|.document\"></i> <i class=\"icon mdi-image-audiotrack i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == editReflectionVm.globalFileTypes.audio\"></i> <i class=\"icon mdi-av-videocam i-28 text-negro-opacity left\" ng-if=\"evidence.blogFileType == editReflectionVm.globalFileTypes.video\"></i> <h6 ng-class=evidence.isSelected class=\"text-azul p-h-xs font-bold text-xs m-v-sm text-left\">{{evidence.blogTitle}}</h6> </div> <div class=clearfix></div> <div class=\"card-body p-sm text-left\"> {{evidence.blogDescription}} </div> </div> </div> </div> </div> </div> </div> <div class=row> <div ng-if=editReflectionVm.errorMsgLinkEvidence class=\"text-center col-md-12 has-error\"> <label class=control-label> Debe seleccionar una evidencia </label> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=editReflectionVm.cancel()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-click=editReflectionVm.linkEvidence()>Enlazar</md-button> </div> </div> </form> <div class=\"row title\" ng-if=editReflectionVm.isAddingEvidence> <div class=\"col-md-12 m-b\"> <h3 class=text-center>Crear Nueva Evidencia para Enlazar a Reflexión</h3> </div> </div> <form name=addingEvidenceForm ng-if=editReflectionVm.isAddingEvidence> <div class=row> <div class=\"form-group col-md-4\"> <div class=\"text-left text-xs\" ng-class=editReflectionVm.hasError(addingEvidenceForm.titleLinkEvidence)> <label class=control-label for=titleLinkEvidence>Titulo</label> <input class=form-control name=titleLinkEvidence ng-model=editReflectionVm.titleLinkEvidence required/> <div class=\"control-label text-xs\" ng-messages=addingEvidenceForm.titleLinkEvidence.$error ng-show=editReflectionVm.showErrorMessages(addingEvidenceForm.titleLinkEvidence)> <div ng-message=required>El titulo es requerido</div> </div> </div> </div> <div class=\"col-md-4 form-group\"> <div class=\"text-left text-xs\" ng-class=editReflectionVm.hasError(addingEvidenceForm.fileType)> <label for=fileType class=control-label>Archivo</label> <select name=fileType ng-model=editReflectionVm.fileTypeId ng-options=\"fileType.fileTypeId as fileType.fileTypeName \n                          for fileType in editReflectionVm.fileTypes\" class=form-control ng-change=editReflectionVm.setFilterUploader() required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=addingEvidenceForm.fileType.$error ng-show=editReflectionVm.showErrorMessages(addingEvidenceForm.fileType)> <div ng-message=required>El tipo de archivo es requerido</div> </div> </div> </div> <div class=\"col-md-4 form-group\"> <div class=\"text-left text-xs\" ng-class=editReflectionVm.hasError(addingEvidenceForm.typeEvidence)> <label for=typeEvidence class=control-label>Tipo de Evidencia</label> <select name=typeEvidence ng-model=editReflectionVm.evidenceType ng-options=\"evidencesType.evidenceTypeId as evidencesType.evidenceTypeName \n                          for evidencesType in editReflectionVm.evidencesTypes\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=addingEvidenceForm.typeEvidence.$error ng-show=editReflectionVm.showErrorMessages(addingEvidenceForm.typeEvidence)> <div ng-message=required>El tipo de evidencia es requerido</div> </div> </div> </div> <div class=\"col-md-12 form-group p-t-12\" ng-if=editReflectionVm.showUploader> <div class=\"p-b-md filetype_upload\"> <div class=\"col-md-6 no-padding\"> <input type=file nv-file-select=\"\" uploader=uploader accept={{editReflectionVm.acceptFileType}} id=inputFileUpload /> </div> <div class=\"col-md-6 text-left\"> <button type=button class=\"btn btn-primary md-raised m-b btn-fw\" ng-click=uploader.queue[0].upload() ng-hide=\"editReflectionVm.STATIC_IMAGE_URL || editReflectionVm.loading\" ng-disabled=editReflectionVm.disableButtonUpload> <span class=\"glyphicon glyphicon-upload\"></span> Adjuntar Archivo </button> <div ng-if=editReflectionVm.loading class=loader></div> <button type=button class=\"btn btn-danger md-raised m-b btn-fw\" ng-click=editReflectionVm.remove() ng-hide=!editReflectionVm.STATIC_IMAGE_URL> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> <div class=\"col-md-12 no-padding has-error text-left\"> <label class=control-label> {{editReflectionVm.errorMsgFileType}} </label> </div> <div ng-if=editReflectionVm.errorMsg class=\"col-md-12 has-error\"> <label class=control-label> Ha ocurrido un error con el archivo. Intente de nuevo. </label> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\"> <h4 class=\"text-negro font-bold\">Archivos Adjuntos</h4> <h4>{{editReflectionVm.attachFile}}</h4> </div> </div> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\" ng-class=editReflectionVm.hasError(addingEvidenceForm.descriptionLinkEvidence)> <label class=control-label for=descriptionLinkEvidence>Descripción</label> <md-input-container class=control-label> <textarea type=text class=form-control name=descriptionLinkEvidence rows=2 ng-model=editReflectionVm.descriptionLinkEvidence maxlength=1200 md-maxlength=1200 ng-model-options=\"{ debounce: 300 }\" required>\n              </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-left\" ng-messages=addingEvidenceForm.descriptionLinkEvidence.$error ng-show=editReflectionVm.showErrorMessages(addingEvidenceForm.descriptionLinkEvidence)> <div ng-message=required> Debe agregar una descripción </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=editReflectionVm.cancel()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"editReflectionVm.validateForm(addingEvidenceForm) || \n                                  editReflectionVm.disableButtonAdd\" ng-click=editReflectionVm.addLinkToReflection()>Agregar y Enlazar</md-button> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-toolbar class=\"m-v no-m-b\"> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=deleteReflectionVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <span flex></span> <h4 class=\"col-xs-12 text-center font-medium text-negro-darker\">Eliminar Reflexión</h4> </div> </md-toolbar> <md-dialog-content> <form name=registryForm> <div class=row> <div class=col-md-12> <div class=\"text-left text-xs\" ng-class=editReflectionVm.hasError(registryForm.title)> <h5 class=\"text-negro font-bold\">Título</h5> <p class=text-md>{{deleteReflectionVm.reflection.blogTitle}}</p> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=\"text-left m-t-sm\"> <h5 class=\"text-negro font-bold\">Evidencias Enlazadas</h5> </div> <div class=\"col-md-6 m-s-v no-padding\" ng-repeat=\" item in deleteReflectionVm.evidencesLinks\"> <div class=\"col-md-8 p-h-xs text-left\"> {{item.evidenceFileName}} </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 form-group\"> <div class=\"text-left m-t-sm\"> <label class=control-label for=\"\">Descripción</label> <br> <md-input-container class=control-label> <textarea type=text class=form-control name=description rows=2 readonly=readonly maxlength=10000>{{deleteReflectionVm.reflection.blogDescription}}\n\t\t\t\t\t\t\t</textarea> </md-input-container> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=deleteReflectionVm.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-click=deleteReflectionVm.deleteReflection()>Eliminar</md-button> </div> </div> </form> </md-dialog-content> </md-dialog>";

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=guidelineVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 m-b\"> <h3 class=\"text-center text-azul\">Ver detalle - {{guidelineVm.guideline.title}} </h3> <h6 class=text-center>{{guidelineVm.guideline.text}} </h6> </div> </div> <div class=row> <div class=\"col-md-12 p-v text-left\"> {{guidelineVm.guideline.description}} </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=guidelineVm.close()>Cerrar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GlobalSrv = function GlobalSrv($resource, SERVICE_URL_CONSTANT, WorkPlanSrv, $cookies) {
	  _classCallCheck(this, GlobalSrv);
	
	  // Other Services
	  var roles = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
	    getAccessModules: {
	      method: 'GET',
	      params: {
	        type: 'subject',
	        route: 'getEvaluatorAssingnedSubmodule'
	      }
	    }
	  });
	
	  var getUserInfo = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getTeacherIdByUserId', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getUserInbox = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getNotificationsInbox', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getScheduledInbox = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getScheduledNotificationsInbox', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getPerfilDash = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/perfil_dash/:teacherId', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getUserImage = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getUserImage/:identification', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getUserInboxAllNoRead = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getUserInboxAllNoRead', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var updateNotificationReadingMessagesUserInbox = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/updateNotificationReadingMessagesUserInbox', {}, {
	    update: {
	      method: 'POST'
	    }
	  });
	
	  var getCountNotificationsUserInboxNoRead = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getCountNotificationsUserInboxNoRead', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	
	  var getUserByRol = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getUserByRol', {}, {
	    get: {
	      method: 'POST'
	    }
	  });
	  var getChangeRole = $resource(SERVICE_URL_CONSTANT.userApi + '/api/user-api/changerole', {}, {
	    get: {
	      method: 'GET'
	    }
	  });
	
	  var getElementsRightBar = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getWorkPlanGeneral', {}, {
	    getList: {
	      method: 'POST'
	    }
	  });
	
	  var addNotificationToAdminWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsToAdminWorkPlan', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var addNotificationToMainEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationToMainEvaluator', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var addNotificationToReviewers = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationToReviewers', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var addNotificationsToAdminByTeacherAM = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsToAdminByTeacherAM', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var addNotificationsEvaluatorsSubmodule = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsEvaluatorsSubmodule', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var addNotificationsToAdminEvaluator = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsToAdminEvaluator', {}, {
	    add: {
	      method: 'POST'
	    }
	  });
	
	  var getUserInfoMetta = $resource(SERVICE_URL_CONSTANT.userApi + '/api/user-api/getUserInfo', {}, {
	    POST: {
	      method: 'POST'
	    }
	  });
	
	  var jobForeachPureApi = $resource(SERVICE_URL_CONSTANT.rosario + '/report/jobForeachPureApi', {}, {
	    execute: {
	      method: 'GET'
	    }
	  });
	
	  function subscribe(scope, root, message, callback) {
	    var handler = root.$on(message, function (event, data) {
	      callback(data);
	    });
	    scope.$on('$destroy', handler);
	  }
	
	  function notify(root, message, object) {
	    root.$emit(message, object);
	  }
	
	  function sendNotification(data) {
	    WorkPlanSrv.addNotificationsTransactions.add(data).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        console.log('Notificación exitosa', dataReturn);
	      } else {
	        console.log('Error de comunicación en la notificación');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function sendNotificationAdmin(data) {
	    WorkPlanSrv.addNotificationsTransactionsToAdmin.add(data).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        console.log('Notificación exitosa', dataReturn);
	      } else {
	        console.log('Error de comunicación en la notificación');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function sendNotificationToMainEvaluator(data) {
	    addNotificationToMainEvaluator.add(data).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        console.log('Notificación exitosa', dataReturn);
	      } else {
	        console.log('Error de comunicación en la notificación');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function sendNotificationAdminAM(data) {
	    addNotificationsToAdminByTeacherAM.add(data).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        console.log('Notificación exitosa', dataReturn);
	      } else {
	        console.log('Error de comunicación en la notificación');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function sendNotificationToReviewers(data) {
	    addNotificationToReviewers.add(data).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        console.log('Notificación exitosa', dataReturn);
	      } else {
	        console.log('Error de comunicación en la notificación');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function sendNotificationsEvaluatorsSubmodule(data) {
	    addNotificationsEvaluatorsSubmodule.add(data).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        console.log('Notificación exitosa', dataReturn);
	      } else {
	        console.log('Error de comunicación en la notificación');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function sendNotificationsToAdminEvaluator(data) {
	    addNotificationsToAdminEvaluator.add(data).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        console.log('Notificación exitosa', dataReturn);
	      } else {
	        console.log('Error de comunicación en la notificación');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getReviewers(idRole) {
	    var reviewers = void 0;
	    try {
	      reviewers = JSON.parse($cookies.get('reviewers'));
	    } catch (e) {
	      reviewers = [];
	    }
	    var evaluators = [];
	    var evaluator = '';
	    for (var index in reviewers) {
	      if (reviewers[index].idRole === idRole) {
	        if (evaluator != reviewers[index].idEvaluator) {
	          evaluators.push(reviewers[index].idEvaluator);
	          evaluator = reviewers[index].idEvaluator;
	        }
	      }
	    }
	    return evaluators;
	  }
	
	  function getReviewersAndEvaluator() {
	    var reviewers = void 0;
	    try {
	      reviewers = JSON.parse($cookies.get('reviewers'));
	    } catch (e) {
	      reviewers = [];
	    }
	    var evaluators = [];
	    var evaluator = '';
	    for (var index in reviewers) {
	      if (evaluator != reviewers[index].idEvaluator) {
	        evaluators.push(reviewers[index].idEvaluator);
	        evaluator = reviewers[index].idEvaluator;
	      }
	    }
	    return evaluators;
	  }
	
	  function getReviewerbySubmodule(idRole, idSubmodule) {
	    var reviewers = void 0;
	    var reviewersToSend = [];
	    try {
	      reviewers = JSON.parse($cookies.get('reviewers'));
	    } catch (e) {
	      reviewers = [];
	    }
	    if (idSubmodule) {
	      reviewers.forEach(function (reviewer) {
	        if (reviewer.idRole === idRole && reviewer.idSubmodule === idSubmodule) {
	          reviewersToSend.push(reviewer.idEvaluator);
	        }
	      });
	    } else {
	      reviewers.forEach(function (reviewer) {
	        if (reviewer.idRole === idRole) {
	          reviewersToSend.push(reviewer.idEvaluator);
	        }
	      });
	    }
	    if (reviewersToSend.length > 0) {
	      return reviewersToSend;
	    } else {
	      return false;
	    }
	  }
	
	  return {
	    getUserInfo: getUserInfo,
	    getUserInbox: getUserInbox,
	    getScheduledInbox: getScheduledInbox,
	    getUserInboxAllNoRead: getUserInboxAllNoRead,
	    updateNotificationReadingMessagesUserInbox: updateNotificationReadingMessagesUserInbox,
	    getCountNotificationsUserInboxNoRead: getCountNotificationsUserInboxNoRead,
	    subscribe: subscribe,
	    getChangeRole: getChangeRole,
	    notify: notify,
	    roles: roles,
	    sendNotification: sendNotification,
	    getElementsRightBar: getElementsRightBar,
	    getReviewers: getReviewers,
	    getReviewerbySubmodule: getReviewerbySubmodule,
	    getUserByRol: getUserByRol,
	    sendNotificationAdmin: sendNotificationAdmin,
	    addNotificationToAdminWorkPlan: addNotificationToAdminWorkPlan,
	    sendNotificationToMainEvaluator: sendNotificationToMainEvaluator,
	    sendNotificationToReviewers: sendNotificationToReviewers,
	    getReviewersAndEvaluator: getReviewersAndEvaluator,
	    sendNotificationAdminAM: sendNotificationAdminAM,
	    sendNotificationsEvaluatorsSubmodule: sendNotificationsEvaluatorsSubmodule,
	    sendNotificationsToAdminEvaluator: sendNotificationsToAdminEvaluator,
	    getUserInfoMetta: getUserInfoMetta,
	    jobForeachPureApi: jobForeachPureApi,
	    getPerfilDash: getPerfilDash,
	    getUserImage: getUserImage
	  };
	};
	
	GlobalSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT', 'WorkPlanSrv', '$cookies'];
	exports.default = angular.module('services.GlobalSrv', []).service('GlobalSrv', GlobalSrv).name;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MyPortfolioCtrl = function MyPortfolioCtrl($scope, $stateParams, $timeout, GlobalSrv, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService, $interval) {
		_classCallCheck(this, MyPortfolioCtrl);
	
		// constants
		var config = __webpack_require__(159);
		var staticServerurl = config.STATIC_IMAGE_URL;
		var portfolioVm = this;
	
		portfolioVm.actualStatement = {};
		portfolioVm.actualStatement.blogDescription = '';
		var currentUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : null;
		portfolioVm.years = [];
		portfolioVm.evidences = [];
		portfolioVm.reflections = [];
		portfolioVm.filetypes = GlobalConfig.portfolioConfig.fileTypes;
	
		portfolioVm.comments = [];
	
		var SEARCH_PARAMS = {};
		var haveGuest = $stateParams.haveGuest;
		var isOnEvaluation = $stateParams.isOnEvaluation;
		var isExternal = $stateParams.isExternal;
	
		portfolioVm.haveGuest = false;
		portfolioVm.isOnEvaluation = isOnEvaluation ? true : false;
		portfolioVm.isExternal = isExternal ? true : false;
	
		portfolioVm.mathId = Math.random();
	
		$interval(function (e) {
			portfolioVm.mathId = Math.random();
		}, 2000);
	
		//console.log($stateParams)
		if (haveGuest) {
			if (isExternal) {
				SEARCH_PARAMS.guestUser = parseInt($stateParams.ownerPortfolio);
				SEARCH_PARAMS.userId = SEARCH_PARAMS.guestUser;
			} else {
				SEARCH_PARAMS.guestUser = currentUser ? currentUser.id : null;
				SEARCH_PARAMS.userId = $cookies.get('ownerPortfolio');
			}
	
			portfolioVm.haveGuest = true;
			portfolioVm.mainText = portfolioVm.isOnEvaluation ? 'Evaluar Portafolio' : 'Otros Portafolios';
		} else {
			SEARCH_PARAMS.userId = currentUser ? currentUser.id : null;
			SEARCH_PARAMS.guestUser = SEARCH_PARAMS.userId;
			portfolioVm.haveGuest = false;
			portfolioVm.mainText = 'Mi Portafolio';
		}
	
		portfolioVm.selectedYear = moment().year();
		portfolioVm.evaluator = {};
	
		portfolioVm.selectedReflection = {};
		portfolioVm.selectedOrderReflection = '';
		portfolioVm.filtersOrderReflections = [{ filterId: '', filterName: ' ' }, { filterId: 'blogTitle', filterName: 'Título Ascendiente' }, { filterId: '-blogTitle', filterName: 'Título Descendiente' }, { filterId: 'blogUpdatedDate', filterName: 'Fecha Ascendiente' }, { filterId: '-blogUpdatedDate', filterName: 'Fecha Descendiente' }];
	
		portfolioVm.selectedIsEnlightedFilter = '';
		portfolioVm.isEnlightedFilter = [{ filterId: '', filterName: ' ' }, { filterId: 1, filterName: 'Destacadas' }, { filterId: 0, filterName: 'No Destacadas' }];
	
		portfolioVm.selectedFilterEvidence = '';
		portfolioVm.filtersEvidences = [{ filterId: '', filterName: ' ' }, { filterId: portfolioVm.filetypes.image, filterName: 'Imagenes' }, { filterId: portfolioVm.filetypes.video, filterName: 'Videos' }, { filterId: portfolioVm.filetypes.audio, filterName: 'Audios' }, { filterId: portfolioVm.filetypes.document, filterName: 'Documentos' }];
	
		portfolioVm.selectedOrderEvidence = '';
		portfolioVm.filtersOrderEvidences = [{ filterId: '', filterName: ' ' }, { filterId: 'blogTitle', filterName: 'Título Ascendiente' }, { filterId: '-blogTitle', filterName: 'Título Descendiente' }, { filterId: 'blogUpdatedDate', filterName: 'Fecha Ascendiente' }, { filterId: '-blogUpdatedDate', filterName: 'Fecha Descendiente' }];
	
		portfolioVm.addUserComment = addUserComment;
		portfolioVm.addReflectionComment = addReflectionComment;
		portfolioVm.addNewRegistry = addNewRegistry;
		portfolioVm.setEnlighted = setEnlighted;
		portfolioVm.setInput = setInput;
		portfolioVm.evidenceLinks = evidenceLinks;
		portfolioVm.disableEvidence = disableEvidence;
		portfolioVm.editEvidence = editEvidence;
		portfolioVm.editStatement = editStatement;
		portfolioVm.historyStatement = historyStatement;
		portfolioVm.getPortfolioBasics = getPortfolioBasics;
		portfolioVm.commentDetails = commentDetails;
		portfolioVm.evalComment = evalComment;
		portfolioVm.editReflection = editReflection;
		portfolioVm.deleteReflection = deleteReflection;
	
		$scope.notPicture = __webpack_require__(294);
	
		//initial functions
	
		function activate() {
			portfolioVm.getPortfolioBasics();
			getPortfolioComitee();
		}
	
		function getYears(actualYear, initialYear) {
			var time = actualYear - initialYear + 1;
	
			var array = [];
	
			for (var i = 0; i < time; i++) {
				array.push(actualYear - i);
			}
	
			return array;
		}
	
		$scope.onUserPictureError = function (callback) {
			$scope.picture = $scope.notPicture;
	
			if ($scope.rut) {
				GlobalSrv.getUserImage.get({ identification: $scope.rut }).$promise.then(function (response) {
					$scope.pictureRosario = response.profilePicture + '?1=' + $scope.mathRandom;
					callback && callback();
				});
			} else {
				callback && callback();
			}
		};
	
		activate();
		//methods
		function getPortfolioBasics() {
			var header = {
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			$scope.mathRandom = Math.random();
			$scope.picture = $scope.notPicture;
	
			if (!haveGuest) {
				$scope.rut = currentUser && currentUser.dsIdentification ? currentUser.dsIdentification : '';
	
				if (currentUser && currentUser.pictureExtension) {
					$scope.picture = staticServerurl + '/profilepicture/' + currentUser.pictureExtension + '?1=' + $scope.mathRandom;
				} else if (currentUser && currentUser.pictureRosario) {
					$scope.picture = currentUser.pictureRosario;
				} else {
					$scope.onUserPictureError();
				}
			}
	
			PortfolioSrv.getPortfolioBasics.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.profesor = dataReturn.profesorData || {};
	
					if (!portfolioVm.years.length) {
						portfolioVm.years = getYears(portfolioVm.selectedYear, portfolioVm.profesor.initialYear || 2017);
					}
	
					if (haveGuest) {
						$scope.rut = portfolioVm.profesor.identification;
						$scope.picture = staticServerurl + '/profilepicture/' + portfolioVm.profesor.pictureExtension + '?1=' + $scope.mathRandom;
					}
	
					portfolioVm.profesor.lastUpdate = moment(portfolioVm.profesor.lastUpdate).format('DD/MM/YYYY');
					portfolioVm.statements = dataReturn.statementsData;
	
					if (portfolioVm.statements.length > 0) {
						for (var i = portfolioVm.statements.length - 1; i >= 0; i--) {
							portfolioVm.statements[i].blogDescription = portfolioVm.statements[i].blogDescription.replaceAll('>?', '>');
						}
						portfolioVm.actualStatement = portfolioVm.statements[0];
					} else {
						portfolioVm.actualStatement = {};
					}
	
					portfolioVm.evidences = dataReturn.evidencesData;
					portfolioVm.reflections = dataReturn.reflectionsData;
					portfolioVm.commentsUsers = dataReturn.commentsData.commentsUsers;
					portfolioVm.commentsEvals = dataReturn.commentsData.commentsEvals;
					for (var r in portfolioVm.reflections) {
						portfolioVm.reflections[r].current = moment(portfolioVm.reflections[r].blogCreationDate, 'DD/MM/YYYY').isSame(new Date(), 'year');
					}
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function getPortfolioComitee() {
			if (portfolioVm.isOnEvaluation) {
				var header = {
					userId: SEARCH_PARAMS.guestUser
				};
	
				PortfolioSrv.getPortfolioComitee.get(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						portfolioVm.evaluator = dataReturn.data;
					}
				}, function (data) {
					console.log(data);
				});
			}
		}
	
		function setEnlighted(reflection) {
			if (!portfolioVm.isOnEvaluation && !portfolioVm.haveGuest) {
				var previous = reflection.blogIsEnlighted;
	
				if (previous == 0) {
					reflection.blogIsEnlighted = 1;
				} else {
					reflection.blogIsEnlighted = 0;
				}
	
				var header = {
					reflectionId: reflection.blogId,
					isEnlighted: reflection.blogIsEnlighted
				};
	
				PortfolioSrv.setEnlighted.update(header).$promise.then(function (dataReturn) {
					if (!dataReturn.status) {
						reflection.blogIsEnlighted = previous;
					}
				}, function (data) {
					console.log(data);
				});
			}
		}
	
		function setInput(reflection) {
			var previous = reflection.blogIsInput;
	
			if (previous == 0) {
				reflection.blogIsInput = 1;
			} else {
				reflection.blogIsInput = 0;
			}
	
			var header = {
				reflectionId: reflection.blogId,
				isInput: reflection.blogIsInput
			};
	
			PortfolioSrv.setInput.update(header).$promise.then(function (dataReturn) {
				if (!dataReturn.status) {
					reflection.isInput = previous;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function updateUsersComments() {
			var header = {
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioSrv.getCommentsUsers.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.commentsUsers = dataReturn.data;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function updateEvalsComments() {
			var header = {
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioSrv.getCommentsEvals.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.commentsEvals = dataReturn.data;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function getEvidences() {
			var header = {
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.evidences = dataReturn.data;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function getStatements() {
			var header = {
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioSrv.getStatements.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.statements = dataReturn.data;
	
					if (portfolioVm.statements.length > 0) {
						for (var i = portfolioVm.statements.length - 1; i >= 0; i--) {
							portfolioVm.statements[i].blogDescription = portfolioVm.statements[i].blogDescription.replaceAll('>?', '>');
						}
						portfolioVm.actualStatement = portfolioVm.statements[0];
					} else {
						portfolioVm.actualStatement = {};
					}
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function getReflections() {
			var header = {
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioSrv.getReflections.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					portfolioVm.reflections = dataReturn.data;
					for (var r in portfolioVm.reflections) {
						portfolioVm.reflections[r].current = moment(portfolioVm.reflections[r].blogCreationDate, 'DD/MM/YYYY').isSame(new Date(), 'year');
					}
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function updateReflectionComments(reflection) {
			var header = {
				reflectionId: reflection.blogId
			};
	
			PortfolioSrv.getReflectionCommentById.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					reflection.comments = dataReturn.data;
					reflection.totalComments = reflection.comments.length;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		// modals
		function addUserComment() {
			var header = SEARCH_PARAMS;
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.addUserComment().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					updateUsersComments();
				}
			});
		}
	
		function addReflectionComment(reflection) {
			var header = {
				guestUser: SEARCH_PARAMS.guestUser,
				reflection: reflection,
				isExternal: isExternal
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.addReflectionComment().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					updateReflectionComments(reflection);
				}
			});
		}
	
		function addNewRegistry() {
			var header = {
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.addNewRegistry().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					activate();
				}
			});
		}
	
		function evidenceLinks(evidence) {
			var header = {
				evidence: evidence
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.evidenceLinks().then(function (promise) {});
		}
	
		function disableEvidence(evidence) {
			var header = {
				evidence: evidence
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.disableEvidence().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					getEvidences();
				}
			});
		}
	
		function editEvidence(evidence) {
			var header = {
				evidence: evidence
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.editEvidence().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					getEvidences();
				}
			});
		}
	
		function editStatement(statement) {
			var header = {
				userId: SEARCH_PARAMS.guestUser,
				statement: statement
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.editStatement().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					getStatements();
				}
			});
		}
	
		function historyStatement() {
			var header = {
				statements: portfolioVm.statements
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.historyStatement().then(function (promise) {});
		}
	
		function commentDetails(comment) {
			var header = {
				comment: comment
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.commentDetails().then(function (promise) {});
		}
	
		function evalComment() {
			var header = {
				comment: null,
				guestUser: SEARCH_PARAMS.guestUser,
				userId: SEARCH_PARAMS.userId,
				isOnEvaluation: portfolioVm.isOnEvaluation,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000'),
				evaluator: portfolioVm.evaluator
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.commentDetails().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					updateEvalsComments();
				}
			});
		}
	
		function editReflection(reflection) {
			var header = {
				reflection: reflection,
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.editReflection().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					getReflections();
					getEvidences();
				}
			});
		}
	
		function deleteReflection(reflection) {
			var header = {
				reflection: reflection,
				userId: SEARCH_PARAMS.userId,
				startDate: moment(portfolioVm.selectedYear + '-01-01T00:00:00.000'),
				endDate: moment(portfolioVm.selectedYear + '-12-31T23:59:59.000')
			};
	
			PortfolioModalSrv.setVariable(header);
			PortfolioModalSrv.deleteReflection().then(function (promise) {
				var shared = PortfolioModalSrv.getVariable();
	
				if (shared.status) {
					getReflections();
					getEvidences();
				}
			});
		}
	
		String.prototype.replaceAll = function (searchStr, replaceStr) {
			var str = this;
	
			if (str.indexOf(searchStr) === -1) return str;
	
			return str.replace(searchStr, replaceStr).replaceAll(searchStr, replaceStr);
		};
	};
	
	exports.default = MyPortfolioCtrl;
	
	
	MyPortfolioCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'GlobalSrv', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', '$cookies', '$state', 'ngYoutubeEmbedService', '$interval'];

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SharedPortfolioCtrl = function SharedPortfolioCtrl($scope, $location, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, GlobalSrv) {
	  _classCallCheck(this, SharedPortfolioCtrl);
	
	  // constants
	  var sharedPortfolioVm = this;
	
	  sharedPortfolioVm.userId = JSON.parse($cookies.get('currentUser')).id;
	  sharedPortfolioVm.userName = JSON.parse($cookies.get('currentUser')).name;
	  sharedPortfolioVm.dsFullname = JSON.parse($cookies.get('currentUser')).dsFullname;
	  var ownerPortfolio = {
	    userId: sharedPortfolioVm.userId
	  };
	  var msgInvalids = ['Debe seleccionar un usuario de la lista', 'No puede seleccionar usuarios repetidos'];
	
	  //variables
	  sharedPortfolioVm.usersWithSharedPermission = [];
	  sharedPortfolioVm.arrayOfUsers = [];
	  sharedPortfolioVm.selectedSharedUser = null;
	  sharedPortfolioVm.searchText = '';
	  sharedPortfolioVm.invalidText = false;
	  sharedPortfolioVm.msgInvalidText = msgInvalids[0];
	  sharedPortfolioVm.sharedLink = $location.absUrl().replace('sharedPortfolio', 'public?ownerPortfolio=' + sharedPortfolioVm.userId + '&external');
	  sharedPortfolioVm.disableButton = false;
	
	  //methods
	  sharedPortfolioVm.searchUsers = searchUsers;
	  sharedPortfolioVm.setUser = setUser;
	  sharedPortfolioVm.validateForm = validateForm;
	  sharedPortfolioVm.changeSharedUser = changeSharedUser;
	  sharedPortfolioVm.cleanForm = cleanForm;
	  sharedPortfolioVm.addSharedUsers = addSharedUsers;
	  sharedPortfolioVm.showConfirmDialog = showConfirmDialog;
	
	  activate();
	
	  function activate() {
	    getSharedPortfolioUsers();
	  }
	
	  function getSharedPortfolioUsers() {
	    PortfolioSrv.getSharedPortfolioUsers.get(ownerPortfolio).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        sharedPortfolioVm.usersWithSharedPermission = dataReturn.usersWithSharedPermission;
	        sharedPortfolioVm.usersToShared = dataReturn.usersToShared;
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function searchUsers(searchText) {
	    var matcher = new RegExp(searchText, 'i');
	    var arr = [];
	    var attr = "ds_fullname";
	    sharedPortfolioVm.usersToShared.forEach(function (list) {
	      if (list[attr].match(matcher)) {
	        arr.push(list);
	      }
	    });
	    return arr;
	  }
	
	  function changeSharedUser() {
	    sharedPortfolioVm.invalidText = false;
	  }
	
	  function setUser() {
	    if (sharedPortfolioVm.selectedSharedUser) {
	      var index = getIndex(sharedPortfolioVm.selectedSharedUser);
	      if (index < 0) {
	        sharedPortfolioVm.arrayOfUsers.push(sharedPortfolioVm.selectedSharedUser);
	        sharedPortfolioVm.selectedSharedUser = null;
	        sharedPortfolioVm.searchText = '';
	        sharedPortfolioVm.invalidText = false;
	        sharedPortfolioVm.msgInvalidText = msgInvalids[0];
	      } else {
	        sharedPortfolioVm.invalidText = true;
	        sharedPortfolioVm.msgInvalidText = msgInvalids[1];
	      }
	    } else {
	      sharedPortfolioVm.invalidText = true;
	    }
	  }
	
	  function getIndex(user) {
	    for (var i = sharedPortfolioVm.arrayOfUsers.length - 1; i >= 0; i--) {
	      if (sharedPortfolioVm.arrayOfUsers[i].id_code == user.id_code) {
	        return i;
	      }
	    }
	    return -1;
	  }
	
	  function getNotify(idUser, name) {
	    getSendNotify(idUser, name);
	  }
	
	  function getSendNotify(idUser, name) {
	    var postEmail = {
	      idUser: idUser,
	      dsName: 'Notificación de portafolio compartido',
	      dsDescription: 'El profesor ' + name + ' ha compartido su portafolio con usted',
	      idNotification_delivery_type: GlobalConfig.notificationType.email,
	      is_grouped: 0
	    };
	    var postInbox = {
	      idUser: idUser,
	      dsName: 'Notificación de portafolio compartido',
	      dsDescription: 'El profesor ' + name + ' ha compartido su portafolio con usted',
	      idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	      is_grouped: 0
	    };
	    GlobalSrv.sendNotification(postEmail);
	    GlobalSrv.sendNotification(postInbox);
	  }
	
	  function addSharedUsers() {
	    sharedPortfolioVm.disableButton = true;
	    var header = {
	      idOwner: ownerPortfolio.userId,
	      usersArray: sharedPortfolioVm.arrayOfUsers
	    };
	    PortfolioSrv.addSharedUsers.add(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        for (var i = 0; i < sharedPortfolioVm.arrayOfUsers.length; i++) {
	          getNotify(sharedPortfolioVm.arrayOfUsers[i].id_code, sharedPortfolioVm.dsFullname);
	        }
	        cleanForm();
	        activate();
	      }
	      sharedPortfolioVm.disableButton = false;
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  //forms    
	  function validateForm() {
	    return sharedPortfolioVm.searchText == '' || sharedPortfolioVm.invalidText;
	  }
	
	  function cleanForm() {
	    sharedPortfolioVm.selectedSharedUser = null;
	    sharedPortfolioVm.searchText = '';
	    sharedPortfolioVm.invalidText = false;
	    sharedPortfolioVm.arrayOfUsers = [];
	  }
	
	  //modals
	  function showConfirmDialog(user) {
	    var header = {
	      idOwner: ownerPortfolio.userId,
	      user: user
	    };
	    PortfolioModalSrv.setVariable(header);
	    PortfolioModalSrv.confirmDialog().then(function (promise) {
	      var shared = PortfolioModalSrv.getVariable();
	      if (shared.status) {
	        cleanForm();
	        activate();
	      }
	    });
	  }
	};
	
	exports.default = SharedPortfolioCtrl;
	
	
	SharedPortfolioCtrl.$inject = ['$scope', '$location', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', '$cookies', '$state', 'GlobalSrv'];

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OtherPortfolioCtrl = function OtherPortfolioCtrl($scope, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService) {
	  _classCallCheck(this, OtherPortfolioCtrl);
	
	  // constants
	  var otherPortfolioVm = this;
	
	  otherPortfolioVm.userId = JSON.parse($cookies.get('currentUser')).id;
	  var guestPortfolio = {
	    userId: otherPortfolioVm.userId
	  };
	
	  otherPortfolioVm.users = [];
	
	  otherPortfolioVm.visitPortfolio = visitPortfolio;
	
	  activate();
	
	  function activate() {
	    getSharedPortfolio();
	  }
	
	  function getSharedPortfolio() {
	    PortfolioSrv.getSharedPortfolio.get(guestPortfolio).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        otherPortfolioVm.users = dataReturn.data;
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function visitPortfolio(user) {
	    $cookies.put('ownerPortfolio', user.idOwner);
	    $state.go('portfolio.visitPortfolio');
	  }
	};
	
	exports.default = OtherPortfolioCtrl;
	
	
	OtherPortfolioCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', '$cookies', '$state'];

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @name APP cmmApp
	 * @autor daniel.molina@u-planner.com
	 * @description vista tabla para forecast
	 * # name controller --> powerbiPortofolioCtrl
	 * # alias: --> powerbiCtrl
	 */
	var powerbiPortfolioCtrl = function powerbiPortfolioCtrl($http, $scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, LOCAL_ENV_CONSTANT) {
	  _classCallCheck(this, powerbiPortfolioCtrl);
	
	  $scope.title = 'Reporte portafolio de profesores';
	
	  $scope.POWER = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY1;
	
	  $scope.workspaceId = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_GROUP_ID;
	  $scope.reportId = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY1;
	};
	
	exports.default = powerbiPortfolioCtrl;
	
	
	powerbiPortfolioCtrl.$inject = ['$http', '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'LOCAL_ENV_CONSTANT'];

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EvaluationPortfolioCtrl = function EvaluationPortfolioCtrl($scope, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, GlobalSrv) {
		_classCallCheck(this, EvaluationPortfolioCtrl);
	
		// constants
		var evaluationVm = this;
		var cacheImage = {};
	
		evaluationVm.userId = JSON.parse($cookies.get('currentUser')).id;
		var ownerPortfolio = {
			userId: evaluationVm.userId
		};
	
		evaluationVm.users = [];
		evaluationVm.evalPortfolio = evalPortfolio;
		evaluationVm.getCachedImages = getCachedImages;
	
		activate();
	
		function activate() {
			getPortfolioForEval();
		}
	
		function getPortfolioForEval() {
			PortfolioSrv.getTeacherToEvaluation.get(ownerPortfolio).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					evaluationVm.users = dataReturn.data;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function getCachedImages(identification) {
			if (cacheImage[identification]) return;
	
			cacheImage[identification] = true;
	
			GlobalSrv.getUserImage.get({ identification: identification }).$promise.then(function (response) {
				// Clona la respuesta para guardarla en caché
				return response.profilePicture;
			});
		}
	
		function evalPortfolio(user) {
			$cookies.put('ownerPortfolio', user.userId);
			$state.go('portfolio.evaluationOfPortfolio');
		}
	};
	
	exports.default = EvaluationPortfolioCtrl;
	
	
	EvaluationPortfolioCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', '$cookies', '$state', 'GlobalSrv'];

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PortfolioParametrizationCtrl = function PortfolioParametrizationCtrl($scope, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService) {
	  _classCallCheck(this, PortfolioParametrizationCtrl);
	
	  // constants
	  var parametrizationVm = this;
	  parametrizationVm.userId = JSON.parse($cookies.get('currentUser')).id;
	  var activeDefault = 0;
	  var activeGuideline = 0;
	  parametrizationVm.guidelines = [];
	  parametrizationVm.disableSaveButton = false;
	
	  parametrizationVm.addGuideline = addGuideline;
	  parametrizationVm.setActiveList = setActiveList;
	  parametrizationVm.setActive = setActive;
	  parametrizationVm.showModal = showModal;
	  parametrizationVm.hasError = hasError;
	  parametrizationVm.showErrorMessages = showErrorMessages;
	  parametrizationVm.validateForm = validateForm;
	
	  activate();
	
	  function activate() {
	    getGuidelinesPortfolio();
	  }
	
	  function getGuidelinesPortfolio() {
	    PortfolioSrv.getGuidelines.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        parametrizationVm.guidelines = dataReturn.data;
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function addGuideline(form) {
	    parametrizationVm.disableSaveButton = true;
	    var header = {
	      title: parametrizationVm.title,
	      description: parametrizationVm.description,
	      active: parametrizationVm.guidelines.length > 0 ? activeDefault : 1
	    };
	    PortfolioSrv.addGuideline.add(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        parametrizationVm.disableSaveButton = false;
	        parametrizationVm.guidelines.push(header);
	        cleanForm(form);
	        activate();
	      } else {
	        parametrizationVm.disableSaveButton = false;
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function showModal(guideline) {
	    var header = {
	      guideline: guideline
	    };
	    PortfolioModalSrv.setVariable(header);
	    PortfolioModalSrv.showGuidelineDetails().then(function (promise) {});
	  }
	
	  function setActive() {
	    if (parametrizationVm.active == 1) {
	      activeDefault = 0;
	      parametrizationVm.active = 0;
	    } else {
	      activeDefault = 1;
	      parametrizationVm.active = 1;
	    }
	  }
	
	  function setActiveList(guideline, pos) {
	
	    var aux = activeGuideline;
	    parametrizationVm.guidelines[activeGuideline].active = 0;
	    parametrizationVm.guidelines[pos].active = 1;
	    activeGuideline = pos;
	    var header = {
	      guidelineId: guideline.guidelineId
	    };
	    PortfolioSrv.updateGuideline.update(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {} else {
	        activeGuideline = aux;
	        parametrizationVm.guidelines[activeGuideline].active = 1;
	        parametrizationVm.guidelines[pos].active = 0;
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  //forms functions
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function validateForm(form) {
	    return form.$invalid || parametrizationVm.disableSaveButton;
	  }
	
	  function cleanForm(form) {
	    parametrizationVm.title = '';
	    parametrizationVm.description = '';
	    parametrizationVm.active = 0;
	    activeDefault = 0;
	    form.$setPristine();
	    form.$setUntouched();
	  }
	};
	
	exports.default = PortfolioParametrizationCtrl;
	
	
	PortfolioParametrizationCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', '$cookies', '$state'];

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AddUserCommentCtrl = function AddUserCommentCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, WorkPlanSrv, GlobalConfig, GlobalSrv) {
	  _classCallCheck(this, AddUserCommentCtrl);
	
	  // constants
	  var commentUserVm = this;
	  var sharedVariable = PortfolioModalSrv.getVariable();
	
	  commentUserVm.ownerId = sharedVariable.userId;
	  commentUserVm.userLogued = sharedVariable.guestUser;
	  // variables
	  commentUserVm.comment = '';
	  commentUserVm.disableButton = false;
	
	  // methods
	  commentUserVm.close = close;
	  commentUserVm.addComment = addComment;
	  commentUserVm.showErrorMessages = showErrorMessages;
	  commentUserVm.hasError = hasError;
	  commentUserVm.validateForm = validateForm;
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  function getSendNotify(idUser) {
	    var post1 = {
	      idUser: idUser,
	      dsName: 'Notificación de comentario (Portafolio)',
	      dsDescription: 'Se ha ingresado un comentario en su portafolio',
	      idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	      is_grouped: 1
	    };
	    GlobalSrv.sendNotification(post1);
	  }
	
	  function addComment() {
	    commentUserVm.disableButton = true;
	    var header = {
	      commentUserId: commentUserVm.userLogued,
	      comment: commentUserVm.comment,
	      ownerId: commentUserVm.ownerId
	    };
	
	    PortfolioSrv.addUserComment.add(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        getSendNotify(commentUserVm.ownerId);
	        PortfolioModalSrv.setVariable({ status: dataReturn.status });
	        $mdDialog.hide();
	      } else {
	        commentUserVm.disableButton = false;
	      }
	    });
	  }
	
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function validateForm(form) {
	    return form.$invalid;
	  }
	};
	
	exports.default = AddUserCommentCtrl;
	
	
	AddUserCommentCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'WorkPlanSrv', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AddReflectionCommentCtrl = function AddReflectionCommentCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv) {
	  _classCallCheck(this, AddReflectionCommentCtrl);
	
	  // constants
	  var reflectionCommentVm = this;
	  var sharedVar = PortfolioModalSrv.getVariable();
	
	  reflectionCommentVm.userId = sharedVar.guestUser;
	  reflectionCommentVm.reflection = sharedVar.reflection;
	  reflectionCommentVm.isExternal = sharedVar.isExternal;
	  // variables
	  reflectionCommentVm.comment = '';
	  reflectionCommentVm.disableButton = false;
	
	  // methods
	  reflectionCommentVm.close = close;
	  reflectionCommentVm.addComment = addComment;
	  reflectionCommentVm.showErrorMessages = showErrorMessages;
	  reflectionCommentVm.hasError = hasError;
	  reflectionCommentVm.validateForm = validateForm;
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  function addComment() {
	    reflectionCommentVm.disableButton = true;
	    var header = {
	      userId: reflectionCommentVm.userId,
	      comment: reflectionCommentVm.comment,
	      reflectionId: reflectionCommentVm.reflection.blogId
	    };
	    PortfolioSrv.addReflectionComment.add(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        PortfolioModalSrv.setVariable({ status: dataReturn.status });
	        return $mdDialog.hide();
	      } else {
	        reflectionCommentVm.disableButton = false;
	      }
	    });
	  }
	
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function validateForm(form) {
	    return form.$invalid;
	  }
	};
	
	exports.default = AddReflectionCommentCtrl;
	
	
	AddReflectionCommentCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv'];

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AddNewRegistryCtrl = function AddNewRegistryCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
		_classCallCheck(this, AddNewRegistryCtrl);
	
		// constants
		var regexp = {
			image: /^(jpg|png|jpeg|bmp|gif)$/,
			audio: /^(mp3|mpeg-4|wma)$/,
			video: /^(mp4|mkv|avi|wmv)$/,
			document: /^(doc|docx|xls|xlsx|pdf)$/
		};
		var registryVm = this;
		var shared = PortfolioModalSrv.getVariable();
		var stylesClass = ['', 'azul text-blanco'];
	
		registryVm.userId = shared.userId;
		registryVm.startDate = shared.startDate;
		registryVm.endDate = shared.endDate;
	
		// variables
		registryVm.itemConfig = GlobalConfig.itemListConfig;
		registryVm.globalFileTypes = GlobalConfig.portfolioConfig.fileTypes;
		registryVm.comment = '';
		registryVm.fileName = '';
		registryVm.attachFile = '';
		registryVm.classTitle = 'col-md-3';
		registryVm.loading = false;
		registryVm.errorMsg = false;
		registryVm.errorMsgFileType = '';
		registryVm.disableButtonUpload = true;
		registryVm.showUploader = false;
		registryVm.acceptFileType = '';
		registryVm.evidencesLinks = [];
		registryVm.registryTypes = [{ registryId: registryVm.itemConfig.idReflection, registryName: registryVm.itemConfig.nameReflection }, { registryId: registryVm.itemConfig.idEvidence, registryName: registryVm.itemConfig.nameEvidence }];
		registryVm.fileTypes = [];
		registryVm.evidencesTypes = [];
		registryVm.isRegistry = true;
		registryVm.isLinking = false;
		registryVm.isAddingEvidence = false;
		registryVm.disableButtonAdd = false;
		registryVm.STATIC_IMAGE_URL = true;
	
		// methods declaration
		registryVm.close = close;
		registryVm.addRegistry = addRegistry;
		registryVm.setClassTitle = setClassTitle;
		registryVm.showErrorMessages = showErrorMessages;
		registryVm.hasError = hasError;
		registryVm.validateForm = validateForm;
		registryVm.remove = remove;
		registryVm.cancel = cancel;
		registryVm.linkEvidence = linkEvidence;
		registryVm.showEvidencesToLink = showEvidencesToLink;
		registryVm.setEvidence = setEvidence;
		registryVm.removeLink = removeLink;
		registryVm.showAddEvidenceToLink = showAddEvidenceToLink;
		registryVm.addLinkToReflection = addLinkToReflection;
		registryVm.setFilterUploader = setFilterUploader;
		registryVm.openFileSelector = openFileSelector;
		registryVm.uploadFile = uploadFile;
	
		activate();
	
		// initial functions
		function activate() {
			PortfolioSrv.getBasicsRegistry.get().$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					registryVm.fileTypes = dataReturn.fileTypes;
					registryVm.evidencesTypes = dataReturn.evidencesTypes;
				}
			});
			getEvidences();
		}
	
		function getEvidences() {
			var header = {
				userId: registryVm.userId,
				startDate: registryVm.startDate,
				endDate: registryVm.endDate
			};
	
			PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					registryVm.evidences = dataReturn.data;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function close() {
			PortfolioModalSrv.setVariable({ status: false });
	
			return $mdDialog.hide();
		}
	
		// methos for add elements
	
		function addRegistry() {
			registryVm.disableButtonAdd = true;
			var header = {
				userId: registryVm.userId,
				description: registryVm.description,
				title: registryVm.title
			};
	
			if (registryVm.itemConfig.idReflection == registryVm.registryId) {
				header.isEnlighted = registryVm.blogIsEnlighted ? 1 : 0;
				header.evidencesLinks = registryVm.evidencesLinks;
				addReflection(header);
			} else {
				header.idSubitem = registryVm.evidenceType;
				header.fileType = registryVm.fileTypeId;
				header.fileName = registryVm.attachFile;
				addEvidence(header);
			}
		}
	
		function addEvidence(evidence) {
			PortfolioSrv.addEvidence.add(evidence).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					registryVm.disableButtonAdd = false;
					PortfolioModalSrv.setVariable({ status: dataReturn.status });
	
					return $mdDialog.hide();
				}
			});
		}
	
		function addReflection(reflection) {
			PortfolioSrv.addReflection.add(reflection).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					registryVm.disableButtonAdd = false;
					PortfolioModalSrv.setVariable({ status: dataReturn.status });
	
					return $mdDialog.hide();
				}
			});
		}
	
		function showEvidencesToLink() {
			registryVm.errorMsgLinkEvidence = false;
			registryVm.isAddingEvidence = false;
			registryVm.isLinking = true;
			registryVm.isRegistry = false;
		}
	
		function showAddEvidenceToLink() {
			registryVm.errorMsgLinkEvidence = false;
			registryVm.isAddingEvidence = true;
			registryVm.isLinking = false;
			registryVm.isRegistry = false;
	
			registryVm.showUploader = false;
			registryVm.descriptionLinkEvidence = null;
			registryVm.titleLinkEvidence = null;
			registryVm.evidenceType = null;
			registryVm.fileTypeId = null;
			registryVm.fileName = null;
			remove();
		}
	
		// methods for link evidence to a new reflection
		function linkEvidence() {
			if (registryVm.selectedEvidence) {
				var header = {
					blogId: registryVm.selectedEvidence.evidence.blogId,
					title: registryVm.selectedEvidence.evidence.blogTitle,
					filetype: registryVm.selectedEvidence.evidence.blogFileType
				};
	
				registryVm.evidencesLinks.push(header);
				cancel();
			} else {
				registryVm.errorMsgLinkEvidence = true;
			}
		}
	
		function setEvidence(evidence, index) {
			if (registryVm.selectedEvidence) {
				registryVm.evidences[registryVm.selectedEvidence.pos].isSelected = stylesClass[0];
				registryVm.selectedEvidence = {
					evidence: evidence,
					pos: index
				};
				evidence.isSelected = stylesClass[1];
			} else {
				registryVm.selectedEvidence = {
					evidence: evidence,
					pos: index
				};
				evidence.isSelected = stylesClass[1];
			}
	
			registryVm.errorMsgLinkEvidence = false;
		}
	
		function removeLink(index) {
			registryVm.evidencesLinks.splice(index, 1);
		}
	
		function cancel() {
			registryVm.isAddingEvidence = false;
			registryVm.isLinking = false;
			registryVm.isRegistry = true;
	
			if (registryVm.evidences[registryVm.selectedEvidence.pos]) {
				registryVm.evidences[registryVm.selectedEvidence.pos].isSelected = stylesClass[0];
			}
	
			registryVm.selectedEvidence = null;
	
			registryVm.descriptionLinkEvidence = null;
			registryVm.titleLinkEvidence = null;
			registryVm.evidenceType = null;
			registryVm.fileTypeId = null;
			registryVm.fileName = null;
		}
	
		// methods to add new evidence, and link to reflection
		function addLinkToReflection() {
			registryVm.disableButtonAdd = true;
			var header = {
				userId: registryVm.userId,
				description: registryVm.descriptionLinkEvidence,
				title: registryVm.titleLinkEvidence,
				idSubitem: registryVm.evidenceType,
				fileType: registryVm.fileTypeId,
				fileName: registryVm.fileName //este valor debe obtener cuando el archivo sea adjuntado
			};
	
			PortfolioSrv.addEvidence.add(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					var addedEvidence = {
						blogId: dataReturn.reflectionId,
						blogTitle: header.title,
						blogFileType: header.fileType
					};
	
					registryVm.selectedEvidence = {
						evidence: addedEvidence,
						pos: 0
					};
					linkEvidence();
					registryVm.disableButtonAdd = false;
				}
			});
		}
	
		//upload methods
		function setFilterUploader() {
			var name = '';
			var extensions = '';
			var pattern = void 0;
	
			if (isImageType(registryVm.fileTypeId)) {
				name = 'imageFilter';
				extensions = '|jpg|png|jpeg|bmp|gif|';
				registryVm.acceptFileType = 'image/*';
				pattern = regexp.image;
			}
	
			if (isAudioType(registryVm.fileTypeId)) {
				name = 'audioFilter';
				extensions = '|mp3|mpeg-4|wma|ogg|';
				registryVm.acceptFileType = 'audio/*';
				pattern = regexp.audio;
			}
	
			if (isVideoType(registryVm.fileTypeId)) {
				name = 'videoFilter';
				extensions = '|mp4|mkv|avi|wmv|';
				registryVm.acceptFileType = 'video/*';
				pattern = regexp.video;
			}
	
			if (isDocumentType(registryVm.fileTypeId)) {
				name = 'documentFilter';
				extensions = '|doc|docx|xls|xlsx|pdf|ppt|pptx|';
				registryVm.acceptFileType = 'application/pdf,application/vnd.ms-excel,application/msword';
				pattern = regexp.document;
			}
	
			uploader.filters.pop();
			uploader.filters.push({
				name: name,
				fn: function fn(item, options) {
					var type = '|' + item.name.slice(item.name.lastIndexOf('.') + 1) + '|';
	
					return extensions.indexOf(type) !== -1;
				}
			});
			registryVm.showUploader = true;
			$('#inputFileUpload').val(null);
			$('#inputFileUpload2').val(null);
			registryVm.disableButtonUpload = true;
	
			if (registryVm.attachFile != '') {
				checkExtensionFile(registryVm.fileTypeId, registryVm.attachFile, pattern);
			}
		}
	
		function checkExtensionFile(fileType, filename, pattern) {
			var ext = filename.substring(filename.lastIndexOf('.') + 1);
	
			if (pattern.test(ext)) {
				registryVm.errorMsgFileType = '';
			} else {
				registryVm.errorMsgFileType = 'El archivo adjunto no es el de tipo seleccionado';
			}
		}
	
		var uploader = $scope.uploader = new FileUploader({
			url: SERVICE_URL_CONSTANT.rosario + '/file/uploadFilePortfolio?userId=' + registryVm.userId
		});
	
		// a sync filter
		uploader.filters.push({
			name: 'syncFilter',
			fn: function fn(item /*{File|FileLikeObject}*/, options) {
				return this.queue.length < 10;
			}
		});
	
		// an async filter
		uploader.filters.push({
			name: 'asyncFilter',
			fn: function fn(item, options, deferred) {
				setTimeout(deferred.resolve, 1e3);
			}
		});
	
		uploader.filters.push({
			name: 'emptyFilter',
			fn: function fn(item, options) {
				return true;
			}
		});
	
		uploader.onWhenAddingFileFailed = function (item, filter, options) {
			registryVm.errorMsgFileType = 'El archivo no es el de tipo seleccionado';
			registryVm.disableButtonUpload = true;
			$('#inputFileUpload').val(null);
			$('#inputFileUpload2').val(null);
		};
	
		uploader.onAfterAddingFile = function (fileItem) {
			registryVm.uploadFile();
			registryVm.errorMsgFileType = '';
			registryVm.disableButtonUpload = false;
		};
	
		uploader.onSuccessItem = function (fileItem, response, status, headers) {
			if (response.status) {
				registryVm.loading = false;
				registryVm.fileName = response.blobFileName;
				registryVm.attachFile = fileItem.file.name;
				registryVm.errorMsg = false;
			}
		};
		uploader.onErrorItem = function (fileItem, response, status, headers) {
			registryVm.errorMsg = true;
		};
	
		uploader.onCompleteItem = function (fileItem, response, status, headers) {
			setTimeout(function () {
				registryVm.STATIC_IMAGE_URL = false;
			}, 3000);
		};
	
		uploader.onBeforeUploadItem = function (item) {
			var header = {
				userId: registryVm.userId
			};
	
			item.formData.push(header);
			registryVm.loading = true;
			registryVm.errorMsg = false;
		};
	
		function remove() {
			registryVm.attachFile = '';
			uploader.clearQueue();
			registryVm.STATIC_IMAGE_URL = true;
			registryVm.loading = false;
			registryVm.errorMsg = false;
			registryVm.fileName = '';
			$('#inputFileUpload').val(null);
			$('#inputFileUpload2').val(null);
		}
	
		//forms methods
		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error';
			}
		}
	
		function showErrorMessages(input) {
			return input.$dirty || input.$touched;
		}
	
		function validateForm(form) {
			if (registryVm.itemConfig.idEvidence == registryVm.registryId) {
				return form.$invalid || registryVm.fileName == '' || registryVm.errorMsgFileType != '';
			} else {
				if (registryVm.isAddingEvidence) {
					return form.$invalid || registryVm.fileName == '' || registryVm.errorMsgFileType != '';
				} else {
					return form.$invalid;
				}
			}
		}
	
		//utils functions
		function setClassTitle() {
			if (registryVm.itemConfig.idEvidence == registryVm.registryId) {
				registryVm.classTitle = 'col-md-3';
			} else {
				registryVm.classTitle = 'col-md-3';
			}
		}
	
		function isImageType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.image;
		}
	
		function isDocumentType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.document;
		}
	
		function isVideoType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.video;
		}
	
		function isAudioType(fileTypeId) {
			return fileTypeId == registryVm.globalFileTypes.audio;
		}
	
		function openFileSelector() {
			var inputFile1 = document.getElementById('inputFileUpload');
	
			if (inputFile1) {
				inputFile1.click();
			} else {
				document.getElementById('inputFileUpload2').click();
			}
		}
	
		function uploadFile() {
			if (uploader.queue.length) {
				if (!hasWhiteSpaceAccentOrN) {
					uploader.queue[0].upload();
				} else {
					uploader.queue[0].file.name = parseAndCleanFileName(uploader.queue[0].file.name);
					uploader.queue[0].upload();
				}
			}
		}
	
		function parseAndCleanFileName(fileName) {
			var removeN = fileName.replace(/[ñÑ]/g, 'n');
			var removeSpaces = removeN.replace(/\s/g, '_');
	
			return removeSpaces.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		}
	
		function hasWhiteSpaceAccentOrN(fileName) {
			var regex = /[ \u00A0-\uFFFFñÑ]/;
	
			return regex.test(fileName);
		}
	};
	
	exports.default = AddNewRegistryCtrl;
	
	
	AddNewRegistryCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EvidenceLinksCtrl = function EvidenceLinksCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig) {
	  _classCallCheck(this, EvidenceLinksCtrl);
	
	  // constants
	  var linksVm = this;
	  var sharedVariable = PortfolioModalSrv.getVariable();
	  linksVm.evidence = sharedVariable.evidence;
	  linksVm.filetypes = GlobalConfig.portfolioConfig.fileTypes;
	
	  // methods
	  linksVm.close = close;
	
	  function close() {
	    return $mdDialog.hide();
	  }
	};
	
	exports.default = EvidenceLinksCtrl;
	
	
	EvidenceLinksCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig'];

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DisableEvidenceCtrl = function DisableEvidenceCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv) {
	  _classCallCheck(this, DisableEvidenceCtrl);
	
	  // constants
	  var disableVm = this;
	  var sharedVariable = PortfolioModalSrv.getVariable();
	
	  disableVm.evidence = sharedVariable.evidence;
	
	  // methods
	  disableVm.close = close;
	  disableVm.disableEvidence = disableEvidence;
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  function disableEvidence() {
	    var header = {
	      blogId: disableVm.evidence.blogId
	    };
	    PortfolioSrv.disableEvidence.disable(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        PortfolioModalSrv.setVariable({ status: dataReturn.status });
	        return $mdDialog.hide();
	      }
	    });
	  }
	};
	
	exports.default = DisableEvidenceCtrl;
	
	
	DisableEvidenceCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv'];

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditEvidenceCtrl = function EditEvidenceCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, EditEvidenceCtrl);
	
	  // constants
	  var regexp = {
	    image: /^(jpg|png|jpeg|bmp|gif)$/,
	    audio: /^(mp3|mpeg-4|wma)$/,
	    video: /^(mp4|mkv|avi|wmv)$/,
	    document: /^(doc|docx|xls|xlsx|pdf)$/
	  };
	  var editEvidenceVm = this;
	  editEvidenceVm.sharedVariable = PortfolioModalSrv.getVariable();
	  // variables
	  editEvidenceVm.evidence = editEvidenceVm.sharedVariable.evidence;
	  editEvidenceVm.comment = '';
	  editEvidenceVm.fileName = '';
	  editEvidenceVm.attachFile = '';
	  editEvidenceVm.loading = false;
	  editEvidenceVm.errorMsg = false;
	  editEvidenceVm.errorMsgFileType = '';
	  editEvidenceVm.disableButtonUpload = false;
	  editEvidenceVm.showUploader = true;
	  editEvidenceVm.acceptFileType = '';
	  editEvidenceVm.fileTypes = [];
	  editEvidenceVm.evidencesTypes = [];
	  editEvidenceVm.globalFileTypes = GlobalConfig.portfolioConfig.fileTypes;
	  editEvidenceVm.disableButtonAdd = false;
	
	  // methods
	  editEvidenceVm.close = close;
	  editEvidenceVm.updateEvidence = updateEvidence;
	  editEvidenceVm.showErrorMessages = showErrorMessages;
	  editEvidenceVm.hasError = hasError;
	  editEvidenceVm.validateForm = validateForm;
	  editEvidenceVm.remove = remove;
	  editEvidenceVm.setFilterUploader = setFilterUploader;
	
	  //initial functions
	  function activate() {
	    setValues();
	    setFilterUploader();
	    PortfolioSrv.getBasicsRegistry.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        editEvidenceVm.fileTypes = dataReturn.fileTypes;
	        editEvidenceVm.evidencesTypes = dataReturn.evidencesTypes;
	      }
	    });
	  }
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  function updateEvidence() {
	    editEvidenceVm.disableButtonAdd = true;
	    var header = {
	      blogId: editEvidenceVm.blogId,
	      title: editEvidenceVm.title,
	      description: editEvidenceVm.description,
	      idSubitem: editEvidenceVm.evidenceType,
	      fileType: editEvidenceVm.fileTypeId,
	      fileName: editEvidenceVm.fileName //este valor debe obtener cuando el archivo sea adjuntado 
	    };
	    PortfolioSrv.updateEvidence.update(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        PortfolioModalSrv.setVariable({ status: dataReturn.status });
	        return $mdDialog.hide();
	      } else {
	        editEvidenceVm.disableButtonAdd = false;
	      }
	    });
	  }
	
	  function setValues() {
	    editEvidenceVm.blogId = editEvidenceVm.evidence.blogId;
	    editEvidenceVm.description = editEvidenceVm.evidence.blogDescription;
	    editEvidenceVm.title = editEvidenceVm.evidence.blogTitle;
	    editEvidenceVm.evidenceType = editEvidenceVm.evidence.blogSubTypeId;
	    editEvidenceVm.fileTypeId = editEvidenceVm.evidence.blogFileType;
	    editEvidenceVm.attachFile = editEvidenceVm.evidence.fileName;
	    editEvidenceVm.fileName = editEvidenceVm.evidence.blogUrlFile;
	    editEvidenceVm.STATIC_IMAGE_URL = true;
	  }
	
	  //upload methods
	  function setFilterUploader() {
	    var name = '';
	    var extensions = '';
	    var pattern = void 0;
	    if (isImageType(editEvidenceVm.fileTypeId)) {
	      name = 'imageFilter';
	      extensions = '|jpg|png|jpeg|bmp|gif|';
	      editEvidenceVm.acceptFileType = 'image/*';
	      pattern = regexp.image;
	    }
	    if (isAudioType(editEvidenceVm.fileTypeId)) {
	      name = 'audioFilter';
	      extensions = '|mp3|mpeg-4|wma|';
	      editEvidenceVm.acceptFileType = 'audio/*';
	      pattern = regexp.audio;
	    }
	    if (isVideoType(editEvidenceVm.fileTypeId)) {
	      name = 'videoFilter';
	      extensions = '|mp4|mkv|avi|wmv|';
	      editEvidenceVm.acceptFileType = 'video/*';
	      pattern = regexp.video;
	    }
	    if (isDocumentType(editEvidenceVm.fileTypeId)) {
	      name = 'documentFilter';
	      extensions = '|doc|docx|xls|xlsx|pdf|';
	      editEvidenceVm.acceptFileType = 'application/pdf,application/vnd.ms-excel,application/msword';
	      pattern = regexp.document;
	    }
	
	    uploader.filters.pop();
	    uploader.filters.push({
	      name: name,
	      fn: function fn(item, options) {
	        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	        return extensions.indexOf(type) !== -1;
	      }
	    });
	    editEvidenceVm.showUploader = true;
	    $('#inputFileUpload').val(null);
	    $('#inputFileUpload2').val(null);
	    editEvidenceVm.disableButtonUpload = true;
	
	    if (editEvidenceVm.attachFile != '') {
	      checkExtensionFile(editEvidenceVm.fileTypeId, editEvidenceVm.attachFile, pattern);
	    }
	  }
	
	  function checkExtensionFile(fileType, filename, pattern) {
	    var ext = filename.substring(filename.lastIndexOf(".") + 1);
	    if (pattern.test(ext)) {
	      editEvidenceVm.errorMsgFileType = '';
	    } else {
	      editEvidenceVm.errorMsgFileType = 'El archivo adjunto no es el de tipo seleccionado';
	    }
	  }
	
	  var uploader = $scope.uploader = new FileUploader({
	    url: SERVICE_URL_CONSTANT.rosario + '/file/uploadFilePortfolio?userId=' + editEvidenceVm.evidence.blogUser
	  });
	
	  // a sync filter
	  uploader.filters.push({
	    name: 'syncFilter',
	    fn: function fn(item, options) {
	      //console.log('syncFilter');
	      return this.queue.length < 10;
	    }
	  });
	
	  // an async filter
	  uploader.filters.push({
	    name: 'asyncFilter',
	    fn: function fn(item, options, deferred) {
	      //console.log('asyncFilter')
	      setTimeout(deferred.resolve, 1e3);
	    }
	  });
	
	  uploader.filters.push({
	    name: 'emptyFilter',
	    fn: function fn(item, options) {
	      return true;
	    }
	  });
	
	  uploader.onWhenAddingFileFailed = function (item, filter, options) {
	    //console.info('onWhenAddingFileFailed', item, filter, options)
	    editEvidenceVm.errorMsgFileType = 'El archivo no es el de tipo seleccionado';
	    editEvidenceVm.disableButtonUpload = true;
	    $('#inputFileUpload').val(null);
	  };
	
	  uploader.onAfterAddingFile = function (fileItem) {
	    //console.info('onAfterAddingFile', fileItem)
	    editEvidenceVm.errorMsgFileType = '';
	    editEvidenceVm.disableButtonUpload = false;
	  };
	
	  uploader.onSuccessItem = function (fileItem, response, status, headers) {
	    //console.info('onSuccessItem', fileItem, response, status, headers)
	    if (response.status) {
	      editEvidenceVm.fileName = response.data;
	      editEvidenceVm.attachFile = fileItem.file.name;
	      editEvidenceVm.errorMsg = false;
	    }
	  };
	  uploader.onErrorItem = function (fileItem, response, status, headers) {
	    //console.info('onErrorItem', fileItem, response, status, headers)
	    editEvidenceVm.errorMsg = true;
	  };
	
	  uploader.onCompleteItem = function (fileItem, response, status, headers) {
	    //console.info('onCompleteItem', fileItem, response, status, headers)      
	    editEvidenceVm.loading = false;
	    editEvidenceVm.STATIC_IMAGE_URL = true;
	  };
	
	  uploader.onBeforeUploadItem = function (item) {
	    var header = {
	      userId: editEvidenceVm.userId
	    };
	    item.formData.push(header);
	    editEvidenceVm.loading = true;
	    editEvidenceVm.errorMsg = false;
	  };
	
	  function remove() {
	    editEvidenceVm.attachFile = '';
	    editEvidenceVm.STATIC_IMAGE_URL = false;
	    editEvidenceVm.loading = false;
	    editEvidenceVm.fileName = '';
	    editEvidenceVm.errorMsg = false;
	    uploader.clearQueue();
	    $('#inputFileUpload').val(null);
	  }
	
	  //forms methods
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function validateForm(form) {
	    return form.$invalid || editEvidenceVm.fileName == '' || editEvidenceVm.errorMsgFileType != '';
	  }
	
	  //utils functions
	  function isImageType(fileTypeId) {
	    return fileTypeId == editEvidenceVm.globalFileTypes.image;
	  }
	
	  function isDocumentType(fileTypeId) {
	    return fileTypeId == editEvidenceVm.globalFileTypes.document;
	  }
	
	  function isVideoType(fileTypeId) {
	    return fileTypeId == editEvidenceVm.globalFileTypes.video;
	  }
	
	  function isAudioType(fileTypeId) {
	    return fileTypeId == editEvidenceVm.globalFileTypes.audio;
	  }
	
	  activate();
	};
	
	exports.default = EditEvidenceCtrl;
	
	
	EditEvidenceCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditStatementCtrl = function EditStatementCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, EditStatementCtrl);
	
	  // constants
	  var statementVm = this;
	  // variables
	  var shared = PortfolioModalSrv.getVariable();
	  statementVm.userId = shared.userId;
	  statementVm.description = shared.statement.blogDescription ? shared.statement.blogDescription : '';
	  statementVm.attachFile = shared.statement.externalUrlFiles ? shared.statement.externalUrlFiles : [];
	  statementVm.errorMsg = false;
	
	  // methods
	  statementVm.close = close;
	  statementVm.addStatement = addStatement;
	  statementVm.showErrorMessages = showErrorMessages;
	  statementVm.hasError = hasError;
	  statementVm.validateForm = validateForm;
	  statementVm.remove = remove;
	
	  activate();
	
	  //initial functions
	  function activate() {
	    console.log(statementVm.attachFile);
	  }
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  function addStatement() {
	    statementVm.description = removeSymbol(statementVm.description);
	    var header = {
	      userId: statementVm.userId,
	      description: statementVm.description,
	      attachFiles: statementVm.attachFile
	    };
	    console.log(header);
	    PortfolioSrv.addStatement.add(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        PortfolioModalSrv.setVariable({ status: dataReturn.status });
	        return $mdDialog.hide();
	      }
	    });
	  }
	
	  function removeSymbol(str) {
	    return str.replaceAll('>?', '>');
	  }
	
	  //upload methods
	  var uploader = $scope.uploader = new FileUploader({
	    url: SERVICE_URL_CONSTANT.rosario + '/file/uploadFilePortfolio?userId=' + statementVm.userId
	  });
	
	  // a sync filter
	  uploader.filters.push({
	    name: 'syncFilter',
	    fn: function fn(item /*{File|FileLikeObject}*/, options) {
	      console.log('syncFilter');
	      return this.queue.length < 10;
	    }
	  });
	
	  // an async filter
	  uploader.filters.push({
	    name: 'asyncFilter',
	    fn: function fn(item /*{File|FileLikeObject}*/, options, deferred) {
	      console.log('asyncFilter');
	      setTimeout(deferred.resolve, 1e3);
	    }
	  });
	  uploader.onSuccessItem = function (fileItem, response, status, headers) {
	    console.info('onSuccessItem', fileItem, response, status, headers);
	    if (response.status) {
	      statementVm.urlFilename = response.data;
	      statementVm.attachFile.push({ filename: fileItem.file.name, externalUrlFile: statementVm.urlFilename });
	      statementVm.errorMsg = false;
	    }
	  };
	  uploader.onErrorItem = function (fileItem, response, status, headers) {
	    console.info('onErrorItem', fileItem, response, status, headers);
	    statementVm.errorMsg = true;
	  };
	
	  uploader.onCompleteItem = function (fileItem, response, status, headers) {
	    console.info('onCompleteItem', fileItem, response, status, headers);
	    statementVm.loading = false;
	    uploader.clearQueue();
	  };
	
	  uploader.onBeforeUploadItem = function (item) {
	    var header = {
	      userId: statementVm.userId
	    };
	    item.formData.push(header);
	    statementVm.loading = true;
	    statementVm.errorMsg = false;
	  };
	
	  function remove(index) {
	    statementVm.loading = false;
	    statementVm.errorMsg = false;
	    statementVm.attachFile.splice(index, 1);
	  }
	
	  //forms methods
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function validateForm(form) {
	    return form.$invalid;
	  }
	
	  String.prototype.replaceAll = function (searchStr, replaceStr) {
	    var str = this;
	    if (str.indexOf(searchStr) === -1) return str;
	    return str.replace(searchStr, replaceStr).replaceAll(searchStr, replaceStr);
	  };
	};
	
	exports.default = EditStatementCtrl;
	
	
	EditStatementCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT'];

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HistoryStatementCtrl = function HistoryStatementCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig) {
	  _classCallCheck(this, HistoryStatementCtrl);
	
	  // constants
	  var historyVm = this;
	  var sharedVariable = PortfolioModalSrv.getVariable();
	  historyVm.statements = sharedVariable.statements;
	  var cssClass = {
	    arrowUp: "mdi-hardware-keyboard-arrow-up",
	    arrowDown: "mdi-hardware-keyboard-arrow-down"
	  };
	  historyVm.showDescription = cssClass.arrowDown;
	
	  // methods
	  historyVm.close = close;
	  historyVm.showStatement = showStatement;
	
	  activate();
	  function activate() {
	    for (var i = historyVm.statements.length - 1; i >= 0; i--) {
	      historyVm.statements[i].isHidden = true;
	    }
	  }
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function showStatement(statement) {
	    if (statement.isHidden) {
	      historyVm.showDescription = cssClass.arrowUp;
	    } else {
	      historyVm.showDescription = cssClass.arrowDown;
	    }
	    statement.isHidden = !statement.isHidden;
	  }
	};
	
	exports.default = HistoryStatementCtrl;
	
	
	HistoryStatementCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig'];

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommentDetailsCtrl = function CommentDetailsCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, WorkPlanSrv, GlobalSrv) {
	  _classCallCheck(this, CommentDetailsCtrl);
	
	  // constants
	  var commentDetailVm = this;
	  var isNew = false;
	  var guidelineNew = {};
	  var sharedVariable = PortfolioModalSrv.getVariable();
	  commentDetailVm.comment = sharedVariable.comment;
	  commentDetailVm.isOnEvaluation = false;
	  if (sharedVariable.isOnEvaluation) {
	    commentDetailVm.isOnEvaluation = sharedVariable.isOnEvaluation;
	    commentDetailVm.userId = sharedVariable.userId;
	    commentDetailVm.evaluator = sharedVariable.evaluator;
	    commentDetailVm.guestUser = sharedVariable.guestUser;
	    commentDetailVm.startDate = sharedVariable.startDate;
	    commentDetailVm.endDate = sharedVariable.endDate;
	  }
	  commentDetailVm.disabledButton = false;
	  commentDetailVm.showErrorMsg = false;
	
	  // methods
	  commentDetailVm.close = close;
	  commentDetailVm.save = save;
	  commentDetailVm.publicComment = publicComment;
	  commentDetailVm.hasError = hasError;
	  commentDetailVm.showErrorMessages = showErrorMessages;
	  commentDetailVm.validateForm = validateForm;
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  active();
	
	  function active() {
	    if (sharedVariable.isOnEvaluation) {
	      getEvalComment();
	    }
	  }
	
	  function getEvalComment() {
	    var header = {
	      userId: commentDetailVm.userId,
	      startDate: commentDetailVm.startDate,
	      endDate: commentDetailVm.endDate
	    };
	    PortfolioSrv.getEvalComment.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        commentDetailVm.comment = dataReturn.data[0];
	        guidelineNew = dataReturn.guidelineData[0];
	        if (!commentDetailVm.comment.commentId) {
	          isNew = true;
	          commentDetailVm.comment.comiteeName = commentDetailVm.evaluator.comiteeName;
	          commentDetailVm.comment.comiteeId = commentDetailVm.evaluator.comiteeId;
	          commentDetailVm.comment.description = '';
	          if (guidelineNew) {
	            commentDetailVm.comment.guidelineId = guidelineNew.guidelineId;
	            commentDetailVm.comment.guidelineTitle = guidelineNew.guidelineTitle;
	            commentDetailVm.comment.guidelineDescription = guidelineNew.guidelineDescription;
	          } else {
	            commentDetailVm.disabledButton = true;
	            commentDetailVm.showErrorMsg = true;
	          }
	        }
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function save() {
	    commentDetailVm.disabledButton = true;
	    var header = {
	      idOwner: parseInt(commentDetailVm.userId),
	      userId: parseInt(commentDetailVm.guestUser),
	      description: commentDetailVm.comment.commentDescription,
	      comiteeId: commentDetailVm.evaluator.comiteeId,
	      status: 0,
	      guidelineId: commentDetailVm.comment.guidelineId
	    };
	    if (isNew) {
	      addComment(header);
	    } else {
	      header.commentId = commentDetailVm.comment.commentId;
	      updateComment(header);
	    }
	  }
	
	  function publicComment() {
	    commentDetailVm.disabledButton = true;
	    var header = {
	      idOwner: parseInt(commentDetailVm.userId),
	      userId: parseInt(commentDetailVm.guestUser),
	      description: commentDetailVm.comment.commentDescription,
	      comiteeId: commentDetailVm.evaluator.comiteeId,
	      status: 1,
	      guidelineId: commentDetailVm.comment.guidelineId
	    };
	    if (isNew) {
	      addCommentPublish(header);
	    } else {
	      header.commentId = commentDetailVm.comment.commentId;
	      updateCommentPublish(header);
	    }
	  }
	
	  function getNotify(iduser) {
	    getSendNotify(iduser);
	  }
	
	  function getSendNotify(idUser) {
	    var post1 = {
	      idUser: idUser,
	      dsName: 'Notificación de evaluación (Portafolio)',
	      dsDescription: 'Su portafolio ha sido evaluado por un comité',
	      idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	      is_grouped: 0
	    };
	    GlobalSrv.sendNotification(post1);
	  }
	
	  function addCommentPublish(comment) {
	
	    PortfolioSrv.addEvalComment.add(comment).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        getNotify(parseInt(commentDetailVm.userId));
	        closeDialog(comment.status);
	      }
	      commentDetailVm.disabledButton = false;
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function updateCommentPublish(comment) {
	
	    PortfolioSrv.updateEvalComment.update(comment).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        getNotify(parseInt(commentDetailVm.userId));
	        closeDialog(comment.status);
	      }
	      commentDetailVm.disabledButton = false;
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function addComment(comment) {
	    PortfolioSrv.addEvalComment.add(comment).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        closeDialog(comment.status);
	      }
	      commentDetailVm.disabledButton = false;
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function updateComment(comment) {
	    PortfolioSrv.updateEvalComment.update(comment).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        closeDialog(comment.status);
	      }
	      commentDetailVm.disabledButton = false;
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function closeDialog(status) {
	    if (status == 1) {
	      PortfolioModalSrv.setVariable({ status: true });
	      return $mdDialog.hide();
	    } else {
	      close();
	    }
	  }
	
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function validateForm(form) {
	    return form.$invalid;
	  }
	};
	
	exports.default = CommentDetailsCtrl;
	
	
	CommentDetailsCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', 'WorkPlanSrv', 'GlobalSrv'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditReflectionCtrl = function EditReflectionCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, EditReflectionCtrl);
	
	  // constants
	  var regexp = {
	    image: /^(jpg|png|jpeg|bmp|gif)$/,
	    audio: /^(mp3|mpeg-4|wma)$/,
	    video: /^(mp4|mkv|avi|wmv)$/,
	    document: /^(doc|docx|xls|xlsx|pdf)$/
	  };
	  var editReflectionVm = this;
	  var shared = PortfolioModalSrv.getVariable();
	  var stylesClass = ['', 'azul text-blanco'];
	  editReflectionVm.reflection = shared.reflection;
	  editReflectionVm.userId = shared.userId;
	  editReflectionVm.startDate = shared.startDate;
	  editReflectionVm.endDate = shared.endDate;
	
	  // variables
	  editReflectionVm.itemConfig = GlobalConfig.itemListConfig;
	  editReflectionVm.globalFileTypes = GlobalConfig.portfolioConfig.fileTypes;
	  editReflectionVm.comment = '';
	  editReflectionVm.fileName = '';
	  editReflectionVm.attachFile = '';
	  editReflectionVm.classTitle = 'col-md-3';
	  editReflectionVm.loading = false;
	  editReflectionVm.errorMsg = false;
	  editReflectionVm.errorMsgFileType = '';
	  editReflectionVm.disableButtonUpload = true;
	  editReflectionVm.showUploader = false;
	  editReflectionVm.acceptFileType = '';
	  editReflectionVm.evidencesLinks = [];
	  editReflectionVm.fileTypes = [];
	  editReflectionVm.evidencesTypes = [];
	  editReflectionVm.isRegistry = true;
	  editReflectionVm.isLinking = false;
	  editReflectionVm.isAddingEvidence = false;
	  editReflectionVm.disableButtonAdd = false;
	
	  // methods declaration
	  editReflectionVm.close = close;
	  editReflectionVm.editReflection = editReflection;
	  editReflectionVm.setClassTitle = setClassTitle;
	  editReflectionVm.showErrorMessages = showErrorMessages;
	  editReflectionVm.hasError = hasError;
	  editReflectionVm.validateForm = validateForm;
	  editReflectionVm.remove = remove;
	  editReflectionVm.cancel = cancel;
	  editReflectionVm.linkEvidence = linkEvidence;
	  editReflectionVm.showEvidencesToLink = showEvidencesToLink;
	  editReflectionVm.setEvidence = setEvidence;
	  editReflectionVm.removeLink = removeLink;
	  editReflectionVm.showAddEvidenceToLink = showAddEvidenceToLink;
	  editReflectionVm.addLinkToReflection = addLinkToReflection;
	  editReflectionVm.setFilterUploader = setFilterUploader;
	
	  activate();
	
	  // initial functions
	  function activate() {
	    setValues();
	    PortfolioSrv.getBasicsRegistry.get().$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        editReflectionVm.fileTypes = dataReturn.fileTypes;
	        editReflectionVm.evidencesTypes = dataReturn.evidencesTypes;
	      }
	    });
	    getEvidences();
	  }
	
	  function getEvidences() {
	    var header = {
	      userId: editReflectionVm.userId,
	      startDate: editReflectionVm.startDate,
	      endDate: editReflectionVm.endDate
	    };
	    PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        editReflectionVm.evidences = dataReturn.data;
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function setValues() {
	    editReflectionVm.blogId = editReflectionVm.reflection.blogId;
	    editReflectionVm.description = editReflectionVm.reflection.blogDescription;
	    editReflectionVm.title = editReflectionVm.reflection.blogTitle;
	    editReflectionVm.blogIsEnlighted = editReflectionVm.reflection.blogIsEnlighted;
	    editReflectionVm.evidencesLinks = editReflectionVm.reflection.evidences;
	  }
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  // methos for add elements
	  function editReflection() {
	    editReflectionVm.disableButtonAdd = true;
	    var header = {
	      blogId: editReflectionVm.blogId,
	      description: editReflectionVm.description,
	      title: editReflectionVm.title,
	      isEnlighted: editReflectionVm.blogIsEnlighted ? 1 : 0,
	      evidencesLinks: editReflectionVm.evidencesLinks
	    };
	    PortfolioSrv.updateReflection.update(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        PortfolioModalSrv.setVariable({ status: dataReturn.status });
	        return $mdDialog.hide();
	      } else {
	        editReflectionVm.disableButtonAdd = false;
	      }
	    });
	  }
	
	  function showEvidencesToLink() {
	    editReflectionVm.errorMsgLinkEvidence = false;
	    editReflectionVm.isAddingEvidence = false;
	    editReflectionVm.isLinking = true;
	    editReflectionVm.isRegistry = false;
	  }
	
	  function showAddEvidenceToLink() {
	    editReflectionVm.errorMsgLinkEvidence = false;
	    editReflectionVm.isAddingEvidence = true;
	    editReflectionVm.isLinking = false;
	    editReflectionVm.isRegistry = false;
	
	    editReflectionVm.showUploader = false;
	    editReflectionVm.descriptionLinkEvidence = null;
	    editReflectionVm.titleLinkEvidence = null;
	    editReflectionVm.evidenceType = null;
	    editReflectionVm.fileTypeId = null;
	    editReflectionVm.fileName = null;
	    remove();
	  }
	
	  // methods for link evidence to a new reflection
	  function linkEvidence() {
	    if (editReflectionVm.selectedEvidence) {
	      var header = {
	        evidenceId: editReflectionVm.selectedEvidence.evidence.blogId,
	        evidenceFileName: editReflectionVm.selectedEvidence.evidence.blogTitle,
	        filetype: editReflectionVm.selectedEvidence.evidence.blogFileType
	      };
	      editReflectionVm.evidencesLinks.push(header);
	      cancel();
	    } else {
	      editReflectionVm.errorMsgLinkEvidence = true;
	    }
	  }
	
	  function setEvidence(evidence, index) {
	    if (editReflectionVm.selectedEvidence) {
	      editReflectionVm.evidences[editReflectionVm.selectedEvidence.pos].isSelected = stylesClass[0];
	      editReflectionVm.selectedEvidence = {
	        evidence: evidence,
	        pos: index
	      };
	      evidence.isSelected = stylesClass[1];
	    } else {
	      editReflectionVm.selectedEvidence = {
	        evidence: evidence,
	        pos: index
	      };
	      evidence.isSelected = stylesClass[1];
	    }
	    editReflectionVm.errorMsgLinkEvidence = false;
	  }
	
	  function removeLink(index) {
	    editReflectionVm.evidencesLinks.splice(index, 1);
	  }
	
	  function cancel() {
	    editReflectionVm.isAddingEvidence = false;
	    editReflectionVm.isLinking = false;
	    editReflectionVm.isRegistry = true;
	    editReflectionVm.evidences[editReflectionVm.selectedEvidence.pos].isSelected = stylesClass[0];
	    editReflectionVm.selectedEvidence = null;
	
	    editReflectionVm.descriptionLinkEvidence = null;
	    editReflectionVm.titleLinkEvidence = null;
	    editReflectionVm.evidenceType = null;
	    editReflectionVm.fileTypeId = null;
	    editReflectionVm.fileName = null;
	    remove();
	  }
	
	  // methods to add new evidence, and link to reflection
	  function addLinkToReflection() {
	    editReflectionVm.disableButtonAdd = true;
	    var header = {
	      userId: editReflectionVm.userId,
	      description: editReflectionVm.descriptionLinkEvidence,
	      title: editReflectionVm.titleLinkEvidence,
	      idSubitem: editReflectionVm.evidenceType,
	      fileType: editReflectionVm.fileTypeId,
	      fileName: editReflectionVm.fileName //este valor debe obtener cuando el archivo sea adjuntado
	    };
	    PortfolioSrv.addEvidence.add(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        var addedEvidence = {
	          blogId: dataReturn.reflectionId,
	          blogTitle: header.title,
	          blogFileType: header.fileType
	        };
	        editReflectionVm.selectedEvidence = {
	          evidence: addedEvidence,
	          pos: 0
	        };
	        linkEvidence();
	        editReflectionVm.disableButtonAdd = false;
	      }
	    });
	  }
	
	  //upload methods
	  function setFilterUploader() {
	    var name = '';
	    var extensions = '';
	    var pattern = void 0;
	    if (isImageType(editReflectionVm.fileTypeId)) {
	      name = 'imageFilter';
	      extensions = '|jpg|png|jpeg|bmp|gif|';
	      editReflectionVm.acceptFileType = 'image/*';
	      pattern = regexp.image;
	    }
	    if (isAudioType(editReflectionVm.fileTypeId)) {
	      name = 'audioFilter';
	      extensions = '|mp3|mpeg-4|wma|';
	      editReflectionVm.acceptFileType = 'audio/*';
	      pattern = regexp.audio;
	    }
	    if (isVideoType(editReflectionVm.fileTypeId)) {
	      name = 'videoFilter';
	      extensions = '|mp4|mkv|avi|wmv|';
	      editReflectionVm.acceptFileType = 'video/*';
	      pattern = regexp.video;
	    }
	    if (isDocumentType(editReflectionVm.fileTypeId)) {
	      name = 'documentFilter';
	      extensions = '|doc|docx|xls|xlsx|pdf|';
	      editReflectionVm.acceptFileType = 'application/pdf,application/vnd.ms-excel,application/msword';
	      pattern = regexp.document;
	    }
	
	    uploader.filters.pop();
	    uploader.filters.push({
	      name: name,
	      fn: function fn(item, options) {
	        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	        return extensions.indexOf(type) !== -1;
	      }
	    });
	    editReflectionVm.showUploader = true;
	    $('#inputFileUpload').val(null);
	    $('#inputFileUpload2').val(null);
	    editReflectionVm.disableButtonUpload = true;
	
	    if (editReflectionVm.attachFile != '') {
	      checkExtensionFile(editReflectionVm.fileTypeId, editReflectionVm.attachFile, pattern);
	    }
	  }
	
	  function checkExtensionFile(fileType, filename, pattern) {
	    var ext = filename.substring(filename.lastIndexOf(".") + 1);
	    if (pattern.test(ext)) {
	      editReflectionVm.errorMsgFileType = '';
	    } else {
	      editReflectionVm.errorMsgFileType = 'El archivo adjunto no es el de tipo seleccionado';
	    }
	  }
	
	  var uploader = $scope.uploader = new FileUploader({
	    url: SERVICE_URL_CONSTANT.rosario + '/file/uploadFilePortfolio?userId=' + editReflectionVm.userId
	  });
	
	  // a sync filter
	  uploader.filters.push({
	    name: 'syncFilter',
	    fn: function fn(item, options) {
	      console.log('syncFilter');
	      return this.queue.length < 10;
	    }
	  });
	
	  // an async filter
	  uploader.filters.push({
	    name: 'asyncFilter',
	    fn: function fn(item, options, deferred) {
	      console.log('asyncFilter');
	      setTimeout(deferred.resolve, 1e3);
	    }
	  });
	
	  uploader.filters.push({
	    name: 'emptyFilter',
	    fn: function fn(item, options) {
	      return true;
	    }
	  });
	
	  uploader.onWhenAddingFileFailed = function (item, filter, options) {
	    //console.info('onWhenAddingFileFailed', item, filter, options)
	    editReflectionVm.errorMsgFileType = 'El archivo no es el de tipo seleccionado';
	    editReflectionVm.disableButtonUpload = true;
	    $('#inputFileUpload').val(null);
	  };
	
	  uploader.onAfterAddingFile = function (fileItem) {
	    //console.info('onAfterAddingFile', fileItem)
	    editReflectionVm.errorMsgFileType = '';
	    editReflectionVm.disableButtonUpload = false;
	  };
	
	  uploader.onSuccessItem = function (fileItem, response, status, headers) {
	    //console.info('onSuccessItem', fileItem, response, status, headers)
	    if (response.status) {
	      editReflectionVm.fileName = response.data;
	      editReflectionVm.attachFile = fileItem.file.name;
	      editReflectionVm.errorMsg = false;
	    }
	  };
	  uploader.onErrorItem = function (fileItem, response, status, headers) {
	    //console.info('onErrorItem', fileItem, response, status, headers)
	    editReflectionVm.errorMsg = true;
	  };
	
	  uploader.onCompleteItem = function (fileItem, response, status, headers) {
	    //console.info('onCompleteItem', fileItem, response, status, headers)
	    editReflectionVm.loading = false;
	    editReflectionVm.STATIC_IMAGE_URL = true;
	  };
	
	  uploader.onBeforeUploadItem = function (item) {
	    var header = {
	      userId: editReflectionVm.userId
	    };
	    item.formData.push(header);
	    editReflectionVm.loading = true;
	    editReflectionVm.errorMsg = false;
	  };
	
	  function remove() {
	    editReflectionVm.attachFile = '';
	    uploader.clearQueue();
	    editReflectionVm.STATIC_IMAGE_URL = false;
	    editReflectionVm.loading = false;
	    editReflectionVm.errorMsg = false;
	    editReflectionVm.fileName = '';
	  }
	
	  //forms methods
	  function hasError(input) {
	    if (input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  }
	
	  function showErrorMessages(input) {
	    return input.$dirty || input.$touched;
	  }
	
	  function validateForm(form) {
	    if (editReflectionVm.itemConfig.idEvidence == editReflectionVm.registryId) {
	      return form.$invalid || editReflectionVm.fileName == '' || editReflectionVm.errorMsgFileType != '';
	    } else {
	      if (editReflectionVm.isAddingEvidence) {
	        return form.$invalid || editReflectionVm.fileName == '' || editReflectionVm.errorMsgFileType != '';
	      } else {
	        return form.$invalid;
	      }
	    }
	  }
	
	  function setClassTitle() {
	    if (editReflectionVm.itemConfig.idEvidence == editReflectionVm.registryId) {
	      //editReflectionVm.classTitle = 'col-md-3'
	      editReflectionVm.classTitle = 'col-md-3';
	    } else {
	      editReflectionVm.classTitle = 'col-md-3';
	    }
	  }
	
	  //utils function
	  function isImageType(fileTypeId) {
	    return fileTypeId == editReflectionVm.globalFileTypes.image;
	  }
	
	  function isDocumentType(fileTypeId) {
	    return fileTypeId == editReflectionVm.globalFileTypes.document;
	  }
	
	  function isVideoType(fileTypeId) {
	    return fileTypeId == editReflectionVm.globalFileTypes.video;
	  }
	
	  function isAudioType(fileTypeId) {
	    return fileTypeId == editReflectionVm.globalFileTypes.audio;
	  }
	};
	
	exports.default = EditReflectionCtrl;
	
	
	EditReflectionCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DeleteReflectionCtrl = function DeleteReflectionCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
		_classCallCheck(this, DeleteReflectionCtrl);
	
		var deleteReflectionVm = this;
		var shared = PortfolioModalSrv.getVariable();
	
		deleteReflectionVm.reflection = shared.reflection;
		deleteReflectionVm.userId = shared.userId;
		deleteReflectionVm.startDate = shared.startDate;
		deleteReflectionVm.endDate = shared.endDate;
	
		//methods declaration
		deleteReflectionVm.close = close;
		deleteReflectionVm.deleteReflection = deleteReflection;
	
		activate();
	
		//initial functions
		function activate() {
			setValues();
			getEvidences();
		}
	
		function getEvidences() {
			var header = {
				userId: deleteReflectionVm.userId,
				startDate: deleteReflectionVm.startDate,
				endDate: deleteReflectionVm.endDate
			};
	
			PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					deleteReflectionVm.evidences = dataReturn.data;
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function setValues() {
			deleteReflectionVm.blogId = deleteReflectionVm.reflection.blogId;
			deleteReflectionVm.description = deleteReflectionVm.reflection.blogDescription;
			deleteReflectionVm.title = deleteReflectionVm.reflection.blogtitle;
			deleteReflectionVm.blogIsEnlighted = deleteReflectionVm.reflection.blogIsEnlighted;
			deleteReflectionVm.evidencesLinks = deleteReflectionVm.reflection.evidences;
		}
	
		function close() {
			PortfolioModalSrv.setVariable({ status: false });
	
			return $mdDialog.hide();
		}
	
		function deleteReflection() {
			var header = {
				blogId: deleteReflectionVm.blogId
			};
	
			console.log(header);
			PortfolioSrv.deleteReflection.delete(header).$promise.then(function (dataReturn) {
	
				if (dataReturn.status) {
					PortfolioModalSrv.setVariable({ status: dataReturn.status });
	
					return $mdDialog.hide();
				}
			});
		}
	};
	
	exports.default = DeleteReflectionCtrl;
	
	
	DeleteReflectionCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT'];

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfirmDialogCtrl = function ConfirmDialogCtrl($scope, $mdDialog, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService) {
	  _classCallCheck(this, ConfirmDialogCtrl);
	
	  // constants
	  var disableAccessVm = this;
	  var shared = PortfolioModalSrv.getVariable();
	  //variable
	  disableAccessVm.idOwner = shared.idOwner;
	  disableAccessVm.user = shared.user;
	
	  //methods
	  disableAccessVm.disableAccess = disableAccess;
	  disableAccessVm.close = close;
	
	  function close() {
	    PortfolioModalSrv.setVariable({ status: false });
	    return $mdDialog.hide();
	  }
	
	  function disableAccess(user) {
	    var header = {
	      idOwner: disableAccessVm.idOwner,
	      idGuest: disableAccessVm.user.idGuest
	    };
	    PortfolioSrv.disableUserAccess.disable(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        PortfolioModalSrv.setVariable({ status: dataReturn.status });
	        return $mdDialog.hide();
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	};
	
	exports.default = ConfirmDialogCtrl;
	
	
	ConfirmDialogCtrl.$inject = ['$scope', '$mdDialog', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', '$cookies', '$state'];

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GuidelineDetailsCtrl = function GuidelineDetailsCtrl($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig) {
	  _classCallCheck(this, GuidelineDetailsCtrl);
	
	  // constants
	  var guidelineVm = this;
	  var sharedVariable = PortfolioModalSrv.getVariable();
	  guidelineVm.guideline = sharedVariable.guideline;
	  guidelineVm.guideline.text = guidelineVm.guideline.active == 1 ? 'Activo' : 'Inactivo';
	  // methods
	  guidelineVm.close = close;
	
	  activate();
	  function activate() {}
	
	  function close() {
	    return $mdDialog.hide();
	  }
	};
	
	exports.default = GuidelineDetailsCtrl;
	
	
	GuidelineDetailsCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig'];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _report = __webpack_require__(345);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _report3 = __webpack_require__(349);
	
	var _report4 = _interopRequireDefault(_report3);
	
	var _reportListCtrl = __webpack_require__(350);
	
	var _reportListCtrl2 = _interopRequireDefault(_reportListCtrl);
	
	var _powerbiWorkPlanCtrl = __webpack_require__(355);
	
	var _powerbiWorkPlanCtrl2 = _interopRequireDefault(_powerbiWorkPlanCtrl);
	
	var _staticReportCtrl = __webpack_require__(356);
	
	var _staticReportCtrl2 = _interopRequireDefault(_staticReportCtrl);
	
	var _reportSrv = __webpack_require__(360);
	
	var _reportSrv2 = _interopRequireDefault(_reportSrv);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	var _reportModalCtrl = __webpack_require__(361);
	
	var _reportModalCtrl2 = _interopRequireDefault(_reportModalCtrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(362);
	
	__webpack_require__(366);
	
	$.getScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/1.11.2/jquery.min.js");
	
	$.getScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.11.4/jquery-ui.min.js");
	
	$.getScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui-touch-punch/0.2.3/jquery.ui.touch-punch.min.js");
	
	exports.default = angular.module('report', [_reportSrv2.default]).config(_report2.default).controller('ReportListCtrl', _reportListCtrl2.default).controller('powerbiWorkPlanCtrl', _powerbiWorkPlanCtrl2.default).controller('StaticReportCtrl', _staticReportCtrl2.default).controller('reportModalCtrl', _reportModalCtrl2.default).run(_report4.default).constant("report", [{
		title: "Reportes",
		icon: "mdi-action-assignment-turned-in",
		// 'moduleId': GlobalConfig.menuModulesId.Reportes,
		subMenu: [
		//  {
		//   	title: 'Reportes Globales',
		//   	url: "report.reportGlobal",
		// 		rolesAllowed: [
		// 			GlobalConfig.userRolesIds.teacher,
		// 			GlobalConfig.userRolesIds.workPlanAdmin,
		// 			GlobalConfig.userRolesIds.approver,
		// 			GlobalConfig.userRolesIds.reviewer,
		// 			GlobalConfig.userRolesIds.unitAdmin,
		// 			GlobalConfig.userRolesIds.gerencialConsultant,
		// 			GlobalConfig.userRolesIds.generalAdmin,
		// 		]
		// },
		{
			title: "Reportes Estáticos",
			url: "report.staticReport",
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.approver, _globalConfig2.default.userRolesIds.reviewer, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.generalAdmin]
		}, {
			title: 'Reportes Dinámicos',
			url: "report.reportList",
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.approver, _globalConfig2.default.userRolesIds.reviewer, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.generalAdmin]
		}, {
			title: "Reporte Plan de Trabajo",
			url: "report.powerbiWorkPlan",
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.approver, _globalConfig2.default.userRolesIds.reviewer, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.generalAdmin]
		}]
	}]).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = routes;
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
		$locationProvider.html5Mode(true);
		$stateProvider.state('report', {
			abstract: false,
			url: '/report',
			redirectTo: 'report.reportList',
			views: {
				'': {
					template: __webpack_require__(168)
				},
				'content': {
					template: __webpack_require__(169)
				},
				'aside': {
					template: __webpack_require__(170),
					controller: 'AsideCtrl'
				},
				'header': {
					template: __webpack_require__(171),
					controller: 'HeaderCtrl'
				},
				'chatbox': {
					template: __webpack_require__(172),
					controller: 'ChatboxController',
					controllerAs: 'chatbox'
				},
				'footer': {
					template: __webpack_require__(177)
				}
			},
			data: {
				displayName: 'Inicio'
			}
		}).state('report.staticReport', {
			abstract: false,
			url: '/static',
			template: __webpack_require__(346),
			controller: 'StaticReportCtrl',
			controllerAs: 'staticReportVM',
			data: {
				displayName: 'Reportes Estáticos'
			}
		}).state('report.reportList', {
			abstract: false,
			url: '/list',
			template: __webpack_require__(347),
			controller: 'ReportListCtrl',
			controllerAs: 'reportListVm',
			params: {
				globalView: true
			},
			data: {
				displayName: 'Reportes'
			}
		}).state('report.reportGlobal', {
			abstract: false,
			url: '/list-global',
			template: __webpack_require__(347),
			controller: 'ReportListCtrl',
			controllerAs: 'reportListVm',
			params: {
				globalView: false
			},
			data: {
				displayName: 'Reportes'
			}
		}).state('report.powerbiWorkPlan', {
			abstract: false,
			url: '/workplanPowerbi',
			template: __webpack_require__(348),
			controller: 'powerbiWorkPlanCtrl',
			controllerAs: 'pbWpCtrl'
		});
	}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v no-padding-r m-b-xs\"> <h3>Reportes Estáticos</h3> <p class=text-16-important>Seleccione los parámetros para la generación del reporte requerido </p> </div> </div> </div> <form name=staticReport novalidate> <div class=\"row blanco\" style=\"height:calc(100% - 110px)\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <div class=col-md-12> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del Reporte</h5> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=staticReportVM.hasError(staticReport.staticReportName)> <label for=staticReportName class=control-label>Reporte*</label> <select name=staticReportName ng-model=staticReportVM.staticReportName ng-options=\"name as name.report_name for name in staticReportVM.reportName\" class=form-control ng-disabled=staticReportVM.isEditing required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-xs\" ng-messages=staticReport.staticReportName.$error ng-show=staticReportVM.showErrorMessages(staticReport.staticReportName)> <div ng-message=required>El reporte es requerido</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=staticReportVM.hasError(staticReport.workplan)> <label for=workplan class=control-label>Plan de Trabajo*</label> <select name=workplan ng-model=staticReportVM.workplan ng-options=\"workplanList.id_code as workplanList.ds_name\n                                for workplanList in staticReportVM.workPlanListCombo\" class=form-control ng-change=\"staticReportVM.changeSelect('workplan')\" required> <option value=\"\" disabled=disabled>Seleccione</option> </select>  <div class=\"control-label text-xs\" ng-messages=staticReport.workplan.$error ng-show=staticReportVM.showErrorMessages(staticReport.workplan)> <div ng-message=required>El plan de trabajo es requerido</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=staticReportVM.hasError(staticReport.academicUnit)> <label for=academicUnit class=control-label>Unidad Académica</label> <select name=academicUnit ng-model=staticReportVM.academicUnit ng-options=\"academicUnitList.faculty_id as academicUnitList.faculty_name\n                                for academicUnitList in staticReportVM.academicUnitListCombo\" class=form-control ng-disabled=staticReportVM.isEditing ng-change=\"staticReportVM.changeSelect('academicUnit')\"> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"col-md-6 no-padding-r\"> <label class=control-label>Profesor</label> <md-autocomplete class=\"autocomplete col-md-12 m-r-xs\" ng-disabled=\"staticReportVM.rolId == '13'\" md-clear-button=false md-item-text=teacher.teacherName md-min-length=0 md-selected-item=staticReportVM.selectedTeacher md-search-text=staticReportVM.searchText md-items=\"teacher in staticReportVM.searchTeacher(staticReportVM.searchText)\" placeholder=\"Buscar profesor...\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{teacher.teacherName}}</span> </md-item-template> <md-not-found> No se encontraron usuarios... </md-not-found> </md-autocomplete> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-7 no-padding\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=staticReportVM.resetForm()>Limpiar</md-button> </div> <div class=\"col-md-5 no-padding text-right\"> <md-button class=\"btn btn-fw btn-primary text-xs no-margin\" ng-click=staticReportVM.generate() ng-disabled=\"staticReportVM.buttonDisable || staticReportVM.validateForm(staticReport)\"> Generar Reporte </md-button> </div> </div> </div> </div> </div> <a id=download href=\"\" download></a> </div></form> ";

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"col-xs-12 p-h-lg p-t-md m-b-xs title\"> <h3 class=\"p-l pull-left\">Reportes</h3> <div class=col-xs-12> <md-button class=\"btn btn-link ng-binding\" ng-disabled=reportDisable ng-click=\"reportListVm.exportToExcel('#table1')\"> <span class=\"glyphicon glyphicon-share\"></span> Exportar datos </md-button> <md-progress-circular ng-if=loadingLoop style=display:inline-block class=md-hue-2 md-diameter=20px></md-progress-circular> </div> <div class=pull-right> <md-button class=\"btn btn-fw btn-cancel\" ng-disabled=reportDisable ng-click=reportListVm.generate()>Mis Reportes</md-button> <md-button class=\"btn btn-fw btn-cancel\" ng-disabled=reportGuardar ng-click=reportListVm.showModalToEnterTitle() ng-show=GlobalView>Guardar Reporte</md-button> </div> </div> </div> <div class=row style=overflow-x:scroll> <div class=col-xs-12> <p style=width:800px></p> <div id=output></div> </div> </div> ";

/***/ }),
/* 348 */
303,
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'report'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, report) {
	  MenuConstant[0]['menu'].push(report);
	}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReportListCtrl = function ReportListCtrl($rootScope, $scope, $timeout, $mdDialog, $cookies, reportSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $window) {
		_classCallCheck(this, ReportListCtrl);
	
		var reportListVm = this;
		var currentUser = JSON.parse($cookies.get('currentUser'));
		var roleId = $cookies.get('hasRoleId');
	
		// VARIABLES
		reportListVm.viewLoaded = false;
		reportListVm.active = GlobalConfig.generals.active;
		reportListVm.notActive = GlobalConfig.generals.notActive;
		reportListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory;
		reportListVm.planningFinish = true;
		reportListVm.showModalToEnterTitle = showModalToEnterTitle;
		reportListVm.exportToExcel = exportToExcel;
		reportListVm.generate = generate;
		reportListVm.exportToExcelSaveTitle = exportToExcelSaveTitle;
		reportListVm.showdata1 = showdata1;
		reportListVm.isDinamic = $stateParams.globalView;
		// reportListVm.finalize=finalize;
		$scope.classPlanning = '';
		$scope.reportDisable = true;
		$scope.reportGuardar = true;
		$scope.reportAbrir = true;
		$scope.GlobalView = $stateParams.globalView;
		$scope.data = {};
		$scope.param = {};
	
		var post = {
			workplanId: currentUser.workplanId,
			teacherId: currentUser.teacherId,
			userId: currentUser.id,
			rolId: roleId
		};
	
		console.log('current user', currentUser);
	
		$rootScope.$on('rootScope:ReportEmit', function (event, data) {
			// alert(data); // 'Emit!'
			activate();
		});
	
		activate();
	
		// METHODS
		reportListVm.roles = [];
	
		function activate() {
	
			var parma = {
				workplanId: currentUser.workplanId,
				teacherId: currentUser.teacherId,
				userId: currentUser.id,
				rolId: roleId
			};
	
			getReportDynamicData(parma);
		}
	
		function showmode() {
			//Funcion de ejemplo del pluggin
			$.getJSON("https://pivottable.js.org/examples/mps.json", function (mps) {
				$("#output2").pivotUI(mps, {
					onRefresh: function onRefresh(config) {
						var config_copy = JSON.parse(JSON.stringify(config));
	
						//delete some values which are functions
						delete config_copy["aggregators"];
						delete config_copy["renderers"];
						//delete some bulky default values
						delete config_copy["rendererOptions"];
						delete config_copy["localeStrings"];
	
						$("#output").text(JSON.stringify(config_copy, undefined, 2));
					}
				});
			});
		}
	
		function showdata(data) {
			$scope.data = data;
			$scope.reportDisable = false;
			$scope.reportGuardar = false;
			//****************************** LO ANTIGUO *********************************** */
			// $("#rosario_report_wrapper").html('')
			// $("#rosario_report_wrapper").append('<textarea id="output" style="float: left; width: 250px; height: 500px; margin: 10px; display: none;" readonly></textarea><div id="output2" style="margin: 30px;"></div>')
	
			$("#output").html('');
			$("#output").append('<textarea id="output" style="float: left; width: 250px; height: 500px; margin: 10px; display: none;" readonly></textarea><div id="output2" style="margin: 30px;"></div>');
	
			// $("#rosario_report_wrapper #output2").pivotUI(data, {
			// 	onRefresh: function (config) {
			// 		var config_copy = JSON.parse(JSON.stringify(config));
			// 		//delete some values which are functions
			// 		delete config_copy["aggregators"];
			// 		delete config_copy["renderers"];
			// 		//delete some bulky default values
			// 		// delete config_copy["rendererOptions"];
			// 		$("#rosario_report_wrapper #output").text(JSON.stringify(config_copy, undefined, 2));
			// 	},
			// 	localeStrings: { totals: "Total" },
			// 	rendererOptions: { localeStrings: { totals: "Total" } },
			// 	renderers: {
			// 		"Tabla": $.pivotUtilities.renderers["Table"],
			// 		"Tabla Barras": $.pivotUtilities.renderers["Table Barchart"],
			// 		"Mapa Calor": $.pivotUtilities.renderers["Heatmap"],
			// 		"Mapa Calor Fila": $.pivotUtilities.renderers["Row Heatmap"],
			// 		"Mapa Calor Columna": $.pivotUtilities.renderers["Col Heatmap"],
			// 		"Mapa Árbol": $.pivotUtilities.d3_renderers["Treemap"],
			// 		"Graf Barra Horizontal": $.pivotUtilities.c3_renderers["Horizontal Bar Chart"],
			// 		"Graf Barra Apilado Horizontal": $.pivotUtilities.c3_renderers["Horizontal Stacked Bar Chart"],
			// 		"Graf Barra": $.pivotUtilities.c3_renderers["Bar Chart"],
			// 		"Graf Barra Apilado": $.pivotUtilities.c3_renderers["Stacked Bar Chart"],
			// 		"Graf Linea": $.pivotUtilities.c3_renderers["Line Chart"],
			// 		"Graf Area": $.pivotUtilities.c3_renderers["Area Chart"],
			// 		"Graf Dispersión": $.pivotUtilities.c3_renderers["Scatter Chart"],
			// 		"Exportar a TSV": $.pivotUtilities.export_renderers["TSV Export"]
			// 	},
			// 	aggregators: {
			// 		"Contar": $.pivotUtilities.aggregators["Count"],
			// 		"Contar Valores Unicos": $.pivotUtilities.aggregators["Count Unique Values"],
			// 		"Listar Valores Unicos": $.pivotUtilities.aggregators["List Unique Values"],
			// 		"Sumar": $.pivotUtilities.aggregators["Sum"],
			// 		"Sumar Enteros": $.pivotUtilities.aggregators["Integer Sum"],
			// 		"Promedio": $.pivotUtilities.aggregators["Average"],
			// 		"Mediana": $.pivotUtilities.aggregators["Median"],
			// 		"Muestra Variación": $.pivotUtilities.aggregators["Sample Variance"],
			// 		"Muestra Desviación Estandar": $.pivotUtilities.aggregators["Sample Standart Deviation"],
			// 		"Minimo": $.pivotUtilities.aggregators["Minimum"],
			// 		"Maximo": $.pivotUtilities.aggregators["Maximum"],
			// 		"Primero": $.pivotUtilities.aggregators["First"],
			// 		"Ultimo": $.pivotUtilities.aggregators["Last"],
			// 		"Suma sobre Suma": $.pivotUtilities.aggregators["Sum over Sum"],
			// 		"80% Limite Superior": $.pivotUtilities.aggregators["80% Upper Bound"],
			// 		"80% Limite Inferior": $.pivotUtilities.aggregators["80% Lower Bound"],
			// 		"Suma Fraccion del Total": $.pivotUtilities.aggregators["Sum as Fraction of Total"],
			// 		"Suma Fraccion de Filas": $.pivotUtilities.aggregators["Sum as Fraction of Rows"],
			// 		"Suma Fraccion de Columnas": $.pivotUtilities.aggregators["Sum as Fraction of Columns"],
			// 		"Contar Fraccion del Total": $.pivotUtilities.aggregators["Count as Fraction of Total"],
			// 		"Contar Fraccion de Filas": $.pivotUtilities.aggregators["Count as Fraction of Rows"],
			// 		"Contar Fraccion de Columnas": $.pivotUtilities.aggregators["Count as Fraction of Columns"]
			// 	}
			// });
			//************************************LO NUEVO ****************************************** */
			$("#output #output2").pivotUI(data, {
				onRefresh: function onRefresh(config) {
					var config_copy = JSON.parse(JSON.stringify(config));
					//delete some values which are functions
					delete config_copy["aggregators"];
					delete config_copy["renderers"];
					//delete some bulky default values
					// delete config_copy["rendererOptions"];
					$("#rosario_report_wrapper #output").text(JSON.stringify(config_copy, undefined, 2));
				},
				localeStrings: { totals: "Total" },
				rendererOptions: { localeStrings: { totals: "Total" } },
				renderers: {
					"Tabla": $.pivotUtilities.renderers["Table"],
					"Tabla Barras": $.pivotUtilities.renderers["Table Barchart"],
					"Mapa Calor": $.pivotUtilities.renderers["Heatmap"],
					"Mapa Calor Fila": $.pivotUtilities.renderers["Row Heatmap"],
					"Mapa Calor Columna": $.pivotUtilities.renderers["Col Heatmap"],
					"Mapa Árbol": $.pivotUtilities.d3_renderers["Treemap"],
					"Graf Barra Horizontal": $.pivotUtilities.c3_renderers["Horizontal Bar Chart"],
					"Graf Barra Apilado Horizontal": $.pivotUtilities.c3_renderers["Horizontal Stacked Bar Chart"],
					"Graf Barra": $.pivotUtilities.c3_renderers["Bar Chart"],
					"Graf Barra Apilado": $.pivotUtilities.c3_renderers["Stacked Bar Chart"],
					"Graf Linea": $.pivotUtilities.c3_renderers["Line Chart"],
					"Graf Area": $.pivotUtilities.c3_renderers["Area Chart"],
					"Graf Dispersión": $.pivotUtilities.c3_renderers["Scatter Chart"],
					"Exportar a TSV": $.pivotUtilities.export_renderers["TSV Export"]
				},
				aggregators: {
					"Contar": $.pivotUtilities.aggregators["Count"],
					"Contar Valores Unicos": $.pivotUtilities.aggregators["Count Unique Values"],
					"Listar Valores Unicos": $.pivotUtilities.aggregators["List Unique Values"],
					"Sumar": $.pivotUtilities.aggregators["Sum"],
					"Sumar Enteros": $.pivotUtilities.aggregators["Integer Sum"],
					"Promedio": $.pivotUtilities.aggregators["Average"],
					"Mediana": $.pivotUtilities.aggregators["Median"],
					"Muestra Variación": $.pivotUtilities.aggregators["Sample Variance"],
					"Muestra Desviación Estandar": $.pivotUtilities.aggregators["Sample Standart Deviation"],
					"Minimo": $.pivotUtilities.aggregators["Minimum"],
					"Maximo": $.pivotUtilities.aggregators["Maximum"],
					"Primero": $.pivotUtilities.aggregators["First"],
					"Ultimo": $.pivotUtilities.aggregators["Last"],
					"Suma sobre Suma": $.pivotUtilities.aggregators["Sum over Sum"],
					"80% Limite Superior": $.pivotUtilities.aggregators["80% Upper Bound"],
					"80% Limite Inferior": $.pivotUtilities.aggregators["80% Lower Bound"],
					"Suma Fraccion del Total": $.pivotUtilities.aggregators["Sum as Fraction of Total"],
					"Suma Fraccion de Filas": $.pivotUtilities.aggregators["Sum as Fraction of Rows"],
					"Suma Fraccion de Columnas": $.pivotUtilities.aggregators["Sum as Fraction of Columns"],
					"Contar Fraccion del Total": $.pivotUtilities.aggregators["Count as Fraction of Total"],
					"Contar Fraccion de Filas": $.pivotUtilities.aggregators["Count as Fraction of Rows"],
					"Contar Fraccion de Columnas": $.pivotUtilities.aggregators["Count as Fraction of Columns"]
				}
			});
		}
	
		function getReportDynamicData(post) {
			return reportSrv.getReportDynamic.post(post).$promise.then(function (dataResult) {
				if (dataResult.status) {
					showdata(dataResult.reportData);
				} else {
					console.log("Error");
				}
			}).catch(function (error) {
				console.error(error);
			});
		}
	
		function showModalToEnterTitle() {
			var THIS = this;
			var SCOPE = $scope;
			var temp1 = [],
			    temp2 = [];
			SCOPE.param = {};
	
			var config = $("#output2").data("pivotUIOptions");
	
			$('.pvtUi tr td.pvtCols li').each(function () {
				var str = this.innerText;
				str = str.substring(0, str.length - 1);
				temp1.push($.trim(str));
			});
	
			$('.pvtUi tr td.pvtRows li').each(function () {
				var str = this.innerText;
				str = str.substring(0, str.length - 1);
				temp2.push($.trim(str));
			});
	
			if (temp1.lenght > 0 || temp2.length > 0) {
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', '$window', 'reportSrv', '$cookies', function ($scope, $mdDialog) {
						$scope.saveReport = function () {
							$scope.inactive = true;
	
							if (typeof $scope.reportName === 'undefined') {
								console.log("Error");
							} else {
								return reportSrv.ValidNameReport.post({ title: $scope.reportName }).$promise.then(function (result) {
									if (result.data[0].cant_name == 0) {
										var config_copy = JSON.parse(JSON.stringify(config));
										//delete some values which will not serialize to JSON
										delete config_copy["aggregators"];
										delete config_copy["renderers"];
	
										var roleid = $cookies.get('hasRoleId');
										var user = $cookies.get('currentUser');
										var userId = JSON.parse(user);
	
										SCOPE.param = {
											title: $scope.reportName,
											config: JSON.stringify(config_copy),
											idRole: roleid,
											idUser: userId.id
										};
	
										$mdDialog.hide();
										return reportSrv.SaveReportData.post(SCOPE.param).$promise.then(function (dataResult) {
											if (dataResult.status) {
												THIS.exportToExcelSaveTitle();
												THIS.exportToExcel($scope.reportName);
												$scope.reportName = '';
											} else {
												console.log("Error");
											}
										}).catch(function (error) {
											console.error(error);
										});
									} else {
										$mdDialog.show({
											controller: ['$scope', '$mdDialog', '$window', 'reportSrv', '$cookies', function ($scope, $mdDialog) {
												$scope.finalize = function () {
													$mdDialog.hide();
												};
											}],
											template: __webpack_require__(351),
											clickOutsideToClose: false
										});
									}
								});
							}
						};
	
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(352),
					clickOutsideToClose: false
				});
			}
		}
	
		function exportToExcelSaveTitle() {
	
			var THIS = this;
			var SCOPE = $scope;
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', '$window', 'reportSrv', '$cookies', function ($scope, $mdDialog) {
					$scope.finalize = function () {
						$mdDialog.hide();
					};
	
					$scope.close = function () {
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(353),
				clickOutsideToClose: false
			});
		}
	
		function exportToExcel() {
			$scope.loadingLoop = true;
			TableToExcel.convert($window.document.querySelector(".pvtTable"), {
				name: 'reporte-dinamico-' + moment().format('DD/MM/YYYY') + '.xlsx',
				autoStyle: true,
				sheet: {
					name: "hoja 1"
				}
			});
			$timeout(function () {
				return $scope.loadingLoop = false;
			}, 3000);
		}
	
		function generate(data) {
			var THIS = this;
			var SCOPE = $scope;
			console.log($scope.data);
			var data = JSON.stringify($scope.data, undefined, 2);
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', '$window', '$cookies', function ($scope, $mdDialog) {
	
					var roleid = $cookies.get('hasRoleId');
					var user = $cookies.get('currentUser');
					var userId = JSON.parse(user);
					var isDinamic = reportListVm.isDinamic;
	
					$scope.selectValue = {};
	
					var param = { idRole: roleid, idUser: userId.id, isDinamic: isDinamic };
	
					reportSrv.getReportData.get(param).$promise.then(function (dataResult) {
	
						if (dataResult.status) {
	
							$scope.selectValue = dataResult.reportData;
							// $mdDialog.hide()
						} else {
							console.log("Error");
						}
					}).catch(function (error) {
						console.error(error);
					});
	
					$scope.getSelectedReport = function (reportData) {
						if (typeof $scope.reportData !== 'undefined') {
							SCOPE.reportAbrir = false;
							console.log($scope.reportData);
							return $scope.reportData.title;
						} else {
							SCOPE.reportAbrir = true;
							return "Seleccione un Reporte";
						}
					};
	
					$scope.abrir = function () {
						if (typeof $scope.reportData !== 'undefined') {
							var jsonData = $scope.reportData;
							// jsonData
							var colRows = JSON.parse(jsonData.jsonData);
							THIS.showdata1(SCOPE.data, colRows);
							$mdDialog.hide();
						}
					};
	
					$scope.close = function () {
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(354),
				clickOutsideToClose: false
			});
		}
	
		function showdata1(data, colRows) {
	
			$('#rosario_report_wrapper').html('');
	
			colRows.localeStrings.totals = "Total";
			colRows.rendererOptions.localeStrings.totals = "Total";
			colRows.renderers = {
				"Tabla": $.pivotUtilities.renderers["Table"],
				"Tabla Barras": $.pivotUtilities.renderers["Table Barchart"],
				"Mapa Calor": $.pivotUtilities.renderers["Heatmap"],
				"Mapa Calor Fila": $.pivotUtilities.renderers["Row Heatmap"],
				"Mapa Calor Columna": $.pivotUtilities.renderers["Col Heatmap"],
				"Mapa Árbol": $.pivotUtilities.d3_renderers["Treemap"],
				"Graf Barra Horizontal": $.pivotUtilities.c3_renderers["Horizontal Bar Chart"],
				"Graf Barra Apilado Horizontal": $.pivotUtilities.c3_renderers["Horizontal Stacked Bar Chart"],
				"Graf Barra": $.pivotUtilities.c3_renderers["Bar Chart"],
				"Graf Barra Apilado": $.pivotUtilities.c3_renderers["Stacked Bar Chart"],
				"Graf Linea": $.pivotUtilities.c3_renderers["Line Chart"],
				"Graf Area": $.pivotUtilities.c3_renderers["Area Chart"],
				"Graf Dispersión": $.pivotUtilities.c3_renderers["Scatter Chart"],
				"Exportar a TSV": $.pivotUtilities.export_renderers["TSV Export"]
			};
	
			colRows.aggregators = {
				"Contar": $.pivotUtilities.aggregators["Count"],
				"Contar Valores Unicos": $.pivotUtilities.aggregators["Count Unique Values"],
				"Listar Valores Unicos": $.pivotUtilities.aggregators["List Unique Values"],
				"Sumar": $.pivotUtilities.aggregators["Sum"],
				"Sumar Enteros": $.pivotUtilities.aggregators["Integer Sum"],
				"Promedio": $.pivotUtilities.aggregators["Average"],
				"Mediana": $.pivotUtilities.aggregators["Median"],
				"Muestra Variación": $.pivotUtilities.aggregators["Sample Variance"],
				"Muestra Desviación Estandar": $.pivotUtilities.aggregators["Sample Standart Deviation"],
				"Minimo": $.pivotUtilities.aggregators["Minimum"],
				"Maximo": $.pivotUtilities.aggregators["Maximum"],
				"Primero": $.pivotUtilities.aggregators["First"],
				"Ultimo": $.pivotUtilities.aggregators["Last"],
				"Suma sobre Suma": $.pivotUtilities.aggregators["Sum over Sum"],
				"80% Limite Superior": $.pivotUtilities.aggregators["80% Upper Bound"],
				"80% Limite Inferior": $.pivotUtilities.aggregators["80% Lower Bound"],
				"Suma Fraccion del Total": $.pivotUtilities.aggregators["Sum as Fraction of Total"],
				"Suma Fraccion de Filas": $.pivotUtilities.aggregators["Sum as Fraction of Rows"],
				"Suma Fraccion de Columnas": $.pivotUtilities.aggregators["Sum as Fraction of Columns"],
				"Contar Fraccion del Total": $.pivotUtilities.aggregators["Count as Fraction of Total"],
				"Contar Fraccion de Filas": $.pivotUtilities.aggregators["Count as Fraction of Rows"],
				"Contar Fraccion de Columnas": $.pivotUtilities.aggregators["Count as Fraction of Columns"]
			};
	
			$("#rosario_report_wrapper").append('<textarea id="output" style="float: left; width: 250px; height: 500px; margin: 10px; display: none;" readonly></textarea><div id="output2" style="margin: 30px;"></div>');
			$("#rosario_report_wrapper #output2").pivotUI(data, colRows, true);
		}
	};
	
	exports.default = ReportListCtrl;
	
	
	ReportListCtrl.$inject = ['$rootScope', '$scope', '$timeout', '$mdDialog', '$cookies', 'reportSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$window'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde style=margin-bottom:40px>Nombre ya existe.</h3> </div> </div> <div class=\"row text-right\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=finalize()>Cerrar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde style=margin-bottom:20px>Guardar Reporte</h3> <md-input-container> <label>Nombre del reporte</label> <input type=text ng-model=reportName ng-model-options=\"{ debounce: 300 }\" required md-maxlength=50> </md-input-container> </div> </div> <div class=\"row text-right\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-disabled=\"!reportName || inactive\" ng-click=saveReport()>Guardar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>Reporte se ha guardado con éxito</h3> <p></p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=finalize()>Cerrar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>Mis Reportes</h3> <div layout=row layout-align=\"space-between center\"> <span style=font-size:14px;width:181px;text-align:center>Nombre del reporte</span> <md-input-container style=margin-right:10px> <md-select ng-model=reportData md-selected-text=getSelectedReport(reportData)> <md-option ng-repeat=\"reportData in selectValue\" ng-value=reportData>{{reportData.title}}</md-option> </md-select> </md-input-container> </div> </div> </div> <div class=\"row text-right\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-disabled=reportAbrir ng-click=abrir()>Abrir</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @name APP cmmApp
	 * @autor daniel.molina@u-planner.com
	 * @description vista tabla para forecast
	 * # name controller --> powerbiPortofolioCtrl
	 * # alias: --> powerbiCtrl
	 */
	var powerbiWorkPlanCtrl = function powerbiWorkPlanCtrl($http, $scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, LOCAL_ENV_CONSTANT) {
	  _classCallCheck(this, powerbiWorkPlanCtrl);
	
	  $scope.title = 'Reporte Plan de Trabajo Profesores';
	
	  $scope.POWER = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY3;
	
	  $scope.workspaceId = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_GROUP_ID;
	  $scope.reportId = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY3;
	};
	
	exports.default = powerbiWorkPlanCtrl;
	
	
	powerbiWorkPlanCtrl.$inject = ['$http', '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'LOCAL_ENV_CONSTANT'];

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StaticReportCtrl = function () {
		function StaticReportCtrl($scope, $timeout, $mdDialog, $stateParams, $cookies, reportSrv, GlobalConfig, $state, WorkPlanModalSrv, GlobalSrv, permissions, UserInfoConstant) {
			_classCallCheck(this, StaticReportCtrl);
	
			var currentUserCookie = $cookies.get('currentUser');
			this.listUser = currentUserCookie ? JSON.parse(currentUserCookie) : {};
			this.$scope = $scope;
			this.rolId = $cookies.get('hasRoleId');
			this.reportSrv = reportSrv;
			this.GlobalConfig = GlobalConfig;
			this.$mdDialog = $mdDialog;
			this.permissions = permissions;
			this.buttonDisable = false;
			this.UserInfoConstant = UserInfoConstant;
			this.timeout = $timeout;
	
			this.header = {
				teacherId: this.listUser.teacherId,
				workplanId: this.listUser.workplanId,
				workplanTeacherActivityId: $stateParams.workplanTeacherActivityId,
				name: this.listUser.name,
				id: this.listUser.id
			};
	
			this.workPlanListCombo = [];
			this.academicUnitListCombo = [];
			this.teachers = [];
			this.selectedTeacher = '';
			this.searchText = '';
			this.reportName = [];
			this.workPlanName = null;
			this.academicUnitName = null;
			this.teacherName = null;
	
			this.activate();
		} // FIN DEL CONSTRUCTOR
	
		_createClass(StaticReportCtrl, [{
			key: 'showErrorMessages',
			value: function showErrorMessages(input) {
				return input.$dirty || input.$touched;
			}
		}, {
			key: 'hasError',
			value: function hasError(input) {
				if (input.$invalid && (input.$dirty || input.$touched)) {
					return 'has-error';
				}
			}
		}, {
			key: 'validateForm',
			value: function validateForm(form) {
				return form.$invalid;
			}
		}, {
			key: 'searchTeacher',
			value: function searchTeacher(teacher) {
				var matcher = new RegExp(teacher, 'i');
				var arr = [];
				var attr = 'teacherName';
	
				this.teachers.forEach(function (list) {
					if (list[attr].match(matcher)) {
						arr.push(list);
					}
				});
	
				return arr;
			}
		}, {
			key: 'activate',
			value: function activate() {
				var _this = this;
	
				setTimeout(function () {
					this.n = this.n + 1;
				}, 10);
				var post = {
					userId: this.header.id,
					rolId: this.rolId
				};
	
				this.reportSrv.getReportDataFilters.get(post).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this.workPlanListCombo = dataReturn.listWorkplan;
						_this.academicUnitListCombo = dataReturn.listAcademicUnit;
	
						_this.AllAcadUnit = _this.formatedAcademicUnit(dataReturn.listAcademicUnit);
						_this.teachers = dataReturn.listTeachers;
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
				var param = {
					rolId: this.rolId
				};
	
				this.reportSrv.getReportStaticList.get(param).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this.reportName = dataReturn.data;
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'formatedAcademicUnit',
			value: function formatedAcademicUnit(data) {
				if (!data.length || !data[0].faculty_id) return;
	
				var formatedAcademicUnit = [];
	
				data.forEach(function (_ref) {
					var faculty_id = _ref.faculty_id;
	
					formatedAcademicUnit.push.apply(formatedAcademicUnit, _toConsumableArray(faculty_id.split(',').map(Number)));
				});
	
				return formatedAcademicUnit;
			}
		}, {
			key: 'generate',
			value: function generate() {
				var _this2 = this;
	
				this.tea = null;
				this.buttonDisable = true;
	
				if (this.rolId == 13) {
					this.tea = this.listUser.teacherId;
				} else {
					this.tea = this.selectedTeacher ? this.selectedTeacher.teacherId : null;
					this.teacherName = this.selectedTeacher && this.selectedTeacher.teacherName ? this.selectedTeacher.teacherName : null;
				}
	
				var email = this.listUser.email;
				var n = email.length;
	
				var post = {
					workplanId: this.workplan,
					teacherId: this.tea,
					academicUnitId: this.academicUnit ? this.academicUnit : this.AllAcadUnit,
					passAcad: this.academicUnit ? 0 : 1,
					username: this.listUser.dsIdentification,
					userId: this.listUser.id,
					rolId: this.rolId,
					email: email.slice(0, n - 16),
					type: 1,
					workPlanName: this.workPlanName,
					teacherName: this.teacherName,
					academicUnitName: this.academicUnitName
				};
	
				console.log(post);
	
				var report = null;
	
				switch (parseInt(this.staticReportName.report_id)) {
	
					case 1:
						report = this.reportSrv.getReportEvaluators;
						break;
					case 2:
						report = this.reportSrv.getReportTeacherSpecialSituation;
						break;
					case 3:
						report = this.reportSrv.getReportTeachersWorkplan;
						break;
					case 4:
						report = this.reportSrv.getReportWorkPlan;
						break;
					case 5:
						report = this.reportSrv.getReportTeachersActivityUnit;
						break;
					case 6:
						report = this.reportSrv.getReportReviewApproved;
						break;
					case 7:
						report = this.reportSrv.getReportIntegral;
						break;
					case 8:
						report = this.reportSrv.getStateApprovalByStage;
						break;
					case 10:
						report = this.reportSrv.getSummaryTeachersActivityUnit;
						post.type = 2;
						break;
					case 11:
						report = this.reportSrv.getReportTeacherActInact;
						break;
					case 12:
						report = this.reportSrv.getReportHoursPlannedExecuted;
						break;
					case 13:
						report = this.reportSrv.getReportStateWorkplanTeacher;
						break;
					case 14:
						report = this.reportSrv.getReportStrategicTracking;
						break;
					case 15:
						report = this.reportSrv.getReportObservationWorkplan;
						break;
					case 16:
						report = this.reportSrv.getReportFinancial;
						break;
					case 17:
						report = this.reportSrv.getReportDedicaciones;
						break;
	
				}
	
				if (!report) return false;
	
				report.post(post).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this2.showModalGeneratingFile();
						_this2.checkFileReady(dataReturn.filename).then(function (fileStatus) {
							if (fileStatus) {
								_this2.downloadFile(dataReturn.filename);
								_this2.showModalConfirmSuccess();
								_this2.buttonDisable = false;
							} else {
								_this2.showModalFailure();
								_this2.buttonDisable = false;
							}
						});
					} else {
						_this2.showModalFailure();
						_this2.buttonDisable = false;
					}
				}, function () {
					_this2.showModalFailure();
					_this2.buttonDisable = false;
				});
			}
		}, {
			key: 'checkFileReady',
			value: function checkFileReady(fileName) {
				var _this3 = this;
	
				var params = {
					fileName: fileName
				};
	
				return this.timeout(function () {
					return _this3.reportSrv.checkFileReady.get(params).$promise.then(function (dataReturn) {
						if (dataReturn.status) {
							if (dataReturn.fileReady) {
								return true;
							}
	
							return _this3.checkFileReady(fileName);
						} else {
							return false;
						}
					});
				}, 5000);
			}
		}, {
			key: 'showModalConfirmSuccess',
			value: function showModalConfirmSuccess() {
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', function showModalConfirmSuccess($scope, $mdDialog) {
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(357),
					clickOutsideToClose: false
				});
			}
		}, {
			key: 'showModalFailure',
			value: function showModalFailure() {
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', function showModalConfirmSuccess($scope, $mdDialog) {
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(358),
					clickOutsideToClose: false
				});
			}
		}, {
			key: 'showModalGeneratingFile',
			value: function showModalGeneratingFile() {
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', function showModalGeneratingFil($scope, $mdDialog) {
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(359),
					clickOutsideToClose: false
				});
			}
		}, {
			key: 'downloadFile',
			value: function downloadFile(filename) {
				var filePath = this.reportSrv.getFilePath(filename);
				var downloadLink = document.getElementById('download');
	
				downloadLink.href = filePath;
				downloadLink.click();
			}
		}, {
			key: 'resetForm',
			value: function resetForm() {
				this.workplan = null;
				this.academicUnit = null;
				this.staticReportName = null;
	
				if (this.selectedTeacher.teacherId != undefined || this.selectedTeacher != null) {
					this.selectedTeacher = null;
					this.searchText = '';
				}
			}
		}, {
			key: 'preventInput',
			value: function preventInput(event) {
				var vKey = 86;
	
				if (event.keyCode == vKey) {
					event.preventDefault();
				}
	
				return;
			}
		}, {
			key: 'changeSelect',
			value: function changeSelect(type) {
				var _this4 = this;
	
				if (type == 'workplan') {
					this.workPlanListCombo.forEach(function (element) {
						if (element.id_code == _this4.workplan) {
							_this4.workPlanName = element.ds_name;
	
							return;
						}
					});
				}
	
				if (type == 'academicUnit') {
					this.academicUnitListCombo.forEach(function (element) {
						if (element.faculty_id == _this4.academicUnit) {
							_this4.academicUnitName = element.faculty_name;
	
							return;
						}
					});
				}
			}
		}]);
	
		return StaticReportCtrl;
	}();
	
	exports.default = StaticReportCtrl;
	
	
	StaticReportCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', '$cookies', 'reportSrv', 'GlobalConfig', '$state', 'WorkPlanModalSrv', 'GlobalSrv', 'permissions', 'UserInfoConstant'];

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Generación de Reporte exitosa!</h3> <p class=m-t-md>El Reporte se ha generado con éxito.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-rojo>Advertencia</h3> <p>No se encontraron datos que coincidan con los parámetros de búsqueda</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content style=height:250px> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-rojo>Generando Archivo</h3> </div> </div> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate ng-disabled=vm.thereIsDetails() md-diameter=96> </md-progress-circular> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var reportSrv = function reportSrv($resource, SERVICE_URL_CONSTANT) {
		_classCallCheck(this, reportSrv);
	
		var getReportDynamic = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportDynamic', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportIntegral = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportIntegral', {}, {
			post: {
				method: 'POST',
				timeout: 180000
			}
		});
	
		var getStateApprovalByStage = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getStateApprovalByStage', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportDataFilters = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportDataFilters', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getReportStaticList = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStaticList', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getReportTeachersWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeachersWorkplan', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportEvaluators = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportEvaluators', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportReviewApproved = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportReviewApproved', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportTeachersActivityUnit = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeachersActivityUnit', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getSummaryTeachersActivityUnit = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getSummaryTeachersActivityUnit', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportTeacherActInact = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeacherActInact', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportHoursPlannedExecuted = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportHoursPlannedExecuted', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportStateWorkplanTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStateWorkplanTeacher', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportStrategicTracking = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStrategicTracking', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportObservationWorkplan = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportObservationWorkplan', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportWorkPlan', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportFinancial = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportFinancial', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportDedicaciones = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportDedicaciones', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportStatic = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportStatic', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportTeacherSpecialSituation = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportTeacherSpecialSituation', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var addDynamicReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/addDynamicReport', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var listDynamicReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/listDynamicReport', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getDynamicReportDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getDynamicReportDetail', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var deleteDynamicReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/deleteDynamicReport', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var SaveReportData = $resource(SERVICE_URL_CONSTANT.rosario + '/report/addReportList', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var ValidNameReport = $resource(SERVICE_URL_CONSTANT.rosario + '/report/ValidNameReportList', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getReportData = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getReportList', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getReportTimestamp = $resource(SERVICE_URL_CONSTANT.rosario + '/report/getTimestamp', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getFilePath = function getFilePath(filename) {
			return SERVICE_URL_CONSTANT.rosario + '/report/getFile/' + filename;
		};
		var checkFileReady = $resource(SERVICE_URL_CONSTANT.rosario + '/report/checkFileReady', {}, {
			get: {
				method: 'GET'
			}
		});
	
		return {
			getReportDynamic: getReportDynamic,
			getReportIntegral: getReportIntegral,
			getStateApprovalByStage: getStateApprovalByStage,
			getReportDataFilters: getReportDataFilters,
			getReportTeachersWorkplan: getReportTeachersWorkplan,
			getFilePath: getFilePath,
			getReportEvaluators: getReportEvaluators,
			getReportTeacherSpecialSituation: getReportTeacherSpecialSituation,
			getReportReviewApproved: getReportReviewApproved,
			getReportTeachersActivityUnit: getReportTeachersActivityUnit,
			getSummaryTeachersActivityUnit: getSummaryTeachersActivityUnit,
			getReportTeacherActInact: getReportTeacherActInact,
			getReportHoursPlannedExecuted: getReportHoursPlannedExecuted,
			getReportWorkPlan: getReportWorkPlan,
			addDynamicReport: addDynamicReport,
			listDynamicReport: listDynamicReport,
			getDynamicReportDetail: getDynamicReportDetail,
			deleteDynamicReport: deleteDynamicReport,
			SaveReportData: SaveReportData,
			ValidNameReport: ValidNameReport,
			getReportData: getReportData,
			getReportTimestamp: getReportTimestamp,
			getReportStateWorkplanTeacher: getReportStateWorkplanTeacher,
			getReportStrategicTracking: getReportStrategicTracking,
			getReportObservationWorkplan: getReportObservationWorkplan,
			getReportStaticList: getReportStaticList,
			getReportFinancial: getReportFinancial,
			getReportDedicaciones: getReportDedicaciones,
			checkFileReady: checkFileReady
	
		};
	};
	
	reportSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	exports.default = angular.module('services.reportSrv', []).service('reportSrv', reportSrv).name;

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP UPlanner
	* @autor jorge.herrero@dbaccess.com
	* @description
	* # name controller --> reportModalCtrl
	* # As Controller --> reportModal
	* brief comment controller for show dialog close Assistence
	
	*/
	
	var reportModalCtrl = function reportModalCtrl($scope, $resource, $mdDialog, items, $state) {
	  _classCallCheck(this, reportModalCtrl);
	
	  var vm = this;
	  vm.close = close;
	  vm.load = load;
	  vm.save = save;
	  vm.edit = edit;
	  vm.delet = delet;
	  vm.see = see;
	
	  //Methods
	  function save() {
	    var data = { action: "save", value: vm.nameReport };
	
	    if (data.value) $mdDialog.hide(data);
	  }
	
	  function close() {
	    $mdDialog.hide();
	  }
	
	  function load() {
	    vm.data = items;
	  }
	
	  function edit(report) {
	    var data = { action: "edit", value: report };
	    $mdDialog.hide(data);
	  }
	
	  function delet(report) {
	    var data = { action: "delet", value: report };
	    $mdDialog.hide(data);
	  }
	
	  function see(report) {
	    var data = { action: "see", value: report };
	    $mdDialog.hide(data);
	  }
	
	  load();
	};
	
	exports.default = reportModalCtrl;
	
	
	reportModalCtrl.$inject = ['$scope', '$resource', '$mdDialog', 'items', '$state'];

/***/ }),
/* 362 */
1199,
/* 363 */,
/* 364 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, jQuery) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function () {
	  var callWithJQuery,
	      indexOf = [].indexOf || function (item) {
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (i in this && this[i] === item) return i;
	    }return -1;
	  },
	      slice = [].slice,
	      bind = function bind(fn, me) {
	    return function () {
	      return fn.apply(me, arguments);
	    };
	  },
	      hasProp = {}.hasOwnProperty;
	
	  callWithJQuery = function callWithJQuery(pivotModule) {
	    if (( false ? "undefined" : _typeof(exports)) === "object" && ( false ? "undefined" : _typeof(module)) === "object") {
	      return pivotModule(__webpack_require__(149));
	    } else if (true) {
	      return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(149)], __WEBPACK_AMD_DEFINE_FACTORY__ = (pivotModule), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	      return pivotModule(jQuery);
	    }
	  };
	
	  callWithJQuery(function ($) {
	
	    /*
	    Utilities
	     */
	    var PivotData, addSeparators, aggregatorTemplates, aggregators, dayNamesEn, derivers, getSort, locales, mthNamesEn, naturalSort, numberFormat, pivotTableRenderer, rd, renderers, rx, rz, sortAs, usFmt, usFmtInt, usFmtPct, zeroPad;
	    addSeparators = function addSeparators(nStr, thousandsSep, decimalSep) {
	      var rgx, x, x1, x2;
	      nStr += '';
	      x = nStr.split('.');
	      x1 = x[0];
	      x2 = x.length > 1 ? decimalSep + x[1] : '';
	      rgx = /(\d+)(\d{3})/;
	      while (rgx.test(x1)) {
	        x1 = x1.replace(rgx, '$1' + thousandsSep + '$2');
	      }
	      return x1 + x2;
	    };
	    numberFormat = function numberFormat(opts) {
	      var defaults;
	      defaults = {
	        digitsAfterDecimal: 2,
	        scaler: 1,
	        thousandsSep: ",",
	        decimalSep: ".",
	        prefix: "",
	        suffix: ""
	      };
	      opts = $.extend({}, defaults, opts);
	      return function (x) {
	        var result;
	        if (isNaN(x) || !isFinite(x)) {
	          return "";
	        }
	        result = addSeparators((opts.scaler * x).toFixed(opts.digitsAfterDecimal), opts.thousandsSep, opts.decimalSep);
	        return "" + opts.prefix + result + opts.suffix;
	      };
	    };
	    usFmt = numberFormat();
	    usFmtInt = numberFormat({
	      digitsAfterDecimal: 0
	    });
	    usFmtPct = numberFormat({
	      digitsAfterDecimal: 1,
	      scaler: 100,
	      suffix: "%"
	    });
	    aggregatorTemplates = {
	      count: function count(formatter) {
	        if (formatter == null) {
	          formatter = usFmtInt;
	        }
	        return function () {
	          return function (data, rowKey, colKey) {
	            return {
	              count: 0,
	              push: function push() {
	                return this.count++;
	              },
	              value: function value() {
	                return this.count;
	              },
	              format: formatter
	            };
	          };
	        };
	      },
	      uniques: function uniques(fn, formatter) {
	        if (formatter == null) {
	          formatter = usFmtInt;
	        }
	        return function (arg) {
	          var attr;
	          attr = arg[0];
	          return function (data, rowKey, colKey) {
	            return {
	              uniq: [],
	              push: function push(record) {
	                var ref;
	                if (ref = record[attr], indexOf.call(this.uniq, ref) < 0) {
	                  return this.uniq.push(record[attr]);
	                }
	              },
	              value: function value() {
	                return fn(this.uniq);
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      sum: function sum(formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function (arg) {
	          var attr;
	          attr = arg[0];
	          return function (data, rowKey, colKey) {
	            return {
	              sum: 0,
	              push: function push(record) {
	                if (!isNaN(parseFloat(record[attr]))) {
	                  return this.sum += parseFloat(record[attr]);
	                }
	              },
	              value: function value() {
	                return this.sum;
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      extremes: function extremes(mode, formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function (arg) {
	          var attr;
	          attr = arg[0];
	          return function (data, rowKey, colKey) {
	            return {
	              val: null,
	              sorter: getSort(data != null ? data.sorters : void 0, attr),
	              push: function push(record) {
	                var ref, ref1, ref2, x;
	                x = record[attr];
	                if (mode === "min" || mode === "max") {
	                  x = parseFloat(x);
	                  if (!isNaN(x)) {
	                    this.val = Math[mode](x, (ref = this.val) != null ? ref : x);
	                  }
	                }
	                if (mode === "first") {
	                  if (this.sorter(x, (ref1 = this.val) != null ? ref1 : x) <= 0) {
	                    this.val = x;
	                  }
	                }
	                if (mode === "last") {
	                  if (this.sorter(x, (ref2 = this.val) != null ? ref2 : x) >= 0) {
	                    return this.val = x;
	                  }
	                }
	              },
	              value: function value() {
	                return this.val;
	              },
	              format: function format(x) {
	                if (isNaN(x)) {
	                  return x;
	                } else {
	                  return formatter(x);
	                }
	              },
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      quantile: function quantile(q, formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function (arg) {
	          var attr;
	          attr = arg[0];
	          return function (data, rowKey, colKey) {
	            return {
	              vals: [],
	              push: function push(record) {
	                var x;
	                x = parseFloat(record[attr]);
	                if (!isNaN(x)) {
	                  return this.vals.push(x);
	                }
	              },
	              value: function value() {
	                var i;
	                if (this.vals.length === 0) {
	                  return null;
	                }
	                this.vals.sort(function (a, b) {
	                  return a - b;
	                });
	                i = (this.vals.length - 1) * q;
	                return (this.vals[Math.floor(i)] + this.vals[Math.ceil(i)]) / 2.0;
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      runningStat: function runningStat(mode, ddof, formatter) {
	        if (mode == null) {
	          mode = "mean";
	        }
	        if (ddof == null) {
	          ddof = 1;
	        }
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function (arg) {
	          var attr;
	          attr = arg[0];
	          return function (data, rowKey, colKey) {
	            return {
	              n: 0.0,
	              m: 0.0,
	              s: 0.0,
	              push: function push(record) {
	                var m_new, x;
	                x = parseFloat(record[attr]);
	                if (isNaN(x)) {
	                  return;
	                }
	                this.n += 1.0;
	                if (this.n === 1.0) {
	                  return this.m = x;
	                } else {
	                  m_new = this.m + (x - this.m) / this.n;
	                  this.s = this.s + (x - this.m) * (x - m_new);
	                  return this.m = m_new;
	                }
	              },
	              value: function value() {
	                if (mode === "mean") {
	                  if (this.n === 0) {
	                    return 0 / 0;
	                  } else {
	                    return this.m;
	                  }
	                }
	                if (this.n <= ddof) {
	                  return 0;
	                }
	                switch (mode) {
	                  case "var":
	                    return this.s / (this.n - ddof);
	                  case "stdev":
	                    return Math.sqrt(this.s / (this.n - ddof));
	                }
	              },
	              format: formatter,
	              numInputs: attr != null ? 0 : 1
	            };
	          };
	        };
	      },
	      sumOverSum: function sumOverSum(formatter) {
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function (arg) {
	          var denom, num;
	          num = arg[0], denom = arg[1];
	          return function (data, rowKey, colKey) {
	            return {
	              sumNum: 0,
	              sumDenom: 0,
	              push: function push(record) {
	                if (!isNaN(parseFloat(record[num]))) {
	                  this.sumNum += parseFloat(record[num]);
	                }
	                if (!isNaN(parseFloat(record[denom]))) {
	                  return this.sumDenom += parseFloat(record[denom]);
	                }
	              },
	              value: function value() {
	                return this.sumNum / this.sumDenom;
	              },
	              format: formatter,
	              numInputs: num != null && denom != null ? 0 : 2
	            };
	          };
	        };
	      },
	      sumOverSumBound80: function sumOverSumBound80(upper, formatter) {
	        if (upper == null) {
	          upper = true;
	        }
	        if (formatter == null) {
	          formatter = usFmt;
	        }
	        return function (arg) {
	          var denom, num;
	          num = arg[0], denom = arg[1];
	          return function (data, rowKey, colKey) {
	            return {
	              sumNum: 0,
	              sumDenom: 0,
	              push: function push(record) {
	                if (!isNaN(parseFloat(record[num]))) {
	                  this.sumNum += parseFloat(record[num]);
	                }
	                if (!isNaN(parseFloat(record[denom]))) {
	                  return this.sumDenom += parseFloat(record[denom]);
	                }
	              },
	              value: function value() {
	                var sign;
	                sign = upper ? 1 : -1;
	                return (0.821187207574908 / this.sumDenom + this.sumNum / this.sumDenom + 1.2815515655446004 * sign * Math.sqrt(0.410593603787454 / (this.sumDenom * this.sumDenom) + this.sumNum * (1 - this.sumNum / this.sumDenom) / (this.sumDenom * this.sumDenom))) / (1 + 1.642374415149816 / this.sumDenom);
	              },
	              format: formatter,
	              numInputs: num != null && denom != null ? 0 : 2
	            };
	          };
	        };
	      },
	      fractionOf: function fractionOf(wrapped, type, formatter) {
	        if (type == null) {
	          type = "total";
	        }
	        if (formatter == null) {
	          formatter = usFmtPct;
	        }
	        return function () {
	          var x;
	          x = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	          return function (data, rowKey, colKey) {
	            return {
	              selector: {
	                total: [[], []],
	                row: [rowKey, []],
	                col: [[], colKey]
	              }[type],
	              inner: wrapped.apply(null, x)(data, rowKey, colKey),
	              push: function push(record) {
	                return this.inner.push(record);
	              },
	              format: formatter,
	              value: function value() {
	                return this.inner.value() / data.getAggregator.apply(data, this.selector).inner.value();
	              },
	              numInputs: wrapped.apply(null, x)().numInputs
	            };
	          };
	        };
	      }
	    };
	    aggregatorTemplates.countUnique = function (f) {
	      return aggregatorTemplates.uniques(function (x) {
	        return x.length;
	      }, f);
	    };
	    aggregatorTemplates.listUnique = function (s) {
	      return aggregatorTemplates.uniques(function (x) {
	        return x.join(s);
	      }, function (x) {
	        return x;
	      });
	    };
	    aggregatorTemplates.max = function (f) {
	      return aggregatorTemplates.extremes('max', f);
	    };
	    aggregatorTemplates.min = function (f) {
	      return aggregatorTemplates.extremes('min', f);
	    };
	    aggregatorTemplates.first = function (f) {
	      return aggregatorTemplates.extremes('first', f);
	    };
	    aggregatorTemplates.last = function (f) {
	      return aggregatorTemplates.extremes('last', f);
	    };
	    aggregatorTemplates.median = function (f) {
	      return aggregatorTemplates.quantile(0.5, f);
	    };
	    aggregatorTemplates.average = function (f) {
	      return aggregatorTemplates.runningStat("mean", 1, f);
	    };
	    aggregatorTemplates["var"] = function (ddof, f) {
	      return aggregatorTemplates.runningStat("var", ddof, f);
	    };
	    aggregatorTemplates.stdev = function (ddof, f) {
	      return aggregatorTemplates.runningStat("stdev", ddof, f);
	    };
	    aggregators = function (tpl) {
	      return {
	        "Count": tpl.count(usFmtInt),
	        "Count Unique Values": tpl.countUnique(usFmtInt),
	        "List Unique Values": tpl.listUnique(", "),
	        "Sum": tpl.sum(usFmt),
	        "Integer Sum": tpl.sum(usFmtInt),
	        "Average": tpl.average(usFmt),
	        "Median": tpl.median(usFmt),
	        "Sample Variance": tpl["var"](1, usFmt),
	        "Sample Standard Deviation": tpl.stdev(1, usFmt),
	        "Minimum": tpl.min(usFmt),
	        "Maximum": tpl.max(usFmt),
	        "First": tpl.first(usFmt),
	        "Last": tpl.last(usFmt),
	        "Sum over Sum": tpl.sumOverSum(usFmt),
	        "80% Upper Bound": tpl.sumOverSumBound80(true, usFmt),
	        "80% Lower Bound": tpl.sumOverSumBound80(false, usFmt),
	        "Sum as Fraction of Total": tpl.fractionOf(tpl.sum(), "total", usFmtPct),
	        "Sum as Fraction of Rows": tpl.fractionOf(tpl.sum(), "row", usFmtPct),
	        "Sum as Fraction of Columns": tpl.fractionOf(tpl.sum(), "col", usFmtPct),
	        "Count as Fraction of Total": tpl.fractionOf(tpl.count(), "total", usFmtPct),
	        "Count as Fraction of Rows": tpl.fractionOf(tpl.count(), "row", usFmtPct),
	        "Count as Fraction of Columns": tpl.fractionOf(tpl.count(), "col", usFmtPct)
	      };
	    }(aggregatorTemplates);
	    renderers = {
	      "Table": function Table(data, opts) {
	        return pivotTableRenderer(data, opts);
	      },
	      "Table Barchart": function TableBarchart(data, opts) {
	        return $(pivotTableRenderer(data, opts)).barchart();
	      },
	      "Heatmap": function Heatmap(data, opts) {
	        return $(pivotTableRenderer(data, opts)).heatmap("heatmap", opts);
	      },
	      "Row Heatmap": function RowHeatmap(data, opts) {
	        return $(pivotTableRenderer(data, opts)).heatmap("rowheatmap", opts);
	      },
	      "Col Heatmap": function ColHeatmap(data, opts) {
	        return $(pivotTableRenderer(data, opts)).heatmap("colheatmap", opts);
	      }
	    };
	    locales = {
	      en: {
	        aggregators: aggregators,
	        renderers: renderers,
	        localeStrings: {
	          renderError: "An error occurred rendering the PivotTable results.",
	          computeError: "An error occurred computing the PivotTable results.",
	          uiRenderError: "An error occurred rendering the PivotTable UI.",
	          selectAll: "Select All",
	          selectNone: "Select None",
	          tooMany: "(too many to list)",
	          filterResults: "Filter values",
	          apply: "Apply",
	          cancel: "Cancel",
	          totals: "Totals",
	          vs: "vs",
	          by: "by"
	        }
	      }
	    };
	    mthNamesEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	    dayNamesEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	    zeroPad = function zeroPad(number) {
	      return ("0" + number).substr(-2, 2);
	    };
	    derivers = {
	      bin: function bin(col, binWidth) {
	        return function (record) {
	          return record[col] - record[col] % binWidth;
	        };
	      },
	      dateFormat: function dateFormat(col, formatString, utcOutput, mthNames, dayNames) {
	        var utc;
	        if (utcOutput == null) {
	          utcOutput = false;
	        }
	        if (mthNames == null) {
	          mthNames = mthNamesEn;
	        }
	        if (dayNames == null) {
	          dayNames = dayNamesEn;
	        }
	        utc = utcOutput ? "UTC" : "";
	        return function (record) {
	          var date;
	          date = new Date(Date.parse(record[col]));
	          if (isNaN(date)) {
	            return "";
	          }
	          return formatString.replace(/%(.)/g, function (m, p) {
	            switch (p) {
	              case "y":
	                return date["get" + utc + "FullYear"]();
	              case "m":
	                return zeroPad(date["get" + utc + "Month"]() + 1);
	              case "n":
	                return mthNames[date["get" + utc + "Month"]()];
	              case "d":
	                return zeroPad(date["get" + utc + "Date"]());
	              case "w":
	                return dayNames[date["get" + utc + "Day"]()];
	              case "x":
	                return date["get" + utc + "Day"]();
	              case "H":
	                return zeroPad(date["get" + utc + "Hours"]());
	              case "M":
	                return zeroPad(date["get" + utc + "Minutes"]());
	              case "S":
	                return zeroPad(date["get" + utc + "Seconds"]());
	              default:
	                return "%" + p;
	            }
	          });
	        };
	      }
	    };
	    rx = /(\d+)|(\D+)/g;
	    rd = /\d/;
	    rz = /^0/;
	    naturalSort = function (_this) {
	      return function (as, bs) {
	        var a, a1, b, b1, nas, nbs;
	        if (bs != null && as == null) {
	          return -1;
	        }
	        if (as != null && bs == null) {
	          return 1;
	        }
	        if (typeof as === "number" && isNaN(as)) {
	          return -1;
	        }
	        if (typeof bs === "number" && isNaN(bs)) {
	          return 1;
	        }
	        nas = +as;
	        nbs = +bs;
	        if (nas < nbs) {
	          return -1;
	        }
	        if (nas > nbs) {
	          return 1;
	        }
	        if (typeof as === "number" && typeof bs !== "number") {
	          return -1;
	        }
	        if (typeof bs === "number" && typeof as !== "number") {
	          return 1;
	        }
	        if (typeof as === "number" && typeof bs === "number") {
	          return 0;
	        }
	        if (isNaN(nbs) && !isNaN(nas)) {
	          return -1;
	        }
	        if (isNaN(nas) && !isNaN(nbs)) {
	          return 1;
	        }
	        a = String(as);
	        b = String(bs);
	        if (a === b) {
	          return 0;
	        }
	        if (!(rd.test(a) && rd.test(b))) {
	          return a > b ? 1 : -1;
	        }
	        a = a.match(rx);
	        b = b.match(rx);
	        while (a.length && b.length) {
	          a1 = a.shift();
	          b1 = b.shift();
	          if (a1 !== b1) {
	            if (rd.test(a1) && rd.test(b1)) {
	              return a1.replace(rz, ".0") - b1.replace(rz, ".0");
	            } else {
	              return a1 > b1 ? 1 : -1;
	            }
	          }
	        }
	        return a.length - b.length;
	      };
	    }(this);
	    sortAs = function sortAs(order) {
	      var i, l_mapping, mapping, x;
	      mapping = {};
	      l_mapping = {};
	      for (i in order) {
	        x = order[i];
	        mapping[x] = i;
	        if (typeof x === "string") {
	          l_mapping[x.toLowerCase()] = i;
	        }
	      }
	      return function (a, b) {
	        if (mapping[a] != null && mapping[b] != null) {
	          return mapping[a] - mapping[b];
	        } else if (mapping[a] != null) {
	          return -1;
	        } else if (mapping[b] != null) {
	          return 1;
	        } else if (l_mapping[a] != null && l_mapping[b] != null) {
	          return l_mapping[a] - l_mapping[b];
	        } else if (l_mapping[a] != null) {
	          return -1;
	        } else if (l_mapping[b] != null) {
	          return 1;
	        } else {
	          return naturalSort(a, b);
	        }
	      };
	    };
	    getSort = function getSort(sorters, attr) {
	      var sort;
	      if (sorters != null) {
	        if ($.isFunction(sorters)) {
	          sort = sorters(attr);
	          if ($.isFunction(sort)) {
	            return sort;
	          }
	        } else if (sorters[attr] != null) {
	          return sorters[attr];
	        }
	      }
	      return naturalSort;
	    };
	
	    /*
	    Data Model class
	     */
	    PivotData = function () {
	      function PivotData(input, opts) {
	        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
	        if (opts == null) {
	          opts = {};
	        }
	        this.getAggregator = bind(this.getAggregator, this);
	        this.getRowKeys = bind(this.getRowKeys, this);
	        this.getColKeys = bind(this.getColKeys, this);
	        this.sortKeys = bind(this.sortKeys, this);
	        this.arrSort = bind(this.arrSort, this);
	        this.input = input;
	        this.aggregator = (ref = opts.aggregator) != null ? ref : aggregatorTemplates.count()();
	        this.aggregatorName = (ref1 = opts.aggregatorName) != null ? ref1 : "Count";
	        this.colAttrs = (ref2 = opts.cols) != null ? ref2 : [];
	        this.rowAttrs = (ref3 = opts.rows) != null ? ref3 : [];
	        this.valAttrs = (ref4 = opts.vals) != null ? ref4 : [];
	        this.sorters = (ref5 = opts.sorters) != null ? ref5 : {};
	        this.rowOrder = (ref6 = opts.rowOrder) != null ? ref6 : "key_a_to_z";
	        this.colOrder = (ref7 = opts.colOrder) != null ? ref7 : "key_a_to_z";
	        this.derivedAttributes = (ref8 = opts.derivedAttributes) != null ? ref8 : {};
	        this.filter = (ref9 = opts.filter) != null ? ref9 : function () {
	          return true;
	        };
	        this.tree = {};
	        this.rowKeys = [];
	        this.colKeys = [];
	        this.rowTotals = {};
	        this.colTotals = {};
	        this.allTotal = this.aggregator(this, [], []);
	        this.sorted = false;
	        PivotData.forEachRecord(this.input, this.derivedAttributes, function (_this) {
	          return function (record) {
	            if (_this.filter(record)) {
	              return _this.processRecord(record);
	            }
	          };
	        }(this));
	      }
	
	      PivotData.forEachRecord = function (input, derivedAttributes, f) {
	        var addRecord, compactRecord, i, j, k, l, len1, record, ref, results, results1, tblCols;
	        if ($.isEmptyObject(derivedAttributes)) {
	          addRecord = f;
	        } else {
	          addRecord = function addRecord(record) {
	            var k, ref, v;
	            for (k in derivedAttributes) {
	              v = derivedAttributes[k];
	              record[k] = (ref = v(record)) != null ? ref : record[k];
	            }
	            return f(record);
	          };
	        }
	        if ($.isFunction(input)) {
	          return input(addRecord);
	        } else if ($.isArray(input)) {
	          if ($.isArray(input[0])) {
	            results = [];
	            for (i in input) {
	              if (!hasProp.call(input, i)) continue;
	              compactRecord = input[i];
	              if (!(i > 0)) {
	                continue;
	              }
	              record = {};
	              ref = input[0];
	              for (j in ref) {
	                if (!hasProp.call(ref, j)) continue;
	                k = ref[j];
	                record[k] = compactRecord[j];
	              }
	              results.push(addRecord(record));
	            }
	            return results;
	          } else {
	            results1 = [];
	            for (l = 0, len1 = input.length; l < len1; l++) {
	              record = input[l];
	              results1.push(addRecord(record));
	            }
	            return results1;
	          }
	        } else if (input instanceof jQuery) {
	          tblCols = [];
	          $("thead > tr > th", input).each(function (i) {
	            return tblCols.push($(this).text());
	          });
	          return $("tbody > tr", input).each(function (i) {
	            record = {};
	            $("td", this).each(function (j) {
	              return record[tblCols[j]] = $(this).text();
	            });
	            return addRecord(record);
	          });
	        } else {
	          throw new Error("unknown input format");
	        }
	      };
	
	      PivotData.prototype.forEachMatchingRecord = function (criteria, callback) {
	        return PivotData.forEachRecord(this.input, this.derivedAttributes, function (_this) {
	          return function (record) {
	            var k, ref, v;
	            if (!_this.filter(record)) {
	              return;
	            }
	            for (k in criteria) {
	              v = criteria[k];
	              if (v !== ((ref = record[k]) != null ? ref : "null")) {
	                return;
	              }
	            }
	            return callback(record);
	          };
	        }(this));
	      };
	
	      PivotData.prototype.arrSort = function (attrs) {
	        var a, sortersArr;
	        sortersArr = function () {
	          var l, len1, results;
	          results = [];
	          for (l = 0, len1 = attrs.length; l < len1; l++) {
	            a = attrs[l];
	            results.push(getSort(this.sorters, a));
	          }
	          return results;
	        }.call(this);
	        return function (a, b) {
	          var comparison, i, sorter;
	          for (i in sortersArr) {
	            if (!hasProp.call(sortersArr, i)) continue;
	            sorter = sortersArr[i];
	            comparison = sorter(a[i], b[i]);
	            if (comparison !== 0) {
	              return comparison;
	            }
	          }
	          return 0;
	        };
	      };
	
	      PivotData.prototype.sortKeys = function () {
	        var v;
	        if (!this.sorted) {
	          this.sorted = true;
	          v = function (_this) {
	            return function (r, c) {
	              return _this.getAggregator(r, c).value();
	            };
	          }(this);
	          switch (this.rowOrder) {
	            case "value_a_to_z":
	              this.rowKeys.sort(function (_this) {
	                return function (a, b) {
	                  return naturalSort(v(a, []), v(b, []));
	                };
	              }(this));
	              break;
	            case "value_z_to_a":
	              this.rowKeys.sort(function (_this) {
	                return function (a, b) {
	                  return -naturalSort(v(a, []), v(b, []));
	                };
	              }(this));
	              break;
	            default:
	              this.rowKeys.sort(this.arrSort(this.rowAttrs));
	          }
	          switch (this.colOrder) {
	            case "value_a_to_z":
	              return this.colKeys.sort(function (_this) {
	                return function (a, b) {
	                  return naturalSort(v([], a), v([], b));
	                };
	              }(this));
	            case "value_z_to_a":
	              return this.colKeys.sort(function (_this) {
	                return function (a, b) {
	                  return -naturalSort(v([], a), v([], b));
	                };
	              }(this));
	            default:
	              return this.colKeys.sort(this.arrSort(this.colAttrs));
	          }
	        }
	      };
	
	      PivotData.prototype.getColKeys = function () {
	        this.sortKeys();
	        return this.colKeys;
	      };
	
	      PivotData.prototype.getRowKeys = function () {
	        this.sortKeys();
	        return this.rowKeys;
	      };
	
	      PivotData.prototype.processRecord = function (record) {
	        var colKey, flatColKey, flatRowKey, l, len1, len2, n, ref, ref1, ref2, ref3, rowKey, x;
	        colKey = [];
	        rowKey = [];
	        ref = this.colAttrs;
	        for (l = 0, len1 = ref.length; l < len1; l++) {
	          x = ref[l];
	          colKey.push((ref1 = record[x]) != null ? ref1 : "null");
	        }
	        ref2 = this.rowAttrs;
	        for (n = 0, len2 = ref2.length; n < len2; n++) {
	          x = ref2[n];
	          rowKey.push((ref3 = record[x]) != null ? ref3 : "null");
	        }
	        flatRowKey = rowKey.join(String.fromCharCode(0));
	        flatColKey = colKey.join(String.fromCharCode(0));
	        this.allTotal.push(record);
	        if (rowKey.length !== 0) {
	          if (!this.rowTotals[flatRowKey]) {
	            this.rowKeys.push(rowKey);
	            this.rowTotals[flatRowKey] = this.aggregator(this, rowKey, []);
	          }
	          this.rowTotals[flatRowKey].push(record);
	        }
	        if (colKey.length !== 0) {
	          if (!this.colTotals[flatColKey]) {
	            this.colKeys.push(colKey);
	            this.colTotals[flatColKey] = this.aggregator(this, [], colKey);
	          }
	          this.colTotals[flatColKey].push(record);
	        }
	        if (colKey.length !== 0 && rowKey.length !== 0) {
	          if (!this.tree[flatRowKey]) {
	            this.tree[flatRowKey] = {};
	          }
	          if (!this.tree[flatRowKey][flatColKey]) {
	            this.tree[flatRowKey][flatColKey] = this.aggregator(this, rowKey, colKey);
	          }
	          return this.tree[flatRowKey][flatColKey].push(record);
	        }
	      };
	
	      PivotData.prototype.getAggregator = function (rowKey, colKey) {
	        var agg, flatColKey, flatRowKey;
	        flatRowKey = rowKey.join(String.fromCharCode(0));
	        flatColKey = colKey.join(String.fromCharCode(0));
	        if (rowKey.length === 0 && colKey.length === 0) {
	          agg = this.allTotal;
	        } else if (rowKey.length === 0) {
	          agg = this.colTotals[flatColKey];
	        } else if (colKey.length === 0) {
	          agg = this.rowTotals[flatRowKey];
	        } else {
	          agg = this.tree[flatRowKey][flatColKey];
	        }
	        return agg != null ? agg : {
	          value: function value() {
	            return null;
	          },
	          format: function format() {
	            return "";
	          }
	        };
	      };
	
	      return PivotData;
	    }();
	    $.pivotUtilities = {
	      aggregatorTemplates: aggregatorTemplates,
	      aggregators: aggregators,
	      renderers: renderers,
	      derivers: derivers,
	      locales: locales,
	      naturalSort: naturalSort,
	      numberFormat: numberFormat,
	      sortAs: sortAs,
	      PivotData: PivotData
	    };
	
	    /*
	    Default Renderer for hierarchical table layout
	     */
	    pivotTableRenderer = function pivotTableRenderer(pivotData, opts) {
	      var aggregator, c, colAttrs, colKey, colKeys, defaults, getClickHandler, i, j, r, result, rowAttrs, rowKey, rowKeys, spanSize, tbody, td, th, thead, totalAggregator, tr, txt, val, x;
	      defaults = {
	        table: {
	          clickCallback: null
	        },
	        localeStrings: {
	          totals: "Totals"
	        }
	      };
	      opts = $.extend(true, {}, defaults, opts);
	      colAttrs = pivotData.colAttrs;
	      rowAttrs = pivotData.rowAttrs;
	      rowKeys = pivotData.getRowKeys();
	      colKeys = pivotData.getColKeys();
	      if (opts.table.clickCallback) {
	        getClickHandler = function getClickHandler(value, rowValues, colValues) {
	          var attr, filters, i;
	          filters = {};
	          for (i in colAttrs) {
	            if (!hasProp.call(colAttrs, i)) continue;
	            attr = colAttrs[i];
	            if (colValues[i] != null) {
	              filters[attr] = colValues[i];
	            }
	          }
	          for (i in rowAttrs) {
	            if (!hasProp.call(rowAttrs, i)) continue;
	            attr = rowAttrs[i];
	            if (rowValues[i] != null) {
	              filters[attr] = rowValues[i];
	            }
	          }
	          return function (e) {
	            return opts.table.clickCallback(e, value, filters, pivotData);
	          };
	        };
	      }
	      result = document.createElement("table");
	      result.className = "pvtTable";
	      spanSize = function spanSize(arr, i, j) {
	        var l, len, n, noDraw, ref, ref1, stop, x;
	        if (i !== 0) {
	          noDraw = true;
	          for (x = l = 0, ref = j; 0 <= ref ? l <= ref : l >= ref; x = 0 <= ref ? ++l : --l) {
	            if (arr[i - 1][x] !== arr[i][x]) {
	              noDraw = false;
	            }
	          }
	          if (noDraw) {
	            return -1;
	          }
	        }
	        len = 0;
	        while (i + len < arr.length) {
	          stop = false;
	          for (x = n = 0, ref1 = j; 0 <= ref1 ? n <= ref1 : n >= ref1; x = 0 <= ref1 ? ++n : --n) {
	            if (arr[i][x] !== arr[i + len][x]) {
	              stop = true;
	            }
	          }
	          if (stop) {
	            break;
	          }
	          len++;
	        }
	        return len;
	      };
	      thead = document.createElement("thead");
	      for (j in colAttrs) {
	        if (!hasProp.call(colAttrs, j)) continue;
	        c = colAttrs[j];
	        tr = document.createElement("tr");
	        if (parseInt(j) === 0 && rowAttrs.length !== 0) {
	          th = document.createElement("th");
	          th.setAttribute("colspan", rowAttrs.length);
	          th.setAttribute("rowspan", colAttrs.length);
	          tr.appendChild(th);
	        }
	        th = document.createElement("th");
	        th.className = "pvtAxisLabel";
	        th.textContent = c;
	        tr.appendChild(th);
	        for (i in colKeys) {
	          if (!hasProp.call(colKeys, i)) continue;
	          colKey = colKeys[i];
	          x = spanSize(colKeys, parseInt(i), parseInt(j));
	          if (x !== -1) {
	            th = document.createElement("th");
	            th.className = "pvtColLabel";
	            th.textContent = colKey[j];
	            th.setAttribute("colspan", x);
	            if (parseInt(j) === colAttrs.length - 1 && rowAttrs.length !== 0) {
	              th.setAttribute("rowspan", 2);
	            }
	            tr.appendChild(th);
	          }
	        }
	        if (parseInt(j) === 0) {
	          th = document.createElement("th");
	          th.className = "pvtTotalLabel";
	          th.innerHTML = opts.localeStrings.totals;
	          th.setAttribute("rowspan", colAttrs.length + (rowAttrs.length === 0 ? 0 : 1));
	          tr.appendChild(th);
	        }
	        thead.appendChild(tr);
	      }
	      if (rowAttrs.length !== 0) {
	        tr = document.createElement("tr");
	        for (i in rowAttrs) {
	          if (!hasProp.call(rowAttrs, i)) continue;
	          r = rowAttrs[i];
	          th = document.createElement("th");
	          th.className = "pvtAxisLabel";
	          th.textContent = r;
	          tr.appendChild(th);
	        }
	        th = document.createElement("th");
	        if (colAttrs.length === 0) {
	          th.className = "pvtTotalLabel";
	          th.innerHTML = opts.localeStrings.totals;
	        }
	        tr.appendChild(th);
	        thead.appendChild(tr);
	      }
	      result.appendChild(thead);
	      tbody = document.createElement("tbody");
	      for (i in rowKeys) {
	        if (!hasProp.call(rowKeys, i)) continue;
	        rowKey = rowKeys[i];
	        tr = document.createElement("tr");
	        for (j in rowKey) {
	          if (!hasProp.call(rowKey, j)) continue;
	          txt = rowKey[j];
	          x = spanSize(rowKeys, parseInt(i), parseInt(j));
	          if (x !== -1) {
	            th = document.createElement("th");
	            th.className = "pvtRowLabel";
	            th.textContent = txt;
	            th.setAttribute("rowspan", x);
	            if (parseInt(j) === rowAttrs.length - 1 && colAttrs.length !== 0) {
	              th.setAttribute("colspan", 2);
	            }
	            tr.appendChild(th);
	          }
	        }
	        for (j in colKeys) {
	          if (!hasProp.call(colKeys, j)) continue;
	          colKey = colKeys[j];
	          aggregator = pivotData.getAggregator(rowKey, colKey);
	          val = aggregator.value();
	          td = document.createElement("td");
	          td.className = "pvtVal row" + i + " col" + j;
	          td.textContent = aggregator.format(val);
	          td.setAttribute("data-value", val);
	          if (getClickHandler != null) {
	            td.onclick = getClickHandler(val, rowKey, colKey);
	          }
	          tr.appendChild(td);
	        }
	        totalAggregator = pivotData.getAggregator(rowKey, []);
	        val = totalAggregator.value();
	        td = document.createElement("td");
	        td.className = "pvtTotal rowTotal";
	        td.textContent = totalAggregator.format(val);
	        td.setAttribute("data-value", val);
	        if (getClickHandler != null) {
	          td.onclick = getClickHandler(val, rowKey, []);
	        }
	        td.setAttribute("data-for", "row" + i);
	        tr.appendChild(td);
	        tbody.appendChild(tr);
	      }
	      tr = document.createElement("tr");
	      th = document.createElement("th");
	      th.className = "pvtTotalLabel";
	      th.innerHTML = opts.localeStrings.totals;
	      th.setAttribute("colspan", rowAttrs.length + (colAttrs.length === 0 ? 0 : 1));
	      tr.appendChild(th);
	      for (j in colKeys) {
	        if (!hasProp.call(colKeys, j)) continue;
	        colKey = colKeys[j];
	        totalAggregator = pivotData.getAggregator([], colKey);
	        val = totalAggregator.value();
	        td = document.createElement("td");
	        td.className = "pvtTotal colTotal";
	        td.textContent = totalAggregator.format(val);
	        td.setAttribute("data-value", val);
	        if (getClickHandler != null) {
	          td.onclick = getClickHandler(val, [], colKey);
	        }
	        td.setAttribute("data-for", "col" + j);
	        tr.appendChild(td);
	      }
	      totalAggregator = pivotData.getAggregator([], []);
	      val = totalAggregator.value();
	      td = document.createElement("td");
	      td.className = "pvtGrandTotal";
	      td.textContent = totalAggregator.format(val);
	      td.setAttribute("data-value", val);
	      if (getClickHandler != null) {
	        td.onclick = getClickHandler(val, [], []);
	      }
	      tr.appendChild(td);
	      tbody.appendChild(tr);
	      result.appendChild(tbody);
	      result.setAttribute("data-numrows", rowKeys.length);
	      result.setAttribute("data-numcols", colKeys.length);
	      return result;
	    };
	
	    /*
	    Pivot Table core: create PivotData object and call Renderer on it
	     */
	    $.fn.pivot = function (input, inputOpts, locale) {
	      var defaults, e, localeDefaults, localeStrings, opts, pivotData, result, x;
	      if (locale == null) {
	        locale = "en";
	      }
	      if (locales[locale] == null) {
	        locale = "en";
	      }
	      defaults = {
	        cols: [],
	        rows: [],
	        vals: [],
	        rowOrder: "key_a_to_z",
	        colOrder: "key_a_to_z",
	        dataClass: PivotData,
	        filter: function filter() {
	          return true;
	        },
	        aggregator: aggregatorTemplates.count()(),
	        aggregatorName: "Count",
	        sorters: {},
	        derivedAttributes: {},
	        renderer: pivotTableRenderer
	      };
	      localeStrings = $.extend(true, {}, locales.en.localeStrings, locales[locale].localeStrings);
	      localeDefaults = {
	        rendererOptions: {
	          localeStrings: localeStrings
	        },
	        localeStrings: localeStrings
	      };
	      opts = $.extend(true, {}, localeDefaults, $.extend({}, defaults, inputOpts));
	      result = null;
	      try {
	        pivotData = new opts.dataClass(input, opts);
	        try {
	          result = opts.renderer(pivotData, opts.rendererOptions);
	        } catch (_error) {
	          e = _error;
	          if (typeof console !== "undefined" && console !== null) {
	            console.error(e.stack);
	          }
	          result = $("<span>").html(opts.localeStrings.renderError);
	        }
	      } catch (_error) {
	        e = _error;
	        if (typeof console !== "undefined" && console !== null) {
	          console.error(e.stack);
	        }
	        result = $("<span>").html(opts.localeStrings.computeError);
	      }
	      x = this[0];
	      while (x.hasChildNodes()) {
	        x.removeChild(x.lastChild);
	      }
	      return this.append(result);
	    };
	
	    /*
	    Pivot Table UI: calls Pivot Table core above with options set by user
	     */
	    $.fn.pivotUI = function (input, inputOpts, overwrite, locale) {
	      var a, aggregator, attr, attrLength, attrValues, colOrderArrow, defaults, e, existingOpts, fn1, i, initialRender, l, len1, len2, len3, localeDefaults, localeStrings, materializedInput, n, o, opts, ordering, pivotTable, recordsProcessed, ref, ref1, ref2, ref3, refresh, refreshDelayed, renderer, rendererControl, rowOrderArrow, shownAttributes, tr1, tr2, uiTable, unused, unusedAttrsVerticalAutoCutoff, unusedAttrsVerticalAutoOverride, x;
	      if (overwrite == null) {
	        overwrite = false;
	      }
	      if (locale == null) {
	        locale = "en";
	      }
	      if (locales[locale] == null) {
	        locale = "en";
	      }
	      defaults = {
	        derivedAttributes: {},
	        aggregators: locales[locale].aggregators,
	        renderers: locales[locale].renderers,
	        hiddenAttributes: [],
	        menuLimit: 500,
	        cols: [],
	        rows: [],
	        vals: [],
	        rowOrder: "key_a_to_z",
	        colOrder: "key_a_to_z",
	        dataClass: PivotData,
	        exclusions: {},
	        inclusions: {},
	        unusedAttrsVertical: 85,
	        autoSortUnusedAttrs: false,
	        onRefresh: null,
	        filter: function filter() {
	          return true;
	        },
	        sorters: {}
	      };
	      localeStrings = $.extend(true, {}, locales.en.localeStrings, locales[locale].localeStrings);
	      localeDefaults = {
	        rendererOptions: {
	          localeStrings: localeStrings
	        },
	        localeStrings: localeStrings
	      };
	      existingOpts = this.data("pivotUIOptions");
	      if (existingOpts == null || overwrite) {
	        opts = $.extend(true, {}, localeDefaults, $.extend({}, defaults, inputOpts));
	      } else {
	        opts = existingOpts;
	      }
	      try {
	        attrValues = {};
	        materializedInput = [];
	        recordsProcessed = 0;
	        PivotData.forEachRecord(input, opts.derivedAttributes, function (record) {
	          var attr, base, ref, value;
	          if (!opts.filter(record)) {
	            return;
	          }
	          materializedInput.push(record);
	          for (attr in record) {
	            if (!hasProp.call(record, attr)) continue;
	            if (attrValues[attr] == null) {
	              attrValues[attr] = {};
	              if (recordsProcessed > 0) {
	                attrValues[attr]["null"] = recordsProcessed;
	              }
	            }
	          }
	          for (attr in attrValues) {
	            value = (ref = record[attr]) != null ? ref : "null";
	            if ((base = attrValues[attr])[value] == null) {
	              base[value] = 0;
	            }
	            attrValues[attr][value]++;
	          }
	          return recordsProcessed++;
	        });
	        uiTable = $("<table>", {
	          "class": "pvtUi"
	        }).attr("cellpadding", 5);
	        rendererControl = $("<td>");
	        renderer = $("<select>").addClass('pvtRenderer').appendTo(rendererControl).bind("change", function () {
	          return refresh();
	        });
	        ref = opts.renderers;
	        for (x in ref) {
	          if (!hasProp.call(ref, x)) continue;
	          $("<option>").val(x).html(x).appendTo(renderer);
	        }
	        unused = $("<td>").addClass('pvtAxisContainer pvtUnused');
	        shownAttributes = function () {
	          var results;
	          results = [];
	          for (a in attrValues) {
	            if (indexOf.call(opts.hiddenAttributes, a) < 0) {
	              results.push(a);
	            }
	          }
	          return results;
	        }();
	        unusedAttrsVerticalAutoOverride = false;
	        if (opts.unusedAttrsVertical === "auto") {
	          unusedAttrsVerticalAutoCutoff = 120;
	        } else {
	          unusedAttrsVerticalAutoCutoff = parseInt(opts.unusedAttrsVertical);
	        }
	        if (!isNaN(unusedAttrsVerticalAutoCutoff)) {
	          attrLength = 0;
	          for (l = 0, len1 = shownAttributes.length; l < len1; l++) {
	            a = shownAttributes[l];
	            attrLength += a.length;
	          }
	          unusedAttrsVerticalAutoOverride = attrLength > unusedAttrsVerticalAutoCutoff;
	        }
	        if (opts.unusedAttrsVertical === true || unusedAttrsVerticalAutoOverride) {
	          unused.addClass('pvtVertList');
	        } else {
	          unused.addClass('pvtHorizList');
	        }
	        fn1 = function fn1(attr) {
	          var attrElem, checkContainer, closeFilterBox, controls, filterItem, filterItemExcluded, finalButtons, hasExcludedItem, len2, n, placeholder, ref1, sorter, triangleLink, v, value, valueCount, valueList, values;
	          values = function () {
	            var results;
	            results = [];
	            for (v in attrValues[attr]) {
	              results.push(v);
	            }
	            return results;
	          }();
	          hasExcludedItem = false;
	          valueList = $("<div>").addClass('pvtFilterBox').hide();
	          valueList.append($("<h4>").append($("<span>").text(attr), $("<span>").addClass("count").text("(" + values.length + ")")));
	          if (values.length > opts.menuLimit) {
	            valueList.append($("<p>").html(opts.localeStrings.tooMany));
	          } else {
	            if (values.length > 5) {
	              controls = $("<p>").appendTo(valueList);
	              sorter = getSort(opts.sorters, attr);
	              placeholder = opts.localeStrings.filterResults;
	              $("<input>", {
	                type: "text"
	              }).appendTo(controls).attr({
	                placeholder: placeholder,
	                "class": "pvtSearch"
	              }).bind("keyup", function () {
	                var accept, accept_gen, filter;
	                filter = $(this).val().toLowerCase().trim();
	                accept_gen = function accept_gen(prefix, accepted) {
	                  return function (v) {
	                    var real_filter, ref1;
	                    real_filter = filter.substring(prefix.length).trim();
	                    if (real_filter.length === 0) {
	                      return true;
	                    }
	                    return ref1 = Math.sign(sorter(v.toLowerCase(), real_filter)), indexOf.call(accepted, ref1) >= 0;
	                  };
	                };
	                accept = filter.startsWith(">=") ? accept_gen(">=", [1, 0]) : filter.startsWith("<=") ? accept_gen("<=", [-1, 0]) : filter.startsWith(">") ? accept_gen(">", [1]) : filter.startsWith("<") ? accept_gen("<", [-1]) : filter.startsWith("~") ? function (v) {
	                  if (filter.substring(1).trim().length === 0) {
	                    return true;
	                  }
	                  return v.toLowerCase().match(filter.substring(1));
	                } : function (v) {
	                  return v.toLowerCase().indexOf(filter) !== -1;
	                };
	                return valueList.find('.pvtCheckContainer p label span.value').each(function () {
	                  if (accept($(this).text())) {
	                    return $(this).parent().parent().show();
	                  } else {
	                    return $(this).parent().parent().hide();
	                  }
	                });
	              });
	              controls.append($("<br>"));
	              $("<button>", {
	                type: "button"
	              }).appendTo(controls).html(opts.localeStrings.selectAll).bind("click", function () {
	                valueList.find("input:visible:not(:checked)").prop("checked", true).toggleClass("changed");
	                return false;
	              });
	              $("<button>", {
	                type: "button"
	              }).appendTo(controls).html(opts.localeStrings.selectNone).bind("click", function () {
	                valueList.find("input:visible:checked").prop("checked", false).toggleClass("changed");
	                return false;
	              });
	            }
	            checkContainer = $("<div>").addClass("pvtCheckContainer").appendTo(valueList);
	            ref1 = values.sort(getSort(opts.sorters, attr));
	            for (n = 0, len2 = ref1.length; n < len2; n++) {
	              value = ref1[n];
	              valueCount = attrValues[attr][value];
	              filterItem = $("<label>");
	              filterItemExcluded = false;
	              if (opts.inclusions[attr]) {
	                filterItemExcluded = indexOf.call(opts.inclusions[attr], value) < 0;
	              } else if (opts.exclusions[attr]) {
	                filterItemExcluded = indexOf.call(opts.exclusions[attr], value) >= 0;
	              }
	              hasExcludedItem || (hasExcludedItem = filterItemExcluded);
	              $("<input>").attr("type", "checkbox").addClass('pvtFilter').attr("checked", !filterItemExcluded).data("filter", [attr, value]).appendTo(filterItem).bind("change", function () {
	                return $(this).toggleClass("changed");
	              });
	              filterItem.append($("<span>").addClass("value").text(value));
	              filterItem.append($("<span>").addClass("count").text("(" + valueCount + ")"));
	              checkContainer.append($("<p>").append(filterItem));
	            }
	          }
	          closeFilterBox = function closeFilterBox() {
	            if (valueList.find("[type='checkbox']").length > valueList.find("[type='checkbox']:checked").length) {
	              attrElem.addClass("pvtFilteredAttribute");
	            } else {
	              attrElem.removeClass("pvtFilteredAttribute");
	            }
	            valueList.find('.pvtSearch').val('');
	            valueList.find('.pvtCheckContainer p').show();
	            return valueList.hide();
	          };
	          finalButtons = $("<p>").appendTo(valueList);
	          if (values.length <= opts.menuLimit) {
	            $("<button>", {
	              type: "button"
	            }).text(opts.localeStrings.apply).appendTo(finalButtons).bind("click", function () {
	              if (valueList.find(".changed").removeClass("changed").length) {
	                refresh();
	              }
	              return closeFilterBox();
	            });
	          }
	          $("<button>", {
	            type: "button"
	          }).text(opts.localeStrings.cancel).appendTo(finalButtons).bind("click", function () {
	            valueList.find(".changed:checked").removeClass("changed").prop("checked", false);
	            valueList.find(".changed:not(:checked)").removeClass("changed").prop("checked", true);
	            return closeFilterBox();
	          });
	          triangleLink = $("<span>").addClass('pvtTriangle').html(" &#x25BE;").bind("click", function (e) {
	            var left, ref2, top;
	            ref2 = $(e.currentTarget).position(), left = ref2.left, top = ref2.top;
	            return valueList.css({
	              left: left + 10,
	              top: top + 10
	            }).show();
	          });
	          attrElem = $("<li>").addClass("axis_" + i).append($("<span>").addClass('pvtAttr').text(attr).data("attrName", attr).append(triangleLink));
	          if (hasExcludedItem) {
	            attrElem.addClass('pvtFilteredAttribute');
	          }
	          return unused.append(attrElem).append(valueList);
	        };
	        for (i in shownAttributes) {
	          if (!hasProp.call(shownAttributes, i)) continue;
	          attr = shownAttributes[i];
	          fn1(attr);
	        }
	        tr1 = $("<tr>").appendTo(uiTable);
	        aggregator = $("<select>").addClass('pvtAggregator').bind("change", function () {
	          return refresh();
	        });
	        ref1 = opts.aggregators;
	        for (x in ref1) {
	          if (!hasProp.call(ref1, x)) continue;
	          aggregator.append($("<option>").val(x).html(x));
	        }
	        ordering = {
	          key_a_to_z: {
	            rowSymbol: "&varr;",
	            colSymbol: "&harr;",
	            next: "value_a_to_z"
	          },
	          value_a_to_z: {
	            rowSymbol: "&darr;",
	            colSymbol: "&rarr;",
	            next: "value_z_to_a"
	          },
	          value_z_to_a: {
	            rowSymbol: "&uarr;",
	            colSymbol: "&larr;",
	            next: "key_a_to_z"
	          }
	        };
	        rowOrderArrow = $("<a>", {
	          role: "button"
	        }).addClass("pvtRowOrder").data("order", opts.rowOrder).html(ordering[opts.rowOrder].rowSymbol).bind("click", function () {
	          $(this).data("order", ordering[$(this).data("order")].next);
	          $(this).html(ordering[$(this).data("order")].rowSymbol);
	          return refresh();
	        });
	        colOrderArrow = $("<a>", {
	          role: "button"
	        }).addClass("pvtColOrder").data("order", opts.colOrder).html(ordering[opts.colOrder].colSymbol).bind("click", function () {
	          $(this).data("order", ordering[$(this).data("order")].next);
	          $(this).html(ordering[$(this).data("order")].colSymbol);
	          return refresh();
	        });
	        $("<td>").addClass('pvtVals').appendTo(tr1).append(aggregator).append(rowOrderArrow).append(colOrderArrow).append($("<br>"));
	        $("<td>").addClass('pvtAxisContainer pvtHorizList pvtCols').appendTo(tr1);
	        tr2 = $("<tr>").appendTo(uiTable);
	        tr2.append($("<td>").addClass('pvtAxisContainer pvtRows').attr("valign", "top"));
	        pivotTable = $("<td>").attr("valign", "top").addClass('pvtRendererArea').appendTo(tr2);
	        if (opts.unusedAttrsVertical === true || unusedAttrsVerticalAutoOverride) {
	          uiTable.find('tr:nth-child(1)').prepend(rendererControl);
	          uiTable.find('tr:nth-child(2)').prepend(unused);
	        } else {
	          uiTable.prepend($("<tr>").append(rendererControl).append(unused));
	        }
	        this.html(uiTable);
	        ref2 = opts.cols;
	        for (n = 0, len2 = ref2.length; n < len2; n++) {
	          x = ref2[n];
	          this.find(".pvtCols").append(this.find(".axis_" + $.inArray(x, shownAttributes)));
	        }
	        ref3 = opts.rows;
	        for (o = 0, len3 = ref3.length; o < len3; o++) {
	          x = ref3[o];
	          this.find(".pvtRows").append(this.find(".axis_" + $.inArray(x, shownAttributes)));
	        }
	        if (opts.aggregatorName != null) {
	          this.find(".pvtAggregator").val(opts.aggregatorName);
	        }
	        if (opts.rendererName != null) {
	          this.find(".pvtRenderer").val(opts.rendererName);
	        }
	        initialRender = true;
	        refreshDelayed = function (_this) {
	          return function () {
	            var exclusions, inclusions, len4, newDropdown, numInputsToProcess, pivotUIOptions, pvtVals, ref4, ref5, subopts, t, u, unusedAttrsContainer, vals;
	            subopts = {
	              derivedAttributes: opts.derivedAttributes,
	              localeStrings: opts.localeStrings,
	              rendererOptions: opts.rendererOptions,
	              sorters: opts.sorters,
	              cols: [],
	              rows: [],
	              dataClass: opts.dataClass
	            };
	            numInputsToProcess = (ref4 = opts.aggregators[aggregator.val()]([])().numInputs) != null ? ref4 : 0;
	            vals = [];
	            _this.find(".pvtRows li span.pvtAttr").each(function () {
	              return subopts.rows.push($(this).data("attrName"));
	            });
	            _this.find(".pvtCols li span.pvtAttr").each(function () {
	              return subopts.cols.push($(this).data("attrName"));
	            });
	            _this.find(".pvtVals select.pvtAttrDropdown").each(function () {
	              if (numInputsToProcess === 0) {
	                return $(this).remove();
	              } else {
	                numInputsToProcess--;
	                if ($(this).val() !== "") {
	                  return vals.push($(this).val());
	                }
	              }
	            });
	            if (numInputsToProcess !== 0) {
	              pvtVals = _this.find(".pvtVals");
	              for (x = t = 0, ref5 = numInputsToProcess; 0 <= ref5 ? t < ref5 : t > ref5; x = 0 <= ref5 ? ++t : --t) {
	                newDropdown = $("<select>").addClass('pvtAttrDropdown').append($("<option>")).bind("change", function () {
	                  return refresh();
	                });
	                for (u = 0, len4 = shownAttributes.length; u < len4; u++) {
	                  attr = shownAttributes[u];
	                  newDropdown.append($("<option>").val(attr).text(attr));
	                }
	                pvtVals.append(newDropdown);
	              }
	            }
	            if (initialRender) {
	              vals = opts.vals;
	              i = 0;
	              _this.find(".pvtVals select.pvtAttrDropdown").each(function () {
	                $(this).val(vals[i]);
	                return i++;
	              });
	              initialRender = false;
	            }
	            subopts.aggregatorName = aggregator.val();
	            subopts.vals = vals;
	            subopts.aggregator = opts.aggregators[aggregator.val()](vals);
	            subopts.renderer = opts.renderers[renderer.val()];
	            subopts.rowOrder = rowOrderArrow.data("order");
	            subopts.colOrder = colOrderArrow.data("order");
	            exclusions = {};
	            _this.find('input.pvtFilter').not(':checked').each(function () {
	              var filter;
	              filter = $(this).data("filter");
	              if (exclusions[filter[0]] != null) {
	                return exclusions[filter[0]].push(filter[1]);
	              } else {
	                return exclusions[filter[0]] = [filter[1]];
	              }
	            });
	            inclusions = {};
	            _this.find('input.pvtFilter:checked').each(function () {
	              var filter;
	              filter = $(this).data("filter");
	              if (exclusions[filter[0]] != null) {
	                if (inclusions[filter[0]] != null) {
	                  return inclusions[filter[0]].push(filter[1]);
	                } else {
	                  return inclusions[filter[0]] = [filter[1]];
	                }
	              }
	            });
	            subopts.filter = function (record) {
	              var excludedItems, k, ref6, ref7;
	              if (!opts.filter(record)) {
	                return false;
	              }
	              for (k in exclusions) {
	                excludedItems = exclusions[k];
	                if (ref6 = "" + ((ref7 = record[k]) != null ? ref7 : 'null'), indexOf.call(excludedItems, ref6) >= 0) {
	                  return false;
	                }
	              }
	              return true;
	            };
	            pivotTable.pivot(materializedInput, subopts);
	            pivotUIOptions = $.extend({}, opts, {
	              cols: subopts.cols,
	              rows: subopts.rows,
	              colOrder: subopts.colOrder,
	              rowOrder: subopts.rowOrder,
	              vals: vals,
	              exclusions: exclusions,
	              inclusions: inclusions,
	              inclusionsInfo: inclusions,
	              aggregatorName: aggregator.val(),
	              rendererName: renderer.val()
	            });
	            _this.data("pivotUIOptions", pivotUIOptions);
	            if (opts.autoSortUnusedAttrs) {
	              unusedAttrsContainer = _this.find("td.pvtUnused.pvtAxisContainer");
	              $(unusedAttrsContainer).children("li").sort(function (a, b) {
	                return naturalSort($(a).text(), $(b).text());
	              }).appendTo(unusedAttrsContainer);
	            }
	            pivotTable.css("opacity", 1);
	            if (opts.onRefresh != null) {
	              return opts.onRefresh(pivotUIOptions);
	            }
	          };
	        }(this);
	        refresh = function (_this) {
	          return function () {
	            pivotTable.css("opacity", 0.5);
	            return setTimeout(refreshDelayed, 10);
	          };
	        }(this);
	        refresh();
	        this.find(".pvtAxisContainer").sortable({
	          update: function update(e, ui) {
	            if (ui.sender == null) {
	              return refresh();
	            }
	          },
	          connectWith: this.find(".pvtAxisContainer"),
	          items: 'li',
	          placeholder: 'pvtPlaceholder'
	        });
	      } catch (_error) {
	        e = _error;
	        if (typeof console !== "undefined" && console !== null) {
	          console.error(e.stack);
	        }
	        this.html(opts.localeStrings.uiRenderError);
	      }
	      return this;
	    };
	
	    /*
	    Heatmap post-processing
	     */
	    $.fn.heatmap = function (scope, opts) {
	      var colorScaleGenerator, heatmapper, i, j, l, n, numCols, numRows, ref, ref1, ref2;
	      if (scope == null) {
	        scope = "heatmap";
	      }
	      numRows = this.data("numrows");
	      numCols = this.data("numcols");
	      colorScaleGenerator = opts != null ? (ref = opts.heatmap) != null ? ref.colorScaleGenerator : void 0 : void 0;
	      if (colorScaleGenerator == null) {
	        colorScaleGenerator = function colorScaleGenerator(values) {
	          var max, min;
	          min = Math.min.apply(Math, values);
	          max = Math.max.apply(Math, values);
	          return function (x) {
	            var nonRed;
	            nonRed = 255 - Math.round(255 * (x - min) / (max - min));
	            return "rgb(255," + nonRed + "," + nonRed + ")";
	          };
	        };
	      }
	      heatmapper = function (_this) {
	        return function (scope) {
	          var colorScale, forEachCell, values;
	          forEachCell = function forEachCell(f) {
	            return _this.find(scope).each(function () {
	              var x;
	              x = $(this).data("value");
	              if (x != null && isFinite(x)) {
	                return f(x, $(this));
	              }
	            });
	          };
	          values = [];
	          forEachCell(function (x) {
	            return values.push(x);
	          });
	          colorScale = colorScaleGenerator(values);
	          return forEachCell(function (x, elem) {
	            return elem.css("background-color", colorScale(x));
	          });
	        };
	      }(this);
	      switch (scope) {
	        case "heatmap":
	          heatmapper(".pvtVal");
	          break;
	        case "rowheatmap":
	          for (i = l = 0, ref1 = numRows; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
	            heatmapper(".pvtVal.row" + i);
	          }
	          break;
	        case "colheatmap":
	          for (j = n = 0, ref2 = numCols; 0 <= ref2 ? n < ref2 : n > ref2; j = 0 <= ref2 ? ++n : --n) {
	            heatmapper(".pvtVal.col" + j);
	          }
	      }
	      heatmapper(".pvtTotal.rowTotal");
	      heatmapper(".pvtTotal.colTotal");
	      return this;
	    };
	
	    /*
	    Barchart post-processing
	     */
	    return $.fn.barchart = function () {
	      var barcharter, i, l, numCols, numRows, ref;
	      numRows = this.data("numrows");
	      numCols = this.data("numcols");
	      barcharter = function (_this) {
	        return function (scope) {
	          var forEachCell, max, scaler, values;
	          forEachCell = function forEachCell(f) {
	            return _this.find(scope).each(function () {
	              var x;
	              x = $(this).data("value");
	              if (x != null && isFinite(x)) {
	                return f(x, $(this));
	              }
	            });
	          };
	          values = [];
	          forEachCell(function (x) {
	            return values.push(x);
	          });
	          max = Math.max.apply(Math, values);
	          scaler = function scaler(x) {
	            return 100 * x / (1.4 * max);
	          };
	          return forEachCell(function (x, elem) {
	            var text, wrapper;
	            text = elem.text();
	            wrapper = $("<div>").css({
	              "position": "relative",
	              "height": "55px"
	            });
	            wrapper.append($("<div>").css({
	              "position": "absolute",
	              "bottom": 0,
	              "left": 0,
	              "right": 0,
	              "height": scaler(x) + "%",
	              "background-color": "gray"
	            }));
	            wrapper.append($("<div>").text(text).css({
	              "position": "relative",
	              "padding-left": "5px",
	              "padding-right": "5px"
	            }));
	            return elem.css({
	              "padding": 0,
	              "padding-top": "5px",
	              "text-align": "center"
	            }).html(wrapper);
	          });
	        };
	      }(this);
	      for (i = l = 0, ref = numRows; 0 <= ref ? l < ref : l > ref; i = 0 <= ref ? ++l : --l) {
	        barcharter(".pvtVal.row" + i);
	      }
	      barcharter(".pvtTotal.colTotal");
	      return this;
	    };
	  });
	}).call(undefined);
	
	//# sourceMappingURL=pivot.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)(module), __webpack_require__(149)))

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _perfil = __webpack_require__(368);
	
	var _perfil2 = _interopRequireDefault(_perfil);
	
	var _perfil3 = __webpack_require__(383);
	
	var _perfil4 = _interopRequireDefault(_perfil3);
	
	var _perfildashController = __webpack_require__(385);
	
	var _perfildashController2 = _interopRequireDefault(_perfildashController);
	
	var _modalEditCommentsCtrl = __webpack_require__(395);
	
	var _modalEditCommentsCtrl2 = _interopRequireDefault(_modalEditCommentsCtrl);
	
	var _areasOfInterestCtrl = __webpack_require__(396);
	
	var _areasOfInterestCtrl2 = _interopRequireDefault(_areasOfInterestCtrl);
	
	var _perfildocenteController = __webpack_require__(397);
	
	var _perfildocenteController2 = _interopRequireDefault(_perfildocenteController);
	
	var _perfildocentechartController = __webpack_require__(400);
	
	var _perfildocentechartController2 = _interopRequireDefault(_perfildocentechartController);
	
	var _perfilinvchartController = __webpack_require__(401);
	
	var _perfilinvchartController2 = _interopRequireDefault(_perfilinvchartController);
	
	var _Perfilinvestigationcontroller = __webpack_require__(402);
	
	var _Perfilinvestigationcontroller2 = _interopRequireDefault(_Perfilinvestigationcontroller);
	
	var _perfilextenchartController = __webpack_require__(403);
	
	var _perfilextenchartController2 = _interopRequireDefault(_perfilextenchartController);
	
	var _perfilextencioncotroller = __webpack_require__(404);
	
	var _perfilextencioncotroller2 = _interopRequireDefault(_perfilextencioncotroller);
	
	var _trayectoriaurcontroller = __webpack_require__(405);
	
	var _trayectoriaurcontroller2 = _interopRequireDefault(_trayectoriaurcontroller);
	
	var _TrayectoriaURGraph = __webpack_require__(408);
	
	var _TrayectoriaURGraph2 = _interopRequireDefault(_TrayectoriaURGraph);
	
	var _perfilformacioncontroller = __webpack_require__(409);
	
	var _perfilformacioncontroller2 = _interopRequireDefault(_perfilformacioncontroller);
	
	var _Reconocimientose_incController = __webpack_require__(410);
	
	var _Reconocimientose_incController2 = _interopRequireDefault(_Reconocimientose_incController);
	
	var _Trayectoria_PreviaCtrl = __webpack_require__(412);
	
	var _Trayectoria_PreviaCtrl2 = _interopRequireDefault(_Trayectoria_PreviaCtrl);
	
	var _actualizacioncontroller = __webpack_require__(413);
	
	var _actualizacioncontroller2 = _interopRequireDefault(_actualizacioncontroller);
	
	var _updateDataProfileCtrl = __webpack_require__(414);
	
	var _updateDataProfileCtrl2 = _interopRequireDefault(_updateDataProfileCtrl);
	
	var _workflowMaintainerCtrl = __webpack_require__(420);
	
	var _workflowMaintainerCtrl2 = _interopRequireDefault(_workflowMaintainerCtrl);
	
	var _cvPrintController = __webpack_require__(423);
	
	var _cvPrintController2 = _interopRequireDefault(_cvPrintController);
	
	var _newRequestCtrl = __webpack_require__(424);
	
	var _newRequestCtrl2 = _interopRequireDefault(_newRequestCtrl);
	
	var _powerbiPerfilCtrl = __webpack_require__(425);
	
	var _powerbiPerfilCtrl2 = _interopRequireDefault(_powerbiPerfilCtrl);
	
	var _dialogdetailcontroller = __webpack_require__(426);
	
	var _dialogdetailcontroller2 = _interopRequireDefault(_dialogdetailcontroller);
	
	var _perfil_popcontroller = __webpack_require__(428);
	
	var _perfil_popcontroller2 = _interopRequireDefault(_perfil_popcontroller);
	
	var _modalDetailsURtCtrl = __webpack_require__(429);
	
	var _modalDetailsURtCtrl2 = _interopRequireDefault(_modalDetailsURtCtrl);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	var _perfilSrv = __webpack_require__(430);
	
	var _perfilSrv2 = _interopRequireDefault(_perfilSrv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//perfil formacion
	
	
	//UR trajectory
	
	
	// perfil extencion
	
	
	// perfil investigation
	
	
	// perfil docente controller
	
	// runs
	__webpack_require__(431);
	
	//Actualizacion_Perfil
	
	
	//Reconocimientoseinc
	
	
	// perfil dash controller
	// routers
	exports.default = angular.module('app.profile', [_perfilSrv2.default, 'angularFileUpload']).config(_perfil2.default).run(_perfil4.default).controller('perfildashController', _perfildashController2.default).controller('perfildocenteController', _perfildocenteController2.default).controller('perfildocentechartController', _perfildocentechartController2.default).controller('perfilinvchartController', _perfilinvchartController2.default).controller('perfilextenchartController', _perfilextenchartController2.default).controller('Perfilinvestigationcontroller', _Perfilinvestigationcontroller2.default).controller('perfilextencioncotroller', _perfilextencioncotroller2.default).controller('trayectoriaurcontroller', _trayectoriaurcontroller2.default).controller('TrayectoriaURGraph', _TrayectoriaURGraph2.default).controller('perfilformacioncontroller', _perfilformacioncontroller2.default).controller('Reconocimientose_incController', _Reconocimientose_incController2.default).controller('Trayectoria_PreviaCtrl', _Trayectoria_PreviaCtrl2.default).controller('actualizacioncontroller', _actualizacioncontroller2.default).controller('dialogdetailcontroller', _dialogdetailcontroller2.default).controller('perfil_popcontroller', _perfil_popcontroller2.default).controller('modalDetailsURtCtrl', _modalDetailsURtCtrl2.default).controller('cvPrintCtrl', _cvPrintController2.default).controller('updateDataProfileCtrl', _updateDataProfileCtrl2.default).controller('workflowMaintainerCtrl', _workflowMaintainerCtrl2.default).controller('newRequestCtrl', _newRequestCtrl2.default).controller('modalEditCommentsCtrl', _modalEditCommentsCtrl2.default).controller('areasOfInterestCtrl', _areasOfInterestCtrl2.default).controller('powerbiPerfilCtrl', _powerbiPerfilCtrl2.default).constant('perfil', [{
		title: 'Perfil',
		icon: 'mdi-image-tune',
		moduleId: _globalConfig2.default.menuModulesId.Profile,
		subMenu: [{
			title: 'Perfil Dash',
			url: 'profile.perfil_dash',
			rolesAllowed: []
		}, {
			title: 'Mi perfil',
			url: 'profile.perfil_dash',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
		}, {
			title: 'Consultar Perfiles',
			url: 'profile.perfil_dash',
			rolesAllowed: [_globalConfig2.default.userRolesIds.profileAdmin, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.comiteeAdmin, _globalConfig2.default.userRolesIds.committee]
		}, {
			title: 'Perfil Docente',
			url: 'profile.perfil_docente',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
	
		}, {
			title: 'Perfil de Investigación',
			url: 'profile.perfil_investigation',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
	
		}, {
			title: 'Perfil de Extensión',
			url: 'profile.perfil_extencion',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
	
		}, {
			title: 'Trayectoria UR',
			url: 'profile.UR_trajectory',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
	
		}, {
			title: 'Perfil de Formación',
			url: 'profile.perfilde_formacion',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
	
		}, {
			title: 'Reconocimientos e Inc.',
			url: 'profile.Reconocimientose_inc',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
	
		}, {
			title: 'Trayectoria Previa',
			url: 'profile.Trayectoria_Previa',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher]
		}, {
			title: 'Pendientes de Revisión',
			url: 'profile.Actualizacion_Perfil',
			rolesAllowed: [_globalConfig2.default.userRolesIds.reviewerUpdatePerfil, _globalConfig2.default.userRolesIds.academicDirection]
		}, {
			title: 'Pendientes de Aprobación',
			url: 'profile.Actualizacion_Perfil',
			rolesAllowed: [_globalConfig2.default.userRolesIds.approverUpdatePerfil, _globalConfig2.default.userRolesIds.humanDeployment]
		},
		// {
		//   'title': 'Buscar Perfil',
		//   'url': 'profile.perfil_dash',
		//   'rolesAllowed': [GlobalConfig.userRolesIds.generalConsultant],
		// },
		{
			title: 'Reporte perfil de profesores',
			url: 'profile.powerbi',
			rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.workPlanAdmin]
		}, {
			title: 'Mantenedor de flujos de perfil',
			url: 'fullscreen.workflowMaintainer',
			rolesAllowed: [_globalConfig2.default.userRolesIds.generalAdmin, _globalConfig2.default.userRolesIds.profileAdmin]
		}]
	}]).name;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
		$locationProvider.html5Mode(true);
		$stateProvider.state('profile', {
			abstract: false,
			url: '/app/profile',
			redirectTo: 'profile.perfil_dash',
			views: {
				'': {
					template: __webpack_require__(168)
				},
				'content': {
					template: __webpack_require__(169)
				},
				'aside': {
					template: __webpack_require__(170),
					controller: 'AsideCtrl'
				},
				'header': {
					template: __webpack_require__(171),
					controller: 'HeaderCtrl'
				},
				'footer': {
					template: __webpack_require__(177)
				}
			}
		}).state('profile.perfil_dash', {
			abstract: false,
			tag: 'perfil_dash',
			url: '/perfil_dash?teacherId',
			template: __webpack_require__(369),
			controller: 'perfildashController',
			controllerAs: 'perfildashVM',
			data: {
				displayName: 'Perfil',
				title: 'Perfil',
				order: 0,
				siblings: [{
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 1
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 2
				}]
			}
		}).state('profile.perfil_docente', {
			abstract: false,
			tag: 'perfil_docente',
			url: '/perfil_docente/:teacherId',
			template: __webpack_require__(370),
			controller: 'perfildocenteController',
			controllerAs: 'perfildocenteVM',
			data: {
				displayName: '',
				title: 'Perfil Docente',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.powerbi', {
			abstract: false,
			tag: 'Reporte',
			url: '/perfilPowerbi',
			template: __webpack_require__(371),
			controller: 'powerbiPerfilCtrl',
			controllerAs: 'powerbiCtrl',
			data: {
				displayName: 'Reporte',
				title: 'Reporte',
				order: 0
			}
	
		}).state('profile.perfil_investigation', {
			abstract: false,
			tag: 'perfil_investigation',
			url: '/perfil_investigation/:teacherId',
			template: __webpack_require__(372),
			controller: 'Perfilinvestigationcontroller',
			controllerAs: 'Perfil',
			data: {
				displayName: '',
				title: 'Perfil de investigación',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.perfil_extencion', {
			abstract: false,
			tag: 'perfil_extencion',
			url: '/perfil_extencion/:teacherId',
			template: __webpack_require__(373),
			controller: 'perfilextencioncotroller',
			controllerAs: 'Perfil',
			data: {
				displayName: '',
				title: 'Perfil de extensión',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.UR_trajectory', {
			abstract: false,
			tag: 'UR_trajectory',
			url: '/UR_trajectory/:teacherId',
			template: __webpack_require__(374),
			controller: 'trayectoriaurcontroller',
			controllerAs: 'Perfil',
			data: {
				displayName: '',
				title: 'Trayectoria UR',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.perfilde_formacion', {
			abstract: false,
			tag: 'perfilde_formacion',
			url: '/perfilde_formacion/:teacherId',
			template: __webpack_require__(375),
			controller: 'perfilformacioncontroller',
			controllerAs: 'Perfil',
			data: {
				displayName: '',
				title: 'Perfil de formación',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.Reconocimientose_inc', {
			abstract: false,
			tag: 'Reconocimientose_inc',
			url: '/Reconocimientose_inc/:teacherId',
			template: __webpack_require__(376),
			controller: 'Reconocimientose_incController',
			controllerAs: 'Perfil',
			data: {
				displayName: '',
				title: 'Reconocimientos e Inc.',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.Trayectoria_Previa', {
			abstract: false,
			tag: '',
			url: '/Trayectoria_Previa/:teacherId',
			template: __webpack_require__(377),
			controller: 'Trayectoria_PreviaCtrl',
			controllerAs: 'Perfil',
			data: {
				displayName: '',
				title: 'Trayectoria previa',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.Actualizacion_Perfil', {
			abstract: false,
			tag: 'Actualizacion_Perfil',
			url: '/Actualizacion_Perfil',
			template: __webpack_require__(378),
			controller: 'actualizacioncontroller',
			controllerAs: 'Perfil',
			data: {
				displayName: 'Formulario de actualización',
				title: 'Actualizacion de perfil',
				order: 3,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}]
			}
		}).state('profile.nueva_solicitud', {
			abstract: false,
			tag: 'nueva_solicitud',
			url: '/nueva_solicitud',
			template: __webpack_require__(379),
			controller: 'newRequestCtrl',
			controllerAs: 'newReq',
			data: {
				displayName: '',
				title: 'Nueva solicitud',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 2
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 3
				}]
			}
		}).state('profile.actualizacion_update', {
			abstract: false,
			tag: 'actualizacion_update',
			url: '/actualizacion_update/:type/:stage?title&nTicket&historyType&idUser&nameUser&idTeacher',
			template: __webpack_require__(380),
			controller: 'updateDataProfileCtrl',
			controllerAs: 'updateVM',
			data: {
				displayName: '',
				title: 'Ver detalle',
				order: 2,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.imprimir_hoja',
					rolesAllowed: [_globalConfig2.default.userRolesIds.teacher],
					order: 1
				}]
			}
		}).state('profile.imprimir_hoja', {
			abstract: false,
			tag: 'imprimir_hoja',
			url: '/imprimir_hoja',
			template: __webpack_require__(381),
			controller: 'cvPrintCtrl',
			controllerAs: 'cvPrintVM',
			data: {
				displayName: 'Descargar hoja de vida',
				title: 'Descargar hoja de vida',
				order: 1,
				siblings: [{
					name: 'profile.perfil_dash',
					order: 0
				}, {
					name: 'profile.Actualizacion_Perfil',
					order: 2
				}]
			}
		}).state('fullscreen.workflowMaintainer', {
			abstract: false,
			tag: 'workflowMaintainer',
			url: '/workflowMaintainer',
			template: __webpack_require__(382),
			controller: 'workflowMaintainerCtrl',
			controllerAs: 'workflowMaintainerCtrl',
			data: {
				displayName: '',
				title: 'Matenedor de Flujos',
				order: 0
			}
		});
	}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row p\"> <div class=\"col-xs-12 p-t\"> <div class=card ng-if=perfildashVM.showSelect style=overflow:visible> <div class=card-body> <div class=row> <div class=\"col-xs-12 m-b-md\"> <label>{{ 'SEARCH_PROFILE_DASH' | translate}}</label> <ui-select ng-model=perfildashVM.teacherSelected ng-change=perfildashVM.onTeacherChange(perfildashVM.teacherSelected.idTeacher)> <ui-select-match class=u-select-overflow-hide placeholder=\"Buscar profesor...\" allow-clear=true> {{perfildashVM.teacherSelected.ds_identification}} - {{perfildashVM.teacherSelected.fullname}} </ui-select-match> <ui-select-choices repeat=\"item in perfildashVM.listTeachers | filter: $select.search\" refresh=perfildashVM.searchingTeacher($select.search) refresh-delay=400> <small ng-bind-html=\"item.idTeacher + ' - ' + item.ds_identification | highlight: $select.search\">{{item.ds_identification}}</small><br/> <span ng-bind-html=\"item.fullname | highlight: $select.search\">{{item.fullname}}</span> </ui-select-choices> </ui-select> </div> </div> </div> </div> <div class=card ng-if=perfildashVM.showDatos> <div class=loading-details ng-if=perfildashVM.loadingData.dpersonales> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=\"card-body no-padding\"> <div class=\"col-lg-7 col-md-7\"> <div class=\"row p-md b-r\"> <div class=\"col-lg-4 col-md-4\"> <img src={{picture}} class=\"img-responsive image_profile_blog align_center\" err-src={{noPicture}} style=height:138px> </div> <div class=\"col-lg-8 col-md-8\"> <h4> {{perfildashVM.dataInfo.name}} - {{perfildashVM.dataInfo.hierarchy}} </h4> <h4> {{perfildashVM.dataInfo.hierarchyType}} </h4> <h4> {{perfildashVM.dataInfo.ds_academicUnit}} </h4> <h4 ng-if=\"perfildashVM.dataInfo.local_charge !== null\"> {{perfildashVM.dataInfo.local_charge}} </h4> <a ng-if=perfildashVM.showModalDetailTeacher class=\"text-azul cursor-pointer\" href=# ng-click=perfildashVM.showModal() alt=link> Ver datos personales </a> </div> </div> <div class=\"row gris-dark draggable-bar\"> <div class=col-lg-12> <ul id=draggablePanelList class=\"list-horizontal exo\"> <li> <div class=drag_div> <a class=cursor-pointer ng-click=perfildashVM.areasOfInterest()> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=right class=\"tooltip-multiline text-center\"> Registre en este espacio sus áreas de interés en docencia, investigación y extensión. </md-tooltip> </i> Áreas de interés</a> </div> </li> <li> <div>{{perfildashVM.dataInfo.ds_area_interest1}}</div> </li> <li> <div>{{perfildashVM.dataInfo.ds_area_interest2}}</div> </li> <li> <div>{{perfildashVM.dataInfo.ds_area_interest3}}</div> </li> <li> <div>{{perfildashVM.dataInfo.ds_area_interest4}}</div> </li> <li> <div>{{perfildashVM.dataInfo.ds_area_interest5}}</div> </li> <li class=pull-right> <div class=drag_div> </div> </li> </ul> </div> </div> </div> <div class=\"col-lg-5 col-md-5\"> <div ng-if=!perfildashVM.userIsNotATeacher class=\"row p-md\"> <div class=col-xs-12> <div class=loading-details ng-if=perfildashVM.loadingData.dpersonales> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <span ng-if=\"perfildashVM.dataInfo.ds_comments === null || perfildashVM.dataInfo.ds_comments === undefined ||\n              (perfildashVM.dataInfo.ds_comments != null && perfildashVM.dataInfo.ds_comments.length === 0)\"> <p class=text-editable>Edite en este espacio el texto de descripción general de su perfil profesional: fortalezas académicas, temas de interés, experiencias destacas, etc. Puede registrarlo en cualquier idioma.</p> </span> <div ta-bind ng-model=perfildashVM.dataInfo.ds_comments> </div> </div> </div> </div> <div class=\"col-lg-5 col-lg-offset-7 col-md-5 col-md-offset-7\" style=position:absolute;bottom:0 ng-if=!perfildashVM.showSelect> <a href=# ng-click=perfildashVM.editComments()><i class=\"mdi-editor-mode-edit i-24 pull right\"></i></a> </div> </div> </div> </div> </div> <div class=\"row p gutter-10\" ng-if=perfildashVM.showDatos> <div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"> <div class=\"brd-md card active\"> <div class=loading-details ng-if=perfildashVM.loadingData.docente> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=card-body> <a href=# md-ink-ripple ng-click=\"perfildashVM.viewDetails('perfil_docente')\"> <div id=perfil_chart_d style=height:270px></div> <h4 class=\"text-azul font-medium text-center\" style=font-size:14px;margin-top:24px>Perfil Docente</h4> </a> </div> </div> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"> <div class=\"brd-md card active\"> <div class=loading-details ng-if=perfildashVM.loadingData.invest> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=card-body> <a ng-click=\"perfildashVM.viewDetails('perfil_investigation')\"> <div id=perfil_inv_d style=height:270px></div> <h4 class=\"text-azul font-medium text-center\" style=font-size:14px;margin-top:24px>Perfil de Investigación</h4> </a> </div> </div> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"> <div class=\"brd-md card active\"> <div class=loading-details ng-if=perfildashVM.loadingData.extend> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=card-body> <a href=# md-ink-ripple ng-click=\"perfildashVM.viewDetails('perfil_extencion')\"> <div id=perfil_ext_d style=height:270px></div> <h4 class=\"text-azul font-medium text-center\" style=font-size:14px;margin-top:24px>Perfil de Extensión</h4> </a> </div> </div> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"> <div class=\"brd-md card active\"> <div class=loading-details ng-if=perfildashVM.loadingData.tur> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=card-body> <a href=# md-ink-ripple ng-click=\"perfildashVM.viewDetails('UR_trajectory')\"> <p class=text-center>Última actualización el {{perfildashVM.singleName.Year || '0000'}}</p> <div id=container style=height:240px> <div class=u-time-line ng-show=perfildashVM.show> <div class=\"item-time-line azul-theme\"> <div class=\"content-circules small azul-theme\"> <div class=big-circule> <div class=middle-circule> <div class=small-circule></div> </div> </div> </div> <p> <span>{{perfildashVM.singleName.Year || 'Sin información'}}</span> {{perfildashVM.singleName.designation || ''}}<br> {{perfildashVM.singleName.subject}}<br> {{perfildashVM.singleName.Rating}} {{ (perfildashVM.singleName.Rating) ? 'pts de producción': ''}} </p> </div> </div> </div> <h4 class=\"text-azul font-medium text-center\" style=font-size:14px;margin-top:24px>Trayectoria UR</h4> </a> </div> </div> </div> <div class=clearfix></div> <div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"> <div class=\"brd-md card active\"> <div class=loading-details ng-if=perfildashVM.loadingData.formacion> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=card-body> <a href=# md-ink-ripple ng-click=\"perfildashVM.viewDetails('perfilde_formacion')\"> <p class=text-center>Última actualización el {{perfildashVM.lastFormation.end_date || '0000'}}</p> <div id=\"\" style=height:270px> <div class=row> <div class=\"col-xs-12 col-md-4\" style=padding-top:12%> <div class=\"img-circle grad-1\" style=width:100px;height:100px;padding:25px> <i class=\"mdi-social-school text-blanco text-center\" style=font-size:50px></i> </div> </div> <div class=\"col-xs-12 col-md-8 p-t-md\"> <p class=text-right> <span class=font-bold>Máximo nivel de <br>formación:</span><br> {{perfildashVM.lastFormation.ds_formation_level || 'Sin información'}} </p> <p class=text-right> <span class=font-bold>Fecha de reconocimiento:</span><br> {{(perfildashVM.lastFormation.program_name !== undefined)?perfildashVM.lastFormation.grade_date:''}} </p> </div> </div> </div> <h4 class=\"text-azul font-medium text-center\" style=font-size:14px;margin-top:24px>Perfil de Formación</h4> </a> </div> </div> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"> <div class=\"brd-md card active\"> <div class=loading-details ng-if=perfildashVM.loadingData.reco> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=card-body> <a href=# md-ink-ripple ng-click=\"perfildashVM.viewDetails('Reconocimientose_inc')\"> <p class=text-center>Última actualización el {{perfildashVM.lastAck.ack_year || '0000'}}</p> <div id=container style=height:270px> <div class=u-time-line> <div class=\"item-time-line azul-theme\"> <div class=\"content-circules small morado-theme\"> <div class=big-circule> <div class=middle-circule> <div class=small-circule></div> </div> </div> </div> <p> <span>{{perfildashVM.lastAck.ack_year || 'Sin Información'}}</span> {{perfildashVM.lastAck.ack_acknowledgment || ''}}<br> </p> </div> </div> </div> <h4 class=\"text-azul font-medium text-center\" style=font-size:14px;margin-top:24px>Reconocimientos e Inc.</h4> </a> </div> </div> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"> <div class=\"brd-md card active\"> <div class=loading-details ng-if=perfildashVM.loadingData.tprevia> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=card-body> <a href=# md-ink-ripple ng-click=\"perfildashVM.viewDetails('Trayectoria_Previa')\"> <p class=text-center>Última actualización el {{perfildashVM.trayectoriaPrevia.AnoFin || '0000'}}</p> <div class=text-center style=padding-top:24%;height:270px> <div class=\"img-circle center-block grad-2\" style=width:100px;height:100px;padding:25px> <i class=\"mdi-content-reply text-blanco text-center\" style=font-size:50px></i> </div> <p class=\"font-medium m-t\">{{(perfildashVM.registrosTP > 0)?'Ver información':'Sin información'}}</p> </div> <h4 class=\"text-azul font-medium text-center\" style=font-size:14px;margin-top:24px>Trayectoria Previa </h4> </a> </div> </div> </div> </div> <style type=text/css>.filetype_upload input[type=file]{display:none}.custom-file-upload{display:inline-block;padding:6px 12px;cursor:pointer}.filetype_upload button{margin:0;padding:2px;font-size:11px}.filetype_upload{position:absolute;bottom:-45px;right:41px}</style> ";

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = "<style></style> <div class=\"row p\"> <div class=\"col-lg-12 col-sm-12 title p-t-md\"> <div> <h4 class=\"col-md-10 no-margin\">Perfil Docente</h4> <div class=col-md-2 ng-if=perfildocenteVM.$stateParams.teacherId> <button class=\"btn btn-fw btn-info md-button md-ink-ripple no-margin\" type=button ng-click=perfildocenteVM.goBack()>Volver</button> </div> </div> </div> <div class=col-lg-12> <p class=text-16-important>Histórico de asignaturas dictadas en los diferentes niveles de formación. Consulte en el detalle de cada asignatura los resultados de apreciación de la docencia por parte de los estudiantes.</p> </div> </div> <div class=\"row p\"> <div class=\"col-xs-12 col-lg-4 col-md-4 col-sm-12\" ng-controller=perfildocentechartController> <div id=perfil_chart style=\"min-width:310px;height:400px;margin:0 auto\"></div> </div> <div class=\"col-xs-12 col-lg-8 col-md-8 col-sm-12\"> <div ui-grid=gridOptionsComplex ng-if=gridOptionsComplex.data ui-grid-pinning ui-grid-tree-view ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination class=\"grid grid-blue\"></div> </div> </div> ";

/***/ }),
/* 371 */
303,
/* 372 */
/***/ (function(module, exports) {

	module.exports = "<style>.grid{width:100%;height:400px}</style> <div class=\"row p\"> <div class=\"col-xs-12 col-md-8 title p-t-md\"> <h4>Perfil de Investigación </h4> <p class=text-16-important>Histórico de su producción científica durante los cuatro últimos años. Para consultar los detalles se debe ingresar al sistema PURE.</p> </div> <div class=\"col-xs-12 col-md-4 p-t-md\"> <button ng-if=Perfil.$stateParams.teacherId class=\"btn btn-fw btn-info md-button md-ink-ripple pull-right m-h-sm\" type=button ng-click=Perfil.goBack()>Volver</button> <md-button class=\"btn btn-fw btn-info text-center md-ink-ripple pull-right m-h-sm\" href=https://scholar.google.es/ >GAcademics</md-button> <md-button class=\"btn btn-fw btn-primary text-center md-ink-ripple pull-right m-h-sm\" href=https://urosario.pure.elsevier.com/ >Ver en PURE</md-button> </div> </div> <div class=\"row p\"> <div class=\"col-xs-12 col-lg-4\" ng-controller=perfilinvchartController> <div id=containt style=\"min-width:310px;height:400px;margin:0 auto\"></div> </div> <div class=\"col-xs-12 col-lg-8\"> <div ui-grid=gridOptionsComplex ng-if=gridOptionsComplex.data ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination class=\"grid grid-blue\"></div> </div> </div> ";

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = "<style>.grid{width:100%;height:400px}</style> <div class=\"row p\"> <div class=\"col-xs-12 col-md-8 title p-t-md\"> <h4>Perfil de Extensión <i class=\"i-24 text-azul mdi-action-info-outline\"><md-tooltip md-direction=bottom> Si encuentra alguna inconsistencia en la información sobre su formación, solicite el ajuste a través del formulario de actualización que encontrará en el menú superior. </md-tooltip></i> </h4> <p class=text-16-important>Histórico de las actividades de extensión en las que usted ha participado.</p> </div> <div class=\"col-xs-12 col-md-4 p-t-md\"> <button ng-if=Perfil.$stateParams.teacherId class=\"btn btn-fw btn-info md-button md-ink-ripple pull-right m-h-sm\" type=button ng-click=Perfil.goBack()>Volver</button> </div> </div> <div class=\"row p\"> <div class=\"col-xs-12 col-lg-3\" ng-controller=perfilextenchartController> <div id=container></div> </div> <div class=\"col-xs-12 col-lg-9\"> <div ui-grid=gridOptionsComplex ng-if=gridOptionsComplex.data ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination class=\"grid grid-blue\"></div> </div> </div>";

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports = "<style>.grid{width:100%;height:450px}.item-time-line{display:inline-flex}.item-time-line>p{margin-left:3em}</style> <div class=\"row p\"> <div class=\"col-xs-12 col-md-8 title p-t-md\"> <h4>Trayectoria UR <i class=\"i-24 text-azul mdi-action-info-outline\"><md-tooltip md-direction=bottom> Si encuentra alguna inconsistencia en la información sobre su formación, solicite el ajuste a través del formulario de actualización que encontrará en el menú superior. </md-tooltip></i> </h4> <p class=text-16-important>Consulte el histórico de su trayectoria en la Universidad. Al ingresar a cada categoría de vinculación en la línea de tiempo ubicada en el panel izquierdo, podrá consultar la información detallada de los criterios tenidos en cuenta en su vinculación o promoción. En el panel derecho podrá consultar los roles que ha asumido en la Universidad y su dedicación.</p> </div> <div class=\"col-xs-12 col-md-4 p-t-md\"> <button ng-if=Perfil.$stateParams.teacherId class=\"btn btn-fw btn-info md-button md-ink-ripple pull-right m-h-sm\" type=button ng-click=Perfil.goBack()>Volver</button> </div> </div> <div class=\"row p\" ng-controller=TrayectoriaURGraph> <div class=col-lg-4> <div class=row> <div class=col-xs-12> <div class=card> <div class=card-heading> <h4 class=\"text-azul font-semibold text-center\">Proceso de Promoción</h4> </div> <div class=\"card-body scroll-55vh\"> <div class=u-time-line> <div class=\"item-time-line cursor-pointer\" ng-repeat=\"name in names\" ng-click=Perfil.trajectoryDetails(name)> <div class=\"content-circules small\"> <div class=big-circule> <div class=middle-circule> <div class=small-circule></div> </div> </div> </div> <p> <span>{{name.Year}}</span> {{name.designation}}<br> {{name.subject}}<br> {{name.Rating || 0}} pts de producción </p> </div> </div> </div> </div> </div> </div> </div> <div class=col-lg-8> <div ui-grid=gridOptionsComplex ng-if=gridOptionsComplex.data ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination class=\"grid grid-blue\"></div> <br/> <div ui-grid=gridOptionsDelegation ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-pagination class=\"grid grid-blue\"></div> </div> </div> ";

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = "<style>.fix-upper{text-transform:lowercase}.fix-upper::first-letter{text-transform:uppercase}.fix-ln-height-xs{position:absolute;width:100%;overflow:hidden;display:block;left:0;padding:auto 10px;line-height:11px}</style> <div class=\"row p\"> <div class=\"col-xs-12 col-md-8 title p-t-md\"> <h4>Perfil de Formación <i class=\"i-24 text-azul mdi-action-info-outline\"><md-tooltip md-direction=bottom> Si encuentra alguna inconsistencia en la información sobre su formación, solicite el ajuste a través del formulario de actualización que encontrará en el menú superior. </md-tooltip></i> </h4> </div> <div class=\"col-xs-12 col-md-4 p-t-md\"> <button ng-if=Perfil.$stateParams.teacherId class=\"btn btn-fw btn-info md-button md-ink-ripple pull-right m-h-sm\" type=button ng-click=Perfil.goBack()>Volver</button> </div> </div> <div class=\"row p-h-md\"> <div class=\"col-xs-12 col-sm-12 p-h-md m-t-lg\"> <slick class=\"slider single-item\" current-index=index touch-move=true slides-to-show={{Perfil.slick.slidesToShow}} slides-to-scroll={{Perfil.slick.slidesToShow}} class=\"slides fadein fadeout\" ng-if=Perfil.slick.viewLoaded infinite={{Perfil.slick.infinite}} class=\"slides fadein fadeout\" responsive=Perfil.slick.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"view in Perfil.slick.viewData\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5 grad-1\"> <div class=first-content> <span class=\"text-xxs text-center\">Programa</span> <p class=\"text-sm exo ng-binding fix-upper\">{{view.program_name || 'Sin título'}}</p> </div> <div class=row> <div class=col-xs-12> <span class=\"badge text-xs {{ view.badgeColorClass }}\">{{view.badgeText}}</span> </div> </div> <div class=\"row m-t-md\"> <div class=col-xs-12> <span class=\"text-xxs fix-ln-height-xs text-center font-normal fix-upper\">{{view.university || 'Sin nombre'}}</span> </div> </div> </div> <div class=\"card-body col-md-8\"> <p class=\"text-gris-dark exo\">{{view.isFormal ? 'Año de Grado' : 'Fecha de Finalización'}}</p> <p class=\"text-xs no-padding no-m-t fix-max-height detail ng-binding\">{{view.isFormal ? view.grade_date : view.end_date}}</p> <p class=\"text-gris-dark exo ng-binding\">Ciudad/País</p> <p class=\"text-xs no-padding no-m-t fix-max-height detail\">{{view.city}} - {{view.country}}</p> <p class=\"text-gris-dark exo ng-binding\">{{view.isFormal ? 'Estado' : 'Fecha de Convalidación'}} </p> <p class=\"text-xs no-padding no-m-t fix-max-height detail\">{{view.isFormal ? view.status : view.Convalescence}}</p> <p class=\"text-xs fix-max-height\" style=position:absolute;bottom:5px> <i class=\"i-24 {{ view.supportDocumentClass }}\"></i> <span style=font-size:x-small>Documento de Soporte</span> </p> </div> </div> </div> </slick> </div> </div> ";

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row p\"> <div class=\"col-xs-12 col-md-8 title p-t-md\"> <h3>Reconocimientos e incentivos <i class=\"i-24 text-azul mdi-action-info-outline\"><md-tooltip md-direction=bottom> Si encuentra alguna inconsistencia en la información sobre su formación, solicite el ajuste a través del formulario de actualización que encontrará en el menú superior. </md-tooltip></i> </h3> <p class=text-16-important>Consulte el histórico de reconocimientos e incentivos que le han sido otorgados.</p> </div> <div class=\"col-xs-12 col-md-4 p-t-md\"> <button ng-if=Perfil.$stateParams.teacherId class=\"btn btn-fw btn-info md-button md-ink-ripple pull-right m-h-sm\" type=button ng-click=Perfil.goBack()>Volver</button> </div> </div> <div class=\"row p-l-md\"> <div class=\"col-lg-12 col-md-12\"> <div class=\"inner-addon right-addon\"> <i class=\"fa fa-search\"></i> <input type=text class=form-control placeholder=Search /> </div> </div> </div> <div class=\"row p-h-md\"> <div class=\"col-xs-12 col-sm-12 p-h-md m-t-lg\"> <slick class=\"slider single-item\" current-index=index touch-move=true slides-to-show={{Perfil.slick.slidesToShow}} slides-to-scroll=\"\t{{Perfil.slick.slidesToShow}}\" class=\"slides fadein fadeout\" ng-if=Perfil.slick.viewLoaded infinite={{Perfil.slick.infinite}} responsive=Perfil.slick.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"view in Perfil.slick.viewData | filter: rolesListSearch\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5 grad-1\"> <div class=first-content> <span class=\"text-xs text-center\">{{view.ack_year}}</span> <p class=\"m-t-sm text-sm exo ng-binding\">{{view.ack_acknowledgment}}</p> <span class=\"text-xs text-center\">{{view.ack_acknowledgement_category}}</span> <span class=\"badge verde\">{{view.ack_type}}</span> </div> </div> <div class=\"card-body col-md-8\"> <p style=margin-bottom:0 class=\"text-gris-dark exo\">Entidad</p> <p class=\"text-xs no-padding no-margin fix-max-height detail ng-binding\">{{view.academic_unit}} </p> <p style=margin-bottom:0 class=\"p-t text-gris-dark exo ng-binding\">Unidad</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\">{{view.num_decret}}</p> <p style=margin-bottom:0 class=\"p-t text-gris-dark exo ng-binding\">Fecha de ceremonia</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\"> {{Perfil.moment(view.date_ceremony).format('DD [de] MMMM [de] YYYY')}}</p> <p class=\"text-xs fix-max-height\" style=position:absolute;bottom:5px> <i class=\"i-24 {{ view.supportDocumentClass }}\"></i> <span style=font-size:x-small>Documento de Soporte</span> </p> </div> </div> </div> </slick> </div> </div>";

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row p\"> <div class=\"col-xs-12 col-md-8 title p-t-md\"> <h4>Trayectoria Previa <i class=\"i-24 text-azul mdi-action-info-outline\"><md-tooltip md-direction=bottom> Si encuentra alguna inconsistencia en la información sobre su formación, solicite el ajuste a través del formulario de actualización que encontrará en el menú superior. </md-tooltip></i> </h4> <p class=text-16-important>Consulte la información de su historia laboral previa a su vinculación a la Universidad.</p> </div> <div class=\"col-xs-12 col-md-4 p-t-md\"> <button ng-if=Perfil.$stateParams.teacherId class=\"btn btn-fw btn-info md-button md-ink-ripple pull-right m-h-sm\" type=button ng-click=Perfil.goBack()>Volver</button> </div> </div> <div class=\"row blanco p\"> <div class=col-xs-12> <div class=bg-white> <ul class=\"nav nav-md nav-tabs nav-lines b-info\"> <li class=active> <a href=\"\" data-toggle=tab data-target=#tab_1 aria-expanded=false>Experiencia Laboral</a> </li> </ul> <div class=\"tab-content p m-b-md b-t b-t-2x\"> <div role=tabpanel class=\"tab-pane animated fadeIn active\" id=tab_1> <div class=table-responsive> <div ui-grid=gridOptionsComplex ng-if=gridOptionsComplex.data ui-grid-resize-columns ui-grid-exporter ui-grid-pagination class=\"grid grid-blue\"></div> </div> </div> </div> </div> </div></div>";

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports = "<style>.grid{width:100%;height:400px}.panel-group .panel+.panel{margin-top:0}.panel{border-radius:0;box-shadow:none}</style> <div class=\"row p\"> <div class=\"col-xs-12 col-md-12 title\"> <h3 class=p-t-md>Actualización de perfil</h3> <p class=text-16-important>Solicite la actualización de la información de su perfil ingresando a la opción &quot;Nueva solicitud&quot; y consulte en la siguiente tabla el estado de sus solicitudes.</p> </div> </div> <div class=\"row p no-p-t\"> <div class=\"col-xs-12 col-md-8 col-lg-9\"> <div class=row> <div class=\"col-xs-12 col-md-6\"> <h4 class=\"text-azul font-medium\">Tabla de solicitudes</h4> </div> </div> <div class=row> <div class=col-xs-12> <div ui-grid=gridOptionsComplex ng-if=gridOptionsComplex.data ui-grid-resize-columns ui-grid-exporter ui-grid-pagination class=\"grid grid-blue\"></div> </div> </div> <div class=\"row p-t\"> <div class=\"col-md-offset-4 col-md-4\"> <button has-disabled=perfil-edit ng-if=\"Perfil.userinfo.role_id == 13\" class=\"btn btn-fw center-block btn-success text-center md-ink-ripple\" ui-sref=profile.nueva_solicitud>Nueva Solicitud</button> </div> </div> </div> <div class=\"col-xs-12 col-md-4 col-lg-3\"> <div class=row> <div class=\"col-xs-12 col-md-10\"> <h5 class=\"text-azul font-medium\">Indicadores de estado de solicitudes</h5> </div> <div class=\"col-xs-12 col-md-2\"> <i class=\"mdi-action-info-outline text-lg pull-right text-azul i-24 m-t-sm\" aria-label=info><md-tooltip md-direction=bottom>En esta sección puede revisar los estados de sus solicitudes</md-tooltip></i> </div> </div> <div class=row> <div class=col-xs-12> <div class=\"panel panel-card\"> <div class=\"panel-body no-padding\"> <div class=panel-group style=margin-bottom:inherit id=accordion role=tablist aria-multiselectable=true> <div class=\"panel panel-default\" ng-repeat=\"state in Perfil.states\"> <div class=\"panel-heading p p-v-sm\" role=tab id=heading_{{$index}}> <div class=\"panel-title text-sm\"> <a role=button data-toggle=collapse data-parent=#accordion href=#collapse_{{$index}} aria-expanded=true aria-controls=collapse_{{$index}}> {{state.ds_name}} <i class=\"i-24 text-gris-dark mdi-navigation-expand-more pull-right\"></i> </a> </div> </div> <div id=collapse_{{$index}} class=\"panel-collapse collapse\" role=tabpanel aria-labelledby=heading_{{$index}}> <div class=panel-body> <p ng-if=\"state.id_code != 5\">Pendientes <span class=pull-right>{{state.activos}}</span></p> <p ng-if=\"state.id_code == 5\">Aprobadas <span class=pull-right>{{state.activos}}</span></p> <p ng-if=\"state.id_code != 3 && state.id_code != 5\">Rechazadas <span class=pull-right>{{state.rechazados}}</span></p> <p ng-if=\"state.id_code == 3\">Canceladas <span class=pull-right>{{state.rechazados}}</span></p> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports = "<style>.md-whiteframe-z1{box-shadow:inherit;border:1px solid #d2d2d2}.m-b-xxl{margin-bottom:60px}</style> <div class=\"row p\"> <div class=\"col-xs-12 col-md-12 title\"> <h3 class=p-t-sm>Actualización de Perfil - Nueva solicitud de actualización</h3> </div> </div> <div class=\"row blanco p p-v-md\" style=min-height:550px> <div class=col-xs-12> <div class=\"row p-v\" disable-all=savingForm> <div class=col-xs-12> <h5 class=\"text-azul font-bold\">Perfil a actualizar</h5> </div> <hr> <div class=col-md-2 ng-if=form.is_active ng-repeat=\"form in newReq.avaliableForms\"> <p> <label class=md-check> <input type=radio id=\"radio-'{{form.id_code}}'\" name=abc ng-click=newReq.perfilToUpdate(newReq.formId[form.id_code]) ng-checked=form.value> <i class=verde></i> {{form.formName}} </label> </p> </div> </div> </div> <div class=\"col-xs-12 col-md-11 m-b-xxl\"> <div class=row> <div class=col-xs-12> <div class=row> <div class=col-md-2> <label class=font-medium>Tipo de actualización</label> </div> <div class=col-md-4> <select class=form-control ng-model=newReq.typeUpdate ng-change=newReq.onChangeUpdateType(newReq.typeUpdate)> <option value=\"\" ng-disabled=true>Seleccione tipo de actualización</option> <option ng-repeat=\"type in newReq.typeRequest\" value={{type.id_code}}>{{type.ds_type}}</option> </select> </div> <div class=col-md-4> <ui-select ng-if=\"newReq.typeUpdate == 2 && (show != 1 && show != 0)\" ng-model=newReq.regUpdate ng-change=newReq.onChangeReg(newReq.regUpdate) required> <ui-select-match class=u-select-overflow-hide placeholder=\"Seleccione registro a actualizar\" allow-clear=true> {{newReq.regUpdate.ds_name}} </ui-select-match> <ui-select-choices repeat=\"item in newReq.registersToUpdate | filter: $select.search\"> <small ng-bind-html=\"item.ds_descrip | highlight: $select.search\">{{item.ds_descrip}}</small><br/> <span ng-bind-html=\"item.ds_name | highlight: $select.search\">{{item.ds_name}}</span> </ui-select-choices> </ui-select> </div> </div> </div> </div> </div> <form name=reqForm novalidate ng-if=\"newReq.typeUpdate && show\"> <div class=\"col-md-12 first_form\" ng-if=\"show==1\"> <h5 class=\"text-azul font-bold\">Tipo de actualización</h5> <div class=row> <div class=\"p-v col-md-3\"> <label class=font-medium>Nombre completo</label> <input class=form-control ng-disabled=true ng-model=\"newReq.forms['1'].name\" ng-model-options=\"{ debounce: 300 }\" type=text> </div> <div class=\"p-v col-md-3\"> <label class=font-medium>Cédula</label> <input class=form-control ng-disabled=true ng-model=\"newReq.forms['1'].cedula\" ng-model-options=\"{ debounce: 300 }\" type=text> </div> <div class=\"p-v col-md-3\"> <label class=font-medium>Dirección</label> <input class=form-control type=text ng-model=\"newReq.forms['1'].address\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"p-v col-md-3\"> <label class=font-medium>Teléfono fijo</label> <input class=form-control type=text ng-model=\"newReq.forms['1'].phone\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"p-v col-md-3\"> <label class=font-medium>Email Alterno</label> <input class=form-control type=text ng-model=\"newReq.forms['1'].mail\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"p-v col-md-3\"> <label class=font-medium>Email Institucional</label> <input class=form-control type=text ng-model=\"newReq.forms['1'].mail_alt\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"p-v col-md-3\"> <label class=font-medium>Nacionalidad</label> <input class=form-control type=text ng-model=\"newReq.forms['1'].nacionality\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"p-v col-md-3\"> <label class=font-medium>Fecha de Nacimiento</label> <div> <md-datepicker ng-model=\"newReq.forms['1'].birthday\" name=start_date onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa ng-disabled=true> </md-datepicker> </div> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label for=file class=form-medium>Adjuntar archivos</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div ng-if=\"uploader.queue.length > 0\" class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=newReq.remove($index)></span></td> </tr> </tbody> </table> </div> </div> </div> <div class=\"col-md-12 second_form\" ng-if=\"show==2\"> <h5 class=\"text-azul font-bold\">Formulario de actualización</h5> <div class=row> <div class=\"col-md-3 p-v\"> <label class=font-medium>Tipo de publicación</label> <select class=form-control ng-model=\"newReq.forms['2'].idPublishType\" ng-change=\"newReq.onChangeSelected(2,newReq.forms['2'].idPublishType)\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{type.idListItem}} ng-repeat=\"type in newReq.comboBoxTypePub\">{{type.listItemName}}</option> </select> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Año de publicación</label> <input type=number class=form-control ng-model=\"newReq.forms['2'].nmPublishYear\"> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Subtipo</label> <select class=form-control ng-model=\"newReq.forms['2'].idPublishSubType\" ng-disabled=\"!newReq.forms['2'].idPublishType\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{subType.idListItem}} ng-repeat=\"subType in newReq.comboBoxSubTypePub\">{{subType.listItemName}}</option> </select> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Título</label> <input type=text class=form-control ng-model=\"newReq.forms['2'].title\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Coautores</label> <input type=text class=form-control ng-model=\"newReq.forms['2'].coAuthor\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Puntos</label> <input type=number class=form-control ng-model=\"newReq.forms['2'].nmPoints\"> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label for=file class=form-medium>Adjuntar archivos</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=newReq.remove($index)></span></td> </tr> </tbody> </table> </div> </div> </div> <div class=\"col-md-12 third_form\" ng-if=\"show==3\"> <h5 class=\"text-azul font-bold\">Formulario de actualización</h5> <div class=row> <div class=\"col-md-3 p-v\"> <label class=font-medium>Servicio*</label> <div class=\"inner-addon right-addon\"> <i class=\"fa fa-search\"></i> <input type=text class=form-control placeholder=Search required ng-model=\"newReq.forms['3'].service\" ng-model-options=\"{ debounce: 300 }\"/> </div> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>A Titulo*</label> <p> <md-radio-group style=display:inline-flex ng-model=\"newReq.forms['3'].totitle\"> <md-radio-button style=margin-right:20px value=1 class=md-primary>Individual</md-radio-button> <md-radio-button value=2 class=md-primary>Institucional</md-radio-button> </md-radio-group> </p> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Fecha Inicio*</label> <p> <md-datepicker ng-model=\"newReq.forms['3'].myInit\" name=init md-max-date=newReq.maxStartDate onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-change=newReq.startDateChange(3) md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Fecha Fin*</label> <p> <md-datepicker ng-model=\"newReq.forms['3'].myEnd\" name=end md-max-date=newReq.currentDate onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-change=newReq.startDateChange(3) md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Ámbito*</label> <select class=form-control required ng-model=\"newReq.forms['3'].scope\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{type.idListItem}} ng-repeat=\"type in newReq.comboBoxTypePub\">{{type.listItemName}}</option> </select> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Tipo de Entidad*</label> <select class=form-control required ng-model=\"newReq.forms['3'].typeEntity\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{subType.idListItem}} ng-repeat=\"subType in newReq.comboBoxTypeInde\">{{subType.listItemName}}</option> </select> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Entidad*</label> <input type=text class=form-control required ng-model=\"newReq.forms['3'].nameEntity\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Valor</label> <input type=number class=form-control ng-model=\"newReq.forms['3'].value\"> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Resultados*</label> <input type=text class=form-control required ng-model=\"newReq.forms['3'].result\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"col-md-4 p-v\"> <label for=file class=form-medium>Adjuntar archivos</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=newReq.remove($index)></span></td> </tr> </tbody> </table> </div> </div> </div> <div class=\"col-md-12 forth_form\" ng-if=\"show==4\"> <h5 class=\"text-azul font-bold\">Formulario de actualización</h5> <div class=row> <div class=\"col-md-4 p-v\"> <label class=font-medium>Tipo de Formación</label> <select class=form-control ng-model=\"newReq.forms['4'].idTypTrayectory\" ng-change=\"newReq.onChangeSelected(4,newReq.forms['4'].idTypTrayectory)\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{type.idListItem}} ng-repeat=\"type in newReq.comboBoxTypePub\">{{type.listItemName}}</option> </select> </div> <div class=\"col-md-4 p-v\"> <label class=font-medium>Nivel de Formación/Idioma</label> <select class=form-control ng-model=\"newReq.forms['4'].idLevel\" ng-disabled=\"!newReq.forms['4'].idTypTrayectory\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{subType.idListItem}} ng-repeat=\"subType in newReq.comboBoxSubTypePub\">{{subType.listItemName}}</option> </select> </div> <div class=\"col-md-4 p-v\"> <label class=font-medium>Título/Nivel</label> <input type=text class=form-control ng-model=\"newReq.forms['4'].title\" ng-model-options=\"{ debounce: 300 }\"> </div> <div class=clearfix></div> <div class=\"col-md-4 p-v\"> <label class=font-medium>Fecha de grado/Fecha de certificación</label> <p> <md-datepicker ng-model=\"newReq.forms['4'].dtGrade\" name=start_date onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> <div class=\"col-md-4 p-v\"> <label class=font-medium>Institución que otorga el Título</label> <div class=\"inner-addon right-addon\"> <i class=\"fa fa-search\"></i> <md-autocomplete style=background:inherit class=form-control-md md-clear-button=false md-item-text=institution.name md-min-length=3 md-selected-item=\"newReq.forms['4'].dsInstitution\" md-search-text=\"newReq.forms['4'].dsInstitutionSearch\" md-items=\"institution in newReq.searchInstitution(newReq.forms['4'].dsInstitutionSearch)\" placeholder=\"Buscar institución...\"> <md-item-template> <span md-highlight-text=\"newReq.forms['4'].dsInstitutionSearch\" md-highlight-flags=^i>{{institution.name}}</span> </md-item-template> <md-not-found> No se encontraron instituciones... </md-not-found> </md-autocomplete> </div> </div> <div class=\"col-md-4 p-v\"> <div class=row> <div class=col-md-6> <label class=font-medium>País</label> <div class=\"inner-addon right-addon\"> <i class=\"fa fa-search\"></i> <md-autocomplete style=background:inherit class=form-control-md md-clear-button=false md-item-text=country.ds_pais md-min-length=2 ng-model=\"newReq.forms['4'].country\" md-selected-item=\"newReq.forms['4'].country\" md-search-text=searchTextCountry md-items=\"country in newReq.searchCountries(searchTextCountry)\" placeholder=\"Buscar país...\" md-selected-item-change=\"newReq.onChangeCountry(newReq.forms['4'].country.id_pais)\"> <md-item-template> <span md-highlight-text=searchTextCountry md-highlight-flags=^i>{{country.ds_pais}}</span> </md-item-template> <md-not-found> No se encontraron paises... </md-not-found> </md-autocomplete> </div> </div> <div class=col-md-6> <label class=font-medium>Ciudad</label> <div class=\"inner-addon right-addon\"> <i class=\"fa fa-search\"></i> <md-autocomplete style=background:inherit class=form-control-md md-clear-button=false md-item-text=city.ds_ciudad md-min-length=2 md-selected-item=\"newReq.forms['4'].city\" md-search-text=searchTextCity md-items=\"city in newReq.searchCities(searchTextCity)\" placeholder=\"Buscar ciudad...\"> <md-item-template> <span md-highlight-text=searchTextCity md-highlight-flags=^i>{{city.ds_ciudad}}</span> </md-item-template> <md-not-found> No se encontraron ciudades... </md-not-found> </md-autocomplete> </div> </div> </div> </div> <div class=clearfix></div> <div class=\"col-md-4 p-v\"> <label class=font-medium>Alcance de emisión del título</label> <select class=form-control ng-model=\"newReq.forms['4'].scopeOfTitle\" ng-change=newReq.cleanValidation()> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{scopeList.idListItem}} ng-repeat=\"scopeList in newReq.scopeOfTitleList\">{{scopeList.listItemName}}</option> </select> </div> <div class=\"col-md-8 p-v\" ng-if=\"newReq.forms['4'].scopeOfTitle && newReq.forms['4'].scopeOfTitle == 1069\"> <label class=font-medium>Tipo de validación*</label> <p> <md-checkbox style=margin-right:20px class=md-primary ng-model=\"newReq.forms['4'].isMen\">¿El título está convalidado ante el MEN?</md-checkbox> <md-checkbox class=md-primary ng-model=\"newReq.forms['4'].isIssuedInSpanish\">¿El título está emitido en español o cuenta con la traducción oficial?</md-checkbox> </p> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label for=file class=form-medium>Adjuntar archivos</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div ng-if=\"uploader.queue.length > 0\" class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=newReq.remove($index)></span></td> </tr> </tbody> </table> </div> <div class=clearfix></div> </div> </div> <div class=\"col-md-12 fifth_form\" ng-if=\"show==5\"> <h5 class=\"text-azul font-bold\">Formulario de actualización</h5> <div class=row> <div class=\"col-md-3 p-v\"> <label class=font-medium>Unidad</label> <select class=form-control ng-model=\"newReq.forms['5'].idUnidad\" ng-change=\"newReq.rolesUnits(newReq.forms['5'].idUnidad)\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{type.academitUnitId}} ng-repeat=\"type in newReq.arrayUnit\">{{type.academitUnitName}}</option> </select> </div> <div class=\"col-md-3 no-padding-r\"> <div class=\"col-md-12 p-v\"> <label for=rolesCombo class=font-medium>Rol</label> <select name=rolesCombo ng-model=\"newReq.forms['5'].idRol\" ng-options=\"role.roleId as role.roleName for role in newReq.rolesCombo\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=newReq.rolesCombo.$error ng-show=newReq.showErrorMessages(newReq.rolesCombo)> <div ng-message=required>El rol es requerido</div> </div> </div> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Fecha de Inicio</label> <p> <md-datepicker ng-model=\"newReq.forms['5'].dtInit\" name=init md-max-date=newReq.maxStartDate onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-change=newReq.startDateChange(5) md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Fecha de Finalización</label> <p> <md-datepicker ng-model=\"newReq.forms['5'].dtEnd\" name=end md-max-date=newReq.currentDate onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-change=newReq.startDateChange(5) md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> <div class=\"col-md-6 p-v\"> <label class=font-medium>Descripción de Equivalencia</label> <input type=text class=form-control ng-model=\"newReq.forms['5'].descriptionEq\" ng-model-options=\"{ debounce: 300 }\"/> </div> <div class=\"col-md-3 p-v\"> <label for=file class=form-medium>Adjuntar archivos(*.pdf)</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=newReq.remove($index)></span></td> </tr> </tbody> </table> </div> </div> </div> <div class=\"col-md-12 sixth_form\" ng-if=\"show==6\"> <h5 class=\"text-azul font-bold\">Formulario de actualización</h5> <div class=row> <div class=\"col-md-12 p-v\"> <p>{{'RECOGNITION_INCENTIVES_MSG_FORM' | translate}}</p> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Tipo*</label> <select class=form-control ng-model=\"newReq.forms['6'].typeRI\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{type.idListItem}} ng-repeat=\"type in newReq.comboBoxTypePub\">{{type.listItemName}}</option> </select> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Entidad*</label> <input type=text class=form-control ng-model=\"newReq.forms['6'].description\" ng-model-options=\"{ debounce: 300 }\"/> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Ámbito*</label> <select class=form-control ng-model=\"newReq.forms['6'].scope\"> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{subType.idListItem}} ng-repeat=\"subType in newReq.comboBoxTypeInde\">{{subType.listItemName}}</option> </select> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Nombre*</label> <input type=text class=form-control required ng-model=\"newReq.forms['6'].name\" ng-model-options=\"{ debounce: 300 }\"/> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Fecha de Acta*</label> <p> <md-datepicker ng-model=\"newReq.forms['6'].dtActa\" md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> <div class=\"col-md-3 p-v\"> <label class=font-medium>Valor Incentivo</label> <input type=number class=form-control ng-model=\"newReq.forms['6'].valueInc\"/> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label for=file class=form-medium>Adjuntar archivos</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div ng-if=\"uploader.queue.length > 0\" class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=newReq.remove($index)></span></td> </tr> </tbody> </table> </div> <div class=clearfix></div> </div> </div> <div class=\"col-md-12 fifth_form\" ng-if=\"show==7\"> <h5 class=\"text-info font-bold\">Formulario de actualizacion</h5> <div class=row> <div class=\"col-md-6 p-t-md\"> <label class=font-medium>Institucion</label> <input type=text class=form-control ng-model=\"newReq.forms['7'].inst\"/> </div> <div class=\"col-md-6 p-t-md\"> <label class=font-medium>Cargo</label> <input type=text class=form-control ng-model=\"newReq.forms['7'].charge\"/> </div> </div> <div class=row> <div class=\"col-md-6 p-t-md\"> <label class=font-medium>Fecha de Inicio</label> <p> <md-datepicker ng-model=\"newReq.forms['7'].dtInit\" name=init md-max-date=newReq.maxStartDate onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-change=newReq.startDateChange(7) md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> <div class=\"col-md-6 p-t-md\"> <label class=font-medium>Fecha de Finalización</label> <p> <md-datepicker ng-model=\"newReq.forms['7'].dtEnd\" name=end md-max-date=newReq.currentDate onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" ng-change=newReq.endDateChange(7) md-placeholder=dd/mm/aaaa required> </md-datepicker> </p> </div> </div> <div class=row> <div class=\"col-md-3 p-v\"> <label class=font-medium>Tipo*</label> <select class=form-control ng-model=\"newReq.forms['7'].trajectoryType\" required> <option value=\"\" ng-disabled=true>Seleccione...</option> <option value={{subType.idListItem}} ng-repeat=\"subType in newReq.comboBoxTypePub\">{{subType.listItemName}}</option> </select> </div> </div> <div class=clearfix></div> <div class=\"col-md-3 p-v\"> <label for=file class=form-medium>Adjuntar archivos</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=newReq.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div ng-if=\"uploader.queue.length > 0\" class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=newReq.remove($index)></span></td> </tr> </tbody> </table> </div> <div class=clearfix></div> </div> <div class=col-md-12> <div class=row ng-if=\"(newReq.noFile && uploader.queue.length <= 0) || newReq.hasErrors\"> <div class=col-xs-12> <p class=\"text-center text-danger\"> {{errorMessage}} </p> </div> </div> <div class=row> <div class=col-md-4> <md-button class=\"btn btn-fw btn-cancel no-margin text-left md-button md-ink-ripple\" ng-disabled=savingForm ng-show=!savingForm ui-sref=profile.Actualizacion_Perfil> Cancelar </md-button> </div> <div class=col-md-4>&nbsp;</div> <div class=col-md-4> <md-button class=\"btn btn-fw btn-success no-margin pull-right md-button md-ink-ripple\" ng-disabled=\"savingForm || newReq.messageFileSize || newReq.messageFileType || newReq.messageFileName || newReq.typeUpdate == '' || show == 0 || newReq.validateForm(reqForm)\" ng-click=newReq.saveRequest()> <md-progress-circular ng-if=savingForm class=md-hue-2 md-diameter=20px style=\"position:absolute;left:calc(50% - 10px)\"> </md-progress-circular> Agregar Solicitud </md-button> </div> </div> </div> </form> </div> ";

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row p\"> <div class=\"col-xs-12 col-md-12 title\"> <h3 class=p-t-md> Actualización de perfil - N&#176;{{updateVM.info.nTicket}} actualización de {{updateVM.info.title}} </h3> </div> </div> <div class=\"row p-l p-r p-b\"> <div class=col-xs-12> <div class=card> <div class=card-body> <form name=reqForm novalidate> <div class=row> <div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4\"> <h3 class=text-info>Datos de actualización</h3> <table class=table ng-if=updateVM.isExtension> <tbody> <tr> <td class=text-info>Nombre del profesor</td> <td>{{updateVM.dataToUpdate.nombreCompleto}}</td> </tr> <tr> <td class=text-info>Perfil a actualizar</td> <td>{{updateVM.info.title}}</td> </tr> <tr> <td class=text-info>Tipo de actualización</td> <td>{{updateVM.dataToUpdate.TipoActualizacion}}</td> </tr> <tr> <td class=text-info>Servicio</td> <td>{{updateVM.dataToUpdate.service_ex}}</td> </tr> <tr> <td class=text-info>A titulo</td> <td>{{updateVM.dataToUpdate.title_ex}}</td> </tr> <tr> <td class=text-info>Fecha de inicio</td> <td>{{updateVM.dataToUpdate.dtInit_ex}}</td> </tr> <tr> <td class=text-info>Fecha de fin</td> <td>{{updateVM.dataToUpdate.dtEnd_ex}}</td> </tr> <tr> <td class=text-info>Ámbito</td> <td>{{updateVM.dataToUpdate.scope_ex}}</td> </tr> <tr> <td class=text-info>Tipo de entidad</td> <td>{{updateVM.dataToUpdate.typeEntity_ex}}</td> </tr> <tr> <td class=text-info>Entidad</td> <td>{{updateVM.dataToUpdate.nameEntity_ex}}</td> </tr> <tr> <td class=text-info>Valor</td> <td>{{updateVM.dataToUpdate.value_ex}}</td> </tr> <tr> <td class=text-info>Resultados</td> <td>{{updateVM.dataToUpdate.result_ex}}</td> </tr> </tbody> </table> <table class=table ng-if=updateVM.isTrayectoriaUr> <tbody> <tr> <td class=text-info>Nombre del profesor</td> <td>{{updateVM.dataToUpdate.nombreCompleto}}</td> </tr> <tr> <td class=text-info>Perfil a actualizar</td> <td>{{updateVM.info.title}}</td> </tr> <tr> <td class=text-info>Tipo de actualización</td> <td>{{updateVM.dataToUpdate.TipoActualizacion}}</td> </tr> <tr> <td class=text-info>Unidad</td> <td>{{updateVM.dataToUpdate.acUnit_ur}}</td> </tr> <tr> <td class=text-info>Rol</td> <td>{{updateVM.dataToUpdate.role_ur}}</td> </tr> <tr> <td class=text-info>Fecha de inicio</td> <td>{{updateVM.dataToUpdate.dtInit_ur}}</td> </tr> <tr> <td class=text-info>Fecha de fin</td> <td>{{updateVM.dataToUpdate.dtEnd_ur}}</td> </tr> <tr> <td class=text-info>Descrip. de equivalencia</td> <td>{{updateVM.dataToUpdate.equiv_ur}}</td> </tr> </tbody> </table> <table class=table ng-if=updateVM.isTrayectoriaPrevia> <tbody> <tr> <td class=text-info>Institución</td> <td>{{updateVM.dataToUpdate.institution_pf}}</td> </tr> <tr> <td class=text-info>Cargo</td> <td>{{updateVM.dataToUpdate.ds_title_in}}</td> </tr> <tr> <td class=text-info>Fecha inicio</td> <td>{{updateVM.dataToUpdate.dtInit_ur}}</td> </tr> <tr> <td class=text-info>Fecha fin</td> <td>{{updateVM.dataToUpdate.dtEnd_ur}}</td> </tr> <tr> <td class=text-info>Tipo</td> <td>{{updateVM.dataToUpdate.type_ri}}</td> </tr> </tbody> </table> <table class=table ng-if=updateVM.isFormation> <tbody> <tr> <td class=text-info>Nombre del profesor</td> <td>{{updateVM.dataToUpdate.nombreCompleto}}</td> </tr> <tr> <td class=text-info>Perfil a actualizar</td> <td>{{updateVM.info.title}}</td> </tr> <tr> <td class=text-info>Tipo de actualización</td> <td>{{updateVM.dataToUpdate.TipoActualizacion}}</td> </tr> <tr> <td class=text-info>Tipo de formación</td> <td> <span data-toggle=tooltip title={{updateVM.dataToUpdate.type}}>{{updateVM.dataToUpdate.formationType_pf}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.type != updateVM.dataToUpdate.formationType_pf\"> *</span> </td> </tr> <tr> <td class=text-info>Nivel de formación</td> <td> <span data-toggle=tooltip title={{updateVM.dataToUpdate.ds_formation_level}}>{{updateVM.dataToUpdate.formationLevel_pf}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.ds_formation_level != updateVM.dataToUpdate.formationLevel_pf\"> (*)</span> </td> </tr> <tr> <td class=text-info>Institución</td> <td> <span data-toggle=tooltip title={{updateVM.dataToUpdate.university}}>{{updateVM.dataToUpdate.institution_pf}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.university != updateVM.dataToUpdate.institution_pf\"> *</span> </td> </tr> <tr> <td class=text-info>Título / Nivel</td> <td> <span data-toggle=tooltip title={{updateVM.dataToUpdate.program_name}}>{{updateVM.dataToUpdate.formationTitle_pf}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.program_name != updateVM.dataToUpdate.formationTitle_pf\"> *</span> </td> </tr> <tr> <td class=text-info>Fecha de grado/Fecha de certificación</td> <td> <span data-toggle=tooltip title={{updateVM.dataToUpdate.end_date}}>{{updateVM.dataToUpdate.dtGrade_pf}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.end_date != updateVM.dataToUpdate.dtGrade_pf\"> *</span> </td> </tr> <tr> <td class=text-info>Alcance de emisión del título</td> <td> <span data-toggle=tooltip title={{updateVM.dataToUpdate.titleScopeName}}>{{updateVM.dataToUpdate.titleScopeName}}</span> </td> </tr> <tr> <td class=text-info>Tipo de validación</td> <td> <ul ng-if=\"updateVM.dataToUpdate.isMen || updateVM.dataToUpdate.isIssuedInSpanish\" class=p-l> <li ng-if=updateVM.dataToUpdate.isMen>Convalidado ante el MEN.</li> <li ng-if=updateVM.dataToUpdate.isIssuedInSpanish>Emitido en español o con traducción oficial.</li> </ul> </td> </tr> <tr> <td class=text-info>Ciudad - país</td> <td> <span data-toggle=tooltip title=\"{{updateVM.dataToUpdate.country}} - {{updateVM.dataToUpdate.city}}\">{{updateVM.dataToUpdate.country_pf}} - {{updateVM.dataToUpdate.city_pf}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.country != updateVM.dataToUpdate.country_pf || updateVM.dataToUpdate.city != updateVM.dataToUpdate.city_pf\"> *</span> </td> </tr> <tr> <td class=text-info>N&#176; de acta</td> <td>{{updateVM.dataToUpdate.numActa_pf}}</td> </tr> <tr> <td class=text-info>Fecha acta</td> <td>{{updateVM.dataToUpdate.dtActa_pf}}</td> </tr> <tr> <td class=text-info>Tipo de equivalencia</td> <td>{{updateVM.dataToUpdate.equivLevel_pf}}</td> </tr> <tr> <td class=text-info>Descrip. de equivalencia</td> <td>{{updateVM.dataToUpdate.equivDes_pf}}</td> </tr> </tbody> </table> <table class=table ng-if=updateVM.isReconocimiento> <tbody> <tr> <td class=text-info>Nombre del profesor</td> <td>{{updateVM.dataToUpdate.nombreCompleto}}</td> </tr> <tr> <td class=text-info>Perfil a actualizar</td> <td>{{updateVM.info.title}}</td> </tr> <tr> <td class=text-info>Tipo de actualización</td> <td>{{updateVM.dataToUpdate.TipoActualizacion}}</td> </tr> <tr> <td class=text-info>Tipo de reconocimiento</td> <td>{{updateVM.dataToUpdate.type_ri}}</td> </tr> <tr> <td class=text-info>Contexto</td> <td>{{updateVM.dataToUpdate.context_ri}}</td> </tr> <tr> <td class=text-info>Entidad</td> <td>{{updateVM.dataToUpdate.entidad_ri}}</td> </tr> <tr> <td class=text-info>Ámbito</td> <td>{{updateVM.dataToUpdate.scope_ri}}</td> </tr> <tr> <td class=text-info>Nombre de reconocimiento</td> <td>{{updateVM.dataToUpdate.name_ri}}</td> </tr> <tr> <td class=text-info>Fecha de acta</td> <td>{{updateVM.dataToUpdate.dtActa_ri}}</td> </tr> <tr> <td class=text-info>Valor incentivo</td> <td>{{updateVM.dataToUpdate.incent_ri}}</td> </tr> </tbody> </table> <table class=table ng-if=updateVM.isPerfil> <tbody> <tr> <td class=text-info>Nombre del profesor</td> <td>{{updateVM.dataToUpdate.nombreCompleto}}</td> </tr> <tr> <td class=text-info>Perfil a actualizar</td> <td>{{updateVM.info.title}}</td> </tr> <tr> <td class=text-info>Tipo de actualización</td> <td>{{updateVM.dataToUpdate.TipoActualizacion}}</td> </tr> <tr> <td class=text-info>Cédula</td> <td>{{updateVM.dataToUpdate.cedula}}</td> </tr> <tr> <td class=text-info>Dirección</td> <td> <span>{{updateVM.dataToUpdate.direccion}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.direccion !== updateVM.dataToUpdate.currentAdress && !workflowClosed\"> *</span> </td> </tr> <tr> <td class=text-info>Teléfono fijo</td> <td> <span>{{updateVM.dataToUpdate.telefono}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.telefono !== updateVM.dataToUpdate.currentPhone && !workflowClosed\"> *</span> </td> </tr> <tr> <td class=text-info>Email Alterno</td> <td> <span>{{updateVM.dataToUpdate.mail_alterno}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.mail_alterno !== updateVM.dataToUpdate.currentAlternativeMail && !workflowClosed\"> *</span> </td> </tr> <tr> <td class=text-info>Email Institucional</td> <td> <span>{{updateVM.dataToUpdate.mail_inst}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.mail_inst !== updateVM.dataToUpdate.currentMail && !workflowClosed\"> *</span> </td> </tr> <tr> <td class=text-info>Nacionalidad</td> <td> <span>{{updateVM.dataToUpdate.nacionalidad}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.nacionalidad !== updateVM.dataToUpdate.currentNationality && !workflowClosed\"> *</span> </td> </tr> <tr> <td class=text-info>Fecha de Nacimiento</td> <td> <span>{{updateVM.dataToUpdate.fechaCumple}}</span> <span class=text-danger ng-show=\"updateVM.dataToUpdate.fechaCumple !== updateVM.dataToUpdate.currentBirthdate && !workflowClosed\"> *</span> </td> </tr> </tbody> </table> </div> <div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-8\"> <div id=formulario ng-if=\"updateVM.userinfo != null && ((updateVM.userinfo.role_id == 13 && (updateVM.dataToUpdate.idEstado == 12 || updateVM.dataToUpdate.idEstado == 17)) || updateVM.userinfo.role_id != 13)\"> <div class=row> <div class=col-xs-12> <h5 class=\"font-semibold text-azul\">Formulario de Ingreso de registro a bitácora</h5> </div> </div> <div class=\"row m-t\"> <div class=col-lg-12> <div class=form-group ng-class=updateVM.hasError(reqForm.descBox)> <label for=descBox class=control-label>Observaciones</label> <textarea required name=descBox ng-model=updateVM.description ng-disabled=\"(updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled) \" class=form-control rows=3 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=control-label ng-messages=reqForm.descBox.$error ng-show=updateVM.showErrorMessages(reqForm.descBox)> <div ng-message=required>La observación es requerida</div> </div> </div> </div> </div> <div class=\"row m-t\"> <div class=col-lg-6> <div class=form-group ng-class=updateVM.hasError(reqForm.selStage)> <label for=selStage class=control-label>Estado a enviar</label> <md-select name=selStage class=no-margin ng-model=updateVM.stage ng-disabled=\"updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled\" placeholder=Etapa class=form-control required> <md-option value={{stage.id_code}} ng-repeat=\"stage in updateVM.listStages\">{{stage.ds_stage}}</md-option> </md-select> <div class=control-label ng-messages=reqForm.selStage.$error ng-show=updateVM.showErrorMessages(reqForm.selStage)> <div ng-message=required>El estado es requerido</div> </div> </div> <div ng-if=updateVM.isFormation> <div class=form-group> <label class=font-medium>Nro. de Acta</label> <input type=number class=form-control ng-model=updateVM.nmActa ng-disabled=\"updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled\"/> </div> <div class=form-group> <label class=font-medium>Fecha de Acta</label> <p> <md-datepicker ng-model=updateVM.dtActa name=start_date md-placeholder=dd/mm/aaaa ng-disabled=\"updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled\"> </md-datepicker> </p> </div> <div class=form-group> <label class=font-medium>Tipo de equivalencia</label> <p><md-radio-group style=display:inline-flex ng-model=updateVM.level> <md-radio-button style=margin-right:20px value=0 class=md-primary ng-disabled=\"updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled\">Nivel de inglés</md-radio-button> <md-radio-button value=1 class=md-primary ng-disabled=\"updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled\">Nivel de formación</md-radio-button> </md-radio-group></p> </div> <div class=form-group> <label class=font-medium>Descripción de Equivalencia</label> <input type=text class=form-control ng-model=updateVM.descriptionEq ng-disabled=\"updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled\" ng-model-options=\"{ debounce: 300 }\"/> </div> </div> </div> <div class=col-lg-6> <label for=file class=form-medium>Adjuntar archivo(*.pdf)</label> <input type=file nv-file-select=\"\" uploader=uploader ng-disabled=\"updateVM.info.stage == updateVM.globalConfig.initStageUpdate.wfComplete || updateVM.editDisabled\" required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=updateVM.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=updateVM.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=updateVM.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div ng-if=\"uploader.queue.length > 0\" class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=updateVM.remove($index)></span></td> </tr> </tbody> </table> </div> </div> </div> <div class=\"table-container table-responsive\"> <h3 class=text-info>Bitácora</h3> <table class=\"table table-striped table-condensed\"> <thead> <tr> <th class=font-semibold>Estado</th> <th class=font-semibold>Fecha de Ingreso</th> <th class=font-semibold>Observación</th> <th class=font-semibold>Adjuntos</th> </tr> </thead> <tbody> <tr ng-repeat=\"log in updateVM.logs\"> <td>{{log.Estado}}</td> <td>{{updateVM.moment(log.fechaIngreso).format('DD-MM-YYYY')}}</td> <td>{{log.Observacion}}</td> <td> <a ng-if=\"log.adjuntos > 0\" ng-click=updateVM.activateModal(log.id_code)> <span class=form_sub_head_action>Documento</span> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class=row> <div class=pull-left> <button class=\"btn btn-fw center-block btn-cancel text-center md-ink-ripple\" ui-sref=profile.Actualizacion_Perfil> <i class=\"icon mdi-content-reply-all i-24\"></i> Volver </button> </div> <div class=pull-right ng-if=\"updateVM.userinfo != null && ((updateVM.userinfo.role_id == 13 && (updateVM.dataToUpdate.idEstado == 12 || updateVM.dataToUpdate.idEstado == 17)) || updateVM.userinfo.role_id != 13)\"> <button class=\"btn btn-fw center-block btn-success text-center md-ink-ripple\" ng-click=updateVM.setStageToData() ng-disabled=\"updateVM.isSaveButtonDisabled || updateVM.validateForm(reqForm)\"> Continuar <i class=\"icon mdi-action-done-all i-24\"></i> </button> </div> </div> </form> </div> </div> </div> </div>";

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row p\"> <div class=\"col-xs-12 title p-t-md\"> <h4>Descargar hoja de vida</h4> </div> </div> <form name=cvPrintForm> <div class=\"row blanco p p-t-md\"> <div class=col-lg-6> <h5 class=\"text-azul font-semibold\">Configuración General</h5> <label for=\"\">Seleccione submódulos a incluir</label> <div class=row> <div class=col-lg-6> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.check ng-change=cvPrintVM.checkAll(cvPrintVM.check)> Marcar todos </md-checkbox> </p> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.arrayCheck[cvPrintVM.idProfiles.docencia] ng-change=cvPrintVM.changeSelectedProfile(cvPrintVM.idProfiles.docencia)> Perfil de Docencia </md-checkbox> </p> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.arrayCheck[cvPrintVM.idProfiles.investigacion] ng-change=cvPrintVM.changeSelectedProfile(cvPrintVM.idProfiles.investigacion)> Perfil de Investigación </md-checkbox> </p> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.arrayCheck[cvPrintVM.idProfiles.extension] ng-change=cvPrintVM.changeSelectedProfile(cvPrintVM.idProfiles.extension)> Perfil de Extensión </md-checkbox> </p> </div> <div class=col-lg-6> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.arrayCheck[cvPrintVM.idProfiles.trayectoria_previa] ng-change=cvPrintVM.changeSelectedProfile(cvPrintVM.idProfiles.trayectoria_previa)> Trayectoria Previa </md-checkbox> </p> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.arrayCheck[cvPrintVM.idProfiles.trayectoria_UR] ng-change=cvPrintVM.changeSelectedProfile(cvPrintVM.idProfiles.trayectoria_UR)> Trayectoria UR </md-checkbox> </p> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.arrayCheck[cvPrintVM.idProfiles.perfil_formacion] ng-change=cvPrintVM.changeSelectedProfile(cvPrintVM.idProfiles.perfil_formacion)> Perfil de Formación </md-checkbox> </p> <p> <md-checkbox class=md-green type=checkbox ng-model=cvPrintVM.arrayCheck[cvPrintVM.idProfiles.reconocimiento] ng-change=cvPrintVM.changeSelectedProfile(cvPrintVM.idProfiles.reconocimiento)> Perfil de Reconocimiento </md-checkbox> </p> </div> </div> </div> <div class=col-lg-6> <h5 class=\"text-azul font-semibold\">Rango de Fecha</h5> <label for=buscar_por>Buscar por</label> <p> <label class=\"md-check m-r\"> <input type=radio name=buscar_por value=0 ng-model=cvPrintVM.dateFilter> <i class=verde></i> Por fecha </label> <label class=md-check> <input type=radio name=buscar_por value=1 ng-model=cvPrintVM.dateFilter> <i class=verde></i> Por Período </label> </p> <div class=row ng-if=\"cvPrintVM.dateFilter == 0\"> <div class=col-lg-6> <label class=dpl-b for=\"\">Fecha Inicio</label> <md-datepicker ng-model=cvPrintVM.start_date name=start_date onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-max-date=cvPrintVM.end_Date ng-change=cvPrintVM.startDateChanged()> </md-datepicker> </div> <div class=col-lg-6> <label class=dpl-b for=\"\">Fecha Fin</label> <md-datepicker ng-model=cvPrintVM.end_date name=end_date onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" md-min-date=cvPrintVM.start_date ng-change=cvPrintVM.startDateChanged()> </md-datepicker> </div> </div> <div class=row ng-if=\"cvPrintVM.dateFilter == 1\"> <div class=col-lg-6> <label class=dpl-b for=\"\">Fecha Fin</label> <md-select class=no-margin ng-model=cvPrintVM.selectedPeriod placeholder=\"Seleccione opción\" class=md-no-underline> <md-option value={{period}} ng-repeat=\"period in cvPrintVM.academicPeriods\">{{period.periodName}}</md-option> </md-select> </div> </div> </div> <div class=\"col-xs-12 col-md-11 p-t-md\"> <div class=\"row m-t\"> <div class=col-lg-4> <button class=\"btn btn-fw btn-cancel no-margin text-left md-button md-ink-ripple pull-left\" ui-sref=profile.Actualizacion_Perfil>Volver</button> </div> <div class=col-lg-4>&nbsp;</div> <div class=\"col-lg-4 custom_right\"> <button class=\"btn btn-fw center-block btn-success text-center md-ink-ripple pull-right\" ng-click=cvPrintVM.getPDF() ng-disabled=\"cvPrintVM.selectedProfilesArray.length === 0 || cvPrintVM.blockButton || cvPrintForm.$invalid\">Descargar hoja de vida</button> </div> </div> </div> </div> </form> <div class=\"row blanco p\" style=height:75vh ng-if=cvPrintVM.documents> <div class=col-lg-12 ng-if=\"cvPrintVM.documents.length !== 0\"> <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"> <div class=\"table-container table-responsive\"> <h3 class=text-info>Documentos</h3> <table class=\"table table-striped table-condensed\"> <thead> <tr> <th>Tipo</th> <th>Documento</th> <th class=text-center>Descargar</th> </tr> </thead> <tbody> <tr ng-repeat=\"doc in cvPrintVM.documents\"> <td>{{ doc.perfil }} {{ doc.formation_type }}</td> <td> {{ doc.documento }} </td> <td class=text-center> <a ng-click=\"cvPrintVM.getFile(doc.rutaDocumento, doc.documento)\"> <span class=form_sub_head_action> <i class=\"icon mdi-file-file-download i-24\"></i> </span> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class=\"col-lg-12 text-center\" ng-if=\"cvPrintVM.documents.length === 0\"> <h5 class=\"text-azul font-semibold\">No existen documentos que coincidan con los criterios de búsqueda</h5> </div> </div> ";

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports = " <style>.grid-workplan{width:100%;min-height:350px!important;max-height:550px!important;overflow-x:auto;display:block;table-layout:fixed}.grid-workplan .ui-grid-row{display:flex;min-height:30px!important;height:auto!important;padding-top:5px;padding-bottom:5px;border-bottom:1px solid rgba(255,255,255,.4)}</style> <div class=\"row gutter-10\"> <div class=\"intro-message m-b-lg\"> <div class=col-xs-12> <h1 class=\"text-blanco text-center\">Flujos de actualización de perfil</h1> </div> </div> <div class=\"col-xs-offset-1 col-xs-10 m-t-lg\"> <div class=grid-workplan ui-grid=profileForms ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns ui-grid-auto-resize></div> </div> </div>";

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'perfil'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, perfil) {
		$templateCache.put('updatePersonalData.html', __webpack_require__(384));
		$templateCache.put('updateGenericTemplate.html', __webpack_require__(380));
		MenuConstant[0]['menu'].push(perfil);
	}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row p\"> <div class=\"col-xs-12 col-md-12 title\"> <h3 class=\"p-l-md p-t-md\">Actualización de perfil - N°{{updateVM.info.nTicket}} actualización de {{updateVM.info.title.toLowerCase()}}</h3> </div> </div> <div class=\"row blanco p-t-md p-h-md\"> <div class=\"col-md-5 col-lg-4 b-r\"> <div class=\"row m-b\"> <div class=col-lg-6><h5 class=\"font-semibold text-azul\">Datos de actualización</h5></div> <div class=col-lg-6><button class=\"btn btn-fw center-block btn-info text-center md-ink-ripple pull-right\">Ver datos actuales</button></div> </div> <div class=row> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Perfil a actualizar <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.PerfilActualizar}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Tipo de actualización <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.TipoActualizacion}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Nombre Completo <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.nombreCompleto}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Cédula <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.cedula}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Dirección <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.direccion}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Teléfono fijo <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.telefono}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Email alterno <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.mail_alterno}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Email institucional <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.mail_inst}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Nacionalidad <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.nacionalidad}}</span></p></div> <div class=col-lg-12><p class=\"font-medium text-azul-light\">Fecha de nacimiento <span class=\"font-normal text-negro-dark pull-right text-left\">{{updateVM.dataToUpdate.fechaCumple}}</span></p></div> </div> </div> <div class=\"col-md-7 col-lg-8\"> <div id=formulario ng-if=true> <div class=row> <div class=col-xs-12> <h5 class=\"font-semibold text-azul\">Formulario de Ingreso de registro a bitácora</h5> </div> </div> <div class=\"row m-t\"> <div class=col-lg-12> <label for=\"\">Observaciones</label> <textarea ng-model=updateVM.description class=form-control rows=3 ng-model-options=\"{ debounce: 300 }\"></textarea> </div> </div> <div class=\"row m-t\"> <div class=col-lg-6> <label>Estado a enviar</label> <md-select class=no-margin ng-model=updateVM.stage placeholder=Etapa class=md-no-underline> <md-option value={{stage.id_code}} ng-repeat=\"stage in updateVM.listStages\">{{stage.ds_stage}}</md-option> </md-select> </div> <div class=col-lg-6> <label for=file class=form-medium>Adjuntar archivo(*.pdf)</label> <input type=file nv-file-select=\"\" uploader=uploader required multiple=multiple /> <div class=control-label style=color:#a94442 ng-show=updateVM.messageFileType>El archivo no tiene el formato correcto</div> <div class=control-label style=color:#a94442 ng-show=updateVM.messageFileSize>El archivo no puede superar los 3Mb</div> <div class=control-label style=color:#a94442 ng-show=updateVM.messageFileName>El archivo no puede contener espacios en el nombre</div> </div> <div ng-if=\"uploader.queue.length > 0\" class=\"col-md-6 p-v\"> <table class=table> <thead> <tr> <th width=50%>Nombre</th> <th ng-show=uploader.isHTML5>Tamaño</th> <th>Eliminar</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in uploader.queue\"> <td>{{ item.file.name }}</td> <td ng-show=uploader.isHTML5 nowrap=nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td> <td> <span class=\"icon i-20 mdi-action-delete\" ng-click=updateVM.remove($index)></span></td> </tr> </tbody> </table> </div> </div> </div> <div class=\"row m-t\"> <div class=col-xs-12> <h5 class=\"font-semibold text-azul\">Bitácora</h5> <table class=\"table table table-hover\"> <thead class=\"exo text-gris-dark\"> <tr> <th class=font-semibold>Estado</th> <th class=font-semibold>Fecha de Ingreso</th> <th class=font-semibold>Observación</th> <th class=font-semibold>Adjuntos</th> </tr> </thead> <tbody> <tr ng-repeat=\"log in updateVM.logs\"> <td>{{log.Estado}}</td> <td>{{updateVM.moment(log.fechaIngreso).format('DD-MM-YYYY')}}</td> <td>{{log.Observacion}}</td> <td> <a ng-if=\"log.adjuntos > 0\" ng-click=updateVM.activateModal(log.id_code)> <span class=form_sub_head_action>Documento</span> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class=col-xs-12> <div class=\"row m-t\"> <div class=col-lg-4> <button class=\"btn btn-fw btn-cancel no-margin text-left md-button md-ink-ripple pull-left\" ui-sref=profile.Actualizacion_Perfil>Volver</button> </div> <div class=col-lg-4>&nbsp;</div> <div class=\"col-lg-4 custom_right\"> <button class=\"btn btn-fw center-block btn-success text-center md-ink-ripple pull-right\" ng-click=updateVM.setStageToData()>Envlar Solicitud</button> </div> </div> </div> </div> ";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: perfildashController
	* # alias: perfildashVM
	*/
	
	var perfildashController = function () {
		function perfildashController($scope, $state, $stateParams, ngNotify, $timeout, GlobalSrv, UserInfoConstant, perfilSrv, $mdDialog, FileUploader, SERVICE_URL_CONSTANT, $cookies, moment, $rootScope, LOCAL_ENV_CONSTANT, GlobalConfig) {
			var _this = this;
	
			_classCallCheck(this, perfildashController);
	
			this.$scope = $scope;
			this.$state = $state;
			this.$timeout = $timeout;
			this.ngNotify = ngNotify;
			this.$stateParams = $stateParams;
			this.perfilSrv = perfilSrv;
			this.userinfo = null;
			this.$mdDialog = $mdDialog;
			this.moment = moment;
			this.$scope.avatar_img = __webpack_require__(386);
			this.$scope.circle_2016 = __webpack_require__(387);
			this.$scope.hat = __webpack_require__(388);
			this.$scope.circle_prp_2016 = __webpack_require__(389);
			this.$scope.back = __webpack_require__(390);
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.$scope.SERVICE_URL_CONSTANT = SERVICE_URL_CONSTANT;
			this.$scope.STATIC_SERVER_DOMAIN = LOCAL_ENV_CONSTANT.STATIC_IMAGE_URL;
			this.$scope.rutID = null;
			this.$scope.STATIC_IMAGE_URL = false;
			this.$scope.STATIC_IMAGE_URL_UPLOAD = true;
			this.$scope.noPicture = __webpack_require__(391);
			this.$scope.picture = this.$scope.noPicture;
			this.role = null;
			this.showModalDetailTeacher = null;
			this.gParams = {};
			this.showDatos = false;
			this.globalSrv = GlobalSrv;
			this.GlobalConfig = GlobalConfig;
			this.$cookies = $cookies;
			this.loadingData = {
				dpersonales: true,
				docente: true,
				extend: true,
				invest: true,
				tur: true,
				formacion: true,
				reco: true,
				tprevia: true
			};
	
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.userinfo.role_id = _this.$cookies.get('hasRoleId');
					_this.viewPencil = _this.userinfo.role_id == 13 ? false : true;
					_this.main();
				}
			});
	
			this.$scope.fileNameChanged = function () {
				this.$scope.STATIC_IMAGE_URL_UPLOAD = false;
			};
	
			var uploader = this.$scope.uploader = new FileUploader({
				url: SERVICE_URL_CONSTANT.rosario + '/perfil/setProfileImage'
			});
	
			uploader.filters.push({
				name: 'imageFilter',
				fn: function fn(item, options) {
					var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	
					return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
				}
			});
			uploader.onSuccessItem = function (fileItem, response, status, headers) {
				console.info('onSuccessItem', fileItem, response, status, headers);
			};
			uploader.onErrorItem = function (fileItem, response, status, headers) {
				console.info('onErrorItem', fileItem, response, status, headers);
			};
			var THIS = this;
	
			uploader.onCompleteItem = function (fileItem, response, status, headers) {
				console.info('onCompleteItem', fileItem, response, status, headers);
				THIS.$scope.STATIC_IMAGE_URL = true;
				THIS.$scope.picture = response.data + '?' + Math.random();
				THIS.$scope.STATIC_IMAGE_URL_UPLOAD = true;
				THIS.ngNotify.set('La foto de perfil se ha subido', 'success');
				$rootScope.$emit('profileimagechange', {});
				//$scope.pictureRosario = 'https://urosariostorage.blob.core.windows.net/profilepicture/'+$scope.rut+'.jpg?1'+$scope.mathRandom
			};
	
			uploader.onBeforeUploadItem = function (item) {
				item.formData = [];
				item.formData.push({ id: THIS.$scope.rutID });
				THIS.$scope.STATIC_IMAGE_URL_UPLOAD = true;
			};
	
			var config = __webpack_require__(159);
	
			this.staticServerurl = config.STATIC_IMAGE_URL;
		}
	
		_createClass(perfildashController, [{
			key: 'main',
			value: function main() {
				var _this2 = this;
	
				this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
					if (!response.status) {
						return _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					}
	
					_this2.role = response.data[0];
					_this2.userIsNotATeacher = _this2.role.types !== 'TEACHER';
					_this2.showModalDetailTeacher = _this2.role.id_code != 4;
	
					if (_this2.userIsNotATeacher) {
						_this2.showSelect = true;
	
						if (_this2.$stateParams.teacherId) {
							_this2.onTeacherChange(_this2.$stateParams.teacherId);
						}
					} else {
						_this2.showSelect = false;
						_this2.getInfoProfile();
					}
				}, function (err) {
					_this2.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'viewDetails',
			value: function viewDetails(det) {
				this.urls = {
					perfil_docente: 'profile.perfil_docente',
					perfil_investigation: 'profile.perfil_investigation',
					perfil_extencion: 'profile.perfil_extencion',
					UR_trajectory: 'profile.UR_trajectory',
					perfilde_formacion: 'profile.perfilde_formacion',
					Reconocimientose_inc: 'profile.Reconocimientose_inc',
					Trayectoria_Previa: 'profile.Trayectoria_Previa'
				};
	
				if (this.gParams.teacherId !== undefined) {
					this.$state.go(this.urls[det], this.gParams);
				}
			}
		}, {
			key: 'getInfoProfile',
			value: function getInfoProfile() {
				var _this3 = this;
	
				this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
					if (!response.status) {
						_this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this3.userinfo.teacherId = response.data[0].idTeacher;
						_this3.callingAllServices(_this3.userinfo.teacherId);
					}
				}, function (err) {
					_this3.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'callingAllServices',
			value: function callingAllServices(teacherId) {
				this.show = true;
				this.gParams = { teacherId: teacherId };
				this.getTeacherInfo(teacherId);
				this.getperfildocenteChart(teacherId);
				this.perfilextentionChart(teacherId);
				this.PerfildeInvestigacionChart(teacherId);
				this.TrayectoriaURGraph(teacherId);
				this.trayectoriaprevia(teacherId);
				this.perfilFormacion(teacherId);
				this.reconocimientros(teacherId);
				this.showDatos = true;
			}
		}, {
			key: 'getperfildocenteChart',
			value: function getperfildocenteChart(teacherId) {
				var _this4 = this;
	
				this.loadingData.docente = true;
				this.perfilSrv.perfildocente.getperfildocenteChart({ teacherId: teacherId }).$promise.then(function (response) {
					if (!response.status) {
						_this4.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this4.chartDocente = Highcharts.chart('perfil_chart_d', {
							chart: { type: 'column' },
							title: { text: 'Última actualización el ' + response.data.lastUpdate },
							subtitle: {
								useHTML: true,
								text: '<p>Asignaturas Dictadas por Nivel</p>',
								floating: true,
								style: {
									fontSize: '9px',
									fontWeight: 'bold'
								},
								align: 'center',
								x: -10,
								y: 255
							},
							xAxis: {
								categories: response.data.category,
								labels: { x: -10 } },
							yAxis: {
								tickInterval: 1,
								minRange: 1,
								allowDecimals: false,
								title: { text: '' } },
							series: response.data.series,
							plotOptions: { column: { stacking: 'normal' } },
							size: { height: '300' },
							tooltip: {
								formatter: function formatter() {
									return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + this.y + '<br/>' + 'Total: ' + this.point.stackTotal;
								}
							},
							credits: false
						});
						_this4.loadingData.docente = false;
					}
				}, function (err) {
					_this4.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'PerfildeInvestigacionChart',
			value: function PerfildeInvestigacionChart(teacherId) {
				var _this5 = this;
	
				this.loadingData.invest = true;
				this.perfilSrv.perfildocente.PerfildeInvestigacionChart({ teacherId: teacherId }).$promise.then(function (response) {
					_this5.cartInves = Highcharts.chart('perfil_inv_d', {
						chart: { type: 'column' },
						title: { text: 'Última actualización el ' + response.data.lastUpdate },
						subtitle: {
							useHTML: true,
							text: '<p>Producción Científica</p>',
							floating: true,
							style: {
								fontSize: '9px',
								fontWeight: 'bold'
							},
							align: 'center',
							x: -10,
							y: 255
						},
						xAxis: { categories: response.data.category, labels: { x: -10 } },
						yAxis: {
							tickInterval: 1,
							minRange: 1,
							allowDecimals: false,
							title: { text: '' } },
						series: response.data.series,
						plotOptions: { column: { stacking: 'normal' } },
						size: { height: '300' },
						tooltip: {
							formatter: function formatter() {
								return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + this.y + '<br/>' + 'Total: ' + this.point.stackTotal;
							}
						},
						credits: false
					});
					_this5.loadingData.invest = false;
				}, function (data) {
					_this5.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'perfilextentionChart',
			value: function perfilextentionChart(teacherId) {
				var _this6 = this;
	
				this.loadingData.extend = true;
				this.perfilSrv.perfildocente.perfilextentionChart({ teacherId: teacherId }).$promise.then(function (response) {
					_this6.chartExt = Highcharts.chart('perfil_ext_d', {
						chart: { type: 'column' },
						title: { text: 'Última actualización el ' + response.data.lastUpdate },
						subtitle: {
							useHTML: true,
							text: '<p>Actividades de Extensión Realizadas</p>',
							floating: true,
							style: {
								fontSize: '9px',
								fontWeight: 'bold'
							},
							align: 'center',
							x: -10,
							y: 255
						},
						xAxis: { categories: response.data.category, labels: { x: -10 } },
						yAxis: {
							tickInterval: 1,
							minRange: 1,
							allowDecimals: false,
							title: { text: '' } },
						series: response.data.series,
						plotOptions: { column: { stacking: 'normal' } },
						size: { height: '300' },
						tooltip: {
							formatter: function formatter() {
								return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + this.y + '<br/>' + 'Total: ' + this.point.stackTotal;
							}
						},
						credits: false
					});
					_this6.loadingData.extend = false;
				}, function (data) {
					_this6.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'TrayectoriaURGraph',
			value: function TrayectoriaURGraph(teacherId) {
				var _this7 = this;
	
				this.loadingData.tur = true;
				this.perfilSrv.perfildocente.TrayectoriaURGraph({ teacherId: teacherId }).$promise.then(function (response) {
					_this7.singleName = response.data[0] || {};
					_this7.loadingData.tur = false;
				}, function (data) {
					_this7.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'perfilFormacion',
			value: function perfilFormacion(teacherId) {
				var _this8 = this;
	
				this.loadingData.formacion = true;
				this.perfilSrv.perfildocente.perfilFormacion({ teacherId: teacherId }).$promise.then(function (dataReturn) {
					_this8.lastFormation = dataReturn.data[0] || {};
					_this8.lastFormation.end_date = dataReturn.maxYear;
					_this8.lastFormation.Convalescence = _this8.moment(_this8.lastFormation.Convalescence).format('DD-MM-YYYY');
					_this8.loadingData.formacion = false;
				}, function (data) {
					_this8.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'reconocimientros',
			value: function reconocimientros(teacherId) {
				var _this9 = this;
	
				this.loadingData.reco = true;
				this.perfilSrv.perfildocente.reconocimientoSeincentivos({ teacherId: teacherId }).$promise.then(function (response) {
					if (!response.status) {
						_this9.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this9.lastAck = response.data[0] || {};
					}
	
					_this9.loadingData.reco = false;
				}, function (err) {
					_this9.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'trayectoriaprevia',
			value: function trayectoriaprevia(teacherId) {
				var _this10 = this;
	
				this.loadingData.tprevia = true;
				this.perfilSrv.perfildocente.trayectoriaprevia({ teacherId: teacherId }).$promise.then(function (dataReturn) {
					_this10.registrosTP = dataReturn.data.length;
					_this10.trayectoriaPrevia = dataReturn.data[0];
					_this10.loadingData.tprevia = false;
				}, function (err) {
					_this10.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getTeacherInfo',
			value: function getTeacherInfo(teacherId) {
				var _this11 = this;
	
				this.$scope.loading = true;
				this.loadingData.dpersonales = true;
				this.dataInfo = {};
				this.perfilSrv.perfildocente.getperfil_dash({ teacherId: teacherId }).$promise.then(function (response) {
					if (!response.status) {
						_this11.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this11.dataInfo = response.data[0] || {};
						_this11.$scope.items = response.data;
						_this11.$scope.loading = false;
						_this11.$scope.rutID = _this11.dataInfo.identification_number;
	
						var self = _this11;
						var currentUser = _this11.$cookies.getObject('currentUser');
						var mathRandom = Math.random();
	
						if (!_this11.userIsNotATeacher && currentUser) {
							if (currentUser.pictureExtension) {
								_this11.$scope.picture = _this11.staticServerurl + '/profilepicture/' + currentUser.pictureExtension + '?1=' + mathRandom;
							} else if (currentUser.pictureRosario) {
								_this11.$scope.picture = currentUser.pictureRosario;
							}
						} else if (_this11.$scope.rutID) {
							_this11.globalSrv.getUserImage.get({ identification: _this11.$scope.rutID }).$promise.then(function (response) {
								self.$scope.picture = response.profilePicture + '?1=' + mathRandom;
							});
						}
					}
	
					_this11.loadingData.dpersonales = false;
				}, function (err) {
					_this11.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getTeacherInfoByRoleUser',
			value: function getTeacherInfoByRoleUser() {}
		}, {
			key: 'returnBack',
			value: function returnBack() {
				window.history.back();
			}
		}, {
			key: 'editComments',
			value: function editComments() {
				var confirm = this.$mdDialog.confirm({
					controller: 'modalEditCommentsCtrl',
					controllerAs: 'modalVM',
					template: __webpack_require__(392),
					locals: { services: this.perfilSrv.post, dataInfo: this.dataInfo },
					animation: true,
					parent: angular.element(document.body),
					clickOutsideToClose: true
				});
	
				this.$mdDialog.show(confirm);
			}
		}, {
			key: 'areasOfInterest',
			value: function areasOfInterest() {
				var confirm = this.$mdDialog.confirm({
					controller: 'areasOfInterestCtrl',
					controllerAs: 'modalVM',
					template: __webpack_require__(393),
					locals: { services: this.perfilSrv.post, dataInfo: this.dataInfo },
					animation: true,
					parent: angular.element(document.body),
					clickOutsideToClose: true
				});
	
				this.$mdDialog.show(confirm);
			}
		}, {
			key: 'searchingTeacher',
			value: function searchingTeacher(typing) {
				var _this12 = this;
	
				if (typing.length > 2) {
					var params = {
						param1: typing,
						param2: this.userinfo.role_id,
						param3: this.userinfo.id
					};
	
					this.perfilSrv.list.getListDocentes(params).$promise.then(function (response) {
						if (!response.status) {
							_this12.ngNotify.set('Ocurrio un error en el servicio', 'warn');
						} else {
							_this12.listTeachers = response.data;
						}
					}, function (err) {
						_this12.ngNotify.set('Imposible conectar con el servicio', 'error');
					});
				}
			}
		}, {
			key: 'onTeacherChange',
			value: function onTeacherChange(teacherId) {
				this.showDatos = false;
				this.$scope.picture = this.$scope.noPicture;
				this.callingAllServices(teacherId);
			}
		}, {
			key: 'showModal',
			value: function showModal() {
				var confirm = this.$mdDialog.confirm({
					controller: 'perfil_popcontroller',
					controllerAs: 'perfildashVM',
					template: __webpack_require__(394),
					locals: { datos: this.dataInfo },
					animation: true,
					parent: angular.element(document.body),
					clickOutsideToClose: true
				});
	
				this.$mdDialog.show(confirm);
			}
		}]);
	
		return perfildashController;
	}();
	
	exports.default = perfildashController;
	
	
	perfildashController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'GlobalSrv', 'UserInfoConstant', 'perfilSrv', '$mdDialog', 'FileUploader', 'SERVICE_URL_CONSTANT', '$cookies', 'moment', '$rootScope', 'LOCAL_ENV_CONSTANT', 'GlobalConfig'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01b263b3ce7c5c3c21cee8a83a746a8e.png";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e7ae7357ad6f8b217b757b270a3e2fa.png";

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ec86ba2eb6b689101c97110d52136e7.png";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a58eadd484ad7eba30c55f0d7905d93e.png";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c94a6f5f89507eb167b4635ac489b969.png";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7b9cf67a8508007a2414bc0681cea55.jpg";

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports = "<style>.c-input{margin-bottom:.9em}</style> <md-dialog class=\"col-xs-12 col-md-4 custom_dialog_box_nn\" style=min-width:50%> <md-dialog-content> <div class=loading-details ng-if=modalVM.loading> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=modalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div class=text-center> <h3 class=\"font-bold text-azul\">Editar resumen del perfil</h3> </div> </div> <div class=col-xs-12> <div class=form-group> <div class=\"m-b-sm webeditor\" text-angular name=ds_description ng-model=modalVM.ds_comments ta-toolbar=modalVM.optionsTextEditor> </div> </div> </div> <div class=col-xs-12> <div class=text-center> <button md-ink-ripple class=\"btn btn-fw md-button md-ink-ripple btn-success m-l-sm\" ng-click=modalVM.save()>Aceptar</button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	module.exports = "<style>.c-input{margin-bottom:.9em}</style> <md-dialog class=\"col-xs-12 col-md-4 custom_dialog_box_nn\"> <md-dialog-content> <div class=loading-details ng-if=modalVM.loading> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=modalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div ng-controller=perfildashController> <div class=text-center> <h3 class=\"font-bold text-azul text-center\">Áreas de Interes</h3> </div> </div> <div class=col-xs-12> <input type=text class=\"form-control c-input\" maxlength=50 ng-model=modalVM.interestArea1 ng-model-options=\"{ debounce: 300 }\"> <input type=text class=\"form-control c-input\" maxlength=50 ng-model=modalVM.interestArea2 ng-model-options=\"{ debounce: 300 }\"> <input type=text class=\"form-control c-input\" maxlength=50 ng-model=modalVM.interestArea3 ng-model-options=\"{ debounce: 300 }\"> <input type=text class=\"form-control c-input\" maxlength=50 ng-model=modalVM.interestArea4 ng-model-options=\"{ debounce: 300 }\"> <input type=text class=\"form-control c-input\" maxlength=50 ng-model=modalVM.interestArea5 ng-model-options=\"{ debounce: 300 }\"> </div> <div class=\"col-xs-12 text-center\"> <div class=text-center> <button md-ink-ripple class=\"btn btn-fw md-button md-ink-ripple btn-success m-l-sm\" ng-click=modalVM.save()>Aceptar</button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog class=\"col-xs-12 col-md-4 custom_dialog_box_nn\" style=min-height:250px;min-width:35%> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=perfildashVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div class=text-center> <h3 class=\"font-bold text-azul text-center\">Datos Personales</h3> </div> <div> <div class=\"col-lg-12 custom_align_left custom_padding_sm\"> <table class=\"table table-no-bordered\"> <tbody> <tr> <td>Identificación</td> <td>{{datos.identification_number}}</td> </tr> <tr> <td>Nacionalidad</td> <td>{{datos.nationality}}</td> </tr> <tr> <td>Fecha de nacimiento</td> <td>{{datos.birth_date}}</td> </tr> <tr> <td>Dirección de residencia</td> <td>{{datos.address}}</td> </tr> <tr> <td>Teléfono de residencia</td> <td>{{datos.phone_number}}</td> </tr> <tr> <td>Correo electrónico institucional</td> <td>{{datos.company_email}}</td> </tr> <tr> <td>Correo alterno</td> <td>{{datos.altern_email}}</td> </tr> </tbody> </table> </div> </div> </div> <div class=\"text-center m-t-md m-b-md\"> <button md-ink-ripple class=\"btn btn-fw md-button md-ink-ripple btn-cancel m-l-sm\" ng-click=perfildashVM.close()>Cancelar</button> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: modalEditCommentsCtrl
	* # alias: Ctrl
	*/
	
	var modalEditCommentsCtrl = function () {
		function modalEditCommentsCtrl($scope, $mdDialog, services, dataInfo, ngNotify) {
			_classCallCheck(this, modalEditCommentsCtrl);
	
			this.$scope = $scope;
			this.$mdDialog = $mdDialog;
			this.services = services;
			this.loading = false;
			this.dataInfo = dataInfo;
			this.ngNotify = ngNotify;
			this.ds_comments = this.dataInfo.ds_comments;
			this.optionsTextEditor = [['bold', 'italics', 'underline'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['ul', 'quote', 'html'], ['insertImage', 'insertVideo', 'insertLink'], ['undo', 'redo']];
		}
	
		_createClass(modalEditCommentsCtrl, [{
			key: 'close',
			value: function close() {
				this.$mdDialog.hide();
			}
		}, {
			key: 'save',
			value: function save() {
				var _this = this;
	
				var params = {
					user_id: this.dataInfo.user_id,
					ds_biography: this.ds_comments.replace(/\u200B/g, '')
				};
	
				this.services.saveBiography(params).$promise.then(function (response) {
					if (!response.status) {
						_this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this.ngNotify.set('Bitácora actualizada', 'success');
						_this.dataInfo.ds_comments = params.ds_biography;
						_this.$mdDialog.hide();
					}
				}, function (err) {
					_this.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}]);
	
		return modalEditCommentsCtrl;
	}();
	
	exports.default = modalEditCommentsCtrl;
	
	
	modalEditCommentsCtrl.$inject = ['$scope', '$mdDialog', 'services', 'dataInfo', 'ngNotify'];

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: areasOfInterestCtrl
	* # alias: Ctrl
	*/
	
	var areasOfInterestCtrl = function () {
		function areasOfInterestCtrl($scope, $mdDialog, services, dataInfo, ngNotify) {
			_classCallCheck(this, areasOfInterestCtrl);
	
			this.$scope = $scope;
			this.$mdDialog = $mdDialog;
			this.loading = false;
			this.ngNotify = ngNotify;
			this.services = services;
			this.dataInfo = dataInfo;
			this.interestArea1 = this.dataInfo.ds_area_interest1;
			this.interestArea2 = this.dataInfo.ds_area_interest2;
			this.interestArea3 = this.dataInfo.ds_area_interest3;
			this.interestArea4 = this.dataInfo.ds_area_interest4;
			this.interestArea5 = this.dataInfo.ds_area_interest5;
		}
	
		_createClass(areasOfInterestCtrl, [{
			key: 'close',
			value: function close() {
				this.$mdDialog.hide();
			}
		}, {
			key: 'save',
			value: function save() {
				var _this = this;
	
				var params = {
					user_id: this.dataInfo.user_id,
					ds_interest1: this.interestArea1,
					ds_interest2: this.interestArea2,
					ds_interest3: this.interestArea3,
					ds_interest4: this.interestArea4,
					ds_interest5: this.interestArea5
				};
	
				this.services.saveInterestArea(params).$promise.then(function (response) {
					if (!response.status) {
						_this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this.ngNotify.set('Información guardada exitosamente!', 'success');
						_this.dataInfo.ds_area_interest1 = _this.interestArea1;
						_this.dataInfo.ds_area_interest2 = _this.interestArea2;
						_this.dataInfo.ds_area_interest3 = _this.interestArea3;
						_this.dataInfo.ds_area_interest4 = _this.interestArea4;
						_this.dataInfo.ds_area_interest5 = _this.interestArea5;
						_this.$mdDialog.hide();
					}
				}, function (err) {
					_this.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}]);
	
		return areasOfInterestCtrl;
	}();
	
	exports.default = areasOfInterestCtrl;
	
	
	areasOfInterestCtrl.$inject = ['$scope', '$mdDialog', 'services', 'dataInfo', 'ngNotify'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: perfildocenteController
	* # alias: perfildocenteVM
	*/
	
	var perfildocenteController = function () {
	  function perfildocenteController($scope, $state, $stateParams, ngNotify, UserInfoConstant, perfilSrv, $cookies, $mdDialog, i18nService) {
	    var _this = this;
	
	    _classCallCheck(this, perfildocenteController);
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.ngNotify = ngNotify;
	    this.$mdDialog = $mdDialog;
	    this.$stateParams = $stateParams;
	    this.perfilSrv = perfilSrv;
	    this.userinfo = null;
	    this.$cookies = $cookies;
	    this.$scope.gridOptionsComplex = {
	      enableFiltering: true,
	      showFooter: true,
	      //rowHeight: 36,
	      enableGridMenu: true,
	      enableRowSelection: true,
	      enableRowHeaderSelection: false,
	      multiSelect: false,
	      modifierKeysToMultiSelect: false,
	      noUnselect: true,
	      columnDefs: [{ displayName: 'Nivel', field: 'Level', width: '10%' }, { displayName: 'Período', field: 'Periodo', width: '15%' }, { displayName: 'Asignatura', field: 'Asignatura', width: '25%' }, { displayName: 'Programa/Área', field: 'ProgramaArea', width: '30%' }, { displayName: 'Dedicación', field: 'Dedic', width: '10%' }, { displayName: 'Número de grupos', field: 'cantGroup', width: '10%' }, { displayName: 'Ver más', field: 'Ver más', width: '10%', cellTemplate: __webpack_require__(398), pinnedRight: true }]
	    };
	    this.$scope.UserInfoConstant = UserInfoConstant;
	    this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	      if (details !== undefined) {
	        _this.userinfo = details.user;
	        _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	        _this.main();
	      }
	    });
	    i18nService.setCurrentLang('es');
	  }
	
	  _createClass(perfildocenteController, [{
	    key: 'main',
	    value: function main() {
	      var _this2 = this;
	
	      /**
	      * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	      **/
	      if (this.$stateParams.teacherId != '') {
	        this.userinfo.teacherId = this.$stateParams.teacherId;
	        this.getperfildocente(this.userinfo.teacherId);
	      } else {
	        this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	          if (!response.status) {
	            _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	          } else {
	            _this2.role = response.data[0];
	            if (_this2.role.types == 'TEACHER') {
	              _this2.getInfo();
	            } else {
	              _this2.$state.go('profile.perfil_dash');
	              _this2.ngNotify.set('No se ha especificado ningún docente', 'info');
	            }
	          }
	        }, function (err) {
	          _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	        });
	      }
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.$state.go('profile.perfil_dash', { teacherId: this.$stateParams.teacherId });
	    }
	  }, {
	    key: 'getInfo',
	    value: function getInfo() {
	      var _this3 = this;
	
	      this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	        if (!response.status) {
	          _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	        } else {
	          _this3.userinfo.teacherId = response.data[0].idTeacher;
	          _this3.getperfildocente(_this3.userinfo.teacherId);
	        }
	      }, function (err) {
	        _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	      });
	    }
	  }, {
	    key: 'getperfildocente',
	    value: function getperfildocente(teacherId) {
	      var _this4 = this;
	
	      this.perfilSrv.perfildocente.getperfildocente({ teacherId: teacherId }).$promise.then(function (response) {
	        if (response.status) {
	          _this4.$scope.gridOptionsComplex.data = _this4.buildingTable(response.data);
	        }
	      }, function (data) {
	        _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	      });
	    }
	  }, {
	    key: 'buildingTable',
	    value: function buildingTable(data) {
	      var result = [];
	      var currentLevel = null;
	      for (var i in data) {
	        if (currentLevel != data[i].Nivel) {
	          currentLevel = data[i].Nivel;
	          result.push({ $$treeLevel: 0, 'Level': data[i].Nivel });
	        }
	        result.push(data[i]);
	      }
	      return result;
	    }
	  }, {
	    key: 'returnBack',
	    value: function returnBack() {
	      window.history.back();
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal(row) {
	      var confirm = this.$mdDialog.confirm({
	        controller: 'dialogdetailcontroller',
	        controllerAs: 'dialogdetaildocente',
	        template: __webpack_require__(399),
	        locals: { data: { row: row, user: this.userinfo } },
	        animation: true,
	        parent: angular.element(document.body),
	        clickOutsideToClose: true
	      });
	
	      this.$mdDialog.show(confirm);
	    }
	  }]);
	
	  return perfildocenteController;
	}();
	
	exports.default = perfildocenteController;
	
	
	perfildocenteController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', 'UserInfoConstant', 'perfilSrv', '$cookies', '$mdDialog', 'i18nService'];

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"text-center ui-grid-cell-contents\"> <a class=form_sub_head_action ng-if=row.entity.Asignatura ng-click=grid.appScope.perfildocenteVM.showModal(row.entity)> Detalle </a> </div>";

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content style=min-height:40vh;max-height:70vh> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=dialogdetaildocente.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div class=text-center> <h3 class=\"font-bold text-azul\">Detalles {{dialogdetaildocente.data.row.Asignatura}}</h3> </div> <div class=\"row no-gutter\"> <div class=col-xs-12> <div class=row> <div class=\"col-xs-12 col-sm-6 text-left\">Período</div> <div class=\"col-xs-12 col-sm-6 text-left\">{{dialogdetaildocente.params.row.Periodo}}</div> </div> <div class=row> <div class=\"col-xs-12 col-sm-6 text-left\">Nombre de la asignatura</div> <div class=\"col-xs-12 col-sm-6 text-left\">{{dialogdetaildocente.params.row.Asignatura}}</div> </div> <div class=row> <div class=\"col-xs-12 col-sm-6 text-left\">Unidad</div> <div class=\"col-xs-12 col-sm-6 text-left\">{{dialogdetaildocente.params.row.Unidad}}</div> </div> <div class=row> <div class=\"col-xs-12 col-sm-6 text-left\">Programa/Área</div> <div class=\"col-xs-12 col-sm-6 text-left\">{{dialogdetaildocente.params.row.ProgramaArea}}</div> </div> <div ng-repeat=\"details in dialogdetaildocente.details\"> <div class=row> <div class=\"col-xs-12 col-sm-6 text-left\">Grupo</div> <div class=\"col-xs-12 col-sm-6 text-left\">{{details.id}}</div> </div> <div ng-repeat=\"aspects in details.data\"> <div class=row> <div class=\"col-xs-12 col-sm-6 text-left\">{{aspects.aspect}}</div> <div class=\"col-xs-12 col-sm-6 text-left\">{{aspects.avgAspect}}</div> </div> </div> </div> </div> </div> </div> <div class=\"text-center m-t-md m-b-md\"> <button md-ink-ripple class=\"btn btn-fw md-button md-ink-ripple btn-cancel m-l-sm\" ng-click=dialogdetaildocente.close()>Cancelar</button> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: perfildocentechartController
	* # alias: chartDocente
	*/
	
	var perfildocentechartController = function () {
	    function perfildocentechartController($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies) {
	        var _this = this;
	
	        _classCallCheck(this, perfildocentechartController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.ngNotify = ngNotify;
	        this.$stateParams = $stateParams;
	        this.perfilSrv = perfilSrv;
	        this.userinfo = null;
	        this.$scope.chartConfig = {};
	        this.$cookies = $cookies;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(perfildocentechartController, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.getperfildocenteChart(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.getperfildocenteChart(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'getperfildocenteChart',
	        value: function getperfildocenteChart(teacherId) {
	            var _this4 = this;
	
	            this.perfilSrv.perfildocente.getperfildocenteChart({ teacherId: teacherId }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this4.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    Highcharts.chart('perfil_chart', {
	                        chart: { type: 'column' },
	                        title: {
	                            style: {
	                                fontWeight: 'bold'
	                            },
	                            align: 'center',
	                            text: 'Asignaturas Dictadas por Nivel' }, //'Última actualización el ' + response.data.lastUpdate},
	                        xAxis: {
	                            categories: response.data.category,
	                            labels: { x: -10 } },
	                        yAxis: {
	                            tickInterval: 1,
	                            minRange: 1,
	                            allowDecimals: false,
	                            title: { text: "" } },
	                        series: response.data.series,
	                        plotOptions: { column: { stacking: 'normal' } },
	                        size: { height: "300" },
	                        tooltip: {
	                            formatter: function formatter() {
	                                return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + this.y + 'Total: ' + this.point.stackTotal;
	                            }
	                        },
	                        credits: {
	                            enabled: false
	                        }
	                    });
	                }
	            }, function (err) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return perfildocentechartController;
	}();
	
	exports.default = perfildocentechartController;
	
	
	perfildocentechartController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies'];

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var perfilinvController = function () {
	    function perfilinvController($scope, $uiGridConstants, $http, perfilSrv, ngNotify, $cookies, UserInfoConstant, $stateParams) {
	        var _this = this;
	
	        _classCallCheck(this, perfilinvController);
	
	        this.$scope = $scope;
	        this.$uiGridConstants = $uiGridConstants;
	        this.$http = $http;
	        this.perfilSrv = perfilSrv;
	        this.ngNotify = ngNotify;
	        this.$cookies = $cookies;
	        this.$stateParams = $stateParams;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(perfilinvController, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.PerfildeInvestigacionChart(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.PerfildeInvestigacionChart(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'PerfildeInvestigacionChart',
	        value: function PerfildeInvestigacionChart(teacherId) {
	            var _this4 = this;
	
	            this.perfilSrv.perfildocente.PerfildeInvestigacionChart({ teacherId: teacherId }).$promise.then(function (response) {
	                var chart = {
	                    chart: { type: 'column' },
	                    title: {
	                        style: {
	                            fontWeight: 'bold'
	                        },
	                        align: 'center',
	                        text: 'Producción Científica' }, //'Última actualización el ' + response.data.lastUpdate},
	                    xAxis: { categories: response.data.category, labels: { x: -10 } },
	                    yAxis: {
	                        tickInterval: 1,
	                        minRange: 1,
	                        allowDecimals: false,
	                        title: { text: "" } },
	                    series: response.data.series,
	                    plotOptions: { column: { stacking: 'normal' } },
	                    size: { height: "300" },
	                    tooltip: {
	                        formatter: function formatter() {
	                            return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + this.y + '<br/>' + 'Total: ' + this.point.stackTotal;
	                        }
	                    }
	                };
	
	                Highcharts.chart('containt', chart);
	            }, function (data) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return perfilinvController;
	}();
	
	exports.default = perfilinvController;
	
	
	perfilinvController.$inject = ['$scope', 'uiGridConstants', '$http', 'perfilSrv', 'ngNotify', '$cookies', 'UserInfoConstant', '$stateParams'];

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Perfilinvestigationcontroller = function () {
	    function Perfilinvestigationcontroller($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, i18nService) {
	        var _this = this;
	
	        _classCallCheck(this, Perfilinvestigationcontroller);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.ngNotify = ngNotify;
	        this.$stateParams = $stateParams;
	        this.perfilSrv = perfilSrv;
	        this.userinfo = null;
	        this.$scope.chartConfig = {};
	        this.$cookies = $cookies;
	        this.$scope.gridOptionsComplex = {
	            enableFiltering: true,
	            enableGridMenu: true,
	            showFooter: true,
	            rowHeight: 36,
	            columnDefs: [{ displayName: 'Tipo de publicación', field: 'tipoDePublicacion', width: '25%' }, { displayName: 'Año de publicación', field: 'anoDePublicacion', width: '25%' }, { displayName: 'Subtipo', field: 'subTipo', width: '20%' }, { displayName: 'Título', field: 'titulo', width: '20%' }]
	        };
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	        i18nService.setCurrentLang('es');
	    }
	
	    _createClass(Perfilinvestigationcontroller, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.PerfildeInvestigacion(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        } else {
	                            _this2.$state.go('profile.perfil_dash');
	                            _this2.ngNotify.set('No se ha especificado ningún docente', 'info');
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.$state.go('profile.perfil_dash', { teacherId: this.$stateParams.teacherId });
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.PerfildeInvestigacion(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'PerfildeInvestigacion',
	        value: function PerfildeInvestigacion(teacherId) {
	            var _this4 = this;
	
	            this.perfilSrv.perfildocente.PerfildeInvestigacion({ teacherId: teacherId }).$promise.then(function (dataReturn) {
	                _this4.$scope.gridOptionsComplex.data = dataReturn.data;
	            }, function (data) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return Perfilinvestigationcontroller;
	}();
	
	exports.default = Perfilinvestigationcontroller;
	
	
	Perfilinvestigationcontroller.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', 'i18nService'];

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var perfilextvController = function () {
	    function perfilextvController($scope, $uiGridConstants, $http, perfilSrv, ngNotify, $cookies, UserInfoConstant, $stateParams) {
	        var _this = this;
	
	        _classCallCheck(this, perfilextvController);
	
	        this.$scope = $scope;
	        this.$uiGridConstants = $uiGridConstants;
	        this.$http = $http;
	        this.perfilSrv = perfilSrv;
	        this.ngNotify = ngNotify;
	        this.$cookies = $cookies;
	        this.$stateParams = $stateParams;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(perfilextvController, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.perfilextentionChart(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.perfilextentionChart(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'perfilextentionChart',
	        value: function perfilextentionChart(teacherId) {
	            var _this4 = this;
	
	            this.perfilSrv.perfildocente.perfilextentionChart({ teacherId: teacherId }).$promise.then(function (response) {
	                var chart = {
	                    chart: { type: 'column' },
	                    title: { text: 'Última actualización el ' + response.data.lastUpdate },
	                    xAxis: { categories: response.data.category, labels: { x: -10 } },
	                    yAxis: {
	                        tickInterval: 1,
	                        minRange: 1,
	                        allowDecimals: false,
	                        title: { text: "" } },
	                    series: response.data.series,
	                    plotOptions: { column: { stacking: 'normal' } },
	                    size: { height: "300" },
	                    tooltip: {
	                        formatter: function formatter() {
	                            return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + this.y + '<br/>' + 'Total: ' + this.point.stackTotal;
	                        }
	                    }
	                };
	                Highcharts.chart('container', chart);
	            }, function (data) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return perfilextvController;
	}();
	
	exports.default = perfilextvController;
	
	
	perfilextvController.$inject = ['$scope', 'uiGridConstants', '$http', 'perfilSrv', 'ngNotify', '$cookies', 'UserInfoConstant', '$stateParams'];

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var perfilextencioncotroller = function () {
	    function perfilextencioncotroller($scope, $uiGridConstants, $http, perfilSrv, ngNotify, UserInfoConstant, $cookies, $stateParams, $state, i18nService) {
	        var _this = this;
	
	        _classCallCheck(this, perfilextencioncotroller);
	
	        this.$scope = $scope;
	        this.$uiGridConstants = $uiGridConstants;
	        this.$http = $http;
	        this.perfilSrv = perfilSrv;
	        this.ngNotify = ngNotify;
	        this.$cookies = $cookies;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.$scope.gridOptionsComplex = {
	            enableFiltering: true,
	            enableGridMenu: true,
	            showFooter: true,
	            enableRowSelection: true,
	            enableRowHeaderSelection: false,
	            multiSelect: false,
	            modifierKeysToMultiSelect: false,
	            noUnselect: true,
	            //rowHeight: 36,
	            columnDefs: [{ displayName: 'Campo/Descripción', field: 'campoDescripcion', width: '25%' }, { displayName: 'Servicio', field: 'servico', width: '15%' }, { displayName: 'A Título', field: 'aTitulo', width: '15%' }, { displayName: 'Objeto', field: 'objeto', width: '15%' }, { displayName: 'Mes/Año Inicio', field: 'mesAnoInicio', width: '15%' }, { displayName: 'Mes/Año Finalización', field: 'mesAnoFinalizacion', width: '25%' }, { displayName: 'Tipo De Entidad', field: 'tipoDeEntidad', width: '15%' }, { displayName: 'Ent. Contratante', field: 'entContratante', width: '15%' }, { displayName: 'Resultados', field: 'resultados', width: '15%' }]
	        };
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	        i18nService.setCurrentLang('es');
	    }
	
	    _createClass(perfilextencioncotroller, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.perfilextention(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        } else {
	                            _this2.$state.go('profile.perfil_dash');
	                            _this2.ngNotify.set('No se ha especificado ningún docente', 'info');
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.$state.go('profile.perfil_dash', { teacherId: this.$stateParams.teacherId });
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.perfilextention(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'perfilextention',
	        value: function perfilextention(teacherId) {
	            var _this4 = this;
	
	            this.perfilSrv.perfildocente.perfilextention({ teacherId: teacherId }).$promise.then(function (dataReturn) {
	                _this4.$scope.gridOptionsComplex.data = dataReturn.data;
	            }, function (data) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return perfilextencioncotroller;
	}();
	
	exports.default = perfilextencioncotroller;
	
	
	perfilextencioncotroller.$inject = ['$scope', 'uiGridConstants', '$http', 'perfilSrv', 'ngNotify', 'UserInfoConstant', '$cookies', '$stateParams', '$state', 'i18nService'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: perfiltrayectoriatable
	* # alias: Perfil
	*/
	
	var perfiltrayectoriatable = function () {
	    function perfiltrayectoriatable($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, $mdDialog, i18nService) {
	        var _this = this;
	
	        _classCallCheck(this, perfiltrayectoriatable);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.ngNotify = ngNotify;
	        this.$stateParams = $stateParams;
	        this.perfilSrv = perfilSrv;
	        this.$mdDialog = $mdDialog;
	        this.userinfo = null;
	        this.$cookies = $cookies;
	        this.$scope.img_grediant_circle_1 = __webpack_require__(406);
	        this.$scope.gridOptionsComplex = {
	            enableFiltering: true,
	            showFooter: true,
	            enableGridMenu: true,
	            //rowHeight: 36,
	            columnDefs: [{ displayName: 'Cargo', field: 'Cargo', width: '20%' }, { displayName: 'Rol', field: 'dsRol', width: '20%' }, { displayName: 'Año Inicio', field: 'dtInit', width: '10%' }, { displayName: 'Año Finalización', field: 'dtEnd', width: '10%' }, { displayName: 'Unidad', field: 'dsUnidad', width: '20%' }, { displayName: 'Dedicación', field: 'Dedicacion', width: '20%' }]
	        };
	
	        this.$scope.gridOptionsDelegation = {
	            enableFiltering: true,
	            showFooter: true,
	            enableGridMenu: true,
	            //rowHeight: 36,
	            columnDefs: [{ displayName: 'Delegación', field: 'delegation', width: '40%' }, { displayName: 'Unidad Académica', field: 'dsUnidad', width: '40%' }, { displayName: 'Fecha inicio', field: 'dtInit', width: '20%' }]
	        };
	
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	        i18nService.setCurrentLang('es');
	    }
	
	    _createClass(perfiltrayectoriatable, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.getTableData(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        } else {
	                            _this2.$state.go('profile.perfil_dash');
	                            _this2.ngNotify.set('No se ha especificado ningún docente', 'info');
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.$state.go('profile.perfil_dash', { teacherId: this.$stateParams.teacherId });
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.getTableData(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'getTableData',
	        value: function getTableData() {
	            var _this4 = this;
	
	            this.perfilSrv.perfildocente.trayectoriaUR({ teacherId: this.userinfo.teacherId }).$promise.then(function (response) {
	                if (!response.status) {
	                    return _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	                }
	
	                _this4.$scope.gridOptionsComplex.data = response.data.trajectory;
	                _this4.$scope.gridOptionsDelegation.data = response.data.delegation;
	            }, function (data) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'trajectoryDetails',
	        value: function trajectoryDetails(item) {
	            var _this5 = this;
	
	            var params = {
	                teacherId: this.userinfo.teacherId,
	                year: item.Year,
	                idHist: item.idHistActiv
	            };
	            this.perfilSrv.perfildocente.trayectoriaURDetail(params).$promise.then(function (response) {
	                if (!response.status) {
	                    _this5.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this5.$scope.graphDetails = response.data[0];
	                    _this5.showModal();
	                }
	            }, function (err) {
	                _this5.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'showModal',
	        value: function showModal() {
	            console.log('sup');
	            var confirm = this.$mdDialog.confirm({
	                controller: 'modalDetailsURtCtrl',
	                controllerAs: 'PerfilDialog',
	                template: __webpack_require__(407),
	                locals: null,
	                preserveScope: true,
	                scope: this.$scope,
	                animation: true,
	                clickOutsideToClose: true
	            });
	
	            this.$mdDialog.show(confirm);
	        }
	    }]);
	
	    return perfiltrayectoriatable;
	}();
	
	exports.default = perfiltrayectoriatable;
	
	
	perfiltrayectoriatable.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', '$mdDialog', 'i18nService'];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c61b83cbc9046dde64d741cc099b6f78.jpg";

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content style=min-height:40vh;max-height:70vh> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=PerfilDialog.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div ng-controller=perfildashController> <div class=text-center> <h3 class=\"font-bold text-azul text-center\">Información del año {{graphDetails.year}}</h3> </div> <div ng-if=graphDetails class=\"col-lg-12 custom_align_left custom_padding_sm\" ng-repeat=\"key in PerfilDialog.getKeys()\"> <div class=col-lg-6>{{PerfilDialog.getTitle(key)}}</div> <div class=col-lg-6> {{graphDetails[key]}} <span ng-if=\"key == 'rating' && graphDetails[key]\"> pts de producción</span> <span ng-if=\"key == 'pointsProvided' && graphDetails[key]\"> pts</span> <span ng-if=\"key == 'recognitionTypeGivenByUniversity' && graphDetails[key]\"> años</span> </div> </div> </div> <div class=\"text-center m-t-md m-b-md\"> <button md-ink-ripple class=\"btn btn-fw md-button md-ink-ripple btn-cancel m-l-sm\" ng-click=PerfilDialog.close()>Cancelar</button> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TrayectoriaURGraph = function () {
	  function TrayectoriaURGraph($scope, $uiGridConstants, $http, perfilSrv, $cookies, ngNotify, UserInfoConstant, $stateParams, $state) {
	    var _this = this;
	
	    _classCallCheck(this, TrayectoriaURGraph);
	
	    this.$scope = $scope;
	    this.perfilSrv = perfilSrv;
	    this.$cookies = $cookies;
	    this.ngNotify = ngNotify;
	    this.$http = $http;
	    this.$uiGridConstants = $uiGridConstants;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$scope.UserInfoConstant = UserInfoConstant;
	
	    this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	      if (details !== undefined) {
	        _this.userinfo = details.user;
	        _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	        _this.main();
	      }
	    });
	  }
	
	  _createClass(TrayectoriaURGraph, [{
	    key: 'main',
	    value: function main() {
	      var _this2 = this;
	
	      /**
	      * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	      **/
	      if (this.$stateParams.teacherId != '') {
	        this.userinfo.teacherId = this.$stateParams.teacherId;
	        this.getChartData(this.userinfo.teacherId);
	      } else {
	        this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	          if (!response.status) {
	            _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	          } else {
	            _this2.role = response.data[0];
	            if (_this2.role.types == 'TEACHER') {
	              _this2.getInfo();
	            }
	          }
	        }, function (err) {
	          _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	        });
	      }
	    }
	  }, {
	    key: 'getInfo',
	    value: function getInfo() {
	      var _this3 = this;
	
	      this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	        if (!response.status) {
	          _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	        } else {
	          _this3.userinfo.teacherId = response.data[0].idTeacher;
	          _this3.getChartData(_this3.userinfo.teacherId);
	        }
	      }, function (err) {
	        _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	      });
	    }
	  }, {
	    key: 'getChartData',
	    value: function getChartData(teacherId) {
	      var _this4 = this;
	
	      this.perfilSrv.perfildocente.TrayectoriaURGraph({ teacherId: teacherId }).$promise.then(function (response) {
	        _this4.$scope.names = response.data;
	        _this4.sigleName = _this4.$scope.names[0] || {};
	      }, function (data) {
	        _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	      });
	    }
	  }]);
	
	  return TrayectoriaURGraph;
	}();
	
	exports.default = TrayectoriaURGraph;
	
	
	TrayectoriaURGraph.$inject = ['$scope', 'uiGridConstants', '$http', 'perfilSrv', '$cookies', 'ngNotify', 'UserInfoConstant', '$stateParams', '$state'];

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var perfilformacioncontroller = function () {
	    function perfilformacioncontroller($scope, $uiGridConstants, $http, perfilSrv, ngNotify, $cookies, UserInfoConstant, moment, $stateParams, $state, $window, SERVICE_URL_CONSTANT) {
	        var _this = this;
	
	        _classCallCheck(this, perfilformacioncontroller);
	
	        this.$scope = $scope;
	        this.$uiGridConstants = $uiGridConstants;
	        this.$http = $http;
	        this.perfilSrv = perfilSrv;
	        this.ngNotify = ngNotify;
	        this.$cookies = $cookies;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.moment = moment;
	        this.$window = $window;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + "/perfil/downloadFileCV";
	        this.slick = {
	            viewData: [],
	            viewLoaded: false,
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            carouselResponsiveBreakpoints: [{
	                breakpoint: 1000,
	                settings: {
	                    slidesToShow: 1,
	                    slidesToScroll: 1
	                }
	            }, {
	                breakpoint: 1200,
	                settings: {
	                    slidesToShow: 2,
	                    slidesToScroll: 2
	                }
	            }, {
	                breakpoint: 1920,
	                settings: {
	                    slidesToShow: 3,
	                    slidesToScroll: 3
	                }
	            }, {
	                breakpoint: 3000,
	                settings: {
	                    slidesToShow: 4,
	                    slidesToScroll: 4
	                }
	            }]
	        };
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(perfilformacioncontroller, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.perfilFormacion(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        } else {
	                            _this2.$state.go('profile.perfil_dash');
	                            _this2.ngNotify.set('No se ha especificado ningún docente', 'info');
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.$state.go('profile.perfil_dash', { teacherId: this.$stateParams.teacherId });
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.perfilFormacion(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'download',
	        value: function download(item) {
	            var documentPath = item.document_url;
	            documentPath = documentPath.replace(/\//g, ',');
	            var params = {
	                rut: item.id_rut,
	                fileName: item.document_suport,
	                filePath: documentPath
	            };
	
	            this.$window.open(this.downloadFileSrv + "/" + params.rut + "/" + params.filePath + "/" + encodeURIComponent(params.fileName));
	        }
	    }, {
	        key: 'perfilFormacion',
	        value: function perfilFormacion(teacherId) {
	            var _this4 = this;
	
	            this.slick.viewLoaded = false;
	            this.perfilSrv.perfildocente.perfilFormacion({ teacherId: teacherId }).$promise.then(function (dataReturn) {
	                _this4.formation = dataReturn.data;
	                console.log(_this4.formation);
	                for (var i in _this4.formation) {
	                    var item = _this4.formation[i];
	
	                    item.end_date = item.end_date ? _this4.moment(item.end_date, 'DD-MM-YYYY').format('DD-MM-YYYY') : 'Sin especificar';
	                    item.Convalescence = item.Convalescence ? _this4.moment(item.Convalescence, 'DD-MM-YYYY').format('DD-MM-YYYY') : 'Sin especificar';
	
	                    item.hasSupportDoc = item.document_suport ? true : false;
	                    item.hasSupportUrl = item.document_url ? true : false;
	                    item.supportDocumentClass = item.hasSupportDoc && item.hasSupportUrl ? 'mdi-action-done text-verde' : 'mdi-navigation-cancel text-rojo';
	
	                    //Diferenciación tarjetas formales y no formales
	                    item.isFormal = item.type === 'Formal' ? true : false;
	                    item.status = item.status ? item.status : 'No Registra';
	                    item.badgeColorClass = item.isFormal ? 'verde' : 'gris-darker';
	                    item.badgeText = item.isFormal ? 'Estudios formales' : 'Otros estudios';
	
	                    _this4.slick.viewData.push(item);
	                }
	                _this4.slick.viewLoaded = true;
	            }, function (data) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return perfilformacioncontroller;
	}();
	
	exports.default = perfilformacioncontroller;
	
	
	perfilformacioncontroller.$inject = ['$scope', 'uiGridConstants', '$http', 'perfilSrv', 'ngNotify', '$cookies', 'UserInfoConstant', 'moment', '$stateParams', '$state', '$window', 'SERVICE_URL_CONSTANT'];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @name APP u-Planning
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @autor over.martinez@u-planner.com
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @description
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Descripcion del controlador
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @controller 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # name: Reconocimientose_incController
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # alias: Perfil
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	
	var _rec = __webpack_require__(411);
	
	var _rec2 = _interopRequireDefault(_rec);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Reconocimientose_incController = function () {
	    function Reconocimientose_incController($scope, $state, $stateParams, ngNotify, SERVICE_URL_CONSTANT, $timeout, UserInfoConstant, perfilSrv, moment, $cookies, $window) {
	        var _this = this;
	
	        _classCallCheck(this, Reconocimientose_incController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.ngNotify = ngNotify;
	        this.$stateParams = $stateParams;
	        this.perfilSrv = perfilSrv;
	        this.moment = moment;
	        this.$cookies = $cookies;
	        this.$window = $window;
	        this.userinfo = null;
	        this.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + "/perfil/downloadFileCV";
	        this.slick = {
	            viewData: [],
	            viewLoaded: false,
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            infinite: false,
	            carouselResponsiveBreakpoints: [{
	                breakpoint: 1000,
	                settings: {
	                    slidesToShow: 1,
	                    slidesToScroll: 1
	                }
	            }, {
	                breakpoint: 1400,
	                settings: {
	                    slidesToShow: 2,
	                    slidesToScroll: 2
	                }
	            }, {
	                breakpoint: 1920,
	                settings: {
	                    slidesToShow: 2,
	                    slidesToScroll: 2
	                }
	            }, {
	                breakpoint: 3000,
	                settings: {
	                    slidesToShow: 4,
	                    slidesToScroll: 4
	                }
	            }]
	        };
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(Reconocimientose_incController, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.reconocimientros(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        } else {
	                            _this2.$state.go('profile.perfil_dash');
	                            _this2.ngNotify.set('No se ha especificado ningún docente', 'info');
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.$state.go('profile.perfil_dash', { teacherId: this.$stateParams.teacherId });
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.reconocimientros(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'download',
	        value: function download(item) {
	            var documentPath = item.document_url;
	            documentPath = documentPath.replace(/\//g, ',');
	            var params = {
	                rut: item.id_rut,
	                fileName: item.document_suport,
	                filePath: documentPath
	            };
	
	            this.$window.open(this.downloadFileSrv + "/" + params.rut + "/" + params.filePath + "/" + encodeURIComponent(params.fileName));
	        }
	    }, {
	        key: 'getPDF',
	        value: function getPDF() {
	            var body = [];
	            for (var i in this.slick.viewData) {
	                body.push([{ text: this.slick.viewData[i].ack_year + ' - ' + this.slick.viewData[i].ack_acknowledgment, colSpan: 2, bold: true, alignment: 'center' }, { text: '' }]);
	                body.push(['Tipo', this.slick.viewData[i].ack_type]);
	                body.push(['Unidad', this.slick.viewData[i].academic_unit]);
	                body.push(['N° de decreto', this.slick.viewData[i].num_decret]);
	                body.push(['Fecha Ceremonia', moment(this.slick.viewData[i].date_ceremony).format('DD-MM-YYYY')]);
	                body.push([{ text: ' ', colSpan: 2 }, { text: '' }]);
	            }
	
	            var docDefinition = {
	                content: [{ text: 'Reconocimientos e incentivos', style: 'header', bold: true, alignment: 'center', fontSize: 22 }, { text: '_______________________________________________________________________________________', style: 'anotherStyle' }, {
	                    table: {
	                        widths: [150, 302],
	                        body: body
	                    }
	                }]
	            };
	
	            pdfMake.createPdf(docDefinition).download('export.pdf');
	        }
	    }, {
	        key: 'reconocimientros',
	        value: function reconocimientros(teacherId) {
	            var _this4 = this;
	
	            this.slick.viewLoaded = false;
	            this.perfilSrv.perfildocente.reconocimientoSeincentivos({ teacherId: teacherId }).$promise.then(function (response) {
	                _this4.reconocimiento = response.data;
	                for (var i in _this4.reconocimiento) {
	                    var item = _this4.reconocimiento[i];
	
	                    item.hasSupportDoc = item.document_suport ? true : false;
	                    item.hasSupportUrl = item.document_url ? true : false;
	                    item.supportDocumentClass = item.hasSupportDoc && item.hasSupportUrl ? 'mdi-action-done text-verde' : 'mdi-navigation-cancel text-rojo';
	
	                    _this4.slick.viewData.push(item);
	                }
	                _this4.slick.viewLoaded = true;
	            }, function (err) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return Reconocimientose_incController;
	}();
	
	exports.default = Reconocimientose_incController;
	
	
	Reconocimientose_incController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', 'SERVICE_URL_CONSTANT', '$timeout', 'UserInfoConstant', 'perfilSrv', 'moment', '$cookies', '$window'];

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	module.exports = {"data":[{"ack_year":2007,"ack_acknowledgment":" BECA DOCTORADO 01/10/2007 AL 30/09/2008    ","ack_acknowledgement_category":"","ack_type":"BECAS","academic_unit":"MINISTERIO DE ASUNTOS EXTERIORES Y DE COOPERACION Y AECI ","num_decret":"52483526","date_ceremony":"2007-08-01T00:05:00.000Z"},{"ack_year":2006,"ack_acknowledgment":" BECA DOCTORADO 01/10/2006 AL 30/09/2007    ","ack_acknowledgement_category":"","ack_type":"BECAS","academic_unit":"MINISTERIO DE ASUNTOS EXTERIORES Y DE COOPERACION Y AECI ","num_decret":"52483526","date_ceremony":"2006-10-01T00:05:00.000Z"}],"status":true}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var perfiltrayectoriatable = function () {
	    function perfiltrayectoriatable($scope, $uiGridConstants, $http, perfilSrv, ngNotify, UserInfoConstant, $cookies, $stateParams, $state, i18nService) {
	        var _this = this;
	
	        _classCallCheck(this, perfiltrayectoriatable);
	
	        this.$scope = $scope;
	        this.$uiGridConstants = $uiGridConstants;
	        this.$http = $http;
	        this.perfilSrv = perfilSrv;
	        this.ngNotify = ngNotify;
	        this.$cookies = $cookies;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.$scope.gridOptionsComplex = {
	            enableFiltering: true,
	            enableGridMenu: true,
	            showFooter: true,
	            rowHeight: 36,
	            columnDefs: [{ displayName: 'Institución', field: 'Institucion', width: '20%' }, { displayName: 'Cargo', field: 'Cargo', width: '15%' }, { displayName: 'Año de Inicio', field: 'AnoInicio', width: '15%' }, { displayName: 'Año de Fin', field: 'AnoFin', width: '15%' }]
	        };
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.main();
	            }
	        });
	        i18nService.setCurrentLang('es');
	    }
	
	    _createClass(perfiltrayectoriatable, [{
	        key: 'main',
	        value: function main() {
	            var _this2 = this;
	
	            /**
	            * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
	            **/
	            if (this.$stateParams.teacherId != '') {
	                this.userinfo.teacherId = this.$stateParams.teacherId;
	                this.trayectoriaprevia(this.userinfo.teacherId);
	            } else {
	                this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then(function (response) {
	                    if (!response.status) {
	                        _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                    } else {
	                        _this2.role = response.data[0];
	                        if (_this2.role.types == 'TEACHER') {
	                            _this2.getInfo();
	                        } else {
	                            _this2.$state.go('profile.perfil_dash');
	                            _this2.ngNotify.set('No se ha especificado ningún docente', 'info');
	                        }
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	                });
	            }
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.$state.go('profile.perfil_dash', { teacherId: this.$stateParams.teacherId });
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo() {
	            var _this3 = this;
	
	            this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.userinfo.teacherId = response.data[0].idTeacher;
	                    _this3.trayectoriaprevia(_this3.userinfo.teacherId);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'trayectoriaprevia',
	        value: function trayectoriaprevia(teacherId) {
	            var _this4 = this;
	
	            this.perfilSrv.perfildocente.trayectoriaprevia({ teacherId: teacherId }).$promise.then(function (dataReturn) {
	                _this4.$scope.gridOptionsComplex.data = dataReturn.data;
	            }, function (err) {
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return perfiltrayectoriatable;
	}();
	
	exports.default = perfiltrayectoriatable;
	
	
	perfiltrayectoriatable.$inject = ['$scope', 'uiGridConstants', '$http', 'perfilSrv', 'ngNotify', 'UserInfoConstant', '$cookies', '$stateParams', '$state', 'i18nService'];

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP cmmApp
	* @autor 
	* @description
	* # name controller --> homeCtrl
	* # As Controller --> home
	* brief comment controller test
	
	*/
	
	var actualizacioncontroller = function () {
		function actualizacioncontroller($scope, $uiGridConstants, $http, perfilSrv, $cookies, ngNotify, UserInfoConstant, GlobalConfig, $state, i18nService) {
			var _this = this;
	
			_classCallCheck(this, actualizacioncontroller);
	
			this.$scope = $scope;
			this.$state = $state;
			this.$uiGridConstants = $uiGridConstants;
			this.$http = $http;
			this.perfilSrv = perfilSrv;
			this.$cookies = $cookies;
			this.ngNotify = ngNotify;
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.globalConfig = GlobalConfig;
			i18nService.setCurrentLang('es');
	
			this.$scope.gridOptionsComplex = {
				enableSorting: true,
				enableFiltering: true,
				paginationPageSizes: [25, 50, 75, 100],
				paginationPageSize: 25,
				columnDefs: []
			};
	
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	
					if (_this.userinfo.role_id == _this.globalConfig.userRolesIds.teacher || _this.userinfo.role_id == _this.globalConfig.userRolesIds.reviewerUpdatePerfil || _this.userinfo.role_id == _this.globalConfig.userRolesIds.approverUpdatePerfil) {
						_this.main();
					} else {
						_this.$state.go('app.unauthorized');
					}
				}
			});
		}
	
		_createClass(actualizacioncontroller, [{
			key: 'main',
			value: function main() {
				var _this2 = this;
	
				this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
					if (!response.status) {
						_this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this2.userinfo.teacherId = response.data[0].idTeacher;
						_this2.getRecordsUpdates();
						_this2.getStates();
					}
				}, function (err) {
					_this2.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getRecordsUpdates',
			value: function getRecordsUpdates() {
				var _this3 = this;
	
				if (this.userinfo.role_id == this.globalConfig.userRolesIds.reviewerUpdatePerfil || this.userinfo.role_id == this.globalConfig.userRolesIds.approverUpdatePerfil) {
					this.getColumnsDefinition('revisorAprobador');
					var params = {
						roleId: this.userinfo.role_id,
						userId: this.userinfo.id
					};
	
					this.perfilSrv.perfildocenteByRole.actualizaciondePerfilByUserRole(params).$promise.then(function (dataReturn) {
						_this3.$scope.gridOptionsComplex.data = dataReturn.data;
					}, function (data) {
						_this3.ngNotify.set('Imposible conectar con el servicio', 'error');
					});
				} else {
					this.perfilSrv.perfildocente.ActualizaciondePerfil({ teacherId: this.userinfo.teacherId }).$promise.then(function (dataReturn) {
						_this3.getColumnsDefinition('profesor');
						_this3.$scope.gridOptionsComplex.data = dataReturn.data;
					}, function (data) {
						_this3.ngNotify.set('Imposible conectar con el servicio', 'error');
					});
				}
			}
		}, {
			key: 'getStates',
			value: function getStates() {
				var _this4 = this;
	
				var params = {
					router: this.userinfo.role_id == this.globalConfig.userRolesIds.teacher ? 'resumenDeLogPerfil' : 'resumenDeLogPerfilGral',
					teacherId: this.userinfo.role_id == this.globalConfig.userRolesIds.teacher ? this.userinfo.teacherId : undefined
				};
	
				this.perfilSrv.perfildocente.getStates(params).$promise.then(function (response) {
					if (response.status) {
						_this4.states = response.data;
					}
				}, function (err) {
					_this4.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getColumnsDefinition',
			value: function getColumnsDefinition(tipo) {
				var columms = [];
	
				if (tipo == 'revisorAprobador') {
					this.$scope.gridOptionsComplex.columnDefs = [{ displayName: 'N° de Ticket', field: 'NTicket', width: '5%' }, { displayName: 'Profesor', field: 'dsTeacher', width: '15%' }, { displayName: 'Perfil a actualizar', field: 'PerfilActualizar', width: '17%' }, { displayName: 'Tipo de actualización', field: 'TipoActualizacion', width: '10%' }, { displayName: 'Estado', field: 'Estado', width: '15%' }, { displayName: 'Fecha de solicitud', field: 'FechaSolicitud', width: '13%', cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FechaSolicitud}}</div>' }, { displayName: 'Fecha de actualización', field: 'FechaActualizacion', width: '15%' }, { displayName: 'Acciones', field: 'NTicket', width: '10%', enableFiltering: false, cellTemplate: '<div class="ui-grid-cell-contents form_sub_head_action">' + '<a ui-sref="profile.actualizacion_update({type: row.entity.idEstado,stage: row.entity.id_stage, title: row.entity.PerfilActualizar, nTicket: row.entity.NTicket, historyType: row.entity.idHistoryType, idUser: row.entity.idUser, nameUser: row.entity.dsTeacher, idTeacher: row.entity.idTeacher})">Ver Detalle</a>' + '</div>' }];
				} else {
					this.$scope.gridOptionsComplex.columnDefs = [{ displayName: 'N° de Ticket', field: 'NTicket', width: '10%' }, { displayName: 'Perfil a actualizar', field: 'PerfilActualizar', width: '20%' }, { displayName: 'Tipo de actualización', field: 'TipoActualizacion', width: '15%' }, { displayName: 'Estado', field: 'Estado', width: '15%' }, { displayName: 'Fecha de solicitud', field: 'FechaSolicitud', width: '15%', cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FechaSolicitud}}</div>' }, { displayName: 'Fecha de actualización', field: 'FechaActualizacion', width: '15%' }, { displayName: 'Acciones', field: 'NTicket', width: '10%', enableFiltering: false, cellTemplate: '<div class="ui-grid-cell-contents form_sub_head_action">' + '<a ui-sref="profile.actualizacion_update({type: row.entity.idEstado, title: row.entity.PerfilActualizar, nTicket: row.entity.NTicket, historyType: row.entity.idHistoryType, idUser: row.entity.idUser, nameUser: row.entity.dsTeacher, idTeacher: row.entity.idTeacher})">Ver Detalle</a>' + '</div>' }];
				}
			}
		}]);
	
		return actualizacioncontroller;
	}();
	
	exports.default = actualizacioncontroller;
	
	
	actualizacioncontroller.$inject = ['$scope', 'uiGridConstants', '$http', 'perfilSrv', '$cookies', 'ngNotify', 'UserInfoConstant', 'GlobalConfig', '$state', 'i18nService'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: updateDataProfileCtrl
	* # alias: updateVM
	*/
	
	var updateDataProfileCtrl = function updateDataProfileCtrl($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, moment, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT, $window, $mdDialog, GlobalSrv) {
		_classCallCheck(this, updateDataProfileCtrl);
	
		var vm = this;
	
		vm.$scope = $scope;
		vm.$state = $state;
		vm.$timeout = $timeout;
		vm.ngNotify = ngNotify;
		vm.$stateParams = $stateParams;
		vm.info = this.$stateParams;
		vm.globalConfig = GlobalConfig;
		vm.services = perfilSrv;
		vm.moment = moment;
		vm.$cookies = $cookies;
		vm.$window = $window;
		vm.userinfo = null;
		vm.$scope.UserInfoConstant = UserInfoConstant;
		vm.main = main;
		vm.getLogs = getLogs;
		vm.getDataToUpdate = getDataToUpdate;
		vm.getStagesList = getStagesList;
		vm.setStageToData = setStageToData;
		vm.getFile = getFile;
		vm.activateModal = activateModal;
		vm.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + '/perfil/downloadFile';
		vm.messageFileType = false;
		vm.messageFileSize = false;
		vm.messageFileName = false;
		vm.getFilesBitacora = getFilesBitacora;
		vm.remove = remove;
		vm.hasError = hasError;
		vm.validateForm = validateForm;
		vm.showErrorMessages = showErrorMessages;
		vm.isSaveButtonDisabled = false;
		vm.editDisabled = true;
		vm.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
			if (details !== undefined) {
				vm.userinfo = details.user;
				vm.userinfo.role_id = $cookies.get('hasRoleId');
				vm.main();
			}
		});
		vm.updateProfiles = GlobalConfig.idUpdateProfile;
		vm.isExtension = vm.updateProfiles.extension === parseInt(vm.info.historyType);
		vm.isFormation = vm.updateProfiles.perfil_formacion === parseInt(vm.info.historyType);
		vm.isTrayectoriaUr = vm.updateProfiles.trayectoria_UR === parseInt(vm.info.historyType);
		vm.isReconocimiento = vm.updateProfiles.reconocimiento === parseInt(vm.info.historyType);
		vm.isPerfil = vm.updateProfiles.docencia == parseInt(vm.info.historyType);
		vm.isTrayectoriaPrevia = vm.updateProfiles.trayectoria_previa === parseInt(vm.info.historyType);
	
		//upload methods
		vm.$scope.uploader = new FileUploader({ url: SERVICE_URL_CONSTANT.rosario + '/perfil/uploadFileRequest' });
	
		// a sync filter
		vm.$scope.uploader.filters.push({
			name: 'syncFilter',
			fn: function fn(item /*{File|FileLikeObject}*/, options) {
				console.log('syncFilter');
	
				return this.queue.length < 10;
			}
		});
	
		// an async filter
		vm.$scope.uploader.filters.push({
			name: 'asyncFilter',
			fn: function fn(item /*{File|FileLikeObject}*/, options, deferred) {
				console.log('asyncFilter');
				setTimeout(deferred.resolve, 1e3);
			}
		});
		vm.$scope.uploader.filters.push({
			name: 'typeFilter',
			fn: function fn(item) {
				console.log('typeFilter');
	
				if (/\/(pdf)$/.test(item.type)) {
					vm.messageFileType = false;
	
					return true;
				} else {
					vm.messageFileType = true;
				}
			}
		});
	
		vm.$scope.uploader.filters.push({
			name: 'sizeFilter',
			fn: function fn(item) {
				console.log('sizeFilter');
	
				if (item.size <= 3145728) {
					vm.messageFileSize = false;
	
					return true;
				} else {
					vm.messageFileSize = true;
				}
			}
		});
		vm.$scope.uploader.filters.push({
			name: 'nameFilter',
			fn: function fn(item) {
				console.log('nameFilter');
	
				if (item.name.indexOf(' ') <= 0) {
					vm.messageFileName = false;
	
					return true;
				} else {
					vm.messageFileName = true;
				}
			}
		});
		vm.$scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
			console.info('onSuccessItem', fileItem, response, status, headers);
		};
		vm.$scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
			console.info('onErrorItem', fileItem, response, status, headers);
			vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			vm.isSaveButtonDisabled = false;
		};
	
		vm.$scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
			console.info('onCompleteItem', fileItem, response, status, headers);
			vm.$state.go('profile.Actualizacion_Perfil');
			vm.ngNotify.set('Perfil actualizado exitosamente!', 'success');
			vm.isSaveButtonDisabled = false;
		};
	
		vm.$scope.uploader.onBeforeUploadItem = function (item) {
			var header = {
				userId: vm.userinfo.id
			};
	
			item.formData.push(header);
			$scope.loading = true;
		};
	
		function remove(index) {
			vm.$scope.uploader.queue[index].remove();
		}
	
		function main() {
			vm.getLogs();
			vm.getDataToUpdate();
		}
	
		function getLogs() {
			vm.services.perfildocente.getLogs({ ticketId: vm.info.nTicket }).$promise.then(function (response) {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					console.log(response.data);
					vm.logs = response.data;
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
		function getDataToUpdate() {
			vm.services.perfildocente.getDataToUpdate({ ticketId: vm.info.nTicket, teacherId: vm.info.idTeacher }).$promise.then(function (response) {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					vm.dataToUpdate = response.data[0];
					vm.nmActa = vm.dataToUpdate.numActa_pf;
					vm.dtActa = new Date(vm.dataToUpdate.dt_act_pf);
					vm.level = vm.dataToUpdate.nm_level_form_pf;
					vm.descriptionEq = vm.dataToUpdate.equivDes_pf;
					vm.identificationNumber = response.data[0].cedula;
					var fechaCumple = moment(vm.dataToUpdate.fechaCumple);
					var currentBirthdate = moment(vm.dataToUpdate.currentBirthdate);
	
					if (vm.dataToUpdate.nm_validation_type) {
						vm.dataToUpdate.nm_validation_type = vm.dataToUpdate.nm_validation_type == 1 ? 'Convalidado ante el MEN' : 'Emitidio en español o con traducción oficial';
					}
	
					vm.dataToUpdate.fechaCumple = fechaCumple.format('DD-MM-YYYY');
					vm.dataToUpdate.currentBirthdate = currentBirthdate.format('YYYY-MM-DD');
	
					vm.workflowClosed = isWorkflowClosed(vm.dataToUpdate.idEstado);
	
					if (vm.userinfo.role_id == vm.globalConfig.userRolesIds.reviewerUpdatePerfil && response.reviewStatus == vm.dataToUpdate.idEstado || vm.userinfo.role_id == vm.globalConfig.userRolesIds.approverUpdatePerfil && response.approveStatus.includes(vm.dataToUpdate.idEstado) || vm.userinfo.role_id == vm.globalConfig.userRolesIds.teacher && response.completeStatus.includes(vm.dataToUpdate.idEstado)) {
						vm.editDisabled = false;
					} else {
						vm.editDisabled = true;
					}
	
					vm.getStagesList();
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function getStagesList() {
			var params = {
				stageId: vm.dataToUpdate.idEstado,
				typeId: vm.dataToUpdate.idType,
				roleId: vm.userinfo.role_id,
				stageCurrentId: vm.dataToUpdate.idEstadoAnt
			};
	
			vm.services.listStage.getListStage(params).$promise.then(function (response) {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					vm.listStages = response.data;
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function getNotifyPendienteDeAprobacion(idRole) {
			var usersByRol = [];
			var header = { rolId: idRole };
	
			GlobalSrv.getUserByRol.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status == true) {
					usersByRol = dataReturn.data;
	
					for (var i in usersByRol) {
						getSendNotifyPendienteDeAprobacion(usersByRol[i].id_user);
					}
				} else {
					console.log('Ocurrio un error en el servicio de notificación');
				}
			}, function (dataReturn) {
				console.log(dataReturn);
			});
		}
	
		function getSendNotifyPendienteDeAprobacion(idUser) {
			var data = {
				idUser: idUser,
				dsName: 'Notificación de una solicitud de aprobación',
				dsDescription: 'Ha recibido una solicitud de aprobación y actualización para el profesor "' + vm.info.nameUser + '" por parte de la dirección académica.',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped: 0
			};
	
			GlobalSrv.sendNotification(data);
		}
	
		function getNotifyActualizacionRealizada(idRole) {
			var usersByRol = [];
			var header = { rolId: idRole };
	
			GlobalSrv.getUserByRol.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status == true) {
					usersByRol = dataReturn.data;
	
					for (var i in usersByRol) {
						getSendNotifyActualizacionRealizada(usersByRol[i].id_user);
					}
				} else {
					console.log('Ocurrio un error en el servicio de notificación');
				}
			}, function (dataReturn) {
				console.log(dataReturn);
			});
		}
	
		function getSendNotifyActualizacionRealizada(idUser) {
			var data = {
				idUser: idUser,
				dsName: 'Notificación de solicitud a actualización realizada',
				dsDescription: 'La actualización solicitada fue realizada, puede consultar la información en el sistema.',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped: 1
			};
	
			GlobalSrv.sendNotification(data);
		}
	
		function isWorkflowClosed(stage) {
			if ([10, 11, 15, 16, 20, 21].includes(stage)) return true;
	
			return false;
		}
	
		function setStageToData() {
			vm.isSaveButtonDisabled = true;
			var fileNames = [];
	
			for (var i = 0; i < vm.$scope.uploader.queue.length; i++) {
				fileNames.push(vm.$scope.uploader.queue[i].file.name);
			}
			var params = {
				stageId: vm.stage,
				currentStageId: vm.dataToUpdate.idEstado,
				idHistActiv: vm.dataToUpdate.NTicket,
				userid: vm.userinfo.id,
				description: vm.description,
				nmActa: vm.nmActa,
				dtActa: moment(vm.dtActa).format('YYYY-MM-DD'),
				level: vm.level,
				descriptionEq: vm.descriptionEq,
				fileNames: fileNames
			};
	
			var aCompletarSolicitud = false;
	
			if (vm.stage == 12 || vm.stage == 17) //Completar Solicitud
				{
					aCompletarSolicitud = true;
				}
	
			var aPendienteDeAprobacion = false;
	
			if (vm.stage == 9 || vm.stage == 14) //Pendiente de Aprobación
				{
					aPendienteDeAprobacion = true;
				}
	
			var aActualizacionRealizada = false;
	
			if (vm.stage == 10 || vm.stage == 15) //Actualización Realizada
				{
					aActualizacionRealizada = true;
				}
	
			var aSolicitudRechazada = false;
	
			if (vm.stage == 11 || vm.stage == 16) //Solicitud rechazada
				{
					aSolicitudRechazada = true;
				}
	
			vm.services.post.saveChangeStage(params).$promise.then(function (response) {
				if (response.status) {
					if (aCompletarSolicitud === true) {
						var post1 = {
							idUser: vm.info.idUser,
							dsName: 'Notificación de solicitud a completar solicitud',
							dsDescription: 'Profesor: Debe completar su solicitud de actualización de perfil. Por favor valide las observaciones registradas.',
							idNotification_delivery_type: GlobalConfig.notificationType.inbox,
							is_grouped: 0
						};
	
						vm.services.addNotificationsTransactions.add(post1).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								console.log('ok notification solicitud a completar solicitud', dataReturn);
							} else {
								console.log('Error Comunications');
							}
						}, function (data) {
							console.log(data);
						});
					}
	
					if (aPendienteDeAprobacion === true) {
						getNotifyPendienteDeAprobacion(GlobalConfig.userRolesIds.approverUpdatePerfil); //Desarrollo Humano
					}
	
					if (aActualizacionRealizada === true) {
						getNotifyActualizacionRealizada(GlobalConfig.userRolesIds.reviewerUpdatePerfil); //Dirección académica
						getSendNotifyActualizacionRealizada(vm.info.idUser); //Profesor de la solicitud
					}
	
					if (aSolicitudRechazada === true) {
						var _post = {
							idUser: vm.info.idUser,
							dsName: 'Notificación de solicitud a solicitud rechazada',
							dsDescription: 'Profesor: Su solicitud de actualización del perfil fue rechazada, verifique desde el perfil la razón del rechazo.',
							idNotification_delivery_type: GlobalConfig.notificationType.inbox,
							is_grouped: 0
						};
	
						vm.services.addNotificationsTransactions.add(_post).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								console.log('ok notification solicitud a solicitud rechazada', dataReturn);
							} else {
								console.log('Error Comunications');
							}
						}, function (data) {
							console.log(data);
						});
					}
	
					if (vm.$scope.uploader.queue.length > 0) {
						vm.logIdInsert = response.data;
						for (var i = 0; i < vm.$scope.uploader.queue.length; i++) {
							vm.$scope.uploader.queue[i].url = vm.$scope.uploader.url + '?userId=' + vm.identificationNumber + '&requestId=' + vm.dataToUpdate.NTicket + '&logId=' + vm.logIdInsert;
						}
						vm.$scope.uploader.uploadAll();
					} else {
						vm.$state.go('profile.Actualizacion_Perfil');
						vm.ngNotify.set('Perfil actualizado exitosamente!', 'success');
						vm.isSaveButtonDisabled = false;
					}
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
					vm.isSaveButtonDisabled = false;
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				vm.isSaveButtonDisabled = false;
			});
		}
	
		function getFile(logId, fileName) {
			var params = {
				requestId: vm.dataToUpdate.NTicket,
				userId: vm.identificationNumber,
				logId: logId,
				fileName: fileName
			};
	
			vm.services.getFileSrv.getFile(params).$promise.then(function (response) {
				if (response.status) {
					var file = new Buffer.from(response.data.data);
					var blob = new Blob([file]);
					var link = document.createElement('a');
	
					link.href = window.URL.createObjectURL(blob);
	
					link.download = fileName;
					link.click();
	
					return;
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				}
			});
		}
	
		function getFilesBitacora(logId) {
			vm.services.getFileBitacoraSrv.getFiles({ logId: logId }).$promise.then(function (response) {
				if (response.status) {
					vm.fileList = response.data;
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
		function activateModal(logId) {
			vm.services.getFileBitacoraSrv.getFiles({ logId: logId }).$promise.then(function (response) {
				if (response.status) {
					var filesDownload = response.data;
	
					$mdDialog.show({
						controller: ['$scope', '$mdDialog', '$state', function modalActivateWorkPlan($scope, $mdDialog, $state) {
							$scope.getFile = vm.getFile;
							$scope.files = filesDownload;
							$scope.logId = logId;
							$scope.close = function () {
								$mdDialog.hide();
							};
						}],
						template: __webpack_require__(419),
						clickOutsideToClose: false
					});
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
		function validateForm(form) {
			if (typeof form !== 'undefined') return form.$invalid;
		}
		function hasError(input) {
			if (typeof input !== 'undefined' && input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error';
			}
		}
		function showErrorMessages(input) {
			if (input) return input.$dirty || input.$touched;else return false;
		}
	};
	
	exports.default = updateDataProfileCtrl;
	
	
	updateDataProfileCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', 'moment', 'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT', '$window', '$mdDialog', 'GlobalSrv'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(415).Buffer))

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(416)
	var ieee754 = __webpack_require__(417)
	var isArray = __webpack_require__(418)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=35> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close() aria-label=cerrar> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-azul>Lista de archivos</h3> <p class=proxima></p> </div> </div> <div class=row> <div class=\"col-md-6 text-center\"> <p class=\"p-v-xs exo text-xs font-bold\">Nombre archivo</p> </div> <div class=\"col-md-6 text-center\"> <p class=\"p-v-xs exo text-xs font-bold\">Descarga</p> </div> </div> <div ng-repeat=\"file in files\" class=row> <div class=\"col-md-6 text-center\"> <p class=\"p-v-xs exo text-xs font-bold\"><span class=\"text-azul p-l proxima text-sm font-normal\">{{file.ds_name}}</span></p> </div> <div class=\"col-md-6 text-center\"> <p class=\"p-v-xs exo text-xs font-bold\"><i class=\"mdi-file-file-download text-lg m-t-sm pull-center\" ng-click=\"getFile(logId, file.ds_name)\" style=cursor:pointer></i></p> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WORKFLOW_TYPE = {
		TWO_STEP: 4, // Represents the ID or type for a two-step workflow
		ONE_STEP: 3 // Represents the ID or type for a one-step workflow
	};
	
	var workflowMaintainerCtrl = function () {
		function workflowMaintainerCtrl($scope, $state, $stateParams, ngNotify, $timeout, GlobalSrv, UserInfoConstant, perfilSrv, $mdDialog, FileUploader, SERVICE_URL_CONSTANT, $cookies, $rootScope, $interval) {
			var _this = this;
	
			_classCallCheck(this, workflowMaintainerCtrl);
	
			this.$scope = $scope;
			this.$state = $state;
			this.ngNotify = ngNotify;
			this.$timeout = $timeout;
			this.perfilSrv = perfilSrv;
			this.$mdDialog = $mdDialog;
	
			$rootScope.fullscreenClass = 'background-planning';
			this.workflows = {};
	
			this.$scope.profileForms = {
				enableRowSelection: true,
				enableRowHeaderSelection: false,
				multiSelect: false,
				modifierKeysToMultiSelect: false,
				noUnselect: true,
				enableFiltering: false,
				enableAutoResize: true,
				columnDefs: [{
					name: 'Tipo de Perfil',
					displayName: 'Tipo de Perfil',
					field: 'formName',
					width: '20%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'text-xs'
				}, {
					name: 'Estado',
					displayName: 'Estado',
					field: 'is_active',
					width: '20%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'text-xs',
					cellTemplate: '<div class="ui-grid-cell-contents">\n\t\t\t\t\t\t\t\t\t\t\t<div ng-if="row.entity.is_active===1">\n\t\t\t\t\t\t\t\t\t\t\t\t{{\'ACTIVE\' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div ng-if="row.entity.is_active!==1"> \n\t\t\t\t\t\t\t\t\t\t\t\t{{\'NOT_ACTIVE\' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>'
				}, {
					name: 'Cant. Revisores',
					displayName: 'Cant. Revisores',
					field: 'reviewerCount',
					width: '20%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'column-center text-xs',
					headerCellClass: 'column-center text-xs',
					cellTemplate: '<div class="ui-grid-cell-contents">\n\t\t\t\t\t\t\t\t\t\t\t<div ng-if="row.entity.id_workflow===4">\n\t\t\t\t\t\t\t\t\t\t\t\t{{row.entity.reviewerCount}}\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div ng-if="row.entity.id_workflow===3"> \n\t\t\t\t\t\t\t\t\t\t\t\t{{\'DOES_NOT_APLLY\' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>'
				}, {
					name: 'Cant. Aprobadores',
					displayName: 'Cant. Aprobadores',
					field: 'approverCount',
					width: '20%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'column-center text-xs',
					headerCellClass: 'column-center text-xs'
				}, {
					name: 'Acciones',
					displayName: 'Acciones',
					field: 'id_code',
					width: '20%',
					enableGridMenu: false,
					enableFiltering: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'column-center text-xs text-azul',
					headerCellClass: 'column-center ',
					cellTemplate: '<div class="ui-grid-cell-contents">\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t<button \n\t\t\t\t\t\t\t\t\t\t\tmd-ink-ripple \n\t\t\t\t\t\t\t\t\t\t\tclass="btn btn-accent sm-btn p-xs" \n\t\t\t\t\t\t\t\t\t\t\ttype="button" \n\t\t\t\t\t\t\t\t\t\t\tng-click="grid.appScope.workflowMaintainerCtrl.showModalEditWorkflow(row.entity)" \n\t\t\t\t\t\t\t\t\t\t\tstyle="padding-top: 0px; height: 20px;">Editar</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t'
				}],
				onRegisterApi: function onRegisterApi(gridApi) {
					_this.gridApi = gridApi;
					$interval(function () {
						if (_this.gridApi && _this.gridApi.core) {
							_this.gridApi.core.handleWindowResize();
						}
					}, 500);
				}
			};
	
			this.main();
		}
	
		_createClass(workflowMaintainerCtrl, [{
			key: 'main',
			value: function main() {
				var _this2 = this;
	
				this.perfilSrv.perfildocente.getUpdateFormsMaintainer().$promise.then(function (dataReturn) {
					_this2.$scope.profileForms.data = dataReturn.data.forms;
					_this2.userList = dataReturn.data.users;
				}).catch(function (error) {
					_this2.ngNotify.set('Error cargando datos iniciales del mantenedor.', 'error');
					console.error('Error in main():', error);
				});
			}
		}, {
			key: 'searchUsers',
			value: function searchUsers(text) {
				var matcher = new RegExp(text, 'i');
				var arr = [];
	
				this.userList.forEach(function (user) {
					if (user.ds_fullname.match(matcher)) {
						arr.push(user);
					}
				});
	
				return arr;
			}
		}, {
			key: 'showModalEditWorkflow',
			value: function showModalEditWorkflow(profileForm) {
				var _this3 = this;
	
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', '$state', 'ngNotify', 'profileFormLocal', 'workFlowRolesLocal', 'perfilSrvLocal', 'userListLocal', 'searchUsersFnLocal', function modalWorkflowMaintainer($scope, $mdDialog, $state, ngNotify, profileFormLocal, workFlowRolesLocal, perfilSrvLocal, userListLocal, searchUsersFnLocal) {
						var modalVM = this;
	
						modalVM.selectedForm = angular.copy(profileFormLocal); // Work with a copy
						modalVM.selectedForm.twoStepFlow = modalVM.selectedForm.id_workflow === WORKFLOW_TYPE.TWO_STEP; // Use boolean
						modalVM.selectedForm.is_active = profileForm.is_active;
						modalVM.workFlowRoles = workFlowRolesLocal;
						modalVM.userList = userListLocal;
						modalVM.selectedReviewerUser = null;
						modalVM.selectedApproverUser = null;
						modalVM.searchApproverText = '';
						modalVM.searchReviewerText = '';
						modalVM.searchUsers = searchUsersFnLocal;
	
						modalVM.reviewerUsers = [];
						modalVM.approverUsers = [];
						modalVM.loading = true;
						modalVM.saveButtonDisabled = false;
	
						perfilSrvLocal.workflows.getFormUsers({ formId: modalVM.selectedForm.id_code }).$promise.then(function (dataReturn) {
							var reviewerIds = new Set(dataReturn.data.reviewers.map(function (us) {
								return us.id_user;
							}));
							var approverIds = new Set(dataReturn.data.approvers.map(function (us) {
								return us.id_user;
							}));
	
							modalVM.reviewerUsers = modalVM.userList.filter(function (user) {
								return reviewerIds.has(user.id_code);
							});
							modalVM.approverUsers = modalVM.userList.filter(function (user) {
								return approverIds.has(user.id_code);
							});
							modalVM.loading = false;
						}).catch(function (error) {
							ngNotify.set('Error cargando usuarios asignados al formulario.', 'error');
							modalVM.loading = false;
							console.error('Error fetching form users:', error);
						});
	
						modalVM.close = function () {
							$mdDialog.hide();
						};
	
						modalVM.toggleActive = function () {
							modalVM.selectedForm.is_active = !modalVM.selectedForm.is_active;
						};
	
						modalVM.addReviewerUser = function (user) {
							if (user && !modalVM.reviewerUsers.some(function (us) {
								return us.id_code === user.id_code;
							})) {
								modalVM.reviewerUsers.push(user);
							}
	
							modalVM.selectedReviewerUser = null; // Clear autocomplete selection
							modalVM.searchReviewerText = '';
						};
	
						modalVM.dropReviewerUser = function (index) {
							modalVM.reviewerUsers.splice(index, 1);
						};
	
						modalVM.addApproverUser = function (user) {
							if (user && !modalVM.approverUsers.some(function (us) {
								return us.id_code === user.id_code;
							})) {
								modalVM.approverUsers.push(user);
							}
	
							modalVM.selectedApproverUser = null; // Clear autocomplete selection
							modalVM.searchApproverText = '';
						};
	
						modalVM.dropApproverUser = function (index) {
							modalVM.approverUsers.splice(index, 1);
						};
	
						modalVM.saveWorkflow = function () {
							if (modalVM.selectedForm.is_active) {
								if (modalVM.selectedForm.twoStepFlow && modalVM.reviewerUsers.length === 0) {
									ngNotify.set('Debe asignar al menos un revisor para el flujo de dos pasos.', 'warn');
	
									return;
								}
	
								if (modalVM.approverUsers.length === 0) {
									ngNotify.set('Debe asignar al menos un aprobador.', 'warn');
	
									return;
								}
							}
	
							modalVM.saveButtonDisabled = true;
	
							var reviewerUserIds = modalVM.reviewerUsers.map(function (user) {
								return { userId: user.id_code };
							});
							var approverUserIds = modalVM.approverUsers.map(function (user) {
								return { userId: user.id_code };
							});
	
							var workflowPayload = {
								profileFormworkFlow: modalVM.selectedForm.twoStepFlow ? WORKFLOW_TYPE.TWO_STEP : WORKFLOW_TYPE.ONE_STEP,
								twoStepFlow: modalVM.selectedForm.twoStepFlow,
								profileFormId: modalVM.selectedForm.id_code,
								active: modalVM.selectedForm.is_active,
								reviewers: modalVM.selectedForm.twoStepFlow ? reviewerUserIds : [],
								approvers: approverUserIds
							};
	
							perfilSrvLocal.workflows.setProfileUpdateWorkflow(workflowPayload).$promise.then(function (dataReturn) {
								if (dataReturn.status) {
									$state.reload(); // Consider updating grid data directly for better UX
									showModalSuccess().then(function () {
										$mdDialog.hide();
									});
								} else {
									ngNotify.set(dataReturn.message || 'No se ha podido guardar el flujo de trabajo.', 'error');
									modalVM.saveButtonDisabled = false;
								}
							}).catch(function (error) {
								ngNotify.set('Error al conectar con el servicio para guardar el flujo.', 'error');
								modalVM.saveButtonDisabled = false;
								console.error('Error saving workflow:', error);
							});
						};
	
						function showModalSuccess() {
							return $mdDialog.show({ // Return the promise
								controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
									$scope.close = function () {
										$mdDialog.hide();
									};
								}],
								template: __webpack_require__(421),
								clickOutsideToClose: false
							});
						}
					}],
					template: __webpack_require__(422),
					controllerAs: 'modalVM', // Use this in the modal's template
					clickOutsideToClose: false,
					locals: {
						profileFormLocal: profileForm,
						workFlowRolesLocal: this.workFlowRoles,
						perfilSrvLocal: this.perfilSrv,
						userListLocal: this.userList,
						searchUsersFnLocal: function searchUsersFnLocal(text) {
							return _this3.searchUsers(text);
						} // Ensure 'this' context is correct
					}
				});
			}
		}]);
	
		return workflowMaintainerCtrl;
	}();
	
	exports.default = workflowMaintainerCtrl;
	
	
	workflowMaintainerCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'GlobalSrv', 'UserInfoConstant', 'perfilSrv', '$mdDialog', 'FileUploader', 'SERVICE_URL_CONSTANT', '$cookies', '$rootScope', '$interval'];

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>{{'ASSIGNATION_SUCCESSFUL' |translate}}</h3> <p>{{'CHANGES_SAVED_SUCCESFULLY' |translate}}</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>{{'ACCEPT' | translate}}</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=modalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-azul>{{'PROFILE_WORKFLOW_EDIT' |translate}} {{modalVM.selectedForm.formName}}</h3> </div> </div> <form name=workflowForm> <div class=row> <div class=col-md-6> <div> {{'ACTIVE' | translate}} <label class=md-switch> <input type=checkbox ng-model=modalVM.selectedForm.is_active ng-true-value=1 ng-false-value=0> <i class=radio-green></i> </label> </div> </div> <div class=col-md-6> <div> {{'TWO_STEP_FLOW' | translate}} <label class=md-switch> <input type=checkbox ng-model=modalVM.selectedForm.twoStepFlow ng-true-value=true ng-false-value=false> <i class=radio-green></i> </label> </div> </div> </div> <div class=row ng-if=modalVM.loading> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=row ng-if=!modalVM.loading> <div class=col-md-6> <div class=row> <div class=\"col-md no-padding-r m-v-xs\"> <div class=\"form-group col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\">{{'REVIEWERS' | translate}}</label> <md-autocomplete ng-disabled=!modalVM.selectedForm.twoStepFlow class=\"custom-autoselect autocomplete col-md-10 no-padding\" md-item-text=users.ds_fullname md-min-length=0 md-selected-item=modalVM.selectedReviewerUser md-search-text=modalVM.searchReviewerText md-items=\"users in modalVM.searchUsers(modalVM.searchReviewerText)\" md-clear-button=false placeholder=Buscar> <md-item-template> <span md-highlight-text=modalVM.searchReviewerText md-highlight-flags=^i>{{users.ds_fullname}}</span> </md-item-template> <md-not-found> {{'USERS_WITH_NAME_NOT_FOUND' | translate}} \"{{modalVM.searchReviewerText}}\" </md-not-found> </md-autocomplete> <div class=\"col-md-2 no-padding\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=modalVM.addReviewerUser(modalVM.selectedReviewerUser)></i> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <ul class=\"without-bullets col-md-12 no-padding\"> <li ng-repeat=\"user in modalVM.reviewerUsers track by $index\" class=\"teacherList text-md\" ng-if=modalVM.selectedForm.twoStepFlow> <p class=\"text-sm no-margin\">{{user.ds_fullname}}</p> <md-button class=\"md-icon-button no-margin\" aria-label=dropUser ng-click=modalVM.dropReviewerUser($index)> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> </div> <div class=col-md-6> <div class=row> <div class=\"col-md no-padding-r m-v-xs\"> <div class=\"form-group col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\">{{'APPROVERS' | translate}}</label> <md-autocomplete class=\"custom-autoselect autocomplete col-md-10 no-padding\" md-item-text=users.ds_fullname md-min-length=0 md-selected-item=modalVM.selectedApproverUser md-search-text=modalVM.searchApproverText md-items=\"users in modalVM.searchUsers(modalVM.searchApproverText)\" md-clear-button=false placeholder=Buscar> <md-item-template> <span md-highlight-text=modalVM.searchApproverText md-highlight-flags=^i>{{users.ds_fullname}}</span> </md-item-template> <md-not-found> {{'USERS_WITH_NAME_NOT_FOUND' | translate}} \"{{modalVM.searchApproverText}}\" </md-not-found> </md-autocomplete> <div class=\"col-md-2 no-padding\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=modalVM.addApproverUser(modalVM.selectedApproverUser)></i> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <ul class=\"without-bullets col-md-12 no-padding\"> <li ng-repeat=\"user in modalVM.approverUsers track by $index\" class=\"teacherList text-md\"> <p class=\"text-sm no-margin\">{{user.ds_fullname}}</p> <md-button class=\"md-icon-button no-margin\" aria-label=dropUser ng-click=modalVM.dropApproverUser($index)> <i class=\"icon mdi-navigation-close i-18\"></i> </md-button> </li> </ul> </div> </div> </div> </div> </form> <div class=\"row text-center\"> <div class=\"col-md-12 m-t-md\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" ng-click=modalVM.close()>{{'GO_BACK' | translate}}</md-button> <md-button class=\"btn btn-fw btn-primary no-margin\" ng-click=modalVM.saveWorkflow() ng-disabled=modalVM.saveButtonDisabled has-permission=mantenedor-flujos-actualizacion-perfil-edit>{{'SAVE' | translate}}</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cvPrintController = function () {
	    function cvPrintController($scope, $uiGridConstants, $base64, $http, perfilSrv, $cookies, $window, ngNotify, UserInfoConstant, GlobalConfig, $state, SERVICE_URL_CONSTANT) {
	        var _this = this;
	
	        _classCallCheck(this, cvPrintController);
	
	        this.$scope = $scope;
	        this.$cookies = $cookies;
	        this.$window = $window;
	        this.ngNotify = ngNotify;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.idProfiles = GlobalConfig.idUpdateProfile;
	        this.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + "/perfil/downloadFileCV";
	        this.services = perfilSrv;
	        this.selectedProfilesArray = [];
	        this.arrayCheck = [];
	        this.academicPeriods = [];
	        this.documents = null;
	        this.userinfo = null;
	        this.start_date = null;
	        this.end_date = null;
	        this.minEndDate = null;
	        this.blockButton = true;
	        this.dateFilter = 0;
	        this.selectedPeriod = null;
	
	        this.body = [];
	        this.body2 = [];
	        this.body3 = [];
	        this.body4 = [];
	        this.body5 = [];
	        this.body6 = [];
	        this.body7 = [];
	        this.content = [];
	        this.tot = 0;
	        this.cant = 0;
	        this.bodyAreasOfInterest = [];
	        this.statement = [""];
	
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.userinfo.role_id = _this.$cookies.get('hasRoleId');
	                _this.userinfo.rut = JSON.parse(_this.$cookies.get('currentUser')).dsIdentification;
	                _this.loadUserData();
	            }
	        });
	
	        for (var obj in this.idProfiles) {
	
	            this.arrayCheck.push(false);
	        }
	    }
	
	    _createClass(cvPrintController, [{
	        key: "printCV",
	        value: function printCV() {
	            this.loadDocuments();
	        }
	    }, {
	        key: "checkAll",
	        value: function checkAll(checked) {
	            this.selectedProfilesArray = [];
	            for (var i in this.idProfiles) {
	                this.arrayCheck[this.idProfiles[i]] = checked;
	                if (checked) {
	                    this.selectedProfilesArray.push(this.idProfiles[i]);
	                }
	            }
	        }
	    }, {
	        key: "loadUserData",
	        value: function loadUserData() {
	            var _this2 = this;
	
	            this.services.role.getInfo({ param1: this.userinfo.id }).$promise.then(function (response) {
	                if (!response.status) {
	                    _this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this2.userinfo.teacherId = response.data[0].idTeacher;
	                    _this2.userinfo.gender = response.data[0].gender;
	                    _this2.userinfo.nacionality = response.data[0].nacionality;
	                    _this2.userinfo.fullname = response.data[0].fullname;
	                    _this2.loadPeriods();
	                }
	            }, function (err) {
	                _this2.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: "loadPeriods",
	        value: function loadPeriods() {
	            var _this3 = this;
	
	            this.services.getAcademicPeriodsSrv.getPeriods().$promise.then(function (response) {
	                if (!response.status) {
	                    _this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this3.academicPeriods = response.data;
	                    _this3.blockButton = false;
	                }
	            }, function (err) {
	                _this3.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: "loadDocuments",
	        value: function loadDocuments() {
	            var _this4 = this;
	
	            this.dateInitPost = this.start_date;
	            this.dateEndPost = this.end_date;
	            this.blockButton = true;
	
	            if (this.dateFilter == 1 && this.selectedPeriod) {
	                this.dateInitPost = JSON.parse(this.selectedPeriod).dt_start_date;
	                this.dateEndPost = JSON.parse(this.selectedPeriod).dt_end_date;
	            }
	
	            var post = {
	                teacherId: this.userinfo.teacherId,
	                historyTypes: this.selectedProfilesArray,
	                dateInit: this.dateInitPost,
	                dateEnd: this.dateEndPost
	            };
	
	            this.services.getCVDocumentsSrv.getDocs(post).$promise.then(function (response) {
	                if (!response.status) {
	                    _this4.blockButton = false;
	                    _this4.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	                    _this4.blockButton = false;
	                    _this4.documents = response.data;
	                }
	            }, function (err) {
	                _this4.blockButton = false;
	                _this4.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: "getFile",
	        value: function getFile(documentPath, documentName) {
	            documentPath = documentPath.replace(/\//g, ',');
	            this.$window.open(this.downloadFileSrv + "/" + this.userinfo.rut + "/" + documentPath + "/" + encodeURIComponent(documentName));
	        }
	    }, {
	        key: "startDateChanged",
	        value: function startDateChanged() {
	            var m = moment(this.startDate);
	            this.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : moment().toDate();
	        }
	    }, {
	        key: "changeSelectedProfile",
	        value: function changeSelectedProfile(idProfile) {
	            var idx = this.selectedProfilesArray.indexOf(idProfile);
	            if (idx > -1) {
	                this.selectedProfilesArray.splice(idx, 1);
	            } else {
	                this.selectedProfilesArray.push(idProfile);
	            }
	        }
	    }, {
	        key: "pdfMakeLive",
	        value: function pdfMakeLive() {
	
	            var fonts = {
	                Roboto: {
	                    normal: 'fonts/Roboto-Regular.ttf',
	                    bold: 'fonts/Roboto-Medium.ttf',
	                    italics: 'fonts/Roboto-Italic.ttf',
	                    bolditalics: 'fonts/Roboto-MediumItalic.ttf'
	                }
	
	                //var testImageDataUrl = require('../images/hat.png');
	
	            };this.content = [{ text: 'Hoja de vida', style: 'header', bold: true, alignment: 'center', fontSize: 22 }, { text: '_______________________________________________________________________________________________', style: 'anotherStyle' }, {
	                table: {
	                    widths: [160, 339],
	                    body: [['Nombre', this.userinfo.name], ['Nombre en citaciones', this.userinfo.fullname], ['Nacionalidad', this.userinfo.nacionality]],
	                    dontBreakRows: true
	                }
	            }];
	            if (this.statement.length > 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [510],
	                        body: [[this.statement]],
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.bodyAreasOfInterest.length > 2) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [94.5, 94.5, 94.5, 94.5, 94.5],
	                        body: this.bodyAreasOfInterest,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.body.length != 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [60, 150, 122, 60, 80],
	                        headerRows: 1,
	                        body: this.body,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.body2.length != 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [100, 40, 100, 142, 40, 40],
	                        body: this.body2,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.body3.length != 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [55, 40, 45, 45, 50, 50, 50, 50, 50],
	                        body: this.body3,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.body4.length != 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [140, 100, 40, 40, 82, 60],
	                        body: this.body4,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.body5.length != 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [162, 40, 110, 30, 80, 40],
	                        body: this.body5,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.body6.length != 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [60, 100, 100, 82, 60, 60],
	                        body: this.body6,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            if (this.body7.length != 0) {
	                this.content.push({
	                    text: '_______________________________________________________________________________________________',
	                    style: 'anotherStyle'
	                }, {
	                    table: {
	                        widths: [160, 158, 81, 81],
	                        body: this.body7,
	                        dontBreakRows: true
	                    }
	                });
	            }
	
	            var docDefinition = {
	                content: this.content
	            };
	
	            pdfMake.createPdf(docDefinition).download('export.pdf');
	        }
	    }, {
	        key: "expApproved",
	        value: function expApproved() {
	            var _this5 = this;
	
	            setTimeout(function () {
	                if (_this5.tot == _this5.cant) {
	                    _this5.pdfMakeLive();
	                } else {
	                    _this5.expApproved();
	                }
	            }, 3000);
	        }
	    }, {
	        key: "parseStatement",
	        value: function parseStatement(statement) {
	            var _this6 = this;
	
	            var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [false, false, '', 9, ''];
	
	            // args = [bold, italics, decoration, size, alignment]
	            var html = document.createElement('div');
	            html.innerHTML = statement;
	            var nodes = html.childNodes;
	            var textArray = [];
	            var returnObject = {};
	            nodes.forEach(function (node) {
	                var name = node.nodeName;
	                var modArgs = args.slice(0);
	                if (node.style && node.style.textAlign !== '') {
	                    modArgs[4] = node.style.textAlign;
	                }
	                switch (name) {
	                    case 'B':
	                        modArgs[0] = true;
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push.apply(textArray, _toConsumableArray(returnObject));
	                        break;
	                    case 'I':
	                        modArgs[1] = true;
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push.apply(textArray, _toConsumableArray(returnObject));
	                        break;
	                    case 'U':
	                        modArgs[2] = 'underline';
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push.apply(textArray, _toConsumableArray(returnObject));
	                        break;
	                    case 'UL':
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push({ ul: [].concat(_toConsumableArray(returnObject)) });
	                        break;
	                    case 'A':
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push.apply(textArray, _toConsumableArray(returnObject));
	                        break;
	                    case 'LI':
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push.apply(textArray, _toConsumableArray(returnObject));
	                        break;
	                    case 'BLOCKQUOTE':
	                        modArgs[3] = 12;
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push.apply(textArray, _toConsumableArray(returnObject));
	                        break;
	                    case 'DIV':
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        textArray.push.apply(textArray, _toConsumableArray(returnObject));
	                        break;
	                    case 'P':
	                        returnObject = _this6.parseStatement(node.innerHTML, modArgs);
	                        if (returnObject.length > 0) {
	                            textArray.push({ text: [].concat(_toConsumableArray(returnObject)) });
	                        }
	                        break;
	                    case '#text':
	                        textArray.push({ text: node.data, bold: args[0], italics: args[1], decoration: args[2], fontSize: args[3], alignment: args[4] });
	                        break;
	                }
	            });
	            return textArray;
	        }
	    }, {
	        key: "getPDF",
	        value: function getPDF() {
	            var _this7 = this;
	
	            this.bodyAreasOfInterest = [[{ text: 'Áreas de interés', style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {}], [{ text: 'Área de interés 1', fontSize: 10, bold: true }, { text: 'Área de interés 2', fontSize: 10, bold: true }, { text: 'Área de interés 3', fontSize: 10, bold: true }, { text: 'Área de interés 4', fontSize: 10, bold: true }, { text: 'Área de interés 5', fontSize: 10, bold: true }]];
	
	            this.services.perfildocente.getperfil_dash({ teacherId: this.userinfo.teacherId }).$promise.then(function (response) {
	                if (response.status) {
	                    var info = response.data;
	                    _this7.statement = _this7.parseStatement(info[0].ds_comments);
	                    for (var i = 0; i < info.length; i++) {
	                        (function (ii) {
	                            if (info[0].ds_area_interest1 !== "" || info[0].ds_area_interest2 !== "" || info[0].ds_area_interest3 !== "" || info[0].ds_area_interest4 !== "" || info[0].ds_area_interest5 !== "") {
	                                _this7.bodyAreasOfInterest.push([{ text: info[ii].ds_area_interest1, fontSize: 8 }, { text: info[ii].ds_area_interest2, fontSize: 8 }, { text: info[ii].ds_area_interest3, fontSize: 8 }, { text: info[ii].ds_area_interest4, fontSize: 8 }, { text: info[ii].ds_area_interest5, fontSize: 8 }]);
	                            }
	                        })(i);
	                    }
	                }
	            }, function (data) {
	                _this7.ngNotify.set('Imposible conectar con el servicio Perfil Docente', 'error');
	            });
	
	            for (var i in this.arrayCheck) {
	                if (this.arrayCheck[i] && i != 8) {
	                    this.cant++;
	                }
	            }
	
	            if (this.arrayCheck[1]) {
	                this.body = [[{ text: 'Perfil de Docencia', style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {}], [{ text: 'Período', fontSize: 10, bold: true }, { text: 'Asignatura', fontSize: 10, bold: true }, { text: 'Programa/Área', fontSize: 10, bold: true }, { text: 'Dedicación', fontSize: 10, bold: true }, { text: 'Nro de grupo', fontSize: 10, bold: true }]];
	
	                this.services.perfildocente.getperfildocente({ teacherId: this.userinfo.teacherId }).$promise.then(function (response) {
	                    if (response.status) {
	                        var info = response.data;
	                        for (var i = 0; i < info.length; i++) {
	                            (function (ii) {
	                                _this7.body.push([{ text: info[ii].Periodo, fontSize: 8 }, { text: info[ii].Asignatura, fontSize: 8 }, { text: info[ii].ProgramaArea, fontSize: 8 }, { text: info[ii].Dedic, fontSize: 8 }, { text: info[ii].cantGroup, fontSize: 8 }]);
	                            })(i);
	                        }
	                        _this7.tot++;
	                    }
	                }, function (data) {
	                    _this7.ngNotify.set('Imposible conectar con el servicio Perfil Docente', 'error');
	                });
	            } else {
	                this.body = [];
	            }
	
	            if (this.arrayCheck[2]) {
	                this.body2 = [[{ text: 'Perfil de Investigación', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {}, {}], [{ text: 'Tipo Publicación', fontSize: 10, bold: true }, { text: 'Año publicacion', fontSize: 10, bold: true }, { text: 'Subtipo', fontSize: 10, bold: true }, { text: 'Titulo', fontSize: 10, bold: true }, { text: 'Factor impacto', fontSize: 10, bold: true }, { text: 'N° de citaciones', fontSize: 10, bold: true }]];
	
	                this.services.perfildocente.PerfildeInvestigacion({ teacherId: this.userinfo.teacherId }).$promise.then(function (response2) {
	                    if (response2.status) {
	                        var info2 = response2.data;
	                        for (var i2 = 0; i2 < info2.length; i2++) {
	                            (function (ii2) {
	                                _this7.body2.push([{ text: info2[ii2].tipoDePublicacion, fontSize: 8 }, { text: info2[ii2].anoDePublicacion, fontSize: 8 }, { text: info2[ii2].subTipo, fontSize: 8 }, { text: info2[ii2].titulo, fontSize: 8 }, { text: info2[ii2].factorDeImpacto, fontSize: 8 }, { text: info2[ii2].nDeCitaciones, fontSize: 8 }]);
	                            })(i2);
	                        }
	                        _this7.tot++;
	                    }
	                }, function (data) {
	                    _this7.ngNotify.set('Imposible conectar con el servicio Perfil Invetigación', 'error');
	                });
	            } else {
	                this.body2 = [];
	            }
	
	            if (this.arrayCheck[3]) {
	                this.body3 = [[{ text: 'Perfil de Extensión', style: 'tableHeader', colSpan: 9, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {}, {}, {}, {}, {}], [{ text: 'Campo/Descripción', fontSize: 10, bold: true }, { text: 'Servicio', fontSize: 10, bold: true }, { text: 'Titulo', fontSize: 10, bold: true }, { text: 'Objeto', fontSize: 10, bold: true }, { text: 'Mes/Año Inicio', fontSize: 10, bold: true }, { text: 'Mes/Año Fin', fontSize: 10, bold: true }, { text: 'Tipo Entidad', fontSize: 10, bold: true }, { text: 'Ent. Contratante', fontSize: 10, bold: true }, { text: 'Resultados', fontSize: 10, bold: true }]];
	
	                this.services.perfildocente.perfilextention({ teacherId: this.userinfo.teacherId }).$promise.then(function (response3) {
	                    if (response3.status) {
	                        var info3 = response3.data;
	                        for (var i3 = 0; i3 < info3.length; i3++) {
	                            (function (ii3) {
	                                console.log(info3[ii3]);
	                                _this7.body3.push([{ text: info3[ii3].campoDescripcion, fontSize: 8 }, { text: info3[ii3].servico, fontSize: 8 }, { text: info3[ii3].aTitulo, fontSize: 8 }, { text: info3[ii3].objeto, fontSize: 8 }, { text: info3[ii3].mesAnoInicio, fontSize: 8 }, { text: info3[ii3].mesAnoFinalizacion, fontSize: 8 }, { text: info3[ii3].tipoDeEntidad, fontSize: 8 }, { text: info3[ii3].entContratante, fontSize: 8 }, { text: info3[ii3].resultados, fontSize: 8 }]);
	                            })(i3);
	                        }
	                        _this7.tot++;
	                    }
	                }, function (data) {
	                    _this7.ngNotify.set('Imposible conectar con el servicio Perfil Invetigación', 'error');
	                });
	            } else {
	                this.body3 = [];
	            }
	
	            if (this.arrayCheck[4]) {
	                this.body4 = [[{ text: 'Perfil de Trayectoria UR', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {}, {}], [{ text: 'Cargo', fontSize: 10, bold: true }, { text: 'Rol', fontSize: 10, bold: true }, { text: 'Año Inicio', fontSize: 10, bold: true }, { text: 'Año Fin', fontSize: 10, bold: true }, { text: 'Unidad', fontSize: 10, bold: true }, { text: 'Dedicación', fontSize: 10, bold: true }]];
	
	                this.services.perfildocente.trayectoriaUR({ teacherId: this.userinfo.teacherId }).$promise.then(function (response4) {
	                    if (response4.status) {
	                        var info4 = response4.data;
	                        for (var i4 = 0; i4 < info4.length; i4++) {
	                            (function (ii4) {
	                                _this7.body4.push([{ text: info4[ii4].Cargo, fontSize: 8 }, { text: info4[ii4].dsRol, fontSize: 8 }, { text: info4[ii4].dtInit, fontSize: 8 }, { text: info4[ii4].dtEnd, fontSize: 8 }, { text: info4[ii4].dsUnidad, fontSize: 8 }, { text: info4[ii4].Dedicacion, fontSize: 8 }]);
	                            })(i4);
	                        }
	                        _this7.tot++;
	                    }
	                }, function (data) {
	                    _this7.ngNotify.set('Imposible conectar con el servicio Perfil Trayectoria UR', 'error');
	                });
	            } else {
	                this.body4 = [];
	            }
	
	            if (this.arrayCheck[7]) {
	                this.body5 = [[{ text: 'Perfil de Formación', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {}, {}], [{ text: 'Programa', fontSize: 10, bold: true }, { text: 'Estudio', fontSize: 10, bold: true }, { text: 'Universidad', fontSize: 10, bold: true }, { text: 'Año Grado', fontSize: 10, bold: true }, { text: 'Ciudad/País', fontSize: 10, bold: true }, { text: 'Estado', fontSize: 10, bold: true }]];
	
	                this.services.perfildocente.perfilFormacion({ teacherId: this.userinfo.teacherId }).$promise.then(function (response5) {
	                    if (response5.status) {
	                        var info5 = response5.data;
	                        for (var i5 = 0; i5 < info5.length; i5++) {
	                            (function (ii5) {
	                                _this7.body5.push([{ text: info5[ii5].program_name, fontSize: 8 }, { text: info5[ii5].type, fontSize: 8 }, { text: info5[ii5].university, fontSize: 8 }, { text: info5[ii5].grade_date, fontSize: 8 }, { text: info5[ii5].city, fontSize: 8 }, { text: info5[ii5].state, fontSize: 8 }]);
	                            })(i5);
	                        }
	                        _this7.tot++;
	                    }
	                }, function (data) {
	                    _this7.ngNotify.set('Imposible conectar con el servicio Perfil Formación', 'error');
	                });
	            } else {
	                this.body5 = [];
	            }
	
	            if (this.arrayCheck[5]) {
	                this.body6 = [[{ text: 'Perfil de Reconocimiento e Incentivos', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {}, {}], [{ text: 'Año', fontSize: 10, bold: true }, { text: 'Destaco', fontSize: 10, bold: true }, { text: 'Unidad', fontSize: 10, bold: true }, { text: 'Tipo Distinción', fontSize: 10, bold: true }, { text: 'Nro Decreto', fontSize: 10, bold: true }, { text: 'Fecha Ceremonia', fontSize: 10, bold: true }]];
	
	                this.services.perfildocente.reconocimientoSeincentivos({ teacherId: this.userinfo.teacherId }).$promise.then(function (response6) {
	                    if (response6.status) {
	                        var info6 = response6.data;
	                        for (var i6 = 0; i6 < info6.length; i6++) {
	                            (function (ii6) {
	                                _this7.body6.push([{ text: info6[ii6].ack_year, fontSize: 8 }, { text: info6[ii6].ack_acknowledgment, fontSize: 8 }, { text: info6[ii6].academic_unit, fontSize: 8 }, { text: info6[ii6].ack_type, fontSize: 8 }, { text: info6[ii6].num_decret, fontSize: 8 }, { text: info6[ii6].date_ceremony, fontSize: 8 }]);
	                            })(i6);
	                        }
	                        _this7.tot++;
	                    }
	                }, function (data) {
	                    _this7.ngNotify.set('Imposible conectar con el servicio Perfil Reconocimiento e Incentivos', 'error');
	                });
	            } else {
	                this.body6 = [];
	            }
	
	            if (this.arrayCheck[6]) {
	                this.body7 = [[{ text: 'Trayectoria Previa', style: 'tableHeader', colSpan: 4, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}], [{ text: 'Institución', fontSize: 10, bold: true }, { text: 'Cargo', fontSize: 10, bold: true }, { text: 'Año Inicio', fontSize: 10, bold: true }, { text: 'Año Fin', fontSize: 10, bold: true }]];
	
	                this.services.perfildocente.trayectoriaprevia({ teacherId: this.userinfo.teacherId }).$promise.then(function (response7) {
	                    if (response7.status) {
	                        var info7 = response7.data;
	                        for (var i7 = 0; i7 < info7.length; i7++) {
	                            (function (ii7) {
	                                _this7.body7.push([{ text: info7[ii7].Institucion, fontSize: 8 }, { text: info7[ii7].Cargo, fontSize: 8 }, { text: info7[ii7].AnoInicio, fontSize: 8 }, { text: info7[ii7].AnoFin, fontSize: 8 }]);
	                            })(i7);
	                        }
	                        _this7.tot++;
	                    }
	                }, function (data) {
	                    _this7.ngNotify.set('Imposible conectar con el servicio Trayectoria Previa', 'error');
	                });
	            } else {
	                this.body7 = [];
	            }
	
	            this.expApproved();
	        }
	    }]);
	
	    return cvPrintController;
	}();
	
	exports.default = cvPrintController;
	
	cvPrintController.$inject = ['$scope', 'uiGridConstants', '$base64', '$http', 'perfilSrv', '$cookies', '$window', 'ngNotify', 'UserInfoConstant', 'GlobalConfig', '$state', 'SERVICE_URL_CONSTANT'];

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: newRequestCtrl
	* # alias: newReq
	*/
	
	var newRequestCtrl = function newRequestCtrl($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, moment, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT, GlobalSrv) {
		_classCallCheck(this, newRequestCtrl);
	
		var vm = this;
	
		vm.$scope = $scope;
		vm.$state = $state;
		vm.$timeout = $timeout;
		vm.ngNotify = ngNotify;
		vm.$stateParams = $stateParams;
		vm.services = perfilSrv;
		vm.$cookies = $cookies;
		vm.moment = moment;
		vm.globalConfig = GlobalConfig;
		vm.userinfo = null;
		vm.$scope.show = 0;
		vm.typeUpdate = '';
		vm.registersToUpdate = [];
		vm.currentDate = new Date();
		vm.maxStartDate = moment(vm.currentDate).subtract(1, 'days').toDate();
		vm.messageFileType = false;
		vm.messageFileSize = false;
		vm.messageFileName = false;
		vm.onlyRoles = [];
		vm.academicsUnitAndRoles = [];
		vm.exists = exists;
		vm.rolesUnits = rolesUnits;
		vm.unitsCombo = [];
		vm.arrayUnit = [];
		vm.$scope.personalDataAvaliable = false;
		vm.personalForm = {};
		vm.typesOfFilesList = [];
		vm.scopeOfTitleList = [];
		vm.trajectoryTypeList = [];
		vm.idRoles = GlobalConfig.roleAcUnitMapping;
	
		var min = new Date();
	
		vm.urlService = null;
		vm.isFileUploadFinish = false;
		vm.auxServices = {
			2: vm.services.perfildocente.PerfildeInvestigacion,
			3: vm.services.perfildocente.perfilextention,
			4: vm.services.perfildocente.perfilFormacion,
			5: vm.services.perfildocente.TrayectoriaURGraph,
			6: vm.services.perfildocente.reconocimientoSeincentivos,
			7: vm.services.perfildocente.trayectoriaprevia
		};
		vm.serviceSave = {
			1: vm.services.post.savePersonalData,
			2: vm.services.post.saveInvestigationData,
			3: vm.services.post.saveExtensionData,
			4: vm.services.post.saveFormationData,
			5: vm.services.post.saveTrajectoryData,
			6: vm.services.post.saveRecognitionData,
			7: vm.services.post.savePrevTrajectoryData
	
		};
		vm.countriesAndCities = [];
		min = min.setFullYear(min.getFullYear() - 100);
		this.perfilTypes = {
			2: { type: '300', subType: '301' },
			3: { type: '205', indep: ['206'] },
			4: { type: '302', subType: '303' },
			5: { type: '309', subType: '310' },
			6: { type: '307', indep: ['308'] },
			7: { type: '322' }
		};
		vm.forms = {
			1: {
				idHistActiv: null,
				name: null,
				cedula: null,
				address: '',
				phone: '',
				mail: '',
				mail_alt: '',
				nacionality: '',
				birthday: null,
				maxDate: vm.currentDate,
				minDate: min,
				url_file: ''
			},
			2: {
				idHistActiv: null
			},
			3: {
				idHistActiv: null,
				myInit: vm.maxStartDate,
				myEnd: vm.currentDate,
				value: null
			},
			4: {
				idHistActiv: null,
				idTypTrayectory: null,
				idLevel: null,
				dsInstitution: null,
				title: null,
				dtActa: null,
				dtGrade: vm.currentDate,
				city: null,
				country: null,
				nmActa: null,
				level: null,
				descriptionEq: null,
				scopeOfTitle: null,
				isMen: null,
				isIssuedInSpanish: null
			},
			5: {
				idHistActiv: null,
				idUnidad: null,
				idRol: null,
				dtInit: vm.currentDate,
				dtEnd: vm.currentDate,
				descriptionEq: null
			},
			6: {
				idHistActiv: null,
				dtActa: vm.currentDate,
				valueInc: null,
				context: 2
			},
			7: {
				idHistActiv: null,
				inst: null,
				charge: null,
				trajectoryType: null,
				dtInit: vm.currentDate,
				dtEnd: vm.currentDate
			}
		};
	
		vm.id_wkf = {
			1: '3', // Datos personales
			2: '4', // Investigacion
			3: '4', // Extension
			4: '4', // Formacion
			5: '3', // Trayectoria UR
			6: '3', // Reconocimientos e Inc
			7: '3' //Trayectoria previa
	
		};
		vm.formId = {
			1: '1',
			2: '2',
			3: '3',
			4: '5',
			5: '6',
			6: '7',
			7: '4'
	
		};
		vm.typeRequest = [{ id_code: 1, ds_type: 'Nuevo' }, { id_code: 2, ds_type: 'Existente' }];
		vm.$scope.UserInfoConstant = UserInfoConstant;
		perfilSrv.perfildocente.getUpdateForms().$promise.then(function (dataReturn) {
			vm.avaliableForms = dataReturn.data;
			for (var form in vm.avaliableForms) {
				vm.avaliableForms[form].value = false;
			}
	
			vm.avaliableForms[6].value = true;
		});
		vm.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
			if (details !== undefined) {
				vm.userinfo = details.user;
				vm.userinfo.role_id = vm.$cookies.get('hasRoleId');
				vm.main();
			}
		});
	
		//methods
		vm.saveRequest = saveRequest;
		vm.onChangeAcademicUnit = onChangeAcademicUnit;
		vm.perfilToUpdate = perfilToUpdate;
		vm.setRegArray = setRegArray;
		vm.onChangeReg = onChangeReg;
		vm.onChangeUpdateType = onChangeUpdateType;
		vm.searchInstitution = searchInstitution;
		vm.getTypePub = getTypePub;
		vm.getDataForType = getDataForType;
		vm.validateForm = validateForm;
		vm.startDateChange = startDateChange;
		vm.onChangeSelected = onChangeSelected;
		vm.getService = getService;
		vm.getCountriesAndCities = getCountriesAndCities;
		vm.onChangeCountry = onChangeCountry;
		vm.searchCities = searchCities;
		vm.searchCountries = searchCountries;
		vm.setForm = setForm;
		vm.getIdFromSelected = getIdFromSelected;
		vm.cleanForms = cleanForms;
		vm.main = main;
		vm.remove = remove;
		vm.cleanValidation = cleanValidation;
		vm.listData = listData;
		vm.restartForms = restartForms;
	
		//upload methods
		vm.$scope.uploader = new FileUploader({ url: SERVICE_URL_CONSTANT.rosario + '/perfil/uploadFileRequest' });
	
		// a sync filter
		vm.$scope.uploader.filters.push({
			name: 'syncFilter',
			fn: function fn(item /*{File|FileLikeObject}*/, options) {
				return this.queue.length < 10;
			}
		});
	
		// an async filter
		vm.$scope.uploader.filters.push({
			name: 'asyncFilter',
			fn: function fn(item /*{File|FileLikeObject}*/, options, deferred) {
				setTimeout(deferred.resolve, 1e3);
			}
		});
		vm.$scope.uploader.filters.push({
			name: 'typeFilter',
			fn: function fn(item) {
				if (/\/(pdf)$/.test(item.type)) {
					vm.messageFileType = false;
	
					return true;
				} else {
					vm.messageFileType = true;
				}
			}
		});
	
		vm.$scope.uploader.filters.push({
			name: 'sizeFilter',
			fn: function fn(item) {
				if (item.size <= 3145728) {
					vm.messageFileSize = false;
	
					return true;
				} else {
					vm.messageFileSize = true;
				}
			}
		});
		vm.$scope.uploader.filters.push({
			name: 'nameFilter',
			fn: function fn(item) {
				if (item.name.indexOf(' ') <= 0) {
					vm.messageFileName = false;
	
					return true;
				} else {
					vm.messageFileName = true;
				}
			}
		});
		vm.$scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
			console.info('onSuccessItem', fileItem, response, status, headers);
		};
		vm.$scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
			console.info('onErrorItem', fileItem, response, status, headers);
			vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
		};
	
		vm.$scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
			console.info('onCompleteItem', fileItem, response, status, headers);
		};
	
		vm.$scope.uploader.onBeforeUploadItem = function (item) {
			var header = {
				userId: vm.userinfo.id
			};
	
			item.formData.push(header);
			$scope.loading = true;
		};
		vm.$scope.uploader.onCompleteAll = function () {
			vm.$state.go('profile.Actualizacion_Perfil');
			vm.ngNotify.set('Perfil actualizado exitosamente!', 'success');
		};
	
		function remove(index) {
			vm.$scope.uploader.queue[index].remove();
		}
		function main() {
			var _this = this;
	
			vm.services.perfildocente.getperfil_dash({ teacherId: vm.userinfo.teacherId }).$promise.then(function (response) {
				if (!response.status) {
					_this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					var dataReturn = response.data[0];
	
					vm.personalForm.name = dataReturn.name;
					vm.personalForm.cedula = dataReturn.identification_number;
					vm.personalForm.address = dataReturn.address;
					vm.personalForm.phone = dataReturn.phone_number;
					vm.personalForm.mail = dataReturn.company_email;
					vm.personalForm.mail_alt = dataReturn.altern_email;
					vm.personalForm.nacionality = dataReturn.nationality;
					vm.personalForm.birthday = new Date(dataReturn.birth_date);
					vm.forms[1].name = vm.personalForm.name;
					vm.forms[1].cedula = vm.personalForm.cedula;
					vm.forms[1].address = vm.personalForm.address;
					vm.forms[1].phone = vm.personalForm.phone;
					vm.forms[1].mail = vm.personalForm.mail;
					vm.forms[1].mail_alt = vm.personalForm.mail_alt;
					vm.forms[1].nacionality = vm.personalForm.nacionality;
					vm.forms[1].birthday = vm.personalForm.birthday;
				}
	
				vm.$scope.personalDataAvaliable = true;
			});
	
			//INICIALIZADO EN EL FORMULARIO 4
			vm.perfilToUpdate(4);
	
			vm.services.getInstitutionsSrv.getInstitutions().$promise.then(function (response) {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					vm.institutions = response.data;
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
			vm.services.role.getInfo({ param1: vm.userinfo.id }).$promise.then(function (response) {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					vm.userinfo.teacherId = response.data[0].idTeacher;
					vm.services.perfildocente.getperfil_dash({ teacherId: vm.userinfo.teacherId }).$promise.then(function (response) {
						if (!response.status) {
							vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
						} else {
							vm.identificationNumber = response.data[0].identification_number;
						}
					}, function (err) {
						vm.ngNotify.set('Imposible conectar con el servicio', 'error');
					});
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function searchInstitution(institutionTerm) {
			var matcher = new RegExp(institutionTerm, 'gi');
			var arr = [];
	
			vm.institutions.forEach(function (institution) {
				if (institution['name'].match(matcher)) {
					arr.push(institution);
				}
			});
	
			return arr;
		}
	
		function searchCountries(countryTerm) {
			var matcher = new RegExp(countryTerm, 'gi');
			var arr = [];
	
			vm.countriesAndCities.forEach(function (country) {
				if (country['ds_pais'].match(matcher)) {
					arr.push(country);
				}
			});
	
			return arr;
		}
	
		function searchCities(cityTerm) {
			var matcher = new RegExp(cityTerm, 'gi');
			var arr = [];
	
			vm.cities.forEach(function (city) {
				if (city['ds_ciudad'].match(matcher)) {
					arr.push(city);
				}
			});
	
			return arr;
		}
	
		function getDataForType(typeId, callback) {
			return vm.services.list.getListItems({ param1: typeId }).$promise.then(function (response) {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					callback(response.data);
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function getTypePub(param, callback) {
			return this.services.list.getListItems({ param1: param }).$promise.then(function (response) {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					callback(response.data);
				}
			}, function (err) {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function onChangeUpdateType(type) {
			if (type == 2 && vm.$scope.show != 0) {
				vm.perfilToUpdate(vm.$scope.show);
	
				if (this.$scope.show == 1) {
					vm.forms[1].address = vm.personalForm.address;
					vm.forms[1].phone = vm.personalForm.phone;
					vm.forms[1].mail = vm.personalForm.mail;
					vm.forms[1].mail_alt = vm.personalForm.mail_alt;
					vm.forms[1].nacionality = vm.personalForm.nacionality;
					vm.forms[1].birthday = vm.personalForm.birthday;
				}
			}
	
			if (type == 1 && vm.$scope.show != 0) {
				vm.cleanForms();
	
				if (this.$scope.show == 1) {
					vm.forms[1].name = vm.personalForm.name;
					vm.forms[1].cedula = vm.personalForm.cedula;
					vm.forms[1].birthday = vm.personalForm.birthday;
				} else if (this.$scope.show == 6) {
					this.restartForms(6);
				}
			}
		}
	
		function onChangeReg(item) {
			if (item !== undefined) {
				for (var i in item.original) {
					var val = item.original[i] != null ? item.original[i].toString() : item.original[i];
	
					vm.forms[vm.$scope.show][i] = val != null && val.match(/00Z/g) ? new Date(val.substring(0, 19)) : val;
				}
				this.setForm();
			} else {
				vm.cleanForms();
			}
	
			vm.forms[vm.$scope.show].url_file = '';
		}
	
		function setForm() {
			if (vm.$scope.show == 2) {
				vm.forms[vm.$scope.show].nmPublishYear = +vm.forms[vm.$scope.show].anoDePublicacion;
				vm.forms[vm.$scope.show].title = vm.forms[vm.$scope.show].titulo;
				vm.forms[vm.$scope.show].idPublishType = vm.getIdFromSelected(vm.forms[vm.$scope.show].tipoDePublicacion, 'listItemName', 'idListItem', vm.comboBoxTypePub);
				vm.forms[vm.$scope.show].idPublishSubType = vm.getIdFromSelected(vm.forms[vm.$scope.show].subTipo, 'listItemName', 'idListItem', vm.comboBoxSubTypePub);
			}
	
			if (vm.$scope.show == 3) {
				vm.forms[vm.$scope.show].service = vm.forms[vm.$scope.show].servico;
				vm.forms[vm.$scope.show].totitle = vm.forms[vm.$scope.show].aTitulo;
				vm.forms[vm.$scope.show].myInit = vm.forms[vm.$scope.show].mesAnoInicio;
				vm.forms[vm.$scope.show].myEnd = vm.forms[vm.$scope.show].mesAnoFinalizacion;
				vm.forms[vm.$scope.show].nameEntity = vm.forms[vm.$scope.show].entContratante;
				vm.forms[vm.$scope.show].result = vm.forms[vm.$scope.show].resultados;
				vm.forms[vm.$scope.show].scope = '';
				vm.forms[vm.$scope.show].typeEntity = vm.getIdFromSelected(vm.forms[vm.$scope.show].tipoDeEntidad, 'listItemName', 'idListItem', vm.comboBoxTypeInde);
			}
	
			if (vm.$scope.show == 4) {
				vm.forms[vm.$scope.show].idTypTrayectory = vm.getIdFromSelected(vm.forms[vm.$scope.show].type, 'listItemName', 'idListItem', vm.comboBoxTypePub);
				vm.onChangeSelected(vm.$scope.show, vm.forms[vm.$scope.show].idTypTrayectory, function () {
					vm.forms[vm.$scope.show].idLevel = vm.getIdFromSelected(vm.forms[vm.$scope.show].ds_formation_level, 'listItemName', 'idListItem', vm.comboBoxSubTypePub);
				});
				vm.forms[vm.$scope.show].dsInstitution = vm.forms[vm.$scope.show].university;
				vm.forms[vm.$scope.show].title = vm.forms[vm.$scope.show].program_name;
				vm.forms[vm.$scope.show].dtGrade = vm.forms[vm.$scope.show].end_date ? new Date(vm.forms[vm.$scope.show].end_date) : null;
				vm.forms[vm.$scope.show].isMen = vm.forms[vm.$scope.show].isMen ? true : false;
				vm.forms[vm.$scope.show].isIssuedInSpanish = vm.forms[vm.$scope.show].isIssuedInSpanish ? true : false;
				vm.forms[vm.$scope.show].scopeOfTitle = vm.getIdFromSelected(vm.forms[vm.$scope.show].scopeOfTitle, 'listItemName', 'idListItem', vm.scopeOfTitleList);
			}
	
			if (vm.$scope.show == 5) {
				vm.forms[vm.$scope.show].idUnidad = vm.getIdFromSelected(vm.forms[vm.$scope.show].dsUnidad, 'academitUnitName', 'academitUnitId', vm.arrayUnit);
				vm.rolesUnits(vm.forms[vm.$scope.show].idUnidad, function () {
					vm.forms[vm.$scope.show].idRol = vm.getIdFromSelected(vm.forms[vm.$scope.show].dsRol, 'roleName', 'roleId', vm.rolesCombo);
				});
				vm.forms[vm.$scope.show].dtInit = vm.forms[vm.$scope.show].dtInitAll;
				vm.forms[vm.$scope.show].dtEnd = vm.forms[vm.$scope.show].dtEndAll;
				vm.forms[vm.$scope.show].descriptionEq = vm.forms[vm.$scope.show].designation;
			}
	
			if (vm.$scope.show == 6) {
				vm.forms[vm.$scope.show].typeRI = vm.getIdFromSelected(vm.forms[vm.$scope.show].ack_type, 'listItemName', 'idListItem', vm.comboBoxTypePub);
				vm.forms[vm.$scope.show].dtActa = vm.forms[vm.$scope.show].date_ceremony ? new Date(vm.forms[vm.$scope.show].date_ceremony) : null;
				vm.forms[vm.$scope.show].name = vm.forms[vm.$scope.show].ack_acknowledgment;
				vm.forms[vm.$scope.show].description = vm.forms[vm.$scope.show].academic_unit;
				vm.forms[vm.$scope.show].scope = vm.getIdFromSelected(vm.forms[vm.$scope.show].ambit, 'listItemName', 'idListItem', vm.comboBoxTypeInde);
			}
	
			if (vm.$scope.show == 7) {
				vm.forms[vm.$scope.show].inst = vm.forms[vm.$scope.show].Institucion;
				vm.forms[vm.$scope.show].dtInit = vm.forms[vm.$scope.show].AnoInicio ? moment(vm.forms[vm.$scope.show].AnoInicio, "DD/MM/YYYY").toDate() : '';
				vm.forms[vm.$scope.show].dtEnd = vm.forms[vm.$scope.show].AnoFin ? moment(vm.forms[vm.$scope.show].AnoFin, "DD/MM/YYYY").toDate() : '';
				vm.forms[vm.$scope.show].charge = vm.forms[vm.$scope.show].Cargo;
				vm.forms[vm.$scope.show].trajectoryType = vm.getIdFromSelected(vm.forms[vm.$scope.show].type, 'listItemName', 'idListItem', vm.comboBoxTypePub);
			}
		}
	
		function cleanForms() {
			for (var x in vm.forms[vm.$scope.show]) {
				vm.forms[vm.$scope.show][x] = null;
			}
		}
	
		function getIdFromSelected(find, field, toReturn, data) {
			var val = '';
			var toFind = '';
	
			if (find != null) {
				for (var i in data) {
					val = data[i][field].toLowerCase().replace(/í/gi, 'i').replace(/ó/gi, 'o');
					toFind = find.toLowerCase().replace(/í/gi, 'i').replace(/ó/gi, 'o');
	
					if (val == toFind) {
						return data[i][toReturn].toString();
					}
				}
			}
		}
	
		function setRegArray(data) {
			vm.registersToUpdate = [];
	
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = data.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _step$value = _slicedToArray(_step.value, 2),
					    index = _step$value[0],
					    item = _step$value[1];
	
					vm.registersToUpdate.push({
						id_code: index,
						ds_name: item.designation || item.Titulo || item.title || item.university || item.ack_acknowledgment || item.campoDescripcion || item.tipoDePublicacion || item.Cargo,
						ds_descrip: item.Unidad || item.Subtipo || item.subtipo || item.descripction || item.program_name || item.ack_acknowledgement_category || item.objeto || item.subtipo || item.Institucion,
						original: item
					});
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	
		function onChangeSelected(perfilId, idType, callback) {
			var _this2 = this;
	
			var params = { param1: this.perfilTypes[perfilId].subType, param2: idType };
	
			this.comboBoxSubTypePub = [];
			var service = this.getService();
	
			service(params).$promise.then(function (response) {
				if (!response.status) {
					_this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					_this2.comboBoxSubTypePub = response.data;
	
					if (typeof callback != 'undefined') {
						callback();
					}
				}
			}, function (err) {
				_this2.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function getService() {
			if (vm.$scope.show == 4 || vm.$scope.show == 2) return this.services.list.getListItemsSubtype;
		}
	
		function startDateChange(form) {
			var fieldInit = form == 3 ? 'myInit' : 'dtInit';
			var fieldFinal = form == 3 ? 'myEnd' : 'dtEnd';
			var mInit = moment(vm.forms[form][fieldInit]);
			var mEnd = moment(vm.forms[form][fieldFinal]);
	
			if (mInit.isAfter(mEnd) || mInit.isSame(mEnd)) {
				vm.forms[form][fieldInit] = mEnd.isValid() ? mEnd.subtract(1, 'days').toDate() : null;
			}
		}
	
		function validateForm(form) {
			// validata que almenos uno de las opciones de alcance de emisión de titulo este seleccionada
			if (vm.forms['4'].scopeOfTitle == 1069 && vm.forms['4'].isMen == 0 && vm.forms['4'].isIssuedInSpanish == 0) {
				return true;
			}
	
			return form.$invalid;
		}
	
		function exists(field, value, array) {
			for (var index in array) {
				if (array[index][field] == value) {
					return true;
				}
			}
	
			return false;
		}
	
		function rolesUnits(value, callback) {
			vm.rolesCombo = [];
			for (var index in vm.unitsAndRolesCombo) {
				if (vm.unitsAndRolesCombo[index].academitUnitId == value) {
					var temp = {
						roleId: vm.unitsAndRolesCombo[index].roleId,
						roleName: vm.unitsAndRolesCombo[index].roleName
					};
	
					vm.rolesCombo.push(temp);
				}
			}
	
			if (typeof callback != 'undefined') {
				callback();
			}
		}
	
		function listData() {
			if (vm.typesOfFilesList.length && vm.scopeOfTitleList.length) return;
	
			vm.getDataForType(323, function (response) {
				vm.typesOfFilesList = response;
			});
			vm.getDataForType(308, function (response) {
				vm.scopeOfTitleList = response;
			});
		}
	
		function restartForms(id) {
			if (id == 6) {
				vm.forms[6].context = 2;
				vm.forms[6].dtActa = vm.currentDate;
			}
		}
	
		function perfilToUpdate(id) {
			var _this3 = this;
	
			vm.$scope.show = id;
			vm.registersToUpdate = [];
			vm.comboBoxSubTypePub = [];
			vm.cleanForms();
			vm.regUpdate = null;
	
			if (this.$scope.show != 1 && this.$scope.show != 5) {
				this.getDataForType(this.perfilTypes[id].type, function (data) {
					vm.comboBoxTypePub = data;
				});
	
				if (this.perfilTypes[id].indep !== undefined) {
					var _loop = function _loop(i) {
						_this3.getDataForType(_this3.perfilTypes[id].indep[i], function (data) {
							if (i == 0) {
								vm.comboBoxTypeInde = data;
							} else {
								vm.comboBoxTypeInde2 = data;
							}
						});
					};
	
					for (var i in this.perfilTypes[id].indep) {
						_loop(i);
					}
				}
			}
	
			vm.forms['5'].city = null;
	
			if (this.$scope.show == 4) {
				vm.listData();
				vm.getCountriesAndCities();
			}
	
			if (this.$scope.show == 5) {
				var params = {
					workplanId: 0,
					teacherId: 0
				};
	
				vm.services.post.getUndAcademicAndRole(params).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						vm.typePeriod = dataReturn.workplanperiod;
						vm.unitsAndRolesCombo = dataReturn.rolesacademicunits;
						vm.unitsCombo = dataReturn.rolesacademicunits;
						//////////////crear un array solo para la unidad//////////////
						for (var index in vm.unitsCombo) {
							if (!vm.exists('academitUnitId', vm.unitsCombo[index].academitUnitId, vm.arrayUnit)) {
								var temp = {
									academitUnitId: vm.unitsCombo[index].academitUnitId,
									academitUnitName: vm.unitsCombo[index].academitUnitName
								};
	
								vm.arrayUnit.push(temp);
							}
						}
						/////////////////////fin//////////////
					}
				}, function (err) {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			} else if (this.$scope.show == 1) {
				if (vm.typeUpdate == 2) {
					vm.forms[1].name = vm.personalForm.name;
					vm.forms[1].cedula = vm.personalForm.cedula;
					vm.forms[1].address = vm.personalForm.address;
					vm.forms[1].phone = vm.personalForm.phone;
					vm.forms[1].mail = vm.personalForm.mail;
					vm.forms[1].mail_alt = vm.personalForm.mail_alt;
					vm.forms[1].nacionality = vm.personalForm.nacionality;
					vm.forms[1].birthday = vm.personalForm.birthday;
				} else {
					vm.forms[1].name = vm.personalForm.name;
					vm.forms[1].cedula = vm.personalForm.cedula;
				}
			} else if (this.$scope.show == 7) {
				var _params = {
					workplanId: 0,
					teacherId: 0
				};
	
				vm.services.list.listTypeTrayect(_params).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						vm.typePeriod = dataReturn.workplanperiod;
						vm.unitsAndRolesCombo = dataReturn.rolesacademicunits;
						vm.unitsCombo = dataReturn.rolesacademicunits;
						//////////////crear un array solo para la unidad//////////////
						for (var index in vm.unitsCombo) {
							if (!vm.exists('academitUnitId', vm.unitsCombo[index].academitUnitId, vm.arrayUnit)) {
								var temp = {
									academitUnitId: vm.unitsCombo[index].academitUnitId,
									academitUnitName: vm.unitsCombo[index].academitUnitName
								};
	
								vm.arrayUnit.push(temp);
							}
						}
						/////////////////////fin//////////////
					}
				}, function (err) {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
	
			if (vm.$scope.show != 0 && vm.$scope.show != 1 && vm.typeUpdate == 2) {
				var context = vm.$scope.show == 6 ? 2 : null; // Context:2 -> reconocimientos e incentivos
	
				vm.auxServices[vm.$scope.show]({ teacherId: vm.userinfo.teacherId, context: context }).$promise.then(function (response) {
					if (!response.status) {
						return vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					}
					vm.setRegArray(response.data);
				}, function (err) {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}
	
		function onChangeAcademicUnit(acadUnit) {
			vm.onlyRoles = [];
			vm.forms['5'].idRol = '';
			for (var i in vm.academicsUnitAndRoles) {
				if (vm.academicsUnitAndRoles[i].academitUnitId == acadUnit) {
					vm.onlyRoles.push(vm.academicsUnitAndRoles[i]);
				}
			}
		}
	
		function onChangeCountry(country) {
			vm.cities = [];
			vm.forms['5'].city = null;
			for (var i in vm.allCountries) {
				if (vm.allCountries[i].id_pais == country) {
					vm.cities.push(vm.allCountries[i]);
				}
			}
		}
	
		function getCountriesAndCities() {
			var _this4 = this;
	
			vm.countriesAndCities = [];
			this.services.list.getCountriesAndCities().$promise.then(function (response) {
				if (!response.status) {
					return _this4.ngNotify.set('Ocurrio un error en el servicio', 'warn');
				}
	
				vm.allCountries = response.data;
	
				for (var i in response.data) {
					if (!vm.exists('id_pais', response.data[i].id_pais, _this4.countriesAndCities)) {
						vm.countriesAndCities.push(response.data[i]);
					}
				}
			}, function (err) {
				_this4.ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function cleanValidation() {
			vm.forms[4].isMen = 0;
			vm.forms[4].isIssuedInSpanish = 0;
		}
	
		function getNotify(idRole) {
			var usersByRol = [];
			var header = { rolId: idRole };
	
			GlobalSrv.getUserByRol.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status == true) {
					usersByRol = dataReturn.data;
	
					for (var i in usersByRol) {
						getSendNotify(usersByRol[i].id_user);
					}
				} else {
					console.log('Ocurrio un error en el servicio de notificación');
				}
			}, function (dataReturn) {
				console.log(dataReturn);
			});
		}
	
		function getSendNotify(idUser) {
			var data = {
				idUser: idUser,
				dsName: 'Notificación de solicitud a pendiente de revisión',
				dsDescription: 'Ha recibido una solicitud de actualización de información del profesor "' + JSON.parse(vm.$cookies.get('currentUser')).dsFullname + '".',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped: 1
			};
	
			GlobalSrv.sendNotification(data);
		}
	
		function saveRequest() {
			var _this5 = this;
	
			var requiredValidationOfFiles = function requiredValidationOfFiles(update) {
				// Perfil existente
				var isAProfileUpdate = _this5.$scope.show == 1;
	
				if (isAProfileUpdate) return false;
	
				return true;
			};
	
			if (vm.$scope.show != 0 && vm.typeUpdate != '') {
				vm.noFile = false;
				vm.hasErrors = false;
				$scope.savingForm = true;
				$scope.errorMessage = '';
				var update = vm.forms[vm.$scope.show];
	
				var form = vm.avaliableForms.filter(function (form) {
					return vm.formId[form.id_code] == vm.$scope.show;
				});
	
				update.id_wkf = form[0].id_workflow;
				update.teacherId = vm.userinfo.teacherId;
				update.type = vm.typeUpdate;
				update.userid = vm.userinfo.id;
				update.fileNames = [];
	
				if (update.id_wkf === 3) update.stageId = vm.globalConfig.initStageUpdate.wfCorto;else update.stageId = vm.globalConfig.initStageUpdate.wfLargo;
	
				for (var i = 0; i < vm.$scope.uploader.queue.length; i++) {
					update.fileNames.push({ name: vm.$scope.uploader.queue[i].file.name, typeOfFile: vm.$scope.uploader.queue[i].typeOfFile });
				}
	
				if (update.fileNames.length <= 0 && requiredValidationOfFiles(update)) {
					vm.noFile = true;
					$scope.errorMessage = 'No se ha adjuntado ningun archivo';
					$scope.savingForm = false;
	
					return;
				}
	
				if (vm.$scope.show == vm.globalConfig.orderProfiles.perfil_formacion) {
					if (update.dsInstitution) {
						update.dsInstitution = update.dsInstitution.name || update.dsInstitution;
					} else if (update.dsInstitutionSearch) {
						update.dsInstitution = update.dsInstitutionSearch;
					} else {
						$scope.errorMessage = 'Debe ingresar el nombre de la institución';
						vm.hasErrors = true;
						$scope.savingForm = false;
	
						return;
					}
	
					if (update.country !== null) {
						update.country = update.country.ds_pais || update.country;
					}
	
					if (update.city !== null) {
						update.city = update.city.ds_ciudad || update.city;
					}
				}
	
				if (typeof update.idHistActiv === 'undefined') update.idHistActiv = null;
	
				if (typeof update.idUnidad === 'undefined') update.idUnidad = null;
	
				if (typeof update.idRol === 'undefined') update.idRol = vm.userinfo.role_id;
	
				vm.serviceSave[vm.$scope.show](update).$promise.then(function (response) {
					if (!response.status) {
						$scope.savingForm = false;
						vm.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						getNotify(GlobalConfig.userRolesIds.reviewerUpdatePerfil); //Dir. Académica
	
						vm.logIdInsert = response.data[1];
	
						if (vm.$scope.uploader.queue.length > 0) {
							for (var i = 0; i < vm.$scope.uploader.queue.length; i++) {
								vm.$scope.uploader.queue[i].url = vm.$scope.uploader.url + '?userId=' + vm.identificationNumber + '&requestId=' + response.data[0] + '&logId=' + vm.logIdInsert;
							}
							vm.$scope.uploader.uploadAll();
						} else {
							$scope.savingForm = false;
							vm.$state.go('profile.Actualizacion_Perfil');
							vm.ngNotify.set('Perfil actualizado exitosamente!', 'success');
						}
					}
				}, function (err) {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}
	};
	
	exports.default = newRequestCtrl;
	
	
	newRequestCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', 'moment', 'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT', 'GlobalSrv'];

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @name APP cmmApp
	 * @autor daniel.molina@u-planner.com
	 * @description vista tabla para forecast
	 * # name controller --> powerbiPerfilCtrl
	 * # alias: --> powerbiCtrl
	 */
	var powerbiPerfilCtrl = function powerbiPerfilCtrl($http, $scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, LOCAL_ENV_CONSTANT) {
	  _classCallCheck(this, powerbiPerfilCtrl);
	
	  $scope.title = 'Reporte perfil de profesores';
	
	  $scope.POWER = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY2;
	
	  $scope.workspaceId = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_GROUP_ID;
	  $scope.reportId = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY2;
	};
	
	exports.default = powerbiPerfilCtrl;
	
	
	powerbiPerfilCtrl.$inject = ['$http', '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'LOCAL_ENV_CONSTANT'];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @name APP ClassPanel
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @autor jaime.salazar@u-planner.com
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @description
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # name controller --> dialogSummaryControllers
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # As Controller --> dialogSummary
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * brief comment controller for show dialog finish approval
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	
	var _detallePerfilDocente = __webpack_require__(427);
	
	var _detallePerfilDocente2 = _interopRequireDefault(_detallePerfilDocente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var dialogdetailcontroller = function () {
	    function dialogdetailcontroller($scope, $http, $resource, $filter, ngNotify, $mdDialog, data, perfilSrv) {
	        _classCallCheck(this, dialogdetailcontroller);
	
	        this.$mdDialog = $mdDialog;
	        this.ngNotify = ngNotify;
	        this.perfilSrv = perfilSrv;
	        this.params = data;
	        this.details = [];
	        this.main();
	    }
	
	    _createClass(dialogdetailcontroller, [{
	        key: 'main',
	        value: function main() {
	            var _this = this;
	
	            var params = {
	                param1: this.params.user.teacherId,
	                param2: this.params.row.Asignatura,
	                param3: this.params.row.Periodo
	            };
	            this.perfilSrv.list.getDetailPerfilDocente(params).$promise.then(function (response) {
	                if (!response.status) {
	                    _this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	                } else {
	
	                    var dataArray = [];
	
	                    var _loop = function _loop() {
	
	                        var obj = response.data[i];
	                        var groupId = obj.dsGroup;
	                        var groupData = { aspect: obj.aspect, avgAspect: obj.nmAspectAvg };
	                        var dataObj = { id: groupId, data: [] };
	
	                        var existantObject = dataArray.filter(function (obj) {
	                            return obj.id == groupId;
	                        });
	                        if (existantObject.length === 0) {
	                            dataObj.data.push(groupData);
	                            dataArray.push(dataObj);
	                        } else {
	                            existantObject[0].data.push(groupData);
	                        }
	                    };
	
	                    for (var i = 0; i < response.data.length; i++) {
	                        _loop();
	                    }
	                    _this.details = dataArray;
	                }
	            }, function (err) {
	                _this.ngNotify.set('Imposible conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$mdDialog.hide();
	        }
	    }]);
	
	    return dialogdetailcontroller;
	}();
	
	exports.default = dialogdetailcontroller;
	
	
	dialogdetailcontroller.$inject = ['$scope', '$http', '$resource', '$filter', 'ngNotify', '$mdDialog', 'data', 'perfilSrv'];

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = {"data":[{"Nivel":"Nivel","code":"0912345","group":"01","AvgAspectIdo":"4.5","AvgResposabilidad":"4.5","AvgActitudForm":"3.0","AvgGeneralApreciacion":"3.8","Periodo":"Período","Asignatura":"Asignatura"}],"status":true}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP ClassPanel
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> dialogSummaryControllers
	* # As Controller --> dialogSummary
	* brief comment controller for show dialog finish approval
	                                                        
	*/
	
	var perfil_popcontroller = function () {
	    function perfil_popcontroller($scope, $http, $resource, $filter, ngNotify, $mdDialog, datos) {
	        _classCallCheck(this, perfil_popcontroller);
	
	        this.$mdDialog = $mdDialog;
	        this.$scope = $scope;
	        this.$scope.datos = datos;
	    }
	
	    _createClass(perfil_popcontroller, [{
	        key: 'close',
	        value: function close() {
	            this.$mdDialog.hide();
	        }
	    }]);
	
	    return perfil_popcontroller;
	}();
	
	exports.default = perfil_popcontroller;
	
	
	perfil_popcontroller.$inject = ['$scope', '$http', '$resource', '$filter', 'ngNotify', '$mdDialog', 'datos'];

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP ClassPanel
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> dialogSummaryControllers
	* # As Controller --> dialogSummary
	* brief comment controller for show dialog finish approval
	                                                        
	*/
	
	var modalDetailsURtCtrl = function () {
	    function modalDetailsURtCtrl($http, $resource, $filter, ngNotify, $mdDialog) {
	        _classCallCheck(this, modalDetailsURtCtrl);
	
	        this.$mdDialog = $mdDialog;
	
	        this.titles = {
	            "teacherType": 'Nivel de promoción',
	            "maxLevelFormationAchieved": 'Máximo nivel de formación alcanzada',
	            "recognitionTypeGivenByUniversity": 'Experiencia reconocida',
	            "nativeLanguage": 'Idioma nativo',
	            "secondLanguage": 'Segundo idioma que certifica',
	            "thirdLanguage": 'Tercer idioma que certifica',
	            "fourthLanguage": 'Cuarto idioma que certifica',
	            "rating": 'Producción académica acumulada',
	            "pointsProvided": 'Puntos prestados de producción',
	            "recognitionDate": 'Fecha de promoción',
	            "record": 'Número de acta',
	            "record_date": 'Fecha de acta',
	            "recognitionMinistryEducation": 'Título de convalidación',
	            "resolutionNumber": 'Número de resolucion',
	            "convalidationDate": 'Fecha de convalidación',
	            // "teacherCategory": 'Categoría de profesor',
	            "observations": 'Observaciones'
	
	        };
	    }
	
	    _createClass(modalDetailsURtCtrl, [{
	        key: "close",
	        value: function close() {
	            this.$mdDialog.hide();
	            //  this.$state.reload();
	        }
	    }, {
	        key: "getKeys",
	        value: function getKeys() {
	            return Object.keys(this.titles);
	        }
	    }, {
	        key: "getTitle",
	        value: function getTitle(key) {
	            return this.titles[key] || 'desconocido';
	        }
	    }]);
	
	    return modalDetailsURtCtrl;
	}();
	
	exports.default = modalDetailsURtCtrl;
	
	
	modalDetailsURtCtrl.$inject = ['$http', '$resource', '$filter', 'ngNotify', '$mdDialog'];

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var perfilSrv = function perfilSrv($resource, SERVICE_URL_CONSTANT, GlobalConfig) {
		_classCallCheck(this, perfilSrv);
	
		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST'
			}
		});
	
		// PORTFOLIO SERVICES
		var perfildocente = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/:router/:teacherId/:year/:idHist/:ticketId', {}, {
			getperfildocente: {
				method: 'GET',
				params: {
					router: 'perfildocente'
				}
			},
			getperfildocenteChart: {
				method: 'GET',
				params: {
					router: 'getperfildocenteChart'
				}
			},
			getperfil_dash: {
				method: 'GET',
				params: {
					router: 'perfil_dash'
				}
			},
			PerfildeInvestigacion: {
				method: 'GET',
				params: {
					router: 'PerfildeInvestigacion'
				}
			},
			PerfildeInvestigacionChart: {
				method: 'GET',
				params: {
					router: 'PerfildeInvestigacionChart'
	
				}
			},
			perfilextention: {
				method: 'GET',
				params: {
					router: 'perfilextention'
				}
			},
			perfilextentionChart: {
				method: 'GET',
				params: {
					router: 'perfilextentionChart'
				}
			},
			perfilFormacion: {
				method: 'GET',
				params: {
					router: 'perfilFormacion'
				}
			},
			trayectoriaURDetail: {
				method: 'GET',
				params: {
					router: 'trayectoriaURDetail'
				}
			},
			TrayectoriaURGraph: {
				method: 'GET',
				params: {
					router: 'trayectoriaURGraph'
				}
			},
			trayectoriaUR: {
				method: 'GET',
				params: {
					router: 'trayectoriaUR'
				}
			},
			reconocimientoSeincentivos: {
				method: 'GET',
				params: {
					router: 'reconocimientoSeincentivos'
				}
			},
			trayectoriaprevia: {
				method: 'GET',
				params: {
					router: 'trayectoriaprevia'
				}
			},
			ActualizaciondePerfil: {
				method: 'GET',
				params: {
					router: 'actualizaciondePerfil'
				}
			},
			getLogs: {
				method: 'GET',
				params: {
					router: 'listadoLog'
				}
			},
			getStates: {
				method: 'GET',
				params: {
					router: 'resumenDeLogPerfil'
				}
			},
			getDataToUpdate: {
				method: 'GET',
				params: {
					router: 'obtenerDatosActualizacion'
				}
			},
			getUpdateForms: {
				method: 'GET',
				params: {
					router: 'updateForms'
				}
			},
			getUpdateFormsMaintainer: {
				method: 'GET',
				params: {
					router: 'updateFormsMaintainer'
				}
			}
	
		});
	
		var perfilFormacionFiltro = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/:router/:teacherId/:typeFormation', {}, {
			perfilFormacionFiltro: {
				method: 'GET',
				params: {
					router: 'perfilFormacionFiltro'
				}
			}
		});
	
		var perfildocenteByRole = $resource(SERVICE_URL_CONSTANT.rosario + '/perfil/:router/:roleId/:userId', {}, {
			actualizaciondePerfilByUserRole: {
				method: 'GET',
				params: {
					router: 'actualizaciondePerfilByUserRole'
				}
			}
		});
	
		var role = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:param1', {}, {
			getInfo: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'esDocente'
				}
			},
			getType: {
				method: 'GET',
				params: {
					type: 'strategic_tracking',
					route: 'getUserTypeRoles'
				}
			}
		});
	
		var list = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:param1/:param2/:param3', {}, {
			getDetailPerfilDocente: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'perfilDocenteDetails'
				}
			},
			getCountriesAndCities: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'getCountryCity'
				}
			},
			getListItems: {
				method: 'GET',
				params: {
					type: 'list',
					route: 'getListItems'
				}
			},
			getListItemsByIdListForRole: {
				method: 'GET',
				params: {
					type: 'list',
					route: 'getListItemsByIdListForRole'
				}
			},
			getListItemsSubtype: {
				method: 'GET',
				params: {
					type: 'list',
					route: 'getListItemsDepend'
				}
			},
			getListDocentes: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'listDocentes'
				}
			},
			getListStage: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'getStageList'
				}
			},
			listTypeTrayect: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'listTypeTrayect'
				}
			}
		});
	
		var listStage = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:stageId/:typeId/:roleId/:stageCurrentId', {}, {
			getListStage: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'getStageList'
				}
			}
		});
	
		var post = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
			getUndAcademicAndRole: {
				method: 'POST',
				params: {
					type: 'activity',
					route: 'getDataRolesList'
				}
			},
			saveBiography: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'savePerfil_dashBiography'
				}
			},
			saveInterestArea: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'savePerfil_dashInterest'
				}
			},
			saveInvestigationData: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveActualizacionDatosInvestigacion'
				}
			},
			savePersonalData: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveActualizacionDatosPersonales'
				}
			},
			saveExtensionData: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveActualizacionDatosExtension'
				}
			},
			saveFormationData: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveActualizacionDatosFormacion'
				}
			},
			saveTrajectoryData: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveActualizacionTrayectoriaUR'
				}
			},
			savePrevTrajectoryData: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveActualizacionTrayectoriaPrevia'
				}
			},
			saveRecognitionData: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveUpdateReconocimientoEincentivos'
				}
			},
			saveChangeStage: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'saveChangeStage'
				}
			}
		});
		var getFileSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:requestId/:userId/:logId/:fileName', {}, {
			getFile: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'downloadFile'
				}
			}
		});
		var getFileBitacoraSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:logId', {}, {
			getFiles: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'getFilesBitacora'
				}
			}
		});
		var getCVDocumentsSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			getDocs: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'getCVDocuments'
				}
			}
		});
		var getInstitutionsSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			getInstitutions: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'getInstitutions'
				}
			}
		});
		var getAcademicPeriodsSrv = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			getPeriods: {
				method: 'GET',
				params: {
					type: 'perfil',
					route: 'getAcademicPeriods'
				}
			}
		});
		var workflows = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/', {}, {
			setProfileUpdateWorkflow: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'setProfileUpdateWorkflow'
				}
			},
			getFormUsers: {
				method: 'POST',
				params: {
					type: 'perfil',
					route: 'getFormUsers'
				}
			}
		});
	
		// SERVICES INJECTION
		return {
			addNotificationsTransactions: addNotificationsTransactions,
			perfildocente: perfildocente,
			post: post,
			list: list,
			role: role,
			perfilFormacionFiltro: perfilFormacionFiltro,
			perfildocenteByRole: perfildocenteByRole,
			listStage: listStage,
			getFileSrv: getFileSrv,
			getFileBitacoraSrv: getFileBitacoraSrv,
			getCVDocumentsSrv: getCVDocumentsSrv,
			getInstitutionsSrv: getInstitutionsSrv,
			getAcademicPeriodsSrv: getAcademicPeriodsSrv,
			workflows: workflows
		};
	};
	
	perfilSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT', 'GlobalConfig'];
	exports.default = angular.module('services.perfilSrv', []).service('perfilSrv', perfilSrv).name;

/***/ }),
/* 431 */
1199,
/* 432 */,
/* 433 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-console */
	var Validations = function Validations(GlobalConfig) {
		_classCallCheck(this, Validations);
	
		var modules = GlobalConfig.modules;
		var stages = GlobalConfig.workplanStages;
		var userRolesIds = GlobalConfig.userRolesIds;
		var activityTypeId = GlobalConfig.activityTypeId;
		var projectTypeId = GlobalConfig.typeProject;
	
		function inReview(currentStage) {
			return currentStage === stages.review;
		}
	
		function inApproval(currentStage) {
			return currentStage === stages.approval;
		}
	
		function inExecution(currentStage) {
			return currentStage === stages.execution;
		}
	
		function inReviewExecution(currentStage) {
			return currentStage === stages.reviewExecution;
		}
	
		function inEvaluation(currentStage) {
			return currentStage === stages.evaluation;
		}
	
		function setPermissions(currentStage) {
			var result = [userRolesIds.workPlanAdmin, userRolesIds.workplanConsultant, userRolesIds.unitAdmin, userRolesIds.gerencialConsultant, userRolesIds.generalConsultant, userRolesIds.consultant, userRolesIds.support, userRolesIds.workplanCommittee, userRolesIds.committee, userRolesIds.comiteeAdmin];
	
			if (inReview(currentStage)) {
				return [userRolesIds.reviewer].concat(result);
			} else if (inApproval(currentStage)) {
				return [userRolesIds.approver].concat(result);
			} else if (inExecution(currentStage)) {
				return [userRolesIds.teacher].concat(result);
			} else if (inReviewExecution(currentStage)) {
				return [userRolesIds.reviewer].concat(result);
			} else if (inEvaluation(currentStage)) {
				return [userRolesIds.approver].concat(result);
			} else {
				return result;
			}
		}
	
		function validUser(currentRoleId, currentStage) {
			var roles = setPermissions(currentStage);
			var idPermitido = false;
	
			for (var i in roles) {
				if (currentRoleId === roles[i]) {
					idPermitido = true;
				}
			}
	
			return idPermitido;
		}
	
		function isSubjectType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.subject;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isActivitiesType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.activities;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isStudentAttentionType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.studentAttention;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isPositionByDelegationType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.positionsByDelegation;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isCommitteeParticipationType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.committeeParticipation;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isRolesType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.roles;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isOtherActivitiesType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.otherActivities;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isDoctoralEducationType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.doctoralEducation;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isTeacherDevelopmentType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.teacherDevelopment;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isCommunityType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.community;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isProjectDesignType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.projectDesign;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isProjectsType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.projects;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isProductsType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.products;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isColaborationSpaceType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.colaborationSpace;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isInvestigationType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.investigation;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isResultsTransferType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.resultsTransfer;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isInternalProjectsFormulationType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.internalProjectsFormulation;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isExtensionProjectsType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.extensionProjects;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isVisibilityType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.visibility;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isConsultancyType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.consultancy;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isShortCoursesType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.shortCourses;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isCrossProjectFormulationType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.crossProjectFormulation;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function isCrossExtensionProjectsType(activity) {
			if (!activity) {
				console.log('Not an activity => ', activity);
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.crossExtensionProjects;
			} else {
				console.log('Not an activity => ', activity);
			}
		}
	
		function inTeaching(module) {
			return module === modules.teaching;
		}
	
		function inAcademicManagement(module) {
			return module === modules.academicManagement;
		}
	
		function inConsolidation(module) {
			return module === modules.consolidation || module === modules.teaching;
		}
	
		function inInvestigation(module) {
			return module === modules.investigation;
		}
	
		function inExtension(module) {
			return module === modules.extentionAndVisibility;
		}
	
		function isTeacher(currentRoleId) {
			return currentRoleId === userRolesIds.teacher;
		}
	
		function isInternalProject(project) {
			return project.activityTypeId === projectTypeId.internalProject || project.activityTypeId === projectTypeId.internal;
		}
		function isCrossProject(project) {
			return project.activityTypeId === projectTypeId.crossProject || project.isProjectCross === projectTypeId.cross;
		}
	
		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error';
			}
		}
	
		function showErrorMessages(input) {
			return input ? input.$dirty || input.$touched : false;
		}
	
		function validateForm(form) {
			return form.$invalid;
		}
	
		function isAdminUnit(id) {
			return userRolesIds.unitAdmin == id;
		}
	
		function isGerencialConsultant(id) {
			return userRolesIds.gerencialConsultant == id;
		}
	
		function isCommitteeAdmin(id) {
			return userRolesIds.comiteeAdmin == id;
		}
	
		function isCommitteeRole(id) {
			return userRolesIds.committee == id;
		}
	
		function isConsultant(roleId) {
			return userRolesIds.consultant == roleId;
		}
	
		function inConsultant(roleId) {
			return roleId === userRolesIds.workPlanAdmin || roleId === userRolesIds.workplanConsultant;
		}
	
		function inAdminConsultantUnit(roleId) {
			return roleId === userRolesIds.unitAdmin || roleId === userRolesIds.gerencialConsultant;
		}
	
		function isWorkplanCommittee(roleId) {
			return roleId === userRolesIds.workplanCommittee;
		}
	
		return {
			inReview: inReview,
			inApproval: inApproval,
			inExecution: inExecution,
			inReviewExecution: inReviewExecution,
			inEvaluation: inEvaluation,
			inConsultant: inConsultant,
			inAdminConsultantUnit: inAdminConsultantUnit,
			setPermissions: setPermissions,
			validUser: validUser,
			isSubjectType: isSubjectType,
			isActivitiesType: isActivitiesType,
			isStudentAttentionType: isStudentAttentionType,
			isRolesType: isRolesType,
			isPositionByDelegationType: isPositionByDelegationType,
			isCommitteeParticipationType: isCommitteeParticipationType,
			isOtherActivitiesType: isOtherActivitiesType,
			isDoctoralEducationType: isDoctoralEducationType,
			isTeacherDevelopmentType: isTeacherDevelopmentType,
			isCommunityType: isCommunityType,
			isProjectDesignType: isProjectDesignType,
			isProjectsType: isProjectsType,
			isProductsType: isProductsType,
			isColaborationSpaceType: isColaborationSpaceType,
			isResultsTransferType: isResultsTransferType,
			isInvestigationType: isInvestigationType,
			isInternalProjectsFormulationType: isInternalProjectsFormulationType,
			isExtensionProjectsType: isExtensionProjectsType,
			isVisibilityType: isVisibilityType,
			isConsultancyType: isConsultancyType,
			isShortCoursesType: isShortCoursesType,
			isCrossProjectFormulationType: isCrossProjectFormulationType,
			isCrossExtensionProjectsType: isCrossExtensionProjectsType,
			inTeaching: inTeaching,
			inAcademicManagement: inAcademicManagement,
			inConsolidation: inConsolidation,
			inInvestigation: inInvestigation,
			inExtension: inExtension,
			isTeacher: isTeacher,
			isInternalProject: isInternalProject,
			isCrossProject: isCrossProject,
			hasError: hasError,
			showErrorMessages: showErrorMessages,
			validateForm: validateForm,
			isAdminUnit: isAdminUnit,
			isGerencialConsultant: isGerencialConsultant,
			isCommitteeAdmin: isCommitteeAdmin,
			isCommitteeRole: isCommitteeRole,
			isConsultant: isConsultant,
			isWorkplanCommittee: isWorkplanCommittee
	
		};
	};
	
	Validations.$inject = ['GlobalConfig'];
	
	exports.default = angular.module('services.Validations', []).service('Validations', Validations).name;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Setters = function Setters(Ramda) {
	  _classCallCheck(this, Setters);
	
	  var R = Ramda;
	
	  var importGlobal = R.curry(function (object, key, cookies) {
	    if (!object[key]) {
	      return JSON.parse(cookies.get('currentUser'))[key];
	    } else {
	      return object[key];
	    }
	  });
	
	  var setTagName = R.curry(function (lib, activity) {
	    switch (true) {
	      case lib.isPositionByDelegationType(activity):
	        return 'Cargos por delegación';
	      case lib.isRolesType(activity):
	        return 'Roles';
	      case lib.isCommitteeParticipationType(activity):
	        return 'Participación en comites';
	      case lib.isOtherActivitiesType(activity):
	        return 'Otras Actividades';
	      case lib.isSubjectType(activity):
	        return 'Asignatura';
	      case lib.isStudentAttentionType(activity):
	        return 'Atención Estudiantes';
	      case lib.isActivitiesType(activity):
	        return 'Actividad';
	      case lib.isDoctoralEducationType(activity):
	        return 'Formación Doctoral';
	      case lib.isTeacherDevelopmentType(activity):
	        return 'Desarrollo Profesoral';
	      case lib.isCommunityType(activity):
	        return 'Comunidades de aprendizaje y práctica';
	      case lib.isProjectDesignType(activity):
	        return 'Formulación de proyectos';
	      case lib.isProjectsType(activity):
	        return 'Proyectos';
	      case lib.isProductsType(activity):
	        return 'Productos';
	      case lib.isColaborationSpaceType(activity):
	        return 'Espacios de colaboración';
	      case lib.isResultsTransferType(activity):
	        return 'Transferencia de resultados';
	      case lib.isInvestigationType(activity):
	        return 'Formación en Investigación';
	      case lib.isInternalProjectsFormulationType(activity):
	        return 'Formulación de proyectos internos';
	      case lib.isExtensionProjectsType(activity):
	        return 'Proyectos internos';
	      case lib.isVisibilityType(activity):
	        return 'Visibilidad';
	      case lib.isConsultancyType(activity):
	        return 'Asesoría/Consultoría';
	      case lib.isShortCoursesType(activity):
	        return 'Cursos cortos';
	      case lib.isCrossProjectFormulationType(activity):
	        return 'Formulación de proyectos transversal';
	      case lib.isCrossExtensionProjectsType(activity):
	        return 'Proyecto transversal';
	    }
	  });
	
	  var formatActivity = R.curry(function (setTagName, activities, stageId) {
	    return activities.map(function (activity) {
	      activity.periodicityName = activity.periodicityName ? activity.periodicityName.split(',').join(', ') : null;
	      activity.tagName = setTagName(activity);
	      activity.stageId = stageId;
	      return activity;
	    });
	  });
	
	  var flatten = function flatten(arr) {
	    return arr.reduce(function (acc, val) {
	      return acc.concat(Array.isArray(val) ? flatten(val) : val);
	    }, []);
	  };
	
	  var sortById = function sortById(list) {
	    var sorted = [];
	    var ids = [];
	    list.forEach(function (obj) {
	      if (!ids.filter(function (x) {
	        return x === obj.activityTypeId;
	      }).length) {
	        ids.push(obj.activityTypeId);
	      }
	    });
	    ids = ids.sort(function (x, y) {
	      if (x < y) return -1;
	      if (x > y) return 1;
	      return 0;
	    });
	    ids.forEach(function (id) {
	      sorted.push(sortByName(list.filter(function (x) {
	        return x.activityTypeId === id;
	      }), id));
	    });
	    return flatten(sorted);
	  };
	
	  var sortByName = function sortByName(list, id) {
	    var keyName = ['name', 'asignatureName', 'itemName', 'nameCharge', 'workplanTeacherChargeName', 'otherActivityItemName', 'scheduleTypeName', 'committeeName', 'roleName'].filter(function (name) {
	      return Reflect.has(list[0], name) && Boolean(list[0][name]);
	    }).filter(Boolean).slice(0, 1);
	    return list.sort(function (a, b) {
	      if (a[keyName] < b[keyName]) return -1;
	      if (a[keyName] > b[keyName]) return 1;
	      return 0;
	    });
	  };
	
	  var sortActivitiesList = sortById;
	
	  // VALIDATIONS SIGNATURE
	  return {
	    importGlobal: importGlobal,
	    setTagName: setTagName,
	    formatActivity: formatActivity,
	    sortActivitiesList: sortActivitiesList,
	    sortById: sortById,
	    sortByName: sortByName
	  };
	};
	
	Setters.$inject = ['Ramda'];
	exports.default = angular.module('services.Setters', []).service('Setters', Setters).name;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Requests = function Requests(Ramda) {
		_classCallCheck(this, Requests);
	
		var curry = Ramda.curry;
	
	
		var getWorkplans = curry(function (service, user) {
			return service.getTeacherWorkplans.request({ teacherId: user.teacherId }).$promise.then(function (dataReturn) {
				return dataReturn.status ? dataReturn.data : 'error in communication';
			});
		});
		var getSummanyProgress = curry(function (service, id) {
			return service.getSummanyProgress.post({ teacherId: id }).$promise.then(function (dataReturn) {
				return dataReturn.status ? dataReturn : 'error in communication';
			});
		});
	
		var setEndExecutionHeader = curry(function (config, user, data) {
			return {
				teacherId: user.teacherId,
				workplanId: user.workplanId,
				userId: user.id,
				stageId: config.workplanIdStages.execution,
				stageName: config.workplanStagesNames.execution,
				data: data.submodulesProgress,
				totalHours: data.totalHoursAllSubmodules,
				totalHoursExecution: data.totalHoursExecutedAllSubmodules,
				isExistActiWitOutHourExecuted: data.isExistActiWitOutHourExecuted,
				minHours: data.minHours,
				maxHours: data.maxHours,
				isPlanning: 0,
				isMinHoursExecuted: data.isMinHoursExecuted,
				isMaxHoursExecuted: data.isMaxHoursExecuted,
				isControlHoursActive: data.isControlHoursActive
			};
		});
	
		var setEndAprovalHeader = curry(function (config, user, currentStage, data) {
			return {
				teacherId: user.teacherId,
				workplanId: user.workplanId,
				userId: user.id,
				textStage: config.workplanStagesNames.approval,
				currentStage: currentStage,
				count: data.toApprove,
				toReviewed: data.noTouched,
				allAct: data.allAct
			};
		});
	
		var setEndEvaluationHeader = curry(function (config, user, currentStage, noTouched) {
			return {
				teacherId: user.teacherId,
				workplanId: user.workplanId,
				userId: user.id,
				textStage: config.workplanStagesNames.evaluation,
				currentStage: currentStage,
				toReviewed: noTouched
			};
		});
	
		var setEndReviewExecutionHeader = curry(function (config, user, currentStage, noTouched) {
			return {
				teacherId: user.teacherId,
				workplanId: user.workplanId,
				userId: user.id,
				textStage: config.workplanStagesNames.reviewExecution,
				currentStage: currentStage,
				toReviewed: noTouched
			};
		});
	
		var getReviewList = curry(function (teacherId, workplanId, service, workplan, module) {
			var header = {
				teacherId: teacherId,
				workplanId: workplan ? Number(workplan) : workplanId
			};
	
			switch (module) {
	
				case 'teaching':
					return service.getReviewListData.teaching(header).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
				case 'academicManagement':
					return service.getReviewListData.academicManagement(header).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
				case 'consolidation':
					return service.getReviewListData.consolidation(header).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
				case 'investigation':
					return service.getReviewListData.investigation(header).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
				case 'extentionAndVisibility':
					return service.getReviewListData.extentionAndVisibility(header).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
	
			}
		});
	
		var setDetailsHeader = curry(function (lib, activity) {
			return lib.isSubjectType(activity) ? {
				teacherId: activity.teacherId,
				asignatureId: activity.asignatureId,
				workplanId: activity.workplanId
			} : activity.workplanTeacherActivityId ? {
				workplanTeacherActivityId: activity.workplanTeacherActivityId,
				activityTypeId: activity.activityTypeId
			} : {
				workplanTeacherActivityId: activity.workplanTeacherActivityId,
				activityTypeId: activity.activityTypeId,
				workplanTeacherId: activity.workplanTeacherId,
				activityId: activity.activityId,
				teacherId: activity.teacherId,
				workplanId: activity.workplanId,
				workplanTeacherChargeId: activity.workplanTeacherChargeId,
				description: activity.description,
				hours: 0,
				isFeedbackActivity: activity.isFeedbackActivity,
				percentage: 0,
				countActivity: 0,
				userId: activity.userId
			};
		});
	
		var normalizeActivity = curry(function (setNullHours, activity) {
			activity.forEach(function (children) {
				children.name = children.itemActivityName;
				delete children.itemActivityName;
				children.description = children.detail;
				delete children.detail;
			});
	
			return setNullHours(activity);
		});
	
		var formatSubjectActivity = curry(function (normalizeActivity, response) {
			var format = {
				data: response.data.header[0],
				planning: normalizeActivity(response.data.activitiesPlanning),
				teaching: normalizeActivity(response.data.activitiesTeachers)
			};
	
			format.planning.type = 'planning';
			format.planning.totalPlannedHours = response.dataSum.countHoursPlannedPlanning;
			format.planning.totalExecutedHours = response.dataSum.countHoursExecutedPlanning;
	
			format.teaching.type = 'teaching';
			format.teaching.totalPlannedHours = response.dataSum.countHoursPlannedTeacher;
			format.teaching.totalExecutedHours = response.dataSum.countHoursExecutedTeacher;
	
			return format;
		});
	
		var routeDetails = curry(function (lib, setNullHours, setStudentAttentionData, formatSubjectActivity, module, activity, response) {
			switch (module) {
	
				case 'teaching':
					if (lib.isSubjectType(activity)) {
						return formatSubjectActivity(response);
					} else if (lib.isStudentAttentionType(activity)) {
						return {
							data: setStudentAttentionData(setNullHours([response.data])[0])
						};
					} else {
						return {
							data: response.data,
							otherActivity: setNullHours([response.data])
						};
					}
				case 'academicManagement':
					return { data: response };
				case 'consolidation':
					return { data: response };
				case 'investigation':
					if (lib.isProductsType(activity) || lib.isProjectsType(activity)) {
						return {
							data: response.parent,
							children: response.childs
						};
					}
	
					return { data: response };
				case 'extentionAndVisibility':
					if (lib.isExtensionProjectsType(activity) || lib.isCrossExtensionProjectsType(activity)) {
						return {
							data: response.parent,
							children: response.childs
						};
					}
	
					return {
						data: response
					};
	
			}
		});
	
		var getActivityDetails = curry(function (service, setHeader, module, activity) {
			switch (module) {
	
				case 'teaching':
					return service.getReviewDetails.teaching(setHeader(activity)).$promise.then(function (response) {
						return response.status ? response : 'error in communication';
					});
				case 'academicManagement':
					return service.getReviewDetails.academicManagement(setHeader(activity)).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
				case 'consolidation':
					return service.getReviewDetails.consolidation(setHeader(activity)).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
				case 'investigation':
					return service.getReviewDetails.investigation(setHeader(activity)).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
				case 'extentionAndVisibility':
					return service.getReviewDetails.extentionAndVisibility(setHeader(activity)).$promise.then(function (response) {
						return response.status ? response.data : 'error in communication';
					});
	
			}
		});
	
		function setNullHours(arr) {
			arr.forEach(function (element) {
				if (!element.hoursPlanned) {
					element.hoursPlanned = 0;
				}
				/* if (!element.hoursExecuted) {
	         element.hoursExecuted = 0
	       } */
			});
	
			return arr;
		}
	
		function setStudentAttentionData(data) {
			var splits = ['periodsNames', 'daysNames'];
			var hours = ['startHours', 'endHours'];
	
			if (data[splits[0]] && data[splits[1]]) {
				data.periodsNames = data[splits[0]].split(',').join(', ');
				data.daysNames = data[splits[1]].split(',').join(', ');
			}
	
			if (data[hours[0]] && data[hours[1]]) {
				data.periodsNames = data[hours[0]].substr(0, 5);
				data.daysNames = data[hours[1]].substr(0, 5);
			}
	
			data.hoursExecuted = data.hoursExecutedDetails;
			delete data.hoursExecutedDetails;
			data.hoursPlanned = data.hoursPlannedDetails;
			delete data.hoursPlannedDetails;
	
			return data;
		}
	
		function submoduleItemRequired(header) {
			var validateSubmodules = {
				teaching: false,
				academicManagement: false
			};
	
			var submodule = header.submodules;
	
			for (var i in submodule) {
				if (submodule[i].submoduleId === header.teaching) {
					validateSubmodules.teaching = true;
				}
	
				if (submodule[i].submoduleId === header.academicManagement) {
					validateSubmodules.academicManagement = true;
				}
			}
	
			return validateSubmodules;
		}
	
		function validateItems(header) {
			var showModal = false;
	
			if (header.submodule.teaching) {
				if (header.itemList.length > 0 || header.itemListOtherAct.length > 0) {
					showModal = true;
				}
			}
	
			if (header.submodule.academicManagement) {
				if (header.itemListOtherActAM.length > 0) {
					showModal = true;
				}
			}
	
			return showModal;
		}
	
		function showModalItemRequiredEndPlanning(WorkPlanModalSrv, header) {
			var data = {
				itemOthersActivityRequired: header.itemListOtherAct,
				itemAssignatures: header.itemList,
				itemListOtherActAM: header.itemListOtherActAM
			};
	
			WorkPlanModalSrv.setVariable(data);
			WorkPlanModalSrv.itemRequiredTeaching();
		}
	
		function showModalItemRequiredEndExecution(WorkPlanModalSrv, header) {
			var data = {
				itemActivities: header
			};
	
			WorkPlanModalSrv.setVariable(data);
			WorkPlanModalSrv.itemRequiredExecution();
		}
	
		function getItemsRequiredList(WorkPlanSrv, header) {
			var data = {
				itemListOtherAct: [],
				itemListOtherActAM: [],
				itemList: []
			};
	
			return WorkPlanSrv.getItemRequiredTeaching.getList(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					data.itemListOtherAct = dataReturn.otherActivities;
					data.itemListOtherActAM = dataReturn.otherActivitiesAM;
					var activities = [];
	
					for (var i in dataReturn.assignatures) {
						for (var j in dataReturn.activities) {
							if (dataReturn.assignatures[i].id_assignature === dataReturn.activities[j].id_assignature) {
								activities.push(dataReturn.activities[j]);
							}
						}
						data.itemList.push({
							assignatureName: dataReturn.assignatures[i].assignatureName,
							assignatureId: dataReturn.assignatures[i].id_assignature,
							showChilds: false,
							itemList: activities
						});
						activities = [];
					}
	
					return data;
				} else {
					console.log('Comunications problem with the server');
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post, $mdDialog) {
			var header = {};
	
			return WorkPlanSrv.getSummanyProgress.post({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					header.feedback = post.feedback;
					header.stageId = post.stageId;
					header.teacherId = post.teacherId;
					header.userId = post.userId;
					header.workplanId = post.workplanId;
					header.data = dataReturn.submodulesProgress;
					header.totalHours = dataReturn.totalHoursAllSubmodules;
					header.minHours = dataReturn.minHours;
					header.maxHours = dataReturn.maxHours;
					header.feedback = header.feedback;
					header.isMinHoursPlanning = dataReturn.isMinHoursPlanning == 1 ? true : false;
					header.isMaxHoursPlanning = dataReturn.isMaxHoursPlanning == 1 ? true : false;
					header.isMinHoursExecuted = dataReturn.isMinHoursExecuted == 1 ? true : false;
					header.isMaxHoursExecuted = dataReturn.isMaxHoursExecuted == 1 ? true : false;
					header.isPlanning = 1;
					header.isControlHoursActive = dataReturn.isControlHoursActive;
	
					// if (header.isControlHoursActive && (header.isMinHoursPlanning || header.isMaxHoursPlanning)) {
					// showModalHoursParametrization(header, $mdDialog, WorkPlanModalSrv)
					// } else {
					getModalEndPlanning(header, WorkPlanModalSrv, $mdDialog);
					// }
				}
			});
		}
	
		function getModalEndPlanning(header, WorkPlanModalSrv, $mdDialog) {
			WorkPlanModalSrv.setVariable(header);
	
			return WorkPlanModalSrv.endPlanning().then(function (promise) {
				return WorkPlanModalSrv.getVariable();
			});
		}
	
		function showModalHoursParametrization(header, $mdDialog, WorkPlanModalSrv) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.data = header;
					$scope.close = function () {
						$mdDialog.hide();
	
						return getModalEndPlanning(header, WorkPlanModalSrv);
					};
				}],
				template: __webpack_require__(436),
				clickOutsideToClose: false
			});
		}
	
		// VALIDATIONS SIGNATURE
		return {
			getWorkplans: getWorkplans,
	
			getSummanyProgress: getSummanyProgress,
			setEndExecutionHeader: setEndExecutionHeader,
			setEndAprovalHeader: setEndAprovalHeader,
			setEndEvaluationHeader: setEndEvaluationHeader,
			setEndReviewExecutionHeader: setEndReviewExecutionHeader,
	
			getReviewList: getReviewList,
	
			setDetailsHeader: setDetailsHeader,
			normalizeActivity: normalizeActivity,
			setNullHours: setNullHours,
			setStudentAttentionData: setStudentAttentionData,
			formatSubjectActivity: formatSubjectActivity,
			routeDetails: routeDetails,
			getActivityDetails: getActivityDetails,
			submoduleItemRequired: submoduleItemRequired,
			validateItems: validateItems,
			showModalItemRequiredEndPlanning: showModalItemRequiredEndPlanning,
			showModalItemRequiredEndExecution: showModalItemRequiredEndExecution,
			getItemsRequiredList: getItemsRequiredList,
			showModalEndPlannig: showModalEndPlannig
		};
	};
	
	Requests.$inject = ['Ramda'];
	exports.default = angular.module('services.Requests', []).service('Requests', Requests).name;

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div ng-show=data.isPlanning> <div class=\"col-md-12 text-center\" ng-show=data.isMinHoursPlanning> <h4>El total horas planeadas es menor a las horas mínimas parametrizadas, actualmente tiene {{data.totalHours}} las mismas deben ser mayor a {{data.minHours}}</h4> </div> <div class=\"col-md-12 text-center\" ng-show=data.isMaxHoursPlanning> <h4>El total horas planeadas es mayor a las horas máximas parametrizadas, actualmente tiene {{data.totalHours}} las mismas deben ser menor a {{data.maxHours}} </h4> </div> <div class=\"col-md-12 text-center\" ng-show=\"!data.isMinHoursPlanning && !data.isMaxHoursPlanning\"> <h4>Estimado profesor, gracias por haber diligenciado su plan de trabajo y por permitirnos conocer las actividades que privilegiará durante este año.</h4> </div> </div> <div ng-show=!data.isPlanning> <div class=\"col-md-12 text-center\" ng-show=data.isMinHoursExecuted> <h4>El total horas ejecutadas es menor a las horas mínimas parametrizadas, actualmente tiene {{data.totalHoursExecutedAllSubmodules}} las mismas deben ser mayor a {{data.minHours}}</h4> </div> <div class=\"col-md-12 text-center\" ng-show=data.isMaxHoursExecuted> <h4>El total horas ejecutadas es mayor a las horas máximas parametrizadas, actualmente tiene {{data.totalHoursExecutedAllSubmodules}} las mismas deben ser menor a {{data.maxHours}}</h4> </div> <div class=\"col-md-12 text-center\" ng-show=\"!data.isMinHoursExecuted && !data.isMaxHoursExecuted\"> <h4> Gracias por registrar los avances, logros y ajustes en su plan de trabajo. Esta información le permitirá tanto a usted como a su unidad académica, evidenciar la diversidad de actividades que conforman su quehacer como profesor(a) en la Universidad. Si aún no lo ha hecho, le invitamos a cerrar este proceso diligenciando la encuesta de autoevaluación que encontrará en el sistema <a href={{integralEvaluationURL}} target=_blank>Deja tu Huella.</a> </h4> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _confirm = __webpack_require__(438);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Util = function Util(Ramda, $mdDialog) {
	  _classCallCheck(this, Util);
	
	  var curry = Ramda.curry;
	
	  function setDate(date) {
	    if (date) return (/^\d\d\/\d\d\/\d\d$/.test(date) ? date : moment.utc(date).format('l')
	    );
	    return 'NA';
	  }
	
	  function unique(list) {
	    return typeof list === 'string' ? [].concat(_toConsumableArray(new Set(list.split(',')))) : [].concat(_toConsumableArray(new Set(list)));
	  }
	
	  function objHas(obj, prop) {
	    return Reflect.has(obj, prop);
	  }
	
	  var confirm = curry(function (message, event, successfulEvent) {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        angular.extend(this, {
	          message: message,
	          event: event,
	          successfulEvent: successfulEvent,
	          close: function close() {
	            return $mdDialog.hide();
	          }
	        });
	      }],
	      controllerAs: 'vm',
	      template: _confirm2.default,
	      clickOutsideToClose: false
	    });
	  });
	
	  return {
	    setDate: setDate,
	    unique: unique,
	    objHas: objHas,
	    confirm: confirm
	  };
	};
	
	Util.$inject = ['Ramda', '$mdDialog'];
	exports.default = angular.module('services.Util', []).service('Util', Util).name;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=vm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>{{ vm.message }}</h3> <p class=m-t-md>{{ vm.event }} <strong>\" {{ vm.successfulEvent }} \"</strong> se ha guardado con éxito.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=vm.close()> Aceptar </md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.periodPicker = undefined;
	
	var _periodPicker = __webpack_require__(440);
	
	var _periodPicker2 = _interopRequireDefault(_periodPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodPicker = exports.periodPicker = {
	  bindings: {
	    onChange: '&',
	    toggleRange: '&',
	    typePeriod: '<',
	    formReference: '<',
	    rangeType: '<',
	    startDate: '<',
	    endDate: '<',
	    periodsArray: '<'
	  },
	  template: _periodPicker2.default,
	  controllerAs: 'vm',
	  controller: ['GlobalConfig', function periodPickerCtrl(GlobalConfig) {
	    var _this = this;
	
	    angular.extend(this, {
	      selectedTypePeriod: {},
	      isTouchedPeriods: true,
	      // minStartDate: new Date(),
	      // minEndDate: new Date(),
	      minStartDate: moment(this.startDate)._d,
	      //minStartDateVALUE:moment('2018-02-01T00:00:00.000')._d,
	      minEndDate: moment(this.endDate)._d,
	      //minEndDate: new Date(),
	      showType: 'PERIODS'
	    });
	    var periodsId = GlobalConfig.periods.rangeType;
	
	    this.$onInit = function () {
	      _this.showType = Number(_this.rangeType) === periodsId ? 'PERIODS' : 'DATES';
	    };
	
	    this.$onChanges = function () {
	      _this.showType = Number(_this.rangeType) === 1 ? 'PERIODS' : 'DATES';
	      if (_this.periodsArray.length > 0) _this.periodsArray.forEach(function (id) {
	        _this.selectedTypePeriod[id] = true;
	      });
	    };
	
	    var validateCheklistPeriods = function validateCheklistPeriods() {
	      return Number(_this.rangeType) === periodsId ? _this.periodsArray.length < 1 : false;
	    };
	
	    var setVariables = function setVariables(bool) {
	      _this.showType = bool ? 'PERIODS' : 'DATES';
	      if (bool) {
	        _this.startDate = null;
	        _this.endDate = null;
	      } else {
	        _this.periodsArray = [];
	        _this.selectedTypePeriod = null;
	        _this.startDate = null;
	        _this.endDate = null;
	      }
	    };
	
	    var funSelectedPeriod = function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!_this.periodsArray.includes(period.periodId)) {
	          _this.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = _this.periodsArray.indexOf(period.periodId);
	        if (index !== -1) {
	          _this.periodsArray.splice(index, 1);
	        }
	      }
	      _this.isTouchedPeriods = true;
	      return { value: { periods: _this.periodsArray, dates: [_this.startDate, _this.endDate] } };
	    };
	
	    var startDateChange = function startDateChange() {
	      var m = moment(_this.startDate);
	      _this.minEndDates = m.isValid() ? m.toDate() : null;
	      return { value: { periods: _this.periodsArray, dates: [_this.startDate, _this.endDate] } };
	    };
	
	    angular.extend(this, {
	      setVariables: setVariables,
	      funSelectedPeriod: funSelectedPeriod,
	      startDateChange: startDateChange,
	      validateCheklistPeriods: validateCheklistPeriods
	    });
	  }]
	};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <h2 class=\"text-azul font-bold text-base left\">Planeación de tiempos de dedicación</h2> <div class=\"col-md-12 no-padding\"> <h5 class=\"text-xs left\">Seleccione la forma en que se realizar&aacute; la planeaci&oacute;n *</h5> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=vm.rangeType ng-click=vm.setVariables(true) ng-change=\"vm.toggleRange({type: vm.rangeType})\" value=1> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=vm.rangeType ng-click=vm.setVariables(false) ng-change=\"vm.toggleRange({type: vm.rangeType})\" value=2> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"vm.showType === 'PERIODS'\"> <div class=\"col-md-12 no-padding-l has-error\"> <label class=\"control-label left\" ng-show=\"vm.isTouchedPeriods && vm.validateCheklistPeriods()\"> Por favor seleccione al menos 1 período. </label> </div> <h5 class=\"text-xs left\">Seleccione los períodos donde se desempeñará:</h5> <div ng-repeat=\"period in vm.typePeriod\" class=left> <md-checkbox name=period class=\"md-green m-r-sm text-sm\" type=checkbox ng-model=vm.selectedTypePeriod[period.periodId] ng-value=period.periodId ng-change=\"vm.onChange(vm.funSelectedPeriod(period, vm.selectedTypePeriod[period.periodId]))\"> {{period.periodName}} </md-checkbox> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"vm.showType === 'DATES'\"> <div class=\"col-md-12 no-padding-l has-error\"> <label class=\"control-label left\" ng-show=\"!vm.startDate && !vm.endDate\"> El rango de fecha es obligatorio. </label> </div> <h5 class=\"text-xs left\">Seleccione un rango de fecha de inicio y fin:</h5> <div class=\"col-md-5 no-padding\" ng-class=vm.hasError(vm.formReference.startDate)> <label class=\"control-label col-md-12\" for=startDate>Fecha inicio</label> <md-datepicker ng-model=vm.startDate name=startDate md-placeholder=dd/mm/aaaa md-min-date=vm.minStartDate md-max-date=vm.minEndDate ng-change=vm.onChange(vm.startDateChange()) md-open-on-focus onkeydown=return!1 required> </md-datepicker> </div> <div class=\"col-md-5 no-padding m-l\" ng-class=vm.hasError(vm.formReference.endDate)> <label class=\"control-label col-md-12\" for=endDate>Fecha fin</label> <md-datepicker ng-model=vm.endDate name=endDate md-placeholder=dd/mm/aaaa required md-min-date=vm.minEndDates ng-change=vm.onChange(vm.startDateChange()) md-open-on-focus ng-disabled=!vm.startDate onkeydown=return!1> </md-datepicker> </div> </div> </div> ";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchBar = undefined;
	
	var _searchBar = __webpack_require__(442);
	
	var _searchBar2 = _interopRequireDefault(_searchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchBar = exports.searchBar = {
	  bindings: {
	    onChange: '&',
	    searchIcon: '<',
	    iconSize: '<',
	    barStyle: '<',
	    opacity: '<'
	  },
	  template: _searchBar2.default,
	  controllerAs: 'vm',
	  controller: ['CssClasses', function searchBarCtrl(CssClasses) {
	    var vm = this;
	    vm.search = CssClasses.icons.search;
	    vm.$onInit = function () {
	      vm.transparent = vm.opacity ? ['transparent', 'opacity-4'] : '';
	      vm.iconClasses = [vm.search, 'i-' + vm.iconSize, vm.transparent[1]];
	      vm.barClasses = [vm.barStyle, vm.transparent[0]];
	    };
	  }] };

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-12 input-group\"> <input id=search-box type=text placeholder=Buscar... class=\"form-control no-brd\" ng-class=vm.barClasses ng-model=vm.filter ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.onChange({search: vm.filter})\"/> <span class=\"input-group-addon squarerify no-brd\" ng-class=vm.barClasses> <i ng-class=vm.iconClasses ng-show=vm.searchIcon></i> </span> </div> ";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.activitiesReview = undefined;
	
	var _activitiesReview = __webpack_require__(444);
	
	var _activitiesReview2 = _interopRequireDefault(_activitiesReview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var activitiesReview = exports.activitiesReview = {
		template: _activitiesReview2.default,
		controllerAs: 'vm',
		controller: ['$state', '$cookies', '$stateParams', '$mdToast', 'GlobalConfig', 'WorkPlanSrv', 'WorkPlanModalSrv', 'ReviewSrv', 'Validations', 'Setters', 'Requests', '$scope', '$rootScope', 'GlobalSrv', function activitiesReviewCtrl($state, $cookies, $stateParams, $mdToast, GlobalConfig, WorkPlanSrv, WorkPlanModalSrv, ReviewSrv, Validations, Setters, Requests, $scope, $rootScope, GlobalSrv) {
			var _this = this;
	
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var currentModule = $state.current.module;
			var modules = GlobalConfig.modules; // Object.keys(GlobalConfig.modules)
	
			var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
			var validBitacora = currentRoleId == 18 ? true : false;
			var validUser = Validations.validUser(currentRoleId, currentStage);
	
			$scope.wpId = $stateParams.workplanId;
			this.hasDetails = false;
	
			// constants
			angular.extend(this, {
				currentStage: currentStage,
				currentModule: currentModule,
				mainLabel: $state.current.data.displayName,
				inExecution: Validations.inExecution(currentStage)
			});
	
			// variables
			$scope.isLoading = true;
			this.imgEmpty = __webpack_require__(445);
			this.teacher = $stateParams.name || $cookies.get('teacherNameSelected');
			var teacherId = $stateParams.teacherId || JSON.parse($cookies.get('currentUser')).teacherId;
			var workplanId = $stateParams.workplanId || JSON.parse($cookies.get('currentUser')).workplanId;
	
			var formatActivity = Setters.formatActivity(Setters.setTagName(Validations));
			var getReviewList = Requests.getReviewList(teacherId, workplanId, ReviewSrv, false);
	
			var setDetailsHeader = Requests.setDetailsHeader(Validations);
			var getActivityDetails = Requests.getActivityDetails(ReviewSrv, setDetailsHeader);
	
			var formatSubjectActivity = Requests.formatSubjectActivity(Requests.normalizeActivity(Requests.setNullHours));
			var routeDetails = Requests.routeDetails(Validations, Requests.setNullHours, Requests.setStudentAttentionData, formatSubjectActivity);
	
			var _moduleName = '';
	
			$rootScope.setHandsProgress = false;
	
			// variables
			angular.extend(this, {
				activities: [],
				showData: false,
				viewLoaded: true,
				filter: '',
				selectedActivity: null,
				details: null, // detailed data of selected activity
				isLoadingDetails: false, // circular loading animation for details data
				noData: false,
				bitacora: { hide: true, tagName: '' },
				planning: [], // custom variable for Subject activities
				teaching: [], // custom variable for Subject activities
				otherActivity: [], // custom variable for Other Activities (teaching) activities
				teacherId: teacherId,
				workplanId: workplanId
			});
	
			// methods
			angular.extend(this, {
				loadDetails: loadDetails,
				updateFilter: function updateFilter(val) {
					_this.filter = val;
				},
				thereIsDetails: function thereIsDetails() {
					return _this.details !== null;
				}
			});
	
			// services
	
			this.$onInit = function () {
				unauthorize(validUser);
				_moduleName = Object.keys(modules).find(function (key) {
					return modules[key] === currentModule;
				});
				getReviewList(_moduleName).then(function (data) {
					_this.activities = formatActivity(data, 0); // Setters.sortActivitiesList(formatActivity(data))
	
					if (_this.activities.length > 0) _this.loadDetails(_this.activities.find(function (activity) {
						return activity !== undefined;
					}));
	
					$scope.isLoading = false;
				});
			};
	
			function unauthorize(authorized) {
				if (!authorized) $state.go('app.unauthorized');
			}
	
			function getFieldUpdate(stage) {
				switch (stage) {
	
					case 'review':
						return 'isReviewed';
					case 'approval':
						return 'isApproved';
					case 'evaluation':
						return 'isAccept';
					case 'execution':
						return 'isApproved';
					case 'reviewExecution':
						return 'isExecution';
	
				}
			}
	
			function calcHours(arr, param) {
				return arr.reduce(function (accumulator, current) {
					return accumulator + current[param];
				}, 0);
			}
	
			function loadDetails(activity, index) {
				var _this2 = this;
	
				activity.userId = JSON.parse($cookies.get('currentUser')).id;
				this.details = null;
				this.hasDetails = this.thereIsDetails();
				this.noData = Validations.isSubjectType(activity) && activity.isForPlan === 0;
	
				if (!this.noData) {
					$rootScope.setHandsProgress = true;
					this.bitacora.hide = validBitacora;
					this.bitacora.tagName = activity.tagName;
					this.activityTypeId = activity.activityTypeId;
					this.workplanTeacherId = activity.workplanTeacherId;
					this.isLoadingDetails = true;
					this.selectedActivity = activity;
	
					GlobalSrv.subscribe($scope, $rootScope, 'ApproveRepprove', function (data) {
						_this2.selectedActivity.isApproved = data.status;
						_this2.activities.find(function (act) {
							return data.activity.workplanTeacherActivityId === act.workplanTeacherActivityId;
						})[getFieldUpdate(data.currentStage)] = data.status;
					});
	
					isStageFinish(teacherId).then(function (stage) {
						getActivityDetails(_moduleName, activity).then(function (detailsResponse) {
							if (detailsResponse === 'error in communication' && !detailsResponse.status) {
								_this2.noData = true;
								_this2.details = null;
								$rootScope.setHandsProgress = false;
								_this2.isLoadingDetails = false;
	
								return;
							}
	
							var dataActivity = detailsResponse.data || detailsResponse.parent || detailsResponse;
	
							if (index >= 0) {
								if (dataActivity.header && dataActivity.header.length) {
									_this2.activities[index].workplanTeacherActivityId = dataActivity.header[0].workplanTeacherActivityId;
								} else {
									_this2.activities[index].workplanTeacherActivityId = dataActivity.workplanTeacherActivityId;
								}
							} else if (_this2.activities.length && !index) {
								if (dataActivity.header && dataActivity.header.length) {
									_this2.activities[0].workplanTeacherActivityId = dataActivity.header[0].workplanTeacherActivityId;
								} else {
									_this2.activities[0].workplanTeacherActivityId = dataActivity.workplanTeacherActivityId;
								}
							}
	
							$cookies.put('executionFinish', stage.executionFinish);
							_this2.details = routeDetails(_moduleName, activity, detailsResponse);
							_this2.hasDetails = _this2.thereIsDetails();
							_this2.details.data.isItemRequired = 0;
	
							if (Validations.isSubjectType(activity)) {
								_this2.details.data.isItemRequired = detailsResponse.data.isItemRequired;
							}
	
							if (_this2.details.data) {
								_this2.details.data.isBlocked = 0;
								_this2.details.data.userId = stage.userId;
								_this2.details.data.executionFinish = stage.executionFinish !== 'error' ? stage.executionFinish : null;
								_this2.details.data.approvedFinish = stage.approvedFinish;
								_this2.details.data.evaluationFinish = stage.evaluationFinished;
								_this2.details.data.reviewedFinish = stage.reviewedFinish;
								_this2.details.data.executionReviewedFinished = stage.executionReviewedFinished;
								_this2.details.data.feedback = stage.isFeedback;
								_this2.details.data.isState = stage.isState;
								_this2.details.data.planningFinish = stage.planningFinish;
								_this2.details.data.stageId = stage.stageId;
								_this2.details.data.totalExecutedHours = _this2.details.children ? calcHours(_this2.details.children, 'hoursExecuted') : 0;
								_this2.details.data.totalPlannedHours = _this2.details.children ? calcHours(_this2.details.children, 'hoursPlanned') : 0;
	
								if (_this2.details.data.hoursExecuted === 0) {
									_this2.details.data.isBlocked = 1;
								}
							} else {
								_this2.noData = true;
								_this2.details = null;
							}
	
							$rootScope.setHandsProgress = false;
							_this2.isLoadingDetails = false;
						});
					});
				}
			}
	
			function isStageFinish(teacherIds) {
				return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: teacherId, wp: $scope.wpId }).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						var stage = dataReturn.data.wokplanTeacherStatus[0];
	
						$cookies.put('workplan-approvedFinish', stage.approvedFinish);
						$cookies.put('workplan-executionFinish', stage.executionFinish);
	
						return stage;
					}
	
					return null;
				});
			}
	
			GlobalSrv.subscribe($scope, $rootScope, 'isStrategicTracing', function (data) {
				_this.selectedActivity.isStrategicTracing = data.isStrategicTracing;
				_this.activities.find(function (act) {
					return data.workplanTeacherActivityId === act.workplanTeacherActivityId;
				}).isStrategicTracing = data.isStrategicTracing;
			});
		}]
	};

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = "<header teacher-name=::vm.teacher teacher-id=::vm.teacherId workplan-id=::vm.workplanId activitytype-id=::vm.activityTypeId workplanteacher-id=::vm.workplanTeacherId btn-bitacora=vm.bitacora></header> <div class=\"w-100 blanco\"> <div> <div class=\"col-md-5 no-padding rightDivider\" style=z-index:1> <p class=\"text-gris-dark exo p-l-md\" ng-show=::vm.inReview> Listado de Actividades de {{ vm.mainLabel }} </p> <md-divider></md-divider> <search-bar search-icon=true icon-size=20 opacity=true bar-style=\"'m-r p-l-md'\" on-change=vm.updateFilter(search)> </search-bar> <md-divider></md-divider> <div class=text-center ng-if=isLoading> <md-progress-circular style=display:inline-block;color:#fff!important class=md-hue-2 md-diameter=80px></md-progress-circular> <div><span class=\"text-negro text-left text-md\">Cargando listado...</span></div> </div> <activities-list activities=vm.activities filtering=vm.filter on-click=\"vm.loadDetails(activity, index)\"> </activities-list> </div> <activity-details ng-if=vm.hasDetails activity=::vm.selectedActivity class=mainActivityDetails details=vm.details module=::vm.currentModule label=::vm.mainLabel> </activity-details> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=vm.isLoadingDetails> <div class=text-center ng-if=!vm.hasDetails> <md-progress-circular style=display:inline-block;color:#fff!important class=md-hue-2 md-diameter=80px></md-progress-circular> <div><span class=\"text-negro text-left text-md\">Cargando detalles...</span></div> </div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=vm.noData> <h3>La actividad no está planeada</h3> </div> </div> </div> ";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2db093b0e5c7d6bc170eeb84cbfa709f.svg";

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.history = undefined;
	
	var _history = __webpack_require__(447);
	
	var _history2 = _interopRequireDefault(_history);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var history = exports.history = {
		template: _history2.default,
		controllerAs: 'vm',
		controller: ['$rootScope', '$cookies', 'ReviewSrv', 'GlobalConfig', 'CssClasses', 'Validations', 'Setters', 'Requests', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', '$mdDialog', '$state', '$scope', '$sessionStorage', '$mdToast', function historyCtrl($rootScope, $cookies, ReviewSrv, GlobalConfig, CssClasses, Validations, Setters, Requests, WorkPlanSrv, WorkPlanModalSrv, $stateParams, $mdDialog, $state, $scope, $sessionStorage, $mdToast) {
			var _this = this;
	
			// constants
			var _modulesNames = GlobalConfig.modulesNames; // GlobalConfig.modulesOrderTab
			var _modulesIds = GlobalConfig.modules;
			var user = JSON.parse($cookies.get('currentUser'));
			var roleId = +$cookies.get('hasRoleId');
	
			var getWorkplans = Requests.getWorkplans(ReviewSrv);
			var getReviewList = Requests.getReviewList();
	
			var formatActivity = Setters.formatActivity(Setters.setTagName(Validations));
			var setEndExecutionHeader = Requests.setEndExecutionHeader(GlobalConfig);
	
			var setDetailsHeader = Requests.setDetailsHeader(Validations);
			var getActivityDetails = Requests.getActivityDetails(ReviewSrv, setDetailsHeader);
			var getSummanyProgress = Requests.getSummanyProgress(WorkPlanSrv);
	
			// variables
			var _currentModule = GlobalConfig.modules.teaching;
	
			var _label = GlobalConfig.modulesNames.teaching;
	
			var _status = false;
	
			if ($sessionStorage.workPlanGeneralList != undefined) {
				var _workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	
				_status = _workPlanGeneralList.wokplanTeacherStatus[0];
			}
	
			var _workplans = [];
			var _selectedWorkplan = null;
			var _selectedActivity = {};
			var _isFeedback = 0;
			var _stageId = 0;
			var itemList = [];
			var iconClasses = ['mdi-hardware-keyboard-arrow-down', 'mdi-hardware-keyboard-arrow-up'];
			var post = {
				workplanId: JSON.parse($cookies.get('currentUser')).workplanId || $stateParams.workplanId,
				teacherId: JSON.parse($cookies.get('currentUser')).teacherId
			};
	
			var normalizeActivity = Requests.normalizeActivity(Requests.setNullHours);
			var formatSubjectActivity = Requests.formatSubjectActivity(normalizeActivity);
			var routeDetails = Requests.routeDetails(Validations, Requests.setNullHours, Requests.setStudentAttentionData, formatSubjectActivity);
	
			$scope.module = '';
	
			angular.extend(this, {
				// variables
				get modules() {
					return _modulesNames;
				},
				get modulesIds() {
					return _modulesIds;
				},
				get inModule() {
					return _currentModule;
				},
				set inModule(value) {
					_currentModule = value;
	
					return value;
				},
				get currentLabel() {
					return _label;
				},
				set currentLabel(value) {
					_label = value;
	
					return value;
				},
				get workplans() {
					return _workplans;
				},
				set workplans(value) {
					_workplans = value;
	
					return value;
				},
				get selectedWorkplan() {
					return _selectedWorkplan;
				},
				set selectedWorkplan(value) {
					_selectedWorkplan = value;
	
					return value;
				},
				get selectedActivity() {
					return _selectedActivity;
				},
				set selectedActivity(value) {
					_selectedActivity = value;
	
					return value;
				},
				keys: [],
				activities: [],
				details: null,
				filter: '',
				isLoadingDetails: false,
				loadDetails: loadDetails,
				selectedTab: null,
				planningFinish: 1,
				executionFinish: 1,
				currentStage: $stateParams.stage,
				stageName: GlobalConfig.workplanStagesNames.planning,
				recordTeacher: [],
				showTable: true,
				inHistory: true,
				iconClasses: ['mdi-hardware-keyboard-arrow-down', 'mdi-hardware-keyboard-arrow-up'],
				class: iconClasses[1],
				title: null,
				// methods
				updateFilter: function updateFilter(val) {
					_this.filter = val;
				},
	
				loadListData: loadListData,
				thereIsDetails: thereIsDetails,
				endPlanning: endPlanning,
				isButtonDisabled: isButtonDisabled,
				showFinishButton: true,
				hiddenTable: hiddenTable,
				endStage: endStage,
				downloadPdf: downloadPdf,
				pdfReporthistoricalWorkplan: pdfReporthistoricalWorkplan,
				prepareInformation: prepareInformation,
				clean: function clean(module) {
					_this.activities = [];
					_this.details = null;
					_this.loadListData(_this.selectedWorkplan, 1, module);
				}
	
			});
	
			this.$onInit = function () {
				_this.downloadRequests = 0;
	
				if (roleId === GlobalConfig.userRolesIds.workPlanAdmin || roleId === GlobalConfig.userRolesIds.unitAdmin || roleId === GlobalConfig.userRolesIds.gerencialConsultant) {
					_this.showFinishButton = false;
				}
	
				if ($cookies.get('isReproved') && JSON.parse($cookies.get('isReproved')) && roleId != GlobalConfig.userRolesIds.workplanCommittee) {
					showModalReactivateWorkplan(_this);
				} else {
					getData(_this);
				}
			};
	
			function getData(obj) {
				//Se setean las variables a utilizar para la vista de Planes Trabajos (Resumen/Historial)
				if ($stateParams.currentStage) {
					obj.currentStage = $stateParams.currentStage;
					post.workplanId = $stateParams.workplanId;
					post.teacherId = $stateParams.teacherId;
					user.teacherId = $stateParams.teacherId;
					user.workplanId = $stateParams.workplanId;
				}
	
				if ($stateParams.teacherId) user.teacherId = $stateParams.teacherId;
	
				obj.stageName = obj.currentStage !== 'planning' ? GlobalConfig.workplanStagesNames.execution : obj.stageName;
				obj.keys = Object.keys(obj.modules);
				obj.keys.splice(5, 1);
				var previousState = Reflect.has($rootScope, 'previousState') ? $rootScope.previousState : {};
				var module = Reflect.has(previousState, 'moduleId') ? previousState.moduleId : false;
	
				getRecordTeacher(post, obj);
				var modsArr = [_modulesIds.teaching, _modulesIds.investigation, _modulesIds.extentionAndVisibility, _modulesIds.academicManagement, _modulesIds.consolidation];
	
				obj.modsArr = modsArr;
				obj.selectedTab = module ? modsArr.indexOf(module) : 0;
				getWorkplans(user).then(function (data) {
					obj.workplans = data;
					obj.selectedWorkplan = obj.workplans[0].workplanId;
					previousState ? obj.loadListData(obj.selectedWorkplan, obj.keys[obj.selectedTab]) : obj.loadListData(obj.selectedWorkplan);
				});
			}
			// LOAD LIST DATA
	
			function setModule(obj, module) {
				if (module) {
					return module;
				}
	
				return obj.keys[obj.inModule - 2];
			}
	
			function showToast(message, isError) {
				$mdToast.show($mdToast.simple().textContent(message).position('bottom right').hideDelay(isError ? 5000 : 3000));
			}
	
			function downloadPdf(workplan) {
				var _this2 = this;
	
				showToast('Generando reporte PDF...', false);
				this.result = [];
	
				// Obtener datos actualizados del workplan antes de generar el PDF
				var post = {
					teacherId: user.teacherId,
					workplanId: workplan
				};
	
				getRecordTeacher(post, this).then(function () {
					// Usar recordTeacher para obtener el nombre del workplan
					_this2.selectWorkPlan = _this2.workplans.find(function (e) {
						return e.workplanId === workplan;
					});
	
					// Si no se encuentra en workplans, crear un objeto con los datos básicos
					if (!_this2.selectWorkPlan) {
						_this2.selectWorkPlan = {
							workplanId: workplan,
							workplanName: 'Plan de trabajo ' + workplan
						};
					}
	
					var promises = _this2.keys.map(function (e) {
						return getReviewList(user.teacherId, workplan, ReviewSrv, workplan, e).then(function (data) {
							if (e !== 'teaching') {
								return data;
							}
	
							var promises = data.map(function (activity) {
								//load details
								return getActivityDetails(e, activity).then(function (details) {
									var detailsData = routeDetails(e, activity, details);
	
									if (detailsData.data) {
										detailsData.data.totalExecutedHours = detailsData.children ? calcHours(detailsData.children, 'hoursExecuted') : 0;
										detailsData.data.totalPlannedHours = detailsData.children ? calcHours(detailsData.children, 'hoursPlanned') : 0;
										activity.details = detailsData;
									} else {
										activity.details = null;
									}
								});
							});
	
							return Promise.all(promises).then(function () {
								return data;
							});
						}).then(function (data) {
							data.push(_this2.modules[e]);
							_this2.result.push(data);
						});
					});
	
					Promise.all(promises).then(function () {
						_this2.prepareInformation();
					}).catch(function (error) {
						console.log(error);
						showToast('Error al generar el reporte PDF', true);
					});
				});
			}
	
			function prepareInformation() {
				var _this3 = this;
	
				this.data = [];
				this.summary = [];
	
				this.result.forEach(function (tipo) {
					switch (tipo[tipo.length - 1]) {
	
						case 'Docencia':
							var docenciaArray = [];
	
							_this3.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0
							};
	
							var nonAsignatureArray = [{
								table: {
									widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
									body: [[{ text: 'Docencia - Otras Actividades de Docencia', colSpan: 5, alignment: 'center', bold: true }, '', '', '', ''], [{ text: 'Actividad', alignment: 'center', bold: true }, { text: 'Tipo', alignment: 'center', bold: true }, { text: 'Detalle', alignment: 'center', bold: true }, { text: 'Planeación', alignment: 'center', bold: true }, { text: 'Ejecución', alignment: 'center', bold: true }]]
								}
							}];
	
							var asignatureArray = [{
								table: {
									widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
									body: [[{ text: 'Docencia - Asignatura a Cargo', colSpan: 10, alignment: 'center', bold: true }, '', '', '', '', '', '', '', '', ''], [{ text: 'Periodo', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Nombre', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Nivel', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Tipo', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Modalidad', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Nro de grupos', rowSpan: 2, alignment: 'center', bold: true }, { text: 'Planeación', colSpan: 2, alignment: 'center', bold: true }, '', { text: 'Ejecución', colSpan: 2, alignment: 'center', bold: true }, ''], ['', '', '', '', '', '', { text: 'Horas directa', alignment: 'center', bold: true }, { text: 'Horas indirecta', alignment: 'center', bold: true }, { text: 'Horas directa', alignment: 'center', bold: true }, { text: 'Horas indirecta', alignment: 'center', bold: true }]],
									dontBreakRows: true
								}
							}, {
								text: '\n',
								style: 'anotherStyle'
							}];
	
							tipo.forEach(function (dato, index) {
								if (tipo.length - 1 > index) {
									_this3.summary[tipo[tipo.length - 1]].planning = _this3.summary[tipo[tipo.length - 1]].planning + dato.totalHoursPlanned;
									_this3.summary[tipo[tipo.length - 1]].executed = _this3.summary[tipo[tipo.length - 1]].executed + dato.totalHoursExecuted;
	
									if (dato.asignatureName == undefined) {
										nonAsignatureArray[0].table.body.push([{ text: dato.activityTypeName }, { text: dato.scheduleTypeName ? dato.scheduleTypeName : dato.activityTypeNameCombo }, { text: (dato.details && dato.details.data && dato.details.data.daysNames ? dato.details.data.daysNames : dato.description) || '' }, { text: dato.totalHoursPlanned || '' }, { text: dato.totalHoursExecuted || '' }]);
									} else {
										asignatureArray[0].table.body.push([{ text: dato.periodicityName, alignment: 'center' }, { text: dato.asignatureName, alignment: 'center' }, { text: dato.asignatureLevel, alignment: 'center' }, { text: dato.asignatureType, alignment: 'center' }, { text: dato.asignatureModality, alignment: 'center' }, { text: dato.groupsTempNum, alignment: 'center' }, { text: dato.details && dato.details.data && dato.details.data.hoursPlanned ? dato.details.data.hoursPlanned : 0, alignment: 'center' }, { text: (dato.details && dato.details.planning ? dato.details.planning['totalPlannedHours'] : 0) + (dato.details && dato.details.teaching ? dato.details.teaching['totalPlannedHours'] : 0), alignment: 'center' }, { text: dato.details && dato.details.data && dato.details.data.hoursExecuted ? dato.details.data.hoursExecuted : 0, alignment: 'center' }, { text: (dato.details && dato.details.planning ? dato.details.planning['totalExecutedHours'] : 0) + (dato.details && dato.details.teaching ? dato.details.teaching['totalExecutedHours'] : 0), alignment: 'center' }]);
										var asignature = {
											table: {
												widths: [120, 120, 120, 120],
												body: [[{ text: dato.asignatureName + ' ' + dato.periodicityName, colSpan: 4, alignment: 'center', bold: true }, '', '', ''], [{ text: 'Actividad', alignment: 'center', bold: true }, { text: 'Detalle', alignment: 'center', bold: true }, { text: 'Planeación', alignment: 'center', bold: true }, { text: 'Ejecución', alignment: 'center', bold: true }]]
	
											}
										};
	
										if (dato.details && dato.details.planning && dato.details.planning.length > 0) {
											dato.details.planning.forEach(function (item, index) {
												asignature.table.body.push([{ text: 'Planeación y Gestión', rowSpan: index == 0 ? dato.details.planning.length : 1, alignment: 'center', bold: true }, { text: item.name, alignment: 'center' }, { text: item.hoursPlanned, alignment: 'center' }, { text: item.hoursExecuted, alignment: 'center' }]);
											});
										} else {
											asignature.table.body.push([{ text: 'Planeación y Gestión', alignment: 'center', bold: true }, { text: '', alignment: 'center' }, { text: 0, alignment: 'center' }, { text: 0, alignment: 'center' }]);
										}
	
										if (dato.details && dato.details.teaching && dato.details.teaching.length > 0) {
											dato.details.teaching.forEach(function (item, index) {
												asignature.table.body.push([{ text: 'Formación Jóvenes Docentes', rowSpan: index == 0 ? dato.details.teaching.length : 1, alignment: 'center', bold: true }, { text: item.name, alignment: 'center' }, { text: item.hoursPlanned, alignment: 'center' }, { text: item.hoursExecuted, alignment: 'center' }]);
											});
										} else {
											asignature.table.body.push([{ text: 'Formación Jóvenes Docentes', alignment: 'center', bold: true }, { text: '', alignment: 'center' }, { text: 0, alignment: 'center' }, { text: 0, alignment: 'center' }]);
										}
	
										asignatureArray.push(asignature);
										asignatureArray.push({
											text: '\n',
											style: 'anotherStyle'
										});
									}
								}
							});
							docenciaArray.push(asignatureArray);
							docenciaArray.push(nonAsignatureArray);
	
							_this3.data[tipo[tipo.length - 1]] = docenciaArray;
							break;
						case 'Investigación e innovación':
							var investigacionArray = [];
	
							_this3.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0
							};
	
							investigacionArray.push( //[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
							[{ text: 'Periodo', fontSize: 10, bold: true }, { text: 'Subactividad', fontSize: 10, bold: true }, { text: 'Actividad', fontSize: 10, bold: true }, { text: 'Descripción', fontSize: 10, bold: true }, { text: 'Total hrs planeadas', fontSize: 10, bold: true }, { text: 'Total hrs ejecutadas', fontSize: 10, bold: true }]);
							tipo.forEach(function (dato, index) {
								if (tipo.length - 1 > index) {
									_this3.summary[tipo[tipo.length - 1]].planning = _this3.summary[tipo[tipo.length - 1]].planning + dato.totalHoursPlanned;
									_this3.summary[tipo[tipo.length - 1]].executed = _this3.summary[tipo[tipo.length - 1]].executed + dato.totalHoursExecuted;
									var executedHours = dato.totalHoursExecuted == null ? 0 : dato.totalHoursExecuted;
									investigacionArray.push([{ text: dato.periodicityName || '' }, { text: dato.activityTypeName || '' }, { text: dato.name || '' }, { text: dato.description || '' }, { text: dato.totalHoursPlanned || 0 }, { text: executedHours }]);
								}
							});
							_this3.data[tipo[tipo.length - 1]] = investigacionArray;
							break;
						case 'Extensión y visibilidad':
							var extensionArray = [];
	
							_this3.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0
							};
	
							extensionArray.push( //[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
							[{ text: 'Periodo', fontSize: 10, bold: true }, { text: 'Subactividad', fontSize: 10, bold: true }, { text: 'Actividad', fontSize: 10, bold: true }, { text: 'Descripción', fontSize: 10, bold: true }, { text: 'Total hrs planeadas', fontSize: 10, bold: true }, { text: 'Total hrs ejecutadas', fontSize: 10, bold: true }]);
							tipo.forEach(function (dato, index) {
								if (tipo.length - 1 > index) {
									_this3.summary[tipo[tipo.length - 1]].planning = _this3.summary[tipo[tipo.length - 1]].planning + dato.totalHoursPlanned;
									_this3.summary[tipo[tipo.length - 1]].executed = _this3.summary[tipo[tipo.length - 1]].executed + dato.totalHoursExecuted;
									extensionArray.push([{ text: dato.periodicityName || '' }, { text: dato.activityTypeName || '' }, { text: dato.name || '' }, { text: dato.description || '' }, { text: dato.totalHoursPlanned || 0 }, { text: dato.totalHoursExecuted || 0 }]);
								}
							});
							_this3.data[tipo[tipo.length - 1]] = extensionArray;
							break;
						case 'Gestión académica':
							var gestionArray = [];
	
							_this3.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0
							};
	
							gestionArray.push( //[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
							[{ text: 'Periodo', fontSize: 10, bold: true }, { text: 'Subactividad', fontSize: 10, bold: true }, { text: 'Actividad', fontSize: 10, bold: true }, { text: 'Descripción', fontSize: 10, bold: true }, { text: 'Total hrs planeadas', fontSize: 10, bold: true }, { text: 'Total hrs ejecutadas', fontSize: 10, bold: true }]);
							tipo.forEach(function (dato, index) {
								if (tipo.length - 1 > index) {
									_this3.summary[tipo[tipo.length - 1]].planning = _this3.summary[tipo[tipo.length - 1]].planning + dato.totalHoursPlanned;
									_this3.summary[tipo[tipo.length - 1]].executed = _this3.summary[tipo[tipo.length - 1]].executed + dato.totalHoursExecuted;
									var name = dato.academicUnitName == null ? dato.otherActivityItemName == null ? dato.activityTypeName : dato.otherActivityItemName : dato.academicUnitName;
									gestionArray.push([{ text: dato.periodicityName || '' }, { text: dato.activityTypeName || '' }, { text: name || '' }, { text: dato.description || '' }, { text: dato.totalHoursPlanned || 0 }, { text: dato.totalHoursExecuted || 0 }]);
								}
							});
							_this3.data[tipo[tipo.length - 1]] = gestionArray;
							break;
						case 'Consolidación de cuerpo profesoral':
							var consolidacionArray = [];
	
							_this3.summary[tipo[tipo.length - 1]] = {
								planning: 0,
								executed: 0
							};
	
							consolidacionArray.push( //[ { text: tipo[tipo.length - 1], style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true }, {}, {}, {}, {} ],
							[{ text: 'Periodo', fontSize: 10, bold: true }, { text: 'Subactividad', fontSize: 10, bold: true }, { text: 'Actividad', fontSize: 10, bold: true }, { text: 'Descripción', fontSize: 10, bold: true }, { text: 'Total hrs planeadas', fontSize: 10, bold: true }, { text: 'Total hrs ejecutadas', fontSize: 10, bold: true }]);
							tipo.forEach(function (dato, index) {
								if (tipo.length - 1 > index) {
									_this3.summary[tipo[tipo.length - 1]].planning = _this3.summary[tipo[tipo.length - 1]].planning + dato.totalHoursPlanned;
									_this3.summary[tipo[tipo.length - 1]].executed = _this3.summary[tipo[tipo.length - 1]].executed + dato.totalHoursExecuted;
									consolidacionArray.push([{ text: dato.periodicityName || '' }, { text: dato.activityTypeName || '' }, { text: dato.name || '' }, { text: dato.description || '' }, { text: dato.totalHoursPlanned || 0 }, { text: dato.totalHoursExecuted || 0 }]);
								}
							});
							_this3.data[tipo[tipo.length - 1]] = consolidacionArray;
							break;
	
					}
				});
				this.keys.forEach(function (tipo) {
					if (_this3.summary[_this3.modules[tipo]]) {
						_this3.summary['totalPlanned'] = (_this3.summary['totalPlanned'] ? _this3.summary['totalPlanned'] : 0) + _this3.summary[_this3.modules[tipo]].planning;
						_this3.summary['totalExecuted'] = (_this3.summary['totalExecuted'] ? _this3.summary['totalExecuted'] : 0) + _this3.summary[_this3.modules[tipo]].executed;
					}
				});
	
				this.pdfReporthistoricalWorkplan();
			}
	
			function pdfReporthistoricalWorkplan() {
				var _this4 = this;
	
				var fonts = {
					Roboto: {
						normal: 'fonts/Roboto-Regular.ttf',
						bold: 'fonts/Roboto-Medium.ttf',
						italics: 'fonts/Roboto-Italic.ttf',
						bolditalics: 'fonts/Roboto-MediumItalic.ttf'
					}
				};
	
				this.content = [{ text: 'Reporte Plan de trabajo Histórico', style: 'header', bold: true, alignment: 'center', fontSize: 22 }, { text: '\n', style: 'anotherStyle' }, {
					table: {
						widths: [160, 339],
						body: [['Profesor', this.recordTeacher.teacherFullname || user.dsFullname || ''], ['Unidad Académica', this.recordTeacher.academicName || ''], ['Plan de trabajo', this.selectWorkPlan.workplanName || ''], ['Etapa', this.recordTeacher.currentStageName || ''], ['Revisores', this.recordTeacher.revieweds || ''], ['Evaluador Principal', this.recordTeacher.evaluators || ''], ['Resultado de la evaluación', this.recordTeacher.criteriaEvaluation || ''], ['Observaciones de la evaluación', this.recordTeacher.evaluationComments || '']],
						dontBreakRows: true
					}
				}, {
					text: '\n',
					style: 'anotherStyle'
				}];
				var summaryTable = {
					table: {
						widths: [132, 85, 85, 85, 85],
						body: [[{ rowSpan: 2, text: 'Actividad', bold: true, alignment: 'center' }, { colSpan: 2, text: 'Planeación', bold: true, alignment: 'center' }, '', { colSpan: 2, text: 'Ejecución', bold: true, alignment: 'center' }, ''], ['', { text: 'Horas', bold: true, alignment: 'center' }, { text: 'Porcentaje', bold: true, alignment: 'center' }, { text: 'Horas', bold: true, alignment: 'center' }, { text: 'Porcentaje', bold: true, alignment: 'center' }]],
						dontBreakRows: true
					}
				};
	
				this.keys.forEach(function (tipo) {
					var info = _this4.summary[_this4.modules[tipo]] ? _this4.summary[_this4.modules[tipo]] : { planning: 0, executed: 0 };
	
					summaryTable.table.body.push([_this4.modules[tipo], info.planning, _this4.summary['totalPlanned'] > 0 ? (info.planning * 100 / _this4.summary['totalPlanned']).toFixed(2) + '%' : '-', info.executed, _this4.summary['totalExecuted'] > 0 ? (info.executed * 100 / _this4.summary['totalExecuted']).toFixed(2) + '%' : '-']);
				});
				summaryTable.table.body.push([{ text: 'Total', alignment: 'center', bold: true }, { text: this.summary['totalPlanned'], fontSize: 10 }, { text: this.summary['totalPlanned'] > 0 ? 100 + '%' : '-', fontSize: 10 }, { text: this.summary['totalExecuted'], fontSize: 10 }, { text: this.summary['totalExecuted'] > 0 ? 100 + '%' : '-', fontSize: 10 }]);
	
				this.content.push(summaryTable);
				this.content.push({
					text: '\n',
					style: 'anotherStyle'
				});
	
				this.keys.forEach(function (tipo) {
					var info = _this4.data[_this4.modules[tipo]];
					var tableWidths = [];
	
					if (_this4.modules[tipo] === 'Docencia') {
						// Validar arrays anidados de Docencia
						var validDocenciaData = _this4.data[_this4.modules[tipo]].map(function (section, sectionIndex) {
							if (Array.isArray(section)) {
								return section.map(function (item, itemIndex) {
									if (item && item.table && item.table.body) {
										// Validar filas de la tabla
										var validBody = item.table.body.filter(function (row, rowIndex) {
											if (!Array.isArray(row)) return true;
											var isValid = row.every(function (cell) {
												return cell !== undefined && cell !== null;
											});
											if (!isValid) {}
											return isValid;
										});
										// Crear nuevo objeto sin spread operator
										var newItem = Object.assign({}, item);
										newItem.table = Object.assign({}, item.table, { body: validBody });
										return newItem;
									}
									return item;
								});
							}
							return section;
						});
						// Verificar que validDocenciaData no tenga undefined
						validDocenciaData.forEach(function (section, si) {
							if (Array.isArray(section)) {
								section.forEach(function (item, ii) {
									if (item === undefined || item === null) {}
									if (item && item.table && item.table.body) {
										item.table.body.forEach(function (row, ri) {
											if (!Array.isArray(row)) return;
											row.forEach(function (cell, ci) {
												if (cell === undefined || cell === null) {}
											});
										});
									}
								});
							}
						});
						_this4.content.push(validDocenciaData);
					} else {
						tableWidths = ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
	
						if (info && info.length > 1) {
							// Validar que todas las filas tengan todas las celdas definidas
							var validRows = _this4.data[_this4.modules[tipo]].filter(function (row) {
								if (!Array.isArray(row)) return true;
								var isValid = row.every(function (cell) {
									return cell !== undefined && cell !== null;
								});
								if (!isValid) {}
								return isValid;
							});
	
							_this4.content.push({
								text: '\n',
								style: 'anotherStyle'
							}, { text: _this4.modules[tipo], alignment: 'center', fontSize: 14, bold: true }, {
								table: {
									widths: tableWidths,
									body: validRows,
									dontBreakRows: true
								}
							});
						}
					}
				});
	
				var docDefinition = {
					content: this.content,
					defaultStyle: {
						fontSize: 8
					}
				};
	
				pdfMake.createPdf(docDefinition).download('report.pdf');
				showToast('Reporte PDF generado exitosamente', false);
			}
	
			function loadListData(workplan, param) {
				var _this5 = this;
	
				var module = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
				var modu = module ? module : param;
				var mod = param == 2 ? $scope.module : setModule(this, modu);
	
				$scope.module = mod;
	
				if (true) {
					this.inModule = this.modulesIds[mod];
					this.currentLabel = this.modules[mod];
					post = {
						teacherId: user.teacherId,
						workplanId: workplan
					};
	
					getRecordTeacher(post, this);
	
					getReviewList(user.teacherId, workplan, ReviewSrv, workplan, mod).then(function (data) {
						getGeneralsWorkplan().then(function (response) {
							$cookies.put('workplan-approvedFinish', response.approvedFinish);
							$cookies.put('workplan-executionFinish', response.executionFinish);
							_isFeedback = response.isState == 1 ? response.feedbackReviewed : 1;
							_this5.planningFinish = response.isState == 1 && response.planningFinish == 0 ? false : true;
							_this5.executionFinish = response.isState == 1 && response.executionFinish == 0 ? false : true;
							_stageId = response.stageId;
							_this5.activities = formatActivity(data, _stageId, Validations); // sortActivitiesList(formatActivity(data, _stageId, Validations))
							_this5.loadDetails(_this5.activities[0], mod);
						});
					});
					$scope.Mod = mod;
				}
			}
	
			function calcHours(arr, param) {
				return arr.reduce(function (accumulator, current) {
					return accumulator + current[param];
				}, 0);
			}
	
			function loadDetails(activity, module) {
				var _this6 = this;
	
				var mod = setModule(this, module);
	
				this.selectedActivity = activity;
				this.isLoadingDetails = true;
				this.details = null;
				this.notPlanned = false;
	
				if (activity && !activity.workplanTeacherActivityId) {
					this.notPlanned = true;
					this.isLoadingDetails = false;
				} else if (activity) {
					getActivityDetails(mod, activity).then(function (data) {
						if (!data) {
							_this6.isLoadingDetails = false;
							_this6.details = null;
	
							return;
						}
	
						_this6.details = routeDetails(mod, activity, data);
						_this6.details.data.isFeedbackReviewed = Boolean(_isFeedback && !_this6.planningFinish);
						_this6.details.data.stageId = _stageId;
	
						if (_this6.details.data) {
							_this6.details.data.totalExecutedHours = _this6.details.children ? calcHours(_this6.details.children, 'hoursExecuted') : 0;
							_this6.details.data.totalPlannedHours = _this6.details.children ? calcHours(_this6.details.children, 'hoursPlanned') : 0;
						}
	
						_this6.details.data ? _this6.isLoadingDetails = false : _this6.details = null;
					});
				} else {
					this.details = null;
					this.isLoadingDetails = false;
				}
			}
	
			function thereIsDetails() {
				return Boolean(this.details);
			}
	
			function getGeneralsWorkplan() {
				return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: user.teacherId }).$promise.then(function (dataReturn) {
					return dataReturn.status ? dataReturn.data.wokplanTeacherStatus[0] : null;
				});
			}
	
			function endPlanning(wpId) {
				var post = {
					teacherId: user.teacherId,
					workplanId: wpId,
					userId: user.id,
					stageId: GlobalConfig.workplanIdStages.planning,
					stageName: GlobalConfig.workplanStagesNames.planning,
					submodules: JSON.parse($cookies.get('subModuleId')),
					teaching: GlobalConfig.modules.teaching,
					academicManagement: GlobalConfig.modules.academicManagement,
					feedback: _isFeedback
				};
				var submodules = Requests.submoduleItemRequired(post);
	
				if (submodules.teaching || submodules.academicManagement) {
					return Requests.getItemsRequiredList(WorkPlanSrv, post).then(function (data) {
						data.submodule = submodules;
	
						if (Requests.validateItems(data)) {
							Requests.showModalItemRequiredEndPlanning(WorkPlanModalSrv, data);
	
							return 0;
						} else {
							return Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post, $mdDialog).then(function (result) {
								// return result
							});
						}
					});
				} else {
					return Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post, $mdDialog).then(function (result) {
						// return result
					});
				}
			}
	
			function isButtonDisabled() {
				if (_status.workplanActive) {
					var curdate = moment();
					var endPlannigDate = moment(this.recordTeacher.dateEndPlanning, 'DD/MM/YYYY');
	
					return this.currentStage === 'planning' ? this.planningFinish || curdate > endPlannigDate : this.executionFinish;
				} else {
					return true;
				}
			}
	
			function endStage() {
				var _this7 = this;
	
				this.planningFinish = 1;
				this.executionFinish = 1;
	
				if (this.currentStage === 'planning') {
					endPlanning(this.selectedWorkplan).then(function (result) {
						_this7.planningFinish = result;
					});
				} else {
					endExecution(this.selectedWorkplan).then(function (result) {
						_this7.executionFinish = result;
					});
				}
			}
	
			function getItemsRequiredList(header) {
				itemList = [];
	
				return WorkPlanSrv.getItemRequiredExecution.getList(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						var activities = [];
	
						for (var i in dataReturn.assignatures) {
							for (var j in dataReturn.activities) {
								if (dataReturn.assignatures[i].id_assignature === dataReturn.activities[j].id_assignature) {
									activities.push(dataReturn.activities[j]);
								}
							}
							itemList.push({
								assignatureName: dataReturn.assignatures[i].assignatureName,
								assignatureId: dataReturn.assignatures[i].id_assignature,
								showChilds: false,
								itemList: activities
							});
							activities = [];
						}
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
	
			function validateSubmodules() {
				var validateSubmodules = {
					teaching: false,
					academicManagement: false
				};
				var submodule = JSON.parse($cookies.get('subModuleId'));
	
				for (var i in submodule) {
					if (submodule[i].submoduleId === GlobalConfig.modules.teaching) {
						validateSubmodules.teaching = true;
					}
	
					if (submodule[i].submoduleId === GlobalConfig.modules.academicManagement) {
						validateSubmodules.academicManagement = true;
					}
				}
	
				return validateSubmodules;
			}
	
			function validateItems(submodule) {
				var showModal = false;
	
				if (submodule.teaching) {
					if (itemList.length > 0) {
						showModal = true;
					}
				}
	
				return showModal;
			}
	
			function endExecution(wpId) {
				var header = {
					teacherId: user.teacherId,
					workplanId: wpId,
					id: user.id
				};
	
				var submodules = validateSubmodules();
	
				if (submodules.teaching) {
					return getItemsRequiredList(header).then(function (promise) {
						if (validateItems(submodules)) {
							showModalItemRequiredEndPlanning();
	
							return 0;
						} else {
							return getActNotExecutionByTeacher(wpId).then(function (response) {
								if (response.activitiesNotEjecution.length > 0) {
									Requests.showModalItemRequiredEndExecution(WorkPlanModalSrv, response.activitiesNotEjecution);
								} else {
									return getSummanyProgress(header.teacherId).then(function (response) {
										if (response.isControlHoursActive && (response.isMinHoursExecuted || response.isMaxHoursExecuted)) {
											showModalHoursParametrization(header, response);
										} else {
											WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response));
											WorkPlanModalSrv.endPlanning().then(function (result) {});
										}
									});
								}
							});
						}
					});
				} else {
					return getSummanyProgress(header.teacherId).then(function (response) {
						if (response.isControlHoursActive && (response.isMinHoursExecuted || response.isMaxHoursExecuted)) {
							showModalHoursParametrization(header, response);
						} else {
							WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response));
							WorkPlanModalSrv.endPlanning().then(function (result) {});
						}
					});
				}
			}
	
			function showModalHoursParametrization(header, response) {
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', function showModalHoursParametrization($scope, $mdDialog) {
						$scope.data = response;
						$scope.close = function () {
							$mdDialog.hide();
							WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response));
						};
					}],
					template: __webpack_require__(436),
					clickOutsideToClose: false
				});
			}
	
			function showModalItemRequiredEndPlanning() {
				var header = {
					itemAssignatures: itemList
				};
	
				WorkPlanModalSrv.setVariable(header);
				WorkPlanModalSrv.itemRequiredExecution();
			}
	
			function getActivitiesNotExecutionByTeacher(wpId) {
				var post = {
					teacherId: user.teacherId,
					workplanId: wpId
				};
	
				return ReviewSrv.getActivitiesNotExecutionByTeacher.get(post).$promise.then(function (dataReturn) {
					return dataReturn.status ? dataReturn.activitiesNotEjecution : 0;
				});
			}
	
			function getActNotExecutionByTeacher(wpId) {
				var post = {
					teacherId: user.teacherId,
					workplanId: wpId
				};
	
				return ReviewSrv.getActNotExecutionByTeacher.get(post).$promise.then(function (dataReturn) {
					return dataReturn;
				});
			}
	
			function showModalActivitiesNotExecution() {
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', function showModalActivitiesNotExecution($scope, $mdDialog) {
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(448),
					clickOutsideToClose: false
				});
			}
	
			function getRecordTeacher(post, aux) {
				aux.downloadRequests++;
				aux.disableDownload = true;
	
				return WorkPlanSrv.getRecordTeacher.get(post).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						aux.recordTeacher = dataReturn.data[0];
	
						if (aux.downloadRequests === 1) {
							aux.downloadRequests--;
							aux.disableDownload = false;
						} else {
							aux.downloadRequests--;
						}
					} else {
						console.log('Comunications problem with the server');
					}
				});
			}
	
			function hiddenTable() {
				if (this.class === this.iconClasses[0]) {
					this.class = this.iconClasses[1];
					this.showTable = true;
				} else {
					this.class = this.iconClasses[0];
					this.showTable = false;
				}
			}
	
			function showModalReactivateWorkplan(obj) {
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', function showModalReactivateWorkplan($scope, $mdDialog) {
						$scope.reactivate = function (isNew) {
							showModalConfirm(isNew, obj);
						};
						$scope.close = function () {
							$mdDialog.hide();
							$state.go('fullscreen.welcomeHome');
						};
					}],
					template: __webpack_require__(449),
					clickOutsideToClose: false
				});
			}
	
			function showModalConfirm(isNew, obj) {
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', function showModalConfirm($scope, $mdDialog) {
						$scope.continue = function () {
							var post = {
								teacherId: user.teacherId,
								workplanId: user.workplanId,
								isNew: isNew
							};
	
							return WorkPlanSrv.setPlanningWorkplanByTeacher.set(post).$promise.then(function (dataReturn) {
								if (dataReturn.status) {
									$cookies.put('isReproved', 0);
									$mdDialog.hide();
									$state.reload();
									getData(obj);
								}
							}, function (data) {
								$mdDialog.hide();
							});
						};
						$scope.close = function () {
							$mdDialog.hide();
							$state.go('fullscreen.welcomeHome');
						};
					}],
					template: __webpack_require__(450),
					clickOutsideToClose: false
				});
			}
		}]
	};

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row p-h-lg\"> <div class=col-md-3> <h3>Historial plan de trabajo</h3> </div> <div class=\"col-md-3 m-t text-right\"> <label class=text-base>Seleccione un plan de trabajo</label> </div> <div class=\"col-md-2 m-t\" id=workPlanId> <md-select class=no-margin aria-label=workPlanId ng-model=vm.selectedWorkplan ng-change=vm.loadListData(vm.selectedWorkplan,2)> <md-option ng-repeat=\"workplan in vm.workplans\" value={{workplan.workplanId}}> {{workplan.workplanName}} </md-option> </md-select> </div> <div class=col-md-4> <form class=\"form-inline pull-right\"> <md-button class=\"btn btn-fw btn-success text-xs\" ng-click=vm.downloadPdf(vm.selectedWorkplan) ng-show=true ng-disabled=vm.disableDownload> Descargar PDF </md-button> <md-button has-permission=historial-edit ng-if=vm.showFinishButton class=\"btn btn-fw btn-success text-xs\" ng-click=vm.endStage() ng-disabled=vm.isButtonDisabled()> Finalizar {{vm.stageName}} </md-button> </form> </div> </div> <div class=\"row p-h-lg\"> <div class=\"col-md-12 p-b-md p-t-xs\"> <div class=\"pointer col-md-12 text-left no-padding-l\" ng-click=vm.hiddenTable()> <h5 class=\"text-azul p-v-xs col-md-3 no-padding\">Detalles del plan de trabajo</h5> <span ng-class=vm.class class=\"icon i-28 col-md-1 text-gris-dark p-v-xs text-left no-padding-r\"></span> </div> <div class=row ng-show=vm.showTable> <div class=col-md-6> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Etapa: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.currentStageName}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Fecha de finalizaci&oacute;n de planeaci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.dateEndPlanning}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Revisores: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.revieweds}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Observaciones de la revisión: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.reviewedComments}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Observaciones de la retroalimentación: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.feedbackComments}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Fecha de finalizaci&oacute;n de la revisi&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.dateEndReviewed}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Observaciones de revisi&oacute;n de la ejecuci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.reviewedExecutionComments}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Fecha de finalizaci&oacute;n de la revisi&oacute;n de la ejecuci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.dateEndReviewedExecution}}</p> </div> </div> </div> <div class=col-md-6> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Evaluador principal: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.evaluators}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Resultado de aprobaci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.criteriaApproved}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Observaciones de aprobaci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.approvedComments}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Fecha de finalizaci&oacute;n de aprobaci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.dateEndApprovededExecution}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Resultado de evaluaci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.criteriaEvaluation}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Observaciones de evaluaci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.evaluationComments}}</p> </div> </div> <div class=row> <div class=\"col-xs-7 col-md-7\"> <p class=\"text-azul-light text-sm\">Fecha de finalizaci&oacute;n de evaluaci&oacute;n: </p> </div> <div class=\"col-xs-5 col-md-5 no-padding-l\"> <p class=text-sm>{{vm.recordTeacher.dateEndEvaluation}}</p> </div> </div> </div> </div> </div> <div class=row ng-if=vm.recordTeacher.stageClosureLog.length> <div class=col-md-12> <p class=\"text-azul-light text-sm\">Bitácora de cierres:</p> <div class=row ng-repeat=\"closure in vm.recordTeacher.stageClosureLog\"> <div class=\"col-xs-3 col-md-3\"> <p class=text-sm>{{closure.stageName}}</p> </div> <div class=\"col-xs-3 col-md-3\"> <p class=text-sm> {{closure.actorName || 'Autor no verificable'}} <span ng-if=!closure.isActorVerified>(dato histórico no verificable)</span> </p> </div> <div class=\"col-xs-3 col-md-3\"> <p class=text-sm> {{closure.closedAt | date:'dd/MM/yyyy HH:mm'}} <span ng-if=!closure.isClosedAtVerified>(fecha estimada)</span> </p> </div> <div class=\"col-xs-3 col-md-3\"> <p class=text-sm>{{closure.comment}}</p> </div> </div> </div> </div> </div> <div class=\"row blanco\"> <div class=col-md-12> <md-tabs md-stretch-tabs=always md-dynamic-height md-border-bottom md-selected=vm.selectedTab> <md-tab ng-repeat=\"module in vm.keys\" label=\"{{ vm.modules[module] }}\" ng-click=vm.clean(module)> <div class=\"col-md-5 no-padding rightDivider\" style=z-index:1> <md-divider></md-divider> <search-bar search-icon=true icon-size=20 opacity=true bar-style=\"'m-r p-l-md'\" on-change=vm.updateFilter(search)> </search-bar> <md-divider></md-divider> <activities-list activities=vm.activities filtering=vm.filter on-click=\"vm.loadDetails(activity, module)\" not-show-checkbox=true> </activities-list> </div> <activity-details ng-if=\"vm.thereIsDetails() && !vm.notPlanned\" activity=vm.selectedActivity details=vm.details module=vm.inModule label=vm.currentLabel> </activity-details> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=\"!vm.thereIsDetails() && vm.notPlanned\"> <h3>La actividad no está planeada</h3> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=vm.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=vm.thereIsDetails() md-diameter=96> </md-progress-circular> </div> </md-tab> </md-tabs> </div> </div> ";

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModal.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Ingrese horas de ejecución a todas las actividades para poder finalizar ejecución.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row col-md-12 text-center\"> <h3 class=text-verde>Reactivar plan</h3> <p>Su plan de trabajo ha sido Reactivado, ¿Desea planear nuevamente su plan o editar la planeación anterior?</p> </div> <div class=\"row col-md-12\"> <div class=\"col-md-6 clone\"> <div class=col-md-5 style=margin-left:140px> <a href=#> <i class=\"icon mdi-editor-insert-drive-file\" ng-click=reactivate(0)></i> <span class=exo>Editar planeación</span> </a> </div> </div> <div class=\"col-md-6 create\"> <div class=col-md-5 style=margin-left:60px> <a href=# class=exo> <i class=\"icon mdi-action-note-add\" ng-click=reactivate(1)></i> <span>Planear nuevo</span> </a> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>¿Desea continuar con la acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=continue()>Sí</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.header = undefined;
	
	var _header = __webpack_require__(452);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var header = exports.header = {
	  bindings: {
	    teacherName: '<',
	    teacherId: '<',
	    workplanId: '<',
	    activitytypeId: '<',
	    workplanteacherId: '<',
	    btnBitacora: '<'
	  },
	  template: _header2.default,
	  controllerAs: 'vm',
	  controller: ['$scope', '$state', '$cookies', '$stateParams', 'GlobalConfig', 'WorkPlanSrv', 'WorkPlanModalSrv', 'ReviewSrv', 'Validations', 'Setters', 'Requests', '$mdDialog', 'ngNotify', 'GlobalSrv', function headerCtrl($scope, $state, $cookies, $stateParams, GlobalConfig, WorkPlanSrv, WorkPlanModalSrv, ReviewSrv, Validations, Setters, Requests, $mdDialog, ngNotify, GlobalSrv) {
	    var _this = this;
	
	    var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
	    var currentModule = $state.current.module;
	    var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	    var user = JSON.parse($cookies.get('currentUser'));
	
	    angular.extend(this, {
	      user: user,
	      mainLabel: $state.current.data.title,
	      executionCompleted: true,
	      approvalCompleted: false,
	      evaluationCompleted: true,
	      reviewExecutionCompleted: false,
	      colClassTexts: 'col-md-3',
	      colClassButtons: 'col-md-9',
	      userId: 0
	    });
	
	    this.entries = {};
	
	    // methods
	    angular.extend(this, {
	      addActivityTeaching: addActivityTeaching,
	      addActivityAM: addActivityAM,
	      addRolesAM: addRolesAM,
	      addCommitteParticipationAM: addCommitteParticipationAM,
	      addLearningComunityCP: addLearningComunityCP,
	      addCourseExternalCP: addCourseExternalCP,
	      viewOfferCoursesCP: viewOfferCoursesCP,
	      viewTransversalProjects: viewTransversalProjects,
	      inReview: Validations.inReview(currentStage),
	      inApproval: Validations.inApproval(currentStage),
	      inExecution: Validations.inExecution(currentStage),
	      inReviewExecution: Validations.inReviewExecution(currentStage),
	      inEvaluation: Validations.inEvaluation(currentStage),
	      inAcademicManagement: Validations.inAcademicManagement(currentModule),
	      inTeaching: Validations.inTeaching(currentModule),
	      inConsolidation: Validations.inConsolidation(currentModule),
	      inInvestigation: Validations.inInvestigation(currentModule),
	      inExtension: Validations.inExtension(currentModule),
	      isTeacher: Validations.isTeacher(currentRoleId),
	      currentModule: currentModule,
	      endExecution: endExecution,
	      endAproval: endAproval,
	      endEvaluation: endEvaluation,
	      endReviewExecution: endReviewExecution,
	      bitacora: bitacora
	    });
	
	    this.inExecution = Validations.inExecution(currentStage);
	    // teacher ID varies depending of view
	    var teacherId = this.teacherId;
	    var workplanId = this.workplanId;
	    var itemList = [];
	
	    function validateClass(scope) {
	      if (!scope.inExecution) {
	        scope.colClassTexts = 'col-md-7';
	        scope.colClassButtons = 'col-md-5';
	      }
	    }
	
	    // services
	
	    var getSummanyProgress = Requests.getSummanyProgress(WorkPlanSrv);
	    var setEndExecutionHeader = Requests.setEndExecutionHeader(GlobalConfig);
	    var setEndAprovalHeader = Requests.setEndAprovalHeader(GlobalConfig);
	    var setEndEvaluationHeader = Requests.setEndEvaluationHeader(GlobalConfig);
	    var setEndReviewExecutionHeader = Requests.setEndReviewExecutionHeader(GlobalConfig);
	
	    this.$onInit = function () {
	
	      _this.inprofilebutton = false;
	
	      if (_this.inExecution == true && currentRoleId == 13) {
	        _this.inprofilebutton = true;
	      }
	
	      getGeneralsWorkplan(_this);
	      validateClass(_this);
	    };
	
	    function Entries(params) {
	      WorkPlanSrv.getEntries.entries(params).$promise.then(function (response) {
	        if (!response.status) {
	          ngNotify.set('Ocurrio un error en el servicio', 'warn');
	        } else {
	          $scope.totalData = response;
	        }
	      }, function (err) {
	        ngNotify.set('Imposible conectar con el servicio', 'error');
	      });
	    }
	
	    function getGeneralsWorkplan(scope) {
	      ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: scope.teacherId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          scope.executionCompleted = dataReturn.data.wokplanTeacherStatus[0].executionFinish === 1;
	          scope.evaluationCompleted = dataReturn.data.wokplanTeacherStatus[0].evaluationFinished === 1;
	          scope.userId = dataReturn.data.wokplanTeacherStatus[0].userId;
	        }
	      });
	    }
	
	    function bitacora(ev) {
	      this.entries.params = {
	        activityTypeId: this.activitytypeId,
	        workplanTeacherId: this.workplanteacherId,
	        userId: this.userId
	      };
	      this.entries.title = this.btnBitacora.tagName;
	      // Entries(this.entries);
	      this.entries.data = undefined;
	      $mdDialog.show({
	        controller: 'bitacoraModalCtrl',
	        controllerAs: 'bit',
	        template: __webpack_require__(453),
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        locals: { data: this.entries },
	        clickOutsideToClose: true,
	        fullscreen: true
	      });
	    }
	
	    function getNotify(idRole) {
	      var reviewers = GlobalSrv.getReviewerbySubmodule(idRole, GlobalConfig.modules.execution);
	      if (reviewers) {
	        getSendNotify(reviewers);
	      }
	    }
	
	    function getSendNotify(idUser) {
	      var nameUser = JSON.parse($cookies.get('currentUser')).name;
	      var msg = 'El profesor ' + nameUser + ' ha finalizado la ejecución';
	
	      var dataInbox = {
	        idUser: idUser,
	        dsName: 'Notificación, Apreciado Usuario el profesor ' + nameUser + ' ha finalizado la ejecución.',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 0
	      };
	
	      var dataEmail = {
	        idUser: idUser,
	        dsName: 'Notificación, Apreciado Usuario el profesor ' + nameUser + ' ha finalizado la ejecución.',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.email,
	        is_grouped: 0
	      };
	
	      GlobalSrv.sendNotification(dataInbox);
	      GlobalSrv.sendNotification(dataEmail);
	    }
	
	    function endExecution() {
	      var header = {
	        teacherId: teacherId,
	        workplanId: workplanId,
	        id: user.id
	      };
	
	      var submodules = validateSubmodules();
	      if (submodules.teaching) {
	        getItemsRequiredList(header).then(function (promise) {
	          if (validateItems(submodules)) {
	            showModalItemRequiredEndPlanning();
	          } else {
	            getSummanyProgress(header.teacherId).then(function (response) {
	              WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response));
	              WorkPlanModalSrv.endPlanning().then(function (promise) {
	                getNotify(GlobalConfig.userRolesIds.reviewer);
	              });
	            });
	          }
	        });
	      }
	    }
	
	    function endAproval() {
	      var post = {
	        teacherId: teacherId,
	        workplanId: workplanId,
	        id: user.id,
	        stageId: GlobalConfig.workplanIdStages.approval
	      };
	      WorkPlanSrv.getReprovedActivities.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          WorkPlanModalSrv.setVariable(setEndAprovalHeader(post, currentStage, dataReturn.data));
	          WorkPlanModalSrv.endStage().then(function (promise) {});
	        }
	      });
	    }
	
	    function endEvaluation() {
	      var post = {
	        teacherId: teacherId,
	        workplanId: workplanId,
	        id: user.id,
	        stageId: GlobalConfig.workplanIdStages.evaluation
	      };
	      WorkPlanSrv.getReprovedActivities.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          WorkPlanModalSrv.setVariable(setEndEvaluationHeader(post, currentStage, dataReturn.data.noTouched));
	          WorkPlanModalSrv.endStage().then(function (promise) {});
	        }
	      });
	    }
	
	    function endReviewExecution() {
	      var post = {
	        teacherId: teacherId,
	        workplanId: workplanId,
	        id: user.id,
	        stageId: GlobalConfig.workplanIdStages.reviewExecution
	      };
	      WorkPlanSrv.getReprovedActivities.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          WorkPlanModalSrv.setVariable(setEndReviewExecutionHeader(post, currentStage, dataReturn.data.noTouched));
	          WorkPlanModalSrv.endStage().then(function (promise) {});
	        }
	      });
	    }
	
	    function addActivityTeaching() {
	      WorkPlanModalSrv.addTeachingActivity();
	    }
	
	    function addActivityAM() {
	      WorkPlanModalSrv.addAcademicManagementActivity();
	    }
	
	    function addRolesAM() {
	      WorkPlanModalSrv.addAcademicManagementRole();
	    }
	
	    function addCommitteParticipationAM() {
	      WorkPlanModalSrv.addAcademicManagementCommitteParticipation();
	    }
	
	    function viewOfferCoursesCP() {
	      WorkPlanModalSrv.addConsolidationOfferCourses();
	    }
	
	    function viewTransversalProjects() {
	      WorkPlanModalSrv.listTransversalProjects();
	    }
	
	    function addCourseExternalCP() {
	      WorkPlanModalSrv.addConsolidationCourseExternal();
	    }
	
	    function addLearningComunityCP() {
	      WorkPlanModalSrv.addConsolidationLearningComunity();
	    }
	
	    function getItemsRequiredList(header) {
	      itemList = [];
	      return WorkPlanSrv.getItemRequiredExecution.getList(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          var activities = [];
	          for (var i in dataReturn.assignatures) {
	            for (var j in dataReturn.activities) {
	              if (dataReturn.assignatures[i].id_assignature === dataReturn.activities[j].id_assignature) {
	                activities.push(dataReturn.activities[j]);
	              }
	            }
	            itemList.push({
	              assignatureName: dataReturn.assignatures[i].assignatureName,
	              assignatureId: dataReturn.assignatures[i].id_assignature,
	              showChilds: false,
	              itemList: activities
	            });
	            activities = [];
	          }
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function validateSubmodules() {
	      var validateSubmodules = {
	        teaching: false,
	        academicManagement: false
	      };
	      var submodule = JSON.parse($cookies.get('subModuleId'));
	      for (var i in submodule) {
	        if (submodule[i].submoduleId === GlobalConfig.modules.teaching) {
	          validateSubmodules.teaching = true;
	        }
	        if (submodule[i].submoduleId === GlobalConfig.modules.academicManagement) {
	          validateSubmodules.academicManagement = true;
	        }
	      }
	      return validateSubmodules;
	    }
	
	    function validateItems(submodule) {
	      var showModal = false;
	      if (submodule.teaching) {
	        if (itemList.length > 0) {
	          showModal = true;
	        }
	      }
	      return showModal;
	    }
	
	    function endPlanning() {
	      var post = {
	        teacherId: JSON.parse($cookies.get('currentUser')).teacherId,
	        workplanId: JSON.parse($cookies.get('currentUser')).workplanId
	      };
	
	      var submodules = validateSubmodules();
	      if (submodules.teaching) {
	        getItemsRequiredList(post).then(function (promise) {
	          if (validateItems(submodules)) {
	            showModalItemRequiredEndPlanning();
	          } else {
	            getSummanyProgress(header.teacherId).then(function (response) {
	              WorkPlanModalSrv.setVariable(setEndExecutionHeader(header, response));
	              WorkPlanModalSrv.endPlanning().then(function (promise) {});
	            });
	          }
	        });
	      }
	    }
	
	    function showModalItemRequiredEndPlanning() {
	      var header = {
	        itemAssignatures: itemList
	      };
	      WorkPlanModalSrv.setVariable(header);
	      WorkPlanModalSrv.itemRequiredExecution();
	    }
	  }] };

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"m-l-lg m-b-xs no-padding\" ng-class=vm.colClassTexts> <h3 class=\"text-block no-margin exo\"> {{ vm.mainLabel }} <br/> <span ng-show=!vm.isTeacher> {{ vm.teacherName }} </span> </h3> </div> <div class=\"m-h m-b-xs no-padding\" ng-class=vm.colClassButtons> <div class=no-padding> <md-button ng-hide=vm.btnBitacora.hide class=\"btn btn-fw btn-success right text-xs\" ng-click=vm.bitacora($event)> Bitácora de {{vm.btnBitacora.tagName}} </md-button> <md-button aria-label ng-show=\"vm.inExecution && vm.inTeaching\" class=\"btn btn-fw btn-primary right text-xs\" ng-click=vm.addActivityTeaching() ng-disabled=vm.executionCompleted> Agregar otra actividad </md-button> <md-button aria-label ng-show=\"vm.inExecution && vm.inConsolidation\" class=\"btn btn-fw btn-cancel right text-xs\" ng-click=vm.viewOfferCoursesCP() ng-disabled=vm.executionCompleted> Ver oferta de cursos </md-button> <md-button aria-label ng-show=\"vm.inExecution && vm.inExtension\" class=\"btn btn-fw btn-cancel right text-xs\" ng-click=vm.viewTransversalProjects() ng-disabled=vm.executionCompleted> Ver Proyectos Transversales </md-button> <add-activity module=vm.currentModule ng-show=\"vm.inExecution && !(vm.inTeaching || vm.inExtension)\" disable=vm.executionCompleted> </add-activity> <add-activity-extension ng-show=\"vm.inExecution && vm.inExtension\" disable=vm.executionCompleted> </add-activity-extension> <md-button ng-show=\"vm.inConsolidation && vm.inprofilebutton\" class=\"btn btn-fw btn-success right text-xs\" ui-sref=profile.nueva_solicitud> Actualizar Perfil </md-button> </div> </div> </div> ";

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	module.exports = "<div class=modal-bitacora> <div class=\"row title p-v-sm\"> <div class=col-xs-12> <div class=row> <div class=\"col-xs-12 p-h-lg p-v m-b-xs\"> <h3 class=text-center>Bit&aacute;cora de {{bit.totalData.title}}</h3> <p class=\"text-info text-left\" ng-if=\"bit.comments.length != bit.totalData.data.length\"> <a href=# ng-click=bit.loadMore()>Ver comentarios anteriores</a> </p> </div> </div> </div> </div> <div class=row> <div class=col-xs-12> <div class=comments> <p ng-if=\"bit.comments.length <= 0\">No hay registros en la bitácora</p> <div class=item-comment ng-repeat=\"comment in bit.comments track by $index\"> <div class=\"row header-comment\"> <div class=\"col-xs-4 col-md-2 col-lg-2 text-left\"> <img src=https://urosariostorage.blob.core.windows.net/profilepicture/{{comment.dsIdentification}}.jpg class=\"img-responsive rounded image_portal\" err-src={{bit.notPicture}}> </div> <div class=\"col-xs-8 col-md-10 col-lg-10\"> <p><strong>{{comment.ds_user}} - {{ comment.ds_roles}}</strong></p> <p><small>{{bit.moment(comment.dateLog.substring(0, 19)).from(comment.dateNow.substring(0, 19))}}</small></p> </div> </div> <div class=\"row body-comment\"> <div class=col-xs-12> <div ta-bind ng-model=comment.description></div> <div class=\"text-right text-info comments-actions\"> <a href=# ng-click=\"bit.response(comment, $index)\"> {{bit.inResponse[$index]?'Cancelar':'Responder'}} </a> <a href=# ng-if=\"comment.response.length > 0\" ng-click=\"bit.showResponse[$index] = !bit.showResponse[$index]\"> {{bit.showResponse[$index]?'Ocultar':'Mostrar'}} respuestas </a> </div> </div> </div> <div class=row ng-if=\"bit.showResponse[$index] || bit.inResponse[$index]\"> <div class=comment-response ng-if=bit.showResponse[$index]> <div class=item-comment ng-repeat=\"response in comment.response track by $index\" ng-if=\"comment.response.length > 0\"> <div class=\"row header-comment\"> <div class=\"col-xs-4 col-md-2 col-lg-2 text-left\"> <div class=\"img_responsive rounded image_portal\"></div> </div> <div class=\"col-xs-8 col-md-10 col-lg-10\"> <p><strong>{{response.ds_user}} - {{ response.ds_roles}}</strong></p> <p><small>{{bit.moment(response.dateLog.substring(0, 19)).from(comment.dateNow.substring(0, 19))}}</small></p> </div> </div> <div class=\"row body-comment\"> <div class=col-xs-12 ta-bind ng-model=response.description> </div> </div> <hr/> </div> </div> <div class=content-response ng-if=bit.inResponse[$index]> <div class=row> <div class=col-xs-12> <div class=form-group> <text-angular ng-model=bit.commentBitacora class=\"m-b-sm webeditor\" name=ds_comment ta-toolbar=bit.optionsTextEditor placeholder=\"Ingresar comentario\"></text-angular> </div> </div> </div> </div> </div> <hr/> </div> </div> </div> </div> <div class=row ng-if=!bit.responding> <div class=col-xs-12> <div class=form-group> <text-angular ng-model=bit.commentBitacora class=\"m-b-sm webeditor\" name=ds_description ta-toolbar=bit.optionsTextEditor placeholder=\"Ingresar comentario\"> </text-angular> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label ng-disabled=\"bit.commentBitacora.length <= 0 || bit.disabledButton\" class=\"btn btn-fw btn-success btn-lg md-ink-ripple btn-horizontal-align\" type=button ng-click=bit.save()>Comentar</md-button> <md-button class=\"btn btn-fw btn-info btn-lg md-ink-ripple btn-horizontal-align\" type=button ng-click=bit.close()>Cerrar</md-button> </div> </div> </div>";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.activitiesList = undefined;
	
	var _activitiesList = __webpack_require__(455);
	
	var _activitiesList2 = _interopRequireDefault(_activitiesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var activitiesList = exports.activitiesList = {
		bindings: {
			activities: '<',
			filtering: '<',
			onClick: '&',
			notShowCheckbox: '<'
		},
		template: _activitiesList2.default,
		controllerAs: 'vm',
		controller: ['$rootScope', '$cookies', '$stateParams', 'WorkPlanSrv', 'CssClasses', 'Validations', '$scope', function activitiesListCtrl($rootScope, $cookies, $stateParams, WorkPlanSrv, CssClasses, Validations, $scope) {
			var _this = this;
	
			var backgroundColor = CssClasses.backgroundColor;
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var inExecution = Validations.inExecution(currentStage);
			var inEvaluation = Validations.inEvaluation(currentStage);
			var inReviewExecution = Validations.inReviewExecution(currentStage);
			var inReview = Validations.inReview(currentStage);
			var inApproval = Validations.inApproval(currentStage);
			var showIcons = function showIcons() {
				return inExecution || inReview || inApproval || inEvaluation || _this.inHistory || inReviewExecution;
			};
			var showIconsMedal = function showIconsMedal() {
				return inExecution || inEvaluation || _this.inHistory || inReviewExecution || inReview;
			};
	
			angular.extend(this, {
				inHistory: $stateParams.inHistory,
				background: '',
				selectedActivity: {},
				selectActivity: selectActivity,
				setBackground: setBackground,
				isForPlanning: true,
				showCheckbox: function showCheckbox(activity) {
					return inExecution && Validations.isSubjectType(activity) && activity.origin === 3;
				},
				disableActivity: function disableActivity(activity) {
					return Boolean(activity.isForPlan);
				},
				showIcons: showIcons,
				showIconsMedal: showIconsMedal,
				updateIsPlanning: updateIsPlanning
			});
	
			this.$onChanges = function () {
				_this.selectedActivity = _this.activities ? _this.activities[0] : null;
	
				if (_this.selectedActivity) {
					for (var activity in _this.activities) {
						setBackground(_this.activities[activity], _this.selectedActivity);
					}
				}
			};
	
			function setBackground(activity, selected) {
				if (activity.isExecution !== 1 && typeof activity.executionFinish !== 'undefined' && activity.executionFinish === 1) {
					activity.background = backgroundColor.inactivo;
				}
	
				if (activity === selected) {
					activity.background = backgroundColor.purple;
				} else {
					activity.background = '';
				}
			}
	
			function selectActivity(activity, index) {
				if ($rootScope.setHandsProgress) return;
	
				if (activity.isExecution !== 1 && typeof activity.executionFinish !== 'undefined' && activity.executionFinish === 1) {
					return;
				}
	
				this.onClick({ activity: activity, index: index });
				this.setBackground(this.selectedActivity, activity);
				this.selectedActivity = activity;
				this.setBackground(activity, activity);
			}
	
			$scope.$on('selectActivityEmit', selectActivityEmit);
	
			function selectActivityEmit($event, activity) {
				$scope.vm.onClick({ activity: activity });
				$scope.vm.selectedActivity = activity;
			}
	
			function updateIsPlanning(assignature) {
				return WorkPlanSrv.updateAssignatureWorkPlan.post({
					teacherId: JSON.parse($cookies.get('currentUser')).teacherId,
					assignatureId: assignature.asignatureId,
					isPlanning: assignature.isForPlanning
				}).$promise.then(function (dataReturn) {
					// console.log(dataReturn)
					return dataReturn;
				});
			}
		}] };

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row scroll-55vh pointer\"> <div class=\"col-md-12 flex\" aria-label=activities ng-model=vm.selectedActivity ng-click=\"vm.selectActivity(activity, $index)\" ng-class=activity.background ng-repeat=\"activity in vm.activities | filter: vm.filtering track by $index\" ng-disable=vm.disableActivity(activity)> <div class=\"col-md-1 text-center flex-center\"> <medal-avatar class=\"col-md-1 no-padding\" ng-show=vm.showIconsMedal activity=::activity> </medal-avatar> </div> <div class=\"col-md-1 text-center flex-center\"> <hand-avatar class=\"col-md-1 no-padding\" ng-show=vm.showIcons activity=::activity> </hand-avatar> </div> <div class=\"col-md-7 no-padding\"> <list-data class=col-md-11 activity=::activity selected=vm.selectedActivity> </list-data> </div> <div class=\"col-md-4 no-padding flex-center\"> <activity-tag class=md-secondary activity=::activity not-show-checkbox=vm.notShowCheckbox></activity-tag> </div> <md-divider ng-if=!$last></md-divider> </div> </div> <style>.custom-tooltip{background-color:#000!important;color:#fff!important;font-size:15px!important;border-radius:5px}</style> ";

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var handAvatar = exports.handAvatar = {
		bindings: {
			activity: '<'
		},
		template: '\n    <span class="icon i-28 md-avatar" ng-class="vm.showHand(vm.activity)">\n      <md-tooltip class="custom-tooltip" md-direction="right">\n        {{::vm.approved}}\n      </md-tooltip>\n    </span>',
		controllerAs: 'vm',
		controller: ['CssClasses', '$stateParams', 'Ramda', 'GlobalConfig', function handAvatarCtrl(CssClasses, $stateParams, Ramda, GlobalConfig) {
			var curry = Ramda.curry;
	
			var textColor = CssClasses.textColor;
			var icons = CssClasses.icons;
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var inHistory = $stateParams.inHistory;
	
			var setColors = curry(function (scope, param, activity) {
				if (activity[param] === 1) {
					scope.approved = 'Aprobado';
	
					return [textColor.blue, icons.thumbsUp];
				} else if (activity[param] === 0) {
					scope.approved = 'Rechazado';
	
					return [textColor.red, icons.thumbsDown];
				}
			});
	
			var handAvatar = curry(function (setColors, currentStage, activity) {
				switch (currentStage) {
	
					case 'reviewExecution':
						return setColors('isExecution')(activity);
					case 'review':
						return setColors('isReviewed')(activity);
					case 'execution':
						return setColors('isApproved')(activity);
					case 'evaluation':
						return setColors('isAccept')(activity);
					case 'approval':
						return setColors('isApproved')(activity);
	
				}
			});
	
			var handAvatarInHistory = curry(function (setColors, activity) {
				switch (activity.stageId) {
	
					case GlobalConfig.workplanIdStages.approval:
						return setColors('isReviewed')(activity);
					case GlobalConfig.workplanIdStages.execution:
						return setColors('isApproved')(activity);
					case GlobalConfig.workplanIdStages.reviewExecution:
						return setColors('isApproved')(activity);
					case GlobalConfig.workplanIdStages.evaluation:
						return setColors('isExecution')(activity);
					case GlobalConfig.workplanIdStages.end:
						return setColors('isAccept')(activity);
					default:
						return setColors('isReviewed')(activity);
	
				}
			});
	
			var showHand = inHistory ? handAvatarInHistory(setColors(this)) : handAvatar(setColors(this), currentStage);
	
			angular.extend(this, {
				showHand: showHand,
				approved: ''
			});
		}] };

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var medalAvatar = exports.medalAvatar = {
		bindings: {
			activity: '<'
		},
		template: '<span class="icon i-28 md-avatar" ng-class="vm.medalAvatar(vm.activity)"><md-tooltip class="custom-tooltip" md-direction="right">{{vm.Medal}}</md-tooltip></span>',
		controllerAs: 'vm',
		controller: ['CssClasses', '$stateParams', function medalAvatarCtrl(CssClasses, $stateParams) {
			var vm = this;
			var textColor = CssClasses.textColor;
			var icons = CssClasses.icons;
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
	
			vm.medalAvatar = medalAvatar;
			vm.Medal = '';
	
			function medalAvatar(activity) {
				if (currentStage === 'review') {
					if (activity.isFeedbackActivity === 1) {
						vm.Medal = 'Ajuste en retroalimentación';
	
						return [textColor.green, icons.feedback];
					}
				} else {
					if (activity.origin === 2) {
						vm.Medal = 'Agregada en ejecución';
	
						return [textColor.yellow, icons.important];
					} else if (activity.origin === 3) {
						vm.Medal = 'Agregada en ejecución (externo)';
	
						return [textColor.orange, icons.important];
					} else if (activity.origin != 1 && activity.origin != 2 && activity.origin != 3) {
						vm.Medal = 'Actividad no revisada';
	
						return [textColor.black, icons.important];
					}
				}
			}
		}] };

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var listData = exports.listData = {
		bindings: {
			activity: '<',
			selected: '<'
		},
		template: '\n    <div class="col-md-12 m-v-sm">\n      <div class="md-list-item-text">\n      <div class="col-xs-10 col-md-10 no-padding-r">\n          <p class="text-sm-important text-color no-margin exo p-v-xs {{ vm.changeColor }}">\n          <i \n            ng-if="vm.activity.isStrategicTracing==1"\n            ng-class="::vm.classEye"\n            class="icon i-24 no-padding"\n            ng-click="vm.strategicTracing(vm.details)"\n            ng-disabled="vm.showEye()"><md-tooltip class="custom-tooltip" md-direction="right">Seguimiento estrat\xE9gico</md-tooltip>  \n          </i>\n            {{ vm.headerName }}  \n          </p>\n          <p class="text-xs-important no-margin proxima {{ vm.changeColor }} p-v-xs">\n            {{ vm.topDescription }} \n          </p>\n          <p class="text-xs-important no-margin {{ vm.urgent }} p-v-xs">\n            {{ vm.bottomDescription }}\n         </p>\n      </div>\n      </div>\n    </div>',
		controllerAs: 'vm',
		controller: ['$state', '$cookies', '$stateParams', 'Validations', 'CssClasses', 'Ramda', 'WorkPlanSrv', '$rootScope', function listDataCtrl($state, $cookies, $stateParams, Validations, CssClasses, Ramda, WorkPlanSrv, $rootScope) {
			var _this = this;
	
			var curry = Ramda.curry;
	
			var textColor = CssClasses.textColor;
			var icons = CssClasses.icons;
	
			var listText = function listText(activity) {
				return {
					dateRange: 'Inicio: ' + activity.startDate + ' - Fin: ' + activity.endDate,
					asignatureCode: 'COD' + (activity.asignatureCode || ' NA'),
					periodicity: activity.periodicityName || 'No hay períodos planeados en esta actividad',
					plannedHours: (activity.totalHoursPlanned || 0) + ' hrs. planeadas - ' + (activity.totalHoursExecuted || 0) + ' hrs. ejecutadas',
					totalPlannedHours: 'Total hrs planeada: ' + (activity.totalHoursPlanned || 0) + ' - Total hrs ejecutadas: ' + (activity.totalHoursExecuted || 0),
					totalExecutedHours: 'hrs ejecutadas: ' + (activity.totalHoursExecuted || 0),
					percentage: 'Porcentaje ' + (activity.percentageDedication || 0) + '%',
					unit: '' + (activity.academicUnitName || 'Sin unidad académica asignada'),
					plannedPercentage: 'Porcentaje planeado: ' + (activity.percentagePanning || 0) + '%',
					executedPercentage: 'Porcentaje ejecutado: ' + (activity.percentageExecuted || 0) + '%',
					nameRegister: '' + (activity.nameCommunicationRegister || 'No posee registro')
				};
			};
	
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var inReviewExecution = Validations.inReviewExecution(currentStage);
			var inEvaluation = Validations.inEvaluation(currentStage);
	
			this.headerName = '';
			this.topDescription = '';
			this.bottomDescription = '';
			var isActivitiesType = Validations.isActivitiesType,
			    isCommitteeParticipationType = Validations.isCommitteeParticipationType,
			    isSubjectType = Validations.isSubjectType,
			    isPositionByDelegationType = Validations.isPositionByDelegationType,
			    isStudentAttentionType = Validations.isStudentAttentionType,
			    isOtherActivitiesType = Validations.isOtherActivitiesType,
			    isRolesType = Validations.isRolesType,
			    isCrossExtensionProjectsType = Validations.isCrossExtensionProjectsType,
			    isVisibilityType = Validations.isVisibilityType;
	
	
			this.$onInit = function () {
				_this.urgent = isUrgent() ? textColor.red : setTextColor(_this);
				setTextColor(_this);
			};
	
			this.$onChanges = function () {
				_this.urgent = isUrgent() ? textColor.red : setTextColor(_this);
				setTextColor(_this);
				_this.headerName = getHeaderName(_this.activity);
				_this.topDescription = getTopDescription(_this.activity);
				_this.bottomDescription = getBottomDescription(_this.activity);
			};
	
			function setTextColor(scope) {
				scope.changeColor = scope.selected === scope.activity ? textColor.white : textColor.black;
	
				return scope.changeColor;
			}
	
			function isUrgent() {
				return inEvaluation || inReviewExecution;
			}
	
			$rootScope.$on('rootScope:execHours', function () {
				_this.headerName = getHeaderName(_this.activity);
				_this.topDescription = getTopDescription(_this.activity);
				_this.bottomDescription = getBottomDescription(_this.activity);
			});
			function getHeaderName(activity) {
				switch (true) {
	
					case isSubjectType(activity):
						return activity.asignatureName || 'Actividad de sin nombre asignado';
					case isActivitiesType(activity):
						return activity.activityTypeNameCombo || 'Actividad de sin nombre asignado';
					case isStudentAttentionType(activity):
						return activity.scheduleTypeName || 'Actividad de sin nombre asignado';
					case isPositionByDelegationType(activity):
						return activity.workplanTeacherChargeName || 'Cargo por delegación sin nombre';
					case isCommitteeParticipationType(activity):
						return activity.committeeName || 'Actividad de sin nombre asignado';
					case isRolesType(activity):
						return activity.roleName || 'Actividad de sin nombre asignado';
					case isOtherActivitiesType(activity):
						return activity.otherActivityItemName || 'Actividad de sin nombre asignado';
					case isCrossExtensionProjectsType(activity):
						return activity.projectName || 'Actividad de sin nombre asignado';
					default:
						return activity.name || 'Actividad de sin nombre asignado';
	
				}
			}
			function getTopDescription(activity) {
				var list = listText(activity);
	
				switch (true) {
	
					case isSubjectType(activity):
						return [list.asignatureCode, list.periodicity, list.totalPlannedHours].join(' - ');
					case isActivitiesType(activity):
						return list.plannedHours;
					case isStudentAttentionType(activity):
						return list.plannedHours;
					case isPositionByDelegationType(activity):
						return list.unit;
					case isCommitteeParticipationType(activity):
						return isUrgent() ? '' : list.totalPlannedHours;
					case isRolesType(activity):
						return isUrgent() ? '' : [activity.startDate ? list.dateRange : list.periodicity, list.unit].join(' - ');
					case isOtherActivitiesType(activity):
						return isUrgent() ? '' : [activity.startDate ? list.dateRange : list.periodicity, list.plannedHours].join(' - ');
					default:
						return isUrgent() ? '' : list.totalPlannedHours;
	
				}
			}
			function getBottomDescription(activity) {
				var list = listText(activity);
				var text = '';
	
				switch (true) {
	
					case isPositionByDelegationType(activity):
						text = isUrgent() ? [list.plannedPercentage, list.executedPercentage] : [list.totalPlannedHours, list.percentage];
						break;
					case isRolesType(activity):
						text = isUrgent() ? [list.totalPlannedHours] : [list.totalPlannedHours || 'No registra planeación'];
						break;
					case isVisibilityType(activity):
						text = isUrgent() ? [list.totalPlannedHours] : [list.nameRegister];
						break;
					case isSubjectType(activity) || isActivitiesType(activity) || isStudentAttentionType(activity):
						text = [''];
						break;
					default:
						text = isUrgent() ? [list.totalPlannedHours] : [''];
						break;
	
				}
	
				if (text !== ['']) {
					text = text.filter(Boolean);
	
					return text.join(' - ');
				} else {
					text = text.filter(Boolean);
				}
			}
	
			angular.extend(this, {
				urgent: '',
				changeColor: '',
				classEye: [icons.eye, textColor.green],
				approvedHand: [icons.thumbsUp, textColor.blue],
				repprovedHand: [icons.thumbsDown, textColor.blue]
			});
		}] };

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var activityTag = exports.activityTag = {
		bindings: {
			activity: '<',
			selected: '<',
			notShowCheckbox: '<'
		},
		template: '\n      <div ng-if="!vm.tagHtmltag(vm.activity)"   \n        class="activityTag font-bold text-block m-h-sm m-b-sm" \n        ng-class="vm.tagClass(vm.activity)" >\n        {{ vm.activity.tagName }}\n      </div>\n\n      <div ng-if="vm.activity.isForPlan === 0" \n        class="activityTag font-bold text-block morado m-h-sm m-b-sm">\n        Sin planear\n      </div>\n\n      <div ng-if="vm.tagHtmltag(vm.activity)"   \n        class="activityTag font-bold text-block m-h-sm m-b-sm" \n        ng-class="vm.tagClass(vm.activity)">\n        {{ vm.activity.tagName }}\n      </div>\n      <div ng-if="vm.tagHtmltag(vm.activity) && !vm.notShowCheckbox" \n        class="clearfix text-xxs font-bold m-t-sm leftActivityDetailsCheck">\n        <span class="text-negro-dark">\n          Ejecutar asignatura\n        <label class="m-l-xs md-check">\n        <input type="checkbox" \n          ng-model="vm.cb1" \n          aria-label="Checkbox 1"  \n          ng-click="vm.toggle(vm.activity)" \n          ng-disabled="vm.validateExecuteSubject(vm.activity)">\n          <i class="verde"></i>\n        </label>\n        </span>\n      </div>',
		controllerAs: 'vm',
		controller: ['$stateParams', '$scope', '$state', 'Validations', 'Ramda', '$mdDialog', 'WorkPlanModalSrv', '$cookies', 'ReviewSrv', 'CssClasses', 'GlobalConfig', function activitiesListCtrl($stateParams, $scope, $state, Validations, Ramda, $mdDialog, WorkPlanModalSrv, $cookies, ReviewSrv, CssClasses, GlobalConfig) {
			var _this = this;
	
			var curry = Ramda.curry;
			var isActivitiesType = Validations.isActivitiesType,
			    isCommitteeParticipationType = Validations.isCommitteeParticipationType,
			    isTeacherDevelopmentType = Validations.isTeacherDevelopmentType,
			    isProjectsType = Validations.isProjectsType,
			    isSubjectType = Validations.isSubjectType,
			    isPositionByDelegationType = Validations.isPositionByDelegationType,
			    isDoctoralEducationType = Validations.isDoctoralEducationType,
			    isProjectDesignType = Validations.isProjectDesignType,
			    isStudentAttentionType = Validations.isStudentAttentionType,
			    isOtherActivitiesType = Validations.isOtherActivitiesType,
			    isCommunityType = Validations.isCommunityType,
			    isProductsType = Validations.isProductsType,
			    isRolesType = Validations.isRolesType,
			    isInvestigationType = Validations.isInvestigationType,
			    isResultsTransferType = Validations.isResultsTransferType,
			    isColaborationSpaceType = Validations.isColaborationSpaceType,
			    isInternalProjectsFormulationType = Validations.isInternalProjectsFormulationType,
			    isExtensionProjectsType = Validations.isExtensionProjectsType,
			    isVisibilityType = Validations.isVisibilityType,
			    isConsultancyType = Validations.isConsultancyType,
			    isShortCoursesType = Validations.isShortCoursesType,
			    isCrossProjectFormulationType = Validations.isCrossProjectFormulationType,
			    isCrossExtensionProjectsType = Validations.isCrossExtensionProjectsType;
	
	
			var is = {
				blue: function blue(activity) {
					return isActivitiesType(activity) || isCommitteeParticipationType(activity) || isTeacherDevelopmentType(activity) || isProjectsType(activity) || isInternalProjectsFormulationType(activity);
				},
				green: function green(activity) {
					return isSubjectType(activity) || isPositionByDelegationType(activity) || isDoctoralEducationType(activity) || isProjectDesignType(activity) || isExtensionProjectsType(activity);
				},
				purple: function purple(activity) {
					return isStudentAttentionType(activity) || isOtherActivitiesType(activity) || isCommunityType(activity) || isProductsType(activity) || isCrossProjectFormulationType(activity);
				},
				gray: function gray(activity) {
					return isRolesType(activity) || isInvestigationType(activity) || isVisibilityType(activity);
				},
				cyan: function cyan(activity) {
					return isResultsTransferType(activity) || isConsultancyType(activity);
				},
				red: function red(activity) {
					return isColaborationSpaceType(activity) || isCrossExtensionProjectsType(activity);
				},
				yellow: function yellow(activity) {
					return isShortCoursesType(activity);
				}
			};
	
			var tagClass = curry(function (is, activity) {
				switch (true) {
	
					case is.green(activity):
						return 'verde';
					case is.blue(activity):
						return 'azul';
					case is.gray(activity):
						return 'gris-dark';
					case is.purple(activity):
						return 'morado';
					case is.cyan(activity):
						return 'cian-light';
					case is.red(activity):
						return 'rojo';
					case is.yellow(activity):
						return 'amarillo';
	
				}
			})(is);
	
			var tagHtmltag = curry(function (scope, is, activity) {
				// if (activity.executionFinish !== 1) scope.cb1 = Boolean(activity.isExecution)
				if (activity.executionFinish !== 1) scope.cb1 = Boolean(activity.origin == 3 && activity.checkStatus == 1);
	
				if (isSubjectType(activity) && activity.origin === 3) {
					return true;
				}
	
				return false;
			})(this, is);
	
			var toggle = function toggle(activity) {
				if (_this.activity.checkStatus == true) {
					_this.cb1 = false;
				} else {
					_this.cb1 = true;
				}
	
				_this.activity.checkStatus = _this.cb1;
				// WorkPlanModalSrv.setupActivity(this, activity)
				var THIS = _this;
	
				if (_this.cb1 == true) {
					$mdDialog.show({
						controller: ['$scope', '$mdDialog', '$state', 'ReviewSrv', '$rootScope', '$timeout', function ($scope, $mdDialog, $state, ReviewSrv, $rootScope, $timeout) {
							$scope.buttonFlagSave = false;
							$scope.alertModule = close;
	
							$timeout(function () {
								$('body .md-icon-button').addClass('closebuttonremove');
								$('.closebuttonremove').hide();
							}, 100);
	
							// $scope.buttonFlagCancel=true
							$scope.save = function () {
								THIS.activity.checkStatus = THIS.cb1;
								$scope.buttonFlagSave = true;
								// $scope.buttonFlagCancel=false
	
								// let header = {id_code: activity.workplanTeacherActivityId}
								var param = { activityId: THIS.activity.activityId,
									workplanTeacherActivityId: THIS.activity.workplanTeacherActivityId };
	
								ReviewSrv.addCustomActivity.updateAssignaturestatus(param).$promise.then(function (dataReturn) {
									$mdDialog.hide();
									$scope.buttonFlagSave = false;
									$rootScope.$broadcast('selectActivityEmit', THIS.activity);
								});
							};
	
							$scope.close = function () {
								THIS.cb1 = false;
								$scope.buttonFlagSave = true;
								THIS.activity.checkStatus = THIS.cb1;
								// $scope.buttonFlagSave=true
								$rootScope.$broadcast('selectActivityEmit', THIS.activity);
								$mdDialog.hide();
							};
	
							$scope.alertModule = function () {
								THIS.cb1 = false;
								$scope.buttonFlagSave = true;
								THIS.activity.checkStatus = THIS.cb1;
								// $scope.buttonFlagSave=true
								$mdDialog.hide();
							};
						}],
						// template: '<div ng-include="setupErrorModal"><div>',
						template: __webpack_require__(460),
						clickOutsideToClose: false,
						escapeToClose: false
					});
				} else {
					$mdDialog.show({
						controller: ['$scope', '$mdDialog', '$state', 'ReviewSrv', '$rootScope', '$timeout', function ($scope, $mdDialog, $state, ReviewSrv, $rootScope, $timeout) {
							$scope.buttonFlagSave = false;
	
							$timeout(function () {
								$('body .md-icon-button').addClass('closebuttonremove');
								$('.closebuttonremove').hide();
							}, 100);
	
							$scope.save = function () {
								THIS.activity.checkStatus = THIS.cb1;
								$scope.buttonFlagSave = true;
								$scope.alertModule = close;
								// let header = {id_code: activity.workplanTeacherActivityId}
								var param = { activityId: THIS.activity.activityId,
									workplanTeacherActivityId: THIS.activity.workplanTeacherActivityId };
	
								ReviewSrv.addCustomActivity.updateAssignaturestatus(param).$promise.then(function (dataReturn) {
									// $scope.close()
									$scope.buttonFlagSave = false;
									$mdDialog.hide();
									$rootScope.$broadcast('selectActivityEmit', THIS.activity);
								});
							};
	
							$scope.close = function () {
								THIS.cb1 = true;
								THIS.activity.checkStatus = THIS.cb1;
								$scope.buttonFlagSave = true;
								$rootScope.$broadcast('selectActivityEmit', THIS.activity);
								$mdDialog.hide();
							};
	
							$scope.alertModule = function () {
								THIS.cb1 = true;
								THIS.activity.checkStatus = THIS.cb1;
								$scope.buttonFlagSave = true;
								$mdDialog.hide();
							};
						}],
						// template: '<div ng-include="setupErrorModal"><div>',
						template: __webpack_require__(461),
						clickOutsideToClose: false
					});
				}
			};
	
			var executionFinishVal = function executionFinishVal(teacherId) {
				return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: teacherId }).$promise.then(function (dataReturn) {
					return dataReturn.status ? dataReturn.data.wokplanTeacherStatus[0].executionFinish : 0;
				});
			};
	
			var validateExecuteSubject = function validateExecuteSubject(activity) {
				var roleId = $cookies.get('hasRoleId');
				var approvedFinish = $cookies.get('workplan-approvedFinish');
				var executionFinish = $cookies.get('workplan-executionFinish');
	
				if (activity.executionFinish !== 1 && roleId == GlobalConfig.userRolesIds.teacher && approvedFinish == 1 && executionFinish != 1) return false;
	
				return true;
			};
	
			angular.extend(this, {
				cb1: false,
				disabled: false,
				tagClass: tagClass,
				tagHtmltag: tagHtmltag,
				toggle: toggle,
				validateExecuteSubject: validateExecuteSubject,
				executionFinishVal: executionFinishVal,
				executionFinish: Boolean($cookies.get('executionFinish')),
				roleIdDisabled: false
			});
	
			this.$onInit = function () {
				var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
	
				_this.disabled = Boolean(Validations.inReviewExecution(currentStage));
				_this.roleIdDisabled = false;
	
				if (Boolean($cookies.get('executionFinish')) && $cookies.get('hasRoleId') != GlobalConfig.userRolesIds.teacher) {
					_this.roleIdDisabled = true;
				}
			};
		}] };
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=row> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <div class=\"panel bg-success p-md m-b-md\"> <h4 class=no-margin>¡Atención!</h4> </div> <h4>Las actividades de la asignatura han sido habilitadas para registrar su ejecución.</h4> </div> </div> </md-content> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-light\" ng-disabled=buttonFlagSave ng-click=save()> Aceptar</md-button> <md-button class=\"btn btn-fw btn-light\" ng-disabled=buttonFlagSave ng-click=close()> no Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=row> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <div class=\"panel bg-success p-md m-b-md\"> <h4 class=no-margin>¡Atención!</h4> </div> <h4> Las actividades de la asignatura han sido bloqueadas, no podrá ingresar registros de ejecución.</h4> </div> </div> </md-content> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-light\" ng-disabled=buttonFlagSave ng-click=save()> Aceptar</md-button> <md-button class=\"btn btn-fw btn-light\" ng-disabled=buttonFlagSave ng-click=close()> no Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var projectTypeTag = exports.projectTypeTag = {
	  bindings: {
	    project: '<'
	  },
	  template: '\n    <div class="text-xxs projectTypeTag font-bold text-block" ng-class="proVM.tagClass(proVM.project)">\n      <p class="text-block no-margin">{{ proVM.project.activityTypeName }}</p>\n    </div>',
	  controllerAs: 'proVM',
	  controller: ['Validations', 'Ramda', function projectTypeCtrl(Validations, Ramda) {
	    var R = Ramda;
	
	    var isBlue = R.curry(function (lib, project) {
	      return lib.isCrossProject(project);
	    });
	
	    var isPurple = R.curry(function (lib, project) {
	      return lib.isInternalProject(project);
	    });
	
	    var tagClass = R.curry(function (lib, project) {
	      switch (true) {
	        case isBlue(lib, project):
	          return 'azul';
	        case isPurple(lib, project):
	          return 'morado';
	      }
	    });
	
	    this.tagClass = tagClass(Validations);
	  }] };

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var projectStateTag = exports.projectStateTag = {
	  bindings: {
	    project: '<'
	  },
	  template: '\n    <div class="text-xxs projectTypeTag font-bold text-block" ng-class="proStateVM.tagClass(proStateVM.project)">\n      <p class="text-block no-margin">{{ proStateVM.project.estatus }}</p>\n    </div>',
	  controllerAs: 'proStateVM',
	  controller: ['Validations', 'Ramda', function (Validations, Ramda) {
	    var R = Ramda;
	
	    var tagClass = R.curry(function (lib, project) {
	
	      if (lib.inReview(project.projectStateId)) {
	        return 'azul';
	      } else if (lib.inApproval(project.projectStateId)) {
	        return 'azul';
	      } else if (lib.inExecution(project.projectStateId)) {
	        return 'verde';
	      } else if (lib.inReviewExecution(project.projectStateId)) {
	        return 'morado';
	      } else if (lib.inEvaluation(project.projectStateId)) {
	        return 'morado';
	      } else {
	        return 'verde';
	      }
	    });
	
	    this.tagClass = tagClass(Validations);
	  }] };

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var projectVisibilityTag = exports.projectVisibilityTag = {
	  bindings: {
	    project: '<'
	  },
	  template: '\n    <div class="text-xxs projectTypeTag projectVisibilityTag font-bold text-block text-color-w" ng-class="proVisibilityVM.tagClass(proVisibilityVM.project)">\n      <p class="text-block no-margin">{{ proVisibilityVM.project.namecCommunicationRegister }}</p>\n    </div>',
	  controllerAs: 'proVisibilityVM',
	  controller: ['Validations', 'Ramda', function projectVisibilityCtrl(Validations, Ramda) {
	    var R = Ramda;
	
	    var isBlue = R.curry(function (lib, project) {
	      return lib.isCrossProject(project);
	    });
	
	    var isPurple = R.curry(function (lib, project) {
	      return lib.isInternalProject(project);
	    });
	
	    var tagClass = R.curry(function (lib, project) {
	
	      switch (true) {
	        case isBlue(lib, project):
	          return 'azul';
	        case isPurple(lib, project):
	          return 'morado';
	        default:
	          return 'naranjo';
	      }
	    });
	
	    this.tagClass = tagClass(Validations);
	  }] };

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addActivity = undefined;
	
	var _addActivity = __webpack_require__(466);
	
	var _addActivity2 = _interopRequireDefault(_addActivity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addActivity = exports.addActivity = {
	  bindings: {
	    disable: '<',
	    module: '<'
	  },
	  template: _addActivity2.default,
	  controllerAs: 'vm',
	  controller: ['$stateParams', '$mdDialog', 'Validations', 'GlobalConfig', 'Ramda', 'ReviewSrv', 'Util', 'WorkPlanModalSrv', function addActivityCtrl($stateParams, $mdDialog, Validations, GlobalConfig, Ramda, ReviewSrv, Util, WorkPlanModalSrv) {
	    var _this = this;
	
	    var isProjectDesignType = Validations.isProjectDesignType,
	        isProductsType = Validations.isProductsType,
	        isColaborationSpaceType = Validations.isColaborationSpaceType,
	        isInvestigationType = Validations.isInvestigationType,
	        isResultsTransferType = Validations.isResultsTransferType,
	        isCommitteeParticipationType = Validations.isCommitteeParticipationType,
	        isRolesType = Validations.isRolesType,
	        isOtherActivitiesType = Validations.isOtherActivitiesType,
	        isCommunityType = Validations.isCommunityType,
	        isTeacherDevelopmentType = Validations.isTeacherDevelopmentType,
	        inConsolidation = Validations.inConsolidation,
	        inAcademicManagement = Validations.inAcademicManagement,
	        inInvestigation = Validations.inInvestigation,
	        isDoctoralEducationType = Validations.isDoctoralEducationType;
	
	
	    var addActivity = function addActivity(activity) {
	      services({ activityTypeId: Number(activity) });
	    };
	
	    var services = function services(activity) {
	      switch (true) {
	        // Investigation
	        case isProjectDesignType(activity):
	          WorkPlanModalSrv.addInvestigationProjectsFormulation();
	          return 'Propuesta de investigación';
	        case isProductsType(activity):
	          WorkPlanModalSrv.addInvestigationProducts();
	          return 'Productos';
	        case isColaborationSpaceType(activity):
	          WorkPlanModalSrv.addInvestigationSpace();
	          return 'Espacios de colaboración';
	        case isInvestigationType(activity):
	          WorkPlanModalSrv.addInvestigationTrainingResearch();
	          return 'Investigación';
	        case isResultsTransferType(activity):
	          WorkPlanModalSrv.addInvestigationResultsTransfer();
	          return 'Transferencia de resultados';
	        // Academic Management
	        case isCommitteeParticipationType(activity):
	          WorkPlanModalSrv.addAcademicManagementCommitteParticipation();
	          return 'Participación en comité';
	        case isRolesType(activity):
	          WorkPlanModalSrv.addAcademicManagementRole();
	          return 'Roles';
	        case isOtherActivitiesType(activity):
	          WorkPlanModalSrv.addAcademicManagementActivity();
	          return 'Otra actividad';
	        // Consolidation CP
	        case isTeacherDevelopmentType(activity):
	          WorkPlanModalSrv.addConsolidationCourseExternal();
	          return 'Cursos externos';
	        case isCommunityType(activity):
	          WorkPlanModalSrv.addConsolidationLearningComunity();
	          return 'Comunidades de aprendizaje';
	        case isDoctoralEducationType(activity):
	          WorkPlanModalSrv.addDoctoralEducation();
	          return 'Formación doctoral';
	      }
	    };
	
	    var activitiesList = function activitiesList(module) {
	      switch (true) {
	        case inConsolidation(module):
	          return [{ name: 'Cursos externos', id: GlobalConfig.activityTypeId.teacherDevelopment }, { name: 'Comunidades de aprendizaje', id: GlobalConfig.activityTypeId.community }, { name: 'Formación doctoral', id: GlobalConfig.activityTypeId.doctoralEducation }];
	        case inAcademicManagement(module):
	          if ($stateParams.stage != GlobalConfig.workplanStages.execution) {
	            return [{ name: 'Participación en comité', id: GlobalConfig.activityTypeId.committeeParticipation }, { name: 'Rol', id: GlobalConfig.activityTypeId.roles }, { name: 'Actividad', id: GlobalConfig.activityTypeId.otherActivities }];
	          } else {
	            return [{ name: 'Participación en comité', id: GlobalConfig.activityTypeId.committeeParticipation }, { name: 'Actividad', id: GlobalConfig.activityTypeId.otherActivities }];
	          }
	        case inInvestigation(module):
	          return [{ name: 'Formulación de proyectos', id: GlobalConfig.activityTypeId.projectDesign }, { name: 'Producto', id: GlobalConfig.activityTypeId.products }, { name: 'Espacio de colaboración', id: GlobalConfig.activityTypeId.colaborationSpace }, { name: 'Formación de investigación', id: GlobalConfig.activityTypeId.investigation }, { name: 'Transferencia de resultados', id: GlobalConfig.activityTypeId.resultsTransfer }];
	      }
	    };
	
	    angular.extend(this, {
	      activityTypes: activitiesList(this.module),
	      activity: null,
	      addActivity: addActivity
	    });
	
	    this.$onInit = function () {
	      console.log(_this.activityTypes);
	    };
	  }] };

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"right text-base m-h-xs m-b-sm p-xs box-shadow\" layout=row layout-align=\"space-between center\"> <md-select class=no-margin ng-model=vm.activity placeholder=\"Seleccione opción\" class=md-no-underline ng-disabled=vm.disable> <md-option value={{type.id}} ng-repeat=\"type in vm.activityTypes\">{{type.name}}</md-option> </md-select> <md-button aria-label class=\"btn btn-fw btn-primary right text-center text-xs m-xs\" ng-click=vm.addActivity(vm.activity) ng-disabled=\"vm.disable || vm.activity == null\"> Agregar </md-button> </div> ";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addActivityExtension = undefined;
	
	var _addActivityExtension = __webpack_require__(468);
	
	var _addActivityExtension2 = _interopRequireDefault(_addActivityExtension);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addActivityExtension = exports.addActivityExtension = {
	  bindings: {
	    disable: '<'
	  },
	  template: _addActivityExtension2.default,
	  controllerAs: 'vm',
	  controller: ['$stateParams', '$mdDialog', 'Validations', 'GlobalConfig', 'Ramda', 'ReviewSrv', 'Util', 'WorkPlanModalSrv', function addActivityExtensionCtrl($stateParams, $mdDialog, Validations, GlobalConfig, Ramda, ReviewSrv, Util, WorkPlanModalSrv) {
	    var curry = Ramda.curry;
	    var confirm = Util.confirm('¡creacion de actividad exitosa!', 'La actividad');
	    var isInternalProjectsFormulationType = Validations.isInternalProjectsFormulationType,
	        isExtensionProjectsType = Validations.isExtensionProjectsType,
	        isVisibilityType = Validations.isVisibilityType,
	        isConsultancyType = Validations.isConsultancyType,
	        isShortCoursesType = Validations.isShortCoursesType;
	
	
	    var addActivityExtension = function addActivityExtension(activity) {
	      services({ activityTypeId: Number(activity) });
	    };
	
	    var services = curry(function (confirm, activity) {
	      switch (true) {
	        case isInternalProjectsFormulationType(activity):
	          console.log(activity);
	          WorkPlanModalSrv.addProjectFormulation();
	          return 'Formulación de propuesta';
	        case isExtensionProjectsType(activity):
	          // console.log("aqui")     
	          WorkPlanModalSrv.addProjectExtension();
	          return 'Proyecto de extensión';
	        case isVisibilityType(activity):
	          WorkPlanModalSrv.addVisibility();
	          return 'Visibilidad';
	        case isConsultancyType(activity):
	          WorkPlanModalSrv.addCounselingAndConsultancy();
	          return 'Consultoría y asesoría';
	        case isShortCoursesType(activity):
	          WorkPlanModalSrv.addEducation();
	          return 'Educación continuada';
	      }
	    })(confirm);
	
	    angular.extend(this, {
	      activityTypes: [{ name: 'Formulación de propuesta', id: GlobalConfig.activityTypeId.internalProjectsFormulation }, { name: 'Proyecto de extensión', id: GlobalConfig.activityTypeId.extensionProjects }, { name: 'Visibilidad', id: GlobalConfig.activityTypeId.visibility }, { name: 'Consultoría y asesoría', id: GlobalConfig.activityTypeId.consultancy }, { name: 'Educación continuada', id: GlobalConfig.activityTypeId.shortCourses }],
	      activity: null,
	      addActivityExtension: addActivityExtension
	    });
	  }] };

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"right text-base p-b-sm p-h m-h box-shadow\" layout=row layout-align=\"space-between center\"> <span class=m-r-sm>Nuevo</span> <md-select class=no-margin ng-model=vm.activity placeholder=\"Seleccione opción\" class=md-no-underline ng-disabled=vm.disable> <md-option value={{type.id}} ng-repeat=\"type in vm.activityTypes\"> {{type.name}} </md-option> </md-select> <md-button aria-label class=\"btn btn-fw btn-primary text-xs\" ng-click=vm.addActivityExtension(vm.activity) ng-disabled=\"vm.disable || vm.activity == null\"> Agregar </md-button> </div> ";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.activityDetails = undefined;
	
	var _activityDetails = __webpack_require__(470);
	
	var _activityDetails2 = _interopRequireDefault(_activityDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var activityDetails = exports.activityDetails = {
	  bindings: {
	    activity: '<',
	    details: '<',
	    module: '<',
	    label: '<'
	  },
	  template: _activityDetails2.default,
	  controllerAs: 'vm',
	  controller: ['Validations', '$stateParams', function activityDetailsCtrl(Validations, $stateParams) {
	    var _this = this;
	
	    var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
	    var inAcademicManagement = Validations.inAcademicManagement,
	        inTeaching = Validations.inTeaching,
	        inConsolidation = Validations.inConsolidation,
	        inInvestigation = Validations.inInvestigation,
	        inExtension = Validations.inExtension,
	        isActivitiesType = Validations.isActivitiesType,
	        isCommitteeParticipationType = Validations.isCommitteeParticipationType,
	        isTeacherDevelopmentType = Validations.isTeacherDevelopmentType,
	        isProjectsType = Validations.isProjectsType,
	        isSubjectType = Validations.isSubjectType,
	        isPositionByDelegationType = Validations.isPositionByDelegationType,
	        isDoctoralEducationType = Validations.isDoctoralEducationType,
	        isProjectDesignType = Validations.isProjectDesignType,
	        isStudentAttentionType = Validations.isStudentAttentionType,
	        isCommunityType = Validations.isCommunityType,
	        isProductsType = Validations.isProductsType,
	        isInvestigationType = Validations.isInvestigationType,
	        isResultsTransferType = Validations.isResultsTransferType,
	        isColaborationSpaceType = Validations.isColaborationSpaceType,
	        isInternalProjectsFormulationType = Validations.isInternalProjectsFormulationType,
	        isExtensionProjectsType = Validations.isExtensionProjectsType,
	        isVisibilityType = Validations.isVisibilityType,
	        isConsultancyType = Validations.isConsultancyType,
	        isShortCoursesType = Validations.isShortCoursesType,
	        isCrossProjectFormulationType = Validations.isCrossProjectFormulationType,
	        isCrossExtensionProjectsType = Validations.isCrossExtensionProjectsType,
	        inReview = Validations.inReview,
	        inApproval = Validations.inApproval,
	        inExecution = Validations.inExecution,
	        inReviewExecution = Validations.inReviewExecution,
	        inEvaluation = Validations.inEvaluation;
	
	
	    angular.extend(this, {
	      inHistory: $stateParams.inHistory,
	      inAcademicManagement: inAcademicManagement(this.module),
	      inTeaching: inTeaching(this.module),
	      inConsolidation: inConsolidation(this.module),
	      inInvestigation: inInvestigation(this.module),
	      inExtension: inExtension(this.module),
	      isSubjectType: isSubjectType,
	      isStudentAttentionType: isStudentAttentionType,
	      isActivitiesType: isActivitiesType,
	      isCommitteeParticipationType: isCommitteeParticipationType,
	      isPositionByDelegationType: isPositionByDelegationType,
	      isDoctoralEducationType: isDoctoralEducationType,
	      isTeacherDevelopmentType: isTeacherDevelopmentType,
	      isCommunityType: isCommunityType,
	      isProjectsType: isProjectsType,
	      isProjectDesignType: isProjectDesignType,
	      isProductsType: isProductsType,
	      isInvestigationType: isInvestigationType,
	      isResultsTransferType: isResultsTransferType,
	      isColaborationSpaceType: isColaborationSpaceType,
	      isInternalProjectsFormulationType: isInternalProjectsFormulationType,
	      isExtensionProjectsType: isExtensionProjectsType,
	      isVisibilityType: isVisibilityType,
	      isConsultancyType: isConsultancyType,
	      isShortCoursesType: isShortCoursesType,
	      isCrossProjectFormulationType: isCrossProjectFormulationType,
	      isCrossExtensionProjectsType: isCrossExtensionProjectsType,
	      inReview: inReview(currentStage),
	      inApproval: inApproval(currentStage),
	      inExecution: inExecution(currentStage),
	      inReviewExecution: inReviewExecution(currentStage),
	      inEvaluation: inEvaluation(currentStage),
	      parentActivities: function parentActivities(activity) {
	        if (_this.isProductsType(activity)) {
	          return activity.isProjectsAssociated === 0;
	        } else {
	          return _this.isProjectsType(activity) || _this.isExtensionProjectsType(activity) || _this.isCrossExtensionProjectsType(activity);
	        }
	      },
	      showEntriesList: function showEntriesList(activity) {
	        if (_this.isProductsType(activity) || _this.isProjectsType(activity) || _this.isExtensionProjectsType(activity) || _this.isCrossExtensionProjectsType(activity)) {
	          if (_this.inExecution || _this.inReviewExecution || _this.inEvaluation) {
	            return !activity.hoursChildren;
	          } else {
	            return false;
	          }
	        }
	
	        if (_this.inExecution || _this.inReviewExecution || _this.inEvaluation) {
	          return _this.isActivitiesType(activity) || _this.isStudentAttentionType(activity) || _this.inAcademicManagement || _this.inConsolidation || _this.inInvestigation || _this.inExtension;
	        }
	        return false;
	      },
	      useMainInfo: function useMainInfo(activity) {
	        return _this.isResultsTransferType(activity) || _this.isProductsType(activity) || _this.isProjectsType(activity) || _this.isProjectDesignType(activity) || _this.isInvestigationType(activity) || _this.isColaborationSpaceType(activity) || _this.isCommunityType(activity) || _this.isDoctoralEducationType(activity) || _this.isInternalProjectsFormulationType(activity) || _this.isExtensionProjectsType(activity) || _this.isVisibilityType(activity) || _this.isConsultancyType(activity) || _this.isShortCoursesType(activity) || _this.isCrossProjectFormulationType(activity) || _this.isCrossExtensionProjectsType(activity);
	      }
	    });
	  }] };

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-7> <details-header label=::vm.label details=::vm.details.data activity=::vm.activity> </details-header> <subject details=::vm.details.data planning=::vm.details.planning teaching=::vm.details.teaching activity=::vm.activity label=::vm.label ng-if=::vm.isSubjectType(vm.activity)> </subject> <student-attention details=::vm.details.data ng-if=::vm.isStudentAttentionType(vm.activity)> </student-attention> <children-activities parent=::vm.activity activity=::vm.activity children=::vm.details.otherActivity ng-if=::vm.isActivitiesType(vm.activity)> </children-activities> <main-info data=::vm.details.data module=::vm.module ng-if=::vm.inAcademicManagement> </main-info> <main-info data=::vm.details.data module=::vm.module ng-if=::vm.isTeacherDevelopmentType(vm.activity)> </main-info> <main-info data=::vm.details.data module=::vm.module stack-items=true ng-if=::vm.useMainInfo(vm.activity)> </main-info> <entries-list details=::vm.details.data activity=::vm.activity ng-if=\"::(vm.showEntriesList(vm.activity) && !vm.isSubjectType(vm.activity))\"> </entries-list> <planned-activities ng-if=::vm.parentActivities(vm.details.data) parent=::vm.details.data children=::vm.details.children activity=::vm.activity> </planned-activities> </div> ";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.detailsHeader = undefined;
	
	var _detailsHeader = __webpack_require__(472);
	
	var _detailsHeader2 = _interopRequireDefault(_detailsHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var detailsHeader = exports.detailsHeader = {
		bindings: {
			label: '<',
			details: '<',
			activity: '<'
		},
		template: _detailsHeader2.default,
		controllerAs: 'vm',
		controller: ['$cookies', '$stateParams', 'CssClasses', 'Validations', 'GlobalConfig', 'ReviewSrv', 'Ramda', 'GlobalSrv', '$rootScope', '$interval', 'ngNotify', function detailsHeaderCtrl($cookies, $stateParams, CssClasses, Validations, GlobalConfig, ReviewSrv, Ramda, GlobalSrv, $rootScope, $interval, ngNotify) {
			var _this = this;
	
			var curry = Ramda.curry;
			var vm = this;
			var icons = CssClasses.icons;
			var textColor = CssClasses.textColor;
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var inHistory = $stateParams.inHistory;
			var user = JSON.parse($cookies.get('currentUser'));
			var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
			$rootScope.setHandsProgress = false;
			var isWorkplanCommittee = Validations.isWorkplanCommittee(currentRoleId);
	
			var up = 1;
			var down = 0;
	
			var namesList = ['name', 'nameSpace', 'nameResearch', 'nameProject', 'asignatureName', 'itemName', 'nameCharge', 'scheduleTypeName', 'roleName', 'comiteeName', 'titleProject', 'nameVisibility', 'projectName'];
	
			var activityHeader = curry(function (names, label, details) {
				var name = names.filter(function (name) {
					return Reflect.has(details, name);
				}).map(function (key) {
					return details[key];
				});
	
				return [label].concat(_toConsumableArray(name)).join(' - ');
			})(namesList);
	
			angular.extend(this, {
				activityHeader: activityHeader,
				isTeacher: Validations.isTeacher,
				currentRoleId: JSON.parse($cookies.get('hasRoleId')),
				inEvaluation: Validations.inEvaluation(currentStage),
				inReviewExecution: Validations.inReviewExecution(currentStage),
				inReview: Validations.inReview(currentStage),
				inApproval: Validations.inApproval(currentStage),
				inExecution: Validations.inExecution(currentStage),
				evaluationFinish: 1,
				isDisabled: false
			});
	
			angular.extend(this, {
				classEye: [icons.eye, textColor.gray],
				approvedHand: [icons.thumbsUp, textColor.gray],
				repprovedHand: [icons.thumbsDown, textColor.gray],
				isEditHands: isEditHands
			});
	
			angular.extend(this, {
				showEye: showEye,
				approve: approve,
				reprove: reprove,
				strategicTracing: strategicTracing
			});
	
			var teacherId = $stateParams.teacherId;
	
			if (!teacherId) {
				teacherId = JSON.parse($cookies.get('currentUser')).teacherId;
			}
	
			vm.$onInit = function () {
				setMainLabel(_this);
				loadColorsIcons(vm.details);
				isEditHands();
			};
	
			function setMainLabel(vm) {
				if (Validations.isStudentAttentionType(vm.details)) {
					vm.label = 'de atención a estudiantes';
				} else if (Validations.isActivitiesType(vm.details)) {
					vm.label = 'de actividad';
				}
			}
	
			function approve(activity, approvedHand, repprovedHand) {
				var stage = setStage(currentStage);
				var json = _defineProperty({
					idTeacher: teacherId,
					idActivity: activity.workplanTeacherActivityId,
					idEvaluator: user.id,
					idRol: currentRoleId
				}, stage[0], up);
				var iconApprovedValue = approvedHand;
				var iconRepprovedValue = repprovedHand;
	
				vm.approvedHand = [icons.thumbsUp, textColor.blue];
				vm.repprovedHand = [icons.thumbsDown, textColor.gray];
	
				setHands(json, iconApprovedValue, iconRepprovedValue, stage[1], activity, 1);
			}
	
			function reprove(activity, approvedHand, repprovedHand) {
				var stage = setStage(currentStage);
				var json = _defineProperty({
					idTeacher: teacherId,
					idActivity: activity.workplanTeacherActivityId,
					idEvaluator: user.id,
					idRol: currentRoleId
				}, stage[0], down);
				var iconApprovedValue = approvedHand;
				var iconRepprovedValue = repprovedHand;
	
				vm.approvedHand = [icons.thumbsUp, textColor.gray];
				vm.repprovedHand = [icons.thumbsDown, textColor.red];
				setHands(json, iconApprovedValue, iconRepprovedValue, stage[1], activity, 0);
			}
	
			function showUnauthorizedToast() {
				ngNotify.set('No tiene permiso para revisar actividades de este submódulo. Contacte a su administrador si considera que se trata de un error.', 'warn');
			}
	
			function setHands(json, iconApprovedValue, iconRepprovedValue, action, activity, status) {
				$rootScope.setHandsProgress = true;
				vm.isDisabled = true;
				ReviewSrv['set' + action].post(json).$promise.then(function (dataReturn) {
					var data = { activity: activity, status: status, currentStage: currentStage };
	
					GlobalSrv.notify($rootScope, 'ApproveRepprove', data);
	
					if (!dataReturn.status) {
						vm.approvedHand = iconApprovedValue;
						vm.repprovedHand = iconRepprovedValue;
	
						if (dataReturn.code === 'UNAUTHORIZED_SUBMODULE') {
							showUnauthorizedToast();
						}
					}
	
					$rootScope.setHandsProgress = false;
					vm.isDisabled = false;
				});
			}
	
			function setStage(stage) {
				switch (stage) {
	
					case 'review':
						return ['isReviewed', 'Review'];
					case 'approval':
						return ['isApproved', 'Approve'];
					case 'evaluation':
						return ['isAccept', 'Accept'];
					case 'execution':
						return ['isApproved', 'Approve'];
					case 'reviewExecution':
						return ['isExecution', 'ReviewedExecution'];
	
				}
			}
	
			function setHeader(activity, value) {
				return {
					idTeacher: teacherId,
					idActivity: activity.workplanTeacherActivityId,
					idEvaluator: user.id,
					idRol: currentRoleId,
					isStrategicTracing: value
				};
			}
	
			function setEyeColor(value) {
				if (value === up) {
					vm.classEye = [icons.eye, textColor.green];
	
					return vm.classEye;
				} else {
					vm.classEye = [icons.eye, textColor.gray];
	
					return vm.classEye;
				}
			}
	
			function getSendNotify(name, notificationType) {
				var msg = 'Profesor: se ha eliminado la actividad ' + name + ' del módulo de Seguimiento estratégico';
	
				var data = {
					idUser: null,
					idTeacher: teacherId,
					dsName: 'Notificación, Seguimiento estratégico',
					dsDescription: msg,
					idNotification_delivery_type: notificationType,
					is_grouped: 1
				};
	
				GlobalSrv.sendNotification(data);
			}
	
			function getValueStrategicTracing(value) {
				switch (value) {
	
					case up:
						return down;
					case down:
						return up;
					default:
						return up;
	
				}
			}
	
			function strategicTracing(activity) {
				$rootScope.setHandsProgress = true;
				vm.isDisabled = true;
				var value = getValueStrategicTracing(activity.isStrategicTracing);
	
				setEyeColor(value);
				var header = setHeader(activity, value);
	
				ReviewSrv.setStrategicTracing.post(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						activity.isStrategicTracing = Number(value);
						GlobalSrv.notify($rootScope, 'isStrategicTracing', activity);
						/*if (value == 0){
	           let name = namesList.filter(name => Reflect.has(this.details, name)).map(key => this.details[key])
	           getSendNotify(name, GlobalConfig.notificationType.inbox)
	           getSendNotify(name, GlobalConfig.notificationType.email)
	         }*/
					} else {
						setEyeColor(value);
					}
	
					$rootScope.setHandsProgress = false;
					vm.isDisabled = false;
				});
			}
	
			function loadColorsIcons(activity) {
				var value = activity.isStrategicTracing;
	
				setEyeColor(value);
				var stage = '';
	
				if (inHistory) {
					stage = handAvatarInHistory(activity);
				} else {
					stage = setStage(currentStage)[0];
				}
	
				handsColorSetting(activity[stage]);
			}
	
			function handAvatarInHistory(activity) {
				switch (activity.stageId) {
	
					case GlobalConfig.workplanIdStages.approval:
						return 'isReviewed';
					case GlobalConfig.workplanIdStages.execution:
						return 'isApproved';
					case GlobalConfig.workplanIdStages.reviewExecution:
						return 'isApproved';
					case GlobalConfig.workplanIdStages.evaluation:
						return 'isExecution';
					case 7:
						return 'isAccept';
					default:
						return 'isReviewed';
	
				}
			}
	
			function handsColorSetting(state) {
				if (state === up) {
					vm.approvedHand = [icons.thumbsUp, textColor.blue];
					vm.repprovedHand = [icons.thumbsDown, textColor.gray];
				} else if (state === down) {
					vm.approvedHand = [icons.thumbsUp, textColor.gray];
					vm.repprovedHand = [icons.thumbsDown, textColor.red];
				} else {
					vm.approvedHand = [icons.thumbsUp, textColor.gray];
					vm.repprovedHand = [icons.thumbsDown, textColor.gray];
				}
			}
	
			function isStageFinished() {
				if (Validations.isConsultant(currentRoleId)) return true;else if (vm.inReview) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.review;
				} else if (vm.inApproval) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.approval;
				} else if (vm.inReviewExecution) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.reviewExecution;
				} else if (vm.evaluationFinish) {
					return vm.details.stageId != GlobalConfig.workplanIdStages.evaluation;
				}
			}
	
			function showEye() {
				if (vm.inReview || vm.inApproval || vm.inExecution) {
					if (vm.currentRoleId == 9 || vm.currentRoleId == 8) {
						return false; //isStageFinished() || vm.isDisabled || isWorkplanCommittee
					} else return true;
				} else {
					return true;
				}
			}
	
			function isEditHands() {
				if (vm.currentRoleId == 9 && (vm.details.stageId == 2 || vm.details.stageId == 5) || vm.currentRoleId == 8 && (vm.details.stageId == 3 || vm.details.stageId == 6)) {
					return false; //isStageFinished() || vm.isDisabled || isWorkplanCommittee
				} else return true;
			}
		}] };

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-12 m-v-sm\"> <div class=\"col-md-6 no-padding\"> <h6 class=\"text-azul m-r-sm font-bold text-block\"> Detalle {{ vm.activityHeader(vm.label, vm.details) }} </h6> </div> <div class=col-md-4 style=\"padding:5px 0\"> <activity-tag activity=vm.activity not-show-checkbox=true> </activity-tag></div> <div class=col-md-2 style=\"padding:5px 0\"> <button ng-class=vm.repprovedHand class=\"icon i-24 strip-btn right no-padding\" ng-click=\"vm.reprove(vm.details, vm.approvedHand, vm.repprovedHand)\" ng-disabled=vm.isEditHands()> <md-tooltip>Rechazar</md-tooltip> </button> <button style=\"padding:0 10px\" ng-class=vm.approvedHand class=\"icon i-24 strip-btn right\" ng-click=\"vm.approve(vm.details, vm.approvedHand, vm.repprovedHand)\" ng-disabled=vm.isEditHands()> <md-tooltip>Aprobar</md-tooltip> </button> <button ng-class=vm.classEye class=\"icon i-24 strip-btn right no-padding\" ng-click=vm.strategicTracing(vm.details) ng-disabled=vm.showEye()> <md-tooltip>Seguimiento estratégico</md-tooltip> </button> </div> </div> ";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mainInfo = undefined;
	
	var _mainInfo = __webpack_require__(474);
	
	var _mainInfo2 = _interopRequireDefault(_mainInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var mainInfo = exports.mainInfo = {
	  bindings: {
	    data: '<',
	    stackItems: '<',
	    module: '<'
	  },
	  template: _mainInfo2.default,
	  controllerAs: 'vm',
	  controller: ['$scope', '$rootScope', '$cookies', '$state', '$stateParams', 'WorkPlanSrv', 'CssClasses', 'Validations', 'Ramda', 'GlobalSrv', 'Util', function mainInfoCtrl($scope, $rootScope, $cookies, $state, $stateParams, WorkPlanSrv, CssClasses, Validations, Ramda, GlobalSrv, Util) {
	    var _this = this;
	
	    // constants
	    var R = Ramda;
	    var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
	    var inHistory = $stateParams.inHistory;
	    var currentModule = this.module;
	    var setDate = Util.setDate;
	    var unique = Util.unique;
	    var objHas = Util.objHas;
	    // variables
	    var _details = [];
	    var _format = [];
	
	    var inReview = Validations.inReview(currentStage);
	    var inApproval = Validations.inApproval(currentStage);
	    var inExecution = Validations.inExecution(currentStage);
	    var inReviewExecution = Validations.inReviewExecution(currentStage);
	    var inEvaluation = Validations.inEvaluation(currentStage);
	    var inTeaching = Validations.inTeaching(currentModule);
	    var isSubjectType = Validations.isSubjectType(this.data);
	    var isPositionByDelegationType = Validations.isPositionByDelegationType(this.data);
	    var isCommitteeParticipationType = Validations.isCommitteeParticipationType(this.data);
	    var isDoctoralEducationType = Validations.isDoctoralEducationType(this.data);
	    var isTeacherDevelopmentType = Validations.isTeacherDevelopmentType(this.data);
	    var isCommunityType = Validations.isCommunityType(this.data);
	    var isColaborationSpaceType = Validations.isColaborationSpaceType(this.data);
	    var isInvestigationType = Validations.isInvestigationType(this.data);
	    var isProjectDesignType = Validations.isProjectDesignType(this.data);
	    var isProductsType = Validations.isProductsType(this.data);
	    var isProjectsType = Validations.isProjectsType(this.data);
	    var isResultsTransferType = Validations.isResultsTransferType(this.data);
	    var isOtherActivitiesType = Validations.isOtherActivitiesType(this.data);
	    var isRolesType = Validations.isRolesType(this.data);
	    var isInternalProjectsFormulationType = Validations.isInternalProjectsFormulationType(this.data);
	    var isExtensionProjectsType = Validations.isExtensionProjectsType(this.data);
	
	    var isVisibilityType = Validations.isVisibilityType(this.data);
	
	    var isConsultancyType = Validations.isConsultancyType(this.data);
	    var isShortCoursesType = Validations.isShortCoursesType(this.data);
	    var isCrossProjectFormulationType = Validations.isCrossProjectFormulationType(this.data);
	    var isCrossExtensionProjectsType = Validations.isCrossExtensionProjectsType(this.data);
	
	    angular.extend(this, {
	      // variables
	      get details() {
	        return _details;
	      },
	      set details(value) {
	        _details = value;
	        return value;
	      },
	      get format() {
	        return _format;
	      },
	      set format(value) {
	        _format.push(value);
	        return value;
	      },
	
	      // methods
	      watchEntries: watchEntries()
	    });
	
	    function watchEntries() {
	      return inExecution || inReviewExecution || inEvaluation;
	    }
	
	    function setDetails(fields) {
	      switch (true) {
	        case isSubjectType:
	          return fields.subject;
	        case isPositionByDelegationType:
	          return fields.positionByDelegation;
	        case isCommitteeParticipationType:
	          return fields.committee;
	        case isOtherActivitiesType:
	          return fields.otherActivities;
	        case isRolesType:
	          return fields.roles;
	        case isDoctoralEducationType:
	          return fields.doctoralEducation;
	        case isTeacherDevelopmentType:
	          return fields.teacherDevelopment;
	        case isCommunityType:
	          return fields.community;
	        case inTeaching:
	          return fields.teaching;
	        case isColaborationSpaceType:
	          return fields.colaborationSpace;
	        case isInvestigationType:
	          return fields.investigation;
	        case isProjectDesignType:
	          return fields.projectDesign;
	        case isProductsType:
	          return fields.product;
	        case isProjectsType:
	          return fields.project;
	        case isResultsTransferType:
	          return fields.resultsTransfer;
	        case isInternalProjectsFormulationType:
	          return fields.formulateProject;
	        case isExtensionProjectsType:
	          return fields.extensionProject;
	        case isVisibilityType:
	          fields.visibility = emptyFields(fields.visibility);
	          return fields.visibility;
	        case isConsultancyType:
	          return fields.consultancy;
	        case isShortCoursesType:
	          return fields.shortCourses;
	        case isCrossProjectFormulationType:
	          return fields.formulateCrossProject;
	        case isCrossExtensionProjectsType:
	          return fields.extensionCrossProject;
	        default:
	          return [['Problemas en el servicio', '404']];
	      }
	    }
	
	    function setStudents(data) {
	      if (objHas(data, 'studentNum') && objHas(data, 'studentTypeName')) {
	        if (data.studentNum && data.studentTypeName) {
	          var num = data.studentNum.split(',');
	          var type = data.studentTypeName.split(',');
	          return num.map(function (amount, index) {
	            return type[index] + ' - ' + amount;
	          }).join(', ');
	        }
	      }
	    }
	
	    function emptyFields(data) {
	      return data.filter(function (fields) {
	        if (fields[1] !== 'NA') return fields;
	      });
	    }
	
	    function checkState(start, end, now) {
	      if (start < now && now < end) {
	        return 'En curso';
	      } else if (start > now) {
	        return 'No iniciado';
	      } else if (now > end) {
	        return 'Finalizado';
	      } else {
	        return 'Desconocido';
	      }
	    }
	
	    function calcState(data) {
	      if (data.startDate) {
	        return checkState(setDate(data.startDate), setDate(data.endDate), setDate(new Date()));
	      } else {
	        return checkState(setDate(data.startPeriod), setDate(data.endPeriod), setDate(new Date()));
	      }
	    }
	
	    var setRangeData = R.curry(function (objHas, setDate, unique, data) {
	      if (objHas(data, 'timeRangeTypeId')) {
	        if (data.timeRangeTypeId != null) {
	          var validator = objHas(data, 'timeRangeTypeId') ? data.timeRangeTypeId : data.periodicityName ? 1 : 2;
	          switch (validator) {
	            case 1:
	              return [['Periocidad', unique(data.periodicityName).join(', ') || unique(data.periodName).join(', ')]];
	            case 2:
	              return [['Fecha de Inicio', setDate(data.startDate)], ['Fecha de Finalización', setDate(data.endDate)]];
	          }
	        }
	      }
	      return [];
	    })(objHas, setDate, unique);
	
	    var setStartDate = R.curry(function (objHas, setDate, unique, data) {
	      if (objHas(data, 'timeRangeTypeId')) {
	        if (data.timeRangeTypeId != null) {
	          var validator = objHas(data, 'timeRangeTypeId') ? data.timeRangeTypeId : data.periodicityName ? 1 : 2;
	          switch (validator) {
	            case 1:
	              return [['Periocidad', unique(data.periodicityName).join(', ') || unique(data.periodName).join(', ')]];
	            case 2:
	              return [['Fecha de Inicio', setDate(data.startDate)]];
	          }
	        }
	      }
	      return [];
	    })(objHas, setDate, unique);
	
	    var setEndDate = R.curry(function (objHas, setDate, unique, data) {
	      if (objHas(data, 'timeRangeTypeId')) {
	        if (data.timeRangeTypeId != null) {
	          var validator = objHas(data, 'timeRangeTypeId') ? data.timeRangeTypeId : data.periodicityName ? 1 : 2;
	          switch (validator) {
	            case 1:
	              return [];
	            case 2:
	              return [['Fecha de Finalización', setDate(data.endDate)]];
	          }
	        }
	      }
	      return [];
	    })(objHas, setDate, unique);
	
	    var showExecutionHours = function showExecutionHours(inHistory, hours, totalHours) {
	      return [inHistory && !inExecution ? [] : ['Horas ejecutadas', hours || totalHours || 0]];
	    };
	
	    var setFields = R.curry(function (showExecutionHours, setDate, setStudents, setRangeData, data) {
	
	      var res = {
	        subject: [['Carga Horaria', data.loadTime || 0], ['Número de grupos', data.groupsTempName || 'No hay grupos asignados'], ['Idioma', data.language || 'Español'], ['N° de estudiantes', data.numberStudents || 0], ['Total de horas planeadas de docencia directa', data.hoursPlanned || 0], ['Horas Planeadas SIAR', data.hoursExecutedSiar || 0], ['Horas planeadas de docencia directa por grupo', data.hoursPlanned / data.groupsTempNum || 0], ['Horas Ejecutadas SIAR', data.hoursPlannedSiar || 0], ['Horas Ejecutadas', data.hoursExecuted || 0], ['Observaciones', data.description || 'Sin observaciones'], ['Relación entre horas docencia directa y horas preparación de clase', data.relationship || 0]],
	        positionByDelegation: [['Unidad', data.academicUnitName || 'Sin unidad académica asignada']].concat(_toConsumableArray(setStartDate(data)), [['Horas Planeadas', data.hoursPlanned || data.activityHoursPlaned || 0]], _toConsumableArray(setEndDate(data)), [['Porcentaje Planeado', data.percentagePanning + '%' || 'Sin porcentaje planeado']], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0)), [['Observaciones', data.description || 'Sin observaciones']]),
	        otherActivities: [['Horas Planeadas', data.hoursPlanned || data.activityHoursPlaned || 0]].concat(_toConsumableArray(setStartDate(data)), [['Horas Ejecutadas', data.totalHoursExecuted || 0]], _toConsumableArray(setEndDate(data)), [['Observaciones', data.description || 'Sin observaciones']]),
	        roles: [['Horas Planeadas', data.hoursPlanned || data.activityHoursPlaned || 0]].concat(_toConsumableArray(setStartDate(data)), [['Horas Ejecutadas', data.totalHoursExecuted || 0]], _toConsumableArray(setEndDate(data)), [['Observaciones', data.description || 'Sin observaciones']]),
	        committee: [].concat(_toConsumableArray(setStartDate(data)), [['Horas Planeadas', data.hoursPlanned || 0]], _toConsumableArray(setEndDate(data)), _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0)), [['Observaciones', data.description || 'Sin observaciones']]),
	        doctoralEducation: [['Institución', data.nameInstitute || 'Sin institución asignada'], ['Tipo de institución', data.typeInstitute || 'Sin tipo de institución asignado'], ['País', data.country || 'Sin país asignado'], ['Ciudad', data.cityName || 'Desconocido'], ['Departamento', data.stateName || 'Desconocido'], ['Nucleo', data.knowledgeCoreName || 'Sin nucleo asignado']].concat(_toConsumableArray(setRangeData(data)), [['Horas Planeadas', data.hoursPlanning || 0], ['Horas Ejecutadas', data.totalHoursExecuted || 0], ['Financiamiento', data.financingName || 'Sin financiamiento'], ['Beca', data.scholarshipName || 'No posee beca']]),
	        teacherDevelopment: [['Modalidad', data.modalityName], ['Profesor', data.teacherCourse ? data.teacherCourse : 'No aplica'], ['Idioma', data.languajeCourse ? data.languajeCourse : 'No aplica'], ['Horario', data.scheduleCourse ? data.scheduleCourse : 'No aplica'], ['Tipo de entidad', data.entityName || 'Sin tipo asignado'], ['Horas Planeadas', data.totalHoursPlanned ? data.totalHoursPlanned : 0], ['Horas Ejecutadas', data.totalHoursExecuted || 0]].concat(_toConsumableArray(setRangeData(data)), [['Institución', data.nameInstitute ? data.nameInstitute : 'No aplica'], ['Tipo de Institución', data.instituteTypeName ? data.instituteTypeName : 'No aplica'], ['Programa', data.nameStudy ? data.nameStudy : 'Sin programa']]),
	        community: [['Ámbito/Escenario', data.listItemNameAmbit || 'Sin ámbito asignado']].concat(_toConsumableArray(setRangeData(data)), [['Horas Planeadas', data.totalHoursPlanned ? data.totalHoursPlanned + ' hrs.' : '0 hrs.']]),
	        colaborationSpace: [['Ámbito/Escenario local', data.ambitColaborationName || '-'], ['Tipo', data.typeSpaceName], ['Tipo de participación', data.typeParticipationName], ['Descripción y justificación', data.description], ['Resultados', data.results], ['Entidad/Organizador', data.entityName || '-'], ['Enlace', data.link || '-'], ['Ciudad', data.cityName || 'Sin ciudad asignada'], ['Pais', data.countryName || 'Sin país asignado']].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanning || '0']], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0))),
	        investigation: [['Tipo de actividad formativa', data.itemTypeSpaceName], ['Descripción', data.description || '-'], ['Resultados', data.resultsExpected], ['Enlace', data.link || '-'], ['Cantidad de estudiantes', setStudents(data)]].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanning || '0']], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0))),
	        projectDesign: [['Rol', data.roleName], ['Tipos de financiador(es)', objHas(data, 'financialName') ? unique(data.financialName).join(', ') : 'NA'], ['Resumen', data.summary]].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanning]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0))),
	        product: [['Área básica de conocimiento', data.itemKnowledgeName], ['Tipo de producto', data.itemProductName], ['Subtipo', data.subItemProductName], ['Proyecto asociado', data.projectName], ['Descripción', data.description]].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned || data.totalPlannedHours || 0]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, data.totalExecutedHours))),
	        project: [['Tipo de proyecto', data.listItemProjectTypeName], ['Estado', data.estatus], ['Descripción', data.description], ['Unidad Académica', data.academicUnitName], ['Rol en el proyecto', data.listItemProjectRoleName], ['Financiadores', objHas(data, 'financialSourceName') ? unique(data.financialSourceName).join(', ') : 'No posee financiadores']].concat(_toConsumableArray(setRangeData(data)), _toConsumableArray(showExecutionHours(inHistory, data.totalExecutedHours, 0))),
	        resultsTransfer: [['Tipo de resultado', data.itemResultsName], ['Descripción', data.description]].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0))),
	        formulateProject: [['Aliados potenciales', data.potencialAllies], ['Tipo de proyecto', data.typeProject], ['Financiadores', objHas(data, 'typeFinanciers') ? unique(data.typeFinanciers).join(', ') : 'No posee financiadores']].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0)), [['Resumen', data.summary]]), // Proyectos Internos
	        extensionProject: [['Rol en el proyecto', data.listItemProjectRoleName], ['Tipo de proyecto', data.listItemProjectTypeName], ['Propuesta asociada', data.projectFormulatedName], ['Unidad académica', data.academicUnitName || 'Sin unidad académica asignada'], ['Financiadores', objHas(data, 'financialSourceName') ? unique(data.financialSourceName).join(', ') : 'No posee financiadores'], ['Estado', data.estatus], ['Descripción', data.description]].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned || data.totalPlannedHours || 0]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, data.totalExecutedHours))),
	        visibility: [['URL', data.link || 'NA'], ['Rol', data.nameRol || 'NA'], ['Ámbito', data.nameAmbit || 'NA'], ['Unidad', data.unitName || 'NA'], ['Contacto', data.contact || 'NA'], ['Sector', data.nameSector || 'NA'], ['Correo Electrónico', data.email || 'NA'], ['Registro de comunicación', data.nameCommunicationRegister], ['Tipo de comunicación', data.nameCommunicationType || 'NA'], ['Frecuencia de emisión', data.nameFrequencyEmission || 'NA'], ['Audiencia', data.nameAudience || 'NA']].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0)), [['Resumen', data.summary]]),
	        consultancy: [['Área básica del conocimiento', data.itemKnowledgeName], ['Descripción', data.description], ['Empresa/Entidad/Organización', data.entity], ['Fuente', objHas(data, 'source') ? unique(data.source).join(', ') : 'No posee financiadores'], ['Ámbito/Escenario', data.itemAmbitName], ['Sector', data.itemSectorName], ['Rol', data.itemRoleName], ['Productos/Entregables', data.deliverables]].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0))),
	        shortCourses: [['Modalidad', data.itemModalityName], ['Descripción', data.description], ['Rol', data.itemRoleName], ['Tipo de curso', data.itemTypeCourseName]].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0))),
	        formulateCrossProject: [['Tipo de proyecto', data.typeProject], ['Aliados potenciales', data.potencialAllies], ['Tipo de financiamiento', objHas(data, 'typeFinanciers') ? unique(data.typeFinanciers).join(', ') : 'No posee financiadores']].concat(_toConsumableArray(setRangeData(data)), [['Horas planeadas', data.hoursPlanned]], _toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, 0)), [['Resumen', data.summary]]),
	        extensionCrossProject: [
	        // ['Nombre del proyecto', data.projectName],
	        ['Objetivos del proyecto', data.objectives], ['Propósitos del proyecto', data.purposes], ['Metodología del proyecto', data.methodology], ['Comunidades implicadas', data.listItemProjectRoleName], ['Resultados/ Productos', data.results], ['Nombre de archivo PDF', data.file], ['Tipo de proyecto de extensión', data.itemProjectTypeName], ['Valor del proyecto', data.value]].concat(_toConsumableArray(showExecutionHours(inHistory, data.hoursExecuted, data.totalExecutedHours)))
	
	        // se agregan dos campos que se estaban mostrando cuando NO estaba en historial
	      };if (!inHistory) {
	        // Consolidacion CP -> Formación doctoral
	        res.doctoralEducation.push(['Estado', calcState(data)]);
	        res.doctoralEducation.push(['Observaciones', data.description || 'Sin observaciones']);
	        // Consolidacion CP -> Desarrollo profesoral
	        res.teacherDevelopment.unshift(['Categoría', data.categoryCourse ? data.categoryCourse : 'No aplica']);
	        res.teacherDevelopment.push(['Sede', data.cityName || 'Sin sede asignada']);
	        res.teacherDevelopment.push(['Estado', calcState(data)]);
	        // Consolidacion CP -> Comunidades
	        if (!inApproval && !inReview) {
	          res.community.push(['Horas Ejecutadas', data.totalHoursExecuted ? data.totalHoursExecuted + ' hrs.' : '0 hrs.']);
	        }
	        res.community.push(['Estado', calcState(data)]);
	      }
	      res.community.push(['Descripción de su labor', data.description || 'Sin descripción']);
	      return res;
	    })(showExecutionHours, setDate, setStudents, setRangeData);
	
	    function cleanFields(details) {
	      details.forEach(function (field, index, arr) {
	        if (Array.isArray(field) && field[0] === '-') {
	          arr.splice(index, 1);
	        }
	      });
	    }
	
	    this.$onInit = function () {
	      _this.format = _this.stackItems ? ['col-md-12', 'col-md-7'] : ['col-md-6', 'col-md-12'];
	      _this.details = setDetails(setFields(_this.data));
	      cleanFields(_this.details);
	    };
	
	    GlobalSrv.subscribe($scope, $rootScope, 'hoursChanged', function (hours) {
	      _this.data.hoursExecuted = hours;
	      _this.data.totalHoursExecuted = hours;
	      _this.data.totalExecutedHours = hours;
	      _this.details = setDetails(setFields(_this.data));
	      cleanFields(_this.details);
	    });
	  }] };

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-12 m-v-sm\"> <div class={{vm.format[0]}} ng-repeat=\"data in vm.details\"> <div class=\"{{vm.format[1]}} no-padding word-wrap\"> <p class=\"text-sm exo no-margin p-r-md p-v-sm\"> {{ data[0] }}<span class=\"text-gris-dark proxima right w-h-100\">{{ data[1] }}<span> </span></span></p> </div> <div class=\"col-md-6 no-padding\" ng-if=vm.stackItems></div> </div> </div> ";

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.childrenActivities = undefined;
	
	var _childrenActivities = __webpack_require__(476);
	
	var _childrenActivities2 = _interopRequireDefault(_childrenActivities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var childrenActivities = exports.childrenActivities = {
		bindings: {
			parent: '<',
			children: '<',
			activity: '=',
			planning: '<'
		},
		template: _childrenActivities2.default,
		controllerAs: 'vm',
		controller: ['$cookies', '$stateParams', 'GlobalConfig', 'WorkPlanModalSrv', 'CssClasses', 'Validations', 'Setters', 'Ramda', 'GlobalSrv', '$scope', '$rootScope', function childrenActivitiesCtrl($cookies, $stateParams, GlobalConfig, WorkPlanModalSrv, CssClasses, Validations, Setters, Ramda, GlobalSrv, $scope, $rootScope) {
			var _this = this;
	
			var R = Ramda;
			var minorActivityId = GlobalConfig.minorActivityId;
			var textColor = CssClasses.textColor;
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var teacherId = Setters.importGlobal($stateParams, 'teacherId', $cookies);
			var workplanId = Setters.importGlobal($stateParams, 'workplanId', $cookies);
			var columns = Validations.isActivitiesType(this.parent) ? 'col-md-3' : 'col-md-2';
			var colExecution = Validations.inExecution(currentStage) ? 'col-md-4' : 'col-md-6';
			var colActions = Validations.inExecution(currentStage) ? 'col-md-4' : 'col-md-2';
			var text = Validations.inExecution(currentStage) ? 'text-center' : 'text-center';
	
			angular.extend(this, {
				// variables
				inExecution: Validations.inExecution(currentStage),
				inEvaluation: Validations.inEvaluation(currentStage),
				inReviewExecution: Validations.inReviewExecution(currentStage),
				isActivitiesType: Validations.isActivitiesType(this.parent),
				isSubjectType: Validations.isSubjectType(this.parent),
				contentHeaderCSS: [colExecution, 'no-padding', 'text-center', 'font-normal', 'text-sm'],
				headingCSS: [columns, 'no-padding', 'text-center', 'text-sm', 'font-normal'],
				contentCSS: [columns, 'no-padding', 'text-center', 'text-sm', textColor.blue],
				acctionCCS: ['col-md-2', 'no-padding', text, 'text-gris-dark', 'text-sm'],
				actionHeaderCSS: [colActions, 'no-padding', 'text-center', 'text-sm'],
				contentNameCSS: [colExecution, 'no-padding'],
				executionFinish: 1,
				disableEdit: 'disabled',
				isBlocked: 1,
				// methods
				addActivity: addActivity,
				executionEntries: executionEntries,
				registerExecution: registerExecution,
				editChildrenExecution: editChildrenExecution,
				isDisabled: isDisabled,
				inHistory: $stateParams.inHistory
			});
	
			var setActivityId = R.curry(function (children) {
				switch (children.type) {
	
					case 'planning':
						return minorActivityId.planning;
					case 'teaching':
						return minorActivityId.teaching;
	
				}
			})(this.children);
	
			var setActivityHeader = R.curry(function (children, parent, id) {
				return {
					idActivityParent: parent.workplanTeacherActivityId,
					idTeacher: teacherId,
					idWorkPlan: workplanId,
					activityId: id,
					asignatureId: parent.asignatureId,
					listType: children.type,
					children: children
				};
			})(this.children, this.parent);
	
			this.$onInit = function () {
				_this.executionFinish = _this.parent.executionFinish;
	
				if (_this.parent.origin == 3) {
					_this.isBlocked = _this.parent.checkStatus == 0 && _this.parent.origin == 3;
				} else {
					_this.isBlocked = _this.parent.isBlocked;
				}
	
				if (_this.executionFinish || _this.isBlocked) {
					_this.disableEdit = 'disabled';
				} else {
					_this.disableEdit = '';
				}
			};
	
			function addActivity(children, parent) {
				WorkPlanModalSrv.setVariable(setActivityHeader(setActivityId));
				WorkPlanModalSrv.addActivity().then(function (promise) {
					var add = WorkPlanModalSrv.getVariable();
	
					add ? children.push(add) : console.log('no activity was added');
					children.totalExecutedHours += add.hoursExecuted;
					$rootScope.$emit('rootScope:execHours', 'execHours!');
				});
			}
	
			function registerExecution(children, action) {
				var _this2 = this;
	
				WorkPlanModalSrv.setVariable({ children: children, action: action });
				WorkPlanModalSrv.registerExecution().then(function (promise) {
					var data = WorkPlanModalSrv.getVariable();
	
					if (data != null) {
						children.hoursExecuted += data.hoursExecuted;
						_this2.children.totalExecutedHours += data.hoursExecuted;
						_this2.activity.totalHoursExecuted += data.hoursExecuted;
						$rootScope.$emit('rootScope:execHours', 'execHours!');
					}
				});
			}
	
			function executionEntries(parent, children) {
				var parentActivity = children;
	
				parentActivity.selectedActivityId = children.workplanTeacherActivityId;
				parentActivity.asignatureName = children.name;
				WorkPlanModalSrv.setVariable(parentActivity);
				WorkPlanModalSrv.executionEntries();
			}
	
			function editChildrenExecution(parent, children) {
				var _this3 = this;
	
				WorkPlanModalSrv.setVariable(children.hoursExecuted);
				WorkPlanModalSrv.editChildrenExecution({ children: children }).then(function (promise) {
					var data = WorkPlanModalSrv.getVariable();
	
					if (data != null) {
						_this3.children.totalExecutedHours += children.hoursExecuted - data;
						_this3.activity.totalHoursExecuted += children.hoursExecuted - data;
						$rootScope.$emit('rootScope:execHours', 'execHours!');
					}
				});
			}
	
			function isDisabled(activity) {
				if (activity.origin == 3 && this.isBlocked) {
					return 'disabled';
				} else if (this.executionFinish || this.isBlocked) {
					return 'disabled';
				} else if (activity.hoursExecuted === 0) {
					return ''; //vignesh change
				}
			}
	
			GlobalSrv.subscribe($scope, $rootScope, 'isBlocked', function (data) {
				_this.isBlocked = data;
			});
	
			GlobalSrv.subscribe($scope, $rootScope, 'hoursChanged', function (hours) {
				if (_this.isActivitiesType) {
					_this.children[0].hoursExecuted = hours;
				}
			});
		}] };

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	module.exports = "<button class=\"btn btn-info btn-sm right m-b\" ng-show=\"vm.isSubjectType && vm.inExecution && !vm.inHistory\" ng-click=\"vm.addActivity(vm.children, vm.parent)\" ng-disabled=\"vm.executionFinish || vm.isBlocked\"> Agregar Actividad </button> <div class=\"col-md-12 proxima m-b\"> <div class=row> <div class=\"col-md-12 text-azul no-padding\"> <div ng-class=::vm.contentHeaderCSS></div> <div ng-class=::vm.headingCSS>Planeadas</div> <div ng-class=::vm.headingCSS>Ejecutadas</div> <div ng-class=vm.actionHeaderCSS ng-if=!vm.isActivitiesType>Acciones</div> </div> </div> <div class=\"row b-b m-t-sm\" ng-repeat=\"activity in vm.children track by $index\"> <div ng-class=vm.contentNameCSS> <p class=\"no-margin text-sm word-wrap\"> {{ activity.name || 'Esta actividad no posee nombre'}} <span ng-if=\"vm.children !== vm.planning\" class=text-gris-dark> - <span ng-if=activity.itemActivityValue>Número de estudiantes: </span>{{ (activity.itemActivityValue || activity.description) || 'Sin descripción' }}</span> </p><p> </p></div> <div ng-class=::vm.contentCSS>{{ ::activity.hoursPlanned }} hrs</div> <div ng-class=::vm.contentCSS>{{ activity.hoursExecuted }} hrs</div> <div ng-class=::vm.acctionCCS> <span ng-show=\"vm.inExecution && !vm.isActivitiesType && !vm.inHistory\" ng-click=\"vm.registerExecution(activity, 'ADD')\" class=\"icon i-24 mdi-content-add pointer\" ng-class=vm.isDisabled(activity)> </span> <span ng-show=\"vm.inExecution && !vm.isActivitiesType && !vm.inHistory\" ng-click=\"vm.editChildrenExecution(vm.children, activity)\" class=\"icon i-24 mdi-content-create pointer\" ng-class=vm.isDisabled(activity)> </span> <p ng-show=\"(vm.inEvaluation || vm.inReviewExecution) && !vm.isActivitiesType\" class=\"no-margin pointer text-center text-azul text-sm close-text\" ng-click=\"vm.executionEntries(vm.children, activity)\"> Ver Registro <br>de Ejecución </p> </div> <div ng-class=vm.acctionCCS ng-show=\"vm.inExecution && !vm.isActivitiesType\"> <p class=\"no-margin pointer text-center text-azul text-sm close-text\" ng-click=\"vm.executionEntries(vm.children, activity)\"> Ver Registro </p> </div> </div> </div> <div class=\"col-md-12 no-padding\" ng-show=vm.isSubjectType> <label class=\"text-azul exo text-sm m-r\"> Total horas planeadas <span class=\"m-h text-negro-darker\">{{vm.children.totalPlannedHours || 0}}</span> </label> <label class=\"text-azul exo text-sm\"> Total horas ejecutadas <span class=\"m-h text-negro-darker\">{{vm.children.totalExecutedHours || 0}}</span> </label> </div> ";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.entriesList = undefined;
	
	var _entriesList = __webpack_require__(478);
	
	var _entriesList2 = _interopRequireDefault(_entriesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entriesList = exports.entriesList = {
		bindings: {
			details: '<',
			activity: '=',
			type: '<'
		},
		template: _entriesList2.default,
		controllerAs: 'vm',
		controller: ['$stateParams', 'ReviewSrv', 'WorkPlanModalSrv', 'CssClasses', 'Validations', '$rootScope', 'GlobalSrv', '$state', 'Util', function entriesListCtrl($stateParams, ReviewSrv, WorkPlanModalSrv, CssClasses, Validations, $rootScope, GlobalSrv, $state, Util) {
			var _this = this;
	
			var setDate = Util.setDate;
			var textColor = CssClasses.textColor;
			var icons = CssClasses.icons;
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var currentModule = $state.current.module;
			var _entries = [];
			var inExecution = Validations.inExecution(currentStage);
			var isPositionByDelegationType = Validations.isPositionByDelegationType(this.activity);
			var isColaborationSpaceType = Validations.isColaborationSpaceType(this.activity);
			var isProjectDesignType = Validations.isProjectDesignType(this.activity);
			var isSubjectType = Validations.isSubjectType(this.activity);
	
			angular.extend(this, {
				// variables
				get entries() {
					return _entries;
				},
				set entries(value) {
					_entries = value;
	
					return value;
				},
				title: 'Ejecución ',
				contentHeaderCSS: ['col-md-6', 'no-padding', 'font-normal', 'text-xs'],
				headingCSS: [isSubjectType ? 'col-md-3' : 'col-md-2', 'no-padding', 'text-center', 'font-normal', 'text-xs'],
				contentCSS: [isSubjectType ? 'col-md-3' : 'col-md-2', 'no-padding', 'text-center', textColor.blue, 'text-xs'],
				contentHeaderCSS2: ['col-md-3', 'no-padding', 'font-normal', 'text-xs'],
				edit: icons.edit,
				executionFinish: this.details.executionFinish,
				itemRequired: 0,
				isBlocked: 1,
				disableEdit: 'disabled',
				evidence: '',
				evidenceName: '',
	
				// methods
				registerExecution: registerExecution,
				allowRegistry: allowRegistry(),
				inExecution: Validations.inExecution(currentStage),
				inEvaluation: Validations.inEvaluation(currentStage),
				inReviewExecution: Validations.inReviewExecution(currentStage),
				inConsolidation: Validations.inConsolidation(currentModule),
				inExtension: Validations.inExtension(currentModule),
				inInvestigation: Validations.inInvestigation(currentModule),
				isSubjectType: isSubjectType,
				inHistory: $stateParams.inHistory,
				viewFile: viewFile
			});
	
			this.$onInit = function () {
				getExecutionEntries(_this.activity).then(function (data) {
					_this.entries = data;
					_this.isBlocked2 = false || _this.inHistory;
					_this.entries.forEach(function (child) {
						child.status = child.status || checkState(child.startDate, child.endDate, setDate(new Date()));
					});
					_this.executionFinish = _this.details.executionFinish;
	
					//this.details.isBlocked ||
					if (_this.activity.origin == 3) {
						_this.isBlocked = _this.activity.origin == 3 && _this.activity.checkStatus == 0 || _this.inHistory;
						_this.isBlocked2 = _this.activity.origin == 3 && _this.activity.checkStatus == 0 || _this.inHistory;
					} else {
						_this.isBlocked = _this.details.isBlocked;
					}
	
					_this.itemRequired = _this.details.isItemRequired;
	
					_this.disableEdit = _this.executionFinish || _this.isBlocked ? 'disabled' : '';
				});
	
				_this.title = _this.type ? 'Registro de ejecución de Docencia Directa' : _this.title;
			};
	
			function allowRegistry() {
				return inExecution && !isPositionByDelegationType;
			}
	
			function getTotalHours(entries) {
				return entries.reduce(function (acc, entry) {
					return acc += entry.hoursExecuted;
				}, 0);
			}
	
			function checkState(start, end, now) {
				if (start < now && now < end) {
					return 'En curso';
				} else if (start > now) {
					return 'No iniciado';
				} else if (now > end) {
					return 'Finalizado';
				} else {
					return 'Desconocido';
				}
			}
	
			function registerExecution(children, action) {
				var _this2 = this;
	
				var header = {
					children: children,
					action: action,
					itemRequired: this.itemRequired,
					isShowState: this.inInvestigation && isColaborationSpaceType || this.inInvestigation && isProjectDesignType
				};
				var diffHours = getTotalHours(this.entries);
				var totalHours = 0;
	
				WorkPlanModalSrv.setVariable(header);
				WorkPlanModalSrv.registerExecution().then(function (promise) {
					var header = WorkPlanModalSrv.getVariable();
	
					if (header) {
						header.startDate = header.startDate === 'Invalid date' ? null : header.startDate;
						header.endDate = header.endDate === 'Invalid date' ? null : header.endDate;
	
						if (header.action === 'ADD') {
							header.evidence = header.fileUrl;
							_this2.entries.push(header);
						} else {
							children.hoursExecuted = header.hoursExecuted;
							children.descriptionExecution = header.descriptionExecution;
							children.startDate = header.startDate;
							children.endDate = header.endDate;
							children.status = header.status;
							children.dateCreation = header.dateCreation;
							children.evidence = header.fileUrl;
							children.evidenceName = header.attachFile;
							children.fileName = header.attachFile;
						}
	
						totalHours = getTotalHours(_this2.entries);
						diffHours = totalHours - diffHours;
						_this2.activity.totalHoursExecuted += diffHours;
						$rootScope.$emit('rootScope:execHours', 'execHours!');
	
						if (totalHours === 0) {
							// this.disableEdit = 'disabled'
							_this2.disableEdit = '';
							_this2.isBlocked = 1;
							// GlobalSrv.notify($rootScope, 'isBlocked', this.isBlocked)
						}
	
						GlobalSrv.notify($rootScope, 'hoursChanged', totalHours);
					}
				});
			}
	
			function getExecutionEntries(activity) {
				var header = {
					workplanTeacherActivityId: activity.workplanTeacherActivityId
				};
	
				return ReviewSrv.getExecutionEntries.post(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						return dataReturn.data;
					}
				});
			}
	
			function viewFile(url) {
				WorkPlanModalSrv.setVariable(url);
				WorkPlanModalSrv.viewFile().then(function (promise) {});
			}
		}] };

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-12 m-v-sm\"> <h4 class=\"text-azul text-base font-bold text-block\">{{vm.title}}</h4> <button class=\"btn btn-info btn-sm right m-b\" ng-click=\"vm.registerExecution(vm.activity, 'ADD')\" ng-show=\"vm.inExecution && !vm.inHistory\" ng-disabled=\"vm.executionFinish || vm.isBlocked2  \"> Registrar Ejecución </button> <div class=\"col-md-12 proxima m-b\"> <div class=row> <div class=\"col-md-12 text-azul no-padding\"> <div ng-class=vm.headingCSS>Observación</div> <div class=\"col-md-1 no-padding text-center font-normal text-xs\">Horas ejecutadas</div> <div ng-class=vm.headingCSS>Fecha Inicio</div> <div ng-class=vm.headingCSS ng-if=!vm.isSubjectType>Fecha Fin</div> <div ng-class=vm.headingCSS ng-if=!vm.isSubjectType>Estado</div> <div class=\"col-md-1 no-padding text-center font-normal text-xs\">Archivo</div> <div ng-class=vm.headingCSS ng-show=\"vm.inExecution ||  !vm.isBlocked2\">Acciones</div> </div> </div> <div class=\"row b-b m-t-sm\" style=line-height:20px ng-repeat=\"children in vm.entries\"> <div ng-class=\"vm.isSubjectType ? 'col-md-3' : 'col-md-2'\" class=no-padding> <p class=\"no-margin text-sm word-wrap text-gris-dark\"> {{ children.descriptionExecution }} </p><p> </p></div> <div class=\"col-md-1 no-padding text-center text-azul text-xs\">{{ children.hoursExecuted }} hrs</div> <div ng-class=vm.contentCSS>{{ children.startDate }}</div> <div ng-class=vm.contentCSS ng-if=!vm.isSubjectType>{{ children.endDate }}</div> <div ng-class=vm.contentCSS ng-if=!vm.isSubjectType>{{ children.status }}</div> <div class=\"col-md-1 no-padding text-center text-gris-dark text-xs\" ng-show=children.evidence> <a class=underscore ng-href={{children.evidence}} target=blank download={{children.evidence}}>Ver</a> </div> <div class=\"col-md-1 no-padding\" ng-show=!children.evidence> </div> <div class=\"col-md-2 no-padding text-center text-gris-dark text-sm\" ng-show=vm.inExecution> <span ng-click=\"vm.registerExecution(children, 'EDIT')\" ng-class=vm.disableEdit ng-if=\" !vm.isBlocked2\" class=\"icon i-24 {{ vm.edit }} pointer\"> </span> </div> </div> <p class=\"text-sm text-gris-dark\" ng-if=\"vm.entries.length < 1\">No se registran horas de ejecución aún</p> </div> </div> ";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.plannedActivities = undefined;
	
	var _plannedActivities = __webpack_require__(480);
	
	var _plannedActivities2 = _interopRequireDefault(_plannedActivities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plannedActivities = exports.plannedActivities = {
		bindings: {
			parent: '<',
			children: '<',
			activity: '='
		},
		template: _plannedActivities2.default,
		controllerAs: 'vm',
		controller: ['$stateParams', 'GlobalConfig', 'WorkPlanModalSrv', 'CssClasses', 'Validations', 'Setters', '$cookies', 'Ramda', 'Util', 'GlobalSrv', '$rootScope', function plannedActivitiesCtrl($stateParams, GlobalConfig, WorkPlanModalSrv, CssClasses, Validations, Setters, $cookies, Ramda, Util, GlobalSrv, $rootScope) {
			var _this = this;
	
			var textColor = CssClasses.textColor;
			var icons = CssClasses.icons;
			var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
			var _entries = [];
	
			//const calcHours = (arr, param) => arr.reduce((accumulator, current) => (accumulator + current[param]), 0)
			this.$onInit = function () {
				_this.children.totalExecutedHours = calcHours(_this.children, 'hoursExecuted');
				_this.children.totalPlannedHours = calcHours(_this.children, 'hoursPlanned');
			};
	
			angular.extend(this, {
				// variables
				get entries() {
					return _entries;
				},
				set entries(value) {
					_entries = value;
	
					return value;
				},
				title: 'Actividades Planeadas ',
				contentHeaderCSS: ['col-md-2', 'no-padding', 'font-normal', 'text-xs'],
				headingCSS: ['col-md-2', 'no-padding', 'text-center', 'font-normal', 'text-xs'],
				timeCSS: ['col-md-4', 'no-padding', 'text-center', textColor.blue, 'text-xs'],
				contentCSS: ['col-md-2', 'no-padding', 'text-center', textColor.blue, 'text-xs'],
				acctionCCS: ['col-md-2', 'no-padding', 'text-center', 'text-gris-dark', 'text-sm'],
				showTime: function showTime(activity) {
					return activity.timeRangeTypeId === 1 ? activity.periodName || activity.periodicityName : activityDates(activity);
				},
				edit: icons.edit,
				add: icons.add,
				isProjectsType: Validations.isProjectsType(this.parent),
				isActivitiesType: Validations.isActivitiesType(this.parent),
				inExecution: Validations.inExecution(currentStage),
				inEvaluation: Validations.inEvaluation(currentStage),
				inReviewExecution: Validations.inReviewExecution(currentStage),
				isProductsType: Validations.isProductsType(this.parent),
				isExtensionProjectsType: Validations.isExtensionProjectsType(this.parent),
				isCrossExtensionProjectsType: Validations.isCrossExtensionProjectsType(this.parent),
				// methods
				setActivity: setActivity,
				addActivity: addActivity,
				executionEntries: executionEntries,
				isDisabled: isDisabled,
				inHistory: $stateParams.inHistory,
				isShowAction: isShowAction
			});
	
			function calcHours(arr, param) {
				return arr.reduce(function (accumulator, current) {
					return accumulator + current[param];
				}, 0);
			}
	
			function activityDates(activity) {
				return Util.setDate(activity.startDate) + ' - ' + Util.setDate(activity.endDate);
			}
	
			function executionEntries(parent, children) {
				var parentActivity = children;
	
				parentActivity.selectedActivityId = children.workplanTeacherActivityId;
				parentActivity.asignatureName = children.name;
				WorkPlanModalSrv.setVariable(parentActivity);
				WorkPlanModalSrv.executionEntries();
			}
	
			function setActivity(parent, order) {
				var _this2 = this;
	
				var child = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
				switch (order) {
	
					case 'ADD':
						WorkPlanModalSrv.setVariable({ children: child, action: 'ADD' });
						WorkPlanModalSrv.registerExecution().then(function (promise) {
							var data = WorkPlanModalSrv.getVariable();
	
							// console.log(data, promise)
							// if (data) this.children.totalExecutedHours = calcHours(this.children, 'hoursExecuted')
							if (data) {
								var index = _this2.children.findIndex(function (children) {
									return children.workplanTeacherActivityId == data.idActivity2;
								});
	
								if (!_this2.children[index].hoursExecuted) _this2.children[index].hoursExecuted = 0;
	
								{
									_this2.children[index].hoursExecuted += data.hoursExecuted;
									_this2.children.totalExecutedHours += data.hoursExecuted;
									GlobalSrv.notify($rootScope, 'hoursChanged', _this2.children.totalExecutedHours);
								}
								_this2.activity.totalHoursExecuted += data.hoursExecuted;
								$rootScope.$emit('rootScope:execHours', 'execHours!');
							}
						});
						break;
					case 'EDIT':
						var diffHours = this.children.totalExecutedHours;
	
						WorkPlanModalSrv.editChildrenExecution({ children: child }).then(function (promise) {
							_this2.children.totalExecutedHours = calcHours(_this2.children, 'hoursExecuted');
							GlobalSrv.notify($rootScope, 'hoursChanged', _this2.children.totalExecutedHours);
							diffHours = _this2.children.totalExecutedHours - diffHours;
							_this2.activity.totalHoursExecuted += diffHours;
							$rootScope.$emit('rootScope:execHours', 'execHours!');
						});
						break;
	
				}
			}
	
			function addActivity(parent) {
				var _this3 = this;
	
				WorkPlanModalSrv.setVariable([parent]);
				WorkPlanModalSrv.addActivity('custom').then(function (promise) {
					var data = WorkPlanModalSrv.getVariable();
	
					if (data) _this3.children.push(data);
				});
			}
	
			function isDisabled(activity) {
				if (this.parent.executionFinish || this.parent.isBlocked) {
					return 'disabled';
				} else if (activity.hoursExecuted < 0) {
					return 'disabled';
				}
			}
	
			function isShowAction() {
				if (this.isProductsType || this.isProjectsType || this.isExtensionProjectsType || this.isCrossExtensionProjectsType) {
					return this.parent.hoursChildren;
				}
			}
		}] };

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"m-t exo\"> <h4 class=\"text-azul text-base font-bold text-block\">{{::vm.title}}</h4> <button class=\"btn btn-info btn-sm right m-b\" ng-disabled=vm.parent.executionFinish ng-show=\"!vm.inHistory && vm.isProjectsType\" ng-click=vm.addActivity(vm.parent)> Agregar Actividad </button> <div class=\"col-md-12 proxima m-b\"> <div class=row> <div class=\"col-md-12 text-azul no-padding\"> <div ng-class=vm.contentHeaderCSS>Actividad</div> <div ng-class=vm.headingCSS>Horas planeadas</div> <div ng-class=vm.headingCSS>Horas ejecutadas</div> <div ng-class=vm.timeCSS>Tiempos planeados</div> <div ng-class=vm.headingCSS ng-show=\"vm.inReviewExecution || vm.inExecution || vm.inEvaluation\" ng-if=vm.isShowAction()>Acciones</div> </div> </div> <div class=\"row b-b m-t-sm\" style=line-height:20px ng-repeat=\"child in vm.children\"> <div class=\"col-md-2 no-padding\"> <p class=\"no-margin text-sm word-wrap text-gris-dark\"> {{ child.name || 'Esta actividad no posee nombre'}} </p><p> </p></div> <div ng-class=vm.contentCSS>{{ child.hoursPlanned || 0 }} hrs</div> <div ng-class=vm.contentCSS>{{ (child.hoursExecuted > 0 ? child.hoursExecuted : 0) || 0}} hrs</div> <div ng-class=vm.timeCSS>{{ vm.showTime(child) }}</div> <div ng-class=vm.acctionCCS ng-show=\"vm.inReviewExecution || vm.inExecution || vm.inEvaluation\"> <span ng-show=\"vm.inExecution && !vm.inHistory\" ng-click=\"vm.setActivity(vm.parent, 'ADD', child)\" class=\"icon i-24 {{ vm.add }} pointer\" ng-class=vm.isDisabled(child) ng-if=vm.isShowAction()> </span> <span ng-show=\"vm.inExecution && !vm.inHistory\" ng-click=\"vm.setActivity(vm.parent, 'EDIT', child)\" class=\"icon i-24 {{ vm.edit }} pointer\" ng-class=vm.isDisabled(child) ng-if=vm.isShowAction()> </span> <p ng-show=\"vm.inEvaluation && !vm.isActivitiesType\" class=\"no-margin pointer text-center text-azul text-sm close-text text-block\" ng-click=\"vm.executionEntries(vm.children, child)\" ng-if=vm.isShowAction()> Ver Registro <br>de Ejecución </p> <p ng-show=\"(vm.inReviewExecution || vm.inExecution) && !vm.isActivitiesType\" class=\"no-margin pointer text-azul text-sm close-text text-block\" ng-click=\"vm.executionEntries(vm.children, child)\" ng-if=vm.isShowAction()> Ver Registro </p> </div> </div> <p class=\"text-sm text-gris-dark\" ng-if=\"vm.children.length < 1 && vm.children.totalPlannedHours > 0 \">La actividad no posee actividades hijo</p> </div> </div> <div class=\"col-md-12 no-padding\"> <label class=\"text-azul exo text-sm m-r\"> Total horas planeadas <span class=\"m-h text-negro-darker\">{{vm.children.totalPlannedHours || 0}}</span> </label> <label class=\"text-azul exo text-sm\"> Total horas ejecutadas <span class=\"m-h text-negro-darker\">{{vm.children.totalExecutedHours || 0}}</span> </label> </div> ";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.studentAttention = undefined;
	
	var _studentAttention = __webpack_require__(482);
	
	var _studentAttention2 = _interopRequireDefault(_studentAttention);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var studentAttention = exports.studentAttention = {
	  bindings: {
	    details: '<'
	  },
	  template: _studentAttention2.default,
	  controllerAs: 'vm',
	  controller: ['Validations', '$stateParams', 'GlobalSrv', '$scope', '$rootScope', function studentAttentionCtrl(Validations, $stateParams, GlobalSrv, $scope, $rootScope) {
	    var _this = this;
	
	    var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
	
	    //let inReviewExecution = Validations.inReviewExecution(currentStage)
	    var inEvaluation = Validations.inEvaluation(currentStage);
	    var columns = inEvaluation ? 'col-md-2' : 'col-md-3';
	
	    angular.extend(this, {
	      activity: {},
	      watchEntries: inEvaluation,
	      headingCSS: [columns, 'no-padding', 'text-center', 'font-normal', 'text-sm'],
	      contentCSS: [columns, 'no-padding', 'text-center', 'font-normal', 'text-sm', 'text-azul'],
	      inPerson: function inPerson(activity) {
	        return activity.scheduleTypeId === 1;
	      }
	    });
	
	    GlobalSrv.subscribe($scope, $rootScope, 'hoursChanged', function (hours) {
	      _this.details.hoursExecuted = hours;
	    });
	  }] };

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-2></div> <div class=\"col-md-8 m-t-lg\" ng-if=vm.inPerson(vm.details)> <div class=\"card brd-xl\"> <div class=\"card-heading grad-2 p-v-lg text-center text-blanco\"> <h3>{{vm.details.scheduleTypeName}}</h3> </div> <div class=card-body> <p class=\"text-center exo\">{{vm.details.periodsNames}}</p> <p class=\"text-center exo\">{{vm.details.daysNames}}</p> <p class=\"text-gris-dark proxima text-center\">{{vm.details.startHour}} - {{vm.details.endHour}}</p> <p class=\"text-center text-xxs\">{{vm.details.description}}</p> </div> </div> </div> <div class=row style=\"padding:20px 0\"> <div class=\"col-md-12 text-azul\"> <div class=\"col-md-3 no-padding text-center font-normal text-sm\"></div> <div ng-class=vm.headingCSS>Planeadas</div> <div ng-class=vm.headingCSS>Ejecutadas</div> <div class=\"col-md-2 no-padding text-center font-normal text-sm\" ng-show=vm.watchEntries>Acciones </div> </div> <div class=row> <div class=\"col-md-3 no-padding\"></div> <div ng-class=vm.contentCSS>{{ vm.details.hoursPlanned || 0}} hrs</div> <div ng-class=vm.contentCSS>{{ vm.details.hoursExecuted || 0}} hrs</div> <div class=\"col-md-2 no-padding text-center\"> <p class=no-padding ng-show=vm.watchEntries> <execution-entries class=text-center activity=vm.details text=\"'Ver detalle de ejecución'\"></execution-entries> </p> </div> </div> </div> ";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subject = undefined;
	
	var _subject = __webpack_require__(484);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subject = exports.subject = {
	  bindings: {
	    details: '<',
	    activity: '<',
	    planning: '<',
	    teaching: '<',
	    label: '<'
	  },
	  template: _subject2.default,
	  controllerAs: 'vm',
	  controller: ['$stateParams', 'Validations', 'CssClasses', 'Ramda', '$state', function subjectCtrl($stateParams, Validations, CssClasses, Ramda, $state) {
	    var _this = this;
	
	    var currentStage = $stateParams.currentStage ? $stateParams.currentStage : $stateParams.stage;
	    var icons = CssClasses.icons;
	    var vm = this;
	    var inExecution = Validations.inExecution(currentStage);
	    var inReviewExecution = Validations.inReviewExecution(currentStage);
	    var inEvaluation = Validations.inEvaluation(currentStage);
	    var currentModule = $state.current.module;
	
	    angular.extend(this, {
	      advancedView: inExecution || inEvaluation || inReviewExecution,
	      standardView: !inExecution && !inEvaluation && !inReviewExecution,
	      children: [],
	      chevron: icons.arrowDown,
	      showData: false,
	      checkChildren: checkChildren,
	      toggleChevron: toggleChevron,
	      module: currentModule
	    });
	
	    this.$onInit = function () {
	      _this.planning.isPlanning = true;
	      _this.teaching.isPlanning = false;
	      _this.children = [_this.planning, _this.teaching];
	    };
	
	    function checkChildren(children) {
	      return children.filter(Boolean).length > 0;
	    }
	
	    function toggleChevron() {
	      if (vm.showData) {
	        vm.chevron = icons.arrowDown;
	        vm.showData = false;
	      } else {
	        vm.chevron = icons.arrowUp;
	        vm.showData = true;
	      }
	    }
	  }] };

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-12 p-b-md\"> <div class=\"col-md-12 no-padding m-b-sm\" ng-if=vm.standardView> <h4 class=\"text-azul text-xs font-bold no-margin text-block\"> {{ vm.label }} Directa </h4> <main-info data=vm.details module=vm.module> </main-info> </div> <a href=# ng-click=vm.toggleChevron() ng-if=vm.advancedView> <div class=\"col-md-12 no-padding b-b b-2x m-b-sm\"> <h4 class=\"text-azul text-xs font-bold no-margin text-block\"> {{ vm.label }} Directa </h4> <span ng-class=vm.chevron class=\"text-gris-dark icon i-28 right\"></span> </div> </a> <div ng-show=vm.showData> <main-info data=vm.details module=vm.module> </main-info></div> </div> <entries-list details=vm.details activity=vm.activity type=true ng-if=vm.advancedView> </entries-list> <div class=\"col-md-12 m-b\" ng-repeat=\"activity in vm.children\" ng-if=vm.checkChildren(vm.children)> <h4 class=\"text-azul text-base font-bold text-block\"> {{activity.isPlanning ? 'Planeación y Gestión' : 'Formación de jóvenes docentes'}} </h4> <div class=m-t ng-repeat=\"children in activity\" ng-if=vm.standardView> <p class=\"text-sm m-b-sm m-h-sm\"> {{ ::children.name }} <span class=text-gris-dark> {{activity.isPlanning ? children.description!=null ? '-'+children.description :'' : 'Número de estudiantes: ' + children.itemActivityValue}} <span> <span class=\"text-info proxima right\">{{ ::children.hoursPlanned }} hrs planeadas<span> </span></span></span></span></p> <md-divider></md-divider> </div> <children-activities parent=vm.details children=activity activity=vm.activity planning=vm.planning ng-if=vm.advancedView> </children-activities> <p class=\"text-sm text-gris-dark\" ng-if=\"activity.length < 1\">No registra actividades de este tipo</p> </div> ";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.listPanel = undefined;
	
	var _listPanel = __webpack_require__(486);
	
	var _listPanel2 = _interopRequireDefault(_listPanel);
	
	var _xlsx = __webpack_require__(487);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listPanel = exports.listPanel = {
		template: _listPanel2.default,
		controllerAs: 'vm',
		controller: ['ReviewSrv', 'uiGridConstants', '$rootScope', '$interval', '$cookies', '$state', 'GlobalConfig', 'Validations', 'uiGridExporterConstants', 'GeneralSettingsSrv', '$scope', '$window', function listPanelCtrl(ReviewSrv, uiGridConstants, $rootScope, $interval, $cookies, $state, GlobalConfig, Validations, uiGridExporterConstants, GeneralSettingsSrv, $scope, $window) {
			var vm = this;
	
			$rootScope.fullscreenClass = 'background-planning';
	
			var currentStage = $state.current.tag;
			var stagesIds = GlobalConfig.workplanIdStages;
			var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	
			var inConsultant = Validations.inConsultant(currentRoleId);
			var inAdminConsultantUnit = Validations.inAdminConsultantUnit(currentRoleId);
			var isWorkplanCommittee = Validations.isWorkplanCommittee(currentRoleId);
			var isCommittee = Validations.isCommitteeRole(currentRoleId);
			var isCommitteeAdmin = Validations.isCommitteeAdmin(currentRoleId);
	
			var inReview = Validations.inReview(currentStage);
			var inApproval = Validations.inApproval(currentStage);
			var inExecution = Validations.inExecution(currentStage);
			var inReviewExecution = Validations.inReviewExecution(currentStage);
			var inEvaluation = Validations.inEvaluation(currentStage);
			var validUser = Validations.validUser(currentRoleId, currentStage);
	
			vm.generalIndicatorsLabel = 'Planes de trabajo';
			vm.mainLabel = $state.current.data.label;
			vm.classAction = '';
			vm.isConsultantOrAdmin = false;
			vm.isConsultantOrAdminUnit = false;
			vm.committeesList = [];
	
			vm.loadIndicatorData = loadIndicatorData;
			vm.singleFilter = singleFilter;
			vm.exportGrid = exportGrid;
			vm.changeWorkplansList = changeWorkplansList;
			$scope.changeWorkplansList = changeWorkplansList;
			var header = {
				idRol: currentRoleId,
				idEvaluator: JSON.parse($cookies.get('currentUser')).id,
				idStage: null
			};
	
			vm.indicators = [];
	
			vm.gridPanel = {
				enableFiltering: true,
				exporterOlderExcelCompatibility: true,
				columnDefs: [{
					name: 'Nombre del profesor',
					displayName: 'Nombre del profesor',
					field: 'teacherName',
					width: '35  %',
					enableGridMenu: false,
					enableFiltering: true,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false
				}, {
					name: 'Plan de trabajo asignado',
					displayName: 'Plan de trabajo asignado',
					field: 'workplanName',
					width: '38%',
					enableGridMenu: false,
					enableFiltering: true,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false
				}, {
					name: 'Estado',
					displayName: 'Estado',
					field: 'stageName',
					width: '15%',
					enableGridMenu: false,
					enableFiltering: true,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false
				}, {
					name: 'Acciones',
					displayName: 'Acciones',
					field: 'actionText',
					width: '12%',
					enableGridMenu: false,
					enableFiltering: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					headerCellClass: 'column-center',
					cellClass: vm.classAction,
					cellTemplate: '<panel-router data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName, stage: row.entity.stageId}" action="row.entity.actionText"></panel-router>'
				}],
				onRegisterApi: function onRegisterApi(gridApi) {
					vm.gridApi = gridApi;
					vm.gridApi.grid.registerRowsProcessor(vm.singleFilter, 100);
					$interval(function () {
						vm.gridApi.core.handleWindowResize();
					}, 500, 10);
				}
			};
	
			vm.gridCommittee = {
				enableFiltering: true,
				columnDefs: [{
					name: 'Comité',
					displayName: 'Comité',
					field: 'commitee.ds_name',
					width: '100%',
					enableGridMenu: false,
					enableFiltering: true,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellTemplate: '<div class="ui-grid-cell-contents over-auto-normal"><a ng-click="grid.appScope.changeWorkplansList(row.entity.teachers, row.entity.commitee.ds_name)">{{row.entity.commitee.ds_name}}</a></div>'
				}],
				onRegisterApi: function onRegisterApi(gridApi) {
					vm.gridApiCommittee = gridApi;
					$interval(function () {
						vm.gridApiCommittee.core.handleWindowResize();
					}, 500, 10);
				}
	
				//init
			};vm.$onInit = function () {
				if (!validUser) {
					$state.go('app.unauthorized');
				}
	
				vm.classAction = inReviewExecution ? 'column-center' : 'column-left';
				header.idStage = setHeader();
	
				//console.log('header.idStage',header.idStage)
				if (vm.isConsultantOrAdmin) {
					getWorkplansList({});
				} else if (vm.isConsultantOrAdminUnit) {
					var obj = { idUser: JSON.parse($cookies.get('currentUser')).id };
	
					getWorkplansList(obj);
				} else if (isWorkplanCommittee || isCommittee || isCommitteeAdmin) {
					vm.showCommittees = true;
					getCommittersByUserId();
				} else {
					vm.mainLabel = 'Etapa de ' + vm.mainLabel;
					getReviewList(header);
				}
			};
	
			function setHeader() {
				switch (true) {
	
					case inReview:
						return stagesIds.review;
					case inApproval:
						return stagesIds.approval;
					case inExecution:
						return stagesIds.execution;
					case inReviewExecution:
						return stagesIds.reviewExecution;
					case inEvaluation:
						return stagesIds.evaluation;
					case inConsultant:
						vm.isConsultantOrAdmin = true;
	
						return stagesIds.consultant;
					case inAdminConsultantUnit:
						vm.isConsultantOrAdminUnit = true;
	
						return stagesIds.adminConsultantUnit;
	
				}
			}
	
			function getReviewList(header) {
				vm.isLoading = true;
				ReviewSrv.getPanelWorkplans.post(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						vm.totalData = dataReturn.data;
						setIndicatorData();
						vm.isLoading = false;
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
	
			function getWorkplansList(header) {
				ReviewSrv.getAllWorkplanList.post(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						vm.gridPanel.data = dataReturn.data;
						//setIndicatorData()
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
	
			function getCommittersByUserId() {
				GeneralSettingsSrv.getCommittersByUserId.get({ idUser: header.idEvaluator }).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						vm.committeesList = dataReturn.data;
						vm.gridCommittee.data = vm.committeesList;
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
	
			function changeWorkplansList(list, committeeName) {
				vm.committeeName = committeeName || null;
				vm.gridPanel.data = list.map(function (a) {
					a.actionText = 'ver';
	
					return a;
				});
			}
	
			function setIndicatorData() {
				for (var i = 0; i < vm.totalData.length; i++) {
					if (i == 0) {
						vm.gridPanel.data = vm.totalData[i].data;
						vm.totalData[i].selected = true;
					} else vm.totalData[i].selected = false;
	
					vm.indicators.push(vm.totalData[i]);
				}
			}
	
			function loadIndicatorData(indicator) {
				vm.indicators.forEach(function (ind) {
					ind.selected = false;
				});
				vm.gridPanel.data = indicator.data;
				indicator.selected = true;
			}
	
			vm.workPlanFilter = '';
	
			function singleFilter(renderableRows) {
				var matcher = new RegExp(vm.workPlanFilter, 'i');
	
				renderableRows.forEach(function (row) {
					var match = false;
	
					['teacherName'].forEach(function (field) {
						if (row.entity[field] && row.entity[field].match(matcher)) {
							match = true;
						}
					});
	
					if (!match) {
						row.visible = false;
					}
				});
	
				return renderableRows;
			}
	
			function exportGrid() {
				var fileName = 'planes_de_trabajo';
				var wb = XLSX.utils.book_new();
	
				var table = [['Nombre del profesor', 'Cédula', 'Plan de trabajo asignado', 'Etapa', 'Unidad Académica']];
	
				for (var i in vm.gridPanel.data) {
					table.push([vm.gridPanel.data[i]['teacherName'], vm.gridPanel.data[i]['identification'], vm.gridPanel.data[i]['workplanName'], vm.gridPanel.data[i]['stageName'], vm.gridPanel.data[i]['academicUnit']]);
				}
	
				var ws = XLSX.utils.aoa_to_sheet(table);
	
				XLSX.utils.book_append_sheet(wb, ws, fileName);
	
				var wbbuf = XLSX.write(wb, {
					bookType: 'xlsx',
					mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					type: 'base64'
				});
	
				var a = document.createElement('a');
	
				a.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + encodeURI(wbbuf);
				a.target = '_blank';
				a.download = fileName + '.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}
		}] };

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = "<style>.grid-workplan{width:100%;height:480px}.grid-workplan .btn-Evaluation{border-style:solid;border-color:#fff;border-width:medium;width:163px}.grid-workplan .over-auto-normal{overflow:auto!important;white-space:normal!important}.grid-workplan .ui-grid-row{display:flex;min-height:30px!important;height:auto!important;padding-top:5px;padding-bottom:5px;border-bottom:1px solid rgba(255,255,255,.4)}.grid-committee{height:480px}.grid-committee .btn-Evaluation{border-style:solid;border-color:#fff;border-width:medium;width:163px}.grid-committee .over-auto-normal{overflow:auto!important;white-space:normal!important}.grid-committee .ui-grid-row{display:flex;min-height:30px!important;height:auto!important;padding-top:5px;padding-bottom:5px;border-bottom:1px solid rgba(255,255,255,.4)}.ui-grid-header-canvas,.ui-grid-header-cell-wrapper,.ui-grid-header-viewport,.ui-grid-top-panel{width:100%}</style> <div class=\"row gutter-10\"> <div class=\"col-md-2 text-center\"> <div class=\"col-md-12 text-center\" ng-show=!vm.isConsultantOrAdmin> <div class=row ng-repeat=\"ind in vm.indicators\"> <div class=\"col-md-12 text-center\"> <div class=\"principal-diagram c100 p{{ind.percentage}} {{ind.selected ? 'md' : 'sm'}} green center\" ng-click=vm.loadIndicatorData(ind)> <span class=pointer>{{ ind.percentage }}%</span> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> <p class=\"text-sm exo p-t text-blanco\">{{ ind.numerator }}/{{ ind.denominator }}</p> <p class=\"text-sm text-blanco\">Planes de trabajo<br>{{ ind.description }}</p> </div> </div> </div> <div class=\"col-md-12 text-center m-t-lg\" ng-show=\"vm.showCommittees && vm.gridCommittee.data.length > 0\"> <div class=m-t-lg> <div class=m-t-lg> <div class=\"grid-committee m-t-lg\" ui-grid=vm.gridCommittee ng-if=\"vm.gridCommittee.data.length > 0\" ui-grid-exporter grid1515519388566 ui-grid-render-container-body> </div> </div> </div> </div> </div> <div class=col-md-10> <div class=row> <div class=\"no-padding m-b-lg col-md-12\"> <div class=col-md-12> <h1 class=\"text-blanco text-left\">Bienvenido a plan de trabajo <span class=text-md>{{vm.mainLabel}}</span> </h1> <span class=\"pull-right text-blanco pointer\" ng-click=vm.exportGrid()> <i class=\"mdi-file-file-download i-24\"></i> Descargar listados </span> </div> <div class=text-center ng-if=vm.isLoading> <md-progress-circular style=display:inline-block;color:#fff!important class=md-hue-2 md-diameter=80px></md-progress-circular> <div><span class=\"text-blanco text-left text-md\">{{'Cargando información' | translate }}...</span></div> </div> <div class=col-md-12 ng-if=\"vm.showCommittees && vm.committeeName\"> <span class=\"text-blanco text-left text-md\">Comité: {{vm.committeeName}}</span> </div> </div> </div> <div class=\"row p-r-md\"> <div class=col-md-12> <div class=\"grid-workplan gridStandardView\" ui-grid=vm.gridPanel ng-if=vm.gridPanel.data ui-grid-exporter> </div> </div> </div> </div> </div> ";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(488);

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process, $) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported XLSX */
	/*global exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */
	var XLSX = {};
	function make_xlsx_lib(XLSX){
	XLSX.version = '0.18.5';
	var current_codepage = 1200, current_ansi = 1252;
	/*global cptable:true, window */
	var $cptable;
	if(typeof cptable !== 'undefined') $cptable = cptable;
	else if(true) {
		$cptable = __webpack_require__(490);
	}
	
	var VALID_ANSI = [ 874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 10000 ];
	/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
	var CS2CP = ({
	0:    1252, /* ANSI */
	1:   65001, /* DEFAULT */
	2:   65001, /* SYMBOL */
	77:  10000, /* MAC */
	128:   932, /* SHIFTJIS */
	129:   949, /* HANGUL */
	130:  1361, /* JOHAB */
	134:   936, /* GB2312 */
	136:   950, /* CHINESEBIG5 */
	161:  1253, /* GREEK */
	162:  1254, /* TURKISH */
	163:  1258, /* VIETNAMESE */
	177:  1255, /* HEBREW */
	178:  1256, /* ARABIC */
	186:  1257, /* BALTIC */
	204:  1251, /* RUSSIAN */
	222:   874, /* THAI */
	238:  1250, /* EASTEUROPE */
	255:  1252, /* OEM */
	69:   6969  /* MISC */
	});
	
	var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
	function reset_ansi() { set_ansi(1252); }
	
	var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	function reset_cp() { set_cp(1200); reset_ansi(); }
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	
	function utf16leread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
		return o.join("");
	}
	function utf16beread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
		return o.join("");
	}
	
	var debom = function(data) {
		var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
		if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
		if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
		if(c1 == 0xFEFF) return data.slice(1);
		return data;
	};
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	var _getansi = function _ga1(x) { return String.fromCharCode(x); };
	if(typeof $cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
		debom = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return $cptable.utils.decode(1200, char_codes(data.slice(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return $cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
		_getansi = function _ga2(x) {
			return $cptable.utils.decode(current_ansi, [x])[0];
		};
	}
	var DENSE = null;
	var DIF_XL = true;
	var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	function Base64_encode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  for (var i = 0; i < input.length; ) {
	    c1 = input.charCodeAt(i++);
	    e1 = c1 >> 2;
	    c2 = input.charCodeAt(i++);
	    e2 = (c1 & 3) << 4 | c2 >> 4;
	    c3 = input.charCodeAt(i++);
	    e3 = (c2 & 15) << 2 | c3 >> 6;
	    e4 = c3 & 63;
	    if (isNaN(c2)) {
	      e3 = e4 = 64;
	    } else if (isNaN(c3)) {
	      e4 = 64;
	    }
	    o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
	  }
	  return o;
	}
	function Base64_decode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  input = input.replace(/[^\w\+\/\=]/g, "");
	  for (var i = 0; i < input.length; ) {
	    e1 = Base64_map.indexOf(input.charAt(i++));
	    e2 = Base64_map.indexOf(input.charAt(i++));
	    c1 = e1 << 2 | e2 >> 4;
	    o += String.fromCharCode(c1);
	    e3 = Base64_map.indexOf(input.charAt(i++));
	    c2 = (e2 & 15) << 4 | e3 >> 2;
	    if (e3 !== 64) {
	      o += String.fromCharCode(c2);
	    }
	    e4 = Base64_map.indexOf(input.charAt(i++));
	    c3 = (e3 & 3) << 6 | e4;
	    if (e4 !== 64) {
	      o += String.fromCharCode(c3);
	    }
	  }
	  return o;
	}
	var has_buf = (function() { return typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node; })();
	
	var Buffer_from = (function() {
		if(typeof Buffer !== 'undefined') {
			var nbfs = !Buffer.from;
			if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
			return nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		}
		return function() {};
	})();
	
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	function new_unsafe_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	var s2a = function s2a(s) {
		if(has_buf) return Buffer_from(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	};
	
	function s2ab(s) {
		if(typeof ArrayBuffer === 'undefined') return s2a(s);
		var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}
	
	function a2s(data) {
		if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
		var o = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
	}
	
	function a2u(data) {
		if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
		return new Uint8Array(data);
	}
	
	function ab2a(data) {
		if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
		if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	var o = new Array(data.length);
		for(var i = 0; i < data.length; ++i) o[i] = data[i];
		return o;
	}
	
	var bconcat = has_buf ? function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); } : function(bufs) {
		if(typeof Uint8Array !== "undefined") {
			var i = 0, maxlen = 0;
			for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
			var o = new Uint8Array(maxlen);
			var len = 0;
			for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
				len = bufs[i].length;
				if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
				else if(typeof bufs[i] == "string") { throw "wtf"; }
				else o.set(new Uint8Array(bufs[i]), maxlen);
			}
			return o;
		}
		return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
	};
	
	function utf8decode(content) {
		var out = [], widx = 0, L = content.length + 250;
		var o = new_raw_buf(content.length + 255);
		for(var ridx = 0; ridx < content.length; ++ridx) {
			var c = content.charCodeAt(ridx);
			if(c < 0x80) o[widx++] = c;
			else if(c < 0x800) {
				o[widx++] = (192|((c>>6)&31));
				o[widx++] = (128|(c&63));
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64;
				var d = content.charCodeAt(++ridx)&1023;
				o[widx++] = (240|((c>>8)&7));
				o[widx++] = (128|((c>>2)&63));
				o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
				o[widx++] = (128|(d&63));
			} else {
				o[widx++] = (224|((c>>12)&15));
				o[widx++] = (128|((c>>6)&63));
				o[widx++] = (128|(c&63));
			}
			if(widx > L) {
				out.push(o.slice(0, widx));
				widx = 0;
				o = new_raw_buf(65535);
				L = 65530;
			}
		}
		out.push(o.slice(0, widx));
		return bconcat(out);
	}
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
	/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	/* yes, in 2022 this is still faster than string compare */
	function SSF_isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function SSF_init_table(t) {
		if(!t) t = {};
		t[0]=  'General';
		t[1]=  '0';
		t[2]=  '0.00';
		t[3]=  '#,##0';
		t[4]=  '#,##0.00';
		t[9]=  '0%';
		t[10]= '0.00%';
		t[11]= '0.00E+00';
		t[12]= '# ?/?';
		t[13]= '# ??/??';
		t[14]= 'm/d/yy';
		t[15]= 'd-mmm-yy';
		t[16]= 'd-mmm';
		t[17]= 'mmm-yy';
		t[18]= 'h:mm AM/PM';
		t[19]= 'h:mm:ss AM/PM';
		t[20]= 'h:mm';
		t[21]= 'h:mm:ss';
		t[22]= 'm/d/yy h:mm';
		t[37]= '#,##0 ;(#,##0)';
		t[38]= '#,##0 ;[Red](#,##0)';
		t[39]= '#,##0.00;(#,##0.00)';
		t[40]= '#,##0.00;[Red](#,##0.00)';
		t[45]= 'mm:ss';
		t[46]= '[h]:mm:ss';
		t[47]= 'mmss.0';
		t[48]= '##0.0E+0';
		t[49]= '@';
		t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
		return t;
	}
	/* repeated to satiate webpack */
	var table_fmt = {
		0:  'General',
		1:  '0',
		2:  '0.00',
		3:  '#,##0',
		4:  '#,##0.00',
		9:  '0%',
		10: '0.00%',
		11: '0.00E+00',
		12: '# ?/?',
		13: '# ??/??',
		14: 'm/d/yy',
		15: 'd-mmm-yy',
		16: 'd-mmm',
		17: 'mmm-yy',
		18: 'h:mm AM/PM',
		19: 'h:mm:ss AM/PM',
		20: 'h:mm',
		21: 'h:mm:ss',
		22: 'm/d/yy h:mm',
		37: '#,##0 ;(#,##0)',
		38: '#,##0 ;[Red](#,##0)',
		39: '#,##0.00;(#,##0.00)',
		40: '#,##0.00;[Red](#,##0.00)',
		45: 'mm:ss',
		46: '[h]:mm:ss',
		47: 'mmss.0',
		48: '##0.0E+0',
		49: '@',
		56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
	};
	
	/* Defaults determined by systematically testing in Excel 2019 */
	
	/* These formats appear to default to other formats in the table */
	var SSF_default_map = {
		5:  37, 6:  38, 7:  39, 8:  40,         //  5 -> 37 ...  8 -> 40
	
		23:  0, 24:  0, 25:  0, 26:  0,         // 23 ->  0 ... 26 ->  0
	
		27: 14, 28: 14, 29: 14, 30: 14, 31: 14, // 27 -> 14 ... 31 -> 14
	
		50: 14, 51: 14, 52: 14, 53: 14, 54: 14, // 50 -> 14 ... 58 -> 14
		55: 14, 56: 14, 57: 14, 58: 14,
		59:  1, 60:  2, 61:  3, 62:  4,         // 59 ->  1 ... 62 ->  4
	
		67:  9, 68: 10,                         // 67 ->  9 ... 68 -> 10
		69: 12, 70: 13, 71: 14,                 // 69 -> 12 ... 71 -> 14
		72: 14, 73: 15, 74: 16, 75: 17,         // 72 -> 14 ... 75 -> 17
		76: 20, 77: 21, 78: 22,                 // 76 -> 20 ... 78 -> 22
		79: 45, 80: 46, 81: 47,                 // 79 -> 45 ... 81 -> 47
		82: 0                                   // 82 ->  0 ... 65536 -> 0 (omitted)
	};
	
	
	/* These formats technically refer to Accounting formats with no equivalent */
	var SSF_default_str = {
		//  5 -- Currency,   0 decimal, black negative
		5:  '"$"#,##0_);\\("$"#,##0\\)',
		63: '"$"#,##0_);\\("$"#,##0\\)',
	
		//  6 -- Currency,   0 decimal, red   negative
		6:  '"$"#,##0_);[Red]\\("$"#,##0\\)',
		64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
	
		//  7 -- Currency,   2 decimal, black negative
		7:  '"$"#,##0.00_);\\("$"#,##0.00\\)',
		65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
	
		//  8 -- Currency,   2 decimal, red   negative
		8:  '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	
		// 41 -- Accounting, 0 decimal, No Symbol
		41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
	
		// 42 -- Accounting, 0 decimal, $  Symbol
		42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
	
		// 43 -- Accounting, 2 decimal, No Symbol
		43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
	
		// 44 -- Accounting, 2 decimal, $  Symbol
		44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
	};
	
	function SSF_frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.00000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
		if(!mixed) return [0, sgn * P, Q];
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function SSF_parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		if(opts && opts.date1904) date += 1462;
		if(out.u > 0.9999) {
			out.u = 0;
			if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 in Gregorian */
			var d = new Date(1900, 0, 1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = SSF_fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	var SSFbasedate = new Date(1899, 11, 31, 0, 0, 0);
	var SSFdnthresh = SSFbasedate.getTime();
	var SSFbase1904 = new Date(1900, 2, 1, 0, 0, 0);
	function datenum_local(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1461*24*60*60*1000;
		else if(v >= SSFbase1904) epoch += 24*60*60*1000;
		return (epoch - (SSFdnthresh + (v.getTimezoneOffset() - SSFbasedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
	}
	/* ECMA-376 18.8.30 numFmt*/
	/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
	/* exponent >= -9 and <= 9 */
	function SSF_strip_decimal(o) {
		return (o.indexOf(".") == -1) ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
	}
	
	/* General Exponential always shows 2 digits exp and trims the mantissa */
	function SSF_normalize_exp(o) {
		if(o.indexOf("E") == -1) return o;
		return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");
	}
	
	/* exponent >= -9 and <= 9 */
	function SSF_small_exp(v) {
		var w = (v<0?12:11);
		var o = SSF_strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}
	
	/* exponent >= 11 or <= -10 likely exponential */
	function SSF_large_exp(v) {
		var o = SSF_strip_decimal(v.toFixed(11));
		return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
	}
	
	function SSF_general_num(v) {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	
		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = SSF_small_exp(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = SSF_large_exp(v);
	
		return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
	}
	
	
	/*
		"General" rules:
		- text is passed through ("@")
		- booleans are rendered as TRUE/FALSE
		- "up to 11 characters" displayed for numbers
		- Default date format (code 14) used for Dates
	
		The longest 32-bit integer text is "-2147483648", exactly 11 chars
		TODO: technically the display depends on the width of the cell
	*/
	function SSF_general(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? v.toString(10) : SSF_general_num(v);
			case 'undefined': return "";
			case 'object':
				if(v == null) return "";
				if(v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	
	function SSF_fix_hijri(date, o) {
	  /* TODO: properly adjust y/m/d and  */
	  o[0] -= 581;
	  var dow = date.getDay();
	  if(date < 60) dow = (dow + 6) % 7;
	  return dow;
	}
	//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
	function SSF_write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
				if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
				if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
	if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
				else tt = ss0 === 1 ? 10 : 1;
				ss = Math.round((tt)*(val.S + val.u));
				if(ss >= 60*tt) ss = 0;
				if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
				o = pad0(ss,2 + ss0);
				if(fmt === 'ss') return o.substr(0,2);
				return "." + o.substr(2,fmt.length-1);
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1; break;
		}
		var outstr = outl > 0 ? pad0(out, outl) : "";
		return outstr;
	}
	
	
	/*jshint -W086 */
	/*jshint +W086 */
	function commaify(s) {
		var w = 3;
		if(s.length <= w) return s;
		var j = (s.length % w), o = s.substr(0,j);
		for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
		return o;
	}
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.([0#]+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) {
		var _frac = val - Math.floor(val), dd = Math.pow(10,d);
		if (d < ('' + Math.round(_frac * dd)).length) return 0;
		return Math.round(_frac * dd);
	}
	function carry(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 1;
		}
		return 0;
	}
	function flr(val) {
		if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
		return ""+Math.floor(val);
	}
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
			case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp2(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
	o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
			o = o.replace(/\.(\d*)$/,function($$, $1) {
	return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
				if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	}
	function SSF_split_fmt(fmt) {
		var out = [];
		var in_str = false/*, cc*/;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	
	var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
	function fmt_is_date(fmt) {
		var i = 0, /*cc = 0,*/ c = "", o = "";
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': if(SSF_isgeneral(fmt, i)) i+= 6; i++; break;
				case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
				case '\\': i+=2; break;
				case '_': i+=2; break;
				case '@': ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
				case 'A': case 'a': case '上':
					if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
					if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
					if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
					++i; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.match(SSF_abstime)) return true;
					break;
				case '.':
					/* falls through */
				case '0': case '#':
					while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
					break;
				case '?': while(fmt.charAt(++i) === c){/* empty */} break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
				case '(': case ')': ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
				case ' ': ++i; break;
				default: ++i; break;
			}
		}
		return false;
	}
	
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': /* General */
					if(!SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
						if(dt==null) { dt=SSF_parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A': case 'a': case '上':
					var q={t:c, v:c};
					if(dt==null) dt=SSF_parse_date_code(v, opts);
					if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
					else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(SSF_abstime)) {
						if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
						lst = o.charAt(1);
					} else if(o.indexOf("$") > -1) {
						o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
						if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
					}
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt.charAt(++i) === c) o+=c;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
	
		/* Scan for date/time parts */
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': /*if(out[i].v === "B2");*/
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		/* time rounding depends on presence of minute / second / usec fields */
		switch(bt) {
			case 0: break;
			case 1:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
	
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i].v = ""; out[i].t = ";"; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
						(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
						(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
					)) {
						out[i].v += out[jj].v;
						out[jj] = {v:"", t:";"}; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = SSF_general(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			if(nstr.charCodeAt(0) == 40) /* '(' */ {
				myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
				ostr = write_num('n', nstr, myv);
			} else {
				myv = (v<0 && flen > 1 ? -v : v);
				ostr = write_num('n', nstr, myv);
				if(myv < 0 && out[0] && out[0].t == 't') {
					ostr = ostr.substr(1);
					out[0].v = "-" + out[0].v;
				}
			}
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr.charAt(jj++);
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	
	var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = SSF_split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function SSF_format(fmt,v,o) {
		if(o == null) o = {};
		var sfmt = "";
		switch(typeof fmt) {
			case "string":
				if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
				else sfmt = fmt;
				break;
			case "number":
				if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
				else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
				if(sfmt == null) sfmt = (o.table && o.table[SSF_default_map[fmt]]) || table_fmt[SSF_default_map[fmt]];
				if(sfmt == null) sfmt = SSF_default_str[fmt] || "General";
				break;
		}
		if(SSF_isgeneral(sfmt,0)) return SSF_general(v, o);
		if(v instanceof Date) v = datenum_local(v, o.date1904);
		var f = choose_fmt(sfmt, v);
		if(SSF_isgeneral(f[1])) return SSF_general(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	function SSF_load(fmt, idx) {
		if(typeof idx != 'number') {
			idx = +idx || -1;
	for(var i = 0; i < 0x0188; ++i) {
	if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
				if(table_fmt[i] == fmt) { idx = i; break; }
			}
	if(idx < 0) idx = 0x187;
		}
	table_fmt[idx] = fmt;
		return idx;
	}
	function SSF_load_table(tbl) {
		for(var i=0; i!=0x0188; ++i)
			if(tbl[i] !== undefined) SSF_load(tbl[i], i);
	}
	
	function make_ssf() {
		table_fmt = SSF_init_table();
	}
	
	var SSF = {
		format: SSF_format,
		load: SSF_load,
		_table: table_fmt,
		load_table: SSF_load_table,
		parse_date_code: SSF_parse_date_code,
		is_date: fmt_is_date,
		get_table: function get_table() { return SSF._table = table_fmt; }
	};
	
	var SSFImplicit/*{[number]:string}*/ = ({
		"5": '"$"#,##0_);\\("$"#,##0\\)',
		"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"23": 'General', "24": 'General', "25": 'General', "26": 'General',
		"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
		"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
		"36": 'm/d/yy',
		"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
		"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
		"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
		"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
		"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
		"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
		"59": '0',
		"60": '0.00',
		"61": '#,##0',
		"62": '#,##0.00',
		"63": '"$"#,##0_);\\("$"#,##0\\)',
		"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"67": '0%',
		"68": '0.00%',
		"69": '# ?/?',
		"70": '# ??/??',
		"71": 'm/d/yy',
		"72": 'm/d/yy',
		"73": 'd-mmm-yy',
		"74": 'd-mmm',
		"75": 'mmm-yy',
		"76": 'h:mm',
		"77": 'h:mm:ss',
		"78": 'm/d/yy h:mm',
		"79": 'mm:ss',
		"80": '[h]:mm:ss',
		"81": 'mmss.0'
	});
	
	/* dateNF parse TODO: move to SSF */
	var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
	function dateNF_regex(dateNF) {
		var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
		fmt = fmt.replace(dateNFregex, "(\\d+)");
		return new RegExp("^" + fmt + "$");
	}
	function dateNF_fix(str, dateNF, match) {
		var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
		(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
			var v = parseInt(match[i+1], 10);
			switch(n.toLowerCase().charAt(0)) {
				case 'y': Y = v; break; case 'd': d = v; break;
				case 'h': H = v; break; case 's': S = v; break;
				case 'm': if(H >= 0) M = v; else m = v; break;
			}
		});
		if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
		var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
		if(datestr.length == 7) datestr = "0" + datestr;
		if(datestr.length == 8) datestr = "20" + datestr;
		var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
		if(H == -1 && M == -1 && S == -1) return datestr;
		if(Y == -1 && m == -1 && d == -1) return timestr;
		return datestr + "T" + timestr;
	}
	
	/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	/*exported CFB */
	/*global Uint8Array:false, Uint16Array:false */
	
	/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported CRC32 */
	var CRC32 = (function() {
	var CRC32 = {};
	CRC32.version = '1.2.0';
	/* see perf/crc32table.js */
	/*global Int32Array */
	function signed_crc_table() {
		var c = 0, table = new Array(256);
	
		for(var n =0; n != 256; ++n){
			c = n;
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			table[n] = c;
		}
	
		return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
	}
	
	var T0 = signed_crc_table();
	function slice_by_16_tables(T) {
		var c = 0, v = 0, n = 0, table = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;
	
		for(n = 0; n != 256; ++n) table[n] = T[n];
		for(n = 0; n != 256; ++n) {
			v = T[n];
			for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
		}
		var out = [];
		for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
		return out;
	}
	var TT = slice_by_16_tables(T0);
	var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
	var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
	var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
	function crc32_bstr(bstr, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
		return ~C;
	}
	
	function crc32_buf(B, seed) {
		var C = seed ^ -1, L = B.length - 15, i = 0;
		for(; i < L;) C =
			Tf[B[i++] ^ (C & 255)] ^
			Te[B[i++] ^ ((C >> 8) & 255)] ^
			Td[B[i++] ^ ((C >> 16) & 255)] ^
			Tc[B[i++] ^ (C >>> 24)] ^
			Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
			T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
			T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
		L += 15;
		while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
		return ~C;
	}
	
	function crc32_str(str, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
			c = str.charCodeAt(i++);
			if(c < 0x80) {
				C = (C>>>8) ^ T0[(C^c)&0xFF];
			} else if(c < 0x800) {
				C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
				C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
			} else {
				C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			}
		}
		return ~C;
	}
	CRC32.table = T0;
	CRC32.bstr = crc32_bstr;
	CRC32.buf = crc32_buf;
	CRC32.str = crc32_str;
	return CRC32;
	})();
	/* [MS-CFB] v20171201 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '1.2.1';
	/* [MS-CFB] 2.6.4 */
	function namecmp(l, r) {
		var L = l.split("/"), R = r.split("/");
		for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
			if((c = L[i].length - R[i].length)) return c;
			if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
		}
		return L.length - R.length;
	}
	function dirname(p) {
		if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(0, c+1);
	}
	
	function filename(p) {
		if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(c+1);
	}
	/* -------------------------------------------------------------------------- */
	/* DOS Date format:
	   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
	   add 1980 to stored year
	   stored second should be doubled
	*/
	
	/* write JS date to buf as a DOS date */
	function write_dos_date(buf, date) {
		if(typeof date === "string") date = new Date(date);
		var hms = date.getHours();
		hms = hms << 6 | date.getMinutes();
		hms = hms << 5 | (date.getSeconds()>>>1);
		buf.write_shift(2, hms);
		var ymd = (date.getFullYear() - 1980);
		ymd = ymd << 4 | (date.getMonth()+1);
		ymd = ymd << 5 | date.getDate();
		buf.write_shift(2, ymd);
	}
	
	/* read four bytes from buf and interpret as a DOS date */
	function parse_dos_date(buf) {
		var hms = buf.read_shift(2) & 0xFFFF;
		var ymd = buf.read_shift(2) & 0xFFFF;
		var val = new Date();
		var d = ymd & 0x1F; ymd >>>= 5;
		var m = ymd & 0x0F; ymd >>>= 4;
		val.setMilliseconds(0);
		val.setFullYear(ymd + 1980);
		val.setMonth(m-1);
		val.setDate(d);
		var S = hms & 0x1F; hms >>>= 5;
		var M = hms & 0x3F; hms >>>= 6;
		val.setHours(hms);
		val.setMinutes(M);
		val.setSeconds(S<<1);
		return val;
	}
	function parse_extra_field(blob) {
		prep_blob(blob, 0);
		var o = {};
		var flags = 0;
		while(blob.l <= blob.length - 4) {
			var type = blob.read_shift(2);
			var sz = blob.read_shift(2), tgt = blob.l + sz;
			var p = {};
			switch(type) {
				/* UNIX-style Timestamps */
				case 0x5455: {
					flags = blob.read_shift(1);
					if(flags & 1) p.mtime = blob.read_shift(4);
					/* for some reason, CD flag corresponds to LFH */
					if(sz > 5) {
						if(flags & 2) p.atime = blob.read_shift(4);
						if(flags & 4) p.ctime = blob.read_shift(4);
					}
					if(p.mtime) p.mt = new Date(p.mtime*1000);
				}
				break;
			}
			blob.l = tgt;
			o[type] = p;
		}
		return o;
	}
	var fs;
	function get_fs() { return fs || (fs = __webpack_require__(491)); }
	function parse(file, options) {
	if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
	if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
	if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
	var mver = 3;
	var ssz = 512;
	var nmfs = 0; // number of mini FAT sectors
	var difat_sec_cnt = 0;
	var dir_start = 0;
	var minifat_start = 0;
	var difat_start = 0;
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		case 0: if(mv[1] == 0) return parse_zip(file, options);
		/* falls through */
		default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var dir_cnt = blob.read_shift(4, 'i');
	if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
	
	// Number of FAT Sectors
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	difat_sec_cnt = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [];
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
	
	build_full_paths(FileIndex, FullPaths, Paths);
	Paths.shift();
	
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	
	// $FlowIgnore
	if(options && options.raw) o.raw = {header: header, sectors: sectors};
	return o;
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		//blob.chk(HEADER_CLSID, 'CLSID: ');
		blob.l += 16;
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
		blob.l += 2;
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
			case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
			default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = [];
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = [], q = [];
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
			if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
		}
		for(i=1; i < pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = i;
			if(j != dad[j]) do {
				j = dad[j];
				FP[i] = FP[j] + "/" + FP[i];
			} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
			dad[i] = -1;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
		}
	}
	
	function get_mfat_entry(entry, payload, mini) {
		var start = entry.start, size = entry.size;
		//return (payload.slice(start*MSSZ, start*MSSZ + size));
		var o = [];
		var idx = start;
		while(mini && size > 0 && idx >= 0) {
			o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
			size -= MSSZ;
			idx = __readInt32LE(mini, idx * 4);
		}
		if(o.length === 0) return (new_buf(0));
		return (bconcat(o).slice(0, entry.size));
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bits */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q = ENDOFCHAIN;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			if(!sector) return;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var buf = [], buf_chain = [];
		if(!chkd) chkd = [];
		var modulus = ssz - 1, j = 0, jj = 0;
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = ([]);
		var chkd = [], buf = [], buf_chain = [];
		var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
		for(i=0; i < sl; ++i) {
			buf = ([]);
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k]) continue;
			buf_chain = [];
			var seen = [];
			for(j=k; j>=0;) {
				seen[j] = true;
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
				if(!sectors[addr]) break;
				j = __readInt32LE(sectors[addr], jj);
				if(seen[j]) break;
			}
			sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name;
		for(; i < sector.length; i+= 128) {
			var blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			var o = ({
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i'),
				start: 0,
				size: 0
			});
			var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
			var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = (sector_list[o.start].data.slice(0,o.size));
			} else {
				o.storage = 'minifat';
				if(o.size < 0) o.size = 0;
				else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
					o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
				}
			}
			if(o.content) prep_blob(o.content, 0);
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	function read_file(filename, options) {
		get_fs();
		return parse(fs.readFileSync(filename), options);
	}
	
	function read(blob, options) {
		var type = options && options.type;
		if(!type) {
			if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
		}
		switch(type || "base64") {
			case "file": return read_file(blob, options);
			case "base64": return parse(s2a(Base64_decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob, options);
	}
	
	function init_cfb(cfb, opts) {
		var o = opts || {}, root = o.root || "Root Entry";
		if(!cfb.FullPaths) cfb.FullPaths = [];
		if(!cfb.FileIndex) cfb.FileIndex = [];
		if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
		if(cfb.FullPaths.length === 0) {
			cfb.FullPaths[0] = root + "/";
			cfb.FileIndex[0] = ({ name: root, type: 5 });
		}
		if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
		seed_cfb(cfb);
	}
	function seed_cfb(cfb) {
		var nm = "\u0001Sh33tJ5";
		if(CFB.find(cfb, "/" + nm)) return;
		var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
		cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
		cfb.FullPaths.push(cfb.FullPaths[0] + nm);
		rebuild_cfb(cfb);
	}
	function rebuild_cfb(cfb, f) {
		init_cfb(cfb);
		var gc = false, s = false;
		for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
			var _file = cfb.FileIndex[i];
			switch(_file.type) {
				case 0:
					if(s) gc = true;
					else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
					break;
				case 1: case 2: case 5:
					s = true;
					if(isNaN(_file.R * _file.L * _file.C)) gc = true;
					if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
					break;
				default: gc = true; break;
			}
		}
		if(!gc && !f) return;
	
		var now = new Date(1987, 1, 19), j = 0;
		// Track which names exist
		var fullPaths = Object.create ? Object.create(null) : {};
		var data = [];
		for(i = 0; i < cfb.FullPaths.length; ++i) {
			fullPaths[cfb.FullPaths[i]] = true;
			if(cfb.FileIndex[i].type === 0) continue;
			data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
		}
		for(i = 0; i < data.length; ++i) {
			var dad = dirname(data[i][0]);
			s = fullPaths[dad];
			if(!s) {
				data.push([dad, ({
					name: filename(dad).replace("/",""),
					type: 1,
					clsid: HEADER_CLSID,
					ct: now, mt: now,
					content: null
				})]);
				// Add name to set
				fullPaths[dad] = true;
			}
		}
	
		data.sort(function(x,y) { return namecmp(x[0], y[0]); });
		cfb.FullPaths = []; cfb.FileIndex = [];
		for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
		for(i = 0; i < data.length; ++i) {
			var elt = cfb.FileIndex[i];
			var nm = cfb.FullPaths[i];
	
			elt.name =  filename(nm).replace("/","");
			elt.L = elt.R = elt.C = -(elt.color = 1);
			elt.size = elt.content ? elt.content.length : 0;
			elt.start = 0;
			elt.clsid = (elt.clsid || HEADER_CLSID);
			if(i === 0) {
				elt.C = data.length > 1 ? 1 : -1;
				elt.size = 0;
				elt.type = 5;
			} else if(nm.slice(-1) == "/") {
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
				elt.C = j >= data.length ? -1 : j;
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
				elt.R = j >= data.length ? -1 : j;
				elt.type = 1;
			} else {
				if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
				elt.type = 2;
			}
		}
	
	}
	
	function _write(cfb, options) {
		var _opts = options || {};
		/* MAD is order-sensitive, skip rebuild and sort */
		if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
		rebuild_cfb(cfb);
		switch(_opts.fileType) {
			case 'zip': return write_zip(cfb, _opts);
			//case 'mad': return write_mad(cfb, _opts);
		}
		var L = (function(cfb){
			var mini_size = 0, fat_size = 0;
			for(var i = 0; i < cfb.FileIndex.length; ++i) {
				var file = cfb.FileIndex[i];
				if(!file.content) continue;
	var flen = file.content.length;
				if(flen > 0){
					if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
					else fat_size += (flen + 0x01FF) >> 9;
				}
			}
			var dir_cnt = (cfb.FullPaths.length +3) >> 2;
			var mini_cnt = (mini_size + 7) >> 3;
			var mfat_cnt = (mini_size + 0x7F) >> 7;
			var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
			var fat_cnt = (fat_base + 0x7F) >> 7;
			var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
			cfb.FileIndex[0].size = mini_size << 6;
			L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
			return L;
		})(cfb);
		var o = new_buf(L[7] << 9);
		var i = 0, T = 0;
		{
			for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
			for(i = 0; i < 8; ++i) o.write_shift(2, 0);
			o.write_shift(2, 0x003E);
			o.write_shift(2, 0x0003);
			o.write_shift(2, 0xFFFE);
			o.write_shift(2, 0x0009);
			o.write_shift(2, 0x0006);
			for(i = 0; i < 3; ++i) o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, L[2]);
			o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
			o.write_shift(4, 0);
			o.write_shift(4, 1<<12);
			o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
			o.write_shift(4, L[3]);
			o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
			o.write_shift(4, L[1]);
			for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
		}
		if(L[1]) {
			for(T = 0; T < L[1]; ++T) {
				for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
				o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
			}
		}
		var chainit = function(w) {
			for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
			if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
		};
		T = i = 0;
		for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
		for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
		chainit(L[3]);
		chainit(L[4]);
		var j = 0, flen = 0;
		var file = cfb.FileIndex[0];
		for(; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(flen < 0x1000) continue;
			file.start = T;
			chainit((flen + 0x01FF) >> 9);
		}
		chainit((L[6] + 7) >> 3);
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		T = i = 0;
		for(j = 0; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(!flen || flen >= 0x1000) continue;
			file.start = T;
			chainit((flen + 0x3F) >> 6);
		}
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		for(i = 0; i < L[4]<<2; ++i) {
			var nm = cfb.FullPaths[i];
			if(!nm || nm.length === 0) {
				for(j = 0; j < 17; ++j) o.write_shift(4, 0);
				for(j = 0; j < 3; ++j) o.write_shift(4, -1);
				for(j = 0; j < 12; ++j) o.write_shift(4, 0);
				continue;
			}
			file = cfb.FileIndex[i];
			if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
			var _nm = (i === 0 && _opts.root) || file.name;
			flen = 2*(_nm.length+1);
			o.write_shift(64, _nm, "utf16le");
			o.write_shift(2, flen);
			o.write_shift(1, file.type);
			o.write_shift(1, file.color);
			o.write_shift(-4, file.L);
			o.write_shift(-4, file.R);
			o.write_shift(-4, file.C);
			if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
			else o.write_shift(16, file.clsid, "hex");
			o.write_shift(4, file.state || 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, file.start);
			o.write_shift(4, file.size); o.write_shift(4, 0);
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size >= 0x1000) {
				o.l = (file.start+1) << 9;
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 511) & -512;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x1FF; ++j) o.write_shift(1, 0);
				}
			}
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size > 0 && file.size < 0x1000) {
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 63) & -64;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x3F; ++j) o.write_shift(1, 0);
				}
			}
		}
		if (has_buf) {
			o.l = o.length;
		} else {
			// When using Buffer, already 0-filled
			while(o.l < o.length) o.write_shift(1, 0);
		}
		return o;
	}
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	function find(cfb, path) {
		var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
		var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
		var k = false;
		if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
		else k = path.indexOf("/") !== -1;
		var UCPath = path.toUpperCase();
		var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
		if(w !== -1) return cfb.FileIndex[w];
	
		var m = !UCPath.match(chr1);
		UCPath = UCPath.replace(chr0,'');
		if(m) UCPath = UCPath.replace(chr1,'!');
		for(w = 0; w < UCFullPaths.length; ++w) {
			if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
			if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		}
		return null;
	}
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	function write_file(cfb, filename, options) {
		get_fs();
		var o = _write(cfb, options);
	fs.writeFileSync(filename, o);
	}
	
	function a2s(o) {
		var out = new Array(o.length);
		for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
		return out.join("");
	}
	
	function write(cfb, options) {
		var o = _write(cfb, options);
		switch(options && options.type || "buffer") {
			case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
			case "binary": return typeof o == "string" ? o : a2s(o);
			case "base64": return Base64_encode(typeof o == "string" ? o : a2s(o));
			case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
				/* falls through */
			case "array": return typeof o == "string" ? s2a(o) : o;
		}
		return o;
	}
	/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
	var _zlib;
	function use_zlib(zlib) { try {
		var InflateRaw = zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
		if(InflRaw.bytesRead) _zlib = zlib;
		else throw new Error("zlib does not expose bytesRead");
	} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }
	
	function _inflateRawSync(payload, usz) {
		if(!_zlib) return _inflate(payload, usz);
		var InflateRaw = _zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
		payload.l += InflRaw.bytesRead;
		return out;
	}
	
	function _deflateRawSync(payload) {
		return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
	}
	var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
	var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];
	
	/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
	var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];
	
	function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }
	
	var use_typed_arrays = typeof Uint8Array !== 'undefined';
	
	var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
	for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);
	
	function bit_swap_n(n, b) {
		var rev = bitswap8[n & 0xFF];
		if(b <= 8) return rev >>> (8-b);
		rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
		if(b <= 16) return rev >>> (16-b);
		rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
		return rev >>> (24-b);
	}
	
	/* helpers for unaligned bit reads */
	function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
	function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
	function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
	function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
	function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }
	
	/* works up to n = 3 * 8 + 1 = 25 */
	function read_bits_n(buf, bl, n) {
		var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
		var v = buf[h] >>> w;
		if(n < 8 - w) return v & f;
		v |= buf[h+1]<<(8-w);
		if(n < 16 - w) return v & f;
		v |= buf[h+2]<<(16-w);
		if(n < 24 - w) return v & f;
		v |= buf[h+3]<<(24-w);
		return v & f;
	}
	
	/* helpers for unaligned bit writes */
	function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
		if(w <= 5) buf[h] |= (v & 7) << w;
		else {
			buf[h] |= (v << w) & 0xFF;
			buf[h+1] = (v&7) >> (8-w);
		}
		return bl + 3;
	}
	
	function write_bits_1(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v = (v&1) << w;
		buf[h] |= v;
		return bl + 1;
	}
	function write_bits_8(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v;
		return bl + 8;
	}
	function write_bits_16(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v & 0xFF;
		buf[h+2] = v >>> 8;
		return bl + 16;
	}
	
	/* until ArrayBuffer#realloc is a thing, fake a realloc */
	function realloc(b, sz) {
		var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
		if(L >= sz) return b;
		if(has_buf) {
			var o = new_unsafe_buf(M);
			// $FlowIgnore
			if(b.copy) b.copy(o);
			else for(; i < b.length; ++i) o[i] = b[i];
			return o;
		} else if(use_typed_arrays) {
			var a = new Uint8Array(M);
			if(a.set) a.set(b);
			else for(; i < L; ++i) a[i] = b[i];
			return a;
		}
		b.length = M;
		return b;
	}
	
	/* zero-filled arrays for older browsers */
	function zero_fill_array(n) {
		var o = new Array(n);
		for(var i = 0; i < n; ++i) o[i] = 0;
		return o;
	}
	
	/* build tree (used for literals and lengths) */
	function build_tree(clens, cmap, MAX) {
		var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
	
		var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
		for(i = 0; i < 32; ++i) bl_count[i] = 0;
	
		for(i = L; i < MAX; ++i) clens[i] = 0;
		L = clens.length;
	
		var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
	
		/* build code tree */
		for(i = 0; i < L; ++i) {
			bl_count[(w = clens[i])]++;
			if(maxlen < w) maxlen = w;
			ctree[i] = 0;
		}
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
		for(i = 0; i < L; ++i) {
			ccode = clens[i];
			if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
		}
	
		/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
				for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
					cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
			}
		}
		return maxlen;
	}
	
	/* Fixed Huffman */
	var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
	var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
	if(!use_typed_arrays) {
		for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
		for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
	}
	(function() {
		var dlens = [];
		var i = 0;
		for(;i<32; i++) dlens.push(5);
		build_tree(dlens, fix_dmap, 32);
	
		var clens = [];
		i = 0;
		for(; i<=143; i++) clens.push(8);
		for(; i<=255; i++) clens.push(9);
		for(; i<=279; i++) clens.push(7);
		for(; i<=287; i++) clens.push(8);
		build_tree(clens, fix_lmap, 288);
	})();var _deflateRaw = (function _deflateRawIIFE() {
		var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
		var j = 0, k = 0;
		for(; j < DST_LN.length - 1; ++j) {
			for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
		}
		for(;k < 32768; ++k) DST_LN_RE[k] = 29;
	
		var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
		for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
			for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
		}
	
		function write_stored(data, out) {
			var boff = 0;
			while(boff < data.length) {
				var L = Math.min(0xFFFF, data.length - boff);
				var h = boff + L == data.length;
				out.write_shift(1, +h);
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
			}
			return out.l;
		}
	
		/* Fixed Huffman */
		function write_huff_fixed(data, out) {
			var bl = 0;
			var boff = 0;
			var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
			while(boff < data.length) {
				var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
	
				/* write a stored block for short data */
				if(L < 10) {
					bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
					if(bl & 7) bl += 8 - (bl & 7);
					out.l = (bl / 8) | 0;
					out.write_shift(2, L);
					out.write_shift(2, (~L) & 0xFFFF);
					while(L-- > 0) out[out.l++] = data[boff++];
					bl = out.l * 8;
					continue;
				}
	
				bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
				var hash = 0;
				while(L-- > 0) {
					var d = data[boff];
					hash = ((hash << 5) ^ d) & 0x7FFF;
	
					var match = -1, mlen = 0;
	
					if((match = addrs[hash])) {
						match |= boff & ~0x7FFF;
						if(match > boff) match -= 0x8000;
						if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
					}
	
					if(mlen > 2) {
						/* Copy Token  */
						d = LEN_LN_RE[mlen];
						if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
						else {
							write_bits_8(out, bl, 3);
							bl += 5;
							write_bits_8(out, bl, bitswap8[d-23]>>5);
							bl += 3;
						}
						var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
						if(len_eb > 0) {
							write_bits_16(out, bl, mlen - LEN_LN[d]);
							bl += len_eb;
						}
	
						d = DST_LN_RE[boff - match];
						bl = write_bits_8(out, bl, bitswap8[d]>>3);
						bl -= 3;
	
						var dst_eb = d < 4 ? 0 : (d-2)>>1;
						if(dst_eb > 0) {
							write_bits_16(out, bl, boff - match - DST_LN[d]);
							bl += dst_eb;
						}
						for(var q = 0; q < mlen; ++q) {
							addrs[hash] = boff & 0x7FFF;
							hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
							++boff;
						}
						L-= mlen - 1;
					} else {
						/* Literal Token */
						if(d <= 143) d = d + 48;
						else bl = write_bits_1(out, bl, 1);
						bl = write_bits_8(out, bl, bitswap8[d]);
						addrs[hash] = boff & 0x7FFF;
						++boff;
					}
				}
	
				bl = write_bits_8(out, bl, 0) - 1;
			}
			out.l = ((bl + 7)/8)|0;
			return out.l;
		}
		return function _deflateRaw(data, out) {
			if(data.length < 8) return write_stored(data, out);
			return write_huff_fixed(data, out);
		};
	})();
	
	function _deflate(data) {
		var buf = new_buf(50+Math.floor(data.length*1.1));
		var off = _deflateRaw(data, buf);
		return buf.slice(0, off);
	}
	/* modified inflate function also moves original read head */
	
	var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
	var dyn_len_1 = 1, dyn_len_2 = 1;
	
	/* 5.5.3 Expanding Huffman Codes */
	function dyn(data, boff) {
		/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
		var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
		var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
		var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
		var w = 0;
	
		/* grab and store code lengths */
		var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
		var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
		var maxlen = 1;
		var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var L = clens.length; /* 19 */
		for(var i = 0; i < _HCLEN; ++i) {
			clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
			if(maxlen < w) maxlen = w;
			bl_count[w]++;
			boff += 3;
		}
	
		/* build code tree */
		var ccode = 0;
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
		for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
		/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bitswap8[ctree[i]]>>(8-cleni);
				for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
			}
		}
	
		/* read literal and dist codes at once */
		var hcodes = [];
		maxlen = 1;
		for(; hcodes.length < _HLIT + _HDIST;) {
			ccode = dyn_cmap[read_bits_7(data, boff)];
			boff += ccode & 7;
			switch((ccode >>>= 3)) {
				case 16:
					w = 3 + read_bits_2(data, boff); boff += 2;
					ccode = hcodes[hcodes.length - 1];
					while(w-- > 0) hcodes.push(ccode);
					break;
				case 17:
					w = 3 + read_bits_3(data, boff); boff += 3;
					while(w-- > 0) hcodes.push(0);
					break;
				case 18:
					w = 11 + read_bits_7(data, boff); boff += 7;
					while(w -- > 0) hcodes.push(0);
					break;
				default:
					hcodes.push(ccode);
					if(maxlen < ccode) maxlen = ccode;
					break;
			}
		}
	
		/* build literal / length trees */
		var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
		for(i = _HLIT; i < 286; ++i) h1[i] = 0;
		for(i = _HDIST; i < 30; ++i) h2[i] = 0;
		dyn_len_1 = build_tree(h1, dyn_lmap, 286);
		dyn_len_2 = build_tree(h2, dyn_dmap, 30);
		return boff;
	}
	
	/* return [ data, bytesRead ] */
	function inflate(data, usz) {
		/* shortcircuit for empty buffer [0x03, 0x00] */
		if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }
	
		/* bit offset */
		var boff = 0;
	
		/* header includes final bit and type bits */
		var header = 0;
	
		var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
		var woff = 0;
		var OL = outbuf.length>>>0;
		var max_len_1 = 0, max_len_2 = 0;
	
		while((header&1) == 0) {
			header = read_bits_3(data, boff); boff += 3;
			if((header >>> 1) == 0) {
				/* Stored block */
				if(boff & 7) boff += 8 - (boff&7);
				/* 2 bytes sz, 2 bytes bit inverse */
				var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
				boff += 32;
				/* push sz bytes */
				if(sz > 0) {
					if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
					while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
				}
				continue;
			} else if((header >> 1) == 1) {
				/* Fixed Huffman */
				max_len_1 = 9; max_len_2 = 5;
			} else {
				/* Dynamic Huffman */
				boff = dyn(data, boff);
				max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
			}
			for(;;) { // while(true) is apparently out of vogue in modern JS circles
				if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
				/* ingest code and move read head */
				var bits = read_bits_n(data, boff, max_len_1);
				var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
				boff += code & 15; code >>>= 4;
				/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
				if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
				else if(code == 256) break;
				else {
					code -= 257;
					var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
					var tgt = woff + LEN_LN[code];
					/* length extra bits */
					if(len_eb > 0) {
						tgt += read_bits_n(data, boff, len_eb);
						boff += len_eb;
					}
	
					/* dist code */
					bits = read_bits_n(data, boff, max_len_2);
					code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
					boff += code & 15; code >>>= 4;
					var dst_eb = (code < 4 ? 0 : (code-2)>>1);
					var dst = DST_LN[code];
					/* dist extra bits */
					if(dst_eb > 0) {
						dst += read_bits_n(data, boff, dst_eb);
						boff += dst_eb;
					}
	
					/* in the common case, manual byte copy is faster than TA set / Buffer copy */
					if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
					while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
				}
			}
		}
		if(usz) return [outbuf, (boff+7)>>>3];
		return [outbuf.slice(0, woff), (boff+7)>>>3];
	}
	
	function _inflate(payload, usz) {
		var data = payload.slice(payload.l||0);
		var out = inflate(data, usz);
		payload.l += out[1];
		return out[0];
	}
	
	function warn_or_throw(wrn, msg) {
		if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
		else throw new Error(msg);
	}
	
	function parse_zip(file, options) {
		var blob = file;
		prep_blob(blob, 0);
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o, { root: options.root });
	
		/* find end of central directory, start just after signature */
		var i = blob.length - 4;
		while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
		blob.l = i + 4;
	
		/* parse end of central directory */
		blob.l += 4;
		var fcnt = blob.read_shift(2);
		blob.l += 6;
		var start_cd = blob.read_shift(4);
	
		/* parse central directory */
		blob.l = start_cd;
	
		for(i = 0; i < fcnt; ++i) {
			/* trust local file header instead of CD entry */
			blob.l += 20;
			var csz = blob.read_shift(4);
			var usz = blob.read_shift(4);
			var namelen = blob.read_shift(2);
			var efsz = blob.read_shift(2);
			var fcsz = blob.read_shift(2);
			blob.l += 8;
			var offset = blob.read_shift(4);
			var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
			blob.l += namelen + efsz + fcsz;
	
			var L = blob.l;
			blob.l = offset + 4;
			parse_local_file(blob, csz, usz, o, EF);
			blob.l = L;
		}
		return o;
	}
	
	
	/* head starts just after local file header signature */
	function parse_local_file(blob, csz, usz, o, EF) {
		/* [local file header] */
		blob.l += 2;
		var flags = blob.read_shift(2);
		var meth = blob.read_shift(2);
		var date = parse_dos_date(blob);
	
		if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
		var crc32 = blob.read_shift(4);
		var _csz = blob.read_shift(4);
		var _usz = blob.read_shift(4);
	
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
	
		// TODO: flags & (1<<11) // UTF8
		var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
		if(efsz) {
			var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
			if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
			if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
		}
		blob.l += efsz;
	
		/* [encryption header] */
	
		/* [file data] */
		var data = blob.slice(blob.l, blob.l + _csz);
		switch(meth) {
			case 8: data = _inflateRawSync(blob, _usz); break;
			case 0: break; // TODO: scan for magic number
			default: throw new Error("Unsupported ZIP Compression method " + meth);
		}
	
		/* [data descriptor] */
		var wrn = false;
		if(flags & 8) {
			crc32 = blob.read_shift(4);
			if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
			_csz = blob.read_shift(4);
			_usz = blob.read_shift(4);
		}
	
		if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
		if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
		//var _crc32 = CRC32.buf(data, 0);
		//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
		cfb_add(o, name, data, {unsafe: true, mt: date});
	}
	function write_zip(cfb, options) {
		var _opts = options || {};
		var out = [], cdirs = [];
		var o = new_buf(1);
		var method = (_opts.compression ? 8 : 0), flags = 0;
		var desc = false;
		if(desc) flags |= 8;
		var i = 0, j = 0;
	
		var start_cd = 0, fcnt = 0;
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		var crcs = [];
		var sz_cd = 0;
	
		for(i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
			var start = start_cd;
	
			/* TODO: CP437 filename */
			var namebuf = new_buf(fp.length);
			for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
			namebuf = namebuf.slice(0, namebuf.l);
			crcs[fcnt] = CRC32.buf(fi.content, 0);
	
			var outbuf = fi.content;
			if(method == 8) outbuf = _deflateRawSync(outbuf);
	
			/* local file header */
			o = new_buf(30);
			o.write_shift(4, 0x04034b50);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			/* TODO: last mod file time/date */
			if(fi.mt) write_dos_date(o, fi.mt);
			else o.write_shift(4, 0);
			o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
			o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
			o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
	
			start_cd += o.length;
			out.push(o);
			start_cd += namebuf.length;
			out.push(namebuf);
	
			/* TODO: extra fields? */
	
			/* TODO: encryption header ? */
	
			start_cd += outbuf.length;
			out.push(outbuf);
	
			/* data descriptor */
			if(flags & 8) {
				o = new_buf(12);
				o.write_shift(-4, crcs[fcnt]);
				o.write_shift(4, outbuf.length);
				o.write_shift(4, fi.content.length);
				start_cd += o.l;
				out.push(o);
			}
	
			/* central directory */
			o = new_buf(46);
			o.write_shift(4, 0x02014b50);
			o.write_shift(2, 0);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			o.write_shift(4, 0); /* TODO: last mod file time/date */
			o.write_shift(-4, crcs[fcnt]);
	
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, start);
	
			sz_cd += o.l;
			cdirs.push(o);
			sz_cd += namebuf.length;
			cdirs.push(namebuf);
			++fcnt;
		}
	
		/* end of central directory */
		o = new_buf(22);
		o.write_shift(4, 0x06054b50);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, fcnt);
		o.write_shift(2, fcnt);
		o.write_shift(4, sz_cd);
		o.write_shift(4, start_cd);
		o.write_shift(2, 0);
	
		return bconcat(([bconcat((out)), bconcat(cdirs), o]));
	}
	var ContentTypeMap = ({
		"htm": "text/html",
		"xml": "text/xml",
	
		"gif": "image/gif",
		"jpg": "image/jpeg",
		"png": "image/png",
	
		"mso": "application/x-mso",
		"thmx": "application/vnd.ms-officetheme",
		"sh33tj5": "application/octet-stream"
	});
	
	function get_content_type(fi, fp) {
		if(fi.ctype) return fi.ctype;
	
		var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
	
		if(fp) {
			m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
			if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
		}
	
		return "application/octet-stream";
	}
	
	/* 76 character chunks TODO: intertwine encoding */
	function write_base64_76(bstr) {
		var data = Base64_encode(bstr);
		var o = [];
		for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
		return o.join("\r\n") + "\r\n";
	}
	
	/*
	Rules for QP:
		- escape =## applies for all non-display characters and literal "="
		- space or tab at end of line must be encoded
		- \r\n newlines can be preserved, but bare \r and \n must be escaped
		- lines must not exceed 76 characters, use soft breaks =\r\n
	
	TODO: Some files from word appear to write line extensions with bare equals:
	
	```
	<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
	="70%"
	```
	*/
	function write_quoted_printable(text) {
		var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
			var w = c.charCodeAt(0).toString(16).toUpperCase();
			return "=" + (w.length == 1 ? "0" + w : w);
		});
	
		encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
	
		if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
		encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
	
		var o = [], split = encoded.split("\r\n");
		for(var si = 0; si < split.length; ++si) {
			var str = split[si];
			if(str.length == 0) { o.push(""); continue; }
			for(var i = 0; i < str.length;) {
				var end = 76;
				var tmp = str.slice(i, i + end);
				if(tmp.charAt(end - 1) == "=") end --;
				else if(tmp.charAt(end - 2) == "=") end -= 2;
				else if(tmp.charAt(end - 3) == "=") end -= 3;
				tmp = str.slice(i, i + end);
				i += end;
				if(i < str.length) tmp += "=";
				o.push(tmp);
			}
		}
	
		return o.join("\r\n");
	}
	function parse_quoted_printable(data) {
		var o = [];
	
		/* unify long lines */
		for(var di = 0; di < data.length; ++di) {
			var line = data[di];
			while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
			o.push(line);
		}
	
		/* decode */
		for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
		return s2a(o.join("\r\n"));
	}
	
	
	function parse_mime(cfb, data, root) {
		var fname = "", cte = "", ctype = "", fdata;
		var di = 0;
		for(;di < 10; ++di) {
			var line = data[di];
			if(!line || line.match(/^\s*$/)) break;
			var m = line.match(/^(.*?):\s*([^\s].*)$/);
			if(m) switch(m[1].toLowerCase()) {
				case "content-location": fname = m[2].trim(); break;
				case "content-type": ctype = m[2].trim(); break;
				case "content-transfer-encoding": cte = m[2].trim(); break;
			}
		}
		++di;
		switch(cte.toLowerCase()) {
			case 'base64': fdata = s2a(Base64_decode(data.slice(di).join(""))); break;
			case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
			default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
		}
		var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
		if(ctype) file.ctype = ctype;
	}
	
	function parse_mad(file, options) {
		if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
		var root = (options && options.root || "");
		// $FlowIgnore
		var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
		var di = 0, row = "";
	
		/* if root is not specified, scan for the common prefix */
		for(di = 0; di < data.length; ++di) {
			row = data[di];
			if(!/^Content-Location:/i.test(row)) continue;
			row = row.slice(row.indexOf("file"));
			if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
			if(row.slice(0, root.length) == root) continue;
			while(root.length > 0) {
				root = root.slice(0, root.length - 1);
				root = root.slice(0, root.lastIndexOf("/") + 1);
				if(row.slice(0,root.length) == root) break;
			}
		}
	
		var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
		if(!mboundary) throw new Error("MAD cannot find boundary");
		var boundary = "--" + (mboundary[1] || "");
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o);
		var start_di, fcnt = 0;
		for(di = 0; di < data.length; ++di) {
			var line = data[di];
			if(line !== boundary && line !== boundary + "--") continue;
			if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
			start_di = di;
		}
		return o;
	}
	
	function write_mad(cfb, options) {
		var opts = options || {};
		var boundary = opts.boundary || "SheetJS";
		boundary = '------=' + boundary;
	
		var out = [
			'MIME-Version: 1.0',
			'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
			'',
			'',
			''
		];
	
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		for(var i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length);
			fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
	
			/* Normalize filename */
			fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
				return "_x" + c.charCodeAt(0).toString(16) + "_";
			}).replace(/[\u0080-\uFFFF]/g, function(u) {
				return "_u" + u.charCodeAt(0).toString(16) + "_";
			});
	
			/* Extract content as binary string */
			var ca = fi.content;
			// $FlowIgnore
			var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
	
			/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
			var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
			for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
			var qp = dispcnt >= L * 4 / 5;
	
			out.push(boundary);
			out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
			out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
			out.push('Content-Type: ' + get_content_type(fi, fp));
			out.push('');
	
			out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
		}
		out.push(boundary + '--\r\n');
		return out.join("\r\n");
	}
	function cfb_new(opts) {
		var o = ({});
		init_cfb(o, opts);
		return o;
	}
	
	function cfb_add(cfb, name, content, opts) {
		var unsafe = opts && opts.unsafe;
		if(!unsafe) init_cfb(cfb);
		var file = !unsafe && CFB.find(cfb, name);
		if(!file) {
			var fpath = cfb.FullPaths[0];
			if(name.slice(0, fpath.length) == fpath) fpath = name;
			else {
				if(fpath.slice(-1) != "/") fpath += "/";
				fpath = (fpath + name).replace("//","/");
			}
			file = ({name: filename(name), type: 2});
			cfb.FileIndex.push(file);
			cfb.FullPaths.push(fpath);
			if(!unsafe) CFB.utils.cfb_gc(cfb);
		}
	file.content = (content);
		file.size = content ? content.length : 0;
		if(opts) {
			if(opts.CLSID) file.clsid = opts.CLSID;
			if(opts.mt) file.mt = opts.mt;
			if(opts.ct) file.ct = opts.ct;
		}
		return file;
	}
	
	function cfb_del(cfb, name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex.splice(j, 1);
			cfb.FullPaths.splice(j, 1);
			return true;
		}
		return false;
	}
	
	function cfb_mov(cfb, old_name, new_name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, old_name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex[j].name = filename(new_name);
			cfb.FullPaths[j] = new_name;
			return true;
		}
		return false;
	}
	
	function cfb_gc(cfb) { rebuild_cfb(cfb, true); }
	
	exports.find = find;
	exports.read = read;
	exports.parse = parse;
	exports.write = write;
	exports.writeFile = write_file;
	exports.utils = {
		cfb_new: cfb_new,
		cfb_add: cfb_add,
		cfb_del: cfb_del,
		cfb_mov: cfb_mov,
		cfb_gc: cfb_gc,
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		use_zlib: use_zlib,
		_deflateRaw: _deflate,
		_inflateRaw: _inflate,
		consts: consts
	};
	
	return exports;
	})();
	
	var _fs;
	if(true) try { _fs = __webpack_require__(491); } catch(e) {}
	
	/* normalize data for blob ctor */
	function blobify(data) {
		if(typeof data === "string") return s2ab(data);
		if(Array.isArray(data)) return a2u(data);
		return data;
	}
	/* write or download file */
	function write_dl(fname, payload, enc) {
		/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
		if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
		if(typeof Deno !== 'undefined') {
			/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */
			if(enc && typeof payload == "string") switch(enc) {
				case "utf8": payload = new TextEncoder(enc).encode(payload); break;
				case "binary": payload = s2ab(payload); break;
				/* TODO: binary equivalent */
				default: throw new Error("Unsupported encoding " + enc);
			}
			return Deno.writeFileSync(fname, payload);
		}
		var data = (enc == "utf8") ? utf8write(payload) : payload;
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
		if(typeof Blob !== 'undefined') {
			var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
	if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
	if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
			if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
				var url = URL.createObjectURL(blob);
	if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
				}
				var a = document.createElement("a");
				if(a.download != null) {
	a.download = fname; a.href = url; document.body.appendChild(a); a.click();
	document.body.removeChild(a);
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return url;
				}
			}
		}
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var out = File(fname); out.open("w"); out.encoding = "binary";
			if(Array.isArray(payload)) payload = a2s(payload);
			out.write(payload); out.close(); return payload;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("cannot save file " + fname);
	}
	
	/* read binary data from file */
	function read_binary(path) {
		if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
		if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var infile = File(path); infile.open("r"); infile.encoding = "binary";
			var data = infile.read(); infile.close();
			return data;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("Cannot access file " + path);
	}
	function keys(o) {
		var ks = Object.keys(o), o2 = [];
		for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
		return o2;
	}
	
	function evert_key(obj, key) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
	function datenum(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1462*24*60*60*1000;
		var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
		return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
	}
	var refdate = new Date();
	var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	var refoffset = refdate.getTimezoneOffset();
	function numdate(v) {
		var out = new Date();
		out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
		if (out.getTimezoneOffset() !== refoffset) {
			out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
		}
		return out;
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].slice(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	
	var good_pd_date_1 = new Date('2017-02-19T19:06:09.000Z');
	var good_pd_date = isNaN(good_pd_date_1.getFullYear()) ? new Date('2/19/17') : good_pd_date_1;
	var good_pd = good_pd_date.getFullYear() == 2017;
	/* parses a date as a local date */
	function parseDate(str, fixdate) {
		var d = new Date(str);
		if(good_pd) {
	if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
			return d;
		}
		if(str instanceof Date) return str;
		if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
			var s = d.getFullYear();
			if(str.indexOf("" + s) > -1) return d;
			d.setFullYear(d.getFullYear() + 100); return d;
		}
		var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
		var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
		if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
		return out;
	}
	
	function cc2str(arr, debomit) {
		if(has_buf && Buffer.isBuffer(arr)) {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
				if(arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
			}
			return arr.toString("binary");
		}
	
		if(typeof TextDecoder !== "undefined") try {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
				if(arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
			}
			var rev = {
				"\u20ac": "\x80", "\u201a": "\x82", "\u0192": "\x83", "\u201e": "\x84",
				"\u2026": "\x85", "\u2020": "\x86", "\u2021": "\x87", "\u02c6": "\x88",
				"\u2030": "\x89", "\u0160": "\x8a", "\u2039": "\x8b", "\u0152": "\x8c",
				"\u017d": "\x8e", "\u2018": "\x91", "\u2019": "\x92", "\u201c": "\x93",
				"\u201d": "\x94", "\u2022": "\x95", "\u2013": "\x96", "\u2014": "\x97",
				"\u02dc": "\x98", "\u2122": "\x99", "\u0161": "\x9a", "\u203a": "\x9b",
				"\u0153": "\x9c", "\u017e": "\x9e", "\u0178": "\x9f"
			};
			if(Array.isArray(arr)) arr = new Uint8Array(arr);
			return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) { return rev[c] || c; });
		} catch(e) {}
	
		var o = [];
		for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
		return o.join("");
	}
	
	function dup(o) {
		if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
		if(typeof o != 'object' || o == null) return o;
		if(o instanceof Date) return new Date(o.getTime());
		var out = {};
		for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
		return out;
	}
	
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	
	/* TODO: stress test */
	function fuzzynum(s) {
		var v = Number(s);
		if(!isNaN(v)) return isFinite(v) ? v : NaN;
		if(!/\d/.test(s)) return v;
		var wt = 1;
		var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
		if(!isNaN(v = Number(ss))) return v / wt;
		ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
		if(!isNaN(v = Number(ss))) return v / wt;
		return v;
	}
	var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
	function fuzzydate(s) {
		var o = new Date(s), n = new Date(NaN);
		var y = o.getYear(), m = o.getMonth(), d = o.getDate();
		if(isNaN(d)) return n;
		var lower = s.toLowerCase();
		if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
			lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
			if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
		} else if(lower.match(/[a-z]/)) return n;
		if(y < 0 || y > 8099) return n;
		if((m > 0 || d > 1) && y != 101) return o;
		if(s.match(/[^-0-9:,\/\\]/)) return n;
		return o;
	}
	
	var split_regex = (function() {
		var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
		return function split_regex(str, re, def) {
			if(safe_split_regex || typeof re == "string") return str.split(re);
			var p = str.split(re), o = [p[0]];
			for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
			return o;
		};
	})();
	function getdatastr(data) {
		if(!data) return null;
		if(data.content && data.type) return cc2str(data.content, true);
		if(data.data) return debom(data.data);
		if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
		if(data.asBinary) return debom(data.asBinary());
		if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		return null;
	}
	
	function getdatabin(data) {
		if(!data) return null;
		if(data.data) return char_codes(data.data);
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
		if(data._data && data._data.getContent) {
			var o = data._data.getContent();
			if(typeof o == "string") return char_codes(o);
			return Array.prototype.slice.call(o);
		}
		if(data.content && data.type) return data.content;
		return null;
	}
	
	function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }
	
	/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
	/* OASIS does not comment on filename case sensitivity */
	function safegetzipfile(zip, file) {
		var k = zip.FullPaths || keys(zip.files);
		var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
		for(var i=0; i<k.length; ++i) {
			var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
			if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
		}
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	function getzipstr(zip, file, safe) {
		if(!safe) return getdatastr(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipstr(zip, file); } catch(e) { return null; }
	}
	
	function getzipbin(zip, file, safe) {
		if(!safe) return getdatabin(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipbin(zip, file); } catch(e) { return null; }
	}
	
	function zipentries(zip) {
		var k = zip.FullPaths || keys(zip.files), o = [];
		for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
		return o.sort();
	}
	
	function zip_add_file(zip, path, content) {
		if(zip.FullPaths) {
			if(typeof content == "string") {
				var res;
				if(has_buf) res = Buffer_from(content);
				/* TODO: investigate performance in Edge 13 */
				//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
				else res = utf8decode(content);
				return CFB.utils.cfb_add(zip, path, res);
			}
			CFB.utils.cfb_add(zip, path, content);
		}
		else zip.file(path, content);
	}
	
	function zip_new() { return CFB.utils.cfb_new(); }
	
	function zip_read(d, o) {
		switch(o.type) {
			case "base64": return CFB.read(d, { type: "base64" });
			case "binary": return CFB.read(d, { type: "binary" });
			case "buffer": case "array": return CFB.read(d, { type: "buffer" });
		}
		throw new Error("Unrecognized type " + o.type);
	}
	
	function resolve_path(path, base) {
		if(path.charAt(0) == "/") return path.slice(1);
		var result = base.split('/');
		if(base.slice(-1) != "/") result.pop(); // folder path
		var target = path.split('/');
		while (target.length !== 0) {
			var step = target.shift();
			if (step === '..') result.pop();
			else if (step !== '.') result.push(step);
		}
		return result.join('/');
	}
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
	var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
	var tagregex = XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root, skip_LC) {
		var z = ({});
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.slice(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.slice(0,c).trim();
			while(cc.charCodeAt(c+1) == 32) ++c;
			quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
			v = cc.slice(c+1+quot, cc.length-quot);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) {
				if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
				z[q] = v;
				if(!skip_LC) z[q.toLowerCase()] = v;
			}
			else {
				var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
				if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
				z[k] = v;
				if(!skip_LC) z[k.toLowerCase()] = v;
			}
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	//var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		/* 22.4.2.4 bstr (Basic String) */
		var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
		return function unescapexml(text) {
			var s = text + '', i = s.indexOf("<![CDATA[");
			if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
			var j = s.indexOf("]]>");
			return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
	}
	function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }
	
	var htmlcharegex = /[\u0000-\u001f]/g;
	function escapehtml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
	}
	
	function escapexlml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); }
	
	function parsexmlbool(value) {
		switch(value) {
			case 1: case true: case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	}
	
	function utf8readb(data) {
		var out = new_raw_buf(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	}
	
	function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); }
	
	var utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	var utf8read = has_buf && (utf8readc(utf8corpus) == utf8reada(utf8corpus) && utf8readc || utf8readb(utf8corpus) == utf8reada(utf8corpus) && utf8readb) || utf8reada;
	
	var utf8write = has_buf ? function(data) { return Buffer_from(data, 'utf8').toString("binary"); } : function(orig) {
		var out = [], i = 0, c = 0, d = 0;
		while(i < orig.length) {
			c = orig.charCodeAt(i++);
			switch(true) {
				case c < 128: out.push(String.fromCharCode(c)); break;
				case c < 2048:
					out.push(String.fromCharCode(192 + (c >> 6)));
					out.push(String.fromCharCode(128 + (c & 63)));
					break;
				case c >= 55296 && c < 57344:
					c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
					out.push(String.fromCharCode(240 + ((d >>18) & 7)));
					out.push(String.fromCharCode(144 + ((d >>12) & 63)));
					out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
					out.push(String.fromCharCode(128 + (d & 63)));
					break;
				default:
					out.push(String.fromCharCode(224 + (c >> 12)));
					out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
					out.push(String.fromCharCode(128 + (c & 63)));
			}
		}
		return out.join("");
	};
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = ({});
		return function matchtag(f,g) {
			var t = f+"|"+(g||"");
			if(mtcache[t]) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
		};
	})();
	
	var htmldecode = (function() {
		var entities = [
			['nbsp', ' '], ['middot', '·'],
			['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
		].map(function(x) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
		return function htmldecode(str) {
			var o = str
					// Remove new lines and spaces from start of content
					.replace(/^[\t\n\r ]+/, "")
					// Remove new lines and spaces from end of content
					.replace(/[\t\n\r ]+$/,"")
					// Added line which removes any white space characters after and before html tags
					.replace(/>\s+/g,">").replace(/\s+</g,"<")
					// Replace remaining new lines and spaces with space
					.replace(/[\t\n\r ]+/g, " ")
					// Replace <br> tags with new lines
					.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
					// Strip HTML elements
					.replace(/<[^>]*>/g,"");
			for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
			return o;
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
	function parseVector(data, opts) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		var res = [];
		if(matches.length != h.size) {
			if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
			return res;
		}
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			if(v) res.push({v:utf8read(v[2]), t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }
	
	function write_vt(s, xlsx) {
		switch(typeof s) {
			case 'string':
				var o = writextag('vt:lpwstr', escapexml(s));
				if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
				return o;
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		/* duktape */
		if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
		throw new Error("Bad input format: expected Buffer or string");
	}
	/* UOS uses CJK in tags */
	var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
	//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	
	var XMLNS = ({
		CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
		CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
		EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
		CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
		RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
		TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	});
	
	var XMLNS_main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	var XLMLNS = ({
		'o':    'urn:schemas-microsoft-com:office:office',
		'x':    'urn:schemas-microsoft-com:office:excel',
		'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
		'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
		'mv':   'http://macVmlSchemaUri',
		'v':    'urn:schemas-microsoft-com:vml',
		'html': 'http://www.w3.org/TR/REC-html40'
	});
	function read_double_le(b, idx) {
		var s = 1 - 2 * (b[idx + 7] >>> 7);
		var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
		var m = (b[idx+6]&0x0f);
		for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
		if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
		if(e == 0) e = -1022;
		else { e -= 1023; m += Math.pow(2,52); }
		return s * Math.pow(2, e - 52) * m;
	}
	
	function write_double_le(b, v, idx) {
		var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
		var av = bs ? (-v) : v;
		if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
		else if(av == 0) e = m = 0;
		else {
			e = Math.floor(Math.log(av) / Math.LN2);
			m = av * Math.pow(2, 52 - e);
			if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
			else { m -= Math.pow(2,52); e+=1023; }
		}
		for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
		b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
		b[idx + 7] = (e >> 4) | bs;
	}
	
	var ___toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
	var __toBuffer = has_buf ? function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);} : ___toBuffer;
	
	var ___utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
	var __utf16le = has_buf ? function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; } : ___utf16le;
	
	var ___hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
	var __hexlify = has_buf ? function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); } : ___hexlify;
	
	var ___utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var __utf8 = has_buf ? function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); } : ___utf8;
	
	var ___lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpstr = ___lpstr;
	
	var ___cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __cpstr = ___cpstr;
	
	var ___lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpwstr = ___lpwstr;
	
	var ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
	var __lpp4 = ___lpp4;
	
	var ___8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
	var __8lpp4 = ___8lpp4;
	
	var ___double = function(b, idx) { return read_double_le(b, idx);};
	var __double = ___double;
	
	var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	
	if(has_buf) {
		__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
		__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
		__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	}
	
	/* from js-xls */
	function cpdoit() {
		__utf16le = function(b,s,e) { return $cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
		__utf8 = function(b,s,e) { return $cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
		__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
		__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
		__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
	}
	if(typeof $cptable !== 'undefined') cpdoit();
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			case 'wstr':
				if(typeof $cptable !== 'undefined') o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
				else return ReadShift.call(this, size, 'dbcs');
				size = 2 * size; break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
			/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
			case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
			/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
			case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case '_wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i < size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'cpstr':
				if(typeof $cptable !== 'undefined') {
					o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
					break;
				}
			/* falls through */
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4: case -4:
				if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
			case 8: case -8:
				if(t === 'f') {
					if(size == 8) oR = __double(this, this.l);
					else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
					this.l += 8; return oR;
				} else size = 8;
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
	var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
	var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };
	
	function WriteShift(t, val, f) {
		var size = 0, i = 0;
		if(f === 'dbcs') {
	for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else if(f === 'sbcs') {
			if(typeof $cptable !== 'undefined' && current_ansi == 874) {
				/* TODO: use tables directly, don't encode */
	for(i = 0; i != val.length; ++i) {
					var cppayload = $cptable.utils.encode(current_ansi, val.charAt(i));
					this[this.l + i] = cppayload[0];
				}
			} else {
	val = val.replace(/[^\x00-\x7F]/g, "_");
	for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
			}
			size = val.length;
		} else if(f === 'hex') {
			for(; i < t; ++i) {
	this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
			} return this;
		} else if(f === 'utf16le') {
	var end = Math.min(this.l + t, this.length);
				for(i = 0; i < Math.min(val.length, t); ++i) {
					var cc = val.charCodeAt(i);
					this[this.l++] = (cc & 0xff);
					this[this.l++] = (cc >> 8);
				}
				while(this.l < end) this[this.l++] = 0;
				return this;
		} else  switch(t) {
			case  1: size = 1; this[this.l] = val&0xFF; break;
			case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
			case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
			case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
			case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; __writeInt32LE(this, val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		if(!data) return;
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		var L = data.length, RT = 0, tgt = 0;
		while(data.l < L) {
			RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = has_buf ? 256 : 2048;
		var newblk = function ba_newblk(sz) {
			var o = (new_buf(sz));
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			if(!curbuf) return;
			if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return bconcat(bufs);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };
	
		return ({ next:next, push:push, end:end, _bufs:bufs });
	}
	
	function write_record(ba, type, payload, length) {
		var t = +type, l;
		if(isNaN(t)) return; // TODO: throw something here?
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt, opts) {
		var out = dup(cell);
		if(tgt.s) {
			if(out.cRel) out.c += tgt.s.c;
			if(out.rRel) out.r += tgt.s.r;
		} else {
			if(out.cRel) out.c += tgt.c;
			if(out.rRel) out.r += tgt.r;
		}
		if(!opts || opts.biff < 12) {
			while(out.c >= 0x100) out.c -= 0x100;
			while(out.r >= 0x10000) out.r -= 0x10000;
		}
		return out;
	}
	
	function shift_range_xls(cell, range, opts) {
		var out = dup(cell);
		out.s = shift_cell_xls(out.s, range.s, opts);
		out.e = shift_cell_xls(out.e, range.s, opts);
		return out;
	}
	
	function encode_cell_xls(c, biff) {
		if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
		if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
		var s = encode_cell(c);
		if(!c.cRel && c.cRel != null) s = fix_col(s);
		if(!c.rRel && c.rRel != null) s = fix_row(s);
		return s;
	}
	
	function encode_range_xls(r, opts) {
		if(r.s.r == 0 && !r.s.rRel) {
			if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
				return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
			}
		}
		if(r.s.c == 0 && !r.s.cRel) {
			if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
				return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
			}
		}
		return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
	}
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function decode_cell(cstr) {
		var R = 0, C = 0;
		for(var i = 0; i < cstr.length; ++i) {
			var cc = cstr.charCodeAt(i);
			if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
			else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
		}
		return { c: C - 1, r:R - 1 };
	}
	//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function encode_cell(cell) {
		var col = cell.c + 1;
		var s="";
		for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
		return s + (cell.r + 1);
	}
	function decode_range(range) {
		var idx = range.indexOf(":");
		if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
		return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
	}
	function encode_range(cs,ce) {
		if(typeof ce === 'undefined' || typeof ce === 'number') {
	return encode_range(cs.s, cs.e);
		}
	if(typeof cs !== 'string') cs = encode_cell((cs));
		if(typeof ce !== 'string') ce = encode_cell((ce));
	return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
		++i;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		var q = (cell.t == 'd' && v instanceof Date);
		if(cell.z != null) try { return (cell.w = SSF_format(cell.z, q ? datenum(v) : v)); } catch(e) { }
		try { return (cell.w = SSF_format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v, o) {
		if(cell == null || cell.t == null || cell.t == 'z') return "";
		if(cell.w !== undefined) return cell.w;
		if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
		if(cell.t == "e") return BErr[cell.v] || cell.v;
		if(v == undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_workbook(sheet, opts) {
		var n = opts && opts.sheet ? opts.sheet : "Sheet1";
		var sheets = {}; sheets[n] = sheet;
		return { SheetNames: [n], Sheets: sheets };
	}
	
	function sheet_add_aoa(_ws, data, opts) {
		var o = opts || {};
		var dense = _ws ? Array.isArray(_ws) : o.dense;
		if(DENSE != null && dense == null) dense = DENSE;
		var ws = _ws || (dense ? ([]) : ({}));
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
			if(!ws["!ref"]) ws["!ref"] = "A1:A1";
		}
		var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.s.c = _range.s.c;
			range.s.r = _range.s.r;
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) range.e.r = _R = _range.e.r + 1;
		}
		for(var R = 0; R != data.length; ++R) {
			if(!data[R]) continue;
			if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
			for(var C = 0; C != data[R].length; ++C) {
				if(typeof data[R][C] === 'undefined') continue;
				var cell = ({v: data[R][C] });
				var __R = _R + R, __C = _C + C;
				if(range.s.r > __R) range.s.r = __R;
				if(range.s.c > __C) range.s.c = __C;
				if(range.e.r < __R) range.e.r = __R;
				if(range.e.c < __C) range.e.c = __C;
				if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
				else {
					if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
					if(cell.v === null) {
						if(cell.f) cell.t = 'n';
						else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
						else if(!o.sheetStubs) continue;
						else cell.t = 'z';
					}
					else if(typeof cell.v === 'number') cell.t = 'n';
					else if(typeof cell.v === 'boolean') cell.t = 'b';
					else if(cell.v instanceof Date) {
						cell.z = o.dateNF || table_fmt[14];
						if(o.cellDates) { cell.t = 'd'; cell.w = SSF_format(cell.z, datenum(cell.v)); }
						else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF_format(cell.z, cell.v); }
					}
					else cell.t = 's';
				}
				if(dense) {
					if(!ws[__R]) ws[__R] = [];
					if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
					ws[__R][__C] = cell;
				} else {
					var cell_ref = encode_cell(({c:__C,r:__R}));
					if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
					ws[cell_ref] = cell;
				}
			}
		}
		if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
		return ws;
	}
	function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }
	
	function parse_Int32LE(data) {
		return data.read_shift(4, 'i');
	}
	function write_UInt32LE(x, o) {
		if (!o) o = new_buf(4);
		o.write_shift(4, x);
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
		o.write_shift(4, data.length);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.91 */
	//function parse_LPWideString(data) {
	//	var cchCharacters = data.read_shift(2);
	//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
	//}
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	function write_StrRun(run, o) {
		if (!o) o = new_buf(4);
		o.write_shift(2, run.ich || 0);
		o.write_shift(2, run.ifnt || 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = ({ t: str, h: str });
		if ((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = [{ ich: 0, ifnt: 0 }];
		//if((flags & 2) !== 0) { /* fExtStr */
		//	/* TODO: phonetic string */
		//}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
		o.write_shift(1, 0);
		write_XLWideString(str.t, o);
		return _null ? o.slice(0, o.l) : o;
	}
	/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
	var parse_BrtCommentText = parse_RichStr;
	function write_BrtCommentText(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
		o.write_shift(1, 1);
		write_XLWideString(str.t, o);
		o.write_shift(4, 1);
		write_StrRun({ ich: 0, ifnt: 0 }, o);
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) << 16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c: col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if (o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* Short XLSB Cell does not include column */
	function parse_XLSBShortCell(data) {
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c:-1, iStyleRef: iStyleRef };
	}
	function write_XLSBShortCell(cell, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* [MS-XLSB] 2.5.21 */
	var parse_XLSBCodeName = parse_XLWideString;
	var write_XLSBCodeName = write_XLWideString;
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(127); }
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.165 */
	var parse_XLNameWideString = parse_XLWideString;
	//var write_XLNameWideString = write_XLWideString;
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l + 4);
		var fX100 = (b[0] & 1), fInt = (b[0] & 2);
		data.l += 4;
		var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
		return fX100 ? (RK / 100) : RK;
	}
	function write_RkNumber(data, o) {
		if (o == null) o = new_buf(4);
		var fX100 = 0, fInt = 0, d100 = data * 100;
		if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
		else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
		if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
		else throw new Error("unsupported RkNumber " + data); // TODO
	}
	
	
	/* [MS-XLSB] 2.5.117 RfX */
	function parse_RfX(data ) {
		var cell = ({ s: {}, e: {} });
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	function write_RfX(r, o) {
		if (!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.153 UncheckedRfX */
	var parse_UncheckedRfX = parse_RfX;
	var write_UncheckedRfX = write_RfX;
	
	/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
	//function parse_UncheckedSqRfX(data) {
	//	var cnt = data.read_shift(4);
	//	var out = [];
	//	for(var i = 0; i < cnt; ++i) {
	//		var rng = parse_UncheckedRfX(data);
	//		out.push(encode_range(rng));
	//	}
	//	return out.join(",");
	//}
	//function write_UncheckedSqRfX(sqrfx) {
	//	var parts = sqrfx.split(/\s*,\s*/);
	//	var o = new_buf(4); o.write_shift(4, parts.length);
	//	var out = [o];
	//	parts.forEach(function(rng) {
	//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
	//	});
	//	return bconcat(out);
	//}
	
	/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
	/* TODO: error checking, NaN and Infinity values are not valid Xnum */
	function parse_Xnum(data) {
		if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
		return data.read_shift(8, 'f');
	}
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }
	
	/* [MS-XLSB] 2.4.324 BrtColor */
	function parse_BrtColor(data) {
		var out = {};
		var d = data.read_shift(1);
	
		//var fValidRGB = d & 1;
		var xColorType = d >>> 1;
	
		var index = data.read_shift(1);
		var nTS = data.read_shift(2, 'i');
		var bR = data.read_shift(1);
		var bG = data.read_shift(1);
		var bB = data.read_shift(1);
		data.l++; //var bAlpha = data.read_shift(1);
	
		switch (xColorType) {
			case 0: out.auto = 1; break;
			case 1:
				out.index = index;
				var icv = XLSIcv[index];
				/* automatic pseudo index 81 */
				if (icv) out.rgb = rgb2Hex(icv);
				break;
			case 2:
				/* if(!fValidRGB) throw new Error("invalid"); */
				out.rgb = rgb2Hex([bR, bG, bB]);
				break;
			case 3: out.theme = index; break;
		}
		if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
	
		return out;
	}
	function write_BrtColor(color, o) {
		if (!o) o = new_buf(8);
		if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
		if (color.index != null) {
			o.write_shift(1, 0x02);
			o.write_shift(1, color.index);
		} else if (color.theme != null) {
			o.write_shift(1, 0x06);
			o.write_shift(1, color.theme);
		} else {
			o.write_shift(1, 0x05);
			o.write_shift(1, 0);
		}
		var nTS = color.tint || 0;
		if (nTS > 0) nTS *= 32767;
		else if (nTS < 0) nTS *= 32768;
		o.write_shift(2, nTS);
		if (!color.rgb || color.theme != null) {
			o.write_shift(2, 0);
			o.write_shift(1, 0);
			o.write_shift(1, 0);
		} else {
			var rgb = (color.rgb || 'FFFFFF');
			if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
			o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
			o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
			o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
			o.write_shift(1, 0xFF);
		}
		return o;
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			fBold: d & 0x01,
			fItalic: d & 0x02,
			fUnderline: d & 0x04,
			fStrikeout: d & 0x08,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	function write_FontFlags(font, o) {
		if (!o) o = new_buf(2);
		var grbit =
			(font.italic ? 0x02 : 0) |
			(font.strike ? 0x08 : 0) |
			(font.outline ? 0x10 : 0) |
			(font.shadow ? 0x20 : 0) |
			(font.condense ? 0x40 : 0) |
			(font.extend ? 0x80 : 0);
		o.write_shift(1, grbit);
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-OLEDS] 2.3.1 and 2.3.2 */
	function parse_ClipboardFormatOrString(o, w) {
		// $FlowIgnore
		var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
		var m = o.read_shift(4);
		switch (m) {
			case 0x00000000: return "";
			case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
		}
		if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
		o.l -= 4;
		return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
	}
	function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
	function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }
	
	/* [MS-OLEPS] 2.2 PropertyType */
	// Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
	//var VT_EMPTY    = 0x0000;
	//var VT_NULL     = 0x0001;
	var VT_I2       = 0x0002;
	var VT_I4       = 0x0003;
	//var VT_R4       = 0x0004;
	//var VT_R8       = 0x0005;
	//var VT_CY       = 0x0006;
	//var VT_DATE     = 0x0007;
	//var VT_BSTR     = 0x0008;
	//var VT_ERROR    = 0x000A;
	var VT_BOOL     = 0x000B;
	var VT_VARIANT  = 0x000C;
	//var VT_DECIMAL  = 0x000E;
	//var VT_I1       = 0x0010;
	//var VT_UI1      = 0x0011;
	//var VT_UI2      = 0x0012;
	var VT_UI4      = 0x0013;
	//var VT_I8       = 0x0014;
	//var VT_UI8      = 0x0015;
	//var VT_INT      = 0x0016;
	//var VT_UINT     = 0x0017;
	var VT_LPSTR    = 0x001E;
	//var VT_LPWSTR   = 0x001F;
	var VT_FILETIME = 0x0040;
	var VT_BLOB     = 0x0041;
	//var VT_STREAM   = 0x0042;
	//var VT_STORAGE  = 0x0043;
	//var VT_STREAMED_Object  = 0x0044;
	//var VT_STORED_Object    = 0x0045;
	//var VT_BLOB_Object      = 0x0046;
	var VT_CF       = 0x0047;
	//var VT_CLSID    = 0x0048;
	//var VT_VERSIONED_STREAM = 0x0049;
	var VT_VECTOR   = 0x1000;
	var VT_VECTOR_VARIANT = 0x100C;
	var VT_VECTOR_LPSTR   = 0x101E;
	//var VT_ARRAY    = 0x2000;
	
	var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
	var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
	var VT_CUSTOM   = [VT_STRING, VT_USTR];
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Category', t: VT_STRING },
	0x03: { n: 'PresentationFormat', t: VT_STRING },
	0x04: { n: 'ByteCount', t: VT_I4 },
	0x05: { n: 'LineCount', t: VT_I4 },
	0x06: { n: 'ParagraphCount', t: VT_I4 },
	0x07: { n: 'SlideCount', t: VT_I4 },
	0x08: { n: 'NoteCount', t: VT_I4 },
	0x09: { n: 'HiddenCount', t: VT_I4 },
	0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
	0x0b: { n: 'ScaleCrop', t: VT_BOOL },
	0x0c: { n: 'HeadingPairs', t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ },
	0x0d: { n: 'TitlesOfParts', t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ },
	0x0e: { n: 'Manager', t: VT_STRING },
	0x0f: { n: 'Company', t: VT_STRING },
	0x10: { n: 'LinksUpToDate', t: VT_BOOL },
	0x11: { n: 'CharacterCount', t: VT_I4 },
	0x13: { n: 'SharedDoc', t: VT_BOOL },
	0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
	0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
	0x18: { n: 'DigSig', t: VT_BLOB },
	0x1A: { n: 'ContentType', t: VT_STRING },
	0x1B: { n: 'ContentStatus', t: VT_STRING },
	0x1C: { n: 'Language', t: VT_STRING },
	0x1D: { n: 'Version', t: VT_STRING },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Title', t: VT_STRING },
	0x03: { n: 'Subject', t: VT_STRING },
	0x04: { n: 'Author', t: VT_STRING },
	0x05: { n: 'Keywords', t: VT_STRING },
	0x06: { n: 'Comments', t: VT_STRING },
	0x07: { n: 'Template', t: VT_STRING },
	0x08: { n: 'LastAuthor', t: VT_STRING },
	0x09: { n: 'RevNumber', t: VT_STRING },
	0x0A: { n: 'EditTime', t: VT_FILETIME },
	0x0B: { n: 'LastPrinted', t: VT_FILETIME },
	0x0C: { n: 'CreatedDate', t: VT_FILETIME },
	0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
	0x0E: { n: 'PageCount', t: VT_I4 },
	0x0F: { n: 'WordCount', t: VT_I4 },
	0x10: { n: 'CharCount', t: VT_I4 },
	0x11: { n: 'Thumbnail', t: VT_CF },
	0x12: { n: 'Application', t: VT_STRING },
	0x13: { n: 'DocSecurity', t: VT_I4 },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
	0x0001: "US", // United States
	0x0002: "CA", // Canada
	0x0003: "", // Latin America (except Brazil)
	0x0007: "RU", // Russia
	0x0014: "EG", // Egypt
	0x001E: "GR", // Greece
	0x001F: "NL", // Netherlands
	0x0020: "BE", // Belgium
	0x0021: "FR", // France
	0x0022: "ES", // Spain
	0x0024: "HU", // Hungary
	0x0027: "IT", // Italy
	0x0029: "CH", // Switzerland
	0x002B: "AT", // Austria
	0x002C: "GB", // United Kingdom
	0x002D: "DK", // Denmark
	0x002E: "SE", // Sweden
	0x002F: "NO", // Norway
	0x0030: "PL", // Poland
	0x0031: "DE", // Germany
	0x0034: "MX", // Mexico
	0x0037: "BR", // Brazil
	0x003d: "AU", // Australia
	0x0040: "NZ", // New Zealand
	0x0042: "TH", // Thailand
	0x0051: "JP", // Japan
	0x0052: "KR", // Korea
	0x0054: "VN", // Viet Nam
	0x0056: "CN", // China
	0x005A: "TR", // Turkey
	0x0069: "JS", // Ramastan
	0x00D5: "DZ", // Algeria
	0x00D8: "MA", // Morocco
	0x00DA: "LY", // Libya
	0x015F: "PT", // Portugal
	0x0162: "IS", // Iceland
	0x0166: "FI", // Finland
	0x01A4: "CZ", // Czech Republic
	0x0376: "TW", // Taiwan
	0x03C1: "LB", // Lebanon
	0x03C2: "JO", // Jordan
	0x03C3: "SY", // Syria
	0x03C4: "IQ", // Iraq
	0x03C5: "KW", // Kuwait
	0x03C6: "SA", // Saudi Arabia
	0x03CB: "AE", // United Arab Emirates
	0x03CC: "IL", // Israel
	0x03CE: "QA", // Qatar
	0x03D5: "IR", // Iran
	0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	/* [MS-XLSB] 2.5.75 Icv */
	var _XLSIcv =  rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Overridable Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Other entries to appease BIFF8/12 */
		0xFFFFFF, /* 0x40 icvForeground ?? */
		0x000000, /* 0x41 icvBackground ?? */
		0x000000, /* 0x42 icvFrame ?? */
		0x000000, /* 0x43 icv3D ?? */
		0x000000, /* 0x44 icv3DText ?? */
		0x000000, /* 0x45 icv3DHilite ?? */
		0x000000, /* 0x46 icv3DShadow ?? */
		0x000000, /* 0x47 icvHilite ?? */
		0x000000, /* 0x48 icvCtlText ?? */
		0x000000, /* 0x49 icvCtlScrl ?? */
		0x000000, /* 0x4A icvCtlInv ?? */
		0x000000, /* 0x4B icvCtlBody ?? */
		0x000000, /* 0x4C icvCtlFrame ?? */
		0x000000, /* 0x4D icvCtlFore ?? */
		0x000000, /* 0x4E icvCtlBack ?? */
		0x000000, /* 0x4F icvCtlNeutral */
		0x000000, /* 0x50 icvInfoBk ?? */
		0x000000 /* 0x51 icvInfoText ?? */
	]);
	var XLSIcv = dup(_XLSIcv);
	
	/* [MS-XLSB] 2.5.97.2 */
	var BErr = {
	0x00: "#NULL!",
	0x07: "#DIV/0!",
	0x0F: "#VALUE!",
	0x17: "#REF!",
	0x1D: "#NAME?",
	0x24: "#NUM!",
	0x2A: "#N/A",
	0x2B: "#GETTING_DATA",
	0xFF: "#WTF?"
	};
	//var RBErr = evert_num(BErr);
	var RBErr = {
		"#NULL!":        0x00,
		"#DIV/0!":       0x07,
		"#VALUE!":       0x0F,
		"#REF!":         0x17,
		"#NAME?":        0x1D,
		"#NUM!":         0x24,
		"#N/A":          0x2A,
		"#GETTING_DATA": 0x2B,
		"#WTF?":         0xFF
	};
	
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type/*{[string]:string}*/ = ({
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
		"application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
		"application/vnd.ms-excel.worksheet": "sheets",
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Chartsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
		"application/vnd.ms-excel.chartsheet": "charts",
	
		/* Macrosheet */
		"application/vnd.ms-excel.macrosheet+xml": "macros",
		"application/vnd.ms-excel.macrosheet": "macros",
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* Dialogsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
		"application/vnd.ms-excel.dialogsheet": "dialogs",
	
		/* Shared Strings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
		"application/vnd.ms-excel.sharedStrings": "strs",
	
		/* Styles */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
		"application/vnd.ms-excel.styles": "styles",
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
	
		/* Comments */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
		"application/vnd.ms-excel.comments": "comments",
		"application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
		"application/vnd.ms-excel.person+xml": "people",
	
		/* Metadata (Stock/Geography and Dynamic Array) */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
		"application/vnd.ms-excel.sheetMetadata": "metadata",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Chart Objects */
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	
		/* Chart Colors */
		"application/vnd.ms-office.chartcolorstyle+xml": "TODO",
	
		/* Chart Style */
		"application/vnd.ms-office.chartstyle+xml": "TODO",
	
		/* Chart Advanced */
		"application/vnd.ms-office.chartex+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "links",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Theme Override */
		"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "TODO",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		/* Image */
		"image/png": "TODO",
	
		"sheet": "js"
	});
	
	var CT_LIST = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			comments: { /* Comments */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
				xlsb: "application/vnd.ms-excel.comments"
			},
			sheets: { /* Worksheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			charts: { /* Chartsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
				xlsb: "application/vnd.ms-excel.chartsheet"
			},
			dialogs: { /* Dialogsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
				xlsb: "application/vnd.ms-excel.dialogsheet"
			},
			macros: { /* Macrosheet (Excel 4.0 Macros) */
				xlsx: "application/vnd.ms-excel.macrosheet+xml",
				xlsb: "application/vnd.ms-excel.macrosheet"
			},
			metadata: { /* Metadata (Stock/Geography and Dynamic Array) */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
				xlsb: "application/vnd.ms-excel.sheetMetadata"
			},
			styles: { /* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
	};
	
	function new_ct() {
		return ({
			workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
			rels:[], strs:[], comments:[], threadedcomments:[], links:[],
			coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
			calcchains:[], vba: [], drawings: [], metadata: [], people:[],
			TODO:[], xmlns: "" });
	}
	
	function parse_ct(data) {
		var ct = new_ct();
		if(!data || !data.match) return ct;
		var ctext = {};
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	function write_ct(ct, opts) {
		var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);
	
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = writextag('Types', null, {
			'xmlns': XMLNS.CT,
			'xmlns:xsd': XMLNS.xsd,
			'xmlns:xsi': XMLNS.xsi
		});
	
		o = o.concat([
			['xml', 'application/xml'],
			['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
			['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
			['data', 'application/vnd.openxmlformats-officedocument.model+data'],
			/* from test files */
			['bmp', 'image/bmp'],
			['png', 'image/png'],
			['gif', 'image/gif'],
			['emf', 'image/x-emf'],
			['wmf', 'image/x-wmf'],
			['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
			['tif', 'image/tiff'], ['tiff', 'image/tiff'],
			['pdf', 'application/pdf'],
			['rels', 'application/vnd.openxmlformats-package.relationships+xml']
		].map(function(x) {
			return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
		}));
	
		/* only write first instance */
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			}
		};
	
		/* book type-specific */
		var f2 = function(w) {
			(ct[w]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			});
		};
	
		/* standard type */
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
	
		f1('workbooks');
		f2('sheets');
		f2('charts');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		f3('vba');
		f3('comments');
		f3('threadedcomments');
		f3('drawings');
		f2('metadata');
		f3('people');
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3 Relationships */
	var RELS = ({
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
		VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
		XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
		XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
		XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
		CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
		CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
		CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
		CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
		EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
		CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
		SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
		STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
		THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
		CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
		CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
		CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
		WS: [
			"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
			"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
		],
		DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
		MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
		IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
		DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
		XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
		TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
		PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
		VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
	});
	
	
	/* 9.3.3 Representing Relationships */
	function get_rels_path(file) {
		var n = file.lastIndexOf("/");
		return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
	}
	
	function parse_rels(data, currentFilePath) {
		var rels = {"!id":{}};
		if (!data) return rels;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var hash = {};
	
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	
	/* TODO */
	function write_rels(rels) {
		var o = [XML_HEADER, writextag('Relationships', null, {
			//'xmlns:ns0': XMLNS.RELS,
			'xmlns': XMLNS.RELS
		})];
		keys(rels['!id']).forEach(function(rid) {
			o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	function add_rels(rels, rId, f, type, relobj, targetmode) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		if(!rels['!idx']) rels['!idx'] = 1;
		if(rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId){/* empty */}
		rels['!idx'] = rId + 1;
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(targetmode) relobj.TargetMode = targetmode;
		else if([RELS.HLINK, RELS.XPATH, RELS.XMISS].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
		return rId;
	}
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	function parse_manifest(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0], false);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: if(opts && opts.WTF) throw Rn;
		}
	}
	
	function write_manifest(manifest) {
		var o = [XML_HEADER];
		o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
		o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
		for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
		o.push('</manifest:manifest>');
		return o.join("");
	}
	
	/* Part 3 Section 6 Metadata Manifest File */
	function write_rdf_type(file, res, tag) {
		return [
			'  <rdf:Description rdf:about="' + file + '">\n',
			'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf_has(base, file) {
		return [
			'  <rdf:Description rdf:about="' + base + '">\n',
			'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf(rdf) {
		var o = [XML_HEADER];
		o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
		for(var i = 0; i != rdf.length; ++i) {
			o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
			o.push(write_rdf_has("",rdf[i][0]));
		}
		o.push(write_rdf_type("","Document", "pkg"));
		o.push('</rdf:RDF>');
		return o.join("");
	}
	/* TODO: pull properties */
	function write_meta_ods() {
		return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	}
	
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
		data = utf8read(data);
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
		}
	
		return p;
	}
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		g = escapexml(g);
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, _opts) {
		var opts = _opts || {};
		var o = [XML_HEADER, writextag('cp:coreProperties', null, {
			//'xmlns': XMLNS.CORE_PROPS,
			'xmlns:cp': XMLNS.CORE_PROPS,
			'xmlns:dc': XMLNS.dc,
			'xmlns:dcterms': XMLNS.dcterms,
			'xmlns:dcmitype': XMLNS.dcmitype,
			'xmlns:xsi': XMLNS.xsi
		})], p = {};
		if(!cp && !opts.Props) return o.join("");
	
		if(cp) {
			if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
			if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		}
	
		for(var i = 0; i != CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
			if(v === true) v = "1";
			else if(v === false) v = "0";
			else if(typeof v == "number") v = String(v);
			if(v != null) cp_doit(f[0], v, null, o, p);
		}
		if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	var PseudoPropsPairs = [
		"Worksheets",  "SheetNames",
		"NamedRanges", "DefinedNames",
		"Chartsheets", "ChartNames"
	];
	function load_props_pairs(HP, TOP, props, opts) {
		var v = [];
		if(typeof HP == "string") v = parseVector(HP, opts);
		else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
		var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
		var idx = 0, len = 0;
		if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
			len = +(v[i+1].v);
			switch(v[i].v) {
				case "Worksheets":
				case "工作表":
				case "Листы":
				case "أوراق العمل":
				case "ワークシート":
				case "גליונות עבודה":
				case "Arbeitsblätter":
				case "Çalışma Sayfaları":
				case "Feuilles de calcul":
				case "Fogli di lavoro":
				case "Folhas de cálculo":
				case "Planilhas":
				case "Regneark":
				case "Hojas de cálculo":
				case "Werkbladen":
					props.Worksheets = len;
					props.SheetNames = parts.slice(idx, idx + len);
					break;
	
				case "Named Ranges":
				case "Rangos con nombre":
				case "名前付き一覧":
				case "Benannte Bereiche":
				case "Navngivne områder":
					props.NamedRanges = len;
					props.DefinedNames = parts.slice(idx, idx + len);
					break;
	
				case "Charts":
				case "Diagramme":
					props.Chartsheets = len;
					props.ChartNames = parts.slice(idx, idx + len);
					break;
			}
			idx += len;
		}
	}
	
	function parse_ext_props(data, p, opts) {
		var q = {}; if(!p) p = {};
		data = utf8read(data);
	
		EXT_PROPS.forEach(function(f) {
			var xml = (data.match(matchtag(f[0]))||[])[1];
			switch(f[2]) {
				case "string": if(xml) p[f[1]] = unescapexml(xml); break;
				case "bool": p[f[1]] = xml === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
	
		return p;
	}
	
	function write_ext_props(cp) {
		var o = [], W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (writextag('Properties', null, {
			'xmlns': XMLNS.EXT_PROPS,
			'xmlns:vt': XMLNS.vt
		}));
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = escapexml(String(cp[f[1]])); break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name = "";
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties': break;
				case '<property': name = unescapexml(y.name); break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].slice(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text);
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = parseDate(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(type.slice(-1) == '/') break;
							if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.slice(0,2) === "</") {/* empty */
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	function write_cust_props(cp) {
		var o = [XML_HEADER, writextag('Properties', null, {
			'xmlns': XMLNS.CUST_PROPS,
			'xmlns:vt': XMLNS.vt
		})];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			o[o.length] = (writextag('property', write_vt(cp[k], true), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': escapexml(k)
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* Common Name -> XLML Name */
	var XLMLDocPropsMap = {
		Title: 'Title',
		Subject: 'Subject',
		Author: 'Author',
		Keywords: 'Keywords',
		Comments: 'Description',
		LastAuthor: 'LastAuthor',
		RevNumber: 'Revision',
		Application: 'AppName',
		/* TotalTime: 'TotalTime', */
		LastPrinted: 'LastPrinted',
		CreatedDate: 'Created',
		ModifiedDate: 'LastSaved',
		/* Pages */
		/* Words */
		/* Characters */
		Category: 'Category',
		/* PresentationFormat */
		Manager: 'Manager',
		Company: 'Company',
		/* Guid */
		/* HyperlinkBase */
		/* Bytes */
		/* Lines */
		/* Paragraphs */
		/* CharactersWithSpaces */
		AppVersion: 'Version',
	
		ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
		Identifier: 'Identifier', /* NOTE: missing from schema */
		Language: 'Language' /* NOTE: missing from schema */
	};
	var evert_XLMLDPM;
	
	function xlml_set_prop(Props, tag, val) {
		if(!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
		tag = evert_XLMLDPM[tag] || tag;
		Props[tag] = val;
	}
	
	function xlml_write_docprops(Props, opts) {
		var o = [];
		keys(XLMLDocPropsMap).map(function(m) {
			for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
			for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
			throw m;
		}).forEach(function(p) {
			if(Props[p[1]] == null) return;
			var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
			switch(p[2]) {
				case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
			}
			if(typeof m == 'number') m = String(m);
			else if(m === true || m === false) { m = m ? "1" : "0"; }
			else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
			o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
		});
		return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
	}
	function xlml_write_custprops(Props, Custprops) {
		var BLACKLIST = ["Worksheets","SheetNames"];
		var T = 'CustomDocumentProperties';
		var o = [];
		if(Props) keys(Props).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
			for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
			for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
			for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;
	
			var m = Props[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		if(Custprops) keys(Custprops).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
			if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
			var m = Custprops[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
	}
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	function write_FILETIME(time) {
		var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
		var t = date.getTime() / 1000 + 11644473600;
		var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
		l *= 1e7; h *= 1e7;
		var w = (l / Math.pow(2,32)) | 0;
		if(w > 0) { l = l % Math.pow(2,32); h += w; }
		var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var start = blob.l;
		var str = blob.read_shift(0, 'lpstr-cp');
		if(pad) while((blob.l - start) & 3) ++blob.l;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
	function parse_VtVecLpwstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) {
			var start = blob.l;
			ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
			if((blob.l - start) & 0x02) blob.l += 2;
		}
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
		return ret;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var start = blob.l;
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = ({});
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
			if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		blob.l += size;
		if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size + 3 - (o.Size - 1) % 4;
		return o;
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
			case 0x101E /*VT_VECTOR|VT_LPSTR*/:
			case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
				return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	function write_TypedPropertyValue(type, value) {
		var o = new_buf(4), p = new_buf(4);
		o.write_shift(4, type == 0x50 ? 0x1F : type);
		switch(type) {
			case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
			case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
			case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
			case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
			case 0x1F /*VT_LPWSTR*/:
			case 0x50 /*VT_STRING*/:
	p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				p.write_shift(4, value.length + 1);
				p.write_shift(0, value, "dbcs");
				while(p.l != p.length) p.write_shift(1, 0);
				break;
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
		}
		return bconcat([o, p]);
	}
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj = ({});
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		Props.sort(function(x,y) { return x[1] - y[1]; });
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 874:
					case 932:
					case 936:
					case 949:
					case 950:
					case 1250:
					case 1251:
					case 1253:
					case 1254:
					case 1255:
					case 1256:
					case 1257:
					case 1258:
					case 10000:
					case 1200:
					case 1201:
					case 1252:
					case 65000: case -536:
					case 65001: case -535:
						set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ]; //.concat(PseudoPropsPairs);
	function guess_property_type(val) {
		switch(typeof val) {
			case "boolean": return 0x0B;
			case "number": return ((val|0)==val) ? 0x03 : 0x05;
			case "string": return 0x1F;
			case "object": if(val instanceof Date) return 0x40; break;
		}
		return -1;
	}
	function write_PropertySet(entries, RE, PIDSI) {
		var hdr = new_buf(8), piao = [], prop = [];
		var sz = 8, i = 0;
	
		var pr = new_buf(8), pio = new_buf(8);
		pr.write_shift(4, 0x0002);
		pr.write_shift(4, 0x04B0);
		pio.write_shift(4, 0x0001);
		prop.push(pr); piao.push(pio);
		sz += 8 + pr.length;
	
		if(!RE) {
			pio = new_buf(8);
			pio.write_shift(4, 0);
			piao.unshift(pio);
	
			var bufs = [new_buf(4)];
			bufs[0].write_shift(4, entries.length);
			for(i = 0; i < entries.length; ++i) {
				var value = entries[i][0];
				pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				pr.write_shift(4, i+2);
				pr.write_shift(4, value.length + 1);
				pr.write_shift(0, value, "dbcs");
				while(pr.l != pr.length) pr.write_shift(1, 0);
				bufs.push(pr);
			}
			pr = bconcat(bufs);
			prop.unshift(pr);
			sz += 8 + pr.length;
		}
	
		for(i = 0; i < entries.length; ++i) {
			if(RE && !RE[entries[i][0]]) continue;
			if(XLSPSSkip.indexOf(entries[i][0]) > -1 || PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
			if(entries[i][1] == null) continue;
	
			var val = entries[i][1], idx = 0;
			if(RE) {
				idx = +RE[entries[i][0]];
				var pinfo = (PIDSI)[idx];
				if(pinfo.p == "version" && typeof val == "string") {
	var arr = val.split(".");
					val = ((+arr[0])<<16) + ((+arr[1])||0);
				}
				pr = write_TypedPropertyValue(pinfo.t, val);
			} else {
				var T = guess_property_type(val);
				if(T == -1) { T = 0x1F; val = String(val); }
				pr = write_TypedPropertyValue(T, val);
			}
			prop.push(pr);
	
			pio = new_buf(8);
			pio.write_shift(4, !RE ? 2+i : idx);
			piao.push(pio);
	
			sz += 8 + pr.length;
		}
	
		var w = 8 * (prop.length + 1);
		for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
		hdr.write_shift(4, sz);
		hdr.write_shift(4, prop.length);
		return bconcat([hdr].concat(piao).concat(prop));
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI, clsid) {
		var blob = file.content;
		if(!blob) return ({});
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
		blob.chk('feff', 'Byte Order: ');
	
		/*var vers = */blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		var CLSID = blob.read_shift(16);
		if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = ({ SystemIdentifier: SystemIdentifier });
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(Offset1 - blob.l == 2) blob.l += 2;
		if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
		var hdr = new_buf(entries2 ? 68 : 48);
		var bufs = [hdr];
		hdr.write_shift(2, 0xFFFE);
		hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
		hdr.write_shift(4, 0x32363237);
		hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
		hdr.write_shift(4, (entries2 ? 2 : 1));
		hdr.write_shift(16, clsid, "hex");
		hdr.write_shift(4, (entries2 ? 68 : 48));
		var ps0 = write_PropertySet(entries, RE, PIDSI);
		bufs.push(ps0);
	
		if(entries2) {
			var ps1 = write_PropertySet(entries2, null, null);
			hdr.write_shift(16, clsid2, "hex");
			hdr.write_shift(4, 68 + ps0.length);
			bufs.push(ps1);
		}
		return bconcat(bufs);
	}
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	function write_Bes(v, t, o) {
		if(!o) o = new_buf(2);
		o.write_shift(1, ((t == 'e') ? +v : +!!v));
		o.write_shift(1, ((t == 'e') ? 1 : 0));
		return o;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
		var encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(!opts || opts.biff == 8 ) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { encoding = 'dbcs-cont'; }
		} else if(opts.biff == 12) {
			encoding = 'wstr';
		}
		if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun = 0, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	function write_XLUnicodeRichExtendedString(xlstr) {
		var str = (xlstr.t||""), nfmts = 1;
	
		var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
		hdr.write_shift(2, str.length);
		hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
		if(nfmts > 1) hdr.write_shift(2, nfmts);
	
		var otext = new_buf(2 * str.length);
		otext.write_shift(2 * str.length, str, 'utf16le');
	
		var out = [hdr, otext];
	
		return bconcat(out);
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
			if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
		}
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
	}
	/* TODO: BIFF5 and lower, codepage awareness */
	function write_XLUnicodeString(str, opts, o) {
		if(!o) o = new_buf(3 + 2 * str.length);
		o.write_shift(2, str.length);
		o.write_shift(1, 1);
		o.write_shift(31, str, 'utf16le');
		return o;
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	function parse_ControlInfo(blob) {
		var flags = blob.read_shift(1);
		blob.l++;
		var accel = blob.read_shift(2);
		blob.l += 2;
		return [flags, accel];
	}
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	function parse_URLMoniker(blob) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	}
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	function parse_FileMoniker(blob) {
		var cAnti = blob.read_shift(2);
		var preamble = ""; while(cAnti-- > 0) preamble += "../";
		var ansiPath = blob.read_shift(0, 'lpstr-ansi');
		blob.l += 2; //var endServer = blob.read_shift(2);
		if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
		var sz = blob.read_shift(4);
		if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
		var bytes = blob.read_shift(4);
		if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
		var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
		return preamble + unicodePath;
	}
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	function parse_HyperlinkMoniker(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw new Error("Unsupported Moniker " + clsid);
		}
	}
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	function parse_HyperlinkString(blob) {
		var len = blob.read_shift(4);
		var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
		return o;
	}
	function write_HyperlinkString(str, o) {
		if(!o) o = new_buf(6 + str.length * 2);
		o.write_shift(4, 1 + str.length);
		for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
	function parse_Hyperlink(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
		blob.l = end;
		var target = targetFrameName||moniker||oleMoniker||"";
		if(target && Loc) target+="#"+Loc;
		if(!target) target = "#" + Loc;
		if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
		var out = ({Target:target});
		if(guid) out.guid = guid;
		if(fileTime) out.time = fileTime;
		if(displayName) out.Tooltip = displayName;
		return out;
	}
	function write_Hyperlink(hl) {
		var out = new_buf(512), i = 0;
		var Target = hl.Target;
		if(Target.slice(0,7) == "file://") Target = Target.slice(7);
		var hashidx = Target.indexOf("#");
		var F = hashidx > -1 ? 0x1f : 0x17;
		switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
		out.write_shift(4,2); out.write_shift(4, F);
		var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
		if(F == 0x1C) {
			Target = Target.slice(1);
			write_HyperlinkString(Target, out);
		} else if(F & 0x02) {
			data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
			out.write_shift(4, 2*(Pretarget.length + 1));
			for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
			out.write_shift(2, 0);
			if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
		} else {
			data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var P = 0;
			while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
			out.write_shift(2, P);
			out.write_shift(4, Target.length - 3 * P + 1);
			for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
			out.write_shift(1, 0);
			out.write_shift(2, 0xFFFF);
			out.write_shift(2, 0xDEAD);
			for(i = 0; i < 6; ++i) out.write_shift(4, 0);
		}
		return out.slice(0, out.l);
	}
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* [MS-XLS] 2.5.19 */
	function parse_XLSCell(blob) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return ({r:rw, c:col, ixfe:ixfe});
	}
	function write_XLSCell(R, C, ixfe, o) {
		if(!o) o = new_buf(6);
		o.write_shift(2, R);
		o.write_shift(2, C);
		o.write_shift(2, ixfe||0);
		return o;
	}
	
	/* [MS-XLS] 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* [MS-XLS] 2.5.344 */
	function parse_XTI(blob, length, opts) {
		var w = opts.biff > 8 ? 4 : 2;
		var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* [MS-XLS] 2.5.218 */
	function parse_RkRec(blob) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		return [ixfe, RK];
	}
	
	/* [MS-XLS] 2.5.1 */
	function parse_AddinUdf(blob, length, opts) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length, opts);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
		blob.l += cb;
		return udfName;
	}
	
	/* [MS-XLS] 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	function write_Ref8U(r, o) {
		if(!o) o = new_buf(8);
		o.write_shift(2, r.s.r);
		o.write_shift(2, r.e.r);
		o.write_shift(2, r.s.c);
		o.write_shift(2, r.e.c);
		return o;
	}
	
	/* [MS-XLS] 2.5.211 */
	function parse_RefU(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* [MS-XLS] 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* [MS-XLS] 2.5.143 */
	function parse_FtCmo(blob) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* [MS-XLS] 2.5.149 */
	function parse_FtNts(blob) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* [MS-XLS] 2.5.142 */
	function parse_FtCf(blob) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
	function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
	var FtTab = {
	0x00: parse_FtSkip,      /* FtEnd */
	0x04: parse_FtSkip,      /* FtMacro */
	0x05: parse_FtSkip,      /* FtButton */
	0x06: parse_FtSkip,      /* FtGmo */
	0x07: parse_FtCf,        /* FtCf */
	0x08: parse_FtSkip,      /* FtPioGrbit */
	0x09: parse_FtSkip,      /* FtPictFmla */
	0x0A: parse_FtSkip,      /* FtCbls */
	0x0B: parse_FtSkip,      /* FtRbo */
	0x0C: parse_FtSkip,      /* FtSbs */
	0x0D: parse_FtNts,       /* FtNts */
	0x0E: parse_FtSkip,      /* FtSbsFmla */
	0x0F: parse_FtSkip,      /* FtGboData */
	0x10: parse_FtSkip,      /* FtEdoData */
	0x11: parse_FtSkip,      /* FtRboData */
	0x12: parse_FtSkip,      /* FtCblsData */
	0x13: parse_FtSkip,      /* FtLbsData */
	0x14: parse_FtSkip,      /* FtCblsFmla */
	0x15: parse_FtCmo
	};
	function parse_FtArray(blob, length) {
		var tgt = blob.l + length;
		var fts = [];
		while(blob.l < tgt) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, tgt - blob.l));
			} catch(e) { blob.l = tgt; return fts; }
		}
		if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
		return fts;
	}
	
	/* --- 2.4 Records --- */
	
	/* [MS-XLS] 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {BIFFVer:0, dt:0};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0400: /* BIFF4 */
			case 0x0300: /* BIFF3 */
			case 0x0200: /* BIFF2 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
		}
	
		blob.read_shift(length);
		return o;
	}
	function write_BOF(wb, t, o) {
		var h = 0x0600, w = 16;
		switch(o.bookType) {
			case 'biff8': break;
			case 'biff5': h = 0x0500; w = 8; break;
			case 'biff4': h = 0x0004; w = 6; break;
			case 'biff3': h = 0x0003; w = 6; break;
			case 'biff2': h = 0x0002; w = 4; break;
			case 'xla': break;
			default: throw new Error("unsupported BIFF version");
		}
		var out = new_buf(w);
		out.write_shift(2, h);
		out.write_shift(2, t);
		if(w > 4) out.write_shift(2, 0x7262);
		if(w > 6) out.write_shift(2, 0x07CD);
		if(w > 8) {
			out.write_shift(2, 0xC009);
			out.write_shift(2, 0x0001);
			out.write_shift(2, 0x0706);
			out.write_shift(2, 0x0000);
		}
		return out;
	}
	
	
	/* [MS-XLS] 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		if((blob.read_shift(2))!==0x04b0){/* empty */}
		return 0x04b0;
	}
	
	
	/* [MS-XLS] 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString2(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	function write_WriteAccess(s, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(b8 ? 112 : 54);
		o.write_shift(opts.biff == 8 ? 2 : 1, 7);
		if(b8) o.write_shift(1, 0);
		o.write_shift(4, 0x33336853);
		o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
		while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
		return o;
	}
	
	/* [MS-XLS] 2.4.351 */
	function parse_WsBool(blob, length, opts) {
		var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
		return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
	}
	
	/* [MS-XLS] 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) & 0x03;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	function write_BoundSheet8(data, opts) {
		var w = (!opts || opts.biff >= 8 ? 2 : 1);
		var o = new_buf(8 + w * data.name.length);
		o.write_shift(4, data.pos);
		o.write_shift(1, data.hs || 0);
		o.write_shift(1, data.dt);
		o.write_shift(1, data.name.length);
		if(opts.biff >= 8) o.write_shift(1, 1);
		o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
		var out = o.slice(0, o.l);
		out.l = o.l; return out;
	}
	
	/* [MS-XLS] 2.4.265 TODO */
	function parse_SST(blob, length) {
		var end = blob.l + length;
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = ([]);
		for(var i = 0; i != ucnt && blob.l < end; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	function write_SST(sst, opts) {
		var header = new_buf(8);
		header.write_shift(4, sst.Count);
		header.write_shift(4, sst.Unique);
		var strs = [];
		for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
		var o = bconcat([header].concat(strs));
	o.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
		return o;
	}
	
	/* [MS-XLS] 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
	function parse_Row(blob) {
		var z = ({});
		z.r = blob.read_shift(2);
		z.c = blob.read_shift(2);
		z.cnt = blob.read_shift(2) - z.c;
		var miyRw = blob.read_shift(2);
		blob.l += 4; // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.l += 3; // reserved(8), ixfe(12), flags(4)
		if(flags & 0x07) z.level = flags & 0x07;
		// collapsed: flags & 0x10
		if(flags & 0x20) z.hidden = true;
		if(flags & 0x40) z.hpt = miyRw / 20;
		return z;
	}
	
	
	/* [MS-XLS] 2.4.125 */
	function parse_ForceFullCalculation(blob) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	
	
	
	/* [MS-XLS] 2.4.215 rt */
	function parse_RecalcId(blob) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* [MS-XLS] 2.4.87 */
	function parse_DefaultRowHeight(blob, length, opts) {
		var f = 0;
		if(!(opts && opts.biff == 2)) {
			f = blob.read_shift(2);
		}
		var miyRw = blob.read_shift(2);
		if((opts && opts.biff == 2)) {
			f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
		}
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* [MS-XLS] 2.4.345 TODO */
	function parse_Window1(blob) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	function write_Window1() {
		var o = new_buf(18);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0x7260);
		o.write_shift(2, 0x44c0);
		o.write_shift(2, 0x38);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 1);
		o.write_shift(2, 0x01f4);
		return o;
	}
	/* [MS-XLS] 2.4.346 TODO */
	function parse_Window2(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff < 5) return {};
		var f = blob.read_shift(2);
		return { RTL: f & 0x40 };
	}
	function write_Window2(view) {
		var o = new_buf(18), f = 0x6b6;
		if(view && view.RTL) f |= 0x40;
		o.write_shift(2, f);
		o.write_shift(4, 0);
		o.write_shift(4, 64);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.189 TODO */
	function parse_Pane(/*blob, length, opts*/) {
	}
	
	/* [MS-XLS] 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		var o = {
			dyHeight: blob.read_shift(2),
			fl: blob.read_shift(2)
		};
		switch((opts && opts.biff) || 8) {
			case 2: break;
			case 3: case 4: blob.l += 2; break;
			default: blob.l += 10; break;
		}
		o.name = parse_ShortXLUnicodeString(blob, 0, opts);
		return o;
	}
	function write_Font(data, opts) {
		var name = data.name || "Arial";
		var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
		var o = new_buf(w);
		o.write_shift(2, (data.sz || 12) * 20);
		o.write_shift(4, 0);
		o.write_shift(2, 400);
		o.write_shift(4, 0);
		o.write_shift(2, 0);
		o.write_shift(1, name.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
		return o;
	}
	
	/* [MS-XLS] 2.4.149 */
	function parse_LabelSst(blob) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	function write_LabelSst(R, C, v, os ) {
		var o = new_buf(10);
		write_XLSCell(R, C, os, o);
		o.write_shift(4, v);
		return o;
	}
	
	/* [MS-XLS] 2.4.148 */
	function parse_Label(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var target = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) blob.l++;
		var str = parse_XLUnicodeString(blob, target - blob.l, opts);
		cell.val = str;
		return cell;
	}
	function write_Label(R, C, v, os, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
		write_XLSCell(R, C, os, o);
		o.write_shift(2, v.length);
		if(b8) o.write_shift(1, 1);
		o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
		return o;
	}
	
	
	/* [MS-XLS] 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var numFmtId = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [numFmtId, fmtstr];
	}
	function write_Format(i, f, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
		o.write_shift(2, i);
		o.write_shift((b5 ? 1 : 2), f.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(out.l == null) out.l = out.length;
		return out;
	}
	var parse_BIFF2Format = parse_XLUnicodeString2;
	
	/* [MS-XLS] 2.4.90 */
	function parse_Dimensions(blob, length, opts) {
		var end = blob.l + length;
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var r = blob.read_shift(w), R = blob.read_shift(w);
		var c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l = end;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	function write_Dimensions(range, opts) {
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var o = new_buf(2*w + 6);
		o.write_shift(w, range.s.r);
		o.write_shift(w, range.e.r + 1);
		o.write_shift(2, range.s.c);
		o.write_shift(2, range.e.c + 1);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.220 */
	function parse_RK(blob) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* [MS-XLS] 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw new Error("MulRK read error");
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	/* [MS-XLS] 2.4.174 */
	function parse_MulBlank(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var ixfes = [];
		while(blob.l < target) ixfes.push(blob.read_shift(2));
		if(blob.l !== target) throw new Error("MulBlank read error");
		var lastcol = blob.read_shift(2);
		if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
		return {r:rw, c:col, C:lastcol, ixfe:ixfes};
	}
	
	/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
	function parse_CellStyleXF(blob, length, style, opts) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
	
		if(!opts.cellStyles) return o;
		o.alc = a & 0x07;
		o.fWrap = (a >> 3) & 0x01;
		o.alcV = (a >> 4) & 0x07;
		o.fJustLast = (a >> 7) & 0x01;
		o.trot = (a >> 8) & 0xFF;
		o.cIndent = (a >> 16) & 0x0F;
		o.fShrinkToFit = (a >> 20) & 0x01;
		o.iReadOrder = (a >> 22) & 0x02;
		o.fAtrNum = (a >> 26) & 0x01;
		o.fAtrFnt = (a >> 27) & 0x01;
		o.fAtrAlc = (a >> 28) & 0x01;
		o.fAtrBdr = (a >> 29) & 0x01;
		o.fAtrPat = (a >> 30) & 0x01;
		o.fAtrProt = (a >> 31) & 0x01;
	
		o.dgLeft = b & 0x0F;
		o.dgRight = (b >> 4) & 0x0F;
		o.dgTop = (b >> 8) & 0x0F;
		o.dgBottom = (b >> 12) & 0x0F;
		o.icvLeft = (b >> 16) & 0x7F;
		o.icvRight = (b >> 23) & 0x7F;
		o.grbitDiag = (b >> 30) & 0x03;
	
		o.icvTop = c & 0x7F;
		o.icvBottom = (c >> 7) & 0x7F;
		o.icvDiag = (c >> 14) & 0x7F;
		o.dgDiag = (c >> 21) & 0x0F;
	
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		o.fsxButton = (d >> 14) & 0x01;
		return o;
	}
	//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
	//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
	
	/* [MS-XLS] 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length, opts) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
		return o;
	}
	function write_XF(data, ixfeP, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? 16 : 20);
		o.write_shift(2, 0);
		if(data.style) {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, 0xFFF4);
		} else {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, (ixfeP<<4));
		}
		var f = 0;
		if(data.numFmtId > 0 && b5) f |= 0x0400;
		o.write_shift(4, f);
		o.write_shift(4, 0);
		if(!b5) o.write_shift(4, 0);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.134 */
	function parse_Guts(blob) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
		return out;
	}
	function write_Guts(guts) {
		var o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
		o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.24 */
	function parse_BoolErr(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2 || length == 9) ++blob.l;
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	function write_BoolErr(R, C, v, os, opts, t) {
		var o = new_buf(8);
		write_XLSCell(R, C, os, o);
		write_Bes(v, t, o);
		return o;
	}
	
	/* [MS-XLS] 2.4.180 Number */
	function parse_Number(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	function write_Number(R, C, v, os) {
		var o = new_buf(14);
		write_XLSCell(R, C, os, o);
		write_Xnum(v, o);
		return o;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* [MS-XLS] 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		opts.sbcch = cch;
		if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
		if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
		var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		/* TODO: 2.5.277 Virtual Path */
		var rgst = [];
		while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
		return [cch, ctab, virtPath, rgst];
	}
	
	/* [MS-XLS] 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = ({
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		});
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		if(typeof body === "string") o.Name = body;
		return o;
	}
	
	/* [MS-XLS] 2.4.150 TODO */
	var XLSLblBuiltIn = [
		"_xlnm.Consolidate_Area",
		"_xlnm.Auto_Open",
		"_xlnm.Auto_Close",
		"_xlnm.Extract",
		"_xlnm.Database",
		"_xlnm.Criteria",
		"_xlnm.Print_Area",
		"_xlnm.Print_Titles",
		"_xlnm.Recorder",
		"_xlnm.Data_Form",
		"_xlnm.Auto_Activate",
		"_xlnm.Auto_Deactivate",
		"_xlnm.Sheet_Title",
		"_xlnm._FilterDatabase"
	];
	function parse_Lbl(blob, length, opts) {
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var itab = 0;
		if(!opts || opts.biff >= 5) {
			if(opts.biff != 5) blob.l += 2;
			itab = blob.read_shift(2);
			if(opts.biff == 5) blob.l += 2;
			blob.l += 4;
		}
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
		var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
		/*jshint -W018 */
		var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
		/*jshint +W018 */
		return {
			chKey: chKey,
			Name: name,
			itab: itab,
			rgce: rgce
		};
	}
	
	/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
		var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
		while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
			// [iSupBook, itabFirst, itabLast];
		if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
		return o;
	}
	function parse_BIFF5ExternSheet(blob, length, opts) {
		if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
		var o = parse_ShortXLUnicodeString(blob, length, opts);
		return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
	}
	
	/* [MS-XLS] 2.4.176 TODO: check older biff */
	function parse_NameCmt(blob, length, opts) {
		if(opts.biff < 8) { blob.l += length; return; }
		var cchName = blob.read_shift(2);
		var cchComment = blob.read_shift(2);
		var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
		var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
		return [name, comment];
	}
	
	/* [MS-XLS] 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
	}
	
	/* [MS-XLS] 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		/* TODO: fAlwaysCalc */
		switch(opts.biff) {
			case 2: blob.l ++; length -= 7; break;
			case 3: case 4: blob.l += 2; length -= 8; break;
			default: blob.l += 6; length -= 12;
		}
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* [MS-XLS] 2.4.173 */
	function parse_MTRSettings(blob) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* [MS-XLS] 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* [MS-XLS] 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* [MS-XLS] 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	function write_MergeCells(merges) {
		var o = new_buf(2 + merges.length * 8);
		o.write_shift(2, merges.length);
		for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
		return o;
	}
	
	/* [MS-XLS] 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length, opts) {
		if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	/* from older spec */
	var parse_BIFF5OT = {
	0x08: function(blob, length) {
		var tgt = blob.l + length;
		blob.l += 10; // todo
		var cf = blob.read_shift(2);
		blob.l += 4;
		blob.l += 2; //var cbPictFmla = blob.read_shift(2);
		blob.l += 2;
		blob.l += 2; //var grbit = blob.read_shift(2);
		blob.l += 4;
		var cchName = blob.read_shift(1);
		blob.l += cchName; // TODO: stName
		blob.l = tgt; // TODO: fmla
		return { fmt:cf };
	}
	};
	
	function parse_BIFF5Obj(blob, length, opts) {
		blob.l += 4; //var cnt = blob.read_shift(4);
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var grbit = blob.read_shift(2);
		blob.l += 2; //var colL = blob.read_shift(2);
		blob.l += 2; //var dxL = blob.read_shift(2);
		blob.l += 2; //var rwT = blob.read_shift(2);
		blob.l += 2; //var dyT = blob.read_shift(2);
		blob.l += 2; //var colR = blob.read_shift(2);
		blob.l += 2; //var dxR = blob.read_shift(2);
		blob.l += 2; //var rwB = blob.read_shift(2);
		blob.l += 2; //var dyB = blob.read_shift(2);
		blob.l += 2; //var cbMacro = blob.read_shift(2);
		blob.l += 6;
		length -= 36;
		var fts = [];
		fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
		return { cmo: [id, ot, grbit], ft:fts };
	}
	
	/* [MS-XLS] 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
		var texts = "";
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo; // eslint-disable-line no-unused-vars
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
		var cchText = blob.read_shift(2);
		/*var cbRuns = */blob.read_shift(2);
		/*var ifntEmpty = */parseuint16(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw new Error("cchText: " + cchText + " != " + texts.length);
		}
	
		blob.l = s + length;
		/* [MS-XLS] 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
	//	blob.l += 6;
	//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts }; }
	}
	
	/* [MS-XLS] 2.4.140 */
	function parse_HLink(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	}
	function write_HLink(hl) {
		var O = new_buf(24);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
		return bconcat([O, write_Hyperlink(hl[1])]);
	}
	
	
	/* [MS-XLS] 2.4.141 */
	function parse_HLinkTooltip(blob, length) {
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	}
	function write_HLinkTooltip(hl) {
		var TT = hl[1].Tooltip;
		var O = new_buf(10 + 2 * (TT.length + 1));
		O.write_shift(2, 0x0800);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
		O.write_shift(2, 0);
		return O;
	}
	
	/* [MS-XLS] 2.4.63 */
	function parse_Country(blob) {
		var o = [0,0], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	function write_Country(o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, 0x01);
		o.write_shift(2, 0x01);
		return o;
	}
	
	/* [MS-XLS] 2.4.50 ClrtClient */
	function parse_ClrtClient(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.188 */
	function parse_Palette(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.354 */
	function parse_XFCRC(blob) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	/* [MS-XLS] 2.4.53 TODO: parse flags */
	/* [MS-XLSB] 2.4.323 TODO: parse flags */
	function parse_ColInfo(blob, length, opts) {
		if(!opts.cellStyles) return parsenoop(blob, length);
		var w = opts && opts.biff >= 12 ? 4 : 2;
		var colFirst = blob.read_shift(w);
		var colLast = blob.read_shift(w);
		var coldx = blob.read_shift(w);
		var ixfe = blob.read_shift(w);
		var flags = blob.read_shift(2);
		if(w == 2) blob.l += 2;
		var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags});
		if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
		return o;
	}
	function write_ColInfo(col, idx) {
		var o = new_buf(12);
		o.write_shift(2, idx);
		o.write_shift(2, idx);
		o.write_shift(2, col.width * 256);
		o.write_shift(2, 0);
		var f = 0;
		if(col.hidden) f |= 1;
		o.write_shift(1, f);
		f = col.level || 0;
		o.write_shift(1, f);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.257 */
	function parse_Setup(blob, length) {
		var o = {};
		if(length < 32) return o;
		blob.l += 16;
		o.header = parse_Xnum(blob, 8);
		o.footer = parse_Xnum(blob, 8);
		blob.l += 2;
		return o;
	}
	
	/* [MS-XLS] 2.4.261 */
	function parse_ShtProps(blob, length, opts) {
		var def = {area:false};
		if(opts.biff != 5) { blob.l += length; return def; }
		var d = blob.read_shift(1); blob.l += 3;
		if((d & 0x10)) def.area = true;
		return def;
	}
	
	/* [MS-XLS] 2.4.241 */
	function write_RRTabId(n) {
		var out = new_buf(2 * n);
		for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
		return out;
	}
	
	var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
	var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_ImData(blob) {
		var cf = blob.read_shift(2);
		var env = blob.read_shift(2);
		var lcb = blob.read_shift(4);
		var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
		blob.l += lcb;
		return o;
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		if(opts.biffguess && opts.biff == 5) opts.biff = 2;
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2NUM(r, c, val) {
		var out = new_buf(15);
		write_BIFF2Cell(out, r, c);
		out.write_shift(8, val, 'f');
		return out;
	}
	
	function parse_BIFF2INT(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = blob.read_shift(2);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2INT(r, c, val) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		out.write_shift(2, val);
		return out;
	}
	
	function parse_BIFF2STRING(blob) {
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* TODO: convert to BIFF8 font struct */
	function parse_BIFF2FONTXTRA(blob, length) {
		blob.l += 6; // unknown
		blob.l += 2; // font weight "bls"
		blob.l += 1; // charset
		blob.l += 3; // unknown
		blob.l += 1; // font family
		blob.l += length - 13;
	}
	
	/* TODO: parse rich text runs */
	function parse_RString(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		var cch = blob.read_shift(2);
		var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
		blob.l = end;
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	/* from js-harb (C) 2014-present  SheetJS */
	var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
	var DBF = (function() {
	var dbf_codepage_map = {
		/* Code Pages Supported by Visual FoxPro */
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	
		/* shapefile DBF extension */
	0x00: 20127,           0x08:   865,
	0x09:   437,           0x0A:   850,
	0x0B:   437,           0x0D:   437,
	0x0E:   850,           0x0F:   437,
	0x10:   850,           0x11:   437,
	0x12:   850,           0x13:   932,
	0x14:   850,           0x15:   437,
	0x16:   850,           0x17:   865,
	0x18:   437,           0x19:   437,
	0x1A:   850,           0x1B:   437,
	0x1C:   863,           0x1D:   850,
	0x1F:   852,           0x22:   852,
	0x23:   852,           0x24:   860,
	0x25:   850,           0x26:   866,
	0x37:   850,           0x40:   852,
	0x4D:   936,           0x4E:   949,
	0x4F:   950,           0x50:   874,
	0x57:  1252,           0x58:  1252,
	0x59:  1252,           0x6C:   863,
	0x86:   737,           0x87:   852,
	0x88:   857,           0xCC:  1257,
	
	0xFF: 16969
	};
	var dbf_reverse_map = evert({
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	0x00: 20127
	});
	/* TODO: find an actual specification */
	function dbf_to_aoa(buf, opts) {
		var out = [];
		var d = (new_raw_buf(1));
		switch(opts.type) {
			case 'base64': d = s2a(Base64_decode(buf)); break;
			case 'binary': d = s2a(buf); break;
			case 'buffer':
			case 'array': d = buf; break;
		}
		prep_blob(d, 0);
	
		/* header */
		var ft = d.read_shift(1);
		var memo = !!(ft & 0x88);
		var vfp = false, l7 = false;
		switch(ft) {
			case 0x02: break; // dBASE II
			case 0x03: break; // dBASE III
			case 0x30: vfp = true; memo = true; break; // VFP
			case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
			// 0x43 dBASE IV SQL table files
			// 0x63 dBASE IV SQL system files
			case 0x83: break; // dBASE III with memo
			case 0x8B: break; // dBASE IV with memo
			case 0x8C: l7 = true; break; // dBASE Level 7 with memo
			// case 0xCB dBASE IV SQL table files with memo
			case 0xF5: break; // FoxPro 2.x with memo
			// case 0xFB FoxBASE
			default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
		}
	
		var nrow = 0, fpos = 0x0209;
		if(ft == 0x02) nrow = d.read_shift(2);
		d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
		if(ft != 0x02) nrow = d.read_shift(4);
		if(nrow > 1048576) nrow = 1e6;
	
		if(ft != 0x02) fpos = d.read_shift(2); // header length
		var rlen = d.read_shift(2); // record length
	
		var /*flags = 0,*/ current_cp = opts.codepage || 1252;
		if(ft != 0x02) { // 20 reserved bytes
			d.l+=16;
			/*flags = */d.read_shift(1);
			//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
	
			/* codepage present in FoxPro and dBASE Level 7 */
			if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
			d.l+=1;
	
			d.l+=2;
		}
		if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
	
	var fields = [], field = ({});
		var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
		var ww = l7 ? 32 : 11;
		while(d.l < hend && d[d.l] != 0x0d) {
			field = ({});
			field.name = $cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
			d.l += ww;
			field.type = String.fromCharCode(d.read_shift(1));
			if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
			field.len = d.read_shift(1);
			if(ft == 0x02) field.offset = d.read_shift(2);
			field.dec = d.read_shift(1);
			if(field.name.length) fields.push(field);
			if(ft != 0x02) d.l += l7 ? 13 : 14;
			switch(field.type) {
				case 'B': // Double (VFP) / Binary (dBASE L7)
					if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'G': // General (FoxPro and dBASE L7)
				case 'P': // Picture (FoxPro and dBASE L7)
					if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case '+': // Autoincrement (dBASE L7 only)
				case '0': // _NullFlags (VFP only)
				case '@': // Timestamp (dBASE L7 only)
				case 'C': // Character (dBASE II)
				case 'D': // Date (dBASE III)
				case 'F': // Float (dBASE IV)
				case 'I': // Long (VFP and dBASE L7)
				case 'L': // Logical (dBASE II)
				case 'M': // Memo (dBASE III)
				case 'N': // Number (dBASE II)
				case 'O': // Double (dBASE L7 only)
				case 'T': // Datetime (VFP only)
				case 'Y': // Currency (VFP only)
					break;
				default: throw new Error('Unknown Field Type: ' + field.type);
			}
		}
	
		if(d[d.l] !== 0x0D) d.l = fpos-1;
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	
		/* data */
		var R = 0, C = 0;
		out[0] = [];
		for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
		while(nrow-- > 0) {
			if(d[d.l] === 0x2A) {
				// TODO: record marked as deleted -- create a hidden row?
				d.l+=rlen;
				continue;
			}
			++d.l;
			out[++R] = []; C = 0;
			for(C = 0; C != fields.length; ++C) {
				var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
				prep_blob(dd, 0);
				var s = $cptable.utils.decode(current_cp, dd);
				switch(fields[C].type) {
					case 'C':
						// NOTE: it is conventional to write '  /  /  ' for empty dates
						if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
						break;
					case 'D':
						if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
						else out[R][C] = s;
						break;
					case 'F': out[R][C] = parseFloat(s.trim()); break;
					case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
					case 'L': switch(s.trim().toUpperCase()) {
						case 'Y': case 'T': out[R][C] = true; break;
						case 'N': case 'F': out[R][C] = false; break;
						case '': case '?': break;
						default: throw new Error("DBF Unrecognized L:|" + s + "|");
						} break;
					case 'M': /* TODO: handle memo files */
						if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
						out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
						break;
					case 'N':
						s = s.replace(/\u0000/g,"").trim();
						// NOTE: dBASE II interprets "  .  " as 0
						if(s && s != ".") out[R][C] = +s || 0; break;
					case '@':
						// NOTE: dBASE specs appear to be incorrect
						out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
						break;
					case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
					case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4 + (dd.read_shift(4, 'i')/1e4)*Math.pow(2,32); break;
					case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
					case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
						/* falls through */
					case 'G': case 'P': dd.l += fields[C].len; break;
					case '0':
						if(fields[C].name === '_NullFlags') break;
						/* falls through */
					default: throw new Error("DBF Unsupported data type " + fields[C].type);
				}
			}
		}
		if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
		if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
		opts.DBF = fields;
		return out;
	}
	
	function dbf_to_sheet(buf, opts) {
		var o = opts || {};
		if(!o.dateNF) o.dateNF = "yyyymmdd";
		var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
		ws["!cols"] = o.DBF.map(function(field) { return {
			wch: field.len,
			DBF: field
		};});
		delete o.DBF;
		return ws;
	}
	
	function dbf_to_workbook(buf, opts) {
		try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
		catch(e) { if(opts && opts.WTF) throw e; }
		return ({SheetNames:[],Sheets:{}});
	}
	
	var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
	function sheet_to_dbf(ws, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write DBF to JS string");
		var ba = buf_array();
		var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
		var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
		var i = 0, j = 0, hcnt = 0, rlen = 1;
		for(i = 0; i < headers.length; ++i) {
			if(((cols[i]||{}).DBF||{}).name) { headers[i] = cols[i].DBF.name; ++hcnt; continue; }
			if(headers[i] == null) continue;
			++hcnt;
			if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
			if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
			if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
				if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
		}
		var range = safe_decode_range(ws['!ref']);
		var coltypes = [];
		var colwidths = [];
		var coldecimals = [];
		for(i = 0; i <= range.e.c - range.s.c; ++i) {
			var guess = '', _guess = '', maxlen = 0;
			var col = [];
			for(j=0; j < data.length; ++j) {
				if(data[j][i] != null) col.push(data[j][i]);
			}
			if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
			for(j = 0; j < col.length; ++j) {
				switch(typeof col[j]) {
					/* TODO: check if L2 compat is desired */
					case 'number': _guess = 'B'; break;
					case 'string': _guess = 'C'; break;
					case 'boolean': _guess = 'L'; break;
					case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
					default: _guess = 'C';
				}
				maxlen = Math.max(maxlen, String(col[j]).length);
				guess = guess && guess != _guess ? 'C' : _guess;
				//if(guess == 'C') break;
			}
			if(maxlen > 250) maxlen = 250;
			_guess = ((cols[i]||{}).DBF||{}).type;
			/* TODO: more fine grained control over DBF type resolution */
			if(_guess == 'C') {
				if(cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
			}
			if(guess == 'B' && _guess == 'N') {
				guess = 'N';
				coldecimals[i] = cols[i].DBF.dec;
				maxlen = cols[i].DBF.len;
			}
			colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : (_RLEN[guess] || 0);
			rlen += colwidths[i];
			coltypes[i] = guess;
		}
	
		var h = ba.next(32);
		h.write_shift(4, 0x13021130);
		h.write_shift(4, data.length);
		h.write_shift(2, 296 + 32 * hcnt);
		h.write_shift(2, rlen);
		for(i=0; i < 4; ++i) h.write_shift(4, 0);
		h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[current_ansi] || 0x03)<<8));
	
		for(i = 0, j = 0; i < headers.length; ++i) {
			if(headers[i] == null) continue;
			var hf = ba.next(32);
			var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
			hf.write_shift(1, _f, "sbcs");
			hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
			hf.write_shift(4, j);
			hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
			hf.write_shift(1, coldecimals[i] || 0);
			hf.write_shift(1, 0x02);
			hf.write_shift(4, 0);
			hf.write_shift(1, 0);
			hf.write_shift(4, 0);
			hf.write_shift(4, 0);
			j += (colwidths[i] || _RLEN[coltypes[i]] || 0);
		}
	
		var hb = ba.next(264);
		hb.write_shift(4, 0x0000000D);
		for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
		for(i=0; i < data.length; ++i) {
			var rout = ba.next(rlen);
			rout.write_shift(1, 0);
			for(j=0; j<headers.length; ++j) {
				if(headers[j] == null) continue;
				switch(coltypes[j]) {
					case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
					case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
					case 'N':
						var _n = "0";
						if(typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j]||0);
						for(hcnt=0; hcnt < colwidths[j]-_n.length; ++hcnt) rout.write_shift(1, 0x20);
						rout.write_shift(1, _n, "sbcs");
						break;
					case 'D':
						if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
						else {
							rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
							rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
							rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
						} break;
					case 'C':
						var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
						rout.write_shift(1, _s, "sbcs");
						for(hcnt=0; hcnt < colwidths[j]-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
				}
			}
			// data
		}
		ba.next(1).write_shift(1, 0x1A);
		return ba.end();
	}
		return {
			to_workbook: dbf_to_workbook,
			to_sheet: dbf_to_sheet,
			from_sheet: sheet_to_dbf
		};
	})();
	
	var SYLK = (function() {
		/* TODO: stress test sequences */
		var sylk_escapes = ({
			AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
			AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
			AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
			AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
			AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
			Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
			Ae:'è', Be:'é', Ce:'ê',         He:'ë',
			Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
			Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
			Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
			KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
			DN:209, Dn:241, Hy:255,
			S:169,  c:170,  R:174,  "B ":180,
	0:176,    1:177,  2:178,
	3:179,    5:181,  6:182,
	7:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
			"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
			"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
		});
		var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
		var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
		var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
		sylk_escapes["|"] = 254;
		/* TODO: find an actual specification */
		function sylk_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return sylk_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return sylk_to_aoa_str(d, opts);
				case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return sylk_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function sylk_to_aoa_str(str, opts) {
			var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
			var formats = [];
			var next_cell_format = null;
			var sht = {}, rowinfo = [], colinfo = [], cw = [];
			var Mval = 0, j;
			if(+opts.codepage >= 0) set_cp(+opts.codepage);
			for (; ri !== records.length; ++ri) {
				Mval = 0;
				var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
				var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
				var RT=record[0], val;
				if(rstr.length > 0) switch(RT) {
				case 'ID': break; /* header */
				case 'E': break; /* EOF */
				case 'B': break; /* dimensions */
				case 'O': break; /* options? */
				case 'W': break; /* window? */
				case 'P':
					if(record[1].charAt(0) == 'P')
						formats.push(rstr.slice(3).replace(/;;/g, ";"));
					break;
				case 'C':
				var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'A': break; // TODO: comment
					case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'K':
						val = record[rj].slice(1);
						if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
						else if(val === 'TRUE') val = true;
						else if(val === 'FALSE') val = false;
						else if(!isNaN(fuzzynum(val))) {
							val = fuzzynum(val);
							if(next_cell_format !== null && fmt_is_date(next_cell_format)) val = numdate(val);
						} else if(!isNaN(fuzzydate(val).getDate())) {
							val = parseDate(val);
						}
						if(typeof $cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = $cptable.utils.decode(opts.codepage, val);
						C_seen_K = true;
						break;
					case 'E':
						C_seen_E = true;
						var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
						arr[R][C] = [arr[R][C], formula];
						break;
					case 'S':
						C_seen_S = true;
						arr[R][C] = [arr[R][C], "S5S"];
						break;
					case 'G': break; // unknown
					case 'R': _R = parseInt(record[rj].slice(1))-1; break;
					case 'C': _C = parseInt(record[rj].slice(1))-1; break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(C_seen_K) {
					if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
					else arr[R][C] = val;
					next_cell_format = null;
				}
				if(C_seen_S) {
					if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
					var shrbase = _R > -1 && arr[_R][_C];
					if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
					arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
				}
				break;
				case 'F':
				var F_seen = 0;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
					case 'F': break; /* ??? */
					case 'G': break; /* hide grid */
					case 'P':
						next_cell_format = formats[parseInt(record[rj].slice(1))];
						break;
					case 'S': break; /* cell style */
					case 'D': break; /* column */
					case 'N': break; /* font */
					case 'W':
						cw = record[rj].slice(1).split(" ");
						for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
							Mval = parseInt(cw[2], 10);
							colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
						} break;
					case 'C': /* default column format */
						C = parseInt(record[rj].slice(1))-1;
						if(!colinfo[C]) colinfo[C] = {};
						break;
					case 'R': /* row properties */
						R = parseInt(record[rj].slice(1))-1;
						if(!rowinfo[R]) rowinfo[R] = {};
						if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
						else if(Mval === 0) rowinfo[R].hidden = true;
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(F_seen < 1) next_cell_format = null; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
			}
			if(rowinfo.length > 0) sht['!rows'] = rowinfo;
			if(colinfo.length > 0) sht['!cols'] = colinfo;
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return [arr, sht];
		}
	
		function sylk_to_sheet(d, opts) {
			var aoasht = sylk_to_aoa(d, opts);
			var aoa = aoasht[0], ws = aoasht[1];
			var o = aoa_to_sheet(aoa, opts);
			keys(ws).forEach(function(k) { o[k] = ws[k]; });
			return o;
		}
	
		function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }
	
		function write_ws_cell_sylk(cell, ws, R, C) {
			var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
			switch(cell.t) {
				case 'n':
					o += (cell.v||0);
					if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
				case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
				case 'e': o += cell.w || cell.v; break;
				case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
				case 's': o += '"' + cell.v.replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
			}
			return o;
		}
	
		function write_ws_cols_sylk(out, cols) {
			cols.forEach(function(col, i) {
				var rec = "F;W" + (i+1) + " " + (i+1) + " ";
				if(col.hidden) rec += "0";
				else {
					if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
					if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
					if(typeof col.wch == 'number') rec += Math.round(col.wch);
				}
				if(rec.charAt(rec.length - 1) != " ") out.push(rec);
			});
		}
	
		function write_ws_rows_sylk(out, rows) {
			rows.forEach(function(row, i) {
				var rec = "F;";
				if(row.hidden) rec += "M0;";
				else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
				else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
				if(rec.length > 2) out.push(rec + "R" + (i+1));
			});
		}
	
		function sheet_to_sylk(ws, opts) {
			var preamble = ["ID;PWXL;N;E"], o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			var RS = "\r\n";
	
			preamble.push("P;PGeneral");
			preamble.push("F;P0;DG0G8;M255");
			if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
			if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
	
			preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
					o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
				}
			}
			return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
		}
	
		return {
			to_workbook: sylk_to_workbook,
			to_sheet: sylk_to_sheet,
			from_sheet: sheet_to_sylk
		};
	})();
	
	var DIF = (function() {
		function dif_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return dif_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return dif_to_aoa_str(d, opts);
				case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return dif_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function dif_to_aoa_str(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
				if (R < 0) continue;
				var metadata = records[ri].trim().split(",");
				var type = metadata[0], value = metadata[1];
				++ri;
				var data = records[ri] || "";
				while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
				data = data.trim();
				switch (+type) {
					case -1:
						if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
						else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
						break;
					case 0:
						if(data === 'TRUE') arr[R][C] = true;
						else if(data === 'FALSE') arr[R][C] = false;
						else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
						else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
						else arr[R][C] = value;
						++C; break;
					case 1:
						data = data.slice(1,data.length-1);
						data = data.replace(/""/g, '"');
						if(DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
						arr[R][C++] = data !== '' ? data : null;
						break;
				}
				if (data === 'EOD') break;
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
		function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }
	
		var sheet_to_dif = (function() {
			var push_field = function pf(o, topic, v, n, s) {
				o.push(topic);
				o.push(v + "," + n);
				o.push('"' + s.replace(/"/g,'""') + '"');
			};
			var push_value = function po(o, type, v, s) {
				o.push(type + "," + v);
				o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
			};
			return function sheet_to_dif(ws) {
				var o = [];
				var r = safe_decode_range(ws['!ref']), cell;
				var dense = Array.isArray(ws);
				push_field(o, "TABLE", 0, 1, "sheetjs");
				push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
				push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
				push_field(o, "DATA", 0, 0,"");
				for(var R = r.s.r; R <= r.e.r; ++R) {
					push_value(o, -1, 0, "BOT");
					for(var C = r.s.c; C <= r.e.c; ++C) {
						var coord = encode_cell({r:R,c:C});
						cell = dense ? (ws[R]||[])[C] : ws[coord];
						if(!cell) { push_value(o, 1, 0, ""); continue;}
						switch(cell.t) {
							case 'n':
								var val = DIF_XL ? cell.w : cell.v;
								if(!val && cell.v != null) val = cell.v;
								if(val == null) {
									if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
									else push_value(o, 1, 0, "");
								}
								else push_value(o, 0, val, "V");
								break;
							case 'b':
								push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
								break;
							case 's':
								push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
								break;
							case 'd':
								if(!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
								if(DIF_XL) push_value(o, 0, cell.w, "V");
								else push_value(o, 1, 0, cell.w);
								break;
							default: push_value(o, 1, 0, "");
						}
					}
				}
				push_value(o, -1, 0, "EOD");
				var RS = "\r\n";
				var oo = o.join(RS);
				//while((oo.length & 0x7F) != 0) oo += "\0";
				return oo;
			};
		})();
		return {
			to_workbook: dif_to_workbook,
			to_sheet: dif_to_sheet,
			from_sheet: sheet_to_dif
		};
	})();
	
	var ETH = (function() {
		function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
		function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }
	
		function eth_to_aoa(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				var record = records[ri].trim().split(":");
				if(record[0] !== 'cell') continue;
				var addr = decode_cell(record[1]);
				if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
				R = addr.r; C = addr.c;
				switch(record[2]) {
					case 't': arr[R][C] = decode(record[3]); break;
					case 'v': arr[R][C] = +record[3]; break;
					case 'vtf': var _f = record[record.length - 1];
						/* falls through */
					case 'vtc':
						switch(record[3]) {
							case 'nl': arr[R][C] = +record[4] ? true : false; break;
							default: arr[R][C] = +record[4]; break;
						}
						if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
				}
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
		function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }
	
		var header = [
			"socialcalc:version:1.5",
			"MIME-Version: 1.0",
			"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
		].join("\n");
	
		var sep = [
			"--SocialCalcSpreadsheetControlSave",
			"Content-type: text/plain; charset=UTF-8"
		].join("\n") + "\n";
	
		/* TODO: the other parts */
		var meta = [
			"# SocialCalc Spreadsheet Control Save",
			"part:sheet"
		].join("\n");
	
		var end = "--SocialCalcSpreadsheetControlSave--";
	
		function sheet_to_eth_data(ws) {
			if(!ws || !ws['!ref']) return "";
			var o = [], oo = [], cell, coord = "";
			var r = decode_range(ws['!ref']);
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null || cell.t === 'z') continue;
					oo = ["cell", coord, 't'];
					switch(cell.t) {
						case 's': case 'str': oo.push(encode(cell.v)); break;
						case 'n':
							if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
							else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
							break;
						case 'b':
							oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
							oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
							break;
						case 'd':
							var t = datenum(parseDate(cell.v));
							oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
							oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
							break;
						case 'e': continue;
					}
					o.push(oo.join(":"));
				}
			}
			o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
			o.push("valueformat:1:text-wiki");
			//o.push("copiedfrom:" + ws['!ref']); // clipboard only
			return o.join("\n");
		}
	
		function sheet_to_eth(ws) {
			return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
			// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
		}
	
		return {
			to_workbook: eth_to_workbook,
			to_sheet: eth_to_sheet,
			from_sheet: sheet_to_eth
		};
	})();
	
	var PRN = (function() {
		function set_text_arr(data, arr, R, C, o) {
			if(o.raw) arr[R][C] = data;
			else if(data === ""){/* empty */}
			else if(data === 'TRUE') arr[R][C] = true;
			else if(data === 'FALSE') arr[R][C] = false;
			else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
			else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
			else arr[R][C] = data;
		}
	
		function prn_to_aoa_str(f, opts) {
			var o = opts || {};
			var arr = ([]);
			if(!f || f.length === 0) return arr;
			var lines = f.split(/[\r\n]/);
			var L = lines.length - 1;
			while(L >= 0 && lines[L].length === 0) --L;
			var start = 10, idx = 0;
			var R = 0;
			for(; R <= L; ++R) {
				idx = lines[R].indexOf(" ");
				if(idx == -1) idx = lines[R].length; else idx++;
				start = Math.max(start, idx);
			}
			for(R = 0; R <= L; ++R) {
				arr[R] = [];
				/* TODO: confirm that widths are always 10 */
				var C = 0;
				set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
				for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
					set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
			}
			if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
			return arr;
		}
	
		// List of accepted CSV separators
		var guess_seps = {
	0x2C: ',',
	0x09: "\t",
	0x3B: ';',
	0x7C: '|'
		};
	
		// CSV separator weights to be used in case of equal numbers
		var guess_sep_weights = {
	0x2C: 3,
	0x09: 2,
	0x3B: 1,
	0x7C: 0
		};
	
		function guess_sep(str) {
			var cnt = {}, instr = false, end = 0, cc = 0;
			for(;end < str.length;++end) {
				if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
				else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
			}
	
			cc = [];
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
	
			if ( !cc.length ) {
				cnt = guess_sep_weights;
				for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
					cc.push([ cnt[end], end ]);
				}
			}
	
			cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });
	
			return guess_seps[cc.pop()[1]] || 0x2C;
		}
	
		function dsv_to_sheet_str(str, opts) {
			var o = opts || {};
			var sep = "";
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			if(str.slice(0,4) == "sep=") {
				// If the line ends in \r\n
				if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
					sep = str.charAt(4); str = str.slice(7);
				}
				// If line ends in \r OR \n
				else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
					sep = str.charAt(4); str = str.slice(6);
				}
				else sep = guess_sep(str.slice(0,1024));
			}
			else if(o && o.FS) sep = o.FS;
			else sep = guess_sep(str.slice(0,1024));
			var R = 0, C = 0, v = 0;
			var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
			str = str.replace(/\r\n/mg, "\n");
			var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
			function finish_cell() {
				var s = str.slice(start, end);
				var cell = ({});
				if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
				if(s.length === 0) cell.t = 'z';
				else if(o.raw) { cell.t = 's'; cell.v = s; }
				else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
				else if(s.charCodeAt(0) == 0x3D) {
					if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
					else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
					else { cell.t = 's'; cell.v = s; } }
				else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
				else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
				else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
				else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
					cell.z = o.dateNF || table_fmt[14];
					var k = 0;
					if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
					if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
					else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
					if(o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
					if(!o.cellNF) delete cell.z;
				} else {
					cell.t = 's';
					cell.v = s;
				}
				if(cell.t == 'z'){}
				else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
				else ws[encode_cell({c:C,r:R})] = cell;
				start = end+1; startcc = str.charCodeAt(start);
				if(range.e.c < C) range.e.c = C;
				if(range.e.r < R) range.e.r = R;
				if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
			}
			outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
				case 0x22: if(startcc === 0x22) instr = !instr; break;
				case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
				default: break;
			}
			if(end - start > 0) finish_cell();
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function prn_to_sheet_str(str, opts) {
			if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
			if(opts.FS) return dsv_to_sheet_str(str, opts);
			if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
			if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
			return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
		}
	
		function prn_to_sheet(d, opts) {
			var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
			switch(opts.type) {
				case 'base64': str = Base64_decode(d); break;
				case 'binary': str = d; break;
				case 'buffer':
					if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
					else if(opts.codepage && typeof $cptable !== 'undefined') str = $cptable.utils.decode(opts.codepage, d);
					else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
					break;
				case 'array': str = cc2str(d); break;
				case 'string': str = d; break;
				default: throw new Error("Unrecognized type " + opts.type);
			}
			if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
			else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
			else if((opts.type == 'binary') && typeof $cptable !== 'undefined' && opts.codepage)  str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591,str));
			if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
			return prn_to_sheet_str(str, opts);
		}
	
		function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }
	
		function sheet_to_prn(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				var oo = [];
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null) { oo.push("          "); continue; }
					var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
					while(w.length < 10) w += " ";
					oo.push(w + (C === 0 ? " " : ""));
				}
				o.push(oo.join(""));
			}
			return o.join("\n");
		}
	
		return {
			to_workbook: prn_to_workbook,
			to_sheet: prn_to_sheet,
			from_sheet: sheet_to_prn
		};
	})();
	
	/* Excel defaults to SYLK but warns if data is not valid */
	function read_wb_ID(d, opts) {
		var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
		try {
			var out = SYLK.to_workbook(d, o);
			o.WTF = OLD_WTF;
			return out;
		} catch(e) {
			o.WTF = OLD_WTF;
			if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
			return PRN.to_workbook(d, opts);
		}
	}
	
	var WK_ = (function() {
		function lotushopper(data, cb, opts) {
			if(!data) return;
			prep_blob(data, data.l || 0);
			var Enum = opts.Enum || WK1Enum;
			while(data.l < data.length) {
				var RT = data.read_shift(2);
				var R = Enum[RT] || Enum[0xFFFF];
				var length = data.read_shift(2);
				var tgt = data.l + length;
				var d = R.f && R.f(data, length, opts);
				data.l = tgt;
				if(cb(d, R, RT)) return;
			}
		}
	
		function lotus_to_workbook(d, opts) {
			switch(opts.type) {
				case 'base64': return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
				case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
				case 'buffer':
				case 'array': return lotus_to_workbook_buf(d, opts);
			}
			throw "Unsupported type " + opts.type;
		}
	
		function lotus_to_workbook_buf(d, opts) {
			if(!d) return d;
			var o = opts || {};
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var s = ((o.dense ? [] : {})), n = "Sheet1", next_n = "", sidx = 0;
			var sheets = {}, snames = [], realnames = [];
	
			var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
			var sheetRows = o.sheetRows || 0;
	
			if(d[2] == 0x00) {
				if(d[3] == 0x08 || d[3] == 0x09) {
					if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
				}
			}
	
			if(d[2] == 0x02) {
				o.Enum = WK1Enum;
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0x00: /* BOF */
						o.vers = val;
						if(val >= 0x1000) o.qpro = true;
						break;
					case 0x06: refguess = val; break; /* RANGE */
					case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
					case 0xDE: next_n = val; break; /* SHEETNAMELP */
					case 0x0F: /* LABEL */
					case 0x33: /* STRING */
						if(!o.qpro) val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x0D: /* INTEGER */
					case 0x0E: /* NUMBER */
					case 0x10: /* FORMULA */
						/* TODO: actual translation of the format code */
						if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
							val[1].z = o.dateNF || table_fmt[14];
							if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
						}
	
						if(o.qpro) {
							if(val[3] > sidx) {
								s["!ref"] = encode_range(refguess);
								sheets[n] = s;
								snames.push(n);
								s = (o.dense ? [] : {});
								refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
								sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
							}
						}
	
						var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
						if(tmpcell) {
							tmpcell.t = val[1].t; tmpcell.v = val[1].v;
							if(val[1].z != null) tmpcell.z = val[1].z;
							if(val[1].f != null) tmpcell.f = val[1].f;
							break;
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						break;
					default:
				}}, o);
			} else if(d[2] == 0x1A || d[2] == 0x0E) {
				o.Enum = WK3Enum;
				if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0xCC: n = val; break; /* SHEETNAMECS */
					case 0x16: /* LABEL16 */
						val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x17: /* NUMBER17 */
					case 0x18: /* NUMBER18 */
					case 0x19: /* FORMULA19 */
					case 0x25: /* NUMBER25 */
					case 0x27: /* NUMBER27 */
					case 0x28: /* FORMULA28 */
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = "Sheet" + (sidx + 1);
						}
						if(sheetRows > 0 && val[0].r >= sheetRows) break;
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
						if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
						break;
					case 0x1B: /* XFORMAT */
						if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
						break;
					case 0x0601: /* SHEETINFOQP */
						realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
					default: break;
				}}, o);
			} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
			s["!ref"] = encode_range(refguess);
			sheets[next_n || n] = s;
			snames.push(next_n || n);
			if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
			var osheets = {}, rnames = [];
			/* TODO: verify no collisions */
			for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
				rnames.push(realnames[i] || snames[i]);
				osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
			} else {
				rnames.push(realnames[i]);
				osheets[realnames[i]] = ({ "!ref": "A1" });
			}
			return { SheetNames: rnames, Sheets: osheets };
		}
	
		function sheet_to_wk1(ws, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
			var ba = buf_array();
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
	
			write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
			write_biff_rec(ba, 0x06, write_RANGE(range));
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: formula records */
					if(cell.t == "n") {
						if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
						else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
					} else {
						var str = format_cell(cell);
						write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
					}
				}
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
		function book_to_wk3(wb, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
			var ba = buf_array();
	
			write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
	
			for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
	
			var wsidx = 0;
			for(i = 0; i < wb.SheetNames.length; ++i) {
				var ws = wb.Sheets[wb.SheetNames[i]];
				if(!ws || !ws["!ref"]) continue;
				var range = safe_decode_range(ws["!ref"]);
				var dense = Array.isArray(ws);
				var cols = [];
				var max_R = Math.min(range.e.r, 8191);
				for(var R = range.s.r; R <= max_R; ++R) {
					var rr = encode_row(R);
					for(var C = range.s.c; C <= range.e.c; ++C) {
						if(R === range.s.r) cols[C] = encode_col(C);
						var ref = cols[C] + rr;
						var cell = dense ? (ws[R]||[])[C] : ws[ref];
						if(!cell || cell.t == "z") continue;
						/* TODO: FORMULA19 NUMBER18 records */
						if(cell.t == "n") {
							write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
						} else {
							var str = format_cell(cell);
							/* TODO: max len? */
							write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
						}
					}
				}
				++wsidx;
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
	
		function write_BOF_WK1(v) {
			var out = new_buf(2);
			out.write_shift(2, v);
			return out;
		}
	
		function write_BOF_WK3(wb) {
			var out = new_buf(26);
			out.write_shift(2, 0x1000);
			out.write_shift(2, 0x0004);
			out.write_shift(4, 0x0000);
			var rows = 0, cols = 0, wscnt = 0;
			for(var i = 0; i < wb.SheetNames.length; ++i) {
				var name = wb.SheetNames[i];
				var ws = wb.Sheets[name];
				if(!ws || !ws["!ref"]) continue;
				++wscnt;
				var range = decode_range(ws["!ref"]);
				if(rows < range.e.r) rows = range.e.r;
				if(cols < range.e.c) cols = range.e.c;
			}
			if(rows > 8191) rows = 8191;
			out.write_shift(2, rows);
			out.write_shift(1, wscnt);
			out.write_shift(1, cols);
			out.write_shift(2, 0x00);
			out.write_shift(2, 0x00);
			out.write_shift(1, 0x01);
			out.write_shift(1, 0x02);
			out.write_shift(4, 0);
			out.write_shift(4, 0);
			return out;
		}
	
		function parse_RANGE(blob, length, opts) {
			var o = {s:{c:0,r:0},e:{c:0,r:0}};
			if(length == 8 && opts.qpro) {
				o.s.c = blob.read_shift(1);
				blob.l++;
				o.s.r = blob.read_shift(2);
				o.e.c = blob.read_shift(1);
				blob.l++;
				o.e.r = blob.read_shift(2);
				return o;
			}
			o.s.c = blob.read_shift(2);
			o.s.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			o.e.c = blob.read_shift(2);
			o.e.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
			return o;
		}
		function write_RANGE(range) {
			var out = new_buf(8);
			out.write_shift(2, range.s.c);
			out.write_shift(2, range.s.r);
			out.write_shift(2, range.e.c);
			out.write_shift(2, range.e.r);
			return out;
		}
	
		function parse_cell(blob, length, opts) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
			if(opts.qpro && opts.vers != 0x5120) {
				o[0].c = blob.read_shift(1);
				o[3] = blob.read_shift(1);
				o[0].r = blob.read_shift(2);
				blob.l+=2;
			} else {
				o[2] = blob.read_shift(1);
				o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			}
			return o;
		}
	
		function parse_LABEL(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			o[1].t = 's';
			if(opts.vers == 0x5120) {
				blob.l++;
				var len = blob.read_shift(1);
				o[1].v = blob.read_shift(len, 'utf8');
				return o;
			}
			if(opts.qpro) blob.l++;
			o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
			return o;
		}
		function write_LABEL(R, C, s) {
			/* TODO: encoding */
			var o = new_buf(7 + s.length);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(1, 0x27); // ??
			for(var i = 0; i < o.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_INTEGER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(2, 'i');
			return o;
		}
		function write_INTEGER(R, C, v) {
			var o = new_buf(7);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(2, v, 'i');
			return o;
		}
	
		function parse_NUMBER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(8, 'f');
			return o;
		}
		function write_NUMBER(R, C, v) {
			var o = new_buf(13);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(8, v, 'f');
			return o;
		}
	
		function parse_FORMULA(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			/* TODO: formula */
			o[1].v = blob.read_shift(8, 'f');
			if(opts.qpro) blob.l = tgt;
			else {
				var flen = blob.read_shift(2);
				wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
				blob.l += flen;
			}
			return o;
		}
	
		function wk1_parse_rc(B, V, col) {
			var rel = V & 0x8000;
			V &= ~0x8000;
			V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
			return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
		}
		/* var oprec = [
			8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
			3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
		]; */
		/* TODO: flesh out */
		var FuncTab = {
			0x33: ["FALSE", 0],
			0x34: ["TRUE", 0],
			0x46: ["LEN", 1],
			0x50: ["SUM", 69],
			0x51: ["AVERAGEA", 69],
			0x52: ["COUNTA", 69],
			0x53: ["MINA", 69],
			0x54: ["MAXA", 69],
			0x6F: ["T", 1]
		};
		var BinOpTab = [
			  "",   "",   "",   "",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>", // eslint-disable-line no-mixed-spaces-and-tabs
			"<=", ">=",  "<",  ">",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			 "&",   "",   "",   "",   "",   "",   "",   ""  // eslint-disable-line no-mixed-spaces-and-tabs
		];
	
		function wk1_fmla_to_csf(blob, o) {
			prep_blob(blob, 0);
			var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
			while(blob.l < blob.length) {
				var cc = blob[blob.l++];
				switch(cc) {
					case 0x00: out.push(blob.read_shift(8, 'f')); break;
					case 0x01: {
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(C + R);
					} break;
					case 0x02: {
						var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(c + r + ":" + C + R);
					} break;
					case 0x03:
						if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
						break;
					case 0x04: out.push("(" + out.pop() + ")"); break;
					case 0x05: out.push(blob.read_shift(2)); break;
					case 0x06: {
						/* TODO: text encoding */
						var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
						out.push('"' + Z.replace(/"/g, '""') + '"');
					} break;
	
					case 0x08: out.push("-" + out.pop()); break;
					case 0x17: out.push("+" + out.pop()); break;
					case 0x16: out.push("NOT(" + out.pop() + ")"); break;
	
					case 0x14: case 0x15: {
						argR = out.pop(); argL = out.pop();
						out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
					} break;
	
					default:
						if(cc < 0x20 && BinOpTab[cc]) {
							argR = out.pop(); argL = out.pop();
							out.push(argL + BinOpTab[cc] + argR);
						} else if(FuncTab[cc]) {
							argc = FuncTab[cc][1];
							if(argc == 69) argc = blob[blob.l++];
							if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
							var args = out.slice(-argc);
							out.length -= argc;
							out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
						}
						else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
						else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
						// possible future functions ??
						else return console.error("WK1 unrecognized opcode " + cc.toString(16));
				}
			}
			if(out.length == 1) o[1].f = "" + out[0];
			else console.error("WK1 bad formula parse |" + out.join("|") + "|");
		}
	
	
		function parse_cell_3(blob) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
			return o;
		}
	
		function parse_LABEL_16(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].t = 's';
			o[1].v = blob.read_shift(length - 4, 'cstr');
			return o;
		}
		function write_LABEL_16(R, C, wsidx, s) {
			/* TODO: encoding */
			var o = new_buf(6 + s.length);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			o.write_shift(1, 0x27);
			for(var i = 0; i < s.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_NUMBER_18(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].v = blob.read_shift(2);
			var v = o[1].v >> 1;
			if(o[1].v & 0x1) {
				switch(v & 0x07) {
					case 0: v = (v >> 3) * 5000; break;
					case 1: v = (v >> 3) * 500; break;
					case 2: v = (v >> 3) / 20; break;
					case 3: v = (v >> 3) / 200; break;
					case 4: v = (v >> 3) / 2000; break;
					case 5: v = (v >> 3) / 20000; break;
					case 6: v = (v >> 3) / 16; break;
					case 7: v = (v >> 3) / 64; break;
				}
			}
			o[1].v = v;
			return o;
		}
	
		function parse_NUMBER_17(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			var v2 = blob.read_shift(4);
			var e = blob.read_shift(2);
			if(e == 0xFFFF) {
				if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
				else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
				else o[1].v = 0;
				return o;
			}
			var s = e & 0x8000; e = (e&0x7FFF) - 16446;
			o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
			return o;
		}
		function write_NUMBER_17(R, C, wsidx, v) {
			var o = new_buf(14);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			if(v == 0) {
				o.write_shift(4, 0);
				o.write_shift(4, 0);
				o.write_shift(2, 0xFFFF);
				return o;
			}
			var s = 0, e = 0, v1 = 0, v2 = 0;
			if(v < 0) { s = 1; v = -v; }
			e = Math.log2(v) | 0;
			v /= Math.pow(2, e-31);
			v2 = (v)>>>0;
			if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
			v -= v2;
			v2 |= 0x80000000;
			v2 >>>= 0;
			v *= Math.pow(2, 32);
			v1 = v>>>0;
			o.write_shift(4, v1);
			o.write_shift(4, v2);
			e += 0x3FFF + (s ? 0x8000 : 0);
			o.write_shift(2, e);
			return o;
		}
	
		function parse_FORMULA_19(blob, length) {
			var o = parse_NUMBER_17(blob, 14);
			blob.l += length - 14; /* TODO: WK3 formula */
			return o;
		}
	
		function parse_NUMBER_25(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			o[1].v = v1 >> 6;
			return o;
		}
	
		function parse_NUMBER_27(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(8,'f');
			o[1].v = v1;
			return o;
		}
	
		function parse_FORMULA_28(blob, length) {
			var o = parse_NUMBER_27(blob, 14);
			blob.l += length - 10; /* TODO: formula */
			return o;
		}
	
		function parse_SHEETNAMECS(blob, length) {
			return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
		}
	
		function parse_SHEETNAMELP(blob, length) {
			var len = blob[blob.l++];
			if(len > length - 1) len = length - 1;
			var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
			return o;
		}
	
		function parse_SHEETINFOQP(blob, length, opts) {
			if(!opts.qpro || length < 21) return;
			var id = blob.read_shift(1);
			blob.l += 17;
			blob.l += 1; //var len = blob.read_shift(1);
			blob.l += 2;
			var nm = blob.read_shift(length - 21, 'cstr');
			return [id, nm];
		}
	
		function parse_XFORMAT(blob, length) {
			var o = {}, tgt = blob.l + length;
			while(blob.l < tgt) {
				var dt = blob.read_shift(2);
				if(dt == 0x36b0) {
					o[dt] = [0, ""];
					o[dt][0] = blob.read_shift(2);
					while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
				}
				// TODO: 0x3a99 ??
			}
			return o;
		}
		function write_XFORMAT_SHEETNAME(name, wsidx) {
			var out = new_buf(5 + name.length);
			out.write_shift(2, 0x36b0);
			out.write_shift(2, wsidx);
			for(var i = 0; i < name.length; ++i) {
				var cc = name.charCodeAt(i);
				out[out.l++] = cc > 0x7F ? 0x5F : cc;
			}
			out[out.l++] = 0;
			return out;
		}
	
		var WK1Enum = {
	0x0000: { n:"BOF", f:parseuint16 },
	0x0001: { n:"EOF" },
	0x0002: { n:"CALCMODE" },
	0x0003: { n:"CALCORDER" },
	0x0004: { n:"SPLIT" },
	0x0005: { n:"SYNC" },
	0x0006: { n:"RANGE", f:parse_RANGE },
	0x0007: { n:"WINDOW1" },
	0x0008: { n:"COLW1" },
	0x0009: { n:"WINTWO" },
	0x000A: { n:"COLW2" },
	0x000B: { n:"NAME" },
	0x000C: { n:"BLANK" },
	0x000D: { n:"INTEGER", f:parse_INTEGER },
	0x000E: { n:"NUMBER", f:parse_NUMBER },
	0x000F: { n:"LABEL", f:parse_LABEL },
	0x0010: { n:"FORMULA", f:parse_FORMULA },
	0x0018: { n:"TABLE" },
	0x0019: { n:"ORANGE" },
	0x001A: { n:"PRANGE" },
	0x001B: { n:"SRANGE" },
	0x001C: { n:"FRANGE" },
	0x001D: { n:"KRANGE1" },
	0x0020: { n:"HRANGE" },
	0x0023: { n:"KRANGE2" },
	0x0024: { n:"PROTEC" },
	0x0025: { n:"FOOTER" },
	0x0026: { n:"HEADER" },
	0x0027: { n:"SETUP" },
	0x0028: { n:"MARGINS" },
	0x0029: { n:"LABELFMT" },
	0x002A: { n:"TITLES" },
	0x002B: { n:"SHEETJS" },
	0x002D: { n:"GRAPH" },
	0x002E: { n:"NGRAPH" },
	0x002F: { n:"CALCCOUNT" },
	0x0030: { n:"UNFORMATTED" },
	0x0031: { n:"CURSORW12" },
	0x0032: { n:"WINDOW" },
	0x0033: { n:"STRING", f:parse_LABEL },
	0x0037: { n:"PASSWORD" },
	0x0038: { n:"LOCKED" },
	0x003C: { n:"QUERY" },
	0x003D: { n:"QUERYNAME" },
	0x003E: { n:"PRINT" },
	0x003F: { n:"PRINTNAME" },
	0x0040: { n:"GRAPH2" },
	0x0041: { n:"GRAPHNAME" },
	0x0042: { n:"ZOOM" },
	0x0043: { n:"SYMSPLIT" },
	0x0044: { n:"NSROWS" },
	0x0045: { n:"NSCOLS" },
	0x0046: { n:"RULER" },
	0x0047: { n:"NNAME" },
	0x0048: { n:"ACOMM" },
	0x0049: { n:"AMACRO" },
	0x004A: { n:"PARSE" },
	0x0066: { n:"PRANGES??" },
	0x0067: { n:"RRANGES??" },
	0x0068: { n:"FNAME??" },
	0x0069: { n:"MRANGES??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00DE: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
	0xFFFF: { n:"" }
		};
	
		var WK3Enum = {
	0x0000: { n:"BOF" },
	0x0001: { n:"EOF" },
	0x0002: { n:"PASSWORD" },
	0x0003: { n:"CALCSET" },
	0x0004: { n:"WINDOWSET" },
	0x0005: { n:"SHEETCELLPTR" },
	0x0006: { n:"SHEETLAYOUT" },
	0x0007: { n:"COLUMNWIDTH" },
	0x0008: { n:"HIDDENCOLUMN" },
	0x0009: { n:"USERRANGE" },
	0x000A: { n:"SYSTEMRANGE" },
	0x000B: { n:"ZEROFORCE" },
	0x000C: { n:"SORTKEYDIR" },
	0x000D: { n:"FILESEAL" },
	0x000E: { n:"DATAFILLNUMS" },
	0x000F: { n:"PRINTMAIN" },
	0x0010: { n:"PRINTSTRING" },
	0x0011: { n:"GRAPHMAIN" },
	0x0012: { n:"GRAPHSTRING" },
	0x0013: { n:"??" },
	0x0014: { n:"ERRCELL" },
	0x0015: { n:"NACELL" },
	0x0016: { n:"LABEL16", f:parse_LABEL_16},
	0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
	0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
	0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
	0x001A: { n:"FORMULA1A" },
	0x001B: { n:"XFORMAT", f:parse_XFORMAT },
	0x001C: { n:"DTLABELMISC" },
	0x001D: { n:"DTLABELCELL" },
	0x001E: { n:"GRAPHWINDOW" },
	0x001F: { n:"CPA" },
	0x0020: { n:"LPLAUTO" },
	0x0021: { n:"QUERY" },
	0x0022: { n:"HIDDENSHEET" },
	0x0023: { n:"??" },
	0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
	0x0026: { n:"??" },
	0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
	0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
	0x008E: { n:"??" },
	0x0093: { n:"??" },
	0x0096: { n:"??" },
	0x0097: { n:"??" },
	0x0098: { n:"??" },
	0x0099: { n:"??" },
	0x009A: { n:"??" },
	0x009B: { n:"??" },
	0x009C: { n:"??" },
	0x00A3: { n:"??" },
	0x00AE: { n:"??" },
	0x00AF: { n:"??" },
	0x00B0: { n:"??" },
	0x00B1: { n:"??" },
	0x00B8: { n:"??" },
	0x00B9: { n:"??" },
	0x00BA: { n:"??" },
	0x00BB: { n:"??" },
	0x00BC: { n:"??" },
	0x00C3: { n:"??" },
	0x00C9: { n:"??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00CD: { n:"??" },
	0x00CE: { n:"??" },
	0x00CF: { n:"??" },
	0x00D0: { n:"??" },
	0x0100: { n:"??" },
	0x0103: { n:"??" },
	0x0104: { n:"??" },
	0x0105: { n:"??" },
	0x0106: { n:"??" },
	0x0107: { n:"??" },
	0x0109: { n:"??" },
	0x010A: { n:"??" },
	0x010B: { n:"??" },
	0x010C: { n:"??" },
	0x010E: { n:"??" },
	0x010F: { n:"??" },
	0x0180: { n:"??" },
	0x0185: { n:"??" },
	0x0186: { n:"??" },
	0x0189: { n:"??" },
	0x018C: { n:"??" },
	0x0200: { n:"??" },
	0x0202: { n:"??" },
	0x0201: { n:"??" },
	0x0204: { n:"??" },
	0x0205: { n:"??" },
	0x0280: { n:"??" },
	0x0281: { n:"??" },
	0x0282: { n:"??" },
	0x0283: { n:"??" },
	0x0284: { n:"??" },
	0x0285: { n:"??" },
	0x0286: { n:"??" },
	0x0287: { n:"??" },
	0x0288: { n:"??" },
	0x0292: { n:"??" },
	0x0293: { n:"??" },
	0x0294: { n:"??" },
	0x0295: { n:"??" },
	0x0296: { n:"??" },
	0x0299: { n:"??" },
	0x029A: { n:"??" },
	0x0300: { n:"??" },
	0x0304: { n:"??" },
	0x0601: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
	0x0640: { n:"??" },
	0x0642: { n:"??" },
	0x0701: { n:"??" },
	0x0702: { n:"??" },
	0x0703: { n:"??" },
	0x0704: { n:"??" },
	0x0780: { n:"??" },
	0x0800: { n:"??" },
	0x0801: { n:"??" },
	0x0804: { n:"??" },
	0x0A80: { n:"??" },
	0x2AF6: { n:"??" },
	0x3231: { n:"??" },
	0x6E49: { n:"??" },
	0x6F44: { n:"??" },
	0xFFFF: { n:"" }
		};
		return {
			sheet_to_wk1: sheet_to_wk1,
			book_to_wk3: book_to_wk3,
			to_workbook: lotus_to_workbook
		};
	})();
	/* 18.4.7 rPr CT_RPrElt */
	function parse_rpr(rpr) {
		var font = {}, m = rpr.match(tagregex), i = 0;
		var pass = false;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;
	
				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					font.cp = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;
	
				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;
	
				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;
	
				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;
	
				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;
				case '<color>': case '<color/>': case '</color>': break;
	
				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;
				case '<family>': case '<family/>': case '</family>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': font.valign = y.val; break;
				case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;
				case '<scheme>': case '<scheme/>': case '</scheme>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		return font;
	}
	
	var parse_rs = (function() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr");
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex)/*, cp = 65001*/;
			if(!t) return {t:"s", v:""};
	
			var o = ({t:'s', v:unescapexml(t[1])});
			var rpr = r.match(rpregex);
			if(rpr) o.s = parse_rpr(rpr[1]);
			return o;
		}
		var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
		};
	})();
	
	
	/* Parse a list of <r> tags */
	var rs_to_html = (function parse_rs_factory() {
		var nlregex = /(\r\n|\n)/g;
		function parse_rpr2(font, intro, outro) {
			var style = [];
	
			if(font.u) style.push("text-decoration: underline;");
			if(font.uval) style.push("text-underline-style:" + font.uval + ";");
			if(font.sz) style.push("font-size:" + font.sz + "pt;");
			if(font.outline) style.push("text-effect: outline;");
			if(font.shadow) style.push("text-shadow: auto;");
			intro.push('<span style="' + style.join("") + '">');
	
			if(font.b) { intro.push("<b>"); outro.push("</b>"); }
			if(font.i) { intro.push("<i>"); outro.push("</i>"); }
			if(font.strike) { intro.push("<s>"); outro.push("</s>"); }
	
			var align = font.valign || "";
			if(align == "superscript" || align == "super") align = "sup";
			else if(align == "subscript") align = "sub";
			if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }
	
			outro.push("</span>");
			return font;
		}
	
		/* 18.4.4 r CT_RElt */
		function r_to_html(r) {
			var terms = [[],r.v,[]];
			if(!r.v) return "";
	
			if(r.s) parse_rpr2(r.s, terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
	
		return function parse_rs(rs) {
			return rs.map(r_to_html).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
	var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return { t: "" };
		//var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		// TODO: is whitespace actually valid here?
		if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
			z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
			z.r = utf8read(x);
			if(html) z.h = escapehtml(z.t);
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((/*y = */x.match(sirregex))) {
			z.r = utf8read(x);
			z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
			if(html) z.h = rs_to_html(parse_rs(z.r));
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
	var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = ([]), ss = "";
		if(!data) return s;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(sst) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i].trim(), opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS_main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(!s.t) s.t = "";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.221 BrtBeginSst */
	function parse_BrtBeginSst(data) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = ([]);
		var pass = false;
		recordhopper(data, function hopper_sst(val, R, RT) {
			switch(RT) {
				case 0x009F: /* BrtBeginSst */
					s.Count = val[0]; s.Unique = val[1]; break;
				case 0x0013: /* BrtSSTItem */
					s.push(val); break;
				case 0x00A0: /* BrtEndSst */
					return true;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
	
				default:
					if(R.T){}
					if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst) {
		var ba = buf_array();
		write_record(ba, 0x009F /* BrtBeginSst */, write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, 0x0013 /* BrtSSTItem */, write_BrtSSTItem(sst[i]));
		/* FRTSST */
		write_record(ba, 0x00A0 /* BrtEndSst */);
		return ba.end();
	}
	function _JS2ANSI(str) {
		if(typeof $cptable !== 'undefined') return $cptable.utils.encode(current_ansi, str);
		var o = [], oo = str.split("");
		for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_CRYPTOVersion(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
	if(length >= 4) blob.l += length - 4;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
	function parse_DataSpaceVersionInfo(blob) {
		var o = {};
		o.id = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
	function parse_DataSpaceMapEntry(blob) {
		var len = blob.read_shift(4);
		var end = blob.l + len - 4;
		var o = {};
		var cnt = blob.read_shift(4);
		var comps = [];
		/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
		while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
		o.name = blob.read_shift(0, 'lpp4');
		o.comps = comps;
		if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
	function parse_DataSpaceMap(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
	function parse_DataSpaceDefinition(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
	function parse_TransformInfoHeader(blob) {
		var o = {};
		/*var len = */blob.read_shift(4);
		blob.l += 4; // must be 0x1
		o.id = blob.read_shift(0, 'lpp4');
		o.name = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	function parse_Primary(blob) {
		/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
		var hdr = parse_TransformInfoHeader(blob);
		/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
		hdr.ename = blob.read_shift(0, '8lpp4');
		hdr.blksz = blob.read_shift(4);
		hdr.cmode = blob.read_shift(4);
		if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
		return hdr;
	}
	
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var tgt = blob.l + length;
		var o = {};
		o.Flags = (blob.read_shift(4) & 0x3F);
		blob.l += 4;
		o.AlgID = blob.read_shift(4);
		var valid = false;
		switch(o.AlgID) {
			case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
			case 0x6801: valid = (o.Flags == 0x04); break;
			case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
		o.AlgIDHash = blob.read_shift(4);
		o.KeySize = blob.read_shift(4);
		o.ProviderType = blob.read_shift(4);
		blob.l += 8;
		o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
		blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		var o = {}, tgt = blob.l + length;
		blob.l += 4; // SaltSize must be 0x10
		o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
		o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
		/*var sz = */blob.read_shift(4);
		o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
	function parse_EncryptionInfo(blob) {
		var vers = parse_CRYPTOVersion(blob);
		switch(vers.Minor) {
			case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
			case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
			case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
		}
		throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
	function parse_EncInfoStd(blob) {
		var flags = blob.read_shift(4);
		if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
		var sz = blob.read_shift(4);
		//var tgt = blob.l + sz;
		var hdr = parse_EncryptionHeader(blob, sz);
		var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
		return { t:"Std", h:hdr, v:verifier };
	}
	/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
	function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
	/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
	function parse_EncInfoAgl(blob) {
		var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
		blob.l+=4;
		var xml = blob.read_shift(blob.length - blob.l, 'utf8');
		var o = {};
		xml.replace(tagregex, function xml_agile(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
				case '<encryption': case '</encryption>': break;
				case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
				case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
				case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
				case '</keyEncryptors>': break;
	
				case '<keyEncryptor': o.uri = y.uri; break;
				case '</keyEncryptor>': break;
				case '<encryptedKey': o.encs.push(y); break;
				default: throw y[0];
			}
		});
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
		if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
		if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
		return o;
	}
	
	
	var RTF = (function() {
		function rtf_to_sheet(d, opts) {
			switch(opts.type) {
				case 'base64': return rtf_to_sheet_str(Base64_decode(d), opts);
				case 'binary': return rtf_to_sheet_str(d, opts);
				case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
	
		/* TODO: this is a stub */
		function rtf_to_sheet_str(str, opts) {
			var o = opts || {};
			var ws = o.dense ? ([]) : ({});
	
			var rows = str.match(/\\trowd.*?\\row\b/g);
			if(!rows.length) throw new Error("RTF missing table");
			var range = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}});
			rows.forEach(function(rowtf, R) {
				if(Array.isArray(ws)) ws[R] = [];
				var rtfre = /\\\w+\b/g;
				var last_index = 0;
				var res;
				var C = -1;
				while((res = rtfre.exec(rowtf))) {
					switch(res[0]) {
						case "\\cell":
							var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
							if(data[0] == " ") data = data.slice(1);
							++C;
							if(data.length) {
								// TODO: value parsing, including codepage adjustments
								var cell = {v: data, t:"s"};
								if(Array.isArray(ws)) ws[R][C] = cell;
								else ws[encode_cell({r:R, c:C})] = cell;
							}
							break;
					}
					last_index = rtfre.lastIndex;
				}
				if(C > range.e.c) range.e.c = C;
			});
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }
	
		/* TODO: this is a stub */
		function sheet_to_rtf(ws) {
			var o = ["{\\rtf1\\ansi"];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				o.push("\\trowd\\trautofit1");
				for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
				o.push("\\pard\\intbl");
				for(C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(" " + (cell.w || (format_cell(cell), cell.w)));
					o.push("\\cell");
				}
				o.push("\\pard\\intbl\\row");
			}
			return o.join("") + "}";
		}
	
		return {
			to_workbook: rtf_to_workbook,
			to_sheet: rtf_to_sheet,
			from_sheet: sheet_to_rtf
		};
	})();
	function hex2RGB(h) {
		var o = h.slice(h[0]==="#"?1:0).slice(0,6);
		return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().slice(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint === 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
		return rgb2Hex(hsl2RGB(hsl));
	}
	
	/* 18.3.1.13 width calculations */
	/* [MS-OI29500] 2.1.595 Column Width & Formatting */
	var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
	function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
	function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
	//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
	//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	/* XLSX/XLSB/XLS specify width in units of MDW */
	function find_mdw_colw(collw) {
		var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
		if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
		MDW = _MDW;
	}
	/* XLML specifies width in terms of pixels */
	/*function find_mdw_wpx(wpx) {
		var delta = Infinity, guess = 0, _MDW = MIN_MDW;
		for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
			guess = char2width_(px2char_(wpx))*256;
			guess = (guess) % 1;
			if(guess > 0.5) guess--;
			if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
		}
		MDW = _MDW;
	}*/
	
	function process_col(coll) {
		if(coll.width) {
			coll.wpx = width2px(coll.width);
			coll.wch = px2char(coll.wpx);
			coll.MDW = MDW;
		} else if(coll.wpx) {
			coll.wch = px2char(coll.wpx);
			coll.width = char2width(coll.wch);
			coll.MDW = MDW;
		} else if(typeof coll.wch == 'number') {
			coll.width = char2width(coll.wch);
			coll.wpx = width2px(coll.width);
			coll.MDW = MDW;
		}
		if(coll.customWidth) delete coll.customWidth;
	}
	
	var DEF_PPI = 96, PPI = DEF_PPI;
	function px2pt(px) { return px * 96 / PPI; }
	function pt2px(pt) { return pt * PPI / 96; }
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	/* 18.8.5 borders CT_Borders */
	function parse_borders(t, styles, themes, opts) {
		styles.Borders = [];
		var border = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<borders': case '<borders>': case '</borders>': break;
	
				/* 18.8.4 border CT_Border */
				case '<border': case '<border>': case '<border/>':
					border = {};
					if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
					if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
					styles.Borders.push(border);
					break;
				case '</border>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<left/>': break;
				case '<left': case '<left>': break;
				case '</left>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<right/>': break;
				case '<right': case '<right>': break;
				case '</right>': break;
	
				/* 18.8.43 top CT_BorderPr */
				case '<top/>': break;
				case '<top': case '<top>': break;
				case '</top>': break;
	
				/* 18.8.6 bottom CT_BorderPr */
				case '<bottom/>': break;
				case '<bottom': case '<bottom>': break;
				case '</bottom>': break;
	
				/* 18.8.13 diagonal CT_BorderPr */
				case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
				case '</diagonal>': break;
	
				/* 18.8.25 horizontal CT_BorderPr */
				case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
				case '</horizontal>': break;
	
				/* 18.8.44 vertical CT_BorderPr */
				case '<vertical': case '<vertical>': case '<vertical/>': break;
				case '</vertical>': break;
	
				/* 18.8.37 start CT_BorderPr */
				case '<start': case '<start>': case '<start/>': break;
				case '</start>': break;
	
				/* 18.8.16 end CT_BorderPr */
				case '<end': case '<end>': case '<end/>': break;
				case '</end>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color>':
					break;
				case '<color/>': case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
				}
			}
		});
	}
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, styles, themes, opts) {
		styles.Fills = [];
		var fill = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fills': case '<fills>': case '</fills>': break;
	
				/* 18.8.20 fill CT_Fill */
				case '<fill>': case '<fill': case '<fill/>':
					fill = {}; styles.Fills.push(fill); break;
				case '</fill>': break;
	
				/* 18.8.24 gradientFill CT_GradientFill */
				case '<gradientFill>': break;
				case '<gradientFill':
				case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;
	
				/* 18.8.32 patternFill CT_PatternFill */
				case '<patternFill': case '<patternFill>':
					if(y.patternType) fill.patternType = y.patternType;
					break;
				case '<patternFill/>': case '</patternFill>': break;
	
				/* 18.8.3 bgColor CT_Color */
				case '<bgColor':
					if(!fill.bgColor) fill.bgColor = {};
					if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
					if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
					break;
				case '<bgColor/>': case '</bgColor>': break;
	
				/* 18.8.19 fgColor CT_Color */
				case '<fgColor':
					if(!fill.fgColor) fill.fgColor = {};
					if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
					break;
				case '<fgColor/>': case '</fgColor>': break;
	
				/* 18.8.38 stop CT_GradientStop */
				case '<stop': case '<stop/>': break;
				case '</stop>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color/>': break;
				case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
				}
			}
		});
	}
	
	/* 18.8.23 fonts CT_Fonts */
	function parse_fonts(t, styles, themes, opts) {
		styles.Fonts = [];
		var font = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fonts': case '<fonts>': case '</fonts>': break;
	
				/* 18.8.22 font CT_Font */
				case '<font': case '<font>': break;
				case '</font>': case '<font/>':
					styles.Fonts.push(font);
					font = {};
					break;
	
				/* 18.8.29 name CT_FontName */
				case '<name': if(y.val) font.name = utf8read(y.val); break;
				case '<name/>': case '</name>': break;
	
				/* 18.8.2  b CT_BooleanProperty */
				case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
				case '<b/>': font.bold = 1; break;
	
				/* 18.8.26 i CT_BooleanProperty */
				case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
				case '<i/>': font.italic = 1; break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					switch(y.val) {
						case "none": font.underline = 0x00; break;
						case "single": font.underline = 0x01; break;
						case "double": font.underline = 0x02; break;
						case "singleAccounting": font.underline = 0x21; break;
						case "doubleAccounting": font.underline = 0x22; break;
					} break;
				case '<u/>': font.underline = 1; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
				case '<strike/>': font.strike = 1; break;
	
				/* 18.4.2  outline CT_BooleanProperty */
				case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
				case '<outline/>': font.outline = 1; break;
	
				/* 18.8.36 shadow CT_BooleanProperty */
				case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
				case '<shadow/>': font.shadow = 1; break;
	
				/* 18.8.12 condense CT_BooleanProperty */
				case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
				case '<condense/>': font.condense = 1; break;
	
				/* 18.8.17 extend CT_BooleanProperty */
				case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
				case '<extend/>': font.extend = 1; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': if(y.val) font.sz = +y.val; break;
				case '<sz/>': case '</sz>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
				case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
				case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.18 family CT_FontFamily */
				case '<family': if(y.val) font.family = parseInt(y.val,10); break;
				case '<family/>': case '</family>': break;
	
				/* 18.8.35 scheme CT_FontScheme */
				case '<scheme': if(y.val) font.scheme = y.val; break;
				case '<scheme/>': case '</scheme>': break;
	
				/* 18.4.1 charset CT_IntProperty */
				case '<charset':
					if(y.val == '1') break;
					y.codepage = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.?.? color CT_Color */
				case '<color':
					if(!font.color) font.color = {};
					if(y.auto) font.color.auto = parsexmlbool(y.auto);
	
					if(y.rgb) font.color.rgb = y.rgb.slice(-6);
					else if(y.indexed) {
						font.color.index = parseInt(y.indexed, 10);
						var icv = XLSIcv[font.color.index];
						if(font.color.index == 81) icv = XLSIcv[1];
						if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
						font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
					} else if(y.theme) {
						font.color.theme = parseInt(y.theme, 10);
						if(y.tint) font.color.tint = parseFloat(y.tint);
						if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
							font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
						}
					}
	
					break;
				case '<color/>': case '</color>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
				}
			}
		});
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, styles, opts) {
		styles.NumberFmt = [];
		var k/*Array<number>*/ = (keys(table_fmt));
		for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = table_fmt[k[i]];
		var m = t[0].match(tagregex);
		if(!m) return;
		for(i=0; i < m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(strip_ns(y[0])) {
				case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
				case '<numFmt': {
					var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
					styles.NumberFmt[j] = f;
					if(j>0) {
						if(j > 0x188) {
							for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
							styles.NumberFmt[j] = f;
						}
						SSF_load(f,j);
					}
				} break;
				case '</numFmt>': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
			}
		}
	}
	
	function write_numFmts(NF) {
		var o = ["<numFmts>"];
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
			for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
		});
		if(o.length === 1) return "";
		o[o.length] = ("</numFmts>");
		o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
		return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
	var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
	function parse_cellXfs(t, styles, opts) {
		styles.CellXf = [];
		var xf;
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x), i = 0;
			switch(strip_ns(y[0])) {
				case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;
	
				/* 18.8.45 xf CT_Xf */
				case '<xf': case '<xf/>':
					xf = y;
					delete xf[0];
					for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
						xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
					for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
						xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
					if(styles.NumberFmt && xf.numFmtId > 0x188) {
						for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
					}
					styles.CellXf.push(xf); break;
				case '</xf>': break;
	
				/* 18.8.1 alignment CT_CellAlignment */
				case '<alignment': case '<alignment/>':
					var alignment = {};
					if(y.vertical) alignment.vertical = y.vertical;
					if(y.horizontal) alignment.horizontal = y.horizontal;
					if(y.textRotation != null) alignment.textRotation = y.textRotation;
					if(y.indent) alignment.indent = y.indent;
					if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
					xf.alignment = alignment;
					break;
				case '</alignment>': break;
	
				/* 18.8.33 protection CT_CellProtection */
				case '<protection':
					break;
				case '</protection>': case '<protection/>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
				}
			}
		});
	}
	
	function write_cellXfs(cellXfs) {
		var o = [];
		o[o.length] = (writextag('cellXfs',null));
		cellXfs.forEach(function(c) {
			o[o.length] = (writextag('xf', null, c));
		});
		o[o.length] = ("</cellXfs>");
		if(o.length === 2) return "";
		o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
		return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml= (function make_pstyx() {
	var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
	var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
	var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
	var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
	var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
	
	return function parse_sty_xml(data, themes, opts) {
		var styles = {};
		if(!data) return styles;
		data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		/* 18.8.39 styleSheet CT_Stylesheet */
		var t;
	
		/* 18.8.31 numFmts CT_NumFmts ? */
		if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);
	
		/* 18.8.23 fonts CT_Fonts ? */
		if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);
	
		/* 18.8.21 fills CT_Fills ? */
		if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);
	
		/* 18.8.5  borders CT_Borders ? */
		if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);
	
		/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
		/* 18.8.8  cellStyles CT_CellStyles ? */
	
		/* 18.8.10 cellXfs CT_CellXfs ? */
		if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);
	
		/* 18.8.15 dxfs CT_Dxfs ? */
		/* 18.8.42 tableStyles CT_TableStyles ? */
		/* 18.8.11 colors CT_Colors ? */
		/* 18.2.10 extLst CT_ExtensionList ? */
	
		return styles;
	};
	})();
	
	function write_sty_xml(wb, opts) {
		var o = [XML_HEADER, writextag('styleSheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:vt': XMLNS.vt
		})], w;
		if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
		o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
		o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
		o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
		o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
		if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
		o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
		o[o.length] = ('<dxfs count="0"/>');
		o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
		if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.657 BrtFmt */
	function parse_BrtFmt(data, length) {
		var numFmtId = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [numFmtId, stFmtCode];
	}
	function write_BrtFmt(i, f, o) {
		if(!o) o = new_buf(6 + 4 * f.length);
		o.write_shift(2, i);
		write_XLWideString(f, o);
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(o.l == null) o.l = o.length;
		return out;
	}
	
	/* [MS-XLSB] 2.4.659 BrtFont TODO */
	function parse_BrtFont(data, length, opts) {
		var out = ({});
	
		out.sz = data.read_shift(2) / 20;
	
		var grbit = parse_FontFlags(data, 2, opts);
		if(grbit.fItalic) out.italic = 1;
		if(grbit.fCondense) out.condense = 1;
		if(grbit.fExtend) out.extend = 1;
		if(grbit.fShadow) out.shadow = 1;
		if(grbit.fOutline) out.outline = 1;
		if(grbit.fStrikeout) out.strike = 1;
	
		var bls = data.read_shift(2);
		if(bls === 0x02BC) out.bold = 1;
	
		switch(data.read_shift(2)) {
			/* case 0: out.vertAlign = "baseline"; break; */
			case 1: out.vertAlign = "superscript"; break;
			case 2: out.vertAlign = "subscript"; break;
		}
	
		var underline = data.read_shift(1);
		if(underline != 0) out.underline = underline;
	
		var family = data.read_shift(1);
		if(family > 0) out.family = family;
	
		var bCharSet = data.read_shift(1);
		if(bCharSet > 0) out.charset = bCharSet;
	
		data.l++;
		out.color = parse_BrtColor(data, 8);
	
		switch(data.read_shift(1)) {
			/* case 0: out.scheme = "none": break; */
			case 1: out.scheme = "major"; break;
			case 2: out.scheme = "minor"; break;
		}
	
		out.name = parse_XLWideString(data, length - 21);
	
		return out;
	}
	function write_BrtFont(font, o) {
		if(!o) o = new_buf(25+4*32);
		o.write_shift(2, font.sz * 20);
		write_FontFlags(font, o);
		o.write_shift(2, font.bold ? 0x02BC : 0x0190);
		var sss = 0;
		if(font.vertAlign == "superscript") sss = 1;
		else if(font.vertAlign == "subscript") sss = 2;
		o.write_shift(2, sss);
		o.write_shift(1, font.underline || 0);
		o.write_shift(1, font.family || 0);
		o.write_shift(1, font.charset || 0);
		o.write_shift(1, 0);
		write_BrtColor(font.color, o);
		var scheme = 0;
		if(font.scheme == "major") scheme = 1;
		if(font.scheme == "minor") scheme = 2;
		o.write_shift(1, scheme);
		write_XLWideString(font.name, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFill */
	var XLSBFillPTNames = [
		"none",
		"solid",
		"mediumGray",
		"darkGray",
		"lightGray",
		"darkHorizontal",
		"darkVertical",
		"darkDown",
		"darkUp",
		"darkGrid",
		"darkTrellis",
		"lightHorizontal",
		"lightVertical",
		"lightDown",
		"lightUp",
		"lightGrid",
		"lightTrellis",
		"gray125",
		"gray0625"
	];
	var rev_XLSBFillPTNames;
	/* TODO: gradient fill representation */
	var parse_BrtFill = parsenoop;
	function write_BrtFill(fill, o) {
		if(!o) o = new_buf(4*3 + 8*7 + 16*1);
		if(!rev_XLSBFillPTNames) rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
		var fls = rev_XLSBFillPTNames[fill.patternType];
		if(fls == null) fls = 0x28;
		o.write_shift(4, fls);
		var j = 0;
		if(fls != 0x28) {
			/* TODO: custom FG Color */
			write_BrtColor({auto:1}, o);
			/* TODO: custom BG Color */
			write_BrtColor({auto:1}, o);
	
			for(; j < 12; ++j) o.write_shift(4, 0);
		} else {
			for(; j < 4; ++j) o.write_shift(4, 0);
	
			for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
			/* iGradientType */
			/* xnumDegree */
			/* xnumFillToLeft */
			/* xnumFillToRight */
			/* xnumFillToTop */
			/* xnumFillToBottom */
			/* cNumStop */
			/* xfillGradientStop */
		}
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.824 BrtXF */
	function parse_BrtXF(data, length) {
		var tgt = data.l + length;
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		data.l = tgt;
		return {ixfe:ixfeParent, numFmtId:ifmt };
	}
	function write_BrtXF(data, ixfeP, o) {
		if(!o) o = new_buf(16);
		o.write_shift(2, ixfeP||0);
		o.write_shift(2, data.numFmtId||0);
		o.write_shift(2, 0); /* iFont */
		o.write_shift(2, 0); /* iFill */
		o.write_shift(2, 0); /* ixBorder */
		o.write_shift(1, 0); /* trot */
		o.write_shift(1, 0); /* indent */
		var flow = 0;
		o.write_shift(1, flow); /* flags */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* xfGrbitAtr */
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.4 Blxf TODO */
	function write_Blxf(data, o) {
		if(!o) o = new_buf(10);
		o.write_shift(1, 0); /* dg */
		o.write_shift(1, 0);
		o.write_shift(4, 0); /* color */
		o.write_shift(4, 0); /* color */
		return o;
	}
	/* [MS-XLSB] 2.4.302 BrtBorder TODO */
	var parse_BrtBorder = parsenoop;
	function write_BrtBorder(border, o) {
		if(!o) o = new_buf(51);
		o.write_shift(1, 0); /* diagonal */
		write_Blxf(null, o); /* top */
		write_Blxf(null, o); /* bottom */
		write_Blxf(null, o); /* left */
		write_Blxf(null, o); /* right */
		write_Blxf(null, o); /* diag */
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.763 BrtStyle TODO */
	function write_BrtStyle(style, o) {
		if(!o) o = new_buf(12+4*10);
		o.write_shift(4, style.xfId);
		o.write_shift(2, 1);
		o.write_shift(1, +style.builtinId);
		o.write_shift(1, 0); /* iLevel */
		write_XLNullableWideString(style.name || "", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
	function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
		var o = new_buf(4+256*2*4);
		o.write_shift(4, cnt);
		write_XLNullableWideString(defTableStyle, o);
		write_XLNullableWideString(defPivotStyle, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, themes, opts) {
		var styles = {};
		styles.NumberFmt = ([]);
		for(var y in table_fmt) styles.NumberFmt[y] = table_fmt[y];
	
		styles.CellXf = [];
		styles.Fonts = [];
		var state = [];
		var pass = false;
		recordhopper(data, function hopper_sty(val, R, RT) {
			switch(RT) {
				case 0x002C: /* BrtFmt */
					styles.NumberFmt[val[0]] = val[1]; SSF_load(val[1], val[0]);
					break;
				case 0x002B: /* BrtFont */
					styles.Fonts.push(val);
					if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
						val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
					}
					break;
				case 0x0401: /* BrtKnownFonts */ break;
				case 0x002D: /* BrtFill */
					break;
				case 0x002E: /* BrtBorder */
					break;
				case 0x002F: /* BrtXF */
					if(state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */) {
						styles.CellXf.push(val);
					}
					break;
				case 0x0030: /* BrtStyle */
				case 0x01FB: /* BrtDXF */
				case 0x023C: /* BrtMRUColor */
				case 0x01DB: /* BrtIndexedColor */
					break;
	
				case 0x0493: /* BrtDXF14 */
				case 0x0836: /* BrtDXF15 */
				case 0x046A: /* BrtSlicerStyleElement */
				case 0x0200: /* BrtTableStyleElement */
				case 0x082F: /* BrtTimelineStyleElement */
				case 0x0C00: /* BrtUid */
					break;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
				case 0x0025: /* BrtACBegin */
					state.push(RT); pass = true; break;
				case 0x0026: /* BrtACEnd */
					state.pop(); pass = false; break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return styles;
	}
	
	function write_FMTS_bin(ba, NF) {
		if(!NF) return;
		var cnt = 0;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
		});
	
		if(cnt == 0) return;
		write_record(ba, 0x0267 /* BrtBeginFmts */, write_UInt32LE(cnt));
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, 0x002C /* BrtFmt */, write_BrtFmt(i, NF[i]));
		});
		write_record(ba, 0x0268 /* BrtEndFmts */);
	}
	
	function write_FONTS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0263 /* BrtBeginFonts */, write_UInt32LE(cnt));
		write_record(ba, 0x002B /* BrtFont */, write_BrtFont({
			sz:12,
			color: {theme:1},
			name: "Calibri",
			family: 2,
			scheme: "minor"
		}));
		/* 1*65491BrtFont [ACFONTS] */
		write_record(ba, 0x0264 /* BrtEndFonts */);
	}
	
	function write_FILLS_bin(ba) {
		var cnt = 2;
	
		if(cnt == 0) return;
		write_record(ba, 0x025B /* BrtBeginFills */, write_UInt32LE(cnt));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"none"}));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"gray125"}));
		/* 1*65431BrtFill */
		write_record(ba, 0x025C /* BrtEndFills */);
	}
	
	function write_BORDERS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0265 /* BrtBeginBorders */, write_UInt32LE(cnt));
		write_record(ba, 0x002E /* BrtBorder */, write_BrtBorder({}));
		/* 1*65430BrtBorder */
		write_record(ba, 0x0266 /* BrtEndBorders */);
	}
	
	function write_CELLSTYLEXFS_bin(ba) {
		var cnt = 1;
		write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */, write_UInt32LE(cnt));
		write_record(ba, 0x002F /* BrtXF */, write_BrtXF({
			numFmtId: 0,
			fontId:   0,
			fillId:   0,
			borderId: 0
		}, 0xFFFF));
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x0273 /* BrtEndCellStyleXFs */);
	}
	
	function write_CELLXFS_bin(ba, data) {
		write_record(ba, 0x0269 /* BrtBeginCellXFs */, write_UInt32LE(data.length));
		data.forEach(function(c) { write_record(ba, 0x002F /* BrtXF */, write_BrtXF(c,0)); });
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x026A /* BrtEndCellXFs */);
	}
	
	function write_STYLES_bin(ba) {
		var cnt = 1;
	
		write_record(ba, 0x026B /* BrtBeginStyles */, write_UInt32LE(cnt));
		write_record(ba, 0x0030 /* BrtStyle */, write_BrtStyle({
			xfId:0,
			builtinId:0,
			name:"Normal"
		}));
		/* 1*65430(BrtStyle *FRT) */
		write_record(ba, 0x026C /* BrtEndStyles */);
	}
	
	function write_DXFS_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01F9 /* BrtBeginDXFs */, write_UInt32LE(cnt));
		/* *2147483647(BrtDXF *FRT) */
		write_record(ba, 0x01FA /* BrtEndDXFs */);
	}
	
	function write_TABLESTYLES_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01FC /* BrtBeginTableStyles */, write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
		/* *TABLESTYLE */
		write_record(ba, 0x01FD /* BrtEndTableStyles */);
	}
	
	function write_COLORPALETTE_bin() {
		return;
		/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0116 /* BrtBeginStyleSheet */);
		write_FMTS_bin(ba, wb.SSF);
		write_FONTS_bin(ba, wb);
		write_FILLS_bin(ba, wb);
		write_BORDERS_bin(ba, wb);
		write_CELLSTYLEXFS_bin(ba, wb);
		write_CELLXFS_bin(ba, opts.cellXfs);
		write_STYLES_bin(ba, wb);
		write_DXFS_bin(ba, wb);
		write_TABLESTYLES_bin(ba, wb);
		write_COLORPALETTE_bin(ba, wb);
		/* FRTSTYLESHEET*/
		write_record(ba, 0x0117 /* BrtEndStyleSheet */);
		return ba.end();
	}
	/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
	var XLSXThemeClrScheme = [
		'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
		'</a:accent1>', '</a:accent2>', '</a:accent3>',
		'</a:accent4>', '</a:accent5>', '</a:accent6>',
		'</a:hlink>', '</a:folHlink>'
	];
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, themes, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr':
					color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr':
					color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.1 accent1 (Accent 1) */
				/* 20.1.4.1.2 accent2 (Accent 2) */
				/* 20.1.4.1.3 accent3 (Accent 3) */
				/* 20.1.4.1.4 accent4 (Accent 4) */
				/* 20.1.4.1.5 accent5 (Accent 5) */
				/* 20.1.4.1.6 accent6 (Accent 6) */
				/* 20.1.4.1.9 dk1 (Dark 1) */
				/* 20.1.4.1.10 dk2 (Dark 2) */
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				/* 20.1.4.1.19 hlink (Hyperlink) */
				/* 20.1.4.1.22 lt1 (Light 1) */
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:dk1>': case '</a:dk1>':
				case '<a:lt1>': case '</a:lt1>':
				case '<a:dk2>': case '</a:dk2>':
				case '<a:lt2>': case '</a:lt2>':
				case '<a:accent1>': case '</a:accent1>':
				case '<a:accent2>': case '</a:accent2>':
				case '<a:accent3>': case '</a:accent3>':
				case '<a:accent4>': case '</a:accent4>':
				case '<a:accent5>': case '</a:accent5>':
				case '<a:accent6>': case '</a:accent6>':
				case '<a:hlink>': case '</a:hlink>':
				case '<a:folHlink>': case '</a:folHlink>':
					if (y[0].charAt(1) === '/') {
						themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
						color = {};
					} else {
						color.name = y[0].slice(3, y[0].length - 1);
					}
					break;
	
				default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme() { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme() { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, themes, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
			m[2](t, themes, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) data = write_theme();
	
		var t;
		var themes = {};
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
		parse_themeElements(t[0], themes, opts);
		themes.raw = data;
		return themes;
	}
	
	function write_theme(Themes, opts) {
		if(opts && opts.themeXLSX) return opts.themeXLSX;
		if(Themes && typeof Themes.raw == "string") return Themes.raw;
		var o = [XML_HEADER];
		o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
		o[o.length] =  '<a:themeElements>';
	
		o[o.length] =   '<a:clrScheme name="Office">';
		o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
		o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
		o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
		o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
		o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
		o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
		o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
		o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
		o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
		o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
		o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
		o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
		o[o.length] =   '</a:clrScheme>';
	
		o[o.length] =   '<a:fontScheme name="Office">';
		o[o.length] =    '<a:majorFont>';
		o[o.length] =     '<a:latin typeface="Cambria"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:majorFont>';
		o[o.length] =    '<a:minorFont>';
		o[o.length] =     '<a:latin typeface="Calibri"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:minorFont>';
		o[o.length] =   '</a:fontScheme>';
	
		o[o.length] =   '<a:fmtScheme name="Office">';
		o[o.length] =    '<a:fillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:fillStyleLst>';
		o[o.length] =    '<a:lnStyleLst>';
		o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =    '</a:lnStyleLst>';
		o[o.length] =    '<a:effectStyleLst>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
		o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =    '</a:effectStyleLst>';
		o[o.length] =    '<a:bgFillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:bgFillStyleLst>';
		o[o.length] =   '</a:fmtScheme>';
		o[o.length] =  '</a:themeElements>';
	
		o[o.length] =  '<a:objectDefaults>';
		o[o.length] =   '<a:spDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:spDef>';
		o[o.length] =   '<a:lnDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:lnDef>';
		o[o.length] =  '</a:objectDefaults>';
		o[o.length] =  '<a:extraClrSchemeLst/>';
		o[o.length] = '</a:theme>';
		return o.join("");
	}
	/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length, opts) {
		var end = blob.l + length;
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		if(!opts.cellStyles) { blob.l = end; return; }
		var data = blob.slice(blob.l);
		blob.l = end;
		var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
		var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
		if(!themeXML) return;
		return parse_theme_xml(themeXML, opts);
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* [MS-XLS] 2.5.108 */
	function parse_ExtProp(blob) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2) - 4;
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x06: break; /* gradient fill */
				case 0x07: break; /* top cell border color */
				case 0x08: break; /* bottom cell border color */
				case 0x09: break; /* left cell border color */
				case 0x0a: break; /* right cell border color */
				case 0x0b: break; /* diagonal cell border color */
				case 0x0d: /* text color */
					break;
				case 0x0e: break; /* font scheme */
				case 0x0f: break; /* indentation level */
			}
		});
	}
	
	function parse_BrtMdtinfo(data, length) {
	  return {
	    flags: data.read_shift(4),
	    version: data.read_shift(4),
	    name: parse_XLWideString(data, length - 8)
	  };
	}
	function write_BrtMdtinfo(data) {
	  var o = new_buf(12 + 2 * data.name.length);
	  o.write_shift(4, data.flags);
	  o.write_shift(4, data.version);
	  write_XLWideString(data.name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtMdb(data) {
	  var out = [];
	  var cnt = data.read_shift(4);
	  while (cnt-- > 0)
	    out.push([data.read_shift(4), data.read_shift(4)]);
	  return out;
	}
	function write_BrtMdb(mdb) {
	  var o = new_buf(4 + 8 * mdb.length);
	  o.write_shift(4, mdb.length);
	  for (var i = 0; i < mdb.length; ++i) {
	    o.write_shift(4, mdb[i][0]);
	    o.write_shift(4, mdb[i][1]);
	  }
	  return o;
	}
	function write_BrtBeginEsfmd(cnt, name) {
	  var o = new_buf(8 + 2 * name.length);
	  o.write_shift(4, cnt);
	  write_XLWideString(name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtBeginEsmdb(data) {
	  data.l += 4;
	  return data.read_shift(4) != 0;
	}
	function write_BrtBeginEsmdb(cnt, cm) {
	  var o = new_buf(8);
	  o.write_shift(4, cnt);
	  o.write_shift(4, cm ? 1 : 0);
	  return o;
	}
	function parse_xlmeta_bin(data, name, _opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  var opts = _opts || {};
	  var state = [];
	  var pass = false;
	  var metatype = 2;
	  recordhopper(data, function(val, R, RT) {
	    switch (RT) {
	      case 335:
	        out.Types.push({ name: val.name });
	        break;
	      case 51:
	        val.forEach(function(r) {
	          if (metatype == 1)
	            out.Cell.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	          else if (metatype == 0)
	            out.Value.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	        });
	        break;
	      case 337:
	        metatype = val ? 1 : 0;
	        break;
	      case 338:
	        metatype = 2;
	        break;
	      case 35:
	        state.push(RT);
	        pass = true;
	        break;
	      case 36:
	        state.pop();
	        pass = false;
	        break;
	      default:
	        if (R.T) {
	        } else if (!pass || opts.WTF && state[state.length - 1] != 35)
	          throw new Error("Unexpected record 0x" + RT.toString(16));
	    }
	  });
	  return out;
	}
	function write_xlmeta_bin() {
	  var ba = buf_array();
	  write_record(ba, 332);
	  write_record(ba, 334, write_UInt32LE(1));
	  write_record(ba, 335, write_BrtMdtinfo({
	    name: "XLDAPR",
	    version: 12e4,
	    flags: 3496657072
	  }));
	  write_record(ba, 336);
	  write_record(ba, 339, write_BrtBeginEsfmd(1, "XLDAPR"));
	  write_record(ba, 52);
	  write_record(ba, 35, write_UInt32LE(514));
	  write_record(ba, 4096, write_UInt32LE(0));
	  write_record(ba, 4097, writeuint16(1));
	  write_record(ba, 36);
	  write_record(ba, 53);
	  write_record(ba, 340);
	  write_record(ba, 337, write_BrtBeginEsmdb(1, true));
	  write_record(ba, 51, write_BrtMdb([[1, 0]]));
	  write_record(ba, 338);
	  write_record(ba, 333);
	  return ba.end();
	}
	function parse_xlmeta_xml(data, name, opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  if (!data)
	    return out;
	  var pass = false;
	  var metatype = 2;
	  var lastmeta;
	  data.replace(tagregex, function(x) {
	    var y = parsexmltag(x);
	    switch (strip_ns(y[0])) {
	      case "<?xml":
	        break;
	      case "<metadata":
	      case "</metadata>":
	        break;
	      case "<metadataTypes":
	      case "</metadataTypes>":
	        break;
	      case "<metadataType":
	        out.Types.push({ name: y.name });
	        break;
	      case "</metadataType>":
	        break;
	      case "<futureMetadata":
	        for (var j = 0; j < out.Types.length; ++j)
	          if (out.Types[j].name == y.name)
	            lastmeta = out.Types[j];
	        break;
	      case "</futureMetadata>":
	        break;
	      case "<bk>":
	        break;
	      case "</bk>":
	        break;
	      case "<rc":
	        if (metatype == 1)
	          out.Cell.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        else if (metatype == 0)
	          out.Value.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        break;
	      case "</rc>":
	        break;
	      case "<cellMetadata":
	        metatype = 1;
	        break;
	      case "</cellMetadata>":
	        metatype = 2;
	        break;
	      case "<valueMetadata":
	        metatype = 0;
	        break;
	      case "</valueMetadata>":
	        metatype = 2;
	        break;
	      case "<extLst":
	      case "<extLst>":
	      case "</extLst>":
	      case "<extLst/>":
	        break;
	      case "<ext":
	        pass = true;
	        break;
	      case "</ext>":
	        pass = false;
	        break;
	      case "<rvb":
	        if (!lastmeta)
	          break;
	        if (!lastmeta.offsets)
	          lastmeta.offsets = [];
	        lastmeta.offsets.push(+y.i);
	        break;
	      default:
	        if (!pass && opts.WTF)
	          throw new Error("unrecognized " + y[0] + " in metadata");
	    }
	    return x;
	  });
	  return out;
	}
	function write_xlmeta_xml() {
	  var o = [XML_HEADER];
	  o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
	  return o.join("");
	}
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data) {
		var d = [];
		if(!data) return d;
		var i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	//function write_cc_xml(data, opts) { }
	
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, name, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R, RT) {
			switch(RT) {
				case 0x003F: /* 'BrtCalcChainItem$' */
					out.push(val); break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	//function write_cc_bin(data, opts) { }
	/* 18.14 Supplementary Workbook Data */
	function parse_xlink_xml() {
		//var opts = _opts || {};
		//if(opts.WTF) throw "XLSX External Link";
	}
	
	/* [MS-XLSB] 2.1.7.25 External Link */
	function parse_xlink_bin(data, rel, name, _opts) {
		if(!data) return data;
		var opts = _opts || {};
	
		var pass = false, end = false;
	
		recordhopper(data, function xlink_parse(val, R, RT) {
			if(end) return;
			switch(RT) {
				case 0x0167: /* 'BrtSupTabs' */
				case 0x016B: /* 'BrtExternTableStart' */
				case 0x016C: /* 'BrtExternTableEnd' */
				case 0x016E: /* 'BrtExternRowHdr' */
				case 0x016F: /* 'BrtExternCellBlank' */
				case 0x0170: /* 'BrtExternCellReal' */
				case 0x0171: /* 'BrtExternCellBool' */
				case 0x0172: /* 'BrtExternCellError' */
				case 0x0173: /* 'BrtExternCellString' */
				case 0x01D8: /* 'BrtExternValueMeta' */
				case 0x0241: /* 'BrtSupNameStart' */
				case 0x0242: /* 'BrtSupNameValueStart' */
				case 0x0243: /* 'BrtSupNameValueEnd' */
				case 0x0244: /* 'BrtSupNameNum' */
				case 0x0245: /* 'BrtSupNameErr' */
				case 0x0246: /* 'BrtSupNameSt' */
				case 0x0247: /* 'BrtSupNameNil' */
				case 0x0248: /* 'BrtSupNameBool' */
				case 0x0249: /* 'BrtSupNameFmla' */
				case 0x024A: /* 'BrtSupNameBits' */
				case 0x024B: /* 'BrtSupNameEnd' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	}
	/* 20.5 DrawingML - SpreadsheetML Drawing */
	/* 20.5.2.35 wsDr CT_Drawing */
	function parse_drawing(data, rels) {
		if(!data) return "??";
		/*
		  Chartsheet Drawing:
		   - 20.5.2.35 wsDr CT_Drawing
		    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
		     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
		      - 20.1.2.2.16 graphic CT_GraphicalObject
		       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
	          - chart reference
		   the actual type is based on the URI of the graphicData
			TODO: handle embedded charts and other types of graphics
		*/
		var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];
	
		return rels['!id'][id].Target;
	}
	
	/* L.5.5.2 SpreadsheetML Comments + VML Schema */
	var _shapeid = 1024;
	function write_comments_vml(rId, comments) {
		var csize = [21600, 21600];
		/* L.5.2.1.2 Path Attribute */
		var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
		var o = [
			writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
			writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
			writextag("v:shapetype", [
				writextag("v:stroke", null, {joinstyle:"miter"}),
				writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
			].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
		];
		while(_shapeid < rId * 1000) _shapeid += 1000;
	
		comments.forEach(function(x) {
		var c = decode_cell(x[0]);
		var fillopts = {'color2':"#BEFF82", 'type':"gradient"};
		if(fillopts.type == "gradient") fillopts.angle = "-180";
		var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
		var fillxml = writextag('v:fill', fillparm, fillopts);
	
		var shadata = ({on:"t", 'obscured':"t"});
		++_shapeid;
	
		o = o.concat([
		'<v:shape' + wxt_helper({
			id:'_x0000_s' + _shapeid,
			type:"#_x0000_t202",
			style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
			fillcolor:"#ECFAD4",
			strokecolor:"#edeaa1"
		}) + '>',
			fillxml,
			writextag("v:shadow", null, shadata),
			writextag("v:path", null, {'o:connecttype':"none"}),
			'<v:textbox><div style="text-align:left"></div></v:textbox>',
			'<x:ClientData ObjectType="Note">',
				'<x:MoveWithCells/>',
				'<x:SizeWithCells/>',
				/* Part 4 19.4.2.3 Anchor (Anchor) */
				writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
				writetag('x:AutoFill', "False"),
				writetag('x:Row', String(c.r)),
				writetag('x:Column', String(c.c)),
				x[1].hidden ? '' : '<x:Visible/>',
			'</x:ClientData>',
		'</v:shape>'
		]); });
		o.push('</xml>');
		return o.join("");
	}
	function sheet_insert_comments(sheet, comments, threaded, people) {
		var dense = Array.isArray(sheet);
		var cell;
		comments.forEach(function(comment) {
			var r = decode_cell(comment.ref);
			if(dense) {
				if(!sheet[r.r]) sheet[r.r] = [];
				cell = sheet[r.r][r.c];
			} else cell = sheet[comment.ref];
			if (!cell) {
				cell = ({t:"z"});
				if(dense) sheet[r.r][r.c] = cell;
				else sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				if(range.s.r > r.r) range.s.r = r.r;
				if(range.e.r < r.r) range.e.r = r.r;
				if(range.s.c > r.c) range.s.c = r.c;
				if(range.e.c < r.c) range.e.c = r.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = ({a: comment.author, t: comment.t, r: comment.r, T: threaded});
			if(comment.h) o.h = comment.h;
	
			/* threaded comments always override */
			for(var i = cell.c.length - 1; i >= 0; --i) {
				if(!threaded && cell.c[i].T) return;
				if(threaded && !cell.c[i].T) cell.c.splice(i, 1);
			}
			if(threaded && people) for(i = 0; i < people.length; ++i) {
				if(o.a == people[i].id) { o.a = people[i].name || o.a; break; }
			}
			cell.c.push(o);
		});
	}
	
	/* 18.7 Comments */
	function parse_comments_xml(data, opts) {
		/* 18.7.6 CT_Comments */
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
		if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
			if(a) authors.push(a[1]);
		});
		var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
		if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
			if(!cm) return;
			var y = parsexmltag(cm[0]);
			var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
			var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
			comment.r = rt.r;
			if(rt.r == "<t></t>") rt.t = rt.h = "";
			comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	function write_comments_xml(data) {
		var o = [XML_HEADER, writextag('comments', null, { 'xmlns': XMLNS_main[0] })];
	
		var iauthor = [];
		o.push("<authors>");
		data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
			if(iauthor.indexOf(a) == -1) {
				iauthor.push(a);
				o.push("<author>" + a + "</author>");
			}
			if(w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
				iauthor.push("tc=" + w.ID);
				o.push("<author>" + "tc=" + w.ID + "</author>");
			}
		}); });
		if(iauthor.length == 0) { iauthor.push("SheetJ5"); o.push("<author>SheetJ5</author>"); }
		o.push("</authors>");
		o.push("<commentList>");
		data.forEach(function(d) {
			/* 18.7.3 CT_Comment */
			var lastauthor = 0, ts = [];
			if(d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
			else d[1].forEach(function(c) {
				if(c.a) lastauthor = iauthor.indexOf(escapexml(c.a));
				ts.push(c.t||"");
			});
			o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
			if(ts.length <= 1) o.push(writetag("t", escapexml(ts[0]||"")));
			else {
				/* based on Threaded Comments -> Comments projection */
				var t = "Comment:\n    " + (ts[0]) + "\n";
				for(var i = 1; i < ts.length; ++i) t += "Reply:\n    " + ts[i] + "\n";
				o.push(writetag("t", escapexml(t)));
			}
			o.push('</text></comment>');
		});
		o.push("</commentList>");
		if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.17 */
	function parse_tcmnt_xml(data, opts) {
		var out = [];
		var pass = false, comment = {}, tidx = 0;
		data.replace(tagregex, function xml_tcmnt(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.6.207 ThreadedComments CT_ThreadedComments */
				case '<ThreadedComments': break;
				case '</ThreadedComments>': break;
	
				/* 2.6.205 threadedComment CT_ThreadedComment */
				case '<threadedComment': comment = {author: y.personId, guid: y.id, ref: y.ref, T: 1}; break;
				case '</threadedComment>': if(comment.t != null) out.push(comment); break;
	
				case '<text>': case '<text': tidx = idx + x.length; break;
				case '</text>': comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n"); break;
	
				/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
				case '<mentions': case '<mentions>': pass = true; break;
				case '</mentions>': pass = false; break;
	
				/* 2.6.202 mention CT_Mention TODO */
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	
	function write_tcmnt_xml(comments, people, opts) {
		var o = [XML_HEADER, writextag('ThreadedComments', null, { 'xmlns': XMLNS.TCMNT }).replace(/[\/]>/, ">")];
		comments.forEach(function(carr) {
			var rootid = "";
			(carr[1] || []).forEach(function(c, idx) {
				if(!c.T) { delete c.ID; return; }
				if(c.a && people.indexOf(c.a) == -1) people.push(c.a);
				var tcopts = {
					ref: carr[0],
					id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
				};
				if(idx == 0) rootid = tcopts.id;
				else tcopts.parentId = rootid;
				c.ID = tcopts.id;
				if(c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
				o.push(writextag('threadedComment', writetag('text', c.t||""), tcopts));
			});
		});
		o.push('</ThreadedComments>');
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.18 */
	function parse_people_xml(data, opts) {
		var out = [];
		var pass = false;
		data.replace(tagregex, function xml_tcmnt(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.4.85 personList CT_PersonList */
				case '<personList': break;
				case '</personList>': break;
	
				/* 2.6.203 person CT_Person TODO: providers */
				case '<person': out.push({name: y.displayname, id: y.id }); break;
				case '</person>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	function write_people_xml(people/*, opts*/) {
		var o = [XML_HEADER, writextag('personList', null, {
			'xmlns': XMLNS.TCMNT,
			'xmlns:x': XMLNS_main[0]
		}).replace(/[\/]>/, ">")];
		people.forEach(function(person, idx) {
			o.push(writextag('person', null, {
				displayName: person,
				id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
				userId: person,
				providerId: "None"
			}));
		});
		o.push("</personList>");
		return o.join("");
	}
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	function write_BrtBeginComment(data, o) {
		if(o == null) o = new_buf(36);
		o.write_shift(4, data[1].iauthor);
		write_UncheckedRfX((data[0]), o);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R, RT) {
			switch(RT) {
				case 0x0278: /* 'BrtCommentAuthor' */
					authors.push(val); break;
				case 0x027B: /* 'BrtBeginComment' */
					c = val; break;
				case 0x027D: /* 'BrtCommentText' */
					c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 0x027C: /* 'BrtEndComment' */
					c.author = authors[c.iauthor];
					delete (c).iauthor;
					if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
					if(!c.t) c.t = "";
					delete c.rfx; out.push(c); break;
	
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	function write_comments_bin(data) {
		var ba = buf_array();
		var iauthor = [];
		write_record(ba, 0x0274 /* BrtBeginComments */);
	
		write_record(ba, 0x0276 /* BrtBeginCommentAuthors */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				if(iauthor.indexOf(c.a) > -1) return;
				iauthor.push(c.a.slice(0,54));
				write_record(ba, 0x0278 /* BrtCommentAuthor */, write_BrtCommentAuthor(c.a));
			});
		});
		write_record(ba, 0x0277 /* BrtEndCommentAuthors */);
	
		write_record(ba, 0x0279 /* BrtBeginCommentList */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				c.iauthor = iauthor.indexOf(c.a);
				var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
				write_record(ba, 0x027B /* BrtBeginComment */, write_BrtBeginComment([range, c]));
				if(c.t && c.t.length > 0) write_record(ba, 0x027D /* BrtCommentText */, write_BrtCommentText(c));
				write_record(ba, 0x027C /* BrtEndComment */);
				delete c.iauthor;
			});
		});
		write_record(ba, 0x027A /* BrtEndCommentList */);
	
		write_record(ba, 0x0275 /* BrtEndComments */);
		return ba.end();
	}
	var CT_VBA = "application/vnd.ms-office.vbaProject";
	function make_vba_xls(cfb) {
	  var newcfb = CFB.utils.cfb_new({ root: "R" });
	  cfb.FullPaths.forEach(function(p, i) {
	    if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
	      return;
	    var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
	    CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
	  });
	  return CFB.write(newcfb);
	}
	function fill_vba_xls(cfb, vba) {
	  vba.FullPaths.forEach(function(p, i) {
	    if (i == 0)
	      return;
	    var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
	    if (newpath.slice(-1) !== "/")
	      CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
	  });
	}
	var VBAFMTS = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
	/* macro and dialog sheet stubs */
	function parse_ds_bin() { return {'!type':'dialog'}; }
	function parse_ds_xml() { return {'!type':'dialog'}; }
	function parse_ms_bin() { return {'!type':'macro'}; }
	function parse_ms_xml() { return {'!type':'macro'}; }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
		var rcbase = ({r:0,c:0});
		function rcfunc($$,$1,$2,$3) {
			var cRel = false, rRel = false;
	
			if($2.length == 0) rRel = true;
			else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }
	
			if($3.length == 0) cRel = true;
			else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }
	
			var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;
	
			if(cRel) C += rcbase.c; else --C;
			if(rRel) R += rcbase.r; else --R;
			return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
	var a1_to_rc = (function(){
		return function a1_to_rc(fstr, base) {
			return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
				var c = decode_col($3) - ($2 ? 0 : base.c);
				var r = decode_row($5) - ($4 ? 0 : base.r);
				var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
				var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
				return $1 + "R" + R + "C" + C;
			});
		};
	})();
	
	/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
	function shift_formula_str(f, delta) {
		return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
		});
	}
	
	function shift_formula_xlsx(f, range, cell) {
		var r = decode_range(range), s = r.s, c = decode_cell(cell);
		var delta = {r:c.r - s.r, c:c.c - s.c};
		return shift_formula_str(f, delta);
	}
	
	/* TODO: parse formula */
	function fuzzyfmla(f) {
		if(f.length == 1) return false;
		return true;
	}
	
	function _xlfn(f) {
		return f.replace(/_xlfn\./g,"");
	}
	function parseread1(blob) { blob.l+=1; return; }
	
	/* [MS-XLS] 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(length == 1 ? 1 : 2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
	function parse_RgceArea(blob, length, opts) {
		var w = 2;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
			else if(opts.biff == 12) w = 4;
		}
		var r=blob.read_shift(w), R=blob.read_shift(w);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	/* BIFF 2-5 encodes flags in the row field */
	function parse_RgceArea_BIFF2(blob) {
		var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
		var c=blob.read_shift(1);
		var C=blob.read_shift(1);
		return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
	function parse_RgceAreaRel(blob, length, opts) {
		if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
		var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
	function parse_RgceLoc(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
		var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	function parse_RgceLoc_BIFF2(blob) {
		var r = parse_ColRelU(blob, 2);
		var c = blob.read_shift(1);
		return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
	}
	
	/* [MS-XLS] 2.5.198.107, 2.5.47 */
	function parse_RgceElfLoc(blob) {
		var r = blob.read_shift(2);
		var c = blob.read_shift(2);
		return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
	}
	
	/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
	function parse_RgceLocRel(blob, length, opts) {
		var biff = opts && opts.biff ? opts.biff : 8;
		if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
		var r = blob.read_shift(biff >= 12 ? 4 : 2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
		cl &= 0x3FFF;
		if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
		if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	function parse_RgceLocRel_BIFF2(blob) {
		var rl = blob.read_shift(2);
		var c = blob.read_shift(1);
		var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
		rl &= 0x3FFF;
		if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
		if(cRel == 1 && c >= 0x80) c = c - 0x100;
		return {r:rl,c:c,cRel:cRel,rRel:rRel};
	}
	
	/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
	function parse_PtgArea(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
	function parse_PtgArea3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2, 'i');
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		var area = parse_RgceArea(blob, w, opts);
		return [type, ixti, area];
	}
	
	/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
	function parse_PtgAreaErr(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
		return [type];
	}
	/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
	function parse_PtgAreaErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
	function parse_PtgAreaN(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, length - 1, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
	function parse_PtgArray(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
	function parse_PtgAttrBaxcel(blob) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
	function parse_PtgAttrChoose(blob, length, opts) {
		blob.l +=2;
		var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
	function parse_PtgAttrGoto(blob, length, opts) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
	function parse_PtgAttrIf(blob, length, opts) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLSB] 2.5.97.28 */
	function parse_PtgAttrIfError(blob) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
	function parse_PtgAttrSemi(blob, length, opts) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += opts && opts.biff == 2 ? 3 : 4;
		return [bitSemi];
	}
	
	/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
	function parse_PtgAttrSpaceType(blob) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
	function parse_PtgAttrSpace(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
	function parse_PtgAttrSpaceSemi(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
	function parse_PtgRef(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
	function parse_PtgRefN(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
	function parse_PtgRef3d(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		if(opts && opts.biff == 5) blob.l += 12;
		var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
		return [type, ixti, loc];
	}
	
	
	/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
	function parse_PtgFunc(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
		return [FtabArgc[iftab], Ftab[iftab], type];
	}
	/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
	function parse_PtgFuncVar(blob, length, opts) {
		var type = blob[blob.l++];
		var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
	function parse_PtgAttrSum(blob, length, opts) {
		blob.l += opts && opts.biff == 2 ? 3 : 4; return;
	}
	
	/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
	function parse_PtgExp(blob, length, opts) {
		blob.l++;
		if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
		var row = blob.read_shift(2);
		var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [row, col];
	}
	
	/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
	function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
	function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }
	
	/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
	function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
	function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
	function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }
	
	/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
	function parse_SerAr(blob, biff) {
		var val = [blob.read_shift(1)];
		if(biff == 12) switch(val[0]) {
			case 0x02: val[0] = 0x04; break; /* SerBool */
			case 0x04: val[0] = 0x10; break; /* SerErr */
			case 0x00: val[0] = 0x01; break; /* SerNum */
			case 0x01: val[0] = 0x02; break; /* SerStr */
		}
		switch(val[0]) {
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				if(biff != 12) blob.l += 7; break;
			case 0x25: /* appears to be an alias */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += ((biff == 12) ? 4 : 8); break;
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
			default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
		}
		return val;
	}
	
	/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
	function parse_PtgExtraMem(blob, cce, opts) {
		var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
		return out;
	}
	
	/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
	function parse_PtgExtraArray(blob, length, opts) {
		var rows = 0, cols = 0;
		if(opts.biff == 12) {
			rows = blob.read_shift(4); // DRw
			cols = blob.read_shift(4); // DCol
		} else {
			cols = 1 + blob.read_shift(1); //DColByteU
			rows = 1 + blob.read_shift(2); //DRw
		}
		if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
		// $FlowIgnore
		for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
		return o;
	}
	
	/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
	function parse_PtgName(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
		var nameindex = blob.read_shift(w);
		switch(opts.biff) {
			case 2: blob.l += 5; break;
			case 3: case 4: blob.l += 8; break;
			case 5: blob.l += 12; break;
		}
		return [type, 0, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
	function parse_PtgNameX(blob, length, opts) {
		if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	function parse_PtgNameX_BIFF5(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2, 'i'); // XtiIndex
		blob.l += 8;
		var nameindex = blob.read_shift(2);
		blob.l += 12;
		return [type, ixti, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
	function parse_PtgMemArea(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += (opts && opts.biff == 2 ? 3 : 4);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
	function parse_PtgMemFunc(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	
	/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
	function parse_PtgRefErr(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		if(opts.biff < 8) blob.l--;
		if(opts.biff == 12) blob.l += 2;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
	function parse_PtgRefErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 4;
		if(opts) switch(opts.biff) {
			case 5: w = 15; break;
			case 12: w = 6; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
	var parse_PtgMemErr = parsenoop;
	/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
	var parse_PtgMemNoMem = parsenoop;
	/* [MS-XLS] 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	function parse_PtgElfLoc(blob, length, opts) {
		blob.l += 2;
		return [parse_RgceElfLoc(blob, 4, opts)];
	}
	function parse_PtgElfNoop(blob) {
		blob.l += 6;
		return [];
	}
	/* [MS-XLS] 2.5.198.46 */
	var parse_PtgElfCol = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.47 */
	var parse_PtgElfColS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.48 */
	var parse_PtgElfColSV = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.49 */
	var parse_PtgElfColV = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.50 */
	function parse_PtgElfLel(blob) {
		blob.l += 2;
		return [parseuint16(blob), blob.read_shift(2) & 0x01];
	}
	/* [MS-XLS] 2.5.198.51 */
	var parse_PtgElfRadical = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.52 */
	var parse_PtgElfRadicalLel = parse_PtgElfLel;
	/* [MS-XLS] 2.5.198.53 */
	var parse_PtgElfRadicalS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.54 */
	var parse_PtgElfRw = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.55 */
	var parse_PtgElfRwV = parse_PtgElfLoc;
	
	/* [MS-XLSB] 2.5.97.52 TODO */
	var PtgListRT = [
		"Data",
		"All",
		"Headers",
		"??",
		"?Data2",
		"??",
		"?DataHeaders",
		"??",
		"Totals",
		"??",
		"??",
		"??",
		"?DataTotals",
		"??",
		"??",
		"??",
		"?Current"
	];
	function parse_PtgList(blob) {
		blob.l += 2;
		var ixti = blob.read_shift(2);
		var flags = blob.read_shift(2);
		var idx = blob.read_shift(4);
		var c = blob.read_shift(2);
		var C = blob.read_shift(2);
		var rt = PtgListRT[(flags >> 2) & 0x1F];
		return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
	}
	/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
	function parse_PtgSxName(blob) {
		blob.l += 2;
		return [blob.read_shift(4)];
	}
	
	/* [XLS] old spec */
	function parse_PtgSheet(blob, length, opts) {
		blob.l += 5;
		blob.l += 2;
		blob.l += (opts.biff == 2 ? 1 : 4);
		return ["PTGSHEET"];
	}
	function parse_PtgEndSheet(blob, length, opts) {
		blob.l += (opts.biff == 2 ? 4 : 5);
		return ["PTGENDSHEET"];
	}
	function parse_PtgMemAreaN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgMemNoMemN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgAttrNoop(blob) {
		blob.l += 4;
		return [0, 0];
	}
	
	/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
	var PtgTypes = {
	0x01: { n:'PtgExp', f:parse_PtgExp },
	0x02: { n:'PtgTbl', f:parse_PtgTbl },
	0x03: { n:'PtgAdd', f:parseread1 },
	0x04: { n:'PtgSub', f:parseread1 },
	0x05: { n:'PtgMul', f:parseread1 },
	0x06: { n:'PtgDiv', f:parseread1 },
	0x07: { n:'PtgPower', f:parseread1 },
	0x08: { n:'PtgConcat', f:parseread1 },
	0x09: { n:'PtgLt', f:parseread1 },
	0x0A: { n:'PtgLe', f:parseread1 },
	0x0B: { n:'PtgEq', f:parseread1 },
	0x0C: { n:'PtgGe', f:parseread1 },
	0x0D: { n:'PtgGt', f:parseread1 },
	0x0E: { n:'PtgNe', f:parseread1 },
	0x0F: { n:'PtgIsect', f:parseread1 },
	0x10: { n:'PtgUnion', f:parseread1 },
	0x11: { n:'PtgRange', f:parseread1 },
	0x12: { n:'PtgUplus', f:parseread1 },
	0x13: { n:'PtgUminus', f:parseread1 },
	0x14: { n:'PtgPercent', f:parseread1 },
	0x15: { n:'PtgParen', f:parseread1 },
	0x16: { n:'PtgMissArg', f:parseread1 },
	0x17: { n:'PtgStr', f:parse_PtgStr },
	0x1A: { n:'PtgSheet', f:parse_PtgSheet },
	0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	0x1C: { n:'PtgErr', f:parse_PtgErr },
	0x1D: { n:'PtgBool', f:parse_PtgBool },
	0x1E: { n:'PtgInt', f:parse_PtgInt },
	0x1F: { n:'PtgNum', f:parse_PtgNum },
	0x20: { n:'PtgArray', f:parse_PtgArray },
	0x21: { n:'PtgFunc', f:parse_PtgFunc },
	0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	0x23: { n:'PtgName', f:parse_PtgName },
	0x24: { n:'PtgRef', f:parse_PtgRef },
	0x25: { n:'PtgArea', f:parse_PtgArea },
	0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
	0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
	0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
	0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	0x2C: { n:'PtgRefN', f:parse_PtgRefN },
	0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
	0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	0x39: { n:'PtgNameX', f:parse_PtgNameX },
	0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
	0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
	0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
	0x40: 0x20, 0x60: 0x20,
	0x41: 0x21, 0x61: 0x21,
	0x42: 0x22, 0x62: 0x22,
	0x43: 0x23, 0x63: 0x23,
	0x44: 0x24, 0x64: 0x24,
	0x45: 0x25, 0x65: 0x25,
	0x46: 0x26, 0x66: 0x26,
	0x47: 0x27, 0x67: 0x27,
	0x48: 0x28, 0x68: 0x28,
	0x49: 0x29, 0x69: 0x29,
	0x4A: 0x2A, 0x6A: 0x2A,
	0x4B: 0x2B, 0x6B: 0x2B,
	0x4C: 0x2C, 0x6C: 0x2C,
	0x4D: 0x2D, 0x6D: 0x2D,
	0x4E: 0x2E, 0x6E: 0x2E,
	0x4F: 0x2F, 0x6F: 0x2F,
	0x58: 0x22, 0x78: 0x22,
	0x59: 0x39, 0x79: 0x39,
	0x5A: 0x3A, 0x7A: 0x3A,
	0x5B: 0x3B, 0x7B: 0x3B,
	0x5C: 0x3C, 0x7C: 0x3C,
	0x5D: 0x3D, 0x7D: 0x3D
	};
	
	var Ptg18 = {
	0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
	0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
	0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
	0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
	0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
	0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	0x19: { n:'PtgList', f:parse_PtgList },
	0x1D: { n:'PtgSxName', f:parse_PtgSxName },
	0xFF: {}
	};
	var Ptg19 = {
	0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x21: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	0xFF: {}
	};
	
	/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
					o.push(rgce[i][2]);
					break;
				case 'PtgExp': /* PtgExp -> PtgExtraCol */
					if(opts && opts.biff == 12) {
						rgce[i][1][1] = blob.read_shift(4);
						o.push(rgce[i][1]);
					} break;
				case 'PtgList': /* TODO: PtgList -> PtgExtraList */
				case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
				case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
				case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
					throw "Unsupported " + rgce[i][0];
				default: break;
			}
		}
		length = target - blob.l;
		/* note: this is technically an error but Excel disregards */
		//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
	function parse_Rgce(blob, length, opts) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
			if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
			if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
			else { ptgs.push([R.n, R.f(blob, length, opts)]); }
		}
		return ptgs;
	}
	
	function stringify_array(f) {
		var o = [];
		for(var i = 0; i < f.length; ++i) {
			var x = f[i], r = [];
			for(var j = 0; j < x.length; ++j) {
				var y = x[j];
				if(y) switch(y[0]) {
					// TODO: handle embedded quotes
					case 0x02:
	r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
					default: r.push(y[1]);
				} else r.push("");
			}
			o.push(r.join(","));
		}
		return o.join(";");
	}
	
	/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
	var PtgBinOp = {
		PtgAdd: "+",
		PtgConcat: "&",
		PtgDiv: "/",
		PtgEq: "=",
		PtgGe: ">=",
		PtgGt: ">",
		PtgLe: "<=",
		PtgLt: "<",
		PtgMul: "*",
		PtgNe: "<>",
		PtgPower: "^",
		PtgSub: "-"
	};
	
	// List of invalid characters needs to be tested further
	function formula_quote_sheet_name(sname, opts) {
		if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
		if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
		return sname;
	}
	function get_ixti_raw(supbooks, ixti, opts) {
		if(!supbooks) return "SH33TJSERR0";
		if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
		if(!supbooks.XTI) return "SH33TJSERR6";
		var XTI = supbooks.XTI[ixti];
		if(opts.biff < 8) {
			if(ixti > 10000) ixti-= 65536;
			if(ixti < 0) ixti = -ixti;
			return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
		}
		if(!XTI) return "SH33TJSERR1";
		var o = "";
		if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
			case 0x0165: /* 'BrtSupSelf' */
				o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x0166: /* 'BrtSupSame' */
				if(opts.SID != null) return supbooks.SheetNames[opts.SID];
				return "SH33TJSSAME" + supbooks[XTI[0]][0];
			case 0x0163: /* 'BrtSupBookSrc' */
				/* falls through */
			default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
		}
		switch(supbooks[XTI[0]][0][0]) {
			case 0x0401:
				o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
			default:
				if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
				o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
		}
	}
	function get_ixti(supbooks, ixti, opts) {
		var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
		return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
	}
	function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
		var biff = (opts && opts.biff) || 8;
		var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
		var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
		if(!formula[0] || !formula[0][0]) return "";
		var last_sp = -1, sp = "";
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			switch(f[0]) {
				case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
					stack.push("-" + stack.pop()); break;
				case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
					stack.push("+" + stack.pop()); break;
				case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
					stack.push(stack.pop() + "%"); break;
	
				case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
				case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
				case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
				case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
				case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
				case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
				case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
				case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
				case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
				case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
				case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
				case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
					e1 = stack.pop(); e2 = stack.pop();
					if(last_sp >= 0) {
						switch(formula[0][last_sp][1][0]) {
							case 0:
								// $FlowIgnore
								sp = fill(" ", formula[0][last_sp][1][1]); break;
							case 1:
								// $FlowIgnore
								sp = fill("\r", formula[0][last_sp][1][1]); break;
							default:
								sp = "";
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						e2 = e2 + sp;
						last_sp = -1;
					}
					stack.push(e2+PtgBinOp[f[0]]+e1);
					break;
	
				case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+":"+e1);
					break;
	
				case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
					break;
				case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
					break;
				case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
					break;
				case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
					break;
	
	
				case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
	c = shift_cell_xls((f[1][1]), _range, opts);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
	c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
	ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
					sname = get_ixti(supbooks, ixti, opts);
					var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
					stack.push(sname + "!" + encode_cell_xls(c, biff));
					break;
	
				case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
				case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
					/* f[1] = [argc, func, type] */
					var argc = (f[1][0]), func = (f[1][1]);
					if(!argc) argc = 0;
					argc &= 0x7F;
					var args = argc == 0 ? [] : stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
					stack.push(f[1] ? "TRUE" : "FALSE"); break;
				case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
					stack.push(f[1]); break;
				case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
					stack.push(String(f[1])); break;
				case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
					// $FlowIgnore
					stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
				case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
					stack.push(f[1]); break;
				case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
	r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
	r = shift_range_xls(f[1][1], _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
	ixti = f[1][1]; r = f[1][2];
					sname = get_ixti(supbooks, ixti, opts);
					stack.push(sname + "!" + encode_range_xls((r), opts));
					break;
				case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
				case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
				case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
					break;
	
				case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
					/* f[1] = type, 0, nameindex */
					nameidx = (f[1][2]);
					var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
					var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
					/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
					if(name && name.slice(0,6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
					stack.push(name);
					break;
	
				case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
					/* f[1] = type, ixti, nameindex */
					var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
					/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
					if(opts.biff <= 5) {
						if(bookidx < 0) bookidx = -bookidx;
						if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
					} else {
						var o = "";
						if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
						else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
							if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
								o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
							}
						}
						else o = supbooks.SheetNames[nameidx-1]+ "!";
						if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
						else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
						else {
							var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
							if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
							else o += "SH33TJSERRX";
						}
						stack.push(o);
						break;
					}
					if(!externbook) externbook = {Name: "SH33TJSERRY"};
					stack.push(externbook.Name);
					break;
	
				case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
					var lp = '(', rp = ')';
					if(last_sp >= 0) {
						sp = "";
						switch(formula[0][last_sp][1][0]) {
							// $FlowIgnore
							case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
							// $FlowIgnore
							case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
							default:
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						last_sp = -1;
					}
					stack.push(lp + stack.pop() + rp); break;
	
				case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
					stack.push('#REF!'); break;
	
				case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
					stack.push('#REF!'); break;
	
				case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
					c = {c:(f[1][1]),r:(f[1][0])};
					var q = ({c: cell.c, r:cell.r});
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					} else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
							fnd = true;
							break;
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
					stack.push("{" + stringify_array(f[1]) + "}");
					break;
	
				case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
				case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
					last_sp = ff;
					break;
	
				case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
					break;
	
				case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
					break;
	
				case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
					stack.push("");
					break;
	
				case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
					stack.push("#REF!"); break;
	
				case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
					stack.push("#REF!"); break;
	
				case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
					// $FlowIgnore
					stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
					break;
	
				case 'PtgMemAreaN':
				case 'PtgMemNoMemN':
				case 'PtgAttrNoop':
				case 'PtgSheet':
				case 'PtgEndSheet':
					break;
	
				case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
					break;
				case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
					break;
	
				case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
				case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
				case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
				case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
				case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
				case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
				case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
				case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
				case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
				case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
					throw new Error("Unsupported ELFs");
	
				case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
				default: throw new Error('Unrecognized Formula Token: ' + String(f));
			}
			var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
			if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
				f = formula[0][last_sp];
				var _left = true;
				switch(f[1][0]) {
					/* note: some bad XLSB files omit the PtgParen */
					case 4: _left = false;
					/* falls through */
					case 0:
						// $FlowIgnore
						sp = fill(" ", f[1][1]); break;
					case 5: _left = false;
					/* falls through */
					case 1:
						// $FlowIgnore
						sp = fill("\r", f[1][1]); break;
					default:
						sp = "";
						// $FlowIgnore
						if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
				}
				stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
				last_sp = -1;
			}
		}
		if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
		return stack[0];
	}
	
	/* [MS-XLS] 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce, opts);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce, opts);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
		return [];
	}
	function write_FormulaValue(value) {
		if(value == null) {
			// Blank String Value
			var o = new_buf(8);
			o.write_shift(1, 0x03);
			o.write_shift(1, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		} else if(typeof value == "number") return write_Xnum(value);
		return write_Xnum(0);
	}
	
	/* [MS-XLS] 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		if(opts.biff != 2) {
			blob.read_shift(1);
			if(opts.biff >= 5) {
				/*var chn = */blob.read_shift(4);
			}
		}
		var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	function write_Formula(cell, R, C, opts, os) {
		// Cell
		var o1 = write_XLSCell(R, C, os);
	
		// FormulaValue
		var o2 = write_FormulaValue(cell.v);
	
		// flags + cache
		var o3 = new_buf(6);
		var flags = 0x01 | 0x20;
		o3.write_shift(2, flags);
		o3.write_shift(4, 0);
	
		// CellParsedFormula
		var bf = new_buf(cell.bf.length);
		for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];
	
		var out = bconcat([o1, o2, o3, bf]);
		return out;
	}
	
	
	/* XLSB Parsed Formula records have the same shape */
	function parse_XLSBParsedFormula(data, length, opts) {
		var cce = data.read_shift(4);
		var rgce = parse_Rgce(data, cce, opts);
		var cb = data.read_shift(4);
		var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
		return [rgce, rgcb];
	}
	
	/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
	var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
	var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
	//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
	//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
	/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
	var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
	var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
	var Cetab = {
	  0: "BEEP",
	  1: "OPEN",
	  2: "OPEN.LINKS",
	  3: "CLOSE.ALL",
	  4: "SAVE",
	  5: "SAVE.AS",
	  6: "FILE.DELETE",
	  7: "PAGE.SETUP",
	  8: "PRINT",
	  9: "PRINTER.SETUP",
	  10: "QUIT",
	  11: "NEW.WINDOW",
	  12: "ARRANGE.ALL",
	  13: "WINDOW.SIZE",
	  14: "WINDOW.MOVE",
	  15: "FULL",
	  16: "CLOSE",
	  17: "RUN",
	  22: "SET.PRINT.AREA",
	  23: "SET.PRINT.TITLES",
	  24: "SET.PAGE.BREAK",
	  25: "REMOVE.PAGE.BREAK",
	  26: "FONT",
	  27: "DISPLAY",
	  28: "PROTECT.DOCUMENT",
	  29: "PRECISION",
	  30: "A1.R1C1",
	  31: "CALCULATE.NOW",
	  32: "CALCULATION",
	  34: "DATA.FIND",
	  35: "EXTRACT",
	  36: "DATA.DELETE",
	  37: "SET.DATABASE",
	  38: "SET.CRITERIA",
	  39: "SORT",
	  40: "DATA.SERIES",
	  41: "TABLE",
	  42: "FORMAT.NUMBER",
	  43: "ALIGNMENT",
	  44: "STYLE",
	  45: "BORDER",
	  46: "CELL.PROTECTION",
	  47: "COLUMN.WIDTH",
	  48: "UNDO",
	  49: "CUT",
	  50: "COPY",
	  51: "PASTE",
	  52: "CLEAR",
	  53: "PASTE.SPECIAL",
	  54: "EDIT.DELETE",
	  55: "INSERT",
	  56: "FILL.RIGHT",
	  57: "FILL.DOWN",
	  61: "DEFINE.NAME",
	  62: "CREATE.NAMES",
	  63: "FORMULA.GOTO",
	  64: "FORMULA.FIND",
	  65: "SELECT.LAST.CELL",
	  66: "SHOW.ACTIVE.CELL",
	  67: "GALLERY.AREA",
	  68: "GALLERY.BAR",
	  69: "GALLERY.COLUMN",
	  70: "GALLERY.LINE",
	  71: "GALLERY.PIE",
	  72: "GALLERY.SCATTER",
	  73: "COMBINATION",
	  74: "PREFERRED",
	  75: "ADD.OVERLAY",
	  76: "GRIDLINES",
	  77: "SET.PREFERRED",
	  78: "AXES",
	  79: "LEGEND",
	  80: "ATTACH.TEXT",
	  81: "ADD.ARROW",
	  82: "SELECT.CHART",
	  83: "SELECT.PLOT.AREA",
	  84: "PATTERNS",
	  85: "MAIN.CHART",
	  86: "OVERLAY",
	  87: "SCALE",
	  88: "FORMAT.LEGEND",
	  89: "FORMAT.TEXT",
	  90: "EDIT.REPEAT",
	  91: "PARSE",
	  92: "JUSTIFY",
	  93: "HIDE",
	  94: "UNHIDE",
	  95: "WORKSPACE",
	  96: "FORMULA",
	  97: "FORMULA.FILL",
	  98: "FORMULA.ARRAY",
	  99: "DATA.FIND.NEXT",
	  100: "DATA.FIND.PREV",
	  101: "FORMULA.FIND.NEXT",
	  102: "FORMULA.FIND.PREV",
	  103: "ACTIVATE",
	  104: "ACTIVATE.NEXT",
	  105: "ACTIVATE.PREV",
	  106: "UNLOCKED.NEXT",
	  107: "UNLOCKED.PREV",
	  108: "COPY.PICTURE",
	  109: "SELECT",
	  110: "DELETE.NAME",
	  111: "DELETE.FORMAT",
	  112: "VLINE",
	  113: "HLINE",
	  114: "VPAGE",
	  115: "HPAGE",
	  116: "VSCROLL",
	  117: "HSCROLL",
	  118: "ALERT",
	  119: "NEW",
	  120: "CANCEL.COPY",
	  121: "SHOW.CLIPBOARD",
	  122: "MESSAGE",
	  124: "PASTE.LINK",
	  125: "APP.ACTIVATE",
	  126: "DELETE.ARROW",
	  127: "ROW.HEIGHT",
	  128: "FORMAT.MOVE",
	  129: "FORMAT.SIZE",
	  130: "FORMULA.REPLACE",
	  131: "SEND.KEYS",
	  132: "SELECT.SPECIAL",
	  133: "APPLY.NAMES",
	  134: "REPLACE.FONT",
	  135: "FREEZE.PANES",
	  136: "SHOW.INFO",
	  137: "SPLIT",
	  138: "ON.WINDOW",
	  139: "ON.DATA",
	  140: "DISABLE.INPUT",
	  142: "OUTLINE",
	  143: "LIST.NAMES",
	  144: "FILE.CLOSE",
	  145: "SAVE.WORKBOOK",
	  146: "DATA.FORM",
	  147: "COPY.CHART",
	  148: "ON.TIME",
	  149: "WAIT",
	  150: "FORMAT.FONT",
	  151: "FILL.UP",
	  152: "FILL.LEFT",
	  153: "DELETE.OVERLAY",
	  155: "SHORT.MENUS",
	  159: "SET.UPDATE.STATUS",
	  161: "COLOR.PALETTE",
	  162: "DELETE.STYLE",
	  163: "WINDOW.RESTORE",
	  164: "WINDOW.MAXIMIZE",
	  166: "CHANGE.LINK",
	  167: "CALCULATE.DOCUMENT",
	  168: "ON.KEY",
	  169: "APP.RESTORE",
	  170: "APP.MOVE",
	  171: "APP.SIZE",
	  172: "APP.MINIMIZE",
	  173: "APP.MAXIMIZE",
	  174: "BRING.TO.FRONT",
	  175: "SEND.TO.BACK",
	  185: "MAIN.CHART.TYPE",
	  186: "OVERLAY.CHART.TYPE",
	  187: "SELECT.END",
	  188: "OPEN.MAIL",
	  189: "SEND.MAIL",
	  190: "STANDARD.FONT",
	  191: "CONSOLIDATE",
	  192: "SORT.SPECIAL",
	  193: "GALLERY.3D.AREA",
	  194: "GALLERY.3D.COLUMN",
	  195: "GALLERY.3D.LINE",
	  196: "GALLERY.3D.PIE",
	  197: "VIEW.3D",
	  198: "GOAL.SEEK",
	  199: "WORKGROUP",
	  200: "FILL.GROUP",
	  201: "UPDATE.LINK",
	  202: "PROMOTE",
	  203: "DEMOTE",
	  204: "SHOW.DETAIL",
	  206: "UNGROUP",
	  207: "OBJECT.PROPERTIES",
	  208: "SAVE.NEW.OBJECT",
	  209: "SHARE",
	  210: "SHARE.NAME",
	  211: "DUPLICATE",
	  212: "APPLY.STYLE",
	  213: "ASSIGN.TO.OBJECT",
	  214: "OBJECT.PROTECTION",
	  215: "HIDE.OBJECT",
	  216: "SET.EXTRACT",
	  217: "CREATE.PUBLISHER",
	  218: "SUBSCRIBE.TO",
	  219: "ATTRIBUTES",
	  220: "SHOW.TOOLBAR",
	  222: "PRINT.PREVIEW",
	  223: "EDIT.COLOR",
	  224: "SHOW.LEVELS",
	  225: "FORMAT.MAIN",
	  226: "FORMAT.OVERLAY",
	  227: "ON.RECALC",
	  228: "EDIT.SERIES",
	  229: "DEFINE.STYLE",
	  240: "LINE.PRINT",
	  243: "ENTER.DATA",
	  249: "GALLERY.RADAR",
	  250: "MERGE.STYLES",
	  251: "EDITION.OPTIONS",
	  252: "PASTE.PICTURE",
	  253: "PASTE.PICTURE.LINK",
	  254: "SPELLING",
	  256: "ZOOM",
	  259: "INSERT.OBJECT",
	  260: "WINDOW.MINIMIZE",
	  265: "SOUND.NOTE",
	  266: "SOUND.PLAY",
	  267: "FORMAT.SHAPE",
	  268: "EXTEND.POLYGON",
	  269: "FORMAT.AUTO",
	  272: "GALLERY.3D.BAR",
	  273: "GALLERY.3D.SURFACE",
	  274: "FILL.AUTO",
	  276: "CUSTOMIZE.TOOLBAR",
	  277: "ADD.TOOL",
	  278: "EDIT.OBJECT",
	  279: "ON.DOUBLECLICK",
	  280: "ON.ENTRY",
	  281: "WORKBOOK.ADD",
	  282: "WORKBOOK.MOVE",
	  283: "WORKBOOK.COPY",
	  284: "WORKBOOK.OPTIONS",
	  285: "SAVE.WORKSPACE",
	  288: "CHART.WIZARD",
	  289: "DELETE.TOOL",
	  290: "MOVE.TOOL",
	  291: "WORKBOOK.SELECT",
	  292: "WORKBOOK.ACTIVATE",
	  293: "ASSIGN.TO.TOOL",
	  295: "COPY.TOOL",
	  296: "RESET.TOOL",
	  297: "CONSTRAIN.NUMERIC",
	  298: "PASTE.TOOL",
	  302: "WORKBOOK.NEW",
	  305: "SCENARIO.CELLS",
	  306: "SCENARIO.DELETE",
	  307: "SCENARIO.ADD",
	  308: "SCENARIO.EDIT",
	  309: "SCENARIO.SHOW",
	  310: "SCENARIO.SHOW.NEXT",
	  311: "SCENARIO.SUMMARY",
	  312: "PIVOT.TABLE.WIZARD",
	  313: "PIVOT.FIELD.PROPERTIES",
	  314: "PIVOT.FIELD",
	  315: "PIVOT.ITEM",
	  316: "PIVOT.ADD.FIELDS",
	  318: "OPTIONS.CALCULATION",
	  319: "OPTIONS.EDIT",
	  320: "OPTIONS.VIEW",
	  321: "ADDIN.MANAGER",
	  322: "MENU.EDITOR",
	  323: "ATTACH.TOOLBARS",
	  324: "VBAActivate",
	  325: "OPTIONS.CHART",
	  328: "VBA.INSERT.FILE",
	  330: "VBA.PROCEDURE.DEFINITION",
	  336: "ROUTING.SLIP",
	  338: "ROUTE.DOCUMENT",
	  339: "MAIL.LOGON",
	  342: "INSERT.PICTURE",
	  343: "EDIT.TOOL",
	  344: "GALLERY.DOUGHNUT",
	  350: "CHART.TREND",
	  352: "PIVOT.ITEM.PROPERTIES",
	  354: "WORKBOOK.INSERT",
	  355: "OPTIONS.TRANSITION",
	  356: "OPTIONS.GENERAL",
	  370: "FILTER.ADVANCED",
	  373: "MAIL.ADD.MAILER",
	  374: "MAIL.DELETE.MAILER",
	  375: "MAIL.REPLY",
	  376: "MAIL.REPLY.ALL",
	  377: "MAIL.FORWARD",
	  378: "MAIL.NEXT.LETTER",
	  379: "DATA.LABEL",
	  380: "INSERT.TITLE",
	  381: "FONT.PROPERTIES",
	  382: "MACRO.OPTIONS",
	  383: "WORKBOOK.HIDE",
	  384: "WORKBOOK.UNHIDE",
	  385: "WORKBOOK.DELETE",
	  386: "WORKBOOK.NAME",
	  388: "GALLERY.CUSTOM",
	  390: "ADD.CHART.AUTOFORMAT",
	  391: "DELETE.CHART.AUTOFORMAT",
	  392: "CHART.ADD.DATA",
	  393: "AUTO.OUTLINE",
	  394: "TAB.ORDER",
	  395: "SHOW.DIALOG",
	  396: "SELECT.ALL",
	  397: "UNGROUP.SHEETS",
	  398: "SUBTOTAL.CREATE",
	  399: "SUBTOTAL.REMOVE",
	  400: "RENAME.OBJECT",
	  412: "WORKBOOK.SCROLL",
	  413: "WORKBOOK.NEXT",
	  414: "WORKBOOK.PREV",
	  415: "WORKBOOK.TAB.SPLIT",
	  416: "FULL.SCREEN",
	  417: "WORKBOOK.PROTECT",
	  420: "SCROLLBAR.PROPERTIES",
	  421: "PIVOT.SHOW.PAGES",
	  422: "TEXT.TO.COLUMNS",
	  423: "FORMAT.CHARTTYPE",
	  424: "LINK.FORMAT",
	  425: "TRACER.DISPLAY",
	  430: "TRACER.NAVIGATE",
	  431: "TRACER.CLEAR",
	  432: "TRACER.ERROR",
	  433: "PIVOT.FIELD.GROUP",
	  434: "PIVOT.FIELD.UNGROUP",
	  435: "CHECKBOX.PROPERTIES",
	  436: "LABEL.PROPERTIES",
	  437: "LISTBOX.PROPERTIES",
	  438: "EDITBOX.PROPERTIES",
	  439: "PIVOT.REFRESH",
	  440: "LINK.COMBO",
	  441: "OPEN.TEXT",
	  442: "HIDE.DIALOG",
	  443: "SET.DIALOG.FOCUS",
	  444: "ENABLE.OBJECT",
	  445: "PUSHBUTTON.PROPERTIES",
	  446: "SET.DIALOG.DEFAULT",
	  447: "FILTER",
	  448: "FILTER.SHOW.ALL",
	  449: "CLEAR.OUTLINE",
	  450: "FUNCTION.WIZARD",
	  451: "ADD.LIST.ITEM",
	  452: "SET.LIST.ITEM",
	  453: "REMOVE.LIST.ITEM",
	  454: "SELECT.LIST.ITEM",
	  455: "SET.CONTROL.VALUE",
	  456: "SAVE.COPY.AS",
	  458: "OPTIONS.LISTS.ADD",
	  459: "OPTIONS.LISTS.DELETE",
	  460: "SERIES.AXES",
	  461: "SERIES.X",
	  462: "SERIES.Y",
	  463: "ERRORBAR.X",
	  464: "ERRORBAR.Y",
	  465: "FORMAT.CHART",
	  466: "SERIES.ORDER",
	  467: "MAIL.LOGOFF",
	  468: "CLEAR.ROUTING.SLIP",
	  469: "APP.ACTIVATE.MICROSOFT",
	  470: "MAIL.EDIT.MAILER",
	  471: "ON.SHEET",
	  472: "STANDARD.WIDTH",
	  473: "SCENARIO.MERGE",
	  474: "SUMMARY.INFO",
	  475: "FIND.FILE",
	  476: "ACTIVE.CELL.FONT",
	  477: "ENABLE.TIPWIZARD",
	  478: "VBA.MAKE.ADDIN",
	  480: "INSERTDATATABLE",
	  481: "WORKGROUP.OPTIONS",
	  482: "MAIL.SEND.MAILER",
	  485: "AUTOCORRECT",
	  489: "POST.DOCUMENT",
	  491: "PICKLIST",
	  493: "VIEW.SHOW",
	  494: "VIEW.DEFINE",
	  495: "VIEW.DELETE",
	  509: "SHEET.BACKGROUND",
	  510: "INSERT.MAP.OBJECT",
	  511: "OPTIONS.MENONO",
	  517: "MSOCHECKS",
	  518: "NORMAL",
	  519: "LAYOUT",
	  520: "RM.PRINT.AREA",
	  521: "CLEAR.PRINT.AREA",
	  522: "ADD.PRINT.AREA",
	  523: "MOVE.BRK",
	  545: "HIDECURR.NOTE",
	  546: "HIDEALL.NOTES",
	  547: "DELETE.NOTE",
	  548: "TRAVERSE.NOTES",
	  549: "ACTIVATE.NOTES",
	  620: "PROTECT.REVISIONS",
	  621: "UNPROTECT.REVISIONS",
	  647: "OPTIONS.ME",
	  653: "WEB.PUBLISH",
	  667: "NEWWEBQUERY",
	  673: "PIVOT.TABLE.CHART",
	  753: "OPTIONS.SAVE",
	  755: "OPTIONS.SPELL",
	  808: "HIDEALL.INKANNOTS"
	};
	var Ftab = {
	  0: "COUNT",
	  1: "IF",
	  2: "ISNA",
	  3: "ISERROR",
	  4: "SUM",
	  5: "AVERAGE",
	  6: "MIN",
	  7: "MAX",
	  8: "ROW",
	  9: "COLUMN",
	  10: "NA",
	  11: "NPV",
	  12: "STDEV",
	  13: "DOLLAR",
	  14: "FIXED",
	  15: "SIN",
	  16: "COS",
	  17: "TAN",
	  18: "ATAN",
	  19: "PI",
	  20: "SQRT",
	  21: "EXP",
	  22: "LN",
	  23: "LOG10",
	  24: "ABS",
	  25: "INT",
	  26: "SIGN",
	  27: "ROUND",
	  28: "LOOKUP",
	  29: "INDEX",
	  30: "REPT",
	  31: "MID",
	  32: "LEN",
	  33: "VALUE",
	  34: "TRUE",
	  35: "FALSE",
	  36: "AND",
	  37: "OR",
	  38: "NOT",
	  39: "MOD",
	  40: "DCOUNT",
	  41: "DSUM",
	  42: "DAVERAGE",
	  43: "DMIN",
	  44: "DMAX",
	  45: "DSTDEV",
	  46: "VAR",
	  47: "DVAR",
	  48: "TEXT",
	  49: "LINEST",
	  50: "TREND",
	  51: "LOGEST",
	  52: "GROWTH",
	  53: "GOTO",
	  54: "HALT",
	  55: "RETURN",
	  56: "PV",
	  57: "FV",
	  58: "NPER",
	  59: "PMT",
	  60: "RATE",
	  61: "MIRR",
	  62: "IRR",
	  63: "RAND",
	  64: "MATCH",
	  65: "DATE",
	  66: "TIME",
	  67: "DAY",
	  68: "MONTH",
	  69: "YEAR",
	  70: "WEEKDAY",
	  71: "HOUR",
	  72: "MINUTE",
	  73: "SECOND",
	  74: "NOW",
	  75: "AREAS",
	  76: "ROWS",
	  77: "COLUMNS",
	  78: "OFFSET",
	  79: "ABSREF",
	  80: "RELREF",
	  81: "ARGUMENT",
	  82: "SEARCH",
	  83: "TRANSPOSE",
	  84: "ERROR",
	  85: "STEP",
	  86: "TYPE",
	  87: "ECHO",
	  88: "SET.NAME",
	  89: "CALLER",
	  90: "DEREF",
	  91: "WINDOWS",
	  92: "SERIES",
	  93: "DOCUMENTS",
	  94: "ACTIVE.CELL",
	  95: "SELECTION",
	  96: "RESULT",
	  97: "ATAN2",
	  98: "ASIN",
	  99: "ACOS",
	  100: "CHOOSE",
	  101: "HLOOKUP",
	  102: "VLOOKUP",
	  103: "LINKS",
	  104: "INPUT",
	  105: "ISREF",
	  106: "GET.FORMULA",
	  107: "GET.NAME",
	  108: "SET.VALUE",
	  109: "LOG",
	  110: "EXEC",
	  111: "CHAR",
	  112: "LOWER",
	  113: "UPPER",
	  114: "PROPER",
	  115: "LEFT",
	  116: "RIGHT",
	  117: "EXACT",
	  118: "TRIM",
	  119: "REPLACE",
	  120: "SUBSTITUTE",
	  121: "CODE",
	  122: "NAMES",
	  123: "DIRECTORY",
	  124: "FIND",
	  125: "CELL",
	  126: "ISERR",
	  127: "ISTEXT",
	  128: "ISNUMBER",
	  129: "ISBLANK",
	  130: "T",
	  131: "N",
	  132: "FOPEN",
	  133: "FCLOSE",
	  134: "FSIZE",
	  135: "FREADLN",
	  136: "FREAD",
	  137: "FWRITELN",
	  138: "FWRITE",
	  139: "FPOS",
	  140: "DATEVALUE",
	  141: "TIMEVALUE",
	  142: "SLN",
	  143: "SYD",
	  144: "DDB",
	  145: "GET.DEF",
	  146: "REFTEXT",
	  147: "TEXTREF",
	  148: "INDIRECT",
	  149: "REGISTER",
	  150: "CALL",
	  151: "ADD.BAR",
	  152: "ADD.MENU",
	  153: "ADD.COMMAND",
	  154: "ENABLE.COMMAND",
	  155: "CHECK.COMMAND",
	  156: "RENAME.COMMAND",
	  157: "SHOW.BAR",
	  158: "DELETE.MENU",
	  159: "DELETE.COMMAND",
	  160: "GET.CHART.ITEM",
	  161: "DIALOG.BOX",
	  162: "CLEAN",
	  163: "MDETERM",
	  164: "MINVERSE",
	  165: "MMULT",
	  166: "FILES",
	  167: "IPMT",
	  168: "PPMT",
	  169: "COUNTA",
	  170: "CANCEL.KEY",
	  171: "FOR",
	  172: "WHILE",
	  173: "BREAK",
	  174: "NEXT",
	  175: "INITIATE",
	  176: "REQUEST",
	  177: "POKE",
	  178: "EXECUTE",
	  179: "TERMINATE",
	  180: "RESTART",
	  181: "HELP",
	  182: "GET.BAR",
	  183: "PRODUCT",
	  184: "FACT",
	  185: "GET.CELL",
	  186: "GET.WORKSPACE",
	  187: "GET.WINDOW",
	  188: "GET.DOCUMENT",
	  189: "DPRODUCT",
	  190: "ISNONTEXT",
	  191: "GET.NOTE",
	  192: "NOTE",
	  193: "STDEVP",
	  194: "VARP",
	  195: "DSTDEVP",
	  196: "DVARP",
	  197: "TRUNC",
	  198: "ISLOGICAL",
	  199: "DCOUNTA",
	  200: "DELETE.BAR",
	  201: "UNREGISTER",
	  204: "USDOLLAR",
	  205: "FINDB",
	  206: "SEARCHB",
	  207: "REPLACEB",
	  208: "LEFTB",
	  209: "RIGHTB",
	  210: "MIDB",
	  211: "LENB",
	  212: "ROUNDUP",
	  213: "ROUNDDOWN",
	  214: "ASC",
	  215: "DBCS",
	  216: "RANK",
	  219: "ADDRESS",
	  220: "DAYS360",
	  221: "TODAY",
	  222: "VDB",
	  223: "ELSE",
	  224: "ELSE.IF",
	  225: "END.IF",
	  226: "FOR.CELL",
	  227: "MEDIAN",
	  228: "SUMPRODUCT",
	  229: "SINH",
	  230: "COSH",
	  231: "TANH",
	  232: "ASINH",
	  233: "ACOSH",
	  234: "ATANH",
	  235: "DGET",
	  236: "CREATE.OBJECT",
	  237: "VOLATILE",
	  238: "LAST.ERROR",
	  239: "CUSTOM.UNDO",
	  240: "CUSTOM.REPEAT",
	  241: "FORMULA.CONVERT",
	  242: "GET.LINK.INFO",
	  243: "TEXT.BOX",
	  244: "INFO",
	  245: "GROUP",
	  246: "GET.OBJECT",
	  247: "DB",
	  248: "PAUSE",
	  251: "RESUME",
	  252: "FREQUENCY",
	  253: "ADD.TOOLBAR",
	  254: "DELETE.TOOLBAR",
	  255: "User",
	  256: "RESET.TOOLBAR",
	  257: "EVALUATE",
	  258: "GET.TOOLBAR",
	  259: "GET.TOOL",
	  260: "SPELLING.CHECK",
	  261: "ERROR.TYPE",
	  262: "APP.TITLE",
	  263: "WINDOW.TITLE",
	  264: "SAVE.TOOLBAR",
	  265: "ENABLE.TOOL",
	  266: "PRESS.TOOL",
	  267: "REGISTER.ID",
	  268: "GET.WORKBOOK",
	  269: "AVEDEV",
	  270: "BETADIST",
	  271: "GAMMALN",
	  272: "BETAINV",
	  273: "BINOMDIST",
	  274: "CHIDIST",
	  275: "CHIINV",
	  276: "COMBIN",
	  277: "CONFIDENCE",
	  278: "CRITBINOM",
	  279: "EVEN",
	  280: "EXPONDIST",
	  281: "FDIST",
	  282: "FINV",
	  283: "FISHER",
	  284: "FISHERINV",
	  285: "FLOOR",
	  286: "GAMMADIST",
	  287: "GAMMAINV",
	  288: "CEILING",
	  289: "HYPGEOMDIST",
	  290: "LOGNORMDIST",
	  291: "LOGINV",
	  292: "NEGBINOMDIST",
	  293: "NORMDIST",
	  294: "NORMSDIST",
	  295: "NORMINV",
	  296: "NORMSINV",
	  297: "STANDARDIZE",
	  298: "ODD",
	  299: "PERMUT",
	  300: "POISSON",
	  301: "TDIST",
	  302: "WEIBULL",
	  303: "SUMXMY2",
	  304: "SUMX2MY2",
	  305: "SUMX2PY2",
	  306: "CHITEST",
	  307: "CORREL",
	  308: "COVAR",
	  309: "FORECAST",
	  310: "FTEST",
	  311: "INTERCEPT",
	  312: "PEARSON",
	  313: "RSQ",
	  314: "STEYX",
	  315: "SLOPE",
	  316: "TTEST",
	  317: "PROB",
	  318: "DEVSQ",
	  319: "GEOMEAN",
	  320: "HARMEAN",
	  321: "SUMSQ",
	  322: "KURT",
	  323: "SKEW",
	  324: "ZTEST",
	  325: "LARGE",
	  326: "SMALL",
	  327: "QUARTILE",
	  328: "PERCENTILE",
	  329: "PERCENTRANK",
	  330: "MODE",
	  331: "TRIMMEAN",
	  332: "TINV",
	  334: "MOVIE.COMMAND",
	  335: "GET.MOVIE",
	  336: "CONCATENATE",
	  337: "POWER",
	  338: "PIVOT.ADD.DATA",
	  339: "GET.PIVOT.TABLE",
	  340: "GET.PIVOT.FIELD",
	  341: "GET.PIVOT.ITEM",
	  342: "RADIANS",
	  343: "DEGREES",
	  344: "SUBTOTAL",
	  345: "SUMIF",
	  346: "COUNTIF",
	  347: "COUNTBLANK",
	  348: "SCENARIO.GET",
	  349: "OPTIONS.LISTS.GET",
	  350: "ISPMT",
	  351: "DATEDIF",
	  352: "DATESTRING",
	  353: "NUMBERSTRING",
	  354: "ROMAN",
	  355: "OPEN.DIALOG",
	  356: "SAVE.DIALOG",
	  357: "VIEW.GET",
	  358: "GETPIVOTDATA",
	  359: "HYPERLINK",
	  360: "PHONETIC",
	  361: "AVERAGEA",
	  362: "MAXA",
	  363: "MINA",
	  364: "STDEVPA",
	  365: "VARPA",
	  366: "STDEVA",
	  367: "VARA",
	  368: "BAHTTEXT",
	  369: "THAIDAYOFWEEK",
	  370: "THAIDIGIT",
	  371: "THAIMONTHOFYEAR",
	  372: "THAINUMSOUND",
	  373: "THAINUMSTRING",
	  374: "THAISTRINGLENGTH",
	  375: "ISTHAIDIGIT",
	  376: "ROUNDBAHTDOWN",
	  377: "ROUNDBAHTUP",
	  378: "THAIYEAR",
	  379: "RTD",
	  380: "CUBEVALUE",
	  381: "CUBEMEMBER",
	  382: "CUBEMEMBERPROPERTY",
	  383: "CUBERANKEDMEMBER",
	  384: "HEX2BIN",
	  385: "HEX2DEC",
	  386: "HEX2OCT",
	  387: "DEC2BIN",
	  388: "DEC2HEX",
	  389: "DEC2OCT",
	  390: "OCT2BIN",
	  391: "OCT2HEX",
	  392: "OCT2DEC",
	  393: "BIN2DEC",
	  394: "BIN2OCT",
	  395: "BIN2HEX",
	  396: "IMSUB",
	  397: "IMDIV",
	  398: "IMPOWER",
	  399: "IMABS",
	  400: "IMSQRT",
	  401: "IMLN",
	  402: "IMLOG2",
	  403: "IMLOG10",
	  404: "IMSIN",
	  405: "IMCOS",
	  406: "IMEXP",
	  407: "IMARGUMENT",
	  408: "IMCONJUGATE",
	  409: "IMAGINARY",
	  410: "IMREAL",
	  411: "COMPLEX",
	  412: "IMSUM",
	  413: "IMPRODUCT",
	  414: "SERIESSUM",
	  415: "FACTDOUBLE",
	  416: "SQRTPI",
	  417: "QUOTIENT",
	  418: "DELTA",
	  419: "GESTEP",
	  420: "ISEVEN",
	  421: "ISODD",
	  422: "MROUND",
	  423: "ERF",
	  424: "ERFC",
	  425: "BESSELJ",
	  426: "BESSELK",
	  427: "BESSELY",
	  428: "BESSELI",
	  429: "XIRR",
	  430: "XNPV",
	  431: "PRICEMAT",
	  432: "YIELDMAT",
	  433: "INTRATE",
	  434: "RECEIVED",
	  435: "DISC",
	  436: "PRICEDISC",
	  437: "YIELDDISC",
	  438: "TBILLEQ",
	  439: "TBILLPRICE",
	  440: "TBILLYIELD",
	  441: "PRICE",
	  442: "YIELD",
	  443: "DOLLARDE",
	  444: "DOLLARFR",
	  445: "NOMINAL",
	  446: "EFFECT",
	  447: "CUMPRINC",
	  448: "CUMIPMT",
	  449: "EDATE",
	  450: "EOMONTH",
	  451: "YEARFRAC",
	  452: "COUPDAYBS",
	  453: "COUPDAYS",
	  454: "COUPDAYSNC",
	  455: "COUPNCD",
	  456: "COUPNUM",
	  457: "COUPPCD",
	  458: "DURATION",
	  459: "MDURATION",
	  460: "ODDLPRICE",
	  461: "ODDLYIELD",
	  462: "ODDFPRICE",
	  463: "ODDFYIELD",
	  464: "RANDBETWEEN",
	  465: "WEEKNUM",
	  466: "AMORDEGRC",
	  467: "AMORLINC",
	  468: "CONVERT",
	  724: "SHEETJS",
	  469: "ACCRINT",
	  470: "ACCRINTM",
	  471: "WORKDAY",
	  472: "NETWORKDAYS",
	  473: "GCD",
	  474: "MULTINOMIAL",
	  475: "LCM",
	  476: "FVSCHEDULE",
	  477: "CUBEKPIMEMBER",
	  478: "CUBESET",
	  479: "CUBESETCOUNT",
	  480: "IFERROR",
	  481: "COUNTIFS",
	  482: "SUMIFS",
	  483: "AVERAGEIF",
	  484: "AVERAGEIFS"
	};
	var FtabArgc = {
	  2: 1,
	  3: 1,
	  10: 0,
	  15: 1,
	  16: 1,
	  17: 1,
	  18: 1,
	  19: 0,
	  20: 1,
	  21: 1,
	  22: 1,
	  23: 1,
	  24: 1,
	  25: 1,
	  26: 1,
	  27: 2,
	  30: 2,
	  31: 3,
	  32: 1,
	  33: 1,
	  34: 0,
	  35: 0,
	  38: 1,
	  39: 2,
	  40: 3,
	  41: 3,
	  42: 3,
	  43: 3,
	  44: 3,
	  45: 3,
	  47: 3,
	  48: 2,
	  53: 1,
	  61: 3,
	  63: 0,
	  65: 3,
	  66: 3,
	  67: 1,
	  68: 1,
	  69: 1,
	  70: 1,
	  71: 1,
	  72: 1,
	  73: 1,
	  74: 0,
	  75: 1,
	  76: 1,
	  77: 1,
	  79: 2,
	  80: 2,
	  83: 1,
	  85: 0,
	  86: 1,
	  89: 0,
	  90: 1,
	  94: 0,
	  95: 0,
	  97: 2,
	  98: 1,
	  99: 1,
	  101: 3,
	  102: 3,
	  105: 1,
	  106: 1,
	  108: 2,
	  111: 1,
	  112: 1,
	  113: 1,
	  114: 1,
	  117: 2,
	  118: 1,
	  119: 4,
	  121: 1,
	  126: 1,
	  127: 1,
	  128: 1,
	  129: 1,
	  130: 1,
	  131: 1,
	  133: 1,
	  134: 1,
	  135: 1,
	  136: 2,
	  137: 2,
	  138: 2,
	  140: 1,
	  141: 1,
	  142: 3,
	  143: 4,
	  144: 4,
	  161: 1,
	  162: 1,
	  163: 1,
	  164: 1,
	  165: 2,
	  172: 1,
	  175: 2,
	  176: 2,
	  177: 3,
	  178: 2,
	  179: 1,
	  184: 1,
	  186: 1,
	  189: 3,
	  190: 1,
	  195: 3,
	  196: 3,
	  197: 1,
	  198: 1,
	  199: 3,
	  201: 1,
	  207: 4,
	  210: 3,
	  211: 1,
	  212: 2,
	  213: 2,
	  214: 1,
	  215: 1,
	  225: 0,
	  229: 1,
	  230: 1,
	  231: 1,
	  232: 1,
	  233: 1,
	  234: 1,
	  235: 3,
	  244: 1,
	  247: 4,
	  252: 2,
	  257: 1,
	  261: 1,
	  271: 1,
	  273: 4,
	  274: 2,
	  275: 2,
	  276: 2,
	  277: 3,
	  278: 3,
	  279: 1,
	  280: 3,
	  281: 3,
	  282: 3,
	  283: 1,
	  284: 1,
	  285: 2,
	  286: 4,
	  287: 3,
	  288: 2,
	  289: 4,
	  290: 3,
	  291: 3,
	  292: 3,
	  293: 4,
	  294: 1,
	  295: 3,
	  296: 1,
	  297: 3,
	  298: 1,
	  299: 2,
	  300: 3,
	  301: 3,
	  302: 4,
	  303: 2,
	  304: 2,
	  305: 2,
	  306: 2,
	  307: 2,
	  308: 2,
	  309: 3,
	  310: 2,
	  311: 2,
	  312: 2,
	  313: 2,
	  314: 2,
	  315: 2,
	  316: 4,
	  325: 2,
	  326: 2,
	  327: 2,
	  328: 2,
	  331: 2,
	  332: 2,
	  337: 2,
	  342: 1,
	  343: 1,
	  346: 2,
	  347: 1,
	  350: 4,
	  351: 3,
	  352: 1,
	  353: 2,
	  360: 1,
	  368: 1,
	  369: 1,
	  370: 1,
	  371: 1,
	  372: 1,
	  373: 1,
	  374: 1,
	  375: 1,
	  376: 1,
	  377: 1,
	  378: 1,
	  382: 3,
	  385: 1,
	  392: 1,
	  393: 1,
	  396: 2,
	  397: 2,
	  398: 2,
	  399: 1,
	  400: 1,
	  401: 1,
	  402: 1,
	  403: 1,
	  404: 1,
	  405: 1,
	  406: 1,
	  407: 1,
	  408: 1,
	  409: 1,
	  410: 1,
	  414: 4,
	  415: 1,
	  416: 1,
	  417: 2,
	  420: 1,
	  421: 1,
	  422: 2,
	  424: 1,
	  425: 2,
	  426: 2,
	  427: 2,
	  428: 2,
	  430: 3,
	  438: 3,
	  439: 3,
	  440: 3,
	  443: 2,
	  444: 2,
	  445: 2,
	  446: 2,
	  447: 6,
	  448: 6,
	  449: 2,
	  450: 2,
	  464: 2,
	  468: 3,
	  476: 2,
	  479: 1,
	  480: 2,
	  65535: 0
	};
	/* Part 3 TODO: actually parse formulae */
	function ods_to_csf_formula(f) {
		if(f.slice(0,3) == "of:") f = f.slice(3);
		/* 5.2 Basic Expressions */
		if(f.charCodeAt(0) == 61) {
			f = f.slice(1);
			if(f.charCodeAt(0) == 61) f = f.slice(1);
		}
		f = f.replace(/COM\.MICROSOFT\./g, "");
		/* Part 3 Section 5.8 References */
		f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
		/* TODO: something other than this */
		f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
		return f.replace(/[;~]/g,",").replace(/\|/g,";");
	}
	
	function csf_to_ods_formula(f) {
		var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
		/* TODO: something other than this */
		return o.replace(/;/g, "|").replace(/,/g,";");
	}
	
	function ods_to_csf_3D(r) {
		var a = r.split(":");
		var s = a[0].split(".")[0];
		return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
	}
	
	function csf_to_ods_3D(r) {
		return r.replace(/\./,"!");
	}
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	
	/*global Map */
	var browser_has_Map = typeof Map !== 'undefined';
	
	function get_sst_id(sst, str, rev) {
		var i = 0, len = sst.length;
		if(rev) {
			if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
				var revarr = browser_has_Map ? rev.get(str) : rev[str];
				for(; i < revarr.length; ++i) {
					if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
				}
			}
		} else for(; i < len; ++i) {
			if(sst[i].t === str) { sst.Count ++; return i; }
		}
		sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
		if(rev) {
			if(browser_has_Map) {
				if(!rev.has(str)) rev.set(str, []);
				rev.get(str).push(len);
			} else {
				if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
				rev[str].push(len);
			}
		}
		return len;
	}
	
	function col_obj_w(C, col) {
		var p = ({min:C+1,max:C+1});
		/* wch (chars), wpx (pixels) */
		var wch = -1;
		if(col.MDW) MDW = col.MDW;
		if(col.width != null) p.customWidth = 1;
		else if(col.wpx != null) wch = px2char(col.wpx);
		else if(col.wch != null) wch = col.wch;
		if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
		else if(col.width != null) p.width = col.width;
		if(col.hidden) p.hidden = true;
		if(col.level != null) { p.outlineLevel = p.level = col.level; }
		return p;
	}
	
	function default_margins(margins, mode) {
		if(!margins) return;
		var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
		if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
		if(margins.left   == null) margins.left   = defs[0];
		if(margins.right  == null) margins.right  = defs[1];
		if(margins.top    == null) margins.top    = defs[2];
		if(margins.bottom == null) margins.bottom = defs[3];
		if(margins.header == null) margins.header = defs[4];
		if(margins.footer == null) margins.footer = defs[5];
	}
	
	function get_cell_style(styles, cell, opts) {
		var z = opts.revssf[cell.z != null ? cell.z : "General"];
		var i = 0x3c, len = styles.length;
		if(z == null && opts.ssf) {
			for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
				SSF_load(cell.z, i);
				// $FlowIgnore
				opts.ssf[i] = cell.z;
				opts.revssf[cell.z] = z = i;
				break;
			}
		}
		for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
		styles[len] = {
			numFmtId:z,
			fontId:0,
			fillId:0,
			borderId:0,
			xfId:0,
			applyNumberFormat:1
		};
		return len;
	}
	
	function safe_format(p, fmtid, fillid, opts, themes, styles) {
		try {
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(p.t === 'z' && !opts.cellStyles) return;
		if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
		if((!opts || opts.cellText !== false) && p.t !== 'z') try {
			if(table_fmt[fmtid] == null) SSF_load(SSFImplicit[fmtid] || "General", fmtid);
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = dd.toString(10);
					else p.w = SSF_general_num(dd);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF_general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF_format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF_format(fmtid,p.v,_ssfopts);
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts.cellStyles) return;
		if(fillid != null) try {
			p.s = styles.Fills[fillid];
			if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
				p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
				if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
			}
			if (p.s.bgColor && p.s.bgColor.theme) {
				p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
				if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
			}
		} catch(e) { if(opts.WTF && styles.Fills) throw e; }
	}
	
	function check_ws(ws, sname, i) {
		if(ws && ws['!ref']) {
			var range = safe_decode_range(ws['!ref']);
			if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
		}
	}
	function parse_ws_xml_dim(ws, s) {
		var d = safe_decode_range(s);
		if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
	var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
	var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
	var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
	var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
	var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
	
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	
		/* 18.3.1.99 worksheet CT_Worksheet */
		var s = opts.dense ? ([]) : ({});
		var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });
	
		var data1 = "", data2 = "";
		var mtch = data.match(sheetdataregex);
		if(mtch) {
			data1 = data.slice(0, mtch.index);
			data2 = data.slice(mtch.index + mtch[0].length);
		} else data1 = data2 = data;
	
		/* 18.3.1.82 sheetPr CT_SheetPr */
		var sheetPr = data1.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
		else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx, styles, themes);
	
		/* 18.3.1.35 dimension CT_SheetDimension */
		var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
		if(ridx > 0) {
			var ref = data1.slice(ridx,ridx+50).match(dimregex);
			if(ref) parse_ws_xml_dim(s, ref[1]);
		}
	
		/* 18.3.1.88 sheetViews CT_SheetViews */
		var svs = data1.match(svsregex);
		if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
	
		/* 18.3.1.17 cols CT_Cols */
		var columns = [];
		if(opts.cellStyles) {
			/* 18.3.1.13 col CT_Col */
			var cols = data1.match(colregex);
			if(cols) parse_ws_xml_cols(columns, cols);
		}
	
		/* 18.3.1.80 sheetData CT_SheetData ? */
		if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
	
		/* 18.3.1.2  autoFilter CT_AutoFilter */
		var afilter = data2.match(afregex);
		if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
	
		/* 18.3.1.55 mergeCells CT_MergeCells */
		var merges = [];
		var _merge = data2.match(mergecregex);
		if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
			merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));
	
		/* 18.3.1.48 hyperlinks CT_Hyperlinks */
		var hlink = data2.match(hlinkregex);
		if(hlink) parse_ws_xml_hlinks(s, hlink, rels);
	
		/* 18.3.1.62 pageMargins CT_PageMargins */
		var margins = data2.match(marginregex);
		if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
	
		if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
		if(opts.sheetRows > 0 && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(columns.length > 0) s["!cols"] = columns;
		if(merges.length > 0) s["!merges"] = merges;
		return s;
	}
	
	function write_ws_xml_merges(merges) {
		if(merges.length === 0) return "";
		var o = '<mergeCells count="' + merges.length + '">';
		for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
		return o + '</mergeCells>';
	}
	
	/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
	function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
		var data = parsexmltag(sheetPr);
		if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
		if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
	}
	function parse_ws_xml_sheetpr2(sheetPr, body, s, wb, idx) {
		parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
	}
	function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
		var needed = false;
		var props = {}, payload = null;
		if(opts.bookType !== 'xlsx' && wb.vbaraw) {
			var cname = wb.SheetNames[idx];
			try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
			needed = true;
			props.codeName = utf8write(escapexml(cname));
		}
	
		if(ws && ws["!outline"]) {
			var outlineprops = {summaryBelow:1, summaryRight:1};
			if(ws["!outline"].above) outlineprops.summaryBelow = 0;
			if(ws["!outline"].left) outlineprops.summaryRight = 0;
			payload = (payload||"") + writextag('outlinePr', null, outlineprops);
		}
	
		if(!needed && !payload) return;
		o[o.length] = (writextag('sheetPr', payload, props));
	}
	
	/* 18.3.1.85 sheetProtection CT_SheetProtection */
	var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var sheetprot_deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	function write_ws_xml_protection(sp) {
		// algorithmName, hashValue, saltValue, spinCount
		var o = ({sheet:1});
		sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
		sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
		/* TODO: algorithm */
		if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
		return writextag('sheetProtection', null, o);
	}
	
	function parse_ws_xml_hlinks(s, data, rels) {
		var dense = Array.isArray(s);
		for(var i = 0; i != data.length; ++i) {
			var val = parsexmltag(utf8read(data[i]), true);
			if(!val.ref) return;
			var rel = ((rels || {})['!id']||[])[val.id];
			if(rel) {
				val.Target = rel.Target;
				if(val.location) val.Target += "#"+unescapexml(val.location);
			} else {
				val.Target = "#" + unescapexml(val.location);
				rel = {Target: val.Target, TargetMode: 'Internal'};
			}
			val.Rel = rel;
			if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
			var rng = safe_decode_range(val.ref);
			for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
				var addr = encode_cell({c:C,r:R});
				if(dense) {
					if(!s[R]) s[R] = [];
					if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
					s[R][C].l = val;
				} else {
					if(!s[addr]) s[addr] = {t:"z",v:undefined};
					s[addr].l = val;
				}
			}
		}
	}
	
	function parse_ws_xml_margins(margin) {
		var o = {};
		["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
			if(margin[k]) o[k] = parseFloat(margin[k]);
		});
		return o;
	}
	function write_ws_xml_margins(margin) {
		default_margins(margin);
		return writextag('pageMargins', null, margin);
	}
	
	function parse_ws_xml_cols(columns, cols) {
		var seencol = false;
		for(var coli = 0; coli != cols.length; ++coli) {
			var coll = parsexmltag(cols[coli], true);
			if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
			var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
			if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
			delete coll.min; delete coll.max; coll.width = +coll.width;
			if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
			process_col(coll);
			while(colm <= colM) columns[colm++] = dup(coll);
		}
	}
	function write_ws_xml_cols(ws, cols) {
		var o = ["<cols>"], col;
		for(var i = 0; i != cols.length; ++i) {
			if(!(col = cols[i])) continue;
			o[o.length] = (writextag('col', null, col_obj_w(i, col)));
		}
		o[o.length] = "</cols>";
		return o.join("");
	}
	
	function parse_ws_xml_autofilter(data) {
		var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
		return o;
	}
	function write_ws_xml_autofilter(data, ws, wb, idx) {
		var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
		return writextag("autoFilter", null, {ref:ref});
	}
	
	/* 18.3.1.88 sheetViews CT_SheetViews */
	/* 18.3.1.87 sheetView CT_SheetView */
	var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
	function parse_ws_xml_sheetviews(data, wb) {
		if(!wb.Views) wb.Views = [{}];
		(data.match(sviewregex)||[]).forEach(function(r, i) {
			var tag = parsexmltag(r);
			// $FlowIgnore
			if(!wb.Views[i]) wb.Views[i] = {};
			// $FlowIgnore
			if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
			// $FlowIgnore
			if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
		});
	}
	function write_ws_xml_sheetviews(ws, opts, idx, wb) {
		var sview = ({workbookViewId:"0"});
		// $FlowIgnore
		if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
		return writextag("sheetViews", writextag("sheetView", null, sview), {});
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts) {
		if(cell.c) ws['!comments'].push([ref, cell.c]);
		if(cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z' && !cell.f) return "";
		var vv = "";
		var oldt = cell.t, oldv = cell.v;
		if(cell.t !== "z") switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': vv = ''+cell.v; break;
			case 'e': vv = BErr[cell.v]; break;
			case 'd':
				if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
				else {
					cell = dup(cell);
					cell.t = 'n';
					vv = ''+(cell.v = datenum(parseDate(cell.v)));
				}
				if(typeof cell.z === 'undefined') cell.z = table_fmt[14];
				break;
			default: vv = cell.v; break;
		}
		var v = writetag('v', escapexml(vv)), o = ({r:ref});
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		if(os !== 0) o.s = os;
		switch(cell.t) {
			case 'n': break;
			case 'd': o.t = "d"; break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
			case 'z': break;
			default: if(cell.v == null) { delete cell.t; break; }
				if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
				if(opts && opts.bookSST) {
					v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
					o.t = "s"; break;
				}
				o.t = "str"; break;
		}
		if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
		if(typeof cell.f == "string" && cell.f) {
			var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
			v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
		}
		if(cell.l) ws['!links'].push([ref, cell.l]);
		if(cell.D) o.cm = 1;
		return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function() {
		var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
		var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
		var refregex = /ref=["']([^"']*)["']/;
		var match_v = matchtag("v"), match_f = matchtag("f");
	
	return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
		var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
		var tag, tagr = 0, tagc = 0;
		var sstr, ftag;
		var fmtid = 0, fillid = 0;
		var do_format = Array.isArray(styles.CellXf), cf;
		var arrayf = [];
		var sharedf = [];
		var dense = Array.isArray(s);
		var rows = [], rowobj = {}, rowrite = false;
		var sheetStubs = !!opts.sheetStubs;
		for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
			x = marr[mt].trim();
			var xlen = x.length;
			if(xlen === 0) continue;
	
			/* 18.3.1.73 row CT_Row */
			var rstarti = 0;
			outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
				case ">" /*62*/:
					if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
					if(opts && opts.cellStyles) {
						// TODO: avoid duplication
						tag = parsexmltag(x.slice(rstarti,ri), true);
						tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
						if(opts.sheetRows && opts.sheetRows < tagr) continue;
						rowobj = {}; rowrite = false;
						if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
						if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
						if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
						if(rowrite) rows[tagr-1] = rowobj;
					}
					break;
				case "<" /*60*/: rstarti = ri; break;
			}
			if(rstarti >= ri) break;
			tag = parsexmltag(x.slice(rstarti,ri), true);
			tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
			if(opts.sheetRows && opts.sheetRows < tagr) continue;
			if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
			if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
			if(opts && opts.cellStyles) {
				rowobj = {}; rowrite = false;
				if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
				if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
				if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
				if(rowrite) rows[tagr-1] = rowobj;
			}
	
			/* 18.3.1.4 c CT_Cell */
			cells = x.slice(ri).split(cellregex);
			for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
			cells = cells.slice(rslice);
			for(ri = 0; ri != cells.length; ++ri) {
				x = cells[ri].trim();
				if(x.length === 0) continue;
				cref = x.match(rregex); idx = ri; i=0; cc=0;
				x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
				if(cref != null && cref.length === 2) {
					idx = 0; d=cref[1];
					for(i=0; i != d.length; ++i) {
						if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
						idx = 26*idx + cc;
					}
					--idx;
					tagc = idx;
				} else ++tagc;
				for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
				tag = parsexmltag(x.slice(0,i), true);
				if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
				d = x.slice(i);
				p = ({t:""});
	
				if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
				if(opts.cellFormula) {
					if((cref=d.match(match_f))!= null && cref[1] !== '') {
						/* TODO: match against XLSXFutureFunctions */
						p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
						if(!opts.xlfn) p.f = _xlfn(p.f);
						if(cref[0].indexOf('t="array"') > -1) {
							p.F = (d.match(refregex)||[])[1];
							if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
						} else if(cref[0].indexOf('t="shared"') > -1) {
							// TODO: parse formula
							ftag = parsexmltag(cref[0]);
							var ___f = unescapexml(utf8read(cref[1]));
							if(!opts.xlfn) ___f = _xlfn(___f);
							sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
						}
					} else if((cref=d.match(/<f[^>]*\/>/))) {
						ftag = parsexmltag(cref[0]);
						if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
					}
					/* TODO: factor out contains logic */
					var _tag = decode_cell(tag.r);
					for(i = 0; i < arrayf.length; ++i)
						if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
							if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
								p.F = arrayf[i][1];
				}
	
				if(tag.t == null && p.v === undefined) {
					if(p.f || p.F) {
						p.v = 0; p.t = "n";
					} else if(!sheetStubs) continue;
					else p.t = "z";
				}
				else p.t = tag.t || "n";
				if(guess.s.c > tagc) guess.s.c = tagc;
				if(guess.e.c < tagc) guess.e.c = tagc;
				/* 18.18.11 t ST_CellType */
				switch(p.t) {
					case 'n':
						if(p.v == "" || p.v == null) {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else p.v = parseFloat(p.v);
						break;
					case 's':
						if(typeof p.v == 'undefined') {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else {
							sstr = strs[parseInt(p.v, 10)];
							p.v = sstr.t;
							p.r = sstr.r;
							if(opts.cellHTML) p.h = sstr.h;
						}
						break;
					case 'str':
						p.t = "s";
						p.v = (p.v!=null) ? utf8read(p.v) : '';
						if(opts.cellHTML) p.h = escapehtml(p.v);
						break;
					case 'inlineStr':
						cref = d.match(isregex);
						p.t = 's';
						if(cref != null && (sstr = parse_si(cref[1]))) {
							p.v = sstr.t;
							if(opts.cellHTML) p.h = sstr.h;
						} else p.v = "";
						break;
					case 'b': p.v = parsexmlbool(p.v); break;
					case 'd':
						if(opts.cellDates) p.v = parseDate(p.v, 1);
						else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
						break;
					/* error string in .w, number in .v */
					case 'e':
						if(!opts || opts.cellText !== false) p.w = p.v;
						p.v = RBErr[p.v]; break;
				}
				/* formatting */
				fmtid = fillid = 0;
				cf = null;
				if(do_format && tag.s !== undefined) {
					cf = styles.CellXf[tag.s];
					if(cf != null) {
						if(cf.numFmtId != null) fmtid = cf.numFmtId;
						if(opts.cellStyles) {
							if(cf.fillId != null) fillid = cf.fillId;
						}
					}
				}
				safe_format(p, fmtid, fillid, opts, themes, styles);
				if(opts.cellDates && do_format && p.t == 'n' && fmt_is_date(table_fmt[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
				if(tag.cm && opts.xlmeta) {
					var cm = (opts.xlmeta.Cell||[])[+tag.cm-1];
					if(cm && cm.type == 'XLDAPR') p.D = true;
				}
				if(dense) {
					var _r = decode_cell(tag.r);
					if(!s[_r.r]) s[_r.r] = [];
					s[_r.r][_r.c] = p;
				} else s[tag.r] = p;
			}
		}
		if(rows.length > 0) s['!rows'] = rows;
	}; })();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
		var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
		var dense = Array.isArray(ws);
		var params = ({r:rr}), row, height = -1;
		for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
		for(R = range.s.r; R <= range.e.r; ++R) {
			r = [];
			rr = encode_row(R);
			for(C = range.s.c; C <= range.e.c; ++C) {
				ref = cols[C] + rr;
				var _cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(_cell === undefined) continue;
				if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
			}
			if(r.length > 0 || (rows && rows[R])) {
				params = ({r:rr});
				if(rows && rows[R]) {
					row = rows[R];
					if(row.hidden) params.hidden = 1;
					height = -1;
					if(row.hpx) height = px2pt(row.hpx);
					else if(row.hpt) height = row.hpt;
					if(height > -1) { params.ht = height; params.customHeight = 1; }
					if(row.level) { params.outlineLevel = row.level; }
				}
				o[o.length] = (writextag('row', r.join(""), params));
			}
		}
		if(rows) for(; R < rows.length; ++R) {
			if(rows && rows[R]) {
				params = ({r:R+1});
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
				o[o.length] = (writextag('row', "", params));
			}
		}
		return o.join("");
	}
	
	function write_ws_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('worksheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		var s = wb.SheetNames[idx], sidx = 0, rdata = "";
		var ws = wb.Sheets[s];
		if(ws == null) ws = {};
		var ref = ws['!ref'] || 'A1';
		var range = safe_decode_range(ref);
		if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
			range.e.c = Math.min(range.e.c, 0x3FFF);
			range.e.r = Math.min(range.e.c, 0xFFFFF);
			ref = encode_range(range);
		}
		if(!rels) rels = {};
		ws['!comments'] = [];
		var _drawing = [];
	
		write_ws_xml_sheetpr(ws, wb, idx, opts, o);
	
		o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
		o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
	
		/* TODO: store in WB, process styles */
		if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
			defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
			baseColWidth:opts.sheetFormat.baseColWidth||'10',
			outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
		}));
	
		if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	
		o[sidx = o.length] = '<sheetData/>';
		ws['!links'] = [];
		if(ws['!ref'] != null) {
			rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
			if(rdata.length > 0) o[o.length] = (rdata);
		}
		if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }
	
		/* sheetCalcPr */
	
		if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);
	
		/* protectedRanges */
		/* scenarios */
	
		if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
	
		/* sortState */
		/* dataConsolidate */
		/* customSheetViews */
	
		if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
		/* phoneticPr */
		/* conditionalFormatting */
		/* dataValidations */
	
		var relc = -1, rel, rId = -1;
		if(ws['!links'].length > 0) {
			o[o.length] = "<hyperlinks>";
	ws['!links'].forEach(function(l) {
				if(!l[1].Target) return;
				rel = ({"ref":l[0]});
				if(l[1].Target.charAt(0) != "#") {
					rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
					rel["r:id"] = "rId"+rId;
				}
				if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
				if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
				o[o.length] = writextag("hyperlink",null,rel);
			});
			o[o.length] = "</hyperlinks>";
		}
		delete ws['!links'];
	
		/* printOptions */
	
		if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	
		/* pageSetup */
		/* headerFooter */
		/* rowBreaks */
		/* colBreaks */
		/* customProperties */
		/* cellWatches */
	
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));
	
		/* smartTags */
	
		if(_drawing.length > 0) {
			rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
			o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
			ws['!drawing'] = _drawing;
		}
	
		if(ws['!comments'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
			ws['!legacy'] = rId;
		}
	
		/* legacyDrawingHF */
		/* picture */
		/* oleObjects */
		/* controls */
		/* webPublishItems */
		/* tableParts */
		/* extLst */
	
		if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.726 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = ({});
		var tgt = data.l + length;
		z.r = data.read_shift(4);
		data.l += 4; // TODO: ixfe
		var miyRw = data.read_shift(2);
		data.l += 1; // TODO: top/bot padding
		var flags = data.read_shift(1);
		data.l = tgt;
		if(flags & 0x07) z.level = flags & 0x07;
		if(flags & 0x10) z.hidden = true;
		if(flags & 0x20) z.hpt = miyRw / 20;
		return z;
	}
	function write_BrtRowHdr(R, range, ws) {
		var o = new_buf(17+8*16);
		var row = (ws['!rows']||[])[R]||{};
		o.write_shift(4, R);
	
		o.write_shift(4, 0); /* TODO: ixfe */
	
		var miyRw = 0x0140;
		if(row.hpx) miyRw = px2pt(row.hpx) * 20;
		else if(row.hpt) miyRw = row.hpt * 20;
		o.write_shift(2, miyRw);
	
		o.write_shift(1, 0); /* top/bot padding */
	
		var flags = 0x0;
		if(row.level) flags |= row.level;
		if(row.hidden) flags |= 0x10;
		if(row.hpx || row.hpt) flags |= 0x20;
		o.write_shift(1, flags);
	
		o.write_shift(1, 0); /* phonetic guide */
	
		/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
		var ncolspan = 0, lcs = o.l;
		o.l += 4;
	
		var caddr = {r:R, c:0};
		for(var i = 0; i < 16; ++i) {
			if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
			var first = -1, last = -1;
			for(var j = (i<<10); j < ((i+1)<<10); ++j) {
				caddr.c = j;
				var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
				if(cell) { if(first < 0) first = j; last = j; }
			}
			if(first < 0) continue;
			++ncolspan;
			o.write_shift(4, first);
			o.write_shift(4, last);
		}
	
		var l = o.l;
		o.l = lcs;
		o.write_shift(4, ncolspan);
		o.l = l;
	
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function write_row_header(ba, ws, range, R) {
		var o = write_BrtRowHdr(R, range, ws);
		if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 0x0000 /* BrtRowHdr */, o);
	}
	
	/* [MS-XLSB] 2.4.820 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
	function parse_BrtWsFmtInfo() {
	}
	//function write_BrtWsFmtInfo(ws, o) { }
	
	/* [MS-XLSB] 2.4.823 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		var f = data[data.l]; ++data.l;
		z.above = !(f & 0x40);
		z.left  = !(f & 0x80);
		/* TODO: pull flags */
		data.l += 18;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	function write_BrtWsProp(str, outl, o) {
		if(o == null) o = new_buf(84+4*str.length);
		var f = 0xC0;
		if(outl) {
			if(outl.above) f &= ~0x40;
			if(outl.left)  f &= ~0x80;
		}
		o.write_shift(1, f);
		for(var i = 1; i < 3; ++i) o.write_shift(1,0);
		write_BrtColor({auto:1}, o);
		o.write_shift(-4,-1);
		o.write_shift(-4,-1);
		write_XLSBCodeName(str, o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.306 BrtCellBlank */
	function parse_BrtCellBlank(data) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(ncell, o);
	}
	function parse_BrtShortBlank(data) {
		var cell = parse_XLSBShortCell(data);
		return [cell];
	}
	function write_BrtShortBlank(cell, ncell, o) {
		if(o == null) o = new_buf(4);
		return write_XLSBShortCell(ncell, o);
	}
	
	/* [MS-XLSB] 2.4.307 BrtCellBool */
	function parse_BrtCellBool(data) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtCellBool(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	function parse_BrtShortBool(data) {
		var cell = parse_XLSBShortCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtShortBool(cell, ncell, o) {
		if(o == null) o = new_buf(5);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellError */
	function parse_BrtCellError(data) {
		var cell = parse_XLSBCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtCellError(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v);
		return o;
	}
	function parse_BrtShortError(data) {
		var cell = parse_XLSBShortCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtShortError(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v);
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.311 BrtCellIsst */
	function parse_BrtCellIsst(data) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtCellIsst(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	function parse_BrtShortIsst(data) {
		var cell = parse_XLSBShortCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtShortIsst(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	
	/* [MS-XLSB] 2.4.313 BrtCellReal */
	function parse_BrtCellReal(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellReal(cell, ncell, o) {
		if(o == null) o = new_buf(16);
		write_XLSBCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	function parse_BrtShortReal(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortReal(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBShortCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.314 BrtCellRk */
	function parse_BrtCellRk(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellRk(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	function parse_BrtShortRk(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortRk(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtCellRString */
	function parse_BrtCellRString(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RichStr(data);
		return [cell, value, 'is'];
	}
	
	/* [MS-XLSB] 2.4.317 BrtCellSt */
	function parse_BrtCellSt(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtCellSt(cell, ncell, o) {
		if(o == null) o = new_buf(12 + 4 * cell.v.length);
		write_XLSBCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function parse_BrtShortSt(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtShortSt(cell, ncell, o) {
		if(o == null) o = new_buf(8 + 4 * cell.v.length);
		write_XLSBShortCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.653 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.654 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.655 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.656 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.682 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	var write_BrtMergeCell = write_UncheckedRfX;
	/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
	function write_BrtBeginMergeCells(cnt, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(4, cnt);
		return o;
	}
	
	/* [MS-XLSB] 2.4.662 BrtHLink */
	function parse_BrtHLink(data, length) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
		if(tooltip) o.Tooltip = tooltip;
		return o;
	}
	function write_BrtHLink(l, rId) {
		var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
		write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
		write_RelID("rId" + rId, o);
		var locidx = l[1].Target.indexOf("#");
		var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
		write_XLWideString(loc || "", o);
		write_XLWideString(l[1].Tooltip || "", o);
		write_XLWideString("", o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.692 BrtPane */
	function parse_BrtPane(/*data, length, opts*/) {
	}
	
	/* [MS-XLSB] 2.4.6 BrtArrFmla */
	function parse_BrtArrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_RfX(data, 16);
		var fAlwaysCalc = data.read_shift(1);
		var o = [rfx]; o[2] = fAlwaysCalc;
		if(opts.cellFormula) {
			var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
			o[1] = formula;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.750 BrtShrFmla */
	function parse_BrtShrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var o = [rfx];
		if(opts.cellFormula) {
			var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
			o[1] = formula;
			data.l = end;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtColInfo */
	/* TODO: once XLS ColInfo is set, combine the functions */
	function write_BrtColInfo(C, col, o) {
		if(o == null) o = new_buf(18);
		var p = col_obj_w(C, col);
		o.write_shift(-4, C);
		o.write_shift(-4, C);
		o.write_shift(4, (p.width || 10) * 256);
		o.write_shift(4, 0/*ixfe*/); // style
		var flags = 0;
		if(col.hidden) flags |= 0x01;
		if(typeof p.width == 'number') flags |= 0x02;
		if(col.level) flags |= (col.level << 8);
		o.write_shift(2, flags); // bit flag
		return o;
	}
	
	/* [MS-XLSB] 2.4.678 BrtMargins */
	var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
	function parse_BrtMargins(data) {
		var margins = ({});
		BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
		return margins;
	}
	function write_BrtMargins(margins, o) {
		if(o == null) o = new_buf(6*8);
		default_margins(margins);
		BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
		return o;
	}
	
	/* [MS-XLSB] 2.4.299 BrtBeginWsView */
	function parse_BrtBeginWsView(data) {
		var f = data.read_shift(2);
		data.l += 28;
		return { RTL: f & 0x20 };
	}
	function write_BrtBeginWsView(ws, Workbook, o) {
		if(o == null) o = new_buf(30);
		var f = 0x39c;
		if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
		o.write_shift(2, f); // bit flag
		o.write_shift(4, 0);
		o.write_shift(4, 0); // view first row
		o.write_shift(4, 0); // view first col
		o.write_shift(1, 0); // gridline color ICV
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 100); // zoom scale
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0); // workbook view id
		return o;
	}
	
	/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
	function write_BrtCellIgnoreEC(ref) {
		var o = new_buf(24);
		o.write_shift(4, 4);
		o.write_shift(4, 1);
		write_UncheckedRfX(ref, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.748 BrtSheetProtection */
	function write_BrtSheetProtection(sp, o) {
		if(o == null) o = new_buf(16*4+2);
		o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
		o.write_shift(4, 1); // this record should not be written if no protection
		[
			["objects",             false], // fObjects
			["scenarios",           false], // fScenarios
			["formatCells",          true], // fFormatCells
			["formatColumns",        true], // fFormatColumns
			["formatRows",           true], // fFormatRows
			["insertColumns",        true], // fInsertColumns
			["insertRows",           true], // fInsertRows
			["insertHyperlinks",     true], // fInsertHyperlinks
			["deleteColumns",        true], // fDeleteColumns
			["deleteRows",           true], // fDeleteRows
			["selectLockedCells",   false], // fSelLockedCells
			["sort",                 true], // fSort
			["autoFilter",           true], // fAutoFilter
			["pivotTables",          true], // fPivotTables
			["selectUnlockedCells", false]  // fSelUnlockedCells
		].forEach(function(n) {
	if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
			else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
		});
		return o;
	}
	
	function parse_BrtDVal(/*data, length, opts*/) {
	}
	function parse_BrtDVal14(/*data, length, opts*/) {
	}
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		var opts = _opts || {};
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var s = (opts.dense ? [] : {});
	
		var ref;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		var state = [];
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr, cell;
		var merges = [];
		opts.biff = 12;
		opts['!row'] = 0;
	
		var ai = 0, af = false;
	
		var arrayf = [];
		var sharedf = {};
		var supbooks = opts.supbooks || wb.supbooks || ([[]]);
		supbooks.sharedf = sharedf;
		supbooks.arrayf = arrayf;
		supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
		if(!opts.supbooks) {
			opts.supbooks = supbooks;
			if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
		}
	
		var colinfo = [], rowinfo = [];
		var seencol = false;
	
		XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };
	
		var cm, vm;
	
		recordhopper(data, function ws_parse(val, RR, RT) {
			if(end) return;
			switch(RT) {
				case 0x0094: /* 'BrtWsDim' */
					ref = val; break;
				case 0x0000: /* 'BrtRowHdr' */
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(R = row.r);
					opts['!row'] = row.r;
					if(val.hidden || val.hpt || val.level != null) {
						if(val.hpt) val.hpx = pt2px(val.hpt);
						rowinfo[val.r] = val;
					}
					break;
	
				case 0x0002: /* 'BrtCellRk' */
				case 0x0003: /* 'BrtCellError' */
				case 0x0004: /* 'BrtCellBool' */
				case 0x0005: /* 'BrtCellReal' */
				case 0x0006: /* 'BrtCellSt' */
				case 0x0007: /* 'BrtCellIsst' */
				case 0x0008: /* 'BrtFmlaString' */
				case 0x0009: /* 'BrtFmlaNum' */
				case 0x000A: /* 'BrtFmlaBool' */
				case 0x000B: /* 'BrtFmlaError' */
				case 0x000D: /* 'BrtShortRk' */
				case 0x000E: /* 'BrtShortError' */
				case 0x000F: /* 'BrtShortBool' */
				case 0x0010: /* 'BrtShortReal' */
				case 0x0011: /* 'BrtShortSt' */
				case 0x0012: /* 'BrtShortIsst' */
				case 0x003E: /* 'BrtCellRString' */
					p = ({t:val[2]});
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = val[1]; break;
						case 'is': p.t = 's'; p.v = val[1].t; break;
					}
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(opts.cellFormula) {
						af = false;
						for(ai = 0; ai < arrayf.length; ++ai) {
							var aii = arrayf[ai];
							if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
								if(C >= aii[0].s.c && C <= aii[0].e.c) {
									p.F = encode_range(aii[0]); af = true;
								}
						}
						if(!af && val.length > 3) p.f = val[3];
					}
	
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(opts.cellDates && cf && p.t == 'n' && fmt_is_date(table_fmt[cf.numFmtId])) {
						var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
					}
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x0001: /* 'BrtCellBlank' */
				case 0x000C: /* 'BrtShortBlank' */
					if(!opts.sheetStubs || pass) break;
					p = ({t:'z',v:void 0});
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x00B0: /* 'BrtMergeCell' */
					merges.push(val); break;
	
				case 0x0031: { /* 'BrtCellMeta' */
					cm = ((opts.xlmeta||{}).Cell||[])[val-1];
				} break;
	
				case 0x01EE: /* 'BrtHLink' */
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					} else if(val.relId == '') {
						val.Target = "#" + val.loc;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						if(opts.dense) {
							if(!s[R]) s[R] = [];
							if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
							s[R][C].l = val;
						} else {
							addr = encode_cell({c:C,r:R});
							if(!s[addr]) s[addr] = {t:'z',v:undefined};
							s[addr].l = val;
						}
					}
					break;
	
				case 0x01AA: /* 'BrtArrFmla' */
					if(!opts.cellFormula) break;
					arrayf.push(val);
					cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					cell.F = encode_range(val[0]);
					break;
				case 0x01AB: /* 'BrtShrFmla' */
					if(!opts.cellFormula) break;
					sharedf[encode_cell(val[0].s)] = val[1];
					cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					break;
	
				/* identical to 'ColInfo' in XLS */
				case 0x003C: /* 'BrtColInfo' */
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
					break;
	
				case 0x00A1: /* 'BrtBeginAFilter' */
					s['!autofilter'] = { ref:encode_range(val) };
					break;
	
				case 0x01DC: /* 'BrtMargins' */
					s['!margins'] = val;
					break;
	
				case 0x0093: /* 'BrtWsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
					break;
	
				case 0x0089: /* 'BrtBeginWsView' */
					if(!wb.Views) wb.Views = [{}];
					if(!wb.Views[0]) wb.Views[0] = {};
					if(val.RTL) wb.Views[0].RTL = true;
					break;
	
				case 0x01E5: /* 'BrtWsFmtInfo' */
					break;
	
				case 0x0040: /* 'BrtDVal' */
				case 0x041D: /* 'BrtDVal14' */
					break;
	
				case 0x0097: /* 'BrtPane' */
					break;
				case 0x0098: /* 'BrtSel' */
				case 0x00AF: /* 'BrtAFilterDateGroupItem' */
				case 0x0284: /* 'BrtActiveX' */
				case 0x0271: /* 'BrtBigName' */
				case 0x0232: /* 'BrtBkHim' */
				case 0x018C: /* 'BrtBrk' */
				case 0x0458: /* 'BrtCFIcon' */
				case 0x047A: /* 'BrtCFRuleExt' */
				case 0x01D7: /* 'BrtCFVO' */
				case 0x041A: /* 'BrtCFVO14' */
				case 0x0289: /* 'BrtCellIgnoreEC' */
				case 0x0451: /* 'BrtCellIgnoreEC14' */
				case 0x024D: /* 'BrtCellSmartTagProperty' */
				case 0x025F: /* 'BrtCellWatch' */
				case 0x0234: /* 'BrtColor' */
				case 0x041F: /* 'BrtColor14' */
				case 0x00A8: /* 'BrtColorFilter' */
				case 0x00AE: /* 'BrtCustomFilter' */
				case 0x049C: /* 'BrtCustomFilter14' */
				case 0x01F3: /* 'BrtDRef' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x0226: /* 'BrtDrawing' */
				case 0x00AB: /* 'BrtDynamicFilter' */
				case 0x00A7: /* 'BrtFilter' */
				case 0x0499: /* 'BrtFilter14' */
				case 0x00A9: /* 'BrtIconFilter' */
				case 0x049D: /* 'BrtIconFilter14' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x0295: /* 'BrtListPart' */
				case 0x027F: /* 'BrtOleObject' */
				case 0x01DE: /* 'BrtPageSetup' */
				case 0x0219: /* 'BrtPhoneticInfo' */
				case 0x01DD: /* 'BrtPrintOptions' */
				case 0x0218: /* 'BrtRangeProtection' */
				case 0x044F: /* 'BrtRangeProtection14' */
				case 0x02A8: /* 'BrtRangeProtectionIso' */
				case 0x0450: /* 'BrtRangeProtectionIso14' */
				case 0x0400: /* 'BrtRwDescent' */
				case 0x0297: /* 'BrtSheetCalcProp' */
				case 0x0217: /* 'BrtSheetProtection' */
				case 0x02A6: /* 'BrtSheetProtectionIso' */
				case 0x01F8: /* 'BrtSlc' */
				case 0x0413: /* 'BrtSparkline' */
				case 0x01AC: /* 'BrtTable' */
				case 0x00AA: /* 'BrtTop10Filter' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0032: /* 'BrtValueMeta' */
				case 0x0816: /* 'BrtWebExtension' */
				case 0x0415: /* 'BrtWsFmtInfoEx14' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if(RR.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		delete opts.supbooks;
		delete opts['!row'];
	
		if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(merges.length > 0) s["!merges"] = merges;
		if(colinfo.length > 0) s["!cols"] = colinfo;
		if(rowinfo.length > 0) s["!rows"] = rowinfo;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen) {
		if(cell.v === undefined) return false;
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'd': // no BrtCellDate :(
				cell = dup(cell);
				cell.z = cell.z || table_fmt[14];
				cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
				break;
			/* falls through */
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = ({r:R, c:C});
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
		if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
					o.t = "s"; o.v = vv;
					if(last_seen) write_record(ba, 0x0012 /* BrtShortIsst */, write_BrtShortIsst(cell, o));
					else write_record(ba, 0x0007 /* BrtCellIsst */, write_BrtCellIsst(cell, o));
				} else {
					o.t = "str";
					if(last_seen) write_record(ba, 0x0011 /* BrtShortSt */, write_BrtShortSt(cell, o));
					else write_record(ba, 0x0006 /* BrtCellSt */, write_BrtCellSt(cell, o));
				}
				return true;
			case 'n':
				/* TODO: determine threshold for Real vs RK */
				if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
					if(last_seen) write_record(ba, 0x000D /* BrtShortRk */, write_BrtShortRk(cell, o));
					else write_record(ba, 0x0002 /* BrtCellRk */, write_BrtCellRk(cell, o));
				} else {
					if(last_seen) write_record(ba, 0x0010 /* BrtShortReal */, write_BrtShortReal(cell, o));
					else write_record(ba, 0x0005 /* BrtCellReal */, write_BrtCellReal(cell, o));
				} return true;
			case 'b':
				o.t = "b";
				if(last_seen) write_record(ba, 0x000F /* BrtShortBool */, write_BrtShortBool(cell, o));
				else write_record(ba, 0x0004 /* BrtCellBool */, write_BrtCellBool(cell, o));
				return true;
			case 'e':
				o.t = "e";
				if(last_seen) write_record(ba, 0x000E /* BrtShortError */, write_BrtShortError(cell, o));
				else write_record(ba, 0x0003 /* BrtCellError */, write_BrtCellError(cell, o));
				return true;
		}
		if(last_seen) write_record(ba, 0x000C /* BrtShortBlank */, write_BrtShortBlank(cell, o));
		else write_record(ba, 0x0001 /* BrtCellBlank */, write_BrtCellBlank(cell, o));
		return true;
	}
	
	function write_CELLTABLE(ba, ws, idx, opts) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 0x0091 /* BrtBeginSheetData */);
		var dense = Array.isArray(ws);
		var cap = range.e.r;
		if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
		for(var R = range.s.r; R <= cap; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			write_row_header(ba, ws, range, R);
			var last_seen = false;
			if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) { last_seen = false; continue; }
				/* write cell */
				last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
			}
		}
		write_record(ba, 0x0092 /* BrtEndSheetData */);
	}
	
	function write_MERGECELLS(ba, ws) {
		if(!ws || !ws['!merges']) return;
		write_record(ba, 0x00B1 /* BrtBeginMergeCells */, write_BrtBeginMergeCells(ws['!merges'].length));
		ws['!merges'].forEach(function(m) { write_record(ba, 0x00B0 /* BrtMergeCell */, write_BrtMergeCell(m)); });
		write_record(ba, 0x00B2 /* BrtEndMergeCells */);
	}
	
	function write_COLINFOS(ba, ws) {
		if(!ws || !ws['!cols']) return;
		write_record(ba, 0x0186 /* BrtBeginColInfos */);
		ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 0x003C /* 'BrtColInfo' */, write_BrtColInfo(i, m)); });
		write_record(ba, 0x0187 /* BrtEndColInfos */);
	}
	
	function write_IGNOREECS(ba, ws) {
		if(!ws || !ws['!ref']) return;
		write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */);
		write_record(ba, 0x0289 /* BrtCellIgnoreEC */, write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
		write_record(ba, 0x028A /* BrtEndCellIgnoreECs */);
	}
	
	function write_HLINKS(ba, ws, rels) {
		/* *BrtHLink */
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
			write_record(ba, 0x01EE /* BrtHLink */, write_BrtHLink(l, rId));
		});
		delete ws['!links'];
	}
	function write_LEGACYDRAWING(ba, ws, idx, rels) {
		/* [BrtLegacyDrawing] */
		if(ws['!comments'].length > 0) {
			var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			write_record(ba, 0x0227 /* BrtLegacyDrawing */, write_RelID("rId" + rId));
			ws['!legacy'] = rId;
		}
	}
	
	function write_AUTOFILTER(ba, ws, wb, idx) {
		if(!ws['!autofilter']) return;
		var data = ws['!autofilter'];
		var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
	
		/* Update FilterDatabase defined name for the worksheet */
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	
		write_record(ba, 0x00A1 /* BrtBeginAFilter */, write_UncheckedRfX(safe_decode_range(ref)));
		/* *FILTERCOLUMN */
		/* [SORTSTATE] */
		/* BrtEndAFilter */
		write_record(ba, 0x00A2 /* BrtEndAFilter */);
	}
	
	function write_WSVIEWS2(ba, ws, Workbook) {
		write_record(ba, 0x0085 /* BrtBeginWsViews */);
		{ /* 1*WSVIEW2 */
			/* [ACUID] */
			write_record(ba, 0x0089 /* BrtBeginWsView */, write_BrtBeginWsView(ws, Workbook));
			/* [BrtPane] */
			/* *4BrtSel */
			/* *4SXSELECT */
			/* *FRT */
			write_record(ba, 0x008A /* BrtEndWsView */);
		}
		/* *FRT */
		write_record(ba, 0x0086 /* BrtEndWsViews */);
	}
	
	function write_WSFMTINFO() {
		/* [ACWSFMTINFO] */
		// write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
	}
	
	function write_SHEETPROTECT(ba, ws) {
		if(!ws['!protect']) return;
		/* [BrtSheetProtectionIso] */
		write_record(ba, 0x0217 /* BrtSheetProtection */, write_BrtSheetProtection(ws['!protect']));
	}
	
	function write_ws_bin(idx, opts, wb, rels) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
		var r = safe_decode_range(ws['!ref'] || "A1");
		if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
			r.e.c = Math.min(r.e.c, 0x3FFF);
			r.e.r = Math.min(r.e.c, 0xFFFFF);
		}
		ws['!links'] = [];
		/* passed back to write_zip and removed there */
		ws['!comments'] = [];
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		if(wb.vbaraw || ws['!outline']) write_record(ba, 0x0093 /* BrtWsProp */, write_BrtWsProp(c, ws['!outline']));
		write_record(ba, 0x0094 /* BrtWsDim */, write_BrtWsDim(r));
		write_WSVIEWS2(ba, ws, wb.Workbook);
		write_WSFMTINFO(ba, ws);
		write_COLINFOS(ba, ws, idx, opts, wb);
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		write_SHEETPROTECT(ba, ws);
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		write_AUTOFILTER(ba, ws, wb, idx);
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		write_MERGECELLS(ba, ws);
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		write_HLINKS(ba, ws, rels);
		/* [BrtPrintOptions] */
		if(ws['!margins']) write_record(ba, 0x01DC /* BrtMargins */, write_BrtMargins(ws['!margins']));
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		write_LEGACYDRAWING(ba, ws, idx, rels);
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	function parse_Cache(data) {
		var col = [];
		var num = data.match(/^<c:numCache>/);
		var f;
	
		/* 21.2.2.150 pt CT_NumVal */
		(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
			var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
			if(!q) return;
			col[+q[1]] = num ? +q[2] : q[2];
		});
	
		/* 21.2.2.71 formatCode CT_Xstring */
		var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);
	
		(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });
	
		return [col, nf, f];
	}
	
	/* 21.2 DrawingML - Charts */
	function parse_chart(data, name, opts, rels, wb, csheet) {
		var cs = ((csheet || {"!type":"chart"}));
		if(!data) return csheet;
		/* 21.2.2.27 chart CT_Chart */
	
		var C = 0, R = 0, col = "A";
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		/* 21.2.2.120 numCache CT_NumData */
		(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
			var cache = parse_Cache(nc);
			refguess.s.r = refguess.s.c = 0;
			refguess.e.c = C;
			col = encode_col(C);
			cache[0].forEach(function(n,i) {
				cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
				R = i;
			});
			if(refguess.e.r < R) refguess.e.r = R;
			++C;
		});
		if(C > 0) cs["!ref"] = encode_range(refguess);
		return cs;
	}
	/* 18.3 Worksheets also covers Chartsheets */
	function parse_cs_xml(data, opts, idx, rels, wb) {
		if(!data) return data;
		/* 18.3.1.12 chartsheet CT_ChartSheet */
		if(!rels) rels = {'!id':{}};
		var s = ({'!type':"chart", '!drawel':null, '!rel':""});
		var m;
	
		/* 18.3.1.83 sheetPr CT_ChartsheetPr */
		var sheetPr = data.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.36 drawing CT_Drawing */
		if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('chartsheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
		add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.331 BrtCsProp */
	function parse_BrtCsProp(data, length) {
		data.l += 10;
		var name = parse_XLWideString(data, length - 10);
		return { name: name };
	}
	
	/* [MS-XLSB] 2.1.7.7 Chart Sheet */
	function parse_cs_bin(data, opts, idx, rels, wb) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!drawel':null, '!rel':""};
		var state = [];
		var pass = false;
		recordhopper(data, function cs_parse(val, R, RT) {
			switch(RT) {
	
				case 0x0226: /* 'BrtDrawing' */
					s['!rel'] = val; break;
	
				case 0x028B: /* 'BrtCsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0232: /* 'BrtBkHim' */
				case 0x028C: /* 'BrtCsPageSetup' */
				case 0x029D: /* 'BrtCsProtection' */
				case 0x02A7: /* 'BrtCsProtectionIso' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x01DC: /* 'BrtMargins' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_bin() {
		var ba = buf_array();
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		/* [BrtCsProp] */
		/* CSVIEWS */
		/* [[BrtCsProtectionIso] BrtCsProtection] */
		/* [USERCSVIEWS] */
		/* [BrtMargins] */
		/* [BrtCsPageSetup] */
		/* [HEADERFOOTER] */
		/* BrtDrawing */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [WEBPUBITEMS] */
		/* FRTCHARTSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery',           false, "bool"],
		['autoCompressPictures',        true,  "bool"],
		['backupFile',                  false, "bool"],
		['checkCompatibility',          false, "bool"],
		['CodeName',                    ''],
		['date1904',                    false, "bool"],
		['defaultThemeVersion',         0,      "int"],
		['filterPrivacy',               false, "bool"],
		['hidePivotFieldList',          false, "bool"],
		['promptedSolutions',           false, "bool"],
		['publishItems',                false, "bool"],
		['refreshAllConnections',       false, "bool"],
		['saveExternalLinkValues',      true,  "bool"],
		['showBorderUnselectedTables',  true,  "bool"],
		['showInkAnnotation',           true,  "bool"],
		['showObjects',                 'all'],
		['showPivotChartFilter',        false, "bool"],
		['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab',                   0,      "int"],
		['autoFilterDateGrouping',      true,  "bool"],
		['firstSheet',                  0,      "int"],
		['minimized',                   false, "bool"],
		['showHorizontalScroll',        true,  "bool"],
		['showSheetTabs',               true,  "bool"],
		['showVerticalScroll',          true,  "bool"],
		['tabRatio',                    600,    "int"],
		['visibility',                  'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		//['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	/*var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];*/
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
				else switch(z[2]) {
				case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
				case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
				}
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
			else switch(z[2]) {
				case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
				case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
			}
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
	}
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		if(!wb.Workbook) return "false";
		if(!wb.Workbook.WBProps) return "false";
		return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
	}
	
	var badchars = "][*?\/\\".split("");
	function check_ws_name(n, safe) {
		if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
		var _good = true;
		badchars.forEach(function(c) {
			if(n.indexOf(c) == -1) return;
			if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
			_good = false;
		});
		return _good;
	}
	function check_wb_names(N, S, codes) {
		N.forEach(function(n,i) {
			check_ws_name(n);
			for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
			if(codes) {
				var cn = (S && S[i] && S[i].CodeName) || n;
				if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
			}
		});
	}
	function check_wb(wb) {
		if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
		if(!wb.SheetNames.length) throw new Error("Workbook is empty");
		var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
		check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
		for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
		/* TODO: validate workbook */
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		if(!data) throw new Error("Could not find file");
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
		var pass = false, xmlns = "xmlns";
		var dname = {}, dnstart = 0;
		data.replace(tagregex, function xml_wb(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': case '</fileVersion>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing':
					break;
				case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr':
				case '<workbookPr/>':
					WBPropsDef.forEach(function(w) {
						if(y[w[0]] == null) return;
						switch(w[2]) {
							case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
							case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
							default: wb.WBProps[w[0]] = y[w[0]];
						}
					});
					if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
					break;
				case '</workbookPr>': break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection':
					break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews': case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
				case '</workbookView>': break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet':
					switch(y.state) {
						case "hidden": y.Hidden = 1; break;
						case "veryHidden": y.Hidden = 2; break;
						default: y.Hidden = 0;
					}
					delete y.state;
					y.name = unescapexml(utf8read(y.name));
					delete y[0]; wb.Sheets.push(y); break;
				case '</sheet>': break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': {
					dname = {};
					dname.Name = utf8read(y.name);
					if(y.comment) dname.Comment = y.comment;
					if(y.localSheetId) dname.Sheet = +y.localSheetId;
					if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
					dnstart = idx + x.length;
				}	break;
				case '</definedName>': {
					dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
					wb.Names.push(dname);
				} break;
				case '<definedName/>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
				case '</calcPr>': break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22 smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent':
				case '<AlternateContent>': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				/* TODO */
				case '<revisionPtr': break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
			}
			return x;
		});
		if(XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	function write_wb_xml(wb) {
		var o = [XML_HEADER];
		o[o.length] = writextag('workbook', null, {
			'xmlns': XMLNS_main[0],
			//'xmlns:mx': XMLNS.mx,
			//'xmlns:s': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		});
	
		var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);
	
		/* fileVersion */
		/* fileSharing */
	
		var workbookPr = ({codeName:"ThisWorkbook"});
		if(wb.Workbook && wb.Workbook.WBProps) {
			WBPropsDef.forEach(function(x) {
	if((wb.Workbook.WBProps[x[0]]) == null) return;
				if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
				workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
			});
	if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
		}
		o[o.length] = (writextag('workbookPr', null, workbookPr));
	
		/* workbookProtection */
	
		var sheets = wb.Workbook && wb.Workbook.Sheets || [];
		var i = 0;
	
		/* bookViews only written if first worksheet is hidden */
		if(sheets && sheets[0] && !!sheets[0].Hidden) {
			o[o.length] = "<bookViews>";
			for(i = 0; i != wb.SheetNames.length; ++i) {
				if(!sheets[i]) break;
				if(!sheets[i].Hidden) break;
			}
			if(i == wb.SheetNames.length) i = 0;
			o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
			o[o.length] = "</bookViews>";
		}
	
		o[o.length] = "<sheets>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
			sht.sheetId = ""+(i+1);
			sht["r:id"] = "rId"+(i+1);
			if(sheets[i]) switch(sheets[i].Hidden) {
				case 1: sht.state = "hidden"; break;
				case 2: sht.state = "veryHidden"; break;
			}
			o[o.length] = (writextag('sheet',null,sht));
		}
		o[o.length] = "</sheets>";
	
		/* functionGroups */
		/* externalReferences */
	
		if(write_names) {
			o[o.length] = "<definedNames>";
			if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
				var d = {name:n.Name};
				if(n.Comment) d.comment = n.Comment;
				if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
				if(n.Hidden) d.hidden = "1";
				if(!n.Ref) return;
				o[o.length] = writextag('definedName', escapexml(n.Ref), d);
			});
			o[o.length] = "</definedNames>";
		}
	
		/* calcPr */
		/* oleSize */
		/* customWorkbookViews */
		/* pivotCaches */
		/* smartTagPr */
		/* smartTagTypes */
		/* webPublishing */
		/* fileRecoveryPr */
		/* webPublishObjects */
		/* extLst */
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.304 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.Hidden = data.read_shift(4); //hsState ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.Hidden);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.slice(0,31), o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.815 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		var o = ({});
		var flags = data.read_shift(4);
		o.defaultThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		if(strName.length > 0) o.CodeName = strName;
		o.autoCompressPictures = !!(flags & 0x10000);
		o.backupFile = !!(flags & 0x40);
		o.checkCompatibility = !!(flags & 0x1000);
		o.date1904 = !!(flags & 0x01);
		o.filterPrivacy = !!(flags & 0x08);
		o.hidePivotFieldList = !!(flags & 0x400);
		o.promptedSolutions = !!(flags & 0x10);
		o.publishItems = !!(flags & 0x800);
		o.refreshAllConnections = !!(flags & 0x40000);
		o.saveExternalLinkValues = !!(flags & 0x80);
		o.showBorderUnselectedTables = !!(flags & 0x04);
		o.showInkAnnotation = !!(flags & 0x20);
		o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
		o.showPivotChartFilter = !!(flags & 0x8000);
		o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
		return o;
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(72);
		var flags = 0;
		if(data) {
			/* TODO: mirror parse_BrtWbProp fields */
			if(data.filterPrivacy) flags |= 0x08;
		}
		o.write_shift(4, flags);
		o.write_shift(4, 0);
		write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
		return o.slice(0, o.l);
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.4.687 BrtName */
	function parse_BrtName(data, length, opts) {
		var end = data.l + length;
		data.l += 4; //var flags = data.read_shift(4);
		data.l += 1; //var chKey = data.read_shift(1);
		var itab = data.read_shift(4);
		var name = parse_XLNameWideString(data);
		var formula = parse_XLSBNameParsedFormula(data, 0, opts);
		var comment = parse_XLNullableWideString(data);
		//if(0 /* fProc */) {
			// unusedstring1: XLNullableWideString
			// description: XLNullableWideString
			// helpTopic: XLNullableWideString
			// unusedstring2: XLNullableWideString
		//}
		data.l = end;
		var out = ({Name:name, Ptg:formula});
		if(itab < 0xFFFFFFF) out.Sheet = itab;
		if(comment) out.Comment = comment;
		return out;
	}
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var state = [];
		var pass = false;
	
		if(!opts) opts = {};
		opts.biff = 12;
	
		var Names = [];
		var supbooks = ([[]]);
		supbooks.SheetNames = [];
		supbooks.XTI = [];
	
		XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };
	
		recordhopper(data, function hopper_wb(val, R, RT) {
			switch(RT) {
				case 0x009C: /* 'BrtBundleSh' */
					supbooks.SheetNames.push(val.name);
					wb.Sheets.push(val); break;
	
				case 0x0099: /* 'BrtWbProp' */
					wb.WBProps = val; break;
	
				case 0x0027: /* 'BrtName' */
					if(val.Sheet != null) opts.SID = val.Sheet;
					val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
					delete opts.SID;
					delete val.Ptg;
					Names.push(val);
					break;
				case 0x040C: /* 'BrtNameExt' */ break;
	
				case 0x0165: /* 'BrtSupSelf' */
				case 0x0166: /* 'BrtSupSame' */
				case 0x0163: /* 'BrtSupBookSrc' */
				case 0x029B: /* 'BrtSupAddin' */
					if(!supbooks[0].length) supbooks[0] = [RT, val];
					else supbooks.push([RT, val]);
					supbooks[supbooks.length - 1].XTI = [];
					break;
				case 0x016A: /* 'BrtExternSheet' */
					if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
					supbooks.XTI = supbooks.XTI.concat(val);
					break;
				case 0x0169: /* 'BrtPlaceholderName' */
					break;
	
				case 0x0817: /* 'BrtAbsPath15' */
				case 0x009E: /* 'BrtBookView' */
				case 0x008F: /* 'BrtBeginBundleShs' */
				case 0x0298: /* 'BrtBeginFnGroup' */
				case 0x0161: /* 'BrtBeginExternals' */
					break;
	
				/* case 'BrtModelTimeGroupingCalcCol' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0C01: /* 'BrtRevisionPtr' */
				case 0x0216: /* 'BrtBookProtection' */
				case 0x02A5: /* 'BrtBookProtectionIso' */
				case 0x009D: /* 'BrtCalcProp' */
				case 0x0262: /* 'BrtCrashRecErr' */
				case 0x0802: /* 'BrtDecoupledPivotCacheID' */
				case 0x009B: /* 'BrtFileRecover' */
				case 0x0224: /* 'BrtFileSharing' */
				case 0x02A4: /* 'BrtFileSharingIso' */
				case 0x0080: /* 'BrtFileVersion' */
				case 0x0299: /* 'BrtFnGroup' */
				case 0x0850: /* 'BrtModelRelationship' */
				case 0x084D: /* 'BrtModelTable' */
				case 0x0225: /* 'BrtOleSize' */
				case 0x0805: /* 'BrtPivotTableRef' */
				case 0x0254: /* 'BrtSmartTagType' */
				case 0x081C: /* 'BrtTableSlicerCacheID' */
				case 0x081B: /* 'BrtTableSlicerCacheIDs' */
				case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
				case 0x018D: /* 'BrtUserBookView' */
				case 0x009A: /* 'BrtWbFactoid' */
				case 0x045D: /* 'BrtWbProp14' */
				case 0x0229: /* 'BrtWebOpt' */
				case 0x082B: /* 'BrtWorkBookPr15' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					state.push(RT); pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					state.pop(); pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				case 0x0010: /* 'BrtFRTArchID$' */ break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */ && state[state.length-1] != 0x0023 /* BrtFRTBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		parse_wb_defaults(wb);
	
		// $FlowIgnore
		wb.Names = Names;
	
		(wb).supbooks = supbooks;
		return wb;
	}
	
	function write_BUNDLESHS(ba, wb) {
		write_record(ba, 0x008F /* BrtBeginBundleShs */);
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
			var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, 0x009C /* BrtBundleSh */, write_BrtBundleSh(d));
		}
		write_record(ba, 0x0090 /* BrtEndBundleShs */);
	}
	
	/* [MS-XLSB] 2.4.649 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.301 BrtBookView */
	function write_BrtBookView(idx, o) {
		if(!o) o = new_buf(29);
		o.write_shift(-4, 0);
		o.write_shift(-4, 460);
		o.write_shift(4,  28800);
		o.write_shift(4,  17600);
		o.write_shift(4,  500);
		o.write_shift(4,  idx);
		o.write_shift(4,  idx);
		var flags = 0x78;
		o.write_shift(1,  flags);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	function write_BOOKVIEWS(ba, wb) {
		/* required if hidden tab appears before visible tab */
		if(!wb.Workbook || !wb.Workbook.Sheets) return;
		var sheets = wb.Workbook.Sheets;
		var i = 0, vistab = -1, hidden = -1;
		for(; i < sheets.length; ++i) {
			if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
			else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
		}
		if(hidden > vistab) return;
		write_record(ba, 0x0087 /* BrtBeginBookViews */);
		write_record(ba, 0x009E /* BrtBookView */, write_BrtBookView(vistab));
		/* 1*(BrtBookView *FRT) */
		write_record(ba, 0x0088 /* BrtEndBookViews */);
	}
	
	/* [MS-XLSB] 2.4.305 BrtCalcProp */
	/*function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); // force recalc
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}*/
	
	/* [MS-XLSB] 2.4.646 BrtFileRecover */
	/*function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}*/
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0083 /* BrtBeginBook */);
		write_record(ba, 0x0080 /* BrtFileVersion */, write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, 0x0099 /* BrtWbProp */, write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		/* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		/* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, 0x0084 /* BrtEndBook */);
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
		return parse_wb_xml((data), opts);
	}
	
	function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_sty(data, name, themes, opts) {
		if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
		return parse_sty_xml((data), themes, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
		return parse_sst_xml((data), opts);
	}
	
	function parse_cmnt(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
		return parse_comments_xml((data), opts);
	}
	
	function parse_cc(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
		return parse_cc_xml((data), name, opts);
	}
	
	function parse_xlink(data, rel, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlink_bin((data), rel, name, opts);
		return parse_xlink_xml((data), rel, name, opts);
	}
	
	function parse_xlmeta(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlmeta_bin((data), name, opts);
		return parse_xlmeta_xml((data), name, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
	}
	
	// eslint-disable-next-line no-unused-vars
	function write_cs(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
	}
	
	function write_sty(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	
	function write_cmnt(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	/*
	function write_cc(data, name:string, opts) {
		return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	
	function write_xlmeta(name) {
		return (name.slice(-4)===".bin" ? write_xlmeta_bin : write_xlmeta_xml)();
	}
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = ([]); if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	
	// ----
	
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap;
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF_general(value);
		return SSF_format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, key, cp, val) {
		var oval = val;
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": oval = parsexmlbool(val); break;
			case "i2": case "int": oval = parseInt(val, 10); break;
			case "r4": case "float": oval = parseFloat(val); break;
			case "date": case "dateTime.tz": oval = parseDate(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw new Error("bad custprop:" + cp[0]);
		}
		Custprops[unescapexml(key)] = oval;
	}
	
	function safe_format_xlml(cell, nf, o) {
		if(cell.t === 'z') return;
		if(!o || o.cellText !== false) try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = cell.v.toString(10);
					else cell.w = SSF_general_num(cell.v);
				}
				else cell.w = SSF_general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
		} catch(e) { if(o.WTF) throw e; }
		try {
			var z = XLMLFormatMap[nf]||nf||"General";
			if(o.cellNF) cell.z = z;
			if(o.cellDates && cell.t == 'n' && fmt_is_date(z)) {
				var _d = SSF_parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
			}
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		var i = 0;
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
				break;
			case 'DateTime':
				if(xml.slice(-1) != "Z") xml += "Z";
				cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
			default:
				if(xml == "" && ss == "") { cell.t = 'z'; }
				else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
				break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula !== false) {
			if(cell.Formula) {
				var fstr = unescapexml(cell.Formula);
				/* strictly speaking, the leading = is required but some writers omit */
				if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
				cell.f = rc_to_a1(fstr, base);
				delete cell.Formula;
				if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
				else if(cell.ArrayRange) {
					cell.F = rc_to_a1(cell.ArrayRange, base);
					arrayf.push([safe_decode_range(cell.F), cell.F]);
				}
			} else {
				for(i = 0; i < arrayf.length; ++i)
					if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
						if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
							cell.F = arrayf[i][1];
			}
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v || "";
		comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	/* TODO: Everything */
	function parse_xlml_xml(d, _opts) {
		var opts = _opts || {};
		make_ssf();
		var str = debom(xlml_normalize(d));
		if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
			if(typeof $cptable !== 'undefined') str = $cptable.utils.decode(65001, char_codes(str));
			else str = utf8read(str);
		}
		var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
		opening = opening.replace(/".*?"/g, "");
		if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
		if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
		if(ishtml) return html_to_workbook(str, opts);
	
		XLMLFormatMap = ({
			"General Number": "General",
			"General Date": table_fmt[22],
			"Long Date": "dddd, mmmm dd, yyyy",
			"Medium Date": table_fmt[15],
			"Short Date": table_fmt[14],
			"Long Time": table_fmt[19],
			"Medium Time": table_fmt[18],
			"Short Time": table_fmt[20],
			"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
			"Fixed": table_fmt[2],
			"Standard": table_fmt[4],
			"Percent": table_fmt[10],
			"Scientific": table_fmt[11],
			"Yes/No": '"Yes";"Yes";"No";@',
			"True/False": '"True";"True";"False";@',
			"On/Off": '"Yes";"Yes";"No";@'
		});
	
	
		var Rn;
		var state = [], tmp;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
		var cell = ({}), row = {};// eslint-disable-line no-unused-vars
		var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
		var c = 0, r = 0;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var merges = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = [];
		var comments = [], comment = ({});
		var cstys = [], csty, seencol = false;
		var arrayf = [];
		var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
		var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"");
		var raw_Rn3 = "";
		while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
			case 'data' /*case 'Data'*/:
				if(raw_Rn3 == "data") {
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
				}
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'cell' /*case 'Cell'*/:
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
						if(opts.dense) {
							if(!cursheet[r]) cursheet[r] = [];
							cursheet[r][c] = cell;
						} else cursheet[encode_col(c) + encode_row(r)] = cell;
					}
					if(cell.HRef) {
						cell.l = ({Target:unescapexml(cell.HRef)});
						if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
						delete cell.HRef; delete cell.HRefScreenTip;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						cc = c + (parseInt(cell.MergeAcross,10)|0);
						rr = r + (parseInt(cell.MergeDown,10)|0);
						merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
					else if(cell.MergeAcross || cell.MergeDown) {
	for(var cma = c; cma <= cc; ++cma) {
							for(var cmd = r; cmd <= rr; ++cmd) {
								if(cma > c || cmd > r) {
									if(opts.dense) {
										if(!cursheet[cmd]) cursheet[cmd] = [];
										cursheet[cmd][cma] = {t:'z'};
									} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
								}
							}
						}
						c = cc + 1;
					}
					else ++c;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].slice(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'row' /*case 'Row'*/:
				if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].slice(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
					rowobj = {};
					if(row.AutoFitHeight == "0" || row.Height) {
						rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
						rowinfo[r] = rowobj;
					}
					if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
				}
				break;
			case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
						cursheet["!ref"] = encode_range(refguess);
						if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
							cursheet["!fullref"] = cursheet["!ref"];
							refguess.e.r = opts.sheetRows - 1;
							cursheet["!ref"] = encode_range(refguess);
						}
					}
					if(merges.length) cursheet["!merges"] = merges;
					if(cstys.length > 0) cursheet["!cols"] = cstys;
					if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = unescapexml(tmp.Name);
					cursheet = (opts.dense ? [] : {});
					merges = [];
					arrayf = [];
					rowinfo = [];
					wsprops = {name:sheetname, Hidden:0};
					Workbook.Sheets.push(wsprops);
				}
				break;
			case 'table' /*case 'Table'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					state.push([Rn[3], false]);
					cstys = []; seencol = false;
				}
				break;
	
			case 'style' /*case 'Style'*/:
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'numberformat' /*case 'NumberFormat'*/:
				stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
				if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
				for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == stag.nf) break;
				if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == null) { SSF_load(stag.nf, ssfidx); break; }
				break;
	
			case 'column' /*case 'Column'*/:
				if(state[state.length-1][0] !== /*'Table'*/'table') break;
				csty = xlml_parsexmltag(Rn[0]);
				if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
				if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
				if(!seencol && csty.wpx > 10) {
					seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
					for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
				}
				if(seencol) process_col(csty);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
				break;
	
			case 'namedrange' /*case 'NamedRange'*/:
				if(Rn[1]==='/') break;
				if(!Workbook.Names) Workbook.Names = [];
				var _NamedRange = parsexmltag(Rn[0]);
				var _DefinedName = ({
					Name: _NamedRange.Name,
					Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
				});
				if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
	Workbook.Names.push(_DefinedName);
				break;
	
			case 'namedcell' /*case 'NamedCell'*/: break;
			case 'b' /*case 'B'*/: break;
			case 'i' /*case 'I'*/: break;
			case 'u' /*case 'U'*/: break;
			case 's' /*case 'S'*/: break;
			case 'em' /*case 'EM'*/: break;
			case 'h2' /*case 'H2'*/: break;
			case 'h3' /*case 'H3'*/: break;
			case 'sub' /*case 'Sub'*/: break;
			case 'sup' /*case 'Sup'*/: break;
			case 'span' /*case 'Span'*/: break;
			case 'alignment' /*case 'Alignment'*/:
				break;
			case 'borders' /*case 'Borders'*/: break;
			case 'border' /*case 'Border'*/: break;
			case 'font' /*case 'Font'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'interior' /*case 'Interior'*/:
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'protection' /*case 'Protection'*/: break;
	
			case 'author' /*case 'Author'*/:
			case 'title' /*case 'Title'*/:
			case 'description' /*case 'Description'*/:
			case 'created' /*case 'Created'*/:
			case 'keywords' /*case 'Keywords'*/:
			case 'subject' /*case 'Subject'*/:
			case 'category' /*case 'Category'*/:
			case 'company' /*case 'Company'*/:
			case 'lastauthor' /*case 'LastAuthor'*/:
			case 'lastsaved' /*case 'LastSaved'*/:
			case 'lastprinted' /*case 'LastPrinted'*/:
			case 'version' /*case 'Version'*/:
			case 'revision' /*case 'Revision'*/:
			case 'totaltime' /*case 'TotalTime'*/:
			case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
			case 'manager' /*case 'Manager'*/:
			case 'contentstatus' /*case 'ContentStatus'*/:
			case 'identifier' /*case 'Identifier'*/:
			case 'language' /*case 'Language'*/:
			case 'appname' /*case 'AppName'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'paragraphs' /*case 'Paragraphs'*/: break;
	
			case 'styles' /*case 'Styles'*/:
			case 'workbook' /*case 'Workbook'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else state.push([Rn[3], false]);
				break;
	
			case 'comment' /*case 'Comment'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = ({a:tmp.Author});
				}
				break;
	
			case 'autofilter' /*case 'AutoFilter'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					var AutoFilter = xlml_parsexmltag(Rn[0]);
					cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
					state.push([Rn[3], true]);
				}
				break;
	
			case 'name' /*case 'Name'*/: break;
	
			case 'datavalidation' /*case 'DataValidation'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				} else {
					if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				}
				break;
	
			case 'pixelsperinch' /*case 'PixelsPerInch'*/:
				break;
			case 'componentoptions' /*case 'ComponentOptions'*/:
			case 'documentproperties' /*case 'DocumentProperties'*/:
			case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
			case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
			case 'pivottable' /*case 'PivotTable'*/:
			case 'pivotcache' /*case 'PivotCache'*/:
			case 'names' /*case 'Names'*/:
			case 'mapinfo' /*case 'MapInfo'*/:
			case 'pagebreaks' /*case 'PageBreaks'*/:
			case 'querytable' /*case 'QueryTable'*/:
			case 'sorting' /*case 'Sorting'*/:
			case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
			case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
			case 'smarttagtype' /*case 'SmartTagType'*/:
			case 'smarttags' /*case 'SmartTags'*/:
			case 'excelworkbook' /*case 'ExcelWorkbook'*/:
			case 'workbookoptions' /*case 'WorkbookOptions'*/:
			case 'worksheetoptions' /*case 'WorksheetOptions'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			case 'null' /*case 'Null'*/: break;
	
			default:
				/* FODS file root is <office:document> */
				if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
				/* UOS file root is <uof:UOF> */
				if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);
	
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
						case 'allowpng' /*case 'AllowPNG'*/: break;
						case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
						case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
						case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
						case 'colors' /*case 'Colors'*/: break;
						case 'color' /*case 'Color'*/: break;
						case 'index' /*case 'Index'*/: break;
						case 'rgb' /*case 'RGB'*/: break;
						case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
						case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
						case 'toolbar' /*case 'Toolbar'*/: break;
						case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
						case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
						case 'label' /*case 'Label'*/: break;
						case 'caption' /*case 'Caption'*/: break;
						case 'maxheight' /*case 'MaxHeight'*/: break;
						case 'maxwidth' /*case 'MaxWidth'*/: break;
						case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
						case 'date1904' /*case 'Date1904'*/:
	Workbook.WBProps.date1904 = true;
							break;
						case 'windowheight' /*case 'WindowHeight'*/: break;
						case 'windowwidth' /*case 'WindowWidth'*/: break;
						case 'windowtopx' /*case 'WindowTopX'*/: break;
						case 'windowtopy' /*case 'WindowTopY'*/: break;
						case 'tabratio' /*case 'TabRatio'*/: break;
						case 'protectstructure' /*case 'ProtectStructure'*/: break;
						case 'protectwindow' /*case 'ProtectWindow'*/: break;
						case 'protectwindows' /*case 'ProtectWindows'*/: break;
						case 'activesheet' /*case 'ActiveSheet'*/: break;
						case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
						case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
						case 'supbook' /*case 'SupBook'*/: break;
						case 'sheetname' /*case 'SheetName'*/: break;
						case 'sheetindex' /*case 'SheetIndex'*/: break;
						case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
						case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
						case 'dll' /*case 'Dll'*/: break;
						case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
						case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
						case 'iteration' /*case 'Iteration'*/: break;
						case 'maxiterations' /*case 'MaxIterations'*/: break;
						case 'maxchange' /*case 'MaxChange'*/: break;
						case 'path' /*case 'Path'*/: break;
						case 'xct' /*case 'Xct'*/: break;
						case 'count' /*case 'Count'*/: break;
						case 'selectedsheets' /*case 'SelectedSheets'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						case 'uncalced' /*case 'Uncalced'*/: break;
						case 'startupprompt' /*case 'StartupPrompt'*/: break;
						case 'crn' /*case 'Crn'*/: break;
						case 'externname' /*case 'ExternName'*/: break;
						case 'formula' /*case 'Formula'*/: break;
						case 'colfirst' /*case 'ColFirst'*/: break;
						case 'collast' /*case 'ColLast'*/: break;
						case 'wantadvise' /*case 'WantAdvise'*/: break;
						case 'boolean' /*case 'Boolean'*/: break;
						case 'error' /*case 'Error'*/: break;
						case 'text' /*case 'Text'*/: break;
						case 'ole' /*case 'OLE'*/: break;
						case 'noautorecover' /*case 'NoAutoRecover'*/: break;
						case 'publishobjects' /*case 'PublishObjects'*/: break;
						case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
						case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
						case 'owcversion' /*case 'OWCVersion'*/: break;
						case 'height' /*case 'Height'*/: break;
						case 'width' /*case 'Width'*/: break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
						case 'visible' /*case 'Visible'*/:
							if(Rn[0].slice(-2) === "/>"){/* empty */}
							else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
								case "SheetHidden": wsprops.Hidden = 1; break;
								case "SheetVeryHidden": wsprops.Hidden = 2; break;
							}
							else pidx = Rn.index + Rn[0].length;
							break;
						case 'header' /*case 'Header'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
							break;
						case 'footer' /*case 'Footer'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
							break;
						case 'pagemargins' /*case 'PageMargins'*/:
							var pagemargins = parsexmltag(Rn[0]);
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
							if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
							if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
							if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
							if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
							break;
						case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
							if(!Workbook.Views) Workbook.Views = [];
							if(!Workbook.Views[0]) Workbook.Views[0] = {};
							Workbook.Views[0].RTL = true;
							break;
	
						case 'freezepanes' /*case 'FreezePanes'*/: break;
						case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;
	
						case 'splithorizontal' /*case 'SplitHorizontal'*/:
						case 'splitvertical' /*case 'SplitVertical'*/:
							break;
	
						case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
							break;
	
						case 'activerow' /*case 'ActiveRow'*/: break;
						case 'activecol' /*case 'ActiveCol'*/: break;
						case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
						case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;
	
						case 'unsynced' /*case 'Unsynced'*/: break;
						case 'print' /*case 'Print'*/: break;
						case 'printerrors' /*case 'PrintErrors'*/: break;
						case 'panes' /*case 'Panes'*/: break;
						case 'scale' /*case 'Scale'*/: break;
						case 'pane' /*case 'Pane'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'layout' /*case 'Layout'*/: break;
						case 'pagesetup' /*case 'PageSetup'*/: break;
						case 'selected' /*case 'Selected'*/: break;
						case 'protectobjects' /*case 'ProtectObjects'*/: break;
						case 'enableselection' /*case 'EnableSelection'*/: break;
						case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
						case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
						case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
						case 'verticalresolution' /*case 'VerticalResolution'*/: break;
						case 'numberofcopies' /*case 'NumberofCopies'*/: break;
						case 'activepane' /*case 'ActivePane'*/: break;
						case 'toprowvisible' /*case 'TopRowVisible'*/: break;
						case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
						case 'fittopage' /*case 'FitToPage'*/: break;
						case 'rangeselection' /*case 'RangeSelection'*/: break;
						case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
						case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
						case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'fitwidth' /*case 'FitWidth'*/: break;
						case 'fitheight' /*case 'FitHeight'*/: break;
						case 'commentslayout' /*case 'CommentsLayout'*/: break;
						case 'zoom' /*case 'Zoom'*/: break;
						case 'lefttoright' /*case 'LeftToRight'*/: break;
						case 'gridlines' /*case 'Gridlines'*/: break;
						case 'allowsort' /*case 'AllowSort'*/: break;
						case 'allowfilter' /*case 'AllowFilter'*/: break;
						case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
						case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
						case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
						case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
						case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
						case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
						case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
						case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
						case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].above = true;
							break;
						case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
						case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
						case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
						case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].left = true;
							break;
						case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
						case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
						case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
						case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
						case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
						case 'noorientation' /*case 'NoOrientation'*/: break;
						case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
						case 'zeroheight' /*case 'ZeroHeight'*/: break;
						case 'viewablerange' /*case 'ViewableRange'*/: break;
						case 'selection' /*case 'Selection'*/: break;
						case 'protectcontents' /*case 'ProtectContents'*/: break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
						case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
						case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
						case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
						case 'location' /*case 'Location'*/: break;
						case 'pivotfield' /*case 'PivotField'*/: break;
						case 'orientation' /*case 'Orientation'*/: break;
						case 'layoutform' /*case 'LayoutForm'*/: break;
						case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
						case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
						case 'position' /*case 'Position'*/: break;
						case 'pivotitem' /*case 'PivotItem'*/: break;
						case 'datatype' /*case 'DataType'*/: break;
						case 'datafield' /*case 'DataField'*/: break;
						case 'sourcename' /*case 'SourceName'*/: break;
						case 'parentfield' /*case 'ParentField'*/: break;
						case 'ptlineitems' /*case 'PTLineItems'*/: break;
						case 'ptlineitem' /*case 'PTLineItem'*/: break;
						case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
						case 'item' /*case 'Item'*/: break;
						case 'itemtype' /*case 'ItemType'*/: break;
						case 'ptsource' /*case 'PTSource'*/: break;
						case 'cacheindex' /*case 'CacheIndex'*/: break;
						case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
						case 'filename' /*case 'FileName'*/: break;
						case 'reference' /*case 'Reference'*/: break;
						case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
						case 'norowgrand' /*case 'NoRowGrand'*/: break;
						case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
						case 'hidden' /*case 'Hidden'*/: break;
						case 'subtotal' /*case 'Subtotal'*/: break;
						case 'basefield' /*case 'BaseField'*/: break;
						case 'mapchilditems' /*case 'MapChildItems'*/: break;
						case 'function' /*case 'Function'*/: break;
						case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
						case 'printsettitles' /*case 'PrintSetTitles'*/: break;
						case 'mergelabels' /*case 'MergeLabels'*/: break;
						case 'defaultversion' /*case 'DefaultVersion'*/: break;
						case 'refreshname' /*case 'RefreshName'*/: break;
						case 'refreshdate' /*case 'RefreshDate'*/: break;
						case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
						case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
						case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
						case 'colbreaks' /*case 'ColBreaks'*/: break;
						case 'colbreak' /*case 'ColBreak'*/: break;
						case 'rowbreaks' /*case 'RowBreaks'*/: break;
						case 'rowbreak' /*case 'RowBreak'*/: break;
						case 'colstart' /*case 'ColStart'*/: break;
						case 'colend' /*case 'ColEnd'*/: break;
						case 'rowend' /*case 'RowEnd'*/: break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
						case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
						case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
						case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
						case 'autofilteror' /*case 'AutoFilterOr'*/: break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
						case 'id' /*case 'Id'*/: break;
						case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
						case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
						case 'querysource' /*case 'QuerySource'*/: break;
						case 'querytype' /*case 'QueryType'*/: break;
						case 'enableredirections' /*case 'EnableRedirections'*/: break;
						case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
						case 'urlstring' /*case 'URLString'*/: break;
						case 'htmltables' /*case 'HTMLTables'*/: break;
						case 'connection' /*case 'Connection'*/: break;
						case 'commandtext' /*case 'CommandText'*/: break;
						case 'refreshinfo' /*case 'RefreshInfo'*/: break;
						case 'notitles' /*case 'NoTitles'*/: break;
						case 'nextid' /*case 'NextId'*/: break;
						case 'columninfo' /*case 'ColumnInfo'*/: break;
						case 'overwritecells' /*case 'OverwriteCells'*/: break;
						case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
						case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
						case 'source' /*case 'Source'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'decimal' /*case 'Decimal'*/: break;
						case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
						case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
						case 'formatsettings' /*case 'FormatSettings'*/: break;
						case 'fieldtype' /*case 'FieldType'*/: break;
						case 'delimiters' /*case 'Delimiters'*/: break;
						case 'tab' /*case 'Tab'*/: break;
						case 'comma' /*case 'Comma'*/: break;
						case 'autoformatname' /*case 'AutoFormatName'*/: break;
						case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						default: seen = false;
					} break;
	
					case 'datavalidation' /*case 'DataValidation'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
	
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
	
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						default: seen = false;
					} break;
	
					case 'sorting' /*case 'Sorting'*/:
					case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
						case 'map' /*case 'Map'*/: break;
						case 'entry' /*case 'Entry'*/: break;
						case 'range' /*case 'Range'*/: break;
						case 'xpath' /*case 'XPath'*/: break;
						case 'field' /*case 'Field'*/: break;
						case 'xsdtype' /*case 'XSDType'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'aggregate' /*case 'Aggregate'*/: break;
						case 'elementtype' /*case 'ElementType'*/: break;
						case 'attributetype' /*case 'AttributeType'*/: break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema' /*case 'schema'*/:
						case 'element' /*case 'element'*/:
						case 'complextype' /*case 'complexType'*/:
						case 'datatype' /*case 'datatype'*/:
						case 'all' /*case 'all'*/:
						case 'attribute' /*case 'attribute'*/:
						case 'extends' /*case 'extends'*/: break;
	
						case 'row' /*case 'row'*/: break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'smarttags' /*case 'SmartTags'*/: break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(Rn[3].match(/!\[CDATA/)) break;
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = ({});
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.Workbook = Workbook;
		out.SSF = dup(table_fmt);
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64_decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(a2s(data), opts);
		}
	}
	
	/* TODO */
	function write_props_xlml(wb, opts) {
		var o = [];
		/* DocumentProperties */
		if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
		/* CustomDocumentProperties */
		if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
		return o.join("");
	}
	/* TODO */
	function write_wb_xlml() {
		/* OfficeDocumentSettings */
		/* ExcelWorkbook */
		return "";
	}
	/* TODO */
	function write_sty_xlml(wb, opts) {
		/* Styles */
		var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
		opts.cellXfs.forEach(function(xf, id) {
			var payload = [];
			payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(table_fmt[xf.numFmtId])}));
	
			var o = {"ss:ID": "s" + (21+id)};
			styles.push(writextag('Style', payload.join(""), o));
		});
		return writextag("Styles", styles.join(""));
	}
	function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
	function write_names_xlml(wb) {
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != null) continue;
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return writextag("Names", out.join(""));
	}
	function write_ws_xlml_names(ws, opts, idx, wb) {
		if(!ws) return "";
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != idx) continue;
			/*switch(n.Name) {
				case "_": continue;
			}*/
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return out.join("");
	}
	/* WorksheetOptions */
	function write_ws_xlml_wsopts(ws, opts, idx, wb) {
		if(!ws) return "";
		var o = [];
		/* NOTE: spec technically allows any order, but stick with implied order */
	
		/* FitToPage */
		/* DoNotDisplayColHeaders */
		/* DoNotDisplayRowHeaders */
		/* ViewableRange */
		/* Selection */
		/* GridlineColor */
		/* Name */
		/* ExcelWorksheetType */
		/* IntlMacro */
		/* Unsynced */
		/* Selected */
		/* CodeName */
	
		if(ws['!margins']) {
			o.push("<PageSetup>");
			if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
			if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
			o.push(writextag("PageMargins", null, {
				'x:Bottom': ws['!margins'].bottom || "0.75",
				'x:Left': ws['!margins'].left || "0.7",
				'x:Right': ws['!margins'].right || "0.7",
				'x:Top': ws['!margins'].top || "0.75"
			}));
			o.push("</PageSetup>");
		}
	
		/* PageSetup */
		/* DisplayPageBreak */
		/* TransitionExpressionEvaluation */
		/* TransitionFormulaEntry */
		/* Print */
		/* Zoom */
		/* PageLayoutZoom */
		/* PageBreakZoom */
		/* ShowPageBreakZoom */
		/* DefaultRowHeight */
		/* DefaultColumnWidth */
		/* StandardWidth */
	
		if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
			/* Visible */
			if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
			else {
				/* Selected */
				for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
				if(i == idx) o.push("<Selected/>");
			}
		}
	
		/* LeftColumnVisible */
	
		if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");
	
		/* GridlineColorIndex */
		/* DisplayFormulas */
		/* DoNotDisplayGridlines */
		/* DoNotDisplayHeadings */
		/* DoNotDisplayOutline */
		/* ApplyAutomaticOutlineStyles */
		/* NoSummaryRowsBelowDetail */
		/* NoSummaryColumnsRightDetail */
		/* DoNotDisplayZeros */
		/* ActiveRow */
		/* ActiveColumn */
		/* FilterOn */
		/* RangeSelection */
		/* TopRowVisible */
		/* TopRowBottomPane */
		/* LeftColumnRightPane */
		/* ActivePane */
		/* SplitHorizontal */
		/* SplitVertical */
		/* FreezePanes */
		/* FrozenNoSplit */
		/* TabColorIndex */
		/* Panes */
	
		/* NOTE: Password not supported in XLML Format */
		if(ws['!protect']) {
			o.push(writetag("ProtectContents", "True"));
			if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
			if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
			if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
			else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
		[
			[ "formatCells", "AllowFormatCells" ],
			[ "formatColumns", "AllowSizeCols" ],
			[ "formatRows", "AllowSizeRows" ],
			[ "insertColumns", "AllowInsertCols" ],
			[ "insertRows", "AllowInsertRows" ],
			[ "insertHyperlinks", "AllowInsertHyperlinks" ],
			[ "deleteColumns", "AllowDeleteCols" ],
			[ "deleteRows", "AllowDeleteRows" ],
			[ "sort", "AllowSort" ],
			[ "autoFilter", "AllowFilter" ],
			[ "pivotTables", "AllowUsePivotTables" ]
		].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
		}
	
		if(o.length == 0) return "";
		return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
	}
	function write_ws_xlml_comment(comments) {
		return comments.map(function(c) {
			// TODO: formatted text
			var t = xlml_unfixstr(c.t||"");
			var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
			return writextag("Comment", d, {"ss:Author":c.a});
		}).join("");
	}
	function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
		if(!cell || (cell.v == undefined && cell.f == undefined)) return "";
	
		var attr = {};
		if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
		if(cell.F && cell.F.slice(0, ref.length) == ref) {
			var end = decode_cell(cell.F.slice(ref.length + 1));
			attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
		}
	
		if(cell.l && cell.l.Target) {
			attr["ss:HRef"] = escapexml(cell.l.Target);
			if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
		}
	
		if(ws['!merges']) {
			var marr = ws['!merges'];
			for(var mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
				if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
				if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
			}
		}
	
		var t = "", p = "";
		switch(cell.t) {
			case 'z': if(!opts.sheetStubs) return ""; break;
			case 'n': t = 'Number'; p = String(cell.v); break;
			case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
			case 'e': t = 'Error'; p = BErr[cell.v]; break;
			case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || table_fmt[14]; break;
			case 's': t = 'String'; p = escapexlml(cell.v||""); break;
		}
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		attr["ss:StyleID"] = "s" + (21+os);
		attr["ss:Index"] = addr.c + 1;
		var _v = (cell.v != null ? p : "");
		var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');
	
		if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);
	
		return writextag("Cell", m, attr);
	}
	function write_ws_xlml_row(R, row) {
		var o = '<Row ss:Index="' + (R+1) + '"';
		if(row) {
			if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
			if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
			if(row.hidden) o += ' ss:Hidden="1"';
		}
		return o + '>';
	}
	/* TODO */
	function write_ws_xlml_table(ws, opts, idx, wb) {
		if(!ws['!ref']) return "";
		var range = safe_decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var o = [];
		if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
			process_col(n);
			var w = !!n.width;
			var p = col_obj_w(i, n);
			var k = {"ss:Index":i+1};
			if(w) k['ss:Width'] = width2px(p.width);
			if(n.hidden) k['ss:Hidden']="1";
			o.push(writextag("Column",null,k));
		});
		var dense = Array.isArray(ws);
		for(var R = range.s.r; R <= range.e.r; ++R) {
			var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
			for(var C = range.s.c; C <= range.e.c; ++C) {
				var skip = false;
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					break;
				}
				if(skip) continue;
				var addr = {r:R,c:C};
				var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
				row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
			}
			row.push("</Row>");
			if(row.length > 2) o.push(row.join(""));
		}
		return o.join("");
	}
	function write_ws_xlml(idx, opts, wb) {
		var o = [];
		var s = wb.SheetNames[idx];
		var ws = wb.Sheets[s];
	
		var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Names>" + t + "</Names>");
	
		/* Table */
		t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Table>" + t + "</Table>");
	
		/* WorksheetOptions */
		o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
	
		return o.join("");
	}
	function write_xlml(wb, opts) {
		if(!opts) opts = {};
		if(!wb.SSF) wb.SSF = dup(table_fmt);
		if(wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
			opts.cellXfs = [];
			get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
		}
		var d = [];
		d.push(write_props_xlml(wb, opts));
		d.push(write_wb_xlml(wb, opts));
		d.push("");
		d.push("");
		for(var i = 0; i < wb.SheetNames.length; ++i)
			d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
		d[2] = write_sty_xlml(wb, opts);
		d[3] = write_names_xlml(wb, opts);
		return XML_HEADER + writextag("Workbook", d.join(""), {
			'xmlns':      XLMLNS.ss,
			'xmlns:o':    XLMLNS.o,
			'xmlns:x':    XLMLNS.x,
			'xmlns:ss':   XLMLNS.ss,
			'xmlns:dt':   XLMLNS.dt,
			'xmlns:html': XLMLNS.html
		});
	}
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		o.l = 28;
	
		v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
		v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
	
		if(o.length - o.l <= 4) return v;
	
		var m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");
	
		if(o.length - o.l <= 4) return v;
		m = o.read_shift(4);
		if(m !== 0x71b239f4) return v;
		v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
	
		m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
	}
	
	/*
		Continue logic for:
		- 2.4.58 Continue          0x003c
		- 2.4.59 ContinueBigName   0x043c
		- 2.4.60 ContinueFrt       0x0812
		- 2.4.61 ContinueFrt11     0x0875
		- 2.4.62 ContinueFrt12     0x087f
	*/
	var CONTINUE_RT = [ 0x003c, 0x043c, 0x0812, 0x0875, 0x087f ];
	function slurp(RecordType, R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType) {
		case 0x0009: case 0x0209: case 0x0409: case 0x0809/* BOF */: case 0x002f /* FilePass */: case 0x0195 /* FileLock */: case 0x00e1 /* InterfaceHdr */: case 0x0196 /* RRDInfo */: case 0x0138 /* RRDHead */: case 0x0194 /* UsrExcl */: case 0x000a /* EOF */:
			break;
		case 0x0085 /* BoundSheet8 */:
			break;
		default:
			opts.enc.insitu(d);
		}
		bufs.push(d);
		blob.l += l;
		var nextrt = __readUInt16LE(blob,blob.l), next = XLSRecordEnum[nextrt];
		var start = 0;
		while(next != null && CONTINUE_RT.indexOf(nextrt) > -1) {
			l = __readUInt16LE(blob,blob.l+2);
			start = blob.l + 4;
			if(nextrt == 0x0812 /* ContinueFrt */) start += 4;
			else if(nextrt == 0x0875 || nextrt == 0x087f) {
				start += 12;
			}
			d = blob.slice(start,blob.l+4+l);
			bufs.push(d);
			blob.l += 4+l;
			next = (XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)]);
		}
		var b = (bconcat(bufs));
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		if(b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(p.t === 'z') return;
		if(!p.XF) return;
		var fmtid = 0;
		try {
			fmtid = p.z || p.XF.numFmtId || 0;
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0 || fmtid == "General") {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else p.w = SSF_general(p.v);
			}
			else p.w = SSF_format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
		} catch(e) { if(opts.WTF) throw e; }
		if(opts.cellDates && fmtid && p.t == 'n' && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
			var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	}
	
	function make_cell(val, ixfe, t) {
		return ({v:val, ixfe:ixfe, t:t});
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = ({opts:{}});
		var Sheets = {};
		if(DENSE != null && options.dense == null) options.dense = DENSE;
		var out = ((options.dense ? [] : {}));
		var Directory = {};
		var range = ({});
		var last_formula = null;
		var sst = ([]);
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
		var sharedf = {};
		var arrayf = [];
		var temp_val;
		var country;
		var XFs = []; /* XF records */
		var palette = [];
		var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line, options) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
			line.s = ({});
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(file_depth > 1) return;
			if(options.sheetRows && cell.r >= options.sheetRows) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
			delete line.ixfe; delete line.XF;
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			if(options.cellFormula && line.f) {
				for(var afi = 0; afi < arrayf.length; ++afi) {
					if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
					if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
					line.F = encode_range(arrayf[afi][0]);
					if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
					if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
					break;
				}
			}
			{
				if(options.dense) {
					if(!out[cell.r]) out[cell.r] = [];
					out[cell.r][cell.c] = line;
				} else out[last_cell] = line;
			}
		};
		var opts = ({
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: sharedf, // shared formulae by address
			arrayf: arrayf, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			cellStyles: !!options && !!options.cellStyles,
			WTF: !!options && !!options.wtf
		});
		if(options.password) opts.password = options.password;
		var themes;
		var merges = [];
		var objects = [];
		var colinfo = [], rowinfo = [];
		var seencol = false;
		var supbooks = ([]); // 1-indexed, will hold extern names
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		supbooks.names = [];
		supbooks.XTI = [];
		var last_RT = 0;
		var file_depth = 0; /* TODO: make a real stack */
		var BIFF2Fmt = 0, BIFF2FmtTable = [];
		var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
		var last_lbl;
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
		var seen_codepage = false;
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_RT === 0x000a /* EOF */) break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
			var R = XLSRecordEnum[RecordType];
			//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
			//if(!R) console.log(blob.slice(blob.l, blob.l + length));
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_RT === 0x0085 /* BoundSheet8 */ && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */) break;
				}
				last_RT = RecordType;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
					if(R.r == 12){
						blob.l += 10; length -= 10;
					} // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val = ({});
				if(RecordType === 0x000a /* EOF */) val = R.f(blob, length, opts);
				else val = slurp(RecordType, R, blob, length, opts);
	if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(last_RT) === -1 /* 'BOF' */) continue;
				switch(RecordType) {
					case 0x0022 /* Date1904 */:
	wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
					case 0x0086 /* WriteProtect */: wb.opts.WriteProtect = true; break;
					case 0x002f /* FilePass */:
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(!options.password) throw new Error("File is password-protected");
						if(val.valid == null) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 0x005c /* WriteAccess */: opts.lastuser = val; break;
					case 0x0042 /* CodePage */:
						var cpval = Number(val);
						/* overrides based on test cases */
						switch(cpval) {
							case 0x5212: cpval =  1200; break;
							case 0x8000: cpval = 10000; break;
							case 0x8001: cpval =  1252; break;
						}
						set_cp(opts.codepage = cpval);
						seen_codepage = true;
						break;
					case 0x013d /* RRTabId */: opts.rrtabid = val; break;
					case 0x0019 /* WinProtect */: opts.winlocked = val; break;
					case 0x01b7 /* RefreshAll */: wb.opts["RefreshAll"] = val; break;
					case 0x000c /* CalcCount */: wb.opts["CalcCount"] = val; break;
					case 0x0010 /* CalcDelta */: wb.opts["CalcDelta"] = val; break;
					case 0x0011 /* CalcIter */: wb.opts["CalcIter"] = val; break;
					case 0x000d /* CalcMode */: wb.opts["CalcMode"] = val; break;
					case 0x000e /* CalcPrecision */: wb.opts["CalcPrecision"] = val; break;
					case 0x005f /* CalcSaveRecalc */: wb.opts["CalcSaveRecalc"] = val; break;
					case 0x000f /* CalcRefMode */: opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 0x08a3 /* ForceFullCalculation */: wb.opts.FullCalc = val; break;
					case 0x0081 /* WsBool */:
						if(val.fDialog) out["!type"] = "dialog";
						if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
						if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
						break; // TODO
					case 0x00e0 /* XF */:
						XFs.push(val); break;
					case 0x01ae /* SupBook */:
						supbooks.push([val]);
						supbooks[supbooks.length-1].XTI = [];
						break;
					case 0x0023: case 0x0223 /* ExternName */:
						supbooks[supbooks.length-1].push(val);
						break;
					case 0x0018: case 0x0218 /* Lbl */:
						last_lbl = ({
							Name: val.Name,
							Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
						});
						if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
						supbooks.names.push(last_lbl);
						if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length-1].push(val);
						if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
							if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
								FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
						break;
					case 0x0016 /* ExternCount */: opts.ExternCount = val; break;
					case 0x0017 /* ExternSheet */:
						if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
					case 0x0894 /* NameCmt */:
						/* TODO: search for correct name */
						if(opts.biff < 8) break;
						if(last_lbl != null) last_lbl.Comment = val[1];
						break;
					case 0x0012 /* Protect */: out["!protect"] = val; break; /* for sheet or book */
					case 0x0013 /* Password */: if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 0x0085 /* BoundSheet8 */: {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 0x000a /* EOF */: {
						if(--file_depth) break;
						if(range.e) {
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								if(options.sheetRows && options.sheetRows <= range.e.r) {
									var tmpri = range.e.r;
									range.e.r = options.sheetRows - 1;
									out["!fullref"] = out["!ref"];
									out["!ref"] = encode_range(range);
									range.e.r = tmpri;
								}
								range.e.r++; range.e.c++;
							}
							if(merges.length > 0) out["!merges"] = merges;
							if(objects.length > 0) out["!objects"] = objects;
							if(colinfo.length > 0) out["!cols"] = colinfo;
							if(rowinfo.length > 0) out["!rows"] = rowinfo;
							Workbook.Sheets.push(wsprops);
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = ((options.dense ? [] : {}));
					} break;
					case 0x0009: case 0x0209: case 0x0409: case 0x0809 /* BOF */: {
						if(opts.biff === 8) opts.biff = {
	0x0009:2,
	0x0209:3,
	0x0409:4
						}[RecordType] || {
	0x0200:2,
	0x0300:3,
	0x0400:4,
	0x0500:5,
	0x0600:8,
	0x0002:2,
	0x0007:2
						}[val.BIFFVer] || 8;
						opts.biffguess = val.BIFFVer == 0;
						if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
						if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
						if(file_depth++) break;
						out = ((options.dense ? [] : {}));
	
						if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
	
						if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
							/* fake BoundSheet8 */
							var fakebs8 = {pos: blob.l - length, name:cur_sheet};
							Directory[fakebs8.pos] = fakebs8;
							opts.snames.push(cur_sheet);
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						if(val.dt == 0x20) out["!type"] = "chart";
						if(val.dt == 0x40) out["!type"] = "macro";
						merges = [];
						objects = [];
						opts.arrayf = arrayf = [];
						colinfo = []; rowinfo = [];
						seencol = false;
						wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
					} break;
					case 0x0203 /* Number */: case 0x0003 /* BIFF2NUM */: case 0x0002 /* BIFF2INT */: {
						if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x0005: case 0x0205 /* BoolErr */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x027e /* RK */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00bd /* MulRk */: {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x0006: case 0x0206: case 0x0406 /* Formula */: {
						if(val.val == 'String') { last_formula = val; break; }
						temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							var _f = val.formula;
							if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
								var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
								var _fe = encode_cell({r:_fr, c:_fc});
								if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
							} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(val.cell, temp_val, options);
						last_formula = val;
					} break;
					case 0x0007: case 0x0207 /* String */: {
						if(last_formula) { /* technically always true */
							last_formula.val = val;
							temp_val = make_cell(val, last_formula.cell.ixfe, 's');
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) {
								temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							}
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						} else throw new Error("String record expects Formula");
					} break;
					case 0x0021: case 0x0221 /* Array */: {
						arrayf.push(val);
						var _arraystart = encode_cell(val[0].s);
						cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
						if(options.cellFormula && cc) {
							if(!last_formula) break; /* technically unreachable */
							if(!_arraystart || !cc) break;
							cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
							cc.F = encode_range(val[0]);
						}
					} break;
					case 0x04bc /* ShrFmla */: {
						if(!options.cellFormula) break;
						if(last_cell) {
							/* TODO: capture range */
							if(!last_formula) break; /* technically unreachable */
							sharedf[encode_cell(last_formula.cell)]= val[0];
							cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
							(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
						}
					} break;
					case 0x00fd /* LabelSst */:
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 0x0201 /* Blank */: if(options.sheetStubs) {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00be /* MulBlank */: if(options.sheetStubs) {
						for(var _j = val.c; _j <= val.C; ++_j) {
							var _ixfe = val.ixfe[_j-val.c];
							temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:_j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x00d6 /* RString */:
					case 0x0204 /* Label */: case 0x0004 /* BIFF2STR */:
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
	
					case 0x0000: case 0x0200 /* Dimensions */: {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 0x00fc /* SST */: {
						sst = val;
					} break;
					case 0x041e /* Format */: { /* val = [id, fmt] */
						if(opts.biff == 4) {
							BIFF2FmtTable[BIFF2Fmt++] = val[1];
							for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(table_fmt[b4idx] == val[1]) break;
							if(b4idx >= 163) SSF_load(val[1], BIFF2Fmt + 163);
						}
						else SSF_load(val[1], val[0]);
					} break;
					case 0x001e /* BIFF2FORMAT */: {
						BIFF2FmtTable[BIFF2Fmt++] = val;
						for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(table_fmt[b2idx] == val) break;
						if(b2idx >= 163) SSF_load(val, BIFF2Fmt + 163);
					} break;
	
					case 0x00e5 /* MergeCells */: merges = merges.concat(val); break;
	
					case 0x005d /* Obj */: objects[val.cmo[0]] = opts.lastobj = val; break;
					case 0x01b6 /* TxO */: opts.lastobj.TxO = val; break;
					case 0x007f /* ImData */: opts.lastobj.ImData = val; break;
	
					case 0x01b8 /* HLink */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l = val[1];
							}
					} break;
					case 0x0800 /* HLinkTooltip */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc && cc.l) cc.l.Tooltip = val[1];
								}
					} break;
					case 0x001c /* Note */: {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) {
							if(options.dense) {
								if(!out[val[0].r]) out[val[0].r] = [];
								cc = out[val[0].r][val[0].c] = ({t:"z"});
							} else {
								cc = out[encode_cell(val[0])] = ({t:"z"});
							}
							range.e.r = Math.max(range.e.r, val[0].r);
							range.s.r = Math.min(range.s.r, val[0].r);
							range.e.c = Math.max(range.e.c, val[0].c);
							range.s.c = Math.min(range.s.c, val[0].c);
						}
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
					case 0x087d /* XFExt */: update_xfext(XFs[val.ixfe], val.ext); break;
					case 0x007d /* ColInfo */: {
						if(!opts.cellStyles) break;
						while(val.e >= val.s) {
							colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
							if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
							process_col(colinfo[val.e+1]);
						}
					} break;
					case 0x0208 /* Row */: {
						var rowobj = {};
						if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
						if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
						if(val.hpt) {
							rowinfo[val.r] = rowobj;
							rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
						}
					} break;
					case 0x0026 /* LeftMargin */:
					case 0x0027 /* RightMargin */:
					case 0x0028 /* TopMargin */:
					case 0x0029 /* BottomMargin */:
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'][({0x26: "left", 0x27:"right", 0x28:"top", 0x29:"bottom"})[RecordType]] = val;
						break;
					case 0x00a1 /* Setup */: // TODO
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'].header = val.header;
						out['!margins'].footer = val.footer;
						break;
					case 0x023e /* Window2 */: // TODO
						// $FlowIgnore
						if(val.RTL) Workbook.Views[0].RTL = true;
						break;
					case 0x0092 /* Palette */: palette = val; break;
					case 0x0896 /* Theme */: themes = val; break;
					case 0x008c /* Country */: country = val; break;
					case 0x01ba /* CodeName */: {
	if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
						else wsprops.CodeName = val || wsprops.name;
					} break;
				}
			} else {
				if(!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
				blob.l += length;
			}
		}
		wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		if(!options.bookSheets) wb.Sheets=Sheets;
		if(!wb.SheetNames.length && Preamble["!ref"]) {
			wb.SheetNames.push("Sheet1");
			/*jshint -W069 */
			if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
			/*jshint +W069 */
		} else wb.Preamble=Preamble;
		if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
		wb.Strings = sst;
		wb.SSF = dup(table_fmt);
		if(opts.enc) wb.Encryption = opts.enc;
		if(themes) wb.Themes = themes;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
		wb.Workbook = Workbook;
		return wb;
	}
	
	/* TODO: split props*/
	var PSCLSID = {
		SI: "e0859ff2f94f6810ab9108002b27b3d9",
		DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
		UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
	};
	function parse_xls_props(cfb, props, o) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
		if(DSI && DSI.size > 0) try {
			var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
			for(var d in DocSummary) props[d] = DocSummary[d];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = CFB.find(cfb, '/!SummaryInformation');
		if(SI && SI.size > 0) try {
			var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
			for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		if(props.HeadingPairs && props.TitlesOfParts) {
			load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
			delete props.HeadingPairs; delete props.TitlesOfParts;
		}
	}
	function write_xls_props(wb, cfb) {
		var DSEntries = [], SEntries = [], CEntries = [];
		var i = 0, Keys;
		var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
		var SummaryRE = evert_key(SummaryPIDSI, "n");
		if(wb.Props) {
			Keys = keys(wb.Props);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
		}
		if(wb.Custprops) {
			Keys = keys(wb.Custprops);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
		}
		var CEntries2 = [];
		for(i = 0; i < CEntries.length; ++i) {
			if(XLSPSSkip.indexOf(CEntries[i][0]) > -1 || PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
			if(CEntries[i][1] == null) continue;
			CEntries2.push(CEntries[i]);
		}
		if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
		if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	if(options.codepage) set_ansi(options.codepage);
	var CompObj, WB;
	if(cfb.FullPaths) {
		if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
		CompObj = CFB.find(cfb, '!CompObj');
		WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
	} else {
		switch(options.type) {
			case 'base64': cfb = s2a(Base64_decode(cfb)); break;
			case 'binary': cfb = s2a(cfb); break;
			case 'buffer': break;
			case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
		}
		prep_blob(cfb, 0);
		WB = ({content: cfb});
	}
	var WorkbookP;
	
	var _data;
	if(CompObj) parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = ({});
	else {
		var T = has_buf ? 'buffer' : 'array';
		if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
		/* Quattro Pro 7-8 */
		else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Quattro Pro 9 */
		else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Works 4 for Mac */
		else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
		else throw new Error("Cannot find Workbook stream");
		if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
	}
	
	var props = {};
	if(cfb.FullPaths) parse_xls_props(cfb, props, options);
	
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
	return WorkbookP;
	}
	
	
	function write_xlscfb(wb, opts) {
		var o = opts || {};
		var cfb = CFB.utils.cfb_new({root:"R"});
		var wbpath = "/Workbook";
		switch(o.bookType || "xls") {
			case "xls": o.bookType = "biff8";
			/* falls through */
			case "xla": if(!o.bookType) o.bookType = "xla";
			/* falls through */
			case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
			case "biff5": wbpath = "/Book"; o.biff = 5; break;
			default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
		}
		CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
		if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
		// TODO: SI, DSI, CO
		if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
		return cfb;
	}
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
	0x0000: { /* n:"BrtRowHdr", */ f:parse_BrtRowHdr },
	0x0001: { /* n:"BrtCellBlank", */ f:parse_BrtCellBlank },
	0x0002: { /* n:"BrtCellRk", */ f:parse_BrtCellRk },
	0x0003: { /* n:"BrtCellError", */ f:parse_BrtCellError },
	0x0004: { /* n:"BrtCellBool", */ f:parse_BrtCellBool },
	0x0005: { /* n:"BrtCellReal", */ f:parse_BrtCellReal },
	0x0006: { /* n:"BrtCellSt", */ f:parse_BrtCellSt },
	0x0007: { /* n:"BrtCellIsst", */ f:parse_BrtCellIsst },
	0x0008: { /* n:"BrtFmlaString", */ f:parse_BrtFmlaString },
	0x0009: { /* n:"BrtFmlaNum", */ f:parse_BrtFmlaNum },
	0x000A: { /* n:"BrtFmlaBool", */ f:parse_BrtFmlaBool },
	0x000B: { /* n:"BrtFmlaError", */ f:parse_BrtFmlaError },
	0x000C: { /* n:"BrtShortBlank", */ f:parse_BrtShortBlank },
	0x000D: { /* n:"BrtShortRk", */ f:parse_BrtShortRk },
	0x000E: { /* n:"BrtShortError", */ f:parse_BrtShortError },
	0x000F: { /* n:"BrtShortBool", */ f:parse_BrtShortBool },
	0x0010: { /* n:"BrtShortReal", */ f:parse_BrtShortReal },
	0x0011: { /* n:"BrtShortSt", */ f:parse_BrtShortSt },
	0x0012: { /* n:"BrtShortIsst", */ f:parse_BrtShortIsst },
	0x0013: { /* n:"BrtSSTItem", */ f:parse_RichStr },
	0x0014: { /* n:"BrtPCDIMissing" */ },
	0x0015: { /* n:"BrtPCDINumber" */ },
	0x0016: { /* n:"BrtPCDIBoolean" */ },
	0x0017: { /* n:"BrtPCDIError" */ },
	0x0018: { /* n:"BrtPCDIString" */ },
	0x0019: { /* n:"BrtPCDIDatetime" */ },
	0x001A: { /* n:"BrtPCDIIndex" */ },
	0x001B: { /* n:"BrtPCDIAMissing" */ },
	0x001C: { /* n:"BrtPCDIANumber" */ },
	0x001D: { /* n:"BrtPCDIABoolean" */ },
	0x001E: { /* n:"BrtPCDIAError" */ },
	0x001F: { /* n:"BrtPCDIAString" */ },
	0x0020: { /* n:"BrtPCDIADatetime" */ },
	0x0021: { /* n:"BrtPCRRecord" */ },
	0x0022: { /* n:"BrtPCRRecordDt" */ },
	0x0023: { /* n:"BrtFRTBegin", */ T:1 },
	0x0024: { /* n:"BrtFRTEnd", */ T:-1 },
	0x0025: { /* n:"BrtACBegin", */ T:1 },
	0x0026: { /* n:"BrtACEnd", */ T:-1 },
	0x0027: { /* n:"BrtName", */ f:parse_BrtName },
	0x0028: { /* n:"BrtIndexRowBlock" */ },
	0x002A: { /* n:"BrtIndexBlock" */ },
	0x002B: { /* n:"BrtFont", */ f:parse_BrtFont },
	0x002C: { /* n:"BrtFmt", */ f:parse_BrtFmt },
	0x002D: { /* n:"BrtFill", */ f:parse_BrtFill },
	0x002E: { /* n:"BrtBorder", */ f:parse_BrtBorder },
	0x002F: { /* n:"BrtXF", */ f:parse_BrtXF },
	0x0030: { /* n:"BrtStyle" */ },
	0x0031: { /* n:"BrtCellMeta", */ f:parse_Int32LE },
	0x0032: { /* n:"BrtValueMeta" */ },
	0x0033: { /* n:"BrtMdb" */ f:parse_BrtMdb },
	0x0034: { /* n:"BrtBeginFmd", */ T:1 },
	0x0035: { /* n:"BrtEndFmd", */ T:-1 },
	0x0036: { /* n:"BrtBeginMdx", */ T:1 },
	0x0037: { /* n:"BrtEndMdx", */ T:-1 },
	0x0038: { /* n:"BrtBeginMdxTuple", */ T:1 },
	0x0039: { /* n:"BrtEndMdxTuple", */ T:-1 },
	0x003A: { /* n:"BrtMdxMbrIstr" */ },
	0x003B: { /* n:"BrtStr" */ },
	0x003C: { /* n:"BrtColInfo", */ f:parse_ColInfo },
	0x003E: { /* n:"BrtCellRString", */ f:parse_BrtCellRString },
	0x003F: { /* n:"BrtCalcChainItem$", */ f:parse_BrtCalcChainItem$ },
	0x0040: { /* n:"BrtDVal", */ f:parse_BrtDVal },
	0x0041: { /* n:"BrtSxvcellNum" */ },
	0x0042: { /* n:"BrtSxvcellStr" */ },
	0x0043: { /* n:"BrtSxvcellBool" */ },
	0x0044: { /* n:"BrtSxvcellErr" */ },
	0x0045: { /* n:"BrtSxvcellDate" */ },
	0x0046: { /* n:"BrtSxvcellNil" */ },
	0x0080: { /* n:"BrtFileVersion" */ },
	0x0081: { /* n:"BrtBeginSheet", */ T:1 },
	0x0082: { /* n:"BrtEndSheet", */ T:-1 },
	0x0083: { /* n:"BrtBeginBook", */ T:1, f:parsenoop, p:0 },
	0x0084: { /* n:"BrtEndBook", */ T:-1 },
	0x0085: { /* n:"BrtBeginWsViews", */ T:1 },
	0x0086: { /* n:"BrtEndWsViews", */ T:-1 },
	0x0087: { /* n:"BrtBeginBookViews", */ T:1 },
	0x0088: { /* n:"BrtEndBookViews", */ T:-1 },
	0x0089: { /* n:"BrtBeginWsView", */ T:1, f:parse_BrtBeginWsView },
	0x008A: { /* n:"BrtEndWsView", */ T:-1 },
	0x008B: { /* n:"BrtBeginCsViews", */ T:1 },
	0x008C: { /* n:"BrtEndCsViews", */ T:-1 },
	0x008D: { /* n:"BrtBeginCsView", */ T:1 },
	0x008E: { /* n:"BrtEndCsView", */ T:-1 },
	0x008F: { /* n:"BrtBeginBundleShs", */ T:1 },
	0x0090: { /* n:"BrtEndBundleShs", */ T:-1 },
	0x0091: { /* n:"BrtBeginSheetData", */ T:1 },
	0x0092: { /* n:"BrtEndSheetData", */ T:-1 },
	0x0093: { /* n:"BrtWsProp", */ f:parse_BrtWsProp },
	0x0094: { /* n:"BrtWsDim", */ f:parse_BrtWsDim, p:16 },
	0x0097: { /* n:"BrtPane", */ f:parse_BrtPane },
	0x0098: { /* n:"BrtSel" */ },
	0x0099: { /* n:"BrtWbProp", */ f:parse_BrtWbProp },
	0x009A: { /* n:"BrtWbFactoid" */ },
	0x009B: { /* n:"BrtFileRecover" */ },
	0x009C: { /* n:"BrtBundleSh", */ f:parse_BrtBundleSh },
	0x009D: { /* n:"BrtCalcProp" */ },
	0x009E: { /* n:"BrtBookView" */ },
	0x009F: { /* n:"BrtBeginSst", */ T:1, f:parse_BrtBeginSst },
	0x00A0: { /* n:"BrtEndSst", */ T:-1 },
	0x00A1: { /* n:"BrtBeginAFilter", */ T:1, f:parse_UncheckedRfX },
	0x00A2: { /* n:"BrtEndAFilter", */ T:-1 },
	0x00A3: { /* n:"BrtBeginFilterColumn", */ T:1 },
	0x00A4: { /* n:"BrtEndFilterColumn", */ T:-1 },
	0x00A5: { /* n:"BrtBeginFilters", */ T:1 },
	0x00A6: { /* n:"BrtEndFilters", */ T:-1 },
	0x00A7: { /* n:"BrtFilter" */ },
	0x00A8: { /* n:"BrtColorFilter" */ },
	0x00A9: { /* n:"BrtIconFilter" */ },
	0x00AA: { /* n:"BrtTop10Filter" */ },
	0x00AB: { /* n:"BrtDynamicFilter" */ },
	0x00AC: { /* n:"BrtBeginCustomFilters", */ T:1 },
	0x00AD: { /* n:"BrtEndCustomFilters", */ T:-1 },
	0x00AE: { /* n:"BrtCustomFilter" */ },
	0x00AF: { /* n:"BrtAFilterDateGroupItem" */ },
	0x00B0: { /* n:"BrtMergeCell", */ f:parse_BrtMergeCell },
	0x00B1: { /* n:"BrtBeginMergeCells", */ T:1 },
	0x00B2: { /* n:"BrtEndMergeCells", */ T:-1 },
	0x00B3: { /* n:"BrtBeginPivotCacheDef", */ T:1 },
	0x00B4: { /* n:"BrtEndPivotCacheDef", */ T:-1 },
	0x00B5: { /* n:"BrtBeginPCDFields", */ T:1 },
	0x00B6: { /* n:"BrtEndPCDFields", */ T:-1 },
	0x00B7: { /* n:"BrtBeginPCDField", */ T:1 },
	0x00B8: { /* n:"BrtEndPCDField", */ T:-1 },
	0x00B9: { /* n:"BrtBeginPCDSource", */ T:1 },
	0x00BA: { /* n:"BrtEndPCDSource", */ T:-1 },
	0x00BB: { /* n:"BrtBeginPCDSRange", */ T:1 },
	0x00BC: { /* n:"BrtEndPCDSRange", */ T:-1 },
	0x00BD: { /* n:"BrtBeginPCDFAtbl", */ T:1 },
	0x00BE: { /* n:"BrtEndPCDFAtbl", */ T:-1 },
	0x00BF: { /* n:"BrtBeginPCDIRun", */ T:1 },
	0x00C0: { /* n:"BrtEndPCDIRun", */ T:-1 },
	0x00C1: { /* n:"BrtBeginPivotCacheRecords", */ T:1 },
	0x00C2: { /* n:"BrtEndPivotCacheRecords", */ T:-1 },
	0x00C3: { /* n:"BrtBeginPCDHierarchies", */ T:1 },
	0x00C4: { /* n:"BrtEndPCDHierarchies", */ T:-1 },
	0x00C5: { /* n:"BrtBeginPCDHierarchy", */ T:1 },
	0x00C6: { /* n:"BrtEndPCDHierarchy", */ T:-1 },
	0x00C7: { /* n:"BrtBeginPCDHFieldsUsage", */ T:1 },
	0x00C8: { /* n:"BrtEndPCDHFieldsUsage", */ T:-1 },
	0x00C9: { /* n:"BrtBeginExtConnection", */ T:1 },
	0x00CA: { /* n:"BrtEndExtConnection", */ T:-1 },
	0x00CB: { /* n:"BrtBeginECDbProps", */ T:1 },
	0x00CC: { /* n:"BrtEndECDbProps", */ T:-1 },
	0x00CD: { /* n:"BrtBeginECOlapProps", */ T:1 },
	0x00CE: { /* n:"BrtEndECOlapProps", */ T:-1 },
	0x00CF: { /* n:"BrtBeginPCDSConsol", */ T:1 },
	0x00D0: { /* n:"BrtEndPCDSConsol", */ T:-1 },
	0x00D1: { /* n:"BrtBeginPCDSCPages", */ T:1 },
	0x00D2: { /* n:"BrtEndPCDSCPages", */ T:-1 },
	0x00D3: { /* n:"BrtBeginPCDSCPage", */ T:1 },
	0x00D4: { /* n:"BrtEndPCDSCPage", */ T:-1 },
	0x00D5: { /* n:"BrtBeginPCDSCPItem", */ T:1 },
	0x00D6: { /* n:"BrtEndPCDSCPItem", */ T:-1 },
	0x00D7: { /* n:"BrtBeginPCDSCSets", */ T:1 },
	0x00D8: { /* n:"BrtEndPCDSCSets", */ T:-1 },
	0x00D9: { /* n:"BrtBeginPCDSCSet", */ T:1 },
	0x00DA: { /* n:"BrtEndPCDSCSet", */ T:-1 },
	0x00DB: { /* n:"BrtBeginPCDFGroup", */ T:1 },
	0x00DC: { /* n:"BrtEndPCDFGroup", */ T:-1 },
	0x00DD: { /* n:"BrtBeginPCDFGItems", */ T:1 },
	0x00DE: { /* n:"BrtEndPCDFGItems", */ T:-1 },
	0x00DF: { /* n:"BrtBeginPCDFGRange", */ T:1 },
	0x00E0: { /* n:"BrtEndPCDFGRange", */ T:-1 },
	0x00E1: { /* n:"BrtBeginPCDFGDiscrete", */ T:1 },
	0x00E2: { /* n:"BrtEndPCDFGDiscrete", */ T:-1 },
	0x00E3: { /* n:"BrtBeginPCDSDTupleCache", */ T:1 },
	0x00E4: { /* n:"BrtEndPCDSDTupleCache", */ T:-1 },
	0x00E5: { /* n:"BrtBeginPCDSDTCEntries", */ T:1 },
	0x00E6: { /* n:"BrtEndPCDSDTCEntries", */ T:-1 },
	0x00E7: { /* n:"BrtBeginPCDSDTCEMembers", */ T:1 },
	0x00E8: { /* n:"BrtEndPCDSDTCEMembers", */ T:-1 },
	0x00E9: { /* n:"BrtBeginPCDSDTCEMember", */ T:1 },
	0x00EA: { /* n:"BrtEndPCDSDTCEMember", */ T:-1 },
	0x00EB: { /* n:"BrtBeginPCDSDTCQueries", */ T:1 },
	0x00EC: { /* n:"BrtEndPCDSDTCQueries", */ T:-1 },
	0x00ED: { /* n:"BrtBeginPCDSDTCQuery", */ T:1 },
	0x00EE: { /* n:"BrtEndPCDSDTCQuery", */ T:-1 },
	0x00EF: { /* n:"BrtBeginPCDSDTCSets", */ T:1 },
	0x00F0: { /* n:"BrtEndPCDSDTCSets", */ T:-1 },
	0x00F1: { /* n:"BrtBeginPCDSDTCSet", */ T:1 },
	0x00F2: { /* n:"BrtEndPCDSDTCSet", */ T:-1 },
	0x00F3: { /* n:"BrtBeginPCDCalcItems", */ T:1 },
	0x00F4: { /* n:"BrtEndPCDCalcItems", */ T:-1 },
	0x00F5: { /* n:"BrtBeginPCDCalcItem", */ T:1 },
	0x00F6: { /* n:"BrtEndPCDCalcItem", */ T:-1 },
	0x00F7: { /* n:"BrtBeginPRule", */ T:1 },
	0x00F8: { /* n:"BrtEndPRule", */ T:-1 },
	0x00F9: { /* n:"BrtBeginPRFilters", */ T:1 },
	0x00FA: { /* n:"BrtEndPRFilters", */ T:-1 },
	0x00FB: { /* n:"BrtBeginPRFilter", */ T:1 },
	0x00FC: { /* n:"BrtEndPRFilter", */ T:-1 },
	0x00FD: { /* n:"BrtBeginPNames", */ T:1 },
	0x00FE: { /* n:"BrtEndPNames", */ T:-1 },
	0x00FF: { /* n:"BrtBeginPName", */ T:1 },
	0x0100: { /* n:"BrtEndPName", */ T:-1 },
	0x0101: { /* n:"BrtBeginPNPairs", */ T:1 },
	0x0102: { /* n:"BrtEndPNPairs", */ T:-1 },
	0x0103: { /* n:"BrtBeginPNPair", */ T:1 },
	0x0104: { /* n:"BrtEndPNPair", */ T:-1 },
	0x0105: { /* n:"BrtBeginECWebProps", */ T:1 },
	0x0106: { /* n:"BrtEndECWebProps", */ T:-1 },
	0x0107: { /* n:"BrtBeginEcWpTables", */ T:1 },
	0x0108: { /* n:"BrtEndECWPTables", */ T:-1 },
	0x0109: { /* n:"BrtBeginECParams", */ T:1 },
	0x010A: { /* n:"BrtEndECParams", */ T:-1 },
	0x010B: { /* n:"BrtBeginECParam", */ T:1 },
	0x010C: { /* n:"BrtEndECParam", */ T:-1 },
	0x010D: { /* n:"BrtBeginPCDKPIs", */ T:1 },
	0x010E: { /* n:"BrtEndPCDKPIs", */ T:-1 },
	0x010F: { /* n:"BrtBeginPCDKPI", */ T:1 },
	0x0110: { /* n:"BrtEndPCDKPI", */ T:-1 },
	0x0111: { /* n:"BrtBeginDims", */ T:1 },
	0x0112: { /* n:"BrtEndDims", */ T:-1 },
	0x0113: { /* n:"BrtBeginDim", */ T:1 },
	0x0114: { /* n:"BrtEndDim", */ T:-1 },
	0x0115: { /* n:"BrtIndexPartEnd" */ },
	0x0116: { /* n:"BrtBeginStyleSheet", */ T:1 },
	0x0117: { /* n:"BrtEndStyleSheet", */ T:-1 },
	0x0118: { /* n:"BrtBeginSXView", */ T:1 },
	0x0119: { /* n:"BrtEndSXVI", */ T:-1 },
	0x011A: { /* n:"BrtBeginSXVI", */ T:1 },
	0x011B: { /* n:"BrtBeginSXVIs", */ T:1 },
	0x011C: { /* n:"BrtEndSXVIs", */ T:-1 },
	0x011D: { /* n:"BrtBeginSXVD", */ T:1 },
	0x011E: { /* n:"BrtEndSXVD", */ T:-1 },
	0x011F: { /* n:"BrtBeginSXVDs", */ T:1 },
	0x0120: { /* n:"BrtEndSXVDs", */ T:-1 },
	0x0121: { /* n:"BrtBeginSXPI", */ T:1 },
	0x0122: { /* n:"BrtEndSXPI", */ T:-1 },
	0x0123: { /* n:"BrtBeginSXPIs", */ T:1 },
	0x0124: { /* n:"BrtEndSXPIs", */ T:-1 },
	0x0125: { /* n:"BrtBeginSXDI", */ T:1 },
	0x0126: { /* n:"BrtEndSXDI", */ T:-1 },
	0x0127: { /* n:"BrtBeginSXDIs", */ T:1 },
	0x0128: { /* n:"BrtEndSXDIs", */ T:-1 },
	0x0129: { /* n:"BrtBeginSXLI", */ T:1 },
	0x012A: { /* n:"BrtEndSXLI", */ T:-1 },
	0x012B: { /* n:"BrtBeginSXLIRws", */ T:1 },
	0x012C: { /* n:"BrtEndSXLIRws", */ T:-1 },
	0x012D: { /* n:"BrtBeginSXLICols", */ T:1 },
	0x012E: { /* n:"BrtEndSXLICols", */ T:-1 },
	0x012F: { /* n:"BrtBeginSXFormat", */ T:1 },
	0x0130: { /* n:"BrtEndSXFormat", */ T:-1 },
	0x0131: { /* n:"BrtBeginSXFormats", */ T:1 },
	0x0132: { /* n:"BrtEndSxFormats", */ T:-1 },
	0x0133: { /* n:"BrtBeginSxSelect", */ T:1 },
	0x0134: { /* n:"BrtEndSxSelect", */ T:-1 },
	0x0135: { /* n:"BrtBeginISXVDRws", */ T:1 },
	0x0136: { /* n:"BrtEndISXVDRws", */ T:-1 },
	0x0137: { /* n:"BrtBeginISXVDCols", */ T:1 },
	0x0138: { /* n:"BrtEndISXVDCols", */ T:-1 },
	0x0139: { /* n:"BrtEndSXLocation", */ T:-1 },
	0x013A: { /* n:"BrtBeginSXLocation", */ T:1 },
	0x013B: { /* n:"BrtEndSXView", */ T:-1 },
	0x013C: { /* n:"BrtBeginSXTHs", */ T:1 },
	0x013D: { /* n:"BrtEndSXTHs", */ T:-1 },
	0x013E: { /* n:"BrtBeginSXTH", */ T:1 },
	0x013F: { /* n:"BrtEndSXTH", */ T:-1 },
	0x0140: { /* n:"BrtBeginISXTHRws", */ T:1 },
	0x0141: { /* n:"BrtEndISXTHRws", */ T:-1 },
	0x0142: { /* n:"BrtBeginISXTHCols", */ T:1 },
	0x0143: { /* n:"BrtEndISXTHCols", */ T:-1 },
	0x0144: { /* n:"BrtBeginSXTDMPS", */ T:1 },
	0x0145: { /* n:"BrtEndSXTDMPs", */ T:-1 },
	0x0146: { /* n:"BrtBeginSXTDMP", */ T:1 },
	0x0147: { /* n:"BrtEndSXTDMP", */ T:-1 },
	0x0148: { /* n:"BrtBeginSXTHItems", */ T:1 },
	0x0149: { /* n:"BrtEndSXTHItems", */ T:-1 },
	0x014A: { /* n:"BrtBeginSXTHItem", */ T:1 },
	0x014B: { /* n:"BrtEndSXTHItem", */ T:-1 },
	0x014C: { /* n:"BrtBeginMetadata", */ T:1 },
	0x014D: { /* n:"BrtEndMetadata", */ T:-1 },
	0x014E: { /* n:"BrtBeginEsmdtinfo", */ T:1 },
	0x014F: { /* n:"BrtMdtinfo", */ f:parse_BrtMdtinfo },
	0x0150: { /* n:"BrtEndEsmdtinfo", */ T:-1 },
	0x0151: { /* n:"BrtBeginEsmdb", */ f:parse_BrtBeginEsmdb, T:1 },
	0x0152: { /* n:"BrtEndEsmdb", */ T:-1 },
	0x0153: { /* n:"BrtBeginEsfmd", */ T:1 },
	0x0154: { /* n:"BrtEndEsfmd", */ T:-1 },
	0x0155: { /* n:"BrtBeginSingleCells", */ T:1 },
	0x0156: { /* n:"BrtEndSingleCells", */ T:-1 },
	0x0157: { /* n:"BrtBeginList", */ T:1 },
	0x0158: { /* n:"BrtEndList", */ T:-1 },
	0x0159: { /* n:"BrtBeginListCols", */ T:1 },
	0x015A: { /* n:"BrtEndListCols", */ T:-1 },
	0x015B: { /* n:"BrtBeginListCol", */ T:1 },
	0x015C: { /* n:"BrtEndListCol", */ T:-1 },
	0x015D: { /* n:"BrtBeginListXmlCPr", */ T:1 },
	0x015E: { /* n:"BrtEndListXmlCPr", */ T:-1 },
	0x015F: { /* n:"BrtListCCFmla" */ },
	0x0160: { /* n:"BrtListTrFmla" */ },
	0x0161: { /* n:"BrtBeginExternals", */ T:1 },
	0x0162: { /* n:"BrtEndExternals", */ T:-1 },
	0x0163: { /* n:"BrtSupBookSrc", */ f:parse_RelID},
	0x0165: { /* n:"BrtSupSelf" */ },
	0x0166: { /* n:"BrtSupSame" */ },
	0x0167: { /* n:"BrtSupTabs" */ },
	0x0168: { /* n:"BrtBeginSupBook", */ T:1 },
	0x0169: { /* n:"BrtPlaceholderName" */ },
	0x016A: { /* n:"BrtExternSheet", */ f:parse_ExternSheet },
	0x016B: { /* n:"BrtExternTableStart" */ },
	0x016C: { /* n:"BrtExternTableEnd" */ },
	0x016E: { /* n:"BrtExternRowHdr" */ },
	0x016F: { /* n:"BrtExternCellBlank" */ },
	0x0170: { /* n:"BrtExternCellReal" */ },
	0x0171: { /* n:"BrtExternCellBool" */ },
	0x0172: { /* n:"BrtExternCellError" */ },
	0x0173: { /* n:"BrtExternCellString" */ },
	0x0174: { /* n:"BrtBeginEsmdx", */ T:1 },
	0x0175: { /* n:"BrtEndEsmdx", */ T:-1 },
	0x0176: { /* n:"BrtBeginMdxSet", */ T:1 },
	0x0177: { /* n:"BrtEndMdxSet", */ T:-1 },
	0x0178: { /* n:"BrtBeginMdxMbrProp", */ T:1 },
	0x0179: { /* n:"BrtEndMdxMbrProp", */ T:-1 },
	0x017A: { /* n:"BrtBeginMdxKPI", */ T:1 },
	0x017B: { /* n:"BrtEndMdxKPI", */ T:-1 },
	0x017C: { /* n:"BrtBeginEsstr", */ T:1 },
	0x017D: { /* n:"BrtEndEsstr", */ T:-1 },
	0x017E: { /* n:"BrtBeginPRFItem", */ T:1 },
	0x017F: { /* n:"BrtEndPRFItem", */ T:-1 },
	0x0180: { /* n:"BrtBeginPivotCacheIDs", */ T:1 },
	0x0181: { /* n:"BrtEndPivotCacheIDs", */ T:-1 },
	0x0182: { /* n:"BrtBeginPivotCacheID", */ T:1 },
	0x0183: { /* n:"BrtEndPivotCacheID", */ T:-1 },
	0x0184: { /* n:"BrtBeginISXVIs", */ T:1 },
	0x0185: { /* n:"BrtEndISXVIs", */ T:-1 },
	0x0186: { /* n:"BrtBeginColInfos", */ T:1 },
	0x0187: { /* n:"BrtEndColInfos", */ T:-1 },
	0x0188: { /* n:"BrtBeginRwBrk", */ T:1 },
	0x0189: { /* n:"BrtEndRwBrk", */ T:-1 },
	0x018A: { /* n:"BrtBeginColBrk", */ T:1 },
	0x018B: { /* n:"BrtEndColBrk", */ T:-1 },
	0x018C: { /* n:"BrtBrk" */ },
	0x018D: { /* n:"BrtUserBookView" */ },
	0x018E: { /* n:"BrtInfo" */ },
	0x018F: { /* n:"BrtCUsr" */ },
	0x0190: { /* n:"BrtUsr" */ },
	0x0191: { /* n:"BrtBeginUsers", */ T:1 },
	0x0193: { /* n:"BrtEOF" */ },
	0x0194: { /* n:"BrtUCR" */ },
	0x0195: { /* n:"BrtRRInsDel" */ },
	0x0196: { /* n:"BrtRREndInsDel" */ },
	0x0197: { /* n:"BrtRRMove" */ },
	0x0198: { /* n:"BrtRREndMove" */ },
	0x0199: { /* n:"BrtRRChgCell" */ },
	0x019A: { /* n:"BrtRREndChgCell" */ },
	0x019B: { /* n:"BrtRRHeader" */ },
	0x019C: { /* n:"BrtRRUserView" */ },
	0x019D: { /* n:"BrtRRRenSheet" */ },
	0x019E: { /* n:"BrtRRInsertSh" */ },
	0x019F: { /* n:"BrtRRDefName" */ },
	0x01A0: { /* n:"BrtRRNote" */ },
	0x01A1: { /* n:"BrtRRConflict" */ },
	0x01A2: { /* n:"BrtRRTQSIF" */ },
	0x01A3: { /* n:"BrtRRFormat" */ },
	0x01A4: { /* n:"BrtRREndFormat" */ },
	0x01A5: { /* n:"BrtRRAutoFmt" */ },
	0x01A6: { /* n:"BrtBeginUserShViews", */ T:1 },
	0x01A7: { /* n:"BrtBeginUserShView", */ T:1 },
	0x01A8: { /* n:"BrtEndUserShView", */ T:-1 },
	0x01A9: { /* n:"BrtEndUserShViews", */ T:-1 },
	0x01AA: { /* n:"BrtArrFmla", */ f:parse_BrtArrFmla },
	0x01AB: { /* n:"BrtShrFmla", */ f:parse_BrtShrFmla },
	0x01AC: { /* n:"BrtTable" */ },
	0x01AD: { /* n:"BrtBeginExtConnections", */ T:1 },
	0x01AE: { /* n:"BrtEndExtConnections", */ T:-1 },
	0x01AF: { /* n:"BrtBeginPCDCalcMems", */ T:1 },
	0x01B0: { /* n:"BrtEndPCDCalcMems", */ T:-1 },
	0x01B1: { /* n:"BrtBeginPCDCalcMem", */ T:1 },
	0x01B2: { /* n:"BrtEndPCDCalcMem", */ T:-1 },
	0x01B3: { /* n:"BrtBeginPCDHGLevels", */ T:1 },
	0x01B4: { /* n:"BrtEndPCDHGLevels", */ T:-1 },
	0x01B5: { /* n:"BrtBeginPCDHGLevel", */ T:1 },
	0x01B6: { /* n:"BrtEndPCDHGLevel", */ T:-1 },
	0x01B7: { /* n:"BrtBeginPCDHGLGroups", */ T:1 },
	0x01B8: { /* n:"BrtEndPCDHGLGroups", */ T:-1 },
	0x01B9: { /* n:"BrtBeginPCDHGLGroup", */ T:1 },
	0x01BA: { /* n:"BrtEndPCDHGLGroup", */ T:-1 },
	0x01BB: { /* n:"BrtBeginPCDHGLGMembers", */ T:1 },
	0x01BC: { /* n:"BrtEndPCDHGLGMembers", */ T:-1 },
	0x01BD: { /* n:"BrtBeginPCDHGLGMember", */ T:1 },
	0x01BE: { /* n:"BrtEndPCDHGLGMember", */ T:-1 },
	0x01BF: { /* n:"BrtBeginQSI", */ T:1 },
	0x01C0: { /* n:"BrtEndQSI", */ T:-1 },
	0x01C1: { /* n:"BrtBeginQSIR", */ T:1 },
	0x01C2: { /* n:"BrtEndQSIR", */ T:-1 },
	0x01C3: { /* n:"BrtBeginDeletedNames", */ T:1 },
	0x01C4: { /* n:"BrtEndDeletedNames", */ T:-1 },
	0x01C5: { /* n:"BrtBeginDeletedName", */ T:1 },
	0x01C6: { /* n:"BrtEndDeletedName", */ T:-1 },
	0x01C7: { /* n:"BrtBeginQSIFs", */ T:1 },
	0x01C8: { /* n:"BrtEndQSIFs", */ T:-1 },
	0x01C9: { /* n:"BrtBeginQSIF", */ T:1 },
	0x01CA: { /* n:"BrtEndQSIF", */ T:-1 },
	0x01CB: { /* n:"BrtBeginAutoSortScope", */ T:1 },
	0x01CC: { /* n:"BrtEndAutoSortScope", */ T:-1 },
	0x01CD: { /* n:"BrtBeginConditionalFormatting", */ T:1 },
	0x01CE: { /* n:"BrtEndConditionalFormatting", */ T:-1 },
	0x01CF: { /* n:"BrtBeginCFRule", */ T:1 },
	0x01D0: { /* n:"BrtEndCFRule", */ T:-1 },
	0x01D1: { /* n:"BrtBeginIconSet", */ T:1 },
	0x01D2: { /* n:"BrtEndIconSet", */ T:-1 },
	0x01D3: { /* n:"BrtBeginDatabar", */ T:1 },
	0x01D4: { /* n:"BrtEndDatabar", */ T:-1 },
	0x01D5: { /* n:"BrtBeginColorScale", */ T:1 },
	0x01D6: { /* n:"BrtEndColorScale", */ T:-1 },
	0x01D7: { /* n:"BrtCFVO" */ },
	0x01D8: { /* n:"BrtExternValueMeta" */ },
	0x01D9: { /* n:"BrtBeginColorPalette", */ T:1 },
	0x01DA: { /* n:"BrtEndColorPalette", */ T:-1 },
	0x01DB: { /* n:"BrtIndexedColor" */ },
	0x01DC: { /* n:"BrtMargins", */ f:parse_BrtMargins },
	0x01DD: { /* n:"BrtPrintOptions" */ },
	0x01DE: { /* n:"BrtPageSetup" */ },
	0x01DF: { /* n:"BrtBeginHeaderFooter", */ T:1 },
	0x01E0: { /* n:"BrtEndHeaderFooter", */ T:-1 },
	0x01E1: { /* n:"BrtBeginSXCrtFormat", */ T:1 },
	0x01E2: { /* n:"BrtEndSXCrtFormat", */ T:-1 },
	0x01E3: { /* n:"BrtBeginSXCrtFormats", */ T:1 },
	0x01E4: { /* n:"BrtEndSXCrtFormats", */ T:-1 },
	0x01E5: { /* n:"BrtWsFmtInfo", */ f:parse_BrtWsFmtInfo },
	0x01E6: { /* n:"BrtBeginMgs", */ T:1 },
	0x01E7: { /* n:"BrtEndMGs", */ T:-1 },
	0x01E8: { /* n:"BrtBeginMGMaps", */ T:1 },
	0x01E9: { /* n:"BrtEndMGMaps", */ T:-1 },
	0x01EA: { /* n:"BrtBeginMG", */ T:1 },
	0x01EB: { /* n:"BrtEndMG", */ T:-1 },
	0x01EC: { /* n:"BrtBeginMap", */ T:1 },
	0x01ED: { /* n:"BrtEndMap", */ T:-1 },
	0x01EE: { /* n:"BrtHLink", */ f:parse_BrtHLink },
	0x01EF: { /* n:"BrtBeginDCon", */ T:1 },
	0x01F0: { /* n:"BrtEndDCon", */ T:-1 },
	0x01F1: { /* n:"BrtBeginDRefs", */ T:1 },
	0x01F2: { /* n:"BrtEndDRefs", */ T:-1 },
	0x01F3: { /* n:"BrtDRef" */ },
	0x01F4: { /* n:"BrtBeginScenMan", */ T:1 },
	0x01F5: { /* n:"BrtEndScenMan", */ T:-1 },
	0x01F6: { /* n:"BrtBeginSct", */ T:1 },
	0x01F7: { /* n:"BrtEndSct", */ T:-1 },
	0x01F8: { /* n:"BrtSlc" */ },
	0x01F9: { /* n:"BrtBeginDXFs", */ T:1 },
	0x01FA: { /* n:"BrtEndDXFs", */ T:-1 },
	0x01FB: { /* n:"BrtDXF" */ },
	0x01FC: { /* n:"BrtBeginTableStyles", */ T:1 },
	0x01FD: { /* n:"BrtEndTableStyles", */ T:-1 },
	0x01FE: { /* n:"BrtBeginTableStyle", */ T:1 },
	0x01FF: { /* n:"BrtEndTableStyle", */ T:-1 },
	0x0200: { /* n:"BrtTableStyleElement" */ },
	0x0201: { /* n:"BrtTableStyleClient" */ },
	0x0202: { /* n:"BrtBeginVolDeps", */ T:1 },
	0x0203: { /* n:"BrtEndVolDeps", */ T:-1 },
	0x0204: { /* n:"BrtBeginVolType", */ T:1 },
	0x0205: { /* n:"BrtEndVolType", */ T:-1 },
	0x0206: { /* n:"BrtBeginVolMain", */ T:1 },
	0x0207: { /* n:"BrtEndVolMain", */ T:-1 },
	0x0208: { /* n:"BrtBeginVolTopic", */ T:1 },
	0x0209: { /* n:"BrtEndVolTopic", */ T:-1 },
	0x020A: { /* n:"BrtVolSubtopic" */ },
	0x020B: { /* n:"BrtVolRef" */ },
	0x020C: { /* n:"BrtVolNum" */ },
	0x020D: { /* n:"BrtVolErr" */ },
	0x020E: { /* n:"BrtVolStr" */ },
	0x020F: { /* n:"BrtVolBool" */ },
	0x0210: { /* n:"BrtBeginCalcChain$", */ T:1 },
	0x0211: { /* n:"BrtEndCalcChain$", */ T:-1 },
	0x0212: { /* n:"BrtBeginSortState", */ T:1 },
	0x0213: { /* n:"BrtEndSortState", */ T:-1 },
	0x0214: { /* n:"BrtBeginSortCond", */ T:1 },
	0x0215: { /* n:"BrtEndSortCond", */ T:-1 },
	0x0216: { /* n:"BrtBookProtection" */ },
	0x0217: { /* n:"BrtSheetProtection" */ },
	0x0218: { /* n:"BrtRangeProtection" */ },
	0x0219: { /* n:"BrtPhoneticInfo" */ },
	0x021A: { /* n:"BrtBeginECTxtWiz", */ T:1 },
	0x021B: { /* n:"BrtEndECTxtWiz", */ T:-1 },
	0x021C: { /* n:"BrtBeginECTWFldInfoLst", */ T:1 },
	0x021D: { /* n:"BrtEndECTWFldInfoLst", */ T:-1 },
	0x021E: { /* n:"BrtBeginECTwFldInfo", */ T:1 },
	0x0224: { /* n:"BrtFileSharing" */ },
	0x0225: { /* n:"BrtOleSize" */ },
	0x0226: { /* n:"BrtDrawing", */ f:parse_RelID },
	0x0227: { /* n:"BrtLegacyDrawing" */ },
	0x0228: { /* n:"BrtLegacyDrawingHF" */ },
	0x0229: { /* n:"BrtWebOpt" */ },
	0x022A: { /* n:"BrtBeginWebPubItems", */ T:1 },
	0x022B: { /* n:"BrtEndWebPubItems", */ T:-1 },
	0x022C: { /* n:"BrtBeginWebPubItem", */ T:1 },
	0x022D: { /* n:"BrtEndWebPubItem", */ T:-1 },
	0x022E: { /* n:"BrtBeginSXCondFmt", */ T:1 },
	0x022F: { /* n:"BrtEndSXCondFmt", */ T:-1 },
	0x0230: { /* n:"BrtBeginSXCondFmts", */ T:1 },
	0x0231: { /* n:"BrtEndSXCondFmts", */ T:-1 },
	0x0232: { /* n:"BrtBkHim" */ },
	0x0234: { /* n:"BrtColor" */ },
	0x0235: { /* n:"BrtBeginIndexedColors", */ T:1 },
	0x0236: { /* n:"BrtEndIndexedColors", */ T:-1 },
	0x0239: { /* n:"BrtBeginMRUColors", */ T:1 },
	0x023A: { /* n:"BrtEndMRUColors", */ T:-1 },
	0x023C: { /* n:"BrtMRUColor" */ },
	0x023D: { /* n:"BrtBeginDVals", */ T:1 },
	0x023E: { /* n:"BrtEndDVals", */ T:-1 },
	0x0241: { /* n:"BrtSupNameStart" */ },
	0x0242: { /* n:"BrtSupNameValueStart" */ },
	0x0243: { /* n:"BrtSupNameValueEnd" */ },
	0x0244: { /* n:"BrtSupNameNum" */ },
	0x0245: { /* n:"BrtSupNameErr" */ },
	0x0246: { /* n:"BrtSupNameSt" */ },
	0x0247: { /* n:"BrtSupNameNil" */ },
	0x0248: { /* n:"BrtSupNameBool" */ },
	0x0249: { /* n:"BrtSupNameFmla" */ },
	0x024A: { /* n:"BrtSupNameBits" */ },
	0x024B: { /* n:"BrtSupNameEnd" */ },
	0x024C: { /* n:"BrtEndSupBook", */ T:-1 },
	0x024D: { /* n:"BrtCellSmartTagProperty" */ },
	0x024E: { /* n:"BrtBeginCellSmartTag", */ T:1 },
	0x024F: { /* n:"BrtEndCellSmartTag", */ T:-1 },
	0x0250: { /* n:"BrtBeginCellSmartTags", */ T:1 },
	0x0251: { /* n:"BrtEndCellSmartTags", */ T:-1 },
	0x0252: { /* n:"BrtBeginSmartTags", */ T:1 },
	0x0253: { /* n:"BrtEndSmartTags", */ T:-1 },
	0x0254: { /* n:"BrtSmartTagType" */ },
	0x0255: { /* n:"BrtBeginSmartTagTypes", */ T:1 },
	0x0256: { /* n:"BrtEndSmartTagTypes", */ T:-1 },
	0x0257: { /* n:"BrtBeginSXFilters", */ T:1 },
	0x0258: { /* n:"BrtEndSXFilters", */ T:-1 },
	0x0259: { /* n:"BrtBeginSXFILTER", */ T:1 },
	0x025A: { /* n:"BrtEndSXFilter", */ T:-1 },
	0x025B: { /* n:"BrtBeginFills", */ T:1 },
	0x025C: { /* n:"BrtEndFills", */ T:-1 },
	0x025D: { /* n:"BrtBeginCellWatches", */ T:1 },
	0x025E: { /* n:"BrtEndCellWatches", */ T:-1 },
	0x025F: { /* n:"BrtCellWatch" */ },
	0x0260: { /* n:"BrtBeginCRErrs", */ T:1 },
	0x0261: { /* n:"BrtEndCRErrs", */ T:-1 },
	0x0262: { /* n:"BrtCrashRecErr" */ },
	0x0263: { /* n:"BrtBeginFonts", */ T:1 },
	0x0264: { /* n:"BrtEndFonts", */ T:-1 },
	0x0265: { /* n:"BrtBeginBorders", */ T:1 },
	0x0266: { /* n:"BrtEndBorders", */ T:-1 },
	0x0267: { /* n:"BrtBeginFmts", */ T:1 },
	0x0268: { /* n:"BrtEndFmts", */ T:-1 },
	0x0269: { /* n:"BrtBeginCellXFs", */ T:1 },
	0x026A: { /* n:"BrtEndCellXFs", */ T:-1 },
	0x026B: { /* n:"BrtBeginStyles", */ T:1 },
	0x026C: { /* n:"BrtEndStyles", */ T:-1 },
	0x0271: { /* n:"BrtBigName" */ },
	0x0272: { /* n:"BrtBeginCellStyleXFs", */ T:1 },
	0x0273: { /* n:"BrtEndCellStyleXFs", */ T:-1 },
	0x0274: { /* n:"BrtBeginComments", */ T:1 },
	0x0275: { /* n:"BrtEndComments", */ T:-1 },
	0x0276: { /* n:"BrtBeginCommentAuthors", */ T:1 },
	0x0277: { /* n:"BrtEndCommentAuthors", */ T:-1 },
	0x0278: { /* n:"BrtCommentAuthor", */ f:parse_BrtCommentAuthor },
	0x0279: { /* n:"BrtBeginCommentList", */ T:1 },
	0x027A: { /* n:"BrtEndCommentList", */ T:-1 },
	0x027B: { /* n:"BrtBeginComment", */ T:1, f:parse_BrtBeginComment},
	0x027C: { /* n:"BrtEndComment", */ T:-1 },
	0x027D: { /* n:"BrtCommentText", */ f:parse_BrtCommentText },
	0x027E: { /* n:"BrtBeginOleObjects", */ T:1 },
	0x027F: { /* n:"BrtOleObject" */ },
	0x0280: { /* n:"BrtEndOleObjects", */ T:-1 },
	0x0281: { /* n:"BrtBeginSxrules", */ T:1 },
	0x0282: { /* n:"BrtEndSxRules", */ T:-1 },
	0x0283: { /* n:"BrtBeginActiveXControls", */ T:1 },
	0x0284: { /* n:"BrtActiveX" */ },
	0x0285: { /* n:"BrtEndActiveXControls", */ T:-1 },
	0x0286: { /* n:"BrtBeginPCDSDTCEMembersSortBy", */ T:1 },
	0x0288: { /* n:"BrtBeginCellIgnoreECs", */ T:1 },
	0x0289: { /* n:"BrtCellIgnoreEC" */ },
	0x028A: { /* n:"BrtEndCellIgnoreECs", */ T:-1 },
	0x028B: { /* n:"BrtCsProp", */ f:parse_BrtCsProp },
	0x028C: { /* n:"BrtCsPageSetup" */ },
	0x028D: { /* n:"BrtBeginUserCsViews", */ T:1 },
	0x028E: { /* n:"BrtEndUserCsViews", */ T:-1 },
	0x028F: { /* n:"BrtBeginUserCsView", */ T:1 },
	0x0290: { /* n:"BrtEndUserCsView", */ T:-1 },
	0x0291: { /* n:"BrtBeginPcdSFCIEntries", */ T:1 },
	0x0292: { /* n:"BrtEndPCDSFCIEntries", */ T:-1 },
	0x0293: { /* n:"BrtPCDSFCIEntry" */ },
	0x0294: { /* n:"BrtBeginListParts", */ T:1 },
	0x0295: { /* n:"BrtListPart" */ },
	0x0296: { /* n:"BrtEndListParts", */ T:-1 },
	0x0297: { /* n:"BrtSheetCalcProp" */ },
	0x0298: { /* n:"BrtBeginFnGroup", */ T:1 },
	0x0299: { /* n:"BrtFnGroup" */ },
	0x029A: { /* n:"BrtEndFnGroup", */ T:-1 },
	0x029B: { /* n:"BrtSupAddin" */ },
	0x029C: { /* n:"BrtSXTDMPOrder" */ },
	0x029D: { /* n:"BrtCsProtection" */ },
	0x029F: { /* n:"BrtBeginWsSortMap", */ T:1 },
	0x02A0: { /* n:"BrtEndWsSortMap", */ T:-1 },
	0x02A1: { /* n:"BrtBeginRRSort", */ T:1 },
	0x02A2: { /* n:"BrtEndRRSort", */ T:-1 },
	0x02A3: { /* n:"BrtRRSortItem" */ },
	0x02A4: { /* n:"BrtFileSharingIso" */ },
	0x02A5: { /* n:"BrtBookProtectionIso" */ },
	0x02A6: { /* n:"BrtSheetProtectionIso" */ },
	0x02A7: { /* n:"BrtCsProtectionIso" */ },
	0x02A8: { /* n:"BrtRangeProtectionIso" */ },
	0x02A9: { /* n:"BrtDValList" */ },
	0x0400: { /* n:"BrtRwDescent" */ },
	0x0401: { /* n:"BrtKnownFonts" */ },
	0x0402: { /* n:"BrtBeginSXTupleSet", */ T:1 },
	0x0403: { /* n:"BrtEndSXTupleSet", */ T:-1 },
	0x0404: { /* n:"BrtBeginSXTupleSetHeader", */ T:1 },
	0x0405: { /* n:"BrtEndSXTupleSetHeader", */ T:-1 },
	0x0406: { /* n:"BrtSXTupleSetHeaderItem" */ },
	0x0407: { /* n:"BrtBeginSXTupleSetData", */ T:1 },
	0x0408: { /* n:"BrtEndSXTupleSetData", */ T:-1 },
	0x0409: { /* n:"BrtBeginSXTupleSetRow", */ T:1 },
	0x040A: { /* n:"BrtEndSXTupleSetRow", */ T:-1 },
	0x040B: { /* n:"BrtSXTupleSetRowItem" */ },
	0x040C: { /* n:"BrtNameExt" */ },
	0x040D: { /* n:"BrtPCDH14" */ },
	0x040E: { /* n:"BrtBeginPCDCalcMem14", */ T:1 },
	0x040F: { /* n:"BrtEndPCDCalcMem14", */ T:-1 },
	0x0410: { /* n:"BrtSXTH14" */ },
	0x0411: { /* n:"BrtBeginSparklineGroup", */ T:1 },
	0x0412: { /* n:"BrtEndSparklineGroup", */ T:-1 },
	0x0413: { /* n:"BrtSparkline" */ },
	0x0414: { /* n:"BrtSXDI14" */ },
	0x0415: { /* n:"BrtWsFmtInfoEx14" */ },
	0x0416: { /* n:"BrtBeginConditionalFormatting14", */ T:1 },
	0x0417: { /* n:"BrtEndConditionalFormatting14", */ T:-1 },
	0x0418: { /* n:"BrtBeginCFRule14", */ T:1 },
	0x0419: { /* n:"BrtEndCFRule14", */ T:-1 },
	0x041A: { /* n:"BrtCFVO14" */ },
	0x041B: { /* n:"BrtBeginDatabar14", */ T:1 },
	0x041C: { /* n:"BrtBeginIconSet14", */ T:1 },
	0x041D: { /* n:"BrtDVal14", */ f: parse_BrtDVal14 },
	0x041E: { /* n:"BrtBeginDVals14", */ T:1 },
	0x041F: { /* n:"BrtColor14" */ },
	0x0420: { /* n:"BrtBeginSparklines", */ T:1 },
	0x0421: { /* n:"BrtEndSparklines", */ T:-1 },
	0x0422: { /* n:"BrtBeginSparklineGroups", */ T:1 },
	0x0423: { /* n:"BrtEndSparklineGroups", */ T:-1 },
	0x0425: { /* n:"BrtSXVD14" */ },
	0x0426: { /* n:"BrtBeginSXView14", */ T:1 },
	0x0427: { /* n:"BrtEndSXView14", */ T:-1 },
	0x0428: { /* n:"BrtBeginSXView16", */ T:1 },
	0x0429: { /* n:"BrtEndSXView16", */ T:-1 },
	0x042A: { /* n:"BrtBeginPCD14", */ T:1 },
	0x042B: { /* n:"BrtEndPCD14", */ T:-1 },
	0x042C: { /* n:"BrtBeginExtConn14", */ T:1 },
	0x042D: { /* n:"BrtEndExtConn14", */ T:-1 },
	0x042E: { /* n:"BrtBeginSlicerCacheIDs", */ T:1 },
	0x042F: { /* n:"BrtEndSlicerCacheIDs", */ T:-1 },
	0x0430: { /* n:"BrtBeginSlicerCacheID", */ T:1 },
	0x0431: { /* n:"BrtEndSlicerCacheID", */ T:-1 },
	0x0433: { /* n:"BrtBeginSlicerCache", */ T:1 },
	0x0434: { /* n:"BrtEndSlicerCache", */ T:-1 },
	0x0435: { /* n:"BrtBeginSlicerCacheDef", */ T:1 },
	0x0436: { /* n:"BrtEndSlicerCacheDef", */ T:-1 },
	0x0437: { /* n:"BrtBeginSlicersEx", */ T:1 },
	0x0438: { /* n:"BrtEndSlicersEx", */ T:-1 },
	0x0439: { /* n:"BrtBeginSlicerEx", */ T:1 },
	0x043A: { /* n:"BrtEndSlicerEx", */ T:-1 },
	0x043B: { /* n:"BrtBeginSlicer", */ T:1 },
	0x043C: { /* n:"BrtEndSlicer", */ T:-1 },
	0x043D: { /* n:"BrtSlicerCachePivotTables" */ },
	0x043E: { /* n:"BrtBeginSlicerCacheOlapImpl", */ T:1 },
	0x043F: { /* n:"BrtEndSlicerCacheOlapImpl", */ T:-1 },
	0x0440: { /* n:"BrtBeginSlicerCacheLevelsData", */ T:1 },
	0x0441: { /* n:"BrtEndSlicerCacheLevelsData", */ T:-1 },
	0x0442: { /* n:"BrtBeginSlicerCacheLevelData", */ T:1 },
	0x0443: { /* n:"BrtEndSlicerCacheLevelData", */ T:-1 },
	0x0444: { /* n:"BrtBeginSlicerCacheSiRanges", */ T:1 },
	0x0445: { /* n:"BrtEndSlicerCacheSiRanges", */ T:-1 },
	0x0446: { /* n:"BrtBeginSlicerCacheSiRange", */ T:1 },
	0x0447: { /* n:"BrtEndSlicerCacheSiRange", */ T:-1 },
	0x0448: { /* n:"BrtSlicerCacheOlapItem" */ },
	0x0449: { /* n:"BrtBeginSlicerCacheSelections", */ T:1 },
	0x044A: { /* n:"BrtSlicerCacheSelection" */ },
	0x044B: { /* n:"BrtEndSlicerCacheSelections", */ T:-1 },
	0x044C: { /* n:"BrtBeginSlicerCacheNative", */ T:1 },
	0x044D: { /* n:"BrtEndSlicerCacheNative", */ T:-1 },
	0x044E: { /* n:"BrtSlicerCacheNativeItem" */ },
	0x044F: { /* n:"BrtRangeProtection14" */ },
	0x0450: { /* n:"BrtRangeProtectionIso14" */ },
	0x0451: { /* n:"BrtCellIgnoreEC14" */ },
	0x0457: { /* n:"BrtList14" */ },
	0x0458: { /* n:"BrtCFIcon" */ },
	0x0459: { /* n:"BrtBeginSlicerCachesPivotCacheIDs", */ T:1 },
	0x045A: { /* n:"BrtEndSlicerCachesPivotCacheIDs", */ T:-1 },
	0x045B: { /* n:"BrtBeginSlicers", */ T:1 },
	0x045C: { /* n:"BrtEndSlicers", */ T:-1 },
	0x045D: { /* n:"BrtWbProp14" */ },
	0x045E: { /* n:"BrtBeginSXEdit", */ T:1 },
	0x045F: { /* n:"BrtEndSXEdit", */ T:-1 },
	0x0460: { /* n:"BrtBeginSXEdits", */ T:1 },
	0x0461: { /* n:"BrtEndSXEdits", */ T:-1 },
	0x0462: { /* n:"BrtBeginSXChange", */ T:1 },
	0x0463: { /* n:"BrtEndSXChange", */ T:-1 },
	0x0464: { /* n:"BrtBeginSXChanges", */ T:1 },
	0x0465: { /* n:"BrtEndSXChanges", */ T:-1 },
	0x0466: { /* n:"BrtSXTupleItems" */ },
	0x0468: { /* n:"BrtBeginSlicerStyle", */ T:1 },
	0x0469: { /* n:"BrtEndSlicerStyle", */ T:-1 },
	0x046A: { /* n:"BrtSlicerStyleElement" */ },
	0x046B: { /* n:"BrtBeginStyleSheetExt14", */ T:1 },
	0x046C: { /* n:"BrtEndStyleSheetExt14", */ T:-1 },
	0x046D: { /* n:"BrtBeginSlicerCachesPivotCacheID", */ T:1 },
	0x046E: { /* n:"BrtEndSlicerCachesPivotCacheID", */ T:-1 },
	0x046F: { /* n:"BrtBeginConditionalFormattings", */ T:1 },
	0x0470: { /* n:"BrtEndConditionalFormattings", */ T:-1 },
	0x0471: { /* n:"BrtBeginPCDCalcMemExt", */ T:1 },
	0x0472: { /* n:"BrtEndPCDCalcMemExt", */ T:-1 },
	0x0473: { /* n:"BrtBeginPCDCalcMemsExt", */ T:1 },
	0x0474: { /* n:"BrtEndPCDCalcMemsExt", */ T:-1 },
	0x0475: { /* n:"BrtPCDField14" */ },
	0x0476: { /* n:"BrtBeginSlicerStyles", */ T:1 },
	0x0477: { /* n:"BrtEndSlicerStyles", */ T:-1 },
	0x0478: { /* n:"BrtBeginSlicerStyleElements", */ T:1 },
	0x0479: { /* n:"BrtEndSlicerStyleElements", */ T:-1 },
	0x047A: { /* n:"BrtCFRuleExt" */ },
	0x047B: { /* n:"BrtBeginSXCondFmt14", */ T:1 },
	0x047C: { /* n:"BrtEndSXCondFmt14", */ T:-1 },
	0x047D: { /* n:"BrtBeginSXCondFmts14", */ T:1 },
	0x047E: { /* n:"BrtEndSXCondFmts14", */ T:-1 },
	0x0480: { /* n:"BrtBeginSortCond14", */ T:1 },
	0x0481: { /* n:"BrtEndSortCond14", */ T:-1 },
	0x0482: { /* n:"BrtEndDVals14", */ T:-1 },
	0x0483: { /* n:"BrtEndIconSet14", */ T:-1 },
	0x0484: { /* n:"BrtEndDatabar14", */ T:-1 },
	0x0485: { /* n:"BrtBeginColorScale14", */ T:1 },
	0x0486: { /* n:"BrtEndColorScale14", */ T:-1 },
	0x0487: { /* n:"BrtBeginSxrules14", */ T:1 },
	0x0488: { /* n:"BrtEndSxrules14", */ T:-1 },
	0x0489: { /* n:"BrtBeginPRule14", */ T:1 },
	0x048A: { /* n:"BrtEndPRule14", */ T:-1 },
	0x048B: { /* n:"BrtBeginPRFilters14", */ T:1 },
	0x048C: { /* n:"BrtEndPRFilters14", */ T:-1 },
	0x048D: { /* n:"BrtBeginPRFilter14", */ T:1 },
	0x048E: { /* n:"BrtEndPRFilter14", */ T:-1 },
	0x048F: { /* n:"BrtBeginPRFItem14", */ T:1 },
	0x0490: { /* n:"BrtEndPRFItem14", */ T:-1 },
	0x0491: { /* n:"BrtBeginCellIgnoreECs14", */ T:1 },
	0x0492: { /* n:"BrtEndCellIgnoreECs14", */ T:-1 },
	0x0493: { /* n:"BrtDxf14" */ },
	0x0494: { /* n:"BrtBeginDxF14s", */ T:1 },
	0x0495: { /* n:"BrtEndDxf14s", */ T:-1 },
	0x0499: { /* n:"BrtFilter14" */ },
	0x049A: { /* n:"BrtBeginCustomFilters14", */ T:1 },
	0x049C: { /* n:"BrtCustomFilter14" */ },
	0x049D: { /* n:"BrtIconFilter14" */ },
	0x049E: { /* n:"BrtPivotCacheConnectionName" */ },
	0x0800: { /* n:"BrtBeginDecoupledPivotCacheIDs", */ T:1 },
	0x0801: { /* n:"BrtEndDecoupledPivotCacheIDs", */ T:-1 },
	0x0802: { /* n:"BrtDecoupledPivotCacheID" */ },
	0x0803: { /* n:"BrtBeginPivotTableRefs", */ T:1 },
	0x0804: { /* n:"BrtEndPivotTableRefs", */ T:-1 },
	0x0805: { /* n:"BrtPivotTableRef" */ },
	0x0806: { /* n:"BrtSlicerCacheBookPivotTables" */ },
	0x0807: { /* n:"BrtBeginSxvcells", */ T:1 },
	0x0808: { /* n:"BrtEndSxvcells", */ T:-1 },
	0x0809: { /* n:"BrtBeginSxRow", */ T:1 },
	0x080A: { /* n:"BrtEndSxRow", */ T:-1 },
	0x080C: { /* n:"BrtPcdCalcMem15" */ },
	0x0813: { /* n:"BrtQsi15" */ },
	0x0814: { /* n:"BrtBeginWebExtensions", */ T:1 },
	0x0815: { /* n:"BrtEndWebExtensions", */ T:-1 },
	0x0816: { /* n:"BrtWebExtension" */ },
	0x0817: { /* n:"BrtAbsPath15" */ },
	0x0818: { /* n:"BrtBeginPivotTableUISettings", */ T:1 },
	0x0819: { /* n:"BrtEndPivotTableUISettings", */ T:-1 },
	0x081B: { /* n:"BrtTableSlicerCacheIDs" */ },
	0x081C: { /* n:"BrtTableSlicerCacheID" */ },
	0x081D: { /* n:"BrtBeginTableSlicerCache", */ T:1 },
	0x081E: { /* n:"BrtEndTableSlicerCache", */ T:-1 },
	0x081F: { /* n:"BrtSxFilter15" */ },
	0x0820: { /* n:"BrtBeginTimelineCachePivotCacheIDs", */ T:1 },
	0x0821: { /* n:"BrtEndTimelineCachePivotCacheIDs", */ T:-1 },
	0x0822: { /* n:"BrtTimelineCachePivotCacheID" */ },
	0x0823: { /* n:"BrtBeginTimelineCacheIDs", */ T:1 },
	0x0824: { /* n:"BrtEndTimelineCacheIDs", */ T:-1 },
	0x0825: { /* n:"BrtBeginTimelineCacheID", */ T:1 },
	0x0826: { /* n:"BrtEndTimelineCacheID", */ T:-1 },
	0x0827: { /* n:"BrtBeginTimelinesEx", */ T:1 },
	0x0828: { /* n:"BrtEndTimelinesEx", */ T:-1 },
	0x0829: { /* n:"BrtBeginTimelineEx", */ T:1 },
	0x082A: { /* n:"BrtEndTimelineEx", */ T:-1 },
	0x082B: { /* n:"BrtWorkBookPr15" */ },
	0x082C: { /* n:"BrtPCDH15" */ },
	0x082D: { /* n:"BrtBeginTimelineStyle", */ T:1 },
	0x082E: { /* n:"BrtEndTimelineStyle", */ T:-1 },
	0x082F: { /* n:"BrtTimelineStyleElement" */ },
	0x0830: { /* n:"BrtBeginTimelineStylesheetExt15", */ T:1 },
	0x0831: { /* n:"BrtEndTimelineStylesheetExt15", */ T:-1 },
	0x0832: { /* n:"BrtBeginTimelineStyles", */ T:1 },
	0x0833: { /* n:"BrtEndTimelineStyles", */ T:-1 },
	0x0834: { /* n:"BrtBeginTimelineStyleElements", */ T:1 },
	0x0835: { /* n:"BrtEndTimelineStyleElements", */ T:-1 },
	0x0836: { /* n:"BrtDxf15" */ },
	0x0837: { /* n:"BrtBeginDxfs15", */ T:1 },
	0x0838: { /* n:"BrtEndDxfs15", */ T:-1 },
	0x0839: { /* n:"BrtSlicerCacheHideItemsWithNoData" */ },
	0x083A: { /* n:"BrtBeginItemUniqueNames", */ T:1 },
	0x083B: { /* n:"BrtEndItemUniqueNames", */ T:-1 },
	0x083C: { /* n:"BrtItemUniqueName" */ },
	0x083D: { /* n:"BrtBeginExtConn15", */ T:1 },
	0x083E: { /* n:"BrtEndExtConn15", */ T:-1 },
	0x083F: { /* n:"BrtBeginOledbPr15", */ T:1 },
	0x0840: { /* n:"BrtEndOledbPr15", */ T:-1 },
	0x0841: { /* n:"BrtBeginDataFeedPr15", */ T:1 },
	0x0842: { /* n:"BrtEndDataFeedPr15", */ T:-1 },
	0x0843: { /* n:"BrtTextPr15" */ },
	0x0844: { /* n:"BrtRangePr15" */ },
	0x0845: { /* n:"BrtDbCommand15" */ },
	0x0846: { /* n:"BrtBeginDbTables15", */ T:1 },
	0x0847: { /* n:"BrtEndDbTables15", */ T:-1 },
	0x0848: { /* n:"BrtDbTable15" */ },
	0x0849: { /* n:"BrtBeginDataModel", */ T:1 },
	0x084A: { /* n:"BrtEndDataModel", */ T:-1 },
	0x084B: { /* n:"BrtBeginModelTables", */ T:1 },
	0x084C: { /* n:"BrtEndModelTables", */ T:-1 },
	0x084D: { /* n:"BrtModelTable" */ },
	0x084E: { /* n:"BrtBeginModelRelationships", */ T:1 },
	0x084F: { /* n:"BrtEndModelRelationships", */ T:-1 },
	0x0850: { /* n:"BrtModelRelationship" */ },
	0x0851: { /* n:"BrtBeginECTxtWiz15", */ T:1 },
	0x0852: { /* n:"BrtEndECTxtWiz15", */ T:-1 },
	0x0853: { /* n:"BrtBeginECTWFldInfoLst15", */ T:1 },
	0x0854: { /* n:"BrtEndECTWFldInfoLst15", */ T:-1 },
	0x0855: { /* n:"BrtBeginECTWFldInfo15", */ T:1 },
	0x0856: { /* n:"BrtFieldListActiveItem" */ },
	0x0857: { /* n:"BrtPivotCacheIdVersion" */ },
	0x0858: { /* n:"BrtSXDI15" */ },
	0x0859: { /* n:"BrtBeginModelTimeGroupings", */ T:1 },
	0x085A: { /* n:"BrtEndModelTimeGroupings", */ T:-1 },
	0x085B: { /* n:"BrtBeginModelTimeGrouping", */ T:1 },
	0x085C: { /* n:"BrtEndModelTimeGrouping", */ T:-1 },
	0x085D: { /* n:"BrtModelTimeGroupingCalcCol" */ },
	0x0C00: { /* n:"BrtUid" */ },
	0x0C01: { /* n:"BrtRevisionPtr" */ },
	0x1000: { /* n:"BrtBeginDynamicArrayPr", */ T:1 },
	0x1001: { /* n:"BrtEndDynamicArrayPr", */ T:-1 },
	0x138A: { /* n:"BrtBeginRichValueBlock", */ T:1 },
	0x138B: { /* n:"BrtEndRichValueBlock", */ T:-1 },
	0x13D9: { /* n:"BrtBeginRichFilters", */ T:1 },
	0x13DA: { /* n:"BrtEndRichFilters", */ T:-1 },
	0x13DB: { /* n:"BrtRichFilter" */ },
	0x13DC: { /* n:"BrtBeginRichFilterColumn", */ T:1 },
	0x13DD: { /* n:"BrtEndRichFilterColumn", */ T:-1 },
	0x13DE: { /* n:"BrtBeginCustomRichFilters", */ T:1 },
	0x13DF: { /* n:"BrtEndCustomRichFilters", */ T:-1 },
	0x13E0: { /* n:"BrtCustomRichFilter" */ },
	0x13E1: { /* n:"BrtTop10RichFilter" */ },
	0x13E2: { /* n:"BrtDynamicRichFilter" */ },
	0x13E4: { /* n:"BrtBeginRichSortCondition", */ T:1 },
	0x13E5: { /* n:"BrtEndRichSortCondition", */ T:-1 },
	0x13E6: { /* n:"BrtRichFilterDateGroupItem" */ },
	0x13E7: { /* n:"BrtBeginCalcFeatures", */ T:1 },
	0x13E8: { /* n:"BrtEndCalcFeatures", */ T:-1 },
	0x13E9: { /* n:"BrtCalcFeature" */ },
	0x13EB: { /* n:"BrtExternalLinksPr" */ },
	0xFFFF: { n:"" }
	};
	
	/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
	var XLSRecordEnum = {
		/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
	0x0006: { /* n:"Formula", */ f:parse_Formula },
	0x000a: { /* n:"EOF", */ f:parsenoop2 },
	0x000c: { /* n:"CalcCount", */ f:parseuint16 }, //
	0x000d: { /* n:"CalcMode", */ f:parseuint16 }, //
	0x000e: { /* n:"CalcPrecision", */ f:parsebool }, //
	0x000f: { /* n:"CalcRefMode", */ f:parsebool }, //
	0x0010: { /* n:"CalcDelta", */ f:parse_Xnum }, //
	0x0011: { /* n:"CalcIter", */ f:parsebool }, //
	0x0012: { /* n:"Protect", */ f:parsebool },
	0x0013: { /* n:"Password", */ f:parseuint16 },
	0x0014: { /* n:"Header", */ f:parse_XLHeaderFooter },
	0x0015: { /* n:"Footer", */ f:parse_XLHeaderFooter },
	0x0017: { /* n:"ExternSheet", */ f:parse_ExternSheet },
	0x0018: { /* n:"Lbl", */ f:parse_Lbl },
	0x0019: { /* n:"WinProtect", */ f:parsebool },
	0x001a: { /* n:"VerticalPageBreaks", */ },
	0x001b: { /* n:"HorizontalPageBreaks", */ },
	0x001c: { /* n:"Note", */ f:parse_Note },
	0x001d: { /* n:"Selection", */ },
	0x0022: { /* n:"Date1904", */ f:parsebool },
	0x0023: { /* n:"ExternName", */ f:parse_ExternName },
	0x0026: { /* n:"LeftMargin", */ f:parse_Xnum }, // *
	0x0027: { /* n:"RightMargin", */ f:parse_Xnum }, // *
	0x0028: { /* n:"TopMargin", */ f:parse_Xnum }, // *
	0x0029: { /* n:"BottomMargin", */ f:parse_Xnum }, // *
	0x002a: { /* n:"PrintRowCol", */ f:parsebool },
	0x002b: { /* n:"PrintGrid", */ f:parsebool },
	0x002f: { /* n:"FilePass", */ f:parse_FilePass },
	0x0031: { /* n:"Font", */ f:parse_Font },
	0x0033: { /* n:"PrintSize", */ f:parseuint16 },
	0x003c: { /* n:"Continue", */ },
	0x003d: { /* n:"Window1", */ f:parse_Window1 },
	0x0040: { /* n:"Backup", */ f:parsebool },
	0x0041: { /* n:"Pane", */ f:parse_Pane },
	0x0042: { /* n:"CodePage", */ f:parseuint16 },
	0x004d: { /* n:"Pls", */ },
	0x0050: { /* n:"DCon", */ },
	0x0051: { /* n:"DConRef", */ },
	0x0052: { /* n:"DConName", */ },
	0x0055: { /* n:"DefColWidth", */ f:parseuint16 },
	0x0059: { /* n:"XCT", */ },
	0x005a: { /* n:"CRN", */ },
	0x005b: { /* n:"FileSharing", */ },
	0x005c: { /* n:"WriteAccess", */ f:parse_WriteAccess },
	0x005d: { /* n:"Obj", */ f:parse_Obj },
	0x005e: { /* n:"Uncalced", */ },
	0x005f: { /* n:"CalcSaveRecalc", */ f:parsebool }, //
	0x0060: { /* n:"Template", */ },
	0x0061: { /* n:"Intl", */ },
	0x0063: { /* n:"ObjProtect", */ f:parsebool },
	0x007d: { /* n:"ColInfo", */ f:parse_ColInfo },
	0x0080: { /* n:"Guts", */ f:parse_Guts },
	0x0081: { /* n:"WsBool", */ f:parse_WsBool },
	0x0082: { /* n:"GridSet", */ f:parseuint16 },
	0x0083: { /* n:"HCenter", */ f:parsebool },
	0x0084: { /* n:"VCenter", */ f:parsebool },
	0x0085: { /* n:"BoundSheet8", */ f:parse_BoundSheet8 },
	0x0086: { /* n:"WriteProtect", */ },
	0x008c: { /* n:"Country", */ f:parse_Country },
	0x008d: { /* n:"HideObj", */ f:parseuint16 },
	0x0090: { /* n:"Sort", */ },
	0x0092: { /* n:"Palette", */ f:parse_Palette },
	0x0097: { /* n:"Sync", */ },
	0x0098: { /* n:"LPr", */ },
	0x0099: { /* n:"DxGCol", */ },
	0x009a: { /* n:"FnGroupName", */ },
	0x009b: { /* n:"FilterMode", */ },
	0x009c: { /* n:"BuiltInFnGroupCount", */ f:parseuint16 },
	0x009d: { /* n:"AutoFilterInfo", */ },
	0x009e: { /* n:"AutoFilter", */ },
	0x00a0: { /* n:"Scl", */ f:parse_Scl },
	0x00a1: { /* n:"Setup", */ f:parse_Setup },
	0x00ae: { /* n:"ScenMan", */ },
	0x00af: { /* n:"SCENARIO", */ },
	0x00b0: { /* n:"SxView", */ },
	0x00b1: { /* n:"Sxvd", */ },
	0x00b2: { /* n:"SXVI", */ },
	0x00b4: { /* n:"SxIvd", */ },
	0x00b5: { /* n:"SXLI", */ },
	0x00b6: { /* n:"SXPI", */ },
	0x00b8: { /* n:"DocRoute", */ },
	0x00b9: { /* n:"RecipName", */ },
	0x00bd: { /* n:"MulRk", */ f:parse_MulRk },
	0x00be: { /* n:"MulBlank", */ f:parse_MulBlank },
	0x00c1: { /* n:"Mms", */ f:parsenoop2 },
	0x00c5: { /* n:"SXDI", */ },
	0x00c6: { /* n:"SXDB", */ },
	0x00c7: { /* n:"SXFDB", */ },
	0x00c8: { /* n:"SXDBB", */ },
	0x00c9: { /* n:"SXNum", */ },
	0x00ca: { /* n:"SxBool", */ f:parsebool },
	0x00cb: { /* n:"SxErr", */ },
	0x00cc: { /* n:"SXInt", */ },
	0x00cd: { /* n:"SXString", */ },
	0x00ce: { /* n:"SXDtr", */ },
	0x00cf: { /* n:"SxNil", */ },
	0x00d0: { /* n:"SXTbl", */ },
	0x00d1: { /* n:"SXTBRGIITM", */ },
	0x00d2: { /* n:"SxTbpg", */ },
	0x00d3: { /* n:"ObProj", */ },
	0x00d5: { /* n:"SXStreamID", */ },
	0x00d7: { /* n:"DBCell", */ },
	0x00d8: { /* n:"SXRng", */ },
	0x00d9: { /* n:"SxIsxoper", */ },
	0x00da: { /* n:"BookBool", */ f:parseuint16 },
	0x00dc: { /* n:"DbOrParamQry", */ },
	0x00dd: { /* n:"ScenarioProtect", */ f:parsebool },
	0x00de: { /* n:"OleObjectSize", */ },
	0x00e0: { /* n:"XF", */ f:parse_XF },
	0x00e1: { /* n:"InterfaceHdr", */ f:parse_InterfaceHdr },
	0x00e2: { /* n:"InterfaceEnd", */ f:parsenoop2 },
	0x00e3: { /* n:"SXVS", */ },
	0x00e5: { /* n:"MergeCells", */ f:parse_MergeCells },
	0x00e9: { /* n:"BkHim", */ },
	0x00eb: { /* n:"MsoDrawingGroup", */ },
	0x00ec: { /* n:"MsoDrawing", */ },
	0x00ed: { /* n:"MsoDrawingSelection", */ },
	0x00ef: { /* n:"PhoneticInfo", */ },
	0x00f0: { /* n:"SxRule", */ },
	0x00f1: { /* n:"SXEx", */ },
	0x00f2: { /* n:"SxFilt", */ },
	0x00f4: { /* n:"SxDXF", */ },
	0x00f5: { /* n:"SxItm", */ },
	0x00f6: { /* n:"SxName", */ },
	0x00f7: { /* n:"SxSelect", */ },
	0x00f8: { /* n:"SXPair", */ },
	0x00f9: { /* n:"SxFmla", */ },
	0x00fb: { /* n:"SxFormat", */ },
	0x00fc: { /* n:"SST", */ f:parse_SST },
	0x00fd: { /* n:"LabelSst", */ f:parse_LabelSst },
	0x00ff: { /* n:"ExtSST", */ f:parse_ExtSST },
	0x0100: { /* n:"SXVDEx", */ },
	0x0103: { /* n:"SXFormula", */ },
	0x0122: { /* n:"SXDBEx", */ },
	0x0137: { /* n:"RRDInsDel", */ },
	0x0138: { /* n:"RRDHead", */ },
	0x013b: { /* n:"RRDChgCell", */ },
	0x013d: { /* n:"RRTabId", */ f:parseuint16a },
	0x013e: { /* n:"RRDRenSheet", */ },
	0x013f: { /* n:"RRSort", */ },
	0x0140: { /* n:"RRDMove", */ },
	0x014a: { /* n:"RRFormat", */ },
	0x014b: { /* n:"RRAutoFmt", */ },
	0x014d: { /* n:"RRInsertSh", */ },
	0x014e: { /* n:"RRDMoveBegin", */ },
	0x014f: { /* n:"RRDMoveEnd", */ },
	0x0150: { /* n:"RRDInsDelBegin", */ },
	0x0151: { /* n:"RRDInsDelEnd", */ },
	0x0152: { /* n:"RRDConflict", */ },
	0x0153: { /* n:"RRDDefName", */ },
	0x0154: { /* n:"RRDRstEtxp", */ },
	0x015f: { /* n:"LRng", */ },
	0x0160: { /* n:"UsesELFs", */ f:parsebool },
	0x0161: { /* n:"DSF", */ f:parsenoop2 },
	0x0191: { /* n:"CUsr", */ },
	0x0192: { /* n:"CbUsr", */ },
	0x0193: { /* n:"UsrInfo", */ },
	0x0194: { /* n:"UsrExcl", */ },
	0x0195: { /* n:"FileLock", */ },
	0x0196: { /* n:"RRDInfo", */ },
	0x0197: { /* n:"BCUsrs", */ },
	0x0198: { /* n:"UsrChk", */ },
	0x01a9: { /* n:"UserBView", */ },
	0x01aa: { /* n:"UserSViewBegin", */ },
	0x01ab: { /* n:"UserSViewEnd", */ },
	0x01ac: { /* n:"RRDUserView", */ },
	0x01ad: { /* n:"Qsi", */ },
	0x01ae: { /* n:"SupBook", */ f:parse_SupBook },
	0x01af: { /* n:"Prot4Rev", */ f:parsebool },
	0x01b0: { /* n:"CondFmt", */ },
	0x01b1: { /* n:"CF", */ },
	0x01b2: { /* n:"DVal", */ },
	0x01b5: { /* n:"DConBin", */ },
	0x01b6: { /* n:"TxO", */ f:parse_TxO },
	0x01b7: { /* n:"RefreshAll", */ f:parsebool }, //
	0x01b8: { /* n:"HLink", */ f:parse_HLink },
	0x01b9: { /* n:"Lel", */ },
	0x01ba: { /* n:"CodeName", */ f:parse_XLUnicodeString },
	0x01bb: { /* n:"SXFDBType", */ },
	0x01bc: { /* n:"Prot4RevPass", */ f:parseuint16 },
	0x01bd: { /* n:"ObNoMacros", */ },
	0x01be: { /* n:"Dv", */ },
	0x01c0: { /* n:"Excel9File", */ f:parsenoop2 },
	0x01c1: { /* n:"RecalcId", */ f:parse_RecalcId, r:2},
	0x01c2: { /* n:"EntExU2", */ f:parsenoop2 },
	0x0200: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0201: { /* n:"Blank", */ f:parse_Blank },
	0x0203: { /* n:"Number", */ f:parse_Number },
	0x0204: { /* n:"Label", */ f:parse_Label },
	0x0205: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0207: { /* n:"String", */ f:parse_String },
	0x0208: { /* n:"Row", */ f:parse_Row },
	0x020b: { /* n:"Index", */ },
	0x0221: { /* n:"Array", */ f:parse_Array },
	0x0225: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
	0x0236: { /* n:"Table", */ },
	0x023e: { /* n:"Window2", */ f:parse_Window2 },
	0x027e: { /* n:"RK", */ f:parse_RK },
	0x0293: { /* n:"Style", */ },
	0x0418: { /* n:"BigName", */ },
	0x041e: { /* n:"Format", */ f:parse_Format },
	0x043c: { /* n:"ContinueBigName", */ },
	0x04bc: { /* n:"ShrFmla", */ f:parse_ShrFmla },
	0x0800: { /* n:"HLinkTooltip", */ f:parse_HLinkTooltip },
	0x0801: { /* n:"WebPub", */ },
	0x0802: { /* n:"QsiSXTag", */ },
	0x0803: { /* n:"DBQueryExt", */ },
	0x0804: { /* n:"ExtString", */ },
	0x0805: { /* n:"TxtQry", */ },
	0x0806: { /* n:"Qsir", */ },
	0x0807: { /* n:"Qsif", */ },
	0x0808: { /* n:"RRDTQSIF", */ },
	0x0809: { /* n:"BOF", */ f:parse_BOF },
	0x080a: { /* n:"OleDbConn", */ },
	0x080b: { /* n:"WOpt", */ },
	0x080c: { /* n:"SXViewEx", */ },
	0x080d: { /* n:"SXTH", */ },
	0x080e: { /* n:"SXPIEx", */ },
	0x080f: { /* n:"SXVDTEx", */ },
	0x0810: { /* n:"SXViewEx9", */ },
	0x0812: { /* n:"ContinueFrt", */ },
	0x0813: { /* n:"RealTimeData", */ },
	0x0850: { /* n:"ChartFrtInfo", */ },
	0x0851: { /* n:"FrtWrapper", */ },
	0x0852: { /* n:"StartBlock", */ },
	0x0853: { /* n:"EndBlock", */ },
	0x0854: { /* n:"StartObject", */ },
	0x0855: { /* n:"EndObject", */ },
	0x0856: { /* n:"CatLab", */ },
	0x0857: { /* n:"YMult", */ },
	0x0858: { /* n:"SXViewLink", */ },
	0x0859: { /* n:"PivotChartBits", */ },
	0x085a: { /* n:"FrtFontList", */ },
	0x0862: { /* n:"SheetExt", */ },
	0x0863: { /* n:"BookExt", */ r:12},
	0x0864: { /* n:"SXAddl", */ },
	0x0865: { /* n:"CrErr", */ },
	0x0866: { /* n:"HFPicture", */ },
	0x0867: { /* n:"FeatHdr", */ f:parsenoop2 },
	0x0868: { /* n:"Feat", */ },
	0x086a: { /* n:"DataLabExt", */ },
	0x086b: { /* n:"DataLabExtContents", */ },
	0x086c: { /* n:"CellWatch", */ },
	0x0871: { /* n:"FeatHdr11", */ },
	0x0872: { /* n:"Feature11", */ },
	0x0874: { /* n:"DropDownObjIds", */ },
	0x0875: { /* n:"ContinueFrt11", */ },
	0x0876: { /* n:"DConn", */ },
	0x0877: { /* n:"List12", */ },
	0x0878: { /* n:"Feature12", */ },
	0x0879: { /* n:"CondFmt12", */ },
	0x087a: { /* n:"CF12", */ },
	0x087b: { /* n:"CFEx", */ },
	0x087c: { /* n:"XFCRC", */ f:parse_XFCRC, r:12 },
	0x087d: { /* n:"XFExt", */ f:parse_XFExt, r:12 },
	0x087e: { /* n:"AutoFilter12", */ },
	0x087f: { /* n:"ContinueFrt12", */ },
	0x0884: { /* n:"MDTInfo", */ },
	0x0885: { /* n:"MDXStr", */ },
	0x0886: { /* n:"MDXTuple", */ },
	0x0887: { /* n:"MDXSet", */ },
	0x0888: { /* n:"MDXProp", */ },
	0x0889: { /* n:"MDXKPI", */ },
	0x088a: { /* n:"MDB", */ },
	0x088b: { /* n:"PLV", */ },
	0x088c: { /* n:"Compat12", */ f:parsebool, r:12 },
	0x088d: { /* n:"DXF", */ },
	0x088e: { /* n:"TableStyles", */ r:12 },
	0x088f: { /* n:"TableStyle", */ },
	0x0890: { /* n:"TableStyleElement", */ },
	0x0892: { /* n:"StyleExt", */ },
	0x0893: { /* n:"NamePublish", */ },
	0x0894: { /* n:"NameCmt", */ f:parse_NameCmt, r:12 },
	0x0895: { /* n:"SortData", */ },
	0x0896: { /* n:"Theme", */ f:parse_Theme, r:12 },
	0x0897: { /* n:"GUIDTypeLib", */ },
	0x0898: { /* n:"FnGrp12", */ },
	0x0899: { /* n:"NameFnGrp12", */ },
	0x089a: { /* n:"MTRSettings", */ f:parse_MTRSettings, r:12 },
	0x089b: { /* n:"CompressPictures", */ f:parsenoop2 },
	0x089c: { /* n:"HeaderFooter", */ },
	0x089d: { /* n:"CrtLayout12", */ },
	0x089e: { /* n:"CrtMlFrt", */ },
	0x089f: { /* n:"CrtMlFrtContinue", */ },
	0x08a3: { /* n:"ForceFullCalculation", */ f:parse_ForceFullCalculation },
	0x08a4: { /* n:"ShapePropsStream", */ },
	0x08a5: { /* n:"TextPropsStream", */ },
	0x08a6: { /* n:"RichTextStream", */ },
	0x08a7: { /* n:"CrtLayout12A", */ },
	0x1001: { /* n:"Units", */ },
	0x1002: { /* n:"Chart", */ },
	0x1003: { /* n:"Series", */ },
	0x1006: { /* n:"DataFormat", */ },
	0x1007: { /* n:"LineFormat", */ },
	0x1009: { /* n:"MarkerFormat", */ },
	0x100a: { /* n:"AreaFormat", */ },
	0x100b: { /* n:"PieFormat", */ },
	0x100c: { /* n:"AttachedLabel", */ },
	0x100d: { /* n:"SeriesText", */ },
	0x1014: { /* n:"ChartFormat", */ },
	0x1015: { /* n:"Legend", */ },
	0x1016: { /* n:"SeriesList", */ },
	0x1017: { /* n:"Bar", */ },
	0x1018: { /* n:"Line", */ },
	0x1019: { /* n:"Pie", */ },
	0x101a: { /* n:"Area", */ },
	0x101b: { /* n:"Scatter", */ },
	0x101c: { /* n:"CrtLine", */ },
	0x101d: { /* n:"Axis", */ },
	0x101e: { /* n:"Tick", */ },
	0x101f: { /* n:"ValueRange", */ },
	0x1020: { /* n:"CatSerRange", */ },
	0x1021: { /* n:"AxisLine", */ },
	0x1022: { /* n:"CrtLink", */ },
	0x1024: { /* n:"DefaultText", */ },
	0x1025: { /* n:"Text", */ },
	0x1026: { /* n:"FontX", */ f:parseuint16 },
	0x1027: { /* n:"ObjectLink", */ },
	0x1032: { /* n:"Frame", */ },
	0x1033: { /* n:"Begin", */ },
	0x1034: { /* n:"End", */ },
	0x1035: { /* n:"PlotArea", */ },
	0x103a: { /* n:"Chart3d", */ },
	0x103c: { /* n:"PicF", */ },
	0x103d: { /* n:"DropBar", */ },
	0x103e: { /* n:"Radar", */ },
	0x103f: { /* n:"Surf", */ },
	0x1040: { /* n:"RadarArea", */ },
	0x1041: { /* n:"AxisParent", */ },
	0x1043: { /* n:"LegendException", */ },
	0x1044: { /* n:"ShtProps", */ f:parse_ShtProps },
	0x1045: { /* n:"SerToCrt", */ },
	0x1046: { /* n:"AxesUsed", */ },
	0x1048: { /* n:"SBaseRef", */ },
	0x104a: { /* n:"SerParent", */ },
	0x104b: { /* n:"SerAuxTrend", */ },
	0x104e: { /* n:"IFmtRecord", */ },
	0x104f: { /* n:"Pos", */ },
	0x1050: { /* n:"AlRuns", */ },
	0x1051: { /* n:"BRAI", */ },
	0x105b: { /* n:"SerAuxErrBar", */ },
	0x105c: { /* n:"ClrtClient", */ f:parse_ClrtClient },
	0x105d: { /* n:"SerFmt", */ },
	0x105f: { /* n:"Chart3DBarShape", */ },
	0x1060: { /* n:"Fbi", */ },
	0x1061: { /* n:"BopPop", */ },
	0x1062: { /* n:"AxcExt", */ },
	0x1063: { /* n:"Dat", */ },
	0x1064: { /* n:"PlotGrowth", */ },
	0x1065: { /* n:"SIIndex", */ },
	0x1066: { /* n:"GelFrame", */ },
	0x1067: { /* n:"BopPopCustom", */ },
	0x1068: { /* n:"Fbi2", */ },
	
	0x0000: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0001: { /* n:"BIFF2BLANK", */ },
	0x0002: { /* n:"BIFF2INT", */ f:parse_BIFF2INT },
	0x0003: { /* n:"BIFF2NUM", */ f:parse_BIFF2NUM },
	0x0004: { /* n:"BIFF2STR", */ f:parse_BIFF2STR },
	0x0005: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0007: { /* n:"String", */ f:parse_BIFF2STRING },
	0x0008: { /* n:"BIFF2ROW", */ },
	0x0009: { /* n:"BOF", */ f:parse_BOF },
	0x000b: { /* n:"Index", */ },
	0x0016: { /* n:"ExternCount", */ f:parseuint16 },
	0x001e: { /* n:"BIFF2FORMAT", */ f:parse_BIFF2Format },
	0x001f: { /* n:"BIFF2FMTCNT", */ }, /* 16-bit cnt of BIFF2FORMAT records */
	0x0020: { /* n:"BIFF2COLINFO", */ },
	0x0021: { /* n:"Array", */ f:parse_Array },
	0x0024: { /* n:"COLWIDTH", */ },
	0x0025: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
		// 0x2c ??
		// 0x2d ??
		// 0x2e ??
		// 0x30 FONTCOUNT: number of fonts
	0x0032: { /* n:"BIFF2FONTXTRA", */ f:parse_BIFF2FONTXTRA },
		// 0x35: INFOOPTS
		// 0x36: TABLE (BIFF2 only)
		// 0x37: TABLE2 (BIFF2 only)
		// 0x38: WNDESK
		// 0x39 ??
		// 0x3a: BEGINPREF
		// 0x3b: ENDPREF
	0x003e: { /* n:"BIFF2WINDOW2", */ },
		// 0x3f ??
		// 0x46: SHOWSCROLL
		// 0x47: SHOWFORMULA
		// 0x48: STATUSBAR
		// 0x49: SHORTMENUS
		// 0x4A:
		// 0x4B:
		// 0x4C:
		// 0x4E:
		// 0x4F:
		// 0x58: TOOLBAR (BIFF3)
	
		/* - - - */
	0x0034: { /* n:"DDEObjName", */ },
	0x0043: { /* n:"BIFF2XF", */ },
	0x0044: { /* n:"BIFF2XFINDEX", */ f:parseuint16 },
	0x0045: { /* n:"BIFF2FONTCLR", */ },
	0x0056: { /* n:"BIFF4FMTCNT", */ }, /* 16-bit cnt, similar to BIFF2 */
	0x007e: { /* n:"RK", */ }, /* Not necessarily same as 0x027e */
	0x007f: { /* n:"ImData", */ f:parse_ImData },
	0x0087: { /* n:"Addin", */ },
	0x0088: { /* n:"Edg", */ },
	0x0089: { /* n:"Pub", */ },
		// 0x8A
		// 0x8B LH: alternate menu key flag (BIFF3/4)
		// 0x8E
		// 0x8F
	0x0091: { /* n:"Sub", */ },
		// 0x93 STYLE
	0x0094: { /* n:"LHRecord", */ },
	0x0095: { /* n:"LHNGraph", */ },
	0x0096: { /* n:"Sound", */ },
		// 0xA2 FNPROTO: function prototypes (BIFF4)
		// 0xA3
		// 0xA8
	0x00a9: { /* n:"CoordList", */ },
	0x00ab: { /* n:"GCW", */ },
	0x00bc: { /* n:"ShrFmla", */ }, /* Not necessarily same as 0x04bc */
	0x00bf: { /* n:"ToolbarHdr", */ },
	0x00c0: { /* n:"ToolbarEnd", */ },
	0x00c2: { /* n:"AddMenu", */ },
	0x00c3: { /* n:"DelMenu", */ },
	0x00d6: { /* n:"RString", */ f:parse_RString },
	0x00df: { /* n:"UDDesc", */ },
	0x00ea: { /* n:"TabIdConf", */ },
	0x0162: { /* n:"XL5Modify", */ },
	0x01a5: { /* n:"FileSharing2", */ },
	0x0206: { /* n:"Formula", */ f:parse_Formula },
	0x0209: { /* n:"BOF", */ f:parse_BOF },
	0x0218: { /* n:"Lbl", */ f:parse_Lbl },
	0x0223: { /* n:"ExternName", */ f:parse_ExternName },
	0x0231: { /* n:"Font", */ },
	0x0243: { /* n:"BIFF3XF", */ },
	0x0406: { /* n:"Formula", */ f:parse_Formula },
	0x0409: { /* n:"BOF", */ f:parse_BOF },
	0x0443: { /* n:"BIFF4XF", */ },
	0x086d: { /* n:"FeatInfo", */ },
	0x0873: { /* n:"FeatInfo11", */ },
	0x0881: { /* n:"SXAddl12", */ },
	0x08c0: { /* n:"AutoWebPub", */ },
	0x08c1: { /* n:"ListObj", */ },
	0x08c2: { /* n:"ListField", */ },
	0x08c3: { /* n:"ListDV", */ },
	0x08c4: { /* n:"ListCondFmt", */ },
	0x08c5: { /* n:"ListCF", */ },
	0x08c6: { /* n:"FMQry", */ },
	0x08c7: { /* n:"FMSQry", */ },
	0x08c8: { /* n:"PLV", */ },
	0x08c9: { /* n:"LnExt", */ },
	0x08ca: { /* n:"MkrExt", */ },
	0x08cb: { /* n:"CrtCoopt", */ },
	0x08d6: { /* n:"FRTArchId$", */ r:12 },
	
	0x7262: {}
	};
	
	function write_biff_rec(ba, type, payload, length) {
		var t = type;
		if(isNaN(t)) return;
		var len = length || (payload||[]).length || 0;
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, len);
		if(len > 0 && is_buf(payload)) ba.push(payload);
	}
	
	function write_biff_continue(ba, type, payload, length) {
		var len = length || (payload||[]).length || 0;
		if(len <= 8224) return write_biff_rec(ba, type, payload, len);
		var t = type;
		if(isNaN(t)) return;
		var parts = payload.parts || [], sidx = 0;
		var i = 0, w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, w);
		ba.push(payload.slice(i, i + w));
		i += w;
		while(i < len) {
			o = ba.next(4);
			o.write_shift(2, 0x3c); // TODO: figure out correct continue type
			w = 0;
			while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
			o.write_shift(2, w);
			ba.push(payload.slice(i, i+w)); i+= w;
		}
	}
	
	function write_BIFF2Cell(out, r, c) {
		if(!out) out = new_buf(7);
		out.write_shift(2, r);
		out.write_shift(2, c);
		out.write_shift(2, 0);
		out.write_shift(1, 0);
		return out;
	}
	
	function write_BIFF2BERR(r, c, val, t) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		write_Bes(val, t || 'b', out);
		return out;
	}
	
	/* TODO: codepage, large strings */
	function write_BIFF2LABEL(r, c, val) {
		var out = new_buf(8 + 2*val.length);
		write_BIFF2Cell(out, r, c);
		out.write_shift(1, val.length);
		out.write_shift(val.length, val, 'sbcs');
		return out.l < out.length ? out.slice(0, out.l) : out;
	}
	
	function write_ws_biff2_cell(ba, cell, R, C) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				if((v == (v|0)) && (v >= 0) && (v < 65536))
					write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
				else
					write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
				return;
			case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v||"").slice(0,255)));
				return;
		}
		write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
	}
	
	function write_ws_biff2(ba, ws, idx, opts) {
		var dense = Array.isArray(ws);
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, 0x3FFF);
			ref = encode_range(range);
		}
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff2_cell(ba, cell, R, C, opts);
			}
		}
	}
	
	/* Based on test files */
	function write_biff2_buf(wb, opts) {
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ba = buf_array();
		var idx = 0;
		for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
		if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
		write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
		/* ... */
		write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
		/* ... */
		write_biff_rec(ba, 0x000A);
		return ba.end();
	}
	
	function write_FONTS_biff8(ba, data, opts) {
		write_biff_rec(ba, 0x0031 /* Font */, write_Font({
			sz:12,
			color: {theme:1},
			name: "Arial",
			family: 2,
			scheme: "minor"
		}, opts));
	}
	
	
	function write_FMTS_biff8(ba, NF, opts) {
		if(!NF) return;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, 0x041E /* Format */, write_Format(i, NF[i], opts));
		});
	}
	
	function write_FEAT(ba, ws) {
		/* [MS-XLS] 2.4.112 */
		var o = new_buf(19);
		o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
		write_biff_rec(ba, 0x0867 /* FeatHdr */, o);
		/* [MS-XLS] 2.4.111 */
		o = new_buf(39);
		o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
		o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
		write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
		o.write_shift(4, 4);
		write_biff_rec(ba, 0x0868 /* Feat */, o);
	}
	
	function write_CELLXFS_biff8(ba, opts) {
		for(var i = 0; i < 16; ++i) write_biff_rec(ba, 0x00e0 /* XF */, write_XF({numFmtId:0, style:true}, 0, opts));
		opts.cellXfs.forEach(function(c) {
			write_biff_rec(ba, 0x00e0 /* XF */, write_XF(c, 0, opts));
		});
	}
	
	function write_ws_biff8_hlinks(ba, ws) {
		for(var R=0; R<ws['!links'].length; ++R) {
			var HL = ws['!links'][R];
			write_biff_rec(ba, 0x01b8 /* HLink */, write_HLink(HL));
			if(HL[1].Tooltip) write_biff_rec(ba, 0x0800 /* HLinkTooltip */, write_HLinkTooltip(HL));
		}
		delete ws['!links'];
	}
	
	function write_ws_cols_biff8(ba, cols) {
		if(!cols) return;
		var cnt = 0;
		cols.forEach(function(col, idx) {
			if(++cnt <= 256 && col) {
				write_biff_rec(ba, 0x007d /* ColInfo */, write_ColInfo(col_obj_w(idx, col), idx));
			}
		});
	}
	
	function write_ws_biff8_cell(ba, cell, R, C, opts) {
		var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
		if(cell.v == null && !cell.bf) {
			write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
			return;
		}
		if(cell.bf) write_biff_rec(ba, 0x0006 /* Formula */, write_Formula(cell, R, C, opts, os));
		else switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				/* TODO: emit RK as appropriate */
				write_biff_rec(ba, 0x0203 /* Number */, write_Number(R, C, v, os, opts));
				break;
			case 'b': case 'e':
				write_biff_rec(ba, 0x0205 /* BoolErr */, write_BoolErr(R, C, cell.v, os, opts, cell.t));
				break;
			/* TODO: codepage, sst */
			case 's': case 'str':
				if(opts.bookSST) {
					var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
					write_biff_rec(ba, 0x00fd /* LabelSst */, write_LabelSst(R, C, isst, os, opts));
				} else write_biff_rec(ba, 0x0204 /* Label */, write_Label(R, C, (cell.v||"").slice(0,255), os, opts));
				break;
			default:
				write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
		}
	}
	
	/* [MS-XLS] 2.1.7.20.5 */
	function write_ws_biff8(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var _WB = ((wb||{}).Workbook||{});
		var _sheet = ((_WB.Sheets||[])[idx]||{});
		var dense = Array.isArray(ws);
		var b8 = opts.biff == 8;
		var ref, rr = "", cols = [];
		var range = safe_decode_range(ws['!ref'] || "A1");
		var MAX_ROWS = b8 ? 65536 : 16384;
		if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, MAX_ROWS-1);
		}
	
		write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
		/* [Uncalced] Index */
		write_biff_rec(ba, 0x000d /* CalcMode */, writeuint16(1));
		write_biff_rec(ba, 0x000c /* CalcCount */, writeuint16(100));
		write_biff_rec(ba, 0x000f /* CalcRefMode */, writebool(true));
		write_biff_rec(ba, 0x0011 /* CalcIter */, writebool(false));
		write_biff_rec(ba, 0x0010 /* CalcDelta */, write_Xnum(0.001));
		write_biff_rec(ba, 0x005f /* CalcSaveRecalc */, writebool(true));
		write_biff_rec(ba, 0x002a /* PrintRowCol */, writebool(false));
		write_biff_rec(ba, 0x002b /* PrintGrid */, writebool(false));
		write_biff_rec(ba, 0x0082 /* GridSet */, writeuint16(1));
		write_biff_rec(ba, 0x0080 /* Guts */, write_Guts([0,0]));
		/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
		/* Header (string) */
		/* Footer (string) */
		write_biff_rec(ba, 0x0083 /* HCenter */, writebool(false));
		write_biff_rec(ba, 0x0084 /* VCenter */, writebool(false));
		/* ... */
		if(b8) write_ws_cols_biff8(ba, ws["!cols"]);
		/* ... */
		write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
		/* ... */
	
		if(b8) ws['!links'] = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff8_cell(ba, cell, R, C, opts);
				if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			}
		}
		var cname = _sheet.CodeName || _sheet.name || s;
		/* ... */
		if(b8) write_biff_rec(ba, 0x023e /* Window2 */, write_Window2((_WB.Views||[])[0]));
		/* ... */
		if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, 0x00e5 /* MergeCells */, write_MergeCells(ws['!merges']));
		/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
		if(b8) write_ws_biff8_hlinks(ba, ws);
		/* [DVAL] */
		write_biff_rec(ba, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		/* *WebPub *CellWatch [SheetExt] */
		if(b8) write_FEAT(ba, ws);
		/* *FEAT11 *RECORD12 */
		write_biff_rec(ba, 0x000a /* EOF */);
		return ba.end();
	}
	
	/* [MS-XLS] 2.1.7.20.3 */
	function write_biff8_global(wb, bufs, opts) {
		var A = buf_array();
		var _WB = ((wb||{}).Workbook||{});
		var _sheets = (_WB.Sheets||[]);
		var _wb = _WB.WBProps||{};
		var b8 = opts.biff == 8, b5 = opts.biff == 5;
		write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
		if(opts.bookType == "xla") write_biff_rec(A, 0x0087 /* Addin */);
		write_biff_rec(A, 0x00e1 /* InterfaceHdr */, b8 ? writeuint16(0x04b0) : null);
		write_biff_rec(A, 0x00c1 /* Mms */, writezeroes(2));
		if(b5) write_biff_rec(A, 0x00bf /* ToolbarHdr */);
		if(b5) write_biff_rec(A, 0x00c0 /* ToolbarEnd */);
		write_biff_rec(A, 0x00e2 /* InterfaceEnd */);
		write_biff_rec(A, 0x005c /* WriteAccess */, write_WriteAccess("SheetJS", opts));
		/* [FileSharing] */
		write_biff_rec(A, 0x0042 /* CodePage */, writeuint16(b8 ? 0x04b0 : 0x04E4));
		/* *2047 Lel */
		if(b8) write_biff_rec(A, 0x0161 /* DSF */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01c0 /* Excel9File */);
		write_biff_rec(A, 0x013d /* RRTabId */, write_RRTabId(wb.SheetNames.length));
		if(b8 && wb.vbaraw) write_biff_rec(A, 0x00d3 /* ObProj */);
		/* [ObNoMacros] */
		if(b8 && wb.vbaraw) {
			var cname = _wb.CodeName || "ThisWorkbook";
			write_biff_rec(A, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		}
		write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */, writeuint16(0x11));
		/* *FnGroupName *FnGrp12 */
		/* *Lbl */
		/* [OleObjectSize] */
		write_biff_rec(A, 0x0019 /* WinProtect */, writebool(false));
		write_biff_rec(A, 0x0012 /* Protect */, writebool(false));
		write_biff_rec(A, 0x0013 /* Password */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01af /* Prot4Rev */, writebool(false));
		if(b8) write_biff_rec(A, 0x01bc /* Prot4RevPass */, writeuint16(0));
		write_biff_rec(A, 0x003d /* Window1 */, write_Window1(opts));
		write_biff_rec(A, 0x0040 /* Backup */, writebool(false));
		write_biff_rec(A, 0x008d /* HideObj */, writeuint16(0));
		write_biff_rec(A, 0x0022 /* Date1904 */, writebool(safe1904(wb)=="true"));
		write_biff_rec(A, 0x000e /* CalcPrecision */, writebool(true));
		if(b8) write_biff_rec(A, 0x01b7 /* RefreshAll */, writebool(false));
		write_biff_rec(A, 0x00DA /* BookBool */, writeuint16(0));
		/* ... */
		write_FONTS_biff8(A, wb, opts);
		write_FMTS_biff8(A, wb.SSF, opts);
		write_CELLXFS_biff8(A, opts);
		/* ... */
		if(b8) write_biff_rec(A, 0x0160 /* UsesELFs */, writebool(false));
		var a = A.end();
	
		var C = buf_array();
		/* METADATA [MTRSettings] [ForceFullCalculation] */
		if(b8) write_biff_rec(C, 0x008C, write_Country());
		/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */
	
		/* BIFF8: [SST *Continue] ExtSST */
		if(b8 && opts.Strings) write_biff_continue(C, 0x00FC, write_SST(opts.Strings, opts));
	
		/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
		write_biff_rec(C, 0x000A /* EOF */);
		var c = C.end();
	
		var B = buf_array();
		var blen = 0, j = 0;
		for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
		var start = a.length + blen + c.length;
		for(j = 0; j < wb.SheetNames.length; ++j) {
			var _sheet = _sheets[j] || ({});
			write_biff_rec(B, 0x0085 /* BoundSheet8 */, write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
			start += bufs[j].length;
		}
		/* 1*BoundSheet8 */
		var b = B.end();
		if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
	
		var out = [];
		if(a.length) out.push(a);
		if(b.length) out.push(b);
		if(c.length) out.push(c);
		return bconcat(out);
	}
	
	/* [MS-XLS] 2.1.7.20 Workbook Stream */
	function write_biff8_buf(wb, opts) {
		var o = opts || {};
		var bufs = [];
	
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
			o.ssf = wb.SSF;
		}
	
		o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
		fix_write_opts(o);
	
		o.cellXfs = [];
		get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
		bufs.unshift(write_biff8_global(wb, bufs, o));
		return bconcat(bufs);
	}
	
	function write_biff_buf(wb, opts) {
		for(var i = 0; i <= wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = decode_range(ws["!ref"]);
			if(range.e.c > 255) { // note: 255 is IV
			if(typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
			}
		}
	
		var o = opts || {};
		switch(o.biff || 2) {
			case 8: case 5: return write_biff8_buf(wb, opts);
			case 4: case 3: case 2: return write_biff2_buf(wb, opts);
		}
		throw new Error("invalid type " + o.bookType + " for BIFF");
	}
	/* note: browser DOM element cannot see mso- style attrs, must parse */
	function html_to_sheet(str, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		str = str.replace(/<!--.*?-->/g, "");
		var mtch = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2 = str.match(/<\/table/i);
		var i = mtch.index, j = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				for(var midx = 0; midx < merges.length; ++midx) {
					var _merge = merges[midx];
					if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
				}
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t = tag.t || tag["data-t"] || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(m);
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) { C += CS; continue; }
				var o = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's'){}
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || table_fmt[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		if(merges.length) ws["!merges"] = merges;
		return ws;
	}
	function make_html_row(ws, r, R, o) {
		var M = (ws['!merges'] ||[]);
		var oo = [];
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			/* TODO: html entities */
			var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
			var sp = ({});
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			else if(cell) {
				sp["data-t"] = cell && cell.t || 'z';
				if(cell.v != null) sp["data-v"] = cell.v;
				if(cell.z != null) sp["data-z"] = cell.z;
				if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
			}
			sp.id = (o.id || "sjs") + "-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	
	var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var HTML_END = '</body></html>';
	
	function html_to_workbook(str, opts) {
		var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
		if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
		if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
		var wb = book_new();
		mtch.forEach(function(s, idx) { book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
		return wb;
	}
	
	function make_html_preamble(ws, R, o) {
		var out = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	
	function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		var out = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");
	}
	
	function sheet_add_dom(ws, table, _opts) {
		var opts = _opts || {};
		if(DENSE != null) opts.dense = DENSE;
		var or_R = 0, or_C = 0;
		if(opts.origin != null) {
			if(typeof opts.origin == 'number') or_R = opts.origin;
			else {
				var _origin = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
				or_R = _origin.r; or_C = _origin.c;
			}
		}
	
		var rows = table.getElementsByTagName('tr');
		var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
		var range = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
		if(ws["!ref"]) {
			var _range = decode_range(ws["!ref"]);
			range.s.r = Math.min(range.s.r, _range.s.r);
			range.s.c = Math.min(range.s.c, _range.s.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			range.e.c = Math.max(range.e.c, _range.e.c);
			if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
		}
		var merges = [], midx = 0;
		var rowinfo = ws["!rows"] || (ws["!rows"] = []);
		var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
		if(!ws["!cols"]) ws['!cols'] = [];
		for(; _R < rows.length && R < sheetRows; ++_R) {
			var row = rows[_R];
			if (is_dom_element_hidden(row)) {
				if (opts.display) continue;
				rowinfo[R] = {hidden: true};
			}
			var elts = (row.children);
			for(_C = C = 0; _C < elts.length; ++_C) {
				var elt = elts[_C];
				if (opts.display && is_dom_element_hidden(elt)) continue;
				var v = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
				var z = elt.getAttribute('data-z') || elt.getAttribute('z');
				for(midx = 0; midx < merges.length; ++midx) {
					var m = merges[midx];
					if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
				}
				/* TODO: figure out how to extract nonstandard mso- style */
				CS = +elt.getAttribute("colspan") || 1;
				if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
				var o = {t:'s', v:v};
				var _t = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
				if(v != null) {
					if(v.length == 0) o.t = _t || 'z';
					else if(opts.raw || v.trim().length == 0 || _t == "s"){}
					else if(v === 'TRUE') o = {t:'b', v:true};
					else if(v === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
					else if(!isNaN(fuzzydate(v).getDate())) {
						o = ({t:'d', v:parseDate(v)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || table_fmt[14];
					}
				}
				if(o.z === undefined && z != null) o.z = z;
				/* The first link is used.  Links are assumed to be fully specified.
				 * TODO: The right way to process relative links is to make a new <a> */
				var l = "", Aelts = elt.getElementsByTagName("A");
				if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
					l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
				}
				if(l && l.charAt(0) != "#") o.l = ({ Target: l });
				if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
				else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
				if(range.e.c < C + or_C) range.e.c = C + or_C;
				C += CS;
			}
			++R;
		}
		if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
		range.e.r = Math.max(range.e.r, R - 1 + or_R);
		ws['!ref'] = encode_range(range);
		if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
		return ws;
	}
	
	function parse_dom_table(table, _opts) {
		var opts = _opts || {};
		var ws = opts.dense ? ([]) : ({});
		return sheet_add_dom(ws, table, _opts);
	}
	
	function table_to_book(table, opts) {
		return sheet_to_workbook(parse_dom_table(table, opts), opts);
	}
	
	function is_dom_element_hidden(element) {
		var display = '';
		var get_computed_style = get_get_computed_style_function(element);
		if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
		if(!display) display = element.style && element.style.display;
		return display === 'none';
	}
	
	/* global getComputedStyle */
	function get_get_computed_style_function(element) {
		// The proper getComputedStyle implementation is the one defined in the element window
		if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
		// If it is not available, try to get one from the global namespace
		if(typeof getComputedStyle === 'function') return getComputedStyle;
		return null;
	}
	/* OpenDocument */
	function parse_text_p(text) {
		/* 6.1.2 White Space Characters */
		var fixed = text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n");
		var v = unescapexml(fixed.replace(/<[^>]*>/g,""));
	
		return [v];
	}
	
	var number_formats_ods = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};
	
	
	function parse_content_xml(d, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag = {name:""}, NF = "", pidx = 0;
			var sheetag;
			var rowtag;
			var Sheets = {}, SheetNames = [];
			var ws = opts.dense ? ([]) : ({});
			var Rn, q;
			var ctag = ({value:""});
			var textp = "", textpidx = 0, textptag;
			var textR = [];
			var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var row_ol = 0;
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
			var rowinfo = [], rowpeat = 1, colpeat = 1;
			var arrayf = [];
			var WB = {Names:[]};
			var atag = ({});
			var _Ref = ["", ""];
			var comments = [], comment = ({});
			var creator = "", creatoridx = 0;
			var isstub = false, intable = false;
			var i = 0;
			xlmlregex.lastIndex = 0;
			str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
			while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
	
				case 'table': case '工作表': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
						else ws['!ref'] = "A1:A1";
						if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
							ws['!fullref'] = ws['!ref'];
							range.e.r = opts.sheetRows - 1;
							ws['!ref'] = encode_range(range);
						}
						if(merges.length) ws['!merges'] = merges;
						if(rowinfo.length) ws["!rows"] = rowinfo;
						sheetag.name = sheetag['名称'] || sheetag.name;
						if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
						intable = false;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0], false);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = opts.dense ? ([]) : ({}); merges = [];
						rowinfo = [];
						intable = true;
					}
					break;
	
				case 'table-row-group': // 9.1.9 <table:table-row-group>
					if(Rn[1] === "/") --row_ol; else ++row_ol;
					break;
				case 'table-row': case '行': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
					rowtag = parsexmltag(Rn[0], false);
					if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
					rowpeat = +rowtag['number-rows-repeated'] || 1;
					/* TODO: remove magic */
					if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
					C = -1; break;
				case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
					if(Rn[1] !== '/') ++C;
					if(opts.sheetStubs) {
						if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
						else ws[encode_cell({r:R,c:C})] = {t:'z'};
					}
					textp = ""; textR = [];
					break; /* stub */
				case 'table-cell': case '数据':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						++C;
						ctag = parsexmltag(Rn[0], false);
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						q = ({t:'z', v:null});
						if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
						if((ctag['数据类型'] || ctag['value-type']) == "string") {
							q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
							if(opts.dense) {
								if(!ws[R]) ws[R] = [];
								ws[R][C] = q;
							} else {
								ws[encode_cell({r:R,c:C})] = q;
							}
						}
						C+= colpeat-1;
					} else if(Rn[1]!=='/') {
						++C;
						textp = ""; textpidx = 0; textR = [];
						colpeat = 1;
						var rptR = rowpeat ? R + rowpeat - 1 : R;
						if(C > range.e.c) range.e.c = C;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						if(rptR > range.e.r) range.e.r = rptR;
						ctag = parsexmltag(Rn[0], false);
						comments = []; comment = ({});
						q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
						if(opts.cellFormula) {
							if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
							if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
								mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
								mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
								mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
								q.F = encode_range(mrange);
								arrayf.push([mrange, q.F]);
							}
							if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
							else for(i = 0; i < arrayf.length; ++i)
								if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
									if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
										q.F = arrayf[i][1];
						}
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
	
						/* 19.675.2 table:number-columns-repeated */
						if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
	
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
								if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
								q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
								if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
								q.z = 'HH:MM:SS'; break;
							case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
							default:
								if(q.t === 'string' || q.t === 'text' || !q.t) {
									q.t = 's';
									if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
								} else throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						isstub = false;
						if(q.t === 's') {
							q.v = textp || '';
							if(textR.length) q.R = textR;
							isstub = textpidx == 0;
						}
						if(atag.Target) q.l = atag;
						if(comments.length > 0) { q.c = comments; comments = []; }
						if(textp && opts.cellText !== false) q.w = textp;
						if(isstub) { q.t = "z"; delete q.v; }
						if(!isstub || opts.sheetStubs) {
							if(!(opts.sheetRows && opts.sheetRows <= R)) {
								for(var rpt = 0; rpt < rowpeat; ++rpt) {
									colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
									if(opts.dense) {
										if(!ws[R + rpt]) ws[R + rpt] = [];
										ws[R + rpt][C] = rpt == 0 ? q : dup(q);
										while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
									} else {
										ws[encode_cell({r:R + rpt,c:C})] = q;
										while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
									}
									if(range.e.c <= C) range.e.c = C;
								}
							}
						}
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						C += colpeat-1; colpeat = 0;
						q = {};
						textp = ""; textR = [];
					}
					atag = ({});
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document': // TODO: <office:document> is the root for FODS
				case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'styles': // TODO <office:styles>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
				case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				case 'annotation': // 14.1 <office:annotation>
					if(Rn[1]==='/'){
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
						comment.t = textp;
						if(textR.length) comment.R = textR;
						comment.a = creator;
						comments.push(comment);
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
					creator = ""; creatoridx = 0;
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'creator': // 4.3.2.7 <dc:creator>
					if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
					else creatoridx = Rn.index + Rn[0].length;
					break;
	
				/* ignore state */
				case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
				case 'settings': // TODO: <office:settings>
				case 'config-item-set': // TODO: <office:config-item-set>
				case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
				case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
				case 'config-item-map-named': // TODO: <office:config-item-map-entry>
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
				case 'text-box': // 10.4.3 <draw:text-box>
				case 'image': // 10.4.4 <draw:image>
				case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
				case 'list-style': // 16.30 <text:list-style>
				case 'form': // 13.13 <form:form>
				case 'dde-links': // 9.8 <table:dde-links>
				case 'event-listeners': // TODO
				case 'chart': // TODO
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'scientific-number': // TODO: <number:scientific-number>
					break;
				case 'currency-symbol': // TODO: <number:currency-symbol>
					break;
				case 'currency-style': // TODO: <number:currency-style>
					break;
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0], false);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'libraries': break; // TODO: <ooo:libraries>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
	
				case 'default-style': // TODO: <style:default-style>
				case 'page-layout': break; // TODO: <style:page-layout>
				case 'style': // 16.2 <style:style>
					break;
				case 'map': break; // 16.3 <style:map>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'fraction': break; // TODO 16.27.6 <number:fraction>
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
	
				case 'named-range': // 9.4.12 <table:named-range>
					tag = parsexmltag(Rn[0], false);
					_Ref = ods_to_csf_3D(tag['cell-range-address']);
					var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
					if(intable) nrange.Sheet = SheetNames.length;
					WB.Names.push(nrange);
					break;
	
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
				case 'embedded-text': break; // 16.27.4 <number:embedded-text>
	
				case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
				case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
				case 'table-rows': break; // 9.1.12 <table:table-rows>
				/* TODO: outline levels */
				case 'table-column-group': break; // 9.1.10 <table:table-column-group>
				case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
				case 'table-columns': break; // 9.1.12 <table:table-columns>
	
				case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904
	
				case 'graphic-properties': break; // 17.21 <style:graphic-properties>
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'label-range': break; // 9.4.9 <table:label-range>
				case 'label-ranges': break; // 9.4.10 <table:label-ranges>
				case 'named-expression': break; // 9.4.13 <table:named-expression>
				case 'sort': break; // 9.4.19 <table:sort>
				case 'sort-by': break; // 9.4.20 <table:sort-by>
				case 'sort-groups': break; // 9.4.22 <table:sort-groups>
	
				case 'tab': break; // 6.1.4 <text:tab>
				case 'line-break': break; // 6.1.5 <text:line-break>
				case 'span': break; // 6.1.7 <text:span>
				case 'p': case '文本串': // 5.1.3 <text:p>
					if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
					if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
						var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
						textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
					} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
	
				case 'database-range': // 9.4.15 <table:database-range>
					if(Rn[1]==='/') break;
					try {
						_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
						Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
					} catch(e) {/* empty */}
					break;
	
				case 'date': break; // <*:date>
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': case '标题': break; // <*:title> OR <uof:标题>
				case 'desc': break; // <*:desc>
				case 'binary-data': break; // 10.4.5 TODO: b64 blob
	
				/* 9.2 Advanced Tables */
				case 'table-source': break; // 9.2.6
				case 'scenario': break; // 9.2.6
	
				case 'iteration': break; // 9.4.3 <table:iteration>
				case 'content-validations': break; // 9.4.4 <table:
				case 'content-validation': break; // 9.4.5 <table:
				case 'help-message': break; // 9.4.6 <table:
				case 'error-message': break; // 9.4.7 <table:
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
	
				case 'list-level-style-bullet': break; // 16.31 <text:
				case 'list-level-style-number': break; // 16.32 <text:
				case 'list-level-properties': break; // 17.19 <style:
	
				/* 7.3 Document Fields */
				case 'sender-firstname': // 7.3.6.2
				case 'sender-lastname': // 7.3.6.3
				case 'sender-initials': // 7.3.6.4
				case 'sender-title': // 7.3.6.5
				case 'sender-position': // 7.3.6.6
				case 'sender-email': // 7.3.6.7
				case 'sender-phone-private': // 7.3.6.8
				case 'sender-fax': // 7.3.6.9
				case 'sender-company': // 7.3.6.10
				case 'sender-phone-work': // 7.3.6.11
				case 'sender-street': // 7.3.6.12
				case 'sender-city': // 7.3.6.13
				case 'sender-postal-code': // 7.3.6.14
				case 'sender-country': // 7.3.6.15
				case 'sender-state-or-province': // 7.3.6.16
				case 'author-name': // 7.3.7.1
				case 'author-initials': // 7.3.7.2
				case 'chapter': // 7.3.8
				case 'file-name': // 7.3.9
				case 'template-name': // 7.3.9
				case 'sheet-name': // 7.3.9
					break;
	
				case 'event-listener':
					break;
				/* TODO: FODS Properties */
				case 'initial-creator':
				case 'creation-date':
				case 'print-date':
				case 'generator':
				case 'document-statistic':
				case 'user-defined':
				case 'editing-duration':
				case 'editing-cycles':
					break;
	
				/* TODO: FODS Config */
				case 'config-item':
					break;
	
				/* TODO: style tokens */
				case 'page-number': break; // TODO <text:page-number>
				case 'page-count': break; // TODO <text:page-count>
				case 'time': break; // TODO <text:time>
	
				/* 9.3 Advanced Table Cells */
				case 'cell-range-source': break; // 9.3.1 <table:
				case 'detective': break; // 9.3.2 <table:
				case 'operation': break; // 9.3.3 <table:
				case 'highlighted-range': break; // 9.3.4 <table:
	
				/* 9.6 Data Pilot Tables <table: */
				case 'data-pilot-table': // 9.6.3
				case 'source-cell-range': // 9.6.5
				case 'source-service': // 9.6.6
				case 'data-pilot-field': // 9.6.7
				case 'data-pilot-level': // 9.6.8
				case 'data-pilot-subtotals': // 9.6.9
				case 'data-pilot-subtotal': // 9.6.10
				case 'data-pilot-members': // 9.6.11
				case 'data-pilot-member': // 9.6.12
				case 'data-pilot-display-info': // 9.6.13
				case 'data-pilot-sort-info': // 9.6.14
				case 'data-pilot-layout-info': // 9.6.15
				case 'data-pilot-field-reference': // 9.6.16
				case 'data-pilot-groups': // 9.6.17
				case 'data-pilot-group': // 9.6.18
				case 'data-pilot-group-member': // 9.6.19
					break;
	
				/* 10.3 Drawing Shapes */
				case 'rect': // 10.3.2
					break;
	
				/* 14.6 DDE Connections */
				case 'dde-connection-decls': // 14.6.2 <text:
				case 'dde-connection-decl': // 14.6.3 <text:
				case 'dde-link': // 14.6.4 <table:
				case 'dde-source': // 14.6.5 <office:
					break;
	
				case 'properties': break; // 13.7 <form:properties>
				case 'property': break; // 13.8 <form:property>
	
				case 'a': // 6.1.8 hyperlink
					if(Rn[1]!== '/') {
						atag = parsexmltag(Rn[0], false);
						if(!atag.href) break;
						atag.Target = unescapexml(atag.href); delete atag.href;
						if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
							_Ref = ods_to_csf_3D(atag.Target.slice(1));
							atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
						} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
					}
					break;
	
				/* non-standard */
				case 'table-protection': break;
				case 'data-pilot-grand-total': break; // <table:
				case 'office-document-common-attrs': break; // bare
				default: switch(Rn[2]) {
					case 'dc:':       // TODO: properties
					case 'calcext:':  // ignore undocumented extensions
					case 'loext:':    // ignore undocumented extensions
					case 'ooo:':      // ignore undocumented extensions
					case 'chartooo:': // ignore undocumented extensions
					case 'draw:':     // TODO: drawing
					case 'style:':    // TODO: styles
					case 'chart:':    // TODO: charts
					case 'form:':     // TODO: forms
					case 'uof:':      // TODO: uof
					case '表:':       // TODO: uof
					case '字:':       // TODO: uof
						break;
					default: if(opts.WTF) throw new Error(Rn);
				}
			}
			var out = ({
				Sheets: Sheets,
				SheetNames: SheetNames,
				Workbook: WB
			});
			if(opts.bookSheets) delete out.Sheets;
			return out;
	}
	
	function parse_ods(zip, opts) {
		opts = opts || ({});
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
		var content = getzipstr(zip, 'content.xml');
		if(!content) throw new Error("Missing content.xml in ODS / UOF file");
		var wb = parse_content_xml(utf8read(content), opts);
		if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
		return wb;
	}
	function parse_fods(data, opts) {
		return parse_content_xml(data, opts);
	}
	
	/* OpenDocument */
	var write_styles_ods = /* @__PURE__ */(function() {
		var master_styles = [
			'<office:master-styles>',
				'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
					'<style:header/>',
					'<style:header-left style:display="false"/>',
					'<style:footer/>',
					'<style:footer-left style:display="false"/>',
				'</style:master-page>',
			'</office:master-styles>'
		].join("");
	
		var payload = '<office:document-styles ' + wxt_helper({
			'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':    "http://www.w3.org/1999/xlink",
			'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
			'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'office:version': "1.2"
		}) + '>' + master_styles + '</office:document-styles>';
	
		return function wso() {
			return XML_HEADER + payload;
		};
	})();
	var write_content_ods = /* @__PURE__ */(function() {
		/* 6.1.2 White Space Characters */
		var write_text_p = function(text) {
			return escapexml(text)
				.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
				.replace(/\t/g, "<text:tab/>")
				.replace(/\n/g, "</text:p><text:p>")
				.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
		};
	
		var null_cell_xml = '          <table:table-cell />\n';
		var covered_cell_xml = '          <table:covered-table-cell/>\n';
		var write_ws = function(ws, wb, i) {
			/* Section 9 Tables */
			var o = [];
			o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
			var R=0,C=0, range = decode_range(ws['!ref']||"A1");
			var marr = ws['!merges'] || [], mi = 0;
			var dense = Array.isArray(ws);
			if(ws["!cols"]) {
				for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
			}
			var H = "", ROWS = ws["!rows"]||[];
			for(R = 0; R < range.s.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '></table:table-row>\n');
			}
			for(; R <= range.e.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '>\n');
				for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
				for(; C <= range.e.c; ++C) {
					var skip = false, ct = {}, textp = "";
					for(mi = 0; mi != marr.length; ++mi) {
						if(marr[mi].s.c > C) continue;
						if(marr[mi].s.r > R) continue;
						if(marr[mi].e.c < C) continue;
						if(marr[mi].e.r < R) continue;
						if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
						ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
						ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
						break;
					}
					if(skip) { o.push(covered_cell_xml); continue; }
					var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
					if(cell && cell.f) {
						ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
						if(cell.F) {
							if(cell.F.slice(0, ref.length) == ref) {
								var _Fref = decode_range(cell.F);
								ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
								ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
							}
						}
					}
					if(!cell) { o.push(null_cell_xml); continue; }
					switch(cell.t) {
						case 'b':
							textp = (cell.v ? 'TRUE' : 'FALSE');
							ct['office:value-type'] = "boolean";
							ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
							break;
						case 'n':
							textp = (cell.w||String(cell.v||0));
							ct['office:value-type'] = "float";
							ct['office:value'] = (cell.v||0);
							break;
						case 's': case 'str':
							textp = cell.v == null ? "" : cell.v;
							ct['office:value-type'] = "string";
							break;
						case 'd':
							textp = (cell.w||(parseDate(cell.v).toISOString()));
							ct['office:value-type'] = "date";
							ct['office:date-value'] = (parseDate(cell.v).toISOString());
							ct['table:style-name'] = "ce1";
							break;
						//case 'e':
						default: o.push(null_cell_xml); continue;
					}
					var text_p = write_text_p(textp);
					if(cell.l && cell.l.Target) {
						var _tgt = cell.l.Target;
						_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
						// TODO: choose correct parent path format based on link delimiters
						if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
						text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
					}
					o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
				}
				o.push('        </table:table-row>\n');
			}
			o.push('      </table:table>\n');
			return o.join("");
		};
	
		var write_automatic_styles_ods = function(o, wb) {
			o.push(' <office:automatic-styles>\n');
	
			o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
			o.push('   <number:month number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:day number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:year/>\n');
			o.push('  </number:date-style>\n');
	
			/* column styles */
			var cidx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!cols"]) {
					for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
						var colobj = ws["!cols"][C];
						if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
						process_col(colobj);
						colobj.ods = cidx;
						var w = ws["!cols"][C].wpx + "px";
						o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
						o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
						o.push('  </style:style>\n');
						++cidx;
					}
				}
			});
	
			/* row styles */
			var ridx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!rows"]) {
					for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
						ws["!rows"][R].ods = ridx;
						var h = ws["!rows"][R].hpx + "px";
						o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
						o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
						o.push('  </style:style>\n');
						++ridx;
					}
				}
			});
	
			/* table */
			o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
			o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
			o.push('  </style:style>\n');
	
			/* table cells, text */
			o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
	
			/* page-layout */
	
			o.push(' </office:automatic-styles>\n');
		};
	
		return function wcx(wb, opts) {
			var o = [XML_HEADER];
			/* 3.1.3.2 */
			var attr = wxt_helper({
				'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
				'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
				'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
				'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
				'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
				'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
				'xmlns:xlink':        "http://www.w3.org/1999/xlink",
				'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
				'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
				'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
				'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
				'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
				'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
				'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
				'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
				'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
				'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
				'xmlns:ooo':          "http://openoffice.org/2004/office",
				'xmlns:ooow':         "http://openoffice.org/2004/writer",
				'xmlns:oooc':         "http://openoffice.org/2004/calc",
				'xmlns:dom':          "http://www.w3.org/2001/xml-events",
				'xmlns:xforms':       "http://www.w3.org/2002/xforms",
				'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
				'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
				'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
				'xmlns:rpt':          "http://openoffice.org/2005/report",
				'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
				'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
				'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
				'xmlns:tableooo':     "http://openoffice.org/2009/table",
				'xmlns:drawooo':      "http://openoffice.org/2010/draw",
				'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
				'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
				'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
				'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
				'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
				'office:version':     "1.2"
			});
	
			var fods = wxt_helper({
				'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
				'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
			});
	
			if(opts.bookType == "fods") {
				o.push('<office:document' + attr + fods + '>\n');
				o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
				// TODO: settings (equiv of settings.xml for ODS)
			} else o.push('<office:document-content' + attr  + '>\n');
			// o.push('  <office:scripts/>\n');
			write_automatic_styles_ods(o, wb);
			o.push('  <office:body>\n');
			o.push('    <office:spreadsheet>\n');
			for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
			o.push('    </office:spreadsheet>\n');
			o.push('  </office:body>\n');
			if(opts.bookType == "fods") o.push('</office:document>');
			else o.push('</office:document-content>');
			return o.join("");
		};
	})();
	
	function write_ods(wb, opts) {
		if(opts.bookType == "fods") return write_content_ods(wb, opts);
	
		var zip = zip_new();
		var f = "";
	
		var manifest = [];
		var rdf = [];
	
		/* Part 3 Section 3.3 MIME Media Type */
		f = "mimetype";
		zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
	
		/* Part 1 Section 2.2 Documents */
		f = "content.xml";
		zip_add_file(zip, f, write_content_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "ContentFile"]);
	
		/* TODO: these are hard-coded styles to satiate excel */
		f = "styles.xml";
		zip_add_file(zip, f, write_styles_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "StylesFile"]);
	
		/* TODO: this is hard-coded to satiate excel */
		f = "meta.xml";
		zip_add_file(zip, f, XML_HEADER + write_meta_ods());
		manifest.push([f, "text/xml"]);
		rdf.push([f, "MetadataFile"]);
	
		/* Part 3 Section 6 Metadata Manifest File */
		f = "manifest.rdf";
		zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
		manifest.push([f, "application/rdf+xml"]);
	
		/* Part 3 Section 4 Manifest File */
		f = "META-INF/manifest.xml";
		zip_add_file(zip, f, write_manifest(manifest/*, opts*/));
	
		return zip;
	}
	
	/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
	function u8_to_dataview(array) {
	  return new DataView(array.buffer, array.byteOffset, array.byteLength);
	}
	function u8str(u8) {
	  return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
	}
	function stru8(str) {
	  return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : s2a(utf8write(str));
	}
	function u8contains(body, search) {
	  outer:
	    for (var L = 0; L <= body.length - search.length; ++L) {
	      for (var j = 0; j < search.length; ++j)
	        if (body[L + j] != search[j])
	          continue outer;
	      return true;
	    }
	  return false;
	}
	function u8concat(u8a) {
	  var len = u8a.reduce(function(acc, x) {
	    return acc + x.length;
	  }, 0);
	  var out = new Uint8Array(len);
	  var off = 0;
	  u8a.forEach(function(u8) {
	    out.set(u8, off);
	    off += u8.length;
	  });
	  return out;
	}
	function popcnt(x) {
	  x -= x >> 1 & 1431655765;
	  x = (x & 858993459) + (x >> 2 & 858993459);
	  return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
	}
	function readDecimal128LE(buf, offset) {
	  var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
	  var mantissa = buf[offset + 14] & 1;
	  for (var j = offset + 13; j >= offset; --j)
	    mantissa = mantissa * 256 + buf[j];
	  return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
	}
	function writeDecimal128LE(buf, offset, value) {
	  var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
	  var mantissa = value / Math.pow(10, exp - 6176);
	  buf[offset + 15] |= exp >> 7;
	  buf[offset + 14] |= (exp & 127) << 1;
	  for (var i = 0; mantissa >= 1; ++i, mantissa /= 256)
	    buf[offset + i] = mantissa & 255;
	  buf[offset + 15] |= value >= 0 ? 0 : 128;
	}
	function parse_varint49(buf, ptr) {
	  var l = ptr ? ptr[0] : 0;
	  var usz = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      usz |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 28);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 35);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 42);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	    }
	  if (ptr)
	    ptr[0] = l;
	  return usz;
	}
	function write_varint49(v) {
	  var usz = new Uint8Array(7);
	  usz[0] = v & 127;
	  var L = 1;
	  sz:
	    if (v > 127) {
	      usz[L - 1] |= 128;
	      usz[L] = v >> 7 & 127;
	      ++L;
	      if (v <= 16383)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 14 & 127;
	      ++L;
	      if (v <= 2097151)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 21 & 127;
	      ++L;
	      if (v <= 268435455)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 256 >>> 21 & 127;
	      ++L;
	      if (v <= 34359738367)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 65536 >>> 21 & 127;
	      ++L;
	      if (v <= 4398046511103)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 16777216 >>> 21 & 127;
	      ++L;
	    }
	  return usz.slice(0, L);
	}
	function varint_to_i32(buf) {
	  var l = 0, i32 = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      i32 |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 28;
	    }
	  return i32;
	}
	function parse_shallow(buf) {
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var off = ptr[0];
	    var num = parse_varint49(buf, ptr);
	    var type = num & 7;
	    num = Math.floor(num / 8);
	    var len = 0;
	    var res;
	    if (num == 0)
	      break;
	    switch (type) {
	      case 0:
	        {
	          var l = ptr[0];
	          while (buf[ptr[0]++] >= 128)
	            ;
	          res = buf.slice(l, ptr[0]);
	        }
	        break;
	      case 5:
	        len = 4;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 1:
	        len = 8;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 2:
	        len = parse_varint49(buf, ptr);
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 3:
	      case 4:
	      default:
	        throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
	    }
	    var v = { data: res, type: type };
	    if (out[num] == null)
	      out[num] = [v];
	    else
	      out[num].push(v);
	  }
	  return out;
	}
	function write_shallow(proto) {
	  var out = [];
	  proto.forEach(function(field, idx) {
	    field.forEach(function(item) {
	      if (!item.data)
	        return;
	      out.push(write_varint49(idx * 8 + item.type));
	      if (item.type == 2)
	        out.push(write_varint49(item.data.length));
	      out.push(item.data);
	    });
	  });
	  return u8concat(out);
	}
	function mappa(data, cb) {
	  return (data == null ? void 0 : data.map(function(d) {
	    return cb(d.data);
	  })) || [];
	}
	function parse_iwa_file(buf) {
	  var _a;
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var len = parse_varint49(buf, ptr);
	    var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
	    ptr[0] += len;
	    var res = {
	      id: varint_to_i32(ai[1][0].data),
	      messages: []
	    };
	    ai[2].forEach(function(b) {
	      var mi = parse_shallow(b.data);
	      var fl = varint_to_i32(mi[3][0].data);
	      res.messages.push({
	        meta: mi,
	        data: buf.slice(ptr[0], ptr[0] + fl)
	      });
	      ptr[0] += fl;
	    });
	    if ((_a = ai[3]) == null ? void 0 : _a[0])
	      res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
	    out.push(res);
	  }
	  return out;
	}
	function write_iwa_file(ias) {
	  var bufs = [];
	  ias.forEach(function(ia) {
	    var ai = [];
	    ai[1] = [{ data: write_varint49(ia.id), type: 0 }];
	    ai[2] = [];
	    if (ia.merge != null)
	      ai[3] = [{ data: write_varint49(+!!ia.merge), type: 0 }];
	    var midata = [];
	    ia.messages.forEach(function(mi) {
	      midata.push(mi.data);
	      mi.meta[3] = [{ type: 0, data: write_varint49(mi.data.length) }];
	      ai[2].push({ data: write_shallow(mi.meta), type: 2 });
	    });
	    var aipayload = write_shallow(ai);
	    bufs.push(write_varint49(aipayload.length));
	    bufs.push(aipayload);
	    midata.forEach(function(mid) {
	      return bufs.push(mid);
	    });
	  });
	  return u8concat(bufs);
	}
	function parse_snappy_chunk(type, buf) {
	  if (type != 0)
	    throw new Error("Unexpected Snappy chunk type ".concat(type));
	  var ptr = [0];
	  var usz = parse_varint49(buf, ptr);
	  var chunks = [];
	  while (ptr[0] < buf.length) {
	    var tag = buf[ptr[0]] & 3;
	    if (tag == 0) {
	      var len = buf[ptr[0]++] >> 2;
	      if (len < 60)
	        ++len;
	      else {
	        var c = len - 59;
	        len = buf[ptr[0]];
	        if (c > 1)
	          len |= buf[ptr[0] + 1] << 8;
	        if (c > 2)
	          len |= buf[ptr[0] + 2] << 16;
	        if (c > 3)
	          len |= buf[ptr[0] + 3] << 24;
	        len >>>= 0;
	        len++;
	        ptr[0] += c;
	      }
	      chunks.push(buf.slice(ptr[0], ptr[0] + len));
	      ptr[0] += len;
	      continue;
	    } else {
	      var offset = 0, length = 0;
	      if (tag == 1) {
	        length = (buf[ptr[0]] >> 2 & 7) + 4;
	        offset = (buf[ptr[0]++] & 224) << 3;
	        offset |= buf[ptr[0]++];
	      } else {
	        length = (buf[ptr[0]++] >> 2) + 1;
	        if (tag == 2) {
	          offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
	          ptr[0] += 2;
	        } else {
	          offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
	          ptr[0] += 4;
	        }
	      }
	      chunks = [u8concat(chunks)];
	      if (offset == 0)
	        throw new Error("Invalid offset 0");
	      if (offset > chunks[0].length)
	        throw new Error("Invalid offset beyond length");
	      if (length >= offset) {
	        chunks.push(chunks[0].slice(-offset));
	        length -= offset;
	        while (length >= chunks[chunks.length - 1].length) {
	          chunks.push(chunks[chunks.length - 1]);
	          length -= chunks[chunks.length - 1].length;
	        }
	      }
	      chunks.push(chunks[0].slice(-offset, -offset + length));
	    }
	  }
	  var o = u8concat(chunks);
	  if (o.length != usz)
	    throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
	  return o;
	}
	function decompress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var t = buf[l++];
	    var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
	    l += 3;
	    out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
	    l += len;
	  }
	  if (l !== buf.length)
	    throw new Error("data is not a valid framed stream!");
	  return u8concat(out);
	}
	function compress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var c = Math.min(buf.length - l, 268435455);
	    var frame = new Uint8Array(4);
	    out.push(frame);
	    var usz = write_varint49(c);
	    var L = usz.length;
	    out.push(usz);
	    if (c <= 60) {
	      L++;
	      out.push(new Uint8Array([c - 1 << 2]));
	    } else if (c <= 256) {
	      L += 2;
	      out.push(new Uint8Array([240, c - 1 & 255]));
	    } else if (c <= 65536) {
	      L += 3;
	      out.push(new Uint8Array([244, c - 1 & 255, c - 1 >> 8 & 255]));
	    } else if (c <= 16777216) {
	      L += 4;
	      out.push(new Uint8Array([248, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255]));
	    } else if (c <= 4294967296) {
	      L += 5;
	      out.push(new Uint8Array([252, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255, c - 1 >>> 24 & 255]));
	    }
	    out.push(buf.slice(l, l + c));
	    L += c;
	    frame[0] = 0;
	    frame[1] = L & 255;
	    frame[2] = L >> 8 & 255;
	    frame[3] = L >> 16 & 255;
	    l += c;
	  }
	  return u8concat(out);
	}
	function parse_old_storage(buf, sst, rsst, v) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(4, true);
	  var data_offset = (v > 1 ? 12 : 8) + popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
	  var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 512) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  data_offset += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
	  if (flags & 16) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 32) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 64) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  var ret;
	  switch (buf[2]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: ieee };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else if (sidx > -1)
	          ret = { t: "s", v: sst[sidx] };
	        else if (!isNaN(ieee))
	          ret = { t: "n", v: ieee };
	        else
	          throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	      }
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function parse_new_storage(buf, sst, rsst) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(8, true);
	  var data_offset = 12;
	  var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 1) {
	    d128 = readDecimal128LE(buf, data_offset);
	    data_offset += 16;
	  }
	  if (flags & 2) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 4) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  if (flags & 8) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 16) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  var ret;
	  switch (buf[1]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: d128 };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else
	          throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	      }
	      break;
	    case 10:
	      ret = { t: "n", v: d128 };
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function write_new_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 5;
	  switch (cell.t) {
	    case "n":
	      out[1] = 2;
	      writeDecimal128LE(out, l, cell.v);
	      flags |= 1;
	      l += 16;
	      break;
	    case "b":
	      out[1] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 2;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[1] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 8;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(8, flags, true);
	  return out.slice(0, l);
	}
	function write_old_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 3;
	  switch (cell.t) {
	    case "n":
	      out[2] = 2;
	      dv.setFloat64(l, cell.v, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "b":
	      out[2] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[2] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 16;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(4, flags, true);
	  return out.slice(0, l);
	}
	function parse_cell_storage(buf, sst, rsst) {
	  switch (buf[0]) {
	    case 0:
	    case 1:
	    case 2:
	    case 3:
	      return parse_old_storage(buf, sst, rsst, buf[0]);
	    case 5:
	      return parse_new_storage(buf, sst, rsst);
	    default:
	      throw new Error("Unsupported payload version ".concat(buf[0]));
	  }
	}
	function parse_TSP_Reference(buf) {
	  var pb = parse_shallow(buf);
	  return parse_varint49(pb[1][0].data);
	}
	function write_TSP_Reference(idx) {
	  var out = [];
	  out[1] = [{ type: 0, data: write_varint49(idx) }];
	  return write_shallow(out);
	}
	function parse_TST_TableDataList(M, root) {
	  var pb = parse_shallow(root.data);
	  var type = varint_to_i32(pb[1][0].data);
	  var entries = pb[3];
	  var data = [];
	  (entries || []).forEach(function(entry) {
	    var le = parse_shallow(entry.data);
	    var key = varint_to_i32(le[1][0].data) >>> 0;
	    switch (type) {
	      case 1:
	        data[key] = u8str(le[3][0].data);
	        break;
	      case 8:
	        {
	          var rt = M[parse_TSP_Reference(le[9][0].data)][0];
	          var rtp = parse_shallow(rt.data);
	          var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
	          var mtype = varint_to_i32(rtpref.meta[1][0].data);
	          if (mtype != 2001)
	            throw new Error("2000 unexpected reference to ".concat(mtype));
	          var tswpsa = parse_shallow(rtpref.data);
	          data[key] = tswpsa[3].map(function(x) {
	            return u8str(x.data);
	          }).join("");
	        }
	        break;
	    }
	  });
	  return data;
	}
	function parse_TST_TileRowInfo(u8, type) {
	  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
	  var pb = parse_shallow(u8);
	  var R = varint_to_i32(pb[1][0].data) >>> 0;
	  var cnt = varint_to_i32(pb[2][0].data) >>> 0;
	  var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
	  var used_storage_u8, used_storage;
	  if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
	    used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
	    used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
	  } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
	    used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
	    used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
	  } else
	    throw "NUMBERS Tile missing ".concat(type, " cell storage");
	  var width = wide_offsets ? 4 : 1;
	  var used_storage_offsets = u8_to_dataview(used_storage_u8);
	  var offsets = [];
	  for (var C = 0; C < used_storage_u8.length / 2; ++C) {
	    var off = used_storage_offsets.getUint16(C * 2, true);
	    if (off < 65535)
	      offsets.push([C, off]);
	  }
	  if (offsets.length != cnt)
	    throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
	  var cells = [];
	  for (C = 0; C < offsets.length - 1; ++C)
	    cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
	  if (offsets.length >= 1)
	    cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
	  return { R: R, cells: cells };
	}
	function parse_TST_Tile(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
	  var ri = mappa(pb[5], function(u8) {
	    return parse_TST_TileRowInfo(u8, storage);
	  });
	  return {
	    nrows: varint_to_i32(pb[4][0].data) >>> 0,
	    data: ri.reduce(function(acc, x) {
	      if (!acc[x.R])
	        acc[x.R] = [];
	      x.cells.forEach(function(cell, C) {
	        if (acc[x.R][C])
	          throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
	        acc[x.R][C] = cell;
	      });
	      return acc;
	    }, [])
	  };
	}
	function parse_TST_TableModelArchive(M, root, ws) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
	  range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
	  if (range.e.r < 0)
	    throw new Error("Invalid row varint ".concat(pb[6][0].data));
	  range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
	  if (range.e.c < 0)
	    throw new Error("Invalid col varint ".concat(pb[7][0].data));
	  ws["!ref"] = encode_range(range);
	  var store = parse_shallow(pb[4][0].data);
	  var sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
	  var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]) : [];
	  var tile = parse_shallow(store[3][0].data);
	  var _R = 0;
	  tile[1].forEach(function(t) {
	    var tl = parse_shallow(t.data);
	    var ref = M[parse_TSP_Reference(tl[2][0].data)][0];
	    var mtype = varint_to_i32(ref.meta[1][0].data);
	    if (mtype != 6002)
	      throw new Error("6001 unexpected reference to ".concat(mtype));
	    var _tile = parse_TST_Tile(M, ref);
	    _tile.data.forEach(function(row, R) {
	      row.forEach(function(buf, C) {
	        var addr = encode_cell({ r: _R + R, c: C });
	        var res = parse_cell_storage(buf, sst, rsst);
	        if (res)
	          ws[addr] = res;
	      });
	    });
	    _R += _tile.nrows;
	  });
	}
	function parse_TST_TableInfoArchive(M, root) {
	  var pb = parse_shallow(root.data);
	  var out = { "!ref": "A1" };
	  var tableref = M[parse_TSP_Reference(pb[2][0].data)];
	  var mtype = varint_to_i32(tableref[0].meta[1][0].data);
	  if (mtype != 6001)
	    throw new Error("6000 unexpected reference to ".concat(mtype));
	  parse_TST_TableModelArchive(M, tableref[0], out);
	  return out;
	}
	function parse_TN_SheetArchive(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var out = {
	    name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
	    sheets: []
	  };
	  var shapeoffs = mappa(pb[2], parse_TSP_Reference);
	  shapeoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 6e3)
	        out.sheets.push(parse_TST_TableInfoArchive(M, m));
	    });
	  });
	  return out;
	}
	function parse_TN_DocumentArchive(M, root) {
	  var out = book_new();
	  var pb = parse_shallow(root.data);
	  var sheetoffs = mappa(pb[1], parse_TSP_Reference);
	  sheetoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 2) {
	        var root2 = parse_TN_SheetArchive(M, m);
	        root2.sheets.forEach(function(sheet, idx) {
	          book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
	        });
	      }
	    });
	  });
	  if (out.SheetNames.length == 0)
	    throw new Error("Empty NUMBERS file");
	  return out;
	}
	function parse_numbers_iwa(cfb) {
	  var _a, _b, _c, _d;
	  var M = {}, indices = [];
	  cfb.FullPaths.forEach(function(p) {
	    if (p.match(/\.iwpv2/))
	      throw new Error("Unsupported password protection");
	  });
	  cfb.FileIndex.forEach(function(s) {
	    if (!s.name.match(/\.iwa$/))
	      return;
	    var o;
	    try {
	      o = decompress_iwa_file(s.content);
	    } catch (e) {
	      return console.log("?? " + s.content.length + " " + (e.message || e));
	    }
	    var packets;
	    try {
	      packets = parse_iwa_file(o);
	    } catch (e) {
	      return console.log("## " + (e.message || e));
	    }
	    packets.forEach(function(packet) {
	      M[packet.id] = packet.messages;
	      indices.push(packet.id);
	    });
	  });
	  if (!indices.length)
	    throw new Error("File has no messages");
	  var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
	  if (!docroot)
	    indices.forEach(function(idx) {
	      M[idx].forEach(function(iwam) {
	        var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
	        if (mtype == 1) {
	          if (!docroot)
	            docroot = iwam;
	          else
	            throw new Error("Document has multiple roots");
	        }
	      });
	    });
	  if (!docroot)
	    throw new Error("Cannot find Document root");
	  return parse_TN_DocumentArchive(M, docroot);
	}
	function write_tile_row(tri, data, SST) {
	  var _a, _b, _c, _d;
	  if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0]))
	    throw "Mutation only works on post-BNC storages!";
	  var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && varint_to_i32(tri[8][0].data) > 0 || false;
	  if (wide_offsets)
	    throw "Math only works with normal offsets";
	  var cnt = 0;
	  var dv = u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
	  var _dv = u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
	  for (var C = 0; C < data.length; ++C) {
	    if (data[C] == null) {
	      dv.setUint16(C * 2, 65535, true);
	      _dv.setUint16(C * 2, 65535);
	      continue;
	    }
	    dv.setUint16(C * 2, last_offset, true);
	    _dv.setUint16(C * 2, _last_offset, true);
	    var celload, _celload;
	    switch (typeof data[C]) {
	      case "string":
	        celload = write_new_storage({ t: "s", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "s", v: data[C] }, SST);
	        break;
	      case "number":
	        celload = write_new_storage({ t: "n", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "n", v: data[C] }, SST);
	        break;
	      case "boolean":
	        celload = write_new_storage({ t: "b", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "b", v: data[C] }, SST);
	        break;
	      default:
	        throw new Error("Unsupported value " + data[C]);
	    }
	    cell_storage.push(celload);
	    last_offset += celload.length;
	    _cell_storage.push(_celload);
	    _last_offset += _celload.length;
	    ++cnt;
	  }
	  tri[2][0].data = write_varint49(cnt);
	  for (; C < tri[7][0].data.length / 2; ++C) {
	    dv.setUint16(C * 2, 65535, true);
	    _dv.setUint16(C * 2, 65535, true);
	  }
	  tri[6][0].data = u8concat(cell_storage);
	  tri[3][0].data = u8concat(_cell_storage);
	  return cnt;
	}
	function write_numbers_iwa(wb, opts) {
	  if (!opts || !opts.numbers)
	    throw new Error("Must pass a `numbers` option -- check the README");
	  var ws = wb.Sheets[wb.SheetNames[0]];
	  if (wb.SheetNames.length > 1)
	    console.error("The Numbers writer currently writes only the first table");
	  var range = decode_range(ws["!ref"]);
	  range.s.r = range.s.c = 0;
	  var trunc = false;
	  if (range.e.c > 9) {
	    trunc = true;
	    range.e.c = 9;
	  }
	  if (range.e.r > 49) {
	    trunc = true;
	    range.e.r = 49;
	  }
	  if (trunc)
	    console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));
	  var data = sheet_to_json(ws, { range: range, header: 1 });
	  var SST = ["~Sh33tJ5~"];
	  data.forEach(function(row) {
	    return row.forEach(function(cell) {
	      if (typeof cell == "string")
	        SST.push(cell);
	    });
	  });
	  var dependents = {};
	  var indices = [];
	  var cfb = CFB.read(opts.numbers, { type: "base64" });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (fi.type != 2)
	      return;
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var old_content = fi.content;
	    var raw1 = decompress_iwa_file(old_content);
	    var x2 = parse_iwa_file(raw1);
	    x2.forEach(function(packet2) {
	      indices.push(packet2.id);
	      dependents[packet2.id] = { deps: [], location: fp, type: varint_to_i32(packet2.messages[0].meta[1][0].data) };
	    });
	  });
	  indices.sort(function(x2, y2) {
	    return x2 - y2;
	  });
	  var indices_varint = indices.filter(function(x2) {
	    return x2 > 1;
	  }).map(function(x2) {
	    return [x2, write_varint49(x2)];
	  });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var x2 = parse_iwa_file(decompress_iwa_file(fi.content));
	    x2.forEach(function(ia) {
	      ia.messages.forEach(function(m) {
	        indices_varint.forEach(function(ivi) {
	          if (ia.messages.some(function(mess) {
	            return varint_to_i32(mess.meta[1][0].data) != 11006 && u8contains(mess.data, ivi[1]);
	          })) {
	            dependents[ivi[0]].deps.push(ia.id);
	          }
	        });
	      });
	    });
	  });
	  function get_unique_msgid() {
	    for (var i = 927262; i < 2e6; ++i)
	      if (!dependents[i])
	        return i;
	    throw new Error("Too many messages");
	  }
	  var entry = CFB.find(cfb, dependents[1].location);
	  var x = parse_iwa_file(decompress_iwa_file(entry.content));
	  var docroot;
	  for (var xi = 0; xi < x.length; ++xi) {
	    var packet = x[xi];
	    if (packet.id == 1)
	      docroot = packet;
	  }
	  var sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  var pb = parse_shallow(docroot.messages[0].data);
	  {
	    pb[6][0].data = write_varint49(range.e.r + 1);
	    pb[7][0].data = write_varint49(range.e.c + 1);
	    var cruidsref = parse_TSP_Reference(pb[46][0].data);
	    var oldbucket = CFB.find(cfb, dependents[cruidsref].location);
	    var _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	    {
	      for (var j = 0; j < _x.length; ++j) {
	        if (_x[j].id == cruidsref)
	          break;
	      }
	      if (_x[j].id != cruidsref)
	        throw "Bad ColumnRowUIDMapArchive";
	      var cruids = parse_shallow(_x[j].messages[0].data);
	      cruids[1] = [];
	      cruids[2] = [], cruids[3] = [];
	      for (var C = 0; C <= range.e.c; ++C) {
	        var uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(C + 420690) }];
	        cruids[1].push({ type: 2, data: write_shallow(uuid) });
	        cruids[2].push({ type: 0, data: write_varint49(C) });
	        cruids[3].push({ type: 0, data: write_varint49(C) });
	      }
	      cruids[4] = [];
	      cruids[5] = [], cruids[6] = [];
	      for (var R = 0; R <= range.e.r; ++R) {
	        uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(R + 726270) }];
	        cruids[4].push({ type: 2, data: write_shallow(uuid) });
	        cruids[5].push({ type: 0, data: write_varint49(R) });
	        cruids[6].push({ type: 0, data: write_varint49(R) });
	      }
	      _x[j].messages[0].data = write_shallow(cruids);
	    }
	    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	    oldbucket.size = oldbucket.content.length;
	    delete pb[46];
	    var store = parse_shallow(pb[4][0].data);
	    {
	      store[7][0].data = write_varint49(range.e.r + 1);
	      var row_headers = parse_shallow(store[1][0].data);
	      var row_header_ref = parse_TSP_Reference(row_headers[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[row_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != row_header_ref)
	          throw "Bad HeaderStorageBucket";
	        var base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (R = 0; R < data.length; ++R) {
	          var _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(R);
	          _bucket[4][0].data = write_varint49(data[R].length);
	          base_bucket[2][R] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var col_header_ref = parse_TSP_Reference(store[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[col_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != col_header_ref)
	          throw "Bad HeaderStorageBucket";
	        base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (C = 0; C <= range.e.c; ++C) {
	          _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(C);
	          _bucket[4][0].data = write_varint49(range.e.r + 1);
	          base_bucket[2][C] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var sstref = parse_TSP_Reference(store[4][0].data);
	      (function() {
	        var sentry = CFB.find(cfb, dependents[sstref].location);
	        var sx = parse_iwa_file(decompress_iwa_file(sentry.content));
	        var sstroot;
	        for (var sxi = 0; sxi < sx.length; ++sxi) {
	          var packet2 = sx[sxi];
	          if (packet2.id == sstref)
	            sstroot = packet2;
	        }
	        var sstdata = parse_shallow(sstroot.messages[0].data);
	        {
	          sstdata[3] = [];
	          var newsst = [];
	          SST.forEach(function(str, i) {
	            newsst[1] = [{ type: 0, data: write_varint49(i) }];
	            newsst[2] = [{ type: 0, data: write_varint49(1) }];
	            newsst[3] = [{ type: 2, data: stru8(str) }];
	            sstdata[3].push({ type: 2, data: write_shallow(newsst) });
	          });
	        }
	        sstroot.messages[0].data = write_shallow(sstdata);
	        var sy = write_iwa_file(sx);
	        var raw32 = compress_iwa_file(sy);
	        sentry.content = raw32;
	        sentry.size = sentry.content.length;
	      })();
	      var tile = parse_shallow(store[3][0].data);
	      {
	        var t = tile[1][0];
	        delete tile[2];
	        var tl = parse_shallow(t.data);
	        {
	          var tileref = parse_TSP_Reference(tl[2][0].data);
	          (function() {
	            var tentry = CFB.find(cfb, dependents[tileref].location);
	            var tx = parse_iwa_file(decompress_iwa_file(tentry.content));
	            var tileroot;
	            for (var sxi = 0; sxi < tx.length; ++sxi) {
	              var packet2 = tx[sxi];
	              if (packet2.id == tileref)
	                tileroot = packet2;
	            }
	            var tiledata = parse_shallow(tileroot.messages[0].data);
	            {
	              delete tiledata[6];
	              delete tile[7];
	              var rowload = new Uint8Array(tiledata[5][0].data);
	              tiledata[5] = [];
	              var cnt = 0;
	              for (var R2 = 0; R2 <= range.e.r; ++R2) {
	                var tilerow = parse_shallow(rowload);
	                cnt += write_tile_row(tilerow, data[R2], SST);
	                tilerow[1][0].data = write_varint49(R2);
	                tiledata[5].push({ data: write_shallow(tilerow), type: 2 });
	              }
	              tiledata[1] = [{ type: 0, data: write_varint49(range.e.c + 1) }];
	              tiledata[2] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	              tiledata[3] = [{ type: 0, data: write_varint49(cnt) }];
	              tiledata[4] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	            }
	            tileroot.messages[0].data = write_shallow(tiledata);
	            var ty = write_iwa_file(tx);
	            var raw32 = compress_iwa_file(ty);
	            tentry.content = raw32;
	            tentry.size = tentry.content.length;
	          })();
	        }
	        t.data = write_shallow(tl);
	      }
	      store[3][0].data = write_shallow(tile);
	    }
	    pb[4][0].data = write_shallow(store);
	  }
	  docroot.messages[0].data = write_shallow(pb);
	  var y = write_iwa_file(x);
	  var raw3 = compress_iwa_file(y);
	  entry.content = raw3;
	  entry.size = entry.content.length;
	  return cfb;
	}
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	function fix_read_opts(opts) {
	fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellText', true], /* emit formatted text as .w */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	
	function fix_write_opts(opts) {
	fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['compression', false], /* Use file compression */
	
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	function get_sheet_type(n) {
		if(RELS.WS.indexOf(n) > -1) return "sheet";
		if(RELS.CS && n == RELS.CS) return "chart";
		if(RELS.DS && n == RELS.DS) return "dialog";
		if(RELS.MS && n == RELS.MS) return "macro";
		return (n && n.length) ? n : "sheet";
	}
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
		try {
			sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
			var data = getzipdata(zip, path);
			var _ws;
			switch(stype) {
				case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
					if(!_ws || !_ws['!drawel']) break;
					var dfile = resolve_path(_ws['!drawel'].Target, path);
					var drelsp = get_rels_path(dfile);
					var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
					var chartp = resolve_path(draw, dfile);
					var crelsp = get_rels_path(chartp);
					_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
					break;
				case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				default: throw new Error("Unrecognized sheet type " + stype);
			}
			sheets[sheet] = _ws;
	
			/* scan rels for comments and threaded comments */
			var tcomments = [];
			if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
				var dfile = "";
				if(sheetRels[sheet][n].Type == RELS.CMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					var comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
					if(!comments || !comments.length) return;
					sheet_insert_comments(_ws, comments, false);
				}
				if(sheetRels[sheet][n].Type == RELS.TCMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
				}
			});
			if(tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }
	
	function parse_zip(zip, opts) {
		make_ssf();
		opts = opts || {};
		fix_read_opts(opts);
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
		/* UOC */
		if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
		/* Numbers */
		if(safegetzipfile(zip, 'Index/Document.iwa')) {
			if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
			if(typeof parse_numbers_iwa != "undefined") {
				if(zip.FileIndex) return parse_numbers_iwa(zip);
				var _zip = CFB.utils.cfb_new();
				zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
				return parse_numbers_iwa(_zip);
			}
			throw new Error('Unsupported NUMBERS file');
		}
		if(!safegetzipfile(zip, '[Content_Types].xml')) {
			if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
			if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
			throw new Error('Unsupported ZIP file');
		}
	
		var entries = zipentries(zip);
		var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;
	
		var themes = ({});
		var styles = ({});
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }
	
			if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);
	
			if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
		}
	
		/*var externbooks = */dir.links.map(function(link) {
			try {
				var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
				return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
			} catch(e) {}
		});
	
		var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length) {
			propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
				if(propdata) parse_ext_props(propdata, props, opts);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = ({});
		if(opts.bookSheets || opts.bookProps) {
			if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = ({});
		var path, relsPath;
	
		{
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsi = dir.workbooks[0].lastIndexOf("/");
		var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
		if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
	
		if((dir.metadata || []).length >= 1) {
			/* TODO: MDX and other types of metadata */
			opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);
		}
	
		if((dir.people || []).length >= 1) {
			opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])),opts);
		}
	
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
	
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		wsloop: for(i = 0; i != props.Worksheets; ++i) {
			var stype = "sheet";
			if(wbrels && wbrels[i]) {
				path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
				if(!safegetzipfile(zip, path)) path = wbrels[i][1];
				if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
				stype = wbrels[i][2];
			} else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			if(opts && opts.sheets != null) switch(typeof opts.sheets) {
				case "number": if(i != opts.sheets) continue wsloop; break;
				case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
				default: if(Array.isArray && Array.isArray(opts.sheets)) {
					var snjseen = false;
					for(var snj = 0; snj != opts.sheets.length; ++snj) {
						if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
						if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
					}
					if(!snjseen) continue wsloop;
				}
			}
			safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
		}
	
		out = ({
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: dup(table_fmt)
		});
		if(opts && opts.bookFiles) {
			if(zip.files) {
				out.keys = entries;
				out.files = zip.files;
			} else {
				out.keys = [];
				out.files = {};
				zip.FullPaths.forEach(function(p, idx) {
					p = p.replace(/^Root Entry[\/]/, "");
					out.keys.push(p);
					out.files[p] = zip.FileIndex[idx];
				});
			}
		}
		if(opts && opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
			else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
		}
		return out;
	}
	
	/* [MS-OFFCRYPTO] 2.1.1 */
	function parse_xlsxcfb(cfb, _opts) {
		var opts = _opts || {};
		var f = 'Workbook', data = CFB.find(cfb, f);
		try {
		f = '/!DataSpaces/Version';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var version = */parse_DataSpaceVersionInfo(data.content);
	
		/* 2.3.4.1 */
		f = '/!DataSpaces/DataSpaceMap';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var dsm = parse_DataSpaceMap(data.content);
		if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.2 */
		f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var seds = parse_DataSpaceDefinition(data.content);
		if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.3 */
		f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var hdr = */parse_Primary(data.content);
		} catch(e) {}
	
		f = '/EncryptionInfo';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var einfo = parse_EncryptionInfo(data.content);
	
		/* 2.3.4.4 */
		f = '/EncryptedPackage';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	
	/*global decrypt_agile */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
	/*global decrypt_std76 */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
		throw new Error("File is password-protected");
	}
	
	function write_zip(wb, opts) {
		if(opts.bookType == "ods") return write_ods(wb, opts);
		if(opts.bookType == "numbers") return write_numbers_iwa(wb, opts);
		if(opts.bookType == "xlsb") return write_zip_xlsxb(wb, opts);
		return write_zip_xlsx(wb, opts);
	}
	
	/* XLSX and XLSB writing are very similar.  Originally they were unified in one
	   export function.  This is horrible for tree shaking in the common case (most
	   applications need to export files in one format) so this function supports
	   both formats while write_zip_xlsx only handles XLSX */
	function write_zip_xlsxb(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta(f));
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function write_zip_xlsx(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		var people = ["SheetJ5"];
		opts.tcid = 0;
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws_xml(rId-1, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					var needtc = false;
					comments.forEach(function(carr) {
						carr[1].forEach(function(c) { if(c.T == true) needtc = true; });
					});
					if(needtc) {
						cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
						zip_add_file(zip, cf, write_tcmnt_xml(comments, people, opts));
						ct.threadedcomments.push(cf);
						add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, RELS.TCMNT);
					}
	
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_comments_xml(comments, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb_xml(wb, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty_xml(wb, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta_xml());
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		if(people.length > 1) {
			f = "xl/persons/person.xml";
			zip_add_file(zip, f, write_people_xml(people, opts));
			ct.people.push(f);
			add_rels(opts.wbrels, -1, "persons/person.xml", RELS.PEOPLE);
		}
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function firstbyte(f,o) {
		var x = "";
		switch((o||{}).type || "base64") {
			case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			case 'base64': x = Base64_decode(f.slice(0,12)); break;
			case 'binary': x = f; break;
			case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
		}
		return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
	}
	
	function read_cfb(cfb, opts) {
		if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
		return parse_xlscfb(cfb, opts);
	}
	
	function read_zip(data, opts) {
		var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		zip = zip_read(d, o);
		return parse_zip(zip, o);
	}
	
	function read_plaintext(data, o) {
		var i = 0;
		main: while(i < data.length) switch(data.charCodeAt(i)) {
			case 0x0A: case 0x0D: case 0x20: ++i; break;
			case 0x3C: return parse_xlml(data.slice(i),o);
			default: break main;
		}
		return PRN.to_workbook(data, o);
	}
	
	function read_plaintext_raw(data, o) {
		var str = "", bytes = firstbyte(data, o);
		switch(o.type) {
			case 'base64': str = Base64_decode(data); break;
			case 'binary': str = data; break;
			case 'buffer': str = data.toString('binary'); break;
			case 'array': str = cc2str(data); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
		o.type = "binary";
		return read_plaintext(str, o);
	}
	
	function read_utf16(data, o) {
		var d = data;
		if(o.type == 'base64') d = Base64_decode(d);
		d = $cptable.utils.decode(1200, d.slice(2), 'str');
		o.type = "binary";
		return read_plaintext(d, o);
	}
	
	function bstrify(data) {
		return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
	}
	
	function read_prn(data, d, o, str) {
		if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
		return PRN.to_workbook(d, o);
	}
	
	function readSync(data, opts) {
		reset_cp();
		var o = opts||{};
		if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
		if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
		var d = data, n = [0,0,0,0], str = false;
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		_ssfopts = {};
		if(o.dateNF) _ssfopts.dateNF = o.dateNF;
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
		if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
		if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
			// $FlowIgnore
			var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
			// $FlowIgnore
			if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
		}
		switch((n = firstbyte(d, o))[0]) {
			case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
			case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
			case 0x3C: return parse_xlml(d, o);
			case 0x49:
				if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
				if(n[1] === 0x44) return read_wb_ID(d, o);
				break;
			case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
			case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
			case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
			case 0xFF:
				if(n[1] === 0xFE) { return read_utf16(d, o); }
				else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				break;
			case 0x00:
				if(n[1] === 0x00) {
					if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
					if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
				}
				break;
			case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
			case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
			case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
			case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
		}
		if(DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
		return read_prn(data, d, o, str);
	}
	
	function readFileSync(filename, opts) {
		var o = opts||{}; o.type = 'file';
		return readSync(filename, o);
	}
	function write_cfb_ctr(cfb, o) {
		switch(o.type) {
			case "base64": case "binary": break;
			case "buffer": case "array": o.type = ""; break;
			case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			default: throw new Error("Unrecognized type " + o.type);
		}
		return CFB.write(cfb, o);
	}
	
	function write_zip_type(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_typeXLSX(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip_xlsx(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_denouement(z, o) {
		var oopts = {};
		var ftype = has_buf ? "nodebuffer" : (typeof Uint8Array !== "undefined" ? "array" : "string");
		if(o.compression) oopts.compression = 'DEFLATE';
		if(o.password) oopts.type = ftype;
		else switch(o.type) {
			case "base64": oopts.type = "base64"; break;
			case "binary": oopts.type = "string"; break;
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			case "buffer":
			case "file": oopts.type = ftype; break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: {"nodebuffer": "buffer", "string": "binary"}[oopts.type] || oopts.type, compression: !!o.compression}) : z.generate(oopts);
		if(typeof Deno !== "undefined") {
			if(typeof out == "string") {
				if(o.type == "binary" || o.type == "base64") return out;
				out = new Uint8Array(s2ab(out));
			}
		}
	/*jshint -W083 */
		if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
	/*jshint +W083 */
		if(o.type === "file") return write_dl(o.file, out);
		return o.type == "string" ? utf8read(out) : out;
	}
	
	function write_cfb_type(wb, opts) {
		var o = opts||{};
		var cfb = write_xlscfb(wb, o);
		return write_cfb_ctr(cfb, o);
	}
	
	function write_string_type(out, opts, bom) {
		if(!bom) bom = "";
		var o = bom + out;
		switch(opts.type) {
			case "base64": return Base64_encode(utf8write(o));
			case "binary": return utf8write(o);
			case "string": return out;
			case "file": return write_dl(opts.file, o, 'utf8');
			case "buffer": {
				if(has_buf) return Buffer_from(o, 'utf8');
				else if(typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
				else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	function write_stxt_type(out, opts) {
		switch(opts.type) {
			case "base64": return Base64_encode(out);
			case "binary": return out;
			case "string": return out; /* override in sheet_to_txt */
			case "file": return write_dl(opts.file, out, 'binary');
			case "buffer": {
				if(has_buf) return Buffer_from(out, 'binary');
				else return out.split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	/* TODO: test consistency */
	function write_binary_type(out, opts) {
		switch(opts.type) {
			case "string":
			case "base64":
			case "binary":
				var bstr = "";
				// $FlowIgnore
				for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
				return opts.type == 'base64' ? Base64_encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
			case "file": return write_dl(opts.file, out);
			case "buffer": return out;
			default: throw new Error("Unrecognized type " + opts.type);
		}
	}
	
	function writeSyncXLSX(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSyncXLSX(wb, o)); o.type = "array"; return s2ab(out); }
		return write_zip_typeXLSX(wb, o);
	}
	
	function writeSync(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
		var idx = 0;
		if(o.sheet) {
			if(typeof o.sheet == "number") idx = o.sheet;
			else idx = wb.SheetNames.indexOf(o.sheet);
			if(!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + (typeof o.sheet));
		}
		switch(o.bookType || 'xlsb') {
			case 'xml':
			case 'xlml': return write_string_type(write_xlml(wb, o), o);
			case 'slk':
			case 'sylk': return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'htm':
			case 'html': return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'txt': return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'csv': return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
			case 'dif': return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'dbf': return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'prn': return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'rtf': return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'eth': return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'fods': return write_string_type(write_ods(wb, o), o);
			case 'wk1': return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
			case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
			case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
			case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
			case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
			case 'biff8':
			case 'xla':
			case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
			case 'xlsx':
			case 'xlsm':
			case 'xlam':
			case 'xlsb':
			case 'numbers':
			case 'ods': return write_zip_type(wb, o);
			default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
		}
	}
	
	function resolve_book_type(o) {
		if(o.bookType) return;
		var _BT = {
			"xls": "biff8",
			"htm": "html",
			"slk": "sylk",
			"socialcalc": "eth",
			"Sh33tJS": "WTF"
		};
		var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
		if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
		o.bookType = _BT[o.bookType] || o.bookType;
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSync(wb, o);
	}
	
	function writeFileSyncXLSX(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSyncXLSX(wb, o);
	}
	
	
	function writeFileAsync(filename, wb, opts, cb) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		o.type = 'buffer';
		var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
		return _fs.writeFile(filename, writeSync(wb, o), _cb);
	}
	function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
		var rr = encode_row(R);
		var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
		var isempty = true;
		var row = (header === 1) ? [] : {};
		if(header !== 1) {
			if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
			else row.__rowNum__ = R;
		}
		if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
			var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			if(val === undefined || val.t === undefined) {
				if(defval === undefined) continue;
				if(hdr[C] != null) { row[hdr[C]] = defval; }
				continue;
			}
			var v = val.v;
			switch(val.t){
				case 'z': if(v == null) break; continue;
				case 'e': v = (v == 0 ? null : void 0); break;
				case 's': case 'd': case 'b': case 'n': break;
				default: throw new Error('unrecognized type ' + val.t);
			}
			if(hdr[C] != null) {
				if(v == null) {
					if(val.t == "e" && v === null) row[hdr[C]] = null;
					else if(defval !== undefined) row[hdr[C]] = defval;
					else if(raw && v === null) row[hdr[C]] = null;
					else continue;
				} else {
					row[hdr[C]] = raw && (val.t !== "n" || (val.t === "n" && o.rawNumbers !== false)) ? v : format_cell(val,v,o);
				}
				if(v != null) isempty = false;
			}
		}
		return { row: row, isempty: isempty };
	}
	
	
	function sheet_to_json(sheet, opts) {
		if(sheet == null || sheet["!ref"] == null) return [];
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		else if(o.header == null) header = 0;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var out = [];
		var outi = 0, counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
		}
		out.length = outi;
		return out;
	}
	
	var qreg = /"/g;
	function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
		var isempty = true;
		var row = [], txt = "", rr = encode_row(R);
		for(var C = r.s.c; C <= r.e.c; ++C) {
			if (!cols[C]) continue;
			var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
			if(val == null) txt = "";
			else if(val.v != null) {
				isempty = false;
				txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
				for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				if(txt == "ID") txt = '"ID"';
			} else if(val.f != null && !val.F) {
				isempty = false;
				txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
			} else txt = "";
			/* NOTE: Excel CSV does not support array formulae */
			row.push(txt);
		}
		if(o.blankrows === false && isempty) return null;
		return row.join(FS);
	}
	
	function sheet_to_csv(sheet, opts) {
		var out = [];
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var w = 0;
		for(var R = r.s.r; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
			if(row == null) { continue; }
			if(o.strip) row = row.replace(endregex,"");
			if(row || (o.blankrows !== false)) out.push((w++ ? RS : "") + row);
		}
		delete o.dense;
		return out.join("");
	}
	
	function sheet_to_txt(sheet, opts) {
		if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
		var s = sheet_to_csv(sheet, opts);
		if(typeof $cptable == 'undefined' || opts.type == 'string') return s;
		var o = $cptable.utils.encode(1200, s, 'str');
		return String.fromCharCode(255) + String.fromCharCode(254) + o;
	}
	
	function sheet_to_formulae(sheet) {
		var y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return [];
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		var cmds = [];
		var dense = Array.isArray(sheet);
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = dense ? (sheet[R]||[])[C] : sheet[y];
				val = "";
				if(x === undefined) continue;
				else if(x.F != null) {
					y = x.F;
					if(!x.f) continue;
					val = x.f;
					if(y.indexOf(":") == -1) y = y + ":" + y;
				}
				if(x.f != null) val = x.f;
				else if(x.t == 'z') continue;
				else if(x.t == 'n' && x.v != null) val = "" + x.v;
				else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else if(x.t == 's') val = "'" + x.v;
				else val = ""+x.v;
				cmds[cmds.length] = y + "=" + val;
			}
		}
		return cmds;
	}
	
	function sheet_add_json(_ws, js, opts) {
		var o = opts || {};
		var offset = +!o.skipHeader;
		var ws = _ws || ({});
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var cell;
		var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
		} else {
			if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
		}
		var hdr = o.header || [], C = 0;
	
		js.forEach(function (JS, R) {
			keys(JS).forEach(function(k) {
				if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
				var v = JS[k];
				var t = 'z';
				var z = "";
				var ref = encode_cell({c:_C + C,r:_R + R + offset});
				cell = ws_get_cell_stub(ws, ref);
				if(v && typeof v === 'object' && !(v instanceof Date)){
					ws[ref] = v;
				} else {
					if(typeof v == 'number') t = 'n';
					else if(typeof v == 'boolean') t = 'b';
					else if(typeof v == 'string') t = 's';
					else if(v instanceof Date) {
						t = 'd';
						if(!o.cellDates) { t = 'n'; v = datenum(v); }
						z = (o.dateNF || table_fmt[14]);
					}
					else if(v === null && o.nullError) { t = 'e'; v = 0; }
					if(!cell) ws[ref] = cell = ({t:t, v:v});
					else {
						cell.t = t; cell.v = v;
						delete cell.w; delete cell.R;
						if(z) cell.z = z;
					}
					if(z) cell.z = z;
				}
			});
		});
		range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
		var __R = encode_row(_R);
		if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }
	
	/* get cell, creating a stub if necessary */
	function ws_get_cell_stub(ws, R, C) {
		/* A1 cell address */
		if(typeof R == "string") {
			/* dense */
			if(Array.isArray(ws)) {
				var RC = decode_cell(R);
				if(!ws[RC.r]) ws[RC.r] = [];
				return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
			}
			return ws[R] || (ws[R] = {t:'z'});
		}
		/* cell address object */
		if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
		/* R and C are 0-based indices */
		return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
	}
	
	/* find sheet index for given name / validate index */
	function wb_sheet_idx(wb, sh) {
		if(typeof sh == "number") {
			if(sh >= 0 && wb.SheetNames.length > sh) return sh;
			throw new Error("Cannot find sheet # " + sh);
		} else if(typeof sh == "string") {
			var idx = wb.SheetNames.indexOf(sh);
			if(idx > -1) return idx;
			throw new Error("Cannot find sheet name |" + sh + "|");
		} else throw new Error("Cannot find sheet |" + sh + "|");
	}
	
	/* simple blank workbook object */
	function book_new() {
		return { SheetNames: [], Sheets: {} };
	}
	
	/* add a worksheet to the end of a given workbook */
	function book_append_sheet(wb, ws, name, roll) {
		var i = 1;
		if(!name) for(; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
		if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
		if(roll && wb.SheetNames.indexOf(name) >= 0) {
			var m = name.match(/(^.*?)(\d+)$/);
			i = m && +m[2] || 0;
			var root = m && m[1] || name;
			for(++i; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = root + i) == -1) break;
		}
		check_ws_name(name);
		if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
	
		wb.SheetNames.push(name);
		wb.Sheets[name] = ws;
		return name;
	}
	
	/* set sheet visibility (visible/hidden/very hidden) */
	function book_set_sheet_visibility(wb, sh, vis) {
		if(!wb.Workbook) wb.Workbook = {};
		if(!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
	
		var idx = wb_sheet_idx(wb, sh);
		// $FlowIgnore
		if(!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
	
		switch(vis) {
			case 0: case 1: case 2: break;
			default: throw new Error("Bad sheet visibility setting " + vis);
		}
		// $FlowIgnore
		wb.Workbook.Sheets[idx].Hidden = vis;
	}
	
	/* set number format */
	function cell_set_number_format(cell, fmt) {
		cell.z = fmt;
		return cell;
	}
	
	/* set cell hyperlink */
	function cell_set_hyperlink(cell, target, tooltip) {
		if(!target) {
			delete cell.l;
		} else {
			cell.l = ({ Target: target });
			if(tooltip) cell.l.Tooltip = tooltip;
		}
		return cell;
	}
	function cell_set_internal_link(cell, range, tooltip) { return cell_set_hyperlink(cell, "#" + range, tooltip); }
	
	/* add to cell comments */
	function cell_add_comment(cell, text, author) {
		if(!cell.c) cell.c = [];
		cell.c.push({t:text, a:author||"SheetJS"});
	}
	
	/* set array formula and flush related cells */
	function sheet_set_array_formula(ws, range, formula, dynamic) {
		var rng = typeof range != "string" ? range : safe_decode_range(range);
		var rngstr = typeof range == "string" ? range : encode_range(range);
		for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
			var cell = ws_get_cell_stub(ws, R, C);
			cell.t = 'n';
			cell.F = rngstr;
			delete cell.v;
			if(R == rng.s.r && C == rng.s.c) {
				cell.f = formula;
				if(dynamic) cell.D = true;
			}
		}
		return ws;
	}
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		sheet_add_aoa: sheet_add_aoa,
		sheet_add_json: sheet_add_json,
		sheet_add_dom: sheet_add_dom,
		aoa_to_sheet: aoa_to_sheet,
		json_to_sheet: json_to_sheet,
		table_to_sheet: parse_dom_table,
		table_to_book: table_to_book,
		sheet_to_csv: sheet_to_csv,
		sheet_to_txt: sheet_to_txt,
		sheet_to_json: sheet_to_json,
		sheet_to_html: sheet_to_html,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_json,
		sheet_get_cell: ws_get_cell_stub,
		book_new: book_new,
		book_append_sheet: book_append_sheet,
		book_set_sheet_visibility: book_set_sheet_visibility,
		cell_set_number_format: cell_set_number_format,
		cell_set_hyperlink: cell_set_hyperlink,
		cell_set_internal_link: cell_set_internal_link,
		cell_add_comment: cell_add_comment,
		sheet_set_array_formula: sheet_set_array_formula,
		consts: {
			SHEET_VISIBLE: 0,
			SHEET_HIDDEN: 1,
			SHEET_VERY_HIDDEN: 2
		}
	};
	
	var _Readable;
	function set_readable(R) { _Readable = R; }
	
	function write_csv_stream(sheet, opts) {
		var stream = _Readable();
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var R = r.s.r;
		var BOM = false, w = 0;
		stream._read = function() {
			if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
			while(R <= r.e.r) {
				++R;
				if ((rowinfo[R-1]||{}).hidden) continue;
				row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
				if(row != null) {
					if(o.strip) row = row.replace(endregex,"");
					if(row || (o.blankrows !== false)) return stream.push((w++ ? RS : "") + row);
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	function write_html_stream(ws, opts) {
		var stream = _Readable();
	
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		stream.push(header);
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		stream.push(make_html_preamble(ws, r, o));
		var R = r.s.r;
		var end = false;
		stream._read = function() {
			if(R > r.e.r) {
				if(!end) { end = true; stream.push("</table>" + footer); }
				return stream.push(null);
			}
			while(R <= r.e.r) {
				stream.push(make_html_row(ws, r, R, o));
				++R;
				break;
			}
		};
		return stream;
	}
	
	function write_json_stream(sheet, opts) {
		var stream = _Readable({objectMode:true});
	
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		R = r.s.r + offset;
		stream._read = function() {
			while(R <= r.e.r) {
				if ((rowinfo[R-1]||{}).hidden) continue;
				var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
				++R;
				if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
					stream.push(row.row);
					return;
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	var __stream = {
		to_json: write_json_stream,
		to_html: write_html_stream,
		to_csv: write_csv_stream,
	  set_readable: set_readable
	};
	if(typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.writeFileAsync = writeFileAsync;
	XLSX.utils = utils;
	XLSX.writeXLSX = writeSyncXLSX;
	XLSX.writeFileXLSX = writeFileSyncXLSX;
	XLSX.SSF = SSF;
	if(typeof __stream !== "undefined") XLSX.stream = __stream;
	if(typeof CFB !== "undefined") XLSX.CFB = CFB;
	if(true) {
	  var strmod = __webpack_require__(492);
	  if((strmod||{}).Readable) set_readable(strmod.Readable);
	}
	}
	/*global define */
	if(true) make_xlsx_lib(exports);
	else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
	else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
	else make_xlsx_lib(XLSX);
	/* NOTE: the following extra line is needed for "Lightning Locker Service" */
	if(typeof window !== 'undefined' && !window.XLSX) try { window.XLSX = XLSX; } catch(e) {}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(415).Buffer, __webpack_require__(489), __webpack_require__(149)))

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.15.0"};
	cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	return {"enc": e, "dec": d }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[28591] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	// eslint-disable-next-line no-undef
	if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
	/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ft=javascript: */
	/*jshint newcap: false */
	(function(root, factory) {
	  /*jshint ignore:start */
	  /*eslint-disable */
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	  /*eslint-enable */
	  /*jshint ignore:end */
	}(this, function(cpt){
	  "use strict";
	  /*global module, Buffer */
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpdcache = {};
	  var cpecache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x) { return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  var Buffer_from = function(){};
	  if(has_buf) {
	    var nbfs = !Buffer.from;
	    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	    // $FlowIgnore
	    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	
	    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
	    var make_EE = function make_EE(E){
	      var EE = Buffer.allocUnsafe(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i=0, j=0, D=0, w=0;
	        if(typeof data === 'string') {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = Buffer.allocUnsafe(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out = out.slice(0,j);
	        } else {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c="";
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j=0;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        return mdb.slice(0, 2 * len).toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = Buffer.allocUnsafe(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        return out.slice(0,k).toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      if(typeof data === "string") return utf8_d(data.split("").map(cca));
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      return mdb.slice(0,k).toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      if(has_buf && Buffer.isBuffer(data)) {
	        if(!ofmt || ofmt === 'buf') return data;
	        if(ofmt !== 'arr') return data.toString('binary');
	        return [].slice.call(data);
	      }
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
	      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
	      return [].slice.call(mdb, 0, j);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i=0, s=0;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var null_enc = function(data, ofmt) { void ofmt; return ""; };
	  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = null_enc; last_cp = 0;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc = null_enc, last_cp = 0;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
	    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
	    var C = cpt[cp], E, M = "";
	    var isstr = typeof data === 'string';
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[isstr? data.charAt(i) : data[i]];
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      } else out[j] = w&255;
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          var c = isstr ? data.charAt(i) : data[i].charAt(0);
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          var tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out = out.slice(0,j);
	    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
	    if(!ofmt || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    if(typeof data === "string") return decode(cp, data.split("").map(cca));
	    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
	    var C = cpt[cp], D, M="";
	    if(C && (D=C.dec)) {
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        s = D[(data[i]<<8)+ data[i+1]];
	        if(!s) {
	          j = 1;
	          s = D[data[i]];
	        }
	        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = s;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          // eslint-disable-next-line no-useless-escape
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64 = "";
	          var c1=0, c2=0, c3=0;
	          var e1=0, e2=0, e3=0, e4=0;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    return out.slice(0,k).join("");
	  };
	  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(415).Buffer))

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 492 */
491,
/* 493 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var indicator = exports.indicator = {
	  bindings: {
	    fraction: '<',
	    description: '<',
	    total: '<',
	    indicatorCount: '<',
	    onClick: '&',
	    selected: '<'
	  },
	  template: '\n    <div class="row">\n      <div class="col-md-12 text-center">\n        <div class="principal-diagram c100 p{{vm.percentageRound}} {{vm.selected? \'md\' : vm.gaugeClass}} green center">\n          <span class="pointer" ng-click=vm.onClick()>{{ vm.percentage }}%</span>\n          <div class="slice">\n            <div class="bar"></div>\n            <div class="fill"></div>\n          </div>                  \n        </div>\n        <p class="{{vm.textClass}} exo p-t text-blanco">{{ vm.fraction }}/{{ vm.total }}</p>\n        <p class="{{vm.textClass}} text-blanco">{{ vm.description[0] }}<br>{{ vm.description[1] }}</p>\n      </div>\n    </div>',
	  controllerAs: 'vm',
	  controller: [function indicatorCtrl() {
	    var vm = this;
	    vm.percentage = null;
	    var nonZeroTotal = vm.total === 0 ? 1 : vm.total;
	
	    vm.$onInit = function () {
	      switch (vm.indicatorCount) {
	        case 4:
	          {
	            vm.textClass = 'text-sm';
	            vm.gaugeClass = 'sm';
	            break;
	          }
	        case 5:
	          {
	            vm.textClass = 'text-xs';
	            vm.gaugeClass = 'xs';
	            break;
	          }
	      }
	      vm.percentage = (vm.fraction / nonZeroTotal * 100).toFixed(1);
	      vm.percentageRound = Math.round(vm.percentage);
	      Number(vm.fraction);
	      Number(vm.total);
	    };
	  }] };

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var panelRouter = exports.panelRouter = {
	  bindings: {
	    data: '<',
	    action: '<'
	  },
	  template: '\n    <div class="ui-grid-cell-contents">\n      <a>\n        <i class="icon {{ vm.map }} i-20" style="padding-right: 5px; opacity: 1"></i>\n      </a>\n      <a ng-if="vm.isLinkActive(vm.action)" class="line-down" ng-click="vm.router(vm.route, vm.header)">\n        {{ vm.action }}\n      </a>\n      <div ng-if="!vm.isLinkActive(vm.action)" class="line-down" style="display:inline-block">\n        {{ vm.action }}\n      </div>\n    </div>',
	  controllerAs: 'vm',
	  controller: ['Validations', '$state', 'CssClasses', '$cookies', 'GlobalConfig', function panelRouterCtrl(Validations, $state, CssClasses, $cookies, GlobalConfig) {
	    var vm = this;
	    var currentStage = $state.current.tag;
	
	    var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	    var inConsultant = Validations.inConsultant(currentRoleId);
	    var inAdminConsultantUnit = Validations.inAdminConsultantUnit(currentRoleId);
	
	    vm.map = CssClasses.icons.map;
	    vm.header = {};
	    vm.route = '';
	
	    vm.router = router;
	    vm.isLinkActive = isLinkActive;
	
	    vm.$onInit = function () {
	      vm.header = setHeader();
	      vm.route = setRoute();
	    };
	
	    var inReview = Validations.inReview(currentStage);
	    var inApproval = Validations.inApproval(currentStage);
	    var inEvaluation = Validations.inEvaluation(currentStage);
	    var inReviewExecution = Validations.inReviewExecution(currentStage);
	    var isWorkplanCommittee = Validations.isWorkplanCommittee(currentRoleId) || Validations.isCommitteeRole(currentRoleId);
	
	    function setRoute() {
	      switch (true) {
	        case inReview:
	          return 'summaryReview';
	        case inApproval:
	          return 'summaryApproval';
	        case inEvaluation:
	          return 'summaryEvaluation';
	        case inReviewExecution:
	          return 'summaryReviewExecution';
	        case inConsultant:
	          return 'summaryConsult';
	        case inAdminConsultantUnit:
	          return 'summaryConsult';
	        case isWorkplanCommittee:
	          return 'summaryConsult';
	      }
	    }
	
	    function setHeader() {
	      return {
	        teacherId: vm.data.teacherId,
	        workplanId: vm.data.workplanId,
	        name: vm.data.name
	      };
	    }
	
	    function router(route, header) {
	      var updatedHeader = {
	        teacherId: vm.data.teacherId,
	        workplanId: vm.data.workplanId,
	        name: vm.data.name,
	        currentStage: Object.keys(GlobalConfig.workplanIdStages).find(function (key) {
	          return GlobalConfig.workplanIdStages[key] == vm.data.stage;
	        })
	      };
	      $state.go('workplan.' + route, updatedHeader);
	    }
	
	    function isLinkActive(action) {
	      if (action == 'Pendientes de ajustes') return false;else return true;
	    }
	  }] };

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var panelRouterEvaluation = exports.panelRouterEvaluation = {
	  bindings: {
	    data: '<',
	    action: '<'
	  },
	  template: '\n    <div class="ui-grid-cell-contents">\n      <a>\n        <i class="icon {{ vm.map }} i-20" style="padding-right: 5px; opacity: 1"></i>\n      </a>\n      <a class="line-down" ng-click="vm.router(vm.route, vm.header)">\n        {{ vm.action }}\n      </a>\n    </div>',
	  controllerAs: 'vm',
	  controller: ['Validations', '$state', 'CssClasses', function panelRouterEvaluationCtrl(Validations, $state, CssClasses) {
	    var vm = this;
	    //const currentStage = $state.current.tag
	    vm.map = CssClasses.icons.map;
	    vm.header = {};
	    vm.route = '';
	
	    vm.router = router;
	
	    vm.$onInit = function () {
	      vm.header = setHeader();
	      vm.route = setRoute();
	
	      // console.log(vm.header);
	      // console.log(vm.route);
	    };
	
	    // let inReview = Validations.inReview(currentStage);
	    // let inApproval = Validations.inApproval(currentStage);
	    // let inEvaluation = Validations.inEvaluation(currentStage);
	    // let inReviewExecution = Validations.inReviewExecution(currentStage);
	
	    function setRoute() {
	      return 'evaluationTeaching';
	    }
	
	    function setHeader() {
	      return {
	        teacherId: vm.data.teacherId,
	        workplanId: vm.data.workplanId,
	        name: vm.data.name
	      };
	    }
	
	    function router(route, header) {
	      var updatedHeader = {
	        teacherId: vm.data.teacherId,
	        workplanId: vm.data.workplanId,
	        name: vm.data.name
	      };
	      $state.go('workplan.' + route, updatedHeader);
	    }
	  }] };

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var executionEntries = exports.executionEntries = {
	  bindings: {
	    activity: '<',
	    text: '<'
	  },
	  template: '\n    <p  \n      class="m-sm pointer text-azul text-sm close-text text-block" \n      ng-click="vm.executionEntries(vm.activity)">\n        {{vm.text}}\n    </p>',
	  controllerAs: 'vm',
	  controller: ['WorkPlanModalSrv', function executionEntriesCtrl(WorkPlanModalSrv) {
	    // constants
	    var vm = this;
	
	    // methods
	    vm.executionEntries = executionEntries;
	
	    function executionEntries(activity) {
	      var parentActivity = activity;
	      parentActivity.selectedActivityId = activity.workplanTeacherActivityId;
	      WorkPlanModalSrv.setVariable(parentActivity);
	      WorkPlanModalSrv.executionEntries();
	    }
	  }] };

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var registerExecution = exports.registerExecution = {
	  bindings: {
	    activity: '<'
	  },
	  template: '\n    <span\n      ng-click="vm.registerExecution(vm.activity)" \n      class="text-gris-dark icon i-20 {{ vm.edit }} pointer">\n    </span>',
	  controllerAs: 'vm',
	  controller: ['$scope', 'WorkPlanModalSrv', 'CssClasses', 'GlobalSrv', function registerExecutionCtrl($scope, WorkPlanModalSrv, CssClasses, GlobalSrv) {
	    // constants
	    var vm = this;
	    var icons = CssClasses.icons;
	    vm.edit = icons.edit;
	    // methods
	    vm.registerExecution = registerExecution;
	
	    function registerExecution(activity) {
	      var parentActivity = activity;
	      parentActivity.selectedActivityId = activity;
	      WorkPlanModalSrv.setVariable(parentActivity);
	      WorkPlanModalSrv.registerExecution().then(function (promise) {
	        $scope.$emit('changeHoursExecuted', WorkPlanModalSrv.getVariable());
	      });
	    }
	  }] };

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addCustom = undefined;
	
	var _addCustom = __webpack_require__(499);
	
	var _addCustom2 = _interopRequireDefault(_addCustom);
	
	var _confirm = __webpack_require__(500);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addCustom = exports.addCustom = {
	  template: _addCustom2.default,
	  controllerAs: 'vm',
	  controller: ['Validations', 'GlobalConfig', 'Ramda', '$mdDialog', '$cookies', '$state', 'WorkPlanModalSrv', 'ReviewSrv', 'Util', 'WorkPlanSrv', function addCustomCtrl(Validations, GlobalConfig, Ramda, $mdDialog, $cookies, $state, WorkPlanModalSrv, ReviewSrv, Util, WorkPlanSrv) {
	    var _this = this;
	
	    var curry = Ramda.curry;
	    var currentModule = $state.current.module;
	    var isProductsType = Validations.isProductsType,
	        isProjectsType = Validations.isProjectsType,
	        isExtensionProjectsType = Validations.isExtensionProjectsType,
	        isCrossExtensionProjectsType = Validations.isCrossExtensionProjectsType;
	    var _GlobalConfig$minorAc = GlobalConfig.minorActivityId,
	        projectParent = _GlobalConfig$minorAc.projectParent,
	        projectChild = _GlobalConfig$minorAc.projectChild,
	        productParent = _GlobalConfig$minorAc.productParent,
	        productChild = _GlobalConfig$minorAc.productChild,
	        extensionProjectParent = _GlobalConfig$minorAc.extensionProjectParent,
	        extensionProjectChild = _GlobalConfig$minorAc.extensionProjectChild,
	        projectCrossParent = _GlobalConfig$minorAc.projectCrossParent,
	        projectCrossChild = _GlobalConfig$minorAc.projectCrossChild;
	
	    var objHas = Util.objHas;
	
	    var startDateChange = function startDateChange(startDate, minEndDate) {
	      minEndDate = moment(startDate).isValid() ? moment(startDate).add(1, 'days').toDate() : null;
	    };
	
	    var extractPeriodsIds = function extractPeriodsIds(obj) {
	      return Object.keys(obj).filter(function (id) {
	        return Boolean(obj[id]);
	      }).map(function (id) {
	        return { periodId: id };
	      });
	    };
	
	    var periodsExist = function periodsExist(arr) {
	      return Array.isArray(arr) ? arr.length > 0 : false;
	    };
	
	    var datesExist = function datesExist(start, end) {
	      return Boolean(start) && Boolean(end);
	    };
	
	    var setChildrenId = function setChildrenId(parent) {
	      switch (parent) {
	        case projectParent:
	          return projectChild;
	        case productParent:
	          return productChild;
	        case extensionProjectParent:
	          return extensionProjectChild;
	        case projectCrossParent:
	          return projectCrossChild;
	      }
	    };
	
	    var setActivity = function setActivity(scope) {
	      return {
	        activityId: setChildrenId(scope.parent.activityId),
	        teacherId: scope.teacherId,
	        workplanId: scope.workplanId,
	        name: scope.title,
	        description: scope.description,
	        hoursPlanning: scope.plannedHours,
	        parentActivityId: scope.parent.workplanTeacherActivityId,
	        timeRangeTypeId: Number(scope.rangeType),
	        origin: 2
	      };
	    };
	
	    var confirm = function confirm(name) {
	      var projectName = _this.title;
	      var createOrEdit = _this.activityTag;
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	          angular.extend(this, {
	            name: name,
	            projectName: projectName,
	            createOrEdit: createOrEdit,
	            close: function close() {
	              return $mdDialog.hide();
	            }
	          });
	        }],
	        controllerAs: 'vm',
	        template: _confirm2.default,
	        clickOutsideToClose: false
	      });
	    };
	
	    var addOrEditProject = curry(function (confirm, parent, activity, name) {
	      switch (true) {
	        case isProductsType(parent):
	          return ReviewSrv.addCustomActivity.product(activity).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	              WorkPlanModalSrv.setVariable(activity);
	              $mdDialog.hide();
	              // dataReturn.status ? confirm(name) : console.log('error in communications')
	            }
	          });
	        case isProjectsType(parent):
	          return ReviewSrv.addCustomActivity.project(activity).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	              WorkPlanModalSrv.setVariable(activity);
	              $mdDialog.hide();
	              // ? confirm(name, dataReturn, parent, activity) : console.log('error in communications')
	            }
	          });
	        case isExtensionProjectsType(parent):
	          return ReviewSrv.addCustomActivity.extensionProject(activity).$promise.then(function (dataReturn) {
	            // dataReturn.status ? confirm(name) : console.log('error in communications')
	            if (dataReturn.status) {
	              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	              WorkPlanModalSrv.setVariable(activity);
	              $mdDialog.hide();
	              // ? confirm(name, dataReturn, parent, activity) : console.log('error in communications')
	            }
	          });
	        case isCrossExtensionProjectsType(parent):
	          return ReviewSrv.addCustomActivity.extensionProject(activity).$promise.then(function (dataReturn) {
	            // dataReturn.status ? confirm(name) : console.log('error in communications')
	            if (dataReturn.status) {
	              activity.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	              WorkPlanModalSrv.setVariable(activity);
	              $mdDialog.hide();
	              // ? confirm(name, dataReturn, parent, activity) : console.log('error in communications')
	            }
	          });
	      }
	    })(confirm);
	
	    var getPeriodList = curry(function (service, header) {
	      return service.getList(header).$promise;
	    })(WorkPlanSrv.getDataFormProduct);
	
	    var addActivity = curry(function (extractPeriodsIds, setActivity, addOrEditProject, scope) {
	      scope.sentForm = true;
	      var activity = setActivity(scope);
	      if (Number(scope.rangeType) === 1) {
	        activity.periods = extractPeriodsIds(scope.periodsArray);
	
	        var periodsId = activity.periods.map(function (period) {
	          return +period.periodId;
	        });
	
	        activity.periodicityName = _this.typePeriod.filter(function (period) {
	          return periodsId.indexOf(period.periodId) !== -1 ? period : null;
	        }).map(function (period) {
	          return period.periodName;
	        }).join(',');
	      } else if (scope.startDate && scope.endDate) {
	        activity.startDate = scope.startDate;
	        activity.endDate = scope.endDate;
	      }
	      if (scope.isEditing) activity.workplanTeacherActivityId = scope.children.workplanTeacherActivityId;
	      var adding = addOrEditProject(scope.parent, activity, scope.activityTag);
	      adding.then(function (promise) {
	        return console.log(promise);
	      });
	    })(extractPeriodsIds, setActivity, addOrEditProject);
	
	    var validPeriods = function validPeriods() {
	      if (Number(_this.rangeType) === 1) {
	        return periodsExist(extractPeriodsIds(_this.periodsArray));
	      } else if (Number(_this.rangeType) === 2) {
	        return datesExist(_this.startDate, _this.endDate);
	      }
	    };
	
	    angular.extend(this, { // CONSTANTS
	      workplanId: JSON.parse($cookies.get('currentUser')).workplanId,
	      teacherId: JSON.parse($cookies.get('currentUser')).teacherId,
	      name: JSON.parse($cookies.get('currentUser')).name,
	      projectChild: GlobalConfig.minorActivityId.projectChild,
	      rangeTypes: GlobalConfig.rangeTypes
	    });
	
	    angular.extend(this, { // VARIABLES
	      activityTag: '',
	      action: '',
	      parent: {},
	      children: {},
	      isEditing: false,
	      title: '',
	      description: '',
	      inConsolidation: Validations.inConsolidation(currentModule),
	      inInvestigation: Validations.inInvestigation(currentModule),
	      inAcademicManagement: Validations.inAcademicManagement(currentModule),
	      plannedHours: 0,
	      startDate: null,
	      endDate: null,
	      rangeType: 2,
	      typePeriod: [],
	      periodsArray: {},
	      minStartDate: moment().toDate(),
	      minEndDate: new Date(),
	      sentForm: false
	    });
	
	    angular.extend(this, { // METHODS
	      hasError: Validations.hasError,
	      showErrorMessages: Validations.showErrorMessages,
	      startDateChange: startDateChange,
	      validAdd: function validAdd(form) {
	        return Validations.validateForm(form) || !validPeriods();
	      },
	      close: function close() {
	        return $mdDialog.hide();
	      },
	      toggleTypePeriod: function toggleTypePeriod(type) {
	        return Number(_this.rangeType) === type;
	      },
	      accept: function accept() {
	        return addActivity(_this);
	      },
	      validateCheklist: function validateCheklist() {
	        return Number(_this.rangeType) === 1 ? !periodsExist(extractPeriodsIds(_this.periodsArray)) : false;
	      },
	      capitalize: function capitalize(str) {
	        return str.charAt(0).toUpperCase() + str.slice(1);
	      }
	    });
	
	    this.$onInit = function () {
	      var download = WorkPlanModalSrv.getVariable();
	      getPeriodList({
	        workplanId: _this.workplanId,
	        teacherId: _this.teacherId,
	        name: _this.name
	      }).then(function (data) {
	        _this.typePeriod = data.status ? data.listPeriods : console.log('Comunications problem');
	      });
	      _this.parent = download[0];
	      _this.children = download[1] ? download[1] : null;
	      if (_this.children) {
	        _this.action = 'editar';
	        _this.description = objHas(_this.children, 'description') ? _this.children.description : '';
	        _this.title = Reflect.has(_this.children, 'name') ? _this.children.name : '';
	        _this.plannedHours = objHas(_this.children, 'hoursPlanned') ? _this.children.hoursPlanned : '';
	        if (objHas(_this.children, 'timeRangeTypeId')) {
	          _this.rangeType = _this.children.timeRangeTypeId;
	          switch (_this.children.timeRangeTypeId) {
	            case 1:
	              _this.children.periodId.split(',').forEach(function (id) {
	                _this.periodsArray[id] = true;
	              });
	              break;
	            case 2:
	              _this.startDate = _this.children.startDate;
	              _this.endDate = _this.children.endDate;
	              break;
	          }
	        }
	      } else {
	        _this.action = 'agregar';
	      }
	      _this.activityTag = isProjectsType(_this.parent) ? 'proyecto' : isProductsType(_this.parent) ? 'producto' : 'proyecto';
	    };
	  }] };

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=vm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=row> <div class=col-md-12> <div class=row> <h3 class=\"text-azul m-r-sm text-center text-block\"> {{ vm.capitalize(vm.action) }} actividades </h3> </div> <div class=row> <label class=text-center>Diligencie el siguiente formulario para {{ vm.action }} una nueva actividad al {{ vm.activityTag }}.</label> </div> </div> </div> <div class=row> <form name=customForm novalidate> <div class=col-md-12> <div class=\"form-group text-left\" ng-class=vm.hasError(customForm.nameActivityProduct)> <label for=nameActivityProduct class=\"control-label text-left\">Nombre de actividad</label> <input type=text name=nameActivityProduct ng-model=vm.title class=form-control ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=customForm.nameActivityProduct.$error ng-show=vm.showErrorMessages(customForm.nameActivityProduct)> <div ng-message=required class=text-xs>El nombre de la actividad es requerido.</div> </div> </div> </div> <div class=col-md-12> <div class=\"form-group text-left\" ng-class=vm.hasError(customForm.description)> <label for=description class=\"control-label text-left\">Descripci&oacute;n</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=vm.description rows=2 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=control-label ng-messages=customForm.description.$error ng-show=vm.showErrorMessages(customForm.description)> <div ng-message=required class=text-xs>La descripción es requerida.</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=col-md-12> <div class=\"col-md-12 no-padding text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempos de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 form-group no-padding-l\" ng-class=vm.hasError(customForm.planificationType)> <label for=planificationType class=\"control-label left\">Seleccione la forma en que se realizar&aacute; la planeaci&oacute;n *</label> </div> <div class=\"col-md-3 no-padding-r\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=vm.rangeType value=1> <i class=radio-green></i> <label class=text-xs>Período</label> </div> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=vm.rangeType value=2> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> <div class=\"col-md-12 no-padding-l\"> <div class=\"col-md-12 no-padding\" ng-if=vm.toggleTypePeriod(vm.rangeTypes.periods)> <div class=col-md-12> <label class=\"m-r-sm left\" ng-repeat=\"period in vm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=vm.periodsArray[period.periodId] name=period> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=vm.validateCheklist()> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=vm.toggleTypePeriod(vm.rangeTypes.custom)> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=vm.hasError(customForm.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=vm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=vm.startDateChange() md-min-date=vm.minStartDate md-max-date=vm.endDate min=\"{{vm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=customForm.startDate.$error ng-show=vm.showErrorMessages(customForm.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-5 no-padding-r\"> <div class=form-group ng-class=vm.hasError(customForm.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=vm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-min-date=vm.minEndDate min={{vm.minEndDate}} ng-change=vm.startDateChange() required> </md-datepicker> <div class=control-label ng-messages=customForm.endDate.$error ng-show=vm.showErrorMessages(customForm.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-12 p-v\" ng-show=\"inAcademicManagement ||  inConsolidation \"> <div class=form-group ng-class=vm.hasError(customForm.hours)> <label for=hours class=\"control-label left\">Horas planeadas</label> <input type=number min=0 name=hours ng-model=vm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\"> <div class=control-label ng-messages=customForm.hours.$error ng-show=vm.showErrorMessages(customForm.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=vm.close()> Cancelar </md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=vm.accept() ng-disabled=\"vm.validAdd(customForm) || vm.sentForm\"> Aceptar </md-button> </div> </div> </form> </div> </md-dialog-content> ";

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=vm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=row> <div class=col-md-12> <h3 class=\"text-verde text-center\">¡Creación de {{ vm.createOrEdit }} exitosa!</h3> <p class=\"m-t-md text-center\">El {{ vm.nameModal }} <strong>\" {{ vm.projectName }} \"</strong> se ha guardado con éxito.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=vm.close()> Aceptar </md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _adminPanel = __webpack_require__(502);
	
	var _adminPanel2 = _interopRequireDefault(_adminPanel);
	
	var _adminPanel3 = __webpack_require__(510);
	
	var _adminPanel4 = _interopRequireDefault(_adminPanel3);
	
	var _userListController = __webpack_require__(511);
	
	var _userListController2 = _interopRequireDefault(_userListController);
	
	var _userCreateController = __webpack_require__(514);
	
	var _userCreateController2 = _interopRequireDefault(_userCreateController);
	
	var _userEditController = __webpack_require__(515);
	
	var _userEditController2 = _interopRequireDefault(_userEditController);
	
	var _modalDeleteUserController = __webpack_require__(516);
	
	var _modalDeleteUserController2 = _interopRequireDefault(_modalDeleteUserController);
	
	var _userServices = __webpack_require__(517);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	var _rolesListController = __webpack_require__(518);
	
	var _rolesListController2 = _interopRequireDefault(_rolesListController);
	
	var _rolesCreateController = __webpack_require__(520);
	
	var _rolesCreateController2 = _interopRequireDefault(_rolesCreateController);
	
	var _modalDeleteRolesController = __webpack_require__(521);
	
	var _modalDeleteRolesController2 = _interopRequireDefault(_modalDeleteRolesController);
	
	var _rolesServices = __webpack_require__(522);
	
	var _rolesServices2 = _interopRequireDefault(_rolesServices);
	
	var _groupsListController = __webpack_require__(523);
	
	var _groupsListController2 = _interopRequireDefault(_groupsListController);
	
	var _groupsCreateController = __webpack_require__(525);
	
	var _groupsCreateController2 = _interopRequireDefault(_groupsCreateController);
	
	var _modalDeleteGroupsController = __webpack_require__(526);
	
	var _modalDeleteGroupsController2 = _interopRequireDefault(_modalDeleteGroupsController);
	
	var _groupsServices = __webpack_require__(527);
	
	var _groupsServices2 = _interopRequireDefault(_groupsServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// controllers & services module groups
	
	
	// controllers & services module Roles
	exports.default = angular.module('app.adminPanel', [_userServices2.default, _rolesServices2.default, _groupsServices2.default]).config(_adminPanel2.default).controller('userListController', _userListController2.default).controller('userCreateController', _userCreateController2.default).controller('userEditController', _userEditController2.default).controller('modalDeleteUserController', _modalDeleteUserController2.default).controller('rolesListController', _rolesListController2.default).controller('rolesCreateController', _rolesCreateController2.default).controller('modalDeleteRolesController', _modalDeleteRolesController2.default).controller('groupsListController', _groupsListController2.default).controller('groupsCreateController', _groupsCreateController2.default).controller('modalDeleteGroupsController', _modalDeleteGroupsController2.default).run(_adminPanel4.default).constant("adminPanel", [{
	
	    "title": "Admin-Panel",
	    "icon": "mdi-action-perm-contact-cal",
	    "subMenu": [
	    // {
	    // 'title' : 'Administración Usuarios',
	    // 'url': 'app.users',
	    // },
	    {
	        'title': 'Administración Roles',
	        'url': "app.roles"
	        // {
	        // 'title':'Administración Grupos',
	        // 'url': "app.groups",
	        // }
	    }]
	}]).name;
	
	// controllers & services module Users
	
	// file Route & run app adminPanel

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = routes;
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
		$locationProvider.html5Mode(true);
		//$urlRouterProvider.otherwise('/');
	
		$stateProvider.state('app.users', {
			abstract: false,
			url: '/admin-panel/usuarios',
			template: __webpack_require__(503),
			controller: 'userListController',
			controllerAs: 'userList'
		}).state('app.userCreate', {
			abstract: false,
			url: '/admin-panel/usuarios/crear',
			template: __webpack_require__(504),
			controller: 'userCreateController',
			controllerAs: 'userCreate'
		}).state('app.userEdit', {
			abstract: false,
			url: '/admin-panel/usuarios/edit?id',
			template: __webpack_require__(505),
			controller: 'userEditController',
			controllerAs: 'userEdit'
		}).state('app.roles', {
			abstract: false,
			url: '/admin-panel/roles',
			template: __webpack_require__(506),
			controller: 'rolesListController',
			controllerAs: 'rolesList'
		}).state('app.rolesCreate', {
			abstract: false,
			url: '/admin-panel/roles/crear',
			template: __webpack_require__(507),
			controller: 'rolesCreateController',
			controllerAs: 'rolesCreate'
		}).state('app.groups', {
			abstract: false,
			url: '/admin-panel/grupos',
			template: __webpack_require__(508),
			controller: 'groupsListController',
			controllerAs: 'groupsList'
		}).state('app.groupsCreate', {
			abstract: false,
			url: 'admin-panel/grupos/crear',
			template: __webpack_require__(509),
			controller: 'groupsCreateController',
			controllerAs: 'groupsCreate'
		});
	}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-md has-permission=acceso-administracion-usuarios-view> <div class=row> <div class=\"col-xs-12 col-md-6 title\"> <h2>Administración Usuarios</h2> </div> </div> <div class=\"row gutter-10\"> <div class=\"col-xs-12 col-md-2 col-lg-2\"> <div class=row> <div class=col-xs-12> <input id=filter type=text class=\"form-control input-lg w-full no-brd m-b\" placeholder=Buscar ng-model=filter_users /> </div> </div> <div class=row> <div class=col-xs-12> <ul class=lista-items-menu> <li ng-repeat=\"item in (filtered = (userList.users | filter:{$:filter_users}))\"> <a ng-click=userList.loadUser(item) class=\"{{(item.username == userList.username)?'active':''}}\"> <span>{{item.username}}</span> <p>{{item.name}}</p> <p class=\"badge bg-success ng-binding\">{{item.institution}}</p> <p class=\"{{(item.active == 'Inactive')?'badge bg-danger ng-binding':'badge bg-success ng-binding'}}\">{{item.active}}</p> </a> </li> </ul> </div> </div> </div> <div class=\"col-xs-12 col-md-10 col-lg-10\"> <div class=row> <div class=\"col-xs-12 col-md-7 col-lg-7 title-prog\"> <span>{{userList.username}}[{{userList.id}}]</span> <h3>{{userList.name}}</h3> </div> <div class=\"col-xs-12 col-md-5 col-lg-5\"> </div> </div> <div class=\"row gutter-10 scroll-70vh p-t\"> <div class=\"col-xs-12 col-md-12 p-t-lg\"> <div class=card> <div class=card-body> <div class=\"row b-b\"> <div class=\"col-xs-6 col-md-3\"> <div alt=\"\" class=p-b> <img ng-src={{picture}} style=width:150px;height:150px class=img-circle err-src={{notPicture}}> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Nombre Completo</h5> <p>{{userList.detailsUser.fullname}}</p> </div> <div class=p-b-md> <h5 class=text-azul-planner>Email</h5> <p>{{userList.detailsUser.mail}}</p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Username</h5> <p>{{userList.detailsUser.username}}</p> </div> <div class=p-b-md> <h5 class=text-azul-planner>Institución a la que pertenece</h5> <p>{{userList.detailsUser.institutionName}}</p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Estado &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ultimo Ingreso</h5> <span class=\"{{(userList.detailsUser.is_active == 'Inactive')?'badge bg-danger ng-binding':'badge bg-success ng-binding'}}\">{{userList.detailsUser.is_active}}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class=\"badge bg-warning ng-binding\"> {{userList.detailsUser.lastLogin.substring(0,16)}}</span> </div> <div class=p-b-md> <h5 class=text-azul-planner>Creado </h5> <span class=\"badge bg-primary ng-binding\">{{userList.detailsUser.createdAt.substring(0,10)}}</span> </div> </div> </div> <div class=row> <div class=col-xs-12> <h4 class=text-azul-planner>Configuración de Acceso</h4> </div> <div class=\"col-xs-12 col-md-6\"> <h5 class=text-azul-planner>Roles usuario</h5> <div ng-repeat=\"item in userList.detailsUser.roles\"> <p>{{item.rolename}}</p> </div> </div> <div class=\"col-xs-12 col-md-6 b-l p-r\"> <h5 class=text-azul-planner>Grupos Asociados</h5> <div ng-repeat=\"item in userList.detailsUser.groups\"> <p>{{item.groupname}}</p> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = "<div has-permission=acceso-administracion-usuarios-edit> <div class=row> <div class=\"col-xs-12 col-md-6 title\"> <h2>Crear Nuevo usuario</h2> </div> </div> <div class=\"row gutter-10\"> <div class=\"col-xs-12 col-md-12 col-lg-12\"> <div class=\"row gutter-12 scroll-70vh p-t\"> <div class=\"col-xs-12 col-md-12 p-t-lg\"> <div class=\"panel panel-card\"> <div class=panel-body> <div class=\"row b-b\"> <div class=col-xs-12> <h4 class=text-azul-planner>Información Personal</h4> </div> <form name=form> <div class=\"col-xs-6 col-md-3\"> <div alt=\"\" class=p-b> <img ng-src={{picture}} style=width:150px;height:150px class=img-circle err-src={{notPicture}}> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Nombre Completo</h5> <p><input type=text class=form-control placeholder=\"\" ng-model=name aria-invalid=false style=\"\"></p> </div> <div class=p-b-md> <h5 class=\"text-azul-planner has-error has-feedback\">Email <span class=\"error control-label\" ng-show=form.input.$error.email>: El correo no es válido!</span></h5> <p><input type=email class=form-control placeholder=\"\" ng-model=email name=input required aria-invalid=false style=\"\"> </p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Nombre Usuario</h5> <p><input type=text class=form-control placeholder=\"\" ng-model=username aria-invalid=false style=\"\"></p> </div> <div class=p-b-md> <h5 class=text-azul-planner>Institución a la que pertenece</h5> <p><select class=form-control ng-model=institution> <option value=1 selected=selected ng-disabled=true>Seleccione Institución....</option> <option value={{institutions.institutionid}} ng-repeat=\"institutions in userCreate.institutions\">{{institutions.institutioname}}</option> </select> </p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Password</h5> <p><input type=password class=form-control placeholder=password ng-model=password aria-invalid=false style=\"\"></p> </div> <div class=p-b-md> <h5 class=text-azul-planner>Ingrese su password Nuevamente</h5> <p><input type=password tooltip-placement=bottom tooltip=\"La contraseña debe ser igual a la ingresada arriba\" class=form-control placeholder=\"ingrese su password\" ng-model=password2 aria-invalid=false style=\"\"></p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Estado</h5> <p><label class=md-check> <input type=radio name=radio ng-value=true ng-model=status> <i class=blue></i>Activo </label>&nbsp;&nbsp;&nbsp; <label class=md-check> <input type=radio name=radio ng-value=false ng-model=status> <i class=blue></i>Inactivo </label> </p> </div> </div> </form></div> <div class=row> <div class=col-xs-12> <h4 class=text-azul-planner>Configuración de Acceso</h4> </div> <div class=\"col-xs-12 col-md-6\"> <h5 class=text-azul-planner>Roles usuario</h5> <div> <ui-select multiple=multiple ng-model=userCreate.rolesList theme=bootstrap close-on-select=false title=\"Seleccione Rol \" remove-selected=false> <ui-select-match placeholder=\"Seleccione Roles...\">{{$item.rolename}}</ui-select-match> <ui-select-choices repeat=\"roles in userCreate.roles\"> <div ng-bind-html=\"roles.name | highlight: $select.search\"></div> <small> <span ng-bind-html=\"''+roles.rolename | highlight: $select.search\"></span> </small> </ui-select-choices> </ui-select> </div> </div> <div class=\"col-xs-12 col-md-6 b-l p-r\"> <h5 class=text-azul-planner>Grupos Asociados</h5> <div> <ui-select multiple=multiple ng-model=userCreate.groupsList theme=bootstrap close-on-select=false title=\"Seleccione Grupos \" remove-selected=false> <ui-select-match placeholder=\"Seleccione grupos...\">{{$item.groupname}}</ui-select-match> <ui-select-choices repeat=\"groups in userCreate.groups\"> <div ng-bind-html=\"groups.name | highlight: $select.search\"></div> <small> <span ng-bind-html=\"''+groups.groupname | highlight: $select.search\"></span> </small> </ui-select-choices> </ui-select> </div> </div>  </div> <div class=row> <div class=col-xs-12> <div class=\"row botonera p-t\"> <div class=\"col-xs-12 col-md-3\"> <button md-ink-ripple ui-sref=app.users class=\"md-btn md-raised m-b btn-fw azul-planner\"><i class=\"i-24 mdi-navigation-arrow-back\"></i> Anterior<div class=md-ripple-container></div></button> </div> <div class=\"col-xs-12 col-md-9\"> <div class=pull-right> <button md-ink-ripple class=\"md-btn md-raised m-b btn-fw morado-planner\" ng-click=userCreate.save() ng-disabled=\"isDisabled || (name == '' || email == '' || username == '' || institution == 0 || password != password2 || userCreate.rolesList == 0)\" ng-model=isDisabled><i class=\"i-24 mdi-content-save\"></i> Guardar<div class=md-ripple-container></div></button> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-md has-permission=acceso-administracion-usuarios-edit> <div class=row> <div class=\"col-xs-12 col-md-6 title\"> <h2>Editar Usuario</h2> </div> </div> <div class=\"row gutter-10\"> <div class=\"col-xs-12 col-md-12 col-lg-12\"> <div class=\"row gutter-12 scroll-70vh p-t\"> <div class=\"col-xs-12 col-md-12 p-t-lg\"> <div class=\"panel panel-card\"> <div class=panel-body> <div class=\"row b-b\"> <div class=col-xs-12> <h4 class=text-azul-planner>Información Personal</h4> </div> <form name=form> <div class=\"col-xs-6 col-md-3\"> <div alt=\"\" class=p-b> <img ng-src={{picture}} style=width:150px;height:150px class=img-circle err-src={{notPicture}}> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Nombre Completo</h5> <p><input type=text class=form-control placeholder=\"\" ng-model=userEdit.name aria-invalid=false style=\"\"></p> </div> <div class=p-b-md> <h5 class=\"text-azul-planner has-error has-feedback\">Email <span class=\"error control-label\" ng-show=form.input.$error.email>: El correo no es válido!</span></h5> <p><input type=email class=form-control placeholder=\"\" ng-model=userEdit.email name=input required aria-invalid=false style=\"\"> </p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Nombre Usuario</h5> <p><input type=text class=form-control placeholder=\"\" ng-model=userEdit.username aria-invalid=false style=\"\"></p> </div> <div class=p-b-md> <h5 class=text-azul-planner>Institución a la que pertenece</h5> <p><select class=form-control id=institution ng-model=userEdit.institution> <option ng-selected=userEdit.selectedId{{institutions.institutionid}} ng-value={{institutions.institutionid}} ng-repeat=\"institutions in userEdit.institutions\">{{institutions.institutioname}}</option> </select> </p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Password</h5> <p><input type=password class=form-control placeholder=password ng-model=userEdit.password aria-invalid=false style=\"\"></p> </div> <div class=p-b-md> <h5 class=text-azul-planner>Ingrese su password Nuevamente</h5> <p><input type=password tooltip-placement=bottom tooltip=\"La contraseña debe ser igual a la ingresada arriba\" class=form-control placeholder=\"ingrese su password\" ng-model=userEdit.password2 aria-invalid=false style=\"\"></p> </div> </div> <div class=\"col-xs-6 col-md-3\"> <div class=p-b-md> <h5 class=text-azul-planner>Estado</h5> <p> <label class=md-check> <input type=radio name=radio ng-value=true ng-model=userEdit.status> <i class=blue></i>Activo </label>&nbsp;&nbsp;&nbsp; <label class=md-check> <input type=radio name=radio ng-value=false ng-model=userEdit.status> <i class=blue></i>Inactivo </label> </p> </div> </div> </form></div> <div class=row> <div class=col-xs-12> <h4 class=text-azul-planner>Configuración de Acceso</h4> </div> <div class=\"col-xs-12 col-md-6\"> <h5 class=text-azul-planner>Roles usuario</h5> <div> <ui-select multiple=multiple ng-model=userEdit.rolesList theme=bootstrap close-on-select=false title=\"Seleccione Rol \" remove-selected=false> <ui-select-match placeholder=\"Seleccione Roles...\">{{$item.rolename}}</ui-select-match> <ui-select-choices repeat=\"roles in ( userEdit.roles | filter: { rolename: $select.search }) track by roles.roleid \"> <div ng-bind-html=\"roles.name | highlight: $select.search\"></div> <small> <span ng-bind-html=\"''+roles.rolename | highlight: $select.search\"></span> </small> </ui-select-choices> </ui-select> </div> </div> <div class=\"col-xs-12 col-md-6 b-l p-r\"> <h5 class=text-azul-planner>Grupos Asociados</h5> <div> <ui-select multiple=multiple ng-model=userEdit.groupsList theme=bootstrap close-on-select=false title=\"Seleccione Grupos \" remove-selected=false> <ui-select-match placeholder=\"Seleccione grupos...\">{{$item.groupname}}</ui-select-match> <ui-select-choices repeat=\"groups in ( userEdit.groups | filter: { groupname: $select.search }) track by groups.groupid \"> <div ng-bind-html=\"groups.name | highlight: $select.search\"></div> <small> <span ng-bind-html=\"''+groups.groupname | highlight: $select.search\"></span> </small> </ui-select-choices> </ui-select> </div> </div>  </div> <div class=row> <div class=col-xs-12> <div class=\"row botonera p-t\"> <div class=\"col-xs-12 col-md-3\"> <button md-ink-ripple ui-sref=app.users class=\"md-btn md-raised m-b btn-fw azul-planner\"><i class=\"i-24 mdi-navigation-arrow-back\"></i> Anterior<div class=md-ripple-container></div></button> </div> <div class=\"col-xs-12 col-md-9\"> <div class=pull-right> <button md-ink-ripple class=\"md-btn md-raised m-b btn-fw morado-planner\" ng-click=userEdit.save() ng-disabled=\"isDisabled || ( userEdit.name == '' ||  userEdit.email == '' ||  userEdit.username == '' ||  userEdit.institution == 0 ||  userEdit.password !=  userEdit.password2 || userEdit.rolesList == 0)\" ng-model=isDisabled><i class=\"i-24 mdi-content-save\"></i> Guardar<div class=md-ripple-container></div></button> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-md has-permission=acceso-administracion-roles-view> <div class=row> <div class=\"col-xs-12 col-md-6 title\"> <h2 ng-show=titleList>Administración Roles Usuario</h2> <h2 ng-show=titleEdit>Edición Roles Usuario</h2> </div> </div> <div class=\"row gutter-10\"> <div class=\"col-xs-12 col-md-2 col-lg-2\"> <div class=row> <div class=col-xs-12> <input id=filter type=text class=\"form-control input-lg w-full no-brd m-b\" placeholder=Buscar ng-model=filter_roles /> </div> </div> <div class=row> <div class=col-xs-12> <ul class=lista-items-menu> <li ng-repeat=\"item in (filtered = (rolesList.roles | filter:{$:filter_roles}))\"> <a ng-click=rolesList.loadRoles(item) class=\"{{(item.roleid == rolesList.roleid)?'active':''}}\"> <span>Código : {{item.roleid}}</span> <p>{{item.rolename}}</p> <p class=\"{{(item.is_active == 'Inactive')?'badge bg-danger ng-binding':'badge bg-success ng-binding'}}\">{{item.is_active}}</p> </a> </li> </ul> </div> </div> </div> <div class=\"col-xs-12 col-md-10 col-lg-10\"> <div class=\"row m-b-md\"> <div class=\"col-xs-12 col-md-7 col-lg-7 title-prog\"> <span>Código:{{rolesList.roleid}}</span> <h5>{{rolesList.rolename}}</h5> </div> <div class=\"col-xs-12 col-md-5\"> <div class=pull-right data-toggle=buttons> <button md-ink-ripple=\"\" has-disabled=acceso-administracion-roles-edit ng-click=rolesList.editRoles() ng-show=edit type=button class=\"btn btn-fw btn-info pull-right md-button md-ink-ripple\"><i class=mdi-editor-border-color></i> Editar Roles</button> </div> <div class=\"col-xs-12 no-padding pull-right\"> <div> <button md-ink-ripple class=\"btn btn-fw btn-success pull-right md-button md-ink-ripple\" ng-show=editSave ng-click=rolesList.editRolesSave() ng-model=isDisabled ng-disabled=isDisabled><i class=\"i-24 mdi-content-save\"></i> Guardar<div class=md-ripple-container></div></button> </div> <div> <button md-ink-ripple class=\"btn btn-fw btn-cancel pull-right md-button md-ink-ripple\" ng-click=rolesList.cancelEditRoles() ng-show=editSave><i class=\"i-24 mdi-content-clear\"></i> Cancelar<div class=md-ripple-container></div></button> </div> </div> </div> </div> <div class=\"row gutter-10\"> <div class=\"col-xs-12 col-md-12\" ng-if=grid> <div ui-grid=rolesList.detailsRoles class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> </div> </div> </div> <style media=screen>.fade-in-out{transition:1s linear all;opacity:1}.fade-in-out.ng-hide{opacity:0}.hh{position:absolute;z-index:99999;bottom:0;width:95%}</style> ";

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-md has-permission=acceso-administracion-roles-edit> <div class=row> <div class=\"col-xs-12 col-md-6 title\"> <h2>Creación Roles Usuario</h2> </div> </div> <div class=\"row gutter-12\"> <div class=\"col-xs-12 col-md-12 col-lg-12\"> <div class=row> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <div class=\"panel panel-card\"> <div class=panel-body> <div class=form-group> <label for=nombre class=control-label>Ingrese Nombre de rol: </label> <input type=text class=form-control ng-model=name id=nombre placeholder=\"\"> </div> </div> </div> </div> </div> <div class=\"row gutter-12\"> <div class=\"col-xs-12 col-md-12\" ng-if=grid> <div ui-grid=rolesCreate.detailsRoles class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> </div> </div> <br> <div class=row> <div class=col-xs-12> <div class=\"row botonera\"> <div class=\"col-xs-12 col-md-3\"> <button md-ink-ripple ui-sref=app.roles class=\"md-btn md-raised m-b btn-fw azul-planner\"><i class=\"i-24 mdi-navigation-arrow-back\"></i> Anterior<div class=md-ripple-container></div></button> </div> <div class=\"col-xs-12 col-md-9\"> <div class=pull-right> <button md-ink-ripple class=\"md-btn md-raised m-b btn-fw morado-planner\" ng-click=rolesCreate.save() ng-disabled=\"isDisabled || (name == '')\" ng-model=isDisabled><i class=\"i-24 mdi-content-save\"></i> Guardar<div class=md-ripple-container></div></button> </div> </div> </div> </div> </div> </div> <style media=screen>.fade-in-out{transition:1s linear all;opacity:1}.fade-in-out.ng-hide{opacity:0}.hh{position:absolute;z-index:99999;bottom:0;width:95%}</style> ";

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-md has-permission=acceso-administracion-grupos-view> <div class=row> <div class=\"col-xs-12 col-md-6 title\"> <h2 ng-show=titleList>Administración Grupos de Usuario</h2> <h2 ng-show=titleEdit>Edición Roles Usuario</h2> </div> <div class=\"col-xs-12 col-md-6\"> <button md-ink-ripple has-disabled=acceso-administracion-grupos-edit ui-sref=app.groupsCreate class=\"md-btn md-raised m-b m-l btn-fw verde-web-planner p-btn-lg pull-right\">Crear Nuevo Grupo</button> </div> </div> <div class=\"row gutter-10\"> <div class=\"col-xs-12 col-md-2 col-lg-2\"> <div class=row> <div class=col-xs-12> <input id=filter type=text class=\"form-control input-lg w-full no-brd m-b\" placeholder=Buscar ng-model=filter_groups /> </div> </div> <div class=row> <div class=col-xs-12> <ul class=lista-items-menu> <li ng-repeat=\"item in (filtered = (groupsList.groups | filter:{$:filter_groups}))\"> <a ng-click=groupsList.loadGroups(item) class=\"{{(item.groupid == groupsList.groupid)?'active':''}}\"> <span>Código : {{item.groupid}}</span> <p>{{item.groupname}}</p> <p class=\"{{(item.active == 'Inactive')?'badge bg-danger ng-binding':'badge bg-success ng-binding'}}\">{{item.active}}</p> </a> </li> </ul> </div> </div> </div> <div class=\"col-xs-12 col-md-10 col-lg-10\"> <div class=\"row m-b-md\"> <div class=\"col-xs-12 col-md-7 col-lg-7 title-prog\"> <span>Código:{{groupsList.groupid}}</span> <h5>{{groupsList.groupname}}</h5> </div> <div class=\"col-xs-12 col-md-5\"> <div class=\"btn-group pull-right\" data-toggle=buttons> <button md-ink-ripple=\"\" has-disabled=acceso-administracion-grupos-edit ng-click=groupsList.editGroups() popover=Editar popover-placement=bottom popover-trigger=mouseenter type=button class=\"btn btn-lg btn-planner morado-planner md-ink-ripple\" ng-show=edit><i class=mdi-editor-border-color></i></button> <button md-ink-ripple=\"\" has-disabled=acceso-administracion-grupos-edit ng-click=groupsList.modalDelete() popover=Borrar popover-placement=bottom popover-trigger=mouseenter type=button class=\"btn btn-lg btn-planner morado-planner md-ink-ripple\"><i class=mdi-action-delete></i></button> </div> </div> </div> <div class=\"md-whiteframe-z0 bg-white\"> <ul class=\"nav nav-lines nav-tabs nav-justified\"> <li class=active> <a href=\"\" data-toggle=tab data-target=#campus ng-click=groupsList.showGridCampus()><h5>CAMPUS</h5></a> </li> <li> <a href=\"\" data-toggle=tab data-target=#career ng-click=groupsList.showGridCareer()><h5>CARRERA</h5></a> </li> <li> <a href=\"\" data-toggle=tab data-target=#apartament ng-click=groupsList.showGridDepartament()><h5>DEPARTAMENTO</h5></a> </li> </ul> <div class=\"tab-content no-padding clear b-t b-t-2x\"> <div role=tabpanel class=\"tab-pane animated fadeInDown active\" id=campus> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"> <div ng-if=gridCampus ui-grid=groupsList.detailsGroups class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> <div role=tabpanel class=\"tab-pane animated fadeInDown\" id=career> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"> <div ng-if=gridCareer ui-grid=groupsList.detailsGroupsCareer class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> <div role=tabpanel class=\"tab-pane animated fadeInDown\" id=apartament> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"> <div ng-if=gridDepartament ui-grid=groupsList.detailsGroupsDepartament class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> </div> </div> </div> </div> <br> <div class=row> <div class=col-xs-12> <div class=\"row botonera\"> <div class=\"col-xs-12 col-md-12\"> <div class=pull-right> <button md-ink-ripple class=\"md-btn md-raised m-b btn-fw morado-planner m-l\" ng-show=editSave ng-click=groupsList.editGroupsSave() ng-model=isDisabled ng-disabled=isDisabled><i class=\"i-24 mdi-content-save\"></i> Guardar<div class=md-ripple-container></div></button> </div> <div class=pull-right> <button md-ink-ripple class=\"md-btn md-raised m-b btn-fw rojo-planner m-l\" ng-click=groupsList.cancelEditGroups() ng-show=editSave><i class=\"i-24 mdi-content-clear\"></i> Cancelar<div class=md-ripple-container></div></button> </div> </div> </div> </div> </div> </div> <style media=screen>.fade-in-out{transition:1s linear all;opacity:1}.fade-in-out.ng-hide{opacity:0}.hh{position:absolute;z-index:99999;bottom:0;width:95%}</style> ";

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-md has-permission=acceso-administracion-grupos-edit> <div class=row> <div class=\"col-xs-12 col-md-6 title\"> <h2>Creación Grupos de Usuario</h2> </div> </div> <div class=\"row gutter-10\"> <div class=\"col-xs-12 col-md-12 col-lg-12\"> <div class=row> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <div class=\"panel panel-card\"> <div class=panel-body> <div class=\"form-group col-lg-6 col-md-6 col-sm-6 col-xs-6\"> <label for=nombre class=control-label>Ingrese Nombre de Grupo: </label> <input type=text class=form-control ng-model=name id=nombre placeholder=\"\"> </div> </div> </div> </div> </div> <div class=\"md-whiteframe-z0 bg-white\"> <ul class=\"nav nav-lines nav-tabs nav-justified\"> <li class=active> <a href=\"\" data-toggle=tab data-target=#campus ng-click=groupsCreate.showGridCampus()><h5>CAMPUS</h5></a> </li> <li> <a href=\"\" data-toggle=tab data-target=#career ng-click=groupsCreate.showGridCareer()><h5>CARRERA</h5></a> </li> <li> <a href=\"\" data-toggle=tab data-target=#departament ng-click=groupsCreate.showGridDepartament()><h5>DEPARTAMENTO</h5></a> </li> </ul> <div class=\"tab-content no-padding clear b-t b-t-2x\"> <div role=tabpanel class=\"tab-pane animated fadeInDown active p-b-md\" id=campus> <br> <div class=\"form-group col-md-4 pull-right\"> <select class=form-control ng-disabled=true> <option value=1>Filtro de Seleccion</option> <option value=2>Campus 1</option> <option value=3>Campus 2</option> <option value=4>Campus 3</option> </select> </div> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"> <div ng-if=gridCampus ui-grid=groupsCreate.detailsGroups class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> <div role=tabpanel class=\"tab-pane animated fadeInDown\" id=career> <br> <div class=\"form-group col-md-4 pull-right\"> <select class=form-control ng-disabled=true> <option value=1>Filtro de Seleccion</option> <option value=2>career 1</option> <option value=3>career 2</option> <option value=4>career 3</option> </select> </div> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"> <div ng-if=gridCareer ui-grid=groupsCreate.detailsGroupsCareer class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> <div role=tabpanel class=\"tab-pane animated fadeInDown\" id=departament> <br> <div class=\"form-group col-md-4 pull-right\"> <select class=form-control ng-disabled=true> <option value=1>Filtro de Seleccion</option> <option value=2>departament 1</option> <option value=3>departament 2</option> <option value=4>departament 3</option> </select> </div> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"> <div ng-if=gridDepartament ui-grid=groupsCreate.detailsGroupsDepartament class=grid style=height:550px ui-grid-pinning ui-grid-pagination></div> </div> </div> </div> </div> </div> </div> <br> <div class=row> <div class=col-xs-12> <div class=\"row botonera\"> <div class=\"col-xs-12 col-md-3\"> <button md-ink-ripple ui-sref=app.groups class=\"md-btn md-raised m-b btn-fw azul-planner\"><i class=\"i-24 mdi-navigation-arrow-back\"></i> Anterior<div class=md-ripple-container></div></button> </div> <div class=\"col-xs-12 col-md-9\"> <div class=pull-right> <button md-ink-ripple class=\"md-btn md-raised m-b btn-fw morado-planner\" ng-click=groupsCreate.save() ng-disabled=\"isDisabled || (name == '')\" ng-model=isDisabled><i class=\"i-24 mdi-content-save\"></i> Guardar<div class=md-ripple-container></div></button> </div> </div> </div> </div> </div> </div> <style media=screen>.fade-in-out{transition:1s linear all;opacity:1}.fade-in-out.ng-hide{opacity:0}.hh{position:absolute;z-index:99999;bottom:0;width:95%}</style> ";

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	                value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'adminPanel'];
	
	//funcion donde se definen la run
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, adminPanel) {
	                // MenuConstant[0]['menu'].push(adminPanel);
	}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP adminPanel
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> userListController
	* # As Controller --> userList
	* brief comment controller the view for the list user active admin-Panel
	*/
	
	var userListController = function () {
		function userListController($scope, $resource, $timeout, ngNotify, UserInfoConstant, userServices, $state, $modal) {
			_classCallCheck(this, userListController);
	
			var vm = this;
			this.ngNotify = ngNotify;
			this.$scope = $scope;
			vm.services = userServices.services;
			vm.modalDelete = modalDelete;
			vm.userEdit = userEdit;
			// $scope.notPicture= require("../images/no_user.jpg");
			$scope.picture = __webpack_require__(512);
	
			vm.init();
	
			function modalDelete() {
	
				$scope.userinfo = UserInfoConstant[0].details;
				$scope.idUser = this.id;
				$scope.nameUser = this.name;
				var modalInstance = $modal.open({
					template: __webpack_require__(513),
					animation: true,
					scope: $scope,
					controller: 'modalDeleteUserController',
					controllerAs: 'modalDeleteUser'
	
				});
			}
			function userEdit(id) {
				$state.go('app.userEdit', { id: id });
			}
		} //fin constructor
	
		//functions
	
		_createClass(userListController, [{
			key: 'loadUser',
			value: function loadUser(item) {
	
				this.params = {
	
					id: item.id
				};
	
				this.name = item.name;
				this.username = item.username;
				this.id = item.id;
				this.getDetailsUserFunction(this.params);
			}
		}, {
			key: 'init',
			value: function init(params) {
				var _this = this;
	
				this.services.getDataUsers(params).$promise.then(function (dataReturn) {
					if (dataReturn.data.lenght == 0) {
						_this.ngNotify.set('registro seleccionado no tiene registros', 'warn');
					} else {
	
						_this.users = dataReturn.data;
						_this.username = _this.users[0].username;
						_this.name = _this.users[0].name;
						_this.id = _this.users[0].id;
						_this.params = {
							id: _this.users[0].id
						};
						_this.getDetailsUserFunction(_this.params);
					}
				}, function (err) {
					_this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getDetailsUserFunction',
			value: function getDetailsUserFunction(params) {
				var _this2 = this;
	
				this.services.getDetailsUser(params).$promise.then(function (dataReturn) {
					if (dataReturn.data.lenght == 0) {
						_this2.ngNotify.set('registro seleccionado no tiene registros', 'warn');
					} else {
	
						_this2.detailsUser = dataReturn.data;
						console.log('details users', dataReturn.data);
					}
				}, function (err) {
					_this2.ngNotify.set('No se ha podido conectar con el servicio', 'error');
				});
			}
		}]);
	
		return userListController;
	}();
	
	exports.default = userListController;
	
	
	userListController.$inject = ['$scope', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', 'userServices', '$state', '$modal'];

/***/ }),
/* 512 */
391,
/* 513 */
/***/ (function(module, exports) {

	module.exports = " <style>.close,.modal-header{background-color:#0069a0;color:#fff!important;text-align:center;font-size:25px}.modal-footer{background-color:#f9f9f9}</style> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close ng-click=modalDeleteUser.cancel()> <span aria-hidden=true>&times;</span> </button> <h3 class=modal-title>Desactivar Usuario</h3> </div> <div class=modal-body> <b>¿Realmente desea Desactivar este registro?</b><br><br> <h4>Nombre Usuario: {{modalDeleteUser.name}} &nbsp;<span class=\"label label-danger\"> Código Usuario : {{modalDeleteUser.id}}</span></h4> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=modalDeleteUser.deleteUser()>Confirmar</button> <button class=\"btn btn-danger\" ng-click=modalDeleteUser.cancel()>Cancelar</button> </div> ";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP adminPanel
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> userCreateController
	* # As Controller --> userCreate
	* brief comment controller the view for the list user active admin-Panel
	*/
	
	var userCreateController = function () {
					function userCreateController($scope, $resource, $timeout, ngNotify, UserInfoConstant, userServices, $state) {
									_classCallCheck(this, userCreateController);
	
									var vm = this;
									this.ngNotify = ngNotify;
									this.$scope = $scope;
									this.$state = $state;
									vm.services = userServices.services;
									vm.save = save;
									$scope.name = '';
									$scope.email = '';
									$scope.username = '';
									$scope.status = true;
									$scope.institution = 0;
									this.$scope.afterSave = true;
									$scope.password = '';
									vm.rolesList = [];
									vm.groupsList = [];
									// $scope.notPicture= require("../images/no_user.jpg");
									$scope.picture = __webpack_require__(512);
	
									vm.init();
	
									function save() {
	
													$scope.isDisabled = true;
	
													var params = {
																	name: $scope.name,
																	email: $scope.email,
																	picture: $scope.file,
																	username: $scope.username,
																	institution: $scope.institution,
																	status: $scope.status,
																	password: $scope.password,
																	roles: vm.rolesList,
																	groups: vm.groupsList
													};
	
													vm.saveUser(params);
									}
					} //fin constructor
	
					//functions
	
					_createClass(userCreateController, [{
									key: 'init',
									value: function init() {
	
													this.getCataloguesRoles();
													this.getCataloguesGroups();
													this.getCataloguesInstitutions();
									}
					}, {
									key: 'getCataloguesRoles',
									value: function getCataloguesRoles() {
													var _this = this;
	
													this.services.getRoles().$promise.then(function (dataReturn) {
																	if (dataReturn.data.lenght == 0) {
																					_this.ngNotify.set('registro seleccionado no tiene registros', 'warn');
																	} else {
	
																					_this.roles = dataReturn.data;
																					console.log('Roles', dataReturn.data);
																	}
													}, function (err) {
																	_this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
													});
									}
					}, {
									key: 'getCataloguesGroups',
									value: function getCataloguesGroups() {
													var _this2 = this;
	
													this.services.getGroups().$promise.then(function (dataReturn) {
																	if (dataReturn.data.lenght == 0) {
																					_this2.ngNotify.set('registro seleccionado no tiene registros', 'warn');
																	} else {
	
																					_this2.groups = dataReturn.data;
																					console.log('Groups', dataReturn.data);
																	}
													}, function (err) {
																	_this2.ngNotify.set('No se ha podido conectar con el servicio', 'error');
													});
									}
					}, {
									key: 'getCataloguesInstitutions',
									value: function getCataloguesInstitutions() {
													var _this3 = this;
	
													this.services.getInstitutions().$promise.then(function (dataReturn) {
																	if (dataReturn.data.lenght == 0) {
																					_this3.ngNotify.set('registro seleccionado no tiene registros', 'warn');
																	} else {
	
																					_this3.institutions = dataReturn.data;
																					console.log('institutions', dataReturn.data);
																	}
													}, function (err) {
																	_this3.ngNotify.set('No se ha podido conectar con el servicio', 'error');
													});
									}
					}, {
									key: 'saveUser',
									value: function saveUser(params) {
													var _this4 = this;
	
													console.log('data envia servicio save', params);
	
													var dataValidate = {
																	email: params.email,
																	name: params.username
													};
	
													this.services.validateUser(dataValidate).$promise.then(function (dataReturn) {
																	if (dataReturn.status == 1) {
																					_this4.ngNotify.set('El usuario ingresado ya existe , intentelo usando otro correo y usuario', 'error');
																	} else {
																					_this4.services.saveUsers(params).$promise.then(function (dataReturn) {
																									if (dataReturn.status == 0) {
	
																													_this4.ngNotify.set('Se ha creado el usuario correctamente', 'success');
																													_this4.$state.go("app.users");
																									} else {
																													_this4.ngNotify.set('Error , con el servicio', 'error');
																													_this4.$scope.isDisabled = false;
																									}
																					}, function (err) {
																									_this4.ngNotify.set('No se ha podido conectar con el servicio', 'error');
																									_this4.$scope.isDisabled = false;
																					});
																	}
													}, function (err) {
																	_this4.ngNotify.set('No se ha podido conectar con el servicio', 'error');
																	_this4.$scope.isDisabled = false;
													});
									}
					}]);
	
					return userCreateController;
	}();
	
	exports.default = userCreateController;
	
	
	userCreateController.$inject = ['$scope', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', 'userServices', '$state'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP adminPanel
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> userCreateController
	* # As Controller --> userCreate
	* brief comment controller the view for the list user active admin-Panel
	*/
	
	var userEditController = function () {
					function userEditController($scope, $resource, $timeout, ngNotify, UserInfoConstant, userServices, $state, $location) {
									_classCallCheck(this, userEditController);
	
									var vm = this;
									this.ngNotify = ngNotify;
									this.$scope = $scope;
									this.$state = $state;
									vm.services = userServices.services;
									vm.save = save;
									$scope.name = '';
									$scope.email = '';
									$scope.username = '';
									$scope.status = true;
									$scope.institution = 0;
									$scope.password = '';
									vm.rolesList = [];
									vm.groupsList = [];
									// $scope.notPicture= require("../images/no_user.jpg");
									$scope.picture = __webpack_require__(512);
									vm.id = $location.search().id;
									vm.oldname = '';
	
									vm.init();
	
									function save() {
													var _params;
	
													$scope.isDisabled = true;
	
													var institution = '';
													if (typeof vm.institution === 'undefined') var institution = $('#institution').val();else institution = vm.institution;
	
													var params = (_params = {
																	username: vm.username,
																	name: vm.name,
																	email: vm.email,
																	picture: vm.file
													}, _defineProperty(_params, 'username', vm.username), _defineProperty(_params, 'institution', institution), _defineProperty(_params, 'status', vm.status), _defineProperty(_params, 'password', vm.password), _defineProperty(_params, 'roles', vm.rolesList), _defineProperty(_params, 'groups', vm.groupsList), _defineProperty(_params, 'oldname', vm.oldname), _defineProperty(_params, 'user_id', vm.id), _params);
	
													vm.saveUser(params);
									}
					} //fin constructor
	
					//functions
	
					_createClass(userEditController, [{
									key: 'init',
									value: function init() {
	
													this.getCataloguesInstitutions();
													this.getCataloguesRoles();
													this.getCataloguesGroups();
													this.getDetailsUserFunction({ id: this.id });
													// console.log('....',this.id);
									}
					}, {
									key: 'getDetailsUserFunction',
									value: function getDetailsUserFunction(params) {
													var _this = this;
	
													this.services.getDetailsUser(params).$promise.then(function (dataReturn) {
																	if (dataReturn.data.lenght == 0) {
																					_this.ngNotify.set('registro seleccionado no tiene registros', 'warn');
																	} else {
	
																					_this.detailsUser = dataReturn.data;
																					_this.name = _this.detailsUser.fullname;
																					_this.username = _this.detailsUser.username;
																					_this.password = _this.detailsUser.prim_keys;
																					_this.password2 = _this.detailsUser.prim_keys;
																					_this.email = _this.detailsUser.mail;
																					_this.oldname = _this.detailsUser.username;
																					// this.file,
																					if (_this.detailsUser.is_active == 'Active') _this.status = true;else _this.status = false;
	
																					$('#institution').val(_this.detailsUser.institutionID);
																					// this.institution=this.detailsUser.institutionID;
																					_this.groupsList = _this.detailsUser.groups;
																					_this.rolesList = _this.detailsUser.roles;
																					// this.groupname=['Servicios','developers'];
	
																					// this.rolesList,
																					// this.groupsList,
	
																					console.log('details users', dataReturn.data);
																	}
													}, function (err) {
																	_this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
													});
									}
					}, {
									key: 'getCataloguesRoles',
									value: function getCataloguesRoles() {
													var _this2 = this;
	
													this.services.getRoles().$promise.then(function (dataReturn) {
																	if (dataReturn.data.lenght == 0) {
																					_this2.ngNotify.set('registro seleccionado no tiene registros', 'warn');
																	} else {
	
																					_this2.roles = dataReturn.data;
																					console.log('Roles', dataReturn.data);
																	}
													}, function (err) {
																	_this2.ngNotify.set('No se ha podido conectar con el servicio', 'error');
													});
									}
					}, {
									key: 'getCataloguesGroups',
									value: function getCataloguesGroups() {
													var _this3 = this;
	
													this.services.getGroups().$promise.then(function (dataReturn) {
																	if (dataReturn.data.lenght == 0) {
																					_this3.ngNotify.set('registro seleccionado no tiene registros', 'warn');
																	} else {
	
																					_this3.groups = dataReturn.data;
																					console.log('Groups', dataReturn.data);
																	}
													}, function (err) {
																	_this3.ngNotify.set('No se ha podido conectar con el servicio', 'error');
													});
									}
					}, {
									key: 'getCataloguesInstitutions',
									value: function getCataloguesInstitutions() {
													var _this4 = this;
	
													this.services.getInstitutions().$promise.then(function (dataReturn) {
																	if (dataReturn.data.lenght == 0) {
																					_this4.ngNotify.set('registro seleccionado no tiene registros', 'warn');
																	} else {
	
																					_this4.institutions = dataReturn.data;
																					console.log('institutions', dataReturn.data);
																	}
													}, function (err) {
																	_this4.ngNotify.set('No se ha podido conectar con el servicio', 'error');
													});
									}
					}, {
									key: 'saveUser',
									value: function saveUser(params) {
													var _this5 = this;
	
													console.log('data envia servicio save', params);
	
													this.services.updateUser(params).$promise.then(function (dataReturn) {
																	if (dataReturn.status == 0) {
																					_this5.ngNotify.set('Usuario editado correctamente', 'success');
																					_this5.$state.go("app.users");
																	} else {
																					_this5.ngNotify.set('Error ,Usuario editado sin éxito', 'error');
																					_this5.$scope.isDisabled = false;
																	}
													}, function (err) {
																	_this5.ngNotify.set('No se ha podido conectar con el servicio', 'error');
																	_this5.$scope.isDisabled = false;
													});
									}
	
									// saveUser(params){
									// 	console.log('data envia servicio edit',params);
	
									// 	let dataValidate  = { 
									// 		email   : params.email ,
									//      name : params.username
									//   }
	
	
									// 	this.services.validateUser(dataValidate).$promise.then((dataReturn) => {
									// 		if(dataReturn.status == 1){
									// 			this.ngNotify.set('El usuario ingresado ya existe , intentelo otra usando otro correo y userio','error');
	
	
									// 		}else{
									// 				this.services.updateUser(params).$promise.then((dataReturn) => {
									// 					if(dataReturn.status == 0){
									// 						this.ngNotify.set('Usuario editado correctamente','success');
									// 						this.$state.go("app.users");
	
									// 					}else{
									// 						this.ngNotify.set('Error , con el servicio','error');
	
									// 					}
									// 				}, (err) => {
									// 					this.ngNotify.set('No se ha podido conectar con el servicio','error');
									// 				})
	
									// 		}
									// 	}, (err) => {
									// 		this.ngNotify.set('No se ha podido conectar con el servicio','error');
									// 	})
	
	
									// }
	
					}]);
	
					return userEditController;
	}();
	
	exports.default = userEditController;
	
	
	userEditController.$inject = ['$scope', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', 'userServices', '$state', '$location'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP cmmApp
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> modalDeleteUserController
	* # As Controller --> modalDeleteUser
	* controllador de modal para eliminar usuario 
	*/
	
	var modalDeleteUserController = function () {
	    function modalDeleteUserController($scope, $resource, $timeout, ngNotify, UserInfoConstant, userServices, $state, $modalInstance) {
	        _classCallCheck(this, modalDeleteUserController);
	
	        var vm = this;
	        vm.deleteUser = deleteUser;
	        this.ngNotify = ngNotify;
	        this.$state = $state;
	        vm.cancel = cancel;
	        this.$modalInstance = $modalInstance;
	        vm.services = userServices.services;
	        vm.id = $scope.idUser;
	        vm.name = $scope.nameUser;
	        vm.user = $scope.userinfo[0].user.id;
	
	        // /////////////////////////////
	
	        function deleteUser() {
	
	            var params = {
	
	                status: false,
	                id_code: vm.id
	
	            };
	
	            vm.deleteUserFunction(params);
	        }
	
	        function cancel() {
	
	            $modalInstance.dismiss('chao');
	        }
	    } //fin constructor
	
	
	    _createClass(modalDeleteUserController, [{
	        key: 'deleteUserFunction',
	        value: function deleteUserFunction(params) {
	            var _this = this;
	
	            console.log('data envia servicio save', params);
	
	            this.services.deleteUser(params).$promise.then(function (dataReturn) {
	                if (dataReturn.status == 0) {
	                    _this.ngNotify.set('El usuario ha sido desactivado de manera correcta', 'success');
	                    _this.$modalInstance.dismiss('chao');
	                    _this.$state.go(_this.$state.current, {}, { reload: true });
	                } else {
	                    _this.ngNotify.set('Error ,problemas con el servicio no se ha podidio eliminar el usuario', 'error');
	                }
	            }, function (err) {
	                _this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return modalDeleteUserController;
	}();
	
	exports.default = modalDeleteUserController;
	
	
	modalDeleteUserController.$inject = ['$scope', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', 'userServices', '$state', '$modalInstance'];

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP adminPanel
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name Services --> userViewController
	* services call backend for user in Admin Panel
	*/
	
	var userServices = function userServices($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, userServices);
	
	  var services = $resource(SERVICE_URL_CONSTANT.adminPanel + '/user-api/:route', {}, {
	    // var services = $resource(SERVICE_URL_CONSTANT.localJson +'/admin-panel/:routeJson',{},{
	
	
	    getDetailsUser: {
	      method: 'GET',
	      params: {
	        route: 'getUserDetails'
	        // routeJson: 'getUserDetails.json'
	      }
	    },
	
	    getDataUsers: {
	      method: 'GET',
	      params: {
	        route: 'getUsers'
	        // routeJson: 'getUser.json'
	      }
	    },
	
	    saveUsers: {
	      method: 'POST',
	      params: {
	        route: 'insertUserInfo'
	        // routeJson: 'insertUserInfo.json'
	      }
	    },
	    getRoles: {
	      method: 'GET',
	      params: {
	        route: 'getRole'
	        // routeJson: 'getRole.json'
	      }
	    },
	
	    getGroups: {
	      method: 'GET',
	      params: {
	        route: 'getGroups'
	        // routeJson: 'getGroups.json'
	      }
	    },
	
	    getInstitutions: {
	      method: 'GET',
	      params: {
	        route: 'getInstitutions'
	        // routeJson: 'getInstitutions.json'
	      }
	    },
	
	    deleteUser: {
	      method: 'POST',
	      params: {
	        route: 'deactiveUsers'
	      }
	    },
	
	    updateUser: {
	      method: 'POST',
	      params: {
	        route: 'updateUserInfo'
	      }
	    },
	
	    validateUser: {
	      method: 'GET',
	      params: {
	        route: 'validateUser'
	      }
	    }
	
	  });
	
	  return {
	    services: services
	  };
	};
	
	userServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	
	exports.default = angular.module('services.userServices', []).service('userServices', userServices).name;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP cmmApp
	* @autor camila.montenegro@u-planner.com
	* @description
	* # name controller --> rolesListController
	* # As Controller --> rolesList
	* brief comment controller shows the view for the main page of assignTimeRange
	*/
	
	var rolesListController = function () {
	    function rolesListController($scope, rolesServices, $resource, $mdDialog, $timeout, ngNotify, UserInfoConstant, $state, $modal, $location) {
	        _classCallCheck(this, rolesListController);
	
	        var vm = this;
	        this.$scope = $scope;
	        this.ngNotify = ngNotify;
	        this.$state = $state;
	        vm.services = rolesServices.services;
	        vm.modalDelete = modalDelete;
	        vm.editRolesSave = editRolesSave;
	        $scope.grid = true;
	        this.$scope.edit = true;
	        this.$scope.titleList = true;
	
	        //function devuelve id user
	
	        $timeout(function () {
	            $scope.userinfo = UserInfoConstant[0].details;
	            console.log('id usuario', $scope.userinfo[0]);
	            vm.user = $scope.userinfo[0].user.id;
	            vm.USER_ID = $scope.userinfo[0].user.id;
	        }, 500);
	
	        this.detailsRoles = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'mname',
	                displayName: 'Modulo',
	                width: '180'
	            }, {
	                field: 'fname',
	                displayName: 'Caracteristicas',
	                width: '380'
	            }, {
	                field: 'ds_permissions',
	                displayName: 'Permisos',
	                width: '380'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                enableSorting: false,
	                width: '90',
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" parse-int ng-true-value="true" ng-false-value="false" ng-click="grid.appScope.rolesList.selectAllItems(checker.checked)" ng-disabled="(grid.appScope.edit == true)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="true" ng-false-value="false" ng-disabled="(grid.appScope.edit == true)"> \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        vm.init();
	
	        function modalDelete() {
	
	            $scope.userinfo = UserInfoConstant[0].details;
	            $scope.roleid = this.roleid;
	            $scope.rolename = this.rolename;
	            var modalInstance = $modal.open({
	                template: __webpack_require__(519),
	                animation: true,
	                scope: $scope,
	                controller: 'modalDeleteRolesController',
	                controllerAs: 'modalDeleteRoles'
	
	            });
	        }
	
	        function editRolesSave() {
	
	            $scope.isDisabled = true;
	
	            var arrayRoles = [];
	            angular.forEach(this.detailsRoles.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayRoles.push({ fid: value.fid, mid: value.mid, permission: value.ds_permissions });
	                }
	            });
	
	            var rolesList = arrayRoles;
	            var params = {
	                id: this.roleid,
	                roles: rolesList
	
	            };
	
	            vm.saveEditRoles(params);
	        }
	    } //Fin constructor
	
	    //functions
	
	    _createClass(rolesListController, [{
	        key: 'loadRoles',
	        value: function loadRoles(item) {
	
	            this.params = {
	
	                id: item.roleid
	            };
	
	            this.roleid = item.roleid;
	            this.rolename = item.rolename;
	            this.getDetailsRolesFunction(this.params);
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.services.getRoles().$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this.ngNotify.set('no existen registros', 'warn');
	                } else {
	
	                    _this.roles = dataReturn.data;
	                    _this.roleid = _this.roles[0].roleid;
	                    _this.rolename = _this.roles[0].rolename;
	                    _this.params = {
	                        id: _this.roles[0].roleid
	                    };
	                    _this.getDetailsRolesFunction(_this.params);
	                }
	            }, function (err) {
	                _this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'selectAllItems',
	        value: function selectAllItems(value) {
	
	            this.detailsRoles.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'getDetailsRolesFunction',
	        value: function getDetailsRolesFunction(params) {
	            var _this2 = this;
	
	            this.services.getDetailsRoles(params).$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this2.ngNotify.set('registro seleccionado no tiene registros', 'warn');
	                } else {
	
	                    _this2.detailsRoles.data = dataReturn.data;
	                    console.log('details Roles', dataReturn.data);
	                }
	            }, function (err) {
	                _this2.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'editRoles',
	        value: function editRoles() {
	
	            this.$scope.editSave = true;
	            this.$scope.edit = false;
	            this.$scope.titleList = false;
	            this.$scope.titleEdit = true;
	            this.$scope.isDisabled = false;
	        }
	    }, {
	        key: 'cancelEditRoles',
	        value: function cancelEditRoles() {
	
	            this.$scope.editSave = false;
	            this.$scope.edit = true;
	            this.$scope.titleList = true;
	            this.$scope.titleEdit = false;
	            this.getDetailsRolesFunction({ id: this.roleid });
	        }
	    }, {
	        key: 'saveEditRoles',
	        value: function saveEditRoles(params) {
	            var _this3 = this;
	
	            console.log('esto es lo que se envia', params);
	
	            var updateRoles = {
	                roleid: params.id,
	                values: params.roles
	            };
	
	            this.services.insertRolePermission(updateRoles).$promise.then(function (dataReturn) {
	                if (dataReturn.status == 0) {
	                    _this3.ngNotify.set('Se ha modificado de manera correcta el rol', 'success');
	                    // this.$state.go(this.$state.current, {}, {reload: true});
	                    _this3.$scope.edit = true;
	                    _this3.$scope.editSave = false;
	                    _this3.$scope.titleList = true;
	                    _this3.$scope.titleEdit = false;
	                } else {
	                    console.log('Error Servicio update check params enviados', dataRoles);
	                    _this3.$scope.isDisabled = false;
	                }
	            }, function (err) {
	                _this3.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	                _this3.$scope.isDisabled = false;
	            });
	        }
	    }]);
	
	    return rolesListController;
	}(); // fin function principal
	
	
	exports.default = rolesListController;
	rolesListController.$inject = ['$scope', 'rolesServices', '$resource', '$mdDialog', '$timeout', 'ngNotify', 'UserInfoConstant', '$state', '$modal', '$location'];

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = " <style>.close,.modal-header{background-color:#0069a0;color:#fff!important;text-align:center;font-size:25px}.modal-footer{background-color:#f9f9f9}</style> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close ng-click=modalDeleteRoles.cancel()> <span aria-hidden=true>&times;</span> </button> <h3 class=modal-title>Desactivar Roles</h3> </div> <div class=modal-body> <b>¿Realmente desea Desactivar este registro?</b><br><br> <h4>Nombre Rol: {{modalDeleteRoles.name}} &nbsp;<span class=\"label label-danger\"> Código Rol : {{modalDeleteRoles.id}}</span></h4> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=modalDeleteRoles.deleteRoles()>Confirmar</button> <button class=\"btn btn-danger\" ng-click=modalDeleteRoles.cancel()>Cancelar</button> </div> ";

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP cmmApp
	* @autor camila.montenegro@u-planner.com
	* @description
	* # name controller --> rolesCreateController
	* # As Controller --> rolesCreate
	* brief comment controller creation roles users
	*/
	
	var rolesCreateController = function () {
	    function rolesCreateController($scope, rolesServices, $resource, $mdDialog, $timeout, ngNotify, UserInfoConstant, $state, $modal, $location) {
	        _classCallCheck(this, rolesCreateController);
	
	        var vm = this;
	        this.$scope = $scope;
	        this.ngNotify = ngNotify;
	        this.$state = $state;
	        vm.services = rolesServices.services;
	        vm.save = save;
	        $scope.name = '';
	        $scope.grid = true;
	
	        //function devuelve id user
	
	        $timeout(function () {
	            $scope.userinfo = UserInfoConstant[0].details;
	            console.log('id usuario', $scope.userinfo[0]);
	            vm.user = $scope.userinfo[0].user.id;
	            vm.USER_ID = $scope.userinfo[0].user.id;
	        }, 500);
	
	        this.detailsRoles = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'mname',
	                displayName: 'Modulo'
	                // width: '210'
	            }, {
	                field: 'fname',
	                displayName: 'Caracteristicas'
	                // width: '460'
	            }, {
	                field: 'ds_permissions',
	                displayName: 'Permisos'
	                // width: '460'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                // width: '110',
	                enableSorting: false,
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" ng-click="grid.appScope.rolesCreate.selectAllItems(checker.checked)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="true" ng-false-value="false" > \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        vm.init();
	
	        function save() {
	
	            $scope.isDisabled = true;
	
	            var arrayRoles = [];
	            angular.forEach(this.detailsRoles.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayRoles.push({ fid: value.fid, mid: value.mid, permission: value.ds_permissions });
	                }
	            });
	
	            var rolesList = arrayRoles;
	            var params = {
	                name: $scope.name,
	                user_id: vm.USER_ID,
	                roles: rolesList
	
	            };
	
	            vm.saveRoles(params);
	        }
	    } //Fin constructor
	
	    //functions
	
	    _createClass(rolesCreateController, [{
	        key: 'init',
	        value: function init() {
	
	            this.getDetailsRolesFunction();
	        }
	    }, {
	        key: 'selectAllItems',
	        value: function selectAllItems(value) {
	            this.detailsRoles.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'getDetailsRolesFunction',
	        value: function getDetailsRolesFunction() {
	            var _this = this;
	
	            this.services.getDetailsRoles().$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this.ngNotify.set('registro seleccionado no tiene registros', 'warn');
	                } else {
	
	                    _this.detailsRoles.data = dataReturn.data;
	                    console.log('details Roles', dataReturn.data);
	                }
	            }, function (err) {
	                _this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'saveRoles',
	        value: function saveRoles(params) {
	            var _this2 = this;
	
	            console.log('data envia servicio save', params);
	
	            if (params.roles.length > 0) {
	                this.services.saveRoles(params).$promise.then(function (dataReturn) {
	                    if (dataReturn.status == 0) {
	
	                        _this2.idRole = dataReturn.data;
	
	                        var dataRoles = {
	                            roleid: _this2.idRole,
	                            values: params.roles
	                        };
	
	                        _this2.services.insertRolePermission(dataRoles).$promise.then(function (dataReturn) {
	                            console.log('se han asociado los permisos correctamente a al rol creado');
	                        });
	
	                        _this2.ngNotify.set('Se ha creado el Rol correctamente', 'success');
	                        _this2.$state.go("app.roles");
	                    } else {
	                        _this2.ngNotify.set('Error con servicio check request', 'error');
	                        _this2.$scope.isDisabled = false;
	                    }
	                }, function (err) {
	                    _this2.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	                    _this2.$scope.isDisabled = false;
	                });
	            } else {
	                this.ngNotify.set('Error , Seleccione permisos para nuevo Rol', 'error');
	                this.$scope.isDisabled = false;
	            }
	        }
	    }]);
	
	    return rolesCreateController;
	}(); // fin function principal
	
	
	exports.default = rolesCreateController;
	rolesCreateController.$inject = ['$scope', 'rolesServices', '$resource', '$mdDialog', '$timeout', 'ngNotify', 'UserInfoConstant', '$state', '$modal', '$location'];

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP cmmApp
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> modalDeleteRolesController
	* # As Controller --> modalDeleteRoles
	* controllador de modal para eliminar rol 
	*/
	
	var modalDeleteRolesController = function () {
	    function modalDeleteRolesController($scope, $resource, $timeout, ngNotify, UserInfoConstant, rolesServices, $state, $modalInstance) {
	        _classCallCheck(this, modalDeleteRolesController);
	
	        var vm = this;
	        vm.deleteRoles = deleteRoles;
	        this.$state = $state;
	        vm.cancel = cancel;
	        this.$modalInstance = $modalInstance;
	        this.ngNotify = ngNotify;
	        vm.services = rolesServices.services;
	        vm.id = $scope.roleid;
	        vm.name = $scope.rolename;
	        vm.user = $scope.userinfo[0].user.id;
	
	        // /////////////////////////////
	
	        function deleteRoles() {
	
	            var params = {
	
	                status: false,
	                id_code: vm.id
	
	            };
	
	            vm.deleteRolesFunction(params);
	        }
	
	        function cancel() {
	
	            $modalInstance.dismiss('chao');
	        }
	    } //fin constructor
	
	
	    _createClass(modalDeleteRolesController, [{
	        key: 'deleteRolesFunction',
	        value: function deleteRolesFunction(params) {
	            var _this = this;
	
	            console.log('data envia servicio save', params);
	
	            this.services.deleteRoles(params).$promise.then(function (dataReturn) {
	                if (dataReturn.status == 0) {
	                    _this.ngNotify.set('El Rol ha sido desactivado de manera correcta', 'success');
	                    _this.$modalInstance.dismiss('chao');
	                    _this.$state.go(_this.$state.current, {}, { reload: true });
	                } else {
	                    _this.ngNotify.set('Error ,problemas con el servicio no se ha podidio eliminar el Rol', 'error');
	                }
	            }, function (err) {
	                _this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return modalDeleteRolesController;
	}();
	
	exports.default = modalDeleteRolesController;
	
	
	modalDeleteRolesController.$inject = ['$scope', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', 'rolesServices', '$state', '$modalInstance'];

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var rolesServices = function rolesServices($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, rolesServices);
	
	  var services = $resource(SERVICE_URL_CONSTANT.adminPanel + '/user-api/:route', {}, {
	    // var services = $resource(SERVICE_URL_CONSTANT.localJson +'/admin-panel/:routeJson',{},{
	
	    getRoles: {
	      method: 'GET',
	      params: {
	        route: 'getRole'
	        // routeJson: 'getRole.json'
	      }
	    },
	
	    getDetailsRoles: {
	      method: 'GET',
	      params: {
	        route: 'getAllPermissionsByrole'
	        // routeJson: 'getAllPermissionsByrole.json'
	      }
	    },
	
	    getDetailsRolesActive: {
	      method: 'GET',
	      params: {
	        route: 'getAllPermissionsByroleActive'
	        // routeJson: 'getAllPermissionsByroleActive.json'
	      }
	    },
	
	    saveRoles: {
	      method: 'POST',
	      params: {
	        route: 'insertRoles'
	        // routeJson: 'insertRoles.json'
	      }
	    },
	
	    deleteRoles: {
	      method: 'POST',
	      params: {
	        route: 'deactiveRole'
	      }
	    },
	
	    insertRolePermission: {
	      method: 'POST',
	      params: {
	        route: 'insertRolePermission'
	      }
	    },
	
	    editRole: {
	      method: 'POST',
	      params: {
	        route: 'updateRole'
	      }
	    }
	
	  });
	
	  return {
	    services: services
	  };
	};
	
	rolesServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	
	exports.default = angular.module('services.rolesServices', []).service('rolesServices', rolesServices).name;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP cmmApp
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> groupsListController
	* # As Controller --> groupsList
	* brief comment controller shows the main view groupsList
	*/
	
	var groupsListController = function () {
	    function groupsListController($scope, groupsServices, $resource, $mdDialog, $timeout, ngNotify, UserInfoConstant, $state, $modal, $location) {
	        _classCallCheck(this, groupsListController);
	
	        var vm = this;
	        this.$scope = $scope;
	        this.ngNotify = ngNotify;
	        vm.services = groupsServices.services;
	        vm.modalDelete = modalDelete;
	        vm.showGridCareer = showGridCareer;
	        vm.showGridCampus = showGridCampus;
	        vm.showGridDepartament = showGridDepartament;
	        vm.editGroupsSave = editGroupsSave;
	        this.$scope.edit = true;
	        this.$scope.titleList = true;
	        $scope.gridCampus = true;
	        $scope.gridCareer = false;
	        $scope.gridDepartament = false;
	        //function devuelve id user
	
	        $timeout(function () {
	            $scope.userinfo = UserInfoConstant[0].details;
	            console.log('id usuario', $scope.userinfo[0]);
	            vm.user = $scope.userinfo[0].user.id;
	            vm.USER_ID = $scope.userinfo[0].user.id;
	        }, 500);
	
	        this.detailsGroups = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'institucionName',
	                displayName: 'Institucion'
	                // width: '220'
	            }, {
	                field: 'campusName',
	                displayName: 'Campus'
	                // width: '410'
	            }, {
	                field: 'periodName',
	                displayName: 'Período'
	                // width: '220'
	            }, {
	                field: 'jornadaName',
	                displayName: 'Jornada'
	                // width: '220'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                enableSorting: false,
	                // width: '120',
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" parse-int ng-true-value="1" ng-false-value="0" ng-click="grid.appScope.groupsList.selectAllCampus(checker.checked)" ng-disabled="(grid.appScope.edit == true)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="1" ng-false-value="0" ng-disabled="(grid.appScope.edit == true)"> \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        this.detailsGroupsCareer = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'institution_name',
	                displayName: 'Institucion'
	                // width: '230'
	            }, {
	                field: 'faculty_name',
	                displayName: 'Unidad Académica'
	                // width: '380'
	            }, {
	                field: 'career_name',
	                displayName: 'Carrera'
	                // width: '310'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                enableSorting: false,
	                // width: '90',
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" parse-int ng-true-value="1" ng-false-value="0" ng-click="grid.appScope.groupsList.selectAllCareer(checker.checked)" ng-disabled="(grid.appScope.edit == true)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="1" ng-false-value="0" ng-disabled="(grid.appScope.edit == true)"> \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        this.detailsGroupsDepartament = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'institution_name',
	                displayName: 'Institucion'
	                // width: '230'
	            }, {
	                field: 'unit_name',
	                displayName: 'Unidad Académica'
	                // width: '380'
	            }, {
	                field: 'faculty_name',
	                displayName: 'Departamento'
	                // width: '310'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                enableSorting: false,
	                // width: '90',
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" parse-int ng-true-value="1" ng-false-value="0" ng-click="grid.appScope.groupsList.selectAllDepartament(checker.checked)" ng-disabled="(grid.appScope.edit == true)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="1" ng-false-value="0" ng-disabled="(grid.appScope.edit == true)"> \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        vm.init();
	
	        function modalDelete() {
	
	            $scope.userinfo = UserInfoConstant[0].details;
	            $scope.groupid = this.groupid;
	            $scope.groupname = this.groupname;
	            var modalInstance = $modal.open({
	                template: __webpack_require__(524),
	                animation: true,
	                scope: $scope,
	                controller: 'modalDeleteGroupsController',
	                controllerAs: 'modalDeleteGroups'
	
	            });
	        }
	
	        function showGridCareer() {
	
	            $scope.gridCampus = false;
	            $scope.gridCareer = true;
	            $scope.gridDepartament = false;
	        }
	
	        function showGridDepartament() {
	
	            $scope.gridCampus = false;
	            $scope.gridCareer = false;
	            $scope.gridDepartament = true;
	        }
	
	        function showGridCampus() {
	            $scope.gridCampus = true;
	            $scope.gridCareer = false;
	            $scope.gridDepartament = false;
	        }
	
	        function editGroupsSave() {
	
	            $scope.isDisabled = true;
	
	            var arrayValues = [];
	            angular.forEach(this.detailsGroups.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayValues.push({ section_name: 'upl_campus_academicperiod_shift', section_id: value.id_section });
	                }
	            });
	
	            angular.forEach(this.detailsGroupsCareer.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayValues.push({ section_name: 'upl_careers', section_id: value.id_section });
	                }
	            });
	
	            angular.forEach(this.detailsGroupsDepartament.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayValues.push({ section_name: 'upl_academicunits', section_id: value.id_section });
	                }
	            });
	
	            var values = arrayValues;
	
	            var params = {
	
	                name: $scope.name,
	                user_id: vm.USER_ID,
	                values: values
	
	            };
	
	            vm.saveGroupsRoles(params);
	        }
	    } //Fin constructor
	
	    //functions
	
	    _createClass(groupsListController, [{
	        key: 'loadGroups',
	        value: function loadGroups(item) {
	
	            this.params = {
	
	                id: item.groupid
	            };
	
	            this.groupid = item.groupid;
	            this.groupname = item.groupname;
	            this.getDetailsGroupsFunction(this.params);
	            this.getDetailsGroupsCareerFunction(this.params);
	            this.getDetailsGroupsDepartamentFunction(this.params);
	        }
	    }, {
	        key: 'editGroups',
	        value: function editGroups() {
	
	            this.$scope.editSave = true;
	            this.$scope.edit = false;
	            this.$scope.titleList = false;
	            this.$scope.titleEdit = true;
	            this.$scope.isDisabled = false;
	        }
	    }, {
	        key: 'cancelEditGroups',
	        value: function cancelEditGroups() {
	
	            this.$scope.editSave = false;
	            this.$scope.edit = true;
	            this.$scope.titleList = true;
	            this.$scope.titleEdit = false;
	            this.getDetailsGroupsFunction({ id: this.groupid });
	            this.getDetailsGroupsCareerFunction({ id: this.groupid });
	            this.getDetailsGroupsDepartamentFunction({ id: this.groupid });
	        }
	    }, {
	        key: 'selectAllCampus',
	        value: function selectAllCampus(value) {
	
	            this.detailsGroups.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'selectAllCareer',
	        value: function selectAllCareer(value) {
	
	            this.detailsGroupsCareer.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'selectAllDepartament',
	        value: function selectAllDepartament(value) {
	
	            this.detailsGroupsDepartament.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.services.getGroups().$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this.ngNotify.set('no existen registros', 'warn');
	                } else {
	
	                    _this.groups = dataReturn.data;
	                    _this.groupid = _this.groups[0].groupid;
	                    _this.groupname = _this.groups[0].groupname;
	                    _this.params = {
	                        id: _this.groups[0].groupid
	                    };
	                    _this.getDetailsGroupsFunction(_this.params);
	                    _this.getDetailsGroupsCareerFunction(_this.params);
	                    _this.getDetailsGroupsDepartamentFunction(_this.params);
	                }
	            }, function (err) {
	                _this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'getDetailsGroupsFunction',
	        value: function getDetailsGroupsFunction(params) {
	            var _this2 = this;
	
	            this.services.getAllPermissionsByCampusByGroup(params).$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this2.ngNotify.set('registro seleccionado no tiene registros', 'warn');
	                } else {
	
	                    _this2.detailsGroups.data = dataReturn.data;
	                    console.log('details groups', dataReturn.data);
	                }
	            }, function (err) {
	                _this2.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'getDetailsGroupsCareerFunction',
	        value: function getDetailsGroupsCareerFunction(params) {
	            var _this3 = this;
	
	            this.services.getAllPermissionsByCareerByGroup(params).$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this3.ngNotify.set('registro seleccionado no tiene registros', 'warn');
	                } else {
	
	                    _this3.detailsGroupsCareer.data = dataReturn.data;
	                    console.log('details groups', dataReturn.data);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'getDetailsGroupsDepartamentFunction',
	        value: function getDetailsGroupsDepartamentFunction(params) {
	            var _this4 = this;
	
	            this.services.getAllPermissionsByDepartmentByGroup(params).$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this4.ngNotify.set('registro seleccionado no tiene registros', 'warn');
	                } else {
	
	                    _this4.detailsGroupsDepartament.data = dataReturn.data;
	                    console.log('details groups', dataReturn.data);
	                }
	            }, function (err) {
	                _this4.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'saveGroupsRoles',
	        value: function saveGroupsRoles(params) {
	            var _this5 = this;
	
	            console.log('esto es lo que se envia', params);
	
	            var updateGroups = {
	                groupid: this.groupid,
	                values: params.values
	            };
	
	            this.services.saveGroupsPermissions(updateGroups).$promise.then(function (dataReturn) {
	                if (dataReturn.status == 0) {
	                    _this5.ngNotify.set('se ha modificado de manera correcta el Grupo', 'success');
	                    // this.$state.go(this.$state.current, {}, {reload: true});
	                    _this5.$scope.edit = true;
	                    _this5.$scope.editSave = false;
	                    _this5.$scope.titleList = true;
	                    _this5.$scope.titleEdit = false;
	                } else {
	                    console.log('Error Servicio update check params enviados', dataRoles);
	                    _this5.$scope.isDisabled = false;
	                }
	            }, function (err) {
	                _this5.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	                _this5.$scope.isDisabled = false;
	            });
	        }
	    }]);
	
	    return groupsListController;
	}(); // fin function principal
	
	
	exports.default = groupsListController;
	groupsListController.$inject = ['$scope', 'groupsServices', '$resource', '$mdDialog', '$timeout', 'ngNotify', 'UserInfoConstant', '$state', '$modal', '$location'];

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = " <style>.close,.modal-header{background-color:#0069a0;color:#fff!important;text-align:center;font-size:25px}.modal-footer{background-color:#f9f9f9}</style> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close ng-click=modalDeleteGroups.cancel()> <span aria-hidden=true>&times;</span> </button> <h3 class=modal-title>Desactivar Grupos</h3> </div> <div class=modal-body> <b>¿Realmente desea Desactivar este registro?</b><br><br> <h4>Nombre grupo: {{modalDeleteGroups.name}} &nbsp;<span class=\"label label-danger\"> Código grupo : {{modalDeleteGroups.id}}</span></h4> </div> <div class=modal-footer> <button class=\"btn btn-success\" ng-click=modalDeleteGroups.deleteGroups()>Confirmar</button> <button class=\"btn btn-danger\" ng-click=modalDeleteGroups.cancel()>Cancelar</button> </div> ";

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP AdminPanel
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> groupsCreateController
	* # As Controller --> groupsCreate
	* brief comment controller shows the main view groups-Create
	*/
	var groupsCreateController = function () {
	    function groupsCreateController($scope, groupsServices, $resource, $mdDialog, $timeout, ngNotify, UserInfoConstant, $state, $modal, $location) {
	        _classCallCheck(this, groupsCreateController);
	
	        var vm = this;
	        this.$scope = $scope;
	        this.ngNotify = ngNotify;
	        this.$state = $state;
	        vm.services = groupsServices.services;
	        vm.save = save;
	        vm.showGridCareer = showGridCareer;
	        vm.showGridCampus = showGridCampus;
	        vm.showGridDepartament = showGridDepartament;
	        $scope.name = '';
	        $scope.gridCampus = true;
	
	        //function devuelve id user
	
	        $timeout(function () {
	            $scope.userinfo = UserInfoConstant[0].details;
	            console.log('id usuario', $scope.userinfo[0]);
	            vm.user = $scope.userinfo[0].user.id;
	            vm.USER_ID = $scope.userinfo[0].user.id;
	        }, 500);
	
	        this.detailsGroups = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'institucionName',
	                displayName: 'Institucion',
	                width: '300'
	            }, {
	                field: 'campusName',
	                displayName: 'Campus',
	                width: '400'
	            }, {
	                field: 'periodName',
	                displayName: 'Período',
	                width: '400'
	            }, {
	                field: 'jornadaName',
	                displayName: 'Jornada',
	                width: '210'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                enableSorting: false,
	                width: '80',
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" parse-int ng-true-value="1" ng-false-value="0" ng-click="grid.appScope.groupsCreate.selectAllCampus(checker.checked)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="1" ng-false-value="0"> \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        this.detailsGroupsCareer = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'institution_name',
	                displayName: 'Institucion'
	                // width: '220'
	            }, {
	                field: 'faculty_name',
	                displayName: 'Facultad'
	                // width: '450'
	            }, {
	                field: 'career_name',
	                displayName: 'Carrera'
	                // width: '450'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                enableSorting: false,
	                // width: '90',
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" parse-int ng-true-value="1" ng-false-value="0" ng-click="grid.appScope.groupsCreate.selectAllCareer(checker.checked)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="1" ng-false-value="0"> \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        this.detailsGroupsDepartament = {
	
	            enableFiltering: true,
	            // data:$scope.gridData
	
	            columnDefs: [{
	                field: 'institution_name',
	                displayName: 'Institucion'
	                // width: '220'
	            }, {
	                field: 'unit_name',
	                displayName: 'Unidad Académica'
	                // width: '450'
	            }, {
	                field: 'faculty_name',
	                displayName: 'Facultad'
	                // width: '450'
	            }, {
	                field: 'hasPermission',
	                displayName: 'Estado',
	                enableFiltering: false,
	                enableSorting: false,
	                // width: '90',
	                headerCellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center p-v"><label class="md-check"> \
	                                        <input type="checkbox" ng-model="checker.checked" parse-int ng-true-value="1" ng-false-value="0" ng-click="grid.appScope.groupsCreate.selectAllDepartament(checker.checked)"> \
	                                        <i class="green"></i></label></span></div>',
	                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="text-center"><label class="md-check"> \
	                                    <input type="checkbox" ng-model="row.entity.hasPermission" parse-int ng-true-value="1" ng-false-value="0"> \
	                                    <i class="green"></i></label></span></div>'
	
	            }]
	        };
	
	        vm.init();
	
	        function save() {
	
	            $scope.isDisabled = true;
	
	            var arrayValues = [];
	            angular.forEach(this.detailsGroups.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayValues.push({ section_name: 'upl_campus_academicperiod_shift', section_id: value.id_section });
	                }
	            });
	
	            angular.forEach(this.detailsGroupsCareer.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayValues.push({ section_name: 'upl_careers', section_id: value.id_section });
	                }
	            });
	
	            angular.forEach(this.detailsGroupsDepartament.data, function (value, key) {
	                if (value.hasPermission == true) {
	                    arrayValues.push({ section_name: 'upl_academicunits', section_id: value.id_section });
	                }
	            });
	
	            var values = arrayValues;
	
	            var params = {
	                name: $scope.name,
	                user_id: vm.USER_ID,
	                values: values
	
	            };
	
	            vm.saveGroups(params);
	        }
	
	        function showGridCareer() {
	
	            $scope.gridCampus = false;
	            $scope.gridCareer = true;
	            $scope.gridDepartament = false;
	        }
	
	        function showGridDepartament() {
	
	            $scope.gridCampus = false;
	            $scope.gridCareer = false;
	            $scope.gridDepartament = true;
	        }
	
	        function showGridCampus() {
	            $scope.gridCampus = true;
	            $scope.gridCareer = false;
	            $scope.gridDepartament = false;
	        }
	    }
	
	    //Fin constructor
	
	    //functions
	
	    _createClass(groupsCreateController, [{
	        key: 'init',
	        value: function init() {
	
	            this.getDetailsGroupsFunction();
	            this.getDetailsGroupsCareerFunction();
	            this.getDetailsGroupsDepartamentFunction();
	            this.$scope.gridCampus = true;
	            this.$scope.gridCareer = false;
	            this.$scope.gridDepartament = false;
	        }
	    }, {
	        key: 'selectAllCampus',
	        value: function selectAllCampus(value) {
	
	            this.detailsGroups.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'selectAllCareer',
	        value: function selectAllCareer(value) {
	
	            this.detailsGroupsCareer.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'selectAllDepartament',
	        value: function selectAllDepartament(value) {
	
	            this.detailsGroupsDepartament.data.forEach(function (item) {
	                item.hasPermission = value;
	            });
	        }
	    }, {
	        key: 'getDetailsGroupsFunction',
	        value: function getDetailsGroupsFunction() {
	            var _this = this;
	
	            this.services.getAllPermissionsByCampusByGroup().$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this.ngNotify.set('registro seleccionado no tiene registros Campus', 'warn');
	                } else {
	
	                    _this.detailsGroups.data = dataReturn.data;
	                    console.log('details groups', dataReturn.data);
	                }
	            }, function (err) {
	                _this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'getDetailsGroupsCareerFunction',
	        value: function getDetailsGroupsCareerFunction() {
	            var _this2 = this;
	
	            this.services.getAllPermissionsByCareerByGroup().$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this2.ngNotify.set('registro seleccionado no tiene registros Carreras', 'warn');
	                } else {
	
	                    _this2.detailsGroupsCareer.data = dataReturn.data;
	                    console.log('details groups', dataReturn.data);
	                }
	            }, function (err) {
	                _this2.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'getDetailsGroupsDepartamentFunction',
	        value: function getDetailsGroupsDepartamentFunction() {
	            var _this3 = this;
	
	            this.services.getAllPermissionsByDepartmentByGroup().$promise.then(function (dataReturn) {
	                if (dataReturn.data.lenght == 0) {
	                    _this3.ngNotify.set('registro seleccionado no tiene registros Departamentos', 'warn');
	                } else {
	
	                    _this3.detailsGroupsDepartament.data = dataReturn.data;
	                    console.log('details groups', dataReturn.data);
	                }
	            }, function (err) {
	                _this3.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }, {
	        key: 'saveGroups',
	        value: function saveGroups(params) {
	            var _this4 = this;
	
	            console.log('data envia servicio save', params);
	
	            if (params.values.length > 0) {
	
	                this.services.saveGroups(params).$promise.then(function (dataReturn) {
	                    if (dataReturn.status == 0) {
	
	                        _this4.Groups = dataReturn.data;
	
	                        var dataGroups = {
	                            groupid: _this4.Groups,
	                            values: params.values
	                        };
	
	                        _this4.services.saveGroupsPermissions(dataGroups).$promise.then(function (dataReturn) {
	                            console.log('se han asociado los permisos correctamente a al grupo creado');
	                        });
	
	                        _this4.ngNotify.set('Se ha creado el Grupo correctamente', 'success');
	                        _this4.$state.go("app.groups");
	                    } else {
	                        _this4.ngNotify.set('Error con servicio, check request', 'error');
	                        _this4.$scope.isDisabled = false;
	                    }
	                }, function (err) {
	                    _this4.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	                    _this4.$scope.isDisabled = false;
	                });
	            } else {
	
	                this.ngNotify.set('Error , Seleccione Permisos para el nuevo Grupo', 'error');
	                this.$scope.isDisabled = false;
	            }
	        }
	    }]);
	
	    return groupsCreateController;
	}(); // fin function principal
	
	
	exports.default = groupsCreateController;
	groupsCreateController.$inject = ['$scope', 'groupsServices', '$resource', '$mdDialog', '$timeout', 'ngNotify', 'UserInfoConstant', '$state', '$modal', '$location'];

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP cmmApp
	* @autor jaime.salazar@u-planner.com
	* @description
	* # name controller --> modalDeleteGroupsController
	* # As Controller --> modalDeleteGroups
	* controllador de modal para eliminar grupo 
	*/
	
	var modalDeleteGroupsController = function () {
	    function modalDeleteGroupsController($scope, $resource, $timeout, ngNotify, UserInfoConstant, groupsServices, $state, $modalInstance) {
	        _classCallCheck(this, modalDeleteGroupsController);
	
	        var vm = this;
	        vm.deleteGroups = deleteGroups;
	        this.ngNotify = ngNotify;
	        this.$state = $state;
	        vm.cancel = cancel;
	        this.$modalInstance = $modalInstance;
	        vm.services = groupsServices.services;
	        vm.id = $scope.groupid;
	        vm.name = $scope.groupname;
	        vm.user = $scope.userinfo[0].user.id;
	
	        // /////////////////////////////
	
	        function deleteGroups() {
	
	            var params = {
	
	                status: false,
	                id_code: vm.id
	
	            };
	
	            vm.deleteGroupsFunction(params);
	        }
	
	        function cancel() {
	
	            $modalInstance.dismiss('chao');
	        }
	    } //fin constructor
	
	
	    _createClass(modalDeleteGroupsController, [{
	        key: 'deleteGroupsFunction',
	        value: function deleteGroupsFunction(params) {
	            var _this = this;
	
	            console.log('data envia servicio save', params);
	
	            this.services.deleteGroups(params).$promise.then(function (dataReturn) {
	                if (dataReturn.status == 0) {
	                    _this.ngNotify.set('El grupo ha sido desactivado de manera correcta', 'success');
	                    _this.$modalInstance.dismiss('chao');
	                    _this.$state.go(_this.$state.current, {}, { reload: true });
	                } else {
	                    _this.ngNotify.set('Error ,problemas con el servicio no se ha podidio eliminar el usuario', 'error');
	                }
	            }, function (err) {
	                _this.ngNotify.set('No se ha podido conectar con el servicio', 'error');
	            });
	        }
	    }]);
	
	    return modalDeleteGroupsController;
	}();
	
	exports.default = modalDeleteGroupsController;
	
	
	modalDeleteGroupsController.$inject = ['$scope', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', 'groupsServices', '$state', '$modalInstance'];

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var groupsServices = function groupsServices($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, groupsServices);
	
	  var services = $resource(SERVICE_URL_CONSTANT.adminPanel + '/user-api/:route', {}, {
	    // var services = $resource(SERVICE_URL_CONSTANT.localJson +'/admin-panel/:routeJson',{},{
	
	    getGroups: {
	      method: 'GET',
	      params: {
	        route: 'getGroups'
	        // routeJson: 'getGroups.json'
	      }
	    },
	
	    getAllPermissionsByCampusByGroup: {
	      method: 'GET',
	      params: {
	        route: 'getAllPermissionsByCampusByGroup'
	        // routeJson: 'getAllPermissionsByCampusByGroup.json'
	      }
	    },
	
	    getAllPermissionsByCareerByGroup: {
	      method: 'GET',
	      params: {
	        route: 'getAllPermissionsByCareerByGroup'
	        // routeJson: 'getAllPermissionsByCareerByGroup.json'
	      }
	    },
	
	    getAllPermissionsByDepartmentByGroup: {
	      method: 'GET',
	      params: {
	        route: 'getAllPermissionsByDepartmentByGroup'
	        // routeJson: 'getAllPermissionsByDepartmentByGroup.json'
	      }
	    },
	
	    saveGroups: {
	      method: 'POST',
	      params: {
	        route: 'insertGroups'
	        // routeJson: 'insertGroups.json'
	      }
	    },
	
	    saveGroupsPermissions: {
	      method: 'POST',
	      params: {
	        route: 'updatesectiongroup'
	      }
	    },
	
	    deleteGroups: {
	      method: 'POST',
	      params: {
	        route: 'deactiveGroups'
	      }
	    }
	
	  });
	
	  return {
	    services: services
	  };
	};
	
	groupsServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	
	exports.default = angular.module('services.groupsServices', []).service('groupsServices', groupsServices).name;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _strategicTracking = __webpack_require__(529);
	
	var _strategicTracking2 = _interopRequireDefault(_strategicTracking);
	
	var _strategicTracking3 = __webpack_require__(533);
	
	var _strategicTracking4 = _interopRequireDefault(_strategicTracking3);
	
	var _strategicTrackingListCtrl = __webpack_require__(534);
	
	var _strategicTrackingListCtrl2 = _interopRequireDefault(_strategicTrackingListCtrl);
	
	var _chartsDetailsCtrl = __webpack_require__(535);
	
	var _chartsDetailsCtrl2 = _interopRequireDefault(_chartsDetailsCtrl);
	
	var _detailsByTeacherCtrl = __webpack_require__(537);
	
	var _detailsByTeacherCtrl2 = _interopRequireDefault(_detailsByTeacherCtrl);
	
	var _bitacoraModalCtrl = __webpack_require__(539);
	
	var _bitacoraModalCtrl2 = _interopRequireDefault(_bitacoraModalCtrl);
	
	var _strategicTrackingListSrv = __webpack_require__(540);
	
	var _strategicTrackingListSrv2 = _interopRequireDefault(_strategicTrackingListSrv);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('strategicTracking', [_strategicTrackingListSrv2.default]).config(_strategicTracking2.default).controller('strategicTrackingListCtrl', _strategicTrackingListCtrl2.default).controller('chartsDetailsCtrl', _chartsDetailsCtrl2.default).controller('detailsByTeacherCtrl', _detailsByTeacherCtrl2.default).controller('bitacoraModalCtrl', _bitacoraModalCtrl2.default).run(_strategicTracking4.default).constant("strategicTracking", [{
		title: "Seguimiento estratégico",
		icon: "mdi-action-trending-up",
		moduleId: _globalConfig2.default.menuModulesId.StrategicTracking,
		subMenu: [{
			title: "Inicio",
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.strategicAdmin, _globalConfig2.default.userRolesIds.approver, _globalConfig2.default.userRolesIds.generalConsultant],
			url: "strategicTracking.strategicTrackingList"
		}]
	}]).name;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = routes;
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
		$locationProvider.html5Mode(true);
		$stateProvider.state('strategicTracking', {
			abstract: false,
			url: '/strategicTracking',
			redirectTo: 'strategicTracking.strategicTrackingList',
			views: {
				'': {
					template: __webpack_require__(168)
				},
				'content': {
					template: __webpack_require__(169)
				},
				'aside': {
					template: __webpack_require__(170),
					controller: 'AsideCtrl'
				},
				'header': {
					template: __webpack_require__(171),
					controller: 'HeaderCtrl'
				},
				'chatbox': {
					template: __webpack_require__(172),
					controller: 'ChatboxController',
					controllerAs: 'chatbox'
				},
				'footer': {
					template: __webpack_require__(177)
				}
			},
			data: {
				displayName: 'Inicio'
			}
		}).state('strategicTracking.strategicTrackingList', {
			abstract: false,
			url: '/list',
			template: __webpack_require__(530),
			controller: 'strategicTrackingListCtrl',
			controllerAs: 'trackCtrl',
			data: {
				displayName: 'Seguimiento Estratégico'
			}
		}).state('strategicTracking.strategicTrackingTeacher', {
			abstract: false,
			url: '/charts/teacher/:acaUnit?workplanId&stateId',
			template: __webpack_require__(531),
			controller: 'chartsDetailsCtrl',
			controllerAs: 'cDetails',
			data: {
				displayName: 'Docencia',
				order: 1,
				siblings: [{
					name: 'strategicTracking.strategicTrackingAcadManagement',
					hideLink: false,
					order: 5,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidation',
					hideLink: false,
					order: 4,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigation',
					hideLink: false,
					order: 2,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtension',
					hideLink: false,
					order: 3,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingGlobalView',
					hideLink: false,
					order: 6,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			},
			params: {
				idModule: 2
			}
		}).state('strategicTracking.strategicTrackingAcadManagement', {
			abstract: false,
			url: '/charts/cademicManagement/:acaUnit?workplanId&stateId',
			template: __webpack_require__(531),
			controller: 'chartsDetailsCtrl',
			controllerAs: 'cDetails',
			params: {
				idModule: 3
			},
			data: {
				displayName: 'Gestión académica',
				order: 5,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacher',
					hideLink: false,
					order: 1,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidation',
					hideLink: false,
					order: 4,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigation',
					hideLink: false,
					order: 2,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtension',
					hideLink: false,
					order: 3,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingGlobalView',
					hideLink: false,
					order: 6,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingConsolidation', {
			abstract: false,
			url: '/charts/consolidation/:acaUnit?workplanId&stateId',
			template: __webpack_require__(531),
			controller: 'chartsDetailsCtrl',
			controllerAs: 'cDetails',
			params: {
				idModule: 5
			},
			data: {
				displayName: 'Consolidación de cuerpo profesoral',
				order: 4,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacher',
					hideLink: false,
					order: 1,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagement',
					hideLink: false,
					order: 5,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigation',
					hideLink: false,
					order: 2,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtension',
					hideLink: false,
					order: 3,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingGlobalView',
					hideLink: false,
					order: 6,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingInvestigation', {
			abstract: false,
			url: '/charts/investigation/:acaUnit?workplanId&stateId',
			template: __webpack_require__(531),
			controller: 'chartsDetailsCtrl',
			controllerAs: 'cDetails',
			params: {
				idModule: 6
			},
			data: {
				displayName: 'Investigación',
				order: 2,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacher',
					hideLink: false,
					order: 1,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagement',
					hideLink: false,
					order: 5,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidation',
					hideLink: false,
					order: 4,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtension',
					hideLink: false,
					order: 3,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingGlobalView',
					hideLink: false,
					order: 6,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingExtension', {
			abstract: false,
			url: '/charts/extension/:acaUnit?workplanId&stateId',
			template: __webpack_require__(531),
			controller: 'chartsDetailsCtrl',
			controllerAs: 'cDetails',
			params: {
				idModule: 4
			},
			data: {
				displayName: 'Extensión',
				order: 3,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacher',
					hideLink: false,
					order: 1,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagement',
					hideLink: false,
					order: 5,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidation',
					hideLink: false,
					order: 4,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigation',
					hideLink: false,
					order: 2,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingGlobalView',
					hideLink: false,
					order: 6,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingGlobalView', {
			abstract: false,
			url: '/charts/globalView/:acaUnit?workplanId&stateId',
			template: __webpack_require__(531),
			controller: 'chartsDetailsCtrl',
			controllerAs: 'cDetails',
			params: {
				idModule: 0
			},
			data: {
				displayName: 'Vista general',
				order: 6,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacher',
					hideLink: false,
					order: 1,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagement',
					hideLink: false,
					order: 5,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidation',
					hideLink: false,
					order: 4,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigation',
					hideLink: false,
					order: 2,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtension',
					hideLink: false,
					order: 3,
					params: {
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingTeacherDetails', {
			abstract: false,
			url: '/details/teacher/:teacherId/:acaUnit?workplanId&stateId',
			template: __webpack_require__(532),
			controller: 'detailsByTeacherCtrl',
			controllerAs: 'tDetails',
			data: {
				displayName: 'Docencia',
				order: 1,
				siblings: [{
					name: 'strategicTracking.strategicTrackingAcadManagementDetails',
					hideLink: false,
					order: 5,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidationDetails',
					hideLink: false,
					order: 4,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigationDetails',
					hideLink: false,
					order: 2,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtensionDetails',
					hideLink: false,
					order: 3,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			},
			params: {
				idModule: 2
			}
		}).state('strategicTracking.strategicTrackingAcadManagementDetails', {
			abstract: false,
			url: '/details/academicManagement/:teacherId/:acaUnit?workplanId&stateId',
			template: __webpack_require__(532),
			controller: 'detailsByTeacherCtrl',
			controllerAs: 'tDetails',
			params: {
				idModule: 3
			},
			data: {
				displayName: 'Gestión académica',
				order: 5,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacherDetails',
					hideLink: false,
					order: 1,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidationDetails',
					hideLink: false,
					order: 4,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigationDetails',
					hideLink: false,
					order: 2,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtensionDetails',
					hideLink: false,
					order: 3,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingConsolidationDetails', {
			abstract: false,
			url: '/details/consolidation/:teacherId/:acaUnit?workplanId&stateId',
			template: __webpack_require__(532),
			controller: 'detailsByTeacherCtrl',
			controllerAs: 'tDetails',
			params: {
				idModule: 5
			},
			data: {
				displayName: 'Consolidación de cuerpo profesoral',
				order: 4,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacherDetails',
					hideLink: false,
					order: 1,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagementDetails',
					hideLink: false,
					order: 5,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigationDetails',
					hideLink: false,
					order: 2,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtensionDetails',
					hideLink: false,
					order: 3,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingInvestigationDetails', {
			abstract: false,
			url: '/details/investigation/:teacherId/:acaUnit?workplanId&stateId',
			template: __webpack_require__(532),
			controller: 'detailsByTeacherCtrl',
			controllerAs: 'tDetails',
			params: {
				idModule: 6
			},
			data: {
				displayName: 'Investigación',
				order: 2,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacherDetails',
					hideLink: false,
					order: 1,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagementDetails',
					hideLink: false,
					order: 5,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidationDetails',
					hideLink: false,
					order: 4,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtensionDetails',
					hideLink: false,
					order: 3,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingExtensionDetails', {
			abstract: false,
			url: '/details/extension/:teacherId/:acaUnit?workplanId&stateId',
			template: __webpack_require__(532),
			controller: 'detailsByTeacherCtrl',
			controllerAs: 'tDetails',
			params: {
				idModule: 4
			},
			data: {
				displayName: 'Extensión',
				order: 3,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacherDetails',
					hideLink: false,
					order: 1,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagementDetails',
					hideLink: false,
					order: 5,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidationDetails',
					hideLink: false,
					order: 4,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigationDetails',
					hideLink: false,
					order: 2,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		}).state('strategicTracking.strategicTrackingGlobalViewDetails', {
			abstract: false,
			url: '/details/globalView/:teacherId/:acaUnit?workplanId&stateId',
			template: __webpack_require__(532),
			controller: 'detailsByTeacherCtrl',
			controllerAs: 'tDetails',
			params: {
				idModule: 0
			},
			data: {
				displayName: 'Gestión académica',
				order: 6,
				siblings: [{
					name: 'strategicTracking.strategicTrackingTeacherDetails',
					hideLink: false,
					order: 1,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingAcadManagementDetails',
					hideLink: false,
					order: 5,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingConsolidationDetails',
					hideLink: false,
					order: 4,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingInvestigationDetails',
					hideLink: false,
					order: 2,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}, {
					name: 'strategicTracking.strategicTrackingExtensionDetails',
					hideLink: false,
					order: 3,
					params: {
						teacherId: "teacherId",
						acaUnit: "acaUnit",
						workplanId: "workplanId",
						stateId: "stateId"
					}
				}]
			}
		});
	}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"col-xs-12 p-h-lg p-t-md m-b-xs title\"> <h3 class=p-l> Seguimiento estratégico {{ trackCtrl.moment().format('YYYY')}} <span ng-if=trackCtrl.showSelect> - {{trackCtrl.academicUnit.ds_name}} </span> </h3> </div> </div> <div class=row> <div class=col-xs-12> <div class=row ng-if=trackCtrl.showSelect> <div class=\"hidden-xs col-xs-3 col-lg-2 text-right\"> <span class=text-md>Filtrar por unidad académica</span> </div> <div class=\"col-xs-9 col-lg-10 m-b-xs\" style=padding-right:45px> <ui-select ng-model=trackCtrl.academicUnit ng-change=trackCtrl.onChangeAcaUnit()> <ui-select-match class=u-select-overflow-hide placeholder=\"Seleccione Unidad Académica\" allow-clear=true> {{trackCtrl.academicUnit.ds_name}} </ui-select-match> <ui-select-choices repeat=\"aunit in trackCtrl.academicUnits | filter: $select.search\"> <span ng-bind-html=\"aunit.ds_name | highlight: $select.search\">{{aunit.ds_name}}</span> </ui-select-choices> </ui-select> </div> </div> <div class=\"row p-h-lg\"> <div class=col-xs-12> <div class=row> <div class=\"col-xs-12 col-md-4 p-v\" ng-repeat=\"chartConfig in trackCtrl.chartConfig track by $index\"> <div class=\"card card-border-radius cursor-pointer\" style=\"\" ng-click=trackCtrl.onClickChart(chartConfig)> <div class=card-body> <highchart id=chart_{{$index}} config=chartConfig></highchart> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"col-xs-12 p-h-lg p-t m-b-xs title\"> <h3 class=\"p-l p-t\">{{cDetails.moduleName}} </h3> </div> </div> <div class=\"row p-h-lg\"> <div class=col-xs-12> <div class=\"row m-b-lg\"> <div class=\"col-xs-12 col-sm-6 col-md-4\"> <label for=period>Plan</label> <ui-select multiple=multiple id=period ng-model=cDetails.plan ng-change=cDetails.reloadStage()> <ui-select-match class=u-select-overflow-hide placeholder=\"Seleccione Plan\" allow-clear=true> {{$item.workplanName}} </ui-select-match> <ui-select-choices repeat=\"pe in cDetails.plans | filter: $select.search\"> <small> Cod: <span ng-bind-html=\"pe.workplanId | highlight: $select.search\"></span><br> </small> <span ng-bind-html=\"pe.workplanName | highlight: $select.search\">{{pe.workplanName}}</span> </ui-select-choices> </ui-select> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 m-b-xs\"> <label for=period>Estado</label> <ui-select id=period ng-model=cDetails.state ng-change=cDetails.reloadStage()> <ui-select-match class=u-select-overflow-hide placeholder=\"Seleccione Estado\" allow-clear=true> {{cDetails.state.ds_name}} </ui-select-match> <ui-select-choices repeat=\"st in cDetails.states | filter: $select.search\"> <span ng-bind-html=\"st.ds_name | highlight: $select.search\">{{st.ds_name}}</span> </ui-select-choices> </ui-select> </div> <div class=\"col-xs-12 col-sm-4 col-md-5 m-b-xs\"> <div class=\"row m-b-lg\" style=margin-top:20px ng-show=\"cDetails.globalParams.idModule == '0'\"> <div class=\"col-xs-4 text-center\"> <div class=text-primary style=font-size:28px> {{cDetails.summaryActivities.percent_act}}% </div> <p>Actividades finalizadas</p> </div> <div class=\"col-xs-4 text-center\"> <div class=text-primary style=font-size:28px> <i class=\"icon mdi-social-people i-34\"></i> {{cDetails.summaryActivities.cant_teacher}} </div> <p>Total profesores</p> </div> <div class=\"col-xs-4 text-center\"> <div class=text-primary style=font-size:28px> <i class=\"icon mdi-action-extension i-34\"></i> {{cDetails.summaryActivities.total_act}} </div> <p>Total actividades</p> </div> </div> </div> </div> </div> <div class=clearfix></div> <div class=\"col-xs-12 col-sm-6 col-md-7\"> <div class=row> <div class=col-xs-12> <div class=card style=height:400px> <div class=\"card-body no-padding\"> <div class=table_wrapper_u_forecast> <div id=grid ui-grid=cDetails.gridOptions ng-if=\"cDetails.gridOptions.data.length>0\" style=width:100%;height:400px class=\"grid grid-blue\" ui-grid-resize-columns ui-grid-exporter ui-grid-pagination> </div> </div> <p class=\"p-lg text-gris-dark text-center text-md ng-scope\" ng-if=\"cDetails.gridOptions.data.length<=0\"> No hay datos para mostrar, por favor seleccione otro set de datos. </p> </div> </div> </div> </div> </div> <div class=\"col-xs-12 col-sm-6 col-md-5\"> <div class=row> <div class=col-xs-12> <div class=card> <div class=card-body> <highchart id=chart config=cDetails.chartConfig></highchart> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = "<style>.text-info{margin-right:20px}.title p.filter-for{font-size:.9em;margin-top:15%;text-align:right}.align-into-detail{margin-left:30px}</style> <div class=\"row p-t-sm\"> <div class=col-xs-12> <div class=\"row p-h-lg\"> <div class=\"col-xs-12 col-sm-2 col-md-1 col-lg-1 text-center\" ng-if=\"tDetails.role.id_code != 13\"> <div class=\"img_responsive rounded image_portal\"></div> </div> <div class=\"col-xs-12 col-sm-10 col-md-11 col-lg-11 p-v\"> <div class=row> <div class=\"col-xs-12 col-md-8 col-lg-6\"> <div> <span class=\"text-info exo font-medium\">Nombre<span class=hidden-xs> profesor</span>:</span> {{tDetails.teacher['teacher name']}} </div> </div> <div class=\"col-xs-12 col-md-4 col-lg-6\"> <div> <span class=\"text-info exo font-medium\"><span class=hidden-xs>N° de </span>actividades:</span> {{tDetails.teacher.cantidad}} </div> </div> </div> <div class=row> <div class=\"col-xs-12 col-md-8 col-lg-6\"> <div> <span class=\"text-info exo font-medium\">Tipología<span class=hidden-xs> de profesor</span>:</span> {{tDetails.teacher.teacher_type}} </div> </div> <div class=\"col-xs-12 col-md-4 col-lg-6\"> <div> <span class=\"text-info exo font-medium\">Und. académica: </span> {{tDetails.teacher.academic_unit}} </div> </div> </div> </div> <div class=col-xs-12> <div class=pull-right> <button class=\"no-m-t btn btn-fw btn-cancel md-ink-ripple\" ng-if=\"tDetails.role.types != 'TEACHER' && tDetails.role.types !== undefined\" type=button ng-click=tDetails.volver()> <i class=\"icon mdi-content-reply-all i-20\"></i> Seleccionar profesor </button> </div> </div> </div> <div class=\"row gris-lighter p-h-lg p-v m-t-sm\"> <div class=\"hidden-xs hidden-sm col-md-1\"> <p class=\"m-t-sm filter-for\">Filtrar por:</p> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 m-b-xs\"> <div class=row> <div class=\"col-xs-12 col-md-4 text-right\"> <label class=m-v-sm for=period>Plan</label> </div> <div class=\"col-xs-12 col-md-8\"> <ui-select multiple=multiple id=period ng-model=tDetails.plan ng-change=tDetails.reloadStage()> <ui-select-match class=u-select-overflow-hide placeholder=\"Seleccione Plan\" allow-clear=true> {{$item.workplanName}} </ui-select-match> <ui-select-choices repeat=\"pe in tDetails.plans | filter: $select.search\"> <small> Cod: <span ng-bind-html=\"pe.workplanId | highlight: $select.search\"></span><br> </small> <span ng-bind-html=\"pe.workplanName | highlight: $select.search\">{{pe.workplanName}}</span> </ui-select-choices> </ui-select> </div> </div> </div> <div class=\"col-xs-12 col-sm-6 col-md-3 m-b-xs\"> <div class=row> <div class=\"col-xs-12 col-md-4 text-right\"> <label class=m-v-sm for=period>Estado</label> </div> <div class=\"col-xs-12 col-md-8\"> <ui-select id=period ng-model=tDetails.state ng-change=tDetails.reloadStage()> <ui-select-match class=u-select-overflow-hide placeholder=\"Seleccione Estado\" allow-clear=true> {{tDetails.state.ds_name}} </ui-select-match> <ui-select-choices repeat=\"st in tDetails.states | filter: $select.search\"> <span ng-bind-html=\"st.ds_name | highlight: $select.search\">{{st.ds_name}}</span> </ui-select-choices> </ui-select> </div> </div> </div> <div class=\"col-xs-12 col-sm-8 col-md-5\"> <div class=pull-right> <button has-permission=docencia-seguimiento-estrategico-edit class=\"btn btn-fw btn-success md-ink-ripple\" type=button ng-click=\"tDetails.bitacora(tDetails.details.tagName, $event)\">Bitacora de {{tDetails.details.tagName}}</button> <button class=\"btn btn-fw btn-info md-ink-ripple\" type=button ng-click=tDetails.resultsEv()>Resultados Ev. Integral</button> </div> </div> </div> </div> </div> <div class=\"row blanco p-r-lg\"> <div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-5 no-padding rightDivider\"> <search-bar search-icon=true icon-size=20 opacity=true bar-style=\"'m-r p-l-md'\" on-change=tDetails.updateFilter(search)> </search-bar> <md-divider></md-divider> <activities-list activities=tDetails.activities filtering=tDetails.filter on-click=tDetails.loadDetails(activity)></activities-list> </div> <div class=\"col-md-7 col-sm-6 col-xs-12 col-lg-7\"> <div ng-if=\"tDetails.details.name !== undefined\"> <div class=row> <div class=col-xs-9> <h5 class=text-azul> Detalle - {{tDetails.details.name.toLowerCase()}} <span class=\"text-xxs activityTag align-into-detail font-bold text-block {{tDetails.details.className}}\" ng-show=\"tDetails.details.tagName.length > 0\"> <p class=\"text-block no-margin ng-binding\">{{tDetails.details.tagName}}</p> </span> </h5> </div> <div class=col-xs-3> <div class=pull-right> <button has-permission=docencia-seguimiento-estrategico-edit ng-if=\"(!tDetails.details.isEmpty) && tDetails.role.types != 'TEACHER' && tDetails.role.types !== undefined\" class=\"btn btn-fw btn-danger md-ink-ripple m-v-sm\" type=button ng-click=tDetails.confirmRemove($event)> <md-tooltip md-direction=bottom> Desmarcar actividad de seguimiento estratégico </md-tooltip> Desmarcar </button> </div> </div> </div> <div class=row> <div class=col-xs-12> <table class=\"table m-t\" ng-if=!tDetails.details.isEmpty> <tr> <td class=\"exo font-medium\" width=30%>Estado</td> <td width=70%>{{tDetails.details.status}}</td> </tr> <tr> <td class=\"exo font-medium\">Detalle de actividad</td> <td>{{tDetails.details.description || 'Sin descripcion'}}</td> </tr> <tr> <td class=\"exo font-medium\">Horas planificadas</td> <td>{{tDetails.details.totalHoursPlanned || '0'}}</td> </tr> <tr> <td class=\"exo font-medium\">Horas ejecutadas</td> <td>{{tDetails.details.totalHoursExecuted || '0'}}</td> </tr> <tr> <td class=\"exo font-medium\">Porcentaje de ejecución</td> <td> <div class=\"progress progress-striped active\"> <div class=\"progress-bar progress-bar-success\" ng-style=\"{width: tDetails.details.progressBar+'%'}\"> {{tDetails.details.porcentExecuted.toFixed(0)}}%</div> </div> </td> </tr> </table> </div> </div> </div> <div class=row ng-if=\"tDetails.childrenDetails.length > 0\"> <div ng-repeat=\"childrenActivity in tDetails.childrenDetails track by $index\"> <div class=\"col-md-12 proxima m-b p-h-lg\"> <h4 class=\"text-azul text-base font-bold text-block ng-binding\"> {{childrenActivity.type == 'planning' ? 'Planeación y Gestión' : ((childrenActivity.type == 'teaching') ? 'Formación de jóvenes docentes' : 'Actividades Planeadas')}} </h4> <div class=row> <div class=\"col-md-12 text-azul no-padding\" ng-if=\"childrenActivity.type != 'project'\"> <div ng-class=tDetails.contentHeaderCSS></div> <div ng-class=tDetails.headingCSS>Planeadas</div> <div ng-class=tDetails.headingCSS>Ejecutadas</div> </div> <div class=\"col-md-12 text-azul no-padding\" ng-if=\"childrenActivity.type == 'project'\"> <div ng-class=tDetails.contentHeaderCSS>Actividad</div> <div ng-class=tDetails.headingCSS>Horas planeadas</div> <div ng-class=tDetails.headingCSS>Horas ejecutadas</div> <div ng-class=tDetails.timeCSS>Tiempos planeados</div> </div> </div> <div class=\"row b-b m-t-sm\" ng-repeat=\"childrenActivityDetails in childrenActivity.data track by $index\"> <div ng-if=\"childrenActivity.type != 'project'\"> <div ng-class=tDetails.contentNameCSS> <p class=\"no-margin text-sm word-wrap\"> {{ childrenActivityDetails.name || 'Esta actividad no posee nombre'}} <span ng-if=!childrenActivityDetails.isPlanning class=text-gris-dark> - <span ng-if=childrenActivityDetails.itemActivityValue>Número de estudiantes: </span> {{ (childrenActivityDetails.itemActivityValue || childrenActivityDetails.description) || 'Sin descripción' }} </span> </p> </div> <div ng-class=tDetails.contentCSS>{{ childrenActivityDetails.hoursPlanned || 0}} hrs</div> <div ng-class=tDetails.contentCSS>{{ childrenActivityDetails.hoursExecuted || 0 }} hrs</div> </div> <div ng-if=\"childrenActivity.type == 'project'\"> <div class=\"col-md-2 no-padding\"> <p class=\"no-margin text-sm word-wrap text-gris-dark\"> {{ childrenActivityDetails.name || 'Esta actividad no posee nombre'}} </p> </div> <div ng-class=tDetails.contentCSS>{{ childrenActivityDetails.hoursPlanned || 0 }} hrs</div> <div ng-class=tDetails.contentCSS>{{ (childrenActivityDetails.hoursExecuted > 0 ? childrenActivityDetails.hoursExecuted : 0) || 0}} hrs</div> <div ng-class=tDetails.timeCSS>{{ tDetails.showTime(childrenActivityDetails) }}</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=tDetails.isLoadingDetails> <md-progress-circular md-mode=indeterminate md-diameter=96> </md-progress-circular> </div> </div> ";

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'strategicTracking'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, strategicTracking) {
	  MenuConstant[0]['menu'].push(strategicTracking);
	}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Controller to management Strategic Tracking
	* @controller 
	* # name: strategicTrackingListCtrl
	* # alias: trackCtrl
	* 1: Vista por Profesor (Realiza Pland de Trabajo)
	* 2: Docente
	* 3: Gestion Académica
	* 4: Extencion y Visibilidad
	* 5: Consolidacion de Cuerpo P.
	* 6: Investigacion
	*/
	
	var strategicTrackingListCtrl = function () {
		function strategicTrackingListCtrl($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, strategicTrackingListSrv, moment, GlobalConfig, $cookies) {
			var _this = this;
	
			_classCallCheck(this, strategicTrackingListCtrl);
	
			this.$scope = $scope;
			this.$state = $state;
			this.moment = moment;
			this.$timeout = $timeout;
			this.ngNotify = ngNotify;
			this.$cookies = $cookies;
			this.$stateParams = $stateParams;
			this.services = strategicTrackingListSrv;
			this.userinfo = null;
			this.chartConfig = [];
			this.GlobalConfig = GlobalConfig;
			this.globalChartConfig = {};
			this.academicUnits = [];
			this.role = null;
			this.showSelect = false;
			this.idsSubmodule = '2,6,4,5,3'.split(',');
			this.columnColors = "#433275,#3ab6ce,#45739d,#bd2f71,#4082b9".split(',');
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.userinfo.role_id = _this.$cookies.get('hasRoleId');
					if (_this.userinfo.role_id != 13 && _this.userinfo.role_id != 8 && _this.userinfo.role_id != 18 && _this.userinfo.role_id != 29) {
						_this.$state.go('app.unauthorized');
					}
					if (_this.userinfo.role_id != 13) {
						_this.idsSubmodule.push(0);
					}
					_this.main();
				}
			});
		}
	
		_createClass(strategicTrackingListCtrl, [{
			key: 'main',
			value: function main() {
				this.checkRole();
			}
		}, {
			key: 'checkRole',
			value: function checkRole() {
				var _this2 = this;
	
				this.services.get.typeRole({ roleId: this.userinfo.role_id }).$promise.then(function (response) {
					if (!response.status) {
						_this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this2.role = response.data[0];
						//cambio luis A 18-05-2017
						//solo pueden ingresar los roles por id:
						// - 13 --> profesor
						// - 8 --> es jefe aprobador
						// - 18 --> consultor
						if (_this2.role.id_code != 13) {
							//solo != profesor puede cambiar de ua
							_this2.showSelect = true;
						} else {
							_this2.showSelect = false;
						}
						_this2.getAcademicUnit();
					}
				}, function (err) {
					_this2.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getCharts',
			value: function getCharts(acaUnit) {
				for (var i in this.idsSubmodule) {
					if (this.chartConfig[i] !== undefined) {
						this.chartConfig[i].series = [];
						this.chartConfig[i].loading = true;
					}
					var params = {
						idModule: this.idsSubmodule[i],
						idAcaUnit: acaUnit,
						userId: this.userinfo.id,
						roleId: this.userinfo.role_id,
						stateId: 0,
						planId: 0
					};
					if (params.idModule != 0) {
						this.getDataChart(params, i);
					} else {
						this.getDataChartTotal(params, i);
					}
				}
			}
		}, {
			key: 'getDataChart',
			value: function getDataChart(params, index) {
				var _this3 = this;
	
				this.services.data.getDataChart(params).$promise.then(function (response) {
					if (!response.status) {
						_this3.ngNotify.set('Error al conectar con el servicio', 'warn');
					} else {
						_this3.buildCharts(response.data, index, params);
					}
				}, function (err) {
					_this3.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getDataChartTotal',
			value: function getDataChartTotal(params, index) {
				var _this4 = this;
	
				this.services.chart.getDataChartTotal(params).$promise.then(function (response) {
					if (!response.status) {
						_this4.ngNotify.set('Error al conectar con el servicio', 'warn');
					} else {
						_this4.buildCharts(response.data, index, params);
					}
				}, function (err) {
					_this4.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getAcademicUnit',
			value: function getAcademicUnit() {
				var _this5 = this;
	
				this.services.list.getAcademicUnit().$promise.then(function (response) {
					if (!response.status) {
						_this5.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this5.academicUnits = response.data;
						_this5.academicUnit = { id_code: 0, ds_name: "Todas" };
						_this5.academicUnits.unshift(_this5.academicUnit);
						_this5.getCharts(0);
					}
				}, function (err) {
					_this5.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'onChangeAcaUnit',
			value: function onChangeAcaUnit() {
				if (this.academicUnit === undefined && this.academicUnit == null) {
					this.academicUnit = { id_code: 0, ds_name: "Todas" };
				}
				this.getCharts(this.academicUnit.id_code);
			}
		}, {
			key: 'detectColor',
			value: function detectColor(nombre) {
				if (nombre == 'Vista General') {
					return 'background-color:#d0e1e1';
				} else {
					return 'background-color:#FFFFFF';
				}
			}
		}, {
			key: 'buildCharts',
			value: function buildCharts(data, index, item) {
				var conf = {
					options: {
						chart: { type: "column", backgroundColor: data.nombre == 'Vista General' ? '#d0e1e1' : '#FFFFFF' },
						legend: { enabled: true }
					},
					series: [],
					title: { text: data.nombre || 'Vista general',
						style: { color: '#4f73d9', font: '18px Arial' }
					},
					xAxis: {
						title: { text: '' },
						labels: { enabled: false }
					},
					yAxis: { title: { text: "" } },
					loading: false,
					size: { height: "310" },
					item: item
	
				};
	
				for (var x in data.state) {
					conf.series.push({
						data: [data.state[x].cantidad],
						name: data.state[x].ds_name,
						borderRadius: "5",
						color: this.columnColors[x]
					});
				}
				this.chartConfig[index] = conf;
			}
		}, {
			key: 'onClickChart',
			value: function onClickChart(chart) {
				var params = {
					idModule: chart.item.idModule,
					acaUnit: chart.item.idAcaUnit
				};
				var urls = {
					"2": "strategicTracking.strategicTrackingTeacher",
					"3": "strategicTracking.strategicTrackingAcadManagement",
					"4": "strategicTracking.strategicTrackingExtension",
					"5": "strategicTracking.strategicTrackingConsolidation",
					"6": "strategicTracking.strategicTrackingInvestigation",
					"0": "strategicTracking.strategicTrackingGlobalView"
				};
	
				if (this.role.types == 'TEACHER') {
					this.goToDetails(params);
				} else {
					this.$state.go(urls[chart.item.idModule], params);
				}
			}
		}, {
			key: 'goToDetails',
			value: function goToDetails(item) {
				if (this.userinfo.role_id == 13 && item.idModule == '0') {
					return;
				}
				var params = {};
				var urls = {
					"2": "strategicTracking.strategicTrackingTeacherDetails",
					"3": "strategicTracking.strategicTrackingAcadManagementDetails",
					"4": "strategicTracking.strategicTrackingExtensionDetails",
					"5": "strategicTracking.strategicTrackingConsolidationDetails",
					"6": "strategicTracking.strategicTrackingInvestigationDetails",
					"0": "strategicTracking.strategicTrackingGlobalViewDetails"
				};
	
				params.teacherId = JSON.parse(this.$cookies.get('currentUser')).teacherId;
				params.acaUnit = item.acaUnit;
				params.userId = this.userinfo.id;
				params.roleId = this.userinfo.role_id;
	
				this.$state.go(urls[item.idModule], params);
			}
		}]);
	
		return strategicTrackingListCtrl;
	}();
	
	exports.default = strategicTrackingListCtrl;
	
	
	strategicTrackingListCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'strategicTrackingListSrv', 'moment', 'GlobalConfig', '$cookies'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @name APP u-Planning
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @autor over.martinez@u-planner.com
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @description
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Descripcion del controlador
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @controller 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # name: chartsDetailsCtrl
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # alias: cDetails
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	
	var _states_list = __webpack_require__(536);
	
	var _states_list2 = _interopRequireDefault(_states_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var chartsDetailsCtrl = function () {
		function chartsDetailsCtrl($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, strategicTrackingListSrv, uiGridConstants, $location, $cookies) {
			var _this = this;
	
			_classCallCheck(this, chartsDetailsCtrl);
	
			this.$scope = $scope;
			this.$state = $state;
			this.$timeout = $timeout;
			this.ngNotify = ngNotify;
			this.$stateParams = $stateParams;
			this.services = strategicTrackingListSrv;
			this.userinfo = null;
			this.$cookies = $cookies;
			this.chartConfig = {};
			this.plans = [];
			this.states = [];
			this.state = null;
			this.plan = [];
			this.$location = $location;
			this.pageTitle = {
				"2": "Docencia",
				"3": "Gestión Académica",
				"4": "Extensión",
				"5": "Consolidación del Cuerpo Profesoral",
				"6": "Investigación",
				"0": "Vista General"
			};
			this.globalParams = {
				idModule: this.$stateParams.idModule,
				idAcaUnit: this.$stateParams.acaUnit
			};
			this.globalParamsDt = {
				idModule: this.$stateParams.idModule,
				idAcaUnit: this.$stateParams.acaUnit
			};
			this.defineUiGrid(uiGridConstants);
			this.columnColors = "#433275,#3ab6ce,#45739d,#bd2f71,#4082b9".split(',');
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.globalParams.userId = _this.userinfo.id;
					_this.globalParams.roleId = _this.$cookies.get('hasRoleId');
					_this.userinfo.roleId = _this.globalParams.roleId;
					_this.moduleName = _this.pageTitle[_this.$stateParams.idModule];
					_this.main();
				}
			});
		}
	
		_createClass(chartsDetailsCtrl, [{
			key: "main",
			value: function main() {
				this.checkRole();
				if (this.$stateParams.idModule == 0) {
					this.getSummaryActivities();
				}
			}
		}, {
			key: "getSummaryActivities",
			value: function getSummaryActivities() {
				var _this2 = this;
	
				var params = {
					evaluatorId: this.userinfo.id,
					roleId: this.userinfo.roleId,
					academic_unit: this.$stateParams.acaUnit
				};
				this.services.tracking.getSummaryActivities(params).$promise.then(function (response) {
					if (!response.status) {
						_this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this2.summaryActivities = response.data[0];
					}
				}, function (err) {
					_this2.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: "checkRole",
			value: function checkRole() {
				var _this3 = this;
	
				this.services.get.typeRole({ roleId: this.globalParams.roleId }).$promise.then(function (response) {
					if (!response.status) {
						_this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this3.role = response.data[0];
						if (_this3.role.types != 'TEACHER') {
							_this3.getPlans(function () {
	
								_this3.states = _states_list2.default.data;
								for (var i in _this3.states) {
									if (_this3.states[i].id_code == _this3.$stateParams.stateId) {
										_this3.state = _this3.states[i];
									}
								}
	
								_this3.getDataGrid();
							});
						}
					}
				}, function (err) {
					_this3.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: "getPlans",
			value: function getPlans(callback) {
				var _this4 = this;
	
				var params = {
					evaluatorId: this.userinfo.id,
					submoduleId: this.$stateParams.idModule,
					roleId: this.userinfo.roleId
				};
				this.services.tracking.plansByEvaluator(params).$promise.then(function (response) {
					if (!response.status) {
						_this4.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this4.plans = response.data;
						var wid_params = _this4.$stateParams.workplanId !== undefined ? _this4.$stateParams.workplanId.split('-') : [0];
						for (var i in _this4.plans) {
							for (var x in wid_params) {
								if (_this4.plans[i].workplanId == wid_params[x]) {
									_this4.plan.push(_this4.plans[i]);
								}
							}
						}
						callback();
					}
				}, function (err) {
					_this4.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: "getDataGrid",
			value: function getDataGrid() {
				var _this5 = this;
	
				this.globalParamsDt.userId = this.globalParams.userId;
				this.globalParamsDt.roleId = this.globalParams.roleId;
				this.globalParamsDt.planId = this.plan.length > 0 ? this.plan.map(function (plan) {
					return plan.workplanId;
				}) : 0;
				this.globalParamsDt.stateId = this.state != null ? this.state.id_code : 0;
				if (this.plan.length == 1) {
					this.globalParamsDt.planId.push(0);
				}
	
				this.services.data.getDataGrid(this.globalParamsDt).$promise.then(function (response) {
					if (!response.status) {
						_this5.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						if (_this5.role.types == 'TEACHER') {
							_this5.goToDetails(response.data[0]);
						} else {
							_this5.gridOptions.data = response.data;
							if (_this5.chartConfig.loading != undefined) {
								_this5.chartConfig.loading = true;
							}
							_this5.getDataChart();
						}
					}
				}, function (err) {
					_this5.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: "getDataChart",
			value: function getDataChart() {
				var _this6 = this;
	
				var services = this.getChartService();
				services(this.globalParamsDt).$promise.then(function (response) {
					if (!response.status) {
						_this6.ngNotify.set('Error al conectar con el servicio', 'warn');
					} else {
						_this6.buildCharts(response.data);
					}
				}, function (err) {
					_this6.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: "getChartService",
			value: function getChartService() {
				if (this.globalParams.idModule == '0') {
					return this.services.chart.getDataChartTotal;
				} else {
					return this.services.data.getDataChart;
				}
			}
		}, {
			key: "buildCharts",
			value: function buildCharts(data) {
				var conf = {
					options: { chart: { type: "column" }, legend: { enabled: true } },
					series: [],
					title: { text: data.nombre || 'Vista general', style: { color: '#4f73d9', font: '18px Arial' } },
					xAxis: {
						title: { text: '' },
						labels: { enabled: false }
					},
					yAxis: { title: { text: "" } },
					loading: false,
					size: { height: "420" }
				};
	
				for (var x in data.state) {
					conf.series.push({
						data: [data.state[x].cantidad],
						name: data.state[x].ds_name,
						borderRadius: "5",
						color: this.columnColors[x]
					});
				}
				this.chartConfig = conf;
			}
		}, {
			key: "goToDetails",
			value: function goToDetails(item) {
				var plansId = this.plan.map(function (plan) {
					return plan.workplanId;
				}).reduce(function (before, current) {
					var val = before !== '' ? before + '-' : '';
					return val + current.toString();
				}, '');
				var urls = {
					"2": "strategicTracking.strategicTrackingTeacherDetails",
					"3": "strategicTracking.strategicTrackingAcadManagementDetails",
					"4": "strategicTracking.strategicTrackingExtensionDetails",
					"5": "strategicTracking.strategicTrackingConsolidationDetails",
					"6": "strategicTracking.strategicTrackingInvestigationDetails",
					"0": "strategicTracking.strategicTrackingGlobalViewDetails"
				};
				this.globalParams.teacherId = item.id_teacher;
				this.globalParams.acaUnit = item.id_acadunit;
	
				if (this.$stateParams.idModule === 0) {
					this.globalParams.idModule = 2;
				} else {
					this.globalParams.idModule = this.$stateParams.idModule;
				}
	
				this.globalParams.workplanId = plansId.length > 0 ? plansId : undefined;
				this.globalParams.stateId = this.state != null ? this.state.id_code : undefined;
	
				this.$state.go(urls[this.globalParams.idModule], this.globalParams);
			}
		}, {
			key: "reloadStage",
			value: function reloadStage() {
				var plansId = this.plan.map(function (plan) {
					return plan.workplanId;
				}).reduce(function (before, current) {
					var val = before !== '' ? before + '-' : '';
					return val + current.toString();
				}, '');
	
				var params = {
					idModule: this.$stateParams.idModule,
					acaUnit: this.$stateParams.acaUnit,
					workplanId: plansId.length > 0 ? plansId : undefined,
					stateId: this.state != null ? this.state.id_code : undefined
				};
				var urls = {
					"2": "strategicTracking.strategicTrackingTeacher",
					"3": "strategicTracking.strategicTrackingAcadManagement",
					"4": "strategicTracking.strategicTrackingExtension",
					"5": "strategicTracking.strategicTrackingConsolidation",
					"6": "strategicTracking.strategicTrackingInvestigation",
					"0": "strategicTracking.strategicTrackingGlobalView"
				};
				this.$state.go(urls[params.idModule], params);
			}
		}, {
			key: "defineUiGrid",
			value: function defineUiGrid(uiGridConstants) {
				var _this7 = this;
	
				this.gridOptions = {
					enableRowSelection: true,
					enableRowHeaderSelection: false,
					multiSelect: false,
					modifierKeysToMultiSelect: false,
					noUnselect: true,
					enableFiltering: true,
					data: [],
					columnDefs: [{
						name: 'Profesor',
						displayName: 'Profesor',
						field: 'ds_teacher',
						width: "46%",
						enableGridMenu: false,
						enableHiding: false,
						enablePinning: false,
						enableColumnMenu: false,
						enableSorting: true,
						cellClass: 'text-xs',
						headerCellClass: 'font-normal text-xs',
						filter: {
							term: '',
							type: uiGridConstants.filter.CONTAINS
						},
						cellTemplate: '<div class="text-left ui-grid-cell-contents">' + '<span>{{row.entity.ds_teacher}} ' + '<small ng-if="row.entity.is_new == 1" class="badge bg-warning"> Nuevo</small>' + '</span>' + '</div>'
					}, {
						name: 'Unidad Académica',
						displayName: 'Unidad Académica',
						field: 'ds_acadunit',
						width: "30%",
						enableGridMenu: false,
						enableHiding: false,
						enablePinning: false,
						enableColumnMenu: false,
						enableSorting: true,
						cellClass: 'text-xs',
						headerCellClass: 'font-normal text-xs',
						filter: {
							term: '',
							type: uiGridConstants.filter.CONTAINS
						}
					}, {
						name: 'Cant. Actividades',
						displayName: 'Cant. Actividades',
						field: 'cantidad',
						width: "12%",
						enableGridMenu: false,
						enableHiding: false,
						enablePinning: false,
						enableColumnMenu: false,
						enableSorting: true,
						cellClass: 'text-xs',
						headerCellClass: 'font-normal text-xs',
						filter: {
							term: '',
							type: uiGridConstants.filter.CONTAINS
						}
					}, {
						name: 'Ver Seguimiento',
						displayName: 'Ver Seguimiento',
						field: 'id_teacher',
						width: "12%",
						enableGridMenu: false,
						enableHiding: false,
						enablePinning: false,
						enableColumnMenu: false,
						enableSorting: true,
						cellClass: 'text-xs',
						headerCellClass: 'font-normal text-xs',
						headerCellTemplate: '<div class="ui-grid-cell-contents text-center ui-grid-header-cell-primary-focus">' + '<span class="ui-grid-header-cell-label ng-binding">Ver Seguimiento</span>' + '</div>',
						cellTemplate: '<div class="text-center ui-grid-cell-contents">' + '<label class="md-check">' + '<a ng-click="grid.appScope.cDetails.goToDetails(row.entity)" class="underscore text-azul">ver Detalles</a>' + '</label>' + '</div>'
					}],
					onRegisterApi: function onRegisterApi(gridApi) {
						_this7.gridApi = gridApi;
					}
				};
			}
		}]);
	
		return chartsDetailsCtrl;
	}();
	
	exports.default = chartsDetailsCtrl;
	
	
	chartsDetailsCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'strategicTrackingListSrv', 'uiGridConstants', '$location', '$cookies'];

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	module.exports = {"data":[{"id_code":1,"ds_name":"Sin iniciar"},{"id_code":2,"ds_name":"Iniciada"},{"id_code":3,"ds_name":"Culminada"},{"id_code":4,"ds_name":"Cancelada"}]}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @name APP u-Planning
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @autor over.martinez@u-planner.com
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @description
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Descripcion del controlador
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * @controller 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # name: detailsByTeacherCtrl
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * # alias: tDetails
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	var _states_list = __webpack_require__(536);
	
	var _states_list2 = _interopRequireDefault(_states_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var detailsByTeacherCtrl = function () {
		function detailsByTeacherCtrl($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, strategicTrackingListSrv, GlobalConfig, Setters, ReviewSrv, Requests, Validations, $location, $cookies, $mdDialog, Util) {
			var _this = this;
	
			_classCallCheck(this, detailsByTeacherCtrl);
	
			this.$scope = $scope;
			this.$state = $state;
			this.$timeout = $timeout;
			this.ngNotify = ngNotify;
			this.$location = $location;
			this.$mdDialog = $mdDialog;
			this.$stateParams = $stateParams;
			this.$cookies = $cookies;
			this.services = strategicTrackingListSrv;
			this.userinfo = null;
			this.plans = [];
			this.Setters = Setters;
			this.formatActivity = this.Setters.formatActivity(Setters.setTagName(Validations));
			this.activities = [];
			this.plan = [];
			this.states = [];
			this.teacher = null;
			this.state = null;
			this.details = {};
			this.entries = null;
			this.role = {};
			this.Requests = Requests;
			this.ReviewSrv = ReviewSrv;
			this.Validations = Validations;
			this.Util = Util;
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.userinfo.role_id = _this.$cookies.get('hasRoleId');
					_this.subModule = _this.$stateParams.idModule;
					_this.main();
				}
			});
	
			this.contentHeaderCSS = ['col-md-6', 'no-padding', 'text-center', 'font-normal', 'text-sm'], this.headingCSS = ['col-md-3', 'no-padding', 'text-center', 'text-sm', 'font-normal'], this.contentCSS = ['col-md-3', 'no-padding', 'text-center', 'text-sm', 'text-azul'], this.contentNameCSS = ['col-md-6', 'no-padding'], this.timeCSS = ['col-md-4', 'no-padding', 'text-center', 'text-azul', 'text-xs'], this.currentStage = $stateParams.stage;
			this.currentModule = this.$stateParams.idModule;
			this.modules = GlobalConfig.modules; // Object.keys(GlobalConfig.modules)
			this._moduleName = Object.keys(this.modules).find(function (key) {
				return _this.modules[key] == _this.currentModule;
			});
			this.formatSubjectActivity = this.Requests.formatSubjectActivity(this.Requests.normalizeActivity(this.Requests.setNullHours));
			this.routeDetails = this.Requests.routeDetails(this.Validations, this.Requests.setNullHours, this.Requests.setStudentAttentionData, this.formatSubjectActivity);
		}
	
		_createClass(detailsByTeacherCtrl, [{
			key: 'main',
			value: function main() {
				var _this2 = this;
	
				this.checkRole();
				this.getTeacherData();
				this.getPlans(function () {
					_this2.states = _states_list2.default.data;
					for (var i in _this2.states) {
						if (_this2.states[i].id_code == _this2.$stateParams.stateId) {
							_this2.state = _this2.states[i];
						}
					}
					_this2.getActivities();
				});
			}
		}, {
			key: 'showTime',
			value: function showTime(activity) {
				return activity.timeRangeTypeId === 1 ? activity.periodName || activity.periodicityName : this.activityDates(activity);
			}
		}, {
			key: 'activityDates',
			value: function activityDates(activity) {
				return this.Util.setDate(activity.startDate) + ' - ' + this.Util.setDate(activity.endDate);
			}
		}, {
			key: 'checkRole',
			value: function checkRole() {
				var _this3 = this;
	
				this.services.get.typeRole({ roleId: this.userinfo.role_id }).$promise.then(function (response) {
					if (!response.status) {
						_this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this3.role = response.data[0];
					}
				}, function (err) {
					_this3.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'bitacora',
			value: function bitacora(title, ev) {
				this.entries.title = title;
				this.$mdDialog.show({
					controller: 'bitacoraModalCtrl',
					controllerAs: 'bit',
					template: __webpack_require__(453),
					parent: angular.element(document.body),
					targetEvent: ev,
					locals: { data: this.entries },
					clickOutsideToClose: true,
					fullscreen: true
				});
			}
		}, {
			key: 'getTeacherData',
			value: function getTeacherData() {
				var _this4 = this;
	
				var params = {
					idModule: this.subModule,
					idAcaUnit: this.$stateParams.acaUnit,
					userId: this.$stateParams.teacherId
				};
				this.services.list.getDataTeacher(params).$promise.then(function (response) {
					if (!response.status) {
						_this4.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this4.teacher = response.data[0];
					}
				}, function (err) {
					_this4.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'updateFilter',
			value: function updateFilter(text) {}
		}, {
			key: 'loadDetails',
			value: function loadDetails(item) {
				this.childrenDetails = [];
				this.activitySelected = item;
				this.details.isEmpty = true;
				this.details.tagName = '';
				if (item === undefined) {
					this.details.name = 'Sin información';
					this.isLoadingDetails = false;
					return false;
				}
				this.details.isEmpty = false;
				this.getEntries(item);
				this.getMoreDetails(item);
				//this.getDetails(item);
				var descrip = item.activityName || item.activityTypeName;
				this.isLoadingDetails = true;
				this.details.name = item.asignatureName || item.academicUnitName || item.otherActivityItemName || item.activityTypeNameCombo || item.activityTypeName;
				this.details.description = descrip + ' - ' + (item.description || item.otherActivityItemName || item.name || 'Sin descripción');
				this.details.totalHoursPlanned = item.totalHoursPlanned;
				this.details.totalHoursExecuted = item.totalHoursExecuted;
				this.details.porcentExecuted = item.totalHoursPlanned > 0 ? Math.round(item.totalHoursExecuted / item.totalHoursPlanned * 100) : '';
				this.details.tagName = item.tagName;
				this.details.progressBar = this.details.porcentExecuted < 0 ? 0 : this.details.porcentExecuted > 100 ? 100 : this.details.porcentExecuted;
				this.details.status = this.states[item.Estado - 1].ds_name;
				this.details.className = this.getClassName(item.activityTypeId);
				this.isLoadingDetails = false;
			}
		}, {
			key: 'getMoreDetails',
			value: function getMoreDetails(item) {
				var _this5 = this;
	
				this.setDetailsHeader = this.Requests.setDetailsHeader(this.Validations);
				this.getActivityDetails = this.Requests.getActivityDetails(this.ReviewSrv, this.setDetailsHeader);
				this.getActivityDetails(this._moduleName, item).then(function (data) {
					if (data === 'error in communication') {
						_this5.details = null;
					} else {
						_this5.childrenData = _this5.routeDetails(_this5._moduleName, item, data);
						_this5.childrenDetails = [];
	
						if (_this5.childrenData.data) {
							if (_this5.childrenData.children) {
								_this5.childrenDetails.push({
									data: _this5.childrenData.children || {}, type: "project"
								});
							}
	
							if (_this5.childrenData.planning) {
								_this5.childrenDetails = [{ data: _this5.childrenData.planning || {}, type: 'planning' }, { data: _this5.childrenData.teaching || {}, type: "teaching" }];
							}
						} else {
							_this5.childrenDetails = [];
						}
					}
				}, function (err) {
					_this5.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getClassName',
			value: function getClassName(type) {
				if ([5, 3, 4, 10].indexOf(type) >= 0) {
					return 'verde';
				}
				if ([8, 12].indexOf(type) >= 0) {
					return 'morado';
				}
				if ([11, 7, 19].indexOf(type) >= 0) {
					return 'azul';
				}
				return 'verde';
			}
		}, {
			key: 'getEntries',
			value: function getEntries(item) {
				var _this6 = this;
	
				var params = {
					workplanTeacherId: item.workplanTeacherId,
					activityTypeId: item.activityTypeId,
					teacherId: this.$stateParams.teacherId
				};
				this.entries = null;
				this.services.get.entries(params).$promise.then(function (response) {
					if (!response.status) {
						_this6.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this6.entries = response;
						_this6.entries.params = params;
					}
				}, function (err) {
					_this6.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this7 = this;
	
				var params = {
					teacherId: this.$stateParams.teacherId,
					workplanId: this.plan.length > 0 ? this.plan.map(function (plan) {
						return plan.workplanId;
					}) : 0,
					idState: this.state != null ? this.state.id_code : 0,
					roleId: this.userinfo.role_id != null ? this.userinfo.role_id : 0,
					userId: this.userinfo.id != null ? this.userinfo.id : 0,
					submoduleId: this.subModule != null ? this.subModule : 0,
					academic_unit: this.$stateParams.acaUnit != null ? this.$stateParams.acaUnit : 0
					// if (this.plan.length == 1) {params.workplanId.push(0) }
	
				};this.details = {};
				this.isLoadingDetails = true;
				this.entries = null;
				var serviceAux = this.getServiceToList();
				serviceAux(params).$promise.then(function (response) {
					if (!response.status) {
						_this7.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this7.activities = _this7.Setters.sortActivitiesList(_this7.formatActivity(response.data, 0));
						_this7.loadDetails(_this7.activities[0]);
					}
				}, function (err) {
					_this7.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getParams',
			value: function getParams(item) {
				if (this.subModule == '2' && item.activityTypeId == 3) {
					return {
						asignatureId: item.asignatureId,
						teacherId: item.teacherId,
						workplanId: item.workplanId
					};
				} else {
					return {
						activityTypeId: item.activityTypeId,
						workplanTeacherActivityId: item.workplanTeacherActivityId
					};
				}
			}
		}, {
			key: 'remove',
			value: function remove() {
				var _this8 = this;
	
				var params = {
					idActivity: this.activitySelected.workplanTeacherActivityId,
					idEvaluator: this.userinfo.id,
					idRol: this.userinfo.role_id,
					idTeacher: this.$stateParams.teacherId,
					isStrategicTracing: false
				};
				var description = '';
				if (this.activitySelected.activityTypeName) description = 'Profesor: Se ha eliminado una actividad de "' + this.activitySelected.activityTypeName + '" del módulo de Seguimiento estratégico';else description = 'Se ha eliminado una actividad de seguimiento estratégico.';
	
				var post1 = {
					idTeacher: this.$stateParams.teacherId,
					dsName: 'Notificación de eliminación de actividad (Seguimiento estratégico)',
					dsDescription: description,
					idNotification_delivery_type: 1,
					is_grouped: 1
				};
	
				this.services.tracking.remove(params).$promise.then(function (response) {
					if (!response.status) {
						_this8.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
	
						_this8.services.addNotificationsTransactions.add(post1).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								console.log("ok notification eliminación actividad de módulo", dataReturn);
							} else {
								console.log("Error Comunications");
							}
						}, function (data) {
							console.log(data);
						});
						_this8.update();
						_this8.ngNotify.set('Actividad a sido retirada de seguimiento estratégico', 'success');
					}
				}, function (err) {
					_this8.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'update',
			value: function update() {
				this.teacher.cantidad--;
				for (var i in this.activities) {
					if (this.activities[i].workplanTeacherActivityId == this.activitySelected.workplanTeacherActivityId) {
						this.activities.splice(i, 1);
						break;
					}
				}
				this.loadDetails(undefined);
			}
		}, {
			key: 'confirmRemove',
			value: function confirmRemove(ev) {
				var _this9 = this;
	
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
						this.close = function (response) {
							$mdDialog.hide(response);
						};
					}],
					controllerAs: 'confirm',
					template: __webpack_require__(538),
					clickOutsideToClose: false
				}).then(function (response) {
					if (response) {
						_this9.remove();
					}
				});
			}
		}, {
			key: 'getServiceToList',
			value: function getServiceToList() {
				if (this.subModule == '2') return this.services.get.activities;
				if (this.subModule == '3') return this.services.get.actAcademics;
				if (this.subModule == '4') return this.services.get.actExtension;
				if (this.subModule == '5') return this.services.get.actConsolidation;
				if (this.subModule == '6') return this.services.get.actInvestigation;
			}
		}, {
			key: 'getServiceDetails',
			value: function getServiceDetails() {
				if (this.subModule == '2') return this.services.get.details;
				if (this.subModule == '3') return this.services.get.acaDetails;
				if (this.subModule == '5') return this.services.get.consDetails;
	
				return this.services.get.details;
			}
		}, {
			key: 'getPlans',
			value: function getPlans(callback) {
				var _this10 = this;
	
				this.services.get.plans({ teacherId: this.$stateParams.teacherId }).$promise.then(function (response) {
					if (!response.status) {
						_this10.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this10.plans = response.data;
						var wid_params = _this10.$stateParams.workplanId !== undefined ? _this10.$stateParams.workplanId.split('-') : [0];
	
						for (var i in _this10.plans) {
							for (var x in wid_params) {
								if (_this10.plans[i].workplanId == wid_params[x]) {
									_this10.plan.push(_this10.plans[i]);
								}
							}
						}
	
						callback();
					}
				}, function (err) {
					_this10.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'volver',
			value: function volver() {
				var params = {
					acaUnit: 0,
					workplanId: this.plan != null ? this.plan.workplanId : undefined,
					stateId: this.state != null ? this.state.id_code : undefined
				};
				var urls = {
					"2": "strategicTracking.strategicTrackingTeacher",
					"3": "strategicTracking.strategicTrackingAcadManagement",
					"4": "strategicTracking.strategicTrackingExtension",
					"5": "strategicTracking.strategicTrackingConsolidation",
					"6": "strategicTracking.strategicTrackingInvestigation",
					"0": "strategicTracking.strategicTrackingGlobalView"
				};
	
				this.$state.go(urls[0], params);
			}
		}, {
			key: 'reloadStage',
			value: function reloadStage() {
				var plansId = this.plan.map(function (plan) {
					return plan.workplanId;
				}).reduce(function (before, current) {
					var val = before !== '' ? before + '-' : '';
					return val + current.toString();
				}, '');
				var params = {
					idModule: this.subModule,
					acaUnit: this.$stateParams.acaUnit,
					teacherId: this.$stateParams.teacherId,
					workplanId: plansId.length > 0 ? plansId : undefined,
					stateId: this.state != null ? this.state.id_code : undefined
				};
	
				var urls = {
					"2": "strategicTracking.strategicTrackingTeacherDetails",
					"3": "strategicTracking.strategicTrackingAcadManagementDetails",
					"4": "strategicTracking.strategicTrackingExtensionDetails",
					"5": "strategicTracking.strategicTrackingConsolidationDetails",
					"6": "strategicTracking.strategicTrackingInvestigationDetails",
					"0": "strategicTracking.strategicTrackingGlobalViewDetails"
				};
	
				this.$state.go(urls[params.idModule], params);
			}
		}]);
	
		return detailsByTeacherCtrl;
	}();
	
	exports.default = detailsByTeacherCtrl;
	
	
	detailsByTeacherCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'strategicTrackingListSrv', 'GlobalConfig', 'Setters', 'ReviewSrv', 'Requests', 'Validations', '$location', '$cookies', '$mdDialog', 'Util'];

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog ng-style=\"{width: '40%'}\"> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=confirm.close(false)> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md> Está a punto de quitar esta actividad de seguimiento estratégico. <br> Puede volverla a colocar en seguimiento desde la etapa de Revisión en el módulo de Plan de Trabajo. <br><br> <strong>¿Está seguro de esta acción?</strong> </p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=confirm.close(false)>No, Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=confirm.close(true)>Sí, Quitar actividad</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: bitacoraModalCtrl
	* # alias: bit
	*/
	var bitacoraModalCtrl = function () {
		function bitacoraModalCtrl($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, $mdDialog, strategicTrackingListSrv, data, moment, $cookies, GlobalSrv, GlobalConfig) {
			var _this = this;
	
			_classCallCheck(this, bitacoraModalCtrl);
	
			this.$scope = $scope;
			this.$state = $state;
			this.$timeout = $timeout;
			this.ngNotify = ngNotify;
			this.$mdDialog = $mdDialog;
			this.$cookies = $cookies;
			this.$stateParams = $stateParams;
			this.userinfo = null;
			this.moment = moment;
			this.showResponse = false;
			this.disabledButton = false;
			this.totalData = data;
			this.gIndex = undefined;
			this.savingComment = false;
			this.comments = [];
			this.inResponse = [];
			this.responding = false;
			this.commentBitacora = '';
			this.commentToResponse = null;
			this.services = strategicTrackingListSrv;
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.GlobalSrv = GlobalSrv;
			this.GlobalConfig = GlobalConfig;
			this.notPicture = __webpack_require__(294);
	
			this.optionsTextEditor = [['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'], ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'clear'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],, ['insertImage', 'insertLink', 'html'], ['undo', 'redo']];
	
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.userinfo.role_id = _this.$cookies.get('hasRoleId');
					if (_this.totalData.data !== undefined) {
						_this.loadMore();
					} else {
						_this.getEntries();
					}
				}
			});
		}
	
		_createClass(bitacoraModalCtrl, [{
			key: 'close',
			value: function close() {
				this.$mdDialog.hide();
			}
		}, {
			key: 'response',
			value: function response(comment, index) {
				this.responding = false;
				this.inResponse[index] = !this.inResponse[index];
				for (var i in this.inResponse) {
					if (this.inResponse[i]) {
						this.responding = true;
					}
				}
				this.commentToResponse = this.responding ? comment : null;
			}
		}, {
			key: 'getNotify',
			value: function getNotify(idUser, isUserIdValue) {
				this.getSendNotify(idUser, this.GlobalConfig.notificationType.inbox, isUserIdValue);
				this.getSendNotify(idUser, this.GlobalConfig.notificationType.email, isUserIdValue);
			}
		}, {
			key: 'getSendNotify',
			value: function getSendNotify(idUser, notificationId, isUserIdValue) {
				var post1 = {
					dsName: 'Notificación de comentario (Bitácora)',
					dsDescription: 'Señor profesor fue agregado un comentario en la bitácora de ' + this.totalData.title,
					idNotification_delivery_type: notificationId,
					is_grouped: 1
				};
				if (isUserIdValue) post1.idUser = idUser;else post1.idTeacher = idUser;
				this.GlobalSrv.sendNotification(post1);
			}
		}, {
			key: 'save',
			value: function save() {
				var _this2 = this;
	
				this.disabledButton = true;
				var params = {
					entriesParents: this.commentToResponse != null ? this.commentToResponse.workplanActivityTypesEntriesId : null,
					workplanTeacherId: this.totalData.params.workplanTeacherId,
					activityTypeId: this.totalData.params.activityTypeId,
					description: this.commentBitacora.replace(/\u200B/g, ''),
					userId: this.userinfo.id,
					rolCreatorId: this.userinfo.role_id
				};
	
				this.savingComment = true;
	
				this.services.save.bitacora(params).$promise.then(function (response) {
					if (!response.status) {
						_this2.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						if (_this2.totalData.params.userId) _this2.getNotify(_this2.totalData.params.userId, true);else if (_this2.totalData.params.teacherId) _this2.getNotify(_this2.totalData.params.teacherId, false);
						_this2.ngNotify.set('Registro guardado en bitácora', 'success');
						_this2.commentBitacora = '';
						_this2.savingComment = true;
						_this2.commentToResponse = null;
						_this2.getEntries();
					}
					_this2.disabledButton = false;
				}, function (err) {
					_this2.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'getEntries',
			value: function getEntries() {
				var _this3 = this;
	
				this.entries = null;
				this.totalData.data = [];
				this.services.get.entries(this.totalData.params).$promise.then(function (response) {
					if (!response.status) {
						_this3.ngNotify.set('Ocurrio un error en el servicio', 'warn');
					} else {
						_this3.totalData.data = response.data;
						_this3.gIndex = _this3.totalData.data.length - 1;
						_this3.comments = [];
						_this3.loadMore();
					}
				}, function (err) {
					_this3.ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'loadMore',
			value: function loadMore() {
				if (this.totalData.data.length > 0) {
					this.gIndex = this.gIndex === undefined ? this.totalData.data.length - 1 : this.gIndex;
					var initial = this.gIndex - 2;
					for (var i = this.gIndex; i >= 0; i--) {
						if (i < initial) {
							break;
						}
						this.comments.unshift(this.totalData.data[i]);
						this.gIndex--;
					}
				}
			}
		}]);
	
		return bitacoraModalCtrl;
	}();
	
	exports.default = bitacoraModalCtrl;
	
	
	bitacoraModalCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', '$mdDialog', 'strategicTrackingListSrv', 'data', 'moment', '$cookies', 'GlobalSrv', 'GlobalConfig'];

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name planning
	* @autor over.martinez@u-planner.com
	* @description : something
	* # planning
	* @name factory: strategicTrackingListSrv
	*/
	
	var strategicTrackingListSrv = function strategicTrackingListSrv($resource, SERVICE_URL_CONSTANT) {
		_classCallCheck(this, strategicTrackingListSrv);
	
		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST'
			}
		});
	
		return {
			addNotificationsTransactions: addNotificationsTransactions,
			list: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:idModule/:idAcaUnit/:userId/:roleId/:planId/:stateId', {}, {
				getAcademicUnit: {
					method: "GET",
					params: {
						type: "academic_unit",
						route: "getAcademicUnit"
					}
				},
				getDataTeacher: {
					method: "GET",
					params: {
						type: "strategic_tracking",
						route: "getDetailTeacherByUASubmodule"
					}
				}
			}),
			data: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:idModule/:idAcaUnit/:userId/:roleId/:stateId', {}, {
				getDataGrid: {
					method: "GET",
					params: {
						type: "strategic_tracking",
						route: "getCountStatesBySubmoduleDetail"
					}
				},
				getDataChart: {
					method: "GET",
					params: {
						type: "strategic_tracking",
						route: "getCountStatesBySubmodule"
					}
				}
			}),
			chart: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:idAcaUnit/:userId/:roleId', {}, {
				getDataChartTotal: {
					method: "GET",
					params: {
						type: "strategic_tracking",
						route: "getCountTotalBySubmodule"
					}
				}
			}),
			tracking: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
				remove: {
					method: "POST",
					params: {
						type: "activity",
						route: "setStrategicTracingActivity"
					}
				},
				plansByEvaluator: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getWorkPlan"
					}
				},
				getSummaryActivities: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getSummaryActivities"
					}
				}
			}),
			save: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:roleId', {}, {
				bitacora: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getSaveActivitiesEntries"
					}
				}
			}),
			get: $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:roleId', {}, {
				plans: {
					method: "POST",
					params: {
						type: "teacher",
						route: "getAllWokplanByTeacher"
					}
				},
				states: {
					method: "GET",
					params: {
						type: "strategic_tracking",
						route: "getListStates"
					}
				},
				typeRole: {
					method: "GET",
					params: {
						type: "strategic_tracking",
						route: "getUserTypeRoles"
					}
				},
				details: {
					method: "POST",
					params: {
						type: "activity",
						route: "getActivitiesDetail"
					}
				},
				acaDetails: {
					method: "POST",
					params: {
						type: "activity",
						route: "getActivityDetailAcademic"
					}
				},
				consDetails: {
					method: "POST",
					params: {
						type: "activity",
						route: "getActivityDetailTeachingStaff"
					}
				},
				entries: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getActivitiesEntries"
					}
				},
				workPlan: {
					method: "POST",
					params: {
						type: "general",
						route: "getWorkPlanGeneral"
					}
				},
				activities: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getActivitiesPlanning"
					}
				},
				actAcademics: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getActivityPlanningAcademic"
					}
				},
				actExtension: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getActivityExtesion"
					}
				},
				actInvestigation: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getActivityinvestigation"
					}
				},
				actConsolidation: {
					method: "POST",
					params: {
						type: "strategic_tracking",
						route: "getActivityConsolidation"
					}
				}
			})
		};
	};
	
	strategicTrackingListSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	
	exports.default = angular.module('services.strategicTrackingListSrv', []).service('strategicTrackingListSrv', strategicTrackingListSrv).name;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _integralEvaluation = __webpack_require__(542);
	
	var _integralEvaluation2 = _interopRequireDefault(_integralEvaluation);
	
	var _integralEvaluation3 = __webpack_require__(545);
	
	var _integralEvaluation4 = _interopRequireDefault(_integralEvaluation3);
	
	var _teacherSelfAssessmentController = __webpack_require__(556);
	
	var _teacherSelfAssessmentController2 = _interopRequireDefault(_teacherSelfAssessmentController);
	
	var _teacherAssessmentController = __webpack_require__(561);
	
	var _teacherAssessmentController2 = _interopRequireDefault(_teacherAssessmentController);
	
	var _integralEvaluationSrv = __webpack_require__(566);
	
	var _integralEvaluationSrv2 = _interopRequireDefault(_integralEvaluationSrv);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// teacher self assessment controller
	exports.default = angular.module('app.evaluations', [_integralEvaluationSrv2.default]).config(_integralEvaluation2.default).run(_integralEvaluation4.default).controller('teacherSelfAssessmentController', _teacherSelfAssessmentController2.default).controller('teacherAssessmentController', _teacherAssessmentController2.default).constant('integralEvaluation', [{
		title: 'Evaluación integral',
		icon: 'mdi-action-assignment-turned-in',
		moduleId: _globalConfig2.default.menuModulesId.integralEvaluation,
		url: _globalConfig2.default.externalURLs.integralEvaluationURL
		/*subMenu: [
	 	{
	 	  title: 'Autoevaluación Docente',
	 	  rolesAllowed: [GlobalConfig.userRolesIds.approver],
	 	  url: 'evaluations.teacherSelfAssessment'
	 	},
	 	{
	 	  title: 'Evaluación Docente',
	 	  rolesAllowed: [GlobalConfig.userRolesIds.approver],
	 	  url: 'evaluations.teacherAssessment'
	 	}
	   ],*/
	
	}]).directive('ngOnkeyup', function () {
		return {
			restrict: 'A',
			scope: {
				func: '&ngOnkeyup'
			},
			link: function link(scope, elem, attrs) {
				elem.bind('keyup', scope.func);
			}
		};
	}).name;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = routes;
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
		$locationProvider.html5Mode(true);
	
		$stateProvider.state('evaluations', {
			abstract: false,
			url: '/app/evaluations',
			views: {
				'': {
					template: __webpack_require__(168)
				},
				'content': {
					template: __webpack_require__(299)
				},
				'aside': {
					template: __webpack_require__(170),
					controller: 'AsideCtrl'
				},
				'header': {
					template: __webpack_require__(171),
					controller: 'HeaderCtrl'
				},
				'chatbox': {
					template: __webpack_require__(172),
					controller: 'ChatboxController',
					controllerAs: 'chatbox'
				},
				'footer': {
					template: __webpack_require__(177)
				}
			}
		}).state('evaluations.teacherSelfAssessment', {
			abstract: false,
			url: '/teacherSelfAssessment',
			template: __webpack_require__(543),
			controller: 'teacherSelfAssessmentController',
			controllerAs: 'selfAssessment'
		}).state('evaluations.teacherAssessment', {
			abstract: false,
			url: '/teacherAssessment/:teacherId?:name&:userId&:workplanId&:reviewApprove',
			template: __webpack_require__(544),
			controller: 'teacherAssessmentController',
			controllerAs: 'selfAssessment'
			// controller: 'teacherAssessmentController',
			// controllerAs: 'teacherAssessmentController'
		});
	}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = "<style>body{overflow:scroll}</style> <div class=\"row p-h-lg\" style=overflow:scroll id=top> <div class=col-md-6> <h3>Estimado profesor</h3> </div> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple\">Guardar</md-button> <md-button class=\"btn btn-fw btn-success md-button md-ink-ripple\" ng-click=selfAssessment.endPlanning()>Finalizar</md-button> </div> <div id=imag-loader-screen style=position:absolute!important;top:0;width:100%;height:100%;opacity:.2;left:0;display:none> </div> <div class=col-md-12> <p>A partir de una reflexión a conciencia lo invitamos a que se autoevalúe y consigne apreciaciones sobre su desempeño docente, logros alcanzados en su plan de trabajo y el compromiso institucional que ha demostrado en el presente año. Sus respuestas y observaciones aportarán elementos para su evaluación integral y el mejoramiento del cuerpo profesoral de la Universidad del Rosario. Le agradecemos su colaboración.</p> </div> </div> <div class=\"row blanco\"> <ul class=\"nav nav-md nav-tabs nav-lines b-info nav-justified nav_bar\" id=tabpanel> <li id=teaching-btn class=active ng-class=\"{ 'active' : flags=='teaching' }\"> <a href=\"\" data-toggle=tab data-target=#teaching ng-click=\"teaching('teaching')\">Docencia</a> </li> <li id=teacherWorkPlan-btn ng-class=\"{ 'active' : flags=='teacherWorkPlan' }\"> <a href=\"\" data-toggle=tab data-target=#teacherWorkPlan ng-click=\"teaching('teacherWorkPlan')\">Plan de Trabajo</a> </li> <li id=commitment-btn ng-class=\"{ 'active' : flags=='commitment' }\"> <a href=\"\" data-toggle=tab data-target=#commitment ng-click=\"teaching('commitment')\">Compromiso Institucional</a> </li> <li id=openQuestions-btn ng-class=\"{ 'active' : flags=='openQuestions' }\"> <a href=\"\" data-toggle=tab data-target=#openQuestions ng-click=\"teaching('openQuestions')\">Preguntas Abiertas</a> </li> <li id=finalConcept-btn ng-class=\"{ 'active' : flags=='finalConcept' }\"> <a href=\"\" data-toggle=tab data-target=#finalConcept ng-click=\"teaching('finalConcept')\">Concepto Final</a> </li> </ul> <div id=tabcontent class=\"tab-content p-h-lg p-v-md\"> <div ng-include=\"'teaching.html'\" role=tabpanel class=\"tab-pane container animated fadeIn active\" id=teaching></div> <div ng-include=\"'teacherWorkPlan.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=teacherWorkPlan></div> <div ng-include=\"'commitment.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=commitment></div> <div ng-include=\"'openQuestions.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=openQuestions></div> <div ng-include=\"'finalConcept.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=finalConcept></div> </div> </div>";

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row p-h-lg\" style=overflow:scroll> <div class=\"col-md-12 text-right\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple\"><span class=\"\">Guardar</span></md-button> <md-button class=\"btn btn-fw btn-success md-button md-ink-ripple\" ng-click=selfAssessment.endPlanning()><span class=\"\">Finalizar</span></md-button> </div> </div> <div class=\"row blanco\"> <ul class=\"nav nav-md nav-tabs nav-lines b-info nav-justified nav_bar\" id=nav_bar_id> <li class=active ng-class=\"{ 'active' : flags=='home' }\"> <a href=\"\" data-toggle=tab data-target=#home ng-click=\"teaching('home')\">Evaluación del plan de trabajo ({{selfAssessment.TotalProgressPercentage[11]}}%) </a> </li> <li ng-class=\"{ 'active' : flags=='teacherWorkPlan' }\"> <a href=\"\" data-toggle=tab data-target=#teacherWorkPlan ng-click=\"teaching('teacherWorkPlan')\">Plan de Trabajo ({{selfAssessment.TotalProgressPercentage[12]}}%)</a> </li> <li ng-class=\"{ 'active' : flags=='commitment' }\"> <a href=\"\" data-toggle=tab data-target=#commitment ng-click=\"teaching('commitment')\">Compromiso Institucional ({{selfAssessment.TotalProgressPercentage[13]}}%)</a> </li> <li ng-class=\"{ 'active' : flags=='openQuestions' }\"> <a href=\"\" data-toggle=tab data-target=#openQuestions ng-click=\"teaching('openQuestions')\">Preguntas Abiertas ({{selfAssessment.TotalProgressPercentage[14]}}%)</a> </li> <li ng-class=\"{ 'active' : flags=='finalConcept' }\"> <a href=\"\" data-toggle=tab data-target=#finalConcept ng-click=\"teaching('finalConcept')\">Concepto Final ({{selfAssessment.TotalProgressPercentage[15]}}%)</a> </li> </ul> <div class=\"tab-content p-h-lg p-v-md\"> <div ng-include=\"'teacherAssessment_home.html'\" role=tabpanel class=\"tab-pane container animated fadeIn active\" id=home></div> <div ng-include=\"'teacherAssessment_teacherWorkPlan.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=teacherWorkPlan></div> <div ng-include=\"'teacherAssessment_commitment.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=commitment></div> <div ng-include=\"'teacherAssessment_openQuestions.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=openQuestions></div> <div ng-include=\"'teacherAssessment_finalConcept.html'\" role=tabpanel class=\"tab-pane container animated fadeIn\" id=finalConcept></div> </div> </div> ";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'integralEvaluation'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, integralEvaluation) {
		// teacher self assessment
		$templateCache.put('teaching.html', __webpack_require__(546));
		$templateCache.put('teacherWorkPlan.html', __webpack_require__(547));
		$templateCache.put('commitment.html', __webpack_require__(548));
		$templateCache.put('openQuestions.html', __webpack_require__(549));
		$templateCache.put('finalConcept.html', __webpack_require__(550));
		// teacher assessment
		$templateCache.put('teacherAssessment_home.html', __webpack_require__(551));
		$templateCache.put('teacherAssessment_teacherWorkPlan.html', __webpack_require__(552));
		$templateCache.put('teacherAssessment_commitment.html', __webpack_require__(553));
		$templateCache.put('teacherAssessment_openQuestions.html', __webpack_require__(554));
		$templateCache.put('teacherAssessment_finalConcept.html', __webpack_require__(555));
		MenuConstant[0]['menu'].push(integralEvaluation);
	}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-sm-12 ng-repeat=\"i in selfAssessment.assignation.evaluation\" ng-if=\"i.id_code_evaluationmenues==1 && $index==0\"> <h2>{{i.Formulario}}</h2> <p>{{i.TextoFormulario}}</p> </div> <div class=col-sm-12> <label for=m1 class=\"control-label text-md\">{{selfAssessment.assignation.evaluation[0].Preguntas}} <span class=text-danger>*</span></label> <textarea class=form-control ng-model=selfAssessment.docencia ng-blur=selfAssessment.teacherTextareaOnBlur(selfAssessment.assignation.evaluation[0].id_code_questions,null,$event) maxlength=1000 ng-trim=false ng-model-options=\"{ debounce: 300 }\" rows=5></textarea> <span class=pull-right>Caracteres: {{selfAssessment.docencia.length}} / 1000</span> </div> <div class=\"col-sm-12 p-t\"> <hr> <h4>Reflexiones por asignatura</h4> <div class=\"form-group-lg m-b\"> <div class=input-group> <span class=input-group-addon>Filtrar</span> <input type=text ng-model=searchText ng-model-options=\"{ debounce: 300 }\" class=form-control> </div> </div> <div class=panel-group id=cursos{{$index}} role=tablist aria-multiselectable=true ng-repeat=\"(key, value) in selfAssessment.assignation.reflexion | filter:searchText \"> <div class=\"panel panel-info\"> <div class=\"panel-heading p-v-sm\" role=tab id=headingOne> <div class=row> <a role=button data-toggle=collapse data-parent=#cursos href=#curso{{$index}} aria-expanded=true aria-controls=curso{{$index}}> <div class=\"col-sm-1 p-v-xs\"> <div class=\"progress no-margin bg-warning\"> <div class=\"progress-bar progress-bar-success\" id=progress-{{value.id_code_asignature}} style=width:{};> &nbsp;{{value.percentage | number : 0}}% </div> </div> </div> <div class=\"col-sm-11 text-sm\"> <div class=\"font-bold inline text-md m-r-md\"> {{value.ds_public_id_asignature}} </div> <div class=\"font-bold inline text-md m-r-md\"> {{value.ds_name_asignature}} </div> <div class=\"inline m-r-md\"> Nº Grupos: <span class=\"badge bg-success\"> {{value.num_group}}</span> </div> <div class=\"inline m-r-md\"> Total Est: <span class=\"badge bg-warning\">{{value.num_students}}</span> </div> <div class=\"inline m-r-md\"> Período: <span class=\"badge bg-info\">{{value.ds_name_academicperiod}}</span> </div> <i class=\"pull-right mdi-hardware-keyboard-arrow-up text-lg\" ng-class=\"{'mdi-hardware-keyboard-arrow-down': status.open, 'mdi-hardware-keyboard-arrow-up': !status.open}\"></i> </div> </a> </div> </div> <div id=curso{{$index}} class=\"panel-collapse collapse\" ng-class=\"{ 'in' : $index==0 }\" role=tabpanel aria-labelledby=headingOne> <div class=panel-body> <div ng-repeat=\"(key1, section) in value.values\" class=panel-group id=secciones role=tablist aria-multiselectable=true> <div class=\"panel panel-success\"> <div class=\"panel-heading p-v-sm\" role=tab id=headingOne> <div class=row> <a role=button data-toggle=collapse data-parent=#seccionesCurso{{$index}} href=#seccion{{key}}-{{$index}} aria-expanded=true aria-controls=seccion{{key}}-{{$index}}> <div class=\"col-sm-1 p-v-xs\"> <span class=badge ng-class=\"{ 'bg-success' : selfAssessment.reflection[section.id] }\"><i class=mdi-action-done></i></span> </div> <div class=\"col-sm-11 text-sm\"> <div class=\"font-bold inline text-md m-r-md\"> Sección {{section.section}} </div> <div class=\"inline m-r-md\"> Nº Est: <span class=\"badge bg-warning\">{{section.nm_students}}</span> </div> <i class=\"pull-right mdi-hardware-keyboard-arrow-up text-lg\" ng-class=\"{'mdi-hardware-keyboard-arrow-down': status.open, 'mdi-hardware-keyboard-arrow-up': !status.open}\"></i> </div> </a> </div> </div> <div id=seccion{{key}}-{{$index}} class=\"panel-collapse collapse\" ng-class=\"{ 'in' : $index==0 }\" role=tabpanel aria-labelledby=headingOne> <div class=panel-body> <label for=m1 class=\"control-label text-md\">Reflexión sobre la docencia </label> <textarea class=form-control rows=5 maxlength=1000 ng-trim=false ng-model=selfAssessment.reflection[section.id] ng-blur=selfAssessment.teacherTextareaOnBlur(section.id_question,section.id,$event,value.id_code_asignature) ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.reflection[section.id].length}} / 1000</span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <hr> <div class=row> <div class=\"col-sm-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" ng-click=\"teaching('teacherWorkPlan')\" href=\"\" data-toggle=tab data-target=#teacherWorkPlan>Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div> ";

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-md-12> <h2>Plan de Trabajo</h2> <p>Describa los principales resultados alcanzados por usted en su plan de trabajo.</p> </div> <div class=row ng-repeat=\"(key, evaluation) in selfAssessment.assignation.evaluation\" ng-if=\"evaluation.id_code_evaluationmenues==2\"> <div class=\"col-md-12 p-t-lg\"> <label for=m1 class=\"control-label text-md\">{{evaluation.Preguntas}} <span class=text-danger>*</span></label> <textarea class=form-control rows=5 rows=5 maxlength=500 ng-trim=false ng-model=selfAssessment.trabajo[evaluation.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(evaluation.id_code_questions)\" ng-model-options=\"{ debounce: 300 }\">\n      </textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[evaluation.id_code_questions].length}} / 500</span> </div> </div> <hr> <hr> </div> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" href=\"\" ng-click=\"teaching('teaching')\" data-toggle=tab data-target=#teaching>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" href=\"\" ng-click=\"teaching('commitment')\" data-toggle=tab data-target=#commitment>Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div>";

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-md-12> <h2>Compromiso Institucional</h2> <p>Registre su apreciación acerca de los siguientes aspectos relacionados con el compromiso institucional.</p> </div> </div> <div class=\"row p-t-lg\" ng-repeat=\"(key, value) in selfAssessment.assignation.options | filter:optionsTextSearch \" ng-if=\"value.id_code_evaluationmenues==3\"> <div class=col-md-12> <label for=m1 class=\"control-label text-md\">{{value.Preguntas}}<span class=text-danger>*</span></label> </div> <div class=\"col-md-4 p-lg\"> <p ng-repeat=\"(key1, value1) in value.value \"> <label class=md-check> <input type=radio name=radio-{{value.id_code_questions}} ng-model=selfAssessment.compromise[value1.optionPlaceholder] ng-value=value1.id_code_options ng-click=selfAssessment.optionSave(value1.id_code_options,value.id_code_questions,value.id_code_evaluationmenues,$event)> <i class=bg-accent></i> {{value1.opcionesPreguntas}} </label> </p> </div> <div class=col-md-6> <label for=m1 class=control-label>Justifique</label> <textarea class=form-control rows=5 maxlength=500 ng-trim=false ng-model=selfAssessment.trabajo[value.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(value.id_code_questions,'options')\" ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[value.id_code_questions].length}} / 500</span> </div> </div> <hr> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" href=\"\" ng-click=\"teaching('teacherWorkPlan')\" data-toggle=tab data-target=#teacherWorkPlan>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" href=\"\" ng-click=\"teaching('openQuestions')\" data-toggle=tab data-target=#openQuestions>Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div>";

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-md-12> <h2>Preguntas Abiertas</h2> </div> <div class=row ng-repeat=\"(key, evaluation) in selfAssessment.assignation.evaluation\" ng-if=\"evaluation.id_code_evaluationmenues==4\"> <div class=\"col-md-12 p-t-lg\"> <label for=m1 class=\"control-label text-md\">{{evaluation.Preguntas}}</label> <textarea class=form-control rows=5 maxlength=1000 ng-trim=false ng-model=selfAssessment.trabajo[evaluation.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(evaluation.id_code_questions)\" ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[evaluation.id_code_questions].length}}/ 1000</span> </div> </div> <hr> </div> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" ng-click=\"teaching('commitment')\" href=\"\" data-toggle=tab data-target=#commitment>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" ng-click=\"teaching('finalConcept')\" href=\"\" data-toggle=tab data-target=#finalConcept>Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div>";

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-md-12> <h2>Concepto Final</h2> <p>Para culminar su autoevaluación, usted considera que su desempeño fue:</p> </div> </div> <div class=\"row p-t-lg\" ng-repeat=\"(key, value) in selfAssessment.assignation.options | filter:optionsTextSearch \" ng-if=\"value.id_code_evaluationmenues==5\"> <div class=\"col-md-4 p-lg\"> <p ng-repeat=\"(key1, value1) in value.value \"> <label class=md-check> <input type=radio name=radio-{{value.id_code_questions}} ng-model=selfAssessment.compromise[value1.optionPlaceholder] ng-value=value1.id_code_options ng-click=selfAssessment.optionSave(value1.id_code_options,value.id_code_questions,value.id_code_evaluationmenues,$event)> <i class=bg-accent></i> {{value1.opcionesPreguntas}} <a popover-placement=top popover={{selfAssessment.finalConceptTooltip[value1.id_code_options]}} popover-trigger=mouseenter><i class=\"icon mdi-action-help text-info i-16\"></i></a> </label> </p> </div> <div class=col-md-6> <label for=m1 class=control-label>Justifique</label> <textarea class=form-control rows=7 maxlength=500 ng-trim=false ng-model=selfAssessment.trabajo[value.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(value.id_code_questions,'options')\" ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[value.id_code_questions].length}} / 500</span> </div> </div> <hr> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" href=\"\" data-toggle=tab ng-click=\"teaching('openQuestions')\" data-target=#openQuestions>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> </div> </div>";

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-md-12> <h2>Evaluación del plan de trabajo</h2> </div> </div> <div class=\"row p-t-lg\" ng-repeat=\"(key, value) in selfAssessment.assignation.options | filter:optionsTextSearch \" ng-if=\"value.id_code_evaluationmenues==11\"> <div class=col-md-12> <label for=m1 class=\"control-label text-md\">{{value.Preguntas}} </label> <label class=text-sm><i>Seleccione al menos 1 criterio</i><span class=text-danger>*</span></label> </div> <div class=\"col-md-4 p-lg\"> <p ng-repeat=\"(key1, value1) in value.value \"> <label class=md-check> <input type=radio name=radio-{{value.id_code_questions}} ng-model=selfAssessment.compromise[value1.optionPlaceholder] ng-value=value1.id_code_options ng-click=selfAssessment.optionSave(value1.id_code_options,value.id_code_questions,value.id_code_evaluationmenues,$event)> <i class=bg-accent></i> {{value1.opcionesPreguntas}} <a tooltip-placement=top tooltip={{value1.tooltip}}><i class=\"icon mdi-action-help text-info i-16\"></i></a> </label> </p> </div> <div class=col-md-6> <label for=m1 class=control-label>Justifique</label> <textarea class=form-control rows=7 maxlength=500 ng-trim=false ng-model=selfAssessment.trabajo[value.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(value.id_code_questions,'options')\" ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[value.id_code_questions].length}} / 500</span> </div> </div> <hr> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" href=\"\" data-toggle=tab data-target=#teacherWorkPlan ng-click=\"teaching('teacherWorkPlan')\">Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div>";

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-md-12> <h2>Plan de Trabajo</h2> <p>Describa los principales resultados alcanzados por el profesor en su plan de trabajo relacionados con el ejercicio de:</p> </div> <div class=row ng-repeat=\"(key, evaluation) in selfAssessment.assignation.evaluation\" ng-if=\"evaluation.id_code_evaluationmenues==12\"> <div class=\"col-md-12 p-t-lg\"> <label for=m1 class=\"control-label text-md\">{{evaluation.Preguntas}} </label> <textarea class=form-control rows=5 rows=5 maxlength=500 ng-trim=false ng-model=selfAssessment.trabajo[evaluation.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(evaluation.id_code_questions)\" ng-model-options=\"{ debounce: 300 }\">\n      </textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[evaluation.id_code_questions].length}} / 500</span> </div> </div> <hr> <hr> </div> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" href=\"\" ng-click=\"teaching('home')\" data-toggle=tab data-target=#home>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" href=\"\" ng-click=\"teaching('commitment')\" data-toggle=tab data-target=#commitment>Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div> ";

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-md-12> <h2>Compromiso Institucional</h2> <p>Analice los siguientes aspectos relacionados con el compromiso institucional del profesor.</p> </div> <div class=row ng-repeat=\"(key, evaluation) in selfAssessment.assignation.evaluation\" ng-if=\"evaluation.id_code_evaluationmenues==13\"> <div class=\"col-md-12 p-t-lg\"> <label for=m1 class=\"control-label text-md\">{{evaluation.Preguntas}}</label> <textarea class=form-control rows=5 maxlength=1000 ng-trim=false ng-model=selfAssessment.trabajo[evaluation.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(evaluation.id_code_questions)\" ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[evaluation.id_code_questions].length}}/ 1000</span> </div> </div> <hr> </div> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" href=\"\" ng-click=\"teaching('teacherWorkPlan')\" data-toggle=tab data-target=#teacherWorkPlan>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" href=\"\" ng-click=\"teaching('openQuestions')\" data-toggle=tab data-target=#openQuestions>Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div> ";

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-md-12> <h2>Preguntas Abiertas</h2> <p>Describa los principales resultados alcanzados por el profesor relacionados con el ejercicio de su plan de trabajo.</p> </div> <div class=row ng-repeat=\"(key, evaluation) in selfAssessment.assignation.evaluation\" ng-if=\"evaluation.id_code_evaluationmenues==14\"> <div class=\"col-md-12 p-t-lg\"> <label for=m1 class=\"control-label text-md\">{{evaluation.Preguntas}}</label> <textarea class=form-control rows=5 maxlength=1000 ng-trim=false ng-model=selfAssessment.trabajo[evaluation.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(evaluation.id_code_questions)\" ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[evaluation.id_code_questions].length}}/ 1000</span> </div> </div> <hr> </div> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" ng-click=\"teaching('commitment')\" href=\"\" data-toggle=tab data-target=#commitment>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-right\" ng-click=\"teaching('finalConcept')\" href=\"\" data-toggle=tab data-target=#finalConcept>Siguiente <i class=\"mdi-hardware-keyboard-arrow-right pull-right\"></i></md-button> </div> </div> ";

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-md-12> <h2>Concepto Final</h2> </div> </div> <div class=\"row p-t-lg\" ng-repeat=\"(key, value) in selfAssessment.assignation.options | filter:optionsTextSearch \" ng-if=\"value.id_code_evaluationmenues==15\"> <div class=col-md-12> <label for=m1 class=\"control-label text-md\">{{value.Preguntas}} <span class=text-danger>*</span></label> </div> <div class=\"col-md-4 p-lg\"> <p ng-repeat=\"(key1, value1) in value.value \"> <label class=md-check> <input type=radio name=radio-{{value.id_code_questions}} ng-model=selfAssessment.compromise[value1.optionPlaceholder] ng-value=value1.id_code_options ng-click=selfAssessment.optionSave(value1.id_code_options,value.id_code_questions,value.id_code_evaluationmenues,$event)> <i class=bg-accent></i> {{value1.opcionesPreguntas}} <a tooltip-placement=top tooltip={{value1.tooltip}}><i class=\"icon mdi-action-help text-info i-16\"></i></a> </label> </p> </div> <div class=col-md-6> <label for=m1 class=control-label>Justifique</label> <textarea class=form-control rows=7 maxlength=500 ng-trim=false ng-model=selfAssessment.trabajo[value.id_code_questions] ng-blur=\" selfAssessment.teacherTextareaOnBlur(value.id_code_questions,'options')\" ng-model-options=\"{ debounce: 300 }\"></textarea> <span class=pull-right>Caracteres: {{selfAssessment.trabajo[value.id_code_questions].length}} / 500</span> </div> </div> <hr> <div class=row> <div class=\"col-md-12 p-t-lg\"> <md-button class=\"btn btn-fw btn-accent md-button md-ink-ripple pull-left\" href=\"\" data-toggle=tab ng-click=\"teaching('openQuestions')\" data-target=#openQuestions>Anterior <i class=\"mdi-hardware-keyboard-arrow-left pull-left\"></i></md-button> </div> </div> ";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor vignesh.somayaji@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: teacherSelfAssessmentController
	* # alias: Ctrl
	*/
	
	var teacherSelfAssessmentController = function () {
	  function teacherSelfAssessmentController($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, integralEvaluationSrv, $cookies, GlobalConfig, WorkPlanSrv, $mdDialog, $location, $anchorScroll) {
	    var _this = this;
	
	    _classCallCheck(this, teacherSelfAssessmentController);
	
	    var selfAss = this;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.ngNotify = ngNotify;
	    this.$timeout = $timeout;
	    this.integralEvaluationSrv = integralEvaluationSrv;
	    this.GlobalConfig = GlobalConfig;
	    this.$mdDialog = $mdDialog;
	    this.assignation = [];
	    this.imageLoader = __webpack_require__(557);
	    this.$location = $location;
	    this.$anchorScroll = $anchorScroll;
	
	    this.teachingId = 1;
	    this.teacherWorkPlanId = 2;
	    this.commitmentId = 3;
	    this.openQuestionsId = 4;
	    this.finalConceptId = 5;
	    this.TotalProgressPercentage = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
	    this.id_code_evaluationmenues = [1, 2, 3, 4, 5];
	    this.percentageBarActualTotal = {};
	    this.percentageBarTotal = {};
	
	    this.finalConceptTooltip = {
	      17: 'El profesor desarrolló plenamente las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue excelente.',
	      18: 'El profesor desarrolló las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue muy buena.',
	      19: '** El profesor desarrolló las actividades relacionadas con las responsabilidades a su cargo establecidas en el plan de trabajo, surgen comentarios frente al nivel de desarrollo en el alguna(s) de ella(s). La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue buena.',
	      20: 'El profesor logró demostrar desarrollos aceptables y se identifican deficiencias en las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes son aceptables.',
	      21: 'El profesor no logró los objetivos propuestos, aunque demostró cierto nivel de desarrollo de las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue insuficiente.'
	    };
	
	    this.$scope.UserInfoConstant = UserInfoConstant;
	    this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
	      if (details !== undefined) {
	        _this.userinfo = details.user;
	        _this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false;
	        _this.main();
	      }
	    });
	
	    $scope.flags = 'teaching';
	    $scope.teaching = function (id) {
	      $scope.flags = id;
	    };
	  }
	
	  _createClass(teacherSelfAssessmentController, [{
	    key: 'main',
	    value: function main() {
	      console.log('Estoy en el controlador de teacherSelfAssessmentController');
	      this.activeParam();
	    }
	  }, {
	    key: 'activeParam',
	    value: function activeParam() {
	
	      console.log('sample try ', this.cookiesUser);
	      //this.cookiesUser.teacherId
	
	      var param = { id_teacher: this.cookiesUser.teacherId, id_work_plan: this.cookiesUser.workplanId, options: 'AUTO' };
	
	      var THIS = this;
	      this.integralEvaluationSrv.asignaturesDetails.getAsignaturesDetails(param).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	
	          THIS.reflection = {};
	          THIS.trabajo = {};
	          THIS.compromise = {};
	          THIS.TotalQuestion = {};
	
	          for (var i in dataReturn.data.reflexion) {
	            var count = 0;
	
	            for (var j in dataReturn.data.reflexion[i].values) {
	              if (dataReturn.data.reflexion[i].values[j].values != '') {
	                count++;
	              }
	              THIS.reflection[dataReturn.data.reflexion[i].values[j].id] = dataReturn.data.reflexion[i].values[j].values;
	            }
	            dataReturn.data.reflexion[i].percentage = count / dataReturn.data.reflexion[i].values.length * 100;
	          }
	
	          for (var i in dataReturn.data.evaluation) {
	            if (typeof THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] === 'undefined') {
	              THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] = 0;
	              THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] = 0;
	            }
	
	            if (dataReturn.data.evaluation[i].id_code_evaluationmenues == 2 | dataReturn.data.evaluation[i].id_code_evaluationmenues == 4) {
	              THIS.trabajo[dataReturn.data.evaluation[i].id_code_questions] = dataReturn.data.evaluation[i].text;
	              if (dataReturn.data.evaluation[i].text != '') {
	                THIS.TotalQuestion[dataReturn.data.evaluation[i].id_code_questions] = dataReturn.data.evaluation[i].text;
	                THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] += 1;
	              }
	              THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] += 1;
	            }
	          }
	
	          for (var i in dataReturn.data.options) {
	
	            if (typeof THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] === 'undefined') {
	              THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] = 0;
	              THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues] = 0;
	            }
	
	            THIS.trabajo[dataReturn.data.options[i].id_code_questions] = dataReturn.data.options[i].text;
	            for (var j in dataReturn.data.options[i].value) {
	
	              if (dataReturn.data.options[i].value[j].values == dataReturn.data.options[i].value[j].id_code_options) {
	                THIS.TotalQuestion[dataReturn.data.options[i].id_code_questions] = dataReturn.data.options[i].value[j].id_code_options;
	                THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder] = dataReturn.data.options[i].value[j].id_code_options;
	                THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] += 1;
	              } else {
	                THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder] = false;
	              }
	            }
	            THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues] += 1;
	          }
	
	          THIS.assignation = dataReturn.data;
	          THIS.docencia = dataReturn.data.evaluation[0].text;
	
	          THIS.$timeout(function () {
	
	            var countRef = 0;
	
	            for (var i in THIS.assignation.reflexion) {
	              var assignature = THIS.assignation.reflexion[i].id_code_asignature;
	              countRef += parseInt(THIS.assignation.reflexion[i].percentage);
	              $('#progress-' + assignature).css('width', parseInt(THIS.assignation.reflexion[i].percentage) + '%');
	            }
	
	            if (THIS.docencia != '') {
	              countRef += 100;
	            }
	
	            var reflexCount = countRef / parseInt(THIS.assignation.reflexion.length + 1);
	            THIS.TotalProgressPercentage[THIS.teachingId] = reflexCount;
	            THIS.TotalProgressPercentage[THIS.teacherWorkPlanId] = THIS.percentageBarTotal[THIS.teacherWorkPlanId] / THIS.percentageBarTotal[THIS.teacherWorkPlanId] * 100;
	            THIS.TotalProgressPercentage[THIS.commitmentId] = THIS.percentageBarTotal[THIS.commitmentId] / THIS.percentageBarTotal[THIS.commitmentId] * 100;
	            THIS.TotalProgressPercentage[THIS.openQuestionsId] = THIS.percentageBarTotal[THIS.openQuestionsId] / THIS.percentageBarTotal[THIS.openQuestionsId] * 100;
	            THIS.TotalProgressPercentage[THIS.finalConceptId] = THIS.percentageBarTotal[THIS.finalConceptId] / THIS.percentageBarTotal[THIS.finalConceptId] * 100;
	          }, 500);
	        }
	      }, function (data) {
	        console.log('sample vignesh', data);
	      });
	    }
	  }, {
	    key: 'checkTotalPercentage',
	    value: function checkTotalPercentage(id_question, id) {
	
	      var param = { id_teacher: this.cookiesUser.teacherId,
	        id_work_plan: this.cookiesUser.workplanId,
	        options: 'AUTO' };
	      var THIS = this;
	      this.integralEvaluationSrv.getTotalPercentageOfEnteredData.getTotal(param).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          console.log('ttttt', dataReturn);
	          THIS.TotalProgressPercentage = dataReturn.data;
	        }
	      }, function (data) {
	        console.log('sample vignesh', data);
	      });
	    }
	  }, {
	    key: 'teacherTextareaOnBlur',
	    value: function teacherTextareaOnBlur(id_question, id, event, id_code_asignature) {
	      var id_assignations = null;
	
	      if (id_question == 1) {
	
	        var id_assignations = null;
	        var text = this.docencia;
	      } else if (id_question == 2) {
	
	        var id_assignations = id;
	        var text = this.reflection[id];
	
	        for (var i in this.assignation.reflexion) {
	          var count = 0;
	          if (id_code_asignature == this.assignation.reflexion[i].id_code_asignature) {
	            for (var j in this.assignation.reflexion[i].values) {
	
	              if (this.reflection[this.assignation.reflexion[i].values[j].id] != '') {
	                count++;
	              }
	            }
	            this.assignation.reflexion[i].percentage = count / this.assignation.reflexion[i].values.length * 100;
	            $('#progress-' + id_code_asignature).css('width', parseInt(this.assignation.reflexion[i].percentage) + '%');
	          }
	        }
	      } else {
	        //if(id_question==3 || id_question==4 || id_question==5 || id_question==6 || id_question==7){
	        var text = this.trabajo[id_question];
	      }
	
	      if (id == 'options') {
	
	        var id_code_options = $('input[name=radio-' + id_question + ']:checked').val();
	        var param = {
	          id_question: id_question,
	          ds_description: text,
	          id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
	          id_assignations: id_assignations,
	          id_option: id_code_options
	        };
	      } else {
	
	        var param = {
	          id_question: id_question,
	          ds_description: text,
	          id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
	          id_assignations: id_assignations
	        };
	      }
	
	      $('#imag-loader').css('top', '50%');
	      $('#imag-loader').css('left', '50%');
	      $('#imag-loader-screen').show();
	      var THIS = this;
	
	      if ($.trim(text) != '') {
	        this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {
	          $('#imag-loader-screen').hide();
	          THIS.checkTotalPercentage();
	        }, function (data) {
	          $('#imag-loader-screen').hide();
	          console.log('error', data);
	        });
	      } else {
	        $('#imag-loader-screen').hide();
	      }
	    }
	  }, {
	    key: 'optionSave',
	    value: function optionSave(id_code_options, id_question, id_code_evaluationmenues, event) {
	
	      var param = {
	        id_question: id_question,
	        ds_description: typeof this.trabajo[id_question] === 'undefined' ? null : this.trabajo[id_question],
	        id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
	        id_option: id_code_options
	      };
	
	      console.log(param);
	
	      // alert(window.innerWidth + ' × ' + $('.content-box').scrollHeight);
	
	
	      // $('#imag-loader').css('top',event.screenY+100 )
	      // $('#imag-loader').css('left',event.screenX)
	
	      $('#imag-loader').css('top', '50%');
	      $('#imag-loader').css('left', '50%');
	      //$('#imag-loader-screen').show()
	
	      var THIS = this;
	      this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {
	
	        $('#imag-loader-screen').hide();
	      }, function (data) {
	        console.log('error', data);
	        $('#imag-loader-screen').hide();
	      });
	    }
	  }, {
	    key: 'endPlanning',
	    value: function endPlanning() {
	
	      var param = { id_teacher: this.cookiesUser.teacherId, id_work_plan: this.cookiesUser.workplanId };
	
	      var THIS = this;
	
	      this.integralEvaluationSrv.getMandatoryData.getMandatoryDataFlag(param).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	
	          if (dataReturn.data.flag == true) {
	            THIS.endProcessModal();
	          } else {
	            var obj = {},
	                ObjArray = [];
	            for (var i in THIS.assignation.evaluation) {
	              if (typeof obj[THIS.assignation.evaluation[i].id_code_evaluationmenues] === 'undefined') {
	                var text = '';
	                if (THIS.assignation.evaluation[i].id_code_questions == 1) {
	                  text = THIS.assignation.evaluation[i].Formulario + '(Reflexión)';
	                } else {
	                  text = THIS.assignation.evaluation[i].Formulario;
	                }
	                obj[THIS.assignation.evaluation[i].id_code_evaluationmenues] = text;
	                if (dataReturn.data.manatory[THIS.assignation.evaluation[i].id_code_evaluationmenues] == false) {
	                  ObjArray.push(text);
	                }
	              }
	            }
	
	            for (var i in THIS.assignation.options) {
	              if (typeof obj[THIS.assignation.options[i].id_code_evaluationmenues] === 'undefined') {
	                obj[THIS.assignation.options[i].id_code_evaluationmenues] = THIS.assignation.options[i].Formulario;
	                if (dataReturn.data.manatory[THIS.assignation.options[i].id_code_evaluationmenues] == false) {
	                  ObjArray.push(THIS.assignation.options[i].Formulario);
	                }
	              }
	            }
	
	            THIS.mandatoryFieldWarningModal(ObjArray);
	          }
	        }
	      }, function (data) {
	        console.log('sample vignesh', data);
	      });
	    }
	  }, {
	    key: 'getNotifyEndExecution',
	    value: function getNotifyEndExecution(idUser, notificationType) {
	      return {
	        idUser: idUser,
	        dsName: 'Notificación, ejecución finalizada',
	        dsDescription: 'El profesor ' + this.cookiesUser.dsFullname + ' ha finalizado la ejecución',
	        idNotification_delivery_type: notificationType,
	        is_grouped: 0
	      };
	    }
	  }, {
	    key: 'mandatoryFieldWarningModal',
	    value: function mandatoryFieldWarningModal(details) {
	
	      this.$mdDialog.show({
	        controller: ['$scope', '$mdDialog', function mandatoryFieldWarningModal($scope, $mdDialog) {
	          $scope.data = details;
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	        }],
	        template: __webpack_require__(558),
	        clickOutsideToClose: false
	      });
	    }
	  }, {
	    key: 'endProcessModal',
	    value: function endProcessModal() {
	
	      var THIS = this;
	
	      this.$mdDialog.show({
	        controller: ['$scope', '$mdDialog', 'GlobalConfig', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalSrv', '$state', function mandatoryFieldWarningModal($scope, $mdDialog, GlobalConfig, WorkPlanSrv, WorkPlanModalSrv, GlobalSrv, $state) {
	          // $scope.data = response
	
	          var headData = WorkPlanModalSrv.getVariable();
	
	          var teacherId = THIS.cookiesUser.teacherId;
	          var workplanId = THIS.cookiesUser.workplanId;
	          var userId = THIS.cookiesUser.id;
	          var stageId = GlobalConfig.workplanIdStages.execution;
	          var header = {
	            workplanId: workplanId,
	            teacherId: teacherId,
	            stageId: stageId,
	            userId: userId,
	            feedback: ''
	          };
	
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	
	          $scope.finilize = function () {
	
	            WorkPlanSrv.endPlanning.post(header).$promise.then(function (dataReturn) {
	              if (dataReturn.status) {
	                // executionFinish = true
	                GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.inbox));
	                GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.email));
	
	                var reviewers = GlobalSrv.getReviewersAndEvaluator();
	                reviewers.forEach(function (reviewer) {
	                  GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.inbox));
	                  GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.email));
	                });
	
	                THIS.finalDialog();
	                close();
	                // $state.go('workplan.executionHistory'); 
	              }
	            });
	
	            $mdDialog.hide();
	          };
	        }],
	        template: __webpack_require__(559),
	        clickOutsideToClose: false
	      });
	    }
	  }, {
	    key: 'finalDialog',
	    value: function finalDialog() {
	
	      this.$mdDialog.show({
	        controller: ['$scope', '$mdDialog', '$state', function mandatoryFieldWarningModal($scope, $mdDialog, $state) {
	          // $scope.data = details
	          $scope.close = function () {
	            $mdDialog.hide();
	            $state.go('workplan.executionHistory');
	          };
	        }],
	        template: __webpack_require__(560),
	        clickOutsideToClose: false
	      });
	    }
	  }, {
	    key: 'changeTab',
	    value: function changeTab(id) {
	      var selector = "#" + id;
	      $('#tabpanel').children().removeClass('active');
	      $(selector).addClass('active');
	      $('#tabcontent').children().removeClass('active');
	      $(selector + '-btn').addClass('active');
	      this.$location.hash('top');
	      this.$anchorScroll();
	    }
	  }]);
	
	  return teacherSelfAssessmentController;
	}();
	
	exports.default = teacherSelfAssessmentController;
	
	
	teacherSelfAssessmentController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'integralEvaluationSrv', '$cookies', 'GlobalConfig', 'WorkPlanSrv', '$mdDialog', '$location', '$anchorScroll'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "22043e8c7084d85807c5d97cfe604d27.gif";

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=row> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <div class=\"panel bg-warning p-md m-b-md\"> <h4 class=no-margin><i class=mdi-alert-warning></i> Estimado profesor, aún quedan preguntas por diligenciar</h4> </div> <h4>Tiene respuestas pendientes en las siguientes secciones:</h4> </div> <div class=\"col-xs-12 col-md-6 col-md-offset-3 text-left\"> <ul class=without-bullets> <li ng-repeat=\"i in data\"><i class=\"mdi-alert-error text-warning i-16\"></i>{{i}}</li> </ul> </div> </div> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-content> </md-dialog-content> </md-dialog>";

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=row> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <div class=\"panel bg-success p-md m-b-md\"> <h4 class=no-margin>¡Ha finalizado su autoevaluación!</h4> </div> <h4>También finalizará la ejecución de su plan de trabajo y pasará a etapa de Revisión de la Ejecución</h4> </div> </div> </md-content> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-light\" ng-click=close()> No Finalizar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=finilize()> Finalizar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=row> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <div class=\"panel bg-success p-md m-b-md\"> <h4 class=no-margin>¡Ha finalizado su autoevaluación!</h4> </div> <h4>También finalizará la ejecución de su plan de trabajo y pasará a etapa de Revisión de la Ejecución</h4> </div> </div> </md-content> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-light\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor vignesh.somayaji@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: teacherSelfAssessmentController
	* # alias: Ctrl
	*/
	
	var teacherAssessmentController = function () {
		function teacherAssessmentController($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, integralEvaluationSrv, $cookies, GlobalConfig, WorkPlanSrv, $mdDialog, $anchorScroll, $location) {
			var _this = this;
	
			_classCallCheck(this, teacherAssessmentController);
	
			var selfAss = this;
	
			this.$state = $state;
			this.$scope = $scope;
			this.$stateParams = $stateParams;
			this.ngNotify = ngNotify;
			this.$timeout = $timeout;
			this.integralEvaluationSrv = integralEvaluationSrv;
			this.GlobalConfig = GlobalConfig;
			this.$mdDialog = $mdDialog;
			this.assignation = [];
			this.imageLoader = __webpack_require__(562);
	
			this.teachingId = 11;
			this.teacherWorkPlanId = 12;
			this.commitmentId = 13;
			this.openQuestionsId = 14;
			this.finalConceptId = 15;
			this.TotalProgressPercentage = { 11: 0, 12: 0, 13: 0, 14: 0, 15: 0 };
			this.percentageBarActualTotal = {};
			this.percentageBarTotal = {};
			this.mandorTory = { 11: 0, 12: 0, 13: 0, 15: 0 };
	
			this.teacherId = this.$stateParams.teacherId;
			this.workplanId = this.$stateParams.workplanId;
			this.userName = this.$stateParams.name;
			this.userId = this.$stateParams.userId;
			this.reviewApprove = this.$stateParams.reviewApprove;
	
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false;
					_this.main();
				}
			});
	
			$scope.flags = 'home';
			$scope.teaching = function (id) {
				$scope.flags = id;
				// $window.scrollTo(0, angular.element('body').offsetTop); 
				$location.hash('nav_bar_id');
				$anchorScroll();
			};
		}
	
		_createClass(teacherAssessmentController, [{
			key: 'main',
			value: function main() {
				console.log('Estoy en el controlador de teacherSelfAssessmentController');
				this.activeParam();
			}
		}, {
			key: 'activeParam',
			value: function activeParam() {
				var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId, options: 'CHIEF' };
	
				var THIS = this;
	
				this.integralEvaluationSrv.asignaturesDetails.getAsignaturesDetails(param).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						THIS.reflection = {};
						THIS.trabajo = {};
						THIS.compromise = {};
						THIS.TotalQuestion = {};
						THIS.questionTitle = {};
	
						for (var i in dataReturn.data.evaluation) {
							if (typeof THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] === 'undefined') {
								// THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]=0
								// THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]=0
							}
	
							if (typeof THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues] === 'undefined') {
								// THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues]=
								THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues] = dataReturn.data.evaluation[i].Formulario;
							}
	
							if (dataReturn.data.evaluation[i].id_code_evaluationmenues == THIS.teacherWorkPlanId || dataReturn.data.evaluation[i].id_code_evaluationmenues == THIS.openQuestionsId || dataReturn.data.evaluation[i].id_code_evaluationmenues == THIS.commitmentId) {
								THIS.trabajo[dataReturn.data.evaluation[i].id_code_questions] = dataReturn.data.evaluation[i].text;
	
								if (dataReturn.data.evaluation[i].text != '') {}
								// THIS.TotalQuestion[dataReturn.data.evaluation[i].id_code_questions]=dataReturn.data.evaluation[i].text
								// THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]+=1
	
								// THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]+=1
							}
						}
	
						for (var i in dataReturn.data.options) {
							if (typeof THIS.questionTitle[dataReturn.data.options[i].id_code_evaluationmenues] === 'undefined') {
								// THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues]=
								THIS.questionTitle[dataReturn.data.options[i].id_code_evaluationmenues] = dataReturn.data.options[i].Formulario;
							}
	
							if (typeof THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] === 'undefined') {
								// THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues]=0
								// THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues]=0
							}
	
							THIS.trabajo[dataReturn.data.options[i].id_code_questions] = dataReturn.data.options[i].text;
							for (var j in dataReturn.data.options[i].value) {
								if (dataReturn.data.options[i].value[j].values == dataReturn.data.options[i].value[j].id_code_options) {
									THIS.TotalQuestion[dataReturn.data.options[i].id_code_questions] = dataReturn.data.options[i].value[j].id_code_options;
									THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder] = dataReturn.data.options[i].value[j].id_code_options;
									THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] += 1;
								} else {
									THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder] = false;
								}
							}
							// THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues]+=1
						}
	
						THIS.assignation = dataReturn.data;
						THIS.docencia = dataReturn.data.evaluation[0].text;
						THIS.checkTotalPercentage();
					}
				}, function (data) {
					console.log('sample vignesh', data);
				});
			}
		}, {
			key: 'checkTotalPercentage',
			value: function checkTotalPercentage() {
				// var param={id_teacher:this.teacherId,id_work_plan:this.workplanId,options:'CHIEF'}
	
				var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId, options: 'CHIEF'
	
					// var param={id_teacher:this.cookiesUser.teacherId,id_work_plan:this.cookiesUser.workplanId,options:'CHIEF'}
				};var THIS = this;
	
				this.integralEvaluationSrv.getTotalPercentageOfEnteredData.getTotal(param).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						console.log('ttttt', dataReturn);
						THIS.TotalProgressPercentage = dataReturn.data;
					}
				}, function (data) {
					console.log('sample vignesh', data);
				});
			}
		}, {
			key: 'teacherTextareaOnBlur',
			value: function teacherTextareaOnBlur(id_question, id, event, id_code_asignature) {
				var id_assignations = null;
	
				if (id_question == 1) {
					var id_assignations = null;
					var text = this.docencia;
				} else {
					var text = this.trabajo[id_question];
				}
	
				if (id == 'options') {
					var id_code_options = $('input[name=radio-' + id_question + ']:checked').val();
					var param = {
						id_question: id_question,
						ds_description: text,
						id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
						id_assignations: id_assignations,
						id_option: id_code_options
					};
				} else {
					var param = {
						id_question: id_question,
						ds_description: text,
						id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
						id_assignations: id_assignations
					};
				}
	
				var THIS = this;
	
				if ($.trim(text) != '') {
					this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {
						$('#imag-loader-screen').hide();
						THIS.checkTotalPercentage();
					}, function (data) {
						$('#imag-loader-screen').hide();
						console.log('error', data);
					});
				} else {
					$('#imag-loader-screen').hide();
				}
			}
		}, {
			key: 'optionSave',
			value: function optionSave(id_code_options, id_question, id_code_evaluationmenues, event) {
				var param = {
					id_question: id_question,
					ds_description: typeof this.trabajo[id_question] === 'undefined' ? null : this.trabajo[id_question],
					id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
					id_option: id_code_options
				};
	
				var THIS = this;
	
				this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {
					$('#imag-loader-screen').hide();
					THIS.checkTotalPercentage();
				}, function (data) {
					console.log('error', data);
					$('#imag-loader-screen').hide();
				});
			}
		}, {
			key: 'endPlanning',
			value: function endPlanning() {
				var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId, options: 'CHIEF' };
				var THIS = this;
	
				this.integralEvaluationSrv.getTotalPercentageOfEnteredData.getTotal(param).$promise.then(function (dataReturn) {
					// this.integralEvaluationSrv.getMandatoryData.getMandatoryDataFlag(param).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						var obj = {},
						    ObjArray = [];
	
						if (dataReturn.data[THIS.teachingId] == 0) {
							ObjArray.push(THIS.questionTitle[THIS.teachingId]);
						}
	
						//  if(dataReturn.data[THIS.teacherWorkPlanId]<100){
						//    ObjArray.push(THIS.questionTitle[THIS.teacherWorkPlanId])
						// }
	
						// if(dataReturn.data[THIS.commitmentId]<100){
						//    ObjArray.push(THIS.questionTitle[THIS.commitmentId])
						// }
	
						if (dataReturn.data[THIS.finalConceptId] == 0) {
							ObjArray.push(THIS.questionTitle[THIS.finalConceptId]);
						}
	
						if (ObjArray.length == 0) {
							var obJtArray = [];
	
							for (var i in THIS.assignation.options) {
								if (THIS.assignation.options[i].id_code_evaluationmenues == THIS.teachingId) {
									for (var j in THIS.assignation.options[i].value) {
										if (THIS.compromise[THIS.assignation.options[i].id_code_questions + '-' + THIS.assignation.options[i].value[j].id_code_options] != false) {
											obJtArray.push(THIS.assignation.options[i].value[j]);
											obJtArray[0].questionId = THIS.assignation.options[i].id_code_questions;
										}
									}
								}
							}
	
							THIS.endProcessModal(obJtArray[0]);
						} else {
							THIS.mandatoryFieldWarningModal(ObjArray);
						}
					}
				}, function (data) {
					console.log('sample vignesh', data);
				});
			}
		}, {
			key: 'getNotifyEndExecution',
			value: function getNotifyEndExecution(idUser, notificationType, details) {
				var data = {
					idUser: idUser,
					dsName: 'Notificación, evaluación finalizada',
					dsDescription: 'Profesor: su plan de trabajo ha sido valorado como ' + details.opcionesPreguntas + ' y fueron registrados los siguientes comentarios: ' + this.trabajo[38],
					idNotification_delivery_type: notificationType,
					is_grouped: 0
				};
			}
		}, {
			key: 'mandatoryFieldWarningModal',
			value: function mandatoryFieldWarningModal(details) {
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', function mandatoryFieldWarningModal($scope, $mdDialog) {
						$scope.data = details;
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(563),
					clickOutsideToClose: false
				});
			}
		}, {
			key: 'endProcessModal',
			value: function endProcessModal(details) {
				var THIS = this;
	
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', 'GlobalConfig', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalSrv', '$state', function mandatoryFieldWarningModal($scope, $mdDialog, GlobalConfig, WorkPlanSrv, WorkPlanModalSrv, GlobalSrv, $state) {
						// $scope.data = response
	
						var headData = WorkPlanModalSrv.getVariable();
	
						var teacherId = THIS.teacherId;
						var workplanId = THIS.workplanId;
	
						var header = {
							comments: THIS.trabajo[details.questionId],
							criteriaId: details.values,
							stageId: 6,
							teacherId: teacherId,
							workplanId: workplanId
						};
	
						$scope.teacherName = THIS.userName;
	
						$scope.close = function () {
							$mdDialog.hide();
						};
	
						$scope.finilize = function () {
							var post = {
								listId: 2,
								workplanId: header.workplanId
							};
	
							WorkPlanSrv.endStages.update(header).$promise.then(function (dataReturn) {
								GlobalSrv.sendNotification(THIS.getNotifyEndExecution(THIS.userId, THIS.GlobalConfig.notificationType.inbox, details));
								GlobalSrv.sendNotification(THIS.getNotifyEndExecution(THIS.userId, THIS.GlobalConfig.notificationType.email, details));
								THIS.finalDialog();
								close();
							}).catch(function (error) {
								console.log(error);
							});
	
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(564),
					clickOutsideToClose: false
				});
			}
		}, {
			key: 'finalDialog',
			value: function finalDialog() {
				var THIS = this;
	
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', '$state', function mandatoryFieldWarningModal($scope, $mdDialog, $state) {
						// $scope.data = details
						$scope.teacherName = THIS.userName;
						$scope.close = function () {
							$mdDialog.hide();
	
							if (THIS.reviewApprove) {
								$state.go('fullscreen.workPlanReviewExecution');
							} else {
								$state.go('workplan.summaryEvaluation', {
									teacherId: THIS.teacherId,
									workplanId: THIS.workplanId,
									name: THIS.userName
								});
							}
						};
					}],
					template: __webpack_require__(565),
					clickOutsideToClose: false
				});
			}
		}]);
	
		return teacherAssessmentController;
	}();
	
	exports.default = teacherAssessmentController;
	
	
	teacherAssessmentController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'integralEvaluationSrv', '$cookies', 'GlobalConfig', 'WorkPlanSrv', '$mdDialog', '$anchorScroll', '$location'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 562 */
557,
/* 563 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=row> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <div class=\"panel bg-warning p-md m-b-md\"> <h4 class=no-margin><i class=mdi-alert-warning></i> Estimado evaluador, aún quedan preguntas por diligenciar</h4> </div> <h4>Tiene respuestas pendientes en las siguientes secciones:</h4> </div> <div class=\"col-xs-12 col-md-6 col-md-offset-3 text-left\"> <ul class=without-bullets> <li ng-repeat=\"i in data\"><i class=\"mdi-alert-error text-warning i-16\"></i>{{i}}</li> </ul> </div> </div> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-content> </md-dialog-content> </md-dialog>";

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=\"row bg-success\"> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <h4>Usted finalizará la evaluación integral del profesor {{teacherName}}, ¿Está seguro?</h4> </div> </div> </md-content> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-light\" ng-click=close()> No Finalizar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=finilize()> Finalizar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-content> <div class=row> <div class=\"col-xs-12 col-md-10 col-md-offset-1\"> <div class=\"panel bg-success p-md m-b-md\"> <h4 class=no-margin>¡Ha finalizado con éxito!</h4> </div> <h4></h4> </div> </div> </md-content> <div class=row> <div class=col-md-12> <md-button class=\"btn btn-fw btn-light\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var integralEvaluationSrv = function integralEvaluationSrv($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, integralEvaluationSrv);
	
	  // NOTIFICATIONS SERVICES
	  var asignaturesDetails = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getAsignaturesDetails', {}, {
	    getAsignaturesDetails: {
	      method: 'GET'
	    }
	  });
	
	  var asignaturesSave = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/updateAssignationValue', {}, {
	    updateAssignationValue: {
	      method: 'POST'
	    }
	  });
	
	  var getMandatoryData = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getMandatoryAsignatures', {}, {
	    getMandatoryDataFlag: {
	      method: 'GET'
	    }
	  });
	
	  var getGraphicAsignature = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getGraphic', {}, {
	    getGraphic: {
	      method: 'GET'
	    }
	  });
	
	  var getTotalPercentageOfEnteredData = $resource(SERVICE_URL_CONSTANT.rosario + '/asignature/getTotalPercentageOfEnteredData', {}, {
	    getTotal: {
	      method: 'GET'
	    }
	  });
	
	  // Services Declarations
	  return {
	    asignaturesDetails: asignaturesDetails,
	    asignaturesSave: asignaturesSave,
	    getMandatoryData: getMandatoryData,
	    getGraphicAsignature: getGraphicAsignature,
	    getTotalPercentageOfEnteredData: getTotalPercentageOfEnteredData
	  };
	};
	
	integralEvaluationSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	exports.default = angular.module('services.integralEvaluationSrv', []).service('integralEvaluationSrv', integralEvaluationSrv).name;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _workplan = __webpack_require__(568);
	
	var _workplan2 = _interopRequireDefault(_workplan);
	
	var _teaching = __webpack_require__(576);
	
	var _teaching2 = _interopRequireDefault(_teaching);
	
	var _academic = __webpack_require__(587);
	
	var _academic2 = _interopRequireDefault(_academic);
	
	var _consolidation = __webpack_require__(599);
	
	var _consolidation2 = _interopRequireDefault(_consolidation);
	
	var _research = __webpack_require__(610);
	
	var _research2 = _interopRequireDefault(_research);
	
	var _extension = __webpack_require__(627);
	
	var _extension2 = _interopRequireDefault(_extension);
	
	var _review = __webpack_require__(640);
	
	var _review2 = _interopRequireDefault(_review);
	
	var _teaching3 = __webpack_require__(642);
	
	var _teaching4 = _interopRequireDefault(_teaching3);
	
	var _academicManagement = __webpack_require__(643);
	
	var _academicManagement2 = _interopRequireDefault(_academicManagement);
	
	var _consolidation3 = __webpack_require__(644);
	
	var _consolidation4 = _interopRequireDefault(_consolidation3);
	
	var _investigation = __webpack_require__(645);
	
	var _investigation2 = _interopRequireDefault(_investigation);
	
	var _extension3 = __webpack_require__(646);
	
	var _extension4 = _interopRequireDefault(_extension3);
	
	var _workplan3 = __webpack_require__(647);
	
	var _workplan4 = _interopRequireDefault(_workplan3);
	
	var _indicators = __webpack_require__(653);
	
	var _indicators2 = _interopRequireDefault(_indicators);
	
	var _consolidation5 = __webpack_require__(654);
	
	var _consolidation6 = _interopRequireDefault(_consolidation5);
	
	var _extension5 = __webpack_require__(662);
	
	var _extension6 = _interopRequireDefault(_extension5);
	
	var _research3 = __webpack_require__(678);
	
	var _research4 = _interopRequireDefault(_research3);
	
	var _workplanSrv = __webpack_require__(690);
	
	var _workplanSrv2 = _interopRequireDefault(_workplanSrv);
	
	var _workplanModalSrv = __webpack_require__(691);
	
	var _workplanModalSrv2 = _interopRequireDefault(_workplanModalSrv);
	
	var _workplanIndicatorSrv = __webpack_require__(727);
	
	var _workplanIndicatorSrv2 = _interopRequireDefault(_workplanIndicatorSrv);
	
	var _activitiesListCtrl = __webpack_require__(728);
	
	var _activitiesListCtrl2 = _interopRequireDefault(_activitiesListCtrl);
	
	var _subjectsListCtrl = __webpack_require__(730);
	
	var _subjectsListCtrl2 = _interopRequireDefault(_subjectsListCtrl);
	
	var _createActivityCtrl = __webpack_require__(731);
	
	var _createActivityCtrl2 = _interopRequireDefault(_createActivityCtrl);
	
	var _consultCalendarCtrl = __webpack_require__(734);
	
	var _consultCalendarCtrl2 = _interopRequireDefault(_consultCalendarCtrl);
	
	var _scheduleListCtrl = __webpack_require__(735);
	
	var _scheduleListCtrl2 = _interopRequireDefault(_scheduleListCtrl);
	
	var _consultSummaryByAreaCtrl = __webpack_require__(740);
	
	var _consultSummaryByAreaCtrl2 = _interopRequireDefault(_consultSummaryByAreaCtrl);
	
	var _planSubjectCtrl = __webpack_require__(742);
	
	var _planSubjectCtrl2 = _interopRequireDefault(_planSubjectCtrl);
	
	var _endPlanningModalCtrl = __webpack_require__(748);
	
	var _endPlanningModalCtrl2 = _interopRequireDefault(_endPlanningModalCtrl);
	
	var _indicatorsCtrl = __webpack_require__(750);
	
	var _indicatorsCtrl2 = _interopRequireDefault(_indicatorsCtrl);
	
	var _indicatorsStartCtrl = __webpack_require__(751);
	
	var _indicatorsStartCtrl2 = _interopRequireDefault(_indicatorsStartCtrl);
	
	var _workplanReviewPhaseCtrl = __webpack_require__(752);
	
	var _workplanReviewPhaseCtrl2 = _interopRequireDefault(_workplanReviewPhaseCtrl);
	
	var _workplanReviewPhaseApprobationCtrl = __webpack_require__(754);
	
	var _workplanReviewPhaseApprobationCtrl2 = _interopRequireDefault(_workplanReviewPhaseApprobationCtrl);
	
	var _workplanReviewExecutionCtrl = __webpack_require__(756);
	
	var _workplanReviewExecutionCtrl2 = _interopRequireDefault(_workplanReviewExecutionCtrl);
	
	var _workplanPhaseExecutionCtrl = __webpack_require__(758);
	
	var _workplanPhaseExecutionCtrl2 = _interopRequireDefault(_workplanPhaseExecutionCtrl);
	
	var _workplanEvaluationCtrl = __webpack_require__(760);
	
	var _workplanEvaluationCtrl2 = _interopRequireDefault(_workplanEvaluationCtrl);
	
	var _chargesListCtrl = __webpack_require__(761);
	
	var _chargesListCtrl2 = _interopRequireDefault(_chargesListCtrl);
	
	var _createParticipationCtrl = __webpack_require__(763);
	
	var _createParticipationCtrl2 = _interopRequireDefault(_createParticipationCtrl);
	
	var _participationsListCtrl = __webpack_require__(764);
	
	var _participationsListCtrl2 = _interopRequireDefault(_participationsListCtrl);
	
	var _rolesListCtrl = __webpack_require__(767);
	
	var _rolesListCtrl2 = _interopRequireDefault(_rolesListCtrl);
	
	var _createRoleCtrl = __webpack_require__(769);
	
	var _createRoleCtrl2 = _interopRequireDefault(_createRoleCtrl);
	
	var _doctoralListCtrl = __webpack_require__(770);
	
	var _doctoralListCtrl2 = _interopRequireDefault(_doctoralListCtrl);
	
	var _createDoctorateCtrl = __webpack_require__(772);
	
	var _createDoctorateCtrl2 = _interopRequireDefault(_createDoctorateCtrl);
	
	var _teachingDevListCtrl = __webpack_require__(773);
	
	var _teachingDevListCtrl2 = _interopRequireDefault(_teachingDevListCtrl);
	
	var _createCourseCtrl = __webpack_require__(775);
	
	var _createCourseCtrl2 = _interopRequireDefault(_createCourseCtrl);
	
	var _learningCommunityListCtrl = __webpack_require__(776);
	
	var _learningCommunityListCtrl2 = _interopRequireDefault(_learningCommunityListCtrl);
	
	var _createLearningComunityCtrl = __webpack_require__(778);
	
	var _createLearningComunityCtrl2 = _interopRequireDefault(_createLearningComunityCtrl);
	
	var _reviewTeacherDevelopmentCtrl = __webpack_require__(779);
	
	var _reviewTeacherDevelopmentCtrl2 = _interopRequireDefault(_reviewTeacherDevelopmentCtrl);
	
	var _projectFormulationProposalsListCtrl = __webpack_require__(780);
	
	var _projectFormulationProposalsListCtrl2 = _interopRequireDefault(_projectFormulationProposalsListCtrl);
	
	var _createProjectFormulationProposalCtrl = __webpack_require__(782);
	
	var _createProjectFormulationProposalCtrl2 = _interopRequireDefault(_createProjectFormulationProposalCtrl);
	
	var _createExtensionProjectCtrl = __webpack_require__(783);
	
	var _createExtensionProjectCtrl2 = _interopRequireDefault(_createExtensionProjectCtrl);
	
	var _projectTypeTag = __webpack_require__(462);
	
	var _projectTypeTag2 = _interopRequireDefault(_projectTypeTag);
	
	var _extensionProjectsListCtrl = __webpack_require__(784);
	
	var _extensionProjectsListCtrl2 = _interopRequireDefault(_extensionProjectsListCtrl);
	
	var _projectStateTag = __webpack_require__(463);
	
	var _projectStateTag2 = _interopRequireDefault(_projectStateTag);
	
	var _projectVisibilityTag = __webpack_require__(464);
	
	var _projectVisibilityTag2 = _interopRequireDefault(_projectVisibilityTag);
	
	var _otherActivitiesListCtrl = __webpack_require__(786);
	
	var _otherActivitiesListCtrl2 = _interopRequireDefault(_otherActivitiesListCtrl);
	
	var _createOtherActivityCtrl = __webpack_require__(788);
	
	var _createOtherActivityCtrl2 = _interopRequireDefault(_createOtherActivityCtrl);
	
	var _itemRequiredModalCtrl = __webpack_require__(792);
	
	var _itemRequiredModalCtrl2 = _interopRequireDefault(_itemRequiredModalCtrl);
	
	var _itemRequiredExecutionModalCtrl = __webpack_require__(793);
	
	var _itemRequiredExecutionModalCtrl2 = _interopRequireDefault(_itemRequiredExecutionModalCtrl);
	
	var _projectsFormulationListCtrl = __webpack_require__(794);
	
	var _projectsFormulationListCtrl2 = _interopRequireDefault(_projectsFormulationListCtrl);
	
	var _createVisibilityCtrl = __webpack_require__(796);
	
	var _createVisibilityCtrl2 = _interopRequireDefault(_createVisibilityCtrl);
	
	var _visibilityListCtrl = __webpack_require__(797);
	
	var _visibilityListCtrl2 = _interopRequireDefault(_visibilityListCtrl);
	
	var _createCounselingAndConsultancyCtrl = __webpack_require__(799);
	
	var _createCounselingAndConsultancyCtrl2 = _interopRequireDefault(_createCounselingAndConsultancyCtrl);
	
	var _counselingAndConsultancyListCtrl = __webpack_require__(800);
	
	var _counselingAndConsultancyListCtrl2 = _interopRequireDefault(_counselingAndConsultancyListCtrl);
	
	var _createProjectFormulationCtrl = __webpack_require__(802);
	
	var _createProjectFormulationCtrl2 = _interopRequireDefault(_createProjectFormulationCtrl);
	
	var _projectsListCtrl = __webpack_require__(803);
	
	var _projectsListCtrl2 = _interopRequireDefault(_projectsListCtrl);
	
	var _createProjectCtrl = __webpack_require__(804);
	
	var _createProjectCtrl2 = _interopRequireDefault(_createProjectCtrl);
	
	var _productsListCtrl = __webpack_require__(805);
	
	var _productsListCtrl2 = _interopRequireDefault(_productsListCtrl);
	
	var _createProductCtrl = __webpack_require__(807);
	
	var _createProductCtrl2 = _interopRequireDefault(_createProductCtrl);
	
	var _collaborationSpacesListCtrl = __webpack_require__(808);
	
	var _collaborationSpacesListCtrl2 = _interopRequireDefault(_collaborationSpacesListCtrl);
	
	var _createSpaceCtrl = __webpack_require__(810);
	
	var _createSpaceCtrl2 = _interopRequireDefault(_createSpaceCtrl);
	
	var _createTrainingResearchCtrl = __webpack_require__(811);
	
	var _createTrainingResearchCtrl2 = _interopRequireDefault(_createTrainingResearchCtrl);
	
	var _trainingResearchListCtrl = __webpack_require__(812);
	
	var _trainingResearchListCtrl2 = _interopRequireDefault(_trainingResearchListCtrl);
	
	var _createResultsTransferCtrl = __webpack_require__(814);
	
	var _createResultsTransferCtrl2 = _interopRequireDefault(_createResultsTransferCtrl);
	
	var _resultsTransferListCtrl = __webpack_require__(815);
	
	var _resultsTransferListCtrl2 = _interopRequireDefault(_resultsTransferListCtrl);
	
	var _shortCoursesListCtrl = __webpack_require__(817);
	
	var _shortCoursesListCtrl2 = _interopRequireDefault(_shortCoursesListCtrl);
	
	var _createShortCoursesCtrl = __webpack_require__(819);
	
	var _createShortCoursesCtrl2 = _interopRequireDefault(_createShortCoursesCtrl);
	
	var _listTransversalProjectsCtrl = __webpack_require__(820);
	
	var _listTransversalProjectsCtrl2 = _interopRequireDefault(_listTransversalProjectsCtrl);
	
	var _addActivityCtrl = __webpack_require__(821);
	
	var _addActivityCtrl2 = _interopRequireDefault(_addActivityCtrl);
	
	var _registerExecutionCtrl = __webpack_require__(822);
	
	var _registerExecutionCtrl2 = _interopRequireDefault(_registerExecutionCtrl);
	
	var _editChildrenExecutionCtrl = __webpack_require__(823);
	
	var _editChildrenExecutionCtrl2 = _interopRequireDefault(_editChildrenExecutionCtrl);
	
	var _executionEntriesCtrl = __webpack_require__(824);
	
	var _executionEntriesCtrl2 = _interopRequireDefault(_executionEntriesCtrl);
	
	var _endStageModalCtrl = __webpack_require__(825);
	
	var _endStageModalCtrl2 = _interopRequireDefault(_endStageModalCtrl);
	
	var _viewFileCtrl = __webpack_require__(827);
	
	var _viewFileCtrl2 = _interopRequireDefault(_viewFileCtrl);
	
	var _feedbackReviewedModalCtrl = __webpack_require__(828);
	
	var _feedbackReviewedModalCtrl2 = _interopRequireDefault(_feedbackReviewedModalCtrl);
	
	var _customChartController = __webpack_require__(830);
	
	var _customChartController2 = _interopRequireDefault(_customChartController);
	
	var _reflexionesDePortafolioEvidenciasController = __webpack_require__(831);
	
	var _reflexionesDePortafolioEvidenciasController2 = _interopRequireDefault(_reflexionesDePortafolioEvidenciasController);
	
	var _successDialogCtrl = __webpack_require__(832);
	
	var _successDialogCtrl2 = _interopRequireDefault(_successDialogCtrl);
	
	var _reviewSrv = __webpack_require__(833);
	
	var _reviewSrv2 = _interopRequireDefault(_reviewSrv);
	
	var _executionCtrl = __webpack_require__(834);
	
	var _executionCtrl2 = _interopRequireDefault(_executionCtrl);
	
	var _summaryCtrl = __webpack_require__(836);
	
	var _summaryCtrl2 = _interopRequireDefault(_summaryCtrl);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	var _modalSrv = __webpack_require__(839);
	
	var _modalSrv2 = _interopRequireDefault(_modalSrv);
	
	var _warningApprovalCtrl = __webpack_require__(841);
	
	var _warningApprovalCtrl2 = _interopRequireDefault(_warningApprovalCtrl);
	
	var _autoevaluationController = __webpack_require__(842);
	
	var _autoevaluationController2 = _interopRequireDefault(_autoevaluationController);
	
	var _reflexionesportafolioController = __webpack_require__(843);
	
	var _reflexionesportafolioController2 = _interopRequireDefault(_reflexionesportafolioController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// standard modals
	
	
	// summary controllers
	
	
	// review services
	
	
	// reflexiones de portafolio evidencias model controller
	
	
	// review controllers
	
	
	// Controladores de Extension y Visibilidad
	
	
	// services
	exports.default = angular.module('app.workplan', [_workplanSrv2.default, _workplanModalSrv2.default, _workplanIndicatorSrv2.default, _modalSrv2.default, _reviewSrv2.default]).config(_workplan2.default).config(_teaching2.default).config(_review2.default).config(_teaching4.default).config(_academicManagement2.default).config(_consolidation4.default).config(_investigation2.default).config(_extension4.default).config(_academic2.default).config(_consolidation2.default).config(_research2.default).config(_extension2.default).run(_workplan4.default).run(_indicators2.default).run(_consolidation6.default).run(_extension6.default).run(_research4.default).controller('SubjectsListCtrl', _subjectsListCtrl2.default).controller('ActivitiesListCtrl', _activitiesListCtrl2.default).controller('CreateActivityCtrl', _createActivityCtrl2.default).controller('ConsultCalendarCtrl', _consultCalendarCtrl2.default).controller('ScheduleListCtrl', _scheduleListCtrl2.default).controller('PlanSubjectCtrl', _planSubjectCtrl2.default).controller('ConsultSummaryByAreaCtrl', _consultSummaryByAreaCtrl2.default).controller('IndicatorsCtrl', _indicatorsCtrl2.default).controller('ChargesListCtrl', _chargesListCtrl2.default).controller('RolesListCtrl', _rolesListCtrl2.default).controller('CreateRoleCtrl', _createRoleCtrl2.default).controller('ParticipationListCtrl', _participationsListCtrl2.default).controller('CreateParticipationCtrl', _createParticipationCtrl2.default).controller('DoctoralListCtrl', _doctoralListCtrl2.default).controller('CreateDoctorateCtrl', _createDoctorateCtrl2.default).controller('TeachingDevListCtrl', _teachingDevListCtrl2.default).controller('CreateCourseCtrl', _createCourseCtrl2.default).controller('LearningCommunityListCtrl', _learningCommunityListCtrl2.default).controller('OtherActivitiesListCtrl', _otherActivitiesListCtrl2.default).controller('CreateLearningComunityCtrl', _createLearningComunityCtrl2.default).controller('ReviewTeacherDevelopmentCtrl', _reviewTeacherDevelopmentCtrl2.default).controller('CreateOtherActivityCtrl', _createOtherActivityCtrl2.default).controller('projectTypeCtrl', _projectTypeTag2.default).controller('ExtensionProjectsListCtrl', _extensionProjectsListCtrl2.default).controller('projectVisibilityCtrl', _projectVisibilityTag2.default).controller('IndicatorsStartCtrl', _indicatorsStartCtrl2.default).controller('WorkPlanReviewPhaseCtrl', _workplanReviewPhaseCtrl2.default).controller('WorkPlanReviewPhaseApprobationCtrl', _workplanReviewPhaseApprobationCtrl2.default).controller('WorkPlanReviewExecutionCtrl', _workplanReviewExecutionCtrl2.default).controller('WorkPlanPhaseExecutionCtrl', _workplanPhaseExecutionCtrl2.default).controller('WorkplanEvaluationCtrl', _workplanEvaluationCtrl2.default)
	
	// Transversal controllers
	.controller('ExecutionCtrl', _executionCtrl2.default).controller('EndPlanningModalCtrl', _endPlanningModalCtrl2.default).controller('EndStageModalCtrl', _endStageModalCtrl2.default).controller('ViewFileCtrl', _viewFileCtrl2.default).controller('FeedbackReviewedModalCtrl', _feedbackReviewedModalCtrl2.default).controller('listTransversalProjectsCtrl', _listTransversalProjectsCtrl2.default)
	
	// custom chart controller
	.controller('customChartController', _customChartController2.default).controller('autoevaluationController', _autoevaluationController2.default).controller('reflexionesportafolioController', _reflexionesportafolioController2.default)
	
	// evidencias model controller
	.controller('reflexionesDePortafolioEvidenciasController', _reflexionesDePortafolioEvidenciasController2.default)
	
	// research Controllers
	.controller('ProjectsFormulationListCtrl', _projectsFormulationListCtrl2.default).controller('CreateProjectFormulationCtrl', _createProjectFormulationCtrl2.default).controller('ProjectsListCtrl', _projectsListCtrl2.default).controller('CreateProjectCtrl', _createProjectCtrl2.default).controller('ProductsListCtrl', _productsListCtrl2.default).controller('CreateProductCtrl', _createProductCtrl2.default).controller('CollaborationSpacesListCtrl', _collaborationSpacesListCtrl2.default).controller('CreateSpaceCtrl', _createSpaceCtrl2.default).controller('CreateTrainingResearchCtrl', _createTrainingResearchCtrl2.default).controller('TrainingResearchListCtrl', _trainingResearchListCtrl2.default).controller('CreateResultsTransferCtrl', _createResultsTransferCtrl2.default).controller('ResultsTransferListCtrl', _resultsTransferListCtrl2.default)
	// extension Controllers
	.controller('CreateVisibilityCtrl', _createVisibilityCtrl2.default).controller('VisibilityListCtrl', _visibilityListCtrl2.default).controller('CreateCounselingAndConsultancyCtrl', _createCounselingAndConsultancyCtrl2.default).controller('CounselingAndConsultancyListCtrl', _counselingAndConsultancyListCtrl2.default).controller('ProjectFormulationProposalsListCtrl', _projectFormulationProposalsListCtrl2.default).controller('CreateProjectFormulationProposalCtrl', _createProjectFormulationProposalCtrl2.default).controller('CreateExtensionProjectCtrl', _createExtensionProjectCtrl2.default).controller('ShortCoursesListCtrl', _shortCoursesListCtrl2.default).controller('CreateShortCoursesCtrl', _createShortCoursesCtrl2.default).controller('ItemRequiredModalCtrl', _itemRequiredModalCtrl2.default).controller('ItemRequiredExecutionModalCtrl', _itemRequiredExecutionModalCtrl2.default).controller('SummaryCtrl', _summaryCtrl2.default).controller('AddActivityCtrl', _addActivityCtrl2.default).controller('RegisterExecutionCtrl', _registerExecutionCtrl2.default).controller('EditChildrenExecutionCtrl', _editChildrenExecutionCtrl2.default).controller('ExecutionEntriesCtrl', _executionEntriesCtrl2.default).controller('warningApprovalCtrl', _warningApprovalCtrl2.default).controller('SuccessDialogCtrl', _successDialogCtrl2.default).constant('workplan', [{
		title: 'Plan de trabajo',
		icon: 'mdi-image-tune',
		subMenu: [{
			title: 'Inicio',
			url: 'fullscreen.workPlanGeneralInformation',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.unitAdmin],
			menuRoleId: [_globalConfig2.default.modules.indexOption],
			stageId: [_globalConfig2.default.workplanIdStages.planning],
			showIfWorkplanActive: true
		}, {
			title: 'Revisión',
			url: 'fullscreen.workPlanReview',
			rolesAllowed: [_globalConfig2.default.userRolesIds.reviewer, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.consultant]
		}, {
			title: 'Aprobación',
			url: 'fullscreen.workPlanApproval',
			rolesAllowed: [_globalConfig2.default.userRolesIds.approver, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.consultant]
		}, {
			title: 'Evaluación',
			url: 'fullscreen.workPlanEvaluation',
			rolesAllowed: [_globalConfig2.default.userRolesIds.approver, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.consultant]
		}, {
			title: 'Revisión de la ejecución',
			url: 'fullscreen.workPlanReviewExecution',
			rolesAllowed: [_globalConfig2.default.userRolesIds.reviewer, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.consultant]
		}, {
			title: 'Docencia',
			url: 'workplan.teachingSubjects',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant],
			menuRoleId: [_globalConfig2.default.modules.teaching],
			stageId: [_globalConfig2.default.workplanIdStages.planning],
			showIfWorkplanActive: true
		}, {
			title: 'Investigación e innovación',
			url: 'workplan.projectsFormulation',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant],
			menuRoleId: [_globalConfig2.default.modules.investigation],
			stageId: [_globalConfig2.default.workplanIdStages.planning],
			showIfWorkplanActive: true
		}, {
			title: 'Extensión y visibilidad',
			url: 'workplan.projectProposalFormulation',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant],
			menuRoleId: [_globalConfig2.default.modules.extentionAndVisibility],
			stageId: [_globalConfig2.default.workplanIdStages.planning],
			showIfWorkplanActive: true
		}, {
			title: 'Gestión Académica',
			url: 'workplan.delegationCharges',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant],
			menuRoleId: [_globalConfig2.default.modules.academicManagement],
			stageId: [_globalConfig2.default.workplanIdStages.planning],
			showIfWorkplanActive: true
		}, {
			title: 'Consolidación de cuerpo profesoral',
			url: 'workplan.teachingDevelopment',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant],
			menuRoleId: [_globalConfig2.default.modules.consolidation],
			stageId: [_globalConfig2.default.workplanIdStages.planning],
			showIfWorkplanActive: true
		}, {
			title: 'Ejecución',
			url: 'fullscreen.workPlanExecution',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant, _globalConfig2.default.userRolesIds.workplanConsultant],
			menuRoleId: [_globalConfig2.default.modules.execution],
			stageId: [_globalConfig2.default.workplanIdStages.execution],
			showIfWorkplanActive: true
		}, {
			title: 'Resumen',
			url: 'workplan.executionHistory',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant],
			menuRoleId: [_globalConfig2.default.modules.execution],
			stageId: [_globalConfig2.default.workplanIdStages.execution],
			showIfWorkplanActive: true
		}, {
			title: 'Resumen',
			url: 'workplan.history',
			rolesAllowed: [_globalConfig2.default.userRolesIds.teacher, _globalConfig2.default.userRolesIds.support, _globalConfig2.default.userRolesIds.generalConsultant],
			menuRoleId: [_globalConfig2.default.modules.planning],
			stageId: [_globalConfig2.default.workplanIdStages.planning],
			showIfWorkplanActive: true
		}, {
			title: 'Planes de Trabajo',
			url: 'fullscreen.workplanList',
			rolesAllowed: [_globalConfig2.default.userRolesIds.workPlanAdmin, _globalConfig2.default.userRolesIds.workplanConsultant, _globalConfig2.default.userRolesIds.unitAdmin, _globalConfig2.default.userRolesIds.gerencialConsultant, _globalConfig2.default.userRolesIds.workplanCommittee, _globalConfig2.default.userRolesIds.committee, _globalConfig2.default.userRolesIds.comiteeAdmin]
		}]
	}]).name;
	
	// config file
	
	
	// global success modal
	
	
	// custom chart controller
	
	// Controladores de Extension y Visibilidad
	
	
	// Controladores de Investigacion
	
	
	// controllers
	
	
	// runs
	// routers

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan', {
	    abstract: false,
	    url: '/workplan',
	    views: {
	      '': {
	        template: __webpack_require__(168)
	      },
	      'content': {
	        template: __webpack_require__(169)
	      },
	      'aside': {
	        template: __webpack_require__(170),
	        controller: 'AsideCtrl'
	      },
	      'header': {
	        template: __webpack_require__(171),
	        controller: 'HeaderCtrl'
	      },
	      'chatbox': {
	        template: __webpack_require__(172),
	        controller: 'ChatboxController',
	        controllerAs: 'chatbox'
	      },
	      'footer': {
	        template: __webpack_require__(177)
	      }
	    },
	    data: { displayName: 'Inicio' }
	  }).state('fullscreen.workPlanGeneralInformation', {
	    abstract: false,
	    url: '/workplanGeneralInfo',
	    template: __webpack_require__(569),
	    controller: 'ConsultSummaryByAreaCtrl',
	    controllerAs: 'summaryByAreaVm',
	    data: {
	      displayName: 'Inicio'
	    }
	  }).state('workplan.summary', {
	    abstract: false,
	    tag: 'summary',
	    url: '/summary',
	    template: __webpack_require__(570),
	    controller: 'summaryController',
	    controllerAs: 'summaryVM',
	    data: {
	      displayName: 'Resumen'
	    }
	  }).state('fullscreen.workplanReviewApprobation', {
	    abstract: false,
	    url: '/workplanReviewApprobation',
	    views: {
	      '': {
	        template: __webpack_require__(571)
	      },
	      'principal@': {
	        template: __webpack_require__(572),
	        controller: 'WorkPlanReviewPhaseApprobationCtrl',
	        controllerAs: 'reviewPhaseApprobationVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(573),
	        controller: 'IndicatorsStartCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Etapa aprobación'
	    }
	  }).state('fullscreen.workPlanPhaseExecution', {
	    abstract: false,
	    url: '/workPlanPhaseExecution',
	    template: __webpack_require__(574),
	    controller: 'WorkPlanPhaseExecutionCtrl',
	    controllerAs: 'workPlanPhaseExecutionVm',
	    data: {
	      displayName: 'Etapa de ejecución'
	    }
	  }).state('fullscreen.workplanEvaluation1', {
	    abstract: false,
	    url: '/workplanEvaluation1',
	    template: __webpack_require__(575),
	    controller: 'WorkplanEvaluationCtrl',
	    controllerAs: 'workplanEvaluationVM',
	    data: {
	      displayName: 'Etapa de evaluación'
	    }
	  });
	}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row gutter-10\"> <div class=\"intro-message m-b-lg\"> <div class=col-md-12> <h1 class=\"text-blanco text-center no-m-t\">Bienvenido al Plan de Trabajo</h1> <h3 class=\"text-blanco text-center m-t-xs proxima font-normal\">Etapa de {{summaryByAreaVm.stage ||'Planeación'}}</h3> </div> </div> <div class=\"col-md-12 m-t-lg\"> <div class=row> <div class=col-xs-12> <h4 class=\"text-blanco text-center\">La distribución de su Plan de Trabajo es:</h4> </div> </div> <div class=row> <div class=\"col-md-1-5 text-center\" ng-repeat=\"item in summaryByAreaVm.asignaturesPlaned\"> <div class=row> <div class=\"col-md-12 text-center p\"> <div class={{item.classDiagram}} ng-click=summaryByAreaVm.submoduleroute(item.submoduleId) ng-class=\"{\n\t\t\t\t              \t\t'cyan'\t\t\t: (item.submoduleId==2),\n\t\t\t\t              \t\t'green'\t\t\t: (item.submoduleId==3),\n\t\t\t\t              \t\t'purple'\t\t: (item.submoduleId==4),\n\t\t\t\t              \t\t'yellow'\t\t: (item.submoduleId==5),\n\t\t\t\t              \t\t'orange'\t\t: (item.submoduleId==6)\n\t\t\t\t              \t}\"> <span class=pointer>{{item.percentage || 0}}% </span> <h4 class=\"text-blanco text-xs m-t-radio-execution\">{{item.submoduleName}}</h4> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row m-b-lg\"> <div class=\"col-md-12 m-b-button\"> <button class=\"btn btn-success btn-lg p-h-lg text-md font-bold p-v btn-fullscreen p-r-md\" ng-click=summaryByAreaVm.showModalMessages() ng-disabled=summaryByAreaVm.disableButton> Principios orientadores</button> </div> </div> <div class=\"row p\"> <div class=\"col-lg-8 col-lg-offset-2\"> <h3 class=\"text-blanco text-center m-b-lg\">Linea de tiempo etapas</h3> <ol class=timeline> <li> <div class=item> <div class=\"circle {{summaryByAreaVm.classCircleGreen1}}\"> <div class=label-item>Planeación</div> </div> <div class=\"line {{summaryByAreaVm.classBarGreen1}}\"></div> </div> </li> <li> <div class=item> <div class=\"circle {{summaryByAreaVm.classCircleGreen2}}\"> <div class=label-item>Aprobación</div> </div> <div class=\"line {{summaryByAreaVm.classBarGreen2}}\"></div> </div> </li> <li> <div class=item> <div class=\"circle {{summaryByAreaVm.classCircleGreen3}}\"> <div class=label-item>Ejecución</div> </div> <div class=\"line {{summaryByAreaVm.classBarGreen3}}\"></div> </div> </li> <li> <div class=item> <div class=\"circle {{summaryByAreaVm.classCircleGreen4}}\"> <div class=label-item>Evaluación</div> </div> </div> </li> </ol> </div> </div> <div class=col-md-12> </div> </div>";

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	module.exports = " <style>div#view{background-color:#f6f6f6}</style> <div class=\"row p-v-sm\"> <div class=\"col-xs-12 col-md-6 p-v p-h-lg\"> <h3>Resumen {{summaryVm.textStage.toLowerCase()}} plan de trabajo - {{summaryVm.headerPage.teacherName}} </h3> </div> <div class=\"col-md-12 col-md-4 p-h-lg p-v text-left\" ng-show=summaryVm.inReview> <button class=\"btn btn-fw md-button md-ink-ripple btn-primary pull-right\" type=button ng-click=summaryVm.showModalFeedback() ng-show=summaryVm.isFeedback ng-disabled=summaryVm.isFinishedButtonDisabled has-permission=finalizar-resumen-edit> <md-tooltip md-direction=bottom>Retroalimentar al profesor</md-tooltip>Finalizar y retroalimentar </button> </div> <div class=\"col-sm-12 col-md-2 p-h-lg p-v text-left pull-right\" ng-if=summaryVm.showFinishButton> <button class=\"btn btn-fw md-button md-ink-ripple btn-success pull-right\" type=button ng-show=\"summaryVm.showEndStageButton() && summaryVm.isReviewerApprover\" ng-disabled=summaryVm.isFinishedButtonDisabled ng-click=summaryVm.showModal(true)>Finalizar {{summaryVm.textStageUnified}}</button> <button class=\"btn btn-fw md-button md-ink-ripple btn-success pull-right\" type=button ng-show=\"summaryVm.showEndStageButton() && !summaryVm.isReviewerApprover\" ng-disabled=summaryVm.isFinishedButtonDisabled ng-click=summaryVm.showModal() has-permission=finalizar-resumen-edit>Finalizar {{summaryVm.textStage.toLowerCase()}}</button> </div> </div> <div class=row> <div class=\"col-xs-12 p-h-lg\"> <div class=card> <div class=row> <div class=\"col-xs-6 col-sm-2 col-md-2\"> <div class=img-container> <div class=\"p m-l-md\"> <img src={{picture}} style=width:90px;height:90px class=img-circle err-src={{notPicture}}> </div> </div> </div> <div class=\"col-xs-12 col-sm-10 col-md-10\"> <div class=row> <div class=\"col-xs-4 col-md-4 m-t-md\"> <div class=row> <div class=\"col-xs-6 col-md-6\"> <p class=text-azul-light>Nombre profesor</p> </div> <div class=\"col-xs-6 col-md-6\"> <p style=margin-left:1em>{{summaryVm.headerPage.teacher_name || 'Sin Especificar'}}</p> </div> </div> <div class=row> <div class=\"col-xs-6 col-md-6\"> <p class=text-azul-light>Tipología<span class=hidden-sm> de profesor</span></p> </div> <div class=\"col-xs-6 col-md-6\"> <p style=margin-left:1em>{{summaryVm.headerPage.teacher_type || 'Sin especificar'}}</p> </div> </div> <div class=row ng-show=summaryVm.inApproval> <div class=\"col-xs-12 col-md-12\"> <p class=text-azul-light>Nombre del Revisor</p> </div> <div class=\"col-xs-12 col-md-12\"> <p align=justify>{{summaryVm.headerPage.revieweds || 'Sin especificar'}}</p> </div> </div> <div class=row ng-show=summaryVm.inEvaluation> <div class=\"col-xs-12 col-md-12\"> <p class=text-azul-light>Nombre del Revisor</p> </div> <div class=\"col-xs-12 col-md-12\"> <p align=justify>{{summaryVm.headerPage.revieweds || 'Sin especificar'}}</p> </div> </div> <div class=row ng-show=summaryVm.inApproval> <div class=\"col-xs-12 col-md-12\"> <p class=text-azul-light>Comentarios de la revisión</p> </div> <div class=\"col-xs-12 col-md-12\"> <p align=justify>{{summaryVm.headerPage.reviewedComments || 'Sin especificar'}}</p> </div> </div> <div class=row ng-show=summaryVm.inEvaluation> <div class=\"col-xs-12 col-md-12\"> <p class=text-azul-light>Comentarios de la revisión de la ejecución</p> </div> <div class=\"col-xs-12 col-md-12\"> <p align=justify>{{summaryVm.headerPage.reviewedExecutionComments || 'Sin especificar'}}</p> </div> </div> <div class=row ng-show=summaryVm.inEvaluation> <div class=\"col-xs-12 col-md-12\"> <p class=text-azul-light>Criterio de Evaluación</p> </div> <div class=\"col-xs-12 col-md-12\"> <p align=justify>{{summaryVm.headerPage.evaluationCriteria || 'Sin especificar'}}</p> </div> </div> </div> <div class=\"col-xs-4 m-t-md\"> <div class=row> <div class=col-xs-8> <p class=\"text-azul-light hidden-sm\">Total horas planeadas</p> <p class=\"text-azul-light hidden-md hidden-lg\">T/Horas plan.</p> </div> <div class=col-xs-4> <p style=margin-left:1em>{{summaryVm.hours_planned_detail || 0}}</p> </div> </div> <div class=row> <div class=col-xs-8> <p class=\"text-azul-light hidden-sm\">Total horas ejecutadas</p> <p class=\"text-azul-light hidden-md hidden-lg\">T/Horas ejec.</p> </div> <div class=col-xs-4> <p style=margin-left:1em>{{summaryVm.hours_executed_detail || 0}}</p> </div> </div> <div class=row ng-show=summaryVm.approvalOnwards> <div class=col-xs-8> <p class=\"text-azul-light hidden-sm\">Horas Mínimas</p> <p class=\"text-azul-light hidden-md hidden-lg\">Hr min.</p> </div> <div class=col-xs-4> <p style=margin-left:1em>{{summaryVm.headerPage.num_min_hours || 0}}</p> </div> </div> <div class=row ng-show=summaryVm.approvalOnwards> <div class=col-xs-8> <p class=\"text-azul-light hidden-sm\">Horas Máximas</p> <p class=\"text-azul-light hidden-md hidden-lg\">Hr max.</p> </div> <div class=col-xs-4> <p style=margin-left:1em>{{summaryVm.headerPage.num_max_hours || 0}}</p> </div> </div> <div class=row> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades con seguimiento estratégico</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Seguimiento estratégico</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.send_strategic}} </p> </div> </div> </div> <div class=\"col-xs-4 m-t-md\"> <div class=row> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades agregadas en ejecución</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Ejecución</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.execution}} </p> </div> </div> <div class=row> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades revisadas</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Revisadas</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.reviewed}} </p> </div> </div> <div class=row ng-if=summaryVm.approvalOnwards> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades aprobadas</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Aprobadas</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.approved}} </p> </div> </div> <div class=row ng-if=summaryVm.approvalOnwards> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades rechazadas</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Rechazadas</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.no_approved}} </p> </div> </div> <div class=row ng-if=summaryVm.reviewExecutionOnwards> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades con ejecución revisada</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Ejecución revisada</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.reviewedExecution}} </p> </div> </div> <div class=row ng-if=summaryVm.inEvaluation> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades evaluadas aprobadas</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Evaluadas</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.accept}} </p> </div> </div> <div class=row ng-if=summaryVm.inEvaluation> <div class=\"col-xs-8 col-sm-7\"> <p class=\"text-azul-light hidden-sm\">Actividades evaluadas no aprobadas</p> <p class=\"text-azul-light hidden-md hidden-lg\">Act/Evaluadas no aprobadas</p> </div> <div class=\"col-xs-4 col-sm-5\"> <p style=margin-left:1em> {{summaryVm.headerPage.no_accept}} </p> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row p-t\"> <div class=col-xs-12> <div class=\"row m-b-md\"> <div class=\"col-md-12 m-l\"> <div class=m-r-lg> <button class=\"btn btn-fw md-button md-ink-ripple btn-warning pull-right\" type=button ng-click=summaryVm.showWarning() ng-if=\"summaryVm.inApproval || summaryVm.inEvaluation || summaryVm.inReview || summaryVm.inReviewExecution\" style=margin-right:0 ng-disabled=summaryVm.isFinishedButtonDisabled> <i class=\"icon mdi-action-done-all i-20\"></i> Marcar todas como aprobadas </button> </div> </div> </div> <div class=row> <div class=\"col-md-12 m-l\"> <div class=m-r-lg> <div class=text-center ng-if=isLoading> <md-progress-circular style=display:inline-block;color:#fff!important class=md-hue-2 md-diameter=80px></md-progress-circular> <div><span class=\"text-negro text-left text-md\">Cargando información...</span></div> </div> <div class=\"grid grid-blue grid-with-button\" ui-grid=gridOptions ui-grid-exporter ng-if=gridOptions.data ui-grid-tree-view></div> </div> </div> </div> <div class=row ng-if=summaryVm.showResumen> <div class=col-sm-12> <ul class=\"nav nav-md nav-tabs nav-lines b-info nav-justified\"> <li class=active ng-if=summaryVm.selfEvaluation> <a href=\"\" data-toggle=tab data-target=#autoevaluacion>Autoevaluación</a> </li> <li ng-class=\"{ active: !summaryVm.selfEvaluation }\" has-permission=reflexion-portafolio-revision-view> <a href=\"\" data-toggle=tab data-target=#reflexionesDePortafolio>Reflexiones de Portafolio</a> </li> <li has-permission=apreciacion-estudiantes-revision-view> <a href=\"\" data-toggle=tab data-target=#resultadosDeApreciacion>Apreciación de estudiantes</a> </li> </ul> <div class=\"tab-content p-h-lg p-v-md\"> <div ng-include=\"'autoevaluacion.html'\" role=tabpanel class=\"tab-pane animated fadeIn active\" id=autoevaluacion ng-if=summaryVm.selfEvaluation has-permission=reflexion-portafolio-revision-view></div> <div ng-include=\"'reflexionesDePortafolio.html'\" role=tabpanel class=\"tab-pane animated fadeIn\" id=reflexionesDePortafolio></div> <div ng-include=\"'resultadosDeApreciacion.html'\" role=tabpanel class=\"tab-pane animated fadeIn\" id=resultadosDeApreciacion has-permission=apreciacion-estudiantes-revision-view></div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div ui-view=indicators@></div> <div ui-view=principal@></div> </div> ";

/***/ }),
/* 572 */
/***/ (function(module, exports) {

	module.exports = "<style>.ui-grid-viewport{overflow-anchor:none}</style> <div class=col-md-9> <div class=\"row title p-v-sm\"> <div class=\"no-padding m-b-lg col-md-12\"> <div class=col-md-12> <h1 class=\"text-blanco text-left\">Bienvenido a plan de trabajo <span class=text-md>Etapa de aprobaci&oacute;n</span> </h1> </div> </div> <div class=\"row p-t search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=reviewPhaseApprobationVm.WorkPlanFilter ng-model-options=\"{ debounce: 300 }\" ng-change=activateWorkPlanVM.filter() class=form-control placeholder=Buscar> <div class=input-group-btn> <button class=\"btn btn-default search-btn p-xs\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"col-xs-offset-1 col-xs-10 m-t-lg\"> <div class=grid-workplan ui-grid=reviewPhaseApprobationVm.gridOptions ng-if=reviewPhaseApprobationVm.gridOptions.data ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns></div> </div> </div> </div> ";

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-2> <div class=row> <div class=col-md-12> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p{{indicatorsVM.percentEndPlaning}} green center\" ui-sref=workplan.teachingSubjects> <span class=pointer>{{indicatorsVM.percentEndPlaning}}%</span> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> <h4 class=\"text-blanco text-xs\">Planes de trabajo</h4> <h4 class=\"text-blanco text-xs\">Etapa de Planeación terminados</h4> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p{{indicatorsVM.percentReview}} green center\"> <span class=pointer>{{indicatorsVM.percentReview}}%</span> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> <h4 class=\"text-blanco text-xs\">Planes de trabajo</h4> <h4 class=\"text-blanco text-xs\">revisados</h4> </div> </div> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p{{indicatorsVM.percentPendingNewReview}} green center\" ui-sref=workplan.delegationCharges> <span class=pointer>{{indicatorsVM.percentPendingNewReview}}%</span> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> <h4 class=\"text-blanco text-xs\">Planes de trabajo</h4> <h4 class=\"text-blanco text-xs\">revisados pendiente</h4> <h4 class=\"text-blanco text-xs\">de nueva revisión</h4> </div> </div> </div>";

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row gutter-10\"> <div class=\"intro-message m-b-lg\"> <div class=col-md-12> <h1 class=\"text-blanco text-left\">Bienvenido al plan de trabajo <span class=text-md>Etapa de ejecuci&oacute;n</span> </h1> </div> </div> <div class=\"col-md-12 m-t-lg\"> <div class=col-md-12> <div class=\"col-md-2 text-center\"> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p{{workPlanPhaseExecutionVm.percentage}} green center\" ui-sref=workplan.teachingSubjects> <span class=pointer>{{workPlanPhaseExecutionVm.percentage}}%</span> <h4 class=\"text-blanco text-xs m-t-xlg\">Docencia</h4> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> </div> </div> </div> <div class=\"col-md-2 text-center\"> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p0 green center\"> <span class=pointer>0%</span> <h4 class=\"text-blanco text-xs m-t-xlg\">Consolidación</h4> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> </div> </div> </div> <div class=\"col-md-2 text-center\"> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p0 green center\" ui-sref=workplan.delegationCharges> <span class=pointer>0%</span> <h4 class=\"text-blanco text-xs m-t-xlg\">Gestión<br>Académica</h4> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> </div> </div> </div> <div class=\"col-md-2 text-center\"> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p0 green center\"> <span class=pointer>0%</span> <h4 class=\"text-blanco text-xs m-t-xlg\">Investigación</h4> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> </div> </div> </div> <div class=\"col-md-2 text-center\"> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p0 green center\"> <span class=pointer>0%</span> <h4 class=\"text-blanco text-xs m-t-xlg\">Extención y <br>visibilidad</h4> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> </div> </div> </div> </div> </div> <div class=\"intro-message m-b-lg\"> <div class=\"col-md-12 m-b-button\"> <button class=\"btn btn-success btn-lg p-h-lg text-md font-bold p-v btn-fullscreen p-r-md\" ui-sref=workplan.teachingSubjects> Ir a plan de trabajo</button> </div> </div> <div class=col-md-12> <div class=col-md-6> <div class=col-md-5> <p class=\"text-blanco text-right text-md\"> Línea de tiempo etapas </p> </div> <div class=\"col-md-7 div-father p-t\"> <div> <div class=div-gris> </div> <div class=div-green ng-style=workPlanPhaseExecutionVm.classBarGreen> </div> <div class=square-planification> <div class=radio-planification ng-style=workPlanPhaseExecutionVm.classRadioGreenPlaneation> <div class=radio-white> </div> </div> <div class=p-t> <span class=\"text-xxs teaching\">Planeación</span> </div> </div> <div class=square-approval> <div class=radio-approval ng-style=workPlanPhaseExecutionVm.classRadioGreenApproval> <div class=radio-white> </div> </div> <div class=p-t> <span class=\"text-xxs teaching\">Aprobación</span> </div> </div> <div class=square-execution> <div class=radio-execution ng-style=workPlanPhaseExecutionVm.classRadioGreenExecution> <div class=radio-white> </div> </div> <div class=p-t> <span class=\"text-xxs teaching\">Ejecución</span> </div> </div> <div class=square-evaluation> <div class=radio-evaluation ng-style=workPlanPhaseExecutionVm.classRadioGreenEvaluation> <div class=radio-white> </div> </div> <div class=p-t> <span class=\"text-xxs teaching\">Evaluación</span> </div> </div> </div> </div> </div> <div class=col-md-4> <p> <i class=\"icon mdi-communication-email i-20 text-blanco text-right text-md\"> Tiene {{workPlanPhaseExecutionVm.messagesList.length}} principio orientador nuevo. <span class=underscore ng-click=workPlanPhaseExecutionVm.showModalMessages()>Revisar</span> </i> </p> </div> <div class=col-md-2> <p class=\"text-blanco text-right text-md pointer\" ui-sref=workplan.teachingSubjects> Ir a Docencia <i class=\"icon mdi-navigation-arrow-forward i-20\"> </i> </p> </div> </div> </div> ";

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row gutter-10\"> <div class=\"col-md-2 m-t-lg text-center\"> <div class=row> <md-button class=\"btn text-center p-sm\" style=border-style:solid;border-color:#fff;border-width:medium;width:163px ng-click=\"workplanEvaluationVM.activePlans('specialSituations')\"> <span class=\"text-blanco font-bold text-center\">Planes de trabajo</span><br/> <span class=\"text-blanco font-bold text-center\">con situaciones</span><br/> <span class=\"text-blanco font-bold text-center\">especiales</span> </md-button> </div> <div class=\"m-r-md m-b-lg\" ng-show=workplanEvaluationVM.isActiveSpecialSituations style=width:163px> <h4 class=\"text-blanco m-t-lg font-bold text-center\">&nbsp;&nbsp;Indicadores</h4> <div class=m-b-lg> <h3> <span class=\"text-blanco font-bold text-center pull-left m-b-lg\"> {{workplanEvaluationVM.numberActualIndicator}}/{{workplanEvaluationVM.numberTotalIndicator}} </span> <span class=\"text-blanco font-bold text-center pull-right m-b-lg\">{{workplanEvaluationVM.numberPercentIndicator}}%</span> </h3> </div> </div> <div class=row> <md-button class=\"btn text-center p-sm\" style=border-style:solid;border-color:#fff;border-width:medium;width:163px ng-click=\"workplanEvaluationVM.activePlans('evaluated')\"> <span class=\"text-blanco font-bold text-center\">Planes de trabajo</span><br/> <span class=\"text-blanco font-bold text-center\">evaluados</span> </md-button> </div> <div class=\"m-r-md m-b-lg\" ng-show=workplanEvaluationVM.isActiveEvaluated style=width:163px> <h4 class=\"text-blanco m-t-lg font-bold text-center\">&nbsp;&nbsp;Indicadores</h4> <div class=m-b-lg> <h3> <span class=\"text-blanco font-bold text-center pull-left m-b-lg\"> {{workplanEvaluationVM.numberActualIndicator}}/{{workplanEvaluationVM.numberTotalIndicator}} </span> <span class=\"text-blanco font-bold text-center pull-right m-b-lg\">{{workplanEvaluationVM.numberPercentIndicator}}%</span> </h3> </div> </div> <div class=row> <md-button class=\"btn text-center p-sm\" style=border-style:solid;border-color:#fff;border-width:medium;width:163px ng-click=\"workplanEvaluationVM.activePlans('adjustments')\"> <span class=\"text-blanco font-bold text-center\">Planes de trabajo</span><br/> <span class=\"text-blanco font-bold text-center\">con ajustes</span> </md-button> </div> <div class=\"m-r-md m-b-lg\" ng-show=workplanEvaluationVM.isActiveAdjustments style=width:163px> <h4 class=\"text-blanco m-t-lg font-bold text-center\">&nbsp;&nbsp;Indicadores</h4> <div class=m-b-lg> <h3> <span class=\"text-blanco font-bold text-center pull-left m-b-lg\"> {{workplanEvaluationVM.numberActualIndicator}}/{{workplanEvaluationVM.numberTotalIndicator}} </span> <span class=\"text-blanco font-bold text-center pull-right m-b-lg\">{{workplanEvaluationVM.numberPercentIndicator}}%</span> </h3> </div> </div> <div class=row> <md-button class=\"btn text-center p-sm\" style=border-style:solid;border-color:#fff;border-width:medium;width:163px ng-click=\"workplanEvaluationVM.activePlans('forEvaluating')\"> <span class=\"text-blanco font-bold text-center\">Planes de trabajo</span><br/> <span class=\"text-blanco font-bold text-center\">por evaluar</span> </md-button> </div> <div class=\"m-r-md m-b-lg\" ng-show=workplanEvaluationVM.isActiveForEvaluating style=width:163px> <h4 class=\"text-blanco m-t-lg font-bold text-center\">&nbsp;&nbsp;Indicadores</h4> <div class=m-b-lg> <h3> <span class=\"text-blanco font-bold text-center pull-left m-b-lg\"> {{workplanEvaluationVM.numberActualIndicator}}/{{workplanEvaluationVM.numberTotalIndicator}} </span> <span class=\"text-blanco font-bold text-center pull-right m-b-lg\">{{workplanEvaluationVM.numberPercentIndicator}}%</span> </h3> </div> </div> </div> <div class=col-xs-10> <div class=\"no-padding m-b\"> <h1 class=text-blanco>Bienvenido a plan de trabajo <span class=text-md>Etapa de evaluaci&oacute;n</span> </h1> </div> <div class=m-l-sm ng-show=workplanEvaluationVM.isActiveSpecialSituations> <p></p><h3 class=text-blanco>Planes de trabajo con situaciones especiales<a href=\"\" ng-click=\"workplanEvaluationVM.exportGrid('specialSituations')\"><span class=\"pull-right text-blanco\"><h5> <b><i class=\"mdi-file-file-download i-24\"></i> Descargar listado </b></h5></span></a></h3><p></p> </div> <div class=m-l-sm ng-show=workplanEvaluationVM.isActiveEvaluated> <p></p><h3 class=text-blanco>Planes de trabajo evaluados <a href=\"\" ng-click=\"workplanEvaluationVM.exportGrid('evaluated')\"><span class=\"pull-right text-blanco\"><h5> <b><i class=\"mdi-file-file-download i-24\"></i> Descargar listado </b></h5></span></a></h3><p></p> </div> <div class=m-l-sm ng-show=workplanEvaluationVM.isActiveAdjustments> <p></p><h3 class=text-blanco>Planes de trabajo con ajustes <a href=\"\" ng-click=\"workplanEvaluationVM.exportGrid('adjustments')\"><span class=\"pull-right text-blanco\"><h5> <b><i class=\"mdi-file-file-download i-24\"></i> Descargar listado </b></h5></span></a></h3><p></p> </div> <div class=m-l-sm ng-show=workplanEvaluationVM.isActiveForEvaluating> <p></p><h3 class=text-blanco>Planes de trabajo por evaluar <a href=\"\" ng-click=\"workplanEvaluationVM.exportGrid('forEvaluating')\"><span class=\"pull-right text-blanco\"><h5> <b><i class=\"mdi-file-file-download i-24\"></i> Descargar listado </b></h5></span></a></h3><p></p> </div> <div class=\"panel-heading p-sm b-b b-light\"> <div class=\"input-group stylish-input-group\"> <input id=filter type=text ng-model=workplanEvaluationVM.workPlanFilter ng-model-options=\"{ debounce: 300 }\" ng-change=workplanEvaluationVM.filter() class=form-control placeholder=\" Buscar..\"/> <div class=input-group-btn> <button class=\"btn btn-default search-btn p-xs\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> <div ng-if=\"(workplanEvaluationVM.isActiveSpecialSituations) && (workplanEvaluationVM.gridOptionsSpecialSituations.data)\" class=\"grid-workplan specialSituations-export\" ui-grid=workplanEvaluationVM.gridOptionsSpecialSituations ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns></div> <div ng-if=\"(workplanEvaluationVM.isActiveEvaluated) && (workplanEvaluationVM.gridOptionsEvaluated.data)\" class=\"grid-workplan evaluated-export\" ui-grid=workplanEvaluationVM.gridOptionsEvaluated ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns></div> <div ng-if=\"(workplanEvaluationVM.isActiveAdjustments) && (workplanEvaluationVM.gridOptionsAdjustments.data)\" class=\"grid-workplan adjustments-export\" ui-grid=workplanEvaluationVM.gridOptionsAdjustments ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns></div> <div ng-if=\"(workplanEvaluationVM.isActiveForEvaluating) && (workplanEvaluationVM.gridOptionsForEvaluating.data)\" class=\"grid-workplan forEvaluating-export\" ui-grid=workplanEvaluationVM.gridOptionsForEvaluating ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns></div> <div ng-if=\"(workplanEvaluationVM.isActiveDefaultGrid) && (workplanEvaluationVM.gridOptionsDefault.data)\" class=grid-workplan ui-grid=workplanEvaluationVM.gridOptionsDefault ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns></div> </div> </div> ";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.teachingSubjects', {
	    moduleId: _globalConfig2.default.modules.teaching,
	    abstract: false,
	    url: '/teaching/subjects',
	    views: {
	      '': {
	        template: __webpack_require__(577)
	      },
	      'principal@': {
	        template: __webpack_require__(578),
	        controller: 'SubjectsListCtrl',
	        controllerAs: 'subjectsListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Planear la asignatura',
	      order: 1,
	      title: 'Docencia',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.listActivities',
	        order: 2
	      }, {
	        name: 'workplan.consultCalendar',
	        order: 3
	      }, {
	        name: 'workplan.history',
	        order: 4
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.teaching,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.teaching', {
	    moduleId: _globalConfig2.default.modules.teaching,
	    abstract: false,
	    url: '/teaching/subjects',
	    views: {
	      '': {
	        template: __webpack_require__(577)
	      },
	      'principal@': {
	        template: __webpack_require__(578),
	        controller: 'SubjectsListCtrl',
	        controllerAs: 'subjectsListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Docencia',
	      order: 1,
	      title: 'Docencia',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.listActivities',
	        order: 2
	      }, {
	        name: 'workplan.consultCalendar',
	        order: 3
	      }, {
	        name: 'workplan.history',
	        order: 4
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.teaching,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.listActivities', {
	    moduleId: _globalConfig2.default.modules.teaching,
	    abstract: false,
	    url: '/teaching/listActivities',
	    views: {
	      '': {
	        template: __webpack_require__(580)
	      },
	      'principal@': {
	        template: __webpack_require__(581),
	        controller: 'ActivitiesListCtrl',
	        controllerAs: 'activitiesVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Otras actividades',
	      order: 2,
	      title: 'Docencia',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.teachingSubjects',
	        order: 1
	      }, {
	        name: 'workplan.consultCalendar',
	        order: 3
	      }, {
	        name: 'workplan.history',
	        order: 4
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.teaching,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createActivity', {
	    moduleId: _globalConfig2.default.modules.teaching,
	    abstract: false,
	    url: '/teaching/createActivity/:activityId',
	    template: __webpack_require__(582),
	    controller: 'CreateActivityCtrl',
	    controllerAs: 'createActivityVm',
	    data: {
	      displayName: 'Otras actividades',
	      order: 2,
	      title: 'Docencia',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.teachingSubjects',
	        order: 1
	      }, {
	        name: 'workplan.consultCalendar',
	        order: 3
	      }, {
	        name: 'workplan.history',
	        order: 4
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.consultCalendar', {
	    moduleId: _globalConfig2.default.modules.teaching,
	    abstract: false,
	    url: '/teaching/consultCalendar/',
	    views: {
	      '': {
	        template: __webpack_require__(583)
	      },
	      'principal@': {
	        template: __webpack_require__(584),
	        controller: 'ConsultCalendarCtrl',
	        controllerAs: 'consultCalendarVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Programar tiempos de atención a estudiantes',
	      order: 3,
	      title: 'Docencia',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.teachingSubjects',
	        order: 1
	      }, {
	        name: 'workplan.listActivities',
	        order: 2
	      }, {
	        name: 'workplan.history',
	        order: 4
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.teaching,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.listSchedule', {
	    moduleId: _globalConfig2.default.modules.teaching,
	    abstract: false,
	    url: '/teaching/listSchedules',
	    template: __webpack_require__(585),
	    controller: 'ScheduleListCtrl',
	    controllerAs: 'schedulesListVm',
	    data: {
	      displayName: 'Programar tiempos de atención a estudiantes',
	      order: 5,
	      title: 'Docencia',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.teachingSubjects',
	        order: 1
	      }, {
	        name: 'workplan.listActivities',
	        order: 2
	      }, {
	        name: 'workplan.history',
	        order: 6
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.planSubject', {
	    moduleId: _globalConfig2.default.modules.teaching,
	    abstract: false,
	    url: '/teaching/planSubject/:subjectId',
	    template: __webpack_require__(586),
	    controller: 'PlanSubjectCtrl',
	    controllerAs: 'subjectVm',
	    data: {
	      displayName: 'Planear la asignatura',
	      order: 1,
	      title: 'Docencia',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.listActivities',
	        order: 2
	      }, {
	        name: 'workplan.consultCalendar',
	        order: 3
	      }, {
	        name: 'workplan.history',
	        order: 4
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  });
	}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row gris-base\"> <div ui-view=principal@></div> <div ui-view=indicators@></div> </div> ";

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-9 p-h-lg p-v m-b-xs\"> <h3>Planear la asignatura</h3> <p class=text-16-important>Revise las asignaturas asignadas y para cada una, haga clik en la opción \"Planear asignatura\" para registrar las horas programadas</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"subjectsListVm.feedback && !subjectsListVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=subjectsListVm.bitacora($event)> Bitácora de Asignaturas </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-l-lg no-padding-r\"> <div class=\"input-group stylish-input-group\"> <input type=text name=search ng-model=subjectsListVm.search ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=\"Buscar asignatura\" ng-change=subjectsListVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-t-md p-h-lg\"> <div class=col-md-12> <slick class=slick-oblique-large current-index=index infinite=false slides-to-show=3 responsive=breakpoints adaptive-height=true respond-to=min ng-if=\"subjectsListVm.subjects.length && subjectsListVm.viewLoaded && (subjectsListVm.subjects | filter: subjectsListVm.search).length != 0\"> <div class=p-h-sm ng-repeat=\"subject in subjectsListVm.subjects | filter: subjectsListVm.search | orderBy: 'asignatureName'\"> <div class=\"card brd-md\"> <div class=\"card-heading slick-oblique-teaching p-v-lg text-blanco hidden-content\" ng-class=subjectsListVm.backgroundGrad($index)> <h3 class=\"exo font-base text-base text-center\">{{subject.asignatureName | limitTo : 70}}{{subject.asignatureName.length > 70 ? '...' : ''}}</h3> <span class=\"proxima font-thin text-center text-xs\">{{subject.asignatureCode}}</span> <div class=\"hours p-xs font-thin\" ng-class=subjectsListVm.getItemListByAssignature(subject)> <span class=\"number text-md\">{{subject.asignatureHours}}</span> <p class=text-xxs>Horas<br>docencia</p> </div> </div> <div class=\"card-body long\" style=\"padding:0 24px\"> <div class=\"text-center m-v period proxima text-md font-thin\"> <span class=periodicity-name ng-repeat=\"periodicityName in subject.periodicityNameArray\">{{periodicityName}}<br></span> <p class=\"text-gris-darker text-base exo font-semibold p-v-xs\">Per&iacute;odo</p> </div> <div class=\"text-center m-v\"> <span class=\"proxima text-md font-thin\" ng-if=\"subject.groupsTempName != null\">{{subject.groupsTempName}}</span> <span class=\"proxima text-md font-thin\" ng-if=\"subject.groupsTempName == null\"> <br/> </span> <p class=\"text-gris-darker text-base exo font-semibold\">Grupos</p> </div> <div class=\"text-center m-v\"> <span class=\"proxima font-thin\" ng-if=\"subject.modality != null\"> {{subject.modality}} / {{subject.type}}</span> <span class=\"proxima font-thin\" ng-if=\"subject.modality == null\"> <br/> </span> <p class=\"text-gris-darker exo font-semibold text-base\">Modalidad / Tipologia</p> </div> <div class=\"text-center m-v text-base\"> <span class=\"proxima font-thin\" ng-if=\"subject.level != null\">{{subject.level}}</span> <span class=\"proxima font-thin\" ng-if=\"subject.level == null\"> <br/> </span> <p class=\"text-gris-darker exo font-semibold\">Nivel</p> </div> </div> <div> <md-checkbox class=\"md-green no-margin text-sm\" name=selPlanearAsig_{{subject.asignatureId}} ng-model=subject.isForPlanning ng-true-value=1 ng-change=subjectsListVm.updateIsPlanning(subject) ng-false-value=0 ng-disabled=\"subjectsListVm.planningFinish || subject.checkPlanningProcess\"> Planear asignatura </md-checkbox> </div> <br> <div class=\"text-center m-b-md\"> <md-button ng-disabled=\"subject.isForPlanning === 0 || subjectsListVm.planningFinish\" ui-sref=\"workplan.planSubject({subjectId: subject.asignatureId})\" class=\"btn btn-fw btn-success p-h-md no-margin\">Planear</md-button> </div> </div> </div> </slick> </div> <div class=clearfix></div> <div class=\"alert btn-cancel alert-dismissable m-t\"> <button type=button class=close data-dismiss=alert>&times;</button> <p class=\"text-sm text-azul\">Si la asignatura que usted imparte no aparece en este listado por favor comun&iacute;quese con la Secretar&iacute;a Acad&eacute;mica de su unidad</p> </div> </div> </div> ";

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-2 ng-show=\"indicatorsVm.type === indicatorsVm.globalConfig.teaching\"> <div class=row> <div class=\"col-md-12 text-center p-sm\"> <div class=\"c100 p{{indicatorsVm.percentage}} center\"> <span>{{indicatorsVm.percentage}}%</span> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> <p class=\"text-center text-gris-dark text-xs m-t-sm exo\">Docencia en su plan de trabajo</p> <p>{{globalConfig}}</p> </div> </div> <div class=row> <div class=\"col-md-12 text-center m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-editor-border-color i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\"> {{indicatorsVm.asignaturesAssigned}}/{{indicatorsVm.totalAsignatures}} </span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Asignaturas<br>planeadas</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-extension i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.otherActivities}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Otras actividades<br>agregadas</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-social-people i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.hours}}<span class=text-xs>HRS</span></span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Atención<br>presencial<br>a estudiantes<br>por semana</p> </div> </div> </div> <div class=col-md-2 ng-show=\"indicatorsVm.type === indicatorsVm.globalConfig.academicManagement\"> <div class=row> <div class=\"col-md-12 text-center p-sm\"> <div class=\"c100 p{{indicatorsVm.percentage}} center\"> <span>{{indicatorsVm.percentage}}%</span> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> <p class=\"text-center text-gris-dark text-xs m-t-sm exo\">Gestión Académica en su <br>Plan de trabajo</p> </div> </div> <div class=row> <div class=\"col-md-12 center\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-editor-border-color i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\"> {{indicatorsVm.chargesAssigned}}/{{indicatorsVm.totalCharges}} </span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Cargos a<br>delegación</p> </div> </div> <div class=row> <div class=col-md-12> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-account-circle i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.roles}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Roles<br>agregados</p> </div> </div> <div class=row> <div class=col-md-12> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-group-work i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.committee}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Participación en<br>comités</p> </div> </div> <div class=row> <div class=col-md-12> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-extension i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.otherActivities}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Otras <br>actividades</p> </div> </div> </div> <div class=col-md-2 ng-show=\"indicatorsVm.type === indicatorsVm.globalConfig.consolidationCP\"> <div class=row> <div class=\"col-md-12 text-center p-sm\"> <div class=\"c100 p{{indicatorsVm.percentage}} center\"> <span>{{indicatorsVm.percentage}}%</span> <div class=slice> <div class=\"bar grad-1\"></div> <div class=\"fill grad-1\"></div> </div> </div> <p class=\"text-center text-gris-dark text-xs p-h m-t-sm exo\">Consolidación de cuerpo <br>profesoral en su Plan de trabajo</p> </div> </div> <div class=row> <div class=\"col-md-12 text-center m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-editor-border-color i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.phd}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Formación<br>Doctoral</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-extension i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.courses}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Desarrollo<br>Profesoral</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-social-people i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.communities}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Comunidades de aprendizaje y práctica</p> </div> </div> </div> <div class=col-md-2 ng-show=\"indicatorsVm.type === indicatorsVm.globalConfig.research\"> <div class=row> <div class=\"col-md-12 text-center p-sm\"> <div class=\"c100 p{{indicatorsVm.percentage}} center\"> <span>{{indicatorsVm.percentage}}%</span> <div class=slice> <div class=\"bar grad-1\"></div> <div class=\"fill grad-1\"></div> </div> </div> <p class=\"text-center text-gris-dark text-xs m-t-sm exo\">Progreso de Investigación e Innovación</p> </div> </div> <div ng-if=\"indicatorsVm.pagination == 1\"> <div class=row> <div class=\"col-md-12 text-center m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-assignment i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.projectsFormulated}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Formulación de<br>Propuestas</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-assignment-turned-in i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.projects}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Proyectos</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-book i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.products}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Producto</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v\" ng-click=\"indicatorsVm.pagination = 2\"> <div class=text-center> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:gray></i> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:#ccc></i> </div> </div> </div> </div> <div ng-if=\"indicatorsVm.pagination == 2\"> <div class=row> <div class=\"col-md-12 text-center m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-group-work i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.spacesCollaboration}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Espacio de<br>Colaboración</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-search i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.researchTraining}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Formación en<br>Investigación</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-find-replace i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.transferResults}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Transferencia de <br> resultados </p> </div> </div> <div class=row> <div class=\"col-md-12 m-v\" ng-click=\"indicatorsVm.pagination = 1\"> <div class=text-center> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:#ccc></i> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:gray></i> </div> </div> </div> </div> </div> <div class=col-md-2 ng-show=\"indicatorsVm.type === indicatorsVm.globalConfig.extension\"> <div class=row> <div class=\"col-md-12 text-center p-sm\"> <div class=\"c100 p{{indicatorsVm.percentage}} center\"> <span>{{indicatorsVm.percentage}}%</span> <div class=slice> <div class=\"bar grad-1\"></div> <div class=\"fill grad-1\"></div> </div> </div> <p class=\"text-center text-gris-dark text-xs m-t-sm exo\">Progreso de Extensión y Visibilidad</p> </div> </div> <div ng-if=\"indicatorsVm.pagination == 1\"> <div class=row> <div class=\"col-md-12 text-center m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-assignment i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.projectsFormulated}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Formulación de<br>Proyectos</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-assignment-turned-in i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.projectsExtension}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Proyectos de<br>Extensión</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-visibility i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.visibility}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Visibilidad</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v\" ng-click=\"indicatorsVm.pagination = 2\"> <div class=text-center> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:gray></i> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:#ccc></i> </div> </div> </div> </div> <div ng-if=\"indicatorsVm.pagination == 2\"> <div class=row> <div class=\"col-md-12 text-center m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-account-circle i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.adviceConsultancy}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Asesoría y<br>Consultoría</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <i class=\"icon mdi-action-extension i-24 vertical-align-sm\"></i> <span class=\"text-lg p-h-sm\">{{indicatorsVm.shortCourses}}</span> </div> <p class=\"text-center text-gris-dark text-xs exo\">Cursos Cortos</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v-xs\"> <div class=\"text-azul text-center\"> <span class=\"text-lg p-h-sm\"></span> </div> <p class=\"text-center text-gris-dark text-xs exo\">&nbsp</p> </div> </div> <div class=row> <div class=\"col-md-12 m-v\" ng-click=\"indicatorsVm.pagination = 1\"> <div class=text-center> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:#ccc></i> <i class=\"icon mdi-image-lens i-12 vertical-align-sm pointer\" style=color:gray></i> </div> </div> </div> </div> </div> ";

/***/ }),
/* 580 */
577,
/* 581 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>Otras actividades de docencia<span class=text-xs> (no relacionadas con asignaturas)</span></h3> <p class=text-16-important>En esta secci&oacute;n puede agregar otras actividades que no est&eacute;n directamente relacionadas a una asignatura</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"activitiesVm.feedback && !activitiesVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=activitiesVm.bitacora($event)> Bitácora de Otras actividades de docencia </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-l-lg np-padding-r\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=activitiesVm.teachingActivitiesSearch ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=\"Buscar actividades\"> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-t-md\"> <div class=\"col-md-12 p-l-lg rounded-list\"> <div class=\"col-md-12 blanco m-t no-padding\" ng-repeat=\"activitiesList in activitiesVm.activities | filter : activitiesVm.teachingActivitiesSearch\"> <div class=\"col-md-3 p-v-sm\"> <h5 class=\"text-azul font-bold no-padding no-margin l-h list-title\"> <span>{{activitiesList.otherActivityName | limitTo: 47 }}</span> <span ng-if=\"activitiesList.otherActivityName.length > 47\">...</span> </h5> <p class=\"text-xs no-padding no-margin text-gris-dark\"><i>{{activitiesList.activityTypeName}}</i></p> </div> <div class=\"col-md-5 p-v-sm\"> <h6 class=\"text-xs no-padding no-margin text-gris-dark\">Detalle de la actividad</h6> <p class=\"text-xs no-padding no-margin fix-max-height detail\" style=word-wrap:break-word;width:320px>{{activitiesList.otherActivityDetail}}</p> </div> <div ng-class=classPlanning class=\"grad-1 col-md-4 text-blanco no-margin no-padding-h p-v border-radio-left flex align-items-center\"> <div class=\"col-md-6 text-center\"> <h3 class=\"no-margin proxima font-thin\">{{activitiesList.otherActivityHoursPlaned}} <span class=text-sm>HRS.</span></h3> </div> <div class=\"col-md-3 text-center\"> <a class=\"text-xxs m-r-md flex align-items-center flex-direction-column\" ui-sref=\"workplan.createActivity({activityId: activitiesList.otherActivityCode})\" has-permission=otras-actividades-docencia-edit> <i class=\"icon mdi-content-create i-20 m-r-xs m-b-sm\"></i> Editar </a> </div> <div class=\"col-md-3 text-center\"> <a class=\"text-xxs m-r-md md-green flex align-items-center flex-direction-column\" ng-click=activitiesVm.confirmDisableActivity(activitiesList) has-permission=otras-actividades-docencia-edit> <i class=\"icon mdi-action-delete i-20 m-r-xs m-b-sm\"></i> Eliminar </a> </div> </div> </div> </div> <div class=\"col-md-12 p-v text-center\"> <md-button class=\"btn btn-fw btn-primary no-margin\" ui-sref=workplan.createActivity ng-disabled=activitiesVm.planningFinish has-permission=otras-actividades-docencia-edit>Agregar otras actividades de docencia</md-button> </div> </div> </div> ";

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = "<style type=text/css>.borderojo{outline:0;border:1px solid red}.bordegris{border:1px solid #d4d4d}</style> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>{{createActivityVm.createOrEdit}} actividad</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar una nueva actividad. Una vez terminado haga clic en el bot&oacute;n agregar actividad</p> </div> </div> <div class=\"row blanco p-v\" style=\"height:calc(100% - 110px)\"> <form name=createActivity novalidate> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-9 no-padding-r\"> <div class=form-group ng-class=createActivityVm.hasError(createActivity.typeActivity)> <label for=typeActivity class=control-label>Tipo de actividad *</label> <select name=typeActivity ng-model=createActivityVm.typeActivity ng-options=\"listActivities.activityTypeCode as listActivities.activityTypeName for listActivities in createActivityVm.comboActivities\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createActivity.typeActivity.$error ng-show=createActivityVm.showErrorMessages(createActivity.typeActivity)> <div ng-message=required>La actividad es requerida</div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group ng-class=createActivityVm.hasError(createActivity.hours)> <label for=hours class=control-label>Horas planeadas *</label> <input type=number name=hours ng-model=createActivityVm.hours class=form-control onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" min=1 onpaste=return!1 required/> <div class=control-label ng-messages=createActivity.hours.$error ng-show=createActivityVm.showErrorMessages(createActivity.hours)> <div ng-message=required>Las horas son requeridas</div> <div ng-message=min>Las horas ingresadas deben ser mayor a cero</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createActivityVm.hasError(createActivity.nameActivity)> <label for=nameActivity class=control-label>Nombre de actividad *</label> <input type=text name=nameActivity ng-model=createActivityVm.nameActivity ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createActivity.nameActivity.$error ng-show=createActivityVm.showErrorMessages(createActivity.nameActivity)> <div ng-message=required>El nombre es requerido</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createActivityVm.hasError(createActivity.detail)> <label for=detail class=control-label>Descripci&oacute;n *</label> <md-input-container class=control-label> <textarea name=detail ng-model=createActivityVm.detail maxlength=500 rows=2 md-maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-9 no-padding\"> <div class=control-label ng-messages=createActivity.detail.$error ng-show=createActivityVm.showErrorMessages(createActivity.detail)> <div ng-message=required>La descripci&oacute;n es requerida</div> </div> </div> <div class=\"col-md-3 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-7 no-padding\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.listActivities>Volver</md-button> </div> <div class=\"col-md-5 no-padding text-right\"> <md-button class=\"btn btn-fw btn-success text-right no-margin\" ng-disabled=createActivityVm.validateForm(createActivity) ng-show=!createActivityVm.isEditing ng-click=\"createActivityVm.addActivity(false, false); createActivityVm.cleanForm(createActivity);\"> Guardar y agregar otra actividad </md-button> <md-button class=\"btn btn-fw btn-primary text-xs p-h-md\" ng-show=createActivityVm.isEditing ng-click=\"createActivityVm.addActivity(true, false); createActivityVm.cleanForm(createActivity);\" ng-disabled=\"createActivityVm.isSaveButtonDisabled || createActivityVm.validateForm(createActivity)\"> Guardar actividad</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <div class=row> <div class=\"alert alert-dismissable col-md-11 bg-azul\"> <button type=button class=close data-dismiss=alert>&times;</button> <p class=\"text-sm text-justify\">Recuerde que las actividades de formaci&oacute;n a la investigaci&oacute;n como: Semilleros, Tutor&iacute;as, Direcci&oacute;n, Supervisi&oacute;n, y otros se encuentran en <span class=font-semibold>formaci&oacute;n</span> en investigaci&oacute;n</p> </div> </div> </div> </form> </div> ";

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row gris-lighter\"> <div ui-view=principal@></div> <div ui-view=indicators@></div> </div> ";

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Programar tiempos de atenci&oacute;n a estudiantes</h3> <p class=\"text-justify text-16-important\">Consulte a continuación los horarios de atención a estudiantes programados hasta el momento. Ingrese a la opción \"Configurar horarios de atención\" para registrar la planeación de sus horas de atención directa y virtual.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"consultCalendarVm.feedback && !consultCalendarVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=consultCalendarVm.bitacora($event)> Bitácora de Atención a estudiantes </md-button> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-9 no-padding\"> <div class=\"row gutter-12\"> <div class=\"col-xs-12 col-md-12\"> <div class=\"\"> <div class=p-l-xl> <span>{{subtitle}}</span> <div class=clearfix></div> <mwl-calendar ng-if=consultCalendarVm.showCalendar events=consultCalendarVm.eventSources view-date=consultCalendarVm.viewDate view-title=consultCalendarVm.calendarTitle view=consultCalendarVm.calendarView cell-auto-open-disabled=false day-view-start={{consultCalendarVm.headerCalendar.START_MODULE}} day-view-end={{consultCalendarVm.headerCalendar.END_MODULE}} day-view-split={{consultCalendarVm.dayViewSplit}} custom-template-urls=\"{calendarWeekView: 'calendarWeekDay.html'}\" on-view-change-click=\"consultCalendarVm.viewChangeClicked(calendarDate, calendarNextView)\" on-event-click=consultCalendarVm.onEventClick(calendarEvent); on-date-range-select=\"consultCalendarVm.rangeSelected(calendarRangeStartDate, calendarRangeEndDate)\" on-timespan-click=consultCalendarVm.cellModifier(calendarCell)> </mwl-calendar> </div> </div> </div> </div> <script id=calendarWeekDay.html type=text/ng-template> <div class=\"cal-week-box capitalize\" ng-class=\"{'cal-day-box': vm.showTimes}\">\n            <div class=\"cal-row-fluid azul p-l-cal text-center\">\n              <div\n                class=\"cal-cell1\"\n                ng-repeat=\"day in vm.view.days | limitTo:6\"\n                ng-class=\"{\n                  'cal-day-past': day.isPast,\n                  'cal-day-future': day.isFuture}\"\n                mwl-element-dimensions=\"vm.dayColumnDimensions\"\n                <span class=\"text-xxs\" ng-bind=\"day.weekDayLabel\"></span>\n                <br>\n                \n              </div>\n            </div>\n\n            <div class=\"cal-day-panel clearfix\" style=\"height: 550px\">\n\n              <mwl-calendar-hour-list\n                day-view-start=\"vm.dayViewStart\"\n                day-view-end=\"vm.dayViewEnd\"\n                day-view-split=\"vm.dayViewSplit\"\n                day-width=\"vm.dayColumnDimensions.width\"\n                view-date=\"vm.viewDate\"\n                on-timespan-click=\"vm.onTimespanClick\"\n                on-date-range-select=\"vm.onDateRangeSelect\"\n                custom-template-urls=\"vm.customTemplateUrls\"\n                cell-modifier=\"vm.cellModifier\"\n                template-scope=\"vm.templateScope\"\n                ng-if=\"vm.showTimes\">\n              </mwl-calendar-hour-list>\n\n               <div class=\"row\" ng-repeat=\"row in vm.view.eventRows\">\n                <div class=\"col-xs-12\">\n                  <div class=\"cal-row-fluid \">\n                    <div\n                      ng-repeat=\"eventRow in row.row track by eventRow.event.calendarEventId\"\n                      ng-style=\"{\n                        top: vm.showTimes ? ((eventRow.top ) + 'px') : 'auto',\n                        position: vm.showTimes ? 'absolute' : 'inherit',\n                        width: vm.showTimes ? (vm.dayColumnDimensions.width + 'px') : '',\n                        left: vm.showTimes ? (vm.dayColumnDimensions.width * eventRow.offset) + 14 + 'px' : ''}\">\n                      <div\n                        ng-style=\"{height: eventRow.event.height + 'px'}\"\n                        ng-class=\"eventRow.event.cssClass\"\n                        class=\"cursor-pointer\"\n                        ng-click=\"vm.onEventClick({calendarEvent: eventRow.event})\"\n                        data-event-class>\n                        {{eventRow.event.title}}\n                        \n                        <span\n                          ng-if=\"eventRow.event.details.length == 1\"\n                          href=\"javascript:;\"\n                          ng-class=\"eventRow.event.cssClassLetra\"\n                          ng-bind-html=\"eventRow.event.details[0].ID_PUBLIC |\n                          calendarTrustAsHtml\"\n                          tooltip-placement=\"bottom\"\n                          tooltip-html-unsafe=\"{{eventRow.event.details[0].ID_PUBLIC}}\n                          {{eventRow.event.details[0].NAME_COURSE}}\">\n                        </span><br/>\n                        <small ng-if=\"eventRow.event.details.length == 1\">\n                          <strong\n                            ng-class=\"eventRow.event.cssClassLetra\"\n                            href=\"javascript:;\"\n                            ng-bind-html=\"eventRow.event.details[0].NAME_COURSE |\n                            calendarTrustAsHtml\"\n                            tooltip-placement=\"bottom\"\n                            tooltip-html-unsafe=\"{{eventRow.event.details[0].PUBLICID}}\n                            {{eventRow.event.details[0].NAME_COURSE}}\">\n                          </strong>\n                        </small>\n                        <center>\n                          <span\n                            ng-if=\"eventRow.event.details.length > 1\"\n                            class=\"badge bg-info\"\n                            tooltip-placement=\"bottom\"\n                            tooltip-html-unsafe=\"Haga Click para ver más\"\n                            href=\"javascript:;\">{{eventRow.event.details.length}}\n                          </span>\n                        </center>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- <div class=\"row\" ng-repeat=\"row in vm.view.eventRows\">{{vm.view.eventRows}}\n                <div class=\"col-xs-12\">\n                  <div class=\"cal-row-fluid \">\n                    <div\n                      ng-repeat=\"eventRow in row.row track by eventRow.event.calendarEventId\"\n                      ng-style=\"{\n                        top: vm.showTimes ? ((eventRow.top ) + 'px') : 'auto',\n                        position: vm.showTimes ? 'absolute' : 'inherit',\n                        width: vm.showTimes ? (vm.dayColumnDimensions.width + 'px') : '',\n                        left: vm.showTimes ? (vm.dayColumnDimensions.width * eventRow.offset) + 14 + 'px' : ''}\">\n                      <div\n                        ng-style=\"{height: eventRow.event.height + 'px'}\"\n                        ng-class=\"eventRow.event.cssClass\"\n                        class=\"cursor-pointer\"\n                        ng-click=\"vm.onEventClick({calendarEvent: eventRow.event})\"\n                        data-event-class>\n                        {{eventRow.event.title}}\n                        \n                        <span\n                          ng-if=\"eventRow.event.details.length == 1\"\n                          href=\"javascript:;\"\n                          ng-class=\"eventRow.event.cssClassLetra\"\n                          ng-bind-html=\"eventRow.event.details[0].ID_PUBLIC |\n                          calendarTrustAsHtml\"\n                          tooltip-placement=\"bottom\"\n                          tooltip-html-unsafe=\"{{eventRow.event.details[0].ID_PUBLIC}}\n                          {{eventRow.event.details[0].NAME_COURSE}}\">\n                        </span><br/>\n                        <small ng-if=\"eventRow.event.details.length == 1\">\n                          <strong\n                            ng-class=\"eventRow.event.cssClassLetra\"\n                            href=\"javascript:;\"\n                            ng-bind-html=\"eventRow.event.details[0].NAME_COURSE |\n                            calendarTrustAsHtml\"\n                            tooltip-placement=\"bottom\"\n                            tooltip-html-unsafe=\"{{eventRow.event.details[0].PUBLICID}}\n                            {{eventRow.event.details[0].NAME_COURSE}}\">\n                          </strong>\n                        </small>\n                        <center>\n                          <span\n                            ng-if=\"eventRow.event.details.length > 1\"\n                            class=\"badge bg-info\"\n                            tooltip-placement=\"bottom\"\n                            tooltip-html-unsafe=\"Haga Click para ver más\"\n                            href=\"javascript:;\">{{eventRow.event.details.length}}\n                          </span>\n                        </center>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div> -->\n\n            </div>\n          </div> </script> </div> <div class=\"col-md-3 no-padding text-center m-t\"> <div class=m-l has-permission=programar-tiempos-atencion-estudiantes-edit> <md-button has-permission=programar-tiempos-atencion-estudiantes-edit class=\"btn btn-fw btn-primary text-xxs p-h-md no-margin text-xs\" ui-sref=workplan.listSchedule ng-disabled=consultCalendarVm.planningFinish> Configurar horario de atenci&oacute;n </md-button> <div class=\"alert btn-cancel alert-dismissable m-t\"> <button type=button class=close data-dismiss=alert>&times;</button> <p class=\"text-xxs font-test text-azul\">No se podr&aacute;n configurar horarios de atenci&oacute;n ni presencial ni virtual en d&iacute;a domingo</p> </div> </div> </div> </div> </div> ";

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row gris-base\"> <div class=col-md-12> <div class=row> <div class=\"col-md-12 title p-h-lg p-v m-b-xs\"> <h3>Programar tiempos de atención a estudiantes</h3> <p>Registre a continuación las horas planeadas de atención directa a estudiantes (contacto presencial o virtual) y la estimación de horas de atención virtual durante el período (respuesta a correos electrónicos, solución de inquietudes en foros, etc.). Tenga en cuenta que debe habilitar una franja mínima de tres (3) horas de atención directa a la semana</p> </div> </div> </div> </div> <div class=\"row blanco p-t\"> <div class=\"col-md-7 no-padding-r\"> <form name=createSchedule novalidate> <div class=form-group> <div class=col-md-12> <h5 class=\"text-azul no-m-t font-bold\">Configuración inicial </h5> </div> <div class=col-md-6> <label class=\"control-label text-xs\" for=regHorario>Seleccione el tipo de registro horario que desea agregar</label> </div> <div class=col-md-3> <div class=\"radio-options no-margin\"> <label class=text-xs><input type=radio name=presencial ng-model=schedulesListVm.scheduleTypeId value=1 ng-click=schedulesListVm.cambiarVistaObsAdic(1)> <i class=radio-green></i> Atención directa</label> </div> </div> <div class=col-md-3> <div class=\"radio-options no-margin\"> <label class=text-xs><input type=radio name=presencial ng-model=schedulesListVm.scheduleTypeId value=2 ng-click=schedulesListVm.cambiarVistaObsAdic(2)> <i class=radio-green></i> Atención virtual</label> </div> </div> </div> <div class=form-group ng-show=\"schedulesListVm.scheduleTypeId == 1\"> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Seleccione uno o más períodos</h5> </div> <div class=col-md-12> <label class=m-r-sm ng-repeat=\"period in schedulesListVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=schedulesListVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"schedulesListVm.funSelectedPeriod(period, schedulesListVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=control-label ng-show=\"schedulesListVm.isTouchedPeriods && schedulesListVm.validateCheklistPeriods()\"> Por favor seleccion al menos 1 períiodo. </label> </div> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Seleccione uno o más días</h5> </div> <div class=col-md-12> <label class=m-r-sm ng-repeat=\"day in schedulesListVm.days\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=schedulesListVm.selectedDays[day.dayId] ng-value=day.dayId name=day ng-change=\"schedulesListVm.funSelectedDays(day, schedulesListVm.selectedDays[day.dayId])\"> {{day.dayName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=control-label ng-show=\"schedulesListVm.isTouchedDays && schedulesListVm.validateCheklistDays()\"> Por favor seleccione al menos 1 dia. </label> </div> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Seleccione rango de tiempo</h5> </div> <div class=\"col-md-3 m-v-xs no-padding-r\" ng-class=schedulesListVm.hasError(createSchedule.startHour)> <label class=control-label for=startHour>Hora inicio</label> <input type=text min=0 onpaste=return!1 onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" class=form-control name=startHour ng-model=schedulesListVm.startHour ng-pattern=schedulesListVm.regex maxlength=8 required ng-model-options=\"{ debounce: 300 }\" ng-change=\"schedulesListVm.validateHours(createSchedule.startHour, createSchedule.endHour)\"/> <div class=control-label ng-messages=createSchedule.startHour.$error ng-show=schedulesListVm.showErrorMessages(createSchedule.startHour)> <div ng-message=required>La Hora Inicial es requerida</div> <div ng-message=pattern>Por favor ingrese un horario válido. ej: 08:00</div> </div> </div> <div class=\"col-md-3 m-v-xs no-padding-r\" ng-class=schedulesListVm.hasErrorEndHour(createSchedule.endHour)> <label class=control-label for=endHour>Hora fin</label> <input type=text min=0 onpaste=return!1 onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" class=form-control name=endHour ng-model=schedulesListVm.endHour ng-pattern=schedulesListVm.regex maxlength=8 required ng-model-options=\"{ debounce: 300 }\" ng-change=\"schedulesListVm.validateHours(createSchedule.startHour, createSchedule.endHour)\"/> <div class=control-label ng-messages=createSchedule.endHour.$error ng-show=schedulesListVm.showErrorMessages(createSchedule.endHour)> <div ng-message=required>La Hora Fin es requerida</div> <div ng-message=pattern>Por favor ingrese un horario válido. ej: 08:00</div> </div> </div> <div class=\"col-md-6 m-v-xs\" ng-class=schedulesListVm.hasError(createSchedule.description)> <label class=control-label for=description>Observaciones adicionales</label> <md-input-container class=control-label> <textarea type=text ng-trim=false class=form-control name=description maxlength=155 rows=2 md-maxlength=155 ng-model=schedulesListVm.description ng-model-options=\"{ debounce: 300 }\" ng-required=schedulesListVm.mostrarObsAdicionalesOblig></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> <div class=\"col-md-12 has-error\" ng-show=schedulesListVm.invalidMinHour> <label class=\"col-md-6 control-label\"> La hora fin debe ser mayor que la hora inicio </label> </div> </div> </form> <form name=createVirtualSchedule novalidate> <div class=form-group ng-show=\"schedulesListVm.scheduleTypeId == 2\"> <div class=row> <div class=\"col-md-12 p-l-lg\"> <h5 class=\"text-azul p-v-xs font-bold\">Seleccione cantidad de horas planeadas</h5> </div> </div> <div class=row> <div class=\"col-md-3 m-v-xs no-padding-r p-l-lg\" ng-class=schedulesListVm.hasError(createVirtualSchedule.hoursPlanning)> <label class=control-label for=hoursPlanning>Horas planeadas</label> <input type=text min=0 onpaste=return!1 class=form-control name=hoursPlanning ng-model=schedulesListVm.hoursPlanning ng-model-options=\"{ debounce: 300 }\" onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-required=schedulesListVm.hourPlanningRequired /> <div class=control-label ng-messages=createVirtualSchedule.hoursPlanning.$error ng-show=schedulesListVm.showErrorMessages(createVirtualSchedule.hoursPlanning)> <div ng-message=required>Las horas planeadas son requeridas</div> </div> </div> </div> </div> </form> <div class=\"row col-md-12 no-padding-r\"> <div class=\"col-md-6 m-v-md\"> <md-button class=\"btn btn-fw btn-cancel text-xs no-margin\" ui-sref=workplan.consultCalendar>Volver</md-button> </div> <div class=\"col-md-6 m-v-md text-right no-padding\"> <md-button class=\"btn btn-fw btn-success text-xs p-h-md no-margin md-button md-ink-ripple\" ng-disabled=\"schedulesListVm.isSaveButtonDisabled || schedulesListVm.validateForm(createSchedule,createVirtualSchedule) \" ng-click=schedulesListVm.addSchedule(createSchedule,createVirtualSchedule)>Guardar horario de atención</md-button> </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"pointer col-md-12 text-left no-padding-l\" ng-click=schedulesListVm.hiddenTable()> <h5 class=\"text-azul p-v-xs font-bold col-md-9\">Atención directa planeada</h5> <span ng-class=schedulesListVm.class class=\"icon i-28 col-md-3 text-gris-dark p-v-xs text-right no-padding-r\"></span> </div> <div class=\"col-md-12 m-v-xs\" ng-show=schedulesListVm.showTable> <div class=\"grid grid-blue\" ui-grid=schedulesListVm.gridListSchedules ui-grid-resize-columns ui-grid-exporter ui-grid-move-columns> </div> </div> <div class=\"pointer col-md-12 text-left no-padding-l\"> <h5 class=\"text-azul p-v-xs font-bold col-md-9\">Atención virtual planeada</h5> <label class=\"control-label text-l p-l-md\">Horas de atención virtual: {{schedulesListVm.virtualAttentionHours}}</label> </div> </div> </div>";

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v\"> <h3>Planear asignatura - {{subjectVm.rightTable.asignatureName}}</h3> <p>Diligencie el siguiente formulario para planear su asignatura. Cuando termine, haga clic en el botón Guardar planeación. </p> </div> </div> <div class=\"row blanco\"> <div class=col-md-7> <div class=col-md-12> <div class=col-md-12> <h4 ng-model=subjectVm.directTeaching class=\"text-azul p-v-xs font-bold\">Docencia directa </h4> <p class=text-gris-dark>Si la cantidad de horas que imparte es diferente a la carga horaria, por favor edite este campo</p> </div> <form name=planSchedule novalidate> <div class=\"col-md-5 m-b-md\" ng-class=subjectVm.hasError(planSchedule.hoursTeaching)> <label class=control-label for=hoursTeaching> Horas de docencia directa </label> <a href=# tooltip-placement=bottom data-toggle=tooltip data-trigger=hover tooltip=\" El número de horas de docencia directa se multiplicará por el número de grupos asignados.\"> <i class=\"mdi-action-info-outline text-left text-azul i-16\"> </i> </a> <input type=number class=form-control name=hoursTeaching ng-model=subjectVm.hoursTeaching maxlength=8 ng-change=subjectVm.updateloadTime(planSchedule.observation) min=0 onpaste=return!1 onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" required/> <div class=\"control-label text-xs\" ng-messages=planSchedule.hoursTeaching.$error ng-show=subjectVm.showErrorMessages(planSchedule.hoursTeaching)> <div ng-message=required>La Hora de docencia directa es requerida</div> </div> </div> <div class=\"col-md-7 m-b-md\" ng-class=subjectVm.hasError(planSchedule.observation)> <label class=control-label for=observation> Observaciones </label> <input type=text class=form-control name=observation ng-model-options=\"{ debounce: 300 }\" ng-model=subjectVm.observation maxlength=500 ng-required=subjectVm.observationRequired() /> <div class=\"control-label text-xs\" ng-messages=planSchedule.observation.$error ng-show=subjectVm.showErrorMessages(planSchedule.observation)> <div ng-message=required>La observaci&oacute;n es requerida</div> </div> </div> <div class=\"col-md-12 p-t b-t-gris-light\"> <h4 ng-model=subjectVm.otherActivities class=\"text-azul p-v-xs font-bold\">Otras actividades de docencia relacionadas con la asignatura <i class=\"i-24 text-azul mdi-action-info-outline\"><md-tooltip md-direction=bottom>Ingrese la estimaci&oacute;n de horas globales que dedicar&aacute; a las actividades adicionales a la docencia directa en esta asignatura.</md-tooltip></i> </h4> </div> <div class=col-md-12> <div class=\"col-md-6 no-padding\"> <label class=control-label for=regHorario> ¿Primera vez que dicta esta asignatura? <i class=\"mdi-action-info-outline text-left text-azul i-16\"><md-tooltip md-direction=bottom>Si usted ha dictado esta asignatura en períodos anteriores, el sistema le dar&aacute; la opci&oacute;n de cargar los datos de su planeaci&oacute;n anterior.</md-tooltip></i> </label> </div> <div class=col-md-2> <div class=\"radio-options no-margin\"> <input type=radio name=radio ng-model=subjectVm.isFirstTime value=1 required> <i class=radio-green></i> <label>Si</label> </div> </div> <div class=col-md-2> <div class=\"radio-options no-margin\"> <input type=radio name=radio ng-model=subjectVm.isFirstTime value=0 ng-click=subjectVm.showModalFirstTime() required> <i class=radio-green></i> <label>No</label> </div> </div> </div> </form> <div class=col-md-12> <h5 ng-model=subjectVm.planning class=\"text-azul-light p-v-xs font-semibold p-t\">Planeaci&oacute;n y gesti&oacute;n</h5> </div> <div class=row> <form name=formActivities novalidate class=col-md-12> <div class=\"col-md-3 m-v-xs form-group no-padding-r\" ng-class=subjectVm.hasError(formActivities.activityCombo)> <label for=activityCombo class=control-label>Actividad</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\"><md-tooltip md-direction=bottom>Las actividades marcadas con asterisco son obligatorias.</md-tooltip></i> <select name=activityCombo ng-model=subjectVm.activityCombo ng-options=\"listActivities.listItemName + (listActivities.isRequired == 1? ' *': '') for listActivities in subjectVm.activityList | filter:subjectVm.filterActivity\" class=form-control required> <option value=\"\" disabled=disabled selected=selected>Seleccione</option> </select> <div class=\"control-label text-xs\" ng-messages=formActivities.activityCombo.$error ng-show=subjectVm.showErrorMessages(formActivities.activityCombo)> <div ng-message=required>La actividad es requerida</div> </div> </div> <div class=\"col-md-3 m-v-xs no-padding-r\" ng-class=subjectVm.hasError(formActivities.hoursPlanned)> <label class=control-label for=hoursPlanned>Horas planeadas</label> <input type=number class=form-control name=hoursPlanned min=0 onpaste=return!1 onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-model=subjectVm.hoursPlanned maxlength=8 required/> <div class=\"control-label text-xs\" ng-messages=formActivities.hoursPlanned.$error ng-show=subjectVm.showErrorMessages(formActivities.hoursPlanned)> <div ng-message=required>Las horas planeadas son requeridas</div> </div> </div> <div class=\"col-md-6 m-v-xs no-padding-r flex form-group\" ng-class=subjectVm.hasError(formActivities.detail)> <div class=\"col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\" for=detail>Descripci&oacute;n</label> <div class=\"col-md-10 no-padding\"> <input type=text class=form-control maxlength=500 name=detail ng-model=subjectVm.detail ng-model-options=\"{ debounce: 300 }\"/> </div> <div class=\"col-md-2 no-padding align-self-end text-right\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=\"subjectVm.addActivities(); subjectVm.cleanForm(formActivities);\" ng-disabled=subjectVm.validateFormActivities(formActivities)></i> </div> </div> </div> </form> </div> <div class=\"col-md-12 m-v-xs no-padding\" ng-show=subjectVm.showTableActivities> <div class=row> <div class=\"col-md-12 m-t p-l\"> <div class=\"col-md-3 no-padding-r\"> <label class=\"control-label col-md-12 no-padding\" for=detail> Actividad</label> </div> <div class=\"col-md-3 no-padding-r\"> <label class=\"control-label col-md-12 no-padding\" for=detail> Horas planeadas</label> </div> <div class=\"col-md-4 no-padding-r\"> <label class=\"control-label col-md-12 no-padding\" for=detail> Descripci&oacute;n</label> </div> </div> </div> <div class=\"row m-l m-r-xs\"> <div class=\"col-md-12 b-b-gris-light no-padding-l m-v-xs\" ng-repeat=\"planningAndManagement in subjectVm.activitiesPlanningArray\"> <div class=\"col-md-3 no-padding\"> <label class=\"control-label col-md-12 no-padding text-gris-dark\" for=detail> {{planningAndManagement.itemActivityName + (subjectVm.searchIfRequired(planningAndManagement.itemActivityId, subjectVm.activityList)? ' *' : '')}} </label> </div> <div class=col-md-3> <label class=\"control-label col-md-12 no-padding text-gris-dark\" for=detail> {{planningAndManagement.hoursPlanned}} </label> </div> <div class=col-md-4 for=detail> <p class=\"control-label col-md-12 no-padding text-gris-dark\" style=word-wrap:break-word;width:160px for=detail> {{planningAndManagement.detail}} </p> </div> <div class=\"col-md-2 no-padding text-right\"> <a class=m-r-sm ng-click=subjectVm.editActivitiesPlanning(planningAndManagement)> <i class=\"icon mdi-content-create i-20 text-gris-dark\"></i> </a> <a ng-click=subjectVm.deleteActivitiesPlanning(planningAndManagement)> <i class=\"icon mdi-action-delete i-20 text-gris-dark\"></i> </a> </div> </div> </div> </div> <form name=formFomation novalidate> <div class=col-md-12> <h5 ng-model=subjectVm.training class=\"text-azul-light p-v-xs font-semibold p-t\"> Formaci&oacute;n de j&oacute;venes docentes</h5> </div> <div class=\"form-group col-md-3 m-v-xs no-padding-r\" ng-class=subjectVm.hasError(formFomation.kindOfYoung)> <label for=kindOfYoung class=control-label>Tipo de j&oacute;venes</label> <select name=kindOfYoung ng-model=subjectVm.kindOfYoung ng-options=\"listYoung.listItemName + (listYoung.isRequired == 1? ' *': '') for listYoung in subjectVm.youngList\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-xs\" ng-messages=formFomation.kindOfYoung.$error ng-show=subjectVm.showErrorMessages(formFomation.kindOfYoung)> <div ng-message=required>El tipo de joven es requerido</div> </div> </div> <div class=\"col-md-3 m-v-xs no-padding-r\" ng-class=subjectVm.hasError(formFomation.hoursDedicated)> <label class=control-label for=hoursDedicated>Horas dedicadas</label> <input type=number class=form-control name=hoursDedicated min=1 onpaste=return!1 onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-model=subjectVm.hoursDedicated maxlength=8 required/> <div class=\"control-label text-xs\" ng-messages=formFomation.hoursDedicated.$error ng-show=subjectVm.showErrorMessages(formFomation.hoursDedicated)> <div ng-message=required>Las horas dedicadas son requeridas</div> </div> </div> <div class=\"col-md-6 m-v-xs flex no-padding-r\" ng-class=subjectVm.hasError(formFomation.numberOfStudents)> <div class=\"col-md-12 no-padding\"> <label class=\"control-label col-md-12 no-padding\" for=numberOfStudents>Cantidad</label> <div class=\"col-md-10 no-padding\"> <input type=number class=form-control name=numberOfStudents ng-model=subjectVm.numberOfStudents min=1 onpaste=return!1 onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" required/> </div> <div class=\"col-md-2 no-padding align-self-end text-right\"> <i class=\"icon mdi-content-add i-20 btn btn-success\" ng-click=\"subjectVm.addFormation(); subjectVm.cleanForm(formFomation);\" ng-disabled=subjectVm.validateFormFormation(formFomation)></i> </div> <div class=\"control-label text-xs\" ng-messages=formFomation.numberOfStudents.$error ng-show=subjectVm.showErrorMessages(formFomation.numberOfStudents)> <div ng-message=required>La cantidad de estudiantes es requerida</div> </div> </div> </div> <div class=\"col-md-12 m-v-sm no-padding-r\" ng-class=subjectVm.hasError(formFomation.activityOfFa)> <label class=control-label for=activityOfFa> Actividades de formaci&oacute;n y acompañamiento</label> <md-input-container class=control-label> <textarea type=text class=form-control name=activityOfFa maxlength=500 rows=2 ng-model-options=\"{ debounce: 300 }\" ng-model=subjectVm.activityOfFa required md-maxlength=500></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-9 no-padding\"> <div class=\"no-padding control-label text-xs\" ng-messages=formFomation.activityOfFa.$error ng-show=subjectVm.showErrorMessages(formFomation.activityOfFa)> <div ng-class=subjectVm.hasError(formFomation.activityOfFa) ng-message=required>El campo actividades de formación y acompañamiento es requerido</div> </div> </div> <div class=\"col-md-3 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </form></div>  <div class=\"col-md-12 m-v-xs no-padding\" ng-show=subjectVm.showTableFormation> <div class=row> <div class=\"col-md-12 m-t p-l\"> <div class=\"col-md-3 no-padding-r\"> <label class=\"control-label col-md-12 no-padding\" for=detail> Tipo de j&oacute;venes</label> </div> <div class=\"col-md-2 no-padding-r\"> <label class=\"control-label col-md-12 no-padding\" for=detail> Horas dedicadas</label> </div> <div class=\"col-md-2 no-padding-r\"> <label class=\"control-label col-md-12 no-padding\" for=detail> Cantidad de estudiantes</label> </div> <div class=\"col-md-3 no-padding-r\"> <label class=\"control-label col-md-12 no-padding\" for=detail> Actividades</label> </div> </div> </div> <div class=\"row m-l m-r-xs\"> <div class=\"col-md-12 b-b-gris-light no-padding-l m-v-xs\" ng-repeat=\"formationList in subjectVm.activitiesTeachersArray\"> <div class=\"col-md-3 no-padding\"> <label class=\"control-label col-md-12 no-padding text-gris-dark\" for=detail> {{formationList.itemActivityName + (subjectVm.searchIfRequired(formationList.itemActivityId, subjectVm.youngList)? ' *' : '')}} </label> </div> <div class=col-md-2> <label class=\"control-label col-md-12 no-padding text-gris-dark\" for=detail> {{formationList.hoursPlanned}} </label> </div> <div class=col-md-2> <label class=\"control-label col-md-12 no-padding text-gris-dark\" for=detail> {{formationList.itemActivityValue}} </label> </div> <div class=col-md-3> <p class=\"control-label col-md-12 no-padding text-gris-dark\" style=word-wrap:break-word;width:160px for=detail>{{formationList.detail}}</p> </div> <div class=\"col-md-2 no-padding text-right\"> <a class=m-r-sm ng-click=subjectVm.editActivitiesTeacher(formationList)> <i class=\"icon mdi-content-create i-20 text-gris-dark\"></i> </a> <a ng-click=subjectVm.deleteActivitiesTeacher(formationList)> <i class=\"icon mdi-action-delete i-20 text-gris-dark\"></i> </a> </div> </div> </div> </div> <div class=form-group> <div class=\"col-md-12 m-v-md no-padding-r\"> <div class=\"col-md-7 no-padding\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.teachingSubjects>Cancelar</md-button> </div> <div class=\"col-md-5 no-padding text-right\"> <md-button class=\"btn btn-fw btn-success no-margin\" ng-disabled=\"subjectVm.validateForm(planSchedule) || subjectVm.buttonDisabled\" ng-click=subjectVm.saveActivity()> Guardar planeaci&oacute;n </md-button> </div> </div> </div> </div> <div class=col-md-5> <div class=pointer ng-click=subjectVm.hiddenTable()> <h5 class=\"text-azul p-v-xs font-bold col-md-10\">Informaci&oacute;n de asignatura <a href=# class=col-md-2> <span ng-class=subjectVm.class class=\"icon i-28 col-md-3 text-gris-dark p-v-xs\"></span> </a> </h5></div> <div class=\"col-md-12 m-v-xs\" ng-if=subjectVm.showTable> <div class=row> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-5 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Nivel de formaci&oacute;n</label> </div> <div class=col-md-7> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.levelTraining}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-5 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Período</label> </div> <div class=col-md-7> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.periodicityName}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-4 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Programa o &aacute;rea</label> </div> <div class=col-md-8> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.program}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-4 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Unidad</label> </div> <div class=col-md-8> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.academicUnit}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-4 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Tipo</label> </div> <div class=col-md-8> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.type}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-4 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Modalidad</label> </div> <div class=col-md-8> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.modality}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-4 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> N° total estudiantes</label> </div> <div class=col-md-8> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.numberStudents}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-6 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Relación entre horas docencia directa y horas de preparación de clase</label> </div> <div class=col-md-6> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{(subjectVm.hoursRelation==0 || subjectVm.hoursTeaching==0 )? (1/(1 * subjectVm.rightTable.groupsTempNum)).toFixed(2):(subjectVm.hoursRelation / (subjectVm.hoursTeaching * subjectVm.rightTable.groupsTempNum)).toFixed(2)}}</label> </div> </div> <div class=\"col-md-12 m-t no-padding-r\"> <div class=\"col-md-4 no-padding\"> <label class=\"control-label col-md-12 no-padding\"> Idioma</label> </div> <div class=col-md-8> <label class=\"control-label col-md-12 no-padding text-right text-gris-darker\"> {{subjectVm.rightTable.language}}</label> </div> </div> <div class=\"col-md-12 azul m-t p flex\"> <div class=\"col-md-4 text-center\"> <label class=\"control-label font-thin text-md\"> {{subjectVm.rightTable.loadTime}}</label> <p class=\"text-center text-sm font-medium\">Carga horaria</p> </div> <div class=\"col-md-3 text-center\"> <label class=\"control-label font-thin text-md\"> {{subjectVm.Math.ceil(subjectVm.hoursTeaching * subjectVm.rightTable.groupsTempNum)}}</label> <p class=\"text-center text-sm font-medium\">Total horas D.D</p> </div> <div class=\"col-md-5 text-center\"> <label class=\"control-label font-thin text-md\"> {{subjectVm.rightTable.groupsTempNum}}</label> <p class=\"text-center text-sm font-medium\">Cantidad de grupos</p> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.delegationCharges', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/charges',
	    views: {
	      '': {
	        template: __webpack_require__(588)
	      },
	      'principal@': {
	        template: __webpack_require__(589),
	        controller: 'ChargesListCtrl',
	        controllerAs: 'chargesListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Cargos por delegación',
	      order: 1,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.roles',
	        order: 2
	      }, {
	        name: 'workplan.committeeParticipation',
	        order: 3
	      }, {
	        name: 'workplan.otherActivities',
	        order: 4
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.academicManagement,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.academicManagement', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/charges',
	    views: {
	      '': {
	        template: __webpack_require__(588)
	      },
	      'principal@': {
	        template: __webpack_require__(589),
	        controller: 'ChargesListCtrl',
	        controllerAs: 'chargesListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Gestión Académica',
	      order: 1,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.roles',
	        order: 2
	      }, {
	        name: 'workplan.committeeParticipation',
	        order: 3
	      }, {
	        name: 'workplan.otherActivities',
	        order: 4
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.academicManagement,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.roles', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/roles',
	    views: {
	      '': {
	        template: __webpack_require__(590)
	      },
	      'principal@': {
	        template: __webpack_require__(591),
	        controller: 'RolesListCtrl',
	        controllerAs: 'rolesListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Roles',
	      order: 2,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.delegationCharges',
	        order: 1
	      }, {
	        name: 'workplan.committeeParticipation',
	        order: 3
	      }, {
	        name: 'workplan.otherActivities',
	        order: 4
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.academicManagement,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.committeeParticipation', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/committeeParticipation',
	    views: {
	      '': {
	        template: __webpack_require__(592)
	      },
	      'principal@': {
	        template: __webpack_require__(593),
	        controller: 'ParticipationListCtrl',
	        controllerAs: 'participationListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Participación en comités',
	      order: 3,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.delegationCharges',
	        order: 1
	      }, {
	        name: 'workplan.roles',
	        order: 2
	      }, {
	        name: 'workplan.otherActivities',
	        order: 4
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.academicManagement,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createParticipation', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/createParticipation/:workplanTeacherActivityId',
	    template: __webpack_require__(594),
	    controller: 'CreateParticipationCtrl',
	    controllerAs: 'participationVm',
	    data: {
	      displayName: 'Participación en comités',
	      order: 3,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.delegationCharges',
	        order: 1
	      }, {
	        name: 'workplan.roles',
	        order: 2
	      }, {
	        name: 'workplan.otherActivities',
	        order: 4
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createRole', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/createRole/workplan/:workplanTeacherActivityId/activity/:activityTypeId',
	    template: __webpack_require__(595),
	    controller: 'CreateRoleCtrl',
	    controllerAs: 'createRoleVm',
	    data: {
	      displayName: 'Roles',
	      order: 2,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.delegationCharges',
	        order: 1
	      }, {
	        name: 'workplan.committeeParticipation',
	        order: 3
	      }, {
	        name: 'workplan.otherActivities',
	        order: 4
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.otherActivities', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/otherActivitiesList',
	    views: {
	      '': {
	        template: __webpack_require__(596)
	      },
	      'principal@': {
	        template: __webpack_require__(597),
	        controller: 'OtherActivitiesListCtrl',
	        controllerAs: 'activitiesVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Otras actividades',
	      order: 4,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.delegationCharges',
	        order: 1
	      }, {
	        name: 'workplan.roles',
	        order: 2
	      }, {
	        name: 'workplan.committeeParticipation',
	        order: 3
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.academicManagement,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createOtherActivity', {
	    moduleId: _globalConfig2.default.modules.academicManagement,
	    abstract: false,
	    url: '/academicManagement/createOtherActivity/:activityId',
	    template: __webpack_require__(598),
	    controller: 'CreateOtherActivityCtrl',
	    controllerAs: 'createActivityVm',
	    data: {
	      displayName: 'Otras actividades',
	      order: 4,
	      title: 'Gestión Académica',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.delegationCharges',
	        order: 1
	      }, {
	        name: 'workplan.roles',
	        order: 2
	      }, {
	        name: 'workplan.committeeParticipation',
	        order: 3
	      }, {
	        name: 'workplan.history',
	        order: 5
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  });
	}

/***/ }),
/* 588 */
577,
/* 589 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-9 p-h-lg p-v no-padding-r m-b-xs\"> <h3>Cargos por delegaci&oacute;n</h3> <p class=text-16-important>Registre la dedicaci&oacute;n asociada a cada uno de los cargos que se le han asignado a nivel institucional. Si no visualiza alguno de sus cargos por delegaci&oacute;n, notifique esta situaci&oacute;n a la direcci&oacute;n administrativa de su unidad acad&eacute;mica </p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"chargesListVm.isFeedback && !chargesListVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=chargesListVm.bitacora($event)> Bitácora de Cargos por Delegación </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-l-lg no-padding-r\"> <div class=\"input-group stylish-input-group\"> <input type=text name=search ng-model=chargesListVm.search class=form-control placeholder=\"Buscar cargos\" ng-change=chargesListVm.updateView() ng-model-options=\"{debounce: 500}\"> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-t-md p-h-lg\"> <div class=col-md-12> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-center title\" ng-if=\"chargesListVm.charges.length == 0 ||\n        (chargesListVm.charges | filter: chargesListVm.search).length == 0\"> <p class=text-md>{{chargesListVm.filterSearchResult}}</p> </div> <slick class=slick-oblique current-index=index infinite=false slides-to-show=3 responsive=breakpoints adaptive-height=true respond-to=min ng-if=\"chargesListVm.charges.length && chargesListVm.viewLoaded && (chargesListVm.charges | filter: chargesListVm.search).length != 0\"> <div class=p-h-sm ng-repeat=\"charge in chargesListVm.charges | filter: chargesListVm.search | orderBy: 'chargeName'\"> <div class=\"card-heigth card brd-md\"> <div class=\"card-heading p-v-lg text-blanco\" ng-class=chargesListVm.backgroundGrad(charge.idCharge)> <h3 class=\"exo font-bold text-md text-center\">{{charge.chargeName}}</h3> <span class=\"proxima font-thin text-center text-xs\">{{charge.academitUnitName}}</span> <div class=\"hours p-xs font-thin\" ng-class=chargesListVm.changeColorBall(charge)> <span class=\"number text-md\">{{charge.hoursPlanned}}</span> <p class=text-xxs>Horas de<br>dedicaci&oacute;n</p> </div> </div> <div class=card-body> <div class=\"text-center m-v period proxima text-md font-thin\" style=height:60px> <span class=periodicity-name>{{charge.chargeDateStart | date : 'dd/MM/yyyy' : 'UTC'}}<br></span> <p class=\"text-gris-darker text-base exo font-bold p-v-xs\">Fecha de Inicio</p> </div> <div class=\"text-center m-t-lg p-t-md\" has-permission=cargos-por-delegacion-edit> <md-button ng-click=chargesListVm.editObs(charge) class=\"btn btn-fw btn-success p-h-md no-margin\" ng-disabled=chargesListVm.planningFinish>{{chargesListVm.getcreatedOrEdit(charge)}} Planeación </md-button> </div> </div> </div> </div> </slick> </div> </div> </div>";

/***/ }),
/* 590 */
577,
/* 591 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>Roles <span class=text-md>(Funciones académico administrativas)</span> </h3> <p class=text-16-important>Registre o edite la informaci&oacute;n correspondiente a los roles que desempeñar&aacute; durante el año.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"rolesListVm.feedback && !rolesListVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=rolesListVm.bitacora($event)> Bitácora de Roles </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=rolesListSearch class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar rol...\" ng-change=rolesListVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-center title\" ng-if=\"rolesListVm.roles.length == 0 || (rolesListVm.roles | filter: rolesListSearch).length == 0\"> <p class=text-md>{{rolesListVm.filterSearchResult}}</p> </div> <slick class=\"slider single-item\" current-index=index ng-if=\"rolesListVm.roles.length && rolesListVm.viewLoaded && (rolesListVm.roles | filter: rolesListSearch).length != 0\" responsive=rolesListVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemRole in rolesListVm.roles | filter: rolesListSearch\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5\" ng-class=rolesListVm.gradRoleClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemRole.roleName}}</p> </div> <div class=\"row m-t-md\" has-permission=roles-edit ng-class=classPlanning> <div class=col-md-6> <a href ui-sref=\"workplan.createRole({workplanTeacherActivityId: itemRole.workplanTeacherActivityId, activityTypeId: itemRole.activityTypeId})\" class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6 ng-if=false> <a href ng-click=rolesListVm.confirmDeleteRole(itemRole) class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-8\"> <p class=\"text-md text-gris-dark exo no-margin\">Unidad</p> <p class=\"text-xs p-b no-margin fix-max-height detail\">{{itemRole.academicUnitName}}</p> <p class=\"text-md text-gris-dark exo no-margin\">{{itemRole.timeRangeTypeName}}</p> <p class=\"text-xs p-b no-margin fix-max-height detail\" ng-if=\"itemRole.timeRangeTypeId == 1\">{{itemRole.periodicityName}}</p> <p class=\"text-xs p-b no-margin fix-max-height detail\" ng-if=\"itemRole.timeRangeTypeId == 2\">{{itemRole.startDate | date: 'dd/MM/yyyy'}} - {{itemRole.endDate | date: 'dd/MM/yyyy'}}</p> <p class=\"text-md text-gris-dark exo no-margin\">Porcentaje de dedicación</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\">{{itemRole.percentage}}%</p> </div> </div> </div> </slick> <div class=\"col-md-12 p-v text-center\" has-permission=roles-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createRole ng-if=false>Agregar Rol</button> </div> </div> </div> </div> ";

/***/ }),
/* 592 */
577,
/* 593 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>{{ participationListVm.mainLabel }}</h3> <p class=text-16-important>Agregue y modifique su participación en comités durante su plan de trabajo.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"participationListVm.feedback && !participationListVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=participationListVm.bitacora($event)> Bitácora de Participación en comités </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=participationListVm.participationFilter class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar participación...\" ng-change=participationListVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-center title\" ng-if=\"participationListVm.participationList.length == 0 || (participationListVm.participationList | filter: participationListVm.participationFilter).length == 0\"> <p class=text-md>{{participationListVm.filterSearchResult}}</p> </div> <slick class=\"slider single-item\" current-index=index ng-if=\"participationListVm.participationList.length && participationListVm.viewLoaded && \n      (participationListVm.participationList | filter: participationListVm.participationFilter).length != 0\" responsive=participationListVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemParticipation in participationListVm.participationList | filter: participationListVm.participationFilter | orderBy: 'participation_name'\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-6\" ng-class=participationListVm.gradRoleClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemParticipation.comiteeName}}</p> </div> <div class=\"row m-t-md\" ng-class=classPlanning has-permission=participacion-en-comites-edit> <div class=col-md-6> <a ui-sref=\"workplan.createParticipation({workplanTeacherActivityId: itemParticipation.workplanTeacherActivityId})\" class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href ng-click=participationListVm.confirmDeleteParticipation(itemParticipation) class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-9\"> <p class=\"text-md text-gris-dark exo\">Descripción</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\">{{itemParticipation.description | limitTo: 100 }}{{itemParticipation.description.length > 100 ? '...' : ''}}</p> <p class=\"text-md text-gris-dark exo p-t\" ng-if=\"itemParticipation.timeRangeTypeId == 1\"> Período </p> <p class=\"text-xs no-padding no-margin fix-max-height detail\" ng-if=\"itemParticipation.timeRangeTypeId == 1\"> {{itemParticipation.periodicityName}} </p> <p class=\"text-md text-gris-dark exo p-t\" ng-if=\"itemParticipation.timeRangeTypeId == 2\"> Fechas </p> <p class=\"text-xs no-padding no-margin fix-max-height detail\" ng-if=\"itemParticipation.timeRangeTypeId == 2\"> {{itemParticipation.startDate}} - {{itemParticipation.endDate}} </p> <p class=\"text-md text-gris-dark exo p-t\"> Horas Planeadas </p> <p class=\"text-xs no-padding no-margin fix-max-height detail\"> {{itemParticipation.hoursPlanned}} </p> </div> </div> </div> </slick> <div class=\"col-md-12 p-v text-center\" has-permission=participacion-en-comites-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createParticipation ng-disabled=participationListVm.planningFinish>Agregar Participación</button> </div> </div> </div> </div> ";

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>{{participationVm.createdOrEditParticipation}} participación en comités</h3> <p class=text-xs>Seleccione el comité en el que estará vinculado y registre las horas de dedicación estimadas y una breve descripción del alcance de su participación. Al finalizar, haga clic en el botón \"Guardar participación\". Todos los campos son obligatorios.</p> </div> </div> <form name=committee novalidate> <div class=\"row blanco\" style=\"height:calc(100% - 110px)\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del comité</h5> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=participationVm.hasError(committee.committeeName)> <label for=committeeName class=control-label>Nombre de comité</label> <select name=committeeName ng-model=participationVm.committeeName ng-options=\"listCommittee.idListItem as listCommittee.listItemName \n                  for listCommittee in participationVm.listCommitteeCombo\" class=form-control ng-disabled=participationVm.isEditing required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=committee.committeeName.$error ng-show=participationVm.showErrorMessages(committee.committeeName)> <div ng-message=required>El nombre es requerido</div> </div> </div> </div> <div class=col-md-6> <div class=form-group ng-class=participationVm.hasError(committee.hoursPlanned)> <label for=hoursPlanned class=control-label>Horas planeadas</label> <input type=number min=0 name=hoursPlanned ng-model=participationVm.hoursPlanned class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=committee.hoursPlanned.$error ng-show=participationVm.showErrorMessages(committee.hoursPlanned)> <div ng-message=required>Las horas planeadas son requeridas</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=participationVm.hasError(committee.detail)> <label for=detail class=control-label>Descripci&oacute;n</label> <md-input-container class=control-label> <textarea name=detail ng-model=participationVm.detail class=form-control rows=2 ng-model-options=\"{ debounce: 300 }\" required>\n                </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-xs\" ng-messages=committee.detail.$error ng-show=participationVm.showErrorMessages(committee.detail)> <div ng-message=required>La descripci&oacute;n es requerida</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-7 no-padding\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.committeeParticipation>Cancelar</md-button> </div> <div class=\"col-md-5 no-padding text-right\"> <md-button class=\"btn btn-fw btn-primary text-xs no-margin\" ng-click=participationVm.addParticipation(false) ng-disabled=\"participationVm.validateForm(committee) || participationVm.disableSaveButtom\"> Guardar participación </md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=participationVm.updateRangeData(value) type-period=participationVm.listPeriods form-reference=committee toggle-range=participationVm.updateRangeType(type) range-type=participationVm.rangeType start-date=participationVm.dt_start end-date=participationVm.dt_end periods-array=participationVm.periodsArray> </period-picker> </div> </div>  </form> ";

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>{{createRoleVm.createOrEdit}} rol</h3> <p class=text-xs>Ingrese en el siguiente formulario la información del rol que asumirá y el porcentaje de dedicación correspondiente. Todos los campos son obligatorios.</p> </div> </div> <form name=createRole novalidate> <div class=\"row blanco\" style=\"height:calc(100% - 110px)\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del rol</h5> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createRoleVm.hasError(createRole.arrayUnit)> <label for=arrayUnit class=control-label>Unidad</label> <select ng-change=createRoleVm.rolesUnits() ng-disabled=createRoleVm.isEditing name=arrayUnit ng-model=createRoleVm.academicUnit ng-options=\"unit.academitUnitId as unit.academitUnitName for unit in createRoleVm.arrayUnit\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createRole.arrayUnit.$error ng-show=createRoleVm.showErrorMessages(createRole.arrayUnit)> <div ng-message=required>La unidad es requerida</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createRoleVm.hasError(createRole.rolesCombo)> <label for=rolesCombo class=control-label>Rol</label> <select name=rolesCombo ng-change=createRoleVm.changedCheckBox() ng-disabled=createRoleVm.isEditing ng-model=createRoleVm.rolesSelected ng-options=\"role.roleId as role.roleName for role in createRoleVm.rolesCombo\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createRole.rolesCombo.$error ng-show=createRoleVm.showErrorMessages(createRole.rolesCombo)> <div ng-message=required>El rol es requerido</div> </div> </div> </div> <div class=col-md-8> <div class=form-group ng-class=createRoleVm.hasError(createRole.detail)> <label for=detail class=control-label>Descripci&oacute;n</label> <md-input-container class=control-label> <textarea name=detail ng-model=createRoleVm.detail maxlength=500 md-maxlength=500 class=form-control rows=2 ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-xs\" ng-messages=createRole.detail.$error ng-show=createRoleVm.showErrorMessages(createRole.detail)> <div ng-message=required>La descripci&oacute;n es requerida</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-4 m-v-xs no-padding-r\" ng-class=createRoleVm.hasError(createRole.percentage)> <label class=control-label for=percentage>Porcentaje de dedicación</label> <input type=number class=form-control name=percentage onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1 ng-model=createRoleVm.percentage maxlength=3 min=0 max=100 required/> <div class=\"control-label text-xs\" ng-messages=createRole.percentage.$error ng-show=createRoleVm.showErrorMessages(createRole.percentage)> <div ng-message=required>El porcentaje es requerido</div> <div ng-message=max>El porcentaje no puede ser mayor a 100</div> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-7 no-padding\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.roles>Cancelar</md-button> </div> <div class=\"col-md-5 no-padding text-right\"> <md-button class=\"btn btn-fw btn-primary text-xs p-h-md\" ng-click=createRoleVm.addRole(false) ng-disabled=\"createRoleVm.isSaveButtonDisabled || createRoleVm.validateForm(createRole)\"> Guardar rol</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createRoleVm.updateRangeData(value) type-period=createRoleVm.typePeriod form-reference=createRole toggle-range=createRoleVm.updateRangeType(type) range-type=createRoleVm.rangeType start-date=createRoleVm.dt_start end-date=createRoleVm.dt_end periods-array=createRoleVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 596 */
577,
/* 597 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>Otras actividades de gestión académica<span class=text-xs> </span></h3> <p class=text-16-important>Agregue o edite las actividades adicionales que planea realizar durante su plan de trabajo</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"activitiesVm.feedback && !activitiesVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=activitiesVm.bitacora($event)> Bitácora de Otras Actividades </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-l-lg np-padding-r\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=activitiesVm.teachingActivitiesSearch ng-model-options=\"{ debounce: 300 }\" class=form-control placeholder=\"Buscar actividades\" ng-change=activitiesVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-t-md\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-center title\" ng-if=\"activitiesVm.activities.length == 0 || (activitiesVm.activities | filter: activitiesVm.teachingActivitiesSearch).length == 0\"> <p class=text-md>{{activitiesVm.filterSearchResult}}</p> </div> <div class=\"col-md-12 p-l-lg rounded-list\"> <div class=\"col-md-12 blanco m-t no-padding\" ng-repeat=\"activitiesList in activitiesVm.activities | filter : activitiesVm.teachingActivitiesSearch\"> <div class=\"col-md-3 p-v-sm\"> <h5 class=\"text-azul font-bold no-padding no-margin l-h list-title\"> {{activitiesList.listItemName}}</h5> <p class=\"text-xs no-padding no-margin text-gris-dark\" ng-if=\"activitiesList.timeRangeTypeId == 1\"><i>{{activitiesList.periodicityName}}</i> </p> <p class=\"text-xs no-padding no-margin text-gris-dark\" ng-if=\"activitiesList.timeRangeTypeId == 2\"><i>{{activitiesList.startDate}} - {{activitiesList.endDate}}</i> </p> </div> <div class=\"col-md-5 p-v-sm\"> <h6 class=\"text-xs no-padding no-margin text-gris-dark\">Descripción</h6> <p class=\"text-xxs no-padding no-margin fix-max-height detail word-wrap\">{{activitiesList.description | limitTo: 100 }}{{activitiesList.description.length > 100 ? '...' : ''}}</p> </div> <div class=\"grad-1 col-md-4 text-blanco no-margin no-padding-h p-v border-radio-left flex align-items-center\" ng-class=classPlanning> <div class=\"col-md-6 text-center\"> <h3 class=\"no-margin proxima font-thin\">{{activitiesList.hoursPlanned}} <span class=text-sm>HRS.</span></h3> </div> <div class=\"col-md-3 text-center\" has-permission=otras-actividades-gestion-academica-edit> <a class=\"text-xxs m-r-md flex align-items-center flex-direction-column\" ui-sref=\"workplan.createOtherActivity({activityId: activitiesList.workplanTeacherActivityId})\"> <i class=\"icon mdi-content-create i-20 m-r-xs m-b-sm\"></i> Editar </a> </div> <div class=\"col-md-3 text-center\" has-permission=otras-actividades-gestion-academica-edit> <a class=\"text-xxs m-r-md md-green flex align-items-center flex-direction-column\" ng-click=activitiesVm.confirmDisableActivity(activitiesList)> <i class=\"icon mdi-action-delete i-20 m-r-xs m-b-sm\"></i> Eliminar </a> </div> </div> </div> </div> <div class=\"col-md-12 p-v text-center\" has-permission=otras-actividades-gestion-academica-edit> <md-button class=\"btn btn-fw btn-primary no-margin\" ui-sref=workplan.createOtherActivity ng-disabled=activitiesVm.planningFinish>Agregar actividad</md-button> </div> </div> </div> ";

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>{{createActivityVm.createOrEdit}} actividad</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar Actividad\". Todos los campos son obligatorios. </p> </div> </div> <form name=createActivityForm novalidate> <div class=\"row blanco\" style=\"height:calc(100% - 110px)\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos de la actividad</h5> </div> <div class=\"col-md-9 no-padding-r\"> <div class=form-group ng-class=createActivityVm.hasError(createActivityForm.typeActivity)> <label for=typeActivity class=control-label>Nombre de actividad</label> <select name=typeActivity ng-model=createActivityVm.activityCode ng-options=\"listActivities.activityTypeCode as listActivities.activityTypeName for listActivities in createActivityVm.comboActivities\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createActivityForm.typeActivity.$error ng-show=createActivityVm.showErrorMessages(createActivityForm.typeActivity)> <div ng-message=required>La actividad es requerida</div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group ng-class=createActivityVm.hasError(createActivityForm.hours)> <label for=hours class=control-label>Horas planeadas</label> <input type=number min=0 name=hours ng-model=createActivityVm.hours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1 /> <div class=control-label ng-messages=createActivityForm.hours.$error ng-show=createActivityVm.showErrorMessages(createActivityForm.hours)> <div ng-message=required>Las horas son requeridas</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createActivityVm.hasError(createActivityForm.detail)> <label for=detail class=control-label>Descripción de labores</label> <md-input-container class=control-label> <textarea name=detail ng-model=createActivityVm.detail maxlength=500 md-maxlength=500 rows=2 class=form-control ng-model-options=\"{ debounce: 300 }\" required>\n                </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"control-label text-xs\" ng-messages=createActivityForm.detail.$error ng-show=createActivityVm.showErrorMessages(createActivityForm.detail)> <div ng-message=required>La descripción es requerida</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-7 no-padding\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.otherActivities>Cancelar</md-button> </div> <div class=\"col-md-5 no-padding text-right\"> <md-button class=\"btn btn-fw btn-primary text-xs p-h-md\" ng-click=\"createActivityVm.addActivity(true, false)\" ng-disabled=\"createActivityVm.isSaveButtonDisabled || createActivityVm.validateForm(createActivityForm)\"> Guardar actividad</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createActivityVm.updateRangeData(value) type-period=createActivityVm.typePeriod form-reference=createActivityForm toggle-range=createActivityVm.updateRangeType(type) range-type=createActivityVm.rangeType start-date=createActivityVm.dt_start end-date=createActivityVm.dt_end periods-array=createActivityVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.doctoralFormation', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/consolidationCP/doctoralFormation',
	    views: {
	      '': {
	        template: __webpack_require__(600)
	      },
	      'principal@': {
	        template: __webpack_require__(601),
	        controller: 'DoctoralListCtrl',
	        controllerAs: 'doctoralListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Formación doctoral',
	      order: 3,
	      title: 'Consolidación Cuerpo Profesoral',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.teachingDevelopment',
	        order: 1
	      }, {
	        name: 'workplan.learningAndPracticeCommunities',
	        order: 2
	      }, {
	        name: 'workplan.history',
	        displayName: 'Ver resumen',
	        order: 4
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.consolidationCP,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createDoctorate', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/consolidationCP/createDoctorate/:workplanTeacherActivityId',
	    template: __webpack_require__(602),
	    controller: 'CreateDoctorateCtrl',
	    controllerAs: 'createDoctorateVm',
	    data: {
	      displayName: 'Formación doctoral',
	      order: 3,
	      title: 'Consolidación Cuerpo Profesoral',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.teachingDevelopment',
	        order: 1
	      }, {
	        name: 'workplan.learningAndPracticeCommunities',
	        order: 2
	      }, {
	        name: 'workplan.history',
	        displayName: 'Ver resumen',
	        order: 4
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.teachingDevelopment', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/consolidationCP/teachingDevelopment',
	    views: {
	      '': {
	        template: __webpack_require__(603)
	      },
	      'principal@': {
	        template: __webpack_require__(604),
	        controller: 'TeachingDevListCtrl',
	        controllerAs: 'teachingDevListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Desarrollo profesoral',
	      order: 1,
	      title: 'Consolidación Cuerpo Profesoral',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.doctoralFormation',
	        order: 3
	      }, {
	        name: 'workplan.learningAndPracticeCommunities',
	        order: 2
	      }, {
	        name: 'workplan.history',
	        displayName: 'Ver resumen',
	        order: 4
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.consolidationCP,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.teachingJobsReview', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/teachingDevelopment/reviewTeachingDevelopment',
	    template: __webpack_require__(605),
	    controller: 'ReviewTeacherDevelopmentCtrl',
	    controllerAs: 'reviewTVM',
	    data: {
	      displayName: 'Desarrollo profesional',
	      order: 1,
	      title: 'Consolidación Cuerpo Profesoral',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.doctoralFormation',
	        order: 3
	      }, {
	        name: 'workplan.createLearningCommunities',
	        order: 2
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createCourse', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/consolidationCP/createCourse/:workplanTeacherActivityId',
	    template: __webpack_require__(606),
	    controller: 'CreateCourseCtrl',
	    controllerAs: 'createCourseVm',
	    data: {
	      displayName: 'Desarrollo profesoral',
	      order: 1,
	      title: 'Consolidación Cuerpo Profesoral',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.doctoralFormation',
	        order: 3
	      }, {
	        name: 'workplan.learningAndPracticeCommunities',
	        order: 2
	      }, {
	        name: 'workplan.history',
	        displayName: 'Ver resumen',
	        order: 4
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.learningAndPracticeCommunities', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/consolidationCP/learningAndPracticeCommunities',
	    views: {
	      '': {
	        template: __webpack_require__(607)
	      },
	      'principal@': {
	        template: __webpack_require__(608),
	        controller: 'LearningCommunityListCtrl',
	        controllerAs: 'learningCommunityListVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Comunidades de aprendizaje y de práctica',
	      order: 2,
	      title: 'Consolidación Cuerpo Profesoral',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.doctoralFormation',
	        order: 3
	      }, {
	        name: 'workplan.teachingDevelopment',
	        order: 1
	      }, {
	        name: 'workplan.history',
	        displayName: 'Ver resumen',
	        order: 4
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.consolidationCP,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createLearningCommunities', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/consolidationCP/createLearningCommunities/activityTypeId/:activityTypeId/workplanTeacherActivityId/:workplanTeacherActivityId',
	    template: __webpack_require__(609),
	    controller: 'CreateLearningComunityCtrl',
	    controllerAs: 'createLearningComunityVM',
	    data: {
	      displayName: 'Comunidades de aprendizaje y de práctica',
	      order: 2,
	      title: 'Consolidación Cuerpo Profesoral',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.doctoralFormation',
	        order: 3
	      }, {
	        name: 'workplan.teachingDevelopment',
	        order: 1
	      }, {
	        name: 'workplan.history',
	        displayName: 'Ver resumen',
	        order: 4
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.consolidationCP', {
	    moduleId: _globalConfig2.default.modules.consolidation,
	    abstract: false,
	    url: '/consolidationCP/teachingDevelopment',
	    redirectTo: 'workplan.teachingDevelopment',
	    data: {
	      displayName: 'Consolidación Cuerpo Profesoral',
	      title: 'Consolidación Cuerpo Profesoral'
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.consolidationCP,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  });
	}

/***/ }),
/* 600 */
577,
/* 601 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>{{ doctoralListVm.mainLabel }}</h3> <p class=text-16-important>En esta sección puede visualizar e ingresar la información frente a la formación doctoral que planea realizar o se encuentra realizando.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"doctoralListVm.feedback && !doctoralListVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=doctoralListVm.bitacora($event)> Bitácora de Formación Doctoral </md-button> </div> </div> <div class=\"row p-h-lg\"> <div class=col-md-12> <slick class=slick-oblique current-index=index infinite=false slides-to-show=4 responsive=breakpoints adaptive-height=true respond-to=min ng-if=\"doctoralListVm.dataList.length && doctoralListVm.viewLoaded\"> <div class=p-h-sm ng-repeat=\"doctorate in doctoralListVm.dataList\"> <div class=\"card brd-md\"> <div class=\"card-heading p-v-lg text-blanco\" ng-class=doctoralListVm.backgroundGrad($index)> <h3 class=\"exo font-bold text-md text-center\">{{doctorate.nameStudy}}</h3> <span class=\"proxima font-thin text-center text-xs\">{{doctorate.typeStudy}}</span> </div> <div class=card-body> <div class=text-center> <span class=\"proxima text-md font-thin\">{{doctorate.country}}</span> <p class=\"text-gris-darker text-base exo font-bold\">Pa&iacute;s</p> </div> <div class=\"text-center m-v\"> <span class=\"proxima text-md font-thin\">{{doctorate.typeInstitute}}</span> <p class=\"text-gris-darker text-base exo font-bold\">Tipo</p> </div> <div class=\"text-center m-v\"> <span class=\"proxima text-md font-thin\">{{doctorate.nameInstitute}}</span> <p class=\"text-gris-darker text-base exo font-bold\">Instituci&oacute;n</p> </div> </div> <div class=col-md-6 ng-class=classPlanning has-permission=formacion-doctoral-edit> <a href ui-sref=\"workplan.createDoctorate({workplanTeacherActivityId: doctorate.workplanTeacherActivityId})\" class=icon> <span class=\"icon i-20 mdi-content-create\"></span> <p class=\"text-xs exo\">Editar</p> </a> </div> <div class=col-md-6 ng-class=classPlanning has-permission=formacion-doctoral-edit> <a href ng-click=doctoralListVm.confirmDeleteDoctorate(doctorate) class=icon> <span class=\"icon i-20 mdi-action-delete\"></span> <p class=\"text-xs exo\">Eliminar</p> </a> </div> </div> </div> </slick> </div> </div> <div class=\"col-md-12 p-v text-center\" has-permission=formacion-doctoral-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createDoctorate ng-disabled=doctoralListVm.planningFinish>Agregar Doctorado</button> </div> </div> ";

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Formación doctoral - {{createDoctorateVm.createOrEdit}} Doctorado</h3> <p class=text-xs ng-show=!createDoctorateVm.isEditing> Ingrese a continuación los datos del programa de Doctorado y la dedicación planeada en el presente año.</p> <p class=text-xs ng-show=createDoctorateVm.isEditing>Edite los datos del siguiente formulario para modificar la formación doctoral. </p> </div> </div> <form name=createDoctorate novalidate> <div class=\"row blanco p-b-md\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=col-md-12> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del doctorado</h5> </div> <div class=\"col-md-5 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docTitle)> <label for=docTitle class=control-label>T&iacute;tulo</label> <input type=text name=docTitle ng-model=createDoctorateVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createDoctorate.docTitle.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docTitle)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-3 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docInstType)> <label for=docInstType class=control-label>Tipo de Instituci&oacute;n</label> <select name=docInstType ng-model=createDoctorateVm.institutionType ng-options=\"source.idListItem as source.listItemName for source in createDoctorateVm.listsTypeInstitution\" class=form-control ng-change=createDoctorateVm.changeTypeInstitution() required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docInstType.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docInstType)> <div ng-message=required class=text-xs>El tipo de instituci&oacute;n es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.institution)> <label for=institution class=control-label>Instituci&oacute;n</label> <md-autocomplete required md-input-name=institution class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=source.nameInstitution md-min-length=0 md-no-cache=true md-select-on-match=true md-selected-item-change=createDoctorateVm.changeInstitution(source) md-selected-item=createDoctorateVm.selectedItem md-search-text=createDoctorateVm.searchText placeholder=\"Buscar institución...\" md-items=\"source in createDoctorateVm.searchInstitution(createDoctorateVm.searchText, createDoctorateVm.institutionType)\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{source.nameInstitution}}</span> </md-item-template> </md-autocomplete> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docCountry)> <label for=docCountry class=control-label>Pa&iacute;s</label> <select name=docCountry ng-model=createDoctorateVm.country ng-options=\"source.codeCountry as source.nameCountry for source in createDoctorateVm.countries\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docCountry.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docCountry)> <div ng-message=required class=text-xs>El pa&iacute;s es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docDepartament)> <label for=docDepartament class=control-label>Departamento o Estado</label> <select name=docDepartament ng-model=createDoctorateVm.departament ng-options=\"source.codeState as source.nameState for source in createDoctorateVm.state | filter:{ codeCountry : createDoctorateVm.country }:true\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docDepartament.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docDepartament)> <div ng-message=required class=text-xs>El departamento es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docCity)> <label for=docCity class=control-label>Ciudad</label> <select name=docCity ng-model=createDoctorateVm.city ng-options=\"source.codeCity as source.nameCity for source in createDoctorateVm.cities | filter:{ codeState : createDoctorateVm.departament }:true\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docCity.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docCity)> <div ng-message=required class=text-xs>La ciudad es requerida.</div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docKnowledge)> <label for=docKnowledge class=control-label>N&uacute;cleo de Conocimiento</label> <md-autocomplete required md-input-name=docKnowledge class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=core.listItemName md-min-length=0 md-autofocus=true md-select-on-match=true md-selected-item-change=createDoctorateVm.changeCore(core) md-selected-item=createDoctorateVm.selectedItemCore md-search-text=createDoctorateVm.searchTextCore placeholder=\"Buscar nucleo de conocimiento...\" md-items=\"core in createDoctorateVm.searchCore(createDoctorateVm.searchTextCore)\"> <md-item-template> <span md-highlight-text=searchTextCore md-highlight-flags=^i>{{core.listItemName}}</span> </md-item-template> </md-autocomplete> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docSource)> <label for=docSource class=control-label>Fuente de Financiaci&oacute;n</label> <select name=docSource ng-model=createDoctorateVm.financingSource ng-options=\"source.idListItem as source.listItemName for source in createDoctorateVm.sourceType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docSource.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docSource)> <div ng-message=required class=text-xs>La fuente de financiaci&oacute;n es requerida.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docProgram)> <label for=docProgram class=control-label>Programa Beca</label> <select name=docProgram ng-model=createDoctorateVm.scholarshipProgram ng-options=\"source.idListItem as source.listItemName for source in createDoctorateVm.scholarshipProgramType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docProgram.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docProgram)> <div ng-message=required class=text-xs>El programa de beca es requerido.</div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docHours)> <label for=docHours class=control-label>Horas Planeadas</label> <input type=number min=0 name=docHours ng-model=createDoctorateVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createDoctorate.docHours.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docHours)> <div ng-message=required class=text-xs>Las horas planeadas son requeridas.</div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel text-left\" ui-sref=workplan.doctoralFormation>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createDoctorateVm.addDoctorate() ng-disabled=\"createDoctorateVm.validateForm(createDoctorate) || createDoctorateVm.disableButton\"> Guardar doctorado</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createDoctorateVm.updateRangeData(value) type-period=createDoctorateVm.typePeriod form-reference=createDoctorate toggle-range=createDoctorateVm.updateRangeType(type) range-type=createDoctorateVm.rangeType start-date=createDoctorateVm.dt_start end-date=createDoctorateVm.dt_end periods-array=createDoctorateVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 603 */
577,
/* 604 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>{{ teachingDevListVm.mainLabel }}</h3> <p class=text-16-important>En esta sección puede visualizar e ingresar todos los cursos de desarrollo profesoral que desea realizar, sean externos o internos.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"teachingDevListVm.feedback && !teachingDevListVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=teachingDevListVm.bitacora($event)> Bitácora de Desarrollo profesoral </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=teachingDevListVm.courseListSearch class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar cursos...\" ng-change=teachingDevListVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <slick class=\"slider single-item\" current-index=index ng-if=\"teachingDevListVm.courseList.length && teachingDevListVm.viewLoaded\" responsive=teachingDevListVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemCourse in teachingDevListVm.courseList | filter: teachingDevListVm.courseListSearch\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-6\" ng-class=teachingDevListVm.gradRoleClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemCourse.nameCourse}}</p> </div> <div class=\"row m-t-md\" ng-if=itemCourse.isEditable ng-class=classPlanning has-permission=desarrollo-profesoral-edit> <div class=col-md-6> <a href ui-sref=\"workplan.createCourse({workplanTeacherActivityId: itemCourse.workplanTeacherActivityId})\" class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6 ng-if=itemCourse.isEditable> <a href ng-click=teachingDevListVm.confirmDeleteCourse(itemCourse) class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-6\"> <p class=\"text-gris-dark exo no-margin\">Institución</p> <p class=\"fix-max-height detail no-margin p-b-xs\"> {{itemCourse.nameInstitute}}</p> <p class=\"text-gris-dark exo no-margin\">País</p> <p class=\"fix-max-height detail no-margin p-b-xs\">{{itemCourse.country}}</p> <p class=\"text-gris-dark exo no-margin\">Modalidad</p> <p class=\"fix-max-height detail no-margin p-b-xs\">{{itemCourse.modalityName}}</p> <p class=\"text-gris-dark exo no-margin\">Categoria</p> <p class=\"fix-max-height detail no-margin p-b-xs\">{{itemCourse.category || 'No aplica'}}</p> <p class=\"text-gris-dark exo no-margin\">{{itemCourse.timeRangeTypeName}}</p> <p class=\"no-padding no-margin fix-max-height detail\" ng-if=\"itemCourse.timeRangeTypeId == 1\"> {{itemCourse.periodicityName}} </p> <p class=\"text-xs no-padding no-margin fix-max-height detail\" ng-if=\"itemCourse.timeRangeTypeId == 2\"> {{itemCourse.startDate}} - {{itemCourse.endDate}} </p> </div> </div> </div> </slick> <div class=\"col-md-12 p-v text-center\" has-permission=desarrollo-profesoral-edit> <button class=\"btn btn-fw btn-cancel no-margin\" type=button ui-sref=workplan.teachingJobsReview ng-disabled=teachingDevListVm.planningFinish>Ver Oferta de Cursos UR</button> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createCourse ng-disabled=teachingDevListVm.planningFinish>Agregar Curso Externo</button> </div> </div> </div> </div> ";

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = " <div> <div ng-include=\"'header-course'\"></div> <div ng-include=\"'courses-list'\"></div> <div ng-include=\"'course-details'\"></div> </div> ";

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Desarrollo profesoral - {{createCourseVm.createOrEdit}} curso</h3> <p class=text-xs ng-show=!createCourseVm.isEditing> Diligencie los datos en el siguiente formulario para agregar un curso que no esté incluido en la oferta de desarrollo profesoral de la Universidad. Recuerde que para poder ser certificado institucionalmente, este debe ser validado y aprobado por el CEA (ensenanzayaprendizaje@urosario.edu.co). Todos los campos son obligatorios. </p> <p class=text-xs ng-show=createCourseVm.isEditing> Edite los datos del siguiente formulario para modificar el curso externo. Este debe haber sido validado y aprobado por el CEA, si no es así por favor comuníquese con esta área al siguiente correo electrónico: ensenanzayaprendizaje@urosario.edu.co. </p> </div> </div> <div class=\"row blanco\"> <form name=createCourseForm novalidate> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del curso</h5> </div> <div class=col-md-12> <div class=col-md-6> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cTitle)> <label for=cTitle class=control-label>T&iacute;tulo</label> <input type=text name=cTitle ng-model=createCourseVm.title class=form-control ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=createCourseForm.cTitle.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cTitle)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=col-md-3> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cEntity)> <label for=cEntity class=control-label>Tipo entidad</label> <select name=cEntity ng-model=createCourseVm.entityType ng-options=\"type.idListItem as type.listItemName for type in createCourseVm.listEntity\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.cEntity.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cEntity)> <div ng-message=required class=text-xs>El tipo de entidad es requerida.</div> </div> </div> </div> <div class=col-md-3> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cLevel)> <label for=cLevel class=control-label>Tipo</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom>Tipo de curso. Ejm: Seminario, Taller.</md-tooltip> </i> <input type=text name=cLevel ng-model=createCourseVm.level ng-model-options=\"{ debounce: 300 }\" class=\"form-control col-md-2\" required> <div class=control-label ng-messages=createCourseForm.cLevel.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cLevel)> <div ng-message=required class=text-xs>El tipo es requerido.</div> </div> </div> </div> </div> <div class=col-md-12> <div class=col-md-4> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cModality)> <label for=cModality class=control-label>Modalidad</label> <select name=cModality ng-model=createCourseVm.modality ng-options=\"type.idListItem as type.listItemName for type in createCourseVm.listModality\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.cModality.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cModality)> <div ng-message=required class=text-xs>La modalidad es requerida.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.coInstType)> <label for=coInstType class=control-label>Tipo de Instituci&oacute;n</label> <select name=coInstType ng-model=createCourseVm.institutionType ng-options=\"source.idListItem as source.listItemName for source in createCourseVm.listsTypeInstitution\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.coInstType.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.coInstType)> <div ng-message=required class=text-xs>El tipo de instituci&oacute;n es requerido.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.institution)> <label for=cInstitution class=control-label>Instituci&oacute;n</label> <md-autocomplete required md-input-name=institution class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=source.nameInstitution md-min-length=0 md-autofocus=true md-no-cache=true md-selected-item-change=createCourseVm.changeInstitution(source) md-selected-item=createCourseVm.selectedItem md-search-text=createCourseVm.searchText placeholder=\"Buscar institución...\" md-items=\"source in createCourseVm.searchInstitution(createCourseVm.searchText, createCourseVm.institutionType)\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{source.nameInstitution}}</span> </md-item-template> </md-autocomplete> <div class=control-label ng-messages=createCourseForm.institution.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.institution)> <div ng-message=required class=text-xs>La instituci&oacute;n es requerida.</div> </div> </div> </div> </div> <div class=col-md-12> <div class=col-md-3> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.coCountry)> <label for=cCountry class=control-label>Pa&iacute;s</label> <select name=coCountry ng-model=createCourseVm.country ng-options=\"source.codeCountry as source.nameCountry for source in createCourseVm.countries\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.coCountry.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.coCountry)> <div ng-message=required class=text-xs>El pa&iacute;s es requerido.</div> </div> </div> </div> <div class=col-md-3> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.coDepartament)> <label for=coDepartament class=control-label>Departamento</label> <select name=coDepartament ng-model=createCourseVm.departament ng-change=createCourseVm.changeDepartament(createCourseVm.departament) ng-options=\"source.codeState as source.nameState for source in createCourseVm.state | filter:{ codeCountry : createCourseVm.country } : true \" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.coDepartament.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.coDepartament)> <div ng-message=required class=text-xs>El departamento es requerido.</div> </div> </div> </div> <div class=col-md-3> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cCity)> <label for=cCity class=control-label>Ciudad</label> <select name=cCity ng-model=createCourseVm.city ng-options=\"source.codeCity as source.nameCity for source in createCourseVm.cities | filter:{ codeState : createCourseVm.departament } : true\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.cCity.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cCity)> <div ng-message=required class=text-xs> La ciudad es requerida. </div> </div> </div> </div> <div class=col-md-3> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cProgram)> <label for=cProgram class=control-label>Área</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom>Área temática del curso. Ejm: Pedagogía, investigación, Uso de TIC.</md-tooltip> </i> <input type=text name=cProgram ng-model=createCourseVm.program ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createCourseForm.cProgram.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cProgram)> <div ng-message=required class=text-xs>El programa es requerido.</div> </div> </div> </div> </div> <div class=col-md-12> <div class=col-md-12> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cDescription)> <label for=cDescription class=control-label>Descripci&oacute;n del curso</label> <md-input-container class=\"control-label no-padding\"> <textarea name=cDescription ng-model=createCourseVm.courseDescription rows=4 class=form-control md-maxlength=500 maxlength=500 ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=control-label ng-messages=createCourseForm.cDescription.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cDescription)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> <div class=col-md-12 style=margin-top:-24px> <div class=col-md-3> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.hours)> <label for=hours class=control-label>Horas Planeadas</label> <input type=number min=0 name=hours onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-model=createCourseVm.plannedHours class=form-control onpaste=return!1> <div class=control-label ng-messages=createCourseForm.hours.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> </div> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel text-left\" ui-sref=workplan.teachingDevelopment>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createCourseVm.addCourse(false) ng-disabled=\"createCourseVm.validateForm(createCourseForm) || createCourseVm.disableSaveButton\"> Guardar</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createCourseVm.updateRangeData(value) type-period=createCourseVm.typePeriod form-reference=createCourseForm toggle-range=createCourseVm.updateRangeType(type) range-type=createCourseVm.rangeType start-date=createCourseVm.dt_start end-date=createCourseVm.dt_end periods-array=createCourseVm.periodsArray> </period-picker> </div> </form> </div> ";

/***/ }),
/* 607 */
577,
/* 608 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>{{ learningCommunityListVm.mainLabel }}</h3> <div class=col-md-7> <p class=text-16-important>En esta sección puede visualizar e ingresar las comunidades a las que pertenece o aquellas en las que planea participar.</p> </div> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"learningCommunityListVm.feedback && !learningCommunityListVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=learningCommunityListVm.bitacora($event)> Bitácora de Comunidades de aprendizaje y práctica </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=learningCommunityListVm.communityFilter class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar comunidad...\" ng-change=learningCommunityListVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <slick class=\"slider single-item\" current-index=index ng-if=\"learningCommunityListVm.communitiesList.length && learningCommunityListVm.viewLoaded\" responsive=learningCommunityListVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemComunity in learningCommunityListVm.communitiesList | filter: learningCommunityListVm.communityFilter | orderBy: 'listItemNameCommunity'\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5\" ng-class=learningCommunityListVm.gradCommunityClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemComunity.name}}</p> </div> <div class=\"row m-t-md\" ng-class=classPlanning has-permission=comunidades-de-aprendizaje-y-practica-edit> <div class=col-md-6> <a ui-sref=\"workplan.createLearningCommunities({activityTypeId: itemComunity.activityTypeId,\n                      workplanTeacherActivityId: itemComunity.workplanTeacherActivityId})\" class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a ng-click=learningCommunityListVm.confirmDeleteCommunity(itemComunity) class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-8\"> <p class=\"text-md text-gris-dark exo\">Descripción</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\">{{itemComunity.description}}</p> </div> </div> </div> </slick> </div> </div> <div class=\"col-md-12 p-v text-center\" has-permission=comunidades-de-aprendizaje-y-practica-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createLearningCommunities ng-disabled=learningCommunityListVm.planningFinish>Agregar Comunidad</button> </div> </div> ";

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Comunidades de aprendizaje y práctica - {{createLearningComunityVM.createOrEdit}} comunidad</h3> <p class=text-xs ng-show=!createLearningComunityVM.isEditing> Ingrese el nombre de la comunidad que desea crear y una breve descripción de los temas a abordar. </p> <p class=text-xs ng-show=createLearningComunityVM.isEditing> Edite los datos del siguiente formulario para modificar la comunidad de aprendizaje y practica</p> </div> </div> <div class=\"row blanco\"> <form name=createComunity novalidate> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos Generales</h5> </div> <div class=\"col-md-9 text-left no-padding-r\"> <div class=form-group> <div class=form-group ng-class=createLearningComunityVM.hasError(createComunity.communities)> <label for=nameComunity class=control-label>Nombre</label> <md-autocomplete required ng-disabled=createLearningComunityVM.isEditing class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=community.listItemName md-input-name=communities md-min-length=0 md-input-minlength=0 md-select-on-match=true md-search-text-change=createLearningComunityVM.changeSearchText(createLearningComunityVM.searchText) md-autofocus=true md-selected-item-change=createLearningComunityVM.changeCommunity(community) md-selected-item=createLearningComunityVM.selectedItem md-search-text=createLearningComunityVM.searchText md-items=\"community in createLearningComunityVM.searchCommunity(createLearningComunityVM.searchText)\" placeholder=\"Buscar nombre de la comunidad...\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i> {{community.listItemName}} </span> </md-item-template> </md-autocomplete> <div class=control-label ng-messages=createComunity.communities.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.communities)> <div ng-message=required class=text-xs> La comunidad es requerida. </div> </div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group ng-class=createLearningComunityVM.hasError(createComunity.typeScene)> <label for=typeScene class=control-label>Ámbito/Escenario</label> <select name=typeScene ng-model=createLearningComunityVM.typeScene ng-options=\"listCommunity.idListItem as listCommunity.listItemName for listCommunity in createLearningComunityVM.listsAmbit\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createComunity.typeScene.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.typeScene)> <div ng-message=required class=text-xs> El ámbito es requerido. </div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createLearningComunityVM.hasError(createComunity.detail)> <label for=detail class=control-label>Descripción</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=right class=\"tooltip-multiline text-center\"> Describa brevemente el alcance de esta comunidad de práctica. <br/> Ejemplo: Estudio de didácticas activas e Identificación de buenas <br/> prácticas en la enseñanza de las matemáticas. </md-tooltip> </i> <md-input-container class=control-label> <textarea name=detail ng-model=createLearningComunityVM.detail class=form-control required md-maxlength=500 maxlength=500 rows=2 ng-model-options=\"{ debounce: 300 }\">\n              </textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=control-label ng-messages=createComunity.detail.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.detail)> <div ng-message=required class=text-xs> La descripción es requerida. </div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-3 no-padding-r\" style=margin-top:-24px> <div class=form-group ng-class=createLearningComunityVM.hasError(createComunity.hoursPlanned)> <label for=hoursPlanned class=control-label>Horas Planeadas</label> <input type=number min=0 name=hoursPlanned ng-model=createLearningComunityVM.hoursPlanning class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1 /> <div class=control-label ng-messages=createComunity.hoursPlanned.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.hoursPlanned)> <div ng-message=required class=text-xs>Las horas planeadas son requeridas.</div> </div> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-7 no-padding\"> <md-button class=\"btn btn-fw btn-cancel text-left\" ui-sref=workplan.learningAndPracticeCommunities>Cancelar</md-button> </div> <div class=\"col-md-5 no-padding text-right\"> <md-button class=\"btn btn-fw btn-success text-xs p-h-md\" ng-click=\"createLearningComunityVM.addActivity(true, false)\" ng-disabled=\"createLearningComunityVM.isSaveButtonDisabled || createLearningComunityVM.validateForm(createComunity)\"> Guardar actividad</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createLearningComunityVM.updateRangeData(value) type-period=createLearningComunityVM.periods form-reference=createComunity toggle-range=createLearningComunityVM.updateRangeType(type) range-type=createLearningComunityVM.rangeType start-date=createLearningComunityVM.dt_start end-date=createLearningComunityVM.dt_end periods-array=createLearningComunityVM.periodsArray> </period-picker> </div> </form> </div> ";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.projectsFormulation', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/projectsFormulation',
	    views: {
	      '': {
	        template: __webpack_require__(611)
	      },
	      'principal@': {
	        template: __webpack_require__(612),
	        controller: 'ProjectsFormulationListCtrl',
	        controllerAs: 'projectsFormulationVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Formulación de propuesta',
	      order: 1,
	      title: 'Investigación e innovación',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.investigation', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/projectsFormulation',
	    views: {
	      '': {
	        template: __webpack_require__(611)
	      },
	      'principal@': {
	        template: __webpack_require__(612),
	        controller: 'ProjectsFormulationListCtrl',
	        controllerAs: 'projectsFormulationVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Investigación',
	      order: 1,
	      title: 'Investigación e innovación',
	      siblings: [{
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createProjectFormulation', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/projectsFormulation/createProjectFormulation/:workplanTeacherActivityId',
	    template: __webpack_require__(613),
	    controller: 'CreateProjectFormulationCtrl',
	    controllerAs: 'createProjectFormulationVm',
	    data: {
	      displayName: 'Formulación de propuesta',
	      title: 'Investigación e innovación',
	      order: 1,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.projects', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/projects',
	    template: __webpack_require__(614),
	    controller: 'ProjectsListCtrl',
	    controllerAs: 'projectsVm',
	    data: {
	      displayName: 'Proyectos',
	      title: 'Investigación e innovación',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createProject', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/projects/createProject/:workplanTeacherActivityId',
	    template: __webpack_require__(615),
	    controller: 'CreateProjectCtrl',
	    controllerAs: 'createProjectVm',
	    data: {
	      displayName: 'Proyectos',
	      title: 'Investigación e innovación',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.products', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/products',
	    template: __webpack_require__(616),
	    controller: 'ProductsListCtrl',
	    controllerAs: 'productsVm',
	    data: {
	      displayName: 'Productos',
	      title: 'Investigación e innovación',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createProduct', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/products/createProduct/:workplanTeacherActivityId',
	    template: __webpack_require__(617),
	    controller: 'CreateProductCtrl',
	    controllerAs: 'createProductVm',
	    data: {
	      displayName: 'Productos',
	      title: 'Investigación e innovación',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.collaborationSpaces', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/collaborationSpaces',
	    views: {
	      '': {
	        template: __webpack_require__(618)
	      },
	      'principal@': {
	        template: __webpack_require__(619),
	        controller: 'CollaborationSpacesListCtrl',
	        controllerAs: 'collaborationSpacesVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Espacio de colaboración',
	      title: 'Investigación e innovación',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createSpace', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/createSpace/:workplanTeacherActivityId',
	    template: __webpack_require__(620),
	    controller: 'CreateSpaceCtrl',
	    controllerAs: 'createSpaceVm',
	    data: {
	      displayName: 'Espacio de colaboración',
	      title: 'Investigación e innovación',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.trainingResearch', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/trainingResearch',
	    views: {
	      '': {
	        template: __webpack_require__(621)
	      },
	      'principal@': {
	        template: __webpack_require__(622),
	        controller: 'TrainingResearchListCtrl',
	        controllerAs: 'trainingResearchVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Formación en investigación',
	      title: 'Investigación e innovación',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createTrainingResearch', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/createTrainingResearch/:workplanTeacherActivityId',
	    template: __webpack_require__(623),
	    controller: 'CreateTrainingResearchCtrl',
	    controllerAs: 'createTrainingVm',
	    data: {
	      displayName: 'Formación en investigación',
	      title: 'Investigación e innovación',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.resultsTransfer',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.resultsTransfer', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/resultsTransfer',
	    views: {
	      '': {
	        template: __webpack_require__(624)
	      },
	      'principal@': {
	        template: __webpack_require__(625),
	        controller: 'ResultsTransferListCtrl',
	        controllerAs: 'resultsTransferVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Transferencia de resultados',
	      title: 'Investigación e innovación',
	      order: 6,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createResultsTransfer', {
	    moduleId: _globalConfig2.default.modules.investigation,
	    abstract: false,
	    url: '/research/createResultsTransfer/:workplanTeacherActivityId',
	    template: __webpack_require__(626),
	    controller: 'CreateResultsTransferCtrl',
	    controllerAs: 'createTransferVm',
	    data: {
	      displayName: 'Transferencia de resultados',
	      title: 'Investigación e innovación',
	      order: 6,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectsFormulation',
	        order: 1
	      }, {
	        name: 'workplan.projects',
	        order: 2
	      }, {
	        name: 'workplan.products',
	        order: 3
	      }, {
	        name: 'workplan.collaborationSpaces',
	        order: 4
	      }, {
	        name: 'workplan.trainingResearch',
	        order: 5
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.research,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  });
	}

/***/ }),
/* 611 */
577,
/* 612 */
/***/ (function(module, exports) {

	module.exports = " <div ng-include=\"'customStyle'\"></div> <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-10 p-h-lg p-v m-b-xs\"> <h3>Formulación de propuestas</h3> <p class=text-16-important>En esta sección puede visualizar e ingresar propuestas de proyectos</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"projectsFormulationVm.feedback && !projectsFormulationVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=projectsFormulationVm.bitacora($event)> Bitácora de Formulación de propuestas </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=projectListSearch class=form-control placeholder=\"Buscar proyectos...\" ng-model-options=\"{ debounce: 300 }\" ng-change=projectsFormulationVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-t-md p-h-lg\"> <div class=col-md-12> <slick class=slick-oblique current-index=index infinite=false slides-to-show=3 responsive=breakpoints adaptive-height=true respond-to=min ng-if=\"projectsFormulationVm.projectList.length && projectsFormulationVm.viewLoaded &&\n      (projectsFormulationVm.projectList | filter: projectListSearch).length != 0\"> <div class=p-h-sm ng-repeat=\"projects in projectsFormulationVm.projectList | filter: projectListSearch\"> <div class=\"card brd-md\"> <div class=\"card-heading slick-oblique-header p-v-lg text-blanco hidden-content\" ng-class=projectsFormulationVm.backgroundGrad($index)> <h3 class=\"exo font-bold text-center word-wrap\" ng-class=\"projects.nameProject.length > 20 ? 'text-sm' : 'text-md'\"> {{projects.nameProject}} </h3> </div> <div class=card-body> <div ng-if=\"projects.timeRangeTypeId == 1\"> <div class=text-center> <label ng-repeat=\"period in projects.periods\" class=m-r-sm> <span class=\"proxima text-md font-thin m-r-sm\">{{period}}</span> </label> <p class=\"text-gris-darker text-base exo font-bold\">Período</p> </div> </div> <div ng-if=\"projects.timeRangeTypeId == 2\"> <div class=text-center> <span class=\"proxima text-md font-thin\">{{projects.startDate}}</span> <p class=\"text-gris-darker text-base exo font-bold\">Fecha inicio</p> </div> <div class=\"text-center m-v\"> <span class=\"proxima text-md font-thin\">{{projects.endDate}}</span> <p class=\"text-gris-darker text-base exo font-bold\">Fecha fin</p> </div> </div> <div class=\"text-center m-v\"> <span class=\"proxima text-md font-thin\">{{projects.num_hours_planned}}</span> <p class=\"text-gris-darker text-base exo font-bold\">Horas planeadas</p> </div> </div> <div class=row ng-class=classPlanning has-permission=formulacion-de-proyectos-edit> <div class=col-md-6> <a href ui-sref=\"workplan.createProjectFormulation({workplanTeacherActivityId: projects.workplanTeacherActivityId})\" ng-disabled=projectsFormulationVm.workplanActive class=icon> <span class=\"icon i-20 mdi-content-create\"></span> <p class=\"text-xs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href ng-click=projectsFormulationVm.confirmDeleteProject(projects) ng-disabled=projectsFormulationVm.workplanActive class=icon> <span class=\"icon i-20 mdi-action-delete\"></span> <p class=\"text-xs exo\">Eliminar</p> </a> </div> </div> </div> </div> </slick> </div> </div> <div class=\"col-md-12 p-v text-center\" has-permission=formulacion-de-proyectos-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createProjectFormulation ng-disabled=projectsFormulationVm.planningFinish>Agregar propuesta</button> </div> </div> ";

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = "<div ng-include=\"'customStyle'\"></div> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Formulación de propuestas de investigación - {{createProjectFormulationVm.createOrEdit}} formulación de propuestas</h3> <p class=text-xs ng-show=!createProjectFormulationVm.isEditing>En esta sección del Plan de Trabajo usted solicita tiempo para escribir una propuesta de investigaci&oacute;n. Se requiere del ingreso de los datos esenciales de la propuesta. La propuesta de proyecto a formular no requiere tener necesariamente identificada la fuente de financiamiento.</p> <p class=text-xs ng-show=createProjectFormulationVm.isEditing>Edite los datos en el siguiente formulario para modificar una propuesta de proyecto</p> </div> </div> <form name=createProject novalidate> <div class=\"row blanco p-b-md\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales de la propuesta de proyecto</h5> </div> <div class=col-md-8> <div class=row> <div class=col-md-8> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.title)> <label for=title class=control-label>T&iacute;tulo * </label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Escriba en este campo el título que podría <br> llevar el proyecto de investigación. </md-tooltip> </i> <input type=text name=title ng-model=createProjectFormulationVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control maxlength=200 required> <div class=control-label ng-messages=createProject.title.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.rol)> <label for=rol class=control-label>Rol * </label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Seleccione el rol que usted tendría dentro del proyecto de investigación. </md-tooltip> </i> <select name=rol ng-model=createProjectFormulationVm.rol ng-options=\"source.idListItem as source.listItemName for source in createProjectFormulationVm.rolList\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createProject.rol.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.rol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.summary)> <label for=summary class=control-label>Resumen del proyecto * </label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Describa en lo posible el tema del proyecto a formular, <br> aspectos generales del alcance que podría tener o <br> cualquier información que considere pertinente. </md-tooltip> </i> <md-input-container class=\"control-label no-margin\"> <textarea name=summary ng-model=createProjectFormulationVm.projectSummary class=form-control required rows=4 maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 500 }\"></textarea> <div class=\"col-md-16 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createProject.summary.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.summary)> <div ng-message=required class=text-xs>El resumen de proyecto es requerido.</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=col-md-4> <label for=financial class=control-label>Tipos de financiadores</label> <div ng-repeat=\"financial in createProjectFormulationVm.typeFinancial\"> <md-checkbox class=\"md-green m-r-sm text-sm\" type=checkbox ng-model=createProjectFormulationVm.selectedTypeFinancial[financial.financialId] ng-value=financial.financialId name=financial ng-change=\"createProjectFormulationVm.funSelectedFinancial(financial, createProjectFormulationVm.selectedTypeFinancial[financial.financialId])\"> {{financial.financialName}} </md-checkbox> </div> </div> <div class=row> <div class=col-md-12> <div class=col-md-3> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.hours)> <label for=hours class=control-label>Horas planeadas</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Estime las horas que dedicará a la propuesta <br/> en el período de tiempo seleccionado. </md-tooltip> </i> <input type=number name=hours ng-model=createProjectFormulationVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" min=0 onpaste=return!1> <div class=control-label ng-messages=createProject.hours.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-6 p-lg\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createProjectFormulationVm.notification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-10 no-padding-l\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.projectsFormulation>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2 no-padding-r\"> <md-button class=\"btn btn-fw btn-success no-margin\" ng-click=createProjectFormulationVm.addProject(false) ng-disabled=\"createProjectFormulationVm.validateForm(createProject) || createProjectFormulationVm.buttonDisabled\"> Guardar propuesta</md-button> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createProjectFormulationVm.updateRangeData(value) type-period=createProjectFormulationVm.typePeriod form-reference=createProject toggle-range=createProjectFormulationVm.updateRangeType(type) range-type=createProjectFormulationVm.rangeType start-date=createProjectFormulationVm.dt_start end-date=createProjectFormulationVm.dt_end periods-array=createProjectFormulationVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = " <div> <div ng-include=\"'customStyle'\"></div> <div ng-include=\"'header-project'\"></div> <div ng-include=\"'projects-list'\"></div> <div ng-include=\"'project-details'\"></div> </div> ";

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = "<div ng-include=\"'customStyle'\"></div> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Proyectos - {{createProjectVm.createOrEdit}} proyecto</h3> <p class=text-xs>Modifique los datos en el siguiente formulario para agregar un proyecto nuevo. Los campos con (*) son obligatorios.</p> </div> </div> <form name=createProject novalidate> <div class=\"blanco row\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del proyecto</h5> </div> <div class=\"col-md-7 no-padding-r\"> <div class=\"row m-t-xs\"> <div class=\"col-md-7 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.title)> <label for=title class=control-label>T&iacute;tulo del proyecto * </label> <input type=text name=title ng-model=createProjectVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createProject.title.$error ng-show=createProjectVm.showErrorMessages(createProject.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=col-md-5> <div class=form-group> <label for=groupInvestigation class=control-label>Grupo de investigaci&oacute;n</label> <select name=groupInvestigation ng-model=createProjectVm.groupInvestigation ng-options=\"source.id_code as source.ds_name for source in createProjectVm.groupInvestigationList\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> </div> <div class=\"row m-t-xs\"> <div class=\"col-md-5 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.projectFormulated)> <label for=projectFormulated class=control-label>Proyecto asociado * </label> <select name=projectFormulated ng-model=createProjectVm.projectFormulated ng-options=\"source.workplanTeacherActivityId as source.nameProject for source in createProjectVm.projectFormulatedList\" class=form-control required> <option value=\"\">Sin Proyecto Asignado</option> </select> <div class=control-label ng-messages=createProject.projectFormulated.$error ng-show=createProjectVm.showErrorMessages(createProject.projectFormulated)> <div ng-message=required class=text-xs>El proyecto asociado es requerido.</div> </div> </div> </div> <div class=col-md-7> <div class=form-group ng-class=createProjectVm.hasError(createProject.typeProject)> <label for=typeProject class=control-label>Tipo de proyecto * </label> <select name=typeProject ng-model=createProjectVm.typeProject ng-options=\"source.idListItem as source.listItemName for source in createProjectVm.typeProjectList\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createProject.typeProject.$error ng-show=createProjectVm.showErrorMessages(createProject.typeProject)> <div ng-message=required class=text-xs>El tipo de proyecto es requerido.</div> </div> </div> </div> </div> <div class=\"row m-t-xs\"> <div class=\"col-md-5 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.rol)> <label for=rol class=control-label>Rol en el proyecto * </label> <select name=rol ng-model=createProjectVm.rol ng-options=\"source.idListItem as source.listItemName for source in createProjectVm.rolList\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createProject.rol.$error ng-show=createProjectVm.showErrorMessages(createProject.rol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> <div class=col-md-7> <div class=col-md-12> <label for=financial class=control-label>Tipos de financiadores</label> </div> <div class=\"col-md-12 m-t-xs\"> <label class=\"m-r-sm text-sm\" ng-repeat=\"financial in createProjectVm.typeFinancial\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectVm.selectedTypeFinancial[financial.financialId] ng-value=financial.financialId name=financial ng-change=\"createProjectVm.funSelectedFinancial(financial, createProjectVm.selectedTypeFinancial[financial.financialId])\"> {{financial.financialName}} </md-checkbox> </label> </div> </div> </div> </div> <div class=col-md-5> <div class=\"row m-t-xs\"> <div class=col-md-11> <div class=form-group> <label for=description class=control-label>Descripci&oacute;n</label> <md-input-container class=control-label> <textarea name=description ng-model=createProjectVm.description rows=4 md-maxlength=500 maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-2 left\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.hours)> <label for=hours class=control-label>Horas planeadas</label> <a href=# tooltip-placement=bottom data-toggle=tooltip data-trigger=hover tooltip=\" Estime las horas que dedicará a la propuesta en el período de tiempo seleccionado.\"> <i class=\"mdi-action-info-outline text-left text-azul i-16\"> </i> </a> <input type=number min=0 name=hours ng-model=createProjectVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createProject.hours.$error ng-show=createProjectVm.showErrorMessages(createProject.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-12 no-padding-r\"> <div class=\"col-md-3 m-t-xs\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createProjectVm.notification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> <div class=\"col-md-12 p-t m-t-md\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel left\" ui-sref=workplan.projects>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2 no-padding-r\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createProjectVm.addProject(false) ng-disabled=\"createProjectVm.isSaveButtonDisabled || createProjectVm.validateForm(createProject)\"> Guardar proyecto </md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createProjectVm.updateRangeData(value) type-period=createProjectVm.typePeriod form-reference=createProject toggle-range=createProjectVm.updateRangeType(type) range-type=createProjectVm.rangeType start-date=createProjectVm.dt_start end-date=createProjectVm.dt_end periods-array=createProjectVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports = " <div> <div ng-include=\"'customStyle'\"></div> <div ng-include=\"'header-products'\"></div> <div ng-include=\"'products-list'\"></div> <div ng-include=\"'products-details'\"></div> </div> ";

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = " <div ng-include=\"'customStyle'\"></div> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Productos - {{createProductVm.createOrEdit}} producto</h3> <p class=text-xs>Diligencie los datos en el siguiente formulario para {{createProductVm.createOrEditTitle}} un producto. Los campos con (*) son obligatorios.</p> </div> </div> <form name=createProduct novalidate> <div class=\"row blanco\" style=\"height:calc(100% - 110px)\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs blanco\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del producto</h5> </div> <div class=\"col-md-7 no-padding-r\"> <div class=\"row m-t-xs\"> <div class=\"col-md-7 no-padding-r\"> <div class=form-group ng-class=createProductVm.hasError(createProduct.title)> <label for=title class=control-label>T&iacute;tulo preliminar del producto*</label> <input type=text name=title ng-model=createProductVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createProduct.title.$error ng-show=createProductVm.showErrorMessages(createProduct.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=col-md-5> <label for=knowledge class=control-label>Área de conocimiento</label> <select name=knowledge ng-model=createProductVm.knowledge ng-options=\"source.idListItem as source.listItemName for source in createProductVm.knowledgeList\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"row m-t-xs\"> <div class=\"col-md-6 no-padding-r\"> <label for=typeProduct class=control-label>Tipo de producto</label> <select name=typeProduct ng-model=createProductVm.typeProduct ng-options=\"source.itemId as source.itemName for source in createProductVm.typeProductList\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> <div class=col-md-6> <div class=form-group> <label for=subTypeProduct class=control-label>Subtipo de producto</label> <select name=subTypeProduct ng-model=createProductVm.subTypeProduct ng-options=\"source.subItemId as source.subItemName for source in createProductVm.subTypeProductList | filter:{ parentId : createProductVm.typeProduct }\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> </div> <div class=\"row m-t-xs\"> <div class=col-md-6> <label for=associatedProject class=control-label>Proyecto asociado</label> <select name=associatedProject ng-model=createProductVm.associatedProject ng-options=\"source.workplanTeacherActivityId as source.name for source in createProductVm.associatedProjecttList\" class=form-control ng-disabled=createProductVm.child.length ng-change=createProductVm.hoursChange(createProductVm.associatedProject)> <option value=\"\">Sin Proyecto Asignado</option> </select> </div> <div class=\"col-md-12 m-t\"> <label class=control-label>¿Con qué horas planeadas/ejecutadas desea trabajar?</label> </div> <div class=\"col-md-6 form-group no-margin\"> <div class=\"radio-options m-l-md\"> <input type=radio name=presencial ng-model=createProductVm.hoursChildren value=0> <i class=radio-green></i> <label class=text-xs>Horas generales del producto</label> </div> </div> <div class=\"col-md-6 form-group\" ng-hide=\"createProductVm.showHoursChildren == true\"> <div class=\"radio-options m-l-md\"> <input type=radio name=presencial ng-model=createProductVm.hoursChildren value=1> <i class=radio-green></i> <label class=text-xs>Horas por actividades hijas</label> </div> </div> </div> </div> <div class=col-md-5> <div class=\"row m-t-xs\"> <div class=col-md-11> <div class=form-group ng-class=createProductVm.hasError(createProduct.description)> <label for=description class=control-label>Descripci&oacute;n*</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createProductVm.description rows=8 maxlength=500 md-maxlength=500 class=form-control required=\"\" ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> <div class=\"col-md-12 no-padding\"> <div class=control-label ng-messages=createProduct.description.$error ng-show=createProductVm.showErrorMessages(createProduct.description)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-6 left\" ng-show=\"createProductVm.hoursChildren == 0\"> <label for=hours class=control-label>Horas planeadas</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Estime las horas que dedicará a la propuesta <br/> en el período de tiempo seleccionado. </md-tooltip> </i> <input type=number min=0 name=hours ng-model=createProductVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" class=form-control onpaste=return!1> </div> <div class=col-md-6> <div class=form-group ng-class=createProductVm.hasError(createProduct.notification)> <div class=\"col-md-12 m-t-lg\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createProductVm.notification value=true ng-disabled=createProjectFormulationVm.isEditing> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> <div class=\"col-md-12 p-t m-t-md\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel left\" ui-sref=workplan.products>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2 no-padding-r\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createProductVm.addProduct(false) ng-disabled=\"createProductVm.validateForm(createProduct) || createProductVm.buttonDisabled\"> Guardar producto </md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createProductVm.updateRangeData(value) type-period=createProductVm.typePeriod form-reference=createProduct toggle-range=createProductVm.updateRangeType(type) range-type=createProductVm.rangeType start-date=createProductVm.dt_start end-date=createProductVm.dt_end periods-array=createProductVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 618 */
577,
/* 619 */
/***/ (function(module, exports) {

	module.exports = " <div ng-include=\"'customStyle'\"></div> <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>{{ collaborationSpacesVm.mainLabel }}</h3> <p class=text-16-important>En este espacio podrá planear la solicitud de tiempo para realizar actividades como simposios, asistencias y delegaciones a comités, o redes de investigación, pasantías y similares.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"collaborationSpacesVm.feedback && !collaborationSpacesVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=collaborationSpacesVm.bitacora($event)> Bitácora de Espacios de colaboración </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=spaceListSearch class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar espacio...\" ng-change=collaborationSpacesVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <slick class=\"slider single-item\" current-index=index ng-if=\"collaborationSpacesVm.spaceList.length && collaborationSpacesVm.viewLoaded &&\n      (collaborationSpacesVm.spaceList | filter: spaceListSearch).length != 0\" responsive=collaborationSpacesVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemSpace in collaborationSpacesVm.spaceList | filter: spaceListSearch\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-6\" ng-class=collaborationSpacesVm.gradRoleClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemSpace.nameSpace}}</p> </div> <div class=p-v> <p class=\"m-t text-sm exo\">{{itemSpace.countryName}} {{itemSpace.cityName}}</p> </div> <div class=\"row m-t-md\" has-permission=espacios-de-colaboracion-edit ng-class=classPlanning> <div class=col-md-6> <a has-permission=espacios-de-colaboracion-edit href ui-sref=\"workplan.createSpace({workplanTeacherActivityId: itemSpace.workplanTeacherActivityId})\" class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href has-permission=espacios-de-colaboracion-edit ng-click=collaborationSpacesVm.confirmDeleteSpace(itemSpace) class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-6\"> <p class=\"text-md text-gris-dark exo no-margin p-t\">Tipo</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\">{{itemSpace.typeSpace}}</p> <p class=\"text-md text-gris-dark exo no-margin p-t\">Participación</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\">{{itemSpace.typeParticipation}}</p> <p class=\"text-md text-gris-dark exo no-margin p-t\">Enlace del evento u organizador</p> <a class=\"text-xs no-padding no-margin fix-max-height detail\" style=word-wrap:break-word target=_blank href={{itemSpace.link}}>{{itemSpace.link | limitTo : 100}}</a> </div> </div> </div> </slick> <div has-permission=espacios-de-colaboracion-edit class=\"col-md-12 p-t-xl text-center\"> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createSpace ng-disabled=collaborationSpacesVm.planningFinish>Agregar espacio</button> </div> <div class=\"col-md-7 no-padding text-center m-t-lg\"> <div class=\"alert btn-cancel alert-dismissable\"> <button type=button class=\"close m-t-xs m-r-xs\" data-dismiss=alert>&times;</button> <p class=\"text-sm font-test text-azul\"> Si usted está organizando un evento por favor remitase al modulo de <b><a href=/workplan/extensionVisibility/projectFormulation>Extensión.</a></b> </p> </div> </div> </div> </div> </div> ";

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = "<div ng-include=\"'customStyle'\"></div> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Espacio de colaboración - {{createSpaceVm.createOrEdit}} espacio de colaboración</h3> </div> </div> <form name=createSpaceForm novalidate> <div class=\"row blanco\" style=\"height:calc(100% - 110px)\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs blanco\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> </div> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.cTitle)> <label for=cTitle class=control-label>Nombre del espacio * </label> <input type=text name=cTitle ng-model=createSpaceVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createSpaceForm.cTitle.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.cTitle)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group> <label for=ambit class=control-label>Ámbito</label> <select name=ambit ng-model=createSpaceVm.ambit ng-options=\"type.idListItem as type.listItemName for type in createSpaceVm.listAmbit\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.typeComunity)> <label for=typeComunity class=control-label>Tipo * </label> <select name=typeComunity ng-model=createSpaceVm.typeComunity ng-options=\"type.idListItem as type.listItemName for type in createSpaceVm.listTypeComunity\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createSpaceForm.typeComunity.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.typeComunity)> <div ng-message=required class=text-xs>El tipo es requerido.</div> </div> </div> </div> </div> <div class=row> <div class=col-md-4> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.typeParticipate)> <label for=typeParticipate class=\"control-label text-sm\">Tipo de participacion del profesor *</label> <select name=typeParticipate ng-model=createSpaceVm.typeParticipate ng-options=\"type.idListItem as type.listItemName for type in createSpaceVm.listTypePaticipate\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createSpaceForm.typeParticipate.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.typeParticipate)> <div ng-message=required class=text-xs>El tipo de participacion es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group> <label for=entity class=control-label>Entidad/Organización</label> <md-autocomplete class=\"autocomplete no-padding col-md-12 m-r-xs\" md-clear-button=false md-item-text=source.listItemName md-min-length=0 md-autofocus=true md-selected-item-change=createSpaceVm.changeEntity(source) md-selected-item=createSpaceVm.selectedItemEntity md-search-text=createSpaceVm.searchText placeholder=\"Buscar entidad...\" md-items=\"source in createSpaceVm.searchEntity(createSpaceVm.searchText)\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{source.listItemName}}</span> </md-item-template> </md-autocomplete> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.link)> <label for=link class=control-label>Enlace del evento u organizador</label> <input type=url name=link ng-model=createSpaceVm.link class=form-control pattern=https?://.+ placeholder=https://www.example.com> <div class=control-label ng-messages=createSpaceForm.link.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.link)> <div ng-message=pattern class=text-xs>La url no es válida.</div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group> <label for=country class=control-label>Pa&iacute;s</label> <select name=country ng-model=createSpaceVm.country ng-options=\"source.codeCountry as source.nameCountry for source in createSpaceVm.countries\" ng-change=createSpaceVm.enableCities(createSpaceVm.country) class=form-control> <option value=\"\">Seleccione</option> </select> </div> </div> <div class=\"col-md-6 no-padding-r\"> <label for=searchcity class=control-label>Ciudad</label> <md-autocomplete class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=source.nameCity md-min-length=1 md-no-cache=true md-selected-item-change=createSpaceVm.changeCity(source) md-selected-item=createSpaceVm.selectedItemCity md-search-text=createSpaceVm.searchcity placeholder=\"Buscar ciudad...\" md-items=\"source in createSpaceVm.searchCity(createSpaceVm.searchcity)\" md-select-on-match=true md-input-name=city ng-disabled=createSpaceVm.countrySelected> <md-item-template> <span md-highlight-text=searchcity md-highlight-flags=^i>{{source.nameCity}}</span> </md-item-template> </md-autocomplete> </div> </div> <div class=row> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.description)> <label for=description class=control-label>Descripci&oacute;n y Justificaci&oacute;n * </label> <md-input-container class=control-label> <textarea name=description ng-model=createSpaceVm.description rows=3 maxlength=500 class=form-control md-maxlength=500 required ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createSpaceForm.description.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.description)> <div ng-message=required class=text-xs> La descripción es requerida. </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group> <label for=results class=control-label>Resultados esperados</label> <md-input-container class=control-label> <textarea name=results ng-model=createSpaceVm.results rows=3 maxlength=500 md-maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> <div class=row> <div class=col-md-6> <label for=hours class=control-label>Horas Planeadas</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Estime las horas que dedicará a la propuesta <br/> en el período de tiempo seleccionado. </md-tooltip> </i> <input onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" type=number min=0 name=hours ng-model=createSpaceVm.plannedHours class=form-control onpaste=return!1> </div> <div class=\"col-md-6 p-t-lg no-padding-l\"> <div class=\"col-md-12 m-t-xs text-left\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createSpaceVm.isNotification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.collaborationSpaces>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createSpaceVm.addSpace(false) ng-disabled=\"createSpaceVm.isSaveButtonDisabled || createSpaceVm.validateForm(createSpaceForm)\"> Guardar espacio</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createSpaceVm.updateRangeData(value) type-period=createSpaceVm.typePeriod form-reference=createSpaceForm toggle-range=createSpaceVm.updateRangeType(type) range-type=createSpaceVm.rangeType start-date=createSpaceVm.dt_start end-date=createSpaceVm.dt_end periods-array=createSpaceVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row gris-base\"> <div ui-view=principal@></div> <div ui-view=indicators@></div> </div> ";

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = " <div ng-include=\"'customStyle'\"></div> <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Formación en investigación</h3> <p class=text-16-important>En esta sección puede visualizar y añadir la solicitud de tiempo para realizar actividades de formación en investigación, como tutorías doctorales, coordinación de semilleros, entre otras.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"trainingResearchVm.feedback && !trainingResearchVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=trainingResearchVm.bitacora($event)> Bitácora de Formación en investigación </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=trainingResearchListSearch class=form-control placeholder=\"Buscar formación\" ng-model-options=\"{ debounce: 300 }\" ng-change=trainingResearchVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=\"col-md-12 long-card\"> <slick class=\"slider single-item\" current-index=index ng-if=\"trainingResearchVm.trainings.length && trainingResearchVm.viewLoaded &&\n      (trainingResearchVm.trainings | filter: trainingResearchListSearch).length != 0\" responsive=trainingResearchVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemTraining in trainingResearchVm.trainings | filter: trainingResearchListSearch\"> <div class=\"card horizontal no-margin\"> <div class=\"p-t text-center text-blanco col-md-6\" ng-class=trainingResearchVm.gradRoleClass> <div class=\"first-content long\"> <p class=\"text-base exo\">{{ itemTraining.nameResearch | limitTo: 165 }}{{itemTraining.nameResearch.length > 165 ? '...' : ''}}</p> </div> <div class=\"row m-t-md\" ng-class=classPlanning has-permission=formacion-de-investigacion-edit> <div class=col-md-6> <a href ui-sref=\"workplan.createTrainingResearch({workplanTeacherActivityId: itemTraining.workplanTeacherActivityId})\" class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href ng-click=trainingResearchVm.confirmDeleteTraining(itemTraining) class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-6\"> <p class=\"text-gris-dark exo no-margin text-base\">Tipo</p> <p class=\"no-padding fix-max-height detail text-base\">{{itemTraining.nameType}}</p> <p class=\"text-gris-dark exo no-margin text-base\">Enlace</p> <a class=\"no-padding fix-max-height detail text-base\" style=word-wrap:break-word target=_blank href={{itemTraining.link}}>{{itemTraining.link | limitTo : 150}}</a> </div> </div> </div> </slick> <div class=\"col-md-12 p-v text-center\" has-permission=formacion-de-investigacion-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createTrainingResearch ng-disabled=trainingResearchVm.planningFinish>Agregar formación en investigación</button> </div> </div> </div> </div> ";

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = " <div ng-include=\"'customStyle'\"></div> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Formaci&oacute;n en investigaci&oacute;n - {{createTrainingVm.createOrEdit}} evento de formaci&oacute;n</h3> <p class=text-xs>Diligencie los datos en el siguiente formulario para agregar un evento de formación. Los campos con (*) son obligatorios.</p> </div> </div> <form name=createTraining novalidate> <div class=\"row blanco p-v\"> <div class=\"col-md-8 p-h-lg m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> </div> <div class=row> <div class=col-md-4> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.title)> <label for=title class=control-label>Nombre(*)</label> <input type=text name=title ng-model=createTrainingVm.title ng-model-options=\"{ debounce: 300 }\" maxlength=200 class=form-control required> <div class=control-label ng-messages=createTraining.title.$error ng-show=createTrainingVm.showErrorMessages(createTraining.title)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group> <label for=spaceType class=control-label>Tipo de actividad formativa</label> <select name=spaceType ng-model=createTrainingVm.spaceType ng-options=\"type.idListItem as type.listItemName for type in createTrainingVm.listSpaceType\" class=form-control ng-change=createTrainingVm.onActivityTypeChanged(createTrainingVm.spaceType)> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.link)> <label for=link class=control-label>Enlace de actividad formativa</label> <input type=url name=link ng-model=createTrainingVm.link class=form-control placeholder=https://www.example.com> <div class=control-label ng-messages=createTraining.link.$error ng-show=createTrainingVm.showErrorMessages(createTraining.link)> <div ng-message=pattern class=text-xs>El enlace no es válido.</div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.description)> <label for=description class=control-label>Descripción y justificación(*)</label> <md-input-container class=control-label> <textarea name=description ng-model=createTrainingVm.description rows=5 maxlength=500 md-maxlength=500 class=form-control required ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createTraining.description.$error ng-show=createTrainingVm.showErrorMessages(createTraining.description)> <div ng-message=required class=text-xs>La descripción es requerida.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.results)> <label for=results class=control-label>Resultados esperados(*)</label> <md-input-container class=control-label> <textarea name=results ng-model=createTrainingVm.results rows=5 maxlength=500 md-maxlength=500 class=form-control required ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createTraining.results.$error ng-show=createTrainingVm.showErrorMessages(createTraining.results)> <div ng-message=required class=text-xs>Los resultados esperados son requeridos.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Cantidad de estudiantes</h5> </div> </div> <div class=row> <div class=col-md-4> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.preg)> <label for=preg class=control-label>Pregrado<span ng-if=createTrainingVm.amountOfStudentsRequired>(*)</span></label> <input type=number name=preg ng-model=createTrainingVm.preg min=1 class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-change=createTrainingVm.checkStudents() ng-required=createTrainingVm.amountOfStudentsRequired onpaste=return!1> <div class=control-label ng-messages=createTraining.preg.$error ng-show=createTrainingVm.showErrorMessages(createTraining.preg)> <div ng-message=min class=text-xs>Ingrese al menos un estudiante de pregrado</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.postg)> <label for=postg class=control-label>Postgrado<span ng-if=createTrainingVm.amountOfStudentsRequired>(*)</span></label> <input type=number name=postg ng-model=createTrainingVm.postg ng-change=createTrainingVm.checkStudents() min=1 class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-required=createTrainingVm.amountOfStudentsRequired onpaste=return!1> <div class=control-label ng-messages=createTraining.postg.$error ng-show=createTrainingVm.showErrorMessages(createTraining.postg)> <div ng-message=min class=text-xs>Ingrese al menos un estudiante de postgrado</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.doct)> <label for=doct class=control-label>Doctorado<span ng-if=createTrainingVm.amountOfStudentsRequired>(*)</span></label> <input type=number name=doct ng-model=createTrainingVm.doct ng-change=createTrainingVm.checkStudents() min=1 class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-required=createTrainingVm.amountOfStudentsRequired onpaste=return!1> <div class=control-label ng-messages=createTraining.doct.$error ng-show=createTrainingVm.showErrorMessages(createTraining.doct)> <div ng-message=min class=text-xs>Ingrese al menos un estudiante de doctorado</div> </div> </div> </div> <div class=col-md-12> <div ng-if=createTrainingVm.amountOfStudentsRequired class=\"text-xs text-rojo left\"> Al menos un tipo de estudiante es obligatorio. </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.hours)> <label for=hours class=control-label>Horas Planeadas</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Estime las horas que dedicará a la propuesta <br/> en el período de tiempo seleccionado. </md-tooltip> </i> <input type=number min=0 name=hours ng-model=createTrainingVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createTraining.hours.$error ng-show=createTrainingVm.showErrorMessages(createTraining.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-6 p-t-lg no-padding-l\"> <div class=\"col-md-12 m-t-xs text-left\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createTrainingVm.notification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> <div class=\"row p-t\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel left\" ui-sref=workplan.trainingResearch>Cancelar</md-button> </div> <div class=\"col-md-6 text-right no-padding-r\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createTrainingVm.addTraining(false) ng-disabled=\"createTrainingVm.isSaveButtonDisabled || createTrainingVm.validateForm(createTraining)\"> Guardar formación</md-button> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createTrainingVm.updateRangeData(value) type-period=createTrainingVm.typePeriod form-reference=createTraining toggle-range=createTrainingVm.updateRangeType(type) range-type=createTrainingVm.rangeType start-date=createTrainingVm.dt_start end-date=createTrainingVm.dt_end periods-array=createTrainingVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 624 */
621,
/* 625 */
/***/ (function(module, exports) {

	module.exports = " <div ng-include=\"'customStyle'\"></div> <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Transferencia de resultados</h3> <p class=text-16-important>En este espacio podrá visualizar y añadir solicitudes para realizar actividades relacionadas con la transferencia de resultados de investigación, como redacción de patentes, constitución de Spin-Offs, registro de metodologías, entre otras.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"resultsTransferVm.feedback && !resultsTransferVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=resultsTransferVm.bitacora($event)> Bitácora de Transferencia de resultados </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=resultsTransferListSearch class=form-control placeholder=\"Buscar transferencia de resultados\" ng-model-options=\"{ debounce: 300 }\" ng-change=resultsTransferVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <slick class=\"slider single-item\" current-index=index ng-if=\"resultsTransferVm.transfers.length && resultsTransferVm.viewLoaded &&\n      (resultsTransferVm.transfers | filter: resultsTransferListSearch).length != 0\" responsive=resultsTransferVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemResultsTransfer in resultsTransferVm.transfers | filter: resultsTransferListSearch\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5\" ng-class=resultsTransferVm.gradRoleClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemResultsTransfer.name}}</p> </div> <div class=\"row m-t-md\" ng-class=classPlanning has-permission=transferencia-de-resultados-edit> <div class=col-md-6> <a href ui-sref=\"workplan.createResultsTransfer({workplanTeacherActivityId: itemResultsTransfer.workplanTeacherActivityId})\" class=icon> <span class=\"icon i-28 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href ng-click=resultsTransferVm.confirmDeleteTransfer(itemResultsTransfer) class=icon> <span class=\"icon i-28 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-8\"> <p class=\"text-gris-dark exo\">Descripción</p> <p class=\"no-padding fix-max-height detail\">{{itemResultsTransfer.description}}</p> <div ng-if=\"itemResultsTransfer.timeRangeTypeId == 1\"> <p class=\"text-gris-dark exo\">Período</p> <p class=\"no-padding fix-max-height detail\">{{itemResultsTransfer.periodName}}</p> </div> <div ng-if=\"itemResultsTransfer.timeRangeTypeId == 2\"> <p class=\"text-gris-dark exo\">Fecha inicio - fin</p> <p class=\"no-padding fix-max-height detail\">{{itemResultsTransfer.startDate}} - {{itemResultsTransfer.endDate}}</p> </div> </div> </div> </div> </slick> <div class=\"col-md-12 p-v text-center\" has-permission=transferencia-de-resultados-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createResultsTransfer ng-disabled=resultsTransferVm.planningFinish>Agregar solicitud de tiempo para desarrollo de actividades de transferencia</button> </div> </div> </div> </div>";

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = "<div ng-include=\"'customStyle'\"></div> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Transferencia de resultados - {{createTransferVm.createOrEdit}} solicitud de tiempo para desarrollo de actividades de transferencia</h3> <p class=text-xs ng-if=!createTransferVm.isEditing>Diligencie los datos en el siguiente formulario para agregar una transferencia nueva. Los campos con (*) son obligatorios.</p> <p class=text-xs ng-if=createTransferVm.isEditing>Edite los datos en el siguiente formulario para modificar la transferencia de resultados. Los campos con (*) son obligatorios.</p> </div> </div> <form name=createResultTransfer novalidate> <div class=\"row blanco p-v\"> <div class=\"col-md-8 p-h-lg m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=col-md-11> <div class=\"row gutter-10 m-t-xs\"> <div class=col-md-6> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.title)> <label for=title class=control-label>Nombre(*)</label> <input type=text name=title ng-model=createTransferVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createResultTransfer.title.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.title)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=col-md-6> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.resultsType)> <label for=resultsType class=control-label>Tipo de resultados suceptible de transferencia(*)</label> <select name=resultsType ng-model=createTransferVm.resultsType ng-options=\"source.idListItem as source.listItemName for source in createTransferVm.listResultsType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createResultTransfer.resultsType.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.resultsType)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> </div> <div class=\"row m-t-xs\"> <div class=col-md-12> <div class=\"form-group no-margin\" ng-class=createTransferVm.hasError(createResultTransfer.description)> <label for=description class=control-label>Descripción de la actividad de transferencia(*)</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createTransferVm.description rows=5 maxlength=500 md-maxlength=500 class=form-control required ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createResultTransfer.description.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.description)> <div ng-message=required class=text-xs>La descripción es requerida.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=col-md-3> <label for=hours class=control-label>Horas Planeadas</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Estime las horas que dedicará a la propuesta <br/> en el período de tiempo seleccionado. </md-tooltip> </i> <input type=number min=0 name=hours ng-model=createTransferVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> </div> <div class=\"col-md-6 p-lg\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createTransferVm.notification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> <div class=\"col-md-11 p-t\"> <div class=row> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel left\" ui-sref=workplan.resultsTransfer>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createTransferVm.addTransfer(false) ng-disabled=\"createTransferVm.validateForm(createResultTransfer) || createTransferVm.buttonDisabled\"> Guardar transferencia</md-button> </div> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createTransferVm.updateRangeData(value) type-period=createTransferVm.typePeriod form-reference=createResultTransfer toggle-range=createTransferVm.updateRangeType(type) range-type=createTransferVm.rangeType start-date=createTransferVm.dt_start end-date=createTransferVm.dt_end periods-array=createTransferVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.projectProposalFormulation', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/projectFormulation',
	    template: __webpack_require__(628),
	    controller: 'ProjectFormulationProposalsListCtrl',
	    controllerAs: 'projectVM',
	    data: {
	      displayName: 'Formulación de propuesta',
	      title: 'Extensión y visibilidad',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.extensionAndVisibility', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/projectFormulation',
	    template: __webpack_require__(628),
	    controller: 'ProjectFormulationProposalsListCtrl',
	    controllerAs: 'projectVM',
	    data: {
	      displayName: 'Extensión y visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 2,
	      siblings: [{
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createProjectFormulationProposal', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/createProjectFormulationProposal/:workplanTeacherActivityId',
	    template: __webpack_require__(629),
	    controller: 'CreateProjectFormulationProposalCtrl',
	    controllerAs: 'createProjectFormulationProposalVm',
	    data: {
	      displayName: 'Formulación de propuesta',
	      title: 'Extensión y visibilidad',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.extensionProjects', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/extensionProjects',
	    template: __webpack_require__(630),
	    controller: 'ExtensionProjectsListCtrl',
	    controllerAs: 'extensionVM',
	    data: {
	      displayName: 'Proyectos de extensión',
	      title: 'Extensión y visibilidad',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createExtensionProject', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/createExtensionProject/:workplanTeacherActivityId',
	    template: __webpack_require__(631),
	    controller: 'CreateExtensionProjectCtrl',
	    controllerAs: 'createExtensionProjectVm',
	    data: {
	      displayName: 'Proyectos de extensión',
	      title: 'Extensión y visibilidad',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.visibilityAndComunication', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/visibilityAndComunication',
	    template: __webpack_require__(632),
	    controller: 'VisibilityListCtrl',
	    controllerAs: 'visibilityVM',
	    data: {
	      displayName: 'Visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createVisibility', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/createVisibility/:workplanTeacherActivityId',
	    template: __webpack_require__(633),
	    controller: 'CreateVisibilityCtrl',
	    controllerAs: 'createVisibilityVm',
	    data: {
	      displayName: 'Visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.counselingAndConsultancy', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/counselingAndConsultancy',
	    views: {
	      '': {
	        template: __webpack_require__(634)
	      },
	      'principal@': {
	        template: __webpack_require__(635),
	        controller: 'CounselingAndConsultancyListCtrl',
	        controllerAs: 'counselingAndConsultancyVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Consultoría y asesoría',
	      title: 'Extensión y Visibilidad',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createCounselingAndConsultancy', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/createCounselingAndConsultancy/:workplanTeacherActivityId',
	    template: __webpack_require__(636),
	    controller: 'CreateCounselingAndConsultancyCtrl',
	    controllerAs: 'createCounselingAndConsultancyVm',
	    data: {
	      displayName: 'Consultoría y asesoría',
	      title: 'Extensión y Visibilidad',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.shortCourses',
	        order: 6
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.shortCourses', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/shortCourses',
	    views: {
	      '': {
	        template: __webpack_require__(637)
	      },
	      'principal@': {
	        template: __webpack_require__(638),
	        controller: 'ShortCoursesListCtrl',
	        controllerAs: 'shortCoursesVm'
	      },
	      'indicators@': {
	        template: __webpack_require__(579),
	        controller: 'IndicatorsCtrl',
	        controllerAs: 'indicatorsVm'
	      }
	    },
	    data: {
	      displayName: 'Educación continuada',
	      order: 6,
	      title: 'Extension y Visibilidad',
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.createShortCourses', {
	    moduleId: _globalConfig2.default.modules.extentionAndVisibility,
	    abstract: false,
	    url: '/extensionVisibility/createShortCourses/:workplanTeacherActivityId',
	    template: __webpack_require__(639),
	    controller: 'CreateShortCoursesCtrl',
	    controllerAs: 'createShortCourseVm',
	    data: {
	      displayName: 'Educación continuada',
	      title: 'Extensión y Visibilidad',
	      order: 6,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.projectProposalFormulation',
	        order: 2
	      }, {
	        name: 'workplan.extensionProjects',
	        order: 3
	      }, {
	        name: 'workplan.visibilityAndComunication',
	        order: 4
	      }, {
	        name: 'workplan.counselingAndConsultancy',
	        order: 5
	      }, {
	        name: 'workplan.history',
	        order: 7
	      }]
	    },
	    params: {
	      indicatorType: _globalConfig2.default.indicatorsType.extension,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  });
	}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-md-12> <div ng-include=\"'header-proposals'\"></div> </div> </div> <div class=\"row blanco\"> <div class=col-xs-12> <div ng-include=\"'proposals-list'\"></div> <div ng-include=\"'proposals-details'\"></div> </div> </div> ";

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Formulaci&oacute;n de proyectos de extensi&oacute;n - {{createProjectFormulationProposalVm.createOrEdit}} propuesta</h3> <p class=text-xs>Diligencie los datos en el siguiente formulario para agregar una nueva propuesta de proyecto de extensi&oacute;n. Los campos con (*) son obligatorios.</p> </div> </div> <form name=newProjectFormulationProposal novalidate> <div class=\"blanco row\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del proyecto</h5> </div> <div class=\"col-md-12 no-padding-r\"> <div class=\"col-md-12 no-padding-l\"> <div class=\"col-md-4 no-padding-l\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.title)> <label for=title class=control-label>T&iacute;tulo de propuesta *</label> <input type=text name=title ng-model=createProjectFormulationProposalVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=newProjectFormulationProposal.title.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-l\"> <div class=form-group> <label for=potentialAllies class=control-label>Aliados potenciales</label> <input type=text name=potentialAllies ng-model=createProjectFormulationProposalVm.potentialAllies ng-model-options=\"{ debounce: 300 }\" class=form-control> </div> </div> <div class=\"col-md-4 no-padding-l\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.projectType)> <label for=projectType class=control-label>Tipo de proyecto *</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Los proyectos de Programa/Facultad/Escuela son los que se formulan <br/> desde las Unidades Académicas en relación con sus prioridades o actividades propias. <br/> Puede ser una iniciativa de los profesores, de los estudiantes o de su trabajo mancomunado. <br/> Los proyectos de Responsabilidad Social vinculan voluntariado y <br/>atención a comunidades en situación de vulnerabilidad. </md-tooltip> </i> <select name=projectType ng-model=createProjectFormulationProposalVm.projectType ng-options=\"source.idListItem as source.listItemName for source in createProjectFormulationProposalVm.projectTypes\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=newProjectFormulationProposal.projectType.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.projectType)> <div ng-message=required class=text-xs>El tipo de proyecto es requerido.</div> </div> </div> </div> </div> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=form-group> <label class=control-label>Financiadores</label> <div class=col-md-12> <label class=\"m-r-sm text-sm\" ng-repeat=\"financier in createProjectFormulationProposalVm.financiers\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectFormulationProposalVm.selectedFinancier[financier.financialId] ng-value=financier.financialId name=financier ng-change=\"createProjectFormulationProposalVm.funSelectedFinancier(financier, createProjectFormulationProposalVm.selectedFinancier[financier.financialId])\"> {{financier.financialName}} </md-checkbox> </label> </div> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.observation)> <label for=observation class=control-label>Objetivo *</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Señale el objetivo de su proyecto, la forma en que procederá, <br/> la población (si aplica), la posible fuente de financiación <br/> y los resultados esperados. </md-tooltip> </i> <md-input-container class=control-label> <textarea type=text name=observation maxlength=500 md-maxlength=500 ng-model=createProjectFormulationProposalVm.observation class=form-control required rows=4 ng-model-options=\"{ debounce: 300 }\">\n              </textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=newProjectFormulationProposal.observation.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.observation)> <div ng-message=required class=text-xs>El objetivo es requerido.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-6 no-padding-l\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.summary)> <label for=summary class=control-label>Resumen *</label> <md-input-container class=\"control-label no-margin\"> <textarea type=text name=summary ng-model=createProjectFormulationProposalVm.summary class=form-control required rows=4 maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\" style=margin-top:5px ;></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=newProjectFormulationProposal.summary.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.summary)> <div ng-message=required class=text-xs>El resumen es requerido.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.hoursPlanned)> <label for=hoursPlanned class=control-label>Horas Planeadas</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Registrar el número de horas que se dedicará a construir la propuesta <br/> y no el número de horas para el desarrollo de la misma. </md-tooltip> </i> <input type=number min=0 name=hoursPlanned ng-model=createProjectFormulationProposalVm.hoursPlanned onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" class=form-control onpaste=return!1> <div class=control-label ng-messages=newProjectFormulationProposal.hoursPlanned.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.hoursPlanned)> <div ng-message=required class=text-xs>Las horas planeadas son requeridas.</div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.projectProposalFormulation>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success no-margin left\" ng-click=createProjectFormulationProposalVm.addProjectFormulationProposal(false) ng-disabled=\"createProjectFormulationProposalVm.isSaveButtonDisabled || createProjectFormulationProposalVm.validateForm(newProjectFormulationProposal)\"> Guardar propuesta</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createProjectFormulationProposalVm.updateRangeData(value) type-period=createProjectFormulationProposalVm.typePeriod form-reference=newProjectFormulationProposal toggle-range=createProjectFormulationProposalVm.updateRangeType(type) range-type=createProjectFormulationProposalVm.rangeType start-date=createProjectFormulationProposalVm.dt_start end-date=createProjectFormulationProposalVm.dt_end periods-array=createProjectFormulationProposalVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-md-12> <div ng-include=\"'extension-header-projects'\"></div> </div> <div class=\"col-md-12 blanco\"> <div ng-include=\"'extension-projects-list'\"></div> <div ng-include=\"'extension-projects-details'\"></div> </div> </div> ";

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Proyectos de extensi&oacute;n - Agregar proyecto interno</h3> <p class=text-xs>Diligencie los datos en el siguiente formulario para agregar una nueva propuesta de proyecto de extensi&oacute;n. Los campos con (*) son obligatorios.</p> </div> </div> <form name=newExtensionProject novalidate> <div class=\"row blanco\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del proyecto</h5> </div> </div> <div class=row> <div class=col-md-9> <div class=row> <div class=col-md-6> <div class=form-group ng-class=createExtensionProjectVm.hasError(newExtensionProject.docProjectType)> <label for=docProjectType class=control-label>Tipo de proyecto *</label> <select name=docProjectType ng-model=createExtensionProjectVm.projectType ng-options=\"source.idListItem as source.listItemName for source in createExtensionProjectVm.projectTypes\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=newExtensionProject.docProjectType.$error ng-show=createExtensionProjectVm.showErrorMessages(newExtensionProject.docProjectType)> <div ng-message=required class=text-xs>El tipo de proyecto es requerido.</div> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=docProjectRole class=control-label>Rol en el proyecto</label> <select name=docProjectRole ng-model=createExtensionProjectVm.projectRole ng-options=\"source.idListItem as source.listItemName for source in createExtensionProjectVm.projectRoles\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=form-group ng-class=createExtensionProjectVm.hasError(newExtensionProject.docTitle)> <label for=docTitle class=control-label>T&iacute;tulo de proyecto *</label> <input type=text name=docTitle ng-model=createExtensionProjectVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=newExtensionProject.docTitle.$error ng-show=createExtensionProjectVm.showErrorMessages(newExtensionProject.docTitle)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group> <label for=docAssocProposal class=control-label>Propuesta asociada</label> <select name=docAssocProposal ng-model=createExtensionProjectVm.assocProposal ng-options=\"source.workplanTeacherActivityId as source.titleProject for source in createExtensionProjectVm.assocProposals\" class=form-control> <option value=\"\">Sin Propuesta Asignada</option> </select> </div> </div> <div class=col-md-6> <div class=form-group> <label for=docAcUnit class=control-label>Unidad acad&eacute;mica</label> <select name=docAcUnit ng-model=createExtensionProjectVm.acUnit ng-options=\"source.id_code as source.ds_name for source in createExtensionProjectVm.acUnits\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> </div> </div> <div class=col-md-3> <div class=form-group> <label class=control-label>Financiadores</label> <div class=col-md-12> <label class=\"m-r-sm text-sm\" ng-repeat=\"financier in createExtensionProjectVm.financiers\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createExtensionProjectVm.selectedFinancier[financier.financialId] ng-value=financier.financialId name=financier ng-change=\"createExtensionProjectVm.funSelectedFinancier(financier, createExtensionProjectVm.selectedFinancier[financier.financialId])\"> {{financier.financialName}} </md-checkbox> </label> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=\"form-group no-margin\" ng-class=createExtensionProjectVm.hasError(newExtensionProject.docAbstract)> <label for=docAbstract class=control-label>Descripci&oacute;n *</label> <md-input-container class=control-label> <textarea type=text name=docAbstract ng-model=createExtensionProjectVm.description ng-model-options=\"{ debounce: 300 }\" class=form-control required rows=4 maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=newExtensionProject.docAbstract.$error ng-show=createExtensionProjectVm.showErrorMessages(newExtensionProject.docAbstract)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> <div class=row> <div class=col-md-12> <label class=control-label>¿Con qué horas planeadas/ejecutadas desea trabajar?</label> </div> </div> <div class=row> <div class=\"col-md-6 form-group p-l-lg\"> <div class=\"radio-options no-margin\"> <input type=radio name=presencial ng-model=createExtensionProjectVm.hoursChildren value=0> <i class=radio-green></i> <label class=text-xs>Horas generales del proyecto</label> </div> </div> <div class=\"col-md-6 form-group\"> <div class=\"radio-options no-margin\"> <input type=radio name=presencial ng-model=createExtensionProjectVm.hoursChildren value=1> <i class=radio-green></i> <label class=text-xs>Horas por actividades hijas</label> </div> </div> </div> <div class=row> <div class=col-md-4 ng-show=\"createExtensionProjectVm.hoursChildren == 0\"> <label for=docHours class=control-label>Horas Planeadas</label> <input type=number min=0 name=docHours ng-model=createExtensionProjectVm.plannedHours onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" class=form-control onpaste=return!1> </div> </div> <div class=\"row p-t\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.extensionProjects>Cancelar</md-button> </div> <div class=\"col-md-6 text-right no-padding-r\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createExtensionProjectVm.addExtensionProject(false) ng-disabled=\"createExtensionProjectVm.isSaveButtonDisabled || createExtensionProjectVm.validateForm(newExtensionProject)\"> Guardar proyecto</md-button> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createExtensionProjectVm.updateRangeData(value) type-period=createExtensionProjectVm.typePeriod form-reference=newExtensionProject toggle-range=createExtensionProjectVm.updateRangeType(type) range-type=createExtensionProjectVm.rangeType start-date=createExtensionProjectVm.dt_start end-date=createExtensionProjectVm.dt_end periods-array=createExtensionProjectVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-xs-12> <div ng-include=\"'visibility-header'\"></div> </div> <div class=\"col-md-12 blanco\"> <div ng-include=\"'visibility-list'\"></div> <div ng-include=\"'visibility-details'\"></div> </div> </div> ";

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Comunicación y visibilidad - Agregar registro</h3> </div> </div> <form name=createVisibility novalidate> <div class=\"row blanco\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Tipo de registro</h5> </div> </div> <div class=row> <div class=col-md-12> <label for=registryType class=control-label>Seleccione el tipo de registro que desea agregar</label> </div> </div> <div class=\"row p-h-md\"> <div class=\"col-md-3 p-h-xs\"> <div class=\"radio-options no-margin\"> <input type=radio name=registryType ng-model=createVisibilityVm.registryType value=1 ng-disabled=createVisibilityVm.isEditing> <i class=radio-green></i> <label class=text-xs>Medios de comunicación</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=registryType ng-model=createVisibilityVm.registryType value=2 ng-disabled=createVisibilityVm.isEditing> <i class=radio-green></i> <label class=text-xs>Redes, asociaciones y relaciones interinstitucionales</label> </div> </div> <div class=\"col-md-3 p-h-xs\"> <div class=\"radio-options no-margin\"> <input type=radio name=registryType ng-model=createVisibilityVm.registryType value=3 ng-disabled=createVisibilityVm.isEditing> <i class=radio-green></i> <label class=text-xs>Organización de eventos</label> </div> </div> </div> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=\"col-md-8 no-padding-r\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.title)> <div ng-if=\"createVisibilityVm.registryType == 1\"> <label for=title class=control-label>Nombre del medio *</label> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <label for=title class=control-label>Nombre de la red y/o asociación *</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\"><md-tooltip md-direction=bottom>Ingrese el nombre de la red o asociación con la que está o estará realizando actividades.</md-tooltip></i> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <label for=title class=control-label>Nombre *</label> </div> <input type=text name=title ng-model=createVisibilityVm.title class=form-control ng-model-options=\"{ debounce: 300 }\" maxlength=45 required> <div class=control-label ng-messages=createVisibility.title.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.title)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=col-md-4> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaKindType)> <label for=mediaKindType class=control-label>Tipo *</label> <select name=mediaKindType ng-model=createVisibilityVm.mediaKindType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaKind\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaKindType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaKindType)> <div ng-message=required class=text-xs>El tipo es requerido.</div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2 || createVisibilityVm.registryType == 3\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.networkAssocInterInstitRelatAmbitStageType)> <label for=networkAssocInterInstitRelatAmbitStageType class=control-label>Ámbito/Escenario *</label> <select name=networkAssocInterInstitRelatAmbitStageType ng-model=createVisibilityVm.networkAssocInterInstitRelatAmbitStageType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeNetworkAssocInterInstitRelatAmbitStage\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatAmbitStageType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.networkAssocInterInstitRelatAmbitStageType)> <div ng-message=required class=text-xs>El &aacute;mbito/escenario es requerido.</div> </div> </div> </div> </div> </div> <div class=row> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaRolType)> <label for=mediaRolType class=control-label>Rol *</label> <select name=mediaRolType ng-model=createVisibilityVm.mediaRolType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaRol\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaRolType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaRolType)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.networkAssocInterInstitRelatSectorType)> <label for=networkAssocInterInstitRelatSectorType class=control-label>Sector *</label> <select name=networkAssocInterInstitRelatSectorType ng-model=createVisibilityVm.networkAssocInterInstitRelatSectorType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeSector\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatSectorType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.networkAssocInterInstitRelatSectorType)> <div ng-message=required class=text-xs>El sector es requerido.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.eventOrganizationUnity)> <label for=eventOrganizationUnity class=control-label>Unidad *</label> <select name=eventOrganizationUnity ng-model=createVisibilityVm.eventOrganizationUnity ng-options=\"unit.academitUnitId as unit.academitUnitName for unit in createVisibilityVm.arrayUnit\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.eventOrganizationUnity.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.eventOrganizationUnity)> <div ng-message=required>La unidad es requerida</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 1 || createVisibilityVm.registryType == 2\"> <div class=col-md-6> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaURL)> <label for=mediaURL class=control-label>URL</label> <input type=url name=mediaURL ng-model=createVisibilityVm.mediaURL class=form-control placeholder=https://www.example.com> <div class=control-label ng-messages=createVisibility.mediaURL.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaURL)> <div ng-message=url class=text-xs>La url no es válida. Ej: \"https://www.example.com\"</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <div class=col-md-4> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.eventOrganizationContact)> <label for=eventOrganizationContact class=control-label>Contacto *</label> <input type=text name=eventOrganizationContact ng-model=createVisibilityVm.networkAssocInterInstitRelatContactName ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createVisibility.eventOrganizationContact.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.eventOrganizationContact)> <div ng-message=required class=text-xs> El contacto es requerido. </div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.eventOrganizationLink)> <label for=eventOrganizationLink class=control-label>Enlace</label> <input type=url name=eventOrganizationLink ng-model=createVisibilityVm.mediaURL class=form-control placeholder=https://www.example.com> <div class=control-label ng-messages=createVisibility.eventOrganizationLink.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.eventOrganizationLink)> <div ng-message=required class=text-xs>El enlace es requerido.</div> <div ng-message=valid class=text-xs>El enlace no es válido. Ej: \"https://www.example.com\"</div> </div> </div> </div> </div> </div> <div class=row> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaFrequencyOfEmissionType)> <label for=mediaFrequencyOfEmissionType class=control-label>Frecuencia de emisi&oacute;n *</label> <select name=mediaFrequencyOfEmissionType ng-model=createVisibilityVm.mediaFrequencyOfEmissionType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaFrequencyOfEmissionType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaFrequencyOfEmissionType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaFrequencyOfEmissionType)> <div ng-message=required class=text-xs>La frecuencia de emisi&oacute;n es requerida.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=\"{'has-error' :createVisibility.networkAssocInterInstitRelatEmail.$invalid && (createVisibility.networkAssocInterInstitRelatEmail.$dirty || createVisibility.networkAssocInterInstitRelatEmail.$touched)}\"> <label for=networkAssocInterInstitRelatEmail class=control-label>Correo electr&oacute;nico *</label> <input type=email name=networkAssocInterInstitRelatEmail ng-model=createVisibilityVm.networkAssocInterInstitRelatEmail class=form-control ng-pattern=createVisibilityVm.regex required> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatEmail.$error ng-show=\"createVisibility.networkAssocInterInstitRelatEmail.$dirty || createVisibility.networkAssocInterInstitRelatEmail.$touched\"> <div ng-message=required class=text-xs>El correo electr&oacute;nico es requerido.</div> <div ng-message=pattern class=text-xs>El formato del correo electr&oacute;nico no es v&aacute;lido.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=col-md-6> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaPublicAudienceType)> <label for=mediaPublicAudienceType class=control-label>Audiencia p&uacute;blicos *</label> <select name=mediaPublicAudienceType ng-model=createVisibilityVm.mediaPublicAudienceType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaPublicAudience\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaPublicAudienceType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaPublicAudienceType)> <div ng-message=required class=text-xs>La audiencia p&uacute;blicos es requerida.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <div class=col-md-6> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.networkAssocInterInstitRelatContactName)> <label for=networkAssocInterInstitRelatContactName class=control-label>Nombre del contacto *</label> <input type=text name=networkAssocInterInstitRelatContactName ng-model=createVisibilityVm.networkAssocInterInstitRelatContactName ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatContactName.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.networkAssocInterInstitRelatContactName)> <div ng-message=required class=text-xs>El nombre del contacto es requerido.</div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 no-padding-r\"> <div class=\"form-group no-margin\" ng-class=createVisibilityVm.hasError(createVisibility.mediaDescription)> <div ng-if=\"createVisibilityVm.registryType == 1 || createVisibilityVm.registryType == 2\"> <label for=mediaDescription class=control-label>Descripci&oacute;n *</label> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info> <md-tooltip md-direction=bottom class=\"tooltip-multiline text-left\"> Describa brevemente las características, propósitos, origen <br> y naturaleza de la red o asociación y su vinculación con ella. </md-tooltip> </i> </div> <label ng-if=\"createVisibilityVm.registryType == 3\" for=mediaDescription class=control-label> Objetivo/Descripci&oacute;n </label> <md-input-container class=\"control-label no-margin\"> <textarea name=mediaDescription ng-model=createVisibilityVm.mediaDescription rows=3 maxlength=500 md-maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createVisibility.mediaDescription.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaDescription)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> <div class=row> <div class=col-md-4> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.plannedHours)> <label for=plannedHours class=control-label>Horas Planeadas</label> <input type=number min=0 name=plannedHours ng-model=createVisibilityVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createVisibility.plannedHours.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.plannedHours)> <div ng-message=required class=text-xs>Las horas planeadas son requeridas.</div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.visibilityAndComunication>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createVisibilityVm.addVisibility(false) ng-disabled=\"createVisibilityVm.isSaveButtonDisabled || createVisibilityVm.validateForm(createVisibility)\"> Guardar</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createVisibilityVm.updateRangeData(value) type-period=createVisibilityVm.typePeriod form-reference=createVisibility toggle-range=createVisibilityVm.updateRangeType(type) range-type=createVisibilityVm.rangeType start-date=createVisibilityVm.dt_start end-date=createVisibilityVm.dt_end periods-array=createVisibilityVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 634 */
577,
/* 635 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Consultor&iacute;a y asesor&iacute;a</h3> <p class=text-16-important> Ingrese las asesor&iacute;as o consultor&iacute;as que quiere ofrecer. Repita este procedimiento para cada uno de las propuestas. </p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"counselingAndConsultancyVm.feedback && !counselingAndConsultancyVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=counselingAndConsultancyVm.bitacora($event)> Bitácora de Consultoría y asesoría </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=counselingAndConsultancyVm.counselingFilter class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar asesoria\" ng-change=counselingAndConsultancyVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-lg\"> <div class=col-md-12> <slick class=\"slider single-item\" current-index=index ng-if=\"counselingAndConsultancyVm.dataList.length && counselingAndConsultancyVm.viewLoaded\" responsive=counselingAndConsultancyVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemCounselingConsultancy in counselingAndConsultancyVm.dataList | filter: counselingAndConsultancyVm.counselingFilter\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5\" ng-class=counselingAndConsultancyVm.gradRoleClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemCounselingConsultancy.name}}</p> </div> <div class=\"col-md-12 no-padding\"> <label class=text-xs>{{itemCounselingConsultancy.entity}}</label> </div> <div class=\"row p-t-md\" has-permission=consultoria-y-asesoria-edit ng-class=classPlanning> <div class=col-md-6> <a href ui-sref=\"workplan.createCounselingAndConsultancy({workplanTeacherActivityId: itemCounselingConsultancy.workplanTeacherActivityId})\" class=icon ng-disabled=counselingAndConsultancyVm.planningFinish> <span class=\"icon i-24 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href ng-click=counselingAndConsultancyVm.confirmDeleteCounseling(itemCounselingConsultancy) class=icon ng-disabled=counselingAndConsultancyVm.planningFinish> <span class=\"icon i-24 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-8\"> <p class=\"text-md text-gris-dark exo no-margin\">Rol</p> <p class=\"no-padding fix-max-height detail\">{{itemCounselingConsultancy.itemRoleName}}</p> <p class=\"text-md text-gris-dark exo no-margin\">Sector</p> <p class=\"no-padding fix-max-height detail\">{{itemCounselingConsultancy.itemSectorName}}</p> <div ng-if=\"itemCounselingConsultancy.timeRangeTypeId == 1\"> <p class=\"text-md text-gris-dark exo no-margin\">Período</p> <p class=\"no-padding no-m-t fix-max-height detail\">{{itemCounselingConsultancy.periodicityName}}</p> </div> <div ng-if=\"itemCounselingConsultancy.timeRangeTypeId == 2\"> <p class=\"text-md text-gris-dark exo no-margin\">Fecha Inicio - Fin</p> <p class=\"no-padding no-m-t fix-max-height detail text-sm\">{{itemCounselingConsultancy.startDate}} - {{itemCounselingConsultancy.endDate}} </p> </div> </div> </div> </div> </slick> </div> </div> <div class=\"col-md-12 p-v text-center\" has-permission=consultoria-y-asesoria-edit> <button class=\"btn btn-fw btn-primary no-margin\" type=button ui-sref=workplan.createCounselingAndConsultancy ng-disabled=counselingAndConsultancyVm.planningFinish>Agregar consultoría/asesoría</button> </div> </div> ";

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Consultoría y asesoría - Agregar consultoría/asesoría</h3> </div> </div> <form name=createCounselingAndConsultancy novalidate> <div class=\"row blanco\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=col-md-12> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=row> <div class=col-md-12> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.nameCounselingConsultancy)> <label for=nameCounselingConsultancy class=control-label>Nombre de la asesoría/servicio *</label> <input type=text name=nameCounselingConsultancy ng-model=createCounselingAndConsultancyVm.nameCounselingConsultancy ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createCounselingAndConsultancy.nameCounselingConsultancy.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.nameCounselingConsultancy)> <div ng-message=required class=text-xs>El nombre de la asesoría/servicio es requerido.</div> </div> </div> </div> <div class=col-md-6> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.basicAreaOfKnowledgeType)> <label for=basicAreaOfKnowledgeType class=control-label>Área básica del conocimiento</label> <select name=basicAreaOfKnowledgeType ng-model=createCounselingAndConsultancyVm.basicAreaOfKnowledgeType ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.listsTypeBasicAreaOfKnowledge\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.basicAreaOfKnowledgeType.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.basicAreaOfKnowledgeType)> <div ng-message=required class=text-xs>El área básica del conocimiento es requerido.</div> </div> </div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.description)> <label for=description style=margin-bottom:2px class=control-label>Descripci&oacute;n *</label> <md-input-container style=margin-top:0 class=control-label> <textarea name=description ng-model=createCounselingAndConsultancyVm.description rows=2 maxlength=500 md-maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> <div class=\"control-label col-md-10 no-padding\" ng-messages=createCounselingAndConsultancy.description.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.description)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </md-input-container> </div> </div> <div class=col-md-6> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.productsDeliverables)> <label for=productsDeliverables style=margin-bottom:2px class=control-label>Productos/Entregables *</label> <md-input-container style=margin-top:0 class=control-label> <textarea name=productsDeliverables ng-model=createCounselingAndConsultancyVm.productsDeliverables rows=2 maxlength=500 md-maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> <div class=\"control-label col-md-10 no-padding\" ng-messages=createCounselingAndConsultancy.productsDeliverables.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.productsDeliverables)> <div ng-message=required class=text-xs>Los productos/entregables son requeridos.</div> </div> </md-input-container> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.source)> <label for=source class=control-label>Contratante *</label> <input type=text name=source ng-model=createCounselingAndConsultancyVm.source ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createCounselingAndConsultancy.source.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.source)> <div ng-message=required class=text-xs>El Contratante es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.companyEntityOrganization)> <label for=companyEntityOrganization class=control-label>Empresa/Entidad/Organizaci&oacute;n *</label> <input type=text name=companyEntityOrganization class=form-control ng-model=createCounselingAndConsultancyVm.companyEntityOrganization ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=createCounselingAndConsultancy.companyEntityOrganization.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.companyEntityOrganization)> <div ng-message=required class=text-xs>La empresa/entidad/organizaci&oacute;n es requerida.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.ambitStage)> <label for=ambitStage class=control-label>Ámbito/escenario</label> <select name=ambitStage ng-model=createCounselingAndConsultancyVm.ambitStage ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.listsTypeAmbitStage\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.ambitStage.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.ambitStage)> <div ng-message=required class=text-xs>El ámbito/escenario es requerido.</div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.sector)> <label for=sector class=control-label>Sector *</label> <select name=sector ng-model=createCounselingAndConsultancyVm.sector ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.sectorType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.sector.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.sector)> <div ng-message=required class=text-xs>El sector es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.rol)> <label for=rol class=control-label>Rol *</label> <select name=rol ng-model=createCounselingAndConsultancyVm.rol ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.rolType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.rol.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.rol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.docHours)> <label for=docHours class=control-label>Horas Planeadas</label> <input type=number min=0 name=docHours ng-model=createCounselingAndConsultancyVm.plannedHours onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" class=form-control onpaste=return!1> <div class=control-label ng-messages=createCounselingAndConsultancy.docHours.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.docHours)> <div ng-message=required class=text-xs>Las horas planeadas son requeridas.</div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.counselingAndConsultancy>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createCounselingAndConsultancyVm.addCounselingAndConsultancy(false) ng-disabled=\"createCounselingAndConsultancyVm.isSaveButtonDisabled || createCounselingAndConsultancyVm.validateForm(createCounselingAndConsultancy)\"> Guardar</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createCounselingAndConsultancyVm.updateRangeData(value) type-period=createCounselingAndConsultancyVm.typePeriod form-reference=createCounselingAndConsultancy toggle-range=createCounselingAndConsultancyVm.updateRangeType(type) range-type=createCounselingAndConsultancyVm.rangeType start-date=createCounselingAndConsultancyVm.dt_start end-date=createCounselingAndConsultancyVm.dt_end periods-array=createCounselingAndConsultancyVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 637 */
577,
/* 638 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-10> <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Educaci&oacute;n continuada</h3> <p class=text-16-important>Ingrese las actividades, eventos acad&eacute;micos y los cursos que quiere ofrecer a trav&eacute;s de Educación Continuada repita este procedimiento para cada uno de las propuestas.</p> </div> <div class=\"col-md-3 no-padding-r text-right\"> <md-button ng-if=\"shortCoursesVm.feedback && !shortCoursesVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=shortCoursesVm.bitacora($event)> Bitácora de Educación continuada </md-button> </div> </div> <div class=\"row search\"> <div class=\"col-md-12 p-h-lg\"> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=shortCoursesVm.shortCoursesFilter class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar cursos\" ng-change=shortCoursesVm.updateView()> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <div class=\"row m-h-lg\"> <div class=col-md-12> <slick class=\"slider single-item\" current-index=index ng-if=\"shortCoursesVm.listShortCourses.length && shortCoursesVm.viewLoaded\" responsive=shortCoursesVm.carouselResponsiveBreakpoints respond-to=min> <div class=p-sm ng-repeat=\"itemCourses in shortCoursesVm.listShortCourses | filter: shortCoursesVm.shortCoursesFilter\"> <div class=\"card horizontal no-margin\"> <div class=\"card-heading p-t text-center text-blanco col-md-5\" ng-class=shortCoursesVm.gradRoleClass> <div class=first-content> <p class=\"m-t text-md exo\">{{itemCourses.name}}</p> </div> <div class=\"row p-t-md\" ng-class=classPlanning has-permission=educacion-continua-edit> <div class=col-md-6> <a href ui-sref=\"workplan.createShortCourses({workplanTeacherActivityId: itemCourses.workplanTeacherActivityId})\" class=icon ng-disabled=shortCoursesVm.planningFinish> <span class=\"icon i-24 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href ng-click=shortCoursesVm.confirmDeleteShortCourse(itemCourses) class=icon ng-disabled=shortCoursesVm.planningFinish> <span class=\"icon i-24 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </div> </div> </div> <div class=\"card-body col-md-8\"> <p class=\"text-gris-dark exo no-m-b\">Modalidad</p> <p class=\"no-padding no-m-t fix-max-height detail\">{{itemCourses.itemModalityName}}</p> <p class=\"text-gris-dark exo no-m-b\">Rol</p> <p class=\"no-padding no-m-t fix-max-height detail\">{{itemCourses.itemRoleName}}</p> <p class=\"text-md text-gris-dark exo no-m-b\">{{itemCourses.timeRangeTypeName}}</p> <p class=\"text-xs no-padding no-margin fix-max-height detail\" ng-if=\"itemCourses.timeRangeTypeId == 1\"> {{itemCourses.periodicityName}} </p> <p class=\"text-xs no-padding no-margin fix-max-height detail\" ng-if=\"itemCourses.timeRangeTypeId == 2\"> {{itemCourses.startDate}} - {{itemCourses.endDate}} </p> <p class=\"text-gris-dark exo no-m-b\">Horas Planeadas</p> <p class=\"no-padding no-m-t fix-max-height detail\">{{itemCourses.hoursPlanned}}</p> </div> </div> </div> </slick> </div> </div> <div class=\"col-md-12 p-v text-center\"> <button class=\"btn btn-fw p-sm btn-primary no-margin\" type=button ui-sref=workplan.createShortCourses ng-disabled=shortCoursesVm.planningFinish>Agregar educación continuada</button> </div> </div> ";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Educaci&oacute;n continuada - Agregar educaci&oacute;n continuada</h3> </div> </div> <form name=createShortCourse novalidate> <div class=\"row blanco\" style=\"height:calc(100% - 110px)\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> </div> <div class=row> <div class=\"col-md-8 no-padding-r\"> <div class=form-group ng-class=createShortCourseVm.hasError(createShortCourse.courseName)> <label for=courseName class=control-label>Nombre *</label> <input type=text name=courseName ng-model=createShortCourseVm.name ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createShortCourse.courseName.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseName)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createShortCourseVm.hasError(createShortCourse.courseType)> <label for=courseType class=control-label>Tipo de curso *</label> <select name=courseType ng-model=createShortCourseVm.type ng-options=\"source.idListItem as source.listItemName for source in createShortCourseVm.listsTypeCourse\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createShortCourse.courseType.$error ng-show=createShortCourse.showErrorMessages(createShortCourse.courseType)> <div ng-message=required class=text-xs>El tipo de curso es requerido.</div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-8 no-padding-r\"> <div class=form-group ng-class=createShortCourseVm.hasError(createShortCourse.courseModality)> <label for=courseModality class=control-label>Modalidad del curso *</label> <select name=courseModality ng-model=createShortCourseVm.modality ng-options=\"source.idListItem as source.listItemName for source in createShortCourseVm.listModalities\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createShortCourse.courseModality.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseModality)> <div ng-message=required class=text-xs>La modalidad es requerido.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createShortCourseVm.hasError(createShortCourse.courseRol)> <label for=courseRol class=control-label>Rol *</label> <select name=courseRol ng-model=createShortCourseVm.rol ng-options=\"source.idListItem as source.listItemName for source in createShortCourseVm.listRoles\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createShortCourse.courseRol.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseRol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=\"form-group no-m-b\" ng-class=createShortCourseVm.hasError(createShortCourse.courseDescription)> <label for=courseDescription class=control-label>Objetivo/Descripci&oacute;n *</label> <md-input-container class=\"control-label no-margin\"> <textarea name=courseDescription ng-model=createShortCourseVm.description maxlength=500 md-maxlength=500 rows=2 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createShortCourse.courseDescription.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseDescription)> <div ng-message=required class=text-xs>La descrici&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=row> <div class=col-md-4> <div class=form-group ng-class=createShortCourseVm.hasError(createShortCourse.courseHours)> <label for=courseHours class=control-label>Horas Planeadas</label> <input type=number min=0 name=courseHours ng-model=createShortCourseVm.plannedHours onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" class=form-control onpaste=return!1> <div class=control-label ng-messages=createShortCourse.courseHours.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseHours)> <div ng-message=required class=text-xs>Las horas planeadas son requeridas.</div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ui-sref=workplan.shortCourses>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createShortCourseVm.addShortCourse(false) ng-disabled=\"createShortCourseVm.isSaveButtonDisabled || createShortCourseVm.validateForm(createShortCourse)\"> Guardar</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t\"> <period-picker on-change=createShortCourseVm.updateRangeData(value) type-period=createShortCourseVm.typePeriod form-reference=createShortCourse toggle-range=createShortCourseVm.updateRangeType(type) range-type=createShortCourseVm.rangeType start-date=createShortCourseVm.dt_start end-date=createShortCourseVm.dt_end periods-array=createShortCourseVm.periodsArray> </period-picker> </div> </div> </form> ";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  var stages = _globalConfig2.default.workplanStages;
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('fullscreen.workPlanReview', {
	    abstract: false,
	    tag: stages.review,
	    url: '/workplanReview',
	    template: '<list-panel></list-panel>',
	    data: {
	      displayName: 'Inicio',
	      label: 'Revisión'
	    }
	  }).state('fullscreen.workPlanApproval', {
	    abstract: false,
	    tag: stages.approval,
	    url: '/workplanApproval',
	    template: '<list-panel></list-panel>',
	    data: {
	      displayName: 'Inicio',
	      label: 'Aprobación'
	    }
	  }).state('fullscreen.workPlanExecution', {
	    abstract: false,
	    tag: stages.execution,
	    url: '/workplanExecution',
	    template: __webpack_require__(641),
	    controller: 'ExecutionCtrl',
	    controllerAs: 'executionVm',
	    data: {
	      displayName: 'Inicio',
	      label: 'Ejecución'
	    }
	  }).state('fullscreen.workPlanReviewExecution', {
	    abstract: false,
	    tag: stages.reviewExecution,
	    url: '/workplanReviewExecution',
	    template: '<list-panel></list-panel>',
	    data: {
	      displayName: 'Inicio',
	      label: 'Revisión de la ejecución'
	    }
	  }).state('fullscreen.workPlanEvaluation', {
	    abstract: false,
	    tag: stages.evaluation,
	    url: '/workplanEvaluation',
	    template: '<list-panel></list-panel>',
	    data: {
	      displayName: 'Inicio',
	      label: 'Evaluación'
	    }
	  }).state('fullscreen.workplanList', {
	    abstract: false,
	    tag: stages.consultant,
	    url: '/workplanList',
	    template: '<list-panel></list-panel>',
	    data: {
	      displayName: 'Inicio',
	      label: 'Planes de Trabajo'
	    }
	  }).state('workplan.history', {
	    abstract: false,
	    url: '/history',
	    template: '<history></history>',
	    data: {
	      displayName: 'Ver resumen',
	      title: 'Resumen',
	      order: 6,
	      siblings: [{
	        name: 'fullscreen.workPlanGeneralInformation',
	        order: 0
	      }, {
	        name: 'workplan.teaching',
	        order: 1
	      }, {
	        name: 'workplan.academicManagement',
	        order: 4
	      }, {
	        name: 'workplan.consolidationCP',
	        order: 5
	      }, {
	        name: 'workplan.investigation',
	        order: 2
	      }, {
	        name: 'workplan.extensionAndVisibility',
	        order: 3
	      }]
	    },
	    params: {
	      inHistory: true,
	      stage: _globalConfig2.default.workplanStages.planning
	    }
	  }).state('workplan.executionHistory', {
	    abstract: false,
	    url: '/historyExecution',
	    template: '<history></history>',
	    data: {
	      displayName: 'Ver resumen',
	      title: 'Resumen',
	      order: 6,
	      siblings: [{
	        name: 'fullscreen.workPlanExecution',
	        order: 0
	      }, {
	        name: 'workplan.executionTeaching',
	        order: 1
	      }, {
	        name: 'workplan.executionAcademicManagement',
	        order: 4
	      }, {
	        name: 'workplan.executionConsolidation',
	        order: 5
	      }, {
	        name: 'workplan.executionInvestigation',
	        order: 2
	      }, {
	        name: 'workplan.executionExtension',
	        order: 3
	      }]
	    },
	    params: {
	      inHistory: true,
	      stage: _globalConfig2.default.workplanStages.execution
	    }
	  })
	  // States from Summaries from stages
	  .state('workplan.summaryReview', {
	    abstract: false,
	    url: '/summaryReview/teacher/:teacherId?name/workplan/:workplanId',
	    template: __webpack_require__(570),
	    controller: 'SummaryCtrl',
	    controllerAs: 'summaryVm',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Resumen',
	      order: 6,
	      title: 'Resumen',
	      siblings: [{
	        name: 'fullscreen.workPlanReview',
	        order: 0,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.review,
	      stageId: _globalConfig2.default.workplanIdStages.review,
	      inHistory: false
	    }
	  }).state('workplan.summaryReviewExecution', {
	    abstract: false,
	    url: '/summaryReviewExecution/teacher/:teacherId?name/workplan/:workplanId',
	    template: __webpack_require__(570),
	    controller: 'SummaryCtrl',
	    controllerAs: 'summaryVm',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Resumen',
	      order: 6,
	      title: 'Resumen',
	      siblings: [{
	        name: 'fullscreen.workPlanReviewExecution',
	        order: 0,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.reviewExecution,
	      stageId: _globalConfig2.default.workplanIdStages.reviewExecution,
	      inHistory: false
	    }
	  }).state('workplan.summaryApproval', {
	    abstract: false,
	    url: '/summaryApproval/teacher/:teacherId?name/workplan/:workplanId',
	    template: __webpack_require__(570),
	    controller: 'SummaryCtrl',
	    controllerAs: 'summaryVm',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Resumen',
	      order: 6,
	      title: 'Resumen',
	      siblings: [{
	        name: 'fullscreen.workPlanApproval',
	        order: 0
	      }, {
	        name: 'workplan.approvalTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.approval,
	      stageId: _globalConfig2.default.workplanIdStages.approval,
	      inHistory: false
	    }
	  }).state('workplan.summaryEvaluation', {
	    abstract: false,
	    url: '/summaryEvaluation/teacher/:teacherId?name/workplan/:workplanId',
	    template: __webpack_require__(570),
	    controller: 'SummaryCtrl',
	    controllerAs: 'summaryVm',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Resumen',
	      order: 6,
	      title: 'Resumen',
	      siblings: [{
	        name: 'fullscreen.workPlanEvaluation',
	        order: 0
	      }, {
	        name: 'workplan.evaluationTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	
	      }, {
	        name: 'workplan.evaluationAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.evaluation,
	      stageId: _globalConfig2.default.workplanIdStages.evaluation,
	      inHistory: false
	    }
	  }).state('workplan.summaryExecution', {
	    abstract: false,
	    url: '/summaryExecution',
	    template: __webpack_require__(570),
	    controller: 'SummaryCtrl',
	    controllerAs: 'summaryVm',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Resumen',
	      order: 6,
	      title: 'Resumen',
	      siblings: [{
	        name: 'fullscreen.workPlanExecution',
	        order: 0
	      }, {
	        name: 'workplan.executionTeaching',
	        order: 1
	      }, {
	        name: 'workplan.executionAcademicManagement',
	        order: 4
	      }, {
	        name: 'workplan.executionConsolidation',
	        order: 5
	      }, {
	        name: 'workplan.executionInvestigation',
	        order: 2
	      }, {
	        name: 'workplan.executionExtension',
	        order: 3
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.review,
	      stageId: _globalConfig2.default.workplanIdStages.review,
	      inHistory: false
	    }
	  }).state('workplan.summaryConsult', {
	    abstract: false,
	    url: '/summaryConsult/teacher/:teacherId?name/workplan/:workplanId/:currentStage',
	    template: __webpack_require__(570),
	    controller: 'SummaryCtrl',
	    controllerAs: 'summaryVm',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Resumen',
	      title: 'Resumen',
	      order: 1,
	      siblings: [{
	        name: 'workplan.consultHistory',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name',
	          currentStage: 'currentStage'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.consultant,
	      stageId: _globalConfig2.default.workplanIdStages.consultant,
	      inHistory: false
	    }
	  }).state('workplan.consultHistory', {
	    abstract: false,
	    url: '/consultHistory/teacher/:teacherId?name/workplan/:workplanId/:currentStage',
	    template: '<history></history>',
	    data: {
	      displayName: 'Ver resumen',
	      title: 'Resumen',
	      order: 2,
	      siblings: [{
	        name: 'workplan.summaryConsult',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name',
	          currentStage: 'currentStage'
	        }
	      }]
	    },
	    params: {
	      inHistory: true,
	      stageId: _globalConfig2.default.workplanIdStages.consultant
	    }
	  });
	}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row gutter-10\"> <div class=\"intro-message m-b-lg\"> <div class=col-md-12> <h1 class=\"text-blanco text-center\">Bienvenido a Plan de Trabajo</h1> <h3 class=\"text-blanco text-center\">Etapa de ejecución</h3> </div> </div> <div class=\"col-md-offset-1 col-md-12 m-t-lg m-l-md\"> <div class=col-md-12> <div class=\"col-md-1-5 text-center\" ng-repeat=\"item in executionVm.RightBar.asignaturesPlaned\"> <div class=row> <div class=\"col-md-12 text-center p\"> <div class=\"principal-diagram c100 p{{item.percentageExecuted||0}} big center\" ui-sref={{item.route}} ng-class=\"{\n            'cyan'      : (item.submoduleId==2),\n            'green'     : (item.submoduleId==3),\n            'purple'    : (item.submoduleId==4),\n            'yellow'    : (item.submoduleId==5),\n            'orange'    : (item.submoduleId==6)\n          }\"> <span class=pointer>{{item.percentageExecuted || 0}}% </span> <h4 class=\"text-blanco text-xs m-t-radio-execution\">{{item.submoduleName}}</h4> <div class=slice> <div class=bar></div> <div class=fill></div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row m-b-lg\"> <div class=\"col-md-12 m-b-button\"> <button class=\"btn btn-success btn-lg p-h-lg text-md font-bold p-v btn-fullscreen p-r-md\" ui-sref=workplan.executionHistory> Ir al Plan de Trabajo</button> </div> </div> <style></style> <div class=\"row p\"> <div class=\"col-lg-8 col-lg-offset-2\"> <h3 class=\"text-blanco text-center m-b-lg\">Linea de tiempo etapas</h3> <ol class=timeline> <li> <div class=item> <div class=\"circle {{executionVm.classCircleGreen1}}\"> <div class=label-item>Planeación</div> </div> <div class=\"line {{executionVm.classBarGreen1}}\"></div> </div> </li> <li> <div class=item> <div class=\"circle {{executionVm.classCircleGreen2}}\"> <div class=label-item>Aprobación</div> </div> <div class=\"line {{executionVm.classBarGreen2}}\"></div> </div> </li> <li> <div class=item> <div class=\"circle {{executionVm.classCircleGreen3}}\"> <div class=label-item>Ejecución</div> </div> <div class=\"line {{executionVm.classBarGreen3}}\"></div> </div> </li> <li> <div class=item> <div class=\"circle {{executionVm.classCircleGreen4}}\"> <div class=label-item>Evaluación</div> </div> <div class=line></div> </div> </li> </ol> </div> </div> <div class=\"row p\"> <div class=\"col-lg-8 col-lg-offset-2\"> <div class=text-right> <p class=text-blanco> <i class=\"icon mdi-communication-email i-20 text-blanco text-right text-md\"></i> Tiene {{executionVm.messagesList.length}} principio orientador nuevo. <span class=underscore ng-click=executionVm.showModalMessages()>Revisar</span> </p> </div> </div> </div> </div>";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.reviewTeaching', {
	    abstract: false,
	    url: '/reviewTeaching/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Docencia',
	      title: 'Docencia',
	      order: 1,
	      siblings: [{
	        name: 'fullscreen.workPlanReview',
	        order: 0
	      }, {
	        name: 'workplan.reviewAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReview',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.review,
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.approvalTeaching', {
	    abstract: false,
	    url: '/approvalTeaching/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Docencia',
	      title: 'Docencia',
	      order: 1,
	      siblings: [{
	        name: 'fullscreen.workPlanApproval',
	        order: 0
	      }, {
	        name: 'workplan.approvalAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryApproval',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.approval,
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  }).state('workplan.executionTeaching', {
	    abstract: false,
	    url: '/executionTeaching',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Docencia',
	      title: 'Docencia',
	      order: 1,
	      siblings: [{
	        name: 'fullscreen.workPlanExecution',
	        order: 0
	      }, {
	        name: 'workplan.executionAcademicManagement',
	        order: 4
	      }, {
	        name: 'workplan.executionConsolidation',
	        order: 5
	      }, {
	        name: 'workplan.executionInvestigation',
	        order: 2
	      }, {
	        name: 'workplan.executionExtension',
	        order: 3
	      }, {
	        name: 'workplan.executionHistory',
	        order: 6
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.execution,
	      roleId: _globalConfig2.default.userRolesIds.teacher,
	      inHistory: false
	    }
	  }).state('workplan.reviewExecutionTeaching', {
	    abstract: false,
	    url: '/reviewExecutionTeaching/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Docencia',
	      title: 'Docencia',
	      order: 1,
	      siblings: [{
	        name: 'fullscreen.workPlanReviewExecution',
	        order: 0
	      }, {
	        name: 'workplan.reviewExecutionAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReviewExecution',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.reviewExecution,
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.evaluationTeaching', {
	    abstract: false,
	    url: '/evaluationTeaching/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.teaching,
	    data: {
	      displayName: 'Docencia',
	      title: 'Docencia',
	      order: 1,
	      siblings: [{
	        name: 'fullscreen.workPlanEvaluation',
	        order: 0
	      }, {
	        name: 'workplan.evaluationAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryEvaluation',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.evaluation,
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  });
	}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.reviewAcademicManagement', {
	    abstract: false,
	    url: '/reviewAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.academicManagement,
	    data: {
	      displayName: 'Gestión Académica',
	      title: 'Gestión Académica',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanReview',
	        order: 0
	      }, {
	        name: 'workplan.reviewTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReview',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'review',
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.approvalAcademicManagement', {
	    abstract: false,
	    url: '/approvalAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.academicManagement,
	    data: {
	      displayName: 'Gestión Académica',
	      title: 'Gestión Académica',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanApproval',
	        order: 0
	      }, {
	        name: 'workplan.approvalTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryApproval',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'approval',
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  }).state('workplan.executionAcademicManagement', {
	    abstract: false,
	    url: '/executionAcademicManagement',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.academicManagement,
	    data: {
	      displayName: 'Gestión Académica',
	      title: 'Gestión Académica',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanExecution',
	        order: 0
	      }, {
	        name: 'workplan.executionTeaching',
	        order: 1
	      }, {
	        name: 'workplan.executionConsolidation',
	        order: 5
	      }, {
	        name: 'workplan.executionInvestigation',
	        order: 2
	      }, {
	        name: 'workplan.executionExtension',
	        order: 3
	      }, {
	        name: 'workplan.executionHistory',
	        order: 6
	      }]
	    },
	    params: {
	      stage: 'execution',
	      roleId: _globalConfig2.default.userRolesIds.teacher,
	      inHistory: false
	    }
	  }).state('workplan.reviewExecutionAcademicManagement', {
	    abstract: false,
	    url: '/reviewExecutionAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.academicManagement,
	    data: {
	      displayName: 'Gestión Académica',
	      title: 'Gestión Académica',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanReviewExecution',
	        order: 0,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReviewExecution',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'reviewExecution',
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.evaluationAcademicManagement', {
	    abstract: false,
	    url: '/evaluationAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.academicManagement,
	    data: {
	      displayName: 'Gestión Académica',
	      title: 'Gestión Académica',
	      order: 4,
	      siblings: [{
	        name: 'fullscreen.workPlanEvaluation',
	        order: 0
	      }, {
	        name: 'workplan.evaluationTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryEvaluation',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'evaluation',
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  });
	}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.reviewConsolidation', {
	    abstract: false,
	    url: '/reviewConsolidation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.consolidation,
	    data: {
	      displayName: 'Consolidación del cuerpo profesoral',
	      title: 'Consolidación del cuerpo profesoral',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanReview',
	        order: 0
	      }, {
	        name: 'workplan.reviewTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReview',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'review',
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.approvalConsolidation', {
	    abstract: false,
	    url: '/approvalConsolidation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.consolidation,
	    data: {
	      displayName: 'Consolidación del cuerpo profesoral',
	      title: 'Consolidación del cuerpo profesoral',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanApproval',
	        order: 0
	      }, {
	        name: 'workplan.approvalTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryApproval',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'approval',
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  }).state('workplan.executionConsolidation', {
	    abstract: false,
	    url: '/executionConsolidation',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.consolidation,
	    data: {
	      displayName: 'Consolidación del cuerpo profesoral',
	      title: 'Consolidación del cuerpo profesoral',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanExecution',
	        order: 0
	      }, {
	        name: 'workplan.executionTeaching',
	        order: 1
	      }, {
	        name: 'workplan.executionAcademicManagement',
	        order: 4
	      }, {
	        name: 'workplan.executionInvestigation',
	        order: 2
	      }, {
	        name: 'workplan.executionExtension',
	        order: 3
	      }, {
	        name: 'workplan.executionHistory',
	        order: 6
	      }]
	    },
	    params: {
	      stage: 'execution',
	      roleId: _globalConfig2.default.userRolesIds.teacher,
	      inHistory: false
	    }
	  }).state('workplan.reviewExecutionConsolidation', {
	    abstract: false,
	    url: '/reviewExecutionConsolidation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.consolidation,
	    data: {
	      displayName: 'Consolidación del cuerpo profesoral',
	      title: 'Consolidación del cuerpo profesoral',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanReviewExecution',
	        order: 0
	      }, {
	        name: 'workplan.reviewExecutionTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReviewExecution',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'reviewExecution',
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.evaluationConsolidation', {
	    abstract: false,
	    url: '/evaluationConsolidation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.consolidation,
	    data: {
	      displayName: 'Consolidación del cuerpo profesoral',
	      title: 'Consolidación del cuerpo profesoral',
	      order: 5,
	      siblings: [{
	        name: 'fullscreen.workPlanEvaluation',
	        order: 0
	      }, {
	        name: 'workplan.evaluationTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryEvaluation',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'evaluation',
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  });
	}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.reviewInvestigation', {
	    abstract: false,
	    url: '/reviewInvestigation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.investigation,
	    data: {
	      displayName: 'Investigación',
	      title: 'Investigación',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanReview',
	        order: 0
	      }, {
	        name: 'workplan.reviewTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReview',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.review,
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.approvalInvestigation', {
	    abstract: false,
	    url: '/approvalInvestigation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.investigation,
	    data: {
	      displayName: 'Investigación',
	      title: 'Investigación',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanApproval',
	        order: 0
	      }, {
	        name: 'workplan.approvalTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryApproval',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.approval,
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  }).state('workplan.executionInvestigation', {
	    abstract: false,
	    url: '/executionInvestigation',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.investigation,
	    data: {
	      displayName: 'Investigación',
	      title: 'Investigación',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanExecution',
	        order: 0
	      }, {
	        name: 'workplan.executionTeaching',
	        order: 1
	      }, {
	        name: 'workplan.executionAcademicManagement',
	        order: 4
	      }, {
	        name: 'workplan.executionConsolidation',
	        order: 5
	      }, {
	        name: 'workplan.executionExtension',
	        order: 3
	      }, {
	        name: 'workplan.executionHistory',
	        order: 6
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.execution,
	      roleId: _globalConfig2.default.userRolesIds.teacher,
	      inHistory: false
	    }
	  }).state('workplan.reviewExecutionInvestigation', {
	    abstract: false,
	    url: '/reviewExecutionInvestigation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.investigation,
	    data: {
	      displayName: 'Investigación',
	      title: 'Investigación',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanReviewExecution',
	        order: 0
	      }, {
	        name: 'workplan.reviewExecutionTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReviewExecution',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.reviewExecution,
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.evaluationInvestigation', {
	    abstract: false,
	    url: '/evaluationInvestigation/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.investigation,
	    data: {
	      displayName: 'Investigación',
	      title: 'Investigación',
	      order: 2,
	      siblings: [{
	        name: 'fullscreen.workPlanEvaluation',
	        order: 0
	      }, {
	        name: 'workplan.evaluationTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationExtension',
	        order: 3,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryEvaluation',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: _globalConfig2.default.workplanStages.evaluation,
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  });
	}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	// config file
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  $stateProvider.state('workplan.reviewExtension', {
	    abstract: false,
	    url: '/reviewExtension/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.extentionAndVisibility,
	    data: {
	      displayName: 'Extensión y visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanReview',
	        order: 0
	      }, {
	        name: 'workplan.reviewTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReview',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'review',
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.approvalExtension', {
	    abstract: false,
	    url: '/approvalExtension/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.extentionAndVisibility,
	    data: {
	      displayName: 'Extensión y visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanApproval',
	        order: 0
	      }, {
	        name: 'workplan.approvalTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.approvalInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryApproval',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'approval',
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  }).state('workplan.executionExtension', {
	    abstract: false,
	    url: '/executionExtension',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.extentionAndVisibility,
	    data: {
	      displayName: 'Extensión y visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanExecution',
	        order: 0
	      }, {
	        name: 'workplan.executionTeaching',
	        order: 1
	      }, {
	        name: 'workplan.executionAcademicManagement',
	        order: 4
	      }, {
	        name: 'workplan.executionConsolidation',
	        order: 5
	      }, {
	        name: 'workplan.executionInvestigation',
	        order: 2
	      }, {
	        name: 'workplan.executionHistory',
	        order: 6
	      }]
	    },
	    params: {
	      stage: 'execution',
	      roleId: _globalConfig2.default.userRolesIds.teacher,
	      inHistory: false
	    }
	  }).state('workplan.reviewExecutionExtension', {
	    abstract: false,
	    url: '/reviewExecutionExtension/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.extentionAndVisibility,
	    data: {
	      displayName: 'Extensión y visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanReviewExecution',
	        order: 0,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.reviewExecutionInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryReviewExecution',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'reviewExecution',
	      roleId: _globalConfig2.default.userRolesIds.reviewer,
	      inHistory: false
	    }
	  }).state('workplan.evaluationExtension', {
	    abstract: false,
	    url: '/evaluationExtension/teacher/:teacherId?name/workplan/:workplanId',
	    template: '<activities-review></activities-review>',
	    module: _globalConfig2.default.modules.extentionAndVisibility,
	    data: {
	      displayName: 'Extensión y visibilidad',
	      title: 'Extensión y visibilidad',
	      order: 3,
	      siblings: [{
	        name: 'fullscreen.workPlanEvaluation',
	        order: 0
	      }, {
	        name: 'workplan.evaluationTeaching',
	        order: 1,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationAcademicManagement',
	        order: 4,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationConsolidation',
	        order: 5,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.evaluationInvestigation',
	        order: 2,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }, {
	        name: 'workplan.summaryEvaluation',
	        order: 6,
	        params: {
	          teacherId: 'teacherId',
	          workplanId: 'workplanId',
	          name: 'name'
	        }
	      }]
	    },
	    params: {
	      stage: 'evaluation',
	      roleId: _globalConfig2.default.userRolesIds.approver,
	      inHistory: false
	    }
	  });
	}

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan) {
	
	  $templateCache.put('autoevaluacion.html', __webpack_require__(648));
	
	  $templateCache.put('reflexionesDePortafolio.html', __webpack_require__(649));
	
	  $templateCache.put('resultadosDeApreciacion.html', __webpack_require__(650));
	
	  $templateCache.put('comentariosDeConsultores.html', __webpack_require__(651));
	
	  $templateCache.put('reflexionesDePares.html', __webpack_require__(652));
	
	  MenuConstant[0]['menu'].push(workplan);
	}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div ng-controller=\"autoevaluationController as custCtrl\" class=col-sm-12> <div class=clearfix></div> <div class=\"inline text-md m-r-md\"> <label for=m1 class=\"control-label text-md\">Estimado evaluador:</label> <div class=clearfix></div> <p> A continuación, encontrará a manera de desplegable, las respuestas dadas por el profesor en su autoevaluación, la cual estaba compuesta por varias secciones: <br> 1. Reflexiones de docencia: este aparte contiene la reflexión general del profesor sobre la docencia (que tenía carácter obligatorio) y si el profesor voluntariamente lo quiso, incluye la reflexión particular para cada una de las asignaturas que tuvo a su cargo. <br> 2. Plan de trabajo: este aparte contiene una reflexión del profesor acerca de los resultados alcanzados durante la ejecución de dicho plan. <br> 3. Compromiso institucional: le presenta las respuestas dadas por el profesor en torno a este tema. <br> 4. Preguntas abiertas: Presenta las respuestas dadas por el profesor en esta sección. <br> 5. Concepto final: muestra la evaluación dada por el profesor sobre su propio desempeño. <br> </p> <div class=clearfix></div> <label for=m1 class=\"control-label text-md\"> Estos son los resultados:</label> <div class=clearfix></div> </div> <div class=clearfix></div> <accordion class=cstm-panel close-others=oneAtATime> <accordion-group ng-init=\"reflexiones = true\" data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md\">Reflexiones de docencia</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <label for=m1 class=\"control-label text-md\">Reflexión general</label> <p>{{custCtrl.general}}</p> </div> <div class=clearfix></div> <div class=\"inline text-md m-r-md\"> {{ custCtrl.headingDescription[0].ds_description }} </div> <div class=clearfix></div> <accordion class=cstm-panel ng-repeat=\"(key1,heads) in custCtrl.reflection\"> <accordion-group ng-init=\"(heads.codSubject==custCtrl.generalFlag)=true\" is-open=custCtrl.generalFlag> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">{{ heads.codSubject }}</div> <div class=\"font-bold inline text-md m-r-md\">{{ heads.subject }}</div> <div class=\"inline m-r-md\"> Nº Grupos: <span class=\"badge bg-success\">{{ heads.cantGroups }}</span> </div> <div class=\"inline m-r-md\"> Total Est: <span class=\"badge bg-warning\">{{ heads.totalStudent }}</span> </div> <div class=\"inline m-r-md\"> Período: <span class=\"badge bg-info\">{{ heads.period }}</span> </div> </accordion-heading> <div class=clearfix></div> <accordion ng-repeat=\"(key,groups) in heads.groups\"> <accordion-group ng-init=\"(groups.assignature_id==custCtrl.assignatureIdFlag[groups.assignature_id])=true\" is-open=custCtrl.assignatureIdFlag[groups.assignature_id] title={{custCtrl.assignatureIdFlag[groups.assignature_id]}}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">{{groups.group}}</div> <div class=\"inline m-r-md\"> Nº Est: <span class=\"badge bg-success\">{{groups.nroStudent}}</span> </div> </accordion-heading> <div class=clearfix></div> <div class=\"col-sm-12 panel-collapse collapse in\"> <label for=m1 class=\"control-label text-md\">Reflexión de la asignatura</label> <p>{{groups.commentary}}</p> </div> </accordion-group> </accordion> </accordion-group> </accordion> </accordion-group> <accordion-group ng-init=\"reflexiones = true\" data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md\">Plan de Trabajo</div> </accordion-heading> <div class=clearfix></div> <div class=\"inline text-md m-r-md\"> {{ custCtrl.headingDescription[1].ds_description }} </div> <div class=clearfix></div> <div class=col-sm-12 ng-repeat=\"(wpKey, wpText) in custCtrl.workPlan\"> <label for=m1 class=\"control-label text-md\">{{wpText.subModule}}</label> <p>{{wpText.commentary}}</p> </div> </accordion-group> <accordion-group ng-init=\"compromiso = true\" data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md\">Compromiso Institucional</div> </accordion-heading> <div class=clearfix></div> <div class=\"inline text-md m-r-md\"> {{ custCtrl.headingDescription[2].ds_description }} </div> <div class=clearfix></div> <div class=\"row p\" ng-repeat=\"question in custCtrl.institutionalCommitment\"> <div class=col-sm-12> <label for=m1 class=\"control-label text-md\">{{question.question}}</label> </div> <div class=col-sm-6> <p> <md-radio-group ng-model=question.chosenOption class=md-primary> <md-radio-button ng-repeat=\"option in question.options\" ng-value=option.codOption ng-disabled=true> {{option.dsOptions}} </md-radio-button> </md-radio-group> </p> </div> <div class=col-sm-6> <label for=m1 class=control-label>Justifique</label> <p>{{question.justification}}</p> </div> </div> </accordion-group> <accordion-group ng-init=\"Preguntas = true\" data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md\">Preguntas Abiertas</div> </accordion-heading> <div class=clearfix></div> <div class=\"inline text-md m-r-md\"> {{ custCtrl.headingDescription[3].ds_description }} </div> <div class=clearfix></div> <div class=col-sm-12 ng-repeat=\"(oqKey, oqText) in custCtrl.openQuestion\"> <label for=m1 class=\"control-label text-md\">{{oqKey+1}}. {{oqText.question}}.</label> <p>{{oqText.answer}}</p> </div> </accordion-group> <accordion-group ng-init=\"Concepto = true\" data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md\">Concepto Final</div> </accordion-heading> <div class=clearfix></div> <div class=\"inline text-md m-r-md\"> {{ custCtrl.headingDescription[4].ds_description }} </div> <div class=clearfix></div> <div class=\"row p\" ng-repeat=\"final in custCtrl.finalConcept\"> <div class=col-sm-6> <p> <md-radio-group ng-model=final.chosenOption class=md-primary> <md-radio-button ng-repeat=\"option in final.options\" ng-value=option.codOption ng-disabled=true> {{option.dsOptions}} </md-radio-button> </md-radio-group> </p> </div> <div class=col-sm-6> <label for=m1 class=control-label>Justifique</label> <p>{{final.justification}}</p> </div> </div> </accordion-group> </accordion> </div> </div> ";

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports = "<div class=row ng-controller=\"reflexionesportafolioController as custCtrl\"> <div class=col-sm-12> <accordion class=cstm-panel close-others=oneAtATime> <accordion-group ng-repeat=\"(key,value) in custCtrl.reflextionData\" ng-init=\"(value.index==1) = 1\" is-open=value.index data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">Reflexion nueva {{value.codReflection}}</div> <div class=\"inline text-md m-r-md\">{{value.dtReflection}} </div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-6> <label for=m1 class=\"control-label text-md\">Descripcion</label> <p>{{value.dsDescription}}</p> </div> <div class=col-sm-6 ng-if=value.link[0]> <label for=m1 class=\"control-label text-md\">Evidencias</label><br/> <div class=\"inline m-r-md\" ng-repeat=\"(key,l) in value.link\"> <a ng-click=custCtrl.showMultivideoDialog(l)> <i class=\"fa fa-5x\" ng-class=\"{'fa-file-photo-o'  : l.dsFileType=='Imagen', \n                            'fa-file-video-o'  : l.dsFileType=='Video',\n                            'fa-file-sound-o'  : l.dsFileType=='Audio',\n                            'fa-file-archive-o': l.dsFileType=='Documento'}\"></i> </a> </div> </div> </accordion-group> </accordion> </div> </div> ";

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = "<div class=row ng-controller=\"customChartController as custCtrl\"> <div class=col-sm-12> <div class=card> <div class=card-heading> <h4>Filtrar por</h4> </div> <div class=card-body> <div class=col-sm-12> <div class=col-sm-4> <md-card> <md-card-content> <div layout=row> <md-input-container> <label>Unidad</label> <md-select ng-model=custCtrl.unit> <md-option ng-disabled=true><em>None</em></md-option> <md-option ng-repeat=\"unit in custCtrl.optionList.unit\" ng-value=unit.id> {{unit.title}} </md-option> </md-select> </md-input-container> </div> </md-card-content> </md-card> </div> <div class=col-sm-4> <md-card> <md-card-content> <div layout=row> <md-input-container> <label>Nivel</label> <md-select ng-model=custCtrl.level> <md-option ng-disabled=true><em>None</em></md-option> <md-option ng-repeat=\"(key,level) in custCtrl.optionList.level\" ng-value=level.id> {{level.title}} </md-option> </md-select> </md-input-container> </div> </md-card-content> </md-card> </div> <div class=col-sm-4> <md-card> <md-card-content> <div layout=row> <md-input-container> <label>Período</label> <md-select ng-model=custCtrl.period> <md-option ng-disabled=true><em>None</em></md-option> <md-option ng-repeat=\"period in custCtrl.optionList.period\" ng-value=period.id> {{period.title}} </md-option> </md-select> </md-input-container> </div> </md-card-content> </md-card> </div> </div> <div class=\"col-sm-12 m-b-sm\"> <button class=\"btn btn-fw btn-warning md-button md-ink-ripple pull-right\" ng-click=custCtrl.reiniciar()>Reiniciar</button> <button class=\"btn btn-fw btn-success md-button md-ink-ripple pull-right\" ng-click=custCtrl.mostrar()>Mostrar</button> </div> </div> </div> </div> <div class=\"col-sm-12 m-t-sm\"> <accordion class=cstm-panel close-others=oneAtATime> <accordion-group id=subject-{{$index}} ng-repeat=\"(key, value) in custCtrl.graph \" ng-init=\"(value.id_code==custCtrl.subjectIncrementCode)=true\" is-open=value.id_code data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">{{value.codSubject}}</div> <div class=\"font-bold inline text-md m-r-md\">{{value.subject}}</div> <div class=\"inline m-r-md\"> N° Grupos: <span class=\"badge bg-warning\">{{value.cantGroups}}</span> </div> <div class=\"inline m-r-md\"> Total Est: <span class=\"badge bg-warning\">{{value.totalStudent}}</span> </div> <div class=\"inline m-r-md\"> Período: <span class=\"badge bg-info\">{{value.period}}</span> </div> <div class=\"inline m-r-md\"> Total Respuestas: <span class=\"badge bg-info\">{{value.nmStudentAnsweredAsssignature}}</span> </div> <div class=\"inline m-r-md\"> Promedio General: <span class=\"badge bg-info\">{{value.nmAverageSubject}}</span> </div> </accordion-heading> <div class=clearfix></div> <accordion> <accordion-group id=subject-{{$index}} ng-repeat=\"(key, groups) in value.groups \" data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">{{groups.group}}</div> <div class=\"inline m-r-md\"> N°Est: <span class=\"badge bg-warning\">{{groups.nm_GroupStudents}}</span> </div> <div class=\"inline m-r-md\"> Total Respuestas: <span class=\"badge bg-warning\">{{groups.nmStudentAnswered}}</span> </div> <div class=\"inline m-r-md\"> Promedio General : <span class=\"badge bg-info\">{{groups.nmAverageGroup}}</span> </div> </accordion-heading> <div class=clearfix></div> <accordion class=cstm-panel close-others=oneAtATime> <accordion-group ng-init=\"resultadosCuantitativos = true\" is-open=resultadosCuantitativos data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"inline text-md m-r-md\">Resultados Cuantitativos</div> </accordion-heading> <accordion> <accordion-group ng-repeat=\"(key, dim) in groups.quantitative[0].dim \" ng-init=\"((dim.id==custCtrl.barGraphId)=true) = true\" is-open=dim.id data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"inline text-md m-r-md\">{{dim.title}}</div> </accordion-heading> <div> <div class=\"row b-b m-b-md\" ng-repeat=\"(keyChart, quantChart) in dim.analysis\"> <div class=col-sm-12> <label for=m1 class=\"control-label text-md\">{{quantChart.title}}</label> </div> <div class=\"col-sm-6 no-p\"> <div id=resultados{{quantChart.highChart}}Chart></div> </div> <div class=\"col-sm-6 text-md p-t-lg\"> <div class=row ng-repeat=\"(keyChartTable, quantChartTable) in quantChart.barGraph\"> <div class=\"col-sm-5 inline\">{{quantChartTable.name}}</div> <div class=\"col-sm-2 inline font-bold\">{{quantChartTable.x}}</div> <div class=\"col-sm-5 inline\">{{quantChartTable.y}}%</div> </div> </div> </div> </div> </accordion-group> </accordion> </accordion-group> <accordion-group ng-init=\"resultadosCualitativos = true\" is-open=resultadosCualitativos data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"inline text-md m-r-md\">Resultados Cualitativos</div> </accordion-heading> <accordion> <accordion-group ng-repeat=\"(keyquality, quality) in groups.qualitative\" ng-init=\"keyquality = true\" is-open=keyquality data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"inline text-md m-r-md\">{{quality.title}}</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <p>{{quality.body}}</p> </div> </accordion-group> </accordion> </accordion-group> </accordion> </accordion-group> </accordion> </accordion-group> </accordion> </div> </div> ";

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-sm-12> <accordion class=cstm-panel close-others=oneAtATime> <accordion-group ng-init=\"comentariosDeConsultores = true\" is-open=comentariosDeConsultores data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">Juan Perez</div> <div class=\"inline text-md m-r-md\">19/12/2017</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes</p> </div> </accordion-group> <accordion-group is-open=comentariosDeConsultores2 data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">Juan Perez</div> <div class=\"inline text-md m-r-md\">05/10/2017</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes</p> </div> </accordion-group> <accordion-group is-open=comentariosDeConsultores3 data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">Marcelo Gonzalez</div> <div class=\"inline text-md m-r-md\">18/08/2017</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes</p> </div> </accordion-group> </accordion> </div> </div> ";

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-sm-12> <accordion class=cstm-panel close-others=oneAtATime> <accordion-group ng-init=\"reflexionesDePares = true\" is-open=reflexionesDePares data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">Juan Perez</div> <div class=\"inline text-md m-r-md\">19/12/2017</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes</p> </div> </accordion-group> <accordion-group is-open=reflexionesDePares2 data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">Juan Perez</div> <div class=\"inline text-md m-r-md\">05/10/2017</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes</p> </div> </accordion-group> <accordion-group is-open=reflexionesDePares3 data-ui-sref-opts={reload:true}> <accordion-heading> <div class=\"font-bold inline text-md m-r-md\">Marcelo Gonzalez</div> <div class=\"inline text-md m-r-md\">18/08/2017</div> </accordion-heading> <div class=clearfix></div> <div class=col-sm-12> <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes</p> </div> </accordion-group> </accordion> </div> </div> ";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan) {
	  $templateCache.put('indicators.html', __webpack_require__(579));
	}

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan, GlobalConfig) {
	  $templateCache.put('courses-list', __webpack_require__(655));
	  $templateCache.put('course-details', __webpack_require__(656));
	  $templateCache.put('course-details-modal', __webpack_require__(657));
	  $templateCache.put('list-data-course', __webpack_require__(658));
	  $templateCache.put('details-header-course', __webpack_require__(659));
	  $templateCache.put('details-header-course-modal', __webpack_require__(660));
	  $templateCache.put('header-course', __webpack_require__(661));
	}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-5 no-padding rightDivider\"> <p class=\"text-md text-gris-dark exo m-l\"> Listado de actividades de {{ reviewTVM.mainLabel }}</p> <div ng-include=\"'search-bar'\"></div> <md-virtual-repeat-container class=\"w-h-100 list-h scroll-55vh\"> <md-list> <md-list-item ng-class=reviewTVM.courseBckgrd(course) ng-model=reviewTVM.selectedCourse class=md-2-line md-virtual-repeat=\"course in reviewTVM.courses | filter: reviewTVM.criteriaFilter\" ng-click=reviewTVM.details(course)> <div ng-include=\"'list-data-course'\"></div> <md-divider ng-if=!$last></md-divider> </md-list-item> </md-list> </md-virtual-repeat-container> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=reviewTVM.close()>Volver</md-button> </div> </div> ";

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-7 ng-if=reviewTVM.thereIsDetails()> <div ng-include=\"'details-header-course'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=reviewTVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=reviewTVM.thereIsDetails() md-diameter=96> </md-progress-circular> </div> ";

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-7 ng-if=reviewTVM.thereIsDetails()> <div ng-include=\"'details-header-course-modal'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=reviewTVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=reviewTVM.thereIsDetails() md-diameter=96> </md-progress-circular> </div> ";

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = " <div class=p-v> <div class=md-list-item-text> <p ng-class=reviewTVM.courseText(course) class=\"text-color no-margin exo\"> <strong>{{ course.nameCourse }}</strong> </p> <p ng-class=reviewTVM.courseText(course) class=\"text-sm no-margin proxima\"> Profesor {{ course.nameTeacher }} </p> </div> </div> ";

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-7 no-padding\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Detalle curso - {{ reviewTVM.detailsData.nameCourse }} </h5> </div> </div> <div class=row> <div class=\"col-md-6 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Categoria:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.categoryCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Profesor:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.nameTeacher}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Modalidad:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.modalityCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Idioma:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.languageCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Tipo:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.typeCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Descripción:</strong></label> </div> </div> </div> <div class=\"col-md-6 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Sede:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.locationCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Horario:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.scheduleCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px;width:150px><strong>Fecha inicio:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:20px;width:200px>{{reviewTVM.detailsData.startCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px;width:150px><strong>Fecha fin:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:20px;width:200px>{{reviewTVM.detailsData.endCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Horas</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.hoursCourse}}</label> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <p>{{reviewTVM.detailsData.descriptionCourse}}</p> </div> </div> <div class=row> <div class=\"col-md-12 text-center\"> <md-button class=\"btn btn-fw btn-success no-margin\" target=_blank type=button href=https://{{reviewTVM.detailsData.linkCourse}}>Inscribir Curso</md-button> </div> </div> </div> </div> ";

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row no-padding\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs no-padding\"> <div class=\"row no-padding\"> <div class=\"col-md-7 no-padding\"> <h5 class=\"text-azul m-r-sm font-bold text-block left\"> Detalle curso - {{ reviewTVM.detailsData.nameCourse }} </h5> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-6 p-h-lg p-v m-b-xs no-padding\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Categoria:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.categoryCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Profesor:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.nameTeacher}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Modalidad:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.modalityCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Idioma:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.languageCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Tipo:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.typeCourse}}</label> </div> </div> </div> <div class=\"col-md-6 p-h-lg p-v m-b-xs no-padding\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Sede:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.locationCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Horario:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.scheduleCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px;width:150px><strong>Fecha inicio:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:20px;width:200px>{{reviewTVM.detailsData.startCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px;width:150px><strong>Fecha fin:</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:20px;width:200px>{{reviewTVM.detailsData.endCourse}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Horas</strong></label> </div> <div class=\"col-md-4 text-left no-padding-r\"> <label style=margin-left:10px;width:200px>{{reviewTVM.detailsData.hoursCourse}}</label> </div> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs no-padding\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px><strong>Descripción:</strong></label> </div> <div class=\"col-md-12 text-left no-padding\"> <p style=margin-left:-15px>{{reviewTVM.detailsData.descriptionCourse}}</p> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-center\"> <md-button class=\"btn btn-fw btn-success no-margin\" target=_blank type=button href=https://{{reviewTVM.detailsData.linkCourse}}>Inscribir Curso</md-button> </div> </div> </div> </div> ";

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-block no-margin exo text-azul\"> {{ reviewTVM.mainLabel }} <span ng-show=!reviewTVM.isTeacher()> - {{ reviewTVM.teacher }} </span> </h3> <md-button aria-label ng-show=reviewTVM.inExecution() class=\"btn btn-fw btn-success right\" ng-click=addActivity()> Finalizar ejecución </md-button> </div> </div> ";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan, GlobalConfig) {
	  $templateCache.put('proposals-list', __webpack_require__(663));
	  $templateCache.put('proposals-details', __webpack_require__(664));
	  $templateCache.put('list-data-proposals', __webpack_require__(665));
	  $templateCache.put('details-header-proposal', __webpack_require__(666));
	  $templateCache.put('header-proposals', __webpack_require__(667));
	
	  $templateCache.put('extension-projects-list', __webpack_require__(668));
	  $templateCache.put('extension-projects-details', __webpack_require__(669));
	  $templateCache.put('list-data-projects', __webpack_require__(670));
	  $templateCache.put('extension-details-header-projects', __webpack_require__(671));
	  $templateCache.put('extension-header-projects', __webpack_require__(672));
	
	  $templateCache.put('visibility-list', __webpack_require__(673));
	  $templateCache.put('visibility-details', __webpack_require__(674));
	  $templateCache.put('list-data-visibility', __webpack_require__(675));
	  $templateCache.put('visibility-details-header', __webpack_require__(676));
	  $templateCache.put('visibility-header', __webpack_require__(677));
	}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-5 no-padding rightDivider blanco\"> <p class=\"text-md m-l m-t-sm text-gris-dark exo\"> Listado de propuestas</p> <div class=\"row search p-l p-r m-b-sm\"> <div class=col-md-12> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=projectVM.criteriaFilter class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar propuestas...\" ng-change=projectVM.updateFilter(search)> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <md-virtual-repeat-container class=\"w-h-100 list-h scroll-55vh\" ng-if=\"projectVM.proposals.length > 0\"> <md-list> <md-list-item ng-class=projectVM.proposalBckgrd(proposal) ng-model=projectVM.selectedProposal class=md-2-line md-virtual-repeat=\"proposal in projectVM.proposals | filter: projectVM.criteriaFilter\" ng-click=projectVM.details(proposal)> <div ng-include=\"'list-data-proposals'\"></div> <md-list-item ng-class=projectVM.proposalText(proposal) ng-if=\"proposal.activityTypeId == 19\" has-permission=formulacion-de-propuestas-de-extension-edit> <a href ui-sref=\"workplan.createProjectFormulationProposal({workplanTeacherActivityId: proposal.workplanTeacherActivityId})\" class=icon ng-class=classPlanning> <span class=\"icon i-24 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </md-list-item> <md-list-item ng-class=projectVM.proposalText(proposal) ng-if=\"proposal.activityTypeId == 19\" has-permission=formulacion-de-propuestas-de-extension-edit> <a href ng-click=projectVM.confirmDeleteProposal(proposal) class=icon ng-class=classPlanning> <span class=\"icon i-24 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </md-list-item> <project-type-tag class=\"md-secondary text-color\" project=proposal></project-type-tag> <md-divider ng-if=!$last></md-divider> </md-list-item> </md-list> </md-virtual-repeat-container> </div> ";

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-7 blanco\" ng-if=projectVM.thereIsDetails()> <div ng-include=\"'details-header-proposal'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=projectVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"projectVM.thereIsDetails() || projectVM.searchValue\" md-diameter=96> </md-progress-circular> </div> ";

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"p-v text-xs\"> <div class=md-list-item-text style=width:210px> <p ng-class=projectVM.proposalText(proposal) class=\"text-sm-important text-color no-margin exo\"> <strong>{{ proposal.titleProject }}</strong> </p> <p ng-class=projectVM.proposalText(proposal) class=\"text-xs-important no-margin proxima\" ng-if=\"proposal.timeRangeTypeId==2\"> {{ proposal.startDate }} - {{ proposal.endDate }} <br><label class=text-xs-important>Hrs. Planeadas {{proposal.hoursPlanned}} </label> </p> <p ng-class=projectVM.proposalText(proposal) class=\"text-xs-important no-margin proxima\" ng-if=\"proposal.timeRangeTypeId==1\"> {{ proposal.periodicityName }} <br><label class=text-xs-important>Hrs. Planeadas {{proposal.hoursPlanned}} </label> </p> </div> </div> ";

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"row m-t-md p-h-lg\" ng-if=\"projectVM.proposals.length == 0\"> <div class=\"col-md-12 p-v-md text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-center title\"> <p class=text-md>¡Aún no se ha registrado información en esta sección!</p> </div> <md-button aria-label ui-sref=workplan.createProjectFormulationProposal class=\"btn btn-fw btn-primary text-xs p-h-md no-margin\" ng-click=\"\" ng-disabled=projectVM.planningFinish has-permission=formulacion-de-propuestas-de-extension-edit> Agregar propuesta </md-button> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs\" id=doc ng-if=\"projectVM.proposals.length > 0\"> <div class=row> <div class=\"col-md-7 no-padding\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Detalle proyecto - {{ projectVM.detailsData.titleProject}} </h5> </div> </div> <div class=\"row export\"> <div class=\"col-md-5 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-6 text-left no-padding-r p-b-xs\"> <label class=text-block><strong>Tipo de proyecto:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label class=\"word-wrap w-h-100\">{{projectVM.detailsData.typeProject}}</label> </div> </div> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Aliados potenciales:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{projectVM.detailsData.potencialAllies}}</label> </div> </div> <div class=row ng-if=\"projectVM.detailsData.timeRangeTypeId==2\"> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Fecha Inicio:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{projectVM.detailsData.startDate | date : 'dd/MM/yyyy':'UTC'}}</label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Fecha Fin:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{projectVM.detailsData.endDate | date : 'dd/MM/yyyy' : 'UTC'}}</label> </div> </div> <div class=row ng-if=\"projectVM.detailsData.timeRangeTypeId==1\"> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Períodos:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{projectVM.detailsData.periodicityName}}</label> </div> </div> </div> <div class=\"col-md-7 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r p-b-xs\"> <label class=text-block><strong>Tipo de financiadores:</strong></label> </div> <div class=\"col-md-6 text-left no-padding\"> <label>{{projectVM.detailsData.typeFinanciers}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Horas Planeadas:</strong></label> </div> <div class=\"col-md-6 text-left no-padding\"> <label>{{projectVM.detailsData.hoursPlanned}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Resumen:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{projectVM.detailsData.summary}}</label> </div> </div> <div class=row> <div class=\"col-md-12 text-left p-t-xs no-padding-r\"> <label class=text-block><strong>Objetivo:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{projectVM.detailsData.observation}}</label> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <p>{{projectVM.detailsData.descriptionCourse}}</p> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-center\"> <md-button class=\"btn btn-fw btn-success no-margin\" target=_blank download={{projectVM.detailsData.titleProject}}.doc ng-click=projectVM.download() href={{projectVM.direct}}>Descargar Información</md-button> </div> </div> </div> </div> ";

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-block no-margin exo\"> Formulación de propuesta de extensión </h3> <p class=text-16-important> Considere un Proyecto de Extensión como el que procura una interacción entre la universidad y su entorno y está eminentemente orientado a la acción (que no, estrictamente, al avance del conocimiento). Ingrese en este apartado los datos del proyecto que quiere ejecutar </p> </div> <div class=\"col-md-5 p-h-lg p-v m-b-xs text-right\"> <md-button aria-label ui-sref=workplan.createProjectFormulationProposal class=\"btn btn-fw btn-primary text-xs p-h-md no-margin\" ng-click=\"\" ng-disabled=projectVM.planningFinish has-permission=formulacion-de-propuestas-de-extension-edit> Agregar propuesta </md-button> <md-button ng-if=\"projectVM.feedback && !projectVM.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=projectVM.bitacora($event)> Bitácora de Formulación de propuesta de extensión </md-button> </div> </div> ";

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-5 no-padding rightDivider\"> <p class=\"text-md m-l text-gris-dark exo\">Listado de proyectos</p> <div class=\"row search\"> <div class=col-md-12> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=extensionVM.criteriaFilter class=form-control ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar proyecto...\" ng-change=extensionVM.updateFilter(search) /> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit> <i class=\"mdi-action-search i-24\"></i> </button> </div> </div> </div> </div> <md-virtual-repeat-container class=\"w-h-100 list-h scroll-55vh\" ng-if=\"extensionVM.projects.length > 0\"> <md-list> <md-list-item ng-class=extensionVM.projectBckgrd(project) ng-model=extensionVM.selectedProject class=md-2-line md-virtual-repeat=\"project in extensionVM.projects | filter: extensionVM.criteriaFilter\" ng-click=extensionVM.details(project)> <div ng-include=\"'list-data-projects'\"></div> <md-list-item has-permission=proyectos-de-extension-edit ng-class=extensionVM.projectText(project) ng-if=\"project.activityTypeId == 20\"> <div class=\"col-md-6 text-center\"> <a href ui-sref=\"workplan.createExtensionProject({workplanTeacherActivityId: project.workplanTeacherActivityId})\" class=icon ng-class=classPlanning> <span class=\"icon i-24 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> </div> <div class=\"col-md-6 text-center\"> <a has-permission=productos-edit ng-click=extensionVM.disableProjectActivyId(project) class=icon ng-class=classPlanning> <span class=\"icon i-24 mdi-action-delete\"></span> <p class=\"text-xs exo\">Eliminar</p> </a> </div> </md-list-item> <project-type-tag class=\"md-secondary text-color\" project=project></project-type-tag> <md-divider ng-if=!$last></md-divider> </md-list-item> </md-list> </md-virtual-repeat-container> </div> ";

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	module.exports = "<div class=col-md-7 ng-if=extensionVM.thereIsDetails()> <div ng-include=\"'extension-details-header-projects'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=extensionVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"extensionVM.thereIsDetails() || extensionVM.searchValue\" md-diameter=96> </md-progress-circular> </div> ";

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"p-v text-xs\" ng-if=!project.isProjectCross> <div class=md-list-item-text style=width:270px> <p ng-class=extensionVM.projectText(project) class=\"text-sm-important text-color no-margin exo\"> <strong>{{ project.name }}</strong> </p> <p ng-class=extensionVM.projectText(project) class=\"text-xs-important no-margin proxima\"> {{ project.activityTypeName }} - {{ project.listItemProjectRoleName }} - {{ project.academicUnitName }} - {{ project.hoursPlanned }} hrs. planeadas </p> </div> </div> <div class=\"p-v text-xs\" ng-if=project.isProjectCross> <div class=md-list-item-text style=width:270px> <p ng-class=extensionVM.projectText(project) class=\"text-sm-important text-color no-margin exo\"> <strong>{{ project.projectName }}</strong> </p> <p ng-class=extensionVM.projectText(project) class=\"text-xs-important no-margin proxima\"> {{ project.activityTypeName}} - {{ project.communities }} - {{ project.itemProjectTypeName }} - {{ project.methodology }} </p> </div> </div> ";

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=doc> <div class=\"col-md-12 p-h-lg p-v m-b-xs\" ng-if=\"extensionVM.projects.length > 0\"> <div class=row> <div class=\"col-md-7 no-padding\"> <h5 class=\"text-azul m-r-sm font-bold text-block\" ng-if=!extensionVM.projectParent.isProjectCross> Detalle proyecto - {{ extensionVM.projectParent.name}} </h5> <h5 class=\"text-azul m-r-sm font-bold text-block\" ng-if=extensionVM.projectParent.isProjectCross> Detalle proyecto - {{ extensionVM.projectParent.projectName}} </h5> </div> <div class=\"col-md-4 no-padding\"> <div class=row> <project-type-tag class=\"md-secondary text-color\" project=extensionVM.selectedProject></project-type-tag> <project-state-tag class=\"md-secondary text-color\" project=extensionVM.selectedProject ng-if=!extensionVM.projectParent.isProjectCross></project-state-tag> </div> </div> </div> <div class=\"row export\" ng-if=!extensionVM.projectParent.isProjectCross> <div class=\"col-md-6 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Tipo de proyecto:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label class=\"w-h-100 word-wrap\">{{extensionVM.projectParent.listItemProjectTypeName}}</label> </div> </div> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Rol en el proyecto:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{extensionVM.projectParent.listItemProjectRoleName}}</label> </div> </div> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Unidad acad&eacute;mica:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{extensionVM.projectParent.academicUnitName}}</label> </div> </div> <div class=row ng-if=\"extensionVM.projectParent.timeRangeTypeId == 1\"> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Período:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{extensionVM.projectParent.periodicityName}}</label> </div> </div> <div class=row ng-if=\"extensionVM.projectParent.timeRangeTypeId == 2\"> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Fecha inicio:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{extensionVM.projectParent.startDate | date : 'dd/MM/yyyy':'UTC'}}</label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Fecha fin:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{extensionVM.projectParent.endDate | date : 'dd/MM/yyyy':'UTC'}}</label> </div> </div> </div> <div class=\"col-md-6 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Financiadores:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.financialSourceName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Propuesta asociada:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.projectFormulatedName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Horas planeadas:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.hoursPlanned}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Descripci&oacute;n:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{extensionVM.projectParent.description}}</label> </div> </div> </div> </div> <div class=row ng-if=extensionVM.projectParent.isProjectCross> <div class=\"col-md-6 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Tipo de proyecto:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.itemProjectTypeName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Metodología:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.methodology}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Comunidades implicadas:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.communities}}</label> </div> </div> </div> <div class=\"col-md-6 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Valor:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.value}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Entidad:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{extensionVM.projectParent.entityType}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Propósitos:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{extensionVM.projectParent.purposes}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Objetivos:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{extensionVM.projectParent.objectives}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Resultados:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{extensionVM.projectParent.results}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> </div> </div> <div class=row ng-if=\"extensionVM.projectParent.activityTypeId == 20\"> <div class=row ng-if=\"extensionVM.projectChilds.length > 0\"> <div class=\"col-md-12 text-left no-padding-r\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Actividades en curso </h5> <div class=\"row export-child\"> <div class=\"col-md-12 m-r-sm no-padding-l\" ng-repeat=\"child in extensionVM.projectChilds\"> <div class=col-md-9> <label class=\"text-gris-dark proxima text-block text-xs\" class=text-block>{{child.name}}</label> </div> <div class=\"col-md-2 text-center text-azul text-xs\"> {{child.hoursPlanned}} hrs Planeadas </div> <div class=col-md-1> <a ng-click=\"extensionVM.addActivityExtensionProject(extensionVM.projectParent, child)\" class=icon ng-class=classPlanning> <span class=\"icon i-20 mdi-content-create\"></span> </a> </div> <md-divider style=margin-top:36px></md-divider> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-v-lg\"> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-success no-margin\" type=button ng-click=\"extensionVM.addActivityExtensionProject(extensionVM.projectParent, null)\" ng-disabled=extensionVM.planningFinish>Agregar Actividades</md-button> </div> <div class=\"col-md-6 text-left\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" target=_blank ng-click=extensionVM.download()>Descargar Información</md-button> </div> </div> </div> </div> <div class=row ng-if=extensionVM.projectParent.isProjectCross> <div class=\"col-md-12 p-v-lg text-center\"> <md-button class=\"btn btn-fw btn-cancel no-margin\" target=_blank ng-click=extensionVM.downloadCross()>Descargar Información</md-button> </div> </div> </div> </div> ";

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <h3 class=\"text-block no-margin exo\"> Proyectos de extensión </h3> <p class=text-16-important> En esta sección puede visualizar proyectos transversales e internos y aregar nuevos proyectos internos </p> </div> <div class=\"col-md-4 p-h-lg p-v m-b-xs text-right\"> <md-button aria-label ui-sref=workplan.createExtensionProject class=\"btn btn-fw btn-primary text-xs p-h-md no-margin\" ng-disabled=extensionVM.planningFinish has-permission=proyectos-de-extension-edit> Agregar Proyecto </md-button> <md-button ng-if=\"extensionVM.feedback && !extensionVM.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=extensionVM.bitacora($event)> Bitácora de Proyectos de extensión </md-button> </div> </div> ";

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-6 no-padding rightDivider blanco\"> <p class=\"text-md text-gris-dark exo p-l-md\"> Listado de actividades</p> <div class=\"row search p-l p-r m-b-sm\"> <div class=col-md-12> <div class=\"input-group stylish-input-group\"> <input type=text ng-model=visibilityVM.criteriaFilter class=\"form-control p-l-md\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Buscar actividad\" ng-change=visibilityVM.updateFilter(search)> <div class=input-group-btn> <button class=\"btn btn-default search-btn\" type=submit><i class=\"mdi-action-search i-24\"></i></button> </div> </div> </div> </div> <md-virtual-repeat-container class=\"w-h-100 list-h scroll-55vh\" ng-if=\"visibilityVM.listVisibility.length > 0\"> <md-list> <md-list-item ng-class=visibilityVM.visibilityBckgrd(visibility) ng-model=visibilityVM.selectedProject class=md-2-line md-virtual-repeat=\"visibility in visibilityVM.listVisibility | filter: visibilityVM.criteriaFilter\" ng-click=visibilityVM.details(visibility)> <div ng-include=\"'list-data-visibility'\"></div> <md-list-item has-permission=visibilidad-edit ng-class=visibilityVM.visibilityText(visibility) class=no-padding-l> <a href ui-sref=\"workplan.createVisibility({workplanTeacherActivityId: visibility.workplanTeacherActivityId})\" class=\"icon p-h\" ng-class=classPlanning> <span class=\"icon i-24 mdi-content-create\"></span> <p class=\"text-xxs exo\">Editar</p> </a> <a href ng-click=visibilityVM.confirmDeleteVisibility(visibility) class=\"icon p-h\" ng-class=classPlanning> <span class=\"icon i-24 mdi-action-delete\"></span> <p class=\"text-xxs exo\">Eliminar</p> </a> </md-list-item> <project-visibility-tag class=\"text-color p-r\" project=visibility></project-visibility-tag> <md-divider ng-if=!$last></md-divider> </md-list-item> </md-list> </md-virtual-repeat-container> </div> ";

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-6 blanco\" ng-if=visibilityVM.thereIsDetails()> <div ng-include=\"'visibility-details-header'\"></div> </div> <div class=\"col-md-6 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=visibilityVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"visibilityVM.thereIsDetails() || visibilityVM.searchValue\" md-diameter=96> </md-progress-circular> </div> ";

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"p-v text-xs\"> <div class=md-list-item-text style=width:210px> <p ng-class=visibilityVM.visibilityText(visibility) class=\"text-sm-important text-color no-margin exo\"> <strong>{{ visibility.nameVisibility }}</strong> </p> <p ng-class=visibilityVM.visibilityText(visibility) class=\"text-xs-important no-margin proxima\"> {{ visibility.nameCommunicationType }} - {{ visibility.hoursPlanned }} hrs. planeadas </p> <p ng-class=visibilityVM.visibilityText(visibility) class=\"text-xs-important no-margin proxima\" ng-if=\"visibility.timeRangeTypeId == 1\"> {{ visibility.periodicityName }} </p> <p ng-class=visibilityVM.visibilityText(visibility) class=\"text-xs-important no-margin proxima\" ng-if=\"visibility.timeRangeTypeId == 2\"> {{ visibility.startDate }} - {{ visibility.endDate }} </p> </div> </div> ";

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"row m-t-md p-h-lg\" ng-if=\"visibilityVM.listVisibility.length == 0\"> <div class=\"col-md-12 p-v-md\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-center title\"> <p class=text-md>¡Aún no se ha registrado información en esta sección!</p> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs\" ng-if=\"visibilityVM.listVisibility.length > 0\"> <div class=row> <div class=\"col-md-7 no-padding\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Detalle proyecto - {{ visibilityVM.detailsData.nameVisibility}} </h5> </div> <div class=\"col-md-4 no-padding\"> <div class=row> <project-visibility-tag class=\"md-secondary text-color\" project=visibilityVM.selectedProject> </project-visibility-tag> </div> </div> </div> <div class=row ng-if=visibilityVM.isMedia> <div class=\"col-md-5 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-b\"> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Tipo:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameCommunicationType}}</label> </div> </div> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Rol:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameRol}}</label> </div> </div> </div> <div class=\"col-md-7 p-h-lg p-v m-b-xs text-sm no-padding-b\"> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Frecuencia de emision:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameFrequencyEmission}}</label> </div> </div> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Audiencia públicos:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameAudience}}</label> </div> </div> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Horas planeadas:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.hoursPlanned}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block><strong>URL:</strong></label> </div> <div class=\"col-md-10 text-left no-padding-r\"> <label class=\"w-h-100 word-wrap\">{{visibilityVM.detailsData.link}}</label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 1\"> <label class=text-block><strong>Períodos</strong></label> </div> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 2\"> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block><strong>Fecha Inicio</strong></label> </div> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block><strong>Fecha Fin</strong></label> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 1\"> <label class=text-block>{{visibilityVM.detailsData.periodicityName}}</label> </div> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 2\"> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block>{{visibilityVM.detailsData.startDate | date : 'dd/MM/yyyy' : 'UTC'}}</label> </div> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block>{{visibilityVM.detailsData.endDate | date : 'dd/MM/yyyy' : 'UTC'}}</label> </div> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Descripci&oacute;n:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.summary}}</label> </div> </div> </div> </div> <div class=row ng-if=visibilityVM.isNetwork> <div class=\"col-md-5 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-b\"> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Sector:</strong></label> </div> <div class=\"col-md-6 text-left no-padding\"> <label>{{visibilityVM.detailsData.nameSector}}</label> </div> </div> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Contacto:</strong></label> </div> <div class=\"col-md-6 text-left no-padding word-wrap\"> <label style=width:120px>{{visibilityVM.detailsData.contact}}</label> </div> </div> </div> <div class=\"col-md-7 p-h-lg p-v m-b-xs text-sm no-padding-b\"> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Red/Asociación:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameVisibility}}</label> </div> </div> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Ámbito/Escenario:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameAmbit}}</label> </div> </div> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Horas planeadas:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.hoursPlanned}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block><strong>Email:</strong> </label> </div> <div class=\"col-md-10 text-left no-padding-r word-wrap\"> <label>{{visibilityVM.detailsData.email}}</label> </div> </div> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block><strong>URL:</strong></label> </div> <div class=\"col-md-10 text-left no-padding-r\"> <label class=\"w-h-100 word-wrap\">{{visibilityVM.detailsData.link}}</label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 1\"> <label class=text-block><strong>Períodos</strong></label> </div> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 2\"> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block><strong>Fecha Inicio</strong></label> </div> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block><strong>Fecha Fin</strong></label> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 1\"> <label class=text-block>{{visibilityVM.detailsData.periodicityName}}</label> </div> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 2\"> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block>{{visibilityVM.detailsData.startDate | date : 'dd/MM/yyyy' : 'UTC'}}</label> </div> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block>{{visibilityVM.detailsData.endDate | date : 'dd/MM/yyyy' : 'UTC'}}</label> </div> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Descripci&oacute;n:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.summary}}</label> </div> </div> </div> </div> <div class=row ng-if=visibilityVM.isEvent> <div class=\"col-md-5 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-b\"> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Nombre:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameVisibility}}</label> </div> </div> <div class=row> <div class=\"col-md-6 text-left no-padding-r\"> <label class=text-block><strong>Unidad:</strong></label> </div> <div class=\"col-md-6 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.unitName}}</label> </div> </div> </div> <div class=\"col-md-7 p-h-lg p-v m-b-xs text-sm no-padding-b\"> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Ámbito/Escenario:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.nameAmbit}}</label> </div> </div> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Contacto:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r word-wrap\"> <label>{{visibilityVM.detailsData.contact}}</label> </div> </div> <div class=row> <div class=\"col-md-7 text-left no-padding-r\"> <label class=text-block><strong>Horas planeadas:</strong></label> </div> <div class=\"col-md-5 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.hoursPlanned}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-2 text-left no-padding-r\"> <label class=text-block><strong>URL:</strong></label> </div> <div class=\"col-md-10 text-left no-padding-r\"> <label class=\"w-h-100 word-wrap\">{{visibilityVM.detailsData.link}}</label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 1\"> <label class=text-block><strong>Períodos</strong></label> </div> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 2\"> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block><strong>Fecha Inicio</strong></label> </div> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block><strong>Fecha Fin</strong></label> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 1\"> <label class=text-block>{{visibilityVM.detailsData.periodicityName}}</label> </div> <div class=\"col-md-12 text-left no-padding-r\" ng-if=\"visibilityVM.detailsData.timeRangeTypeId == 2\"> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block>{{visibilityVM.detailsData.startDate | date : 'dd/MM/yyyy' : 'UTC'}}</label> </div> <div class=\"col-md-6 text-left no-padding\"> <label class=text-block>{{visibilityVM.detailsData.endDate | date : 'dd/MM/yyyy' : 'UTC'}}</label> </div> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Objetivo/Descripción:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{visibilityVM.detailsData.summary}}</label> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <h3 class=\"text-block no-margin exo\"> Comunicación y visibilidad </h3> <p class=text-16-important> En esta sección puede visualizar e ingresar actividades que den visibilidad a la universidad. </p> </div> <div class=\"col-md-5 p-h-lg p-v m-b-xs text-right\"> <md-button aria-label ui-sref=workplan.createVisibility class=\"btn btn-fw btn-primary text-xs p-h-md no-margin\" ng-click=\"\" has-permission=visibilidad-edit ng-disabled=visibilityVM.planningFinish> Agregar registro </md-button> <md-button ng-if=\"visibilityVM.feedback && !visibilityVM.planningFinish\" class=\"btn btn-fw btn-success text-xs p-h-md\" ng-click=visibilityVM.bitacora($event)> Bitácora de Comunicación y visibilidad </md-button> </div> </div> ";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan', 'GlobalConfig', 'WorkPlanModalSrv', 'WorkPlanSrv'];
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan, GlobalConfig, WorkPlanModalSrv, WorkPlanSrv) {
	  $templateCache.put('projects-list', __webpack_require__(679));
	  $templateCache.put('project-details', __webpack_require__(680));
	  $templateCache.put('list-data-project', __webpack_require__(681));
	  $templateCache.put('details-header-project', __webpack_require__(682));
	  $templateCache.put('header-project', __webpack_require__(683));
	  $templateCache.put('customStyle', __webpack_require__(684));
	
	  $templateCache.put('products-list', __webpack_require__(685));
	  $templateCache.put('products-details', __webpack_require__(686));
	  $templateCache.put('list-data-products', __webpack_require__(687));
	  $templateCache.put('details-header-products', __webpack_require__(688));
	  $templateCache.put('header-products', __webpack_require__(689));
	}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"blanco col-md-5 no-padding rightDivider\"> <p class=\"text-md text-gris-dark exo p-h m-t-sm\"> Listado de proyectos</p> <search-bar search-icon=true icon-size=20 opacity=true bar-style=\"'m-r p-l-md'\" on-change=projectsVm.updateFilter(search)> </search-bar> <md-divider ng-if=!$last></md-divider> <md-virtual-repeat-container class=\"w-h-100 list-h scroll-55vh\" ng-if=\"projectsVm.projectsList.length > 0\"> <md-list> <md-list-item aria-label=project ng-class=projectsVm.projectBckgrd(project) ng-model=projectsVm.selectedproject class=md-2-line md-virtual-repeat=\"project in projectsVm.projectsList | filter: projectsVm.criteriaFilter\" ng-click=projectsVm.details(project)> <div ng-include=\"'list-data-project'\"> </div> <md-divider ng-if=!$last></md-divider> </md-list-item> </md-list> </md-virtual-repeat-container> </div> ";

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"blanco col-md-7\" ng-if=projectsVm.thereIsDetails()> <div ng-include=\"'details-header-project'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=projectsVm.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"projectsVm.thereIsDetails() || projectsVm.searchValue\" md-diameter=96> </md-progress-circular> </div> ";

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-v> <div class=md-list-item-text style=width:370px> <p ng-class=projectsVm.projectText(project) class=\"text-color no-margin exo\"> <strong>{{ project.name }}</strong> </p> <p ng-class=projectsVm.projectText(project) class=\"text-sm no-margin proxima\"> Horas planeadas {{ project.hoursPlanned }} </p> </div> </div> ";

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"col-md-12 p-h-lg p-v m-b-xs\" ng-if=\"projectsVm.projectsList.length > 0\"> <div class=row> <div class=\"col-md-7 no-padding\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Detalle del proyecto - {{ projectsVm.projectParent.name }} </h5> </div> </div> <div class=\"row text-sm\"> <div class=\"col-md-6 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Unidad Académica:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\">{{projectsVm.projectParent.academicUnitName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Tipo de Proyecto:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\">{{projectsVm.projectParent.listItemProjectTypeName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Estado:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\">{{projectsVm.projectParent.estatus}}</label> </div> </div> </div> <div class=\"col-md-6 p-h-lg p-v m-b-xs no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Rol en el proyecto:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\">{{projectsVm.projectParent.listItemProjectRoleName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Financiadores:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\" class=text-block>{{projectsVm.projectParent.financialSourceName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Horas planeadas:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\" class=text-block>{{projectsVm.projectParent.hoursPlanned}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Descripción:</label> </div> <div class=\"col-md-12 text-left no-padding-r\"> <p class=\"text-gris-dark proxima ng-binding\" style=margin-left:-30px>{{projectsVm.projectParent.description}}</p> </div> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-6 m-t-xs text-left\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-disabled=projectsVm.planningFinish name=notification ng-model=projectsVm.isNotification ng-change=projectsVm.showNotification() value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> <div class=row ng-if=\"projectsVm.projectChilds.length > 0\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Actividades en curso </h5> <div class=\"col-md-12 m-r-sm no-padding-l\" ng-repeat=\"child in projectsVm.projectChilds\"> <div class=col-md-9> <label class=\"text-gris-dark proxima ng-binding\" class=text-block>{{child.name}}</label> </div> <div class=\"col-md-2 text-center text-azul text-xs\"> {{child.hoursPlanned}} hrs Planeadas </div> <div class=col-md-1> <a ng-click=\"projectsVm.addActivityProject(projectsVm.projectParent, child)\" class=icon ng-class=classPlanning> <span class=\"icon i-20 mdi-content-create\"></span> </a> </div> <md-divider style=margin-top:36px></md-divider> </div> </div> </div> </div> ";

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Proyectos</h3> <p class=text-16-important>En esta sección puede visualizar el listado de proyectos en curso y aquellos agregados por usted en el Sistema de Gestión de Investigación e Innovación PURE. Solamente los proyectos adicionados desde el Sistema de Gestión de Investigación e Innovación aparecerán en el listado.</p> </div> <div class=col-md-6> <md-button ng-if=\"projectsVm.feedback && !projectsVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=projectsVm.bitacora($event)> Bitácora de Proyectos </md-button> </div> </div> ";

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	module.exports = "<style>body .breadcrumb a,body .breadcrumb span{font-size:13px}</style>";

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"blanco col-md-5 no-padding rightDivider\"> <p class=\"text-md text-gris-dark exo p-h m-t-sm\"> Listado de productos en progreso</p> <search-bar search-icon=true icon-size=20 opacity=true bar-style=\"'m-r p-l-md'\" on-change=productsVm.updateFilter(search)> </search-bar> <md-divider ng-if=!$last></md-divider> <md-virtual-repeat-container class=\"w-h-100 list-h scroll-55vh\" ng-if=\"productsVm.productsList.length > 0\"> <md-list> <md-list-item ng-class=productsVm.productBckgrd(product) ng-model=productsVm.selectedproduct class=md-2-line md-virtual-repeat=\"product in productsVm.productsList | filter: productsVm.criteriaFilter\" ng-click=productsVm.details(product)> <div ng-include=\"'list-data-products'\"> </div> <md-list-item ng-class=productsVm.productText(product)> <div class=col-md-6> <a href has-permission=productos-edit ui-sref=\"workplan.createProduct({workplanTeacherActivityId: product.workplanTeacherActivityId})\" class=icon ng-class=classPlanning> <span class=\"icon i-24 mdi-content-create\"></span> <p class=\"text-xs exo\">Editar</p> </a> </div> <div class=col-md-6> <a href has-permission=productos-edit ng-click=productsVm.disableProductActivyId(product.workplanTeacherActivityId,product) class=icon ng-class=classPlanning> <span class=\"icon i-24 mdi-action-delete\"></span> <p class=\"text-xs exo\">Eliminar</p> </a> </div> </md-list-item> <md-divider ng-if=!$last></md-divider> </md-list-item> </md-list> </md-virtual-repeat-container> </div> ";

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"blanco col-md-7\" ng-if=productsVm.thereIsDetails()> <div ng-include=\"'details-header-products'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=productsVm.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"productsVm.thereIsDetails() || productsVm.searchValue\" md-diameter=96> </md-progress-circular> </div> ";

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = "<div class=p-v> <div class=md-list-item-text style=width:370px> <p ng-class=productsVm.productText(product) class=\"text-color no-margin exo\"> <strong>{{ product.name }}</strong> </p> <p ng-class=productsVm.productText(product) class=\"text-sm no-margin proxima\"> {{ product.itemProductName }} - {{product.subItemProductName}} </p> </div> </div> ";

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col-md-12 p-h-lg p-v m-b-xs\" ng-if=\"productsVm.productsList.length > 0\"> <div class=row> <div class=\"col-md-12 no-padding\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Detalle del producto - {{productsVm.productParent.itemProductName}}: {{ productsVm.productParent.name }} </h5> </div> </div> <div class=\"row text-sm\"> <div class=\"col-md-6 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Tipo de producto:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\">{{productsVm.productParent.itemProductName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Subtipo:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\">{{productsVm.productParent.subItemProductName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Área básica de conocimiento:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\">{{productsVm.productParent.itemKnowledgeName}}</label> </div> </div> </div> <div class=\"col-md-6 p-h-lg p-v m-b-xs no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Proyecto asociado:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\" class=text-block ng-if=productsVm.productParent.projectName> {{productsVm.productParent.projectName}} </label> <label class=\"text-gris-dark proxima ng-binding\" class=text-block ng-if=!productsVm.productParent.projectName> Sin Proyecto Asignado </label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Horas planeadas:</label> </div> <div class=\"col-md-7 text-left no-padding-l\"> <label class=\"text-gris-dark proxima ng-binding\" class=text-block>{{productsVm.productParent.hoursPlanned}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>{{productsVm.productParent.timeRangeTypeName}}:</label> </div> <div class=\"col-md-7 text-left no-padding-l\" ng-if=\"productsVm.productParent.timeRangeTypeId == 1\"> <label class=\"text-gris-dark proxima ng-binding\" class=text-block>{{productsVm.productParent.periodName}}</label> </div> <div class=\"col-md-7 text-left no-padding\" ng-if=\"productsVm.productParent.timeRangeTypeId == 2 \"> <label class=\"text-gris-dark proxima ng-binding\" class=text-block>{{productsVm.productParent.startDate | date: 'dd/MM/yyyy': 'UTC' }} - {{productsVm.productParent.endDate | date: 'dd/MM/yyyy': 'UTC'}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block style=margin-left:-30px>Descripción:</label> </div> <div class=\"col-md-12 text-left no-padding-r\"> <p class=\"text-gris-dark proxima ng-binding\" style=margin-left:-30px>{{productsVm.productParent.description}}</p> </div> </div> </div> </div> <div class=row ng-if=\"productsVm.productChilds.length > 0\"> <h5 class=\"text-azul m-r-sm font-bold text-block\"> Actividades en curso </h5> <div class=\"col-md-12 m-r-sm p-t-sm\" ng-repeat=\"child in productsVm.productChilds\"> <div class=col-md-9> <label class=\"text-gris-dark proxima ng-binding text-sm\">{{child.name}}</label> </div> <div class=\"col-md-2 text-center text-azul text-sm\"> {{child.hoursPlanned}} hrs Planeadas </div> <div class=col-md-1> <a ng-click=\"productsVm.addActivityProduct(productsVm.productParent, child)\" class=icon ng-class=classPlanning> <span class=\"icon i-20 mdi-content-create\"></span> </a> </div> <md-divider style=margin-top:36px></md-divider> </div> </div> <div class=row> <div class=\"col-md-12 text-center p-v-lg\"> <md-button class=\"btn btn-fw btn-success no-margin\" type=button ng-click=\"productsVm.addActivityProduct(productsVm.productParent, null)\" ng-disabled=\"productsVm.productParent.isProjectsAssociated || productsVm.planningFinish\">Agregar Actividades</md-button> </div> </div> </div> ";

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v no-padding-r m-b-xs\"> <h3>Productos</h3> <p class=text-16-important>En esta sección puede visualizar el listado de productos, agregar actividades a estos y agregar nuevos.</p> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-primary right\" has-permission=productos-edit ui-sref=workplan.createProduct ng-disabled=productsVm.planningFinish>Agregar producto</md-button> <md-button ng-if=\"productsVm.feedback && !productsVm.planningFinish\" class=\"btn btn-fw btn-success right text-xs\" ng-click=productsVm.bitacora($event)> Bitácora de Productos </md-button> </div> </div> ";

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanSrv = function WorkPlanSrv($resource, SERVICE_URL_CONSTANT, GlobalConfig) {
		_classCallCheck(this, WorkPlanSrv);
	
		var addOtherActivityAM = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addOtherActivityAM', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var getOtherActivityItemAM = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getOtherActivityItemAM', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var disableActivity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivity', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		// OTHER Services
		var getActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addActivityCommunity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityCommunity', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var getActivityDetailTeachingStaff = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityDetailTeachingStaff', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getActivitiesCombo = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getTypeActivities/combo/:listTypeId/:listId', {}, {
			getList: {
				method: 'GET'
			}
		});
	
		var addActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addOtherActivityItem', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var getActivityCommitteeByActivity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityCommitteeByActivity', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var addActivityCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityCommittee', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var getListOtherActivityItemAM = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListOtherActivityItemAM', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var addActivityPlanningTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityPlanningTeacher', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getDetailAsignaturePlanning = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getDetailAsignaturePlanning', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getWorkplanByEvaluatorAndStage = $resource(SERVICE_URL_CONSTANT.rosario + '/reviewer/getWorkplanByEvaluatorAndStage', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var updateActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/updateOtherActivityItem', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var deleteActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/deleteOtherActivityItem', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		var getActivityPlanningTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityPlanningTeacher', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getPreviusPlanning = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getPreviousActivitiesPlanning', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getDataFormCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommittee', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getActivityItem = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/:otherActivityCode', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getAsignaturesAssigned = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getAsignaturesAssigned', {}, {
			getList: {
				method: 'POST'
			}
		});
		var getPeriodicity = $resource(SERVICE_URL_CONSTANT.rosario + '/periodicity', {}, {
			get: {
				method: 'GET'
			}
		});
	
		// SCHEDULE SERVICES
		var getSchedules = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendar', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getSchedulesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendarReviewedReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/addActivityCalendar', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var disableSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/deleteActivityCalendar', {}, {
			disable: {
				method: 'POST'
			}
		});
	
		var getScheduleById = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendarById/:calendarId', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var updateSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/addActivityCalendar', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var getDataForSchedule = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormAttentionStudents', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getElementsRightBar = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getWorkPlanGeneral', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getIndicatorBySubmodule = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getIndicatorBySubmodule', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getAssignatureWithoutActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getAssignatureWithoutActivities', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getActivityCalendarReviewedRejectById = $resource(SERVICE_URL_CONSTANT.rosario + '/calendar/getActivityCalendarReviewedRejectById', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		// MESSEGES SERVICES
		var getMessages = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getNotificationToShowByUser', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getMessagesNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getMessagesNotification', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var updateReadingMessages = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/updateNotificationReadByUser', {}, {
			update: {
				method: 'POST'
			}
		});
	
		// END PLANNING SERVICE
		var getSummanyProgress = $resource(SERVICE_URL_CONSTANT.rosario + '/general/getSummaryProgressBySubmodule', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var endPlanning = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateWorkplanTeacherWithStage', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getItemRequiredTeaching = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getItemRequiredTeaching', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getItemRequiredOtherActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getItemRequiredOtherActivities', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		// ENDSTAGES SERVICE
		var endStages = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateWorkplanTeacherWithStage', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var getReprovedActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getReprovedActivities', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getAsignaturesAssignedReviewedReject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getAsignaturesAssignedReviewedReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var updateFeedbackActivate = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateFeedbackActivate', {}, {
			update: {
				method: 'POST'
			}
		});
	
		var addNotificationsTransactions = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactions', {}, {
			add: {
				method: 'POST'
			}
		});
	
		var addNotificationsTransactionsToAdmin = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/addNotificationsTransactionsToAdmin', {}, {
			add: {
				method: 'POST'
			}
		});
	
		// REVIEW SERVICE
	
		var getDelegationCharges = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDelegationCharges', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addActivityPlanningAcademic = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityPlanningAcademic', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getActivityPlanningAcademic = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityPlanningAcademic', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataRolesList = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataRolesList', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getActivityDetailAcademic = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getActivityDetailAcademic', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addRol = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addRol', {}, {
			save: {
				method: 'POST'
			}
		});
		var updateAssignatureWorkPlan = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/updateAssignatureWorkPlan', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var deleteParticipation = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivity', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		var getDataPhdList = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataPhdList', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addPhd = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addPhd', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var disableActivityTeachingStaff = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivityTeachingStaff', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		var getInstitutionCountry = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getInstitutionCountry', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormActivityTeaching = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormActivityTeaching', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getWorkPlansInReview = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/getWorkPlansInReview', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getDataCoursesList = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataCoursesList', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getCoursesIntern = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getCoursesIntern', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getCoursesInternDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getCoursesInternDetail', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addCourseExtern = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addCourseExtern', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getOtherActivitiesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getOtherActivitiesReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		// Body Consolidation Profesoral Sevices
		var getDataFormCommunities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommunities', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var deleteDataFormCommunities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivityTeachingStaff', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		// RESEARCH
		var getListProjectsFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListProjectsFormulated', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getListProjectsFormulatedReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListProjectsFormulatedReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var disableProject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableProject', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		var addProjectFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addProjectFormulated', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getProjectsFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectsFormulated', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getWorkPlansInApproved = $resource(SERVICE_URL_CONSTANT.rosario + '/workplan/getWorkPlansInApproved', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getListState = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListState', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getDataFormProjects = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjects', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormProjectsReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjectsReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getProjectByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectByActivityId', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var addActivityExecution = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityExecution', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var addActivityProject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityProject', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getFeedbackReviewedReject = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getFeedbackReviewedReject', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getFeedbackReviewedRejectGeneral = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getFeedbackReviewedRejectGeneral', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getDataFormProduct = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProduct', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormProductReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProductReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDelegationChargesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDelegationChargesReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getProductByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProductByActivityId', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var disableProductActivyId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableProductActivyId', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getDataFormCommitteeReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommitteeReject', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var addActivityProduct = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityProduct', {}, {
			save: {
				method: 'POST'
			}
		});
	
		// EXTENSION
		var getListFormulatedExtensionProjects = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListFormulatedExtensionProjects', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getListFormulatedExtensionProjectsReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListFormulatedExtensionProjectsReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getOtherActivityItemAMReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getOtherActivityItemAMReject', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getFormulatedExtensionProjectsById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getFormulatedExtensionProjectsById', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getListSpacesCollaboration = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListSpacesCollaboration', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getListSpacesCollaborationReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListSpacesCollaborationReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addProjectsExtensionFormulated = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addProjectsExtensionFormulated', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getDataRolesListReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataRolesListReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var disableActivityResearch = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/disableActivityResearch', {}, {
			delete: {
				method: 'POST'
			}
		});
	
		var getExtensionProjectsById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getExtensionProjectsById', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getDataPhdListReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataPhdListReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormAdviceConsultancy = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormAdviceConsultancy', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormAdviceConsultancyReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormAdviceConsultancyReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormCommunitiesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormCommunitiesReject', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var addAdviceConsultancy = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addAdviceConsultancy', {}, {
			save: {
				method: 'POST'
			}
		});
		var getDataCoursesListReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataCoursesListReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormProjectsExtension = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjectsExtension', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormProjectsExtensionReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormProjectsExtensionReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getProjectExtensionByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectExtensionByActivityId', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getProjectsCrossById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getProjectsCrossById', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var setDumpInformation = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/setDumpInformation', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var summary = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route/:workplanId/:teacherId', {}, {
			getDataGrid: {
				method: 'GET',
				params: {
					type: 'workplan',
					route: 'getSubmodulesRevision'
				}
			},
			getTeacherData: {
				method: 'GET',
				params: {
					type: 'teacher',
					route: 'getSummaryAprovedByTeacher'
				}
			},
			checkReviewerApprover: {
				method: 'POST',
				params: {
					type: 'workplan',
					route: 'checkReviewerApprover'
				}
			},
			approvalAll: {
				method: 'POST',
				params: {
					type: 'workplan',
					route: 'updateWorkPlanTeacher'
				}
			},
			approvalAllEvaluation: {
				method: 'POST',
				params: {
					type: 'workplan',
					route: 'updateWorkPlanTeacherForEvaluation'
				}
			}
	
		});
	
		var addSpaceCollaboration = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addSpaceCollaboration', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var addActivityProjectExtension = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addActivityProjectExtension', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getSpacesCollaboration = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getSpacesCollaboration', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getAdviceConsultancyById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getAdviceConsultancyById', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getListResearchTraining = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListResearchTraining', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getListResearchTrainingReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListResearchTrainingReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormShortCourses = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormShortCourses', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormShortCoursesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormShortCoursesReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addResearchTraining = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addResearchTraining', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var addShortCourses = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addShortCourses', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getResearchTrainingByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getResearchTrainingByActivityId', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getShortCoursesById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getShortCoursesById', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getDataFormTransferResults = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormTransferResults', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getDataFormTransferResultsReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getDataFormTransferResultsReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getListVisibilityActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListVisibilityActivities', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getListVisibilityActivitiesReject = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListVisibilityActivitiesReject', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var addTransferResult = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addTransferResult', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getVisibilityActivitiesById = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getVisibilityActivitiesById', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var addVisibilityActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/addVisibilityActivities', {}, {
			save: {
				method: 'POST'
			}
		});
	
		var getTransferResultsByActivityId = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getTransferResultsByActivityId', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getCriteriaCategoryDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getCriteriaCategoryDetail', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getWorkplanEvaluationCriteriaDetail = $resource(SERVICE_URL_CONSTANT.rosario + '/criteria/getWorkplanEvaluationCriteriaDetail', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getHistoryActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getHistoryActivities/:id', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var postUptHistoryActivities = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/postUptHistoryActivities', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getItemRequiredExecution = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getItemRequiredExecution', {}, {
			getList: {
				method: 'POST'
			}
		});
	
		var getEntries = $resource(SERVICE_URL_CONSTANT.rosario + '/:type/:route', {}, {
			entries: {
				method: 'POST',
				params: {
					type: 'strategic_tracking',
					route: 'getActivitiesEntries'
				}
			}
		});
	
		var addSpecialSituationTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/addSpecialSituationTeacher', {}, {
			set: {
				method: 'POST'
			}
		});
	
		var listUserNotify = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/listUserNotify', {}, {
			set: {
				method: 'POST'
			}
		});
	
		var setPlanningWorkplanByTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/setPlanningWorkplanByTeacher', {}, {
			set: {
				method: 'POST'
			}
		});
	
		var getRecordTeacher = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getRecordTeacher', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getActivitiesNotReviewed = $resource(SERVICE_URL_CONSTANT.rosario + '/teacher/getActivitiesNotReviewed', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var updateIsNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/updateIsNotification', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getListProjectsCross = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/getListProjectsCross', {}, {
			post: {
				method: 'POST'
			}
		});
	
		// SERVICES INJECTION
		return {
			addOtherActivityAM: addOtherActivityAM,
			getOtherActivityItemAM: getOtherActivityItemAM,
			disableActivity: disableActivity,
			getEntries: getEntries,
			// OTHER
			getActivities: getActivities,
			getActivitiesCombo: getActivitiesCombo,
			addActivityItem: addActivityItem,
			addSchedule: addSchedule,
			getActivityItem: getActivityItem,
			getSchedules: getSchedules,
			getMessages: getMessages,
			getMessagesNotification: getMessagesNotification,
			getDataForSchedule: getDataForSchedule,
			getScheduleById: getScheduleById,
			updateActivityItem: updateActivityItem,
			updateSchedule: updateSchedule,
			updateReadingMessages: updateReadingMessages,
			deleteActivityItem: deleteActivityItem,
			getAsignaturesAssigned: getAsignaturesAssigned,
			getElementsRightBar: getElementsRightBar,
			disableSchedule: disableSchedule,
			getActivityPlanningTeacher: getActivityPlanningTeacher,
			addActivityPlanningTeacher: addActivityPlanningTeacher,
			getDetailAsignaturePlanning: getDetailAsignaturePlanning,
			getAssignatureWithoutActivities: getAssignatureWithoutActivities,
			getPreviusPlanning: getPreviusPlanning,
			getDelegationCharges: getDelegationCharges,
			addActivityPlanningAcademic: addActivityPlanningAcademic,
			getActivityPlanningAcademic: getActivityPlanningAcademic,
			getDataRolesList: getDataRolesList,
			getActivityDetailAcademic: getActivityDetailAcademic,
			addRol: addRol,
			getDataPhdList: getDataPhdList,
			addPhd: addPhd,
			disableActivityTeachingStaff: disableActivityTeachingStaff,
			getInstitutionCountry: getInstitutionCountry,
			getDataCoursesList: getDataCoursesList,
			getCoursesIntern: getCoursesIntern,
			getCoursesInternDetail: getCoursesInternDetail,
			addCourseExtern: addCourseExtern,
			getPeriodicity: getPeriodicity,
			getActivityCalendarReviewedRejectById: getActivityCalendarReviewedRejectById,
			getOtherActivitiesReject: getOtherActivitiesReject,
			// END PLANNING
			getSummanyProgress: getSummanyProgress,
			endPlanning: endPlanning,
			listUserNotify: listUserNotify,
			// ENDSTAGES
			endStages: endStages,
			getReprovedActivities: getReprovedActivities,
			getAsignaturesAssignedReviewedReject: getAsignaturesAssignedReviewedReject,
			updateFeedbackActivate: updateFeedbackActivate,
			addSpecialSituationTeacher: addSpecialSituationTeacher,
			//
			getWorkplanByEvaluatorAndStage: getWorkplanByEvaluatorAndStage,
			deleteParticipation: deleteParticipation,
			getDataFormCommittee: getDataFormCommittee,
			getListOtherActivityItemAM: getListOtherActivityItemAM,
			addActivityCommittee: addActivityCommittee,
			updateAssignatureWorkPlan: updateAssignatureWorkPlan,
			getActivityCommitteeByActivity: getActivityCommitteeByActivity,
			getWorkPlansInReview: getWorkPlansInReview,
			getItemRequiredTeaching: getItemRequiredTeaching,
			getItemRequiredOtherActivities: getItemRequiredOtherActivities,
			// Body Consolidation Profesoral
			getDataFormCommunities: getDataFormCommunities,
			deleteDataFormCommunities: deleteDataFormCommunities,
			addActivityCommunity: addActivityCommunity,
			getActivityDetailTeachingStaff: getActivityDetailTeachingStaff,
			getDataFormActivityTeaching: getDataFormActivityTeaching,
			getWorkPlansInApproved: getWorkPlansInApproved,
			getListState: getListState,
			addActivityExecution: addActivityExecution,
	
			// RESEARCH
			getListProjectsFormulated: getListProjectsFormulated,
			disableProject: disableProject,
			addProjectFormulated: addProjectFormulated,
			getProjectsFormulated: getProjectsFormulated,
			getDataFormProjects: getDataFormProjects,
			getProjectByActivityId: getProjectByActivityId,
			addActivityProject: addActivityProject,
			getDataFormProduct: getDataFormProduct,
			getProductByActivityId: getProductByActivityId,
			disableProductActivyId: disableProductActivyId,
			addActivityProduct: addActivityProduct,
			getListSpacesCollaboration: getListSpacesCollaboration,
			disableActivityResearch: disableActivityResearch,
			addSpaceCollaboration: addSpaceCollaboration,
			getSpacesCollaboration: getSpacesCollaboration,
			getListResearchTraining: getListResearchTraining,
			addResearchTraining: addResearchTraining,
			getResearchTrainingByActivityId: getResearchTrainingByActivityId,
			getDataFormTransferResults: getDataFormTransferResults,
			addTransferResult: addTransferResult,
			getTransferResultsByActivityId: getTransferResultsByActivityId,
			getListSpacesCollaborationReject: getListSpacesCollaborationReject,
			getDataFormProductReject: getDataFormProductReject,
			getDataFormProjectsReject: getDataFormProjectsReject,
			getListProjectsFormulatedReject: getListProjectsFormulatedReject,
			getDataFormTransferResultsReject: getDataFormTransferResultsReject,
			getListResearchTrainingReject: getListResearchTrainingReject,
			getDataFormAdviceConsultancyReject: getDataFormAdviceConsultancyReject,
			updateIsNotification: updateIsNotification,
			getListProjectsCross: getListProjectsCross,
			//
			getFeedbackReviewedReject: getFeedbackReviewedReject,
			getFeedbackReviewedRejectGeneral: getFeedbackReviewedRejectGeneral,
			// EXTENSION
			getListFormulatedExtensionProjects: getListFormulatedExtensionProjects,
			getFormulatedExtensionProjectsById: getFormulatedExtensionProjectsById,
			addProjectsExtensionFormulated: addProjectsExtensionFormulated,
			getExtensionProjectsById: getExtensionProjectsById,
			getDataFormAdviceConsultancy: getDataFormAdviceConsultancy,
			addAdviceConsultancy: addAdviceConsultancy,
			getDataFormProjectsExtension: getDataFormProjectsExtension,
			getProjectExtensionByActivityId: getProjectExtensionByActivityId,
			addActivityProjectExtension: addActivityProjectExtension,
			getAdviceConsultancyById: getAdviceConsultancyById,
			getDataFormShortCourses: getDataFormShortCourses,
			addShortCourses: addShortCourses,
			getShortCoursesById: getShortCoursesById,
			getListVisibilityActivities: getListVisibilityActivities,
			getVisibilityActivitiesById: getVisibilityActivitiesById,
			addVisibilityActivities: addVisibilityActivities,
			getDelegationChargesReject: getDelegationChargesReject,
			getDataFormCommitteeReject: getDataFormCommitteeReject,
			getOtherActivityItemAMReject: getOtherActivityItemAMReject,
			getDataRolesListReject: getDataRolesListReject,
			getDataPhdListReject: getDataPhdListReject,
			getDataFormCommunitiesReject: getDataFormCommunitiesReject,
			getDataCoursesListReject: getDataCoursesListReject,
			setDumpInformation: setDumpInformation,
			summary: summary,
			getSchedulesReject: getSchedulesReject,
			getCriteriaCategoryDetail: getCriteriaCategoryDetail,
			getWorkplanEvaluationCriteriaDetail: getWorkplanEvaluationCriteriaDetail,
			getHistoryActivities: getHistoryActivities,
			postUptHistoryActivities: postUptHistoryActivities,
			getItemRequiredExecution: getItemRequiredExecution,
			getDataFormProjectsExtensionReject: getDataFormProjectsExtensionReject,
			getListFormulatedExtensionProjectsReject: getListFormulatedExtensionProjectsReject,
			getDataFormShortCoursesReject: getDataFormShortCoursesReject,
			getListVisibilityActivitiesReject: getListVisibilityActivitiesReject,
			addNotificationsTransactions: addNotificationsTransactions,
			getProjectsCrossById: getProjectsCrossById,
			addNotificationsTransactionsToAdmin: addNotificationsTransactionsToAdmin,
			setPlanningWorkplanByTeacher: setPlanningWorkplanByTeacher,
			getRecordTeacher: getRecordTeacher,
			getActivitiesNotReviewed: getActivitiesNotReviewed,
			getIndicatorBySubmodule: getIndicatorBySubmodule
		};
	};
	
	WorkPlanSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT', 'GlobalConfig'];
	exports.default = angular.module('services.WorkPlanSrv', []).service('WorkPlanSrv', WorkPlanSrv).name;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanModalSrv = function WorkPlanModalSrv($mdDialog, $cookies, WorkPlanSrv) {
		_classCallCheck(this, WorkPlanModalSrv);
	
		var endPlanning = function endPlanning() {
			return $mdDialog.show({
				controller: 'EndPlanningModalCtrl',
				template: __webpack_require__(692),
				clickOutsideToClose: false
			});
		};
	
		function addActivity() {
			var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'standard';
	
			switch (option) {
	
				case 'standard':
					return $mdDialog.show({
						controller: 'AddActivityCtrl',
						template: __webpack_require__(693),
						clickOutsideToClose: false,
						controllerAs: 'addActivity'
					});
				case 'custom':
					return $mdDialog.show({
						template: '<add-custom></add-custom>',
						clickOutsideToClose: false
					});
	
			}
		}
	
		var registerExecution = function registerExecution() {
			return $mdDialog.show({
				controller: 'RegisterExecutionCtrl',
				template: __webpack_require__(694),
				clickOutsideToClose: false,
				controllerAs: 'regExecution'
			});
		};
	
		var editChildrenExecution = function editChildrenExecution(activity) {
			return $mdDialog.show({
				controller: 'EditChildrenExecutionCtrl',
				template: __webpack_require__(695),
				clickOutsideToClose: false,
				controllerAs: 'editChildrenExecutionVm',
				locals: { activity: activity }
			});
		};
	
		var executionEntries = function executionEntries() {
			return $mdDialog.show({
				controller: 'ExecutionEntriesCtrl',
				template: __webpack_require__(696),
				clickOutsideToClose: false
			});
		};
	
		var endStage = function endStage() {
			return $mdDialog.show({
				controller: 'EndStageModalCtrl',
				controllerAs: 'endStageModalVm',
				template: __webpack_require__(697),
				clickOutsideToClose: false
			});
		};
	
		var feedbackReviewed = function feedbackReviewed() {
			return $mdDialog.show({
				controller: 'FeedbackReviewedModalCtrl',
				controllerAs: 'feedbackReviewedModalVm',
				template: __webpack_require__(698),
				clickOutsideToClose: false
			});
		};
	
		var addTeachingActivity = function addTeachingActivity() {
			return $mdDialog.show({
				controller: 'CreateActivityCtrl',
				controllerAs: 'createActivityVm',
				template: __webpack_require__(699),
				clickOutsideToClose: false
			});
		};
	
		var addAcademicManagementActivity = function addAcademicManagementActivity() {
			return $mdDialog.show({
				controller: 'CreateOtherActivityCtrl',
				controllerAs: 'createActivityVm',
				template: __webpack_require__(700),
				clickOutsideToClose: false
			});
		};
	
		var addAcademicManagementRole = function addAcademicManagementRole() {
			return $mdDialog.show({
				controller: 'CreateRoleCtrl',
				controllerAs: 'createRoleVm',
				template: __webpack_require__(701),
				clickOutsideToClose: false
			});
		};
	
		var addAcademicManagementCommitteParticipation = function addAcademicManagementCommitteParticipation() {
			return $mdDialog.show({
				controller: 'CreateParticipationCtrl',
				controllerAs: 'participationVm',
				template: __webpack_require__(702),
				clickOutsideToClose: false
			});
		};
	
		var itemRequiredTeaching = function itemRequiredTeaching() {
			return $mdDialog.show({
				controller: 'ItemRequiredModalCtrl',
				template: __webpack_require__(703),
				clickOutsideToClose: false
			});
		};
	
		var itemRequiredExecution = function itemRequiredExecution() {
			return $mdDialog.show({
				controller: 'ItemRequiredExecutionModalCtrl',
				template: __webpack_require__(704),
				clickOutsideToClose: false
			});
		};
	
		var setupActivity = function setupActivity(scope, activity) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', '$state', 'ReviewSrv', function ($scope, $mdDialog, $state, ReviewSrv) {
					$scope.save = function () {
						var header = { id_code: activity.workplanTeacherActivityId };
	
						ReviewSrv.setactivityTag.set(header).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								$scope.close();
								$state.reload();
							}
						});
					};
					$scope.close = function () {
						scope.cb1 = true;
						$mdDialog.hide();
					};
				}],
				// template: '<div ng-include="setupErrorModal"><div>',
				template: __webpack_require__(705),
				clickOutsideToClose: false
			});
		};
	
		var successDialog = function successDialog(shared) {
			return $mdDialog.show({
				controller: 'SuccessDialogCtrl',
				controllerAs: 'ctrlModalVM',
				template: __webpack_require__(706),
				clickOutsideToClose: false,
				params: {
					shared: shared
				}
			});
		};
	
		var reusableVariable = null;
		var reusableVariable2 = null;
	
		function setVariable(variable) {
			reusableVariable = variable;
	
			return reusableVariable;
		}
	
		function getVariable() {
			var unload = reusableVariable;
	
			reusableVariable = null;
	
			return unload;
		}
	
		function setVariableSuccessDialog(variable) {
			reusableVariable2 = variable;
	
			return reusableVariable2;
		}
	
		function getVariableSuccessDialog() {
			var unload = reusableVariable2;
	
			reusableVariable2 = null;
	
			return unload;
		}
	
		var addConsolidationCourseExternal = function addConsolidationCourseExternal() {
			return $mdDialog.show({
				controller: 'CreateCourseCtrl',
				controllerAs: 'createCourseVm',
				template: __webpack_require__(707),
				clickOutsideToClose: true
			});
		};
	
		var addConsolidationLearningComunity = function addConsolidationLearningComunity() {
			return $mdDialog.show({
				controller: 'CreateLearningComunityCtrl',
				controllerAs: 'createLearningComunityVM',
				template: __webpack_require__(708),
				clickOutsideToClose: true
			});
		};
	
		var addDoctoralEducation = function addDoctoralEducation() {
			return $mdDialog.show({
				controller: 'CreateDoctorateCtrl',
				controllerAs: 'createDoctorateVm',
				template: __webpack_require__(709),
				clickOutsideToClose: true
			});
		};
	
		var addConsolidationOfferCourses = function addConsolidationOfferCourses() {
			return $mdDialog.show({
				controller: 'ReviewTeacherDevelopmentCtrl',
				controllerAs: 'reviewTVM',
				template: __webpack_require__(710),
				clickOutsideToClose: true
			});
		};
	
		var listTransversalProjects = function listTransversalProjects() {
			return $mdDialog.show({
				controller: 'listTransversalProjectsCtrl',
				controllerAs: 'listTPCtrl',
				template: __webpack_require__(711),
				clickOutsideToClose: true
			});
		};
	
		var addActivityProject = function addActivityProject() {
			return $mdDialog.show({
				controller: 'CreateProjectCtrl',
				controllerAs: 'createProjectVm',
				template: __webpack_require__(712),
				clickOutsideToClose: true
			});
		};
	
		var addActivityProduct = function addActivityProduct() {
			return $mdDialog.show({
				controller: 'CreateProductCtrl',
				controllerAs: 'createProductVm',
				template: __webpack_require__(713),
				clickOutsideToClose: true
			});
		};
	
		var viewFile = function viewFile() {
			return $mdDialog.show({
				controller: 'ViewFileCtrl',
				template: __webpack_require__(714),
				clickOutsideToClose: true,
				preserveScope: true
			});
		};
	
		var addActivityExtensionProject = function addActivityExtensionProject() {
			return $mdDialog.show({
				controller: 'CreateExtensionProjectCtrl',
				controllerAs: 'createExtensionProjectVm',
				template: __webpack_require__(715),
				clickOutsideToClose: true
			});
		};
	
		var addInvestigationProjectsFormulation = function addInvestigationProjectsFormulation() {
			return $mdDialog.show({
				controller: 'CreateProjectFormulationCtrl',
				controllerAs: 'createProjectFormulationVm',
				template: __webpack_require__(716),
				clickOutsideToClose: true
			});
		};
	
		var addInvestigationProjects = function addInvestigationProjects() {
			return $mdDialog.show({
				controller: 'CreateProjectCtrl',
				controllerAs: 'createProjectVm',
				template: __webpack_require__(717),
				clickOutsideToClose: true
			});
		};
	
		var addInvestigationProducts = function addInvestigationProducts() {
			return $mdDialog.show({
				controller: 'CreateProductCtrl',
				controllerAs: 'createProductVm',
				template: __webpack_require__(718),
				clickOutsideToClose: true
			});
		};
	
		var addInvestigationSpace = function addInvestigationSpace() {
			return $mdDialog.show({
				controller: 'CreateSpaceCtrl',
				controllerAs: 'createSpaceVm',
				template: __webpack_require__(719),
				clickOutsideToClose: true
			});
		};
	
		var addInvestigationTrainingResearch = function addInvestigationTrainingResearch() {
			return $mdDialog.show({
				controller: 'CreateTrainingResearchCtrl',
				controllerAs: 'createTrainingVm',
				template: __webpack_require__(720),
				clickOutsideToClose: true
			});
		};
	
		var addInvestigationResultsTransfer = function addInvestigationResultsTransfer() {
			return $mdDialog.show({
				controller: 'CreateResultsTransferCtrl',
				controllerAs: 'createTransferVm',
				template: __webpack_require__(721),
				clickOutsideToClose: true
			});
		};
	
		var addProjectFormulation = function addProjectFormulation() {
			return $mdDialog.show({
				controller: 'CreateProjectFormulationProposalCtrl',
				controllerAs: 'createProjectFormulationProposalVm',
				template: __webpack_require__(722),
				clickOutsideToClose: true
			});
		};
	
		var addProjectExtension = function addProjectExtension() {
			return $mdDialog.show({
				controller: 'CreateExtensionProjectCtrl',
				controllerAs: 'createExtensionProjectVm',
				template: __webpack_require__(723),
				clickOutsideToClose: true
			});
		};
	
		var addVisibility = function addVisibility() {
			return $mdDialog.show({
				controller: 'CreateVisibilityCtrl',
				controllerAs: 'createVisibilityVm',
				template: __webpack_require__(724),
				clickOutsideToClose: true
			});
		};
	
		var addCounselingAndConsultancy = function addCounselingAndConsultancy() {
			return $mdDialog.show({
				controller: 'CreateCounselingAndConsultancyCtrl',
				controllerAs: 'createCounselingAndConsultancyVm',
				template: __webpack_require__(725),
				clickOutsideToClose: true
			});
		};
	
		var addEducation = function addEducation() {
			return $mdDialog.show({
				controller: 'CreateShortCoursesCtrl',
				controllerAs: 'createShortCourseVm',
				template: __webpack_require__(726),
				clickOutsideToClose: true
			});
		};
	
		return {
			endPlanning: endPlanning,
			addActivity: addActivity,
			registerExecution: registerExecution,
			editChildrenExecution: editChildrenExecution,
			executionEntries: executionEntries,
			endStage: endStage,
			addTeachingActivity: addTeachingActivity,
			addAcademicManagementActivity: addAcademicManagementActivity,
			addAcademicManagementRole: addAcademicManagementRole,
			addAcademicManagementCommitteParticipation: addAcademicManagementCommitteParticipation,
			itemRequiredTeaching: itemRequiredTeaching,
			addConsolidationCourseExternal: addConsolidationCourseExternal,
			addConsolidationLearningComunity: addConsolidationLearningComunity,
			addDoctoralEducation: addDoctoralEducation,
			addConsolidationOfferCourses: addConsolidationOfferCourses,
			listTransversalProjects: listTransversalProjects,
			addActivityProject: addActivityProject,
			addActivityProduct: addActivityProduct,
			viewFile: viewFile,
			feedbackReviewed: feedbackReviewed,
			itemRequiredExecution: itemRequiredExecution,
			addInvestigationProjectsFormulation: addInvestigationProjectsFormulation,
			addInvestigationProjects: addInvestigationProjects,
			addInvestigationProducts: addInvestigationProducts,
			successDialog: successDialog,
			addInvestigationSpace: addInvestigationSpace,
			addInvestigationTrainingResearch: addInvestigationTrainingResearch,
			addInvestigationResultsTransfer: addInvestigationResultsTransfer,
			// extension
			addActivityExtensionProject: addActivityExtensionProject,
			addProjectFormulation: addProjectFormulation,
			addProjectExtension: addProjectExtension,
			addVisibility: addVisibility,
			addCounselingAndConsultancy: addCounselingAndConsultancy,
			addEducation: addEducation,
			setupActivity: setupActivity,
			// open methods
			setVariable: setVariable,
			getVariable: getVariable,
			getVariableSuccessDialog: getVariableSuccessDialog,
			setVariableSuccessDialog: setVariableSuccessDialog
	
		};
	};
	
	WorkPlanModalSrv.$inject = ['$mdDialog', '$cookies', 'WorkPlanSrv'];
	exports.default = angular.module('services.WorkPlanModalSrv', []).service('WorkPlanModalSrv', WorkPlanModalSrv).name;

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=\"text-center text-azul\">Finalizar {{stageName}}</h3> <p class=text-center> {{stageNameText}} </p> </div> <div class=col-md-12> <table class=m-v-md style=margin-left:auto;margin-right:auto> <tr class=\"text-azul text-base\"> <th class=\"font-normal text-center\" style=width:250px>Actividad</th> <th class=\"font-normal p-h text-center\">N° de Horas</th> <th class=\"font-normal text-center\">Porcentaje</th> </tr> <tr class=text-sm ng-repeat=\"submodule in data\"> <td class=\"text-left p-v-xs\">{{submodule.submoduleName}}</td> <td class=\"text-center p-v-xs\">{{isPlanning ? submodule.hours : submodule.hoursExecuted}}</td> <td class=\"text-center p-v-xs\">{{isPlanning ? submodule.percentage : submodule.percentageExecuted}}%</td> </tr> </table> </div> <div class=\"text-center col-md-12\"> <div ng-class=classPlanning> <h3>{{totalHours}}</h3> <h5 class=text-azul>Total horas planeadas</h5> </div> <div class=col-md-6 ng-if=!isPlanning> <h3>{{totalHoursExecution}}</h3> <h5 class=text-azul>Total horas ejecutadas</h5> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-center\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=endPlanning()>Finalizar</md-button> </div> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=addActivity.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 m-b\"> <h3 class=\"text-center text-azul\">Agregar actividad</h3> </div> </div> <form name=addActivityForm> <div class=\"p-h-lg m-h-lg\"> <div class=col-md-12> <div class=form-group ng-class=addActivity.hasError(addActivityForm.listItem)> <label for=listItem class=control-label>Seleccione tipo de actividad</label> <select name=listItem ng-model=addActivity.listItemId class=form-control required ng-options=\"activity.idListItem as activity.listItemName for activity in activities\"> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=addActivityForm.listItem.$error ng-show=addActivity.showErrorMessages(addActivityForm.listItem)> <div class=text-left ng-message=required>El tipo de actividad es requerido</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=addActivity.hasError(addActivityForm.observations)> <label class=control-label>Observaciones</label> <md-input-container class=control-label> <textarea name=observations ng-model=addActivity.observationsAdd maxlength=500 md-maxlength=500 md-select-on-focus ng-model-options=\"{ debounce: 300 }\" rows=4 required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=addActivityForm.observations.$error ng-show=addActivity.showErrorMessages(addActivityForm.observations)> <div ng-message=required class=text-xs>La observaci&oacute;n es requerida</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </form> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=addActivity.close()>Cancelar</md-button> <md-button aria-label class=\"btn btn-fw btn-success\" ng-disabled=\"addActivity.isSaveButtonDisabled || addActivity.validateForm(addActivityForm)\" ng-click=addActivity.addActivityNew()>Finalizar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<style>.btn-per{max-height:20px;max-width:50px;line-height:20px}</style> <md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=\"text-center text-azul\">{{action}} ejecución</h3> </div> </div> <form name=registerExecutionForm data-ng-hide=showForm> <div class=\"row text-left\"> <div class=\"col-md-12 m-t-lg\"> <div class=form-inline> <div class=form-group ng-class=hasError(registerExecutionForm.hoursExecuted)> <label class=\"text-md control-label text-gris-darker\">Horas ejecutadas</label> <input type=number class=form-control ng-model=hoursExecuted name=hoursExecuted onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" min=0 required> <div class=\"control-label text-xs\" ng-messages=registerExecutionForm.hoursExecuted.$error role=alert ng-show=showErrorMessages(registerExecutionForm.hoursExecuted)> <div ng-message=required>Las horas ejecutadas son requeridas</div> <div ng-message=min>Las horas ejecutadas deben ser mayor o igual 0</div> </div> </div> </div> </div> <div class=text-left> <div class=\"col-md-6 m-t-lg\" ng-class=hasError(registerExecutionForm.start_date) ng-if=true> <label class=\"text-md control-label text-gris-darker\" for=start_date>Fecha inicio</label> <md-datepicker ng-model=startDate name=start_date md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa ng-change=\"startDateChange(startDate, 'start')\" md-min-date=minStartDate md-max-date=end_date min=\"{{minStartDate | date: 'dd/MM/yyyy' }}\" required> </md-datepicker> <div class=\"control-label text-xs\" ng-messages=registerExecutionForm.start_date.$error role=alert ng-show=showErrorMessages(registerExecutionForm.start_date) multiple=multiple> <div ng-message=required class=\"my-message font-color: @danger\">Debe completar la fecha de inicio</div> </div> </div> <div class=\"col-md-6 m-t-lg\" ng-class=hasError(registerExecutionForm.end_date) ng-if=true> <label class=\"text-md control-label text-gris-darker\" for=end_date>Fecha fin</label> <md-datepicker ng-model=endDate name=end_date md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-min-date=minEndDate min={{minEndDate}} ng-change=\"startDateChange(endDate, 'end')\" ng-disabled=disabledEndDate required> </md-datepicker> <div class=\"control-label text-xs\" ng-messages=registerExecutionForm.end_date.$error role=alert ng-show=showErrorMessages(registerExecutionForm.end_date) multiple=multiple> <div ng-message=required class=\"my-message font-color: @danger\">Debe completar la fecha de fin</div> </div> </div> </div> <div class=\"col-md-12 m-t-lg\"> <label class=\"text-md control-label text-gris-darker\">Estado</label> <select name=state ng-model=state class=form-control ng-options=\"listStates.stateId as listStates.stateName for listStates in states\" ng-required=requireState> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div ng-messages=registerExecutionForm.state.$error role=alert ng-show=showErrorMessages(registerExecutionForm.state) multiple=multiple> <div ng-message=required class=my-message>El estado es obligatorio</div> </div> </div> <div class=\"col-md-12 m-t-lg\"> <div class=form-group ng-class=hasError(registerExecutionForm.observations)> <span ng-show=inExtension class=\"text-md control-label text-gris-darker\">Resultados</span> <span ng-show=!inExtension class=\"text-md control-label text-gris-darker\">Observaciones</span> <md-input-container class=control-label> <textarea name=observations ng-model=observations maxlength=500 md-maxlength=500 class=form-control ng-required=!inInvestigation ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div ng-messages=registerExecutionForm.observations.$error role=alert ng-show=showErrorMessages(registerExecutionForm.observations) multiple=multiple> <div ng-show=!inExtension ng-message=required class=my-message>Las obeservaciones son requeridas</div> <div ng-show=inExtension ng-message=required class=my-message>Los resultados son requeridos</div> <div ng-message=md-maxlength class=my-message> No debe excederse de la cantidad de letras proveidas </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-12 m-t-lg\"> <div class=\"col-md-12 text-negro text-left text-xs p-sm no-padding-l\"> <i class=\"mdi-action-info-outline text-left text-azul i-16\" aria-label=info></i> Adjunte solamente documentos en formato pdf </div> <div class=\"p-b-md filetype_upload\"> <div class=\"col-md-8 no-padding text-xs\"> <input type=file id=uploader nv-file-select=\"\" uploader=uploader name=uploader /> </div> <div class=col-md-4> <button type=button class=\"btn btn-primary md-raised m-b btn-fw\" ng-click=uploader.queue[0].upload() ng-hide=\"STATIC_IMAGE_URL || loading\"> <span class=\"glyphicon glyphicon-upload\"></span> Adjuntar Archivo </button> <div ng-if=loading class=loader></div> <button type=button class=\"btn btn-danger md-raised m-b btn-fw\" ng-click=remove() ng-hide=\"!STATIC_IMAGE_URL || loading\"> <span class=\"glyphicon glyphicon-trash\"></span> Eliminar </button> </div> </div> <div class=\"text-left m-t-lg-sm\" ng-show=attachFile> <h4 class=text-negro>Archivos Adjuntos</h4> <h4 class=\"text-negro text-md\">{{attachFile}}</h4> </div> </div> </div> </form> <div class=\"col-md-12 text-center text-padd\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button id=register class=\"btn btn-fw btn-success\" ng-disabled=validateForm(registerExecutionForm) ng-click=register()>{{action}}</md-button> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=\"{{!inTeaching ? 60 : 40}}\"> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=\"text-center text-azul\">Editar ejecución</h3> </div> </div> <div class=\"row m-t-sm\"> <div ng-class=vm.contentCSS class=text-left> </div> <table class=\"table table-striped text-left text-xs\"> <tbody> <tr> <th ng-show=!inTeaching>Fecha Inicio</th> <th ng-show=!inTeaching>Fecha Fin</th> <th>Descripción</th> <th>Horas</th> <th>Acción</th> </tr> <tr ng-repeat=\"regExe in variable \"> <td ng-show=!inTeaching> <md-datepicker ng-model=regExe.dt_start_date md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-max-date=regExe.dt_end_date> </md-datepicker> </td> <td ng-show=!inTeaching> <md-datepicker ng-model=regExe.dt_end_date md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-min-date=regExe.dt_start_date min={{regExe.dt_start_date}}> </md-datepicker> </td> <td><input class=form-control type=text ng-model=regExe.ds_description ng-model-options=\"{ debounce: 300 }\" style=width:200px;border-radius:5%></td> <td><input class=form-control type=number min=0 onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-model=regExe.num_hours_executed style=width:90px!important;border-radius:5%></td> <td><md-button class=\"btn btn-xs btn-success\" ng-click=regUpdate(regExe,$index) ng-disabled=saving>Actualizar</md-button></td> </tr> </tbody> </table> </div> <div class=\"col-md-12 text-center\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=close()>Cerrar</md-button> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h4 class=\"text-center text-azul\">Registro de ejecución de - {{ activity.asignatureName || activity.workplanTeacherChargeName || activity.roleName || activity.scheduleTypeName|| activity.activityName }}</h4> </div> </div> <md-divider></md-divider> <div ng-repeat=\"entry in entries\"> <div class=row> <p class=\"left text-azul text-md exo\">{{entry.startDate}}</p> <p class=\"right text-azul text-md exo\">{{entry.hoursExecuted}}h</p> </div> <div class=row> <div class=col-xs-8> <p class=\"text-left proxima\">{{entry.descriptionExecution}}</p> </div> <div class=col-xs-4 ng-show=entry.evidence> <a class=underscore ng-click=download(entry.evidence)>Documento</a> </div> </div> <md-divider></md-divider> </div> <div class=row ng-if=\"entries.length == 0\"> <div class=\"col-md-12 text-center text-base\"> <p>Actualmente no tiene registro de ejecución</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label=close class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=endStageModalVm.close() aria-label=cerrar> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-azul>Finalizar {{endStageModalVm.textStage}} </h3> </div> </div> <div class=row> <div class=col-xs-12> <div class=loading-details style=padding-top:5% ng-if=\"endStageModalVm.isAllReviewed() && \n                 endStageModalVm.criteriaList.length <= 0 && \n                 (endStageModalVm.inApproval || endStageModalVm.inEvaluation || (endStageModalVm.isReviewAndApproval &&  (endStageModalVm.inReview || endStageModalVm.inReviewExecution )))\"> <div layout=row layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> <div class=\"col-md-12 text-center\" ng-show=endStageModalVm.isToReviewed()> <h4 ng-show=\"!endStageModalVm.inReviewExecution && !endStageModalVm.inReview\">Revise todas la actividades para poder finalizar {{endStageModalVm.textStage}}</h4> <div ng-show=\"(endStageModalVm.inReview || endStageModalVm.inReviewExecution) && endStageModalVm.pendingBreakdownLoading\"> <md-progress-circular md-mode=indeterminate md-diameter=32></md-progress-circular> </div> <h4 ng-show=\"(endStageModalVm.inReview || endStageModalVm.inReviewExecution) && endStageModalVm.pendingBreakdown && endStageModalVm.assignedAllApproved()\"> Todas las actividades de los subm&oacute;dulos asignados a usted fueron aprobadas. </h4> <h4 ng-show=\"(endStageModalVm.inReview || endStageModalVm.inReviewExecution) && endStageModalVm.pendingBreakdown && !endStageModalVm.assignedAllApproved()\"> Revise todas la actividades de los subm&oacute;dulos asignados a usted para poder finalizar {{endStageModalVm.textStage}}. </h4> <div ng-show=\"(endStageModalVm.inReview || endStageModalVm.inReviewExecution) && endStageModalVm.hasPendingOther()\" class=text-left style=\"padding:0 20px\"> <p>Actividades pendientes en subm&oacute;dulos no asignados a usted:</p> <ul> <li ng-repeat=\"item in endStageModalVm.pendingBreakdown.other\"> {{ item.submoduleName }}: {{ item.pending }} </li> </ul> <p class=text-xs>Debe esperar a que el revisor correspondiente las revise antes de finalizar.</p> </div> </div> <form name=endStageForm novalidate> <div class=row ng-show=endStageModalVm.isAllReviewed()> <div class=\"col-md-12 m-t text-left\" ng-if=\"endStageModalVm.inReview || endStageModalVm.inReviewExecution\"> <p ng-show=\"endStageModalVm.pendingBreakdown && endStageModalVm.assignedAllApproved()\" class=text-success> Todas las actividades de los subm&oacute;dulos asignados a usted fueron aprobadas. </p> <div ng-show=endStageModalVm.hasPendingOther()> <p>Actividades pendientes en subm&oacute;dulos no asignados a usted:</p> <ul> <li ng-repeat=\"item in endStageModalVm.pendingBreakdown.other\"> {{ item.submoduleName }}: {{ item.pending }} </li> </ul> </div> </div> <div class=\"col-md-12 m-v-xs text-left\" ng-if=\"endStageModalVm.criteriaList.length > 0 &&\n            (endStageModalVm.inApproval || endStageModalVm.inEvaluation || (endStageModalVm.isReviewAndApproval &&  (endStageModalVm.inReview || endStageModalVm.inReviewExecution )))\" ng-class=\"{'has-error': endStageForm.aprobar.$invalid}\"> <label class=\"control-label text-md\" for=aprobar>&iquest;Con cu&aacute;l resultado finalizar&aacute; esta etapa? </label> <div class=\"col-md-12 m-v-xs text-left\" ng-if=\"endStageModalVm.inEvaluation || endStageModalVm.inApproval  || (endStageModalVm.isReviewAndApproval &&  (endStageModalVm.inReview || endStageModalVm.inReviewExecution ))\" ng-class=endStageModalVm.hasError(endStageForm.aprobar)> <div class=\"col-md-12 m-v-xs\" ng-repeat=\"listCriteria in endStageModalVm.criteriaList\"> <div class=input-group> <div class=\"radio-options no-margin\"> <input type=radio name=aprobar ng-model=endStageModalVm.idList ng-value=listCriteria.id_lists_item ng-change=endStageModalVm.selectedCriteria() ng-required=\"endStageModalVm.inEvaluation || endStageModalVm.inApproval || (endStageModalVm.isReviewAndApproval &&  (endStageModalVm.inReview || endStageModalVm.inReviewExecution ))\"> <i class=radio-green></i> <label class=text-xs>{{listCriteria.lists_item_name}} </label> </div> <md-tooltip md-direction=top>{{listCriteria.ds_description}}</md-tooltip> </div> </div> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"endStageModalVm.isNotTouchedCriterias && (endStageModalVm.inEvaluation || endStageModalVm.inApproval ||  (endStageModalVm.isReviewAndApproval &&  (endStageModalVm.inReview || endStageModalVm.inReviewExecution )))\"> Seleccione al menos 1 criterio </label> </div> </div> <div class=\"col-md-12 m-t text-left\"> <div class=\"form-group no-margin\" ng-class=endStageModalVm.hasError(endStageForm.description)> <label for=description>Observaciones de {{endStageModalVm.textStage}} </label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=endStageModalVm.description maxlength=500 md-maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div ng-messages=endStageForm.description.$error role=alert ng-show=endStageModalVm.showErrorMessages(endStageForm.description) multiple=multiple> <div ng-message=required class=my-message>La observaci&oacute;n es requerida</div> <div ng-message=md-maxlength class=my-message> No debe excederse de la cantidad de letras proveidas </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">N&uacute;mero de caracteres</div> </div> </div> </md-input-container> </div> </div> </div> <div class=\"row text-center\" ng-show=endStageModalVm.isAllReviewed()> <div class=\"col-md-12 m-t-md\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=endStageModalVm.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-primary\" ng-disabled=endStageModalVm.validateForm(endStageForm) ng-click=endStageModalVm.finish()>Finalizar</md-button> </div> </div> <div class=\"row text-center\" ng-show=endStageModalVm.isToReviewed()> <div class=\"col-md-12 m-t-md\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=endStageModalVm.close()>Cancelar</md-button> </div> </div> </form> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>En este momento usted enviará el resultado de revisión de las siguientes actividades al profesor para que realice las respectivas correcciones sobre su plan de trabajo. Recuerde añadir un comentario general de la revisión para ser tomado en cuenta por el profesor:</p> </div> </div> <div ng-repeat=\"module in activities\"> <div class=\"row p-v-xs\"> <div class=col-md-12> <a ng-click=toggleSubcategories(module)> <p class=\"text-left text-ms no-margin\">{{module.submodule}} <label ng-if=!module.showChilds class=\"icon mdi-content-add i-20 pull-right\"></label> <label ng-if=module.showChilds class=\"icon mdi-content-remove i-20 pull-right\"></label> </p> </a> </div> </div> <div class=\"row p-v-xs no-padding-t\" ng-if=module.showChilds> <ul class=\"p-l-xl with-bullets bullets-md p-h-md\"> <li ng-repeat=\"activity in module.activities track by $index\" class=m-v-sm> <p class=\"text-left text-xs p-l-sm\"> {{activity}} </p> </li> </ul> </div> </div> <p></p> <div class=\"row title text-center\"> <div> <md-input-container md-no-float class=\"control-label no-margin\"> <textarea type=text ng-model=vm.comment class=form-control placeholder=\"Escribir un comentario\" maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=feedback(vm.comment)>Sí</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createActivityVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Crear actividad</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar una nueva actividad. Una vez terminado haga clic en el bot&oacute;n agregar actividad </p> </div> </div> <form name=createActivity novalidate> <div class=row> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-9 no-padding-r\"> <div class=form-group ng-class=createActivityVm.hasError(createActivity.typeActivity)> <label for=typeActivity class=\"control-label pull-left\">Tipo de actividad</label> <select name=typeActivity ng-model=createActivityVm.typeActivity ng-options=\"listActivities.activityTypeCode as listActivities.activityTypeName for listActivities in createActivityVm.comboActivities\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createActivity.typeActivity.$error ng-show=createActivityVm.showErrorMessages(createActivity.typeActivity)> <div class=text-left ng-message=required>La actividad es requerida</div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group ng-class=createActivityVm.hasError(createActivity.hours)> <label for=hours class=\"control-label pull-left\" ng-hide=true>Horas planeadas </label> <input type=hidden min=0 name=hours ng-model=createActivityVm.hours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-view=false ng-value=0 /> <div class=control-label ng-messages=createActivity.hours.$error ng-show=createActivityVm.showErrorMessages(createActivity.hours)> <div class=text-left ng-message=required>Las horas son requeridas</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createActivityVm.hasError(createActivity.nameActivity)> <label for=nameActivity class=\"control-label pull-left\">Nombre de actividad</label> <input type=text name=nameActivity ng-model=createActivityVm.nameActivity ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createActivity.nameActivity.$error ng-show=createActivityVm.showErrorMessages(createActivity.nameActivity)> <div class=text-left ng-message=required>El nombre es requerido</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createActivityVm.hasError(createActivity.detail)> <label for=detail class=\"control-label pull-left\">Detalle</label> <md-input-container class=control-label> <textarea name=detail ng-model=createActivityVm.detail maxlength=500 md-maxlength=500 class=form-control ng-model-options=\"{ debounce: 300 }\" required></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createActivity.detail.$error ng-show=createActivityVm.showErrorMessages(createActivity.detail)> <div class=text-left ng-message=required>El detalle es requerido</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-6 no-padding text-right\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=createActivityVm.close()>Cancelar</md-button> </div> <div class=\"col-md-6 text-left\"> <md-button class=\"btn btn-fw btn-primary text-xs p-h-md no-margin\" ng-click=\"createActivityVm.addActivity(false, true); createActivityVm.cleanForm(createActivity);\" ng-disabled=\"createActivityVm.isSaveButtonDisabled || createActivityVm.validateForm(createActivity)\"> Guardar actividad</md-button> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createActivityVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-azul text-center\">Crear actividad</h3> <p class=\"text-xs text-center\">Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar Actividad\". Todos los campos son obligatorios. </p> </div> </div> <form name=createActivityForm novalidate> <div class=row> <div class=\"col-md-8 p-v m-b-xs\"> <div class=\"row no-padding\"> <div class=\"col-md-9 no-padding-r\"> <div class=form-group ng-class=createActivityVm.hasError(createActivityForm.typeActivity)> <label for=typeActivity class=\"control-label pull-left\">Nombre de actividad</label> <select name=typeActivity ng-model=createActivityVm.activityCode ng-options=\"listActivities.activityTypeCode as listActivities.activityTypeName for listActivities in createActivityVm.comboActivities\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-left\" ng-messages=createActivityForm.typeActivity.$error ng-show=createActivityVm.showErrorMessages(createActivityForm.typeActivity)> <div ng-message=required>La actividad es requerida</div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group ng-class=createActivityVm.hasError(createActivityForm.hours) ng-hide=true> <label for=hours class=\"control-label pull-left\" ng-hide=true>Horas planeadas</label> <input type=number min=0 name=hours ng-model=createActivityVm.hours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-hide=true ng-value=0 /> <div class=\"control-label text-left\" ng-messages=createActivityForm.hours.$error ng-show=createActivityVm.showErrorMessages(createActivityForm.hours)> <div ng-message=required>Las horas son requeridas</div> </div> </div> </div> <div class=col-md-12> <div class=form-group> <label for=detail class=\"control-label pull-left\">Descripción de labores</label> <md-input-container class=control-label> <textarea name=detail ng-model=createActivityVm.detail class=form-control md-maxlength=500 maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-4 p-v m-b-xs\"> <div class=\"row no-padding\"> <div class=\"col-md-12 no-padding\"> <h5 class=\"text-xs text-left\">Seleccione la forma en que se realizará la Ejecución *</h5> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=createActivityVm.rangeType value=1 ng-change=createActivityVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=createActivityVm.rangeType value=2 ng-change=createActivityVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"row no-padding\" ng-if=\"createActivityVm.rangeType == 1\"> <div class=\"col-md-12 no-padding\"> <h5 class=\"text-xs pull-left\">Seleccione los períodos donde desempeñará este rol:</h5> <div class=\"col-md-12 has-error no-padding text-left\"> <label class=\"control-label text-left proxima\" ng-show=\"createActivityVm.isTouchedPeriods && createActivityVm.validateCheklistPeriods()\"> Por favor seleccione al menos 1 período. </label> </div> <div class=\"col-md-12 text-left no-padding\"> <div ng-repeat=\"period in createActivityVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createActivityVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createActivityVm.funSelectedPeriod(period, createActivityVm.selectedTypePeriod[period.periodId])\">{{period.periodName}} </md-checkbox> </div> </div> </div> </div> <div class=\"row no-padding\" ng-if=\"createActivityVm.rangeType == 2\"> <div class=\"col-md-12 no-padding\"> <h5 class=\"text-xs text-left\">Seleccione un rango de fecha de inicio y fin:</h5> <div class=\"col-md-12 text-left no-padding\"> <div ng-class=createActivityVm.hasError(createActivityForm.initialDate)> <label class=\"control-label no-padding\" for=initialDate>Fecha inicio</label> <md-datepicker ng-model=createActivityVm.initialDate name=initialDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createActivityVm.startDateChange() md-max-date=createActivityVm.finalDate min=\"{{createActivityVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> </div> <div ng-class=createActivityVm.hasError(createActivityForm.finalDate)> <label class=\"control-label no-padding\" for=finalDate>Fecha fin</label> <md-datepicker ng-model=createActivityVm.finalDate name=finalDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createActivityVm.minEndDate min={{createActivityVm.minEndDate}} ng-change=createActivityVm.startDateChange()> </md-datepicker> </div> </div> </div> </div> </div> </div> <div class=\"row text-center\"> <div class=\"col-md-12 p-t\"> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=createActivityVm.close()>Cancelar</md-button> </div> <div class=\"col-md-6 no-padding text-left\"> <md-button class=\"btn btn-fw btn-primary no-margin text-xs p-h-md\" ng-click=\"createActivityVm.addActivity(false, true)\" ng-disabled=\"createActivityVm.isSaveButtonDisabled || createActivityVm.validateForm(createActivityForm)\"> Guardar actividad</md-button> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createRoleVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Crear rol</h3> <p class=text-xs>Ingrese los datos del siguiente formulario y luego haga clic en el bot&oacute;n \"Guardar Rol\". Todos los campos son obligatorios.</p> </div> </div> <form name=createRole novalidate> <div class=row> <div class=\"col-md-8 p-v m-b-xs\"> <div class=\"row no-padding-r\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createRoleVm.hasError(createRole.arrayUnit)> <label for=arrayUnit class=\"control-label col-md-12 text-left no-padding\">Unidad</label> <select ng-change=createRoleVm.rolesUnits() name=arrayUnit ng-model=createRoleVm.academicUnit ng-options=\"unit.academitUnitId as unit.academitUnitName for unit in createRoleVm.arrayUnit\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-left\" ng-messages=createRole.arrayUnit.$error ng-show=createRoleVm.showErrorMessages(createRole.arrayUnit)> <div ng-message=required>La unidad es requerida</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createRoleVm.hasError(createRole.rolesCombo)> <label for=rolesCombo class=\"control-label col-md-12 text-left no-padding\">Rol</label> <select name=rolesCombo ng-change=createRoleVm.changedCheckBox() ng-model=createRoleVm.rolesSelected ng-options=\"role.roleId as role.roleName for role in createRoleVm.rolesCombo\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-left\" ng-messages=createRole.rolesCombo.$error ng-show=createRoleVm.showErrorMessages(createRole.rolesCombo)> <div ng-message=required>El rol es requerido</div> </div> </div> </div> <div class=col-md-9> <div class=form-group ng-class=createRoleVm.hasError(createRole.detail)> <label for=detail class=\"control-label col-md-12 text-left no-padding\">Detalle</label> <md-input-container class=\"control-label no-margin\"> <textarea name=detail ng-model=createRoleVm.detail class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=\"control-label text-left\" ng-messages=createRole.detail.$error ng-show=createRoleVm.showErrorMessages(createRole.detail)> <div ng-message=required>El detalle es requerido</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-3 m-v-xs no-padding-r\" ng-class=createRoleVm.hasError(createRole.hoursPlanned) ng-hide=true> <label class=\"control-label col-md-12 text-left no-padding\" for=hoursPlanned ng-hide=true>Horas planeadas</label> <input type=number min=0 class=form-control name=hoursPlanned onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-hide=true ng-value=0 ng-model=createRoleVm.hoursPlanned maxlength=8 /> <div class=\"control-label text-left\" ng-messages=createRole.hoursPlanned.$error ng-show=createRoleVm.showErrorMessages(createRole.hoursPlanned)> <div ng-message=required>Las horas planeadas son requeridas</div> </div> </div> </div> </div> <div class=\"col-md-4 p-t no-padding-l\"> <div class=\"row no-padding\"> <div class=col-md-12> <h5 class=\"text-xs text-left\">Seleccione la forma en que se realizará la Ejecución *</h5> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=createRoleVm.rangeType value=1 ng-click=createRoleVm.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=createRoleVm.rangeType value=2 ng-click=createRoleVm.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=col-md-12 ng-if=\"createRoleVm.rangeType == 1\"> <h5 class=\"text-xs text-left\">Seleccione los períodos donde desempeñará este rol:</h5> <div class=\"col-md-12 has-error no-padding text-left\"> <label class=\"control-label text-left proxima\" ng-show=\"createRoleVm.isTouchedPeriods && createRoleVm.validateCheklistPeriods()\"> Por favor seleccion al menos 1 período. </label> </div> <div ng-repeat=\"period in createRoleVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm text-left pull-left col-md-12\" type=checkbox ng-model=createRoleVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createRoleVm.funSelectedPeriod(period, createRoleVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </div> </div> <div class=col-md-12 ng-if=\"createRoleVm.rangeType == 2\"> <h5 class=\"text-xs text-left\">Seleccione un rango de fecha de inicio y fin:</h5> <div class=\"col-md-12 text-left align-calendars m-b-sm\" ng-class=hasError(createRole.startDate)> <label class=\"control-label col-md-12 text-left no-margin no-padding\" for=start_date>Fecha inicio</label> <md-datepicker ng-model=createRoleVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-max-date=createRoleVm.endDate min=\"{{createRoleVm.minStartDate | date: 'dd/MM/yyyy' }}\" ng-change=createRoleVm.startDateChange() required> </md-datepicker> </div> <div class=\"col-md-12 text-left align-calendars m-b-sm\" ng-class=hasError(createRole.endDate)> <label class=\"control-label col-md-12 text-left no-margin no-padding\" for=start_date>Fecha fin</label> <md-datepicker ng-model=createRoleVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-min-date=createRoleVm.minEndDate min={{createRoleVm.minEndDate}} required> </md-datepicker> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=createRoleVm.close()>Cancelar</md-button> </div> <div class=\"col-md-6 no-padding text-left\"> <md-button class=\"btn btn-fw btn-primary no-margin text-xs p-h-md\" ng-click=createRoleVm.addRole(true) ng-disabled=\"createRoleVm.isSaveButtonDisabled || createRoleVm.validateForm(createRole)\"> Guardar rol</md-button> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=70> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=participationVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Crear participación en comités</h3> <p class=text-xs>Diligencie los datos del siguiente formulario y luego haga clic en el bot&oacute;n \"Guardar participación\". Todos los campos son obligatorios.</p> </div> </div> <form name=committee novalidate> <div class=row> <div class=\"col-md-8 p-v m-b-xs\"> <div class=\"row no-padding\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=participationVm.hasError(committee.committeeName)> <label for=committeeName class=\"control-label col-md-12 no-padding text-left\">Nombre de comité</label> <select name=committeeName ng-model=participationVm.committeeName ng-options=\"listCommittee.idListItem as listCommittee.listItemName \n                      for listCommittee in participationVm.listCommitteeCombo\" class=form-control ng-disabled=participationVm.isEditing required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-left\" ng-messages=committee.committeeName.$error ng-show=participationVm.showErrorMessages(committee.committeeName)> <div ng-message=required>El nombre es requerido</div> </div> </div> </div> <div class=col-md-6> <div class=form-group ng-class=participationVm.hasError(committee.hoursPlanned) ng-hide=true> <label for=hoursPlanned class=\"control-label col-md-12 no-padding text-left\" ng-hide=true>Horas planeadasfghfg</label> <input type=number name=hoursPlanned ng-model=participationVm.hoursPlanned min=0 class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-hide=true ng-value=0> <div class=\"control-label text-left\" ng-messages=committee.hoursPlanned.$error ng-show=participationVm.showErrorMessages(committee.hoursPlanned)> <div ng-message=required>Las horas planeadas son requeridas</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=participationVm.hasError(committee.detail)> <label for=detail class=\"control-label col-md-12 no-padding text-left\">Detalle</label> <md-input-container class=\"control-label no-margin\"> <textarea name=detail ng-model=participationVm.detail class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=\"control-label text-left\" ng-messages=committee.detail.$error ng-show=participationVm.showErrorMessages(committee.detail)> <div ng-message=required>El detalle es requerido</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-4 p-t no-padding-l\"> <div class=\"row no-padding\"> <div class=\"col-md-12 no-padding\"> <h5 class=\"text-xs text-left\">Seleccione en que marco de tiempo debe ser considerada esta participación:</h5> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=participationVm.rangeType value=1 ng-click=participationVm.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=participationVm.rangeType value=2 ng-click=participationVm.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"participationVm.rangeType == 1\"> <h5 class=\"text-xs text-left\">Seleccione los períodos donde desempeñará esta participación:</h5> <div class=\"col-md-12 has-error no-padding text-left\"> <label class=\"control-label text-left proxima\" ng-show=\"participationVm.isTouchedPeriods && participationVm.validateCheklistPeriods()\"> Por favor seleccione al menos 1 período. </label> </div> <div ng-repeat=\"period in participationVm.listPeriods\"> <md-checkbox class=\"md-green m-r-sm text-left pull-left col-md-12\" type=checkbox ng-model=participationVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"participationVm.funSelectedPeriod(period, participationVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"participationVm.rangeType == 2\"> <h5 class=\"text-xs text-left\">Seleccione un rango de fecha de inicio y fin:</h5> <div class=\"col-md-12 text-left align-calendars m-b-sm\" ng-class=participationVm.hasError(committee.start_date)> <label class=\"control-label col-md-12 no-padding text-left no-margin\" for=start_date>Fecha inicio</label> <md-datepicker ng-model=participationVm.start_date name=start_date md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-max-date=participationVm.end_date ng-change=participationVm.startDateChange() min=\"{{participationVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> </div> <div class=\"col-md-12 text-left align-calendars m-b-sm\" ng-class=participationVm.hasError(committee.end_date)> <label class=\"control-label col-md-12 no-padding text-left no-margin\" for=end_date>Fecha fin</label> <md-datepicker ng-model=participationVm.end_date name=end_date md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=participationVm.minEndDate min={{participationVm.minEndDate}} ng-change=participationVm.startDateChange()> </md-datepicker> </div> </div> </div> </div> </div> <div class=\"row text-center\"> <div class=\"col-md-12 p-t\"> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=participationVm.close()>Cancelar</md-button> </div> <div class=\"col-md-6 no-padding text-left\"> <md-button class=\"btn btn-fw btn-primary text-xs no-margin\" ng-click=participationVm.addParticipation(true) ng-disabled=\"participationVm.validateForm(committee) || participationVm.disableSaveButtom\"> Guardar participación </md-button> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=row> <div class=col-md-12> <div class=\"row title text-center\"> <h3 class=\"text-verde text-center\">¡Atención!</h3> <p>Para finalizar planeación debe configurar las siguientes secciones:</p> </div> <h3 class=\"text-center text-azul\" ng-if=\"itemAssignatures.length || itemOthersActivityRequired.length\">Docencia</h3> <p class=\"text-left text-ms font-text\" ng-if=itemAssignatures.length>Asignaturas por Planear (Actividades Obligatorias)</p> <md-divider ng-if=itemAssignatures.length></md-divider> <div ng-repeat=\"assignature in itemAssignatures\"> <div class=\"row p-v-xs\"> <div class=col-md-12> <a ng-click=toggleSubcategories(assignature) ng-if=\"assignature.itemList.length > 0\"> <p class=\"text-left text-ms no-margin\">{{assignature.assignatureName}} <label ng-if=!assignature.showChilds class=\"icon mdi-content-add i-20 pull-right\"></label> <label ng-if=assignature.showChilds class=\"icon mdi-content-remove i-20 pull-right\"></label> </p> </a> </div> </div> <div class=\"row p-v-xs no-padding-t\" ng-if=assignature.showChilds> <ul class=\"p-l-xl with-bullets bullets-md p-h-md\"> <li ng-repeat=\"item in assignature.itemList\" class=m-v-sm> <p class=\"text-left text-xs p-l-sm\"> {{item.list_items}} ({{item.list_name}}) </p> </li> </ul> </div> </div> <p></p> <p class=\"text-left text-base font-text\" ng-if=itemOthersActivityRequired.length>Otras Actividades (Actividades Obligatorias)</p> <md-divider ng-if=itemOthersActivityRequired.length></md-divider> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"itemOthersActivityRequired in itemOthersActivityRequired\" class=m-v-sm> <p class=\"text-left text-ms p-l-sm\"> {{itemOthersActivityRequired.list_items}} </p> </li> </ul> <p class=\"text-center text-ms text-gris-dark\" ng-if=itemListOtherActAM.length>Gestión Académica</p> <p class=\"text-left text-base font-text\" ng-if=itemListOtherActAM.length>Otras Actividades (Actividades Obligatorias)</p> <md-divider ng-if=itemListOtherActAM.length></md-divider> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"itemListOtherActAM in itemListOtherActAM\" class=m-v-sm> <p class=\"text-left text-ms p-l-sm\"> {{itemListOtherActAM.list_items}} </p> </li> </ul> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=row> <div class=col-md-12> <div class=\"row title text-center\"> <h3 class=text-verde>¡Atención!</h3> <p>Para finalizar la ejecución debe agregar horas de ejecución a las siguientes actividades:</p> </div> <p class=\"text-left text-ms font-text\" ng-if=itemActivities.length>Actividades sin horas de ejecución</p> <md-divider ng-if=itemActivities.length></md-divider> <div ng-repeat=\"activities in itemActivities\"> <div class=\"row p-v-xs\"> <div class=col-md-12> <a ng-click=toggleSubcategories(activities) ng-if=\"activities.itemList.length > 0\"> <p class=\"text-left text-ms no-margin\">{{activities.submodule}} <label ng-if=!activities.showChilds class=\"icon mdi-content-add i-20 pull-right\"></label> <label ng-if=activities.showChilds class=\"icon mdi-content-remove i-20 pull-right\"></label> </p> </a> </div> </div> <div class=\"row p-v-xs no-padding-t\" ng-if=activities.showChilds> <ul class=\"p-l-xl with-bullets bullets-md p-h-md\"> <li ng-repeat=\"item in activities.itemList\" class=m-v-sm> <p class=\"text-left text-xs p-l-sm\"> {{item.Activity_type}} - {{item.Activity}} </p> </li> </ul> </div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=col-md-12> <h3 class=text-azul>¡Atención!</h3> <p>Estas a punto de eliminar estas asignatura, por que pertenece a su plan de trabajo, &#191 Est&#225; seguro?</p> </div> </div> <div class=\"row pull-left\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Volver</md-button> </div> </div> <div class=\"row pull-right\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=save()>Continuar y Eliminar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>{{ctrlModalVM.createOrEdit}}</h3> <p class=m-t-md> {{ctrlModalVM.nameModal}} <strong>\" {{ctrlModalVM.itemName}} \"</strong> se ha {{ctrlModalVM.textCreateOrEdit}} con éxito.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=70 style=height:80vh> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createCourseVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Agregar Curso</h3> <p class=text-xs>Diligencie los datos en el siguiente formulario para agregar un curso externo a su Ejecución. Este debe haber sido validado y aprobado por el CEA, si no es así por favor comuníquese con esta área al siguiente correo electrónico: CEA@urosario.edu.co. Todos los campos son obligatorios.</p> </div> </div> <form name=createCourseForm novalidate> <div class=row> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"row col-md-12 no-padding\"> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b left\">Datos del curso</h5> </div> <div class=\"col-md-5 no-padding-r\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cTitle)> <label for=cTitle class=\"control-label left\">T&iacute;tulo</label> <input type=text name=cTitle ng-model=createCourseVm.title class=form-control ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=createCourseForm.cTitle.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cTitle)> <div ng-message=required class=\"text-xs text-left\">El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cEntity)> <label for=cEntity class=\"control-label left\">Tipo entidad</label> <select name=cEntity ng-model=createCourseVm.entityType ng-options=\"type.idListItem as type.listItemName for type in createCourseVm.listEntity\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.cEntity.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cEntity)> <div ng-message=required class=\"text-xs text-left\">El tipo de entidad es requerida.</div> </div> </div> </div> <div class=\"col-md-3 no-padding-r\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cLevel)> <label for=cLevel class=\"control-label left\">Nivel</label> <input type=text name=cLevel ng-model=createCourseVm.level class=form-control ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=createCourseForm.cLevel.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cLevel)> <div ng-message=required class=\"text-xs text-left\">El nivel es requerido.</div> </div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cModality)> <label for=cModality class=\"control-label left\">Modalidad</label> <select name=cModality ng-model=createCourseVm.modality ng-options=\"type.idListItem as type.listItemName for type in createCourseVm.listModality\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.cModality.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cModality)> <div ng-message=required class=\"text-xs text-left\">La modalidad es requerida.</div> </div> </div> </div> <div class=\"col-md-3 no-padding-r\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.coInstType)> <label for=coInstType class=\"control-label left\">Tipo de Instituci&oacute;n</label> <select name=coInstType ng-model=createCourseVm.institutionType ng-options=\"source.idListItem as source.listItemName for source in createCourseVm.listsTypeInstitution\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.coInstType.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.coInstType)> <div ng-message=required class=\"text-xs text-left\">El tipo de instituci&oacute;n es requerido.</div> </div> </div> </div> <div class=\"col-md-5 no-padding-r\"> <label for=cInstitution class=\"control-label left\">Instituci&oacute;n</label> <md-autocomplete required class=\"autocomplete no-padding col-md-12 m-r-xs\" md-clear-button=false md-item-text=source.nameInstitution md-min-length=0 md-autofocus=true md-no-cache=true md-selected-item-change=createCourseVm.changeInstitution(source) md-selected-item=createCourseVm.selectedItem md-search-text=createCourseVm.searchText placeholder=\"Buscar institución...\" md-items=\"source in createCourseVm.searchInstitution(createCourseVm.searchText, createCourseVm.institutionType)\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{source.nameInstitution}}</span> </md-item-template> </md-autocomplete> </div> <div class=\"col-md-12 no-padding\"> <div class=col-md-4> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.coCountry)> <label for=cCountry class=\"control-label left\">Pa&iacute;s</label> <select name=coCountry ng-model=createCourseVm.country ng-options=\"source.codeCountry as source.nameCountry for source in createCourseVm.countries\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.coCountry.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.coCountry)> <div ng-message=required class=\"text-xs text-left\">El pa&iacute;s es requerido.</div> </div> </div> </div> <div class=col-md-4> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.coDepartament)> <label for=coDepartament class=\"control-label left\">Departamento</label> <select name=coDepartament ng-model=createCourseVm.departament ng-options=\"source.codeState as source.nameState for source in createCourseVm.state | filter:{ codeCountry : createCourseVm.country }:true\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.coDepartament.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.coDepartament)> <div ng-message=required class=\"text-xs text-left\">El departamento es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cCity)> <label for=cCity class=\"control-label left\">Ciudad</label> <select name=cCity ng-model=createCourseVm.city ng-options=\"source.codeCity as source.nameCity for source in createCourseVm.cities | filter:{ codeState : createCourseVm.departament }:true\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCourseForm.cCity.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cCity)> <div ng-message=required class=\"text-xs text-left\">La ciudad es requerida.</div> </div> </div> </div> </div> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cProgram)> <label for=cProgram class=\"control-label left\">Programa</label> <input type=text name=cProgram ng-model=createCourseVm.program class=form-control ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=createCourseForm.cProgram.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cProgram)> <div ng-message=required class=\"text-xs text-left\">El programa es requerido.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.cDescription)> <label for=cDescription class=\"control-label left\">Descripci&oacute;n del curso</label> <md-input-container class=\"control-label no-margin\"> <textarea name=cDescription ng-model=createCourseVm.courseDescription rows=2 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createCourseForm.cDescription.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.cDescription)> <div ng-message=required class=\"text-xs text-left\">La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b left\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 no-padding-r\"> <div class=\"row no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.planificationType)> <div class=\"col-md-12 no-padding\"> <label for=planificationType class=\"control-label left\">Seleccione la forma en que se realizará la Ejecución *</label> </div> <div class=col-md-3> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createCourseVm.rangeType value=1 ng-click=createCourseVm.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-5> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createCourseVm.rangeType value=2 ng-click=createCourseVm.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\" ng-hide=true> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.hours)> <label for=hours class=\"control-label left\">Horas Planeadas</label> <input type=number min=0 name=hours ng-model=createCourseVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-hide=true ng-value=0> <div class=control-label ng-messages=createCourseForm.hours.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.hours)> <div ng-message=required class=\"text-xs text-left\">Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-12 no-padding\" ng-if=\"createCourseVm.rangeType == 1\"> <div class=\"col-md-12 no-padding\"> <label class=\"m-r-sm left\" ng-repeat=\"period in createCourseVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createCourseVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createCourseVm.funSelectedPeriod(period, createCourseVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createCourseVm.isTouchedPeriods && createCourseVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding text-left\" ng-if=\"createCourseVm.rangeType == 2\"> <div class=\"col-md-4 no-padding left\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createCourseVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa min=\"{{createCourseVm.minStartDate | date: 'dd/MM/yyyy' }}\" ng-change=createCourseVm.startDateChange() required> </md-datepicker> <div class=control-label ng-messages=createCourseForm.startDate.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.startDate)> <div ng-message=required class=\"text-xs text-left\">La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding left\"> <div class=form-group ng-class=createCourseVm.hasError(createCourseForm.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createCourseVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-min-date=createCourseVm.minEndDate min={{createCourseVm.minEndDate}} required> </md-datepicker> <div class=control-label ng-messages=createCourseForm.endDate.$error ng-show=createCourseVm.showErrorMessages(createCourseForm.endDate)> <div ng-message=required class=\"text-xs text-left\">La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-12 text-center p-t\"> <md-button class=\"btn btn-fw btn-cancel text-left\" ng-click=createCourseVm.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=createCourseVm.addCourse(true) ng-disabled=\"createCourseVm.disableSaveButton || createCourseVm.validateForm(createCourseForm)\"> Guardar curso</md-button> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog>";

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button aria-label=close ng-click=createLearningComunityVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Comunidades de aprendizaje y práctica - Agregar comunidad</h3> <p class=text-xs>Ingrese los datos del siguiente formulario para agregar una comunidad nueva a su Ejecución</p> </div> </div> <form name=createComunity novalidate> <div class=row> <div class=\"col-md-8 p-v m-b-xs\"> <div class=\"row no-padding-r\"> <div class=\"col-md-7 no-padding-r\"> <div class=form-group> <label for=nameComunity class=\"control-label left\">Nombre</label> <md-autocomplete required ng-disabled=createLearningComunityVM.isEditing class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=community.listItemName md-input-name=communities md-min-length=0 md-input-minlength=0 md-select-on-match=true md-search-text-change=createLearningComunityVM.changeSearchText(createLearningComunityVM.searchText) md-selected-item-change=createLearningComunityVM.changeCommunity(community) md-selected-item=createLearningComunityVM.selectedItem md-search-text=createLearningComunityVM.searchText md-items=\"community in createLearningComunityVM.searchCommunity(createLearningComunityVM.searchText)\" placeholder=\"Buscar nombre de la comunidad...\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{community.listItemName}}</span> </md-item-template> <md-not-found> No se encontraron comunidades... </md-not-found> </md-autocomplete> </div> </div> <div class=\"col-md-5 no-padding-r\"> <div class=form-group ng-class=createLearningComunityVM.hasError(createComunity.typeScene)> <label for=typeScene class=\"control-label left\">Ámbito/Escenario</label> <select name=typeScene ng-model=createLearningComunityVM.typeScene ng-options=\"listCommunity.idListItem as listCommunity.listItemName for listCommunity in createLearningComunityVM.listsAmbit\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createComunity.typeScene.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.typeScene)> <div ng-message=required class=\"text-xs text-left\">El ámbito es requerido.</div> </div> </div> </div> <div class=col-md-9> <div class=form-group ng-class=createLearningComunityVM.hasError(createComunity.detail)> <label for=detail class=\"control-label left\">Descripción de su labor</label> <md-input-container class=\"control-label no-margin\"> <textarea name=detail ng-model=createLearningComunityVM.detail class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-8 no-padding\"> <div class=control-label ng-messages=createComunity.detail.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.detail)> <div ng-message=required class=\"text-xs text-left\">La descripción es requerida.</div> </div> </div> <div class=\"col-md-4 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-3 m-v-xs no-padding-r\" ng-class=createLearningComunityVM.hasError(createComunity.hoursPlanning) ng-hide=true> <label class=\"control-label col-md-12 text-left no-padding\" for=hoursPlanning ng-hide=true>Horas planeadas</label> <input type=number min=0 class=form-control name=hoursPlanning onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-hide=true ng-value=0 ng-model=createLearningComunityVM.hoursPlanning maxlength=8 /> <div class=\"control-label text-left\" ng-messages=createComunity.hoursPlanning.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.hoursPlanning)> <div ng-message=required class=\"text-xs text-left\">Las horas planeadas son requeridas.</div> </div> </div> </div> </div> <div class=\"col-md-4 p-t no-padding-l\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b left\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> <div class=\"row no-padding\"> <div class=col-md-12> <h5 class=\"text-xs text-left\">Seleccione la forma en que se realizará la Ejecución *</h5> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=createLearningComunityVM.rangeType value=1 ng-click=createLearningComunityVM.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=rangeType ng-model=createLearningComunityVM.rangeType value=2 ng-click=createLearningComunityVM.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=col-md-12 ng-if=\"createLearningComunityVM.rangeType == 1\"> <h5 class=\"text-xs text-left\">Seleccione los períodos:</h5> <div class=\"col-md-12 has-error no-padding text-left\"> <label class=\"control-label text-left proxima text-xs\" ng-show=\"createLearningComunityVM.isTouchedPeriods && createLearningComunityVM.validateCheklistPeriods()\"> Por favor seleccione al menos 1 período. </label> </div> <div ng-repeat=\"period in createLearningComunityVM.periods\"> <md-checkbox class=\"md-green m-r-sm text-left pull-left col-md-12\" type=checkbox ng-model=createLearningComunityVM.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createLearningComunityVM.funSelectedPeriod(period, createLearningComunityVM.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </div> </div> <div class=col-md-12 ng-if=\"createLearningComunityVM.rangeType == 2\"> <h5 class=\"text-xs text-left\">Seleccione un rango de fecha de inicio y fin:</h5> <div class=\"col-md-12 text-left align-calendars m-b-sm\" ng-class=createLearningComunityVM.hasError(createComunity.startDate)> <label class=\"control-label col-md-12 text-left no-margin no-padding\" for=startDate>Fecha inicio</label> <md-datepicker ng-model=createLearningComunityVM.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-max-date=createLearningComunityVM.endDate min=\"{{createLearningComunityVM.minStartDate | date: 'dd/MM/yyyy' }}\" md-min-date=createLearningComunityVM.minStartDate ng-change=createLearningComunityVM.startDateChange() required> </md-datepicker> <div class=control-label ng-messages=createComunity.startDate.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> <div class=\"col-md-12 text-left align-calendars m-b-sm\" ng-class=createLearningComunityVM.hasError(createComunity.endDate)> <label class=\"control-label col-md-12 text-left no-margin no-padding\" for=endDate>Fecha fin</label> <md-datepicker ng-model=createLearningComunityVM.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa md-min-date=createLearningComunityVM.minEndDate min={{createLearningComunityVM.minEndDate}} required> </md-datepicker> <div class=control-label ng-messages=createComunity.endDate.$error ng-show=createLearningComunityVM.showErrorMessages(createComunity.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> <div ng-message=mindate class=text-xs>La fecha de fin debe ser mayor a la fecha de inicio.</div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=\"col-md-6 text-right\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=createLearningComunityVM.close()>Cancelar</md-button> </div> <div class=\"col-md-6 no-padding text-left\"> <md-button class=\"btn btn-fw btn-primary no-margin text-xs p-h-md\" ng-click=\"createLearningComunityVM.addActivity(false, true)\" ng-disabled=\"createLearningComunityVM.isSaveButtonDisabled || createLearningComunityVM.validateForm(createComunity)\"> Guardar actividad</md-button> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3>Formación doctoral - {{createDoctorateVm.createOrEdit}} Doctorado</h3> <p class=text-xs ng-show=!createDoctorateVm.isEditing> Ingrese a continuación los datos del programa de Doctorado y la dedicación planeada en el presente año.</p> <p class=text-xs ng-show=createDoctorateVm.isEditing>Edite los datos del siguiente formulario para modificar la formación doctoral. </p> </div> </div> <form name=createDoctorate novalidate> <div class=\"row blanco p-b-md\"> <div class=\"col-md-8 p-h-lg p-v m-b-xs\"> <div class=col-md-12> <div class=row> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del doctorado</h5> </div> <div class=\"col-md-5 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docTitle)> <label for=docTitle class=\"control-label left\">T&iacute;tulo</label> <input type=text name=docTitle ng-model=createDoctorateVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createDoctorate.docTitle.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docTitle)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-3 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docInstType)> <label for=docInstType class=\"control-label left\">Tipo de Instituci&oacute;n</label> <select name=docInstType ng-model=createDoctorateVm.institutionType ng-options=\"source.idListItem as source.listItemName for source in createDoctorateVm.listsTypeInstitution\" class=form-control ng-change=createDoctorateVm.changeTypeInstitution() required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docInstType.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docInstType)> <div ng-message=required class=text-xs>El tipo de instituci&oacute;n es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.institution)> <label for=institution class=\"control-label left\">Instituci&oacute;n</label> <md-autocomplete required md-input-name=institution class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=source.nameInstitution md-min-length=0 md-no-cache=true md-select-on-match=true md-selected-item-change=createDoctorateVm.changeInstitution(source) md-selected-item=createDoctorateVm.selectedItem md-search-text=createDoctorateVm.searchText placeholder=\"Buscar institución...\" md-items=\"source in createDoctorateVm.searchInstitution(createDoctorateVm.searchText, createDoctorateVm.institutionType)\"> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{source.nameInstitution}}</span> </md-item-template> </md-autocomplete> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docCountry)> <label for=docCountry class=\"control-label left\">Pa&iacute;s</label> <select name=docCountry ng-model=createDoctorateVm.country ng-options=\"source.codeCountry as source.nameCountry for source in createDoctorateVm.countries\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docCountry.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docCountry)> <div ng-message=required class=text-xs>El pa&iacute;s es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docDepartament)> <label for=docDepartament class=\"control-label left\">Departamento o Estado</label> <select name=docDepartament ng-model=createDoctorateVm.departament ng-options=\"source.codeState as source.nameState for source in createDoctorateVm.state | filter:{ codeCountry : createDoctorateVm.country }:true\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docDepartament.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docDepartament)> <div ng-message=required class=text-xs>El departamento es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docCity)> <label for=docCity class=\"control-label left\">Ciudad</label> <select name=docCity ng-model=createDoctorateVm.city ng-options=\"source.codeCity as source.nameCity for source in createDoctorateVm.cities | filter:{ codeState : createDoctorateVm.departament }:true\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docCity.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docCity)> <div ng-message=required class=text-xs>La ciudad es requerida.</div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docKnowledge)> <label for=docKnowledge class=\"control-label left\">N&uacute;cleo de Conocimiento</label> <md-autocomplete required md-input-name=docKnowledge class=\"autocomplete no-padding col-md-12 m-r-xs form-control\" md-clear-button=false md-item-text=core.listItemName md-min-length=0 md-autofocus=true md-select-on-match=true md-selected-item-change=createDoctorateVm.changeCore(core) md-selected-item=createDoctorateVm.selectedItemCore md-search-text=createDoctorateVm.searchTextCore placeholder=\"Buscar nucleo de conocimiento...\" md-items=\"core in createDoctorateVm.searchCore(createDoctorateVm.searchTextCore)\"> <md-item-template> <span md-highlight-text=searchTextCore md-highlight-flags=^i>{{core.listItemName}}</span> </md-item-template> </md-autocomplete> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docSource)> <label for=docSource class=\"control-label left\">Fuente de Financiaci&oacute;n</label> <select name=docSource ng-model=createDoctorateVm.financingSource ng-options=\"source.idListItem as source.listItemName for source in createDoctorateVm.sourceType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docSource.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docSource)> <div ng-message=required class=text-xs>La fuente de financiaci&oacute;n es requerida.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docProgram)> <label for=docProgram class=\"control-label left\">Programa Beca</label> <select name=docProgram ng-model=createDoctorateVm.scholarshipProgram ng-options=\"source.idListItem as source.listItemName for source in createDoctorateVm.scholarshipProgramType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createDoctorate.docProgram.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docProgram)> <div ng-message=required class=text-xs>El programa de beca es requerido.</div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=row> <div class=\"col-md-4 no-padding-r\"> <div class=form-group ng-class=createDoctorateVm.hasError(createDoctorate.docHours)> <label for=docHours class=\"control-label left\">Horas Planeadas</label> <input type=number min=0 name=docHours ng-model=createDoctorateVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createDoctorate.docHours.$error ng-show=createDoctorateVm.showErrorMessages(createDoctorate.docHours)> <div ng-message=required class=text-xs>Las horas planeadas son requeridas.</div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=\"col-md-12 p-t\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel\" ui-sref=workplan.doctoralFormation>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createDoctorateVm.addDoctorate() ng-disabled=\"createDoctorateVm.validateForm(createDoctorate) || createDoctorateVm.disableButton\"> Guardar doctorado</md-button> </div> </div> </div> </div> <div class=\"col-md-4 p-t left\"> <period-picker on-change=createDoctorateVm.updateRangeData(value) type-period=createDoctorateVm.typePeriod form-reference=createDoctorate toggle-range=createDoctorateVm.updateRangeType(type) range-type=createDoctorateVm.rangeType start-date=createDoctorateVm.dt_start end-date=createDoctorateVm.dt_end periods-array=createDoctorateVm.periodsArray> </period-picker> </div> </div> </form> </md-dialog-content> </md-dialog>";

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=reviewTVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div ng-include=\"'header-course'\"></div> <div ng-include=\"'courses-list'\"></div> <div ng-include=\"'course-details-modal'\"></div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=listTPCtrl.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-block no-margin exo text-azul\"> Proyectos transversales <span> - {{ listTPCtrl.tacherName }} </span> </h3> </div> </div> <div class=\"col-md-5 no-padding rightDivider\"> <p class=\"text-md text-gris-dark exo m-l\"> Listado de actividades de transversales </p> <md-content> <md-list> <md-list-item class=md-3-line ng-repeat=\"projects in listTPCtrl.ProjectsCross\" ng-click=listTPCtrl.detailTransversal(projects)> <div class=md-list-item-text layout=column> <h3>{{ projects.projectName }}</h3> <p>Proyecto {{ projects.itemProjectTypeName }}</p> <p> Proyecto {{ projects.communities }} - {{ projects.itemProjectTypeName}} - {{ projects.methodology}}</p> <br> </div> </md-list-item> </md-list> </md-content> </div> <div class=\"col-md-7 m-t-lg p-t-lg\"> <div class=row> <md-progress-circular style=margin-left:350px md-mode=indeterminate ng-if=!listTPCtrl.status md-diameter=96> </md-progress-circular> <h5 class=\"text-azul m-r-sm font-bold text-block\" ng-show=listTPCtrl.status> Detalle proyecto - {{ listTPCtrl.DetailProjectsCross.projectName}} </h5> </div> <div class=row ng-if=listTPCtrl.status> <div class=\"col-md-6 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Tipo de proyecto:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.itemProjectTypeName}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Metodología:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.methodology}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Comunidades implicadas:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.communities}}</label> </div> </div> </div> <div class=\"col-md-6 p-h-lg p-v m-b-xs text-sm no-padding-l\"> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Valor:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.value}}</label> </div> </div> <div class=row> <div class=\"col-md-5 text-left no-padding-r\"> <label class=text-block><strong>Entidad:</strong></label> </div> <div class=\"col-md-7 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.entityType}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Propósitos:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.purposes}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Objetivos:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.objectives}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label class=text-block><strong>Resultados:</strong></label> </div> </div> <div class=row> <div class=\"col-md-12 text-left no-padding-r\"> <label>{{listTPCtrl.DetailProjectsCross.results}}</label> </div> </div> </div> <div class=\"col-md-12 p-h-lg p-v m-b-xs text-sm no-padding-l no-padding-t\"> </div> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=50> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button aria-label=btnmd class=md-icon-button ng-click=createProjectVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=row> <div class=col-md-12> <div class=row> <h3 class=\"text-azul text-center m-r-sm text-block\"> {{createProjectVm.createOrEdit}} actividad </h3> </div> <div class=row> <label class=text-center>Edite los campos del siguiente formulario para modificar la actividad del proyecto.</label> </div> </div> </div> <div class=row> <form name=createActivityProject novalidate> <div class=col-md-12> <div class=form-group ng-class=createProjectVm.hasError(createActivityProject.nameActivityProject)> <label for=nameActivityProject class=\"control-label left\">Nombre de actividad</label> <input type=text name=nameActivityProject ng-model=createProjectVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control disabled=createProjectVm.disabled required> <div class=control-label ng-messages=createActivityProject.nameActivityProject.$error ng-show=createProjectVm.showErrorMessages(createActivityProject.nameActivityProject)> <div ng-message=required class=text-xs>El nombre de la actividad es requerido.</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createProjectVm.hasError(createActivityProject.description)> <label for=description class=\"control-label left\">Descripci&oacute;n</label> <md-input-container class=control-label> <textarea name=description aria-label=description ng-model=createProjectVm.description rows=4 md-maxlength=500 maxlength=500 class=form-control disabled=createProjectVm.disabled required ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=control-label ng-messages=createActivityProject.description.$error ng-show=createProjectVm.showErrorMessages(createActivityProject.description)> <div ng-message=required class=text-xs>La descripción es requerida.</div> </div> <div class=\"col-md-3 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=col-md-12> <div class=\"col-md-12 no-padding text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempos de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 form-group no-padding-l\" ng-class=createProjectVm.hasError(createActivityProject.planificationType)> <label for=planificationType class=\"control-label left\">Seleccione la forma en que se realizar&aacute; la planeaci&oacute;n *</label> </div> <div class=\"col-md-3 no-padding-r\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectVm.rangeType value=1 ng-change=createProjectVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectVm.rangeType value=2 ng-change=createProjectVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> <div class=\"col-md-9 no-padding-r\"> <div class=\"col-md-12 no-padding\" ng-if=\"createProjectVm.rangeType == 1\"> <div class=col-md-12 ng-required=\"createProjectVm.rangeType == 1\"> <label class=\"m-r-sm left\" ng-repeat=\"period in createProjectVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createProjectVm.funSelectedPeriod(period, createProjectVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createProjectVm.isTouchedPeriods && createProjectVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"createProjectVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createActivityProject.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createProjectVm.dt_start name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa ng-change=createProjectVm.startDateChange() md-min-date=createProjectVm.dt_startt md-max-date=createProjectVm.dt_endd required> </md-datepicker> <div class=control-label ng-messages=createActivityProject.startDate.$error ng-show=createProjectVm.showErrorMessages(createActivityProject.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createActivityProject.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createProjectVm.dt_end name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createProjectVm.minEndDate ng-change=createProjectVm.startDateChange() ng-disabled=!createProjectVm.dt_start> </md-datepicker> <div class=control-label ng-messages=createActivityProject.endDate.$error ng-show=createProjectVm.showErrorMessages(createActivityProject.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-12 p-v\"> <div class=form-group ng-class=createProjectVm.hasError(createActivityProject.hours)> <label for=hours class=\"control-label left\">Horas planeadas</label> <input type=number min=0 name=hours ng-model=createProjectVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createActivityProject.hours.$error ng-show=createProjectVm.showErrorMessages(createActivityProject.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button aria-label=cancelar class=\"btn btn-fw btn-cancel\" ng-click=createProjectVm.close()> Cancelar</md-button> <md-button aria-label=aceptar class=\"btn btn-fw btn-success\" ng-click=createProjectVm.addActivityProject(createActivityProject) ng-disabled=\"createProjectVm.rangeType == 1 ? (createProjectVm.isDisableButton) : createProjectVm.validateForm(createActivityProject)\"> Aceptar</md-button> </div> </div> </form> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=50> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createProductVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <div class=row> <h3 class=\"text-azul m-r-sm text-block\"> {{createProductVm.createOrEdit}} actividades </h3> </div> <div class=row> <label class=text-center>Diligencie el siguiente formulario para {{createProductVm.createOrEditModal}} una actividad al producto.</label> </div> </div> </div> <div class=row> <form name=createActivityProduct novalidate> <div class=col-md-12> <div class=form-group ng-class=createProductVm.hasError(createActivityProduct.nameActivityProduct)> <label for=nameActivityProduct class=\"control-label left\">Nombre de actividad</label> <input type=text name=nameActivityProduct ng-model=createProductVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createActivityProduct.nameActivityProduct.$error ng-show=createProductVm.showErrorMessages(createActivityProduct.nameActivityProduct)> <div ng-message=required class=\"text-xs text-left\">El nombre de la actividad es requerido.</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createProductVm.hasError(createActivityProduct.description)> <label for=description class=\"control-label left\">Descripci&oacute;n</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createProductVm.description rows=4 class=form-control maxlength=500 md-maxlength=500 required ng-model-options=\"{ debounce: 300 }\">\n              </textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=createActivityProduct.description.$error ng-show=createProductVm.showErrorMessages(createActivityProduct.description)> <div ng-message=required class=\"text-xs text-left\">La descripción es requerida.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=col-md-12> <div class=\"col-md-12 no-padding text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempos de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 form-group no-padding-l\" ng-class=createProductVm.hasError(createActivityProduct.planificationType)> <label for=planificationType class=\"control-label left\">Seleccione la forma en que se realizar&aacute; la planeaci&oacute;n *</label> </div> <div class=\"col-md-3 no-padding-r\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProductVm.rangeType value=1 ng-change=createProductVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProductVm.rangeType value=2 ng-change=createProductVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> <div class=\"col-md-9 no-padding-r\"> <div class=\"col-md-12 no-padding\" ng-if=\"createProductVm.rangeType == 1\"> <div class=col-md-12> <label class=\"m-r-sm left\" ng-repeat=\"period in createProductVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProductVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createProductVm.funSelectedPeriod(period, createProductVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createProductVm.isTouchedPeriods && createProductVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"createProductVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProductVm.hasError(createActivityProduct.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createProductVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createProductVm.startDateChange() md-min-date=createProductVm.minStartDate md-max-date=createProductVm.endDate min=\"{{createProductVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=createActivityProduct.startDate.$error ng-show=createProductVm.showErrorMessages(createActivityProduct.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProductVm.hasError(createActivityProduct.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createProductVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createProductVm.minEndDate min={{createProductVm.minEndDate}} ng-change=createProductVm.startDateChange()> </md-datepicker> <div class=control-label ng-messages=createActivityProduct.endDate.$error ng-show=createProductVm.showErrorMessages(createActivityProduct.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-12 p-v\" ng-if=\"createProductVm.hoursChildren == 1\"> <div class=form-group ng-class=createProductVm.hasError(createActivityProduct.hours)> <label for=hours class=\"control-label left\">Horas planeadas</label> <input type=number min=0 name=hours ng-model=createProductVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createActivityProduct.hours.$error ng-show=createProductVm.showErrorMessages(createActivityProduct.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=createProductVm.close()> Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=createProductVm.addActivityProduct(createActivityProduct) ng-disabled=\"createProductVm.validateForm(createActivityProduct) || createProductVm.buttonDisabled\"> Aceptar</md-button> </div> </div> </form> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=col-md-12> <img class=\"col-md-12 m-v-sm no-padding\" class=img-responsive ng-src={{url}}> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=50> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createExtensionProjectVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <div class=row> <h3 class=\"text-azul m-r-sm text-block\"> {{createExtensionProjectVm.createOrEdit}} actividad </h3> </div> <div class=row> <label class=text-center>Diligencie el siguiente formulario para agregar una nueva actividad al proyecto.</label> </div> </div> </div> <div class=row> <form name=createActivityProject novalidate> <div class=col-md-12> <div class=form-group ng-class=createExtensionProjectVm.hasError(createActivityProject.nameActivityProject)> <label for=nameActivityProject class=\"control-label left no-padding\">Nombre de actividad</label> <input type=text name=nameActivityProject ng-model=createExtensionProjectVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createActivityProject.nameActivityProject.$error ng-show=createExtensionProjectVm.showErrorMessages(createActivityProject.nameActivityProject)> <div ng-message=required class=text-xs>El nombre de la actividad es requerido.</div> </div> </div> </div> <div class=col-md-12> <div class=form-group ng-class=createExtensionProjectVm.hasError(createActivityProject.description)> <label for=description class=\"control-label left no-padding\">Descripci&oacute;n</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createExtensionProjectVm.description rows=2 ng-model-options=\"{ debounce: 300 }\" class=form-control required maxlength=500 md-maxlength=500>\n              </textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createActivityProject.description.$error ng-show=createExtensionProjectVm.showErrorMessages(createActivityProject.description)> <div ng-message=required class=\"text-xs text-left\">La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">N&uacute;mero de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=col-md-12> <div class=\"col-md-12 no-padding text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempos de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 form-group no-padding-l\" ng-class=createExtensionProjectVm.hasError(createActivityProject.planificationType)> <label for=planificationType class=\"control-label left no-padding\">Seleccione la forma en que se realizar&aacute; la planeaci&oacute;n *</label> </div> <div class=\"col-md-3 no-padding-r\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createExtensionProjectVm.rangeType value=1 ng-change=createExtensionProjectVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createExtensionProjectVm.rangeType value=2 ng-change=createExtensionProjectVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> <div class=\"col-md-9 no-padding-r\"> <div class=\"col-md-12 no-padding\" ng-if=\"createExtensionProjectVm.rangeType == 1\"> <div class=col-md-12> <label class=\"m-r-sm left\" ng-repeat=\"period in createExtensionProjectVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createExtensionProjectVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createExtensionProjectVm.funSelectedPeriod(period, createExtensionProjectVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createExtensionProjectVm.isTouchedPeriods && createExtensionProjectVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"createExtensionProjectVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(createActivityProject.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createExtensionProjectVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createExtensionProjectVm.startDateChange() md-max-date=createExtensionProjectVm.endDate md-min-date=createExtensionProjectVm.minStartDate min=\"{{createExtensionProjectVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=createActivityProject.startDate.$error ng-show=createExtensionProjectVm.showErrorMessages(createActivityProject.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(createActivityProject.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createExtensionProjectVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createExtensionProjectVm.minEndDate min={{createExtensionProjectVm.minEndDate}} ng-change=createExtensionProjectVm.startDateChange()> </md-datepicker> <div class=control-label ng-messages=createActivityProject.endDate.$error ng-show=createExtensionProjectVm.showErrorMessages(createActivityProject.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-12 p-v\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(createActivityProject.hours) ng-if=\"createExtensionProjectVm.hoursChildren == 1\"> <label for=hours class=\"control-label left no-padding\">Horas planeadas</label> <input type=number min=0 name=hours ng-model=createExtensionProjectVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1> <div class=control-label ng-messages=createActivityProject.hours.$error ng-show=createExtensionProjectVm.showErrorMessages(createActivityProject.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=createExtensionProjectVm.close()> Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=createExtensionProjectVm.addActivityProject(createActivityProject) ng-disabled=\"createExtensionProjectVm.isSaveButtonDisabled || createExtensionProjectVm.validateForma(createActivityProject)\"> Aceptar</md-button> </div> </div> </form> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=70> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createProjectFormulationVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Crear formulación de proyectos</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar propuesta\". </p> </div> </div> <form name=createProject novalidate> <div class=row> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales de propuesta de proyecto</h5> </div> <div class=\"col-md-9 no-padding-l\"> <div class=\"row no-padding\"> <div class=\"col-md-7 text-left no-padding-r\"> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.title)> <label for=title class=control-label>T&iacute;tulo</label> <input type=text name=title ng-model=createProjectFormulationVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createProject.title.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-5 text-left\"> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.rol)> <label for=rol class=control-label>Rol</label> <select name=rol ng-model=createProjectFormulationVm.rol ng-options=\"source.idListItem as source.listItemName for source in createProjectFormulationVm.rolList\" class=form-control ng-disabled=createProjectFormulationVm.isEditing required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createProject.rol.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.rol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-12 text-left\"> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.summary)> <label for=summary class=control-label>Resumen del proyecto</label> <md-input-container class=\"control-label no-margin\"> <textarea name=summary ng-model=createProjectFormulationVm.projectSummary rows=2 class=form-control ng-disabled=createProjectFormulationVm.isEditing required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 500 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createProject.summary.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.summary)> <div ng-message=required class=text-xs>El resumen es requerido.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-3 p-h-lg p-v m-b-xs no-padding text-left\"> <label for=financial class=control-label>Tipos de financiadores</label> <div ng-repeat=\"financial in createProjectFormulationVm.typeFinancial\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectFormulationVm.selectedTypeFinancial[financial.financialId] ng-value=financial.financialId name=financial ng-change=\"createProjectFormulationVm.funSelectedFinancial(financial, createProjectFormulationVm.selectedTypeFinancial[financial.financialId])\" ng-disabled=createProjectFormulationVm.isEditing> {{financial.financialName}} </md-checkbox> </div> </div> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 p-b-sm text-left\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.planificationType)> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectFormulationVm.rangeType value=1 ng-disabled=createProjectFormulationVm.isEditing ng-click=createProjectFormulationVm.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectFormulationVm.rangeType value=2 ng-disabled=createProjectFormulationVm.isEditing ng-click=createProjectFormulationVm.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"col-md-6 text-left\" ng-hide=true> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.hours)> <label for=hours class=control-label>Horas planeadas</label> <input type=number min=0 name=hours ng-model=createProjectFormulationVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-disabled=createProjectFormulationVm.isEditing ng-value=0> <div class=control-label ng-messages=createProject.hours.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-12 no-padding text-left\"> <div class=\"col-md-12 no-padding\" ng-if=\"createProjectFormulationVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md\"> <label class=m-r-sm ng-repeat=\"period in createProjectFormulationVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectFormulationVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createProjectFormulationVm.funSelectedPeriod(period, createProjectFormulationVm.selectedTypePeriod[period.periodId])\" ng-disabled=createProjectFormulationVm.isEditing> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createProjectFormulationVm.isTouchedPeriods && createProjectFormulationVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding text-left\" ng-if=\"createProjectFormulationVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createProjectFormulationVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createProjectFormulationVm.startDateChange() md-min-date=createProjectFormulationVm.minStartDate md-max-date=createProjectFormulationVm.endDate min=\"{{createProjectFormulationVm.minStartDate | date: 'dd/MM/yyyy' }}\" ng-disabled=createProjectFormulationVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createProject.startDate.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectFormulationVm.hasError(createProject.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createProjectFormulationVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createProjectFormulationVm.minEndDate min={{createProjectFormulationVm.minEndDate}} ng-change=createProjectFormulationVm.startDateChange() ng-disabled=createProjectFormulationVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createProject.endDate.$error ng-show=createProjectFormulationVm.showErrorMessages(createProject.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-8 no-padding-r text-left\"> <div class=\"col-md-12 right\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createProjectFormulationVm.notification value=1 ng-disabled=createProjectFormulationVm.isEditing> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> <div class=\"col-md-10 p-t\"> <div class=\"col-md-10 text-left\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=createProjectFormulationVm.close()>Cancelar</md-button> </div> <div class=\"col-md-2 no-padding-r\"> <md-button class=\"btn btn-fw btn-success left no-margin\" ng-click=createProjectFormulationVm.addProject(true) ng-disabled=\"createProjectFormulationVm.validateForm(createProject) || createProjectFormulationVm.buttonDisabled\"> Guardar propuesta</md-button> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createProjectVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Crear proyecto</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar proyecto\". Los campos con (*) son obligatorios. </p> </div> </div> <form name=createProject novalidate> <div class=\"blanco row\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del proyecto</h5> </div> <div class=\"col-md-7 no-padding\"> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.title)> <label for=title class=control-label>T&iacute;tulo del proyecto*</label> <input type=text name=title ng-model=createProjectVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createProject.title.$error ng-show=createProjectVm.showErrorMessages(createProject.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group> <label for=groupInvestigation class=control-label>Grupo de investigaci&oacute;n</label> <select name=groupInvestigation ng-model=createProjectVm.groupInvestigation ng-options=\"source.id_code as source.ds_name for source in createProjectVm.groupInvestigationList\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> </div> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.projectFormulated)> <label for=projectFormulated class=control-label>Proyecto asociado*</label> <select name=projectFormulated ng-model=createProjectVm.projectFormulated ng-options=\"source.workplanTeacherActivityId as source.nameProject for source in createProjectVm.projectFormulatedList\" class=form-control> <option value=\"\">Sin Proyecto Asignado</option> </select> <div class=control-label ng-messages=createProject.projectFormulated.$error ng-show=createProjectVm.showErrorMessages(createProject.projectFormulated)> <div ng-message=required class=text-xs>El proyecto asociado es requerido.</div> </div> </div> </div> <div class=\"col-md-6 text-left\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.typeProject)> <label for=typeProject class=control-label>Tipo de proyecto*</label> <select name=typeProject ng-model=createProjectVm.typeProject ng-options=\"source.idListItem as source.listItemName for source in createProjectVm.typeProjectList\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createProject.typeProject.$error ng-show=createProjectVm.showErrorMessages(createProject.typeProject)> <div ng-message=required class=text-xs>El tipo de proyecto es requerido.</div> </div> </div> </div> </div> </div> <div class=col-md-5> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-12 no-padding text-left\"> <div class=form-group> <label for=description class=control-label>Descripci&oacute;n</label> <md-input-container class=control-label> <textarea name=description ng-model=createProjectVm.description rows=3 class=form-control md-maxlength=500 maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-12 no-padding\"> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-5 no-padding-r text-left\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.rol)> <label for=rol class=control-label>Rol en el proyecto*</label> <select name=rol ng-model=createProjectVm.rol ng-options=\"source.idListItem as source.listItemName for source in createProjectVm.rolList\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createProject.rol.$error ng-show=createProjectVm.showErrorMessages(createProject.rol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> <div class=\"col-md-7 text-left\"> <div class=col-md-12> <label for=financial class=control-label>Tipos de financiadores</label> </div> <div class=\"col-md-12 m-t-xs\"> <label class=m-r-sm ng-repeat=\"financial in createProjectVm.typeFinancial\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectVm.selectedTypeFinancial[financial.financialId] ng-value=financial.financialId name=financial ng-change=\"createProjectVm.funSelectedFinancial(financial, createProjectVm.selectedTypeFinancial[financial.financialId])\"> {{financial.financialName}} </md-checkbox> </label> </div> </div> </div> </div> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 p-b-sm text-left\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.planificationType)> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectVm.rangeType value=1 ng-disabled=createProjectVm.isEditing ng-click=createProjectVm.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectVm.rangeType value=2 ng-disabled=createProjectVm.isEditing ng-click=createProjectVm.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"col-md-6 text-left\" ng-hide=true> <div class=form-group ng-class=createProjectVm.hasError(createProject.hours)> <label for=hours class=control-label>Horas planeadas</label> <input type=number min=0 name=hours ng-model=createProjectVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-disabled=createProjectVm.isEditing ng-value=0> <div class=control-label ng-messages=createProject.hours.$error ng-show=createProjectVm.showErrorMessages(createProject.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-12 no-padding text-left\"> <div class=\"col-md-12 no-padding\" ng-if=\"createProjectVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md\"> <label class=m-r-sm ng-repeat=\"period in createProjectVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createProjectVm.funSelectedPeriod(period, createProjectVm.selectedTypePeriod[period.periodId])\" ng-disabled=createProjectVm.isEditing> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createProjectVm.isTouchedPeriods && createProjectVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding text-left\" ng-if=\"createProjectVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createProjectVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createProjectVm.startDateChange() md-min-date=createProjectVm.minStartDate md-max-date=createProjectVm.endDate min=\"{{createProjectVm.minStartDate | date: 'dd/MM/yyyy' }}\" ng-disabled=createProjectVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createProject.startDate.$error ng-show=createProjectVm.showErrorMessages(createProject.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectVm.hasError(createProject.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createProjectVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createProjectVm.minEndDate min={{createProjectVm.minEndDate}} ng-change=createProjectVm.startDateChange() ng-disabled=createProjectVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createProject.endDate.$error ng-show=createProjectVm.showErrorMessages(createProject.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-12 no-padding-r\"> <div class=\"col-md-6 m-t-xs text-left\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createProjectVm.notification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> <div class=\"col-md-11 p-t m-t-md\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel left\" ng-click=createProjectVm.close()>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2 no-padding-r\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createProjectVm.addProject(true) ng-disabled=\"createProjectVm.isSaveButtonDisabled || createProjectVm.validateForm(createProject)\"> Guardar proyecto</md-button> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createProductVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>{{createProductVm.createOrEdit}} producto</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar producto\". Los campos con (*) son obligatorios. </p> </div> </div> <form name=createProduct novalidate> <div class=row> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=\"row no-padding\"> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del producto</h5> </div> <div class=\"col-md-7 no-padding-r\"> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createProductVm.hasError(createProduct.title)> <label for=title class=control-label>T&iacute;tulo preliminar del producto*</label> <input type=text name=title ng-model=createProductVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createProduct.title.$error ng-show=createProductVm.showErrorMessages(createProduct.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-6 text-left\"> <label for=knowledge class=control-label>Área de conocimiento</label> <select name=knowledge ng-model=createProductVm.knowledge ng-options=\"source.idListItem as source.listItemName for source in createProductVm.knowledgeList\" class=form-control style=margin-top:20px> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-6 no-padding-r text-left\"> <label for=typeProduct class=control-label>Tipo de producto</label> <select name=typeProduct ng-model=createProductVm.typeProduct ng-options=\"source.itemId as source.itemName for source in createProductVm.typeProductList\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> <div class=\"col-md-6 text-left\"> <div class=form-group> <label for=subTypeProduct class=control-label>Subtipo de producto</label> <select name=subTypeProduct ng-model=createProductVm.subTypeProduct ng-options=\"source.subItemId as source.subItemName for source in createProductVm.subTypeProductList | filter:{ parentId : createProductVm.typeProduct }\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> </div> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-6 text-left\"> <label for=associatedProject class=control-label>Proyecto asociado</label> <select name=associatedProject ng-model=createProductVm.associatedProject ng-options=\"source.workplanTeacherActivityId as source.name for source in createProductVm.associatedProjecttList\" class=form-control ng-disabled=createProductVm.child.length ng-change=createProductVm.hoursChange(createProductVm.associatedProject)> <option value=\"\">Sin Proyecto Asignado</option> </select> </div> <div class=\"col-md-6 text-left no-padding-r\"> <div class=form-group ng-class=createProductVm.hasError(createProduct.notification)> <div class=\"col-md-12 m-t-lg\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createProductVm.notification value=true ng-disabled=createProductVm.isEditing> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-12 no-padding-r text-left\"> <div class=form-group ng-class=createProductVm.hasError(createProduct.description)> <label for=description class=control-label>Descripci&oacute;n*</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createProductVm.description rows=4 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createProduct.description.$error ng-show=createProductVm.showErrorMessages(createProduct.description)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-12 text-left\"> <label class=control-label>¿Con qué horas ejecutadas desea trabajar?</label> </div> <div class=\"col-md-12 p-b-sm text-left\"> <div class=\"col-md-8 no-padding-r\"> <div class=form-group> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=presencial ng-model=createProductVm.hoursChildren value=0> <i class=radio-green></i> <label class=text-xs>Horas generales del producto</label> </div> </div> <div class=col-md-6 ng-hide=\"createProductVm.showHoursChildren == true\"> <div class=\"radio-options no-margin\"> <input type=radio name=presencial ng-model=createProductVm.hoursChildren value=1> <i class=radio-green></i> <label class=text-xs>Horas por actividades hijas</label> </div> </div> </div> </div> </div> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 p-b-sm text-left\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProductVm.hasError(createProduct.planificationType)> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución*</label> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProductVm.rangeType value=1 ng-disabled=createProductVm.isEditing ng-click=createProductVm.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProductVm.rangeType value=2 ng-disabled=createProductVm.isEditing ng-click=createProductVm.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"col-md-6 text-left\" ng-hide=true> <div class=form-group ng-class=createProductVm.hasError(createProduct.hours)> <label for=hours class=control-label>Horas planeadas</label> <input type=number min=0 name=hours ng-model=createProductVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-disabled=createProductVm.isEditing ng-value=0> <div class=control-label ng-messages=createProduct.hours.$error ng-show=createProductVm.showErrorMessages(createProduct.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-12 no-padding text-left\"> <div class=\"col-md-12 no-padding\" ng-if=\"createProductVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md\"> <label class=m-r-sm ng-repeat=\"period in createProductVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProductVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createProductVm.funSelectedPeriod(period, createProductVm.selectedTypePeriod[period.periodId])\" ng-disabled=createProductVm.isEditing> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createProductVm.isTouchedPeriods && createProductVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding text-left\" ng-if=\"createProductVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProductVm.hasError(createProduct.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createProductVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createProductVm.startDateChange() md-min-date=createProductVm.minStartDate md-max-date=createProductVm.endDate min=\"{{createProductVm.minStartDate | date: 'dd/MM/yyyy' }}\" ng-disabled=createProductVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createProduct.startDate.$error ng-show=createProductVm.showErrorMessages(createProduct.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProductVm.hasError(createProduct.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createProductVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createProductVm.minEndDate min={{createProductVm.minEndDate}} ng-change=createProductVm.startDateChange() ng-disabled=createProductVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createProduct.endDate.$error ng-show=createProductVm.showErrorMessages(createProduct.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-11 p-t m-t-md\"> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel left\" ng-click=createProductVm.close()>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2 no-padding-r\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createProductVm.addProduct(true) ng-disabled=\"createProductVm.validateForm(createProduct) || createProductVm.buttonDisabled\"> Guardar producto</md-button> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createSpaceVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Crear espacio de colaboración</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar espacio de colaboración\".</p> </div> </div> <form name=createSpaceForm novalidate> <div class=row> <div class=\"col-md-12 p-h-lg p-v m-b-xs no-padding\"> <div class=\"row no-padding\"> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del curso</h5> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.cTitle)> <label for=cTitle class=control-label>Nombre del espacio</label> <input type=text name=cTitle ng-model=createSpaceVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createSpaceForm.cTitle.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.cTitle)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=\"col-md-2 no-padding-r text-left\"> <div class=form-group> <label for=ambit class=control-label>Ámbito</label> <select name=ambit ng-model=createSpaceVm.ambit ng-options=\"type.idListItem as type.listItemName for type in createSpaceVm.listAmbit\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"col-md-3 no-padding-r text-left\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.typeComunity)> <label for=typeComunity class=control-label>Tipo</label> <select name=typeComunity ng-model=createSpaceVm.typeComunity ng-options=\"type.idListItem as type.listItemName for type in createSpaceVm.listTypeComunity\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createSpaceForm.typeComunity.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.typeComunity)> <div ng-message=required class=text-xs>El tipo es requerido.</div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.typeParticipate)> <label for=typeParticipate class=control-label>Tipo de participacion del profesor</label> <select name=typeParticipate ng-model=createSpaceVm.typeParticipate ng-options=\"type.idListItem as type.listItemName for type in createSpaceVm.listTypePaticipate\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createSpaceForm.typeParticipate.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.typeParticipate)> <div ng-message=required class=text-xs>El tipo de participacion es requerido.</div> </div> </div> </div> <div class=\"col-md-12 no-padding\"> <div class=\"row no-padding\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.description)> <label for=description class=control-label>Descripci&oacute;n de la actividad de transferencia</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createSpaceVm.description rows=2 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createSpaceForm.description.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.description)> <div ng-message=required class=text-xs> La descripción es requerida. </div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-6 text-left\"> <div class=form-group> <label for=results class=control-label>Resultados esperados</label> <md-input-container class=\"control-label no-margin\"> <textarea name=results ng-model=createSpaceVm.results rows=2 class=form-control maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-3 no-padding-r text-left\"> <div class=form-group> <label for=entity class=control-label>Entidad/Organización</label> <md-autocomplete class=\"autocomplete no-padding col-md-12 m-r-xs\" md-selected-item=createSpaceVm.selectedItemEntity md-search-text=createSpaceVm.searchText md-items=\"source in createSpaceVm.searchEntity(createSpaceVm.searchText)\" md-item-text=source.listItemName md-min-length=0 placeholder=\"Buscar entidad...\" md-selected-item-change=createSpaceVm.changeEntity(source)> <md-item-template> <span md-highlight-text=searchText md-highlight-flags=^i>{{source.listItemName}}</span> </md-item-template> </md-autocomplete> </div> </div> <div class=\"col-md-3 no-padding-r text-left\"> <div class=form-group> <label for=link class=control-label>Enlace del evento u organizador</label> <input type=url name=link ng-model=createSpaceVm.link value=\"http://jsfiddle .net/\" class=form-control pattern=https?://.+ placeholder=https://www.example.com title=\"No deje espacios por favor\"> <div class=control-label ng-messages=createSpaceForm.description.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.description)> <div ng-message=required class=text-xs>El enlace es requerido</div> <div ng-message=pattern class=text-xs>El enlace es debe llevar el formato 'http://www.elencale.com'</div> </div> </div> </div> <div class=\"col-md-3 text-left\"> <div class=form-group> <label for=cCountry class=control-label>Pa&iacute;s</label> <select name=coCountry ng-model=createSpaceVm.country ng-options=\"source.codeCountry as source.nameCountry for source in createSpaceVm.countries\" class=form-control ng-change=createSpaceVm.enableCities(createSpaceVm.country)> <option value=\"\">Seleccione</option> </select> </div> </div> <div class=\"col-md-3 no-padding-r text-left\"> <div class=form-group> <label for=searchcity class=control-label>Ciudad</label> <md-autocomplete class=\"autocomplete no-padding col-md-12 m-r-xs\" md-clear-button=false md-item-text=source.nameCity md-min-length=1 md-no-cache=true md-selected-item-change=createSpaceVm.changeCity(source) md-selected-item=createSpaceVm.selectedItemCity md-search-text=createSpaceVm.searchcity placeholder=\"Buscar ciudad...\" md-items=\"source in createSpaceVm.searchCity(createSpaceVm.searchcity)\" ng-disabled=createSpaceVm.countrySelected> <md-item-template> <span md-highlight-text=searchcity md-highlight-flags=^i>{{source.nameCity}}</span> </md-item-template> </md-autocomplete> </div> <div class=\"form-group has-error no-padding-h\" ng-show=createSpaceVm.invalidCity> <label class=\"control-label no-padding-h\"> Debe seleccionar una ciudad de la lista </label> </div> </div> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=\"col-md-12 p-b-sm text-left\"> <div class=\"col-md-6 no-padding\"> <div class=\"col-md-12 no-padding\"> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> </div> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.planificationType)> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createSpaceVm.rangeType value=1 ng-disabled=createSpaceVm.isEditing ng-click=createSpaceVm.rbPlanifications(true)> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createSpaceVm.rangeType value=2 ng-disabled=createSpaceVm.isEditing ng-click=createSpaceVm.rbPlanifications(false)> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"col-md-6 text-left\" ng-hide=true> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.hours)> <label for=hours class=control-label>Horas planeadas</label> <input type=number min=0 name=hours ng-model=createSpaceVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-disabled=createSpaceVm.isEditing ng-value=0> <div class=control-label ng-messages=createSpaceForm.hours.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> <div class=\"col-md-12 no-padding text-left\"> <div class=\"col-md-12 no-padding\" ng-if=\"createSpaceVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md no-padding\"> <label class=m-r-sm ng-repeat=\"period in createSpaceVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createSpaceVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createSpaceVm.funSelectedPeriod(period, createSpaceVm.selectedTypePeriod[period.periodId])\" ng-disabled=createSpaceVm.isEditing> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createSpaceVm.isTouchedPeriods && createSpaceVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding text-left\" ng-if=\"createSpaceVm.rangeType == 2\"> <div class=\"col-md-3 no-padding-r\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createSpaceVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createSpaceVm.startDateChange() md-min-date=createSpaceVm.minStartDate md-max-date=createSpaceVm.endDate min=\"{{createSpaceVm.minStartDate | date: 'dd/MM/yyyy' }}\" ng-disabled=createSpaceVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createSpaceForm.startDate.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-3 no-padding-r\"> <div class=form-group ng-class=createSpaceVm.hasError(createSpaceForm.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createSpaceVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createSpaceVm.minEndDate min={{createSpaceVm.minEndDate}} ng-change=createSpaceVm.startDateChange() ng-disabled=createSpaceVm.isEditing> </md-datepicker> <div class=control-label ng-messages=createSpaceForm.endDate.$error ng-show=createSpaceVm.showErrorMessages(createSpaceForm.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-12 p-t\"> <div class=\"col-md-10 text-left\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=createSpaceVm.close()>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createSpaceVm.addSpace(true) ng-disabled=\"createSpaceVm.isSaveButtonDisabled || createSpaceVm.validateForm(createSpaceForm)\"> Guardar espacio</md-button> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createTrainingVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Agregar evento de formaci&oacute;n</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar formación en investigación\". Los campos con (*) son obligatorios. </p> </div> </div> <form name=createTraining novalidate> <div class=row> <div class=\"col-md-12 p-h-lg m-b-xs\"> <div class=\"row no-padding\"> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=col-md-12> <div class=\"row gutter-10 m-t-xs no-padding\"> <div class=\"col-md-4 text-left\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.title)> <label for=title class=control-label>Nombre *</label> <input type=text name=title ng-model=createTrainingVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control maxlength=200 required> <div class=control-label ng-messages=createTraining.title.$error ng-show=createTrainingVm.showErrorMessages(createTraining.title)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=\"col-md-4 text-left\"> <div class=form-group> <label for=spaceType class=control-label>Tipo de actividad formativa</label> <select name=spaceType ng-model=createTrainingVm.spaceType ng-options=\"type.idListItem as type.listItemName for type in createTrainingVm.listSpaceType\" class=form-control ng-change=createTrainingVm.onActivityTypeChanged(createTrainingVm.spaceType)> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"col-md-4 text-left\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.link)> <label for=link class=control-label>Enlace de actividad formativa *</label> <input type=url name=link ng-model=createTrainingVm.link class=form-control pattern=https?://.+ placeholder=https://www.example.com> </div> </div> </div> <div class=\"row gutter-10 m-t-xs no-padding\"> <div class=\"col-md-6 text-left\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.description)> <label for=description class=control-label>Descripción y justificación *</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createTrainingVm.description rows=3 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createTraining.description.$error ng-show=createTrainingVm.showErrorMessages(createTraining.description)> <div ng-message=required class=text-xs>La descripción es requerida.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-6 text-left\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.results)> <label for=results class=control-label>Resultados esperados *</label> <md-input-container class=\"control-label no-margin\"> <textarea name=results ng-model=createTrainingVm.results rows=3 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createTraining.results.$error ng-show=createTrainingVm.showErrorMessages(createTraining.results)> <div ng-message=required class=text-xs>Los resultados esperados son requeridos.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-12 text-left p-t\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Cantidad de estudiantes</h5> </div> <div class=col-md-11> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=\"row no-padding\"> <div class=\"col-md-4 text-left no-padding-l\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.preg)> <label for=preg class=control-label> Pregrado<span ng-if=createTrainingVm.amountOfStudentsRequired>*</span> </label> <input type=number name=preg ng-model=createTrainingVm.preg ng-change=createTrainingVm.checkStudents() min=1 class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1 ng-required=createTrainingVm.amountOfStudentsRequired> <div class=control-label ng-messages=createTraining.preg.$error ng-show=createTrainingVm.showErrorMessages(createTraining.preg)> <div ng-message=min class=text-xs> Ingrese al menos un estudiante de pregrado </div> </div> </div> </div> <div class=\"col-md-4 text-left no-padding-l\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.postg)> <label for=postg class=control-label> Postgrado<span ng-if=createTrainingVm.amountOfStudentsRequired>*</span> </label> <input type=number name=postg ng-model=createTrainingVm.postg ng-change=createTrainingVm.checkStudents() min=1 class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1 ng-required=createTrainingVm.amountOfStudentsRequired> <div class=control-label ng-messages=createTraining.postg.$error ng-show=createTrainingVm.showErrorMessages(createTraining.postg)> <div ng-message=min class=text-xs>Ingrese al menos un estudiante de postgrado</div> </div> </div> </div> <div class=\"col-md-4 text-left no-padding-l\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.doct)> <label for=doct class=control-label> Doctorado<span ng-if=createTrainingVm.amountOfStudentsRequired>*</span> </label> <input type=number name=doct ng-model=createTrainingVm.doct ng-change=createTrainingVm.checkStudents() min=1 class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" onpaste=return!1 ng-required=createTrainingVm.amountOfStudentsRequired> <div class=control-label ng-messages=createTraining.doct.$error ng-show=createTrainingVm.showErrorMessages(createTraining.doct)> <div ng-message=min class=text-xs>Ingrese al menos un estudiante de doctorado</div> </div> </div> </div> </div> </div> </div> <div ng-if=createTrainingVm.amountOfStudentsRequired class=\"text-xs text-rojo left\"> Al menos un tipo de estudiante es obligatorio. </div> </div> <div class=\"col-md-12 p-t\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b text-left\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=col-md-12> <div class=\"row no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=\"col-md-12 no-padding text-left\"> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> </div> <div class=\"col-md-8 no-padding\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.planificationType)> <div class=col-md-5> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createTrainingVm.rangeType value=1> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-7> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createTrainingVm.rangeType value=2> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"col-md-4 left\" ng-hide=true> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.hours)> <label for=hours class=control-label>Horas Planeadas</label> <input type=number min=0 name=hours ng-model=createTrainingVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\" ng-disabled=createTrainingVm.isEditing ng-value=0> <div class=control-label ng-messages=createTraining.hours.$error ng-show=createTrainingVm.showErrorMessages(createTraining.hours)> <div ng-message=required class=text-xs>Las horas son requeridas.</div> </div> </div> </div> </div> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-12 no-padding text-left\" ng-if=\"createTrainingVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md no-padding\"> <label class=m-r-sm ng-repeat=\"period in createTrainingVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createTrainingVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createTrainingVm.funSelectedPeriod(period, createTrainingVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createTrainingVm.isTouchedPeriods && createTrainingVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 text-left\" ng-if=\"createTrainingVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createTrainingVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa min=\"{{createTrainingVm.minStartDate | date: 'dd/MM/yyyy' }}\" md-min-date=createTrainingVm.minStartDate md-max-date=createTrainingVm.endDate ng-change=createTrainingVm.startDateChange() required> </md-datepicker> <div class=control-label ng-messages=createTraining.startDate.$error ng-show=createTrainingVm.showErrorMessages(createTraining.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createTrainingVm.hasError(createTraining.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createTrainingVm.endDate name=endDate md-placeholder=dd/mm/aaaa md-open-on-focus onkeydown=return!1 md-min-date=createTrainingVm.minEndDate min={{createTrainingVm.minEndDate}} required> </md-datepicker> <div class=control-label ng-messages=createTraining.endDate.$error ng-show=createTrainingVm.showErrorMessages(createTraining.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-3 m-t-xs\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createTrainingVm.notification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> </div> </div> <div class=\"col-md-11 p-t\"> <div class=row> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel left\" ng-click=createTrainingVm.close()>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createTrainingVm.addTraining(true) ng-disabled=\"createTrainingVm.isSaveButtonDisabled || createTrainingVm.validateForm(createTraining)\"> Guardar formación</md-button> </div> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createTransferVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=text-azul>Crear transferencia de resultados</h3> <p class=text-xs>Diligencie los datos del siguiente formulario para agregar y luego haga clic en el bot&oacute;n \"Guardar transferencia\". Todos los campos son obligatorios.</p> </div> </div> <form name=createResultTransfer novalidate> <div class=row> <div class=\"col-md-12 p-h-lg m-b-xs\"> <div class=\"row no-padding\"> <div class=\"col-md-12 no-padding text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=\"col-md-12 no-padding\"> <div class=\"row gutter-10 m-t-xs no-padding\"> <div class=\"col-md-6 text-left\"> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.title)> <label for=title class=control-label>Nombre</label> <input type=text name=title ng-model=createTransferVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createResultTransfer.title.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.title)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=\"col-md-6 text-left\"> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.resultsType)> <label for=resultsType class=control-label>Tipo de resultados suceptible de transferencia</label> <select name=resultsType ng-model=createTransferVm.resultsType ng-options=\"source.idListItem as source.listItemName for source in createTransferVm.listResultsType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createResultTransfer.resultsType.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.resultsType)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> </div> <div class=\"row m-t-xs no-padding\"> <div class=\"col-md-12 text-left no-padding\"> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.description)> <label for=description class=control-label>Descripción y justificación</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createTransferVm.description rows=3 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createResultTransfer.description.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.description)> <div ng-message=required class=text-xs>La descripción es requerida.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-12 text-left no-padding\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=col-md-12> <div class=\"row no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-7 no-padding text-left\"> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.planificationType)> <div class=\"col-md-4 text-left\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createTransferVm.rangeType value=1 ng-change=createTransferVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=\"col-md-6 text-left\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createTransferVm.rangeType value=2 ng-change=createTransferVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> </div> <div class=\"col-md-4 left\" ng-hide=true> <label for=hours class=control-label>Horas Planeadas</label> <input type=number min=0 name=hours ng-model=createTransferVm.plannedHours class=form-control onkeypress=\"return 48<=event.charCode&&event.charCode<=58\"> </div> </div> <div class=\"col-md-12 no-padding text-left\"> <div class=\"col-md-12 no-padding\" ng-if=\"createTransferVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md\"> <label class=m-r-sm ng-repeat=\"period in createTransferVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createTransferVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createTransferVm.funSelectedPeriod(period, createTransferVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> </div> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createTransferVm.isTouchedPeriods && createTransferVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> <div class=\"col-md-12 no-padding\" ng-if=\"createTransferVm.rangeType == 2\"> <div class=\"col-md-4 no-padding text-left\"> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha inicio</label> <md-datepicker ng-model=createTransferVm.startDate name=startDate md-placeholder=dd/mm/aaaa md-min-date=createTransferVm.minStartDate md-open-on-focus onkeydown=return!1 min=\"{{createTransferVm.minStartDate | date: 'dd/MM/yyyy' }}\" ng-change=createTransferVm.startDateChange() required> </md-datepicker> <div class=control-label ng-messages=createResultTransfer.startDate.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createTransferVm.hasError(createResultTransfer.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha fin</label> <md-datepicker ng-model=createTransferVm.endDate name=endDate md-placeholder=dd/mm/aaaa md-min-date=createTransferVm.minEndDate md-open-on-focus onkeydown=return!1 min={{createTransferVm.minEndDate}} required> </md-datepicker> <div class=control-label ng-messages=createResultTransfer.endDate.$error ng-show=createTransferVm.showErrorMessages(createResultTransfer.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row no-padding p-t\"> <div class=\"col-md-12 right no-padding text-left\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox name=notification ng-model=createTransferVm.notification value=1> <span class=control-label>¿Desea recibir notificaciones?</span> </md-checkbox> </div> </div> <div class=\"col-md-11 p-t\"> <div class=row> <div class=col-md-10> <md-button class=\"btn btn-fw btn-cancel left\" ng-click=createTransferVm.close()>Cancelar</md-button> </div> <div class=\"col-md-2 col-md-2\"> <md-button class=\"btn btn-fw btn-success right\" ng-click=createTransferVm.addTransfer(true) ng-disabled=\"createTransferVm.validateForm(createResultTransfer) || createTransferVm.buttonDisabled\"> Guardar transferencia</md-button> </div> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createProjectFormulationProposalVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-azul text-center\">Crear formulaci&oacute;n de propuesta</h3> <p class=text-xs>Ingrese los datos del siguiente formulario y luego haga clic en el bot&oacute;n \"Guardar formulaci&oacute;n de propuesta\". Todos los campos son obligatorios.</p> </div> </div> <form name=newProjectFormulationProposal novalidate> <div class=\"blanco row\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del proyecto</h5> </div> <div class=col-md-12> <div class=\"row no-padding\"> <div class=\"col-md-4 no-padding-l text-left\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.title)> <label for=title class=control-label>T&iacute;tulo de propuesta *</label> <input type=text name=title ng-model=createProjectFormulationProposalVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=newProjectFormulationProposal.title.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.title)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-l text-left\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.potentialAllies)> <label for=potentialAllies class=control-label>Aliados potenciales *</label> <input type=text name=potentialAllies ng-model-options=\"{ debounce: 300 }\" ng-model=createProjectFormulationProposalVm.potentialAllies class=form-control required> <div class=control-label ng-messages=newProjectFormulationProposal.potentialAllies.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.potentialAllies)> <div ng-message=required class=text-xs>Los aliados son requeridos.</div> </div> </div> </div> <div class=\"col-md-4 no-padding text-left\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.projectType)> <label for=projectType class=control-label>Tipo de proyecto *</label> <select name=projectType ng-model=createProjectFormulationProposalVm.projectType ng-options=\"source.idListItem as source.listItemName for source in createProjectFormulationProposalVm.projectTypes\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=newProjectFormulationProposal.projectType.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.projectType)> <div ng-message=required class=text-xs>El tipo de proyecto es requerido.</div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-12 p-t no-padding\"> <div class=\"col-md-6 no-padding-l text-left\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.summary)> <label for=summary class=control-label>Resumen *</label> <md-input-container class=\"control-label no-margin\"> <textarea type=text name=summary ng-model=createProjectFormulationProposalVm.summary class=form-control required rows=2 maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=newProjectFormulationProposal.summary.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.summary)> <div ng-message=required class=text-xs>El resumen es requerido.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-6 no-padding text-left\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.observation)> <label for=observation class=control-label>Objetivo *</label> <md-input-container class=\"control-label no-margin\"> <textarea type=text name=observation ng-model=createProjectFormulationProposalVm.observation class=form-control required rows=2 maxlength=500 md-maxlength=500></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=newProjectFormulationProposal.observation.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.observation)> <div ng-message=required class=text-xs>El objetivo es requerido.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=\"col-md-12 no-padding text-left\"> <div class=form-group> <label class=control-label>Financiadores</label> <div class=\"col-md-12 no-padding text-left\"> <label class=m-r-sm ng-repeat=\"financier in createProjectFormulationProposalVm.financiers\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectFormulationProposalVm.selectedFinancier[financier.financialId] ng-value=financier.financialId name=financier ng-change=\"createProjectFormulationProposalVm.funSelectedFinancier(financier, createProjectFormulationProposalVm.selectedFinancier[financier.financialId])\"> {{financier.financialName}} </md-checkbox> </label> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t-xs text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b text-left\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> <div class=\"col-md-5 no-padding text-left\"> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> <div class=col-md-5> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectFormulationProposalVm.rangeType value=1 ng-change=createProjectFormulationProposalVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-7> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createProjectFormulationProposalVm.rangeType value=2 ng-change=createProjectFormulationProposalVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=\"col-md-7 no-padding\"> <div class=\"col-md-12 no-padding\" ng-if=\"createProjectFormulationProposalVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md no-padding\"> <label class=m-r-sm ng-repeat=\"period in createProjectFormulationProposalVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createProjectFormulationProposalVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createProjectFormulationProposalVm.funSelectedPeriod(period, createProjectFormulationProposalVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createProjectFormulationProposalVm.isTouchedPeriods && createProjectFormulationProposalVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> </div> <div class=col-md-12 ng-if=\"createProjectFormulationProposalVm.rangeType == 2\"> <div class=\"col-md-6 no-padding\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha Inicio</label> <md-datepicker ng-model=createProjectFormulationProposalVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createProjectFormulationProposalVm.startDateChange() md-min-date=createProjectFormulationProposalVm.minStartDate md-max-date=createProjectFormulationProposalVm.endDate min=\"{{createProjectFormulationProposalVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=newProjectFormulationProposal.startDate.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createProjectFormulationProposalVm.hasError(newProjectFormulationProposal.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha Fin</label> <md-datepicker ng-model=createProjectFormulationProposalVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createProjectFormulationProposalVm.minEndDate min={{createProjectFormulationProposalVm.minEndDate}} ng-change=createProjectFormulationProposalVm.startDateChange()> </md-datepicker> <div class=control-label ng-messages=newProjectFormulationProposal.endDate.$error ng-show=createProjectFormulationProposalVm.showErrorMessages(newProjectFormulationProposal.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel no-margin text-center\" ng-click=createProjectFormulationProposalVm.close()>Cancelar</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success no-margin text-center\" ng-click=createProjectFormulationProposalVm.addProjectFormulationProposal(true) ng-disabled=\"createProjectFormulationProposalVm.isSaveButtonDisabled || createProjectFormulationProposalVm.validateForm(newProjectFormulationProposal)\"> Guardar</md-button> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createExtensionProjectVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-azul text-center\">Crear proyecto de extensión</h3> <p class=text-xs>Ingrese los datos del siguiente formulario y luego haga clic en el bot&oacute;n \"Guardar proyecto de extensi&oacute;n\". Todos los campos son obligatorios.</p> </div> </div> <form name=newExtensionProject novalidate> <div class=\"blanco row\"> <div class=col-md-12> <div class=row> <div class=\"col-md-12 text-left no-padding\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos del proyecto</h5> </div> <div class=\"col-md-16 no-padding-r\"> <div class=\"col-md-8 no-padding-l text-left\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(newExtensionProject.docTitle)> <label for=docTitle class=control-label>T&iacute;tulo de proyecto *</label> <input type=text name=docTitle ng-model=createExtensionProjectVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=newExtensionProject.docTitle.$error ng-show=createExtensionProjectVm.showErrorMessages(newExtensionProject.docTitle)> <div ng-message=required class=text-xs>El t&iacute;tulo es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding text-left\"> <div class=form-group> <label for=docProjectRole class=control-label>Rol en el proyecto</label> <select name=docProjectRole ng-model=createExtensionProjectVm.projectRole ng-options=\"source.idListItem as source.listItemName for source in createExtensionProjectVm.projectRoles\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> <div class=\"col-md-4 no-padding-l text-left\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(newExtensionProject.docProjectType)> <label for=docProjectType class=control-label>Tipo de proyecto *</label> <select name=docProjectType ng-model=createExtensionProjectVm.projectType ng-options=\"source.idListItem as source.listItemName for source in createExtensionProjectVm.projectTypes\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=newExtensionProject.docProjectType.$error ng-show=createExtensionProjectVm.showErrorMessages(newExtensionProject.docProjectType)> <div ng-message=required class=text-xs>El tipo de proyecto es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group> <label for=docAssocProposal class=control-label>Propuesta asociada</label> <select name=docAssocProposal ng-model=createExtensionProjectVm.assocProposal ng-options=\"source.workplanTeacherActivityId as source.titleProject for source in createExtensionProjectVm.assocProposals\" class=form-control> <option value=\"\">Sin Propuesta Asignada</option> </select> </div> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group> <label for=docAcUnit class=control-label>Unidad acad&eacute;mica</label> <select name=docAcUnit ng-model=createExtensionProjectVm.acUnit ng-options=\"source.id_code as source.ds_name for source in createExtensionProjectVm.acUnits\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-7 no-padding text-left\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(newExtensionProject.docAbstract)> <label for=docAbstract class=control-label>Descripci&oacute;n *</label> <md-input-container class=\"control-label no-margin\"> <textarea type=text name=docAbstract ng-model=createExtensionProjectVm.description class=form-control required rows=2 maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-10 no-padding\"> <div class=\"col-md-7 no-padding\"> <div class=control-label ng-messages=newExtensionProject.docAbstract.$error ng-show=createExtensionProjectVm.showErrorMessages(newExtensionProject.docAbstract)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-5 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-3 no-padding-r text-left\"> <div class=form-group> <label class=control-label> Financiadores</label> <div class=col-md-12> <label class=m-r-sm ng-repeat=\"financier in createExtensionProjectVm.financiers\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createExtensionProjectVm.selectedFinancier[financier.financialId] ng-value=financier.financialId name=financier ng-change=\"createExtensionProjectVm.funSelectedFinancier(financier, createExtensionProjectVm.selectedFinancier[financier.financialId])\"> {{financier.financialName}} </md-checkbox> </label> </div> </div> </div> </div> </div> <div class=\"col-md-12 text-left\"> <label class=control-label>¿Con qué horas ejecutadas desea trabajar?</label> </div> <div class=\"col-md-12 p-b-sm text-left\"> <div class=\"col-md-8 no-padding-r\"> <div class=form-group> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=presencial ng-model=createExtensionProjectVm.hoursChildren value=0> <i class=radio-green></i> <label class=text-xs>Horas generales del producto</label> </div> </div> <div class=col-md-6> <div class=\"radio-options no-margin\"> <input type=radio name=presencial ng-model=createExtensionProjectVm.hoursChildren value=1> <i class=radio-green></i> <label class=text-xs>Horas por actividades hijas</label> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-16 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=col-md-16> <div class=\"col-md-5 no-padding text-left\"> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> <div class=col-md-5> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createExtensionProjectVm.rangeType value=1 ng-change=createExtensionProjectVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-7> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createExtensionProjectVm.rangeType value=2 ng-change=createExtensionProjectVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=\"col-md-7 no-padding\"> <div class=col-md-16 ng-if=\"createExtensionProjectVm.rangeType == 1\"> <div class=\"col-md-16 m-t-md text-left\"> <label class=m-r-sm ng-repeat=\"period in createExtensionProjectVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm text-xs\" type=checkbox ng-model=createExtensionProjectVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createExtensionProjectVm.funSelectedPeriod(period, createExtensionProjectVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> <div class=\"col-md-16 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createExtensionProjectVm.isTouchedPeriods && createExtensionProjectVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> </div> <div class=col-md-12 ng-if=\"createExtensionProjectVm.rangeType == 2\"> <div class=\"col-md-6 no-padding\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(createShortCourse.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha Inicio</label> <md-datepicker ng-model=createExtensionProjectVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createExtensionProjectVm.startDateChange() md-min-date=createExtensionProjectVm.minStartDate md-max-date=createExtensionProjectVm.endDate min=\"{{createExtensionProjectVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=createShortCourse.startDate.$error ng-show=createExtensionProjectVm.showErrorMessages(createShortCourse.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createExtensionProjectVm.hasError(createShortCourse.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha Fin</label> <md-datepicker ng-model=createExtensionProjectVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createExtensionProjectVm.minEndDate min={{createExtensionProjectVm.minEndDate}} ng-change=createExtensionProjectVm.startDateChange()> </md-datepicker> <div class=control-label ng-messages=createShortCourse.endDate.$error ng-show=createExtensionProjectVm.showErrorMessages(createShortCourse.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-16 p-t\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel\" ng-click=createExtensionProjectVm.close()>Cancelar</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success left\" ng-click=createExtensionProjectVm.addExtensionProject(true) ng-disabled=\"createExtensionProjectVm.isSaveButtonDisabled || createExtensionProjectVm.validateForm(newExtensionProject)\"> Guardar</md-button> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=80> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createVisibilityVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-azul text-center\">Crear comunicaci&oacute;n y visibilidad</h3> <p class=text-xs>Ingrese los datos del siguiente formulario y luego haga clic en el bot&oacute;n \"Guardar comunicaci&oacute;n y visibilidad\". Todos los campos son obligatorios.</p> </div> {{createVisibilityVm.aux}} </div> <form name=createVisibility novalidate> <div class=\"row blanco\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=row> <div class=\"col-md-12 text-left\"> <div class=\"col-md-4 no-padding-r\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Tipo de registro</h5> </div> </div> <div class=\"col-md-12 text-left\"> <div class=\"col-md-5 no-padding-r\"> <label for=registryType class=control-label>Seleccione el tipo de registro que desea agregar</label> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-h-lg\"> <div class=col-md-3> <div class=\"radio-options no-margin\"> <input type=radio name=registryType ng-model=createVisibilityVm.registryType value=1> <i class=radio-green></i> <label class=text-xs>Medio de comunicación</label> </div> </div> <div class=col-md-5> <div class=\"radio-options no-margin\"> <input type=radio name=registryType ng-model=createVisibilityVm.registryType value=2> <i class=radio-green></i> <label class=text-xs>Redes, asociaciones y relaciones interinstitucionales</label> </div> </div> <div class=col-md-3> <div class=\"radio-options no-margin\"> <input type=radio name=registryType ng-model=createVisibilityVm.registryType value=3> <i class=radio-green></i> <label class=text-xs>Organización de eventos</label> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left\"> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=\"col-md-8 no-padding\"> <div class=\"row no-padding\"> <div class=\"col-md-8 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.title)> <div ng-if=\"createVisibilityVm.registryType == 1\"> <label for=title class=control-label>Nombre del medio</label> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <label for=title class=control-label>Nombre de la red y/o asociación</label> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <label for=title class=control-label>Nombre</label> </div> <input type=text name=title ng-model=createVisibilityVm.title ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createVisibility.title.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.title)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaKindType)> <label for=mediaKindType class=control-label>Tipo</label> <select name=mediaKindType ng-model=createVisibilityVm.mediaKindType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaKind\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaKindType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaKindType)> <div ng-message=required class=text-xs>El tipo es requerido.</div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2 || createVisibilityVm.registryType == 3\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.networkAssocInterInstitRelatAmbitStageType)> <label for=networkAssocInterInstitRelatAmbitStageType class=control-label>Ámbito/Escenario</label> <select name=networkAssocInterInstitRelatAmbitStageType ng-model=createVisibilityVm.networkAssocInterInstitRelatAmbitStageType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeNetworkAssocInterInstitRelatAmbitStage\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatAmbitStageType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.networkAssocInterInstitRelatAmbitStageType)> <div ng-message=required class=text-xs>El &aacute;mbito/escenario es requerido.</div> </div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaRolType)> <label for=mediaRolType class=control-label>Rol</label> <select name=mediaRolType ng-model=createVisibilityVm.mediaRolType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaRol\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaRolType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaRolType)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.networkAssocInterInstitRelatSectorType)> <label for=networkAssocInterInstitRelatSectorType class=control-label>Sector</label> <select name=networkAssocInterInstitRelatSectorType ng-model=createVisibilityVm.networkAssocInterInstitRelatSectorType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeSector\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatSectorType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.networkAssocInterInstitRelatSectorType)> <div ng-message=required class=text-xs>El sector es requerido.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.eventOrganizationUnity)> <label for=eventOrganizationUnity class=control-label>Unidad</label> <select name=eventOrganizationUnity ng-model=createVisibilityVm.eventOrganizationUnity ng-options=\"unit.academitUnitId as unit.academitUnitName for unit in createVisibilityVm.arrayUnit\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.eventOrganizationUnity.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.eventOrganizationUnity)> <div ng-message=required>La unidad es requerida</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 1 || createVisibilityVm.registryType == 2\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaURL)> <label for=mediaURL class=control-label>URL</label> <input type=url name=mediaURL ng-model=createVisibilityVm.mediaURL class=form-control pattern=https?://.+ placeholder=https://www.example.com> <div class=control-label ng-messages=createVisibility.mediaURL.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaURL)> <div ng-message=required class=text-xs>La url es requerida.</div> <div ng-message=pattern class=text-xs>La url no es válida. El formato debe ser \"https://www.example.com\"</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.eventOrganizationContact)> <label for=eventOrganizationContact class=control-label>Contacto</label> <input type=text name=eventOrganizationContact ng-model=createVisibilityVm.networkAssocInterInstitRelatContactName ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createVisibility.eventOrganizationContact.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.eventOrganizationContact)> <div ng-message=required class=text-xs>El contacto es requerido.</div> </div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaFrequencyOfEmissionType)> <label for=mediaFrequencyOfEmissionType class=control-label>Frecuencia de emisi&oacute;n</label> <select name=mediaFrequencyOfEmissionType ng-model=createVisibilityVm.mediaFrequencyOfEmissionType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaFrequencyOfEmissionType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaFrequencyOfEmissionType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaFrequencyOfEmissionType)> <div ng-message=required class=text-xs>La frecuencia de emisi&oacute;n es requerida.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.networkAssocInterInstitRelatEmail)> <label for=networkAssocInterInstitRelatEmail class=control-label>Correo electr&oacute;nico</label> <input type=email name=networkAssocInterInstitRelatEmail ng-model=createVisibilityVm.networkAssocInterInstitRelatEmail class=form-control ng-pattern=createVisibilityVm.regex required> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatEmail.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.networkAssocInterInstitRelatEmail)> <div ng-message=required class=text-xs>El correo electr&oacute;nico es requerido.</div> <div ng-message=pattern class=text-xs>El formato del correo electr&oacute;nico no es v&aacute;lido.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.eventOrganizationLink)> <label for=eventOrganizationLink class=control-label>Enlace</label> <input type=url name=eventOrganizationLink ng-model=createVisibilityVm.mediaURL class=form-control pattern=https?://.+ placeholder=https://www.example.com> <div class=control-label ng-messages=createVisibility.eventOrganizationLink.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.eventOrganizationLink)> <div ng-message=required class=text-xs>El enlace es requerido.</div> <div ng-message=pattern class=text-xs>El enlace no es válido. El formato debe ser \"https://www.example.com\"</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 1\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaPublicAudienceType)> <label for=mediaPublicAudienceType class=control-label>Audiencia p&uacute;blicos</label> <select name=mediaPublicAudienceType ng-model=createVisibilityVm.mediaPublicAudienceType ng-options=\"source.idListItem as source.listItemName for source in createVisibilityVm.listsTypeMediaPublicAudience\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createVisibility.mediaPublicAudienceType.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaPublicAudienceType)> <div ng-message=required class=text-xs>La audiencia p&uacute;blicos es requerida.</div> </div> </div> </div> </div> <div ng-if=\"createVisibilityVm.registryType == 2\"> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.networkAssocInterInstitRelatContactName)> <label for=networkAssocInterInstitRelatContactName class=control-label>Nombre del contacto</label> <input type=text name=networkAssocInterInstitRelatContactName ng-model=createVisibilityVm.networkAssocInterInstitRelatContactName ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createVisibility.networkAssocInterInstitRelatContactName.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.networkAssocInterInstitRelatContactName)> <div ng-message=required class=text-xs>El nombre del contacto es requerido.</div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-4 text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.mediaDescription)> <div ng-if=\"createVisibilityVm.registryType == 1 || createVisibilityVm.registryType == 2\"> <label for=mediaDescription class=control-label>Descripci&oacute;n</label> </div> <div ng-if=\"createVisibilityVm.registryType == 3\"> <label for=mediaDescription class=control-label>Objetivo/Descripci&oacute;n</label> </div> <md-input-container class=\"control-label no-margin\"> <textarea name=mediaDescription ng-model=createVisibilityVm.mediaDescription rows=3 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createVisibility.mediaDescription.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.mediaDescription)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left\"> <div class=\"col-md-4 no-padding-r\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> </div> <div class=\"col-md-12 text-left\"> <div class=\"col-md-12 no-padding-r\"> <div class=\"col-md-12 no-padding\"> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> </div> <div class=\"col-md-2 text-left\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createVisibilityVm.rangeType value=1 ng-change=createVisibilityVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=\"col-md-6 text-left\"> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createVisibilityVm.rangeType value=2 ng-change=createVisibilityVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=\"col-md-12 no-padding-r text-left\"> <div class=\"col-md-12 no-padding\" ng-if=\"createVisibilityVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md\"> <label class=m-r-sm ng-repeat=\"period in createVisibilityVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createVisibilityVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createVisibilityVm.funSelectedPeriod(period, createVisibilityVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createVisibilityVm.isTouchedPeriods && createVisibilityVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> </div> <div class=\"col-md-12 no-padding m-t\" ng-if=\"createVisibilityVm.rangeType == 2\"> <div class=\"col-md-3 no-padding text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha Inicio</label> <md-datepicker ng-model=createVisibilityVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createVisibilityVm.startDateChange() md-min-date=createVisibilityVm.minStartDate md-max-date=createVisibilityVm.endDate min=\"{{createVisibilityVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=createVisibility.startDate.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createVisibilityVm.hasError(createVisibility.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha Fin</label> <md-datepicker ng-model=createVisibilityVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createVisibilityVm.minEndDate min={{createVisibilityVm.minEndDate}} ng-change=createVisibilityVm.startDateChange()> </md-datepicker> <div class=control-label ng-messages=createVisibility.endDate.$error ng-show=createVisibilityVm.showErrorMessages(createVisibility.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-10 p-t\"> <div class=\"col-md-10 text-left\"> <md-button class=\"btn btn-fw btn-cancel no-margin text-left\" ng-click=createVisibilityVm.close()>Cancelar</md-button> </div> <div class=col-md-2> <md-button class=\"btn btn-fw btn-success left\" ng-click=createVisibilityVm.addVisibility(true) ng-disabled=\"createVisibilityVm.isSaveButtonDisabled || createVisibilityVm.validateForm(createVisibility)\"> Guardar</md-button> </div> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createCounselingAndConsultancyVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-azul text-center\">Crear consultor&iacute;a y asesor&iacute;a</h3> <p class=text-xs>Ingrese los datos del siguiente formulario y luego haga clic en el bot&oacute;n \"Guardar consultor&iacute;a y asesor&iacute;a\". Todos los campos son obligatorios.</p> </div> </div> <form name=createCounselingAndConsultancy novalidate> <div class=\"row blanco\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=col-md-12> <div class=\"row no-padding\"> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=\"col-md-12 no-padding\"> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.nameCounselingConsultancy)> <label for=nameCounselingConsultancy class=control-label>Nombre de la asesoría/servicio *</label> <input type=text name=nameCounselingConsultancy ng-model=createCounselingAndConsultancyVm.nameCounselingConsultancy ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=control-label ng-messages=createCounselingAndConsultancy.nameCounselingConsultancy.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.nameCounselingConsultancy)> <div ng-message=required class=text-xs>El nombre de la asesoría/servicio es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.basicAreaOfKnowledgeType)> <label for=basicAreaOfKnowledgeType class=control-label>Área básica del conocimiento</label> <select name=basicAreaOfKnowledgeType ng-model=createCounselingAndConsultancyVm.basicAreaOfKnowledgeType ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.listsTypeBasicAreaOfKnowledge\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.basicAreaOfKnowledgeType.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.basicAreaOfKnowledgeType)> <div ng-message=required class=text-xs>El área básica del conocimiento es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.companyEntityOrganization)> <label for=companyEntityOrganization class=control-label>Empresa/Entidad/Organizaci&oacute;n *</label> <input type=text name=companyEntityOrganization class=form-control ng-model=createCounselingAndConsultancyVm.companyEntityOrganization ng-model-options=\"{ debounce: 300 }\" required> <div class=control-label ng-messages=createCounselingAndConsultancy.companyEntityOrganization.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.companyEntityOrganization)> <div ng-message=required class=text-xs>La empresa/entidad/organizaci&oacute;n es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=col-md-12> <div class=\"row no-padding\"> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.ambitStage)> <label for=ambitStage class=control-label>Ámbito/escenario</label> <select name=ambitStage ng-model=createCounselingAndConsultancyVm.ambitStage ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.listsTypeAmbitStage\" class=form-control> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.ambitStage.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.ambitStage)> <div ng-message=required class=text-xs>El ámbito/escenario es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.sector)> <label for=sector class=control-label>Sector *</label> <select name=sector ng-model=createCounselingAndConsultancyVm.sector ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.sectorType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.sector.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.sector)> <div ng-message=required class=text-xs>El sector es requerido.</div> </div> </div> </div> <div class=\"col-md-4 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.rol)> <label for=rol class=control-label>Rol *</label> <select name=rol ng-model=createCounselingAndConsultancyVm.rol ng-options=\"source.idListItem as source.listItemName for source in createCounselingAndConsultancyVm.rolType\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=control-label ng-messages=createCounselingAndConsultancy.rol.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.rol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div class=col-md-12> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.description)> <label for=description class=control-label>Descripci&oacute;n *</label> <md-input-container class=\"control-label no-margin\"> <textarea name=description ng-model=createCounselingAndConsultancyVm.description rows=2 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createCounselingAndConsultancy.description.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.description)> <div ng-message=required class=text-xs>La descripci&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.productsDeliverables)> <label for=productsDeliverables class=control-label>Productos/Entregables *</label> <md-input-container class=\"control-label no-margin\"> <textarea name=productsDeliverables ng-model=createCounselingAndConsultancyVm.productsDeliverables rows=2 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-9 no-padding\"> <div class=\"col-md-6 no-padding\"> <div class=control-label ng-messages=createCounselingAndConsultancy.productsDeliverables.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.productsDeliverables)> <div ng-message=required class=text-xs>Los productos / entregables son requeridos.</div> </div> </div> <div class=\"col-md-6 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> <div class=col-md-12> <div class=\"col-md-6 no-padding-r text-left\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.source)> <label for=source class=control-label>Fuente</label> <input type=text name=source ng-model=createCounselingAndConsultancyVm.source ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=\"control-label text-left\" ng-messages=createCounselingAndConsultancy.source.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.source)> <div ng-message=required class=text-xs>La fuente es requerida.</div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> </div> <div class=col-md-12> <div class=\"col-md-5 no-padding-r text-left\"> <label for=planificationType class=control-label>Seleccione la forma en que se realizará la Ejecución *</label> <div class=col-md-5> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createCounselingAndConsultancyVm.rangeType value=1 ng-change=createCounselingAndConsultancyVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-7> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createCounselingAndConsultancyVm.rangeType value=2 ng-change=createCounselingAndConsultancyVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=\"col-md-7 no-padding\"> <div class=\"col-md-12 no-padding\" ng-if=\"createCounselingAndConsultancyVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md no-padding text-left\"> <label class=m-r-sm ng-repeat=\"period in createCounselingAndConsultancyVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm\" type=checkbox ng-model=createCounselingAndConsultancyVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createCounselingAndConsultancyVm.funSelectedPeriod(period, createCounselingAndConsultancyVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createCounselingAndConsultancyVm.isTouchedPeriods && createCounselingAndConsultancyVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> </div> <div class=col-md-12 ng-if=\"createCounselingAndConsultancyVm.rangeType == 2\"> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha Inicio</label> <md-datepicker ng-model=createCounselingAndConsultancyVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createCounselingAndConsultancyVm.startDateChange() md-min-date=createCounselingAndConsultancyVm.minStartDate md-max-date=createCounselingAndConsultancyVm.endDate min=\"{{createCounselingAndConsultancyVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=createCounselingAndConsultancy.startDate.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createCounselingAndConsultancyVm.hasError(createCounselingAndConsultancy.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha Fin</label> <md-datepicker ng-model=createCounselingAndConsultancyVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createCounselingAndConsultancyVm.minEndDate min={{createCounselingAndConsultancyVm.minEndDate}} ng-change=createCounselingAndConsultancyVm.startDateChange()> </md-datepicker> <div class=control-label ng-messages=createCounselingAndConsultancy.endDate.$error ng-show=createCounselingAndConsultancyVm.showErrorMessages(createCounselingAndConsultancy.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel\" ng-click=createCounselingAndConsultancyVm.close()>Cancelar</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success left\" ng-click=createCounselingAndConsultancyVm.addCounselingAndConsultancy(true) ng-disabled=\"createCounselingAndConsultancyVm.isSaveButtonDisabled || createCounselingAndConsultancyVm.validateForm(createCounselingAndConsultancy)\"> Guardar</md-button> </div> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=60> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=createShortCourseVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-azul text-center\">Crear educaci&oacute;n continuada</h3> <p class=text-xs>Ingrese los datos del siguiente formulario y luego haga clic en el bot&oacute;n \"Guardar educaci&oacute;n continuada\". Todos los campos son obligatorios.</p> </div> </div> <form name=createShortCourse novalidate> <div class=\"row blanco\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Datos generales</h5> </div> <div class=\"col-md-12 no-padding\"> <div class=\"row no-padding\"> <div class=\"col-md-6 no-padding-r\"> <div class=\"form-group text-left\" ng-class=createShortCourseVm.hasError(createShortCourse.courseName)> <label for=courseName class=control-label>Nombre</label> <input type=text name=courseName ng-model=createShortCourseVm.name ng-model-options=\"{ debounce: 300 }\" class=form-control required> <div class=\"control-label text-left\" ng-messages=createShortCourse.courseName.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseName)> <div ng-message=required class=text-xs>El nombre es requerido.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=\"form-group text-left\" ng-class=createShortCourseVm.hasError(createShortCourse.courseType)> <label for=courseType class=control-label>Tipo de curso</label> <select name=courseType ng-model=createShortCourseVm.type ng-options=\"source.idListItem as source.listItemName for source in createShortCourseVm.listsTypeCourse\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-left\" ng-messages=createShortCourse.courseType.$error ng-show=createShortCourse.showErrorMessages(createShortCourse.courseType)> <div ng-message=required class=text-xs>El tipo de curso es requerido.</div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-6 no-padding-r\"> <div class=\"form-group text-left\" ng-class=createShortCourseVm.hasError(createShortCourse.courseModality)> <label for=courseModality class=control-label>Modalidad del curso</label> <select name=courseModality ng-model=createShortCourseVm.modality ng-options=\"source.idListItem as source.listItemName for source in createShortCourseVm.listModalities\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-left\" ng-messages=createShortCourse.courseModality.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseModality)> <div ng-message=required class=text-xs>La modalidad es requerido.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=\"form-group text-left\" ng-class=createShortCourseVm.hasError(createShortCourse.courseRol)> <label for=courseRol class=control-label>Rol</label> <select name=courseRol ng-model=createShortCourseVm.rol ng-options=\"source.idListItem as source.listItemName for source in createShortCourseVm.listRoles\" class=form-control required> <option value=\"\" disabled=disabled>Seleccione</option> </select> <div class=\"control-label text-left\" ng-messages=createShortCourse.courseRol.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseRol)> <div ng-message=required class=text-xs>El rol es requerido.</div> </div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-12 no-padding\"> <div class=col-md-12> <div class=\"col-md-12 no-padding\"> <div class=\"form-group text-left\" ng-class=createShortCourseVm.hasError(createShortCourse.courseDescription)> <label for=courseDescription class=control-label>Objetivo/Descripci&oacute;n</label> <md-input-container class=\"control-label no-margin\"> <textarea name=courseDescription ng-model=createShortCourseVm.description rows=2 class=form-control required maxlength=500 md-maxlength=500 ng-model-options=\"{ debounce: 300 }\"></textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-9 no-padding\"> <div class=\"control-label text-left\" ng-messages=createShortCourse.courseDescription.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.courseDescription)> <div ng-message=required class=text-xs>La descrici&oacute;n es requerida.</div> </div> </div> <div class=\"col-md-3 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> </div> </div> <div class=\"row no-padding\"> <div class=\"col-md-12 text-left\"> <h5 class=\"text-azul p-v-xs font-bold no-m-b\">Planeaci&oacute;n de tiempo de dedicaci&oacute;n</h5> <h6 class=\"text-negro p-v-xs\">Seleccione la forma en que se realizará la Ejecución *</h6> </div> <div class=col-md-12> <div class=\"col-md-5 no-padding-r\"> <div class=col-md-5> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createShortCourseVm.rangeType value=1 ng-change=createShortCourseVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Período</label> </div> </div> <div class=col-md-7> <div class=\"radio-options no-margin\"> <input type=radio name=planificationType ng-model=createShortCourseVm.rangeType value=2 ng-change=createShortCourseVm.cleanRangeType()> <i class=radio-green></i> <label class=text-xs>Rango de fecha</label> </div> </div> </div> <div class=\"col-md-7 no-padding-r\"> <div class=col-md-12 ng-if=\"createShortCourseVm.rangeType == 1\"> <div class=\"col-md-12 m-t-md\"> <label class=m-r-sm ng-repeat=\"period in createShortCourseVm.typePeriod\"> <md-checkbox class=\"md-green m-r-sm text-xs\" type=checkbox ng-model=createShortCourseVm.selectedTypePeriod[period.periodId] ng-value=period.periodId name=period ng-change=\"createShortCourseVm.funSelectedPeriod(period, createShortCourseVm.selectedTypePeriod[period.periodId])\"> {{period.periodName}} </md-checkbox> </label> <div class=\"col-md-12 has-error\"> <label class=\"control-label text-xs\" ng-show=\"createShortCourseVm.isTouchedPeriods && createShortCourseVm.validateCheklistPeriods()\"> Seleccione al menos 1 período. </label> </div> </div> </div> <div class=col-md-12 ng-if=\"createShortCourseVm.rangeType == 2\"> <div class=\"col-md-6 no-padding\"> <div class=form-group ng-class=createShortCourseVm.hasError(createShortCourse.startDate)> <label for=startDate class=\"control-label col-md-12\">Fecha Inicio</label> <md-datepicker ng-model=createShortCourseVm.startDate name=startDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required ng-change=createShortCourseVm.startDateChange() md-min-date=createShortCourseVm.minStartDate md-max-date=createShortCourseVm.endDate min=\"{{createShortCourseVm.minStartDate | date: 'dd/MM/yyyy' }}\"> </md-datepicker> <div class=control-label ng-messages=createShortCourse.startDate.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.startDate)> <div ng-message=required class=text-xs>La fecha de inicio es requerida.</div> </div> </div> </div> <div class=\"col-md-6 no-padding-r\"> <div class=form-group ng-class=createShortCourseVm.hasError(createShortCourse.endDate)> <label for=endDate class=\"control-label col-md-12\">Fecha Fin</label> <md-datepicker ng-model=createShortCourseVm.endDate name=endDate md-open-on-focus onkeydown=return!1 md-placeholder=dd/mm/aaaa required md-min-date=createShortCourseVm.minEndDate min={{createShortCourseVm.minEndDate}} ng-change=createShortCourseVm.startDateChange()> </md-datepicker> <div class=control-label ng-messages=createShortCourse.endDate.$error ng-show=createShortCourseVm.showErrorMessages(createShortCourse.endDate)> <div ng-message=required class=text-xs>La fecha de fin es requerida.</div> </div> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-12 p-t\"> <div class=col-md-6> <md-button class=\"btn btn-fw btn-cancel\" ng-click=createShortCourseVm.close()>Cancelar</md-button> </div> <div class=col-md-6> <md-button class=\"btn btn-fw btn-success left\" ng-click=createShortCourseVm.addShortCourse(true) ng-disabled=\"createShortCourseVm.isSaveButtonDisabled || createShortCourseVm.validateForm(createShortCourse)\"> Guardar</md-button> </div> </div> </div> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanIndicatorSrv = function WorkPlanIndicatorSrv() {
	  _classCallCheck(this, WorkPlanIndicatorSrv);
	
	  var reloadIndicators = [];
	
	  function setVariable(variable) {
	    reloadIndicators.pop();
	    reloadIndicators.push(variable);
	    notifyAll();
	  }
	
	  function getVariable() {
	    return reloadIndicators;
	  }
	
	  var notifyAll = function notifyAll() {
	    reloadIndicators.reload();
	  };
	
	  return {
	    setVariable: setVariable,
	    getVariable: getVariable
	  };
	};
	
	WorkPlanIndicatorSrv.$inject = [];
	
	exports.default = angular.module('services.WorkPlanIndicatorSrv', []).service('WorkPlanIndicatorSrv', WorkPlanIndicatorSrv).name;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActivitiesListCtrl = function () {
		function ActivitiesListCtrl($scope, WorkPlanSrv, $mdDialog, WorkPlanIndicatorSrv, WorkPlanModalSrv, $cookies, GlobalConfig, Requests, $sessionStorage) {
			_classCallCheck(this, ActivitiesListCtrl);
	
			this.currentUser = JSON.parse($cookies.get('currentUser'));
			this.activities = [];
			this.active = GlobalConfig.generals.active;
			this.planningFinish = true;
			this.$scope = $scope;
			this.$scope.classPlanning = '';
			this.inReview = 0;
			this.feedback = 0;
			this.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
			this.$sessionStorage = $sessionStorage;
			this.WorkPlanSrv = WorkPlanSrv;
			this.WorkPlanIndicatorSrv = WorkPlanIndicatorSrv;
			this.WorkPlanModalSrv = WorkPlanModalSrv;
			this.GlobalConfig = GlobalConfig;
			this.$mdDialog = $mdDialog;
			this.activate();
		}
	
		_createClass(ActivitiesListCtrl, [{
			key: 'activate',
			value: function activate() {
				var _this = this;
	
				var post = {
					teacherId: this.currentUser.teacherId,
					workplanId: this.currentUser.workplanId
				};
	
				if (this.workPlanGeneralList != undefined) {
					this.status = this.workPlanGeneralList.wokplanTeacherStatus[0];
					this.stages = this.workPlanGeneralList.stages;
					this.inReview = this.status.reviewed;
					this.feedback = this.status.feedbackReviewed;
					this.workplanTeacherId = this.status.workplanTeacherId;
					this.isPlanning(this.status, this.stages);
	
					if (this.feedback && !this.planningFinish) {
						this.getOtherActivitiesReject(post);
					} else {
						this.getActivities();
					}
				} else {
					this.getGeneralsWorkplan(post).then(function (promise) {
						if (_this.feedback && !_this.planningFinish) {
							_this.getOtherActivitiesReject(post);
						} else {
							_this.getActivities();
						}
					});
				}
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this2 = this;
	
				var post = {
					idTeacher: this.currentUser.teacherId,
					idWorkPlan: this.currentUser.workplanId
				};
	
				this.WorkPlanSrv.getActivities.getList(post).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this2.activities = dataReturn.data;
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'getOtherActivitiesReject',
			value: function getOtherActivitiesReject(post) {
				var _this3 = this;
	
				this.WorkPlanSrv.getOtherActivitiesReject.getList(post).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						// console.log("dataReturn-->", dataReturn)
						_this3.activities = dataReturn.data;
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'getGeneralsWorkplan',
			value: function getGeneralsWorkplan(post) {
				var _this4 = this;
	
				return this.WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this4.$sessionStorage.workPlanGeneralList = dataReturn.data;
						_this4.status = dataReturn.data.wokplanTeacherStatus[0];
						_this4.stages = dataReturn.data.stages;
						_this4.inReview = _this4.status.reviewed;
						_this4.feedback = _this4.status.feedbackReviewed;
						_this4.workplanTeacherId = _this4.status.workplanTeacherId;
						_this4.isPlanning(_this4.status, _this4.stages);
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'isPlanning',
			value: function isPlanning(status, stages) {
				this.currentDate = moment(new Date()).format('YYYY-MM-DD');
				for (var i = stages.length - 1; i >= 0; i--) {
					if (stages[i].stageId == this.GlobalConfig.workplanIdStages.review) {
						this.startDateStage = stages[i].startDate;
					}
				}
	
				if (status.workplanActive) {
					if (status.planningFinish == this.active) {
						this.planningFinish = true;
	
						if (this.startDateStage < this.currentDate || status.reviewedFinish == this.active) {
							this.planningFinish = true;
						} else if (status.reviewedReject == this.active) {
							this.planningFinish = false;
						}
					} else {
						this.planningFinish = false;
					}
				} else {
					this.planningFinish = true;
				}
	
				this.$scope.classPlanning = this.planningFinish ? 'disabled' : ' ';
			}
		}, {
			key: 'confirmDisableActivity',
			value: function confirmDisableActivity(row) {
				var _this5 = this;
	
				var activityArray = this.activities.indexOf(row);
				var activityCode = row.otherActivityCode;
				var deleteActivityName = row.otherActivityName;
	
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
						this.close = function (value) {
							$mdDialog.hide(value);
						};
					}],
					controllerAs: 'ctrlModalVM',
					template: __webpack_require__(729),
					clickOutsideToClose: false
				}).then(function (dataReturn) {
					if (dataReturn) {
						_this5.WorkPlanSrv.deleteActivityItem.delete({ otherActivityCode: activityCode }).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								// se hace set de variable para actualizar los indicadores
								// se comunica con el controlador de Indicadores
								_this5.WorkPlanIndicatorSrv.setVariable(true);
								_this5.activities.splice(activityArray, 1);
								_this5.showModalDeleteSuccess(deleteActivityName);
							} else {
								console.log('Comunications problem with the server');
							}
						}, function (data) {
							console.log(data);
						});
					}
				});
			}
		}, {
			key: 'showModalDeleteSuccess',
			value: function showModalDeleteSuccess(deleteActivityName) {
				var texts = this.GlobalConfig.appTexts;
				var header = {
					createOrEdit: texts.deleteDialog,
					textCreateOrEdit: texts.deleted,
					itemName: deleteActivityName,
					nameModal: texts.modalTypeName.deleted,
					modalType: texts.modalTypeId.default
				};
	
				this.WorkPlanModalSrv.setVariableSuccessDialog(header);
				this.WorkPlanModalSrv.successDialog(header).then(function (promise) {});
			}
		}, {
			key: 'toggleSubcategories',
			value: function toggleSubcategories(assignature) {
				if (assignature.showChilds) {
					assignature.showChilds = false;
				} else {
					assignature.showChilds = true;
				}
			}
		}, {
			key: 'bitacora',
			value: function bitacora(ev) {
				var entries = {};
	
				entries.params = {
					activityTypeId: this.GlobalConfig.activityTypeId.activities,
					workplanTeacherId: this.workplanTeacherId
				};
				entries.title = 'Otras actividades de docencia';
				// Entries(this.entries);
				entries.data = undefined;
				$mdDialog.show({
					controller: 'bitacoraModalCtrl',
					controllerAs: 'bit',
					template: __webpack_require__(453),
					parent: angular.element(document.body),
					targetEvent: ev,
					locals: { data: entries },
					clickOutsideToClose: true,
					fullscreen: true
				});
			}
		}]);
	
		return ActivitiesListCtrl;
	}();
	
	exports.default = ActivitiesListCtrl;
	
	
	ActivitiesListCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', 'WorkPlanIndicatorSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la actividad \"{{ctrlModalVM.delActivityName}}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close(false)>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.close(true)>Sí, eliminar actividad</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: SubjectsListCtrl
	* # alias: subjectsListVm
	*/
	
	var SubjectsListCtrl = function () {
	  function SubjectsListCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, GlobalConfig, $stateParams, Validations, $state, Requests, $rootScope, $sessionStorage) {
	    _classCallCheck(this, SubjectsListCtrl);
	
	    this.luser = JSON.parse($cookies.get('currentUser'));
	    this.subjects = [];
	    this.totalAsignature = [];
	    this.viewLoaded = false;
	    this.itemList = [];
	    this.itemListOtherAct = [];
	    this.itemListOtherActAM = [];
	    this.active = GlobalConfig.generals.active;
	    this.notActive = GlobalConfig.generals.notActive;
	    this.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory;
	    this.imgEmpty = __webpack_require__(445);
	    this.planningFinish = true;
	    this.inReview = 0;
	    this.feedback = 0;
	    this.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	    this.$sessionStorage = $sessionStorage;
	    this.Requests = Requests;
	    this.GlobalConfig = GlobalConfig;
	    this.WorkPlanSrv = WorkPlanSrv;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.$mdDialog = $mdDialog;
	
	    this.$scope.breakpoints = [{
	      breakpoint: 3500,
	      settings: {
	        slidesToShow: 4,
	        slidesToScroll: 4
	      }
	    }, {
	      breakpoint: 1850,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 3
	      }
	    }, {
	      breakpoint: 1150,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    }, {
	      breakpoint: 760,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }];
	
	    this.activate();
	  }
	
	  _createClass(SubjectsListCtrl, [{
	    key: 'activate',
	    value: function activate() {
	      var _this = this;
	
	      var post = {
	        teacherId: this.luser.teacherId,
	        workplanId: this.luser.workplanId
	      };
	
	      if (this.workPlanGeneralList != undefined) {
	        this.status = this.workPlanGeneralList.wokplanTeacherStatus[0];
	        this.stages = this.workPlanGeneralList.stages;
	        this.inReview = this.status.reviewed;
	        this.feedback = this.status.feedbackReviewed;
	        this.isPlanning(this.status, this.stages);
	
	        this.Requests.getItemsRequiredList(this.WorkPlanSrv, post).then(function (data) {
	          _this.itemList = data.itemList;
	          _this.itemListOtherAct = data.itemListOtherAct;
	          _this.itemListOtherActAM = data.itemListOtherActAM;
	          _this.workplanTeacherId = _this.status.workplanTeacherId;
	          if (_this.feedback && !_this.planningFinish) {
	            _this.getAsignaturesAssignedReviewedReject(post);
	          } else _this.getAsignaturesAssigned(post);
	        });
	      } else {
	        this.getGeneralsWorkplan(post).then(function (promise) {
	          _this.Requests.getItemsRequiredList(_this.WorkPlanSrv, post).then(function (data) {
	            _this.itemList = data.itemList;
	            _this.itemListOtherAct = data.itemListOtherAct;
	            _this.itemListOtherActAM = data.itemListOtherActAM;
	            _this.workplanTeacherId = _this.status.workplanTeacherId;
	            if (_this.feedback && !_this.planningFinish) {
	              _this.getAsignaturesAssignedReviewedReject(post);
	            } else _this.getAsignaturesAssigned(post);
	          });
	        });
	      }
	    }
	  }, {
	    key: 'updateView',
	    value: function updateView() {
	      var _this2 = this;
	
	      this.viewLoaded = false;
	      this.$timeout(function () {
	        _this2.viewLoaded = true;
	      }, 1000);
	    }
	  }, {
	    key: 'getAsignaturesAssigned',
	    value: function getAsignaturesAssigned(header) {
	      var _this3 = this;
	
	      return this.WorkPlanSrv.getAsignaturesAssigned.getList(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          _this3.loadData(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	  }, {
	    key: 'getAsignaturesAssignedReviewedReject',
	    value: function getAsignaturesAssignedReviewedReject(header) {
	      var _this4 = this;
	
	      return this.WorkPlanSrv.getAsignaturesAssignedReviewedReject.getList(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          //console.log("dataReturn--->", dataReturn)
	          _this4.loadData(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	  }, {
	    key: 'getGeneralsWorkplan',
	    value: function getGeneralsWorkplan(post) {
	      var _this5 = this;
	
	      return this.WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          //console.log(dataReturn.data)
	          _this5.$sessionStorage.workPlanGeneralList = dataReturn.data;
	          _this5.status = dataReturn.data.wokplanTeacherStatus[0];
	          _this5.stages = dataReturn.data.stages;
	          _this5.inReview = _this5.status.reviewed;
	          _this5.feedback = _this5.status.feedbackReviewed;
	          _this5.isPlanning(_this5.status, _this5.stages);
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	  }, {
	    key: 'isPlanning',
	    value: function isPlanning(status, stages) {
	      this.currentDate = moment(new Date()).format("DD/MM/YYYY");
	      for (var i = stages.length - 1; i >= 0; i--) {
	        if (stages[i].stageId == this.GlobalConfig.workplanIdStages.review) {
	          this.startDateStage = stages[i].startDate;
	        }
	      }
	
	      if (status.planningFinish == this.active) {
	        this.planningFinish = true;
	        if (this.startDateReview < this.currentDate || status.reviewedFinish == this.active) {
	          this.planningFinish = true;
	        } else if (status.reviewedReject == this.active) {
	          this.planningFinish = false;
	        }
	      } else {
	        this.planningFinish = false;
	      }
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(data) {
	      this.subjectsData = data;
	      this.subjects = this.subjectsData.map(function (subject) {
	        if (subject.periodicityName) {
	          subject.periodicityNameArray = subject.periodicityName.split(',');
	        }
	        if (subject.hoursPlanned > 0) {
	          subject.asignatureHours = subject.hoursPlanned;
	        } else {
	          subject.asignatureHours = 0;
	        }
	        subject.checkPlanningProcess = false;
	        return subject;
	      });
	      this.getTotalAssignatures();
	      this.updateView();
	    }
	  }, {
	    key: 'backgroundGrad',
	    value: function backgroundGrad(index) {
	      var result = 'grad-oblique-';
	
	      switch (index % 4) {
	        case 0:
	          return result + 'negro-dark';
	        case 1:
	          return result + 'azul';
	        case 2:
	          return result + 'teal';
	        case 3:
	          return result + 'deep-orange';
	        default:
	          return result + 'negro-dark';
	      }
	    }
	  }, {
	    key: 'updateView',
	    value: function updateView() {
	      var _this6 = this;
	
	      this.viewLoaded = false;
	      this.$timeout(function () {
	        _this6.viewLoaded = true;
	      }, 1);
	    }
	  }, {
	    key: 'getItemListByAssignature',
	    value: function getItemListByAssignature(subject) {
	      var color = '';
	
	      if (subject.isForPlanning === 0) color = 'gris-darker';
	
	      if (subject.asignatureHours > 0 && subject.totalHoursPlanned == 0) color = 'gris-darker';
	
	      if (subject.totalHoursPlanned > 0 && subject.isForPlanning === 1) color = 'verde';
	
	      if (subject.totalHoursPlanned === 0 && subject.isForPlanning === 1) color = 'amarillo';
	
	      if (subject.isForPlanning === 1) {
	        console.log();
	        for (var i in this.itemList) {
	          console.log();
	          if (this.itemList[i].assignatureId === subject.asignatureId) {
	            console.log();
	            if (this.itemList[i].itemList.length > 0) {
	              color = 'amarillo';
	              break;
	            }
	          }
	        }
	      }
	      return color;
	    }
	  }, {
	    key: 'getTotalAssignatures',
	    value: function getTotalAssignatures() {
	      this.totalAsignature = this.subjects.filter(function (subjets) {
	        return subjets.isForPlanning === 1;
	      });
	
	      this.$rootScope.totalAsignatures = this.totalAsignature.length;
	    }
	  }, {
	    key: 'updateIsPlanning',
	    value: function updateIsPlanning(assignature) {
	      var _this7 = this;
	
	      assignature.checkPlanningProcess = true;
	      var params = {
	        teacherId: this.luser.teacherId,
	        assignatureId: assignature.asignatureId,
	        isPlanning: assignature.isForPlanning
	      };
	      this.WorkPlanSrv.updateAssignatureWorkPlan.post(params).$promise.then(function () {
	        _this7.getTotalAssignatures();
	        assignature.checkPlanningProcess = false;
	        return;
	      });
	      return;
	    }
	  }, {
	    key: 'bitacora',
	    value: function bitacora(ev) {
	      var entries = {};
	
	      entries.params = {
	        activityTypeId: this.GlobalConfig.activityTypeId.subject,
	        workplanTeacherId: this.workplanTeacherId
	      };
	      entries.title = 'Asignaturas';
	      // Entries(this.entries);
	      entries.data = undefined;
	      this.$mdDialog.show({
	        controller: 'bitacoraModalCtrl',
	        controllerAs: 'bit',
	        template: __webpack_require__(453),
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        locals: { data: entries },
	        clickOutsideToClose: true,
	        fullscreen: true
	      });
	    }
	  }]);
	
	  return SubjectsListCtrl;
	}();
	
	exports.default = SubjectsListCtrl;
	
	
	SubjectsListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', 'GlobalConfig', '$stateParams', 'Validations', '$state', 'Requests', '$rootScope', '$sessionStorage'];

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateActivityCtrl = function CreateActivityCtrl($scope, WorkPlanSrv, $mdDialog, $stateParams, $cookies, GlobalConfig, GlobalSrv) {
	  _classCallCheck(this, CreateActivityCtrl);
	
	  var createActivityVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  createActivityVm.nameActivityModal = "";
	  createActivityVm.hrefActivityModal = "Añadir ";
	  createActivityVm.editOrCreated = "Creación exitosa";
	  createActivityVm.createOrEdit = "Añadir";
	  createActivityVm.idWorkPlan = currentUser.workplanId;
	  createActivityVm.idTeacher = currentUser.teacherId;
	  createActivityVm.comboActivities = [];
	  createActivityVm.activityItem = [];
	  createActivityVm.itemActivityRequired = [];
	  createActivityVm.cleanForm = cleanForm;
	  createActivityVm.cleanRangeType = cleanRangeType;
	  createActivityVm.isEditing = $stateParams.activityId ? true : false;
	  createActivityVm.close = close;
	  createActivityVm.hours = 0;
	  createActivityVm.isSaveButtonDisabled = false;
	  createActivityVm.isFeedback = currentUser.isFeedback;
	  createActivityVm.hasError = function (input) {
	    if (input && input.$invalid && (input.$dirty || input.$touched)) {
	      return 'has-error';
	    }
	  };
	
	  createActivityVm.showErrorMessages = function (input) {
	    return input.$dirty || input.$touched;
	  };
	
	  createActivityVm.validateForm = function (form) {
	    return form.$invalid;
	  };
	
	  activate();
	
	  function activate() {
	    if (createActivityVm.isEditing) {
	      createActivityVm.createOrEdit = "Editar ";
	      createActivityVm.editOrCreated = "Edición exitosa";
	    }
	
	    // Combo type of activity
	    var requestHeader = {
	      listTypeId: GlobalConfig.typeListId.teaching,
	      listId: GlobalConfig.listId.teachingOtherActivities
	    };
	    WorkPlanSrv.getActivitiesCombo.getList(requestHeader).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        createActivityVm.comboActivities = dataReturn.data;
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	
	    if (createActivityVm.isEditing) {
	      return editActivitySrv().then(function () {});
	    }
	  }
	
	  function isAllActivityItemRequired() {
	    var header = {
	      teacherId: currentUser.teacherId,
	      workplanId: currentUser.workplanId,
	      listId: GlobalConfig.listId.teachingOtherActivities
	    };
	
	    WorkPlanSrv.getItemRequiredOtherActivities.getList(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        createActivityVm.itemActivityRequired = dataReturn.otherActivities;
	        if (createActivityVm.itemActivityRequired.length > 0) showModalItemRequired();
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function showModalItemRequired() {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.itemRequired = createActivityVm.itemActivityRequired;
	        $scope.activityModal = createActivityVm.hrefActivityModal;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(732),
	      clickOutsideToClose: false
	    });
	  }
	
	  createActivityVm.addActivity = function (sw, isExecution) {
	    createActivityVm.isSaveButtonDisabled = true;
	    createActivityVm.hrefActivityModal = sw;
	    var origin = 1;
	    if (isExecution) {
	      origin = GlobalConfig.activityTypeId.originActivityExecution;
	    }
	    createJson(origin);
	  };
	
	  function createJson(origin) {
	    var assignment = {
	      otherActivityCode: $stateParams.activityId,
	      idTeacher: createActivityVm.idTeacher,
	      idWorkPlan: createActivityVm.idWorkPlan,
	      activityTypeCode: createActivityVm.typeActivity,
	      otherActivityHoursPlaned: createActivityVm.hours,
	      otherActivityName: createActivityVm.nameActivity,
	      otherActivityDetail: createActivityVm.detail,
	      origin: origin,
	      isFeedbackActivity: createActivityVm.isFeedback
	    };
	
	    if (createActivityVm.isEditing) {
	      // add activity
	      WorkPlanSrv.updateActivityItem.update(assignment).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createActivityModal();
	        } else {
	          createActivityVm.isSaveButtonDisabled = false;
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        createActivityVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    } else {
	      // add activity
	      WorkPlanSrv.addActivityItem.add(assignment).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createActivityModal();
	        } else {
	          createActivityVm.isSaveButtonDisabled = false;
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        createActivityVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	  }
	
	  function cleanForm(form) {
	    createActivityVm.nameActivityModal = createActivityVm.nameActivity;
	    createActivityVm.typeActivity = 0;
	    createActivityVm.hours = 0;
	    createActivityVm.nameActivity = undefined;
	    createActivityVm.detail = undefined;
	    form.$setPristine();
	    form.$setUntouched();
	  }
	
	  function createActivityModal() {
	    var texts = GlobalConfig.appTexts;
	    var activityName = createActivityVm.nameActivityModal;
	    var hrefActivity = createActivityVm.hrefActivityModal;
	    var actionEditOrCreate = texts.saved;
	    var sucsessAction = texts.createDialog;
	    if (createActivityVm.isEditing) {
	      actionEditOrCreate = texts.modified;
	      sucsessAction = texts.editDialog;
	    }
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', '$state', function ($scope, $mdDialog, $state) {
	        var ctrlModal = this;
	        ctrlModal.sucsessAction = sucsessAction;
	        ctrlModal.activityModal = hrefActivity;
	        ctrlModal.actionEditOrCreateModal = actionEditOrCreate;
	        ctrlModal.nameActivityModal = activityName;
	        ctrlModal.close = function () {
	          isAllActivityItemRequired();
	          $mdDialog.hide();
	          $state.reload();
	        };
	      }],
	      controllerAs: 'ctrlModal',
	      template: __webpack_require__(733),
	      clickOutsideToClose: false
	    });
	  }
	
	  function editActivity() {
	    createActivityVm.typeActivity = createActivityVm.activityItem[0].activityTypeCode;
	    createActivityVm.hours = createActivityVm.activityItem[0].otherActivityHoursPlaned;
	    createActivityVm.nameActivity = createActivityVm.activityItem[0].otherActivityName;
	    createActivityVm.detail = createActivityVm.activityItem[0].otherActivityDetail;
	  }
	
	  function editActivitySrv() {
	    // Activity Item
	    return WorkPlanSrv.getActivityItem.get({ otherActivityCode: $stateParams.activityId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        createActivityVm.activityItem = dataReturn.data;
	        editActivity();
	      } else {
	        createActivityVm.activityItem = [];
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function close() {
	    $mdDialog.hide();
	  }
	
	  function cleanRangeType() {
	    if (parseInt(createActivityVm.rangeType) == GlobalConfig.periods.rangeType) {
	      createActivityVm.startDate = null;
	      createActivityVm.endDate = null;
	    } else {
	      createActivityVm.periodsArray = [];
	      createActivityVm.selectedTypePeriod = null;
	    }
	  }
	
	  /*
	  var inputs = "textarea[maxlength]";
	  $(document).on('keyup', "[maxlength]", function (e) {
	      var este = $(this),
	          maxlength = este.attr('maxlength'),
	          maxlengthint = parseInt(maxlength),
	          textoActual = este.val(),
	          currentCharacters = este.val().length,
	          remainingCharacters = maxlengthint - currentCharacters,
	          espan = este.prev('div').find('span'); 
	          console.log('-----------------------')
	          console.log(textoActual)
	          console.log(maxlengthint)     
	          console.log(currentCharacters) 
	          console.log(remainingCharacters) 
	          console.log(espan)
	          // Detectamos si es IE9 y si hemos llegado al final, convertir el -1 en 0 - bug ie9 porq. no coge directamente el atributo 'maxlength' de HTML5
	          espan.html(currentCharacters);
	          if (!!maxlength) {
	              var texto = este.val(); 
	              if (texto.length >= maxlength) {
	                  este.removeClass().addClass('borderojo');
	                  este.val(texto.substring(0, maxlength));
	                  e.preventDefault();
	              }
	              else if (texto.length < maxlength) {
	                  este.removeClass().addClass("bordegris");
	              }   
	          }   
	      });
	  */
	};
	
	exports.default = CreateActivityCtrl;
	
	
	CreateActivityCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Antes de finalizar planeación debe configurar las siguientes Actividades en esta sección</p> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"itemRequired in itemRequired\" class=m-v-sm> <p class=\"text-left text-md p-l-sm\"> {{itemRequired.list_items}} </p> </li> </ul> </div> </div> <div class=\"row text-center\"> <div class=col-md-12 ng-if=activityModal> <md-button class=\"btn btn-fw btn-success\" ng-click=close() ui-sref=workplan.listActivities> Aceptar</md-button> </div> <div class=col-md-12 ng-if=!activityModal> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModal.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>{{ctrlModal.sucsessAction}}</h3> <p class=m-t-md>La actividad <span class=font-bold>\"{{ctrlModal.nameActivityModal}}\"</span> se ha {{ctrlModal.actionEditOrCreateModal}} con éxito.</p>{{ctrlModal.palabra}} </div> </div> <div class=\"row text-center\"> <div class=col-md-12 ng-if=ctrlModal.activityModal> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModal.close() ui-sref=workplan.listActivities> Aceptar</md-button> </div> <div class=col-md-12 ng-if=!ctrlModal.activityModal> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModal.close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConsultCalendarCtrl = function ConsultCalendarCtrl($scope, WorkPlanSrv, UserInfoConstant, $timeout, calendarConfig, moment, WorkPlanModalSrv, $cookies, $mdDialog, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, ConsultCalendarCtrl);
	
	  var consultCalendarVm = this;
	
	  // modals
	  consultCalendarVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  consultCalendarVm.active = GlobalConfig.generals.active;
	  consultCalendarVm.notActive = GlobalConfig.generals.notActive;
	  consultCalendarVm.planningFinish = true;
	  consultCalendarVm.inReview = 0;
	  consultCalendarVm.feedback = 0;
	  consultCalendarVm.bitacora = bitacora;
	  consultCalendarVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  consultCalendarVm.$sessionStorage = $sessionStorage;
	
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  var SEARCH_PARAMS = {
	    teacherId: currentUser.teacherId,
	    workplanId: currentUser.workplanId,
	    scheduleTypeId: 1
	  };
	
	  consultCalendarVm.calendarList = [];
	
	  var vm = this;
	  calendarConfig.displayAllMonthEvents = true;
	  moment.locale('es');
	  vm.calendarView = 'week';
	  vm.viewDate = new Date();
	  vm.showSections = false;
	  // vm.id_simulacion     = 0
	  vm.level = '';
	  vm.error = error;
	  vm.cancel = cancel;
	  vm.showCalendar = true;
	  vm.showTimes = true;
	  vm.dayViewSplit = 30;
	  vm.eventSources = [];
	  vm.$scope = $scope;
	  vm.WEEKS = [];
	  calendarConfig.dateFormatter = 'moment'; // use either moment or angular to format dates on the calendar. Default angular. Setting this will override any date formats you have already set.
	  calendarConfig.allDateFormats.moment.date.hour = 'HH:mm'; // this will configure times on the day view to display in 24 hour format rather than the default of 12 hour
	  calendarConfig.allDateFormats.moment.title.day = 'ddd D MMM'; // this will configure the day view title to be shorter
	  calendarConfig.i18nStrings.weekNumber = 'Week {week}'; // This will set the week number hover label on the month view
	  calendarConfig.displayAllMonthEvents = true; // This will display all events on a month view even if they're not in the current month. Default false.
	  calendarConfig.showTimesOnWeekView = true; // Make the week view more like the day view, with the caveat that event end times are ignored.
	  vm.headerCalendar = {
	    TIME_MODULE: 29,
	    START_MODULE: '00:00',
	    END_MODULE: '23:59'
	  };
	  var dates = {
	    'Lunes': '2017-05-01 ',
	    'Martes': '2017-05-02 ',
	    'Miércoles': '2017-05-03 ',
	    'Jueves': '2017-05-04 ',
	    'Viernes': '2017-05-05 ',
	    'Sábado': '2017-05-06 ',
	    'Domingo': '2017-05-07 '
	  };
	
	  vm.viewChangeClicked = function (date, nextView) {
	    return false;
	  };
	
	  $scope.pageChanged = function () {
	    $scope.uiConfig = {};
	  };
	
	  function error() {}
	
	  function cancel() {}
	
	  function showCalendar() {
	    vm.showCalendar = true;
	    vm.viewDate = moment('2017-05-01').toDate();
	    vm.showCalendarResults = true;
	    vm.calendarView = 'week';
	  }
	
	  function calendarStudentAttention() {
	    if (consultCalendarVm.feedback && !consultCalendarVm.planningFinish) {
	      getSchedulesReviewedReject();
	    } else {
	      getSchedules();
	    }
	  }
	
	  function getSchedules(header) {
	    WorkPlanSrv.getSchedules.getList(SEARCH_PARAMS).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        consultCalendarVm.calendarList = dataReturn.data;
	        setEvents(consultCalendarVm.calendarList);
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getSchedulesReviewedReject(header) {
	    WorkPlanSrv.getActivityCalendarReviewedRejectById.getList(SEARCH_PARAMS).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        consultCalendarVm.calendarList = dataReturn.data;
	        setEvents(consultCalendarVm.calendarList);
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function setEvents(calendarList) {
	    vm.eventSources = [];
	    for (var i in calendarList) {
	      var days = calendarList[i].daysNames.split(',');
	      for (var x in days) {
	        var event = {};
	        event.calendarEventId = x + 1;
	        event.title = calendarList[i].scheduleTypeName;
	        event.cssClass = 'bg-green-web-planner';
	        event.cssClassLetra = 'text-azul-planner';
	        event.draggable = false;
	        event.resizable = false;
	        event.startsAt = moment(dates[days[x]] + calendarList[i].startHour).toDate();
	        event.endsAt = moment(dates[days[x]] + calendarList[i].endHour).toDate();
	        event.height = getEventHeight(event.startsAt, event.endsAt);
	        vm.eventSources.push(event);
	      }
	    }
	    showCalendar();
	  }
	
	  function getEventHeight(startDate, endDate) {
	    startDate = moment(startDate);
	    endDate = moment(endDate);
	    var diff = endDate.diff(startDate, 'minutes');
	    diff = Math.round(diff / 30);
	    return 30 * diff;
	  }
	
	  activate();
	
	  function activate() {
	    var post = {
	      teacherId: currentUser.teacherId,
	      workplanId: currentUser.workplanId
	    };
	    if (consultCalendarVm.workPlanGeneralList != undefined) {
	      consultCalendarVm.status = consultCalendarVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      consultCalendarVm.stages = consultCalendarVm.workPlanGeneralList.stages;
	      consultCalendarVm.inReview = consultCalendarVm.status.reviewed;
	      consultCalendarVm.feedback = consultCalendarVm.status.feedbackReviewed;
	      consultCalendarVm.workplanTeacherId = consultCalendarVm.status.workplanTeacherId;
	      isPlanning(consultCalendarVm.status, consultCalendarVm.stages);
	
	      calendarStudentAttention();
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        calendarStudentAttention();
	      });
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        consultCalendarVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        consultCalendarVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        consultCalendarVm.stages = dataReturn.data.stages;
	        consultCalendarVm.inReview = consultCalendarVm.status.reviewed;
	        consultCalendarVm.feedback = consultCalendarVm.status.feedbackReviewed;
	        consultCalendarVm.workplanTeacherId = consultCalendarVm.status.workplanTeacherId;
	        isPlanning(consultCalendarVm.status, consultCalendarVm.stages);
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    consultCalendarVm.currentDate = moment(new Date()).format('DD/MM/YYYY');
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        consultCalendarVm.startDateStage = stages[i].startDate;
	      }
	    }
	    if (status.workplanActive) {
	      if (status.planningFinish == consultCalendarVm.active) {
	        consultCalendarVm.planningFinish = true;
	        if (consultCalendarVm.startDateReview < consultCalendarVm.currentDate || status.reviewedFinish == consultCalendarVm.active) {
	          consultCalendarVm.planningFinish = true;
	        } else if (status.reviewedReject == consultCalendarVm.active) {
	          consultCalendarVm.planningFinish = false;
	        }
	      } else {
	        consultCalendarVm.planningFinish = false;
	      }
	    } else {
	      consultCalendarVm.planningFinish = true;
	    }
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.studentAttention,
	      workplanTeacherId: consultCalendarVm.workplanTeacherId
	    };
	    entries.title = 'Atención a estudiantes';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = ConsultCalendarCtrl;
	
	
	ConsultCalendarCtrl.$inject = ['$scope', 'WorkPlanSrv', 'UserInfoConstant', '$timeout', 'calendarConfig', 'moment', 'WorkPlanModalSrv', '$cookies', '$mdDialog', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	  * @name APP u-Planning
	  * @autor over.martinez@u-planner.com
	  * @description
	  * Descripcion del controlador
	  * @controller 
	  * # name: ScheduleListCtrl
	  * # alias: schedulesListVm
	  */
	
	var ScheduleListCtrl = function () {
		function ScheduleListCtrl($scope, WorkPlanSrv, $interval, $mdDialog, $stateParams, $cookies, GlobalConfig, WorkPlanModalSrv, $sessionStorage) {
			var _this = this;
	
			_classCallCheck(this, ScheduleListCtrl);
	
			this.luser = JSON.parse($cookies.get('currentUser'));
			this.SEARCH_PARAMS = {
				teacherId: this.luser.teacherId,
				workplanId: this.luser.workplanId
				// declaracion de variables
			};this.$scope = $scope;
			this.regex = /^(([01]?[0-9]|2[0-3]):[0-5][0-9])|(([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])$/;
			this.daysArray = [];
			this.isTouchedDays = false;
			this.$sessionStorage = $sessionStorage;
			this.WorkPlanSrv = WorkPlanSrv;
			this.GlobalConfig = GlobalConfig;
			this.configScheduleTypeId = this.GlobalConfig.scheduleTypeId;
			this.WorkPlanModalSrv = WorkPlanModalSrv;
			this.$mdDialog = $mdDialog;
			this.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
			this.selectedDays = {};
			this.periodsArray = [];
			this.typePeriod = [];
			this.isTouchedPeriods = false;
			this.selectedTypePeriod = {};
			this.scheduleTypeId = this.configScheduleTypeId.presencial;
			this.scheduleRadio = 'Atención virtual';
			this.editOrCreated = 'Creación exitosa';
			this.actionEditOrCreate = 'creado';
			this.invalidMinHour = false;
			this.feedback = 0;
			this.planningFinish = true;
			this.isSaveButtonDisabled = false;
			this.hourPlanningRequired = false;
			this.mostrarObsAdicionalesOblig = true;
			// sustituir por valores que deberian estar en log de usuario
			// y JSON traido de la seccion docencia
			this.activityId = 34;
			this.gridApi = {};
			this.calendarId = null;
			this.workplanTeacherActivityId = null;
			this.startHour = null;
			this.endHour = null;
			this.description = null;
			this.editing = false;
			this.showTable = true;
			this.isFeedback = JSON.parse($cookies.get('currentUser')).isFeedback;
			this.iconClasses = ['mdi-hardware-keyboard-arrow-down', 'mdi-hardware-keyboard-arrow-up'];
			this.class = this.iconClasses[1];
			this.calendarIdForVirtualAttention = null;
			this.workplanTeacherActivityIdForVirtualAttention = null;
	
			this.gridListSchedules = {
				enableFiltering: false,
				enableVerticalScrollbar: 1,
				enableHorizontalScrollbar: 0,
				columnDefs: [{
					name: 'Período',
					displayName: 'Período',
					field: 'periodsNames',
					width: '25%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs p-b-sm'
				}, {
					name: 'Día',
					displayName: 'Día',
					field: 'daysNames',
					width: '30%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs p-b-sm'
				}, {
					name: 'Horario',
					displayName: 'Horario',
					width: '25%',
					enableGridMenu: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'text-xs',
					headerCellClass: 'font-normal text-xs p-b-sm',
					cellTemplate: __webpack_require__(736)
				}, {
					name: 'Acciones',
					displayName: 'Acciones',
					width: '20%',
					enableGridMenu: false,
					enableFiltering: false,
					enableHiding: false,
					enablePinning: false,
					enableColumnMenu: false,
					enableSorting: false,
					cellClass: 'column-center text-xs',
					headerCellClass: 'column-center font-normal text-xs p-b-sm',
					cellTemplate: __webpack_require__(737)
				}],
				onRegisterApi: function onRegisterApi(gridApi) {
					_this.gridApi = gridApi;
					$interval(function () {
						_this.gridApi.core.handleWindowResize();
					}, 200, 10);
				}
	
				/**************************************
	       * funcion inicial                   *
	       ***************************************/
			};this.activate();
		}
	
		_createClass(ScheduleListCtrl, [{
			key: 'activate',
			value: function activate() {
				var _this2 = this;
	
				this.getDaysAndPeriodsData();
	
				if (this.workPlanGeneralList != undefined) {
					this.status = this.workPlanGeneralList.wokplanTeacherStatus[0];
					this.stages = this.workPlanGeneralList.stages;
					this.feedback = this.status.feedbackReviewed;
					this.isPlanning(this.status, this.stages);
	
					if (this.feedback && !this.planningFinish) {
						this.getSchedulesRejectData();
					} else {
						this.getSchedulesData();
					}
				} else {
					this.getGeneralsWorkplan().then(function (promise) {
						if (_this2.feedback && !_this2.planningFinish) {
							_this2.getSchedulesRejectData();
						} else {
							_this2.getSchedulesData();
						}
					});
				}
			}
		}, {
			key: 'getDaysAndPeriodsData',
			value: function getDaysAndPeriodsData() {
				var _this3 = this;
	
				this.WorkPlanSrv.getDataForSchedule.get(this.SEARCH_PARAMS).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this3.typePeriod = dataReturn.periods;
						_this3.days = dataReturn.days;
					} else {}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'getGeneralsWorkplan',
			value: function getGeneralsWorkplan() {
				var _this4 = this;
	
				return this.WorkPlanSrv.getElementsRightBar.getList({ teacherId: this.SEARCH_PARAMS.teacherId }).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this4.$sessionStorage.workPlanGeneralList = dataReturn.data;
						_this4.status = dataReturn.data.wokplanTeacherStatus[0];
						_this4.stages = dataReturn.data.stages;
						_this4.feedback = _this4.status.feedbackReviewed;
						_this4.isPlanning(_this4.status, _this4.stages);
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'isPlanning',
			value: function isPlanning(status, stages) {
				this.currentDate = moment(new Date()).format('DD/MM/YYYY');
				for (var i = stages.length - 1; i >= 0; i--) {
					if (stages[i].stageId == this.GlobalConfig.workplanIdStages.review) {
						this.startDateStage = stages[i].startDate;
					}
				}
	
				if (status.workplanActive) {
					if (status.planningFinish == this.active) {
						this.planningFinish = true;
	
						if (this.startDateReview < this.currentDate || status.reviewedFinish == this.active) {
							this.planningFinish = true;
						} else if (status.reviewedReject == this.active) {
							this.planningFinish = false;
						}
					} else {
						this.planningFinish = false;
					}
				} else {
					this.planningFinish = true;
				}
			}
		}, {
			key: 'highlightFilteredHeader',
			value: function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
				if (col.filters[0].term) {
					return 'header-filtered';
				} else {
					return '';
				}
			}
		}, {
			key: 'getSchedulesData',
			value: function getSchedulesData() {
				var _this5 = this;
	
				this.WorkPlanSrv.getSchedules.getList(this.SEARCH_PARAMS).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this5.gridListSchedules.data = _this5.getPresentialInfo(dataReturn.data);
						_this5.virtualAttentionHours = _this5.getTotalVirtualAttentionInfo(dataReturn.data);
					} else {
						_this5.gridListSchedules.data = [];
						_this5.virtualAttentionHours = 0;
					}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'getSchedulesRejectData',
			value: function getSchedulesRejectData() {
				var _this6 = this;
	
				this.WorkPlanSrv.getSchedulesReject.getList(this.SEARCH_PARAMS).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this6.gridListSchedules.data = _this6.getPresentialInfo(dataReturn.data);
						_this6.virtualAttentionHours = _this6.getTotalVirtualAttentionInfo(dataReturn.data);
					} else {
						_this6.gridListSchedules.data = [];
						_this6.virtualAttentionHours = 0;
					}
				}, function (data) {
					console.log(data);
				});
			}
		}, {
			key: 'hiddenTable',
			value: function hiddenTable() {
				if (this.class === this.iconClasses[0]) {
					this.class = this.iconClasses[1];
					this.showTable = true;
				} else {
					this.class = this.iconClasses[0];
					this.showTable = false;
				}
			}
		}, {
			key: 'hasError',
			value: function hasError(input) {
				if (input && input.$invalid && (input.$dirty || input.$touched)) {
					return 'has-error';
				}
			}
		}, {
			key: 'hasErrorEndHour',
			value: function hasErrorEndHour(input) {
				if (input && input.$invalid && (input.$dirty || input.$touched) || this.invalidMinHour) {
					return 'has-error';
				}
			}
		}, {
			key: 'showErrorMessages',
			value: function showErrorMessages(input) {
				return input && (input.$dirty || input.$touched);
			}
		}, {
			key: 'validateForm',
			value: function validateForm(form, virtualForm) {
				if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
					return form.$invalid || this.validateCheklistDays() || this.validateCheklistPeriods() || this.invalidMinHour;
				} else {
					return virtualForm.$invalid;
				}
			}
		}, {
			key: 'validateHour',
			value: function validateHour(input) {
				return input.$error.pattern;
			}
		}, {
			key: 'validateCheklistDays',
			value: function validateCheklistDays() {
				return this.scheduleTypeId == this.configScheduleTypeId.presencial && this.daysArray.length < 1;
			}
		}, {
			key: 'validateHours',
			value: function validateHours(inputStart, inputEnd) {
				if (!this.validateHour(inputStart) && !this.validateHour(inputEnd) && !inputStart.$invalid && !inputEnd.$invalid) {
					var splitStart = this.startHour.split(':');
					var splitEnd = this.endHour.split(':');
	
					if (parseInt(splitStart[0]) < parseInt(splitEnd[0])) {
						this.invalidMinHour = false;
	
						return this.invalidMinHour;
					}
	
					if (parseInt(splitStart[0]) === parseInt(splitEnd[0])) {
						if (parseInt(splitStart[1]) < parseInt(splitEnd[1])) {
							this.invalidMinHour = false;
	
							return this.invalidMinHour;
						}
					}
	
					this.invalidMinHour = true;
	
					return this.invalidMinHour;
				}
			}
		}, {
			key: 'funSelectedDays',
			value: function funSelectedDays(day, checked) {
				if (checked) {
					if (!this.daysArray.includes(day.dayId)) {
						this.daysArray.push(day.dayId);
					}
				} else {
					var index = this.daysArray.indexOf(day.dayId);
	
					if (index != -1) {
						this.daysArray.splice(index, 1);
					}
				}
	
				this.isTouchedDays = true;
			}
		}, {
			key: 'validateCheklistPeriods',
			value: function validateCheklistPeriods() {
				return this.scheduleTypeId == this.configScheduleTypeId.presencial && this.periodsArray.length < 1;
			}
		}, {
			key: 'funSelectedPeriod',
			value: function funSelectedPeriod(period, checked) {
				if (checked) {
					if (!this.periodsArray.includes(period.periodId)) {
						this.periodsArray.push(period.periodId);
					}
				} else {
					var index = this.periodsArray.indexOf(period.periodId);
	
					if (index != -1) {
						this.periodsArray.splice(index, 1);
					}
				}
	
				this.isTouchedPeriods = true;
			}
		}, {
			key: 'addSchedule',
			value: function addSchedule(form, virtualForm) {
				if (this.scheduleTypeId == this.configScheduleTypeId.presencial) this.createJson(form);else this.createJson(virtualForm);
			}
		}, {
			key: 'createJson',
			value: function createJson(form) {
				this.schedule = {
					teacherId: this.SEARCH_PARAMS.teacherId,
					workplanId: this.SEARCH_PARAMS.workplanId,
					activityId: this.activityId,
					scheduleTypeId: this.scheduleTypeId,
					description: this.description,
					isFeedbackActivity: this.isFeedback
	
					//si es de tipo presencial, agregar los dias, periodos, hora de inicio/fin y descripcion
				};if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
					this.scheduleRadio = 'Atención presencial';
	
					var arrayPeriod = [];
	
					for (var index in this.periodsArray) {
						var temp = {
							periodId: this.periodsArray[index]
						};
	
						arrayPeriod.push(temp);
					}
	
					var arrayDays = [];
	
					for (var index in this.daysArray) {
						var temp = {
							dayId: this.daysArray[index]
						};
	
						arrayDays.push(temp);
					}
	
					this.schedule.days = arrayDays;
					this.schedule.periods = arrayPeriod;
					this.schedule.startHour = this.startHour;
					this.schedule.endHour = this.endHour;
				} else {
					// no es presencial, agregamos las horas
					this.schedule.hoursPlanning = this.hoursPlanning;
				}
	
				if (this.editing || this.scheduleTypeId == this.configScheduleTypeId.virtual) {
					if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
						this.schedule.workplanTeacherActivityId = this.workplanTeacherActivityId;
						this.schedule.calendarId = this.calendarId;
					} else {
						// virtual
						this.schedule.workplanTeacherActivityId = this.workplanTeacherActivityIdForVirtualAttention;
						this.schedule.calendarId = this.calendarIdForVirtualAttention;
					}
	
					this.editExistingSchedule(this.schedule, form);
					this.editOrCreated = 'Edición exitosa';
				} else {
					if (this.isValidSchedule(this.schedule)) this.addNewSchedule(this.schedule, form);else this.showModalScheduleFailure('Estas horas ya han sido seleccionadas en la semana');
				}
			}
		}, {
			key: 'addNewSchedule',
			value: function addNewSchedule(schedule, form) {
				var _this7 = this;
	
				this.isSaveButtonDisabled = true;
				this.WorkPlanSrv.addSchedule.add(schedule).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this7.showModalScheduleSuccess();
	
						if (_this7.feedback && !_this7.planningFinish) _this7.getSchedulesRejectData();else _this7.getSchedulesData();
	
						_this7.gridApi.grid.refresh();
						_this7.cleanForm(form);
					} else {
						_this7.isSaveButtonDisabled = false;
						_this7.showModalScheduleFailure('Ha ocurrido un problema de conexión con el servidor');
					}
				}, function (data) {
					_this7.isSaveButtonDisabled = false;
					console.log(data);
				});
			}
		}, {
			key: 'editExistingSchedule',
			value: function editExistingSchedule(schedule, form) {
				var _this8 = this;
	
				this.isSaveButtonDisabled = true;
				this.WorkPlanSrv.updateSchedule.update(schedule).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this8.showModalScheduleSuccess();
	
						if (_this8.feedback && !_this8.planningFinish) _this8.getSchedulesRejectData();else _this8.getSchedulesData();
	
						_this8.gridApi.grid.refresh();
						_this8.cleanForm(form);
						_this8.editing = false;
					} else {
						_this8.isSaveButtonDisabled = false;
						_this8.showModalScheduleFailure('Ha ocurrido un problema de conexión con el servidor');
					}
				}, function (data) {
					_this8.isSaveButtonDisabled = false;
					console.log(data);
				});
			}
		}, {
			key: 'cleanForm',
			value: function cleanForm(form) {
				this.daysArray = [];
				this.selectedDays = {};
				this.periodsArray = [];
				this.selectedTypePeriod = {};
				this.startHour = null;
				this.endHour = null;
				this.description = null;
				this.isTouchedPeriods = false;
				this.isTouchedDays = false;
				this.scheduleTypeId = 1;
				this.mostrarObsAdicionalesOblig = false;
				this.calendarId = null;
				this.workplanTeacherActivityId = null;
				this.editing = false;
				this.hoursPlanning = null;
				this.isSaveButtonDisabled = false;
				form.$setPristine();
				form.$setUntouched();
			}
		}, {
			key: 'setValues',
			value: function setValues(schedule) {
				this.calendarId = schedule[0].calendarId;
				this.workplanTeacherActivityId = schedule[0].workplanTeacherActivityId;
				this.scheduleTypeId = schedule[0].scheduleTypeId;
				this.startHour = schedule[0].startHour;
				this.endHour = schedule[0].endHour;
				this.description = schedule[0].description;
	
				this.daysArray = [];
				this.selectedDays = {};
				this.periodsArray = [];
				this.selectedTypePeriod = {};
				this.hoursPlanning = schedule[0].hoursPlanned;
	
				//si es de tipo presencial, setear los dias y periodos
				if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
					var splits = schedule[0].daysId.split(',');
	
					for (var i = 0; i < splits.length; i++) {
						var valor = splits[i];
	
						this.daysArray.push(parseInt(valor));
						this.selectedDays[valor] = true;
					}
					splits = schedule[0].periodsId.split(',');
					for (var i = 0; i < splits.length; i++) {
						var valor = splits[i];
	
						this.periodsArray.push(parseInt(valor));
						this.selectedTypePeriod[valor] = true;
					}
				}
	
				this.editing = true;
			}
		}, {
			key: 'getSchedule',
			value: function getSchedule(schedule) {
				var _this9 = this;
	
				this.actionEditOrCreate = 'modificado';
				var header = {
					calendarId: schedule.calendarId
				};
	
				this.WorkPlanSrv.getScheduleById.get(header).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						_this9.setValues(dataReturn.data);
					} else {}
				}, function (data) {
					console.log(data);
				});
			}
			/**************************************
	       * aqui termina add/edit               *
	       ***************************************/
	
			/**************************************
	     * Aqui Comienza Delete Schedule       *
	     ***************************************/
	
		}, {
			key: 'confirmDisableSchedule',
			value: function confirmDisableSchedule(row) {
				var _this10 = this;
	
				var schedule = row;
	
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', 'WorkPlanSrv', function ($scope, $mdDialog, WorkPlanSrv) {
						var confirmDisableCtlVm = this;
	
						confirmDisableCtlVm.schedule = schedule;
	
						confirmDisableCtlVm.close = close;
						confirmDisableCtlVm.disableSchedule = disableSchedule;
	
						function close() {
							$mdDialog.hide();
						}
	
						function disableSchedule() {
							WorkPlanSrv.disableSchedule.disable({
								calendarId: confirmDisableCtlVm.schedule.calendarId,
								workplanTeacherActivityId: confirmDisableCtlVm.schedule.workplanTeacherActivityId
							}).$promise.then(function (dataReturn) {
								$mdDialog.hide(dataReturn);
							});
						}
					}],
					controllerAs: 'confirmDisableCtlVm',
					template: __webpack_require__(738),
					clickOutsideToClose: false
				}).then(function (dataReturn) {
					if (dataReturn && dataReturn.status) {
						if (_this10.feedback && !_this10.planningFinish) _this10.getSchedulesRejectData();else _this10.getSchedulesData();
	
						_this10.gridApi.grid.refresh();
						_this10.showModalDeleteSuccess();
					}
				});
			}
		}, {
			key: 'showModalDeleteSuccess',
			value: function showModalDeleteSuccess() {
				var texts = this.GlobalConfig.appTexts;
				var header = {
					createOrEdit: texts.deleteDialog,
					textCreateOrEdit: texts.deleted,
					itemName: 'el horario seleccionado',
					nameModal: texts.modalTypeName.deleted,
					modalType: texts.modalTypeId.default
				};
	
				this.WorkPlanModalSrv.setVariableSuccessDialog(header);
				this.WorkPlanModalSrv.successDialog(header);
			}
			/**************************************
	       * Aqui Termina Delete Schedule        *
	       ***************************************/
	
			/**************************************
	     * Modal para add/edit exitoso         *
	     ***************************************/
	
		}, {
			key: 'showModalScheduleSuccess',
			value: function showModalScheduleSuccess() {
				var texts = this.GlobalConfig.appTexts;
				var createdOrEdit = texts.saved;
				var successAction = texts.createDialog;
	
				if (this.editing) {
					createdOrEdit = texts.modified;
					successAction = texts.editDialog;
				}
	
				var header = {
					createOrEdit: successAction,
					textCreateOrEdit: createdOrEdit,
					itemName: this.scheduleRadio,
					nameModal: texts.modalTypeName.schedule,
					modalType: texts.modalTypeId.default
				};
	
				this.WorkPlanModalSrv.setVariableSuccessDialog(header);
				this.WorkPlanModalSrv.successDialog(header);
			}
	
			/**************************************
	     * Modal para add/edit fallo           *
	     ***************************************/
	
		}, {
			key: 'showModalScheduleFailure',
			value: function showModalScheduleFailure(text) {
				this.$mdDialog.show({
					controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
						var failureDialogCtlVm = this;
	
						failureDialogCtlVm.text = text;
						failureDialogCtlVm.close = function () {
							$mdDialog.hide();
						};
					}],
					template: __webpack_require__(739),
					controllerAs: 'failureDialogCtlVm',
					clickOutsideToClose: true
				});
			}
		}, {
			key: 'cambiarVistaObsAdic',
			value: function cambiarVistaObsAdic(val) {
				if (val === 1) {
					this.mostrarObsAdicionalesOblig = true;
					this.hourPlanningRequired = false;
				} else if (val === 2) {
					this.mostrarObsAdicionalesOblig = false;
					this.hourPlanningRequired = true;
				}
			}
		}, {
			key: 'getPresentialInfo',
			value: function getPresentialInfo(data) {
				var _this11 = this;
	
				var result = [];
	
				data.forEach(function (element) {
					if (element.scheduleTypeId == _this11.configScheduleTypeId.presencial) result.push(element);
				});
	
				return result;
			}
		}, {
			key: 'getTotalVirtualAttentionInfo',
			value: function getTotalVirtualAttentionInfo(data) {
				var _this12 = this;
	
				var result = 0;
	
				data.forEach(function (element) {
					if (element.scheduleTypeId == _this12.configScheduleTypeId.virtual) {
						var hours = element.hoursPlanned | 0;
	
						result = result + hours;
						_this12.calendarIdForVirtualAttention = element.calendarId;
						_this12.workplanTeacherActivityIdForVirtualAttention = element.workplanTeacherActivityId;
					}
				});
	
				return result;
			}
		}, {
			key: 'isValidSchedule',
			value: function isValidSchedule(schedule) {
				var isValid = true;
	
				schedule.startHour = schedule.startHour + ':00';
				schedule.endHour = schedule.endHour + ':00';
				for (var idx1 in this.gridListSchedules.data) {
					var element = this.gridListSchedules.data[idx1];
	
					for (var idx2 in schedule.days) {
						var day = schedule.days[idx2];
	
						if (parseInt(day.dayId) === parseInt(element.daysId)) {
							var scheduleStartHour = moment(schedule.startHour, 'HH:mm:ss').toDate();
							var scheduleEndHour = moment(schedule.endHour, 'HH:mm:ss').toDate();
							var elementStartHour = moment(element.startHour, 'HH:mm:ss').toDate();
							var elementEndHour = moment(element.endHour, 'HH:mm:ss').toDate();
	
							if (scheduleStartHour <= elementStartHour && scheduleEndHour <= elementStartHour) {
								console.log('if');
								//isValid = true
							} else if (scheduleStartHour >= elementEndHour) {
								console.log('else if');
								//isValid = true
							} else {
								//console.log("else")
								isValid = false;
								break;
							}
						}
					}
	
					if (!isValid) break;
				}
	
				return isValid;
			}
		}]);
	
		return ScheduleListCtrl;
	}();
	
	exports.default = ScheduleListCtrl;
	
	
	ScheduleListCtrl.$inject = ['$scope', 'WorkPlanSrv', '$interval', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', '$sessionStorage'];

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> {{row.entity.startHour.substring(0,5)}} - {{row.entity.endHour.substring(0,5)}} </div> ";

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div> <i class=\"icon mdi-content-create i-16 text-negro-opacity m-r-sm pointer\" ng-click=grid.appScope.schedulesListVm.getSchedule(row.entity)></i> <i class=\"icon mdi-action-delete i-16 text-negro-opacity m-r-sm pointer\" ng-click=grid.appScope.schedulesListVm.confirmDisableSchedule(row.entity)></i> </div> </div> ";

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=confirmDisableCtlVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>¿Está seguro que desea eliminar este horario?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=confirmDisableCtlVm.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=confirmDisableCtlVm.disableSchedule()>Eliminar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=failureDialogCtlVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>{{failureDialogCtlVm.text}}</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=failureDialogCtlVm.close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConsultSummaryByAreaCtrl = function ConsultSummaryByAreaCtrl($scope, $rootScope, WorkPlanSrv, $mdDialog, $cookieStore, $state, $cookies, GlobalConfig, $sessionStorage) {
	  _classCallCheck(this, ConsultSummaryByAreaCtrl);
	
	  var summaryByAreaVm = this;
	  $rootScope.fullscreenClass = 'background-planning';
	  summaryByAreaVm.showModalMessages = showModalMessages;
	  summaryByAreaVm.messagesList = [];
	  summaryByAreaVm.userId = 0;
	  summaryByAreaVm.classDiagram = "";
	  summaryByAreaVm.teacherId = 0;
	  summaryByAreaVm.radioGreen = "#04B404";
	  summaryByAreaVm.submoduleroute = submoduleroute;
	  summaryByAreaVm.getValidateModule = getValidateModule;
	  summaryByAreaVm.disableButton = true;
	  summaryByAreaVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  summaryByAreaVm.$sessionStorage = $sessionStorage;
	
	  var submoduleArray = $cookieStore.get('subModuleId');
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	
	  summaryByAreaVm.assignStyles = function () {
	    switch (parseInt(summaryByAreaVm.timeline)) {
	
	      case 1:
	        summaryByAreaVm.classCircleGreen1 = 'green';
	        break;
	      case 2:
	        summaryByAreaVm.classCircleGreen1 = 'green';
	        summaryByAreaVm.classBarGreen1 = 'green';
	        break;
	      case 3:
	        summaryByAreaVm.classCircleGreen1 = 'green';
	        summaryByAreaVm.classCircleGreen2 = 'green';
	        summaryByAreaVm.classBarGreen1 = 'green';
	        break;
	      case 4:
	        summaryByAreaVm.classCircleGreen1 = 'green';
	        summaryByAreaVm.classCircleGreen2 = 'green';
	        summaryByAreaVm.classCircleGreen3 = 'green';
	        summaryByAreaVm.classBarGreen1 = 'green';
	        summaryByAreaVm.classBarGreen2 = 'green';
	        break;
	      case 5:
	        summaryByAreaVm.classCircleGreen1 = 'green';
	        summaryByAreaVm.classCircleGreen2 = 'green';
	        summaryByAreaVm.classCircleGreen3 = 'green';
	        summaryByAreaVm.classBarGreen1 = 'green';
	        summaryByAreaVm.classBarGreen2 = 'green';
	        summaryByAreaVm.classBarGreen3 = ' green';
	        break;
	      case 6:
	        summaryByAreaVm.classCircleGreen1 = 'green';
	        summaryByAreaVm.classCircleGreen2 = 'green';
	        summaryByAreaVm.classCircleGreen3 = 'green';
	        summaryByAreaVm.classCircleGreen4 = 'green';
	        summaryByAreaVm.classBarGreen1 = 'green';
	        summaryByAreaVm.classBarGreen2 = 'green';
	        summaryByAreaVm.classBarGreen3 = 'green';
	        break;
	      case 7:
	        summaryByAreaVm.classCircleGreen1 = 'green';
	        summaryByAreaVm.classCircleGreen2 = 'green';
	        summaryByAreaVm.classCircleGreen3 = 'green';
	        summaryByAreaVm.classCircleGreen4 = 'green';
	        summaryByAreaVm.classBarGreen1 = 'green';
	        summaryByAreaVm.classBarGreen2 = 'green';
	        summaryByAreaVm.classBarGreen3 = 'green';
	        break;
	      default:
	    }
	  };
	
	  activate();
	
	  function activate() {
	    if ($cookieStore.get("isReproved")) {
	      showModalReactivateWorkplan();
	    } else {
	      getData();
	    }
	  }
	
	  function getValidateModule(submodule) {
	    var result = false;
	    for (var i = 0, len = submoduleArray.length; i < len; i++) {
	      if (submoduleArray[i].submoduleId == submodule) {
	        result = true;
	        break;
	      }
	    }
	
	    if (!result) return ' disabled';else return '';
	  }
	
	  function getData() {
	    summaryByAreaVm.userId = $cookieStore.get("currentUser").id;
	    summaryByAreaVm.teacherId = currentUser.teacherId;
	    getElements();
	    getMessages();
	  }
	
	  function submoduleroute(submodule) {
	    for (var i = 0, len = submoduleArray.length; i < len; i++) {
	      if (submoduleArray[i].submoduleId == submodule) {
	        if (submodule == GlobalConfig.modules.teaching) {
	          $state.go('workplan.teachingSubjects');
	        }
	
	        if (submodule == GlobalConfig.modules.academicManagement) {
	          $state.go('workplan.academicManagement');
	        }
	
	        if (submodule == GlobalConfig.modules.consolidation) {
	          $state.go('workplan.teachingDevelopment');
	        }
	
	        if (submodule == GlobalConfig.modules.extentionAndVisibility) {
	          $state.go('workplan.extensionAndVisibility');
	        }
	
	        if (submodule == GlobalConfig.modules.investigation) {
	          $state.go('workplan.investigation');
	        }
	      }
	    }
	  }
	
	  // Submodule order the SQL/UI expects (matches ORDER BY FIELD(s.submoduleId,2,6,4,3,5)).
	  // Used to synthesize empty 0% anillos when the teacher has no activities yet — see USUITE-14167.
	  var WORKPLAN_SUBMODULES = [{ submoduleId: 2, submoduleName: 'Docencia' }, { submoduleId: 6, submoduleName: 'Investigación' }, { submoduleId: 4, submoduleName: 'Extensión y visibilidad' }, { submoduleId: 3, submoduleName: 'Gestión académica' }, { submoduleId: 5, submoduleName: 'Consolidación del cuerpo profesoral' }];
	
	  function buildEmptyAnillos() {
	    return WORKPLAN_SUBMODULES.filter(function (sm) {
	      return submoduleArray && submoduleArray.some(function (s) {
	        return s.submoduleId === sm.submoduleId;
	      });
	    }).map(function (sm) {
	      var fromCookie = submoduleArray.find(function (s) {
	        return s.submoduleId === sm.submoduleId;
	      });
	      return {
	        submoduleId: sm.submoduleId,
	        submoduleName: fromCookie && fromCookie.submoduleName || sm.submoduleName,
	        percentage: 0,
	        hours: 0
	      };
	    });
	  }
	
	  function getElements() {
	    WorkPlanSrv.getElementsRightBar.getList({ teacherId: summaryByAreaVm.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        delete $sessionStorage.workPlanGeneralList;
	        summaryByAreaVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        var index = 0;
	        summaryByAreaVm.RightBar = dataReturn.data;
	        // Teachers with zero activities get an empty asignaturesPlaned[] from the
	        // backend (the SQL's UNION ALL fallback is filtered out by the inner join
	        // on wpt_code). Synthesize one row per accessible submodule so the anillos
	        // render at 0% instead of disappearing.
	        if (!summaryByAreaVm.RightBar.asignaturesPlaned || summaryByAreaVm.RightBar.asignaturesPlaned.length === 0) {
	          summaryByAreaVm.RightBar.asignaturesPlaned = buildEmptyAnillos();
	        }
	        summaryByAreaVm.asignaturesPlaned = summaryByAreaVm.RightBar.asignaturesPlaned.map(function (summaryByAreaVm) {
	          summaryByAreaVm.classDiagram = 'principal-diagram c100 big center ' + 'p' + summaryByAreaVm.percentage + getValidateModule(summaryByAreaVm.submoduleId);
	          return summaryByAreaVm;
	        });
	        //console.log(dataReturn.data)
	        if (summaryByAreaVm.RightBar.asignaturesPlaned[index]) {
	          summaryByAreaVm.teachingSubjects = summaryByAreaVm.RightBar.asignaturesPlaned[index].percentage;
	        }
	        if (summaryByAreaVm.RightBar.asignaturesPlaned[2]) {
	          summaryByAreaVm.doctoralFormation = summaryByAreaVm.RightBar.asignaturesPlaned[2].percentage;
	        }
	        if (summaryByAreaVm.RightBar.asignaturesPlaned[1]) {
	          summaryByAreaVm.delegationCharges = summaryByAreaVm.RightBar.asignaturesPlaned[1].percentage;
	        }
	        if (summaryByAreaVm.RightBar.timeline && summaryByAreaVm.RightBar.timeline[index]) {
	          summaryByAreaVm.timeline = summaryByAreaVm.RightBar.timeline[index].stageId;
	          summaryByAreaVm.stage = summaryByAreaVm.RightBar.timeline[index].stage;
	        }
	        summaryByAreaVm.assignStyles();
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getMessages() {
	    //WorkPlanSrv.getMessages.get({userId:summaryByAreaVm.userId}).$promise.then(function (dataReturn) {
	    WorkPlanSrv.getMessagesNotification.get({ userId: summaryByAreaVm.userId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        summaryByAreaVm.messagesList = dataReturn.data;
	      } else {
	        summaryByAreaVm.messagesList = [];
	      }
	      summaryByAreaVm.disableButton = false;
	    });
	  }
	
	  function showModalMessages() {
	    var userId = summaryByAreaVm.userId;
	    var messagesList = summaryByAreaVm.messagesList;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function showModalMessages($scope, $mdDialog) {
	        var modalMessagesVm = this;
	
	        //declaracion de variables
	        modalMessagesVm.userId = userId;
	        modalMessagesVm.messagesList = messagesList;
	        modalMessagesVm.class1 = "mdi-hardware-keyboard-arrow-down";
	        modalMessagesVm.class2 = "mdi-hardware-keyboard-arrow-up";
	        modalMessagesVm.classRead = "mdi-content-drafts";
	        modalMessagesVm.classUnRead = "mdi-content-mail";
	
	        //declaracion de funciones
	        modalMessagesVm.showMessage = showMessage;
	        modalMessagesVm.close = close;
	
	        activate();
	        function activate() {
	          //updateReadMessage()
	        }
	
	        function showMessage(pos) {
	          if (modalMessagesVm.messagesList[pos].isHiden) {
	            modalMessagesVm.messagesList[pos].isHiden = false;
	          } else {
	            modalMessagesVm.messagesList[pos].isHiden = true;
	          }
	          //si el mensaje esta leido se muestra un ojo justo al lado de la flecha que muestra el mensaje.
	          //en caso contrario no muestra nada
	          if (modalMessagesVm.messagesList[pos].isRead == 0) {
	            //updateReadMessage(pos)
	            modalMessagesVm.messagesList[pos].isRead = 1;
	          }
	        }
	
	        function updateReadMessage(pos) {
	          WorkPlanSrv.updateReadingMessages.update({
	            userId: modalMessagesVm.userId
	          }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              modalMessagesVm.messagesList[pos].isRead = 1;
	            } else {
	              console.log('error de comunicacion con el servidor');
	            }
	          }, function (data) {
	            console.log(data);
	          });
	        }
	
	        function close() {
	          $mdDialog.hide();
	        }
	      }],
	      template: __webpack_require__(741),
	      controllerAs: 'modalMessagesVm',
	      clickOutsideToClose: false
	    });
	  }
	
	  function showModalReactivateWorkplan() {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.reactivate = function (isNew) {
	          showModalConfirm(isNew);
	          //$mdDialog.hide()
	        };
	        $scope.close = function () {
	          $mdDialog.hide();
	          $state.go('fullscreen.welcomeHome');
	        };
	      }],
	      template: __webpack_require__(449),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showModalConfirm(isNew) {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function showModalConfirm($scope, $mdDialog) {
	        $scope.continue = function () {
	
	          var post = {
	            teacherId: $cookieStore.get("currentUser").teacherId,
	            workplanId: $cookieStore.get("currentUser").workplanId,
	            isNew: isNew
	          };
	          return WorkPlanSrv.setPlanningWorkplanByTeacher.set(post).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              $cookieStore.put('isReproved', 0);
	              $mdDialog.hide();
	              $state.reload();
	              getData();
	            }
	          }, function (data) {
	            console.log(data);
	            $mdDialog.hide();
	          });
	        };
	        $scope.close = function () {
	          $mdDialog.hide();
	          //getData()
	          $state.go('fullscreen.welcomeHome');
	        };
	      }],
	      template: __webpack_require__(450),
	      clickOutsideToClose: false
	    });
	  }
	};
	
	exports.default = ConsultSummaryByAreaCtrl;
	
	
	ConsultSummaryByAreaCtrl.$inject = ['$scope', '$rootScope', 'WorkPlanSrv', '$mdDialog', '$cookieStore', '$state', '$cookies', 'GlobalConfig', '$sessionStorage'];

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=45> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=modalMessagesVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> <div class=col-xs-12> <h4 class=\"text-azul p-v font-bold text-md text-center\">Principios orientadores</h4> </div> </div> </md-toolbar> <md-dialog-content> <div ng-repeat=\"message in modalMessagesVm.messagesList\"> <div class=row> <div class=col-xs-12> <h5 class=\"text-negro font-bold text-center font-test\" ng-click=modalMessagesVm.showMessage($index)>{{message.title}}</h5> <div ng-bind-html=message.body></div> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlanSubjectCtrl = function PlanSubjectCtrl($scope, $state, $stateParams, WorkPlanSrv, $mdDialog, $cookies, GlobalConfig, WorkPlanModalSrv) {
		_classCallCheck(this, PlanSubjectCtrl);
	
		var subjectVm = this;
	
		subjectVm.currentUser = JSON.parse($cookies.get('currentUser'));
		subjectVm.showTable = true;
		subjectVm.isFirstTime = 1;
		subjectVm.teaching = 1;
		subjectVm.swEdit = false;
		subjectVm.isFirstTimeRadio = '';
		subjectVm.editOrCreated = 'Planeación exitosa';
		subjectVm.activityName = '';
		subjectVm.workplanTeacherActivityId = null;
		subjectVm.showTableActivities = false;
		subjectVm.showTableFormation = false;
		subjectVm.formPlanSchedule = true;
		subjectVm.formFormation = true;
		subjectVm.comboboxData = [];
		subjectVm.rightTable = [];
		subjectVm.activityList = [];
		subjectVm.editOneActivity = [];
		subjectVm.youngList = [];
		subjectVm.activitiesPlanningArray = [];
		subjectVm.activitiesTeachersArray = [];
		subjectVm.oldPlanningAndManagement = null;
		subjectVm.oldFormation = null;
		subjectVm.itemActivityRequired = [];
		subjectVm.itemFormationRequired = [];
		subjectVm.hoursRelation = 0;
		subjectVm.buttonDisabled = false;
		subjectVm.buttonDisabledModal = false;
		// -----------------------------Funciones---------------------------------//
		subjectVm.cleanForm = cleanForm;
		subjectVm.editActivitiesPlanning = editActivitiesPlanning;
		subjectVm.deleteActivitiesPlanning = deleteActivitiesPlanning;
		subjectVm.editActivitiesTeacher = editActivitiesTeacher;
		subjectVm.deleteActivitiesTeacher = deleteActivitiesTeacher;
		subjectVm.hiddenTable = hiddenTable;
		subjectVm.addActivities = addActivities;
		subjectVm.addFormation = addFormation;
		subjectVm.filterActivity = filterActivity;
		subjectVm.saveActivity = saveActivity;
		subjectVm.showErrorMessages = showErrorMessages;
		subjectVm.hasError = hasError;
		subjectVm.validateForm = validateForm;
		subjectVm.validateFormActivities = validateFormActivities;
		subjectVm.validateFormFormation = validateFormFormation;
		subjectVm.showModalFirstTime = showModalFirstTime;
		subjectVm.observationRequired = observationRequired;
		subjectVm.updateloadTime = updateloadTime;
		var iconClasses = ['mdi-hardware-keyboard-arrow-down', 'mdi-hardware-keyboard-arrow-up'];
	
		subjectVm.class = iconClasses[0];
		var post = {
			teacherId: subjectVm.currentUser.teacherId,
			asignatureId: $stateParams.subjectId,
			workplanId: subjectVm.currentUser.workplanId
		};
	
		subjectVm.isFeedback = subjectVm.currentUser.isFeedback;
	
		var defeaultHoursTeaching = 0;
	
		subjectVm.Math = window.Math;
	
		activate();
	
		function activate() {
			if (!$stateParams.subjectId) {
				$state.go('workplan.teachingSubjects');
			}
	
			callServiceCombobox();
		}
	
		function callServiceEdit() {
			// edit activity
			WorkPlanSrv.getActivityPlanningTeacher.get(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					//console.log("--->", dataReturn)
					if (dataReturn.header.length > 0) {
						subjectVm.editOneActivity = dataReturn;
						addValuesEdit();
						getTotalHoursRelation();
						subjectVm.swEdit = true;
					}
				} else {
					console.log('Comunications problem with the server');
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function getTotalHoursRelation() {
			var hoursPlanned = 0;
	
			//console.log("---", hoursPlanned)
			for (var i in subjectVm.activitiesPlanningArray) {
				//console.log("item--->", subjectVm.activitiesPlanningArray[i])
				if (subjectVm.activitiesPlanningArray[i].itemActivityId === GlobalConfig.minorActivityId.itemRequiredTeaching) {
					//console.log("+++", subjectVm.activitiesPlanningArray[i].hoursPlanned)
					hoursPlanned += subjectVm.activitiesPlanningArray[i].hoursPlanned;
				}
			}
	
			subjectVm.hoursRelation = hoursPlanned;
		}
	
		function callServiceDetailAsignature() {
			// List right table
			return WorkPlanSrv.getDetailAsignaturePlanning.getList(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					subjectVm.rightTable = dataReturn.data[0];
	
					if (subjectVm.rightTable.numberStudents == null) {
						subjectVm.rightTable.numberStudents = '0';
					}
	
					if (subjectVm.activitiesPlanningArray.length === 0 && subjectVm.activitiesTeachersArray.length === 0) {
						if (subjectVm.hoursTeaching) {
							subjectVm.rightTable.loadTime = subjectVm.hoursTeaching;
						} else {
							subjectVm.hoursTeaching = subjectVm.rightTable.loadTime;
						}
					} else {
						subjectVm.rightTable.loadTime = subjectVm.hoursTeaching;
					}
	
					defeaultHoursTeaching = subjectVm.rightTable.loadTime;
				} else {
					console.log('Comunications problem with the server');
				}
			}, function (data) {
				console.log(data);
			});
			//return Promise.resolve(true)
		}
	
		function callServiceCombobox() {
			// Combobox data
			WorkPlanSrv.getDataFormActivityTeaching.get().$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					subjectVm.comboboxData = dataReturn;
					//console.log("Combobox ", dataReturn)
					subjectVm.activityList = subjectVm.comboboxData.listsPlanning.items;
					subjectVm.youngList = subjectVm.comboboxData.listsTeachers.items;
					subjectVm.directTeaching = GlobalConfig.minorActivityId.directTeaching;
					subjectVm.planning = GlobalConfig.minorActivityId.planning;
					subjectVm.training = GlobalConfig.minorActivityId.teaching;
				} else {
					console.log('Comunications problem with the server');
				}
			}, function (data) {
				console.log(data);
			});
			callServiceDetailAsignature().then(callServiceEdit());
		}
	
		function addActivityPlanningTeacher(jsonActivity) {
			// Combobox data
			WorkPlanSrv.addActivityPlanningTeacher.save(jsonActivity).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					if (subjectVm.swEdit) subjectVm.activityName = 'modificado';else subjectVm.activityName = 'creado';
	
					subjectVm.buttonDisabledModal = false;
					showModalActivityCreated();
				} else {
					subjectVm.buttonDisabled = false;
					console.log('Comunications problem with the server');
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function createJson() {
			subjectVm.buttonDisabled = true;
	
			if (subjectVm.isFirstTime == 1) {
				subjectVm.isFirstTimeRadio = 1;
			} else {
				if (subjectVm.isFirstTime == 0) {
					subjectVm.isFirstTimeRadio = 0;
				}
			}
	
			if (subjectVm.swEdit) {
				if (subjectVm.editOneActivity.header[0].workplanTeacherActivityId) {
					subjectVm.workplanTeacherActivityId = subjectVm.editOneActivity.header[0].workplanTeacherActivityId;
				}
	
				subjectVm.editOrCreated = 'EdiciÃ³n exitosa';
			}
	
			var headerArray = {
				workplanTeacherActivityId: subjectVm.workplanTeacherActivityId,
				hoursPlanned: subjectVm.hoursTeaching == 0 ? subjectVm.hoursTeaching : subjectVm.hoursTeaching * subjectVm.rightTable.groupsTempNum,
				hoursDirectTeaching: subjectVm.hoursTeaching,
				description: subjectVm.observation,
				teacherId: post.teacherId,
				asignatureId: post.asignatureId,
				workplanId: post.workplanId,
				isFirstTime: subjectVm.isFirstTimeRadio,
				activitiesPlanning: subjectVm.activitiesPlanningArray,
				activitiesTeachers: subjectVm.activitiesTeachersArray,
				activityId: parseInt(subjectVm.directTeaching),
				relationship: subjectVm.hoursRelation == 0 || subjectVm.hoursTeaching == 0 ? (1 / (1 * subjectVm.rightTable.groupsTempNum)).toFixed(2) : (subjectVm.hoursRelation / (subjectVm.hoursTeaching * subjectVm.rightTable.groupsTempNum)).toFixed(2),
				isFeedbackActivity: subjectVm.isFeedback
			};
	
			addActivityPlanningTeacher(headerArray);
		}
	
		function addValuesEdit() {
			var index = 0;
	
			if (subjectVm.editOneActivity.header.length) {
				subjectVm.observation = subjectVm.editOneActivity.header[index].description;
				subjectVm.hoursTeaching = subjectVm.editOneActivity.header[index].hoursDirectTeaching;
				subjectVm.rightTable.loadTime = subjectVm.hoursTeaching;
				subjectVm.isFirstTime = subjectVm.editOneActivity.header[0].isFirstTime;
				subjectVm.activitiesPlanningArray = subjectVm.editOneActivity.activitiesPlanning.map(function (aux) {
					if (null === aux.activityId) aux.activityId = parseInt(subjectVm.planning);
	
					return aux;
				});
				subjectVm.showTableActivities = true; //Muestro el div oculto de gestiÃ³n
				subjectVm.activitiesTeachersArray = subjectVm.editOneActivity.activitiesTeachers.map(function (aux) {
					if (null === aux.activityId) aux.activityId = parseInt(subjectVm.training);
	
					return aux;
				});
				subjectVm.showTableFormation = true; //Muestro el div oculto de actividades
				defeaultHoursTeaching = subjectVm.hoursTeaching;
			}
		}
	
		function showModalSaveItemRequired() {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.itemActivitiesRequired = subjectVm.itemActivityRequired;
					$scope.itemFormationRequired = subjectVm.itemFormationRequired;
					$scope.buttonDisabledModal = subjectVm.buttonDisabledModal;
					$scope.continue = function () {
						subjectVm.buttonDisabledModal = true;
						createJson();
						$mdDialog.hide();
					};
					$scope.close = function () {
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(743),
				clickOutsideToClose: false
			});
		}
	
		function saveActivity() {
			subjectVm.buttonDisabled = true;
			isAllActivityItemRequired();
			isAllFormationItemRequired();
	
			if (subjectVm.oldPlanningAndManagement) {
				addOldActivities(subjectVm.oldPlanningAndManagement);
			}
	
			if (subjectVm.itemActivityRequired.length > 0 || subjectVm.itemFormationRequired.length > 0) {
				subjectVm.buttonDisabled = false;
				showModalSaveItemRequired();
			} else {
				createJson();
			}
		}
	
		function showModalActivityCreated() {
			var texts = GlobalConfig.appTexts;
			var actionEditOrCreate = texts.createDialog;
			var textCreateOrEdit = texts.saved;
	
			if (subjectVm.swEdit) {
				actionEditOrCreate = texts.editDialog;
				textCreateOrEdit = texts.modified;
			}
	
			var header = {
				createOrEdit: actionEditOrCreate,
				textCreateOrEdit: textCreateOrEdit,
				itemName: subjectVm.rightTable.asignatureName,
				nameModal: texts.modalTypeName.teachingSubject,
				modalType: texts.modalTypeId.teachingSubject
			};
	
			WorkPlanModalSrv.setVariableSuccessDialog(header);
			WorkPlanModalSrv.successDialog(header).then(function (promise) {});
		}
	
		function hiddenTable() {
			if (subjectVm.class === iconClasses[0]) {
				subjectVm.class = iconClasses[1];
				subjectVm.showTable = true;
			} else {
				subjectVm.class = iconClasses[0];
				subjectVm.showTable = false;
			}
		}
	
		function showModalItemRequired(activities) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					if (activities) {
						$scope.itemName = 'Actividades';
						$scope.itemRequired = subjectVm.itemActivityRequired;
					} else {
						$scope.itemName = 'Formaciones';
						$scope.itemRequired = subjectVm.itemFormationRequired;
					}
	
					$scope.close = function () {
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(744),
				clickOutsideToClose: false
			});
		}
	
		function isAllActivityItemRequired() {
			var enc = false;
	
			subjectVm.itemActivityRequired = [];
	
			for (var i in subjectVm.activityList) {
				enc = false;
	
				if (subjectVm.activityList[i].isRequired === 1) {
					for (var j in subjectVm.activitiesPlanningArray) {
						if (subjectVm.activitiesPlanningArray[j].itemActivityId === subjectVm.activityList[i].idListItem) {
							enc = true;
							break;
						}
					}
	
					if (!enc) {
						subjectVm.itemActivityRequired.push({
							itemActivityName: subjectVm.activityList[i].listItemName
						});
					}
				}
			}
		}
	
		function isItemRepeat(array, value) {
			for (var index in array) {
				if (array[index].itemActivityName === value) {
					return true;
				}
			}
	
			return false;
		}
	
		function addActivities() {
			// if(!isItemRepeat(subjectVm.activitiesPlanningArray, subjectVm.activityCombo.listItemName)){
			subjectVm.activitiesPlanningArray.push({
				itemActivityId: subjectVm.activityCombo.idListItem,
				itemActivityName: subjectVm.activityCombo.listItemName,
				hoursPlanned: subjectVm.hoursPlanned,
				detail: subjectVm.detail,
				activityId: parseInt(subjectVm.planning),
				itemRequired: subjectVm.activityCombo.isRequired
			});
			//}
	
			getTotalHoursRelation();
	
			subjectVm.activityCombo = null;
			subjectVm.hoursPlanned = null;
			subjectVm.detail = null;
			subjectVm.showTableActivities = true; //Muestro el div oculto de gestión
			subjectVm.oldPlanningAndManagement = null;
			isAllActivityItemRequired();
	
			if (subjectVm.itemActivityRequired.length > 0) showModalItemRequired(true);
		}
	
		function addOldActivities(planningAndManagement) {
			subjectVm.activitiesPlanningArray.push({
				itemActivityId: planningAndManagement.itemActivityId,
				itemActivityName: planningAndManagement.itemActivityName,
				hoursPlanned: planningAndManagement.hoursPlanned,
				detail: planningAndManagement.detail,
				activityId: parseInt(planningAndManagement.activityId),
				itemRequired: subjectVm.activityCombo.isRequired
			});
	
			getTotalHoursRelation();
	
			subjectVm.activityCombo = null;
			subjectVm.hoursPlanned = null;
			subjectVm.detail = null;
			subjectVm.showTableActivities = true; //Muestro el div oculto de gestión
			subjectVm.oldPlanningAndManagement = null;
		}
	
		function isAllFormationItemRequired() {
			var enc = false;
	
			subjectVm.itemFormationRequired = [];
	
			for (var i in subjectVm.youngList) {
				enc = false;
	
				if (subjectVm.youngList[i].isRequired === 1) {
					for (var j in subjectVm.activitiesTeachersArray) {
						if (subjectVm.activitiesTeachersArray[j].itemActivityId === subjectVm.youngList[i].idListItem) {
							enc = true;
							break;
						}
					}
	
					if (!enc) {
						subjectVm.itemFormationRequired.push({
							itemActivityName: subjectVm.youngList[i].listItemName
						});
					}
				}
			}
		}
	
		function addFormation() {
			if (!isItemRepeat(subjectVm.activitiesTeachersArray, subjectVm.kindOfYoung.listItemName)) {
				subjectVm.activitiesTeachersArray.push({
					itemActivityId: subjectVm.kindOfYoung.idListItem,
					itemActivityName: subjectVm.kindOfYoung.listItemName,
					hoursPlanned: subjectVm.hoursDedicated,
					itemActivityValue: subjectVm.numberOfStudents,
					detail: subjectVm.activityOfFa,
					activityId: parseInt(subjectVm.training),
					itemRequired: subjectVm.kindOfYoung.isRequired
				});
			}
	
			subjectVm.kindOfYoung = null;
			subjectVm.hoursDedicated = null;
			subjectVm.numberOfStudents = null;
			subjectVm.activityOfFa = null;
			subjectVm.showTableFormation = true; //Muestro el div oculto de actividades
			subjectVm.oldFormation = null;
			isAllFormationItemRequired();
	
			if (subjectVm.itemFormationRequired.length > 0) showModalItemRequired(false);
		}
	
		function addOldFormation(formationList) {
			subjectVm.activitiesTeachersArray.push({
				itemActivityId: formationList.itemActivityId,
				itemActivityName: formationList.itemActivityName,
				hoursPlanned: formationList.hoursPlanned,
				itemActivityValue: formationList.itemActivityValue,
				detail: formationList.detail,
				activityId: parseInt(formationList.training),
				itemRequired: subjectVm.kindOfYoung.isRequired
			});
	
			subjectVm.kindOfYoung = null;
			subjectVm.hoursDedicated = null;
			subjectVm.numberOfStudents = null;
			subjectVm.activityOfFa = null;
			subjectVm.showTableFormation = true; //Muestro el div oculto de actividades
			subjectVm.oldFormation = null;
		}
	
		function editActivitiesPlanning(planningAndManagement) {
			//VERIFICA QUE NO ESTE UN REGISTRO EN LOS CAMPOS DE AGREGAR
			if (subjectVm.oldPlanningAndManagement) {
				addOldActivities(subjectVm.oldPlanningAndManagement);
			}
	
			for (var index in subjectVm.activityList) {
				if (subjectVm.activityList[index].idListItem == planningAndManagement.itemActivityId) {
					subjectVm.activityCombo = subjectVm.activityList[index];
				}
			}
	
			subjectVm.hoursPlanned = planningAndManagement.hoursPlanned;
			subjectVm.detail = planningAndManagement.detail;
			var idx = subjectVm.activitiesPlanningArray.indexOf(planningAndManagement);
	
			subjectVm.activitiesPlanningArray.splice(idx, 1);
			subjectVm.oldPlanningAndManagement = planningAndManagement;
	
			if (subjectVm.activitiesPlanningArray == 0) {
				subjectVm.showTableActivities = false;
			}
		}
	
		function editActivitiesTeacher(formationList) {
			//VERIFICA QUE NO ESTE UN REGISTRO EN LOS CAMPOS DE AGREGAR
			if (subjectVm.oldFormation) {
				addOldFormation(subjectVm.oldFormation);
			}
	
			for (var index in subjectVm.youngList) {
				if (subjectVm.youngList[index].idListItem == formationList.itemActivityId) {
					subjectVm.kindOfYoung = subjectVm.youngList[index];
				}
			}
	
			subjectVm.hoursDedicated = formationList.hoursPlanned;
			subjectVm.numberOfStudents = formationList.itemActivityValue;
			subjectVm.activityOfFa = formationList.detail;
			var idx = subjectVm.activitiesTeachersArray.indexOf(formationList);
	
			subjectVm.activitiesTeachersArray.splice(idx, 1);
			subjectVm.oldFormation = formationList;
	
			if (subjectVm.activitiesTeachersArray == 0) {
				subjectVm.showTableFormation = false;
			}
		}
	
		function deleteActivitiesPlanning(planningAndManagement) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.subjectName = planningAndManagement.itemActivityName;
					$scope.close = function () {
						$mdDialog.hide();
					};
					$scope.deleteActivitiesPlanning = function () {
						if (planningAndManagement.itemActivityId === GlobalConfig.minorActivityId.itemRequiredTeaching) {
							subjectVm.hoursRelation -= planningAndManagement.hoursPlanned;
						}
	
						var idx = subjectVm.activitiesPlanningArray.indexOf(planningAndManagement);
	
						subjectVm.activitiesPlanningArray.splice(idx, 1);
	
						if (subjectVm.activitiesPlanningArray.length == 0) {
							subjectVm.showTableActivities = false;
						}
	
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(745),
				clickOutsideToClose: false
			});
		}
	
		function filterActivity(item) {
			for (var x in subjectVm.activitiesPlanningArray) {
				if (subjectVm.activitiesPlanningArray[x].itemActivityId == item.idListItem) {
					return false;
				}
			}
	
			return true;
		}
	
		function deleteActivitiesTeacher(formationList) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.subjectName = formationList.itemActivityName;
					$scope.close = function () {
						$mdDialog.hide();
					};
					$scope.deleteActivitiesTeacher = function () {
						var idx = subjectVm.activitiesTeachersArray.indexOf(formationList);
	
						subjectVm.activitiesTeachersArray.splice(idx, 1);
	
						if (subjectVm.activitiesTeachersArray.length == 0) {
							subjectVm.showTableFormation = false;
						}
	
						$mdDialog.hide();
					};
				}],
				template: __webpack_require__(746),
				clickOutsideToClose: false
			});
		}
	
		function cleanForm(form) {
			form.$setPristine();
			form.$setUntouched();
		}
	
		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error';
			}
		}
	
		function showErrorMessages(input) {
			return input.$dirty || input.$touched;
		}
	
		function validateForm(form) {
			return form.$invalid;
		}
	
		function validateFormActivities(formActivities) {
			return formActivities.$invalid;
		}
	
		function validateFormFormation(formFormation) {
			return formFormation.$invalid;
		}
	
		function showModalFirstTime() {
			post.assignaturePublicId = subjectVm.rightTable.assignaturePublicId;
			post.semId = subjectVm.rightTable.semId;
			post.typen = subjectVm.rightTable.type;
			post.id_mod = subjectVm.rightTable.id_modality;
			var postVal = post;
	
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					var firstTimeVm = this;
	
					firstTimeVm.postValues = postVal;
					firstTimeVm.datos = {};
					//funciones
					firstTimeVm.close = close;
					firstTimeVm.getPreviusPlanning = getPreviusPlanning;
	
					function close() {
						$mdDialog.hide();
						subjectVm.isFirstTime = 1;
					}
	
					function getPreviusPlanning() {
						WorkPlanSrv.getPreviusPlanning.get(firstTimeVm.postValues).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								firstTimeVm.datos = dataReturn.data;
	
								if (!isEmptyJSON(firstTimeVm.datos)) {
									setValues();
								}
							}
						}, function (data) {
							console.log(data);
						});
	
						$mdDialog.hide();
					}
	
					function setValues() {
						var index = 0;
	
						subjectVm.observation = firstTimeVm.datos.header[index].description;
						subjectVm.hoursTeaching = firstTimeVm.datos.header[index].hoursPlanned;
						subjectVm.activitiesPlanningArray = firstTimeVm.datos.activitiesPlanning.map(function (aux) {
							aux.activityId = parseInt(subjectVm.planning);
	
							return aux;
						});
						subjectVm.showTableActivities = true; //Muestro el div oculto de gestión
						subjectVm.activitiesTeachersArray = firstTimeVm.datos.activitiesTeachers.map(function (aux) {
							aux.activityId = parseInt(subjectVm.training);
	
							return aux;
						});
						subjectVm.showTableFormation = true; //Muestro el div oculto de actividades
					}
				}],
				controllerAs: 'firstTimeVm',
				template: __webpack_require__(747),
				clickOutsideToClose: false
			});
		}
	
		function observationRequired() {
			return subjectVm.hoursTeaching != defeaultHoursTeaching;
		}
	
		function isEmptyJSON(obj) {
			if (obj != null) {
				return false;
			}
	
			//for(var i in obj) { return false; }
			return true;
		}
	
		function updateloadTime(observationInput) {
			subjectVm.rightTable.loadTime = subjectVm.hoursTeaching;
			observationInput.$setTouched();
		}
	};
	
	exports.default = PlanSubjectCtrl;
	
	
	PlanSubjectCtrl.$inject = ['$scope', '$state', '$stateParams', 'WorkPlanSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv'];

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=row> <div class=col-md-12> <div class=\"row title text-center\"> <h3 class=text-verde>¡Atención!</h3> <p>Debe configurar los siguientes items obligatorios en esta Asignatura ¿Está seguro de esta acción?</p> </div> <p class=\"text-left text-ms font-text\" ng-if=itemActivitiesRequired.length>Actividades</p> <md-divider></md-divider> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"itemActivitiesRequired in itemActivitiesRequired\" class=m-v-sm> <p class=\"text-left text-ms p-l-sm\"> {{itemActivitiesRequired.itemActivityName}} </p> </li> </ul> <p class=\"text-left text-ms font-text\" ng-if=itemFormationRequired.length>Formaciones</p> <md-divider></md-divider> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"itemFormationRequired in itemFormationRequired\" class=m-v-sm> <p class=\"text-left text-ms p-l-sm\"> {{itemFormationRequired.itemActivityName}} </p> </li> </ul> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-disabled=buttonDisabledModal ng-click=continue()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Para guardar la planeación de esta Asignatura debe configurar las siguientes {{itemName}}</p> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"itemRequired in itemRequired\" class=m-v-sm> <p class=\"text-left text-md p-l-sm\"> {{itemRequired.itemActivityName}} </p> </li> </ul> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Está a punto de eliminar la actividad \"{{subjectName}}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=deleteActivitiesPlanning()>Sí, eliminar actividad</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Está a punto de eliminar la formación \"{{subjectName}}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=deleteActivitiesTeacher()>Sí, eliminar formación</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=firstTimeVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <p>¿Desea que el sistema cargue su planeación anterior?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=firstTimeVm.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=firstTimeVm.getPreviusPlanning()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EndPlanningModalCtrl = function EndPlanningModalCtrl($scope, $mdDialog, WorkPlanModalSrv, WorkPlanSrv, ModalSrv, GlobalConfig, $state, GlobalSrv, $cookies, $sessionStorage) {
		_classCallCheck(this, EndPlanningModalCtrl);
	
		var headData = WorkPlanModalSrv.getVariable();
		var teacherId = headData.teacherId;
		var workplanId = headData.workplanId;
		var userId = headData.userId;
		var stageId = headData.stageId;
		var integralEvaluationURL = GlobalConfig.externalURLs.integralEvaluationURL;
	
		var planningFinish = false;
		var executionFinish = false;
		var currentUser = JSON.parse($cookies.get('currentUser'));
	
		$scope.data = headData.data;
		$scope.totalHours = headData.totalHours;
		$scope.totalHoursExecution = headData.totalHoursExecution;
		$scope.minHours = headData.minHours;
		$scope.maxHours = headData.maxHours;
		$scope.isMinHoursPlanning = headData.isMinHoursPlanning;
		$scope.isMaxHoursPlanning = headData.isMaxHoursPlanning;
		$scope.isMinHoursExecuted = headData.isMinHoursExecuted;
		$scope.isMaxHoursExecuted = headData.isMaxHoursExecuted;
		$scope.isExistActiWitOutHourExecuted = headData.isExistActiWitOutHourExecuted;
		$scope.close = close;
		$scope.endPlanning = endPlanning;
		$scope.stageId = stageId;
		$scope.planning = GlobalConfig.workplanIdStages.planning;
		$scope.isPlanning = headData.isPlanning;
		$scope.classPlanning = $scope.isPlanning ? 'col-md-12' : 'col-md-6';
		$scope.stageName = $scope.isPlanning ? GlobalConfig.workplanStagesNames.planning : GlobalConfig.workplanStagesNames.execution;
		$scope.stageNameText = $scope.isPlanning ? GlobalConfig.workplanStagesNames.planningText : GlobalConfig.workplanStagesNames.executionText;
	
		function close() {
			// if ($scope.isPlanning) {
			//   WorkPlanModalSrv.setVariable(planningFinish)
			// } else { WorkPlanModalSrv.setVariable(executionFinish) }
			return $mdDialog.hide();
		}
	
		function endPlanning(event) {
			var header = {
				workplanId: workplanId,
				teacherId: teacherId,
				stageId: stageId,
				userId: userId,
				feedback: headData.feedback
			};
	
			if (!$scope.isPlanning) {
				endExecution(header);
			}
	
			showModalHoursParametrization(headData, $scope.isPlanning);
		}
	
		function showModalHoursParametrization(header, isPlanning) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.data = header;
					$scope.integralEvaluationURL = integralEvaluationURL;
					$scope.close = function () {
						if (isPlanning) {
							if (header.isMinHoursPlanning || header.isMaxHoursPlanning) {
								close();
							} else {
								confirmPlanning(header);
							}
						} else {
							close();
							$state.reload();
						}
					};
				}],
				template: __webpack_require__(436),
				clickOutsideToClose: false
			});
		}
	
		function confirmPlanning(header) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function confirmPlanning($scope, $mdDialog) {
					$scope.continue = function () {
						$sessionStorage.workPlanGeneralList.wokplanTeacherStatus[0].planningFinish = 1;
	
						return WorkPlanSrv.endPlanning.post(header).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								planningFinish = true;
								getNotify(header.feedback);
								$state.reload();
								close();
							}
						});
					};
					$scope.close = function () {
						close();
						$state.reload();
					};
				}],
				template: __webpack_require__(749),
				clickOutsideToClose: false
			});
		}
	
		function getNotify(feedback) {
			//SE NOTIFICA A REVISORES Y EVALUADORES
			var reviewers = GlobalSrv.getReviewersAndEvaluator();
	
			reviewers.forEach(function (reviewer) {
				getSendNotify(reviewer, feedback);
			});
		}
	
		function getNotifyFeeback(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, retroalimentacíón finalizada',
				dsDescription: 'El profesor ' + currentUser.dsFullname + ' ha ajustado su planeación',
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
		}
	
		function getNotifyMinHours(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, horas minimas planeadas',
				dsDescription: 'El profesor ' + currentUser.dsFullname + ' finalizó su plan de trabajo con un número menor de horas a las requeridas',
				idNotification_delivery_type: notificationType,
				is_grouped: 1
			};
		}
	
		function getNotifyMaxHours(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, horas máximas planeadas',
				dsDescription: 'El profesor ' + currentUser.dsFullname + ' finalizó la planeación de su plan de trabajo con un número mayor de horas a las requeridas',
				idNotification_delivery_type: notificationType,
				is_grouped: 1
			};
		}
	
		function getNotifyEndPlanning(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, planeación finalizada',
				dsDescription: 'El profesor ' + currentUser.dsFullname + ' ha finalizado la planeación',
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
		}
	
		function getNotifyEndExecution(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, ejecución finalizada',
				dsDescription: 'El profesor ' + currentUser.dsFullname + ' ha finalizado la ejecución',
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
		}
	
		function getNotifyHoursExecution(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, limites horas',
				dsDescription: 'El profesor ' + currentUser.dsFullname + ' finalizo su ejecución con un número de horas ' + headData.totalHoursExecution + ' las cuales son inferiores o superan las horas requeridas.',
				idNotification_delivery_type: notificationType,
				is_grouped: 1
			};
		}
	
		function getSendNotify(idUser, feedback) {
			if ($scope.isPlanning) {
				if (planningFinish) {
					GlobalSrv.sendNotification(getNotifyEndPlanning(idUser, GlobalConfig.notificationType.email));
					GlobalSrv.sendNotification(getNotifyEndPlanning(idUser, GlobalConfig.notificationType.inbox));
				}
	
				if (feedback) {
					GlobalSrv.sendNotification(getNotifyFeeback(idUser, GlobalConfig.notificationType.email));
					GlobalSrv.sendNotification(getNotifyFeeback(idUser, GlobalConfig.notificationType.inbox));
				}
	
				if (headData.minHours > headData.totalHours) {
					GlobalSrv.sendNotification(getNotifyMinHours(idUser, GlobalConfig.notificationType.email));
					GlobalSrv.sendNotification(getNotifyMinHours(idUser, GlobalConfig.notificationType.inbox));
				} else if (headData.totalHours > headData.maxHours) {
					GlobalSrv.sendNotification(getNotifyMaxHours(idUser, GlobalConfig.notificationType.email));
					GlobalSrv.sendNotification(getNotifyMaxHours(idUser, GlobalConfig.notificationType.inbox));
				}
			} else {
				if (headData.minHours > headData.totalHoursExecution || headData.maxHours < headData.totalHoursExecution) {
					GlobalSrv.sendNotification(getNotifyHoursExecution(idUser, GlobalConfig.notificationType.email));
					GlobalSrv.sendNotification(getNotifyHoursExecution(idUser, GlobalConfig.notificationType.inbox));
				}
	
				if (executionFinish) {
					GlobalSrv.sendNotification(getNotifyEndExecution(idUser, GlobalConfig.notificationType.inbox));
					GlobalSrv.sendNotification(getNotifyEndExecution(idUser, GlobalConfig.notificationType.email));
				}
			}
		}
	
		function endExecution(header) {
			WorkPlanSrv.endPlanning.post(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					executionFinish = true;
					GlobalSrv.sendNotification(getNotifyEndExecution(header.userId, GlobalConfig.notificationType.inbox));
					GlobalSrv.sendNotification(getNotifyEndExecution(header.userId, GlobalConfig.notificationType.email));
					getNotify(0);
				}
			});
		}
	};
	
	exports.default = EndPlanningModalCtrl;
	
	
	EndPlanningModalCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanModalSrv', 'WorkPlanSrv', 'ModalSrv', 'GlobalConfig', '$state', 'GlobalSrv', '$cookies', '$sessionStorage'];

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Si finaliza planeación, no podra modificar más su planeación ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=continue()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IndicatorsCtrl = function IndicatorsCtrl($scope, $timeout, $stateParams, WorkPlanSrv, GlobalConfig, WorkPlanIndicatorSrv, $cookies, $rootScope, $interval) {
	  _classCallCheck(this, IndicatorsCtrl);
	
	  var indicatorsVm = this;
	  var teacher = {
	    teacherId: JSON.parse($cookies.get('currentUser')).teacherId
	
	    //declaracion de variables
	  };$rootScope.addchargesAssigned = false;
	  indicatorsVm.type = $stateParams.indicatorType;
	
	  //variables para indicadores de tipo docencia
	  indicatorsVm.percentage = 0;
	  indicatorsVm.asignaturesAssigned = 0;
	  indicatorsVm.totalAsignatures = 0;
	  indicatorsVm.otherActivities = 0;
	  indicatorsVm.hours = 0;
	
	  //variables indicadores para gestión academica
	  indicatorsVm.chargesAssigned = 0;
	  indicatorsVm.totalCharges = 0;
	  indicatorsVm.roles = 0;
	  indicatorsVm.committee = 0;
	
	  //variables indicadores para consolidacion CP
	  indicatorsVm.percentage = 0;
	  indicatorsVm.phd = 0;
	  indicatorsVm.courses = 0;
	  indicatorsVm.communities = 0;
	
	  //variables indicadores para investigacion
	  indicatorsVm.pagination = 1;
	  indicatorsVm.projectsFormulated = 0;
	  indicatorsVm.projects = 0;
	  indicatorsVm.products = 0;
	  indicatorsVm.spacesCollaboration = 0;
	  indicatorsVm.researchTraining = 0;
	  indicatorsVm.transferResults = 0;
	
	  //variables indicadores para extension
	  indicatorsVm.projectsExtension = 0;
	  indicatorsVm.visibility = 0;
	  indicatorsVm.adviceConsultancy = 0;
	  indicatorsVm.shortCourses = 0;
	
	  //Función temporal para sumar al agregar cargo por delegación
	  var getChargesAssigned = $interval(function () {
	
	    if ($rootScope.addchargesAssigned) {
	      indicatorsVm.chargesAssigned += 1;
	      $rootScope.addchargesAssigned = false;
	    }
	
	    indicatorsVm.totalAsignatures = $rootScope.totalAsignatures ? $rootScope.totalAsignatures : 0;
	  }, 500);
	
	  // declaracion de variable global y variable compartida para 
	  // actualizar la vista en caso de recibir un aviso
	  indicatorsVm.globalConfig = GlobalConfig.indicatorsType;
	  indicatorsVm.sharedVariable = WorkPlanIndicatorSrv.getVariable();
	
	  indicatorsVm.sharedVariable.reload = function () {
	    indicatorsVm.sharedVariable = WorkPlanIndicatorSrv.getVariable();
	    var recargarIndicador = indicatorsVm.sharedVariable.pop();
	    if (recargarIndicador) {
	      activate();
	      WorkPlanIndicatorSrv.setVariable(false);
	    }
	  };
	
	  //declaracion de funciones
	  activate();
	
	  function activate() {
	    $timeout(function () {
	      getIndicators();
	    }, 10000);
	  }
	
	  // When the teacher has no planned activities in the requested submodule,
	  // _getProgressBySubmodule returns a row with submoduleId = NULL; findIndex
	  // returns -1 and dereferencing [-1].percentage crashes. Keep percentage at
	  // its default 0 in that case so the empty ring still renders.
	  function loadIndicatorsTeaching(datos) {
	
	    if (datos !== []) {
	      var index = datos.asignaturesPlaned.findIndex(function (item, i) {
	        return item.submoduleId === indicatorsVm.globalConfig.teaching;
	      });
	      if (index >= 0) {
	        indicatorsVm.percentage = datos.asignaturesPlaned[index].percentage;
	      }
	      indicatorsVm.asignaturesAssigned = datos.asignaturesAssigned[0].asignaturesAssigned;
	      //indicatorsVm.totalAsignatures    = datos.asignaturesAssigned[0].totalAsignatures
	      indicatorsVm.otherActivities = datos.otherActivities;
	      indicatorsVm.hours = datos.attencionHours ? datos.attencionHours : 0;
	    }
	  }
	
	  function loadIndicatorsAcademicManagement(datos) {
	    if (datos !== []) {
	      var index = datos.asignaturesPlaned.findIndex(function (item, i) {
	        return item.submoduleId === indicatorsVm.globalConfig.academicManagement;
	      });
	      if (index >= 0) {
	        indicatorsVm.percentage = datos.asignaturesPlaned[index].percentage;
	      }
	      indicatorsVm.chargesAssigned = datos.delegationCharges.chargesAssigned;
	      indicatorsVm.totalCharges = datos.delegationCharges.totalCharges;
	      indicatorsVm.otherActivities = datos.otherActivityAM;
	      indicatorsVm.roles = datos.roles;
	      indicatorsVm.committee = datos.committee;
	    }
	  }
	
	  function loadIndicatorsConsolidation(datos) {
	    if (datos !== []) {
	      var index = datos.asignaturesPlaned.findIndex(function (item, i) {
	        return item.submoduleId === indicatorsVm.globalConfig.consolidationCP;
	      });
	      if (index >= 0) {
	        indicatorsVm.percentage = datos.asignaturesPlaned[index].percentage;
	      }
	      indicatorsVm.phd = datos.phd;
	      indicatorsVm.courses = datos.courses;
	      indicatorsVm.communities = datos.communities;
	    }
	  }
	
	  function loadIndicatorsResearch(datos) {
	
	    if (datos !== []) {
	      var index = datos.asignaturesPlaned.findIndex(function (item, i) {
	        return item.submoduleId === indicatorsVm.globalConfig.research;
	      });
	      if (index >= 0) {
	        indicatorsVm.percentage = datos.asignaturesPlaned[index].percentage;
	      }
	      indicatorsVm.projectsFormulated = datos.projectsFormulated;
	      indicatorsVm.projects = datos.projects;
	      indicatorsVm.products = datos.products;
	      indicatorsVm.spacesCollaboration = datos.spacesCollaboration;
	      indicatorsVm.researchTraining = datos.researchTraining;
	      indicatorsVm.transferResults = datos.transferResults;
	    }
	  }
	
	  function loadIndicatorsExtension(datos) {
	
	    if (datos !== []) {
	      var index = datos.asignaturesPlaned.findIndex(function (item, i) {
	        return item.submoduleId === indicatorsVm.globalConfig.extension;
	      });
	      if (index >= 0) {
	        indicatorsVm.percentage = datos.asignaturesPlaned[index].percentage;
	      }
	      indicatorsVm.projectsFormulated = datos.projectsFormulatedExtension;
	      indicatorsVm.projectsExtension = datos.projectsExtension;
	      indicatorsVm.visibility = datos.visibility;
	      indicatorsVm.adviceConsultancy = datos.adviceConsultancy;
	      indicatorsVm.shortCourses = datos.shortCourses;
	    }
	  }
	
	  function getIndicators() {
	    var post = {
	      teacherId: teacher.teacherId,
	      submoduleId: indicatorsVm.type
	    };
	    WorkPlanSrv.getIndicatorBySubmodule.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        var datos = dataReturn.data;
	        //indicadores de Docencia
	        if (indicatorsVm.type === indicatorsVm.globalConfig.teaching) {
	          loadIndicatorsTeaching(datos);
	          //indicadores de Gestion Académica
	        } else if (indicatorsVm.type === indicatorsVm.globalConfig.academicManagement) {
	          loadIndicatorsAcademicManagement(datos);
	          //indicadores de Consolidacion CP
	        } else if (indicatorsVm.type === indicatorsVm.globalConfig.consolidationCP) {
	          loadIndicatorsConsolidation(datos);
	          //indicadores de Investigación
	        } else if (indicatorsVm.type === indicatorsVm.globalConfig.research) {
	          loadIndicatorsResearch(datos);
	          //indicadores de Extension
	        } else if (indicatorsVm.type === indicatorsVm.globalConfig.extension) {
	          loadIndicatorsExtension(datos);
	        }
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	};
	
	exports.default = IndicatorsCtrl;
	
	
	IndicatorsCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'WorkPlanSrv', 'GlobalConfig', 'WorkPlanIndicatorSrv', '$cookies', '$rootScope', '$interval'];

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IndicatorsStartCtrl = function IndicatorsStartCtrl($scope, $timeout, $stateParams, WorkPlanSrv, WorkPlanIndicatorSrv, $cookies) {
	  _classCallCheck(this, IndicatorsStartCtrl);
	
	  var indicatorsVm = this;
	
	  //declaracion de variables
	  indicatorsVm.type = $stateParams.indicatorType;
	
	  //variables para indicadores de tipo docencia
	  indicatorsVm.percentEndPlaning = 0;
	  indicatorsVm.percentReview = 0;
	  indicatorsVm.percentPendingNewReview = 0;
	  indicatorsVm.totalWorkPlans = 0;
	  indicatorsVm.numberEndPlaning = 0;
	  indicatorsVm.numberReview = 0;
	  indicatorsVm.numberPendingNewReview = 0;
	
	  //declaracion de funciones
	  activate();
	
	  function activate() {
	    loadIndicators();
	  }
	
	  function loadIndicators() {
	    var params = {
	      id_user: 1,
	      is_review: 2,
	      is_rejected: null
	    };
	    WorkPlanSrv.getWorkPlansInReview.get(params).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	
	        if (dataReturn.data !== []) {
	          var index = 0;
	          indicatorsVm.percentEndPlaning = 0;
	          indicatorsVm.percentReview = 0;
	          indicatorsVm.percentPendingNewReview = 0;
	          indicatorsVm.totalWorkPlans = 0;
	          indicatorsVm.numberEndPlaning = 0;
	          indicatorsVm.numberReview = 0;
	          indicatorsVm.numberPendingNewReview = 0;
	        }
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	};
	
	exports.default = IndicatorsStartCtrl;
	
	
	IndicatorsStartCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'WorkPlanSrv', 'WorkPlanIndicatorSrv', '$cookies'];

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanReviewPhaseCtrl = function WorkPlanReviewPhaseCtrl($scope, $timeout, $stateParams, WorkPlanSrv, $cookies, $rootScope, $interval) {
	  _classCallCheck(this, WorkPlanReviewPhaseCtrl);
	
	  var workplanReviewVM = this;
	
	  $rootScope.fullscreenClass = 'background-planning';
	  workplanReviewVM.filter = filter;
	  workplanReviewVM.singleFilter = singleFilter;
	
	  // Grid definition
	
	  workplanReviewVM.gridOptions = {
	    enableFiltering: true,
	    columnDefs: [{
	      displayName: 'Nombre Profesor',
	      name: 'Nombre Profesor',
	      field: 'ds_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enableFiltering: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Plan de Trabajo asignado',
	      name: 'Plan de Trabajo asignado',
	      field: 'workplan_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enableFiltering: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Estado',
	      name: 'Estado',
	      field: 'state_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enableFiltering: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: true
	    }, {
	      displayName: 'Acciones',
	      name: 'Acciones',
	      field: 'id_state',
	      width: '25%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enableFiltering: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: __webpack_require__(753)
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      workplanReviewVM.gridApi = gridApi;
	      workplanReviewVM.gridApi.grid.registerRowsProcessor(workplanReviewVM.singleFilter, 200);
	      $interval(function () {
	        workplanReviewVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	
	  function filter() {
	    workplanReviewVM.gridApi.grid.refresh();
	  }
	
	  function singleFilter(renderableRows) {
	    var matcher = new RegExp(workplanReviewVM.workPlanFilter, 'i');
	    renderableRows.forEach(function (row) {
	      var match = false;
	      ['ds_name', 'workplan_name'].forEach(function (field) {
	        if (row.entity[field] && row.entity[field].match(matcher)) {
	          match = true;
	        }
	      });
	      if (!match) {
	        row.visible = false;
	      }
	    });
	    return renderableRows;
	  };
	
	  activate();
	
	  function activate() {
	    //getListItems()
	    workplanReviewVM.gridOptions.data = listJson();
	  }
	
	  function getListItems() {
	    var params = {
	      id_user: JSON.parse($cookies.get('currentUser')),
	      is_review: 2,
	      is_rejected: null
	    };
	    WorkPlanSrv.getWorkPlansInReview.get(params).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        workplanReviewVM.gridOptions.data = dataReturn.data;
	      } else {
	        console.log(dataReturn);
	      }
	    }).catch(function (err) {
	      console.log('Error: ', err);
	    });
	  }
	
	  function listJson() {
	    var dataList = [{
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Alexandra Neira',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }];
	    return dataList;
	  }
	};
	
	exports.default = WorkPlanReviewPhaseCtrl;
	
	
	WorkPlanReviewPhaseCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'WorkPlanSrv', '$cookies', '$rootScope', '$interval'];

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.id_work_plan_state == 3\"> <a ui-sref=\"reviewPhaseVM.setupTeacherActivities({workPlanId: row.entity.id_code})\"> <i class=\"icon mdi-action-settings i-20\" style=padding-right:5px;opacity:1></i> </a> <a ui-sref=\"reviewPhaseVM.setupTeacherActivities({workPlanId: row.entity.id_code})\" style=opacity:.85;text-decoration:underline>Revisar</a> </div> <div ng-if=\"row.entity.id_work_plan_state != 3\"> <a ui-sref=\"reviewPhaseVM.workPlanView({id: row.entity.id_code})\"> <i class=\"icon mdi-action-search i-20\" style=padding-right:5px;opacity:1></i> </a> <a style=opacity:.85;text-decoration:underline ui-sref=\"reviewPhaseVM.workPlanView({id: row.entity.id_code})\">Revisar nuevamente</a> </div> </div>";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanReviewPhaseApprobationCtrl = function WorkPlanReviewPhaseApprobationCtrl($scope, $timeout, $stateParams, WorkPlanSrv, $cookies, $rootScope, $interval) {
	  _classCallCheck(this, WorkPlanReviewPhaseApprobationCtrl);
	
	  var reviewPhaseApprobationVm = this;
	
	  $rootScope.fullscreenClass = 'background-planning';
	
	  // Grid definition    
	  reviewPhaseApprobationVm.gridOptions = {
	    columnDefs: [{
	      displayName: 'Nombre profesor',
	      name: 'Nombre profesor',
	      field: 'ds_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Plan de trabajo asignado',
	      name: 'Plan de trabajo asignado',
	      field: 'workplan_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Estado',
	      name: 'Estado',
	      field: 'state_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: true
	    }, {
	      displayName: 'Acciones',
	      name: 'Acciones',
	      field: 'id_state',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: __webpack_require__(755)
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      reviewPhaseApprobationVm.gridApi = gridApi;
	      reviewPhaseApprobationVm.gridApi.grid.registerRowsProcessor(reviewPhaseApprobationVm.singleFilter, 200);
	      $interval(function () {
	        reviewPhaseApprobationVm.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	
	    // VARIABLES
	  };reviewPhaseApprobationVm.workPlanFilter = '';
	
	  // METHODS
	  reviewPhaseApprobationVm.singleFilter = singleFilter;
	  reviewPhaseApprobationVm.filter = filter;
	
	  function filter() {
	    reviewPhaseApprobationVm.gridApi.grid.refresh();
	  }
	
	  function singleFilter(renderableRows) {
	    var matcher = new RegExp(reviewPhaseApprobationVm.workPlanFilter, 'i');
	    renderableRows.forEach(function (row) {
	      var match = false;
	      ['ds_name', 'workplan_name', 'state_name', 'id_state'].forEach(function (field) {
	        if (row.entity[field].match(matcher)) {
	          match = true;
	        }
	      });
	      if (!match) {
	        row.visible = false;
	      }
	    });
	    return renderableRows;
	  }
	
	  activate();
	
	  function activate() {
	    getListItemsTest();
	  }
	
	  function getListItems() {
	    var params = {
	      id_user: user = JSON.parse($cookies.get('currentUser')),
	      is_review: 2,
	      is_rejected: null
	    };
	    WorkPlanSrv.getWorkPlansInReview.get(params).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        reviewPhaseApprobationVm.gridOptions.data = dataReturn.data;
	      } else {
	        console.log(dataReturn);
	      }
	    }).catch(function (err) {
	      console.log('Error: ', err);
	    });
	  }
	
	  function getListItemsTest() {
	    reviewPhaseApprobationVm.gridOptions.data = [{ ds_name: "Nombre profesor 1", workplan_name: "workplan 1", state_name: "estado 1", id_state: "1" }, { ds_name: "Nombre profesor 2", workplan_name: "workplan 2", state_name: "estado 2", id_state: "2" }];
	  }
	};
	
	exports.default = WorkPlanReviewPhaseApprobationCtrl;
	
	
	WorkPlanReviewPhaseApprobationCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'WorkPlanSrv', '$cookies', '$rootScope', '$interval'];

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.id_work_plan_state == 3\"> <a ui-sref=\"reviewPhaseApprobationVm.setupTeacherActivities({workPlanId: row.entity.id_code})\"> <i class=\"icon mdi-action-settings i-20\" style=padding-right:5px;opacity:1></i> </a> <a ui-sref=\"reviewPhaseApprobationVm.setupTeacherActivities({workPlanId: row.entity.id_code})\" style=opacity:.85;text-decoration:underline>Aprobar</a> </div> <div ng-if=\"row.entity.id_work_plan_state != 3\"> <a ui-sref=\"reviewPhaseApprobationVm.workPlanView({id: row.entity.id_code})\"> <i class=\"icon mdi-action-search i-20\" style=padding-right:5px;opacity:1></i> </a> <a style=opacity:.85;text-decoration:underline ui-sref=\"reviewPhaseApprobationVm.workPlanView({id: row.entity.id_code})\">Aprobar nuevamente</a> </div> </div>";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanReviewExecutionCtrl = function WorkPlanReviewExecutionCtrl($scope, $timeout, $stateParams, WorkPlanSrv, $cookies, $rootScope, $interval) {
	  _classCallCheck(this, WorkPlanReviewExecutionCtrl);
	
	  var workplanReviewVM = this;
	
	  $rootScope.fullscreenClass = 'background-planning';
	  workplanReviewVM.filter = filter;
	  workplanReviewVM.singleFilter = singleFilter;
	
	  // Grid definition
	
	  workplanReviewVM.gridOptions = {
	    enableFiltering: true,
	    columnDefs: [{
	      displayName: 'Nombre Profesor',
	      name: 'Nombre Profesor',
	      field: 'ds_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Plan de Trabajo asignado',
	      name: 'Plan de Trabajo asignado',
	      field: 'workplan_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      displayName: 'Estado',
	      name: 'Estado',
	      field: 'state_name',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: true
	    }, {
	      displayName: 'Acciones',
	      name: 'Acciones',
	      field: 'id_state',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: __webpack_require__(757)
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      workplanReviewVM.gridApi = gridApi;
	      workplanReviewVM.gridApi.grid.registerRowsProcessor(workplanReviewVM.singleFilter, 200);
	      $interval(function () {
	        workplanReviewVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	
	  function filter() {
	    workplanReviewVM.gridApi.grid.refresh();
	  }
	
	  function singleFilter(renderableRows) {
	    var matcher = new RegExp(workplanReviewVM.workPlanFilter, 'i');
	    renderableRows.forEach(function (row) {
	      var match = false;
	      ['ds_name', 'workplan_name'].forEach(function (field) {
	        if (row.entity[field] && row.entity[field].match(matcher)) {
	          match = true;
	        }
	      });
	      if (!match) {
	        row.visible = false;
	      }
	    });
	    return renderableRows;
	  };
	
	  activate();
	
	  function activate() {
	    //getListItems()
	    workplanReviewVM.gridOptions.data = listJson();
	  }
	
	  function getListItems() {
	    var params = {
	      id_user: JSON.parse($cookies.get('currentUser')),
	      is_review: 2,
	      is_rejected: null
	    };
	    WorkPlanSrv.getWorkPlansInReview.get(params).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        workplanReviewVM.gridOptions.data = dataReturn.data;
	      } else {
	        console.log(dataReturn);
	      }
	    }).catch(function (err) {
	      console.log('Error: ', err);
	    });
	  }
	
	  function listJson() {
	    var dataList = [{
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Alexandra Neira',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }, {
	      ds_name: 'Enrique Diaz',
	      workplan_name: 'Plan de trabajo A 2017',
	      state_name: 'Planeacion Terminada',
	      id_state: 1
	    }];
	    return dataList;
	  }
	};
	
	exports.default = WorkPlanReviewExecutionCtrl;
	
	
	WorkPlanReviewExecutionCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'WorkPlanSrv', '$cookies', '$rootScope', '$interval'];

/***/ }),
/* 757 */
283,
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkPlanPhaseExecutionCtrl = function WorkPlanPhaseExecutionCtrl($scope, $rootScope, WorkPlanSrv, $mdDialog, $cookieStore, $sessionStorage) {
	  _classCallCheck(this, WorkPlanPhaseExecutionCtrl);
	
	  var workPlanPhaseExecutionVm = this;
	  $rootScope.fullscreenClass = 'background-planning';
	  workPlanPhaseExecutionVm.showModalMessages = showModalMessages;
	  workPlanPhaseExecutionVm.messagesList = [];
	  workPlanPhaseExecutionVm.userId = 0;
	  workPlanPhaseExecutionVm.teacherId = 0;
	  workPlanPhaseExecutionVm.radioGreen = "#04B404";
	  workPlanPhaseExecutionVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  workPlanPhaseExecutionVm.$sessionStorage = $sessionStorage;
	
	  workPlanPhaseExecutionVm.assignStyles = function () {
	    switch (workPlanPhaseExecutionVm.timeline) {
	      case "Planeación":
	        workPlanPhaseExecutionVm.classRadioGreenPlaneation = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classBarGreen = { width: "60px" };
	        break;
	      case "Aprobación":
	        workPlanPhaseExecutionVm.classRadioGreenPlaneation = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classRadioGreenApproval = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classBarGreen = { width: "150px" };
	        break;
	      case "Ejecución":
	        workPlanPhaseExecutionVm.classRadioGreenPlaneation = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classRadioGreenApproval = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classRadioGreenExecution = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classBarGreen = { width: "240px" };
	        break;
	      case "Evaluación":
	        workPlanPhaseExecutionVm.classRadioGreenPlaneation = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classRadioGreenApproval = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classRadioGreenExecution = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classRadioGreenEvaluation = { backgroundColor: workPlanPhaseExecutionVm.radioGreen };
	        workPlanPhaseExecutionVm.classBarGreen = { width: "350px" };
	        break;
	      default:
	    }
	  };
	
	  activate();
	
	  function activate() {
	    workPlanPhaseExecutionVm.userId = $cookieStore.get("currentUser").id;
	    workPlanPhaseExecutionVm.teacherId = $cookieStore.get("currentUser").teacherId;
	    getElements();
	    getMessages();
	  }
	
	  function getElements() {
	    if (workPlanPhaseExecutionVm.workPlanGeneralList == undefined) {
	      // Right Bar
	      WorkPlanSrv.getElementsRightBar.getList({ teacherId: workPlanPhaseExecutionVm.teacherId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status == true) {
	          var index = 0;
	          workPlanPhaseExecutionVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	          workPlanPhaseExecutionVm.RightBar = dataReturn.data;
	          console.log(workPlanPhaseExecutionVm.RightBar);
	          workPlanPhaseExecutionVm.percentage = workPlanPhaseExecutionVm.RightBar.asignaturesPlaned[index].percentage;
	          workPlanPhaseExecutionVm.timeline = workPlanPhaseExecutionVm.RightBar.timeline[index].stage;
	          workPlanPhaseExecutionVm.assignStyles();
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    } else {
	      var index = 0;
	      workPlanPhaseExecutionVm.RightBar = workPlanPhaseExecutionVm.workPlanGeneralList;
	      console.log(workPlanPhaseExecutionVm.RightBar);
	      workPlanPhaseExecutionVm.percentage = workPlanPhaseExecutionVm.RightBar.asignaturesPlaned[index].percentage;
	      workPlanPhaseExecutionVm.timeline = workPlanPhaseExecutionVm.RightBar.timeline[index].stage;
	      workPlanPhaseExecutionVm.assignStyles();
	    }
	  }
	
	  function getMessages() {
	    WorkPlanSrv.getMessages.get({ userId: workPlanPhaseExecutionVm.userId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        workPlanPhaseExecutionVm.messagesList = dataReturn.data;
	      } else {
	        workPlanPhaseExecutionVm.messagesList = [];
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function showModalMessages() {
	    var userId = workPlanPhaseExecutionVm.userId;
	    var messagesList = workPlanPhaseExecutionVm.messagesList;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function showModalMessages($scope, $mdDialog) {
	        var modalMessagesVm = this;
	
	        //declaracion de variables
	        modalMessagesVm.userId = userId;
	        modalMessagesVm.messagesList = messagesList;
	        modalMessagesVm.class1 = "mdi-hardware-keyboard-arrow-down";
	        modalMessagesVm.class2 = "mdi-hardware-keyboard-arrow-up";
	        modalMessagesVm.classRead = "mdi-content-drafts";
	        modalMessagesVm.classUnRead = "mdi-content-mail";
	
	        //declaracion de funciones
	        modalMessagesVm.showMessage = showMessage;
	        modalMessagesVm.close = close;
	
	        activate();
	        function activate() {
	          //updateReadMessage()
	        }
	
	        function showMessage(pos) {
	          if (modalMessagesVm.messagesList[pos].isHiden) {
	            modalMessagesVm.messagesList[pos].isHiden = false;
	          } else {
	            modalMessagesVm.messagesList[pos].isHiden = true;
	          }
	          //si el mensaje esta leido se muestra un ojo justo al lado de la flecha que muestra el mensaje.
	          //en caso contrario no muestra nada
	          if (modalMessagesVm.messagesList[pos].isRead == 0) {
	            updateReadMessage();
	          }
	        }
	
	        function updateReadMessage() {
	          WorkPlanSrv.updateReadingMessages.update({
	            userId: modalMessagesVm.userId
	          }).$promise.then(function (dataReturn) {
	            console.log(dataReturn);
	            if (dataReturn.status) {
	              for (var i = modalMessagesVm.messagesList.length - 1; i >= 0; i--) {
	                modalMessagesVm.messagesList[i].isRead = 1;
	              }
	            } else {
	              console.log('error de comunicacion con el servidor');
	            }
	          }, function (data) {
	            console.log(data);
	          });
	        }
	
	        function close() {
	          $mdDialog.hide();
	        }
	      }],
	      template: __webpack_require__(759),
	      controllerAs: 'modalMessagesWorkPlanPhaseExecutionVm',
	      clickOutsideToClose: false
	    });
	  }
	};
	
	exports.default = WorkPlanPhaseExecutionCtrl;
	
	
	WorkPlanPhaseExecutionCtrl.$inject = ['$scope', '$rootScope', 'WorkPlanSrv', '$mdDialog', '$cookieStore', '$sessionStorage'];

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog style=width:560px> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=modalMessagesWorkPlanPhaseExecutionVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h4 class=\"text-azul font-bold text-md\">Mensajes </h4></div> <div ng-repeat=\"message in modalMessagesWorkPlanPhaseExecutionVm.messagesList\"> <div class=\"col-md-12 p-v-xs no-padding-h b-b-gris-light\"> <h5 class=\"text-negro font-bold col-md-8 font-test\">{{message.title}}</h5> <div class=col-md-2 ng-if=\"message.isRead == 1\"> <span ng-class=modalMessagesWorkPlanPhaseExecutionVm.classRead class=\"icon i-28 text-gris-dark pointer text-right\" ng-click=modalMessagesWorkPlanPhaseExecutionVm.showMessage($index)></span> </div> <div class=col-md-2 ng-if=\"!(message.isRead == 1)\"> <span ng-class=modalMessagesWorkPlanPhaseExecutionVm.classUnRead class=\"icon i-28 text-gris-dark pointer text-right\" ng-click=modalMessagesWorkPlanPhaseExecutionVm.showMessage($index)></span> </div> <div class=col-md-2 ng-if=message.isHiden> <span ng-class=modalMessagesWorkPlanPhaseExecutionVm.class1 class=\"icon i-28 text-gris-dark pointer text-left\" ng-click=modalMessagesWorkPlanPhaseExecutionVm.showMessage($index)></span> </div> <div class=col-md-2 ng-if=!message.isHiden> <span ng-class=modalMessagesWorkPlanPhaseExecutionVm.class2 class=\"icon i-28 text-gris-dark pointer text-left\" ng-click=modalMessagesWorkPlanPhaseExecutionVm.showMessage($index)></span> </div> <div class=col-md-12 ng-if=!message.isHiden> <div class=\"col-md-9 no-padding font-test text-gris-dark text-xs\"> {{message.body}} </div> </div> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WorkplanEvaluationCtrl = function WorkplanEvaluationCtrl($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, ReviewSrv, $rootScope, uiGridConstants, uiGridExporterConstants, $interval, $mdDialog) {
	  _classCallCheck(this, WorkplanEvaluationCtrl);
	
	  // Constants
	  var workplanEvaluationVM = this;
	  var stagesIds = GlobalConfig.workplanIdStages;
	  var evaluationIndicatorIds = {
	    evaluated: 5,
	    forEvaluating: 6,
	    specialSituations: 7,
	    withAdjustments: 8
	  };
	  $rootScope.fullscreenClass = 'background-planning';
	
	  // Grid definition
	  workplanEvaluationVM.gridOptionsSpecialSituations = {
	    columnDefs: [{
	      name: 'Nombre del profesor',
	      displayName: 'Nombre del profesor',
	      field: 'teacherName',
	      width: '30%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Nota',
	      displayName: 'Nota',
	      field: 'ds_description',
	      width: '50%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      field: 'actionText',
	      width: '18%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      workplanEvaluationVM.gridApi = gridApi;
	      workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
	      $interval(function () {
	        workplanEvaluationVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	  workplanEvaluationVM.gridOptionsEvaluated = {
	    columnDefs: [{
	      name: 'Nombre del profesor',
	      displayName: 'Nombre del profesor',
	      field: 'teacherName',
	      width: '30%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Calificación',
	      displayName: 'Calificación',
	      field: 'nm_rating',
	      width: '40%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      field: 'actionText',
	      width: '25%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      workplanEvaluationVM.gridApi = gridApi;
	      workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
	      $interval(function () {
	        workplanEvaluationVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	  workplanEvaluationVM.gridOptionsAdjustments = {
	    columnDefs: [{
	      name: 'Nombre del profesor',
	      displayName: 'Nombre del profesor',
	      field: 'teacherName',
	      width: '60%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      field: 'actionText',
	      width: '15%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      workplanEvaluationVM.gridApi = gridApi;
	      workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
	      $interval(function () {
	        workplanEvaluationVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	  workplanEvaluationVM.gridOptionsForEvaluating = {
	    columnDefs: [{
	      name: 'Nombre del profesor',
	      displayName: 'Nombre del profesor',
	      field: 'teacherName',
	      width: '30%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Horas Planeadas',
	      displayName: 'H/Planeadas',
	      field: 'nm_plannedHours',
	      width: '13%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Horas Ejecutadas',
	      displayName: 'H/Ejecutadas',
	      field: 'nm_workedHours',
	      width: '13%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Actividades Planeadas',
	      displayName: 'Act/Planeadas',
	      field: 'nm_plannedActivities',
	      width: '13%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Actividades Ejecutadas',
	      displayName: 'Act/Ejecutadas',
	      field: 'nm_workedActivities',
	      width: '13%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      field: 'actionText',
	      width: '14%',
	      enableGridMenu: false,
	      enableFiltering: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      workplanEvaluationVM.gridApi = gridApi;
	      workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
	      $interval(function () {
	        workplanEvaluationVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	  workplanEvaluationVM.gridOptionsDefault = {
	    columnDefs: [{
	      name: 'Nombre profesor',
	      displayName: 'Nombre profesor',
	      field: 'teacherName',
	      width: '25%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Plan de trabajo asignado',
	      displayName: 'Plan de trabajo asignado',
	      field: 'workplanName',
	      width: '30%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Estado',
	      displayName: 'Estado',
	      field: 'stageName',
	      width: '30%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false
	    }, {
	      name: 'Acciones',
	      displayName: 'Acciones',
	      field: 'actionText',
	      width: '15%',
	      enableGridMenu: false,
	      enableHiding: false,
	      enablePinning: false,
	      enableColumnMenu: false,
	      enableSorting: false,
	      headerCellClass: 'column-center',
	      cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      workplanEvaluationVM.gridApi = gridApi;
	      workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
	      $interval(function () {
	        workplanEvaluationVM.gridApi.core.handleWindowResize();
	      }, 500, 10);
	    }
	  };
	
	  workplanEvaluationVM.workPlanFilter = '';
	  workplanEvaluationVM.isActiveDefaultGrid = false;
	  workplanEvaluationVM.isActiveSpecialSituations = false;
	  workplanEvaluationVM.isActiveEvaluated = false;
	  workplanEvaluationVM.isActiveAdjustments = false;
	  workplanEvaluationVM.isActiveForEvaluating = false;
	
	  //indicator parameters
	  workplanEvaluationVM.numberActualIndicator = '0';
	  workplanEvaluationVM.numberTotalIndicator = '0';
	  workplanEvaluationVM.numberPercentIndicator = '0';
	
	  // Method definitions
	  workplanEvaluationVM.filter = filter;
	  workplanEvaluationVM.activePlans = activePlans;
	  workplanEvaluationVM.singleFilter = singleFilter;
	  workplanEvaluationVM.exportGrid = exportGrid;
	
	  // Initialization
	  activate();
	
	  function filter() {
	    workplanEvaluationVM.gridApi.grid.refresh();
	  }
	  function activate() {
	    workplanEvaluationVM.isActiveDefaultGrid = true;
	    getListItems('default');
	  }
	
	  function getListItems(activeType) {
	    var localHeader = {
	      idRol: JSON.parse($cookies.get('hasRoleId')),
	      idEvaluator: JSON.parse($cookies.get('currentUser')).id,
	      idStage: stagesIds.evaluation,
	      idIndicatorType: setTypeIndicator(activeType)
	    };
	
	    console.log(localHeader);
	
	    ReviewSrv.getIndicatorsForWorkplanEvaluationByIndicator.post(localHeader).$promise.then(function (dataReturn) {
	      if (dataReturn.status === true) {
	        console.log('indicador' + dataReturn.data);
	        workplanEvaluationVM.numberPercentIndicator = dataReturn.data[0].nm_percentage;
	        workplanEvaluationVM.numberActualIndicator = dataReturn.data[0].nm_fraction;
	        workplanEvaluationVM.numberTotalIndicator = dataReturn.data[0].nm_total;
	      } else {
	        console.log('sin datos');
	        console.log(dataReturn);
	      }
	    });
	
	    //GET DATA FOR GRID
	    switch (activeType) {
	      case 'specialSituations':
	        ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then(function (dataReturn) {
	          if (dataReturn.status === true) {
	            workplanEvaluationVM.gridOptionsSpecialSituations.data = dataReturn.data;
	          } else {
	            console.log(dataReturn);
	          }
	        });
	        break;
	      case 'evaluated':
	        ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then(function (dataReturn) {
	          if (dataReturn.status === true) {
	            workplanEvaluationVM.gridOptionsEvaluated.data = dataReturn.data;
	          } else {
	            console.log(dataReturn);
	          }
	        });
	        break;
	      case 'adjustments':
	        ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then(function (dataReturn) {
	          if (dataReturn.status === true) {
	            workplanEvaluationVM.gridOptionsAdjustments.data = dataReturn.data;
	          } else {
	            console.log(dataReturn);
	          }
	        });
	        break;
	      case 'forEvaluating':
	        ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then(function (dataReturn) {
	          if (dataReturn.status === true) {
	            workplanEvaluationVM.gridOptionsForEvaluating.data = dataReturn.data;
	          } else {
	            console.log(dataReturn);
	          }
	        });
	        break;
	      case 'default':
	        ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then(function (dataReturn) {
	          console.log('datos de plan default', dataReturn);
	          if (dataReturn.status) {
	            console.log('datos de plan default', dataReturn.data);
	            workplanEvaluationVM.gridOptionsDefault.data = dataReturn.data;
	            workplanEvaluationVM.gridApi.grid.refresh();
	          }
	        }).catch(function (err) {
	          console.log(err);
	        });
	        break;
	    }
	  }
	
	  function setTypeIndicator(activeType) {
	    switch (activeType) {
	      case 'specialSituations':
	        return evaluationIndicatorIds.specialSituations;
	      case 'evaluated':
	        return evaluationIndicatorIds.evaluated;
	      case 'adjustments':
	        return evaluationIndicatorIds.withAdjustments;
	      case 'forEvaluating':
	        return evaluationIndicatorIds.forEvaluating;
	      default:
	        console.log('no implementado');
	        return 0;
	    }
	  }
	
	  function activePlans(activeType) {
	    //console.log(activeType);
	
	    workplanEvaluationVM.isActiveSpecialSituations = false;
	    workplanEvaluationVM.isActiveEvaluated = false;
	    workplanEvaluationVM.isActiveAdjustments = false;
	    workplanEvaluationVM.isActiveForEvaluating = false;
	    workplanEvaluationVM.isActiveDefaultGrid = false;
	
	    switch (activeType) {
	      case 'specialSituations':
	        workplanEvaluationVM.isActiveSpecialSituations = true;break;
	      case 'evaluated':
	        workplanEvaluationVM.isActiveEvaluated = true;break;
	      case 'adjustments':
	        workplanEvaluationVM.isActiveAdjustments = true;break;
	      case 'forEvaluating':
	        workplanEvaluationVM.isActiveForEvaluating = true;break;
	      default:
	        workplanEvaluationVM.isActiveDefaultGrid = true;break;
	        console.log('no implementado');
	    }
	
	    getListItems(activeType);
	  }
	
	  function singleFilter(renderableRows) {
	    console.log('pasa por single filter');
	    var matcher = new RegExp(workplanEvaluationVM.workPlanFilter, 'i');
	    renderableRows.forEach(function (row) {
	      var match = false;
	
	      if (workplanEvaluationVM.isActiveSpecialSituations) {
	        ['teacherName', 'ds_description'].forEach(function (field) {
	          if (row.entity[field] && row.entity[field].match(matcher)) {
	            match = true;
	          }
	        });
	      } else if (workplanEvaluationVM.isActiveEvaluated) {
	        ['teacherName'].forEach(function (field) {
	          if (row.entity[field] && row.entity[field].match(matcher)) {
	            match = true;
	          }
	        });
	      } else if (workplanEvaluationVM.isActiveAdjustments) {
	        ['teacherName'].forEach(function (field) {
	          if (row.entity[field] && row.entity[field].match(matcher)) {
	            match = true;
	          }
	        });
	      } else if (workplanEvaluationVM.isActiveForEvaluating) {
	        ['teacherName'].forEach(function (field) {
	          if (row.entity[field] && row.entity[field].match(matcher)) {
	            match = true;
	          }
	        });
	      } else if (workplanEvaluationVM.isActiveDefaultGrid) {
	        ['teacherName'].forEach(function (field) {
	          if (row.entity[field] && row.entity[field].match(matcher)) {
	            match = true;
	          }
	        });
	      }
	      if (!match) {
	        row.visible = false;
	      }
	    });
	    return renderableRows;
	  }
	
	  function exportGrid(activeType) {
	    var myElement = angular.element(document.querySelectorAll("." + activeType + "-export"));
	    //console.log(myElement);
	    workplanEvaluationVM.gridApi.exporter.csvExport(uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE, myElement);
	  }
	};
	
	exports.default = WorkplanEvaluationCtrl;
	
	
	WorkplanEvaluationCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', 'ReviewSrv', '$rootScope', 'uiGridConstants', 'uiGridExporterConstants', '$interval', '$mdDialog'];

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ChargesListCtrl = function () {
	  function ChargesListCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, Requests, $filter, $rootScope, WorkPlanIndicatorSrv, $sessionStorage) {
	    _classCallCheck(this, ChargesListCtrl);
	
	    var chargesListVm = this;
	    var _timeout;
	    var listuser = JSON.parse($cookies.get('currentUser'));
	    var active = GlobalConfig.generals.active;
	
	    chargesListVm.charges = [];
	    chargesListVm.viewLoaded = false;
	
	    chargesListVm.planningFinish = true;
	    chargesListVm.idCharge = 0;
	    chargesListVm.feedback = 0;
	    chargesListVm.sr = '';
	    chargesListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory;
	    chargesListVm.imgEmpty = __webpack_require__(445);
	
	    chargesListVm.updateView = updateView;
	    chargesListVm.backgroundGrad = backgroundGrad;
	    chargesListVm.editObs = editObs;
	    chargesListVm.changeColorBall = changeColorBall;
	    chargesListVm.getcreatedOrEdit = getcreatedOrEdit;
	    chargesListVm.getGeneralsWorkplan = getGeneralsWorkplan;
	    chargesListVm.validateSearch = validateSearch;
	    chargesListVm.bitacora = bitacora;
	    chargesListVm.dt_start = $cookies.get('wp_start');
	    chargesListVm.dt_end = $cookies.get('wp_end');
	    chargesListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	    chargesListVm.$sessionStorage = $sessionStorage;
	
	    function validateSearch() {
	      return $filter('filter')(chargesListVm.charges, chargesListVm.search);
	    }
	
	    activate();
	
	    function updateView() {
	      chargesListVm.viewLoaded = false;
	      if (_timeout) {
	        //if there is already a timeout in process cancel it
	        $timeout.cancel(_timeout);
	      }
	      _timeout = $timeout(function () {
	        chargesListVm.viewLoaded = true;
	        _timeout = null;
	      }, 1);
	    }
	
	    function backgroundGrad(index) {
	      var result = 'grad-oblique-';
	      chargesListVm.ind = index % 4;
	
	      switch (index % 4) {
	        case 0:
	          return result + 'negro-dark';
	        case 1:
	          return result + 'azul';
	        case 2:
	          return result + 'teal';
	        case 3:
	          return result + 'deep-orange';
	        default:
	          return result + 'negro-dark';
	      }
	    }
	
	    function activate() {
	
	      chargesListVm.isFeedback = listuser.isFeedback;
	      var post = {
	        teacherId: listuser.teacherId,
	        wp_start: chargesListVm.dt_start,
	        wp_end: chargesListVm.dt_end
	      };
	
	      if (chargesListVm.workPlanGeneralList != undefined) {
	        chargesListVm.status = chargesListVm.workPlanGeneralList.wokplanTeacherStatus[0];
	        chargesListVm.stages = chargesListVm.workPlanGeneralList.stages;
	        chargesListVm.feedback = chargesListVm.status.feedbackReviewed;
	        chargesListVm.workplanTeacherId = chargesListVm.status.workplanTeacherId;
	        isPlanning(chargesListVm.status, chargesListVm.stages);
	
	        if (chargesListVm.feedback && !chargesListVm.planningFinish) {
	          getDelegationChargesReject(post);
	        } else {
	          getDelegationCharges(post);
	        }
	      } else {
	        getGeneralsWorkplan(post).then(function (promise) {
	          if (chargesListVm.feedback && !chargesListVm.planningFinish) {
	            getDelegationChargesReject(post);
	          } else {
	            getDelegationCharges(post);
	          }
	        });
	      }
	    }
	
	    function getDelegationCharges(post) {
	      WorkPlanSrv.getDelegationCharges.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn.data);
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getDelegationChargesReject(post) {
	      WorkPlanSrv.getDelegationChargesReject.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn.data);
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function loadData(data) {
	      chargesListVm.charges = data.map(function (chargeList) {
	        chargeList.idCharge = chargesListVm.idCharge;
	        chargesListVm.idCharge++;
	        return chargeList;
	      });
	      console.log(chargesListVm.charges);
	      for (var i = chargesListVm.charges.length - 1; i >= 0; i--) {
	        //chargesListVm.charges[i].chargeDateStart = moment(chargesListVm.charges[i].chargeDateStart).format('DD/MM/YYYY')
	        if (chargesListVm.charges[i].chargeObservation == null || chargesListVm.charges[i].chargeObservation == '') {
	          chargesListVm.charges[i].chargeObservation = GlobalConfig.charges.emptyDescriptionMessage;
	        }
	        if (chargesListVm.charges[i].hoursPlanned == null) {
	          chargesListVm.charges[i].hoursPlanned = 0;
	        }
	      }
	      updateView();
	    }
	
	    function editObs(charge) {
	      var editCharge = charge;
	
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	          var editObsVm = this;
	          editObsVm.per = editCharge.percentageDedication;
	          editObsVm.obs = editCharge.chargeObservation;
	          editObsVm.validateForm = validateForm;
	          editObsVm.showErrorMessages = showErrorMessages;
	          editObsVm.hasError = hasError;
	          editObsVm.nameButton = editCharge.hoursPlanned > 0 ? 'Modificar' : 'Agregar';
	
	          if (editCharge.chargeObservation == GlobalConfig.charges.emptyDescriptionMessage) {
	            editObsVm.obs = '';
	            editObsVm.per = 0;
	          } else {
	            editObsVm.obs = editCharge.chargeObservation;
	            editObsVm.per = editCharge.percentageDedication;
	          }
	          editObsVm.addActivityPlanningAcademic = addActivityPlanningAcademic;
	
	          editObsVm.close = function () {
	            $mdDialog.hide();
	          };
	
	          function validateForm(form) {
	            return form.$invalid;
	          }
	
	          function showErrorMessages(input) {
	            return input.$dirty || input.$touched;
	          }
	
	          function hasError(input) {
	            if (input.$invalid && (input.$dirty || input.$touched)) {
	              return 'has-error';
	            }
	          }
	
	          function createJson(editCharge) {
	            var post = {
	              teacherId: listuser.teacherId,
	              workplanId: listuser.workplanId,
	              userId: listuser.id,
	              isFeedbackActivity: chargesListVm.isFeedback
	            };
	
	            var assignment = {
	              teacherId: post.teacherId,
	              workplanId: post.workplanId,
	              workplanTeacherChargeId: editCharge.workplanTeacherChargeId,
	              description: editObsVm.obs,
	              percentage: editObsVm.per,
	              userId: post.userId,
	              activityId: 27,
	              wp_start: chargesListVm.dt_start,
	              wp_end: chargesListVm.dt_end,
	              workplanTeacherActivityId: editCharge.workplanTeacherActivityId
	            };
	
	            WorkPlanSrv.addActivityPlanningAcademic.save(assignment).$promise.then(function (dataReturn) {
	              if (dataReturn.status) {
	                WorkPlanIndicatorSrv.setVariable(true);
	                var idx = chargesListVm.charges.indexOf(editCharge);
	
	                if (!assignment.workplanTeacherActivityId) $rootScope.addchargesAssigned = true;
	
	                chargesListVm.charges[idx].hoursPlanned = dataReturn.hours;
	                charge.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	                editObsVm.close();
	              } else {
	                console.log("Comunication problem with server");
	              }
	            });
	          }
	
	          function addActivityPlanningAcademic() {
	            $scope.disablebutton = false;
	            createJson(editCharge);
	            editCharge.percentageDedication = editObsVm.per;
	            editCharge.chargeObservation = editObsVm.obs;
	          }
	        }],
	        controllerAs: "editObsVm",
	        template: __webpack_require__(762),
	        clickOutsideToClose: false
	      });
	    }
	
	    function changeColorBall(charge) {
	      var color = 'gris-darker';
	      if (charge.percentageDedication > 0) color = 'amarillo';
	
	      return color;
	    }
	
	    function getcreatedOrEdit(charge) {
	      if (charge.hoursPlanned > 0) return 'Editar';else return 'Agregar';
	    }
	
	    function getGeneralsWorkplan(post) {
	      return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          chargesListVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	          chargesListVm.status = dataReturn.data.wokplanTeacherStatus[0];
	          chargesListVm.stages = dataReturn.data.stages;
	          chargesListVm.feedback = chargesListVm.status.feedbackReviewed;
	          chargesListVm.workplanTeacherId = chargesListVm.status.workplanTeacherId;
	          isPlanning(chargesListVm.status, chargesListVm.stages);
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function isPlanning(status, stages) {
	      chargesListVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	      for (var i = stages.length - 1; i >= 0; i--) {
	        if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	          chargesListVm.startDateStage = stages[i].startDate;
	        }
	      }
	
	      if (status.workplanActive) {
	        if (status.planningFinish == active) {
	          chargesListVm.planningFinish = true;
	          if (chargesListVm.startDateReview < chargesListVm.currentDate || status.reviewedFinish == active) {
	            chargesListVm.planningFinish = true;
	          } else if (status.reviewedReject == active) {
	            chargesListVm.planningFinish = false;
	          }
	        } else {
	          chargesListVm.planningFinish = false;
	        }
	      } else {
	        chargesListVm.planningFinish = true;
	      }
	
	      $scope.classPlanning = chargesListVm.planningFinish ? "disabled" : " ";
	    }
	
	    function bitacora(ev) {
	      var entries = {};
	
	      entries.params = {
	        activityTypeId: GlobalConfig.activityTypeId.positionsByDelegation,
	        workplanTeacherId: chargesListVm.workplanTeacherId
	      };
	      entries.title = 'Cargos por Delegación';
	      // Entries(this.entries);
	      entries.data = undefined;
	      $mdDialog.show({
	        controller: 'bitacoraModalCtrl',
	        controllerAs: 'bit',
	        template: __webpack_require__(453),
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        locals: { data: entries },
	        clickOutsideToClose: true,
	        fullscreen: true
	      });
	    }
	  } //FIN DEL CONSTRUCTOR
	
	
	  _createClass(ChargesListCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) event.preventDefault();
	      return;
	    }
	  }]);
	
	  return ChargesListCtrl;
	}();
	
	exports.default = ChargesListCtrl;
	
	
	ChargesListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$filter', '$rootScope', 'WorkPlanIndicatorSrv', '$sessionStorage'];

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=editObsVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <form name=changeObs novalidate> <div class=row> <div class=col-md-12 style=margin-bottom:-40px> <h2 class=\"text-center text-azul control-label text-md\">{{editObsVm.nameButton}} planeaci&oacute;n</h2> <p class=text-16-important> Ingrese a continuaci&oacute;n la estimaci&oacute;n del porcentaje de dedicaci&oacute;n a este cargo y describa brevemente las actividades que contempla. Recuerde que en esta dedicaci&oacute;n no se deben contemplar las dem&aacute;s actividades incluidas en su plan de trabajo y que corresponden a su labor como profesor.</p> <div class=\"form-group text-left\" ng-class=editObsVm.hasError(changeObs.obs)> <label for=obs class=\"control-label text-azul\">Observaci&oacute;n</label> <md-input-container class=control-label> <textarea ng-model=editObsVm.obs name=obs maxlength=500 md-maxlength=500 class=form-control rows=4 ng-model-options=\"{ debounce: 300 }\" required>\n              </textarea> <div class=\"col-md-11 no-padding\"> <div class=\"col-md-9 no-padding\"> <div class=control-label ng-messages=changeObs.obs.$error ng-show=editObsVm.showErrorMessages(changeObs.obs)> <div ng-message=required class=text-xs>La observaci&oacute;n es requerida</div> </div> </div> <div class=\"col-md-3 no-padding\"> <div class=\"text-xs text-right text-padd\">Número de caracteres &nbsp;</div> </div> </div> </md-input-container> </div> </div> </div> <div class=row> <div class=col-md-4> <div class=form-group ng-class=editObsVm.hasError(changeObs.porcOcupacion)> <h5 class=\"text-azul text-left control-label\">Porcentaje de dedicaci&#243;n</h5> <input type=number min=1 max=100 name=porcOcupacion ng-model=editObsVm.per class=form-control onkeypress=\"return 47<=event.charCode&&event.charCode<=58\" onpaste=return!1 required/> <div class=control-label ng-messages=changeObs.porcOcupacion.$error ng-show=editObsVm.showErrorMessages(changeObs.porcOcupacion)> <div ng-message=required class=\"text-xs text-left\">El porcentaje de dedicaci&oacute;n es requerido</div> <div ng-message=min class=\"text-xs text-left\">El porcentaje debe ser mayor a 0</div> </div> </div> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=editObsVm.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-disabled=\"editObsVm.validateForm(changeObs)  && disablebutton\" ng-click=editObsVm.addActivityPlanningAcademic()>{{editObsVm.nameButton}}</md-button> </div> </div> </form> </md-dialog-content> </md-dialog>";

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateParticipationCtrl = function () {
	  function CreateParticipationCtrl($scope, $timeout, $mdDialog, $stateParams, $cookies, WorkPlanSrv, GlobalConfig, $state, WorkPlanModalSrv, GlobalSrv) {
	    _classCallCheck(this, CreateParticipationCtrl);
	
	    var participationVm = this;
	    var texts = GlobalConfig.appTexts;
	    participationVm.isEditing = Boolean($stateParams.workplanTeacherActivityId);
	    participationVm.createOrEdit = '';
	    participationVm.start_date = null;
	    participationVm.end_date = null;
	    participationVm.minStartDate = moment().toDate();
	    participationVm.minEndDate = new Date();
	    participationVm.actionEditOrCreate = 'creado';
	    participationVm.createdOrEdit = 'Creación';
	    participationVm.createdOrEditParticipation = 'Crear';
	    participationVm.textCreateOrEdit = texts.saved;
	    participationVm.createOrEditMV = texts.createDialog;
	    participationVm.rangeType = 1;
	    participationVm.range = GlobalConfig.periods.rangeType;
	    participationVm.periodsArray = [];
	    participationVm.listCommitteeCombo = [];
	    participationVm.selectedTypePeriod = {};
	    participationVm.isTouchedPeriods = false;
	    participationVm.detail = '';
	    participationVm.typeUnit = 1;
	    participationVm.listPeriods = [];
	    participationVm.periodArray = [];
	    participationVm.minStartDate = new Date();
	    participationVm.plannedHours = '';
	    participationVm.hoursPlanned = 0;
	    participationVm.dt_start = $cookies.get('wp_start');
	    participationVm.dt_end = $cookies.get('wp_end');
	
	    var listUser = JSON.parse($cookies.get('currentUser'));
	
	    participationVm.isFeedback = listUser.isFeedback;
	
	    participationVm.updateRangeType = function (val) {
	      participationVm.rangeType = val;
	      participationVm.periodsArray = [];
	      participationVm.startDate = null;
	      participationVm.endDate = null;
	    };
	    participationVm.updateRangeData = function (val) {
	      participationVm.periodsArray = val['periods'];
	      participationVm.start_date = val['dates'][0];
	      participationVm.end_date = val['dates'][1];
	    };
	
	    var header = {
	      teacherId: listUser.teacherId,
	      workplanId: listUser.workplanId,
	      workplanTeacherActivityId: $stateParams.workplanTeacherActivityId,
	      name: listUser.name
	    };
	    participationVm.addParticipation = addParticipation;
	    participationVm.validateForm = validateForm;
	    participationVm.funSelectedPeriod = funSelectedPeriod;
	    participationVm.confirmParticipationAction = confirmParticipationAction;
	    participationVm.isPeriodEmpty = isPeriodEmpty;
	    participationVm.hasError = hasError;
	    participationVm.showErrorMessages = showErrorMessages;
	    participationVm.validateCheklistPeriods = validateCheklistPeriods;
	    participationVm.startDateChange = startDateChange;
	    participationVm.close = close;
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function validateForm(form) {
	      return form.$invalid || participationVm.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return participationVm.rangeType == participationVm.range ? participationVm.periodsArray.length < 1 : false;
	    }
	
	    function getDataFormCommittee() {
	      // List Service Committee
	      return WorkPlanSrv.getDataFormCommittee.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          participationVm.listCommitteeCombo = dataReturn.listCommittee.items;
	          participationVm.listPeriods = dataReturn.listPeriods;
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getActivityCommitteeByActivity() {
	      // Edit Committee
	      WorkPlanSrv.getActivityCommitteeByActivity.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.data[0]);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    activate();
	
	    function activate() {
	      getDataFormCommittee().then(function () {
	        if (participationVm.isEditing) {
	          participationVm.createdOrEdit = 'Edición';
	          participationVm.createdOrEditParticipation = 'Editar';
	          participationVm.actionEditOrCreate = 'modificado';
	          participationVm.createOrEditMV = texts.editDialog;
	          participationVm.textCreateOrEdit = texts.modified;
	          getActivityCommitteeByActivity();
	        }
	      });
	    }
	
	    function setValues(committee) {
	      var selectedElement = {
	        idListItem: committee.comiteeId,
	        listItemName: committee.comiteeName,
	        isRequired: 0
	      };
	      participationVm.listCommitteeCombo.push(selectedElement);
	      participationVm.committeeName = committee.comiteeId;
	      participationVm.hoursPlanned = committee.hoursPlanned;
	      participationVm.detail = committee.description;
	      participationVm.rangeType = committee.timeRangeTypeId;
	
	      participationVm.start_date = moment(committee.startDate, 'YYYY-MM-DD').toDate();
	      participationVm.end_date = moment(committee.endDate, 'YYYY-MM-DD').toDate();
	
	      participationVm.periodsArray = [];
	      participationVm.selectedTypePeriod = {};
	
	      if (parseInt(committee.timeRangeTypeId) === GlobalConfig.periods.rangeType) {
	        var splits = committee.periodId.split(',');
	        participationVm.start_date = null;
	        participationVm.end_date = null;
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          participationVm.periodsArray.push(parseInt(valor));
	          participationVm.selectedTypePeriod[valor] = true;
	        }
	      }
	
	      if (committee.startDate) {
	        var startDateNew = moment(committee.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          participationVm.minStartDate = moment(committee.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	      participationVm.isEditing = true;
	    }
	
	    function isPeriodEmpty() {
	      return participationVm.periodArray.length == 0;
	    }
	
	    function getNotify(origin) {
	      getSendNotify(origin);
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El profesor ' + listUser.dsFullname + ' ha registrado una nueva participación de comité en la etapa de planeacion.';
	      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
	        msg = 'El profesor ' + listUser.dsFullname + ' ha registrado una nueva participación de comité en la etapa de ejecución.';
	      }
	      var data = {
	        idTeacher: listUser.teacherId,
	        dsName: 'Notificación, se agregó o editó un comité',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1,
	        submodule: GlobalConfig.modules.academicManagement
	      };
	
	      console.log("--->", data);
	
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data);
	    }
	
	    function addOrEditParticipation(participation) {
	      participationVm.disableSaveButtom = true;
	      WorkPlanSrv.addActivityCommittee.add(participation).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getNotify(participation.origin);
	          confirmParticipationAction();
	        } else {
	          console.log('Comunications problem with server');
	        }
	        participationVm.disableSaveButtom = false;
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function addParticipation(isExecution) {
	      var origin = 1;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var participation = {
	        teacherId: header.teacherId,
	        workplanId: header.workplanId,
	        committeeId: participationVm.committeeName,
	        name: 'HOlA',
	        description: participationVm.detail,
	        hoursPlanning: participationVm.hoursPlanned,
	        userId: header.teacherId,
	        timeRangeTypeId: participationVm.rangeType,
	        activityId: GlobalConfig.minorActivityId.participation,
	        origin: origin,
	        isFeedbackActivity: participationVm.isFeedback
	      };
	
	      if (participationVm.isEditing) {
	        participation.workplanTeacherActivityId = header.workplanTeacherActivityId;
	      }
	
	      if (parseInt(participationVm.rangeType) === participationVm.range) {
	        var arrayPeriod = [];
	        for (var index in participationVm.periodsArray) {
	          var temp = {
	            periodId: participationVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        participation.periods = arrayPeriod;
	      } else {
	        participation.startDate = new Date(participationVm.start_date);
	        participation.endDate = new Date(participationVm.end_date);
	      }
	
	      // Conseguir el nombre del comite en el listado
	      var aux = participationVm.listCommitteeCombo.find(function (comiteName) {
	        return comiteName.idListItem == participation.committeeId;
	      });
	      participation.name = aux.listItemName;
	      addOrEditParticipation(participation);
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!participationVm.periodsArray.includes(period.periodId)) {
	          participationVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = participationVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          participationVm.periodsArray.splice(index, 1);
	        }
	      }
	      participationVm.isTouchedPeriods = true;
	    }
	
	    function confirmParticipationAction() {
	      var name = getActivityNameFromCombo();
	      var header = {
	        createOrEdit: participationVm.createOrEditMV,
	        textCreateOrEdit: participationVm.textCreateOrEdit,
	        itemName: name,
	        nameModal: texts.modalTypeName.comiteeParticipation,
	        modalType: texts.modalTypeId.comiteeParticipation
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getActivityNameFromCombo() {
	      for (var i = 0; i < participationVm.listCommitteeCombo.length; i++) {
	        var row = participationVm.listCommitteeCombo[i];
	        if (row.idListItem == participationVm.committeeName) {
	          return participationVm.listCommitteeCombo[i].listItemName;
	        }
	      }
	    }
	
	    function startDateChange() {
	      var m = moment(participationVm.start_date);
	      participationVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function close() {
	      $mdDialog.hide();
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateParticipationCtrl, [{
	    key: 'rbPlanifications',
	    value: function rbPlanifications(bool) {
	      if (bool) {
	        this.start_date = null;
	        this.end_date = null;
	      } else {
	        this.periodsArray = [];
	        this.selectedTypePeriod = null;
	        this.start_date = null;
	        this.end_date = null;
	      }
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateParticipationCtrl;
	}();
	
	exports.default = CreateParticipationCtrl;
	
	
	CreateParticipationCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', '$cookies', 'WorkPlanSrv', 'GlobalConfig', '$state', 'WorkPlanModalSrv', 'GlobalSrv'];

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ParticipationListCtrl = function ParticipationListCtrl($scope, $timeout, WorkPlanSrv, $mdDialog, $cookies, $stateParams, WorkPlanModalSrv, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, ParticipationListCtrl);
	
	  var participationListVm = this;
	  participationListVm.mainLabel = 'Participación en comités';
	  participationListVm.gradRoleClass = 'grad-4';
	  participationListVm.participationList = [];
	  participationListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  participationListVm.$sessionStorage = $sessionStorage;
	  participationListVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  // VARIABLES
	  participationListVm.viewLoaded = true;
	  participationListVm.active = GlobalConfig.generals.active;
	  participationListVm.notActive = GlobalConfig.generals.notActive;
	  participationListVm.planningFinish = true;
	  $scope.classPlanning = '';
	  participationListVm.inReview = 0;
	  participationListVm.feedback = 0;
	  participationListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory;
	  participationListVm.imgEmpty = __webpack_require__(445);
	
	  // METHODS
	  participationListVm.participation = [];
	  participationListVm.confirmDeleteParticipation = confirmDeleteParticipation;
	  participationListVm.finalizePlan = finalizePlan;
	  participationListVm.updateView = updateView;
	  participationListVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  participationListVm.bitacora = bitacora;
	
	  function updateView() {
	    participationListVm.viewLoaded = false;
	    $timeout(function () {
	      participationListVm.viewLoaded = true;
	    }, 400);
	  }
	
	  activate();
	
	  function activate() {
	    var header = {
	      teacherId: $cookies.getObject('currentUser').teacherId,
	      workplanId: $cookies.getObject('currentUser').workplanId
	    };
	
	    if (participationListVm.workPlanGeneralList != undefined) {
	
	      participationListVm.status = participationListVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      participationListVm.stages = participationListVm.workPlanGeneralList.stages;
	      participationListVm.inReview = participationListVm.status.reviewed;
	      participationListVm.feedback = participationListVm.status.feedbackReviewed;
	      participationListVm.workplanTeacherId = participationListVm.status.workplanTeacherId;
	      isPlanning(participationListVm.status, participationListVm.stages);
	
	      if (participationListVm.feedback && !participationListVm.planningFinish) {
	        getDataFormCommitteeReject(header);
	      } else {
	        getDataFormCommittee(header);
	      }
	    } else {
	      getGeneralsWorkplan(header).then(function (promise) {
	        if (participationListVm.feedback && !participationListVm.planningFinish) {
	          getDataFormCommitteeReject(header);
	        } else {
	          getDataFormCommittee(header);
	        }
	      });
	    }
	    updateView();
	  }
	
	  function getDataFormCommittee(header) {
	    WorkPlanSrv.getDataFormCommittee.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        participationListVm.participationList = dataReturn.committee;
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getDataFormCommitteeReject(header) {
	    WorkPlanSrv.getDataFormCommitteeReject.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        participationListVm.participationList = dataReturn.committee;
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function finalizePlan() {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.dataArray = [{ activity: 'Docencia', time: '10', percentage: '10%' }, { activity: 'Gestión académica administrativa', time: '15', percentage: '11%' }, { activity: 'Consolidación de cuerpo profesoral', time: '0', percentage: '0%' }, { activity: 'Investigación e Innovación', time: '100', percentage: '81%' }, { activity: 'Extensión y relaciones interinstitucionales', time: '0', percentage: '0%' }];
	
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(765),
	      clickOutsideToClose: false
	    });
	  }
	
	  function confirmDeleteParticipation(itemParticipation) {
	    var participationArray = participationListVm.participationList.indexOf(itemParticipation);
	    var participationName = itemParticipation.comiteeName;
	    var participationId = itemParticipation.comiteeId;
	    var workplanTeacherActivityId = itemParticipation.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.participationArrayCode = participationArray;
	        ctrlModalVM.participationName = participationName;
	        ctrlModalVM.participationId = participationId;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.deleteParticipation = function () {
	          WorkPlanSrv.deleteParticipation.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              showSuccessDialog(ctrlModalVM.participationName);
	              updateView();
	              WorkPlanIndicatorSrv.setVariable(true);
	              participationListVm.participationList.splice(ctrlModalVM.participationArrayCode, 1);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(766),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showSuccessDialog(name) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: name,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        participationListVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        participationListVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        participationListVm.stages = dataReturn.data.stages;
	        participationListVm.inReview = participationListVm.status.reviewed;
	        participationListVm.feedback = participationListVm.status.feedbackReviewed;
	        participationListVm.workplanTeacherId = participationListVm.status.workplanTeacherId;
	        isPlanning(participationListVm.status, participationListVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    participationListVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        participationListVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == participationListVm.active) {
	        participationListVm.planningFinish = true;
	        if (participationListVm.startDateReview < participationListVm.currentDate || status.reviewedFinish == participationListVm.active) {
	          participationListVm.planningFinish = true;
	        } else if (status.reviewedReject == participationListVm.active) {
	          participationListVm.planningFinish = false;
	        }
	      } else {
	        participationListVm.planningFinish = false;
	      }
	    } else {
	      participationListVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = participationListVm.planningFinish ? "disabled" : " ";
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.committeeParticipation,
	      workplanTeacherId: participationListVm.workplanTeacherId
	    };
	    entries.title = 'Cargos por Delegación';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = ParticipationListCtrl;
	
	
	ParticipationListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', '$mdDialog', '$cookies', '$stateParams', 'WorkPlanModalSrv', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModal.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>Finalizar planeación</h3> <p class=m-t-md>Revise los datos mostrados a continuación para asegurar que desea finalizar su planeación.</p> </div> </div> <div class=row> <div class=\"col-md-7 no-padding\"> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold text-left\">Actividad</h5> </div> </div> <div class=\"col-md-3 no-padding\"> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">N° de horas</h5> </div> </div> <div class=\"col-md-2 no-padding\"> <div class=col-md-12> <h5 class=\"text-azul p-v-xs font-bold\">Porcentaje</h5> </div> </div> <div class=col-md-12 ng-repeat=\"item in ctrlModalVM.dataArray\"> <div class=\"col-md-7 no-padding text-left\"> {{item.activity}} </div> <div class=\"col-md-3 no-padding text-center\"> {{item.time}} </div> <div class=\"col-md-2 no-padding text-center\"> {{item.percentage}} </div> </div> <div class=\"col-md-12 text-center\"> <h3>124</h3> <h5 class=\"text-azul p-v-xs font-bold text-center\">Total horas planeadas</h5> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.close()>Finalizar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la participación <strong>\"{{ ctrlModalVM.participationName }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.deleteParticipation()>Sí, eliminar participación</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RolesListCtrl = function RolesListCtrl($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, RolesListCtrl);
	
	  var rolesListVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  rolesListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  rolesListVm.$sessionStorage = $sessionStorage;
	
	  rolesListVm.mainLabel = 'Roles';
	  rolesListVm.gradRoleClass = 'grad-1';
	  rolesListVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  // VARIABLES
	  rolesListVm.viewLoaded = false;
	  rolesListVm.active = GlobalConfig.generals.active;
	  rolesListVm.notActive = GlobalConfig.generals.notActive;
	  rolesListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory;
	  rolesListVm.imgEmpty = __webpack_require__(445);
	  rolesListVm.planningFinish = true;
	  $scope.classPlanning = '';
	  rolesListVm.inReview = 0;
	  rolesListVm.feedback = 0;
	
	  // METHODS
	  rolesListVm.roles = [];
	  rolesListVm.updateView = updateView;
	  rolesListVm.confirmDeleteRole = confirmDeleteRole;
	  rolesListVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  rolesListVm.bitacora = bitacora;
	
	  activate();
	
	  function activate() {
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId
	    };
	
	    if (rolesListVm.workPlanGeneralList != undefined) {
	      rolesListVm.status = rolesListVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      rolesListVm.stages = rolesListVm.workPlanGeneralList.stages;
	      rolesListVm.inReview = rolesListVm.status.reviewed;
	      rolesListVm.feedback = rolesListVm.status.feedbackReviewed;
	      rolesListVm.workplanTeacherId = rolesListVm.status.workplanTeacherId;
	      isPlanning(rolesListVm.status, rolesListVm.stages);
	
	      if (rolesListVm.feedback && !rolesListVm.planningFinish) {
	        getDataRolesListReject(post);
	      } else {
	        getDataRolesList(post);
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (rolesListVm.feedback && !rolesListVm.planningFinish) {
	          getDataRolesListReject(post);
	        } else {
	          getDataRolesList(post);
	        }
	      });
	    }
	  }
	
	  function getDataRolesList(post) {
	    WorkPlanSrv.getDataRolesList.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.workplanlistdate);
	      }
	    }, function (data) {
	      console.log(workplanlistdate);
	    });
	  }
	
	  function getDataRolesListReject(post) {
	    WorkPlanSrv.getDataRolesListReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.workplanlistdate);
	      }
	    }, function (data) {
	      console.log(workplanlistdate);
	    });
	  }
	
	  function loadData(data) {
	    rolesListVm.roles = data;
	    /*for (var i = rolesListVm.roles.length - 1; i >= 0; i--) {
	      rolesListVm.roles[i].startDate= moment(rolesListVm.roles[i].startDate).format('YYYY-MM-DD')
	      rolesListVm.roles[i].endDate= moment(rolesListVm.roles[i].endDate).format('YYYY-MM-DD')
	    }*/
	    updateView();
	  }
	
	  function updateView() {
	    rolesListVm.viewLoaded = false;
	    $timeout(function () {
	      rolesListVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function confirmDeleteRole(itemRole) {
	    var rolArray = rolesListVm.roles.indexOf(itemRole);
	    var roleName = itemRole.roleName;
	    var roleId = itemRole.roleId;
	    var workplanTeacherActivityId = itemRole.workplanTeacherActivityId;
	    //console.log(itemRole)
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.rolArrayCode = rolArray;
	        ctrlModalVM.roleName = roleName;
	        ctrlModalVM.roleId = roleId;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.deleteRole = function () {
	          WorkPlanSrv.disableActivity.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              showSuccessDialog(ctrlModalVM.roleName);
	              updateView();
	              WorkPlanIndicatorSrv.setVariable(true);
	              rolesListVm.roles.splice(ctrlModalVM.rolArrayCode, 1);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(768),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showSuccessDialog(name) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: name,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        rolesListVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        rolesListVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        rolesListVm.stages = dataReturn.data.stages;
	        rolesListVm.inReview = rolesListVm.status.reviewed;
	        rolesListVm.feedback = rolesListVm.status.feedbackReviewed;
	        rolesListVm.workplanTeacherId = rolesListVm.status.workplanTeacherId;
	        isPlanning(rolesListVm.status, rolesListVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    rolesListVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        rolesListVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == rolesListVm.active) {
	        rolesListVm.planningFinish = true;
	        if (rolesListVm.startDateReview < rolesListVm.currentDate || status.reviewedFinish == rolesListVm.active) {
	          rolesListVm.planningFinish = true;
	        } else if (status.reviewedReject == rolesListVm.active) {
	          rolesListVm.planningFinish = false;
	        }
	      } else {
	        rolesListVm.planningFinish = false;
	      }
	    } else {
	      rolesListVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = rolesListVm.planningFinish ? "disabled" : " ";
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.roles,
	      workplanTeacherId: rolesListVm.workplanTeacherId
	    };
	    entries.title = 'Roles';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = RolesListCtrl;
	
	
	RolesListCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar el rol <strong>\"{{ ctrlModalVM.roleName }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.deleteRole()>Sí, eliminar rol</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateRoleCtrl = function () {
	  function CreateRoleCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, $cookies, GlobalConfig, $state, WorkPlanModalSrv, GlobalSrv) {
	    _classCallCheck(this, CreateRoleCtrl);
	
	    var createRoleVm = this;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	
	    createRoleVm.isEditing = Boolean($stateParams.activityTypeId);
	    createRoleVm.createOrEditModal = 'Creación';
	    createRoleVm.startDate = null;
	    createRoleVm.endDate = null;
	    createRoleVm.minStartDate = new Date();
	    createRoleVm.minEndDate = new Date();
	    createRoleVm.rangeType = GlobalConfig.periods.rangeType;
	    createRoleVm.createOrEdit = 'Crear';
	    createRoleVm.roles = [];
	    createRoleVm.dt_start = $cookies.get('wp_start');
	    createRoleVm.dt_end = $cookies.get('wp_end');
	
	    createRoleVm.typePeriod = [];
	    createRoleVm.periodsArray = [];
	    createRoleVm.selectedTypePeriod = {};
	    createRoleVm.isTouchedPeriods = false;
	
	    createRoleVm.workplanId = currentUser.workplanId;
	    createRoleVm.teacherId = currentUser.teacherId;
	    createRoleVm.nameTeacher = currentUser.name;
	    createRoleVm.workplanTeacherActivityId = null;
	    createRoleVm.activityTypeId = null;
	    createRoleVm.detail = '';
	    createRoleVm.unitsCombo = [];
	    createRoleVm.arrayUnit = [];
	    createRoleVm.rolesCombo = [];
	    createRoleVm.isSaveButtonDisabled = false;
	    createRoleVm.isFeedback = currentUser.isFeedback;
	
	    createRoleVm.addRole = addRole;
	    createRoleVm.funSelectedPeriod = funSelectedPeriod;
	    createRoleVm.confirmRoleAction = confirmRoleAction;
	    createRoleVm.validateForm = validateForm;
	    createRoleVm.validateCheklistPeriods = validateCheklistPeriods;
	    createRoleVm.rolesUnits = rolesUnits;
	    createRoleVm.exists = exists;
	    createRoleVm.showErrorMessages = showErrorMessages;
	    createRoleVm.hasError = hasError;
	    createRoleVm.changedCheckBox = changedCheckBox;
	    createRoleVm.addOrEditRol = addOrEditRol;
	    createRoleVm.startDateChange = startDateChange;
	    createRoleVm.close = close;
	    createRoleVm.percentage = 0;
	
	    createRoleVm.updateRangeType = function (val) {
	      createRoleVm.rangeType = val;
	      createRoleVm.periodsArray = [];
	      createRoleVm.startDate = null;
	      createRoleVm.endDate = null;
	    };
	    createRoleVm.updateRangeData = function (val) {
	      createRoleVm.periodsArray = val['periods'];
	      createRoleVm.startDate = val['dates'][0];
	      createRoleVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function getPeriodsData() {
	      var post = {
	        workplanId: currentUser.workplanId,
	        teacherId: currentUser.teacherId
	      };
	      WorkPlanSrv.getDataRolesList.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createRoleVm.typePeriod = dataReturn.workplanperiod;
	          createRoleVm.unitsAndRolesCombo = dataReturn.rolesacademicunits;
	          createRoleVm.unitsCombo = dataReturn.rolesacademicunits;
	          createRoleVm.rolesCombo = dataReturn.rolesacademicunits;
	          // ////////////crear un array solo para la unidad//////////////
	          rolesUnits();
	          for (var index in createRoleVm.unitsCombo) {
	            if (!exists(createRoleVm.unitsCombo[index].academitUnitId, createRoleVm.arrayUnit)) {
	              var temp = {
	                academitUnitId: createRoleVm.unitsCombo[index].academitUnitId,
	                academitUnitName: createRoleVm.unitsCombo[index].academitUnitName
	              };
	              createRoleVm.arrayUnit.push(temp);
	            }
	          }
	          // ///////////////////fin//////////////
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function rolesUnits() {
	      createRoleVm.rolesCombo = [];
	      if (!createRoleVm.academicUnit) return;
	
	      var value = createRoleVm.academicUnit;
	      for (var index in createRoleVm.unitsAndRolesCombo) {
	        if (createRoleVm.unitsAndRolesCombo[index].academitUnitId == value) {
	          var temp = {
	            roleId: createRoleVm.unitsAndRolesCombo[index].roleId,
	            roleName: createRoleVm.unitsAndRolesCombo[index].roleName
	          };
	          createRoleVm.rolesCombo.push(temp);
	        }
	      }
	    }
	
	    function exists(value, array) {
	      for (var index in array) {
	        if (array[index].academitUnitId == value) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function activate() {
	      if (createRoleVm.isEditing) {
	        createRoleVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createRoleVm.activityTypeId = $stateParams.activityTypeId;
	        createRoleVm.createOrEdit = "Editar";
	        getDataRoles().then(function () {
	          getPeriodsData();
	        });
	      } else {
	        getPeriodsData();
	      }
	    }
	
	    function addRole(isExecution) {
	      createRoleVm.isSaveButtonDisabled = true;
	      var origin = 1;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function getDataRoles() {
	      var post = {
	        workplanTeacherActivityId: parseInt($stateParams.workplanTeacherActivityId),
	        activityTypeId: parseInt($stateParams.activityTypeId)
	      };
	
	      return WorkPlanSrv.getActivityDetailAcademic.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createRoleVm.roles = dataReturn.data;
	
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function createJson(origin) {
	      var assignment = {
	        workplanTeacherActivityId: $stateParams.workplanTeacherActivityId,
	        activityId: GlobalConfig.minorActivityId.roles,
	        percentage: createRoleVm.percentage,
	        description: createRoleVm.detail,
	        teacherId: createRoleVm.teacherId,
	        workplanId: createRoleVm.workplanId,
	        roleId: createRoleVm.rolesSelected,
	        academitUnitId: createRoleVm.academicUnit,
	        timeRangeTypeId: createRoleVm.rangeType,
	        userId: currentUser.id,
	        origin: origin,
	        isFeedbackActivity: createRoleVm.isFeedback
	      };
	
	      if (parseInt(createRoleVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createRoleVm.periodsArray) {
	          var temp = {
	            periodId: createRoleVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        assignment.periods = arrayPeriod;
	      } else {
	        assignment.startDate = new Date(createRoleVm.startDate);
	        assignment.endDate = new Date(createRoleVm.endDate);
	      }
	
	      if (createRoleVm.isEditing) {
	        assignment.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	      }
	      var aux = createRoleVm.rolesCombo.find(function (rolesName) {
	        return rolesName.roleId == assignment.roleId;
	      });
	      assignment.name = aux.roleName;
	      addOrEditRol(assignment);
	    }
	
	    function addOrEditRol(assignment) {
	      WorkPlanSrv.addRol.save(assignment).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getNotify(createRoleVm.teacherId, GlobalConfig.notificationType.inbox);
	          getNotify(createRoleVm.teacherId, GlobalConfig.notificationType.email);
	          confirmRoleAction();
	        } else {
	          createRoleVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function setValues(rol) {
	      createRoleVm.academicUnit = rol.academicUnitId;
	      createRoleVm.rolesSelected = rol.roleId;
	      createRoleVm.activityTypeId = rol.activityTypeId;
	      createRoleVm.detail = rol.description;
	      createRoleVm.dt_start = moment(rol.startDate, 'YYYY-MM-DD').toDate();
	      createRoleVm.dt_end = moment(rol.endDate, 'YYYY-MM-DD').toDate();
	      createRoleVm.percentage = rol.percentage;
	      createRoleVm.roleId = rol.roleId;
	      createRoleVm.roleName = rol.roleName;
	      createRoleVm.rangeType = rol.timeRangeTypeId;
	      createRoleVm.periodsArray = [];
	      createRoleVm.selectedTypePeriod = {};
	
	      if (createRoleVm.rangeType == GlobalConfig.periods.rangeType) {
	        var splits = rol.periodId.split(',');
	        createRoleVm.startDate = null;
	        createRoleVm.endDate = null;
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          createRoleVm.periodsArray.push(parseInt(valor));
	          createRoleVm.selectedTypePeriod[valor] = true;
	        }
	      }
	
	      if (rol.startDate) {
	        var startDateNew = moment(rol.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createRoleVm.minStartDate = moment(rol.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createRoleVm.isEditing = true;
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createRoleVm.validateCheklistPeriods();
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createRoleVm.periodsArray.includes(period.periodId)) {
	          createRoleVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createRoleVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createRoleVm.periodsArray.splice(index, 1);
	        }
	      }
	      createRoleVm.isTouchedPeriods = true;
	    }
	
	    function validateCheklistPeriods() {
	      return createRoleVm.rangeType == GlobalConfig.periods.rangeType ? createRoleVm.periodsArray.length < 1 : false;
	    }
	
	    function confirmRoleAction() {
	      var texts = GlobalConfig.appTexts;
	      var roleName = getActivityNameFromCombo();
	      var actionEditOrCreate = texts.createDialog;
	      var textCreateOrEdit = texts.saved;
	      if (createRoleVm.isEditing) {
	        actionEditOrCreate = texts.editDialog;
	        textCreateOrEdit = texts.modified;
	      }
	      var header = {
	        createOrEdit: actionEditOrCreate,
	        textCreateOrEdit: textCreateOrEdit,
	        itemName: roleName,
	        nameModal: texts.modalTypeName.roleAcademicManagement,
	        modalType: texts.modalTypeId.roleAcademicManagement
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function showErrorMessages(input) {
	      if (input) {
	        return input.$dirty || input.$touched;
	      } else {
	        return false;
	      }
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function changedCheckBox() {
	      for (var i = 0; i < createRoleVm.rolesCombo.length; i++) {
	        createRoleVm.roleName = createRoleVm.rolesCombo[i].roleName;
	      }
	    }
	
	    function startDateChange() {
	      var m = moment(createRoleVm.startDate);
	      createRoleVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function getActivityNameFromCombo() {
	      for (var i = 0; i < createRoleVm.rolesCombo.length; i++) {
	        var row = createRoleVm.rolesCombo[i];
	        if (row.roleId == createRoleVm.rolesSelected) {
	          return createRoleVm.rolesCombo[i].roleName;
	        }
	      }
	    }
	
	    function close() {
	      $mdDialog.hide();
	    }
	
	    function getNotify(teacherId, notificationType) {
	      var data = {
	        idTeacher: teacherId,
	        dsName: 'Notificación, El profesor ' + currentUser.dsFullname + ' ha creado un nuevo rol',
	        dsDescription: 'El profesor ' + currentUser.dsFullname + ' ha creado un nuevo rol el cual requiere de su validación, aprobación y registro en el sistema fuente',
	        idNotification_delivery_type: notificationType,
	        is_grouped: 1
	      };
	
	      GlobalSrv.sendNotificationAdminAM(data);
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateRoleCtrl, [{
	    key: 'rbPlanifications',
	    value: function rbPlanifications(bool) {
	      this.rangeType = Number(this.rangeType);
	      if (bool) {
	        this.startDate = null;
	        this.endDate = null;
	      } else {
	        this.periodsArray = [];
	        this.selectedTypePeriod = null;
	        this.startDate = null;
	        this.endDate = null;
	      }
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateRoleCtrl;
	}();
	
	exports.default = CreateRoleCtrl;
	
	
	CreateRoleCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', '$cookies', 'GlobalConfig', '$state', 'WorkPlanModalSrv', 'GlobalSrv'];

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DoctoralListCtrl = function DoctoralListCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, DoctoralListCtrl);
	
	  var doctoralListVm = this;
	
	  // VARIABLES
	  doctoralListVm.mainLabel = 'Formación doctoral';
	  doctoralListVm.viewLoaded = false;
	  doctoralListVm.dataList = [];
	  doctoralListVm.active = GlobalConfig.generals.active;
	  doctoralListVm.notActive = GlobalConfig.generals.notActive;
	  doctoralListVm.inReview = 0;
	  doctoralListVm.feedback = 0;
	  doctoralListVm.planningFinish = true;
	  doctoralListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  doctoralListVm.$sessionStorage = $sessionStorage;
	
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	  };
	
	  doctoralListVm.imgEmpty = __webpack_require__(445);
	
	  $scope.breakpoints = [{
	    breakpoint: 1550,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }, {
	    breakpoint: 768,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 480,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }];
	
	  // METHODS
	  doctoralListVm.backgroundGrad = backgroundGrad;
	  doctoralListVm.updateView = updateView;
	  doctoralListVm.loadData = loadData;
	  doctoralListVm.confirmDeleteDoctorate = confirmDeleteDoctorate;
	  doctoralListVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  doctoralListVm.bitacora = bitacora;
	
	  activate();
	
	  function activate() {
	    if (doctoralListVm.workPlanGeneralList != undefined) {
	      doctoralListVm.status = doctoralListVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      doctoralListVm.stages = doctoralListVm.workPlanGeneralList.stages;
	      doctoralListVm.inReview = doctoralListVm.status.reviewed;
	      doctoralListVm.feedback = doctoralListVm.status.feedbackReviewed;
	      doctoralListVm.workplanTeacherId = doctoralListVm.status.workplanTeacherId;
	      isPlanning(doctoralListVm.status, doctoralListVm.stages);
	
	      if (doctoralListVm.feedback && !doctoralListVm.planningFinish) {
	        getDataPhdListReject();
	      } else {
	        getDataPhdList();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (doctoralListVm.feedback && !doctoralListVm.planningFinish) {
	          getDataPhdListReject();
	        } else {
	          getDataPhdList();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getDataPhdList() {
	    WorkPlanSrv.getDataPhdList.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listphd);
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log(listphd);
	    });
	  }
	
	  function getDataPhdListReject() {
	    WorkPlanSrv.getDataPhdListReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listphd);
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log(listphd);
	    });
	  }
	
	  function loadData(data) {
	    doctoralListVm.dataList = data;
	    updateView();
	  }
	
	  function updateView() {
	    doctoralListVm.viewLoaded = false;
	    $timeout(function () {
	      doctoralListVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function backgroundGrad(index) {
	    var result = 'grad-oblique-';
	
	    switch (index % 4) {
	      case 0:
	        return result + 'negro-dark';
	      case 1:
	        return result + 'azul';
	      case 2:
	        return result + 'teal';
	      case 3:
	        return result + 'deep-orange';
	      default:
	        return result + 'negro-dark';
	    }
	  }
	
	  function confirmDeleteDoctorate(doc) {
	    var docName = doc.nameStudy;
	    var workplanTeacherActivityId = doc.workplanTeacherActivityId;
	    // console.log(doc)
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.docName = docName;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.deleteDoctorate = function () {
	          WorkPlanSrv.disableActivityTeachingStaff.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeDoctorateFromCaroussel(doc);
	              showDeletedDoctorateSuccessfully(ctrlModalVM.docName);
	              WorkPlanIndicatorSrv.setVariable(true);
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(771),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedDoctorateSuccessfully(doctorateName) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: doctorateName,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeDoctorateFromCaroussel(doc) {
	    for (var i in doctoralListVm.dataList) {
	      if (doctoralListVm.dataList[i].workplanTeacherActivityId === doc.workplanTeacherActivityId) {
	        doctoralListVm.dataList.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        doctoralListVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        doctoralListVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        doctoralListVm.stages = dataReturn.data.stages;
	        doctoralListVm.inReview = doctoralListVm.status.reviewed;
	        doctoralListVm.feedback = doctoralListVm.status.feedbackReviewed;
	        doctoralListVm.workplanTeacherId = doctoralListVm.status.workplanTeacherId;
	        isPlanning(doctoralListVm.status, doctoralListVm.stages);
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    doctoralListVm.currentDate = moment(new Date()).format('DD/MM/YYYY');
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        doctoralListVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == doctoralListVm.active) {
	        doctoralListVm.planningFinish = true;
	        if (doctoralListVm.startDateReview < doctoralListVm.currentDate || status.reviewedFinish == doctoralListVm.active) {
	          doctoralListVm.planningFinish = true;
	        } else if (status.reviewedReject == doctoralListVm.active) {
	          doctoralListVm.planningFinish = false;
	        }
	      } else {
	        doctoralListVm.planningFinish = false;
	      }
	    } else {
	      doctoralListVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = doctoralListVm.planningFinish ? 'disabled' : ' ';
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.doctoralEducation,
	      workplanTeacherId: doctoralListVm.workplanTeacherId
	    };
	    entries.title = 'Formación Doctoral';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = DoctoralListCtrl;
	
	
	DoctoralListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar el doctorado <strong>\"{{ ctrlModalVM.docName }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.deleteDoctorate()>Sí, eliminar doctorado</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateDoctorateCtrl = function () {
	  function CreateDoctorateCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig) {
	    _classCallCheck(this, CreateDoctorateCtrl);
	
	    var createDoctorateVm = this;
	    var texts = GlobalConfig.appTexts;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId
	    };
	    createDoctorateVm.sourceType = [];
	    createDoctorateVm.scholarshipProgramType = [];
	    createDoctorateVm.isEditing = $stateParams.workplanTeacherActivityId ? true : false;
	    createDoctorateVm.rangeType = GlobalConfig.periods.rangeType;
	    createDoctorateVm.workplanTeacherActivityId = null;
	    createDoctorateVm.createOrEdit = 'Crear';
	    createDoctorateVm.textCreateOrEdit = texts.saved;
	    createDoctorateVm.createOrEditMV = texts.createDialog;
	    createDoctorateVm.typePeriod = [];
	    createDoctorateVm.periodsArray = [];
	    createDoctorateVm.selectedTypePeriod = {};
	    createDoctorateVm.isTouchedPeriods = false;
	    createDoctorateVm.startDate = null;
	    createDoctorateVm.endDate = null;
	    createDoctorateVm.minStartDate = moment().toDate();
	    createDoctorateVm.minEndDate = new Date();
	    createDoctorateVm.listInstitutions = [];
	    createDoctorateVm.idCore = null;
	    createDoctorateVm.isFeedback = currentUser.isFeedback;
	    createDoctorateVm.dt_start = $cookies.get('wp_start');
	    createDoctorateVm.dt_end = $cookies.get('wp_end');
	
	    createDoctorateVm.hasError = hasError;
	    createDoctorateVm.showErrorMessages = showErrorMessages;
	    createDoctorateVm.confirmDoctorateAction = confirmDoctorateAction;
	    createDoctorateVm.validateForm = validateForm;
	    createDoctorateVm.validateCheklistPeriods = validateCheklistPeriods;
	    createDoctorateVm.funSelectedPeriod = funSelectedPeriod;
	    createDoctorateVm.startDateChange = startDateChange;
	    createDoctorateVm.addDoctorate = addDoctorate;
	    createDoctorateVm.addOrEditDoctorate = addOrEditDoctorate;
	    createDoctorateVm.searchInstitution = searchInstitution;
	    createDoctorateVm.changeInstitution = changeInstitution;
	    createDoctorateVm.searchCore = searchCore;
	    createDoctorateVm.changeCore = changeCore;
	    createDoctorateVm.changeTypeInstitution = changeTypeInstitution;
	    createDoctorateVm.disableButton = false;
	
	    createDoctorateVm.updateRangeType = function (val) {
	      createDoctorateVm.rangeType = val;
	      createDoctorateVm.periodsArray = [];
	      createDoctorateVm.startDate = null;
	      createDoctorateVm.endDate = null;
	    };
	    createDoctorateVm.updateRangeData = function (val) {
	      createDoctorateVm.periodsArray = val['periods'];
	      createDoctorateVm.startDate = val['dates'][0];
	      createDoctorateVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createDoctorateVm.isEditing) {
	        createDoctorateVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createDoctorateVm.activityTypeId = GlobalConfig.activityTypeId.doctoralEducation;
	        createDoctorateVm.createOrEdit = 'Editar';
	        createDoctorateVm.createOrEditMV = texts.editDialog;
	        createDoctorateVm.textCreateOrEdit = texts.modified;
	        getDataDoctorate();
	      }
	
	      WorkPlanSrv.getDataPhdList.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	      listInstitutions();
	    }
	
	    function listInstitutions() {
	      WorkPlanSrv.getInstitutionCountry.getList().$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createDoctorateVm.listInstitutions = dataReturn.institutionCountries;
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getDataDoctorate() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createDoctorateVm.workplanTeacherActivityId),
	        activityTypeId: parseInt(createDoctorateVm.activityTypeId)
	      };
	      WorkPlanSrv.getActivityDetailTeachingStaff.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createDoctorateVm.doctorate = dataReturn.data;
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function loadData(data) {
	      createDoctorateVm.scholarshipProgramType = data.listsScholarship.items;
	      createDoctorateVm.sourceType = data.listsFinancing.items;
	      createDoctorateVm.cities = data.cities;
	      createDoctorateVm.listsTypeInstitution = data.listsTypeInstitution.items;
	      createDoctorateVm.countries = data.countries;
	      createDoctorateVm.state = data.states;
	      createDoctorateVm.typePeriod = data.listPeriods;
	      createDoctorateVm.knowledge = data.listsCoreKnowledge.items;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function addDoctorate() {
	      createJson();
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createDoctorateVm.validateCheklistPeriods();
	    }
	
	    function createJson() {
	      var doctorate = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        namePhd: createDoctorateVm.title,
	        hoursPlanning: createDoctorateVm.plannedHours,
	        activityId: GlobalConfig.minorActivityId.doctorate,
	        cityId: createDoctorateVm.city,
	        knowledgeCoreId: createDoctorateVm.idCore,
	        knowledgeCoreName: createDoctorateVm.searchTextCore,
	        typeInstituteId: createDoctorateVm.institutionType,
	        nameInstitute: createDoctorateVm.searchText,
	        financingId: createDoctorateVm.financingSource,
	        scholarshipId: createDoctorateVm.scholarshipProgram,
	        timeRangeTypeId: createDoctorateVm.rangeType,
	        isFeedbackActivity: createDoctorateVm.isFeedback
	      };
	
	      if (createDoctorateVm.isEditing) {
	        doctorate.workplanTeacherActivityId = createDoctorateVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createDoctorateVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createDoctorateVm.periodsArray) {
	          var temp = {
	            periodId: createDoctorateVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        doctorate.periods = arrayPeriod;
	      } else {
	        doctorate.startDate = new Date(createDoctorateVm.startDate);
	        doctorate.endDate = new Date(createDoctorateVm.endDate);
	      }
	
	      addOrEditDoctorate(doctorate);
	    }
	
	    function addOrEditDoctorate(doctorate) {
	      createDoctorateVm.disableButton = true;
	      WorkPlanSrv.addPhd.save(doctorate).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          confirmDoctorateAction();
	        } else {
	          createDoctorateVm.disableButton = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function confirmDoctorateAction() {
	      var header = {
	        createOrEdit: createDoctorateVm.createOrEditMV,
	        textCreateOrEdit: createDoctorateVm.textCreateOrEdit,
	        itemName: createDoctorateVm.title,
	        nameModal: texts.modalTypeName.doctoralFormation,
	        modalType: texts.modalTypeId.doctoralFormation
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function validateCheklistPeriods() {
	      return createDoctorateVm.rangeType == 1 ? createDoctorateVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createDoctorateVm.periodsArray.includes(period.periodId)) {
	          createDoctorateVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createDoctorateVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createDoctorateVm.periodsArray.splice(index, 1);
	        }
	      }
	      createDoctorateVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createDoctorateVm.startDate);
	      createDoctorateVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function setValues(doc) {
	      createDoctorateVm.country = doc.countryId;
	      createDoctorateVm.departament = doc.stateId;
	      createDoctorateVm.city = doc.cityId;
	      createDoctorateVm.docKnowledge = doc.knowledgeCoreName;
	      createDoctorateVm.institutionType = doc.typeInstituteId;
	      createDoctorateVm.searchText = doc.nameInstitute;
	      createDoctorateVm.searchTextCore = doc.knowledgeCoreName;
	      createDoctorateVm.financingSource = doc.financingId;
	      createDoctorateVm.scholarshipProgram = doc.scholarshipId;
	      createDoctorateVm.rangeType = doc.timeRangeTypeId;
	      createDoctorateVm.dt_start = moment(doc.startDate, 'YYYY-MM-DD').toDate();
	      createDoctorateVm.dt_end = moment(doc.endDate, 'YYYY-MM-DD').toDate();
	      createDoctorateVm.plannedHours = doc.hoursPlanning;
	      createDoctorateVm.periodsArray = [];
	      createDoctorateVm.selectedTypePeriod = {};
	      createDoctorateVm.title = doc.nameStudy;
	      if (createDoctorateVm.rangeType == 1) {
	        createDoctorateVm.startDate = null;
	        createDoctorateVm.endDate = null;
	        var splits = doc.periodId.split(',');
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          createDoctorateVm.periodsArray.push(parseInt(valor));
	          createDoctorateVm.selectedTypePeriod[valor] = true;
	        }
	      }
	
	      if (doc.startDate) {
	        var startDateNew = moment(doc.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createDoctorateVm.minStartDate = moment(doc.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      $timeout(function () {
	        createDoctorateVm.country = doc.countryId;
	        createDoctorateVm.departament = doc.stateId;
	        createDoctorateVm.city = doc.cityId;
	      }, 500);
	
	      createDoctorateVm.isEditing = true;
	    }
	
	    function searchCore(searchText) {
	      if (!createDoctorateVm.knowledge) {
	        return;
	      }
	
	      var matcher = new RegExp(searchText, 'i');
	      var arr = [];
	      var attr = 'listItemName';
	      createDoctorateVm.knowledge.forEach(function (searchText) {
	        if (searchText[attr].match(matcher)) {
	          arr.push(searchText);
	        }
	      });
	      return arr;
	    }
	
	    function searchInstitution(searchText, type) {
	      var matcher = new RegExp(searchText, 'i');
	      var arr = [];
	      var attr = 'nameInstitution';
	      createDoctorateVm.listInstitutions.forEach(function (list) {
	        if (list.idInstitution == type) {
	          if (list[attr].match(matcher)) {
	            arr.push(list);
	          }
	        }
	      });
	      return arr;
	    }
	
	    function changeInstitution(doc) {
	      if (doc) {
	        createDoctorateVm.country = doc.countryId;
	        createDoctorateVm.departament = doc.stateId;
	        createDoctorateVm.city = doc.cityId;
	      } else {
	        createDoctorateVm.country = null;
	        createDoctorateVm.departament = null;
	        createDoctorateVm.city = null;
	      }
	    }
	
	    function changeCore(core) {
	      if (!core) {
	        return;
	      }
	
	      createDoctorateVm.idCore = core.idListItem;
	    }
	
	    function changeTypeInstitution() {
	      createDoctorateVm.country = null;
	      createDoctorateVm.departament = null;
	      createDoctorateVm.city = null;
	      createDoctorateVm.searchText = '';
	      createDoctorateVm.selectedItem = null;
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateDoctorateCtrl, [{
	    key: 'rbPlanifications',
	    value: function rbPlanifications(bool) {
	      if (bool) {
	        this.startDate = null;
	        this.endDate = null;
	      } else {
	        this.periodsArray = [];
	        this.selectedTypePeriod = null;
	        this.startDate = null;
	        this.endDate = null;
	      }
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateDoctorateCtrl;
	}();
	
	exports.default = CreateDoctorateCtrl;
	
	
	CreateDoctorateCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig'];

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TeachingDevListCtrl = function TeachingDevListCtrl($scope, $timeout, WorkPlanSrv, $mdDialog, $cookies, GlobalConfig, WorkPlanModalSrv, $filter, Requests, $sessionStorage) {
	  _classCallCheck(this, TeachingDevListCtrl);
	
	  var teachingDevListVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	  };
	
	  teachingDevListVm.mainLabel = 'Desarrollo profesoral';
	  teachingDevListVm.courseList = [];
	  teachingDevListVm.viewLoaded = false;
	  teachingDevListVm.gradRoleClass = 'grad-1';
	  teachingDevListVm.active = GlobalConfig.generals.active;
	  teachingDevListVm.notActive = GlobalConfig.generals.notActive;
	  teachingDevListVm.inReview = 0;
	  teachingDevListVm.feedback = 0;
	  teachingDevListVm.planningFinish = true;
	  teachingDevListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  teachingDevListVm.$sessionStorage = $sessionStorage;
	  teachingDevListVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  teachingDevListVm.imgEmpty = __webpack_require__(445);
	
	  teachingDevListVm.confirmDeleteCourse = confirmDeleteCourse;
	  teachingDevListVm.updateView = updateView;
	  teachingDevListVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  teachingDevListVm.loadData = loadData;
	  teachingDevListVm.validateSearch = validateSearch;
	  teachingDevListVm.bitacora = bitacora;
	
	  function validateSearch() {
	    return $filter('filter')(teachingDevListVm.courseList, teachingDevListVm.courseListSearch);
	  }
	
	  activate();
	
	  function activate() {
	    if (teachingDevListVm.workPlanGeneralList != undefined) {
	      teachingDevListVm.status = teachingDevListVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      teachingDevListVm.stages = teachingDevListVm.workPlanGeneralList.stages;
	      teachingDevListVm.inReview = teachingDevListVm.status.reviewed;
	      teachingDevListVm.feedback = teachingDevListVm.status.feedbackReviewed;
	      teachingDevListVm.workplanTeacherId = teachingDevListVm.status.workplanTeacherId;
	      isPlanning(teachingDevListVm.status, teachingDevListVm.stages);
	
	      if (teachingDevListVm.feedback && !teachingDevListVm.planningFinish) {
	        getDataCoursesListReject();
	      } else {
	        getDataCoursesList();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (teachingDevListVm.feedback && !teachingDevListVm.planningFinish) {
	          getDataCoursesListReject();
	        } else {
	          getDataCoursesList();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getDataCoursesList() {
	    WorkPlanSrv.getDataCoursesList.getList(post).$promise.then(function (dataReturn) {
	      dataReturn.status ? loadData(dataReturn.listCourses) : console.log('Comunications problem');
	    });
	  }
	
	  function getDataCoursesListReject() {
	    WorkPlanSrv.getDataCoursesListReject.getList(post).$promise.then(function (dataReturn) {
	      dataReturn.status ? loadData(dataReturn.listCourses) : console.log('Comunications problem');
	    });
	  }
	
	  function updateView() {
	    teachingDevListVm.viewLoaded = false;
	    $timeout(function () {
	      teachingDevListVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function loadData(data) {
	    teachingDevListVm.courseList = data;
	    for (var i = teachingDevListVm.courseList.length - 1; i >= 0; i--) {
	      if (teachingDevListVm.courseList[i].typeCourseId == GlobalConfig.courseType.courseExternal) {
	        teachingDevListVm.courseList[i].isEditable = true;
	      } else {
	        teachingDevListVm.courseList[i].isEditable = false;
	      }
	
	      if (teachingDevListVm.courseList[i].timeRangeTypeId == 1) {
	        teachingDevListVm.courseList[i].periodicityName = teachingDevListVm.courseList[i].periodicityName.replaceAll(',', '.').replaceAll('.', ', ');
	      }
	    }
	    console.log('listado de desarrollo', teachingDevListVm.courseList);
	  }
	
	  String.prototype.replaceAll = function (searchStr, replaceStr) {
	    var str = this;
	    if (str.indexOf(searchStr) === -1) return str;
	    return str.replace(searchStr, replaceStr).replaceAll(searchStr, replaceStr);
	  };
	
	  function confirmDeleteCourse(itemCourse) {
	    var courseName = itemCourse.nameCourse;
	    var workplanTeacherActivityId = itemCourse.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.courseName = courseName;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.deleteCourse = function () {
	          WorkPlanSrv.disableActivityTeachingStaff.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeCourseFromCaroussel(itemCourse);
	              showDeletedSuccessfully(ctrlModalVM.courseName);
	              WorkPlanIndicatorSrv.setVariable(true);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(774),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(courseName) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: courseName,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeCourseFromCaroussel(itemCourse) {
	    for (var i in teachingDevListVm.courseList) {
	      if (teachingDevListVm.courseList[i].workplanTeacherActivityId === itemCourse.workplanTeacherActivityId) {
	        teachingDevListVm.courseList.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        teachingDevListVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        teachingDevListVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        teachingDevListVm.stages = dataReturn.data.stages;
	        teachingDevListVm.inReview = teachingDevListVm.status.reviewed;
	        teachingDevListVm.feedback = teachingDevListVm.status.feedbackReviewed;
	        teachingDevListVm.workplanTeacherId = teachingDevListVm.status.workplanTeacherId;
	        isPlanning(teachingDevListVm.status, teachingDevListVm.stages);
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    teachingDevListVm.currentDate = moment(new Date()).format('DD/MM/YYYY');
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        teachingDevListVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == teachingDevListVm.active) {
	        teachingDevListVm.planningFinish = true;
	        if (teachingDevListVm.startDateReview < teachingDevListVm.currentDate || status.reviewedFinish == teachingDevListVm.active) {
	          teachingDevListVm.planningFinish = true;
	        } else if (status.reviewedReject == teachingDevListVm.active) {
	          teachingDevListVm.planningFinish = false;
	        }
	      } else {
	        teachingDevListVm.planningFinish = false;
	      }
	    } else {
	      teachingDevListVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = teachingDevListVm.planningFinish ? 'disabled' : ' ';
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.teacherDevelopment,
	      workplanTeacherId: teachingDevListVm.workplanTeacherId
	    };
	    entries.title = 'Desarrollo profesoral';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = TeachingDevListCtrl;
	
	
	TeachingDevListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', '$filter', 'Requests', '$sessionStorage'];

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar el curso \"{{ ctrlModalVM.courseName }}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.deleteCourse()>Sí, eliminar curso</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateCourseCtrl = function () {
	  function CreateCourseCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateCourseCtrl);
	
	    var createCourseVm = this;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var texts = GlobalConfig.appTexts;
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId,
	      name: currentUser.name
	    };
	
	    createCourseVm.isEditing = $stateParams.courseId ? true : false;
	
	    // VARIABLES
	    createCourseVm.isEditing = $stateParams.workplanTeacherActivityId ? true : false;
	    createCourseVm.rangeType = GlobalConfig.periods.rangeType;
	    createCourseVm.workplanTeacherActivityId = null;
	    createCourseVm.createOrEdit = 'Crear';
	    createCourseVm.textCreateOrEdit = texts.saved;
	    createCourseVm.createOrEditMV = texts.createDialog;
	    createCourseVm.typePeriod = [];
	    createCourseVm.periodsArray = [];
	    createCourseVm.selectedTypePeriod = {};
	    createCourseVm.isTouchedPeriods = false;
	    createCourseVm.startDate = null;
	    createCourseVm.endDate = null;
	    createCourseVm.minStartDate = moment().toDate();
	    createCourseVm.minEndDate = new Date();
	    createCourseVm.listEntity = [];
	    createCourseVm.listInstitutions = [];
	    createCourseVm.plannedHours = 0;
	    createCourseVm.disableSaveButton = false;
	    createCourseVm.isFeedback = currentUser.isFeedback;
	    createCourseVm.dt_start = $cookies.get('wp_start');
	    createCourseVm.dt_end = $cookies.get('wp_end');
	
	    // METHODS
	    createCourseVm.hasError = hasError;
	    createCourseVm.showErrorMessages = showErrorMessages;
	    createCourseVm.addCourse = addCourse;
	    createCourseVm.validateForm = validateForm;
	    createCourseVm.validateCheklistPeriods = validateCheklistPeriods;
	    createCourseVm.funSelectedPeriod = funSelectedPeriod;
	    createCourseVm.startDateChange = startDateChange;
	    createCourseVm.confirmCourseAction = confirmCourseAction;
	    createCourseVm.searchInstitution = searchInstitution;
	    createCourseVm.changeInstitution = changeInstitution;
	    createCourseVm.changeDepartament = changeDepartament;
	    createCourseVm.addOrEditcourses = addOrEditcourses;
	    createCourseVm.close = close;
	    createCourseVm.changeTypeInstitution = changeTypeInstitution;
	
	    createCourseVm.updateRangeType = function (val) {
	      createCourseVm.rangeType = val;
	      createCourseVm.periodsArray = [];
	      createCourseVm.startDate = null;
	      createCourseVm.endDate = null;
	    };
	    createCourseVm.updateRangeData = function (val) {
	      createCourseVm.periodsArray = val['periods'];
	      createCourseVm.startDate = val['dates'][0];
	      createCourseVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createCourseVm.isEditing) {
	        createCourseVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createCourseVm.activityTypeId = GlobalConfig.activityTypeId.teacherDevelopment;
	        createCourseVm.createOrEdit = 'Editar';
	        createCourseVm.createOrEditMV = texts.editDialog;
	        createCourseVm.textCreateOrEdit = texts.modified;
	        getDataCourses();
	      }
	
	      WorkPlanSrv.getDataCoursesList.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(dataReturn);
	      });
	
	      listInstitutions();
	    }
	
	    function loadData(data) {
	      createCourseVm.cities = data.cities;
	      createCourseVm.countries = data.countries;
	      createCourseVm.state = data.states;
	      createCourseVm.listsTypeInstitution = data.listsTypeInstitution.items;
	      createCourseVm.typePeriod = data.listPeriods;
	      createCourseVm.listEntity = data.listsEntity.items;
	      createCourseVm.listModality = data.listsModality.items;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function addCourse(isExecution) {
	      var origin = 1;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createCourseVm.validateCheklistPeriods();
	    }
	
	    function getDataCourses() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createCourseVm.workplanTeacherActivityId),
	        activityTypeId: parseInt(createCourseVm.activityTypeId)
	      };
	      WorkPlanSrv.getActivityDetailTeachingStaff.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createCourseVm.course = dataReturn.data;
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(course) {
	      createCourseVm.country = course.countryId;
	      createCourseVm.departament = course.stateId;
	      createCourseVm.city = course.cityId;
	      createCourseVm.title = course.name;
	      createCourseVm.institutionType = course.instituteTypeId;
	      createCourseVm.searchText = course.nameInstitute;
	      createCourseVm.entityType = course.entityId;
	      createCourseVm.level = course.level;
	      createCourseVm.modality = course.modalityId;
	      createCourseVm.program = course.nameStudy;
	      createCourseVm.courseDescription = course.description;
	      createCourseVm.rangeType = course.timeRangeTypeId;
	      createCourseVm.dt_start = moment(course.startDate, 'YYYY-MM-DD').toDate();
	      createCourseVm.dt_end = moment(course.endDate, 'YYYY-MM-DD').toDate();
	      createCourseVm.plannedHours = course.hoursPlanned;
	      createCourseVm.periodsArray = [];
	      createCourseVm.selectedTypePeriod = {};
	
	      if (course.periodId) {
	        var splits = course.periodId.split(',');
	        createCourseVm.startDate = null;
	        createCourseVm.endDate = null;
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	
	          if (parseInt(createCourseVm.rangeType) == GlobalConfig.periods.rangeType) {
	            createCourseVm.periodsArray.push(parseInt(valor));
	            createCourseVm.selectedTypePeriod[valor] = true;
	          }
	        }
	      }
	
	      if (course.startDate) {
	        var startDateNew = moment(course.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createCourseVm.minStartDate = moment(course.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createCourseVm.isEditing = true;
	    }
	
	    function confirmCourseAction() {
	      var header = {
	        createOrEdit: createCourseVm.createOrEditMV,
	        textCreateOrEdit: createCourseVm.textCreateOrEdit,
	        itemName: createCourseVm.title,
	        nameModal: texts.modalTypeName.teachingDev,
	        modalType: texts.modalTypeId.teachingDev
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header);
	    }
	
	    function validateCheklistPeriods() {
	      return createCourseVm.rangeType == 1 ? createCourseVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createCourseVm.periodsArray.includes(period.periodId)) {
	          createCourseVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createCourseVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createCourseVm.periodsArray.splice(index, 1);
	        }
	      }
	      createCourseVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createCourseVm.startDate);
	      createCourseVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    // AUTOCOMPLETE
	    function listInstitutions() {
	      WorkPlanSrv.getInstitutionCountry.getList().$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createCourseVm.listInstitutions = dataReturn.institutionCountries;
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(listInstitutions);
	      });
	    }
	
	    function searchInstitution(searchText, type) {
	      var matcher = new RegExp(searchText, 'i');
	      var arr = [];
	      var attr = 'nameInstitution';
	      createCourseVm.listInstitutions.forEach(function (list) {
	        if (list.idInstitution === type) {
	          if (list[attr] && list[attr].match(matcher)) {
	            arr.push(list);
	          }
	        }
	      });
	      return arr;
	    }
	
	    function changeInstitution(courses) {
	      if (courses) {
	        createCourseVm.country = courses.countryId;
	        createCourseVm.departament = courses.stateId;
	        createCourseVm.city = courses.cityId;
	      } else {
	        createCourseVm.country = null;
	        createCourseVm.departament = null;
	        createCourseVm.city = null;
	      }
	    }
	
	    function changeDepartament(departament) {
	      if (!departament) {
	        createCourseVm.city = null;
	        createCourseVm.departament = null;
	      }
	    }
	
	    function createJson(origin) {
	      createCourseVm.disableSaveButton = true;
	      var courses = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        activityId: GlobalConfig.minorActivityId.courses,
	        name: createCourseVm.title,
	        entityId: createCourseVm.entityType,
	        level: createCourseVm.level,
	        modalityId: createCourseVm.modality,
	        instituteTypeId: createCourseVm.institutionType,
	        courseTypeId: GlobalConfig.courseType.courseExternal,
	        nameInstitute: createCourseVm.searchText,
	        cityId: createCourseVm.city,
	        program: createCourseVm.program,
	        description: createCourseVm.courseDescription,
	        hoursPlanning: createCourseVm.plannedHours,
	        timeRangeTypeId: createCourseVm.rangeType,
	        origin: origin,
	        isFeedbackActivity: createCourseVm.isFeedback
	      };
	
	      if (createCourseVm.isEditing) {
	        courses.workplanTeacherActivityId = createCourseVm.workplanTeacherActivityId;
	      }
	
	      if (createCourseVm.rangeType == GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createCourseVm.periodsArray) {
	          var temp = {
	            periodId: createCourseVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        courses.periods = arrayPeriod;
	      } else {
	        courses.startDate = createCourseVm.startDate;
	        courses.endDate = createCourseVm.endDate;
	      }
	
	      addOrEditcourses(courses);
	    }
	
	    function addOrEditcourses(courses) {
	      WorkPlanSrv.addCourseExtern.save(courses).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getNotify(courses.origin);
	          confirmCourseAction();
	        } else {
	          createCourseVm.disableSaveButton = false;
	          console.log('Error Comunications');
	        }
	      });
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function changeTypeInstitution() {
	      createCourseVm.searchText = null;
	    }
	
	    function getNotify(origin) {
	      /* let reviewers = GlobalSrv.getReviewerbySubmodule(idRole, GlobalConfig.modules.consolidation)
	      if(reviewers) */
	      getSendNotify(origin);
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El curso externo registrado por el profesor' + post.name + ' requiere su verificación y validación.';
	      var data = {
	        dsName: 'Notificación, se agregó o editó un curso externo',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1
	      };
	      GlobalSrv.addNotificationToAdminWorkPlan.add(data).$promise.then(function (dataReturn) {
	        console.log(dataReturn);
	      }, function (data) {
	        console.log(data);
	      });
	    }
	  } // Fin del constructor
	
	  _createClass(CreateCourseCtrl, [{
	    key: 'rbPlanifications',
	    value: function rbPlanifications(bool) {
	      if (bool) {
	        this.startDate = null;
	        this.endDate = null;
	      } else {
	        this.periodsArray = [];
	        this.selectedTypePeriod = null;
	        this.startDate = null;
	        this.endDate = null;
	      }
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateCourseCtrl;
	}();
	
	exports.default = CreateCourseCtrl;
	
	
	CreateCourseCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LearningCommunityListCtrl = function LearningCommunityListCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, GlobalConfig, $filter, Requests, $sessionStorage) {
	  _classCallCheck(this, LearningCommunityListCtrl);
	
	  var learningCommunityListVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  learningCommunityListVm.mainLabel = 'Comunidades de aprendizaje y práctica';
	  learningCommunityListVm.gradCommunityClass = 'grad-1';
	  learningCommunityListVm.communitiesList = [];
	  learningCommunityListVm.active = GlobalConfig.generals.active;
	  learningCommunityListVm.notActive = GlobalConfig.generals.notActive;
	  learningCommunityListVm.inReview = 0;
	  learningCommunityListVm.feedback = 0;
	  learningCommunityListVm.planningFinish = true;
	  learningCommunityListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  learningCommunityListVm.$sessionStorage = $sessionStorage;
	
	  var header = {
	    teacherId: currentUser.teacherId,
	    workplanId: currentUser.workplanId
	  };
	  learningCommunityListVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  // VARIABLES
	  learningCommunityListVm.viewLoaded = true;
	  learningCommunityListVm.imgEmpty = __webpack_require__(445);
	
	  // METHODS
	  learningCommunityListVm.updateView = updateView;
	  learningCommunityListVm.confirmDeleteCommunity = confirmDeleteCommunity;
	  learningCommunityListVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  learningCommunityListVm.validateSearch = validateSearch;
	  learningCommunityListVm.bitacora = bitacora;
	
	  function validateSearch() {
	    return $filter('filter')(learningCommunityListVm.communitiesList, learningCommunityListVm.communityFilter);
	  }
	
	  activate();
	
	  function activate() {
	    var post = {
	      teacherId: currentUser.teacherId
	    };
	
	    if (learningCommunityListVm.workPlanGeneralList != undefined) {
	      learningCommunityListVm.status = learningCommunityListVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      learningCommunityListVm.stages = learningCommunityListVm.workPlanGeneralList.stages;
	      learningCommunityListVm.inReview = learningCommunityListVm.status.reviewed;
	      learningCommunityListVm.feedback = learningCommunityListVm.status.feedbackReviewed;
	      learningCommunityListVm.workplanTeacherId = learningCommunityListVm.status.workplanTeacherId;
	      isPlanning(learningCommunityListVm.status, learningCommunityListVm.stages);
	
	      if (learningCommunityListVm.feedback && !learningCommunityListVm.planningFinish) {
	        getDataFormCommunitiesReject();
	      } else {
	        getDataFormCommunities();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (learningCommunityListVm.feedback && !learningCommunityListVm.planningFinish) {
	          getDataFormCommunitiesReject();
	        } else {
	          getDataFormCommunities();
	        }
	      });
	    }
	  }
	
	  function getDataFormCommunities() {
	    // List Service Communities
	    WorkPlanSrv.getDataFormCommunities.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        //console.log(dataReturn)
	        learningCommunityListVm.dataCommunitiesList = dataReturn;
	        console.log("learningCommunityListVm.dataCommunitiesList");
	        console.log(learningCommunityListVm.dataCommunitiesList);
	        learningCommunityListVm.communitiesList = learningCommunityListVm.dataCommunitiesList.communities;
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getDataFormCommunitiesReject() {
	    // List Service Communities
	    WorkPlanSrv.getDataFormCommunitiesReject.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        //console.log(dataReturn)
	        learningCommunityListVm.dataCommunitiesList = dataReturn;
	        learningCommunityListVm.communitiesList = learningCommunityListVm.dataCommunitiesList.communities;
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function updateView() {
	
	    learningCommunityListVm.viewLoaded = false;
	    $timeout(function () {
	      learningCommunityListVm.viewLoaded = true;
	    }, 1000);
	  }
	
	  function confirmDeleteCommunity(itemCommunity) {
	    var communityName = itemCommunity.listItemNameCommunity;
	    var communityId = itemCommunity.workplanTeacherActivityId;
	
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.communityName = communityName;
	        ctrlModalVM.communityId = communityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.deleteCommunity = function () {
	          var requestHeader = { workplanTeacherActivityId: ctrlModalVM.communityId };
	          WorkPlanSrv.deleteDataFormCommunities.delete(requestHeader).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeCommunityFromCaroussel(itemCommunity);
	              showDeletedCommunitySuccessfully(ctrlModalVM.communityName);
	              WorkPlanIndicatorSrv.setVariable(true);
	              itemCommunity.notShow = true;
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(777),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedCommunitySuccessfully(communityName) {
	
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: communityName,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeCommunityFromCaroussel(community) {
	    for (var i in learningCommunityListVm.communitiesList) {
	      if (learningCommunityListVm.communitiesList[i].workplanTeacherActivityId === community.workplanTeacherActivityId) {
	        learningCommunityListVm.communitiesList.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        learningCommunityListVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        learningCommunityListVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        learningCommunityListVm.stages = dataReturn.data.stages;
	        learningCommunityListVm.inReview = learningCommunityListVm.status.reviewed;
	        learningCommunityListVm.feedback = learningCommunityListVm.status.feedbackReviewed;
	        learningCommunityListVm.workplanTeacherId = learningCommunityListVm.status.workplanTeacherId;
	        isPlanning(learningCommunityListVm.status, learningCommunityListVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    learningCommunityListVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        learningCommunityListVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == learningCommunityListVm.active) {
	        learningCommunityListVm.planningFinish = true;
	        if (learningCommunityListVm.startDateReview < learningCommunityListVm.currentDate || status.reviewedFinish == learningCommunityListVm.active) {
	          learningCommunityListVm.planningFinish = true;
	        } else if (status.reviewedReject == learningCommunityListVm.active) {
	          learningCommunityListVm.planningFinish = false;
	        }
	      } else {
	        learningCommunityListVm.planningFinish = false;
	      }
	    } else {
	      learningCommunityListVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = learningCommunityListVm.planningFinish ? "disabled" : " ";
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.community,
	      workplanTeacherId: learningCommunityListVm.workplanTeacherId
	    };
	    entries.title = 'Comunidades de aprendizaje y práctica';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = LearningCommunityListCtrl;
	
	
	LearningCommunityListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', 'GlobalConfig', '$filter', 'Requests', '$sessionStorage'];

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la comunidad \"{{ ctrlModalVM.communityName }}\" ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.deleteCommunity()>Sí, eliminar comunidad</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateLearningComunityCtrl = function () {
	  function CreateLearningComunityCtrl($scope, WorkPlanSrv, $mdDialog, $stateParams, $cookies, GlobalConfig, WorkPlanModalSrv, GlobalSrv) {
	    _classCallCheck(this, CreateLearningComunityCtrl);
	
	    var createLearningComunityVM = this;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var texts = GlobalConfig.appTexts;
	    createLearningComunityVM.isEditing = $stateParams.workplanTeacherActivityId ? true : false;
	    createLearningComunityVM.comboScene = [];
	    createLearningComunityVM.dataCommunities = [];
	    createLearningComunityVM.periodsArray = [];
	    createLearningComunityVM.communitiesArray = [];
	    createLearningComunityVM.createOrEdit = 'Agregar ';
	    createLearningComunityVM.textCreateOrEdit = texts.saved;
	    createLearningComunityVM.createOrEditMV = texts.createDialog;
	    createLearningComunityVM.communityNameModal = '';
	    createLearningComunityVM.selectedTypePeriod = {};
	    createLearningComunityVM.periods = [];
	    createLearningComunityVM.rangeType = GlobalConfig.periods.rangeType;
	    createLearningComunityVM.range = '';
	    createLearningComunityVM.hrefActivityModal = false;
	    createLearningComunityVM.hoursPlanning = 0;
	    createLearningComunityVM.isSaveButtonDisabled = false;
	    createLearningComunityVM.dt_start = $cookies.get('wp_start');
	    createLearningComunityVM.dt_end = $cookies.get('wp_end');
	
	    // createLearningComunityVM.idListItem = ''
	    createLearningComunityVM.listItemName = '';
	    createLearningComunityVM.idWorkPlan = currentUser.workplanId;
	    createLearningComunityVM.idTeacher = currentUser.teacherId;
	    var header = {
	      teacherId: currentUser.teacherId,
	      workplanId: currentUser.workplanId,
	      name: currentUser.name
	    };
	    createLearningComunityVM.startDate = null;
	    createLearningComunityVM.endDate = null;
	    createLearningComunityVM.minStartDate = moment().toDate();
	    createLearningComunityVM.minEndDate = new Date();
	    createLearningComunityVM.searchText = '';
	    createLearningComunityVM.isFeedback = currentUser.isFeedback;
	
	    // FUNCTIONS
	    createLearningComunityVM.hasError = hasError;
	    createLearningComunityVM.showErrorMessages = showErrorMessages;
	    createLearningComunityVM.validateForm = validateForm;
	    createLearningComunityVM.addActivity = addActivity;
	    createLearningComunityVM.funSelectedPeriod = funSelectedPeriod;
	    createLearningComunityVM.validateCheklistPeriods = validateCheklistPeriods;
	    createLearningComunityVM.searchCommunity = searchCommunity;
	    createLearningComunityVM.changeCommunity = changeCommunity;
	    createLearningComunityVM.close = close;
	    createLearningComunityVM.startDateChange = startDateChange;
	    createLearningComunityVM.changeSearchText = changeSearchText;
	    createLearningComunityVM.updateRangeType = function (val) {
	      createLearningComunityVM.rangeType = val;
	      createLearningComunityVM.periodsArray = [];
	      createLearningComunityVM.startDate = null;
	      createLearningComunityVM.endDate = null;
	    };
	    createLearningComunityVM.updateRangeData = function (val) {
	      createLearningComunityVM.periodsArray = val['periods'];
	      createLearningComunityVM.startDate = val['dates'][0];
	      createLearningComunityVM.endDate = val['dates'][1];
	    };
	
	    function searchCommunity(searchText) {
	      var matcher = new RegExp(searchText, 'i');
	      var arr = [];
	      var attr = 'listItemName';
	      createLearningComunityVM.communitiesArray.forEach(function (searchText) {
	        if (searchText[attr].match(matcher)) {
	          arr.push(searchText);
	        }
	      });
	      return arr;
	    }
	
	    function changeCommunity(community) {
	      if (community && community.idListItem) {
	        createLearningComunityVM.idListItemChangue = community.idListItem;
	      } else {
	        createLearningComunityVM.idListItemChangue = null;
	      }
	      createLearningComunityVM.listItemName = community.listItemName;
	    }
	
	    function changeSearchText(searchText) {
	      createLearningComunityVM.searchText = searchText.substring(0, 200);
	      createLearningComunityVM.listItemName = searchText;
	      createLearningComunityVM.idListItemChangue = null;
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createLearningComunityVM.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return createLearningComunityVM.rangeType == 1 ? createLearningComunityVM.periodsArray.length < 1 : false;
	    }
	
	    function getDataFormCommunities() {
	      // List Service Committee
	      WorkPlanSrv.getDataFormCommunities.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createLearningComunityVM.dataCommunities = dataReturn;
	          createLearningComunityVM.listsAmbit = createLearningComunityVM.dataCommunities.listsAmbit.items;
	          createLearningComunityVM.periods = createLearningComunityVM.dataCommunities.listPeriods;
	          createLearningComunityVM.range = createLearningComunityVM.dataCommunities.communities.timeRangeTypeId;
	          createLearningComunityVM.communitiesArray = createLearningComunityVM.dataCommunities.listsCommunities.items;
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    activate();
	
	    function activate() {
	      if (createLearningComunityVM.isEditing) {
	        createLearningComunityVM.createOrEdit = 'Editar ';
	        createLearningComunityVM.createOrEditMV = texts.editDialog;
	        createLearningComunityVM.textCreateOrEdit = texts.modified;
	        editCommunity();
	      }
	
	      getDataFormCommunities();
	    }
	
	    function addActivity(sw, isExecution) {
	      createLearningComunityVM.isSaveButtonDisabled = true;
	      createLearningComunityVM.hrefActivityModal = sw;
	      var origin = 1;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var workplanTeacherActivityId = null;
	      var idListItem = createLearningComunityVM.idListItemChangue;
	      createLearningComunityVM.communityNameModal = createLearningComunityVM.listItemName;
	      var listItemNameCommunity = createLearningComunityVM.listItemName;
	      if (createLearningComunityVM.isEditing) {
	        workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        idListItem = createLearningComunityVM.idListItem;
	        createLearningComunityVM.communityNameModal = createLearningComunityVM.listItemNameCommunity;
	        listItemNameCommunity = createLearningComunityVM.listItemNameCommunity;
	      }
	
	      var community = {
	        teacherId: header.teacherId,
	        workplanId: header.workplanId,
	        name: listItemNameCommunity,
	        description: createLearningComunityVM.detail,
	        hoursPlanning: createLearningComunityVM.hoursPlanning,
	        ambitId: createLearningComunityVM.typeScene,
	        communityId: idListItem,
	        timeRangeTypeId: createLearningComunityVM.rangeType,
	        activityId: GlobalConfig.minorActivityId.learningComunity,
	        workplanTeacherActivityId: workplanTeacherActivityId,
	        origin: origin,
	        isFeedbackActivity: createLearningComunityVM.isFeedback
	      };
	
	      if (parseInt(createLearningComunityVM.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createLearningComunityVM.periodsArray) {
	          var temp = {
	            periodId: createLearningComunityVM.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        community.periods = arrayPeriod;
	      } else {
	        community.startDate = new Date(createLearningComunityVM.startDate);
	        community.endDate = new Date(createLearningComunityVM.endDate);
	      }
	      addOrEditCommunity(community);
	    }
	
	    function editCommunity() {
	      WorkPlanSrv.getActivityDetailTeachingStaff.get({ activityTypeId: parseInt($stateParams.activityTypeId), workplanTeacherActivityId: $stateParams.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function setValues(community) {
	      createLearningComunityVM.isEditingAutocomplete = true;
	      createLearningComunityVM.selectedItem = community.listItemNameCommunity;
	      createLearningComunityVM.idListItem = community.listItemIdCommunity;
	      createLearningComunityVM.listItemNameCommunity = community.listItemNameCommunity;
	      createLearningComunityVM.typeScene = community.listItemIdAmbit;
	      createLearningComunityVM.detail = community.description;
	      createLearningComunityVM.hoursPlanning = community.hoursPlanned;
	      createLearningComunityVM.rangeType = community.timeRangeTypeId;
	      createLearningComunityVM.periodsArray = [];
	      createLearningComunityVM.selectedTypePeriod = {};
	
	      if (createLearningComunityVM.rangeType == 1) {
	        var splits = community.periodId.split(',');
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          createLearningComunityVM.periodsArray.push(parseInt(valor));
	          createLearningComunityVM.selectedTypePeriod[valor] = true;
	        }
	      }
	
	      var m = moment(community.startDate, 'YYYY-MM-DD');
	      createLearningComunityVM.dt_start = m.isValid() ? m.toDate() : null;
	
	      m = moment(community.endDate, 'YYYY-MM-DD');
	      createLearningComunityVM.dt_end = m.isValid() ? m.toDate() : null;
	
	      if (community.startDate) {
	        var startDateNew = moment(community.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createLearningComunityVM.minStartDate = moment(community.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createLearningComunityVM.isEditing = true;
	    }
	
	    function addOrEditCommunity(community) {
	      WorkPlanSrv.addActivityCommunity.add(community).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getSendNotify(community.origin);
	          showModalAddCommunity();
	        } else {
	          createLearningComunityVM.isSaveButtonDisabled = false;
	          console.log('Comunications problem with server');
	        }
	      }, function (data) {
	        createLearningComunityVM.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function showModalAddCommunity() {
	      var header = {
	        createOrEdit: createLearningComunityVM.createOrEditMV,
	        textCreateOrEdit: createLearningComunityVM.textCreateOrEdit,
	        itemName: createLearningComunityVM.communityNameModal,
	        nameModal: texts.modalTypeName.learningComunity,
	        modalType: texts.modalTypeId.learningComunity
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createLearningComunityVM.periodsArray.includes(period.periodId)) {
	          createLearningComunityVM.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createLearningComunityVM.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createLearningComunityVM.periodsArray.splice(index, 1);
	        }
	      }
	      createLearningComunityVM.isTouchedPeriods = true;
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function startDateChange() {
	      var m = moment(createLearningComunityVM.startDate);
	      createLearningComunityVM.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva comunidad en la etapa de planeación.';
	      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
	        msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva comunidad en la etapa de ejecución.';
	      }
	      var data = {
	        idTeacher: currentUser.teacherId,
	        dsName: 'Notificación, se agregó o editó una comunidad',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 0,
	        submodule: GlobalConfig.modules.consolidation
	      };
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data);
	    }
	  } // FIN DEL CONSTRUCTOR
	
	
	  _createClass(CreateLearningComunityCtrl, [{
	    key: 'rbPlanifications',
	    value: function rbPlanifications(bool) {
	      if (bool) {
	        this.startDate = null;
	        this.endDate = null;
	      } else {
	        this.periodsArray = [];
	        this.periodsArray = [];
	        this.selectedTypePeriod = null;
	        this.startDate = null;
	        this.endDate = null;
	      }
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateLearningComunityCtrl;
	}();
	
	exports.default = CreateLearningComunityCtrl;
	
	
	CreateLearningComunityCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', 'GlobalSrv'];

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReviewTeacherDevelopmentCtrl = function ReviewTeacherDevelopmentCtrl($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog) {
	  _classCallCheck(this, ReviewTeacherDevelopmentCtrl);
	
	  // constants
	  var reviewTVM = this;
	
	  var currentRoleId = JSON.parse($cookies.get('hasRoleId'));
	  var user = JSON.parse($cookies.get('currentUser'));
	  reviewTVM.teacher = $stateParams.name;
	  if (!reviewTVM.teacher) {
	    reviewTVM.teacher = user.name;
	  }
	
	  reviewTVM.mainLabel = $state.current.data.displayName;
	  reviewTVM.courses = [];
	
	  var colorClass = ['text-gris-dark', 'text-azul', 'text-rojo', 'text-verde'];
	  var iconClasses = ['mdi-hardware-keyboard-arrow-down', 'mdi-hardware-keyboard-arrow-up'];
	
	  // variables
	
	  // teacher ID varies depending of view
	  var teacherId = $stateParams.teacherId;
	  if (!teacherId) {
	    teacherId = JSON.parse($cookies.get('currentUser')).teacherId;
	  }
	
	  reviewTVM.iconClass = iconClasses[0];
	  reviewTVM.showData = false;
	  reviewTVM.viewLoaded = true;
	  reviewTVM.criteriaFilter = '';
	  reviewTVM.selectedCourse = null;
	  reviewTVM.detailsData = null;
	  reviewTVM.classEye = colorClass[0];
	  reviewTVM.approvedHand = colorClass[0];
	  reviewTVM.repprovedHand = colorClass[0];
	  reviewTVM.selectedWorkplan = {};
	  reviewTVM.isLoadingDetails = false;
	  reviewTVM.details = details;
	
	  // methods
	  reviewTVM.tagClass = tagClass;
	  reviewTVM.courseBckgrd = courseBckgrd;
	  reviewTVM.courseText = courseText;
	  reviewTVM.toggleChevron = toggleChevron;
	  reviewTVM.getReviewData = getReviewData;
	  reviewTVM.close = close;
	
	  // data validations
	  reviewTVM.thereIsDetails = thereIsDetails;
	
	  // services
	
	  activate();
	
	  function activate() {
	    return getReviewData();
	  }
	
	  function getReviewData() {
	
	    WorkPlanSrv.getCoursesIntern.getList().$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        reviewTVM.courses = dataReturn.listCoursesIntern;
	        // loadData(dataReturn)
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(listphd);
	    });
	  }
	
	  function getCourseDetails(course) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    WorkPlanSrv.getCoursesInternDetail.getList({ courseId: course.courseId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        reviewTVM.detailsData = dataReturn.listCoursesInternDetail[0];
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log();
	    });
	
	    if (!reload) {
	      reviewTVM.isLoadingDetails = true;
	      reviewTVM.detailsData = null;
	    }
	
	    reviewTVM.isLoadingDetails = false;
	  }
	
	  function strategicTracing() {
	    var newValue = reviewTVM.detailsData.isStrategicTracing === 1 ? 0 : 1;
	    if (newValue === 1) {
	      reviewTVM.classEye = colorClass[3];
	    } else {
	      reviewTVM.classEye = colorClass[0];
	    }
	    var header = {
	      idTeacher: teacherId,
	      idActivity: reviewTVM.selectedCourse.workplanTeacherActivityId,
	      idEvaluator: user.id,
	      idRol: currentRoleId,
	      isStrategicTracing: newValue
	    };
	    WorkPlanSrv.setStrategicTracing.post(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        reviewTVM.detailsData.isStrategicTracing = newValue;
	      } else {
	        if (newValue === 1) {
	          reviewTVM.classEye = colorClass[3];
	        } else {
	          reviewTVM.classEye = colorClass[0];
	        }
	      }
	    });
	  }
	
	  function toggleChevron() {
	    if (reviewTVM.showData) {
	      reviewTVM.iconClass = iconClasses[0];
	      reviewTVM.showData = false;
	    } else {
	      reviewTVM.iconClass = iconClasses[1];
	      reviewTVM.showData = true;
	    }
	  }
	
	  function thereIsDetails() {
	    return reviewTVM.detailsData !== null;
	  }
	
	  function tagClass(course) {
	    return 'azul';
	  }
	
	  function courseBckgrd(course) {
	    if (reviewTVM.selectedCourse === course) {
	      return 'bg-review';
	    }
	  }
	
	  function courseText(course) {
	    if (reviewTVM.selectedCourse === course) {
	      return 'text-color-w';
	    }
	  }
	
	  function details(course) {
	    reviewTVM.selectedCourse = course;
	    getCourseDetails(course);
	  }
	
	  function thereIsDetails() {
	    return reviewTVM.detailsData !== null;
	  }
	
	  function close() {
	    if ($state.current.name === 'workplan.teachingJobsReview') {
	      return $state.go('workplan.teachingDevelopment');
	    } else {
	      return $mdDialog.hide();
	    }
	  }
	};
	
	exports.default = ReviewTeacherDevelopmentCtrl;
	
	
	ReviewTeacherDevelopmentCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog'];

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProjectFormulationProposalsListCtrl = function ProjectFormulationProposalsListCtrl($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
	  _classCallCheck(this, ProjectFormulationProposalsListCtrl);
	
	  // constants
	  var projectVM = this;
	  projectVM.currentUser = JSON.parse($cookies.get('currentUser'));
	  projectVM.subModuleId = JSON.parse($cookies.get('subModuleId'));
	  projectVM.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  projectVM.$sessionStorage = $sessionStorage;
	
	  var post = {
	    teacherId: projectVM.currentUser.teacherId,
	    workplanId: projectVM.currentUser.workplanId
	
	    // variables
	  };projectVM.showData = false;
	  projectVM.viewLoaded = false;
	  projectVM.criteriaFilter = '';
	  projectVM.selectedProposal = null;
	  projectVM.detailsData = null;
	  projectVM.proposals = [];
	  projectVM.imgEmpty = __webpack_require__(445);
	  projectVM.sr = '';
	  projectVM.searchValue = false;
	  projectVM.feedback = 0;
	  projectVM.planningFinish = true;
	  projectVM.active = GlobalConfig.generals.active;
	  projectVM.notActive = GlobalConfig.generals.notActive;
	  $scope.classPlanning = '';
	
	  // methods
	  projectVM.details = details;
	  projectVM.updateSearchView = updateSearchView;
	  projectVM.tagClas = tagClass;
	  projectVM.proposalBckgrd = proposalBckgrd;
	  projectVM.proposalText = proposalText;
	  projectVM.getReviewData = getReviewData;
	  projectVM.close = close;
	  projectVM.confirmDeleteProposal = confirmDeleteProposal;
	  projectVM.thereIsDetails = thereIsDetails;
	  projectVM.updateFilter = updateFilter;
	  projectVM.download = download;
	  projectVM.getGeneralsWorkplan = getGeneralsWorkplan;
	  projectVM.bitacora = bitacora;
	
	  angular.extend(projectVM, {
	    isLoadingDetails: false,
	    filter: ''
	  });
	
	  activate();
	
	  function download() {
	    var HTML = document.getElementById('doc');
	    var title = '<h2>' + projectVM.detailsData.titleProject + '</h2>';
	    var xt = HTML.getElementsByClassName("export")[0].innerHTML;
	    var htmlDocument = '<html><head><meta charset="utf-8"></head><body>' + title + xt + '</body></html>';
	    var dataUri = 'data:text/html,' + encodeURIComponent(htmlDocument);
	    projectVM.direct = dataUri;
	    return false;
	  }
	
	  function activate() {
	    if (projectVM.workPlanGeneralList != undefined) {
	      projectVM.status = projectVM.workPlanGeneralList.wokplanTeacherStatus[0];
	      projectVM.stages = projectVM.workPlanGeneralList.stages;
	      projectVM.feedback = projectVM.status.feedbackReviewed;
	      projectVM.workplanTeacherId = projectVM.status.workplanTeacherId;
	      isPlanning(projectVM.status, projectVM.stages);
	
	      if (projectVM.feedback && !projectVM.planningFinish) {
	        getReviewDataReject();
	      } else {
	        getReviewData();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (projectVM.feedback && !projectVM.planningFinish) {
	          getReviewDataReject();
	        } else {
	          getReviewData();
	        }
	      });
	    }
	  }
	
	  function getReviewData() {
	
	    WorkPlanSrv.getListFormulatedExtensionProjects.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectVM.proposals = dataReturn.listExtension;
	        if (projectVM.proposals.length == 0) {
	          projectVM.detailsData = true;
	        }
	
	        for (var i = projectVM.proposals.length - 1; i >= 0; i--) {
	          if (projectVM.proposals[i].activityTypeId == GlobalConfig.typeProject.internalProject) {
	            projectVM.proposals[i].activityTypeName = 'Proyecto Interno';
	          } else {
	            projectVM.proposals[i].activityTypeName = 'Proyecto Transversal';
	          }
	        }
	
	        if (projectVM.proposals && projectVM.proposals.length > 0) projectVM.details(projectVM.proposals[0]);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function getReviewDataReject() {
	
	    WorkPlanSrv.getListFormulatedExtensionProjectsReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectVM.proposals = dataReturn.listExtension;
	        if (projectVM.proposals.length == 0) {
	          projectVM.detailsData = true;
	        }
	
	        if (projectVM.proposals.length == 0) projectVM.detailsData = 0;
	
	        for (var i = projectVM.proposals.length - 1; i >= 0; i--) {
	          if (projectVM.proposals[i].activityTypeId == GlobalConfig.typeProject.internalProject) {
	            projectVM.proposals[i].activityTypeName = 'Proyecto Interno';
	          } else {
	            projectVM.proposals[i].activityTypeName = 'Proyecto Transversal';
	          }
	        }
	
	        if (projectVM.proposals && projectVM.proposals.length > 0) projectVM.details(projectVM.proposals[0]);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function getProposalsDetails(proposals) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var callback = arguments[2];
	
	    WorkPlanSrv.getFormulatedExtensionProjectsById.get({ workplanTeacherActivityId: proposals.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectVM.detailsData = dataReturn.listExtension[0];
	        if (projectVM.detailsData.activityTypeId == GlobalConfig.typeProject.internalProject) {
	          projectVM.detailsData.activityTypeName = 'Proyecto Interno';
	        } else {
	          projectVM.detailsData.activityTypeName = 'Proyecto Transversal';
	        }
	        //projectVM.detailsData.startDate = moment(projectVM.detailsData.startDate).format('DD/MM/YYYY')
	        //projectVM.detailsData.endDate = moment(projectVM.detailsData.endDate).format('DD/MM/YYYY')
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log();
	    });
	
	    if (!reload) {
	      projectVM.isLoadingDetails = true;
	      projectVM.detailsData = null;
	    }
	    callback;
	  }
	
	  function thereIsDetails() {
	    return Boolean(projectVM.detailsData);
	  }
	
	  function tagClass(proposal) {
	    return 'azul';
	  }
	
	  function proposalBckgrd(proposal) {
	    if (projectVM.selectedProposal === proposal) {
	      return 'bg-review';
	    }
	  }
	
	  function proposalText(proposal) {
	    if (projectVM.selectedProposal === proposal) {
	      return 'text-color-w';
	    }
	  }
	
	  function details(proposal) {
	    projectVM.detailsData = null;
	    projectVM.selectedProposal = proposal;
	    projectVM.isLoadingDetails = true;
	    getProposalsDetails(proposal, function () {
	      projectVM.isLoadingDetails = false;
	    });
	  }
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function updateFilter(val) {
	    projectVM.sr = validateSearch();
	    if (projectVM.sr.length == 0) {
	      console.log(projectVM.sr);
	      projectVM.searchValue = true;
	      projectVM.detailsData = null;
	    } else {
	      projectVM.searchValue = false;
	      if (projectVM.proposals && projectVM.proposals.length > 0) projectVM.details(projectVM.proposals[0]);
	    }
	  }
	
	  function updateSearchView() {
	    projectVM.viewLoaded = true;
	    projectVM.viewLoaded = false;
	    $timeout(function () {
	      projectVM.viewLoaded = true;
	    }, 100);
	  }
	
	  function confirmDeleteProposal(proposal) {
	    var name = proposal.titleProject;
	    var workplanTeacherActivityId = proposal.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.name = name;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.delete = function () {
	          WorkPlanSrv.disableActivityResearch.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeFromlist(proposal);
	              showDeletedSuccessfully(ctrlModalVM.name);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(781),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(name) {
	
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: name,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeFromlist(proposal) {
	    for (var i in projectVM.proposals) {
	      if (projectVM.proposals[i].workplanTeacherActivityId === proposal.workplanTeacherActivityId) {
	        projectVM.proposals.splice(i, 1);
	        updateSearchView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectVM.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        projectVM.status = dataReturn.data.wokplanTeacherStatus[0];
	        projectVM.stages = dataReturn.data.stages;
	        projectVM.feedback = projectVM.status.feedbackReviewed;
	        projectVM.workplanTeacherId = projectVM.status.workplanTeacherId;
	        isPlanning(projectVM.status, projectVM.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    projectVM.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        projectVM.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == projectVM.active) {
	        projectVM.planningFinish = true;
	        if (projectVM.startDateReview < projectVM.currentDate || status.reviewedFinish == projectVM.active) {
	          projectVM.planningFinish = true;
	        } else if (status.reviewedReject == projectVM.active) {
	          projectVM.planningFinish = false;
	        }
	      } else {
	        projectVM.planningFinish = false;
	      }
	    } else {
	      projectVM.planningFinish = true;
	    }
	
	    $scope.classPlanning = projectVM.planningFinish ? "disabled" : " ";
	  }
	
	  function validateSearch() {
	    return $filter('filter')(projectVM.proposals, projectVM.criteriaFilter);
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.internalProjectsFormulation,
	      workplanTeacherId: projectVM.workplanTeacherId
	    };
	    entries.title = 'Formulación de propuesta de extensión';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = ProjectFormulationProposalsListCtrl;
	
	
	ProjectFormulationProposalsListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage'];

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la formulación de propuesta de extensión <strong>\"{{ ctrlModalVM.name }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.delete()>Sí, eliminar propuesta</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateProjectFormulationProposalCtrl = function () {
	  function CreateProjectFormulationProposalCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateProjectFormulationProposalCtrl);
	
	    var createProjectFormulationProposalVm = this;
	    var texts = GlobalConfig.appTexts;
	
	    createProjectFormulationProposalVm.currentUser = JSON.parse($cookies.get('currentUser'));
	
	    var post = {
	      teacherId: createProjectFormulationProposalVm.currentUser.teacherId,
	      workplanId: createProjectFormulationProposalVm.currentUser.workplanId,
	      name: createProjectFormulationProposalVm.currentUser.name
	    };
	
	    createProjectFormulationProposalVm.isEditing = Boolean($stateParams.workplanTeacherActivityId);
	    createProjectFormulationProposalVm.typePeriod = [];
	    createProjectFormulationProposalVm.projectTypes = [];
	    createProjectFormulationProposalVm.financiers = [];
	    createProjectFormulationProposalVm.financiersArray = [];
	    createProjectFormulationProposalVm.hoursPlanned = null;
	    createProjectFormulationProposalVm.periodsArray = [];
	    createProjectFormulationProposalVm.isTouchedPeriods = false;
	    createProjectFormulationProposalVm.rangeType = GlobalConfig.periods.rangeType;
	    createProjectFormulationProposalVm.startDate = null;
	    createProjectFormulationProposalVm.endDate = null;
	    createProjectFormulationProposalVm.planningFinish = true;
	    createProjectFormulationProposalVm.minStartDate = moment().toDate();
	    createProjectFormulationProposalVm.minEndDate = new Date();
	    createProjectFormulationProposalVm.createOrEdit = 'Crear';
	    createProjectFormulationProposalVm.potentialAllies = '';
	    createProjectFormulationProposalVm.textCreateOrEdit = texts.saved;
	    createProjectFormulationProposalVm.isSaveButtonDisabled = false;
	    createProjectFormulationProposalVm.createOrEditMV = texts.createDialog;
	    createProjectFormulationProposalVm.isFeedback = createProjectFormulationProposalVm.currentUser.isFeedback;
	    createProjectFormulationProposalVm.dt_start = $cookies.get('wp_start');
	    createProjectFormulationProposalVm.dt_end = $cookies.get('wp_end');
	
	    createProjectFormulationProposalVm.funSelectedPeriod = funSelectedPeriod;
	    createProjectFormulationProposalVm.funSelectedFinancier = funSelectedFinancier;
	    createProjectFormulationProposalVm.hasError = hasError;
	    createProjectFormulationProposalVm.showErrorMessages = showErrorMessages;
	    createProjectFormulationProposalVm.addProjectFormulationProposal = addProjectFormulationProposal;
	    createProjectFormulationProposalVm.validateForm = validateForm;
	    createProjectFormulationProposalVm.validateCheklistPeriods = validateCheklistPeriods;
	    createProjectFormulationProposalVm.startDateChange = startDateChange;
	    createProjectFormulationProposalVm.cleanRangeType = cleanRangeType;
	    createProjectFormulationProposalVm.close = close;
	
	    createProjectFormulationProposalVm.updateRangeType = function (val) {
	      createProjectFormulationProposalVm.rangeType = val;
	      createProjectFormulationProposalVm.periodsArray = [];
	      createProjectFormulationProposalVm.startDate = null;
	      createProjectFormulationProposalVm.endDate = null;
	    };
	    createProjectFormulationProposalVm.updateRangeData = function (val) {
	      createProjectFormulationProposalVm.periodsArray = val['periods'];
	      createProjectFormulationProposalVm.startDate = val['dates'][0];
	      createProjectFormulationProposalVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createProjectFormulationProposalVm.isEditing) {
	        createProjectFormulationProposalVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createProjectFormulationProposalVm.createOrEdit = 'Editar';
	        createProjectFormulationProposalVm.createOrEditMV = texts.editDialog;
	        createProjectFormulationProposalVm.textCreateOrEdit = texts.modified;
	        getDataProposal();
	      }
	
	      WorkPlanSrv.getListFormulatedExtensionProjects.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log();
	      });
	    }
	
	    function loadData(data) {
	      createProjectFormulationProposalVm.typePeriod = data.listPeriods;
	      createProjectFormulationProposalVm.projectTypes = data.listFormulation.items;
	      createProjectFormulationProposalVm.financiers = data.listFinancial;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createProjectFormulationProposalVm.periodsArray.includes(period.periodId)) {
	          createProjectFormulationProposalVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createProjectFormulationProposalVm.periodsArray.indexOf(period.periodId);
	        if (index !== -1) {
	          createProjectFormulationProposalVm.periodsArray.splice(index, 1);
	        }
	      }
	      createProjectFormulationProposalVm.isTouchedPeriods = true;
	    }
	
	    function funSelectedFinancier(financier, checked) {
	      if (checked) {
	        if (!createProjectFormulationProposalVm.financiersArray.includes(financier.financialId)) {
	          createProjectFormulationProposalVm.financiersArray.push(financier.financialId);
	        }
	      } else {
	        var index = createProjectFormulationProposalVm.financiersArray.indexOf(financier.financialId);
	        if (index !== -1) {
	          createProjectFormulationProposalVm.financiersArray.splice(index, 1);
	        }
	      }
	    }
	
	    function startDateChange() {
	      var m = moment(createProjectFormulationProposalVm.startDate);
	      createProjectFormulationProposalVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createProjectFormulationProposalVm.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return createProjectFormulationProposalVm.rangeType == 1 ? createProjectFormulationProposalVm.periodsArray.length < 1 : false;
	    }
	
	    function addProjectFormulationProposal(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var proposal = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        titleProject: createProjectFormulationProposalVm.title,
	        summary: createProjectFormulationProposalVm.summary,
	        observation: createProjectFormulationProposalVm.observation,
	        potencialAllies: createProjectFormulationProposalVm.potentialAllies,
	        hoursPlanning: createProjectFormulationProposalVm.hoursPlanned,
	        idFormulation: createProjectFormulationProposalVm.projectType,
	        activityId: GlobalConfig.minorActivityId.proposal,
	        origin: origin,
	        timeRangeTypeId: createProjectFormulationProposalVm.rangeType,
	        isFeedbackActivity: createProjectFormulationProposalVm.isFeedback
	      };
	
	      if (createProjectFormulationProposalVm.isEditing) {
	        proposal.workplanTeacherActivityId = createProjectFormulationProposalVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createProjectFormulationProposalVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createProjectFormulationProposalVm.periodsArray) {
	          var temp = {
	            periodId: createProjectFormulationProposalVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        proposal.periods = arrayPeriod;
	      } else {
	        proposal.startDate = new Date(createProjectFormulationProposalVm.startDate);
	        proposal.endDate = new Date(createProjectFormulationProposalVm.endDate);
	      }
	
	      // FINANCIERS
	      var arrayFinancier = [];
	      for (var index in createProjectFormulationProposalVm.financiersArray) {
	        var temp = {
	          financialId: createProjectFormulationProposalVm.financiersArray[index]
	        };
	        arrayFinancier.push(temp);
	      }
	      proposal.financial = arrayFinancier.length !== 0 ? arrayFinancier : null;
	
	      addOrEditFormulationProposal(proposal);
	    }
	
	    function addOrEditFormulationProposal(proposal) {
	      createProjectFormulationProposalVm.isSaveButtonDisabled = true;
	      WorkPlanSrv.addProjectsExtensionFormulated.save(proposal).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getSendNotify(proposal.origin);
	          confirmAction();
	        } else {
	          createProjectFormulationProposalVm.isSaveButtonDisabled = false;
	        }
	      }, function (data) {
	        createProjectFormulationProposalVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function confirmAction() {
	      var header = {
	        createOrEdit: createProjectFormulationProposalVm.createOrEditMV,
	        textCreateOrEdit: createProjectFormulationProposalVm.textCreateOrEdit,
	        itemName: createProjectFormulationProposalVm.title,
	        nameModal: texts.modalTypeName.projectFormulationExt,
	        modalType: texts.modalTypeId.projectFormulationExt
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getDataProposal() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createProjectFormulationProposalVm.workplanTeacherActivityId)
	      };
	      WorkPlanSrv.getExtensionProjectsById.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.listExtension[0]);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(proposal) {
	      var dateValueSetter = function dateValueSetter(date) {
	        return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null;
	      };
	      createProjectFormulationProposalVm.title = proposal.titleProject;
	      createProjectFormulationProposalVm.summary = proposal.summary;
	      createProjectFormulationProposalVm.observation = proposal.observation;
	      createProjectFormulationProposalVm.potentialAllies = proposal.potencialAllies;
	      createProjectFormulationProposalVm.hoursPlanned = proposal.hoursPlanned;
	      createProjectFormulationProposalVm.projectType = proposal.idFormulation;
	      createProjectFormulationProposalVm.rangeType = proposal.timeRangeTypeId;
	      createProjectFormulationProposalVm.dt_start = dateValueSetter(proposal.startDate);
	      createProjectFormulationProposalVm.dt_end = dateValueSetter(proposal.endDate);
	      createProjectFormulationProposalVm.periodsArray = [];
	      createProjectFormulationProposalVm.selectedTypePeriod = {};
	      createProjectFormulationProposalVm.financiersArray = [];
	      createProjectFormulationProposalVm.selectedFinancier = {};
	
	      if (createProjectFormulationProposalVm.rangeType === GlobalConfig.periods.rangeType) {
	        createProjectFormulationProposalVm.periodsArray = proposal.periodId.split(',').map(function (id) {
	          createProjectFormulationProposalVm.selectedTypePeriod[Number(id)] = true;
	          return Number(id);
	        });
	      }
	      // financiers
	      if (proposal.idFinanciers) {
	        createProjectFormulationProposalVm.financiersArray = proposal.idFinanciers.split(',').map(function (id) {
	          createProjectFormulationProposalVm.selectedFinancier[Number(id)] = true;
	          return Number(id);
	        });
	      }
	
	      if (proposal.startDate) {
	        var startDateNew = moment(proposal.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createProjectFormulationProposalVm.minStartDate = moment(proposal.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createProjectFormulationProposalVm.isEditing = true;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createProjectFormulationProposalVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createProjectFormulationProposalVm.startDate = null;
	        createProjectFormulationProposalVm.endDate = null;
	      } else {
	        createProjectFormulationProposalVm.periodsArray = [];
	        createProjectFormulationProposalVm.selectedTypePeriod = null;
	      }
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El profesor ' + createProjectFormulationProposalVm.currentUser.dsFullname + ' ha registrado una nueva formulación de proyecto en la etapa de planeación.';
	      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
	        msg = 'El profesor ' + createProjectFormulationProposalVm.currentUser.dsFullname + ' ha registrado una nueva formulación de proyecto en la etapa de ejecución.';
	      }
	      var data = {
	        idTeacher: post.teacherId,
	        dsName: 'Notificación, se agregó o editó una formulación de proyecto',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1,
	        submodule: GlobalConfig.modules.extentionAndVisibility
	      };
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data);
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateProjectFormulationProposalCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateProjectFormulationProposalCtrl;
	}();
	
	exports.default = CreateProjectFormulationProposalCtrl;
	
	
	CreateProjectFormulationProposalCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateExtensionProjectCtrl = function () {
	  function CreateExtensionProjectCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateExtensionProjectCtrl);
	
	    var createExtensionProjectVm = this;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var texts = GlobalConfig.appTexts;
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId,
	      name: currentUser.name
	    };
	
	    createExtensionProjectVm.idParent = WorkPlanModalSrv.getVariable();
	    createExtensionProjectVm.isEditing = Boolean($stateParams.workplanTeacherActivityId);
	    createExtensionProjectVm.createOrEdit = 'Agregar';
	    createExtensionProjectVm.textCreateOrEdit = texts.saved;
	    createExtensionProjectVm.createOrEditMV = texts.createDialog;
	    createExtensionProjectVm.typePeriod = [];
	    createExtensionProjectVm.projectTypes = [];
	    createExtensionProjectVm.financiers = [];
	    createExtensionProjectVm.projectRoles = [];
	    createExtensionProjectVm.acUnits = [];
	    createExtensionProjectVm.projectStatusP = [];
	    createExtensionProjectVm.financiersArray = [];
	    createExtensionProjectVm.periodsArray = [];
	    createExtensionProjectVm.isTouchedPeriods = false;
	    createExtensionProjectVm.rangeType = GlobalConfig.periods.rangeType;
	    createExtensionProjectVm.startDate = null;
	    createExtensionProjectVm.endDate = null;
	    createExtensionProjectVm.minStartDate = moment().toDate();
	    createExtensionProjectVm.minEndDate = new Date();
	    createExtensionProjectVm.isSaveButtonDisabled = false;
	    createExtensionProjectVm.isFeedback = currentUser.isFeedback;
	    createExtensionProjectVm.dt_start = $cookies.get('wp_start');
	    createExtensionProjectVm.dt_end = $cookies.get('wp_end');
	
	    // createExtensionProjectVm.hoursChildren = 0
	    createExtensionProjectVm.hoursChildren = GlobalConfig.hoursChildren.generalProject;
	
	    createExtensionProjectVm.funSelectedPeriod = funSelectedPeriod;
	    createExtensionProjectVm.funSelectedFinancier = funSelectedFinancier;
	    createExtensionProjectVm.hasError = hasError;
	    createExtensionProjectVm.showErrorMessages = showErrorMessages;
	    createExtensionProjectVm.addExtensionProject = addExtensionProject;
	    createExtensionProjectVm.addActivityProject = addActivityProject;
	    createExtensionProjectVm.validateForm = validateForm;
	    createExtensionProjectVm.validateForma = validateForma;
	    createExtensionProjectVm.validateCheklistPeriods = validateCheklistPeriods;
	    createExtensionProjectVm.startDateChange = startDateChange;
	    createExtensionProjectVm.cleanRangeType = cleanRangeType;
	    createExtensionProjectVm.close = close;
	
	    createExtensionProjectVm.updateRangeType = function (val) {
	      createExtensionProjectVm.rangeType = val;
	      createExtensionProjectVm.periodsArray = [];
	      createExtensionProjectVm.startDate = null;
	      createExtensionProjectVm.endDate = null;
	    };
	    createExtensionProjectVm.updateRangeData = function (val) {
	      createExtensionProjectVm.periodsArray = val['periods'];
	      createExtensionProjectVm.startDate = val['dates'][0];
	      createExtensionProjectVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createExtensionProjectVm.isEditing) {
	        createExtensionProjectVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createExtensionProjectVm.activityId = GlobalConfig.minorActivityId.extensionProjectParent;
	        createExtensionProjectVm.createOrEdit = 'Editar';
	        createExtensionProjectVm.createOrEditMV = texts.editDialog;
	        createExtensionProjectVm.textCreateOrEdit = texts.modified;
	        getDataProject();
	      }
	
	      if (createExtensionProjectVm.idParent) {
	        createExtensionProjectVm.workplanTeacherActivityId = createExtensionProjectVm.idParent.children.workplanTeacherActivityId;
	        if (createExtensionProjectVm.idParent.children !== 'ADD') {
	          createExtensionProjectVm.createOrEdit = 'Editar';
	          createExtensionProjectVm.createOrEditMV = texts.editDialog;
	          createExtensionProjectVm.textCreateOrEdit = texts.modified;
	          setValues(createExtensionProjectVm.idParent.children, createExtensionProjectVm.idParent.hoursChildren);
	        } else {
	          createExtensionProjectVm.hoursChildren = createExtensionProjectVm.idParent.hoursChildren ? createExtensionProjectVm.idParent.hoursChildren : 0;
	        }
	      }
	
	      WorkPlanSrv.getDataFormProjectsExtension.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function loadData(data) {
	      createExtensionProjectVm.financiers = data.listFinancial;
	      createExtensionProjectVm.projectTypes = data.listInternalProject.items;
	      createExtensionProjectVm.projectRoles = data.listRole.items;
	      createExtensionProjectVm.assocProposals = data.listPorjectsFormulated;
	      createExtensionProjectVm.acUnits = data.academicUnit;
	      createExtensionProjectVm.typePeriod = data.listPeriods;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createExtensionProjectVm.periodsArray.includes(period.periodId)) {
	          createExtensionProjectVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createExtensionProjectVm.periodsArray.indexOf(period.periodId);
	        if (index !== -1) {
	          createExtensionProjectVm.periodsArray.splice(index, 1);
	        }
	      }
	      createExtensionProjectVm.isTouchedPeriods = true;
	    }
	
	    function funSelectedFinancier(financier, checked) {
	      if (checked) {
	        if (!createExtensionProjectVm.financiersArray.includes(financier.financialId)) {
	          createExtensionProjectVm.financiersArray.push(financier.financialId);
	        }
	      } else {
	        var index = createExtensionProjectVm.financiersArray.indexOf(financier.financialId);
	        if (index !== -1) {
	          createExtensionProjectVm.financiersArray.splice(index, 1);
	        }
	      }
	    }
	
	    function startDateChange() {
	      var m = moment(createExtensionProjectVm.startDate);
	      createExtensionProjectVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createExtensionProjectVm.validateCheklistPeriods();
	    }
	
	    function validateForma(form) {
	      return form.$invalid || createExtensionProjectVm.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return createExtensionProjectVm.rangeType == 1 ? createExtensionProjectVm.periodsArray.length < 1 : false;
	    }
	
	    function close() {
	      WorkPlanModalSrv.setVariable({ status: false });
	      return $mdDialog.hide();
	    }
	
	    function addExtensionProject(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var project = {
	        activityId: GlobalConfig.minorActivityId.extensionProjectParent,
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createExtensionProjectVm.title,
	        description: createExtensionProjectVm.description,
	        hoursPlanning: createExtensionProjectVm.plannedHours,
	        porjectsFormulatedId: createExtensionProjectVm.assocProposal,
	        itemRoleId: createExtensionProjectVm.projectRole,
	        itemTypePorjectId: createExtensionProjectVm.projectType,
	        academicUnitId: createExtensionProjectVm.acUnit,
	        timeRangeTypeId: createExtensionProjectVm.rangeType,
	        origin: origin,
	        hoursChildren: parseInt(createExtensionProjectVm.hoursChildren),
	        isFeedbackActivity: createExtensionProjectVm.isFeedback
	
	        // Financiadores
	      };var arrayFinancial = [];
	      for (var index in createExtensionProjectVm.financiersArray) {
	        var temp = {
	          financialId: createExtensionProjectVm.financiersArray[index]
	        };
	        arrayFinancial.push(temp);
	      }
	      project.financial = arrayFinancial.length !== 0 ? arrayFinancial : null;
	
	      if (createExtensionProjectVm.isEditing) {
	        project.workplanTeacherActivityId = createExtensionProjectVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createExtensionProjectVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createExtensionProjectVm.periodsArray) {
	          var temp = {
	            periodId: createExtensionProjectVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        project.periods = arrayPeriod;
	      } else {
	        project.startDate = createExtensionProjectVm.startDate;
	        project.endDate = createExtensionProjectVm.endDate;
	      }
	      createExtensionProjectVm.modalType = texts.modalTypeId.extensionProject;
	      addOrEditProject(project, createExtensionProjectVm.modalType);
	    }
	
	    function addOrEditProject(project, modalType) {
	      var action = 'ADD';
	      if (createExtensionProjectVm.workplanTeacherActivityId) {
	        action = 'EDIT';
	      }
	      createExtensionProjectVm.isSaveButtonDisabled = true;
	      WorkPlanSrv.addActivityProjectExtension.save(project).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          project.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	          project.hoursPlanned = project.hoursPlanning;
	          if (isExtensionProject(modalType)) {
	            getSendNotify(project.origin);
	            confirmProjectAction(modalType);
	          } else {
	            WorkPlanModalSrv.setVariable({ status: dataReturn.status, child: project, action: action });
	            confirmProjectAction(modalType);
	            return $mdDialog.hide();
	          }
	        } else {
	          createExtensionProjectVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        createExtensionProjectVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function confirmProjectAction(modalType) {
	      var header = {
	        createOrEdit: createExtensionProjectVm.createOrEditMV,
	        textCreateOrEdit: createExtensionProjectVm.textCreateOrEdit,
	        itemName: createExtensionProjectVm.title,
	        nameModal: isExtensionProject(modalType) ? texts.modalTypeName.extensionProject : texts.modalTypeName.activity,
	        modalType: modalType
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getDataProject() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createExtensionProjectVm.workplanTeacherActivityId)
	      };
	      WorkPlanSrv.getProjectExtensionByActivityId.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          if (!dataReturn.data.parent) {
	            createExtensionProjectVm.project = dataReturn.data.childs[0];
	          } else {
	            createExtensionProjectVm.project = dataReturn.data.parent;
	          }
	          setValues(createExtensionProjectVm.project, createExtensionProjectVm.project.hoursChildren);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(project, hoursChildren) {
	      var dateValueSetter = function dateValueSetter(date) {
	        return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null;
	      };
	      createExtensionProjectVm.title = project.name;
	      createExtensionProjectVm.acUnit = project.academicUnitId;
	      createExtensionProjectVm.assocProposal = project.projectFormulatedId;
	      createExtensionProjectVm.projectType = project.listItemProjectTypeId;
	      createExtensionProjectVm.projectRole = project.listItemProjectRoleId;
	      createExtensionProjectVm.description = project.description;
	      createExtensionProjectVm.rangeType = project.timeRangeTypeId;
	      createExtensionProjectVm.dt_start = dateValueSetter(project.startDate);
	      createExtensionProjectVm.dt_end = dateValueSetter(project.endDate);
	      createExtensionProjectVm.plannedHours = project.hoursPlanned;
	      createExtensionProjectVm.notification = Boolean(project.isNotification === 1);
	      createExtensionProjectVm.periodsArray = [];
	      createExtensionProjectVm.selectedTypePeriod = {};
	      createExtensionProjectVm.financiersArray = [];
	      createExtensionProjectVm.selectedFinancier = {};
	      createExtensionProjectVm.hoursChildren = hoursChildren ? hoursChildren : 0;
	
	      if (createExtensionProjectVm.rangeType == GlobalConfig.periods.rangeType) {
	        createExtensionProjectVm.periodsArray = project.periodId.split(',').map(function (id) {
	          createExtensionProjectVm.selectedTypePeriod[Number(id)] = true;
	          return Number(id);
	        });
	      }
	
	      if (project.financialSourceId) {
	        createExtensionProjectVm.financiersArray = project.financialSourceId.split(',').map(function (id) {
	          createExtensionProjectVm.selectedFinancier[Number(id)] = true;
	          return Number(id);
	        });
	      }
	
	      if (project.startDate) {
	        var startDateNew = moment(project.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createExtensionProjectVm.minStartDate = moment(project.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createExtensionProjectVm.isEditing = true;
	    }
	
	    function addActivityProject(activity) {
	      createJsonActivity();
	    }
	
	    function createJsonActivity() {
	      var activity = {
	        activityId: GlobalConfig.minorActivityId.extensionProjectChild,
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createExtensionProjectVm.title,
	        description: createExtensionProjectVm.description,
	        hoursPlanning: createExtensionProjectVm.plannedHours,
	        parentActivityId: createExtensionProjectVm.idParent.workplanTeacherActivityIdParent,
	        hoursChildren: createExtensionProjectVm.idParent.hoursChildren,
	        timeRangeTypeId: createExtensionProjectVm.rangeType,
	        isFeedbackActivity: createExtensionProjectVm.isFeedback
	      };
	
	      if (activity.hoursChildren == 0) {
	        activity.hoursPlanning = 0;
	      }
	
	      if (createExtensionProjectVm.rangeType === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        var aux = [];
	        for (var index in createExtensionProjectVm.periodsArray) {
	          var temp = {
	            periodId: createExtensionProjectVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	          aux.push(createExtensionProjectVm.periodsArray[index]);
	        }
	        activity.periods = arrayPeriod;
	        activity.periodId = aux.join(',');
	      } else {
	        activity.startDate = createExtensionProjectVm.startDate;
	        activity.endDate = createExtensionProjectVm.endDate;
	      }
	      if (createExtensionProjectVm.isEditing) {
	        activity.workplanTeacherActivityId = createExtensionProjectVm.workplanTeacherActivityId;
	      }
	
	      createExtensionProjectVm.modalType = texts.modalTypeId.activity;
	      addOrEditProject(activity, createExtensionProjectVm.modalType);
	    }
	
	    function isExtensionProject(value) {
	      return value == texts.modalTypeId.extensionProject;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createExtensionProjectVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createExtensionProjectVm.startDate = null;
	        createExtensionProjectVm.endDate = null;
	      } else {
	        createExtensionProjectVm.periodsArray = [];
	        createExtensionProjectVm.selectedTypePeriod = null;
	      }
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado un nuevo proyecto interno en la etapa de ';
	      if (origin == GlobalConfig.activityTypeId.originActivityExecution) msg = msg + 'ejecución.';else msg = msg + 'planeación.';
	
	      var data = {
	        idTeacher: currentUser.teacherId,
	        dsName: 'Notificación, se agregó o editó un proyecto interno',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1
	      };
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data);
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateExtensionProjectCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateExtensionProjectCtrl;
	}();
	
	exports.default = CreateExtensionProjectCtrl;
	
	
	CreateExtensionProjectCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExtensionProjectsListCtrl = function ExtensionProjectsListCtrl($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
		_classCallCheck(this, ExtensionProjectsListCtrl);
	
		// constants
		var extensionVM = this;
		var currentUser = JSON.parse($cookies.get('currentUser'));
		var post = {
			teacherId: currentUser.teacherId,
			workplanId: currentUser.workplanId
		};
	
		extensionVM.viewLoaded = true;
		extensionVM.criteriaFilter = '';
		extensionVM.projectParent = null;
		extensionVM.details = details;
		extensionVM.updateSearchView = updateSearchView;
		extensionVM.imgEmpty = __webpack_require__(445);
		extensionVM.sr = '';
		extensionVM.searchValue = false;
		extensionVM.feedback = 0;
		extensionVM.planningFinish = true;
		extensionVM.active = GlobalConfig.generals.active;
		extensionVM.notActive = GlobalConfig.generals.notActive;
		extensionVM.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
		extensionVM.sessionStorage = $sessionStorage;
		$scope.classPlanning = '';
	
		// methods
		extensionVM.tagClas = tagClass;
		extensionVM.projectBckgrd = projectBckgrd;
		extensionVM.projectText = projectText;
		extensionVM.getReviewData = getReviewData;
		extensionVM.close = close;
		extensionVM.addActivityExtensionProject = addActivityExtensionProject;
		extensionVM.getGeneralsWorkplan = getGeneralsWorkplan;
		extensionVM.updateFilter = updateFilter;
		extensionVM.download = download;
		extensionVM.downloadCross = downloadCross;
		extensionVM.bitacora = bitacora;
		extensionVM.disableProjectActivyId = disableProjectActivyId;
	
		// data validations
		extensionVM.thereIsDetails = thereIsDetails;
	
		// services
	
		angular.extend(extensionVM, {
			isLoadingDetails: false,
			filter: ''
		});
	
		activate();
	
		function activate() {
			if (extensionVM.workPlanGeneralList != undefined) {
				extensionVM.status = extensionVM.workPlanGeneralList.wokplanTeacherStatus[0];
				extensionVM.stages = extensionVM.workPlanGeneralList.stages;
				extensionVM.feedback = extensionVM.status.feedbackReviewed;
				extensionVM.workplanTeacherId = extensionVM.status.workplanTeacherId;
				isPlanning(extensionVM.status, extensionVM.stages);
	
				if (extensionVM.feedback && !extensionVM.planningFinish) {
					getReviewDataReject();
				} else {
					getReviewData();
				}
			} else {
				getGeneralsWorkplan(post).then(function (promise) {
					if (extensionVM.feedback && !extensionVM.planningFinish) {
						getReviewDataReject();
					} else {
						getReviewData();
					}
				});
			}
		}
	
		function download() {
			var arrayChild = '';
			var titleChild = '';
			var date = new Date();
	
			date = moment(date).format('DDMMYYYY');
	
			if (extensionVM.projectChilds) {
				titleChild = 'Actividades en curso';
				for (var i = extensionVM.projectChilds.length - 1; i >= 0; i--) {
					arrayChild += extensionVM.projectChilds[i].name + ' - ' + extensionVM.projectChilds[i].hoursPlanned + 'hrs Planeadas \n';
				}
			}
	
			var docDefinition = {
				content: [{ text: extensionVM.projectParent.name, style: 'header' }, { text: 'Tipo de proyecto: ', style: 'title' }, extensionVM.projectParent.listItemProjectTypeName, { text: 'Rol en el proyecto:', style: 'title' }, extensionVM.projectParent.listItemProjectRoleName, { text: 'Unidad académica: ', style: 'title' }, extensionVM.projectParent.academicUnitName, { text: 'Financiadores: ', style: 'title' }, extensionVM.projectParent.financialSourceName, { text: 'Propuesta asociada: ', style: 'title' }, extensionVM.projectParent.projectFormulatedName],
				styles: {
					header: {
						fontSize: 16,
						bold: true,
						margin: [0, 10]
					},
					title: {
						bold: true
					}
				}
			};
	
			if (extensionVM.projectParent.timeRangeTypeId == 1) {
				docDefinition.content.push({ text: 'Período', style: 'title' }, extensionVM.projectParent.periodicityName);
			} else {
				docDefinition.content.push({ text: 'Fecha inicio: ', style: 'title' }, moment(extensionVM.projectParent.startDate).format('DD/MM/YYYY'));
				docDefinition.content.push({ text: 'Fecha fin: ', style: 'title' }, moment(extensionVM.projectParent.endDate).format('DD/MM/YYYY'));
			}
	
			docDefinition.content.push({ text: 'Descripción: ', style: 'title' }, extensionVM.projectParent.description, { text: titleChild, style: 'header' }, arrayChild);
	
			pdfMake.createPdf(docDefinition).download(extensionVM.projectParent.name + date + '.pdf');
		}
	
		function downloadCross() {
			var date = new Date();
	
			date = moment(date).format('DDMMYYYY');
			var docDefinition = {
				content: [{ text: extensionVM.projectParent.projectName, style: 'header' }, { text: 'Tipo de proyecto: ', style: 'title' }, extensionVM.projectParent.itemProjectTypeName, { text: 'Metodología:', style: 'title' }, extensionVM.projectParent.methodology, { text: 'Propósitos: ', style: 'title' }, extensionVM.projectParent.purposes, { text: 'Comunidades implicadas: ', style: 'title' }, extensionVM.projectParent.communities, { text: 'Objetivos: ', style: 'title' }, extensionVM.projectParent.objectives, { text: 'Resultados: ', style: 'title' }, extensionVM.projectParent.results, { text: 'Valor: ', style: 'title' }, extensionVM.projectParent.value, { text: 'Entidad: ', style: 'title' }, extensionVM.projectParent.entityType],
				styles: {
					header: {
						fontSize: 16,
						bold: true,
						margin: [0, 10]
					},
					title: {
						bold: true
					}
				}
			};
	
			pdfMake.createPdf(docDefinition).download(extensionVM.projectParent.projectName + date + '.pdf');
		}
	
		function getReviewData() {
			WorkPlanSrv.getDataFormProjectsExtension.getList(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					extensionVM.projects = dataReturn.listProjectsExtension;
					extensionVM.projectsCross = dataReturn.listProjectsCross;
					for (var i = extensionVM.projectsCross.length - 1; i >= 0; i--) {
						extensionVM.projects.push(extensionVM.projectsCross[i]);
					}
	
					if (extensionVM.projects.length == 0) {
						extensionVM.projectParent = true;
					}
	
					if (extensionVM.projects.length == 0) {
						extensionVM.projectParent = 0;
					}
	
					for (var i = extensionVM.projects.length - 1; i >= 0; i--) {
						if (extensionVM.projects[i].activityTypeId == GlobalConfig.typeProject.internal) {
							extensionVM.projects[i].activityTypeName = 'Proyecto Interno';
						} else {
							extensionVM.projects[i].activityTypeName = 'Proyecto Transversal';
						}
					}
	
					if (extensionVM.projects && extensionVM.projects.length > 0) {
						extensionVM.details(extensionVM.projects[0]);
					}
				} else {
					console.log('Comunications problem');
				}
			}, function (data) {
				console.log();
			});
		}
	
		function getReviewDataReject() {
			WorkPlanSrv.getDataFormProjectsExtensionReject.getList(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					extensionVM.projects = dataReturn.listProjectsExtension;
	
					if (extensionVM.projects.length == 0) {
						extensionVM.projectParent = true;
					}
	
					if (extensionVM.projects.length == 0) {
						extensionVM.projectParent = 0;
					}
	
					for (var i = extensionVM.projects.length - 1; i >= 0; i--) {
						if (extensionVM.projects[i].activityTypeId == GlobalConfig.typeProject.internal) {
							extensionVM.projects[i].activityTypeName = 'Proyecto Interno';
						} else {
							extensionVM.projects[i].activityTypeName = 'Proyecto Transversal';
						}
					}
	
					if (extensionVM.projects && extensionVM.projects.length > 0) {
						extensionVM.details(extensionVM.projects[0]);
					}
				} else {
					console.log('Comunications problem');
				}
			}, function (data) {});
		}
	
		function getProjectsDetails(project) {
			var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
			var callback = arguments[2];
	
			if (!project.isProjectCross) {
				WorkPlanSrv.getProjectExtensionByActivityId.get({ workplanTeacherActivityId: project.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						extensionVM.projectParent = dataReturn.data.parent;
						extensionVM.projectChilds = dataReturn.data.childs;
	
						if (!extensionVM.projectParent.projectFormulatedName) extensionVM.projectParent.projectFormulatedName = 'Sin propuesta asignada';
	
						if (extensionVM.projectParent.activityTypeId == GlobalConfig.typeProject.internalProject) {
							extensionVM.projectParent.activityTypeName = 'Proyecto Interno';
						} else {
							extensionVM.projectParent.activityTypeName = 'Proyecto Transversal';
						}
					} else {
						console.log('Comunications problem');
					}
				}, function (data) {
					console.log();
				});
			} else {
				WorkPlanSrv.getProjectsCrossById.get({ transversalProjectsId: project.transversalProjectsId }).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						extensionVM.projectParent = dataReturn.data;
					} else {
						console.log('Comunications problem');
					}
				}, function (data) {
					console.log();
				});
			}
	
			if (!reload) {
				extensionVM.isLoadingDetails = true;
				extensionVM.projectParent = null;
			}
	
			callback;
		}
	
		function thereIsDetails() {
			return Boolean(extensionVM.projectParent);
		}
	
		function tagClass(project) {
			return 'azul';
		}
	
		function projectBckgrd(project) {
			if (extensionVM.selectedProject === project) {
				return 'bg-review';
			}
		}
	
		function projectText(project) {
			if (extensionVM.selectedProject === project) {
				return 'text-color-w';
			}
		}
	
		function details(project) {
			extensionVM.projectParent = null;
			extensionVM.selectedProject = project;
			extensionVM.isLoadingDetails = true;
			getProjectsDetails(project, function () {
				extensionVM.isLoadingDetails = false;
			});
		}
	
		function close() {
			return $mdDialog.hide();
		}
	
		function updateSearchView() {
			extensionVM.viewLoaded = true;
			extensionVM.viewLoaded = false;
			$timeout(function () {
				extensionVM.viewLoaded = true;
			}, 100);
		}
	
		function addActivityExtensionProject(project, activity) {
			var header = {
				workplanTeacherActivityIdParent: project.workplanTeacherActivityId,
				children: activity || 'ADD',
				hoursChildren: project.hoursChildren
			};
	
			WorkPlanModalSrv.setVariable(header);
			WorkPlanModalSrv.addActivityExtensionProject().then(function (promise) {
				var shared = WorkPlanModalSrv.getVariable();
	
				if (shared.status) {
					if (shared.action == 'ADD') {
						extensionVM.projectChilds.push(shared.child);
					} else {
						for (var i = extensionVM.projectChilds.length - 1; i >= 0; i--) {
							if (extensionVM.projectChilds[i].workplanTeacherActivityId == shared.child.workplanTeacherActivityId) {
								extensionVM.projectChilds[i].name = shared.child.name;
								extensionVM.projectChilds[i].hoursPlanned = shared.child.hoursPlanned;
								extensionVM.projectChilds[i].description = shared.child.description;
							}
						}
					}
	
					if (project.hoursChildren == 1) {
						extensionVM.projectParent.hoursPlanned = hoursPlanned();
	
						for (var i = extensionVM.projects.length - 1; i >= 0; i--) {
							if (extensionVM.projects[i].workplanTeacherActivityId == extensionVM.projectParent.workplanTeacherActivityId) {
								extensionVM.projects[i].hoursPlanned = extensionVM.projectParent.hoursPlanned;
								break;
							}
						}
					}
				}
			});
		}
	
		function hoursPlanned() {
			var aux = 0;
	
			for (var i = extensionVM.projectChilds.length - 1; i >= 0; i--) {
				aux += extensionVM.projectChilds[i].hoursPlanned;
			}
	
			return aux;
		}
	
		function updateFilter(val) {
			extensionVM.sr = validateSearch();
	
			if (extensionVM.sr.length == 0) {
				extensionVM.searchValue = true;
				extensionVM.projectParent = null;
			} else {
				extensionVM.searchValue = false;
	
				if (extensionVM.projects && extensionVM.projects.length > 0) {
					extensionVM.details(extensionVM.projects[0]);
				}
			}
		}
	
		function validateSearch() {
			return $filter('filter')(extensionVM.projects, extensionVM.criteriaFilter);
		}
	
		function getGeneralsWorkplan(post) {
			return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					extensionVM.$sessionStorage.workPlanGeneralList = dataReturn.data;
					extensionVM.status = dataReturn.data.wokplanTeacherStatus[0];
					extensionVM.stages = dataReturn.data.stages;
					extensionVM.feedback = extensionVM.status.feedbackReviewed;
					extensionVM.workplanTeacherId = extensionVM.status.workplanTeacherId;
					isPlanning(extensionVM.status, extensionVM.stages);
				} else {
					console.log('Comunications problem with the server');
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function isPlanning(status, stages) {
			extensionVM.currentDate = moment(new Date()).format('DD/MM/YYYY');
			for (var i = stages.length - 1; i >= 0; i--) {
				if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
					extensionVM.startDateStage = stages[i].startDate;
				}
			}
	
			if (status.workplanActive) {
				if (status.planningFinish == extensionVM.active) {
					extensionVM.planningFinish = true;
	
					if (extensionVM.startDateReview < extensionVM.currentDate || status.reviewedFinish == extensionVM.active) {
						extensionVM.planningFinish = true;
					} else if (status.reviewedReject == extensionVM.active) {
						extensionVM.planningFinish = false;
					}
				} else {
					extensionVM.planningFinish = false;
				}
			} else {
				extensionVM.planningFinish = true;
			}
	
			$scope.classPlanning = extensionVM.planningFinish ? 'disabled' : ' ';
		}
	
		function bitacora(ev) {
			var entries = {};
	
			entries.params = {
				activityTypeId: GlobalConfig.activityTypeId.extensionProjects,
				workplanTeacherId: extensionVM.workplanTeacherId
			};
			entries.title = 'Consultoría y asesoría';
			// Entries(this.entries);
			entries.data = undefined;
			$mdDialog.show({
				controller: 'bitacoraModalCtrl',
				controllerAs: 'bit',
				template: __webpack_require__(453),
				parent: angular.element(document.body),
				targetEvent: ev,
				locals: { data: entries },
				clickOutsideToClose: true,
				fullscreen: true
			});
		}
	
		function disableProjectActivyId(project) {
			var header = {
				workplanTeacherActivityId: project.workplanTeacherActivityId
			};
			var name = project.name;
	
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
					var ctrlModalVM = this;
	
					ctrlModalVM.name = name;
					ctrlModalVM.close = function () {
						$mdDialog.hide();
					};
					ctrlModalVM.delete = function () {
						WorkPlanSrv.disableActivity.delete(header).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								showDeletedSuccessfully(ctrlModalVM.name);
								$mdDialog.hide();
							} else {
								console.log('Comunications problem with the server');
							}
						}, function (data) {});
					};
				}],
				controllerAs: 'ctrlModalVM',
				template: __webpack_require__(785),
				clickOutsideToClose: false
			});
		}
	
		function showDeletedSuccessfully(name) {
			var texts = GlobalConfig.appTexts;
			var header = {
				createOrEdit: texts.deleteDialog,
				textCreateOrEdit: texts.deleted,
				itemName: name,
				nameModal: texts.modalTypeName.deleted,
				modalType: texts.modalTypeId.default
			};
	
			WorkPlanModalSrv.setVariableSuccessDialog(header);
			WorkPlanModalSrv.successDialog(header).then(function (promise) {
				if (extensionVM.workPlanGeneralList != undefined) {
					if (extensionVM.feedback && !extensionVM.planningFinish) {
						getReviewDataReject();
					} else {
						getReviewData();
					}
				} else {
					getGeneralsWorkplan(post).then(function (promise) {
						if (extensionVM.feedback && !extensionVM.planningFinish) {
							getReviewDataReject();
						} else {
							getReviewData();
						}
					});
				}
			});
		}
	};
	
	exports.default = ExtensionProjectsListCtrl;
	
	
	ExtensionProjectsListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage'];

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md> Está a punto de eliminar el proyecto <strong>\"{{ ctrlModalVM.name }}\"</strong> ¿Está seguro de esta acción? </p> </div> </div> </md-dialog-content> <md-dialog-actions style=justify-content:center> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.delete()>Sí, eliminar</md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OtherActivitiesListCtrl = function () {
	  function OtherActivitiesListCtrl($scope, WorkPlanSrv, $mdDialog, WorkPlanIndicatorSrv, WorkPlanModalSrv, $cookies, GlobalConfig, Requests, $timeout, $sessionStorage) {
	    _classCallCheck(this, OtherActivitiesListCtrl);
	
	    var activitiesVm = this;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	
	    activitiesVm.activities = [];
	    activitiesVm.idWorkPlan = currentUser.workplanId;
	    activitiesVm.idTeacher = currentUser.teacherId;
	    activitiesVm.active = GlobalConfig.generals.active;
	    activitiesVm.notActive = GlobalConfig.generals.notActive;
	    activitiesVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory;
	    activitiesVm.imgEmpty = __webpack_require__(445);
	    activitiesVm.planningFinish = true;
	    $scope.classPlanning = '';
	    activitiesVm.inReview = 0;
	    activitiesVm.feedback = 0;
	    activitiesVm.viewLoaded = false;
	    activitiesVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	    activitiesVm.$sessionStorage = $sessionStorage;
	
	    // modals
	    activitiesVm.updateView = updateView;
	    activitiesVm.confirmDisableActivity = confirmDisableActivity;
	    activitiesVm.getGeneralsWorkplan = getGeneralsWorkplan;
	    activitiesVm.bitacora = bitacora;
	
	    activate();
	
	    function activate() {
	      var header = {
	        teacherId: currentUser.teacherId,
	        workplanId: currentUser.workplanId
	      };
	
	      if (activitiesVm.workPlanGeneralList != undefined) {
	        activitiesVm.status = activitiesVm.workPlanGeneralList.wokplanTeacherStatus[0];
	        activitiesVm.stages = activitiesVm.workPlanGeneralList.stages;
	        activitiesVm.inReview = activitiesVm.status.reviewed;
	        activitiesVm.feedback = activitiesVm.status.feedbackReviewed;
	        activitiesVm.workplanTeacherId = activitiesVm.status.workplanTeacherId;
	        isPlanning(activitiesVm.status, activitiesVm.stages);
	
	        if (activitiesVm.feedback && !activitiesVm.planningFinish) {
	          getOtherActivityItemAMReject(header);
	        } else {
	          getListOtherActivityItemAM(header);
	        }
	      } else {
	        getGeneralsWorkplan(header).then(function (promise) {
	          if (activitiesVm.feedback && !activitiesVm.planningFinish) {
	            getOtherActivityItemAMReject(header);
	          } else {
	            getListOtherActivityItemAM(header);
	          }
	        });
	      }
	    }
	
	    function getListOtherActivityItemAM(header) {
	      WorkPlanSrv.getListOtherActivityItemAM.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          activitiesVm.activities = dataReturn.data;
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getOtherActivityItemAMReject(header) {
	      WorkPlanSrv.getOtherActivityItemAMReject.get(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          activitiesVm.activities = dataReturn.data;
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function updateView() {
	      activitiesVm.viewLoaded = false;
	      $timeout(function () {
	        activitiesVm.viewLoaded = true;
	      }, 1000);
	    }
	
	    function confirmDisableActivity(row) {
	      var activityArray = activitiesVm.activities.indexOf(row);
	      var workplanTeacherActivityId = row.workplanTeacherActivityId;
	      var deleteActivityName = row.listItemName;
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', 'WorkPlanSrv', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanSrv, WorkPlanIndicatorSrv) {
	          var ctrlModalVM = this;
	          ctrlModalVM.activityArrayCode = activityArray;
	          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	          ctrlModalVM.delActivityName = deleteActivityName;
	          ctrlModalVM.close = function () {
	            $mdDialog.hide();
	          };
	          ctrlModalVM.disableOtherActivity = function () {
	            WorkPlanSrv.disableActivity.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	              if (dataReturn.status) {
	                // se hace set de variable para actualizar los indicadores
	                // se comunica con el controlador de Indicadores
	                WorkPlanIndicatorSrv.setVariable(true);
	                activitiesVm.activities.splice(ctrlModalVM.activityArrayCode, 1);
	                $mdDialog.hide();
	                showModalDeleteSuccess(deleteActivityName);
	              } else {
	                console.log('Comunications problem with the server');
	              }
	            }, function (data) {});
	          };
	        }],
	        controllerAs: 'ctrlModalVM',
	        template: __webpack_require__(787),
	        clickOutsideToClose: false
	      });
	    }
	
	    function showModalDeleteSuccess(deleteActivityName) {
	
	      var texts = GlobalConfig.appTexts;
	      var header = {
	        createOrEdit: texts.deleteDialog,
	        textCreateOrEdit: texts.deleted,
	        itemName: deleteActivityName,
	        nameModal: texts.modalTypeName.deleted,
	        modalType: texts.modalTypeId.default
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getGeneralsWorkplan(post) {
	      return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          activitiesVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	          activitiesVm.status = dataReturn.data.wokplanTeacherStatus[0];
	          activitiesVm.stages = dataReturn.data.stages;
	          activitiesVm.inReview = activitiesVm.status.reviewed;
	          activitiesVm.feedback = activitiesVm.status.feedbackReviewed;
	          activitiesVm.workplanTeacherId = activitiesVm.status.workplanTeacherId;
	          isPlanning(activitiesVm.status, activitiesVm.stages);
	        } else {
	          console.log("Comunications problem with the server");
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function isPlanning(status, stages) {
	      activitiesVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	      for (var i = stages.length - 1; i >= 0; i--) {
	        if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	          activitiesVm.startDateStage = stages[i].startDate;
	        }
	      }
	
	      if (status.workplanActive) {
	        if (status.planningFinish == activitiesVm.active) {
	          activitiesVm.planningFinish = true;
	          if (activitiesVm.startDateReview < activitiesVm.currentDate || status.reviewedFinish == activitiesVm.active) {
	            activitiesVm.planningFinish = true;
	          } else if (status.reviewedReject == activitiesVm.active) {
	            activitiesVm.planningFinish = false;
	          }
	        } else {
	          activitiesVm.planningFinish = false;
	        }
	      } else {
	        activitiesVm.planningFinish = true;
	      }
	
	      $scope.classPlanning = activitiesVm.planningFinish ? "disabled" : " ";
	    }
	
	    function bitacora(ev) {
	      var entries = {};
	
	      entries.params = {
	        activityTypeId: GlobalConfig.activityTypeId.otherActivities,
	        workplanTeacherId: activitiesVm.workplanTeacherId
	      };
	      entries.title = 'Otras Actividades';
	      // Entries(this.entries);
	      entries.data = undefined;
	      $mdDialog.show({
	        controller: 'bitacoraModalCtrl',
	        controllerAs: 'bit',
	        template: __webpack_require__(453),
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        locals: { data: entries },
	        clickOutsideToClose: true,
	        fullscreen: true
	      });
	    }
	  } //FIN DEL CONSTRUCTOR
	
	  _createClass(OtherActivitiesListCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return OtherActivitiesListCtrl;
	}();
	
	exports.default = OtherActivitiesListCtrl;
	
	
	OtherActivitiesListCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', 'WorkPlanIndicatorSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'Requests', '$timeout', '$sessionStorage'];

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la actividad <span class=font-bold>\"{{ctrlModalVM.delActivityName}}\"</span> ¿Está seguro de esta acción? </p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.disableOtherActivity()>Sí, eliminar actividad</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateOtherActivityCtrl = function () {
	  function CreateOtherActivityCtrl($scope, WorkPlanSrv, $mdDialog, $stateParams, $cookies, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateOtherActivityCtrl);
	
	    var createActivityVm = this;
	    var currentUser = $cookies.getObject('currentUser');
	    createActivityVm.nameActivityModal = '';
	    createActivityVm.hrefActivityModal = '';
	    createActivityVm.createOrEdit = '';
	    createActivityVm.idWorkPlan = currentUser.workplanId;
	    createActivityVm.idTeacher = currentUser.teacherId;
	    createActivityVm.workplanTeacherActivityId = $stateParams.activityId;
	    var SEARCH_PARAMS = {
	      teacherId: createActivityVm.idTeacher,
	      workplanId: createActivityVm.idWorkPlan,
	      workplanTeacherActivityId: createActivityVm.workplanTeacherActivityId,
	      name: currentUser.name
	    };
	    createActivityVm.comboActivities = [];
	    createActivityVm.activityItem = [];
	    createActivityVm.itemActivityRequired = [];
	    createActivityVm.isEditing = $stateParams.activityId ? true : false;
	    createActivityVm.rangeType = 1;
	
	    createActivityVm.periodsArray = [];
	    createActivityVm.typePeriod = [];
	    createActivityVm.isTouchedPeriods = false;
	    createActivityVm.selectedTypePeriod = {};
	    createActivityVm.initialDate = null;
	    createActivityVm.finalDate = null;
	    createActivityVm.minStartDate = new Date();
	    createActivityVm.minEndDate = new Date();
	    createActivityVm.isFeedback = currentUser.isFeedback;
	    createActivityVm.dt_start = $cookies.get('wp_start');
	    createActivityVm.dt_end = $cookies.get('wp_end');
	
	    createActivityVm.funSelectedPeriod = funSelectedPeriod;
	    createActivityVm.addActivity = addActivity;
	    createActivityVm.validateCheklistPeriods = validateCheklistPeriods;
	
	    createActivityVm.startDateChange = startDateChange;
	
	    createActivityVm.hasError = hasError;
	    createActivityVm.showErrorMessages = showErrorMessages;
	    createActivityVm.validateForm = validateForm;
	    createActivityVm.close = close;
	    createActivityVm.hours = 0;
	    createActivityVm.updateRangeType = function (val) {
	      createActivityVm.rangeType = val;
	      createActivityVm.periodsArray = [];
	      createActivityVm.startDate = null;
	      createActivityVm.endDate = null;
	    };
	    createActivityVm.updateRangeData = function (val) {
	      createActivityVm.periodsArray = val['periods'];
	      createActivityVm.initialDate = val['dates'][0];
	      createActivityVm.finalDate = val['dates'][1];
	    };
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      if (input) {
	        return input.$dirty || input.$touched;
	      } else {
	        return false;
	      }
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createActivityVm.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return createActivityVm.rangeType == 1 ? createActivityVm.periodsArray.length < 1 : false;
	    }
	
	    function startDateChange() {
	      var m = moment(createActivityVm.initialDate);
	      createActivityVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    activate();
	
	    function activate() {
	      if (createActivityVm.isEditing) {
	        createActivityVm.createOrEdit = 'Editar ';
	      } else {
	        createActivityVm.createOrEdit = 'Agregar ';
	      }
	      getDaysAndPeriodsData();
	      getActivitiesCombo();
	
	      if (createActivityVm.isEditing) {
	        getActivity();
	      }
	    }
	
	    function getActivityNameFromCombo() {
	      for (var i = 0; i < createActivityVm.comboActivities.length; i++) {
	        var row = createActivityVm.comboActivities[i];
	        if (row.activityTypeCode == createActivityVm.activityCode) {
	          return createActivityVm.comboActivities[i].activityTypeName;
	        }
	      }
	    }
	
	    function addActivity(sw, isExecution) {
	      createActivityVm.isSaveButtonDisabled = true;
	      createActivityVm.hrefActivityModal = sw;
	      var origin = 1;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var activity = {
	        idTeacher: createActivityVm.idTeacher,
	        idWorkPlan: createActivityVm.idWorkPlan,
	        activityHoursPlaned: createActivityVm.hours,
	        activityCode: createActivityVm.activityCode,
	        activityDetail: createActivityVm.detail,
	        periodType: createActivityVm.rangeType,
	        origin: origin,
	        isFeedbackActivity: createActivityVm.isFeedback
	      };
	
	      if (parseInt(createActivityVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createActivityVm.periodsArray) {
	          var temp = {
	            periodId: createActivityVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        activity.periods = arrayPeriod;
	      } else {
	        activity.initialDate = new Date(createActivityVm.initialDate);
	        activity.finalDate = new Date(createActivityVm.finalDate);
	      }
	
	      if (createActivityVm.isEditing) {
	        activity.workplanTeacherActivityId = createActivityVm.workplanTeacherActivityId;
	      }
	
	      addOrEditActivity(activity);
	    }
	
	    function addOrEditActivity(activity) {
	      WorkPlanSrv.addOtherActivityAM.add(activity).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          showModalSucces();
	        } else {
	          createActivityVm.isSaveButtonDisabled = false;
	          showModalFailure();
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function showModalSucces() {
	      var texts = GlobalConfig.appTexts;
	      var activityName = getActivityNameFromCombo();
	      var hrefActivity = createActivityVm.hrefActivityModal;
	      var actionEditOrCreate = texts.createDialog;
	      var textCreateOrEdit = texts.saved;
	      if (createActivityVm.isEditing) {
	        actionEditOrCreate = texts.editDialog;
	        textCreateOrEdit = texts.modified;
	      }
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', '$state', function ($scope, $mdDialog, $state) {
	          var ctrlModal = this;
	          ctrlModal.activityModal = hrefActivity;
	          ctrlModal.actionEditOrCreateModal = actionEditOrCreate;
	          ctrlModal.textCreateOrEdit = textCreateOrEdit;
	          ctrlModal.nameActivityModal = activityName;
	          ctrlModal.close = function () {
	            $mdDialog.hide();
	            isAllActivityItemRequired();
	            if ($state.current.name === 'workplan.createOtherActivity') {
	              $state.go('workplan.otherActivities');
	            } else {
	              $state.reload();
	            }
	          };
	        }],
	        controllerAs: 'ctrlModal',
	        template: __webpack_require__(789),
	        clickOutsideToClose: false
	      });
	    }
	
	    function showModalFailure() {
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	          var failureDialogCtlVm = this;
	          failureDialogCtlVm.close = function () {
	            $mdDialog.hide();
	          };
	        }],
	        template: __webpack_require__(790),
	        controllerAs: 'failureDialogCtlVm',
	        clickOutsideToClose: true
	      });
	    }
	
	    function getDaysAndPeriodsData() {
	      WorkPlanSrv.getDataForSchedule.get(SEARCH_PARAMS).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createActivityVm.typePeriod = dataReturn.periods;
	        } else {}
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getActivitiesCombo() {
	      var requestHeader = {
	        listTypeId: GlobalConfig.typeListId.academicManagement,
	        listId: GlobalConfig.listId.academicManagementotherActivities
	      };
	      WorkPlanSrv.getActivitiesCombo.getList(requestHeader).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createActivityVm.comboActivities = dataReturn.data;
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getActivity() {
	      WorkPlanSrv.getOtherActivityItemAM.get(SEARCH_PARAMS).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          console.log(dataReturn.data[0]);
	          setValues(dataReturn.data[0]);
	        } else {}
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function setValues(activity) {
	      createActivityVm.activityCode = activity.activityCode;
	      createActivityVm.nameActivity = activity.activityName;
	
	      createActivityVm.rangeType = activity.periodType;
	      createActivityVm.hours = activity.activityHoursPlaned;
	      createActivityVm.detail = activity.description;
	
	      createActivityVm.dt_start = moment(activity.startDate, 'YYYY-MM-DD').toDate();
	      createActivityVm.dt_end = moment(activity.endDate, 'YYYY-MM-DD').toDate();
	
	      createActivityVm.periodsArray = [];
	      createActivityVm.selectedTypePeriod = {};
	
	      if (createActivityVm.rangeType == 1) {
	        var splits = activity.periodId.split(',');
	        createActivityVm.initialDate = null;
	        createActivityVm.finalDate = null;
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          createActivityVm.periodsArray.push(parseInt(valor));
	          createActivityVm.selectedTypePeriod[valor] = true;
	        }
	      }
	
	      if (activity.startDate) {
	        var startDateNew = moment(activity.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createActivityVm.minStartDate = moment(activity.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createActivityVm.isEditing = true;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createActivityVm.periodsArray.includes(period.periodId)) {
	          createActivityVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createActivityVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createActivityVm.periodsArray.splice(index, 1);
	        }
	      }
	      createActivityVm.isTouchedPeriods = true;
	    }
	
	    function close() {
	      $mdDialog.hide();
	    }
	
	    function isAllActivityItemRequired() {
	      var header = {
	        teacherId: currentUser.teacherId,
	        workplanId: currentUser.workplanId,
	        listId: GlobalConfig.listId.academicManagementotherActivities
	      };
	
	      WorkPlanSrv.getItemRequiredOtherActivities.getList(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createActivityVm.itemActivityRequired = dataReturn.otherActivities;
	          if (createActivityVm.itemActivityRequired.length > 0) {
	            showModalItemRequired();
	          }
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function showModalItemRequired() {
	      $mdDialog.show({
	        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	          $scope.itemRequired = createActivityVm.itemActivityRequired;
	          $scope.hrefActivityModal = createActivityVm.hrefActivityModal;
	          $scope.close = function () {
	            $mdDialog.hide();
	          };
	        }],
	        template: __webpack_require__(791),
	        clickOutsideToClose: false
	      });
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateOtherActivityCtrl, [{
	    key: 'rbPlanifications',
	    value: function rbPlanifications(bool) {
	      if (bool) {
	        this.initialDate = null;
	        this.finalDate = null;
	      } else {
	        this.periodsArray = [];
	        this.selectedTypePeriod = null;
	        this.initialDate = null;
	        this.finalDate = null;
	      }
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateOtherActivityCtrl;
	}();
	
	exports.default = CreateOtherActivityCtrl;
	
	
	CreateOtherActivityCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModal.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>{{ctrlModal.actionEditOrCreateModal}}</h3> <p class=m-t-md>La actividad <span class=font-bold>\"{{ctrlModal.nameActivityModal}}\"</span> se ha {{ctrlModal.textCreateOrEdit}} con éxito.</p>{{ctrlModal.palabra}} </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModal.close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=failureDialogCtlVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡¡Atención!!</h3> <p>Ha ocurrido un problema de conexión con el servidor</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=failureDialogCtlVm.close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Antes de finalizar planeación debe configurar las siguientes Actividades en esta sección</p> <ul class=\"p-l-xl m-t with-bullets bullets-md p-h-md\"> <li ng-repeat=\"itemRequired in itemRequired\" class=m-v-sm> <p class=\"text-left text-md p-l-sm\"> {{itemRequired.list_items}} </p> </li> </ul> </div> </div> <div class=\"row text-center\"> <div class=col-md-12 ng-if=activityModal> <md-button class=\"btn btn-fw btn-success\" ng-click=close() ui-sref=workplan.listActivities> Aceptar</md-button> </div> <div class=\"text-center col-md-12\" ng-if=!activityModal> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemRequiredModalCtrl = function ItemRequiredModalCtrl($scope, $mdDialog, WorkPlanModalSrv) {
	  _classCallCheck(this, ItemRequiredModalCtrl);
	
	  // constants
	  var headData = WorkPlanModalSrv.getVariable();
	
	  // variables
	  $scope.itemOthersActivityRequired = headData.itemOthersActivityRequired;
	  $scope.itemAssignatures = headData.itemAssignatures;
	  $scope.itemListOtherActAM = headData.itemListOtherActAM;
	
	  // methods
	  $scope.close = close;
	  $scope.toggleSubcategories = toggleSubcategories;
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function toggleSubcategories(assignature) {
	    if (assignature.showChilds) {
	      assignature.showChilds = false;
	    } else {
	      assignature.showChilds = true;
	    }
	  }
	};
	
	exports.default = ItemRequiredModalCtrl;
	
	
	ItemRequiredModalCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanModalSrv'];

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ItemRequiredExecutionModalCtrl = function ItemRequiredExecutionModalCtrl($scope, $mdDialog, WorkPlanModalSrv) {
	  _classCallCheck(this, ItemRequiredExecutionModalCtrl);
	
	  // constants
	  var headData = WorkPlanModalSrv.getVariable();
	
	  // variables
	  $scope.itemActivities = headData.itemActivities;
	
	  // methods
	  $scope.close = close;
	  $scope.toggleSubcategories = toggleSubcategories;
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function toggleSubcategories(activities) {
	    if (activities.showChilds) {
	      activities.showChilds = false;
	    } else {
	      activities.showChilds = true;
	    }
	  }
	};
	
	exports.default = ItemRequiredExecutionModalCtrl;
	
	
	ItemRequiredExecutionModalCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanModalSrv'];

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProjectsFormulationListCtrl = function ProjectsFormulationListCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, ProjectsFormulationListCtrl);
	
	  var projectsFormulationVm = this;
	
	  projectsFormulationVm.mainLabel = 'Formación doctoral';
	  projectsFormulationVm.viewLoaded = false;
	  projectsFormulationVm.projectList = [];
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	  };
	
	  projectsFormulationVm.imgEmpty = __webpack_require__(445);
	
	  //VARIABLES
	  projectsFormulationVm.active = GlobalConfig.generals.active;
	  projectsFormulationVm.notActive = GlobalConfig.generals.notActive;
	  projectsFormulationVm.planningFinish = true;
	  $scope.classPlanning = '';
	  projectsFormulationVm.feedback = 0;
	  projectsFormulationVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  projectsFormulationVm.$sessionStorage = $sessionStorage;
	
	  //METHODS
	  projectsFormulationVm.backgroundGrad = backgroundGrad;
	  projectsFormulationVm.updateView = updateView;
	  projectsFormulationVm.loadData = loadData;
	  projectsFormulationVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  projectsFormulationVm.close = close;
	  projectsFormulationVm.confirmDeleteProject = confirmDeleteProject;
	  projectsFormulationVm.bitacora = bitacora;
	
	  function backgroundGrad(index) {
	    var result = 'grad-oblique-';
	
	    switch (index % 4) {
	      case 0:
	        return result + 'negro-dark';
	      case 1:
	        return result + 'azul';
	      case 2:
	        return result + 'teal';
	      case 3:
	        return result + 'deep-orange';
	      default:
	        return result + 'negro-dark';
	    }
	  }
	
	  activate();
	
	  function activate() {
	    if (projectsFormulationVm.workPlanGeneralList != undefined) {
	      projectsFormulationVm.status = projectsFormulationVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      projectsFormulationVm.stages = projectsFormulationVm.workPlanGeneralList.stages;
	      projectsFormulationVm.feedback = projectsFormulationVm.status.feedbackReviewed;
	      projectsFormulationVm.workplanTeacherId = projectsFormulationVm.status.workplanTeacherId;
	      isPlanning(projectsFormulationVm.status, projectsFormulationVm.stages);
	
	      if (projectsFormulationVm.feedback && !projectsFormulationVm.planningFinish) {
	        getListProjectsFormulatedReject();
	      } else {
	        getListProjectsFormulated();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (projectsFormulationVm.feedback && !projectsFormulationVm.planningFinish) {
	          getListProjectsFormulatedReject();
	        } else {
	          getListProjectsFormulated();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getListProjectsFormulated() {
	    WorkPlanSrv.getListProjectsFormulated.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listProjects);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getListProjectsFormulatedReject() {
	    WorkPlanSrv.getListProjectsFormulatedReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listProjects);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function loadData(data) {
	    projectsFormulationVm.projectList = data;
	    for (var i = projectsFormulationVm.projectList.length - 1; i >= 0; i--) {
	      if (projectsFormulationVm.projectList[i].timeRangeTypeId == GlobalConfig.periods.rangeType) projectsFormulationVm.projectList[i].periods = data[i].periodName.split(',');
	    }
	  }
	
	  function updateView() {
	    projectsFormulationVm.viewLoaded = false;
	    $timeout(function () {
	      projectsFormulationVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectsFormulationVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        projectsFormulationVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        projectsFormulationVm.stages = dataReturn.data.stages;
	        projectsFormulationVm.feedback = projectsFormulationVm.status.feedbackReviewed;
	        projectsFormulationVm.workplanTeacherId = projectsFormulationVm.status.workplanTeacherId;
	        isPlanning(projectsFormulationVm.status, projectsFormulationVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    projectsFormulationVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        projectsFormulationVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == projectsFormulationVm.active) {
	        projectsFormulationVm.planningFinish = true;
	        if (projectsFormulationVm.startDateReview < projectsFormulationVm.currentDate || status.reviewedFinish == projectsFormulationVm.active) {
	          projectsFormulationVm.planningFinish = true;
	        } else if (status.reviewedReject == projectsFormulationVm.active) {
	          projectsFormulationVm.planningFinish = false;
	        }
	      } else {
	        projectsFormulationVm.planningFinish = false;
	      }
	    } else {
	      projectsFormulationVm.planningFinish = true;
	      projectsFormulationVm.workplanActive = true;
	    }
	
	    $scope.classPlanning = projectsFormulationVm.planningFinish ? "disabled" : " ";
	  }
	
	  function confirmDeleteProject(project) {
	    var projectName = project.nameProject;
	    var projectId = project.workplanTeacherActivityId;
	
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.projectName = projectName;
	        ctrlModalVM.projectId = projectId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.deleteProject = function () {
	          var requestHeader = { workplanTeacherActivityId: ctrlModalVM.projectId };
	          WorkPlanSrv.disableActivityResearch.delete(requestHeader).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeFromCaroussel(project);
	              showDeletedSuccessfully(ctrlModalVM.projectName);
	              WorkPlanIndicatorSrv.setVariable(true);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(795),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(projectName) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: projectName,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeFromCaroussel(project) {
	    for (var i in projectsFormulationVm.projectList) {
	      if (projectsFormulationVm.projectList[i].workplanTeacherActivityId === project.workplanTeacherActivityId) {
	        projectsFormulationVm.projectList.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function close() {
	    $mdDialog.hide();
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.projectDesign,
	      workplanTeacherId: projectsFormulationVm.workplanTeacherId
	    };
	    entries.title = 'Formulación de propuestas';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = ProjectsFormulationListCtrl;
	
	
	ProjectsFormulationListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la propuesta de proyecto <strong>\"{{ ctrlModalVM.projectName }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.deleteProject()>Sí, eliminar propuesta</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateVisibilityCtrl = function () {
	  function CreateVisibilityCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateVisibilityCtrl);
	
	    var createVisibilityVm = this;
	    var texts = GlobalConfig.appTexts;
	    var listUser = JSON.parse($cookies.get('currentUser'));
	    var post = {
	      workplanId: listUser.workplanId,
	      teacherId: listUser.teacherId,
	      name: listUser.name
	    };
	
	    createVisibilityVm.listsTypeMediaKind = [];
	    createVisibilityVm.listsTypeMediaRol = [];
	    createVisibilityVm.listsTypeMediaFrequencyOfEmission = [];
	    createVisibilityVm.listsTypeMediaPublicAudience = [];
	    createVisibilityVm.listsTypeNetworkAssocInterInstitRelatAmbitStage = [];
	    createVisibilityVm.listsTypeNetworkAssocInterInstitRelatSector = [];
	    createVisibilityVm.visibilityType = GlobalConfig.visibilityType;
	    createVisibilityVm.regex = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
	    // createVisibilityVm.regex = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/
	
	    createVisibilityVm.isEditing = $stateParams.workplanTeacherActivityId ? true : false;
	    createVisibilityVm.rangeType = GlobalConfig.periods.rangeType;
	    createVisibilityVm.registryType = GlobalConfig.generals.active;
	    createVisibilityVm.workplanTeacherActivityId = null;
	    createVisibilityVm.createOrEdit = 'Crear';
	    createVisibilityVm.textCreateOrEdit = texts.saved;
	    createVisibilityVm.createOrEditMV = texts.createDialog;
	    createVisibilityVm.typePeriod = [];
	    createVisibilityVm.periodsArray = [];
	    createVisibilityVm.selectedTypePeriod = {};
	    createVisibilityVm.isTouchedPeriods = false;
	    createVisibilityVm.startDate = null;
	    createVisibilityVm.endDate = null;
	    createVisibilityVm.minStartDate = moment().toDate();
	    createVisibilityVm.minEndDate = new Date();
	    createVisibilityVm.isSaveButtonDisabled = false;
	    createVisibilityVm.arrayUnit = [];
	    createVisibilityVm.unitsCombo = [];
	    createVisibilityVm.isFeedback = listUser.isFeedback;
	    createVisibilityVm.dt_start = $cookies.get('wp_start');
	    createVisibilityVm.dt_end = $cookies.get('wp_end');
	    // createVisibilityVm.rolesUnits = rolesUnits
	
	    createVisibilityVm.hasError = hasError;
	    createVisibilityVm.showErrorMessages = showErrorMessages;
	    createVisibilityVm.confirmVisibilityAction = confirmVisibilityAction;
	    createVisibilityVm.validateForm = validateForm;
	    createVisibilityVm.validateCheklistPeriods = validateCheklistPeriods;
	    createVisibilityVm.funSelectedPeriod = funSelectedPeriod;
	    createVisibilityVm.startDateChange = startDateChange;
	    createVisibilityVm.addVisibility = addVisibility;
	    createVisibilityVm.close = close;
	    createVisibilityVm.addOrEditVisibility = addOrEditVisibility;
	    createVisibilityVm.unitAcademic = unitAcademic;
	    createVisibilityVm.exists = exists;
	
	    createVisibilityVm.updateRangeType = function (val) {
	      createVisibilityVm.rangeType = val;
	      createVisibilityVm.periodsArray = [];
	      createVisibilityVm.startDate = null;
	      createVisibilityVm.endDate = null;
	    };
	    createVisibilityVm.updateRangeData = function (val) {
	      createVisibilityVm.periodsArray = val['periods'];
	      createVisibilityVm.startDate = val['dates'][0];
	      createVisibilityVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      loadContent();
	    }
	
	    function loadContent() {
	      WorkPlanSrv.getListVisibilityActivities.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          // Primero cargo contenido, y luego consulto si esta editando para setear los valores
	          loadData(dataReturn);
	          if (createVisibilityVm.isEditing) {
	            createVisibilityVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	            createVisibilityVm.createOrEdit = 'Editar';
	            createVisibilityVm.createOrEditMV = texts.editDialog;
	            createVisibilityVm.textCreateOrEdit = texts.modified;
	            getDataVisibility();
	          }
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getDataVisibility() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createVisibilityVm.workplanTeacherActivityId)
	      };
	      WorkPlanSrv.getVisibilityActivitiesById.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.listVisibility[0]);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function loadData(data) {
	      createVisibilityVm.typePeriod = data.listPeriods;
	      createVisibilityVm.listsTypeMediaKind = data.listVisibilityType.items;
	      createVisibilityVm.listsTypeMediaRol = data.listVisibilityRole.items;
	      createVisibilityVm.listsTypeMediaFrequencyOfEmissionType = data.listFrequencyEmission.items;
	      createVisibilityVm.listsTypeMediaPublicAudience = data.listAudience.items;
	      createVisibilityVm.listsTypeNetworkAssocInterInstitRelatAmbitStage = data.listAmbit.items;
	      createVisibilityVm.listsTypeSector = data.listSector.items;
	      createVisibilityVm.unitsCombo = data.academicUnit;
	      unitAcademic();
	    }
	
	    function unitAcademic() {
	      for (var index in createVisibilityVm.unitsCombo) {
	        if (!exists(createVisibilityVm.unitsCombo[index].id_code, createVisibilityVm.arrayUnit)) {
	          var temp = {
	            academitUnitId: createVisibilityVm.unitsCombo[index].id_code,
	            academitUnitName: createVisibilityVm.unitsCombo[index].ds_name
	          };
	          createVisibilityVm.arrayUnit.push(temp);
	        }
	      }
	    }
	
	    function exists(value, array) {
	      for (var index in array) {
	        if (array[index].id_code == value) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function hasError(input) {
	      if (input && input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input && (input.$dirty || input.$touched);
	    }
	
	    function addVisibility(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function validateForm(form) {
	      return form && form.$invalid || createVisibilityVm.validateCheklistPeriods();
	    }
	
	    function createJson(origin) {
	      var visibility = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        activityId: GlobalConfig.minorActivityId.visibility,
	        nameVisibility: createVisibilityVm.title,
	        summary: createVisibilityVm.mediaDescription,
	        link: createVisibilityVm.mediaURL,
	        hoursPlanning: createVisibilityVm.plannedHours,
	        idCommunicationType: createVisibilityVm.mediaKindType,
	        idFrequencyEmission: createVisibilityVm.mediaFrequencyOfEmissionType,
	        idAudience: createVisibilityVm.mediaPublicAudienceType,
	        idRol: createVisibilityVm.mediaRolType,
	        origin: origin,
	        email: createVisibilityVm.networkAssocInterInstitRelatEmail,
	        contact: createVisibilityVm.networkAssocInterInstitRelatContactName,
	        idAmbit: createVisibilityVm.networkAssocInterInstitRelatAmbitStageType,
	        idSector: createVisibilityVm.networkAssocInterInstitRelatSectorType,
	        unit: createVisibilityVm.eventOrganizationUnity,
	        timeRangeTypeId: createVisibilityVm.rangeType,
	        isFeedbackActivity: createVisibilityVm.isFeedback
	      };
	
	      if (createVisibilityVm.isEditing) {
	        visibility.workplanTeacherActivityId = createVisibilityVm.workplanTeacherActivityId;
	      }
	
	      if (createVisibilityVm.rangeType == GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createVisibilityVm.periodsArray) {
	          var temp = {
	            periodId: createVisibilityVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        visibility.periods = arrayPeriod;
	      } else {
	        visibility.startDate = new Date(createVisibilityVm.startDate);
	        visibility.endDate = new Date(createVisibilityVm.endDate);
	      }
	
	      // registryType
	      for (var i = createVisibilityVm.visibilityType.length - 1; i >= 0; i--) {
	        if (createVisibilityVm.visibilityType[i].idVisibility == createVisibilityVm.registryType) {
	          visibility.nameCommunicationRegister = createVisibilityVm.visibilityType[i].nameVisibility;
	        }
	      }
	      addOrEditVisibility(visibility);
	    }
	
	    function addOrEditVisibility(visibility) {
	      createVisibilityVm.isSaveButtonDisabled = true;
	      WorkPlanSrv.addVisibilityActivities.save(visibility).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getSendNotify(visibility.origin);
	          confirmVisibilityAction();
	        } else {
	          createVisibilityVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        createVisibilityVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function confirmVisibilityAction() {
	      var header = {
	        createOrEdit: createVisibilityVm.createOrEditMV,
	        textCreateOrEdit: createVisibilityVm.textCreateOrEdit,
	        itemName: createVisibilityVm.title,
	        nameModal: texts.modalTypeName.visibility,
	        modalType: texts.modalTypeId.visibility
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function validateCheklistPeriods() {
	      return createVisibilityVm.rangeType == 1 ? createVisibilityVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createVisibilityVm.periodsArray.includes(period.periodId)) {
	          createVisibilityVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createVisibilityVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createVisibilityVm.periodsArray.splice(index, 1);
	        }
	      }
	      createVisibilityVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createVisibilityVm.startDate);
	      createVisibilityVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function setValues(visibility) {
	      createVisibilityVm.registryType = visibility.registryTypeId;
	      createVisibilityVm.title = visibility.nameVisibility;
	      createVisibilityVm.mediaDescription = visibility.summary;
	      createVisibilityVm.mediaRolType = visibility.idRol;
	      createVisibilityVm.mediaFrequencyOfEmissionType = visibility.idFrequencyEmission;
	      createVisibilityVm.mediaPublicAudienceType = visibility.idAudience;
	      createVisibilityVm.rangeType = visibility.timeRangeTypeId;
	      createVisibilityVm.eventOrganizationUnity = parseInt(visibility.unit);
	      createVisibilityVm.networkAssocInterInstitRelatSectorType = visibility.idSector;
	      createVisibilityVm.networkAssocInterInstitRelatAmbitStageType = visibility.idAmbit;
	      createVisibilityVm.networkAssocInterInstitRelatContactName = visibility.contact;
	      createVisibilityVm.dt_start = moment(visibility.startDate, 'YYYY-MM-DD').toDate();
	      createVisibilityVm.dt_end = moment(visibility.endDate, 'YYYY-MM-DD').toDate();
	      createVisibilityVm.mediaKindType = visibility.idCommunicationType;
	      createVisibilityVm.networkAssocInterInstitRelatEmail = visibility.email;
	      createVisibilityVm.mediaURL = visibility.link;
	      createVisibilityVm.plannedHours = visibility.hoursPlanned;
	      createVisibilityVm.periodsArray = [];
	      createVisibilityVm.selectedTypePeriod = {};
	
	      if (createVisibilityVm.rangeType == GlobalConfig.periods.rangeType) {
	        createVisibilityVm.startDate = null;
	        createVisibilityVm.endDate = null;
	        var splits = visibility.periodId.split(',');
	        if (splits) {
	          for (var i = 0; i < splits.length; i++) {
	            var valor = splits[i];
	            createVisibilityVm.periodsArray.push(parseInt(valor));
	            createVisibilityVm.selectedTypePeriod[valor] = true;
	          }
	        }
	      }
	
	      for (var i = createVisibilityVm.visibilityType.length - 1; i >= 0; i--) {
	        if (createVisibilityVm.visibilityType[i].nameVisibility == visibility.nameCommunicationRegister) {
	          createVisibilityVm.registryType = createVisibilityVm.visibilityType[i].idVisibility;
	        }
	      }
	
	      if (visibility.startDate) {
	        var startDateNew = moment(visibility.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createVisibilityVm.minStartDate = moment(visibility.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createVisibilityVm.isEditing = true;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createVisibilityVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createVisibilityVm.startDate = null;
	        createVisibilityVm.endDate = null;
	      } else {
	        createVisibilityVm.periodsArray = [];
	        createVisibilityVm.selectedTypePeriod = null;
	      }
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El profesor ' + listUser.dsFullname + ' ha registrado una nueva actividad en visibilidad en la etapa de ';
	      if (origin == GlobalConfig.activityTypeId.originActivityExecution) msg = msg + 'ejecución.';else msg = msg + 'planeación.';
	
	      var data = {
	        idTeacher: listUser.teacherId,
	        dsName: 'Notificación, se agregó o editó una actividad en visibilidad',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1
	      };
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data);
	    }
	  } // FIN DEL CONSTRUCTOR
	
	
	  _createClass(CreateVisibilityCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateVisibilityCtrl;
	}();
	
	exports.default = CreateVisibilityCtrl;
	
	
	CreateVisibilityCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VisibilityListCtrl = function VisibilityListCtrl($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
	  _classCallCheck(this, VisibilityListCtrl);
	
	  // constants
	  var visibilityVM = this;
	  var listUser = JSON.parse($cookies.get('currentUser'));
	  var post = {
	    teacherId: listUser.teacherId,
	    workplanId: listUser.workplanId
	
	    // variables
	  };visibilityVM.showData = false;
	  visibilityVM.viewLoaded = false;
	  visibilityVM.criteriaFilter = '';
	  visibilityVM.selectedProject = null;
	  visibilityVM.detailsData = null;
	  visibilityVM.listVisibility = [];
	  visibilityVM.imgEmpty = __webpack_require__(445);
	  visibilityVM.sr = '';
	  visibilityVM.searchValue = false;
	  visibilityVM.feedback = 0;
	  visibilityVM.planningFinish = true;
	  $scope.classPlanning = '';
	  visibilityVM.active = GlobalConfig.generals.active;
	  visibilityVM.notActive = GlobalConfig.generals.notActive;
	  visibilityVM.isMedia = false;
	  visibilityVM.isEvent = false;
	  visibilityVM.isNetwork = false;
	  visibilityVM.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  visibilityVM.$sessionStorage = $sessionStorage;
	
	  // methods
	  visibilityVM.details = details;
	  visibilityVM.updateSearchView = updateSearchView;
	  visibilityVM.tagClas = tagClass;
	  visibilityVM.visibilityBckgrd = visibilityBckgrd;
	  visibilityVM.visibilityText = visibilityText;
	  visibilityVM.getReviewData = getReviewData;
	  visibilityVM.close = close;
	  visibilityVM.confirmDeleteVisibility = confirmDeleteVisibility;
	  visibilityVM.thereIsDetails = thereIsDetails;
	  visibilityVM.updateFilter = updateFilter;
	  visibilityVM.getGeneralsWorkplan = getGeneralsWorkplan;
	  visibilityVM.bitacora = bitacora;
	
	  angular.extend(visibilityVM, {
	    isLoadingDetails: false,
	    filter: ''
	  });
	
	  activate();
	
	  function activate() {
	    if (visibilityVM.workPlanGeneralList != undefined) {
	      visibilityVM.status = visibilityVM.workPlanGeneralList.wokplanTeacherStatus[0];
	      visibilityVM.stages = visibilityVM.workPlanGeneralList.stages;
	      visibilityVM.feedback = visibilityVM.status.feedbackReviewed;
	      visibilityVM.workplanTeacherId = visibilityVM.status.workplanTeacherId;
	      isPlanning(visibilityVM.status, visibilityVM.stages);
	
	      if (visibilityVM.feedback && !visibilityVM.planningFinish) {
	        getReviewDataReject();
	      } else {
	        getReviewData();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (visibilityVM.feedback && !visibilityVM.planningFinish) {
	          getReviewDataReject();
	        } else {
	          getReviewData();
	        }
	      });
	    }
	  }
	
	  function getReviewData() {
	
	    WorkPlanSrv.getListVisibilityActivities.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        visibilityVM.listVisibility = dataReturn.listVisibilityActivities;
	        if (visibilityVM.listVisibility.length == 0) {
	          visibilityVM.detailsData = true;
	        }
	
	        for (var i = visibilityVM.listVisibility.length - 1; i >= 0; i--) {
	          if (visibilityVM.listVisibility[i].activityTypeId == GlobalConfig.typeProject.internal) {
	            visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Interno';
	          } else {
	            visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Transversal';
	          }
	        }
	
	        if (visibilityVM.listVisibility && visibilityVM.listVisibility.length > 0) visibilityVM.details(visibilityVM.listVisibility[0]);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function getReviewDataReject() {
	
	    WorkPlanSrv.getListVisibilityActivitiesReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        visibilityVM.listVisibility = dataReturn.listVisibilityActivities;
	        if (visibilityVM.listVisibility.length == 0) {
	          visibilityVM.detailsData = true;
	        }
	
	        if (visibilityVM.listVisibility.length == 0) visibilityVM.detailsData = 0;
	
	        for (var i = visibilityVM.listVisibility.length - 1; i >= 0; i--) {
	          if (visibilityVM.listVisibility[i].activityTypeId == GlobalConfig.typeProject.internal) {
	            visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Interno';
	          } else {
	            visibilityVM.listVisibility[i].activityTypeName = 'Proyecto Transversal';
	          }
	        }
	
	        if (visibilityVM.listVisibility && visibilityVM.listVisibility.length > 0) visibilityVM.details(visibilityVM.listVisibility[0]);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function getvisibilitysDetails(visibilitys) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var callback = arguments[2];
	
	    WorkPlanSrv.getVisibilityActivitiesById.get({ workplanTeacherActivityId: visibilitys.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        visibilityVM.detailsData = dataReturn.listVisibility[0];
	        //visibilityVM.detailsData.startDate = moment(visibilityVM.detailsData.startDate).format('DD/MM/YYYY')
	        //visibilityVM.detailsData.endDate  = moment(visibilityVM.detailsData.endtDate).format('DD/MM/YYYY')
	        validateTypeVisibility(visibilityVM.detailsData.nameCommunicationRegister);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log();
	    });
	
	    if (!reload) {
	      visibilityVM.isLoadingDetails = true;
	      visibilityVM.detailsData = null;
	    }
	    callback;
	  }
	
	  function thereIsDetails() {
	    return Boolean(visibilityVM.detailsData);
	  }
	
	  function tagClass(visibility) {
	    return 'azul';
	  }
	
	  function visibilityBckgrd(visibility) {
	    if (visibilityVM.selectedProject === visibility) {
	      return 'bg-review';
	    }
	  }
	
	  function visibilityText(visibility) {
	    if (visibilityVM.selectedProject === visibility) {
	      return 'text-color-w';
	    }
	  }
	
	  function details(visibility) {
	    visibilityVM.detailsData = null;
	    visibilityVM.selectedProject = visibility;
	    visibilityVM.isLoadingDetails = true;
	    getvisibilitysDetails(visibility, function () {
	      visibilityVM.isLoadingDetails = false;
	    });
	  }
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function updateSearchView() {
	    visibilityVM.viewLoaded = true;
	    visibilityVM.viewLoaded = false;
	    $timeout(function () {
	      visibilityVM.viewLoaded = true;
	    }, 100);
	  }
	
	  function confirmDeleteVisibility(visibility) {
	    var name = visibility.nameVisibility;
	    var workplanTeacherActivityId = visibility.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.name = name;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.delete = function () {
	          WorkPlanSrv.disableActivityResearch.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeFromlist(visibility);
	              showDeletedSuccessfully(ctrlModalVM.name);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(798),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(name) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: name,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeFromlist(visibility) {
	    for (var i in visibilityVM.listVisibility) {
	      if (visibilityVM.listVisibility[i].workplanTeacherActivityId === visibility.workplanTeacherActivityId) {
	        visibilityVM.listVisibility.splice(i, 1);
	        updateSearchView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        visibilityVM.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        visibilityVM.status = dataReturn.data.wokplanTeacherStatus[0];
	        visibilityVM.stages = dataReturn.data.stages;
	        visibilityVM.feedback = visibilityVM.status.feedbackReviewed;
	        visibilityVM.workplanTeacherId = visibilityVM.status.workplanTeacherId;
	        isPlanning(visibilityVM.status, visibilityVM.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    visibilityVM.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        visibilityVM.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == visibilityVM.active) {
	        visibilityVM.planningFinish = true;
	        if (visibilityVM.startDateReview < visibilityVM.currentDate || status.reviewedFinish == visibilityVM.active) {
	          visibilityVM.planningFinish = true;
	        } else if (status.reviewedReject == visibilityVM.active) {
	          visibilityVM.planningFinish = false;
	        }
	      } else {
	        visibilityVM.planningFinish = false;
	      }
	    } else {
	      visibilityVM.planningFinish = true;
	    }
	
	    $scope.classPlanning = visibilityVM.planningFinish ? "disabled" : " ";
	  }
	
	  function updateFilter(val) {
	    visibilityVM.sr = validateSearch();
	    if (visibilityVM.sr.length == 0) {
	      visibilityVM.searchValue = true;
	      visibilityVM.detailsData = null;
	    } else {
	      visibilityVM.searchValue = false;
	      if (visibilityVM.listVisibility && visibilityVM.listVisibility.length > 0) visibilityVM.details(visibilityVM.listVisibility[0]);
	    }
	  }
	
	  function validateSearch() {
	    return $filter('filter')(visibilityVM.listVisibility, visibilityVM.criteriaFilter);
	  }
	
	  function validateTypeVisibility(strVal) {
	    strVal = strVal.substring(0, 3);
	    //si es medio de comunicacion
	    if (strVal == 'Med') {
	      visibilityVM.isMedia = true;
	      visibilityVM.isEvent = false;
	      visibilityVM.isNetwork = false;
	      //si es eventos
	    } else if (strVal == 'Org') {
	      visibilityVM.isEvent = true;
	      visibilityVM.isMedia = false;
	      visibilityVM.isNetwork = false;
	      //si es redes
	    } else if (strVal == 'Red') {
	      visibilityVM.isNetwork = true;
	      visibilityVM.isMedia = false;
	      visibilityVM.isEvent = false;
	    }
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.visibility,
	      workplanTeacherId: visibilityVM.workplanTeacherId
	    };
	    entries.title = 'Comunicación y visibilidad';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = VisibilityListCtrl;
	
	
	VisibilityListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage'];

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la actividad de visibilidad <strong>\"{{ ctrlModalVM.name }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.delete()>Sí, eliminar actividad</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateCounselingAndConsultancyCtrl = function () {
	  function CreateCounselingAndConsultancyCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateCounselingAndConsultancyCtrl);
	
	    var createCounselingAndConsultancyVm = this;
	    var texts = GlobalConfig.appTexts;
	    createCounselingAndConsultancyVm.currentUser = JSON.parse($cookies.get('currentUser'));
	
	    var post = {
	      workplanId: createCounselingAndConsultancyVm.currentUser.workplanId,
	      teacherId: createCounselingAndConsultancyVm.currentUser.teacherId,
	      name: createCounselingAndConsultancyVm.currentUser.name
	    };
	    createCounselingAndConsultancyVm.listBasicAreaOfKnowledge = [];
	    createCounselingAndConsultancyVm.sectorType = [];
	    createCounselingAndConsultancyVm.rolType = [];
	
	    createCounselingAndConsultancyVm.isEditing = $stateParams.workplanTeacherActivityId ? true : false;
	    createCounselingAndConsultancyVm.rangeType = GlobalConfig.periods.rangeType;
	    createCounselingAndConsultancyVm.workplanTeacherActivityId = null;
	    createCounselingAndConsultancyVm.createOrEdit = 'Crear';
	    createCounselingAndConsultancyVm.textCreateOrEdit = texts.saved;
	    createCounselingAndConsultancyVm.createOrEditMV = texts.createDialog;
	    createCounselingAndConsultancyVm.financiers = [];
	    createCounselingAndConsultancyVm.isTouchedFinanciers = false;
	    createCounselingAndConsultancyVm.typePeriod = [];
	    createCounselingAndConsultancyVm.periodsArray = [];
	    createCounselingAndConsultancyVm.selectedTypePeriod = {};
	    createCounselingAndConsultancyVm.isTouchedPeriods = false;
	    createCounselingAndConsultancyVm.startDate = null;
	    createCounselingAndConsultancyVm.endDate = null;
	    createCounselingAndConsultancyVm.minStartDate = moment().toDate();
	    createCounselingAndConsultancyVm.minEndDate = new Date();
	    createCounselingAndConsultancyVm.isSaveButtonDisabled = false;
	    createCounselingAndConsultancyVm.isFeedback = createCounselingAndConsultancyVm.currentUser.isFeedback;
	    createCounselingAndConsultancyVm.dt_start = $cookies.get('wp_start');
	    createCounselingAndConsultancyVm.dt_end = $cookies.get('wp_end');
	
	    createCounselingAndConsultancyVm.hasError = hasError;
	    createCounselingAndConsultancyVm.showErrorMessages = showErrorMessages;
	    createCounselingAndConsultancyVm.confirmCounselingAndConsultancyAction = confirmCounselingAndConsultancyAction;
	    createCounselingAndConsultancyVm.validateForm = validateForm;
	    createCounselingAndConsultancyVm.validateCheklistPeriods = validateCheklistPeriods;
	    createCounselingAndConsultancyVm.funSelectedPeriod = funSelectedPeriod;
	    createCounselingAndConsultancyVm.cleanRangeType = cleanRangeType;
	    createCounselingAndConsultancyVm.startDateChange = startDateChange;
	    createCounselingAndConsultancyVm.addCounselingAndConsultancy = addCounselingAndConsultancy;
	    createCounselingAndConsultancyVm.addOrEditCounselingAndConsultancy = addOrEditCounselingAndConsultancy;
	    createCounselingAndConsultancyVm.close = close;
	
	    createCounselingAndConsultancyVm.updateRangeType = function (val) {
	      createCounselingAndConsultancyVm.rangeType = val;
	      createCounselingAndConsultancyVm.periodsArray = [];
	      createCounselingAndConsultancyVm.startDate = null;
	      createCounselingAndConsultancyVm.endDate = null;
	    };
	    createCounselingAndConsultancyVm.updateRangeData = function (val) {
	      createCounselingAndConsultancyVm.periodsArray = val['periods'];
	      createCounselingAndConsultancyVm.startDate = val['dates'][0];
	      createCounselingAndConsultancyVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createCounselingAndConsultancyVm.isEditing) {
	        createCounselingAndConsultancyVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createCounselingAndConsultancyVm.createOrEdit = 'Editar';
	        createCounselingAndConsultancyVm.createOrEditMV = texts.editDialog;
	        createCounselingAndConsultancyVm.textCreateOrEdit = texts.modified;
	        getDataCounselingAndConsultancy();
	      }
	      WorkPlanSrv.getDataFormAdviceConsultancy.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function getDataCounselingAndConsultancy() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createCounselingAndConsultancyVm.workplanTeacherActivityId)
	      };
	
	      WorkPlanSrv.getAdviceConsultancyById.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      });
	    }
	
	    function loadData(data) {
	      createCounselingAndConsultancyVm.listsTypeBasicAreaOfKnowledge = data.listKnowledge.items;
	      createCounselingAndConsultancyVm.listsTypeAmbitStage = data.listAmbit.items;
	      createCounselingAndConsultancyVm.sectorType = data.listSector.items;
	      createCounselingAndConsultancyVm.rolType = data.listRole.items;
	      createCounselingAndConsultancyVm.typePeriod = data.listPeriods;
	      createCounselingAndConsultancyVm.financiers = data.listFinancial;
	    }
	
	    function addCounselingAndConsultancy(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var counselingConsultancy = {
	        activityId: GlobalConfig.minorActivityId.counseling,
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createCounselingAndConsultancyVm.nameCounselingConsultancy,
	        description: createCounselingAndConsultancyVm.description,
	        hoursPlanning: createCounselingAndConsultancyVm.plannedHours,
	        deliverables: createCounselingAndConsultancyVm.productsDeliverables,
	        itemKnowledgeId: createCounselingAndConsultancyVm.basicAreaOfKnowledgeType,
	        entity: createCounselingAndConsultancyVm.companyEntityOrganization,
	        source: createCounselingAndConsultancyVm.source,
	        itemSectorId: createCounselingAndConsultancyVm.sector,
	        itemRoleId: createCounselingAndConsultancyVm.rol,
	        itemSpaceId: createCounselingAndConsultancyVm.ambitStage,
	        timeRangeTypeId: parseInt(createCounselingAndConsultancyVm.rangeType),
	        origin: origin,
	        isFeedbackActivity: createCounselingAndConsultancyVm.isFeedback
	      };
	
	      if (parseInt(createCounselingAndConsultancyVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createCounselingAndConsultancyVm.periodsArray) {
	          var temp = {
	            periodId: createCounselingAndConsultancyVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        counselingConsultancy.periods = arrayPeriod;
	      } else {
	        counselingConsultancy.startDate = new Date(createCounselingAndConsultancyVm.startDate);
	        counselingConsultancy.endDate = new Date(createCounselingAndConsultancyVm.endDate);
	      }
	
	      if (createCounselingAndConsultancyVm.isEditing) {
	        counselingConsultancy.workplanTeacherActivityId = createCounselingAndConsultancyVm.workplanTeacherActivityId;
	      }
	      addOrEditCounselingAndConsultancy(counselingConsultancy);
	    }
	
	    function addOrEditCounselingAndConsultancy(counselingConsultancy) {
	      createCounselingAndConsultancyVm.isSaveButtonDisabled = true;
	      WorkPlanSrv.addAdviceConsultancy.save(counselingConsultancy).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getSendNotify(counselingConsultancy.origin);
	          confirmCounselingAndConsultancyAction();
	        } else {
	          createCounselingAndConsultancyVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        createCounselingAndConsultancyVm.isSaveButtonDisabled = false;
	      });
	    }
	
	    function confirmCounselingAndConsultancyAction() {
	      var header = {
	        createOrEdit: createCounselingAndConsultancyVm.createOrEditMV,
	        textCreateOrEdit: createCounselingAndConsultancyVm.textCreateOrEdit,
	        itemName: createCounselingAndConsultancyVm.nameCounselingConsultancy,
	        nameModal: texts.modalTypeName.counselingConsultancy,
	        modalType: texts.modalTypeId.counselingConsultancy
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header);
	    }
	
	    function hasError(input) {
	      if (input && input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input && (input.$dirty || input.$touched);
	    }
	
	    function validateForm(form) {
	      return form && form.$invalid || createCounselingAndConsultancyVm.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return createCounselingAndConsultancyVm.rangeType == 1 ? createCounselingAndConsultancyVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createCounselingAndConsultancyVm.periodsArray.includes(period.periodId)) {
	          createCounselingAndConsultancyVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createCounselingAndConsultancyVm.periodsArray.indexOf(period.periodId);
	        if (index !== -1) {
	          createCounselingAndConsultancyVm.periodsArray.splice(index, 1);
	        }
	      }
	      createCounselingAndConsultancyVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createCounselingAndConsultancyVm.startDate);
	      createCounselingAndConsultancyVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function setValues(counseling) {
	      createCounselingAndConsultancyVm.nameCounselingConsultancy = counseling.name;
	      createCounselingAndConsultancyVm.plannedHours = counseling.hoursPlanned;
	      createCounselingAndConsultancyVm.description = counseling.description;
	      createCounselingAndConsultancyVm.productsDeliverables = counseling.deliverables;
	      createCounselingAndConsultancyVm.basicAreaOfKnowledgeType = counseling.itemKnowledgeId;
	      createCounselingAndConsultancyVm.companyEntityOrganization = counseling.entity;
	      createCounselingAndConsultancyVm.ambitStage = counseling.itemAmbitId;
	      createCounselingAndConsultancyVm.sector = counseling.itemSectorId;
	      createCounselingAndConsultancyVm.source = counseling.source;
	      createCounselingAndConsultancyVm.rol = counseling.itemRoleId;
	      createCounselingAndConsultancyVm.rangeType = counseling.timeRangeTypeId;
	      createCounselingAndConsultancyVm.dt_start = moment(counseling.startDate, 'YYYY-MM-DD').toDate();
	      createCounselingAndConsultancyVm.dt_end = moment(counseling.endDate, 'YYYY-MM-DD').toDate();
	      createCounselingAndConsultancyVm.periodsArray = [];
	      createCounselingAndConsultancyVm.selectedTypePeriod = {};
	      createCounselingAndConsultancyVm.selectedFinancier = {};
	
	      if (createCounselingAndConsultancyVm.rangeType == GlobalConfig.periods.rangeType) {
	        var splits = counseling.periodId.split(',');
	        createCounselingAndConsultancyVm.startDate = null;
	        createCounselingAndConsultancyVm.endDate = null;
	
	        if (splits) {
	          for (var i = 0; i < splits.length; i++) {
	            var valor = splits[i];
	            createCounselingAndConsultancyVm.periodsArray.push(parseInt(valor));
	            createCounselingAndConsultancyVm.selectedTypePeriod[valor] = true;
	          }
	        }
	      }
	
	      if (counseling.startDate) {
	        var startDateNew = moment(counseling.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createCounselingAndConsultancyVm.minStartDate = moment(counseling.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createCounselingAndConsultancyVm.isEditing = true;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createCounselingAndConsultancyVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createCounselingAndConsultancyVm.startDate = null;
	        createCounselingAndConsultancyVm.endDate = null;
	      } else {
	        createCounselingAndConsultancyVm.periodsArray = [];
	        createCounselingAndConsultancyVm.selectedTypePeriod = null;
	      }
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El profesor ' + createCounselingAndConsultancyVm.currentUser.dsFullname + ' ha registrado una nueva consultoria y asesoria en la etapa de ';
	      if (origin == GlobalConfig.activityTypeId.originActivityExecution) msg = msg + 'ejecución.';else msg = msg + 'planeación.';
	      var data = {
	        idTeacher: createCounselingAndConsultancyVm.currentUser.teacherId,
	        dsName: 'Notificación, se agregó o editó una consultoria y asesoria',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1
	      };
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data);
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateCounselingAndConsultancyCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateCounselingAndConsultancyCtrl;
	}();
	
	exports.default = CreateCounselingAndConsultancyCtrl;
	
	
	CreateCounselingAndConsultancyCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CounselingAndConsultancyListCtrl = function CounselingAndConsultancyListCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, CounselingAndConsultancyListCtrl);
	
	  var counselingAndConsultancyVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  counselingAndConsultancyVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  counselingAndConsultancyVm.$sessionStorage = $sessionStorage;
	
	  counselingAndConsultancyVm.gradRoleClass = 'grad-1';
	  counselingAndConsultancyVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  //VARIABLES
	  counselingAndConsultancyVm.dataList = [];
	  counselingAndConsultancyVm.viewLoaded = false;
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	  };
	  counselingAndConsultancyVm.imgEmpty = __webpack_require__(445);
	
	  counselingAndConsultancyVm.active = GlobalConfig.generals.active;
	  counselingAndConsultancyVm.notActive = GlobalConfig.generals.notActive;
	  counselingAndConsultancyVm.planningFinish = true;
	  $scope.classPlanning = '';
	  counselingAndConsultancyVm.feedback = 0;
	
	  //METHODS
	  counselingAndConsultancyVm.updateView = updateView;
	  counselingAndConsultancyVm.confirmDeleteCounseling = confirmDeleteCounseling;
	  counselingAndConsultancyVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  counselingAndConsultancyVm.bitacora = bitacora;
	
	  activate();
	
	  function activate() {
	    if (counselingAndConsultancyVm.workPlanGeneralList != undefined) {
	      counselingAndConsultancyVm.status = counselingAndConsultancyVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      counselingAndConsultancyVm.stages = counselingAndConsultancyVm.workPlanGeneralList.stages;
	      counselingAndConsultancyVm.feedback = counselingAndConsultancyVm.status.feedbackReviewed;
	      counselingAndConsultancyVm.workplanTeacherId = counselingAndConsultancyVm.status.workplanTeacherId;
	      isPlanning(counselingAndConsultancyVm.status, counselingAndConsultancyVm.stages);
	
	      if (counselingAndConsultancyVm.feedback && !counselingAndConsultancyVm.planningFinish) {
	        getDataFormAdviceConsultancyReject();
	      } else {
	        getDataFormAdviceConsultancy();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (counselingAndConsultancyVm.feedback && !counselingAndConsultancyVm.planningFinish) {
	          getDataFormAdviceConsultancyReject();
	        } else {
	          getDataFormAdviceConsultancy();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getDataFormAdviceConsultancy() {
	    WorkPlanSrv.getDataFormAdviceConsultancy.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listAdviceConsultancy);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(listAdviceConsultancy);
	    });
	  }
	
	  function getDataFormAdviceConsultancyReject() {
	    WorkPlanSrv.getDataFormAdviceConsultancyReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listAdviceConsultancy);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(listAdviceConsultancy);
	    });
	  }
	
	  function loadData(data) {
	    counselingAndConsultancyVm.dataList = data;
	  }
	
	  function updateView() {
	    counselingAndConsultancyVm.viewLoaded = false;
	    $timeout(function () {
	      counselingAndConsultancyVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        counselingAndConsultancyVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        counselingAndConsultancyVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        counselingAndConsultancyVm.stages = dataReturn.data.stages;
	        counselingAndConsultancyVm.feedback = counselingAndConsultancyVm.status.feedbackReviewed;
	        counselingAndConsultancyVm.workplanTeacherId = counselingAndConsultancyVm.status.workplanTeacherId;
	        isPlanning(counselingAndConsultancyVm.status, counselingAndConsultancyVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    counselingAndConsultancyVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        counselingAndConsultancyVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == counselingAndConsultancyVm.active) {
	        counselingAndConsultancyVm.planningFinish = true;
	        if (counselingAndConsultancyVm.startDateReview < counselingAndConsultancyVm.currentDate || status.reviewedFinish == counselingAndConsultancyVm.active) {
	          counselingAndConsultancyVm.planningFinish = true;
	        } else if (status.reviewedReject == counselingAndConsultancyVm.active) {
	          counselingAndConsultancyVm.planningFinish = false;
	        }
	      } else {
	        counselingAndConsultancyVm.planningFinish = false;
	      }
	    } else {
	      counselingAndConsultancyVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = counselingAndConsultancyVm.planningFinish ? "disabled" : " ";
	  }
	
	  function confirmDeleteCounseling(couseling) {
	    var name = couseling.name;
	    var workplanTeacherActivityId = couseling.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.name = name;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.delete = function () {
	          WorkPlanSrv.disableActivityResearch.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              showDeletedSuccessfully(ctrlModalVM.name);
	              removeFromCaroussel(couseling);
	              WorkPlanIndicatorSrv.setVariable(true);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(801),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(name) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: name,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeFromCaroussel(couseling) {
	    for (var i in counselingAndConsultancyVm.dataList) {
	      if (counselingAndConsultancyVm.dataList[i].workplanTeacherActivityId === couseling.workplanTeacherActivityId) {
	        counselingAndConsultancyVm.dataList.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.consultancy,
	      workplanTeacherId: counselingAndConsultancyVm.workplanTeacherId
	    };
	    entries.title = 'Consultoría y asesoría';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = CounselingAndConsultancyListCtrl;
	
	
	CounselingAndConsultancyListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la asesoría/consultoría <strong>\"{{ ctrlModalVM.name }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.delete()>Sí, eliminar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateProjectFormulationCtrl = function () {
	  function CreateProjectFormulationCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateProjectFormulationCtrl);
	
	    var createProjectFormulationVm = this;
	    var texts = GlobalConfig.appTexts;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId
	
	      // VARIABLES
	    };createProjectFormulationVm.isEditing = Boolean($stateParams.workplanTeacherActivityId);
	    createProjectFormulationVm.rolList = [];
	    createProjectFormulationVm.financialArray = [];
	    createProjectFormulationVm.typeFinancial = [];
	    createProjectFormulationVm.isTouchedfinancials = false;
	    createProjectFormulationVm.createOrEdit = 'Crear';
	    createProjectFormulationVm.textCreateOrEdit = texts.saved;
	    createProjectFormulationVm.createOrEditMV = texts.createDialog;
	    createProjectFormulationVm.active = GlobalConfig.generals.active;
	    createProjectFormulationVm.notActive = GlobalConfig.generals.notActive;
	    $scope.classPlanning = '';
	    createProjectFormulationVm.notification = createProjectFormulationVm.notActive;
	    createProjectFormulationVm.rangeType = GlobalConfig.periods.rangeType;
	    createProjectFormulationVm.periodsArray = [];
	    createProjectFormulationVm.typePeriod = [];
	    createProjectFormulationVm.isTouchedPeriods = false;
	    createProjectFormulationVm.selectedTypePeriod = {};
	    createProjectFormulationVm.selectedTypeFinancial = {};
	    createProjectFormulationVm.startDate = null;
	    createProjectFormulationVm.endDate = null;
	    createProjectFormulationVm.minStartDate = moment().toDate();
	    createProjectFormulationVm.minEndDate = new Date();
	    createProjectFormulationVm.buttonDisabled = false;
	    createProjectFormulationVm.isFeedback = currentUser.isFeedback;
	    createProjectFormulationVm.$cookies = $cookies;
	
	    createProjectFormulationVm.dt_start = $cookies.get('wp_start');
	    createProjectFormulationVm.dt_end = $cookies.get('wp_end');
	
	    // //METHODS
	    createProjectFormulationVm.validateForm = validateForm;
	    createProjectFormulationVm.showErrorMessages = showErrorMessages;
	    createProjectFormulationVm.hasError = hasError;
	    createProjectFormulationVm.startDateChange = startDateChange;
	    createProjectFormulationVm.funSelectedFinancial = funSelectedFinancial;
	    createProjectFormulationVm.validateCheklistFinancials = validateCheklistFinancials;
	    createProjectFormulationVm.funSelectedPeriod = funSelectedPeriod;
	    createProjectFormulationVm.validateCheklistPeriods = validateCheklistPeriods;
	    createProjectFormulationVm.close = close;
	    createProjectFormulationVm.addProject = addProject;
	    createProjectFormulationVm.cleanRangeType = cleanRangeType;
	
	    createProjectFormulationVm.updateRangeType = function (val) {
	      createProjectFormulationVm.rangeType = val;
	      createProjectFormulationVm.periodsArray = [];
	      createProjectFormulationVm.startDate = null;
	      createProjectFormulationVm.endDate = null;
	    };
	    createProjectFormulationVm.updateRangeData = function (val) {
	      createProjectFormulationVm.periodsArray = val['periods'];
	      createProjectFormulationVm.startDate = val['dates'][0];
	      createProjectFormulationVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createProjectFormulationVm.isEditing) {
	        createProjectFormulationVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createProjectFormulationVm.activityId = GlobalConfig.minorActivityId.project;
	        createProjectFormulationVm.createOrEdit = 'Editar';
	        createProjectFormulationVm.createOrEditMV = texts.editDialog;
	        createProjectFormulationVm.textCreateOrEdit = texts.modified;
	        getDataProject();
	      }
	
	      WorkPlanSrv.getListProjectsFormulated.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function showErrorMessages(input) {
	      if (input) {
	        return input.$dirty || input.$touched;
	      } else {
	        return false;
	      }
	    }
	
	    function hasError(input) {
	      if (input && input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function validateForm(form) {
	      return form && form.$invalid || createProjectFormulationVm.validateCheklistPeriods();
	    }
	
	    function loadData(data) {
	      createProjectFormulationVm.rolList = data.listRoles.items;
	      createProjectFormulationVm.typeFinancial = data.listFinancial;
	      createProjectFormulationVm.typePeriod = data.listPeriods;
	      updateView();
	    }
	
	    function updateView() {
	      createProjectFormulationVm.viewLoaded = false;
	      $timeout(function () {
	        createProjectFormulationVm.viewLoaded = true;
	      }, 1);
	    }
	
	    function funSelectedFinancial(financial, checked) {
	      if (checked) {
	        if (!createProjectFormulationVm.financialArray.includes(financial.financialId)) {
	          createProjectFormulationVm.financialArray.push(financial.financialId);
	        }
	      } else {
	        var index = createProjectFormulationVm.financialArray.indexOf(financial.financialId);
	        if (index != -1) {
	          createProjectFormulationVm.financialArray.splice(index, 1);
	        }
	      }
	      createProjectFormulationVm.isTouchedfinancials = true;
	    }
	
	    function validateCheklistFinancials() {
	      return createProjectFormulationVm.rangeType > 0 ? createProjectFormulationVm.financialArray.length < 1 : false;
	    }
	
	    function startDateChange() {
	      var m = moment(createProjectFormulationVm.startDate);
	      createProjectFormulationVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function validateCheklistPeriods() {
	      return createProjectFormulationVm.rangeType == 1 ? createProjectFormulationVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createProjectFormulationVm.periodsArray.includes(period.periodId)) {
	          createProjectFormulationVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createProjectFormulationVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createProjectFormulationVm.periodsArray.splice(index, 1);
	        }
	      }
	      createProjectFormulationVm.isTouchedPeriods = true;
	    }
	
	    function close() {
	      $mdDialog.hide();
	    }
	
	    function addProject(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var project = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createProjectFormulationVm.title,
	        summary: createProjectFormulationVm.projectSummary,
	        hoursPlanning: createProjectFormulationVm.plannedHours,
	        activityId: GlobalConfig.minorActivityId.project,
	        roleId: createProjectFormulationVm.rol,
	        notification: createProjectFormulationVm.notification,
	        timeRangeTypeId: createProjectFormulationVm.rangeType,
	        origin: origin,
	        isFeedbackActivity: createProjectFormulationVm.isFeedback
	
	        // Financiadores
	      };var arrayFinancial = [];
	      for (var index in createProjectFormulationVm.financialArray) {
	        var temp = {
	          financialId: createProjectFormulationVm.financialArray[index]
	        };
	        arrayFinancial.push(temp);
	      }
	      project.financial = arrayFinancial;
	
	      if (createProjectFormulationVm.isEditing) {
	        project.workplanTeacherActivityId = createProjectFormulationVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createProjectFormulationVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createProjectFormulationVm.periodsArray) {
	          var temp = {
	            periodId: createProjectFormulationVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        project.periods = arrayPeriod;
	      } else {
	        project.startDate = createProjectFormulationVm.startDate != null ? createProjectFormulationVm.startDate : createProjectFormulationVm.project.startDate;
	        project.endDate = createProjectFormulationVm.endDate != null ? createProjectFormulationVm.endDate : createProjectFormulationVm.project.endDate;
	      }
	      addOrEditProject(project);
	    }
	
	    function getSendNotify() {
	      var nameUser = currentUser.dsFullname;
	      var idTeacher = currentUser.teacherId;
	      var msg = 'El profesor ' + nameUser + ' ha registrado una formulación de proyecto';
	      var notificationName = 'Notificación, El profesor ' + nameUser + ' ha registrado una formulación de proyecto';
	      var groupedNotification = 1;
	
	      var dataInbox = {
	        idTeacher: idTeacher,
	        dsName: notificationName,
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: groupedNotification
	      };
	
	      var dataEmail = {
	        idTeacher: idTeacher,
	        dsName: notificationName,
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.email,
	        is_grouped: groupedNotification
	      };
	
	      var secondData = {
	        idTeacher: idTeacher,
	        dsName: 'Notificación, se ha registrado actividades en investigación',
	        dsDescription: 'El profesor ' + nameUser + ' ha registrado actividades en investigación',
	        idNotification_delivery_type: GlobalConfig.notificationType.email,
	        is_grouped: groupedNotification
	      };
	
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(dataInbox);
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(dataEmail);
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(secondData);
	    }
	
	    function addOrEditProject(project) {
	      createProjectFormulationVm.buttonDisabled = true;
	      WorkPlanSrv.addProjectFormulated.save(project).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          confirmProjectAction();
	          getSendNotify();
	        } else {
	          createProjectFormulationVm.buttonDisabled = false;
	        }
	      });
	    }
	
	    function confirmProjectAction() {
	      var header = {
	        createOrEdit: createProjectFormulationVm.createOrEditMV,
	        textCreateOrEdit: createProjectFormulationVm.textCreateOrEdit,
	        itemName: createProjectFormulationVm.title,
	        nameModal: texts.modalTypeName.projectFormulation,
	        modalType: texts.modalTypeId.projectFormulation
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header);
	    }
	
	    function getDataProject() {
	      var data = {
	        workplanTeacherActivityId: parseInt(createProjectFormulationVm.workplanTeacherActivityId),
	        activityId: parseInt(createProjectFormulationVm.activityId)
	      };
	      WorkPlanSrv.getProjectsFormulated.get(data).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          createProjectFormulationVm.project = dataReturn.project[0];
	          setValues(createProjectFormulationVm.project);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      });
	    }
	
	    function setValues(project) {
	      var dateValueSetter = function dateValueSetter(date) {
	        return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null;
	      };
	      createProjectFormulationVm.title = project.nameProject;
	      createProjectFormulationVm.rol = project.roleId;
	      createProjectFormulationVm.projectSummary = project.summary;
	      createProjectFormulationVm.rangeType = project.timeRangeTypeId;
	      createProjectFormulationVm.dt_start = dateValueSetter(project.startDate);
	      createProjectFormulationVm.dt_end = dateValueSetter(project.endDate);
	      createProjectFormulationVm.plannedHours = project.hoursPlanning;
	      createProjectFormulationVm.periodsArray = [];
	      createProjectFormulationVm.selectedTypePeriod = {};
	      createProjectFormulationVm.financialArray = [];
	      createProjectFormulationVm.selectedTypeFinancial = {};
	      createProjectFormulationVm.notification = Boolean(project.isNotification === 1);
	
	      if (createProjectFormulationVm.rangeType === GlobalConfig.periods.rangeType) {
	        createProjectFormulationVm.periodsArray = project.periodId.split(',').map(function (id) {
	          createProjectFormulationVm.selectedTypePeriod[Number(id)] = true;
	          return Number(id);
	        });
	      }
	
	      if (project.financialId != null) {
	        createProjectFormulationVm.financialArray = project.financialId.split(',').map(function (id) {
	          createProjectFormulationVm.selectedTypeFinancial[Number(id)] = true;
	          return Number(id);
	        });
	      }
	
	      if (project.startDate) {
	        var startDateNew = moment(project.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createProjectFormulationVm.minStartDate = moment(project.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createProjectFormulationVm.isEditing = true;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createProjectFormulationVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createProjectFormulationVm.startDate = null;
	        createProjectFormulationVm.endDate = null;
	      } else {
	        createProjectFormulationVm.periodsArray = [];
	        createProjectFormulationVm.selectedTypePeriod = null;
	      }
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateProjectFormulationCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateProjectFormulationCtrl;
	}();
	
	exports.default = CreateProjectFormulationCtrl;
	
	
	CreateProjectFormulationCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProjectsListCtrl = function ProjectsListCtrl($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
	  _classCallCheck(this, ProjectsListCtrl);
	
	  // constants
	  var projectsVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  var post = {
	    teacherId: currentUser.teacherId,
	    workplanId: currentUser.workplanId
	
	    // variables
	  };projectsVm.projectsList = [];
	  projectsVm.viewLoaded = true;
	  projectsVm.criteriaFilter = '';
	  projectsVm.selectedProject = null;
	  projectsVm.projectParent = null;
	  projectsVm.isLoadingDetails = false;
	  projectsVm.imgEmpty = __webpack_require__(445);
	  projectsVm.active = GlobalConfig.generals.active;
	  projectsVm.notActive = GlobalConfig.generals.notActive;
	  projectsVm.planningFinish = true;
	  $scope.classPlanning = '';
	  projectsVm.sr = '';
	  projectsVm.searchValue = false;
	  projectsVm.feedback = 0;
	  projectsVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  projectsVm.$sessionStorage = $sessionStorage;
	
	  // methods
	  projectsVm.projectBckgrd = projectBckgrd;
	  projectsVm.projectText = projectText;
	  projectsVm.details = details;
	  projectsVm.close = close;
	  projectsVm.updateFilter = updateFilter;
	  projectsVm.addActivityProject = addActivityProject;
	  projectsVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  projectsVm.searchResult = searchResult;
	  projectsVm.bitacora = bitacora;
	
	  // data validations
	  projectsVm.thereIsDetails = thereIsDetails;
	  projectsVm.showNotification = function () {
	    WorkPlanSrv.updateIsNotification.post({
	      workplanTeacherActivityId: projectsVm.projectParent.workplanTeacherActivityId,
	      isNotification: Number(projectsVm.isNotification)
	    }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectsVm.projectParent.isNotification = Number(!projectsVm.projectParent.isNotification);
	      } else {
	        projectsVm.isNotification = Boolean(projectsVm.projectParent.isNotification);
	      }
	    });
	  };
	
	  // services
	
	  activate();
	
	  function activate() {
	    if (projectsVm.workPlanGeneralList != undefined) {
	      projectsVm.status = projectsVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      projectsVm.stages = projectsVm.workPlanGeneralList.stages;
	      projectsVm.feedback = projectsVm.status.feedbackReviewed;
	      projectsVm.workplanTeacherId = projectsVm.status.workplanTeacherId;
	      isPlanning(projectsVm.status, projectsVm.stages);
	
	      if (projectsVm.feedback && !projectsVm.planningFinish) {
	        getDataFormProjectsReject();
	      } else {
	        getDataFormProjects();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (projectsVm.feedback && !projectsVm.planningFinish) {
	          getDataFormProjectsReject();
	        } else {
	          getDataFormProjects();
	        }
	      });
	    }
	  }
	
	  function getDataFormProjects() {
	    WorkPlanSrv.getDataFormProjects.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectsVm.projectsList = dataReturn.listProjects;
	
	        if (projectsVm.projectsList.length == 0) {
	          projectsVm.projectParent = 0;
	        }
	
	        if (projectsVm.projectsList && projectsVm.projectsList.length > 0) {
	          projectsVm.details(projectsVm.projectsList[0]);
	        }
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function getDataFormProjectsReject() {
	    WorkPlanSrv.getDataFormProjectsReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectsVm.projectsList = dataReturn.listProjects;
	
	        if (projectsVm.projectsList.length == 0) {
	          projectsVm.projectParent = 0;
	        }
	
	        if (projectsVm.projectsList && projectsVm.projectsList.length > 0) {
	          projectsVm.details(projectsVm.projectsList[0]);
	        }
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function validateSearch() {
	    return $filter('filter')(projectsVm.projectsList, projectsVm.criteriaFilter);
	  }
	
	  function searchResult() {
	    projectsVm.sr = validateSearch();
	  }
	
	  function getProjectDetails(project) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    WorkPlanSrv.getProjectByActivityId.get({ workplanTeacherActivityId: project.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectsVm.projectParent = dataReturn.data.parent;
	        projectsVm.isNotification = Boolean(projectsVm.projectParent.isNotification);
	        projectsVm.projectChilds = dataReturn.data.childs;
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log();
	    });
	
	    if (!reload) {
	      projectsVm.isLoadingDetails = true;
	      projectsVm.projectParent = null;
	    }
	  }
	
	  function thereIsDetails() {
	    return projectsVm.projectParent !== null;
	  }
	
	  function projectBckgrd(project) {
	    if (projectsVm.selectedProject === project) {
	      return 'bg-review';
	    }
	  }
	
	  function projectText(project) {
	    if (projectsVm.selectedProject === project) {
	      return 'text-color-w';
	    }
	  }
	
	  function details(project) {
	    projectsVm.selectedProject = project;
	    getProjectDetails(project);
	  }
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function updateFilter(val) {
	    projectsVm.criteriaFilter = val;
	    projectsVm.sr = validateSearch();
	    if (projectsVm.sr.length == 0) {
	      projectsVm.searchValue = true;
	      projectsVm.projectParent = null;
	    } else {
	      projectsVm.searchValue = false;
	      if (projectsVm.projectsList && projectsVm.projectsList.length > 0) {
	        projectsVm.details(projectsVm.projectsList[0]);
	      }
	    }
	  }
	
	  function addActivityProject(project, activity) {
	    activity.hoursChildren = project.hoursChildren;
	    var header = {
	      workplanTeacherActivityIdParent: project.workplanTeacherActivityId,
	      children: activity || 'ADD'
	    };
	    WorkPlanModalSrv.setVariable(header);
	    WorkPlanModalSrv.addActivityProject().then(function (promise) {
	      var shared = WorkPlanModalSrv.getVariable();
	      if (shared.status) {
	        // getProjectDetails(project)
	        if (shared.action == 'ADD') {
	          projectsVm.projectChilds.push(shared.child);
	        } else {
	          for (var i = projectsVm.projectChilds.length - 1; i >= 0; i--) {
	            if (projectsVm.projectChilds[i].workplanTeacherActivityId == shared.child.workplanTeacherActivityId) {
	              projectsVm.projectChilds[i].name = shared.child.name;
	              projectsVm.projectChilds[i].hoursPlanned = shared.child.hoursPlanned;
	              projectsVm.projectChilds[i].description = shared.child.description;
	              projectsVm.projectChilds[i].timeRangeTypeId = shared.child.timeRangeTypeId;
	              projectsVm.projectChilds[i].periodId = shared.child.periodId;
	              projectsVm.projectChilds[i].endDate = shared.child.timeRangeTypeId == GlobalConfig.periods.rangeType ? null : moment(shared.child.endDate).format('YYYY-MM-DD');
	              projectsVm.projectChilds[i].startDate = shared.child.timeRangeTypeId == GlobalConfig.periods.rangeType ? null : moment(shared.child.startDate).format('YYYY-MM-DD');
	            }
	          }
	        }
	      }
	      if (promise) {
	        getDataFormProjects();
	      }
	    });
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        projectsVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        projectsVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        projectsVm.stages = dataReturn.data.stages;
	        projectsVm.feedback = projectsVm.status.feedbackReviewed;
	        projectsVm.workplanTeacherId = projectsVm.status.workplanTeacherId;
	        isPlanning(projectsVm.status, projectsVm.stages);
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    projectsVm.currentDate = moment(new Date()).format('DD/MM/YYYY');
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        projectsVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.planningFinish == projectsVm.active) {
	      projectsVm.planningFinish = true;
	      if (projectsVm.startDateReview < projectsVm.currentDate || status.reviewedFinish == projectsVm.active) {
	        projectsVm.planningFinish = true;
	      } else if (status.reviewedReject == projectsVm.active) {
	        projectsVm.planningFinish = false;
	      }
	    } else {
	      projectsVm.planningFinish = false;
	    }
	    $scope.classPlanning = projectsVm.planningFinish ? 'disabled' : ' ';
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.projects,
	      workplanTeacherId: projectsVm.workplanTeacherId
	    };
	    entries.title = 'Proyectos';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = ProjectsListCtrl;
	
	
	ProjectsListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage'];

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateProjectCtrl = function () {
	  function CreateProjectCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateProjectCtrl);
	
	    var createProjectVm = this;
	    var texts = GlobalConfig.appTexts;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId
	      // name: currentUser.name
	
	
	      // //VARIABLES
	    };createProjectVm.idParent = WorkPlanModalSrv.getVariable();
	    createProjectVm.isEditing = Number($stateParams.workplanTeacherActivityId);
	    createProjectVm.rolList = [];
	    createProjectVm.projectFormulatedList = [];
	    createProjectVm.typeProjectList = [];
	    createProjectVm.financialArray = [];
	    createProjectVm.typeFinancial = [];
	    createProjectVm.groupInvestigationList = [];
	    createProjectVm.isTouchedfinancials = false;
	    createProjectVm.createOrEdit = 'Agregar';
	    createProjectVm.textCreateOrEdit = texts.saved;
	    createProjectVm.createOrEditMV = texts.createDialog;
	    createProjectVm.active = GlobalConfig.generals.active;
	    createProjectVm.notActive = GlobalConfig.generals.notActive;
	    createProjectVm.notification = createProjectVm.notActive;
	    createProjectVm.rangeType = GlobalConfig.periods.rangeType;
	    createProjectVm.periodsArray = [];
	    createProjectVm.typePeriod = [];
	    createProjectVm.isTouchedPeriods = false;
	    createProjectVm.selectedTypePeriod = {};
	    createProjectVm.selectedTypeFinancial = {};
	    createProjectVm.isDisableButton = true;
	    createProjectVm.startDate = null;
	    createProjectVm.endDate = null;
	    createProjectVm.minStartDate = moment().toDate();
	    createProjectVm.minEndDate = new Date();
	    createProjectVm.isSaveButtonDisabled = false;
	    createProjectVm.disabled = false;
	    createProjectVm.isFeedback = currentUser.isFeedback;
	    createProjectVm.dt_start = $cookies.get('wp_start');
	    createProjectVm.dt_end = $cookies.get('wp_end');
	    createProjectVm.dt_startt = moment($cookies.get('wp_start'))._d;
	    createProjectVm.dt_endd = moment($cookies.get('wp_end'))._d;
	
	    // // //METHODS
	    createProjectVm.validateForm = validateForm;
	    createProjectVm.showErrorMessages = showErrorMessages;
	    createProjectVm.hasError = hasError;
	    createProjectVm.startDateChange = startDateChange;
	    createProjectVm.funSelectedFinancial = funSelectedFinancial;
	    createProjectVm.validateCheklistFinancials = validateCheklistFinancials;
	    createProjectVm.funSelectedPeriod = funSelectedPeriod;
	    createProjectVm.validateCheklistPeriods = validateCheklistPeriods;
	    createProjectVm.close = close;
	    createProjectVm.addProject = addProject;
	    createProjectVm.addActivityProject = addActivityProject;
	    createProjectVm.cleanRangeType = cleanRangeType;
	
	    createProjectVm.updateRangeType = function (val) {
	      createProjectVm.rangeType = val;
	      createProjectVm.periodsArray = [];
	      createProjectVm.startDate = null;
	      createProjectVm.endDate = null;
	    };
	    createProjectVm.updateRangeData = function (val) {
	      createProjectVm.periodsArray = val['periods'];
	      createProjectVm.startDate = val['dates'][0];
	      createProjectVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createProjectVm.isEditing) {
	        createProjectVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createProjectVm.activityId = GlobalConfig.minorActivityId.projectParent;
	        getDataProject();
	      }
	
	      if (createProjectVm.idParent) {
	        createProjectVm.workplanTeacherActivityId = createProjectVm.idParent.children.workplanTeacherActivityId;
	        if (createProjectVm.idParent.children !== 'ADD') {
	          createProjectVm.disabled = true;
	          createProjectVm.createOrEdit = 'Editar';
	          createProjectVm.createOrEditMV = texts.editDialog;
	          createProjectVm.textCreateOrEdit = texts.modified;
	          setValues(createProjectVm.idParent.children);
	        }
	      }
	
	      WorkPlanSrv.getDataFormProjects.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function loadData(data) {
	      createProjectVm.rolList = data.listRole.items;
	      createProjectVm.projectFormulatedList = data.listPorjectsFormulated;
	      createProjectVm.typeFinancial = data.listFinancial;
	      createProjectVm.typeProjectList = data.listTypePorject.items;
	      createProjectVm.groupInvestigationList = data.academicUnit;
	      createProjectVm.typePeriod = data.listPeriods;
	      updateView();
	    }
	
	    function showErrorMessages(input) {
	      if (input) {
	        return input.$dirty || input.$touched;
	      } else {
	        return false;
	      }
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createProjectVm.validateCheklistPeriods();
	    }
	
	    function updateView() {
	      createProjectVm.viewLoaded = false;
	      $timeout(function () {
	        createProjectVm.viewLoaded = true;
	      }, 1);
	    }
	
	    function funSelectedFinancial(financial, checked) {
	      if (checked) {
	        if (!createProjectVm.financialArray.includes(financial.financialId)) {
	          createProjectVm.financialArray.push(financial.financialId);
	        }
	      } else {
	        var index = createProjectVm.financialArray.indexOf(financial.financialId);
	        if (index !== -1) {
	          createProjectVm.financialArray.splice(index, 1);
	        }
	      }
	      createProjectVm.isTouchedfinancials = true;
	    }
	
	    function validateCheklistFinancials() {
	      return createProjectVm.rangeType > 0 ? createProjectVm.financialArray.length < 1 : false;
	    }
	
	    function startDateChange() {
	      var m = moment(createProjectVm.startDate);
	      createProjectVm.minEndDate = m.isValid() ? m.add(0, 'days').toDate() : null;
	    }
	
	    function validateCheklistPeriods() {
	      return createProjectVm.rangeType === 1 ? createProjectVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createProjectVm.periodsArray.includes(period.periodId)) {
	          createProjectVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createProjectVm.periodsArray.indexOf(period.periodId);
	        if (index !== -1) {
	          createProjectVm.periodsArray.splice(index, 1);
	        }
	      }
	
	      var selectedPeriods = Object.values(createProjectVm.selectedTypePeriod);
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = selectedPeriods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var selected = _step.value;
	
	          if (selected) {
	            createProjectVm.isDisableButton = false;
	            break;
	          }
	          createProjectVm.isDisableButton = true;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      createProjectVm.isTouchedPeriods = true;
	    }
	
	    function close() {
	      WorkPlanModalSrv.setVariable({ status: false });
	      return $mdDialog.hide();
	    }
	
	    function addProject(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var project = {
	        activityId: GlobalConfig.minorActivityId.projectParent,
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createProjectVm.title,
	        description: createProjectVm.description,
	        hoursChildren: createProjectVm.hoursChildren,
	        hoursPlanning: createProjectVm.plannedHours,
	        porjectsFormulatedId: createProjectVm.projectFormulated,
	        itemRoleId: createProjectVm.rol,
	        itemTypePorjectId: createProjectVm.typeProject,
	        academicUnitId: createProjectVm.groupInvestigation,
	        isNotification: createProjectVm.notification,
	        timeRangeTypeId: createProjectVm.rangeType,
	        origin: origin,
	        isFeedbackActivity: createProjectVm.isFeedback
	
	        // Financiadores
	      };var arrayFinancial = [];
	      for (var index in createProjectVm.financialArray) {
	        var temp = {
	          financialId: createProjectVm.financialArray[index]
	        };
	        arrayFinancial.push(temp);
	      }
	      project.financial = arrayFinancial;
	
	      if (createProjectVm.isEditing) {
	        project.workplanTeacherActivityId = createProjectVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createProjectVm.rangeType) == GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        createProjectVm.startDate = null;
	        createProjectVm.endDate = null;
	        for (var index in createProjectVm.periodsArray) {
	          var temp = {
	            periodId: createProjectVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        project.periods = arrayPeriod;
	      } else {
	        project.startDate = createProjectVm.startDate;
	        project.endDate = createProjectVm.endDate;
	      }
	      createProjectVm.modalType = texts.modalTypeId.project;
	      addOrEditProject(project, createProjectVm.modalType);
	    }
	
	    function addOrEditProject(project, modalType) {
	      var action = 'ADD';
	      if (createProjectVm.workplanTeacherActivityId) {
	        action = 'EDIT';
	      }
	      createProjectVm.isSaveButtonDisabled = true;
	
	      WorkPlanSrv.addActivityProject.save(project).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          project.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	          project.hoursPlanned = project.hoursPlanning;
	          // let data = {
	          //   idUser:  post.teacherId
	          //   dsName: 'Notificación, se ha registrado actividades en investigación',
	          //   dsDescription: 'El profesor ' + post.name + ' ha registrado actividades en investigación',
	          //   idNotification_delivery_type: GlobalConfig.notificationType.email
	          // }
	
	          if (isProject(modalType)) {
	            confirmProjectAction(modalType);
	            // GlobalSrv.sendNotification(data)
	          } else {
	            WorkPlanModalSrv.setVariable({ status: dataReturn.status, child: project, action: action });
	            confirmProjectAction(modalType);
	            // GlobalSrv.sendNotification(data)
	            return $mdDialog.hide(true);
	          }
	        } else {
	          createProjectVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        createProjectVm.isSaveButtonDisabled = false;
	      });
	    }
	
	    function confirmProjectAction(modalType) {
	      var header = {
	        createOrEdit: createProjectVm.createOrEditMV,
	        textCreateOrEdit: createProjectVm.textCreateOrEdit,
	        itemName: createProjectVm.title,
	        nameModal: isProject(modalType) ? texts.modalTypeName.project : texts.modalTypeName.activity,
	        modalType: modalType
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getDataProject() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createProjectVm.workplanTeacherActivityId)
	      };
	      WorkPlanSrv.getProjectByActivityId.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          if (!dataReturn.data.parent) {
	            createProjectVm.project = dataReturn.data.childs[0];
	          } else {
	            createProjectVm.project = dataReturn.data.parent;
	          }
	          setValues(createProjectVm.project);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(project) {
	      var dateValueSetter = function dateValueSetter(date) {
	        return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null;
	      };
	      createProjectVm.title = project.name;
	      createProjectVm.groupInvestigation = project.academicUnitId;
	      createProjectVm.projectFormulated = project.projectFormulatedId;
	      createProjectVm.typeProject = project.listItemProjectTypeId;
	      createProjectVm.rol = project.listItemProjectRoleId;
	      createProjectVm.description = project.description ? project.description : '-';
	      createProjectVm.rangeType = project.timeRangeTypeId;
	      createProjectVm.hoursChildren = project.hoursChildren;
	      createProjectVm.dt_start = moment(project.startDate)._d;
	      createProjectVm.dt_end = moment(project.endDate)._d;
	      createProjectVm.plannedHours = project.hoursPlanned;
	      createProjectVm.notification = Boolean(project.isNotification === 1);
	      createProjectVm.periodsArray = [];
	      createProjectVm.selectedTypePeriod = {};
	      createProjectVm.financialArray = [];
	      createProjectVm.selectedTypeFinancial = {};
	
	      if (createProjectVm.rangeType == GlobalConfig.periods.rangeType) {
	        createProjectVm.periodsArray = project.periodId.split(',').map(function (id) {
	          createProjectVm.selectedTypePeriod[Number(id)] = true;
	          return Number(id);
	        });
	      }
	
	      if (project.financialSourceId) {
	        createProjectVm.financialArray = project.financialSourceId.split(',').map(function (id) {
	          createProjectVm.selectedTypeFinancial[Number(id)] = true;
	          return Number(id);
	        });
	      }
	
	      if (project.startDate) {
	        var startDateNew = moment(project.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createProjectVm.minStartDate = moment(project.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createProjectVm.isEditing = true;
	    }
	
	    function addActivityProject(activity) {
	      createJsonActivity();
	    }
	
	    function createJsonActivity() {
	      var arrayPeriod = [];
	      var activity = {
	        activityId: GlobalConfig.minorActivityId.projectChild,
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createProjectVm.title,
	        description: createProjectVm.description,
	        hoursChildren: createProjectVm.hoursChildren,
	        hoursPlanning: createProjectVm.plannedHours,
	        parentActivityId: createProjectVm.idParent.workplanTeacherActivityIdParent,
	        timeRangeTypeId: createProjectVm.rangeType,
	        isFeedbackActivity: createProjectVm.isFeedback
	      };
	
	      if (createProjectVm.rangeType == GlobalConfig.periods.rangeType) {
	        var aux = [];
	        for (var index in createProjectVm.periodsArray) {
	          var temp = {
	            periodId: createProjectVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	          aux.push(createProjectVm.periodsArray[index]);
	        }
	        activity.periods = arrayPeriod;
	        activity.periodId = aux.join(',');
	      } else {
	        activity.startDate = createProjectVm.dt_start;
	        activity.endDate = createProjectVm.dt_end;
	      }
	      if (createProjectVm.isEditing) {
	        activity.workplanTeacherActivityId = createProjectVm.workplanTeacherActivityId;
	      }
	
	      createProjectVm.modalType = texts.modalTypeId.activity;
	      addOrEditProject(activity, createProjectVm.modalType);
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createProjectVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createProjectVm.dt_start = null;
	        createProjectVm.dt_end = null;
	        createProjectVm.startDate = null;
	        createProjectVm.endDate = null;
	      } else {
	        createProjectVm.periodsArray = [];
	        createProjectVm.selectedTypePeriod = null;
	        createProjectVm.isDisableButton = true;
	      }
	    }
	
	    function isProject(value) {
	      return value == texts.modalTypeId.project;
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateProjectCtrl, [{
	    key: 'rbPlanifications',
	    value: function rbPlanifications(bool) {
	      if (bool) {
	        this.startDate = null;
	        this.endDate = null;
	      } else {
	        this.periodsArray = [];
	        this.selectedTypePeriod = null;
	        this.startDate = null;
	        this.endDate = null;
	      }
	    }
	  }, {
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateProjectCtrl;
	}();
	
	exports.default = CreateProjectCtrl;
	
	
	CreateProjectCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductsListCtrl = function ProductsListCtrl($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
	  _classCallCheck(this, ProductsListCtrl);
	
	  // constants
	  var productsVm = this;
	  var currentUser = $cookies.getObject('currentUser');
	
	  var post = {
	    teacherId: currentUser.teacherId,
	    workplanId: currentUser.workplanId
	
	    // variables
	  };productsVm.productsList = [];
	  productsVm.viewLoaded = true;
	  productsVm.criteriaFilter = '';
	  productsVm.selectedProduct = null;
	  productsVm.productParent = null;
	  productsVm.isLoadingDetails = false;
	  productsVm.imgEmpty = __webpack_require__(445);
	  productsVm.active = GlobalConfig.generals.active;
	  productsVm.notActive = GlobalConfig.generals.notActive;
	  productsVm.planningFinish = true;
	  $scope.classPlanning = '';
	  productsVm.sr = '';
	  productsVm.searchValue = false;
	  productsVm.feedback = 0;
	  productsVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  productsVm.$sessionStorage = $sessionStorage;
	
	  // methods
	  productsVm.productBckgrd = productBckgrd;
	  productsVm.productText = productText;
	  productsVm.details = details;
	  productsVm.close = close;
	  productsVm.updateFilter = updateFilter;
	  productsVm.addActivityProduct = addActivityProduct;
	  productsVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  productsVm.searchResult = searchResult;
	  productsVm.bitacora = bitacora;
	  productsVm.disableProductActivyId = disableProductActivyId;
	  productsVm.eliminarProducto = eliminarProducto;
	
	  // data validations
	  productsVm.thereIsDetails = thereIsDetails;
	
	  // services
	
	  activate();
	
	  function activate() {
	    if (productsVm.workPlanGeneralList != undefined) {
	      productsVm.status = productsVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      productsVm.stages = productsVm.workPlanGeneralList.stages;
	      productsVm.feedback = productsVm.status.feedbackReviewed;
	      productsVm.workplanTeacherId = productsVm.status.workplanTeacherId;
	      isPlanning(productsVm.status, productsVm.stages);
	
	      if (productsVm.feedback && !productsVm.planningFinish) {
	        getDataFormProductReject();
	      } else {
	        getDataFormProduct();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (productsVm.feedback && !productsVm.planningFinish) {
	          getDataFormProductReject();
	        } else {
	          getDataFormProduct();
	        }
	      });
	    }
	  }
	
	  function getDataFormProduct() {
	    return WorkPlanSrv.getDataFormProduct.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        productsVm.productsList = dataReturn.listProducts;
	        if (productsVm.productsList.length == 0) {
	          productsVm.productParent = 0;
	        }
	
	        if (productsVm.productsList && productsVm.productsList.length > 0) {
	          productsVm.details(productsVm.productsList[0]);
	        }
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function getDataFormProductReject() {
	    return WorkPlanSrv.getDataFormProductReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        productsVm.productsList = dataReturn.listProducts;
	        if (productsVm.productsList.length == 0) {
	          productsVm.productParent = 0;
	        }
	
	        if (productsVm.productsList && productsVm.productsList.length > 0) {
	          productsVm.details(productsVm.productsList[0]);
	        }
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log();
	    });
	  }
	
	  function validateSearch() {
	    return $filter('filter')(productsVm.productsList, productsVm.criteriaFilter);
	  }
	
	  function searchResult() {
	    productsVm.sr = validateSearch();
	  }
	
	  function getProductDetails(product) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    WorkPlanSrv.getProductByActivityId.get({ workplanTeacherActivityId: product.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        productsVm.productParent = dataReturn.data.parent;
	        productsVm.productChilds = dataReturn.data.childs;
	      } else {
	        console.log('Comunications problem');
	      }
	    }, function (data) {
	      console.log();
	    });
	
	    if (!reload) {
	      productsVm.isLoadingDetails = true;
	      productsVm.productParent = null;
	    }
	  }
	
	  function thereIsDetails() {
	    return productsVm.productParent !== null;
	  }
	
	  function productBckgrd(product) {
	    if (productsVm.selectedProduct === product) {
	      return 'bg-review';
	    }
	  }
	
	  function productText(product) {
	    if (productsVm.selectedProduct === product) {
	      return 'text-color-w';
	    }
	  }
	
	  function details(product) {
	    productsVm.selectedproduct = product;
	    getProductDetails(product);
	  }
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function updateFilter(val) {
	    productsVm.criteriaFilter = val;
	    productsVm.sr = validateSearch();
	    if (productsVm.sr.length == 0) {
	      productsVm.searchValue = true;
	      productsVm.productParent = null;
	    } else {
	      productsVm.searchValue = false;
	      if (productsVm.productsList && productsVm.productsList.length > 0) {
	        productsVm.details(productsVm.productsList[0]);
	      }
	    }
	  }
	
	  function addActivityProduct(product, activity) {
	    var header = {
	      workplanTeacherActivityIdParent: product.workplanTeacherActivityId,
	      children: activity || 'ADD',
	      hoursChildren: product.hoursChildren
	    };
	
	    WorkPlanModalSrv.setVariable(header);
	    WorkPlanModalSrv.addActivityProduct().then(function (promise) {
	      var shared = WorkPlanModalSrv.getVariable();
	      if (shared) {
	        // getProductDetails(product)
	        if (shared.action === 'ADD') {
	          productsVm.productChilds.push(shared.child);
	        } else if (shared.action === 'EDIT') {
	          for (var i = productsVm.productChilds.length - 1; i >= 0; i--) {
	            if (productsVm.productChilds[i].workplanTeacherActivityId === shared.child.workplanTeacherActivityId) {
	              productsVm.productChilds[i].name = shared.child.name;
	              productsVm.productChilds[i].hoursPlanned = shared.child.hoursPlanned;
	              productsVm.productChilds[i].description = shared.child.description;
	              productsVm.productChilds[i].endDate = shared.child.endDate;
	              productsVm.productChilds[i].startDate = shared.child.startDate;
	              productsVm.productChilds[i].timeRangeTypeId = parseInt(shared.child.timeRangeTypeId);
	              productsVm.productChilds[i].periods = shared.child.periods;
	              //productsVm.productChilds[i].periodId = shared.child.periods
	            }
	          }
	        }
	      }
	    });
	  }
	
	  function endPlanning() {
	    var post = {
	      teacherId: currentUser.teacherId,
	      workplanId: currentUser.workplanId,
	      userId: currentUser.id,
	      stageId: GlobalConfig.workplanIdStages.planning,
	      stageName: GlobalConfig.workplanStagesNames.planning,
	      submodules: $cookies.getObject('subModuleId'),
	      teaching: GlobalConfig.modules.teaching,
	      academicManagement: GlobalConfig.modules.academicManagement,
	      feedback: productsVm.feedback
	    };
	
	    var submodules = Requests.submoduleItemRequired(post);
	
	    if (submodules.teaching || submodules.academicManagement) {
	      Requests.getItemsRequiredList(WorkPlanSrv, post).then(function (data) {
	        data.submodule = submodules;
	
	        if (Requests.validateItems(data)) {
	          Requests.showModalItemRequiredEndPlanning(WorkPlanModalSrv, data);
	        } else {
	          Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post);
	        }
	        activate();
	      });
	    } else {
	      Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post);
	      activate();
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        productsVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        productsVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        productsVm.stages = dataReturn.data.stages;
	        productsVm.feedback = productsVm.status.feedbackReviewed;
	        productsVm.workplanTeacherId = productsVm.status.workplanTeacherId;
	        isPlanning(productsVm.status, productsVm.stages);
	      } else {
	        console.log('Comunications problem with the server');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function disableProductActivyId(wplt, product, ev) {
	    var _this = this;
	
	    eliminarProducto(ev).then(function (answer) {
	      if (answer) {
	        return WorkPlanSrv.disableProductActivyId.get({ workplanTeacherId: wplt }).$promise.then(function (response) {
	          if (!response.status) {
	            _this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
	          } else {
	            getDataFormProduct();
	            getProductDetails(product, false);
	          }
	        }, function (err) {
	          _this.ngNotify.set('Imposible conectar con el servicio', 'error');
	        });
	      }
	    });
	  }
	
	  function isPlanning(status, stages) {
	    productsVm.currentDate = moment(new Date()).format('DD/MM/YYYY');
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        productsVm.startDateStage = stages[i].startDate;
	      }
	    }
	    if (status.workplanActive) {
	      if (status.planningFinish == productsVm.active) {
	        productsVm.planningFinish = true;
	        if (productsVm.startDateReview < productsVm.currentDate || status.reviewedFinish == productsVm.active) {
	          productsVm.planningFinish = true;
	        } else if (status.reviewedReject == productsVm.active) {
	          productsVm.planningFinish = false;
	        }
	      } else {
	        productsVm.planningFinish = false;
	      }
	    } else {
	      productsVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = productsVm.planningFinish ? 'disabled' : ' ';
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.products,
	      workplanTeacherId: productsVm.workplanTeacherId
	    };
	    entries.title = 'Productos';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	
	  function eliminarProducto(ev) {
	    return $mdDialog.show({
	      controller: ['$scope', '$mdDialog', productDeleteCtrl],
	      controllerAs: 'productDelete',
	      template: __webpack_require__(806),
	      parent: angular.element(document.body),
	      targetEvent: ev
	    });
	  };
	
	  function productDeleteCtrl($scope, $mdDialog) {
	    $scope.close = function (answer) {
	      $mdDialog.hide(answer);
	    };
	  }
	};
	
	exports.default = ProductsListCtrl;
	
	
	ProductsListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage'];

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar el producto ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close(false)>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=close(true)>Sí, eliminar producto</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateProductCtrl = function () {
	  function CreateProductCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateProductCtrl);
	
	    var createProductVm = this;
	    var texts = GlobalConfig.appTexts;
	    var currentUser = $cookies.getObject('currentUser');
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId,
	      name: currentUser.name
	
	      // //VARIABLES
	    };createProductVm.idParent = WorkPlanModalSrv.getVariable();
	    createProductVm.isEditing = Number($stateParams.workplanTeacherActivityId);
	    createProductVm.knowledgeList = [];
	    createProductVm.productFormulatedList = [];
	    createProductVm.typeProductList = [];
	    createProductVm.subTypeProductList = [];
	    createProductVm.associatedProjecttList = [];
	    createProductVm.groupInvestigationList = [];
	    createProductVm.isTouchedfinancials = false;
	    createProductVm.createOrEdit = 'Agregar';
	    createProductVm.createOrEditTitle = 'agregar';
	    createProductVm.createOrEditModal = 'agregar';
	    createProductVm.textCreateOrEdit = texts.saved;
	    createProductVm.createOrEditMV = texts.createDialog;
	    createProductVm.active = GlobalConfig.generals.active;
	    createProductVm.notActive = GlobalConfig.generals.notActive;
	    createProductVm.isNotification = createProductVm.notActive;
	    createProductVm.rangeType = GlobalConfig.periods.rangeType;
	    createProductVm.periodsArray = [];
	    createProductVm.typePeriod = [];
	    createProductVm.isTouchedPeriods = false;
	    createProductVm.selectedTypePeriod = {};
	    createProductVm.startDate = null;
	    createProductVm.endDate = null;
	    createProductVm.minStartDate = moment().toDate();
	    createProductVm.minEndDate = new Date();
	    createProductVm.buttonDisabled = false;
	    createProductVm.hoursChildren = 0;
	    createProductVm.showHoursChildren = false;
	    createProductVm.isFeedback = currentUser.isFeedback;
	    createProductVm.dt_start = $cookies.get('wp_start');
	    createProductVm.dt_end = $cookies.get('wp_end');
	
	    // // //METHODS
	    createProductVm.validateForm = validateForm;
	    createProductVm.showErrorMessages = showErrorMessages;
	    createProductVm.hasError = hasError;
	    createProductVm.startDateChange = startDateChange;
	    createProductVm.funSelectedPeriod = funSelectedPeriod;
	    createProductVm.validateCheklistPeriods = validateCheklistPeriods;
	    createProductVm.close = close;
	    createProductVm.addProduct = addProduct;
	    createProductVm.addActivityProduct = addActivityProduct;
	    createProductVm.cleanRangeType = cleanRangeType;
	    createProductVm.hoursChange = hoursChange;
	
	    createProductVm.updateRangeType = function (val) {
	      createProductVm.rangeType = val;
	      createProductVm.periodsArray = [];
	      createProductVm.startDate = null;
	      createProductVm.endDate = null;
	    };
	    createProductVm.updateRangeData = function (val) {
	      createProductVm.periodsArray = val['periods'];
	      createProductVm.startDate = val['dates'][0];
	      createProductVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createProductVm.isEditing) {
	        createProductVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createProductVm.activityId = GlobalConfig.minorActivityId.productParent;
	        createProductVm.createOrEdit = 'Editar';
	        createProductVm.createOrEditModal = 'editar';
	        createProductVm.createOrEditTitle = 'editar';
	        createProductVm.createOrEditMV = texts.editDialog;
	        createProductVm.textCreateOrEdit = texts.modified;
	        getDataProduct();
	      }
	
	      if (createProductVm.idParent) {
	        createProductVm.isEditing = true;
	        if (createProductVm.idParent.children !== 'ADD') {
	          createProductVm.createOrEditMV = texts.editDialog;
	          createProductVm.textCreateOrEdit = texts.modified;
	          createProductVm.createOrEdit = 'Editar';
	          createProductVm.createOrEditModal = 'editar';
	          createProductVm.createOrEditTitle = 'editar';
	          createProductVm.workplanTeacherActivityId = createProductVm.idParent.children.workplanTeacherActivityId;
	          setValues(createProductVm.idParent.children, createProductVm.idParent.hoursChildren);
	        } else {
	          createProductVm.hoursChildren = createProductVm.idParent.hoursChildren ? createProductVm.idParent.hoursChildren : 0;
	        }
	      }
	
	      WorkPlanSrv.getDataFormProduct.getList(post).$promise.then(function (dataReturn) {
	        dataReturn.status ? loadData(dataReturn) : console.log('Comunications problem');
	      });
	    }
	
	    function loadData(data) {
	      createProductVm.knowledgeList = data.listKnowledge.items;
	      createProductVm.typeProductList = data.listItemsProducts;
	      createProductVm.subTypeProductList = data.listSubItemsProducts;
	      createProductVm.associatedProjecttList = data.listProjects;
	      createProductVm.typePeriod = data.listPeriods;
	      updateView();
	    }
	
	    function showErrorMessages(input) {
	      if (input) {
	        return input.$dirty || input.$touched;
	      } else {
	        return false;
	      }
	    }
	
	    function hasError(input) {
	      if (input && input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createProductVm.validateCheklistPeriods();
	    }
	
	    function updateView() {
	      createProductVm.viewLoaded = false;
	      $timeout(function () {
	        createProductVm.viewLoaded = true;
	      }, 1);
	    }
	
	    function startDateChange() {
	      var m = moment(createProductVm.startDate);
	      createProductVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function validateCheklistPeriods() {
	      return createProductVm.rangeType == 1 && createProductVm.periodsArray ? createProductVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createProductVm.periodsArray.includes(period.periodId)) {
	          createProductVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createProductVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createProductVm.periodsArray.splice(index, 1);
	        }
	      }
	      createProductVm.isTouchedPeriods = true;
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function addProduct(isExecution) {
	      if (createProductVm.notification == true) {
	        createProductVm.notification = 1;
	      }
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function createJson(origin) {
	      var product = {
	        activityId: GlobalConfig.minorActivityId.productParent,
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createProductVm.title,
	        description: createProductVm.description,
	        hoursPlanning: createProductVm.plannedHours,
	        projectId: createProductVm.associatedProject,
	        itemKnowledgeId: createProductVm.knowledge,
	        itemProductId: createProductVm.typeProduct,
	        itemSubProductId: createProductVm.subTypeProduct,
	        isNotification: createProductVm.notification,
	        timeRangeTypeId: createProductVm.rangeType,
	        origin: origin,
	        hoursChildren: parseInt(createProductVm.hoursChildren),
	        isFeedbackActivity: createProductVm.isFeedback
	      };
	
	      if (createProductVm.isEditing) {
	        product.workplanTeacherActivityId = createProductVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createProductVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createProductVm.periodsArray) {
	          var temp = {
	            periodId: createProductVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        product.periods = arrayPeriod;
	      } else {
	        product.startDate = new Date(createProductVm.startDate);
	        product.endDate = new Date(createProductVm.endDate);
	      }
	      createProductVm.modalType = texts.modalTypeId.product;
	      addOrEditProduct(product, createProductVm.modalType);
	    }
	
	    function getNotify(isProduct) {
	      var reviewers = GlobalSrv.getReviewersAndEvaluator();
	      reviewers.forEach(function (reviewer) {
	        if (isProduct) getSendNotify(reviewer);else getSendNotifyActivity(reviewer);
	      });
	    }
	
	    function getSendNotify(idUser) {
	      var nameUser = currentUser.dsFullname;
	      var data = {
	        idUser: idUser,
	        dsName: 'Notificación, se agregó producto',
	        dsDescription: 'El profesor ' + nameUser + ' ha agregado un producto',
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1
	      };
	      GlobalSrv.sendNotification(data);
	    }
	
	    function getSendNotifyActivity(idUser) {
	      var nameUser = currentUser.dsFullname;
	
	      var data = {
	        idUser: idUser,
	        dsName: 'Notificación, se ha registrado actividades en investigación',
	        dsDescription: 'El profesor ' + nameUser + ' ha registrado actividades en investigación',
	        idNotification_delivery_type: GlobalConfig.notificationType.email,
	        is_grouped: 1
	      };
	      GlobalSrv.sendNotification(data);
	    }
	
	    function addOrEditProduct(product, modalType) {
	      createProductVm.buttonDisabled = true;
	      var action = 'ADD';
	      if (createProductVm.workplanTeacherActivityId) {
	        action = 'EDIT';
	      }
	
	      WorkPlanSrv.addActivityProduct.save(product).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          product.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId;
	          product.hoursPlanned = product.hoursPlanning;
	          if (createProductVm.idParent && createProductVm.idParent.children && typeof createProductVm.idParent.children !== 'string') {
	            createProductVm.idParent.children.name = product.name;
	            createProductVm.idParent.children.periodId = product.periodId;
	            createProductVm.idParent.children.description = product.description;
	            createProductVm.idParent.children.startDate = product.startDate;
	            createProductVm.idParent.children.endDate = product.endDate;
	            createProductVm.idParent.children.timeRangeTypeId = product.timeRangeTypeId;
	          }
	          getNotify(isProduct(modalType));
	          if (isProduct(modalType)) {
	            confirmProductAction(modalType);
	          } else {
	            WorkPlanModalSrv.setVariable({ status: dataReturn.status, child: product, action: action });
	            confirmProductAction(modalType);
	            return $mdDialog.hide();
	          }
	        } else {
	          console.log('Error Comunications');
	          createProductVm.buttonDisabled = false;
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function confirmProductAction(modalType) {
	      var header = {
	        createOrEdit: createProductVm.createOrEditMV,
	        textCreateOrEdit: createProductVm.textCreateOrEdit,
	        itemName: createProductVm.title,
	        nameModal: isProduct(modalType) ? texts.modalTypeName.product : texts.modalTypeName.activity,
	        modalType: modalType
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getDataProduct() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createProductVm.workplanTeacherActivityId)
	      };
	      WorkPlanSrv.getProductByActivityId.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          if (!dataReturn.data.parent) {
	            createProductVm.product = dataReturn.data.childs[0];
	          } else {
	            createProductVm.product = dataReturn.data.parent;
	            createProductVm.child = dataReturn.data.childs;
	          }
	          setValues(createProductVm.product, createProductVm.product.hoursChildren);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(product, hoursChildren) {
	      var dateValueSetter = function dateValueSetter(date) {
	        return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null;
	      };
	      createProductVm.title = product.name;
	      createProductVm.description = product.description;
	      createProductVm.associatedProject = product.projectId;
	      createProductVm.knowledge = product.itemKnowledgeId;
	      createProductVm.typeProduct = product.itemProductId;
	      createProductVm.subTypeProduct = product.subItemProductId;
	      createProductVm.rangeType = product.timeRangeTypeId;
	      createProductVm.dt_start = dateValueSetter(product.startDate);
	      createProductVm.dt_end = dateValueSetter(product.endDate);
	      createProductVm.plannedHours = product.hoursPlanned;
	      createProductVm.notification = Boolean(product.isNotification === 1);
	      // createProductVm.hoursChildren = (product.hoursChildren ? product.hoursChildren : 0)
	      createProductVm.periodsArray = []; // product.periods
	      createProductVm.selectedTypePeriod = {};
	      createProductVm.hoursChildren = hoursChildren ? hoursChildren : 0;
	
	      if (parseInt(createProductVm.rangeType) === GlobalConfig.periods.rangeType) {
	        if (product.periodId) {
	          createProductVm.periodsArray = product.periodId.split(',').map(function (id) {
	            createProductVm.selectedTypePeriod[Number(id)] = true;
	            return Number(id);
	          });
	        } else {
	          createProductVm.periodsArray = product.periods;
	        }
	      }
	      if (product.startDate) {
	        var startDateNew = moment(product.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createProductVm.minStartDate = moment(product.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createProductVm.isEditing = true;
	    }
	
	    function addActivityProduct(activity) {
	      createJsonActivity();
	    }
	
	    function createJsonActivity() {
	      var activity = {
	        activityId: GlobalConfig.minorActivityId.productChild,
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createProductVm.title,
	        description: createProductVm.description,
	        hoursPlanning: createProductVm.plannedHours,
	        parentActivityId: createProductVm.idParent.workplanTeacherActivityIdParent,
	        hoursChildren: createProductVm.idParent.hoursChildren,
	        timeRangeTypeId: createProductVm.rangeType,
	        isFeedbackActivity: createProductVm.isFeedback
	      };
	
	      if (activity.hoursChildren == 0) {
	        activity.hoursPlanning = 0;
	      }
	
	      if (parseInt(createProductVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var periodIds = '';
	        var arrayPeriod = [];
	        for (var index in createProductVm.periodsArray) {
	          var temp = {
	            periodId: createProductVm.periodsArray[index]
	          };
	          periodIds = periodIds + createProductVm.periodsArray[index] + ',';
	          arrayPeriod.push(temp);
	        }
	        activity.periods = arrayPeriod;
	        activity.periodId = periodIds.slice(0, -1);
	      } else {
	        activity.startDate = createProductVm.startDate;
	        activity.endDate = createProductVm.endDate;
	      }
	      if (createProductVm.isEditing) {
	        activity.workplanTeacherActivityId = createProductVm.workplanTeacherActivityId;
	      }
	
	      createProductVm.modalType = texts.modalTypeId.activity;
	      addOrEditProduct(activity, createProductVm.modalType);
	    }
	
	    function isProduct(value) {
	      return value == texts.modalTypeId.product;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createProductVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createProductVm.startDate = null;
	        createProductVm.endDate = null;
	      } else {
	        createProductVm.periodsArray = [];
	        createProductVm.selectedTypePeriod = null;
	      }
	    }
	
	    function hoursChange(aux) {
	      if (aux == null) {
	        createProductVm.showHoursChildren = false;
	      } else {
	        createProductVm.showHoursChildren = true;
	      }
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateProductCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateProductCtrl;
	}();
	
	exports.default = CreateProductCtrl;
	
	
	CreateProductCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CollaborationSpacesListCtrl = function CollaborationSpacesListCtrl($scope, $timeout, WorkPlanSrv, $mdDialog, $cookies, GlobalConfig, WorkPlanModalSrv, Requests, $sessionStorage) {
	  _classCallCheck(this, CollaborationSpacesListCtrl);
	
	  var collaborationSpacesVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	  };
	
	  collaborationSpacesVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  collaborationSpacesVm.$sessionStorage = $sessionStorage;
	
	  collaborationSpacesVm.mainLabel = 'Espacios de colaboración';
	  collaborationSpacesVm.spaceList = [];
	  collaborationSpacesVm.viewLoaded = false;
	  collaborationSpacesVm.gradRoleClass = 'grad-1';
	  collaborationSpacesVm.active = GlobalConfig.generals.active;
	  collaborationSpacesVm.notActive = GlobalConfig.generals.notActive;
	  collaborationSpacesVm.planningFinish = true;
	  $scope.classPlanning = '';
	  collaborationSpacesVm.feedback = 0;
	  collaborationSpacesVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  collaborationSpacesVm.imgEmpty = __webpack_require__(445);
	
	  collaborationSpacesVm.confirmDeleteSpace = confirmDeleteSpace;
	  collaborationSpacesVm.updateView = updateView;
	  collaborationSpacesVm.loadData = loadData;
	  collaborationSpacesVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  collaborationSpacesVm.bitacora = bitacora;
	
	  activate();
	
	  function activate() {
	    if (collaborationSpacesVm.workPlanGeneralList != undefined) {
	      collaborationSpacesVm.status = collaborationSpacesVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      collaborationSpacesVm.stages = collaborationSpacesVm.workPlanGeneralList.stages;
	      collaborationSpacesVm.inReview = collaborationSpacesVm.status.reviewed;
	      collaborationSpacesVm.feedback = collaborationSpacesVm.status.feedbackReviewed;
	      collaborationSpacesVm.workplanTeacherId = collaborationSpacesVm.status.workplanTeacherId;
	      isPlanning(collaborationSpacesVm.status, collaborationSpacesVm.stages);
	
	      if (collaborationSpacesVm.feedback && !collaborationSpacesVm.planningFinish) {
	        getListSpacesCollaborationReject();
	      } else {
	        getListSpacesCollaboration();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (collaborationSpacesVm.feedback && !collaborationSpacesVm.planningFinish) {
	          getListSpacesCollaborationReject();
	        } else {
	          getListSpacesCollaboration();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getListSpacesCollaboration() {
	    WorkPlanSrv.getListSpacesCollaboration.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listSpaces);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getListSpacesCollaborationReject() {
	    WorkPlanSrv.getListSpacesCollaborationReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listSpaces);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function updateView() {
	    collaborationSpacesVm.viewLoaded = false;
	    $timeout(function () {
	      collaborationSpacesVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function loadData(data) {
	    collaborationSpacesVm.spaceList = data;
	  }
	
	  function confirmDeleteSpace(itemSpace) {
	    var spaceName = itemSpace.nameSpace;
	    var workplanTeacherActivityId = itemSpace.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.spaceName = spaceName;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.deleteSpace = function () {
	          WorkPlanSrv.disableActivityResearch.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeSpaceFromCaroussel(itemSpace);
	              showDeletedSuccessfully(ctrlModalVM.spaceName);
	              WorkPlanIndicatorSrv.setVariable(true);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(809),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(spaceName) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: spaceName,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeSpaceFromCaroussel(itemSpace) {
	    for (var i in collaborationSpacesVm.spaceList) {
	      if (collaborationSpacesVm.spaceList[i].workplanTeacherActivityId === itemSpace.workplanTeacherActivityId) {
	        collaborationSpacesVm.spaceList.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        collaborationSpacesVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        collaborationSpacesVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        collaborationSpacesVm.stages = dataReturn.data.stages;
	        collaborationSpacesVm.inReview = collaborationSpacesVm.status.reviewed;
	        collaborationSpacesVm.feedback = collaborationSpacesVm.status.feedbackReviewed;
	        collaborationSpacesVm.workplanTeacherId = collaborationSpacesVm.status.workplanTeacherId;
	        isPlanning(collaborationSpacesVm.status, collaborationSpacesVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    collaborationSpacesVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        collaborationSpacesVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == collaborationSpacesVm.active) {
	        collaborationSpacesVm.planningFinish = true;
	        if (collaborationSpacesVm.startDateReview < collaborationSpacesVm.currentDate || status.reviewedFinish == collaborationSpacesVm.active) {
	          collaborationSpacesVm.planningFinish = true;
	        } else if (status.reviewedReject == collaborationSpacesVm.active) {
	          collaborationSpacesVm.planningFinish = false;
	        }
	      } else {
	        collaborationSpacesVm.planningFinish = false;
	      }
	    } else {
	      collaborationSpacesVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = collaborationSpacesVm.planningFinish ? "disabled" : " ";
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.colaborationSpace,
	      workplanTeacherId: collaborationSpacesVm.workplanTeacherId
	    };
	    entries.title = 'Espacios de colaboración';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = CollaborationSpacesListCtrl;
	
	
	CollaborationSpacesListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', 'Requests', '$sessionStorage'];

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar el espacio <strong>\"{{ctrlModalVM.spaceName}}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.deleteSpace()>Sí, eliminar espacio</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateSpaceCtrl = function () {
	  function CreateSpaceCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig) {
	    _classCallCheck(this, CreateSpaceCtrl);
	
	    var createSpaceVm = this;
	    var texts = GlobalConfig.appTexts;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId
	
	      // VARIABLES
	    };createSpaceVm.isEditing = !!$stateParams.workplanTeacherActivityId;
	    createSpaceVm.rangeType = GlobalConfig.periods.rangeType;
	    createSpaceVm.workplanTeacherActivityId = null;
	    createSpaceVm.createOrEdit = 'Crear';
	    createSpaceVm.textCreateOrEdit = texts.saved;
	    createSpaceVm.createOrEditMV = texts.createDialog;
	    createSpaceVm.typePeriod = [];
	    createSpaceVm.periodsArray = [];
	    createSpaceVm.selectedTypePeriod = {};
	    createSpaceVm.isTouchedPeriods = false;
	    createSpaceVm.invalidCity = false;
	    createSpaceVm.startDate = null;
	    createSpaceVm.endDate = null;
	    createSpaceVm.minStartDate = moment().toDate();
	    createSpaceVm.minEndDate = new Date();
	    createSpaceVm.listEntity = [];
	    createSpaceVm.isSaveButtonDisabled = false;
	    createSpaceVm.isFeedback = currentUser.isFeedback;
	    createSpaceVm.dt_start = $cookies.get('wp_start');
	    createSpaceVm.dt_end = $cookies.get('wp_end');
	
	    // METHODS
	    createSpaceVm.hasError = hasError;
	    createSpaceVm.showErrorMessages = showErrorMessages;
	    createSpaceVm.addSpace = addSpace;
	    createSpaceVm.validateForm = validateForm;
	    createSpaceVm.validateCheklistPeriods = validateCheklistPeriods;
	    createSpaceVm.funSelectedPeriod = funSelectedPeriod;
	    createSpaceVm.startDateChange = startDateChange;
	    createSpaceVm.confirmSpaceAction = confirmSpaceAction;
	    // createSpaceVm.searchCountry = searchCountry
	    // createSpaceVm.changeCountry = changeCountry
	    createSpaceVm.searchCity = searchCity;
	    createSpaceVm.changeCity = changeCity;
	    createSpaceVm.searchEntity = searchEntity;
	    createSpaceVm.changeEntity = changeEntity;
	    createSpaceVm.addOrEditSpaces = addOrEditSpaces;
	    createSpaceVm.close = close;
	    createSpaceVm.cleanRangeType = cleanRangeType;
	    createSpaceVm.availableCities = [];
	    createSpaceVm.enableCities = function (country) {
	      createSpaceVm.countrySelected = false;
	      createSpaceVm.availableCities = createSpaceVm.cities.filter(function (city) {
	        return city.codeCountry === country;
	      });
	    };
	    createSpaceVm.countrySelected = true;
	
	    createSpaceVm.updateRangeType = function (val) {
	      createSpaceVm.rangeType = val;
	      createSpaceVm.periodsArray = [];
	      createSpaceVm.startDate = null;
	      createSpaceVm.endDate = null;
	    };
	    createSpaceVm.updateRangeData = function (val) {
	      createSpaceVm.periodsArray = val['periods'];
	      createSpaceVm.startDate = val['dates'][0];
	      createSpaceVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      WorkPlanSrv.getListSpacesCollaboration.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	          if (createSpaceVm.isEditing) {
	            createSpaceVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	            createSpaceVm.activityId = GlobalConfig.minorActivityId.space;
	            createSpaceVm.createOrEdit = 'Editar';
	            createSpaceVm.createOrEditMV = texts.editDialog;
	            createSpaceVm.textCreateOrEdit = texts.modified;
	            getDataSpaces();
	          }
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function loadData(data) {
	      createSpaceVm.listAmbit = data.listAmbitColaboration.items;
	      createSpaceVm.listTypePaticipate = data.listFormatColaboration.items;
	      createSpaceVm.listTypeComunity = data.listTypeColaboration.items;
	      createSpaceVm.listEntity = data.listsEntity.items;
	      createSpaceVm.cities = data.cities;
	      createSpaceVm.state = data.states;
	      createSpaceVm.countries = data.countries;
	      createSpaceVm.typePeriod = data.listPeriods.fulfillmentValue;
	    }
	
	    function hasError(input) {
	      if (input && input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input && (input.$dirty || input.$touched);
	    }
	
	    function addSpace(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createSpaceVm.validateCheklistPeriods();
	    }
	
	    function getDataSpaces() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createSpaceVm.workplanTeacherActivityId),
	        activityId: parseInt(createSpaceVm.activityId)
	      };
	      WorkPlanSrv.getSpacesCollaboration.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.project[0]);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(space) {
	      createSpaceVm.title = space.nameSpace;
	      createSpaceVm.description = space.description;
	      createSpaceVm.plannedHours = space.hoursPlanning;
	      createSpaceVm.typeComunity = space.typeSpaceId;
	      createSpaceVm.ambit = space.ambitColaborationId;
	      createSpaceVm.idEntity = space.entityId;
	      createSpaceVm.results = space.results;
	      createSpaceVm.link = space.link;
	      createSpaceVm.typeParticipate = space.typeParticipationId;
	      createSpaceVm.selectedItemEntity = space.entityName;
	      createSpaceVm.city = space.cityId;
	      createSpaceVm.selectedItemCity = null;
	
	      if (space.cityId && space.cityName) {
	        createSpaceVm.selectedItemCity = {
	          codeCity: space.cityId,
	          codeState: space.cityState,
	          nameCity: space.cityName
	        };
	      }
	
	      createSpaceVm.rangeType = space.timeRangeTypeId;
	      createSpaceVm.country = space.countryId;
	      var m = moment(space.startDate, 'YYYY-MM-DD');
	      createSpaceVm.dt_start = m.isValid() ? m.toDate() : null;
	
	      m = moment(space.endDate, 'YYYY-MM-DD');
	      createSpaceVm.dt_end = m.isValid() ? m.toDate() : null;
	
	      if (createSpaceVm.rangeType === GlobalConfig.periods.rangeType) {
	        createSpaceVm.periodsArray = space.periodId.split(',').map(function (id) {
	          //createSpaceVm.selectedTypePeriod[Number(id)] = true
	          return Number(id);
	        });
	      }
	
	      if (space.isNotification == 0) {
	        createSpaceVm.isNotification = false;
	      } else {
	        createSpaceVm.isNotification = true;
	      }
	
	      if (space.startDate) {
	        var startDateNew = moment(space.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createSpaceVm.minStartDate = moment(space.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createSpaceVm.isEditing = true;
	    }
	
	    function confirmSpaceAction() {
	      var header = {
	        createOrEdit: createSpaceVm.createOrEditMV,
	        textCreateOrEdit: createSpaceVm.textCreateOrEdit,
	        itemName: createSpaceVm.title,
	        nameModal: texts.modalTypeName.collaborationSpace,
	        modalType: texts.modalTypeId.collaborationSpace
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function validateCheklistPeriods() {
	      return Number(createSpaceVm.rangeType) === 1 ? createSpaceVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createSpaceVm.periodsArray.includes(period.periodId)) {
	          createSpaceVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createSpaceVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createSpaceVm.periodsArray.splice(index, 1);
	        }
	      }
	      createSpaceVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createSpaceVm.startDate);
	      createSpaceVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function searchEntity(searchText) {
	      var matcher = new RegExp(searchText, 'i');
	      var arr = [];
	      var attr = 'listItemName';
	      createSpaceVm.listEntity.forEach(function (searchText) {
	        if (searchText[attr] && searchText[attr].match(matcher)) {
	          arr.push(searchText);
	        }
	      });
	      console.log(arr);
	      return arr;
	    }
	
	    function searchCity(searchText) {
	      var matcher = new RegExp(searchText, 'i');
	      var arr = [];
	      var attr = 'nameCity';
	      createSpaceVm.availableCities.forEach(function (searchText) {
	        if (searchText[attr] && searchText[attr].match(matcher)) {
	          if (searchText[attr] !== 'NO REGISTRA') arr.push(searchText);
	        }
	      });
	      return arr;
	    }
	
	    function changeCity(city) {
	      if (city) {
	        createSpaceVm.city = city.codeCity;
	        createSpaceVm.nameCity = city.nameCity;
	        for (var i = createSpaceVm.state.length - 1; i >= 0; i--) {
	          if (createSpaceVm.state[i].codeState == city.codeState) {
	            createSpaceVm.country = createSpaceVm.state[i].codeCountry;
	          }
	        }
	        createSpaceVm.invalidCity = false;
	      } else {
	        createSpaceVm.city = null;
	        createSpaceVm.nameCity = '';
	        createSpaceVm.country = null;
	        createSpaceVm.invalidCity = true;
	      }
	    }
	
	    function changeEntity(entity) {
	      createSpaceVm.idEntity = entity.idListItem;
	      createSpaceVm.nameEntity = entity.listItemName;
	    }
	
	    function createJson(origin) {
	      var space = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        activityId: GlobalConfig.minorActivityId.space,
	        name: createSpaceVm.title,
	        description: createSpaceVm.description,
	        hoursPlanning: createSpaceVm.plannedHours,
	        typeColaborationId: createSpaceVm.typeComunity,
	        ambitColaborationParticipationId: createSpaceVm.typeParticipate,
	        entityId: createSpaceVm.idEntity,
	        results: createSpaceVm.results,
	        link: createSpaceVm.link,
	        ambitColaborationId: createSpaceVm.ambit,
	        entityName: createSpaceVm.nameEntity,
	        cityId: parseInt(createSpaceVm.city),
	        timeRangeTypeId: createSpaceVm.rangeType,
	        origin: origin,
	        cityName: createSpaceVm.nameCity,
	        isNotification: createSpaceVm.isNotification,
	        isFeedbackActivity: createSpaceVm.isFeedback
	      };
	      if (createSpaceVm.isEditing) {
	        space.workplanTeacherActivityId = parseInt(createSpaceVm.workplanTeacherActivityId);
	      }
	
	      if (parseInt(createSpaceVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createSpaceVm.periodsArray) {
	          var temp = {
	            periodId: createSpaceVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        space.periods = arrayPeriod;
	      } else {
	        space.startDate = createSpaceVm.startDate;
	        space.endDate = createSpaceVm.endDate;
	      }
	      addOrEditSpaces(space);
	    }
	
	    function addOrEditSpaces(space) {
	      createSpaceVm.isSaveButtonDisabled = true;
	
	      WorkPlanSrv.addSpaceCollaboration.save(space).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          confirmSpaceAction();
	        } else {
	          createSpaceVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        createSpaceVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createSpaceVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createSpaceVm.startDate = null;
	        createSpaceVm.endDate = null;
	      } else {
	        createSpaceVm.selectedTypePeriod = [];
	        createSpaceVm.periodsArray = [];
	      }
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateSpaceCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	    }
	  }]);
	
	  return CreateSpaceCtrl;
	}();
	
	exports.default = CreateSpaceCtrl;
	
	
	CreateSpaceCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig'];

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateTrainingResearchCtrl = function () {
	  function CreateTrainingResearchCtrl($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig) {
	    _classCallCheck(this, CreateTrainingResearchCtrl);
	
	    var createTrainingVm = this;
	    var texts = GlobalConfig.appTexts;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId
	
	      // VARIABLES
	    };createTrainingVm.isEditing = $stateParams.workplanTeacherActivityId ? true : false;
	    createTrainingVm.rangeType = GlobalConfig.periods.rangeType;
	    createTrainingVm.workplanTeacherActivityId = null;
	    createTrainingVm.createOrEdit = 'Crear';
	    createTrainingVm.textCreateOrEdit = texts.saved;
	    createTrainingVm.createOrEditMV = texts.createDialog;
	    createTrainingVm.typePeriod = [];
	    createTrainingVm.periodsArray = [];
	    createTrainingVm.selectedTypePeriod = {};
	    createTrainingVm.isTouchedPeriods = false;
	    createTrainingVm.startDate = null;
	    createTrainingVm.endDate = null;
	    createTrainingVm.notActive = GlobalConfig.generals.notActive;
	    createTrainingVm.notification = createTrainingVm.notActive;
	    createTrainingVm.minStartDate = moment().toDate();
	    createTrainingVm.minEndDate = new Date();
	    createTrainingVm.studentType = [];
	    createTrainingVm.studentNumber = [];
	    createTrainingVm.isSaveButtonDisabled = false;
	    createTrainingVm.amountOfStudentsRequired = false;
	    createTrainingVm.isFeedback = currentUser.isFeedback;
	    createTrainingVm.dt_start = $cookies.get('wp_start');
	    createTrainingVm.dt_end = $cookies.get('wp_end');
	
	    // METHODS
	    createTrainingVm.hasError = hasError;
	    createTrainingVm.showErrorMessages = showErrorMessages;
	    createTrainingVm.addTraining = addTraining;
	    createTrainingVm.validateForm = validateForm;
	    createTrainingVm.validateCheklistPeriods = validateCheklistPeriods;
	    createTrainingVm.funSelectedPeriod = funSelectedPeriod;
	    createTrainingVm.startDateChange = startDateChange;
	    createTrainingVm.confirmTrainingAction = confirmTrainingAction;
	    createTrainingVm.addOrEditTraining = addOrEditTraining;
	    createTrainingVm.close = close;
	    createTrainingVm.cleanRangeType = cleanRangeType;
	    createTrainingVm.onActivityTypeChanged = onActivityTypeChanged;
	    createTrainingVm.checkStudents = function () {
	      var inSeeder = GlobalConfig.minorActivityId.trainningResearchType === createTrainingVm.spaceType;
	      if (createTrainingVm.preg > 0 || createTrainingVm.postg > 0 || createTrainingVm.doct > 0) {
	        createTrainingVm.amountOfStudentsRequired = false;
	      }
	      if (inSeeder && !createTrainingVm.preg && !createTrainingVm.postg && !createTrainingVm.doct) {
	        createTrainingVm.amountOfStudentsRequired = true;
	      }
	    };
	
	    createTrainingVm.updateRangeType = function (val) {
	      createTrainingVm.rangeType = val;
	      createTrainingVm.periodsArray = [];
	      createTrainingVm.startDate = null;
	      createTrainingVm.endDate = null;
	    };
	    createTrainingVm.updateRangeData = function (val) {
	      createTrainingVm.periodsArray = val['periods'];
	      createTrainingVm.startDate = val['dates'][0];
	      createTrainingVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createTrainingVm.isEditing) {
	        createTrainingVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createTrainingVm.activityId = GlobalConfig.minorActivityId.training;
	        createTrainingVm.createOrEdit = 'Editar';
	        createTrainingVm.createOrEditMV = texts.editDialog;
	        createTrainingVm.textCreateOrEdit = texts.modified;
	        getDataTrainings();
	      }
	
	      WorkPlanSrv.getListResearchTraining.getList(post).$promise.then(function (dataReturn) {
	        return dataReturn.status ? loadData(dataReturn) : console.log('Comunications problem');
	      });
	    }
	
	    function loadData(training) {
	      createTrainingVm.listSpaceType = training.listSpacesTraining.items;
	      createTrainingVm.typePeriod = training.listPeriods.fulfillmentValue;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function addTraining(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createTrainingVm.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return createTrainingVm.rangeType == 1 ? createTrainingVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createTrainingVm.periodsArray.includes(period.periodId)) {
	          createTrainingVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createTrainingVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createTrainingVm.periodsArray.splice(index, 1);
	        }
	      }
	      createTrainingVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createTrainingVm.startDate);
	      createTrainingVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function createJson(origin) {
	      var training = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        activityId: GlobalConfig.minorActivityId.training,
	        name: createTrainingVm.title,
	        description: createTrainingVm.description,
	        results: createTrainingVm.results,
	        hoursPlanning: createTrainingVm.plannedHours,
	        link: createTrainingVm.link,
	        isNotification: createTrainingVm.notification,
	        spacesTrainingId: createTrainingVm.spaceType,
	        timeRangeTypeId: createTrainingVm.rangeType,
	        origin: origin,
	        isFeedbackActivity: createTrainingVm.isFeedback
	      };
	
	      if (createTrainingVm.isEditing) {
	        training.workplanTeacherActivityId = createTrainingVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createTrainingVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createTrainingVm.periodsArray) {
	          var temp = {
	            periodId: createTrainingVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        training.periods = arrayPeriod;
	      } else {
	        training.startDate = createTrainingVm.startDate;
	        training.endDate = createTrainingVm.endDate;
	      }
	
	      var arrayStudents = [];
	
	      if (createTrainingVm.preg) {
	        var temp = {
	          studentTypeId: GlobalConfig.trainingResearch.pregrado,
	          number: createTrainingVm.preg
	        };
	        arrayStudents.push(temp);
	      }
	
	      if (createTrainingVm.postg) {
	        var temp = {
	          studentTypeId: GlobalConfig.trainingResearch.postgrado,
	          number: createTrainingVm.postg
	        };
	        arrayStudents.push(temp);
	      }
	
	      if (createTrainingVm.doct) {
	        var temp = {
	          studentTypeId: GlobalConfig.trainingResearch.doctoral,
	          number: createTrainingVm.doct
	        };
	        arrayStudents.push(temp);
	      }
	
	      if (arrayStudents.length > 0) {
	        training.students = arrayStudents;
	      } else {
	        training.students = null;
	      }
	      addOrEditTraining(training);
	    }
	
	    function addOrEditTraining(training) {
	      createTrainingVm.isSaveButtonDisabled = true;
	      WorkPlanSrv.addResearchTraining.save(training).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          confirmTrainingAction();
	        } else {
	          createTrainingVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        createTrainingVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function confirmTrainingAction(itemtraining) {
	      var header = {
	        createOrEdit: createTrainingVm.createOrEditMV,
	        textCreateOrEdit: createTrainingVm.textCreateOrEdit,
	        itemName: createTrainingVm.title,
	        nameModal: texts.modalTypeName.trainingResearch,
	        modalType: texts.modalTypeId.trainingResearch
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getDataTrainings() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createTrainingVm.workplanTeacherActivityId),
	        activityId: parseInt(createTrainingVm.activityId)
	      };
	      WorkPlanSrv.getResearchTrainingByActivityId.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(training) {
	      createTrainingVm.title = training.nameResearch;
	      createTrainingVm.description = training.description;
	      createTrainingVm.results = training.resultsExpected;
	      createTrainingVm.plannedHours = training.hoursPlanning;
	      createTrainingVm.spaceType = training.itemTypeSpaceId;
	      createTrainingVm.link = training.link;
	      createTrainingVm.rangeType = training.timeRangeTypeId;
	
	      var m = moment(training.startDate, 'YYYY-MM-DD');
	      createTrainingVm.dt_start = m.isValid() ? m.toDate() : null;
	
	      m = moment(training.endDate, 'YYYY-MM-DD');
	      createTrainingVm.dt_end = m.isValid() ? m.toDate() : null;
	
	      if (training.isNotification == 1) {
	        createTrainingVm.notification = true;
	      }
	
	      if (createTrainingVm.rangeType == GlobalConfig.periods.rangeType) {
	        var splits = training.periodId.split(',');
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          createTrainingVm.periodsArray.push(parseInt(valor));
	          createTrainingVm.selectedTypePeriod[valor] = true;
	        }
	      }
	
	      if (training.studentTypeId) {
	        var splits = training.studentTypeId.split(',');
	        var aux = training.studentNum.split(',');
	        // var axu2 = aux
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          createTrainingVm.studentType.push(parseInt(valor));
	        }
	        for (var i = 0; i < aux.length; i++) {
	          var valor2 = aux[i];
	          createTrainingVm.studentNumber.push(parseInt(valor2));
	        }
	      }
	
	      for (var i = createTrainingVm.studentType.length - 1; i >= 0; i--) {
	        if (createTrainingVm.studentType[i] == GlobalConfig.trainingResearch.pregrado) {
	          createTrainingVm.preg = createTrainingVm.studentNumber[i];
	        } else if (createTrainingVm.studentType[i] == GlobalConfig.trainingResearch.postgrado) {
	          createTrainingVm.postg = createTrainingVm.studentNumber[i];
	        } else if (createTrainingVm.studentType[i] == GlobalConfig.trainingResearch.doctoral) {
	          createTrainingVm.doct = createTrainingVm.studentNumber[i];
	        }
	      }
	
	      if (training.startDate) {
	        var startDateNew = moment(training.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createTrainingVm.minStartDate = moment(training.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createTrainingVm.isEditing = true;
	      createTrainingVm.checkStudents();
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createTrainingVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createTrainingVm.startDate = null;
	        createTrainingVm.endDate = null;
	      } else {
	        createTrainingVm.periodsArray = [];
	        createTrainingVm.selectedTypePeriod = null;
	      }
	    }
	
	    function onActivityTypeChanged(type) {
	      if (type === GlobalConfig.minorActivityId.trainningResearchType) {
	        createTrainingVm.amountOfStudentsRequired = true;
	      } else {
	        createTrainingVm.amountOfStudentsRequired = false;
	      }
	    }
	  } // FIN DEL CONSTRUCTOR
	
	
	  _createClass(CreateTrainingResearchCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateTrainingResearchCtrl;
	}();
	
	exports.default = CreateTrainingResearchCtrl;
	
	CreateTrainingResearchCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig'];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TrainingResearchListCtrl = function TrainingResearchListCtrl($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, TrainingResearchListCtrl);
	
	  var trainingResearchVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	    //Variables
	  };trainingResearchVm.viewLoaded = false;
	  trainingResearchVm.active = GlobalConfig.generals.active;
	  trainingResearchVm.notActive = GlobalConfig.generals.notActive;
	  trainingResearchVm.planningFinish = true;
	  $scope.classPlanning = '';
	  trainingResearchVm.feedback = 0;
	  trainingResearchVm.trainings = [];
	  trainingResearchVm.imgEmpty = __webpack_require__(445);
	
	  //Methods
	  trainingResearchVm.updateView = updateView;
	  trainingResearchVm.gradRoleClass = 'grad-5';
	  trainingResearchVm.confirmDeleteTraining = confirmDeleteTraining;
	  trainingResearchVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  trainingResearchVm.bitacora = bitacora;
	  trainingResearchVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  trainingResearchVm.$sessionStorage = $sessionStorage;
	
	  trainingResearchVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  active();
	
	  function active() {
	    if (trainingResearchVm.workPlanGeneralList != undefined) {
	      trainingResearchVm.status = trainingResearchVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      trainingResearchVm.stages = trainingResearchVm.workPlanGeneralList.stages;
	      trainingResearchVm.inReview = trainingResearchVm.status.reviewed;
	      trainingResearchVm.feedback = trainingResearchVm.status.feedbackReviewed;
	      trainingResearchVm.workplanTeacherId = trainingResearchVm.status.workplanTeacherId;
	      isPlanning(trainingResearchVm.status, trainingResearchVm.stages);
	
	      if (trainingResearchVm.feedback && !trainingResearchVm.planningFinish) {
	        getListResearchTrainingReject();
	      } else {
	        getListResearchTraining();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (trainingResearchVm.feedback && !trainingResearchVm.planningFinish) {
	          getListResearchTrainingReject();
	        } else {
	          getListResearchTraining();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getListResearchTraining() {
	    WorkPlanSrv.getListResearchTraining.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        trainingResearchVm.trainings = dataReturn.listResearchTraining;
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getListResearchTrainingReject() {
	    WorkPlanSrv.getListResearchTrainingReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        trainingResearchVm.trainings = dataReturn.listResearchTraining;
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function updateView() {
	    trainingResearchVm.viewLoaded = false;
	    $timeout(function () {
	      trainingResearchVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function confirmDeleteTraining(item) {
	    var trainingName = item.nameResearch;
	    var workplanTeacherActivityId = item.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.trainingName = trainingName;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.delete = function () {
	          WorkPlanSrv.disableActivityResearch.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeSpaceFromCaroussel(item);
	              showDeletedSuccessfully(ctrlModalVM.trainingName);
	              WorkPlanIndicatorSrv.setVariable(true);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(813),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(trainingName) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: trainingName,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeSpaceFromCaroussel(item) {
	    for (var i in trainingResearchVm.trainings) {
	      if (trainingResearchVm.trainings[i].workplanTeacherActivityId === item.workplanTeacherActivityId) {
	        trainingResearchVm.trainings.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        trainingResearchVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        trainingResearchVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        trainingResearchVm.stages = dataReturn.data.stages;
	        trainingResearchVm.inReview = trainingResearchVm.status.reviewed;
	        trainingResearchVm.feedback = trainingResearchVm.status.feedbackReviewed;
	        trainingResearchVm.workplanTeacherId = trainingResearchVm.status.workplanTeacherId;
	        isPlanning(trainingResearchVm.status, trainingResearchVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    trainingResearchVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        trainingResearchVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == trainingResearchVm.active) {
	        trainingResearchVm.planningFinish = true;
	        if (trainingResearchVm.startDateReview < trainingResearchVm.currentDate || status.reviewedFinish == trainingResearchVm.active) {
	          trainingResearchVm.planningFinish = true;
	        } else if (status.reviewedReject == trainingResearchVm.active) {
	          trainingResearchVm.planningFinish = false;
	        }
	      } else {
	        trainingResearchVm.planningFinish = false;
	      }
	    } else {
	      trainingResearchVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = trainingResearchVm.planningFinish ? "disabled" : " ";
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.investigation,
	      workplanTeacherId: trainingResearchVm.workplanTeacherId
	    };
	    entries.title = 'Formación en investigación';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = TrainingResearchListCtrl;
	
	TrainingResearchListCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar el espacio de investigación <strong>\"{{ ctrlModalVM.trainingName }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.delete()>Sí, eliminar formación en investigación</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateResultsTransferCtrl = function () {
	  function CreateResultsTransferCtrl($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig) {
	    _classCallCheck(this, CreateResultsTransferCtrl);
	
	    var createTransferVm = this;
	    var texts = GlobalConfig.appTexts;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId
	
	      // VARIABLES
	    };createTransferVm.isEditing = Boolean($stateParams.workplanTeacherActivityId);
	    createTransferVm.rangeType = GlobalConfig.periods.rangeType;
	    createTransferVm.workplanTeacherActivityId = null;
	    createTransferVm.createOrEdit = 'Crear';
	    createTransferVm.textCreateOrEdit = texts.saved;
	    createTransferVm.createOrEditMV = texts.createDialog;
	    createTransferVm.typePeriod = [];
	    createTransferVm.periodsArray = [];
	    createTransferVm.notification = GlobalConfig.generals.notActive;
	    createTransferVm.selectedTypePeriod = {};
	    createTransferVm.isTouchedPeriods = false;
	    createTransferVm.startDate = null;
	    createTransferVm.endDate = null;
	    createTransferVm.minStartDate = moment().toDate();
	    createTransferVm.minEndDate = new Date();
	    createTransferVm.buttonDisabled = false;
	    createTransferVm.isFeedback = currentUser.isFeedback;
	    createTransferVm.dt_start = $cookies.get('wp_start');
	    createTransferVm.dt_end = $cookies.get('wp_end');
	
	    // METHODS
	    createTransferVm.hasError = hasError;
	    createTransferVm.showErrorMessages = showErrorMessages;
	    createTransferVm.addTransfer = addTransfer;
	    createTransferVm.validateForm = validateForm;
	    createTransferVm.validateCheklistPeriods = validateCheklistPeriods;
	    createTransferVm.funSelectedPeriod = funSelectedPeriod;
	    createTransferVm.startDateChange = startDateChange;
	    createTransferVm.confirmTransferAction = confirmTransferAction;
	    createTransferVm.addOrEditTransfer = addOrEditTransfer;
	    createTransferVm.close = close;
	    createTransferVm.cleanRangeType = cleanRangeType;
	
	    createTransferVm.updateRangeType = function (val) {
	      createTransferVm.rangeType = val;
	      createTransferVm.periodsArray = [];
	      createTransferVm.startDate = null;
	      createTransferVm.endDate = null;
	    };
	    createTransferVm.updateRangeData = function (val) {
	      createTransferVm.periodsArray = val['periods'];
	      createTransferVm.startDate = val['dates'][0];
	      createTransferVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createTransferVm.isEditing) {
	        createTransferVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createTransferVm.activityId = GlobalConfig.minorActivityId.transfer;
	        createTransferVm.createOrEdit = 'Editar';
	        createTransferVm.createOrEditMV = texts.editDialog;
	        createTransferVm.textCreateOrEdit = texts.modified;
	        getDataTransfers();
	      }
	
	      WorkPlanSrv.getDataFormTransferResults.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(dataReturn);
	      });
	    }
	
	    function loadData(data) {
	      createTransferVm.listResultsType = data.listTransferResults.items;
	      createTransferVm.typePeriod = data.listPeriods.fulfillmentValue;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function addTransfer(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createTransferVm.validateCheklistPeriods();
	    }
	
	    function validateCheklistPeriods() {
	      return createTransferVm.rangeType == 1 ? createTransferVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createTransferVm.periodsArray.includes(period.periodId)) {
	          createTransferVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createTransferVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createTransferVm.periodsArray.splice(index, 1);
	        }
	      }
	      createTransferVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createTransferVm.startDate);
	      createTransferVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function createJson(origin) {
	      var transfer = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        activityId: GlobalConfig.minorActivityId.transfer,
	        name: createTransferVm.title,
	        description: createTransferVm.description,
	        hoursPlanning: createTransferVm.plannedHours,
	        isNotification: createTransferVm.notification,
	        itemTypeResult: createTransferVm.resultsType,
	        timeRangeTypeId: createTransferVm.rangeType,
	        origin: origin,
	        isFeedbackActivity: createTransferVm.isFeedback
	      };
	
	      if (createTransferVm.isEditing) {
	        transfer.workplanTeacherActivityId = createTransferVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createTransferVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createTransferVm.periodsArray) {
	          var temp = {
	            periodId: createTransferVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        transfer.periods = arrayPeriod;
	      } else {
	        transfer.startDate = createTransferVm.startDate;
	        transfer.endDate = createTransferVm.endDate;
	      }
	      addOrEditTransfer(transfer);
	    }
	
	    function addOrEditTransfer(transfer) {
	      createTransferVm.buttonDisabled = true;
	      WorkPlanSrv.addTransferResult.save(transfer).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          confirmTransferAction();
	        } else {
	          createTransferVm.buttonDisabled = false;
	          console.log('Communication error');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function confirmTransferAction() {
	      var header = {
	        createOrEdit: createTransferVm.createOrEditMV,
	        textCreateOrEdit: createTransferVm.textCreateOrEdit,
	        itemName: createTransferVm.title,
	        nameModal: texts.modalTypeName.resultsTransfer,
	        modalType: texts.modalTypeId.resultsTransfer
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getDataTransfers() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createTransferVm.workplanTeacherActivityId),
	        activityId: parseInt(createTransferVm.activityId)
	      };
	      WorkPlanSrv.getTransferResultsByActivityId.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(transfer) {
	      createTransferVm.title = transfer.name;
	      createTransferVm.description = transfer.description;
	      createTransferVm.plannedHours = transfer.hoursPlanned;
	      createTransferVm.resultsType = transfer.itemResultsId;
	      createTransferVm.rangeType = transfer.timeRangeTypeId;
	
	      var m = moment(transfer.startDate, 'YYYY-MM-DD');
	      createTransferVm.dt_start = m.isValid() ? m.toDate() : null;
	
	      m = moment(transfer.endDate, 'YYYY-MM-DD');
	      createTransferVm.dt_end = m.isValid() ? m.toDate() : null;
	
	      createTransferVm.periodsArray = [];
	      createTransferVm.selectedTypePeriod = {};
	      if (transfer.isNotification == 1) {
	        createTransferVm.notification = true;
	      }
	
	      if (createTransferVm.rangeType == GlobalConfig.periods.rangeType) {
	        var splits = transfer.periodId.split(',');
	        for (var i = 0; i < splits.length; i++) {
	          var valor = splits[i];
	          createTransferVm.periodsArray.push(parseInt(valor));
	          createTransferVm.selectedTypePeriod[valor] = true;
	        }
	      }
	
	      if (transfer.startDate) {
	        var startDateNew = moment(transfer.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createTransferVm.minStartDate = moment(transfer.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createTransferVm.isEditing = true;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createTransferVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createTransferVm.startDate = null;
	        createTransferVm.endDate = null;
	      } else {
	        createTransferVm.periodsArray = [];
	        createTransferVm.selectedTypePeriod = null;
	      }
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	  } // FIN DEL CONSTRUCTOR
	
	
	  _createClass(CreateResultsTransferCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateResultsTransferCtrl;
	}();
	
	exports.default = CreateResultsTransferCtrl;
	
	CreateResultsTransferCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig'];

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResultsTransferCtrlList = function ResultsTransferCtrlList($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, ResultsTransferCtrlList);
	
	  var resultsTransferListVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	    //Variables
	  };resultsTransferListVm.viewLoaded = false;
	  resultsTransferListVm.active = GlobalConfig.generals.active;
	  resultsTransferListVm.notActive = GlobalConfig.generals.notActive;
	  resultsTransferListVm.planningFinish = true;
	  resultsTransferListVm.transfers = [];
	  $scope.classPlanning = '';
	  resultsTransferListVm.feedback = 0;
	  resultsTransferListVm.imgEmpty = __webpack_require__(445);
	
	  //Methods
	  resultsTransferListVm.updateView = updateView;
	  resultsTransferListVm.gradRoleClass = 'grad-4';
	  resultsTransferListVm.confirmDeleteTransfer = confirmDeleteTransfer;
	  resultsTransferListVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  resultsTransferListVm.bitacora = bitacora;
	  resultsTransferListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  resultsTransferListVm.$sessionStorage = $sessionStorage;
	
	  resultsTransferListVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 3
	    }
	  }];
	
	  active();
	
	  function active() {
	    if (resultsTransferListVm.workPlanGeneralList != undefined) {
	      resultsTransferListVm.status = resultsTransferListVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      resultsTransferListVm.stages = resultsTransferListVm.workPlanGeneralList.stages;
	      resultsTransferListVm.inReview = resultsTransferListVm.status.reviewed;
	      resultsTransferListVm.feedback = resultsTransferListVm.status.feedbackReviewed;
	      resultsTransferListVm.workplanTeacherId = resultsTransferListVm.status.workplanTeacherId;
	      isPlanning(resultsTransferListVm.status, resultsTransferListVm.stages);
	
	      if (resultsTransferListVm.feedback && !resultsTransferListVm.planningFinish) {
	        getDataFormTransferResultsReject();
	      } else {
	        getDataFormTransferResults();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (resultsTransferListVm.feedback && !resultsTransferListVm.planningFinish) {
	          getDataFormTransferResultsReject();
	        } else {
	          getDataFormTransferResults();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getDataFormTransferResults() {
	    WorkPlanSrv.getDataFormTransferResults.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        resultsTransferListVm.transfers = dataReturn.listActivitiesResults;
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function getDataFormTransferResultsReject() {
	    WorkPlanSrv.getDataFormTransferResultsReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        resultsTransferListVm.transfers = dataReturn.listActivitiesResults;
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function updateView() {
	    resultsTransferListVm.viewLoaded = false;
	    $timeout(function () {
	      resultsTransferListVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        resultsTransferListVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        resultsTransferListVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        resultsTransferListVm.stages = dataReturn.data.stages;
	        resultsTransferListVm.inReview = resultsTransferListVm.status.reviewed;
	        resultsTransferListVm.feedback = resultsTransferListVm.status.feedbackReviewed;
	        resultsTransferListVm.workplanTeacherId = resultsTransferListVm.status.workplanTeacherId;
	        isPlanning(resultsTransferListVm.status, resultsTransferListVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    resultsTransferListVm.currentDate = moment(new Date()).format('DD/MM/YYYY');
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        resultsTransferListVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == resultsTransferListVm.active) {
	        resultsTransferListVm.planningFinish = true;
	        if (resultsTransferListVm.startDateReview < resultsTransferListVm.currentDate || status.reviewedFinish == resultsTransferListVm.active) {
	          resultsTransferListVm.planningFinish = true;
	        } else if (status.reviewedReject == resultsTransferListVm.active) {
	          resultsTransferListVm.planningFinish = false;
	        }
	      } else {
	        resultsTransferListVm.planningFinish = false;
	      }
	    } else {
	      resultsTransferListVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = resultsTransferListVm.planningFinish ? "disabled" : " ";
	  }
	
	  function confirmDeleteTransfer(item) {
	    var transferName = item.name;
	    var workplanTeacherActivityId = item.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.transferName = transferName;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.delete = function () {
	          WorkPlanSrv.disableActivityResearch.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              removeFromCaroussel(item);
	              showDeletedSuccessfully(ctrlModalVM.transferName);
	              WorkPlanIndicatorSrv.setVariable(true);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(816),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(transferName) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: transferName,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeFromCaroussel(item) {
	    for (var i in resultsTransferListVm.transfers) {
	      if (resultsTransferListVm.transfers[i].workplanTeacherActivityId === item.workplanTeacherActivityId) {
	        resultsTransferListVm.transfers.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.resultsTransfer,
	      workplanTeacherId: resultsTransferListVm.workplanTeacherId
	    };
	    entries.title = 'Transferencia de resultados';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = ResultsTransferCtrlList;
	
	ResultsTransferCtrlList.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar la transferencia de resultados <strong>\"{{ ctrlModalVM.transferName }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.delete()>Sí, eliminar transferencia de resultados</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShortCoursesListCtrl = function ShortCoursesListCtrl($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, Requests, $sessionStorage) {
	  _classCallCheck(this, ShortCoursesListCtrl);
	
	  var shortCoursesVm = this;
	  var currentUser = JSON.parse($cookies.get('currentUser'));
	
	  shortCoursesVm.gradRoleClass = 'grad-5';
	  shortCoursesVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList;
	  shortCoursesVm.$sessionStorage = $sessionStorage;
	
	  shortCoursesVm.carouselResponsiveBreakpoints = [{
	    breakpoint: 1360,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 1366,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 1920,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  }, {
	    breakpoint: 3000,
	    settings: {
	      slidesToShow: 4,
	      slidesToScroll: 3
	    }
	  }];
	
	  //VARIABLES
	  shortCoursesVm.listShortCourses = [];
	  shortCoursesVm.viewLoaded = false;
	  shortCoursesVm.feedback = 0;
	  shortCoursesVm.planningFinish = true;
	  $scope.classPlanning = '';
	  var post = {
	    workplanId: currentUser.workplanId,
	    teacherId: currentUser.teacherId
	  };
	  shortCoursesVm.imgEmpty = __webpack_require__(445);
	
	  //METHODS
	  shortCoursesVm.updateView = updateView;
	  shortCoursesVm.loadData = loadData;
	  shortCoursesVm.confirmDeleteShortCourse = confirmDeleteShortCourse;
	  shortCoursesVm.getGeneralsWorkplan = getGeneralsWorkplan;
	  shortCoursesVm.active = GlobalConfig.generals.active;
	  shortCoursesVm.notActive = GlobalConfig.generals.notActive;
	  shortCoursesVm.bitacora = bitacora;
	
	  activate();
	
	  function activate() {
	    if (shortCoursesVm.workPlanGeneralList != undefined) {
	      shortCoursesVm.status = shortCoursesVm.workPlanGeneralList.wokplanTeacherStatus[0];
	      shortCoursesVm.stages = shortCoursesVm.workPlanGeneralList.stages;
	      shortCoursesVm.feedback = shortCoursesVm.status.feedbackReviewed;
	      shortCoursesVm.workplanTeacherId = shortCoursesVm.status.workplanTeacherId;
	      isPlanning(shortCoursesVm.status, shortCoursesVm.stages);
	
	      if (shortCoursesVm.feedback && !shortCoursesVm.planningFinish) {
	        getDataFormShortCoursesReject();
	      } else {
	        getDataFormShortCourses();
	      }
	    } else {
	      getGeneralsWorkplan(post).then(function (promise) {
	        if (shortCoursesVm.feedback && !shortCoursesVm.planningFinish) {
	          getDataFormShortCoursesReject();
	        } else {
	          getDataFormShortCourses();
	        }
	      });
	    }
	
	    updateView();
	  }
	
	  function getDataFormShortCourses() {
	    WorkPlanSrv.getDataFormShortCourses.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listShortCourses);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(listphd);
	    });
	  }
	
	  function getDataFormShortCoursesReject() {
	    WorkPlanSrv.getDataFormShortCoursesReject.getList(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        loadData(dataReturn.listShortCourses);
	      } else {
	        console.log("Comunications problem");
	      }
	    }, function (data) {
	      console.log(listphd);
	    });
	  }
	
	  function loadData(data) {
	    shortCoursesVm.listShortCourses = data;
	  }
	
	  function updateView() {
	    shortCoursesVm.viewLoaded = false;
	    $timeout(function () {
	      shortCoursesVm.viewLoaded = true;
	    }, 1);
	  }
	
	  function confirmDeleteShortCourse(course) {
	    var name = course.name;
	    var workplanTeacherActivityId = course.workplanTeacherActivityId;
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
	        var ctrlModalVM = this;
	        ctrlModalVM.name = name;
	        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId;
	        ctrlModalVM.close = function () {
	          $mdDialog.hide();
	        };
	        ctrlModalVM.delete = function () {
	          WorkPlanSrv.disableActivityResearch.delete({ workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status) {
	              showDeletedSuccessfully(ctrlModalVM.name);
	              removeFromCaroussel(course);
	              // activate()
	              WorkPlanIndicatorSrv.setVariable(true);
	              $mdDialog.hide();
	            } else {
	              console.log('Comunications problem with the server');
	            }
	          }, function (data) {});
	        };
	      }],
	      controllerAs: 'ctrlModalVM',
	      template: __webpack_require__(818),
	      clickOutsideToClose: false
	    });
	  }
	
	  function showDeletedSuccessfully(name) {
	    var texts = GlobalConfig.appTexts;
	    var header = {
	      createOrEdit: texts.deleteDialog,
	      textCreateOrEdit: texts.deleted,
	      itemName: name,
	      nameModal: texts.modalTypeName.deleted,
	      modalType: texts.modalTypeId.default
	    };
	    WorkPlanModalSrv.setVariableSuccessDialog(header);
	    WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	  }
	
	  function removeFromCaroussel(course) {
	    for (var i in shortCoursesVm.listShortCourses) {
	      if (shortCoursesVm.listShortCourses[i].workplanTeacherActivityId === course.workplanTeacherActivityId) {
	        shortCoursesVm.listShortCourses.splice(i, 1);
	        updateView();
	        break;
	      }
	    }
	  }
	
	  function getGeneralsWorkplan(post) {
	    return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        shortCoursesVm.$sessionStorage.workPlanGeneralList = dataReturn.data;
	        shortCoursesVm.status = dataReturn.data.wokplanTeacherStatus[0];
	        shortCoursesVm.stages = dataReturn.data.stages;
	        shortCoursesVm.feedback = shortCoursesVm.status.feedbackReviewed;
	        shortCoursesVm.workplanTeacherId = shortCoursesVm.status.workplanTeacherId;
	        isPlanning(shortCoursesVm.status, shortCoursesVm.stages);
	      } else {
	        console.log("Comunications problem with the server");
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	
	  function isPlanning(status, stages) {
	    shortCoursesVm.currentDate = moment(new Date()).format("DD/MM/YYYY");
	    for (var i = stages.length - 1; i >= 0; i--) {
	      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
	        shortCoursesVm.startDateStage = stages[i].startDate;
	      }
	    }
	
	    if (status.workplanActive) {
	      if (status.planningFinish == shortCoursesVm.active) {
	        shortCoursesVm.planningFinish = true;
	        if (shortCoursesVm.startDateReview < shortCoursesVm.currentDate || status.reviewedFinish == shortCoursesVm.active) {
	          shortCoursesVm.planningFinish = true;
	        } else if (status.reviewedReject == shortCoursesVm.active) {
	          shortCoursesVm.planningFinish = false;
	        }
	      } else {
	        shortCoursesVm.planningFinish = false;
	      }
	    } else {
	      shortCoursesVm.planningFinish = true;
	    }
	
	    $scope.classPlanning = shortCoursesVm.planningFinish ? "disabled" : " ";
	  }
	
	  function bitacora(ev) {
	    var entries = {};
	
	    entries.params = {
	      activityTypeId: GlobalConfig.activityTypeId.shortCourses,
	      workplanTeacherId: shortCoursesVm.workplanTeacherId
	    };
	    entries.title = 'Consultoría y asesoría';
	    // Entries(this.entries);
	    entries.data = undefined;
	    $mdDialog.show({
	      controller: 'bitacoraModalCtrl',
	      controllerAs: 'bit',
	      template: __webpack_require__(453),
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      locals: { data: entries },
	      clickOutsideToClose: true,
	      fullscreen: true
	    });
	  }
	};
	
	exports.default = ShortCoursesListCtrl;
	
	
	ShortCoursesListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$sessionStorage'];

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModalVM.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p class=m-t-md>Está a punto de eliminar curso corto <strong>\"{{ ctrlModalVM.name }}\"</strong> ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=ctrlModalVM.close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=ctrlModalVM.delete()>Sí, eliminar propuesta</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateShortCoursesCtrl = function () {
	  function CreateShortCoursesCtrl($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
	    _classCallCheck(this, CreateShortCoursesCtrl);
	
	    var createShortCourseVm = this;
	    var currentUser = JSON.parse($cookies.get('currentUser'));
	    var texts = GlobalConfig.appTexts;
	    var post = {
	      workplanId: currentUser.workplanId,
	      teacherId: currentUser.teacherId,
	      name: currentUser.name
	    };
	    createShortCourseVm.sourceType = [];
	    createShortCourseVm.scholarshipProgramType = [];
	    createShortCourseVm.isEditing = $stateParams.workplanTeacherActivityId ? true : false;
	    createShortCourseVm.rangeType = GlobalConfig.periods.rangeType;
	    createShortCourseVm.createOrEdit = 'Crear';
	    createShortCourseVm.textCreateOrEdit = texts.saved;
	    createShortCourseVm.createOrEditMV = texts.createDialog;
	    createShortCourseVm.typePeriod = [];
	    createShortCourseVm.periodsArray = [];
	    createShortCourseVm.selectedTypePeriod = {};
	    createShortCourseVm.isTouchedPeriods = false;
	    createShortCourseVm.startDate = null;
	    createShortCourseVm.endDate = null;
	    createShortCourseVm.minStartDate = moment().toDate();
	    createShortCourseVm.minEndDate = new Date();
	    createShortCourseVm.isSaveButtonDisabled = false;
	    createShortCourseVm.isFeedback = currentUser.isFeedback;
	    createShortCourseVm.hasError = hasError;
	    createShortCourseVm.showErrorMessages = showErrorMessages;
	    createShortCourseVm.validateForm = validateForm;
	    createShortCourseVm.validateCheklistPeriods = validateCheklistPeriods;
	    createShortCourseVm.funSelectedPeriod = funSelectedPeriod;
	    createShortCourseVm.startDateChange = startDateChange;
	    createShortCourseVm.addShortCourse = addShortCourse;
	    createShortCourseVm.cleanRangeType = cleanRangeType;
	    createShortCourseVm.close = close;
	    createShortCourseVm.dt_start = $cookies.get('wp_start');
	    createShortCourseVm.dt_end = $cookies.get('wp_end');
	
	    createShortCourseVm.updateRangeType = function (val) {
	      createShortCourseVm.rangeType = val;
	      createShortCourseVm.periodsArray = [];
	      createShortCourseVm.startDate = null;
	      createShortCourseVm.endDate = null;
	    };
	    createShortCourseVm.updateRangeData = function (val) {
	      createShortCourseVm.periodsArray = val['periods'];
	      createShortCourseVm.startDate = val['dates'][0];
	      createShortCourseVm.endDate = val['dates'][1];
	    };
	
	    activate();
	
	    function activate() {
	      if (createShortCourseVm.isEditing) {
	        createShortCourseVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId;
	        createShortCourseVm.createOrEdit = 'Editar';
	        createShortCourseVm.createOrEditMV = texts.editDialog;
	        createShortCourseVm.textCreateOrEdit = texts.modified;
	        getDataShortCourses();
	      }
	
	      WorkPlanSrv.getDataFormShortCourses.getList(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          loadData(dataReturn);
	        } else {
	          console.log('Comunications problem');
	        }
	      }, function (data) {
	        console.log(data);
	      });
	    }
	
	    function loadData(data) {
	      createShortCourseVm.typePeriod = data.listPeriods;
	      createShortCourseVm.listsTypeCourse = data.listTypeCourse.items;
	      createShortCourseVm.listModalities = data.listModalityCourse.items;
	      createShortCourseVm.listRoles = data.listRoleCourse.items;
	    }
	
	    function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	
	    function showErrorMessages(input) {
	      return input.$dirty || input.$touched;
	    }
	
	    function addShortCourse(isExecution) {
	      var origin = GlobalConfig.activityTypeId.originActivityPlanning;
	      if (isExecution) {
	        origin = GlobalConfig.activityTypeId.originActivityExecution;
	      }
	      createJson(origin);
	    }
	
	    function validateForm(form) {
	      return form.$invalid || createShortCourseVm.validateCheklistPeriods();
	    }
	
	    function createJson(origin) {
	      var shortCourse = {
	        teacherId: post.teacherId,
	        workplanId: post.workplanId,
	        name: createShortCourseVm.name,
	        description: createShortCourseVm.description,
	        hoursPlanning: createShortCourseVm.plannedHours,
	        activityId: GlobalConfig.minorActivityId.shortCourse,
	        itemTypeCourseId: createShortCourseVm.type,
	        itemModalityId: createShortCourseVm.modality,
	        itemRoleId: createShortCourseVm.rol,
	        timeRangeTypeId: createShortCourseVm.rangeType,
	        origin: origin,
	        isFeedbackActivity: createShortCourseVm.isFeedback
	      };
	
	      if (createShortCourseVm.isEditing) {
	        shortCourse.workplanTeacherActivityId = createShortCourseVm.workplanTeacherActivityId;
	      }
	
	      if (parseInt(createShortCourseVm.rangeType) === GlobalConfig.periods.rangeType) {
	        var arrayPeriod = [];
	        for (var index in createShortCourseVm.periodsArray) {
	          var temp = {
	            periodId: createShortCourseVm.periodsArray[index]
	          };
	          arrayPeriod.push(temp);
	        }
	        shortCourse.periods = arrayPeriod;
	      } else {
	        shortCourse.startDate = new Date(createShortCourseVm.startDate);
	        shortCourse.endDate = new Date(createShortCourseVm.endDate);
	      }
	
	      addOrEditshortCourse(shortCourse);
	    }
	
	    function addOrEditshortCourse(shortCourse) {
	      createShortCourseVm.isSaveButtonDisabled = true;
	      WorkPlanSrv.addShortCourses.save(shortCourse).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          getSendNotify(shortCourse.origin);
	          confirmShortCourseAction();
	        } else {
	          createShortCourseVm.isSaveButtonDisabled = false;
	          console.log('Error Comunications');
	        }
	      }, function (data) {
	        createShortCourseVm.isSaveButtonDisabled = false;
	        console.log(data);
	      });
	    }
	
	    function validateCheklistPeriods() {
	      return createShortCourseVm.rangeType == 1 ? createShortCourseVm.periodsArray.length < 1 : false;
	    }
	
	    function funSelectedPeriod(period, checked) {
	      if (checked) {
	        if (!createShortCourseVm.periodsArray.includes(period.periodId)) {
	          createShortCourseVm.periodsArray.push(period.periodId);
	        }
	      } else {
	        var index = createShortCourseVm.periodsArray.indexOf(period.periodId);
	        if (index != -1) {
	          createShortCourseVm.periodsArray.splice(index, 1);
	        }
	      }
	      createShortCourseVm.isTouchedPeriods = true;
	    }
	
	    function startDateChange() {
	      var m = moment(createShortCourseVm.startDate);
	      createShortCourseVm.minEndDate = m.isValid() ? m /*.add(1, 'days')*/.toDate() : null;
	    }
	
	    function confirmShortCourseAction() {
	      var header = {
	        createOrEdit: createShortCourseVm.createOrEditMV,
	        textCreateOrEdit: createShortCourseVm.textCreateOrEdit,
	        itemName: createShortCourseVm.name,
	        nameModal: texts.modalTypeName.shortCourses,
	        modalType: texts.modalTypeId.shortCourses
	      };
	      WorkPlanModalSrv.setVariableSuccessDialog(header);
	      WorkPlanModalSrv.successDialog(header).then(function (promise) {});
	    }
	
	    function getDataShortCourses() {
	      var post = {
	        workplanTeacherActivityId: parseInt(createShortCourseVm.workplanTeacherActivityId)
	      };
	
	      WorkPlanSrv.getShortCoursesById.get(post).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          setValues(dataReturn.data);
	        } else {
	          console.log('Comunications problem with the server');
	        }
	      }, function (data) {});
	    }
	
	    function setValues(shortCourse) {
	      createShortCourseVm.name = shortCourse.name;
	      createShortCourseVm.description = shortCourse.description;
	      createShortCourseVm.plannedHours = shortCourse.hoursPlanned;
	      createShortCourseVm.type = shortCourse.itemTypeCourseId;
	      createShortCourseVm.modality = shortCourse.itemModalityId;
	      createShortCourseVm.rol = shortCourse.itemRoleId;
	      createShortCourseVm.rangeType = shortCourse.timeRangeTypeId;
	      createShortCourseVm.dt_start = moment(shortCourse.startDate, 'YYYY-MM-DD').toDate();
	      createShortCourseVm.dt_end = moment(shortCourse.endDate, 'YYYY-MM-DD').toDate();
	      createShortCourseVm.periodsArray = [];
	      createShortCourseVm.selectedTypePeriod = {};
	
	      if (createShortCourseVm.rangeType == GlobalConfig.periods.rangeType) {
	        var splits = shortCourse.periodId.split(',');
	        if (splits) {
	          for (var i = 0; i < splits.length; i++) {
	            var valor = splits[i];
	            createShortCourseVm.periodsArray.push(parseInt(valor));
	            createShortCourseVm.selectedTypePeriod[valor] = true;
	          }
	        }
	      }
	
	      if (shortCourse.startDate) {
	        var startDateNew = moment(shortCourse.startDate, 'YYYY-MM-DD').toDate();
	        if (startDateNew <= moment().toDate()) {
	          createShortCourseVm.minStartDate = moment(shortCourse.startDate, 'YYYY-MM-DD').toDate();
	        }
	        startDateChange();
	      }
	
	      createShortCourseVm.isEditing = true;
	    }
	
	    function cleanRangeType() {
	      if (parseInt(createShortCourseVm.rangeType) == GlobalConfig.periods.rangeType) {
	        createShortCourseVm.startDate = null;
	        createShortCourseVm.endDate = null;
	      } else {
	        createShortCourseVm.periodsArray = [];
	        createShortCourseVm.selectedTypePeriod = null;
	      }
	    }
	
	    function close() {
	      return $mdDialog.hide();
	    }
	
	    function getSendNotify(origin) {
	      var msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva actividad en educación continuada en la etapa de planeación.';
	      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
	        msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva actividad en educación continuada en la etapa de ejecución.';
	      }
	      var data = {
	        idTeacher: currentUser.teacherId,
	        dsName: 'Notificación, se agregó o editó una actividad en educación continuada',
	        dsDescription: msg,
	        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
	        is_grouped: 1,
	        submodule: GlobalConfig.modules.extentionAndVisibility
	      };
	      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data);
	    }
	  } // FIN DEL CONSTRUCTOR
	
	  _createClass(CreateShortCoursesCtrl, [{
	    key: 'preventInput',
	    value: function preventInput(event) {
	      var vKey = 86;
	      if (event.keyCode == vKey) {
	        event.preventDefault();
	      }
	      return;
	    }
	  }]);
	
	  return CreateShortCoursesCtrl;
	}();
	
	exports.default = CreateShortCoursesCtrl;
	
	
	CreateShortCoursesCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv'];

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: listTransversalProjectsCtrl
	* # alias: listTPCtrl
	*/
	
	var listTransversalProjectsCtrl = function () {
		function listTransversalProjectsCtrl($scope, $state, $stateParams, ngNotify, UserInfoConstant, $mdDialog, $cookies, WorkPlanSrv) {
			var _this = this;
	
			_classCallCheck(this, listTransversalProjectsCtrl);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$stateParams = $stateParams;
			this.$cookies = $cookies;
			this.tacherName = $cookies.get('adminName');
			this.ngNotify = ngNotify;
			this.$mdDialog = $mdDialog;
			this.WorkPlanSrv = WorkPlanSrv;
	
			this.$scope.UserInfoConstant = UserInfoConstant;
			this.$scope.$watch('UserInfoConstant[0].details[0]', function (details) {
				if (details !== undefined) {
					_this.userinfo = details.user;
					_this.main();
				}
			});
		}
	
		_createClass(listTransversalProjectsCtrl, [{
			key: 'main',
			value: function main() {
				this.listTransversal();
			}
		}, {
			key: 'close',
			value: function close() {
				return this.$mdDialog.hide();
			}
		}, {
			key: 'listTransversal',
			value: function listTransversal() {
				var _this2 = this;
	
				this.WorkPlanSrv.getListProjectsCross.post().$promise.then(function (result) {
					if (!result.status) {
						ngNotify.set('Error al conectar con el servicio', 'error');
					} else {
						_this2.ProjectsCross = result.data;
						_this2.detailTransversal({ transversalProjectsId: _this2.ProjectsCross[0].transversalProjectsId });
					}
				}, function (err) {
					ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}, {
			key: 'detailTransversal',
			value: function detailTransversal(data) {
				var _this3 = this;
	
				var params = {
					transversalProjectsId: data.transversalProjectsId
				};
	
				this.status = false;
	
				this.WorkPlanSrv.getProjectsCrossById.get(params).$promise.then(function (result) {
					if (!result.status) {
						ngNotify.set('Error al conectar con el servicio', 'error');
					} else {
						_this3.DetailProjectsCross = result.data;
						_this3.status = result.status;
					}
				}, function (err) {
					ngNotify.set('Imposible conectar con el servicio', 'error');
				});
			}
		}]);
	
		return listTransversalProjectsCtrl;
	}();
	
	exports.default = listTransversalProjectsCtrl;
	
	
	listTransversalProjectsCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', 'UserInfoConstant', '$mdDialog', '$cookies', 'WorkPlanSrv'];

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AddActivityCtrl = function () {
	  function AddActivityCtrl($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv) {
	    _classCallCheck(this, AddActivityCtrl);
	
	    // constants
	    this.$scope = $scope;
	    this.$scope.parentActivity = WorkPlanModalSrv.getVariable();
	    this.WorkPlanModalSrv = WorkPlanModalSrv;
	    this.$scope.activities = {};
	    this.$mdDialog = $mdDialog;
	    this.ReviewSrv = ReviewSrv;
	
	    // variables
	    this.numberOfStudentsAdd = '';
	    this.hoursExecutedAdd = '';
	    this.observationsAdd = '';
	    this.listItemId = '';
	    this.$scope.listType = '';
	    this.isSaveButtonDisabled = false;
	
	    this.activate();
	  }
	
	  _createClass(AddActivityCtrl, [{
	    key: 'activate',
	    value: function activate() {
	      this.$scope.listType = this.$scope.parentActivity.listType;
	      return this.getActivitiesList();
	    }
	  }, {
	    key: 'clearCombo',
	    value: function clearCombo() {
	      var items = this.$scope.parentActivity.children;
	      for (var i in items) {
	        for (var j in this.$scope.activities) {
	          if (items[i].itemActivityId === this.$scope.activities[j].idListItem) {
	            this.$scope.activities.splice(j, 1);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      return this.$mdDialog.hide();
	    }
	  }, {
	    key: 'getActivitiesList',
	    value: function getActivitiesList() {
	      var _this = this;
	
	      return this.ReviewSrv.getDataFormActivityTeaching.get().$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          if (_this.$scope.parentActivity.listType === 'planning') {
	            _this.$scope.activities = dataReturn.listsPlanning.items;
	          } else {
	            _this.$scope.activities = dataReturn.listsTeachers.items;
	          }
	          _this.clearCombo();
	        }
	      });
	    }
	  }, {
	    key: 'addActivityNew',
	    value: function addActivityNew() {
	      var _this2 = this;
	
	      this.isSaveButtonDisabled = true;
	      this.hoursExecutedAdd = this.hoursExecutedAdd != '' ? this.hoursExecutedAdd : 0;
	      var header = {
	        idActivityParent: this.$scope.parentActivity.idActivityParent,
	        idTeacher: this.$scope.parentActivity.idTeacher,
	        idWorkPlan: this.$scope.parentActivity.idWorkPlan,
	        activityId: this.$scope.parentActivity.activityId,
	        asignatureId: this.$scope.parentActivity.asignatureId,
	        listItemId: this.listItemId,
	        descriptionExecution: this.observationsAdd,
	        hoursExecuted: this.hoursExecutedAdd,
	        numberOfStudents: this.numberOfStudentsAdd
	      };
	      this.ReviewSrv.addActivityExecution.post(header).$promise.then(function (dataReturn) {
	        if (dataReturn.status) {
	          var data = dataReturn.data;
	          data.name = data.itemActivityName;
	          delete data.itemActivityName;
	          data.itemActivityValue = header.numberOfStudents;
	          _this2.WorkPlanModalSrv.setVariable(data);
	          _this2.close();
	          _this2.isSaveButtonDisabled = false;
	        }
	      });
	    }
	  }, {
	    key: 'showErrorMessages',
	    value: function showErrorMessages(input) {
	      if (input) {
	        return input.$dirty || input.$touched;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm(form) {
	      return form.$invalid;
	    }
	  }, {
	    key: 'hasError',
	    value: function hasError(input) {
	      if (input.$invalid && (input.$dirty || input.$touched)) {
	        return 'has-error';
	      }
	    }
	  }]);
	
	  return AddActivityCtrl;
	}();
	
	exports.default = AddActivityCtrl;
	
	
	AddActivityCtrl.$inject = ['$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv'];

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegisterExecutionCtrl = function RegisterExecutionCtrl($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv, $state, $cookies, WorkPlanSrv, $stateParams, ngNotify, Validations, Ramda, FileUploader, SERVICE_URL_CONSTANT, $rootScope, GlobalConfig, GlobalSrv) {
		_classCallCheck(this, RegisterExecutionCtrl);
	
		$scope.showForm = true;
		var curry = Ramda.curry;
	
		var activity = WorkPlanModalSrv.getVariable();
		var currentModule = $state.current.module;
		var userId = JSON.parse($cookies.get('currentUser')).id;
		var finishedState = 'Finalizado';
	
		$('#register').attr('disabled', true);
		$scope.regUpdate = regUpdate;
		$scope.upCompare = upCompare;
		$rootScope.setHandsProgress = false;
	
		var isDoctoralEducationType = Validations.isDoctoralEducationType,
		    isTeacherDevelopmentType = Validations.isTeacherDevelopmentType;
	
	
		var requireState = function requireState(activity) {
			return isDoctoralEducationType(activity) || isTeacherDevelopmentType(activity);
		};
	
		angular.extend($scope, {
			observations: '',
			hoursExecuted: null,
			action: 'Registrar',
			startDate: null,
			endDate: null,
			minStartDate: null,
			minEndDate: null,
			states: [],
			inTeaching: Validations.inTeaching(currentModule),
			inConsolidation: Validations.inConsolidation(currentModule),
			inInvestigation: Validations.inInvestigation(currentModule),
			inExtension: Validations.inExtension(currentModule),
			inAcademicManagement: Validations.inAcademicManagement(currentModule),
			isColaborationSpaceType: Validations.isColaborationSpaceType(activity.children),
			isProjectDesignType: Validations.isProjectDesignType(activity.children),
			requireState: requireState(activity.children),
			state: null,
			oldHoursExecuted: 0,
			fileName: null,
			attachFile: '',
			loading: false,
			min: 0,
			finishedState: finishedState,
			errorMsg: false,
			STATIC_IMAGE_URL: false,
			isShowState: null,
			close: close,
			register: register,
			validateForm: validateForm,
			showErrorMessages: showErrorMessages,
			startDateChange: startDateChange,
			disabledEndDate: true,
			remove: remove,
			hasError: hasError
		});
	
		activate();
	
		function activate() {
			history(activity.children);
			getData();
	
			if (activity.children.itemRequired || activity.itemRequired > 0) {
				$scope.min = 1;
			}
	
			getStatesCombo();
		}
	
		function getData() {
			if (activity.action === 'EDIT') {
				$scope.action = 'Modificar';
				$scope.hoursExecuted = activity.children.hoursExecuted;
				$scope.observations = activity.children.descriptionExecution;
				$scope.oldHoursExecuted = activity.children.hoursExecuted;
				$scope.startDate = moment(activity.children.startDate, 'DD/MM/YYYY').toDate();
				$scope.endDate = moment(activity.children.endDate, 'DD/MM/YYYY').toDate();
				startDateChange($scope.startDate, 'start');
				$scope.state = activity.children.status;
				$scope.fileName = activity.children.fileName;
				$scope.isShowState = activity.isShowState;
	
				if ($scope.fileName != null && $scope.fileName != '') {
					var miArray = $scope.fileName.split('/', -1);
	
					$scope.attachFile = miArray[miArray.length - 1];
				}
	
				if ($scope.startDate == 'Invalid Date' || activity.children.startDate == 'Invalid date') {
					$scope.startDate = null;
				}
	
				if ($scope.endDate == 'Invalid Date' || activity.children.endDate == 'Invalid date') {
					$scope.endDate = null;
				}
			}
		}
	
		function regUpdate(reg, i) {
			if ($scope.arrayvar[i].num_hours_executed != reg.num_hours_executed) {
				$scope.diff = reg.num_hours_executed - $scope.arrayvar[i].num_hours_executed;
			} else {
				$scope.diff = 0;
			}
	
			var params = {
				id_key: activity.children.workplanTeacherActivityId,
				hourdiff: $scope.diff,
				id_code: reg.id_code,
				num_hours_executed: reg.num_hours_executed,
				ds_description: reg.ds_description
			};
	
			WorkPlanSrv.postUptHistoryActivities.get(params).$promise.then(function (response) {
				if (!response.status) {
					ngNotify.set('Error al conectar con el servicio', 'error');
				} else {
					activity.children.hoursExecuted += $scope.diff;
					ngNotify.set('Bitacora Actualizada', 'success');
					$scope.close();
				}
			}, function (err) {
				ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function getStatesCombo() {
			WorkPlanSrv.getListState.get().$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					$scope.states = dataReturn.listStates;
					$scope.showForm = false;
				} else {
					console.log('Comunications problem with the server');
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function setHeader(activity) {
			return {
				idActivity: activity.workplanTeacherActivityId,
				descriptionExecution: $scope.observations,
				hoursExecuted: $scope.hoursExecuted,
				idEntry: activity.workplanTeacherEntriesId,
				startDate: moment($scope.startDate).format('YYYY-MM-DD'),
				endDate: moment($scope.endDate).format('YYYY-MM-DD'),
				state: $scope.state,
				oldHoursExecuted: $scope.oldHoursExecuted,
				fileName: $scope.fileName,
				attachFile: $scope.attachFile,
				fileUrl: $scope.fileUrl
			};
		}
	
		function close() {
			return $mdDialog.hide();
		}
	
		function history(activity) {
			var params = {
				id: activity.workplanTeacherActivityId
			};
	
			WorkPlanSrv.getHistoryActivities.get(params).$promise.then(function (response) {
				if (!response.status) {
					ngNotify.set('Error al conectar con el servicio', 'error');
				} else {
					$scope.showForm = false;
					$scope.variable = response.data;
					$scope.arrayvar = angular.copy(response.data);
				}
			}, function () {
				ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function upCompare(reg, i) {
			return $scope.arrayvar[i].ds_description != reg.ds_description || $scope.arrayvar[i].num_hours_executed != reg.num_hours_executed;
		}
	
		function setDate(date) {
			return moment(date).format('DD/MM/YYYY');
		}
	
		function setData(activity, insertId, date, action) {
			return {
				idActivity: activity.workplanTeacherActivityId,
				idActivity2: activity.children.workplanTeacherActivityId,
				workplanTeacherActivityId: activity.children.workplanTeacherActivityId,
				descriptionExecution: $scope.observations,
				hoursExecuted: $scope.hoursExecuted,
				workplanTeacherEntriesId: insertId,
				dateCreation: date,
				startDate: setDate($scope.startDate),
				endDate: setDate($scope.endDate),
				status: $scope.state,
				action: action,
				fileName: $scope.fileName,
				attachFile: $scope.attachFile,
				fileUrl: $scope.fileUrl
			};
		}
	
		var addExecution = curry(function (activity, header) {
			ReviewSrv.setExecution.post(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					var data = setData(activity, dataReturn.idActivityItem, moment(new Date()).format('DD/MM/YYYY'), 'ADD');
	
					WorkPlanModalSrv.setVariable(data);
					$rootScope.setHandsProgress = false;
					$scope.close();
				}
			});
		})(activity);
	
		var editExecution = curry(function (activity, header) {
			ReviewSrv.editExecution.post(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					var data = setData(activity, header.idEntry, moment(new Date()).format('DD/MM/YYYY'), 'EDIT');
	
					WorkPlanModalSrv.setVariable(data);
					$rootScope.setHandsProgress = false;
					$scope.close();
				}
			});
		})(activity);
	
		function getNotify(idRole, modulo, typecall, origin, nameuser, nameactivity) {
			var reviewers = GlobalSrv.getReviewerbySubmodule(idRole, GlobalConfig.modules.execution);
	
			if (reviewers) {
				getSendNotify(reviewers, modulo, typecall, origin, nameuser, nameactivity);
			}
		}
	
		function getSendNotify(idUser, modulo, typecall, origin, nameuser, nameactivity) {
			var msg = void 0;
	
			if (Validations.inConsolidation(modulo) && typecall) {
				msg = 'El profesor ' + nameuser + ' ha efectuado cambios en sus actividades en seguimiento estratégico';
			}
	
			if (Validations.inConsolidation(modulo) && typecall) {
				GlobalSrv.sendNotification({
					idUser: idUser,
					dsName: 'Notificación, El profesor ' + nameuser + ' ha modificado una actividad',
					dsDescription: msg,
					idNotification_delivery_type: GlobalConfig.notificationType.inbox,
					is_grouped: 1
				});
			}
		}
	
		function register() {
			$rootScope.setHandsProgress = true;
			$('#register').attr('disabled', true);
			var nameusers = JSON.parse($cookies.get('currentUser')).dsFullname;
	
			switch (activity.action) {
	
				case 'ADD':
					addExecution(setHeader(activity.children));
					getNotify(GlobalConfig.userRolesIds.reviewer, currentModule, false, activity.children.origin, nameusers, activity.children.activityTypeNameCombo);
					getNotify(GlobalConfig.userRolesIds.approver, currentModule, false, activity.children.origin, nameusers, activity.children.activityTypeNameCombo);
					break;
				case 'EDIT':
					editExecution(setHeader(activity.children));
					getNotify(GlobalConfig.userRolesIds.reviewer, currentModule, true, activity.children.origin, nameusers, activity.children.activityTypeNameCombo);
					getNotify(GlobalConfig.userRolesIds.approver, currentModule, true, activity.children.origin, nameusers, activity.children.activityTypeNameCombo);
					break;
				default:
					console.log('Not an available action');
					break;
	
			}
		}
	
		function showErrorMessages(input) {
			if (input) {
				return input.$dirty || input.$touched;
			} else {
				return false;
			}
		}
	
		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error';
			}
		}
	
		function validateForm(form) {
			if (form) {
				if ($scope.inConsolidation === true) {
					return !(form.$invalid === false);
				} else {
					return form.$invalid;
				}
			}
		}
	
		function startDateChange(date, type) {
			switch (type) {
	
				case 'start':
					$scope.startDate = date;
					break;
				case 'end':
					$scope.endDate = date;
					break;
	
			}
			$scope.disabledEndDate = !$scope.startDate;
			var m = moment($scope.startDate);
	
			$scope.minEndDate = m.isValid() ? m.add(0, 'days').toDate() : null;
		}
	
		var uploader = $scope.uploader = new FileUploader({
			url: SERVICE_URL_CONSTANT.rosario + '/file/uploadFileExecution?userId=' + userId
		});
	
		uploader.filters.push({
			name: 'syncFilter',
			fn: function fn(item /* {File|FileLikeObject} */, options) {
				console.log('syncFilter');
	
				return this.queue.length < 10;
			}
		});
	
		// an async filter
		uploader.filters.push({
			name: 'asyncFilter',
			fn: function fn(item /* {File|FileLikeObject} */, options, deferred) {
				console.log('asyncFilter');
				setTimeout(deferred.resolve, 1e3);
			}
		});
	
		uploader.onSuccessItem = function (fileItem, response, status, headers) {
			if (response.status) {
				$scope.fileName = response.data;
				$scope.fileUrl = response.url;
				$scope.loading = false;
				$scope.STATIC_IMAGE_URL = true;
				$scope.attachFile = fileItem.file.name;
				$scope.errorMsg = false;
				$('#uploader').val('');
			}
		};
	
		uploader.onErrorItem = function (fileItem, response, status, headers) {
			$scope.attachFile = '';
			$scope.STATIC_IMAGE_URL = false;
			$scope.loading = false;
			$scope.fileName = null;
			$scope.errorMsg = true;
			$('#uploader').val('');
		};
	
		uploader.onBeforeUploadItem = function (item) {
			var header = { userId: userId };
	
			item.formData.push(header);
			$scope.loading = true;
		};
	
		function remove() {
			$scope.attachFile = '';
			$scope.STATIC_IMAGE_URL = false;
			$scope.loading = false;
			$scope.fileName = null;
			$scope.errorMsg = false;
			$('#uploader').val('');
	
			if (uploader.queue[0]) {
				uploader.queue[0].remove();
			}
		}
	};
	
	exports.default = RegisterExecutionCtrl;
	
	
	RegisterExecutionCtrl.$inject = ['$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv', '$state', '$cookies', 'WorkPlanSrv', '$stateParams', 'ngNotify', 'Validations', 'Ramda', 'FileUploader', 'SERVICE_URL_CONSTANT', '$rootScope', 'GlobalConfig', 'GlobalSrv'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditChildrenExecutionCtrl = function EditChildrenExecutionCtrl($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv, $state, $cookies, WorkPlanSrv, ngNotify, Validations, Ramda, activity) {
	  _classCallCheck(this, EditChildrenExecutionCtrl);
	
	  var currentModule = $state.current.module;
	
	  angular.extend($scope, {
	    regUpdate: regUpdate,
	    upCompare: upCompare,
	    inTeaching: Validations.inTeaching(currentModule),
	    close: close
	  });
	
	  activate();
	
	  function activate() {
	    $scope.saving = false;
	    history(activity.children);
	    if (activity.children.itemRequired || activity.itemRequired > 0) $scope.min = 1;
	  }
	
	  function regUpdate(reg, i) {
	
	    $scope.saving = true;
	    if ($scope.arrayvar[i].num_hours_executed != reg.num_hours_executed) {
	      $scope.diff = reg.num_hours_executed - $scope.arrayvar[i].num_hours_executed;
	    } else {
	      $scope.diff = 0;
	    }
	    var params = {
	      id_key: activity.children.workplanTeacherActivityId,
	      hourdiff: $scope.diff,
	      id_code: reg.id_code,
	      num_hours_executed: reg.num_hours_executed,
	      ds_description: reg.ds_description
	    };
	
	    if (!$scope.inTeaching) {
	
	      params.dt_start_date = moment(reg.dt_start_date).format('YYYY-MM-DD');
	      params.dt_end_date = moment(reg.dt_end_date).format('YYYY-MM-DD');
	    }
	
	    WorkPlanSrv.postUptHistoryActivities.get(params).$promise.then(function (response) {
	      if (!response.status) {
	        ngNotify.set('Error al conectar con el servicio', 'error');
	      } else {
	        activity.children.hoursExecuted += $scope.diff;
	        //ngNotify.set('Bitacora Actualizada', 'success')
	        $scope.close();
	      }
	    }, function (err) {
	      ngNotify.set('Imposible conectar con el servicio', 'error');
	    });
	  }
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function history(activity) {
	    var params = {
	      id: activity.workplanTeacherActivityId
	    };
	    WorkPlanSrv.getHistoryActivities.get(params).$promise.then(function (response) {
	      if (!response.status) {
	        ngNotify.set('Error al conectar con el servicio', 'error');
	      } else {
	        $scope.variable = response.data;
	        $scope.arrayvar = angular.copy(response.data);
	        for (var i = $scope.variable.length - 1; i >= 0; i--) {
	          $scope.variable[i].dt_start_date = moment($scope.variable[i].dt_start_date, 'DD-MM-YYYY').toDate();
	          $scope.variable[i].dt_end_date = moment($scope.variable[i].dt_end_date, 'DD-MM-YYYY').toDate();
	        }
	      }
	    }, function (err) {
	      ngNotify.set('Imposible conectar con el servicio', 'error');
	    });
	  }
	
	  function upCompare(reg, i) {
	    if ($scope.arrayvar[i].ds_description != reg.ds_description || $scope.arrayvar[i].num_hours_executed != reg.num_hours_executed || $scope.arrayvar[i].dt_start_date != reg.dt_start_date || $scope.arrayvar[i].dt_end_date != reg.dt_end_date) {
	      return false;
	    } else {
	      return true;
	    }
	  }
	};
	
	exports.default = EditChildrenExecutionCtrl;
	
	
	EditChildrenExecutionCtrl.$inject = ['$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv', '$state', '$cookies', 'WorkPlanSrv', 'ngNotify', 'Validations', 'Ramda', 'activity'];

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExecutionEntriesCtrl = function ExecutionEntriesCtrl($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv) {
		_classCallCheck(this, ExecutionEntriesCtrl);
	
		$scope.activity = WorkPlanModalSrv.getVariable();
		$scope.entries = [];
	
		$scope.close = close;
		$scope.dateFormatter = dateFormatter;
	
		$scope.download = function (link) {
			window.open(link);
		};
	
		activate();
	
		function close() {
			return $mdDialog.hide();
		}
	
		function dateFormatter(date) {
			var formattedDate = moment(date).format('dddd DD/MM/YYYY');
	
			return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
		}
	
		function activate() {
			return getExecutionEntries($scope.activity);
		}
	
		function getExecutionEntries(activity) {
			var header = {
				workplanTeacherActivityId: activity.selectedActivityId
			};
	
			return ReviewSrv.getExecutionEntries.post(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					$scope.entries = dataReturn.data;
				}
			});
		}
	};
	
	exports.default = ExecutionEntriesCtrl;
	
	
	ExecutionEntriesCtrl.$inject = ['$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv'];

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EndStageModalCtrl = function EndStageModalCtrl($scope, $state, $http, $resource, $filter, ngNotify, $mdDialog, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, Validations, WorkPlanParametrizationSrv, GlobalSrv, $cookies, $stateParams, ReviewSrv) {
		_classCallCheck(this, EndStageModalCtrl);
	
		var endStageModalVm = this;
		// Variables
		var sharedVar = WorkPlanModalSrv.getVariable();
	
		endStageModalVm.teacherId = parseInt(sharedVar.teacherId);
		endStageModalVm.workplanId = parseInt(sharedVar.workplanId);
		endStageModalVm.currentUser = $cookies.getObject('currentUser');
		endStageModalVm.userId = sharedVar.userId;
		endStageModalVm.textStage = sharedVar.textStage;
		endStageModalVm.count = sharedVar.count;
		endStageModalVm.toReviewed = sharedVar.toReviewed;
		endStageModalVm.allAct = sharedVar.allAct;
		endStageModalVm.isReviewAndApproval = sharedVar.isReviewAndApproval;
		var currentStage = sharedVar.currentStage;
		var currentRoleId = +$cookies.get('hasRoleId');
	
		endStageModalVm.pendingBreakdown = null;
		endStageModalVm.pendingBreakdownLoading = false;
		endStageModalVm.hasPendingOther = hasPendingOther;
		endStageModalVm.assignedAllApproved = assignedAllApproved;
	
		endStageModalVm.strategic = sharedVar.strategic;
		endStageModalVm.statusApproval = 0;
		endStageModalVm.approvalCompleted = false;
		endStageModalVm.criteriaList = [];
		endStageModalVm.criteriaOption = 1;
		endStageModalVm.isNotTouchedCriterias = true;
		endStageModalVm.toBlocked = 0;
	
		endStageModalVm.inReview = Validations.inReview(currentStage);
		endStageModalVm.inApproval = Validations.inApproval(currentStage);
		endStageModalVm.inExecution = Validations.inExecution(currentStage);
		endStageModalVm.inEvaluation = Validations.inEvaluation(currentStage);
		endStageModalVm.inReviewExecution = Validations.inReviewExecution(currentStage);
		endStageModalVm.integralEvaluationURL = GlobalConfig.externalURLs.integralEvaluationURL;
	
		// methods
		endStageModalVm.close = close;
		endStageModalVm.hasError = hasError;
		endStageModalVm.showErrorMessages = showErrorMessages;
		endStageModalVm.validateForm = validateForm;
		endStageModalVm.finish = finish;
		endStageModalVm.isToReviewed = isToReviewed;
		endStageModalVm.isAllReviewed = isAllReviewed;
		endStageModalVm.isShowOption = isShowOption;
		endStageModalVm.selectedCriteria = selectedCriteria;
	
		active();
	
		if (endStageModalVm.inReview || endStageModalVm.inReviewExecution) {
			loadPendingBreakdown();
		}
	
		function loadPendingBreakdown() {
			var stageId = endStageModalVm.inReview ? GlobalConfig.workplanIdStages.review : GlobalConfig.workplanIdStages.reviewExecution;
	
			var post = {
				teacherId: endStageModalVm.teacherId,
				workplanId: endStageModalVm.workplanId,
				stageId: stageId,
				evaluatorId: endStageModalVm.currentUser.id,
				roleId: currentRoleId
			};
	
			endStageModalVm.pendingBreakdownLoading = true;
	
			return ReviewSrv.getPendingActivitiesBySubmodule.post(post).$promise.then(function (dataReturn) {
				if (dataReturn && dataReturn.status) {
					endStageModalVm.pendingBreakdown = dataReturn.data;
				}
			}).catch(function (err) {
				console.log('loadPendingBreakdown error', err);
			}).finally(function () {
				endStageModalVm.pendingBreakdownLoading = false;
			});
		}
	
		function hasPendingOther() {
			return !!(endStageModalVm.pendingBreakdown && endStageModalVm.pendingBreakdown.other && endStageModalVm.pendingBreakdown.other.length > 0);
		}
	
		function assignedAllApproved() {
			return !!(endStageModalVm.pendingBreakdown && endStageModalVm.pendingBreakdown.assigned && endStageModalVm.pendingBreakdown.assigned.pending === 0);
		}
	
		function active() {
			if (endStageModalVm.inEvaluation || endStageModalVm.inApproval || endStageModalVm.isReviewAndApproval) {
				if (endStageModalVm.count == 0) {
					endStageModalVm.statusApproval = 1;
				} else if (endStageModalVm.count > 0 || endStageModalVm.allAct !== endStageModalVm.count) {
					endStageModalVm.statusApproval = 2;
				} else if (endStageModalVm.count > 0) {
					endStageModalVm.statusApproval = 3;
				}
	
				var post = {
					listId: endStageModalVm.inApproval || endStageModalVm.isReviewAndApproval ? 1 : 2,
					workplanId: endStageModalVm.workplanId
				};
	
				if (endStageModalVm.inReviewExecution || endStageModalVm.inEvaluation) {
					return WorkPlanSrv.getWorkplanEvaluationCriteriaDetail.get(post).$promise.then(function (dataReturn) {
						if (dataReturn.status) {
							endStageModalVm.criteriaList = dataReturn.data.list;
						}
					}).catch(function (error) {
						console.log(error);
					});
				} else {
					return WorkPlanSrv.getCriteriaCategoryDetail.get(post).$promise.then(function (dataReturn) {
						if (dataReturn.status) {
							endStageModalVm.criteriaList = dataReturn.data.list;
						}
					}).catch(function (error) {
						console.log(error);
					});
				}
			}
		}
	
		function close() {
			WorkPlanModalSrv.setVariable(endStageModalVm.approvalCompleted);
	
			return $mdDialog.hide();
		}
	
		function finish() {
			var header = {
				teacherId: endStageModalVm.teacherId,
				workplanId: endStageModalVm.workplanId
			};
	
			if (endStageModalVm.inReview && !endStageModalVm.isReviewAndApproval) {
				header.stageId = GlobalConfig.workplanIdStages.review;
				header.isReviewed = GlobalConfig.generals.active;
				header.comments = endStageModalVm.description;
			} else if (endStageModalVm.inApproval) {
				endStageModalVm.toBlocked = getNumOrderCriteria(endStageModalVm.idList);
				header.stageId = GlobalConfig.workplanIdStages.approval;
	
				if (endStageModalVm.toBlocked) {
					endStageModalVm.statusApproval = 0;
				}
	
				header.isApproved = endStageModalVm.statusApproval;
				header.comments = endStageModalVm.description;
				header.criteriaId = endStageModalVm.idList;
	
				if (header.isApproved > 0) {
					header.isApprovedReject = 0;
				} else {
					header.isApprovedReject = 1;
				}
			} else if (endStageModalVm.inReview && endStageModalVm.isReviewAndApproval) {
				header.stageId = GlobalConfig.workplanIdStages.review;
				header.isReviewed = GlobalConfig.generals.active;
				header.comments = endStageModalVm.description;
				endStageModalVm.toBlocked = getNumOrderCriteria(endStageModalVm.idList);
				header.reviewAndApprove = endStageModalVm.isReviewAndApproval;
	
				if (endStageModalVm.toBlocked) {
					endStageModalVm.statusApproval = 0;
				}
	
				header.isApproved = endStageModalVm.statusApproval;
				header.comments = endStageModalVm.description;
				header.criteriaId = endStageModalVm.idList;
	
				if (header.isApproved > 0) {
					header.isApprovedReject = 0;
				} else {
					header.isApprovedReject = 1;
				}
			} else if (endStageModalVm.inReviewExecution) {
				header.stageId = GlobalConfig.workplanIdStages.reviewExecution;
				header.comments = endStageModalVm.description;
	
				if (endStageModalVm.isReviewAndApproval) {
					header.reviewAndApprove = endStageModalVm.isReviewAndApproval;
					header.criteriaId = endStageModalVm.idList;
					getNumOrderCriteria(endStageModalVm.idList);
				}
			} else if (endStageModalVm.inEvaluation) {
				header.stageId = GlobalConfig.workplanIdStages.evaluation;
				header.criteriaId = endStageModalVm.idList;
				header.comments = endStageModalVm.description;
				getNumOrderCriteria(endStageModalVm.idList);
			}
	
			if (endStageModalVm.toBlocked) {
				var header2 = {
					id_teacher: endStageModalVm.teacherId,
					id_work_plan: endStageModalVm.workplanId,
					ds_description: 'Plan de trabajo bloqueado por no aprobación',
					dt_start_date: moment().format('YYYY-MM-DD'),
					id_list_item_situation_type: 2400,
					id_teacher_type: '', // TODO se envia null, dado que no lo tenemos y no lo ocupa en el insert
					id_submodule: '2,3,4,5,6',
					dt_end_date: '',
					id_user: endStageModalVm.currentUser.id
				};
	
				toBlock(header2);
			}
	
			endStage(header);
		}
	
		function endStage(header) {
			WorkPlanSrv.endStages.update(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					if (endStageModalVm.inReview && !endStageModalVm.isReviewAndApproval) {
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.inbox);
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.email);
						$state.go('fullscreen.workPlanReview');
					} else if (endStageModalVm.inApproval) {
						if (endStageModalVm.toBlocked == 0) {
							setApprovedCompletedNotify(endStageModalVm.userId);
							setApprovalNotify(endStageModalVm.userId);
							setApprovalNotifyStrategic(endStageModalVm.userId);
							//setGenerateRolNotify(endStageModalVm.userId,endStageModalVm.teacherId)   
						} else {
							setReprovedCompletedNotify(endStageModalVm.userId);
							setSpecialSituationNotify(endStageModalVm.userId);
						}
	
						$state.go('fullscreen.workPlanApproval');
					} else if (endStageModalVm.inReview && endStageModalVm.isReviewAndApproval) {
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.inbox);
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.email);
	
						if (endStageModalVm.toBlocked == 0) {
							setApprovedCompletedNotify(endStageModalVm.userId);
							setApprovalNotify(endStageModalVm.userId);
							setApprovalNotifyStrategic(endStageModalVm.userId);
						} else {
							setReprovedCompletedNotify(endStageModalVm.userId);
							setSpecialSituationNotify(endStageModalVm.userId);
						}
	
						$state.go('fullscreen.workPlanReview');
					} else if (endStageModalVm.inReviewExecution) {
						if (endStageModalVm.isReviewAndApproval) {
							setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.inbox);
							setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.email);
							showEvaluationModal('fullscreen.workPlanReviewExecution');
						} else {
							$state.go('fullscreen.workPlanReviewExecution');
						}
					} else if (endStageModalVm.inEvaluation) {
						setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.inbox);
						setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.email);
						showEvaluationModal('fullscreen.workPlanEvaluation');
					}
	
					endStageModalVm.approvalCompleted = true;
					endStageModalVm.close();
				}
			}).catch(function (error) {
				var message = error && error.data && error.data.message ? error.data.message : 'No fue posible finalizar la etapa. Revise las condiciones del plan e intente nuevamente.';
				ngNotify.set(message, 'error');
			});
		}
	
		function showEvaluationModal(state) {
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', function showEvaluationModal($scope, $mdDialog) {
					$scope.integralEvaluationURL = endStageModalVm.integralEvaluationURL;
					$scope.close = function () {
						$mdDialog.hide();
						$state.go(state);
					};
				}],
				template: __webpack_require__(826),
				clickOutsideToClose: false
			});
		}
	
		function toBlock(header) {
			WorkPlanSrv.addSpecialSituationTeacher.set(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					console.log('llamada a crear una situacion especial');
				}
			});
		}
	
		function getNumOrderCriteria(criteriaId) {
			var toBlock = 0;
	
			for (var i in endStageModalVm.criteriaList) {
				if (endStageModalVm.criteriaList[i].id_lists_item === criteriaId) {
					endStageModalVm.itemName = endStageModalVm.criteriaList[i].lists_item_name;
	
					if (parseInt(i) === 2) {
						toBlock = 1;
						break;
					}
				}
			}
	
			return toBlock;
		}
	
		// forms validations
		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error';
			}
		}
	
		function showErrorMessages(input) {
			return input.$dirty || input.$touched;
		}
	
		function validateForm(form) {
			return form.$invalid;
		}
	
		function isToReviewed() {
			if (endStageModalVm.inApproval || endStageModalVm.inEvaluation || endStageModalVm.inReviewExecution || endStageModalVm.isReviewAndApproval) {
				return endStageModalVm.toReviewed > 0;
			} else {
				return false;
			}
		}
	
		function isAllReviewed() {
			if (endStageModalVm.inApproval || endStageModalVm.inEvaluation || endStageModalVm.inReviewExecution || endStageModalVm.isReviewAndApproval) {
				return endStageModalVm.toReviewed === 0;
			} else {
				return true;
			}
		}
	
		function isShowOption(value) {
			if (endStageModalVm.inApproval) {
				switch (value) {
	
					case 1:
						return endStageModalVm.count === 0;
					case 2:
						return endStageModalVm.count === 0 || endStageModalVm.allAct === endStageModalVm.count;
					case 3:
						return endStageModalVm.count > 0;
					default:
						return false;
	
				}
			} else {
				return false;
			}
		}
	
		function selectedCriteria() {
			if (endStageModalVm.idList > 0) {
				endStageModalVm.isNotTouchedCriterias = false;
			}
		}
	
		function notifyMainEvaluator(idTeacher, teacherName, notificationType) {
			var data = {
				idTeacher: idTeacher,
				dsName: 'Notificación, revisión finalizada',
				dsDescription: 'Apreciado Evaluador el revisor ' + $cookies.getObject('currentUser').name + ' finalizó la revisión del plan de trabajo del profesor ' + teacherName,
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
	
			GlobalSrv.sendNotificationToMainEvaluator(data);
		}
	
		function setEvaluationNotify(idUser, notificationType) {
			var data = {
				idUser: idUser,
				dsName: 'Notificación, evaluación finalizada',
				dsDescription: 'Profesor: su plan de trabajo ha sido valorado como ' + endStageModalVm.itemName + ' y fueron registrados los siguientes comentarios: ' + endStageModalVm.description,
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
	
			GlobalSrv.sendNotification(data);
		}
	
		function setEvaluationNotifyReviewers(idRole) {
			var reviewers = GlobalSrv.getReviewers(idRole);
	
			reviewers.forEach(function (reviewer) {
				getEvaluationNotify(reviewer);
			});
		}
	
		function getSpecialSituationNotify(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, situación especial',
				dsDescription: ' Profesor, se le ha creado una situación especial. Debe comunicarse con su administrador para activar su plan de trabajo',
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
		}
	
		function getApprovalNotify(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, aprobación finalizada',
				dsDescription: 'Profesor, su plan de trabajo ha sido valorado como ' + endStageModalVm.itemName + ' y fueron registrados los siguientes comentarios: ' + endStageModalVm.description + '. Realice los ajustes correspondientes en la ejecución.',
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
		}
	
		function getReprovedNotify(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, aprobación finalizada',
				dsDescription: 'Profesor: su plan de trabajo ha sido valorado como Reprobado y fueron registrados los siguientes comentarios: ' + endStageModalVm.description,
				idNotification_delivery_type: notificationType,
				is_grouped: 0
			};
		}
	
		function setApprovedCompletedNotify(idUser) {
			GlobalSrv.sendNotification(getApprovalNotify(idUser, GlobalConfig.notificationType.inbox));
			GlobalSrv.sendNotification(getApprovalNotify(idUser, GlobalConfig.notificationType.email));
		}
	
		function setSpecialSituationNotify(idUser) {
			GlobalSrv.sendNotification(getSpecialSituationNotify(idUser, GlobalConfig.notificationType.inbox));
			GlobalSrv.sendNotification(getSpecialSituationNotify(idUser, GlobalConfig.notificationType.email));
		}
	
		function setReprovedCompletedNotify(idUser) {
			GlobalSrv.sendNotification(getReprovedNotify(idUser, GlobalConfig.notificationType.inbox));
			GlobalSrv.sendNotification(getReprovedNotify(idUser, GlobalConfig.notificationType.email));
		}
	
		function setApprovalNotifyStrategic(idUser) {
			GlobalSrv.sendNotificationToReviewers(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.inbox));
			GlobalSrv.sendNotificationToReviewers(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.email));
		}
	
		function setGenerateRolNotify(idUser, idTeacher) {
			WorkPlanSrv.listUserNotify.set({ id_user: idTeacher }).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					var idUsers = [];
	
					for (var i in dataReturn.data) {
						idUsers.push(dataReturn.data[i].id_user);
					}
					idUsers.push(idUser);
					GlobalSrv.sendNotificationToReviewers(getGenerateRolNotify(idUsers, GlobalConfig.notificationType.inbox));
					GlobalSrv.sendNotificationToReviewers(getGenerateRolNotify(idUsers, GlobalConfig.notificationType.email));
					GlobalSrv.sendNotification(getGenerateRolNotify(idUsers, GlobalConfig.notificationType.inbox));
				}
			});
		}
	
		function getApprovalNotifyCount(idUser) {
			return {
				idUser: idUser,
				dsName: 'Notificación, aprobación finalizada (actividades reprobadas)',
				dsDescription: 'Profesor: Su plan de trabajo cuenta con actividades no aprobadas por su jefe',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped: 1
			};
		}
	
		function getApprovalNotifyStrategic(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, aprobación finalizada (actividades seguimiento estratégico)',
				dsDescription: 'Algunas actividades del plan de trabajo del profesor ' + sharedVar.teacherName + ' se han enviado al módulo de seguimiento estratégico',
				idNotification_delivery_type: notificationType,
				is_grouped: 1
			};
		}
	
		function getGenerateRolNotify(idUser, notificationType) {
			return {
				idUser: idUser,
				dsName: 'Notificación, creación de Rol.',
				dsDescription: 'El profesor ' + sharedVar.teacherName + ' ha creado un rol durante la planeacion de su plan de trabajo.',
				idNotification_delivery_type: notificationType,
				is_grouped: 1
			};
		}
	
		function setApprovalNotify(idUser) {
			if (endStageModalVm.inApproval && endStageModalVm.count > 0) {
				GlobalSrv.sendNotification(getApprovalNotifyCount(idUser));
			}
	
			if (endStageModalVm.inApproval && endStageModalVm.strategic > 0) {
				GlobalSrv.sendNotification(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.inbox));
				GlobalSrv.sendNotification(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.email));
			}
		}
	};
	
	exports.default = EndStageModalCtrl;
	
	
	EndStageModalCtrl.$inject = ['$scope', '$state', '$http', '$resource', '$filter', 'ngNotify', '$mdDialog', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', 'Validations', 'WorkPlanParametrizationSrv', 'GlobalSrv', '$cookies', '$stateParams', 'ReviewSrv'];

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div> <div class=\"col-md-12 text-center\"> <h4> Gracias por finalizar la evaluación del plan de trabajo. Si aún no lo ha hecho, le invitamos a diligenciar la encuesta de evaluación integral por parte del jefe inmediato que encontrará en el sistema <a href={{integralEvaluationURL}} target=_blank>Deja tu Huella.</a> </h4> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close()> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ViewFileCtrl = function ViewFileCtrl($scope, $mdDialog, WorkPlanModalSrv) {
	  _classCallCheck(this, ViewFileCtrl);
	
	  // constants
	  var url = WorkPlanModalSrv.getVariable();
	
	  $scope.url = '';
	
	  $scope.close = close;
	
	  activate();
	
	  function activate() {
	    $scope.url = url;
	  }
	
	  function close() {
	    return $mdDialog.hide();
	  }
	};
	
	exports.default = ViewFileCtrl;
	
	
	ViewFileCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanModalSrv'];

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FeedbackReviewedModalCtrl = function FeedbackReviewedModalCtrl($scope, $cookies, $mdDialog, WorkPlanModalSrv, WorkPlanSrv, GlobalSrv, GlobalConfig, ngNotify) {
	  _classCallCheck(this, FeedbackReviewedModalCtrl);
	
	  var vm = this;
	  var sharedVar = WorkPlanModalSrv.getVariable();
	
	  // Variables declaradas
	  vm.comment = '';
	
	  // methods
	  $scope.close = close;
	  $scope.feedback = feedback;
	  $scope.toggleSubcategories = toggleSubcategories;
	
	  activate();
	
	  function close() {
	    return $mdDialog.hide();
	  }
	
	  function activate() {
	    $scope.activities = sharedVar.data;
	  }
	
	  function getNotify(notificationId, comment) {
	    var description = 'Profesor: su plan de trabajo requiere ajustes. Por favor modifique su plan de acuerdo a las observaciones del revisor: ';
	    description = description + comment;
	    var data = {
	      idUser: sharedVar.userId,
	      dsName: 'Notificación, retroalimentar plan de trabajo',
	      dsDescription: description,
	      idNotification_delivery_type: notificationId,
	      is_grouped: 0
	    };
	
	    GlobalSrv.sendNotification(data);
	  }
	
	  function feedback(comment) {
	    var post = {
	      teacherId: sharedVar.teacherId,
	      workplanId: sharedVar.workplanId,
	      comment: comment
	    };
	    WorkPlanSrv.updateFeedbackActivate.update(post).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        getNotify(GlobalConfig.notificationType.email, comment);
	        getNotify(GlobalConfig.notificationType.inbox, comment);
	        showModalSuccess();
	      }
	    }, function (data) {
	      var message = data && data.data && data.data.message ? data.data.message : 'No fue posible registrar la retroalimentación. Revise las condiciones del plan.';
	      ngNotify.set(message, 'error');
	    });
	    return $mdDialog.hide();
	  }
	
	  function showModalSuccess() {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function showModalSuccess($scope, $mdDialog) {
	        $scope.name = sharedVar.teacherName;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(829),
	      clickOutsideToClose: false
	    });
	  }
	
	  function toggleSubcategories(module) {
	    if (module.showChilds) {
	      module.showChilds = false;
	    } else {
	      module.showChilds = true;
	    }
	  }
	};
	
	exports.default = FeedbackReviewedModalCtrl;
	
	
	FeedbackReviewedModalCtrl.$inject = ['$scope', '$cookies', '$mdDialog', 'WorkPlanModalSrv', 'WorkPlanSrv', 'GlobalSrv', 'GlobalConfig', 'ngNotify'];

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=ctrlModal.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h3 class=text-verde>¡Retroalimentación satisfactoria!</h3> <p class=m-t-md>El plan de trabajo de {{name}} se ha activado con éxito.</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-success\" ng-click=close() ui-sref=fullscreen.workPlanReview> Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-faculty
	* @autor daniel.molina@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: customChartController
	* # alias: custCtrl
	*/
	
	var customChartController = function () {
	    function customChartController($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, ReviewSrv, integralEvaluationSrv, $cookies) {
	        var _this = this;
	
	        _classCallCheck(this, customChartController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.ngNotify = ngNotify;
	        this.$stateParams = $stateParams;
	        this.ReviewSrv = ReviewSrv;
	        this.integralEvaluationSrv = integralEvaluationSrv;
	        this.userinfo = null;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	
	        this.teacherId = this.$stateParams.teacherId;
	        this.workplanId = this.$stateParams.workplanId;
	        this.optionList = {};
	        this.optionListClean = {};
	        // this.period=0
	        // this.level=0
	        // this.unit=0
	
	
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false;
	                _this.userinfo = details.user;
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(customChartController, [{
	        key: 'mostrar',
	        value: function mostrar() {
	
	            var period = this.period;
	            var level = this.level;
	            var unit = this.unit;
	            this.main();
	        }
	    }, {
	        key: 'reiniciar',
	        value: function reiniciar() {
	            delete this.period;
	            delete this.level;
	            delete this.unit;
	            this.main();
	        }
	    }, {
	        key: 'optionsList',
	        value: function optionsList() {
	
	            var THIS = this;
	            var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId };
	            this.ReviewSrv.getGraphSelectionListMethod.get(param).$promise.then(function (dataReturn) {
	                THIS.optionList = dataReturn.data;
	                THIS.optionListClean = dataReturn.data;
	            }, function (data) {
	                console.log('error', data);
	            });
	        }
	    }, {
	        key: 'main',
	        value: function main() {
	            console.log('Estoy en el controlador de customChartController');
	
	            var THIS = this;
	            var param = { teacherId: this.teacherId,
	                workplanId: this.workplanId,
	                idPeriod: this.period,
	                idLevel: this.level,
	                idUnit: this.unit
	            };
	
	            this.optionsList();
	
	            this.graphs = [];
	            this.subjectIncrementCode = 0;
	
	            this.integralEvaluationSrv.getGraphicAsignature.getGraphic(param).$promise.then(function (dataReturn) {
	
	                if (dataReturn.data.length < 0) {
	                    THIS.graph = [];
	                } else {
	                    THIS.graph = dataReturn.data;
	                    THIS.subjectIncrementCode = dataReturn.data[0].id_code;
	                    THIS.barGraphId = dataReturn.data[0].groups[0].quantitative[0].dim[0].id;
	                    THIS.$timeout(function () {
	                        THIS.drawGraph(THIS.graph);
	                    }, 1000);
	                }
	            }, function (data) {
	                console.log('error', data);
	            });
	        }
	    }, {
	        key: 'drawGraph',
	        value: function drawGraph(graph) {
	
	            this.chartConfig = {};
	
	            for (var i in graph) {
	                for (var i1 in graph[i].groups) {
	                    for (var j1 in graph[i].groups[i1].quantitative[0].dim) {
	                        for (var j in graph[i].groups[i1].quantitative[0].dim[j1].analysis) {
	
	                            var chartVar = {
	                                chart: {
	                                    plotBackgroundColor: null,
	                                    plotBorderWidth: null,
	                                    plotShadow: false,
	                                    type: 'pie'
	                                },
	                                title: {
	                                    text: ''
	                                },
	                                credits: {
	                                    enabled: false
	                                },
	                                exporting: {
	                                    enabled: false
	                                },
	                                tooltip: {
	                                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
	                                },
	                                plotOptions: {
	                                    pie: {
	                                        allowPointSelect: true,
	                                        cursor: 'pointer',
	                                        dataLabels: {
	                                            enabled: false,
	                                            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
	                                            style: {
	                                                color: Highcharts.theme && Highcharts.theme.contrastTextColor || 'black'
	                                            }
	                                        }
	                                    }
	                                },
	                                series: [{
	                                    name: 'Brands',
	                                    colorByPoint: true,
	                                    data: graph[i].groups[i1].quantitative[0].dim[j1].analysis[j].barGraph
	                                }]
	                            };
	
	                            Highcharts.chart('resultados' + graph[i].groups[i1].quantitative[0].dim[j1].analysis[j].highChart + 'Chart', chartVar);
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'autoevaluation',
	        value: function autoevaluation() {
	            var _this2 = this;
	
	            this.ReviewSrv.getAutoevaluation.Autoevaluation().$promise.then(function (dataReturn) {
	                if (dataReturn.status === true) {
	                    _this2.reflection = dataReturn.data.reflection;
	                } else {
	                    console.log(dataReturn);
	                }
	            });
	        }
	    }]);
	
	    return customChartController;
	}();
	
	exports.default = customChartController;
	
	
	customChartController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'ReviewSrv', 'integralEvaluationSrv', '$cookies'];

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var reflexionesDePortafolioEvidenciasController = function reflexionesDePortafolioEvidenciasController($scope, $http, $mdDialog, locals, $timeout) {
	  _classCallCheck(this, reflexionesDePortafolioEvidenciasController);
	
	  var reflexionesDePortafolioEvidencias = this;
	
	  // $timeout( function(){
	  $scope.data = locals.videoLinks;
	  // }, 1000 );
	
	
	  reflexionesDePortafolioEvidencias.close = close;
	
	  function close() {
	    $mdDialog.hide();
	  }
	};
	
	exports.default = reflexionesDePortafolioEvidenciasController;
	
	
	reflexionesDePortafolioEvidenciasController.$inject = ['$scope', '$http', '$mdDialog', 'locals', '$timeout'];

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SuccessDialogCtrl = function SuccessDialogCtrl($scope, WorkPlanModalSrv, $mdDialog, $state, GlobalConfig) {
	  _classCallCheck(this, SuccessDialogCtrl);
	
	  var ctrlModalVM = this;
	  var texts = GlobalConfig.appTexts;
	  var shared = WorkPlanModalSrv.getVariableSuccessDialog();
	  ctrlModalVM.nameModal = shared.nameModal;
	  ctrlModalVM.itemName = shared.itemName;
	  ctrlModalVM.createOrEdit = shared.createOrEdit;
	  ctrlModalVM.textCreateOrEdit = shared.textCreateOrEdit;
	  ctrlModalVM.modalType = shared.modalType;
	
	  ctrlModalVM.close = close;
	
	  function close() {
	    //compare for Investigation submodule
	    if (isProduct(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionInvestigation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.products');
	      }
	    } else if (isProject(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionInvestigation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.projects');
	      }
	    } else if (isCollaborationSpace(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionInvestigation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.collaborationSpaces');
	      }
	    } else if (isProjectFormulation(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionInvestigation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.investigation');
	      }
	    } else if (isResultsTransfer(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionInvestigation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.resultsTransfer');
	      }
	    } else if (isTrainingResearch(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionInvestigation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.trainingResearch');
	      }
	      //compare for Extension submodule
	    } else if (isProjectFormulationExt(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionExtension') {
	        $state.reload();
	      } else {
	        $state.go('workplan.projectProposalFormulation');
	      }
	    } else if (isCounselingConsultancy(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionExtension') {
	        $state.reload();
	      } else {
	        $state.go('workplan.counselingAndConsultancy');
	      }
	    } else if (isShortCourses(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionExtension') {
	        $state.reload();
	      } else {
	        $state.go('workplan.shortCourses');
	      }
	    } else if (isExtensionProject(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionExtension') {
	        $state.reload();
	      } else {
	        $state.go('workplan.extensionProjects');
	      }
	    } else if (isVisibility(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionExtension') {
	        $state.reload();
	      } else {
	        $state.go('workplan.visibilityAndComunication');
	      }
	      //compare for Consolidation CP submodule
	    } else if (isDoctoralFormation(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionConsolidation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.doctoralFormation');
	      }
	    } else if (isLearningCommunitie(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionConsolidation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.learningAndPracticeCommunities');
	      }
	    } else if (isTeachingDev(ctrlModalVM.modalType)) {
	      if ($state.current.name == 'workplan.executionConsolidation') {
	        $state.reload();
	      } else {
	        $state.go('workplan.teachingDevelopment');
	      }
	      //compare for Academic Management submodule
	    } else if (isComiteeParticipation(ctrlModalVM.modalType)) {
	      if ($state.current.name === 'workplan.createParticipation') {
	        $state.go('workplan.committeeParticipation');
	      } else {
	        $state.reload();
	      }
	    } else if (isRolAcademicManagement(ctrlModalVM.modalType)) {
	      if ($state.current.name === 'workplan.createRole') {
	        $state.go('workplan.roles');
	      } else {
	        $state.reload();
	      }
	      //compare for Teaching submodule
	    } else if (isTeachingSubject(ctrlModalVM.modalType)) {
	      $state.go('workplan.teachingSubjects');
	    }
	
	    return $mdDialog.hide();
	  }
	
	  //comparefunctions
	  //comparefunctions for investigation
	  function isProduct(value) {
	    return value == texts.modalTypeId.product;
	  }
	  function isProject(value) {
	    return value == texts.modalTypeId.project;
	  }
	  function isCollaborationSpace(value) {
	    return value == texts.modalTypeId.collaborationSpace;
	  }
	  function isProjectFormulation(value) {
	    return value == texts.modalTypeId.projectFormulation;
	  }
	  function isResultsTransfer(value) {
	    return value == texts.modalTypeId.resultsTransfer;
	  }
	  function isTrainingResearch(value) {
	    return value == texts.modalTypeId.trainingResearch;
	  }
	  //comparefunctions for extension
	  function isProjectFormulationExt(value) {
	    return value == texts.modalTypeId.projectFormulationExt;
	  }
	  function isCounselingConsultancy(value) {
	    return value == texts.modalTypeId.counselingConsultancy;
	  }
	  function isShortCourses(value) {
	    return value == texts.modalTypeId.shortCourses;
	  }
	  function isExtensionProject(value) {
	    return value == texts.modalTypeId.extensionProject;
	  }
	  function isVisibility(value) {
	    return value == texts.modalTypeId.visibility;
	  }
	  //comparefunctions for consolidation CP
	  function isDoctoralFormation(value) {
	    return value == texts.modalTypeId.doctoralFormation;
	  }
	  function isLearningCommunitie(value) {
	    return value == texts.modalTypeId.learningComunity;
	  }
	  function isTeachingDev(value) {
	    return value == texts.modalTypeId.teachingDev;
	  }
	  //comparefunctions for academic management
	  function isComiteeParticipation(value) {
	    return value == texts.modalTypeId.comiteeParticipation;
	  }
	  function isRolAcademicManagement(value) {
	    return value == texts.modalTypeId.roleAcademicManagement;
	  }
	  //comparefunctions for teaching    
	  function isTeachingSubject(value) {
	    return value == texts.modalTypeId.teachingSubject;
	  }
	};
	
	exports.default = SuccessDialogCtrl;
	
	
	SuccessDialogCtrl.$inject = ['$scope', 'WorkPlanModalSrv', '$mdDialog', '$state', 'GlobalConfig'];

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReviewSrv = function ReviewSrv($resource, SERVICE_URL_CONSTANT, GlobalConfig) {
		var _$resource, _$resource2;
	
		_classCallCheck(this, ReviewSrv);
	
		var URL = SERVICE_URL_CONSTANT;
		var modules = {};
	
		Object.keys(GlobalConfig.modules).forEach(function (key) {
			modules[key] = key;
		});
	
		// MAIN SERVICES
		var getReviewListData = $resource(URL.rosario + '/activity/:route', {}, (_$resource = {}, _defineProperty(_$resource, modules.teaching, {
			method: 'POST',
			params: {
				route: 'getActivitiesPlanning'
			}
		}), _defineProperty(_$resource, modules.academicManagement, {
			method: 'POST',
			params: {
				route: 'getActivityPlanningAcademic'
			}
		}), _defineProperty(_$resource, modules.consolidation, {
			method: 'POST',
			params: {
				route: 'getActivitiesTeachingStaff'
			}
		}), _defineProperty(_$resource, modules.investigation, {
			method: 'POST',
			params: {
				route: 'getActivitiesResearch'
			}
		}), _defineProperty(_$resource, modules.extentionAndVisibility, {
			method: 'POST',
			params: {
				route: 'getActivitiesExtension'
			}
		}), _$resource));
	
		var getAutoevaluation = $resource(URL.rosario + '/asignature/:route', {}, {
			Autoevaluation: {
				method: 'GET',
				params: {
					route: 'getAutoevaluation'
				}
			}
		});
	
		var getReviewDetails = $resource(URL.rosario + '/activity/:route', {}, (_$resource2 = {}, _defineProperty(_$resource2, modules.teaching, {
			method: 'POST',
			params: {
				route: 'getActivitiesDetail'
			}
		}), _defineProperty(_$resource2, modules.academicManagement, {
			method: 'POST',
			params: {
				route: 'getActivityDetailAcademic'
			}
		}), _defineProperty(_$resource2, modules.consolidation, {
			method: 'POST',
			params: {
				route: 'getActivityDetailTeachingStaff'
			}
		}), _defineProperty(_$resource2, modules.investigation, {
			method: 'POST',
			params: {
				route: 'getActivityDetailResearch'
			}
		}), _defineProperty(_$resource2, modules.extentionAndVisibility, {
			method: 'POST',
			params: {
				route: 'getActivityDetailExtension'
			}
		}), _$resource2));
	
		// GENERIC SERVICES
		var getTeacherWorkplans = $resource(URL.rosario + '/teacher/getAllWokplanByTeacher', {}, {
			request: {
				method: 'POST'
			}
		});
	
		var getAllWorkplanList = $resource(URL.rosario + '/reviewer/getAllWorkplanList', {}, {
			post: {
				method: 'POST'
			}
		});
	
		/* var setHands = $resource(URL.rosario + '/activity/:route', {}, {
	     review: {
	       method: 'POST',
	       params: {
	         route: 'setApprovedReviewed'
	       }
	     },
	     approval: {
	       method: 'POST',
	       params: {
	         route: 'setApprovedExecution'
	       }
	     },
	     reviewExecution: {
	       method: 'POST',
	       params: {
	         route: 'setReviewedExecution'
	       }
	     },
	     evaluation: {
	       method: 'POST',
	       params: {
	         route: 'setAcceptActivity'
	       }
	     },
	   }) */
	
		var setReview = $resource(URL.rosario + '/activity/setApprovedReviewed', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var setApprove = $resource(URL.rosario + '/activity/setApprovedExecution', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var setAccept = $resource(URL.rosario + '/activity/setAcceptActivity', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var setReviewedExecution = $resource(URL.rosario + '/activity/setReviewedExecution', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var setStrategicTracing = $resource(URL.rosario + '/activity/setStrategicTracingActivity', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var addActivityExecution = $resource(URL.rosario + '/activity/addActivityExecution', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var setExecution = $resource(URL.rosario + '/activity/setExecution', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getExecutionEntries = $resource(URL.rosario + '/activity/getActivitiesEntries', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getDataFormActivityTeaching = $resource(URL.rosario + '/activity/getDataFormActivityTeaching', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var editExecution = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/editExecution', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getSubmodulesByRole = $resource(SERVICE_URL_CONSTANT.rosario + '/role/getSubmodulesByRole', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getPendingActivitiesBySubmodule = $resource(URL.rosario + '/activity/getPendingActivitiesBySubmodule', {}, {
			post: {
				method: 'POST'
			}
		});
	
		// LIST PANEL SERVICES
		var getPanelWorkplans = $resource(URL.rosario + '/reviewer/getWorkplanByEvaluatorAndStage', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getWorkplanIndicators = $resource(URL.rosario + '/reviewer/getWorkplanIndicatorsByEvaluatorAndStage', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getWorkplanReviewIndicatorByEvaluatorAndIndicatorType = $resource(URL.rosario + '/reviewer/getWorkplanReviewIndicatorByEvaluatorAndIndicatorType', {}, {
			post: {
				method: 'POST'
			}
		});
	
		var getFinishedWorkplanIndicator = $resource(URL.rosario + '/reviewer/getFinishedWorkplanIndicatorByEvaluatorAndStage', {}, {
			post: {
				method: 'POST'
			}
		});
	
		//EVALUATION
		var getWorkplanForEvaluationByIndicator = $resource(URL.rosario + '/reviewer/getWorkplanForEvaluationByIndicator', {}, {
			post: {
				method: 'POST'
			}
		});
		var getIndicatorsForWorkplanEvaluationByIndicator = $resource(URL.rosario + '/reviewer/getIndicatorsForWorkplanEvaluationByIndicator', {}, {
			post: {
				method: 'POST'
			}
		});
	
		// TEACHING SERVICES
		var getReviewData = $resource(URL.rosario + '/activity/getActivitiesPlanning', {}, {
			request: {
				method: 'POST'
			}
		});
	
		var getActivityDetails = $resource(URL.rosario + '/activity/getActivitiesDetail', {}, {
			request: {
				method: 'POST'
			}
		});
	
		// ACADEMIC MANAGEMENT SERVICES
		var getAcademicManagmentData = $resource(URL.rosario + '/activity/getActivityPlanningAcademic', {}, {
			request: {
				method: 'POST'
			}
		});
	
		var getAcademicManagmentActivityDetails = $resource(URL.rosario + '/activity/getActivityDetailAcademic', {}, {
			request: {
				method: 'POST'
			}
		});
	
		var setactivityTag = $resource(URL.rosario + '/activity/setactivityTag', {}, {
			set: {
				method: 'POST'
			}
		});
	
		var getWorkPlanGeneralDetail = $resource(URL.rosario + '/general/getWorkPlanGeneralDetail', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getActivitiesNotExecutionByTeacher = $resource(URL.rosario + '/teacher/getActivitiesNotExecutionByTeacher', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getActNotExecutionByTeacher = $resource(URL.rosario + '/teacher/getActNotExecutionByTeacher', {}, {
			get: {
				method: 'POST'
			}
		});
	
		var getTeachershistoricalWorkplan = $resource(URL.rosario + '/general/getTeachershistoricalWorkplan', {}, {
			get: {
				method: 'GET'
			}
		});
	
		// INVESTIGATION SERVICES
	
		var addCustomActivity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/:route', {}, {
			product: {
				method: 'POST',
				params: {
					route: 'addActivityProduct'
				}
			},
			project: {
				method: 'POST',
				params: {
					route: 'addActivityProject'
				}
			},
			extensionProject: {
				method: 'POST',
				params: {
					route: 'addActivityProjectExtension'
				}
			},
			updateAssignaturestatus: {
				method: 'POST',
				params: {
					route: 'updateAssignaturestatus'
				}
			}
		});
	
		var getReflectionMethod = $resource(URL.rosario + '/asignature/getReflection', {}, {
			get: {
				method: 'GET'
			}
		});
	
		var getGraphSelectionListMethod = $resource(URL.rosario + '/asignature/getGraphSelectionList', {}, {
			get: {
				method: 'GET'
			}
		});
	
		// SERVICES INJECTION
		return {
			getReviewListData: getReviewListData,
			getReviewDetails: getReviewDetails,
			// GENERIC
			getTeacherWorkplans: getTeacherWorkplans,
			getAllWorkplanList: getAllWorkplanList,
			setReview: setReview,
			setApprove: setApprove,
			setAccept: setAccept,
			setExecution: setExecution,
			setReviewedExecution: setReviewedExecution,
			setStrategicTracing: setStrategicTracing,
			editExecution: editExecution,
			getActivitiesNotExecutionByTeacher: getActivitiesNotExecutionByTeacher,
			getActNotExecutionByTeacher: getActNotExecutionByTeacher,
			// MODALS
			addActivityExecution: addActivityExecution,
			getExecutionEntries: getExecutionEntries,
			getDataFormActivityTeaching: getDataFormActivityTeaching,
			// LIST PANEL
			getPanelWorkplans: getPanelWorkplans,
			// INDICATORS PANEL
			getWorkplanIndicators: getWorkplanIndicators,
			getFinishedWorkplanIndicator: getFinishedWorkplanIndicator,
			getWorkplanReviewIndicatorByEvaluatorAndIndicatorType: getWorkplanReviewIndicatorByEvaluatorAndIndicatorType,
			// EVALUATION
			getWorkplanForEvaluationByIndicator: getWorkplanForEvaluationByIndicator,
			getIndicatorsForWorkplanEvaluationByIndicator: getIndicatorsForWorkplanEvaluationByIndicator,
			// TEACHING
			getReviewData: getReviewData,
			getActivityDetails: getActivityDetails,
			// ACADEMIC MANAGEMENT
			getAcademicManagmentData: getAcademicManagmentData,
			getAcademicManagmentActivityDetails: getAcademicManagmentActivityDetails,
			setactivityTag: setactivityTag,
			getWorkPlanGeneralDetail: getWorkPlanGeneralDetail,
			// INVESTIGATION
			addCustomActivity: addCustomActivity,
			getSubmodulesByRole: getSubmodulesByRole,
			getPendingActivitiesBySubmodule: getPendingActivitiesBySubmodule,
			//AUTOEVALUACION INTEGRAL
			getAutoevaluation: getAutoevaluation,
			getReflectionMethod: getReflectionMethod,
			getGraphSelectionListMethod: getGraphSelectionListMethod,
			getTeachershistoricalWorkplan: getTeachershistoricalWorkplan
		};
	};
	
	ReviewSrv.$inject = ['$resource', 'SERVICE_URL_CONSTANT', 'GlobalConfig'];
	exports.default = angular.module('services.ReviewSrv', []).service('ReviewSrv', ReviewSrv).name;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var executionController = function () {
	   function executionController($scope, $rootScope, WorkPlanSrv, $mdDialog, GlobalConfig, $cookies, $sessionStorage) {
	      var _this = this;
	
	      _classCallCheck(this, executionController);
	
	      this.WorkPlanSrv = WorkPlanSrv;
	      this.$mdDialog = $mdDialog;
	      $rootScope.fullscreenClass = 'background-planning';
	      this.messagesList = [];
	      this.routes = GlobalConfig.modulesRoutes;
	      this.currentUser = JSON.parse($cookies.get('currentUser'));
	      this.userId = this.currentUser.id;
	      //this.workPlanGeneralList = $sessionStorage.workPlanGeneralList
	      this.$sessionStorage = $sessionStorage;
	
	      this.assignStyles = function () {
	         switch (_this.timeline) {
	            case 1:
	               _this.classCircleGreen1 = 'green';
	               break;
	            case 2:
	               _this.classCircleGreen1 = 'green';
	               _this.classBarGreen1 = 'green';
	               break;
	            case 3:
	               _this.classCircleGreen1 = 'green';
	               _this.classCircleGreen2 = 'green';
	               _this.classBarGreen1 = 'green';
	               break;
	            case 4:
	               _this.classCircleGreen1 = 'green';
	               _this.classCircleGreen2 = 'green';
	               _this.classCircleGreen3 = 'green';
	               _this.classBarGreen1 = 'green';
	               _this.classBarGreen2 = 'green';
	               break;
	            case 5:
	               _this.classCircleGreen1 = 'green';
	               _this.classCircleGreen2 = 'green';
	               _this.classCircleGreen3 = 'green';
	               _this.classBarGreen1 = 'green';
	               _this.classBarGreen2 = 'green';
	               _this.classBarGreen3 = ' green';
	               break;
	            case 6:
	               _this.classCircleGreen1 = 'green';
	               _this.classCircleGreen2 = 'green';
	               _this.classCircleGreen3 = 'green';
	               _this.classCircleGreen4 = 'green';
	               _this.classBarGreen1 = 'green';
	               _this.classBarGreen2 = 'green';
	               _this.classBarGreen3 = 'green';
	               break;
	            case 7:
	               _this.classCircleGreen1 = 'green';
	               _this.classCircleGreen2 = 'green';
	               _this.classCircleGreen3 = 'green';
	               _this.classCircleGreen4 = 'green';
	               _this.classBarGreen1 = 'green';
	               _this.classBarGreen2 = 'green';
	               _this.classBarGreen3 = 'green';
	               break;
	            default:
	         }
	      };
	      this.activate();
	   }
	
	   _createClass(executionController, [{
	      key: 'activate',
	      value: function activate() {
	         this.getElements();
	      }
	   }, {
	      key: 'getElements',
	      value: function getElements() {
	         var _this2 = this;
	
	         //if(this.workPlanGeneralList == undefined){
	         this.WorkPlanSrv.getElementsRightBar.getList({ teacherId: this.currentUser.teacherId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status == true) {
	               //this.$sessionStorage.workPlanGeneralList = dataReturn.data
	               _this2.RightBar = dataReturn.data;
	               _this2.percentage = _this2.RightBar.asignaturesPlaned[0].percentage;
	               _this2.timeline = parseInt(_this2.RightBar.timeline[0].stageId);
	               for (var i = _this2.RightBar.asignaturesPlaned.length - 1; i >= 0; i--) {
	                  if (_this2.RightBar.asignaturesPlaned[i].submoduleId == _this2.routes[i].id) {
	                     _this2.RightBar.asignaturesPlaned[i].route = _this2.routes[i].route;
	                  }
	               }
	            }
	            _this2.assignStyles();
	         });
	         /*}else{
	            this.RightBar = this.workPlanGeneralList
	            this.percentage = this.RightBar.asignaturesPlaned[0].percentage
	            this.timeline = parseInt(this.RightBar.timeline[0].stageId)
	            for (var i = this.RightBar.asignaturesPlaned.length - 1; i >= 0; i--) {
	               if(this.RightBar.asignaturesPlaned[i].submoduleId == this.routes[i].id){  
	                  this.RightBar.asignaturesPlaned[i].route = this.routes[i].route
	               }
	            }
	         }*/
	         this.getMessages();
	      }
	   }, {
	      key: 'getMessages',
	      value: function getMessages() {
	         var _this3 = this;
	
	         this.WorkPlanSrv.getMessagesNotification.get({ userId: this.userId }).$promise.then(function (dataReturn) {
	            if (dataReturn.status === true) {
	               _this3.messagesList = dataReturn.data;
	            } else {
	               _this3.messagesList = [];
	            }
	         });
	      }
	   }, {
	      key: 'showModalMessages',
	      value: function showModalMessages() {
	         var userId = this.userId;
	         var messagesList = this.messagesList;
	         this.$mdDialog.show({
	            controller: ['$scope', '$mdDialog', 'WorkPlanSrv', function showModalMessages($scope, $mdDialog, WorkPlanSrv) {
	               var modalMessagesVm = this;
	
	               // declaracion de variables
	               modalMessagesVm.userId = userId;
	               modalMessagesVm.messagesList = messagesList;
	               modalMessagesVm.class1 = 'mdi-hardware-keyboard-arrow-down';
	               modalMessagesVm.class2 = 'mdi-hardware-keyboard-arrow-up';
	               modalMessagesVm.classRead = 'mdi-content-drafts';
	               modalMessagesVm.classUnRead = 'mdi-content-mail';
	
	               // declaracion de funciones
	               modalMessagesVm.showMessage = showMessage;
	               modalMessagesVm.close = close;
	
	               function showMessage(pos) {
	                  if (modalMessagesVm.messagesList[pos].isHiden) {
	                     modalMessagesVm.messagesList[pos].isHiden = false;
	                  } else {
	                     modalMessagesVm.messagesList[pos].isHiden = true;
	                  }
	               }
	
	               function updateReadMessage() {
	                  WorkPlanSrv.updateReadingMessages.update({ userId: modalMessagesVm.userId }).$promise.then(function (dataReturn) {
	                     if (dataReturn.status) {
	                        for (var i = modalMessagesVm.messagesList.length - 1; i >= 0; i--) {
	                           modalMessagesVm.messagesList[i].isRead = 1;
	                        }
	                     } else {
	                        console.log('error de comunicacion con el servidor');
	                     }
	                  }, function (data) {
	                     console.log(data);
	                  });
	               }
	
	               function close() {
	                  $mdDialog.hide();
	               }
	            }],
	            template: __webpack_require__(835),
	            controllerAs: 'modalMessagesVm',
	            clickOutsideToClose: false
	         });
	      }
	   }]);
	
	   return executionController;
	}();
	
	exports.default = executionController;
	
	executionController.$inject = ['$scope', '$rootScope', 'WorkPlanSrv', '$mdDialog', 'GlobalConfig', '$cookies', '$sessionStorage'];

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog style=width:560px> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=modalMessagesVm.close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row text-center\"> <div class=col-md-12> <h4 class=\"text-azul font-bold text-md\">Mensajes </h4></div> <div ng-repeat=\"message in modalMessagesVm.messagesList\"> <div class=\"col-md-12 p-v-xs no-padding-h b-b-gris-light\"> <h5 class=\"text-negro font-bold col-md-8 font-test\">{{message.title}}</h5> <div class=col-md-2 ng-if=\"message.isRead == 1\"> <span ng-class=modalMessagesVm.classRead class=\"icon i-28 text-gris-dark pointer text-right\" ng-click=modalMessagesVm.showMessage($index)></span> </div> <div class=col-md-2 ng-if=\"!(message.isRead == 1)\"> <span ng-class=modalMessagesVm.classUnRead class=\"icon i-28 text-gris-dark pointer text-right\" ng-click=modalMessagesVm.showMessage($index)></span> </div> <div class=col-md-2 ng-if=message.isHiden> <span ng-class=modalMessagesVm.class1 class=\"icon i-28 text-gris-dark pointer text-left\" ng-click=modalMessagesVm.showMessage($index)></span> </div> <div class=col-md-2 ng-if=!message.isHiden> <span ng-class=modalMessagesVm.class2 class=\"icon i-28 text-gris-dark pointer text-left\" ng-click=modalMessagesVm.showMessage($index)></span> </div> <div class=col-md-12 ng-if=!message.isHiden> <div class=\"col-md-9 no-padding font-test text-gris-dark text-xs\"> <div ng-bind-html=message.body></div> </div> </div> </div> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SummaryCtrl = function SummaryCtrl($scope, WorkPlanModalSrv, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, uiGridTreeViewConstants, $http, $window, $cookies, Validations, WorkPlanSrv, GlobalConfig, ReviewSrv, ngNotify, $state, LOCAL_ENV_CONSTANT) {
		_classCallCheck(this, SummaryCtrl);
	
		// CONSTANTS
	
		var summaryVm = this;
		var currentStage = $stateParams.stage;
		var user = JSON.parse($cookies.get('currentUser'));
		var roleId = +$cookies.get('hasRoleId');
		var stages = GlobalConfig.workplanStagesNames;
	
		var inApproval = Validations.inApproval(currentStage);
		var inEvaluation = Validations.inEvaluation(currentStage);
		var inReviewExecution = Validations.inReviewExecution(currentStage);
	
		$scope.STATIC_SERVER_DOMAIN = LOCAL_ENV_CONSTANT.STATIC_IMAGE_URL;
	
		summaryVm.inReview = Validations.inReview(currentStage);
		summaryVm.inApproval = inApproval;
		summaryVm.inExecution = Validations.inExecution(currentStage);
		summaryVm.inEvaluation = inEvaluation;
		summaryVm.inReviewExecution = inReviewExecution;
		summaryVm.textStage = '';
		summaryVm.toReviewedReject = 0;
		summaryVm.selfEvaluation = 0;
		summaryVm.isFeedback = false;
		summaryVm.teacherId = $stateParams.teacherId;
		summaryVm.workplanId = $stateParams.workplanId;
		summaryVm.headerPage = { teacherName: $stateParams.name };
		summaryVm.headerModal = {};
		summaryVm.executionFinish = 1;
		summaryVm.evaluationFinish = 1;
		summaryVm.approvedFinish = 1;
		summaryVm.reviewedFinish = 1;
		summaryVm.executionReviewedFinished = 1;
		summaryVm.feedback = 1;
		summaryVm.isState = 1;
		summaryVm.planningFinish = 1;
		i18nService.setCurrentLang('es');
	
		summaryVm.showModal = showModal;
		summaryVm.showModalFeedback = showModalFeedback;
		summaryVm.showWarning = showWarning;
		summaryVm.showEndStageButton = showEndStageButton;
		summaryVm.isReviewerApprover = false;
		summaryVm.textStageUnified = '';
		summaryVm.isFinishedButtonDisabled = true;
		summaryVm.showFinishButton = true;
		summaryVm.approvalOnwards = inApproval || inReviewExecution || inEvaluation;
		summaryVm.reviewExecutionOnwards = inReviewExecution || inEvaluation;
	
		summaryVm.reflexionesDePortafolioEvidenciasModel = reflexionesDePortafolioEvidenciasModel;
		summaryVm.showResumen = false;
		summaryVm.hours_planned_detail = 0;
		summaryVm.hours_executed_detail = 0;
	
		activate();
	
		function activate() {
			summaryVm.textStage = stages[currentStage];
	
			if (roleId === GlobalConfig.userRolesIds.workPlanAdmin || roleId === GlobalConfig.userRolesIds.unitAdmin || roleId === GlobalConfig.userRolesIds.gerencialConsultant) {
				summaryVm.showFinishButton = false;
			}
	
			if (GlobalConfig.userRolesIds.approver == roleId && inEvaluation == true) {
				summaryVm.showResumen = true;
			} else {
				summaryVm.showResumen = false;
			}
	
			getTeacherInfo().then(function (promise) {
				getGeneralsWorkplan().then(function (promise) {
					summaryVm.headerModal = setHeader();
	
					if (summaryVm.inReview && GlobalConfig.userRolesIds.reviewer == roleId) {
						isReviewerAndApprover().then(function (promise) {
							getFeedback().then(function (promise) {
								summaryVm.isFinishedButtonDisabled = isStageFinished();
							});
						});
					}
	
					if (summaryVm.inApproval && GlobalConfig.userRolesIds.approver == roleId) {
						setHeaderApproval().then(function (promise) {
							summaryVm.isFinishedButtonDisabled = isStageFinished() || summaryVm.isState === 2;
						});
					}
	
					if (summaryVm.inEvaluation && GlobalConfig.userRolesIds.approver == roleId) {
						setHeaderEvaluation().then(function (promise) {
							summaryVm.isFinishedButtonDisabled = isStageFinished();
						});
					}
	
					if (summaryVm.inReviewExecution && GlobalConfig.userRolesIds.reviewer == roleId) {
						setReviewExecutionEvaluation().then(function (promise) {
							isReviewerAndApprover().then(function (promise) {
								summaryVm.isFinishedButtonDisabled = isStageFinished();
							});
						});
					}
				});
			});
		}
	
		function isReviewerAndApprover() {
			var header = {
				teacherId: summaryVm.teacherId,
				reviewerId: user.id,
				workplanId: summaryVm.workplanId
			};
	
			return WorkPlanSrv.summary.checkReviewerApprover(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					summaryVm.isReviewerApprover = dataReturn.isReviewerApprover;
	
					if (summaryVm.inReview && summaryVm.isReviewerApprover) {
						summaryVm.textStageUnified = 'revisión y aprobación';
	
						return setHeaderApproval();
					} else if (summaryVm.inReviewExecution && summaryVm.isReviewerApprover) {
						summaryVm.textStageUnified = 'revisión ejecución y evaluación';
						summaryVm.showResumen = true;
	
						return setHeaderEvaluation();
					}
				}
			});
		}
		function getFeedback() {
			var post = {
				teacherId: summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId
			};
	
			return WorkPlanSrv.getFeedbackReviewedRejectGeneral.get(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					var now = moment(new Date()).format('YYYY-MM-DD');
					var endPlanning = moment(dataReturn.data[0].datePlanning).format('YYYY-MM-DD');
	
					if (now <= endPlanning) {
						summaryVm.isFeedback = true;
					}
				}
			}, function (data) {
				console.log(data);
			});
		}
	
		function getTeacherInfo() {
			var params = {
				teacherId: summaryVm.workplanId,
				workplanId: summaryVm.teacherId
			};
	
			return WorkPlanSrv.summary.getTeacherData(params).$promise.then(function (response) {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio, status:', response.status);
				} else {
					summaryVm.headerPage = Object.assign(summaryVm.headerPage, response.data[0] || {});
				}
			}, function (err) {
				ngNotify.set('Imposible conectar con el servicio', err);
			});
		}
	
		// grid con árbol
		$scope.gridOptions = {
			enableGridMenu: true,
			exporterMenuPdf: false,
			exporterCsvColumnSeparator: ';',
			exporterOlderExcelCompatibility: true,
			gridMenuShowHideColumns: false,
			enableSorting: true,
			enableFiltering: true,
			expandableRowTemplate: 'subgrid',
			enableScrollbars: true,
			expandableRowHeight: 150,
			columnDefs: [{ name: 'Submódulo',
				displayName: 'Submódulo',
				width: '15%',
				field: 'ds_submodule',
				enableHiding: false,
				cellTemplate: '<div class="ui-grid-cell-contents"> <span><strong>{{row.entity.ds_submodule}}' + '<md-tooltip md-direction="top" class="custom-tooltip">' + '{{row.entity.ds_submodule}}' + '</md-tooltip>' + '</strong></span></div>',
				filter: {
					condition: function condition(searchTerm, cellValue, row, column) {
						switch (row.entity.$$treeLevel) {
	
							case 0:
								cellValue = row.entity.ds_submodule;
								break;
							case 1:
								cellValue = row.treeNode.parentRow.entity.ds_submodule;
								break;
							default:
								cellValue = row.treeNode.parentRow.treeNode.parentRow.entity.ds_submodule;
								break;
	
						}
	
						var expr = new RegExp(searchTerm, 'i');
	
						return !!cellValue.match(expr);
					}
				}
			}, { name: 'Tipo actividad',
				displayName: 'Tipo actividad',
				field: 'ds_activity_type',
				enableHiding: false,
				cellTemplate: '<div class="ui-grid-cell-contents"> <span><strong>{{row.entity.ds_activity_type}}' + '<md-tooltip md-direction="top" class="custom-tooltip">' + '{{row.entity.ds_activity_type}}' + '</md-tooltip>' + '</strong></span></div>',
				filter: {
					condition: function condition(searchTerm, cellValue, row, column) {
						switch (row.entity.$$treeLevel) {
	
							case 0:
								cellValue = row.treeNode.children.map(function (child) {
									return child.row.entity.ds_activity_type;
								}).join(',');
								break;
							case 1:
								cellValue = row.entity.ds_activity_type;
								break;
							default:
								cellValue = row.treeNode.parentRow.entity.ds_activity_type;
								break;
	
						}
	
						var expr = new RegExp(searchTerm, 'i');
	
						return !!cellValue.match(expr);
					}
				}
			}, { name: 'Actividad',
				displayName: 'Actividad',
				field: 'ds_activity',
				width: 200,
				enableHiding: false,
				cellTemplate: '<div class="ui-grid-cell-contents"> <span>{{row.entity.ds_activity}}' + '<md-tooltip md-direction="top" class="custom-tooltip">' + '{{row.entity.ds_activity}}' + '</md-tooltip>' + '</span></div>'
			}, {
				name: 'En seguimiento',
				displayName: 'En seguimiento',
				field: 'is_strategic_tracing',
				width: '8%',
				enableHiding: false,
				cellTemplate: '<div class="text-center ui-grid-cell-contents">' + '<a ng-if="row.entity.isStrategicTracing == 1" href="#"><i class="icon mdi-image-remove-red-eye text-success i-20 p-h-md"></i></a>' + '</div>',
				enableFiltering: false,
				enableColumnMenu: false
			}, {
				name: 'Estado',
				displayName: 'Estado',
				field: 'status',
				width: '7%',
				enableHiding: false,
				cellTemplate: '<div class="text-center ui-grid-cell-contents">\n              <a ng-if="(row.entity.isReviewed == 1 && row.entity.inReview) ||\n                        (row.entity.isApproved  == 1 && row.entity.inApproval) ||\n                        (row.entity.isExecution == 1 && row.entity.inReviewExecution) ||\n                        (row.entity.isAccept == 1 && row.entity.inEvaluation)"\n              href="#">\n                <i class="icon mdi-action-thumb-up text-primary i-20 p-h-md"></i></a>\n              <a ng-if="(row.entity.isReviewed == 0 && row.entity.inReview) ||\n                        (row.entity.isApproved  == 0 && row.entity.inApproval) ||\n                        (row.entity.isExecution == 0 && row.entity.inReviewExecution) ||\n                        (row.entity.isAccept == 0 && row.entity.inEvaluation)"\n              href="#">\n                <i class="icon mdi-action-thumb-down text-danger i-20 p-h-md"></i></a>\n             </div>',
				enableFiltering: false,
				enableColumnMenu: false
			}, { name: 'Horas plan.', displayName: 'Horas planeadas', field: 'total_horas', width: '8%', enableHiding: false }, { name: 'Porcentaje horas plan.', displayName: 'Porcentaje horas planeadas', field: 'porcentaje_horas', width: '12%', enableHiding: false }, { name: 'Horas ejec.', displayName: 'Horas ejecutadas', field: 'total_horas_executed', width: '8%', enableHiding: false }, { name: 'Porcentaje horas ejec.', displayName: 'Porcentaje horas ejecutadas', field: 'porcentaje_horas_executed', width: '12%', enableHiding: false }],
			//
			onRegisterApi: function onRegisterApi(gridApi) {
				$scope.gridApi = gridApi;
				$scope.gridApi.treeBase.on.rowExpanded($scope, function (row) {});
			}
		};
	
		getTableData();
	
		function getTableData() {
			$scope.isLoading = true;
			var data = [];
	
			$scope.gridOptions.data = [];
			var params = {
				workplanId: summaryVm.workplanId,
				teacherId: summaryVm.teacherId
			};
			var total_horas = 0,
			    total_horas_executed = 0;
	
			WorkPlanSrv.summary.getDataGrid(params).$promise.then(function (response) {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					summaryVm.workplanTeacherId = response.workplanteacherId;
					summaryVm.userId = response.userId;
	
					if (response.userIdentification && response.userIdentification.length > 0) {
						//$scope.picture = getFullpathUserImage(response.userIdentification)
						$scope.picture = response.profilePicture + '?1' + Math.random();
					}
	
					$scope.notPicture = __webpack_require__(294);
	
					for (var i in response.data) {
						var val = data.length;
	
						data.push({
							$$treeLevel: 0,
							ds_submodule: response.data[i].ds_submodule,
							total_horas: response.data[i].total_horas,
							total_horas_executed: response.data[i].total_horas_executed
						});
						var countHoursTotal = 0,
						    countHoursExecTotal = 0;
	
						for (var x in response.data[i].job_submodule) {
							var valSubmodule = data.length;
	
							data.push({
								$$treeLevel: 1,
								total_horas: response.data[i].job_submodule[x].total_horas,
								total_horas_executed: response.data[i].job_submodule[x].total_horas_executed,
								ds_activity_type: response.data[i].job_submodule[x].ds_activity_type
							});
							var countHours = 0;
							var countHoursExec = 0;
	
							for (var j in response.data[i].job_submodule[x].job_activity_type) {
								countHours = countHours + response.data[i].job_submodule[x].job_activity_type[j].total_horas;
								countHoursExec = countHoursExec + response.data[i].job_submodule[x].job_activity_type[j].total_horas_executed;
	
								data.push({
									total_horas: response.data[i].job_submodule[x].job_activity_type[j].total_horas,
									total_horas_executed: response.data[i].job_submodule[x].job_activity_type[j].total_horas_executed,
									ds_activity: response.data[i].job_submodule[x].job_activity_type[j].ds_activity,
									isStrategicTracing: response.data[i].job_submodule[x].job_activity_type[j].isStrategicTracing,
									status: response.data[i].job_submodule[x].job_activity_type[j].status,
	
									isReviewed: response.data[i].job_submodule[x].job_activity_type[j].isReviewed,
									isApproved: response.data[i].job_submodule[x].job_activity_type[j].isApproved,
									isAccept: response.data[i].job_submodule[x].job_activity_type[j].isAccept,
									isExecution: response.data[i].job_submodule[x].job_activity_type[j].isExecution,
									isReviewedExecution: response.data[i].job_submodule[x].job_activity_type[j].isReviewedExecution,
									isEvaluation: response.data[i].job_submodule[x].job_activity_type[j].isEvaluation,
	
									inReview: summaryVm.inReview,
									inApproval: summaryVm.inApproval,
									inExecution: summaryVm.inExecution,
									inReviewExecution: summaryVm.inReviewExecution,
									inEvaluation: summaryVm.inEvaluation
	
								});
							}
							data[valSubmodule].total_horas = countHours;
							data[valSubmodule].total_horas_executed = countHoursExec;
							countHoursTotal = countHoursTotal + countHours;
							countHoursExecTotal = countHoursExecTotal + countHoursExec;
						}
						data[val].total_horas = countHoursTotal;
						data[val].total_horas_executed = countHoursExecTotal;
					}
					$scope.isLoading = false;
					$scope.gridOptions.data = data;
				}
	
				for (var _i in data) {
					if (data[_i].$$treeLevel == 0) {
						if (typeof data[_i].total_horas !== 'undefiend') {
							total_horas += data[_i].total_horas;
						}
	
						if (typeof data[_i].total_horas_executed !== 'undefiend') {
							total_horas_executed += data[_i].total_horas_executed;
						}
					}
				}
				for (var _i2 in data) {
					if (data[_i2].$$treeLevel == 0) {
						data[_i2].porcentaje_horas = (total_horas > 0 ? data[_i2].total_horas * 100 / total_horas : 0).toFixed(2) + '%';
						data[_i2].porcentaje_horas_executed = (total_horas_executed > 0 ? data[_i2].total_horas_executed * 100 / total_horas_executed : 0).toFixed(2) + '%';
					}
				}
	
				summaryVm.hours_planned_detail = total_horas;
				summaryVm.hours_executed_detail = total_horas_executed;
	
				// summaryVm.headerPage.hours_planned=total_horas;
				// summaryVm.headerPage.hours_executed=total_horas_executed;
				//  console.log(total_horas+'---t0tt---'+total_horas_executed)
			}, function (err) {
				ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function setHeader() {
			return {
				teacherId: summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				textStage: summaryVm.textStage,
				userId: user.id,
				currentStage: currentStage
			};
		}
	
		// Modal
		function showModal() {
			var isReviewAndApproval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
			summaryVm.headerModal.userId = summaryVm.userId;
			summaryVm.headerModal.teacherName = summaryVm.headerPage.teacherName;
			summaryVm.headerModal.isReviewAndApproval = isReviewAndApproval;
			summaryVm.headerModal.textStage = isReviewAndApproval && (summaryVm.inReview || summaryVm.inReviewExecution) ? summaryVm.textStageUnified : summaryVm.headerModal.textStage;
			summaryVm.headerModal.isReviewAndApproval;
			WorkPlanModalSrv.setVariable(summaryVm.headerModal);
	
			if (summaryVm.inApproval || summaryVm.inEvaluation || summaryVm.inReviewExecution) {
				// return summaryVm.headerModal > 0
			}
	
			if (GlobalConfig.userRolesIds.approver == roleId && inEvaluation == true) {
				WorkPlanModalSrv.endStage();
			} else if (GlobalConfig.userRolesIds.teacher == roleId && inExecution == true) {
				$state.go('evaluations.teacherSelfAssessment');
			} else {
				WorkPlanModalSrv.endStage();
			}
		}
	
		function setHeaderApproval() {
			var post = {
				teacherId: summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				stageId: GlobalConfig.workplanIdStages.approval
			};
	
			return WorkPlanSrv.getReprovedActivities.get(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					summaryVm.headerModal.count = dataReturn.data.toApprove;
					summaryVm.headerModal.toReviewed = dataReturn.data.noTouched;
					summaryVm.headerModal.allAct = dataReturn.data.allAct;
					summaryVm.headerModal.strategic = dataReturn.data.forStrategicTracingOn;
				}
			});
		}
	
		function setHeaderEvaluation() {
			var post = {
				teacherId: summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				stageId: GlobalConfig.workplanIdStages.evaluation
			};
	
			return WorkPlanSrv.getReprovedActivities.get(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					summaryVm.headerModal.toReviewed = dataReturn.data.noTouched;
				}
			});
		}
	
		function setReviewExecutionEvaluation() {
			var post = {
				teacherId: summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				stageId: GlobalConfig.workplanIdStages.reviewExecution
			};
	
			return WorkPlanSrv.getReprovedActivities.get(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					summaryVm.headerModal.toReviewed = dataReturn.data.noTouched;
				}
			});
		}
	
		function showWarning() {
			var header = {
				teacherId: summaryVm.teacherId,
				workplanId: summaryVm.workplanId,
				textStage: summaryVm.textStage,
				evaluatorId: user.id,
				currentStage: currentStage,
				workplanteacherId: summaryVm.workplanTeacherId,
				isReviewerApprover: summaryVm.isReviewerApprover
			};
			var headerDump = {
				workplanteacherId: summaryVm.workplanTeacherId
			};
	
			WorkPlanModalSrv.setVariable(header);
	
			return $mdDialog.show({
				controller: 'warningApprovalCtrl',
				controllerAs: 'warningCtrl',
				template: __webpack_require__(837),
				clickOutsideToClose: true
			}).then(function (response) {
				if (response) {
					if (summaryVm.inApproval || summaryVm.inReview) {
						setDumpInformation(headerDump).then(function () {
							return approveAll(header);
						});
					} else if (summaryVm.inEvaluation || summaryVm.inReviewExecution) {
						setDumpInformation(headerDump).then(function () {
							return approvalAllEvaluation(header);
						});
					}
				}
			});
		}
	
		function approvalAllEvaluation(datos) {
			var params = {
				workplanTeacherId: datos.workplanteacherId,
				evaluatorId: datos.evaluatorId,
				isReviewerApprover: datos.isReviewerApprover
			};
	
			WorkPlanSrv.summary.approvalAllEvaluation(params).$promise.then(function (response) {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					// Despues de guardar los cambios, recargar el ui-grid
					getTeacherInfo();
					getTableData();
	
					// El conteo que habilita "Finalizar" debe leer la etapa actual:
					// revisión de la ejecución usa is_execution; evaluación usa is_accept.
					if (summaryVm.inReviewExecution) {
						setReviewExecutionEvaluation();
					} else {
						setHeaderEvaluation();
					}
	
					ngNotify.set('Actividades Aprobadas Exitosamente!', 'success');
				}
			}, function (err) {
				ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function setDumpInformation(header) {
			return WorkPlanSrv.setDumpInformation.post(header).$promise.then(function (response) {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					// Despues de guardar los cambios, recargar el ui-grid
					getTableData();
					ngNotify.set('Actividades Aprobadas Exitosamente!', 'success');
				}
	
				return true;
			}, function (err) {
				ngNotify.set('Imposible conectar con el servicio', 'error');
	
				return false;
			});
		}
	
		function approveAll(datos) {
			/* let params = {
	       workplanTeacherId: datos.workplanteacherId,
	       userId: user.id
	     } */
			WorkPlanSrv.summary.approvalAll(datos).$promise.then(function (response) {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn');
				} else {
					// Despues de guardar los cambios, recargar el ui-grid
					getTeacherInfo();
					getTableData();
					setHeaderApproval();
					ngNotify.set('Actividades Aprobadas Exitosamente!', 'success');
				}
			}, function (err) {
				ngNotify.set('Imposible conectar con el servicio', 'error');
			});
		}
	
		function showModalFeedback() {
			var post = {
				teacherId: summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				teacherName: summaryVm.headerPage.teacher_name,
				userId: summaryVm.userId
			};
	
			WorkPlanSrv.getActivitiesNotReviewed.get(post).$promise.then(function (response) {
				post.data = response.data;
				WorkPlanModalSrv.setVariable(post);
				WorkPlanModalSrv.feedbackReviewed().then(function (promise) {});
			});
		}
	
		function showEndStageButton() {
			if (summaryVm.inReviewExecution) {
				return summaryVm.executionFinish === 1;
			} else {
				return true;
			}
		}
	
		function getGeneralsWorkplan() {
			return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: summaryVm.teacherId }).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					summaryVm.workplanIdStages = dataReturn.data.wokplanTeacherStatus[0].stageId;
					summaryVm.feedback = dataReturn.data.wokplanTeacherStatus[0].isFeedback;
					summaryVm.isState = dataReturn.data.wokplanTeacherStatus[0].isState;
					summaryVm.selfEvaluation = dataReturn.data.wokplanTeacherStatus[0].selfEvaluation;
				}
			});
		}
	
		function getFullpathUserImage(identification) {
			return GlobalConfig.azureProfilePicturePath + identification + '.jpg1=' + Math.random();
		}
	
		function isStageFinished() {
			if (Validations.isConsultant(roleId)) return true;else if (summaryVm.inReview) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.review;
			} else if (summaryVm.inApproval) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.approval;
			} else if (summaryVm.inReviewExecution) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.reviewExecution;
			} else if (summaryVm.evaluationFinish) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.evaluation;
			}
		}
	
		// accordian start
		$scope.oneAtATime = true;
		// accordian end 
	
		// question 11 grid options
		$scope.q11GridOptions = {
	
			rowHeight: 36,
	
			data: [{
				Respuestas: 'Lideranzgo',
				Cantidad: '7',
				Porcentaje: '7%'
			}, {
				Respuestas: 'Autonomia',
				Cantidad: '15',
				Porcentaje: '15%'
			}, {
				Respuestas: 'Trabajo en equipo',
				Cantidad: '10',
				Porcentaje: '10%'
			}]
	
			// reflexiones de portafolio evidencias model
		};function reflexionesDePortafolioEvidenciasModel() {
			var confirm = $mdDialog.confirm({
				controller: 'reflexionesDePortafolioEvidenciasController',
				controllerAs: 'reflexionesDePortafolioEvidencias',
				template: __webpack_require__(838),
				locals: {},
				animation: true,
				parent: angular.element(document.body),
				clickOutsideToClose: true
			});
	
			$mdDialog.show(confirm).then(function () {});
		}
	};
	
	exports.default = SummaryCtrl;
	
	
	SummaryCtrl.$inject = ['$scope', 'WorkPlanModalSrv', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', 'uiGridTreeViewConstants', '$http', '$window', '$cookies', 'Validations', 'WorkPlanSrv', 'GlobalConfig', 'ReviewSrv', 'ngNotify', '$state', 'LOCAL_ENV_CONSTANT'];

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=warningCtrl.close() aria-label=cerrar> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-danger>Advertencia</h3> </div> </div> <form name=endStageForm novalidate> <div class=\"row text-center\"> <div class=\"col-md-12 m-v-xs text-center\"> <h5>¿Esta seguro de marcar todas las actividades como aprobadas?</h5> </div> </div> <div class=row ng-show=\"(warningCtrl.inReview || warningCtrl.inReviewExecution) && !warningCtrl.pendingBreakdownLoaded\"> <div class=\"col-md-12 text-center m-t-md\"> <md-progress-circular md-mode=indeterminate md-diameter=32></md-progress-circular> </div> </div> <div class=row ng-show=\"(warningCtrl.inReview || warningCtrl.inReviewExecution) && warningCtrl.pendingBreakdownLoaded\"> <div class=\"col-md-12 m-t text-left\" style=\"padding:0 30px\"> <p ng-show=warningCtrl.assignedAllApproved() class=text-success> Todas las actividades de los subm&oacute;dulos asignados a usted fueron aprobadas. </p> <div ng-show=warningCtrl.hasPendingOther()> <p>Actividades pendientes en subm&oacute;dulos no asignados a usted:</p> <ul> <li ng-repeat=\"item in warningCtrl.pendingBreakdown.other\"> {{ item.submoduleName }}: {{ item.pending }} </li> </ul> </div> </div> </div> <div class=\"row text-center\"> <div class=\"col-md-12 m-t-md\"> <md-button aria-label class=\"btn btn-fw btn-cancel\" ng-click=warningCtrl.close(false)>Cancelar</md-button> <md-button class=\"btn btn-fw btn-primary\" ng-disabled=\"(warningCtrl.inReview || warningCtrl.inReviewExecution) && !warningCtrl.pendingBreakdownLoaded\" ng-click=warningCtrl.close(true)>Aceptar</md-button> </div> </div> </form> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog class=modal-md> <md-dialog-content> <div class=\"card p\"> <i ng-click=reflexionesDePortafolioEvidencias.close() class=\"btn mdi-navigation-close pull-right\"></i> <div ng-if=\"data.idFileType == 5\"> <img class=\"col-md-12 m-v-sm no-padding img-responsive align_left\" ng-src={{data.link}}> </div> <div ng-if=\"data.idFileType == 7 || data.idFileType == 8\"> <video class=\"col-md-12 m-v-sm no-padding\" controls ng-src={{data.link}}></video> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalSrv = function ModalSrv($mdDialog) {
	  _classCallCheck(this, ModalSrv);
	
	  var showConfirm = function showConfirm(event) {
	    /*let confirm = $mdDialog.confirm()
	      .title('Desea finalizar planeación?')
	      .textContent('Si finaliza planeación no podra modificar mas su planeación')
	      .ariaLabel('end planning')
	      .targetEvent(event)
	      .ok('Continuar')
	      .cancel('Cancelar')
	    return $mdDialog.show(confirm)*/
	    return $mdDialog.show({
	      controller: function showModalSaveItemRequired($scope, $mdDialog) {
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      },
	      template: __webpack_require__(840),
	      clickOutsideToClose: false
	    });
	  };
	
	  return {
	    showConfirm: showConfirm
	  };
	};
	
	ModalSrv.$inject = ['$mdDialog'];
	
	exports.default = angular.module('services.ModalSrv', []).service('ModalSrv', ModalSrv).name;

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title\"> <div class=col-md-12> <h3 class=text-verde>¡Atención!</h3> <p>Si finaliza planeación, no podra modificar más su planeación ¿Está seguro de esta acción?</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Cancelar</md-button> <md-button class=\"btn btn-fw btn-success\" ng-click=close()>Aceptar</md-button> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller
	* # name: warningApprovalCtrl
	* # alias: warningCtrl
	*/
	
	var warningApprovalCtrl = function () {
		function warningApprovalCtrl($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, ReviewSrv, GlobalConfig, Validations, $cookies) {
			var _this = this;
	
			_classCallCheck(this, warningApprovalCtrl);
	
			this.$scope = $scope;
			this.$state = $state;
			this.$timeout = $timeout;
			this.ngNotify = ngNotify;
			this.$stateParams = $stateParams;
			this.WorkPlanSrv = WorkPlanSrv;
			this.WorkPlanModalSrv = WorkPlanModalSrv;
			this.$mdDialog = $mdDialog;
			this.userinfo = null;
			this.$scope.UserInfoConstant = UserInfoConstant;
	
			var sharedVar = WorkPlanModalSrv.getVariable() || {};
			var currentStage = sharedVar.currentStage;
	
			this.inReview = Validations.inReview(currentStage);
			this.inReviewExecution = Validations.inReviewExecution(currentStage);
			this.pendingBreakdown = null;
			this.pendingBreakdownLoaded = false;
			this.hasPendingOther = function () {
				return !!(_this.pendingBreakdown && _this.pendingBreakdown.other && _this.pendingBreakdown.other.length > 0);
			};
			this.assignedAllApproved = function () {
				return !!(_this.pendingBreakdown && _this.pendingBreakdown.assigned && _this.pendingBreakdown.assigned.pending === 0);
			};
	
			if ((this.inReview || this.inReviewExecution) && sharedVar.teacherId && sharedVar.workplanId) {
				var currentUser = $cookies.getObject('currentUser');
				var currentRoleId = +$cookies.get('hasRoleId');
				var stageId = this.inReview ? GlobalConfig.workplanIdStages.review : GlobalConfig.workplanIdStages.reviewExecution;
	
				ReviewSrv.getPendingActivitiesBySubmodule.post({
					teacherId: sharedVar.teacherId,
					workplanId: sharedVar.workplanId,
					stageId: stageId,
					evaluatorId: currentUser.id,
					roleId: currentRoleId
				}).$promise.then(function (dataReturn) {
					if (dataReturn && dataReturn.status) {
						_this.pendingBreakdown = dataReturn.data;
					}
				}).finally(function () {
					_this.pendingBreakdownLoaded = true;
				});
			} else {
				this.pendingBreakdownLoaded = true;
			}
		}
	
		_createClass(warningApprovalCtrl, [{
			key: 'close',
			value: function close(response) {
				return this.$mdDialog.hide(response);
			}
		}]);
	
		return warningApprovalCtrl;
	}();
	
	exports.default = warningApprovalCtrl;
	
	
	warningApprovalCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', 'ReviewSrv', 'GlobalConfig', 'Validations', '$cookies'];

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-faculty
	* @autor vignesh.somayaji@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: customChartController
	* # alias: autoCtrl
	*/
	
	var autoevaluationController = function () {
	    function autoevaluationController($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, ReviewSrv, $cookies) {
	        var _this = this;
	
	        _classCallCheck(this, autoevaluationController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.ngNotify = ngNotify;
	        this.$stateParams = $stateParams;
	        this.ReviewSrv = ReviewSrv;
	        this.userinfo = null;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.teacherId = _this.$stateParams.teacherId;
	                _this.workplanId = _this.$stateParams.workplanId;
	                _this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false;
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(autoevaluationController, [{
	        key: 'main',
	        value: function main() {
	            console.log('Estoy en el controlador de autoevaluationController');
	            this.autoevaluation();
	        }
	    }, {
	        key: 'autoevaluation',
	        value: function autoevaluation() {
	            var _this2 = this;
	
	            var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId };
	            this.ReviewSrv.getAutoevaluation.Autoevaluation(param).$promise.then(function (dataReturn) {
	                if (dataReturn.status === true) {
	
	                    if (dataReturn.data.general.length == 0) {
	                        _this2.general = '';
	                    } else {
	                        _this2.general = dataReturn.data.general[0].reflectionGeneral;
	                    }
	                    _this2.generalFlag = {};
	                    if (dataReturn.data.reflection.length > 0) {
	
	                        _this2.generalFlag = dataReturn.data.reflection[0].codSubject;
	                        _this2.assignatureIdFlag = {};
	                        for (var i in dataReturn.data.reflection) {
	                            // this.generalFlag[dataReturn.data.reflection[i].codSubject]=dataReturn.data.reflection[i].codSubject
	                            for (var j in dataReturn.data.reflection[i].groups) {
	
	                                if (j == 0) {
	                                    _this2.assignatureIdFlag[dataReturn.data.reflection[i].groups[j].assignature_id] = dataReturn.data.reflection[i].groups[j].assignature_id;
	                                }
	                            }
	                        }
	
	                        // this.assignatureIdFlag=dataReturn.data.reflection[0].groups[0].assignature_id 
	                    }
	
	                    // typeof dataReturn.data.general[0].reflectionGeneral!=='undefined' ? :  
	
	
	                    _this2.reflection = dataReturn.data.reflection;
	                    _this2.workPlan = dataReturn.data.workPlan;
	                    _this2.institutionalCommitment = dataReturn.data.institutionalCommitment;
	                    _this2.openQuestion = dataReturn.data.openQuestions;
	                    _this2.finalConcept = dataReturn.data.finalConcept;
	                    _this2.headingDescription = dataReturn.data.descriptionTitle;
	                } else {
	                    console.log(dataReturn);
	                }
	            });
	        }
	    }]);
	
	    return autoevaluationController;
	}();
	
	exports.default = autoevaluationController;
	
	
	autoevaluationController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'ReviewSrv', '$cookies'];

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-faculty
	* @autor vignesh.somayaji@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: customChartController
	* # alias: autoCtrl
	*/
	
	var reflexionesportafolioController = function () {
	    function reflexionesportafolioController($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, ReviewSrv, $cookies, $mdDialog) {
	        var _this = this;
	
	        _classCallCheck(this, reflexionesportafolioController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.ngNotify = ngNotify;
	        this.$stateParams = $stateParams;
	        this.ReviewSrv = ReviewSrv;
	        this.userinfo = null;
	        this.$mdDialog = $mdDialog;
	        this.$scope.UserInfoConstant = UserInfoConstant;
	        this.$scope.$watch('UserInfoConstant[0].details[0]', function (details, before) {
	            if (details !== undefined) {
	                _this.userinfo = details.user;
	                _this.teacherId = _this.$stateParams.teacherId;
	                _this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false;
	                _this.param = { 'id_teacher': _this.teacherId,
	                    'id_work_plan': _this.workplanId };
	                _this.main();
	            }
	        });
	    }
	
	    _createClass(reflexionesportafolioController, [{
	        key: 'main',
	        value: function main() {
	            console.log('Estoy en el controlador de reflexionesportafolioController');
	            this.autoevaluation();
	        }
	    }, {
	        key: 'autoevaluation',
	        value: function autoevaluation() {
	
	            var THIS = this;
	            this.ReviewSrv.getReflectionMethod.get(this.param).$promise.then(function (dataReturn) {
	                if (dataReturn.status === true) {
	
	                    THIS.reflextionData = dataReturn.data;
	                } else {
	                    console.log(dataReturn);
	                }
	            });
	        }
	    }, {
	        key: 'showMultivideoDialog',
	        value: function showMultivideoDialog(details) {
	
	            this.videoLinks = details;
	
	            var confirm = this.$mdDialog.confirm({
	                controller: 'reflexionesDePortafolioEvidenciasController',
	                controllerAs: 'reflexionesDePortafolioEvidencias',
	                template: __webpack_require__(838),
	                locals: { videoLinks: details },
	                animation: true,
	                parent: angular.element(document.body),
	                clickOutsideToClose: true
	            });
	
	            this.$mdDialog.show(confirm).then(function () {});
	        }
	    }]);
	
	    return reflexionesportafolioController;
	}();
	
	exports.default = reflexionesportafolioController;
	
	
	reflexionesportafolioController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'ReviewSrv', '$cookies', '$mdDialog'];

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	          value: true
	});
	
	var _integrationPanel = __webpack_require__(845);
	
	var _integrationPanel2 = _interopRequireDefault(_integrationPanel);
	
	var _integrationPanel3 = __webpack_require__(847);
	
	var _integrationPanel4 = _interopRequireDefault(_integrationPanel3);
	
	var _tablesint = __webpack_require__(848);
	
	var _tablesint2 = _interopRequireDefault(_tablesint);
	
	var _tables = __webpack_require__(853);
	
	var _tables2 = _interopRequireDefault(_tables);
	
	var _executeDataController = __webpack_require__(858);
	
	var _executeDataController2 = _interopRequireDefault(_executeDataController);
	
	var _integrationServices = __webpack_require__(859);
	
	var _integrationServices2 = _interopRequireDefault(_integrationServices);
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.executionPanel', [_integrationServices2.default, _tablesint2.default, _tables2.default]).config(_integrationPanel2.default).controller('executeDataController', _executeDataController2.default).run(_integrationPanel4.default).constant("ExecutionIntegrationPanel", [{
	          "title": "Data-Integration",
	          "icon": "mdi-action-perm-contact-cal",
	          "subMenu": [{
	                    'title': 'Ejecutar integración de datos',
	                    'url': 'app.integracion',
	                    'rolesAllowed': [_globalConfig2.default.userRolesIds.generalAdmin]
	
	          }]
	}]).name;
	
	// controllers & services module Users
	
	
	// tablas de integracion y datos cargados
	
	// file Route & run app integration

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = routes;
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	      $locationProvider.html5Mode(true);
	      //$urlRouterProvider.otherwise('/');
	
	      $stateProvider.state('app.integracion', {
	            abstract: false,
	            url: '/panel-integracion/integracion',
	            template: __webpack_require__(846),
	            controller: 'executeDataController',
	            controllerAs: 'executeData'
	      });
	}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row title p-v-sm ng-scope\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"no-margin ng-binding\">Ejecutar integración de datos</h3> </div> </div> <div class=\"row p-h-lg\"> <div class=col-md-10 ng-repeat=\"x in executiondata\"> <p>{{x.feature_name}}</p> <dl> <dt>Fecha</dt> <dd>{{x.timenow}}</dd> <dt>Usuario</dt> <dd>{{x.name}}</dd> <dt>Estado</dt> <dd> <span ng-if=x.exection_status id=execution_button_{{x.fid}} class=\"label green label-lg student_risk_factor\" class=\"badge bg-success\"> {{x.exection_status}}</span> <span ng-if=!x.exection_status id=execution_button_{{x.fid}} class=label-lg class=badge></span> </dd> <dt>{{x.feature_name}} Realizar carga de datos</dt> <dd> <button ng-click=Ejacutar(x.feature_name,x.fid) class=\"btn bg-accent\">Iniciar carga</button> </dd> </dl> </div> </div>";

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'ExecutionIntegrationPanel', '$cookies'];
	
	//funcion donde se definen la run
	
	function run($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, ExecutionIntegrationPanel, $cookies) {
	  MenuConstant[0]['menu'].push(ExecutionIntegrationPanel);
	}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tablesint = __webpack_require__(849);
	
	var _tablesint2 = _interopRequireDefault(_tablesint);
	
	var _tableintCtrl = __webpack_require__(851);
	
	var _tableintCtrl2 = _interopRequireDefault(_tableintCtrl);
	
	var _tablesintServices = __webpack_require__(852);
	
	var _tablesintServices2 = _interopRequireDefault(_tablesintServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//injectamos los controladores y servicios 
	
	
	//importamos nuestros controladores
	
	exports.default = angular.module('app.tableint', [_tablesintServices2.default]).config(_tablesint2.default).controller('tableintCtrl', _tableintCtrl2.default).name;
	
	//importamos nuestros services 
	
	/**
	* @name APP integration
	* @autor jaime.salazar@u-planner.com
	* @description
	* file index para modulo tablas de filtrado
	*/
	
	//importamos el file .route

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	/**
	 * @name APP integration
	 * @autor jaime.salazar@u-planner.com
	 * @description
	 * rutas modulo tablas de filtrado
	 */
	
	//Inyectamos la dependencias necesarias de angular para generar las rutas;
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	//funcion donde se definen la rutas
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	
	  $stateProvider.state('app.tableint_campus', {
	    url: '/tableintcampus?:type',
	    abstract: false,
	    params: { type: 'campus' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_periodo', {
	    url: '/tableintperiodo?:type',
	    abstract: false,
	    params: { type: 'PeriodoAcademico' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_horaClase', {
	    url: '/tableinthoraClase?:type',
	    abstract: false,
	    params: { type: 'jornada' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_infraestructura', {
	    url: '/tableintinfraestructura?:type',
	    abstract: false,
	    params: { type: 'Recurso' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_infraestructuratipouso', {
	    url: '/tableintinfraestructuratipouso?:type',
	    abstract: false,
	    params: { type: 'Recurso_Tipouso' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_planestudioasignatura', {
	    url: '/tableintplanestudioasignatura?:type',
	    abstract: false,
	    params: { type: 'curso_planestudio' }, //?
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_planestudioturno', {
	    url: '/tableintplanestudioturno?:type',
	    abstract: false,
	    params: { type: 'CampusperiodojornadaPlan' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_actividadasignaturadetalle', {
	    url: '/tableintactividadasignaturadetalle?:type',
	    abstract: false,
	    params: { type: 'Curso_Actividad' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_actividadasignaturatipouso', {
	    url: '/tableintactividadasignaturatipouso?:type',
	    abstract: false,
	    params: { type: 'curso_actividad_tipouso' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_valorhoraasignatura', {
	    url: '/tableintvalorhoraasignatura?:type',
	    abstract: false,
	    params: { type: 'ValorHoraCurso' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_arancelcarrera', {
	    url: '/tableintarancelcarrera?:type',
	    abstract: false,
	    params: { type: 'ArancelCarrera' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_docente', {
	    url: '/tableintdocente?:type',
	    abstract: false,
	    params: { type: 'Docente' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_docenteasignaturaactividadsede', {
	    url: '/tableintdocenteasignaturaactividadsede?:type',
	    abstract: false,
	    params: { type: 'DocenteCursoActividad' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_docentevalorhoraevaluacion', {
	    url: '/tableintdocentevalorhoraevaluacion?:type',
	    abstract: false,
	    params: { type: 'DocenteValorHoraEvaluacion' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  }).state('app.tableint_notaclase', {
	    url: '/tableintnotaclase?:type',
	    abstract: false,
	    params: { type: 'Nota_Clase' },
	    template: __webpack_require__(850),
	    controller: 'tableintCtrl',
	    controllerAs: 'tableint'
	  });
	}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports = " <div class=main-title> <div class=title> <h1> Tabla {{title}} </h1> </div> <div class=button-group> <button md-ink-ripple class=\"md-btn md-raised\" ng-click=tableint.exportAll()> <i class=mdi-file-export></i>Exportar CSV </button> </div> </div> <div class=row> <div class=col-lg-12> <div class=panel> <div style=height:65vh class=t-h40 ui-grid=tabla ui-grid-pinning ui-grid-pagination ui-grid-resize-columns ng-if=tabla.data></div> </div> </div> <div class=col-xs-12> </div> </div>";

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @name APP cmmApp
	 * @autor camila.montenegro@u-planner.com
	 * @description Tabla para Campus
	 * # name controller --> tableCtrl
	 */
	
	var tableintCtrl = function tableintCtrl($scope, $http, $filter, tablesintServices, $stateParams, ngNotify, SERVICE_URL_CONSTANT, $window) {
	    _classCallCheck(this, tableintCtrl);
	
	    function ucfirst(st) {
	        return st.substring(0, 1).toUpperCase() + st.substring(1).toLowerCase();
	    }
	    $scope.type = $stateParams['type'];
	    $scope.title = $scope.type.replace(/([A-Z])/g, " $1"); //ucfirst();
	    $scope.title = $scope.title.replace(/_/g, ' '); //ucfirst();
	    var vm = this;
	
	    $scope.model = {};
	    //// Table
	
	    $scope.tabla = {
	        exporterCsvFilename: 'integration_table_' + $scope.type + '.csv',
	        exporterCsvColumnSeparator: ';',
	        exporterMenuAllData: true,
	        exporterOlderExcelCompatibility: true,
	        exporterPdfDefaultStyle: { fontSize: 7 },
	        exporterPdfTableStyle: { margin: [5, 5, 5, 5] },
	        exporterPdfTableHeaderStyle: { fontSize: 8, bold: true, italics: true, color: 'blue' },
	        exporterPdfMaxGridWidth: 620,
	        exporterPdfCustomFormatter: function exporterPdfCustomFormatter(docDefinition) {
	            docDefinition.styles.headerStyle = {
	                fontSize: 15,
	                bold: true,
	                marginTop: 10,
	                marginLeft: 40,
	                marginBottom: 40
	            };
	            return docDefinition;
	        },
	        enableFiltering: true,
	        enableGridMenu: true,
	        paginationPageSizes: [10, 25, 50, 75],
	        paginationPageSize: 10,
	        useExternalPagination: true,
	        onRegisterApi: function onRegisterApi(gridApi) {
	            gridApi.core.on.filterChanged($scope, function () {
	                var grid = this.grid;
	                var filters = {};
	
	                for (var i in grid.columns) {
	                    if (grid.columns[i].filters[0].term != '' && grid.columns[i].filters[0].term != undefined) {
	                        filters[grid.columns[i].field] = grid.columns[i].filters[0].term;
	                    }
	                }
	                $scope.tabla.paginationNumber = 1;
	                tablesintServices.services.getTabla({ tabla: $scope.type, newPage: 1, pageSize: $scope.tabla.paginationPageSize, filters: filters }).$promise.then(function (data) {
	                    $scope.tabla.data = data.data;
	                    $scope.tabla.totalItems = data.size;
	                });
	            });
	            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
	                var grid = this.grid;
	                var filters = {};
	                for (var i in grid.columns) {
	                    if (grid.columns[i].filters[0].term != '' && grid.columns[i].filters[0].term != undefined) {
	                        filters[grid.columns[i].field] = grid.columns[i].filters[0].term;
	                    }
	                }
	                tablesintServices.services.getTabla({ tabla: $scope.type, newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
	                    $scope.tabla.data = data.data;
	                    $scope.tabla.totalItems = data.size;
	                });
	            });
	        }
	
	        //columnDefs : cols
	    };
	    tablesintServices.services.getTabla({ tabla: $scope.type, newPage: 1, pageSize: 10 }).$promise.then(function (data) {
	        $scope.tabla.data = data.data;
	        $scope.tabla.totalItems = data.size;
	    });
	    var url = SERVICE_URL_CONSTANT.tablesFiltering + '/integrationExport?tabla=' + $scope.type;
	    vm.exportAll = function () {
	        $window.open(url);
	    };
	};
	
	exports.default = tableintCtrl;
	
	
	tableintCtrl.$inject = ['$scope', '$http', '$filter', 'tablesintServices', '$stateParams', 'ngNotify', 'SERVICE_URL_CONSTANT', '$window'];

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @name Integration
	 * @description
	 *
	 * Servicio para el reporte  de Simulacion Academica Schedule
	 */
	var tablesintServices = function tablesintServices($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, tablesintServices);
	
	  var services = $resource(SERVICE_URL_CONSTANT.tablesintFiltering + '/:folder/:controller', {}, {
	    getTabla: {
	      method: 'GET',
	      params: {
	        folder: 'reports',
	        controller: SERVICE_URL_CONSTANT.tablesType == 'PHP' ? 'tablas.php' : 'integration'
	      }
	    }
	
	  });
	
	  return {
	    services: services
	  };
	};
	
	tablesintServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	
	exports.default = angular.module('services.tablesintServices', []).service('tablesintServices', tablesintServices).name;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tables = __webpack_require__(854);
	
	var _tables2 = _interopRequireDefault(_tables);
	
	var _tableCtrl = __webpack_require__(856);
	
	var _tableCtrl2 = _interopRequireDefault(_tableCtrl);
	
	var _tablesServices = __webpack_require__(857);
	
	var _tablesServices2 = _interopRequireDefault(_tablesServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//definimos los controladores y servicios ya importados anteriormente
	
	
	//importamos nuestros controladores
	
	exports.default = angular.module('app.table', [_tablesServices2.default]).config(_tables2.default).controller('tableCtrl', _tableCtrl2.default).name;
	
	//importamos nuestros services 
	
	/**
	* @name APP Integration
	* @autor jaime.salazar@u-planner.com
	* @description module datos cargados 
	*/

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	/**
	 * @name APP u-planning
	 * @autor jaime.salazar@u-planner.com
	 * @description
	 * rutas modulo tablas de datos cargados
	 */
	
	//Inyectamos la dependencias necesarias de angular para generar las rutas;
	
	routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
	
	//funcion donde se definen la rutas
	
	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	
	  $stateProvider.state('app.table_institucion', {
	    url: '/table_institucion?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_campus', {
	    url: '/table_campus?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_periodo', {
	    url: '/table_periodo?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_jornada', {
	    url: '/table_jornada?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_modulos_jornada', {
	    url: '/table_modulos_jornada?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_planes_campus', {
	    url: '/table_planes_campus?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_carrera', {
	    url: '/table_carrera?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_plan_estudio', {
	    url: '/table_plan_estudio?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_materia_plan', {
	    url: '/table_materia_plan?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_departamento', {
	    url: '/table_departamento?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_materia_departamento', {
	    url: '/table_materia_departamento?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_actividad', {
	    url: '/table_actividad?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  }).state('app.table_nota_clase', {
	    url: '/table_nota_clase?type',
	    abstract: false,
	    template: __webpack_require__(855),
	    controller: 'tableCtrl',
	    controllerAs: 'table'
	  });
	}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = "<div class=main-title> <div class=title> <h1> Tabla {{title}} </h1> </div> <div class=button-group> <button md-ink-ripple class=\"md-btn md-raised\" ng-click=table.exportAll()> <i class=mdi-file-export></i>Exportar CSV </button> <button md-ink-ripple class=\"md-btn md-raised\" ng-click=table.exportAllxls()> <i class=mdi-file-export></i>Exportar XLS </button> </div> </div> <div class=button-group ng-if=filterBlock> <form class=form-inline> <div class=form-group> <label>Filtrar por Campus:</label> <select ng-model=myModel.selectedCampus class=\"\" ng-change=table.filter()> <option ng-repeat=\"campus in cataloguesCampus.data track by $index\" value={{campus.id_Sede}}>{{campus.des_Nombre}}</option> </select> </div> </form> </div> <div class=button-group ng-if=filterBlockN> <form class=form-inline> <div class=form-group> <label>Filtrar por Campus:</label> <select ng-model=myModel.selectedCampus style=min-width:200px ng-change=table.filterN()> <option ng-repeat=\"campus in list track by $index\" value={{campus.id_Sede}}>{{campus.des_Nombre}}</option> </select> </div> </form> </div> <div class=button-group ng-if=filterBlockC> <form class=form-inline> <div class=form-group> <select class=form-control ng-change=table.callFilter() ng-model=myModel.filter> <option value=0>Seleccione Letra</option> <option ng-repeat=\"i in ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']\" value={{i}}>{{i}}</option> </select> </div> <div class=form-group> <select ng-model=myModel.selectedCarrera class=\"\" ng-change=table.filterC()> <option ng-repeat=\"carrera in cataloguesCarreras.data track by $index\" value={{carrera.id_carrera}}>{{carrera.des_nombre_carrera}}</option> </select> </div> </form> </div> <div class=button-group ng-if=filterBlockD> <form class=form-inline> <div class=form-group> <select class=form-control ng-change=table.filterD() ng-model=myModel.filter> <option value=0>Seleccione Letra</option> <option ng-repeat=\"i in ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']\" value={{i}}>{{i}}</option> </select> </div> </form> </div> <div class=button-group ng-if=filterBlockUnit> <form class=form-inline> <div class=form-group> <select ng-model=myModel.selectedUnidad class=\"\" ng-change=table.filterUnit()> <option ng-repeat=\"unidad in cataloguesUnidad.data track by $index\" value={{unidad.id_unidad_academica}}>{{unidad.des_Unidad_Academica}}</option> </select> </div> </form> </div> <div class=button-group ng-if=filterBlockCJ> <form class=form-inline> <div class=form-group> <select ng-model=myModel.selectedCampus class=\"\" ng-change=table.filterCJ()> <option ng-repeat=\"campus in cataloguesCampus.data track by $index\" value={{campus.id_Sede}}>{{campus.des_Nombre}}</option> </select> </div> <div class=form-group> <select ng-model=myModel.selectedJornada class=\"\" ng-change=table.filterCJ()> <option ng-repeat=\"jornadas in cataloguesJornadas.data track by $index\" value={{jornadas.id_jornada}}>{{jornadas.des_nombre_jornada}}</option> </select> </div> </form> </div> <div style=height:65vh class=t-h40 ui-grid=tabla ui-grid-pinning ui-grid-pagination ui-grid-resize-columns ng-if=tabla.data></div> <button ng-show=false ng-click=table.saveChanges(); md-ink-ripple class=\"md-btn md-raised bg-accent\"> <i class=mdi-content-save></i> Guardar Cambios </button> ";

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @name APP cmmApp
	 * @autor camila.montenegro@u-planner.com
	 * @description Tabla para Campus
	 * # name controller --> tableCtrl
	 */
	
	var tableCtrl = function tableCtrl($scope, $http, $filter, tablesServices, $stateParams, ngNotify, SERVICE_URL_CONSTANT, $window, permissions, permissionList) {
		_classCallCheck(this, tableCtrl);
	
		/*  permissionList["filtertableedit"]=true;
	  permissions.setPermissions(); */
		function ucfirst(st) {
			return st.substring(0, 1).toUpperCase() + st.substring(1).toLowerCase();
		}
		$scope.type = $stateParams['type'];
		$scope.title = ucfirst($scope.type);
		var vm = this;
		var nci = [{
			name: 'Nombre',
			field: 'des_nombre_' + $scope.type
		}, {
			name: 'Código',
			field: 'id_publica_' + $scope.type
		}, {
			name: 'id_Integración',
			field: 'cod_integracion_' + $scope.type
		}];
	
		if (permissions.hasPermission("filtertableedit")) {
			var switchs = [{
				name: 'Sincronizable',
				field: $scope.type + '_sincronizable',
				width: '10%',
				enableFiltering: false,
				cellTemplate: '<div class="ui-grid-cell-contents">' + '<span>' + '<label class="md-switch">' + '<input type="checkbox" aria-label="Sincronizable" ng-model="grid.appScope.model[row.entity.cod_integracion_' + $scope.type + '].sincronizable"' + ' ng-click="grid.appScope.modelSave[((row.entity.cod_alt)?row.entity.cod_alt:row.entity.cod_integracion_' + $scope.type + ')].sincronizable=grid.appScope.model[row.entity.cod_integracion_' + $scope.type + '].sincronizable"><i class="green"></i></label></span>' + '</div>'
			}, {
				name: 'Estado',
				field: $scope.type + '_activa',
				width: '7%',
				enableFiltering: false,
				cellTemplate: '<div class="ui-grid-cell-contents">' + '<span><label class="md-switch">' + '<input type="checkbox" aria-label="Sincronizable" ng-model="grid.appScope.model[row.entity.cod_integracion_' + $scope.type + '].activa"' + ' ng-click="grid.appScope.modelSave[((row.entity.cod_alt)?row.entity.cod_alt:row.entity.cod_integracion_' + $scope.type + ')].activa=grid.appScope.model[row.entity.cod_integracion_' + $scope.type + '].activa"><i class="green"></i></label></span>' + '</div>'
			}];
		} else {
			var switchs = [{
				name: 'Sincronizable',
				field: $scope.type + '_sincronizable',
				width: '10%',
				enableFiltering: true
			}, {
				name: 'Estado',
				field: $scope.type + '_activa',
				width: '7%',
				enableFiltering: true
			}];
		}
	
		var exp = { data: [], headers: [], headerspdf: [] };
		switch ($scope.type) {
			case 'campus':
				var cols = nci.concat(switchs);
				tablesServices.services.getCampus({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
				break;
			case 'jornada':
				var cols = nci.concat(switchs);
				tablesServices.services.getJornada({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
	
				break;
			case 'actividad':
				var cols = nci.concat(switchs);
				tablesServices.services.getActivity({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
				break;
			case 'institucion':
				$scope.title = 'Institución';
				var cols = nci.concat(switchs);
				tablesServices.services.getInstitution({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					if ($scope.tabla.data == undefined) {
						console.log('raro');
					} else {
						console.log($scope.tabla.data);
					}
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
				break;
			case 'unidad_academica':
				$scope.title = "Departamento";
				var ua = [{
					name: 'Unidad Académica',
					field: 'des_nombre_unidad_academica'
				}, {
					name: 'Código',
					field: 'id_publica_unidad_academica'
				}, {
					name: 'Id Integración',
					field: 'cod_integracion_unidad_academica'
				}];
				var cols = ua.concat(switchs);
				tablesServices.services.getUnidadAcademica({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
	
				break;
			case "tipo_uso":
				$scope.title = "Tipo de Uso";
				var tp = [{
					name: 'Nombre',
					field: 'des_nombre_tipo_uso'
				}, {
					name: 'Tipo uso Detalle',
					field: 'des_nombre_tipo_uso_detalle'
				}, {
					name: 'ID Integración Tipo uso Detalle',
					field: 'cod_integracion_tipo_uso' }];
				var cols = tp.concat(switchs);
				tablesServices.services.getTipoUso({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.totalItems = data.size;
					$scope.tabla.data = data.data;
					$scope.booleanizar();
				});
	
				break;
			case "carrera":
				var cols = nci.concat(switchs);
				tablesServices.services.getCarrera({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
	
				break;
			case "ccepr":
				$scope.title = "Campus Recursos";
				var ccepr = [{
					name: 'Campus',
					field: 'des_nombre_campus'
				}, {
					name: 'Edificio',
					field: 'des_nombre_edificio'
				}, {
					name: 'Piso',
					field: 'des_nombre_piso'
				}, {
					name: 'Recurso',
					field: 'des_nombre_recurso'
				}, {
					name: 'Capacidad',
					field: 'nm_capacity'
				}, {
					name: 'Código',
					field: 'id_publica_recurso'
				}, {
					name: 'ID Integración',
					field: 'cod_integracion_ccepr'
				}];
				var cols = ccepr.concat(switchs);
				tablesServices.services.getRecurso({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
	
				break;
			case "cceprt":
				$scope.title = "Recurso Tipo de Uso";
				var cceprt = [{
					name: 'Campus',
					field: 'des_nombre_campus'
				}, {
					name: 'Edificio',
					field: 'des_nombre_edificio'
				}, {
					name: 'Piso',
					field: 'des_nombre_piso'
				}, {
					name: 'Recurso',
					field: 'des_nombre_recurso'
				}, {
					name: 'Tipo de Uso',
					field: 'des_nombre_tipo_uso'
				}];
				var cols = cceprt.concat(switchs);
				tablesServices.services.getRecursoTipoUso({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
	
				break;
			case 'docente':
				var cols = nci.concat(switchs);
				tablesServices.services.getDocente({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
	
				break;
			case 'periodo':
				var cols = nci.concat(switchs);
				cols.unshift({ name: 'Tipo de periodo', field: 'tipo_periodo' });
				$scope.myModel = { selectedCampus: 0 };
				$scope.filterBlock = true;
				tablesServices.catalogues.getCatalogueCampus().$promise.then(function (data) {
					$scope.cataloguesCampus = data;
	
					$scope.myModel.selectedCampus = '' + $scope.cataloguesCampus.data[0].id_Sede;
					vm.filter();
				});
	
				break;
			case 'pm':
				$scope.title = 'Materias por Plan';
				var pm = [{
					name: 'Carrera',
					field: 'des_nombre_carrera'
				}, {
					name: 'Plan',
					field: 'des_nombre_plan'
				}, {
					name: 'Nivel',
					field: 'nro_nivel'
					// width: '10%',
				}, {
					name: 'Nombre Asignatura',
					field: 'nombre_asignatura'
				}];
				var cols = pm.concat(switchs);
				$scope.myModel = { selectedCarrera: 0, filter: '0' };
				$scope.filterBlockC = true;
	
				break;
			case 'ad':
				$scope.title = 'Docente Materia Actividad';
				var ad = [{
					name: 'Asignatura',
					field: 'des_asignatura'
				}, {
					name: 'Actividad',
					field: 'des_actividad'
				}, {
					name: 'Docente',
					field: 'des_nombre_apellido'
				}];
				var cols = ad.concat(switchs);
				$scope.myModel = { selectedApellido: 0, filter: '0' };
				$scope.filterBlockD = true;
	
				break;
			case 'nota':
				$scope.title = 'Nota Clase';
				var cols = [{
					name: 'Nota Clase',
					field: 'des_nota_clase'
				}, {
					name: 'Código',
					field: 'id_nota_clase'
				}, {
					name: 'Id Integración',
					field: 'cod_integracion_nota'
				}];
				if (permissions.hasPermission("filtertableedit")) {
					cols.push({
						name: 'Estado',
						field: $scope.type + '_activa',
						width: '7%',
						cellTemplate: '<div class="ui-grid-cell-contents">' + '<span><label class="md-switch">' + '<input type="checkbox" aria-label="Sincronizable" ng-model="grid.appScope.model[row.entity.cod_integracion_nota].activa"' + ' ng-click="grid.appScope.modelSave[row.entity.cod_integracion_nota].activa=grid.appScope.model[row.entity.cod_integracion_nota].activa"><i class="green"></i></label></span>' + '</div>'
					});
				} else {
					cols.push({
						name: 'Estado',
						field: $scope.type + '_activa',
						width: '7%'
					});
				}
				$scope.filterBlockN = true;
	
				tablesServices.catalogues.getCatalogueCampus().$promise.then(function (data) {
					$scope.list = data.data;console.log(data.data);
					tablesServices.services.getNotaClase({ newPage: 1, pageSize: 10, id: data.data[0].id_Sede }).$promise.then(function (data) {
	
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.myModel = { selectedCampus: 0 };
						$scope.booleanizar();
					});
				});
	
				break;
			/*Modificar columna en tabla planes campus*/
			case 'cpjc':
				$scope.title = 'Planes en Campus';
				var cpjc = [{
					name: 'Campus',
					field: 'des_nombre_campus'
				}, {
					name: 'Periodo',
					field: 'des_nombre_periodo'
				}, {
					name: 'Jornada',
					field: 'des_nombre_jornada'
				}, {
					name: 'Carrera',
					field: 'des_nombre_carrera'
				}, {
					name: 'Plan',
					field: 'des_nombre_plan'
				}];
				var cols = cpjc.concat(switchs);
				$scope.myModel = { selectedCampus: 0 };
				$scope.filterBlock = true;
				tablesServices.catalogues.getCatalogueCampus().$promise.then(function (data) {
					$scope.cataloguesCampus = data;
	
					$scope.myModel.selectedCampus = $scope.cataloguesCampus.data[0].id_Sede;
					vm.filter();
				});
	
				break;
			case 'dm':
				$scope.title = 'Módulos por Jornada';
				var dm = [{
					name: 'Nombre',
					field: 'des_nombre_dia'
				}, {
					name: 'Código',
					field: 'des_nombre_modulo'
				}, {
					name: 'Jornada',
					field: 'des_jornada'
				}];
				var cols = dm.concat(switchs);
				$scope.myModel = { selectedCampus: 0 };
				$scope.filterBlockCJ = true;
				tablesServices.catalogues.getCatalogueCampus().$promise.then(function (data) {
					$scope.cataloguesCampus = data;
	
					$scope.myModel.selectedCampus = $scope.cataloguesCampus.data[0].id_Sede;
					tablesServices.services.getJornada({ newPage: 1, pageSize: 10000 }).$promise.then(function (data) {
						$scope.cataloguesJornadas = data;
						$scope.myModel.selectedJornada = '' + $scope.cataloguesJornadas.data[0].id_jornada;
						vm.filterCJ();
					});
				});
	
				break;
			case 'plan':
				$scope.title = 'Plan de Estudio';
				var cp = [{
					name: 'Carrera',
					field: 'des_nombre_carrera',
					width: '30%'
				}, {
					name: 'Plan',
					field: 'des_nombre_plan',
					width: '30%'
				}, {
					name: 'Modalidad',
					field: 'modalidad',
					width: '15%'
				}, {
					name: 'Código',
					field: 'id_publica_plan',
					width: '10%'
				}];
				var cols = cp.concat(switchs);
				tablesServices.services.getTable({ newPage: 1, pageSize: 10 }).$promise.then(function (data) {
					$scope.tabla.data = data.data;
					$scope.tabla.totalItems = data.size;
					$scope.booleanizar();
				});
	
				break;
			case 'aa':
				$scope.title = 'Materia Actividad';
				var aa = [{
					name: 'Asignatura',
					field: 'des_nombre_asignatura'
				}, {
					name: 'Actividad',
					field: 'des_nombre_actividad'
				}, {
					name: 'Módulos por semana',
					field: 'nro_modulos_por_semana'
				}, {
					name: 'Módulos consecutivos',
					field: 'nro_cant_modulos_consecutivos'
				}, {
					name: 'Cupo Académico',
					field: 'cupo'
				}];
				if (permissions.hasPermission("filtertableedit")) {
					aa[2].cellTemplate = '<div class="ui-grid-cell-contents">' + '<input type="number" aria-label="Sincronizable" ng-model="grid.appScope.modelSave[row.entity.cod_integracion_' + $scope.type + '].nro_modulos_por_semana"' + 'ng-value="row.entity.nro_modulos_por_semana">' + '</div>';
					aa[3].cellTemplate = '<div class="ui-grid-cell-contents">' + '<input type="number" aria-label="Sincronizable" ng-model="grid.appScope.modelSave[row.entity.cod_integracion_' + $scope.type + '].nro_Cant_Modulos_Consecutivos"' + 'ng-value="row.entity.nro_Cant_Modulos_Consecutivos">' + '</div>';
				}
				var cols = aa.concat(switchs);
				$scope.myModel = { selectedUnidad: 0 };
				$scope.filterBlockUnit = true;
				tablesServices.catalogues.getCatalogueUnidadAcademica().$promise.then(function (data) {
					$scope.cataloguesUnidad = data;
	
					$scope.myModel.selectedUnidad = $scope.cataloguesUnidad.data[0].id_unidad_academica;
					vm.filterUnit();
				});
	
				break;
			case 'uam':
				$scope.title = 'Materias por Departamento';
				var uam = [{
					name: 'Unidad Académica',
					field: 'des_nombre_unidad_academica'
				}, {
					name: 'Asignatura',
					field: 'des_nombre_asignatura',
					width: '35%'
				}, {
					name: 'Código',
					field: 'cod_integracion_uam'
				}];
				var cols = uam.concat(switchs);
				$scope.myModel = { selectedUnidad: 0 };
				$scope.filterBlockUnit = true;
				tablesServices.catalogues.getCatalogueUnidadAcademica().$promise.then(function (data) {
					$scope.cataloguesUnidad = data;
	
					$scope.myModel.selectedUnidad = $scope.cataloguesUnidad.data[0].id_unidad_academica;
					vm.filterUnit();
				});
	
				break;
			case 'aau':
				$scope.title = 'Materia Actividad Tipo Uso';
				var aau = [{
					name: 'Unidad Academica',
					field: 'des_nombre_unidad_academica'
				}, {
					name: 'Asignatura',
					field: 'des_nombre_asignatura',
					width: '35%'
				}, {
					name: 'Actividad',
					field: 'des_nombre_actividad'
				}, {
					name: 'Tipo de Uso',
					field: 'des_nombre_tipo_uso'
				}];
				var cols = aau.concat(switchs);
				$scope.myModel = { selectedUnidad: 0 };
				$scope.filterBlockUnit = true;
				tablesServices.catalogues.getCatalogueUnidadAcademica().$promise.then(function (data) {
					$scope.cataloguesUnidad = data;
	
					$scope.myModel.selectedUnidad = $scope.cataloguesUnidad.data[0].id_unidad_academica;
					vm.filterUnit();
				});
				break;
	
		}
		$scope.model = {};
		//// Table
		for (var i in cols) {
			if (cols[i] == undefined) {
				delete cols[i];
			} else {
				if (!cols[i].cellTemplate) {
					cols[i].cellTemplate = '<div class="ui-grid-cell-contents" ng-binding ng-scope">{{COL_FIELD}}<md-tooltip md-direction="right" style="background-color:#000000;">{{COL_FIELD}}</md-tooltip></div>';
				}
			}
		}
		$scope.tabla = {
			enableFiltering: true,
			enableGridMenu: true,
			paginationPageSizes: [10, 25, 50, 75],
			paginationPageSize: 10,
			useExternalPagination: true,
			onRegisterApi: function onRegisterApi(gridApi) {
				gridApi.core.on.filterChanged($scope, function () {
					var grid = this.grid;
					$scope.tabla.paginationNumber = 1;
					selectService(1, $scope.tabla.paginationPageSize, grid);
				});
				gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
					var grid = this.grid;
					selectService(newPage, pageSize, grid);
				});
			},
	
			columnDefs: cols
		};
		$scope.booleanizar = function () {
			$scope.modelSave = {};
			if (permissions.hasPermission("filtertableedit")) {
				for (var i in $scope.tabla.data) {
					//console.log($scope.tabla.data[i]);
					var key = $scope.tabla.data[i]['cod_integracion_' + $scope.type];
					if ($scope.tabla.data[i][$scope.type + '_sincronizable'] == 1) {
						$scope.tabla.data[i][$scope.type + '_sincronizable'] = true;
					}
					if ($scope.tabla.data[i][$scope.type + '_sincronizable'] == 0) {
						$scope.tabla.data[i][$scope.type + '_sincronizable'] = false;
					}
					if ($scope.tabla.data[i][$scope.type + '_activa'] == 1) {
						$scope.tabla.data[i][$scope.type + '_activa'] = true;
					}
					if ($scope.tabla.data[i][$scope.type + '_activa'] == 0) {
						$scope.tabla.data[i][$scope.type + '_activa'] = false;
					}
					$scope.model[key] = { sincronizable: $scope.tabla.data[i][$scope.type + '_sincronizable'], activa: $scope.tabla.data[i][$scope.type + '_activa'], key: '' };
				}
			} else {
				for (var i in $scope.tabla.data) {
					//console.log($scope.tabla.data[i]);
					var key = $scope.tabla.data[i]['cod_integracion_' + $scope.type];
					if ($scope.tabla.data[i][$scope.type + '_sincronizable'] == 1) {
						$scope.tabla.data[i][$scope.type + '_sincronizable'] = "Sincronizable";
					}
					if ($scope.tabla.data[i][$scope.type + '_sincronizable'] == 0) {
						$scope.tabla.data[i][$scope.type + '_sincronizable'] = "No Sincronizable";
					}
					if ($scope.tabla.data[i][$scope.type + '_activa'] == 1) {
						$scope.tabla.data[i][$scope.type + '_activa'] = "Activo";
					}
					if ($scope.tabla.data[i][$scope.type + '_activa'] == 0) {
						$scope.tabla.data[i][$scope.type + '_activa'] = "Inactivo";
					}
				}
			}
		};
		vm.desBooleanizar = function () {
	
			for (var i in $scope.modelSave) {
				if ($scope.modelSave[i].sincronizable == true) {
					$scope.modelSave[i].sincronizable = 1;
				}
				if ($scope.modelSave[i].sincronizable == false) {
					$scope.modelSave[i].sincronizable = 0;
				}
				if ($scope.modelSave[i].activa == true) {
					$scope.modelSave[i].activa = 1;
				}
				if ($scope.modelSave[i].activa == false) {
					$scope.modelSave[i].activa = 0;
				}
			}
		};
		vm.filter = function () {
			switch ($scope.type) {
				case "docente":
					tablesServices.services.getDocente({ newPage: 1, pageSize: 10, campus: $scope.myModel.selectedCampus }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
						console.log($scope.tabla.data);
					});
					break;
				case "periodo":
					tablesServices.services.getPeriod({ newPage: 1, pageSize: 10, campus: $scope.myModel.selectedCampus }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case "cpjc":
					tablesServices.services.getCPJCarrera({ newPage: 1, pageSize: 10, campus: $scope.myModel.selectedCampus }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
			}
		};
		vm.filterUnit = function () {
			$scope.modelSave = {};
			$scope.model = {};
			delete $scope.tabla.data;
			switch ($scope.type) {
				case "aa":
					tablesServices.services.getMateriaActivity({ newPage: 1, pageSize: 10, unidad: $scope.myModel.selectedUnidad }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case "aau":
					tablesServices.services.getMateriaActivityUse({ newPage: 1, pageSize: 10, unidad: $scope.myModel.selectedUnidad }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case "uam":
					tablesServices.services.getUnidadAcademicaMateria({ newPage: 1, pageSize: 10, unidad: $scope.myModel.selectedUnidad }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
			}
		};
		vm.filterCJ = function () {
			tablesServices.services.getModulo({ newPage: 1, pageSize: 10, campus: $scope.myModel.selectedCampus, jornada: $scope.myModel.selectedJornada }).$promise.then(function (data) {
				$scope.tabla.data = data.data;
				$scope.tabla.totalItems = data.size;
				$scope.booleanizar();
			});
		};
		vm.filterC = function () {
			tablesServices.services.getPlanMateria({ newPage: 1, pageSize: 10, carrera: $scope.myModel.selectedCarrera }).$promise.then(function (data) {
				$scope.tabla.data = data.data;
				$scope.tabla.totalItems = data.size;
				$scope.booleanizar();
			});
		};
		vm.filterD = function () {
			tablesServices.services.getAsignacionDocente({ newPage: 1, pageSize: 10, apellido: $scope.myModel.filter }).$promise.then(function (data) {
				$scope.tabla.data = data.data;
				$scope.tabla.totalItems = data.size;
				$scope.booleanizar();
			});
		};
		vm.filterN = function () {
			tablesServices.services.getNotaClase({ newPage: 1, pageSize: 10, id: $scope.myModel.selectedCampus }).$promise.then(function (data) {
				$scope.tabla.data = data.data;
				$scope.tabla.totalItems = data.size;
				$scope.booleanizar();
			});
		};
		vm.callFilter = function () {
			$scope.cataloguesCarreras = [];
			tablesServices.catalogues.getCatalogueCarreras({ i: $scope.myModel.filter }).$promise.then(function (data) {
				$scope.cataloguesCarreras = data;
				$scope.myModel.selectedCarrera = $scope.cataloguesCarreras.data[0].id_carrera;
				//vm.filterC();
			});
		};
		vm.saveChanges = function () {
			vm.desBooleanizar();
			tablesServices.updates.save({ data: $scope.modelSave, type: $scope.type }).$promise.then(function (data) {
				console.log(data);
				if (data.status == 0) {
					ngNotify.set('Se han guardado los cambios de manera correcta.', 'success');
				} else {
					ngNotify.set('El servicio no responde.', 'error');
				}
			});
		};
		vm.getData = function () {
			var ex = [];
			for (var i in $scope.tabla.data) {
				var ob = {};
				for (var j in $scope.tabla.data[i]) {
					if (j == $scope.type + '_sincronizable' || j == $scope.type + '_activa') {
						if ($scope.tabla.data[i][j] == true) {
							ob[j] = 1;
						}
						if ($scope.tabla.data[i][j] == false) {
							ob[j] = 0;
						}
					} else {
						ob[j] = $scope.tabla.data[i][j];
					}
				}
				ex.push(ob);
			}
			return ex;
		};
	
		var url = SERVICE_URL_CONSTANT.tablesFiltering;
		$scope.exporter = true;
		switch ($scope.type) {
			case "nota":
				url += "/exportNota";break;
			case "periodo":
				url += "/exportPeriodo";break;
			case "pm":
				url += "/exportPlanmateria";break;
			case "uam":
				url += "/exportUam";break;
			case "cpjc":
				url += "/exportCpjcp";break;
			case "dm":
				url += "/exportModulosporjornada";break;
			case "institucion":
				url += "/institutionsExport";break;
			case "campus":
				url += "/campusesExport";break;
			case "jornada":
				url += "/shiftsExport";break;
			case "carrera":
				url += "/careersExport";break;
			case "plan":
				url += "/careerspensumsExport";break;
			case "unidad_academica":
				url += "/academicunitExport";break;
			case "actividad":
				url += "/activitiesExport";break;
			default:
				$scope.exporter = false;
	
		}
		vm.exportAll = function () {
			$window.open(url);
		};
		vm.exportAllpdf = function () {
			$window.open(url + "?tipo=pdf");
		};
		vm.exportAllxls = function () {
			$window.open(url + "?tipo=xls");
		};
		var selectService = function selectService(newPage, pageSize, grid) {
			var filters = {};
			for (var _i in grid.columns) {
				if (grid.columns[_i].filters[0].term != '' && grid.columns[_i].filters[0].term != undefined) {
					filters[grid.columns[_i].field] = grid.columns[_i].filters[0].term;
				}
			}
			switch ($scope.type) {
				case 'campus':
					tablesServices.services.getCampus({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case 'jornada':
					tablesServices.services.getJornada({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case 'actividad':
					tablesServices.services.getActivity({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case 'institucion':
					tablesServices.services.getInstitution({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case 'unidad_academica':
					tablesServices.services.getUnidadAcademica({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case "tipo_uso":
					tablesServices.services.getTipoUso({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.totalItems = data.size;
						$scope.tabla.data = data.data;
						$scope.booleanizar();
					});
	
					break;
				case "carrera":
					tablesServices.services.getCarrera({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case "ccepr":
					tablesServices.services.getRecurso({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case "cceprt":
					tablesServices.services.getRecursoTipoUso({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case 'docente':
					tablesServices.services.getDocente({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case 'periodo':
					tablesServices.services.getPeriod({ newPage: newPage, pageSize: pageSize, campus: $scope.myModel.selectedCampus, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case 'pm':
					tablesServices.services.getPlanMateria({ newPage: newPage, pageSize: pageSize, carrera: $scope.myModel.selectedCarrera, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case 'ad':
					tablesServices.services.getAsignacionDocente({ newPage: newPage, pageSize: pageSize, apellido: $scope.myModel.filter, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case 'nota':
					tablesServices.services.getNotaClase({ newPage: newPage, pageSize: pageSize, id: $scope.myModel.selectedCampus, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case 'cpjc':
					tablesServices.services.getCPJCarrera({ newPage: newPage, pageSize: pageSize, campus: $scope.myModel.selectedCampus, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case 'dm':
					tablesServices.services.getModulo({ newPage: newPage, pageSize: pageSize, campus: $scope.myModel.selectedCampus, jornada: $scope.myModel.selectedJornada, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case 'plan':
					tablesServices.services.getTable({ newPage: newPage, pageSize: pageSize, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
	
					break;
				case "aa":
					tablesServices.services.getMateriaActivity({ newPage: newPage, pageSize: pageSize, unidad: $scope.myModel.selectedUnidad, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case "aau":
					tablesServices.services.getMateriaActivityUse({ newPage: newPage, pageSize: pageSize, unidad: $scope.myModel.selectedUnidad, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case "uam":
					tablesServices.services.getUnidadAcademicaMateria({ newPage: newPage, pageSize: pageSize, unidad: $scope.myModel.selectedUnidad, filters: filters }).$promise.then(function (data) {
						$scope.tabla.data = data.data;
						$scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
	
			}
		};
	};
	
	exports.default = tableCtrl;
	
	
	tableCtrl.$inject = ['$scope', '$http', '$filter', 'tablesServices', '$stateParams', 'ngNotify', 'SERVICE_URL_CONSTANT', '$window', 'permissions', 'permissionList'];

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @name integration
	 * @autor Jaime.salazar@u-planner.com
	 */
	
	var tablesServices = function tablesServices($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, tablesServices);
	
	  var catalogues = $resource(SERVICE_URL_CONSTANT.tablesFiltering + '/:controller', {}, {
	
	    getCatalogueCampus: {
	      method: 'GET',
	      params: {
	        controller: 'cataloguecampuses'
	      }
	    },
	
	    getCatalogueCarreras: {
	      method: 'GET',
	      params: {
	        controller: 'cataloguecareers'
	      }
	    },
	
	    getCatalogueUnidadAcademica: {
	      method: 'GET',
	      params: {
	        controller: 'catalogueunits'
	      }
	    }
	
	  });
	
	  var services = $resource(SERVICE_URL_CONSTANT.tablesFiltering + '/:controller', {}, {
	    getActivity: {
	      method: 'GET',
	      params: {
	        controller: 'activities'
	      }
	    },
	    getCampus: {
	      method: 'GET',
	      params: {
	        controller: 'campuses'
	      }
	    },
	    getInstitution: {
	      method: 'GET',
	      params: {
	        controller: 'institutions'
	      }
	    },
	    getJornada: {
	      method: 'GET',
	      params: {
	        controller: 'shifts'
	      }
	    },
	    getCarrera: {
	      method: 'GET',
	      params: {
	        controller: 'careers'
	      }
	
	    },
	    getUnidadAcademica: {
	      method: 'GET',
	      params: {
	        controller: 'academicunit'
	      }
	    },
	    getPeriod: {
	      method: 'GET',
	      params: {
	        controller: 'period'
	      }
	    },
	    getPlanMateria: {
	      method: 'GET',
	      params: {
	        controller: 'coursepensum'
	      }
	    },
	    getTipoUso: {
	      method: 'GET',
	      params: {
	        controller: 'usagetype'
	      }
	    },
	    getRecursoTipoUso: {
	      method: 'GET',
	      params: {
	        controller: 'classroomusagetype'
	      }
	    },
	    getRecurso: {
	      method: 'GET',
	      params: {
	        controller: 'classroom'
	      }
	    },
	    getUnidadAcademicaMateria: {
	      method: 'GET',
	      params: {
	        controller: 'academicunitcourse'
	      }
	    },
	    getCPJCarrera: {
	      method: 'GET',
	      params: {
	        controller: 'campusperiodshiftcareer'
	      }
	    },
	    getMateriaActivity: {
	      method: 'GET',
	      params: {
	        controller: 'courseactivity'
	      }
	    },
	    getMateriaActivityUse: {
	      method: 'GET',
	      params: {
	        controller: 'courseactivityusagetype'
	      }
	    },
	
	    getTable: {
	      method: 'GET',
	      params: {
	        controller: 'careerspensum'
	      }
	    },
	
	    getModulo: {
	      method: 'GET',
	      params: {
	        controller: 'modulesshift'
	      }
	    },
	
	    getDocente: {
	      method: 'GET',
	      params: {
	        controller: 'teacher'
	      }
	    },
	    getAsignacionDocente: {
	      method: 'GET',
	      params: {
	        controller: 'docente_materia_actividad.php'
	      }
	    },
	    getNotaClase: {
	      method: 'GET',
	      params: {
	        controller: 'nota'
	      }
	    }
	
	  });
	
	  var updates = $resource(SERVICE_URL_CONSTANT.tablesFiltering + '/:controller', {}, {
	
	    save: {
	      method: 'POST',
	      params: {
	        controller: 'save'
	      }
	    } });
	
	  return {
	    services: services,
	    catalogues: catalogues,
	    updates: updates
	  };
	};
	
	tablesServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	
	exports.default = angular.module('services.tablesServices', []).service('tablesServices', tablesServices).name;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP Integration
	* @autor VigneshKumar Somayaji
	* @description
	* # name controller --> executeDataController
	*/
	
	var executeDataController = function executeDataController($scope, $http, $resource, $timeout, ngNotify, UserInfoConstant, $state, $interval, $cookies, SERVICE_URL_CONSTANT, integrationServices) {
		_classCallCheck(this, executeDataController);
	
		var vm = this;
		$scope.userDetails = '';
		$scope.id = 0;
		$scope.setProcess = [];
	
		var sumInterval = {};
	
		$scope.Ejacutar = function (title, fid) {
	
			var ejaculatorProcess = $scope.setProcess;
	
			$scope.pingMethod = function pingMethod() {
				var cookiesProcess = $scope.setProcess;
	
				if (typeof cookiesProcess[0].fid !== 'undefined') {
					for (var i in cookiesProcess) {
	
						integrationServices.services.pingEtlExecutable({ 'id': cookiesProcess[i].processID }).$promise.then(function (response) {
							console.log('pingEtlExecutable', response);
							var pingEtlExecutable = response.executablefeatures[i];
							if (pingEtlExecutable.id_status != 1 && pingEtlExecutable.id_status != 2) {
								$('#execution_button_' + cookiesProcess[i].fid).addClass('bg-success');
								$('#execution_button_' + cookiesProcess[i].fid).html(pingEtlExecutable.statues);
								$('#execution_button_' + cookiesProcess[i].fid).removeClass('bg-warning');
								delete cookiesProcess[i];
								//$cookies.remove('setProcess');
								$scope.setProcess = [];
								$scope.setProcess.push(cookiesProcess);
								// $cookies.putObject('setProcess',cookiesProcess);
							}
						}, function (err) {
							ngNotify.set('No se ha podido conectar con el servicio', 'error');
						});
					}
				} else {
					$interval.cancel(sumInterval);
					$scope.setProcess = [];
				}
			};
	
			var obj = [];
			console.log('it manger', ejaculatorProcess);
			if (ejaculatorProcess.length == 0) {
	
				// if($scope.executiondata[0].execution_status)
				var param = { fid: fid, user_id: $scope.userDetails.id, jobname: $scope.executiondata[0].ds_job_name,
					execution_status: $scope.executiondata[0].execution_status };
				integrationServices.services.setExecutionDetails(param).$promise.then(function (dataReturn) {
	
					sumInterval = $interval($scope.pingMethod, 30000);
					$scope.id = dataReturn.data;
					$scope.setProcess.push({ processID: dataReturn.data,
						title: title,
						fid: fid });
					// $cookies.putObject('setProcess',obj);
					$('#execution_button_' + fid).addClass('bg-warning');
					$('#execution_button_' + fid).html('En ejecucion');
					$('#execution_button_' + fid).removeClass('label-danger');
				}, function (err) {
					ngNotify.set('No se ha podido conectar con el servicio', 'error');
				});
			} else {
	
				// console.log('yyyyyyy',ejaculatorProcess);
				// console.log('sumInterval',sumInterval);
				if (sumInterval !== null && ejaculatorProcess[0].fid == fid) {
					sumInterval = $interval($scope.pingMethod, 5000);
					$('#execution_button_' + fid).addClass('bg-warning');
					$('#execution_button_' + fid).html('En ejecucion');
					$('#execution_button_' + fid).removeClass('label-danger');
					$('#execution_button_' + fid).removeClass('bg-success');
				} else {
					ngNotify.set('Espere a que se complete el proceso', 'error');
				}
			}
		};
	
		/// process not terminated
	
	
		integrationServices.services.getExecutionDetails().$promise.then(function (dataReturn) {
			if (dataReturn.data.lenght == 0) {} else {
	
				$timeout(function () {
					$scope.userDetails = $scope.userDetails = UserInfoConstant[0].details[0].user;
					$scope.executiondata = dataReturn.data;
	
					for (var i in dataReturn.data) {
						// $scope.setProcess=	$scope.id= dataReturn.data;
						if (dataReturn.data[i].execution_status == 1 || dataReturn.data[i].execution_status == 2) {
							$scope.setProcess.push({ processID: dataReturn.data[i].exection_id,
								title: dataReturn.data[i].feature_name,
								fid: dataReturn.data[i].fid });
						}
					}
	
					try {
						var ejap = $scope.setProcess;
	
						if (typeof ejap !== 'undefined' || ejap[0] != null) {
							$scope.Ejacutar(ejap[0].title, ejap[0].fid);
							$timeout(function () {
								console.log('vfvvvvvv', ejap);
								$('#execution_button_' + ejap[0].fid).addClass('bg-warning');
								$('#execution_button_' + ejap[0].fid).html('En ejecucion');
								$('#execution_button_' + ejap[0].fid).removeClass('bg-success');
								$('#execution_button_' + ejap[0].fid).removeClass('bg-danger');
							}, 3000);
						}
					} catch (e) {
						console.log('process  terminated', e);
					}
				}, 1000);
			}
		}, function (err) {
			ngNotify.set('No se ha podido conectar con el servicio', 'error');
		});
	};
	
	exports.default = executeDataController;
	
	
	executeDataController.$inject = ['$scope', '$http', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', '$state', '$interval', '$cookies', 'SERVICE_URL_CONSTANT', 'integrationServices'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var integrationServices = function integrationServices($resource, SERVICE_URL_CONSTANT) {
	  _classCallCheck(this, integrationServices);
	
	  var services = $resource(SERVICE_URL_CONSTANT.dataExecution + '/:route', {}, {
	    getExecutionDetails: {
	      method: 'GET',
	      params: {
	        route: 'getExecutablefeatures'
	      }
	    },
	    setExecutionDetails: {
	      method: 'POST',
	      params: {
	        route: 'setExecutionDetails'
	      }
	    },
	    pingEtlExecutable: {
	      method: 'GET',
	      params: {
	        route: 'pingEtlExecutable'
	      }
	    }
	
	  });
	
	  return {
	    services: services
	  };
	};
	
	integrationServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT'];
	
	exports.default = angular.module('services.integrationServices', []).service('integrationServices', integrationServices).name;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AsideCtrl = function AsideCtrl($scope, $http, $timeout, $resource, $location, $cookieStore, MenuConstant, UserInfoConstant, permissionList, permissions, $state, $rootScope, $mdDialog, $cookies, GlobalSrv, chatboxServices, GlobalConfig, $interval, adminPanel, reportSrv, $localStorage, $sessionStorage, $translate, FileUploader, SERVICE_URL_CONSTANT, Helpers, LOCAL_ENV_CONSTANT) {
		_classCallCheck(this, AsideCtrl);
	
		var config = __webpack_require__(159);
		var staticServerurl = config.STATIC_IMAGE_URL;
		var langs = {
			es: 'Español',
			en: 'English',
			por: 'Portugues'
		};
		var notGroupAssigned = 'user has not any role assigned';
		var notRoleAssigned = 'user has not any role assigned';
	
		$scope.STATIC_IMAGE_URL = true;
		$scope.picture = '';
		$scope.uploader = '';
		var THIS = $scope;
	
		$scope.lang = $cookies.get('lang') || 'es';
		$scope.languages = [];
		config.AVAILABLE_LANG = config.AVAILABLE_LANG || ['es'];
	
		for (var i in config.AVAILABLE_LANG) {
			$scope.languages.push({
				key: config.AVAILABLE_LANG[i],
				value: langs[config.AVAILABLE_LANG[i]],
				src: 'assets/images/flags/' + config.AVAILABLE_LANG[i] + '.png'
			});
		}
	
		$translate.use($scope.lang);
		$scope.languageHeader = updateLanguageKey($scope.lang, $scope.languages);
	
		$scope.updateLanguage1 = function (key) {
			$translate.use(key);
			$scope.languageHeader = updateLanguageKey(key, $scope.languages);
		};
	
		function updateLanguageKey(key, value) {
			for (var i in value) {
				if (value[i].key == key) {
					return value[i];
				}
			}
		}
	
		$scope.menuClickLang = function (e, index) {
			if (flag) {
				if ($('.box-inner #parent_li_' + index).hasClass('active')) {
					$('.box-inner #parent_li_' + index).removeClass('active');
				} else {
					$('.box-inner #parent_li_' + index).addClass('active');
				}
			}
	
			flag = true;
		};
	
		var url = {};
		var serverUrl = {};
		var localenv = __webpack_require__(159);
		var flag = true;
	
		var NotifyCurrentUser = $cookies.get('currentUser');
		var locationpath = $location.path();
	
		// var split = split($location).substring(externalUrlFiles[j].lastIndexOf("/") + 1)
		var externalPortfolio = $location.search().external ? $location.search().external : false;
	
		function wsdlLogin() {
			var cookieObject = $localStorage.userAuth;
			var autoLogin = $location.search().accessLogin;
	
			if (autoLogin) {
				try {
					autoLogin = decodeURIComponent(escape(window.atob(autoLogin)));
					var email = autoLogin;
	
					delete $localStorage.autoLogin;
					var param = {
						type: 'autoLogin',
						users: {
							sn: email,
							givenname: email,
							name: email,
							mail: email
						}
					};
	
					GlobalSrv.getUserInfoMetta.POST(param).$promise.then(function (response) {
						if (response.status == 1) {
							var data = Helpers.getUserStored(response.data);
	
							$localStorage.userLogin = data;
							$localStorage.userAuth = response.data;
							$localStorage.logintime = Date.now();
							window.location = LOCAL_ENV_CONSTANT.HOMEPAGE;
						} else {
							delete $localStorage.userLogin;
							delete $localStorage.userAuth;
						}
					}).catch(function () {
						window.location = url + '?returnTo=' + serverUrl;
					});
				} catch (e) {
					delete $localStorage.userLogin;
					delete $localStorage.userAuth;
					window.location = LOCAL_ENV_CONSTANT.HOMEPAGE;
				}
			} else if (typeof cookieObject === 'undefined') {
				$state.go('login');
			} else {
				setResponseData(Helpers.getUserStored(cookieObject));
			}
		}
	
		function adalFunctionCallback() {
			var searchObject = $location.search().idUserToken;
	
			if (typeof searchObject !== 'undefined') {
				var temp = JSON.parse(decodeURIComponent(atob(searchObject).split('').map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				}).join('')));
	
				GlobalSrv.getUserInfoMetta.POST(temp).$promise.then(function (response) {
					var data = response.data;
	
					if (response.status == 1) {
						$localStorage.userLogin = data;
						$location.search('idUserToken', null);
	
						if (typeof data === 'undefined') {
							window.location = url + '?returnTo=' + serverUrl + 'app/welcomeHome';
						} else {
							setResponseData(data);
						}
					} else {
						delete $localStorage.userLogin;
					}
				}).catch(function () {
					window.location = url;
				});
			} else {
				var cookieObject = $localStorage.userLogin;
	
				if (typeof cookieObject === 'undefined') {
					window.location = url + '?returnTo=' + serverUrl + 'app/welcomeHome';
				} else {
					setResponseData(cookieObject);
				}
			}
		}
	
		function casAdalFunctionCallback() {
			$.ajax({
				dataType: 'jsonp',
				data: 'returnTo=' + serverUrl,
				jsonp: 'callback',
				url: url,
				cache: true,
				async: true,
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Methods': 'GET,OPTIONS',
					'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
					'Content-Type': 'text/plain',
					'Accept-Language': 'en-US'
				},
				xhrFields: {
					withCredentials: true
				},
				crossDomain: true,
				success: function success(response) {
					var temp = JSON.parse(decodeURIComponent(atob(response).split('').map(function (c) {
						return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
					}).join('')));
	
					response = temp;
					setResponseData(response);
				},
				error: function error(xhr, ajaxOptions, thrownError) {
					window.location = url;
					console.log(thrownError);
				}
			});
		}
	
		function setResponseData(cookieObject) {
			var response = cookieObject;
	
			$scope.admin = response.user;
			// $cookies.put('ESTSAUTH_INTIAL',false)
			UserInfoConstant[0].details.push(response);
			setCookiesValues(response);
			permissions.setPermissions(response.user.permissions[0]);
			$scope.idUser = response.user.id;
			$timeout(function () {
				notificationUserInbox(response);
				countNotificationsUserInboxNoRead();
			}, 10000);
			var RoleId = 0;
	
			if (!$cookies.get('hasRoleId')) {
				RoleId = response.user.role[0] ? response.user.role[0].role_id : 0;
			} else {
				RoleId = $cookies.get('hasRoleId');
			}
	
			var header = { RoleId: RoleId };
	
			GlobalSrv.getChangeRole.get(header).$promise.then(function (dataReturn) {
				permissions.setPermissions(dataReturn.user.permissions[0]);
				response.user.permissions[0] = dataReturn.user.permissions[0];
				response.user.url = '';
				// console.log("la url del usuario es: ", response.user.url);
				response.user.url = dataReturn.user.url;
				UserInfoConstant[0].details[0].user['url'] = [];
				UserInfoConstant[0].details[0].user['url'] = dataReturn.user.url;
				$timeout(function () {
					$scope.subitems = MenuConstant[0].menu;
					$scope.roles = [{ name: 'Roles', items: response.user.role }];
					$rootScope.$emit('CallMyMethodRoles', $scope.roles);
					getAsideMenu();
				}, 200);
	
				UserInfoConstant[0].details[0].user['url'].push('/app');
	
				if (response.user.id === 1) {
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/usuarios');
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/usuarios/crear');
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/roles');
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/roles/crear');
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/grupos');
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/grupos/crear');
					UserInfoConstant[0].details[0].user['url'].push('/app/admin-panel/usuarios/edit');
				}
	
				// let permission = next.$$state.permission;
				$timeout(function () {
					var urls = processUrl($location.path());
	
					if (RoleId == 15) {
						var flag = false;
	
						for (var i in MenuConstant[0]['menu']) {
							if (MenuConstant[0]['menu'][i][0].title == 'Admin-Panel') {
								delete MenuConstant[0]['menu'][i];
								flag = true;
							}
						}
						// if (flag == false) {
						MenuConstant[0]['menu'][MenuConstant[0]['menu'].length] = adminPanel;
						// }
	
						UserInfoConstant[0].details[0].user['url'].push('//panel-integracion/integracion');
						UserInfoConstant[0].details[0].user['url'].push('/app/panel-integracion/integracion');
					} else {
						// MenuConstant[0]['menu']={};
						for (var i in MenuConstant[0]['menu']) {
							if (MenuConstant[0]['menu'][i][0].title == 'Admin-Panel') {
								delete MenuConstant[0]['menu'][i];
							}
						}
					}
	
					if (UserInfoConstant[0].details[0].user['url'].indexOf(urls.string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(urls.str3) > -1) {
						// $state.go('app.welcomeHome');
					} else {
						if (urls.string != '/app/welcomeHome') {
							$state.go('app.unauthorized');
						}
						// $location.path('/app/unauthorized')
					}
				}, 100);
			}, function (dataReturn) {
				console.log(dataReturn);
			});
		}
	
		if (localenv.USER_API_URL && !externalPortfolio) {
			var protocol = $location.protocol();
	
			url = localenv.USER_API_URL + '/api/user-api';
			serverUrl = localenv.SERVER_NAME;
	
			if (protocol == 'http') {
				$cookies.put('ESTSAUTH_INTIAL', 'true');
			}
	
			var ESTSAUTH = $cookies.get('ESTSAUTH_INTIAL');
	
			var uploader = $scope.uploader = new FileUploader({
				url: SERVICE_URL_CONSTANT.rosario + '/perfil/setProfileImage',
				autoUpload: true
			});
	
			uploader.filters.push({
				name: 'imageFilter',
				fn: function fn(item) {
					var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	
					return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
				}
			});
	
			uploader.onSuccessItem = function (fileItem, response, status, headers) {
				console.info('onSuccessItem', fileItem, response, status, headers);
			};
	
			uploader.onErrorItem = function (fileItem, response, status, headers) {
				console.info('onErrorItem', fileItem, response, status, headers);
			};
	
			uploader.onCompleteItem = function (fileItem, response, status, headers) {
				console.info('onCompleteItem', fileItem, response, status, headers);
				THIS.STATIC_IMAGE_URL = true;
				THIS.picture = response.data + '?' + Math.random();
				THIS.STATIC_IMAGE_URL_UPLOAD = true;
				var cookiesUser = $cookies.getObject('currentUser');
	
				if (cookiesUser) {
					cookiesUser.pictureExtension = response.data.replace(staticServerurl + '/profilepicture/', '');
					$cookies.putObject('currentUser', cookiesUser);
				}
			};
	
			uploader.onBeforeUploadItem = function (item) {
				item.formData = [];
				item.formData.push({ id: THIS.rut });
				THIS.STATIC_IMAGE_URL_UPLOAD = true;
			};
	
			/**************************************/
	
			if (['adal', 'gsuite'].indexOf(localenv.loginType) >= 0) {
				adalFunctionCallback();
			} else if (localenv.loginType == 'web') {
				wsdlLogin();
			} else {
				casAdalFunctionCallback();
			}
		} else {
			var response = '{\n            "user": {\n              "name": "Invitado",\n              "email": "Invitado",\n              "id": 34,\n              "permissions": [\n              {\n                "filtertableedit": true,\n                "campuses-association": true,\n                "create-academic-programming": true,\n                "update-academic-programming": true,\n                "campus-academicperiod-shift-academicprogramming": true,\n                "update-campus-period-shift": true,\n                "create-classroom-association": true,\n                "career-pensum-insert": true,\n                "course-pensum-insert": true,\n                "disable-simulation": true,\n                "disable-multiple-simulations": true\n              }\n              ],\n              "central": 1\n            }\n          }';
	
			response = JSON.parse(response);
			$scope.admin = response.user;
			UserInfoConstant[0].details.push(response);
			permissions.setPermissions(response.user.permissions[0]);
			$scope.subitems = MenuConstant[0].menu;
			getAsideMenu();
		}
	
		$scope.menuClick = menuClick;
		$scope.superMenu = superMenu;
		$scope.menuLogout = menuLogout;
		$scope.toogleAccountClass = toogleAccountClass;
		$scope.openAside = openAside;
		$scope.callFunction = callFunction;
		$scope.showModalCreateWorkplan = showModalCreateWorkplan;
		// $scope.roleClick = roleClick
		$scope.validateRoleSelected = validateRoleSelected;
		$scope.validateRoleSelectedMenu = validateRoleSelectedMenu;
		$scope.validateSubModule = validateSubModule;
		$scope.notificationUserInbox = notificationUserInbox;
		$scope.workPlanGeneral = notificationUserInbox;
		$scope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead;
		$rootScope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead;
		$scope.validateIfWorkPlanActive = validateIfWorkPlanActive;
	
		$scope.onUserPictureError = function (callback) {
			$scope.picture = $scope.notPicture;
			var cookiesUser = $cookies.getObject('currentUser');
	
			if (cookiesUser) {
				cookiesUser.pictureExtension = null;
				$cookies.putObject('currentUser', cookiesUser);
			}
	
			if ($scope.rut) {
				GlobalSrv.getUserImage.get({ identification: $scope.rut }).$promise.then(function (response) {
					$scope.pictureRosario = response.profilePicture + '?1=' + $scope.mathRandom;
	
					if (cookiesUser) {
						cookiesUser.pictureRosario = $scope.pictureRosario;
						$cookies.putObject('currentUser', cookiesUser);
					}
	
					callback();
				});
			} else {
				callback();
			}
		};
	
		var getCurrentUser = $interval(function () {
			var cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false;
	
			if (cookiesUser) {
				// var currentUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
				var currentUser = JSON.parse($cookies.get('currentUser'));
	
				workPlanGeneral();
				$scope.showWorkplanMenuOption = !!(currentUser && currentUser.isWorkPlanActive);
				$scope.rut = currentUser && currentUser.dsIdentification ? currentUser.dsIdentification : '';
				$scope.mathRandom = Math.random();
				$scope.notPicture = __webpack_require__(294);
	
				if (currentUser.pictureExtension) {
					$scope.picture = staticServerurl + '/profilepicture/' + currentUser.pictureExtension + '?1=' + $scope.mathRandom;
				} else if (cookiesUser.pictureRosario) {
					$scope.picture = cookiesUser.pictureRosario;
				}
	
				$interval.cancel(getCurrentUser);
	
				$timeout(function () {
					var intialLogin = $cookies.get('isIntialLoginResponse');
					var rid = 0;
	
					rid = $cookies.get('hasRoleId');
	
					if (intialLogin != rid) {
						$cookies.put('isIntialLoginResponse', rid);
						var param = {
							idRole: rid,
							idUser: currentUser.id,
							teacherId: currentUser.teacherId
						};
	
						$.ajax({
							url: localenv.SERVICE_URL_CONSTANT.rosario + '/report/getTimestamp',
							global: false,
							type: 'GET',
							data: $.param(param),
							async: true, //blocks window close
							success: function success() {
								console.log('report is generated');
							}
						});
	
						if (currentUser.teacherId) GlobalSrv.jobForeachPureApi.execute({ teacherId: currentUser.teacherId });
					}
				}, 800);
			}
		}, 500);
	
		function menuClick(e, index) {
			if (flag) {
				if ($('.box-inner #parent_li_' + index).hasClass('active') || $scope.subitems[index][0].url) {
					$('.box-inner #parent_li_' + index).removeClass('active');
				} else {
					$('.box-inner #parent_li_' + index).addClass('active');
				}
			}
	
			flag = true;
		}
	
		function superMenu(element, index) {
			if ($('#super_menu_li_' + index).hasClass('active')) {
				$('#super_menu_li_' + index).removeClass('active');
			} else {
				$('#super_menu_li_' + index).addClass('active');
			}
	
			flag = false;
		}
	
		function super_menu_language(element, index) {
			if ($('#super_menu_li_lang_' + index).hasClass('active')) {
				$('#super_menu_li_lang_' + index).removeClass('active');
			} else {
				$('#super_menu_li_lang_' + index).addClass('active');
			}
	
			flag = false;
		}
	
		function menuLogout(e, index) {
			if (config.loginType === 'web') {
				removeCookies();
				window.location.href = '/login';
			} else {
				var cooky = $cookies.get('currentUser');
				var login = JSON.parse(cooky);
	
				var post = {
					userId: login.id,
					onLine: 0
				};
	
				removeCookies();
				chatboxServices.updateChatStatus.post(post).$promise.then(function () {
					window.location = url + '/logout?id=' + login.id;
				}).catch(function (error) {
					console.error(error);
				});
			}
		}
	
		function toogleAccountClass() {
			$('#nav,#account').toggleClass('hide');
		}
	
		function openAside() {
			$scope.folded = !$scope.folded;
	
			if (!$scope.folded) {
				$('#menubaritem').addClass('menu-right');
				$('#menubaritem').removeClass('menu-left');
				$('#menubaritem2').addClass('menu-right-2');
				$('#menubaritem2').removeClass('menu-left-2');
			} else {
				$('#menubaritem').removeClass('menu-right');
				$('#menubaritem').addClass('menu-left');
				$('#menubaritem2').removeClass('menu-right-2');
				$('#menubaritem2').addClass('menu-left-2');
			}
		}
	
		function openAsideFullscreen() {
			$scope.fullyFolded = !$scope.fullyFolded;
	
			if ($scope.fullyFolded) {
				$('#menubaritem1').addClass('menu-right');
				$('#menubaritem1').removeClass('menu-left');
			} else {
				$('#menubaritem1').removeClass('menu-right');
				$('#menubaritem1').addClass('menu-left');
			}
		}
	
		function callFunction(name) {
			if (angular.isFunction($scope[name])) {
				$scope[name]();
			}
		}
	
		function showModalCreateWorkplan() {
			$mdDialog.show({
				controller: 'workPlanCreateModalCtrl',
				template: __webpack_require__(202),
				clickOutsideToClose: true,
				fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
			});
		}
	
		$scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
			$timeout(function () {
				var string = $location.path();
				var str3 = string.replace(/[0-9]/g, '');
				var str2 = string.replace(/[^\d.]/g, '');
	
				if (str2 > 999) {
					string = string.replace(/\//g, '');
				}
	
				if (str2) {
					string = string.replace(str2, '*');
				}
	
				console.log('El valor de la url es : ', str3);
	
				// let urlParse = $state.current.url.split('?') UNUSED VARIABLE
				if (UserInfoConstant[0].details[0].user['url'].indexOf(string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(str3) > -1) {
					// $state.go('app.unauthorized');
				} else {
						// $location.path('/app/unauthorized')
					}
			}, 200);
		});
	
		// $scope.folded=true;
		$rootScope.$on('CallMyMethod', function () {
			$scope.openAside();
		});
	
		$rootScope.$on('CallMyMethodfullscreen', function () {
			openAsideFullscreen();
		});
	
		$rootScope.$on('profileimagechange', function () {
			alert(1);
			$scope.mathRandom = Math.random();
		});
	
		$rootScope.$on('rootScope:ReportEmit', function (event) {
			getAsideMenu();
		});
		function getAsideMenu() {
			for (var item in $scope.subitems) {
				var showifSubitem = validateRoleSelectedMenu($scope.subitems[item]);
	
				$scope.subitems[item].showif = showifSubitem;
	
				if (showifSubitem) {
					for (var items in $scope.subitems[item][0].subMenu) {
						var showif = validateRoleSelected($scope.subitems[item][0].subMenu[items].rolesAllowed, $scope.subitems[item][0].subMenu[items]);
	
						$scope.subitems[item][0].subMenu[items].showif = showif;
					}
	
					if ($scope.subitems[item][0].subMenu && !$scope.subitems[item][0].subMenu.some(function (item) {
						return item.showif;
					})) {
						$scope.subitems[item].showif = false;
					}
				}
			}
		}
	
		function validateRoleSelected(rolSelected, subMenu) {
			if (!rolSelected) {
				var show = false;
	
				if (!subMenu.superMenu) {
					var _url = subMenu.url;
	
					var ref = $state.href(_url);
	
					if (!ref) return false;
	
					var processedUrl = processUrl(ref);
	
					if (UserInfoConstant[0].details[0].user['url'].indexOf(processedUrl.string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(processedUrl.str3) > -1) {
						show = true;
					}
	
					return show;
				}
	
				for (var i = 0; i < subMenu.superMenu.length; i++) {
					var _url2 = subMenu.superMenu[i].url;
	
					var _ref = $state.href(_url2);
	
					if (!_ref) continue;
	
					var _processedUrl = processUrl(_ref);
	
					if (UserInfoConstant[0].details[0].user['url'].indexOf(_processedUrl.string) > -1 || UserInfoConstant[0].details[0].user['url'].indexOf(_processedUrl.str3) > -1) {
						show = true;
						subMenu.superMenu.showIf = true;
					} else {
						subMenu.superMenu.showIf = false;
					}
				}
	
				return show;
			} else {
				return rolSelected.indexOf(parseInt($cookies.get('hasRoleId'))) > -1;
			}
		}
	
		function processUrl(url) {
			var str3 = url.replace(/[0-9]/g, '');
			var str2 = url.replace(/[^\d.]/g, '');
	
			if (str2 > 999) {
				url = url.replace(/\//g, '');
			}
	
			if (str2) {
				url = url.replace(str2, '*');
			}
	
			if (str3 == '/app/evaluations/teacherAssessment/') {
				if (str2) {
					str3 += '*';
				}
			}
	
			if (url.length > 1 && url.endsWith('/')) {
				url = url.slice(0, url.length - 1);
			}
	
			return {
				string: url,
				str2: str2,
				str3: str3
			};
		}
	
		function validateTeacherTypeSelected(option) {
			var user = $cookies.getObject('currentUser');
	
			if (user) {
				if (user.teacherId) {
					if (option == GlobalConfig.menuModulesId.Portfolio) return user.isPortfolio;
	
					if (option == GlobalConfig.menuModulesId.Profile) return user.isProfile;
	
					if (option == GlobalConfig.menuModulesId.StrategicTracking) {
						return user.isWorkPlanActive;
					}
				}
			}
	
			return true;
		}
	
		function validateRoleSelectedMenu(item) {
			if (item && item[0]) {
				if (validateTeacherTypeSelected(item[0].moduleId)) {
					if (typeof item[0].subMenu !== 'undefined') {
						var hasSubMenu = false;
	
						for (var i = 0; i < item[0].subMenu.length; i++) {
							var rolSelected = item[0].subMenu[i].rolesAllowed;
	
							if (!rolSelected) {
								hasSubMenu = true;
								i = item[0].subMenu.length;
							} else {
								if (rolSelected.indexOf(parseInt($cookies.get('hasRoleId'))) > -1) {
									hasSubMenu = true;
									i = item[0].subMenu.length;
								}
							}
						}
	
						return hasSubMenu;
					} else {
						return true;
					}
				}
			}
		}
	
		function validateSubModule(menuRoleId, stageId) {
			if (!menuRoleId || !stageId) {
				return true;
			} else {
				//si el item del panel izquierdo es la opcion del index
				if (menuRoleId && menuRoleId[0] == GlobalConfig.modules.indexOption) {
					var isApproved = JSON.parse($cookies.get('isApproved'));
	
					if (isApproved == 1 || isApproved == 2) {
						return false;
					} else {
						return true;
					}
				}
	
				var user = JSON.parse($cookies.get('currentUser'));
				var isReproved = JSON.parse($cookies.get('isReproved'));
	
				return searchValue(JSON.parse($cookies.get('subModuleId')), menuRoleId[0], JSON.parse($cookies.get('stageId')), stageId[0], user.isFeedback, user.isFeedbackPlanning, isReproved);
			}
		}
	
		function searchValue(arraySubmodule, submoduleId, arrayStage, stageId, feedback, feedbackPlanning, isReproved) {
			var result = false;
	
			// validar que en la cookie tenga esa etapa y ademas esta entre las fechas acordes
			for (var i = 0, len = arrayStage.length; i < len; i++) {
				if (arrayStage[i].stageId == stageId && compareDates(arrayStage[i].startDate, arrayStage[i].endDate)) {
					if (stageId == GlobalConfig.workplanIdStages.planning) {
						// validar que este retroalimentado
						result = (feedback == 0 ? feedback == 0 : feedback == 1 && feedbackPlanning == 0) && !isReproved;
						break;
					} else {
						result = true;
						break;
					}
				}
			}
	
			if (result) {
				// si el id de submodulo es ejecucion mostrarlo ya que se encuentra en la etapa deseada
				if (submoduleId == GlobalConfig.modules.execution) {
					// Si el plan no esta aprobado no se muestra la opcion de ejecuci�n
					var isApproved = JSON.parse($cookies.get('isApproved'));
	
					if (isApproved == 1 || isApproved == 2) {
						return true;
					} else {
						return false;
					}
				}
	
				result = false;
	
				for (var i = 0, len = arraySubmodule.length; i < len; i++) {
					if (arraySubmodule[i].submoduleId == submoduleId) {
						result = true;
						break;
					}
				}
			}
	
			return result;
		}
	
		function compareDates(startDate, endDate) {
			var now = moment({ hour: 0, minute: 0, second: 0, millisecond: 0 });
			var start = moment(startDate);
			var end = moment(endDate);
	
			if (now.isBefore(end) && now.isAfter(start) || now.isSame(start) || now.isSame(end)) {
				return true;
			} else {
				return false;
			}
		}
	
		function validateIfWorkPlanActive(forWorkplanActiveMenu) {
			if (forWorkplanActiveMenu) {
				return $scope.showWorkplanMenuOption;
			} else {
				return true;
			}
		}
	
		function setCookiesValues(response) {
			var serviceResponse = angular.copy(response);
	
			if (!$cookies.get('currentUser')) {
				var header = { userId: response.user.id };
	
				GlobalSrv.getUserInfo.get(header).$promise.then(function (dataReturn) {
					serviceResponse.user.teacherId = dataReturn.teacherId;
					serviceResponse.user.workplanId = dataReturn.workplanId;
					serviceResponse.user.isWorkPlanActive = dataReturn.isWorkPlanActive;
					serviceResponse.user.dsIdentification = dataReturn.dsIdentification;
					serviceResponse.user.dsFullname = dataReturn.dsFullname;
					serviceResponse.user.isPortfolio = dataReturn.isPortfolio;
					serviceResponse.user.isProfile = dataReturn.isProfile;
	
					$scope.isProfile = serviceResponse.user.isProfile;
	
					if (serviceResponse.user.isWorkPlanActive) {
						$scope.showWorkplanMenuOption = true;
					} else {
						$scope.showWorkplanMenuOption = false;
					}
	
					delete serviceResponse.user.permissions;
					delete serviceResponse.user.url;
					serviceResponse.user.isFeedback = dataReturn.isFeedback;
					serviceResponse.user.isFeedbackPlanning = dataReturn.isFeedbackPlanning;
					$cookies.putObject('currentUser', serviceResponse.user);
					$cookies.putObject('subModuleId', dataReturn.summodules);
					$cookies.putObject('stageId', dataReturn.stages);
					$cookies.putObject('reviewers', dataReturn.reviewers);
					$cookies.put('isReproved', dataReturn.isReproved);
					$cookies.put('isApproved', dataReturn.isApproved);
					$scope.rut = dataReturn.dsIdentification;
					$scope.mathRandom = Math.random();
					$scope.picture = staticServerurl + '/profilepicture/' + serviceResponse.user.pictureExtension + '?1=' + $scope.mathRandom;
				});
			}
	
			$cookies.put('adminName', $scope.admin.name);
	
			if (!$cookies.get('hasRoleId')) {
				if (!response.user.role[0]) {
					return;
				}
	
				$cookies.put('hasRoleId', response.user.role[0].role_id);
				$cookies.put('roleName', response.user.role[0].role_name);
				$scope.rolActive = response.user.role[0].role_name;
			} else {
				var idRol = $cookies.get('hasRoleId');
	
				for (var i = 0; i < response.user.role.length; i++) {
					if (response.user.role[i].role_id == idRol) {
						$scope.rolActive = response.user.role[i].role_name;
	
						i = response.user.role.length;
					}
				}
			}
	
			window.Intercom('boot', {
				api_base: 'https://api-iam.intercom.io',
				app_id: 'rio5bzun',
				name: response.user.name,
				email: response.user.email,
				group_id: passGroupIds2Intercom(response.user),
				group_name: passGroupNames2Intercom(response.user),
				rol_id: passRoleIds2Intercom(response.user),
				rol_name: passRoleNames2Intercom(response.user),
				subdomain: window.location.host.split('.')[0],
				created_at: new Date().toISOString()
			});
		}
	
		function notificationUserInbox(response) {
			var header = { userId: response.user.id };
	
			GlobalSrv.getScheduledInbox.get(header).$promise.then(function () {
				return GlobalSrv.getUserInbox.get(header).$promise;
			}).then(function (dataReturn) {
				if (dataReturn.status) {
					console.log(dataReturn);
					$scope.notificationUserInbox = dataReturn.data;
				} else {
					$scope.notificationUserInbox = [];
				}
	
				$rootScope.$emit('CallSetNotifications', $scope.notificationUserInbox);
			}).catch(function (error) {
				console.log(error);
			});
		}
	
		function workPlanGeneral() {
			var listUser = JSON.parse($cookies.get('currentUser'));
			var post = {
				teacherId: listUser.teacherId,
				workplanId: listUser.workplanId
			};
	
			if (post.teacherId != undefined && post.teacherId != null && $sessionStorage.workPlanGeneralList == undefined) {
				GlobalSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						$sessionStorage.workPlanGeneralList = dataReturn.data;
					} else {
						console.log('Comunications problem with the server');
					}
				}, function (data) {
					console.log(data);
				});
			}
		}
	
		function countNotificationsUserInboxNoRead() {
			var header = { userId: $scope.idUser };
	
			GlobalSrv.getCountNotificationsUserInboxNoRead.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status == true) {
					$scope.countNotificationsUserInboxNoRead = dataReturn.data[0].countNotificationsUserInboxNoRead;
				} else {
					$scope.countNotificationsUserInboxNoRead = '';
				}
	
				$rootScope.$emit('CallSetCountNotificationsUserInboxNoRead', $scope.countNotificationsUserInboxNoRead);
			}, function (dataReturn) {
				console.log(dataReturn);
			});
		}
	
		function removeCookies() {
			$cookies.put('hasDemand', '');
			$cookies.remove('isAdmin');
			$cookies.remove('hasType');
			$cookies.remove('hasRoleId');
			$cookies.remove('currentUser');
			$cookies.remove('subModuleId');
			$cookies.remove('stageId');
			$cookies.remove('reviewers');
			$cookies.remove('isReproved');
			$cookies.remove('adminName');
			$cookies.remove('roleName');
			$cookies.remove('isIntialLogin');
			$cookies.remove('isIntialLoginResponse');
			delete $sessionStorage.workPlanGeneralList;
			delete $localStorage.userLogin;
			delete $localStorage.userAuth;
		}
	
		function passGroupNames2Intercom(userInfo) {
			var userGroups = '';
	
			if (userInfo.groups.length) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = userInfo.groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var group = _step.value;
	
						userGroups += group.groupname + ', ';
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return userGroups;
			}
	
			return notGroupAssigned;
		}
	
		function passRoleNames2Intercom(userInfo) {
			var userRoles = '';
	
			if (userInfo.role.length) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = userInfo.role[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var role = _step2.value;
	
						userRoles += role.role_name + ', ';
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return userRoles;
			}
	
			return notRoleAssigned;
		}
	
		function passGroupIds2Intercom(userInfo) {
			var userGroupIds = '';
	
			if (userInfo.groups.length) {
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;
	
				try {
					for (var _iterator3 = userInfo.groups[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var role = _step3.value;
	
						userGroupIds += role.groupid + ', ';
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
	
				return userGroupIds;
			}
	
			return notGroupAssigned;
		}
	
		function passRoleIds2Intercom(userInfo) {
			var userRoleIds = '';
	
			if (userInfo.role.length) {
				var _iteratorNormalCompletion4 = true;
				var _didIteratorError4 = false;
				var _iteratorError4 = undefined;
	
				try {
					for (var _iterator4 = userInfo.role[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
						var role = _step4.value;
	
						userRoleIds += role.role_id + ', ';
					}
				} catch (err) {
					_didIteratorError4 = true;
					_iteratorError4 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion4 && _iterator4.return) {
							_iterator4.return();
						}
					} finally {
						if (_didIteratorError4) {
							throw _iteratorError4;
						}
					}
				}
	
				return userRoleIds;
			}
	
			return notRoleAssigned;
		}
	};
	
	exports.default = AsideCtrl;
	
	
	AsideCtrl.$inject = ['$scope', '$http', '$timeout', '$resource', '$location', '$cookieStore', 'MenuConstant', 'UserInfoConstant', 'permissionList', 'permissions', '$state', '$rootScope', '$mdDialog', '$cookies', 'GlobalSrv', 'chatboxServices', 'GlobalConfig', '$interval', 'adminPanel', 'reportSrv', '$localStorage', '$sessionStorage', '$translate', 'FileUploader', 'SERVICE_URL_CONSTANT', 'Helpers', 'LOCAL_ENV_CONSTANT'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-Planning
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller
	* # name: welcomeCtrl
	* # alias: wCtrl
	*/
	
	var welcomeCtrl = function welcomeCtrl($rootScope, $scope, $state, $stateParams, $timeout, $cookies, $interval) {
	  _classCallCheck(this, welcomeCtrl);
	
	  this.$scope = $scope;
	
	  var getUserInfo = $interval(function () {
	    $scope.adminName = $cookies.get('adminName');
	    if ($scope.adminName) {
	      $scope.roleName = $cookies.get('roleName');
	      $interval.cancel(getUserInfo);
	    }
	  }, 500);
	
	  this.$state = $state;
	  this.$timeout = $timeout;
	  this.$stateParams = $stateParams;
	  this.$cookies = $cookies;
	  this.$rootScope = $rootScope;
	  this.$rootScope.fullscreenClass = 'background-planning';
	};
	
	exports.default = welcomeCtrl;
	
	
	welcomeCtrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$timeout', '$cookies', '$interval'];

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HeaderCtrl = function HeaderCtrl($scope, $http, $timeout, $resource, $location, MenuConstant, UserInfoConstant, permissionList, permissions, $state, $rootScope, $translate, $cookies, $mdSidenav, GlobalConfig, GlobalSrv, $mdDialog, $interval, $stateParams) {
	  _classCallCheck(this, HeaderCtrl);
	
	  var localenv = __webpack_require__(159);
	  var stages = GlobalConfig.workplanStagesNames;
	  $scope.roleClick = roleClick;
	  $scope.notificationUserInboxClick = notificationUserInboxClick;
	  $scope.notificationUserInboxAllClick = notificationUserInboxAllClick;
	  $scope.notificationUserInboxAll = [];
	  $scope.notificationUserInboxDetailClick = notificationUserInboxDetailClick;
	  $scope.toUpdate = toUpdate;
	  $rootScope.showChat = false;
	  $rootScope.showComments = false;
	  $rootScope.showReflections = false;
	
	  $timeout(function () {
	    $interval(function () {
	      $scope.notificationsChat = $rootScope.chatNotifications;
	      // $scope.notificationsOberv = 5
	      // $scope.notificationsReflex = 2
	      $scope.totalNotifications = $scope.notificationsChat; // + $scope.notificationsOberv + $scope.notificationsReflex
	      $scope.rolId = $cookies.getObject('hasRoleValue');
	    }, 3000);
	  }, 1500);
	
	  $scope.menuTitle = '';
	  if ($state.current && $state.current.params && $state.current.params.stage) {
	    if (stages[$state.current.params.stage] != undefined) {
	      $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$state.current.params.stage];
	    } else {
	      $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$location.search().currentStage];
	    }
	  }
	
	  $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
	    if ($state.current && $state.current.params && $state.current.params.stage) {
	      if (stages[$state.current.params.stage] != undefined) {
	        $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$state.current.params.stage];
	      } else {
	        $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$location.search().currentStage];
	      }
	    } else {
	      $scope.menuTitle = '';
	    }
	  });
	
	  $scope.lang = $cookies.get('lang');
	  $scope.languages = [{
	    'key': 'es',
	    'value': 'Spanish',
	    'src': 'assets/images/flags/es.png'
	  }, {
	    'key': 'en',
	    'value': 'English',
	    'src': 'assets/images/flags/en.png'
	  }];
	
	  if (typeof $scope.lang === 'undefined') $scope.lang = 'es';
	
	  $translate.use($scope.lang);
	
	  $scope.languageHeader = updateLanguageKey($scope.lang, $scope.languages);
	
	  /* $scope.updateLanguage = function() {
	  console.log($scope.language)
	  $translate.use($scope.language.key);
	  }; */
	
	  $scope.updateLanguage1 = function (key) {
	    console.log(key);
	    $translate.use(key);
	    $scope.languageHeader = updateLanguageKey(key, $scope.languages);
	    console.log($scope.languageHeader);
	  };
	
	  $scope.asideParentClick = function () {
	    $('slick').slick('refresh');
	    $rootScope.$emit('CallMyMethod', {});
	  };
	
	  $scope.asideParentClickfullScreen = function () {
	    $('slick').slick('refresh');
	    $rootScope.$emit('CallMyMethodfullscreen', {});
	  };
	
	  $rootScope.$on('$translateChangeSuccess', function (event, data) {
	    console.log('translateChangeSucces');
	    var language = data.language;
	    $cookies.put('lang', language);
	    $rootScope.lang = language;
	    // $rootScope.$emit("CallMyMethod", {});
	  });
	
	  function updateLanguageKey(key, value) {
	    for (var i in value) {
	      if (value[i].key === key) {
	        return value[i];
	      }
	    }
	  }
	
	  $rootScope.$on('CallSetNotifications', function (event, notificationUserInbox) {
	    $scope.notificationUserInbox = notificationUserInbox;
	  });
	
	  $rootScope.$on('CallSetCountNotificationsUserInboxNoRead', function (event, countNotificationsUserInboxNoRead) {
	    $scope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead;
	  });
	
	  $rootScope.$on('CallMyMethodRoles', function (event, roles) {
	    $scope.roles = roles;
	  });
	
	  function roleClick(role) {
	    $cookies.put('roleName', role.role_name);
	    $cookies.remove('isIntialLogin');
	    switch (role.role_id) {
	      case GlobalConfig.userRolesIds.consultant:
	      case GlobalConfig.userRolesIds.approver:
	      case GlobalConfig.userRolesIds.reviewer:
	      case GlobalConfig.userRolesIds.teacher:
	        $cookies.put('hasRoleValue', true);
	        break;
	      default:
	        $cookies.put('hasRoleValue', false);
	        break;
	    }
	
	    $cookies.put('hasRoleId', role.role_id);
	
	    $rootScope.$emit('rootScope:ReportEmit', 'ReportEmit!'); // $rootScope.$on     
	    $state.go('fullscreen.welcomeHome', {}, { reload: true });
	  }
	
	  /* $scope.sessionChat = function(bool){
	    $cookies.put('onlineStatus',true);
	    $cookies.put('status',bool);
	  } */
	
	  $scope.openChat = function (bool) {
	    $scope.rolSelect = $cookies.getObject('hasRoleId');
	
	    switch ($scope.rolSelect) {
	      case GlobalConfig.userRolesIds.consultant:
	      case GlobalConfig.userRolesIds.approver:
	      case GlobalConfig.userRolesIds.reviewer:
	      case GlobalConfig.userRolesIds.teacher:
	        $rootScope.showChat = true;
	        $rootScope.openContacts = true;
	        $rootScope.showComments = false;
	        $rootScope.showReflections = false;
	        break;
	      default:
	        $rootScope.showChat = false;
	        break;
	    }
	  };
	
	  $scope.openComments = function () {
	    $scope.rolSelect = $cookies.getObject('hasRoleId');
	
	    switch ($scope.rolSelect) {
	      case GlobalConfig.userRolesIds.consultant:
	      case GlobalConfig.userRolesIds.approver:
	      case GlobalConfig.userRolesIds.reviewer:
	      case GlobalConfig.userRolesIds.teacher:
	        $rootScope.showChat = false;
	        $rootScope.showComments = true;
	        $rootScope.showReflections = false;
	        break;
	      default:
	        break;
	    }
	  };
	
	  $scope.openReflections = function () {
	    $scope.rolSelect = $cookies.getObject('hasRoleId');
	
	    switch ($scope.rolSelect) {
	      case GlobalConfig.userRolesIds.consultant:
	      case GlobalConfig.userRolesIds.approver:
	      case GlobalConfig.userRolesIds.reviewer:
	      case GlobalConfig.userRolesIds.teacher:
	        $rootScope.showChat = false;
	        $rootScope.showComments = false;
	        $rootScope.showReflections = true;
	        break;
	      default:
	        break;
	    }
	  };
	
	  function notificationUserInboxClick(varNotificationUserInbox) {
	    // update is_read
	    udpateIsReadNotificationUserInbox(varNotificationUserInbox, popUpNotification);
	  }
	
	  function popUpNotification(varNotificationUserInbox) {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        console.log(varNotificationUserInbox);
	        $scope.msgInboxDate = varNotificationUserInbox.dt_creationDate;
	        $scope.msgInboxName = varNotificationUserInbox.ds_name;
	        $scope.msgInboxDescription = varNotificationUserInbox.ds_description;
	        $scope.close = function () {
	          return $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(863),
	      clickOutsideToClose: true
	    });
	  }
	
	  function popUpNotificationAll(varNotificationUserInbox) {
	    $mdDialog.show({
	      controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	        $scope.msgInboxIdUser = varNotificationUserInbox.id_user;
	        $scope.msgInboxDate = varNotificationUserInbox.dt_creationDate;
	        $scope.msgInboxName = varNotificationUserInbox.ds_name;
	        $scope.msgInboxDescription = varNotificationUserInbox.ds_description;
	        $scope.notificationUserInboxAllClick = notificationUserInboxAllClick;
	        $scope.close = function () {
	          $mdDialog.hide();
	        };
	      }],
	      template: __webpack_require__(864),
	      clickOutsideToClose: true
	    });
	  }
	
	  function notificationUserInboxAllClick(id_user) {
	    var header = { userId: $cookies.getObject('currentUser').id };
	    GlobalSrv.getUserInboxAllNoRead.get(header).$promise.then(function (dataReturn) {
	      if (dataReturn.status == true) {
	        $mdDialog.show({
	          controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
	            $scope.allData = dataReturn.data;
	            $scope.notificationUserInboxDetailClick = notificationUserInboxDetailClick;
	            $scope.close = function () {
	              $mdDialog.hide();
	            };
	          }],
	          template: __webpack_require__(865),
	          clickOutsideToClose: true
	        });
	      } else {
	        $scope.notificationUserInboxAll = [];
	      }
	    }, function (dataReturn) {
	      console.log(dataReturn);
	    });
	  }
	
	  function cleanNotificationUserInbox(varNotificationUserInbox) {
	    for (var i in $scope.notificationUserInbox) {
	      if (varNotificationUserInbox.id_code == $scope.notificationUserInbox[i].id_code) {
	        $scope.notificationUserInbox.splice(i, 1);
	        break;
	      }
	    }
	  }
	
	  function udpateIsReadNotificationUserInbox(varNotificationUserInbox, callback) {
	    GlobalSrv.updateNotificationReadingMessagesUserInbox.update({
	      msgIdCode: varNotificationUserInbox.id_code
	    }).$promise.then(function (dataReturn) {
	      console.log(dataReturn);
	      if (dataReturn.status) {
	        //reload
	        $rootScope.countNotificationsUserInboxNoRead();
	        $rootScope.$on('CallSetCountNotificationsUserInboxNoRead', function (event, countNotificationsUserInboxNoRead) {
	          $scope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead;
	        });
	        cleanNotificationUserInbox(varNotificationUserInbox);
	        callback(varNotificationUserInbox);
	      } else {
	        console.log('error de comunicacion con el servidor');
	      }
	    }, function (data) {
	      console.log(data);
	    });
	  }
	  function notificationUserInboxDetailClick(varNotificationUserInbox) {
	    // update is_read
	    udpateIsReadNotificationUserInbox(varNotificationUserInbox, popUpNotificationAll);
	  }
	
	  function toUpdate() {
	    var role = {
	      role_name: 'Profesor',
	      role_id: 13
	    };
	
	    $cookies.put('roleName', role.role_name);
	    $cookies.remove('isIntialLogin');
	    switch (role.role_id) {
	      case GlobalConfig.userRolesIds.consultant:
	      case GlobalConfig.userRolesIds.approver:
	      case GlobalConfig.userRolesIds.reviewer:
	      case GlobalConfig.userRolesIds.teacher:
	        $cookies.put('hasRoleValue', true);
	        break;
	      default:
	        $cookies.put('hasRoleValue', false);
	        break;
	    }
	
	    $cookies.put('hasRoleId', role.role_id);
	
	    $rootScope.$emit('rootScope:ReportEmit', 'ReportEmit!'); // $rootScope.$on
	    // $state.reload()
	    $state.go('fullscreen.welcomeHome');
	    $state.reload();
	
	    // let header = {userId: UserInfoConstant[0].details[0].user.id}
	    // GlobalSrv.getUserInfo.get(header).$promise.then((dataReturn) => {
	
	    //   $cookies.putObject('subModuleId', dataReturn.summodules)
	    //   $cookies.putObject('stageId', dataReturn.stages)
	    //   $cookies.putObject('reviewers', dataReturn.reviewers)
	    //   $cookies.put('isReproved', dataReturn.isApproved)
	    //   $cookies.put('isApproved', dataReturn.isReproved)
	    //   $scope.rut = dataReturn.dsIdentification
	    //   // $cookies.remove('isIntialLogin')
	
	    // })
	  }
	};
	
	exports.default = HeaderCtrl;
	
	
	HeaderCtrl.$inject = ['$scope', '$http', '$timeout', '$resource', '$location', 'MenuConstant', 'UserInfoConstant', 'permissionList', 'permissions', '$state', '$rootScope', '$translate', '$cookies', '$mdSidenav', 'GlobalConfig', 'GlobalSrv', '$mdDialog', '$interval', '$stateParams'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> <h3 class=\"text-verde text-center\">Mensaje inbox usuario</h3> </md-toolbar> <md-dialog-content> <div class=\"row title\"> <div class=\"col-md-12 text-left\"> <p class=p-b><span class=\"exo text-gris-dark font-semibold\">Fecha:</span><br> {{msgInboxDate}} </p> <p class=p-b><span class=\"exo text-gris-dark font-semibold\">Nombre:</span><br> {{msgInboxName}} </p> <p class=p-b><span class=\"exo text-gris-dark font-semibold\">Descripción:</span><br></p><div ng-bind-html=msgInboxDescription></div> <p></p> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=notificationUserInboxAllClick(msgInboxIdUser)> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> <h3 class=\"text-verde text-center\">Mensaje inbox usuario</h3> </md-toolbar> <md-dialog-content> <div class=\"row title\"> <div class=\"col-md-12 text-left\"> <p class=p-b><span class=\"exo font-semibold\">Fecha:</span><br> {{msgInboxDate}} </p> <p class=p-b><span class=\"exo font-semibold\">Nombre:</span><br> {{msgInboxName}} </p> <p class=p-b><span class=\"exo font-semibold\">Descripción:</span><br></p><div ng-bind-html=msgInboxDescription></div><p></p> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog flex=40> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> <div class=\"row exo text-azul text-center\"> <h3>Todas las notificaciones</h3> </div> </md-toolbar> <md-dialog-content style=height:450px> <div class=title> <div class=col-md-12> <p ng-repeat=\"var in allData\" ui-sref-active=active id=super_menu_li_{{$index}} class=\"text-left super_menu_li b-b\"> <a md-ink-ripple ng-click=notificationUserInboxDetailClick(var) style=width:100%;height:100%;padding:10px;display:block;overflow:hidden> <span class=text-xs>{{var.dt_creationDate | date:'yyyy-MM-dd'}}</span><br> {{var.ds_name}} </a> </p> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  F: __webpack_require__(867),
	  T: __webpack_require__(871),
	  __: __webpack_require__(872),
	  add: __webpack_require__(873),
	  addIndex: __webpack_require__(875),
	  adjust: __webpack_require__(880),
	  all: __webpack_require__(882),
	  allPass: __webpack_require__(889),
	  always: __webpack_require__(868),
	  and: __webpack_require__(905),
	  any: __webpack_require__(906),
	  anyPass: __webpack_require__(908),
	  ap: __webpack_require__(909),
	  aperture: __webpack_require__(910),
	  append: __webpack_require__(913),
	  apply: __webpack_require__(914),
	  applySpec: __webpack_require__(915),
	  ascend: __webpack_require__(917),
	  assoc: __webpack_require__(918),
	  assocPath: __webpack_require__(919),
	  binary: __webpack_require__(921),
	  bind: __webpack_require__(896),
	  both: __webpack_require__(923),
	  call: __webpack_require__(927),
	  chain: __webpack_require__(929),
	  clamp: __webpack_require__(934),
	  clone: __webpack_require__(935),
	  comparator: __webpack_require__(939),
	  complement: __webpack_require__(940),
	  compose: __webpack_require__(942),
	  composeK: __webpack_require__(949),
	  composeP: __webpack_require__(950),
	  concat: __webpack_require__(953),
	  cond: __webpack_require__(971),
	  construct: __webpack_require__(972),
	  constructN: __webpack_require__(973),
	  contains: __webpack_require__(974),
	  converge: __webpack_require__(975),
	  countBy: __webpack_require__(976),
	  curry: __webpack_require__(928),
	  curryN: __webpack_require__(877),
	  dec: __webpack_require__(979),
	  descend: __webpack_require__(980),
	  defaultTo: __webpack_require__(981),
	  difference: __webpack_require__(982),
	  differenceWith: __webpack_require__(983),
	  dissoc: __webpack_require__(985),
	  dissocPath: __webpack_require__(986),
	  divide: __webpack_require__(987),
	  drop: __webpack_require__(988),
	  dropLast: __webpack_require__(990),
	  dropLastWhile: __webpack_require__(995),
	  dropRepeats: __webpack_require__(998),
	  dropRepeatsWith: __webpack_require__(1000),
	  dropWhile: __webpack_require__(1003),
	  either: __webpack_require__(1005),
	  empty: __webpack_require__(1007),
	  eqBy: __webpack_require__(1008),
	  eqProps: __webpack_require__(1009),
	  equals: __webpack_require__(958),
	  evolve: __webpack_require__(1010),
	  filter: __webpack_require__(967),
	  find: __webpack_require__(1011),
	  findIndex: __webpack_require__(1013),
	  findLast: __webpack_require__(1015),
	  findLastIndex: __webpack_require__(1017),
	  flatten: __webpack_require__(1019),
	  flip: __webpack_require__(1020),
	  forEach: __webpack_require__(1021),
	  forEachObjIndexed: __webpack_require__(1022),
	  fromPairs: __webpack_require__(1023),
	  groupBy: __webpack_require__(1024),
	  groupWith: __webpack_require__(1025),
	  gt: __webpack_require__(1026),
	  gte: __webpack_require__(1027),
	  has: __webpack_require__(1028),
	  hasIn: __webpack_require__(1029),
	  head: __webpack_require__(1030),
	  identical: __webpack_require__(962),
	  identity: __webpack_require__(1031),
	  ifElse: __webpack_require__(1033),
	  inc: __webpack_require__(1034),
	  indexBy: __webpack_require__(1035),
	  indexOf: __webpack_require__(1036),
	  init: __webpack_require__(1037),
	  insert: __webpack_require__(1038),
	  insertAll: __webpack_require__(1039),
	  intersection: __webpack_require__(1040),
	  intersectionWith: __webpack_require__(1044),
	  intersperse: __webpack_require__(1046),
	  into: __webpack_require__(1047),
	  invert: __webpack_require__(1052),
	  invertObj: __webpack_require__(1053),
	  invoker: __webpack_require__(1054),
	  is: __webpack_require__(1055),
	  isArrayLike: __webpack_require__(897),
	  isEmpty: __webpack_require__(1056),
	  isNil: __webpack_require__(1057),
	  join: __webpack_require__(1058),
	  juxt: __webpack_require__(1059),
	  keys: __webpack_require__(900),
	  keysIn: __webpack_require__(1060),
	  last: __webpack_require__(1001),
	  lastIndexOf: __webpack_require__(1061),
	  length: __webpack_require__(1062),
	  lens: __webpack_require__(1064),
	  lensIndex: __webpack_require__(1065),
	  lensPath: __webpack_require__(1067),
	  lensProp: __webpack_require__(1069),
	  lift: __webpack_require__(925),
	  liftN: __webpack_require__(926),
	  lt: __webpack_require__(1070),
	  lte: __webpack_require__(1071),
	  map: __webpack_require__(892),
	  mapAccum: __webpack_require__(1072),
	  mapAccumRight: __webpack_require__(1073),
	  mapObjIndexed: __webpack_require__(1074),
	  match: __webpack_require__(1075),
	  mathMod: __webpack_require__(1076),
	  max: __webpack_require__(890),
	  maxBy: __webpack_require__(1077),
	  mean: __webpack_require__(1078),
	  median: __webpack_require__(1080),
	  memoize: __webpack_require__(1081),
	  merge: __webpack_require__(1082),
	  mergeAll: __webpack_require__(1083),
	  mergeWith: __webpack_require__(1084),
	  mergeWithKey: __webpack_require__(1085),
	  min: __webpack_require__(1086),
	  minBy: __webpack_require__(1087),
	  modulo: __webpack_require__(1088),
	  multiply: __webpack_require__(1089),
	  nAry: __webpack_require__(922),
	  negate: __webpack_require__(1090),
	  none: __webpack_require__(1091),
	  not: __webpack_require__(941),
	  nth: __webpack_require__(1002),
	  nthArg: __webpack_require__(1092),
	  objOf: __webpack_require__(1051),
	  of: __webpack_require__(1093),
	  omit: __webpack_require__(1095),
	  once: __webpack_require__(1096),
	  or: __webpack_require__(1006),
	  over: __webpack_require__(1097),
	  pair: __webpack_require__(1098),
	  partial: __webpack_require__(1099),
	  partialRight: __webpack_require__(1101),
	  partition: __webpack_require__(1102),
	  path: __webpack_require__(1068),
	  pathEq: __webpack_require__(1103),
	  pathOr: __webpack_require__(1104),
	  pathSatisfies: __webpack_require__(1105),
	  pick: __webpack_require__(1106),
	  pickAll: __webpack_require__(1107),
	  pickBy: __webpack_require__(1108),
	  pipe: __webpack_require__(943),
	  pipeK: __webpack_require__(1109),
	  pipeP: __webpack_require__(951),
	  pluck: __webpack_require__(891),
	  prepend: __webpack_require__(1110),
	  product: __webpack_require__(1111),
	  project: __webpack_require__(1112),
	  prop: __webpack_require__(903),
	  propEq: __webpack_require__(1114),
	  propIs: __webpack_require__(1115),
	  propOr: __webpack_require__(1116),
	  propSatisfies: __webpack_require__(1117),
	  props: __webpack_require__(1118),
	  range: __webpack_require__(1119),
	  reduce: __webpack_require__(904),
	  reduceBy: __webpack_require__(977),
	  reduceRight: __webpack_require__(1120),
	  reduceWhile: __webpack_require__(1121),
	  reduced: __webpack_require__(1122),
	  reject: __webpack_require__(965),
	  remove: __webpack_require__(1123),
	  repeat: __webpack_require__(1124),
	  replace: __webpack_require__(1126),
	  reverse: __webpack_require__(948),
	  scan: __webpack_require__(1127),
	  sequence: __webpack_require__(1128),
	  set: __webpack_require__(1129),
	  slice: __webpack_require__(947),
	  sort: __webpack_require__(1130),
	  sortBy: __webpack_require__(1131),
	  sortWith: __webpack_require__(1132),
	  split: __webpack_require__(1133),
	  splitAt: __webpack_require__(1134),
	  splitEvery: __webpack_require__(1135),
	  splitWhen: __webpack_require__(1136),
	  subtract: __webpack_require__(1137),
	  sum: __webpack_require__(1079),
	  symmetricDifference: __webpack_require__(1138),
	  symmetricDifferenceWith: __webpack_require__(1139),
	  tail: __webpack_require__(945),
	  take: __webpack_require__(992),
	  takeLast: __webpack_require__(1140),
	  takeLastWhile: __webpack_require__(1141),
	  takeWhile: __webpack_require__(1142),
	  tap: __webpack_require__(1144),
	  test: __webpack_require__(1145),
	  times: __webpack_require__(1125),
	  toLower: __webpack_require__(1147),
	  toPairs: __webpack_require__(1148),
	  toPairsIn: __webpack_require__(1149),
	  toString: __webpack_require__(954),
	  toUpper: __webpack_require__(1150),
	  transduce: __webpack_require__(1151),
	  transpose: __webpack_require__(1152),
	  traverse: __webpack_require__(1153),
	  trim: __webpack_require__(1154),
	  tryCatch: __webpack_require__(1155),
	  type: __webpack_require__(938),
	  unapply: __webpack_require__(1156),
	  unary: __webpack_require__(1157),
	  uncurryN: __webpack_require__(1158),
	  unfold: __webpack_require__(1159),
	  union: __webpack_require__(1160),
	  unionWith: __webpack_require__(1161),
	  uniq: __webpack_require__(1041),
	  uniqBy: __webpack_require__(1042),
	  uniqWith: __webpack_require__(1045),
	  unless: __webpack_require__(1162),
	  unnest: __webpack_require__(1163),
	  until: __webpack_require__(1164),
	  update: __webpack_require__(1066),
	  useWith: __webpack_require__(1113),
	  values: __webpack_require__(916),
	  valuesIn: __webpack_require__(1165),
	  view: __webpack_require__(1166),
	  when: __webpack_require__(1167),
	  where: __webpack_require__(1168),
	  whereEq: __webpack_require__(1169),
	  without: __webpack_require__(1170),
	  xprod: __webpack_require__(1171),
	  zip: __webpack_require__(1172),
	  zipObj: __webpack_require__(1173),
	  zipWith: __webpack_require__(1174)
	};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	var always = __webpack_require__(868);
	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	module.exports = always(false);


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	module.exports = _curry1(function always(val) {
	  return function() {
	    return val;
	  };
	});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(870);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ }),
/* 870 */
/***/ (function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var always = __webpack_require__(868);
	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	module.exports = always(true);


/***/ }),
/* 872 */
/***/ (function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	module.exports = _curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _isPlaceholder = __webpack_require__(870);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry1 = __webpack_require__(869);
	var curryN = __webpack_require__(877);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, Ramda's simple `map` function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ }),
/* 876 */
/***/ (function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _curry1 = __webpack_require__(869);
	var _curry2 = __webpack_require__(874);
	var _curryN = __webpack_require__(879);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ }),
/* 878 */
/***/ (function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _isPlaceholder = __webpack_require__(870);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	module.exports = _curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _curry2 = __webpack_require__(874);
	var _isPlaceholder = __webpack_require__(870);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xall = __webpack_require__(886);
	
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(884);
	var _isTransformer = __webpack_require__(885);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ }),
/* 884 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduced = __webpack_require__(887);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function(result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function(result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
	}());


/***/ }),
/* 887 */
/***/ (function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ }),
/* 888 */
/***/ (function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var curryN = __webpack_require__(877);
	var max = __webpack_require__(890);
	var pluck = __webpack_require__(891);
	var reduce = __webpack_require__(904);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	module.exports = _curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var map = __webpack_require__(892);
	var prop = __webpack_require__(903);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig k -> [{k: v}] -> [v]
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _map = __webpack_require__(893);
	var _reduce = __webpack_require__(894);
	var _xmap = __webpack_require__(899);
	var curryN = __webpack_require__(877);
	var keys = __webpack_require__(900);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ }),
/* 893 */
/***/ (function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(895);
	var bind = __webpack_require__(896);
	var isArrayLike = __webpack_require__(897);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ }),
/* 895 */
/***/ (function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _isArray = __webpack_require__(884);
	var _isString = __webpack_require__(898);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @deprecated since v0.23.0
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ }),
/* 898 */
/***/ (function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _has = __webpack_require__(901);
	var _isArguments = __webpack_require__(902);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ }),
/* 901 */
/***/ (function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(901);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var _reduce = __webpack_require__(894);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xany = __webpack_require__(907);
	
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduced = __webpack_require__(887);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function(result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
	}());


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var curryN = __webpack_require__(877);
	var max = __webpack_require__(890);
	var pluck = __webpack_require__(891);
	var reduce = __webpack_require__(904);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	module.exports = _curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry2 = __webpack_require__(874);
	var _reduce = __webpack_require__(894);
	var map = __webpack_require__(892);
	
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @param {Array} fns An array of functions
	 * @param {Array} vs An array of values
	 * @return {Array} An array of results of applying each of `fns` to all of `vs` in turn.
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	module.exports = _curry2(function ap(applicative, fn) {
	  return (
	    typeof applicative.ap === 'function' ?
	      applicative.ap(fn) :
	    typeof applicative === 'function' ?
	      function(x) { return applicative(x)(fn(x)); } :
	    // else
	      _reduce(function(acc, f) { return _concat(acc, map(f, fn)); }, [], applicative)
	  );
	});


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	var _aperture = __webpack_require__(911);
	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xaperture = __webpack_require__(912);
	
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ }),
/* 911 */
/***/ (function(module, exports) {

	module.exports = function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	};


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function(result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function() {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos),
	                   Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
	}());


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	module.exports = _curry2(function append(el, list) {
	  return _concat(list, [el]);
	});


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var apply = __webpack_require__(914);
	var curryN = __webpack_require__(877);
	var map = __webpack_require__(892);
	var max = __webpack_require__(890);
	var pluck = __webpack_require__(891);
	var reduce = __webpack_require__(904);
	var values = __webpack_require__(916);
	
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *                                      sum: R.add,
	 *                                      nested: { mul: R.multiply }
	 *                                   });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	module.exports = _curry1(function applySpec(spec) {
	  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
	             spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))),
	                function() {
	                  var args = arguments;
	                  return map(function(f) { return apply(f, args); }, spec);
	                });
	});


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var keys = __webpack_require__(900);
	
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	module.exports = _curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var _has = __webpack_require__(901);
	var _isArray = __webpack_require__(884);
	var _isInteger = __webpack_require__(920);
	var assoc = __webpack_require__(918);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	module.exports = _curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});


/***/ }),
/* 920 */
/***/ (function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return (n << 0) === n;
	};


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var nAry = __webpack_require__(922);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	module.exports = _curry1(function binary(fn) {
	  return nAry(2, fn);
	});


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isFunction = __webpack_require__(924);
	var and = __webpack_require__(905);
	var lift = __webpack_require__(925);
	
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	module.exports = _curry2(function both(f, g) {
	  return _isFunction(f) ?
	    function _both() {
	      return f.apply(this, arguments) && g.apply(this, arguments);
	    } :
	    lift(and)(f, g);
	});


/***/ }),
/* 924 */
/***/ (function(module, exports) {

	module.exports = function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	};


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var liftN = __webpack_require__(926);
	
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	module.exports = _curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduce = __webpack_require__(894);
	var ap = __webpack_require__(909);
	var curryN = __webpack_require__(877);
	var map = __webpack_require__(892);
	
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	module.exports = _curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function() {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var curry = __webpack_require__(928);
	
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * `R.converge`: the left branch can produce a function while the right branch
	 * produces a value to be passed to that function as an argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.times(R.always(' ')),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	module.exports = curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var curryN = __webpack_require__(877);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _makeFlat = __webpack_require__(930);
	var _xchain = __webpack_require__(931);
	var map = __webpack_require__(892);
	
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	module.exports = _curry2(_dispatchable(['chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function(x) { return fn(monad(x))(x); };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(897);
	
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	module.exports = function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	};


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _flatCat = __webpack_require__(932);
	var map = __webpack_require__(892);
	
	
	module.exports = _curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var _forceReduced = __webpack_require__(933);
	var _reduce = __webpack_require__(894);
	var _xfBase = __webpack_require__(888);
	var isArrayLike = __webpack_require__(897);
	
	module.exports = (function() {
	  var preservingReduced = function(xf) {
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return xf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        var ret = xf['@@transducer/step'](result, input);
	        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	      }
	    };
	  };
	
	  return function _xcat(xf) {
	    var rxf = preservingReduced(xf);
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return rxf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        return !isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	      }
	    };
	  };
	}());


/***/ }),
/* 933 */
/***/ (function(module, exports) {

	module.exports = function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	};


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	module.exports = _curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min :
	         value > max ? max :
	         value;
	});


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(936);
	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	module.exports = _curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ?
	    value.clone() :
	    _clone(value, [], [], true);
	});


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(937);
	var type = __webpack_require__(938);
	
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	module.exports = function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ?
	        _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':  return copy({});
	    case 'Array':   return copy([]);
	    case 'Date':    return new Date(value.valueOf());
	    case 'RegExp':  return _cloneRegExp(value);
	    default:        return value;
	  }
	};


/***/ }),
/* 937 */
/***/ (function(module, exports) {

	module.exports = function _cloneRegExp(pattern) {
	  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
	                                    (pattern.ignoreCase ? 'i' : '') +
	                                    (pattern.multiline  ? 'm' : '') +
	                                    (pattern.sticky     ? 'y' : '') +
	                                    (pattern.unicode    ? 'u' : ''));
	};


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a, b -> Boolean) -> (a, b -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	module.exports = _curry1(function comparator(pred) {
	  return function(a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var lift = __webpack_require__(925);
	var not = __webpack_require__(941);
	
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	module.exports = lift(not);


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(943);
	var reverse = __webpack_require__(948);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _pipe = __webpack_require__(944);
	var reduce = __webpack_require__(904);
	var tail = __webpack_require__(945);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ }),
/* 944 */
/***/ (function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(946);
	var _curry1 = __webpack_require__(869);
	var slice = __webpack_require__(947);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(884);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(946);
	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _isString = __webpack_require__(898);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var chain = __webpack_require__(929);
	var compose = __webpack_require__(942);
	var map = __webpack_require__(892);
	
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	module.exports = function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var pipeP = __webpack_require__(951);
	var reverse = __webpack_require__(948);
	
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	module.exports = function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	};


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _pipeP = __webpack_require__(952);
	var reduce = __webpack_require__(904);
	var tail = __webpack_require__(945);
	
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	module.exports = function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipeP, arguments[0], tail(arguments)));
	};


/***/ }),
/* 952 */
/***/ (function(module, exports) {

	module.exports = function _pipeP(f, g) {
	  return function() {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function(x) {
	      return g.call(ctx, x);
	    });
	  };
	};


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isArray = __webpack_require__(884);
	var _isFunction = __webpack_require__(924);
	var toString = __webpack_require__(954);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	module.exports = _curry2(function concat(a, b) {
	  if (a == null || !_isFunction(a.concat)) {
	    throw new TypeError(toString(a) + ' does not have a method named "concat"');
	  }
	  if (_isArray(a) && !_isArray(b)) {
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  return a.concat(b);
	});


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _toString = __webpack_require__(955);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(956);
	var _map = __webpack_require__(893);
	var _quote = __webpack_require__(963);
	var _toISOString = __webpack_require__(964);
	var keys = __webpack_require__(900);
	var reject = __webpack_require__(965);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(957);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(958);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _equals = __webpack_require__(959);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(960);
	var _functionName = __webpack_require__(961);
	var _has = __webpack_require__(901);
	var identical = __webpack_require__(962);
	var keys = __webpack_require__(900);
	var type = __webpack_require__(938);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ }),
/* 960 */
/***/ (function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ }),
/* 961 */
/***/ (function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ }),
/* 963 */
/***/ (function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ }),
/* 964 */
/***/ (function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(966);
	var _curry2 = __webpack_require__(874);
	var filter = __webpack_require__(967);
	
	
	/**
	 * The complement of `filter`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ }),
/* 966 */
/***/ (function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _filter = __webpack_require__(968);
	var _isObject = __webpack_require__(969);
	var _reduce = __webpack_require__(894);
	var _xfilter = __webpack_require__(970);
	var keys = __webpack_require__(900);
	
	
	/**
	 * Takes a predicate and a "filterable", and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _curry1 = __webpack_require__(869);
	var map = __webpack_require__(892);
	var max = __webpack_require__(890);
	var reduce = __webpack_require__(904);
	
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	module.exports = _curry1(function cond(pairs) {
	  var arity = reduce(max,
	                     0,
	                     map(function(pair) { return pair[0].length; }, pairs));
	  return _arity(arity, function() {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var constructN = __webpack_require__(973);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	module.exports = _curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var curry = __webpack_require__(928);
	var nAry = __webpack_require__(922);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      };
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map((ingredient) => (
	 *          'Add a whollop of ' + ingredient, this.ingredients)
	 *        )
	 *        return R.join('\n', instructions)
	 *      }
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad)
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
	 *      console.log(salad.recipe());
	 *      // Add a whollop of Mayonnaise
	 *      // Add a whollop of Potato Chips
	 *      // Add a whollop of Potato Ketchup
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(956);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns `true` if the specified value is equal, in `R.equals` terms, to at
	 * least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	module.exports = _curry2(_contains);


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _map = __webpack_require__(893);
	var curryN = __webpack_require__(877);
	var max = __webpack_require__(890);
	var pluck = __webpack_require__(891);
	var reduce = __webpack_require__(904);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(977);
	
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(879);
	var _dispatchable = __webpack_require__(883);
	var _has = __webpack_require__(901);
	var _reduce = __webpack_require__(894);
	var _xreduceBy = __webpack_require__(978);
	
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general `groupBy` function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
	  function reduceBy(valueFn, valueAcc, keyFn, list) {
	    return _reduce(function(acc, elt) {
	      var key = keyFn(elt);
	      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	      return acc;
	    }, {}, list);
	  }));


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(879);
	var _has = __webpack_require__(901);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function(result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return _curryN(4, [],
	                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	                 });
	}());


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(873);
	
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	module.exports = add(-1);


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	module.exports = _curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(956);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared are compared
	 * in terms of value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	module.exports = _curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(984);
	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	module.exports = _curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) &&
	        !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 984 */
/***/ (function(module, exports) {

	module.exports = function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var assoc = __webpack_require__(918);
	var dissoc = __webpack_require__(985);
	
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @sig [String] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	module.exports = _curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      return obj[head] == null ? obj : assoc(head, dissocPath(tail, obj[head]), obj);
	  }
	});


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xdrop = __webpack_require__(989);
	var slice = __webpack_require__(947);
	
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {[a]} list
	 * @return {[a]} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function(result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
	}());


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _dropLast = __webpack_require__(991);
	var _xdropLast = __webpack_require__(994);
	
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var take = __webpack_require__(992);
	
	module.exports = function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	};


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xtake = __webpack_require__(993);
	var slice = __webpack_require__(947);
	
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduced = __webpack_require__(887);
	var _xfBase = __webpack_require__(888);
	
	module.exports = (function() {
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function(result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
	}());


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] =  function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
	}());


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _dropLastWhile = __webpack_require__(996);
	var _xdropLastWhile = __webpack_require__(997);
	
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ }),
/* 996 */
/***/ (function(module, exports) {

	module.exports = function dropLastWhile(pred, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && pred(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx + 1);
	};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduce = __webpack_require__(894);
	var _xfBase = __webpack_require__(888);
	
	module.exports = (function() {
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.retain(result, input)
	                         : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function(result, input) {
	    result = _reduce(
	      this.xf['@@transducer/step'],
	      result,
	      this.retained
	    );
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function(result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
	}());


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _dispatchable = __webpack_require__(883);
	var _xdropRepeatsWith = __webpack_require__(999);
	var dropRepeatsWith = __webpack_require__(1000);
	var equals = __webpack_require__(958);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. `R.equals`
	 * is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xdropRepeatsWith = __webpack_require__(999);
	var last = __webpack_require__(1001);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(1002);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isString = __webpack_require__(898);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xdropWhile = __webpack_require__(1004);
	
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 */
	module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && pred(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, idx);
	}));


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
	}());


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isFunction = __webpack_require__(924);
	var lift = __webpack_require__(925);
	var or = __webpack_require__(1006);
	
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	module.exports = _curry2(function either(f, g) {
	  return _isFunction(f) ?
	    function _either() {
	      return f.apply(this, arguments) || g.apply(this, arguments);
	    } :
	    lift(or)(f, g);
	});


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	module.exports = _curry2(function or(a, b) {
	  return a || b;
	});


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _isArguments = __webpack_require__(902);
	var _isArray = __webpack_require__(884);
	var _isObject = __webpack_require__(969);
	var _isString = __webpack_require__(898);
	
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty` and/or
	 * `<Type>.prototype.empty`.
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	module.exports = _curry1(function empty(x) {
	  return (
	    (x != null && typeof x.empty === 'function') ?
	      x.empty() :
	    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
	      x.constructor.empty() :
	    _isArray(x) ?
	      [] :
	    _isString(x) ?
	      '' :
	    _isObject(x) ?
	      {} :
	    _isArguments(x) ?
	      (function() { return arguments; }()) :
	    // else
	      void 0
	  );
	});


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var equals = __webpack_require__(958);
	
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	module.exports = _curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var equals = __webpack_require__(958);
	
	
	/**
	 * Reports whether two objects have the same value, in `R.equals` terms, for
	 * the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function'                 ? transformation(object[key])
	                : transformation && type === 'object' ? evolve(transformation, object[key])
	                                                      : object[key];
	  }
	  return result;
	});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xfind = __webpack_require__(1012);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduced = __webpack_require__(887);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xfindIndex = __webpack_require__(1014);
	
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduced = __webpack_require__(887);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
	}());


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xfindLast = __webpack_require__(1016);
	
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
	}());


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xfindLastIndex = __webpack_require__(1018);
	
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
	}());


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _makeFlat = __webpack_require__(930);
	
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	module.exports = _curry1(_makeFlat(true));


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var curry = __webpack_require__(928);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(946);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var keys = __webpack_require__(900);
	
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	module.exports = _curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(946);
	var _curry2 = __webpack_require__(874);
	var reduceBy = __webpack_require__(977);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all "equal" according to the provided equality function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of equal elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	module.exports = _curry2(function(fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[idx], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _has = __webpack_require__(901);
	
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	module.exports = _curry2(_has);


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	module.exports = _curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(1002);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _identity = __webpack_require__(1032);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	module.exports = _curry1(_identity);


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var curryN = __webpack_require__(877);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(873);
	
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	module.exports = add(1);


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(977);
	
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _indexOf = __webpack_require__(957);
	var _isArray = __webpack_require__(884);
	
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
	    xs.indexOf(target) :
	    _indexOf(xs, target, 0);
	});


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(947);
	
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	module.exports = slice(0, -1);


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Inserts the supplied element into the list, at index `index`. _Note that
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Inserts the sub-list into the list, at index `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	module.exports = _curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx),
	                   elts,
	                   Array.prototype.slice.call(list, idx));
	});


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(956);
	var _curry2 = __webpack_require__(874);
	var _filter = __webpack_require__(968);
	var flip = __webpack_require__(1020);
	var uniq = __webpack_require__(1041);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.intersectionWith
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	module.exports = _curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(1031);
	var uniqBy = __webpack_require__(1042);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. `R.equals` is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	module.exports = uniqBy(identity);


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	var _Set = __webpack_require__(1043);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. `R.equals` is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	module.exports = _curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(956);
	
	
	// A simple Set type that honours R.equals semantics
	module.exports = (function() {
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function(item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function(item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  function hasOrAdd(item, shouldAdd, set) {
	    var type = typeof item;
	    var prevSize, newSize;
	    switch (type) {
	      case 'string':
	      case 'number':
	        // distinguish between +0 and -0
	        if (item === 0 && 1 / item === -Infinity) {
	          if (set._items['-0']) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items['-0'] = true;
	            }
	            return false;
	          }
	        }
	        // these types can all utilise the native Set
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = {};
	              set._items[type][item] = true;
	            }
	            return false;
	          } else if (item in set._items[type]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][item] = true;
	            }
	            return false;
	          }
	        }
	
	      case 'boolean':
	        // set._items['boolean'] holds a two element array
	        // representing [ falseExists, trueExists ]
	        if (type in set._items) {
	          var bIdx = item ? 1 : 0;
	          if (set._items[type][bIdx]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][bIdx] = true;
	            }
	            return false;
	          }
	        } else {
	          if (shouldAdd) {
	            set._items[type] = item ? [false, true] : [true, false];
	          }
	          return false;
	        }
	
	      case 'function':
	        // compare functions for reference equality
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = [item];
	            }
	            return false;
	          }
	          if (!_contains(item, set._items[type])) {
	            if (shouldAdd) {
	              set._items[type].push(item);
	            }
	            return false;
	          }
	          return true;
	        }
	
	      case 'undefined':
	        if (set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type] = true;
	          }
	          return false;
	        }
	
	      case 'object':
	        if (item === null) {
	          if (!set._items['null']) {
	            if (shouldAdd) {
	              set._items['null'] = true;
	            }
	            return false;
	          }
	          return true;
	        }
	      /* falls through */
	      default:
	        // reduce the search size of heterogeneous sets by creating buckets
	        // for each type.
	        type = Object.prototype.toString.call(item);
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        // scan through all previously applied items
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	    }
	  }
	  return _Set;
	}());


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(984);
	var _curry3 = __webpack_require__(881);
	var uniqWith = __webpack_require__(1045);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate function that determines whether
	 *        the two supplied elements are equal.
	 * @param {Array} list1 One list of items to compare
	 * @param {Array} list2 A second list of items to compare
	 * @return {Array} A new list containing those elements common to both lists.
	 * @see R.intersection
	 * @example
	 *
	 *      var buffaloSpringfield = [
	 *        {id: 824, name: 'Richie Furay'},
	 *        {id: 956, name: 'Dewey Martin'},
	 *        {id: 313, name: 'Bruce Palmer'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *      var csny = [
	 *        {id: 204, name: 'David Crosby'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 539, name: 'Graham Nash'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *
	 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function intersectionWith(pred, list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  var results = [];
	  var idx = 0;
	  while (idx < filteredList.length) {
	    if (_containsWith(pred, filteredList[idx], lookupList)) {
	      results[results.length] = filteredList[idx];
	    }
	    idx += 1;
	  }
	  return uniqWith(pred, results);
	});


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(984);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	module.exports = _curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(946);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(936);
	var _curry3 = __webpack_require__(881);
	var _isTransformer = __webpack_require__(885);
	var _reduce = __webpack_require__(894);
	var _stepCat = __webpack_require__(1048);
	
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	module.exports = _curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ?
	    _reduce(xf(acc), acc['@@transducer/init'](), list) :
	    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(1049);
	var _identity = __webpack_require__(1032);
	var _isTransformer = __webpack_require__(885);
	var isArrayLike = __webpack_require__(897);
	var objOf = __webpack_require__(1051);
	
	
	module.exports = (function() {
	  var _stepCatArray = {
	    '@@transducer/init': Array,
	    '@@transducer/step': function(xs, x) {
	      xs.push(x);
	      return xs;
	    },
	    '@@transducer/result': _identity
	  };
	  var _stepCatString = {
	    '@@transducer/init': String,
	    '@@transducer/step': function(a, b) { return a + b; },
	    '@@transducer/result': _identity
	  };
	  var _stepCatObject = {
	    '@@transducer/init': Object,
	    '@@transducer/step': function(result, input) {
	      return _assign(
	        result,
	        isArrayLike(input) ? objOf(input[0], input[1]) : input
	      );
	    },
	    '@@transducer/result': _identity
	  };
	
	  return function _stepCat(obj) {
	    if (_isTransformer(obj)) {
	      return obj;
	    }
	    if (isArrayLike(obj)) {
	      return _stepCatArray;
	    }
	    if (typeof obj === 'string') {
	      return _stepCatString;
	    }
	    if (typeof obj === 'object') {
	      return _stepCatObject;
	    }
	    throw new Error('Cannot create transformer for ' + obj);
	  };
	}());


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(1050);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(901);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _has = __webpack_require__(901);
	var keys = __webpack_require__(900);
	
	
	/**
	 * Same as R.invertObj, however this accounts for objects with duplicate values
	 * by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys
	 * in an array.
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	module.exports = _curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : (out[val] = []);
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var keys = __webpack_require__(900);
	
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	module.exports = _curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isFunction = __webpack_require__(924);
	var curryN = __webpack_require__(877);
	var toString = __webpack_require__(954);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var empty = __webpack_require__(1007);
	var equals = __webpack_require__(958);
	
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	module.exports = _curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(1054);
	
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	module.exports = invoker(1, 'join');


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var converge = __webpack_require__(975);
	
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	module.exports = _curry1(function juxt(fns) {
	  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
	});


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	module.exports = _curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isArray = __webpack_require__(884);
	var equals = __webpack_require__(958);
	
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _isNumber = __webpack_require__(1063);
	
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	module.exports = _curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	module.exports = function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	};


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var map = __webpack_require__(892);
	
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry2(function lens(getter, setter) {
	  return function(toFunctorFn) {
	    return function(target) {
	      return map(
	        function(focus) {
	          return setter(focus, target);
	        },
	        toFunctorFn(getter(target))
	      );
	    };
	  };
	});


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var lens = __webpack_require__(1064);
	var nth = __webpack_require__(1002);
	var update = __webpack_require__(1066);
	
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	module.exports = _curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var adjust = __webpack_require__(880);
	var always = __webpack_require__(868);
	
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	module.exports = _curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var assocPath = __webpack_require__(919);
	var lens = __webpack_require__(1064);
	var path = __webpack_require__(1068);
	
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	module.exports = _curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	module.exports = _curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var assoc = __webpack_require__(918);
	var lens = __webpack_require__(1064);
	var prop = __webpack_require__(903);
	
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * The mapAccum function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	module.exports = _curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * The mapAccumRight function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to `mapAccum`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	module.exports = _curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduce = __webpack_require__(894);
	var keys = __webpack_require__(900);
	
	
	/**
	 * An Object-specific version of `map`. The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * `map` instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	module.exports = _curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function(acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	module.exports = _curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isInteger = __webpack_require__(920);
	
	
	/**
	 * mathMod behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, R.modulo). So while "-17 % 5" is -2,
	 * mathMod(-17, 5) is 3. mathMod requires Integer arguments, and returns NaN
	 * when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	module.exports = _curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) { return NaN; }
	  if (!_isInteger(p) || p < 1) { return NaN; }
	  return ((m % p) + p) % p;
	});


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	module.exports = _curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var sum = __webpack_require__(1079);
	
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	module.exports = _curry1(function mean(list) {
	  return sum(list) / list.length;
	});


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(873);
	var reduce = __webpack_require__(904);
	
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	module.exports = reduce(add, 0);


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var mean = __webpack_require__(1078);
	
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	module.exports = _curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _curry1 = __webpack_require__(869);
	var _has = __webpack_require__(901);
	var toString = __webpack_require__(954);
	
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @example
	 *
	 *      var count = 0;
	 *      var factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = _curry1(function memoize(fn) {
	  var cache = {};
	  return _arity(fn.length, function() {
	    var key = toString(arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(1049);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(1049);
	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var mergeWithKey = __webpack_require__(1085);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object. The key will be
	 * excluded from the returned object if the resulting value is `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	module.exports = _curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function(_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var _has = __webpack_require__(901);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object. The key
	 * will be excluded from the returned object if the resulting value is
	 * `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	module.exports = _curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !(_has(k, result))) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	module.exports = _curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see `mathMod`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	module.exports = _curry1(function negate(n) { return -n; });


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(966);
	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xany = __webpack_require__(907);
	var any = __webpack_require__(906);
	
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var curryN = __webpack_require__(877);
	var nth = __webpack_require__(1002);
	
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	module.exports = _curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function() {
	    return nth(n, arguments);
	  });
	});


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _of = __webpack_require__(1094);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(956);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	module.exports = _curry2(function omit(names, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (!_contains(prop, names)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	module.exports = _curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function() {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	module.exports = (function() {
	  // `Identity` is a functor that holds a single value, where `map` simply
	  // transforms the held value with the provided function.
	  var Identity = function(x) {
	    return {value: x, map: function(f) { return Identity(f(x)); }};
	  };
	
	  return _curry3(function over(lens, f, x) {
	    // The value returned by the getter function is first transformed with `f`,
	    // then set as the value of an `Identity`. This is then mapped over with the
	    // setter function of the lens.
	    return lens(function(y) { return Identity(f(y)); })(x).value;
	  });
	}());


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _createPartialApplicator = __webpack_require__(1100);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	module.exports = _createPartialApplicator(_concat);


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _curry2 = __webpack_require__(874);
	
	
	module.exports = function _createPartialApplicator(concat) {
	  return _curry2(function(fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function() {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	};


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _createPartialApplicator = __webpack_require__(1100);
	var flip = __webpack_require__(1020);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	module.exports = _createPartialApplicator(flip(_concat));


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	var filter = __webpack_require__(967);
	var juxt = __webpack_require__(1059);
	var reject = __webpack_require__(965);
	
	
	/**
	 * Takes a predicate and a list or other "filterable" object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	module.exports = juxt([filter, reject]);


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var equals = __webpack_require__(958);
	var path = __webpack_require__(1068);
	
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * `R.equals` terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	module.exports = _curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var defaultTo = __webpack_require__(981);
	var path = __webpack_require__(1068);
	
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	module.exports = _curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var path = __webpack_require__(1068);
	
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	module.exports = _curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	var composeK = __webpack_require__(949);
	var reverse = __webpack_require__(948);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	module.exports = function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	};


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	var multiply = __webpack_require__(1089);
	var reduce = __webpack_require__(904);
	
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	module.exports = reduce(multiply, 1);


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	var _map = __webpack_require__(893);
	var identity = __webpack_require__(1031);
	var pickAll = __webpack_require__(1107);
	var useWith = __webpack_require__(1113);
	
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var curryN = __webpack_require__(877);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var equals = __webpack_require__(958);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in `R.equals`
	 * terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var is = __webpack_require__(1055);
	
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	module.exports = _curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var _has = __webpack_require__(901);
	
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	module.exports = _curry3(function propOr(val, p, obj) {
	  return (obj != null && _has(p, obj)) ? obj[p] : val;
	});


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _isNumber = __webpack_require__(1063);
	
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	module.exports = _curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to `reduce`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a, b -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *          -               -2
	 *         / \              / \
	 *        1   -            1   3
	 *           / \              / \
	 *          2   -     ==>    2  -1
	 *             / \              / \
	 *            3   -            3   4
	 *               / \              / \
	 *              4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	module.exports = _curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(879);
	var _reduce = __webpack_require__(894);
	var _reduced = __webpack_require__(887);
	
	
	/**
	 * Like `reduce`, `reduceWhile` returns a single item by iterating through
	 * the list, successively calling the iterator function. `reduceWhile` also
	 * takes a predicate that is evaluated before each step. If the predicate returns
	 * `false`, it "short-circuits" the iteration and returns the current value
	 * of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function(acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _reduced = __webpack_require__(887);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by reduceRight.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *      R.reduce(
	 *        R.pipe(R.add, R.when(R.gte(R.__, 10), R.reduced)),
	 *        0,
	 *        [1, 2, 3, 4, 5]) // 10
	 */
	
	module.exports = _curry1(_reduced);


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	module.exports = _curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var always = __webpack_require__(868);
	var times = __webpack_require__(1125);
	
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	module.exports = _curry2(function repeat(value, n) {
	  return times(always(value), n);
	});


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	module.exports = _curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	module.exports = _curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Scan is similar to reduce, but returns a list of successively reduced values
	 * from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a,b -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	module.exports = _curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var ap = __webpack_require__(909);
	var map = __webpack_require__(892);
	var prepend = __webpack_require__(1110);
	var reduceRight = __webpack_require__(1120);
	
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	module.exports = _curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ?
	    traversable.sequence(of) :
	    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
	                of([]),
	                traversable);
	});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var always = __webpack_require__(868);
	var over = __webpack_require__(1097);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	module.exports = _curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,a -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	module.exports = _curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	module.exports = _curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [a -> a -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	module.exports = _curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(1054);
	
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	module.exports = invoker(1, 'split');


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var length = __webpack_require__(1062);
	var slice = __webpack_require__(947);
	
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	module.exports = _curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var slice = __webpack_require__(947);
	
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	module.exports = _curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	module.exports = _curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	module.exports = _curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var concat = __webpack_require__(953);
	var difference = __webpack_require__(982);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	module.exports = _curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var concat = __webpack_require__(953);
	var differenceWith = __webpack_require__(983);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var drop = __webpack_require__(988);
	
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	module.exports = _curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 */
	module.exports = _curry2(function takeLastWhile(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && fn(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, idx + 1);
	});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _dispatchable = __webpack_require__(883);
	var _xtakeWhile = __webpack_require__(1143);
	
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 */
	module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && fn(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx);
	}));


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _reduced = __webpack_require__(887);
	var _xfBase = __webpack_require__(888);
	
	
	module.exports = (function() {
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
	}());


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	module.exports = _curry2(function tap(fn, x) {
	  fn(x);
	  return x;
	});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(937);
	var _curry2 = __webpack_require__(874);
	var _isRegExp = __webpack_require__(1146);
	var toString = __webpack_require__(954);
	
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	module.exports = _curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});


/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	module.exports = function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(1054);
	
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	module.exports = invoker(0, 'toLowerCase');


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var _has = __webpack_require__(901);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	module.exports = _curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(1054);
	
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	module.exports = invoker(0, 'toUpperCase');


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	var _reduce = __webpack_require__(894);
	var _xwrap = __webpack_require__(895);
	var curryN = __webpack_require__(877);
	
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the `R.reduced` function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is R.identity. The init
	 * function can be used to provide an initial accumulator, but is ignored by
	 * transduce.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 */
	module.exports = curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 * If some of the rows are shorter than the following rows, their elements are skipped:
	 *
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	module.exports = _curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	var map = __webpack_require__(892);
	var sequence = __webpack_require__(1128);
	
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	module.exports = _curry3(function traverse(of, f, traversable) {
	  return sequence(of, map(f, traversable));
	});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	module.exports = (function() {
	  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	           '\u2029\uFEFF';
	  var zeroWidth = '\u200b';
	  var hasProtoTrim = (typeof String.prototype.trim === 'function');
	  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	    return _curry1(function trim(str) {
	      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	      return str.replace(beginRx, '').replace(endRx, '');
	    });
	  } else {
	    return _curry1(function trim(str) {
	      return str.trim();
	    });
	  }
	}());


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(878);
	var _concat = __webpack_require__(876);
	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, R.unapply derives a variadic function from a function which
	 * takes an array. R.unapply is the inverse of R.apply.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	var nAry = __webpack_require__(922);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	module.exports = _curry1(function unary(fn) {
	  return nAry(1, fn);
	});


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var curryN = __webpack_require__(877);
	
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	module.exports = _curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function() {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	module.exports = _curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry2 = __webpack_require__(874);
	var compose = __webpack_require__(942);
	var uniq = __webpack_require__(1041);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(compose(uniq, _concat));


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(876);
	var _curry3 = __webpack_require__(881);
	var uniqWith = __webpack_require__(1045);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	module.exports = _curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      // coerceArray :: (a|[a]) -> [a]
	 *      var coerceArray = R.unless(R.isArrayLike, R.of);
	 *      coerceArray([1, 2, 3]); //=> [1, 2, 3]
	 *      coerceArray(1);         //=> [1]
	 */
	module.exports = _curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	var _identity = __webpack_require__(1032);
	var chain = __webpack_require__(929);
	
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	module.exports = chain(_identity);


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	module.exports = _curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(869);
	
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	module.exports = _curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	module.exports = (function() {
	  // `Const` is a functor that effectively ignores the function given to `map`.
	  var Const = function(x) {
	    return {value: x, map: function() { return this; }};
	  };
	
	  return _curry2(function view(lens, x) {
	    // Using `Const` effectively ignores the setter function of the `lens`,
	    // leaving the value returned by the getter function unmodified.
	    return lens(Const)(x).value;
	  });
	}());


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	module.exports = _curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var _has = __webpack_require__(901);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as `filter` and `find`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(__, 10),
	 *        y: R.lt(__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	module.exports = _curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	var equals = __webpack_require__(958);
	var map = __webpack_require__(892);
	var where = __webpack_require__(1168);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in `R.equals` terms) as accessing that property of the spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	module.exports = _curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(956);
	var _curry2 = __webpack_require__(874);
	var flip = __webpack_require__(1020);
	var reject = __webpack_require__(965);
	
	
	/**
	 * Returns a new list without values in the first argument.
	 * `R.equals` is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	module.exports = _curry2(function(xs, list) {
	  return reject(flip(_contains)(xs), list);
	});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	module.exports = _curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(874);
	
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(881);
	
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,b -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	module.exports = _curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});


/***/ }),
/* 1175 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var onlyInteger = exports.onlyInteger = function onlyInteger() {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      element.on('keypress', function (event) {
	        if (!isIntegerChar()) {
	          event.preventDefault();
	        }
	        function isIntegerChar() {
	          return (/[0-9]|-/.test(String.fromCharCode(event.which))
	          );
	        }
	      });
	    }
	  };
	};
	
	var errSrc = exports.errSrc = function errSrc() {
	  return {
	    scope: { errSrcResolve: '&' },
	    link: function link(scope, element, attrs) {
	      var setSrcToErr = function setSrcToErr() {
	        if (attrs.src !== attrs.errSrc) {
	          attrs.$set('src', attrs.errSrc);
	        }
	      };
	
	      var onError = function onError() {
	        if (!scope.errSrcResolve()) return setSrcToErr();
	        scope.errSrcResolve()(setSrcToErr);
	      };
	
	      element.bind('error', onError);
	    }
	  };
	};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = angular.module('directive.userAuthDirective', []).directive('userAuthDirective', function () {
		var controller = ['$rootScope', '$scope', '$http', '$timeout', '$resource', '$location', 'MenuConstant', 'UserInfoConstant', 'permissionList', 'permissions', '$mdSidenav', '$state', '$cookies', '$stateParams', '$localStorage', 'GlobalSrv', 'ngNotify', '$interval', function ($rootScope, $scope, $http, $timeout, $resource, $location, MenuConstant, UserInfoConstant, permissionList, permissions, $mdSidenav, $state, $cookies, $stateParams, $localStorage, GlobalSrv, ngNotify, $interval) {
			console.log('Por aqui pase yo!');
	
			var localenv = __webpack_require__(159);
	
			if (localenv.USER_API_URL != false) {
				var url = localenv.USER_API_URL + '/api/user-api';
				var serverUrl = localenv.SERVER_NAME + 'app' + $state.current.url;
	
				$cookies.remove('hasDemand');
				$cookies.remove('hasType');
				$cookies.remove('groupids');
	
				var protocol = $location.protocol();
	
				if (protocol == 'http') {
					$cookies.put('ESTSAUTH_INTIAL', 'true');
				}
	
				var ESTSAUTH = $cookies.get('ESTSAUTH_INTIAL');
	
				if ((typeof ESTSAUTH === 'undefined' || ESTSAUTH == 'false') && protocol == 'https') {
					//  $cookies.put('ESTSAUTH_INTIAL',true)
					window.location = url;
	
					return;
				} else {
					if (localenv.loginType == 'web') {
						wsdlFunctionCallback();
					} else if (localenv.loginType == 'saml' || localenv.loginType == 'adal') {
						samlFunctionCallback();
					} else {
						casAdalFunctionCallback();
					}
				}
			} else {
				$scope.admin = userSettingDefault.user;
				UserInfoConstant[0].details.push(userSettingDefault);
				permissions.setPermissions(userSettingDefault.user.permissions[0]);
				$scope.subitems = MenuConstant[0].menu;
			}
	
			var flag = true;
	
			function casAdalFunctionCallback() {
				$.ajax({
					dataType: 'jsonp',
					data: 'returnTo=' + serverUrl,
					jsonp: 'callback',
					url: url,
					cache: true,
					async: true,
					headers: {
						'Access-Control-Allow-Origin': '*',
						'Access-Control-Allow-Methods': 'GET,OPTIONS',
						'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
						'Content-Type': 'text/plain',
						'Accept-Language': 'en-US'
					},
					xhrFields: {
						withCredentials: true
					},
					crossDomain: true,
					success: function success(response) {
						var temp = JSON.parse(decodeURIComponent(atob(response).split('').map(function (c) {
							return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
						}).join('')));
	
						response = temp;
						setResponseData(response);
					},
					error: function error(xhr, ajaxOptions, thrownError) {
						window.location = url;
						console.log(thrownError);
					}
				});
			}
	
			function samlFunctionCallback() {
				var searchObject = $location.search().idUserToken;
	
				if (typeof searchObject !== 'undefined') {
					var temp = JSON.parse(decodeURIComponent(atob(searchObject).split('').map(function (c) {
						return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
					}).join('')));
	
					console.log(temp);
	
					GlobalSrv.getUserInfo.POST(temp).$promise.then(function (response) {
						var data = response.data;
	
						if (response.status == 1) {
							$localStorage.userLogin = data;
							$location.search('idUserToken', null);
	
							if (typeof data === 'undefined') {
								window.location = url;
							} else {
								setResponseData(data);
							}
						} else {
							//  $cookies.remove('userLogin');
							delete $localStorage.userLogin;
							// window.location = url;
						}
					}).catch(function (error) {
						window.location = url;
					});
				} else {
					var cookieObject = $localStorage.userLogin;
	
					if (typeof cookieObject === 'undefined') {
						window.location = url;
					} else {
						setResponseData(cookieObject);
					}
				}
			}
	
			function wsdlFunctionCallback() {
				var cookieObject = $localStorage.userAuth;
				var autoLogin = $localStorage.autoLogin;
	
				if (autoLogin) {
					try {
						autoLogin = decodeURIComponent(escape(window.atob(autoLogin)));
						var email = autoLogin;
	
						delete $localStorage.autoLogin;
						var param = {
							users: {},
							type: 'autoLogin'
						};
	
						param['users'] = {
							sn: email,
							givenname: email,
							name: email,
							mail: email
						};
	
						GlobalSrv.getUserInfoMetta.POST(param).$promise.then(function (response) {
							if (response.status == 1) {
								var data = Helpers.getUserStored(response.data);
	
								$localStorage.userLogin = data;
								$localStorage.userAuth = response.data;
								$localStorage.logintime = Date.now();
								window.location = LOCAL_ENV_CONSTANT.HOMEPAGE;
							} else {
								delete $localStorage.userLogin;
								delete $localStorage.userAuth;
							}
						}).catch(function () {
							window.location = url + '?returnTo=' + serverUrl;
						});
					} catch (e) {
						delete $localStorage.userLogin;
						delete $localStorage.userAuth;
						window.location = LOCAL_ENV_CONSTANT.HOMEPAGE;
					}
				} else if (typeof cookieObject === 'undefined') {
					$state.go('login');
				} else {
					setResponseData(Helpers.getUserStored(cookieObject));
				}
			}
	
			function setResponseData(cookieObject) {
				var response = cookieObject;
	
				$scope.admin = response.user;
				$rootScope.admin = response.user;
				$localStorage.userLogin = response;
				$cookies.put('token', response.token);
				UserInfoConstant[0].details.push(response);
				permissions.setPermissions(response.user.permissions[0]);
				$timeout(function () {
					$rootScope.urlAllowed = UserInfoConstant[0].details[0].user['url'];
					$rootScope.subitems = MenuConstant[0].menu;
					$rootScope.urlImage = response.user.picture;
	
					console.log(response.user.picture);
					$rootScope.defaultImage = __webpack_require__(294);
				}, 200);
			}
		}];
	
		// var template ='';
		return {
			restrict: 'EA', //Default in 1.3+
			scope: {
				datasource: '=',
				add: '&' //,
				// WORKSPACEID:'@workspaceid',
				// REPORTID:'@reportid'
			},
			controller: controller
			// template: template
		};
	}).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	/*! powerbi-client v2.5.1 | (c) 2016 Microsoft Corporation MIT */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["powerbi-client"] = factory();
		else
			root["powerbi-client"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var service = __webpack_require__(1);
		exports.service = service;
		var factories = __webpack_require__(15);
		exports.factories = factories;
		var models = __webpack_require__(4);
		exports.models = models;
		var report_1 = __webpack_require__(5);
		exports.Report = report_1.Report;
		var dashboard_1 = __webpack_require__(11);
		exports.Dashboard = dashboard_1.Dashboard;
		var tile_1 = __webpack_require__(12);
		exports.Tile = tile_1.Tile;
		var embed_1 = __webpack_require__(2);
		exports.Embed = embed_1.Embed;
		var page_1 = __webpack_require__(6);
		exports.Page = page_1.Page;
		var qna_1 = __webpack_require__(13);
		exports.Qna = qna_1.Qna;
		var visual_1 = __webpack_require__(14);
		exports.Visual = visual_1.Visual;
		var visualDescriptor_1 = __webpack_require__(7);
		exports.VisualDescriptor = visualDescriptor_1.VisualDescriptor;
		/**
		 * Makes Power BI available to the global object for use in applications that don't have module loading support.
		 *
		 * Note: create an instance of the class with the default configuration for normal usage, or save the class so that you can create an instance of the service.
		 */
		var powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
		window.powerbi = powerbi;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var embed = __webpack_require__(2);
		var report_1 = __webpack_require__(5);
		var create_1 = __webpack_require__(10);
		var dashboard_1 = __webpack_require__(11);
		var tile_1 = __webpack_require__(12);
		var page_1 = __webpack_require__(6);
		var qna_1 = __webpack_require__(13);
		var visual_1 = __webpack_require__(14);
		var utils = __webpack_require__(3);
		/**
		 * The Power BI Service embed component, which is the entry point to embed all other Power BI components into your application
		 *
		 * @export
		 * @class Service
		 * @implements {IService}
		 */
		var Service = (function () {
		    /**
		     * Creates an instance of a Power BI Service.
		     *
		     * @param {IHpmFactory} hpmFactory The http post message factory used in the postMessage communication layer
		     * @param {IWpmpFactory} wpmpFactory The window post message factory used in the postMessage communication layer
		     * @param {IRouterFactory} routerFactory The router factory used in the postMessage communication layer
		     * @param {IServiceConfiguration} [config={}]
		     */
		    function Service(hpmFactory, wpmpFactory, routerFactory, config) {
		        var _this = this;
		        if (config === void 0) { config = {}; }
		        this.wpmp = wpmpFactory(config.wpmpName, config.logMessages);
		        this.hpm = hpmFactory(this.wpmp, null, config.version, config.type);
		        this.router = routerFactory(this.wpmp);
		        /**
		         * Adds handler for report events.
		         */
		        this.router.post("/reports/:uniqueId/events/:eventName", function (req, res) {
		            var event = {
		                type: 'report',
		                id: req.params.uniqueId,
		                name: req.params.eventName,
		                value: req.body
		            };
		            _this.handleEvent(event);
		        });
		        this.router.post("/reports/:uniqueId/pages/:pageName/events/:eventName", function (req, res) {
		            var event = {
		                type: 'report',
		                id: req.params.uniqueId,
		                name: req.params.eventName,
		                value: req.body
		            };
		            _this.handleEvent(event);
		        });
		        this.router.post("/reports/:uniqueId/pages/:pageName/visuals/:visualName/events/:eventName", function (req, res) {
		            var event = {
		                type: 'report',
		                id: req.params.uniqueId,
		                name: req.params.eventName,
		                value: req.body
		            };
		            _this.handleEvent(event);
		        });
		        this.router.post("/dashboards/:uniqueId/events/:eventName", function (req, res) {
		            var event = {
		                type: 'dashboard',
		                id: req.params.uniqueId,
		                name: req.params.eventName,
		                value: req.body
		            };
		            _this.handleEvent(event);
		        });
		        this.router.post("/tile/:uniqueId/events/:eventName", function (req, res) {
		            var event = {
		                type: 'tile',
		                id: req.params.uniqueId,
		                name: req.params.eventName,
		                value: req.body
		            };
		            _this.handleEvent(event);
		        });
		        /**
		         * Adds handler for Q&A events.
		         */
		        this.router.post("/qna/:uniqueId/events/:eventName", function (req, res) {
		            var event = {
		                type: 'qna',
		                id: req.params.uniqueId,
		                name: req.params.eventName,
		                value: req.body
		            };
		            _this.handleEvent(event);
		        });
		        this.embeds = [];
		        // TODO: Change when Object.assign is available.
		        this.config = utils.assign({}, Service.defaultConfig, config);
		        if (this.config.autoEmbedOnContentLoaded) {
		            this.enableAutoEmbed();
		        }
		    }
		    /**
		     * Creates new report
		     * @param {HTMLElement} element
		     * @param {embed.IEmbedConfiguration} [config={}]
		     * @returns {embed.Embed}
		     */
		    Service.prototype.createReport = function (element, config) {
		        config.type = 'create';
		        var powerBiElement = element;
		        var component = new create_1.Create(this, powerBiElement, config);
		        powerBiElement.powerBiEmbed = component;
		        this.addOrOverwriteEmbed(component, element);
		        return component;
		    };
		    /**
		     * TODO: Add a description here
		     *
		     * @param {HTMLElement} [container]
		     * @param {embed.IEmbedConfiguration} [config=undefined]
		     * @returns {embed.Embed[]}
		     */
		    Service.prototype.init = function (container, config) {
		        var _this = this;
		        if (config === void 0) { config = undefined; }
		        container = (container && container instanceof HTMLElement) ? container : document.body;
		        var elements = Array.prototype.slice.call(container.querySelectorAll("[" + embed.Embed.embedUrlAttribute + "]"));
		        return elements.map(function (element) { return _this.embed(element, config); });
		    };
		    /**
		     * Given a configuration based on an HTML element,
		     * if the component has already been created and attached to the element, reuses the component instance and existing iframe,
		     * otherwise creates a new component instance.
		     *
		     * @param {HTMLElement} element
		     * @param {embed.IEmbedConfigurationBase} [config={}]
		     * @returns {embed.Embed}
		     */
		    Service.prototype.embed = function (element, config) {
		        if (config === void 0) { config = {}; }
		        return this.embedInternal(element, config);
		    };
		    /**
		     * Given a configuration based on an HTML element,
		     * if the component has already been created and attached to the element, reuses the component instance and existing iframe,
		     * otherwise creates a new component instance.
		     * This is used for the phased embedding API, once element is loaded successfully, one can call 'render' on it.
		     *
		     * @param {HTMLElement} element
		     * @param {embed.IEmbedConfigurationBase} [config={}]
		     * @returns {embed.Embed}
		     */
		    Service.prototype.load = function (element, config) {
		        if (config === void 0) { config = {}; }
		        return this.embedInternal(element, config, /* phasedRender */ true);
		    };
		    Service.prototype.embedInternal = function (element, config, phasedRender) {
		        if (config === void 0) { config = {}; }
		        var component;
		        var powerBiElement = element;
		        if (powerBiElement.powerBiEmbed) {
		            component = this.embedExisting(powerBiElement, config, phasedRender);
		        }
		        else {
		            component = this.embedNew(powerBiElement, config, phasedRender);
		        }
		        return component;
		    };
		    /**
		     * Given a configuration based on a Power BI element, saves the component instance that reference the element for later lookup.
		     *
		     * @private
		     * @param {IPowerBiElement} element
		     * @param {embed.IEmbedConfigurationBase} config
		     * @returns {embed.Embed}
		     */
		    Service.prototype.embedNew = function (element, config, phasedRender) {
		        var componentType = config.type || element.getAttribute(embed.Embed.typeAttribute);
		        if (!componentType) {
		            throw new Error("Attempted to embed using config " + JSON.stringify(config) + " on element " + element.outerHTML + ", but could not determine what type of component to embed. You must specify a type in the configuration or as an attribute such as '" + embed.Embed.typeAttribute + "=\"" + report_1.Report.type.toLowerCase() + "\"'.");
		        }
		        // Saves the type as part of the configuration so that it can be referenced later at a known location.
		        config.type = componentType;
		        var Component = utils.find(function (component) { return componentType === component.type.toLowerCase(); }, Service.components);
		        if (!Component) {
		            throw new Error("Attempted to embed component of type: " + componentType + " but did not find any matching component.  Please verify the type you specified is intended.");
		        }
		        var component = new Component(this, element, config, phasedRender);
		        element.powerBiEmbed = component;
		        this.addOrOverwriteEmbed(component, element);
		        return component;
		    };
		    /**
		     * Given an element that already contains an embed component, load with a new configuration.
		     *
		     * @private
		     * @param {IPowerBiElement} element
		     * @param {embed.IEmbedConfigurationBase} config
		     * @returns {embed.Embed}
		     */
		    Service.prototype.embedExisting = function (element, config, phasedRender) {
		        var component = utils.find(function (x) { return x.element === element; }, this.embeds);
		        if (!component) {
		            throw new Error("Attempted to embed using config " + JSON.stringify(config) + " on element " + element.outerHTML + " which already has embedded comopnent associated, but could not find the existing comopnent in the list of active components. This could indicate the embeds list is out of sync with the DOM, or the component is referencing the incorrect HTML element.");
		        }
		        // TODO: Multiple embedding to the same iframe is not supported in QnA
		        if (config.type && config.type.toLowerCase() === "qna") {
		            return this.embedNew(element, config);
		        }
		        /**
		         * TODO: Dynamic embed type switching could be supported but there is work needed to prepare the service state and DOM cleanup.
		         * remove all event handlers from the DOM, then reset the element to initial state which removes iframe, and removes from list of embeds
		         * then we can call the embedNew function which would allow setting the proper embedUrl and construction of object based on the new type.
		         */
		        if (typeof config.type === "string" && config.type !== component.config.type) {
		            /**
		             * When loading report after create we want to use existing Iframe to optimize load period
		             */
		            if (config.type === "report" && component.config.type === "create") {
		                var report = new report_1.Report(this, element, config, /* phasedRender */ false, element.powerBiEmbed.iframe);
		                report.load(config);
		                element.powerBiEmbed = report;
		                this.addOrOverwriteEmbed(component, element);
		                return report;
		            }
		            throw new Error("Embedding on an existing element with a different type than the previous embed object is not supported.  Attempted to embed using config " + JSON.stringify(config) + " on element " + element.outerHTML + ", but the existing element contains an embed of type: " + this.config.type + " which does not match the new type: " + config.type);
		        }
		        component.load(config, phasedRender);
		        return component;
		    };
		    /**
		     * Adds an event handler for DOMContentLoaded, which searches the DOM for elements that have the 'powerbi-embed-url' attribute,
		     * and automatically attempts to embed a powerbi component based on information from other powerbi-* attributes.
		     *
		     * Note: Only runs if `config.autoEmbedOnContentLoaded` is true when the service is created.
		     * This handler is typically useful only for applications that are rendered on the server so that all required data is available when the handler is called.
		     */
		    Service.prototype.enableAutoEmbed = function () {
		        var _this = this;
		        window.addEventListener('DOMContentLoaded', function (event) { return _this.init(document.body); }, false);
		    };
		    /**
		     * Returns an instance of the component associated with the element.
		     *
		     * @param {HTMLElement} element
		     * @returns {(Report | Tile)}
		     */
		    Service.prototype.get = function (element) {
		        var powerBiElement = element;
		        if (!powerBiElement.powerBiEmbed) {
		            throw new Error("You attempted to get an instance of powerbi component associated with element: " + element.outerHTML + " but there was no associated instance.");
		        }
		        return powerBiElement.powerBiEmbed;
		    };
		    /**
		     * Finds an embed instance by the name or unique ID that is provided.
		     *
		     * @param {string} uniqueId
		     * @returns {(Report | Tile)}
		     */
		    Service.prototype.find = function (uniqueId) {
		        return utils.find(function (x) { return x.config.uniqueId === uniqueId; }, this.embeds);
		    };
		    Service.prototype.addOrOverwriteEmbed = function (component, element) {
		        // remove embeds over the same div element.
		        this.embeds = this.embeds.filter(function (embed) {
		            return embed.element.id !== element.id;
		        });
		        this.embeds.push(component);
		    };
		    /**
		     * Given an HTML element that has a component embedded within it, removes the component from the list of embedded components, removes the association between the element and the component, and removes the iframe.
		     *
		     * @param {HTMLElement} element
		     * @returns {void}
		     */
		    Service.prototype.reset = function (element) {
		        var powerBiElement = element;
		        if (!powerBiElement.powerBiEmbed) {
		            return;
		        }
		        /** Removes the component from an internal list of components. */
		        utils.remove(function (x) { return x === powerBiElement.powerBiEmbed; }, this.embeds);
		        /** Deletes a property from the HTML element. */
		        delete powerBiElement.powerBiEmbed;
		        /** Removes the iframe from the element. */
		        var iframe = element.querySelector('iframe');
		        if (iframe) {
		            if (iframe.remove !== undefined) {
		                iframe.remove();
		            }
		            else {
		                /** Workaround for IE: unhandled rejection TypeError: object doesn't support propert or method 'remove' */
		                iframe.parentElement.removeChild(iframe);
		            }
		        }
		    };
		    /**
		     * handles tile events
		     *
		     * @param {IEvent<any>} event
		     */
		    Service.prototype.handleTileEvents = function (event) {
		        if (event.type === 'tile') {
		            this.handleEvent(event);
		        }
		    };
		    /**
		     * Given an event object, finds the embed component with the matching type and ID, and invokes its handleEvent method with the event object.
		     *
		     * @private
		     * @param {IEvent<any>} event
		     */
		    Service.prototype.handleEvent = function (event) {
		        var embed = utils.find(function (embed) {
		            return (embed.config.uniqueId === event.id);
		        }, this.embeds);
		        if (embed) {
		            var value = event.value;
		            if (event.name === 'pageChanged') {
		                var pageKey = 'newPage';
		                var page = value[pageKey];
		                if (!page) {
		                    throw new Error("Page model not found at 'event.value." + pageKey + "'.");
		                }
		                value[pageKey] = new page_1.Page(embed, page.name, page.displayName, true /* isActive */);
		            }
		            utils.raiseCustomEvent(embed.element, event.name, value);
		        }
		    };
		    /**
		     * API for warm starting powerbi embedded endpoints.
		     * Use this API to preload Power BI Embedded in the background.
		     *
		     * @public
		     * @param {embed.IEmbedConfigurationBase} [config={}]
		     * @param {HTMLElement} [element=undefined]
		     */
		    Service.prototype.preload = function (config, element) {
		        var iframeContent = document.createElement("iframe");
		        iframeContent.setAttribute("style", "display:none;");
		        iframeContent.setAttribute("src", config.embedUrl);
		        iframeContent.setAttribute("scrolling", "no");
		        iframeContent.setAttribute("allowfullscreen", "false");
		        var node = element;
		        if (!node) {
		            node = document.getElementsByTagName("body")[0];
		        }
		        node.appendChild(iframeContent);
		        iframeContent.onload = function () {
		            utils.raiseCustomEvent(iframeContent, "preloaded", {});
		        };
		        return iframeContent;
		    };
		    /**
		     * A list of components that this service can embed
		     */
		    Service.components = [
		        tile_1.Tile,
		        report_1.Report,
		        dashboard_1.Dashboard,
		        qna_1.Qna,
		        visual_1.Visual
		    ];
		    /**
		     * The default configuration for the service
		     */
		    Service.defaultConfig = {
		        autoEmbedOnContentLoaded: false,
		        onError: function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i - 0] = arguments[_i];
		            }
		            return console.log(args[0], args.slice(1));
		        }
		    };
		    Service.DefaultInitEmbedUrl = "http://app.powerbi.com/reportEmbed";
		    return Service;
		}());
		exports.Service = Service;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var utils = __webpack_require__(3);
		var models = __webpack_require__(4);
		/**
		 * Base class for all Power BI embed components
		 *
		 * @export
		 * @abstract
		 * @class Embed
		 */
		var Embed = (function () {
		    /**
		     * Creates an instance of Embed.
		     *
		     * Note: there is circular reference between embeds and the service, because
		     * the service has a list of all embeds on the host page, and each embed has a reference to the service that created it.
		     *
		     * @param {service.Service} service
		     * @param {HTMLElement} element
		     * @param {IEmbedConfigurationBase} config
		     */
		    function Embed(service, element, config, iframe, phasedRender) {
		        this.allowedEvents = [];
		        Array.prototype.push.apply(this.allowedEvents, Embed.allowedEvents);
		        this.eventHandlers = [];
		        this.service = service;
		        this.element = element;
		        this.iframe = iframe;
		        this.embeType = config.type.toLowerCase();
		        this.populateConfig(config);
		        if (this.embeType === 'create') {
		            this.setIframe(false /*set EventListener to call create() on 'load' event*/);
		        }
		        else {
		            this.setIframe(true /*set EventListener to call load() on 'load' event*/, phasedRender);
		        }
		    }
		    /**
		     * Sends createReport configuration data.
		     *
		     * ```javascript
		     * createReport({
		     *   datasetId: '5dac7a4a-4452-46b3-99f6-a25915e0fe55',
		     *   accessToken: 'eyJ0eXA ... TaE2rTSbmg',
		     * ```
		     *
		     * @param {models.IReportCreateConfiguration} config
		     * @returns {Promise<void>}
		     */
		    Embed.prototype.createReport = function (config) {
		        var errors = models.validateCreateReport(config);
		        if (errors) {
		            throw errors;
		        }
		        return this.service.hpm.post("/report/create", config, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Saves Report.
		     *
		     * @returns {Promise<void>}
		     */
		    Embed.prototype.save = function () {
		        return this.service.hpm.post('/report/save', null, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        })
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * SaveAs Report.
		     *
		     * @returns {Promise<void>}
		     */
		    Embed.prototype.saveAs = function (saveAsParameters) {
		        return this.service.hpm.post('/report/saveAs', saveAsParameters, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        })
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Sends load configuration data.
		     *
		     * ```javascript
		     * report.load({
		     *   type: 'report',
		     *   id: '5dac7a4a-4452-46b3-99f6-a25915e0fe55',
		     *   accessToken: 'eyJ0eXA ... TaE2rTSbmg',
		     *   settings: {
		     *     navContentPaneEnabled: false
		     *   },
		     *   pageName: "DefaultPage",
		     *   filters: [
		     *     {
		     *        ...  DefaultReportFilter ...
		     *     }
		     *   ]
		     * })
		     *   .catch(error => { ... });
		     * ```
		     *
		     * @param {models.ILoadConfiguration} config
		     * @param {boolean} phasedRender
		     * @returns {Promise<void>}
		     */
		    Embed.prototype.load = function (config, phasedRender) {
		        var _this = this;
		        var errors = this.validate(config);
		        if (errors) {
		            throw errors;
		        }
		        var path = phasedRender && config.type === 'report' ? this.phasedLoadPath : this.loadPath;
		        return this.service.hpm.post(path, config, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            utils.assign(_this.config, config);
		            return response.body;
		        }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Removes one or more event handlers from the list of handlers.
		     * If a reference to the existing handle function is specified, remove the specific handler.
		     * If the handler is not specified, remove all handlers for the event name specified.
		     *
		     * ```javascript
		     * report.off('pageChanged')
		     *
		     * or
		     *
		     * const logHandler = function (event) {
		     *    console.log(event);
		     * };
		     *
		     * report.off('pageChanged', logHandler);
		     * ```
		     *
		     * @template T
		     * @param {string} eventName
		     * @param {service.IEventHandler<T>} [handler]
		     */
		    Embed.prototype.off = function (eventName, handler) {
		        var _this = this;
		        var fakeEvent = { name: eventName, type: null, id: null, value: null };
		        if (handler) {
		            utils.remove(function (eventHandler) { return eventHandler.test(fakeEvent) && (eventHandler.handle === handler); }, this.eventHandlers);
		            this.element.removeEventListener(eventName, handler);
		        }
		        else {
		            var eventHandlersToRemove = this.eventHandlers
		                .filter(function (eventHandler) { return eventHandler.test(fakeEvent); });
		            eventHandlersToRemove
		                .forEach(function (eventHandlerToRemove) {
		                utils.remove(function (eventHandler) { return eventHandler === eventHandlerToRemove; }, _this.eventHandlers);
		                _this.element.removeEventListener(eventName, eventHandlerToRemove.handle);
		            });
		        }
		    };
		    /**
		     * Adds an event handler for a specific event.
		     *
		     * ```javascript
		     * report.on('pageChanged', (event) => {
		     *   console.log('PageChanged: ', event.page.name);
		     * });
		     * ```
		     *
		     * @template T
		     * @param {string} eventName
		     * @param {service.IEventHandler<T>} handler
		     */
		    Embed.prototype.on = function (eventName, handler) {
		        if (this.allowedEvents.indexOf(eventName) === -1) {
		            throw new Error("eventName is must be one of " + this.allowedEvents + ". You passed: " + eventName);
		        }
		        this.eventHandlers.push({
		            test: function (event) { return event.name === eventName; },
		            handle: handler
		        });
		        this.element.addEventListener(eventName, handler);
		    };
		    /**
		     * Reloads embed using existing configuration.
		     * E.g. For reports this effectively clears all filters and makes the first page active which simulates resetting a report back to loaded state.
		     *
		     * ```javascript
		     * report.reload();
		     * ```
		     */
		    Embed.prototype.reload = function () {
		        return this.load(this.config);
		    };
		    /**
		     * Set accessToken.
		     *
		     * @returns {Promise<void>}
		     */
		    Embed.prototype.setAccessToken = function (accessToken) {
		        var embedType = this.config.type;
		        return this.service.hpm.post('/' + embedType + '/token', accessToken, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        })
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Gets an access token from the first available location: config, attribute, global.
		     *
		     * @private
		     * @param {string} globalAccessToken
		     * @returns {string}
		     */
		    Embed.prototype.getAccessToken = function (globalAccessToken) {
		        var accessToken = this.config.accessToken || this.element.getAttribute(Embed.accessTokenAttribute) || globalAccessToken;
		        if (!accessToken) {
		            throw new Error("No access token was found for element. You must specify an access token directly on the element using attribute '" + Embed.accessTokenAttribute + "' or specify a global token at: powerbi.accessToken.");
		        }
		        return accessToken;
		    };
		    /**
		     * Populate config for create and load
		     *
		     * @param {IEmbedConfiguration}
		     * @returns {void}
		     */
		    Embed.prototype.populateConfig = function (config) {
		        this.config = config;
		        // TODO: Change when Object.assign is available.
		        this.config.uniqueId = this.getUniqueId();
		        this.config.embedUrl = this.getEmbedUrl();
		        this.config.accessToken = this.getAccessToken(this.service.accessToken);
		        this.addLocaleToEmbedUrl(config);
		    };
		    /**
		     * Adds locale parameters to embedUrl
		     *
		     * @private
		     * @param {IEmbedConfiguration} config
		     */
		    Embed.prototype.addLocaleToEmbedUrl = function (config) {
		        if (!config.settings) {
		            return;
		        }
		        var localeSettings = config.settings.localeSettings;
		        if (localeSettings && localeSettings.language) {
		            this.config.embedUrl = utils.addParamToUrl(this.config.embedUrl, 'language', localeSettings.language);
		        }
		        if (localeSettings && localeSettings.formatLocale) {
		            this.config.embedUrl = utils.addParamToUrl(this.config.embedUrl, 'formatLocale', localeSettings.formatLocale);
		        }
		    };
		    /**
		     * Gets an embed url from the first available location: options, attribute.
		     *
		     * @private
		     * @returns {string}
		     */
		    Embed.prototype.getEmbedUrl = function () {
		        var embedUrl = this.config.embedUrl || this.element.getAttribute(Embed.embedUrlAttribute);
		        if (typeof embedUrl !== 'string' || embedUrl.length === 0) {
		            throw new Error("Embed Url is required, but it was not found. You must provide an embed url either as part of embed configuration or as attribute '" + Embed.embedUrlAttribute + "'.");
		        }
		        return embedUrl;
		    };
		    /**
		     * Gets a unique ID from the first available location: options, attribute.
		     * If neither is provided generate a unique string.
		     *
		     * @private
		     * @returns {string}
		     */
		    Embed.prototype.getUniqueId = function () {
		        return this.config.uniqueId || this.element.getAttribute(Embed.nameAttribute) || utils.createRandomString();
		    };
		    /**
		     * Requests the browser to render the component's iframe in fullscreen mode.
		     */
		    Embed.prototype.fullscreen = function () {
		        var requestFullScreen = this.iframe.requestFullscreen || this.iframe.msRequestFullscreen || this.iframe.mozRequestFullScreen || this.iframe.webkitRequestFullscreen;
		        requestFullScreen.call(this.iframe);
		    };
		    /**
		     * Requests the browser to exit fullscreen mode.
		     */
		    Embed.prototype.exitFullscreen = function () {
		        if (!this.isFullscreen(this.iframe)) {
		            return;
		        }
		        var exitFullscreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
		        exitFullscreen.call(document);
		    };
		    /**
		     * Returns true if the iframe is rendered in fullscreen mode,
		     * otherwise returns false.
		     *
		     * @private
		     * @param {HTMLIFrameElement} iframe
		     * @returns {boolean}
		     */
		    Embed.prototype.isFullscreen = function (iframe) {
		        var options = ['fullscreenElement', 'webkitFullscreenElement', 'mozFullscreenScreenElement', 'msFullscreenElement'];
		        return options.some(function (option) { return document[option] === iframe; });
		    };
		    /**
		     * Sets Iframe for embed
		     */
		    Embed.prototype.setIframe = function (isLoad, phasedRender) {
		        var _this = this;
		        if (!this.iframe) {
		            var iframeContent = document.createElement("iframe");
		            var embedUrl = this.config.embedUrl;
		            iframeContent.setAttribute("style", "width:100%;height:100%;");
		            iframeContent.setAttribute("src", embedUrl);
		            iframeContent.setAttribute("scrolling", "no");
		            iframeContent.setAttribute("allowfullscreen", "true");
		            var node = this.element;
		            while (node.firstChild) {
		                node.removeChild(node.firstChild);
		            }
		            node.appendChild(iframeContent);
		            this.iframe = node.firstChild;
		        }
		        if (isLoad) {
		            this.iframe.addEventListener('load', function () { return _this.load(_this.config, phasedRender); }, false);
		        }
		        else {
		            this.iframe.addEventListener('load', function () { return _this.createReport(_this.createConfig); }, false);
		        }
		    };
		    Embed.allowedEvents = ["loaded", "saved", "rendered", "saveAsTriggered", "error", "dataSelected"];
		    Embed.accessTokenAttribute = 'powerbi-access-token';
		    Embed.embedUrlAttribute = 'powerbi-embed-url';
		    Embed.nameAttribute = 'powerbi-name';
		    Embed.typeAttribute = 'powerbi-type';
		    return Embed;
		}());
		exports.Embed = Embed;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		/**
		 * Raises a custom event with event data on the specified HTML element.
		 *
		 * @export
		 * @param {HTMLElement} element
		 * @param {string} eventName
		 * @param {*} eventData
		 */
		function raiseCustomEvent(element, eventName, eventData) {
		    var customEvent;
		    if (typeof CustomEvent === 'function') {
		        customEvent = new CustomEvent(eventName, {
		            detail: eventData,
		            bubbles: true,
		            cancelable: true
		        });
		    }
		    else {
		        customEvent = document.createEvent('CustomEvent');
		        customEvent.initCustomEvent(eventName, true, true, eventData);
		    }
		    element.dispatchEvent(customEvent);
		}
		exports.raiseCustomEvent = raiseCustomEvent;
		/**
		 * Finds the index of the first value in an array that matches the specified predicate.
		 *
		 * @export
		 * @template T
		 * @param {(x: T) => boolean} predicate
		 * @param {T[]} xs
		 * @returns {number}
		 */
		function findIndex(predicate, xs) {
		    if (!Array.isArray(xs)) {
		        throw new Error("You attempted to call find with second parameter that was not an array. You passed: " + xs);
		    }
		    var index;
		    xs.some(function (x, i) {
		        if (predicate(x)) {
		            index = i;
		            return true;
		        }
		    });
		    return index;
		}
		exports.findIndex = findIndex;
		/**
		 * Finds the first value in an array that matches the specified predicate.
		 *
		 * @export
		 * @template T
		 * @param {(x: T) => boolean} predicate
		 * @param {T[]} xs
		 * @returns {T}
		 */
		function find(predicate, xs) {
		    var index = findIndex(predicate, xs);
		    return xs[index];
		}
		exports.find = find;
		function remove(predicate, xs) {
		    var index = findIndex(predicate, xs);
		    xs.splice(index, 1);
		}
		exports.remove = remove;
		// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
		// TODO: replace in favor of using polyfill
		/**
		 * Copies the values of all enumerable properties from one or more source objects to a target object, and returns the target object.
		 *
		 * @export
		 * @param {any} args
		 * @returns
		 */
		function assign() {
		    var args = [];
		    for (var _i = 0; _i < arguments.length; _i++) {
		        args[_i - 0] = arguments[_i];
		    }
		    var target = args[0];
		    'use strict';
		    if (target === undefined || target === null) {
		        throw new TypeError('Cannot convert undefined or null to object');
		    }
		    var output = Object(target);
		    for (var index = 1; index < arguments.length; index++) {
		        var source = arguments[index];
		        if (source !== undefined && source !== null) {
		            for (var nextKey in source) {
		                if (source.hasOwnProperty(nextKey)) {
		                    output[nextKey] = source[nextKey];
		                }
		            }
		        }
		    }
		    return output;
		}
		exports.assign = assign;
		/**
		 * Generates a random 7 character string.
		 *
		 * @export
		 * @returns {string}
		 */
		function createRandomString() {
		    return (Math.random() + 1).toString(36).substring(7);
		}
		exports.createRandomString = createRandomString;
		/**
		 * Adds a parameter to the given url
		 *
		 * @export
		 * @param {string} url
		 * @param {string} paramName
		 * @param {string} value
		 * @returns {string}
		 */
		function addParamToUrl(url, paramName, value) {
		    var parameterPrefix = url.indexOf('?') > 0 ? '&' : '?';
		    url += parameterPrefix + paramName + '=' + value;
		    return url;
		}
		exports.addParamToUrl = addParamToUrl;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/*! powerbi-models v1.0.4 | (c) 2016 Microsoft Corporation MIT */
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory();
			else if(typeof define === 'function' && define.amd)
				define([], factory);
			else if(typeof exports === 'object')
				exports["powerbi-models"] = factory();
			else
				root["powerbi-models"] = factory();
		})(this, function() {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		/******/
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		/******/
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		/******/
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		/******/
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			exports.Validators = __webpack_require__(1).Validators;
			var PageSizeType;
			(function (PageSizeType) {
			    PageSizeType[PageSizeType["Widescreen"] = 0] = "Widescreen";
			    PageSizeType[PageSizeType["Standard"] = 1] = "Standard";
			    PageSizeType[PageSizeType["Cortana"] = 2] = "Cortana";
			    PageSizeType[PageSizeType["Letter"] = 3] = "Letter";
			    PageSizeType[PageSizeType["Custom"] = 4] = "Custom";
			})(PageSizeType = exports.PageSizeType || (exports.PageSizeType = {}));
			var DisplayOption;
			(function (DisplayOption) {
			    DisplayOption[DisplayOption["FitToPage"] = 0] = "FitToPage";
			    DisplayOption[DisplayOption["FitToWidth"] = 1] = "FitToWidth";
			    DisplayOption[DisplayOption["ActualSize"] = 2] = "ActualSize";
			})(DisplayOption = exports.DisplayOption || (exports.DisplayOption = {}));
			var BackgroundType;
			(function (BackgroundType) {
			    BackgroundType[BackgroundType["Default"] = 0] = "Default";
			    BackgroundType[BackgroundType["Transparent"] = 1] = "Transparent";
			})(BackgroundType = exports.BackgroundType || (exports.BackgroundType = {}));
			var VisualContainerDisplayMode;
			(function (VisualContainerDisplayMode) {
			    VisualContainerDisplayMode[VisualContainerDisplayMode["Visible"] = 0] = "Visible";
			    VisualContainerDisplayMode[VisualContainerDisplayMode["Hidden"] = 1] = "Hidden";
			})(VisualContainerDisplayMode = exports.VisualContainerDisplayMode || (exports.VisualContainerDisplayMode = {}));
			var LayoutType;
			(function (LayoutType) {
			    LayoutType[LayoutType["Master"] = 0] = "Master";
			    LayoutType[LayoutType["Custom"] = 1] = "Custom";
			    LayoutType[LayoutType["MobilePortrait"] = 2] = "MobilePortrait";
			    LayoutType[LayoutType["MobileLandscape"] = 3] = "MobileLandscape";
			})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
			var SectionVisibility;
			(function (SectionVisibility) {
			    SectionVisibility[SectionVisibility["AlwaysVisible"] = 0] = "AlwaysVisible";
			    SectionVisibility[SectionVisibility["HiddenInViewMode"] = 1] = "HiddenInViewMode";
			})(SectionVisibility = exports.SectionVisibility || (exports.SectionVisibility = {}));
			var Permissions;
			(function (Permissions) {
			    Permissions[Permissions["Read"] = 0] = "Read";
			    Permissions[Permissions["ReadWrite"] = 1] = "ReadWrite";
			    Permissions[Permissions["Copy"] = 2] = "Copy";
			    Permissions[Permissions["Create"] = 4] = "Create";
			    Permissions[Permissions["All"] = 7] = "All";
			})(Permissions = exports.Permissions || (exports.Permissions = {}));
			var ViewMode;
			(function (ViewMode) {
			    ViewMode[ViewMode["View"] = 0] = "View";
			    ViewMode[ViewMode["Edit"] = 1] = "Edit";
			})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
			var TokenType;
			(function (TokenType) {
			    TokenType[TokenType["Aad"] = 0] = "Aad";
			    TokenType[TokenType["Embed"] = 1] = "Embed";
			})(TokenType = exports.TokenType || (exports.TokenType = {}));
			var FilterType;
			(function (FilterType) {
			    FilterType[FilterType["Advanced"] = 0] = "Advanced";
			    FilterType[FilterType["Basic"] = 1] = "Basic";
			    FilterType[FilterType["Unknown"] = 2] = "Unknown";
			    FilterType[FilterType["IncludeExclude"] = 3] = "IncludeExclude";
			    FilterType[FilterType["RelativeDate"] = 4] = "RelativeDate";
			    FilterType[FilterType["TopN"] = 5] = "TopN";
			})(FilterType = exports.FilterType || (exports.FilterType = {}));
			var RelativeDateFilterTimeUnit;
			(function (RelativeDateFilterTimeUnit) {
			    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Days"] = 0] = "Days";
			    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Weeks"] = 1] = "Weeks";
			    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarWeeks"] = 2] = "CalendarWeeks";
			    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Months"] = 3] = "Months";
			    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarMonths"] = 4] = "CalendarMonths";
			    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Years"] = 5] = "Years";
			    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarYears"] = 6] = "CalendarYears";
			})(RelativeDateFilterTimeUnit = exports.RelativeDateFilterTimeUnit || (exports.RelativeDateFilterTimeUnit = {}));
			var RelativeDateOperators;
			(function (RelativeDateOperators) {
			    RelativeDateOperators[RelativeDateOperators["InLast"] = 0] = "InLast";
			    RelativeDateOperators[RelativeDateOperators["InThis"] = 1] = "InThis";
			    RelativeDateOperators[RelativeDateOperators["InNext"] = 2] = "InNext";
			})(RelativeDateOperators = exports.RelativeDateOperators || (exports.RelativeDateOperators = {}));
			var Filter = /** @class */ (function () {
			    function Filter(target, filterType) {
			        this.target = target;
			        this.filterType = filterType;
			    }
			    Filter.prototype.toJSON = function () {
			        return {
			            $schema: this.schemaUrl,
			            target: this.target,
			            filterType: this.filterType
			        };
			    };
			    ;
			    return Filter;
			}());
			exports.Filter = Filter;
			var NotSupportedFilter = /** @class */ (function (_super) {
			    __extends(NotSupportedFilter, _super);
			    function NotSupportedFilter(target, message, notSupportedTypeName) {
			        var _this = _super.call(this, target, FilterType.Unknown) || this;
			        _this.message = message;
			        _this.notSupportedTypeName = notSupportedTypeName;
			        _this.schemaUrl = NotSupportedFilter.schemaUrl;
			        return _this;
			    }
			    NotSupportedFilter.prototype.toJSON = function () {
			        var filter = _super.prototype.toJSON.call(this);
			        filter.message = this.message;
			        filter.notSupportedTypeName = this.notSupportedTypeName;
			        return filter;
			    };
			    NotSupportedFilter.schemaUrl = "http://powerbi.com/product/schema#notSupported";
			    return NotSupportedFilter;
			}(Filter));
			exports.NotSupportedFilter = NotSupportedFilter;
			var IncludeExcludeFilter = /** @class */ (function (_super) {
			    __extends(IncludeExcludeFilter, _super);
			    function IncludeExcludeFilter(target, isExclude, values) {
			        var _this = _super.call(this, target, FilterType.IncludeExclude) || this;
			        _this.values = values;
			        _this.isExclude = isExclude;
			        _this.schemaUrl = IncludeExcludeFilter.schemaUrl;
			        return _this;
			    }
			    IncludeExcludeFilter.prototype.toJSON = function () {
			        var filter = _super.prototype.toJSON.call(this);
			        filter.isExclude = this.isExclude;
			        filter.values = this.values;
			        return filter;
			    };
			    IncludeExcludeFilter.schemaUrl = "http://powerbi.com/product/schema#includeExclude";
			    return IncludeExcludeFilter;
			}(Filter));
			exports.IncludeExcludeFilter = IncludeExcludeFilter;
			var TopNFilter = /** @class */ (function (_super) {
			    __extends(TopNFilter, _super);
			    function TopNFilter(target, operator, itemCount) {
			        var _this = _super.call(this, target, FilterType.TopN) || this;
			        _this.operator = operator;
			        _this.itemCount = itemCount;
			        _this.schemaUrl = TopNFilter.schemaUrl;
			        return _this;
			    }
			    TopNFilter.prototype.toJSON = function () {
			        var filter = _super.prototype.toJSON.call(this);
			        filter.operator = this.operator;
			        filter.itemCount = this.itemCount;
			        return filter;
			    };
			    TopNFilter.schemaUrl = "http://powerbi.com/product/schema#topN";
			    return TopNFilter;
			}(Filter));
			exports.TopNFilter = TopNFilter;
			var RelativeDateFilter = /** @class */ (function (_super) {
			    __extends(RelativeDateFilter, _super);
			    function RelativeDateFilter(target, operator, timeUnitsCount, timeUnitType, includeToday) {
			        var _this = _super.call(this, target, FilterType.RelativeDate) || this;
			        _this.operator = operator;
			        _this.timeUnitsCount = timeUnitsCount;
			        _this.timeUnitType = timeUnitType;
			        _this.includeToday = includeToday;
			        _this.schemaUrl = RelativeDateFilter.schemaUrl;
			        return _this;
			    }
			    RelativeDateFilter.prototype.toJSON = function () {
			        var filter = _super.prototype.toJSON.call(this);
			        filter.operator = this.operator;
			        filter.timeUnitsCount = this.timeUnitsCount;
			        filter.timeUnitType = this.timeUnitType;
			        filter.includeToday = this.includeToday;
			        return filter;
			    };
			    RelativeDateFilter.schemaUrl = "http://powerbi.com/product/schema#relativeDate";
			    return RelativeDateFilter;
			}(Filter));
			exports.RelativeDateFilter = RelativeDateFilter;
			var BasicFilter = /** @class */ (function (_super) {
			    __extends(BasicFilter, _super);
			    function BasicFilter(target, operator) {
			        var values = [];
			        for (var _i = 2; _i < arguments.length; _i++) {
			            values[_i - 2] = arguments[_i];
			        }
			        var _this = _super.call(this, target, FilterType.Basic) || this;
			        _this.operator = operator;
			        _this.schemaUrl = BasicFilter.schemaUrl;
			        if (values.length === 0 && operator !== "All") {
			            throw new Error("values must be a non-empty array unless your operator is \"All\".");
			        }
			        /**
			         * Accept values as array instead of as individual arguments
			         * new BasicFilter('a', 'b', 1, 2);
			         * new BasicFilter('a', 'b', [1,2]);
			         */
			        if (Array.isArray(values[0])) {
			            _this.values = values[0];
			        }
			        else {
			            _this.values = values;
			        }
			        return _this;
			    }
			    BasicFilter.prototype.toJSON = function () {
			        var filter = _super.prototype.toJSON.call(this);
			        filter.operator = this.operator;
			        filter.values = this.values;
			        return filter;
			    };
			    BasicFilter.schemaUrl = "http://powerbi.com/product/schema#basic";
			    return BasicFilter;
			}(Filter));
			exports.BasicFilter = BasicFilter;
			var BasicFilterWithKeys = /** @class */ (function (_super) {
			    __extends(BasicFilterWithKeys, _super);
			    function BasicFilterWithKeys(target, operator, values, keyValues) {
			        var _this = _super.call(this, target, operator, values) || this;
			        _this.keyValues = keyValues;
			        _this.target = target;
			        var numberOfKeys = target.keys ? target.keys.length : 0;
			        if (numberOfKeys > 0 && !keyValues) {
			            throw new Error("You shold pass the values to be filtered for each key. You passed: no values and " + numberOfKeys + " keys");
			        }
			        if (numberOfKeys === 0 && keyValues && keyValues.length > 0) {
			            throw new Error("You passed key values but your target object doesn't contain the keys to be filtered");
			        }
			        for (var i = 0; i < _this.keyValues.length; i++) {
			            if (_this.keyValues[i]) {
			                var lengthOfArray = _this.keyValues[i].length;
			                if (lengthOfArray !== numberOfKeys) {
			                    throw new Error("Each tuple of key values should contain a value for each of the keys. You passed: " + lengthOfArray + " values and " + numberOfKeys + " keys");
			                }
			            }
			        }
			        return _this;
			    }
			    BasicFilterWithKeys.prototype.toJSON = function () {
			        var filter = _super.prototype.toJSON.call(this);
			        filter.keyValues = this.keyValues;
			        return filter;
			    };
			    return BasicFilterWithKeys;
			}(BasicFilter));
			exports.BasicFilterWithKeys = BasicFilterWithKeys;
			var AdvancedFilter = /** @class */ (function (_super) {
			    __extends(AdvancedFilter, _super);
			    function AdvancedFilter(target, logicalOperator) {
			        var conditions = [];
			        for (var _i = 2; _i < arguments.length; _i++) {
			            conditions[_i - 2] = arguments[_i];
			        }
			        var _this = _super.call(this, target, FilterType.Advanced) || this;
			        _this.schemaUrl = AdvancedFilter.schemaUrl;
			        // Guard statements
			        if (typeof logicalOperator !== "string" || logicalOperator.length === 0) {
			            // TODO: It would be nicer to list out the possible logical operators.
			            throw new Error("logicalOperator must be a valid operator, You passed: " + logicalOperator);
			        }
			        _this.logicalOperator = logicalOperator;
			        var extractedConditions;
			        /**
			         * Accept conditions as array instead of as individual arguments
			         * new AdvancedFilter('a', 'b', "And", { value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" });
			         * new AdvancedFilter('a', 'b', "And", [{ value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" }]);
			         */
			        if (Array.isArray(conditions[0])) {
			            extractedConditions = conditions[0];
			        }
			        else {
			            extractedConditions = conditions;
			        }
			        if (extractedConditions.length === 0) {
			            throw new Error("conditions must be a non-empty array. You passed: " + conditions);
			        }
			        if (extractedConditions.length > 2) {
			            throw new Error("AdvancedFilters may not have more than two conditions. You passed: " + conditions.length);
			        }
			        if (extractedConditions.length === 1 && logicalOperator !== "And") {
			            throw new Error("Logical Operator must be \"And\" when there is only one condition provided");
			        }
			        _this.conditions = extractedConditions;
			        return _this;
			    }
			    AdvancedFilter.prototype.toJSON = function () {
			        var filter = _super.prototype.toJSON.call(this);
			        filter.logicalOperator = this.logicalOperator;
			        filter.conditions = this.conditions;
			        return filter;
			    };
			    AdvancedFilter.schemaUrl = "http://powerbi.com/product/schema#advanced";
			    return AdvancedFilter;
			}(Filter));
			exports.AdvancedFilter = AdvancedFilter;
			function isFilterKeyColumnsTarget(target) {
			    return isColumn(target) && !!target.keys;
			}
			exports.isFilterKeyColumnsTarget = isFilterKeyColumnsTarget;
			function isBasicFilterWithKeys(filter) {
			    return getFilterType(filter) === FilterType.Basic && !!filter.keyValues;
			}
			exports.isBasicFilterWithKeys = isBasicFilterWithKeys;
			function getFilterType(filter) {
			    if (filter.filterType) {
			        return filter.filterType;
			    }
			    var basicFilter = filter;
			    var advancedFilter = filter;
			    if ((typeof basicFilter.operator === "string")
			        && (Array.isArray(basicFilter.values))) {
			        return FilterType.Basic;
			    }
			    else if ((typeof advancedFilter.logicalOperator === "string")
			        && (Array.isArray(advancedFilter.conditions))) {
			        return FilterType.Advanced;
			    }
			    else {
			        return FilterType.Unknown;
			    }
			}
			exports.getFilterType = getFilterType;
			function isMeasure(arg) {
			    return arg.table !== undefined && arg.measure !== undefined;
			}
			exports.isMeasure = isMeasure;
			function isColumn(arg) {
			    return arg.table !== undefined && arg.column !== undefined;
			}
			exports.isColumn = isColumn;
			function isHierarchy(arg) {
			    return arg.table !== undefined && arg.hierarchy !== undefined && arg.hierarchyLevel !== undefined;
			}
			exports.isHierarchy = isHierarchy;
			var QnaMode;
			(function (QnaMode) {
			    QnaMode[QnaMode["Interactive"] = 0] = "Interactive";
			    QnaMode[QnaMode["ResultOnly"] = 1] = "ResultOnly";
			})(QnaMode = exports.QnaMode || (exports.QnaMode = {}));
			var ExportDataType;
			(function (ExportDataType) {
			    ExportDataType[ExportDataType["Summarized"] = 0] = "Summarized";
			    ExportDataType[ExportDataType["Underlying"] = 1] = "Underlying";
			})(ExportDataType = exports.ExportDataType || (exports.ExportDataType = {}));
			var BookmarksPlayMode;
			(function (BookmarksPlayMode) {
			    BookmarksPlayMode[BookmarksPlayMode["Off"] = 0] = "Off";
			    BookmarksPlayMode[BookmarksPlayMode["Presentation"] = 1] = "Presentation";
			})(BookmarksPlayMode = exports.BookmarksPlayMode || (exports.BookmarksPlayMode = {}));
			function normalizeError(error) {
			    var message = error.message;
			    if (!message) {
			        message = error.path + " is invalid. Not meeting " + error.keyword + " constraint";
			    }
			    return {
			        message: message
			    };
			}
			function validatePlayBookmarkRequest(input) {
			    var errors = exports.Validators.playBookmarkRequestValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validatePlayBookmarkRequest = validatePlayBookmarkRequest;
			function validateAddBookmarkRequest(input) {
			    var errors = exports.Validators.addBookmarkRequestValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateAddBookmarkRequest = validateAddBookmarkRequest;
			function validateApplyBookmarkByNameRequest(input) {
			    var errors = exports.Validators.applyBookmarkByNameRequestValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateApplyBookmarkByNameRequest = validateApplyBookmarkByNameRequest;
			function validateApplyBookmarkStateRequest(input) {
			    var errors = exports.Validators.applyBookmarkStateRequestValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateApplyBookmarkStateRequest = validateApplyBookmarkStateRequest;
			function validateSettings(input) {
			    var errors = exports.Validators.settingsValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateSettings = validateSettings;
			function validateCustomPageSize(input) {
			    var errors = exports.Validators.customPageSizeValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateCustomPageSize = validateCustomPageSize;
			function validateExtension(input) {
			    var errors = exports.Validators.extentionValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateExtension = validateExtension;
			function validateReportLoad(input) {
			    var errors = exports.Validators.reportLoadValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateReportLoad = validateReportLoad;
			function validateCreateReport(input) {
			    var errors = exports.Validators.reportCreateValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateCreateReport = validateCreateReport;
			function validateDashboardLoad(input) {
			    var errors = exports.Validators.dashboardLoadValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateDashboardLoad = validateDashboardLoad;
			function validateTileLoad(input) {
			    var errors = exports.Validators.tileLoadValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateTileLoad = validateTileLoad;
			function validatePage(input) {
			    var errors = exports.Validators.pageValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validatePage = validatePage;
			function validateFilter(input) {
			    var errors = exports.Validators.filtersValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateFilter = validateFilter;
			function validateSaveAsParameters(input) {
			    var errors = exports.Validators.saveAsParametersValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateSaveAsParameters = validateSaveAsParameters;
			function validateLoadQnaConfiguration(input) {
			    var errors = exports.Validators.loadQnaValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateLoadQnaConfiguration = validateLoadQnaConfiguration;
			function validateQnaInterpretInputData(input) {
			    var errors = exports.Validators.qnaInterpretInputDataValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateQnaInterpretInputData = validateQnaInterpretInputData;
			function validateExportDataRequest(input) {
			    var errors = exports.Validators.exportDataRequestValidator.validate(input);
			    return errors ? errors.map(normalizeError) : undefined;
			}
			exports.validateExportDataRequest = validateExportDataRequest;
		
		
		/***/ }),
		/* 1 */
		/***/ (function(module, exports, __webpack_require__) {
		
			Object.defineProperty(exports, "__esModule", { value: true });
			var typeValidator_1 = __webpack_require__(2);
			var extensionsValidator_1 = __webpack_require__(3);
			var settingsValidator_1 = __webpack_require__(5);
			var bookmarkValidator_1 = __webpack_require__(6);
			var filtersValidator_1 = __webpack_require__(7);
			var fieldRequiredValidator_1 = __webpack_require__(8);
			var anyOfValidator_1 = __webpack_require__(9);
			var reportLoadValidator_1 = __webpack_require__(10);
			var reportCreateValidator_1 = __webpack_require__(11);
			var dashboardLoadValidator_1 = __webpack_require__(12);
			var tileLoadValidator_1 = __webpack_require__(13);
			var pageValidator_1 = __webpack_require__(14);
			var qnaValidator_1 = __webpack_require__(15);
			var saveAsParametersValidator_1 = __webpack_require__(16);
			var mapValidator_1 = __webpack_require__(17);
			var layoutValidator_1 = __webpack_require__(18);
			var exportDataValidator_1 = __webpack_require__(19);
			exports.Validators = {
			    advancedFilterTypeValidator: new typeValidator_1.EnumValidator([0]),
			    advancedFilterValidator: new filtersValidator_1.AdvancedFilterValidator(),
			    anyArrayValidator: new typeValidator_1.ArrayValidator([new anyOfValidator_1.AnyOfValidator([new typeValidator_1.StringValidator(), new typeValidator_1.NumberValidator(), new typeValidator_1.BooleanValidator()])]),
			    anyFilterValidator: new anyOfValidator_1.AnyOfValidator([new filtersValidator_1.BasicFilterValidator(), new filtersValidator_1.AdvancedFilterValidator(), new filtersValidator_1.IncludeExcludeFilterValidator(), new filtersValidator_1.NotSupportedFilterValidator(), new filtersValidator_1.RelativeDateFilterValidator(), new filtersValidator_1.TopNFilterValidator()]),
			    anyValueValidator: new anyOfValidator_1.AnyOfValidator([new typeValidator_1.StringValidator(), new typeValidator_1.NumberValidator(), new typeValidator_1.BooleanValidator()]),
			    basicFilterTypeValidator: new typeValidator_1.EnumValidator([1]),
			    basicFilterValidator: new filtersValidator_1.BasicFilterValidator(),
			    playBookmarkRequestValidator: new bookmarkValidator_1.PlayBookmarkRequestValidator(),
			    addBookmarkRequestValidator: new bookmarkValidator_1.AddBookmarkRequestValidator(),
			    applyBookmarkByNameRequestValidator: new bookmarkValidator_1.ApplyBookmarkByNameRequestValidator(),
			    applyBookmarkStateRequestValidator: new bookmarkValidator_1.ApplyBookmarkStateRequestValidator(),
			    applyBookmarkValidator: new anyOfValidator_1.AnyOfValidator([new bookmarkValidator_1.ApplyBookmarkByNameRequestValidator(), new bookmarkValidator_1.ApplyBookmarkStateRequestValidator()]),
			    backgroundValidator: new typeValidator_1.EnumValidator([0, 1]),
			    booleanArrayValidator: new typeValidator_1.BooleanArrayValidator(),
			    booleanValidator: new typeValidator_1.BooleanValidator(),
			    commandExtensionValidator: new extensionsValidator_1.CommandExtensionValidator(),
			    conditionItemValidator: new filtersValidator_1.ConditionItemValidator(),
			    customLayoutValidator: new layoutValidator_1.CustomLayoutValidator(),
			    customLayoutDisplayOptionValidator: new typeValidator_1.EnumValidator([0, 1, 2]),
			    customPageSizeValidator: new pageValidator_1.CustomPageSizeValidator(),
			    dashboardLoadValidator: new dashboardLoadValidator_1.DashboardLoadValidator(),
			    displayStateModeValidator: new typeValidator_1.EnumValidator([0, 1]),
			    displayStateValidator: new layoutValidator_1.DisplayStateValidator(),
			    exportDataRequestValidator: new exportDataValidator_1.ExportDataRequestValidator(),
			    extensionPointsValidator: new extensionsValidator_1.ExtensionPointsValidator(),
			    extentionArrayValidator: new typeValidator_1.ArrayValidator([new extensionsValidator_1.ExtensionValidator()]),
			    extentionValidator: new extensionsValidator_1.ExtensionValidator(),
			    fieldRequiredValidator: new fieldRequiredValidator_1.FieldRequiredValidator(),
			    filterColumnTargetValidator: new filtersValidator_1.FilterColumnTargetValidator(),
			    filterConditionsValidator: new typeValidator_1.ArrayValidator([new filtersValidator_1.ConditionItemValidator()]),
			    filterHierarchyTargetValidator: new filtersValidator_1.FilterHierarchyTargetValidator(),
			    filterMeasureTargetValidator: new filtersValidator_1.FilterMeasureTargetValidator(),
			    filterTargetValidator: new anyOfValidator_1.AnyOfValidator([new filtersValidator_1.FilterColumnTargetValidator(), new filtersValidator_1.FilterHierarchyTargetValidator(), new filtersValidator_1.FilterMeasureTargetValidator()]),
			    filtersArrayValidator: new typeValidator_1.ArrayValidator([new anyOfValidator_1.AnyOfValidator([new filtersValidator_1.BasicFilterValidator(), new filtersValidator_1.AdvancedFilterValidator(), new filtersValidator_1.RelativeDateFilterValidator()])]),
			    filtersValidator: new filtersValidator_1.FilterValidator(),
			    includeExcludeFilterValidator: new filtersValidator_1.IncludeExcludeFilterValidator(),
			    includeExludeFilterTypeValidator: new typeValidator_1.EnumValidator([3]),
			    layoutTypeValidator: new typeValidator_1.EnumValidator([0, 1, 2, 3]),
			    loadQnaValidator: new qnaValidator_1.LoadQnaValidator(),
			    menuExtensionValidator: new extensionsValidator_1.MenuExtensionValidator(),
			    notSupportedFilterTypeValidator: new typeValidator_1.EnumValidator([2]),
			    notSupportedFilterValidator: new filtersValidator_1.NotSupportedFilterValidator(),
			    numberArrayValidator: new typeValidator_1.NumberArrayValidator(),
			    numberValidator: new typeValidator_1.NumberValidator(),
			    pageLayoutValidator: new mapValidator_1.MapValidator([new typeValidator_1.StringValidator()], [new layoutValidator_1.VisualLayoutValidator()]),
			    pageSizeTypeValidator: new typeValidator_1.EnumValidator([0, 1, 2, 3, 4, 5]),
			    pageSizeValidator: new pageValidator_1.PageSizeValidator(),
			    pageValidator: new pageValidator_1.PageValidator(),
			    pageViewFieldValidator: new pageValidator_1.PageViewFieldValidator(),
			    pagesLayoutValidator: new mapValidator_1.MapValidator([new typeValidator_1.StringValidator()], [new layoutValidator_1.PageLayoutValidator()]),
			    permissionsValidator: new typeValidator_1.EnumValidator([0, 1, 2, 4, 7]),
			    qnaInterpretInputDataValidator: new qnaValidator_1.QnaInterpretInputDataValidator(),
			    qnaSettingValidator: new qnaValidator_1.QnaSettingsValidator(),
			    relativeDateFilterOperatorValidator: new typeValidator_1.EnumValidator([0, 1, 2]),
			    relativeDateFilterTimeUnitTypeValidator: new typeValidator_1.EnumValidator([0, 1, 2, 3, 4, 5, 6]),
			    relativeDateFilterTypeValidator: new typeValidator_1.EnumValidator([4]),
			    relativeDateFilterValidator: new filtersValidator_1.RelativeDateFilterValidator(),
			    reportCreateValidator: new reportCreateValidator_1.ReportCreateValidator(),
			    reportLoadValidator: new reportLoadValidator_1.ReportLoadValidator(),
			    saveAsParametersValidator: new saveAsParametersValidator_1.SaveAsParametersValidator(),
			    settingsValidator: new settingsValidator_1.SettingsValidator(),
			    stringArrayValidator: new typeValidator_1.StringArrayValidator(),
			    stringValidator: new typeValidator_1.StringValidator(),
			    tileLoadValidator: new tileLoadValidator_1.TileLoadValidator(),
			    tokenTypeValidator: new typeValidator_1.EnumValidator([0, 1]),
			    topNFilterTypeValidator: new typeValidator_1.EnumValidator([5]),
			    topNFilterValidator: new filtersValidator_1.TopNFilterValidator(),
			    viewModeValidator: new typeValidator_1.EnumValidator([0, 1]),
			    visualLayoutValidator: new layoutValidator_1.VisualLayoutValidator(),
			};
		
		
		/***/ }),
		/* 2 */
		/***/ (function(module, exports) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var ObjectValidator = /** @class */ (function () {
			    function ObjectValidator() {
			    }
			    ObjectValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        if (typeof input !== "object" || Array.isArray(input)) {
			            return [{
			                    message: field !== undefined ? field + " must be an object" : "input must be an object",
			                    path: path,
			                    keyword: "type"
			                }];
			        }
			        return null;
			    };
			    return ObjectValidator;
			}());
			exports.ObjectValidator = ObjectValidator;
			var ArrayValidator = /** @class */ (function () {
			    function ArrayValidator(itemValidators) {
			        this.itemValidators = itemValidators;
			    }
			    ArrayValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        if (!(Array.isArray(input))) {
			            return [{
			                    message: field + " property is invalid",
			                    path: (path ? path + "." : "") + field,
			                    keyword: "type"
			                }];
			        }
			        for (var i = 0; i < input.length; i++) {
			            var fieldsPath = (path ? path + "." : "") + field + "." + i;
			            for (var _i = 0, _a = this.itemValidators; _i < _a.length; _i++) {
			                var validator = _a[_i];
			                var errors = validator.validate(input[i], fieldsPath, field);
			                if (errors) {
			                    return [{
			                            message: field + " property is invalid",
			                            path: (path ? path + "." : "") + field,
			                            keyword: "type"
			                        }];
			                }
			            }
			        }
			        return null;
			    };
			    return ArrayValidator;
			}());
			exports.ArrayValidator = ArrayValidator;
			var TypeValidator = /** @class */ (function () {
			    function TypeValidator(expectedType) {
			        this.expectedType = expectedType;
			    }
			    TypeValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        if (!(typeof input === this.expectedType)) {
			            return [{
			                    message: field + " must be a " + this.expectedType,
			                    path: (path ? path + "." : "") + field,
			                    keyword: "type"
			                }];
			        }
			        return null;
			    };
			    return TypeValidator;
			}());
			exports.TypeValidator = TypeValidator;
			var StringValidator = /** @class */ (function (_super) {
			    __extends(StringValidator, _super);
			    function StringValidator() {
			        return _super.call(this, "string") || this;
			    }
			    return StringValidator;
			}(TypeValidator));
			exports.StringValidator = StringValidator;
			var BooleanValidator = /** @class */ (function (_super) {
			    __extends(BooleanValidator, _super);
			    function BooleanValidator() {
			        return _super.call(this, "boolean") || this;
			    }
			    return BooleanValidator;
			}(TypeValidator));
			exports.BooleanValidator = BooleanValidator;
			var NumberValidator = /** @class */ (function (_super) {
			    __extends(NumberValidator, _super);
			    function NumberValidator() {
			        return _super.call(this, "number") || this;
			    }
			    return NumberValidator;
			}(TypeValidator));
			exports.NumberValidator = NumberValidator;
			var ValueValidator = /** @class */ (function () {
			    function ValueValidator(possibleValues) {
			        this.possibleValues = possibleValues;
			    }
			    ValueValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        if (this.possibleValues.indexOf(input) < 0) {
			            return [{
			                    message: field + " property is invalid",
			                    path: (path ? path + "." : "") + field,
			                    keyword: "invalid"
			                }];
			        }
			        return null;
			    };
			    return ValueValidator;
			}());
			exports.ValueValidator = ValueValidator;
			var EnumValidator = /** @class */ (function (_super) {
			    __extends(EnumValidator, _super);
			    function EnumValidator(possibleValues) {
			        var _this = _super.call(this) || this;
			        _this.possibleValues = possibleValues;
			        return _this;
			    }
			    EnumValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var valueValidator = new ValueValidator(this.possibleValues);
			        return valueValidator.validate(input, path, field);
			    };
			    return EnumValidator;
			}(NumberValidator));
			exports.EnumValidator = EnumValidator;
			var StringArrayValidator = /** @class */ (function (_super) {
			    __extends(StringArrayValidator, _super);
			    function StringArrayValidator() {
			        return _super.call(this, [new StringValidator()]) || this;
			    }
			    StringArrayValidator.prototype.validate = function (input, path, field) {
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return [{
			                    message: field + " must be an array of strings",
			                    path: (path ? path + "." : "") + field,
			                    keyword: "type"
			                }];
			        }
			        return null;
			    };
			    return StringArrayValidator;
			}(ArrayValidator));
			exports.StringArrayValidator = StringArrayValidator;
			var BooleanArrayValidator = /** @class */ (function (_super) {
			    __extends(BooleanArrayValidator, _super);
			    function BooleanArrayValidator() {
			        return _super.call(this, [new BooleanValidator()]) || this;
			    }
			    BooleanArrayValidator.prototype.validate = function (input, path, field) {
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return [{
			                    message: field + " must be an array of booleans",
			                    path: (path ? path + "." : "") + field,
			                    keyword: "type"
			                }];
			        }
			        return null;
			    };
			    return BooleanArrayValidator;
			}(ArrayValidator));
			exports.BooleanArrayValidator = BooleanArrayValidator;
			var NumberArrayValidator = /** @class */ (function (_super) {
			    __extends(NumberArrayValidator, _super);
			    function NumberArrayValidator() {
			        return _super.call(this, [new NumberValidator()]) || this;
			    }
			    NumberArrayValidator.prototype.validate = function (input, path, field) {
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return [{
			                    message: field + " must be an array of numbers",
			                    path: (path ? path + "." : "") + field,
			                    keyword: "type"
			                }];
			        }
			        return null;
			    };
			    return NumberArrayValidator;
			}(ArrayValidator));
			exports.NumberArrayValidator = NumberArrayValidator;
		
		
		/***/ }),
		/* 3 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var MenuExtensionValidator = /** @class */ (function (_super) {
			    __extends(MenuExtensionValidator, _super);
			    function MenuExtensionValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    MenuExtensionValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "title",
			                validators: [validator_1.Validators.stringValidator]
			            },
			            {
			                field: "icon",
			                validators: [validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return MenuExtensionValidator;
			}(typeValidator_1.ObjectValidator));
			exports.MenuExtensionValidator = MenuExtensionValidator;
			var ExtensionPointsValidator = /** @class */ (function (_super) {
			    __extends(ExtensionPointsValidator, _super);
			    function ExtensionPointsValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ExtensionPointsValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "visualContextMenu",
			                validators: [validator_1.Validators.menuExtensionValidator]
			            },
			            {
			                field: "visualOptionsMenu",
			                validators: [validator_1.Validators.menuExtensionValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ExtensionPointsValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ExtensionPointsValidator = ExtensionPointsValidator;
			var ExtensionItemValidator = /** @class */ (function (_super) {
			    __extends(ExtensionItemValidator, _super);
			    function ExtensionItemValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ExtensionItemValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "name",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "extend",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.extensionPointsValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ExtensionItemValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ExtensionItemValidator = ExtensionItemValidator;
			var CommandExtensionValidator = /** @class */ (function (_super) {
			    __extends(CommandExtensionValidator, _super);
			    function CommandExtensionValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    CommandExtensionValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "title",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "icon",
			                validators: [validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return CommandExtensionValidator;
			}(ExtensionItemValidator));
			exports.CommandExtensionValidator = CommandExtensionValidator;
			var ExtensionValidator = /** @class */ (function (_super) {
			    __extends(ExtensionValidator, _super);
			    function ExtensionValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ExtensionValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "command",
			                validators: [validator_1.Validators.commandExtensionValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ExtensionValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ExtensionValidator = ExtensionValidator;
		
		
		/***/ }),
		/* 4 */
		/***/ (function(module, exports) {
		
			Object.defineProperty(exports, "__esModule", { value: true });
			var MultipleFieldsValidator = /** @class */ (function () {
			    function MultipleFieldsValidator(fieldValidatorsPairs) {
			        this.fieldValidatorsPairs = fieldValidatorsPairs;
			    }
			    MultipleFieldsValidator.prototype.validate = function (input, path, field) {
			        if (!this.fieldValidatorsPairs) {
			            return null;
			        }
			        var fieldsPath = path ? path + "." + field : field;
			        for (var _i = 0, _a = this.fieldValidatorsPairs; _i < _a.length; _i++) {
			            var fieldValidators = _a[_i];
			            for (var _b = 0, _c = fieldValidators.validators; _b < _c.length; _b++) {
			                var validator = _c[_b];
			                var errors = validator.validate(input[fieldValidators.field], fieldsPath, fieldValidators.field);
			                if (errors) {
			                    return errors;
			                }
			            }
			        }
			        return null;
			    };
			    return MultipleFieldsValidator;
			}());
			exports.MultipleFieldsValidator = MultipleFieldsValidator;
		
		
		/***/ }),
		/* 5 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var SettingsValidator = /** @class */ (function (_super) {
			    __extends(SettingsValidator, _super);
			    function SettingsValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    SettingsValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "filterPaneEnabled",
			                validators: [validator_1.Validators.booleanValidator]
			            },
			            {
			                field: "navContentPaneEnabled",
			                validators: [validator_1.Validators.booleanValidator]
			            },
			            {
			                field: "bookmarksPaneEnabled",
			                validators: [validator_1.Validators.booleanValidator]
			            },
			            {
			                field: "useCustomSaveAsDialog",
			                validators: [validator_1.Validators.booleanValidator]
			            },
			            {
			                field: "extensions",
			                validators: [validator_1.Validators.extentionArrayValidator]
			            },
			            {
			                field: "layoutType",
			                validators: [validator_1.Validators.layoutTypeValidator]
			            },
			            {
			                field: "customLayout",
			                validators: [validator_1.Validators.customLayoutValidator]
			            },
			            {
			                field: "background",
			                validators: [validator_1.Validators.backgroundValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return SettingsValidator;
			}(typeValidator_1.ObjectValidator));
			exports.SettingsValidator = SettingsValidator;
		
		
		/***/ }),
		/* 6 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var PlayBookmarkRequestValidator = /** @class */ (function (_super) {
			    __extends(PlayBookmarkRequestValidator, _super);
			    function PlayBookmarkRequestValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    PlayBookmarkRequestValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "playMode",
			                validators: [validator_1.Validators.fieldRequiredValidator, new typeValidator_1.EnumValidator([0, 1])]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return PlayBookmarkRequestValidator;
			}(typeValidator_1.ObjectValidator));
			exports.PlayBookmarkRequestValidator = PlayBookmarkRequestValidator;
			var AddBookmarkRequestValidator = /** @class */ (function (_super) {
			    __extends(AddBookmarkRequestValidator, _super);
			    function AddBookmarkRequestValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    AddBookmarkRequestValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "state",
			                validators: [validator_1.Validators.stringValidator]
			            },
			            {
			                field: "displayName",
			                validators: [validator_1.Validators.stringValidator]
			            },
			            {
			                field: "apply",
			                validators: [validator_1.Validators.booleanValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return AddBookmarkRequestValidator;
			}(typeValidator_1.ObjectValidator));
			exports.AddBookmarkRequestValidator = AddBookmarkRequestValidator;
			var ApplyBookmarkByNameRequestValidator = /** @class */ (function (_super) {
			    __extends(ApplyBookmarkByNameRequestValidator, _super);
			    function ApplyBookmarkByNameRequestValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ApplyBookmarkByNameRequestValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "name",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ApplyBookmarkByNameRequestValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ApplyBookmarkByNameRequestValidator = ApplyBookmarkByNameRequestValidator;
			var ApplyBookmarkStateRequestValidator = /** @class */ (function (_super) {
			    __extends(ApplyBookmarkStateRequestValidator, _super);
			    function ApplyBookmarkStateRequestValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ApplyBookmarkStateRequestValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "state",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ApplyBookmarkStateRequestValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ApplyBookmarkStateRequestValidator = ApplyBookmarkStateRequestValidator;
		
		
		/***/ }),
		/* 7 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var FilterColumnTargetValidator = /** @class */ (function (_super) {
			    __extends(FilterColumnTargetValidator, _super);
			    function FilterColumnTargetValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    FilterColumnTargetValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "table",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "column",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return FilterColumnTargetValidator;
			}(typeValidator_1.ObjectValidator));
			exports.FilterColumnTargetValidator = FilterColumnTargetValidator;
			var FilterHierarchyTargetValidator = /** @class */ (function (_super) {
			    __extends(FilterHierarchyTargetValidator, _super);
			    function FilterHierarchyTargetValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    FilterHierarchyTargetValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "table",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "hierarchy",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "hierarchyLevel",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return FilterHierarchyTargetValidator;
			}(typeValidator_1.ObjectValidator));
			exports.FilterHierarchyTargetValidator = FilterHierarchyTargetValidator;
			var FilterMeasureTargetValidator = /** @class */ (function (_super) {
			    __extends(FilterMeasureTargetValidator, _super);
			    function FilterMeasureTargetValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    FilterMeasureTargetValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "table",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "measure",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return FilterMeasureTargetValidator;
			}(typeValidator_1.ObjectValidator));
			exports.FilterMeasureTargetValidator = FilterMeasureTargetValidator;
			var BasicFilterValidator = /** @class */ (function (_super) {
			    __extends(BasicFilterValidator, _super);
			    function BasicFilterValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    BasicFilterValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "target",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.filterTargetValidator]
			            },
			            {
			                field: "operator",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "values",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.anyArrayValidator]
			            },
			            {
			                field: "filterType",
			                validators: [validator_1.Validators.basicFilterTypeValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return BasicFilterValidator;
			}(typeValidator_1.ObjectValidator));
			exports.BasicFilterValidator = BasicFilterValidator;
			var AdvancedFilterValidator = /** @class */ (function (_super) {
			    __extends(AdvancedFilterValidator, _super);
			    function AdvancedFilterValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    AdvancedFilterValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "target",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.filterTargetValidator]
			            },
			            {
			                field: "logicalOperator",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "conditions",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.filterConditionsValidator]
			            },
			            {
			                field: "filterType",
			                validators: [validator_1.Validators.advancedFilterTypeValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return AdvancedFilterValidator;
			}(typeValidator_1.ObjectValidator));
			exports.AdvancedFilterValidator = AdvancedFilterValidator;
			var RelativeDateFilterValidator = /** @class */ (function (_super) {
			    __extends(RelativeDateFilterValidator, _super);
			    function RelativeDateFilterValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    RelativeDateFilterValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "target",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.filterTargetValidator]
			            },
			            {
			                field: "operator",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.relativeDateFilterOperatorValidator]
			            },
			            {
			                field: "timeUnitsCount",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.numberValidator]
			            },
			            {
			                field: "timeUnitType",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.relativeDateFilterTimeUnitTypeValidator]
			            },
			            {
			                field: "includeToday",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.booleanValidator]
			            },
			            {
			                field: "filterType",
			                validators: [validator_1.Validators.relativeDateFilterTypeValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return RelativeDateFilterValidator;
			}(typeValidator_1.ObjectValidator));
			exports.RelativeDateFilterValidator = RelativeDateFilterValidator;
			var TopNFilterValidator = /** @class */ (function (_super) {
			    __extends(TopNFilterValidator, _super);
			    function TopNFilterValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    TopNFilterValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "target",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.filterTargetValidator]
			            },
			            {
			                field: "operator",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "itemCount",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.numberValidator]
			            },
			            {
			                field: "filterType",
			                validators: [validator_1.Validators.topNFilterTypeValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return TopNFilterValidator;
			}(typeValidator_1.ObjectValidator));
			exports.TopNFilterValidator = TopNFilterValidator;
			var NotSupportedFilterValidator = /** @class */ (function (_super) {
			    __extends(NotSupportedFilterValidator, _super);
			    function NotSupportedFilterValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    NotSupportedFilterValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "target",
			                validators: [validator_1.Validators.filterTargetValidator]
			            },
			            {
			                field: "message",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "notSupportedTypeName",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "filterType",
			                validators: [validator_1.Validators.notSupportedFilterTypeValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return NotSupportedFilterValidator;
			}(typeValidator_1.ObjectValidator));
			exports.NotSupportedFilterValidator = NotSupportedFilterValidator;
			var IncludeExcludeFilterValidator = /** @class */ (function (_super) {
			    __extends(IncludeExcludeFilterValidator, _super);
			    function IncludeExcludeFilterValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    IncludeExcludeFilterValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "target",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.filterTargetValidator]
			            },
			            {
			                field: "isExclude",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.booleanValidator]
			            },
			            {
			                field: "values",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.anyArrayValidator]
			            },
			            {
			                field: "filterType",
			                validators: [validator_1.Validators.includeExludeFilterTypeValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return IncludeExcludeFilterValidator;
			}(typeValidator_1.ObjectValidator));
			exports.IncludeExcludeFilterValidator = IncludeExcludeFilterValidator;
			var FilterValidator = /** @class */ (function (_super) {
			    __extends(FilterValidator, _super);
			    function FilterValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    FilterValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        return validator_1.Validators.anyFilterValidator.validate(input, path, field);
			    };
			    return FilterValidator;
			}(typeValidator_1.ObjectValidator));
			exports.FilterValidator = FilterValidator;
			var ConditionItemValidator = /** @class */ (function (_super) {
			    __extends(ConditionItemValidator, _super);
			    function ConditionItemValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ConditionItemValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "value",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.anyValueValidator]
			            },
			            {
			                field: "operator",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ConditionItemValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ConditionItemValidator = ConditionItemValidator;
		
		
		/***/ }),
		/* 8 */
		/***/ (function(module, exports) {
		
			Object.defineProperty(exports, "__esModule", { value: true });
			var FieldRequiredValidator = /** @class */ (function () {
			    function FieldRequiredValidator() {
			    }
			    FieldRequiredValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return [{
			                    message: field + " is required",
			                    path: (path ? path + "." : "") + field,
			                    keyword: "required"
			                }];
			        }
			        return null;
			    };
			    return FieldRequiredValidator;
			}());
			exports.FieldRequiredValidator = FieldRequiredValidator;
		
		
		/***/ }),
		/* 9 */
		/***/ (function(module, exports) {
		
			Object.defineProperty(exports, "__esModule", { value: true });
			var AnyOfValidator = /** @class */ (function () {
			    function AnyOfValidator(validators) {
			        this.validators = validators;
			    }
			    AnyOfValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var valid = false;
			        for (var _i = 0, _a = this.validators; _i < _a.length; _i++) {
			            var validator = _a[_i];
			            var errors = validator.validate(input, path, field);
			            if (!errors) {
			                valid = true;
			                break;
			            }
			        }
			        if (!valid) {
			            return [{
			                    message: field + " property is invalid",
			                    path: (path ? path + "." : "") + field,
			                    keyword: "invalid"
			                }];
			        }
			        return null;
			    };
			    return AnyOfValidator;
			}());
			exports.AnyOfValidator = AnyOfValidator;
		
		
		/***/ }),
		/* 10 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var ReportLoadValidator = /** @class */ (function (_super) {
			    __extends(ReportLoadValidator, _super);
			    function ReportLoadValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ReportLoadValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "accessToken",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "id",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "settings",
			                validators: [validator_1.Validators.settingsValidator]
			            },
			            {
			                field: "pageName",
			                validators: [validator_1.Validators.stringValidator]
			            },
			            {
			                field: "filters",
			                validators: [validator_1.Validators.filtersArrayValidator]
			            },
			            {
			                field: "permissions",
			                validators: [validator_1.Validators.permissionsValidator]
			            },
			            {
			                field: "viewMode",
			                validators: [validator_1.Validators.viewModeValidator]
			            },
			            {
			                field: "tokenType",
			                validators: [validator_1.Validators.tokenTypeValidator]
			            },
			            {
			                field: "bookmark",
			                validators: [validator_1.Validators.applyBookmarkValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ReportLoadValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ReportLoadValidator = ReportLoadValidator;
		
		
		/***/ }),
		/* 11 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var ReportCreateValidator = /** @class */ (function (_super) {
			    __extends(ReportCreateValidator, _super);
			    function ReportCreateValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ReportCreateValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "accessToken",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "datasetId",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "tokenType",
			                validators: [validator_1.Validators.tokenTypeValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ReportCreateValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ReportCreateValidator = ReportCreateValidator;
		
		
		/***/ }),
		/* 12 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var DashboardLoadValidator = /** @class */ (function (_super) {
			    __extends(DashboardLoadValidator, _super);
			    function DashboardLoadValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    DashboardLoadValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "accessToken",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "id",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "pageView",
			                validators: [validator_1.Validators.pageViewFieldValidator]
			            },
			            {
			                field: "tokenType",
			                validators: [validator_1.Validators.tokenTypeValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return DashboardLoadValidator;
			}(typeValidator_1.ObjectValidator));
			exports.DashboardLoadValidator = DashboardLoadValidator;
		
		
		/***/ }),
		/* 13 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var TileLoadValidator = /** @class */ (function (_super) {
			    __extends(TileLoadValidator, _super);
			    function TileLoadValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    TileLoadValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "accessToken",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "id",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "dashboardId",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "pageView",
			                validators: [validator_1.Validators.stringValidator]
			            },
			            {
			                field: "tokenType",
			                validators: [validator_1.Validators.tokenTypeValidator]
			            },
			            {
			                field: "width",
			                validators: [validator_1.Validators.numberValidator]
			            },
			            {
			                field: "height",
			                validators: [validator_1.Validators.numberValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return TileLoadValidator;
			}(typeValidator_1.ObjectValidator));
			exports.TileLoadValidator = TileLoadValidator;
		
		
		/***/ }),
		/* 14 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var PageSizeValidator = /** @class */ (function (_super) {
			    __extends(PageSizeValidator, _super);
			    function PageSizeValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    PageSizeValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "type",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.pageSizeTypeValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return PageSizeValidator;
			}(typeValidator_1.ObjectValidator));
			exports.PageSizeValidator = PageSizeValidator;
			var CustomPageSizeValidator = /** @class */ (function (_super) {
			    __extends(CustomPageSizeValidator, _super);
			    function CustomPageSizeValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    CustomPageSizeValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "width",
			                validators: [validator_1.Validators.numberValidator]
			            },
			            {
			                field: "height",
			                validators: [validator_1.Validators.numberValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return CustomPageSizeValidator;
			}(PageSizeValidator));
			exports.CustomPageSizeValidator = CustomPageSizeValidator;
			var PageValidator = /** @class */ (function (_super) {
			    __extends(PageValidator, _super);
			    function PageValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    PageValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "name",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return PageValidator;
			}(typeValidator_1.ObjectValidator));
			exports.PageValidator = PageValidator;
			var PageViewFieldValidator = /** @class */ (function (_super) {
			    __extends(PageViewFieldValidator, _super);
			    function PageViewFieldValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    PageViewFieldValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var possibleValues = ["actualSize", "fitToWidth", "oneColumn"];
			        if (possibleValues.indexOf(input) < 0) {
			            return [{
			                    message: "pageView must be a string with one of the following values: \"actualSize\", \"fitToWidth\", \"oneColumn\""
			                }];
			        }
			        return null;
			    };
			    return PageViewFieldValidator;
			}(typeValidator_1.StringValidator));
			exports.PageViewFieldValidator = PageViewFieldValidator;
		
		
		/***/ }),
		/* 15 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var LoadQnaValidator = /** @class */ (function (_super) {
			    __extends(LoadQnaValidator, _super);
			    function LoadQnaValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    LoadQnaValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "accessToken",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			            {
			                field: "datasetIds",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringArrayValidator]
			            },
			            {
			                field: "question",
			                validators: [validator_1.Validators.stringValidator]
			            },
			            {
			                field: "viewMode",
			                validators: [validator_1.Validators.viewModeValidator]
			            },
			            {
			                field: "settings",
			                validators: [validator_1.Validators.qnaSettingValidator]
			            },
			            {
			                field: "tokenType",
			                validators: [validator_1.Validators.tokenTypeValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return LoadQnaValidator;
			}(typeValidator_1.ObjectValidator));
			exports.LoadQnaValidator = LoadQnaValidator;
			var QnaSettingsValidator = /** @class */ (function (_super) {
			    __extends(QnaSettingsValidator, _super);
			    function QnaSettingsValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    QnaSettingsValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "filterPaneEnabled",
			                validators: [validator_1.Validators.booleanValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return QnaSettingsValidator;
			}(typeValidator_1.ObjectValidator));
			exports.QnaSettingsValidator = QnaSettingsValidator;
			var QnaInterpretInputDataValidator = /** @class */ (function (_super) {
			    __extends(QnaInterpretInputDataValidator, _super);
			    function QnaInterpretInputDataValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    QnaInterpretInputDataValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "datasetIds",
			                validators: [validator_1.Validators.stringArrayValidator]
			            },
			            {
			                field: "question",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            },
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return QnaInterpretInputDataValidator;
			}(typeValidator_1.ObjectValidator));
			exports.QnaInterpretInputDataValidator = QnaInterpretInputDataValidator;
		
		
		/***/ }),
		/* 16 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var SaveAsParametersValidator = /** @class */ (function (_super) {
			    __extends(SaveAsParametersValidator, _super);
			    function SaveAsParametersValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    SaveAsParametersValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "name",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.stringValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return SaveAsParametersValidator;
			}(typeValidator_1.ObjectValidator));
			exports.SaveAsParametersValidator = SaveAsParametersValidator;
		
		
		/***/ }),
		/* 17 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var typeValidator_1 = __webpack_require__(2);
			var MapValidator = /** @class */ (function (_super) {
			    __extends(MapValidator, _super);
			    function MapValidator(keyValidators, valueValidators) {
			        var _this = _super.call(this) || this;
			        _this.keyValidators = keyValidators;
			        _this.valueValidators = valueValidators;
			        return _this;
			    }
			    MapValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        for (var key in input) {
			            if (input.hasOwnProperty(key)) {
			                var fieldsPath = (path ? path + "." : "") + field + "." + key;
			                for (var _i = 0, _a = this.keyValidators; _i < _a.length; _i++) {
			                    var keyValidator = _a[_i];
			                    errors = keyValidator.validate(key, fieldsPath, field);
			                    if (errors) {
			                        return errors;
			                    }
			                }
			                for (var _b = 0, _c = this.valueValidators; _b < _c.length; _b++) {
			                    var valueValidator = _c[_b];
			                    errors = valueValidator.validate(input[key], fieldsPath, field);
			                    if (errors) {
			                        return errors;
			                    }
			                }
			            }
			        }
			        return null;
			    };
			    return MapValidator;
			}(typeValidator_1.ObjectValidator));
			exports.MapValidator = MapValidator;
		
		
		/***/ }),
		/* 18 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var validator_1 = __webpack_require__(1);
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var CustomLayoutValidator = /** @class */ (function (_super) {
			    __extends(CustomLayoutValidator, _super);
			    function CustomLayoutValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    CustomLayoutValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "pageSize",
			                validators: [validator_1.Validators.pageSizeValidator]
			            },
			            {
			                field: "displayOption",
			                validators: [validator_1.Validators.customLayoutDisplayOptionValidator]
			            },
			            {
			                field: "pagesLayout",
			                validators: [validator_1.Validators.pagesLayoutValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return CustomLayoutValidator;
			}(typeValidator_1.ObjectValidator));
			exports.CustomLayoutValidator = CustomLayoutValidator;
			var VisualLayoutValidator = /** @class */ (function (_super) {
			    __extends(VisualLayoutValidator, _super);
			    function VisualLayoutValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    VisualLayoutValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "x",
			                validators: [validator_1.Validators.numberValidator]
			            },
			            {
			                field: "y",
			                validators: [validator_1.Validators.numberValidator]
			            },
			            {
			                field: "z",
			                validators: [validator_1.Validators.numberValidator]
			            },
			            {
			                field: "width",
			                validators: [validator_1.Validators.numberValidator]
			            },
			            {
			                field: "height",
			                validators: [validator_1.Validators.numberValidator]
			            },
			            {
			                field: "displayState",
			                validators: [validator_1.Validators.displayStateValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return VisualLayoutValidator;
			}(typeValidator_1.ObjectValidator));
			exports.VisualLayoutValidator = VisualLayoutValidator;
			var DisplayStateValidator = /** @class */ (function (_super) {
			    __extends(DisplayStateValidator, _super);
			    function DisplayStateValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    DisplayStateValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "mode",
			                validators: [validator_1.Validators.displayStateModeValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return DisplayStateValidator;
			}(typeValidator_1.ObjectValidator));
			exports.DisplayStateValidator = DisplayStateValidator;
			var PageLayoutValidator = /** @class */ (function (_super) {
			    __extends(PageLayoutValidator, _super);
			    function PageLayoutValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    PageLayoutValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "visualsLayout",
			                validators: [validator_1.Validators.fieldRequiredValidator, validator_1.Validators.pageLayoutValidator]
			            },
			            {
			                field: "defaultLayout",
			                validators: [validator_1.Validators.visualLayoutValidator]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return PageLayoutValidator;
			}(typeValidator_1.ObjectValidator));
			exports.PageLayoutValidator = PageLayoutValidator;
		
		
		/***/ }),
		/* 19 */
		/***/ (function(module, exports, __webpack_require__) {
		
			var __extends = (this && this.__extends) || (function () {
			    var extendStatics = Object.setPrototypeOf ||
			        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
			        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
			    return function (d, b) {
			        extendStatics(d, b);
			        function __() { this.constructor = d; }
			        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			    };
			})();
			Object.defineProperty(exports, "__esModule", { value: true });
			var multipleFieldsValidator_1 = __webpack_require__(4);
			var typeValidator_1 = __webpack_require__(2);
			var ExportDataRequestValidator = /** @class */ (function (_super) {
			    __extends(ExportDataRequestValidator, _super);
			    function ExportDataRequestValidator() {
			        return _super !== null && _super.apply(this, arguments) || this;
			    }
			    ExportDataRequestValidator.prototype.validate = function (input, path, field) {
			        if (input == null) {
			            return null;
			        }
			        var errors = _super.prototype.validate.call(this, input, path, field);
			        if (errors) {
			            return errors;
			        }
			        var fields = [
			            {
			                field: "rows",
			                validators: [new typeValidator_1.NumberValidator()]
			            },
			            {
			                field: "exportDataType",
			                validators: [new typeValidator_1.EnumValidator([0, 1])]
			            }
			        ];
			        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
			        return multipleFieldsValidator.validate(input, path, field);
			    };
			    return ExportDataRequestValidator;
			}(typeValidator_1.ObjectValidator));
			exports.ExportDataRequestValidator = ExportDataRequestValidator;
		
		
		/***/ })
		/******/ ])
		});
		;
		//# sourceMappingURL=models.js.map
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var embed = __webpack_require__(2);
		var models = __webpack_require__(4);
		var utils = __webpack_require__(3);
		var page_1 = __webpack_require__(6);
		var defaults_1 = __webpack_require__(8);
		var bookmarksManager_1 = __webpack_require__(9);
		/**
		 * The Power BI Report embed component
		 *
		 * @export
		 * @class Report
		 * @extends {embed.Embed}
		 * @implements {IReportNode}
		 * @implements {IFilterable}
		 */
		var Report = (function (_super) {
		    __extends(Report, _super);
		    /**
		     * Creates an instance of a Power BI Report.
		     *
		     * @param {service.Service} service
		     * @param {HTMLElement} element
		     * @param {embed.IEmbedConfiguration} config
		     */
		    function Report(service, element, baseConfig, phasedRender, iframe) {
		        var config = baseConfig;
		        var filterPaneEnabled = (config.settings && config.settings.filterPaneEnabled) || !(element.getAttribute(Report.filterPaneEnabledAttribute) === "false");
		        var navContentPaneEnabled = (config.settings && config.settings.navContentPaneEnabled) || !(element.getAttribute(Report.navContentPaneEnabledAttribute) === "false");
		        var settings = utils.assign({
		            filterPaneEnabled: filterPaneEnabled,
		            navContentPaneEnabled: navContentPaneEnabled
		        }, config.settings);
		        var configCopy = utils.assign({ settings: settings }, config);
		        _super.call(this, service, element, configCopy, iframe, phasedRender);
		        this.loadPath = "/report/load";
		        this.phasedLoadPath = "/report/prepare";
		        Array.prototype.push.apply(this.allowedEvents, Report.allowedEvents);
		        this.bookmarksManager = new bookmarksManager_1.BookmarksManager(service, config, this.iframe);
		    }
		    /**
		     * Adds backwards compatibility for the previous load configuration, which used the reportId query parameter to specify the report ID
		     * (e.g. http://embedded.powerbi.com/appTokenReportEmbed?reportId=854846ed-2106-4dc2-bc58-eb77533bf2f1).
		     *
		     * By extracting the ID we can ensure that the ID is always explicitly provided as part of the load configuration.
		     *
		     * @static
		     * @param {string} url
		     * @returns {string}
		     */
		    Report.findIdFromEmbedUrl = function (url) {
		        var reportIdRegEx = /reportId="?([^&]+)"?/;
		        var reportIdMatch = url.match(reportIdRegEx);
		        var reportId;
		        if (reportIdMatch) {
		            reportId = reportIdMatch[1];
		        }
		        return reportId;
		    };
		    /**
		     * Render a preloaded report, using phased embedding API
		     *
		     * ```javascript
		     * // Load report
		     * var report = powerbi.load(element, config);
		     *
		     * ...
		     *
		     * // Render report
		     * report.render()
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    Report.prototype.render = function (config) {
		        return this.service.hpm.post("/report/render", config, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        })
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Gets filters that are applied at the report level.
		     *
		     * ```javascript
		     * // Get filters applied at report level
		     * report.getFilters()
		     *   .then(filters => {
		     *     ...
		     *   });
		     * ```
		     *
		     * @returns {Promise<models.IFilter[]>}
		     */
		    Report.prototype.getFilters = function () {
		        return this.service.hpm.get("/report/filters", { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) { return response.body; }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Gets the report ID from the first available location: options, attribute, embed url.
		     *
		     * @returns {string}
		     */
		    Report.prototype.getId = function () {
		        var config = this.config;
		        var reportId = config.id || this.element.getAttribute(Report.reportIdAttribute) || Report.findIdFromEmbedUrl(config.embedUrl);
		        if (typeof reportId !== 'string' || reportId.length === 0) {
		            throw new Error("Report id is required, but it was not found. You must provide an id either as part of embed configuration or as attribute '" + Report.reportIdAttribute + "'.");
		        }
		        return reportId;
		    };
		    /**
		     * Gets the list of pages within the report.
		     *
		     * ```javascript
		     * report.getPages()
		     *  .then(pages => {
		     *      ...
		     *  });
		     * ```
		     *
		     * @returns {Promise<Page[]>}
		     */
		    Report.prototype.getPages = function () {
		        var _this = this;
		        return this.service.hpm.get('/report/pages', { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body
		                .map(function (page) {
		                return new page_1.Page(_this, page.name, page.displayName, page.isActive);
		            });
		        }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Creates an instance of a Page.
		     *
		     * Normally you would get Page objects by calling `report.getPages()`, but in the case
		     * that the page name is known and you want to perform an action on a page without having to retrieve it
		     * you can create it directly.
		     *
		     * Note: Because you are creating the page manually there is no guarantee that the page actually exists in the report, and subsequent requests could fail.
		     *
		     * ```javascript
		     * const page = report.page('ReportSection1');
		     * page.setActive();
		     * ```
		     *
		     * @param {string} name
		     * @param {string} [displayName]
		     * @param {boolean} [isActive]
		     * @returns {Page}
		     */
		    Report.prototype.page = function (name, displayName, isActive) {
		        return new page_1.Page(this, name, displayName, isActive);
		    };
		    /**
		     * Prints the active page of the report by invoking `window.print()` on the embed iframe component.
		     */
		    Report.prototype.print = function () {
		        return this.service.hpm.post('/report/print', null, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        })
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Removes all filters at the report level.
		     *
		     * ```javascript
		     * report.removeFilters();
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    Report.prototype.removeFilters = function () {
		        return this.setFilters([]);
		    };
		    /**
		     * Sets the active page of the report.
		     *
		     * ```javascript
		     * report.setPage("page2")
		     *  .catch(error => { ... });
		     * ```
		     *
		     * @param {string} pageName
		     * @returns {Promise<void>}
		     */
		    Report.prototype.setPage = function (pageName) {
		        var page = {
		            name: pageName,
		            displayName: null,
		            isActive: true
		        };
		        return this.service.hpm.put('/report/pages/active', page, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Sets filters at the report level.
		     *
		     * ```javascript
		     * const filters: [
		     *    ...
		     * ];
		     *
		     * report.setFilters(filters)
		     *  .catch(errors => {
		     *    ...
		     *  });
		     * ```
		     *
		     * @param {(models.IFilter[])} filters
		     * @returns {Promise<void>}
		     */
		    Report.prototype.setFilters = function (filters) {
		        return this.service.hpm.put("/report/filters", filters, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Updates visibility settings for the filter pane and the page navigation pane.
		     *
		     * ```javascript
		     * const newSettings = {
		     *   navContentPaneEnabled: true,
		     *   filterPaneEnabled: false
		     * };
		     *
		     * report.updateSettings(newSettings)
		     *   .catch(error => { ... });
		     * ```
		     *
		     * @param {models.ISettings} settings
		     * @returns {Promise<void>}
		     */
		    Report.prototype.updateSettings = function (settings) {
		        return this.service.hpm.patch('/report/settings', settings, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Validate load configuration.
		     */
		    Report.prototype.validate = function (config) {
		        return models.validateReportLoad(config);
		    };
		    /**
		     * Populate config for load config
		     *
		     * @param {IEmbedConfigurationBase}
		     * @returns {void}
		     */
		    Report.prototype.populateConfig = function (baseConfig) {
		        var config = baseConfig;
		        if (config.settings && (config.settings.layoutType === models.LayoutType.MobileLandscape || config.settings.layoutType === models.LayoutType.MobilePortrait))
		            config.embedUrl = utils.addParamToUrl(config.embedUrl, "isMobile", "true");
		        _super.prototype.populateConfig.call(this, config);
		        // TODO: Change when Object.assign is available.
		        var settings = utils.assign({}, defaults_1.Defaults.defaultSettings, config.settings);
		        config = utils.assign({ settings: settings }, config);
		        config.id = this.getId();
		        this.config = config;
		    };
		    /**
		     * Switch Report view mode.
		     *
		     * @returns {Promise<void>}
		     */
		    Report.prototype.switchMode = function (viewMode) {
		        var url = '/report/switchMode/' + viewMode;
		        return this.service.hpm.post(url, null, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        })
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		    * Refreshes data sources for the report.
		    *
		    * ```javascript
		    * report.refresh();
		    * ```
		    */
		    Report.prototype.refresh = function () {
		        return this.service.hpm.post('/report/refresh', null, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) {
		            return response.body;
		        })
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    Report.allowedEvents = ["filtersApplied", "pageChanged", "commandTriggered", "swipeStart", "swipeEnd", "bookmarkApplied"];
		    Report.reportIdAttribute = 'powerbi-report-id';
		    Report.filterPaneEnabledAttribute = 'powerbi-settings-filter-pane-enabled';
		    Report.navContentPaneEnabledAttribute = 'powerbi-settings-nav-content-pane-enabled';
		    Report.typeAttribute = 'powerbi-type';
		    Report.type = "Report";
		    return Report;
		}(embed.Embed));
		exports.Report = Report;
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var visualDescriptor_1 = __webpack_require__(7);
		var models = __webpack_require__(4);
		/**
		 * A Power BI report page
		 *
		 * @export
		 * @class Page
		 * @implements {IPageNode}
		 * @implements {IFilterable}
		 */
		var Page = (function () {
		    /**
		     * Creates an instance of a Power BI report page.
		     *
		     * @param {IReportNode} report
		     * @param {string} name
		     * @param {string} [displayName]
		     * @param {boolean} [isActivePage]
		     */
		    function Page(report, name, displayName, isActivePage) {
		        this.report = report;
		        this.name = name;
		        this.displayName = displayName;
		        this.isActive = isActivePage;
		    }
		    /**
		     * Gets all page level filters within the report.
		     *
		     * ```javascript
		     * page.getFilters()
		     *  .then(filters => { ... });
		     * ```
		     *
		     * @returns {(Promise<models.IFilter[]>)}
		     */
		    Page.prototype.getFilters = function () {
		        return this.report.service.hpm.get("/report/pages/" + this.name + "/filters", { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow)
		            .then(function (response) { return response.body; }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Removes all filters from this page of the report.
		     *
		     * ```javascript
		     * page.removeFilters();
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    Page.prototype.removeFilters = function () {
		        return this.setFilters([]);
		    };
		    /**
		     * Makes the current page the active page of the report.
		     *
		     * ```javascripot
		     * page.setActive();
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    Page.prototype.setActive = function () {
		        var page = {
		            name: this.name,
		            displayName: null,
		            isActive: true
		        };
		        return this.report.service.hpm.put('/report/pages/active', page, { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Sets all filters on the current page.
		     *
		     * ```javascript
		     * page.setFilters(filters);
		     *   .catch(errors => { ... });
		     * ```
		     *
		     * @param {(models.IFilter[])} filters
		     * @returns {Promise<void>}
		     */
		    Page.prototype.setFilters = function (filters) {
		        return this.report.service.hpm.put("/report/pages/" + this.name + "/filters", filters, { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Gets all the visuals on the page.
		     *
		     * ```javascript
		     * page.getVisuals()
		     *   .then(visuals => { ... });
		     * ```
		     *
		     * @returns {Promise<VisualDescriptor[]>}
		     */
		    Page.prototype.getVisuals = function () {
		        var _this = this;
		        return this.report.service.hpm.get("/report/pages/" + this.name + "/visuals", { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow)
		            .then(function (response) {
		            return response.body
		                .map(function (visual) {
		                return new visualDescriptor_1.VisualDescriptor(_this, visual.name, visual.title, visual.type, visual.layout);
		            });
		        }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Checks if page has layout.
		     *
		     * ```javascript
		     * page.hasLayout(layoutType)
		     *  .then(hasLayout: boolean => { ... });
		     * ```
		     *
		     * @returns {(Promise<boolean>)}
		     */
		    Page.prototype.hasLayout = function (layoutType) {
		        var layoutTypeEnum = models.LayoutType[layoutType];
		        return this.report.service.hpm.get("/report/pages/" + this.name + "/layoutTypes/" + layoutTypeEnum, { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow)
		            .then(function (response) { return response.body; }, function (response) {
		            throw response.body;
		        });
		    };
		    return Page;
		}());
		exports.Page = Page;
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/**
		 * A Power BI visual within a page
		 *
		 * @export
		 * @class VisualDescriptor
		 * @implements {IVisualNode}
		 */
		var VisualDescriptor = (function () {
		    function VisualDescriptor(page, name, title, type, layout) {
		        this.name = name;
		        this.title = title;
		        this.type = type;
		        this.layout = layout;
		        this.page = page;
		    }
		    /**
		     * Gets all visual level filters of the current visual.
		     *
		     * ```javascript
		     * visual.getFilters()
		     *  .then(filters => { ... });
		     * ```
		     *
		     * @returns {(Promise<models.IFilter[]>)}
		     */
		    VisualDescriptor.prototype.getFilters = function () {
		        return this.page.report.service.hpm.get("/report/pages/" + this.page.name + "/visuals/" + this.name + "/filters", { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow)
		            .then(function (response) { return response.body; }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Removes all filters from the current visual.
		     *
		     * ```javascript
		     * visual.removeFilters();
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    VisualDescriptor.prototype.removeFilters = function () {
		        return this.setFilters([]);
		    };
		    /**
		     * Sets the filters on the current visual to 'filters'.
		     *
		     * ```javascript
		     * visual.setFilters(filters);
		     *   .catch(errors => { ... });
		     * ```
		     *
		     * @param {(models.IFilter[])} filters
		     * @returns {Promise<void>}
		     */
		    VisualDescriptor.prototype.setFilters = function (filters) {
		        return this.page.report.service.hpm.put("/report/pages/" + this.page.name + "/visuals/" + this.name + "/filters", filters, { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Exports Visual data.
		     * Can export up to 30K rows.
		     * @param rows: Optional. Default value is 30K, maximum value is 30K as well.
		     * @param exportDataType: Optional. Default is models.ExportDataType.Summarized.
		     * ```javascript
		     * visual.exportData()
		     *  .then(data => { ... });
		     * ```
		     *
		     * @returns {(Promise<string>)}
		     */
		    VisualDescriptor.prototype.exportData = function (exportDataType, rows) {
		        var exportDataRequestBody = {
		            rows: rows,
		            exportDataType: exportDataType
		        };
		        return this.page.report.service.hpm.post("/report/pages/" + this.page.name + "/visuals/" + this.name + "/exportData", exportDataRequestBody, { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow)
		            .then(function (response) { return response.body; }, function (response) {
		            throw response.body;
		        });
		    };
		    return VisualDescriptor;
		}());
		exports.VisualDescriptor = VisualDescriptor;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		var Defaults = (function () {
		    function Defaults() {
		    }
		    Defaults.defaultSettings = {
		        filterPaneEnabled: true
		    };
		    Defaults.defaultQnaSettings = {
		        filterPaneEnabled: false
		    };
		    return Defaults;
		}());
		exports.Defaults = Defaults;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
		/**
		 * Manages report bookmarks.
		 *
		 * @export
		 * @class BookmarksManager
		 * @implements {IBookmarksManager}
		 */
		var BookmarksManager = (function () {
		    function BookmarksManager(service, config, iframe) {
		        this.service = service;
		        this.config = config;
		        this.iframe = iframe;
		    }
		    /**
		     * Gets bookmarks that are defined in the report.
		     *
		     * ```javascript
		     * // Gets bookmarks that are defined in the report
		     * bookmarksManager.getBookmarks()
		     *   .then(bookmarks => {
		     *     ...
		     *   });
		     * ```
		     *
		     * @returns {Promise<models.IReportBookmark[]>}
		     */
		    BookmarksManager.prototype.getBookmarks = function () {
		        return this.service.hpm.get("/report/bookmarks", { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) { return response.body; }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Apply bookmark By name.
		     *
		     * ```javascript
		     * bookmarksManager.apply(bookmarkName)
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    BookmarksManager.prototype.apply = function (bookmarkName) {
		        var request = {
		            name: bookmarkName
		        };
		        return this.service.hpm.post("/report/bookmarks/applyByName", request, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Play bookmarks: Enter or Exit bookmarks presentation mode.
		     *
		     * ```javascript
		     * // Enter presentation mode.
		     * bookmarksManager.play(true)
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    BookmarksManager.prototype.play = function (playMode) {
		        var playBookmarkRequest = {
		            playMode: playMode
		        };
		        return this.service.hpm.post("/report/bookmarks/play", playBookmarkRequest, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Capture bookmark from current state.
		     *
		     * ```javascript
		     * bookmarksManager.capture()
		     * ```
		     *
		     * @returns {Promise<models.IReportBookmark>}
		     */
		    BookmarksManager.prototype.capture = function () {
		        return this.service.hpm.post("/report/bookmarks/capture", null, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .then(function (response) { return response.body; }, function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Apply bookmark state.
		     *
		     * ```javascript
		     * bookmarksManager.applyState(bookmarkName)
		     * ```
		     *
		     * @returns {Promise<void>}
		     */
		    BookmarksManager.prototype.applyState = function (state) {
		        var request = {
		            state: state
		        };
		        return this.service.hpm.post("/report/bookmarks/applyState", request, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    return BookmarksManager;
		}());
		exports.BookmarksManager = BookmarksManager;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var models = __webpack_require__(4);
		var embed = __webpack_require__(2);
		var utils = __webpack_require__(3);
		var defaults_1 = __webpack_require__(8);
		var Create = (function (_super) {
		    __extends(Create, _super);
		    function Create(service, element, config, phasedRender) {
		        _super.call(this, service, element, config, /* iframe */ undefined, phasedRender);
		    }
		    /**
		     * Gets the dataset ID from the first available location: createConfig or embed url.
		     *
		     * @returns {string}
		     */
		    Create.prototype.getId = function () {
		        var datasetId = (this.createConfig && this.createConfig.datasetId) ? this.createConfig.datasetId : Create.findIdFromEmbedUrl(this.config.embedUrl);
		        if (typeof datasetId !== 'string' || datasetId.length === 0) {
		            throw new Error('Dataset id is required, but it was not found. You must provide an id either as part of embed configuration.');
		        }
		        return datasetId;
		    };
		    /**
		     * Validate create report configuration.
		     */
		    Create.prototype.validate = function (config) {
		        return models.validateCreateReport(config);
		    };
		    /**
		     * Populate config for create
		     *
		     * @param {IEmbedConfigurationBase}
		     * @returns {void}
		     */
		    Create.prototype.populateConfig = function (baseConfig) {
		        _super.prototype.populateConfig.call(this, baseConfig);
		        // TODO: Change when Object.assign is available.
		        var settings = utils.assign({}, defaults_1.Defaults.defaultSettings, baseConfig.settings);
		        this.config = utils.assign({ settings: settings }, baseConfig);
		        var config = this.config;
		        this.createConfig = {
		            datasetId: config.datasetId || this.getId(),
		            accessToken: config.accessToken,
		            tokenType: config.tokenType,
		            settings: settings
		        };
		    };
		    /**
		     * Adds the ability to get datasetId from url.
		     * (e.g. http://embedded.powerbi.com/appTokenReportEmbed?datasetId=854846ed-2106-4dc2-bc58-eb77533bf2f1).
		     *
		     * By extracting the ID we can ensure that the ID is always explicitly provided as part of the create configuration.
		     *
		     * @static
		     * @param {string} url
		     * @returns {string}
		     */
		    Create.findIdFromEmbedUrl = function (url) {
		        var datasetIdRegEx = /datasetId="?([^&]+)"?/;
		        var datasetIdMatch = url.match(datasetIdRegEx);
		        var datasetId;
		        if (datasetIdMatch) {
		            datasetId = datasetIdMatch[1];
		        }
		        return datasetId;
		    };
		    return Create;
		}(embed.Embed));
		exports.Create = Create;
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var embed = __webpack_require__(2);
		var models = __webpack_require__(4);
		var utils = __webpack_require__(3);
		var defaults_1 = __webpack_require__(8);
		/**
		 * A Power BI Dashboard embed component
		 *
		 * @export
		 * @class Dashboard
		 * @extends {embed.Embed}
		 * @implements {IDashboardNode}
		 * @implements {IFilterable}
		 */
		var Dashboard = (function (_super) {
		    __extends(Dashboard, _super);
		    /**
		     * Creates an instance of a Power BI Dashboard.
		     *
		     * @param {service.Service} service
		     * @param {HTMLElement} element
		     */
		    function Dashboard(service, element, config, phasedRender) {
		        _super.call(this, service, element, config, /* iframe */ undefined, phasedRender);
		        this.loadPath = "/dashboard/load";
		        this.phasedLoadPath = "/dashboard/prepare";
		        Array.prototype.push.apply(this.allowedEvents, Dashboard.allowedEvents);
		    }
		    /**
		     * This adds backwards compatibility for older config which used the dashboardId query param to specify dashboard id.
		     * E.g. https://powerbi-df.analysis-df.windows.net/dashboardEmbedHost?dashboardId=e9363c62-edb6-4eac-92d3-2199c5ca2a9e
		     *
		     * By extracting the id we can ensure id is always explicitly provided as part of the load configuration.
		     *
		     * @static
		     * @param {string} url
		     * @returns {string}
		     */
		    Dashboard.findIdFromEmbedUrl = function (url) {
		        var dashboardIdRegEx = /dashboardId="?([^&]+)"?/;
		        var dashboardIdMatch = url.match(dashboardIdRegEx);
		        var dashboardId;
		        if (dashboardIdMatch) {
		            dashboardId = dashboardIdMatch[1];
		        }
		        return dashboardId;
		    };
		    /**
		     * Get dashboard id from first available location: options, attribute, embed url.
		     *
		     * @returns {string}
		     */
		    Dashboard.prototype.getId = function () {
		        var config = this.config;
		        var dashboardId = config.id || this.element.getAttribute(Dashboard.dashboardIdAttribute) || Dashboard.findIdFromEmbedUrl(config.embedUrl);
		        if (typeof dashboardId !== 'string' || dashboardId.length === 0) {
		            throw new Error("Dashboard id is required, but it was not found. You must provide an id either as part of embed configuration or as attribute '" + Dashboard.dashboardIdAttribute + "'.");
		        }
		        return dashboardId;
		    };
		    /**
		     * Validate load configuration.
		     */
		    Dashboard.prototype.validate = function (baseConfig) {
		        var config = baseConfig;
		        var error = models.validateDashboardLoad(config);
		        return error ? error : this.ValidatePageView(config.pageView);
		    };
		    /**
		     * Populate config for load config
		     *
		     * @param {IEmbedConfigurationBase}
		     * @returns {void}
		     */
		    Dashboard.prototype.populateConfig = function (baseConfig) {
		        var config = baseConfig;
		        _super.prototype.populateConfig.call(this, config);
		        // TODO: Change when Object.assign is available.
		        var settings = utils.assign({}, defaults_1.Defaults.defaultSettings, config.settings);
		        config = utils.assign({ settings: settings }, config);
		        config.id = this.getId();
		        this.config = config;
		    };
		    /**
		     * Validate that pageView has a legal value: if page view is defined it must have one of the values defined in models.PageView
		     */
		    Dashboard.prototype.ValidatePageView = function (pageView) {
		        if (pageView && pageView !== "fitToWidth" && pageView !== "oneColumn" && pageView !== "actualSize") {
		            return [{ message: "pageView must be one of the followings: fitToWidth, oneColumn, actualSize" }];
		        }
		    };
		    Dashboard.allowedEvents = ["tileClicked", "error"];
		    Dashboard.dashboardIdAttribute = 'powerbi-dashboard-id';
		    Dashboard.typeAttribute = 'powerbi-type';
		    Dashboard.type = "Dashboard";
		    return Dashboard;
		}(embed.Embed));
		exports.Dashboard = Dashboard;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var models = __webpack_require__(4);
		var embed = __webpack_require__(2);
		var utils = __webpack_require__(3);
		var defaults_1 = __webpack_require__(8);
		/**
		 * The Power BI tile embed component
		 *
		 * @export
		 * @class Tile
		 * @extends {Embed}
		 */
		var Tile = (function (_super) {
		    __extends(Tile, _super);
		    function Tile(service, element, baseConfig, phasedRender) {
		        var config = baseConfig;
		        _super.call(this, service, element, config, /* iframe */ undefined, phasedRender);
		        this.loadPath = "/tile/load";
		        Array.prototype.push.apply(this.allowedEvents, Tile.allowedEvents);
		    }
		    /**
		     * The ID of the tile
		     *
		     * @returns {string}
		     */
		    Tile.prototype.getId = function () {
		        var config = this.config;
		        var tileId = config.id || Tile.findIdFromEmbedUrl(this.config.embedUrl);
		        if (typeof tileId !== 'string' || tileId.length === 0) {
		            throw new Error("Tile id is required, but it was not found. You must provide an id either as part of embed configuration.");
		        }
		        return tileId;
		    };
		    /**
		     * Validate load configuration.
		     */
		    Tile.prototype.validate = function (config) {
		        var embedConfig = config;
		        return models.validateTileLoad(embedConfig);
		    };
		    /**
		     * Populate config for load config
		     *
		     * @param {IEmbedConfigurationBase}
		     * @returns {void}
		     */
		    Tile.prototype.populateConfig = function (baseConfig) {
		        var config = baseConfig;
		        _super.prototype.populateConfig.call(this, config);
		        // TODO: Change when Object.assign is available.
		        var settings = utils.assign({}, defaults_1.Defaults.defaultSettings, config.settings);
		        config = utils.assign({ settings: settings }, config);
		        config.id = this.getId();
		        this.config = config;
		    };
		    /**
		     * Adds the ability to get tileId from url.
		     * By extracting the ID we can ensure that the ID is always explicitly provided as part of the load configuration.
		     *
		     * @static
		     * @param {string} url
		     * @returns {string}
		     */
		    Tile.findIdFromEmbedUrl = function (url) {
		        var tileIdRegEx = /tileId="?([^&]+)"?/;
		        var tileIdMatch = url.match(tileIdRegEx);
		        var tileId;
		        if (tileIdMatch) {
		            tileId = tileIdMatch[1];
		        }
		        return tileId;
		    };
		    Tile.type = "Tile";
		    Tile.allowedEvents = ["tileClicked", "tileLoaded"];
		    return Tile;
		}(embed.Embed));
		exports.Tile = Tile;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var models = __webpack_require__(4);
		var embed = __webpack_require__(2);
		/**
		 * The Power BI Qna embed component
		 *
		 * @export
		 * @class Qna
		 * @extends {Embed}
		 */
		var Qna = (function (_super) {
		    __extends(Qna, _super);
		    function Qna(service, element, config, phasedRender) {
		        _super.call(this, service, element, config, /* iframe */ undefined, phasedRender);
		        this.loadPath = "/qna/load";
		        this.phasedLoadPath = "/qna/prepare";
		        Array.prototype.push.apply(this.allowedEvents, Qna.allowedEvents);
		    }
		    /**
		     * The ID of the Qna embed component
		     *
		     * @returns {string}
		     */
		    Qna.prototype.getId = function () {
		        return null;
		    };
		    /**
		     * Change the question of the Q&A embed component
		     *
		     * @param question - question which will render Q&A data
		     * @returns {string}
		     */
		    Qna.prototype.setQuestion = function (question) {
		        var qnaData = {
		            question: question
		        };
		        return this.service.hpm.post('/qna/interpret', qnaData, { uid: this.config.uniqueId }, this.iframe.contentWindow)
		            .catch(function (response) {
		            throw response.body;
		        });
		    };
		    /**
		     * Validate load configuration.
		     */
		    Qna.prototype.validate = function (config) {
		        return models.validateLoadQnaConfiguration(config);
		    };
		    Qna.type = "Qna";
		    Qna.allowedEvents = ["loaded", "visualRendered"];
		    return Qna;
		}(embed.Embed));
		exports.Qna = Qna;
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var models = __webpack_require__(4);
		var report_1 = __webpack_require__(5);
		/**
		 * The Power BI Visual embed component
		 *
		 * @export
		 * @class Visual
		 */
		var Visual = (function (_super) {
		    __extends(Visual, _super);
		    /**
		     * Creates an instance of a Power BI Single Visual.
		     *
		     * @param {service.Service} service
		     * @param {HTMLElement} element
		     * @param {embed.IEmbedConfiguration} config
		     */
		    function Visual(service, element, baseConfig, phasedRender, iframe) {
		        _super.call(this, service, element, baseConfig, phasedRender, iframe);
		    }
		    Visual.prototype.load = function (baseConfig, phasedRender) {
		        var config = baseConfig;
		        if (typeof config.pageName !== 'string' || config.pageName.length === 0) {
		            throw new Error("Page name is required when embedding a visual.");
		        }
		        if (typeof config.visualName !== 'string' || config.visualName.length === 0) {
		            throw new Error("Visual name is required, but it was not found. You must provide a visual name as part of embed configuration.");
		        }
		        // calculate custom layout settings and override config.
		        var width = config.width ? config.width : this.iframe.offsetWidth;
		        var height = config.height ? config.height : this.iframe.offsetHeight;
		        var pageSize = {
		            type: models.PageSizeType.Custom,
		            width: width,
		            height: height,
		        };
		        var pagesLayout = {};
		        pagesLayout[config.pageName] = {
		            defaultLayout: {
		                displayState: {
		                    mode: models.VisualContainerDisplayMode.Hidden
		                }
		            },
		            visualsLayout: {}
		        };
		        pagesLayout[config.pageName].visualsLayout[config.visualName] = {
		            displayState: {
		                mode: models.VisualContainerDisplayMode.Visible
		            },
		            x: 1,
		            y: 1,
		            z: 1,
		            width: pageSize.width,
		            height: pageSize.height
		        };
		        config.settings = config.settings || {};
		        config.settings.filterPaneEnabled = false;
		        config.settings.navContentPaneEnabled = false;
		        config.settings.layoutType = models.LayoutType.Custom;
		        config.settings.customLayout = {
		            displayOption: models.DisplayOption.FitToPage,
		            pageSize: pageSize,
		            pagesLayout: pagesLayout
		        };
		        return _super.prototype.load.call(this, config, phasedRender);
		    };
		    /**
		     * Gets the list of pages within the report - not supported in visual embed.
		     *
		     * @returns {Promise<Page[]>}
		     */
		    Visual.prototype.getPages = function () {
		        throw Visual.GetPagesNotSupportedError;
		    };
		    /**
		     * Sets the active page of the report - not supported in visual embed.
		     *
		     * @param {string} pageName
		     * @returns {Promise<void>}
		     */
		    Visual.prototype.setPage = function (pageName) {
		        throw Visual.SetPageNotSupportedError;
		    };
		    /**
		     * Gets filters that are applied at the visual level.
		     *
		     * ```javascript
		     * // Get filters applied at visual level
		     * visual.getFilters()
		     *   .then(filters => {
		     *     ...
		     *   });
		     * ```
		     *
		     * @returns {Promise<models.IFilter[]>}
		     */
		    Visual.prototype.getFilters = function () {
		        throw Visual.GetFiltersNotSupportedError;
		    };
		    /**
		     * Sets filters at the visual level.
		     *
		     * ```javascript
		     * const filters: [
		     *    ...
		     * ];
		     *
		     * visual.setFilters(filters)
		     *  .catch(errors => {
		     *    ...
		     *  });
		     * ```
		     *
		     * @param {(models.IFilter[])} filters
		     * @returns {Promise<void>}
		     */
		    Visual.prototype.setFilters = function (filters) {
		        throw Visual.SetFiltersNotSupportedError;
		    };
		    Visual.type = "visual";
		    Visual.GetFiltersNotSupportedError = "Getting visual level filters is not supported.";
		    Visual.SetFiltersNotSupportedError = "Setting visual level filters is not supported.";
		    Visual.GetPagesNotSupportedError = "Get pages is not supported while embedding a visual.";
		    Visual.SetPageNotSupportedError = "Set page is not supported while embedding a visual.";
		    return Visual;
		}(report_1.Report));
		exports.Visual = Visual;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var config_1 = __webpack_require__(16);
		var wpmp = __webpack_require__(17);
		var hpm = __webpack_require__(18);
		var router = __webpack_require__(19);
		exports.hpmFactory = function (wpmp, defaultTargetWindow, sdkVersion, sdkType) {
		    if (sdkVersion === void 0) { sdkVersion = config_1.default.version; }
		    if (sdkType === void 0) { sdkType = config_1.default.type; }
		    return new hpm.HttpPostMessage(wpmp, {
		        'x-sdk-type': sdkType,
		        'x-sdk-version': sdkVersion
		    }, defaultTargetWindow);
		};
		exports.wpmpFactory = function (name, logMessages, eventSourceOverrideWindow) {
		    return new wpmp.WindowPostMessageProxy({
		        processTrackingProperties: {
		            addTrackingProperties: hpm.HttpPostMessage.addTrackingProperties,
		            getTrackingProperties: hpm.HttpPostMessage.getTrackingProperties,
		        },
		        isErrorMessage: hpm.HttpPostMessage.isErrorMessage,
		        suppressWarnings: true,
		        name: name,
		        logMessages: logMessages,
		        eventSourceOverrideWindow: eventSourceOverrideWindow
		    });
		};
		exports.routerFactory = function (wpmp) {
		    return new router.Router(wpmp);
		};
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
		var config = {
		    version: '2.5.1',
		    type: 'js'
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.default = config;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/*! window-post-message-proxy v0.2.5 | (c) 2016 Microsoft Corporation MIT */
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory();
			else if(typeof define === 'function' && define.amd)
				define([], factory);
			else if(typeof exports === 'object')
				exports["window-post-message-proxy"] = factory();
			else
				root["window-post-message-proxy"] = factory();
		})(this, function() {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		/******/
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		/******/
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		/******/
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		/******/
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ (function(module, exports) {
		
			"use strict";
			var WindowPostMessageProxy = (function () {
			    function WindowPostMessageProxy(options) {
			        var _this = this;
			        if (options === void 0) { options = {
			            processTrackingProperties: {
			                addTrackingProperties: WindowPostMessageProxy.defaultAddTrackingProperties,
			                getTrackingProperties: WindowPostMessageProxy.defaultGetTrackingProperties
			            },
			            isErrorMessage: WindowPostMessageProxy.defaultIsErrorMessage,
			            receiveWindow: window,
			            name: WindowPostMessageProxy.createRandomString()
			        }; }
			        this.pendingRequestPromises = {};
			        // save options with defaults
			        this.addTrackingProperties = (options.processTrackingProperties && options.processTrackingProperties.addTrackingProperties) || WindowPostMessageProxy.defaultAddTrackingProperties;
			        this.getTrackingProperties = (options.processTrackingProperties && options.processTrackingProperties.getTrackingProperties) || WindowPostMessageProxy.defaultGetTrackingProperties;
			        this.isErrorMessage = options.isErrorMessage || WindowPostMessageProxy.defaultIsErrorMessage;
			        this.receiveWindow = options.receiveWindow || window;
			        this.name = options.name || WindowPostMessageProxy.createRandomString();
			        this.logMessages = options.logMessages || false;
			        this.eventSourceOverrideWindow = options.eventSourceOverrideWindow;
			        this.suppressWarnings = options.suppressWarnings || false;
			        if (this.logMessages) {
			            console.log("new WindowPostMessageProxy created with name: " + this.name + " receiving on window: " + this.receiveWindow.document.title);
			        }
			        // Initialize
			        this.handlers = [];
			        this.windowMessageHandler = function (event) { return _this.onMessageReceived(event); };
			        this.start();
			    }
			    // Static
			    WindowPostMessageProxy.defaultAddTrackingProperties = function (message, trackingProperties) {
			        message[WindowPostMessageProxy.messagePropertyName] = trackingProperties;
			        return message;
			    };
			    WindowPostMessageProxy.defaultGetTrackingProperties = function (message) {
			        return message[WindowPostMessageProxy.messagePropertyName];
			    };
			    WindowPostMessageProxy.defaultIsErrorMessage = function (message) {
			        return !!message.error;
			    };
			    /**
			     * Utility to create a deferred object.
			     */
			    // TODO: Look to use RSVP library instead of doing this manually.
			    // From what I searched RSVP would work better because it has .finally and .deferred; however, it doesn't have Typings information. 
			    WindowPostMessageProxy.createDeferred = function () {
			        var deferred = {
			            resolve: null,
			            reject: null,
			            promise: null
			        };
			        var promise = new Promise(function (resolve, reject) {
			            deferred.resolve = resolve;
			            deferred.reject = reject;
			        });
			        deferred.promise = promise;
			        return deferred;
			    };
			    /**
			     * Utility to generate random sequence of characters used as tracking id for promises.
			     */
			    WindowPostMessageProxy.createRandomString = function () {
			        return (Math.random() + 1).toString(36).substring(7);
			    };
			    /**
			     * Adds handler.
			     * If the first handler whose test method returns true will handle the message and provide a response.
			     */
			    WindowPostMessageProxy.prototype.addHandler = function (handler) {
			        this.handlers.push(handler);
			    };
			    /**
			     * Removes handler.
			     * The reference must match the original object that was provided when adding the handler.
			     */
			    WindowPostMessageProxy.prototype.removeHandler = function (handler) {
			        var handlerIndex = this.handlers.indexOf(handler);
			        if (handlerIndex === -1) {
			            throw new Error("You attempted to remove a handler but no matching handler was found.");
			        }
			        this.handlers.splice(handlerIndex, 1);
			    };
			    /**
			     * Start listening to message events.
			     */
			    WindowPostMessageProxy.prototype.start = function () {
			        this.receiveWindow.addEventListener('message', this.windowMessageHandler);
			    };
			    /**
			     * Stops listening to message events.
			     */
			    WindowPostMessageProxy.prototype.stop = function () {
			        this.receiveWindow.removeEventListener('message', this.windowMessageHandler);
			    };
			    /**
			     * Post message to target window with tracking properties added and save deferred object referenced by tracking id.
			     */
			    WindowPostMessageProxy.prototype.postMessage = function (targetWindow, message) {
			        // Add tracking properties to indicate message came from this proxy
			        var trackingProperties = { id: WindowPostMessageProxy.createRandomString() };
			        this.addTrackingProperties(message, trackingProperties);
			        if (this.logMessages) {
			            console.log(this.name + " Posting message:");
			            console.log(JSON.stringify(message, null, '  '));
			        }
			        targetWindow.postMessage(message, "*");
			        var deferred = WindowPostMessageProxy.createDeferred();
			        this.pendingRequestPromises[trackingProperties.id] = deferred;
			        return deferred.promise;
			    };
			    /**
			     * Send response message to target window.
			     * Response messages re-use tracking properties from a previous request message.
			     */
			    WindowPostMessageProxy.prototype.sendResponse = function (targetWindow, message, trackingProperties) {
			        this.addTrackingProperties(message, trackingProperties);
			        if (this.logMessages) {
			            console.log(this.name + " Sending response:");
			            console.log(JSON.stringify(message, null, '  '));
			        }
			        targetWindow.postMessage(message, "*");
			    };
			    /**
			     * Message handler.
			     */
			    WindowPostMessageProxy.prototype.onMessageReceived = function (event) {
			        var _this = this;
			        if (this.logMessages) {
			            console.log(this.name + " Received message:");
			            console.log("type: " + event.type);
			            console.log(JSON.stringify(event.data, null, '  '));
			        }
			        var sendingWindow = this.eventSourceOverrideWindow || event.source;
			        var message = event.data;
			        if (typeof message !== "object") {
			            if (!this.suppressWarnings) {
			                console.warn("Proxy(" + this.name + "): Received message that was not an object. Discarding message");
			            }
			            return;
			        }
			        var trackingProperties;
			        try {
			            trackingProperties = this.getTrackingProperties(message);
			        }
			        catch (e) {
			            if (!this.suppressWarnings) {
			                console.warn("Proxy(" + this.name + "): Error occurred when attempting to get tracking properties from incoming message:", JSON.stringify(message, null, '  '), "Error: ", e);
			            }
			        }
			        var deferred;
			        if (trackingProperties) {
			            deferred = this.pendingRequestPromises[trackingProperties.id];
			        }
			        // If message does not have a known ID, treat it as a request
			        // Otherwise, treat message as response
			        if (!deferred) {
			            var handled = this.handlers.some(function (handler) {
			                var canMessageBeHandled = false;
			                try {
			                    canMessageBeHandled = handler.test(message);
			                }
			                catch (e) {
			                    if (!_this.suppressWarnings) {
			                        console.warn("Proxy(" + _this.name + "): Error occurred when handler was testing incoming message:", JSON.stringify(message, null, '  '), "Error: ", e);
			                    }
			                }
			                if (canMessageBeHandled) {
			                    var responseMessagePromise = void 0;
			                    try {
			                        responseMessagePromise = Promise.resolve(handler.handle(message));
			                    }
			                    catch (e) {
			                        if (!_this.suppressWarnings) {
			                            console.warn("Proxy(" + _this.name + "): Error occurred when handler was processing incoming message:", JSON.stringify(message, null, '  '), "Error: ", e);
			                        }
			                        responseMessagePromise = Promise.resolve();
			                    }
			                    responseMessagePromise
			                        .then(function (responseMessage) {
			                        if (!responseMessage) {
			                            var warningMessage = "Handler for message: " + JSON.stringify(message, null, '  ') + " did not return a response message. The default response message will be returned instead.";
			                            if (!_this.suppressWarnings) {
			                                console.warn("Proxy(" + _this.name + "): " + warningMessage);
			                            }
			                            responseMessage = {
			                                warning: warningMessage
			                            };
			                        }
			                        _this.sendResponse(sendingWindow, responseMessage, trackingProperties);
			                    });
			                    return true;
			                }
			            });
			            /**
			             * TODO: Consider returning an error message if nothing handled the message.
			             * In the case of the Report receiving messages all of them should be handled,
			             * however, in the case of the SDK receiving messages it's likely it won't register handlers
			             * for all events. Perhaps make this an option at construction time.
			             */
			            if (!handled && !this.suppressWarnings) {
			                console.warn("Proxy(" + this.name + ") did not handle message. Handlers: " + this.handlers.length + "  Message: " + JSON.stringify(message, null, '') + ".");
			            }
			        }
			        else {
			            /**
			             * If error message reject promise,
			             * Otherwise, resolve promise
			             */
			            var isErrorMessage = true;
			            try {
			                isErrorMessage = this.isErrorMessage(message);
			            }
			            catch (e) {
			                console.warn("Proxy(" + this.name + ") Error occurred when trying to determine if message is consider an error response. Message: ", JSON.stringify(message, null, ''), 'Error: ', e);
			            }
			            if (isErrorMessage) {
			                deferred.reject(message);
			            }
			            else {
			                deferred.resolve(message);
			            }
			            // TODO: Move to .finally clause up where promise is created for better maitenance like original proxy code.
			            delete this.pendingRequestPromises[trackingProperties.id];
			        }
			    };
			    WindowPostMessageProxy.messagePropertyName = "windowPostMessageProxy";
			    return WindowPostMessageProxy;
			}());
			exports.WindowPostMessageProxy = WindowPostMessageProxy;
		
		
		/***/ })
		/******/ ])
		});
		;
		//# sourceMappingURL=windowPostMessageProxy.js.map
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/*! http-post-message v0.2.3 | (c) 2016 Microsoft Corporation MIT */
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory();
			else if(typeof define === 'function' && define.amd)
				define([], factory);
			else if(typeof exports === 'object')
				exports["http-post-message"] = factory();
			else
				root["http-post-message"] = factory();
		})(this, function() {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		/******/
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		/******/
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		/******/
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		/******/
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ function(module, exports) {
		
			"use strict";
			var HttpPostMessage = (function () {
			    function HttpPostMessage(windowPostMessageProxy, defaultHeaders, defaultTargetWindow) {
			        if (defaultHeaders === void 0) { defaultHeaders = {}; }
			        this.defaultHeaders = defaultHeaders;
			        this.defaultTargetWindow = defaultTargetWindow;
			        this.windowPostMessageProxy = windowPostMessageProxy;
			    }
			    // TODO: See if it's possible to share tracking properties interface?
			    // The responsibility of knowing how to configure windowPostMessageProxy for http should
			    // live in this http class, but the configuration would need ITrackingProperties
			    // interface which lives in WindowPostMessageProxy. Use <any> type as workaround
			    HttpPostMessage.addTrackingProperties = function (message, trackingProperties) {
			        message.headers = message.headers || {};
			        if (trackingProperties && trackingProperties.id) {
			            message.headers.id = trackingProperties.id;
			        }
			        return message;
			    };
			    HttpPostMessage.getTrackingProperties = function (message) {
			        return {
			            id: message.headers && message.headers.id
			        };
			    };
			    HttpPostMessage.isErrorMessage = function (message) {
			        if (typeof (message && message.statusCode) !== 'number') {
			            return false;
			        }
			        return !(200 <= message.statusCode && message.statusCode < 300);
			    };
			    HttpPostMessage.prototype.get = function (url, headers, targetWindow) {
			        if (headers === void 0) { headers = {}; }
			        if (targetWindow === void 0) { targetWindow = this.defaultTargetWindow; }
			        return this.send({
			            method: "GET",
			            url: url,
			            headers: headers
			        }, targetWindow);
			    };
			    HttpPostMessage.prototype.post = function (url, body, headers, targetWindow) {
			        if (headers === void 0) { headers = {}; }
			        if (targetWindow === void 0) { targetWindow = this.defaultTargetWindow; }
			        return this.send({
			            method: "POST",
			            url: url,
			            headers: headers,
			            body: body
			        }, targetWindow);
			    };
			    HttpPostMessage.prototype.put = function (url, body, headers, targetWindow) {
			        if (headers === void 0) { headers = {}; }
			        if (targetWindow === void 0) { targetWindow = this.defaultTargetWindow; }
			        return this.send({
			            method: "PUT",
			            url: url,
			            headers: headers,
			            body: body
			        }, targetWindow);
			    };
			    HttpPostMessage.prototype.patch = function (url, body, headers, targetWindow) {
			        if (headers === void 0) { headers = {}; }
			        if (targetWindow === void 0) { targetWindow = this.defaultTargetWindow; }
			        return this.send({
			            method: "PATCH",
			            url: url,
			            headers: headers,
			            body: body
			        }, targetWindow);
			    };
			    HttpPostMessage.prototype.delete = function (url, body, headers, targetWindow) {
			        if (body === void 0) { body = null; }
			        if (headers === void 0) { headers = {}; }
			        if (targetWindow === void 0) { targetWindow = this.defaultTargetWindow; }
			        return this.send({
			            method: "DELETE",
			            url: url,
			            headers: headers,
			            body: body
			        }, targetWindow);
			    };
			    HttpPostMessage.prototype.send = function (request, targetWindow) {
			        if (targetWindow === void 0) { targetWindow = this.defaultTargetWindow; }
			        request.headers = this.assign({}, this.defaultHeaders, request.headers);
			        if (!targetWindow) {
			            throw new Error("target window is not provided.  You must either provide the target window explicitly as argument to request, or specify default target window when constructing instance of this class.");
			        }
			        return this.windowPostMessageProxy.postMessage(targetWindow, request);
			    };
			    /**
			     * Object.assign() polyfill
			     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
			     */
			    HttpPostMessage.prototype.assign = function (target) {
			        var sources = [];
			        for (var _i = 1; _i < arguments.length; _i++) {
			            sources[_i - 1] = arguments[_i];
			        }
			        if (target === undefined || target === null) {
			            throw new TypeError('Cannot convert undefined or null to object');
			        }
			        var output = Object(target);
			        sources.forEach(function (source) {
			            if (source !== undefined && source !== null) {
			                for (var nextKey in source) {
			                    if (Object.prototype.hasOwnProperty.call(source, nextKey)) {
			                        output[nextKey] = source[nextKey];
			                    }
			                }
			            }
			        });
			        return output;
			    };
			    return HttpPostMessage;
			}());
			exports.HttpPostMessage = HttpPostMessage;
		
		
		/***/ }
		/******/ ])
		});
		;
		//# sourceMappingURL=httpPostMessage.js.map
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/*! powerbi-router v0.1.5 | (c) 2016 Microsoft Corporation MIT */
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory();
			else if(typeof define === 'function' && define.amd)
				define([], factory);
			else if(typeof exports === 'object')
				exports["powerbi-router"] = factory();
			else
				root["powerbi-router"] = factory();
		})(this, function() {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		/******/
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		/******/
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		/******/
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		/******/
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ function(module, exports, __webpack_require__) {
		
			"use strict";
			var RouteRecognizer = __webpack_require__(1);
			var Router = (function () {
			    function Router(handlers) {
			        this.handlers = handlers;
			        /**
			         * TODO: look at generating the router dynamically based on list of supported http methods
			         * instead of hardcoding the creation of these and the methods.
			         */
			        this.getRouteRecognizer = new RouteRecognizer();
			        this.patchRouteRecognizer = new RouteRecognizer();
			        this.postRouteRecognizer = new RouteRecognizer();
			        this.putRouteRecognizer = new RouteRecognizer();
			        this.deleteRouteRecognizer = new RouteRecognizer();
			    }
			    Router.prototype.get = function (url, handler) {
			        this.registerHandler(this.getRouteRecognizer, "GET", url, handler);
			        return this;
			    };
			    Router.prototype.patch = function (url, handler) {
			        this.registerHandler(this.patchRouteRecognizer, "PATCH", url, handler);
			        return this;
			    };
			    Router.prototype.post = function (url, handler) {
			        this.registerHandler(this.postRouteRecognizer, "POST", url, handler);
			        return this;
			    };
			    Router.prototype.put = function (url, handler) {
			        this.registerHandler(this.putRouteRecognizer, "PUT", url, handler);
			        return this;
			    };
			    Router.prototype.delete = function (url, handler) {
			        this.registerHandler(this.deleteRouteRecognizer, "DELETE", url, handler);
			        return this;
			    };
			    /**
			     * TODO: This method could use some refactoring.  There is conflict of interest between keeping clean separation of test and handle method
			     * Test method only returns boolean indicating if request can be handled, and handle method has opportunity to modify response and return promise of it.
			     * In the case of the router with route-recognizer where handlers are associated with routes, this already guarantees that only one handler is selected and makes the test method feel complicated
			     * Will leave as is an investigate cleaner ways at later time.
			     */
			    Router.prototype.registerHandler = function (routeRecognizer, method, url, handler) {
			        var routeRecognizerHandler = function (request) {
			            var response = new Response();
			            return Promise.resolve(handler(request, response))
			                .then(function (x) { return response; });
			        };
			        routeRecognizer.add([
			            { path: url, handler: routeRecognizerHandler }
			        ]);
			        var internalHandler = {
			            test: function (request) {
			                if (request.method !== method) {
			                    return false;
			                }
			                var matchingRoutes = routeRecognizer.recognize(request.url);
			                if (matchingRoutes === undefined) {
			                    return false;
			                }
			                /**
			                 * Copy parameters from recognized route to the request so they can be used within the handler function
			                 * This isn't ideal because it is side affect which modifies the request instead of strictly testing for true or false
			                 * but I don't see a better place to put this.  If we move it between the call to test and the handle it becomes part of the window post message proxy
			                 * even though it's responsibility is related to routing.
			                 */
			                var route = matchingRoutes[0];
			                request.params = route.params;
			                request.queryParams = matchingRoutes.queryParams;
			                request.handler = route.handler;
			                return true;
			            },
			            handle: function (request) {
			                return request.handler(request);
			            }
			        };
			        this.handlers.addHandler(internalHandler);
			    };
			    return Router;
			}());
			exports.Router = Router;
			var Response = (function () {
			    function Response() {
			        this.statusCode = 200;
			        this.headers = {};
			        this.body = null;
			    }
			    Response.prototype.send = function (statusCode, body) {
			        this.statusCode = statusCode;
			        this.body = body;
			    };
			    return Response;
			}());
			exports.Response = Response;
		
		
		/***/ },
		/* 1 */
		/***/ function(module, exports, __webpack_require__) {
		
			var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
			    "use strict";
			    function $$route$recognizer$dsl$$Target(path, matcher, delegate) {
			      this.path = path;
			      this.matcher = matcher;
			      this.delegate = delegate;
			    }
			
			    $$route$recognizer$dsl$$Target.prototype = {
			      to: function(target, callback) {
			        var delegate = this.delegate;
			
			        if (delegate && delegate.willAddRoute) {
			          target = delegate.willAddRoute(this.matcher.target, target);
			        }
			
			        this.matcher.add(this.path, target);
			
			        if (callback) {
			          if (callback.length === 0) { throw new Error("You must have an argument in the function passed to `to`"); }
			          this.matcher.addChild(this.path, target, callback, this.delegate);
			        }
			        return this;
			      }
			    };
			
			    function $$route$recognizer$dsl$$Matcher(target) {
			      this.routes = {};
			      this.children = {};
			      this.target = target;
			    }
			
			    $$route$recognizer$dsl$$Matcher.prototype = {
			      add: function(path, handler) {
			        this.routes[path] = handler;
			      },
			
			      addChild: function(path, target, callback, delegate) {
			        var matcher = new $$route$recognizer$dsl$$Matcher(target);
			        this.children[path] = matcher;
			
			        var match = $$route$recognizer$dsl$$generateMatch(path, matcher, delegate);
			
			        if (delegate && delegate.contextEntered) {
			          delegate.contextEntered(target, match);
			        }
			
			        callback(match);
			      }
			    };
			
			    function $$route$recognizer$dsl$$generateMatch(startingPath, matcher, delegate) {
			      return function(path, nestedCallback) {
			        var fullPath = startingPath + path;
			
			        if (nestedCallback) {
			          nestedCallback($$route$recognizer$dsl$$generateMatch(fullPath, matcher, delegate));
			        } else {
			          return new $$route$recognizer$dsl$$Target(startingPath + path, matcher, delegate);
			        }
			      };
			    }
			
			    function $$route$recognizer$dsl$$addRoute(routeArray, path, handler) {
			      var len = 0;
			      for (var i=0; i<routeArray.length; i++) {
			        len += routeArray[i].path.length;
			      }
			
			      path = path.substr(len);
			      var route = { path: path, handler: handler };
			      routeArray.push(route);
			    }
			
			    function $$route$recognizer$dsl$$eachRoute(baseRoute, matcher, callback, binding) {
			      var routes = matcher.routes;
			
			      for (var path in routes) {
			        if (routes.hasOwnProperty(path)) {
			          var routeArray = baseRoute.slice();
			          $$route$recognizer$dsl$$addRoute(routeArray, path, routes[path]);
			
			          if (matcher.children[path]) {
			            $$route$recognizer$dsl$$eachRoute(routeArray, matcher.children[path], callback, binding);
			          } else {
			            callback.call(binding, routeArray);
			          }
			        }
			      }
			    }
			
			    var $$route$recognizer$dsl$$default = function(callback, addRouteCallback) {
			      var matcher = new $$route$recognizer$dsl$$Matcher();
			
			      callback($$route$recognizer$dsl$$generateMatch("", matcher, this.delegate));
			
			      $$route$recognizer$dsl$$eachRoute([], matcher, function(route) {
			        if (addRouteCallback) { addRouteCallback(this, route); }
			        else { this.add(route); }
			      }, this);
			    };
			
			    var $$route$recognizer$$specials = [
			      '/', '.', '*', '+', '?', '|',
			      '(', ')', '[', ']', '{', '}', '\\'
			    ];
			
			    var $$route$recognizer$$escapeRegex = new RegExp('(\\' + $$route$recognizer$$specials.join('|\\') + ')', 'g');
			
			    function $$route$recognizer$$isArray(test) {
			      return Object.prototype.toString.call(test) === "[object Array]";
			    }
			
			    // A Segment represents a segment in the original route description.
			    // Each Segment type provides an `eachChar` and `regex` method.
			    //
			    // The `eachChar` method invokes the callback with one or more character
			    // specifications. A character specification consumes one or more input
			    // characters.
			    //
			    // The `regex` method returns a regex fragment for the segment. If the
			    // segment is a dynamic of star segment, the regex fragment also includes
			    // a capture.
			    //
			    // A character specification contains:
			    //
			    // * `validChars`: a String with a list of all valid characters, or
			    // * `invalidChars`: a String with a list of all invalid characters
			    // * `repeat`: true if the character specification can repeat
			
			    function $$route$recognizer$$StaticSegment(string) { this.string = string; }
			    $$route$recognizer$$StaticSegment.prototype = {
			      eachChar: function(currentState) {
			        var string = this.string, ch;
			
			        for (var i=0; i<string.length; i++) {
			          ch = string.charAt(i);
			          currentState = currentState.put({ invalidChars: undefined, repeat: false, validChars: ch });
			        }
			
			        return currentState;
			      },
			
			      regex: function() {
			        return this.string.replace($$route$recognizer$$escapeRegex, '\\$1');
			      },
			
			      generate: function() {
			        return this.string;
			      }
			    };
			
			    function $$route$recognizer$$DynamicSegment(name) { this.name = name; }
			    $$route$recognizer$$DynamicSegment.prototype = {
			      eachChar: function(currentState) {
			        return currentState.put({ invalidChars: "/", repeat: true, validChars: undefined });
			      },
			
			      regex: function() {
			        return "([^/]+)";
			      },
			
			      generate: function(params) {
			        return params[this.name];
			      }
			    };
			
			    function $$route$recognizer$$StarSegment(name) { this.name = name; }
			    $$route$recognizer$$StarSegment.prototype = {
			      eachChar: function(currentState) {
			        return currentState.put({ invalidChars: "", repeat: true, validChars: undefined });
			      },
			
			      regex: function() {
			        return "(.+)";
			      },
			
			      generate: function(params) {
			        return params[this.name];
			      }
			    };
			
			    function $$route$recognizer$$EpsilonSegment() {}
			    $$route$recognizer$$EpsilonSegment.prototype = {
			      eachChar: function(currentState) {
			        return currentState;
			      },
			      regex: function() { return ""; },
			      generate: function() { return ""; }
			    };
			
			    function $$route$recognizer$$parse(route, names, specificity) {
			      // normalize route as not starting with a "/". Recognition will
			      // also normalize.
			      if (route.charAt(0) === "/") { route = route.substr(1); }
			
			      var segments = route.split("/");
			      var results = new Array(segments.length);
			
			      // A routes has specificity determined by the order that its different segments
			      // appear in. This system mirrors how the magnitude of numbers written as strings
			      // works.
			      // Consider a number written as: "abc". An example would be "200". Any other number written
			      // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
			      // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
			      // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
			      // leading symbol, "1".
			      // The rule is that symbols to the left carry more weight than symbols to the right
			      // when a number is written out as a string. In the above strings, the leading digit
			      // represents how many 100's are in the number, and it carries more weight than the middle
			      // number which represents how many 10's are in the number.
			      // This system of number magnitude works well for route specificity, too. A route written as
			      // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
			      // `x`, irrespective of the other parts.
			      // Because of this similarity, we assign each type of segment a number value written as a
			      // string. We can find the specificity of compound routes by concatenating these strings
			      // together, from left to right. After we have looped through all of the segments,
			      // we convert the string to a number.
			      specificity.val = '';
			
			      for (var i=0; i<segments.length; i++) {
			        var segment = segments[i], match;
			
			        if (match = segment.match(/^:([^\/]+)$/)) {
			          results[i] = new $$route$recognizer$$DynamicSegment(match[1]);
			          names.push(match[1]);
			          specificity.val += '3';
			        } else if (match = segment.match(/^\*([^\/]+)$/)) {
			          results[i] = new $$route$recognizer$$StarSegment(match[1]);
			          specificity.val += '1';
			          names.push(match[1]);
			        } else if(segment === "") {
			          results[i] = new $$route$recognizer$$EpsilonSegment();
			          specificity.val += '2';
			        } else {
			          results[i] = new $$route$recognizer$$StaticSegment(segment);
			          specificity.val += '4';
			        }
			      }
			
			      specificity.val = +specificity.val;
			
			      return results;
			    }
			
			    // A State has a character specification and (`charSpec`) and a list of possible
			    // subsequent states (`nextStates`).
			    //
			    // If a State is an accepting state, it will also have several additional
			    // properties:
			    //
			    // * `regex`: A regular expression that is used to extract parameters from paths
			    //   that reached this accepting state.
			    // * `handlers`: Information on how to convert the list of captures into calls
			    //   to registered handlers with the specified parameters
			    // * `types`: How many static, dynamic or star segments in this route. Used to
			    //   decide which route to use if multiple registered routes match a path.
			    //
			    // Currently, State is implemented naively by looping over `nextStates` and
			    // comparing a character specification against a character. A more efficient
			    // implementation would use a hash of keys pointing at one or more next states.
			
			    function $$route$recognizer$$State(charSpec) {
			      this.charSpec = charSpec;
			      this.nextStates = [];
			      this.charSpecs = {};
			      this.regex = undefined;
			      this.handlers = undefined;
			      this.specificity = undefined;
			    }
			
			    $$route$recognizer$$State.prototype = {
			      get: function(charSpec) {
			        if (this.charSpecs[charSpec.validChars]) {
			          return this.charSpecs[charSpec.validChars];
			        }
			
			        var nextStates = this.nextStates;
			
			        for (var i=0; i<nextStates.length; i++) {
			          var child = nextStates[i];
			
			          var isEqual = child.charSpec.validChars === charSpec.validChars;
			          isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;
			
			          if (isEqual) {
			            this.charSpecs[charSpec.validChars] = child;
			            return child;
			          }
			        }
			      },
			
			      put: function(charSpec) {
			        var state;
			
			        // If the character specification already exists in a child of the current
			        // state, just return that state.
			        if (state = this.get(charSpec)) { return state; }
			
			        // Make a new state for the character spec
			        state = new $$route$recognizer$$State(charSpec);
			
			        // Insert the new state as a child of the current state
			        this.nextStates.push(state);
			
			        // If this character specification repeats, insert the new state as a child
			        // of itself. Note that this will not trigger an infinite loop because each
			        // transition during recognition consumes a character.
			        if (charSpec.repeat) {
			          state.nextStates.push(state);
			        }
			
			        // Return the new state
			        return state;
			      },
			
			      // Find a list of child states matching the next character
			      match: function(ch) {
			        var nextStates = this.nextStates,
			            child, charSpec, chars;
			
			        var returned = [];
			
			        for (var i=0; i<nextStates.length; i++) {
			          child = nextStates[i];
			
			          charSpec = child.charSpec;
			
			          if (typeof (chars = charSpec.validChars) !== 'undefined') {
			            if (chars.indexOf(ch) !== -1) { returned.push(child); }
			          } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
			            if (chars.indexOf(ch) === -1) { returned.push(child); }
			          }
			        }
			
			        return returned;
			      }
			    };
			
			    // Sort the routes by specificity
			    function $$route$recognizer$$sortSolutions(states) {
			      return states.sort(function(a, b) {
			        return b.specificity.val - a.specificity.val;
			      });
			    }
			
			    function $$route$recognizer$$recognizeChar(states, ch) {
			      var nextStates = [];
			
			      for (var i=0, l=states.length; i<l; i++) {
			        var state = states[i];
			
			        nextStates = nextStates.concat(state.match(ch));
			      }
			
			      return nextStates;
			    }
			
			    var $$route$recognizer$$oCreate = Object.create || function(proto) {
			      function F() {}
			      F.prototype = proto;
			      return new F();
			    };
			
			    function $$route$recognizer$$RecognizeResults(queryParams) {
			      this.queryParams = queryParams || {};
			    }
			    $$route$recognizer$$RecognizeResults.prototype = $$route$recognizer$$oCreate({
			      splice: Array.prototype.splice,
			      slice:  Array.prototype.slice,
			      push:   Array.prototype.push,
			      length: 0,
			      queryParams: null
			    });
			
			    function $$route$recognizer$$findHandler(state, path, queryParams) {
			      var handlers = state.handlers, regex = state.regex;
			      var captures = path.match(regex), currentCapture = 1;
			      var result = new $$route$recognizer$$RecognizeResults(queryParams);
			
			      result.length = handlers.length;
			
			      for (var i=0; i<handlers.length; i++) {
			        var handler = handlers[i], names = handler.names, params = {};
			
			        for (var j=0; j<names.length; j++) {
			          params[names[j]] = captures[currentCapture++];
			        }
			
			        result[i] = { handler: handler.handler, params: params, isDynamic: !!names.length };
			      }
			
			      return result;
			    }
			
			    function $$route$recognizer$$decodeQueryParamPart(part) {
			      // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
			      part = part.replace(/\+/gm, '%20');
			      var result;
			      try {
			        result = decodeURIComponent(part);
			      } catch(error) {result = '';}
			      return result;
			    }
			
			    // The main interface
			
			    var $$route$recognizer$$RouteRecognizer = function() {
			      this.rootState = new $$route$recognizer$$State();
			      this.names = {};
			    };
			
			
			    $$route$recognizer$$RouteRecognizer.prototype = {
			      add: function(routes, options) {
			        var currentState = this.rootState, regex = "^",
			            specificity = {},
			            handlers = new Array(routes.length), allSegments = [], name;
			
			        var isEmpty = true;
			
			        for (var i=0; i<routes.length; i++) {
			          var route = routes[i], names = [];
			
			          var segments = $$route$recognizer$$parse(route.path, names, specificity);
			
			          allSegments = allSegments.concat(segments);
			
			          for (var j=0; j<segments.length; j++) {
			            var segment = segments[j];
			
			            if (segment instanceof $$route$recognizer$$EpsilonSegment) { continue; }
			
			            isEmpty = false;
			
			            // Add a "/" for the new segment
			            currentState = currentState.put({ invalidChars: undefined, repeat: false, validChars: "/" });
			            regex += "/";
			
			            // Add a representation of the segment to the NFA and regex
			            currentState = segment.eachChar(currentState);
			            regex += segment.regex();
			          }
			          var handler = { handler: route.handler, names: names };
			          handlers[i] = handler;
			        }
			
			        if (isEmpty) {
			          currentState = currentState.put({ invalidChars: undefined, repeat: false, validChars: "/" });
			          regex += "/";
			        }
			
			        currentState.handlers = handlers;
			        currentState.regex = new RegExp(regex + "$");
			        currentState.specificity = specificity;
			
			        if (name = options && options.as) {
			          this.names[name] = {
			            segments: allSegments,
			            handlers: handlers
			          };
			        }
			      },
			
			      handlersFor: function(name) {
			        var route = this.names[name];
			
			        if (!route) { throw new Error("There is no route named " + name); }
			
			        var result = new Array(route.handlers.length);
			
			        for (var i=0; i<route.handlers.length; i++) {
			          result[i] = route.handlers[i];
			        }
			
			        return result;
			      },
			
			      hasRoute: function(name) {
			        return !!this.names[name];
			      },
			
			      generate: function(name, params) {
			        var route = this.names[name], output = "";
			        if (!route) { throw new Error("There is no route named " + name); }
			
			        var segments = route.segments;
			
			        for (var i=0; i<segments.length; i++) {
			          var segment = segments[i];
			
			          if (segment instanceof $$route$recognizer$$EpsilonSegment) { continue; }
			
			          output += "/";
			          output += segment.generate(params);
			        }
			
			        if (output.charAt(0) !== '/') { output = '/' + output; }
			
			        if (params && params.queryParams) {
			          output += this.generateQueryString(params.queryParams, route.handlers);
			        }
			
			        return output;
			      },
			
			      generateQueryString: function(params, handlers) {
			        var pairs = [];
			        var keys = [];
			        for(var key in params) {
			          if (params.hasOwnProperty(key)) {
			            keys.push(key);
			          }
			        }
			        keys.sort();
			        for (var i = 0; i < keys.length; i++) {
			          key = keys[i];
			          var value = params[key];
			          if (value == null) {
			            continue;
			          }
			          var pair = encodeURIComponent(key);
			          if ($$route$recognizer$$isArray(value)) {
			            for (var j = 0; j < value.length; j++) {
			              var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
			              pairs.push(arrayPair);
			            }
			          } else {
			            pair += "=" + encodeURIComponent(value);
			            pairs.push(pair);
			          }
			        }
			
			        if (pairs.length === 0) { return ''; }
			
			        return "?" + pairs.join("&");
			      },
			
			      parseQueryString: function(queryString) {
			        var pairs = queryString.split("&"), queryParams = {};
			        for(var i=0; i < pairs.length; i++) {
			          var pair      = pairs[i].split('='),
			              key       = $$route$recognizer$$decodeQueryParamPart(pair[0]),
			              keyLength = key.length,
			              isArray = false,
			              value;
			          if (pair.length === 1) {
			            value = 'true';
			          } else {
			            //Handle arrays
			            if (keyLength > 2 && key.slice(keyLength -2) === '[]') {
			              isArray = true;
			              key = key.slice(0, keyLength - 2);
			              if(!queryParams[key]) {
			                queryParams[key] = [];
			              }
			            }
			            value = pair[1] ? $$route$recognizer$$decodeQueryParamPart(pair[1]) : '';
			          }
			          if (isArray) {
			            queryParams[key].push(value);
			          } else {
			            queryParams[key] = value;
			          }
			        }
			        return queryParams;
			      },
			
			      recognize: function(path) {
			        var states = [ this.rootState ],
			            pathLen, i, l, queryStart, queryParams = {},
			            isSlashDropped = false;
			
			        queryStart = path.indexOf('?');
			        if (queryStart !== -1) {
			          var queryString = path.substr(queryStart + 1, path.length);
			          path = path.substr(0, queryStart);
			          queryParams = this.parseQueryString(queryString);
			        }
			
			        path = decodeURI(path);
			
			        if (path.charAt(0) !== "/") { path = "/" + path; }
			
			        pathLen = path.length;
			        if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
			          path = path.substr(0, pathLen - 1);
			          isSlashDropped = true;
			        }
			
			        for (i=0; i<path.length; i++) {
			          states = $$route$recognizer$$recognizeChar(states, path.charAt(i));
			          if (!states.length) { break; }
			        }
			
			        var solutions = [];
			        for (i=0; i<states.length; i++) {
			          if (states[i].handlers) { solutions.push(states[i]); }
			        }
			
			        states = $$route$recognizer$$sortSolutions(solutions);
			
			        var state = solutions[0];
			
			        if (state && state.handlers) {
			          // if a trailing slash was dropped and a star segment is the last segment
			          // specified, put the trailing slash back
			          if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") {
			            path = path + "/";
			          }
			          return $$route$recognizer$$findHandler(state, path, queryParams);
			        }
			      }
			    };
			
			    $$route$recognizer$$RouteRecognizer.prototype.map = $$route$recognizer$dsl$$default;
			
			    $$route$recognizer$$RouteRecognizer.VERSION = '0.1.11';
			
			    var $$route$recognizer$$default = $$route$recognizer$$RouteRecognizer;
			
			    /* global define:true module:true window: true */
			    if ("function" === 'function' && __webpack_require__(3)['amd']) {
			      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return $$route$recognizer$$default; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			    } else if (typeof module !== 'undefined' && module['exports']) {
			      module['exports'] = $$route$recognizer$$default;
			    } else if (typeof this !== 'undefined') {
			      this['RouteRecognizer'] = $$route$recognizer$$default;
			    }
			}).call(this);
			
			//# sourceMappingURL=route-recognizer.js.map
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))
		
		/***/ },
		/* 2 */
		/***/ function(module, exports) {
		
			module.exports = function(module) {
				if(!module.webpackPolyfill) {
					module.deprecate = function() {};
					module.paths = [];
					// module.parent = undefined by default
					module.children = [];
					module.webpackPolyfill = 1;
				}
				return module;
			}
		
		
		/***/ },
		/* 3 */
		/***/ function(module, exports) {
		
			module.exports = function() { throw new Error("define cannot be used indirect"); };
		
		
		/***/ }
		/******/ ])
		});
		;
		//# sourceMappingURL=router.js.map
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=powerbi.js.map

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP ClassPanel
	* @autor vignesh kumar somayaji
	* @description
	* # name Services --> powerBiSrv
	* file for call at services for assistance page
	*/
	//  powerBiSrv.refreshDataset('f774845d-03f5-4650-b147-35ab22f19b6f','119eaef5-38e8-4cac-85ab-fba07439fb7d');
	var powerBiSrv = function powerBiSrv($http, $resource, SERVICE_URL_CONSTANT, $q, $cookies, $localStorage, $timeout, LOCAL_ENV_CONSTANT) {
	  _classCallCheck(this, powerBiSrv);
	
	  var currentClass = null;
	
	  var refreshDataset = function refreshDataset(groupId, dataset) {
	    var defered = $q.defer();
	    var promise = defered.promise;
	    var token = null;
	
	    $http({
	      crossDomain: true,
	      xhrFields: { withCredentials: false },
	      headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
	      method: 'POST',
	      url: LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.API_URL
	    }).then(function (response) {
	
	      var data = response.data.data;
	      var tokenAttributes = JSON.parse(data);
	      var token = tokenAttributes.access_token;
	
	      $localStorage.embeded = tokenAttributes;
	      var token = $localStorage.embeded.access_token;
	
	      var dataset = LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_DATASET;
	
	      var j = 0;
	
	      var _loop = function _loop() {
	        j++;
	        var get = {
	          groupId: LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_GROUP_ID,
	          dataset: dataset[i]
	        };
	
	        $timeout(function () {
	
	          $http.post('https://api.powerbi.com/v1.0/myorg/groups/' + get.groupId + '/datasets/' + get.dataset + '/refreshes', {
	            headers: { 'Authorization': 'Bearer  ' + token,
	              'Content-Type': 'application/json; charset=utf-8' }
	          }).then(function (response) {
	
	            // console.log('response true',response)
	            defered.resolve(response);
	          }, function (error) {
	            // $scope.reportError = error;
	          });
	        }, j * 1000);
	      };
	
	      for (var i in dataset) {
	        _loop();
	      }
	    }, function (response) {
	      defered.reject("Error:   " + JSON.stringify(response));
	    });
	
	    return promise;
	  };
	
	  return {
	
	    refreshDataset: refreshDataset
	
	  };
	};
	
	powerBiSrv.$inject = ['$http', '$resource', 'SERVICE_URL_CONSTANT', '$q', '$cookies', '$localStorage', '$timeout', 'LOCAL_ENV_CONSTANT'];
	
	exports.default = angular.module('services.powerBiSrv', []).service('powerBiSrv', powerBiSrv).name;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-suite
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: loginController
	* # alias: $ctrl
	*/
	
	var loginController = function () {
		function loginController($scope, $state, ngNotify, LOCAL_ENV_CONSTANT, $localStorage, $http, $timeout, Helpers, GlobalSrv, $filter) {
			var _this = this;
	
			_classCallCheck(this, loginController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.ngNotify = ngNotify;
			this.$timeout = $timeout;
			this.$localStorage = $localStorage;
			this.$http = $http;
			this.Helpers = Helpers;
			this.appConfig = LOCAL_ENV_CONSTANT;
			this.$scope.auth2 = {};
			this.$translate = $filter('translate');
			this.userApi = GlobalSrv.userLogin;
			this.main();
	
			if (this.$localStorage.userAuth) {
				this.goHomePage();
			}
	
			$timeout(function () {
				if (_this.appConfig.GOOGLE_ACCOUNT_KEY) {
					gapi.load('auth2', $scope.initGoogleSign);
				}
			}, 700);
	
			$scope.initGoogleSign = function () {
				gapi.auth2.init({ client_id: _this.appConfig.GOOGLE_ACCOUNT_KEY });
				_this.$scope.auth2 = gapi.auth2.getAuthInstance();
				_this.$scope.auth2.isSignedIn.listen($scope.googleSigninChanged);
	
				if (_this.$scope.auth2.isSignedIn.get() == true) {
					_this.$scope.auth2.signIn();
				}
			};
	
			$scope.googleSigninChanged = function (isSignedIn) {
				if (isSignedIn) {
					var GUser = _this.$scope.auth2.currentUser.get();
					var AuthResponse = GUser.getAuthResponse();
					var Profile = GUser.getBasicProfile();
					var userLoged = {
						socialId: Profile.getId(),
						fullName: Profile.getName(),
						firstName: Profile.getGivenName(),
						lastName: Profile.getFamilyName(),
						photo: Profile.getImageUrl(),
						email: Profile.getEmail(),
						tokenId: AuthResponse.id_token,
						sessionTime: AuthResponse.expires_at
					};
	
					_this.$scope.$digest();
	
					if (!_this.$localStorage.userAuth) {
						_this.validateUser(userLoged);
					}
				} else {
					_this.$scope.$digest();
				}
			};
		}
	
		_createClass(loginController, [{
			key: 'main',
			value: function main() {
				var clientName = this.appConfig.clientName;
	
				try {
					this.$scope.clientLogo = __webpack_require__(1180)("./logo-" + clientName + '.svg');
				} catch (error) {
					this.$scope.clientLogo = __webpack_require__(1182);
				}
			}
		}, {
			key: 'validateUser',
			value: function validateUser(user) {
				var _this2 = this;
	
				var params = angular.extend({}, user, {
					username: user.email,
					status: 1,
					institution: '1'
				});
	
				this.$scope.isLoading = true;
				this.userApi.validUserSocialIntegration(params).$promise.then(function (response) {
					if (!response.status) {
						var msn = response.messageError || response.message || _this2.$translate('MSJ_ERROR');
	
						_this2.ngNotify.set(msn, 'warn');
					} else {
						if (response.data.exist || response.inserted) {
							var _params = {
								name: user.email,
								password: '*******',
								type: 'WEB'
							};
	
							_this2.getRequest('', _params).success(function (response) {
								_this2.$scope.isLoading = false;
								_this2.saveUser(response);
							});
						}
					}
				}, function (err) {
					_this2.$scope.isLoading = false;
					_this2.ngNotify.set(_this2.$translate('ERROR_CLONING_PROCESS') + ' validUserSocialIntegration', 'error');
				});
			}
		}, {
			key: 'goHomePage',
			value: function goHomePage() {
				var path = this.appConfig.HOMEPAGE.substr(4);
	
				for (var i in this.$state.get()) {
					if (this.$state.get()[i].url == path) {
						this.$state.go(this.$state.get()[i].name, {}, { reload: this.$state.get()[i].name });
	
						return;
					}
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(isValid) {
				var _this3 = this;
	
				if (isValid) {
					var params = {
						name: this.$scope.loginForm.name.$$rawModelValue,
						password: this.$scope.loginForm.password.$$rawModelValue,
						type: 'WEB'
					};
	
					this.getRequest('', params).success(function (response) {
						_this3.saveUser(response);
					});
				} else {
					this.ngNotify.set(this.$translate('MSJ_INCORRECT_USER_PASS'), 'error');
					delete this.$localStorage.userLogin;
					delete this.$localStorage.userAuth;
				}
			}
		}, {
			key: 'saveUser',
			value: function saveUser(response) {
				var data = this.Helpers.getUserStored(response);
	
				if (data.status) {
					this.$localStorage.userAuth = response;
					this.$localStorage.userLogin = data;
					this.$localStorage.logintime = Date.now();
					window.location = this.appConfig.HOMEPAGE;
				} else {
					this.ngNotify.set(this.$translate('MSJ_INCORRECT_USER_PASS'), 'error');
					delete this.$localStorage.userLogin;
					delete this.$localStorage.userAuth;
				}
			}
		}, {
			key: 'getRequest',
			value: function getRequest(url, params) {
				return this.$http({
					method: 'POST',
					url: this.appConfig.USER_API_URL + '/api/user-api' + url,
					data: $.param(params),
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
			}
		}]);
	
		return loginController;
	}();
	
	exports.default = loginController;
	
	
	loginController.$inject = ['$scope', '$state', 'ngNotify', 'LOCAL_ENV_CONSTANT', '$localStorage', '$http', '$timeout', 'Helpers', 'GlobalSrv', '$filter'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./logo-ucentralcolombia.svg": 1181,
		"./logo-uplanner.svg": 1182
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1180;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "351469620f304102101e7533297aea53.svg";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4b3b434970538521e7f1403051d2c18.svg";

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @name APP u-suite
	* @autor over.martinez@u-planner.com
	* @description
	* Descripcion del controlador
	* @controller 
	* # name: loginErrorMessage
	* # alias: $ctrl
	*/
	
	var loginErrorMessage = function () {
		function loginErrorMessage($rootScope, $scope, $state, $stateParams, ngNotify, uFunctions, LOCAL_ENV_CONSTANT, $cookies, $localStorage, $timeout) {
			_classCallCheck(this, loginErrorMessage);
	
			this.$rootScope = $rootScope;
			this.$cookies = $cookies;
			this.$state = $state;
			this.$localStorage = $localStorage;
			this.$timeout = $timeout;
			this.$scope = $scope;
			this.config = LOCAL_ENV_CONSTANT;
			this.$stateParams = $stateParams;
			this.ngNotify = ngNotify;
			this.Helpers = uFunctions;
			this.main();
		}
	
		_createClass(loginErrorMessage, [{
			key: 'main',
			value: function main() {
				this.message = this.Helpers.getUserStored(this.$stateParams.message);
			}
		}, {
			key: 'goToLoggin',
			value: function goToLoggin() {
				var auth = this.Helpers.getUserStored();
				var id = auth ? auth.user.id : 0;
				var url = this.config.USER_API_URL + '/api/user-api';
				var auth2 = void 0;
	
				try {
					// eslint-disable-next-line no-undef
					gapi.auth2.init();
					// eslint-disable-next-line no-undef
					auth2 = gapi.auth2.getAuthInstance();
				} catch (error) {
					// eslint-disable-next-line no-console
					console.log('error->', error);
				}
				delete this.$localStorage.userLogin;
				delete this.$localStorage.userAuth;
				this.$cookies.put('hasDemand', '');
				this.$cookies.remove('isAdmin');
				this.$cookies.remove('hasType');
	
				if (this.config.loginType == 'web') {
					if (auth2 && auth2.isSignedIn.get()) {
						auth2.disconnect().then(function () {
							window.location.href = '/login';
						});
					} else {
						window.location.href = '/login';
					}
				} else {
					var iframe = document.createElement('iframe');
	
					iframe.style.display = 'none';
					iframe.src = url + '/logout?id=' + id;
					document.body.appendChild(iframe);
	
					this.$timeout(function () {
						window.location = 'app/home';
					}, 3000);
				}
			}
		}]);
	
		return loginErrorMessage;
	}();
	
	exports.default = loginErrorMessage;
	
	
	loginErrorMessage.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'ngNotify', 'uFunctions', 'LOCAL_ENV_CONSTANT', '$cookies', '$localStorage', '$timeout'];

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-inner-declarations */
	/**
	* @name planning
	* @autor over.martinez@u-planner.com
	* @description : Pool of commons functions to help development
	* # planning
	* @name factory: Helpers
	*/
	
	var Helpers = function Helpers(SERVICE_URL_CONSTANT, $filter, $http, ngNotify, $mdDialog, LOCAL_ENV_CONSTANT, $cookies, $localStorage, moment, $timeout) {
		var _this2 = this;
	
		_classCallCheck(this, Helpers);
	
		this.$translate = $filter('translate');
		this.inputsArray = ['multipleSelect', 'multipleSelectSuggest', 'listGroup', 'table', 'file', 'structure', 'concatFields'];
		this.inputsInLine = ['text', 'number', 'textArea', 'switch', 'datetime', 'checkbox'];
		this.inputsObject = ['select', 'selectSuggest', 'datetimeRange'];
		this.typefieldsNotEvaluate = ['ui-grid', 'history'];
		this.$localStorage = $localStorage;
		this.inputs = this.inputsInLine.concat(this.inputsObject, this.inputsArray);
		this.systemConfig = LOCAL_ENV_CONSTANT;
		this.clt = {
			error: {
				default: { title: ' Unknow error!', message: 'No Description' },
				title: 'consoleLogTitleErrorStyle',
				subT: 'consoleLogSubtitleErrorStyle'
			},
			warn: {
				default: { title: ' Unknow warning!', message: 'No Description' },
				title: 'consoleLogTitleWarnStyle',
				subT: 'consoleLogSubtitleWarnStyle'
			},
			info: {
				default: { title: ' Info!', message: 'No Description' },
				title: 'consoleLogTitleInfoStyle',
				subT: 'consoleLogSubtitleInfoStyle'
			}
		};
		var commonsStyle = ['display: block', 'font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif', 'font-style: bold', 'font-weight: 400', 'line-height: 1.42857142857143', 'letter-spacing: -.005em'];
	
		this.consoleLogTitleErrorStyle = commonsStyle.concat(['font-size: 24px', 'color: red']).join(';');
		this.consoleLogSubtitleErrorStyle = commonsStyle.concat(['font-size: 14px', 'color: red']).join(';');
		this.consoleLogTitleWarnStyle = commonsStyle.concat(['font-size: 24px', 'color: orange']).join(';');
		this.consoleLogSubtitleWarnStyle = commonsStyle.concat(['font-size: 14px', 'color: orange']).join(';');
		this.consoleLogTitleInfoStyle = commonsStyle.concat(['font-size: 24px', 'color: blue']).join(';');
		this.consoleLogSubtitleInfoStyle = commonsStyle.concat(['font-size: 14px', 'color: blue']).join(';');
		/**
	 * Funcion para validar estructuras de arbol como la del syllabus
	 **/
		this.checkStructureInputsRequire = function (structure, errors, parent) {
			structure = structure || [];
			errors = errors || { status: true };
			parent = parent || 'MAIN_ACCORDION';
			errors[parent] = { errors: [] };
	
			for (var i in structure) {
				if (_this2.inputs.indexOf(structure[i].typefield) >= 0) {
					if (structure[i].isRequired == 1) {
						if (_this2.inputsArray.indexOf(structure[i].typefield) >= 0) {
							/**
	      * Validando los campos de tipo arreglo como ['multipleSelect', 'multipleSelectSuggest', 'listGroup']
	      **/
							if (structure[i].data.length <= 0 || angular.equals(structure[i].data[0], {})) {
								errors.status = false;
								errors[parent].errors.push({
									label: _this2.$translate(structure[i].label),
									text: 'Es requerido'
								});
							}
						} else if (_this2.inputsObject.indexOf(structure[i].typefield) >= 0) {
							/**
	      * Validando los campos de tipo Object como ['select', 'selectSuggest', 'datetimeRange']
	      **/
							if (Object.keys(structure[i].data).length <= 0) {
								errors.status = false;
								errors[parent].errors.push({
									label: _this2.$translate(structure[i].label),
									text: 'Es requerido'
								});
							}
						} else {
							/**
	      * Validando los campos lineales como ['text', 'number', 'textArea', 'switch', 'datetime']
	      **/
							// structure[i].data[0] = structure[i].data[0] || {}
							if (!structure[i].data[0] || structure[i].data[0].value === undefined || structure[i].data[0].value === null || structure[i].data[0].value === '') {
								errors.status = false;
								errors[parent].errors.push({
									label: _this2.$translate(structure[i].label),
									text: 'Es requerido'
								});
							}
						}
					}
				} else if (_this2.typefieldsNotEvaluate.indexOf(structure[i].typefield) >= 0) {
					errors[parent].errors = errors[parent].errors || [];
				} else {
					/**
	    * Validacion recursiva
	    **/
					var err = _this2.checkStructureInputsRequire(structure[i].data, errors, structure[i].label);
	
					errors[parent][structure[i].label] = err.errors;
					errors.status = err.status;
				}
			}
	
			return { errors: errors[parent], status: errors.status };
		};
	
		/**
	 * Funcion generica para obtener los parametros para los servicios de listado de los dynamic-inputs
	 **/
		this.getParam = function (model, paramName, config) {
			var p = {};
	
			if (Array.isArray(model)) {
				p[paramName] = model.map(function (item) {
					return item[config.id];
				});
			} else if ((typeof model === 'undefined' ? 'undefined' : _typeof(model)) == 'object') {
				if (model[config.id]) {
					p[paramName] = model[config.id];
				}
			} else {
				p[paramName] = model;
			}
	
			return p;
		};
	
		this.chunkData = function (arrayList, limit) {
			limit = limit || 2;
			var chunk = {};
			var x = 0;
			var cols = 0;
	
			arrayList.data.forEach(function (sec) {
				cols += sec.col || (typeof sec.cols == 'string' ? parseInt(sec.cols) : null) || 1;
	
				if (cols > limit) {
					cols = sec.col || (typeof sec.cols == 'string' ? parseInt(sec.cols) : null) || 1;
					x++;
				}
	
				chunk[x] = chunk[x] || [];
				chunk[x].push(sec);
			});
	
			return Object.values(chunk);
		};
	
		this.defineStructure = function (section, order) {
			if (!section) {
				return false;
			}
	
			/**
	  * Otros tipos de orden
	  *  first | last | first-last | full | none
	  **/
			order = order || 'first-last';
			var isPar = section.data.length % 2 == 0 ? 1 : 2;
	
			section.data = section.data.sort(function (a, b) {
				return a.orderBy - b.orderBy;
			});
			for (var i in section.data) {
				if (order == 'first-last') {
					if (i == 0 || i == section.data.length - 1) {
						section.data[i].col = 2;
						continue;
					}
	
					section.data[i].col = isPar != 0 ? isPar : 1;
					isPar = 0;
				} else if (order == 'full') {
					section.data[i].col = 2;
				} else if (order == 'first') {
					if (i == 0) {
						section.data[i].col = 2;
						continue;
					}
	
					section.data[i].col = isPar != 0 ? isPar : 1;
					isPar = 0;
				} else if (order == 'last') {
					if (i == section.data.length - 1) {
						section.data[i].col = 2;
						continue;
					}
	
					section.data[i].col = isPar != 0 ? isPar : 1;
					isPar = 0;
				} else if (order == 'none') {
					section.data[i].col = 1;
				}
			}
			section.data = _this2.chunkData(section);
	
			section.data.forEach(function (row) {
				row.forEach(function (panel) {
					if (panel.typefield == 'panel') {
						panel.data = _this2.definePanel(panel);
					} else if (panel.typefield == 'dynamicOccurrences') {
						panel.data.forEach(function (ocurrency) {
							ocurrency.data = _this2.definePanel(ocurrency, true);
						});
					} else if (panel.typefield == 'occurrences') {
						panel.data.forEach(function (ocurrency) {
							ocurrency.col = panel.col;
							ocurrency.data = _this2.definePanel(ocurrency);
						});
					}
				});
			});
	
			return section;
		};
	
		this.definePanel = function (panel, isOcur) {
			var items = panel.data.length;
	
			panel.data = panel.data.sort(function (a, b) {
				return a.orderBy - b.orderBy;
			});
			panel.data.forEach(function (field) {
				field.col = panel.col == 2 && items > 1 ? 1 : 2;
				field.col = isOcur ? 1 : field.col;
	
				if (['occurrences', 'dynamicOccurrences'].indexOf(field.typefield) >= 0) {
					field.data = field.data || [];
					// eslint-disable-next-line no-unused-vars
					field.data.forEach(function (acco) {
						acco = _this2.defineStructure(acco, 'none');
					});
				}
			});
	
			panel.data = _this2.chunkData(panel);
	
			return panel.data;
		};
	
		this.getItemForModel = function (field) {
			var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var conf = arguments[2];
	
			conf = conf || { name: 'ds_name', id: 'id_code', code: 'ds_code' };
			var namesForName = ['componentName', 'courseName', 'equivalenceName', 'activityName', 'cycleName', 'studentName', 'campusPeriodShiftName', 'roleName', 'workflowName', 'statusName', 'value', 'adminitstrativeName', 'teacherName', 'ModalityName', 'languajeName', 'name', 'academicPeriodName', 'periodName', 'careerName', 'pensumName', 'campusName', 'facultyName', 'periodTypeName', 'shiftName', 'departmentName', 'userName', 'resourceTypeName', 'usageTypesName'];
			var namesForCode = ['componentCode', 'courseCode', 'equivalenceCode', 'activityCode', 'cycleCode', 'studentCode', 'campusPeriodShiftCode', 'roleCode', 'workflowCode', 'statusCode', 'academicPeriodCode', 'periodCode', 'pensumCode', 'careerCode', 'campusCode', 'facultyCode', 'periodTypeCode', 'shiftCode', 'departmentCode', 'teacherCode', 'userCode', 'resourceTypeCode', 'usageTypesCode'];
			var namesForId = ['componentId', 'courseId', 'equivalenceId', 'activityId', 'cycleId', 'studentId', 'campusPeriodShiftId', 'roleId', 'workflowId', 'statusId', 'id', 'idAdministrative', 'teacherId', 'modalityId', 'languajeId', 'academicPeriodId', 'periodId', 'pensumId', 'careerId', 'campusId', 'periodTypeId', 'shiftId', 'departmentId', 'teacherId', 'userId', 'resourceTypeId', 'usageTypesId'];
			var localField = null;
			var item = {};
	
			if (data.studentFirstName || data.studentLastName) {
				data.studentName = _this2.getTitle(data, 'studentFirstName', 'studentLastName', ' ');
			}
	
			for (var f in data) {
				var fi = namesForName.indexOf(f) >= 0 ? item[conf.name] ? f : conf.name : f;
				var fie = namesForCode.indexOf(fi) >= 0 ? item[conf.code] ? fi : conf.code : fi;
	
				localField = namesForId.indexOf(fie) >= 0 ? item[conf.id] ? fie : conf.id : fie;
				item[localField] = data[f];
				item[f] = data[f];
			}
			delete item.value;
			delete item.id;
			field.addParams = field.addParams || {};
	
			if (Object.keys(field.addParams).length > 0) {
				for (var i in field.params) {
					item[field.params[i]] = field.addParams[field.params[i]];
				}
			}
	
			return _.size(item) > 1 ? item : null;
		};
	
		this.organizeElements = function (section, order) {
			if (!section) return false;
	
			section.data = section.data || [];
	
			if (Array.isArray(section.data[0])) {
				return section;
			}
	
			/**
	  * Otros tipos de orden
	  *  first | last | first-last | full | none
	  **/
			order = order || 'first-last';
			section.data = section.data.sort(function (a, b) {
				return a.orderBy - b.orderBy;
			});
	
			for (var i in section.data) {
				if (order == 'first-last') {
					section.data[i].col = 1;
	
					if (i == 0 || i == section.data.length - 1) {
						section.data[i].col = 2;
					}
				} else if (order == 'full') {
					section.data[i].col = 2;
				} else if (order == 'first') {
					section.data[i].col = 1;
	
					if (i == 0) {
						section.data[i].col = 2;
					}
				} else if (order == 'last') {
					if (i == section.data.length - 1) {
						section.data[i].col = 2;
					} else {
						section.data[i].col = 1;
					}
				} else if (order == 'none') {
					section.data[i].col = 1;
				}
			}
	
			section.data = _this2.chunkData(section);
	
			return section;
		};
	
		this.saveChanges = function (opt, params, callback, noMessage) {
			callback = callback || function () {};
			$http({
				url: opt.url,
				method: opt.method || 'POST',
				data: params
			}).then(function (response) {
				if (response.data.status) {
					if (!noMessage) {
						ngNotify.set(_this2.$translate('UPDATE_SUCCESS_MESSAGE'), 'success');
					}
	
					callback(true, response.data);
				} else {
					callback(response.data);
	
					if (!noMessage) {
						ngNotify.set('Ocurrio un error con el servicio', 'error');
					}
				}
			}, function () {
				callback(false);
	
				if (!noMessage) {
					ngNotify.set('Imposible conectar con el servicio ' + opt.url, 'error');
				}
			});
		};
	
		this.validateRequiredInputs = function (data, forcedInputs) {
			for (var i in forcedInputs) {
				if (data[forcedInputs[i]] == undefined) {
					ngNotify.set('Falta completar campos obligatorios', 'warn');
	
					return false;
				}
			}
	
			return true;
		};
	
		this.consoleLog = function (msg, type, trace) {
			type = type || 'error'; // [error | warn | info]
			var standardTitle = 'Sandbox-front | ';
	
			if (Array.isArray(msg)) {
				// Comming soon
			} else if ((typeof msg === 'undefined' ? 'undefined' : _typeof(msg)) == 'object') {
				msg = angular.extend({}, _this2.clt[type].default, msg);
			} else {
				msg = { title: msg, message: _this2.clt[type].default.message };
			}
	
			// eslint-disable-next-line no-console
			console.log('%c ' + standardTitle + msg.title, _this2[_this2.clt[type].title]);
			// eslint-disable-next-line no-console
			console.log('%c Description: ' + msg.message, _this2[_this2.clt[type].subT]);
	
			if (trace) {
				// eslint-disable-next-line no-console
				console.trace('%c Sequency functions calls', _this2.consoleLogSubtitleErrorStyle);
			}
		};
	
		this.getListByConcept = function (concept, callback) {
			callback = callback || function () {};
			var url = SERVICE_URL_CONSTANT.improve + '/commons/getList';
	
			if (concept) {
				$http({
					url: url,
					method: 'GET',
					params: { concept: concept }
				}).then(function (response) {
					if (response.data.status) {
						callback(response.data);
					} else {
						callback(false);
						var error = {
							title: 'Helper Error Message: getListByConcept',
							message: response.data.message || 'Ocurrio un error en el servicio ' + url
						};
	
						_this2.consoleLog(error);
					}
				}, function () {
					callback(false);
					var err = {
						title: 'Helper Error Message: getListByConcept',
						message: 'Imposible conectar con el servicio ' + url
					};
	
					_this2.consoleLog(err);
				});
			} else {
				callback(false);
				var error = {
					title: 'Helper Error Message: getListByConcept',
					message: "No se recibio el valor del parametro 'concept'"
				};
	
				_this2.consoleLog(error);
			}
		};
	
		this.checkCode = function (publicId, concept, idCode, callback) {
			callback = callback || function () {};
			idCode = idCode || 0;
			var params = { publicId: publicId, concept: concept, idCode: idCode };
			var url = SERVICE_URL_CONSTANT.coreApi + '/helpers/checkPID';
	
			if (concept && publicId) {
				$http({
					url: url,
					method: 'GET',
					params: params
				}).then(function (response) {
					if (response.data.status) {
						var valid = true;
	
						if (response.data.data.length > 0) {
							valid = false;
						}
	
						callback(valid);
					} else {
						callback(false);
						ngNotify.set('Ocurrio un error con el servicio', 'warn');
						var error = {
							title: 'Helper Error Message: checkCode',
							message: response.data.message || 'Ocurrio un error en el servicio ' + url
						};
	
						_this2.consoleLog(error);
					}
				}, function () {
					callback(false);
					ngNotify.set('Imposible conectar con el servicio ' + url, 'warn');
					var err = {
						title: 'Helper Error Message: checkCode',
						message: 'Imposible conectar con el servicio ' + url
					};
	
					_this2.consoleLog(err);
				});
			} else {
				callback(false);
				ngNotify.set('Ver consola ', 'warn');
				var error = {
					title: 'Helper Error Message: checkCode',
					message: 'Error en el envio de parametros (publicId, concept, idCode)'
				};
	
				_this2.consoleLog(error);
			}
		};
	
		this.guid = function (segmentCounts) {
			segmentCounts = segmentCounts || 3;
			var segments = [];
	
			segments.push(s4() + s4());
			function s4() {
				return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
			}
			for (var i = 0; i < segmentCounts; i++) {
				segments.push(s4());
			}
			segments.push(s4() + s4() + s4());
	
			return segments.join('-');
		};
	
		this.getGridConfig = function (options) {
			var defaultOpt = {
				exporterMenuCsv: true,
				exporterMenuPdf: false,
				exporterCsvFilename: 'uiGridTable.csv',
				enableGridMenu: true,
				enableFiltering: true,
				enablePaging: true,
				paginationPageSizes: [25, 50, 100, 200, 500, 10000],
				paginationPageSize: 25,
				columnDefs: []
			};
	
			return angular.extend({}, defaultOpt, options);
		};
	
		this.getFieldData = function (field) {
			if (_this2.inputsArray.indexOf(field.typefield) >= 0) {
				var model = [];
	
				if (field.model) {
					field.model.forEach(function (item) {
						if (item.model) {
							model.push({ id: item.model.id_code, value: item.model.ds_name });
						}
					});
				}
	
				return model;
			} else if (_this2.inputsObject.indexOf(field.typefield) >= 0) {
				if (field.model) {
					return [{ id: field.model.id_code, value: field.model.ds_name }];
				} else {
					return [];
				}
			} else if (_this2.inputsInLine.indexOf(field.typefield) >= 0) {
				return [{ value: field.model }];
			}
	
			return [];
		};
	
		// this.mathjs = require('../../../bower_components/mathjs/dist/math.min.js')
	
		this.findFunction = function (formula) {
			var functionsList = ['MejorX', 'PeorX', 'Mejor', 'Peor', 'Promedio', 'IF'];
			var _this = _this2;
	
			function containsFunctions(str) {
				var functions = ['Mejor', 'Peor', 'Promedio', 'IF'];
	
				for (var i = 0; i != functions.length; i++) {
					var fn = functions[i];
	
					if (str.toString().indexOf(fn) != -1) {
						return true;
					}
				}
	
				return false;
			}
			// eslint-disable-next-line no-unused-vars
			function Promedio() {
				var count = arguments.length;
	
				if (count) {
					var compare = [];
	
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = arguments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var arg = _step.value;
	
							compare.push(arg);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					var exec = '(' + compare.join('+') + ')/' + count;
	
					return eval(exec);
				} else {
					return 0;
				}
			}
			// eslint-disable-next-line no-unused-vars
			function IF(condition, thenVal, elseVal) {
				if (eval(condition)) {
					return _this.findFunction(thenVal);
				} else {
					return _this.findFunction(elseVal);
				}
			}
			// eslint-disable-next-line no-unused-vars
			function Mejor() {
				var compare = [];
	
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = arguments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var arg = _step2.value;
	
						compare.push(arg);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				compare.sort();
				compare.reverse();
	
				return compare[0];
			}
			// eslint-disable-next-line no-unused-vars
			function Peor() {
				var compare = [];
	
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;
	
				try {
					for (var _iterator3 = arguments[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var arg = _step3.value;
	
						compare.push(arg);
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
	
				compare.sort();
	
				return compare[0];
			}
			// eslint-disable-next-line no-unused-vars
			function MejorX() {
				var compare = [];
				var count = arguments[0];
	
				if (count) {
					for (var i in arguments) {
						if (i > 0) {
							compare.push(arguments[i]);
						}
					}
					compare.sort();
					compare.reverse();
					var response = [];
	
					for (var _i = 0; _i < count; _i++) {
						response.push(compare[_i]);
					}
	
					return response;
				} else {
					return 0;
				}
			}
			// eslint-disable-next-line no-unused-vars
			function PeorX() {
				var compare = [];
				var count = arguments[0];
	
				if (count) {
					for (var i in arguments) {
						if (i > 0) {
							compare.push(arguments[i]);
						}
					}
					compare.sort();
					var response = [];
	
					for (var _i2 = 0; _i2 < count; _i2++) {
						response.push(compare[_i2]);
					}
	
					return response;
				} else {
					return 0;
				}
			}
	
			function findFN(formula, str) {
				var re = new RegExp(str + '\\(([^()]+)\\)', 'g');
				var res = res = formula.toString().match(re);
	
				formula = formula === undefined || formula === null ? '' : formula;
	
				if (res) {
					for (var i in res) {
						if (res[i] == res[i].match(re)[0]) {
							var fn = str + res[i].match(/\([^()]+\)/g)[0];
	
							res[i] = eval(fn);
						} else {
							res[i] = _this.findFunction(res[i]);
						}
					}
					for (var _i3 in res) {
						formula = formula.replace(formula.toString().match(re)[0], res[_i3]);
					}
				} else {
					if (containsFunctions(formula) <= 1) {
						var _re = new RegExp('\\(([^()]+)\\)', 'g');
						var _res = formula.toString().match(_re);
	
						if (_res) {
							var orig = angular.copy(_res);
	
							for (var _i4 in _res) {
								if (_res[_i4].toString().indexOf(',') >= 0) continue;
	
								// res[i] = _this.mathjs.eval(res[i])
							}
							for (var _i5 in _res) {
								formula = formula.replace(orig[_i5], _res[_i5]);
							}
						}
					}
				}
	
				return formula;
			}
	
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;
	
			try {
				for (var _iterator4 = functionsList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var fun = _step4.value;
	
					formula = findFN(formula, fun);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
	
			while (containsFunctions(formula)) {
				formula = _this.findFunction(formula);
			}
	
			return formula;
		};
	
		this.getRandomClassColor = function (noneOf) {
			noneOf = noneOf || [];
			var colorNames = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange']; //, 'deep-orange', 'brown', 'blue-grey', 'grey']
			// eslint-disable-next-line no-unused-vars
			var tonality = ['A100', 'A200', 'A400', 'A700'];
			// let tonalityIndex = Math.floor((Math.random() * tonality.length))
			var colorIndex = null;
	
			if (noneOf.length >= colorNames.length) {
				noneOf = [];
			}
	
			do {
				colorIndex = Math.floor(Math.random() * colorNames.length);
			} while (noneOf.indexOf(colorNames[colorIndex]) >= 0);
	
			return colorNames[colorIndex]; // + '-' + tonality[tonalityIndex]
		};
	
		this.getHeaderCellTemplate = function (header) {
			header = header || 'tooltip';
	
			if (header == 'tooltip') {
				return __webpack_require__(1185);
			} else {
				_this2.consoleLog('getHeaderCellTemplate => header "' + header + '" is not defined');
			}
		};
	
		this.getTitle = function (obj, code, name, split) {
			obj = obj || {};
			split = split || ' - ';
			var t = [obj[code], obj[name]];
			var title = t.filter(function (a) {
				return a && a != 0 || a == '0' ? true : false;
			}).join(split);
	
			return title;
		};
	
		this.getWeekDays = function (day) {
			var weekDays = [{ day: 1, name: 'MON' }, { day: 2, name: 'TUE' }, { day: 3, name: 'WED' }, { day: 4, name: 'THU' }, { day: 5, name: 'FRI' }, { day: 6, name: 'SAT' }, { day: 7, name: 'SUN' }];
	
			if (day) {
				return weekDays[parseInt(day) - 1];
			} else {
				return weekDays;
			}
		};
	
		this.prepareCourseList = function (data) {
			var response = [];
	
			data = data || [];
			data.forEach(function (course) {
				var subt = _this2.getTitle(course, 'departmentCode', 'departmentName');
				var desc = _this2.getTitle(course, 'facultyCode', 'facultyName');
	
				response.push(angular.extend({}, course, {
					id_code: course.courseId,
					cod: course.courseCode,
					title: course.courseName,
					subTitle: subt,
					descriptionList: [{ label: 'FACULTY', value: desc }, { label: 'DEPARTMENT', value: subt }],
					badges: [{ bg: 'bg-warning', label: course.statusName }]
				}));
			});
	
			return response;
		};
	
		this.prepareSectionList = function (Data) {
			var response = [];
	
			Data = Data || [];
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;
	
			try {
				for (var _iterator5 = Data[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var section = _step5.value;
	
					section.roles = section.roles || [];
					section.roles = section.roles || [];
					section.courses = section.courses || [];
					section.teachers = section.teachers || [];
					var teachers = section.teachers.filter(function (teach) {
						return teach.isPrincipal;
					}).map(function (teach) {
						return teach.teacherName;
					});
	
					section.activities = section.activities || [];
					var activities = section.activities.map(function (act) {
						return _this2.getTitle(act, 'activityCode', 'activityName');
					});
					var item = angular.extend({}, section, {
						id_code: section.sectionId,
						title: section.courses.map(function (course) {
							return _this2.getTitle(course, 'courseCode', 'courseName');
						}),
						descriptionList: [{ label: teachers.length ? 'IMPROVE_PROFESSOR' : false, value: teachers.join() }, { label: 'SECTION', value: section.sectionName }, { label: 'NRC', value: section.sectionNumber }, { label: activities.length ? 'ACTIVITY' : false, value: activities.join(', ') }, { label: 'PERIOD', value: _this2.getTitle(section, 'periodCode', 'periodName') }],
						rolLabels: section.roles.map(function (role) {
							return {
								id: role.roleId,
								id_code: role.roleCode,
								ds_name: role.roleName
							};
						}),
						badges: [{ bg: 'bg-warning', label: section.statusName }, { bg: 'bg-info', label: section.evaluationAssigned ? 'ASIGNED' : false, icon: 'fal fa-check no-margin' }, { bg: 'bg-info', label: section.inProgress == 1 ? 'COURSE_IN_PROGRESS' : false, icon: 'fal fa-chalkboard-teacher no-margin' }]
					});
	
					response.push(item);
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}
	
			return response;
		};
	
		this.filterInObject = function (obj, text) {
			var search = new RegExp(text, 'gi');
	
			for (var i in obj) {
				if (obj[i].toString().match(search)) {
					return true;
				}
			}
	
			return false;
		};
	
		this.getName = function (ar) {
			var ext = ar[ar.length - 1].toLowerCase();
	
			return ar.filter(function (i) {
				return i.toLowerCase() !== ext;
			}).join('.');
		};
	
		this.getFileIcon = function (file) {
			var classes = {
				w: 'fal fa-file-word',
				p: 'fal fa-file-pdf',
				pp: 'fal fa-file-powerpoint',
				x: 'fal fa-file-excel',
				c: 'fal fa-file-csv',
				t: 'fal fa-file-alt',
				o: 'fal fa-file',
				i: 'fal fa-file-image',
				v: 'fal fa-file-video'
			};
	
			file.filename = file.filename || file.fileName || '';
			var limitTo = 10;
			var fn = file.filename.toString().split('.');
	
			file.showName = _this2.getName(fn);
			file.showName = $filter('limitTo')(file.showName, limitTo) + (file.showName.length >= limitTo ? '...' : '.') + (fn[fn.length - 1] || '');
			var ext = fn[fn.length - 1] ? fn[fn.length - 1].toLowerCase() : 'o';
	
			if (['doc', 'docx'].indexOf(ext) >= 0) {
				return classes['w'];
			}
	
			if (['pdf'].indexOf(ext) >= 0) {
				return classes['p'];
			}
	
			if (['ppt', 'pptx', 'pptm'].indexOf(ext) >= 0) {
				return classes['pp'];
			}
	
			if (['csv'].indexOf(ext) >= 0) {
				return classes['c'];
			}
	
			if (['xls', 'xlsx'].indexOf(ext) >= 0) {
				return classes['x'];
			}
	
			if (['txt'].indexOf(ext) >= 0) {
				return classes['t'];
			}
	
			if (['mp4', 'mov', 'avi', 'mkv', 'flv', 'swf', 'm4v'].indexOf(ext) >= 0) {
				return classes['v'];
			}
	
			if (['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg'].indexOf(ext) >= 0) {
				return classes['i'];
			}
	
			return classes['o'];
		};
	
		this.getRecordsFormatted = function (field, records) {
			var data = [];
	
			records = records || [];
			for (var i in records) {
				var row = _this2.getItemForModel(field, records[i]);
	
				data.push(row);
			}
	
			return data;
		};
	
		this.callService = function (field, params, baseServiceUrl, callback) {
			if (!field.pathService || field.pathService == '' || field.initialDisabled) {
				callback({ data: [] });
	
				return;
			}
	
			var url = Array.isArray(field.pathService) ? field.pathService : baseServiceUrl ? baseServiceUrl + field.pathService : [];
	
			if (Array.isArray(url)) {
				callback({ data: _this2.getRecordsFormatted(field, url) });
			} else if (field.pathService !== undefined && field.pathService !== null && field.pathService != '') {
				$http({
					method: 'GET',
					url: url,
					params: params
				}).then(function (response) {
					response.data.data = response.data.data || [];
	
					if (response.data.data.length <= 0) {
						callback({ data: [] });
	
						return;
					} else {
						callback({ data: _this2.getRecordsFormatted(field, response.data.data) });
					}
				}, function () {
					callback({ data: [] });
	
					return;
				});
			} else {
				callback({ data: [] });
	
				return;
			}
		};
	
		this.chunk = function (a, n) {
			a = a || [];
	
			return [].concat.apply([], a.map(function (e, i) {
				return i % n ? [] : [a.slice(i, i + n)];
			}));
		};
	
		this.alert = function (msg) {
			$mdDialog.show($mdDialog.alert().parent($('#content > .box')).clickOutsideToClose(false).title('Error').textContent(msg).ok('Aceptar'));
		};
	
		this.timeToMinutesPerc = function (item) {
			var limit = '23:59';
			var totalMin = limit.split(':').map(function (a) {
				return parseInt(a || 0);
			}).reduce(function (a, b) {
				return a * 60 + b;
			});
			var startMin = item.from.split(':').map(function (a) {
				return parseInt(a || 0);
			}).reduce(function (a, b) {
				return a * 60 + b;
			});
			var endMin = item.to.split(':').map(function (b) {
				return parseInt(b || 0);
			}).reduce(function (a, b) {
				return a * 60 + b;
			});
	
			var _temp = {
				startMin: startMin,
				endMin: endMin,
				startPerc: parseFloat((startMin * 100 / totalMin).toFixed(2)),
				endPerc: parseFloat((endMin * 100 / totalMin).toFixed(2)),
				type: item.type || 'booked',
				tooltip: item.tooltip || 'BOOKING_BUSY'
			};
	
			return _temp;
		};
	
		this.getPercentageArray = function (marks) {
			var finalArr = [];
	
			for (var i in marks) {
				var _last = finalArr.length - 1;
	
				if (finalArr[_last] && finalArr[_last].type != 'free') {
					var start = finalArr[_last].endPerc;
	
					finalArr.push({
						type: 'free',
						tooltip: 'BOOKING_FREE',
						perc: marks[i].startPerc - start,
						endPerc: marks[i].endPerc,
						startPerc: start,
						style: {
							width: marks[i].startPerc - start + '%'
						}
					});
				}
	
				finalArr.push({
					type: marks[i].type || 'booked',
					perc: marks[i].endPerc - marks[i].startPerc,
					endPerc: marks[i].endPerc,
					startPerc: marks[i].startPerc,
					tooltip: marks[i].tooltip || 'BOOKING_BUSY',
					style: {
						width: marks[i].endPerc - marks[i].startPerc + '%'
					}
				});
			}
	
			var totalPerc = finalArr.map(function (a) {
				return a.perc;
			}).reduce(function (a, b) {
				return a + b;
			}, 0);
			var last = finalArr.length - 1;
	
			if (totalPerc < 100) {
				var width = finalArr[last] ? finalArr[last].endPerc + 0.1 : 0;
	
				finalArr.push({
					type: 'free',
					tooltip: 'BOOKING_FREE',
					startPerc: 0,
					style: {
						width: 100 - width + '%'
					}
				});
			}
	
			return finalArr;
		};
	
		this.getHoursList = function (start, end, split, chrash) {
			start = start || '00:00';
			end = end || '23:59';
			split = split || 30;
			chrash = chrash === undefined ? false : chrash;
			split = chrash ? split - 1 : split;
			var today = moment(new Date()).format('YYYY-MM-DD ');
			var i = moment(today + start);
			var f = moment(today + end);
	
			f.add(split * -1, 'minutes');
			var fin = moment(today + start);
	
			fin.add(split, 'minutes');
			var ID = 1;
			var hours = [{ id: ID, start: start, end: fin.format('HH:mm') }];
	
			while (parseInt(i.format('HHmmss')) < parseInt(f.format('HHmmss'))) {
				ID++;
				i.add(chrash ? split + 1 : split, 'minutes');
				fin = angular.copy(i);
				fin.add(split, 'minutes');
	
				if (fin.format('HHmmss') == '000000') {
					fin.add(-1, 'minutes');
				}
	
				hours.push({ id: ID, start: i.format('HH:mm'), end: fin.format('HH:mm') });
			}
	
			return hours;
		};
	
		this.updateInputDataFromModel = function (field) {
			field = field || {};
			field.data = field.data || [{}];
	
			if (_this2.inputsInLine.indexOf(field.typefield) >= 0) {
				field.data[0] = field.data[0] || {};
				field.data[0].value = field.model;
			}
	
			if (field.typefield == 'file') {
				field.data = angular.copy(field.filesModel);
			}
	
			return field;
		};
	
		this.getOccurrenceTitle = function (occurrence) {
			occurrence.label = occurrence.label || '';
			var response = '<div class="occurrence-title">';
			var title = occurrence.label.split(' - ');
	
			if (title.length == 1) {
				return _this2.$translate(occurrence.label);
			}
	
			for (var i in title) {
				var conector = i > 0 ? '<span class="m-l-xs"> - </span>' : '';
	
				response += conector + ' <div class="m-l-xs">' + _this2.$translate(title[i]) + '</div>';
			}
	
			return response += '</div>';
		};
	
		this.getItemTitle = function (item, code, name) {
			item.label = item.label || '';
			var response = '<div class="occurrence-title">';
			var tcode = item[code] ? '<div class="m-l-xs">' + _this2.$translate(item[code]) + '</div>' : '';
			var tname = item[name] ? '<div class="m-l-xs">' + _this2.$translate(item[name]) + '</div>' : '';
			var conector = tcode && tname ? '<span class="m-l-xs"> - </span>' : '';
	
			return response + tcode + conector + tname + '</div>';
		};
	
		this.getFormattedStudentName = function (student) {
			student = student || {};
			_this2.systemConfig.studentNameFormat = _this2.systemConfig.studentNameFormat || _this2.systemConfig.teacherNameFormat || ':firstName :lastName';
			var displayName = _this2.systemConfig.studentNameFormat.replaceAll(':firstName', student.studentFirstName || student.nameStudent);
	
			displayName = displayName.replaceAll(':lastName', student.studentLastName || student.lastName);
	
			return displayName;
		};
	
		this.getReportColums = function () {
			var response = {
				//lista para isil, se debe cambiar clientName
				isil: [{
					ds_origin: 'Campus', new_name: _this2.$translate('CAMPUS')
				}, {
					ds_origin: 'Id_Periodo_Academico', new_name: _this2.$translate('ACADEMIC_PERIOD_ID')
				}, {
					ds_origin: 'turno', new_name: _this2.$translate('TURN')
				}, {
					ds_origin: 'Id_Curso', new_name: _this2.$translate('COURSE') + '_Id'
				}, {
					ds_origin: 'Descripcion_del_Curso', new_name: _this2.$translate('COURSE_DESCRIPTION')
				}, {
					ds_origin: 'Id_Actividad', new_name: _this2.$translate('ACTIVITY_ID')
				}, {
					ds_origin: 'id_uplanner', new_name: _this2.$translate('ID_UPL')
				}, {
					ds_origin: 'id_padre', new_name: _this2.$translate('ID_FATHER')
				}, {
					ds_origin: 'Capacidad_Inscripcion', new_name: _this2.$translate('INSCRIPTION_CAPACITY') // sss.nm_sectionQuota AS estudiantes_seccion
				}, {
					ds_origin: 'Id_Plan', new_name: _this2.$translate('PENSUM_ID')
				}, {
					ds_origin: 'ds_studentsCohort', new_name: _this2.$translate('DS_COHORTE')
				}, {
					ds_origin: 'Numero_Inscritos', new_name: _this2.$translate('N_ENROLLED') //?ssf.nm_students AS estudiantes_grupo_compatible
				}, {
					ds_origin: 'Grupo', new_name: _this2.$translate('GROUPS')
				}, {
					ds_origin: 'nota_de_clase', new_name: _this2.$translate('MENU_CLASS_NOTE')
				}, {
					ds_origin: 'modulo', new_name: _this2.$translate('MODULE')
				}, {
					ds_origin: 'dia', new_name: _this2.$translate('DAY')
				}, {
					ds_origin: 'Docente', new_name: _this2.$translate('TEACHER')
				}, {
					ds_origin: 'Edificio_Salon', new_name: _this2.$translate('BUILDING_ROOMS')
				}, {
					ds_origin: 'id_simulation', new_name: _this2.$translate('SIMULATION')
				}],
				uplanner: [{
					ds_origin: 'Campus', new_name: _this2.$translate('CAMPUS')
				}, {
					ds_origin: 'Capacidad', new_name: _this2.$translate('CAPACITY')
				}, {
					ds_origin: 'Capacidad_Inscripcion', new_name: _this2.$translate('INSCRIPTION_CAPACITY')
				}, {
					ds_origin: 'capacidad_ociosa', new_name: _this2.$translate('IDLE_CAPACITY')
				}, {
					ds_origin: 'Cargo_Docente', new_name: _this2.$translate('TEACHER_ROLE')
				}, {
					ds_origin: 'Carrera', new_name: _this2.$translate('CAREER')
				}, {
					ds_origin: 'Ciclo', new_name: _this2.$translate('CYCLE')
				}, {
					ds_origin: 'Cohorte', new_name: _this2.$translate('COHORTE')
				}, {
					ds_origin: 'Descripcion_del_Curso', new_name: _this2.$translate('COURSE_DESCRIPTION')
				}, {
					ds_origin: 'Docente', new_name: _this2.$translate('TEACHER')
				}, {
					ds_origin: 'ds_studentsCohort', new_name: _this2.$translate('YEAR_OF_ENTRY')
				}, {
					ds_origin: 'Edificio_Salon', new_name: _this2.$translate('BUILDING_ROOMS')
				}, {
					ds_origin: 'Estado', new_name: _this2.$translate('STATUS')
				}, {
					ds_origin: 'Evaluacion_Docente', new_name: _this2.$translate('TEACHER_EVALUATION')
				}, {
					ds_origin: 'Fecha_Fin', new_name: _this2.$translate('END_DATE')
				}, {
					ds_origin: 'Fecha_Inicio', new_name: _this2.$translate('START_DATE')
				}, {
					ds_origin: 'Frecuencia', new_name: _this2.$translate('IMPROVE_FRECUENCY')
				}, {
					ds_origin: 'Grupo', new_name: _this2.$translate('GROUPS')
				}, {
					ds_origin: 'Grupo_Unico', new_name: _this2.$translate('UNIQUE_GROUP')
				}, {
					ds_origin: 'grupos_compactados', new_name: _this2.$translate('COMPACTED_GROUPS')
				}, {
					ds_origin: 'Horario_Fin', new_name: _this2.$translate('END_TIME')
				}, {
					ds_origin: 'Horario_Inicio', new_name: _this2.$translate('START_TIME')
				}, {
					ds_origin: 'Horas_Utilizadas_Semanales', new_name: _this2.$translate('HOURS_USED_PER_WEEK')
				}, {
					ds_origin: 'Id_Actividad', new_name: _this2.$translate('ACTIVITY_ID')
				}, {
					ds_origin: 'Id_Campus', new_name: _this2.$translate('CAMPUS') + '_Id'
				}, {
					ds_origin: 'Id_Carrera', new_name: _this2.$translate('CAREER') + '_Id'
				}, {
					ds_origin: 'Id_Curso', new_name: _this2.$translate('COURSE') + '_Id'
				}, {
					ds_origin: 'Id_Docente', new_name: _this2.$translate('TEACHER_ID')
				}, {
					ds_origin: 'id_padre', new_name: _this2.$translate('ID_FATHER')
				}, {
					ds_origin: 'id_pensum', new_name: _this2.$translate('PENSUM_ID')
				}, {
					ds_origin: 'Id_Periodo_Academico', new_name: _this2.$translate('ACADEMIC_PERIOD_ID')
				}, {
					ds_origin: 'Id_Plan', new_name: _this2.$translate('PENSUM_ID ')
				}, {
					ds_origin: 'id_uplanner', new_name: _this2.$translate('ID_UPL')
				}, {
					ds_origin: 'Maximas_Horas_Semanales', new_name: _this2.$translate('MAX_WEEKLY_HOURS')
				}, {
					ds_origin: 'Modalidad_Temporalidad', new_name: _this2.$translate('MODALITY_TEMPORALITY')
				}, {
					ds_origin: 'Nivel', new_name: _this2.$translate('LEVEL')
				}, {
					ds_origin: 'nm_usedQuota', new_name: _this2.$translate('QUOTA')
				}, {
					ds_origin: 'nota_de_clase', new_name: _this2.$translate('MENU_CLASS_NOTE')
				}, {
					ds_origin: 'Numero_Horas_Total_Semana', new_name: _this2.$translate('WEEKLY_BLOCKS')
				}, {
					ds_origin: 'Numero_Inscritos', new_name: _this2.$translate('N_ENROLLED')
				}, {
					ds_origin: 'Plan_Academico', new_name: _this2.$translate('ACADEMIC_PLAN')
				}, {
					ds_origin: 'Porcentaje_capacidad_Ocupada', new_name: _this2.$translate('PERCENTAGE_OCCUPIED_CAPACITY')
				}, {
					ds_origin: 'Sesion', new_name: _this2.$translate('SESSION')
				}, {
					ds_origin: 'Tipo_Uso_Detallado', new_name: _this2.$translate('USAGE_TYPE_DETAILED')
				}, {
					ds_origin: 'turno', new_name: _this2.$translate('TURN')
				}],
				uin: [{
					ds_origin: 'Campus', new_name: 'Plantel_Licenciatura'
				}, {
					ds_origin: 'Descripcion_del_Curso', new_name: 'Asignatura'
				}, {
					ds_origin: 'Cohorte', new_name: 'Año Academico'
				}, {
					ds_origin: 'Periodo', new_name: 'Periodo'
				}, {
					ds_origin: 'Clave Power Campus', new_name: 'Clave Power Campus'
				}, {
					ds_origin: 'seccion', new_name: 'seccion'
				}, {
					ds_origin: 'Nro Estudiantes', new_name: 'Nro Estudiantes'
				}, {
					ds_origin: 'Horas del plan', new_name: 'Horas del plan'
				}, {
					ds_origin: 'Horas_por_Semana', new_name: 'Horas_por_Semana'
				}, {
					ds_origin: 'Fecha Inicial', new_name: 'Fecha Inicial'
				}, {
					ds_origin: 'Fecha Final', new_name: 'Fecha Final'
				}, {
					ds_origin: 'Programa', new_name: 'Programa'
				}, {
					ds_origin: 'Nivel Clase', new_name: 'Nivel Clase'
				}, {
					ds_origin: 'Tipo_operacion', new_name: 'Tipo_operacion'
				}, {
					ds_origin: 'Dias', new_name: 'Dias'
				}, {
					ds_origin: 'Horario Inicio', new_name: 'Horario Inicio'
				}, {
					ds_origin: 'Horario Fin', new_name: 'Horario Fin'
				}, {
					ds_origin: 'Turno x grupo', new_name: 'Turno x grupo'
				}, {
					ds_origin: 'Docente', new_name: _this2.$translate('TEACHER')
				}, {
					ds_origin: 'Edificio', new_name: 'Edificio'
				}, {
					ds_origin: 'Salon', new_name: 'Salon'
				}, {
					ds_origin: 'Instalaciones', new_name: 'Instalaciones'
				}, {
					ds_origin: 'Observaciones', new_name: 'Observaciones'
				}]
			};
	
			return response[_this2.systemConfig.clientName];
		};
	
		this.validateUniqueFieldOnEvaluationStructure = function (input, nodes, alreadyUsed) {
			nodes = nodes || [];
			_this2.alreadyUsed = alreadyUsed || [];
			var isValid = function isValid(input, node) {
				var _iteratorNormalCompletion6 = true;
				var _didIteratorError6 = false;
				var _iteratorError6 = undefined;
	
				try {
					for (var _iterator6 = node.headerInputs[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
						var field = _step6.value;
	
						if (input.label == field.label) {
							if (_this2.inputsInLine.indexOf(field.typefield) >= 0) {
								if (_this2.alreadyUsed.indexOf(field.model) >= 0) {
									return false;
								} else {
									_this2.alreadyUsed.push(field.model);
									break;
								}
							} else if (_this2.inputsObject.indexOf(field.typefield) >= 0) {
								if (_this2.alreadyUsed.indexOf(field.model[field.config.id] >= 0)) {
									return false;
								} else {
									_this2.alreadyUsed.push(field.model[field.config.id]);
									break;
								}
							} else {
								return true;
							}
						}
					}
				} catch (err) {
					_didIteratorError6 = true;
					_iteratorError6 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion6 && _iterator6.return) {
							_iterator6.return();
						}
					} finally {
						if (_didIteratorError6) {
							throw _iteratorError6;
						}
					}
				}
	
				if (node.nodes.length) {
					return _this2.validateUniqueFieldOnEvaluationStructure(input, node.nodes, _this2.alreadyUsed);
				}
	
				return true;
			};
	
			var _iteratorNormalCompletion7 = true;
			var _didIteratorError7 = false;
			var _iteratorError7 = undefined;
	
			try {
				for (var _iterator7 = nodes[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
					var node = _step7.value;
	
					if (!isValid(input, node)) {
						return false;
					}
				}
			} catch (err) {
				_didIteratorError7 = true;
				_iteratorError7 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion7 && _iterator7.return) {
						_iterator7.return();
					}
				} finally {
					if (_didIteratorError7) {
						throw _iteratorError7;
					}
				}
			}
	
			return true;
		};
	
		this.findEvaluationStructure = function (structure) {
			structure = structure || [];
			var found = false;
	
			var _iteratorNormalCompletion8 = true;
			var _didIteratorError8 = false;
			var _iteratorError8 = undefined;
	
			try {
				for (var _iterator8 = structure[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
					var element = _step8.value;
	
					if (Array.isArray(element)) {
						for (var i in element) {
							if (element[i].typefield == 'structure') {
								return angular.copy(element[i].data);
							} else if (_this2.inputs.indexOf(element[i].typefield) < 0) {
								found = _this2.findEvaluationStructure(element[i].data);
	
								if (found) {
									return found;
								}
							}
						}
					} else {
						if (element.typefield == 'structure') {
							return angular.copy(element.data);
						} else if (_this2.inputs.indexOf(element.typefield) < 0) {
							found = _this2.findEvaluationStructure(element.data);
	
							if (found) {
								return found;
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError8 = true;
				_iteratorError8 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion8 && _iterator8.return) {
						_iterator8.return();
					}
				} finally {
					if (_didIteratorError8) {
						throw _iteratorError8;
					}
				}
			}
	
			return found;
		};
	
		this.download = function (url, filename, callback, method) {
			if (url) {
				callback = callback || function () {};
				var token = $cookies.get('token');
				var request = {
					method: method || 'GET',
					url: url,
					responseType: 'blob',
					headers: { 'x-access-token': token }
				};
	
				$http(request).then(function (response) {
					var a = document.createElement('a');
	
					if (response.data.type == 'application/json') {
						callback(false, []);
	
						ngNotify.set(':::Ocurrio un error al intentar descargar el archivo', 'error');
	
						return false;
					}
	
					a.href = window.URL.createObjectURL(response.data);
					a.download = filename;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					callback(true);
				}, function (error) {
					callback(false, error);
					// eslint-disable-next-line no-console
					console.log('error->', error);
					ngNotify.set(':::Ocurrio un error al intentar descargar el archivo', 'error');
				});
			}
		};
	
		this.base64 = function (data) {
			return new Buffer(data).toString('base64');
		};
	
		this.getUserStored = function (data) {
			data = data || _this2.$localStorage.userAuth;
	
			if (data) {
				return JSON.parse(decodeURIComponent(atob(data).split('').map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				}).join('')));
			} else {
				return false;
			}
		};
	
		this.getShortName = function () {
			var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
			var names = name.split(' ');
	
			if (names.length == 1) {
				return names[0].substring(0, 3);
			} else if (names.length > 1) {
				return names.reduce(function (b, c, i) {
					return b.substring(0, i) + c[0];
				});
			}
	
			return name;
		};
	
		this.cacheServiceFlush = function (bucket) {
			lscache.setBucket(bucket);
			lscache.flush();
		};
	
		this.cacheServiceRemove = function (key) {
			return lscache.remove(key);
		};
	
		this.cacheService = function (options) {
			var _options$params = options.params,
			    params = _options$params === undefined ? {} : _options$params,
			    service = options.service,
			    storage = options.storage,
			    _options$time = options.time,
			    time = _options$time === undefined ? 120 : _options$time,
			    _options$delay = options.delay,
			    delay = _options$delay === undefined ? 300 : _options$delay,
			    bucket = options.bucket;
	
	
			lscache.setBucket(bucket);
	
			var key = $.param(params) + '-' + storage;
			var data = lscache.get(key);
	
			if (data) return new Promise(function (resolve) {
				return $timeout(function () {
					return resolve(data);
				}, delay);
			});
	
			return service(params).$promise.then(function (response) {
				if (response.status) {
					response.key = key;
					lscache.set(key, response, time);
				}
	
				return response;
			});
		};
	
		return {
			checkStructureInputsRequire: this.checkStructureInputsRequire,
			getParam: this.getParam,
			chunkData: this.chunkData,
			defineStructure: this.defineStructure,
			definePanel: this.definePanel,
			getItemForModel: this.getItemForModel,
			organizeElements: this.organizeElements,
			saveChanges: this.saveChanges,
			validateRequiredInputs: this.validateRequiredInputs,
			getListByConcept: this.getListByConcept,
			consoleLog: this.consoleLog,
			checkCode: this.checkCode,
			guid: this.guid,
			getGridConfig: this.getGridConfig,
			getFieldData: this.getFieldData,
			findFunction: this.findFunction,
			// mathjs                                  : this.mathjs, 
			getRandomClassColor: this.getRandomClassColor,
			getHeaderCellTemplate: this.getHeaderCellTemplate,
			getTitle: this.getTitle,
			getWeekDays: this.getWeekDays,
			prepareCourseList: this.prepareCourseList,
			prepareSectionList: this.prepareSectionList,
			filterInObject: this.filterInObject,
			getFileIcon: this.getFileIcon,
			callService: this.callService,
			chunk: this.chunk,
			alert: this.alert,
			timeToMinutesPerc: this.timeToMinutesPerc,
			getPercentageArray: this.getPercentageArray,
			getHoursList: this.getHoursList,
			updateInputDataFromModel: this.updateInputDataFromModel,
			getOccurrenceTitle: this.getOccurrenceTitle,
			getItemTitle: this.getItemTitle,
			getFormattedStudentName: this.getFormattedStudentName,
			getReportColums: this.getReportColums,
			validateUniqueFieldOnEvaluationStructure: this.validateUniqueFieldOnEvaluationStructure,
			findEvaluationStructure: this.findEvaluationStructure,
			download: this.download,
			getUserStored: this.getUserStored,
			getShortName: this.getShortName,
			cacheService: this.cacheService,
			cacheServiceFlush: this.cacheServiceFlush,
			base64: this.base64
		};
	};
	
	Helpers.$inject = ['SERVICE_URL_CONSTANT', '$filter', '$http', 'ngNotify', '$mdDialog', 'LOCAL_ENV_CONSTANT', '$cookies', '$localStorage', 'moment', '$timeout'];
	
	exports.default = angular.module('services.Helpers', []).service('Helpers', Helpers).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149), __webpack_require__(415).Buffer))

/***/ }),
/* 1185 */
307,
/* 1186 */
/***/ (function(module, exports) {

	module.exports = {"textColor":{"gray":"text-gris-dark","blue":"text-azul","red":"text-rojo-important","green":"text-verde","white":"text-color-w","black":"text-negro-darker","yellow":"text-amarillo","orange":"text-naranja","cian":"text-cian"},"backgroundColor":{"purple":"bg-review","naranja":"naranjo","inactivo":"bg-grey"},"icons":{"thumbsUp":"mdi-action-thumb-up","thumbsDown":"mdi-action-thumb-down","eye":"mdi-action-visibility","arrowUp":"mdi-hardware-keyboard-arrow-down","arrowDown":"mdi-hardware-keyboard-arrow-up","map":"mdi-maps-rate-review","search":"mdi-action-search","edit":"mdi-content-create","important":"mdi-av-new-releases","add":"mdi-content-add","feedback":"fa fa-pencil-square-o"}}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1188);

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery UI - v1.12.1 - 2016-09-14
	* http://jqueryui.com
	* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
	* Copyright jQuery Foundation and other contributors; Licensed MIT */
	
	(function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(149) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}(function( $ ) {
	
	$.ui = $.ui || {};
	
	var version = $.ui.version = "1.12.1";
	
	
	/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
	
				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var instance = $.data( this, fullName );
	
						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}
	
						if ( !instance ) {
							return $.error( "cannot call methods on " + name +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}
	
						if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for " + name +
								" widget instance" );
						}
	
						methodValue = instance[ options ].apply( instance, args );
	
						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			this._on( options.element, {
				"remove": "_untrackClassesElement"
			} );
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_untrackClassesElement: function( event ) {
			var that = this;
			$.each( that.classesElementLookup, function( key, value ) {
				if ( $.inArray( event.target, value ) !== -1 ) {
					that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
				}
			} );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	var widget = $.widget;
	
	
	/*!
	 * jQuery UI Position 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/position/
	 */
	
	//>>label: Position
	//>>group: Core
	//>>description: Positions elements relative to other elements.
	//>>docs: http://api.jqueryui.com/position/
	//>>demos: http://jqueryui.com/position/
	
	
	( function() {
	var cachedScrollbarWidth,
		max = Math.max,
		abs = Math.abs,
		rhorizontal = /left|center|right/,
		rvertical = /top|center|bottom/,
		roffset = /[\+\-]\d+(\.[\d]+)?%?/,
		rposition = /^\w+/,
		rpercent = /%$/,
		_position = $.fn.position;
	
	function getOffsets( offsets, width, height ) {
		return [
			parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
			parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
		];
	}
	
	function parseCss( element, property ) {
		return parseInt( $.css( element, property ), 10 ) || 0;
	}
	
	function getDimensions( elem ) {
		var raw = elem[ 0 ];
		if ( raw.nodeType === 9 ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: 0, left: 0 }
			};
		}
		if ( $.isWindow( raw ) ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
			};
		}
		if ( raw.preventDefault ) {
			return {
				width: 0,
				height: 0,
				offset: { top: raw.pageY, left: raw.pageX }
			};
		}
		return {
			width: elem.outerWidth(),
			height: elem.outerHeight(),
			offset: elem.offset()
		};
	}
	
	$.position = {
		scrollbarWidth: function() {
			if ( cachedScrollbarWidth !== undefined ) {
				return cachedScrollbarWidth;
			}
			var w1, w2,
				div = $( "<div " +
					"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
					"<div style='height:100px;width:auto;'></div></div>" ),
				innerDiv = div.children()[ 0 ];
	
			$( "body" ).append( div );
			w1 = innerDiv.offsetWidth;
			div.css( "overflow", "scroll" );
	
			w2 = innerDiv.offsetWidth;
	
			if ( w1 === w2 ) {
				w2 = div[ 0 ].clientWidth;
			}
	
			div.remove();
	
			return ( cachedScrollbarWidth = w1 - w2 );
		},
		getScrollInfo: function( within ) {
			var overflowX = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-x" ),
				overflowY = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-y" ),
				hasOverflowX = overflowX === "scroll" ||
					( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
				hasOverflowY = overflowY === "scroll" ||
					( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
			return {
				width: hasOverflowY ? $.position.scrollbarWidth() : 0,
				height: hasOverflowX ? $.position.scrollbarWidth() : 0
			};
		},
		getWithinInfo: function( element ) {
			var withinElement = $( element || window ),
				isWindow = $.isWindow( withinElement[ 0 ] ),
				isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
				hasOffset = !isWindow && !isDocument;
			return {
				element: withinElement,
				isWindow: isWindow,
				isDocument: isDocument,
				offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
				scrollLeft: withinElement.scrollLeft(),
				scrollTop: withinElement.scrollTop(),
				width: withinElement.outerWidth(),
				height: withinElement.outerHeight()
			};
		}
	};
	
	$.fn.position = function( options ) {
		if ( !options || !options.of ) {
			return _position.apply( this, arguments );
		}
	
		// Make a copy, we don't want to modify arguments
		options = $.extend( {}, options );
	
		var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
			target = $( options.of ),
			within = $.position.getWithinInfo( options.within ),
			scrollInfo = $.position.getScrollInfo( within ),
			collision = ( options.collision || "flip" ).split( " " ),
			offsets = {};
	
		dimensions = getDimensions( target );
		if ( target[ 0 ].preventDefault ) {
	
			// Force left top to allow flipping
			options.at = "left top";
		}
		targetWidth = dimensions.width;
		targetHeight = dimensions.height;
		targetOffset = dimensions.offset;
	
		// Clone to reuse original targetOffset later
		basePosition = $.extend( {}, targetOffset );
	
		// Force my and at to have valid horizontal and vertical positions
		// if a value is missing or invalid, it will be converted to center
		$.each( [ "my", "at" ], function() {
			var pos = ( options[ this ] || "" ).split( " " ),
				horizontalOffset,
				verticalOffset;
	
			if ( pos.length === 1 ) {
				pos = rhorizontal.test( pos[ 0 ] ) ?
					pos.concat( [ "center" ] ) :
					rvertical.test( pos[ 0 ] ) ?
						[ "center" ].concat( pos ) :
						[ "center", "center" ];
			}
			pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
			pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";
	
			// Calculate offsets
			horizontalOffset = roffset.exec( pos[ 0 ] );
			verticalOffset = roffset.exec( pos[ 1 ] );
			offsets[ this ] = [
				horizontalOffset ? horizontalOffset[ 0 ] : 0,
				verticalOffset ? verticalOffset[ 0 ] : 0
			];
	
			// Reduce to just the positions without the offsets
			options[ this ] = [
				rposition.exec( pos[ 0 ] )[ 0 ],
				rposition.exec( pos[ 1 ] )[ 0 ]
			];
		} );
	
		// Normalize collision option
		if ( collision.length === 1 ) {
			collision[ 1 ] = collision[ 0 ];
		}
	
		if ( options.at[ 0 ] === "right" ) {
			basePosition.left += targetWidth;
		} else if ( options.at[ 0 ] === "center" ) {
			basePosition.left += targetWidth / 2;
		}
	
		if ( options.at[ 1 ] === "bottom" ) {
			basePosition.top += targetHeight;
		} else if ( options.at[ 1 ] === "center" ) {
			basePosition.top += targetHeight / 2;
		}
	
		atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
		basePosition.left += atOffset[ 0 ];
		basePosition.top += atOffset[ 1 ];
	
		return this.each( function() {
			var collisionPosition, using,
				elem = $( this ),
				elemWidth = elem.outerWidth(),
				elemHeight = elem.outerHeight(),
				marginLeft = parseCss( this, "marginLeft" ),
				marginTop = parseCss( this, "marginTop" ),
				collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
					scrollInfo.width,
				collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
					scrollInfo.height,
				position = $.extend( {}, basePosition ),
				myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );
	
			if ( options.my[ 0 ] === "right" ) {
				position.left -= elemWidth;
			} else if ( options.my[ 0 ] === "center" ) {
				position.left -= elemWidth / 2;
			}
	
			if ( options.my[ 1 ] === "bottom" ) {
				position.top -= elemHeight;
			} else if ( options.my[ 1 ] === "center" ) {
				position.top -= elemHeight / 2;
			}
	
			position.left += myOffset[ 0 ];
			position.top += myOffset[ 1 ];
	
			collisionPosition = {
				marginLeft: marginLeft,
				marginTop: marginTop
			};
	
			$.each( [ "left", "top" ], function( i, dir ) {
				if ( $.ui.position[ collision[ i ] ] ) {
					$.ui.position[ collision[ i ] ][ dir ]( position, {
						targetWidth: targetWidth,
						targetHeight: targetHeight,
						elemWidth: elemWidth,
						elemHeight: elemHeight,
						collisionPosition: collisionPosition,
						collisionWidth: collisionWidth,
						collisionHeight: collisionHeight,
						offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
						my: options.my,
						at: options.at,
						within: within,
						elem: elem
					} );
				}
			} );
	
			if ( options.using ) {
	
				// Adds feedback as second argument to using callback, if present
				using = function( props ) {
					var left = targetOffset.left - position.left,
						right = left + targetWidth - elemWidth,
						top = targetOffset.top - position.top,
						bottom = top + targetHeight - elemHeight,
						feedback = {
							target: {
								element: target,
								left: targetOffset.left,
								top: targetOffset.top,
								width: targetWidth,
								height: targetHeight
							},
							element: {
								element: elem,
								left: position.left,
								top: position.top,
								width: elemWidth,
								height: elemHeight
							},
							horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
							vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
						};
					if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
						feedback.horizontal = "center";
					}
					if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
						feedback.vertical = "middle";
					}
					if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
						feedback.important = "horizontal";
					} else {
						feedback.important = "vertical";
					}
					options.using.call( this, props, feedback );
				};
			}
	
			elem.offset( $.extend( position, { using: using } ) );
		} );
	};
	
	$.ui.position = {
		fit: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
					outerWidth = within.width,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = withinOffset - collisionPosLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
					newOverRight;
	
				// Element is wider than within
				if ( data.collisionWidth > outerWidth ) {
	
					// Element is initially over the left side of within
					if ( overLeft > 0 && overRight <= 0 ) {
						newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
							withinOffset;
						position.left += overLeft - newOverRight;
	
					// Element is initially over right side of within
					} else if ( overRight > 0 && overLeft <= 0 ) {
						position.left = withinOffset;
	
					// Element is initially over both left and right sides of within
					} else {
						if ( overLeft > overRight ) {
							position.left = withinOffset + outerWidth - data.collisionWidth;
						} else {
							position.left = withinOffset;
						}
					}
	
				// Too far left -> align with left edge
				} else if ( overLeft > 0 ) {
					position.left += overLeft;
	
				// Too far right -> align with right edge
				} else if ( overRight > 0 ) {
					position.left -= overRight;
	
				// Adjust based on position and margin
				} else {
					position.left = max( position.left - collisionPosLeft, position.left );
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
					outerHeight = data.within.height,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = withinOffset - collisionPosTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
					newOverBottom;
	
				// Element is taller than within
				if ( data.collisionHeight > outerHeight ) {
	
					// Element is initially over the top of within
					if ( overTop > 0 && overBottom <= 0 ) {
						newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
							withinOffset;
						position.top += overTop - newOverBottom;
	
					// Element is initially over bottom of within
					} else if ( overBottom > 0 && overTop <= 0 ) {
						position.top = withinOffset;
	
					// Element is initially over both top and bottom of within
					} else {
						if ( overTop > overBottom ) {
							position.top = withinOffset + outerHeight - data.collisionHeight;
						} else {
							position.top = withinOffset;
						}
					}
	
				// Too far up -> align with top
				} else if ( overTop > 0 ) {
					position.top += overTop;
	
				// Too far down -> align with bottom edge
				} else if ( overBottom > 0 ) {
					position.top -= overBottom;
	
				// Adjust based on position and margin
				} else {
					position.top = max( position.top - collisionPosTop, position.top );
				}
			}
		},
		flip: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.left + within.scrollLeft,
					outerWidth = within.width,
					offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = collisionPosLeft - offsetLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
					myOffset = data.my[ 0 ] === "left" ?
						-data.elemWidth :
						data.my[ 0 ] === "right" ?
							data.elemWidth :
							0,
					atOffset = data.at[ 0 ] === "left" ?
						data.targetWidth :
						data.at[ 0 ] === "right" ?
							-data.targetWidth :
							0,
					offset = -2 * data.offset[ 0 ],
					newOverRight,
					newOverLeft;
	
				if ( overLeft < 0 ) {
					newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
						outerWidth - withinOffset;
					if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
						position.left += myOffset + atOffset + offset;
					}
				} else if ( overRight > 0 ) {
					newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
						atOffset + offset - offsetLeft;
					if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
						position.left += myOffset + atOffset + offset;
					}
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.top + within.scrollTop,
					outerHeight = within.height,
					offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = collisionPosTop - offsetTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
					top = data.my[ 1 ] === "top",
					myOffset = top ?
						-data.elemHeight :
						data.my[ 1 ] === "bottom" ?
							data.elemHeight :
							0,
					atOffset = data.at[ 1 ] === "top" ?
						data.targetHeight :
						data.at[ 1 ] === "bottom" ?
							-data.targetHeight :
							0,
					offset = -2 * data.offset[ 1 ],
					newOverTop,
					newOverBottom;
				if ( overTop < 0 ) {
					newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
						outerHeight - withinOffset;
					if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
						position.top += myOffset + atOffset + offset;
					}
				} else if ( overBottom > 0 ) {
					newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
						offset - offsetTop;
					if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
						position.top += myOffset + atOffset + offset;
					}
				}
			}
		},
		flipfit: {
			left: function() {
				$.ui.position.flip.left.apply( this, arguments );
				$.ui.position.fit.left.apply( this, arguments );
			},
			top: function() {
				$.ui.position.flip.top.apply( this, arguments );
				$.ui.position.fit.top.apply( this, arguments );
			}
		}
	};
	
	} )();
	
	var position = $.ui.position;
	
	
	/*!
	 * jQuery UI :data 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :data Selector
	//>>group: Core
	//>>description: Selects elements which have data stored under the specified key.
	//>>docs: http://api.jqueryui.com/data-selector/
	
	
	var data = $.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo( function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			} ) :
	
			// Support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			}
	} );
	
	/*!
	 * jQuery UI Disable Selection 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: disableSelection
	//>>group: Core
	//>>description: Disable selection of text content within the set of matched elements.
	//>>docs: http://api.jqueryui.com/disableSelection/
	
	// This file is deprecated
	
	
	var disableSelection = $.fn.extend( {
		disableSelection: ( function() {
			var eventType = "onselectstart" in document.createElement( "div" ) ?
				"selectstart" :
				"mousedown";
	
			return function() {
				return this.on( eventType + ".ui-disableSelection", function( event ) {
					event.preventDefault();
				} );
			};
		} )(),
	
		enableSelection: function() {
			return this.off( ".ui-disableSelection" );
		}
	} );
	
	
	/*!
	 * jQuery UI Effects 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Effects Core
	//>>group: Effects
	// jscs:disable maximumLineLength
	//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/category/effects-core/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var dataSpace = "ui-effects-",
		dataSpaceStyle = "ui-effects-style",
		dataSpaceAnimated = "ui-effects-animated",
	
		// Create a local jQuery because jQuery Color relies on it and the
		// global may not exist with AMD and a custom build (#10199)
		jQuery = $;
	
	$.effects = {
		effect: {}
	};
	
	/*!
	 * jQuery Color Animations v2.1.2
	 * https://github.com/jquery/jquery-color
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * Date: Wed Jan 16 08:47:09 2013 -0600
	 */
	( function( jQuery, undefined ) {
	
		var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
			"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
	
		// Plusequals test for += 100 -= 100
		rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,
	
		// A set of RE's that can match strings and generate color tuples.
		stringParsers = [ {
				re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ],
						execResult[ 3 ],
						execResult[ 4 ]
					];
				}
			}, {
				re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ] * 2.55,
						execResult[ 2 ] * 2.55,
						execResult[ 3 ] * 2.55,
						execResult[ 4 ]
					];
				}
			}, {
	
				// This regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ], 16 )
					];
				}
			}, {
	
				// This regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
					];
				}
			}, {
				re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				space: "hsla",
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ] / 100,
						execResult[ 3 ] / 100,
						execResult[ 4 ]
					];
				}
			} ],
	
		// JQuery.Color( )
		color = jQuery.Color = function( color, green, blue, alpha ) {
			return new jQuery.Color.fn.parse( color, green, blue, alpha );
		},
		spaces = {
			rgba: {
				props: {
					red: {
						idx: 0,
						type: "byte"
					},
					green: {
						idx: 1,
						type: "byte"
					},
					blue: {
						idx: 2,
						type: "byte"
					}
				}
			},
	
			hsla: {
				props: {
					hue: {
						idx: 0,
						type: "degrees"
					},
					saturation: {
						idx: 1,
						type: "percent"
					},
					lightness: {
						idx: 2,
						type: "percent"
					}
				}
			}
		},
		propTypes = {
			"byte": {
				floor: true,
				max: 255
			},
			"percent": {
				max: 1
			},
			"degrees": {
				mod: 360,
				floor: true
			}
		},
		support = color.support = {},
	
		// Element for support tests
		supportElem = jQuery( "<p>" )[ 0 ],
	
		// Colors = jQuery.Color.names
		colors,
	
		// Local aliases of functions called often
		each = jQuery.each;
	
	// Determine rgba support immediately
	supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
	support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;
	
	// Define cache name and alpha properties
	// for rgba and hsla spaces
	each( spaces, function( spaceName, space ) {
		space.cache = "_" + spaceName;
		space.props.alpha = {
			idx: 3,
			type: "percent",
			def: 1
		};
	} );
	
	function clamp( value, prop, allowEmpty ) {
		var type = propTypes[ prop.type ] || {};
	
		if ( value == null ) {
			return ( allowEmpty || !prop.def ) ? null : prop.def;
		}
	
		// ~~ is an short way of doing floor for positive numbers
		value = type.floor ? ~~value : parseFloat( value );
	
		// IE will pass in empty strings as value for alpha,
		// which will hit this case
		if ( isNaN( value ) ) {
			return prop.def;
		}
	
		if ( type.mod ) {
	
			// We add mod before modding to make sure that negatives values
			// get converted properly: -10 -> 350
			return ( value + type.mod ) % type.mod;
		}
	
		// For now all property types without mod have min and max
		return 0 > value ? 0 : type.max < value ? type.max : value;
	}
	
	function stringParse( string ) {
		var inst = color(),
			rgba = inst._rgba = [];
	
		string = string.toLowerCase();
	
		each( stringParsers, function( i, parser ) {
			var parsed,
				match = parser.re.exec( string ),
				values = match && parser.parse( match ),
				spaceName = parser.space || "rgba";
	
			if ( values ) {
				parsed = inst[ spaceName ]( values );
	
				// If this was an rgba parse the assignment might happen twice
				// oh well....
				inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
				rgba = inst._rgba = parsed._rgba;
	
				// Exit each( stringParsers ) here because we matched
				return false;
			}
		} );
	
		// Found a stringParser that handled it
		if ( rgba.length ) {
	
			// If this came from a parsed string, force "transparent" when alpha is 0
			// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
			if ( rgba.join() === "0,0,0,0" ) {
				jQuery.extend( rgba, colors.transparent );
			}
			return inst;
		}
	
		// Named colors
		return colors[ string ];
	}
	
	color.fn = jQuery.extend( color.prototype, {
		parse: function( red, green, blue, alpha ) {
			if ( red === undefined ) {
				this._rgba = [ null, null, null, null ];
				return this;
			}
			if ( red.jquery || red.nodeType ) {
				red = jQuery( red ).css( green );
				green = undefined;
			}
	
			var inst = this,
				type = jQuery.type( red ),
				rgba = this._rgba = [];
	
			// More than 1 argument specified - assume ( red, green, blue, alpha )
			if ( green !== undefined ) {
				red = [ red, green, blue, alpha ];
				type = "array";
			}
	
			if ( type === "string" ) {
				return this.parse( stringParse( red ) || colors._default );
			}
	
			if ( type === "array" ) {
				each( spaces.rgba.props, function( key, prop ) {
					rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
				} );
				return this;
			}
	
			if ( type === "object" ) {
				if ( red instanceof color ) {
					each( spaces, function( spaceName, space ) {
						if ( red[ space.cache ] ) {
							inst[ space.cache ] = red[ space.cache ].slice();
						}
					} );
				} else {
					each( spaces, function( spaceName, space ) {
						var cache = space.cache;
						each( space.props, function( key, prop ) {
	
							// If the cache doesn't exist, and we know how to convert
							if ( !inst[ cache ] && space.to ) {
	
								// If the value was null, we don't need to copy it
								// if the key was alpha, we don't need to copy it either
								if ( key === "alpha" || red[ key ] == null ) {
									return;
								}
								inst[ cache ] = space.to( inst._rgba );
							}
	
							// This is the only case where we allow nulls for ALL properties.
							// call clamp with alwaysAllowEmpty
							inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
						} );
	
						// Everything defined but alpha?
						if ( inst[ cache ] &&
								jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {
	
							// Use the default of 1
							inst[ cache ][ 3 ] = 1;
							if ( space.from ) {
								inst._rgba = space.from( inst[ cache ] );
							}
						}
					} );
				}
				return this;
			}
		},
		is: function( compare ) {
			var is = color( compare ),
				same = true,
				inst = this;
	
			each( spaces, function( _, space ) {
				var localCache,
					isCache = is[ space.cache ];
				if ( isCache ) {
					localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
					each( space.props, function( _, prop ) {
						if ( isCache[ prop.idx ] != null ) {
							same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
							return same;
						}
					} );
				}
				return same;
			} );
			return same;
		},
		_space: function() {
			var used = [],
				inst = this;
			each( spaces, function( spaceName, space ) {
				if ( inst[ space.cache ] ) {
					used.push( spaceName );
				}
			} );
			return used.pop();
		},
		transition: function( other, distance ) {
			var end = color( other ),
				spaceName = end._space(),
				space = spaces[ spaceName ],
				startColor = this.alpha() === 0 ? color( "transparent" ) : this,
				start = startColor[ space.cache ] || space.to( startColor._rgba ),
				result = start.slice();
	
			end = end[ space.cache ];
			each( space.props, function( key, prop ) {
				var index = prop.idx,
					startValue = start[ index ],
					endValue = end[ index ],
					type = propTypes[ prop.type ] || {};
	
				// If null, don't override start value
				if ( endValue === null ) {
					return;
				}
	
				// If null - use end
				if ( startValue === null ) {
					result[ index ] = endValue;
				} else {
					if ( type.mod ) {
						if ( endValue - startValue > type.mod / 2 ) {
							startValue += type.mod;
						} else if ( startValue - endValue > type.mod / 2 ) {
							startValue -= type.mod;
						}
					}
					result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
				}
			} );
			return this[ spaceName ]( result );
		},
		blend: function( opaque ) {
	
			// If we are already opaque - return ourself
			if ( this._rgba[ 3 ] === 1 ) {
				return this;
			}
	
			var rgb = this._rgba.slice(),
				a = rgb.pop(),
				blend = color( opaque )._rgba;
	
			return color( jQuery.map( rgb, function( v, i ) {
				return ( 1 - a ) * blend[ i ] + a * v;
			} ) );
		},
		toRgbaString: function() {
			var prefix = "rgba(",
				rgba = jQuery.map( this._rgba, function( v, i ) {
					return v == null ? ( i > 2 ? 1 : 0 ) : v;
				} );
	
			if ( rgba[ 3 ] === 1 ) {
				rgba.pop();
				prefix = "rgb(";
			}
	
			return prefix + rgba.join() + ")";
		},
		toHslaString: function() {
			var prefix = "hsla(",
				hsla = jQuery.map( this.hsla(), function( v, i ) {
					if ( v == null ) {
						v = i > 2 ? 1 : 0;
					}
	
					// Catch 1 and 2
					if ( i && i < 3 ) {
						v = Math.round( v * 100 ) + "%";
					}
					return v;
				} );
	
			if ( hsla[ 3 ] === 1 ) {
				hsla.pop();
				prefix = "hsl(";
			}
			return prefix + hsla.join() + ")";
		},
		toHexString: function( includeAlpha ) {
			var rgba = this._rgba.slice(),
				alpha = rgba.pop();
	
			if ( includeAlpha ) {
				rgba.push( ~~( alpha * 255 ) );
			}
	
			return "#" + jQuery.map( rgba, function( v ) {
	
				// Default to 0 when nulls exist
				v = ( v || 0 ).toString( 16 );
				return v.length === 1 ? "0" + v : v;
			} ).join( "" );
		},
		toString: function() {
			return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
		}
	} );
	color.fn.parse.prototype = color.fn;
	
	// Hsla conversions adapted from:
	// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021
	
	function hue2rgb( p, q, h ) {
		h = ( h + 1 ) % 1;
		if ( h * 6 < 1 ) {
			return p + ( q - p ) * h * 6;
		}
		if ( h * 2 < 1 ) {
			return q;
		}
		if ( h * 3 < 2 ) {
			return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
		}
		return p;
	}
	
	spaces.hsla.to = function( rgba ) {
		if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
			return [ null, null, null, rgba[ 3 ] ];
		}
		var r = rgba[ 0 ] / 255,
			g = rgba[ 1 ] / 255,
			b = rgba[ 2 ] / 255,
			a = rgba[ 3 ],
			max = Math.max( r, g, b ),
			min = Math.min( r, g, b ),
			diff = max - min,
			add = max + min,
			l = add * 0.5,
			h, s;
	
		if ( min === max ) {
			h = 0;
		} else if ( r === max ) {
			h = ( 60 * ( g - b ) / diff ) + 360;
		} else if ( g === max ) {
			h = ( 60 * ( b - r ) / diff ) + 120;
		} else {
			h = ( 60 * ( r - g ) / diff ) + 240;
		}
	
		// Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
		// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
		if ( diff === 0 ) {
			s = 0;
		} else if ( l <= 0.5 ) {
			s = diff / add;
		} else {
			s = diff / ( 2 - add );
		}
		return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
	};
	
	spaces.hsla.from = function( hsla ) {
		if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
			return [ null, null, null, hsla[ 3 ] ];
		}
		var h = hsla[ 0 ] / 360,
			s = hsla[ 1 ],
			l = hsla[ 2 ],
			a = hsla[ 3 ],
			q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
			p = 2 * l - q;
	
		return [
			Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
			Math.round( hue2rgb( p, q, h ) * 255 ),
			Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
			a
		];
	};
	
	each( spaces, function( spaceName, space ) {
		var props = space.props,
			cache = space.cache,
			to = space.to,
			from = space.from;
	
		// Makes rgba() and hsla()
		color.fn[ spaceName ] = function( value ) {
	
			// Generate a cache for this space if it doesn't exist
			if ( to && !this[ cache ] ) {
				this[ cache ] = to( this._rgba );
			}
			if ( value === undefined ) {
				return this[ cache ].slice();
			}
	
			var ret,
				type = jQuery.type( value ),
				arr = ( type === "array" || type === "object" ) ? value : arguments,
				local = this[ cache ].slice();
	
			each( props, function( key, prop ) {
				var val = arr[ type === "object" ? key : prop.idx ];
				if ( val == null ) {
					val = local[ prop.idx ];
				}
				local[ prop.idx ] = clamp( val, prop );
			} );
	
			if ( from ) {
				ret = color( from( local ) );
				ret[ cache ] = local;
				return ret;
			} else {
				return color( local );
			}
		};
	
		// Makes red() green() blue() alpha() hue() saturation() lightness()
		each( props, function( key, prop ) {
	
			// Alpha is included in more than one space
			if ( color.fn[ key ] ) {
				return;
			}
			color.fn[ key ] = function( value ) {
				var vtype = jQuery.type( value ),
					fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
					local = this[ fn ](),
					cur = local[ prop.idx ],
					match;
	
				if ( vtype === "undefined" ) {
					return cur;
				}
	
				if ( vtype === "function" ) {
					value = value.call( this, cur );
					vtype = jQuery.type( value );
				}
				if ( value == null && prop.empty ) {
					return this;
				}
				if ( vtype === "string" ) {
					match = rplusequals.exec( value );
					if ( match ) {
						value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
					}
				}
				local[ prop.idx ] = value;
				return this[ fn ]( local );
			};
		} );
	} );
	
	// Add cssHook and .fx.step function for each named hook.
	// accept a space separated string of properties
	color.hook = function( hook ) {
		var hooks = hook.split( " " );
		each( hooks, function( i, hook ) {
			jQuery.cssHooks[ hook ] = {
				set: function( elem, value ) {
					var parsed, curElem,
						backgroundColor = "";
	
					if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
							( parsed = stringParse( value ) ) ) ) {
						value = color( parsed || value );
						if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
							curElem = hook === "backgroundColor" ? elem.parentNode : elem;
							while (
								( backgroundColor === "" || backgroundColor === "transparent" ) &&
								curElem && curElem.style
							) {
								try {
									backgroundColor = jQuery.css( curElem, "backgroundColor" );
									curElem = curElem.parentNode;
								} catch ( e ) {
								}
							}
	
							value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
								backgroundColor :
								"_default" );
						}
	
						value = value.toRgbaString();
					}
					try {
						elem.style[ hook ] = value;
					} catch ( e ) {
	
						// Wrapped to prevent IE from throwing errors on "invalid" values like
						// 'auto' or 'inherit'
					}
				}
			};
			jQuery.fx.step[ hook ] = function( fx ) {
				if ( !fx.colorInit ) {
					fx.start = color( fx.elem, hook );
					fx.end = color( fx.end );
					fx.colorInit = true;
				}
				jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
			};
		} );
	
	};
	
	color.hook( stepHooks );
	
	jQuery.cssHooks.borderColor = {
		expand: function( value ) {
			var expanded = {};
	
			each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
				expanded[ "border" + part + "Color" ] = value;
			} );
			return expanded;
		}
	};
	
	// Basic color names only.
	// Usage of any of the other color names requires adding yourself or including
	// jquery.color.svg-names.js.
	colors = jQuery.Color.names = {
	
		// 4.1. Basic color keywords
		aqua: "#00ffff",
		black: "#000000",
		blue: "#0000ff",
		fuchsia: "#ff00ff",
		gray: "#808080",
		green: "#008000",
		lime: "#00ff00",
		maroon: "#800000",
		navy: "#000080",
		olive: "#808000",
		purple: "#800080",
		red: "#ff0000",
		silver: "#c0c0c0",
		teal: "#008080",
		white: "#ffffff",
		yellow: "#ffff00",
	
		// 4.2.3. "transparent" color keyword
		transparent: [ null, null, null, 0 ],
	
		_default: "#ffffff"
	};
	
	} )( jQuery );
	
	/******************************************************************************/
	/****************************** CLASS ANIMATIONS ******************************/
	/******************************************************************************/
	( function() {
	
	var classAnimationActions = [ "add", "remove", "toggle" ],
		shorthandStyles = {
			border: 1,
			borderBottom: 1,
			borderColor: 1,
			borderLeft: 1,
			borderRight: 1,
			borderTop: 1,
			borderWidth: 1,
			margin: 1,
			padding: 1
		};
	
	$.each(
		[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
		function( _, prop ) {
			$.fx.step[ prop ] = function( fx ) {
				if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
					jQuery.style( fx.elem, prop, fx.end );
					fx.setAttr = true;
				}
			};
		}
	);
	
	function getElementStyles( elem ) {
		var key, len,
			style = elem.ownerDocument.defaultView ?
				elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
				elem.currentStyle,
			styles = {};
	
		if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
			len = style.length;
			while ( len-- ) {
				key = style[ len ];
				if ( typeof style[ key ] === "string" ) {
					styles[ $.camelCase( key ) ] = style[ key ];
				}
			}
	
		// Support: Opera, IE <9
		} else {
			for ( key in style ) {
				if ( typeof style[ key ] === "string" ) {
					styles[ key ] = style[ key ];
				}
			}
		}
	
		return styles;
	}
	
	function styleDifference( oldStyle, newStyle ) {
		var diff = {},
			name, value;
	
		for ( name in newStyle ) {
			value = newStyle[ name ];
			if ( oldStyle[ name ] !== value ) {
				if ( !shorthandStyles[ name ] ) {
					if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
						diff[ name ] = value;
					}
				}
			}
		}
	
		return diff;
	}
	
	// Support: jQuery <1.8
	if ( !$.fn.addBack ) {
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	$.effects.animateClass = function( value, duration, easing, callback ) {
		var o = $.speed( duration, easing, callback );
	
		return this.queue( function() {
			var animated = $( this ),
				baseClass = animated.attr( "class" ) || "",
				applyClassChange,
				allAnimations = o.children ? animated.find( "*" ).addBack() : animated;
	
			// Map the animated objects to store the original styles.
			allAnimations = allAnimations.map( function() {
				var el = $( this );
				return {
					el: el,
					start: getElementStyles( this )
				};
			} );
	
			// Apply class change
			applyClassChange = function() {
				$.each( classAnimationActions, function( i, action ) {
					if ( value[ action ] ) {
						animated[ action + "Class" ]( value[ action ] );
					}
				} );
			};
			applyClassChange();
	
			// Map all animated objects again - calculate new styles and diff
			allAnimations = allAnimations.map( function() {
				this.end = getElementStyles( this.el[ 0 ] );
				this.diff = styleDifference( this.start, this.end );
				return this;
			} );
	
			// Apply original class
			animated.attr( "class", baseClass );
	
			// Map all animated objects again - this time collecting a promise
			allAnimations = allAnimations.map( function() {
				var styleInfo = this,
					dfd = $.Deferred(),
					opts = $.extend( {}, o, {
						queue: false,
						complete: function() {
							dfd.resolve( styleInfo );
						}
					} );
	
				this.el.animate( this.diff, opts );
				return dfd.promise();
			} );
	
			// Once all animations have completed:
			$.when.apply( $, allAnimations.get() ).done( function() {
	
				// Set the final class
				applyClassChange();
	
				// For each animated element,
				// clear all css properties that were animated
				$.each( arguments, function() {
					var el = this.el;
					$.each( this.diff, function( key ) {
						el.css( key, "" );
					} );
				} );
	
				// This is guarnteed to be there if you use jQuery.speed()
				// it also handles dequeuing the next anim...
				o.complete.call( animated[ 0 ] );
			} );
		} );
	};
	
	$.fn.extend( {
		addClass: ( function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return speed ?
					$.effects.animateClass.call( this,
						{ add: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		} )( $.fn.addClass ),
	
		removeClass: ( function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return arguments.length > 1 ?
					$.effects.animateClass.call( this,
						{ remove: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		} )( $.fn.removeClass ),
	
		toggleClass: ( function( orig ) {
			return function( classNames, force, speed, easing, callback ) {
				if ( typeof force === "boolean" || force === undefined ) {
					if ( !speed ) {
	
						// Without speed parameter
						return orig.apply( this, arguments );
					} else {
						return $.effects.animateClass.call( this,
							( force ? { add: classNames } : { remove: classNames } ),
							speed, easing, callback );
					}
				} else {
	
					// Without force parameter
					return $.effects.animateClass.call( this,
						{ toggle: classNames }, force, speed, easing );
				}
			};
		} )( $.fn.toggleClass ),
	
		switchClass: function( remove, add, speed, easing, callback ) {
			return $.effects.animateClass.call( this, {
				add: add,
				remove: remove
			}, speed, easing, callback );
		}
	} );
	
	} )();
	
	/******************************************************************************/
	/*********************************** EFFECTS **********************************/
	/******************************************************************************/
	
	( function() {
	
	if ( $.expr && $.expr.filters && $.expr.filters.animated ) {
		$.expr.filters.animated = ( function( orig ) {
			return function( elem ) {
				return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
			};
		} )( $.expr.filters.animated );
	}
	
	if ( $.uiBackCompat !== false ) {
		$.extend( $.effects, {
	
			// Saves a set of properties in a data storage
			save: function( element, set ) {
				var i = 0, length = set.length;
				for ( ; i < length; i++ ) {
					if ( set[ i ] !== null ) {
						element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
					}
				}
			},
	
			// Restores a set of previously saved properties from a data storage
			restore: function( element, set ) {
				var val, i = 0, length = set.length;
				for ( ; i < length; i++ ) {
					if ( set[ i ] !== null ) {
						val = element.data( dataSpace + set[ i ] );
						element.css( set[ i ], val );
					}
				}
			},
	
			setMode: function( el, mode ) {
				if ( mode === "toggle" ) {
					mode = el.is( ":hidden" ) ? "show" : "hide";
				}
				return mode;
			},
	
			// Wraps the element around a wrapper that copies position properties
			createWrapper: function( element ) {
	
				// If the element is already wrapped, return it
				if ( element.parent().is( ".ui-effects-wrapper" ) ) {
					return element.parent();
				}
	
				// Wrap the element
				var props = {
						width: element.outerWidth( true ),
						height: element.outerHeight( true ),
						"float": element.css( "float" )
					},
					wrapper = $( "<div></div>" )
						.addClass( "ui-effects-wrapper" )
						.css( {
							fontSize: "100%",
							background: "transparent",
							border: "none",
							margin: 0,
							padding: 0
						} ),
	
					// Store the size in case width/height are defined in % - Fixes #5245
					size = {
						width: element.width(),
						height: element.height()
					},
					active = document.activeElement;
	
				// Support: Firefox
				// Firefox incorrectly exposes anonymous content
				// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
				try {
					active.id;
				} catch ( e ) {
					active = document.body;
				}
	
				element.wrap( wrapper );
	
				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
	
				// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
				// lose the reference to the wrapped element
				wrapper = element.parent();
	
				// Transfer positioning properties to the wrapper
				if ( element.css( "position" ) === "static" ) {
					wrapper.css( { position: "relative" } );
					element.css( { position: "relative" } );
				} else {
					$.extend( props, {
						position: element.css( "position" ),
						zIndex: element.css( "z-index" )
					} );
					$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
						props[ pos ] = element.css( pos );
						if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
							props[ pos ] = "auto";
						}
					} );
					element.css( {
						position: "relative",
						top: 0,
						left: 0,
						right: "auto",
						bottom: "auto"
					} );
				}
				element.css( size );
	
				return wrapper.css( props ).show();
			},
	
			removeWrapper: function( element ) {
				var active = document.activeElement;
	
				if ( element.parent().is( ".ui-effects-wrapper" ) ) {
					element.parent().replaceWith( element );
	
					// Fixes #7595 - Elements lose focus when wrapped.
					if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
						$( active ).trigger( "focus" );
					}
				}
	
				return element;
			}
		} );
	}
	
	$.extend( $.effects, {
		version: "1.12.1",
	
		define: function( name, mode, effect ) {
			if ( !effect ) {
				effect = mode;
				mode = "effect";
			}
	
			$.effects.effect[ name ] = effect;
			$.effects.effect[ name ].mode = mode;
	
			return effect;
		},
	
		scaledDimensions: function( element, percent, direction ) {
			if ( percent === 0 ) {
				return {
					height: 0,
					width: 0,
					outerHeight: 0,
					outerWidth: 0
				};
			}
	
			var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
				y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;
	
			return {
				height: element.height() * y,
				width: element.width() * x,
				outerHeight: element.outerHeight() * y,
				outerWidth: element.outerWidth() * x
			};
	
		},
	
		clipToBox: function( animation ) {
			return {
				width: animation.clip.right - animation.clip.left,
				height: animation.clip.bottom - animation.clip.top,
				left: animation.clip.left,
				top: animation.clip.top
			};
		},
	
		// Injects recently queued functions to be first in line (after "inprogress")
		unshift: function( element, queueLength, count ) {
			var queue = element.queue();
	
			if ( queueLength > 1 ) {
				queue.splice.apply( queue,
					[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
			}
			element.dequeue();
		},
	
		saveStyle: function( element ) {
			element.data( dataSpaceStyle, element[ 0 ].style.cssText );
		},
	
		restoreStyle: function( element ) {
			element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
			element.removeData( dataSpaceStyle );
		},
	
		mode: function( element, mode ) {
			var hidden = element.is( ":hidden" );
	
			if ( mode === "toggle" ) {
				mode = hidden ? "show" : "hide";
			}
			if ( hidden ? mode === "hide" : mode === "show" ) {
				mode = "none";
			}
			return mode;
		},
	
		// Translates a [top,left] array into a baseline value
		getBaseline: function( origin, original ) {
			var y, x;
	
			switch ( origin[ 0 ] ) {
			case "top":
				y = 0;
				break;
			case "middle":
				y = 0.5;
				break;
			case "bottom":
				y = 1;
				break;
			default:
				y = origin[ 0 ] / original.height;
			}
	
			switch ( origin[ 1 ] ) {
			case "left":
				x = 0;
				break;
			case "center":
				x = 0.5;
				break;
			case "right":
				x = 1;
				break;
			default:
				x = origin[ 1 ] / original.width;
			}
	
			return {
				x: x,
				y: y
			};
		},
	
		// Creates a placeholder element so that the original element can be made absolute
		createPlaceholder: function( element ) {
			var placeholder,
				cssPosition = element.css( "position" ),
				position = element.position();
	
			// Lock in margins first to account for form elements, which
			// will change margin if you explicitly set height
			// see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
			// Support: Safari
			element.css( {
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() );
	
			if ( /^(static|relative)/.test( cssPosition ) ) {
				cssPosition = "absolute";
	
				placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {
	
					// Convert inline to inline block to account for inline elements
					// that turn to inline block based on content (like img)
					display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
						"inline-block" :
						"block",
					visibility: "hidden",
	
					// Margins need to be set to account for margin collapse
					marginTop: element.css( "marginTop" ),
					marginBottom: element.css( "marginBottom" ),
					marginLeft: element.css( "marginLeft" ),
					marginRight: element.css( "marginRight" ),
					"float": element.css( "float" )
				} )
				.outerWidth( element.outerWidth() )
				.outerHeight( element.outerHeight() )
				.addClass( "ui-effects-placeholder" );
	
				element.data( dataSpace + "placeholder", placeholder );
			}
	
			element.css( {
				position: cssPosition,
				left: position.left,
				top: position.top
			} );
	
			return placeholder;
		},
	
		removePlaceholder: function( element ) {
			var dataKey = dataSpace + "placeholder",
					placeholder = element.data( dataKey );
	
			if ( placeholder ) {
				placeholder.remove();
				element.removeData( dataKey );
			}
		},
	
		// Removes a placeholder if it exists and restores
		// properties that were modified during placeholder creation
		cleanUp: function( element ) {
			$.effects.restoreStyle( element );
			$.effects.removePlaceholder( element );
		},
	
		setTransition: function( element, list, factor, value ) {
			value = value || {};
			$.each( list, function( i, x ) {
				var unit = element.cssUnit( x );
				if ( unit[ 0 ] > 0 ) {
					value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
				}
			} );
			return value;
		}
	} );
	
	// Return an effect options object for the given parameters:
	function _normalizeArguments( effect, options, speed, callback ) {
	
		// Allow passing all options as the first parameter
		if ( $.isPlainObject( effect ) ) {
			options = effect;
			effect = effect.effect;
		}
	
		// Convert to an object
		effect = { effect: effect };
	
		// Catch (effect, null, ...)
		if ( options == null ) {
			options = {};
		}
	
		// Catch (effect, callback)
		if ( $.isFunction( options ) ) {
			callback = options;
			speed = null;
			options = {};
		}
	
		// Catch (effect, speed, ?)
		if ( typeof options === "number" || $.fx.speeds[ options ] ) {
			callback = speed;
			speed = options;
			options = {};
		}
	
		// Catch (effect, options, callback)
		if ( $.isFunction( speed ) ) {
			callback = speed;
			speed = null;
		}
	
		// Add options to effect
		if ( options ) {
			$.extend( effect, options );
		}
	
		speed = speed || options.duration;
		effect.duration = $.fx.off ? 0 :
			typeof speed === "number" ? speed :
			speed in $.fx.speeds ? $.fx.speeds[ speed ] :
			$.fx.speeds._default;
	
		effect.complete = callback || options.complete;
	
		return effect;
	}
	
	function standardAnimationOption( option ) {
	
		// Valid standard speeds (nothing, number, named speed)
		if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
			return true;
		}
	
		// Invalid strings - treat as "normal" speed
		if ( typeof option === "string" && !$.effects.effect[ option ] ) {
			return true;
		}
	
		// Complete callback
		if ( $.isFunction( option ) ) {
			return true;
		}
	
		// Options hash (but not naming an effect)
		if ( typeof option === "object" && !option.effect ) {
			return true;
		}
	
		// Didn't match any standard API
		return false;
	}
	
	$.fn.extend( {
		effect: function( /* effect, options, speed, callback */ ) {
			var args = _normalizeArguments.apply( this, arguments ),
				effectMethod = $.effects.effect[ args.effect ],
				defaultMode = effectMethod.mode,
				queue = args.queue,
				queueName = queue || "fx",
				complete = args.complete,
				mode = args.mode,
				modes = [],
				prefilter = function( next ) {
					var el = $( this ),
						normalizedMode = $.effects.mode( el, mode ) || defaultMode;
	
					// Sentinel for duck-punching the :animated psuedo-selector
					el.data( dataSpaceAnimated, true );
	
					// Save effect mode for later use,
					// we can't just call $.effects.mode again later,
					// as the .show() below destroys the initial state
					modes.push( normalizedMode );
	
					// See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
					if ( defaultMode && ( normalizedMode === "show" ||
							( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
						el.show();
					}
	
					if ( !defaultMode || normalizedMode !== "none" ) {
						$.effects.saveStyle( el );
					}
	
					if ( $.isFunction( next ) ) {
						next();
					}
				};
	
			if ( $.fx.off || !effectMethod ) {
	
				// Delegate to the original method (e.g., .show()) if possible
				if ( mode ) {
					return this[ mode ]( args.duration, complete );
				} else {
					return this.each( function() {
						if ( complete ) {
							complete.call( this );
						}
					} );
				}
			}
	
			function run( next ) {
				var elem = $( this );
	
				function cleanup() {
					elem.removeData( dataSpaceAnimated );
	
					$.effects.cleanUp( elem );
	
					if ( args.mode === "hide" ) {
						elem.hide();
					}
	
					done();
				}
	
				function done() {
					if ( $.isFunction( complete ) ) {
						complete.call( elem[ 0 ] );
					}
	
					if ( $.isFunction( next ) ) {
						next();
					}
				}
	
				// Override mode option on a per element basis,
				// as toggle can be either show or hide depending on element state
				args.mode = modes.shift();
	
				if ( $.uiBackCompat !== false && !defaultMode ) {
					if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {
	
						// Call the core method to track "olddisplay" properly
						elem[ mode ]();
						done();
					} else {
						effectMethod.call( elem[ 0 ], args, done );
					}
				} else {
					if ( args.mode === "none" ) {
	
						// Call the core method to track "olddisplay" properly
						elem[ mode ]();
						done();
					} else {
						effectMethod.call( elem[ 0 ], args, cleanup );
					}
				}
			}
	
			// Run prefilter on all elements first to ensure that
			// any showing or hiding happens before placeholder creation,
			// which ensures that any layout changes are correctly captured.
			return queue === false ?
				this.each( prefilter ).each( run ) :
				this.queue( queueName, prefilter ).queue( queueName, run );
		},
	
		show: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "show";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.show ),
	
		hide: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "hide";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.hide ),
	
		toggle: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "toggle";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.toggle ),
	
		cssUnit: function( key ) {
			var style = this.css( key ),
				val = [];
	
			$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
				if ( style.indexOf( unit ) > 0 ) {
					val = [ parseFloat( style ), unit ];
				}
			} );
			return val;
		},
	
		cssClip: function( clipObj ) {
			if ( clipObj ) {
				return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
					clipObj.bottom + "px " + clipObj.left + "px)" );
			}
			return parseClip( this.css( "clip" ), this );
		},
	
		transfer: function( options, done ) {
			var element = $( this ),
				target = $( options.to ),
				targetFixed = target.css( "position" ) === "fixed",
				body = $( "body" ),
				fixTop = targetFixed ? body.scrollTop() : 0,
				fixLeft = targetFixed ? body.scrollLeft() : 0,
				endPosition = target.offset(),
				animation = {
					top: endPosition.top - fixTop,
					left: endPosition.left - fixLeft,
					height: target.innerHeight(),
					width: target.innerWidth()
				},
				startPosition = element.offset(),
				transfer = $( "<div class='ui-effects-transfer'></div>" )
					.appendTo( "body" )
					.addClass( options.className )
					.css( {
						top: startPosition.top - fixTop,
						left: startPosition.left - fixLeft,
						height: element.innerHeight(),
						width: element.innerWidth(),
						position: targetFixed ? "fixed" : "absolute"
					} )
					.animate( animation, options.duration, options.easing, function() {
						transfer.remove();
						if ( $.isFunction( done ) ) {
							done();
						}
					} );
		}
	} );
	
	function parseClip( str, element ) {
			var outerWidth = element.outerWidth(),
				outerHeight = element.outerHeight(),
				clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
				values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];
	
			return {
				top: parseFloat( values[ 1 ] ) || 0,
				right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
				bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
				left: parseFloat( values[ 4 ] ) || 0
			};
	}
	
	$.fx.step.clip = function( fx ) {
		if ( !fx.clipInit ) {
			fx.start = $( fx.elem ).cssClip();
			if ( typeof fx.end === "string" ) {
				fx.end = parseClip( fx.end, fx.elem );
			}
			fx.clipInit = true;
		}
	
		$( fx.elem ).cssClip( {
			top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
			right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
			bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
			left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
		} );
	};
	
	} )();
	
	/******************************************************************************/
	/*********************************** EASING ***********************************/
	/******************************************************************************/
	
	( function() {
	
	// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)
	
	var baseEasings = {};
	
	$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
		baseEasings[ name ] = function( p ) {
			return Math.pow( p, i + 2 );
		};
	} );
	
	$.extend( baseEasings, {
		Sine: function( p ) {
			return 1 - Math.cos( p * Math.PI / 2 );
		},
		Circ: function( p ) {
			return 1 - Math.sqrt( 1 - p * p );
		},
		Elastic: function( p ) {
			return p === 0 || p === 1 ? p :
				-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
		},
		Back: function( p ) {
			return p * p * ( 3 * p - 2 );
		},
		Bounce: function( p ) {
			var pow2,
				bounce = 4;
	
			while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
			return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
		}
	} );
	
	$.each( baseEasings, function( name, easeIn ) {
		$.easing[ "easeIn" + name ] = easeIn;
		$.easing[ "easeOut" + name ] = function( p ) {
			return 1 - easeIn( 1 - p );
		};
		$.easing[ "easeInOut" + name ] = function( p ) {
			return p < 0.5 ?
				easeIn( p * 2 ) / 2 :
				1 - easeIn( p * -2 + 2 ) / 2;
		};
	} );
	
	} )();
	
	var effect = $.effects;
	
	
	/*!
	 * jQuery UI Effects Blind 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Blind Effect
	//>>group: Effects
	//>>description: Blinds the element.
	//>>docs: http://api.jqueryui.com/blind-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
		var map = {
				up: [ "bottom", "top" ],
				vertical: [ "bottom", "top" ],
				down: [ "top", "bottom" ],
				left: [ "right", "left" ],
				horizontal: [ "right", "left" ],
				right: [ "left", "right" ]
			},
			element = $( this ),
			direction = options.direction || "up",
			start = element.cssClip(),
			animate = { clip: $.extend( {}, start ) },
			placeholder = $.effects.createPlaceholder( element );
	
		animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];
	
		if ( options.mode === "show" ) {
			element.cssClip( animate.clip );
			if ( placeholder ) {
				placeholder.css( $.effects.clipToBox( animate ) );
			}
	
			animate.clip = start;
		}
	
		if ( placeholder ) {
			placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
		}
	
		element.animate( animate, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
	} );
	
	
	/*!
	 * jQuery UI Effects Bounce 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Bounce Effect
	//>>group: Effects
	//>>description: Bounces an element horizontally or vertically n times.
	//>>docs: http://api.jqueryui.com/bounce-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
		var upAnim, downAnim, refValue,
			element = $( this ),
	
			// Defaults:
			mode = options.mode,
			hide = mode === "hide",
			show = mode === "show",
			direction = options.direction || "up",
			distance = options.distance,
			times = options.times || 5,
	
			// Number of internal animations
			anims = times * 2 + ( show || hide ? 1 : 0 ),
			speed = options.duration / anims,
			easing = options.easing,
	
			// Utility:
			ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
			motion = ( direction === "up" || direction === "left" ),
			i = 0,
	
			queuelen = element.queue().length;
	
		$.effects.createPlaceholder( element );
	
		refValue = element.css( ref );
	
		// Default distance for the BIGGEST bounce is the outer Distance / 3
		if ( !distance ) {
			distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
		}
	
		if ( show ) {
			downAnim = { opacity: 1 };
			downAnim[ ref ] = refValue;
	
			// If we are showing, force opacity 0 and set the initial position
			// then do the "first" animation
			element
				.css( "opacity", 0 )
				.css( ref, motion ? -distance * 2 : distance * 2 )
				.animate( downAnim, speed, easing );
		}
	
		// Start at the smallest distance if we are hiding
		if ( hide ) {
			distance = distance / Math.pow( 2, times - 1 );
		}
	
		downAnim = {};
		downAnim[ ref ] = refValue;
	
		// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
		for ( ; i < times; i++ ) {
			upAnim = {};
			upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;
	
			element
				.animate( upAnim, speed, easing )
				.animate( downAnim, speed, easing );
	
			distance = hide ? distance * 2 : distance / 2;
		}
	
		// Last Bounce when Hiding
		if ( hide ) {
			upAnim = { opacity: 0 };
			upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;
	
			element.animate( upAnim, speed, easing );
		}
	
		element.queue( done );
	
		$.effects.unshift( element, queuelen, anims + 1 );
	} );
	
	
	/*!
	 * jQuery UI Effects Clip 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Clip Effect
	//>>group: Effects
	//>>description: Clips the element on and off like an old TV.
	//>>docs: http://api.jqueryui.com/clip-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
		var start,
			animate = {},
			element = $( this ),
			direction = options.direction || "vertical",
			both = direction === "both",
			horizontal = both || direction === "horizontal",
			vertical = both || direction === "vertical";
	
		start = element.cssClip();
		animate.clip = {
			top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
			right: horizontal ? ( start.right - start.left ) / 2 : start.right,
			bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
			left: horizontal ? ( start.right - start.left ) / 2 : start.left
		};
	
		$.effects.createPlaceholder( element );
	
		if ( options.mode === "show" ) {
			element.cssClip( animate.clip );
			animate.clip = start;
		}
	
		element.animate( animate, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
	
	} );
	
	
	/*!
	 * jQuery UI Effects Drop 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Drop Effect
	//>>group: Effects
	//>>description: Moves an element in one direction and hides it at the same time.
	//>>docs: http://api.jqueryui.com/drop-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {
	
		var distance,
			element = $( this ),
			mode = options.mode,
			show = mode === "show",
			direction = options.direction || "left",
			ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
			motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
			oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
			animation = {
				opacity: 0
			};
	
		$.effects.createPlaceholder( element );
	
		distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;
	
		animation[ ref ] = motion + distance;
	
		if ( show ) {
			element.css( animation );
	
			animation[ ref ] = oppositeMotion + distance;
			animation.opacity = 1;
		}
	
		// Animate
		element.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
	} );
	
	
	/*!
	 * jQuery UI Effects Explode 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Explode Effect
	//>>group: Effects
	// jscs:disable maximumLineLength
	//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/explode-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {
	
		var i, j, left, top, mx, my,
			rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
			cells = rows,
			element = $( this ),
			mode = options.mode,
			show = mode === "show",
	
			// Show and then visibility:hidden the element before calculating offset
			offset = element.show().css( "visibility", "hidden" ).offset(),
	
			// Width and height of a piece
			width = Math.ceil( element.outerWidth() / cells ),
			height = Math.ceil( element.outerHeight() / rows ),
			pieces = [];
	
		// Children animate complete:
		function childComplete() {
			pieces.push( this );
			if ( pieces.length === rows * cells ) {
				animComplete();
			}
		}
	
		// Clone the element for each row and cell.
		for ( i = 0; i < rows; i++ ) { // ===>
			top = offset.top + i * height;
			my = i - ( rows - 1 ) / 2;
	
			for ( j = 0; j < cells; j++ ) { // |||
				left = offset.left + j * width;
				mx = j - ( cells - 1 ) / 2;
	
				// Create a clone of the now hidden main element that will be absolute positioned
				// within a wrapper div off the -left and -top equal to size of our pieces
				element
					.clone()
					.appendTo( "body" )
					.wrap( "<div></div>" )
					.css( {
						position: "absolute",
						visibility: "visible",
						left: -j * width,
						top: -i * height
					} )
	
					// Select the wrapper - make it overflow: hidden and absolute positioned based on
					// where the original was located +left and +top equal to the size of pieces
					.parent()
						.addClass( "ui-effects-explode" )
						.css( {
							position: "absolute",
							overflow: "hidden",
							width: width,
							height: height,
							left: left + ( show ? mx * width : 0 ),
							top: top + ( show ? my * height : 0 ),
							opacity: show ? 0 : 1
						} )
						.animate( {
							left: left + ( show ? 0 : mx * width ),
							top: top + ( show ? 0 : my * height ),
							opacity: show ? 1 : 0
						}, options.duration || 500, options.easing, childComplete );
			}
		}
	
		function animComplete() {
			element.css( {
				visibility: "visible"
			} );
			$( pieces ).remove();
			done();
		}
	} );
	
	
	/*!
	 * jQuery UI Effects Fade 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Fade Effect
	//>>group: Effects
	//>>description: Fades the element.
	//>>docs: http://api.jqueryui.com/fade-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
		var show = options.mode === "show";
	
		$( this )
			.css( "opacity", show ? 0 : 1 )
			.animate( {
				opacity: show ? 1 : 0
			}, {
				queue: false,
				duration: options.duration,
				easing: options.easing,
				complete: done
			} );
	} );
	
	
	/*!
	 * jQuery UI Effects Fold 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Fold Effect
	//>>group: Effects
	//>>description: Folds an element first horizontally and then vertically.
	//>>docs: http://api.jqueryui.com/fold-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {
	
		// Create element
		var element = $( this ),
			mode = options.mode,
			show = mode === "show",
			hide = mode === "hide",
			size = options.size || 15,
			percent = /([0-9]+)%/.exec( size ),
			horizFirst = !!options.horizFirst,
			ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
			duration = options.duration / 2,
	
			placeholder = $.effects.createPlaceholder( element ),
	
			start = element.cssClip(),
			animation1 = { clip: $.extend( {}, start ) },
			animation2 = { clip: $.extend( {}, start ) },
	
			distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],
	
			queuelen = element.queue().length;
	
		if ( percent ) {
			size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
		}
		animation1.clip[ ref[ 0 ] ] = size;
		animation2.clip[ ref[ 0 ] ] = size;
		animation2.clip[ ref[ 1 ] ] = 0;
	
		if ( show ) {
			element.cssClip( animation2.clip );
			if ( placeholder ) {
				placeholder.css( $.effects.clipToBox( animation2 ) );
			}
	
			animation2.clip = start;
		}
	
		// Animate
		element
			.queue( function( next ) {
				if ( placeholder ) {
					placeholder
						.animate( $.effects.clipToBox( animation1 ), duration, options.easing )
						.animate( $.effects.clipToBox( animation2 ), duration, options.easing );
				}
	
				next();
			} )
			.animate( animation1, duration, options.easing )
			.animate( animation2, duration, options.easing )
			.queue( done );
	
		$.effects.unshift( element, queuelen, 4 );
	} );
	
	
	/*!
	 * jQuery UI Effects Highlight 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Highlight Effect
	//>>group: Effects
	//>>description: Highlights the background of an element in a defined color for a custom duration.
	//>>docs: http://api.jqueryui.com/highlight-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
		var element = $( this ),
			animation = {
				backgroundColor: element.css( "backgroundColor" )
			};
	
		if ( options.mode === "hide" ) {
			animation.opacity = 0;
		}
	
		$.effects.saveStyle( element );
	
		element
			.css( {
				backgroundImage: "none",
				backgroundColor: options.color || "#ffff99"
			} )
			.animate( animation, {
				queue: false,
				duration: options.duration,
				easing: options.easing,
				complete: done
			} );
	} );
	
	
	/*!
	 * jQuery UI Effects Size 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Size Effect
	//>>group: Effects
	//>>description: Resize an element to a specified width and height.
	//>>docs: http://api.jqueryui.com/size-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectSize = $.effects.define( "size", function( options, done ) {
	
		// Create element
		var baseline, factor, temp,
			element = $( this ),
	
			// Copy for children
			cProps = [ "fontSize" ],
			vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
			hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],
	
			// Set options
			mode = options.mode,
			restore = mode !== "effect",
			scale = options.scale || "both",
			origin = options.origin || [ "middle", "center" ],
			position = element.css( "position" ),
			pos = element.position(),
			original = $.effects.scaledDimensions( element ),
			from = options.from || original,
			to = options.to || $.effects.scaledDimensions( element, 0 );
	
		$.effects.createPlaceholder( element );
	
		if ( mode === "show" ) {
			temp = from;
			from = to;
			to = temp;
		}
	
		// Set scaling factor
		factor = {
			from: {
				y: from.height / original.height,
				x: from.width / original.width
			},
			to: {
				y: to.height / original.height,
				x: to.width / original.width
			}
		};
	
		// Scale the css box
		if ( scale === "box" || scale === "both" ) {
	
			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				from = $.effects.setTransition( element, vProps, factor.from.y, from );
				to = $.effects.setTransition( element, vProps, factor.to.y, to );
			}
	
			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				from = $.effects.setTransition( element, hProps, factor.from.x, from );
				to = $.effects.setTransition( element, hProps, factor.to.x, to );
			}
		}
	
		// Scale the content
		if ( scale === "content" || scale === "both" ) {
	
			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				from = $.effects.setTransition( element, cProps, factor.from.y, from );
				to = $.effects.setTransition( element, cProps, factor.to.y, to );
			}
		}
	
		// Adjust the position properties based on the provided origin points
		if ( origin ) {
			baseline = $.effects.getBaseline( origin, original );
			from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
			from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
			to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
			to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
		}
		element.css( from );
	
		// Animate the children if desired
		if ( scale === "content" || scale === "both" ) {
	
			vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
			hProps = hProps.concat( [ "marginLeft", "marginRight" ] );
	
			// Only animate children with width attributes specified
			// TODO: is this right? should we include anything with css width specified as well
			element.find( "*[width]" ).each( function() {
				var child = $( this ),
					childOriginal = $.effects.scaledDimensions( child ),
					childFrom = {
						height: childOriginal.height * factor.from.y,
						width: childOriginal.width * factor.from.x,
						outerHeight: childOriginal.outerHeight * factor.from.y,
						outerWidth: childOriginal.outerWidth * factor.from.x
					},
					childTo = {
						height: childOriginal.height * factor.to.y,
						width: childOriginal.width * factor.to.x,
						outerHeight: childOriginal.height * factor.to.y,
						outerWidth: childOriginal.width * factor.to.x
					};
	
				// Vertical props scaling
				if ( factor.from.y !== factor.to.y ) {
					childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
					childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
				}
	
				// Horizontal props scaling
				if ( factor.from.x !== factor.to.x ) {
					childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
					childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
				}
	
				if ( restore ) {
					$.effects.saveStyle( child );
				}
	
				// Animate children
				child.css( childFrom );
				child.animate( childTo, options.duration, options.easing, function() {
	
					// Restore children
					if ( restore ) {
						$.effects.restoreStyle( child );
					}
				} );
			} );
		}
	
		// Animate
		element.animate( to, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: function() {
	
				var offset = element.offset();
	
				if ( to.opacity === 0 ) {
					element.css( "opacity", from.opacity );
				}
	
				if ( !restore ) {
					element
						.css( "position", position === "static" ? "relative" : position )
						.offset( offset );
	
					// Need to save style here so that automatic style restoration
					// doesn't restore to the original styles from before the animation.
					$.effects.saveStyle( element );
				}
	
				done();
			}
		} );
	
	} );
	
	
	/*!
	 * jQuery UI Effects Scale 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Scale Effect
	//>>group: Effects
	//>>description: Grows or shrinks an element and its content.
	//>>docs: http://api.jqueryui.com/scale-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectScale = $.effects.define( "scale", function( options, done ) {
	
		// Create element
		var el = $( this ),
			mode = options.mode,
			percent = parseInt( options.percent, 10 ) ||
				( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),
	
			newOptions = $.extend( true, {
				from: $.effects.scaledDimensions( el ),
				to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
				origin: options.origin || [ "middle", "center" ]
			}, options );
	
		// Fade option to support puff
		if ( options.fade ) {
			newOptions.from.opacity = 1;
			newOptions.to.opacity = 0;
		}
	
		$.effects.effect.size.call( this, newOptions, done );
	} );
	
	
	/*!
	 * jQuery UI Effects Puff 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Puff Effect
	//>>group: Effects
	//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
	//>>docs: http://api.jqueryui.com/puff-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
		var newOptions = $.extend( true, {}, options, {
			fade: true,
			percent: parseInt( options.percent, 10 ) || 150
		} );
	
		$.effects.effect.scale.call( this, newOptions, done );
	} );
	
	
	/*!
	 * jQuery UI Effects Pulsate 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Pulsate Effect
	//>>group: Effects
	//>>description: Pulsates an element n times by changing the opacity to zero and back.
	//>>docs: http://api.jqueryui.com/pulsate-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
		var element = $( this ),
			mode = options.mode,
			show = mode === "show",
			hide = mode === "hide",
			showhide = show || hide,
	
			// Showing or hiding leaves off the "last" animation
			anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
			duration = options.duration / anims,
			animateTo = 0,
			i = 1,
			queuelen = element.queue().length;
	
		if ( show || !element.is( ":visible" ) ) {
			element.css( "opacity", 0 ).show();
			animateTo = 1;
		}
	
		// Anims - 1 opacity "toggles"
		for ( ; i < anims; i++ ) {
			element.animate( { opacity: animateTo }, duration, options.easing );
			animateTo = 1 - animateTo;
		}
	
		element.animate( { opacity: animateTo }, duration, options.easing );
	
		element.queue( done );
	
		$.effects.unshift( element, queuelen, anims + 1 );
	} );
	
	
	/*!
	 * jQuery UI Effects Shake 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Shake Effect
	//>>group: Effects
	//>>description: Shakes an element horizontally or vertically n times.
	//>>docs: http://api.jqueryui.com/shake-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectShake = $.effects.define( "shake", function( options, done ) {
	
		var i = 1,
			element = $( this ),
			direction = options.direction || "left",
			distance = options.distance || 20,
			times = options.times || 3,
			anims = times * 2 + 1,
			speed = Math.round( options.duration / anims ),
			ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
			positiveMotion = ( direction === "up" || direction === "left" ),
			animation = {},
			animation1 = {},
			animation2 = {},
	
			queuelen = element.queue().length;
	
		$.effects.createPlaceholder( element );
	
		// Animation
		animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
		animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
		animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;
	
		// Animate
		element.animate( animation, speed, options.easing );
	
		// Shakes
		for ( ; i < times; i++ ) {
			element
				.animate( animation1, speed, options.easing )
				.animate( animation2, speed, options.easing );
		}
	
		element
			.animate( animation1, speed, options.easing )
			.animate( animation, speed / 2, options.easing )
			.queue( done );
	
		$.effects.unshift( element, queuelen, anims + 1 );
	} );
	
	
	/*!
	 * jQuery UI Effects Slide 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Slide Effect
	//>>group: Effects
	//>>description: Slides an element in and out of the viewport.
	//>>docs: http://api.jqueryui.com/slide-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
		var startClip, startRef,
			element = $( this ),
			map = {
				up: [ "bottom", "top" ],
				down: [ "top", "bottom" ],
				left: [ "right", "left" ],
				right: [ "left", "right" ]
			},
			mode = options.mode,
			direction = options.direction || "left",
			ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
			positiveMotion = ( direction === "up" || direction === "left" ),
			distance = options.distance ||
				element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
			animation = {};
	
		$.effects.createPlaceholder( element );
	
		startClip = element.cssClip();
		startRef = element.position()[ ref ];
	
		// Define hide animation
		animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
		animation.clip = element.cssClip();
		animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];
	
		// Reverse the animation if we're showing
		if ( mode === "show" ) {
			element.cssClip( animation.clip );
			element.css( ref, animation[ ref ] );
			animation.clip = startClip;
			animation[ ref ] = startRef;
		}
	
		// Actually animate
		element.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
	} );
	
	
	/*!
	 * jQuery UI Effects Transfer 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Transfer Effect
	//>>group: Effects
	//>>description: Displays a transfer effect from one element to another.
	//>>docs: http://api.jqueryui.com/transfer-effect/
	//>>demos: http://jqueryui.com/effect/
	
	
	
	var effect;
	if ( $.uiBackCompat !== false ) {
		effect = $.effects.define( "transfer", function( options, done ) {
			$( this ).transfer( options, done );
		} );
	}
	var effectsEffectTransfer = effect;
	
	
	/*!
	 * jQuery UI Focusable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :focusable Selector
	//>>group: Core
	//>>description: Selects elements which can be focused.
	//>>docs: http://api.jqueryui.com/focusable-selector/
	
	
	
	// Selectors
	$.ui.focusable = function( element, hasTabindex ) {
		var map, mapName, img, focusableIfVisible, fieldset,
			nodeName = element.nodeName.toLowerCase();
	
		if ( "area" === nodeName ) {
			map = element.parentNode;
			mapName = map.name;
			if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
				return false;
			}
			img = $( "img[usemap='#" + mapName + "']" );
			return img.length > 0 && img.is( ":visible" );
		}
	
		if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
			focusableIfVisible = !element.disabled;
	
			if ( focusableIfVisible ) {
	
				// Form controls within a disabled fieldset are disabled.
				// However, controls within the fieldset's legend do not get disabled.
				// Since controls generally aren't placed inside legends, we skip
				// this portion of the check.
				fieldset = $( element ).closest( "fieldset" )[ 0 ];
				if ( fieldset ) {
					focusableIfVisible = !fieldset.disabled;
				}
			}
		} else if ( "a" === nodeName ) {
			focusableIfVisible = element.href || hasTabindex;
		} else {
			focusableIfVisible = hasTabindex;
		}
	
		return focusableIfVisible && $( element ).is( ":visible" ) && visible( $( element ) );
	};
	
	// Support: IE 8 only
	// IE 8 doesn't resolve inherit to visible/hidden for computed values
	function visible( element ) {
		var visibility = element.css( "visibility" );
		while ( visibility === "inherit" ) {
			element = element.parent();
			visibility = element.css( "visibility" );
		}
		return visibility !== "hidden";
	}
	
	$.extend( $.expr[ ":" ], {
		focusable: function( element ) {
			return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
		}
	} );
	
	var focusable = $.ui.focusable;
	
	
	
	
	// Support: IE8 Only
	// IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
	// with a string, so we need to find the proper form.
	var form = $.fn.form = function() {
		return typeof this[ 0 ].form === "string" ? this.closest( "form" ) : $( this[ 0 ].form );
	};
	
	
	/*!
	 * jQuery UI Form Reset Mixin 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Form Reset Mixin
	//>>group: Core
	//>>description: Refresh input widgets when their form is reset
	//>>docs: http://api.jqueryui.com/form-reset-mixin/
	
	
	
	var formResetMixin = $.ui.formResetMixin = {
		_formResetHandler: function() {
			var form = $( this );
	
			// Wait for the form reset to actually happen before refreshing
			setTimeout( function() {
				var instances = form.data( "ui-form-reset-instances" );
				$.each( instances, function() {
					this.refresh();
				} );
			} );
		},
	
		_bindFormResetHandler: function() {
			this.form = this.element.form();
			if ( !this.form.length ) {
				return;
			}
	
			var instances = this.form.data( "ui-form-reset-instances" ) || [];
			if ( !instances.length ) {
	
				// We don't use _on() here because we use a single event handler per form
				this.form.on( "reset.ui-form-reset", this._formResetHandler );
			}
			instances.push( this );
			this.form.data( "ui-form-reset-instances", instances );
		},
	
		_unbindFormResetHandler: function() {
			if ( !this.form.length ) {
				return;
			}
	
			var instances = this.form.data( "ui-form-reset-instances" );
			instances.splice( $.inArray( this, instances ), 1 );
			if ( instances.length ) {
				this.form.data( "ui-form-reset-instances", instances );
			} else {
				this.form
					.removeData( "ui-form-reset-instances" )
					.off( "reset.ui-form-reset" );
			}
		}
	};
	
	
	/*!
	 * jQuery UI Support for jQuery core 1.7.x 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 */
	
	//>>label: jQuery 1.7 Support
	//>>group: Core
	//>>description: Support version 1.7.x of jQuery core
	
	
	
	// Support: jQuery 1.7 only
	// Not a great way to check versions, but since we only support 1.7+ and only
	// need to detect <1.8, this is a simple check that should suffice. Checking
	// for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
	// and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
	// 1.7 anymore). See #11197 for why we're not using feature detection.
	if ( $.fn.jquery.substring( 0, 3 ) === "1.7" ) {
	
		// Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
		// Unlike jQuery Core 1.8+, these only support numeric values to set the
		// dimensions in pixels
		$.each( [ "Width", "Height" ], function( i, name ) {
			var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
				type = name.toLowerCase(),
				orig = {
					innerWidth: $.fn.innerWidth,
					innerHeight: $.fn.innerHeight,
					outerWidth: $.fn.outerWidth,
					outerHeight: $.fn.outerHeight
				};
	
			function reduce( elem, size, border, margin ) {
				$.each( side, function() {
					size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
					if ( border ) {
						size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
					}
					if ( margin ) {
						size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
					}
				} );
				return size;
			}
	
			$.fn[ "inner" + name ] = function( size ) {
				if ( size === undefined ) {
					return orig[ "inner" + name ].call( this );
				}
	
				return this.each( function() {
					$( this ).css( type, reduce( this, size ) + "px" );
				} );
			};
	
			$.fn[ "outer" + name ] = function( size, margin ) {
				if ( typeof size !== "number" ) {
					return orig[ "outer" + name ].call( this, size );
				}
	
				return this.each( function() {
					$( this ).css( type, reduce( this, size, true, margin ) + "px" );
				} );
			};
		} );
	
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	;
	/*!
	 * jQuery UI Keycode 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Keycode
	//>>group: Core
	//>>description: Provide keycodes as keynames
	//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/
	
	
	var keycode = $.ui.keyCode = {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	};
	
	
	
	
	// Internal use only
	var escapeSelector = $.ui.escapeSelector = ( function() {
		var selectorEscape = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
		return function( selector ) {
			return selector.replace( selectorEscape, "\\$1" );
		};
	} )();
	
	
	/*!
	 * jQuery UI Labels 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: labels
	//>>group: Core
	//>>description: Find all the labels associated with a given input
	//>>docs: http://api.jqueryui.com/labels/
	
	
	
	var labels = $.fn.labels = function() {
		var ancestor, selector, id, labels, ancestors;
	
		// Check control.labels first
		if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
			return this.pushStack( this[ 0 ].labels );
		}
	
		// Support: IE <= 11, FF <= 37, Android <= 2.3 only
		// Above browsers do not support control.labels. Everything below is to support them
		// as well as document fragments. control.labels does not work on document fragments
		labels = this.eq( 0 ).parents( "label" );
	
		// Look for the label based on the id
		id = this.attr( "id" );
		if ( id ) {
	
			// We don't search against the document in case the element
			// is disconnected from the DOM
			ancestor = this.eq( 0 ).parents().last();
	
			// Get a full set of top level ancestors
			ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );
	
			// Create a selector for the label based on the id
			selector = "label[for='" + $.ui.escapeSelector( id ) + "']";
	
			labels = labels.add( ancestors.find( selector ).addBack( selector ) );
	
		}
	
		// Return whatever we have found for labels
		return this.pushStack( labels );
	};
	
	
	/*!
	 * jQuery UI Scroll Parent 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: scrollParent
	//>>group: Core
	//>>description: Get the closest ancestor element that is scrollable.
	//>>docs: http://api.jqueryui.com/scrollParent/
	
	
	
	var scrollParent = $.fn.scrollParent = function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
					parent.css( "overflow-x" ) );
			} ).eq( 0 );
	
		return position === "fixed" || !scrollParent.length ?
			$( this[ 0 ].ownerDocument || document ) :
			scrollParent;
	};
	
	
	/*!
	 * jQuery UI Tabbable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :tabbable Selector
	//>>group: Core
	//>>description: Selects elements which can be tabbed to.
	//>>docs: http://api.jqueryui.com/tabbable-selector/
	
	
	
	var tabbable = $.extend( $.expr[ ":" ], {
		tabbable: function( element ) {
			var tabIndex = $.attr( element, "tabindex" ),
				hasTabindex = tabIndex != null;
			return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
		}
	} );
	
	
	/*!
	 * jQuery UI Unique ID 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: uniqueId
	//>>group: Core
	//>>description: Functions to generate and remove uniqueId's
	//>>docs: http://api.jqueryui.com/uniqueId/
	
	
	
	var uniqueId = $.fn.extend( {
		uniqueId: ( function() {
			var uuid = 0;
	
			return function() {
				return this.each( function() {
					if ( !this.id ) {
						this.id = "ui-id-" + ( ++uuid );
					}
				} );
			};
		} )(),
	
		removeUniqueId: function() {
			return this.each( function() {
				if ( /^ui-id-\d+$/.test( this.id ) ) {
					$( this ).removeAttr( "id" );
				}
			} );
		}
	} );
	
	
	/*!
	 * jQuery UI Accordion 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Accordion
	//>>group: Widgets
	// jscs:disable maximumLineLength
	//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/accordion/
	//>>demos: http://jqueryui.com/accordion/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/accordion.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	var widgetsAccordion = $.widget( "ui.accordion", {
		version: "1.12.1",
		options: {
			active: 0,
			animate: {},
			classes: {
				"ui-accordion-header": "ui-corner-top",
				"ui-accordion-header-collapsed": "ui-corner-all",
				"ui-accordion-content": "ui-corner-bottom"
			},
			collapsible: false,
			event: "click",
			header: "> li > :first-child, > :not(li):even",
			heightStyle: "auto",
			icons: {
				activeHeader: "ui-icon-triangle-1-s",
				header: "ui-icon-triangle-1-e"
			},
	
			// Callbacks
			activate: null,
			beforeActivate: null
		},
	
		hideProps: {
			borderTopWidth: "hide",
			borderBottomWidth: "hide",
			paddingTop: "hide",
			paddingBottom: "hide",
			height: "hide"
		},
	
		showProps: {
			borderTopWidth: "show",
			borderBottomWidth: "show",
			paddingTop: "show",
			paddingBottom: "show",
			height: "show"
		},
	
		_create: function() {
			var options = this.options;
	
			this.prevShow = this.prevHide = $();
			this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
			this.element.attr( "role", "tablist" );
	
			// Don't allow collapsible: false and active: false / null
			if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
				options.active = 0;
			}
	
			this._processPanels();
	
			// handle negative values
			if ( options.active < 0 ) {
				options.active += this.headers.length;
			}
			this._refresh();
		},
	
		_getCreateEventData: function() {
			return {
				header: this.active,
				panel: !this.active.length ? $() : this.active.next()
			};
		},
	
		_createIcons: function() {
			var icon, children,
				icons = this.options.icons;
	
			if ( icons ) {
				icon = $( "<span>" );
				this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
				icon.prependTo( this.headers );
				children = this.active.children( ".ui-accordion-header-icon" );
				this._removeClass( children, icons.header )
					._addClass( children, null, icons.activeHeader )
					._addClass( this.headers, "ui-accordion-icons" );
			}
		},
	
		_destroyIcons: function() {
			this._removeClass( this.headers, "ui-accordion-icons" );
			this.headers.children( ".ui-accordion-header-icon" ).remove();
		},
	
		_destroy: function() {
			var contents;
	
			// Clean up main element
			this.element.removeAttr( "role" );
	
			// Clean up headers
			this.headers
				.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
				.removeUniqueId();
	
			this._destroyIcons();
	
			// Clean up content panels
			contents = this.headers.next()
				.css( "display", "" )
				.removeAttr( "role aria-hidden aria-labelledby" )
				.removeUniqueId();
	
			if ( this.options.heightStyle !== "content" ) {
				contents.css( "height", "" );
			}
		},
	
		_setOption: function( key, value ) {
			if ( key === "active" ) {
	
				// _activate() will handle invalid values and update this.options
				this._activate( value );
				return;
			}
	
			if ( key === "event" ) {
				if ( this.options.event ) {
					this._off( this.headers, this.options.event );
				}
				this._setupEvents( value );
			}
	
			this._super( key, value );
	
			// Setting collapsible: false while collapsed; open first panel
			if ( key === "collapsible" && !value && this.options.active === false ) {
				this._activate( 0 );
			}
	
			if ( key === "icons" ) {
				this._destroyIcons();
				if ( value ) {
					this._createIcons();
				}
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this.element.attr( "aria-disabled", value );
	
			// Support: IE8 Only
			// #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
			// so we need to add the disabled class to the headers and panels
			this._toggleClass( null, "ui-state-disabled", !!value );
			this._toggleClass( this.headers.add( this.headers.next() ), null, "ui-state-disabled",
				!!value );
		},
	
		_keydown: function( event ) {
			if ( event.altKey || event.ctrlKey ) {
				return;
			}
	
			var keyCode = $.ui.keyCode,
				length = this.headers.length,
				currentIndex = this.headers.index( event.target ),
				toFocus = false;
	
			switch ( event.keyCode ) {
			case keyCode.RIGHT:
			case keyCode.DOWN:
				toFocus = this.headers[ ( currentIndex + 1 ) % length ];
				break;
			case keyCode.LEFT:
			case keyCode.UP:
				toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
				break;
			case keyCode.SPACE:
			case keyCode.ENTER:
				this._eventHandler( event );
				break;
			case keyCode.HOME:
				toFocus = this.headers[ 0 ];
				break;
			case keyCode.END:
				toFocus = this.headers[ length - 1 ];
				break;
			}
	
			if ( toFocus ) {
				$( event.target ).attr( "tabIndex", -1 );
				$( toFocus ).attr( "tabIndex", 0 );
				$( toFocus ).trigger( "focus" );
				event.preventDefault();
			}
		},
	
		_panelKeyDown: function( event ) {
			if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
				$( event.currentTarget ).prev().trigger( "focus" );
			}
		},
	
		refresh: function() {
			var options = this.options;
			this._processPanels();
	
			// Was collapsed or no panel
			if ( ( options.active === false && options.collapsible === true ) ||
					!this.headers.length ) {
				options.active = false;
				this.active = $();
	
			// active false only when collapsible is true
			} else if ( options.active === false ) {
				this._activate( 0 );
	
			// was active, but active panel is gone
			} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
	
				// all remaining panel are disabled
				if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
					options.active = false;
					this.active = $();
	
				// activate previous panel
				} else {
					this._activate( Math.max( 0, options.active - 1 ) );
				}
	
			// was active, active panel still exists
			} else {
	
				// make sure active index is correct
				options.active = this.headers.index( this.active );
			}
	
			this._destroyIcons();
	
			this._refresh();
		},
	
		_processPanels: function() {
			var prevHeaders = this.headers,
				prevPanels = this.panels;
	
			this.headers = this.element.find( this.options.header );
			this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
				"ui-state-default" );
	
			this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
			this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );
	
			// Avoid memory leaks (#10056)
			if ( prevPanels ) {
				this._off( prevHeaders.not( this.headers ) );
				this._off( prevPanels.not( this.panels ) );
			}
		},
	
		_refresh: function() {
			var maxHeight,
				options = this.options,
				heightStyle = options.heightStyle,
				parent = this.element.parent();
	
			this.active = this._findActive( options.active );
			this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
				._removeClass( this.active, "ui-accordion-header-collapsed" );
			this._addClass( this.active.next(), "ui-accordion-content-active" );
			this.active.next().show();
	
			this.headers
				.attr( "role", "tab" )
				.each( function() {
					var header = $( this ),
						headerId = header.uniqueId().attr( "id" ),
						panel = header.next(),
						panelId = panel.uniqueId().attr( "id" );
					header.attr( "aria-controls", panelId );
					panel.attr( "aria-labelledby", headerId );
				} )
				.next()
					.attr( "role", "tabpanel" );
	
			this.headers
				.not( this.active )
					.attr( {
						"aria-selected": "false",
						"aria-expanded": "false",
						tabIndex: -1
					} )
					.next()
						.attr( {
							"aria-hidden": "true"
						} )
						.hide();
	
			// Make sure at least one header is in the tab order
			if ( !this.active.length ) {
				this.headers.eq( 0 ).attr( "tabIndex", 0 );
			} else {
				this.active.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} )
					.next()
						.attr( {
							"aria-hidden": "false"
						} );
			}
	
			this._createIcons();
	
			this._setupEvents( options.event );
	
			if ( heightStyle === "fill" ) {
				maxHeight = parent.height();
				this.element.siblings( ":visible" ).each( function() {
					var elem = $( this ),
						position = elem.css( "position" );
	
					if ( position === "absolute" || position === "fixed" ) {
						return;
					}
					maxHeight -= elem.outerHeight( true );
				} );
	
				this.headers.each( function() {
					maxHeight -= $( this ).outerHeight( true );
				} );
	
				this.headers.next()
					.each( function() {
						$( this ).height( Math.max( 0, maxHeight -
							$( this ).innerHeight() + $( this ).height() ) );
					} )
					.css( "overflow", "auto" );
			} else if ( heightStyle === "auto" ) {
				maxHeight = 0;
				this.headers.next()
					.each( function() {
						var isVisible = $( this ).is( ":visible" );
						if ( !isVisible ) {
							$( this ).show();
						}
						maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
						if ( !isVisible ) {
							$( this ).hide();
						}
					} )
					.height( maxHeight );
			}
		},
	
		_activate: function( index ) {
			var active = this._findActive( index )[ 0 ];
	
			// Trying to activate the already active panel
			if ( active === this.active[ 0 ] ) {
				return;
			}
	
			// Trying to collapse, simulate a click on the currently active header
			active = active || this.active[ 0 ];
	
			this._eventHandler( {
				target: active,
				currentTarget: active,
				preventDefault: $.noop
			} );
		},
	
		_findActive: function( selector ) {
			return typeof selector === "number" ? this.headers.eq( selector ) : $();
		},
	
		_setupEvents: function( event ) {
			var events = {
				keydown: "_keydown"
			};
			if ( event ) {
				$.each( event.split( " " ), function( index, eventName ) {
					events[ eventName ] = "_eventHandler";
				} );
			}
	
			this._off( this.headers.add( this.headers.next() ) );
			this._on( this.headers, events );
			this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
			this._hoverable( this.headers );
			this._focusable( this.headers );
		},
	
		_eventHandler: function( event ) {
			var activeChildren, clickedChildren,
				options = this.options,
				active = this.active,
				clicked = $( event.currentTarget ),
				clickedIsActive = clicked[ 0 ] === active[ 0 ],
				collapsing = clickedIsActive && options.collapsible,
				toShow = collapsing ? $() : clicked.next(),
				toHide = active.next(),
				eventData = {
					oldHeader: active,
					oldPanel: toHide,
					newHeader: collapsing ? $() : clicked,
					newPanel: toShow
				};
	
			event.preventDefault();
	
			if (
	
					// click on active header, but not collapsible
					( clickedIsActive && !options.collapsible ) ||
	
					// allow canceling activation
					( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
				return;
			}
	
			options.active = collapsing ? false : this.headers.index( clicked );
	
			// When the call to ._toggle() comes after the class changes
			// it causes a very odd bug in IE 8 (see #6720)
			this.active = clickedIsActive ? $() : clicked;
			this._toggle( eventData );
	
			// Switch classes
			// corner classes on the previously active header stay after the animation
			this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				activeChildren = active.children( ".ui-accordion-header-icon" );
				this._removeClass( activeChildren, null, options.icons.activeHeader )
					._addClass( activeChildren, null, options.icons.header );
			}
	
			if ( !clickedIsActive ) {
				this._removeClass( clicked, "ui-accordion-header-collapsed" )
					._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
				if ( options.icons ) {
					clickedChildren = clicked.children( ".ui-accordion-header-icon" );
					this._removeClass( clickedChildren, null, options.icons.header )
						._addClass( clickedChildren, null, options.icons.activeHeader );
				}
	
				this._addClass( clicked.next(), "ui-accordion-content-active" );
			}
		},
	
		_toggle: function( data ) {
			var toShow = data.newPanel,
				toHide = this.prevShow.length ? this.prevShow : data.oldPanel;
	
			// Handle activating a panel during the animation for another activation
			this.prevShow.add( this.prevHide ).stop( true, true );
			this.prevShow = toShow;
			this.prevHide = toHide;
	
			if ( this.options.animate ) {
				this._animate( toShow, toHide, data );
			} else {
				toHide.hide();
				toShow.show();
				this._toggleComplete( data );
			}
	
			toHide.attr( {
				"aria-hidden": "true"
			} );
			toHide.prev().attr( {
				"aria-selected": "false",
				"aria-expanded": "false"
			} );
	
			// if we're switching panels, remove the old header from the tab order
			// if we're opening from collapsed state, remove the previous header from the tab order
			// if we're collapsing, then keep the collapsing header in the tab order
			if ( toShow.length && toHide.length ) {
				toHide.prev().attr( {
					"tabIndex": -1,
					"aria-expanded": "false"
				} );
			} else if ( toShow.length ) {
				this.headers.filter( function() {
					return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
				} )
					.attr( "tabIndex", -1 );
			}
	
			toShow
				.attr( "aria-hidden", "false" )
				.prev()
					.attr( {
						"aria-selected": "true",
						"aria-expanded": "true",
						tabIndex: 0
					} );
		},
	
		_animate: function( toShow, toHide, data ) {
			var total, easing, duration,
				that = this,
				adjust = 0,
				boxSizing = toShow.css( "box-sizing" ),
				down = toShow.length &&
					( !toHide.length || ( toShow.index() < toHide.index() ) ),
				animate = this.options.animate || {},
				options = down && animate.down || animate,
				complete = function() {
					that._toggleComplete( data );
				};
	
			if ( typeof options === "number" ) {
				duration = options;
			}
			if ( typeof options === "string" ) {
				easing = options;
			}
	
			// fall back from options to animation in case of partial down settings
			easing = easing || options.easing || animate.easing;
			duration = duration || options.duration || animate.duration;
	
			if ( !toHide.length ) {
				return toShow.animate( this.showProps, duration, easing, complete );
			}
			if ( !toShow.length ) {
				return toHide.animate( this.hideProps, duration, easing, complete );
			}
	
			total = toShow.show().outerHeight();
			toHide.animate( this.hideProps, {
				duration: duration,
				easing: easing,
				step: function( now, fx ) {
					fx.now = Math.round( now );
				}
			} );
			toShow
				.hide()
				.animate( this.showProps, {
					duration: duration,
					easing: easing,
					complete: complete,
					step: function( now, fx ) {
						fx.now = Math.round( now );
						if ( fx.prop !== "height" ) {
							if ( boxSizing === "content-box" ) {
								adjust += fx.now;
							}
						} else if ( that.options.heightStyle !== "content" ) {
							fx.now = Math.round( total - toHide.outerHeight() - adjust );
							adjust = 0;
						}
					}
				} );
		},
	
		_toggleComplete: function( data ) {
			var toHide = data.oldPanel,
				prev = toHide.prev();
	
			this._removeClass( toHide, "ui-accordion-content-active" );
			this._removeClass( prev, "ui-accordion-header-active" )
				._addClass( prev, "ui-accordion-header-collapsed" );
	
			// Work around for rendering bug in IE (#5421)
			if ( toHide.length ) {
				toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
			}
			this._trigger( "activate", null, data );
		}
	} );
	
	
	
	var safeActiveElement = $.ui.safeActiveElement = function( document ) {
		var activeElement;
	
		// Support: IE 9 only
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {
			activeElement = document.activeElement;
		} catch ( error ) {
			activeElement = document.body;
		}
	
		// Support: IE 9 - 11 only
		// IE may return null instead of an element
		// Interestingly, this only seems to occur when NOT in an iframe
		if ( !activeElement ) {
			activeElement = document.body;
		}
	
		// Support: IE 11 only
		// IE11 returns a seemingly empty object in some cases when accessing
		// document.activeElement from an <iframe>
		if ( !activeElement.nodeName ) {
			activeElement = document.body;
		}
	
		return activeElement;
	};
	
	
	/*!
	 * jQuery UI Menu 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Menu
	//>>group: Widgets
	//>>description: Creates nestable menus.
	//>>docs: http://api.jqueryui.com/menu/
	//>>demos: http://jqueryui.com/menu/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/menu.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	var widgetsMenu = $.widget( "ui.menu", {
		version: "1.12.1",
		defaultElement: "<ul>",
		delay: 300,
		options: {
			icons: {
				submenu: "ui-icon-caret-1-e"
			},
			items: "> *",
			menus: "ul",
			position: {
				my: "left top",
				at: "right top"
			},
			role: "menu",
	
			// Callbacks
			blur: null,
			focus: null,
			select: null
		},
	
		_create: function() {
			this.activeMenu = this.element;
	
			// Flag used to prevent firing of the click handler
			// as the event bubbles up through nested menus
			this.mouseHandled = false;
			this.element
				.uniqueId()
				.attr( {
					role: this.options.role,
					tabIndex: 0
				} );
	
			this._addClass( "ui-menu", "ui-widget ui-widget-content" );
			this._on( {
	
				// Prevent focus from sticking to links inside menu after clicking
				// them (focus should always stay on UL during navigation).
				"mousedown .ui-menu-item": function( event ) {
					event.preventDefault();
				},
				"click .ui-menu-item": function( event ) {
					var target = $( event.target );
					var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
					if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
						this.select( event );
	
						// Only set the mouseHandled flag if the event will bubble, see #9469.
						if ( !event.isPropagationStopped() ) {
							this.mouseHandled = true;
						}
	
						// Open submenu on click
						if ( target.has( ".ui-menu" ).length ) {
							this.expand( event );
						} else if ( !this.element.is( ":focus" ) &&
								active.closest( ".ui-menu" ).length ) {
	
							// Redirect focus to the menu
							this.element.trigger( "focus", [ true ] );
	
							// If the active item is on the top level, let it stay active.
							// Otherwise, blur the active item since it is no longer visible.
							if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
								clearTimeout( this.timer );
							}
						}
					}
				},
				"mouseenter .ui-menu-item": function( event ) {
	
					// Ignore mouse events while typeahead is active, see #10458.
					// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
					// is over an item in the menu
					if ( this.previousFilter ) {
						return;
					}
	
					var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
						target = $( event.currentTarget );
	
					// Ignore bubbled events on parent items, see #11641
					if ( actualTarget[ 0 ] !== target[ 0 ] ) {
						return;
					}
	
					// Remove ui-state-active class from siblings of the newly focused menu item
					// to avoid a jump caused by adjacent elements both having a class with a border
					this._removeClass( target.siblings().children( ".ui-state-active" ),
						null, "ui-state-active" );
					this.focus( event, target );
				},
				mouseleave: "collapseAll",
				"mouseleave .ui-menu": "collapseAll",
				focus: function( event, keepActiveItem ) {
	
					// If there's already an active item, keep it active
					// If not, activate the first item
					var item = this.active || this.element.find( this.options.items ).eq( 0 );
	
					if ( !keepActiveItem ) {
						this.focus( event, item );
					}
				},
				blur: function( event ) {
					this._delay( function() {
						var notContained = !$.contains(
							this.element[ 0 ],
							$.ui.safeActiveElement( this.document[ 0 ] )
						);
						if ( notContained ) {
							this.collapseAll( event );
						}
					} );
				},
				keydown: "_keydown"
			} );
	
			this.refresh();
	
			// Clicks outside of a menu collapse any open menus
			this._on( this.document, {
				click: function( event ) {
					if ( this._closeOnDocumentClick( event ) ) {
						this.collapseAll( event );
					}
	
					// Reset the mouseHandled flag
					this.mouseHandled = false;
				}
			} );
		},
	
		_destroy: function() {
			var items = this.element.find( ".ui-menu-item" )
					.removeAttr( "role aria-disabled" ),
				submenus = items.children( ".ui-menu-item-wrapper" )
					.removeUniqueId()
					.removeAttr( "tabIndex role aria-haspopup" );
	
			// Destroy (sub)menus
			this.element
				.removeAttr( "aria-activedescendant" )
				.find( ".ui-menu" ).addBack()
					.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
						"tabIndex" )
					.removeUniqueId()
					.show();
	
			submenus.children().each( function() {
				var elem = $( this );
				if ( elem.data( "ui-menu-submenu-caret" ) ) {
					elem.remove();
				}
			} );
		},
	
		_keydown: function( event ) {
			var match, prev, character, skip,
				preventDefault = true;
	
			switch ( event.keyCode ) {
			case $.ui.keyCode.PAGE_UP:
				this.previousPage( event );
				break;
			case $.ui.keyCode.PAGE_DOWN:
				this.nextPage( event );
				break;
			case $.ui.keyCode.HOME:
				this._move( "first", "first", event );
				break;
			case $.ui.keyCode.END:
				this._move( "last", "last", event );
				break;
			case $.ui.keyCode.UP:
				this.previous( event );
				break;
			case $.ui.keyCode.DOWN:
				this.next( event );
				break;
			case $.ui.keyCode.LEFT:
				this.collapse( event );
				break;
			case $.ui.keyCode.RIGHT:
				if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
					this.expand( event );
				}
				break;
			case $.ui.keyCode.ENTER:
			case $.ui.keyCode.SPACE:
				this._activate( event );
				break;
			case $.ui.keyCode.ESCAPE:
				this.collapse( event );
				break;
			default:
				preventDefault = false;
				prev = this.previousFilter || "";
				skip = false;
	
				// Support number pad values
				character = event.keyCode >= 96 && event.keyCode <= 105 ?
					( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );
	
				clearTimeout( this.filterTimer );
	
				if ( character === prev ) {
					skip = true;
				} else {
					character = prev + character;
				}
	
				match = this._filterMenuItems( character );
				match = skip && match.index( this.active.next() ) !== -1 ?
					this.active.nextAll( ".ui-menu-item" ) :
					match;
	
				// If no matches on the current filter, reset to the last character pressed
				// to move down the menu to the first item that starts with that character
				if ( !match.length ) {
					character = String.fromCharCode( event.keyCode );
					match = this._filterMenuItems( character );
				}
	
				if ( match.length ) {
					this.focus( event, match );
					this.previousFilter = character;
					this.filterTimer = this._delay( function() {
						delete this.previousFilter;
					}, 1000 );
				} else {
					delete this.previousFilter;
				}
			}
	
			if ( preventDefault ) {
				event.preventDefault();
			}
		},
	
		_activate: function( event ) {
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				if ( this.active.children( "[aria-haspopup='true']" ).length ) {
					this.expand( event );
				} else {
					this.select( event );
				}
			}
		},
	
		refresh: function() {
			var menus, items, newSubmenus, newItems, newWrappers,
				that = this,
				icon = this.options.icons.submenu,
				submenus = this.element.find( this.options.menus );
	
			this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );
	
			// Initialize nested menus
			newSubmenus = submenus.filter( ":not(.ui-menu)" )
				.hide()
				.attr( {
					role: this.options.role,
					"aria-hidden": "true",
					"aria-expanded": "false"
				} )
				.each( function() {
					var menu = $( this ),
						item = menu.prev(),
						submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );
	
					that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
					item
						.attr( "aria-haspopup", "true" )
						.prepend( submenuCaret );
					menu.attr( "aria-labelledby", item.attr( "id" ) );
				} );
	
			this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );
	
			menus = submenus.add( this.element );
			items = menus.find( this.options.items );
	
			// Initialize menu-items containing spaces and/or dashes only as dividers
			items.not( ".ui-menu-item" ).each( function() {
				var item = $( this );
				if ( that._isDivider( item ) ) {
					that._addClass( item, "ui-menu-divider", "ui-widget-content" );
				}
			} );
	
			// Don't refresh list items that are already adapted
			newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
			newWrappers = newItems.children()
				.not( ".ui-menu" )
					.uniqueId()
					.attr( {
						tabIndex: -1,
						role: this._itemRole()
					} );
			this._addClass( newItems, "ui-menu-item" )
				._addClass( newWrappers, "ui-menu-item-wrapper" );
	
			// Add aria-disabled attribute to any disabled menu item
			items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );
	
			// If the active item has been removed, blur the menu
			if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
				this.blur();
			}
		},
	
		_itemRole: function() {
			return {
				menu: "menuitem",
				listbox: "option"
			}[ this.options.role ];
		},
	
		_setOption: function( key, value ) {
			if ( key === "icons" ) {
				var icons = this.element.find( ".ui-menu-icon" );
				this._removeClass( icons, null, this.options.icons.submenu )
					._addClass( icons, null, value.submenu );
			}
			this._super( key, value );
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this.element.attr( "aria-disabled", String( value ) );
			this._toggleClass( null, "ui-state-disabled", !!value );
		},
	
		focus: function( event, item ) {
			var nested, focused, activeParent;
			this.blur( event, event && event.type === "focus" );
	
			this._scrollIntoView( item );
	
			this.active = item.first();
	
			focused = this.active.children( ".ui-menu-item-wrapper" );
			this._addClass( focused, null, "ui-state-active" );
	
			// Only update aria-activedescendant if there's a role
			// otherwise we assume focus is managed elsewhere
			if ( this.options.role ) {
				this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
			}
	
			// Highlight active parent menu item, if any
			activeParent = this.active
				.parent()
					.closest( ".ui-menu-item" )
						.children( ".ui-menu-item-wrapper" );
			this._addClass( activeParent, null, "ui-state-active" );
	
			if ( event && event.type === "keydown" ) {
				this._close();
			} else {
				this.timer = this._delay( function() {
					this._close();
				}, this.delay );
			}
	
			nested = item.children( ".ui-menu" );
			if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
				this._startOpening( nested );
			}
			this.activeMenu = item.parent();
	
			this._trigger( "focus", event, { item: item } );
		},
	
		_scrollIntoView: function( item ) {
			var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
			if ( this._hasScroll() ) {
				borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
				paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
				offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
				scroll = this.activeMenu.scrollTop();
				elementHeight = this.activeMenu.height();
				itemHeight = item.outerHeight();
	
				if ( offset < 0 ) {
					this.activeMenu.scrollTop( scroll + offset );
				} else if ( offset + itemHeight > elementHeight ) {
					this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
				}
			}
		},
	
		blur: function( event, fromFocus ) {
			if ( !fromFocus ) {
				clearTimeout( this.timer );
			}
	
			if ( !this.active ) {
				return;
			}
	
			this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
				null, "ui-state-active" );
	
			this._trigger( "blur", event, { item: this.active } );
			this.active = null;
		},
	
		_startOpening: function( submenu ) {
			clearTimeout( this.timer );
	
			// Don't open if already open fixes a Firefox bug that caused a .5 pixel
			// shift in the submenu position when mousing over the caret icon
			if ( submenu.attr( "aria-hidden" ) !== "true" ) {
				return;
			}
	
			this.timer = this._delay( function() {
				this._close();
				this._open( submenu );
			}, this.delay );
		},
	
		_open: function( submenu ) {
			var position = $.extend( {
				of: this.active
			}, this.options.position );
	
			clearTimeout( this.timer );
			this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
				.hide()
				.attr( "aria-hidden", "true" );
	
			submenu
				.show()
				.removeAttr( "aria-hidden" )
				.attr( "aria-expanded", "true" )
				.position( position );
		},
	
		collapseAll: function( event, all ) {
			clearTimeout( this.timer );
			this.timer = this._delay( function() {
	
				// If we were passed an event, look for the submenu that contains the event
				var currentMenu = all ? this.element :
					$( event && event.target ).closest( this.element.find( ".ui-menu" ) );
	
				// If we found no valid submenu ancestor, use the main menu to close all
				// sub menus anyway
				if ( !currentMenu.length ) {
					currentMenu = this.element;
				}
	
				this._close( currentMenu );
	
				this.blur( event );
	
				// Work around active item staying active after menu is blurred
				this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );
	
				this.activeMenu = currentMenu;
			}, this.delay );
		},
	
		// With no arguments, closes the currently active menu - if nothing is active
		// it closes all menus.  If passed an argument, it will search for menus BELOW
		_close: function( startMenu ) {
			if ( !startMenu ) {
				startMenu = this.active ? this.active.parent() : this.element;
			}
	
			startMenu.find( ".ui-menu" )
				.hide()
				.attr( "aria-hidden", "true" )
				.attr( "aria-expanded", "false" );
		},
	
		_closeOnDocumentClick: function( event ) {
			return !$( event.target ).closest( ".ui-menu" ).length;
		},
	
		_isDivider: function( item ) {
	
			// Match hyphen, em dash, en dash
			return !/[^\-\u2014\u2013\s]/.test( item.text() );
		},
	
		collapse: function( event ) {
			var newItem = this.active &&
				this.active.parent().closest( ".ui-menu-item", this.element );
			if ( newItem && newItem.length ) {
				this._close();
				this.focus( event, newItem );
			}
		},
	
		expand: function( event ) {
			var newItem = this.active &&
				this.active
					.children( ".ui-menu " )
						.find( this.options.items )
							.first();
	
			if ( newItem && newItem.length ) {
				this._open( newItem.parent() );
	
				// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
				this._delay( function() {
					this.focus( event, newItem );
				} );
			}
		},
	
		next: function( event ) {
			this._move( "next", "first", event );
		},
	
		previous: function( event ) {
			this._move( "prev", "last", event );
		},
	
		isFirstItem: function() {
			return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
		},
	
		isLastItem: function() {
			return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
		},
	
		_move: function( direction, filter, event ) {
			var next;
			if ( this.active ) {
				if ( direction === "first" || direction === "last" ) {
					next = this.active
						[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
						.eq( -1 );
				} else {
					next = this.active
						[ direction + "All" ]( ".ui-menu-item" )
						.eq( 0 );
				}
			}
			if ( !next || !next.length || !this.active ) {
				next = this.activeMenu.find( this.options.items )[ filter ]();
			}
	
			this.focus( event, next );
		},
	
		nextPage: function( event ) {
			var item, base, height;
	
			if ( !this.active ) {
				this.next( event );
				return;
			}
			if ( this.isLastItem() ) {
				return;
			}
			if ( this._hasScroll() ) {
				base = this.active.offset().top;
				height = this.element.height();
				this.active.nextAll( ".ui-menu-item" ).each( function() {
					item = $( this );
					return item.offset().top - base - height < 0;
				} );
	
				this.focus( event, item );
			} else {
				this.focus( event, this.activeMenu.find( this.options.items )
					[ !this.active ? "first" : "last" ]() );
			}
		},
	
		previousPage: function( event ) {
			var item, base, height;
			if ( !this.active ) {
				this.next( event );
				return;
			}
			if ( this.isFirstItem() ) {
				return;
			}
			if ( this._hasScroll() ) {
				base = this.active.offset().top;
				height = this.element.height();
				this.active.prevAll( ".ui-menu-item" ).each( function() {
					item = $( this );
					return item.offset().top - base + height > 0;
				} );
	
				this.focus( event, item );
			} else {
				this.focus( event, this.activeMenu.find( this.options.items ).first() );
			}
		},
	
		_hasScroll: function() {
			return this.element.outerHeight() < this.element.prop( "scrollHeight" );
		},
	
		select: function( event ) {
	
			// TODO: It should never be possible to not have an active item at this
			// point, but the tests don't trigger mouseenter before click.
			this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
			var ui = { item: this.active };
			if ( !this.active.has( ".ui-menu" ).length ) {
				this.collapseAll( event, true );
			}
			this._trigger( "select", event, ui );
		},
	
		_filterMenuItems: function( character ) {
			var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
				regex = new RegExp( "^" + escapedCharacter, "i" );
	
			return this.activeMenu
				.find( this.options.items )
	
					// Only match on items, not dividers or other content (#10571)
					.filter( ".ui-menu-item" )
						.filter( function() {
							return regex.test(
								$.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
						} );
		}
	} );
	
	
	/*!
	 * jQuery UI Autocomplete 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Autocomplete
	//>>group: Widgets
	//>>description: Lists suggested words as the user is typing.
	//>>docs: http://api.jqueryui.com/autocomplete/
	//>>demos: http://jqueryui.com/autocomplete/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/autocomplete.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.widget( "ui.autocomplete", {
		version: "1.12.1",
		defaultElement: "<input>",
		options: {
			appendTo: null,
			autoFocus: false,
			delay: 300,
			minLength: 1,
			position: {
				my: "left top",
				at: "left bottom",
				collision: "none"
			},
			source: null,
	
			// Callbacks
			change: null,
			close: null,
			focus: null,
			open: null,
			response: null,
			search: null,
			select: null
		},
	
		requestIndex: 0,
		pending: 0,
	
		_create: function() {
	
			// Some browsers only repeat keydown events, not keypress events,
			// so we use the suppressKeyPress flag to determine if we've already
			// handled the keydown event. #7269
			// Unfortunately the code for & in keypress is the same as the up arrow,
			// so we use the suppressKeyPressRepeat flag to avoid handling keypress
			// events when we know the keydown event was used to modify the
			// search term. #7799
			var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
				nodeName = this.element[ 0 ].nodeName.toLowerCase(),
				isTextarea = nodeName === "textarea",
				isInput = nodeName === "input";
	
			// Textareas are always multi-line
			// Inputs are always single-line, even if inside a contentEditable element
			// IE also treats inputs as contentEditable
			// All other element types are determined by whether or not they're contentEditable
			this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );
	
			this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
			this.isNewMenu = true;
	
			this._addClass( "ui-autocomplete-input" );
			this.element.attr( "autocomplete", "off" );
	
			this._on( this.element, {
				keydown: function( event ) {
					if ( this.element.prop( "readOnly" ) ) {
						suppressKeyPress = true;
						suppressInput = true;
						suppressKeyPressRepeat = true;
						return;
					}
	
					suppressKeyPress = false;
					suppressInput = false;
					suppressKeyPressRepeat = false;
					var keyCode = $.ui.keyCode;
					switch ( event.keyCode ) {
					case keyCode.PAGE_UP:
						suppressKeyPress = true;
						this._move( "previousPage", event );
						break;
					case keyCode.PAGE_DOWN:
						suppressKeyPress = true;
						this._move( "nextPage", event );
						break;
					case keyCode.UP:
						suppressKeyPress = true;
						this._keyEvent( "previous", event );
						break;
					case keyCode.DOWN:
						suppressKeyPress = true;
						this._keyEvent( "next", event );
						break;
					case keyCode.ENTER:
	
						// when menu is open and has focus
						if ( this.menu.active ) {
	
							// #6055 - Opera still allows the keypress to occur
							// which causes forms to submit
							suppressKeyPress = true;
							event.preventDefault();
							this.menu.select( event );
						}
						break;
					case keyCode.TAB:
						if ( this.menu.active ) {
							this.menu.select( event );
						}
						break;
					case keyCode.ESCAPE:
						if ( this.menu.element.is( ":visible" ) ) {
							if ( !this.isMultiLine ) {
								this._value( this.term );
							}
							this.close( event );
	
							// Different browsers have different default behavior for escape
							// Single press can mean undo or clear
							// Double press in IE means clear the whole form
							event.preventDefault();
						}
						break;
					default:
						suppressKeyPressRepeat = true;
	
						// search timeout should be triggered before the input value is changed
						this._searchTimeout( event );
						break;
					}
				},
				keypress: function( event ) {
					if ( suppressKeyPress ) {
						suppressKeyPress = false;
						if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
							event.preventDefault();
						}
						return;
					}
					if ( suppressKeyPressRepeat ) {
						return;
					}
	
					// Replicate some key handlers to allow them to repeat in Firefox and Opera
					var keyCode = $.ui.keyCode;
					switch ( event.keyCode ) {
					case keyCode.PAGE_UP:
						this._move( "previousPage", event );
						break;
					case keyCode.PAGE_DOWN:
						this._move( "nextPage", event );
						break;
					case keyCode.UP:
						this._keyEvent( "previous", event );
						break;
					case keyCode.DOWN:
						this._keyEvent( "next", event );
						break;
					}
				},
				input: function( event ) {
					if ( suppressInput ) {
						suppressInput = false;
						event.preventDefault();
						return;
					}
					this._searchTimeout( event );
				},
				focus: function() {
					this.selectedItem = null;
					this.previous = this._value();
				},
				blur: function( event ) {
					if ( this.cancelBlur ) {
						delete this.cancelBlur;
						return;
					}
	
					clearTimeout( this.searching );
					this.close( event );
					this._change( event );
				}
			} );
	
			this._initSource();
			this.menu = $( "<ul>" )
				.appendTo( this._appendTo() )
				.menu( {
	
					// disable ARIA support, the live region takes care of that
					role: null
				} )
				.hide()
				.menu( "instance" );
	
			this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
			this._on( this.menu.element, {
				mousedown: function( event ) {
	
					// prevent moving focus out of the text field
					event.preventDefault();
	
					// IE doesn't prevent moving focus even with event.preventDefault()
					// so we set a flag to know when we should ignore the blur event
					this.cancelBlur = true;
					this._delay( function() {
						delete this.cancelBlur;
	
						// Support: IE 8 only
						// Right clicking a menu item or selecting text from the menu items will
						// result in focus moving out of the input. However, we've already received
						// and ignored the blur event because of the cancelBlur flag set above. So
						// we restore focus to ensure that the menu closes properly based on the user's
						// next actions.
						if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
							this.element.trigger( "focus" );
						}
					} );
				},
				menufocus: function( event, ui ) {
					var label, item;
	
					// support: Firefox
					// Prevent accidental activation of menu items in Firefox (#7024 #9118)
					if ( this.isNewMenu ) {
						this.isNewMenu = false;
						if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
							this.menu.blur();
	
							this.document.one( "mousemove", function() {
								$( event.target ).trigger( event.originalEvent );
							} );
	
							return;
						}
					}
	
					item = ui.item.data( "ui-autocomplete-item" );
					if ( false !== this._trigger( "focus", event, { item: item } ) ) {
	
						// use value to match what will end up in the input, if it was a key event
						if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
							this._value( item.value );
						}
					}
	
					// Announce the value in the liveRegion
					label = ui.item.attr( "aria-label" ) || item.value;
					if ( label && $.trim( label ).length ) {
						this.liveRegion.children().hide();
						$( "<div>" ).text( label ).appendTo( this.liveRegion );
					}
				},
				menuselect: function( event, ui ) {
					var item = ui.item.data( "ui-autocomplete-item" ),
						previous = this.previous;
	
					// Only trigger when focus was lost (click on menu)
					if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
						this.element.trigger( "focus" );
						this.previous = previous;
	
						// #6109 - IE triggers two focus events and the second
						// is asynchronous, so we need to reset the previous
						// term synchronously and asynchronously :-(
						this._delay( function() {
							this.previous = previous;
							this.selectedItem = item;
						} );
					}
	
					if ( false !== this._trigger( "select", event, { item: item } ) ) {
						this._value( item.value );
					}
	
					// reset the term after the select event
					// this allows custom select handling to work properly
					this.term = this._value();
	
					this.close( event );
					this.selectedItem = item;
				}
			} );
	
			this.liveRegion = $( "<div>", {
				role: "status",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			} )
				.appendTo( this.document[ 0 ].body );
	
			this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );
	
			// Turning off autocomplete prevents the browser from remembering the
			// value when navigating through history, so we re-enable autocomplete
			// if the page is unloaded before the widget is destroyed. #7790
			this._on( this.window, {
				beforeunload: function() {
					this.element.removeAttr( "autocomplete" );
				}
			} );
		},
	
		_destroy: function() {
			clearTimeout( this.searching );
			this.element.removeAttr( "autocomplete" );
			this.menu.element.remove();
			this.liveRegion.remove();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "source" ) {
				this._initSource();
			}
			if ( key === "appendTo" ) {
				this.menu.element.appendTo( this._appendTo() );
			}
			if ( key === "disabled" && value && this.xhr ) {
				this.xhr.abort();
			}
		},
	
		_isEventTargetInWidget: function( event ) {
			var menuElement = this.menu.element[ 0 ];
	
			return event.target === this.element[ 0 ] ||
				event.target === menuElement ||
				$.contains( menuElement, event.target );
		},
	
		_closeOnClickOutside: function( event ) {
			if ( !this._isEventTargetInWidget( event ) ) {
				this.close();
			}
		},
	
		_appendTo: function() {
			var element = this.options.appendTo;
	
			if ( element ) {
				element = element.jquery || element.nodeType ?
					$( element ) :
					this.document.find( element ).eq( 0 );
			}
	
			if ( !element || !element[ 0 ] ) {
				element = this.element.closest( ".ui-front, dialog" );
			}
	
			if ( !element.length ) {
				element = this.document[ 0 ].body;
			}
	
			return element;
		},
	
		_initSource: function() {
			var array, url,
				that = this;
			if ( $.isArray( this.options.source ) ) {
				array = this.options.source;
				this.source = function( request, response ) {
					response( $.ui.autocomplete.filter( array, request.term ) );
				};
			} else if ( typeof this.options.source === "string" ) {
				url = this.options.source;
				this.source = function( request, response ) {
					if ( that.xhr ) {
						that.xhr.abort();
					}
					that.xhr = $.ajax( {
						url: url,
						data: request,
						dataType: "json",
						success: function( data ) {
							response( data );
						},
						error: function() {
							response( [] );
						}
					} );
				};
			} else {
				this.source = this.options.source;
			}
		},
	
		_searchTimeout: function( event ) {
			clearTimeout( this.searching );
			this.searching = this._delay( function() {
	
				// Search if the value has changed, or if the user retypes the same value (see #7434)
				var equalValues = this.term === this._value(),
					menuVisible = this.menu.element.is( ":visible" ),
					modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	
				if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
					this.selectedItem = null;
					this.search( null, event );
				}
			}, this.options.delay );
		},
	
		search: function( value, event ) {
			value = value != null ? value : this._value();
	
			// Always save the actual value, not the one passed as an argument
			this.term = this._value();
	
			if ( value.length < this.options.minLength ) {
				return this.close( event );
			}
	
			if ( this._trigger( "search", event ) === false ) {
				return;
			}
	
			return this._search( value );
		},
	
		_search: function( value ) {
			this.pending++;
			this._addClass( "ui-autocomplete-loading" );
			this.cancelSearch = false;
	
			this.source( { term: value }, this._response() );
		},
	
		_response: function() {
			var index = ++this.requestIndex;
	
			return $.proxy( function( content ) {
				if ( index === this.requestIndex ) {
					this.__response( content );
				}
	
				this.pending--;
				if ( !this.pending ) {
					this._removeClass( "ui-autocomplete-loading" );
				}
			}, this );
		},
	
		__response: function( content ) {
			if ( content ) {
				content = this._normalize( content );
			}
			this._trigger( "response", null, { content: content } );
			if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
				this._suggest( content );
				this._trigger( "open" );
			} else {
	
				// use ._close() instead of .close() so we don't cancel future searches
				this._close();
			}
		},
	
		close: function( event ) {
			this.cancelSearch = true;
			this._close( event );
		},
	
		_close: function( event ) {
	
			// Remove the handler that closes the menu on outside clicks
			this._off( this.document, "mousedown" );
	
			if ( this.menu.element.is( ":visible" ) ) {
				this.menu.element.hide();
				this.menu.blur();
				this.isNewMenu = true;
				this._trigger( "close", event );
			}
		},
	
		_change: function( event ) {
			if ( this.previous !== this._value() ) {
				this._trigger( "change", event, { item: this.selectedItem } );
			}
		},
	
		_normalize: function( items ) {
	
			// assume all items have the right format when the first item is complete
			if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
				return items;
			}
			return $.map( items, function( item ) {
				if ( typeof item === "string" ) {
					return {
						label: item,
						value: item
					};
				}
				return $.extend( {}, item, {
					label: item.label || item.value,
					value: item.value || item.label
				} );
			} );
		},
	
		_suggest: function( items ) {
			var ul = this.menu.element.empty();
			this._renderMenu( ul, items );
			this.isNewMenu = true;
			this.menu.refresh();
	
			// Size and position menu
			ul.show();
			this._resizeMenu();
			ul.position( $.extend( {
				of: this.element
			}, this.options.position ) );
	
			if ( this.options.autoFocus ) {
				this.menu.next();
			}
	
			// Listen for interactions outside of the widget (#6642)
			this._on( this.document, {
				mousedown: "_closeOnClickOutside"
			} );
		},
	
		_resizeMenu: function() {
			var ul = this.menu.element;
			ul.outerWidth( Math.max(
	
				// Firefox wraps long text (possibly a rounding bug)
				// so we add 1px to avoid the wrapping (#7513)
				ul.width( "" ).outerWidth() + 1,
				this.element.outerWidth()
			) );
		},
	
		_renderMenu: function( ul, items ) {
			var that = this;
			$.each( items, function( index, item ) {
				that._renderItemData( ul, item );
			} );
		},
	
		_renderItemData: function( ul, item ) {
			return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
		},
	
		_renderItem: function( ul, item ) {
			return $( "<li>" )
				.append( $( "<div>" ).text( item.label ) )
				.appendTo( ul );
		},
	
		_move: function( direction, event ) {
			if ( !this.menu.element.is( ":visible" ) ) {
				this.search( null, event );
				return;
			}
			if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
					this.menu.isLastItem() && /^next/.test( direction ) ) {
	
				if ( !this.isMultiLine ) {
					this._value( this.term );
				}
	
				this.menu.blur();
				return;
			}
			this.menu[ direction ]( event );
		},
	
		widget: function() {
			return this.menu.element;
		},
	
		_value: function() {
			return this.valueMethod.apply( this.element, arguments );
		},
	
		_keyEvent: function( keyEvent, event ) {
			if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
				this._move( keyEvent, event );
	
				// Prevents moving cursor to beginning/end of the text field in some browsers
				event.preventDefault();
			}
		},
	
		// Support: Chrome <=50
		// We should be able to just use this.element.prop( "isContentEditable" )
		// but hidden elements always report false in Chrome.
		// https://code.google.com/p/chromium/issues/detail?id=313082
		_isContentEditable: function( element ) {
			if ( !element.length ) {
				return false;
			}
	
			var editable = element.prop( "contentEditable" );
	
			if ( editable === "inherit" ) {
			  return this._isContentEditable( element.parent() );
			}
	
			return editable === "true";
		}
	} );
	
	$.extend( $.ui.autocomplete, {
		escapeRegex: function( value ) {
			return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
		},
		filter: function( array, term ) {
			var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
			return $.grep( array, function( value ) {
				return matcher.test( value.label || value.value || value );
			} );
		}
	} );
	
	// Live region extension, adding a `messages` option
	// NOTE: This is an experimental API. We are still investigating
	// a full solution for string manipulation and internationalization.
	$.widget( "ui.autocomplete", $.ui.autocomplete, {
		options: {
			messages: {
				noResults: "No search results.",
				results: function( amount ) {
					return amount + ( amount > 1 ? " results are" : " result is" ) +
						" available, use up and down arrow keys to navigate.";
				}
			}
		},
	
		__response: function( content ) {
			var message;
			this._superApply( arguments );
			if ( this.options.disabled || this.cancelSearch ) {
				return;
			}
			if ( content && content.length ) {
				message = this.options.messages.results( content.length );
			} else {
				message = this.options.messages.noResults;
			}
			this.liveRegion.children().hide();
			$( "<div>" ).text( message ).appendTo( this.liveRegion );
		}
	} );
	
	var widgetsAutocomplete = $.ui.autocomplete;
	
	
	/*!
	 * jQuery UI Controlgroup 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Controlgroup
	//>>group: Widgets
	//>>description: Visually groups form control widgets
	//>>docs: http://api.jqueryui.com/controlgroup/
	//>>demos: http://jqueryui.com/controlgroup/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/controlgroup.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	var controlgroupCornerRegex = /ui-corner-([a-z]){2,6}/g;
	
	var widgetsControlgroup = $.widget( "ui.controlgroup", {
		version: "1.12.1",
		defaultElement: "<div>",
		options: {
			direction: "horizontal",
			disabled: null,
			onlyVisible: true,
			items: {
				"button": "input[type=button], input[type=submit], input[type=reset], button, a",
				"controlgroupLabel": ".ui-controlgroup-label",
				"checkboxradio": "input[type='checkbox'], input[type='radio']",
				"selectmenu": "select",
				"spinner": ".ui-spinner-input"
			}
		},
	
		_create: function() {
			this._enhance();
		},
	
		// To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
		_enhance: function() {
			this.element.attr( "role", "toolbar" );
			this.refresh();
		},
	
		_destroy: function() {
			this._callChildMethod( "destroy" );
			this.childWidgets.removeData( "ui-controlgroup-data" );
			this.element.removeAttr( "role" );
			if ( this.options.items.controlgroupLabel ) {
				this.element
					.find( this.options.items.controlgroupLabel )
					.find( ".ui-controlgroup-label-contents" )
					.contents().unwrap();
			}
		},
	
		_initWidgets: function() {
			var that = this,
				childWidgets = [];
	
			// First we iterate over each of the items options
			$.each( this.options.items, function( widget, selector ) {
				var labels;
				var options = {};
	
				// Make sure the widget has a selector set
				if ( !selector ) {
					return;
				}
	
				if ( widget === "controlgroupLabel" ) {
					labels = that.element.find( selector );
					labels.each( function() {
						var element = $( this );
	
						if ( element.children( ".ui-controlgroup-label-contents" ).length ) {
							return;
						}
						element.contents()
							.wrapAll( "<span class='ui-controlgroup-label-contents'></span>" );
					} );
					that._addClass( labels, null, "ui-widget ui-widget-content ui-state-default" );
					childWidgets = childWidgets.concat( labels.get() );
					return;
				}
	
				// Make sure the widget actually exists
				if ( !$.fn[ widget ] ) {
					return;
				}
	
				// We assume everything is in the middle to start because we can't determine
				// first / last elements until all enhancments are done.
				if ( that[ "_" + widget + "Options" ] ) {
					options = that[ "_" + widget + "Options" ]( "middle" );
				} else {
					options = { classes: {} };
				}
	
				// Find instances of this widget inside controlgroup and init them
				that.element
					.find( selector )
					.each( function() {
						var element = $( this );
						var instance = element[ widget ]( "instance" );
	
						// We need to clone the default options for this type of widget to avoid
						// polluting the variable options which has a wider scope than a single widget.
						var instanceOptions = $.widget.extend( {}, options );
	
						// If the button is the child of a spinner ignore it
						// TODO: Find a more generic solution
						if ( widget === "button" && element.parent( ".ui-spinner" ).length ) {
							return;
						}
	
						// Create the widget if it doesn't exist
						if ( !instance ) {
							instance = element[ widget ]()[ widget ]( "instance" );
						}
						if ( instance ) {
							instanceOptions.classes =
								that._resolveClassesValues( instanceOptions.classes, instance );
						}
						element[ widget ]( instanceOptions );
	
						// Store an instance of the controlgroup to be able to reference
						// from the outermost element for changing options and refresh
						var widgetElement = element[ widget ]( "widget" );
						$.data( widgetElement[ 0 ], "ui-controlgroup-data",
							instance ? instance : element[ widget ]( "instance" ) );
	
						childWidgets.push( widgetElement[ 0 ] );
					} );
			} );
	
			this.childWidgets = $( $.unique( childWidgets ) );
			this._addClass( this.childWidgets, "ui-controlgroup-item" );
		},
	
		_callChildMethod: function( method ) {
			this.childWidgets.each( function() {
				var element = $( this ),
					data = element.data( "ui-controlgroup-data" );
				if ( data && data[ method ] ) {
					data[ method ]();
				}
			} );
		},
	
		_updateCornerClass: function( element, position ) {
			var remove = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";
			var add = this._buildSimpleOptions( position, "label" ).classes.label;
	
			this._removeClass( element, null, remove );
			this._addClass( element, null, add );
		},
	
		_buildSimpleOptions: function( position, key ) {
			var direction = this.options.direction === "vertical";
			var result = {
				classes: {}
			};
			result.classes[ key ] = {
				"middle": "",
				"first": "ui-corner-" + ( direction ? "top" : "left" ),
				"last": "ui-corner-" + ( direction ? "bottom" : "right" ),
				"only": "ui-corner-all"
			}[ position ];
	
			return result;
		},
	
		_spinnerOptions: function( position ) {
			var options = this._buildSimpleOptions( position, "ui-spinner" );
	
			options.classes[ "ui-spinner-up" ] = "";
			options.classes[ "ui-spinner-down" ] = "";
	
			return options;
		},
	
		_buttonOptions: function( position ) {
			return this._buildSimpleOptions( position, "ui-button" );
		},
	
		_checkboxradioOptions: function( position ) {
			return this._buildSimpleOptions( position, "ui-checkboxradio-label" );
		},
	
		_selectmenuOptions: function( position ) {
			var direction = this.options.direction === "vertical";
			return {
				width: direction ? "auto" : false,
				classes: {
					middle: {
						"ui-selectmenu-button-open": "",
						"ui-selectmenu-button-closed": ""
					},
					first: {
						"ui-selectmenu-button-open": "ui-corner-" + ( direction ? "top" : "tl" ),
						"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "top" : "left" )
					},
					last: {
						"ui-selectmenu-button-open": direction ? "" : "ui-corner-tr",
						"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "bottom" : "right" )
					},
					only: {
						"ui-selectmenu-button-open": "ui-corner-top",
						"ui-selectmenu-button-closed": "ui-corner-all"
					}
	
				}[ position ]
			};
		},
	
		_resolveClassesValues: function( classes, instance ) {
			var result = {};
			$.each( classes, function( key ) {
				var current = instance.options.classes[ key ] || "";
				current = $.trim( current.replace( controlgroupCornerRegex, "" ) );
				result[ key ] = ( current + " " + classes[ key ] ).replace( /\s+/g, " " );
			} );
			return result;
		},
	
		_setOption: function( key, value ) {
			if ( key === "direction" ) {
				this._removeClass( "ui-controlgroup-" + this.options.direction );
			}
	
			this._super( key, value );
			if ( key === "disabled" ) {
				this._callChildMethod( value ? "disable" : "enable" );
				return;
			}
	
			this.refresh();
		},
	
		refresh: function() {
			var children,
				that = this;
	
			this._addClass( "ui-controlgroup ui-controlgroup-" + this.options.direction );
	
			if ( this.options.direction === "horizontal" ) {
				this._addClass( null, "ui-helper-clearfix" );
			}
			this._initWidgets();
	
			children = this.childWidgets;
	
			// We filter here because we need to track all childWidgets not just the visible ones
			if ( this.options.onlyVisible ) {
				children = children.filter( ":visible" );
			}
	
			if ( children.length ) {
	
				// We do this last because we need to make sure all enhancment is done
				// before determining first and last
				$.each( [ "first", "last" ], function( index, value ) {
					var instance = children[ value ]().data( "ui-controlgroup-data" );
	
					if ( instance && that[ "_" + instance.widgetName + "Options" ] ) {
						var options = that[ "_" + instance.widgetName + "Options" ](
							children.length === 1 ? "only" : value
						);
						options.classes = that._resolveClassesValues( options.classes, instance );
						instance.element[ instance.widgetName ]( options );
					} else {
						that._updateCornerClass( children[ value ](), value );
					}
				} );
	
				// Finally call the refresh method on each of the child widgets.
				this._callChildMethod( "refresh" );
			}
		}
	} );
	
	/*!
	 * jQuery UI Checkboxradio 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Checkboxradio
	//>>group: Widgets
	//>>description: Enhances a form with multiple themeable checkboxes or radio buttons.
	//>>docs: http://api.jqueryui.com/checkboxradio/
	//>>demos: http://jqueryui.com/checkboxradio/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/button.css
	//>>css.structure: ../../themes/base/checkboxradio.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.widget( "ui.checkboxradio", [ $.ui.formResetMixin, {
		version: "1.12.1",
		options: {
			disabled: null,
			label: null,
			icon: true,
			classes: {
				"ui-checkboxradio-label": "ui-corner-all",
				"ui-checkboxradio-icon": "ui-corner-all"
			}
		},
	
		_getCreateOptions: function() {
			var disabled, labels;
			var that = this;
			var options = this._super() || {};
	
			// We read the type here, because it makes more sense to throw a element type error first,
			// rather then the error for lack of a label. Often if its the wrong type, it
			// won't have a label (e.g. calling on a div, btn, etc)
			this._readType();
	
			labels = this.element.labels();
	
			// If there are multiple labels, use the last one
			this.label = $( labels[ labels.length - 1 ] );
			if ( !this.label.length ) {
				$.error( "No label found for checkboxradio widget" );
			}
	
			this.originalLabel = "";
	
			// We need to get the label text but this may also need to make sure it does not contain the
			// input itself.
			this.label.contents().not( this.element[ 0 ] ).each( function() {
	
				// The label contents could be text, html, or a mix. We concat each element to get a
				// string representation of the label, without the input as part of it.
				that.originalLabel += this.nodeType === 3 ? $( this ).text() : this.outerHTML;
			} );
	
			// Set the label option if we found label text
			if ( this.originalLabel ) {
				options.label = this.originalLabel;
			}
	
			disabled = this.element[ 0 ].disabled;
			if ( disabled != null ) {
				options.disabled = disabled;
			}
			return options;
		},
	
		_create: function() {
			var checked = this.element[ 0 ].checked;
	
			this._bindFormResetHandler();
	
			if ( this.options.disabled == null ) {
				this.options.disabled = this.element[ 0 ].disabled;
			}
	
			this._setOption( "disabled", this.options.disabled );
			this._addClass( "ui-checkboxradio", "ui-helper-hidden-accessible" );
			this._addClass( this.label, "ui-checkboxradio-label", "ui-button ui-widget" );
	
			if ( this.type === "radio" ) {
				this._addClass( this.label, "ui-checkboxradio-radio-label" );
			}
	
			if ( this.options.label && this.options.label !== this.originalLabel ) {
				this._updateLabel();
			} else if ( this.originalLabel ) {
				this.options.label = this.originalLabel;
			}
	
			this._enhance();
	
			if ( checked ) {
				this._addClass( this.label, "ui-checkboxradio-checked", "ui-state-active" );
				if ( this.icon ) {
					this._addClass( this.icon, null, "ui-state-hover" );
				}
			}
	
			this._on( {
				change: "_toggleClasses",
				focus: function() {
					this._addClass( this.label, null, "ui-state-focus ui-visual-focus" );
				},
				blur: function() {
					this._removeClass( this.label, null, "ui-state-focus ui-visual-focus" );
				}
			} );
		},
	
		_readType: function() {
			var nodeName = this.element[ 0 ].nodeName.toLowerCase();
			this.type = this.element[ 0 ].type;
			if ( nodeName !== "input" || !/radio|checkbox/.test( this.type ) ) {
				$.error( "Can't create checkboxradio on element.nodeName=" + nodeName +
					" and element.type=" + this.type );
			}
		},
	
		// Support jQuery Mobile enhanced option
		_enhance: function() {
			this._updateIcon( this.element[ 0 ].checked );
		},
	
		widget: function() {
			return this.label;
		},
	
		_getRadioGroup: function() {
			var group;
			var name = this.element[ 0 ].name;
			var nameSelector = "input[name='" + $.ui.escapeSelector( name ) + "']";
	
			if ( !name ) {
				return $( [] );
			}
	
			if ( this.form.length ) {
				group = $( this.form[ 0 ].elements ).filter( nameSelector );
			} else {
	
				// Not inside a form, check all inputs that also are not inside a form
				group = $( nameSelector ).filter( function() {
					return $( this ).form().length === 0;
				} );
			}
	
			return group.not( this.element );
		},
	
		_toggleClasses: function() {
			var checked = this.element[ 0 ].checked;
			this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
	
			if ( this.options.icon && this.type === "checkbox" ) {
				this._toggleClass( this.icon, null, "ui-icon-check ui-state-checked", checked )
					._toggleClass( this.icon, null, "ui-icon-blank", !checked );
			}
	
			if ( this.type === "radio" ) {
				this._getRadioGroup()
					.each( function() {
						var instance = $( this ).checkboxradio( "instance" );
	
						if ( instance ) {
							instance._removeClass( instance.label,
								"ui-checkboxradio-checked", "ui-state-active" );
						}
					} );
			}
		},
	
		_destroy: function() {
			this._unbindFormResetHandler();
	
			if ( this.icon ) {
				this.icon.remove();
				this.iconSpace.remove();
			}
		},
	
		_setOption: function( key, value ) {
	
			// We don't allow the value to be set to nothing
			if ( key === "label" && !value ) {
				return;
			}
	
			this._super( key, value );
	
			if ( key === "disabled" ) {
				this._toggleClass( this.label, null, "ui-state-disabled", value );
				this.element[ 0 ].disabled = value;
	
				// Don't refresh when setting disabled
				return;
			}
			this.refresh();
		},
	
		_updateIcon: function( checked ) {
			var toAdd = "ui-icon ui-icon-background ";
	
			if ( this.options.icon ) {
				if ( !this.icon ) {
					this.icon = $( "<span>" );
					this.iconSpace = $( "<span> </span>" );
					this._addClass( this.iconSpace, "ui-checkboxradio-icon-space" );
				}
	
				if ( this.type === "checkbox" ) {
					toAdd += checked ? "ui-icon-check ui-state-checked" : "ui-icon-blank";
					this._removeClass( this.icon, null, checked ? "ui-icon-blank" : "ui-icon-check" );
				} else {
					toAdd += "ui-icon-blank";
				}
				this._addClass( this.icon, "ui-checkboxradio-icon", toAdd );
				if ( !checked ) {
					this._removeClass( this.icon, null, "ui-icon-check ui-state-checked" );
				}
				this.icon.prependTo( this.label ).after( this.iconSpace );
			} else if ( this.icon !== undefined ) {
				this.icon.remove();
				this.iconSpace.remove();
				delete this.icon;
			}
		},
	
		_updateLabel: function() {
	
			// Remove the contents of the label ( minus the icon, icon space, and input )
			var contents = this.label.contents().not( this.element[ 0 ] );
			if ( this.icon ) {
				contents = contents.not( this.icon[ 0 ] );
			}
			if ( this.iconSpace ) {
				contents = contents.not( this.iconSpace[ 0 ] );
			}
			contents.remove();
	
			this.label.append( this.options.label );
		},
	
		refresh: function() {
			var checked = this.element[ 0 ].checked,
				isDisabled = this.element[ 0 ].disabled;
	
			this._updateIcon( checked );
			this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
			if ( this.options.label !== null ) {
				this._updateLabel();
			}
	
			if ( isDisabled !== this.options.disabled ) {
				this._setOptions( { "disabled": isDisabled } );
			}
		}
	
	} ] );
	
	var widgetsCheckboxradio = $.ui.checkboxradio;
	
	
	/*!
	 * jQuery UI Button 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Button
	//>>group: Widgets
	//>>description: Enhances a form with themeable buttons.
	//>>docs: http://api.jqueryui.com/button/
	//>>demos: http://jqueryui.com/button/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/button.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.widget( "ui.button", {
		version: "1.12.1",
		defaultElement: "<button>",
		options: {
			classes: {
				"ui-button": "ui-corner-all"
			},
			disabled: null,
			icon: null,
			iconPosition: "beginning",
			label: null,
			showLabel: true
		},
	
		_getCreateOptions: function() {
			var disabled,
	
				// This is to support cases like in jQuery Mobile where the base widget does have
				// an implementation of _getCreateOptions
				options = this._super() || {};
	
			this.isInput = this.element.is( "input" );
	
			disabled = this.element[ 0 ].disabled;
			if ( disabled != null ) {
				options.disabled = disabled;
			}
	
			this.originalLabel = this.isInput ? this.element.val() : this.element.html();
			if ( this.originalLabel ) {
				options.label = this.originalLabel;
			}
	
			return options;
		},
	
		_create: function() {
			if ( !this.option.showLabel & !this.options.icon ) {
				this.options.showLabel = true;
			}
	
			// We have to check the option again here even though we did in _getCreateOptions,
			// because null may have been passed on init which would override what was set in
			// _getCreateOptions
			if ( this.options.disabled == null ) {
				this.options.disabled = this.element[ 0 ].disabled || false;
			}
	
			this.hasTitle = !!this.element.attr( "title" );
	
			// Check to see if the label needs to be set or if its already correct
			if ( this.options.label && this.options.label !== this.originalLabel ) {
				if ( this.isInput ) {
					this.element.val( this.options.label );
				} else {
					this.element.html( this.options.label );
				}
			}
			this._addClass( "ui-button", "ui-widget" );
			this._setOption( "disabled", this.options.disabled );
			this._enhance();
	
			if ( this.element.is( "a" ) ) {
				this._on( {
					"keyup": function( event ) {
						if ( event.keyCode === $.ui.keyCode.SPACE ) {
							event.preventDefault();
	
							// Support: PhantomJS <= 1.9, IE 8 Only
							// If a native click is available use it so we actually cause navigation
							// otherwise just trigger a click event
							if ( this.element[ 0 ].click ) {
								this.element[ 0 ].click();
							} else {
								this.element.trigger( "click" );
							}
						}
					}
				} );
			}
		},
	
		_enhance: function() {
			if ( !this.element.is( "button" ) ) {
				this.element.attr( "role", "button" );
			}
	
			if ( this.options.icon ) {
				this._updateIcon( "icon", this.options.icon );
				this._updateTooltip();
			}
		},
	
		_updateTooltip: function() {
			this.title = this.element.attr( "title" );
	
			if ( !this.options.showLabel && !this.title ) {
				this.element.attr( "title", this.options.label );
			}
		},
	
		_updateIcon: function( option, value ) {
			var icon = option !== "iconPosition",
				position = icon ? this.options.iconPosition : value,
				displayBlock = position === "top" || position === "bottom";
	
			// Create icon
			if ( !this.icon ) {
				this.icon = $( "<span>" );
	
				this._addClass( this.icon, "ui-button-icon", "ui-icon" );
	
				if ( !this.options.showLabel ) {
					this._addClass( "ui-button-icon-only" );
				}
			} else if ( icon ) {
	
				// If we are updating the icon remove the old icon class
				this._removeClass( this.icon, null, this.options.icon );
			}
	
			// If we are updating the icon add the new icon class
			if ( icon ) {
				this._addClass( this.icon, null, value );
			}
	
			this._attachIcon( position );
	
			// If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
			// the iconSpace if there is one.
			if ( displayBlock ) {
				this._addClass( this.icon, null, "ui-widget-icon-block" );
				if ( this.iconSpace ) {
					this.iconSpace.remove();
				}
			} else {
	
				// Position is beginning or end so remove the ui-widget-icon-block class and add the
				// space if it does not exist
				if ( !this.iconSpace ) {
					this.iconSpace = $( "<span> </span>" );
					this._addClass( this.iconSpace, "ui-button-icon-space" );
				}
				this._removeClass( this.icon, null, "ui-wiget-icon-block" );
				this._attachIconSpace( position );
			}
		},
	
		_destroy: function() {
			this.element.removeAttr( "role" );
	
			if ( this.icon ) {
				this.icon.remove();
			}
			if ( this.iconSpace ) {
				this.iconSpace.remove();
			}
			if ( !this.hasTitle ) {
				this.element.removeAttr( "title" );
			}
		},
	
		_attachIconSpace: function( iconPosition ) {
			this.icon[ /^(?:end|bottom)/.test( iconPosition ) ? "before" : "after" ]( this.iconSpace );
		},
	
		_attachIcon: function( iconPosition ) {
			this.element[ /^(?:end|bottom)/.test( iconPosition ) ? "append" : "prepend" ]( this.icon );
		},
	
		_setOptions: function( options ) {
			var newShowLabel = options.showLabel === undefined ?
					this.options.showLabel :
					options.showLabel,
				newIcon = options.icon === undefined ? this.options.icon : options.icon;
	
			if ( !newShowLabel && !newIcon ) {
				options.showLabel = true;
			}
			this._super( options );
		},
	
		_setOption: function( key, value ) {
			if ( key === "icon" ) {
				if ( value ) {
					this._updateIcon( key, value );
				} else if ( this.icon ) {
					this.icon.remove();
					if ( this.iconSpace ) {
						this.iconSpace.remove();
					}
				}
			}
	
			if ( key === "iconPosition" ) {
				this._updateIcon( key, value );
			}
	
			// Make sure we can't end up with a button that has neither text nor icon
			if ( key === "showLabel" ) {
					this._toggleClass( "ui-button-icon-only", null, !value );
					this._updateTooltip();
			}
	
			if ( key === "label" ) {
				if ( this.isInput ) {
					this.element.val( value );
				} else {
	
					// If there is an icon, append it, else nothing then append the value
					// this avoids removal of the icon when setting label text
					this.element.html( value );
					if ( this.icon ) {
						this._attachIcon( this.options.iconPosition );
						this._attachIconSpace( this.options.iconPosition );
					}
				}
			}
	
			this._super( key, value );
	
			if ( key === "disabled" ) {
				this._toggleClass( null, "ui-state-disabled", value );
				this.element[ 0 ].disabled = value;
				if ( value ) {
					this.element.blur();
				}
			}
		},
	
		refresh: function() {
	
			// Make sure to only check disabled if its an element that supports this otherwise
			// check for the disabled class to determine state
			var isDisabled = this.element.is( "input, button" ) ?
				this.element[ 0 ].disabled : this.element.hasClass( "ui-button-disabled" );
	
			if ( isDisabled !== this.options.disabled ) {
				this._setOptions( { disabled: isDisabled } );
			}
	
			this._updateTooltip();
		}
	} );
	
	// DEPRECATED
	if ( $.uiBackCompat !== false ) {
	
		// Text and Icons options
		$.widget( "ui.button", $.ui.button, {
			options: {
				text: true,
				icons: {
					primary: null,
					secondary: null
				}
			},
	
			_create: function() {
				if ( this.options.showLabel && !this.options.text ) {
					this.options.showLabel = this.options.text;
				}
				if ( !this.options.showLabel && this.options.text ) {
					this.options.text = this.options.showLabel;
				}
				if ( !this.options.icon && ( this.options.icons.primary ||
						this.options.icons.secondary ) ) {
					if ( this.options.icons.primary ) {
						this.options.icon = this.options.icons.primary;
					} else {
						this.options.icon = this.options.icons.secondary;
						this.options.iconPosition = "end";
					}
				} else if ( this.options.icon ) {
					this.options.icons.primary = this.options.icon;
				}
				this._super();
			},
	
			_setOption: function( key, value ) {
				if ( key === "text" ) {
					this._super( "showLabel", value );
					return;
				}
				if ( key === "showLabel" ) {
					this.options.text = value;
				}
				if ( key === "icon" ) {
					this.options.icons.primary = value;
				}
				if ( key === "icons" ) {
					if ( value.primary ) {
						this._super( "icon", value.primary );
						this._super( "iconPosition", "beginning" );
					} else if ( value.secondary ) {
						this._super( "icon", value.secondary );
						this._super( "iconPosition", "end" );
					}
				}
				this._superApply( arguments );
			}
		} );
	
		$.fn.button = ( function( orig ) {
			return function() {
				if ( !this.length || ( this.length && this[ 0 ].tagName !== "INPUT" ) ||
						( this.length && this[ 0 ].tagName === "INPUT" && (
							this.attr( "type" ) !== "checkbox" && this.attr( "type" ) !== "radio"
						) ) ) {
					return orig.apply( this, arguments );
				}
				if ( !$.ui.checkboxradio ) {
					$.error( "Checkboxradio widget missing" );
				}
				if ( arguments.length === 0 ) {
					return this.checkboxradio( {
						"icon": false
					} );
				}
				return this.checkboxradio.apply( this, arguments );
			};
		} )( $.fn.button );
	
		$.fn.buttonset = function() {
			if ( !$.ui.controlgroup ) {
				$.error( "Controlgroup widget missing" );
			}
			if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" && arguments[ 2 ] ) {
				return this.controlgroup.apply( this,
					[ arguments[ 0 ], "items.button", arguments[ 2 ] ] );
			}
			if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" ) {
				return this.controlgroup.apply( this, [ arguments[ 0 ], "items.button" ] );
			}
			if ( typeof arguments[ 0 ] === "object" && arguments[ 0 ].items ) {
				arguments[ 0 ].items = {
					button: arguments[ 0 ].items
				};
			}
			return this.controlgroup.apply( this, arguments );
		};
	}
	
	var widgetsButton = $.ui.button;
	
	
	// jscs:disable maximumLineLength
	/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
	/*!
	 * jQuery UI Datepicker 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Datepicker
	//>>group: Widgets
	//>>description: Displays a calendar from an input or inline for selecting dates.
	//>>docs: http://api.jqueryui.com/datepicker/
	//>>demos: http://jqueryui.com/datepicker/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/datepicker.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.extend( $.ui, { datepicker: { version: "1.12.1" } } );
	
	var datepicker_instActive;
	
	function datepicker_getZindex( elem ) {
		var position, value;
		while ( elem.length && elem[ 0 ] !== document ) {
	
			// Ignore z-index if position is set to a value where z-index is ignored by the browser
			// This makes behavior of this function consistent across browsers
			// WebKit always returns auto if the element is positioned
			position = elem.css( "position" );
			if ( position === "absolute" || position === "relative" || position === "fixed" ) {
	
				// IE returns 0 when zIndex is not specified
				// other browsers return a string
				// we ignore the case of nested elements with an explicit value of 0
				// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
				value = parseInt( elem.css( "zIndex" ), 10 );
				if ( !isNaN( value ) && value !== 0 ) {
					return value;
				}
			}
			elem = elem.parent();
		}
	
		return 0;
	}
	/* Date picker manager.
	   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
	   Settings for (groups of) date pickers are maintained in an instance object,
	   allowing multiple different settings on the same page. */
	
	function Datepicker() {
		this._curInst = null; // The current instance in use
		this._keyEvent = false; // If the last event was a key event
		this._disabledInputs = []; // List of date picker inputs that have been disabled
		this._datepickerShowing = false; // True if the popup picker is showing , false if not
		this._inDialog = false; // True if showing within a "dialog", false if not
		this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
		this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
		this._appendClass = "ui-datepicker-append"; // The name of the append marker class
		this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
		this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
		this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
		this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
		this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
		this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
		this.regional = []; // Available regional settings, indexed by language code
		this.regional[ "" ] = { // Default regional settings
			closeText: "Done", // Display text for close link
			prevText: "Prev", // Display text for previous month link
			nextText: "Next", // Display text for next month link
			currentText: "Today", // Display text for current month link
			monthNames: [ "January","February","March","April","May","June",
				"July","August","September","October","November","December" ], // Names of months for drop-down and formatting
			monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
			dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
			dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
			dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ], // Column headings for days starting at Sunday
			weekHeader: "Wk", // Column header for week of the year
			dateFormat: "mm/dd/yy", // See format options on parseDate
			firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
			isRTL: false, // True if right-to-left language, false if left-to-right
			showMonthAfterYear: false, // True if the year select precedes month, false for month then year
			yearSuffix: "" // Additional text to append to the year in the month headers
		};
		this._defaults = { // Global defaults for all the date picker instances
			showOn: "focus", // "focus" for popup on focus,
				// "button" for trigger button, or "both" for either
			showAnim: "fadeIn", // Name of jQuery animation for popup
			showOptions: {}, // Options for enhanced animations
			defaultDate: null, // Used when field is blank: actual date,
				// +/-number for offset from today, null for today
			appendText: "", // Display text following the input box, e.g. showing the format
			buttonText: "...", // Text for trigger button
			buttonImage: "", // URL for trigger button image
			buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
			hideIfNoPrevNext: false, // True to hide next/previous month links
				// if not applicable, false to just disable them
			navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
			gotoCurrent: false, // True if today link goes back to current selection instead
			changeMonth: false, // True if month can be selected directly, false if only prev/next
			changeYear: false, // True if year can be selected directly, false if only prev/next
			yearRange: "c-10:c+10", // Range of years to display in drop-down,
				// either relative to today's year (-nn:+nn), relative to currently displayed year
				// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
			showOtherMonths: false, // True to show dates in other months, false to leave blank
			selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
			showWeek: false, // True to show week of the year, false to not show it
			calculateWeek: this.iso8601Week, // How to calculate the week of the year,
				// takes a Date and returns the number of the week for it
			shortYearCutoff: "+10", // Short year values < this are in the current century,
				// > this are in the previous century,
				// string value starting with "+" for current year + value
			minDate: null, // The earliest selectable date, or null for no limit
			maxDate: null, // The latest selectable date, or null for no limit
			duration: "fast", // Duration of display/closure
			beforeShowDay: null, // Function that takes a date and returns an array with
				// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
				// [2] = cell title (optional), e.g. $.datepicker.noWeekends
			beforeShow: null, // Function that takes an input field and
				// returns a set of custom settings for the date picker
			onSelect: null, // Define a callback function when a date is selected
			onChangeMonthYear: null, // Define a callback function when the month or year is changed
			onClose: null, // Define a callback function when the datepicker is closed
			numberOfMonths: 1, // Number of months to show at a time
			showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
			stepMonths: 1, // Number of months to step back/forward
			stepBigMonths: 12, // Number of months to step back/forward for the big links
			altField: "", // Selector for an alternate field to store selected dates into
			altFormat: "", // The date format to use for the alternate field
			constrainInput: true, // The input is constrained by the current date format
			showButtonPanel: false, // True to show button panel, false to not show it
			autoSize: false, // True to size the input for the date format, false to leave as is
			disabled: false // The initial disabled state
		};
		$.extend( this._defaults, this.regional[ "" ] );
		this.regional.en = $.extend( true, {}, this.regional[ "" ] );
		this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
		this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
	}
	
	$.extend( Datepicker.prototype, {
		/* Class name added to elements to indicate already configured with a date picker. */
		markerClassName: "hasDatepicker",
	
		//Keep track of the maximum number of rows displayed (see #7043)
		maxRows: 4,
	
		// TODO rename to "widget" when switching to widget factory
		_widgetDatepicker: function() {
			return this.dpDiv;
		},
	
		/* Override the default settings for all instances of the date picker.
		 * @param  settings  object - the new settings to use as defaults (anonymous object)
		 * @return the manager object
		 */
		setDefaults: function( settings ) {
			datepicker_extendRemove( this._defaults, settings || {} );
			return this;
		},
	
		/* Attach the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
		 */
		_attachDatepicker: function( target, settings ) {
			var nodeName, inline, inst;
			nodeName = target.nodeName.toLowerCase();
			inline = ( nodeName === "div" || nodeName === "span" );
			if ( !target.id ) {
				this.uuid += 1;
				target.id = "dp" + this.uuid;
			}
			inst = this._newInst( $( target ), inline );
			inst.settings = $.extend( {}, settings || {} );
			if ( nodeName === "input" ) {
				this._connectDatepicker( target, inst );
			} else if ( inline ) {
				this._inlineDatepicker( target, inst );
			}
		},
	
		/* Create a new instance object. */
		_newInst: function( target, inline ) {
			var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
			return { id: id, input: target, // associated target
				selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
				drawMonth: 0, drawYear: 0, // month being drawn
				inline: inline, // is datepicker inline or not
				dpDiv: ( !inline ? this.dpDiv : // presentation div
				datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
		},
	
		/* Attach the date picker to an input field. */
		_connectDatepicker: function( target, inst ) {
			var input = $( target );
			inst.append = $( [] );
			inst.trigger = $( [] );
			if ( input.hasClass( this.markerClassName ) ) {
				return;
			}
			this._attachments( input, inst );
			input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
				on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
			this._autoSize( inst );
			$.data( target, "datepicker", inst );
	
			//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
			if ( inst.settings.disabled ) {
				this._disableDatepicker( target );
			}
		},
	
		/* Make attachments based on settings. */
		_attachments: function( input, inst ) {
			var showOn, buttonText, buttonImage,
				appendText = this._get( inst, "appendText" ),
				isRTL = this._get( inst, "isRTL" );
	
			if ( inst.append ) {
				inst.append.remove();
			}
			if ( appendText ) {
				inst.append = $( "<span class='" + this._appendClass + "'>" + appendText + "</span>" );
				input[ isRTL ? "before" : "after" ]( inst.append );
			}
	
			input.off( "focus", this._showDatepicker );
	
			if ( inst.trigger ) {
				inst.trigger.remove();
			}
	
			showOn = this._get( inst, "showOn" );
			if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
				input.on( "focus", this._showDatepicker );
			}
			if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
				buttonText = this._get( inst, "buttonText" );
				buttonImage = this._get( inst, "buttonImage" );
				inst.trigger = $( this._get( inst, "buttonImageOnly" ) ?
					$( "<img/>" ).addClass( this._triggerClass ).
						attr( { src: buttonImage, alt: buttonText, title: buttonText } ) :
					$( "<button type='button'></button>" ).addClass( this._triggerClass ).
						html( !buttonImage ? buttonText : $( "<img/>" ).attr(
						{ src:buttonImage, alt:buttonText, title:buttonText } ) ) );
				input[ isRTL ? "before" : "after" ]( inst.trigger );
				inst.trigger.on( "click", function() {
					if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
						$.datepicker._hideDatepicker();
					} else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
						$.datepicker._hideDatepicker();
						$.datepicker._showDatepicker( input[ 0 ] );
					} else {
						$.datepicker._showDatepicker( input[ 0 ] );
					}
					return false;
				} );
			}
		},
	
		/* Apply the maximum length for the date format. */
		_autoSize: function( inst ) {
			if ( this._get( inst, "autoSize" ) && !inst.inline ) {
				var findMax, max, maxI, i,
					date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
					dateFormat = this._get( inst, "dateFormat" );
	
				if ( dateFormat.match( /[DM]/ ) ) {
					findMax = function( names ) {
						max = 0;
						maxI = 0;
						for ( i = 0; i < names.length; i++ ) {
							if ( names[ i ].length > max ) {
								max = names[ i ].length;
								maxI = i;
							}
						}
						return maxI;
					};
					date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
						"monthNames" : "monthNamesShort" ) ) ) );
					date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
						"dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
				}
				inst.input.attr( "size", this._formatDate( inst, date ).length );
			}
		},
	
		/* Attach an inline date picker to a div. */
		_inlineDatepicker: function( target, inst ) {
			var divSpan = $( target );
			if ( divSpan.hasClass( this.markerClassName ) ) {
				return;
			}
			divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
			$.data( target, "datepicker", inst );
			this._setDate( inst, this._getDefaultDate( inst ), true );
			this._updateDatepicker( inst );
			this._updateAlternate( inst );
	
			//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
			if ( inst.settings.disabled ) {
				this._disableDatepicker( target );
			}
	
			// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
			// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
			inst.dpDiv.css( "display", "block" );
		},
	
		/* Pop-up the date picker in a "dialog" box.
		 * @param  input element - ignored
		 * @param  date	string or Date - the initial date to display
		 * @param  onSelect  function - the function to call when a date is selected
		 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
		 * @param  pos int[2] - coordinates for the dialog's position within the screen or
		 *					event - with x/y coordinates or
		 *					leave empty for default (screen centre)
		 * @return the manager object
		 */
		_dialogDatepicker: function( input, date, onSelect, settings, pos ) {
			var id, browserWidth, browserHeight, scrollX, scrollY,
				inst = this._dialogInst; // internal instance
	
			if ( !inst ) {
				this.uuid += 1;
				id = "dp" + this.uuid;
				this._dialogInput = $( "<input type='text' id='" + id +
					"' style='position: absolute; top: -100px; width: 0px;'/>" );
				this._dialogInput.on( "keydown", this._doKeyDown );
				$( "body" ).append( this._dialogInput );
				inst = this._dialogInst = this._newInst( this._dialogInput, false );
				inst.settings = {};
				$.data( this._dialogInput[ 0 ], "datepicker", inst );
			}
			datepicker_extendRemove( inst.settings, settings || {} );
			date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
			this._dialogInput.val( date );
	
			this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
			if ( !this._pos ) {
				browserWidth = document.documentElement.clientWidth;
				browserHeight = document.documentElement.clientHeight;
				scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
				scrollY = document.documentElement.scrollTop || document.body.scrollTop;
				this._pos = // should use actual width/height below
					[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
			}
	
			// Move input on screen for focus, but hidden behind dialog
			this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
			inst.settings.onSelect = onSelect;
			this._inDialog = true;
			this.dpDiv.addClass( this._dialogClass );
			this._showDatepicker( this._dialogInput[ 0 ] );
			if ( $.blockUI ) {
				$.blockUI( this.dpDiv );
			}
			$.data( this._dialogInput[ 0 ], "datepicker", inst );
			return this;
		},
	
		/* Detach a datepicker from its control.
		 * @param  target	element - the target input field or division or span
		 */
		_destroyDatepicker: function( target ) {
			var nodeName,
				$target = $( target ),
				inst = $.data( target, "datepicker" );
	
			if ( !$target.hasClass( this.markerClassName ) ) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			$.removeData( target, "datepicker" );
			if ( nodeName === "input" ) {
				inst.append.remove();
				inst.trigger.remove();
				$target.removeClass( this.markerClassName ).
					off( "focus", this._showDatepicker ).
					off( "keydown", this._doKeyDown ).
					off( "keypress", this._doKeyPress ).
					off( "keyup", this._doKeyUp );
			} else if ( nodeName === "div" || nodeName === "span" ) {
				$target.removeClass( this.markerClassName ).empty();
			}
	
			if ( datepicker_instActive === inst ) {
				datepicker_instActive = null;
			}
		},
	
		/* Enable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */
		_enableDatepicker: function( target ) {
			var nodeName, inline,
				$target = $( target ),
				inst = $.data( target, "datepicker" );
	
			if ( !$target.hasClass( this.markerClassName ) ) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			if ( nodeName === "input" ) {
				target.disabled = false;
				inst.trigger.filter( "button" ).
					each( function() { this.disabled = false; } ).end().
					filter( "img" ).css( { opacity: "1.0", cursor: "" } );
			} else if ( nodeName === "div" || nodeName === "span" ) {
				inline = $target.children( "." + this._inlineClass );
				inline.children().removeClass( "ui-state-disabled" );
				inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
					prop( "disabled", false );
			}
			this._disabledInputs = $.map( this._disabledInputs,
				function( value ) { return ( value === target ? null : value ); } ); // delete entry
		},
	
		/* Disable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */
		_disableDatepicker: function( target ) {
			var nodeName, inline,
				$target = $( target ),
				inst = $.data( target, "datepicker" );
	
			if ( !$target.hasClass( this.markerClassName ) ) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			if ( nodeName === "input" ) {
				target.disabled = true;
				inst.trigger.filter( "button" ).
					each( function() { this.disabled = true; } ).end().
					filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
			} else if ( nodeName === "div" || nodeName === "span" ) {
				inline = $target.children( "." + this._inlineClass );
				inline.children().addClass( "ui-state-disabled" );
				inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
					prop( "disabled", true );
			}
			this._disabledInputs = $.map( this._disabledInputs,
				function( value ) { return ( value === target ? null : value ); } ); // delete entry
			this._disabledInputs[ this._disabledInputs.length ] = target;
		},
	
		/* Is the first field in a jQuery collection disabled as a datepicker?
		 * @param  target	element - the target input field or division or span
		 * @return boolean - true if disabled, false if enabled
		 */
		_isDisabledDatepicker: function( target ) {
			if ( !target ) {
				return false;
			}
			for ( var i = 0; i < this._disabledInputs.length; i++ ) {
				if ( this._disabledInputs[ i ] === target ) {
					return true;
				}
			}
			return false;
		},
	
		/* Retrieve the instance data for the target control.
		 * @param  target  element - the target input field or division or span
		 * @return  object - the associated instance data
		 * @throws  error if a jQuery problem getting data
		 */
		_getInst: function( target ) {
			try {
				return $.data( target, "datepicker" );
			}
			catch ( err ) {
				throw "Missing instance data for this datepicker";
			}
		},
	
		/* Update or retrieve the settings for a date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 * @param  name	object - the new settings to update or
		 *				string - the name of the setting to change or retrieve,
		 *				when retrieving also "all" for all instance settings or
		 *				"defaults" for all global defaults
		 * @param  value   any - the new value for the setting
		 *				(omit if above is an object or to retrieve a value)
		 */
		_optionDatepicker: function( target, name, value ) {
			var settings, date, minDate, maxDate,
				inst = this._getInst( target );
	
			if ( arguments.length === 2 && typeof name === "string" ) {
				return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
					( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
					this._get( inst, name ) ) : null ) );
			}
	
			settings = name || {};
			if ( typeof name === "string" ) {
				settings = {};
				settings[ name ] = value;
			}
	
			if ( inst ) {
				if ( this._curInst === inst ) {
					this._hideDatepicker();
				}
	
				date = this._getDateDatepicker( target, true );
				minDate = this._getMinMaxDate( inst, "min" );
				maxDate = this._getMinMaxDate( inst, "max" );
				datepicker_extendRemove( inst.settings, settings );
	
				// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
				if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
					inst.settings.minDate = this._formatDate( inst, minDate );
				}
				if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
					inst.settings.maxDate = this._formatDate( inst, maxDate );
				}
				if ( "disabled" in settings ) {
					if ( settings.disabled ) {
						this._disableDatepicker( target );
					} else {
						this._enableDatepicker( target );
					}
				}
				this._attachments( $( target ), inst );
				this._autoSize( inst );
				this._setDate( inst, date );
				this._updateAlternate( inst );
				this._updateDatepicker( inst );
			}
		},
	
		// Change method deprecated
		_changeDatepicker: function( target, name, value ) {
			this._optionDatepicker( target, name, value );
		},
	
		/* Redraw the date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 */
		_refreshDatepicker: function( target ) {
			var inst = this._getInst( target );
			if ( inst ) {
				this._updateDatepicker( inst );
			}
		},
	
		/* Set the dates for a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  date	Date - the new date
		 */
		_setDateDatepicker: function( target, date ) {
			var inst = this._getInst( target );
			if ( inst ) {
				this._setDate( inst, date );
				this._updateDatepicker( inst );
				this._updateAlternate( inst );
			}
		},
	
		/* Get the date(s) for the first entry in a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  noDefault boolean - true if no default date is to be used
		 * @return Date - the current date
		 */
		_getDateDatepicker: function( target, noDefault ) {
			var inst = this._getInst( target );
			if ( inst && !inst.inline ) {
				this._setDateFromField( inst, noDefault );
			}
			return ( inst ? this._getDate( inst ) : null );
		},
	
		/* Handle keystrokes. */
		_doKeyDown: function( event ) {
			var onSelect, dateStr, sel,
				inst = $.datepicker._getInst( event.target ),
				handled = true,
				isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );
	
			inst._keyEvent = true;
			if ( $.datepicker._datepickerShowing ) {
				switch ( event.keyCode ) {
					case 9: $.datepicker._hideDatepicker();
							handled = false;
							break; // hide on tab out
					case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
										$.datepicker._currentClass + ")", inst.dpDiv );
							if ( sel[ 0 ] ) {
								$.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
							}
	
							onSelect = $.datepicker._get( inst, "onSelect" );
							if ( onSelect ) {
								dateStr = $.datepicker._formatDate( inst );
	
								// Trigger custom callback
								onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
							} else {
								$.datepicker._hideDatepicker();
							}
	
							return false; // don't submit the form
					case 27: $.datepicker._hideDatepicker();
							break; // hide on escape
					case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								-$.datepicker._get( inst, "stepBigMonths" ) :
								-$.datepicker._get( inst, "stepMonths" ) ), "M" );
							break; // previous month/year on page up/+ ctrl
					case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								+$.datepicker._get( inst, "stepBigMonths" ) :
								+$.datepicker._get( inst, "stepMonths" ) ), "M" );
							break; // next month/year on page down/+ ctrl
					case 35: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._clearDate( event.target );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // clear on ctrl or command +end
					case 36: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._gotoToday( event.target );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // current on ctrl or command +home
					case 37: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
							}
							handled = event.ctrlKey || event.metaKey;
	
							// -1 day on ctrl or command +left
							if ( event.originalEvent.altKey ) {
								$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
									-$.datepicker._get( inst, "stepBigMonths" ) :
									-$.datepicker._get( inst, "stepMonths" ) ), "M" );
							}
	
							// next month/year on alt +left on Mac
							break;
					case 38: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, -7, "D" );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // -1 week on ctrl or command +up
					case 39: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
							}
							handled = event.ctrlKey || event.metaKey;
	
							// +1 day on ctrl or command +right
							if ( event.originalEvent.altKey ) {
								$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
									+$.datepicker._get( inst, "stepBigMonths" ) :
									+$.datepicker._get( inst, "stepMonths" ) ), "M" );
							}
	
							// next month/year on alt +right
							break;
					case 40: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, +7, "D" );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // +1 week on ctrl or command +down
					default: handled = false;
				}
			} else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
				$.datepicker._showDatepicker( this );
			} else {
				handled = false;
			}
	
			if ( handled ) {
				event.preventDefault();
				event.stopPropagation();
			}
		},
	
		/* Filter entered characters - based on date format. */
		_doKeyPress: function( event ) {
			var chars, chr,
				inst = $.datepicker._getInst( event.target );
	
			if ( $.datepicker._get( inst, "constrainInput" ) ) {
				chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
				chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
				return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
			}
		},
	
		/* Synchronise manual entry and field/alternate field. */
		_doKeyUp: function( event ) {
			var date,
				inst = $.datepicker._getInst( event.target );
	
			if ( inst.input.val() !== inst.lastVal ) {
				try {
					date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
						( inst.input ? inst.input.val() : null ),
						$.datepicker._getFormatConfig( inst ) );
	
					if ( date ) { // only if valid
						$.datepicker._setDateFromField( inst );
						$.datepicker._updateAlternate( inst );
						$.datepicker._updateDatepicker( inst );
					}
				}
				catch ( err ) {
				}
			}
			return true;
		},
	
		/* Pop-up the date picker for a given input field.
		 * If false returned from beforeShow event handler do not show.
		 * @param  input  element - the input field attached to the date picker or
		 *					event - if triggered by focus
		 */
		_showDatepicker: function( input ) {
			input = input.target || input;
			if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
				input = $( "input", input.parentNode )[ 0 ];
			}
	
			if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
				return;
			}
	
			var inst, beforeShow, beforeShowSettings, isFixed,
				offset, showAnim, duration;
	
			inst = $.datepicker._getInst( input );
			if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
				$.datepicker._curInst.dpDiv.stop( true, true );
				if ( inst && $.datepicker._datepickerShowing ) {
					$.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
				}
			}
	
			beforeShow = $.datepicker._get( inst, "beforeShow" );
			beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
			if ( beforeShowSettings === false ) {
				return;
			}
			datepicker_extendRemove( inst.settings, beforeShowSettings );
	
			inst.lastVal = null;
			$.datepicker._lastInput = input;
			$.datepicker._setDateFromField( inst );
	
			if ( $.datepicker._inDialog ) { // hide cursor
				input.value = "";
			}
			if ( !$.datepicker._pos ) { // position below input
				$.datepicker._pos = $.datepicker._findPos( input );
				$.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
			}
	
			isFixed = false;
			$( input ).parents().each( function() {
				isFixed |= $( this ).css( "position" ) === "fixed";
				return !isFixed;
			} );
	
			offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
			$.datepicker._pos = null;
	
			//to avoid flashes on Firefox
			inst.dpDiv.empty();
	
			// determine sizing offscreen
			inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
			$.datepicker._updateDatepicker( inst );
	
			// fix width for dynamic number of date pickers
			// and adjust position before showing
			offset = $.datepicker._checkOffset( inst, offset, isFixed );
			inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
				"static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
				left: offset.left + "px", top: offset.top + "px" } );
	
			if ( !inst.inline ) {
				showAnim = $.datepicker._get( inst, "showAnim" );
				duration = $.datepicker._get( inst, "duration" );
				inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
				$.datepicker._datepickerShowing = true;
	
				if ( $.effects && $.effects.effect[ showAnim ] ) {
					inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
				} else {
					inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
				}
	
				if ( $.datepicker._shouldFocusInput( inst ) ) {
					inst.input.trigger( "focus" );
				}
	
				$.datepicker._curInst = inst;
			}
		},
	
		/* Generate the date picker content. */
		_updateDatepicker: function( inst ) {
			this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
			datepicker_instActive = inst; // for delegate hover events
			inst.dpDiv.empty().append( this._generateHTML( inst ) );
			this._attachHandlers( inst );
	
			var origyearshtml,
				numMonths = this._getNumberOfMonths( inst ),
				cols = numMonths[ 1 ],
				width = 17,
				activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );
	
			if ( activeCell.length > 0 ) {
				datepicker_handleMouseover.apply( activeCell.get( 0 ) );
			}
	
			inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
			if ( cols > 1 ) {
				inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
			}
			inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
				"Class" ]( "ui-datepicker-multi" );
			inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
				"Class" ]( "ui-datepicker-rtl" );
	
			if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.trigger( "focus" );
			}
	
			// Deffered render of the years select (to avoid flashes on Firefox)
			if ( inst.yearshtml ) {
				origyearshtml = inst.yearshtml;
				setTimeout( function() {
	
					//assure that inst.yearshtml didn't change.
					if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
						inst.dpDiv.find( "select.ui-datepicker-year:first" ).replaceWith( inst.yearshtml );
					}
					origyearshtml = inst.yearshtml = null;
				}, 0 );
			}
		},
	
		// #6694 - don't focus the input if it's already focused
		// this breaks the change event in IE
		// Support: IE and jQuery <1.9
		_shouldFocusInput: function( inst ) {
			return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
		},
	
		/* Check positioning to remain on screen. */
		_checkOffset: function( inst, offset, isFixed ) {
			var dpWidth = inst.dpDiv.outerWidth(),
				dpHeight = inst.dpDiv.outerHeight(),
				inputWidth = inst.input ? inst.input.outerWidth() : 0,
				inputHeight = inst.input ? inst.input.outerHeight() : 0,
				viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
				viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );
	
			offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
			offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
			offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;
	
			// Now check if datepicker is showing outside window viewport - move to a better place if so.
			offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
				Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
			offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
				Math.abs( dpHeight + inputHeight ) : 0 );
	
			return offset;
		},
	
		/* Find an object's position on the screen. */
		_findPos: function( obj ) {
			var position,
				inst = this._getInst( obj ),
				isRTL = this._get( inst, "isRTL" );
	
			while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden( obj ) ) ) {
				obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
			}
	
			position = $( obj ).offset();
			return [ position.left, position.top ];
		},
	
		/* Hide the date picker from view.
		 * @param  input  element - the input field attached to the date picker
		 */
		_hideDatepicker: function( input ) {
			var showAnim, duration, postProcess, onClose,
				inst = this._curInst;
	
			if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
				return;
			}
	
			if ( this._datepickerShowing ) {
				showAnim = this._get( inst, "showAnim" );
				duration = this._get( inst, "duration" );
				postProcess = function() {
					$.datepicker._tidyDialog( inst );
				};
	
				// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
				if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
					inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
				} else {
					inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
						( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
				}
	
				if ( !showAnim ) {
					postProcess();
				}
				this._datepickerShowing = false;
	
				onClose = this._get( inst, "onClose" );
				if ( onClose ) {
					onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
				}
	
				this._lastInput = null;
				if ( this._inDialog ) {
					this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
					if ( $.blockUI ) {
						$.unblockUI();
						$( "body" ).append( this.dpDiv );
					}
				}
				this._inDialog = false;
			}
		},
	
		/* Tidy up after a dialog display. */
		_tidyDialog: function( inst ) {
			inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
		},
	
		/* Close date picker if clicked elsewhere. */
		_checkExternalClick: function( event ) {
			if ( !$.datepicker._curInst ) {
				return;
			}
	
			var $target = $( event.target ),
				inst = $.datepicker._getInst( $target[ 0 ] );
	
			if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
					$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
					!$target.hasClass( $.datepicker.markerClassName ) &&
					!$target.closest( "." + $.datepicker._triggerClass ).length &&
					$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
				( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
					$.datepicker._hideDatepicker();
			}
		},
	
		/* Adjust one of the date sub-fields. */
		_adjustDate: function( id, offset, period ) {
			var target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
				return;
			}
			this._adjustInstDate( inst, offset +
				( period === "M" ? this._get( inst, "showCurrentAtPos" ) : 0 ), // undo positioning
				period );
			this._updateDatepicker( inst );
		},
	
		/* Action for current link. */
		_gotoToday: function( id ) {
			var date,
				target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
				inst.selectedDay = inst.currentDay;
				inst.drawMonth = inst.selectedMonth = inst.currentMonth;
				inst.drawYear = inst.selectedYear = inst.currentYear;
			} else {
				date = new Date();
				inst.selectedDay = date.getDate();
				inst.drawMonth = inst.selectedMonth = date.getMonth();
				inst.drawYear = inst.selectedYear = date.getFullYear();
			}
			this._notifyChange( inst );
			this._adjustDate( target );
		},
	
		/* Action for selecting a new month/year. */
		_selectMonthYear: function( id, select, period ) {
			var target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
			inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
				parseInt( select.options[ select.selectedIndex ].value, 10 );
	
			this._notifyChange( inst );
			this._adjustDate( target );
		},
	
		/* Action for selecting a day. */
		_selectDay: function( id, month, year, td ) {
			var inst,
				target = $( id );
	
			if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
				return;
			}
	
			inst = this._getInst( target[ 0 ] );
			inst.selectedDay = inst.currentDay = $( "a", td ).html();
			inst.selectedMonth = inst.currentMonth = month;
			inst.selectedYear = inst.currentYear = year;
			this._selectDate( id, this._formatDate( inst,
				inst.currentDay, inst.currentMonth, inst.currentYear ) );
		},
	
		/* Erase the input field and hide the date picker. */
		_clearDate: function( id ) {
			var target = $( id );
			this._selectDate( target, "" );
		},
	
		/* Update the input field with the selected date. */
		_selectDate: function( id, dateStr ) {
			var onSelect,
				target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
			if ( inst.input ) {
				inst.input.val( dateStr );
			}
			this._updateAlternate( inst );
	
			onSelect = this._get( inst, "onSelect" );
			if ( onSelect ) {
				onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );  // trigger custom callback
			} else if ( inst.input ) {
				inst.input.trigger( "change" ); // fire the change event
			}
	
			if ( inst.inline ) {
				this._updateDatepicker( inst );
			} else {
				this._hideDatepicker();
				this._lastInput = inst.input[ 0 ];
				if ( typeof( inst.input[ 0 ] ) !== "object" ) {
					inst.input.trigger( "focus" ); // restore focus
				}
				this._lastInput = null;
			}
		},
	
		/* Update any alternate field to synchronise with the main field. */
		_updateAlternate: function( inst ) {
			var altFormat, date, dateStr,
				altField = this._get( inst, "altField" );
	
			if ( altField ) { // update alternate field too
				altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
				date = this._getDate( inst );
				dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
				$( altField ).val( dateStr );
			}
		},
	
		/* Set as beforeShowDay function to prevent selection of weekends.
		 * @param  date  Date - the date to customise
		 * @return [boolean, string] - is this date selectable?, what is its CSS class?
		 */
		noWeekends: function( date ) {
			var day = date.getDay();
			return [ ( day > 0 && day < 6 ), "" ];
		},
	
		/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
		 * @param  date  Date - the date to get the week for
		 * @return  number - the number of the week within the year that contains this date
		 */
		iso8601Week: function( date ) {
			var time,
				checkDate = new Date( date.getTime() );
	
			// Find Thursday of this week starting on Monday
			checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );
	
			time = checkDate.getTime();
			checkDate.setMonth( 0 ); // Compare with Jan 1
			checkDate.setDate( 1 );
			return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
		},
	
		/* Parse a string value into a date object.
		 * See formatDate below for the possible formats.
		 *
		 * @param  format string - the expected format of the date
		 * @param  value string - the date in the above format
		 * @param  settings Object - attributes include:
		 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  Date - the extracted date value or null if value is blank
		 */
		parseDate: function( format, value, settings ) {
			if ( format == null || value == null ) {
				throw "Invalid arguments";
			}
	
			value = ( typeof value === "object" ? value.toString() : value + "" );
			if ( value === "" ) {
				return null;
			}
	
			var iFormat, dim, extra,
				iValue = 0,
				shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
				shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
					new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
				dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
				dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
				monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
				monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
				year = -1,
				month = -1,
				day = -1,
				doy = -1,
				literal = false,
				date,
	
				// Check whether a format character is doubled
				lookAhead = function( match ) {
					var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
					if ( matches ) {
						iFormat++;
					}
					return matches;
				},
	
				// Extract a number from the string value
				getNumber = function( match ) {
					var isDoubled = lookAhead( match ),
						size = ( match === "@" ? 14 : ( match === "!" ? 20 :
						( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
						minSize = ( match === "y" ? size : 1 ),
						digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
						num = value.substring( iValue ).match( digits );
					if ( !num ) {
						throw "Missing number at position " + iValue;
					}
					iValue += num[ 0 ].length;
					return parseInt( num[ 0 ], 10 );
				},
	
				// Extract a name from the string value and convert to an index
				getName = function( match, shortNames, longNames ) {
					var index = -1,
						names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
							return [ [ k, v ] ];
						} ).sort( function( a, b ) {
							return -( a[ 1 ].length - b[ 1 ].length );
						} );
	
					$.each( names, function( i, pair ) {
						var name = pair[ 1 ];
						if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
							index = pair[ 0 ];
							iValue += name.length;
							return false;
						}
					} );
					if ( index !== -1 ) {
						return index + 1;
					} else {
						throw "Unknown name at position " + iValue;
					}
				},
	
				// Confirm that a literal character matches the string value
				checkLiteral = function() {
					if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
						throw "Unexpected literal at position " + iValue;
					}
					iValue++;
				};
	
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						checkLiteral();
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d":
							day = getNumber( "d" );
							break;
						case "D":
							getName( "D", dayNamesShort, dayNames );
							break;
						case "o":
							doy = getNumber( "o" );
							break;
						case "m":
							month = getNumber( "m" );
							break;
						case "M":
							month = getName( "M", monthNamesShort, monthNames );
							break;
						case "y":
							year = getNumber( "y" );
							break;
						case "@":
							date = new Date( getNumber( "@" ) );
							year = date.getFullYear();
							month = date.getMonth() + 1;
							day = date.getDate();
							break;
						case "!":
							date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
							year = date.getFullYear();
							month = date.getMonth() + 1;
							day = date.getDate();
							break;
						case "'":
							if ( lookAhead( "'" ) ) {
								checkLiteral();
							} else {
								literal = true;
							}
							break;
						default:
							checkLiteral();
					}
				}
			}
	
			if ( iValue < value.length ) {
				extra = value.substr( iValue );
				if ( !/^\s+/.test( extra ) ) {
					throw "Extra/unparsed characters found in date: " + extra;
				}
			}
	
			if ( year === -1 ) {
				year = new Date().getFullYear();
			} else if ( year < 100 ) {
				year += new Date().getFullYear() - new Date().getFullYear() % 100 +
					( year <= shortYearCutoff ? 0 : -100 );
			}
	
			if ( doy > -1 ) {
				month = 1;
				day = doy;
				do {
					dim = this._getDaysInMonth( year, month - 1 );
					if ( day <= dim ) {
						break;
					}
					month++;
					day -= dim;
				} while ( true );
			}
	
			date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
			if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
				throw "Invalid date"; // E.g. 31/02/00
			}
			return date;
		},
	
		/* Standard date formats. */
		ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
		COOKIE: "D, dd M yy",
		ISO_8601: "yy-mm-dd",
		RFC_822: "D, d M y",
		RFC_850: "DD, dd-M-y",
		RFC_1036: "D, d M y",
		RFC_1123: "D, d M yy",
		RFC_2822: "D, d M yy",
		RSS: "D, d M y", // RFC 822
		TICKS: "!",
		TIMESTAMP: "@",
		W3C: "yy-mm-dd", // ISO 8601
	
		_ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
			Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),
	
		/* Format a date object into a string value.
		 * The format can be combinations of the following:
		 * d  - day of month (no leading zero)
		 * dd - day of month (two digit)
		 * o  - day of year (no leading zeros)
		 * oo - day of year (three digit)
		 * D  - day name short
		 * DD - day name long
		 * m  - month of year (no leading zero)
		 * mm - month of year (two digit)
		 * M  - month name short
		 * MM - month name long
		 * y  - year (two digit)
		 * yy - year (four digit)
		 * @ - Unix timestamp (ms since 01/01/1970)
		 * ! - Windows ticks (100ns since 01/01/0001)
		 * "..." - literal text
		 * '' - single quote
		 *
		 * @param  format string - the desired format of the date
		 * @param  date Date - the date value to format
		 * @param  settings Object - attributes include:
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  string - the date in the above format
		 */
		formatDate: function( format, date, settings ) {
			if ( !date ) {
				return "";
			}
	
			var iFormat,
				dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
				dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
				monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
				monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
	
				// Check whether a format character is doubled
				lookAhead = function( match ) {
					var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
					if ( matches ) {
						iFormat++;
					}
					return matches;
				},
	
				// Format a number, with leading zero if necessary
				formatNumber = function( match, value, len ) {
					var num = "" + value;
					if ( lookAhead( match ) ) {
						while ( num.length < len ) {
							num = "0" + num;
						}
					}
					return num;
				},
	
				// Format a name, short or long as requested
				formatName = function( match, value, shortNames, longNames ) {
					return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
				},
				output = "",
				literal = false;
	
			if ( date ) {
				for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
					if ( literal ) {
						if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
							literal = false;
						} else {
							output += format.charAt( iFormat );
						}
					} else {
						switch ( format.charAt( iFormat ) ) {
							case "d":
								output += formatNumber( "d", date.getDate(), 2 );
								break;
							case "D":
								output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
								break;
							case "o":
								output += formatNumber( "o",
									Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
								break;
							case "m":
								output += formatNumber( "m", date.getMonth() + 1, 2 );
								break;
							case "M":
								output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
								break;
							case "y":
								output += ( lookAhead( "y" ) ? date.getFullYear() :
									( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
								break;
							case "@":
								output += date.getTime();
								break;
							case "!":
								output += date.getTime() * 10000 + this._ticksTo1970;
								break;
							case "'":
								if ( lookAhead( "'" ) ) {
									output += "'";
								} else {
									literal = true;
								}
								break;
							default:
								output += format.charAt( iFormat );
						}
					}
				}
			}
			return output;
		},
	
		/* Extract all possible characters from the date format. */
		_possibleChars: function( format ) {
			var iFormat,
				chars = "",
				literal = false,
	
				// Check whether a format character is doubled
				lookAhead = function( match ) {
					var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
					if ( matches ) {
						iFormat++;
					}
					return matches;
				};
	
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						chars += format.charAt( iFormat );
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d": case "m": case "y": case "@":
							chars += "0123456789";
							break;
						case "D": case "M":
							return null; // Accept anything
						case "'":
							if ( lookAhead( "'" ) ) {
								chars += "'";
							} else {
								literal = true;
							}
							break;
						default:
							chars += format.charAt( iFormat );
					}
				}
			}
			return chars;
		},
	
		/* Get a setting value, defaulting if necessary. */
		_get: function( inst, name ) {
			return inst.settings[ name ] !== undefined ?
				inst.settings[ name ] : this._defaults[ name ];
		},
	
		/* Parse existing date and initialise date picker. */
		_setDateFromField: function( inst, noDefault ) {
			if ( inst.input.val() === inst.lastVal ) {
				return;
			}
	
			var dateFormat = this._get( inst, "dateFormat" ),
				dates = inst.lastVal = inst.input ? inst.input.val() : null,
				defaultDate = this._getDefaultDate( inst ),
				date = defaultDate,
				settings = this._getFormatConfig( inst );
	
			try {
				date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
			} catch ( event ) {
				dates = ( noDefault ? "" : dates );
			}
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
			inst.currentDay = ( dates ? date.getDate() : 0 );
			inst.currentMonth = ( dates ? date.getMonth() : 0 );
			inst.currentYear = ( dates ? date.getFullYear() : 0 );
			this._adjustInstDate( inst );
		},
	
		/* Retrieve the default date shown on opening. */
		_getDefaultDate: function( inst ) {
			return this._restrictMinMax( inst,
				this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
		},
	
		/* A date may be specified as an exact value or a relative one. */
		_determineDate: function( inst, date, defaultDate ) {
			var offsetNumeric = function( offset ) {
					var date = new Date();
					date.setDate( date.getDate() + offset );
					return date;
				},
				offsetString = function( offset ) {
					try {
						return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
							offset, $.datepicker._getFormatConfig( inst ) );
					}
					catch ( e ) {
	
						// Ignore
					}
	
					var date = ( offset.toLowerCase().match( /^c/ ) ?
						$.datepicker._getDate( inst ) : null ) || new Date(),
						year = date.getFullYear(),
						month = date.getMonth(),
						day = date.getDate(),
						pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
						matches = pattern.exec( offset );
	
					while ( matches ) {
						switch ( matches[ 2 ] || "d" ) {
							case "d" : case "D" :
								day += parseInt( matches[ 1 ], 10 ); break;
							case "w" : case "W" :
								day += parseInt( matches[ 1 ], 10 ) * 7; break;
							case "m" : case "M" :
								month += parseInt( matches[ 1 ], 10 );
								day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
								break;
							case "y": case "Y" :
								year += parseInt( matches[ 1 ], 10 );
								day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
								break;
						}
						matches = pattern.exec( offset );
					}
					return new Date( year, month, day );
				},
				newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
					( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );
	
			newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
			if ( newDate ) {
				newDate.setHours( 0 );
				newDate.setMinutes( 0 );
				newDate.setSeconds( 0 );
				newDate.setMilliseconds( 0 );
			}
			return this._daylightSavingAdjust( newDate );
		},
	
		/* Handle switch to/from daylight saving.
		 * Hours may be non-zero on daylight saving cut-over:
		 * > 12 when midnight changeover, but then cannot generate
		 * midnight datetime, so jump to 1AM, otherwise reset.
		 * @param  date  (Date) the date to check
		 * @return  (Date) the corrected date
		 */
		_daylightSavingAdjust: function( date ) {
			if ( !date ) {
				return null;
			}
			date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
			return date;
		},
	
		/* Set the date(s) directly. */
		_setDate: function( inst, date, noChange ) {
			var clear = !date,
				origMonth = inst.selectedMonth,
				origYear = inst.selectedYear,
				newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );
	
			inst.selectedDay = inst.currentDay = newDate.getDate();
			inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
			inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
			if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
				this._notifyChange( inst );
			}
			this._adjustInstDate( inst );
			if ( inst.input ) {
				inst.input.val( clear ? "" : this._formatDate( inst ) );
			}
		},
	
		/* Retrieve the date(s) directly. */
		_getDate: function( inst ) {
			var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
				this._daylightSavingAdjust( new Date(
				inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
				return startDate;
		},
	
		/* Attach the onxxx handlers.  These are declared statically so
		 * they work with static code transformers like Caja.
		 */
		_attachHandlers: function( inst ) {
			var stepMonths = this._get( inst, "stepMonths" ),
				id = "#" + inst.id.replace( /\\\\/g, "\\" );
			inst.dpDiv.find( "[data-handler]" ).map( function() {
				var handler = {
					prev: function() {
						$.datepicker._adjustDate( id, -stepMonths, "M" );
					},
					next: function() {
						$.datepicker._adjustDate( id, +stepMonths, "M" );
					},
					hide: function() {
						$.datepicker._hideDatepicker();
					},
					today: function() {
						$.datepicker._gotoToday( id );
					},
					selectDay: function() {
						$.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
						return false;
					},
					selectMonth: function() {
						$.datepicker._selectMonthYear( id, this, "M" );
						return false;
					},
					selectYear: function() {
						$.datepicker._selectMonthYear( id, this, "Y" );
						return false;
					}
				};
				$( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
			} );
		},
	
		/* Generate the HTML for the current state of the date picker. */
		_generateHTML: function( inst ) {
			var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
				controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
				monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
				selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
				cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
				printDate, dRow, tbody, daySettings, otherMonth, unselectable,
				tempDate = new Date(),
				today = this._daylightSavingAdjust(
					new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
				isRTL = this._get( inst, "isRTL" ),
				showButtonPanel = this._get( inst, "showButtonPanel" ),
				hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
				navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
				numMonths = this._getNumberOfMonths( inst ),
				showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
				stepMonths = this._get( inst, "stepMonths" ),
				isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
				currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
					new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
				minDate = this._getMinMaxDate( inst, "min" ),
				maxDate = this._getMinMaxDate( inst, "max" ),
				drawMonth = inst.drawMonth - showCurrentAtPos,
				drawYear = inst.drawYear;
	
			if ( drawMonth < 0 ) {
				drawMonth += 12;
				drawYear--;
			}
			if ( maxDate ) {
				maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
					maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
				maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
				while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
					drawMonth--;
					if ( drawMonth < 0 ) {
						drawMonth = 11;
						drawYear--;
					}
				}
			}
			inst.drawMonth = drawMonth;
			inst.drawYear = drawYear;
	
			prevText = this._get( inst, "prevText" );
			prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
				this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
				this._getFormatConfig( inst ) ) );
	
			prev = ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ?
				"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
				" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" :
				( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" ) );
	
			nextText = this._get( inst, "nextText" );
			nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
				this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
				this._getFormatConfig( inst ) ) );
	
			next = ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ?
				"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
				" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" :
				( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" ) );
	
			currentText = this._get( inst, "currentText" );
			gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
			currentText = ( !navigationAsDateFormat ? currentText :
				this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );
	
			controls = ( !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
				this._get( inst, "closeText" ) + "</button>" : "" );
	
			buttonPanel = ( showButtonPanel ) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + ( isRTL ? controls : "" ) +
				( this._isInRange( inst, gotoDate ) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
				">" + currentText + "</button>" : "" ) + ( isRTL ? "" : controls ) + "</div>" : "";
	
			firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
			firstDay = ( isNaN( firstDay ) ? 0 : firstDay );
	
			showWeek = this._get( inst, "showWeek" );
			dayNames = this._get( inst, "dayNames" );
			dayNamesMin = this._get( inst, "dayNamesMin" );
			monthNames = this._get( inst, "monthNames" );
			monthNamesShort = this._get( inst, "monthNamesShort" );
			beforeShowDay = this._get( inst, "beforeShowDay" );
			showOtherMonths = this._get( inst, "showOtherMonths" );
			selectOtherMonths = this._get( inst, "selectOtherMonths" );
			defaultDate = this._getDefaultDate( inst );
			html = "";
	
			for ( row = 0; row < numMonths[ 0 ]; row++ ) {
				group = "";
				this.maxRows = 4;
				for ( col = 0; col < numMonths[ 1 ]; col++ ) {
					selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
					cornerClass = " ui-corner-all";
					calender = "";
					if ( isMultiMonth ) {
						calender += "<div class='ui-datepicker-group";
						if ( numMonths[ 1 ] > 1 ) {
							switch ( col ) {
								case 0: calender += " ui-datepicker-group-first";
									cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
								case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
									cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
								default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
							}
						}
						calender += "'>";
					}
					calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
						( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
						( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
						this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
						row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
						"</div><table class='ui-datepicker-calendar'><thead>" +
						"<tr>";
					thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
					for ( dow = 0; dow < 7; dow++ ) { // days of the week
						day = ( dow + firstDay ) % 7;
						thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
							"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
					}
					calender += thead + "</tr></thead><tbody>";
					daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
					if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
						inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
					}
					leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
					curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
					numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); //If multiple months, use the higher number of rows (see #7043)
					this.maxRows = numRows;
					printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
					for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
						calender += "<tr>";
						tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
							this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
						for ( dow = 0; dow < 7; dow++ ) { // create date picker days
							daySettings = ( beforeShowDay ?
								beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
							otherMonth = ( printDate.getMonth() !== drawMonth );
							unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
								( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
							tbody += "<td class='" +
								( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
								( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
								( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
								( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?
	
								// or defaultDate is current printedDate and defaultDate is selectedDate
								" " + this._dayOverClass : "" ) + // highlight selected day
								( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) +  // highlight unselectable days
								( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
								( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
								( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
								( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
								( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
								( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
								( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
								( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
								( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
								( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
								"' href='#'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
							printDate.setDate( printDate.getDate() + 1 );
							printDate = this._daylightSavingAdjust( printDate );
						}
						calender += tbody + "</tr>";
					}
					drawMonth++;
					if ( drawMonth > 11 ) {
						drawMonth = 0;
						drawYear++;
					}
					calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
								( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
					group += calender;
				}
				html += group;
			}
			html += buttonPanel;
			inst._keyEvent = false;
			return html;
		},
	
		/* Generate the month and year header. */
		_generateMonthYearHeader: function( inst, drawMonth, drawYear, minDate, maxDate,
				secondary, monthNames, monthNamesShort ) {
	
			var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
				changeMonth = this._get( inst, "changeMonth" ),
				changeYear = this._get( inst, "changeYear" ),
				showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
				html = "<div class='ui-datepicker-title'>",
				monthHtml = "";
	
			// Month selection
			if ( secondary || !changeMonth ) {
				monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
			} else {
				inMinYear = ( minDate && minDate.getFullYear() === drawYear );
				inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
				monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
				for ( month = 0; month < 12; month++ ) {
					if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
						monthHtml += "<option value='" + month + "'" +
							( month === drawMonth ? " selected='selected'" : "" ) +
							">" + monthNamesShort[ month ] + "</option>";
					}
				}
				monthHtml += "</select>";
			}
	
			if ( !showMonthAfterYear ) {
				html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
			}
	
			// Year selection
			if ( !inst.yearshtml ) {
				inst.yearshtml = "";
				if ( secondary || !changeYear ) {
					html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
				} else {
	
					// determine range of years to display
					years = this._get( inst, "yearRange" ).split( ":" );
					thisYear = new Date().getFullYear();
					determineYear = function( value ) {
						var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
							( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
							parseInt( value, 10 ) ) );
						return ( isNaN( year ) ? thisYear : year );
					};
					year = determineYear( years[ 0 ] );
					endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
					year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
					endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
					inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
					for ( ; year <= endYear; year++ ) {
						inst.yearshtml += "<option value='" + year + "'" +
							( year === drawYear ? " selected='selected'" : "" ) +
							">" + year + "</option>";
					}
					inst.yearshtml += "</select>";
	
					html += inst.yearshtml;
					inst.yearshtml = null;
				}
			}
	
			html += this._get( inst, "yearSuffix" );
			if ( showMonthAfterYear ) {
				html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
			}
			html += "</div>"; // Close datepicker_header
			return html;
		},
	
		/* Adjust one of the date sub-fields. */
		_adjustInstDate: function( inst, offset, period ) {
			var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
				month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
				day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
				date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );
	
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
			if ( period === "M" || period === "Y" ) {
				this._notifyChange( inst );
			}
		},
	
		/* Ensure a date is within any min/max bounds. */
		_restrictMinMax: function( inst, date ) {
			var minDate = this._getMinMaxDate( inst, "min" ),
				maxDate = this._getMinMaxDate( inst, "max" ),
				newDate = ( minDate && date < minDate ? minDate : date );
			return ( maxDate && newDate > maxDate ? maxDate : newDate );
		},
	
		/* Notify change of month/year. */
		_notifyChange: function( inst ) {
			var onChange = this._get( inst, "onChangeMonthYear" );
			if ( onChange ) {
				onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
					[ inst.selectedYear, inst.selectedMonth + 1, inst ] );
			}
		},
	
		/* Determine the number of months to show. */
		_getNumberOfMonths: function( inst ) {
			var numMonths = this._get( inst, "numberOfMonths" );
			return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
		},
	
		/* Determine the current maximum date - ensure no time components are set. */
		_getMinMaxDate: function( inst, minMax ) {
			return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
		},
	
		/* Find the number of days in a given month. */
		_getDaysInMonth: function( year, month ) {
			return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
		},
	
		/* Find the day of the week of the first of a month. */
		_getFirstDayOfMonth: function( year, month ) {
			return new Date( year, month, 1 ).getDay();
		},
	
		/* Determines if we should allow a "next/prev" month display change. */
		_canAdjustMonth: function( inst, offset, curYear, curMonth ) {
			var numMonths = this._getNumberOfMonths( inst ),
				date = this._daylightSavingAdjust( new Date( curYear,
				curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );
	
			if ( offset < 0 ) {
				date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
			}
			return this._isInRange( inst, date );
		},
	
		/* Is the given date in the accepted range? */
		_isInRange: function( inst, date ) {
			var yearSplit, currentYear,
				minDate = this._getMinMaxDate( inst, "min" ),
				maxDate = this._getMinMaxDate( inst, "max" ),
				minYear = null,
				maxYear = null,
				years = this._get( inst, "yearRange" );
				if ( years ) {
					yearSplit = years.split( ":" );
					currentYear = new Date().getFullYear();
					minYear = parseInt( yearSplit[ 0 ], 10 );
					maxYear = parseInt( yearSplit[ 1 ], 10 );
					if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
						minYear += currentYear;
					}
					if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
						maxYear += currentYear;
					}
				}
	
			return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
				( !maxDate || date.getTime() <= maxDate.getTime() ) &&
				( !minYear || date.getFullYear() >= minYear ) &&
				( !maxYear || date.getFullYear() <= maxYear ) );
		},
	
		/* Provide the configuration settings for formatting/parsing. */
		_getFormatConfig: function( inst ) {
			var shortYearCutoff = this._get( inst, "shortYearCutoff" );
			shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
			return { shortYearCutoff: shortYearCutoff,
				dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
				monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
		},
	
		/* Format the given date for display. */
		_formatDate: function( inst, day, month, year ) {
			if ( !day ) {
				inst.currentDay = inst.selectedDay;
				inst.currentMonth = inst.selectedMonth;
				inst.currentYear = inst.selectedYear;
			}
			var date = ( day ? ( typeof day === "object" ? day :
				this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
				this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
			return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
		}
	} );
	
	/*
	 * Bind hover events for datepicker elements.
	 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
	 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
	 */
	function datepicker_bindHover( dpDiv ) {
		var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
		return dpDiv.on( "mouseout", selector, function() {
				$( this ).removeClass( "ui-state-hover" );
				if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
					$( this ).removeClass( "ui-datepicker-prev-hover" );
				}
				if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
					$( this ).removeClass( "ui-datepicker-next-hover" );
				}
			} )
			.on( "mouseover", selector, datepicker_handleMouseover );
	}
	
	function datepicker_handleMouseover() {
		if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
			$( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
			$( this ).addClass( "ui-state-hover" );
			if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
				$( this ).addClass( "ui-datepicker-prev-hover" );
			}
			if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
				$( this ).addClass( "ui-datepicker-next-hover" );
			}
		}
	}
	
	/* jQuery extend now ignores nulls! */
	function datepicker_extendRemove( target, props ) {
		$.extend( target, props );
		for ( var name in props ) {
			if ( props[ name ] == null ) {
				target[ name ] = props[ name ];
			}
		}
		return target;
	}
	
	/* Invoke the datepicker functionality.
	   @param  options  string - a command, optionally followed by additional parameters or
						Object - settings for attaching new datepicker functionality
	   @return  jQuery object */
	$.fn.datepicker = function( options ) {
	
		/* Verify an empty collection wasn't passed - Fixes #6976 */
		if ( !this.length ) {
			return this;
		}
	
		/* Initialise the date picker. */
		if ( !$.datepicker.initialized ) {
			$( document ).on( "mousedown", $.datepicker._checkExternalClick );
			$.datepicker.initialized = true;
		}
	
		/* Append datepicker main container to body if not exist. */
		if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
			$( "body" ).append( $.datepicker.dpDiv );
		}
	
		var otherArgs = Array.prototype.slice.call( arguments, 1 );
		if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
			return $.datepicker[ "_" + options + "Datepicker" ].
				apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
		}
		if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
			return $.datepicker[ "_" + options + "Datepicker" ].
				apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
		}
		return this.each( function() {
			typeof options === "string" ?
				$.datepicker[ "_" + options + "Datepicker" ].
					apply( $.datepicker, [ this ].concat( otherArgs ) ) :
				$.datepicker._attachDatepicker( this, options );
		} );
	};
	
	$.datepicker = new Datepicker(); // singleton instance
	$.datepicker.initialized = false;
	$.datepicker.uuid = new Date().getTime();
	$.datepicker.version = "1.12.1";
	
	var widgetsDatepicker = $.datepicker;
	
	
	
	
	// This file is deprecated
	var ie = $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	
	/*!
	 * jQuery UI Mouse 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	
	
	
	var mouseHandled = false;
	$( document ).on( "mouseup", function() {
		mouseHandled = false;
	} );
	
	var widgetsMouse = $.widget( "ui.mouse", {
		version: "1.12.1",
		options: {
			cancel: "input, textarea, button, select, option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.on( "mousedown." + this.widgetName, function( event ) {
					return that._mouseDown( event );
				} )
				.on( "click." + this.widgetName, function( event ) {
					if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
						$.removeData( event.target, that.widgetName + ".preventClickEvent" );
						event.stopImmediatePropagation();
						return false;
					}
				} );
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.off( "." + this.widgetName );
			if ( this._mouseMoveDelegate ) {
				this.document
					.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
					.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
			}
		},
	
		_mouseDown: function( event ) {
	
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// We may have missed mouseup (out of window)
			( this._mouseStarted && this._mouseUp( event ) );
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = ( event.which === 1 ),
	
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
					$( event.target ).closest( this.options.cancel ).length : false );
			if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if ( !this.mouseDelayMet ) {
				this._mouseDelayTimer = setTimeout( function() {
					that.mouseDelayMet = true;
				}, this.options.delay );
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted = ( this._mouseStart( event ) !== false );
				if ( !this._mouseStarted ) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
				$.removeData( event.target, this.widgetName + ".preventClickEvent" );
			}
	
			// These delegates are required to keep context
			this._mouseMoveDelegate = function( event ) {
				return that._mouseMove( event );
			};
			this._mouseUpDelegate = function( event ) {
				return that._mouseUp( event );
			};
	
			this.document
				.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.on( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function( event ) {
	
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
	
				// IE mouseup check - mouseup happened when mouse was out of window
				if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
						!event.button ) {
					return this._mouseUp( event );
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
	
					// Support: Safari <=8 - 9
					// Safari sets which to 0 if you press any of the following keys
					// during a drag (#14461)
					if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
							event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
						this.ignoreMissingWhich = true;
					} else if ( !this.ignoreMissingWhich ) {
						return this._mouseUp( event );
					}
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
				return event.preventDefault();
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted =
					( this._mouseStart( this._mouseDownEvent, event ) !== false );
				( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function( event ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if ( this._mouseStarted ) {
				this._mouseStarted = false;
	
				if ( event.target === this._mouseDownEvent.target ) {
					$.data( event.target, this.widgetName + ".preventClickEvent", true );
				}
	
				this._mouseStop( event );
			}
	
			if ( this._mouseDelayTimer ) {
				clearTimeout( this._mouseDelayTimer );
				delete this._mouseDelayTimer;
			}
	
			this.ignoreMissingWhich = false;
			mouseHandled = false;
			event.preventDefault();
		},
	
		_mouseDistanceMet: function( event ) {
			return ( Math.max(
					Math.abs( this._mouseDownEvent.pageX - event.pageX ),
					Math.abs( this._mouseDownEvent.pageY - event.pageY )
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function( /* event */ ) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function( /* event */ ) {},
		_mouseDrag: function( /* event */ ) {},
		_mouseStop: function( /* event */ ) {},
		_mouseCapture: function( /* event */ ) { return true; }
	} );
	
	
	
	
	// $.ui.plugin is deprecated. Use $.widget() extensions instead.
	var plugin = $.ui.plugin = {
		add: function( module, option, set ) {
			var i,
				proto = $.ui[ module ].prototype;
			for ( i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args, allowDisconnected ) {
			var i,
				set = instance.plugins[ name ];
	
			if ( !set ) {
				return;
			}
	
			if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
					instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
				return;
			}
	
			for ( i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	};
	
	
	
	var safeBlur = $.ui.safeBlur = function( element ) {
	
		// Support: IE9 - 10 only
		// If the <body> is blurred, IE will switch windows, see #9420
		if ( element && element.nodeName.toLowerCase() !== "body" ) {
			$( element ).trigger( "blur" );
		}
	};
	
	
	/*!
	 * jQuery UI Draggable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Draggable
	//>>group: Interactions
	//>>description: Enables dragging functionality for any element.
	//>>docs: http://api.jqueryui.com/draggable/
	//>>demos: http://jqueryui.com/draggable/
	//>>css.structure: ../../themes/base/draggable.css
	
	
	
	$.widget( "ui.draggable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "drag",
		options: {
			addClasses: true,
			appendTo: "parent",
			axis: false,
			connectToSortable: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			grid: false,
			handle: false,
			helper: "original",
			iframeFix: false,
			opacity: false,
			refreshPositions: false,
			revert: false,
			revertDuration: 500,
			scope: "default",
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			snap: false,
			snapMode: "both",
			snapTolerance: 20,
			stack: false,
			zIndex: false,
	
			// Callbacks
			drag: null,
			start: null,
			stop: null
		},
		_create: function() {
	
			if ( this.options.helper === "original" ) {
				this._setPositionRelative();
			}
			if ( this.options.addClasses ) {
				this._addClass( "ui-draggable" );
			}
			this._setHandleClassName();
	
			this._mouseInit();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "handle" ) {
				this._removeHandleClassName();
				this._setHandleClassName();
			}
		},
	
		_destroy: function() {
			if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
				this.destroyOnClear = true;
				return;
			}
			this._removeHandleClassName();
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var o = this.options;
	
			// Among others, prevent a drag on a resizable-handle
			if ( this.helper || o.disabled ||
					$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
				return false;
			}
	
			//Quit if we're not on a valid handle
			this.handle = this._getHandle( event );
			if ( !this.handle ) {
				return false;
			}
	
			this._blurActiveElement( event );
	
			this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );
	
			return true;
	
		},
	
		_blockFrames: function( selector ) {
			this.iframeBlocks = this.document.find( selector ).map( function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css( "position", "absolute" )
					.appendTo( iframe.parent() )
					.outerWidth( iframe.outerWidth() )
					.outerHeight( iframe.outerHeight() )
					.offset( iframe.offset() )[ 0 ];
			} );
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_blurActiveElement: function( event ) {
			var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
				target = $( event.target );
	
			// Don't blur if the event occurred on an element that is within
			// the currently focused element
			// See #10527, #12472
			if ( target.closest( activeElement ).length ) {
				return;
			}
	
			// Blur any element that currently has focus, see #4261
			$.ui.safeBlur( activeElement );
		},
	
		_mouseStart: function( event ) {
	
			var o = this.options;
	
			//Create and append the visible helper
			this.helper = this._createHelper( event );
	
			this._addClass( this.helper, "ui-draggable-dragging" );
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			//If ddmanager is used for droppables, set the global draggable
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.current = this;
			}
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Store the helper's css position
			this.cssPosition = this.helper.css( "position" );
			this.scrollParent = this.helper.scrollParent( true );
			this.offsetParent = this.helper.offsetParent();
			this.hasFixedAncestor = this.helper.parents().filter( function() {
					return $( this ).css( "position" ) === "fixed";
				} ).length > 0;
	
			//The element's absolute position on the page minus margins
			this.positionAbs = this.element.offset();
			this._refreshOffsets( event );
	
			//Generate the original position
			this.originalPosition = this.position = this._generatePosition( event, false );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );
	
			//Set a containment if given in the options
			this._setContainment();
	
			//Trigger event + callbacks
			if ( this._trigger( "start", event ) === false ) {
				this._clear();
				return false;
			}
	
			//Recache the helper size
			this._cacheHelperProportions();
	
			//Prepare the droppable offsets
			if ( $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
	
			// Execute the drag once - this causes the helper not to be visible before getting its
			// correct position
			this._mouseDrag( event, true );
	
			// If the ddmanager is used for droppables, inform the manager that dragging has started
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStart( this, event );
			}
	
			return true;
		},
	
		_refreshOffsets: function( event ) {
			this.offset = {
				top: this.positionAbs.top - this.margins.top,
				left: this.positionAbs.left - this.margins.left,
				scroll: false,
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset()
			};
	
			this.offset.click = {
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			};
		},
	
		_mouseDrag: function( event, noPropagation ) {
	
			// reset any necessary cached properties (see #5009)
			if ( this.hasFixedAncestor ) {
				this.offset.parent = this._getParentOffset();
			}
	
			//Compute the helpers position
			this.position = this._generatePosition( event, true );
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			//Call plugins and callbacks and use the resulting position if something is returned
			if ( !noPropagation ) {
				var ui = this._uiHash();
				if ( this._trigger( "drag", event, ui ) === false ) {
					this._mouseUp( new $.Event( "mouseup", event ) );
					return false;
				}
				this.position = ui.position;
			}
	
			this.helper[ 0 ].style.left = this.position.left + "px";
			this.helper[ 0 ].style.top = this.position.top + "px";
	
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.drag( this, event );
			}
	
			return false;
		},
	
		_mouseStop: function( event ) {
	
			//If we are using droppables, inform the manager about the drop
			var that = this,
				dropped = false;
			if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
				dropped = $.ui.ddmanager.drop( this, event );
			}
	
			//if a drop comes from outside (a sortable)
			if ( this.dropped ) {
				dropped = this.dropped;
				this.dropped = false;
			}
	
			if ( ( this.options.revert === "invalid" && !dropped ) ||
					( this.options.revert === "valid" && dropped ) ||
					this.options.revert === true || ( $.isFunction( this.options.revert ) &&
					this.options.revert.call( this.element, dropped ) )
			) {
				$( this.helper ).animate(
					this.originalPosition,
					parseInt( this.options.revertDuration, 10 ),
					function() {
						if ( that._trigger( "stop", event ) !== false ) {
							that._clear();
						}
					}
				);
			} else {
				if ( this._trigger( "stop", event ) !== false ) {
					this._clear();
				}
			}
	
			return false;
		},
	
		_mouseUp: function( event ) {
			this._unblockFrames();
	
			// If the ddmanager is used for droppables, inform the manager that dragging has stopped
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStop( this, event );
			}
	
			// Only need to focus if the event occurred on the draggable itself, see #10527
			if ( this.handleElement.is( event.target ) ) {
	
				// The interaction is over; whether or not the click resulted in a drag,
				// focus the element
				this.element.trigger( "focus" );
			}
	
			return $.ui.mouse.prototype._mouseUp.call( this, event );
		},
	
		cancel: function() {
	
			if ( this.helper.is( ".ui-draggable-dragging" ) ) {
				this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
			} else {
				this._clear();
			}
	
			return this;
	
		},
	
		_getHandle: function( event ) {
			return this.options.handle ?
				!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
				true;
		},
	
		_setHandleClassName: function() {
			this.handleElement = this.options.handle ?
				this.element.find( this.options.handle ) : this.element;
			this._addClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_removeHandleClassName: function() {
			this._removeClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_createHelper: function( event ) {
	
			var o = this.options,
				helperIsFunction = $.isFunction( o.helper ),
				helper = helperIsFunction ?
					$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
					( o.helper === "clone" ?
						this.element.clone().removeAttr( "id" ) :
						this.element );
	
			if ( !helper.parents( "body" ).length ) {
				helper.appendTo( ( o.appendTo === "parent" ?
					this.element[ 0 ].parentNode :
					o.appendTo ) );
			}
	
			// Http://bugs.jqueryui.com/ticket/9446
			// a helper function can return the original element
			// which wouldn't have been set to relative in _create
			if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
				this._setPositionRelative();
			}
	
			if ( helper[ 0 ] !== this.element[ 0 ] &&
					!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
				helper.css( "position", "absolute" );
			}
	
			return helper;
	
		},
	
		_setPositionRelative: function() {
			if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
				this.element[ 0 ].style.position = "relative";
			}
		},
	
		_adjustOffsetFromHelper: function( obj ) {
			if ( typeof obj === "string" ) {
				obj = obj.split( " " );
			}
			if ( $.isArray( obj ) ) {
				obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
			}
			if ( "left" in obj ) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ( "right" in obj ) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ( "top" in obj ) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ( "bottom" in obj ) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_isRootNode: function( element ) {
			return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			var po = this.offsetParent.offset(),
				document = this.document[ 0 ];
	
			// This is a special case where we need to modify a offset calculated on start, since the
			// following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the
			// next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
			// the document, which means that the scroll is included in the initial calculation of the
			// offset of the parent, and never recalculated upon drag
			if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
				left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
			};
	
		},
	
		_getRelativeOffset: function() {
			if ( this.cssPosition !== "relative" ) {
				return { top: 0, left: 0 };
			}
	
			var p = this.element.position(),
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
			};
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
				top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
				right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
				bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var isUserScrollable, c, ce,
				o = this.options,
				document = this.document[ 0 ];
	
			this.relativeContainer = null;
	
			if ( !o.containment ) {
				this.containment = null;
				return;
			}
	
			if ( o.containment === "window" ) {
				this.containment = [
					$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
					$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
					$( window ).scrollLeft() + $( window ).width() -
						this.helperProportions.width - this.margins.left,
					$( window ).scrollTop() +
						( $( window ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment === "document" ) {
				this.containment = [
					0,
					0,
					$( document ).width() - this.helperProportions.width - this.margins.left,
					( $( document ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment.constructor === Array ) {
				this.containment = o.containment;
				return;
			}
	
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
	
			c = $( o.containment );
			ce = c[ 0 ];
	
			if ( !ce ) {
				return;
			}
	
			isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );
	
			this.containment = [
				( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
				( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
				( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width -
					this.margins.left -
					this.margins.right,
				( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height -
					this.margins.top -
					this.margins.bottom
			];
			this.relativeContainer = c;
		},
	
		_convertPositionTo: function( d, pos ) {
	
			if ( !pos ) {
				pos = this.position;
			}
	
			var mod = d === "absolute" ? 1 : -1,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: (
	
					// The absolute mouse position
					pos.top	+
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top * mod -
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
				),
				left: (
	
					// The absolute mouse position
					pos.left +
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left * mod	-
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
				)
			};
	
		},
	
		_generatePosition: function( event, constrainPosition ) {
	
			var containment, co, top, left,
				o = this.options,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
				pageX = event.pageX,
				pageY = event.pageY;
	
			// Cache the scroll
			if ( !scrollIsRootNode || !this.offset.scroll ) {
				this.offset.scroll = {
					top: this.scrollParent.scrollTop(),
					left: this.scrollParent.scrollLeft()
				};
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			// If we are not dragging yet, we won't check for options
			if ( constrainPosition ) {
				if ( this.containment ) {
					if ( this.relativeContainer ) {
						co = this.relativeContainer.offset();
						containment = [
							this.containment[ 0 ] + co.left,
							this.containment[ 1 ] + co.top,
							this.containment[ 2 ] + co.left,
							this.containment[ 3 ] + co.top
						];
					} else {
						containment = this.containment;
					}
	
					if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
						pageX = containment[ 0 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
						pageY = containment[ 1 ] + this.offset.click.top;
					}
					if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
						pageX = containment[ 2 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
						pageY = containment[ 3 ] + this.offset.click.top;
					}
				}
	
				if ( o.grid ) {
	
					//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
					// argument errors in IE (see ticket #6950)
					top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
						this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
					pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
						top - this.offset.click.top > containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;
	
					left = o.grid[ 0 ] ? this.originalPageX +
						Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
						this.originalPageX;
					pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
						left - this.offset.click.left > containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
				}
	
				if ( o.axis === "y" ) {
					pageX = this.originalPageX;
				}
	
				if ( o.axis === "x" ) {
					pageY = this.originalPageY;
				}
			}
	
			return {
				top: (
	
					// The absolute mouse position
					pageY -
	
					// Click offset (relative to the element)
					this.offset.click.top -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
				),
				left: (
	
					// The absolute mouse position
					pageX -
	
					// Click offset (relative to the element)
					this.offset.click.left -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
				)
			};
	
		},
	
		_clear: function() {
			this._removeClass( this.helper, "ui-draggable-dragging" );
			if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
				this.helper.remove();
			}
			this.helper = null;
			this.cancelHelperRemoval = false;
			if ( this.destroyOnClear ) {
				this.destroy();
			}
		},
	
		// From now on bulk stuff - mainly helpers
	
		_trigger: function( type, event, ui ) {
			ui = ui || this._uiHash();
			$.ui.plugin.call( this, type, [ event, ui, this ], true );
	
			// Absolute position and offset (see #6884 ) have to be recalculated after plugins
			if ( /^(drag|start|stop)/.test( type ) ) {
				this.positionAbs = this._convertPositionTo( "absolute" );
				ui.offset = this.positionAbs;
			}
			return $.Widget.prototype._trigger.call( this, type, event, ui );
		},
	
		plugins: {},
	
		_uiHash: function() {
			return {
				helper: this.helper,
				position: this.position,
				originalPosition: this.originalPosition,
				offset: this.positionAbs
			};
		}
	
	} );
	
	$.ui.plugin.add( "draggable", "connectToSortable", {
		start: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.sortables = [];
			$( draggable.options.connectToSortable ).each( function() {
				var sortable = $( this ).sortable( "instance" );
	
				if ( sortable && !sortable.options.disabled ) {
					draggable.sortables.push( sortable );
	
					// RefreshPositions is called at drag start to refresh the containerCache
					// which is used in drag. This ensures it's initialized and synchronized
					// with any changes that might have happened on the page since initialization.
					sortable.refreshPositions();
					sortable._trigger( "activate", event, uiSortable );
				}
			} );
		},
		stop: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.cancelHelperRemoval = false;
	
			$.each( draggable.sortables, function() {
				var sortable = this;
	
				if ( sortable.isOver ) {
					sortable.isOver = 0;
	
					// Allow this sortable to handle removing the helper
					draggable.cancelHelperRemoval = true;
					sortable.cancelHelperRemoval = false;
	
					// Use _storedCSS To restore properties in the sortable,
					// as this also handles revert (#9675) since the draggable
					// may have modified them in unexpected ways (#8809)
					sortable._storedCSS = {
						position: sortable.placeholder.css( "position" ),
						top: sortable.placeholder.css( "top" ),
						left: sortable.placeholder.css( "left" )
					};
	
					sortable._mouseStop( event );
	
					// Once drag has ended, the sortable should return to using
					// its original helper, not the shared helper from draggable
					sortable.options.helper = sortable.options._helper;
				} else {
	
					// Prevent this Sortable from removing the helper.
					// However, don't set the draggable to remove the helper
					// either as another connected Sortable may yet handle the removal.
					sortable.cancelHelperRemoval = true;
	
					sortable._trigger( "deactivate", event, uiSortable );
				}
			} );
		},
		drag: function( event, ui, draggable ) {
			$.each( draggable.sortables, function() {
				var innermostIntersecting = false,
					sortable = this;
	
				// Copy over variables that sortable's _intersectsWith uses
				sortable.positionAbs = draggable.positionAbs;
				sortable.helperProportions = draggable.helperProportions;
				sortable.offset.click = draggable.offset.click;
	
				if ( sortable._intersectsWith( sortable.containerCache ) ) {
					innermostIntersecting = true;
	
					$.each( draggable.sortables, function() {
	
						// Copy over variables that sortable's _intersectsWith uses
						this.positionAbs = draggable.positionAbs;
						this.helperProportions = draggable.helperProportions;
						this.offset.click = draggable.offset.click;
	
						if ( this !== sortable &&
								this._intersectsWith( this.containerCache ) &&
								$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
							innermostIntersecting = false;
						}
	
						return innermostIntersecting;
					} );
				}
	
				if ( innermostIntersecting ) {
	
					// If it intersects, we use a little isOver variable and set it once,
					// so that the move-in stuff gets fired only once.
					if ( !sortable.isOver ) {
						sortable.isOver = 1;
	
						// Store draggable's parent in case we need to reappend to it later.
						draggable._parent = ui.helper.parent();
	
						sortable.currentItem = ui.helper
							.appendTo( sortable.element )
							.data( "ui-sortable-item", true );
	
						// Store helper option to later restore it
						sortable.options._helper = sortable.options.helper;
	
						sortable.options.helper = function() {
							return ui.helper[ 0 ];
						};
	
						// Fire the start events of the sortable with our passed browser event,
						// and our own helper (so it doesn't create a new one)
						event.target = sortable.currentItem[ 0 ];
						sortable._mouseCapture( event, true );
						sortable._mouseStart( event, true, true );
	
						// Because the browser event is way off the new appended portlet,
						// modify necessary variables to reflect the changes
						sortable.offset.click.top = draggable.offset.click.top;
						sortable.offset.click.left = draggable.offset.click.left;
						sortable.offset.parent.left -= draggable.offset.parent.left -
							sortable.offset.parent.left;
						sortable.offset.parent.top -= draggable.offset.parent.top -
							sortable.offset.parent.top;
	
						draggable._trigger( "toSortable", event );
	
						// Inform draggable that the helper is in a valid drop zone,
						// used solely in the revert option to handle "valid/invalid".
						draggable.dropped = sortable.element;
	
						// Need to refreshPositions of all sortables in the case that
						// adding to one sortable changes the location of the other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
	
						// Hack so receive/update callbacks work (mostly)
						draggable.currentItem = draggable.element;
						sortable.fromOutside = draggable;
					}
	
					if ( sortable.currentItem ) {
						sortable._mouseDrag( event );
	
						// Copy the sortable's position because the draggable's can potentially reflect
						// a relative position, while sortable is always absolute, which the dragged
						// element has now become. (#8809)
						ui.position = sortable.position;
					}
				} else {
	
					// If it doesn't intersect with the sortable, and it intersected before,
					// we fake the drag stop of the sortable, but make sure it doesn't remove
					// the helper by using cancelHelperRemoval.
					if ( sortable.isOver ) {
	
						sortable.isOver = 0;
						sortable.cancelHelperRemoval = true;
	
						// Calling sortable's mouseStop would trigger a revert,
						// so revert must be temporarily false until after mouseStop is called.
						sortable.options._revert = sortable.options.revert;
						sortable.options.revert = false;
	
						sortable._trigger( "out", event, sortable._uiHash( sortable ) );
						sortable._mouseStop( event, true );
	
						// Restore sortable behaviors that were modfied
						// when the draggable entered the sortable area (#9481)
						sortable.options.revert = sortable.options._revert;
						sortable.options.helper = sortable.options._helper;
	
						if ( sortable.placeholder ) {
							sortable.placeholder.remove();
						}
	
						// Restore and recalculate the draggable's offset considering the sortable
						// may have modified them in unexpected ways. (#8809, #10669)
						ui.helper.appendTo( draggable._parent );
						draggable._refreshOffsets( event );
						ui.position = draggable._generatePosition( event, true );
	
						draggable._trigger( "fromSortable", event );
	
						// Inform draggable that the helper is no longer in a valid drop zone
						draggable.dropped = false;
	
						// Need to refreshPositions of all sortables just in case removing
						// from one sortable changes the location of other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
					}
				}
			} );
		}
	} );
	
	$.ui.plugin.add( "draggable", "cursor", {
		start: function( event, ui, instance ) {
			var t = $( "body" ),
				o = instance.options;
	
			if ( t.css( "cursor" ) ) {
				o._cursor = t.css( "cursor" );
			}
			t.css( "cursor", o.cursor );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._cursor ) {
				$( "body" ).css( "cursor", o._cursor );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "opacity", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
			if ( t.css( "opacity" ) ) {
				o._opacity = t.css( "opacity" );
			}
			t.css( "opacity", o.opacity );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._opacity ) {
				$( ui.helper ).css( "opacity", o._opacity );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "scroll", {
		start: function( event, ui, i ) {
			if ( !i.scrollParentNotHidden ) {
				i.scrollParentNotHidden = i.helper.scrollParent( false );
			}
	
			if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
					i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
				i.overflowOffset = i.scrollParentNotHidden.offset();
			}
		},
		drag: function( event, ui, i  ) {
	
			var o = i.options,
				scrolled = false,
				scrollParent = i.scrollParentNotHidden[ 0 ],
				document = i.document[ 0 ];
	
			if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
				if ( !o.axis || o.axis !== "x" ) {
					if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
							o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
					} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
							o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
					}
				}
	
			} else {
	
				if ( !o.axis || o.axis !== "x" ) {
					if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
					} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() - o.scrollSpeed
						);
					} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() + o.scrollSpeed
						);
					}
				}
	
			}
	
			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( i, event );
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "snap", {
		start: function( event, ui, i ) {
	
			var o = i.options;
	
			i.snapElements = [];
	
			$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
				.each( function() {
					var $t = $( this ),
						$o = $t.offset();
					if ( this !== i.element[ 0 ] ) {
						i.snapElements.push( {
							item: this,
							width: $t.outerWidth(), height: $t.outerHeight(),
							top: $o.top, left: $o.left
						} );
					}
				} );
	
		},
		drag: function( event, ui, inst ) {
	
			var ts, bs, ls, rs, l, r, t, b, i, first,
				o = inst.options,
				d = o.snapTolerance,
				x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
				y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
	
			for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {
	
				l = inst.snapElements[ i ].left - inst.margins.left;
				r = l + inst.snapElements[ i ].width;
				t = inst.snapElements[ i ].top - inst.margins.top;
				b = t + inst.snapElements[ i ].height;
	
				if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
						!$.contains( inst.snapElements[ i ].item.ownerDocument,
						inst.snapElements[ i ].item ) ) {
					if ( inst.snapElements[ i ].snapping ) {
						( inst.options.snap.release &&
							inst.options.snap.release.call(
								inst.element,
								event,
								$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
							) );
					}
					inst.snapElements[ i ].snapping = false;
					continue;
				}
	
				if ( o.snapMode !== "inner" ) {
					ts = Math.abs( t - y2 ) <= d;
					bs = Math.abs( b - y1 ) <= d;
					ls = Math.abs( l - x2 ) <= d;
					rs = Math.abs( r - x1 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l - inst.helperProportions.width
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r
						} ).left;
					}
				}
	
				first = ( ts || bs || ls || rs );
	
				if ( o.snapMode !== "outer" ) {
					ts = Math.abs( t - y1 ) <= d;
					bs = Math.abs( b - y2 ) <= d;
					ls = Math.abs( l - x1 ) <= d;
					rs = Math.abs( r - x2 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r - inst.helperProportions.width
						} ).left;
					}
				}
	
				if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
					( inst.options.snap.snap &&
						inst.options.snap.snap.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), {
								snapItem: inst.snapElements[ i ].item
							} ) ) );
				}
				inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );
	
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "stack", {
		start: function( event, ui, instance ) {
			var min,
				o = instance.options,
				group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
					return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
						( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
				} );
	
			if ( !group.length ) { return; }
	
			min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
			$( group ).each( function( i ) {
				$( this ).css( "zIndex", min + i );
			} );
			this.css( "zIndex", ( min + group.length ) );
		}
	} );
	
	$.ui.plugin.add( "draggable", "zIndex", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
	
			if ( t.css( "zIndex" ) ) {
				o._zIndex = t.css( "zIndex" );
			}
			t.css( "zIndex", o.zIndex );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
	
			if ( o._zIndex ) {
				$( ui.helper ).css( "zIndex", o._zIndex );
			}
		}
	} );
	
	var widgetsDraggable = $.ui.draggable;
	
	
	/*!
	 * jQuery UI Resizable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Resizable
	//>>group: Interactions
	//>>description: Enables resize functionality for any element.
	//>>docs: http://api.jqueryui.com/resizable/
	//>>demos: http://jqueryui.com/resizable/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/resizable.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.widget( "ui.resizable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "resize",
		options: {
			alsoResize: false,
			animate: false,
			animateDuration: "slow",
			animateEasing: "swing",
			aspectRatio: false,
			autoHide: false,
			classes: {
				"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
			},
			containment: false,
			ghost: false,
			grid: false,
			handles: "e,s,se",
			helper: false,
			maxHeight: null,
			maxWidth: null,
			minHeight: 10,
			minWidth: 10,
	
			// See #7960
			zIndex: 90,
	
			// Callbacks
			resize: null,
			start: null,
			stop: null
		},
	
		_num: function( value ) {
			return parseFloat( value ) || 0;
		},
	
		_isNumber: function( value ) {
			return !isNaN( parseFloat( value ) );
		},
	
		_hasScroll: function( el, a ) {
	
			if ( $( el ).css( "overflow" ) === "hidden" ) {
				return false;
			}
	
			var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
				has = false;
	
			if ( el[ scroll ] > 0 ) {
				return true;
			}
	
			// TODO: determine which cases actually cause this to happen
			// if the element doesn't have the scroll set, see if it's possible to
			// set the scroll
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
			return has;
		},
	
		_create: function() {
	
			var margins,
				o = this.options,
				that = this;
			this._addClass( "ui-resizable" );
	
			$.extend( this, {
				_aspectRatio: !!( o.aspectRatio ),
				aspectRatio: o.aspectRatio,
				originalElement: this.element,
				_proportionallyResizeElements: [],
				_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
			} );
	
			// Wrap the element if it cannot hold child nodes
			if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {
	
				this.element.wrap(
					$( "<div class='ui-wrapper' style='overflow: hidden;'></div>" ).css( {
						position: this.element.css( "position" ),
						width: this.element.outerWidth(),
						height: this.element.outerHeight(),
						top: this.element.css( "top" ),
						left: this.element.css( "left" )
					} )
				);
	
				this.element = this.element.parent().data(
					"ui-resizable", this.element.resizable( "instance" )
				);
	
				this.elementIsWrapper = true;
	
				margins = {
					marginTop: this.originalElement.css( "marginTop" ),
					marginRight: this.originalElement.css( "marginRight" ),
					marginBottom: this.originalElement.css( "marginBottom" ),
					marginLeft: this.originalElement.css( "marginLeft" )
				};
	
				this.element.css( margins );
				this.originalElement.css( "margin", 0 );
	
				// support: Safari
				// Prevent Safari textarea resize
				this.originalResizeStyle = this.originalElement.css( "resize" );
				this.originalElement.css( "resize", "none" );
	
				this._proportionallyResizeElements.push( this.originalElement.css( {
					position: "static",
					zoom: 1,
					display: "block"
				} ) );
	
				// Support: IE9
				// avoid IE jump (hard set the margin)
				this.originalElement.css( margins );
	
				this._proportionallyResize();
			}
	
			this._setupHandles();
	
			if ( o.autoHide ) {
				$( this.element )
					.on( "mouseenter", function() {
						if ( o.disabled ) {
							return;
						}
						that._removeClass( "ui-resizable-autohide" );
						that._handles.show();
					} )
					.on( "mouseleave", function() {
						if ( o.disabled ) {
							return;
						}
						if ( !that.resizing ) {
							that._addClass( "ui-resizable-autohide" );
							that._handles.hide();
						}
					} );
			}
	
			this._mouseInit();
		},
	
		_destroy: function() {
	
			this._mouseDestroy();
	
			var wrapper,
				_destroy = function( exp ) {
					$( exp )
						.removeData( "resizable" )
						.removeData( "ui-resizable" )
						.off( ".resizable" )
						.find( ".ui-resizable-handle" )
							.remove();
				};
	
			// TODO: Unwrap at same DOM position
			if ( this.elementIsWrapper ) {
				_destroy( this.element );
				wrapper = this.element;
				this.originalElement.css( {
					position: wrapper.css( "position" ),
					width: wrapper.outerWidth(),
					height: wrapper.outerHeight(),
					top: wrapper.css( "top" ),
					left: wrapper.css( "left" )
				} ).insertAfter( wrapper );
				wrapper.remove();
			}
	
			this.originalElement.css( "resize", this.originalResizeStyle );
			_destroy( this.originalElement );
	
			return this;
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			switch ( key ) {
			case "handles":
				this._removeHandles();
				this._setupHandles();
				break;
			default:
				break;
			}
		},
	
		_setupHandles: function() {
			var o = this.options, handle, i, n, hname, axis, that = this;
			this.handles = o.handles ||
				( !$( ".ui-resizable-handle", this.element ).length ?
					"e,s,se" : {
						n: ".ui-resizable-n",
						e: ".ui-resizable-e",
						s: ".ui-resizable-s",
						w: ".ui-resizable-w",
						se: ".ui-resizable-se",
						sw: ".ui-resizable-sw",
						ne: ".ui-resizable-ne",
						nw: ".ui-resizable-nw"
					} );
	
			this._handles = $();
			if ( this.handles.constructor === String ) {
	
				if ( this.handles === "all" ) {
					this.handles = "n,e,s,w,se,sw,ne,nw";
				}
	
				n = this.handles.split( "," );
				this.handles = {};
	
				for ( i = 0; i < n.length; i++ ) {
	
					handle = $.trim( n[ i ] );
					hname = "ui-resizable-" + handle;
					axis = $( "<div>" );
					this._addClass( axis, "ui-resizable-handle " + hname );
	
					axis.css( { zIndex: o.zIndex } );
	
					this.handles[ handle ] = ".ui-resizable-" + handle;
					this.element.append( axis );
				}
	
			}
	
			this._renderAxis = function( target ) {
	
				var i, axis, padPos, padWrapper;
	
				target = target || this.element;
	
				for ( i in this.handles ) {
	
					if ( this.handles[ i ].constructor === String ) {
						this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
					} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
						this.handles[ i ] = $( this.handles[ i ] );
						this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
					}
	
					if ( this.elementIsWrapper &&
							this.originalElement[ 0 ]
								.nodeName
								.match( /^(textarea|input|select|button)$/i ) ) {
						axis = $( this.handles[ i ], this.element );
	
						padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
							axis.outerHeight() :
							axis.outerWidth();
	
						padPos = [ "padding",
							/ne|nw|n/.test( i ) ? "Top" :
							/se|sw|s/.test( i ) ? "Bottom" :
							/^e$/.test( i ) ? "Right" : "Left" ].join( "" );
	
						target.css( padPos, padWrapper );
	
						this._proportionallyResize();
					}
	
					this._handles = this._handles.add( this.handles[ i ] );
				}
			};
	
			// TODO: make renderAxis a prototype function
			this._renderAxis( this.element );
	
			this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
			this._handles.disableSelection();
	
			this._handles.on( "mouseover", function() {
				if ( !that.resizing ) {
					if ( this.className ) {
						axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
					}
					that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
				}
			} );
	
			if ( o.autoHide ) {
				this._handles.hide();
				this._addClass( "ui-resizable-autohide" );
			}
		},
	
		_removeHandles: function() {
			this._handles.remove();
		},
	
		_mouseCapture: function( event ) {
			var i, handle,
				capture = false;
	
			for ( i in this.handles ) {
				handle = $( this.handles[ i ] )[ 0 ];
				if ( handle === event.target || $.contains( handle, event.target ) ) {
					capture = true;
				}
			}
	
			return !this.options.disabled && capture;
		},
	
		_mouseStart: function( event ) {
	
			var curleft, curtop, cursor,
				o = this.options,
				el = this.element;
	
			this.resizing = true;
	
			this._renderProxy();
	
			curleft = this._num( this.helper.css( "left" ) );
			curtop = this._num( this.helper.css( "top" ) );
	
			if ( o.containment ) {
				curleft += $( o.containment ).scrollLeft() || 0;
				curtop += $( o.containment ).scrollTop() || 0;
			}
	
			this.offset = this.helper.offset();
			this.position = { left: curleft, top: curtop };
	
			this.size = this._helper ? {
					width: this.helper.width(),
					height: this.helper.height()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.originalSize = this._helper ? {
					width: el.outerWidth(),
					height: el.outerHeight()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.sizeDiff = {
				width: el.outerWidth() - el.width(),
				height: el.outerHeight() - el.height()
			};
	
			this.originalPosition = { left: curleft, top: curtop };
			this.originalMousePosition = { left: event.pageX, top: event.pageY };
	
			this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
				o.aspectRatio :
				( ( this.originalSize.width / this.originalSize.height ) || 1 );
	
			cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
			$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );
	
			this._addClass( "ui-resizable-resizing" );
			this._propagate( "start", event );
			return true;
		},
	
		_mouseDrag: function( event ) {
	
			var data, props,
				smp = this.originalMousePosition,
				a = this.axis,
				dx = ( event.pageX - smp.left ) || 0,
				dy = ( event.pageY - smp.top ) || 0,
				trigger = this._change[ a ];
	
			this._updatePrevProperties();
	
			if ( !trigger ) {
				return false;
			}
	
			data = trigger.apply( this, [ event, dx, dy ] );
	
			this._updateVirtualBoundaries( event.shiftKey );
			if ( this._aspectRatio || event.shiftKey ) {
				data = this._updateRatio( data, event );
			}
	
			data = this._respectSize( data, event );
	
			this._updateCache( data );
	
			this._propagate( "resize", event );
	
			props = this._applyChanges();
	
			if ( !this._helper && this._proportionallyResizeElements.length ) {
				this._proportionallyResize();
			}
	
			if ( !$.isEmptyObject( props ) ) {
				this._updatePrevProperties();
				this._trigger( "resize", event, this.ui() );
				this._applyChanges();
			}
	
			return false;
		},
	
		_mouseStop: function( event ) {
	
			this.resizing = false;
			var pr, ista, soffseth, soffsetw, s, left, top,
				o = this.options, that = this;
	
			if ( this._helper ) {
	
				pr = this._proportionallyResizeElements;
				ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
				soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
				soffsetw = ista ? 0 : that.sizeDiff.width;
	
				s = {
					width: ( that.helper.width()  - soffsetw ),
					height: ( that.helper.height() - soffseth )
				};
				left = ( parseFloat( that.element.css( "left" ) ) +
					( that.position.left - that.originalPosition.left ) ) || null;
				top = ( parseFloat( that.element.css( "top" ) ) +
					( that.position.top - that.originalPosition.top ) ) || null;
	
				if ( !o.animate ) {
					this.element.css( $.extend( s, { top: top, left: left } ) );
				}
	
				that.helper.height( that.size.height );
				that.helper.width( that.size.width );
	
				if ( this._helper && !o.animate ) {
					this._proportionallyResize();
				}
			}
	
			$( "body" ).css( "cursor", "auto" );
	
			this._removeClass( "ui-resizable-resizing" );
	
			this._propagate( "stop", event );
	
			if ( this._helper ) {
				this.helper.remove();
			}
	
			return false;
	
		},
	
		_updatePrevProperties: function() {
			this.prevPosition = {
				top: this.position.top,
				left: this.position.left
			};
			this.prevSize = {
				width: this.size.width,
				height: this.size.height
			};
		},
	
		_applyChanges: function() {
			var props = {};
	
			if ( this.position.top !== this.prevPosition.top ) {
				props.top = this.position.top + "px";
			}
			if ( this.position.left !== this.prevPosition.left ) {
				props.left = this.position.left + "px";
			}
			if ( this.size.width !== this.prevSize.width ) {
				props.width = this.size.width + "px";
			}
			if ( this.size.height !== this.prevSize.height ) {
				props.height = this.size.height + "px";
			}
	
			this.helper.css( props );
	
			return props;
		},
	
		_updateVirtualBoundaries: function( forceAspectRatio ) {
			var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
				o = this.options;
	
			b = {
				minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
				maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
				minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
				maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
			};
	
			if ( this._aspectRatio || forceAspectRatio ) {
				pMinWidth = b.minHeight * this.aspectRatio;
				pMinHeight = b.minWidth / this.aspectRatio;
				pMaxWidth = b.maxHeight * this.aspectRatio;
				pMaxHeight = b.maxWidth / this.aspectRatio;
	
				if ( pMinWidth > b.minWidth ) {
					b.minWidth = pMinWidth;
				}
				if ( pMinHeight > b.minHeight ) {
					b.minHeight = pMinHeight;
				}
				if ( pMaxWidth < b.maxWidth ) {
					b.maxWidth = pMaxWidth;
				}
				if ( pMaxHeight < b.maxHeight ) {
					b.maxHeight = pMaxHeight;
				}
			}
			this._vBoundaries = b;
		},
	
		_updateCache: function( data ) {
			this.offset = this.helper.offset();
			if ( this._isNumber( data.left ) ) {
				this.position.left = data.left;
			}
			if ( this._isNumber( data.top ) ) {
				this.position.top = data.top;
			}
			if ( this._isNumber( data.height ) ) {
				this.size.height = data.height;
			}
			if ( this._isNumber( data.width ) ) {
				this.size.width = data.width;
			}
		},
	
		_updateRatio: function( data ) {
	
			var cpos = this.position,
				csize = this.size,
				a = this.axis;
	
			if ( this._isNumber( data.height ) ) {
				data.width = ( data.height * this.aspectRatio );
			} else if ( this._isNumber( data.width ) ) {
				data.height = ( data.width / this.aspectRatio );
			}
	
			if ( a === "sw" ) {
				data.left = cpos.left + ( csize.width - data.width );
				data.top = null;
			}
			if ( a === "nw" ) {
				data.top = cpos.top + ( csize.height - data.height );
				data.left = cpos.left + ( csize.width - data.width );
			}
	
			return data;
		},
	
		_respectSize: function( data ) {
	
			var o = this._vBoundaries,
				a = this.axis,
				ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
				ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
				isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
				isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
				dw = this.originalPosition.left + this.originalSize.width,
				dh = this.originalPosition.top + this.originalSize.height,
				cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
			if ( isminw ) {
				data.width = o.minWidth;
			}
			if ( isminh ) {
				data.height = o.minHeight;
			}
			if ( ismaxw ) {
				data.width = o.maxWidth;
			}
			if ( ismaxh ) {
				data.height = o.maxHeight;
			}
	
			if ( isminw && cw ) {
				data.left = dw - o.minWidth;
			}
			if ( ismaxw && cw ) {
				data.left = dw - o.maxWidth;
			}
			if ( isminh && ch ) {
				data.top = dh - o.minHeight;
			}
			if ( ismaxh && ch ) {
				data.top = dh - o.maxHeight;
			}
	
			// Fixing jump error on top/left - bug #2330
			if ( !data.width && !data.height && !data.left && data.top ) {
				data.top = null;
			} else if ( !data.width && !data.height && !data.top && data.left ) {
				data.left = null;
			}
	
			return data;
		},
	
		_getPaddingPlusBorderDimensions: function( element ) {
			var i = 0,
				widths = [],
				borders = [
					element.css( "borderTopWidth" ),
					element.css( "borderRightWidth" ),
					element.css( "borderBottomWidth" ),
					element.css( "borderLeftWidth" )
				],
				paddings = [
					element.css( "paddingTop" ),
					element.css( "paddingRight" ),
					element.css( "paddingBottom" ),
					element.css( "paddingLeft" )
				];
	
			for ( ; i < 4; i++ ) {
				widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
				widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
			}
	
			return {
				height: widths[ 0 ] + widths[ 2 ],
				width: widths[ 1 ] + widths[ 3 ]
			};
		},
	
		_proportionallyResize: function() {
	
			if ( !this._proportionallyResizeElements.length ) {
				return;
			}
	
			var prel,
				i = 0,
				element = this.helper || this.element;
	
			for ( ; i < this._proportionallyResizeElements.length; i++ ) {
	
				prel = this._proportionallyResizeElements[ i ];
	
				// TODO: Seems like a bug to cache this.outerDimensions
				// considering that we are in a loop.
				if ( !this.outerDimensions ) {
					this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
				}
	
				prel.css( {
					height: ( element.height() - this.outerDimensions.height ) || 0,
					width: ( element.width() - this.outerDimensions.width ) || 0
				} );
	
			}
	
		},
	
		_renderProxy: function() {
	
			var el = this.element, o = this.options;
			this.elementOffset = el.offset();
	
			if ( this._helper ) {
	
				this.helper = this.helper || $( "<div style='overflow:hidden;'></div>" );
	
				this._addClass( this.helper, this._helper );
				this.helper.css( {
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					position: "absolute",
					left: this.elementOffset.left + "px",
					top: this.elementOffset.top + "px",
					zIndex: ++o.zIndex //TODO: Don't modify option
				} );
	
				this.helper
					.appendTo( "body" )
					.disableSelection();
	
			} else {
				this.helper = this.element;
			}
	
		},
	
		_change: {
			e: function( event, dx ) {
				return { width: this.originalSize.width + dx };
			},
			w: function( event, dx ) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { left: sp.left + dx, width: cs.width - dx };
			},
			n: function( event, dx, dy ) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { top: sp.top + dy, height: cs.height - dy };
			},
			s: function( event, dx, dy ) {
				return { height: this.originalSize.height + dy };
			},
			se: function( event, dx, dy ) {
				return $.extend( this._change.s.apply( this, arguments ),
					this._change.e.apply( this, [ event, dx, dy ] ) );
			},
			sw: function( event, dx, dy ) {
				return $.extend( this._change.s.apply( this, arguments ),
					this._change.w.apply( this, [ event, dx, dy ] ) );
			},
			ne: function( event, dx, dy ) {
				return $.extend( this._change.n.apply( this, arguments ),
					this._change.e.apply( this, [ event, dx, dy ] ) );
			},
			nw: function( event, dx, dy ) {
				return $.extend( this._change.n.apply( this, arguments ),
					this._change.w.apply( this, [ event, dx, dy ] ) );
			}
		},
	
		_propagate: function( n, event ) {
			$.ui.plugin.call( this, n, [ event, this.ui() ] );
			( n !== "resize" && this._trigger( n, event, this.ui() ) );
		},
	
		plugins: {},
	
		ui: function() {
			return {
				originalElement: this.originalElement,
				element: this.element,
				helper: this.helper,
				position: this.position,
				size: this.size,
				originalSize: this.originalSize,
				originalPosition: this.originalPosition
			};
		}
	
	} );
	
	/*
	 * Resizable Extensions
	 */
	
	$.ui.plugin.add( "resizable", "animate", {
	
		stop: function( event ) {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				pr = that._proportionallyResizeElements,
				ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
				soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
				soffsetw = ista ? 0 : that.sizeDiff.width,
				style = {
					width: ( that.size.width - soffsetw ),
					height: ( that.size.height - soffseth )
				},
				left = ( parseFloat( that.element.css( "left" ) ) +
					( that.position.left - that.originalPosition.left ) ) || null,
				top = ( parseFloat( that.element.css( "top" ) ) +
					( that.position.top - that.originalPosition.top ) ) || null;
	
			that.element.animate(
				$.extend( style, top && left ? { top: top, left: left } : {} ), {
					duration: o.animateDuration,
					easing: o.animateEasing,
					step: function() {
	
						var data = {
							width: parseFloat( that.element.css( "width" ) ),
							height: parseFloat( that.element.css( "height" ) ),
							top: parseFloat( that.element.css( "top" ) ),
							left: parseFloat( that.element.css( "left" ) )
						};
	
						if ( pr && pr.length ) {
							$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
						}
	
						// Propagating resize, and updating values for each animation step
						that._updateCache( data );
						that._propagate( "resize", event );
	
					}
				}
			);
		}
	
	} );
	
	$.ui.plugin.add( "resizable", "containment", {
	
		start: function() {
			var element, p, co, ch, cw, width, height,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				el = that.element,
				oc = o.containment,
				ce = ( oc instanceof $ ) ?
					oc.get( 0 ) :
					( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;
	
			if ( !ce ) {
				return;
			}
	
			that.containerElement = $( ce );
	
			if ( /document/.test( oc ) || oc === document ) {
				that.containerOffset = {
					left: 0,
					top: 0
				};
				that.containerPosition = {
					left: 0,
					top: 0
				};
	
				that.parentData = {
					element: $( document ),
					left: 0,
					top: 0,
					width: $( document ).width(),
					height: $( document ).height() || document.body.parentNode.scrollHeight
				};
			} else {
				element = $( ce );
				p = [];
				$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
					p[ i ] = that._num( element.css( "padding" + name ) );
				} );
	
				that.containerOffset = element.offset();
				that.containerPosition = element.position();
				that.containerSize = {
					height: ( element.innerHeight() - p[ 3 ] ),
					width: ( element.innerWidth() - p[ 1 ] )
				};
	
				co = that.containerOffset;
				ch = that.containerSize.height;
				cw = that.containerSize.width;
				width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
				height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;
	
				that.parentData = {
					element: ce,
					left: co.left,
					top: co.top,
					width: width,
					height: height
				};
			}
		},
	
		resize: function( event ) {
			var woset, hoset, isParent, isOffsetRelative,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cp = that.position,
				pRatio = that._aspectRatio || event.shiftKey,
				cop = {
					top: 0,
					left: 0
				},
				ce = that.containerElement,
				continueResize = true;
	
			if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
				cop = co;
			}
	
			if ( cp.left < ( that._helper ? co.left : 0 ) ) {
				that.size.width = that.size.width +
					( that._helper ?
						( that.position.left - co.left ) :
						( that.position.left - cop.left ) );
	
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
				that.position.left = o.helper ? co.left : 0;
			}
	
			if ( cp.top < ( that._helper ? co.top : 0 ) ) {
				that.size.height = that.size.height +
					( that._helper ?
						( that.position.top - co.top ) :
						that.position.top );
	
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
				that.position.top = that._helper ? co.top : 0;
			}
	
			isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
			isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );
	
			if ( isParent && isOffsetRelative ) {
				that.offset.left = that.parentData.left + that.position.left;
				that.offset.top = that.parentData.top + that.position.top;
			} else {
				that.offset.left = that.element.offset().left;
				that.offset.top = that.element.offset().top;
			}
	
			woset = Math.abs( that.sizeDiff.width +
				( that._helper ?
					that.offset.left - cop.left :
					( that.offset.left - co.left ) ) );
	
			hoset = Math.abs( that.sizeDiff.height +
				( that._helper ?
					that.offset.top - cop.top :
					( that.offset.top - co.top ) ) );
	
			if ( woset + that.size.width >= that.parentData.width ) {
				that.size.width = that.parentData.width - woset;
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( hoset + that.size.height >= that.parentData.height ) {
				that.size.height = that.parentData.height - hoset;
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( !continueResize ) {
				that.position.left = that.prevPosition.left;
				that.position.top = that.prevPosition.top;
				that.size.width = that.prevSize.width;
				that.size.height = that.prevSize.height;
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cop = that.containerPosition,
				ce = that.containerElement,
				helper = $( that.helper ),
				ho = helper.offset(),
				w = helper.outerWidth() - that.sizeDiff.width,
				h = helper.outerHeight() - that.sizeDiff.height;
	
			if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
				$( this ).css( {
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				} );
			}
	
			if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
				$( this ).css( {
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				} );
			}
		}
	} );
	
	$.ui.plugin.add( "resizable", "alsoResize", {
	
		start: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options;
	
			$( o.alsoResize ).each( function() {
				var el = $( this );
				el.data( "ui-resizable-alsoresize", {
					width: parseFloat( el.width() ), height: parseFloat( el.height() ),
					left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
				} );
			} );
		},
	
		resize: function( event, ui ) {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				os = that.originalSize,
				op = that.originalPosition,
				delta = {
					height: ( that.size.height - os.height ) || 0,
					width: ( that.size.width - os.width ) || 0,
					top: ( that.position.top - op.top ) || 0,
					left: ( that.position.left - op.left ) || 0
				};
	
				$( o.alsoResize ).each( function() {
					var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
						css = el.parents( ui.originalElement[ 0 ] ).length ?
								[ "width", "height" ] :
								[ "width", "height", "top", "left" ];
	
					$.each( css, function( i, prop ) {
						var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
						if ( sum && sum >= 0 ) {
							style[ prop ] = sum || null;
						}
					} );
	
					el.css( style );
				} );
		},
	
		stop: function() {
			$( this ).removeData( "ui-resizable-alsoresize" );
		}
	} );
	
	$.ui.plugin.add( "resizable", "ghost", {
	
		start: function() {
	
			var that = $( this ).resizable( "instance" ), cs = that.size;
	
			that.ghost = that.originalElement.clone();
			that.ghost.css( {
				opacity: 0.25,
				display: "block",
				position: "relative",
				height: cs.height,
				width: cs.width,
				margin: 0,
				left: 0,
				top: 0
			} );
	
			that._addClass( that.ghost, "ui-resizable-ghost" );
	
			// DEPRECATED
			// TODO: remove after 1.12
			if ( $.uiBackCompat !== false && typeof that.options.ghost === "string" ) {
	
				// Ghost option
				that.ghost.addClass( this.options.ghost );
			}
	
			that.ghost.appendTo( that.helper );
	
		},
	
		resize: function() {
			var that = $( this ).resizable( "instance" );
			if ( that.ghost ) {
				that.ghost.css( {
					position: "relative",
					height: that.size.height,
					width: that.size.width
				} );
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" );
			if ( that.ghost && that.helper ) {
				that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
			}
		}
	
	} );
	
	$.ui.plugin.add( "resizable", "grid", {
	
		resize: function() {
			var outerDimensions,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				cs = that.size,
				os = that.originalSize,
				op = that.originalPosition,
				a = that.axis,
				grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
				gridX = ( grid[ 0 ] || 1 ),
				gridY = ( grid[ 1 ] || 1 ),
				ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
				oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
				newWidth = os.width + ox,
				newHeight = os.height + oy,
				isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
				isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
				isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
				isMinHeight = o.minHeight && ( o.minHeight > newHeight );
	
			o.grid = grid;
	
			if ( isMinWidth ) {
				newWidth += gridX;
			}
			if ( isMinHeight ) {
				newHeight += gridY;
			}
			if ( isMaxWidth ) {
				newWidth -= gridX;
			}
			if ( isMaxHeight ) {
				newHeight -= gridY;
			}
	
			if ( /^(se|s|e)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
			} else if ( /^(ne)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else if ( /^(sw)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.left = op.left - ox;
			} else {
				if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
					outerDimensions = that._getPaddingPlusBorderDimensions( this );
				}
	
				if ( newHeight - gridY > 0 ) {
					that.size.height = newHeight;
					that.position.top = op.top - oy;
				} else {
					newHeight = gridY - outerDimensions.height;
					that.size.height = newHeight;
					that.position.top = op.top + os.height - newHeight;
				}
				if ( newWidth - gridX > 0 ) {
					that.size.width = newWidth;
					that.position.left = op.left - ox;
				} else {
					newWidth = gridX - outerDimensions.width;
					that.size.width = newWidth;
					that.position.left = op.left + os.width - newWidth;
				}
			}
		}
	
	} );
	
	var widgetsResizable = $.ui.resizable;
	
	
	/*!
	 * jQuery UI Dialog 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Dialog
	//>>group: Widgets
	//>>description: Displays customizable dialog windows.
	//>>docs: http://api.jqueryui.com/dialog/
	//>>demos: http://jqueryui.com/dialog/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/dialog.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.widget( "ui.dialog", {
		version: "1.12.1",
		options: {
			appendTo: "body",
			autoOpen: true,
			buttons: [],
			classes: {
				"ui-dialog": "ui-corner-all",
				"ui-dialog-titlebar": "ui-corner-all"
			},
			closeOnEscape: true,
			closeText: "Close",
			draggable: true,
			hide: null,
			height: "auto",
			maxHeight: null,
			maxWidth: null,
			minHeight: 150,
			minWidth: 150,
			modal: false,
			position: {
				my: "center",
				at: "center",
				of: window,
				collision: "fit",
	
				// Ensure the titlebar is always visible
				using: function( pos ) {
					var topOffset = $( this ).css( pos ).offset().top;
					if ( topOffset < 0 ) {
						$( this ).css( "top", pos.top - topOffset );
					}
				}
			},
			resizable: true,
			show: null,
			title: null,
			width: 300,
	
			// Callbacks
			beforeClose: null,
			close: null,
			drag: null,
			dragStart: null,
			dragStop: null,
			focus: null,
			open: null,
			resize: null,
			resizeStart: null,
			resizeStop: null
		},
	
		sizeRelatedOptions: {
			buttons: true,
			height: true,
			maxHeight: true,
			maxWidth: true,
			minHeight: true,
			minWidth: true,
			width: true
		},
	
		resizableRelatedOptions: {
			maxHeight: true,
			maxWidth: true,
			minHeight: true,
			minWidth: true
		},
	
		_create: function() {
			this.originalCss = {
				display: this.element[ 0 ].style.display,
				width: this.element[ 0 ].style.width,
				minHeight: this.element[ 0 ].style.minHeight,
				maxHeight: this.element[ 0 ].style.maxHeight,
				height: this.element[ 0 ].style.height
			};
			this.originalPosition = {
				parent: this.element.parent(),
				index: this.element.parent().children().index( this.element )
			};
			this.originalTitle = this.element.attr( "title" );
			if ( this.options.title == null && this.originalTitle != null ) {
				this.options.title = this.originalTitle;
			}
	
			// Dialogs can't be disabled
			if ( this.options.disabled ) {
				this.options.disabled = false;
			}
	
			this._createWrapper();
	
			this.element
				.show()
				.removeAttr( "title" )
				.appendTo( this.uiDialog );
	
			this._addClass( "ui-dialog-content", "ui-widget-content" );
	
			this._createTitlebar();
			this._createButtonPane();
	
			if ( this.options.draggable && $.fn.draggable ) {
				this._makeDraggable();
			}
			if ( this.options.resizable && $.fn.resizable ) {
				this._makeResizable();
			}
	
			this._isOpen = false;
	
			this._trackFocus();
		},
	
		_init: function() {
			if ( this.options.autoOpen ) {
				this.open();
			}
		},
	
		_appendTo: function() {
			var element = this.options.appendTo;
			if ( element && ( element.jquery || element.nodeType ) ) {
				return $( element );
			}
			return this.document.find( element || "body" ).eq( 0 );
		},
	
		_destroy: function() {
			var next,
				originalPosition = this.originalPosition;
	
			this._untrackInstance();
			this._destroyOverlay();
	
			this.element
				.removeUniqueId()
				.css( this.originalCss )
	
				// Without detaching first, the following becomes really slow
				.detach();
	
			this.uiDialog.remove();
	
			if ( this.originalTitle ) {
				this.element.attr( "title", this.originalTitle );
			}
	
			next = originalPosition.parent.children().eq( originalPosition.index );
	
			// Don't try to place the dialog next to itself (#8613)
			if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
				next.before( this.element );
			} else {
				originalPosition.parent.append( this.element );
			}
		},
	
		widget: function() {
			return this.uiDialog;
		},
	
		disable: $.noop,
		enable: $.noop,
	
		close: function( event ) {
			var that = this;
	
			if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
				return;
			}
	
			this._isOpen = false;
			this._focusedElement = null;
			this._destroyOverlay();
			this._untrackInstance();
	
			if ( !this.opener.filter( ":focusable" ).trigger( "focus" ).length ) {
	
				// Hiding a focused element doesn't trigger blur in WebKit
				// so in case we have nothing to focus on, explicitly blur the active element
				// https://bugs.webkit.org/show_bug.cgi?id=47182
				$.ui.safeBlur( $.ui.safeActiveElement( this.document[ 0 ] ) );
			}
	
			this._hide( this.uiDialog, this.options.hide, function() {
				that._trigger( "close", event );
			} );
		},
	
		isOpen: function() {
			return this._isOpen;
		},
	
		moveToTop: function() {
			this._moveToTop();
		},
	
		_moveToTop: function( event, silent ) {
			var moved = false,
				zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map( function() {
					return +$( this ).css( "z-index" );
				} ).get(),
				zIndexMax = Math.max.apply( null, zIndices );
	
			if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
				this.uiDialog.css( "z-index", zIndexMax + 1 );
				moved = true;
			}
	
			if ( moved && !silent ) {
				this._trigger( "focus", event );
			}
			return moved;
		},
	
		open: function() {
			var that = this;
			if ( this._isOpen ) {
				if ( this._moveToTop() ) {
					this._focusTabbable();
				}
				return;
			}
	
			this._isOpen = true;
			this.opener = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
	
			this._size();
			this._position();
			this._createOverlay();
			this._moveToTop( null, true );
	
			// Ensure the overlay is moved to the top with the dialog, but only when
			// opening. The overlay shouldn't move after the dialog is open so that
			// modeless dialogs opened after the modal dialog stack properly.
			if ( this.overlay ) {
				this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
			}
	
			this._show( this.uiDialog, this.options.show, function() {
				that._focusTabbable();
				that._trigger( "focus" );
			} );
	
			// Track the dialog immediately upon openening in case a focus event
			// somehow occurs outside of the dialog before an element inside the
			// dialog is focused (#10152)
			this._makeFocusTarget();
	
			this._trigger( "open" );
		},
	
		_focusTabbable: function() {
	
			// Set focus to the first match:
			// 1. An element that was focused previously
			// 2. First element inside the dialog matching [autofocus]
			// 3. Tabbable element inside the content element
			// 4. Tabbable element inside the buttonpane
			// 5. The close button
			// 6. The dialog itself
			var hasFocus = this._focusedElement;
			if ( !hasFocus ) {
				hasFocus = this.element.find( "[autofocus]" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.element.find( ":tabbable" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.uiDialog;
			}
			hasFocus.eq( 0 ).trigger( "focus" );
		},
	
		_keepFocus: function( event ) {
			function checkFocus() {
				var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
					isActive = this.uiDialog[ 0 ] === activeElement ||
						$.contains( this.uiDialog[ 0 ], activeElement );
				if ( !isActive ) {
					this._focusTabbable();
				}
			}
			event.preventDefault();
			checkFocus.call( this );
	
			// support: IE
			// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
			// so we check again later
			this._delay( checkFocus );
		},
	
		_createWrapper: function() {
			this.uiDialog = $( "<div>" )
				.hide()
				.attr( {
	
					// Setting tabIndex makes the div focusable
					tabIndex: -1,
					role: "dialog"
				} )
				.appendTo( this._appendTo() );
	
			this._addClass( this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front" );
			this._on( this.uiDialog, {
				keydown: function( event ) {
					if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
							event.keyCode === $.ui.keyCode.ESCAPE ) {
						event.preventDefault();
						this.close( event );
						return;
					}
	
					// Prevent tabbing out of dialogs
					if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
						return;
					}
					var tabbables = this.uiDialog.find( ":tabbable" ),
						first = tabbables.filter( ":first" ),
						last = tabbables.filter( ":last" );
	
					if ( ( event.target === last[ 0 ] || event.target === this.uiDialog[ 0 ] ) &&
							!event.shiftKey ) {
						this._delay( function() {
							first.trigger( "focus" );
						} );
						event.preventDefault();
					} else if ( ( event.target === first[ 0 ] ||
							event.target === this.uiDialog[ 0 ] ) && event.shiftKey ) {
						this._delay( function() {
							last.trigger( "focus" );
						} );
						event.preventDefault();
					}
				},
				mousedown: function( event ) {
					if ( this._moveToTop( event ) ) {
						this._focusTabbable();
					}
				}
			} );
	
			// We assume that any existing aria-describedby attribute means
			// that the dialog content is marked up properly
			// otherwise we brute force the content as the description
			if ( !this.element.find( "[aria-describedby]" ).length ) {
				this.uiDialog.attr( {
					"aria-describedby": this.element.uniqueId().attr( "id" )
				} );
			}
		},
	
		_createTitlebar: function() {
			var uiDialogTitle;
	
			this.uiDialogTitlebar = $( "<div>" );
			this._addClass( this.uiDialogTitlebar,
				"ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix" );
			this._on( this.uiDialogTitlebar, {
				mousedown: function( event ) {
	
					// Don't prevent click on close button (#8838)
					// Focusing a dialog that is partially scrolled out of view
					// causes the browser to scroll it into view, preventing the click event
					if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {
	
						// Dialog isn't getting focus when dragging (#8063)
						this.uiDialog.trigger( "focus" );
					}
				}
			} );
	
			// Support: IE
			// Use type="button" to prevent enter keypresses in textboxes from closing the
			// dialog in IE (#9312)
			this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
				.button( {
					label: $( "<a>" ).text( this.options.closeText ).html(),
					icon: "ui-icon-closethick",
					showLabel: false
				} )
				.appendTo( this.uiDialogTitlebar );
	
			this._addClass( this.uiDialogTitlebarClose, "ui-dialog-titlebar-close" );
			this._on( this.uiDialogTitlebarClose, {
				click: function( event ) {
					event.preventDefault();
					this.close( event );
				}
			} );
	
			uiDialogTitle = $( "<span>" ).uniqueId().prependTo( this.uiDialogTitlebar );
			this._addClass( uiDialogTitle, "ui-dialog-title" );
			this._title( uiDialogTitle );
	
			this.uiDialogTitlebar.prependTo( this.uiDialog );
	
			this.uiDialog.attr( {
				"aria-labelledby": uiDialogTitle.attr( "id" )
			} );
		},
	
		_title: function( title ) {
			if ( this.options.title ) {
				title.text( this.options.title );
			} else {
				title.html( "&#160;" );
			}
		},
	
		_createButtonPane: function() {
			this.uiDialogButtonPane = $( "<div>" );
			this._addClass( this.uiDialogButtonPane, "ui-dialog-buttonpane",
				"ui-widget-content ui-helper-clearfix" );
	
			this.uiButtonSet = $( "<div>" )
				.appendTo( this.uiDialogButtonPane );
			this._addClass( this.uiButtonSet, "ui-dialog-buttonset" );
	
			this._createButtons();
		},
	
		_createButtons: function() {
			var that = this,
				buttons = this.options.buttons;
	
			// If we already have a button pane, remove it
			this.uiDialogButtonPane.remove();
			this.uiButtonSet.empty();
	
			if ( $.isEmptyObject( buttons ) || ( $.isArray( buttons ) && !buttons.length ) ) {
				this._removeClass( this.uiDialog, "ui-dialog-buttons" );
				return;
			}
	
			$.each( buttons, function( name, props ) {
				var click, buttonOptions;
				props = $.isFunction( props ) ?
					{ click: props, text: name } :
					props;
	
				// Default to a non-submitting button
				props = $.extend( { type: "button" }, props );
	
				// Change the context for the click callback to be the main element
				click = props.click;
				buttonOptions = {
					icon: props.icon,
					iconPosition: props.iconPosition,
					showLabel: props.showLabel,
	
					// Deprecated options
					icons: props.icons,
					text: props.text
				};
	
				delete props.click;
				delete props.icon;
				delete props.iconPosition;
				delete props.showLabel;
	
				// Deprecated options
				delete props.icons;
				if ( typeof props.text === "boolean" ) {
					delete props.text;
				}
	
				$( "<button></button>", props )
					.button( buttonOptions )
					.appendTo( that.uiButtonSet )
					.on( "click", function() {
						click.apply( that.element[ 0 ], arguments );
					} );
			} );
			this._addClass( this.uiDialog, "ui-dialog-buttons" );
			this.uiDialogButtonPane.appendTo( this.uiDialog );
		},
	
		_makeDraggable: function() {
			var that = this,
				options = this.options;
	
			function filteredUi( ui ) {
				return {
					position: ui.position,
					offset: ui.offset
				};
			}
	
			this.uiDialog.draggable( {
				cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
				handle: ".ui-dialog-titlebar",
				containment: "document",
				start: function( event, ui ) {
					that._addClass( $( this ), "ui-dialog-dragging" );
					that._blockFrames();
					that._trigger( "dragStart", event, filteredUi( ui ) );
				},
				drag: function( event, ui ) {
					that._trigger( "drag", event, filteredUi( ui ) );
				},
				stop: function( event, ui ) {
					var left = ui.offset.left - that.document.scrollLeft(),
						top = ui.offset.top - that.document.scrollTop();
	
					options.position = {
						my: "left top",
						at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
							"top" + ( top >= 0 ? "+" : "" ) + top,
						of: that.window
					};
					that._removeClass( $( this ), "ui-dialog-dragging" );
					that._unblockFrames();
					that._trigger( "dragStop", event, filteredUi( ui ) );
				}
			} );
		},
	
		_makeResizable: function() {
			var that = this,
				options = this.options,
				handles = options.resizable,
	
				// .ui-resizable has position: relative defined in the stylesheet
				// but dialogs have to use absolute or fixed positioning
				position = this.uiDialog.css( "position" ),
				resizeHandles = typeof handles === "string" ?
					handles :
					"n,e,s,w,se,sw,ne,nw";
	
			function filteredUi( ui ) {
				return {
					originalPosition: ui.originalPosition,
					originalSize: ui.originalSize,
					position: ui.position,
					size: ui.size
				};
			}
	
			this.uiDialog.resizable( {
				cancel: ".ui-dialog-content",
				containment: "document",
				alsoResize: this.element,
				maxWidth: options.maxWidth,
				maxHeight: options.maxHeight,
				minWidth: options.minWidth,
				minHeight: this._minHeight(),
				handles: resizeHandles,
				start: function( event, ui ) {
					that._addClass( $( this ), "ui-dialog-resizing" );
					that._blockFrames();
					that._trigger( "resizeStart", event, filteredUi( ui ) );
				},
				resize: function( event, ui ) {
					that._trigger( "resize", event, filteredUi( ui ) );
				},
				stop: function( event, ui ) {
					var offset = that.uiDialog.offset(),
						left = offset.left - that.document.scrollLeft(),
						top = offset.top - that.document.scrollTop();
	
					options.height = that.uiDialog.height();
					options.width = that.uiDialog.width();
					options.position = {
						my: "left top",
						at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
							"top" + ( top >= 0 ? "+" : "" ) + top,
						of: that.window
					};
					that._removeClass( $( this ), "ui-dialog-resizing" );
					that._unblockFrames();
					that._trigger( "resizeStop", event, filteredUi( ui ) );
				}
			} )
				.css( "position", position );
		},
	
		_trackFocus: function() {
			this._on( this.widget(), {
				focusin: function( event ) {
					this._makeFocusTarget();
					this._focusedElement = $( event.target );
				}
			} );
		},
	
		_makeFocusTarget: function() {
			this._untrackInstance();
			this._trackingInstances().unshift( this );
		},
	
		_untrackInstance: function() {
			var instances = this._trackingInstances(),
				exists = $.inArray( this, instances );
			if ( exists !== -1 ) {
				instances.splice( exists, 1 );
			}
		},
	
		_trackingInstances: function() {
			var instances = this.document.data( "ui-dialog-instances" );
			if ( !instances ) {
				instances = [];
				this.document.data( "ui-dialog-instances", instances );
			}
			return instances;
		},
	
		_minHeight: function() {
			var options = this.options;
	
			return options.height === "auto" ?
				options.minHeight :
				Math.min( options.minHeight, options.height );
		},
	
		_position: function() {
	
			// Need to show the dialog to get the actual offset in the position plugin
			var isVisible = this.uiDialog.is( ":visible" );
			if ( !isVisible ) {
				this.uiDialog.show();
			}
			this.uiDialog.position( this.options.position );
			if ( !isVisible ) {
				this.uiDialog.hide();
			}
		},
	
		_setOptions: function( options ) {
			var that = this,
				resize = false,
				resizableOptions = {};
	
			$.each( options, function( key, value ) {
				that._setOption( key, value );
	
				if ( key in that.sizeRelatedOptions ) {
					resize = true;
				}
				if ( key in that.resizableRelatedOptions ) {
					resizableOptions[ key ] = value;
				}
			} );
	
			if ( resize ) {
				this._size();
				this._position();
			}
			if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
				this.uiDialog.resizable( "option", resizableOptions );
			}
		},
	
		_setOption: function( key, value ) {
			var isDraggable, isResizable,
				uiDialog = this.uiDialog;
	
			if ( key === "disabled" ) {
				return;
			}
	
			this._super( key, value );
	
			if ( key === "appendTo" ) {
				this.uiDialog.appendTo( this._appendTo() );
			}
	
			if ( key === "buttons" ) {
				this._createButtons();
			}
	
			if ( key === "closeText" ) {
				this.uiDialogTitlebarClose.button( {
	
					// Ensure that we always pass a string
					label: $( "<a>" ).text( "" + this.options.closeText ).html()
				} );
			}
	
			if ( key === "draggable" ) {
				isDraggable = uiDialog.is( ":data(ui-draggable)" );
				if ( isDraggable && !value ) {
					uiDialog.draggable( "destroy" );
				}
	
				if ( !isDraggable && value ) {
					this._makeDraggable();
				}
			}
	
			if ( key === "position" ) {
				this._position();
			}
	
			if ( key === "resizable" ) {
	
				// currently resizable, becoming non-resizable
				isResizable = uiDialog.is( ":data(ui-resizable)" );
				if ( isResizable && !value ) {
					uiDialog.resizable( "destroy" );
				}
	
				// Currently resizable, changing handles
				if ( isResizable && typeof value === "string" ) {
					uiDialog.resizable( "option", "handles", value );
				}
	
				// Currently non-resizable, becoming resizable
				if ( !isResizable && value !== false ) {
					this._makeResizable();
				}
			}
	
			if ( key === "title" ) {
				this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
			}
		},
	
		_size: function() {
	
			// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
			// divs will both have width and height set, so we need to reset them
			var nonContentHeight, minContentHeight, maxContentHeight,
				options = this.options;
	
			// Reset content sizing
			this.element.show().css( {
				width: "auto",
				minHeight: 0,
				maxHeight: "none",
				height: 0
			} );
	
			if ( options.minWidth > options.width ) {
				options.width = options.minWidth;
			}
	
			// Reset wrapper sizing
			// determine the height of all the non-content elements
			nonContentHeight = this.uiDialog.css( {
				height: "auto",
				width: options.width
			} )
				.outerHeight();
			minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
			maxContentHeight = typeof options.maxHeight === "number" ?
				Math.max( 0, options.maxHeight - nonContentHeight ) :
				"none";
	
			if ( options.height === "auto" ) {
				this.element.css( {
					minHeight: minContentHeight,
					maxHeight: maxContentHeight,
					height: "auto"
				} );
			} else {
				this.element.height( Math.max( 0, options.height - nonContentHeight ) );
			}
	
			if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
				this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
			}
		},
	
		_blockFrames: function() {
			this.iframeBlocks = this.document.find( "iframe" ).map( function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css( {
						position: "absolute",
						width: iframe.outerWidth(),
						height: iframe.outerHeight()
					} )
					.appendTo( iframe.parent() )
					.offset( iframe.offset() )[ 0 ];
			} );
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_allowInteraction: function( event ) {
			if ( $( event.target ).closest( ".ui-dialog" ).length ) {
				return true;
			}
	
			// TODO: Remove hack when datepicker implements
			// the .ui-front logic (#8989)
			return !!$( event.target ).closest( ".ui-datepicker" ).length;
		},
	
		_createOverlay: function() {
			if ( !this.options.modal ) {
				return;
			}
	
			// We use a delay in case the overlay is created from an
			// event that we're going to be cancelling (#2804)
			var isOpening = true;
			this._delay( function() {
				isOpening = false;
			} );
	
			if ( !this.document.data( "ui-dialog-overlays" ) ) {
	
				// Prevent use of anchors and inputs
				// Using _on() for an event handler shared across many instances is
				// safe because the dialogs stack and must be closed in reverse order
				this._on( this.document, {
					focusin: function( event ) {
						if ( isOpening ) {
							return;
						}
	
						if ( !this._allowInteraction( event ) ) {
							event.preventDefault();
							this._trackingInstances()[ 0 ]._focusTabbable();
						}
					}
				} );
			}
	
			this.overlay = $( "<div>" )
				.appendTo( this._appendTo() );
	
			this._addClass( this.overlay, null, "ui-widget-overlay ui-front" );
			this._on( this.overlay, {
				mousedown: "_keepFocus"
			} );
			this.document.data( "ui-dialog-overlays",
				( this.document.data( "ui-dialog-overlays" ) || 0 ) + 1 );
		},
	
		_destroyOverlay: function() {
			if ( !this.options.modal ) {
				return;
			}
	
			if ( this.overlay ) {
				var overlays = this.document.data( "ui-dialog-overlays" ) - 1;
	
				if ( !overlays ) {
					this._off( this.document, "focusin" );
					this.document.removeData( "ui-dialog-overlays" );
				} else {
					this.document.data( "ui-dialog-overlays", overlays );
				}
	
				this.overlay.remove();
				this.overlay = null;
			}
		}
	} );
	
	// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if ( $.uiBackCompat !== false ) {
	
		// Backcompat for dialogClass option
		$.widget( "ui.dialog", $.ui.dialog, {
			options: {
				dialogClass: ""
			},
			_createWrapper: function() {
				this._super();
				this.uiDialog.addClass( this.options.dialogClass );
			},
			_setOption: function( key, value ) {
				if ( key === "dialogClass" ) {
					this.uiDialog
						.removeClass( this.options.dialogClass )
						.addClass( value );
				}
				this._superApply( arguments );
			}
		} );
	}
	
	var widgetsDialog = $.ui.dialog;
	
	
	/*!
	 * jQuery UI Droppable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Droppable
	//>>group: Interactions
	//>>description: Enables drop targets for draggable elements.
	//>>docs: http://api.jqueryui.com/droppable/
	//>>demos: http://jqueryui.com/droppable/
	
	
	
	$.widget( "ui.droppable", {
		version: "1.12.1",
		widgetEventPrefix: "drop",
		options: {
			accept: "*",
			addClasses: true,
			greedy: false,
			scope: "default",
			tolerance: "intersect",
	
			// Callbacks
			activate: null,
			deactivate: null,
			drop: null,
			out: null,
			over: null
		},
		_create: function() {
	
			var proportions,
				o = this.options,
				accept = o.accept;
	
			this.isover = false;
			this.isout = true;
	
			this.accept = $.isFunction( accept ) ? accept : function( d ) {
				return d.is( accept );
			};
	
			this.proportions = function( /* valueToWrite */ ) {
				if ( arguments.length ) {
	
					// Store the droppable's proportions
					proportions = arguments[ 0 ];
				} else {
	
					// Retrieve or derive the droppable's proportions
					return proportions ?
						proportions :
						proportions = {
							width: this.element[ 0 ].offsetWidth,
							height: this.element[ 0 ].offsetHeight
						};
				}
			};
	
			this._addToManager( o.scope );
	
			o.addClasses && this._addClass( "ui-droppable" );
	
		},
	
		_addToManager: function( scope ) {
	
			// Add the reference and positions to the manager
			$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
			$.ui.ddmanager.droppables[ scope ].push( this );
		},
	
		_splice: function( drop ) {
			var i = 0;
			for ( ; i < drop.length; i++ ) {
				if ( drop[ i ] === this ) {
					drop.splice( i, 1 );
				}
			}
		},
	
		_destroy: function() {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
			this._splice( drop );
		},
	
		_setOption: function( key, value ) {
	
			if ( key === "accept" ) {
				this.accept = $.isFunction( value ) ? value : function( d ) {
					return d.is( value );
				};
			} else if ( key === "scope" ) {
				var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
				this._splice( drop );
				this._addToManager( value );
			}
	
			this._super( key, value );
		},
	
		_activate: function( event ) {
			var draggable = $.ui.ddmanager.current;
	
			this._addActiveClass();
			if ( draggable ) {
				this._trigger( "activate", event, this.ui( draggable ) );
			}
		},
	
		_deactivate: function( event ) {
			var draggable = $.ui.ddmanager.current;
	
			this._removeActiveClass();
			if ( draggable ) {
				this._trigger( "deactivate", event, this.ui( draggable ) );
			}
		},
	
		_over: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
					draggable.element ) ) ) {
				this._addHoverClass();
				this._trigger( "over", event, this.ui( draggable ) );
			}
	
		},
	
		_out: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
					draggable.element ) ) ) {
				this._removeHoverClass();
				this._trigger( "out", event, this.ui( draggable ) );
			}
	
		},
	
		_drop: function( event, custom ) {
	
			var draggable = custom || $.ui.ddmanager.current,
				childrenIntersection = false;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return false;
			}
	
			this.element
				.find( ":data(ui-droppable)" )
				.not( ".ui-draggable-dragging" )
				.each( function() {
					var inst = $( this ).droppable( "instance" );
					if (
						inst.options.greedy &&
						!inst.options.disabled &&
						inst.options.scope === draggable.options.scope &&
						inst.accept.call(
							inst.element[ 0 ], ( draggable.currentItem || draggable.element )
						) &&
						intersect(
							draggable,
							$.extend( inst, { offset: inst.element.offset() } ),
							inst.options.tolerance, event
						)
					) {
						childrenIntersection = true;
						return false; }
				} );
			if ( childrenIntersection ) {
				return false;
			}
	
			if ( this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this._removeActiveClass();
				this._removeHoverClass();
	
				this._trigger( "drop", event, this.ui( draggable ) );
				return this.element;
			}
	
			return false;
	
		},
	
		ui: function( c ) {
			return {
				draggable: ( c.currentItem || c.element ),
				helper: c.helper,
				position: c.position,
				offset: c.positionAbs
			};
		},
	
		// Extension points just to make backcompat sane and avoid duplicating logic
		// TODO: Remove in 1.13 along with call to it below
		_addHoverClass: function() {
			this._addClass( "ui-droppable-hover" );
		},
	
		_removeHoverClass: function() {
			this._removeClass( "ui-droppable-hover" );
		},
	
		_addActiveClass: function() {
			this._addClass( "ui-droppable-active" );
		},
	
		_removeActiveClass: function() {
			this._removeClass( "ui-droppable-active" );
		}
	} );
	
	var intersect = $.ui.intersect = ( function() {
		function isOverAxis( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		}
	
		return function( draggable, droppable, toleranceMode, event ) {
	
			if ( !droppable.offset ) {
				return false;
			}
	
			var x1 = ( draggable.positionAbs ||
					draggable.position.absolute ).left + draggable.margins.left,
				y1 = ( draggable.positionAbs ||
					draggable.position.absolute ).top + draggable.margins.top,
				x2 = x1 + draggable.helperProportions.width,
				y2 = y1 + draggable.helperProportions.height,
				l = droppable.offset.left,
				t = droppable.offset.top,
				r = l + droppable.proportions().width,
				b = t + droppable.proportions().height;
	
			switch ( toleranceMode ) {
			case "fit":
				return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
			case "intersect":
				return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
					x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
			case "pointer":
				return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
					isOverAxis( event.pageX, l, droppable.proportions().width );
			case "touch":
				return (
					( y1 >= t && y1 <= b ) || // Top edge touching
					( y2 >= t && y2 <= b ) || // Bottom edge touching
					( y1 < t && y2 > b ) // Surrounded vertically
				) && (
					( x1 >= l && x1 <= r ) || // Left edge touching
					( x2 >= l && x2 <= r ) || // Right edge touching
					( x1 < l && x2 > r ) // Surrounded horizontally
				);
			default:
				return false;
			}
		};
	} )();
	
	/*
		This manager tracks offsets of draggables and droppables
	*/
	$.ui.ddmanager = {
		current: null,
		droppables: { "default": [] },
		prepareOffsets: function( t, event ) {
	
			var i, j,
				m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
				type = event ? event.type : null, // workaround for #2317
				list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();
	
			droppablesLoop: for ( i = 0; i < m.length; i++ ) {
	
				// No disabled and non-accepted
				if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
						( t.currentItem || t.element ) ) ) ) {
					continue;
				}
	
				// Filter out elements in the current dragged item
				for ( j = 0; j < list.length; j++ ) {
					if ( list[ j ] === m[ i ].element[ 0 ] ) {
						m[ i ].proportions().height = 0;
						continue droppablesLoop;
					}
				}
	
				m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
				if ( !m[ i ].visible ) {
					continue;
				}
	
				// Activate the droppable if used directly from draggables
				if ( type === "mousedown" ) {
					m[ i ]._activate.call( m[ i ], event );
				}
	
				m[ i ].offset = m[ i ].element.offset();
				m[ i ].proportions( {
					width: m[ i ].element[ 0 ].offsetWidth,
					height: m[ i ].element[ 0 ].offsetHeight
				} );
	
			}
	
		},
		drop: function( draggable, event ) {
	
			var dropped = false;
	
			// Create a copy of the droppables in case the list changes during the drop (#9116)
			$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {
	
				if ( !this.options ) {
					return;
				}
				if ( !this.options.disabled && this.visible &&
						intersect( draggable, this, this.options.tolerance, event ) ) {
					dropped = this._drop.call( this, event ) || dropped;
				}
	
				if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
						( draggable.currentItem || draggable.element ) ) ) {
					this.isout = true;
					this.isover = false;
					this._deactivate.call( this, event );
				}
	
			} );
			return dropped;
	
		},
		dragStart: function( draggable, event ) {
	
			// Listen for scrolling so that if the dragging causes scrolling the position of the
			// droppables can be recalculated (see #5003)
			draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
				if ( !draggable.options.refreshPositions ) {
					$.ui.ddmanager.prepareOffsets( draggable, event );
				}
			} );
		},
		drag: function( draggable, event ) {
	
			// If you have a highly dynamic page, you might try this option. It renders positions
			// every time you move the mouse.
			if ( draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
	
			// Run through all droppables and check their positions based on specific tolerance options
			$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {
	
				if ( this.options.disabled || this.greedyChild || !this.visible ) {
					return;
				}
	
				var parentInstance, scope, parent,
					intersects = intersect( draggable, this, this.options.tolerance, event ),
					c = !intersects && this.isover ?
						"isout" :
						( intersects && !this.isover ? "isover" : null );
				if ( !c ) {
					return;
				}
	
				if ( this.options.greedy ) {
	
					// find droppable parents with same scope
					scope = this.options.scope;
					parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
						return $( this ).droppable( "instance" ).options.scope === scope;
					} );
	
					if ( parent.length ) {
						parentInstance = $( parent[ 0 ] ).droppable( "instance" );
						parentInstance.greedyChild = ( c === "isover" );
					}
				}
	
				// We just moved into a greedy child
				if ( parentInstance && c === "isover" ) {
					parentInstance.isover = false;
					parentInstance.isout = true;
					parentInstance._out.call( parentInstance, event );
				}
	
				this[ c ] = true;
				this[ c === "isout" ? "isover" : "isout" ] = false;
				this[ c === "isover" ? "_over" : "_out" ].call( this, event );
	
				// We just moved out of a greedy child
				if ( parentInstance && c === "isout" ) {
					parentInstance.isout = false;
					parentInstance.isover = true;
					parentInstance._over.call( parentInstance, event );
				}
			} );
	
		},
		dragStop: function( draggable, event ) {
			draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );
	
			// Call prepareOffsets one final time since IE does not fire return scroll events when
			// overflow was caused by drag (see #5003)
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		}
	};
	
	// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if ( $.uiBackCompat !== false ) {
	
		// Backcompat for activeClass and hoverClass options
		$.widget( "ui.droppable", $.ui.droppable, {
			options: {
				hoverClass: false,
				activeClass: false
			},
			_addActiveClass: function() {
				this._super();
				if ( this.options.activeClass ) {
					this.element.addClass( this.options.activeClass );
				}
			},
			_removeActiveClass: function() {
				this._super();
				if ( this.options.activeClass ) {
					this.element.removeClass( this.options.activeClass );
				}
			},
			_addHoverClass: function() {
				this._super();
				if ( this.options.hoverClass ) {
					this.element.addClass( this.options.hoverClass );
				}
			},
			_removeHoverClass: function() {
				this._super();
				if ( this.options.hoverClass ) {
					this.element.removeClass( this.options.hoverClass );
				}
			}
		} );
	}
	
	var widgetsDroppable = $.ui.droppable;
	
	
	/*!
	 * jQuery UI Progressbar 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Progressbar
	//>>group: Widgets
	// jscs:disable maximumLineLength
	//>>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/progressbar/
	//>>demos: http://jqueryui.com/progressbar/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/progressbar.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	var widgetsProgressbar = $.widget( "ui.progressbar", {
		version: "1.12.1",
		options: {
			classes: {
				"ui-progressbar": "ui-corner-all",
				"ui-progressbar-value": "ui-corner-left",
				"ui-progressbar-complete": "ui-corner-right"
			},
			max: 100,
			value: 0,
	
			change: null,
			complete: null
		},
	
		min: 0,
	
		_create: function() {
	
			// Constrain initial value
			this.oldValue = this.options.value = this._constrainedValue();
	
			this.element.attr( {
	
				// Only set static values; aria-valuenow and aria-valuemax are
				// set inside _refreshValue()
				role: "progressbar",
				"aria-valuemin": this.min
			} );
			this._addClass( "ui-progressbar", "ui-widget ui-widget-content" );
	
			this.valueDiv = $( "<div>" ).appendTo( this.element );
			this._addClass( this.valueDiv, "ui-progressbar-value", "ui-widget-header" );
			this._refreshValue();
		},
	
		_destroy: function() {
			this.element.removeAttr( "role aria-valuemin aria-valuemax aria-valuenow" );
	
			this.valueDiv.remove();
		},
	
		value: function( newValue ) {
			if ( newValue === undefined ) {
				return this.options.value;
			}
	
			this.options.value = this._constrainedValue( newValue );
			this._refreshValue();
		},
	
		_constrainedValue: function( newValue ) {
			if ( newValue === undefined ) {
				newValue = this.options.value;
			}
	
			this.indeterminate = newValue === false;
	
			// Sanitize value
			if ( typeof newValue !== "number" ) {
				newValue = 0;
			}
	
			return this.indeterminate ? false :
				Math.min( this.options.max, Math.max( this.min, newValue ) );
		},
	
		_setOptions: function( options ) {
	
			// Ensure "value" option is set after other values (like max)
			var value = options.value;
			delete options.value;
	
			this._super( options );
	
			this.options.value = this._constrainedValue( value );
			this._refreshValue();
		},
	
		_setOption: function( key, value ) {
			if ( key === "max" ) {
	
				// Don't allow a max less than min
				value = Math.max( this.min, value );
			}
			this._super( key, value );
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this.element.attr( "aria-disabled", value );
			this._toggleClass( null, "ui-state-disabled", !!value );
		},
	
		_percentage: function() {
			return this.indeterminate ?
				100 :
				100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
		},
	
		_refreshValue: function() {
			var value = this.options.value,
				percentage = this._percentage();
	
			this.valueDiv
				.toggle( this.indeterminate || value > this.min )
				.width( percentage.toFixed( 0 ) + "%" );
	
			this
				._toggleClass( this.valueDiv, "ui-progressbar-complete", null,
					value === this.options.max )
				._toggleClass( "ui-progressbar-indeterminate", null, this.indeterminate );
	
			if ( this.indeterminate ) {
				this.element.removeAttr( "aria-valuenow" );
				if ( !this.overlayDiv ) {
					this.overlayDiv = $( "<div>" ).appendTo( this.valueDiv );
					this._addClass( this.overlayDiv, "ui-progressbar-overlay" );
				}
			} else {
				this.element.attr( {
					"aria-valuemax": this.options.max,
					"aria-valuenow": value
				} );
				if ( this.overlayDiv ) {
					this.overlayDiv.remove();
					this.overlayDiv = null;
				}
			}
	
			if ( this.oldValue !== value ) {
				this.oldValue = value;
				this._trigger( "change" );
			}
			if ( value === this.options.max ) {
				this._trigger( "complete" );
			}
		}
	} );
	
	
	/*!
	 * jQuery UI Selectable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Selectable
	//>>group: Interactions
	//>>description: Allows groups of elements to be selected with the mouse.
	//>>docs: http://api.jqueryui.com/selectable/
	//>>demos: http://jqueryui.com/selectable/
	//>>css.structure: ../../themes/base/selectable.css
	
	
	
	var widgetsSelectable = $.widget( "ui.selectable", $.ui.mouse, {
		version: "1.12.1",
		options: {
			appendTo: "body",
			autoRefresh: true,
			distance: 0,
			filter: "*",
			tolerance: "touch",
	
			// Callbacks
			selected: null,
			selecting: null,
			start: null,
			stop: null,
			unselected: null,
			unselecting: null
		},
		_create: function() {
			var that = this;
	
			this._addClass( "ui-selectable" );
	
			this.dragged = false;
	
			// Cache selectee children based on filter
			this.refresh = function() {
				that.elementPos = $( that.element[ 0 ] ).offset();
				that.selectees = $( that.options.filter, that.element[ 0 ] );
				that._addClass( that.selectees, "ui-selectee" );
				that.selectees.each( function() {
					var $this = $( this ),
						selecteeOffset = $this.offset(),
						pos = {
							left: selecteeOffset.left - that.elementPos.left,
							top: selecteeOffset.top - that.elementPos.top
						};
					$.data( this, "selectable-item", {
						element: this,
						$element: $this,
						left: pos.left,
						top: pos.top,
						right: pos.left + $this.outerWidth(),
						bottom: pos.top + $this.outerHeight(),
						startselected: false,
						selected: $this.hasClass( "ui-selected" ),
						selecting: $this.hasClass( "ui-selecting" ),
						unselecting: $this.hasClass( "ui-unselecting" )
					} );
				} );
			};
			this.refresh();
	
			this._mouseInit();
	
			this.helper = $( "<div>" );
			this._addClass( this.helper, "ui-selectable-helper" );
		},
	
		_destroy: function() {
			this.selectees.removeData( "selectable-item" );
			this._mouseDestroy();
		},
	
		_mouseStart: function( event ) {
			var that = this,
				options = this.options;
	
			this.opos = [ event.pageX, event.pageY ];
			this.elementPos = $( this.element[ 0 ] ).offset();
	
			if ( this.options.disabled ) {
				return;
			}
	
			this.selectees = $( options.filter, this.element[ 0 ] );
	
			this._trigger( "start", event );
	
			$( options.appendTo ).append( this.helper );
	
			// position helper (lasso)
			this.helper.css( {
				"left": event.pageX,
				"top": event.pageY,
				"width": 0,
				"height": 0
			} );
	
			if ( options.autoRefresh ) {
				this.refresh();
			}
	
			this.selectees.filter( ".ui-selected" ).each( function() {
				var selectee = $.data( this, "selectable-item" );
				selectee.startselected = true;
				if ( !event.metaKey && !event.ctrlKey ) {
					that._removeClass( selectee.$element, "ui-selected" );
					selectee.selected = false;
					that._addClass( selectee.$element, "ui-unselecting" );
					selectee.unselecting = true;
	
					// selectable UNSELECTING callback
					that._trigger( "unselecting", event, {
						unselecting: selectee.element
					} );
				}
			} );
	
			$( event.target ).parents().addBack().each( function() {
				var doSelect,
					selectee = $.data( this, "selectable-item" );
				if ( selectee ) {
					doSelect = ( !event.metaKey && !event.ctrlKey ) ||
						!selectee.$element.hasClass( "ui-selected" );
					that._removeClass( selectee.$element, doSelect ? "ui-unselecting" : "ui-selected" )
						._addClass( selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting" );
					selectee.unselecting = !doSelect;
					selectee.selecting = doSelect;
					selectee.selected = doSelect;
	
					// selectable (UN)SELECTING callback
					if ( doSelect ) {
						that._trigger( "selecting", event, {
							selecting: selectee.element
						} );
					} else {
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
					return false;
				}
			} );
	
		},
	
		_mouseDrag: function( event ) {
	
			this.dragged = true;
	
			if ( this.options.disabled ) {
				return;
			}
	
			var tmp,
				that = this,
				options = this.options,
				x1 = this.opos[ 0 ],
				y1 = this.opos[ 1 ],
				x2 = event.pageX,
				y2 = event.pageY;
	
			if ( x1 > x2 ) { tmp = x2; x2 = x1; x1 = tmp; }
			if ( y1 > y2 ) { tmp = y2; y2 = y1; y1 = tmp; }
			this.helper.css( { left: x1, top: y1, width: x2 - x1, height: y2 - y1 } );
	
			this.selectees.each( function() {
				var selectee = $.data( this, "selectable-item" ),
					hit = false,
					offset = {};
	
				//prevent helper from being selected if appendTo: selectable
				if ( !selectee || selectee.element === that.element[ 0 ] ) {
					return;
				}
	
				offset.left   = selectee.left   + that.elementPos.left;
				offset.right  = selectee.right  + that.elementPos.left;
				offset.top    = selectee.top    + that.elementPos.top;
				offset.bottom = selectee.bottom + that.elementPos.top;
	
				if ( options.tolerance === "touch" ) {
					hit = ( !( offset.left > x2 || offset.right < x1 || offset.top > y2 ||
	                    offset.bottom < y1 ) );
				} else if ( options.tolerance === "fit" ) {
					hit = ( offset.left > x1 && offset.right < x2 && offset.top > y1 &&
	                    offset.bottom < y2 );
				}
	
				if ( hit ) {
	
					// SELECT
					if ( selectee.selected ) {
						that._removeClass( selectee.$element, "ui-selected" );
						selectee.selected = false;
					}
					if ( selectee.unselecting ) {
						that._removeClass( selectee.$element, "ui-unselecting" );
						selectee.unselecting = false;
					}
					if ( !selectee.selecting ) {
						that._addClass( selectee.$element, "ui-selecting" );
						selectee.selecting = true;
	
						// selectable SELECTING callback
						that._trigger( "selecting", event, {
							selecting: selectee.element
						} );
					}
				} else {
	
					// UNSELECT
					if ( selectee.selecting ) {
						if ( ( event.metaKey || event.ctrlKey ) && selectee.startselected ) {
							that._removeClass( selectee.$element, "ui-selecting" );
							selectee.selecting = false;
							that._addClass( selectee.$element, "ui-selected" );
							selectee.selected = true;
						} else {
							that._removeClass( selectee.$element, "ui-selecting" );
							selectee.selecting = false;
							if ( selectee.startselected ) {
								that._addClass( selectee.$element, "ui-unselecting" );
								selectee.unselecting = true;
							}
	
							// selectable UNSELECTING callback
							that._trigger( "unselecting", event, {
								unselecting: selectee.element
							} );
						}
					}
					if ( selectee.selected ) {
						if ( !event.metaKey && !event.ctrlKey && !selectee.startselected ) {
							that._removeClass( selectee.$element, "ui-selected" );
							selectee.selected = false;
	
							that._addClass( selectee.$element, "ui-unselecting" );
							selectee.unselecting = true;
	
							// selectable UNSELECTING callback
							that._trigger( "unselecting", event, {
								unselecting: selectee.element
							} );
						}
					}
				}
			} );
	
			return false;
		},
	
		_mouseStop: function( event ) {
			var that = this;
	
			this.dragged = false;
	
			$( ".ui-unselecting", this.element[ 0 ] ).each( function() {
				var selectee = $.data( this, "selectable-item" );
				that._removeClass( selectee.$element, "ui-unselecting" );
				selectee.unselecting = false;
				selectee.startselected = false;
				that._trigger( "unselected", event, {
					unselected: selectee.element
				} );
			} );
			$( ".ui-selecting", this.element[ 0 ] ).each( function() {
				var selectee = $.data( this, "selectable-item" );
				that._removeClass( selectee.$element, "ui-selecting" )
					._addClass( selectee.$element, "ui-selected" );
				selectee.selecting = false;
				selectee.selected = true;
				selectee.startselected = true;
				that._trigger( "selected", event, {
					selected: selectee.element
				} );
			} );
			this._trigger( "stop", event );
	
			this.helper.remove();
	
			return false;
		}
	
	} );
	
	
	/*!
	 * jQuery UI Selectmenu 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Selectmenu
	//>>group: Widgets
	// jscs:disable maximumLineLength
	//>>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/selectmenu/
	//>>demos: http://jqueryui.com/selectmenu/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	var widgetsSelectmenu = $.widget( "ui.selectmenu", [ $.ui.formResetMixin, {
		version: "1.12.1",
		defaultElement: "<select>",
		options: {
			appendTo: null,
			classes: {
				"ui-selectmenu-button-open": "ui-corner-top",
				"ui-selectmenu-button-closed": "ui-corner-all"
			},
			disabled: null,
			icons: {
				button: "ui-icon-triangle-1-s"
			},
			position: {
				my: "left top",
				at: "left bottom",
				collision: "none"
			},
			width: false,
	
			// Callbacks
			change: null,
			close: null,
			focus: null,
			open: null,
			select: null
		},
	
		_create: function() {
			var selectmenuId = this.element.uniqueId().attr( "id" );
			this.ids = {
				element: selectmenuId,
				button: selectmenuId + "-button",
				menu: selectmenuId + "-menu"
			};
	
			this._drawButton();
			this._drawMenu();
			this._bindFormResetHandler();
	
			this._rendered = false;
			this.menuItems = $();
		},
	
		_drawButton: function() {
			var icon,
				that = this,
				item = this._parseOption(
					this.element.find( "option:selected" ),
					this.element[ 0 ].selectedIndex
				);
	
			// Associate existing label with the new button
			this.labels = this.element.labels().attr( "for", this.ids.button );
			this._on( this.labels, {
				click: function( event ) {
					this.button.focus();
					event.preventDefault();
				}
			} );
	
			// Hide original select element
			this.element.hide();
	
			// Create button
			this.button = $( "<span>", {
				tabindex: this.options.disabled ? -1 : 0,
				id: this.ids.button,
				role: "combobox",
				"aria-expanded": "false",
				"aria-autocomplete": "list",
				"aria-owns": this.ids.menu,
				"aria-haspopup": "true",
				title: this.element.attr( "title" )
			} )
				.insertAfter( this.element );
	
			this._addClass( this.button, "ui-selectmenu-button ui-selectmenu-button-closed",
				"ui-button ui-widget" );
	
			icon = $( "<span>" ).appendTo( this.button );
			this._addClass( icon, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button );
			this.buttonItem = this._renderButtonItem( item )
				.appendTo( this.button );
	
			if ( this.options.width !== false ) {
				this._resizeButton();
			}
	
			this._on( this.button, this._buttonEvents );
			this.button.one( "focusin", function() {
	
				// Delay rendering the menu items until the button receives focus.
				// The menu may have already been rendered via a programmatic open.
				if ( !that._rendered ) {
					that._refreshMenu();
				}
			} );
		},
	
		_drawMenu: function() {
			var that = this;
	
			// Create menu
			this.menu = $( "<ul>", {
				"aria-hidden": "true",
				"aria-labelledby": this.ids.button,
				id: this.ids.menu
			} );
	
			// Wrap menu
			this.menuWrap = $( "<div>" ).append( this.menu );
			this._addClass( this.menuWrap, "ui-selectmenu-menu", "ui-front" );
			this.menuWrap.appendTo( this._appendTo() );
	
			// Initialize menu widget
			this.menuInstance = this.menu
				.menu( {
					classes: {
						"ui-menu": "ui-corner-bottom"
					},
					role: "listbox",
					select: function( event, ui ) {
						event.preventDefault();
	
						// Support: IE8
						// If the item was selected via a click, the text selection
						// will be destroyed in IE
						that._setSelection();
	
						that._select( ui.item.data( "ui-selectmenu-item" ), event );
					},
					focus: function( event, ui ) {
						var item = ui.item.data( "ui-selectmenu-item" );
	
						// Prevent inital focus from firing and check if its a newly focused item
						if ( that.focusIndex != null && item.index !== that.focusIndex ) {
							that._trigger( "focus", event, { item: item } );
							if ( !that.isOpen ) {
								that._select( item, event );
							}
						}
						that.focusIndex = item.index;
	
						that.button.attr( "aria-activedescendant",
							that.menuItems.eq( item.index ).attr( "id" ) );
					}
				} )
				.menu( "instance" );
	
			// Don't close the menu on mouseleave
			this.menuInstance._off( this.menu, "mouseleave" );
	
			// Cancel the menu's collapseAll on document click
			this.menuInstance._closeOnDocumentClick = function() {
				return false;
			};
	
			// Selects often contain empty items, but never contain dividers
			this.menuInstance._isDivider = function() {
				return false;
			};
		},
	
		refresh: function() {
			this._refreshMenu();
			this.buttonItem.replaceWith(
				this.buttonItem = this._renderButtonItem(
	
					// Fall back to an empty object in case there are no options
					this._getSelectedItem().data( "ui-selectmenu-item" ) || {}
				)
			);
			if ( this.options.width === null ) {
				this._resizeButton();
			}
		},
	
		_refreshMenu: function() {
			var item,
				options = this.element.find( "option" );
	
			this.menu.empty();
	
			this._parseOptions( options );
			this._renderMenu( this.menu, this.items );
	
			this.menuInstance.refresh();
			this.menuItems = this.menu.find( "li" )
				.not( ".ui-selectmenu-optgroup" )
					.find( ".ui-menu-item-wrapper" );
	
			this._rendered = true;
	
			if ( !options.length ) {
				return;
			}
	
			item = this._getSelectedItem();
	
			// Update the menu to have the correct item focused
			this.menuInstance.focus( null, item );
			this._setAria( item.data( "ui-selectmenu-item" ) );
	
			// Set disabled state
			this._setOption( "disabled", this.element.prop( "disabled" ) );
		},
	
		open: function( event ) {
			if ( this.options.disabled ) {
				return;
			}
	
			// If this is the first time the menu is being opened, render the items
			if ( !this._rendered ) {
				this._refreshMenu();
			} else {
	
				// Menu clears focus on close, reset focus to selected item
				this._removeClass( this.menu.find( ".ui-state-active" ), null, "ui-state-active" );
				this.menuInstance.focus( null, this._getSelectedItem() );
			}
	
			// If there are no options, don't open the menu
			if ( !this.menuItems.length ) {
				return;
			}
	
			this.isOpen = true;
			this._toggleAttr();
			this._resizeMenu();
			this._position();
	
			this._on( this.document, this._documentClick );
	
			this._trigger( "open", event );
		},
	
		_position: function() {
			this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
		},
	
		close: function( event ) {
			if ( !this.isOpen ) {
				return;
			}
	
			this.isOpen = false;
			this._toggleAttr();
	
			this.range = null;
			this._off( this.document );
	
			this._trigger( "close", event );
		},
	
		widget: function() {
			return this.button;
		},
	
		menuWidget: function() {
			return this.menu;
		},
	
		_renderButtonItem: function( item ) {
			var buttonItem = $( "<span>" );
	
			this._setText( buttonItem, item.label );
			this._addClass( buttonItem, "ui-selectmenu-text" );
	
			return buttonItem;
		},
	
		_renderMenu: function( ul, items ) {
			var that = this,
				currentOptgroup = "";
	
			$.each( items, function( index, item ) {
				var li;
	
				if ( item.optgroup !== currentOptgroup ) {
					li = $( "<li>", {
						text: item.optgroup
					} );
					that._addClass( li, "ui-selectmenu-optgroup", "ui-menu-divider" +
						( item.element.parent( "optgroup" ).prop( "disabled" ) ?
							" ui-state-disabled" :
							"" ) );
	
					li.appendTo( ul );
	
					currentOptgroup = item.optgroup;
				}
	
				that._renderItemData( ul, item );
			} );
		},
	
		_renderItemData: function( ul, item ) {
			return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
		},
	
		_renderItem: function( ul, item ) {
			var li = $( "<li>" ),
				wrapper = $( "<div>", {
					title: item.element.attr( "title" )
				} );
	
			if ( item.disabled ) {
				this._addClass( li, null, "ui-state-disabled" );
			}
			this._setText( wrapper, item.label );
	
			return li.append( wrapper ).appendTo( ul );
		},
	
		_setText: function( element, value ) {
			if ( value ) {
				element.text( value );
			} else {
				element.html( "&#160;" );
			}
		},
	
		_move: function( direction, event ) {
			var item, next,
				filter = ".ui-menu-item";
	
			if ( this.isOpen ) {
				item = this.menuItems.eq( this.focusIndex ).parent( "li" );
			} else {
				item = this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
				filter += ":not(.ui-state-disabled)";
			}
	
			if ( direction === "first" || direction === "last" ) {
				next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
			} else {
				next = item[ direction + "All" ]( filter ).eq( 0 );
			}
	
			if ( next.length ) {
				this.menuInstance.focus( event, next );
			}
		},
	
		_getSelectedItem: function() {
			return this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
		},
	
		_toggle: function( event ) {
			this[ this.isOpen ? "close" : "open" ]( event );
		},
	
		_setSelection: function() {
			var selection;
	
			if ( !this.range ) {
				return;
			}
	
			if ( window.getSelection ) {
				selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange( this.range );
	
			// Support: IE8
			} else {
				this.range.select();
			}
	
			// Support: IE
			// Setting the text selection kills the button focus in IE, but
			// restoring the focus doesn't kill the selection.
			this.button.focus();
		},
	
		_documentClick: {
			mousedown: function( event ) {
				if ( !this.isOpen ) {
					return;
				}
	
				if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" +
						$.ui.escapeSelector( this.ids.button ) ).length ) {
					this.close( event );
				}
			}
		},
	
		_buttonEvents: {
	
			// Prevent text selection from being reset when interacting with the selectmenu (#10144)
			mousedown: function() {
				var selection;
	
				if ( window.getSelection ) {
					selection = window.getSelection();
					if ( selection.rangeCount ) {
						this.range = selection.getRangeAt( 0 );
					}
	
				// Support: IE8
				} else {
					this.range = document.selection.createRange();
				}
			},
	
			click: function( event ) {
				this._setSelection();
				this._toggle( event );
			},
	
			keydown: function( event ) {
				var preventDefault = true;
				switch ( event.keyCode ) {
				case $.ui.keyCode.TAB:
				case $.ui.keyCode.ESCAPE:
					this.close( event );
					preventDefault = false;
					break;
				case $.ui.keyCode.ENTER:
					if ( this.isOpen ) {
						this._selectFocusedItem( event );
					}
					break;
				case $.ui.keyCode.UP:
					if ( event.altKey ) {
						this._toggle( event );
					} else {
						this._move( "prev", event );
					}
					break;
				case $.ui.keyCode.DOWN:
					if ( event.altKey ) {
						this._toggle( event );
					} else {
						this._move( "next", event );
					}
					break;
				case $.ui.keyCode.SPACE:
					if ( this.isOpen ) {
						this._selectFocusedItem( event );
					} else {
						this._toggle( event );
					}
					break;
				case $.ui.keyCode.LEFT:
					this._move( "prev", event );
					break;
				case $.ui.keyCode.RIGHT:
					this._move( "next", event );
					break;
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.PAGE_UP:
					this._move( "first", event );
					break;
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_DOWN:
					this._move( "last", event );
					break;
				default:
					this.menu.trigger( event );
					preventDefault = false;
				}
	
				if ( preventDefault ) {
					event.preventDefault();
				}
			}
		},
	
		_selectFocusedItem: function( event ) {
			var item = this.menuItems.eq( this.focusIndex ).parent( "li" );
			if ( !item.hasClass( "ui-state-disabled" ) ) {
				this._select( item.data( "ui-selectmenu-item" ), event );
			}
		},
	
		_select: function( item, event ) {
			var oldIndex = this.element[ 0 ].selectedIndex;
	
			// Change native select element
			this.element[ 0 ].selectedIndex = item.index;
			this.buttonItem.replaceWith( this.buttonItem = this._renderButtonItem( item ) );
			this._setAria( item );
			this._trigger( "select", event, { item: item } );
	
			if ( item.index !== oldIndex ) {
				this._trigger( "change", event, { item: item } );
			}
	
			this.close( event );
		},
	
		_setAria: function( item ) {
			var id = this.menuItems.eq( item.index ).attr( "id" );
	
			this.button.attr( {
				"aria-labelledby": id,
				"aria-activedescendant": id
			} );
			this.menu.attr( "aria-activedescendant", id );
		},
	
		_setOption: function( key, value ) {
			if ( key === "icons" ) {
				var icon = this.button.find( "span.ui-icon" );
				this._removeClass( icon, null, this.options.icons.button )
					._addClass( icon, null, value.button );
			}
	
			this._super( key, value );
	
			if ( key === "appendTo" ) {
				this.menuWrap.appendTo( this._appendTo() );
			}
	
			if ( key === "width" ) {
				this._resizeButton();
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this.menuInstance.option( "disabled", value );
			this.button.attr( "aria-disabled", value );
			this._toggleClass( this.button, null, "ui-state-disabled", value );
	
			this.element.prop( "disabled", value );
			if ( value ) {
				this.button.attr( "tabindex", -1 );
				this.close();
			} else {
				this.button.attr( "tabindex", 0 );
			}
		},
	
		_appendTo: function() {
			var element = this.options.appendTo;
	
			if ( element ) {
				element = element.jquery || element.nodeType ?
					$( element ) :
					this.document.find( element ).eq( 0 );
			}
	
			if ( !element || !element[ 0 ] ) {
				element = this.element.closest( ".ui-front, dialog" );
			}
	
			if ( !element.length ) {
				element = this.document[ 0 ].body;
			}
	
			return element;
		},
	
		_toggleAttr: function() {
			this.button.attr( "aria-expanded", this.isOpen );
	
			// We can't use two _toggleClass() calls here, because we need to make sure
			// we always remove classes first and add them second, otherwise if both classes have the
			// same theme class, it will be removed after we add it.
			this._removeClass( this.button, "ui-selectmenu-button-" +
				( this.isOpen ? "closed" : "open" ) )
				._addClass( this.button, "ui-selectmenu-button-" +
					( this.isOpen ? "open" : "closed" ) )
				._toggleClass( this.menuWrap, "ui-selectmenu-open", null, this.isOpen );
	
			this.menu.attr( "aria-hidden", !this.isOpen );
		},
	
		_resizeButton: function() {
			var width = this.options.width;
	
			// For `width: false`, just remove inline style and stop
			if ( width === false ) {
				this.button.css( "width", "" );
				return;
			}
	
			// For `width: null`, match the width of the original element
			if ( width === null ) {
				width = this.element.show().outerWidth();
				this.element.hide();
			}
	
			this.button.outerWidth( width );
		},
	
		_resizeMenu: function() {
			this.menu.outerWidth( Math.max(
				this.button.outerWidth(),
	
				// Support: IE10
				// IE10 wraps long text (possibly a rounding bug)
				// so we add 1px to avoid the wrapping
				this.menu.width( "" ).outerWidth() + 1
			) );
		},
	
		_getCreateOptions: function() {
			var options = this._super();
	
			options.disabled = this.element.prop( "disabled" );
	
			return options;
		},
	
		_parseOptions: function( options ) {
			var that = this,
				data = [];
			options.each( function( index, item ) {
				data.push( that._parseOption( $( item ), index ) );
			} );
			this.items = data;
		},
	
		_parseOption: function( option, index ) {
			var optgroup = option.parent( "optgroup" );
	
			return {
				element: option,
				index: index,
				value: option.val(),
				label: option.text(),
				optgroup: optgroup.attr( "label" ) || "",
				disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
			};
		},
	
		_destroy: function() {
			this._unbindFormResetHandler();
			this.menuWrap.remove();
			this.button.remove();
			this.element.show();
			this.element.removeUniqueId();
			this.labels.attr( "for", this.ids.element );
		}
	} ] );
	
	
	/*!
	 * jQuery UI Slider 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Slider
	//>>group: Widgets
	//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
	//>>docs: http://api.jqueryui.com/slider/
	//>>demos: http://jqueryui.com/slider/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/slider.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "slide",
	
		options: {
			animate: false,
			classes: {
				"ui-slider": "ui-corner-all",
				"ui-slider-handle": "ui-corner-all",
	
				// Note: ui-widget-header isn't the most fittingly semantic framework class for this
				// element, but worked best visually with a variety of themes
				"ui-slider-range": "ui-corner-all ui-widget-header"
			},
			distance: 0,
			max: 100,
			min: 0,
			orientation: "horizontal",
			range: false,
			step: 1,
			value: 0,
			values: null,
	
			// Callbacks
			change: null,
			slide: null,
			start: null,
			stop: null
		},
	
		// Number of pages in a slider
		// (how many times can you page up/down to go through the whole range)
		numPages: 5,
	
		_create: function() {
			this._keySliding = false;
			this._mouseSliding = false;
			this._animateOff = true;
			this._handleIndex = null;
			this._detectOrientation();
			this._mouseInit();
			this._calculateNewMax();
	
			this._addClass( "ui-slider ui-slider-" + this.orientation,
				"ui-widget ui-widget-content" );
	
			this._refresh();
	
			this._animateOff = false;
		},
	
		_refresh: function() {
			this._createRange();
			this._createHandles();
			this._setupEvents();
			this._refreshValue();
		},
	
		_createHandles: function() {
			var i, handleCount,
				options = this.options,
				existingHandles = this.element.find( ".ui-slider-handle" ),
				handle = "<span tabindex='0'></span>",
				handles = [];
	
			handleCount = ( options.values && options.values.length ) || 1;
	
			if ( existingHandles.length > handleCount ) {
				existingHandles.slice( handleCount ).remove();
				existingHandles = existingHandles.slice( 0, handleCount );
			}
	
			for ( i = existingHandles.length; i < handleCount; i++ ) {
				handles.push( handle );
			}
	
			this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );
	
			this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );
	
			this.handle = this.handles.eq( 0 );
	
			this.handles.each( function( i ) {
				$( this )
					.data( "ui-slider-handle-index", i )
					.attr( "tabIndex", 0 );
			} );
		},
	
		_createRange: function() {
			var options = this.options;
	
			if ( options.range ) {
				if ( options.range === true ) {
					if ( !options.values ) {
						options.values = [ this._valueMin(), this._valueMin() ];
					} else if ( options.values.length && options.values.length !== 2 ) {
						options.values = [ options.values[ 0 ], options.values[ 0 ] ];
					} else if ( $.isArray( options.values ) ) {
						options.values = options.values.slice( 0 );
					}
				}
	
				if ( !this.range || !this.range.length ) {
					this.range = $( "<div>" )
						.appendTo( this.element );
	
					this._addClass( this.range, "ui-slider-range" );
				} else {
					this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );
	
					// Handle range switching from true to min/max
					this.range.css( {
						"left": "",
						"bottom": ""
					} );
				}
				if ( options.range === "min" || options.range === "max" ) {
					this._addClass( this.range, "ui-slider-range-" + options.range );
				}
			} else {
				if ( this.range ) {
					this.range.remove();
				}
				this.range = null;
			}
		},
	
		_setupEvents: function() {
			this._off( this.handles );
			this._on( this.handles, this._handleEvents );
			this._hoverable( this.handles );
			this._focusable( this.handles );
		},
	
		_destroy: function() {
			this.handles.remove();
			if ( this.range ) {
				this.range.remove();
			}
	
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
				that = this,
				o = this.options;
	
			if ( o.disabled ) {
				return false;
			}
	
			this.elementSize = {
				width: this.element.outerWidth(),
				height: this.element.outerHeight()
			};
			this.elementOffset = this.element.offset();
	
			position = { x: event.pageX, y: event.pageY };
			normValue = this._normValueFromMouse( position );
			distance = this._valueMax() - this._valueMin() + 1;
			this.handles.each( function( i ) {
				var thisDistance = Math.abs( normValue - that.values( i ) );
				if ( ( distance > thisDistance ) ||
					( distance === thisDistance &&
						( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
					distance = thisDistance;
					closestHandle = $( this );
					index = i;
				}
			} );
	
			allowed = this._start( event, index );
			if ( allowed === false ) {
				return false;
			}
			this._mouseSliding = true;
	
			this._handleIndex = index;
	
			this._addClass( closestHandle, null, "ui-state-active" );
			closestHandle.trigger( "focus" );
	
			offset = closestHandle.offset();
			mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
			this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
				left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
				top: event.pageY - offset.top -
					( closestHandle.height() / 2 ) -
					( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
					( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
			};
	
			if ( !this.handles.hasClass( "ui-state-hover" ) ) {
				this._slide( event, index, normValue );
			}
			this._animateOff = true;
			return true;
		},
	
		_mouseStart: function() {
			return true;
		},
	
		_mouseDrag: function( event ) {
			var position = { x: event.pageX, y: event.pageY },
				normValue = this._normValueFromMouse( position );
	
			this._slide( event, this._handleIndex, normValue );
	
			return false;
		},
	
		_mouseStop: function( event ) {
			this._removeClass( this.handles, null, "ui-state-active" );
			this._mouseSliding = false;
	
			this._stop( event, this._handleIndex );
			this._change( event, this._handleIndex );
	
			this._handleIndex = null;
			this._clickOffset = null;
			this._animateOff = false;
	
			return false;
		},
	
		_detectOrientation: function() {
			this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
		},
	
		_normValueFromMouse: function( position ) {
			var pixelTotal,
				pixelMouse,
				percentMouse,
				valueTotal,
				valueMouse;
	
			if ( this.orientation === "horizontal" ) {
				pixelTotal = this.elementSize.width;
				pixelMouse = position.x - this.elementOffset.left -
					( this._clickOffset ? this._clickOffset.left : 0 );
			} else {
				pixelTotal = this.elementSize.height;
				pixelMouse = position.y - this.elementOffset.top -
					( this._clickOffset ? this._clickOffset.top : 0 );
			}
	
			percentMouse = ( pixelMouse / pixelTotal );
			if ( percentMouse > 1 ) {
				percentMouse = 1;
			}
			if ( percentMouse < 0 ) {
				percentMouse = 0;
			}
			if ( this.orientation === "vertical" ) {
				percentMouse = 1 - percentMouse;
			}
	
			valueTotal = this._valueMax() - this._valueMin();
			valueMouse = this._valueMin() + percentMouse * valueTotal;
	
			return this._trimAlignValue( valueMouse );
		},
	
		_uiHash: function( index, value, values ) {
			var uiHash = {
				handle: this.handles[ index ],
				handleIndex: index,
				value: value !== undefined ? value : this.value()
			};
	
			if ( this._hasMultipleValues() ) {
				uiHash.value = value !== undefined ? value : this.values( index );
				uiHash.values = values || this.values();
			}
	
			return uiHash;
		},
	
		_hasMultipleValues: function() {
			return this.options.values && this.options.values.length;
		},
	
		_start: function( event, index ) {
			return this._trigger( "start", event, this._uiHash( index ) );
		},
	
		_slide: function( event, index, newVal ) {
			var allowed, otherVal,
				currentValue = this.value(),
				newValues = this.values();
	
			if ( this._hasMultipleValues() ) {
				otherVal = this.values( index ? 0 : 1 );
				currentValue = this.values( index );
	
				if ( this.options.values.length === 2 && this.options.range === true ) {
					newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
				}
	
				newValues[ index ] = newVal;
			}
	
			if ( newVal === currentValue ) {
				return;
			}
	
			allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );
	
			// A slide can be canceled by returning false from the slide callback
			if ( allowed === false ) {
				return;
			}
	
			if ( this._hasMultipleValues() ) {
				this.values( index, newVal );
			} else {
				this.value( newVal );
			}
		},
	
		_stop: function( event, index ) {
			this._trigger( "stop", event, this._uiHash( index ) );
		},
	
		_change: function( event, index ) {
			if ( !this._keySliding && !this._mouseSliding ) {
	
				//store the last changed value index for reference when handles overlap
				this._lastChangedValue = index;
				this._trigger( "change", event, this._uiHash( index ) );
			}
		},
	
		value: function( newValue ) {
			if ( arguments.length ) {
				this.options.value = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, 0 );
				return;
			}
	
			return this._value();
		},
	
		values: function( index, newValue ) {
			var vals,
				newValues,
				i;
	
			if ( arguments.length > 1 ) {
				this.options.values[ index ] = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, index );
				return;
			}
	
			if ( arguments.length ) {
				if ( $.isArray( arguments[ 0 ] ) ) {
					vals = this.options.values;
					newValues = arguments[ 0 ];
					for ( i = 0; i < vals.length; i += 1 ) {
						vals[ i ] = this._trimAlignValue( newValues[ i ] );
						this._change( null, i );
					}
					this._refreshValue();
				} else {
					if ( this._hasMultipleValues() ) {
						return this._values( index );
					} else {
						return this.value();
					}
				}
			} else {
				return this._values();
			}
		},
	
		_setOption: function( key, value ) {
			var i,
				valsLength = 0;
	
			if ( key === "range" && this.options.range === true ) {
				if ( value === "min" ) {
					this.options.value = this._values( 0 );
					this.options.values = null;
				} else if ( value === "max" ) {
					this.options.value = this._values( this.options.values.length - 1 );
					this.options.values = null;
				}
			}
	
			if ( $.isArray( this.options.values ) ) {
				valsLength = this.options.values.length;
			}
	
			this._super( key, value );
	
			switch ( key ) {
				case "orientation":
					this._detectOrientation();
					this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
						._addClass( "ui-slider-" + this.orientation );
					this._refreshValue();
					if ( this.options.range ) {
						this._refreshRange( value );
					}
	
					// Reset positioning from previous orientation
					this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
					break;
				case "value":
					this._animateOff = true;
					this._refreshValue();
					this._change( null, 0 );
					this._animateOff = false;
					break;
				case "values":
					this._animateOff = true;
					this._refreshValue();
	
					// Start from the last handle to prevent unreachable handles (#9046)
					for ( i = valsLength - 1; i >= 0; i-- ) {
						this._change( null, i );
					}
					this._animateOff = false;
					break;
				case "step":
				case "min":
				case "max":
					this._animateOff = true;
					this._calculateNewMax();
					this._refreshValue();
					this._animateOff = false;
					break;
				case "range":
					this._animateOff = true;
					this._refresh();
					this._animateOff = false;
					break;
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this._toggleClass( null, "ui-state-disabled", !!value );
		},
	
		//internal value getter
		// _value() returns value trimmed by min and max, aligned by step
		_value: function() {
			var val = this.options.value;
			val = this._trimAlignValue( val );
	
			return val;
		},
	
		//internal values getter
		// _values() returns array of values trimmed by min and max, aligned by step
		// _values( index ) returns single value trimmed by min and max, aligned by step
		_values: function( index ) {
			var val,
				vals,
				i;
	
			if ( arguments.length ) {
				val = this.options.values[ index ];
				val = this._trimAlignValue( val );
	
				return val;
			} else if ( this._hasMultipleValues() ) {
	
				// .slice() creates a copy of the array
				// this copy gets trimmed by min and max and then returned
				vals = this.options.values.slice();
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( vals[ i ] );
				}
	
				return vals;
			} else {
				return [];
			}
		},
	
		// Returns the step-aligned value that val is closest to, between (inclusive) min and max
		_trimAlignValue: function( val ) {
			if ( val <= this._valueMin() ) {
				return this._valueMin();
			}
			if ( val >= this._valueMax() ) {
				return this._valueMax();
			}
			var step = ( this.options.step > 0 ) ? this.options.step : 1,
				valModStep = ( val - this._valueMin() ) % step,
				alignValue = val - valModStep;
	
			if ( Math.abs( valModStep ) * 2 >= step ) {
				alignValue += ( valModStep > 0 ) ? step : ( -step );
			}
	
			// Since JavaScript has problems with large floats, round
			// the final value to 5 digits after the decimal point (see #4124)
			return parseFloat( alignValue.toFixed( 5 ) );
		},
	
		_calculateNewMax: function() {
			var max = this.options.max,
				min = this._valueMin(),
				step = this.options.step,
				aboveMin = Math.round( ( max - min ) / step ) * step;
			max = aboveMin + min;
			if ( max > this.options.max ) {
	
				//If max is not divisible by step, rounding off may increase its value
				max -= step;
			}
			this.max = parseFloat( max.toFixed( this._precision() ) );
		},
	
		_precision: function() {
			var precision = this._precisionOf( this.options.step );
			if ( this.options.min !== null ) {
				precision = Math.max( precision, this._precisionOf( this.options.min ) );
			}
			return precision;
		},
	
		_precisionOf: function( num ) {
			var str = num.toString(),
				decimal = str.indexOf( "." );
			return decimal === -1 ? 0 : str.length - decimal - 1;
		},
	
		_valueMin: function() {
			return this.options.min;
		},
	
		_valueMax: function() {
			return this.max;
		},
	
		_refreshRange: function( orientation ) {
			if ( orientation === "vertical" ) {
				this.range.css( { "width": "", "left": "" } );
			}
			if ( orientation === "horizontal" ) {
				this.range.css( { "height": "", "bottom": "" } );
			}
		},
	
		_refreshValue: function() {
			var lastValPercent, valPercent, value, valueMin, valueMax,
				oRange = this.options.range,
				o = this.options,
				that = this,
				animate = ( !this._animateOff ) ? o.animate : false,
				_set = {};
	
			if ( this._hasMultipleValues() ) {
				this.handles.each( function( i ) {
					valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
						that._valueMin() ) * 100;
					_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
					$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
					if ( that.options.range === true ) {
						if ( that.orientation === "horizontal" ) {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
									left: valPercent + "%"
								}, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( {
									width: ( valPercent - lastValPercent ) + "%"
								}, {
									queue: false,
									duration: o.animate
								} );
							}
						} else {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
									bottom: ( valPercent ) + "%"
								}, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( {
									height: ( valPercent - lastValPercent ) + "%"
								}, {
									queue: false,
									duration: o.animate
								} );
							}
						}
					}
					lastValPercent = valPercent;
				} );
			} else {
				value = this.value();
				valueMin = this._valueMin();
				valueMax = this._valueMax();
				valPercent = ( valueMax !== valueMin ) ?
						( value - valueMin ) / ( valueMax - valueMin ) * 100 :
						0;
				_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
	
				if ( oRange === "min" && this.orientation === "horizontal" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						width: valPercent + "%"
					}, o.animate );
				}
				if ( oRange === "max" && this.orientation === "horizontal" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						width: ( 100 - valPercent ) + "%"
					}, o.animate );
				}
				if ( oRange === "min" && this.orientation === "vertical" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						height: valPercent + "%"
					}, o.animate );
				}
				if ( oRange === "max" && this.orientation === "vertical" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						height: ( 100 - valPercent ) + "%"
					}, o.animate );
				}
			}
		},
	
		_handleEvents: {
			keydown: function( event ) {
				var allowed, curVal, newVal, step,
					index = $( event.target ).data( "ui-slider-handle-index" );
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
					case $.ui.keyCode.END:
					case $.ui.keyCode.PAGE_UP:
					case $.ui.keyCode.PAGE_DOWN:
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						event.preventDefault();
						if ( !this._keySliding ) {
							this._keySliding = true;
							this._addClass( $( event.target ), null, "ui-state-active" );
							allowed = this._start( event, index );
							if ( allowed === false ) {
								return;
							}
						}
						break;
				}
	
				step = this.options.step;
				if ( this._hasMultipleValues() ) {
					curVal = newVal = this.values( index );
				} else {
					curVal = newVal = this.value();
				}
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
						newVal = this._valueMin();
						break;
					case $.ui.keyCode.END:
						newVal = this._valueMax();
						break;
					case $.ui.keyCode.PAGE_UP:
						newVal = this._trimAlignValue(
							curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
						);
						break;
					case $.ui.keyCode.PAGE_DOWN:
						newVal = this._trimAlignValue(
							curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
						break;
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
						if ( curVal === this._valueMax() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal + step );
						break;
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						if ( curVal === this._valueMin() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal - step );
						break;
				}
	
				this._slide( event, index, newVal );
			},
			keyup: function( event ) {
				var index = $( event.target ).data( "ui-slider-handle-index" );
	
				if ( this._keySliding ) {
					this._keySliding = false;
					this._stop( event, index );
					this._change( event, index );
					this._removeClass( $( event.target ), null, "ui-state-active" );
				}
			}
		}
	} );
	
	
	/*!
	 * jQuery UI Sortable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Sortable
	//>>group: Interactions
	//>>description: Enables items in a list to be sorted using the mouse.
	//>>docs: http://api.jqueryui.com/sortable/
	//>>demos: http://jqueryui.com/sortable/
	//>>css.structure: ../../themes/base/sortable.css
	
	
	
	var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "sort",
		ready: false,
		options: {
			appendTo: "parent",
			axis: false,
			connectWith: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			dropOnEmpty: true,
			forcePlaceholderSize: false,
			forceHelperSize: false,
			grid: false,
			handle: false,
			helper: "original",
			items: "> *",
			opacity: false,
			placeholder: false,
			revert: false,
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			scope: "default",
			tolerance: "intersect",
			zIndex: 1000,
	
			// Callbacks
			activate: null,
			beforeStop: null,
			change: null,
			deactivate: null,
			out: null,
			over: null,
			receive: null,
			remove: null,
			sort: null,
			start: null,
			stop: null,
			update: null
		},
	
		_isOverAxis: function( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		},
	
		_isFloating: function( item ) {
			return ( /left|right/ ).test( item.css( "float" ) ) ||
				( /inline|table-cell/ ).test( item.css( "display" ) );
		},
	
		_create: function() {
			this.containerCache = {};
			this._addClass( "ui-sortable" );
	
			//Get the items
			this.refresh();
	
			//Let's determine the parent's offset
			this.offset = this.element.offset();
	
			//Initialize mouse events for interaction
			this._mouseInit();
	
			this._setHandleClassName();
	
			//We're ready to go
			this.ready = true;
	
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			if ( key === "handle" ) {
				this._setHandleClassName();
			}
		},
	
		_setHandleClassName: function() {
			var that = this;
			this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
			$.each( this.items, function() {
				that._addClass(
					this.instance.options.handle ?
						this.item.find( this.instance.options.handle ) :
						this.item,
					"ui-sortable-handle"
				);
			} );
		},
	
		_destroy: function() {
			this._mouseDestroy();
	
			for ( var i = this.items.length - 1; i >= 0; i-- ) {
				this.items[ i ].item.removeData( this.widgetName + "-item" );
			}
	
			return this;
		},
	
		_mouseCapture: function( event, overrideHandle ) {
			var currentItem = null,
				validHandle = false,
				that = this;
	
			if ( this.reverting ) {
				return false;
			}
	
			if ( this.options.disabled || this.options.type === "static" ) {
				return false;
			}
	
			//We have to refresh the items data once first
			this._refreshItems( event );
	
			//Find out if the clicked node (or one of its parents) is a actual item in this.items
			$( event.target ).parents().each( function() {
				if ( $.data( this, that.widgetName + "-item" ) === that ) {
					currentItem = $( this );
					return false;
				}
			} );
			if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
				currentItem = $( event.target );
			}
	
			if ( !currentItem ) {
				return false;
			}
			if ( this.options.handle && !overrideHandle ) {
				$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
					if ( this === event.target ) {
						validHandle = true;
					}
				} );
				if ( !validHandle ) {
					return false;
				}
			}
	
			this.currentItem = currentItem;
			this._removeCurrentsFromItems();
			return true;
	
		},
	
		_mouseStart: function( event, overrideHandle, noActivation ) {
	
			var i, body,
				o = this.options;
	
			this.currentContainer = this;
	
			//We only need to call refreshPositions, because the refreshItems call has been moved to
			// mouseCapture
			this.refreshPositions();
	
			//Create and append the visible helper
			this.helper = this._createHelper( event );
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Get the next scrolling parent
			this.scrollParent = this.helper.scrollParent();
	
			//The element's absolute position on the page minus margins
			this.offset = this.currentItem.offset();
			this.offset = {
				top: this.offset.top - this.margins.top,
				left: this.offset.left - this.margins.left
			};
	
			$.extend( this.offset, {
				click: { //Where the click happened, relative to the element
					left: event.pageX - this.offset.left,
					top: event.pageY - this.offset.top
				},
				parent: this._getParentOffset(),
	
				// This is a relative to absolute position minus the actual position calculation -
				// only used for relative positioned helper
				relative: this._getRelativeOffset()
			} );
	
			// Only after we got the offset, we can change the helper's position to absolute
			// TODO: Still need to figure out a way to make relative sorting possible
			this.helper.css( "position", "absolute" );
			this.cssPosition = this.helper.css( "position" );
	
			//Generate the original position
			this.originalPosition = this._generatePosition( event );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );
	
			//Cache the former DOM position
			this.domPosition = {
				prev: this.currentItem.prev()[ 0 ],
				parent: this.currentItem.parent()[ 0 ]
			};
	
			// If the helper is not the original, hide the original so it's not playing any role during
			// the drag, won't cause anything bad this way
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.currentItem.hide();
			}
	
			//Create the placeholder
			this._createPlaceholder();
	
			//Set a containment if given in the options
			if ( o.containment ) {
				this._setContainment();
			}
	
			if ( o.cursor && o.cursor !== "auto" ) { // cursor option
				body = this.document.find( "body" );
	
				// Support: IE
				this.storedCursor = body.css( "cursor" );
				body.css( "cursor", o.cursor );
	
				this.storedStylesheet =
					$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
			}
	
			if ( o.opacity ) { // opacity option
				if ( this.helper.css( "opacity" ) ) {
					this._storedOpacity = this.helper.css( "opacity" );
				}
				this.helper.css( "opacity", o.opacity );
			}
	
			if ( o.zIndex ) { // zIndex option
				if ( this.helper.css( "zIndex" ) ) {
					this._storedZIndex = this.helper.css( "zIndex" );
				}
				this.helper.css( "zIndex", o.zIndex );
			}
	
			//Prepare scrolling
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {
				this.overflowOffset = this.scrollParent.offset();
			}
	
			//Call callbacks
			this._trigger( "start", event, this._uiHash() );
	
			//Recache the helper size
			if ( !this._preserveHelperProportions ) {
				this._cacheHelperProportions();
			}
	
			//Post "activate" events to possible containers
			if ( !noActivation ) {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
				}
			}
	
			//Prepare possible droppables
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.current = this;
			}
	
			if ( $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
	
			this.dragging = true;
	
			this._addClass( this.helper, "ui-sortable-helper" );
	
			// Execute the drag once - this causes the helper not to be visiblebefore getting its
			// correct position
			this._mouseDrag( event );
			return true;
	
		},
	
		_mouseDrag: function( event ) {
			var i, item, itemElement, intersection,
				o = this.options,
				scrolled = false;
	
			//Compute the helpers position
			this.position = this._generatePosition( event );
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			if ( !this.lastPositionAbs ) {
				this.lastPositionAbs = this.positionAbs;
			}
	
			//Do scrolling
			if ( this.options.scroll ) {
				if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
						this.scrollParent[ 0 ].tagName !== "HTML" ) {
	
					if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
							event.pageY < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollTop =
							scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
					} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollTop =
							scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
					}
	
					if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
							event.pageX < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollLeft = scrolled =
							this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
						this.scrollParent[ 0 ].scrollLeft = scrolled =
							this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
					}
	
				} else {
	
					if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
						scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
					} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
							o.scrollSensitivity ) {
						scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
					}
	
					if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
						scrolled = this.document.scrollLeft(
							this.document.scrollLeft() - o.scrollSpeed
						);
					} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
							o.scrollSensitivity ) {
						scrolled = this.document.scrollLeft(
							this.document.scrollLeft() + o.scrollSpeed
						);
					}
	
				}
	
				if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
					$.ui.ddmanager.prepareOffsets( this, event );
				}
			}
	
			//Regenerate the absolute position used for position checks
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			//Set the helper position
			if ( !this.options.axis || this.options.axis !== "y" ) {
				this.helper[ 0 ].style.left = this.position.left + "px";
			}
			if ( !this.options.axis || this.options.axis !== "x" ) {
				this.helper[ 0 ].style.top = this.position.top + "px";
			}
	
			//Rearrange
			for ( i = this.items.length - 1; i >= 0; i-- ) {
	
				//Cache variables and intersection, continue if no intersection
				item = this.items[ i ];
				itemElement = item.item[ 0 ];
				intersection = this._intersectsWithPointer( item );
				if ( !intersection ) {
					continue;
				}
	
				// Only put the placeholder inside the current Container, skip all
				// items from other containers. This works because when moving
				// an item from one container to another the
				// currentContainer is switched before the placeholder is moved.
				//
				// Without this, moving items in "sub-sortables" can cause
				// the placeholder to jitter between the outer and inner container.
				if ( item.instance !== this.currentContainer ) {
					continue;
				}
	
				// Cannot intersect with itself
				// no useless actions that have been done before
				// no action if the item moved is the parent of the item checked
				if ( itemElement !== this.currentItem[ 0 ] &&
					this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
					!$.contains( this.placeholder[ 0 ], itemElement ) &&
					( this.options.type === "semi-dynamic" ?
						!$.contains( this.element[ 0 ], itemElement ) :
						true
					)
				) {
	
					this.direction = intersection === 1 ? "down" : "up";
	
					if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
						this._rearrange( event, item );
					} else {
						break;
					}
	
					this._trigger( "change", event, this._uiHash() );
					break;
				}
			}
	
			//Post events to containers
			this._contactContainers( event );
	
			//Interconnect with droppables
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.drag( this, event );
			}
	
			//Call callbacks
			this._trigger( "sort", event, this._uiHash() );
	
			this.lastPositionAbs = this.positionAbs;
			return false;
	
		},
	
		_mouseStop: function( event, noPropagation ) {
	
			if ( !event ) {
				return;
			}
	
			//If we are using droppables, inform the manager about the drop
			if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
				$.ui.ddmanager.drop( this, event );
			}
	
			if ( this.options.revert ) {
				var that = this,
					cur = this.placeholder.offset(),
					axis = this.options.axis,
					animation = {};
	
				if ( !axis || axis === "x" ) {
					animation.left = cur.left - this.offset.parent.left - this.margins.left +
						( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
							0 :
							this.offsetParent[ 0 ].scrollLeft
						);
				}
				if ( !axis || axis === "y" ) {
					animation.top = cur.top - this.offset.parent.top - this.margins.top +
						( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
							0 :
							this.offsetParent[ 0 ].scrollTop
						);
				}
				this.reverting = true;
				$( this.helper ).animate(
					animation,
					parseInt( this.options.revert, 10 ) || 500,
					function() {
						that._clear( event );
					}
				);
			} else {
				this._clear( event, noPropagation );
			}
	
			return false;
	
		},
	
		cancel: function() {
	
			if ( this.dragging ) {
	
				this._mouseUp( new $.Event( "mouseup", { target: null } ) );
	
				if ( this.options.helper === "original" ) {
					this.currentItem.css( this._storedCSS );
					this._removeClass( this.currentItem, "ui-sortable-helper" );
				} else {
					this.currentItem.show();
				}
	
				//Post deactivating events to containers
				for ( var i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
					if ( this.containers[ i ].containerCache.over ) {
						this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
						this.containers[ i ].containerCache.over = 0;
					}
				}
	
			}
	
			if ( this.placeholder ) {
	
				//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
				// it unbinds ALL events from the original node!
				if ( this.placeholder[ 0 ].parentNode ) {
					this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
				}
				if ( this.options.helper !== "original" && this.helper &&
						this.helper[ 0 ].parentNode ) {
					this.helper.remove();
				}
	
				$.extend( this, {
					helper: null,
					dragging: false,
					reverting: false,
					_noFinalSort: null
				} );
	
				if ( this.domPosition.prev ) {
					$( this.domPosition.prev ).after( this.currentItem );
				} else {
					$( this.domPosition.parent ).prepend( this.currentItem );
				}
			}
	
			return this;
	
		},
	
		serialize: function( o ) {
	
			var items = this._getItemsAsjQuery( o && o.connected ),
				str = [];
			o = o || {};
	
			$( items ).each( function() {
				var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
					.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
				if ( res ) {
					str.push(
						( o.key || res[ 1 ] + "[]" ) +
						"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
				}
			} );
	
			if ( !str.length && o.key ) {
				str.push( o.key + "=" );
			}
	
			return str.join( "&" );
	
		},
	
		toArray: function( o ) {
	
			var items = this._getItemsAsjQuery( o && o.connected ),
				ret = [];
	
			o = o || {};
	
			items.each( function() {
				ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
			} );
			return ret;
	
		},
	
		/* Be careful with the following core functions */
		_intersectsWith: function( item ) {
	
			var x1 = this.positionAbs.left,
				x2 = x1 + this.helperProportions.width,
				y1 = this.positionAbs.top,
				y2 = y1 + this.helperProportions.height,
				l = item.left,
				r = l + item.width,
				t = item.top,
				b = t + item.height,
				dyClick = this.offset.click.top,
				dxClick = this.offset.click.left,
				isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
					( y1 + dyClick ) < b ),
				isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
					( x1 + dxClick ) < r ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( this.options.tolerance === "pointer" ||
				this.options.forcePointerForContainers ||
				( this.options.tolerance !== "pointer" &&
					this.helperProportions[ this.floating ? "width" : "height" ] >
					item[ this.floating ? "width" : "height" ] )
			) {
				return isOverElement;
			} else {
	
				return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
					x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half
	
			}
		},
	
		_intersectsWithPointer: function( item ) {
			var verticalDirection, horizontalDirection,
				isOverElementHeight = ( this.options.axis === "x" ) ||
					this._isOverAxis(
						this.positionAbs.top + this.offset.click.top, item.top, item.height ),
				isOverElementWidth = ( this.options.axis === "y" ) ||
					this._isOverAxis(
						this.positionAbs.left + this.offset.click.left, item.left, item.width ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( !isOverElement ) {
				return false;
			}
	
			verticalDirection = this._getDragVerticalDirection();
			horizontalDirection = this._getDragHorizontalDirection();
	
			return this.floating ?
				( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
				: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );
	
		},
	
		_intersectsWithSides: function( item ) {
	
			var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
					this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
				isOverRightHalf = this._isOverAxis( this.positionAbs.left +
					this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if ( this.floating && horizontalDirection ) {
				return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
					( horizontalDirection === "left" && !isOverRightHalf ) );
			} else {
				return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
					( verticalDirection === "up" && !isOverBottomHalf ) );
			}
	
		},
	
		_getDragVerticalDirection: function() {
			var delta = this.positionAbs.top - this.lastPositionAbs.top;
			return delta !== 0 && ( delta > 0 ? "down" : "up" );
		},
	
		_getDragHorizontalDirection: function() {
			var delta = this.positionAbs.left - this.lastPositionAbs.left;
			return delta !== 0 && ( delta > 0 ? "right" : "left" );
		},
	
		refresh: function( event ) {
			this._refreshItems( event );
			this._setHandleClassName();
			this.refreshPositions();
			return this;
		},
	
		_connectWith: function() {
			var options = this.options;
			return options.connectWith.constructor === String ?
				[ options.connectWith ] :
				options.connectWith;
		},
	
		_getItemsAsjQuery: function( connected ) {
	
			var i, j, cur, inst,
				items = [],
				queries = [],
				connectWith = this._connectWith();
	
			if ( connectWith && connected ) {
				for ( i = connectWith.length - 1; i >= 0; i-- ) {
					cur = $( connectWith[ i ], this.document[ 0 ] );
					for ( j = cur.length - 1; j >= 0; j-- ) {
						inst = $.data( cur[ j ], this.widgetFullName );
						if ( inst && inst !== this && !inst.options.disabled ) {
							queries.push( [ $.isFunction( inst.options.items ) ?
								inst.options.items.call( inst.element ) :
								$( inst.options.items, inst.element )
									.not( ".ui-sortable-helper" )
									.not( ".ui-sortable-placeholder" ), inst ] );
						}
					}
				}
			}
	
			queries.push( [ $.isFunction( this.options.items ) ?
				this.options.items
					.call( this.element, null, { options: this.options, item: this.currentItem } ) :
				$( this.options.items, this.element )
					.not( ".ui-sortable-helper" )
					.not( ".ui-sortable-placeholder" ), this ] );
	
			function addItems() {
				items.push( this );
			}
			for ( i = queries.length - 1; i >= 0; i-- ) {
				queries[ i ][ 0 ].each( addItems );
			}
	
			return $( items );
	
		},
	
		_removeCurrentsFromItems: function() {
	
			var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );
	
			this.items = $.grep( this.items, function( item ) {
				for ( var j = 0; j < list.length; j++ ) {
					if ( list[ j ] === item.item[ 0 ] ) {
						return false;
					}
				}
				return true;
			} );
	
		},
	
		_refreshItems: function( event ) {
	
			this.items = [];
			this.containers = [ this ];
	
			var i, j, cur, inst, targetData, _queries, item, queriesLength,
				items = this.items,
				queries = [ [ $.isFunction( this.options.items ) ?
					this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
					$( this.options.items, this.element ), this ] ],
				connectWith = this._connectWith();
	
			//Shouldn't be run the first time through due to massive slow-down
			if ( connectWith && this.ready ) {
				for ( i = connectWith.length - 1; i >= 0; i-- ) {
					cur = $( connectWith[ i ], this.document[ 0 ] );
					for ( j = cur.length - 1; j >= 0; j-- ) {
						inst = $.data( cur[ j ], this.widgetFullName );
						if ( inst && inst !== this && !inst.options.disabled ) {
							queries.push( [ $.isFunction( inst.options.items ) ?
								inst.options.items
									.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
								$( inst.options.items, inst.element ), inst ] );
							this.containers.push( inst );
						}
					}
				}
			}
	
			for ( i = queries.length - 1; i >= 0; i-- ) {
				targetData = queries[ i ][ 1 ];
				_queries = queries[ i ][ 0 ];
	
				for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
					item = $( _queries[ j ] );
	
					// Data for target checking (mouse manager)
					item.data( this.widgetName + "-item", targetData );
	
					items.push( {
						item: item,
						instance: targetData,
						width: 0, height: 0,
						left: 0, top: 0
					} );
				}
			}
	
		},
	
		refreshPositions: function( fast ) {
	
			// Determine whether items are being displayed horizontally
			this.floating = this.items.length ?
				this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
				false;
	
			//This has to be redone because due to the item being moved out/into the offsetParent,
			// the offsetParent's position will change
			if ( this.offsetParent && this.helper ) {
				this.offset.parent = this._getParentOffset();
			}
	
			var i, item, t, p;
	
			for ( i = this.items.length - 1; i >= 0; i-- ) {
				item = this.items[ i ];
	
				//We ignore calculating positions of all connected containers when we're not over them
				if ( item.instance !== this.currentContainer && this.currentContainer &&
						item.item[ 0 ] !== this.currentItem[ 0 ] ) {
					continue;
				}
	
				t = this.options.toleranceElement ?
					$( this.options.toleranceElement, item.item ) :
					item.item;
	
				if ( !fast ) {
					item.width = t.outerWidth();
					item.height = t.outerHeight();
				}
	
				p = t.offset();
				item.left = p.left;
				item.top = p.top;
			}
	
			if ( this.options.custom && this.options.custom.refreshContainers ) {
				this.options.custom.refreshContainers.call( this );
			} else {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					p = this.containers[ i ].element.offset();
					this.containers[ i ].containerCache.left = p.left;
					this.containers[ i ].containerCache.top = p.top;
					this.containers[ i ].containerCache.width =
						this.containers[ i ].element.outerWidth();
					this.containers[ i ].containerCache.height =
						this.containers[ i ].element.outerHeight();
				}
			}
	
			return this;
		},
	
		_createPlaceholder: function( that ) {
			that = that || this;
			var className,
				o = that.options;
	
			if ( !o.placeholder || o.placeholder.constructor === String ) {
				className = o.placeholder;
				o.placeholder = {
					element: function() {
	
						var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
							element = $( "<" + nodeName + ">", that.document[ 0 ] );
	
							that._addClass( element, "ui-sortable-placeholder",
									className || that.currentItem[ 0 ].className )
								._removeClass( element, "ui-sortable-helper" );
	
						if ( nodeName === "tbody" ) {
							that._createTrPlaceholder(
								that.currentItem.find( "tr" ).eq( 0 ),
								$( "<tr>", that.document[ 0 ] ).appendTo( element )
							);
						} else if ( nodeName === "tr" ) {
							that._createTrPlaceholder( that.currentItem, element );
						} else if ( nodeName === "img" ) {
							element.attr( "src", that.currentItem.attr( "src" ) );
						}
	
						if ( !className ) {
							element.css( "visibility", "hidden" );
						}
	
						return element;
					},
					update: function( container, p ) {
	
						// 1. If a className is set as 'placeholder option, we don't force sizes -
						// the class is responsible for that
						// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
						// class name is specified
						if ( className && !o.forcePlaceholderSize ) {
							return;
						}
	
						//If the element doesn't have a actual height by itself (without styles coming
						// from a stylesheet), it receives the inline height from the dragged item
						if ( !p.height() ) {
							p.height(
								that.currentItem.innerHeight() -
								parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
								parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
						}
						if ( !p.width() ) {
							p.width(
								that.currentItem.innerWidth() -
								parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
								parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
						}
					}
				};
			}
	
			//Create the placeholder
			that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );
	
			//Append it after the actual current item
			that.currentItem.after( that.placeholder );
	
			//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
			o.placeholder.update( that, that.placeholder );
	
		},
	
		_createTrPlaceholder: function( sourceTr, targetTr ) {
			var that = this;
	
			sourceTr.children().each( function() {
				$( "<td>&#160;</td>", that.document[ 0 ] )
					.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
					.appendTo( targetTr );
			} );
		},
	
		_contactContainers: function( event ) {
			var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
				floating, axis,
				innermostContainer = null,
				innermostIndex = null;
	
			// Get innermost container that intersects with item
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
	
				// Never consider a container that's located within the item itself
				if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
					continue;
				}
	
				if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {
	
					// If we've already found a container and it's more "inner" than this, then continue
					if ( innermostContainer &&
							$.contains(
								this.containers[ i ].element[ 0 ],
								innermostContainer.element[ 0 ] ) ) {
						continue;
					}
	
					innermostContainer = this.containers[ i ];
					innermostIndex = i;
	
				} else {
	
					// container doesn't intersect. trigger "out" event if necessary
					if ( this.containers[ i ].containerCache.over ) {
						this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
						this.containers[ i ].containerCache.over = 0;
					}
				}
	
			}
	
			// If no intersecting containers found, return
			if ( !innermostContainer ) {
				return;
			}
	
			// Move the item into the container if it's not there already
			if ( this.containers.length === 1 ) {
				if ( !this.containers[ innermostIndex ].containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
					this.containers[ innermostIndex ].containerCache.over = 1;
				}
			} else {
	
				// When entering a new container, we will find the item with the least distance and
				// append our item near it
				dist = 10000;
				itemWithLeastDistance = null;
				floating = innermostContainer.floating || this._isFloating( this.currentItem );
				posProperty = floating ? "left" : "top";
				sizeProperty = floating ? "width" : "height";
				axis = floating ? "pageX" : "pageY";
	
				for ( j = this.items.length - 1; j >= 0; j-- ) {
					if ( !$.contains(
							this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
					) {
						continue;
					}
					if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
						continue;
					}
	
					cur = this.items[ j ].item.offset()[ posProperty ];
					nearBottom = false;
					if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
						nearBottom = true;
					}
	
					if ( Math.abs( event[ axis ] - cur ) < dist ) {
						dist = Math.abs( event[ axis ] - cur );
						itemWithLeastDistance = this.items[ j ];
						this.direction = nearBottom ? "up" : "down";
					}
				}
	
				//Check if dropOnEmpty is enabled
				if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
					return;
				}
	
				if ( this.currentContainer === this.containers[ innermostIndex ] ) {
					if ( !this.currentContainer.containerCache.over ) {
						this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
						this.currentContainer.containerCache.over = 1;
					}
					return;
				}
	
				itemWithLeastDistance ?
					this._rearrange( event, itemWithLeastDistance, null, true ) :
					this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
				this._trigger( "change", event, this._uiHash() );
				this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
				this.currentContainer = this.containers[ innermostIndex ];
	
				//Update the placeholder
				this.options.placeholder.update( this.currentContainer, this.placeholder );
	
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
	
		},
	
		_createHelper: function( event ) {
	
			var o = this.options,
				helper = $.isFunction( o.helper ) ?
					$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
					( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );
	
			//Add the helper to the DOM if that didn't happen already
			if ( !helper.parents( "body" ).length ) {
				$( o.appendTo !== "parent" ?
					o.appendTo :
					this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
			}
	
			if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
				this._storedCSS = {
					width: this.currentItem[ 0 ].style.width,
					height: this.currentItem[ 0 ].style.height,
					position: this.currentItem.css( "position" ),
					top: this.currentItem.css( "top" ),
					left: this.currentItem.css( "left" )
				};
			}
	
			if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
				helper.width( this.currentItem.width() );
			}
			if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
				helper.height( this.currentItem.height() );
			}
	
			return helper;
	
		},
	
		_adjustOffsetFromHelper: function( obj ) {
			if ( typeof obj === "string" ) {
				obj = obj.split( " " );
			}
			if ( $.isArray( obj ) ) {
				obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
			}
			if ( "left" in obj ) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ( "right" in obj ) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ( "top" in obj ) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ( "bottom" in obj ) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			this.offsetParent = this.helper.offsetParent();
			var po = this.offsetParent.offset();
	
			// This is a special case where we need to modify a offset calculated on start, since the
			// following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the
			// next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
			// the document, which means that the scroll is included in the initial calculation of the
			// offset of the parent, and never recalculated upon drag
			if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			// This needs to be actually done for all browsers, since pageX/pageY includes this
			// information with an ugly IE fix
			if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
					( this.offsetParent[ 0 ].tagName &&
					this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
				left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
			};
	
		},
	
		_getRelativeOffset: function() {
	
			if ( this.cssPosition === "relative" ) {
				var p = this.currentItem.position();
				return {
					top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
						this.scrollParent.scrollTop(),
					left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
						this.scrollParent.scrollLeft()
				};
			} else {
				return { top: 0, left: 0 };
			}
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
				top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var ce, co, over,
				o = this.options;
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
			if ( o.containment === "document" || o.containment === "window" ) {
				this.containment = [
					0 - this.offset.relative.left - this.offset.parent.left,
					0 - this.offset.relative.top - this.offset.parent.top,
					o.containment === "document" ?
						this.document.width() :
						this.window.width() - this.helperProportions.width - this.margins.left,
					( o.containment === "document" ?
						( this.document.height() || document.body.parentNode.scrollHeight ) :
						this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
					) - this.helperProportions.height - this.margins.top
				];
			}
	
			if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
				ce = $( o.containment )[ 0 ];
				co = $( o.containment ).offset();
				over = ( $( ce ).css( "overflow" ) !== "hidden" );
	
				this.containment = [
					co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
						( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
					co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
						( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
					co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
						( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
						( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
						this.helperProportions.width - this.margins.left,
					co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
						( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
						( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
						this.helperProportions.height - this.margins.top
				];
			}
	
		},
	
		_convertPositionTo: function( d, pos ) {
	
			if ( !pos ) {
				pos = this.position;
			}
			var mod = d === "absolute" ? 1 : -1,
				scroll = this.cssPosition === "absolute" &&
					!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
						this.offsetParent :
						this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );
	
			return {
				top: (
	
					// The absolute mouse position
					pos.top	+
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top * mod -
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollTop() :
						( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
				),
				left: (
	
					// The absolute mouse position
					pos.left +
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left * mod	-
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
						scroll.scrollLeft() ) * mod )
				)
			};
	
		},
	
		_generatePosition: function( event ) {
	
			var top, left,
				o = this.options,
				pageX = event.pageX,
				pageY = event.pageY,
				scroll = this.cssPosition === "absolute" &&
					!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
						this.offsetParent :
						this.scrollParent,
					scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );
	
			// This is another very weird special case that only happens for relative elements:
			// 1. If the css position is relative
			// 2. and the scroll parent is the document or similar to the offset parent
			// we have to refresh the relative offset during the scroll so there are no jumps
			if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
				this.offset.relative = this._getRelativeOffset();
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options
	
				if ( this.containment ) {
					if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
						pageX = this.containment[ 0 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
						pageY = this.containment[ 1 ] + this.offset.click.top;
					}
					if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
						pageX = this.containment[ 2 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
						pageY = this.containment[ 3 ] + this.offset.click.top;
					}
				}
	
				if ( o.grid ) {
					top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
						o.grid[ 1 ] ) * o.grid[ 1 ];
					pageY = this.containment ?
						( ( top - this.offset.click.top >= this.containment[ 1 ] &&
							top - this.offset.click.top <= this.containment[ 3 ] ) ?
								top :
								( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
									top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
									top;
	
					left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
						o.grid[ 0 ] ) * o.grid[ 0 ];
					pageX = this.containment ?
						( ( left - this.offset.click.left >= this.containment[ 0 ] &&
							left - this.offset.click.left <= this.containment[ 2 ] ) ?
								left :
								( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
									left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
									left;
				}
	
			}
	
			return {
				top: (
	
					// The absolute mouse position
					pageY -
	
					// Click offset (relative to the element)
					this.offset.click.top -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top +
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollTop() :
						( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
				),
				left: (
	
					// The absolute mouse position
					pageX -
	
					// Click offset (relative to the element)
					this.offset.click.left -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left +
					( ( this.cssPosition === "fixed" ?
						-this.scrollParent.scrollLeft() :
						scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
				)
			};
	
		},
	
		_rearrange: function( event, i, a, hardRefresh ) {
	
			a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
				i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
					( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );
	
			//Various things done here to improve the performance:
			// 1. we create a setTimeout, that calls refreshPositions
			// 2. on the instance, we have a counter variable, that get's higher after every append
			// 3. on the local scope, we copy the counter variable, and check in the timeout,
			// if it's still the same
			// 4. this lets only the last addition to the timeout stack through
			this.counter = this.counter ? ++this.counter : 1;
			var counter = this.counter;
	
			this._delay( function() {
				if ( counter === this.counter ) {
	
					//Precompute after each DOM insertion, NOT on mousemove
					this.refreshPositions( !hardRefresh );
				}
			} );
	
		},
	
		_clear: function( event, noPropagation ) {
	
			this.reverting = false;
	
			// We delay all events that have to be triggered to after the point where the placeholder
			// has been removed and everything else normalized again
			var i,
				delayedTriggers = [];
	
			// We first have to update the dom position of the actual currentItem
			// Note: don't do it if the current item is already removed (by a user), or it gets
			// reappended (see #4088)
			if ( !this._noFinalSort && this.currentItem.parent().length ) {
				this.placeholder.before( this.currentItem );
			}
			this._noFinalSort = null;
	
			if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
				for ( i in this._storedCSS ) {
					if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
						this._storedCSS[ i ] = "";
					}
				}
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}
	
			if ( this.fromOutside && !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
				} );
			}
			if ( ( this.fromOutside ||
					this.domPosition.prev !==
					this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
					this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {
	
				// Trigger update callback if the DOM position has changed
				delayedTriggers.push( function( event ) {
					this._trigger( "update", event, this._uiHash() );
				} );
			}
	
			// Check if the items Container has Changed and trigger appropriate
			// events.
			if ( this !== this.currentContainer ) {
				if ( !noPropagation ) {
					delayedTriggers.push( function( event ) {
						this._trigger( "remove", event, this._uiHash() );
					} );
					delayedTriggers.push( ( function( c ) {
						return function( event ) {
							c._trigger( "receive", event, this._uiHash( this ) );
						};
					} ).call( this, this.currentContainer ) );
					delayedTriggers.push( ( function( c ) {
						return function( event ) {
							c._trigger( "update", event, this._uiHash( this ) );
						};
					} ).call( this, this.currentContainer ) );
				}
			}
	
			//Post events to containers
			function delayEvent( type, instance, container ) {
				return function( event ) {
					container._trigger( type, event, instance._uiHash( instance ) );
				};
			}
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				if ( !noPropagation ) {
					delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
				}
				if ( this.containers[ i ].containerCache.over ) {
					delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}
	
			//Do what was originally in plugins
			if ( this.storedCursor ) {
				this.document.find( "body" ).css( "cursor", this.storedCursor );
				this.storedStylesheet.remove();
			}
			if ( this._storedOpacity ) {
				this.helper.css( "opacity", this._storedOpacity );
			}
			if ( this._storedZIndex ) {
				this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
			}
	
			this.dragging = false;
	
			if ( !noPropagation ) {
				this._trigger( "beforeStop", event, this._uiHash() );
			}
	
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
	
			if ( !this.cancelHelperRemoval ) {
				if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
					this.helper.remove();
				}
				this.helper = null;
			}
	
			if ( !noPropagation ) {
				for ( i = 0; i < delayedTriggers.length; i++ ) {
	
					// Trigger all delayed events
					delayedTriggers[ i ].call( this, event );
				}
				this._trigger( "stop", event, this._uiHash() );
			}
	
			this.fromOutside = false;
			return !this.cancelHelperRemoval;
	
		},
	
		_trigger: function() {
			if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
				this.cancel();
			}
		},
	
		_uiHash: function( _inst ) {
			var inst = _inst || this;
			return {
				helper: inst.helper,
				placeholder: inst.placeholder || $( [] ),
				position: inst.position,
				originalPosition: inst.originalPosition,
				offset: inst.positionAbs,
				item: inst.currentItem,
				sender: _inst ? _inst.element : null
			};
		}
	
	} );
	
	
	/*!
	 * jQuery UI Spinner 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Spinner
	//>>group: Widgets
	//>>description: Displays buttons to easily input numbers via the keyboard or mouse.
	//>>docs: http://api.jqueryui.com/spinner/
	//>>demos: http://jqueryui.com/spinner/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/spinner.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	function spinnerModifer( fn ) {
		return function() {
			var previous = this.element.val();
			fn.apply( this, arguments );
			this._refresh();
			if ( previous !== this.element.val() ) {
				this._trigger( "change" );
			}
		};
	}
	
	$.widget( "ui.spinner", {
		version: "1.12.1",
		defaultElement: "<input>",
		widgetEventPrefix: "spin",
		options: {
			classes: {
				"ui-spinner": "ui-corner-all",
				"ui-spinner-down": "ui-corner-br",
				"ui-spinner-up": "ui-corner-tr"
			},
			culture: null,
			icons: {
				down: "ui-icon-triangle-1-s",
				up: "ui-icon-triangle-1-n"
			},
			incremental: true,
			max: null,
			min: null,
			numberFormat: null,
			page: 10,
			step: 1,
	
			change: null,
			spin: null,
			start: null,
			stop: null
		},
	
		_create: function() {
	
			// handle string values that need to be parsed
			this._setOption( "max", this.options.max );
			this._setOption( "min", this.options.min );
			this._setOption( "step", this.options.step );
	
			// Only format if there is a value, prevents the field from being marked
			// as invalid in Firefox, see #9573.
			if ( this.value() !== "" ) {
	
				// Format the value, but don't constrain.
				this._value( this.element.val(), true );
			}
	
			this._draw();
			this._on( this._events );
			this._refresh();
	
			// Turning off autocomplete prevents the browser from remembering the
			// value when navigating through history, so we re-enable autocomplete
			// if the page is unloaded before the widget is destroyed. #7790
			this._on( this.window, {
				beforeunload: function() {
					this.element.removeAttr( "autocomplete" );
				}
			} );
		},
	
		_getCreateOptions: function() {
			var options = this._super();
			var element = this.element;
	
			$.each( [ "min", "max", "step" ], function( i, option ) {
				var value = element.attr( option );
				if ( value != null && value.length ) {
					options[ option ] = value;
				}
			} );
	
			return options;
		},
	
		_events: {
			keydown: function( event ) {
				if ( this._start( event ) && this._keydown( event ) ) {
					event.preventDefault();
				}
			},
			keyup: "_stop",
			focus: function() {
				this.previous = this.element.val();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}
	
				this._stop();
				this._refresh();
				if ( this.previous !== this.element.val() ) {
					this._trigger( "change", event );
				}
			},
			mousewheel: function( event, delta ) {
				if ( !delta ) {
					return;
				}
				if ( !this.spinning && !this._start( event ) ) {
					return false;
				}
	
				this._spin( ( delta > 0 ? 1 : -1 ) * this.options.step, event );
				clearTimeout( this.mousewheelTimer );
				this.mousewheelTimer = this._delay( function() {
					if ( this.spinning ) {
						this._stop( event );
					}
				}, 100 );
				event.preventDefault();
			},
			"mousedown .ui-spinner-button": function( event ) {
				var previous;
	
				// We never want the buttons to have focus; whenever the user is
				// interacting with the spinner, the focus should be on the input.
				// If the input is focused then this.previous is properly set from
				// when the input first received focus. If the input is not focused
				// then we need to set this.previous based on the value before spinning.
				previous = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] ) ?
					this.previous : this.element.val();
				function checkFocus() {
					var isActive = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] );
					if ( !isActive ) {
						this.element.trigger( "focus" );
						this.previous = previous;
	
						// support: IE
						// IE sets focus asynchronously, so we need to check if focus
						// moved off of the input because the user clicked on the button.
						this._delay( function() {
							this.previous = previous;
						} );
					}
				}
	
				// Ensure focus is on (or stays on) the text field
				event.preventDefault();
				checkFocus.call( this );
	
				// Support: IE
				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				// and check (again) if focus moved off of the input.
				this.cancelBlur = true;
				this._delay( function() {
					delete this.cancelBlur;
					checkFocus.call( this );
				} );
	
				if ( this._start( event ) === false ) {
					return;
				}
	
				this._repeat( null, $( event.currentTarget )
					.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
			},
			"mouseup .ui-spinner-button": "_stop",
			"mouseenter .ui-spinner-button": function( event ) {
	
				// button will add ui-state-active if mouse was down while mouseleave and kept down
				if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
					return;
				}
	
				if ( this._start( event ) === false ) {
					return false;
				}
				this._repeat( null, $( event.currentTarget )
					.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
			},
	
			// TODO: do we really want to consider this a stop?
			// shouldn't we just stop the repeater and wait until mouseup before
			// we trigger the stop event?
			"mouseleave .ui-spinner-button": "_stop"
		},
	
		// Support mobile enhanced option and make backcompat more sane
		_enhance: function() {
			this.uiSpinner = this.element
				.attr( "autocomplete", "off" )
				.wrap( "<span>" )
				.parent()
	
					// Add buttons
					.append(
						"<a></a><a></a>"
					);
		},
	
		_draw: function() {
			this._enhance();
	
			this._addClass( this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content" );
			this._addClass( "ui-spinner-input" );
	
			this.element.attr( "role", "spinbutton" );
	
			// Button bindings
			this.buttons = this.uiSpinner.children( "a" )
				.attr( "tabIndex", -1 )
				.attr( "aria-hidden", true )
				.button( {
					classes: {
						"ui-button": ""
					}
				} );
	
			// TODO: Right now button does not support classes this is already updated in button PR
			this._removeClass( this.buttons, "ui-corner-all" );
	
			this._addClass( this.buttons.first(), "ui-spinner-button ui-spinner-up" );
			this._addClass( this.buttons.last(), "ui-spinner-button ui-spinner-down" );
			this.buttons.first().button( {
				"icon": this.options.icons.up,
				"showLabel": false
			} );
			this.buttons.last().button( {
				"icon": this.options.icons.down,
				"showLabel": false
			} );
	
			// IE 6 doesn't understand height: 50% for the buttons
			// unless the wrapper has an explicit height
			if ( this.buttons.height() > Math.ceil( this.uiSpinner.height() * 0.5 ) &&
					this.uiSpinner.height() > 0 ) {
				this.uiSpinner.height( this.uiSpinner.height() );
			}
		},
	
		_keydown: function( event ) {
			var options = this.options,
				keyCode = $.ui.keyCode;
	
			switch ( event.keyCode ) {
			case keyCode.UP:
				this._repeat( null, 1, event );
				return true;
			case keyCode.DOWN:
				this._repeat( null, -1, event );
				return true;
			case keyCode.PAGE_UP:
				this._repeat( null, options.page, event );
				return true;
			case keyCode.PAGE_DOWN:
				this._repeat( null, -options.page, event );
				return true;
			}
	
			return false;
		},
	
		_start: function( event ) {
			if ( !this.spinning && this._trigger( "start", event ) === false ) {
				return false;
			}
	
			if ( !this.counter ) {
				this.counter = 1;
			}
			this.spinning = true;
			return true;
		},
	
		_repeat: function( i, steps, event ) {
			i = i || 500;
	
			clearTimeout( this.timer );
			this.timer = this._delay( function() {
				this._repeat( 40, steps, event );
			}, i );
	
			this._spin( steps * this.options.step, event );
		},
	
		_spin: function( step, event ) {
			var value = this.value() || 0;
	
			if ( !this.counter ) {
				this.counter = 1;
			}
	
			value = this._adjustValue( value + step * this._increment( this.counter ) );
	
			if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false ) {
				this._value( value );
				this.counter++;
			}
		},
	
		_increment: function( i ) {
			var incremental = this.options.incremental;
	
			if ( incremental ) {
				return $.isFunction( incremental ) ?
					incremental( i ) :
					Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
			}
	
			return 1;
		},
	
		_precision: function() {
			var precision = this._precisionOf( this.options.step );
			if ( this.options.min !== null ) {
				precision = Math.max( precision, this._precisionOf( this.options.min ) );
			}
			return precision;
		},
	
		_precisionOf: function( num ) {
			var str = num.toString(),
				decimal = str.indexOf( "." );
			return decimal === -1 ? 0 : str.length - decimal - 1;
		},
	
		_adjustValue: function( value ) {
			var base, aboveMin,
				options = this.options;
	
			// Make sure we're at a valid step
			// - find out where we are relative to the base (min or 0)
			base = options.min !== null ? options.min : 0;
			aboveMin = value - base;
	
			// - round to the nearest step
			aboveMin = Math.round( aboveMin / options.step ) * options.step;
	
			// - rounding is based on 0, so adjust back to our base
			value = base + aboveMin;
	
			// Fix precision from bad JS floating point math
			value = parseFloat( value.toFixed( this._precision() ) );
	
			// Clamp the value
			if ( options.max !== null && value > options.max ) {
				return options.max;
			}
			if ( options.min !== null && value < options.min ) {
				return options.min;
			}
	
			return value;
		},
	
		_stop: function( event ) {
			if ( !this.spinning ) {
				return;
			}
	
			clearTimeout( this.timer );
			clearTimeout( this.mousewheelTimer );
			this.counter = 0;
			this.spinning = false;
			this._trigger( "stop", event );
		},
	
		_setOption: function( key, value ) {
			var prevValue, first, last;
	
			if ( key === "culture" || key === "numberFormat" ) {
				prevValue = this._parse( this.element.val() );
				this.options[ key ] = value;
				this.element.val( this._format( prevValue ) );
				return;
			}
	
			if ( key === "max" || key === "min" || key === "step" ) {
				if ( typeof value === "string" ) {
					value = this._parse( value );
				}
			}
			if ( key === "icons" ) {
				first = this.buttons.first().find( ".ui-icon" );
				this._removeClass( first, null, this.options.icons.up );
				this._addClass( first, null, value.up );
				last = this.buttons.last().find( ".ui-icon" );
				this._removeClass( last, null, this.options.icons.down );
				this._addClass( last, null, value.down );
			}
	
			this._super( key, value );
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this._toggleClass( this.uiSpinner, null, "ui-state-disabled", !!value );
			this.element.prop( "disabled", !!value );
			this.buttons.button( value ? "disable" : "enable" );
		},
	
		_setOptions: spinnerModifer( function( options ) {
			this._super( options );
		} ),
	
		_parse: function( val ) {
			if ( typeof val === "string" && val !== "" ) {
				val = window.Globalize && this.options.numberFormat ?
					Globalize.parseFloat( val, 10, this.options.culture ) : +val;
			}
			return val === "" || isNaN( val ) ? null : val;
		},
	
		_format: function( value ) {
			if ( value === "" ) {
				return "";
			}
			return window.Globalize && this.options.numberFormat ?
				Globalize.format( value, this.options.numberFormat, this.options.culture ) :
				value;
		},
	
		_refresh: function() {
			this.element.attr( {
				"aria-valuemin": this.options.min,
				"aria-valuemax": this.options.max,
	
				// TODO: what should we do with values that can't be parsed?
				"aria-valuenow": this._parse( this.element.val() )
			} );
		},
	
		isValid: function() {
			var value = this.value();
	
			// Null is invalid
			if ( value === null ) {
				return false;
			}
	
			// If value gets adjusted, it's invalid
			return value === this._adjustValue( value );
		},
	
		// Update the value without triggering change
		_value: function( value, allowAny ) {
			var parsed;
			if ( value !== "" ) {
				parsed = this._parse( value );
				if ( parsed !== null ) {
					if ( !allowAny ) {
						parsed = this._adjustValue( parsed );
					}
					value = this._format( parsed );
				}
			}
			this.element.val( value );
			this._refresh();
		},
	
		_destroy: function() {
			this.element
				.prop( "disabled", false )
				.removeAttr( "autocomplete role aria-valuemin aria-valuemax aria-valuenow" );
	
			this.uiSpinner.replaceWith( this.element );
		},
	
		stepUp: spinnerModifer( function( steps ) {
			this._stepUp( steps );
		} ),
		_stepUp: function( steps ) {
			if ( this._start() ) {
				this._spin( ( steps || 1 ) * this.options.step );
				this._stop();
			}
		},
	
		stepDown: spinnerModifer( function( steps ) {
			this._stepDown( steps );
		} ),
		_stepDown: function( steps ) {
			if ( this._start() ) {
				this._spin( ( steps || 1 ) * -this.options.step );
				this._stop();
			}
		},
	
		pageUp: spinnerModifer( function( pages ) {
			this._stepUp( ( pages || 1 ) * this.options.page );
		} ),
	
		pageDown: spinnerModifer( function( pages ) {
			this._stepDown( ( pages || 1 ) * this.options.page );
		} ),
	
		value: function( newVal ) {
			if ( !arguments.length ) {
				return this._parse( this.element.val() );
			}
			spinnerModifer( this._value ).call( this, newVal );
		},
	
		widget: function() {
			return this.uiSpinner;
		}
	} );
	
	// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if ( $.uiBackCompat !== false ) {
	
		// Backcompat for spinner html extension points
		$.widget( "ui.spinner", $.ui.spinner, {
			_enhance: function() {
				this.uiSpinner = this.element
					.attr( "autocomplete", "off" )
					.wrap( this._uiSpinnerHtml() )
					.parent()
	
						// Add buttons
						.append( this._buttonHtml() );
			},
			_uiSpinnerHtml: function() {
				return "<span>";
			},
	
			_buttonHtml: function() {
				return "<a></a><a></a>";
			}
		} );
	}
	
	var widgetsSpinner = $.ui.spinner;
	
	
	/*!
	 * jQuery UI Tabs 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Tabs
	//>>group: Widgets
	//>>description: Transforms a set of container elements into a tab structure.
	//>>docs: http://api.jqueryui.com/tabs/
	//>>demos: http://jqueryui.com/tabs/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/tabs.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.widget( "ui.tabs", {
		version: "1.12.1",
		delay: 300,
		options: {
			active: null,
			classes: {
				"ui-tabs": "ui-corner-all",
				"ui-tabs-nav": "ui-corner-all",
				"ui-tabs-panel": "ui-corner-bottom",
				"ui-tabs-tab": "ui-corner-top"
			},
			collapsible: false,
			event: "click",
			heightStyle: "content",
			hide: null,
			show: null,
	
			// Callbacks
			activate: null,
			beforeActivate: null,
			beforeLoad: null,
			load: null
		},
	
		_isLocal: ( function() {
			var rhash = /#.*$/;
	
			return function( anchor ) {
				var anchorUrl, locationUrl;
	
				anchorUrl = anchor.href.replace( rhash, "" );
				locationUrl = location.href.replace( rhash, "" );
	
				// Decoding may throw an error if the URL isn't UTF-8 (#9518)
				try {
					anchorUrl = decodeURIComponent( anchorUrl );
				} catch ( error ) {}
				try {
					locationUrl = decodeURIComponent( locationUrl );
				} catch ( error ) {}
	
				return anchor.hash.length > 1 && anchorUrl === locationUrl;
			};
		} )(),
	
		_create: function() {
			var that = this,
				options = this.options;
	
			this.running = false;
	
			this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
			this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );
	
			this._processTabs();
			options.active = this._initialActive();
	
			// Take disabling tabs via class attribute from HTML
			// into account and update option properly.
			if ( $.isArray( options.disabled ) ) {
				options.disabled = $.unique( options.disabled.concat(
					$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
						return that.tabs.index( li );
					} )
				) ).sort();
			}
	
			// Check for length avoids error when initializing empty list
			if ( this.options.active !== false && this.anchors.length ) {
				this.active = this._findActive( options.active );
			} else {
				this.active = $();
			}
	
			this._refresh();
	
			if ( this.active.length ) {
				this.load( options.active );
			}
		},
	
		_initialActive: function() {
			var active = this.options.active,
				collapsible = this.options.collapsible,
				locationHash = location.hash.substring( 1 );
	
			if ( active === null ) {
	
				// check the fragment identifier in the URL
				if ( locationHash ) {
					this.tabs.each( function( i, tab ) {
						if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
							active = i;
							return false;
						}
					} );
				}
	
				// Check for a tab marked active via a class
				if ( active === null ) {
					active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
				}
	
				// No active tab, set to false
				if ( active === null || active === -1 ) {
					active = this.tabs.length ? 0 : false;
				}
			}
	
			// Handle numbers: negative, out of range
			if ( active !== false ) {
				active = this.tabs.index( this.tabs.eq( active ) );
				if ( active === -1 ) {
					active = collapsible ? false : 0;
				}
			}
	
			// Don't allow collapsible: false and active: false
			if ( !collapsible && active === false && this.anchors.length ) {
				active = 0;
			}
	
			return active;
		},
	
		_getCreateEventData: function() {
			return {
				tab: this.active,
				panel: !this.active.length ? $() : this._getPanelForTab( this.active )
			};
		},
	
		_tabKeydown: function( event ) {
			var focusedTab = $( $.ui.safeActiveElement( this.document[ 0 ] ) ).closest( "li" ),
				selectedIndex = this.tabs.index( focusedTab ),
				goingForward = true;
	
			if ( this._handlePageNav( event ) ) {
				return;
			}
	
			switch ( event.keyCode ) {
			case $.ui.keyCode.RIGHT:
			case $.ui.keyCode.DOWN:
				selectedIndex++;
				break;
			case $.ui.keyCode.UP:
			case $.ui.keyCode.LEFT:
				goingForward = false;
				selectedIndex--;
				break;
			case $.ui.keyCode.END:
				selectedIndex = this.anchors.length - 1;
				break;
			case $.ui.keyCode.HOME:
				selectedIndex = 0;
				break;
			case $.ui.keyCode.SPACE:
	
				// Activate only, no collapsing
				event.preventDefault();
				clearTimeout( this.activating );
				this._activate( selectedIndex );
				return;
			case $.ui.keyCode.ENTER:
	
				// Toggle (cancel delayed activation, allow collapsing)
				event.preventDefault();
				clearTimeout( this.activating );
	
				// Determine if we should collapse or activate
				this._activate( selectedIndex === this.options.active ? false : selectedIndex );
				return;
			default:
				return;
			}
	
			// Focus the appropriate tab, based on which key was pressed
			event.preventDefault();
			clearTimeout( this.activating );
			selectedIndex = this._focusNextTab( selectedIndex, goingForward );
	
			// Navigating with control/command key will prevent automatic activation
			if ( !event.ctrlKey && !event.metaKey ) {
	
				// Update aria-selected immediately so that AT think the tab is already selected.
				// Otherwise AT may confuse the user by stating that they need to activate the tab,
				// but the tab will already be activated by the time the announcement finishes.
				focusedTab.attr( "aria-selected", "false" );
				this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );
	
				this.activating = this._delay( function() {
					this.option( "active", selectedIndex );
				}, this.delay );
			}
		},
	
		_panelKeydown: function( event ) {
			if ( this._handlePageNav( event ) ) {
				return;
			}
	
			// Ctrl+up moves focus to the current tab
			if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
				event.preventDefault();
				this.active.trigger( "focus" );
			}
		},
	
		// Alt+page up/down moves focus to the previous/next tab (and activates)
		_handlePageNav: function( event ) {
			if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
				this._activate( this._focusNextTab( this.options.active - 1, false ) );
				return true;
			}
			if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
				this._activate( this._focusNextTab( this.options.active + 1, true ) );
				return true;
			}
		},
	
		_findNextTab: function( index, goingForward ) {
			var lastTabIndex = this.tabs.length - 1;
	
			function constrain() {
				if ( index > lastTabIndex ) {
					index = 0;
				}
				if ( index < 0 ) {
					index = lastTabIndex;
				}
				return index;
			}
	
			while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
				index = goingForward ? index + 1 : index - 1;
			}
	
			return index;
		},
	
		_focusNextTab: function( index, goingForward ) {
			index = this._findNextTab( index, goingForward );
			this.tabs.eq( index ).trigger( "focus" );
			return index;
		},
	
		_setOption: function( key, value ) {
			if ( key === "active" ) {
	
				// _activate() will handle invalid values and update this.options
				this._activate( value );
				return;
			}
	
			this._super( key, value );
	
			if ( key === "collapsible" ) {
				this._toggleClass( "ui-tabs-collapsible", null, value );
	
				// Setting collapsible: false while collapsed; open first panel
				if ( !value && this.options.active === false ) {
					this._activate( 0 );
				}
			}
	
			if ( key === "event" ) {
				this._setupEvents( value );
			}
	
			if ( key === "heightStyle" ) {
				this._setupHeightStyle( value );
			}
		},
	
		_sanitizeSelector: function( hash ) {
			return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
		},
	
		refresh: function() {
			var options = this.options,
				lis = this.tablist.children( ":has(a[href])" );
	
			// Get disabled tabs from class attribute from HTML
			// this will get converted to a boolean if needed in _refresh()
			options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
				return lis.index( tab );
			} );
	
			this._processTabs();
	
			// Was collapsed or no tabs
			if ( options.active === false || !this.anchors.length ) {
				options.active = false;
				this.active = $();
	
			// was active, but active tab is gone
			} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {
	
				// all remaining tabs are disabled
				if ( this.tabs.length === options.disabled.length ) {
					options.active = false;
					this.active = $();
	
				// activate previous tab
				} else {
					this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
				}
	
			// was active, active tab still exists
			} else {
	
				// make sure active index is correct
				options.active = this.tabs.index( this.active );
			}
	
			this._refresh();
		},
	
		_refresh: function() {
			this._setOptionDisabled( this.options.disabled );
			this._setupEvents( this.options.event );
			this._setupHeightStyle( this.options.heightStyle );
	
			this.tabs.not( this.active ).attr( {
				"aria-selected": "false",
				"aria-expanded": "false",
				tabIndex: -1
			} );
			this.panels.not( this._getPanelForTab( this.active ) )
				.hide()
				.attr( {
					"aria-hidden": "true"
				} );
	
			// Make sure one tab is in the tab order
			if ( !this.active.length ) {
				this.tabs.eq( 0 ).attr( "tabIndex", 0 );
			} else {
				this.active
					.attr( {
						"aria-selected": "true",
						"aria-expanded": "true",
						tabIndex: 0
					} );
				this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
				this._getPanelForTab( this.active )
					.show()
					.attr( {
						"aria-hidden": "false"
					} );
			}
		},
	
		_processTabs: function() {
			var that = this,
				prevTabs = this.tabs,
				prevAnchors = this.anchors,
				prevPanels = this.panels;
	
			this.tablist = this._getList().attr( "role", "tablist" );
			this._addClass( this.tablist, "ui-tabs-nav",
				"ui-helper-reset ui-helper-clearfix ui-widget-header" );
	
			// Prevent users from focusing disabled tabs via click
			this.tablist
				.on( "mousedown" + this.eventNamespace, "> li", function( event ) {
					if ( $( this ).is( ".ui-state-disabled" ) ) {
						event.preventDefault();
					}
				} )
	
				// Support: IE <9
				// Preventing the default action in mousedown doesn't prevent IE
				// from focusing the element, so if the anchor gets focused, blur.
				// We don't have to worry about focusing the previously focused
				// element since clicking on a non-focusable element should focus
				// the body anyway.
				.on( "focus" + this.eventNamespace, ".ui-tabs-anchor", function() {
					if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
						this.blur();
					}
				} );
	
			this.tabs = this.tablist.find( "> li:has(a[href])" )
				.attr( {
					role: "tab",
					tabIndex: -1
				} );
			this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );
	
			this.anchors = this.tabs.map( function() {
				return $( "a", this )[ 0 ];
			} )
				.attr( {
					role: "presentation",
					tabIndex: -1
				} );
			this._addClass( this.anchors, "ui-tabs-anchor" );
	
			this.panels = $();
	
			this.anchors.each( function( i, anchor ) {
				var selector, panel, panelId,
					anchorId = $( anchor ).uniqueId().attr( "id" ),
					tab = $( anchor ).closest( "li" ),
					originalAriaControls = tab.attr( "aria-controls" );
	
				// Inline tab
				if ( that._isLocal( anchor ) ) {
					selector = anchor.hash;
					panelId = selector.substring( 1 );
					panel = that.element.find( that._sanitizeSelector( selector ) );
	
				// remote tab
				} else {
	
					// If the tab doesn't already have aria-controls,
					// generate an id by using a throw-away element
					panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
					selector = "#" + panelId;
					panel = that.element.find( selector );
					if ( !panel.length ) {
						panel = that._createPanel( panelId );
						panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
					}
					panel.attr( "aria-live", "polite" );
				}
	
				if ( panel.length ) {
					that.panels = that.panels.add( panel );
				}
				if ( originalAriaControls ) {
					tab.data( "ui-tabs-aria-controls", originalAriaControls );
				}
				tab.attr( {
					"aria-controls": panelId,
					"aria-labelledby": anchorId
				} );
				panel.attr( "aria-labelledby", anchorId );
			} );
	
			this.panels.attr( "role", "tabpanel" );
			this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );
	
			// Avoid memory leaks (#10056)
			if ( prevTabs ) {
				this._off( prevTabs.not( this.tabs ) );
				this._off( prevAnchors.not( this.anchors ) );
				this._off( prevPanels.not( this.panels ) );
			}
		},
	
		// Allow overriding how to find the list for rare usage scenarios (#7715)
		_getList: function() {
			return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
		},
	
		_createPanel: function( id ) {
			return $( "<div>" )
				.attr( "id", id )
				.data( "ui-tabs-destroy", true );
		},
	
		_setOptionDisabled: function( disabled ) {
			var currentItem, li, i;
	
			if ( $.isArray( disabled ) ) {
				if ( !disabled.length ) {
					disabled = false;
				} else if ( disabled.length === this.anchors.length ) {
					disabled = true;
				}
			}
	
			// Disable tabs
			for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
				currentItem = $( li );
				if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
					currentItem.attr( "aria-disabled", "true" );
					this._addClass( currentItem, null, "ui-state-disabled" );
				} else {
					currentItem.removeAttr( "aria-disabled" );
					this._removeClass( currentItem, null, "ui-state-disabled" );
				}
			}
	
			this.options.disabled = disabled;
	
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
				disabled === true );
		},
	
		_setupEvents: function( event ) {
			var events = {};
			if ( event ) {
				$.each( event.split( " " ), function( index, eventName ) {
					events[ eventName ] = "_eventHandler";
				} );
			}
	
			this._off( this.anchors.add( this.tabs ).add( this.panels ) );
	
			// Always prevent the default action, even when disabled
			this._on( true, this.anchors, {
				click: function( event ) {
					event.preventDefault();
				}
			} );
			this._on( this.anchors, events );
			this._on( this.tabs, { keydown: "_tabKeydown" } );
			this._on( this.panels, { keydown: "_panelKeydown" } );
	
			this._focusable( this.tabs );
			this._hoverable( this.tabs );
		},
	
		_setupHeightStyle: function( heightStyle ) {
			var maxHeight,
				parent = this.element.parent();
	
			if ( heightStyle === "fill" ) {
				maxHeight = parent.height();
				maxHeight -= this.element.outerHeight() - this.element.height();
	
				this.element.siblings( ":visible" ).each( function() {
					var elem = $( this ),
						position = elem.css( "position" );
	
					if ( position === "absolute" || position === "fixed" ) {
						return;
					}
					maxHeight -= elem.outerHeight( true );
				} );
	
				this.element.children().not( this.panels ).each( function() {
					maxHeight -= $( this ).outerHeight( true );
				} );
	
				this.panels.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
					.css( "overflow", "auto" );
			} else if ( heightStyle === "auto" ) {
				maxHeight = 0;
				this.panels.each( function() {
					maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
				} ).height( maxHeight );
			}
		},
	
		_eventHandler: function( event ) {
			var options = this.options,
				active = this.active,
				anchor = $( event.currentTarget ),
				tab = anchor.closest( "li" ),
				clickedIsActive = tab[ 0 ] === active[ 0 ],
				collapsing = clickedIsActive && options.collapsible,
				toShow = collapsing ? $() : this._getPanelForTab( tab ),
				toHide = !active.length ? $() : this._getPanelForTab( active ),
				eventData = {
					oldTab: active,
					oldPanel: toHide,
					newTab: collapsing ? $() : tab,
					newPanel: toShow
				};
	
			event.preventDefault();
	
			if ( tab.hasClass( "ui-state-disabled" ) ||
	
					// tab is already loading
					tab.hasClass( "ui-tabs-loading" ) ||
	
					// can't switch durning an animation
					this.running ||
	
					// click on active header, but not collapsible
					( clickedIsActive && !options.collapsible ) ||
	
					// allow canceling activation
					( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
				return;
			}
	
			options.active = collapsing ? false : this.tabs.index( tab );
	
			this.active = clickedIsActive ? $() : tab;
			if ( this.xhr ) {
				this.xhr.abort();
			}
	
			if ( !toHide.length && !toShow.length ) {
				$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
			}
	
			if ( toShow.length ) {
				this.load( this.tabs.index( tab ), event );
			}
			this._toggle( event, eventData );
		},
	
		// Handles show/hide for selecting tabs
		_toggle: function( event, eventData ) {
			var that = this,
				toShow = eventData.newPanel,
				toHide = eventData.oldPanel;
	
			this.running = true;
	
			function complete() {
				that.running = false;
				that._trigger( "activate", event, eventData );
			}
	
			function show() {
				that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );
	
				if ( toShow.length && that.options.show ) {
					that._show( toShow, that.options.show, complete );
				} else {
					toShow.show();
					complete();
				}
			}
	
			// Start out by hiding, then showing, then completing
			if ( toHide.length && this.options.hide ) {
				this._hide( toHide, this.options.hide, function() {
					that._removeClass( eventData.oldTab.closest( "li" ),
						"ui-tabs-active", "ui-state-active" );
					show();
				} );
			} else {
				this._removeClass( eventData.oldTab.closest( "li" ),
					"ui-tabs-active", "ui-state-active" );
				toHide.hide();
				show();
			}
	
			toHide.attr( "aria-hidden", "true" );
			eventData.oldTab.attr( {
				"aria-selected": "false",
				"aria-expanded": "false"
			} );
	
			// If we're switching tabs, remove the old tab from the tab order.
			// If we're opening from collapsed state, remove the previous tab from the tab order.
			// If we're collapsing, then keep the collapsing tab in the tab order.
			if ( toShow.length && toHide.length ) {
				eventData.oldTab.attr( "tabIndex", -1 );
			} else if ( toShow.length ) {
				this.tabs.filter( function() {
					return $( this ).attr( "tabIndex" ) === 0;
				} )
					.attr( "tabIndex", -1 );
			}
	
			toShow.attr( "aria-hidden", "false" );
			eventData.newTab.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} );
		},
	
		_activate: function( index ) {
			var anchor,
				active = this._findActive( index );
	
			// Trying to activate the already active panel
			if ( active[ 0 ] === this.active[ 0 ] ) {
				return;
			}
	
			// Trying to collapse, simulate a click on the current active header
			if ( !active.length ) {
				active = this.active;
			}
	
			anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
			this._eventHandler( {
				target: anchor,
				currentTarget: anchor,
				preventDefault: $.noop
			} );
		},
	
		_findActive: function( index ) {
			return index === false ? $() : this.tabs.eq( index );
		},
	
		_getIndex: function( index ) {
	
			// meta-function to give users option to provide a href string instead of a numerical index.
			if ( typeof index === "string" ) {
				index = this.anchors.index( this.anchors.filter( "[href$='" +
					$.ui.escapeSelector( index ) + "']" ) );
			}
	
			return index;
		},
	
		_destroy: function() {
			if ( this.xhr ) {
				this.xhr.abort();
			}
	
			this.tablist
				.removeAttr( "role" )
				.off( this.eventNamespace );
	
			this.anchors
				.removeAttr( "role tabIndex" )
				.removeUniqueId();
	
			this.tabs.add( this.panels ).each( function() {
				if ( $.data( this, "ui-tabs-destroy" ) ) {
					$( this ).remove();
				} else {
					$( this ).removeAttr( "role tabIndex " +
						"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
				}
			} );
	
			this.tabs.each( function() {
				var li = $( this ),
					prev = li.data( "ui-tabs-aria-controls" );
				if ( prev ) {
					li
						.attr( "aria-controls", prev )
						.removeData( "ui-tabs-aria-controls" );
				} else {
					li.removeAttr( "aria-controls" );
				}
			} );
	
			this.panels.show();
	
			if ( this.options.heightStyle !== "content" ) {
				this.panels.css( "height", "" );
			}
		},
	
		enable: function( index ) {
			var disabled = this.options.disabled;
			if ( disabled === false ) {
				return;
			}
	
			if ( index === undefined ) {
				disabled = false;
			} else {
				index = this._getIndex( index );
				if ( $.isArray( disabled ) ) {
					disabled = $.map( disabled, function( num ) {
						return num !== index ? num : null;
					} );
				} else {
					disabled = $.map( this.tabs, function( li, num ) {
						return num !== index ? num : null;
					} );
				}
			}
			this._setOptionDisabled( disabled );
		},
	
		disable: function( index ) {
			var disabled = this.options.disabled;
			if ( disabled === true ) {
				return;
			}
	
			if ( index === undefined ) {
				disabled = true;
			} else {
				index = this._getIndex( index );
				if ( $.inArray( index, disabled ) !== -1 ) {
					return;
				}
				if ( $.isArray( disabled ) ) {
					disabled = $.merge( [ index ], disabled ).sort();
				} else {
					disabled = [ index ];
				}
			}
			this._setOptionDisabled( disabled );
		},
	
		load: function( index, event ) {
			index = this._getIndex( index );
			var that = this,
				tab = this.tabs.eq( index ),
				anchor = tab.find( ".ui-tabs-anchor" ),
				panel = this._getPanelForTab( tab ),
				eventData = {
					tab: tab,
					panel: panel
				},
				complete = function( jqXHR, status ) {
					if ( status === "abort" ) {
						that.panels.stop( false, true );
					}
	
					that._removeClass( tab, "ui-tabs-loading" );
					panel.removeAttr( "aria-busy" );
	
					if ( jqXHR === that.xhr ) {
						delete that.xhr;
					}
				};
	
			// Not remote
			if ( this._isLocal( anchor[ 0 ] ) ) {
				return;
			}
	
			this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );
	
			// Support: jQuery <1.8
			// jQuery <1.8 returns false if the request is canceled in beforeSend,
			// but as of 1.8, $.ajax() always returns a jqXHR object.
			if ( this.xhr && this.xhr.statusText !== "canceled" ) {
				this._addClass( tab, "ui-tabs-loading" );
				panel.attr( "aria-busy", "true" );
	
				this.xhr
					.done( function( response, status, jqXHR ) {
	
						// support: jQuery <1.8
						// http://bugs.jquery.com/ticket/11778
						setTimeout( function() {
							panel.html( response );
							that._trigger( "load", event, eventData );
	
							complete( jqXHR, status );
						}, 1 );
					} )
					.fail( function( jqXHR, status ) {
	
						// support: jQuery <1.8
						// http://bugs.jquery.com/ticket/11778
						setTimeout( function() {
							complete( jqXHR, status );
						}, 1 );
					} );
			}
		},
	
		_ajaxSettings: function( anchor, event, eventData ) {
			var that = this;
			return {
	
				// Support: IE <11 only
				// Strip any hash that exists to prevent errors with the Ajax request
				url: anchor.attr( "href" ).replace( /#.*$/, "" ),
				beforeSend: function( jqXHR, settings ) {
					return that._trigger( "beforeLoad", event,
						$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
				}
			};
		},
	
		_getPanelForTab: function( tab ) {
			var id = $( tab ).attr( "aria-controls" );
			return this.element.find( this._sanitizeSelector( "#" + id ) );
		}
	} );
	
	// DEPRECATED
	// TODO: Switch return back to widget declaration at top of file when this is removed
	if ( $.uiBackCompat !== false ) {
	
		// Backcompat for ui-tab class (now ui-tabs-tab)
		$.widget( "ui.tabs", $.ui.tabs, {
			_processTabs: function() {
				this._superApply( arguments );
				this._addClass( this.tabs, "ui-tab" );
			}
		} );
	}
	
	var widgetsTabs = $.ui.tabs;
	
	
	/*!
	 * jQuery UI Tooltip 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Tooltip
	//>>group: Widgets
	//>>description: Shows additional information for any element on hover or focus.
	//>>docs: http://api.jqueryui.com/tooltip/
	//>>demos: http://jqueryui.com/tooltip/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/tooltip.css
	//>>css.theme: ../../themes/base/theme.css
	
	
	
	$.widget( "ui.tooltip", {
		version: "1.12.1",
		options: {
			classes: {
				"ui-tooltip": "ui-corner-all ui-widget-shadow"
			},
			content: function() {
	
				// support: IE<9, Opera in jQuery <1.7
				// .text() can't accept undefined, so coerce to a string
				var title = $( this ).attr( "title" ) || "";
	
				// Escape title, since we're going from an attribute to raw HTML
				return $( "<a>" ).text( title ).html();
			},
			hide: true,
	
			// Disabled elements have inconsistent behavior across browsers (#8661)
			items: "[title]:not([disabled])",
			position: {
				my: "left top+15",
				at: "left bottom",
				collision: "flipfit flip"
			},
			show: true,
			track: false,
	
			// Callbacks
			close: null,
			open: null
		},
	
		_addDescribedBy: function( elem, id ) {
			var describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ );
			describedby.push( id );
			elem
				.data( "ui-tooltip-id", id )
				.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
		},
	
		_removeDescribedBy: function( elem ) {
			var id = elem.data( "ui-tooltip-id" ),
				describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ ),
				index = $.inArray( id, describedby );
	
			if ( index !== -1 ) {
				describedby.splice( index, 1 );
			}
	
			elem.removeData( "ui-tooltip-id" );
			describedby = $.trim( describedby.join( " " ) );
			if ( describedby ) {
				elem.attr( "aria-describedby", describedby );
			} else {
				elem.removeAttr( "aria-describedby" );
			}
		},
	
		_create: function() {
			this._on( {
				mouseover: "open",
				focusin: "open"
			} );
	
			// IDs of generated tooltips, needed for destroy
			this.tooltips = {};
	
			// IDs of parent tooltips where we removed the title attribute
			this.parents = {};
	
			// Append the aria-live region so tooltips announce correctly
			this.liveRegion = $( "<div>" )
				.attr( {
					role: "log",
					"aria-live": "assertive",
					"aria-relevant": "additions"
				} )
				.appendTo( this.document[ 0 ].body );
			this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );
	
			this.disabledTitles = $( [] );
		},
	
		_setOption: function( key, value ) {
			var that = this;
	
			this._super( key, value );
	
			if ( key === "content" ) {
				$.each( this.tooltips, function( id, tooltipData ) {
					that._updateContent( tooltipData.element );
				} );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this[ value ? "_disable" : "_enable" ]();
		},
	
		_disable: function() {
			var that = this;
	
			// Close open tooltips
			$.each( this.tooltips, function( id, tooltipData ) {
				var event = $.Event( "blur" );
				event.target = event.currentTarget = tooltipData.element[ 0 ];
				that.close( event, true );
			} );
	
			// Remove title attributes to prevent native tooltips
			this.disabledTitles = this.disabledTitles.add(
				this.element.find( this.options.items ).addBack()
					.filter( function() {
						var element = $( this );
						if ( element.is( "[title]" ) ) {
							return element
								.data( "ui-tooltip-title", element.attr( "title" ) )
								.removeAttr( "title" );
						}
					} )
			);
		},
	
		_enable: function() {
	
			// restore title attributes
			this.disabledTitles.each( function() {
				var element = $( this );
				if ( element.data( "ui-tooltip-title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
			} );
			this.disabledTitles = $( [] );
		},
	
		open: function( event ) {
			var that = this,
				target = $( event ? event.target : this.element )
	
					// we need closest here due to mouseover bubbling,
					// but always pointing at the same event target
					.closest( this.options.items );
	
			// No element to show a tooltip for or the tooltip is already open
			if ( !target.length || target.data( "ui-tooltip-id" ) ) {
				return;
			}
	
			if ( target.attr( "title" ) ) {
				target.data( "ui-tooltip-title", target.attr( "title" ) );
			}
	
			target.data( "ui-tooltip-open", true );
	
			// Kill parent tooltips, custom or native, for hover
			if ( event && event.type === "mouseover" ) {
				target.parents().each( function() {
					var parent = $( this ),
						blurEvent;
					if ( parent.data( "ui-tooltip-open" ) ) {
						blurEvent = $.Event( "blur" );
						blurEvent.target = blurEvent.currentTarget = this;
						that.close( blurEvent, true );
					}
					if ( parent.attr( "title" ) ) {
						parent.uniqueId();
						that.parents[ this.id ] = {
							element: this,
							title: parent.attr( "title" )
						};
						parent.attr( "title", "" );
					}
				} );
			}
	
			this._registerCloseHandlers( event, target );
			this._updateContent( target, event );
		},
	
		_updateContent: function( target, event ) {
			var content,
				contentOption = this.options.content,
				that = this,
				eventType = event ? event.type : null;
	
			if ( typeof contentOption === "string" || contentOption.nodeType ||
					contentOption.jquery ) {
				return this._open( event, target, contentOption );
			}
	
			content = contentOption.call( target[ 0 ], function( response ) {
	
				// IE may instantly serve a cached response for ajax requests
				// delay this call to _open so the other call to _open runs first
				that._delay( function() {
	
					// Ignore async response if tooltip was closed already
					if ( !target.data( "ui-tooltip-open" ) ) {
						return;
					}
	
					// JQuery creates a special event for focusin when it doesn't
					// exist natively. To improve performance, the native event
					// object is reused and the type is changed. Therefore, we can't
					// rely on the type being correct after the event finished
					// bubbling, so we set it back to the previous value. (#8740)
					if ( event ) {
						event.type = eventType;
					}
					this._open( event, target, response );
				} );
			} );
			if ( content ) {
				this._open( event, target, content );
			}
		},
	
		_open: function( event, target, content ) {
			var tooltipData, tooltip, delayedShow, a11yContent,
				positionOption = $.extend( {}, this.options.position );
	
			if ( !content ) {
				return;
			}
	
			// Content can be updated multiple times. If the tooltip already
			// exists, then just update the content and bail.
			tooltipData = this._find( target );
			if ( tooltipData ) {
				tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
				return;
			}
	
			// If we have a title, clear it to prevent the native tooltip
			// we have to check first to avoid defining a title if none exists
			// (we don't want to cause an element to start matching [title])
			//
			// We use removeAttr only for key events, to allow IE to export the correct
			// accessible attributes. For mouse events, set to empty string to avoid
			// native tooltip showing up (happens only when removing inside mouseover).
			if ( target.is( "[title]" ) ) {
				if ( event && event.type === "mouseover" ) {
					target.attr( "title", "" );
				} else {
					target.removeAttr( "title" );
				}
			}
	
			tooltipData = this._tooltip( target );
			tooltip = tooltipData.tooltip;
			this._addDescribedBy( target, tooltip.attr( "id" ) );
			tooltip.find( ".ui-tooltip-content" ).html( content );
	
			// Support: Voiceover on OS X, JAWS on IE <= 9
			// JAWS announces deletions even when aria-relevant="additions"
			// Voiceover will sometimes re-read the entire log region's contents from the beginning
			this.liveRegion.children().hide();
			a11yContent = $( "<div>" ).html( tooltip.find( ".ui-tooltip-content" ).html() );
			a11yContent.removeAttr( "name" ).find( "[name]" ).removeAttr( "name" );
			a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
			a11yContent.appendTo( this.liveRegion );
	
			function position( event ) {
				positionOption.of = event;
				if ( tooltip.is( ":hidden" ) ) {
					return;
				}
				tooltip.position( positionOption );
			}
			if ( this.options.track && event && /^mouse/.test( event.type ) ) {
				this._on( this.document, {
					mousemove: position
				} );
	
				// trigger once to override element-relative positioning
				position( event );
			} else {
				tooltip.position( $.extend( {
					of: target
				}, this.options.position ) );
			}
	
			tooltip.hide();
	
			this._show( tooltip, this.options.show );
	
			// Handle tracking tooltips that are shown with a delay (#8644). As soon
			// as the tooltip is visible, position the tooltip using the most recent
			// event.
			// Adds the check to add the timers only when both delay and track options are set (#14682)
			if ( this.options.track && this.options.show && this.options.show.delay ) {
				delayedShow = this.delayedShow = setInterval( function() {
					if ( tooltip.is( ":visible" ) ) {
						position( positionOption.of );
						clearInterval( delayedShow );
					}
				}, $.fx.interval );
			}
	
			this._trigger( "open", event, { tooltip: tooltip } );
		},
	
		_registerCloseHandlers: function( event, target ) {
			var events = {
				keyup: function( event ) {
					if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
						var fakeEvent = $.Event( event );
						fakeEvent.currentTarget = target[ 0 ];
						this.close( fakeEvent, true );
					}
				}
			};
	
			// Only bind remove handler for delegated targets. Non-delegated
			// tooltips will handle this in destroy.
			if ( target[ 0 ] !== this.element[ 0 ] ) {
				events.remove = function() {
					this._removeTooltip( this._find( target ).tooltip );
				};
			}
	
			if ( !event || event.type === "mouseover" ) {
				events.mouseleave = "close";
			}
			if ( !event || event.type === "focusin" ) {
				events.focusout = "close";
			}
			this._on( true, target, events );
		},
	
		close: function( event ) {
			var tooltip,
				that = this,
				target = $( event ? event.currentTarget : this.element ),
				tooltipData = this._find( target );
	
			// The tooltip may already be closed
			if ( !tooltipData ) {
	
				// We set ui-tooltip-open immediately upon open (in open()), but only set the
				// additional data once there's actually content to show (in _open()). So even if the
				// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
				// the period between open() and _open().
				target.removeData( "ui-tooltip-open" );
				return;
			}
	
			tooltip = tooltipData.tooltip;
	
			// Disabling closes the tooltip, so we need to track when we're closing
			// to avoid an infinite loop in case the tooltip becomes disabled on close
			if ( tooltipData.closing ) {
				return;
			}
	
			// Clear the interval for delayed tracking tooltips
			clearInterval( this.delayedShow );
	
			// Only set title if we had one before (see comment in _open())
			// If the title attribute has changed since open(), don't restore
			if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
				target.attr( "title", target.data( "ui-tooltip-title" ) );
			}
	
			this._removeDescribedBy( target );
	
			tooltipData.hiding = true;
			tooltip.stop( true );
			this._hide( tooltip, this.options.hide, function() {
				that._removeTooltip( $( this ) );
			} );
	
			target.removeData( "ui-tooltip-open" );
			this._off( target, "mouseleave focusout keyup" );
	
			// Remove 'remove' binding only on delegated targets
			if ( target[ 0 ] !== this.element[ 0 ] ) {
				this._off( target, "remove" );
			}
			this._off( this.document, "mousemove" );
	
			if ( event && event.type === "mouseleave" ) {
				$.each( this.parents, function( id, parent ) {
					$( parent.element ).attr( "title", parent.title );
					delete that.parents[ id ];
				} );
			}
	
			tooltipData.closing = true;
			this._trigger( "close", event, { tooltip: tooltip } );
			if ( !tooltipData.hiding ) {
				tooltipData.closing = false;
			}
		},
	
		_tooltip: function( element ) {
			var tooltip = $( "<div>" ).attr( "role", "tooltip" ),
				content = $( "<div>" ).appendTo( tooltip ),
				id = tooltip.uniqueId().attr( "id" );
	
			this._addClass( content, "ui-tooltip-content" );
			this._addClass( tooltip, "ui-tooltip", "ui-widget ui-widget-content" );
	
			tooltip.appendTo( this._appendTo( element ) );
	
			return this.tooltips[ id ] = {
				element: element,
				tooltip: tooltip
			};
		},
	
		_find: function( target ) {
			var id = target.data( "ui-tooltip-id" );
			return id ? this.tooltips[ id ] : null;
		},
	
		_removeTooltip: function( tooltip ) {
			tooltip.remove();
			delete this.tooltips[ tooltip.attr( "id" ) ];
		},
	
		_appendTo: function( target ) {
			var element = target.closest( ".ui-front, dialog" );
	
			if ( !element.length ) {
				element = this.document[ 0 ].body;
			}
	
			return element;
		},
	
		_destroy: function() {
			var that = this;
	
			// Close open tooltips
			$.each( this.tooltips, function( id, tooltipData ) {
	
				// Delegate to close method to handle common cleanup
				var event = $.Event( "blur" ),
					element = tooltipData.element;
				event.target = event.currentTarget = element[ 0 ];
				that.close( event, true );
	
				// Remove immediately; destroying an open tooltip doesn't use the
				// hide animation
				$( "#" + id ).remove();
	
				// Restore the title
				if ( element.data( "ui-tooltip-title" ) ) {
	
					// If the title attribute has changed since open(), don't restore
					if ( !element.attr( "title" ) ) {
						element.attr( "title", element.data( "ui-tooltip-title" ) );
					}
					element.removeData( "ui-tooltip-title" );
				}
			} );
			this.liveRegion.remove();
		}
	} );
	
	// DEPRECATED
	// TODO: Switch return back to widget declaration at top of file when this is removed
	if ( $.uiBackCompat !== false ) {
	
		// Backcompat for tooltipClass option
		$.widget( "ui.tooltip", $.ui.tooltip, {
			options: {
				tooltipClass: null
			},
			_tooltip: function() {
				var tooltipData = this._superApply( arguments );
				if ( this.options.tooltipClass ) {
					tooltipData.tooltip.addClass( this.options.tooltipClass );
				}
				return tooltipData;
			}
		} );
	}
	
	var widgetsTooltip = $.ui.tooltip;
	
	
	
	
	}));

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1190);
	module.exports = __webpack_require__(1196);
	__webpack_require__(1192);
	__webpack_require__(1195);
	__webpack_require__(1194);
	__webpack_require__(1193);

/***/ }),
/* 1190 */
1199,
/* 1191 */,
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7ad17c6085dee9a33787bac28fb23d46.eot";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "68ed1dac06bf0409c18ae7bc62889170.woff";

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e49d52e74b7689a0727def99da31f3eb.ttf";

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32941d6330044744c02493835b799e90.svg";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.1.1 (http://getbootstrap.com)
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 */
	
	if (typeof jQuery === 'undefined') { throw new Error('Bootstrap\'s JavaScript requires jQuery') }
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.1.1
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      'WebkitTransition' : 'webkitTransitionEnd',
	      'MozTransition'    : 'transitionend',
	      'OTransition'      : 'oTransitionEnd otransitionend',
	      'transition'       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false, $el = this
	    $(this).one($.support.transition.end, function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.1.1
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.hasClass('alert') ? $this : $this.parent()
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      $parent.trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one($.support.transition.end, removeElement)
	        .emulateTransitionEnd(150) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  var old = $.fn.alert
	
	  $.fn.alert = function (option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.1.1
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state = state + 'Text'
	
	    if (!data.resetText) $el.data('resetText', $el[val]())
	
	    $el[val](data[state] || this.options[state])
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked') && this.$element.hasClass('active')) changed = false
	        else $parent.find('.active').removeClass('active')
	      }
	      if (changed) $input.prop('checked', !this.$element.hasClass('active')).trigger('change')
	    }
	
	    if (changed) this.$element.toggleClass('active')
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  var old = $.fn.button
	
	  $.fn.button = function (option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document).on('click.bs.button.data-api', '[data-toggle^=button]', function (e) {
	    var $btn = $(e.target)
	    if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn')
	    $btn.button('toggle')
	    e.preventDefault()
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.1.1
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      =
	    this.sliding     =
	    this.interval    =
	    this.$active     =
	    this.$items      = null
	
	    this.options.pause == 'hover' && this.$element
	      .on('mouseenter', $.proxy(this.pause, this))
	      .on('mouseleave', $.proxy(this.cycle, this))
	  }
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true
	  }
	
	  Carousel.prototype.cycle =  function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getActiveIndex = function () {
	    this.$active = this.$element.find('.item.active')
	    this.$items  = this.$active.parent().children()
	
	    return this.$items.index(this.$active)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getActiveIndex()
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) })
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', $(this.$items[pos]))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || $active[type]()
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var fallback  = type == 'next' ? 'first' : 'last'
	    var that      = this
	
	    if (!$next.length) {
	      if (!this.options.wrap) return
	      $next = this.$element.find('.item')[fallback]()
	    }
	
	    if ($next.hasClass('active')) return this.sliding = false
	
	    var e = $.Event('slide.bs.carousel', { relatedTarget: $next[0], direction: direction })
	    this.$element.trigger(e)
	    if (e.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      this.$element.one('slid.bs.carousel', function () {
	        var $nextIndicator = $(that.$indicators.children()[that.getActiveIndex()])
	        $nextIndicator && $nextIndicator.addClass('active')
	      })
	    }
	
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one($.support.transition.end, function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () { that.$element.trigger('slid.bs.carousel') }, 0)
	        })
	        .emulateTransitionEnd($active.css('transition-duration').slice(0, -1) * 1000)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger('slid.bs.carousel')
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  var old = $.fn.carousel
	
	  $.fn.carousel = function (option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  $(document).on('click.bs.carousel.data-api', '[data-slide], [data-slide-to]', function (e) {
	    var $this   = $(this), href
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    $target.carousel(options)
	
	    if (slideIndex = $this.attr('data-slide-to')) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  })
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      $carousel.carousel($carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.1.1
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.transitioning = null
	
	    if (this.options.parent) this.$parent = $(this.options.parent)
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var actives = this.$parent && this.$parent.find('> .panel > .in')
	
	    if (actives && actives.length) {
	      var hasData = actives.data('bs.collapse')
	      if (hasData && hasData.transitioning) return
	      actives.collapse('hide')
	      hasData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')
	      [dimension](0)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')
	        [dimension]('auto')
	      this.transitioning = 0
	      this.$element.trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one($.support.transition.end, $.proxy(complete, this))
	      .emulateTransitionEnd(350)
	      [dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element
	      [dimension](this.$element[dimension]())
	      [0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse')
	      .removeClass('in')
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .trigger('hidden.bs.collapse')
	        .removeClass('collapsing')
	        .addClass('collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one($.support.transition.end, $.proxy(complete, this))
	      .emulateTransitionEnd(350)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  var old = $.fn.collapse
	
	  $.fn.collapse = function (option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && option == 'show') option = !option
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle=collapse]', function (e) {
	    var $this   = $(this), href
	    var target  = $this.attr('data-target')
	        || e.preventDefault()
	        || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
	    var $target = $(target)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	    var parent  = $this.attr('data-parent')
	    var $parent = parent && $(parent)
	
	    if (!data || !data.transitioning) {
	      if ($parent) $parent.find('[data-toggle=collapse][data-parent="' + parent + '"]').not($this).addClass('collapsed')
	      $this[$target.hasClass('in') ? 'addClass' : 'removeClass']('collapsed')
	    }
	
	    $target.collapse(option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.1.1
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle=dropdown]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $parent
	        .toggleClass('open')
	        .trigger('shown.bs.dropdown', relatedTarget)
	
	      $this.focus()
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27)/.test(e.keyCode)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive || (isActive && e.keyCode == 27)) {
	      if (e.which == 27) $parent.find(toggle).focus()
	      return $this.click()
	    }
	
	    var desc = ' li:not(.divider):visible a'
	    var $items = $parent.find('[role=menu]' + desc + ', [role=listbox]' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index($items.filter(':focus'))
	
	    if (e.keyCode == 38 && index > 0)                 index--                        // up
	    if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
	    if (!~index)                                      index = 0
	
	    $items.eq(index).focus()
	  }
	
	  function clearMenus(e) {
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $parent = getParent($(this))
	      var relatedTarget = { relatedTarget: this }
	      if (!$parent.hasClass('open')) return
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	      if (e.isDefaultPrevented()) return
	      $parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget)
	    })
	  }
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown = function (option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle + ', [role=menu], [role=listbox]', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.1.1
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options   = options
	    this.$element  = $(element)
	    this.$backdrop =
	    this.isShown   = null
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this[!this.isShown ? 'show' : 'hide'](_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.escape()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(document.body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element
	        .addClass('in')
	        .attr('aria-hidden', false)
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$element.find('.modal-dialog') // wait for modal to slide in
	          .one($.support.transition.end, function () {
	            that.$element.focus().trigger(e)
	          })
	          .emulateTransitionEnd(300) :
	        that.$element.focus().trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .attr('aria-hidden', true)
	      .off('click.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one($.support.transition.end, $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(300) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
	          this.$element.focus()
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keyup.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keyup.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.removeBackdrop()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
	        .appendTo(document.body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus.call(this.$element[0])
	          : this.hide.call(this)
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one($.support.transition.end, callback)
	          .emulateTransitionEnd(150) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one($.support.transition.end, callback)
	          .emulateTransitionEnd(150) :
	        callback()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  var old = $.fn.modal
	
	  $.fn.modal = function (option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target
	      .modal(option, this)
	      .one('hide', function () {
	        $this.is(':visible') && $this.focus()
	      })
	  })
	
	  $(document)
	    .on('show.bs.modal', '.modal', function () { $(document.body).addClass('modal-open') })
	    .on('hidden.bs.modal', '.modal', function () { $(document.body).removeClass('modal-open') })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.1.1
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       =
	    this.options    =
	    this.enabled    =
	    this.timeout    =
	    this.hoverState =
	    this.$element   = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled  = true
	    this.type     = type
	    this.$element = $(element)
	    this.options  = this.getOptions(options)
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	      var that = this;
	
	      var $tip = this.tip()
	
	      this.setContent()
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var $parent = this.$element.parent()
	
	        var orgPlacement = placement
	        var docScroll    = document.documentElement.scrollTop || document.body.scrollTop
	        var parentWidth  = this.options.container == 'body' ? window.innerWidth  : $parent.outerWidth()
	        var parentHeight = this.options.container == 'body' ? window.innerHeight : $parent.outerHeight()
	        var parentLeft   = this.options.container == 'body' ? 0 : $parent.offset().left
	
	        placement = placement == 'bottom' && pos.top   + pos.height  + actualHeight - docScroll > parentHeight  ? 'top'    :
	                    placement == 'top'    && pos.top   - docScroll   - actualHeight < 0                         ? 'bottom' :
	                    placement == 'right'  && pos.right + actualWidth > parentWidth                              ? 'left'   :
	                    placement == 'left'   && pos.left  - actualWidth < parentLeft                               ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	      this.hoverState = null
	
	      var complete = function() {
	        that.$element.trigger('shown.bs.' + that.type)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one($.support.transition.end, complete)
	          .emulateTransitionEnd(150) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var replace
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  = offset.top  + marginTop
	    offset.left = offset.left + marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      replace = true
	      offset.top = offset.top + height - actualHeight
	    }
	
	    if (/bottom|top/.test(placement)) {
	      var delta = 0
	
	      if (offset.left < 0) {
	        delta       = offset.left * -2
	        offset.left = 0
	
	        $tip.offset(offset)
	
	        actualWidth  = $tip[0].offsetWidth
	        actualHeight = $tip[0].offsetHeight
	      }
	
	      this.replaceArrow(delta - width + actualWidth, actualWidth, 'left')
	    } else {
	      this.replaceArrow(actualHeight - height, actualHeight, 'top')
	    }
	
	    if (replace) $tip.offset(offset)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, position) {
	    this.arrow().css(position, delta ? (50 * (1 - delta / dimension) + '%') : '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function () {
	    var that = this
	    var $tip = this.tip()
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      that.$element.trigger('hidden.bs.' + that.type)
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && this.$tip.hasClass('fade') ?
	      $tip
	        .one($.support.transition.end, complete)
	        .emulateTransitionEnd(150) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function () {
	    var el = this.$element[0]
	    return $.extend({}, (typeof el.getBoundingClientRect == 'function') ? el.getBoundingClientRect() : {
	      width: el.offsetWidth,
	      height: el.offsetHeight
	    }, this.$element.offset())
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2  } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2  } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width   }
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.tip = function () {
	    return this.$tip = this.$tip || $(this.options.template)
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow')
	  }
	
	  Tooltip.prototype.validate = function () {
	    if (!this.$element[0].parentNode) {
	      this.hide()
	      this.$element = null
	      this.options  = null
	    }
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = e ? $(e.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type) : this
	    self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	  }
	
	  Tooltip.prototype.destroy = function () {
	    clearTimeout(this.timeout)
	    this.hide().$element.off('.' + this.type).removeData('bs.' + this.type)
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip = function (option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && option == 'destroy') return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.1.1
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content')[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.arrow')
	  }
	
	  Popover.prototype.tip = function () {
	    if (!this.$tip) this.$tip = $(this.options.template)
	    return this.$tip
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  var old = $.fn.popover
	
	  $.fn.popover = function (option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && option == 'destroy') return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.1.1
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    var href
	    var process  = $.proxy(this.process, this)
	
	    this.$element       = $(element).is('body') ? $(window) : $(element)
	    this.$body          = $('body')
	    this.$scrollElement = this.$element.on('scroll.bs.scroll-spy.data-api', process)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target
	      || ((href = $(element).attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
	      || '') + ' .nav li > a'
	    this.offsets        = $([])
	    this.targets        = $([])
	    this.activeTarget   = null
	
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var offsetMethod = this.$element[0] == window ? 'offset' : 'position'
	
	    this.offsets = $([])
	    this.targets = $([])
	
	    var self     = this
	    var $targets = this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[ $href[offsetMethod]().top + (!$.isWindow(self.$scrollElement.get(0)) && self.$scrollElement.scrollTop()), href ]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        self.offsets.push(this[0])
	        self.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.$scrollElement[0].scrollHeight || this.$body[0].scrollHeight
	    var maxScroll    = scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets.last()[0]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop <= offsets[0]) {
	      return activeTarget != (i = targets[0]) && this.activate(i)
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (!offsets[i + 1] || scrollTop <= offsets[i + 1])
	        && this.activate( targets[i] )
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	
	    var selector = this.selector +
	        '[data-target="' + target + '"],' +
	        this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy = function (option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      $spy.scrollspy($spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.1.1
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    this.element = $(element)
	  }
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var previous = $ul.find('.active:last a')[0]
	    var e        = $.Event('show.bs.tab', {
	      relatedTarget: previous
	    })
	
	    $this.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.parent('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: previous
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && $active.hasClass('fade')
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	
	      element.addClass('active')
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu')) {
	        element.closest('li.dropdown').addClass('active')
	      }
	
	      callback && callback()
	    }
	
	    transition ?
	      $active
	        .one($.support.transition.end, next)
	        .emulateTransitionEnd(150) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  var old = $.fn.tab
	
	  $.fn.tab = function ( option ) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
	    e.preventDefault()
	    $(this).tab('show')
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.1.1
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2014 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	    this.$window = $(window)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      =
	    this.unpin        =
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.RESET = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$window.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var scrollHeight = $(document).height()
	    var scrollTop    = this.$window.scrollTop()
	    var position     = this.$element.offset()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	
	    if (this.affixed == 'top') position.top += scrollTop
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.unpin   != null && (scrollTop + this.unpin <= position.top) ? false :
	                offsetBottom != null && (position.top + this.$element.height() >= scrollHeight - offsetBottom) ? 'bottom' :
	                offsetTop    != null && (scrollTop <= offsetTop) ? 'top' : false
	
	    if (this.affixed === affix) return
	    if (this.unpin) this.$element.css('top', '')
	
	    var affixType = 'affix' + (affix ? '-' + affix : '')
	    var e         = $.Event(affixType + '.bs.affix')
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    this.affixed = affix
	    this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	    this.$element
	      .removeClass(Affix.RESET)
	      .addClass(affixType)
	      .trigger($.Event(affixType.replace('affix', 'affixed')))
	
	    if (affix == 'bottom') {
	      this.$element.offset({ top: scrollHeight - offsetBottom - this.$element.height() })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  var old = $.fn.affix
	
	  $.fn.affix = function (option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop)    data.offset.top    = data.offsetTop
	
	      $spy.affix(data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1202);

/***/ }),
/* 1202 */
1199,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1240);
	module.exports = __webpack_require__(1241);
	module.exports = __webpack_require__(1242);
	__webpack_require__(1243);

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.5.16
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/
	
	/*
	Commonjs package manager support (eg componentjs).
	*/
	
	
	"use strict";// NOTE: textAngularVersion must match the Gruntfile.js 'setVersion' task.... and have format v/d+./d+./d+
	var textAngularVersion = 'v1.5.16';   // This is automatically updated during the build process to the current release!
	
	
	// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
	// We need this as IE sometimes plays funny tricks with the contenteditable.
	// ----------------------------------------------------------
	// If you're not in IE (or IE version is less than 5) then:
	// ie === undefined
	// If you're in IE (>=5) then you can determine which version:
	// ie === 7; // IE7
	// Thus, to detect IE:
	// if (ie) {}
	// And to detect the version:
	// ie === 6 // IE6
	// ie > 7 // IE8, IE9, IE10 ...
	// ie < 9 // Anything less than IE9
	// ----------------------------------------------------------
	/* istanbul ignore next: untestable browser check */
	var _browserDetect = {
		ie: (function(){
			var undef,
				v = 3,
				div = document.createElement('div'),
				all = div.getElementsByTagName('i');
	
			while (
				div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
				all[0]
			);
	
			return v > 4 ? v : undef;
		}()),
		webkit: /AppleWebKit\/([\d.]+)/i.test(navigator.userAgent),
		isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1
	};
	
	// Global to textAngular to measure performance where needed
	/* istanbul ignore next: untestable browser check */
	var performance = performance || {};
	/* istanbul ignore next: untestable browser check */
	performance.now = (function() {
		return performance.now       ||
			performance.mozNow    ||
			performance.msNow     ||
			performance.oNow      ||
			performance.webkitNow ||
			function() { return new Date().getTime(); };
	})();
	// usage is:
	// var t0 = performance.now();
	// doSomething();
	// var t1 = performance.now();
	// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to do something!');
	//
	
	// turn html into pure text that shows visiblity
	function stripHtmlToText(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		var res = tmp.textContent || tmp.innerText || '';
		res.replace('\u200B', ''); // zero width space
		res = res.trim();
		return res;
	}
	// get html
	function getDomFromHtml(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp;
	}
	
	
	// Global to textAngular REGEXP vars for block and list elements.
	
	var BLOCKELEMENTS = /^(address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;
	var LISTELEMENTS = /^(ul|li|ol)$/i;
	// updated VALIDELEMENTS to include #text and span so that we can use nodeName instead of tagName
	var VALIDELEMENTS = /^(#text|span|address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;
	
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
	/* istanbul ignore next: trim shim for older browsers */
	if (!String.prototype.trim) {
		String.prototype.trim = function () {
			return this.replace(/^\s+|\s+$/g, '');
		};
	}
	
	/*
		Custom stylesheet for the placeholders rules.
		Credit to: http://davidwalsh.name/add-rules-stylesheets
	*/
	var sheet, addCSSRule, removeCSSRule, _addCSSRule, _removeCSSRule, _getRuleIndex;
	/* istanbul ignore else: IE <8 test*/
	if(_browserDetect.ie > 8 || _browserDetect.ie === undefined){
		var _sheets = document.styleSheets;
		/* istanbul ignore next: preference for stylesheet loaded externally */
		for(var i = 0; i < _sheets.length; i++){
			if(_sheets[i].media.length === 0 || _sheets[i].media.mediaText.match(/(all|screen)/ig)){
				if(_sheets[i].href){
					if(_sheets[i].href.match(/textangular\.(min\.|)css/ig)){
						sheet = _sheets[i];
						break;
					}
				}
			}
		}
		/* istanbul ignore next: preference for stylesheet loaded externally */
		if(!sheet){
			// this sheet is used for the placeholders later on.
			sheet = (function() {
				// Create the <style> tag
				var style = document.createElement("style");
				/* istanbul ignore else : WebKit hack :( */
				if(_browserDetect.webkit) style.appendChild(document.createTextNode(""));
	
				// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
				document.getElementsByTagName('head')[0].appendChild(style);
	
				return style.sheet;
			})();
		}
	
		// use as: addCSSRule("header", "float: left");
		addCSSRule = function(selector, rules) {
			return _addCSSRule(sheet, selector, rules);
		};
		_addCSSRule = function(_sheet, selector, rules){
			var insertIndex;
			var insertedRule;
			// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
			/* istanbul ignore next: browser catches */
			if(_sheet.cssRules) insertIndex = Math.max(_sheet.cssRules.length - 1, 0);
			else if(_sheet.rules) insertIndex = Math.max(_sheet.rules.length - 1, 0);
	
			/* istanbul ignore else: untestable IE option */
			if(_sheet.insertRule) {
				_sheet.insertRule(selector + "{" + rules + "}", insertIndex);
			}
			else {
				_sheet.addRule(selector, rules, insertIndex);
			}
			/* istanbul ignore next: browser catches */
			if(sheet.rules) insertedRule = sheet.rules[insertIndex];
			else if(sheet.cssRules) insertedRule = sheet.cssRules[insertIndex];
			// return the inserted stylesheet rule
			return insertedRule;
		};
	
		_getRuleIndex = function(rule, rules) {
			var i, ruleIndex;
			for (i=0; i < rules.length; i++) {
				/* istanbul ignore else: check for correct rule */
				if (rules[i].cssText === rule.cssText) {
					ruleIndex = i;
					break;
				}
			}
			return ruleIndex;
		};
	
		removeCSSRule = function(rule){
			_removeCSSRule(sheet, rule);
		};
		/* istanbul ignore next: tests are browser specific */
		_removeCSSRule = function(sheet, rule){
			var rules = sheet.cssRules || sheet.rules;
			if(!rules || rules.length === 0) return;
			var ruleIndex = _getRuleIndex(rule, rules);
			if(sheet.removeRule){
				sheet.removeRule(ruleIndex);
			}else{
				sheet.deleteRule(ruleIndex);
			}
		};
	}
	
	angular.module('textAngular.factories', [])
	.factory('taBrowserTag', [function(){
	    return function(tag){
	        /* istanbul ignore next: ie specific test */
	        if(!tag) return (_browserDetect.ie <= 8)? 'P' : 'p';
	        else if(tag === '') return (_browserDetect.ie === undefined)? 'div' : (_browserDetect.ie <= 8)? 'P' : 'p';
	        else return (_browserDetect.ie <= 8)? tag.toUpperCase() : tag;
	    };
	}]).factory('taApplyCustomRenderers', ['taCustomRenderers', 'taDOM', function(taCustomRenderers, taDOM){
	    return function(val){
	        var element = angular.element('<div></div>');
	        element[0].innerHTML = val;
	
	        angular.forEach(taCustomRenderers, function(renderer){
	            var elements = [];
	            // get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
	            if(renderer.selector && renderer.selector !== '')
	                elements = element.find(renderer.selector);
	            /* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
	            else if(renderer.customAttribute && renderer.customAttribute !== '')
	                elements = taDOM.getByAttribute(element, renderer.customAttribute);
	            // process elements if any found
	            angular.forEach(elements, function(_element){
	                _element = angular.element(_element);
	                if(renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== ''){
	                    if(_element.attr(renderer.customAttribute) !== undefined) renderer.renderLogic(_element);
	                } else renderer.renderLogic(_element);
	            });
	        });
	
	        return element[0].innerHTML;
	    };
	}]).factory('taFixChrome', function(){
	    // get whaterever rubbish is inserted in chrome
	    // should be passed an html string, returns an html string
	    var taFixChrome = function(html, keepStyles){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // grab all elements with a style attibute
	        // a betterSpanMatch matches only a style=... with matching quotes
	        // this captures the whole:
	        // 'style="background-color: rgb(255, 255, 255);"'
	        var betterSpanMatch = /style\s?=\s?(["'])(?:(?=(\\?))\2.)*?\1/ig;
	        // where the original spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        // captures too much and includes the front tag!
	        var spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        var appleConvertedSpaceMatch = /<span class="Apple-converted-space">([^<]+)<\/span>/ig;
	        var match, styleVal, appleSpaceVal, newTag, finalHtml = '', lastIndex = 0;
	        // remove all the Apple-converted-space spans and replace with the content of the span
	        //console.log('before:', html);
	        /* istanbul ignore next: apple-contereted-space span match */
	        while(match = appleConvertedSpaceMatch.exec(html)){
	            appleSpaceVal = match[1];
	            appleSpaceVal = appleSpaceVal.replace(/&nbsp;/ig, ' ');
	            finalHtml += html.substring(lastIndex, match.index) + appleSpaceVal;
	            lastIndex = match.index + match[0].length;
	        }
	        /* istanbul ignore next: apple-contereted-space span has matched */
	        if (lastIndex) {
	            // modified....
	            finalHtml += html.substring(lastIndex);
	            html=finalHtml;
	            finalHtml='';
	            lastIndex=0;
	        }
	        /////////////////////////////////////////////////////////////
	        //
	        // Allow control of this modification
	        // taKeepStyles: False - removes these modification
	        //
	        // taFixChrome removes the following styles:
	        //    font-family: inherit;
	        //    line-height: <number>
	        //    color: inherit;
	        //    color: rgb( <rgb-component>#{3} )
	        //    background-color: rgb( <rgb-component>#{3} )
	        //
	        /////////////////////////////////////////////////////////////
	        if (!keepStyles) {
	            while (match = betterSpanMatch.exec(html)) {
	                finalHtml += html.substring(lastIndex, match.index-1);
	                styleVal = match[0];
	                // test for chrome inserted junk
	                match = /font-family: inherit;|line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;|color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/gi.exec(styleVal);
	                if (match) {
	                    styleVal = styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;|( |)color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|( |)background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/ig, '');
	                    //console.log(styleVal, styleVal.length);
	                    if (styleVal.length > 8) {
	                        finalHtml += ' ' + styleVal;
	                    }
	                } else {
	                    finalHtml += ' ' + styleVal;
	                }
	                lastIndex = betterSpanMatch.lastIndex;
	            }
	            finalHtml += html.substring(lastIndex);
	        }
	        //console.log('final:', finalHtml);
	        // only replace when something has changed, else we get focus problems on inserting lists
	        if(lastIndex > 0){
	            // replace all empty strings
	            var fe = finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig, '$1');
	            return fe;
	        } else return html;
	    };
	    return taFixChrome;
	}).factory('taSanitize', ['$sanitize', function taSanitizeFactory($sanitize){
	
	    var convert_infos = [
	        {
	            property: 'font-weight',
	            values: [ 'bold' ],
	            tag: 'b'
	        },
	        {
	            property: 'font-style',
	            values: [ 'italic' ],
	            tag: 'i'
	        }
	    ];
	
	    var styleMatch = [];
	    for(var i = 0; i < convert_infos.length; i++){
	        var _partialStyle = '(' + convert_infos[i].property + ':\\s*(';
	        for(var j = 0; j < convert_infos[i].values.length; j++){
	            /* istanbul ignore next: not needed to be tested yet */
	            if(j > 0) _partialStyle += '|';
	            _partialStyle += convert_infos[i].values[j];
	        }
	        _partialStyle += ');)';
	        styleMatch.push(_partialStyle);
	    }
	    var styleRegexString = '(' + styleMatch.join('|') + ')';
	
	    function wrapNested(html, wrapTag) {
	        var depth = 0;
	        var lastIndex = 0;
	        var match;
	        var tagRegex = /<[^>]*>/ig;
	        while(match = tagRegex.exec(html)){
	            lastIndex = match.index;
	            if(match[0].substr(1, 1) === '/'){
	                if(depth === 0) break;
	                else depth--;
	            }else depth++;
	        }
	        return wrapTag +
	            html.substring(0, lastIndex) +
	            // get the start tags reversed - this is safe as we construct the strings with no content except the tags
	            angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length) +
	            html.substring(lastIndex);
	    }
	
	    function transformLegacyStyles(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        var i;
	        var styleElementMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, subMatch, styleVal, newTag, lastNewTag = '', newHtml, finalHtml = '', lastIndex = 0;
	        while(match = styleElementMatch.exec(html)){
	            // one of the quoted values ' or "
	            /* istanbul ignore next: quotations match */
	            styleVal = match[3] || match[4];
	            var styleRegex = new RegExp(styleRegexString, 'i');
	            // test for style values to change
	            if(angular.isString(styleVal) && styleRegex.test(styleVal)){
	                // remove build tag list
	                newTag = '';
	                // init regex here for exec
	                var styleRegexExec = new RegExp(styleRegexString, 'ig');
	                // find relevand tags and build a string of them
	                while(subMatch = styleRegexExec.exec(styleVal)){
	                    for(i = 0; i < convert_infos.length; i++){
	                        if(!!subMatch[(i*2) + 2]){
	                            newTag += '<' + convert_infos[i].tag + '>';
	                        }
	                    }
	                }
	                // recursively find more legacy styles in html before this tag and after the previous match (if any)
	                newHtml = transformLegacyStyles(html.substring(lastIndex, match.index));
	                // build up html
	                if(lastNewTag.length > 0){
	                    finalHtml += wrapNested(newHtml, lastNewTag);
	                }else finalHtml += newHtml;
	                // grab the style val without the transformed values
	                styleVal = styleVal.replace(new RegExp(styleRegexString, 'ig'), '');
	                // build the html tag
	                finalHtml += '<' + match[1].trim();
	                if(styleVal.length > 0) finalHtml += ' style="' + styleVal + '"';
	                finalHtml += match[5] + '>';
	                // update the start index to after this tag
	                lastIndex = match.index + match[0].length;
	                lastNewTag = newTag;
	            }
	        }
	        if(lastNewTag.length > 0){
	            finalHtml += wrapNested(html.substring(lastIndex), lastNewTag);
	        }
	        else finalHtml += html.substring(lastIndex);
	        return finalHtml;
	    }
	
	    function transformLegacyAttributes(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // replace all align='...' tags with text-align attributes
	        var attrElementMatch = /<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, finalHtml = '', lastIndex = 0;
	        // match all attr tags
	        while(match = attrElementMatch.exec(html)){
	            // add all html before this tag
	            finalHtml += html.substring(lastIndex, match.index);
	            // record last index after this tag
	            lastIndex = match.index + match[0].length;
	            // construct tag without the align attribute
	            var newTag = '<' + match[1] + match[5];
	            // add the style attribute
	            if(/style=("([^"]+)"|'([^']+)')/ig.test(newTag)){
	                /* istanbul ignore next: quotations match */
	                newTag = newTag.replace(/style=("([^"]+)"|'([^']+)')/i, 'style="$2$3 text-align:' + (match[3] || match[4]) + ';"');
	            }else{
	                /* istanbul ignore next: quotations match */
	                newTag += ' style="text-align:' + (match[3] || match[4]) + ';"';
	            }
	            newTag += '>';
	            // add to html
	            finalHtml += newTag;
	        }
	        // return with remaining html
	        return finalHtml + html.substring(lastIndex);
	    }
	
	    // use precompiled regexp for speed
	    var rsb1 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	    var rsb2 = new RegExp(/<span class="rangySelectionBoundary" id="selectionBoundary_\d+_\d+">[^<>]+?<\/span>/ig);
	    var rsb3 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	
	    return function taSanitize(unsafe, oldsafe, ignore){
	        // unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
	        if ( !ignore ) {
	            try {
	                unsafe = transformLegacyStyles(unsafe);
	            } catch (e) {
	            }
	        }
	
	        // unsafe and oldsafe should be valid HTML strings
	        // any exceptions (lets say, color for example) should be made here but with great care
	        // setup unsafe element for modification
	        unsafe = transformLegacyAttributes(unsafe);
	
	        // we had an issue in the past, where we dumped a whole bunch of <span>'s into the content...
	        // so we remove them here
	        // IN A FUTURE release this can be removed after all have updated through release 1.5.9
	        if (unsafe) {
	            try {
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb2, '');
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb3, '');
	            } catch (e) {
	            }
	        }
	
	        var safe;
	        try {
	            safe = $sanitize(unsafe);
	            // do this afterwards, then the $sanitizer should still throw for bad markup
	            if(ignore) safe = unsafe;
	        } catch (e){
	            safe = oldsafe || '';
	        }
	
	        // Do processing for <pre> tags, removing tabs and return carriages outside of them
	
	        var _preTags = safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);
	        var processedSafe = safe.replace(/(&#(9|10);)*/ig, '');
	        var re = /<pre[^>]*>.*?<\/pre[^>]*>/ig;
	        var index = 0;
	        var lastIndex = 0;
	        var origTag;
	        safe = '';
	        while((origTag = re.exec(processedSafe)) !== null && index < _preTags.length){
	            safe += processedSafe.substring(lastIndex, origTag.index) + _preTags[index];
	            lastIndex = origTag.index + origTag[0].length;
	            index++;
	        }
	        return safe + processedSafe.substring(lastIndex);
	    };
	}]).factory('taToolExecuteAction', ['$q', '$log', function($q, $log){
	    // this must be called on a toolScope or instance
	    return function(editor){
	        if(editor !== undefined) this.$editor = function(){ return editor; };
	        var deferred = $q.defer(),
	            promise = deferred.promise,
	            _editor = this.$editor();
	        // pass into the action the deferred function and also the function to reload the current selection if rangy available
	        var result;
	        try{
	            result = this.action(deferred, _editor.startAction());
	            // We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
	            promise['finally'](function(){
	                _editor.endAction.call(_editor);
	            });
	        }catch(exc){
	            $log.error(exc);
	        }
	        if(result || result === undefined){
	            // if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
	            deferred.resolve();
	        }
	    };
	}]);
	
	angular.module('textAngular.DOM', ['textAngular.factories'])
	.factory('taExecCommand', ['taSelection', 'taBrowserTag', '$document', function(taSelection, taBrowserTag, $document){
	    var listToDefault = function(listElement, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements and convert to taDefaultWrap tags
	        var children = listElement.find('li');
	        for(i = children.length - 1; i >= 0; i--){
	            $target = angular.element('<' + defaultWrap + '>' + children[i].innerHTML + '</' + defaultWrap + '>');
	            listElement.after($target);
	        }
	        listElement.remove();
	        taSelection.setSelectionToElementEnd($target[0]);
	    };
	    var listElementToSelfTag = function(list, listElement, selfTag, bDefault, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements
	        var priorElement;
	        var nextElement;
	        var children = list.find('li');
	        var foundIndex;
	        for (i = 0; i<children.length; i++) {
	            if (children[i].outerHTML === listElement[0].outerHTML) {
	                // found it...
	                foundIndex = i;
	                if (i>0) {
	                    priorElement = children[i-1];
	                }
	                if (i+1<children.length) {
	                    nextElement = children[i+1];
	                }
	                break;
	            }
	        }
	        //console.log('listElementToSelfTag', list, listElement, selfTag, bDefault, priorElement, nextElement);
	        // un-list the listElement
	        var html = '';
	        if (bDefault) {
	            html += '<' + defaultWrap + '>' + listElement[0].innerHTML + '</' + defaultWrap + '>';
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            html += '<li>' + listElement[0].innerHTML + '</li>';
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        //console.log('$target', $target[0]);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            listElement.remove();
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!nextElement) {
	            // this is the last in the list, so we just remove it..
	            listElement.remove();
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	        } else {
	            var p = list.parent();
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndex; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndex+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            //console.log(html1, $target[0], html2);
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******XXX*****', p[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var listElementsToSelfTag = function(list, listElements, selfTag, bDefault, defaultWrap){
	        var $target, i, j, p;
	        // grab all li elements
	        var priorElement;
	        var afterElement;
	        //console.log('list:', list, 'listElements:', listElements, 'selfTag:', selfTag, 'bDefault:', bDefault);
	        var children = list.find('li');
	        var foundIndexes = [];
	        for (i = 0; i<children.length; i++) {
	            for (j = 0; j<listElements.length; j++) {
	                if (children[i].isEqualNode(listElements[j])) {
	                    // found it...
	                    foundIndexes[j] = i;
	                }
	            }
	        }
	        if (foundIndexes[0] > 0) {
	            priorElement = children[foundIndexes[0] - 1];
	        }
	        if (foundIndexes[listElements.length-1] + 1 < children.length) {
	            afterElement = children[foundIndexes[listElements.length-1] + 1];
	        }
	        //console.log('listElementsToSelfTag', list, listElements, selfTag, bDefault, !priorElement, !afterElement, foundIndexes[listElements.length-1], children.length);
	        // un-list the listElements
	        var html = '';
	        if (bDefault) {
	            for (j = 0; j < listElements.length; j++) {
	                html += '<' + defaultWrap + '>' + listElements[j].innerHTML + '</' + defaultWrap + '>';
	                listElements[j].remove();
	            }
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            for (j = 0; j < listElements.length; j++) {
	                html += listElements[j].outerHTML;
	                listElements[j].remove();
	            }
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!afterElement) {
	            // this is the last in the list, so we just remove it..
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else {
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndexes[0]; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndexes[listElements.length-1]+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******YYY*****', list.parent()[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var selectLi = function(liElement){
	        if(/(<br(|\/)>)$/i.test(liElement.innerHTML.trim())) taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);
	        else taSelection.setSelectionToElementEnd(liElement);
	    };
	    var listToList = function(listElement, newListTag){
	        var $target = angular.element('<' + newListTag + '>' + listElement[0].innerHTML + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var childElementsToList = function(elements, listElement, newListTag){
	        var html = '';
	        for(var i = 0; i < elements.length; i++){
	            html += '<' + taBrowserTag('li') + '>' + elements[i].innerHTML + '</' + taBrowserTag('li') + '>';
	        }
	        var $target = angular.element('<' + newListTag + '>' + html + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var turnBlockIntoBlocks = function(element, options) {
	        for(var i = 0; i<element.childNodes.length; i++) {
	            var _n = element.childNodes[i];
	            /* istanbul ignore next - more complex testing*/
	            if (_n.tagName && _n.tagName.match(BLOCKELEMENTS)) {
	                turnBlockIntoBlocks(_n, options);
	            }
	        }
	        /* istanbul ignore next - very rare condition that we do not test*/
	        if (element.parentNode === null) {
	            // nothing left to do..
	            return element;
	        }
	        /* istanbul ignore next - not sure have to test this */
	        if (options === '<br>'){
	            return element;
	        }
	        else {
	            var $target = angular.element(options);
	            $target[0].innerHTML = element.innerHTML;
	            element.parentNode.insertBefore($target[0], element);
	            element.parentNode.removeChild(element);
	            return $target;
	        }
	    };
	    return function(taDefaultWrap, topNode){
	        // NOTE: here we are dealing with the html directly from the browser and not the html the user sees.
	        // IF you want to modify the html the user sees, do it when the user does a switchView
	        taDefaultWrap = taBrowserTag(taDefaultWrap);
	        return function(command, showUI, options, defaultTagAttributes){
	            var i, $target, html, _nodes, next, optionsTagName, selectedElement, ourSelection;
	            var defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	            try{
	                if (taSelection.getSelection) {
	                    ourSelection = taSelection.getSelection();
	                }
	                selectedElement = taSelection.getSelectionElement();
	                // special checks and fixes when we are selecting the whole container
	                var __h, _innerNode;
	                /* istanbul ignore next */
	                if (selectedElement.tagName !== undefined) {
	                    if (selectedElement.tagName.toLowerCase() === 'div' &&
	                        /taTextElement.+/.test(selectedElement.id) &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // opps we are actually selecting the whole container!
	                        //console.log('selecting whole container!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner whole container', selectedElement.childNodes);
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                    } else if (selectedElement.tagName.toLowerCase() === 'span' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // just a span -- this is a problem...
	                        //console.log('selecting span!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner span', selectedElement.childNodes);
	                        // we wrap this in a <div> because otherwise the browser get confused when we attempt to select the whole node
	                        // and the focus is not set correctly no matter what we do
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                        //console.log(selectedElement.innerHTML);
	                    } else if (selectedElement.tagName.toLowerCase() === 'p' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        //console.log('p special');
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                            selectedElement.innerHTML = __h;
	                        }
	                    } else if (selectedElement.tagName.toLowerCase() === 'li' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === ourSelection.end.offset) {
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '');  // nothing
	                            selectedElement.innerHTML = __h;
	                        }
	                    }
	                }
	            }catch(e){}
	            //console.log('************** selectedElement:', selectedElement);
	            /* istanbul ignore if: */
	            if (!selectedElement){return;}
	            var $selected = angular.element(selectedElement);
	            var tagName = (selectedElement && selectedElement.tagName && selectedElement.tagName.toLowerCase()) ||
	                /* istanbul ignore next: */ "";
	            if(command.toLowerCase() === 'insertorderedlist' || command.toLowerCase() === 'insertunorderedlist'){
	                var selfTag = taBrowserTag((command.toLowerCase() === 'insertorderedlist')? 'ol' : 'ul');
	                var selectedElements = taSelection.getOnlySelectedElements();
	                //console.log('PPPPPPPPPPPPP', tagName, selfTag, selectedElements, tagName.match(BLOCKELEMENTS), $selected.hasClass('ta-bind'), $selected.parent()[0].tagName);
	                if (selectedElements.length>1 && (tagName === 'ol' ||  tagName === 'ul' )) {
	                    return listElementsToSelfTag($selected, selectedElements, selfTag, selfTag===tagName, taDefaultWrap);
	                }
	                if(tagName === selfTag){
	                    // if all selected then we should remove the list
	                    // grab all li elements and convert to taDefaultWrap tags
	                    //console.log('tagName===selfTag');
	                    if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                        $selected = angular.element(selectedElements[0]);
	                        return listElementToSelfTag($selected.parent(), $selected, selfTag, true, taDefaultWrap);
	                    } else {
	                        return listToDefault($selected, taDefaultWrap);
	                    }
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() === selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToDefault($selected.parent(), taDefaultWrap);
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() !== selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToList($selected.parent(), selfTag);
	                }else if(tagName.match(BLOCKELEMENTS) && !$selected.hasClass('ta-bind')){
	                    // if it's one of those block elements we have to change the contents
	                    // if it's a ol/ul we are changing from one to the other
	                    if (selectedElements.length) {
	                        if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                            //console.log('&&&&&&&&&&&&&&& --------- &&&&&&&&&&&&&&&&', selectedElements[0], $selected[0].childNodes);
	                            $selected = angular.element(selectedElements[0]);
	                            return listElementToSelfTag($selected.parent(), $selected, selfTag, selfTag===tagName, taDefaultWrap);
	                        }
	                    }
	                    if(tagName === 'ol' || tagName === 'ul'){
	                        // now if this is a set of selected elements... behave diferently
	                        return listToList($selected, selfTag);
	                    }else{
	                        var childBlockElements = false;
	                        angular.forEach($selected.children(), function(elem){
	                            if(elem.tagName.match(BLOCKELEMENTS)) {
	                                childBlockElements = true;
	                            }
	                        });
	                        if(childBlockElements){
	                            return childElementsToList($selected.children(), $selected, selfTag);
	                        }else{
	                            return childElementsToList([angular.element('<div>' + selectedElement.innerHTML + '</div>')[0]], $selected, selfTag);
	                        }
	                    }
	                }else if(tagName.match(BLOCKELEMENTS)){
	                    // if we get here then the contents of the ta-bind are selected
	                    _nodes = taSelection.getOnlySelectedElements();
	                    //console.log('_nodes', _nodes, tagName);
	                    if(_nodes.length === 0){
	                        // here is if there is only text in ta-bind ie <div ta-bind>test content</div>
	                        $target = angular.element('<' + selfTag + '><li>' + selectedElement.innerHTML + '</li></' + selfTag + '>');
	                        $selected.html('');
	                        $selected.append($target);
	                    }else if(_nodes.length === 1 && (_nodes[0].tagName.toLowerCase() === 'ol' || _nodes[0].tagName.toLowerCase() === 'ul')){
	                        if(_nodes[0].tagName.toLowerCase() === selfTag){
	                            // remove
	                            return listToDefault(angular.element(_nodes[0]), taDefaultWrap);
	                        }else{
	                            return listToList(angular.element(_nodes[0]), selfTag);
	                        }
	                    }else{
	                        html = '';
	                        var $nodes = [];
	                        for(i = 0; i < _nodes.length; i++){
	                            /* istanbul ignore else: catch for real-world can't make it occur in testing */
	                            if(_nodes[i].nodeType !== 3){
	                                var $n = angular.element(_nodes[i]);
	                                /* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
	                                if(_nodes[i].tagName.toLowerCase() === 'li') continue;
	                                else if(_nodes[i].tagName.toLowerCase() === 'ol' || _nodes[i].tagName.toLowerCase() === 'ul'){
	                                    html += $n[0].innerHTML; // if it's a list, add all it's children
	                                }else if(_nodes[i].tagName.toLowerCase() === 'span' && (_nodes[i].childNodes[0].tagName.toLowerCase() === 'ol' || _nodes[i].childNodes[0].tagName.toLowerCase() === 'ul')){
	                                    html += $n[0].childNodes[0].innerHTML; // if it's a list, add all it's children
	                                }else{
	                                    html += '<' + taBrowserTag('li') + '>' + $n[0].innerHTML + '</' + taBrowserTag('li') + '>';
	                                }
	                                $nodes.unshift($n);
	                            }
	                        }
	                        //console.log('$nodes', $nodes);
	                        $target = angular.element('<' + selfTag + '>' + html + '</' + selfTag + '>');
	                        $nodes.pop().replaceWith($target);
	                        angular.forEach($nodes, function($node){ $node.remove(); });
	                    }
	                    taSelection.setSelectionToElementEnd($target[0]);
	                    return;
	                }
	            }else if(command.toLowerCase() === 'formatblock'){
	                optionsTagName = options.toLowerCase().replace(/[<>]/ig, '');
	                if(optionsTagName.trim() === 'default') {
	                    optionsTagName = taDefaultWrap;
	                    options = '<' + taDefaultWrap + '>';
	                }
	                if(tagName === 'li') {
	                    $target = $selected.parent();
	                }
	                else {
	                    $target = $selected;
	                }
	                // find the first blockElement
	                while(!$target[0].tagName || !$target[0].tagName.match(BLOCKELEMENTS) && !$target.parent().attr('contenteditable')){
	                    $target = $target.parent();
	                    /* istanbul ignore next */
	                    tagName = ($target[0].tagName || '').toLowerCase();
	                }
	                if(tagName === optionsTagName){
	                    // $target is wrap element
	                    _nodes = $target.children();
	                    var hasBlock = false;
	                    for(i = 0; i < _nodes.length; i++){
	                        hasBlock = hasBlock || _nodes[i].tagName.match(BLOCKELEMENTS);
	                    }
	                    if(hasBlock){
	                        $target.after(_nodes);
	                        next = $target.next();
	                        $target.remove();
	                        $target = next;
	                    }else{
	                        defaultWrapper.append($target[0].childNodes);
	                        $target.after(defaultWrapper);
	                        $target.remove();
	                        $target = defaultWrapper;
	                    }
	                }else if($target.parent()[0].tagName.toLowerCase() === optionsTagName &&
	                    !$target.parent().hasClass('ta-bind')){
	                    //unwrap logic for parent
	                    var blockElement = $target.parent();
	                    var contents = blockElement.contents();
	                    for(i = 0; i < contents.length; i ++){
	                        /* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
	                        if(blockElement.parent().hasClass('ta-bind') && contents[i].nodeType === 3){
	                            defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	                            defaultWrapper[0].innerHTML = contents[i].outerHTML;
	                            contents[i] = defaultWrapper[0];
	                        }
	                        blockElement.parent()[0].insertBefore(contents[i], blockElement[0]);
	                    }
	                    blockElement.remove();
	                }else if(tagName.match(LISTELEMENTS)){
	                    // wrapping a list element
	                    $target.wrap(options);
	                }else{
	                    // default wrap behaviour
	                    _nodes = taSelection.getOnlySelectedElements();
	                    if(_nodes.length === 0) {
	                        // no nodes at all....
	                        _nodes = [$target[0]];
	                    }
	                    // find the parent block element if any of the nodes are inline or text
	                    for(i = 0; i < _nodes.length; i++){
	                        if(_nodes[i].nodeType === 3 || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                            while(_nodes[i].nodeType === 3 || !_nodes[i].tagName || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                                _nodes[i] = _nodes[i].parentNode;
	                            }
	                        }
	                    }
	                    // remove any duplicates from the array of _nodes!
	                    _nodes = _nodes.filter(function(value, index, self) {
	                        return self.indexOf(value) === index;
	                    });
	                    // remove all whole taTextElement if it is here... unless it is the only element!
	                    if (_nodes.length>1) {
	                        _nodes = _nodes.filter(function (value, index, self) {
	                            return !(value.nodeName.toLowerCase() === 'div' && /^taTextElement/.test(value.id));
	                        });
	                    }
	                    if(angular.element(_nodes[0]).hasClass('ta-bind')){
	                        $target = angular.element(options);
	                        $target[0].innerHTML = _nodes[0].innerHTML;
	                        _nodes[0].innerHTML = $target[0].outerHTML;
	                    }else if(optionsTagName === 'blockquote'){
	                        // blockquotes wrap other block elements
	                        html = '';
	                        for(i = 0; i < _nodes.length; i++){
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0],_nodes[0]);
	                        for(i = _nodes.length - 1; i >= 0; i--){
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    } else /* istanbul ignore next: not tested since identical to blockquote */
	                    if (optionsTagName === 'pre' && taSelection.getStateShiftKey()) {
	                        //console.log('shift pre', _nodes);
	                        // pre wrap other block elements
	                        html = '';
	                        for (i = 0; i < _nodes.length; i++) {
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0], _nodes[0]);
	                        for (i = _nodes.length - 1; i >= 0; i--) {
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    }
	                    else {
	                        //console.log(optionsTagName, _nodes);
	                        // regular block elements replace other block elements
	                        for (i = 0; i < _nodes.length; i++) {
	                            var newBlock = turnBlockIntoBlocks(_nodes[i], options);
	                            if (_nodes[i] === $target[0]) {
	                                $target = angular.element(newBlock);
	                            }
	                        }
	                    }
	                }
	                taSelection.setSelectionToElementEnd($target[0]);
	                // looses focus when we have the whole container selected and no text!
	                // refocus on the shown display element, this fixes a bug when using firefox
	                $target[0].focus();
	                return;
	            }else if(command.toLowerCase() === 'createlink'){
	                /* istanbul ignore next: firefox specific fix */
	                if (tagName === 'a') {
	                    // already a link!!! we are just replacing it...
	                    taSelection.getSelectionElement().href = options;
	                    return;
	                }
	                var tagBegin = '<a href="' + options + '" target="' +
	                        (defaultTagAttributes.a.target ? defaultTagAttributes.a.target : '') +
	                        '">',
	                    tagEnd = '</a>',
	                    _selection = taSelection.getSelection();
	                if(_selection.collapsed){
	                    //console.log('collapsed');
	                    // insert text at selection, then select then just let normal exec-command run
	                    taSelection.insertHtml(tagBegin + options + tagEnd, topNode);
	                }else if(rangy.getSelection().getRangeAt(0).canSurroundContents()){
	                    var node = angular.element(tagBegin + tagEnd)[0];
	                    rangy.getSelection().getRangeAt(0).surroundContents(node);
	                }
	                return;
	            }else if(command.toLowerCase() === 'inserthtml'){
	                //console.log('inserthtml');
	                taSelection.insertHtml(options, topNode);
	                return;
	            }
	            try{
	                $document[0].execCommand(command, showUI, options);
	            }catch(e){}
	        };
	    };
	}]).service('taSelection', ['$document', 'taDOM', '$log',
	/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
	function($document, taDOM, $log){
	    // need to dereference the document else the calls don't work correctly
	    var _document = $document[0];
	    var bShiftState;
	    var brException = function (element, offset) {
	        /* check if selection is a BR element at the beginning of a container. If so, get
	        * the parentNode instead.
	        * offset should be zero in this case. Otherwise, return the original
	        * element.
	        */
	        if (element.tagName && element.tagName.match(/^br$/i) && offset === 0 && !element.previousSibling) {
	            return {
	                element: element.parentNode,
	                offset: 0
	            };
	        } else {
	            return {
	                element: element,
	                offset: offset
	            };
	        }
	    };
	    var api = {
	        getSelection: function(){
	            var range;
	            try {
	                // catch any errors from rangy and ignore the issue
	                range = rangy.getSelection().getRangeAt(0);
	            } catch(e) {
	                //console.info(e);
	                return undefined;
	            }
	            var container = range.commonAncestorContainer;
	            var selection = {
	                start: brException(range.startContainer, range.startOffset),
	                end: brException(range.endContainer, range.endOffset),
	                collapsed: range.collapsed
	            };
	            // This has problems under Firefox.
	            // On Firefox with
	            // <p>Try me !</p>
	            // <ul>
	            // <li>line 1</li>
	            // <li>line 2</li>
	            // </ul>
	            // <p>line 3</p>
	            // <ul>
	            // <li>line 4</li>
	            // <li>line 5</li>
	            // </ul>
	            // <p>Hello textAngular</p>
	            // WITH the cursor after the 3 on line 3, it gets the commonAncestorContainer as:
	            // <TextNode textContent='line 3'>
	            // AND Chrome gets the commonAncestorContainer as:
	            // <p>line 3</p>
	            //
	            // Check if the container is a text node and return its parent if so
	            // unless this is the whole taTextElement.  If so we return the textNode
	            if (container.nodeType === 3) {
	                if (container.parentNode.nodeName.toLowerCase() === 'div' &&
	                    /^taTextElement/.test(container.parentNode.id)) {
	                    // textNode where the parent is the whole <div>!!!
	                    //console.log('textNode ***************** container:', container);
	                } else {
	                    container = container.parentNode;
	                }
	            }
	            if (container.nodeName.toLowerCase() === 'div' &&
	                /^taTextElement/.test(container.id)) {
	                //console.log('*********taTextElement************');
	                //console.log('commonAncestorContainer:', container);
	                selection.start.element = container.childNodes[selection.start.offset];
	                selection.end.element = container.childNodes[selection.end.offset];
	                selection.container = container;
	            } else {
	                if (container.parentNode === selection.start.element ||
	                    container.parentNode === selection.end.element) {
	                    selection.container = container.parentNode;
	                } else {
	                    selection.container = container;
	                }
	            }
	            //console.log('***selection container:', selection.container.nodeName, selection.start.offset, selection.container);
	            return selection;
	        },
	        // if we use the LEFT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        // Chrome and Firefox behave differently so so fix this for Firefox here.  No adjustment needed for Chrome.
	        updateLeftArrowKey: function(element) {
	            var range = rangy.getSelection().getRangeAt(0);
	            if (range && range.collapsed) {
	                var _nodes = api.getFlattenedDom(range);
	                if (!_nodes.findIndex) return;
	                var _node = range.startContainer;
	                var indexStartContainer = _nodes.findIndex(function(element, index){
	                    if (element.node===_node) return true;
	                    var _indexp = element.parents.indexOf(_node);
	                    return (_indexp !== -1);
	                });
	                var m;
	                var nextNodeToRight;
	                //console.log('indexStartContainer', indexStartContainer, _nodes.length, 'startContainer:', _node, _node === _nodes[indexStartContainer].node);
	                _nodes.forEach(function (n, i) {
	                    //console.log(i, n.node);
	                    n.parents.forEach(function (nn, j){
	                        //console.log(i, j, nn);
	                    });
	                });
	                if (indexStartContainer+1 < _nodes.length) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToRight = _nodes[indexStartContainer+1].node;
	                    //console.log(nextNodeToRight, range.startContainer);
	                }
	                //console.log('updateLeftArrowKey', range.startOffset, range.startContainer.textContent);
	                // this first section handles the case for Chrome browser
	                // if the first character of the nextNode is a \ufeff we know that we are just before the special span...
	                // and so we most left by one character
	                if (nextNodeToRight && nextNodeToRight.textContent) {
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToRight.textContent);
	                    if (m) {
	                        // we are before the special node with begins with a \ufeff character
	                        //console.log('LEFT ...found it...', 'startOffset:', range.startOffset, m[0].length, m[1].length);
	                        // no need to change anything in this case
	                        return;
	                    }
	                }
	                var nextNodeToLeft;
	                if (indexStartContainer > 0) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToLeft = _nodes[indexStartContainer-1].node;
	                    //console.log(nextNodeToLeft, nextNodeToLeft);
	                }
	                if (range.startOffset === 0 && nextNodeToLeft) {
	                    //console.log(nextNodeToLeft, range.startOffset, nextNodeToLeft.textContent);
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToLeft.textContent);
	                    if (m) {
	                        //console.log('LEFT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', nextNodeToLeft, m[0].length, m[1].length);
	                        // move over to the left my one -- Firefox triggers this case
	                        api.setSelectionToElementEnd(nextNodeToLeft);
	                        return;
	                    }
	                }
	            }
	            return;
	        },
	        // if we use the RIGHT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        updateRightArrowKey: function(element) {
	            // we do not need to make any adjustments here, so we ignore all this code
	            if (false) {
	                var range = rangy.getSelection().getRangeAt(0);
	                if (range && range.collapsed) {
	                    var _nodes = api.getFlattenedDom(range);
	                    if (!_nodes.findIndex) return;
	                    var _node = range.startContainer;
	                    var indexStartContainer = _nodes.findIndex(function (element, index) {
	                        if (element.node === _node) return true;
	                        var _indexp = element.parents.indexOf(_node);
	                        return (_indexp !== -1);
	                    });
	                    var _sel;
	                    var i;
	                    var m;
	
	                    // if the last character is a \ufeff we know that we are just before the special span...
	                    // and so we most right by one character
	                    var indexFound = _nodes.findIndex(function (n, index) {
	                        if (n.textContent) {
	                            var m = /^\ufeff([^\ufeff]*)$/.exec(n.textContent);
	                            if (m) {
	                                return true;
	                            } else {
	                                return false;
	                            }
	                        } else {
	                            return false;
	                        }
	                    });
	                    if (indexFound === -1) {
	                        return;
	                    }
	                    //console.log(indexFound, range.startContainer, range.startOffset);
	                    _node = _nodes[indexStartContainer];
	                    //console.log('indexStartContainer', indexStartContainer);
	                    if (_node && _node.textContent) {
	                        m = /^\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                        if (m && range.startOffset - 1 === m[1].length) {
	                            //console.log('RIGHT found it...&&&&&&&&&&&', range.startOffset);
	                            // no need to make any adjustment
	                            return;
	                        }
	                    }
	                    //console.log(range.startOffset);
	                    if (_nodes && range.startOffset === 0) {
	                        indexStartContainer = _nodes.indexOf(range.startContainer);
	                        if (indexStartContainer !== -1 && indexStartContainer > 0) {
	                            _node = _nodes[indexStartContainer - 1];
	                            if (_node.textContent) {
	                                m = /\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                                if (m && true || range.startOffset === m[1].length + 1) {
	                                    //console.log('RIGHT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', range.startOffset, m[1].length);
	                                    // no need to make any adjustment
	                                    return;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        getFlattenedDom: function(range) {
	            var parent = range.commonAncestorContainer.parentNode;
	            if (!parent) {
	                return range.commonAncestorContainer.childNodes;
	            }
	            var nodes = Array.prototype.slice.call(parent.childNodes); // converts NodeList to Array
	            var indexStartContainer = nodes.indexOf(range.startContainer);
	            // make sure that we have a big enough set of nodes
	            if (indexStartContainer+1 < nodes.length && indexStartContainer > 0) {
	                // we are good
	                // we can go down one node or up one node
	            } else {
	                if (parent.parentNode) {
	                    parent = parent.parentNode;
	                }
	            }
	            // now walk the parent
	            nodes = [];
	            function addNodes(_set) {
	                if (_set.node.childNodes.length) {
	                    var childNodes = Array.prototype.slice.call(_set.node.childNodes); // converts NodeList to Array
	                    childNodes.forEach(function(n) {
	                        var _t = _set.parents.slice();
	                        if (_t.slice(-1)[0]!==_set.node) {
	                            _t.push(_set.node);
	                        }
	                        addNodes({parents: _t, node: n});
	                    });
	                } else {
	                    nodes.push({parents: _set.parents, node: _set.node});
	                }
	            }
	            addNodes({parents: [parent], node: parent});
	            return nodes;
	        },
	        getOnlySelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            return range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	        },
	        // this includes the container element if all children are selected
	        getAllSelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            var selectedNodes = range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	            var innerHtml = container.innerHTML;
	            // remove the junk that rangy has put down
	            innerHtml = innerHtml.replace(/<span id=.selectionBoundary[^>]+>\ufeff?<\/span>/ig, '');
	            //console.log(innerHtml);
	            //console.log(range.toHtml());
	            //console.log(innerHtml === range.toHtml());
	            if (innerHtml === range.toHtml() &&
	                // not the whole taTextElement
	                (!(container.nodeName.toLowerCase() === 'div' &&  /^taTextElement/.test(container.id)))
	            ) {
	                var arr = [];
	                for(var i = selectedNodes.length; i--; arr.unshift(selectedNodes[i]));
	                selectedNodes = arr;
	                selectedNodes.push(container);
	                //$log.debug(selectedNodes);
	            }
	            return selectedNodes;
	        },
	        // Some basic selection functions
	        getSelectionElement: function () {
	            var s = api.getSelection();
	            if (s) {
	                return api.getSelection().container;
	            } else {
	                return undefined;
	            }
	        },
	        setSelection: function(elStart, elEnd, start, end){
	            var range = rangy.createRange();
	
	            range.setStart(elStart, start);
	            range.setEnd(elEnd, end);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionBeforeElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionAfterElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(false);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementStart: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementEnd: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(false);
	            if(el.childNodes && el.childNodes[el.childNodes.length - 1] && el.childNodes[el.childNodes.length - 1].nodeName === 'br'){
	                range.startOffset = range.endOffset = range.startOffset - 1;
	            }
	            rangy.getSelection().setSingleRange(range);
	        },
	        setStateShiftKey: function(bS) {
	            bShiftState = bS;
	        },
	        getStateShiftKey: function() {
	            return bShiftState;
	        },
	        // from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
	        // topNode is the contenteditable normally, all manipulation MUST be inside this.
	        insertHtml: function(html, topNode){
	            var parent, secondParent, _childI, nodes, i, lastNode, _tempFrag;
	            var element = angular.element("<div>" + html + "</div>");
	            var range = rangy.getSelection().getRangeAt(0);
	            var frag = _document.createDocumentFragment();
	            var children = element[0].childNodes;
	            var isInline = true;
	
	            if(children.length > 0){
	                // NOTE!! We need to do the following:
	                // check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
	                // If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
	                nodes = [];
	                for(_childI = 0; _childI < children.length; _childI++){
	                    var _cnode = children[_childI];
	                    if (_cnode.nodeName.toLowerCase() === 'p' &&
	                        _cnode.innerHTML.trim() === '') { // empty p element
	                        continue;
	                    }
	                    /****************
	                     *  allow any text to be inserted...
	                    if((   _cnode.nodeType === 3 &&
	                           _cnode.nodeValue === '\ufeff'[0] &&
	                           _cnode.nodeValue.trim() === '') // empty no-space space element
	                        ) {
	                        // no change to isInline
	                        nodes.push(_cnode);
	                        continue;
	                    }
	                    if(_cnode.nodeType === 3 &&
	                         _cnode.nodeValue.trim() === '') { // empty text node
	                        continue;
	                    }
	                    *****************/
	                    isInline = isInline && !BLOCKELEMENTS.test(_cnode.nodeName);
	                    nodes.push(_cnode);
	                }
	                for(var _n = 0; _n < nodes.length; _n++) {
	                    lastNode = frag.appendChild(nodes[_n]);
	                }
	                if( !isInline &&
	                    range.collapsed &&
	                    /^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML) ) {
	                    range.selectNode(range.startContainer);
	                }
	            }else{
	                isInline = true;
	                // paste text of some sort
	                lastNode = frag = _document.createTextNode(html);
	            }
	
	            // Other Edge case - selected data spans multiple blocks.
	            if(isInline){
	                range.deleteContents();
	            }else{ // not inline insert
	                if(range.collapsed && range.startContainer !== topNode){
	                    if(range.startContainer.innerHTML && range.startContainer.innerHTML.match(/^<[^>]*>$/i)){
	                        // this log is to catch when innerHTML is something like `<img ...>`
	                        parent = range.startContainer;
	                        if(range.startOffset === 1){
	                            // before single tag
	                            range.setStartAfter(parent);
	                            range.setEndAfter(parent);
	                        }else{
	                            // after single tag
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                        }
	                    }else{
	                        // split element into 2 and insert block element in middle
	                        if(range.startContainer.nodeType === 3 && range.startContainer.parentNode !== topNode){ // if text node
	                            parent = range.startContainer.parentNode;
	                            secondParent = parent.cloneNode();
	                            // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, range.startContainer, range.startOffset);
	
	                            // Escape out of the inline tags like b
	                            while(!VALIDELEMENTS.test(parent.nodeName)){
	                                angular.element(parent).after(secondParent);
	                                parent = parent.parentNode;
	                                var _lastSecondParent = secondParent;
	                                secondParent = parent.cloneNode();
	                                // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                                taDOM.splitNodes(parent.childNodes, parent, secondParent, _lastSecondParent);
	                            }
	                        }else{
	                            parent = range.startContainer;
	                            secondParent = parent.cloneNode();
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, undefined, undefined, range.startOffset);
	                        }
	
	                        angular.element(parent).after(secondParent);
	                        // put cursor to end of inserted content
	                        //console.log('setStartAfter', parent);
	                        range.setStartAfter(parent);
	                        range.setEndAfter(parent);
	
	                        if(/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())){
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                            angular.element(parent).remove();
	                        }
	                        if(/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim())) angular.element(secondParent).remove();
	                        if(parent.nodeName.toLowerCase() === 'li'){
	                            _tempFrag = _document.createDocumentFragment();
	                            for(i = 0; i < frag.childNodes.length; i++){
	                                element = angular.element('<li>');
	                                taDOM.transferChildNodes(frag.childNodes[i], element[0]);
	                                taDOM.transferNodeAttributes(frag.childNodes[i], element[0]);
	                                _tempFrag.appendChild(element[0]);
	                            }
	                            frag = _tempFrag;
	                            if(lastNode){
	                                lastNode = frag.childNodes[frag.childNodes.length - 1];
	                                lastNode = lastNode.childNodes[lastNode.childNodes.length - 1];
	                            }
	                        }
	                    }
	                }else{
	                    range.deleteContents();
	                }
	            }
	
	            range.insertNode(frag);
	            if(lastNode){
	                api.setSelectionToElementEnd(lastNode);
	            }
	        }
	
	        /* NOT FUNCTIONAL YET
	         // under Firefox, we may have a selection that needs to be normalized
	         isSelectionContainerWhole_taTextElement: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         if (container.nodeName.toLowerCase() === 'div' &&
	         /^taTextElement/.test(container.id)) {
	         // container is the whole taTextElement
	         return true;
	         }
	         return false;
	         },
	         setNormalizedSelection: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         console.log(range);
	         console.log(container.childNodes);
	         if (range.collapsed) {
	         // we know what to do...
	         console.log(container.childNodes[range.startOffset]);
	         api.setSelectionToElementStart(container.childNodes[range.startOffset]);
	         }
	         },
	         */
	    };
	    return api;
	}]).service('taDOM', function(){
	    var taDOM = {
	        // recursive function that returns an array of angular.elements that have the passed attribute set on them
	        getByAttribute: function(element, attribute){
	            var resultingElements = [];
	            var childNodes = element.children();
	            if(childNodes.length){
	                angular.forEach(childNodes, function(child){
	                    resultingElements = resultingElements.concat(taDOM.getByAttribute(angular.element(child), attribute));
	                });
	            }
	            if(element.attr(attribute) !== undefined) resultingElements.push(element);
	            return resultingElements;
	        },
	
	        transferChildNodes: function(source, target){
	            // clear out target
	            target.innerHTML = '';
	            while(source.childNodes.length > 0) target.appendChild(source.childNodes[0]);
	            return target;
	        },
	
	        splitNodes: function(nodes, target1, target2, splitNode, subSplitIndex, splitIndex){
	            if(!splitNode && isNaN(splitIndex)) throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');
	            var startNodes = document.createDocumentFragment();
	            var endNodes = document.createDocumentFragment();
	            var index = 0;
	
	            while(nodes.length > 0 && (isNaN(splitIndex) || splitIndex !== index) && nodes[0] !== splitNode){
	                startNodes.appendChild(nodes[0]); // this removes from the nodes array (if proper childNodes object.
	                index++;
	            }
	
	            if(!isNaN(subSplitIndex) && subSplitIndex >= 0 && nodes[0]){
	                startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0, subSplitIndex)));
	                nodes[0].nodeValue = nodes[0].nodeValue.substring(subSplitIndex);
	            }
	            while(nodes.length > 0) endNodes.appendChild(nodes[0]);
	
	            taDOM.transferChildNodes(startNodes, target1);
	            taDOM.transferChildNodes(endNodes, target2);
	        },
	
	        transferNodeAttributes: function(source, target){
	            for(var i = 0; i < source.attributes.length; i++) target.setAttribute(source.attributes[i].name, source.attributes[i].value);
	            return target;
	        }
	    };
	    return taDOM;
	});
	
	angular.module('textAngular.validators', [])
	.directive('taMaxText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var max = parseInt(scope.$eval(attrs.taMaxText));
	            if (isNaN(max)){
	                throw('Max text must be an integer');
	            }
	            attrs.$observe('taMaxText', function(value){
	                max = parseInt(value);
	                if (isNaN(max)){
	                    throw('Max text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMaxText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return source.text().length <= max;
	            };
	        }
	    };
	}).directive('taMinText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var min = parseInt(scope.$eval(attrs.taMinText));
	            if (isNaN(min)){
	                throw('Min text must be an integer');
	            }
	            attrs.$observe('taMinText', function(value){
	                min = parseInt(value);
	                if (isNaN(min)){
	                    throw('Min text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMinText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return !source.text().length || source.text().length >= min;
	            };
	        }
	    };
	});
	angular.module('textAngular.taBind', ['textAngular.factories', 'textAngular.DOM'])
	.service('_taBlankTest', [function(){
	    return function(_blankVal){
	        // we radically restructure this code.
	        // what was here before was incredibly fragile.
	        // What we do now is to check that the html is non-blank visually
	        // which we check by looking at html->text
	        if(!_blankVal) return true;
	        // find first non-tag match - ie start of string or after tag that is not whitespace
	        // var t0 = performance.now();
	        // Takes a small fraction of a mSec to do this...
	        var _text_ = stripHtmlToText(_blankVal);
	        // var t1 = performance.now();
	        // console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to generate:');
	        if (_text_=== '') {
	            // img generates a visible item so it is not blank!
	            if (/<img[^>]+>/.test(_blankVal)) {
	                return false;
	            }
	            return true;
	        } else {
	            return false;
	        }
	    };
	}])
	.directive('taButton', [function(){
	    return {
	        link: function(scope, element, attrs){
	            element.attr('unselectable', 'on');
	            element.on('mousedown', function(e, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(e, eventData);
	                // this prevents focusout from firing on the editor when clicking toolbar buttons
	                e.preventDefault();
	                return false;
	            });
	        }
	    };
	}])
	.directive('taBind', [
	        'taSanitize', '$timeout', '$document', 'taFixChrome', 'taBrowserTag',
	        'taSelection', 'taSelectableElements', 'taApplyCustomRenderers', 'taOptions',
	        '_taBlankTest', '$parse', 'taDOM', 'textAngularManager',
	        function(
	            taSanitize, $timeout, $document, taFixChrome, taBrowserTag,
	            taSelection, taSelectableElements, taApplyCustomRenderers, taOptions,
	            _taBlankTest, $parse, taDOM, textAngularManager){
	    // Uses for this are textarea or input with ng-model and ta-bind='text'
	    // OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	    return {
	        priority: 2, // So we override validators correctly
	        require: ['ngModel','?ngModelOptions'],
	        link: function(scope, element, attrs, controller){
	            var ngModel = controller[0];
	            var ngModelOptions = controller[1] || {};
	            // the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
	            var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
	            var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
	            var _isReadonly = false;
	            var _focussed = false;
	            var _skipRender = false;
	            var _disableSanitizer = attrs.taUnsafeSanitizer || taOptions.disableSanitizer;
	            var _keepStyles = attrs.taKeepStyles || taOptions.keepStyles;
	            var _lastKey;
	            // see http://www.javascripter.net/faq/keycodes.htm for good information
	            // NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
	            // BLOCKED_KEYS are special keys...
	            // Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
	            // Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
	            // f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
	            // NumLock, ScrollLock
	            var BLOCKED_KEYS = /^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;
	            // UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
	            // Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
	            // Numpad +, Numpad -, (; :), (= +),
	            // (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
	            // NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
	            var UNDO_TRIGGER_KEYS = /^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;
	            var _pasteHandler;
	
	            // defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
	            // non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
	            var _defaultVal, _defaultTest;
	
	            var _CTRL_KEY = 0x0001;
	            var _META_KEY = 0x0002;
	            var _ALT_KEY = 0x0004;
	            var _SHIFT_KEY = 0x0008;
	            // KEYCODEs we use
	            var _ENTER_KEYCODE = 13;
	            var _SHIFT_KEYCODE = 16;
	            var _TAB_KEYCODE = 9;
	            var _LEFT_ARROW_KEYCODE = 37;
	            var _RIGHT_ARROW_KEYCODE = 39;
	            // map events to special keys...
	            // mappings is an array of maps from events to specialKeys as declared in textAngularSetup
	            var _keyMappings = [
	                //		ctrl/command + z
	                {
	                    specialKey: 'UndoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + shift + z
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY, _SHIFT_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + y
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 89
	                },
	                //		TabKey
	                {
	                    specialKey: 'TabKey',
	                    forbiddenModifiers: _META_KEY + _SHIFT_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [],
	                    keyCode: _TAB_KEYCODE
	                },
	                //		shift + TabKey
	                {
	                    specialKey: 'ShiftTabKey',
	                    forbiddenModifiers: _META_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [_SHIFT_KEY],
	                    keyCode: _TAB_KEYCODE
	                }
	            ];
	            function _mapKeys(event) {
	                var specialKey;
	                _keyMappings.forEach(function (map){
	                    if (map.keyCode === event.keyCode) {
	                        var netModifiers = (event.metaKey ? _META_KEY: 0) +
	                            (event.ctrlKey ? _CTRL_KEY: 0) +
	                            (event.shiftKey ? _SHIFT_KEY: 0) +
	                            (event.altKey ? _ALT_KEY: 0);
	                        if (map.forbiddenModifiers & netModifiers) return;
	                        if (map.mustHaveModifiers.every(function (modifier) { return netModifiers & modifier; })){
	                            specialKey = map.specialKey;
	                        }
	                    }
	                });
	                return specialKey;
	            }
	
	            // set the default to be a paragraph value
	            if(attrs.taDefaultWrap === undefined) attrs.taDefaultWrap = 'p';
	            /* istanbul ignore next: ie specific test */
	            if(attrs.taDefaultWrap === ''){
	                _defaultVal = '';
	                _defaultTest = (_browserDetect.ie === undefined)? '<div><br></div>' : (_browserDetect.ie >= 11)? '<p><br></p>' : (_browserDetect.ie <= 8)? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
	            }else{
	                _defaultVal = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<BR><BR>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
	                _defaultTest = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<br><br>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
	            }
	
	            /* istanbul ignore else */
	            if(!ngModelOptions.$options) ngModelOptions.$options = {}; // ng-model-options support
	
	            var _ensureContentWrapped = function(value) {
	                if (_taBlankTest(value)) return value;
	                var domTest = angular.element("<div>" + value + "</div>");
	                //console.log('domTest.children().length():', domTest.children().length);
	                //console.log('_ensureContentWrapped', domTest.children());
	                //console.log(value, attrs.taDefaultWrap);
	                if (domTest.children().length === 0) {
	                    // if we have a <br> and the attrs.taDefaultWrap is a <p> we need to remove the <br>
	                    //value = value.replace(/<br>/i, '');
	                    value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                } else {
	                    var _children = domTest[0].childNodes;
	                    var i;
	                    var _foundBlockElement = false;
	                    for (i = 0; i < _children.length; i++) {
	                        if (_foundBlockElement = _children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) break;
	                    }
	                    if (!_foundBlockElement) {
	                        value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                    }
	                    else{
	                        value = "";
	                        for(i = 0; i < _children.length; i++){
	                            var node = _children[i];
	                            var nodeName = node.nodeName.toLowerCase();
	                            //console.log('node#:', i, 'name:', nodeName);
	                            if(nodeName === '#comment') {
	                                value += '<!--' + node.nodeValue + '-->';
	                            } else if(nodeName === '#text') {
	                                // determine if this is all whitespace, if so, we will leave it as it is.
	                                // otherwise, we will wrap it as it is
	                                var text = node.textContent;
	                                if (!text.trim()) {
	                                    // just whitespace
	                                    value += text;
	                                } else {
	                                    // not pure white space so wrap in <p>...</p> or whatever attrs.taDefaultWrap is set to.
	                                    value += "<" + attrs.taDefaultWrap + ">" + text + "</" + attrs.taDefaultWrap + ">";
	                                }
	                            } else if(!nodeName.match(BLOCKELEMENTS)){
	                                /* istanbul ignore  next: Doesn't seem to trigger on tests */
	                                var _subVal = (node.outerHTML || node.nodeValue);
	                                /* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
	                                if(_subVal.trim() !== '')
	                                    value += "<" + attrs.taDefaultWrap + ">" + _subVal + "</" + attrs.taDefaultWrap + ">";
	                                else value += _subVal;
	                            } else {
	                                value += node.outerHTML;
	                            }
	                            //console.log(value);
	                        }
	                    }
	                }
	                //console.log(value);
	                return value;
	            };
	
	            if(attrs.taPaste) {
	                _pasteHandler = $parse(attrs.taPaste);
	            }
	
	            element.addClass('ta-bind');
	
	            var _undoKeyupTimeout;
	
	            scope['$undoManager' + (attrs.id || '')] = ngModel.$undoManager = {
	                _stack: [],
	                _index: 0,
	                _max: 1000,
	                push: function(value){
	                    if((typeof value === "undefined" || value === null) ||
	                        ((typeof this.current() !== "undefined" && this.current() !== null) && value === this.current())) return value;
	                    if(this._index < this._stack.length - 1){
	                        this._stack = this._stack.slice(0,this._index+1);
	                    }
	                    this._stack.push(value);
	                    if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                    if(this._stack.length > this._max) this._stack.shift();
	                    this._index = this._stack.length - 1;
	                    return value;
	                },
	                undo: function(){
	                    return this.setToIndex(this._index-1);
	                },
	                redo: function(){
	                    return this.setToIndex(this._index+1);
	                },
	                setToIndex: function(index){
	                    if(index < 0 || index > this._stack.length - 1){
	                        return undefined;
	                    }
	                    this._index = index;
	                    return this.current();
	                },
	                current: function(){
	                    return this._stack[this._index];
	                }
	            };
	
	            // in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
	            var _compileHtml = function(){
	                if(_isContentEditable) {
	                    return element[0].innerHTML;
	                }
	                if(_isInputFriendly) {
	                    return element.val();
	                }
	                throw ('textAngular Error: attempting to update non-editable taBind');
	            };
	
	            var selectorClickHandler = function(event){
	                // emit the element-select event, pass the element
	                scope.$emit('ta-element-select', this);
	                event.preventDefault();
	                return false;
	            };
	
	            //used for updating when inserting wrapped elements
	            var _reApplyOnSelectorHandlers = scope['reApplyOnSelectorHandlers' + (attrs.id || '')] = function(){
	                /* istanbul ignore else */
	                if(!_isReadonly) angular.forEach(taSelectableElements, function(selector){
	                    // check we don't apply the handler twice
	                    element.find(selector)
	                        .off('click', selectorClickHandler)
	                        .on('click', selectorClickHandler);
	                });
	            };
	
	            var _setViewValue = function(_val, triggerUndo, skipRender){
	                _skipRender = skipRender || false;
	                if(typeof triggerUndo === "undefined" || triggerUndo === null) triggerUndo = true && _isContentEditable; // if not contentEditable then the native undo/redo is fine
	                if(typeof _val === "undefined" || _val === null) _val = _compileHtml();
	                if(_taBlankTest(_val)){
	                    // this avoids us from tripping the ng-pristine flag if we click in and out with out typing
	                    if(ngModel.$viewValue !== '') ngModel.$setViewValue('');
	                    if(triggerUndo && ngModel.$undoManager.current() !== '') ngModel.$undoManager.push('');
	                }else{
	                    _reApplyOnSelectorHandlers();
	                    if(ngModel.$viewValue !== _val){
	                        ngModel.$setViewValue(_val);
	                        if(triggerUndo) ngModel.$undoManager.push(_val);
	                    }
	                }
	                ngModel.$render();
	            };
	
	            var _setInnerHTML = function(newval){
	                element[0].innerHTML = newval;
	            };
	
	            var _redoUndoTimeout;
	            var _undo = scope['$undoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.undo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            var _redo = scope['$redoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.redo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        /* istanbul ignore next */
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            //used for updating when inserting wrapped elements
	            scope['updateTaBind' + (attrs.id || '')] = function(){
	                if(!_isReadonly) _setViewValue(undefined, undefined, true);
	            };
	
	            // catch DOM XSS via taSanitize
	            // Sanitizing both ways is identical
	            var _sanitize = function(unsafe){
	                return (ngModel.$oldViewValue = taSanitize(taFixChrome(unsafe, _keepStyles), ngModel.$oldViewValue, _disableSanitizer));
	            };
	
	            // trigger the validation calls
	            if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                return !_taBlankTest(modelValue || viewValue);
	            };
	            // parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
	            ngModel.$parsers.push(_sanitize);
	            ngModel.$parsers.unshift(_ensureContentWrapped);
	            // because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
	            ngModel.$formatters.push(_sanitize);
	            ngModel.$formatters.unshift(_ensureContentWrapped);
	            ngModel.$formatters.unshift(function(value){
	                return ngModel.$undoManager.push(value || '');
	            });
	
	            //this code is used to update the models when data is entered/deleted
	            if(_isInputFriendly){
	                scope.events = {};
	                if(!_isContentEditable){
	                    // if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
	                    element.on('change blur', scope.events.change = scope.events.blur = function(){
	                        if(!_isReadonly) ngModel.$setViewValue(_compileHtml());
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        // Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
	                        /* istanbul ignore else: otherwise normal functionality */
	                        if(event.keyCode === _TAB_KEYCODE){ // tab was pressed
	                            // get caret position/selection
	                            var start = this.selectionStart;
	                            var end = this.selectionEnd;
	
	                            var value = element.val();
	                            if(event.shiftKey){
	                                // find \t
	                                var _linebreak = value.lastIndexOf('\n', start), _tab = value.lastIndexOf('\t', start);
	                                if(_tab !== -1 && _tab >= _linebreak){
	                                    // set textarea value to: text before caret + tab + text after caret
	                                    element.val(value.substring(0, _tab) + value.substring(_tab + 1));
	
	                                    // put caret at right position again (add one for the tab)
	                                    this.selectionStart = this.selectionEnd = start - 1;
	                                }
	                            }else{
	                                // set textarea value to: text before caret + tab + text after caret
	                                element.val(value.substring(0, start) + "\t" + value.substring(end));
	
	                                // put caret at right position again (add one for the tab)
	                                this.selectionStart = this.selectionEnd = start + 1;
	                            }
	                            // prevent the focus lose
	                            event.preventDefault();
	                        }
	                    });
	
	                    var _repeat = function(string, n){
	                        var result = '';
	                        for(var _n = 0; _n < n; _n++) result += string;
	                        return result;
	                    };
	
	                    // add a forEach function that will work on a NodeList, etc..
	                    var forEach = function (array, callback, scope) {
	                        for (var i= 0; i<array.length; i++) {
	                            callback.call(scope, i, array[i]);
	                        }
	                    };
	
	                    // handle <ul> or <ol> nodes
	                    var recursiveListFormat = function(listNode, tablevel){
	                        var _html = '';
	                        var _subnodes = listNode.childNodes;
	                        tablevel++;
	                        // tab out and add the <ul> or <ol> html piece
	                        _html += _repeat('\t', tablevel-1) + listNode.outerHTML.substring(0, 4);
	                        forEach(_subnodes, function (index, node) {
	                            /* istanbul ignore next: browser catch */
	                            var nodeName = node.nodeName.toLowerCase();
	                            if (nodeName === '#comment') {
	                                _html += '<!--' + node.nodeValue + '-->';
	                                return;
	                            }
	                            if (nodeName === '#text') {
	                                _html += node.textContent;
	                                return;
	                            }
	                            /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                            if(!node.outerHTML) {
	                                // no html to add
	                                return;
	                            }
	                            if(nodeName === 'ul' || nodeName === 'ol') {
	                                _html += '\n' + recursiveListFormat(node, tablevel);
	                            }
	                            else {
	                                // no reformatting within this subnode, so just do the tabing...
	                                _html += '\n' + _repeat('\t', tablevel) + node.outerHTML;
	                            }
	                        });
	                        // now add on the </ol> or </ul> piece
	                        _html += '\n' + _repeat('\t', tablevel-1) + listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));
	                        return _html;
	                    };
	                    // handle formating of something like:
	                    // <ol><!--First comment-->
	                    //  <li>Test Line 1<!--comment test list 1--></li>
	                    //    <ul><!--comment ul-->
	                    //      <li>Nested Line 1</li>
	                    //        <!--comment between nested lines--><li>Nested Line 2</li>
	                    //    </ul>
	                    //  <li>Test Line 3</li>
	                    // </ol>
	                    ngModel.$formatters.unshift(function(htmlValue){
	                        // tabulate the HTML so it looks nicer
	                        //
	                        // first get a list of the nodes...
	                        // we do this by using the element parser...
	                        //
	                        // doing this -- which is simpiler -- breaks our tests...
	                        //var _nodes=angular.element(htmlValue);
	                        var _nodes = angular.element('<div>' + htmlValue + '</div>')[0].childNodes;
	                        if(_nodes.length > 0){
	                            // do the reformatting of the layout...
	                            htmlValue = '';
	                            forEach(_nodes, function (index, node) {
	                                var nodeName = node.nodeName.toLowerCase();
	                                if (nodeName === '#comment') {
	                                    htmlValue += '<!--' + node.nodeValue + '-->';
	                                    return;
	                                }
	                                if (nodeName === '#text') {
	                                    htmlValue += node.textContent;
	                                    return;
	                                }
	                                /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                                if(!node.outerHTML)
	                                {
	                                    // nothing to format!
	                                    return;
	                                }
	                                if(htmlValue.length > 0) {
	                                    // we aready have some content, so drop to a new line
	                                    htmlValue += '\n';
	                                }
	                                if(nodeName === 'ul' || nodeName === 'ol') {
	                                    // okay a set of list stuff we want to reformat in a nested way
	                                    htmlValue += '' + recursiveListFormat(node, 0);
	                                }
	                                else {
	                                    // just use the original without any additional formating
	                                    htmlValue += '' + node.outerHTML;
	                                }
	                            });
	                        }
	                        return htmlValue;
	                    });
	                }else{
	                    // all the code specific to contenteditable divs
	                    var _processingPaste = false;
	                    /* istanbul ignore next: phantom js cannot test this for some reason */
	                    var processpaste = function(text) {
	                       var _isOneNote = text!==undefined? text.match(/content=["']*OneNote.File/i): false;
	                        /* istanbul ignore else: don't care if nothing pasted */
	                        //console.log(text);
	                        if(text && text.trim().length){
	                            // test paste from word/microsoft product
	                            if(text.match(/class=["']*Mso(Normal|List)/i) || text.match(/content=["']*Word.Document/i) || text.match(/content=["']*OneNote.File/i)){
	                                var textFragment = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);
	                                if(!textFragment) textFragment = text;
	                                else textFragment = textFragment[1];
	                                textFragment = textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig, '').replace(/class=(["']|)MsoNormal(["']|)/ig, '');
	                                var dom = angular.element("<div>" + textFragment + "</div>");
	                                var targetDom = angular.element("<div></div>");
	                                var _list = {
	                                    element: null,
	                                    lastIndent: [],
	                                    lastLi: null,
	                                    isUl: false
	                                };
	                                _list.lastIndent.peek = function(){
	                                    var n = this.length;
	                                    if (n>0) return this[n-1];
	                                };
	                                var _resetList = function(isUl){
	                                    _list.isUl = isUl;
	                                    _list.element = angular.element(isUl ? "<ul>" : "<ol>");
	                                    _list.lastIndent = [];
	                                    _list.lastIndent.peek = function(){
	                                        var n = this.length;
	                                        if (n>0) return this[n-1];
	                                    };
	                                    _list.lastLevelMatch = null;
	                                };
	                                for(var i = 0; i <= dom[0].childNodes.length; i++){
	                                    if(!dom[0].childNodes[i] || dom[0].childNodes[i].nodeName === "#text"){
	                                        continue;
	                                    } else {
	                                        var tagName = dom[0].childNodes[i].tagName.toLowerCase();
	                                        if(tagName !== 'p' &&
	                                            tagName !== 'ul' &&
	                                            tagName !== 'h1' &&
	                                            tagName !== 'h2' &&
	                                            tagName !== 'h3' &&
	                                            tagName !== 'h4' &&
	                                            tagName !== 'h5' &&
	                                            tagName !== 'h6' &&
	                                            tagName !== 'table'){
	                                            continue;
	                                        }
	                                    }
	                                    var el = angular.element(dom[0].childNodes[i]);
	                                    var _listMatch = (el.attr('class') || '').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);
	
	                                    if(_listMatch){
	                                        if(el[0].childNodes.length < 2 || el[0].childNodes[1].childNodes.length < 1){
	                                            continue;
	                                        }
	                                        var isUl = _listMatch[1].toLowerCase() === 'bullet' || (_listMatch[1].toLowerCase() !== 'number' && !(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML) || /^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML)));
	                                        var _indentMatch = (el.attr('style') || '').match(/margin-left:([\-\.0-9]*)/i);
	                                        var indent = parseFloat((_indentMatch)?_indentMatch[1]:0);
	                                        var _levelMatch = (el.attr('style') || '').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);
	                                        // prefers the mso-list syntax
	
	                                        if(_levelMatch && _levelMatch[2]) indent = parseInt(_levelMatch[2]);
	
	                                        if ((_levelMatch && (!_list.lastLevelMatch || _levelMatch[1] !== _list.lastLevelMatch[1])) || !_listMatch[3] || _listMatch[3].toLowerCase() === 'first' || (_list.lastIndent.peek() === null) || (_list.isUl !== isUl && _list.lastIndent.peek() === indent)) {
	                                            _resetList(isUl);
	                                            targetDom.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() < indent){
	                                            _list.element = angular.element(isUl ? '<ul>' : '<ol>');
	                                            _list.lastLi.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                            while(_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                                if(_list.element.parent()[0].tagName.toLowerCase() === 'li'){
	                                                    _list.element = _list.element.parent();
	                                                    continue;
	                                                }else if(/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())){
	                                                    _list.element = _list.element.parent();
	                                                }else{ // else it's it should be a sibling
	                                                    break;
	                                                }
	                                                _list.lastIndent.pop();
	                                            }
	                                            _list.isUl = _list.element[0].tagName.toLowerCase() === 'ul';
	                                            if (isUl !== _list.isUl) {
	                                                _resetList(isUl);
	                                                targetDom.append(_list.element);
	                                            }
	                                        }
	
	                                        _list.lastLevelMatch = _levelMatch;
	                                        if(indent !== _list.lastIndent.peek()) _list.lastIndent.push(indent);
	                                        _list.lastLi = angular.element('<li>');
	                                        _list.element.append(_list.lastLi);
	                                        _list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig, ''));
	                                        el.remove();
	                                    }else{
	                                        _resetList(false);
	                                        targetDom.append(el);
	                                    }
	                                }
	                                var _unwrapElement = function(node){
	                                    node = angular.element(node);
	                                    for(var _n = node[0].childNodes.length - 1; _n >= 0; _n--) node.after(node[0].childNodes[_n]);
	                                    node.remove();
	                                };
	
	                                angular.forEach(targetDom.find('span'), function(node){
	                                    node.removeAttribute('lang');
	                                    if(node.attributes.length <= 0) _unwrapElement(node);
	                                });
	                                angular.forEach(targetDom.find('font'), _unwrapElement);
	
	                                text = targetDom.html();
	                                if(_isOneNote){
	                                    text = targetDom.html() || dom.html();
	                                }
	                                // LF characters instead of spaces in some spots and they are replaced by '/n', so we need to just swap them to spaces
	                                text = text.replace(/\n/g, ' ');
	                            }else{
	                                // remove unnecessary chrome insert
	                                text = text.replace(/<(|\/)meta[^>]*?>/ig, '');
	                                if(text.match(/<[^>]*?(ta-bind)[^>]*?>/)){
	                                    // entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
	                                    if(text.match(/<[^>]*?(text-angular)[^>]*?>/)){
	                                        var _el = angular.element('<div>' + text + '</div>');
	                                        _el.find('textarea').remove();
	                                        for(var _b = 0; _b < binds.length; _b++){
	                                            var _target = binds[_b][0].parentNode.parentNode;
	                                            for(var _c = 0; _c < binds[_b][0].childNodes.length; _c++){
	                                                _target.parentNode.insertBefore(binds[_b][0].childNodes[_c], _target);
	                                            }
	                                            _target.parentNode.removeChild(_target);
	                                        }
	                                        text = _el.html().replace('<br class="Apple-interchange-newline">', '');
	                                    }
	                                }else if(text.match(/^<span/)){
	                                    // in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
	                                    // if we remove the '<span class="Apple-converted-space"> </span>' here we destroy the spacing
	                                    // on paste from even ourselves!
	                                    if (!text.match(/<span class=(\"Apple-converted-space\"|\'Apple-converted-space\')>.<\/span>/ig)) {
	                                        text = text.replace(/<(|\/)span[^>]*?>/ig, '');
	                                    }
	                                }
	                                // Webkit on Apple tags
	                                text = text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig, '').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig, '&nbsp;');
	                            }
	
	                            if (/<li(\s.*)?>/i.test(text) && /(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text) === false) {
	                                // insert missing parent of li element
	                                text = text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i, '<ul>$&</ul>');
	                            }
	
	                            // parse whitespace from plaintext input, starting with preceding spaces that get stripped on paste
	                            text = text.replace(/^[ |\u00A0]+/gm, function (match) {
	                                var result = '';
	                                for (var i = 0; i < match.length; i++) {
	                                    result += '&nbsp;';
	                                }
	                                return result;
	                            }).replace(/\n|\r\n|\r/g, '<br />').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
	
	                            if(_pasteHandler) text = _pasteHandler(scope, {$html: text}) || text;
	
	                            // turn span vertical-align:super into <sup></sup>
	                            text = text.replace(/<span style=("|')([^<]*?)vertical-align\s*:\s*super;?([^>]*?)("|')>([^<]+?)<\/span>/g, "<sup style='$2$3'>$5</sup>");
	
	                            text = taSanitize(text, '', _disableSanitizer);
	                            //console.log('DONE\n', text);
	
	                            taSelection.insertHtml(text, element[0]);
	                            $timeout(function(){
	                                ngModel.$setViewValue(_compileHtml());
	                                _processingPaste = false;
	                                element.removeClass('processing-paste');
	                            }, 0);
	                        }else{
	                            _processingPaste = false;
	                            element.removeClass('processing-paste');
	                        }
	                    };
	
	                    element.on('paste', scope.events.paste = function(e, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(e, eventData);
	                        if(_isReadonly || _processingPaste){
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	
	                        // Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
	                        _processingPaste = true;
	                        element.addClass('processing-paste');
	                        var pastedContent;
	                        var clipboardData = (e.originalEvent || e).clipboardData;
	                        /* istanbul ignore next: Handle legacy IE paste */
	                        if ( !clipboardData && window.clipboardData && window.clipboardData.getData ){
	                            pastedContent = window.clipboardData.getData("Text");
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	                        if (clipboardData && clipboardData.getData && clipboardData.types.length > 0) {// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
	                            var _types = "";
	                            for(var _t = 0; _t < clipboardData.types.length; _t++){
	                                _types += " " + clipboardData.types[_t];
	                            }
	                            /* istanbul ignore next: browser tests */
	                            if (/text\/html/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/html');
	                            } else if (/text\/plain/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/plain');
	                            }
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        } else {// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
	                            var _savedSelection = rangy.saveSelection(),
	                                _tempDiv = angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');
	                            $document.find('body').append(_tempDiv);
	                            _tempDiv[0].focus();
	                            $timeout(function(){
	                                // restore selection
	                                rangy.restoreSelection(_savedSelection);
	                                processpaste(_tempDiv[0].innerHTML);
	                                element[0].focus();
	                                _tempDiv.remove();
	                            }, 0);
	                        }
	                    });
	                    element.on('cut', scope.events.cut = function(e){
	                        // timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
	                        if(!_isReadonly) $timeout(function(){
	                            ngModel.$setViewValue(_compileHtml());
	                        }, 0);
	                        else e.preventDefault();
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        if (event.keyCode === _SHIFT_KEYCODE) {
	                            taSelection.setStateShiftKey(true);
	                        } else {
	                            taSelection.setStateShiftKey(false);
	                        }
	                        event.specialKey = _mapKeys(event);
	                        var userSpecialKey;
	                        /* istanbul ignore next: difficult to test */
	                        taOptions.keyMappings.forEach(function (mapping) {
	                            if (event.specialKey === mapping.commandKeyCode) {
	                                // taOptions has remapped this binding... so
	                                // we disable our own
	                                event.specialKey = undefined;
	                            }
	                            if (mapping.testForKey(event)) {
	                                userSpecialKey = mapping.commandKeyCode;
	                            }
	                            if ((mapping.commandKeyCode === 'UndoKey') || (mapping.commandKeyCode === 'RedoKey')) {
	                                // this is necessary to fully stop the propagation.
	                                if (!mapping.enablePropagation) {
	                                    event.preventDefault();
	                                }
	                            }
	                        });
	                        /* istanbul ignore next: difficult to test */
	                        if (typeof userSpecialKey !== 'undefined') {
	                            event.specialKey = userSpecialKey;
	                        }
	                        /* istanbul ignore next: difficult to test as can't seem to select */
	                        if ((typeof event.specialKey !== 'undefined') && (
	                                event.specialKey !== 'UndoKey' || event.specialKey !== 'RedoKey'
	                            )) {
	                            event.preventDefault();
	                            textAngularManager.sendKeyCommand(scope, event);
	                        }
	                        /* istanbul ignore else: readonly check */
	                        if(!_isReadonly){
	                            if (event.specialKey==='UndoKey') {
	                                _undo();
	                                event.preventDefault();
	                            }
	                            if (event.specialKey==='RedoKey') {
	                                _redo();
	                                event.preventDefault();
	                            }
	                            /* istanbul ignore next: difficult to test as can't seem to select */
	                            if(event.keyCode === _ENTER_KEYCODE && !event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey)
	                            {
	                                var contains = function(a, obj) {
	                                    for (var i = 0; i < a.length; i++) {
	                                        if (a[i] === obj) {
	                                            return true;
	                                        }
	                                    }
	                                    return false;
	                                };
	                                var $selection;
	                                var selection = taSelection.getSelectionElement();
	                                // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                if(!selection.nodeName.match(VALIDELEMENTS)) return;
	                                var _new = angular.element(_defaultVal);
	                                // if we are in the last element of a blockquote, or ul or ol and the element is blank
	                                // we need to pull the element outside of the said type
	                                var moveOutsideElements = ['blockquote', 'ul', 'ol'];
	                                if (contains(moveOutsideElements, selection.parentNode.tagName.toLowerCase())) {
	                                    if (/^<br(|\/)>$/i.test(selection.innerHTML.trim()) && !selection.nextSibling) {
	                                        // if last element is blank, pull element outside.
	                                        $selection = angular.element(selection);
	                                        var _parent = $selection.parent();
	                                        _parent.after(_new);
	                                        $selection.remove();
	                                        if (_parent.children().length === 0) _parent.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                    if (/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim())) {
	                                        $selection = angular.element(selection);
	                                        $selection.after(_new);
	                                        $selection.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                }
	                            }
	                        }
	                    });
	                    var _keyupTimeout;
	                    element.on('keyup', scope.events.keyup = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        taSelection.setStateShiftKey(false);	// clear the ShiftKey state
	                        /* istanbul ignore next: FF specific bug fix */
	                        if (event.keyCode === _TAB_KEYCODE) {
	                            var _selection = taSelection.getSelection();
	                            if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                            return;
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _LEFT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateLeftArrowKey(element);
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _RIGHT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateRightArrowKey(element);
	                        }
	                        if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                        if(!_isReadonly && !BLOCKED_KEYS.test(event.keyCode)){
	                            /* istanbul ignore next: Ignore any _ENTER_KEYCODE that has ctrlKey, metaKey or alKey */
	                            if (event.keyCode === _ENTER_KEYCODE && (event.ctrlKey || event.metaKey || event.altKey)) {
	                                // we ignore any ENTER_	KEYCODE that is anything but plain or a shift one...
	                            } else {
	                                // if enter - insert new taDefaultWrap, if shift+enter insert <br/>
	                                if(_defaultVal !== '' && _defaultVal !== '<BR><BR>' && event.keyCode === _ENTER_KEYCODE && !event.ctrlKey && !event.metaKey && !event.altKey){
	                                    var selection = taSelection.getSelectionElement();
	                                    while(!selection.nodeName.match(VALIDELEMENTS) && selection !== element[0]){
	                                        selection = selection.parentNode;
	                                    }
	                                    if(!event.shiftKey){
	                                        // new paragraph, br should be caught correctly
	                                        // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                        //console.log('Enter', selection.nodeName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        if(selection.tagName.toLowerCase() !==
	                                            attrs.taDefaultWrap &&
	                                            selection.nodeName.toLowerCase() !== 'li' &&
	                                            (selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')
	                                        ) {
	                                            // Chrome starts with a <div><br></div> after an EnterKey
	                                            // so we replace this with the _defaultVal
	                                            var _new = angular.element(_defaultVal);
	                                            angular.element(selection).replaceWith(_new);
	                                            taSelection.setSelectionToElementStart(_new[0]);
	                                        }
	                                    } else {
	                                        // shift + Enter
	                                        var tagName = selection.tagName.toLowerCase();
	                                        //console.log('Shift+Enter', selection.tagName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        // For an LI: We see: LI p ....<br><br>
	                                        // For a P: We see: P p ....<br><br>
	                                        // on Safari, the browser ignores the Shift+Enter and acts just as an Enter Key
	                                        // For an LI: We see: LI p <br>
	                                        // For a P: We see: P p <br>
	                                        if((tagName === attrs.taDefaultWrap ||
	                                            tagName === 'li' ||
	                                            tagName === 'pre' ||
	                                            tagName === 'div') &&
	                                            !/.+<br><br>/.test(selection.innerHTML.trim())) {
	                                            var ps = selection.previousSibling;
	                                            //console.log('wrong....', ps);
	                                            // we need to remove this selection and fix the previousSibling up...
	                                            if (ps) {
	                                                ps.innerHTML = ps.innerHTML + '<br><br>';
	                                                angular.element(selection).remove();
	                                                taSelection.setSelectionToElementEnd(ps);
	                                            }
	                                        }
	                                    }
	                                }
	                                var val = _compileHtml();
	                                if(_defaultVal !== '' && (val.trim() === '' || val.trim() === '<br>')){
	                                    _setInnerHTML(_defaultVal);
	                                    taSelection.setSelectionToElementStart(element.children()[0]);
	                                }else if(val.substring(0, 1) !== '<' && attrs.taDefaultWrap !== ''){
	                                    /* we no longer do this, since there can be comments here and white space
	                                     var _savedSelection = rangy.saveSelection();
	                                     val = _compileHtml();
	                                     val = "<" + attrs.taDefaultWrap + ">" + val + "</" + attrs.taDefaultWrap + ">";
	                                     _setInnerHTML(val);
	                                     rangy.restoreSelection(_savedSelection);
	                                     */
	                                }
	                                var triggerUndo = _lastKey !== event.keyCode && UNDO_TRIGGER_KEYS.test(event.keyCode);
	                                if(_keyupTimeout) $timeout.cancel(_keyupTimeout);
	                                _keyupTimeout = $timeout(function() {
	                                    _setViewValue(val, triggerUndo, true);
	                                }, ngModelOptions.$options.debounce || 400);
	                                if(!triggerUndo) _undoKeyupTimeout = $timeout(function(){ ngModel.$undoManager.push(val); }, 250);
	                                _lastKey = event.keyCode;
	                            }
	                        }
	                    });
	
	                    // when there is a change from a spelling correction in the browser, the only
	                    // change that is seen is a 'input' and the $watch('html') sees nothing... So
	                    // we added this element.on('input') to catch this change and call the _setViewValue()
	                    // so the ngModel is updated and all works as it should.
	                    var _inputTimeout;
	                    element.on('input', function() {
	                        if (_compileHtml() !== ngModel.$viewValue) {
	                            // we wait a time now to allow the natural $watch('html') to handle this change
	                            // and then after a 1 second delay, if there is still a difference we will do the
	                            // _setViewValue() call.
	                            /* istanbul ignore if: can't test */
	                            if(_inputTimeout) $timeout.cancel(_inputTimeout);
	                            /* istanbul ignore next: cant' test? */
	                            _inputTimeout = $timeout(function() {
	                                var _savedSelection = rangy.saveSelection();
	                                var _val = _compileHtml();
	                                if (_val !== ngModel.$viewValue) {
	                                    //console.log('_setViewValue');
	                                    //console.log('old:', ngModel.$viewValue);
	                                    //console.log('new:', _val);
	                                    _setViewValue(_val, true);
	                                }
	                                // if the savedSelection marker is gone at this point, we cannot restore the selection!!!
	                                //console.log('rangy.restoreSelection', ngModel.$viewValue.length, _savedSelection);
	                                if (ngModel.$viewValue.length !== 0) {
	                                    rangy.restoreSelection(_savedSelection);
	                                }
	                            }, 1000);
	                        }
	                    });
	
	                    element.on('blur', scope.events.blur = function(){
	                        _focussed = false;
	                        /* istanbul ignore else: if readonly don't update model */
	                        if(!_isReadonly){
	                            _setViewValue(undefined, undefined, true);
	                        }else{
	                            _skipRender = true; // don't redo the whole thing, just check the placeholder logic
	                            ngModel.$render();
	                        }
	                    });
	
	                    // Placeholders not supported on ie 8 and below
	                    if(attrs.placeholder && (_browserDetect.ie > 8 || _browserDetect.ie === undefined)){
	                        var rule;
	                        if(attrs.id) rule = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');
	                        else throw('textAngular Error: An unique ID is required for placeholders to work');
	
	                        scope.$on('$destroy', function(){
	                            removeCSSRule(rule);
	                        });
	                    }
	
	                    element.on('focus', scope.events.focus = function(){
	                        _focussed = true;
	                        element.removeClass('placeholder-text');
	                        _reApplyOnSelectorHandlers();
	                    });
	
	                    element.on('mouseup', scope.events.mouseup = function(){
	                        var _selection = taSelection.getSelection();
	                        if(_selection && _selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                    });
	
	                    // prevent propagation on mousedown in editor, see #206
	                    element.on('mousedown', scope.events.mousedown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        event.stopPropagation();
	                    });
	                }
	            }
	
	            var fileDropHandler = function(event, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(event, eventData);
	                // emit the drop event, pass the element, preventing should be done elsewhere
	                if(!dropFired && !_isReadonly){
	                    dropFired = true;
	                    var dataTransfer;
	                    if(event.originalEvent) dataTransfer = event.originalEvent.dataTransfer;
	                    else dataTransfer = event.dataTransfer;
	                    scope.$emit('ta-drop-event', this, event, dataTransfer);
	                    $timeout(function(){
	                        dropFired = false;
	                        _setViewValue(undefined, undefined, true);
	                    }, 100);
	                }
	            };
	
	            var _renderTimeout;
	            var _renderInProgress = false;
	            // changes to the model variable from outside the html/text inputs
	            ngModel.$render = function(){
	                /* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
	                if(_renderInProgress) return;
	                else _renderInProgress = true;
	                // catch model being null or undefined
	                var val = ngModel.$viewValue || '';
	                // if the editor isn't focused it needs to be updated, otherwise it's receiving user input
	                if(!_skipRender){
	                    /* istanbul ignore else: in other cases we don't care */
	                    if(_isContentEditable && _focussed){
	                        // update while focussed
	                        element.removeClass('placeholder-text');
	                        /* istanbul ignore next: don't know how to test this */
	                        if(_renderTimeout) $timeout.cancel(_renderTimeout);
	                        _renderTimeout = $timeout(function(){
	                            /* istanbul ignore if: Can't be bothered testing this... */
	                            if(!_focussed){
	                                element[0].focus();
	                                taSelection.setSelectionToElementEnd(element.children()[element.children().length - 1]);
	                            }
	                            _renderTimeout = undefined;
	                        }, 1);
	                    }
	                    if(_isContentEditable){
	                        // WYSIWYG Mode
	                        if(attrs.placeholder){
	                            if(val === ''){
	                                // blank
	                                _setInnerHTML(_defaultVal);
	                            }else{
	                                // not-blank
	                                _setInnerHTML(val);
	                            }
	                        }else{
	                            _setInnerHTML((val === '') ? _defaultVal : val);
	                        }
	                        // if in WYSIWYG and readOnly we kill the use of links by clicking
	                        if(!_isReadonly){
	                            _reApplyOnSelectorHandlers();
	                            element.on('drop', fileDropHandler);
	                        }else{
	                            element.off('drop', fileDropHandler);
	                        }
	                    }else if(element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input'){
	                        // make sure the end user can SEE the html code as a display. This is a read-only display element
	                        _setInnerHTML(taApplyCustomRenderers(val));
	                    }else{
	                        // only for input and textarea inputs
	                        element.val(val);
	                    }
	                }
	                if(_isContentEditable && attrs.placeholder){
	                    if(val === ''){
	                        if(_focussed) element.removeClass('placeholder-text');
	                        else element.addClass('placeholder-text');
	                    }else{
	                        element.removeClass('placeholder-text');
	                    }
	                }
	                _renderInProgress = _skipRender = false;
	            };
	
	            if(attrs.taReadonly){
	                //set initial value
	                _isReadonly = scope.$eval(attrs.taReadonly);
	                if(_isReadonly){
	                    element.addClass('ta-readonly');
	                    // we changed to readOnly mode (taReadonly='true')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.attr('disabled', 'disabled');
	                    }
	                    if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                        element.removeAttr('contenteditable');
	                    }
	                }else{
	                    element.removeClass('ta-readonly');
	                    // we changed to NOT readOnly mode (taReadonly='false')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.removeAttr('disabled');
	                    }else if(_isContentEditable){
	                        element.attr('contenteditable', 'true');
	                    }
	                }
	                // taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
	                // Otherwise it is readonly by default
	                scope.$watch(attrs.taReadonly, function(newVal, oldVal){
	                    if(oldVal === newVal) return;
	                    if(newVal){
	                        element.addClass('ta-readonly');
	                        // we changed to readOnly mode (taReadonly='true')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.attr('disabled', 'disabled');
	                        }
	                        if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                            element.removeAttr('contenteditable');
	                        }
	                        // turn ON selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).on('click', selectorClickHandler);
	                        });
	                        element.off('drop', fileDropHandler);
	                    }else{
	                        element.removeClass('ta-readonly');
	                        // we changed to NOT readOnly mode (taReadonly='false')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.removeAttr('disabled');
	                        }else if(_isContentEditable){
	                            element.attr('contenteditable', 'true');
	                        }
	                        // remove the selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).off('click', selectorClickHandler);
	                        });
	                        element.on('drop', fileDropHandler);
	                    }
	                    _isReadonly = newVal;
	                });
	            }
	
	            // Initialise the selectableElements
	            // if in WYSIWYG and readOnly we kill the use of links by clicking
	            if(_isContentEditable && !_isReadonly){
	                angular.forEach(taSelectableElements, function(selector){
	                    element.find(selector).on('click', selectorClickHandler);
	                });
	                element.on('drop', fileDropHandler);
	            }
	        }
	    };
	}]);
	
	// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
	var dropFired = false;
	var textAngular = angular.module("textAngular", ['ngSanitize', 'textAngularSetup', 'textAngular.factories', 'textAngular.DOM', 'textAngular.validators', 'textAngular.taBind']); //This makes ngSanitize required
	
	textAngular.config([function(){
	    // clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	    angular.forEach(taTools, function(value, key){ delete taTools[key];	});
	}]);
	
	textAngular.directive("textAngular", [
	    '$compile', '$timeout', 'taOptions', 'taSelection', 'taExecCommand',
	    'textAngularManager', '$document', '$animate', '$log', '$q', '$parse',
	    function($compile, $timeout, taOptions, taSelection, taExecCommand,
	        textAngularManager, $document, $animate, $log, $q, $parse){
	        return {
	            require: '?ngModel',
	            scope: {},
	            restrict: "EA",
	            priority: 2, // So we override validators correctly
	            link: function(scope, element, attrs, ngModel){
	                // all these vars should not be accessable outside this directive
	                var _keydown, _keyup, _keypress, _mouseup, _focusin, _focusout,
	                    _originalContents, _editorFunctions,
	                    _serial = (attrs.serial) ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
	                    _taExecCommand, _resizeMouseDown, _updateSelectedStylesTimeout;
	                var _resizeTimeout;
	
	                scope._name = (attrs.name) ? attrs.name : 'textAngularEditor' + _serial;
	
	                var oneEvent = function(_element, event, action){
	                    $timeout(function(){
	                        _element.one(event, action);
	                    }, 100);
	                };
	                _taExecCommand = taExecCommand(attrs.taDefaultWrap);
	                // get the settings from the defaults and add our specific functions that need to be on the scope
	                angular.extend(scope, angular.copy(taOptions), {
	                    // wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
	                    wrapSelection: function(command, opt, isSelectableElementTool){
	                        // we restore the saved selection that was saved when focus was lost
	                        /* NOT FUNCTIONAL YET */
	                        /* textAngularManager.restoreFocusSelection(scope._name, scope); */
	                        if(command.toLowerCase() === "undo"){
	                            scope['$undoTaBindtaTextElement' + _serial]();
	                        }else if(command.toLowerCase() === "redo"){
	                            scope['$redoTaBindtaTextElement' + _serial]();
	                        }else{
	                            // catch errors like FF erroring when you try to force an undo with nothing done
	                            _taExecCommand(command, false, opt, scope.defaultTagAttributes);
	                            if(isSelectableElementTool){
	                                // re-apply the selectable tool events
	                                scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                            }
	                            // refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
	                            // You still have focus on the text/html input it just doesn't show up
	                            scope.displayElements.text[0].focus();
	                        }
	                    },
	                    showHtml: scope.$eval(attrs.taShowHtml) || false
	                });
	                // setup the options from the optional attributes
	                if(attrs.taFocussedClass)			scope.classes.focussed = attrs.taFocussedClass;
	                if(attrs.taTextEditorClass)			scope.classes.textEditor = attrs.taTextEditorClass;
	                if(attrs.taHtmlEditorClass)			scope.classes.htmlEditor = attrs.taHtmlEditorClass;
	                if(attrs.taDefaultTagAttributes){
	                    try	{
	                        //	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
	                        angular.extend(scope.defaultTagAttributes, angular.fromJson(attrs.taDefaultTagAttributes));
	                    } catch (error) {
	                        $log.error(error);
	                    }
	                }
	                // optional setup functions
	                if(attrs.taTextEditorSetup)			scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
	                if(attrs.taHtmlEditorSetup)			scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
	                // optional fileDropHandler function
	                if(attrs.taFileDrop)				scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);
	                else								scope.fileDropHandler = scope.defaultFileDropHandler;
	
	                _originalContents = element[0].innerHTML;
	                // clear the original content
	                element[0].innerHTML = '';
	
	                // Setup the HTML elements as variable references for use later
	                scope.displayElements = {
	                    // we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
	                    // wheras the input will ALLWAYS have the correct value.
	                    forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
	                    html: angular.element("<textarea></textarea>"),
	                    text: angular.element("<div></div>"),
	                    // other toolbased elements
	                    scrollWindow: angular.element("<div class='ta-scroll-window'></div>"),
	                    popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),
	                    popoverArrow: angular.element('<div class="arrow"></div>'),
	                    popoverContainer: angular.element('<div class="popover-content"></div>'),
	                    resize: {
	                        overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
	                        background: angular.element('<div class="ta-resizer-handle-background"></div>'),
	                        anchors: [
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')
	                        ],
	                        info: angular.element('<div class="ta-resizer-handle-info"></div>')
	                    }
	                };
	
	                // Setup the popover
	                scope.displayElements.popover.append(scope.displayElements.popoverArrow);
	                scope.displayElements.popover.append(scope.displayElements.popoverContainer);
	                scope.displayElements.scrollWindow.append(scope.displayElements.popover);
	
	                scope.displayElements.popover.on('mousedown', function(e, eventData){
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(e, eventData);
	                    // this prevents focusout from firing on the editor when clicking anything in the popover
	                    e.preventDefault();
	                    return false;
	                });
	
	                /* istanbul ignore next: popover resize and scroll events handled */
	                scope.handlePopoverEvents = function() {
	                    if (scope.displayElements.popover.css('display')==='block') {
	                        if(_resizeTimeout) $timeout.cancel(_resizeTimeout);
	                        _resizeTimeout = $timeout(function() {
	                            //console.log('resize', scope.displayElements.popover.css('display'));
	                            scope.reflowPopover(scope.resizeElement);
	                            scope.reflowResizeOverlay(scope.resizeElement);
	                        }, 100);
	                    }
	                };
	
	                /* istanbul ignore next: browser resize check */
	                angular.element(window).on('resize', scope.handlePopoverEvents);
	
	                /* istanbul ignore next: browser scroll check */
	                angular.element(window).on('scroll', scope.handlePopoverEvents);
	
	                // we want to know if a given node has a scrollbar!
	                // credit to lotif on http://stackoverflow.com/questions/4880381/check-whether-html-element-has-scrollbars
	                var isScrollable = function(node) {
	                    var cs;
	                    var _notScrollable = {
	                        vertical: false,
	                        horizontal: false,
	                    };
	                    try {
	                        cs = window.getComputedStyle(node);
	                        if (cs === null) {
	                            return _notScrollable;
	                        }
	                    } catch (e) {
	                        /* istanbul ignore next: error handler */
	                        return _notScrollable;
	                    }
	                    var overflowY = cs['overflow-y'];
	                    var overflowX = cs['overflow-x'];
	                    return {
	                        vertical: (overflowY === 'scroll' || overflowY === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollHeight > node.clientHeight,
	                        horizontal: (overflowX === 'scroll' || overflowX === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollWidth > node.clientWidth,
	                    };
	                };
	
	                // getScrollTop
	                //
	                // we structure this so that it can climb the parents of the _el and when it finds
	                // one with scrollbars, it adds an EventListener, so that no matter how the
	                // DOM is structured in the user APP, if there is a scrollbar not as part of the
	                // ta-scroll-window, we will still capture the 'scroll' events...
	                // and handle the scroll event properly and do the resize, etc.
	                //
	                scope.getScrollTop = function (_el, bAddListener) {
	                    var scrollTop = _el.scrollTop;
	                    if (typeof scrollTop === 'undefined') {
	                        scrollTop = 0;
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar */
	                    if (bAddListener && isScrollable(_el).vertical) {
	                        // remove element eventListener
	                        _el.removeEventListener('scroll', scope._scrollListener, false);
	                        _el.addEventListener('scroll', scope._scrollListener, false);
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar and scrolled */
	                    if (scrollTop !== 0) {
	                        return { node:_el.nodeName, top:scrollTop };
	                    }
	                    /* istanbul ignore else: catches only if no scroll */
	                    if (_el.parentNode) {
	                        return scope.getScrollTop(_el.parentNode, bAddListener);
	                    } else {
	                        return { node:'<none>', top:0 };
	                    }
	                };
	
	                // define the popover show and hide functions
	                scope.showPopover = function(_el){
	                    scope.getScrollTop(scope.displayElements.scrollWindow[0], true);
	                    scope.displayElements.popover.css('display', 'block');
	                    // we must use a $timeout here, or the css change to the
	                    // displayElements.resize.overlay will not take!!!
	                    // WHY???
	                    $timeout(function() {
	                        scope.displayElements.resize.overlay.css('display', 'block');
	                    });
	                    scope.resizeElement = _el;
	                    scope.reflowPopover(_el);
	                    $animate.addClass(scope.displayElements.popover, 'in');
	                    oneEvent($document.find('body'), 'click keyup', function(){scope.hidePopover();});
	                };
	
	                /* istanbul ignore next: browser scroll event handler */
	                scope._scrollListener = function (e, eventData){
	                    scope.handlePopoverEvents();
	                };
	
	                scope.reflowPopover = function(_el){
	                    var scrollTop = scope.getScrollTop(scope.displayElements.scrollWindow[0], false);
	                    var spaceAboveImage = _el[0].offsetTop-scrollTop.top;
	                    //var spaceBelowImage = scope.displayElements.text[0].offsetHeight - _el[0].offsetHeight - spaceAboveImage;
	                    //console.log(spaceAboveImage, spaceBelowImage);
	
	                    /* istanbul ignore if: catches only if near bottom of editor */
	                    if(spaceAboveImage < 51) {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('top').addClass('bottom');
	                    } else {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('bottom').addClass('top');
	                    }
	                    var _maxLeft = scope.displayElements.text[0].offsetWidth - scope.displayElements.popover[0].offsetWidth;
	                    var _targetLeft = _el[0].offsetLeft + (_el[0].offsetWidth / 2.0) - (scope.displayElements.popover[0].offsetWidth / 2.0);
	                    var _rleft = Math.max(0, Math.min(_maxLeft, _targetLeft));
	                    var _marginLeft = (Math.min(_targetLeft, (Math.max(0, _targetLeft - _maxLeft))) - 11);
	                    _rleft += window.scrollX;
	                    _marginLeft -= window.scrollX;
	                    scope.displayElements.popover.css('left', _rleft + 'px');
	                    scope.displayElements.popoverArrow.css('margin-left', _marginLeft + 'px');
	                };
	                scope.hidePopover = function(){
	                    scope.displayElements.popover.css('display', 'none');
	                    scope.displayElements.popoverContainer.attr('style', '');
	                    scope.displayElements.popoverContainer.attr('class', 'popover-content');
	                    scope.displayElements.popover.removeClass('in');
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // setup the resize overlay
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
	                angular.forEach(scope.displayElements.resize.anchors, function(anchor){ scope.displayElements.resize.overlay.append(anchor);});
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
	                scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);
	
	                // A click event on the resize.background will now shift the focus to the editor
	                /* istanbul ignore next: click on the resize.background to focus back to editor */
	                scope.displayElements.resize.background.on('click', function(e) {
	                    scope.displayElements.text[0].focus();
	                });
	
	                // define the show and hide events
	                scope.reflowResizeOverlay = function(_el){
	                    _el = angular.element(_el)[0];
	                    scope.displayElements.resize.overlay.css({
	                        'display': 'block',
	                        'left': _el.offsetLeft - 5 + 'px',
	                        'top': _el.offsetTop - 5 + 'px',
	                        'width': _el.offsetWidth + 10 + 'px',
	                        'height': _el.offsetHeight + 10 + 'px'
	                    });
	                    scope.displayElements.resize.info.text(_el.offsetWidth + ' x ' + _el.offsetHeight);
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.showResizeOverlay = function(_el){
	                    var _body = $document.find('body');
	                    _resizeMouseDown = function(event){
	                        var startPosition = {
	                            width: parseInt(_el.attr('width')),
	                            height: parseInt(_el.attr('height')),
	                            x: event.clientX,
	                            y: event.clientY
	                        };
	                        if(startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
	                        if(startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
	                        scope.hidePopover();
	                        var ratio = startPosition.height / startPosition.width;
	                        var mousemove = function(event){
	                            // calculate new size
	                            var pos = {
	                                x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
	                                y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
	                            };
	
	                            // DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
	                            //
	                            // attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
	                            var bForceAspectRatio = (attrs.taResizeForceAspectRatio !== undefined);
	                            // attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
	                            // unless the Shift key is pressed
	                            var bFlipKeyBinding = attrs.taResizeMaintainAspectRatio;
	                            var bKeepRatio =  bForceAspectRatio || (bFlipKeyBinding && !event.shiftKey);
	                            if(bKeepRatio) {
	                                var newRatio = pos.y / pos.x;
	                                pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
	                                pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
	                            }
	                            var el = angular.element(_el);
	                            function roundedMaxVal(val) {
	                                return Math.round(Math.max(0, val));
	                            }
	                            el.css('height', roundedMaxVal(pos.y) + 'px');
	                            el.css('width', roundedMaxVal(pos.x) + 'px');
	
	                            // reflow the popover tooltip
	                            scope.reflowResizeOverlay(_el);
	                        };
	                        _body.on('mousemove', mousemove);
	                        oneEvent(_body, 'mouseup', function(event){
	                            event.preventDefault();
	                            event.stopPropagation();
	                            _body.off('mousemove', mousemove);
	                            // at this point, we need to force the model to update! since the css has changed!
	                            // this fixes bug: #862 - we now hide the popover -- as this seems more consitent.
	                            // there are still issues under firefox, the window does not repaint. -- not sure
	                            // how best to resolve this, but clicking anywhere works.
	                            scope.$apply(function (){
	                                scope.hidePopover();
	                                scope.updateTaBindtaTextElement();
	                            }, 100);
	                        });
	                        event.stopPropagation();
	                        event.preventDefault();
	                    };
	
	                    scope.displayElements.resize.anchors[3].off('mousedown');
	                    scope.displayElements.resize.anchors[3].on('mousedown', _resizeMouseDown);
	
	                    scope.reflowResizeOverlay(_el);
	                    oneEvent(_body, 'click', function(){scope.hideResizeOverlay();});
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.hideResizeOverlay = function(){
	                    scope.displayElements.resize.anchors[3].off('mousedown', _resizeMouseDown);
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // allow for insertion of custom directives on the textarea and div
	                scope.setup.htmlEditorSetup(scope.displayElements.html);
	                scope.setup.textEditorSetup(scope.displayElements.text);
	                scope.displayElements.html.attr({
	                    'id': 'taHtmlElement' + _serial,
	                    'ng-show': 'showHtml',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.text.attr({
	                    'id': 'taTextElement' + _serial,
	                    'contentEditable': 'true',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.scrollWindow.attr({'ng-hide': 'showHtml'});
	                if(attrs.taDefaultWrap) {
	                    // taDefaultWrap is only applied to the text and not the html view
	                    scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);
	                }
	
	                if(attrs.taUnsafeSanitizer){
	                    scope.displayElements.text.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                    scope.displayElements.html.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                }
	
	                if(attrs.taKeepStyles){
	                    scope.displayElements.text.attr('ta-keep-styles', attrs.taKeepStyles);
	                    scope.displayElements.html.attr('ta-keep-styles', attrs.taKeepStyles);
	                }
	
	                // add the main elements to the origional element
	                scope.displayElements.scrollWindow.append(scope.displayElements.text);
	                element.append(scope.displayElements.scrollWindow);
	                element.append(scope.displayElements.html);
	
	                scope.displayElements.forminput.attr('name', scope._name);
	                element.append(scope.displayElements.forminput);
	
	                if(attrs.tabindex){
	                    element.removeAttr('tabindex');
	                    scope.displayElements.text.attr('tabindex', attrs.tabindex);
	                    scope.displayElements.html.attr('tabindex', attrs.tabindex);
	                }
	
	                if (attrs.placeholder) {
	                    scope.displayElements.text.attr('placeholder', attrs.placeholder);
	                    scope.displayElements.html.attr('placeholder', attrs.placeholder);
	                }
	
	                if(attrs.taDisabled){
	                    scope.displayElements.text.attr('ta-readonly', 'disabled');
	                    scope.displayElements.html.attr('ta-readonly', 'disabled');
	                    scope.disabled = scope.$parent.$eval(attrs.taDisabled);
	                    scope.$parent.$watch(attrs.taDisabled, function(newVal){
	                        scope.disabled = newVal;
	                        if(scope.disabled){
	                            element.addClass(scope.classes.disabled);
	                        }else{
	                            element.removeClass(scope.classes.disabled);
	                        }
	                    });
	                }
	
	                if(attrs.taPaste){
	                    scope._pasteHandler = function(_html){
	                        return $parse(attrs.taPaste)(scope.$parent, {$html: _html});
	                    };
	                    scope.displayElements.text.attr('ta-paste', '_pasteHandler($html)');
	                }
	
	                // compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
	                $compile(scope.displayElements.scrollWindow)(scope);
	                $compile(scope.displayElements.html)(scope);
	
	                scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
	                scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];
	
	                // add the classes manually last
	                element.addClass("ta-root");
	                scope.displayElements.scrollWindow.addClass("ta-text ta-editor " + scope.classes.textEditor);
	                scope.displayElements.html.addClass("ta-html ta-editor " + scope.classes.htmlEditor);
	
	                var testAndSet = function(choice, beforeState) {
	                    /* istanbul ignore next: this is only here because of a bug in rangy where rangy.saveSelection() has cleared the state */
	                    if (beforeState !== $document[0].queryCommandState(choice)) {
	                        $document[0].execCommand(choice, false, null);
	                    }
	                };
	                // used in the toolbar actions
	                scope._actionRunning = false;
	                var _savedSelection = false;
	                scope.startAction = function(){
	                    var _beforeStateBold = false;
	                    var _beforeStateItalic = false;
	                    var _beforeStateUnderline = false;
	                    var _beforeStateStrikethough = false;
	                    scope._actionRunning = true;
	                    _beforeStateBold = $document[0].queryCommandState('bold');
	                    _beforeStateItalic = $document[0].queryCommandState('italic');
	                    _beforeStateUnderline = $document[0].queryCommandState('underline');
	                    _beforeStateStrikethough = $document[0].queryCommandState('strikeThrough');
	                    //console.log('B', _beforeStateBold, 'I', _beforeStateItalic, '_', _beforeStateUnderline, 'S', _beforeStateStrikethough);
	                    // if rangy library is loaded return a function to reload the current selection
	                    _savedSelection = rangy.saveSelection();
	                    // rangy.saveSelection() clear the state of bold, italic, underline, strikethrough
	                    // so we reset them here....!!!
	                    // this fixes bugs #423, #1129, #1105, #693 which are actually rangy bugs!
	                    testAndSet('bold', _beforeStateBold);
	                    testAndSet('italic', _beforeStateItalic);
	                    testAndSet('underline', _beforeStateUnderline);
	                    testAndSet('strikeThrough', _beforeStateStrikethough);
	                    //console.log('B', $document[0].queryCommandState('bold'), 'I', $document[0].queryCommandState('italic'), '_', $document[0].queryCommandState('underline'), 'S', $document[0].queryCommandState('strikeThrough') );
	                    return function(){
	                        if(_savedSelection) rangy.restoreSelection(_savedSelection);
	                        // perhaps if we restore the selections here, we would do better overall???
	                        // BUT what we do above does well in 90% of the cases...
	                    };
	                };
	                scope.endAction = function(){
	                    scope._actionRunning = false;
	                    if(_savedSelection){
	                        if(scope.showHtml){
	                            scope.displayElements.html[0].focus();
	                        }else{
	                            scope.displayElements.text[0].focus();
	                        }
	                        // rangy.restoreSelection(_savedSelection);
	                        rangy.removeMarkers(_savedSelection);
	                    }
	                    _savedSelection = false;
	                    scope.updateSelectedStyles();
	                    // only update if in text or WYSIWYG mode
	                    if(!scope.showHtml) scope['updateTaBindtaTextElement' + _serial]();
	                };
	
	                // note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
	                // cascades to displayElements.text and displayElements.html automatically.
	                _focusin = function(e){
	                    scope.focussed = true;
	                    element.addClass(scope.classes.focussed);
	/*******  NOT FUNCTIONAL YET
	                    if (e.target.id === 'taTextElement' + _serial) {
	                        console.log('_focusin taTextElement');
	                        // we only do this if NOT focussed
	                        textAngularManager.restoreFocusSelection(scope._name);
	                    }
	*******/
	                    _editorFunctions.focus();
	                    element.triggerHandler('focus');
	                    // we call editorScope.updateSelectedStyles() here because we want the toolbar to be focussed
	                    // as soon as we have focus.  Otherwise this only happens on mousedown or keydown etc...
	                    /* istanbul ignore else: don't run if already running */
	                    if(scope.updateSelectedStyles && !scope._bUpdateSelectedStyles){
	                        // we don't set editorScope._bUpdateSelectedStyles here, because we do not want the
	                        // updateSelectedStyles() to run twice which it will do after 200 msec if we have
	                        // set editorScope._bUpdateSelectedStyles
	                        //
	                        // WOW, normally I would do a scope.$apply here, but this causes ERRORs when doing tests!
	                        $timeout(function () {
	                            scope.updateSelectedStyles();
	                        }, 0);
	                    }
	                };
	                scope.displayElements.html.on('focus', _focusin);
	                scope.displayElements.text.on('focus', _focusin);
	                _focusout = function(e){
	                    /****************** NOT FUNCTIONAL YET
	                    try {
	                        var _s = rangy.getSelection();
	                        if (_s) {
	                            // we save the selection when we loose focus so that if do a wrapSelection, the
	                            // apropriate selection in the editor is restored before action.
	                            var _savedFocusRange = rangy.saveRange(_s.getRangeAt(0));
	                            textAngularManager.saveFocusSelection(scope._name, _savedFocusRange);
	                        }
	                    } catch(error) { }
	                    *****************/
	                    // if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
	                    if(!scope._actionRunning &&
	                        $document[0].activeElement !== scope.displayElements.html[0] &&
	                        $document[0].activeElement !== scope.displayElements.text[0])
	                    {
	                        element.removeClass(scope.classes.focussed);
	                        _editorFunctions.unfocus();
	                        // to prevent multiple apply error defer to next seems to work.
	                        $timeout(function(){
	                            scope._bUpdateSelectedStyles = false;
	                            element.triggerHandler('blur');
	                            scope.focussed = false;
	                        }, 0);
	                    }
	                    e.preventDefault();
	                    return false;
	                };
	                scope.displayElements.html.on('blur', _focusout);
	                scope.displayElements.text.on('blur', _focusout);
	
	                scope.displayElements.text.on('paste', function(event){
	                    element.triggerHandler('paste', event);
	                });
	
	                // Setup the default toolbar tools, this way allows the user to add new tools like plugins.
	                // This is on the editor for future proofing if we find a better way to do this.
	                scope.queryFormatBlockState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return !scope.showHtml && command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
	                };
	                scope.queryCommandState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return (!scope.showHtml) ? $document[0].queryCommandState(command) : '';
	                };
	                scope.switchView = function(){
	                    scope.showHtml = !scope.showHtml;
	                    $animate.enabled(false, scope.displayElements.html);
	                    $animate.enabled(false, scope.displayElements.text);
	                    //Show the HTML view
	                    /* istanbul ignore next: ngModel exists check */
	/* THIS is not the correct thing to do, here....
	   The ngModel is correct, but it is not formatted as the user as done it...
	                    var _model;
	                    if (ngModel) {
	                        _model = ngModel.$viewValue;
	                    } else {
	                        _model = scope.html;
	                    }
	                    var _html = scope.displayElements.html[0].value;
	                    if (getDomFromHtml(_html).childElementCount !== getDomFromHtml(_model).childElementCount) {
	                        // the model and the html do not agree
	                        // they can get out of sync and when they do, we correct that here...
	                        scope.displayElements.html.val(_model);
	                    }
	*/
	                    if(scope.showHtml){
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.html[0].focus();
	                        }, 100);
	                    }else{
	                        //Show the WYSIWYG view
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.text[0].focus();
	                        }, 100);
	                    }
	                };
	
	                // changes to the model variable from outside the html/text inputs
	                // if no ngModel, then the only input is from inside text-angular
	                if(attrs.ngModel){
	                    var _firstRun = true;
	                    ngModel.$render = function(){
	                        if(_firstRun){
	                            // we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
	                            _firstRun = false;
	                            // if view value is null or undefined initially and there was original content, set to the original content
	                            var _initialValue = scope.$parent.$eval(attrs.ngModel);
	                            if((_initialValue === undefined || _initialValue === null) && (_originalContents && _originalContents !== '')){
	                                // on passing through to taBind it will be sanitised
	                                ngModel.$setViewValue(_originalContents);
	                            }
	                        }
	                        scope.displayElements.forminput.val(ngModel.$viewValue);
	                        // if the editors aren't focused they need to be updated, otherwise they are doing the updating
	                        scope.html = ngModel.$viewValue || '';
	                    };
	                    // trigger the validation calls
	                    if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                        var value = modelValue || viewValue;
	                        return !(!value || value.trim() === '');
	                    };
	                }else{
	                    // if no ngModel then update from the contents of the origional html.
	                    scope.displayElements.forminput.val(_originalContents);
	                    scope.html = _originalContents;
	                }
	
	                // changes from taBind back up to here
	                scope.$watch('html', function(newValue, oldValue){
	                    if(newValue !== oldValue){
	                        if(attrs.ngModel && ngModel.$viewValue !== newValue) {
	                            ngModel.$setViewValue(newValue);
	                        }
	                        scope.displayElements.forminput.val(newValue);
	                    }
	                });
	
	                if(attrs.taTargetToolbars) {
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, attrs.taTargetToolbars.split(','));
	                }
	                else{
	                    var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
	                    // passthrough init of toolbar options
	                    if(attrs.taToolbar)						_toolbar.attr('ta-toolbar', attrs.taToolbar);
	                    if(attrs.taToolbarClass)				_toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
	                    if(attrs.taToolbarGroupClass)			_toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
	                    if(attrs.taToolbarButtonClass)			_toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
	                    if(attrs.taToolbarActiveButtonClass)	_toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
	                    if(attrs.taFocussedClass)				_toolbar.attr('ta-focussed-class', attrs.taFocussedClass);
	
	                    element.prepend(_toolbar);
	                    $compile(_toolbar)(scope.$parent);
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, ['textAngularToolbar' + _serial]);
	                }
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterEditor(scope._name);
	                    angular.element(window).off('blur');
	                    angular.element(window).off('resize', scope.handlePopoverEvents);
	                    angular.element(window).off('scroll', scope.handlePopoverEvents);
	                });
	
	                // catch element select event and pass to toolbar tools
	                scope.$on('ta-element-select', function(event, element){
	                    if(_editorFunctions.triggerElementSelect(event, element)){
	                        scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                    }
	                });
	
	/******************* no working fully
	                var distanceFromPoint = function (px, py, x, y) {
	                    return Math.sqrt((px-x)*(px-x)+(py-y)*(py-y));
	                };
	                // because each object is a rectangle and we have a single point,
	                // we need to give priority if the point is inside the rectangle
	                var getPositionDistance = function(el, x, y) {
	                    var range = document.createRange();
	                    range.selectNode(el);
	                    var rect = range.getBoundingClientRect();
	                    console.log(el, rect);
	                    range.detach();
	                    var bcr = rect;
	                    // top left
	                    var d1 = distanceFromPoint(bcr.left, bcr.top, x, y);
	                    // bottom left
	                    var d2 = distanceFromPoint(bcr.left, bcr.bottom, x, y);
	                    // top right
	                    var d3 = distanceFromPoint(bcr.right, bcr.top, x, y);
	                    // bottom right
	                    var d4 = distanceFromPoint(bcr.right, bcr.bottom, x, y);
	                    return Math.min(d1, d2, d3, d4);
	                };
	                var findClosest = function(el, minElement, maxDistance, x, y) {
	                    var _d=0;
	                    for (var i = 0; i < el.childNodes.length; i++) {
	                        var _n = el.childNodes[i];
	                        if (!_n.childNodes.length) {
	                            _d = getPositionDistance(_n, x, y);
	                            //console.log(_n, _n.childNodes, _d);
	                            if (_d < maxDistance) {
	                                maxDistance = _d;
	                                minElement = _n;
	                            }
	                        }
	                        var res = findClosest(_n, minElement, maxDistance, x, y);
	                        if (res.max < maxDistance) {
	                            maxDistance = res.max;
	                            minElement = res.min;
	                        }
	                    }
	                    return { max: maxDistance, min: minElement };
	                };
	                var getClosestElement = function (el, x, y) {
	                    return findClosest(el, null, 12341234124, x, y);
	                };
	****************/
	
	                scope.$on('ta-drop-event', function(event, element, dropEvent, dataTransfer){
	                    if(dataTransfer && dataTransfer.files && dataTransfer.files.length > 0){
	                        scope.displayElements.text[0].focus();
	                        // we must set the location of the drop!
	                        //console.log(dropEvent.clientX, dropEvent.clientY, dropEvent.target);
	                        taSelection.setSelectionToElementEnd(dropEvent.target);
	                        angular.forEach(dataTransfer.files, function(file){
	                            // taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
	                            // If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
	                            // Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
	                            try{
	                                $q.when(scope.fileDropHandler(file, scope.wrapSelection) ||
	                                    (scope.fileDropHandler !== scope.defaultFileDropHandler &&
	                                    $q.when(scope.defaultFileDropHandler(file, scope.wrapSelection)))).then(function(){
	                                        scope['updateTaBindtaTextElement' + _serial]();
	                                    });
	                            }catch(error){
	                                $log.error(error);
	                            }
	                        });
	                        dropEvent.preventDefault();
	                        dropEvent.stopPropagation();
	                    /* istanbul ignore else, the updates if moved text */
	                    }else{
	                        $timeout(function(){
	                            scope['updateTaBindtaTextElement' + _serial]();
	                        }, 0);
	                    }
	                });
	
	                // the following is for applying the active states to the tools that support it
	                scope._bUpdateSelectedStyles = false;
	                /* istanbul ignore next: browser window/tab leave check */
	                angular.element(window).on('blur', function(){
	                    scope._bUpdateSelectedStyles = false;
	                    scope.focussed = false;
	                });
	                // loop through all the tools polling their activeState function if it exists
	                scope.updateSelectedStyles = function(){
	                    var _selection;
	                    /* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
	                    if(_updateSelectedStylesTimeout) $timeout.cancel(_updateSelectedStylesTimeout);
	                    // test if the common element ISN'T the root ta-text node
	                    if((_selection = taSelection.getSelectionElement()) !== undefined && _selection.parentNode !== scope.displayElements.text[0]){
	                        _editorFunctions.updateSelectedStyles(angular.element(_selection));
	                    }else _editorFunctions.updateSelectedStyles();
	                    // used to update the active state when a key is held down, ie the left arrow
	                    /* istanbul ignore else: browser only check */
	                    if(scope._bUpdateSelectedStyles) _updateSelectedStylesTimeout = $timeout(scope.updateSelectedStyles, 200);
	                };
	                // start updating on keydown
	                _keydown = function(){
	                    /* istanbul ignore next: ie catch */
	                    if(!scope.focussed){
	                        scope._bUpdateSelectedStyles = false;
	                        return;
	                    }
	                    /* istanbul ignore else: don't run if already running */
	                    if(!scope._bUpdateSelectedStyles){
	                        scope._bUpdateSelectedStyles = true;
	                        scope.$apply(function(){
	                            scope.updateSelectedStyles();
	                        });
	                    }
	                };
	                scope.displayElements.html.on('keydown', _keydown);
	                scope.displayElements.text.on('keydown', _keydown);
	                // stop updating on key up and update the display/model
	                _keyup = function(){
	                    scope._bUpdateSelectedStyles = false;
	                };
	                scope.displayElements.html.on('keyup', _keyup);
	                scope.displayElements.text.on('keyup', _keyup);
	                // stop updating on key up and update the display/model
	                _keypress = function(event, eventData){
	                    // bug fix for Firefox.  If we are selecting a <a> already, any characters will
	                    // be added within the <a> which is bad!
	                    /* istanbul ignore next: don't see how to test this... */
	                    if (taSelection.getSelection) {
	                        var _selection = taSelection.getSelection();
	                        // in a weird case (can't reproduce) taSelection.getSelectionElement() can be undefined!!
	                        // this comes from range.commonAncestorContainer;
	                        // so I check for this here which fixes the error case
	                        if (taSelection.getSelectionElement() && taSelection.getSelectionElement().nodeName.toLowerCase() === 'a') {
	                            // check and see if we are at the edge of the <a>
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.element.textContent.length === _selection.end.offset) {
	                                // we are at the end of the <a>!!!
	                                // so move the selection to after the <a>!!
	                                taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                            }
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.offset === 0) {
	                                // we are at the start of the <a>!!!
	                                // so move the selection before the <a>!!
	                                taSelection.setSelectionBeforeElement(taSelection.getSelectionElement());
	                            }
	                        }
	                    }
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(event, eventData);
	                    scope.$apply(function(){
	                        if(_editorFunctions.sendKeyCommand(event)){
	                            /* istanbul ignore else: don't run if already running */
	                            if(!scope._bUpdateSelectedStyles){
	                                scope.updateSelectedStyles();
	                            }
	                            event.preventDefault();
	                            return false;
	                        }
	                    });
	                };
	                scope.displayElements.html.on('keypress', _keypress);
	                scope.displayElements.text.on('keypress', _keypress);
	                // update the toolbar active states when we click somewhere in the text/html boxed
	                _mouseup = function(){
	                    // ensure only one execution of updateSelectedStyles()
	                    scope._bUpdateSelectedStyles = false;
	                    // for some reason, unless we do a $timeout here, after a _mouseup when the line is
	                    // highlighted, and instead use a scope.$apply(function(){ scope.updateSelectedStyles(); });
	                    // doesn't work properly, so we replaced this with:
	                    /* istanbul ignore next: not tested  */
	                    $timeout(function() { scope.updateSelectedStyles(); }, 0);
	                };
	                scope.displayElements.html.on('mouseup', _mouseup);
	                scope.displayElements.text.on('mouseup', _mouseup);
	            }
	        };
	    }
	]);
	textAngular.service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool', '$interval', '$rootScope', '$log',
	    function(taToolExecuteAction, taTools, taRegisterTool, $interval, $rootScope, $log){
	    // this service is used to manage all textAngular editors and toolbars.
	    // All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	    // these contain references to all the editors and toolbars that have been initialised in this app
	    var toolbars = {}, editors = {};
	    // we touch the time any change occurs through register of an editor or tool so that we
	    // in the future will fire and event to trigger an updateSelection
	    var timeRecentModification = 0;
	    var updateStyles = function(selectedElement){
	        angular.forEach(editors, function(editor) {
	            editor.editorFunctions.updateSelectedStyles(selectedElement);
	        });
	    };
	    var triggerInterval = 50;
	    var triggerIntervalTimer;
	    var setupTriggerUpdateStyles = function() {
	        timeRecentModification = Date.now();
	        /* istanbul ignore next: setup a one time updateStyles() */
	        triggerIntervalTimer = $interval(function() {
	            updateStyles();
	            triggerIntervalTimer = undefined;
	        }, triggerInterval, 1); // only trigger once
	    };
	    /* istanbul ignore next: make sure clean up on destroy */
	    $rootScope.$on('destroy', function() {
	        if (triggerIntervalTimer) {
	            $interval.cancel(triggerIntervalTimer);
	            triggerIntervalTimer = undefined;
	        }
	    });
	    var touchModification = function() {
	        if (Math.abs(Date.now() - timeRecentModification) > triggerInterval) {
	            // we have already triggered the updateStyles a long time back... so setup it again...
	            setupTriggerUpdateStyles();
	        }
	    };
	    // when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	    // We also need to set the tools to be updated to be the toolbars...
	    return {
	        // register an editor and the toolbars that it is affected by
	        registerEditor: function(editorName, editorScope, targetToolbars){
	            // NOTE: name === editorScope._name
	            // targetToolbars is an [] of 'toolbar name's
	            // targetToolbars are optional, we don't require a toolbar to function
	            if(!editorName || editorName === '') throw('textAngular Error: An editor requires a name');
	            if(!editorScope) throw('textAngular Error: An editor requires a scope');
	            if(editors[editorName]) throw('textAngular Error: An Editor with name "' + editorName + '" already exists');
	            editors[editorName] = {
	                scope: editorScope,
	                toolbars: targetToolbars,
	                // toolbarScopes used by this editor
	                toolbarScopes: [],
	                _registerToolbarScope: function(toolbarScope){
	                    // add to the list late
	                    if(this.toolbars.indexOf(toolbarScope.name) >= 0) {
	                        // if this toolbarScope is being used by this editor we add it as one of the scopes
	                        this.toolbarScopes.push(toolbarScope);
	                    }
	                },
	                // this is a suite of functions the editor should use to update all it's linked toolbars
	                editorFunctions: {
	                    disable: function(){
	                        // disable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                        });
	                    },
	                    enable: function(){
	                        // enable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = false;
	                        });
	                    },
	                    focus: function(){
	                        // this should be called when the editor is focussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope._parent = editorScope;
	                            toolbarScope.disabled = false;
	                            toolbarScope.focussed = true;
	                        });
	                        editorScope.focussed = true;
	                    },
	                    unfocus: function(){
	                        // this should be called when the editor becomes unfocussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                            toolbarScope.focussed = false;
	                        });
	                        editorScope.focussed = false;
	                    },
	                    updateSelectedStyles: function(selectedElement){
	                        // update the active state of all buttons on liked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            angular.forEach(toolbarScope.tools, function(toolScope){
	                                if(toolScope.activeState){
	                                    toolbarScope._parent = editorScope;
	                                    // selectedElement may be undefined if nothing selected
	                                    toolScope.active = toolScope.activeState(selectedElement);
	                                }
	                            });
	                        });
	                    },
	                    sendKeyCommand: function(event){
	                        // we return true if we applied an action, false otherwise
	                        var result = false;
	                        if(event.ctrlKey || event.metaKey || event.specialKey) angular.forEach(taTools, function(tool, name){
	                            if(tool.commandKeyCode && (tool.commandKeyCode === event.which || tool.commandKeyCode === event.specialKey)){
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        taToolExecuteAction.call(editors[editorName].toolbarScopes[_t].tools[name], editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                            }
	                        });
	                        return result;
	                    },
	                    triggerElementSelect: function(event, element){
	                        // search through the taTools to see if a match for the tag is made.
	                        // if there is, see if the tool is on a registered toolbar and not disabled.
	                        // NOTE: This can trigger on MULTIPLE tools simultaneously.
	                        var elementHasAttrs = function(_element, attrs){
	                            var result = true;
	                            for(var i = 0; i < attrs.length; i++) result = result && _element.attr(attrs[i]);
	                            return result;
	                        };
	                        var workerTools = [];
	                        var unfilteredTools = {};
	                        var result = false;
	                        element = angular.element(element);
	                        // get all valid tools by element name, keep track if one matches the
	                        var onlyWithAttrsFilter = false;
	                        angular.forEach(taTools, function(tool, name){
	                            if(
	                                tool.onElementSelect &&
	                                tool.onElementSelect.element &&
	                                tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() &&
	                                (!tool.onElementSelect.filter || tool.onElementSelect.filter(element))
	                            ){
	                                // this should only end up true if the element matches the only attributes
	                                onlyWithAttrsFilter = onlyWithAttrsFilter ||
	                                    (angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs));
	                                if(!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) unfilteredTools[name] = tool;
	                            }
	                        });
	                        // if we matched attributes to filter on, then filter, else continue
	                        if(onlyWithAttrsFilter){
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                if(tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) workerTools.push({'name': name, 'tool': tool});
	                            });
	                            // sort most specific (most attrs to find) first
	                            workerTools.sort(function(a,b){
	                                return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
	                            });
	                        }else{
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                workerTools.push({'name': name, 'tool': tool});
	                            });
	                        }
	                        // Run the actions on the first visible filtered tool only
	                        if(workerTools.length > 0){
	                            for(var _i = 0; _i < workerTools.length; _i++){
	                                var tool = workerTools[_i].tool;
	                                var name = workerTools[_i].name;
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        tool.onElementSelect.action.call(editors[editorName].toolbarScopes[_t].tools[name], event, element, editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                                if(result) break;
	                            }
	                        }
	                        return result;
	                    }
	                }
	            };
	            angular.forEach(targetToolbars, function(_name){
	                if(toolbars[_name]) {
	                    editors[editorName].toolbarScopes.push(toolbars[_name]);
	                }
	                // if it doesn't exist it may not have been compiled yet and it will be added later
	            });
	            touchModification();
	            return editors[editorName].editorFunctions;
	        },
	        // retrieve editor by name, largely used by testing suites only
	        retrieveEditor: function(name){
	            return editors[name];
	        },
	        unregisterEditor: function(name){
	            delete editors[name];
	            touchModification();
	        },
	        // registers a toolbar such that it can be linked to editors
	        registerToolbar: function(toolbarScope){
	            if(!toolbarScope) throw('textAngular Error: A toolbar requires a scope');
	            if(!toolbarScope.name || toolbarScope.name === '') throw('textAngular Error: A toolbar requires a name');
	            if(toolbars[toolbarScope.name]) throw('textAngular Error: A toolbar with name "' + toolbarScope.name + '" already exists');
	            toolbars[toolbarScope.name] = toolbarScope;
	            // walk all the editors and connect this toolbarScope to the editors.... if we need to.  This way, it does
	            // not matter if we register the editors after the toolbars or not
	            // Note the editor will ignore this toolbarScope if it is not connected to it...
	            angular.forEach(editors, function(_editor){
	                _editor._registerToolbarScope(toolbarScope);
	            });
	            touchModification();
	        },
	        // retrieve toolbar by name, largely used by testing suites only
	        retrieveToolbar: function(name){
	            return toolbars[name];
	        },
	        // retrieve toolbars by editor name, largely used by testing suites only
	        retrieveToolbarsViaEditor: function(name){
	            var result = [], _this = this;
	            angular.forEach(this.retrieveEditor(name).toolbars, function(name){
	                result.push(_this.retrieveToolbar(name));
	            });
	            return result;
	        },
	        unregisterToolbar: function(name){
	            delete toolbars[name];
	            touchModification();
	        },
	        // functions for updating the toolbar buttons display
	        updateToolsDisplay: function(newTaTools){
	            // pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
	            var _this = this;
	            angular.forEach(newTaTools, function(_newTool, key){
	                _this.updateToolDisplay(key, _newTool);
	            });
	        },
	        // this function resets all toolbars to their default tool definitions
	        resetToolsDisplay: function(){
	            var _this = this;
	            angular.forEach(taTools, function(_newTool, key){
	                _this.resetToolDisplay(key);
	            });
	            touchModification();
	        },
	        // update a tool on all toolbars
	        updateToolDisplay: function(toolKey, _newTool){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
	            });
	            touchModification();
	        },
	        // resets a tool to the default/starting state on all toolbars
	        resetToolDisplay: function(toolKey){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.resetToolbarToolDisplay(toolbarKey, toolKey);
	            });
	            touchModification();
	        },
	        // update a tool on a specific toolbar
	        updateToolbarToolDisplay: function(toolbarKey, toolKey, _newTool){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // reset a tool on a specific toolbar to it's default starting value
	        resetToolbarToolDisplay: function(toolbarKey, toolKey){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // removes a tool from all toolbars and it's definition
	        removeTool: function(toolKey){
	            delete taTools[toolKey];
	            angular.forEach(toolbars, function(toolbarScope){
	                delete toolbarScope.tools[toolKey];
	                for(var i = 0; i < toolbarScope.toolbar.length; i++){
	                    var toolbarIndex;
	                    for(var j = 0; j < toolbarScope.toolbar[i].length; j++){
	                        if(toolbarScope.toolbar[i][j] === toolKey){
	                            toolbarIndex = {
	                                group: i,
	                                index: j
	                            };
	                            break;
	                        }
	                        if(toolbarIndex !== undefined) break;
	                    }
	                    if(toolbarIndex !== undefined){
	                        toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
	                        toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
	                    }
	                }
	            });
	            touchModification();
	        },
	        // toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
	        addTool: function(toolKey, toolDefinition, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            angular.forEach(toolbars, function(toolbarScope){
	                toolbarScope.addTool(toolKey, toolDefinition, group, index);
	            });
	            touchModification();
	        },
	        // adds a Tool but only to one toolbar not all
	        addToolToToolbar: function(toolKey, toolDefinition, toolbarKey, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
	            touchModification();
	        },
	        // this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
	        // this will call a $digest if not already happening
	        refreshEditor: function(name){
	            if(editors[name]){
	                editors[name].scope.updateTaBindtaTextElement();
	                /* istanbul ignore else: phase catch */
	                if(!editors[name].scope.$$phase) editors[name].scope.$digest();
	            }else throw('textAngular Error: No Editor with name "' + name + '" exists');
	            touchModification();
	        },
	        // this is used by taBind to send a key command in response to a special key event
	        sendKeyCommand: function(scope, event){
	            var _editor = editors[scope._name];
	            /* istanbul ignore else: if nothing to do, do nothing */
	            if (_editor && _editor.editorFunctions.sendKeyCommand(event)) {
	                /* istanbul ignore else: don't run if already running */
	                if(!scope._bUpdateSelectedStyles){
	                    scope.updateSelectedStyles();
	                }
	                event.preventDefault();
	                return false;
	            }
	        },
	        //
	        // When a toolbar and tools are created, it isn't until there is a key event or mouse event
	        // that the updateSelectedStyles() is called behind the scenes.
	        // This function forces an update through the existing editors to help the application make sure
	        // the inital state is correct.
	        //
	        updateStyles: updateStyles,
	        // return the current version of textAngular in use to the user
	        getVersion: function () { return textAngularVersion; },
	        // for testing
	        getToolbarScopes: function () {
	            var tmp=[];
	            angular.forEach(editors, function (_editor) {
	                tmp = tmp.concat(_editor.toolbarScopes);
	            });
	            return tmp;
	        }
	/********************** not functional yet
	        // save the selection ('range') for the given editor
	        saveFocusSelection: function (name, range) {
	            editors[name].savedFocusRange = range;
	        },
	        // restore the saved selection from when the focus was lost
	        restoreFocusSelection: function(name, scope) {
	            // we only do this if NOT focussed and saved...
	            if (editors[name].savedFocusRange && !scope.focussed) {
	                try {
	                    var _r = rangy.restoreRange(editors[name].savedFocusRange);
	                    var _sel = rangy.getSelection();
	                    _sel.addRange(_r);
	                } catch(e) {}
	            }
	        }
	*************/
	    };
	}]);
	textAngular.directive('textAngularToolbar', [
	    '$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window',
	    function($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window){
	        return {
	            scope: {
	                name: '@' // a name IS required
	            },
	            restrict: "EA",
	            link: function(scope, element, attrs){
	                if(!scope.name || scope.name === '') throw('textAngular Error: A toolbar requires a name');
	                angular.extend(scope, angular.copy(taOptions));
	                if(attrs.taToolbar)						scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
	                if(attrs.taToolbarClass)				scope.classes.toolbar = attrs.taToolbarClass;
	                if(attrs.taToolbarGroupClass)			scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
	                if(attrs.taToolbarButtonClass)			scope.classes.toolbarButton = attrs.taToolbarButtonClass;
	                if(attrs.taToolbarActiveButtonClass)	scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
	                if(attrs.taFocussedClass)				scope.classes.focussed = attrs.taFocussedClass;
	
	                scope.disabled = true;
	                scope.focussed = false;
	                scope._$element = element;
	                element[0].innerHTML = '';
	                element.addClass("ta-toolbar " + scope.classes.toolbar);
	
	                scope.$watch('focussed', function(){
	                    if(scope.focussed) element.addClass(scope.classes.focussed);
	                    else element.removeClass(scope.classes.focussed);
	                });
	
	                var setupToolElement = function(toolDefinition, toolScope){
	                    var toolElement;
	                    if(toolDefinition && toolDefinition.display){
	                        toolElement = angular.element(toolDefinition.display);
	                    }
	                    else toolElement = angular.element("<button type='button'>");
	
	                    if(toolDefinition && toolDefinition["class"]) toolElement.addClass(toolDefinition["class"]);
	                    else toolElement.addClass(scope.classes.toolbarButton);
	
	                    toolElement.attr('name', toolScope.name);
	                    // important to not take focus from the main text/html entry
	                    toolElement.attr('ta-button', 'ta-button');
	                    toolElement.attr('ng-disabled', 'isDisabled()');
	                    toolElement.attr('tabindex', '-1');
	                    toolElement.attr('ng-click', 'executeAction()');
	                    toolElement.attr('ng-class', 'displayActiveToolClass(active)');
	
	                    if (toolDefinition && toolDefinition.tooltiptext) {
	                        toolElement.attr('title', toolDefinition.tooltiptext);
	                    }
	                    if(toolDefinition && !toolDefinition.display && !toolScope._display){
	                        // first clear out the current contents if any
	                        toolElement[0].innerHTML = '';
	                        // add the buttonText
	                        if(toolDefinition.buttontext) toolElement[0].innerHTML = toolDefinition.buttontext;
	                        // add the icon to the front of the button if there is content
	                        if(toolDefinition.iconclass){
	                            var icon = angular.element('<i>'), content = toolElement[0].innerHTML;
	                            icon.addClass(toolDefinition.iconclass);
	                            toolElement[0].innerHTML = '';
	                            toolElement.append(icon);
	                            if(content && content !== '') toolElement.append('&nbsp;' + content);
	                        }
	                    }
	
	                    toolScope._lastToolDefinition = angular.copy(toolDefinition);
	
	                    return $compile(toolElement)(toolScope);
	                };
	
	                // Keep a reference for updating the active states later
	                scope.tools = {};
	                // create the tools in the toolbar
	                // default functions and values to prevent errors in testing and on init
	                scope._parent = {
	                    disabled: true,
	                    showHtml: false,
	                    queryFormatBlockState: function(){ return false; },
	                    queryCommandState: function(){ return false; }
	                };
	                var defaultChildScope = {
	                    $window: $window,
	                    $editor: function(){
	                        // dynamically gets the editor as it is set
	                        return scope._parent;
	                    },
	                    isDisabled: function(){
	                        // view selection button is always enabled since it doesn not depend on a selction!
	                        if (this.name === 'html' && scope._parent.startAction) {
	                            return false;
	                        }
	                        // to set your own disabled logic set a function or boolean on the tool called 'disabled'
	                        return ( // this bracket is important as without it it just returns the first bracket and ignores the rest
	                            // when the button's disabled function/value evaluates to true
	                            (typeof this.$eval('disabled') !== 'function' && this.$eval('disabled')) || this.$eval('disabled()') ||
	                            // all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
	                            (this.name !== 'html' && this.$editor().showHtml) ||
	                            // if the toolbar is disabled
	                            this.$parent.disabled ||
	                            // if the current editor is disabled
	                            this.$editor().disabled
	                        );
	                    },
	                    displayActiveToolClass: function(active){
	                        return (active)? scope.classes.toolbarButtonActive : '';
	                    },
	                    executeAction: taToolExecuteAction
	                };
	
	                angular.forEach(scope.toolbar, function(group){
	                    // setup the toolbar group
	                    var groupElement = angular.element("<div>");
	                    groupElement.addClass(scope.classes.toolbarGroup);
	                    angular.forEach(group, function(tool){
	                        // init and add the tools to the group
	                        // a tool name (key name from taTools struct)
	                        //creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
	                        // reference to the scope and element kept
	                        scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {name: tool});
	                        scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
	                        // append the tool compiled with the childScope to the group element
	                        groupElement.append(scope.tools[tool].$element);
	                    });
	                    // append the group to the toolbar
	                    element.append(groupElement);
	                });
	
	                // update a tool
	                // if a value is set to null, remove from the display
	                // when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
	                // to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
	                scope.updateToolDisplay = function(key, _newTool, forceNew){
	                    var toolInstance = scope.tools[key];
	                    if(toolInstance){
	                        // get the last toolDefinition, then override with the new definition
	                        if(toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
	                        if(_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null)
	                            throw('textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value');
	
	                        // if tool is defined on this toolbar, update/redo the tool
	                        if(_newTool.buttontext === null){
	                            delete _newTool.buttontext;
	                        }
	                        if(_newTool.iconclass === null){
	                            delete _newTool.iconclass;
	                        }
	                        if(_newTool.display === null){
	                            delete _newTool.display;
	                        }
	
	                        var toolElement = setupToolElement(_newTool, toolInstance);
	                        toolInstance.$element.replaceWith(toolElement);
	                        toolInstance.$element = toolElement;
	                    }
	                };
	
	                // we assume here that all values passed are valid and correct
	                scope.addTool = function(key, _newTool, groupIndex, index){
	                    scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, {name: key});
	                    scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
	                    var group;
	                    if(groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
	                    group = angular.element(element.children()[groupIndex]);
	
	                    if(index === undefined){
	                        group.append(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
	                    }else{
	                        group.children().eq(index).after(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][index] = key;
	                    }
	                };
	
	                textAngularManager.registerToolbar(scope);
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterToolbar(scope.name);
	                });
	            }
	        };
	    }
	]);
	textAngular.directive('textAngularVersion', ['textAngularManager',
	    function(textAngularManager) {
	        var version = textAngularManager.getVersion();
	        return {
	            restrict: "EA",
	            link: function (scope, element, attrs) {
	                element.html(version);
	            }
	        };
	    }
	]);


/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.10
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function $SanitizeProvider() {
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    return function(html) {
	      if (typeof arguments[1] != 'undefined') {
	        arguments[1].version = 'taSanitize';
	      }
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var START_TAG_REGEXP =
	       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	  BEGIN_TAG_REGEXP = /^</,
	  BEGING_END_TAGE_REGEXP = /^<\//,
	  COMMENT_REGEXP = /<!--(.*?)-->/g,
	  SINGLE_COMMENT_REGEXP = /(^<!--.*?-->)/,
	  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g,
	  WHITE_SPACE_REGEXP = /^(\s+)/;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = makeMap("area,br,col,hr,img,wbr,input");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = makeMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	var svgElements = makeMap("animate,animateColor,animateMotion,animateTransform,circle,defs," +
	        "desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient," +
	        "line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set," +
	        "stop,svg,switch,text,title,tspan,use");
	
	// Special Elements (can contain anything)
	var specialElements = makeMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements,
	                                   svgElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");
	
	var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,'+
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,'+
	    'id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,'+
	    'scope,scrolling,shape,size,span,start,summary,target,title,type,'+
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,' +
	    'color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,' +
	    'font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,' +
	    'gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,' +
	    'keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,' +
	    'markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,' +
	    'overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,' +
	    'repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,' +
	    'stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,' +
	    'stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,' +
	    'stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,' +
	    'underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,' +
	    'viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,' +
	    'xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,' +
	    'zoomAndPan');
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) obj[items[i]] = true;
	  return obj;
	}
	
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (typeof html !== 'string') {
	    if (html === null || typeof html === 'undefined') {
	      html = '';
	    } else {
	      html = '' + html;
	    }
	  }
	  var index, chars, match, stack = [], last = html, text;
	  stack.last = function() { return stack[ stack.length - 1 ]; };
	
	  while (html) {
	    text = '';
	    chars = true;
	
	    // Make sure we're not in a script or style element
	    if (!stack.last() || !specialElements[ stack.last() ]) {
	
	      // White space
	      if (WHITE_SPACE_REGEXP.test(html)) {
	        match = html.match(WHITE_SPACE_REGEXP);
	
	        if (match) {
	          var mat = match[0];
	          if (handler.whitespace) handler.whitespace(match[0]);
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      //Comment
	      } else if (SINGLE_COMMENT_REGEXP.test(html)) {
	        match = html.match(SINGLE_COMMENT_REGEXP);
	
	        if (match) {
	          if (handler.comment) handler.comment(match[1]);
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // DOCTYPE
	      } else if (DOCTYPE_REGEXP.test(html)) {
	        match = html.match(DOCTYPE_REGEXP);
	
	        if (match) {
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // end tag
	      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
	        match = html.match(END_TAG_REGEXP);
	
	        if (match) {
	          html = html.substring(match[0].length);
	          match[0].replace(END_TAG_REGEXP, parseEndTag);
	          chars = false;
	        }
	
	      // start tag
	      } else if (BEGIN_TAG_REGEXP.test(html)) {
	        match = html.match(START_TAG_REGEXP);
	
	        if (match) {
	          // We only have a valid start-tag if there is a '>'.
	          if (match[4]) {
	            html = html.substring(match[0].length);
	            match[0].replace(START_TAG_REGEXP, parseStartTag);
	          }
	          chars = false;
	        } else {
	          // no ending tag found --- this piece should be encoded as an entity.
	          text += '<';
	          html = html.substring(1);
	        }
	      }
	
	      if (chars) {
	        index = html.indexOf("<");
	
	        text += index < 0 ? html : html.substring(0, index);
	        html = index < 0 ? "" : html.substring(index);
	
	        if (handler.chars) handler.chars(decodeEntities(text));
	      }
	
	    } else {
	      html = html.replace(new RegExp("([^]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
	        function(all, text) {
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	
	          return "";
	      });
	
	      parseEndTag("", stack.last());
	    }
	
	    if (html == last) {
	      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
	                                        "of html: {0}", html);
	    }
	    last = html;
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function parseStartTag(tag, tagName, rest, unary) {
	    tagName = angular.lowercase(tagName);
	    if (blockElements[ tagName ]) {
	      while (stack.last() && inlineElements[ stack.last() ]) {
	        parseEndTag("", stack.last());
	      }
	    }
	
	    if (optionalEndTagElements[ tagName ] && stack.last() == tagName) {
	      parseEndTag("", tagName);
	    }
	
	    unary = voidElements[ tagName ] || !!unary;
	
	    if (!unary)
	      stack.push(tagName);
	
	    var attrs = {};
	
	    rest.replace(ATTR_REGEXP,
	      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue
	          || singleQuotedValue
	          || unquotedValue
	          || '';
	
	        attrs[name] = decodeEntities(value);
	    });
	    if (handler.start) handler.start(tagName, attrs, unary);
	  }
	
	  function parseEndTag(tag, tagName) {
	    var pos = 0, i;
	    tagName = angular.lowercase(tagName);
	    if (tagName)
	      // Find the closest opened tag of the same type
	      for (pos = stack.length - 1; pos >= 0; pos--)
	        if (stack[ pos ] == tagName)
	          break;
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (i = stack.length - 1; i >= pos; i--)
	        if (handler.end) handler.end(stack[ i ]);
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	    }
	  }
	}
	
	var hiddenPre=document.createElement("pre");
	var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;
	/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function decodeEntities(value) {
	  if (!value) { return ''; }
	
	  // Note: IE8 does not preserve spaces at the start/end of innerHTML
	  // so we must capture them and reattach them afterward
	  var parts = spaceRe.exec(value);
	  var spaceBefore = parts[1];
	  var spaceAfter = parts[3];
	  var content = parts[2];
	  if (content) {
	    hiddenPre.innerHTML=content.replace(/</g,"&lt;");
	    // innerText depends on styling as it doesn't display hidden elements.
	    // Therefore, it's better to use textContent not to cause unnecessary
	    // reflows. However, IE<9 don't support textContent so the innerText
	    // fallback is necessary.
	    content = 'textContent' in hiddenPre ?
	      hiddenPre.textContent : hiddenPre.innerText;
	  }
	  return spaceBefore + content + spaceAfter;
	}
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      // unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
	      // decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
	      var c = value.charCodeAt(0);
	      // if unsafe character encode
	      if(c <= 159 ||
	        c == 173 ||
	        (c >= 1536 && c <= 1540) ||
	        c == 1807 ||
	        c == 6068 ||
	        c == 6069 ||
	        (c >= 8204 && c <= 8207) ||
	        (c >= 8232 && c <= 8239) ||
	        (c >= 8288 && c <= 8303) ||
	        c == 65279 ||
	        (c >= 65520 && c <= 65535)) return '&#' + c + ';';
	      return value; // avoids multilingual issues
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	var trim = (function() {
	  // native trim is way faster: http://jsperf.com/angular-trim-test
	  // but IE doesn't have it... :-(
	  // TODO: we should move this into IE/ES5 polyfill
	  if (!String.prototype.trim) {
	    return function(value) {
	      return angular.isString(value) ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value;
	    };
	  }
	  return function(value) {
	    return angular.isString(value) ? value.trim() : value;
	  };
	})();
	
	// Custom logic for accepting certain style options only - textAngular
	// Currently allows only the color, background-color, text-align, float, width and height attributes
	// all other attributes should be easily done through classes.
	function validStyles(styleAttr){
		var result = '';
		var styleArray = styleAttr.split(';');
		angular.forEach(styleArray, function(value){
			var v = value.split(':');
			if(v.length == 2){
				var key = trim(angular.lowercase(v[0]));
				var value = trim(angular.lowercase(v[1]));
				if(
					(key === 'color' || key === 'background-color') && (
						value.match(/^rgb\([0-9%,\. ]*\)$/i)
						|| value.match(/^rgba\([0-9%,\. ]*\)$/i)
						|| value.match(/^hsl\([0-9%,\. ]*\)$/i)
						|| value.match(/^hsla\([0-9%,\. ]*\)$/i)
						|| value.match(/^#[0-9a-f]{3,6}$/i)
						|| value.match(/^[a-z]*$/i)
					)
				||
					key === 'text-align' && (
						value === 'left'
						|| value === 'right'
						|| value === 'center'
						|| value === 'justify'
					)
				||
	        key === 'text-decoration' && (
	            value === 'underline'
	            || value === 'line-through'
	        )
	      || 
	        key === 'font-weight' && (
	            value === 'bold'
	        )
	      ||
	        key === 'font-style' && (
	          value === 'italic'
	        )
	      ||
	        key === 'float' && (
	            value === 'left'
	            || value === 'right'
	            || value === 'none'
	        )
	      ||
	        key === 'vertical-align' && (
	            value === 'baseline'
	            || value === 'sub'
	            || value === 'super'
	            || value === 'test-top'
	            || value === 'text-bottom'
	            || value === 'middle'
	            || value === 'top'
	            || value === 'bottom'
	            || value.match(/[0-9]*(px|em)/)
	            || value.match(/[0-9]+?%/)
	        )
	      ||
	        key === 'font-size' && (
	            value === 'xx-small'
	            || value === 'x-small'
	            || value === 'small'
	            || value === 'medium'
	            || value === 'large'
	            || value === 'x-large'
	            || value === 'xx-large'
	            || value === 'larger'
	            || value === 'smaller'
	            || value.match(/[0-9]*\.?[0-9]*(px|em|rem|mm|q|cm|in|pt|pc|%)/)
	                               )
				||
					(key === 'width' || key === 'height') && (
						value.match(/[0-9\.]*(px|em|rem|%)/)
					)
				|| // Reference #520
					(key === 'direction' && value.match(/^ltr|rtl|initial|inherit$/))
				) result += key + ': ' + value + ';';
			}
		});
		return result;
	}
	
	// this function is used to manually allow specific attributes on specific tags with certain prerequisites
	function validCustomTag(tag, attrs, lkey, value){
		// catch the div placeholder for the iframe replacement
	    if (tag === 'img' && attrs['ta-insert-video']){
	        if(lkey === 'ta-insert-video' || lkey === 'allowfullscreen' || lkey === 'frameborder' || (lkey === 'contenteditable' && value === 'false')) return true;
	    }
	    return false;
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignore = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs, unary) {
	      tag = angular.lowercase(tag);
	      if (!ignore && specialElements[tag]) {
	        ignore = tag;
	      }
	      if (!ignore && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage=(tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if ((lkey === 'style' && (value = validStyles(value)) !== '') || validCustomTag(tag, attrs, lkey, value) || validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out(unary ? '/>' : '>');
	      }
	    },
	    comment: function (com) {
	      out(com);
	    },
	    whitespace: function (ws) {
	      out(encodeEntities(ws));
	    },
	    end: function(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	    chars: function(chars) {
	        if (!ignore) {
	          out(encodeEntities(chars));
	        }
	      }
	  };
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,
	      MAILTO_REGEXP = /^mailto:/;
	
	  return function(text, target) {
	    if (!text) return text;
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      html.push('<a ');
	      if (angular.isDefined(target)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	
	// tests against the current jqLite/jquery implementation if this can be an element
	function validElementString(string){
	    try{
	        return angular.element(string).length !== 0;
	    }catch(any){
	        return false;
	    }
	}
	// setup the global contstant functions for setting up the toolbar
	
	// all tool definitions
	var taTools = {};
	/*
	    A tool definition is an object with the following key/value parameters:
	        action: [function(deferred, restoreSelection)]
	                a function that is executed on clicking on the button - this will allways be executed using ng-click and will
	                overwrite any ng-click value in the display attribute.
	                The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
	                manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
	                restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
	                selection in the WYSIWYG editor.
	        display: [string]?
	                Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
	                If set this will cause buttontext and iconclass to be ignored
	        class: [string]?
	                Optional, if set will override the taOptions.classes.toolbarButton class.
	        buttontext: [string]?
	                if this is defined it will replace the contents of the element contained in the `display` element
	        iconclass: [string]?
	                if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
	        tooltiptext: [string]?
	                Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
	        activestate: [function(commonElement)]?
	                this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
	                will be applied to the `display` element, else the class will be removed
	        disabled: [function()]?
	                if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	    Other functions available on the scope are:
	        name: [string]
	                the name of the tool, this is the first parameter passed into taRegisterTool
	        isDisabled: [function()]
	                returns true if the tool is disabled, false if it isn't
	        displayActiveToolClass: [function(boolean)]
	                returns true if the tool is 'active' in the currently focussed toolbar
	        onElementSelect: [Object]
	                This object contains the following key/value pairs and is used to trigger the ta-element-select event
	                element: [String]
	                    an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
	                filter: [function(element)]?
	                    an optional filter that returns a boolean, if true it will trigger the onElementSelect.
	                action: [function(event, element, editorScope)]
	                    the action that should be executed if the onElementSelect function runs
	*/
	// name and toolDefinition to add into the tools available to be added on the toolbar
	function registerTextAngularTool(name, toolDefinition){
	    if(!name || name === '' || taTools.hasOwnProperty(name)) throw('textAngular Error: A unique name is required for a Tool Definition');
	    if(
	        (toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display))) ||
	        (!toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass)
	    )
	        throw('textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value');
	    taTools[name] = toolDefinition;
	}
	
	angular.module('textAngularSetup', [])
	.constant('taRegisterTool', registerTextAngularTool)
	.value('taTools', taTools)
	// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
	.value('taOptions',  {
	    //////////////////////////////////////////////////////////////////////////////////////
	    // forceTextAngularSanitize
	    // set false to allow the textAngular-sanitize provider to be replaced
	    // with angular-sanitize or a custom provider.
	    forceTextAngularSanitize: true,
	    ///////////////////////////////////////////////////////////////////////////////////////
	    // keyMappings
	    // allow customizable keyMappings for specialized key boards or languages
	    //
	    // keyMappings provides key mappings that are attached to a given commandKeyCode.
	    // To modify a specific keyboard binding, simply provide function which returns true
	    // for the event you wish to map to.
	    // Or to disable a specific keyboard binding, provide a function which returns false.
	    // Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
	    // At present, the following commandKeyCodes are in use:
	    // 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
	    //
	    // To map to an new commandKeyCode, add a new key mapping such as:
	    // {commandKeyCode: 'CustomKey', testForKey: function (event) {
	    //  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
	    // } }
	    // to the keyMappings. This example maps ctrl+9 to 'CustomKey'
	    // Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
	    // tool will be bound to ctrl+9.
	    //
	    // To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
	    // {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
	    // {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
	    // to disable them.
	    //
	    keyMappings : [],
	    toolbar: [
	        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
	        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
	        ['justifyLeft','justifyCenter','justifyRight','justifyFull','indent','outdent'],
	        ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
	    ],
	    classes: {
	        focussed: "focussed",
	        toolbar: "btn-toolbar",
	        toolbarGroup: "btn-group",
	        toolbarButton: "btn btn-default",
	        toolbarButtonActive: "active",
	        disabled: "disabled",
	        textEditor: 'form-control',
	        htmlEditor: 'form-control'
	    },
	    defaultTagAttributes : {
	        a: {target:""}
	    },
	    setup: {
	        // wysiwyg mode
	        textEditorSetup: function($element){ /* Do some processing here */ },
	        // raw html
	        htmlEditorSetup: function($element){ /* Do some processing here */ }
	    },
	    defaultFileDropHandler:
	        /* istanbul ignore next: untestable image processing */
	        function(file, insertAction){
	            var reader = new FileReader();
	            if(file.type.substring(0, 5) === 'image'){
	                reader.onload = function() {
	                    if(reader.result !== '') insertAction('insertImage', reader.result, true);
	                };
	
	                reader.readAsDataURL(file);
	                // NOTE: For async procedures return a promise and resolve it when the editor should update the model.
	                return true;
	            }
	            return false;
	        }
	})
	
	// This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
	// these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
	// div is only used as div.ta-insert-video caught in filter.
	.value('taSelectableElements', ['a','img'])
	
	// This is an array of objects with the following options:
	//				selector: <string> a jqLite or jQuery selector string
	//				customAttribute: <string> an attribute to search for
	//				renderLogic: <function(element)>
	// Both or one of selector and customAttribute must be defined.
	.value('taCustomRenderers', [
	    {
	        // Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
	        // To correct video element. For now only support youtube
	        selector: 'img',
	        customAttribute: 'ta-insert-video',
	        renderLogic: function(element){
	            var iframe = angular.element('<iframe></iframe>');
	            var attributes = element.prop("attributes");
	            // loop through element attributes and apply them on iframe
	            angular.forEach(attributes, function(attr) {
	                iframe.attr(attr.name, attr.value);
	            });
	            iframe.attr('src', iframe.attr('ta-insert-video'));
	            element.replaceWith(iframe);
	        }
	    }
	])
	
	.value('taTranslations', {
	    // moved to sub-elements
	    //toggleHTML: "Toggle HTML",
	    //insertImage: "Please enter a image URL to insert",
	    //insertLink: "Please enter a URL to insert",
	    //insertVideo: "Please enter a youtube URL to embed",
	    html: {
	        tooltip: 'Toggle html / Rich Text'
	    },
	    // tooltip for heading - might be worth splitting
	    heading: {
	        tooltip: 'Heading '
	    },
	    p: {
	        tooltip: 'Paragraph'
	    },
	    pre: {
	        tooltip: 'Preformatted text'
	    },
	    ul: {
	        tooltip: 'Unordered List'
	    },
	    ol: {
	        tooltip: 'Ordered List'
	    },
	    quote: {
	        tooltip: 'Quote/unquote selection or paragraph'
	    },
	    undo: {
	        tooltip: 'Undo'
	    },
	    redo: {
	        tooltip: 'Redo'
	    },
	    bold: {
	        tooltip: 'Bold'
	    },
	    italic: {
	        tooltip: 'Italic'
	    },
	    underline: {
	        tooltip: 'Underline'
	    },
	    strikeThrough:{
	        tooltip: 'Strikethrough'
	    },
	    justifyLeft: {
	        tooltip: 'Align text left'
	    },
	    justifyRight: {
	        tooltip: 'Align text right'
	    },
	    justifyFull: {
	        tooltip: 'Justify text'
	    },
	    justifyCenter: {
	        tooltip: 'Center'
	    },
	    indent: {
	        tooltip: 'Increase indent'
	    },
	    outdent: {
	        tooltip: 'Decrease indent'
	    },
	    clear: {
	        tooltip: 'Clear formatting'
	    },
	    insertImage: {
	        dialogPrompt: 'Please enter an image URL to insert',
	        tooltip: 'Insert image',
	        hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
	    },
	    insertVideo: {
	        tooltip: 'Insert video',
	        dialogPrompt: 'Please enter a youtube URL to embed'
	    },
	    insertLink: {
	        tooltip: 'Insert / edit link',
	        dialogPrompt: "Please enter a URL to insert"
	    },
	    editLink: {
	        reLinkButton: {
	            tooltip: "Relink"
	        },
	        unLinkButton: {
	            tooltip: "Unlink"
	        },
	        targetToggle: {
	            buttontext: "Open in New Window"
	        }
	    },
	    wordcount: {
	        tooltip: 'Display words Count'
	    },
	        charcount: {
	        tooltip: 'Display characters Count'
	    }
	})
	.factory('taToolFunctions', ['$window','taTranslations', function($window, taTranslations) {
	    return {
	        imgOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
	            var finishEdit = function(){
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            };
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '375px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
	            fullButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '100%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
	            halfButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '50%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
	            quartButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '25%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
	            resetButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    width: '',
	                    height: ''
	                });
	                finishEdit();
	            });
	            buttonGroup.append(fullButton);
	            buttonGroup.append(halfButton);
	            buttonGroup.append(quartButton);
	            buttonGroup.append(resetButton);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
	            floatLeft.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'left');
	                // firefox
	                $element.css('cssFloat', 'left');
	                // IE < 8
	                $element.css('styleFloat', 'left');
	                finishEdit();
	            });
	            var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
	            floatRight.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'right');
	                // firefox
	                $element.css('cssFloat', 'right');
	                // IE < 8
	                $element.css('styleFloat', 'right');
	                finishEdit();
	            });
	            var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
	            floatNone.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', '');
	                // firefox
	                $element.css('cssFloat', '');
	                // IE < 8
	                $element.css('styleFloat', '');
	                finishEdit();
	            });
	            buttonGroup.append(floatLeft);
	            buttonGroup.append(floatNone);
	            buttonGroup.append(floatRight);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group">');
	            var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
	            remove.on('click', function(event){
	                event.preventDefault();
	                $element.remove();
	                finishEdit();
	            });
	            buttonGroup.append(remove);
	            container.append(buttonGroup);
	
	            editorScope.showPopover($element);
	            editorScope.showResizeOverlay($element);
	        },
	        aOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '436px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            container.css('line-height', '28px');
	            var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
	            link.css({
	                'display': 'inline-block',
	                'max-width': '200px',
	                'overflow': 'hidden',
	                'text-overflow': 'ellipsis',
	                'white-space': 'nowrap',
	                'vertical-align': 'middle'
	            });
	            container.append(link);
	            var buttonGroup = angular.element('<div class="btn-group pull-right">');
	            var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
	            reLinkButton.on('click', function(event){
	                event.preventDefault();
	                var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
	                if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                    $element.attr('href', urlLink);
	                    editorScope.updateTaBindtaTextElement();
	                }
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(reLinkButton);
	            var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
	            // directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
	            unLinkButton.on('click', function(event){
	                event.preventDefault();
	                $element.replaceWith($element.contents());
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(unLinkButton);
	            var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
	            if($element.attr('target') === '_blank'){
	                targetToggle.addClass('active');
	            }
	            targetToggle.on('click', function(event){
	                event.preventDefault();
	                $element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
	                targetToggle.toggleClass('active');
	                editorScope.updateTaBindtaTextElement();
	            });
	            buttonGroup.append(targetToggle);
	            container.append(buttonGroup);
	            editorScope.showPopover($element);
	        },
	        extractYoutubeVideoId: function(url) {
	            var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
	            var match = url.match(re);
	            return (match && match[1]) || null;
	        }
	    };
	}])
	.run(['taRegisterTool', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', '$log',
	    function(taRegisterTool, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions, $log){
	    // test for the version of $sanitize that is in use
	    // You can disable this check by setting taOptions.textAngularSanitize == false
	    var gv = {}; $sanitize('', gv);
	    /* istanbul ignore next, throws error */
	    if ((taOptions.forceTextAngularSanitize===true) && (gv.version !== 'taSanitize')) {
	        throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
	    }
	    taRegisterTool("html", {
	        iconclass: 'fa fa-code',
	        tooltiptext: taTranslations.html.tooltip,
	        action: function(){
	            this.$editor().switchView();
	        },
	        activeState: function(){
	            return this.$editor().showHtml;
	        }
	    });
	    // add the Header tools
	    // convenience functions so that the loop works correctly
	    var _retActiveStateFunction = function(q){
	        return function(){ return this.$editor().queryFormatBlockState(q); };
	    };
	    var headerAction = function(){
	        return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() +">");
	    };
	    angular.forEach(['h1','h2','h3','h4','h5','h6'], function(h){
	        taRegisterTool(h.toLowerCase(), {
	            buttontext: h.toUpperCase(),
	            tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
	            action: headerAction,
	            activeState: _retActiveStateFunction(h.toLowerCase())
	        });
	    });
	    taRegisterTool('p', {
	        buttontext: 'P',
	        tooltiptext: taTranslations.p.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<P>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('p'); }
	    });
	    // key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
	    taRegisterTool('pre', {
	        buttontext: 'pre',
	        tooltiptext: taTranslations.pre.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<PRE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('pre'); }
	    });
	    taRegisterTool('ul', {
	        iconclass: 'fa fa-list-ul',
	        tooltiptext: taTranslations.ul.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertUnorderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertUnorderedList'); }
	    });
	    taRegisterTool('ol', {
	        iconclass: 'fa fa-list-ol',
	        tooltiptext: taTranslations.ol.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertOrderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertOrderedList'); }
	    });
	    taRegisterTool('quote', {
	        iconclass: 'fa fa-quote-right',
	        tooltiptext: taTranslations.quote.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('blockquote'); }
	    });
	    taRegisterTool('undo', {
	        iconclass: 'fa fa-undo',
	        tooltiptext: taTranslations.undo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("undo", null);
	        }
	    });
	    taRegisterTool('redo', {
	        iconclass: 'fa fa-repeat',
	        tooltiptext: taTranslations.redo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("redo", null);
	        }
	    });
	    taRegisterTool('bold', {
	        iconclass: 'fa fa-bold',
	        tooltiptext: taTranslations.bold.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("bold", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('bold');
	        },
	        commandKeyCode: 98
	    });
	    taRegisterTool('justifyLeft', {
	        iconclass: 'fa fa-align-left',
	        tooltiptext: taTranslations.justifyLeft.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyLeft", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if (commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result =
	                        commonElement.css('text-align') === 'left' ||
	                        commonElement.attr('align') === 'left' ||
	                        (
	                            commonElement.css('text-align') !== 'right' &&
	                            commonElement.css('text-align') !== 'center' &&
	                            commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter')
	                        ) && !this.$editor().queryCommandState('justifyFull');
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyLeft');
	            return result;
	        }
	    });
	    taRegisterTool('justifyRight', {
	        iconclass: 'fa fa-align-right',
	        tooltiptext: taTranslations.justifyRight.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyRight", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'right';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyRight');
	            return result;
	        }
	    });
	    taRegisterTool('justifyFull', {
	        iconclass: 'fa fa-align-justify',
	        tooltiptext: taTranslations.justifyFull.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyFull", null);
	        },
	        activeState: function(commonElement){
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'justify';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyFull');
	            return result;
	        }
	    });
	    taRegisterTool('justifyCenter', {
	        iconclass: 'fa fa-align-center',
	        tooltiptext: taTranslations.justifyCenter.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyCenter", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'center';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	
	            }
	            result = result || this.$editor().queryCommandState('justifyCenter');
	            return result;
	        }
	    });
	    taRegisterTool('indent', {
	        iconclass: 'fa fa-indent',
	        tooltiptext: taTranslations.indent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("indent", null);
	        },
	        activeState: function(){
	            return this.$editor().queryFormatBlockState('blockquote');
	        },
	        commandKeyCode: 'TabKey'
	    });
	    taRegisterTool('outdent', {
	        iconclass: 'fa fa-outdent',
	        tooltiptext: taTranslations.outdent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("outdent", null);
	        },
	        activeState: function(){
	            return false;
	        },
	        commandKeyCode: 'ShiftTabKey'
	    });
	    taRegisterTool('italics', {
	        iconclass: 'fa fa-italic',
	        tooltiptext: taTranslations.italic.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("italic", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('italic');
	        },
	        commandKeyCode: 105
	    });
	    taRegisterTool('underline', {
	        iconclass: 'fa fa-underline',
	        tooltiptext: taTranslations.underline.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("underline", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('underline');
	        },
	        commandKeyCode: 117
	    });
	    taRegisterTool('strikeThrough', {
	        iconclass: 'fa fa-strikethrough',
	        tooltiptext: taTranslations.strikeThrough.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("strikeThrough", null);
	        },
	        activeState: function(){
	            return document.queryCommandState('strikeThrough');
	        }
	    });
	    taRegisterTool('clear', {
	        iconclass: 'fa fa-ban',
	        tooltiptext: taTranslations.clear.tooltip,
	        action: function(deferred, restoreSelection){
	            var i, selectedElements, elementsSeen;
	
	            this.$editor().wrapSelection("removeFormat", null);
	            var possibleNodes = angular.element(taSelection.getSelectionElement());
	            selectedElements = taSelection.getAllSelectedElements();
	            //$log.log('selectedElements:', selectedElements);
	            // remove lists
	            var removeListElements = function(list, pe){
	                list = angular.element(list);
	                var prevElement = pe;
	                if (!pe) {
	                    prevElement = list;
	                }
	                angular.forEach(list.children(), function(liElem){
	                    if (liElem.tagName.toLowerCase() === 'ul' ||
	                        liElem.tagName.toLowerCase() === 'ol') {
	                        prevElement = removeListElements(liElem, prevElement);
	                    } else {
	                        var newElem = angular.element('<p></p>');
	                        newElem.html(angular.element(liElem).html());
	                        prevElement.after(newElem);
	                        prevElement = newElem;
	                    }
	                });
	                list.remove();
	                return prevElement;
	            };
	
	            angular.forEach(selectedElements, function(element) {
	                if (element.nodeName.toLowerCase() === 'ul' ||
	                    element.nodeName.toLowerCase() === 'ol') {
	                    //console.log('removeListElements', element);
	                    removeListElements(element);
	                }
	            });
	
	            angular.forEach(possibleNodes.find("ul"), removeListElements);
	            angular.forEach(possibleNodes.find("ol"), removeListElements);
	
	            // clear out all class attributes. These do not seem to be cleared via removeFormat
	            var $editor = this.$editor();
	            var recursiveRemoveClass = function(node){
	                node = angular.element(node);
	                /* istanbul ignore next: this is not triggered in tests any longer since we now never select the whole displayELement */
	                if(node[0] !== $editor.displayElements.text[0]) {
	                    node.removeAttr('class');
	                }
	                angular.forEach(node.children(), recursiveRemoveClass);
	            };
	            angular.forEach(possibleNodes, recursiveRemoveClass);
	            // check if in list. If not in list then use formatBlock option
	            if(possibleNodes[0] && possibleNodes[0].tagName.toLowerCase() !== 'li' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ol' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ul' &&
	                possibleNodes[0].getAttribute("contenteditable") !== "true") {
	                this.$editor().wrapSelection("formatBlock", "default");
	            }
	            restoreSelection();
	        }
	    });
	
	        /* jshint -W099 */
	    /****************************
	     //  we don't use this code - since the previous way CLEAR is expected to work does not clear partially selected <li>
	
	     var removeListElement = function(listE){
	                console.log(listE);
	                var _list = listE.parentNode.childNodes;
	                console.log('_list', _list);
	                var _preLis = [], _postLis = [], _found = false;
	                for (i = 0; i < _list.length; i++) {
	                    if (_list[i] === listE) {
	                        _found = true;
	                    } else if (!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(listE.parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(listE).html());
	                if (_preLis.length === 0 || _postLis.length === 0) {
	                    if (_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(listE).remove();
	                } else {
	                    var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    for (i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for (i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            };
	
	     elementsSeen = [];
	     if (selectedElements.length !==0) console.log(selectedElements);
	     angular.forEach(selectedElements, function (element) {
	                if (elementsSeen.indexOf(element) !== -1 || elementsSeen.indexOf(element.parentElement) !== -1) {
	                    return;
	                }
	                elementsSeen.push(element);
	                if (element.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element);
	                    removeListElement(element);
	                }
	                else if (element.parentElement && element.parentElement.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element.parentElement);
	                    elementsSeen.push(element.parentElement);
	                    removeListElement(element.parentElement);
	                }
	            });
	     **********************/
	
	    /**********************
	     if(possibleNodes[0].tagName.toLowerCase() === 'li'){
	                var _list = possibleNodes[0].parentNode.childNodes;
	                var _preLis = [], _postLis = [], _found = false;
	                for(i = 0; i < _list.length; i++){
	                    if(_list[i] === possibleNodes[0]){
	                        _found = true;
	                    }else if(!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(possibleNodes[0].parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(possibleNodes[0]).html());
	                if(_preLis.length === 0 || _postLis.length === 0){
	                    if(_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if(_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(possibleNodes[0]).remove();
	                }else{
	                    var _firstList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    var _secondList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    for(i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for(i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            }
	     *******************/
	
	
	    /* istanbul ignore next: if it's javascript don't worry - though probably should show some kind of error message */
	    var blockJavascript = function (link) {
	        if (link.toLowerCase().indexOf('javascript')!==-1) {
	            return true;
	        }
	        return false;
	    };
	
	    taRegisterTool('insertImage', {
	        iconclass: 'fa fa-picture-o',
	        tooltiptext: taTranslations.insertImage.tooltip,
	        action: function(){
	            var imageLink;
	            imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
	            if(imageLink && imageLink !== '' && imageLink !== 'http://'){
	                /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                // block javascript here
	                if (!blockJavascript(imageLink)) {
	                    if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                        // due to differences in implementation between FireFox and Chrome, we must move the
	                        // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                        // With this change, both FireFox and Chrome behave the same way!
	                        taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                    }
	                    // In the past we used the simple statement:
	                    //return this.$editor().wrapSelection('insertImage', imageLink, true);
	                    //
	                    // However on Firefox only, when the content is empty this is a problem
	                    // See Issue #1201
	                    // Investigation reveals that Firefox only inserts a <p> only!!!!
	                    // So now we use insertHTML here and all is fine.
	                    // NOTE: this is what 'insertImage' is supposed to do anyway!
	                    var embed = '<img src="' + imageLink + '">';
	                    return this.$editor().wrapSelection('insertHTML', embed, true);
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertVideo', {
	        iconclass: 'fa fa-youtube-play',
	        tooltiptext: taTranslations.insertVideo.tooltip,
	        action: function(){
	            var urlPrompt;
	            urlPrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, 'https://');
	            // block javascript here
	            /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	            if (!blockJavascript(urlPrompt)) {
	
	                if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
	
	                    videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);
	
	                    /* istanbul ignore else: if it's invalid don't worry - though probably should show some kind of error message */
	                    if (videoId) {
	                        // create the embed link
	                        var urlLink = "https://www.youtube.com/embed/" + videoId;
	                        // create the HTML
	                        // for all options see: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
	                        // maxresdefault.jpg seems to be undefined on some.
	                        var embed = '<img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" contenteditable="false" allowfullscreen="true" frameborder="0" />';
	                        /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                        if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                            // due to differences in implementation between FireFox and Chrome, we must move the
	                            // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                            // With this change, both FireFox and Chrome behave the same way!
	                            taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                        }
	                        // insert
	                        return this.$editor().wrapSelection('insertHTML', embed, true);
	                    }
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            onlyWithAttrs: ['ta-insert-video'],
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertLink', {
	        tooltiptext: taTranslations.insertLink.tooltip,
	        iconclass: 'fa fa-link',
	        action: function(){
	            var urlLink;
	            // if this link has already been set, we need to just edit the existing link
	            /* istanbul ignore if: we do not test this */
	            if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, taSelection.getSelectionElement().href);
	            } else {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
	            }
	            if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                // block javascript here
	                /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	                if (!blockJavascript(urlLink)) {
	                    return this.$editor().wrapSelection('createLink', urlLink, true);
	                }
	            }
	        },
	        activeState: function(commonElement){
	            if(commonElement) return commonElement[0].tagName === 'A';
	            return false;
	        },
	        onElementSelect: {
	            element: 'a',
	            action: taToolFunctions.aOnSelectAction
	        }
	    });
	    taRegisterTool('wordcount', {
	        display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
	        disabled: true,
	        wordcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            /* istanbul ignore next: will default to '' when undefined */
	            var workingHTML = textElement[0].innerHTML || '';
	            var noOfWords = 0;
	
	            /* istanbul ignore if: will default to '' when undefined */
	            if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
	                if (workingHTML.trim() !== '') {
	                    noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
	                        .replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
	                        .replace(/(<[^>]*?>)/ig, '') // remove any singular tags
	                        .replace(/\s+/ig, ' ') // condense spacing
	                        .match(/\S+/g).length; // count remaining non-space strings
	                }
	            }
	
	            //Set current scope
	            this.wordcount = noOfWords;
	            //Set editor scope
	            this.$editor().wordcount = noOfWords;
	
	            return false;
	        }
	    });
	    taRegisterTool('charcount', {
	        display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
	        disabled: true,
	        charcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.
	
	            // Caculate number of chars
	            var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm,"").replace(/^\s+/g,' ').replace(/\s+$/g, ' ').length;
	            //Set current scope
	            this.charcount = noOfChars;
	            //Set editor scope
	            this.$editor().charcount = noOfChars;
	            return false;
	        }
	    });
	}]);


/***/ }),
/* 1243 */
1199,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1390);

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	/**
	 * oclazyload - Load modules on demand (lazy load) with angularJS
	 * @version v0.5.2
	 * @link https://github.com/ocombe/ocLazyLoad
	 * @license MIT
	 * @author Olivier Combe <olivier.combe@gmail.com>
	 */
	!function(){"use strict";function e(e){var n=[];return angular.forEach(e.requires,function(e){-1===l.indexOf(e)&&n.push(e)}),n}function n(e){try{return angular.module(e)}catch(n){if(/No module/.test(n)||n.message.indexOf("$injector:nomod")>-1)return!1}}function r(e){try{return angular.module(e)}catch(n){throw(/No module/.test(n)||n.message.indexOf("$injector:nomod")>-1)&&(n.message='The module "'+e+'" that you are trying to load does not exist. '+n.message),n}}function a(e,n,r,a){if(n){var t,i,u,l;for(t=0,i=n.length;i>t;t++)if(u=n[t],angular.isArray(u)){if(null!==e){if(!e.hasOwnProperty(u[0]))throw new Error("unsupported provider "+u[0]);l=e[u[0]]}var s=o(u,r);if("invoke"!==u[1])s&&angular.isDefined(l)&&l[u[1]].apply(l,u[2]);else{var f=function(e){var n=c.indexOf(r+"-"+e);(-1===n||a)&&(-1===n&&c.push(r+"-"+e),angular.isDefined(l)&&l[u[1]].apply(l,u[2]))};if(angular.isFunction(u[2][0]))f(u[2][0]);else if(angular.isArray(u[2][0]))for(var d=0,g=u[2][0].length;g>d;d++)angular.isFunction(u[2][0][d])&&f(u[2][0][d])}}}}function t(e,n,r){if(n){var o,u,s,f=[];for(o=n.length-1;o>=0;o--)if(u=n[o],"string"!=typeof u&&(u=i(u)),u&&-1===d.indexOf(u)){var c=-1===l.indexOf(u);if(s=angular.module(u),c&&(l.push(u),t(e,s.requires,r)),s._runBlocks.length>0)for(g[u]=[];s._runBlocks.length>0;)g[u].push(s._runBlocks.shift());angular.isDefined(g[u])&&(c||r.rerun)&&(f=f.concat(g[u])),a(e,s._invokeQueue,u,r.reconfig),a(e,s._configBlocks,u,r.reconfig),p(c?"ocLazyLoad.moduleLoaded":"ocLazyLoad.moduleReloaded",u),n.pop(),d.push(u)}var h=e.getInstanceInjector();angular.forEach(f,function(e){h.invoke(e)})}}function o(e,n){var r=e[2][0],a=e[1],t=!1;angular.isUndefined(f[n])&&(f[n]={}),angular.isUndefined(f[n][a])&&(f[n][a]=[]);var o=function(e){t=!0,f[n][a].push(e),p("ocLazyLoad.componentLoaded",[n,a,e])};if(angular.isString(r)&&-1===f[n][a].indexOf(r))o(r);else{if(!angular.isObject(r))return!1;angular.forEach(r,function(e){angular.isString(e)&&-1===f[n][a].indexOf(e)&&o(e)})}return t}function i(e){var n=null;return angular.isString(e)?n=e:angular.isObject(e)&&e.hasOwnProperty("name")&&angular.isString(e.name)&&(n=e.name),n}function u(e){if(0===s.length){var n=[e],r=["ng:app","ng-app","x-ng-app","data-ng-app"],t=/\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,o=function(e){return e&&n.push(e)};angular.forEach(r,function(n){r[n]=!0,o(document.getElementById(n)),n=n.replace(":","\\:"),e[0].querySelectorAll&&(angular.forEach(e[0].querySelectorAll("."+n),o),angular.forEach(e[0].querySelectorAll("."+n+"\\:"),o),angular.forEach(e[0].querySelectorAll("["+n+"]"),o))}),angular.forEach(n,function(n){if(0===s.length){var a=" "+e.className+" ",o=t.exec(a);o?s.push((o[2]||"").replace(/\s+/g,",")):angular.forEach(n.attributes,function(e){0===s.length&&r[e.name]&&s.push(e.value)})}})}if(0===s.length)throw"No module found during bootstrap, unable to init ocLazyLoad";var i=function u(e){if(-1===l.indexOf(e)){l.push(e);var n=angular.module(e);a(null,n._invokeQueue,e),a(null,n._configBlocks,e),angular.forEach(n.requires,u)}};angular.forEach(s,function(e){i(e)})}var l=["ng"],s=[],f={},c=[],d=[],g={},h=angular.module("oc.lazyLoad",["ng"]),p=angular.noop;h.provider("$ocLazyLoad",["$controllerProvider","$provide","$compileProvider","$filterProvider","$injector","$animateProvider",function(a,o,s,f,c,g){var h,m,v,y={},L={$controllerProvider:a,$compileProvider:s,$filterProvider:f,$provide:o,$injector:c,$animateProvider:g},w=document.getElementsByTagName("head")[0]||document.getElementsByTagName("body")[0],O=!1,j=!1;u(angular.element(window.document)),this.$get=["$log","$q","$templateCache","$http","$rootElement","$rootScope","$cacheFactory","$interval",function(a,o,u,s,f,c,g,E){var $,x=g("ocLazyLoad"),b=!1,z=!1;O||(a={},a.error=angular.noop,a.warn=angular.noop,a.info=angular.noop),L.getInstanceInjector=function(){return $?$:$=f.data("$injector")||angular.injector()},p=function(e,n){j&&c.$broadcast(e,n),O&&a.info(e,n)};var P=function(e,n,r){var a,t,i=o.defer(),u=function(e){var n=(new Date).getTime();return e.indexOf("?")>=0?"&"===e.substring(0,e.length-1)?e+"_dc="+n:e+"&_dc="+n:e+"?_dc="+n};switch(angular.isUndefined(x.get(n))&&x.put(n,i.promise),e){case"css":a=document.createElement("link"),a.type="text/css",a.rel="stylesheet",a.href=r.cache===!1?u(n):n;break;case"js":a=document.createElement("script"),a.src=r.cache===!1?u(n):n;break;default:i.reject(new Error('Requested type "'+e+'" is not known. Could not inject "'+n+'"'))}a.onload=a.onreadystatechange=function(){a.readyState&&!/^c|loade/.test(a.readyState)||t||(a.onload=a.onreadystatechange=null,t=1,p("ocLazyLoad.fileLoaded",n),i.resolve())},a.onerror=function(){i.reject(new Error("Unable to load "+n))},a.async=r.serie?0:1;var l=w.lastChild;if(r.insertBefore){var s=angular.element(r.insertBefore);s&&s.length>0&&(l=s[0])}if(w.insertBefore(a,l),"css"==e){if(!b){var f=navigator.userAgent.toLowerCase();if(/iP(hone|od|ad)/.test(navigator.platform)){var c=navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),d=parseFloat([parseInt(c[1],10),parseInt(c[2],10),parseInt(c[3]||0,10)].join("."));z=6>d}else if(f.indexOf("android")>-1){var g=parseFloat(f.slice(f.indexOf("android")+8));z=4.4>g}else if(f.indexOf("safari")>-1&&-1==f.indexOf("chrome")){var h=parseFloat(f.match(/version\/([\.\d]+)/i)[1]);z=6>h}}if(z)var m=1e3,v=E(function(){try{a.sheet.cssRules,E.cancel(v),a.onload()}catch(e){--m<=0&&a.onerror()}},20)}return i.promise};angular.isUndefined(h)&&(h=function(e,n,r){var a=[];angular.forEach(e,function(e){a.push(P("js",e,r))}),o.all(a).then(function(){n()},function(e){n(e)})},h.ocLazyLoadLoader=!0),angular.isUndefined(m)&&(m=function(e,n,r){var a=[];angular.forEach(e,function(e){a.push(P("css",e,r))}),o.all(a).then(function(){n()},function(e){n(e)})},m.ocLazyLoadLoader=!0),angular.isUndefined(v)&&(v=function(e,n,r){var a=[];return angular.forEach(e,function(e){var n=o.defer();a.push(n.promise),s.get(e,r).success(function(r){angular.isString(r)&&r.length>0&&angular.forEach(angular.element(r),function(e){"SCRIPT"===e.nodeName&&"text/ng-template"===e.type&&u.put(e.id,e.innerHTML)}),angular.isUndefined(x.get(e))&&x.put(e,!0),n.resolve()}).error(function(r){n.reject(new Error('Unable to load template file "'+e+'": '+r))})}),o.all(a).then(function(){n()},function(e){n(e)})},v.ocLazyLoadLoader=!0);var D=function(e,n){var r=[],t=[],i=[],u=[],l=null;angular.extend(n||{},e);var s=function(e){l=x.get(e),angular.isUndefined(l)||n.cache===!1?/\.(css|less)[^\.]*$/.test(e)&&-1===r.indexOf(e)?r.push(e):/\.(htm|html)[^\.]*$/.test(e)&&-1===t.indexOf(e)?t.push(e):-1===i.indexOf(e)&&i.push(e):l&&u.push(l)};if(n.serie?s(n.files.shift()):angular.forEach(n.files,function(e){s(e)}),r.length>0){var f=o.defer();m(r,function(e){angular.isDefined(e)&&m.hasOwnProperty("ocLazyLoadLoader")?(a.error(e),f.reject(e)):f.resolve()},n),u.push(f.promise)}if(t.length>0){var c=o.defer();v(t,function(e){angular.isDefined(e)&&v.hasOwnProperty("ocLazyLoadLoader")?(a.error(e),c.reject(e)):c.resolve()},n),u.push(c.promise)}if(i.length>0){var d=o.defer();h(i,function(e){angular.isDefined(e)&&h.hasOwnProperty("ocLazyLoadLoader")?(a.error(e),d.reject(e)):d.resolve()},n),u.push(d.promise)}return n.serie&&n.files.length>0?o.all(u).then(function(){return D(e,n)}):o.all(u)};return{getModuleConfig:function(e){if(!angular.isString(e))throw new Error("You need to give the name of the module to get");return y[e]?y[e]:null},setModuleConfig:function(e){if(!angular.isObject(e))throw new Error("You need to give the module config object to set");return y[e.name]=e,e},getModules:function(){return l},isLoaded:function(e){var r=function(e){var r=l.indexOf(e)>-1;return r||(r=!!n(e)),r};if(angular.isString(e)&&(e=[e]),angular.isArray(e)){var a,t;for(a=0,t=e.length;t>a;a++)if(!r(e[a]))return!1;return!0}throw new Error("You need to define the module(s) name(s)")},load:function(u,s){var f,c,g=this,h=null,p=[],m=[],v=o.defer();if(angular.isUndefined(s)&&(s={}),angular.isArray(u))return angular.forEach(u,function(e){e&&m.push(g.load(e,s))}),o.all(m).then(function(){v.resolve(u)},function(e){v.reject(e)}),v.promise;if(f=i(u),"string"==typeof u?(h=g.getModuleConfig(u),h||(h={files:[u]},f=null)):"object"==typeof u&&(h=g.setModuleConfig(u)),null===h?(c='Module "'+f+'" is not configured, cannot load.',a.error(c),v.reject(new Error(c))):angular.isDefined(h.template)&&(angular.isUndefined(h.files)&&(h.files=[]),angular.isString(h.template)?h.files.push(h.template):angular.isArray(h.template)&&h.files.concat(h.template)),p.push=function(e){-1===this.indexOf(e)&&Array.prototype.push.apply(this,arguments)},angular.isDefined(f)&&n(f)&&-1!==l.indexOf(f)&&(p.push(f),angular.isUndefined(h.files)))return v.resolve(),v.promise;var y={};angular.extend(y,s,h);var w=function O(t){var u,l,s,f,c=[];if(u=i(t),null===u)return o.when();try{l=r(u)}catch(d){var h=o.defer();return a.error(d.message),h.reject(d),h.promise}return s=e(l),angular.forEach(s,function(e){if("string"==typeof e){var r=g.getModuleConfig(e);if(null===r)return void p.push(e);e=r}return n(e.name)?void("string"!=typeof t&&(f=e.files.filter(function(n){return g.getModuleConfig(e.name).files.indexOf(n)<0}),0!==f.length&&a.warn('Module "',u,'" attempted to redefine configuration for dependency. "',e.name,'"\n Additional Files Loaded:',f),c.push(D(e.files,y).then(function(){return O(e)})))):("object"==typeof e&&(e.hasOwnProperty("name")&&e.name&&(g.setModuleConfig(e),p.push(e.name)),e.hasOwnProperty("css")&&0!==e.css.length&&angular.forEach(e.css,function(e){P("css",e,y)})),void(e.hasOwnProperty("files")&&0!==e.files.length&&e.files&&c.push(D(e,y).then(function(){return O(e)}))))}),o.all(c)};return D(h,y).then(function(){null===f?v.resolve(u):(p.push(f),w(f).then(function(){try{d=[],t(L,p,y)}catch(e){return a.error(e.message),void v.reject(e)}v.resolve(u)},function(e){v.reject(e)}))},function(e){v.reject(e)}),v.promise}}}],this.config=function(e){if(angular.isDefined(e.jsLoader)||angular.isDefined(e.asyncLoader)){if(!angular.isFunction(e.jsLoader||e.asyncLoader))throw"The js loader needs to be a function";h=e.jsLoader||e.asyncLoader}if(angular.isDefined(e.cssLoader)){if(!angular.isFunction(e.cssLoader))throw"The css loader needs to be a function";m=e.cssLoader}if(angular.isDefined(e.templatesLoader)){if(!angular.isFunction(e.templatesLoader))throw"The template loader needs to be a function";v=e.templatesLoader}angular.isDefined(e.modules)&&(angular.isArray(e.modules)?angular.forEach(e.modules,function(e){y[e.name]=e}):y[e.modules.name]=e.modules),angular.isDefined(e.debug)&&(O=e.debug),angular.isDefined(e.events)&&(j=e.events)}}]),h.directive("ocLazyLoad",["$ocLazyLoad","$compile","$animate","$parse",function(e,n,r,a){return{restrict:"A",terminal:!0,priority:1e3,compile:function(t){var o=t[0].innerHTML;return t.html(""),function(t,i,u){var l=a(u.ocLazyLoad);t.$watch(function(){return l(t)||u.ocLazyLoad},function(a){angular.isDefined(a)&&e.load(a).then(function(){r.enter(n(o)(t),null,i)})},!0)}}}}]);var m=angular.bootstrap;angular.bootstrap=function(e,n,r){return s=n.slice(),m(e,n,r)},Array.prototype.indexOf||(Array.prototype.indexOf=function(e,n){var r;if(null==this)throw new TypeError('"this" is null or not defined');var a=Object(this),t=a.length>>>0;if(0===t)return-1;var o=+n||0;if(1/0===Math.abs(o)&&(o=0),o>=t)return-1;for(r=Math.max(o>=0?o:t-Math.abs(o),0);t>r;){if(r in a&&a[r]===e)return r;r++}return-1})}();

/***/ }),
/* 1391 */,
/* 1392 */,
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1394);

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	( function( window, factory ) {
	  /*global define: false, module: false */
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.matchesSelector = factory();
	  }
	
	}( window, function factory() {
	  'use strict';
	
	  var matchesMethod = ( function() {
	    var ElemProto = window.Element.prototype;
	    // check for the standard method name first
	    if ( ElemProto.matches ) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if ( ElemProto.matchesSelector ) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
	
	    for ( var i=0; i < prefixes.length; i++ ) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if ( ElemProto[ method ] ) {
	        return method;
	      }
	    }
	  })();
	
	  return function matchesSelector( elem, selector ) {
	    return elem[ matchesMethod ]( selector );
	  };
	
	}));


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1396);

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	/*! ng-csv 10-10-2015 */
	!function(a){angular.module("ngCsv.config",[]).value("ngCsv.config",{debug:!0}).config(["$compileProvider",function(a){angular.isDefined(a.urlSanitizationWhitelist)?a.urlSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|data):/):a.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|data):/)}]),angular.module("ngCsv.directives",["ngCsv.services"]),angular.module("ngCsv.services",[]),angular.module("ngCsv",["ngCsv.config","ngCsv.services","ngCsv.directives","ngSanitize"]),"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="ngCsv"),angular.module("ngCsv.services").service("CSV",["$q",function(a){var b="\r\n",c="﻿",d={"\\t":"	","\\b":"\b","\\v":"","\\f":"\f","\\r":"\r"};this.stringifyField=function(a,b){return"locale"===b.decimalSep&&this.isFloat(a)?a.toLocaleString():"."!==b.decimalSep&&this.isFloat(a)?a.toString().replace(".",b.decimalSep):"string"==typeof a?(a=a.replace(/"/g,'""'),(b.quoteStrings||a.indexOf(",")>-1||a.indexOf("\n")>-1||a.indexOf("\r")>-1)&&(a=b.txtDelim+a+b.txtDelim),a):"boolean"==typeof a?a?"TRUE":"FALSE":a},this.isFloat=function(a){return+a===a&&(!isFinite(a)||Boolean(a%1))},this.stringify=function(d,e){var f=a.defer(),g=this,h="",i="",j=a.when(d).then(function(a){if(angular.isDefined(e.header)&&e.header){var d,j;d=[],angular.forEach(e.header,function(a){this.push(g.stringifyField(a,e))},d),j=d.join(e.fieldSep?e.fieldSep:","),i+=j+b}var k=[];if(angular.isArray(a)?k=a:angular.isFunction(a)&&(k=a()),angular.isDefined(e.label)&&e.label&&"boolean"==typeof e.label){var l,m;l=[],angular.forEach(k[0],function(a,b){this.push(g.stringifyField(b,e))},l),m=l.join(e.fieldSep?e.fieldSep:","),i+=m+b}angular.forEach(k,function(a,c){var d,f,h=angular.copy(k[c]);f=[];var j=e.columnOrder?e.columnOrder:h;angular.forEach(j,function(a){var b=e.columnOrder?h[a]:a;this.push(g.stringifyField(b,e))},f),d=f.join(e.fieldSep?e.fieldSep:","),i+=c<k.length?d+b:d}),e.addByteOrderMarker&&(h+=c),h+=i,f.resolve(h)});return"function"==typeof j["catch"]&&j["catch"](function(a){f.reject(a)}),f.promise},this.isSpecialChar=function(a){return void 0!==d[a]},this.getSpecialChar=function(a){return d[a]}}]),angular.module("ngCsv.directives").directive("ngCsv",["$parse","$q","CSV","$document","$timeout",function(b,c,d,e,f){return{restrict:"AC",scope:{data:"&ngCsv",filename:"@filename",header:"&csvHeader",columnOrder:"&csvColumnOrder",txtDelim:"@textDelimiter",decimalSep:"@decimalSeparator",quoteStrings:"@quoteStrings",fieldSep:"@fieldSeparator",lazyLoad:"@lazyLoad",addByteOrderMarker:"@addBom",ngClick:"&",charset:"@charset",label:"&csvLabel"},controller:["$scope","$element","$attrs","$transclude",function(a,b,e){function f(){var b={txtDelim:a.txtDelim?a.txtDelim:'"',decimalSep:a.decimalSep?a.decimalSep:".",quoteStrings:a.quoteStrings,addByteOrderMarker:a.addByteOrderMarker};return angular.isDefined(e.csvHeader)&&(b.header=a.$eval(a.header)),angular.isDefined(e.csvColumnOrder)&&(b.columnOrder=a.$eval(a.columnOrder)),angular.isDefined(e.csvLabel)&&(b.label=a.$eval(a.label)),b.fieldSep=a.fieldSep?a.fieldSep:",",b.fieldSep=d.isSpecialChar(b.fieldSep)?d.getSpecialChar(b.fieldSep):b.fieldSep,b}a.csv="",angular.isDefined(a.lazyLoad)&&"true"==a.lazyLoad||angular.isArray(a.data)&&a.$watch("data",function(){a.buildCSV()},!0),a.getFilename=function(){return a.filename||"download.csv"},a.buildCSV=function(){var g=c.defer();return b.addClass(e.ngCsvLoadingClass||"ng-csv-loading"),d.stringify(a.data(),f()).then(function(c){a.csv=c,b.removeClass(e.ngCsvLoadingClass||"ng-csv-loading"),g.resolve(c)}),a.$apply(),g.promise}}],link:function(b,c){function d(){var c=b.charset||"utf-8",d=new Blob([b.csv],{type:"text/csv;charset="+c+";"});if(a.navigator.msSaveOrOpenBlob)navigator.msSaveBlob(d,b.getFilename());else{var g=angular.element('<div data-tap-disabled="true"><a></a></div>'),h=angular.element(g.children()[0]);h.attr("href",a.URL.createObjectURL(d)),h.attr("download",b.getFilename()),h.attr("target","_blank"),e.find("body").append(g),f(function(){h[0].click(),h.remove()},null)}}c.bind("click",function(){b.buildCSV().then(function(){d()}),b.$apply()})}}}])}(window,document);

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1398);

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 angular-file-upload v2.5.0
	 https://github.com/nervgh/angular-file-upload
	*/
	
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["angular-file-upload"]=t():e["angular-file-upload"]=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return e[o].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}var r=n(1),i=o(r),s=n(2),a=o(s),u=n(3),l=o(u),p=n(4),c=o(p),f=n(5),d=o(f),h=n(6),y=o(h),v=n(7),m=o(v),_=n(8),g=o(_),b=n(9),F=o(b),O=n(10),C=o(O),w=n(11),A=o(w),I=n(12),T=o(I),U=n(13),x=o(U);angular.module(i["default"].name,[]).value("fileUploaderOptions",a["default"]).factory("FileUploader",l["default"]).factory("FileLikeObject",c["default"]).factory("FileItem",d["default"]).factory("FileDirective",y["default"]).factory("FileSelect",m["default"]).factory("FileDrop",F["default"]).factory("FileOver",C["default"]).factory("Pipeline",g["default"]).directive("nvFileSelect",A["default"]).directive("nvFileDrop",T["default"]).directive("nvFileOver",x["default"]).run(["FileUploader","FileLikeObject","FileItem","FileDirective","FileSelect","FileDrop","FileOver","Pipeline",function(e,t,n,o,r,i,s,a){e.FileLikeObject=t,e.FileItem=n,e.FileDirective=o,e.FileSelect=r,e.FileDrop=i,e.FileOver=s,e.Pipeline=a}])},function(e,t){e.exports={name:"angularFileUpload"}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]={url:"/",alias:"file",headers:{},queue:[],progress:0,autoUpload:!1,removeAfterUpload:!1,method:"POST",filters:[],formData:[],queueLimit:Number.MAX_VALUE,withCredentials:!1,disableMultipart:!1}},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,n,o,i,a,u,g){var b=o.File,F=o.FormData,O=function(){function o(t){r(this,o);var n=p(e);c(this,n,t,{isUploading:!1,_nextIndex:0,_directives:{select:[],drop:[],over:[]}}),this.filters.unshift({name:"queueLimit",fn:this._queueLimitFilter}),this.filters.unshift({name:"folder",fn:this._folderFilter})}return o.prototype.addToQueue=function(e,t,n){var o=this,r=this.isArrayLikeObject(e)?Array.prototype.slice.call(e):[e],i=this._getFilters(n),l=this.queue.length,p=[],c=function d(){var e=r.shift();if(m(e))return f();var n=o.isFile(e)?e:new a(e),l=o._convertFiltersToPipes(i),c=new g(l),h=function(e){var t=e.pipe.originalFilter,n=s(e.args,2),r=n[0],i=n[1];o._onWhenAddingFileFailed(r,t,i),d()},y=function(e,t){var n=new u(o,e,t);p.push(n),o.queue.push(n),o._onAfterAddingFile(n),d()};c.onThrown=h,c.onSuccessful=y,c.exec(n,t)},f=function(){o.queue.length!==l&&(o._onAfterAddingAll(p),o.progress=o._getTotalProgress()),o._render(),o.autoUpload&&o.uploadAll()};c()},o.prototype.removeFromQueue=function(e){var t=this.getIndexOfItem(e),n=this.queue[t];n.isUploading&&n.cancel(),this.queue.splice(t,1),n._destroy(),this.progress=this._getTotalProgress()},o.prototype.clearQueue=function(){for(;this.queue.length;)this.queue[0].remove();this.progress=0},o.prototype.uploadItem=function(e){var t=this.getIndexOfItem(e),n=this.queue[t],o=this.isHTML5?"_xhrTransport":"_iframeTransport";n._prepareToUploading(),this.isUploading||(this._onBeforeUploadItem(n),n.isCancel||(n.isUploading=!0,this.isUploading=!0,this[o](n),this._render()))},o.prototype.cancelItem=function(e){var t=this,n=this.getIndexOfItem(e),o=this.queue[n],r=this.isHTML5?"_xhr":"_form";o&&(o.isCancel=!0,o.isUploading?o[r].abort():!function(){var e=[void 0,0,{}],n=function(){t._onCancelItem.apply(t,[o].concat(e)),t._onCompleteItem.apply(t,[o].concat(e))};i(n)}())},o.prototype.uploadAll=function(){var e=this.getNotUploadedItems().filter(function(e){return!e.isUploading});e.length&&(f(e,function(e){return e._prepareToUploading()}),e[0].upload())},o.prototype.cancelAll=function(){var e=this.getNotUploadedItems();f(e,function(e){return e.cancel()})},o.prototype.isFile=function(e){return this.constructor.isFile(e)},o.prototype.isFileLikeObject=function(e){return this.constructor.isFileLikeObject(e)},o.prototype.isArrayLikeObject=function(e){return this.constructor.isArrayLikeObject(e)},o.prototype.getIndexOfItem=function(e){return h(e)?e:this.queue.indexOf(e)},o.prototype.getNotUploadedItems=function(){return this.queue.filter(function(e){return!e.isUploaded})},o.prototype.getReadyItems=function(){return this.queue.filter(function(e){return e.isReady&&!e.isUploading}).sort(function(e,t){return e.index-t.index})},o.prototype.destroy=function(){var e=this;f(this._directives,function(t){f(e._directives[t],function(e){e.destroy()})})},o.prototype.onAfterAddingAll=function(e){},o.prototype.onAfterAddingFile=function(e){},o.prototype.onWhenAddingFileFailed=function(e,t,n){},o.prototype.onBeforeUploadItem=function(e){},o.prototype.onProgressItem=function(e,t){},o.prototype.onProgressAll=function(e){},o.prototype.onSuccessItem=function(e,t,n,o){},o.prototype.onErrorItem=function(e,t,n,o){},o.prototype.onCancelItem=function(e,t,n,o){},o.prototype.onCompleteItem=function(e,t,n,o){},o.prototype.onCompleteAll=function(){},o.prototype._getTotalProgress=function(e){if(this.removeAfterUpload)return e||0;var t=this.getNotUploadedItems().length,n=t?this.queue.length-t:this.queue.length,o=100/this.queue.length,r=(e||0)*o/100;return Math.round(n*o+r)},o.prototype._getFilters=function(e){if(!e)return this.filters;if(v(e))return e;var t=e.match(/[^\s,]+/g);return this.filters.filter(function(e){return-1!==t.indexOf(e.name)})},o.prototype._convertFiltersToPipes=function(e){var t=this;return e.map(function(e){var n=l(t,e.fn);return n.isAsync=3===e.fn.length,n.originalFilter=e,n})},o.prototype._render=function(){t.$$phase||t.$apply()},o.prototype._folderFilter=function(e){return!(!e.size&&!e.type)},o.prototype._queueLimitFilter=function(){return this.queue.length<this.queueLimit},o.prototype._isSuccessCode=function(e){return e>=200&&300>e||304===e},o.prototype._transformResponse=function(e,t){var o=this._headersGetter(t);return f(n.defaults.transformResponse,function(t){e=t(e,o)}),e},o.prototype._parseHeaders=function(e){var t,n,o,r={};return e?(f(e.split("\n"),function(e){o=e.indexOf(":"),t=e.slice(0,o).trim().toLowerCase(),n=e.slice(o+1).trim(),t&&(r[t]=r[t]?r[t]+", "+n:n)}),r):r},o.prototype._headersGetter=function(e){return function(t){return t?e[t.toLowerCase()]||null:e}},o.prototype._xhrTransport=function(e){var t,n=this,o=e._xhr=new XMLHttpRequest;if(e.disableMultipart?t=e._file:(t=new F,f(e.formData,function(e){f(e,function(e,n){t.append(n,e)})}),t.append(e.alias,e._file,e.file.name)),"number"!=typeof e._file.size)throw new TypeError("The file specified is no longer valid");o.upload.onprogress=function(t){var o=Math.round(t.lengthComputable?100*t.loaded/t.total:0);n._onProgressItem(e,o)},o.onload=function(){var t=n._parseHeaders(o.getAllResponseHeaders()),r=n._transformResponse(o.response,t),i=n._isSuccessCode(o.status)?"Success":"Error",s="_on"+i+"Item";n[s](e,r,o.status,t),n._onCompleteItem(e,r,o.status,t)},o.onerror=function(){var t=n._parseHeaders(o.getAllResponseHeaders()),r=n._transformResponse(o.response,t);n._onErrorItem(e,r,o.status,t),n._onCompleteItem(e,r,o.status,t)},o.onabort=function(){var t=n._parseHeaders(o.getAllResponseHeaders()),r=n._transformResponse(o.response,t);n._onCancelItem(e,r,o.status,t),n._onCompleteItem(e,r,o.status,t)},o.open(e.method,e.url,!0),o.withCredentials=e.withCredentials,f(e.headers,function(e,t){o.setRequestHeader(t,e)}),o.send(t)},o.prototype._iframeTransport=function(e){var t=this,n=_('<form style="display: none;" />'),o=_('<iframe name="iframeTransport'+Date.now()+'">'),r=e._input;e._form&&e._form.replaceWith(r),e._form=n,r.prop("name",e.alias),f(e.formData,function(e){f(e,function(e,t){var o=_('<input type="hidden" name="'+t+'" />');o.val(e),n.append(o)})}),n.prop({action:e.url,method:"POST",target:o.prop("name"),enctype:"multipart/form-data",encoding:"multipart/form-data"}),o.bind("load",function(){var n="",r=200;try{n=o[0].contentDocument.body.innerHTML}catch(i){r=500}var s={response:n,status:r,dummy:!0},a={},u=t._transformResponse(s.response,a);t._onSuccessItem(e,u,s.status,a),t._onCompleteItem(e,u,s.status,a)}),n.abort=function(){var i,s={status:0,dummy:!0},a={};o.unbind("load").prop("src","javascript:false;"),n.replaceWith(r),t._onCancelItem(e,i,s.status,a),t._onCompleteItem(e,i,s.status,a)},r.after(n),n.append(r).append(o),n[0].submit()},o.prototype._onWhenAddingFileFailed=function(e,t,n){this.onWhenAddingFileFailed(e,t,n)},o.prototype._onAfterAddingFile=function(e){this.onAfterAddingFile(e)},o.prototype._onAfterAddingAll=function(e){this.onAfterAddingAll(e)},o.prototype._onBeforeUploadItem=function(e){e._onBeforeUpload(),this.onBeforeUploadItem(e)},o.prototype._onProgressItem=function(e,t){var n=this._getTotalProgress(t);this.progress=n,e._onProgress(t),this.onProgressItem(e,t),this.onProgressAll(n),this._render()},o.prototype._onSuccessItem=function(e,t,n,o){e._onSuccess(t,n,o),this.onSuccessItem(e,t,n,o)},o.prototype._onErrorItem=function(e,t,n,o){e._onError(t,n,o),this.onErrorItem(e,t,n,o)},o.prototype._onCancelItem=function(e,t,n,o){e._onCancel(t,n,o),this.onCancelItem(e,t,n,o)},o.prototype._onCompleteItem=function(e,t,n,o){e._onComplete(t,n,o),this.onCompleteItem(e,t,n,o);var r=this.getReadyItems()[0];return this.isUploading=!1,y(r)?void r.upload():(this.onCompleteAll(),this.progress=this._getTotalProgress(),void this._render())},o.isFile=function(e){return b&&e instanceof b},o.isFileLikeObject=function(e){return e instanceof a},o.isArrayLikeObject=function(e){return d(e)&&"length"in e},o.inherit=function(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.super_=t},o}();return O.prototype.isHTML5=!(!b||!F),O.isHTML5=O.prototype.isHTML5,O}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){var n=[],o=!0,r=!1,i=void 0;try{for(var s,a=e[Symbol.iterator]();!(o=(s=a.next()).done)&&(n.push(s.value),!t||n.length!==t);o=!0);}catch(u){r=!0,i=u}finally{try{!o&&a["return"]&&a["return"]()}finally{if(r)throw i}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();t["default"]=i;var a=n(1),u=(o(a),angular),l=u.bind,p=u.copy,c=u.extend,f=u.forEach,d=u.isObject,h=u.isNumber,y=u.isDefined,v=u.isArray,m=u.isUndefined,_=u.element;i.$inject=["fileUploaderOptions","$rootScope","$http","$window","$timeout","FileLikeObject","FileItem","Pipeline"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){return function(){function e(t){r(this,e);var n=l(t),o=n?t.value:t,i=p(o)?"FakePath":"Object",s="_createFrom"+i;this[s](o)}return e.prototype._createFromFakePath=function(e){this.lastModifiedDate=null,this.size=null,this.type="like/"+e.slice(e.lastIndexOf(".")+1).toLowerCase(),this.name=e.slice(e.lastIndexOf("/")+e.lastIndexOf("\\")+2)},e.prototype._createFromObject=function(e){this.lastModifiedDate=u(e.lastModifiedDate),this.size=e.size,this.type=e.type,this.name=e.name},e}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=n(1),a=(o(s),angular),u=a.copy,l=a.isElement,p=a.isString},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){return function(){function n(e,o,i){r(this,n);var s=c(o),a=s?p(o):null,f=s?null:o;l(this,{url:e.url,alias:e.alias,headers:u(e.headers),formData:u(e.formData),removeAfterUpload:e.removeAfterUpload,withCredentials:e.withCredentials,disableMultipart:e.disableMultipart,method:e.method},i,{uploader:e,file:new t(o),isReady:!1,isUploading:!1,isUploaded:!1,isSuccess:!1,isCancel:!1,isError:!1,progress:0,index:null,_file:f,_input:a}),a&&this._replaceNode(a)}return n.prototype.upload=function(){try{this.uploader.uploadItem(this)}catch(e){var t=e.name+":"+e.message;this.uploader._onCompleteItem(this,t,e.code,[]),this.uploader._onErrorItem(this,t,e.code,[])}},n.prototype.cancel=function(){this.uploader.cancelItem(this)},n.prototype.remove=function(){this.uploader.removeFromQueue(this)},n.prototype.onBeforeUpload=function(){},n.prototype.onProgress=function(e){},n.prototype.onSuccess=function(e,t,n){},n.prototype.onError=function(e,t,n){},n.prototype.onCancel=function(e,t,n){},n.prototype.onComplete=function(e,t,n){},n.prototype._onBeforeUpload=function(){this.isReady=!0,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!1,this.isError=!1,this.progress=0,this.onBeforeUpload()},n.prototype._onProgress=function(e){this.progress=e,this.onProgress(e)},n.prototype._onSuccess=function(e,t,n){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!0,this.isCancel=!1,this.isError=!1,this.progress=100,this.index=null,this.onSuccess(e,t,n)},n.prototype._onError=function(e,t,n){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!1,this.isCancel=!1,this.isError=!0,this.progress=0,this.index=null,this.onError(e,t,n)},n.prototype._onCancel=function(e,t,n){this.isReady=!1,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!0,this.isError=!1,this.progress=0,this.index=null,this.onCancel(e,t,n)},n.prototype._onComplete=function(e,t,n){this.onComplete(e,t,n),this.removeAfterUpload&&this.remove()},n.prototype._destroy=function(){this._input&&this._input.remove(),this._form&&this._form.remove(),delete this._form,delete this._input},n.prototype._prepareToUploading=function(){this.index=this.index||++this.uploader._nextIndex,this.isReady=!0},n.prototype._replaceNode=function(t){var n=e(t.clone())(t.scope());n.prop("value",null),t.css("display","none"),t.after(n)},n}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=n(1),a=(o(s),angular),u=a.copy,l=a.extend,p=a.element,c=a.isElement;i.$inject=["$compile","FileLikeObject"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){var e=function(){function e(t){r(this,e),u(this,t),this.uploader._directives[this.prop].push(this),this._saveLinks(),this.bind()}return e.prototype.bind=function(){for(var e in this.events){var t=this.events[e];this.element.bind(e,this[t])}},e.prototype.unbind=function(){for(var e in this.events)this.element.unbind(e,this.events[e])},e.prototype.destroy=function(){var e=this.uploader._directives[this.prop].indexOf(this);this.uploader._directives[this.prop].splice(e,1),this.unbind()},e.prototype._saveLinks=function(){for(var e in this.events){var t=this.events[e];this[t]=this[t].bind(this)}},e}();return e.prototype.events={},e}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=n(1),a=(o(s),angular),u=a.extend},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){return function(t){function n(e){r(this,n);var o=p(e,{events:{$destroy:"destroy",change:"onChange"},prop:"select"}),s=i(this,t.call(this,o));return s.uploader.isHTML5||s.element.removeAttr("multiple"),s.element.prop("value",null),s}return s(n,t),n.prototype.getOptions=function(){},n.prototype.getFilters=function(){},n.prototype.isEmptyAfterSelection=function(){return!!this.element.attr("multiple")},n.prototype.onChange=function(){var t=this.uploader.isHTML5?this.element[0].files:this.element[0],n=this.getOptions(),o=this.getFilters();this.uploader.isHTML5||this.destroy(),this.uploader.addToQueue(t,n,o),this.isEmptyAfterSelection()&&(this.element.prop("value",null),this.element.replaceWith(e(this.element.clone())(this.scope)))},n}(t)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var u=n(1),l=(o(u),angular),p=l.extend;a.$inject=["$compile","FileDirective"]},function(e,t){"use strict";function n(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e){return function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?[]:arguments[0];o(this,t),this.pipes=e}return t.prototype.next=function(t){var o=this.pipes.shift();if(a(o))return void this.onSuccessful.apply(this,n(t));var r=new Error("The filter has not passed");if(r.pipe=o,r.args=t,o.isAsync){var i=e.defer(),u=s(this,this.next,t),l=s(this,this.onThrown,r);i.promise.then(u,l),o.apply(void 0,n(t).concat([i]))}else{var p=Boolean(o.apply(void 0,n(t)));p?this.next(t):this.onThrown(r)}},t.prototype.exec=function(){for(var e=arguments.length,t=Array(e),n=0;e>n;n++)t[n]=arguments[n];this.next(t)},t.prototype.onThrown=function(e){},t.prototype.onSuccessful=function(){},t}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=angular,s=i.bind,a=i.isUndefined;r.$inject=["$q"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(n){r(this,t);var o=p(n,{events:{$destroy:"destroy",drop:"onDrop",dragover:"onDragOver",dragleave:"onDragLeave"},prop:"drop"});return i(this,e.call(this,o))}return s(t,e),t.prototype.getOptions=function(){},t.prototype.getFilters=function(){},t.prototype.onDrop=function(e){var t=this._getTransfer(e);if(t){var n=this.getOptions(),o=this.getFilters();this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this),this.uploader.addToQueue(t.files,n,o)}},t.prototype.onDragOver=function(e){var t=this._getTransfer(e);this._haveFiles(t.types)&&(t.dropEffect="copy",this._preventAndStop(e),c(this.uploader._directives.over,this._addOverClass,this))},t.prototype.onDragLeave=function(e){e.currentTarget!==this.element[0]&&(this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this))},t.prototype._getTransfer=function(e){return e.dataTransfer?e.dataTransfer:e.originalEvent.dataTransfer},t.prototype._preventAndStop=function(e){e.preventDefault(),e.stopPropagation()},t.prototype._haveFiles=function(e){return e?e.indexOf?-1!==e.indexOf("Files"):e.contains?e.contains("Files"):!1:!1},t.prototype._addOverClass=function(e){e.addOverClass()},t.prototype._removeOverClass=function(e){e.removeOverClass()},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var u=n(1),l=(o(u),angular),p=l.extend,c=l.forEach;a.$inject=["FileDirective"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(n){r(this,t);var o=p(n,{events:{$destroy:"destroy"},prop:"over",overClass:"nv-file-over"});return i(this,e.call(this,o))}return s(t,e),t.prototype.addOverClass=function(){this.element.addClass(this.getOverClass())},t.prototype.removeOverClass=function(){this.element.removeClass(this.getOverClass())},t.prototype.getOverClass=function(){return this.overClass},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var u=n(1),l=(o(u),angular),p=l.extend;a.$inject=["FileDirective"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t,n){return{link:function(o,r,i){var s=o.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');var a=new n({uploader:s,element:r,scope:o});a.getOptions=e(i.options).bind(a,o),a.getFilters=function(){return i.filters}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=n(1);o(i);r.$inject=["$parse","FileUploader","FileSelect"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t,n){return{link:function(o,r,i){var s=o.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');if(s.isHTML5){var a=new n({uploader:s,element:r});a.getOptions=e(i.options).bind(a,o),a.getFilters=function(){return i.filters}}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=n(1);o(i);r.$inject=["$parse","FileUploader","FileDrop"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){return{link:function(n,o,r){var i=n.$eval(r.uploader);if(!(i instanceof e))throw new TypeError('"Uploader" must be an instance of FileUploader');var s=new t({uploader:i,element:o});s.getOverClass=function(){return r.overClass||s.overClass}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=n(1);o(i);r.$inject=["FileUploader","FileOver"]}])});
	//# sourceMappingURL=angular-file-upload.min.js.map

/***/ }),
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1412);
	module.exports = __webpack_require__(1414);

/***/ }),
/* 1412 */
1199,
/* 1413 */,
/* 1414 */
/***/ (function(module, exports) {

	/*!
	angular-xeditable - 0.3.0
	Edit-in-place for angular.js
	Build date: 2016-09-06 
	*/
	/**
	 * Angular-xeditable module 
	 *
	 */
	angular.module('xeditable', [])
	
	
	/**
	 * Default options. 
	 *
	 * @namespace editable-options
	 */
	//todo: maybe better have editableDefaults, not options...
	.value('editableOptions', {
	  /**
	   * Theme. Possible values `bs3`, `bs2`, `default`.
	   * 
	   * @var {string} theme
	   * @memberOf editable-options
	   */  
	  theme: 'default',
	  /**
	   * Icon Set. Possible values `font-awesome`, `default`.
	   * 
	   * @var {string} icon set
	   * @memberOf editable-options
	   */  
	  icon_set: 'default',
	  /**
	   * Whether to show buttons for single editalbe element.  
	   * Possible values `right` (default), `no`.
	   * 
	   * @var {string} buttons
	   * @memberOf editable-options
	   */    
	  buttons: 'right',
	  /**
	   * Default value for `blur` attribute of single editable element.  
	   * Can be `cancel|submit|ignore`.
	   * 
	   * @var {string} blurElem
	   * @memberOf editable-options
	   */
	  blurElem: 'cancel',
	  /**
	   * Default value for `blur` attribute of editable form.  
	   * Can be `cancel|submit|ignore`.
	   * 
	   * @var {string} blurForm
	   * @memberOf editable-options
	   */
	  blurForm: 'ignore',
	  /**
	   * How input elements get activated. Possible values: `focus|select|none`.
	   *
	   * @var {string} activate
	   * @memberOf editable-options
	   */
	  activate: 'focus',
	  /**
	   * Whether to disable x-editable. Can be overloaded on each element.
	   *
	   * @var {boolean} isDisabled
	   * @memberOf editable-options
	   */
	   isDisabled: false,
	  
	  /**
	   * Event, on which the edit mode gets activated. 
	   * Can be any event.
	   *
	   * @var {string} activationEvent
	   * @memberOf editable-options
	   */
	  activationEvent: 'click'
	
	});
	
	/*
	 Angular-ui bootstrap datepicker
	 http://angular-ui.github.io/bootstrap/#/datepicker
	 */
	angular.module('xeditable').directive('editableBsdate', ['editableDirectiveFactory',
	    function(editableDirectiveFactory) {
	        return editableDirectiveFactory({
	            directiveName: 'editableBsdate',
	            inputTpl: '<div></div>',
	            render: function() {
	                /** This basically renders a datepicker as in the example shown in
	                 **  http://angular-ui.github.io/bootstrap/#/datepicker
	                 **  The attributes are all the same as in the bootstrap-ui datepicker with e- as prefix
	                 **/
	                this.parent.render.call(this);
	
	                var inputDatePicker = angular.element('<input type="text" class="form-control" data-ng-model="$parent.$data"/>');
	
	                inputDatePicker.attr('uib-datepicker-popup', this.attrs.eDatepickerPopupXEditable || 'yyyy/MM/dd' );
	                inputDatePicker.attr('is-open', this.attrs.eIsOpen);
	                inputDatePicker.attr('date-disabled', this.attrs.eDateDisabled);
	                inputDatePicker.attr('uib-datepicker-popup', this.attrs.eDatepickerPopup);
	                inputDatePicker.attr('year-range', this.attrs.eYearRange || 20);
	                inputDatePicker.attr('show-button-bar', this.attrs.eShowButtonBar || true);
	                inputDatePicker.attr('current-text', this.attrs.eCurrentText || 'Today');
	                inputDatePicker.attr('clear-text', this.attrs.eClearText || 'Clear');
	                inputDatePicker.attr('close-text', this.attrs.eCloseText || 'Done');
	                inputDatePicker.attr('close-on-date-selection', this.attrs.eCloseOnDateSelection || true);
	                inputDatePicker.attr('datepicker-append-to-body', this.attrs.eDatePickerAppendToBody || false);
	                inputDatePicker.attr('date-disabled', this.attrs.eDateDisabled);
	                inputDatePicker.attr('name', this.attrs.eName);
	                inputDatePicker.attr('on-open-focus', this.attrs.eOnOpenFocus || true);
	                inputDatePicker.attr('ng-readonly', this.attrs.eReadonly || false);
	
	                if (this.attrs.eNgChange) {
	                    inputDatePicker.attr('ng-change', this.attrs.eNgChange);
	                    this.inputEl.removeAttr('ng-change');
	                }
	
	                if (this.attrs.eStyle) {
	                    inputDatePicker.attr('style', this.attrs.eStyle);
	                    this.inputEl.removeAttr('style');
	                }
	
	                this.scope.dateOptions = {
	                    formatDay:  this.attrs.eFormatDay || 'dd',
	                    formatMonth: this.attrs.eFormatMonth || 'MMMM',
	                    formatYear: this.attrs.eFormatYear || 'yyyy',
	                    formatDayHeader: this.attrs.eFormatDayHeader || 'EEE',
	                    formatDayTitle: this.attrs.eFormatDayTitle || 'MMMM yyyy',
	                    formatMonthTitle: this.attrs.eFormatMonthTitle || 'yyyy',
	                    showWeeks: this.attrs.eShowWeeks ? this.attrs.eShowWeeks.toLowerCase() === 'true' : true,
	                    startingDay: this.attrs.eStartingDay || 0,
	                    minMode: this.attrs.eMinMode || 'day',
	                    maxMode: this.attrs.eMaxMode || 'year',
	                    initDate: this.scope.$eval(this.attrs.eInitDate) || new Date(),
	                    datepickerMode: this.attrs.eDatepickerMode || 'day',
	                    maxDate: this.scope.$eval(this.attrs.eMaxDate) || null,
	                    minDate: this.scope.$eval(this.attrs.eMinDate) || null
	                };
	
	                var showCalendarButton = angular.isDefined(this.attrs.eShowCalendarButton) ? this.attrs.eShowCalendarButton : "true";
	
	                //See if calendar button should be displayed
	                if (showCalendarButton === "true") {
	                    var buttonDatePicker = angular.element('<button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button>');
	                    var buttonWrapper = angular.element('<span class="input-group-btn"></span>');
	
	                    buttonDatePicker.attr('ng-click', this.attrs.eNgClick);
	
	                    buttonWrapper.append(buttonDatePicker);
	
	                    this.inputEl.append(buttonWrapper);
	                } else {
	                    //If no calendar button, display calendar popup on click of input field
	                    inputDatePicker.attr('ng-click', this.attrs.eNgClick);
	                }
	
	                inputDatePicker.attr('datepicker-options', "dateOptions");
	
	                this.inputEl.prepend(inputDatePicker);
	
	                this.inputEl.removeAttr('class');
	                this.inputEl.removeAttr('ng-click');
	                this.inputEl.removeAttr('is-open');
	                this.inputEl.removeAttr('init-date');
	                this.inputEl.removeAttr('datepicker-popup');
	                this.inputEl.removeAttr('required');
	                this.inputEl.removeAttr('ng-model');
	                this.inputEl.removeAttr('date-picker-append-to-body');
	                this.inputEl.removeAttr('name');
	                this.inputEl.attr('class','input-group');
	            }
		});
	}]);
	/*
	Angular-ui bootstrap editable timepicker
	http://angular-ui.github.io/bootstrap/#/timepicker
	*/
	angular.module('xeditable').directive('editableBstime', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableBstime',
	      inputTpl: '<uib-timepicker></uib-timepicker>',
	      render: function() {
	        this.parent.render.call(this);
	
	        // timepicker can't update model when ng-model set directly to it
	        // see: https://github.com/angular-ui/bootstrap/issues/1141
	        // so we wrap it into DIV
	        var div = angular.element('<div class="well well-small" style="display:inline-block;"></div>');
	
	        // move ng-model to wrapping div
	        div.attr('ng-model', this.inputEl.attr('ng-model'));
	        this.inputEl.removeAttr('ng-model');
	
	        // move ng-change to wrapping div
	        if(this.attrs.eNgChange) {
	          div.attr('ng-change', this.inputEl.attr('ng-change'));
	          this.inputEl.removeAttr('ng-change');
	        }
	
	        // wrap
	        this.inputEl.wrap(div);
	      }
	    });
	}]);
	//checkbox
	angular.module('xeditable').directive('editableCheckbox', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableCheckbox',
	      inputTpl: '<input type="checkbox">',
	      render: function() {
	        this.parent.render.call(this);
	        if(this.attrs.eTitle) {
	          this.inputEl.wrap('<label></label>');
	          this.inputEl.parent().append('<span>' + this.attrs.eTitle + '</span>');
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          setTimeout(function() {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }, 500);
	        });
	      }
	    });
	}]);
	
	// checklist
	angular.module('xeditable').directive('editableChecklist', [
	  'editableDirectiveFactory',
	  'editableNgOptionsParser',
	  function(editableDirectiveFactory, editableNgOptionsParser) {
	    return editableDirectiveFactory({
	      directiveName: 'editableChecklist',
	      inputTpl: '<span></span>',
	      useCopy: true,
	      render: function() {
	        this.parent.render.call(this);
	        var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
	        var html = '<label ng-repeat="'+parsed.ngRepeat+'">'+
	          '<input type="checkbox" checklist-model="$parent.$parent.$data" checklist-value="'+parsed.locals.valueFn+'">'+
	          '<span ng-bind="'+parsed.locals.displayFn+'"></span></label>';
	
	        this.inputEl.removeAttr('ng-model');
	        this.inputEl.removeAttr('ng-options');
	        this.inputEl.html(html);
	      }
	    });
	}]);
	
	angular.module('xeditable').directive('editableCombodate', ['editableDirectiveFactory', 'editableCombodate',
	  function(editableDirectiveFactory, editableCombodate) {
	    return editableDirectiveFactory({
	      directiveName: 'editableCombodate',
	      inputTpl: '<input type="text">',
	      render: function() {
	        this.parent.render.call(this);
	
	        var options = {
	          value: new Date(this.scope.$data)
	        };
	        var self = this;
	        angular.forEach(["format", "template", "minYear", "maxYear", "yearDescending", "minuteStep", "secondStep", "firstItem", "errorClass", "customClass", "roundTime", "smartDays"], function(name) {
	
	          var attrName = "e" + name.charAt(0).toUpperCase() + name.slice(1);
	          if (attrName in self.attrs) {
	            options[name] = self.attrs[attrName];
	          }
	        });
	
	        var combodate = editableCombodate.getInstance(this.inputEl, options);
	        combodate.$widget.find('select').bind('change', function(e) {
	          self.scope.$data = (new Date(combodate.getValue())).toISOString();
	        });
	      }
	    });
	  }
	]);
	
	/*
	Input types: text|password|email|tel|number|url|search|color|date|datetime|datetime-local|time|month|week|file
	*/
	
	(function() {
	
	  var camelCase = function(dashDelimitedString) {
	    return dashDelimitedString.toLowerCase().replace(/-(.)/g, function(match, word) {
	      return word.toUpperCase();
	    });
	  };
	
	  var types = 'text|password|email|tel|number|url|search|color|date|datetime|datetime-local|time|month|week|file'.split('|');
	
	  //todo: datalist
	  
	  // generate directives
	  angular.forEach(types, function(type) {
	    var directiveName = camelCase('editable' + '-' + type);
	    angular.module('xeditable').directive(directiveName, ['editableDirectiveFactory',
	      function(editableDirectiveFactory) {
	        return editableDirectiveFactory({
	          directiveName: directiveName,
	          inputTpl: '<input type="'+type+'">',
	          render: function() {
	            this.parent.render.call(this);
	
	            // Add label to the input
	            if (this.attrs.eLabel) {
	              var label = angular.element('<label>' + this.attrs.eLabel + '</label>');
	              this.inputEl.parent().prepend(label);
	            }
	            
	            // Add classes to the form
	            if (this.attrs.eFormclass) {
	              this.editorEl.addClass(this.attrs.eFormclass);
	            }
	          }
	        });
	    }]);
	  });
	
	  //`range` is bit specific
	  angular.module('xeditable').directive('editableRange', ['editableDirectiveFactory',
	    function(editableDirectiveFactory) {
	      return editableDirectiveFactory({
	        directiveName: 'editableRange',
	        inputTpl: '<input type="range" id="range" name="range">',
	        render: function() {
	          this.parent.render.call(this);
	          this.inputEl.after('<output>{{$data}}</output>');
	        }        
	      });
	  }]);
	
	}());
	
	
	/*
	 Tags input directive for AngularJS
	 https://github.com/mbenford/ngTagsInput
	 */
	angular.module('xeditable').directive('editableTagsInput', ['editableDirectiveFactory', 'editableUtils',
	  function(editableDirectiveFactory, editableUtils) {
	    var findElement = function(name) {
	        for(var i = 0, len = autoComplete.length; i < len; i++) {
	            if (autoComplete[i].name === name) {
	                return i;
	            }
	        }
	    };
	
	    var autoComplete = [];
	
	    var dir = editableDirectiveFactory({
	        directiveName: 'editableTagsInput',
	        inputTpl: '<tags-input></tags-input>',
	        render: function () {
	            var index = findElement(this.name);
	            this.parent.render.call(this);
	            this.inputEl.append(editableUtils.rename('auto-complete', autoComplete[index].element));
	            this.inputEl.removeAttr('ng-model');
	            this.inputEl.attr('ng-model', '$parent.$data');
	        }
	    });
	
	    var linkOrg = dir.link;
	
	    dir.link = function (scope, el, attrs, ctrl) {
	        var autoCompleteEl = el.find('editable-tags-input-auto-complete');
	
	        autoComplete.push({name : attrs.name || attrs.editableTagsInput, element : autoCompleteEl.clone()});
	
	        autoCompleteEl.remove();
	
	        return linkOrg(scope, el, attrs, ctrl);
	    };
	
	    return dir;
	}]);
	// radiolist
	angular.module('xeditable').directive('editableRadiolist', [
	  'editableDirectiveFactory',
	  'editableNgOptionsParser',
	  function(editableDirectiveFactory, editableNgOptionsParser) {
	    return editableDirectiveFactory({
	      directiveName: 'editableRadiolist',
	      inputTpl: '<span></span>',
	      render: function() {
	        this.parent.render.call(this);
	        var parsed = editableNgOptionsParser(this.attrs.eNgOptions);
	        
	        var html = '<label data-ng-repeat="'+parsed.ngRepeat+'">'+
	          '<input type="radio" data-ng-disabled="::' + this.attrs.eNgDisabled + '" data-ng-model="$parent.$parent.$data" value="{{::'+parsed.locals.valueFn+'}}">'+
	          '<span data-ng-bind="::'+parsed.locals.displayFn+'"></span></label>';
	
	        this.inputEl.removeAttr('ng-model');
	        this.inputEl.removeAttr('ng-options');
	        this.inputEl.html(html);
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          setTimeout(function() {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }, 500);
	        });
	      }
	    });
	}]);
	
	//select
	angular.module('xeditable').directive('editableSelect', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableSelect',
	      inputTpl: '<select></select>',
	      render: function() {
	        this.parent.render.call(this);
	
	        if (this.attrs.ePlaceholder) {
	          var placeholder = angular.element('<option value="">' + this.attrs.ePlaceholder + '</option>');
	          this.inputEl.append(placeholder);
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('change', function() {
	          self.scope.$apply(function() {
	            self.scope.$form.$submit();
	          });
	        });
	      }
	    });
	}]);
	//textarea
	angular.module('xeditable').directive('editableTextarea', ['editableDirectiveFactory',
	  function(editableDirectiveFactory) {
	    return editableDirectiveFactory({
	      directiveName: 'editableTextarea',
	      inputTpl: '<textarea></textarea>',
	      addListeners: function() {
	        var self = this;
	        self.parent.addListeners.call(self);
	        // submit textarea by ctrl+enter even with buttons
	        if (self.single && self.buttons !== 'no') {
	          self.autosubmit();
	        }
	      },
	      autosubmit: function() {
	        var self = this;
	        self.inputEl.bind('keydown', function(e) {
	          if ((e.ctrlKey || e.metaKey) && (e.keyCode === 13)) {
	            self.scope.$apply(function() {
	              self.scope.$form.$submit();
	            });
	          }
	        });
	      }
	    });
	}]);
	
	/*
	 AngularJS-native version of Select2 and Selectize
	 https://github.com/angular-ui/ui-select
	 */
	angular.module('xeditable').directive('editableUiSelect',['editableDirectiveFactory', 'editableUtils',
	    function(editableDirectiveFactory, editableUtils) {
	        var findElement = function(name) {
	            for(var i = 0, len = match.length; i < len; i++) {
	                  if (match[i].name === name) {
	                      return i;
	                  }
	              }
	        };
	
	        var match = [];
	        var choices = [];
	
	        var dir = editableDirectiveFactory({
	            directiveName: 'editableUiSelect',
	            inputTpl: '<ui-select></ui-select>',
	            render: function () {
	                var index = findElement(this.name);
	                this.parent.render.call(this);
	                this.inputEl.append(editableUtils.rename('ui-select-match', match[index].element));
	                this.inputEl.append(editableUtils.rename('ui-select-choices', choices[index].element));
	                this.inputEl.removeAttr('ng-model');
	                this.inputEl.attr('ng-model', '$parent.$parent.$data');
	            }
	        });
	
	        var linkOrg = dir.link;
	
	        dir.link = function (scope, el, attrs, ctrl) {
	            var matchEl = el.find('editable-ui-select-match');
	            var choicesEl = el.find('editable-ui-select-choices');
	
	            match.push({name : attrs.name || attrs.editableUiSelect, element : matchEl.clone()});
	            choices.push({name : attrs.name || attrs.editableUiSelect, element : choicesEl.clone()});
	
	            matchEl.remove();
	            choicesEl.remove();
	
	            return linkOrg(scope, el, attrs, ctrl);
	        };
	
	        return dir;
	    }]);
	/**
	 * EditableController class. 
	 * Attached to element with `editable-xxx` directive.
	 *
	 * @namespace editable-element
	 */
	/*
	TODO: this file should be refactored to work more clear without closures!
	*/
	angular.module('xeditable').factory('editableController', 
	  ['$q', 'editableUtils',
	  function($q, editableUtils) {
	
	  //EditableController function
	  EditableController.$inject = ['$scope', '$attrs', '$element', '$parse', 'editableThemes', 'editableIcons', 'editableOptions', '$rootScope', '$compile', '$q'];
	  function EditableController($scope, $attrs, $element, $parse, editableThemes, editableIcons, editableOptions, $rootScope, $compile, $q) {
	    var valueGetter;
	
	    //if control is disabled - it does not participate in waiting process
	    var inWaiting;
	
	    var self = this;
	
	    self.scope = $scope;
	    self.elem = $element;
	    self.attrs = $attrs;
	    self.inputEl = null;
	    self.editorEl = null;
	    self.single = true;
	    self.error = '';
	    self.theme =  editableThemes[$attrs.editableTheme] || editableThemes[editableOptions.theme] || editableThemes['default'];
	    self.parent = {};
	
	    //will be undefined if icon_set is default and theme is default
	    self.icon_set = editableOptions.icon_set === 'default' ? editableIcons.default[editableOptions.theme] : editableIcons.external[editableOptions.icon_set];
	
	    //to be overwritten by directive
	    self.inputTpl = '';
	    self.directiveName = '';
	
	    // with majority of controls copy is not needed, but..
	    // copy MUST NOT be used for `select-multiple` with objects as items
	    // copy MUST be used for `checklist`
	    self.useCopy = false;
	
	    //runtime (defaults)
	    self.single = null;
	
	    /**
	     * Attributes defined with `e-*` prefix automatically transferred from original element to
	     * control.  
	     * For example, if you set `<span editable-text="user.name" e-style="width: 100px"`>
	     * then input will appear as `<input style="width: 100px">`.  
	     * See [demo](#text-customize).
	     * 
	     * @var {any|attribute} e-*
	     * @memberOf editable-element
	     */ 
	
	    /**
	     * Whether to show ok/cancel buttons. Values: `right|no`.
	     * If set to `no` control automatically submitted when value changed.  
	     * If control is part of form buttons will never be shown. 
	     * 
	     * @var {string|attribute} buttons
	     * @memberOf editable-element
	     */    
	    self.buttons = 'right'; 
	    /**
	     * Action when control losses focus. Values: `cancel|submit|ignore`.
	     * Has sense only for single editable element.
	     * Otherwise, if control is part of form - you should set `blur` of form, not of individual element.
	     * 
	     * @var {string|attribute} blur
	     * @memberOf editable-element
	     */     
	    // no real `blur` property as it is transferred to editable form
	
	    //init
	    self.init = function(single) {
	      self.single = single;
	
	      self.name = $attrs.eName || $attrs[self.directiveName];
	      /*
	      if(!$attrs[directiveName] && !$attrs.eNgModel && ($attrs.eValue === undefined)) {
	        throw 'You should provide value for `'+directiveName+'` or `e-value` in editable element!';
	      }
	      */
	      if($attrs[self.directiveName]) {
	        valueGetter = $parse($attrs[self.directiveName]);
	      } else {
	        throw 'You should provide value for `'+self.directiveName+'` in editable element!';
	      }
	
	      // settings for single and non-single
	      if (!self.single) {
	        // hide buttons for non-single
	        self.buttons = 'no';
	      } else {
	        self.buttons = self.attrs.buttons || editableOptions.buttons;
	      }
	
	      //if name defined --> watch changes and update $data in form
	      if($attrs.eName) {
	        self.scope.$watch('$data', function(newVal){
	          self.scope.$form.$data[$attrs.eName] = newVal;
	        });
	      }
	
	      /**
	       * Called when control is shown.  
	       * See [demo](#select-remote).
	       * 
	       * @var {method|attribute} onshow
	       * @memberOf editable-element
	       */
	      if($attrs.onshow) {
	        self.onshow = function() {
	          return self.catchError($parse($attrs.onshow)($scope));
	        };
	      }
	
	      /**
	       * Called when control is hidden after both save or cancel.  
	       * 
	       * @var {method|attribute} onhide
	       * @memberOf editable-element
	       */
	      if($attrs.onhide) {
	        self.onhide = function() {
	          return $parse($attrs.onhide)($scope);
	        };
	      }
	
	      /**
	       * Called when control is cancelled.  
	       * 
	       * @var {method|attribute} oncancel
	       * @memberOf editable-element
	       */
	      if($attrs.oncancel) {
	        self.oncancel = function() {
	          return $parse($attrs.oncancel)($scope);
	        };
	      }          
	
	      /**
	       * Called during submit before value is saved to model.  
	       * See [demo](#onbeforesave).
	       * 
	       * @var {method|attribute} onbeforesave
	       * @memberOf editable-element
	       */
	      if ($attrs.onbeforesave) {
	        self.onbeforesave = function() {
	          return self.catchError($parse($attrs.onbeforesave)($scope));
	        };
	      }
	
	      /**
	       * Called during submit after value is saved to model.  
	       * See [demo](#onaftersave).
	       * 
	       * @var {method|attribute} onaftersave
	       * @memberOf editable-element
	       */
	      if ($attrs.onaftersave) {
	        self.onaftersave = function() {
	          return self.catchError($parse($attrs.onaftersave)($scope));
	        };
	      }
	
	      // watch change of model to update editable element
	      // now only add/remove `editable-empty` class.
	      // Initially this method called with newVal = undefined, oldVal = undefined
	      // so no need initially call handleEmpty() explicitly
	      $scope.$parent.$watch($attrs[self.directiveName], function(newVal, oldVal) {
	        self.setLocalValue();
	        self.handleEmpty();
	      });
	    };
	
	    self.render = function() {
	      var theme = self.theme;
	
	      //build input
	      self.inputEl = angular.element(self.inputTpl);
	
	      //build controls
	      self.controlsEl = angular.element(theme.controlsTpl);
	      self.controlsEl.append(self.inputEl);
	
	      //build buttons
	      if(self.buttons !== 'no') {
	        self.buttonsEl = angular.element(theme.buttonsTpl);
	        self.submitEl = angular.element(theme.submitTpl);
	        self.cancelEl = angular.element(theme.cancelTpl);
	        if(self.icon_set) {
	          self.submitEl.find('span').addClass(self.icon_set.ok);
	          self.cancelEl.find('span').addClass(self.icon_set.cancel);
	        }
	        self.buttonsEl.append(self.submitEl).append(self.cancelEl);
	        self.controlsEl.append(self.buttonsEl);
	        
	        self.inputEl.addClass('editable-has-buttons');
	      }
	
	      //build error
	      self.errorEl = angular.element(theme.errorTpl);
	      self.controlsEl.append(self.errorEl);
	
	      //build editor
	      self.editorEl = angular.element(self.single ? theme.formTpl : theme.noformTpl);
	      self.editorEl.append(self.controlsEl);
	
	      // transfer `e-*|data-e-*|x-e-*` attributes
	      for(var k in $attrs.$attr) {
	        if(k.length <= 1) {
	          continue;
	        }
	        var transferAttr = false;
	        var nextLetter = k.substring(1, 2);
	
	        // if starts with `e` + uppercase letter
	        if(k.substring(0, 1) === 'e' && nextLetter === nextLetter.toUpperCase()) {
	          transferAttr = k.substring(1); // cut `e`
	        } else {
	          continue;
	        }
	        
	        // exclude `form` and `ng-submit`, 
	        if(transferAttr === 'Form' || transferAttr === 'NgSubmit') {
	          continue;
	        }
	
	        // convert back to lowercase style
	        transferAttr = transferAttr.substring(0, 1).toLowerCase() + editableUtils.camelToDash(transferAttr.substring(1));  
	
	        // workaround for attributes without value (e.g. `multiple = "multiple"`)
	        // except for 'e-value'
	        var attrValue = (transferAttr !== 'value' && $attrs[k] === '') ? transferAttr : $attrs[k];
	
	        // set attributes to input
	        self.inputEl.attr(transferAttr, attrValue);
	      }
	
	      self.inputEl.addClass('editable-input');
	      self.inputEl.attr('ng-model', '$parent.$data');
	
	      // add directiveName class to editor, e.g. `editable-text`
	      self.editorEl.addClass(editableUtils.camelToDash(self.directiveName));
	
	      if(self.single) {
	        self.editorEl.attr('editable-form', '$form');
	        // transfer `blur` to form
	        self.editorEl.attr('blur', self.attrs.blur || (self.buttons === 'no' ? 'cancel' : editableOptions.blurElem));
	      }
	
	      //apply `postrender` method of theme
	      if(angular.isFunction(theme.postrender)) {
	        theme.postrender.call(self);
	      }
	
	    };
	
	    // with majority of controls copy is not needed, but..
	    // copy MUST NOT be used for `select-multiple` with objects as items
	    // copy MUST be used for `checklist`
	    self.setLocalValue = function() {
	      self.scope.$data = self.useCopy ? 
	        angular.copy(valueGetter($scope.$parent)) : 
	        valueGetter($scope.$parent);
	    };
	
	    // reference of the scope to use for $compile
	    var newScope = null;
	    //show
	    self.show = function() {
	      // set value of scope.$data
	      self.setLocalValue();
	
	      /*
	      Originally render() was inside init() method, but some directives polluting editorEl,
	      so it is broken on second openning.
	      Cloning is not a solution as jqLite can not clone with event handler's.
	      */
	      self.render();
	
	      // insert into DOM
	      $element.after(self.editorEl);
	
	      // compile (needed to attach ng-* events from markup)
	      newScope = $scope.$new();
	      $compile(self.editorEl)(newScope);
	
	      // attach listeners (`escape`, autosubmit, etc)
	      self.addListeners();
	
	      // hide element
	      $element.addClass('editable-hide');
	
	      // onshow
	      return self.onshow();
	    };
	
	    //hide
	    self.hide = function() {
	
	      // destroy the scope to prevent memory leak
	      newScope.$destroy();
	
	      self.controlsEl.remove();
	      self.editorEl.remove();
	      $element.removeClass('editable-hide');
	
	      // onhide
	      return self.onhide();
	    };
	
	    // cancel
	    self.cancel = function() {
	      // oncancel
	      self.oncancel();
	      // don't call hide() here as it called in form's code
	    };
	
	    /*
	    Called after show to attach listeners
	    */
	    self.addListeners = function() {
	      // bind keyup for `escape`
	      self.inputEl.bind('keyup', function(e) {
	          if(!self.single) {
	            return;
	          }
	
	          // todo: move this to editable-form!
	          switch(e.keyCode) {
	            // hide on `escape` press
	            case 27:
	              self.scope.$apply(function() {
	                self.scope.$form.$cancel();
	              });
	            break;
	          }
	      });
	
	      // autosubmit when `no buttons`
	      if (self.single && self.buttons === 'no') {
	        self.autosubmit();
	      }
	
	      // click - mark element as clicked to exclude in document click handler
	      self.editorEl.bind('click', function(e) {
	        // ignore right/middle button click
	        if (e.which && e.which !== 1) {
	          return;
	        }
	
	        if (self.scope.$form.$visible) {
	          self.scope.$form._clicked = true;
	        }
	      });
	    };
	
	    // setWaiting
	    self.setWaiting = function(value) {
	      if (value) {
	        // participate in waiting only if not disabled
	        inWaiting = !self.inputEl.attr('disabled') &&
	                    !self.inputEl.attr('ng-disabled') &&
	                    !self.inputEl.attr('ng-enabled');
	        if (inWaiting) {
	          self.inputEl.attr('disabled', 'disabled');
	          if(self.buttonsEl) {
	            self.buttonsEl.find('button').attr('disabled', 'disabled');
	          }
	        }
	      } else {
	        if (inWaiting) {
	          self.inputEl.removeAttr('disabled');
	          if (self.buttonsEl) {
	            self.buttonsEl.find('button').removeAttr('disabled');
	          }
	        }
	      }
	    };
	
	    self.activate = function(start, end) {
	      setTimeout(function() {
	        var el = self.inputEl[0];
	        if (editableOptions.activate === 'focus' && el.focus) {
	          if(start){
	            end = end || start;
	            el.onfocus = function(){
	              var that = this;
	              setTimeout(function(){
	                that.setSelectionRange(start,end);
	              });
	            };
	          }
	          el.focus();
	        }
	        if (editableOptions.activate === 'select' && el.select) {
	          el.select();
	        }
	      }, 0);
	    };
	
	    self.setError = function(msg) {
	      if(!angular.isObject(msg)) {
	        $scope.$error = msg;
	        self.error = msg;
	      }
	    };
	
	    /*
	    Checks that result is string or promise returned string and shows it as error message
	    Applied to onshow, onbeforesave, onaftersave
	    */
	    self.catchError = function(result, noPromise) {
	      if (angular.isObject(result) && noPromise !== true) {
	        $q.when(result).then(
	          //success and fail handlers are equal
	          angular.bind(this, function(r) {
	            this.catchError(r, true);
	          }),
	          angular.bind(this, function(r) {
	            this.catchError(r, true);
	          })
	        );
	      //check $http error
	      } else if (noPromise && angular.isObject(result) && result.status &&
	        (result.status !== 200) && result.data && angular.isString(result.data)) {
	        this.setError(result.data);
	        //set result to string: to let form know that there was error
	        result = result.data;
	      } else if (angular.isString(result)) {
	        this.setError(result);
	      }
	      return result;
	    };
	
	    self.save = function() {
	      valueGetter.assign($scope.$parent,
	          self.useCopy ? angular.copy(self.scope.$data) : self.scope.$data);
	
	      // no need to call handleEmpty here as we are watching change of model value
	      // self.handleEmpty();
	    };
	
	    /*
	    attach/detach `editable-empty` class to element
	    */
	    self.handleEmpty = function() {
	      var val = valueGetter($scope.$parent);
	      var isEmpty = val === null || val === undefined || val === "" || (angular.isArray(val) && val.length === 0); 
	      $element.toggleClass('editable-empty', isEmpty);
	    };
	
	    /*
	    Called when `buttons = "no"` to submit automatically
	    */
	    self.autosubmit = angular.noop;
	
	    self.onshow = angular.noop;
	    self.onhide = angular.noop;
	    self.oncancel = angular.noop;
	    self.onbeforesave = angular.noop;
	    self.onaftersave = angular.noop;
	  }
	
	  return EditableController;
	}]);
	
	/*
	editableFactory is used to generate editable directives (see `/directives` folder)
	Inside it does several things:
	- detect form for editable element. Form may be one of three types:
	  1. autogenerated form (for single editable elements)
	  2. wrapper form (element wrapped by <form> tag)
	  3. linked form (element has `e-form` attribute pointing to existing form)
	
	- attach editableController to element
	
	Depends on: editableController, editableFormFactory
	*/
	angular.module('xeditable').factory('editableDirectiveFactory',
	['$parse', '$compile', 'editableThemes', '$rootScope', '$document', 'editableController', 'editableFormController', 'editableOptions',
	function($parse, $compile, editableThemes, $rootScope, $document, editableController, editableFormController, editableOptions) {
	
	  //directive object
	  return function(overwrites) {
	    return {
	      restrict: 'A',
	      scope: true,
	      require: [overwrites.directiveName, '?^form'],
	      controller: editableController,
	      link: function(scope, elem, attrs, ctrl) {
	        // editable controller
	        var eCtrl = ctrl[0];
	
	        // form controller
	        var eFormCtrl;
	
	        // this variable indicates is element is bound to some existing form,
	        // or it's single element who's form will be generated automatically
	        // By default consider single element without any linked form.ß
	        var hasForm = false;
	
	        // element wrapped by form
	        if (ctrl[1]) {
	          eFormCtrl = ctrl[1];
	          hasForm = attrs.eSingle === undefined;
	        } else if (attrs.eForm) { // element not wrapped by <form>, but we have `e-form` attr
	          var getter = $parse(attrs.eForm)(scope);
	          if (getter) { // form exists in scope (above), e.g. editable column
	            eFormCtrl = getter;
	            hasForm = true;
	          } else if (elem && typeof elem.parents === "function" && elem.parents().last().find('form[name='+attrs.eForm+']').length) { // form exists below or not exist at all: check document.forms
	            // form is below and not processed yet
	            eFormCtrl = null;
	            hasForm = true;
	          } else {
	            // form exists below or not exist at all: check document.forms
	            for (var i=0; i<$document[0].forms.length;i++) {
	              if ($document[0].forms[i].name === attrs.eForm) {
	                // form is below and not processed yet
	                eFormCtrl = null;
	                hasForm = true;
	                break;
	              }
	            }
	          }
	        }
	
	        /*
	        if(hasForm && !attrs.eName) {
	          throw 'You should provide `e-name` for editable element inside form!';
	        }
	        */
	
	        //check for `editable-form` attr in form
	        /*
	        if(eFormCtrl && ) {
	          throw 'You should provide `e-name` for editable element inside form!';
	        }
	        */
	
	        // store original props to `parent` before merge
	        angular.forEach(overwrites, function(v, k) {
	          if(eCtrl[k] !== undefined) {
	            eCtrl.parent[k] = eCtrl[k];
	          }
	        });
	
	        // merge overwrites to base editable controller
	        angular.extend(eCtrl, overwrites);
	
	        // x-editable can be disabled using editableOption or edit-disabled attribute
	        var disabled = angular.isDefined(attrs.editDisabled) ?
	          scope.$eval(attrs.editDisabled) :
	          editableOptions.isDisabled;
	
	        if (disabled) {
	          return;
	        }
	
	        // init editable ctrl
	        eCtrl.init(!hasForm);
	
	        // publich editable controller as `$editable` to be referenced in html
	        scope.$editable = eCtrl;
	
	        // add `editable` class to element
	        elem.addClass('editable');
	
	        // hasForm
	        if(hasForm) {
	          if(eFormCtrl) {
	            scope.$form = eFormCtrl;
	            if(!scope.$form.$addEditable) {
	              throw 'Form with editable elements should have `editable-form` attribute.';
	            }
	            scope.$form.$addEditable(eCtrl);
	          } else {
	            // future form (below): add editable controller to buffer and add to form later
	            $rootScope.$$editableBuffer = $rootScope.$$editableBuffer || {};
	            $rootScope.$$editableBuffer[attrs.eForm] = $rootScope.$$editableBuffer[attrs.eForm] || [];
	            $rootScope.$$editableBuffer[attrs.eForm].push(eCtrl);
	            scope.$form = null; //will be re-assigned later
	          }
	        // !hasForm
	        } else {
	          // create editableform controller
	          scope.$form = editableFormController();
	          // add self to editable controller
	          scope.$form.$addEditable(eCtrl);
	
	          // if `e-form` provided, publish local $form in scope
	          if(attrs.eForm) {
	            ($parse(attrs.eForm).assign || angular.noop)(scope.$parent, scope.$form);
	          }
	
	          // bind click - if no external form defined
	          if(!attrs.eForm || attrs.eClickable) {
	            elem.addClass('editable-click');
	            elem.bind(editableOptions.activationEvent, function(e) {
	              e.preventDefault();
	              e.editable = eCtrl;
	              scope.$apply(function(){
	                scope.$form.$show();
	              });
	            });
	          }
	        }
	
	      }
	    };
	  };
	}]);
	
	/*
	Returns editableForm controller
	*/
	angular.module('xeditable').factory('editableFormController', 
	  ['$parse', '$document', '$rootScope', 'editablePromiseCollection', 'editableUtils',
	  function($parse, $document, $rootScope, editablePromiseCollection, editableUtils) {
	
	  // array of opened editable forms
	  var shown = [];
	
	  //Check if the child element correspond or is a descendant of the parent element
	  var isSelfOrDescendant = function (parent, child) {
	    if (child == parent) {
	      return true;
	    }
	
	    var node = child.parentNode;
	    while (node !== null) {
	      if (node == parent) {
	        return true;
	      }
	      node = node.parentNode;
	    }
	    return false;
	  };
	  
	  //Check if it is a real blur : if the click event appear on a shown editable elem, this is not a blur.
	  var isBlur = function(shown, event) {
	    var isBlur = true;
	
	    var editables = shown.$editables;
	    angular.forEach(editables, function(v){
	      var element = v.editorEl[0];
	      if (isSelfOrDescendant(element, event.target))
	        isBlur = false;
	      
	    });
	    return isBlur;
	  };
	  
	  // bind click to body: cancel|submit|ignore forms
	  $document.bind('click', function(e) {
	    // ignore right/middle button click
	    if (e.which && e.which !== 1) {
	      return;
	    }
	
	    var toCancel = [];
	    var toSubmit = [];
	    for (var i=0; i<shown.length; i++) {
	
	      // exclude clicked
	      if (shown[i]._clicked) {
	        shown[i]._clicked = false;
	        continue;
	      }
	
	      // exclude waiting
	      if (shown[i].$waiting) {
	        continue;
	      }
	
	      if (shown[i]._blur === 'cancel' && isBlur(shown[i], e)) {
	        toCancel.push(shown[i]);
	      }
	
	      if (shown[i]._blur === 'submit' && isBlur(shown[i], e)) {
	        toSubmit.push(shown[i]);
	      }
	    }
	
	    if (toCancel.length || toSubmit.length) {
	      $rootScope.$apply(function() {
	        angular.forEach(toCancel, function(v){ v.$cancel(); });
	        angular.forEach(toSubmit, function(v){ v.$submit(); });
	      });
	    }
	  });
	 
	  $rootScope.$on('closeEdit', function() {
	    for(var i=0; i < shown.length; i++) {
	      shown[i].$hide();
	    }
	  }); 
	
	  var base = {
	    $addEditable: function(editable) {
	      //console.log('add editable', editable.elem, editable.elem.bind);
	      this.$editables.push(editable);
	
	      //'on' is not supported in angular 1.0.8
	      editable.elem.bind('$destroy', angular.bind(this, this.$removeEditable, editable));
	
	      //bind editable's local $form to self (if not bound yet, below form) 
	      if (!editable.scope.$form) {
	        editable.scope.$form = this;
	      }
	
	      //if form already shown - call show() of new editable
	      if (this.$visible) {
	        editable.catchError(editable.show());
	      }
	      editable.catchError(editable.setWaiting(this.$waiting));
	    },
	
	    $removeEditable: function(editable) {
	      //arrayRemove
	      for(var i=0; i < this.$editables.length; i++) {
	        if(this.$editables[i] === editable) {
	          this.$editables.splice(i, 1);
	          return;
	        }
	      }
	    },
	
	    /**
	     * Shows form with editable controls.
	     * 
	     * @method $show()
	     * @memberOf editable-form
	     */
	    $show: function() {
	      if (this.$visible) {
	        return;
	      }
	
	      this.$visible = true;
	
	      var pc = editablePromiseCollection();
	
	      //own show
	      pc.when(this.$onshow());
	
	      //clear errors
	      this.$setError(null, '');
	
	      //children show
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.show());
	      });
	
	      //wait promises and activate
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting), 
	        onTrue: angular.bind(this, this.$activate), 
	        onFalse: angular.bind(this, this.$activate), 
	        onString: angular.bind(this, this.$activate)
	      });
	
	      // add to internal list of shown forms
	      // setTimeout needed to prevent closing right after opening (e.g. when trigger by button)
	      setTimeout(angular.bind(this, function() {
	        // clear `clicked` to get ready for clicks on visible form
	        this._clicked = false;
	        if(editableUtils.indexOf(shown, this) === -1) {
	          shown.push(this);
	        }
	      }), 0);      
	    },
	
	    /**
	     * Sets focus on form field specified by `name`.<br/>
	     * When trying to set the focus on a form field of a new row in the editable table, the `$activate` call needs to be wrapped in a `$timeout` call so that the form is rendered before the `$activate` function is called.
	     * 
	     * @method $activate(name)
	     * @param {string} name name of field
	     * @memberOf editable-form
	     */
	    $activate: function(name) {
	      var i;
	      if (this.$editables.length) {
	        //activate by name
	        if (angular.isString(name)) {
	          for(i=0; i<this.$editables.length; i++) {
	            if (this.$editables[i].name === name) {
	              this.$editables[i].activate();
	              return;
	            }
	          }
	        }
	
	        //try activate error field
	        for(i=0; i<this.$editables.length; i++) {
	          if (this.$editables[i].error) {
	            this.$editables[i].activate();
	            return;
	          }
	        }
	
	        //by default activate first field
	        this.$editables[0].activate(this.$editables[0].elem[0].selectionStart, this.$editables[0].elem[0].selectionEnd);
	      }
	    },
	
	    /**
	     * Hides form with editable controls without saving.
	     * 
	     * @method $hide()
	     * @memberOf editable-form
	     */
	    $hide: function() {
	      if (!this.$visible) {
	        return;
	      }      
	      this.$visible = false;
	      // self hide
	      this.$onhide();
	      // children's hide
	      angular.forEach(this.$editables, function(editable) {
	        editable.hide();
	      });
	
	      // remove from internal list of shown forms
	      editableUtils.arrayRemove(shown, this);
	    },
	
	    /**
	     * Triggers `oncancel` event and calls `$hide()`.
	     * 
	     * @method $cancel()
	     * @memberOf editable-form
	     */
	    $cancel: function() {
	      if (!this.$visible) {
	        return;
	      }      
	      // self cancel
	      this.$oncancel();
	      // children's cancel      
	      angular.forEach(this.$editables, function(editable) {
	        editable.cancel();
	      });
	      // self hide
	      this.$hide();
	    },    
	
	    $setWaiting: function(value) {
	      this.$waiting = !!value;
	      // we can't just set $waiting variable and use it via ng-disabled in children
	      // because in editable-row form is not accessible
	      angular.forEach(this.$editables, function(editable) {
	        editable.setWaiting(!!value);
	      });
	    },
	
	    /**
	     * Shows error message for particular field.
	     * 
	     * @method $setError(name, msg)
	     * @param {string} name name of field
	     * @param {string} msg error message
	     * @memberOf editable-form
	     */
	    $setError: function(name, msg) {
	      angular.forEach(this.$editables, function(editable) {
	        if(!name || editable.name === name) {
	          editable.setError(msg);
	        }
	      });
	    },
	
	    $submit: function() {
	      if (this.$waiting) {
	        return;
	      } 
	
	      //clear errors
	      this.$setError(null, '');
	
	      //children onbeforesave
	      var pc = editablePromiseCollection();
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.onbeforesave());
	      });
	
	      /*
	      onbeforesave result:
	      - true/undefined: save data and close form
	      - false: close form without saving
	      - string: keep form open and show error
	      */
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting), 
	        onTrue: angular.bind(this, checkSelf, true), 
	        onFalse: angular.bind(this, checkSelf, false), 
	        onString: angular.bind(this, this.$activate)
	      });
	
	      //save
	      function checkSelf(childrenTrue){
	        var pc = editablePromiseCollection();
	        pc.when(this.$onbeforesave());
	        pc.then({
	          onWait: angular.bind(this, this.$setWaiting), 
	          onTrue: childrenTrue ? angular.bind(this, this.$save) : angular.bind(this, this.$hide), 
	          onFalse: angular.bind(this, this.$hide), 
	          onString: angular.bind(this, this.$activate)
	        });
	      }
	    },
	
	    $save: function() {
	      // write model for each editable
	      angular.forEach(this.$editables, function(editable) {
	        editable.save();
	      });
	
	      //call onaftersave of self and children
	      var pc = editablePromiseCollection();
	      pc.when(this.$onaftersave());
	      angular.forEach(this.$editables, function(editable) {
	        pc.when(editable.onaftersave());
	      });
	
	      /*
	      onaftersave result:
	      - true/undefined/false: just close form
	      - string: keep form open and show error
	      */
	      pc.then({
	        onWait: angular.bind(this, this.$setWaiting), 
	        onTrue: angular.bind(this, this.$hide), 
	        onFalse: angular.bind(this, this.$hide), 
	        onString: angular.bind(this, this.$activate)
	      });
	    },
	
	    $onshow: angular.noop,
	    $oncancel: angular.noop,
	    $onhide: angular.noop,
	    $onbeforesave: angular.noop,
	    $onaftersave: angular.noop
	  };
	
	  return function() {
	    return angular.extend({
	      $editables: [],
	      /**
	       * Form visibility flag.
	       * 
	       * @var {bool} $visible
	       * @memberOf editable-form
	       */
	      $visible: false,
	      /**
	       * Form waiting flag. It becomes `true` when form is loading or saving data.
	       * 
	       * @var {bool} $waiting
	       * @memberOf editable-form
	       */
	      $waiting: false,
	      $data: {},
	      _clicked: false,
	      _blur: null
	    }, base);
	  };
	}]);
	
	/**
	 * EditableForm directive. Should be defined in <form> containing editable controls.  
	 * It add some usefull methods to form variable exposed to scope by `name="myform"` attribute.
	 *
	 * @namespace editable-form
	 */
	angular.module('xeditable').directive('editableForm',
	  ['$rootScope', '$parse', 'editableFormController', 'editableOptions',
	  function($rootScope, $parse, editableFormController, editableOptions) {
	    return {
	      restrict: 'A',
	      require: ['form'],
	      //require: ['form', 'editableForm'],
	      //controller: EditableFormController,
	      compile: function() {
	        return {
	          pre: function(scope, elem, attrs, ctrl) {
	            var form = ctrl[0];
	            var eForm;
	
	            //if `editableForm` has value - publish smartly under this value
	            //this is required only for single editor form that is created and removed
	            if(attrs.editableForm) {
	              if(scope[attrs.editableForm] && scope[attrs.editableForm].$show) {
	                eForm = scope[attrs.editableForm];
	                angular.extend(form, eForm);
	              } else {
	                eForm = editableFormController();
	                scope[attrs.editableForm] = eForm;
	                angular.extend(eForm, form);
	              }
	            } else { //just merge to form and publish if form has name
	              eForm = editableFormController();
	              angular.extend(form, eForm);
	            }
	
	            //read editables from buffer (that appeared before FORM tag)
	            var buf = $rootScope.$$editableBuffer;
	            var name = form.$name;
	            if(name && buf && buf[name]) {
	              angular.forEach(buf[name], function(editable) {
	                eForm.$addEditable(editable);
	              });
	              delete buf[name];
	            }
	          },
	          post: function(scope, elem, attrs, ctrl) {
	            var eForm;
	
	            if(attrs.editableForm && scope[attrs.editableForm] && scope[attrs.editableForm].$show) {
	              eForm = scope[attrs.editableForm];
	            } else {
	              eForm = ctrl[0];
	            }
	
	            /**
	             * Called when form is shown.
	             * 
	             * @var {method|attribute} onshow 
	             * @memberOf editable-form
	             */
	            if(attrs.onshow) {
	              eForm.$onshow = angular.bind(eForm, $parse(attrs.onshow), scope);
	            }
	
	            /**
	             * Called when form hides after both save or cancel.
	             * 
	             * @var {method|attribute} onhide 
	             * @memberOf editable-form
	             */
	            if(attrs.onhide) {
	              eForm.$onhide = angular.bind(eForm, $parse(attrs.onhide), scope);
	            }
	
	            /**
	             * Called when form is cancelled.
	             * 
	             * @var {method|attribute} oncancel
	             * @memberOf editable-form
	             */
	            if(attrs.oncancel) {
	              eForm.$oncancel = angular.bind(eForm, $parse(attrs.oncancel), scope);
	            }
	
	            /**
	             * Whether form initially rendered in shown state.
	             *
	             * @var {bool|attribute} shown
	             * @memberOf editable-form
	             */
	            if(attrs.shown && $parse(attrs.shown)(scope)) {
	              eForm.$show();
	            }
	
	            /**
	             * Action when form losses focus. Values: `cancel|submit|ignore`.
	             * Default is `ignore`.
	             * 
	             * @var {string|attribute} blur
	             * @memberOf editable-form
	             */
	            eForm._blur = attrs.blur || editableOptions.blurForm;
	
	            // onbeforesave, onaftersave
	            if(!attrs.ngSubmit && !attrs.submit) {
	              /**
	               * Called after all children `onbeforesave` callbacks but before saving form values
	               * to model.  
	               * If at least one children callback returns `non-string` - it will not not be called.  
	               * See [editable-form demo](#editable-form) for details.
	               * 
	               * @var {method|attribute} onbeforesave
	               * @memberOf editable-form
	               * 
	               */
	              if(attrs.onbeforesave) {
	                eForm.$onbeforesave = function() {
	                  return $parse(attrs.onbeforesave)(scope, {$data: eForm.$data});
	                };
	              }
	
	              /**
	               * Called when form values are saved to model.  
	               * See [editable-form demo](#editable-form) for details.
	               * 
	               * @var {method|attribute} onaftersave 
	               * @memberOf editable-form
	               * 
	               */
	              if(attrs.onaftersave) {
	                eForm.$onaftersave = function() {
	                  return $parse(attrs.onaftersave)(scope, {$data: eForm.$data});
	                };
	              }
	
	              elem.bind('submit', function(event) {
	                event.preventDefault();
	                scope.$apply(function() {
	                  eForm.$submit();
	                });
	              });
	            }
	
	
	            // click - mark form as clicked to exclude in document click handler
	            elem.bind('click', function(e) {
	              // ignore right/middle button click
	              if (e.which && e.which !== 1) {
	                return;
	              }
	
	              if (eForm.$visible) {
	                eForm._clicked = true;
	              }
	            });   
	
	          }
	        };
	      }
	    };
	}]);
	/**
	 * editablePromiseCollection
	 *  
	 * Collect results of function calls. Shows waiting if there are promises. 
	 * Finally, applies callbacks if:
	 * - onTrue(): all results are true and all promises resolved to true
	 * - onFalse(): at least one result is false or promise resolved to false
	 * - onString(): at least one result is string or promise rejected or promise resolved to string
	 */
	
	angular.module('xeditable').factory('editablePromiseCollection', ['$q', function($q) { 
	
	  function promiseCollection() {
	    return {
	      promises: [],
	      hasFalse: false,
	      hasString: false,
	      when: function(result, noPromise) {
	        if (result === false) {
	          this.hasFalse = true;
	        } else if (!noPromise && angular.isObject(result)) {
	          this.promises.push($q.when(result));
	        } else if (angular.isString(result)){
	          this.hasString = true;
	        } else { //result === true || result === undefined || result === null
	          return;
	        }
	      },
	      //callbacks: onTrue, onFalse, onString
	      then: function(callbacks) {
	        callbacks = callbacks || {};
	        var onTrue = callbacks.onTrue || angular.noop;
	        var onFalse = callbacks.onFalse || angular.noop;
	        var onString = callbacks.onString || angular.noop;
	        var onWait = callbacks.onWait || angular.noop;
	
	        var self = this;
	
	        if (this.promises.length) {
	          onWait(true);
	          $q.all(this.promises).then(
	            //all resolved       
	            function(results) {
	              onWait(false);
	              //check all results via same `when` method (without checking promises)
	              angular.forEach(results, function(result) {
	                self.when(result, true);  
	              });
	              applyCallback();
	            },
	            //some rejected
	            function(error) { 
	              onWait(false);
	              onString();
	            }
	            );
	        } else {
	          applyCallback();
	        }
	
	        function applyCallback() {
	          if (!self.hasString && !self.hasFalse) {
	            onTrue();
	          } else if (!self.hasString && self.hasFalse) {
	            onFalse();
	          } else {
	            onString();
	          }
	        }
	
	      }
	    };
	  }
	
	  return promiseCollection;
	
	}]);
	
	/**
	 * editableUtils
	 */
	 angular.module('xeditable').factory('editableUtils', [function() {
	  return {
	    indexOf: function (array, obj) {
	      if (array.indexOf) return array.indexOf(obj);
	
	      for ( var i = 0; i < array.length; i++) {
	        if (obj === array[i]) return i;
	      }
	      return -1;
	    },
	
	    arrayRemove: function (array, value) {
	      var index = this.indexOf(array, value);
	      if (index >= 0) {
	        array.splice(index, 1);
	      }
	      return value;
	    },
	
	    // copy from https://github.com/angular/angular.js/blob/master/src/Angular.js
	    camelToDash: function(str) {
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	      return str.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	        return (pos ? '-' : '') + letter.toLowerCase();
	      });
	    },
	
	    dashToCamel: function(str) {
	      var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	      var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	      return str.
	      replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	        return offset ? letter.toUpperCase() : letter;
	      }).
	      replace(MOZ_HACK_REGEXP, 'Moz$1');
	    },
	
	    rename: function (tag, el) {
	      var newEl = angular.element('<' + tag + '/>');
	      newEl.html(el.html());
	      var attrs = el[0].attributes;
	      for (var i = 0; i < attrs.length; ++i) {
	          newEl.attr(attrs.item(i).nodeName, attrs.item(i).value);
	      }
	      return newEl;
	    }
	  };
	}]);
	
	/**
	 * editableNgOptionsParser
	 *
	 * see: https://github.com/angular/angular.js/blob/master/src/ng/directive/select.js#L131
	 */
	 angular.module('xeditable').factory('editableNgOptionsParser', [function() {
	  //0000111110000000000022220000000000000000000000333300000000000000444444444444444000000000555555555555555000000066666666666666600000000000000007777000000000000000000088888
	  var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
	
	  function parser(optionsExp) {
	    var match;
	
	    if (! (match = optionsExp.match(NG_OPTIONS_REGEXP))) {
	      throw 'ng-options parse error';
	    }
	
	    var 
	    displayFn = match[2] || match[1],
	    valueName = match[4] || match[6],
	    keyName = match[5],
	    groupByFn = match[3] || '',
	    valueFn = match[2] ? match[1] : valueName,
	    valuesFn = match[7],
	    track = match[8],
	    trackFn = track ? match[8] : null;
	
	    var ngRepeat;
	    if (keyName === undefined) { // array
	      ngRepeat = valueName + ' in ' + valuesFn;
	      if (track !== undefined) {
	        ngRepeat += ' track by '+trackFn;
	      }
	    } else { // object
	      ngRepeat = '('+keyName+', '+valueName+') in '+valuesFn;
	    }
	    
	    // group not supported yet
	    return {
	      ngRepeat: ngRepeat,
	      locals: {
	        valueName: valueName,
	        keyName: keyName,
	        valueFn: valueFn,
	        displayFn: displayFn
	      }
	    };
	  }
	
	  return parser;
	}]);
	
	/**
	 * editableCombodate
	 *
	 * angular version of https://github.com/vitalets/combodate
	 */
	angular.module('xeditable').factory('editableCombodate', [function() {
	  function Combodate(element, options) {
	    this.$element = angular.element(element);
	
	    if(this.$element[0].nodeName != 'INPUT') {
	      throw 'Combodate should be applied to INPUT element';
	    }
	
	    var currentYear = new Date().getFullYear();
	    this.defaults = {
	      //in this format value stored in original input
	      format: 'YYYY-MM-DD HH:mm',
	      //in this format items in dropdowns are displayed
	      template: 'D / MMM / YYYY   H : mm',
	      //initial value, can be `new Date()`
	      value: null,
	      minYear: 1970,
	      maxYear: currentYear,
	      yearDescending: true,
	      minuteStep: 5,
	      secondStep: 1,
	      firstItem: 'empty', //'name', 'empty', 'none'
	      errorClass: null,
	      customClass: '',
	      roundTime: true, // whether to round minutes and seconds if step > 1
	      smartDays: true // whether days in combo depend on selected month: 31, 30, 28
	    };
	
	    this.options = angular.extend({}, this.defaults, options);
	    this.init();
	  }
	
	  Combodate.prototype = {
	    constructor: Combodate,
	    init: function () {
	      this.map = {
	        //key   regexp    moment.method
	        day:    ['D',    'date'], 
	        month:  ['M',    'month'], 
	        year:   ['Y',    'year'], 
	        hour:   ['[Hh]', 'hours'],
	        minute: ['m',    'minutes'], 
	        second: ['s',    'seconds'],
	        ampm:   ['[Aa]', ''] 
	      };
	      
	      this.$widget = angular.element('<span class="combodate"></span>').html(this.getTemplate());
	      
	      this.initCombos();
	      
	      if (this.options.smartDays) {
	        var combo = this;
	        this.$widget.find('select').bind('change', function(e) {
	          // update days count if month or year changes
	          if (angular.element(e.target).hasClass('month') || angular.element(e.target).hasClass('year')) {
	            combo.fillCombo('day');
	          }
	        });        
	      }
	
	      this.$widget.find('select').css('width', 'auto');
	
	      // hide original input and insert widget                                       
	      this.$element.css('display', 'none').after(this.$widget);
	      
	      // set initial value
	      this.setValue(this.$element.val() || this.options.value);
	    },
	    
	    /*
	     Replace tokens in template with <select> elements 
	     */         
	     getTemplate: function() {
	      var tpl = this.options.template;
	      var customClass = this.options.customClass;
	
	      //first pass
	      angular.forEach(this.map, function(v, k) {
	        v = v[0]; 
	        var r = new RegExp(v+'+');
	        var token = v.length > 1 ? v.substring(1, 2) : v;
	        
	        tpl = tpl.replace(r, '{'+token+'}');
	      });
	
	      //replace spaces with &nbsp;
	      tpl = tpl.replace(/ /g, '&nbsp;');
	
	      //second pass
	      angular.forEach(this.map, function(v, k) {
	        v = v[0];
	        var token = v.length > 1 ? v.substring(1, 2) : v;
	
	        tpl = tpl.replace('{'+token+'}', '<select class="'+k+' '+customClass+'"></select>');
	      });   
	
	      return tpl;
	    },
	    
	    /*
	     Initialize combos that presents in template 
	     */        
	     initCombos: function() {
	      for (var k in this.map) {
	        var c = this.$widget[0].querySelectorAll('.'+k);
	        // set properties like this.$day, this.$month etc.
	        this['$'+k] = c.length ? angular.element(c) : null;
	        // fill with items
	        this.fillCombo(k);
	      }
	    },
	
	    /*
	     Fill combo with items 
	     */        
	     fillCombo: function(k) {
	      var $combo = this['$'+k];
	      if (!$combo) {
	        return;
	      }
	
	      // define method name to fill items, e.g `fillDays`
	      var f = 'fill' + k.charAt(0).toUpperCase() + k.slice(1); 
	      var items = this[f]();
	      var value = $combo.val();
	
	      $combo.html('');
	      for(var i=0; i<items.length; i++) {
	        $combo.append('<option value="'+items[i][0]+'">'+items[i][1]+'</option>');
	      }
	
	      $combo.val(value);
	    },
	
	    /*
	     Initialize items of combos. Handles `firstItem` option 
	     */
	     fillCommon: function(key) {
	      var values = [], relTime;
	
	      if(this.options.firstItem === 'name') {
	        //need both to support moment ver < 2 and  >= 2
	        relTime = moment.relativeTime || moment.langData()._relativeTime; 
	        var header = typeof relTime[key] === 'function' ? relTime[key](1, true, key, false) : relTime[key];
	        //take last entry (see momentjs lang files structure) 
	        header = header.split(' ').reverse()[0];                
	        values.push(['', header]);
	      } else if(this.options.firstItem === 'empty') {
	        values.push(['', '']);
	      }
	      return values;
	    },  
	
	
	    /*
	    fill day
	    */
	    fillDay: function() {
	      var items = this.fillCommon('d'), name, i,
	      twoDigit = this.options.template.indexOf('DD') !== -1,
	      daysCount = 31;
	
	      // detect days count (depends on month and year)
	      // originally https://github.com/vitalets/combodate/pull/7
	      if (this.options.smartDays && this.$month && this.$year) {
	        var month = parseInt(this.$month.val(), 10);
	        var year = parseInt(this.$year.val(), 10);
	
	        if (!isNaN(month) && !isNaN(year)) {
	          daysCount = moment([year, month]).daysInMonth();
	        }
	      }
	
	      for (i = 1; i <= daysCount; i++) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	    
	    /*
	    fill month
	    */
	    fillMonth: function() {
	      var items = this.fillCommon('M'), name, i, 
	      longNames = this.options.template.indexOf('MMMM') !== -1,
	      shortNames = this.options.template.indexOf('MMM') !== -1,
	      twoDigit = this.options.template.indexOf('MM') !== -1;
	
	      for(i=0; i<=11; i++) {
	        if(longNames) {
	          //see https://github.com/timrwood/momentjs.com/pull/36
	          name = moment().date(1).month(i).format('MMMM');
	        } else if(shortNames) {
	          name = moment().date(1).month(i).format('MMM');
	        } else if(twoDigit) {
	          name = this.leadZero(i+1);
	        } else {
	          name = i+1;
	        }
	        items.push([i, name]);
	      } 
	      return items;
	    },
	    
	    /*
	    fill year
	    */
	    fillYear: function() {
	      var items = [], name, i, 
	      longNames = this.options.template.indexOf('YYYY') !== -1;
	
	      for(i=this.options.maxYear; i>=this.options.minYear; i--) {
	        name = longNames ? i : (i+'').substring(2);
	        items[this.options.yearDescending ? 'push' : 'unshift']([i, name]);
	      }
	      
	      items = this.fillCommon('y').concat(items);
	      
	      return items;
	    },
	    
	    /*
	    fill hour
	    */
	    fillHour: function() {
	      var items = this.fillCommon('h'), name, i,
	      h12 = this.options.template.indexOf('h') !== -1,
	      h24 = this.options.template.indexOf('H') !== -1,
	      twoDigit = this.options.template.toLowerCase().indexOf('hh') !== -1,
	      min = h12 ? 1 : 0, 
	      max = h12 ? 12 : 23;
	
	      for(i=min; i<=max; i++) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      } 
	      return items;
	    },
	
	    /*
	    fill minute
	    */
	    fillMinute: function() {
	      var items = this.fillCommon('m'), name, i,
	      twoDigit = this.options.template.indexOf('mm') !== -1;
	
	      for(i=0; i<=59; i+= this.options.minuteStep) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }
	      return items;
	    },
	    
	    /*
	    fill second
	    */
	    fillSecond: function() {
	      var items = this.fillCommon('s'), name, i,
	      twoDigit = this.options.template.indexOf('ss') !== -1;
	
	      for(i=0; i<=59; i+= this.options.secondStep) {
	        name = twoDigit ? this.leadZero(i) : i;
	        items.push([i, name]);
	      }    
	      return items;
	    },
	    
	    /*
	    fill ampm
	    */
	    fillAmpm: function() {
	      var ampmL = this.options.template.indexOf('a') !== -1,
	      ampmU = this.options.template.indexOf('A') !== -1,            
	      items = [
	      ['am', ampmL ? 'am' : 'AM'],
	      ['pm', ampmL ? 'pm' : 'PM']
	      ];
	      return items;
	    },
	
	    /*
	     Returns current date value from combos. 
	     If format not specified - `options.format` used.
	     If format = `null` - Moment object returned.
	     */
	     getValue: function(format) {
	      var dt, values = {}, 
	      that = this,
	      notSelected = false;
	
	      //getting selected values    
	      angular.forEach(this.map, function(v, k) {
	        if(k === 'ampm') {
	          return;
	        }
	        var def = k === 'day' ? 1 : 0;
	
	        values[k] = that['$'+k] ? parseInt(that['$'+k].val(), 10) : def; 
	        
	        if(isNaN(values[k])) {
	         notSelected = true;
	         return false; 
	       }
	     });
	      
	      //if at least one visible combo not selected - return empty string
	      if(notSelected) {
	       return '';
	     }
	
	      //convert hours 12h --> 24h 
	      if(this.$ampm) {
	        //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
	        if(values.hour === 12) {
	          values.hour = this.$ampm.val() === 'am' ? 0 : 12;                    
	        } else {
	          values.hour = this.$ampm.val() === 'am' ? values.hour : values.hour+12;
	        }
	      }
	      
	      dt = moment([values.year, values.month, values.day, values.hour, values.minute, values.second]);
	      
	      //highlight invalid date
	      this.highlight(dt);
	
	      format = format === undefined ? this.options.format : format;
	      if(format === null) {
	       return dt.isValid() ? dt : null; 
	     } else {
	       return dt.isValid() ? dt.format(format) : ''; 
	     }
	   },
	
	   setValue: function(value) {
	    if(!value) {
	      return;
	    }
	
	      // parse in strict mode (third param `true`)
	      var dt = typeof value === 'string' ? moment(value, this.options.format, true) : moment(value),
	      that = this,
	      values = {};
	      
	      //function to find nearest value in select options
	      function getNearest($select, value) {
	        var delta = {};
	        angular.forEach($select.children('option'), function(opt, i){
	          var optValue = angular.element(opt).attr('value');
	
	          if(optValue === '') return;
	          var distance = Math.abs(optValue - value); 
	          if(typeof delta.distance === 'undefined' || distance < delta.distance) {
	            delta = {value: optValue, distance: distance};
	          } 
	        }); 
	        return delta.value;
	      }
	      
	      if(dt.isValid()) {
	        //read values from date object
	        angular.forEach(this.map, function(v, k) {
	          if(k === 'ampm') {
	            return; 
	          }
	          values[k] = dt[v[1]]();
	        });
	
	        if(this.$ampm) {
	          //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
	          if(values.hour >= 12) {
	            values.ampm = 'pm';
	            if(values.hour > 12) {
	              values.hour -= 12;
	            }
	          } else {
	            values.ampm = 'am';
	            if(values.hour === 0) {
	              values.hour = 12;
	            }
	          }
	        }
	
	        angular.forEach(values, function(v, k) {
	          //call val() for each existing combo, e.g. this.$hour.val()
	          if(that['$'+k]) {
	
	            if(k === 'minute' && that.options.minuteStep > 1 && that.options.roundTime) {
	             v = getNearest(that['$'+k], v);
	           }
	           
	           if(k === 'second' && that.options.secondStep > 1 && that.options.roundTime) {
	             v = getNearest(that['$'+k], v);
	           }                       
	           
	           that['$'+k].val(v);
	         }
	       });
	
	        // update days count
	        if (this.options.smartDays) {
	          this.fillCombo('day');
	        }
	
	        this.$element.val(dt.format(this.options.format)).triggerHandler('change');
	      }
	    },
	    
	    /*
	     highlight combos if date is invalid
	     */
	     highlight: function(dt) {
	      if(!dt.isValid()) {
	        if(this.options.errorClass) {
	          this.$widget.addClass(this.options.errorClass);
	        } else {
	          //store original border color
	          if(!this.borderColor) {
	            this.borderColor = this.$widget.find('select').css('border-color'); 
	          }
	          this.$widget.find('select').css('border-color', 'red');
	        }
	      } else {
	        if(this.options.errorClass) {
	          this.$widget.removeClass(this.options.errorClass);
	        } else {
	          this.$widget.find('select').css('border-color', this.borderColor);
	        }  
	      }
	    },
	    
	    leadZero: function(v) {
	      return v <= 9 ? '0' + v : v; 
	    },
	    
	    destroy: function() {
	      this.$widget.remove();
	      this.$element.removeData('combodate').show();
	    }
	
	  };
	
	  return {
	    getInstance: function(element, options) {
	      return new Combodate(element, options);
	    }
	  };
	}]);
	
	/*
	Editable icons:
	- default
	- font-awesome
	
	*/
	angular.module('xeditable').factory('editableIcons', function() {
	
	  var icons = {
	    //Icon-set to use, defaults to bootstrap icons
	    default: {
	      'bs2': {
	        ok: 'icon-ok icon-white',
	        cancel: 'icon-remove'
	      },
	      'bs3': {
	        ok: 'glyphicon glyphicon-ok',
	        cancel: 'glyphicon glyphicon-remove'
	      }
	    },
	    external: {
	      'font-awesome': {
	        ok: 'fa fa-check',
	        cancel: 'fa fa-times'
	      }
	    }
	  };
	
	  return icons;
	});
	
	/*
	Editable themes:
	- default
	- bootstrap 2
	- bootstrap 3
	- semantic-ui
	
	Note: in postrender() `this` is instance of editableController
	*/
	angular.module('xeditable').factory('editableThemes', function() {
	  var themes = {
	    //default
	    'default': {
	      formTpl:      '<form class="editable-wrap"></form>',
	      noformTpl:    '<span class="editable-wrap"></span>',
	      controlsTpl:  '<span class="editable-controls"></span>',
	      inputTpl:     '',
	      errorTpl:     '<div class="editable-error" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:   '<span class="editable-buttons"></span>',
	      submitTpl:    '<button type="submit">save</button>',
	      cancelTpl:    '<button type="button" ng-click="$form.$cancel()">cancel</button>'
	    },
	
	    //bs2
	    'bs2': {
	      formTpl:     '<form class="form-inline editable-wrap" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls controls control-group" ng-class="{\'error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error help-block" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="editable-buttons"></span>',
	      submitTpl:   '<button type="submit" class="btn btn-primary"><span></span></button>',
	      cancelTpl:   '<button type="button" class="btn" ng-click="$form.$cancel()">'+
	                      '<span></span>'+
	                   '</button>'
	
	    },
	
	    //bs3
	    'bs3': {
	      formTpl:     '<form class="form-inline editable-wrap" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls form-group" ng-class="{\'has-error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error help-block" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="editable-buttons"></span>',
	      submitTpl:   '<button type="submit" class="btn btn-primary"><span></span></button>',
	      cancelTpl:   '<button type="button" class="btn btn-default" ng-click="$form.$cancel()">'+
	                     '<span></span>'+
	                   '</button>',
	
	      //bs3 specific prop to change buttons class: btn-sm, btn-lg
	      buttonsClass: '',
	      //bs3 specific prop to change standard inputs class: input-sm, input-lg
	      inputClass: '',
	      postrender: function() {
	        //apply `form-control` class to std inputs
	        switch(this.directiveName) {
	          case 'editableText':
	          case 'editableSelect':
	          case 'editableTextarea':
	          case 'editableEmail':
	          case 'editableTel':
	          case 'editableNumber':
	          case 'editableUrl':
	          case 'editableSearch':
	          case 'editableDate':
	          case 'editableDatetime':
	          case 'editableBsdate':
	          case 'editableTime':
	          case 'editableMonth':
	          case 'editableWeek':
	          case 'editablePassword':
	          case 'editableDatetimeLocal':
	            this.inputEl.addClass('form-control');
	            if(this.theme.inputClass) {
	              // don`t apply `input-sm` and `input-lg` to select multiple
	              // should be fixed in bs itself!
	              if(this.inputEl.attr('multiple') &&
	                (this.theme.inputClass === 'input-sm' || this.theme.inputClass === 'input-lg')) {
	                  break;
	              }
	              this.inputEl.addClass(this.theme.inputClass);
	            }
	          break;
	          case 'editableCheckbox':
	              this.editorEl.addClass('checkbox');
	        }
	
	        //apply buttonsClass (bs3 specific!)
	        if(this.buttonsEl && this.theme.buttonsClass) {
	          this.buttonsEl.find('button').addClass(this.theme.buttonsClass);
	        }
	      }
	    },
	    
	    //semantic-ui
	    'semantic': {
	      formTpl:     '<form class="editable-wrap ui form" ng-class="{\'error\': $error}" role="form"></form>',
	      noformTpl:   '<span class="editable-wrap"></span>',
	      controlsTpl: '<div class="editable-controls ui fluid input" ng-class="{\'error\': $error}"></div>',
	      inputTpl:    '',
	      errorTpl:    '<div class="editable-error ui error message" data-ng-if="$error" data-ng-bind="$error"></div>',
	      buttonsTpl:  '<span class="mini ui buttons"></span>',
	      submitTpl:   '<button type="submit" class="ui primary button"><i class="ui check icon"></i></button>',
	      cancelTpl:   '<button type="button" class="ui button" ng-click="$form.$cancel()">'+
	                      '<i class="ui cancel icon"></i>'+
	                   '</button>'
	    }
	  };
	
	  return themes;
	});


/***/ }),
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1432);
	module.exports = __webpack_require__(1434);

/***/ }),
/* 1432 */
1199,
/* 1433 */,
/* 1434 */
/***/ (function(module, exports) {

	(function () {
	    angular
	        .module('template/treeGrid/treeGrid.html', [])
	        .run([
	            '$templateCache',
	            function ($templateCache) {
	                $templateCache.put('template/treeGrid/treeGrid.html',
	                    "<div class=\"table-responsive\">\n" +
	                    " <table class=\"table tree-grid\">\n" +
	                    "   <thead>\n" +
	                    "     <tr>\n" +
	                    "       <th><a ng-if=\"expandingProperty.sortable\" ng-click=\"sortBy(expandingProperty)\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}}</a><span ng-if=\"!expandingProperty.sortable\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}}</span><i ng-if=\"expandingProperty.sorted\" class=\"{{expandingProperty.sortingIcon}} pull-right\"></i></th>\n" +
	                    "       <th ng-repeat=\"col in colDefinitions\"><a ng-if=\"col.sortable\" ng-click=\"sortBy(col)\">{{col.displayName || col.field}}</a><span ng-if=\"!col.sortable\">{{col.displayName || col.field}}</span><i ng-if=\"col.sorted\" class=\"{{col.sortingIcon}} pull-right\"></i></th>\n" +
	                    "     </tr>\n" +
	                    "   </thead>\n" +
	                    "   <tbody>\n" +
	                    "     <tr ng-repeat=\"row in tree_rows | searchFor:$parent.filterString:expandingProperty:colDefinitions track by row.branch.uid\"\n" +
	                    "       ng-class=\"'level-' + {{ row.level }} + (row.branch.selected ? ' active':'')\" class=\"tree-grid-row\">\n" +
	                    "       <td><a ng-click=\"user_clicks_branch(row.branch)\"><i ng-class=\"row.tree_icon\"\n" +
	                    "              ng-click=\"row.branch.expanded = !row.branch.expanded\"\n" +
	                    "              class=\"indented tree-icon\"></i></a><span ng-if=\"expandingProperty.cellTemplate\" class=\"indented tree-label\" " +
	                    "              ng-click=\"on_user_click(row.branch)\" compile=\"expandingProperty.cellTemplate\"></span>" +
	                    "              <span  ng-if=\"!expandingProperty.cellTemplate\" class=\"indented tree-label\" ng-click=\"on_user_click(row.branch)\">\n" +
	                    "             {{row.branch[expandingProperty.field] || row.branch[expandingProperty]}}</span>\n" +
	                    "       </td>\n" +
	                    "       <td ng-repeat=\"col in colDefinitions\">\n" +
	                    "         <div ng-if=\"col.cellTemplate\" compile=\"col.cellTemplate\" cell-template-scope=\"col.cellTemplateScope\"></div>\n" +
	                    "         <div ng-if=\"!col.cellTemplate\">{{row.branch[col.field]}}</div>\n" +
	                    "       </td>\n" +
	                    "     </tr>\n" +
	                    "   </tbody>\n" +
	                    " </table>\n" +
	                    "</div>\n" +
	                    "");
	            }]);
	
	    angular
	        .module('treeGrid', [
	            'template/treeGrid/treeGrid.html'
	        ])
	
	        .directive('compile', [
	            '$compile',
	            function ($compile) {
	                return {
	                    restrict: 'A',
	                    link: function (scope, element, attrs) {
	                        scope.cellTemplateScope = scope.$eval(attrs.cellTemplateScope);
	
	                        // Watch for changes to expression.
	                        scope.$watch(attrs.compile, function (new_val) {
	                            /*
	                             * Compile creates a linking function
	                             * that can be used with any scope.
	                             */
	                            var link = $compile(new_val);
	
	                            /*
	                             * Executing the linking function
	                             * creates a new element.
	                             */
	                            var new_elem = link(scope);
	
	                            // Which we can then append to our DOM element.
	                            element.append(new_elem);
	                        });
	                    }
	                };
	            }])
	
	        .directive('treeGrid', [
	            '$timeout',
	            'treegridTemplate',
	            function ($timeout,
	                      treegridTemplate) {
	
	                return {
	                    restrict: 'E',
	                    templateUrl: function (tElement, tAttrs) {
	                        return tAttrs.templateUrl || treegridTemplate.getPath();
	                    },
	                    replace: true,
	                    scope: {
	                        treeData: '=',
	                        colDefs: '=',
	                        expandOn: '=',
	                        onSelect: '&',
	                        onClick: '&',
	                        initialSelection: '@',
	                        treeControl: '=',
	                        expandTo: '='
	                    },
	                    link: function (scope, element, attrs) {
	                        var error, expandingProperty, expand_all_parents, expand_level, for_all_ancestors, for_each_branch, get_parent, n, on_treeData_change, select_branch, selected_branch, tree;
	
	                        error = function (s) {
	                            console.log('ERROR:' + s);
	                            debugger;
	                            return void 0;
	                        };
	
	                        attrs.iconExpand = attrs.iconExpand ? attrs.iconExpand : 'icon-plus  glyphicon glyphicon-plus  fa fa-plus';
	                        attrs.iconCollapse = attrs.iconCollapse ? attrs.iconCollapse : 'icon-minus glyphicon glyphicon-minus fa fa-minus';
	                        attrs.iconLeaf = attrs.iconLeaf ? attrs.iconLeaf : 'icon-file  glyphicon glyphicon-file  fa fa-file';
	                        attrs.sortedAsc = attrs.sortedAsc ? attrs.sortedAsc : 'icon-file  glyphicon glyphicon-chevron-up  fa angle-up';
	                        attrs.sortedDesc = attrs.sortedDesc ? attrs.sortedDesc : 'icon-file  glyphicon glyphicon-chevron-down  fa angle-down';
	                        attrs.expandLevel = attrs.expandLevel ? attrs.expandLevel : '0';
	                        expand_level = parseInt(attrs.expandLevel, 10);
	
	                        if (!scope.treeData) {
	                            alert('No data was defined for the tree, please define treeData!');
	                            return;
	                        }
	
	                        var getExpandingProperty = function getExpandingProperty() {
	                            if (attrs.expandOn) {
	                                expandingProperty = scope.expandOn;
	                                scope.expandingProperty = scope.expandOn;
	                            } else {
	                                if (scope.treeData.length) {
	                                    var _firstRow = scope.treeData[0],
	                                        _keys = Object.keys(_firstRow);
	                                    for (var i = 0, len = _keys.length; i < len; i++) {
	                                        if (typeof (_firstRow[_keys[i]]) === 'string') {
	                                            expandingProperty = _keys[i];
	                                            break;
	                                        }
	                                    }
	                                    if (!expandingProperty) expandingProperty = _keys[0];
	                                    scope.expandingProperty = expandingProperty;
	                                }
	                            }
	                        };
	
	                        getExpandingProperty();
	
	                        if (!attrs.colDefs) {
	                            if (scope.treeData.length) {
	                                var _col_defs = [],
	                                    _firstRow = scope.treeData[0],
	                                    _unwantedColumn = ['children', 'level', 'expanded', 'icons', expandingProperty];
	                                for (var idx in _firstRow) {
	                                    if (_unwantedColumn.indexOf(idx) === -1) {
	                                        _col_defs.push({
	                                            field: idx
	                                        });
	                                    }
	                                }
	                                scope.colDefinitions = _col_defs;
	                            }
	                        } else {
	                            scope.colDefinitions = scope.colDefs;
	                        }
	
	                        for_each_branch = function (f) {
	                            var do_f, root_branch, _i, _len, _ref, _results;
	                            do_f = function (branch, level) {
	                                var child, _i, _len, _ref, _results;
	                                f(branch, level);
	                                if (branch.children != null) {
	                                    _ref = branch.children;
	                                    _results = [];
	                                    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                                        child = _ref[_i];
	                                        _results.push(do_f(child, level + 1));
	                                    }
	                                    return _results;
	                                }
	                            };
	                            _ref = scope.treeData;
	                            _results = [];
	                            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                                root_branch = _ref[_i];
	                                _results.push(do_f(root_branch, 1));
	                            }
	                            return _results;
	                        };
	                        selected_branch = null;
	                        select_branch = function (branch) {
	                            if (!branch) {
	                                if (selected_branch != null) {
	                                    selected_branch.selected = false;
	                                }
	                                selected_branch = null;
	                                return;
	                            }
	                            if (branch !== selected_branch) {
	                                if (selected_branch != null) {
	                                    selected_branch.selected = false;
	                                }
	                                branch.selected = true;
	                                selected_branch = branch;
	                                expand_all_parents(branch);
	                                if (branch.onSelect != null) {
	                                    return $timeout(function () {
	                                        return branch.onSelect(branch);
	                                    });
	                                } else {
	                                    if (scope.onSelect != null) {
	                                        return $timeout(function () {
	                                            return scope.onSelect({
	                                                branch: branch
	                                            });
	                                        });
	                                    }
	                                }
	                            }
	                        };
	                        scope.on_user_click = function (branch) {
	                            if (scope.onClick) {
	                                scope.onClick({
	                                    branch: branch
	                                });
	                            }
	                        };
	                        scope.user_clicks_branch = function (branch) {
	                            if (branch !== selected_branch) {
	                                return select_branch(branch);
	                            }
	                        };
	
	                        /* sorting methods */
	                        scope.sortBy = function (col) {
	                            if (col.sortDirection === "asc") {
	                                sort_recursive(scope.treeData, col, true);
	                                col.sortDirection = "desc";
	                                col.sortingIcon = attrs.sortedDesc;
	                            } else {
	                                sort_recursive(scope.treeData, col, false);
	                                col.sortDirection = "asc";
	                                col.sortingIcon = attrs.sortedAsc;
	                            }
	                            col.sorted = true;
	                            resetSorting(col);
	                        };
	
	                        var sort_recursive = function (elements, col, descending) {
	                            elements.sort(sort_by(col, descending));
	                            for (var i = 0; i < elements.length; i++) {
	                                sort_recursive(elements[i].children, col, descending);
	                            }
	                        };
	
	                        var sort_by = function (col, descending) {
	
	                            var direction = !descending ? 1 : -1;
	
	                            if (col.sortingType === "custom" && typeof col.sortingFunc === "function") {
	                                return function (a, b) {
	                                    return col.sortingFunc(a, b) * direction;
	                                };
	                            }
	
	                            var key = function (x) {
	                                return (x[col.field] === null ? "" : x[col.field].toLowerCase());
	                            };
	
	                            switch (col.sortingType) {
	                                case "number":
	                                    key = function (x) {
	                                        return parseFloat(x[col.field]);
	                                    };
	                                    break;
	                                case "date":
	                                    key = function (x) {
	                                        return new Date(x[col.field]);
	                                    };
	                                    break;
	                            }
	
	                            return function (a, b) {
	                                return a = key(a), b = key(b), direction * ((a > b) - (b > a));
	                            };
	                        }
	
	                        var resetSorting = function (sortedCol) {
	                            var arraySize = scope.colDefinitions.length;
	                            for (var i = 0; i < arraySize; i++) {
	                                var col = scope.colDefinitions[i];
	                                if (col.field != sortedCol.field) {
	                                    col.sorted = false;
	                                    col.sortDirection = "none";
	                                }
	                            }
	                        }
	
	                        /* end of sorting methods */
	
	                        get_parent = function (child) {
	                            var parent;
	                            parent = void 0;
	                            if (child.parent_uid) {
	                                for_each_branch(function (b) {
	                                    if (b.uid === child.parent_uid) {
	                                        return parent = b;
	                                    }
	                                });
	                            }
	                            return parent;
	                        };
	                        for_all_ancestors = function (child, fn) {
	                            var parent;
	                            parent = get_parent(child);
	                            if (parent != null) {
	                                fn(parent);
	                                return for_all_ancestors(parent, fn);
	                            }
	                        };
	                        expand_all_parents = function (child) {
	                            return for_all_ancestors(child, function (b) {
	                                return b.expanded = true;
	                            });
	                        };
	
	                        scope.tree_rows = [];
	
	                        on_treeData_change = function () {
	                            getExpandingProperty();
	
	                            var add_branch_to_list, root_branch, _i, _len, _ref, _results;
	                            for_each_branch(function (b, level) {
	                                if (!b.uid) {
	                                    return b.uid = "" + Math.random();
	                                }
	                            });
	                            for_each_branch(function (b) {
	                                var child, _i, _len, _ref, _results;
	                                if (angular.isArray(b.children)) {
	                                    _ref = b.children;
	                                    _results = [];
	                                    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                                        child = _ref[_i];
	                                        _results.push(child.parent_uid = b.uid);
	                                    }
	                                    return _results;
	                                }
	                            });
	                            scope.tree_rows = [];
	                            for_each_branch(function (branch) {
	                                var child, f;
	                                if (branch.children) {
	                                    if (branch.children.length > 0) {
	                                        f = function (e) {
	                                            if (typeof e === 'string') {
	                                                return {
	                                                    label: e,
	                                                    children: []
	                                                };
	                                            } else {
	                                                return e;
	                                            }
	                                        };
	                                        return branch.children = (function () {
	                                            var _i, _len, _ref, _results;
	                                            _ref = branch.children;
	                                            _results = [];
	                                            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                                                child = _ref[_i];
	                                                _results.push(f(child));
	                                            }
	                                            return _results;
	                                        })();
	                                    }
	                                } else {
	                                    return branch.children = [];
	                                }
	                            });
	                            add_branch_to_list = function (level, branch, visible) {
	                                var child, child_visible, tree_icon, _i, _len, _ref, _results;
	                                if (branch.expanded == null) {
	                                    branch.expanded = false;
	                                }
	                                if (!branch.children || branch.children.length === 0) {
	                                    tree_icon = branch.icons && branch.icons.iconLeaf || attrs.iconLeaf;
	                                } else {
	                                    if (branch.expanded) {
	                                        tree_icon = branch.icons && branch.icons.iconCollapse || attrs.iconCollapse;
	                                    } else {
	                                        tree_icon = branch.icons && branch.icons.iconExpand || attrs.iconExpand;
	                                    }
	                                }
	                                branch.level = level;
	                                scope.tree_rows.push({
	                                    level: level,
	                                    branch: branch,
	                                    label: branch[expandingProperty],
	                                    tree_icon: tree_icon,
	                                    visible: visible
	                                });
	                                if (branch.children != null) {
	                                    _ref = branch.children;
	                                    _results = [];
	                                    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                                        child = _ref[_i];
	                                        child_visible = visible && (branch.expanded || branch.level < expand_level);
	                                        _results.push(add_branch_to_list(level + 1, child, child_visible));
	                                    }
	                                    return _results;
	                                }
	                            };
	                            _ref = scope.treeData;
	                            _results = [];
	                            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	                                root_branch = _ref[_i];
	                                _results.push(add_branch_to_list(1, root_branch, true));
	                            }
	                            return _results;
	                        };
	
	                        scope.$watch('treeData', on_treeData_change, true);
	
	                        on_expandTo_change = function () {
	                            if (angular.isDefined((scope.expandTo))) {
	                                for_each_branch(function (b) {
	                                    b.expanded = false;
	                                    if (b[expandingProperty.field] === scope.expandTo || b[expandingProperty] === scope.expandTo) {
	                                        return $timeout(function () {
	                                            return select_branch(b);
	                                        });
	                                    }
	                                });
	                            }
	                        };
	
	                        scope.$watch('expandTo', on_expandTo_change, true);
	
	                        if (attrs.initialSelection != null) {
	                            for_each_branch(function (b) {
	                                if (b.label === attrs.initialSelection) {
	                                    return $timeout(function () {
	                                        return select_branch(b);
	                                    });
	                                }
	                            });
	                        }
	                        n = scope.treeData.length;
	                        for_each_branch(function (b, level) {
	                            b.level = level;
	                            return b.expanded = b.level < expand_level;
	                        });
	                        if (scope.treeControl != null) {
	                            if (angular.isObject(scope.treeControl)) {
	                                tree = scope.treeControl;
	                                tree.expand_all = function () {
	                                    return for_each_branch(function (b, level) {
	                                        return b.expanded = true;
	                                    });
	                                };
	                                tree.collapse_all = function () {
	                                    return for_each_branch(function (b, level) {
	                                        return b.expanded = false;
	                                    });
	                                };
	                                tree.get_first_branch = function () {
	                                    n = scope.treeData.length;
	                                    if (n > 0) {
	                                        return scope.treeData[0];
	                                    }
	                                };
	                                tree.select_first_branch = function () {
	                                    var b;
	                                    b = tree.get_first_branch();
	                                    return tree.select_branch(b);
	                                };
	                                tree.get_selected_branch = function () {
	                                    return selected_branch;
	                                };
	                                tree.get_parent_branch = function (b) {
	                                    return get_parent(b);
	                                };
	                                tree.select_branch = function (b) {
	                                    select_branch(b);
	                                    return b;
	                                };
	                                tree.get_children = function (b) {
	                                    return b.children;
	                                };
	                                tree.select_parent_branch = function (b) {
	                                    var p;
	                                    if (b == null) {
	                                        b = tree.get_selected_branch();
	                                    }
	                                    if (b != null) {
	                                        p = tree.get_parent_branch(b);
	                                        if (p != null) {
	                                            tree.select_branch(p);
	                                            return p;
	                                        }
	                                    }
	                                };
	                                tree.add_branch = function (parent, new_branch) {
	                                    if (parent != null) {
	                                        parent.children.push(new_branch);
	                                        parent.expanded = true;
	                                    } else {
	                                        scope.treeData.push(new_branch);
	                                    }
	                                    return new_branch;
	                                };
	                                tree.add_root_branch = function (new_branch) {
	                                    tree.add_branch(null, new_branch);
	                                    return new_branch;
	                                };
	                                tree.expand_branch = function (b) {
	                                    if (b == null) {
	                                        b = tree.get_selected_branch();
	                                    }
	                                    if (b != null) {
	                                        b.expanded = true;
	                                        return b;
	                                    }
	                                };
	                                tree.collapse_branch = function (b) {
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        b.expanded = false;
	                                        return b;
	                                    }
	                                };
	                                tree.get_siblings = function (b) {
	                                    var p, siblings;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        p = tree.get_parent_branch(b);
	                                        if (p) {
	                                            siblings = p.children;
	                                        } else {
	                                            siblings = scope.treeData;
	                                        }
	                                        return siblings;
	                                    }
	                                };
	                                tree.get_next_sibling = function (b) {
	                                    var i, siblings;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        siblings = tree.get_siblings(b);
	                                        n = siblings.length;
	                                        i = siblings.indexOf(b);
	                                        if (i < n) {
	                                            return siblings[i + 1];
	                                        }
	                                    }
	                                };
	                                tree.get_prev_sibling = function (b) {
	                                    var i, siblings;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    siblings = tree.get_siblings(b);
	                                    n = siblings.length;
	                                    i = siblings.indexOf(b);
	                                    if (i > 0) {
	                                        return siblings[i - 1];
	                                    }
	                                };
	                                tree.select_next_sibling = function (b) {
	                                    var next;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        next = tree.get_next_sibling(b);
	                                        if (next != null) {
	                                            return tree.select_branch(next);
	                                        }
	                                    }
	                                };
	                                tree.select_prev_sibling = function (b) {
	                                    var prev;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        prev = tree.get_prev_sibling(b);
	                                        if (prev != null) {
	                                            return tree.select_branch(prev);
	                                        }
	                                    }
	                                };
	                                tree.get_first_child = function (b) {
	                                    var _ref;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        if (((_ref = b.children) != null ? _ref.length : void 0) > 0) {
	                                            return b.children[0];
	                                        }
	                                    }
	                                };
	                                tree.get_closest_ancestor_next_sibling = function (b) {
	                                    var next, parent;
	                                    next = tree.get_next_sibling(b);
	                                    if (next != null) {
	                                        return next;
	                                    } else {
	                                        parent = tree.get_parent_branch(b);
	                                        return tree.get_closest_ancestor_next_sibling(parent);
	                                    }
	                                };
	                                tree.get_next_branch = function (b) {
	                                    var next;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        next = tree.get_first_child(b);
	                                        if (next != null) {
	                                            return next;
	                                        } else {
	                                            next = tree.get_closest_ancestor_next_sibling(b);
	                                            return next;
	                                        }
	                                    }
	                                };
	                                tree.select_next_branch = function (b) {
	                                    var next;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        next = tree.get_next_branch(b);
	                                        if (next != null) {
	                                            tree.select_branch(next);
	                                            return next;
	                                        }
	                                    }
	                                };
	                                tree.last_descendant = function (b) {
	                                    var last_child;
	                                    if (b == null) {
	                                        debugger;
	                                    }
	                                    n = b.children.length;
	                                    if (n === 0) {
	                                        return b;
	                                    } else {
	                                        last_child = b.children[n - 1];
	                                        return tree.last_descendant(last_child);
	                                    }
	                                };
	                                tree.get_prev_branch = function (b) {
	                                    var parent, prev_sibling;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        prev_sibling = tree.get_prev_sibling(b);
	                                        if (prev_sibling != null) {
	                                            return tree.last_descendant(prev_sibling);
	                                        } else {
	                                            parent = tree.get_parent_branch(b);
	                                            return parent;
	                                        }
	                                    }
	                                };
	                                return tree.select_prev_branch = function (b) {
	                                    var prev;
	                                    if (b == null) {
	                                        b = selected_branch;
	                                    }
	                                    if (b != null) {
	                                        prev = tree.get_prev_branch(b);
	                                        if (prev != null) {
	                                            tree.select_branch(prev);
	                                            return prev;
	                                        }
	                                    }
	                                };
	                            }
	                        }
	                    }
	                };
	            }
	        ])
	
	        .provider('treegridTemplate', function () {
	            var templatePath = 'template/treeGrid/treeGrid.html';
	
	            this.setPath = function (path) {
	                templatePath = path;
	            };
	
	            this.$get = function () {
	                return {
	                    getPath: function () {
	                        return templatePath;
	                    }
	                };
	            };
	        })
	
	        .filter('searchFor', function () {
	            return function (arr, filterString, expandingProperty, colDefinitions, expand) {
	                var filtered = [];
	                //only apply filter for strings 3 characters long or more
	                if (!filterString || filterString.length < 3) {
	                    for (var i = 0; i < arr.length; i++) {
	                        var item = arr[i];
	                        if (item.visible) {
	                            filtered.push(item);
	                        }
	                    }
	                } else {
	                    var ancestorStack = [];
	                    var currentLevel = 0;
	                    for (var i = 0; i < arr.length; i++) {
	                        var item = arr[i];
	                        while (currentLevel >= item.level) {
	                            throwAway = ancestorStack.pop();
	                            currentLevel--;
	                        }
	                        ancestorStack.push(item);
	                        currentLevel = item.level;
	                        if (include(item, filterString, expandingProperty, colDefinitions)) {
	                            for (var ancestorIndex = 0; ancestorIndex < ancestorStack.length; ancestorIndex++) {
	                                ancestor = ancestorStack[ancestorIndex];
	                                if (ancestor.visible) {
	                                    if (expand)
	                                        ancestor.branch.expanded = true;
	                                    filtered.push(ancestor);
	                                }
	                            }
	                            ancestorStack = [];
	                        }
	                    }
	                }
	                return filtered;
	            };
	
	            function include(item, filterString, expandingProperty, colDefinitions) {
	                var includeItem = false;
	                var filterApplied = false;
	                //first check the expandingProperty
	                if (expandingProperty.filterable) {
	                    filterApplied = true;
	                    if (checkItem(item, filterString, expandingProperty)) {
	                        includeItem = true;
	                    }
	                }
	                //then check each of the other columns
	                var arraySize = colDefinitions.length;
	                for (var i = 0; i < arraySize; i++) {
	                    var col = colDefinitions[i];
	                    if (col.filterable) {
	                        filterApplied = true;
	                        if (checkItem(item, filterString, col)) {
	                            includeItem = true;
	                        }
	                    }
	                }
	                if (filterApplied) {
	                    return includeItem;
	                } else {
	                    return true;
	                }
	            }
	
	            function checkItem(item, filterString, col) {
	                if (col.sortingType === "number") {
	                    if (item.branch[col.field] != null
	                        && parseFloat(item.branch[col.field]) === parseFloat(filterString)) {
	                        return true;
	                    }
	                } else {
	                    if (item.branch[col.field] != null
	                        && item.branch[col.field].toLowerCase().indexOf(filterString.toLowerCase()) !== -1) {
	                        return true;
	                    }
	                }
	            }
	        });
	}).call(window);


/***/ }),
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1442);

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	/*!
	 * angular-translate - v2.5.2 - 2014-12-10
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2014 ; Licensed MIT
	 */
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateLocalStorage
	 * @requires $window
	 *
	 * @description
	 * Abstraction layer for localStorage. This service is used when telling angular-translate
	 * to use localStorage as storage.
	 *
	 */
	.factory('$translateLocalStorage', ['$window', '$translateCookieStorage', function ($window, $translateCookieStorage) {
	
	  // Setup adapter
	  var localStorageAdapter = (function(){
	    var langKey;
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#get
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Returns an item from localStorage by given name.
	       *
	       * @param {string} name Item name
	       * @return {string} Value of item name
	       */
	      get: function (name) {
	        if(!langKey) {
	          langKey = $window.localStorage.getItem(name);
	        }
	
	        return langKey;
	      },
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#set
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Sets an item in localStorage by given name.
	       *
	       * @deprecated use #put
	       *
	       * @param {string} name Item name
	       * @param {string} value Item value
	       */
	      set: function (name, value) {
	        langKey=value;
	        $window.localStorage.setItem(name, value);
	      },
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#put
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Sets an item in localStorage by given name.
	       *
	       * @param {string} name Item name
	       * @param {string} value Item value
	       */
	      put: function (name, value) {
	        langKey=value;
	        $window.localStorage.setItem(name, value);
	      }
	    };
	  }());
	
	  var hasLocalStorageSupport = 'localStorage' in $window;
	  if (hasLocalStorageSupport) {
	    var testKey = 'pascalprecht.translate.storageTest';
	    try {
	      // this check have to be wrapped within a try/catch because on
	      // a SecurityError: Dom Exception 18 on iOS
	      if ($window.localStorage !== null) {
	        $window.localStorage.setItem(testKey, 'foo');
	        $window.localStorage.removeItem(testKey);
	        hasLocalStorageSupport = true;
	      } else {
	        hasLocalStorageSupport = false;
	      }
	    } catch (e){
	      hasLocalStorageSupport = false;
	    }
	  }
	  var $translateLocalStorage = hasLocalStorageSupport ? localStorageAdapter : $translateCookieStorage;
	  return $translateLocalStorage;
	}]);


/***/ }),
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1450);

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {angular.module('ui.bootstrap.contextMenu', [])
	
	.service('CustomService', function () {
	    "use strict";
	
	    return {
	        initialize: function (item) {
	            console.log("got here", item);
	        }
	    }
	
	})
	.directive('contextMenu', ["$parse", "$q", "CustomService", "$sce", function ($parse, $q, custom, $sce) {
	
	    var contextMenus = [];
	    var $currentContextMenu = null;
	    var defaultItemText = "New Item";
	
	    var removeContextMenus = function (level) {
	        /// <summary>Remove context menu.</summary>
	        while (contextMenus.length && (!level || contextMenus.length > level)) {
	            contextMenus.pop().remove();
	        }
	        if (contextMenus.length == 0 && $currentContextMenu) {
	            $currentContextMenu.remove();
	        }
	    };
	
	
	    var processTextItem = function ($scope, item, text, event, modelValue, $promises, nestedMenu, $) {
	        "use strict";
	
	        var $a = $('<a>');
	        $a.css("padding-right", "8px");
	        $a.attr({ tabindex: '-1', href: '#' });
	
	        if (typeof item[0] === 'string') {
	            text = item[0];
	        }
	        else if (typeof item[0] === "function") {
	            text = item[0].call($scope, $scope, event, modelValue);
	        } else if (typeof item.text !== "undefined") {
	            text = item.text;
	        }
	
	        var $promise = $q.when(text);
	        $promises.push($promise);
	        $promise.then(function (text) {
	            if (nestedMenu) {
	                $a.css("cursor", "default");
	                $a.append($('<strong style="font-family:monospace;font-weight:bold;float:right;">&gt;</strong>'));
	            }
	            $a.append(text);
	        });
	
	        return $a;
	
	    };
	
	    var processItem = function ($scope, event, modelValue, item, $ul, $li, $promises, $q, $, level) {
	        /// <summary>Process individual item</summary>
	        "use strict";
	        // nestedMenu is either an Array or a Promise that will return that array.
	        var nestedMenu = angular.isArray(item[1]) || (item[1] && angular.isFunction(item[1].then))
	          ? item[1] : angular.isArray(item[2]) || (item[2] && angular.isFunction(item[2].then))
	          ? item[2] : angular.isArray(item[3]) || (item[3] && angular.isFunction(item[3].then))
	          ? item[3] : null;
	
	        // if html property is not defined, fallback to text, otherwise use default text
	        // if first item in the item array is a function then invoke .call()
	        // if first item is a string, then text should be the string.
	
	        var text = defaultItemText;
	        if (typeof item[0] === 'function' || typeof item[0] === 'string' || typeof item.text !== "undefined") {
	            text = processTextItem($scope, item, text, event, modelValue, $promises, nestedMenu, $);
	        }
	        else if (typeof item.html === 'function') {
	            // leave styling open to dev
	            text = item.html($scope);
	        }
	        else if (typeof item.html !== "undefined") {
	            // leave styling open to dev
	            text = item.html;
	        }
	
	        $li.append(text);
	
	
	
	
	        // if item is object, and has enabled prop invoke the prop
	        // els if fallback to item[2]
	
	        var isEnabled = function () {
	            if (typeof item.enabled !== "undefined") {
	                return item.enabled.call($scope, $scope, event, modelValue, text);
	            } else if (typeof item[2] === "function") {
	                return item[2].call($scope, $scope, event, modelValue, text);
	            } else {
	                return true;
	            }
	        };
	
	        registerEnabledEvents($scope, isEnabled(), item, $ul, $li, nestedMenu, modelValue, text, event, $, level);
	    };
	
	    var handlePromises = function ($ul, level, event, $promises) {
	        /// <summary>
	        /// calculate if drop down menu would go out of screen at left or bottom
	        /// calculation need to be done after element has been added (and all texts are set; thus thepromises)
	        /// to the DOM the get the actual height
	        /// </summary>
	        "use strict";
	        $q.all($promises).then(function () {
	            var topCoordinate = event.pageY;
	            var menuHeight = angular.element($ul[0]).prop('offsetHeight');
	            var winHeight = event.view.innerHeight;
	            if (topCoordinate > menuHeight && winHeight - topCoordinate < menuHeight) {
	                topCoordinate = event.pageY - menuHeight;
	            } else if(winHeight <= menuHeight) {
	                // If it really can't fit, reset the height of the menu to one that will fit
	                angular.element($ul[0]).css({"height": winHeight - 5, "overflow-y": "scroll"});
	                // ...then set the topCoordinate height to 0 so the menu starts from the top
	                topCoordinate = 0;
	            } else if(winHeight - topCoordinate < menuHeight) {
	                var reduceThreshold = 5;
	                if(topCoordinate < reduceThreshold) {
	                    reduceThreshold = topCoordinate;
	                }
	                topCoordinate = winHeight - menuHeight - reduceThreshold;
	            }
	
	            var leftCoordinate = event.pageX;
	            var menuWidth = angular.element($ul[0]).prop('offsetWidth');
	            var winWidth = event.view.innerWidth;
	            var rightPadding = 5;
	            if (leftCoordinate > menuWidth && winWidth - leftCoordinate - rightPadding < menuWidth) {
	                leftCoordinate = winWidth - menuWidth - rightPadding;
	            } else if(winWidth - leftCoordinate < menuWidth) {
	                var reduceThreshold = 5;
	                if(leftCoordinate < reduceThreshold + rightPadding) {
	                    reduceThreshold = leftCoordinate + rightPadding;
	                }
	                leftCoordinate = winWidth - menuWidth - reduceThreshold - rightPadding;
	            }
	
	            $ul.css({
	                display: 'block',
	                position: 'absolute',
	                left: leftCoordinate + 'px',
	                top: topCoordinate + 'px'
	            });
	        });
	
	    };
	
	    var registerEnabledEvents = function ($scope, enabled, item, $ul, $li, nestedMenu, modelValue, text, event, $, level) {
	        /// <summary>If item is enabled, register various mouse events.</summary>
	        if (enabled) {
	            var openNestedMenu = function ($event) {
	                removeContextMenus(level + 1);
	                /*
	                 * The object here needs to be constructed and filled with data
	                 * on an "as needed" basis. Copying the data from event directly
	                 * or cloning the event results in unpredictable behavior.
	                 */
	                var ev = {
	                    pageX: event.pageX + $ul[0].offsetWidth - 1,
	                    pageY: $ul[0].offsetTop + $li[0].offsetTop - 3,
	                    view: event.view || window
	                };
	
	                /*
	                 * At this point, nestedMenu can only either be an Array or a promise.
	                 * Regardless, passing them to when makes the implementation singular.
	                 */
	                $q.when(nestedMenu).then(function(promisedNestedMenu) {
	                    renderContextMenu($scope, ev, promisedNestedMenu, modelValue, level + 1);
	                });
	            };
	
	            $li.on('click', function ($event) {
	                $event.preventDefault();
	                $scope.$apply(function () {
	                    if (nestedMenu) {
	                        openNestedMenu($event);
	                    } else {
	                        $(event.currentTarget).removeClass('context');
	                        removeContextMenus();
	
	                        if (angular.isFunction(item[1])) {
	                            item[1].call($scope, $scope, event, modelValue, text, $li)
	                        } else {
	                            item.click.call($scope, $scope, event, modelValue, text, $li);
	                        }
	                    }
	                });
	            });
	
	            $li.on('mouseover', function ($event) {
	                $scope.$apply(function () {
	                    if (nestedMenu) {
	                        openNestedMenu($event);
	                    }
	                });
	            });
	        } else {
	            $li.on('click', function ($event) {
	                $event.preventDefault();
	            });
	            $li.addClass('disabled');
	        }
	
	    };
	
	
	    var renderContextMenu = function ($scope, event, options, modelValue, level, customClass) {
	        /// <summary>Render context menu recursively.</summary>
	        if (!level) { level = 0; }
	        if (!$) { var $ = angular.element; }
	        $(event.currentTarget).addClass('context');
	        var $contextMenu = $('<div>');
	        if ($currentContextMenu) {
	            $contextMenu = $currentContextMenu;
	        } else {
	            $currentContextMenu = $contextMenu;
	            $contextMenu.addClass('angular-bootstrap-contextmenu dropdown clearfix');
	        }
	        if (customClass) {
	            $contextMenu.addClass(customClass);
	        }
	        var $ul = $('<ul>');
	        $ul.addClass('dropdown-menu');
	        $ul.attr({ 'role': 'menu' });
	        $ul.css({
	            display: 'block',
	            position: 'absolute',
	            left: event.pageX + 'px',
	            top: event.pageY + 'px',
	            "z-index": 10000
	        });
	
	        var $promises = [];
	
	        angular.forEach(options, function (item) {
	
	            var $li = $('<li>');
	            if (item === null) {
	                $li.addClass('divider');
	            } else if (typeof item[0] === "object") {
	                custom.initialize($li, item);
	            } else {
	                processItem($scope, event, modelValue, item, $ul, $li, $promises, $q, $, level);
	            }
	            $ul.append($li);
	        });
	        $contextMenu.append($ul);
	        var height = Math.max(
	            document.body.scrollHeight, document.documentElement.scrollHeight,
	            document.body.offsetHeight, document.documentElement.offsetHeight,
	            document.body.clientHeight, document.documentElement.clientHeight
	        );
	        $contextMenu.css({
	            width: '100%',
	            height: height + 'px',
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            zIndex: 9999,
	            "max-height" : window.innerHeight - 3,
	        });
	        $(document).find('body').append($contextMenu);
	
	        handlePromises($ul, level, event, $promises);
	
	        function removeAllContextMenus(e) {
	            if ($(e.target).hasClass('angular-bootstrap-contextmenu')) {
	                $(event.currentTarget).removeClass('context');
	                removeContextMenus();
	            }
	        }
	
	        $(document.body).on('mousedown', removeAllContextMenus);
	
	        $contextMenu.on('contextmenu', function (event) {
	            $(event.currentTarget).removeClass('context');
	            event.preventDefault();
	            removeContextMenus(level);
	        });
	
	        $scope.$on("$destroy", function () {
	            removeContextMenus();
	            $(document.body).off('mousedown', removeAllContextMenus);
	        });
	
	        contextMenus.push($ul);
	    };
	
	    function isTouchDevice() {
	      return 'ontouchstart' in window        // works on most browsers
	          || navigator.maxTouchPoints;       // works on IE10/11 and Surface
	    };
	
	    return function ($scope, element, attrs) {
	        var openMenuEvent = "contextmenu";
	        if(attrs.contextMenuOn && typeof(attrs.contextMenuOn) === "string"){
	            openMenuEvent = attrs.contextMenuOn;
	        }
	        element.on(openMenuEvent, function (event) {
	            if(!attrs.allowEventPropagation) {
	              event.stopPropagation();
	              event.preventDefault();
	            }
	            
	            // Don't show context menu if on touch device and element is draggable
	            if(isTouchDevice() && element.attr('draggable') === 'true') {
	              return false;
	            }
	
	            $scope.$apply(function () {
	                var options = $scope.$eval(attrs.contextMenu);
	                var customClass = attrs.contextMenuClass;
	                var modelValue = $scope.$eval(attrs.model);
	                if (options instanceof Array) {
	                    if (options.length === 0) { return; }
	                    renderContextMenu($scope, event, options, modelValue, undefined, customClass);
	                } else {
	                    throw '"' + attrs.contextMenu + '" not an array';
	                }
	            });
	        });
	    };
	}]);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1452);

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	/**
	 * Bunch of useful filters for angularJS(with no external dependencies!)
	 * @version v0.5.17 - 2017-09-22 * @link https://github.com/a8m/angular-filter
	 * @author Ariel Mashraki <ariel@mashraki.co.il>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function ( window, angular, undefined ) {
	/*jshint globalstrict:true*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isUndefined = angular.isUndefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isNumber = angular.isNumber,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    equals = angular.equals;
	
	
	/**
	 * @description
	 * get an object and return array of values
	 * @param object
	 * @returns {Array}
	 */
	function toArray(object) {
	  return isArray(object) 
	    ? object 
	    : Object.keys(object).map(function(key) {
	      return object[key];
	    });
	}
	
	/**
	 * @param value
	 * @returns {boolean}
	 */
	function isNull(value) {
	    return value === null;
	}
	
	/**
	 * @description
	 * return if object contains partial object
	 * @param partial{object}
	 * @param object{object}
	 * @returns {boolean}
	 */
	function objectContains(partial, object) {
	  var keys = Object.keys(partial);
	
	  return keys.map(function(el) {
	    return (object[el] !== undefined) && (object[el] == partial[el]);
	  }).indexOf(false) == -1;
	
	}
	
	/**
	 * @description
	 * search for approximate pattern in string
	 * @param word
	 * @param pattern
	 * @returns {*}
	 */
	function hasApproxPattern(word, pattern) {
	  // cheaper version of indexOf; instead of creating each
	  // iteration new str.
	  function indexOf(word, p, c) {
	    var j = 0;
	    while ((p + j) <= word.length) {
	      if (word.charAt(p + j) == c) return j;
	      j++;
	    }
	    return -1;
	  }
	  var p = 0;
	  for (var i = 0; i <= pattern.length; i++) {
	    var index = indexOf(word, p, pattern.charAt(i));
	    if (index == -1) return false;
	    p += index + 1;
	  }
	  return true
	}
	
	/**
	 * @description
	 * return the first n element of an array,
	 * if expression provided, is returns as long the expression return truthy
	 * @param array
	 * @param n {number}
	 * @param expression {$parse}
	 * @return array or single object
	 */
	function getFirstMatches(array, n, expression) {
	  var count = 0;
	
	  return array.filter(function(elm) {
	    var rest = isDefined(expression) ? (count < n && expression(elm)) : count < n;
	    count = rest ? count+1 : count;
	
	    return rest;
	  });
	}
	/**
	 * Polyfill to ECMA6 String.prototype.contains
	 */
	if (!String.prototype.contains) {
	  String.prototype.contains = function() {
	    return String.prototype.indexOf.apply(this, arguments) !== -1;
	  };
	}
	
	/**
	 * @param num {Number}
	 * @param decimal {Number}
	 * @returns {Number}
	 */
	function convertToDecimal(num, decimal){
	  return Math.round(num * Math.pow(10,decimal)) / (Math.pow(10, decimal));
	}
	
	/**
	 * @description
	 * Get an object, and return an array composed of it's properties names(nested too).
	 * @param obj {Object}
	 * @param stack {Array}
	 * @param parent {String}
	 * @returns {Array}
	 * @example
	 * parseKeys({ a:1, b: { c:2, d: { e: 3 } } }) ==> ["a", "b.c", "b.d.e"]
	 */
	function deepKeys(obj, stack, parent) {
	  stack = stack || [];
	  var keys = Object.keys(obj);
	
	  keys.forEach(function(el) {
	    //if it's a nested object
	    if(isObject(obj[el]) && !isArray(obj[el])) {
	      //concatenate the new parent if exist
	      var p = parent ? parent + '.' + el : parent;
	      deepKeys(obj[el], stack, p || el);
	    } else {
	      //create and save the key
	      var key = parent ? parent + '.' + el : el;
	      stack.push(key)
	    }
	  });
	  return stack
	}
	
	/**
	 * @description
	 * Test if given object is a Scope instance
	 * @param obj
	 * @returns {Boolean}
	 */
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	/**
	 * @ngdoc filter
	 * @name a8m.angular
	 * @kind function
	 *
	 * @description
	 * reference to angular function
	 */
	
	angular.module('a8m.angular', [])
	
	    .filter('isUndefined', function () {
	      return function (input) {
	        return angular.isUndefined(input);
	      }
	    })
	    .filter('isDefined', function() {
	      return function (input) {
	        return angular.isDefined(input);
	      }
	    })
	    .filter('isFunction', function() {
	      return function (input) {
	        return angular.isFunction(input);
	      }
	    })
	    .filter('isString', function() {
	      return function (input) {
	        return angular.isString(input)
	      }
	    })
	    .filter('isNumber', function() {
	      return function (input) {
	        return angular.isNumber(input);
	      }
	    })
	    .filter('isArray', function() {
	      return function (input) {
	        return angular.isArray(input);
	      }
	    })
	    .filter('isObject', function() {
	      return function (input) {
	        return angular.isObject(input);
	      }
	    })
	    .filter('isEqual', function() {
	      return function (o1, o2) {
	        return angular.equals(o1, o2);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name a8m.conditions
	 * @kind function
	 *
	 * @description
	 * reference to math conditions
	 */
	 angular.module('a8m.conditions', [])
	
	  .filter({
	    isGreaterThan  : isGreaterThanFilter,
	    '>'            : isGreaterThanFilter,
	
	    isGreaterThanOrEqualTo  : isGreaterThanOrEqualToFilter,
	    '>='                    : isGreaterThanOrEqualToFilter,
	
	    isLessThan  : isLessThanFilter,
	    '<'         : isLessThanFilter,
	
	    isLessThanOrEqualTo  : isLessThanOrEqualToFilter,
	    '<='                 : isLessThanOrEqualToFilter,
	
	    isEqualTo  : isEqualToFilter,
	    '=='       : isEqualToFilter,
	
	    isNotEqualTo  : isNotEqualToFilter,
	    '!='          : isNotEqualToFilter,
	
	    isIdenticalTo  : isIdenticalToFilter,
	    '==='          : isIdenticalToFilter,
	
	    isNotIdenticalTo  : isNotIdenticalToFilter,
	    '!=='             : isNotIdenticalToFilter
	  });
	
	  function isGreaterThanFilter() {
	    return function (input, check) {
	      return input > check;
	    };
	  }
	
	  function isGreaterThanOrEqualToFilter() {
	    return function (input, check) {
	      return input >= check;
	    };
	  }
	
	  function isLessThanFilter() {
	    return function (input, check) {
	      return input < check;
	    };
	  }
	
	  function isLessThanOrEqualToFilter() {
	    return function (input, check) {
	      return input <= check;
	    };
	  }
	
	  function isEqualToFilter() {
	    return function (input, check) {
	      return input == check;
	    };
	  }
	
	  function isNotEqualToFilter() {
	    return function (input, check) {
	      return input != check;
	    };
	  }
	
	  function isIdenticalToFilter() {
	    return function (input, check) {
	      return input === check;
	    };
	  }
	
	  function isNotIdenticalToFilter() {
	    return function (input, check) {
	      return input !== check;
	    };
	  }
	/**
	 * @ngdoc filter
	 * @name isNull
	 * @kind function
	 *
	 * @description
	 * checks if value is null or not
	 * @return Boolean
	 */
	angular.module('a8m.is-null', [])
	    .filter('isNull', function () {
	      return function(input) {
	        return isNull(input);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name after-where
	 * @kind function
	 *
	 * @description
	 * get a collection and properties object, and returns all of the items
	 * in the collection after the first that found with the given properties.
	 *
	 */
	angular.module('a8m.after-where', [])
	    .filter('afterWhere', function() {
	      return function (collection, object) {
	
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        if(!isArray(collection) || isUndefined(object)) return collection;
	
	        var index = collection.map( function( elm ) {
	          return objectContains(object, elm);
	        }).indexOf( true );
	
	        return collection.slice((index === -1) ? 0 : index);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name after
	 * @kind function
	 *
	 * @description
	 * get a collection and specified count, and returns all of the items
	 * in the collection after the specified count.
	 *
	 */
	
	angular.module('a8m.after', [])
	    .filter('after', function() {
	      return function (collection, count) {
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        return (isArray(collection))
	          ? collection.slice(count)
	          : collection;
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name before-where
	 * @kind function
	 *
	 * @description
	 * get a collection and properties object, and returns all of the items
	 * in the collection before the first that found with the given properties.
	 */
	angular.module('a8m.before-where', [])
	  .filter('beforeWhere', function() {
	    return function (collection, object) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(object)) return collection;
	
	      var index = collection.map( function( elm ) {
	        return objectContains(object, elm);
	      }).indexOf( true );
	
	      return collection.slice(0, (index === -1) ? collection.length : ++index);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name before
	 * @kind function
	 *
	 * @description
	 * get a collection and specified count, and returns all of the items
	 * in the collection before the specified count.
	 */
	angular.module('a8m.before', [])
	    .filter('before', function() {
	      return function (collection, count) {
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        return (isArray(collection))
	          ? collection.slice(0, (!count) ? count : --count)
	          : collection;
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name chunkBy
	 * @kind function
	 *
	 * @description
	 * Collect data into fixed-length chunks or blocks
	 */
	
	angular.module('a8m.chunk-by', ['a8m.filter-watcher'])
	    .filter('chunkBy', ['filterWatcher', function (filterWatcher) {
	      return function (array, n, fillVal) {
	
	        return filterWatcher.isMemoized('chunkBy', arguments) ||
	            filterWatcher.memoize('chunkBy', arguments, this,
	                _chunkBy(array, n, fillVal));
	        /**
	         * @description
	         * Get array with size `n` in `val` inside it.
	         * @param n
	         * @param val
	         * @returns {Array}
	         */
	        function fill(n, val) {
	          var ret = [];
	          while (n--) ret[n] = val;
	          return ret;
	        }
	
	        function _chunkBy(array, n, fillVal) {
	          if (!isArray(array)) return array;
	          return array.map(function (el, i, self) {
	            i = i * n;
	            el = self.slice(i, i + n);
	            return !isUndefined(fillVal) && el.length < n
	                ? el.concat(fill(n - el.length, fillVal))
	                : el;
	          }).slice(0, Math.ceil(array.length / n));
	        }
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name concat
	 * @kind function
	 *
	 * @description
	 * get (array/object, object/array) and return merged collection
	 */
	angular.module('a8m.concat', [])
	  .filter('concat', [function () {
	    return function (collection, joined) {
	
	      if (isUndefined(joined)) return collection;
	
	      if (isArray(collection)) {
	        return isObject(joined)
	          ? collection.concat(toArray(joined))
	          : collection.concat(joined);
	      }
	
	      if (isObject(collection)) {
	        var array = toArray(collection);
	        return (isObject(joined))
	          ? array.concat(toArray(joined))
	          : array.concat(joined);
	      }
	      return collection;
	    };
	  }
	]);
	
	/**
	 * @ngdoc filter
	 * @name contains
	 * @kind function
	 *
	 * @description
	 * Checks if given expression is present in one or more object in the collection
	 */
	angular.module('a8m.contains', [])
	  .filter({
	    contains: ['$parse', containsFilter],
	    some: ['$parse', containsFilter]
	  });
	
	function containsFilter($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return false;
	      }
	
	      return collection.some(function(elm) {
	        return ((isString(expression) && isObject(elm)) || isFunction(expression))
	          ? $parse(expression)(elm)
	          : elm === expression;
	      });
	
	    }
	 }
	
	/**
	 * @ngdoc filter
	 * @name countBy
	 * @kind function
	 *
	 * @description
	 * Sorts a list into groups and returns a count for the number of objects in each group.
	 */
	
	angular.module('a8m.count-by', [])
	
	  .filter('countBy', [ '$parse', function ( $parse ) {
	    return function (collection, property) {
	
	      var result = {},
	        get = $parse(property),
	        prop;
	
	      collection = (isObject(collection)) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(property)) {
	        return collection;
	      }
	
	      collection.forEach( function( elm ) {
	        prop = get(elm);
	
	        if(!result[prop]) {
	          result[prop] = 0;
	        }
	
	        result[prop]++;
	      });
	
	      return result;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name defaults
	 * @kind function
	 *
	 * @description
	 * defaultsFilter allows to specify a default fallback value for properties that resolve to undefined.
	 */
	angular.module('a8m.defaults', [])
	  .filter('defaults', ['$parse', function( $parse ) {
	    return function(collection, defaults) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || !isObject(defaults)) {
	        return collection;
	      }
	
	      var keys = deepKeys(defaults);
	
	      collection.forEach(function(elm) {
	        //loop through all the keys
	        keys.forEach(function(key) {
	          var getter = $parse(key);
	          var setter = getter.assign;
	          //if it's not exist
	          if(isUndefined(getter(elm))) {
	            //get from defaults, and set to the returned object
	            setter(elm, getter(defaults))
	          }
	        });
	      });
	
	      return collection;
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name every
	 * @kind function
	 *
	 * @description
	 * Checks if given expression is present in all members in the collection
	 *
	 */
	angular.module('a8m.every', [])
	  .filter('every', ['$parse', function($parse) {
	    return function (collection, expression) {
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return true;
	      }
	
	      return collection.every( function(elm) {
	        return (isObject(elm) || isFunction(expression))
	          ? $parse(expression)(elm)
	          : elm === expression;
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name filterBy
	 * @kind function
	 *
	 * @description
	 * filter by specific properties, avoid the rest
	 */
	angular.module('a8m.filter-by', [])
	  .filter('filterBy', ['$parse', function( $parse ) {
	    return function(collection, properties, search, strict) {
	      var comparator;
	
	      search = (isString(search) || isNumber(search)) ?
	        String(search).toLowerCase() : undefined;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(search)) {
	        return collection;
	      }
	
	      return collection.filter(function(elm) {
	        return properties.some(function(prop) {
	
	          /**
	           * check if there is concatenate properties
	           * example:
	           * object: { first: 'foo', last:'bar' }
	           * filterBy: ['first + last'] => search by full name(i.e 'foo bar')
	           */
	          if(!~prop.indexOf('+')) {
	            comparator = $parse(prop)(elm)
	          } else {
	            var propList = prop.replace(/\s+/g, '').split('+');
	            comparator = propList
	              .map(function(prop) { return $parse(prop)(elm); })
	              .join(' ');
	          }
	
	          if (!isString(comparator) && !isNumber(comparator)) {
	            return false;
	          }
	
	          comparator = String(comparator).toLowerCase();
	
	          return strict ? comparator === search : comparator.contains(search);
	        });
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name first
	 * @kind function
	 *
	 * @description
	 * Gets the first element or first n elements of an array
	 * if callback is provided, is returns as long the callback return truthy
	 */
	angular.module('a8m.first', [])
	  .filter('first', ['$parse', function( $parse ) {
	    return function(collection) {
	      var n
	        , getter
	        , args;
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      args = Array.prototype.slice.call(arguments, 1);
	      n = (isNumber(args[0])) ? args[0] : 1;
	      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;
	
	      return (args.length) ? getFirstMatches(collection, n,(getter) ? $parse(getter) : getter) :
	        collection[0];
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name flatten
	 * @kind function
	 *
	 * @description
	 * Flattens a nested array (the nesting can be to any depth).
	 * If you pass shallow, the array will only be flattened a single level
	 */
	angular.module('a8m.flatten', [])
	  .filter('flatten', function () {
	    return function(collection, shallow) {
	
	      shallow = shallow || false;
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      return !shallow
	        ? flatten(collection, 0)
	        : [].concat.apply([], collection);
	    }
	  });
	
	/**
	 * flatten nested array (the nesting can be to any depth).
	 * @param array {Array}
	 * @param i {int}
	 * @returns {Array}
	 * @private
	 */
	function flatten(array, i) {
	  i = i || 0;
	
	  if(i >= array.length)
	    return array;
	
	  if(isArray(array[i])) {
	    return flatten(array.slice(0,i)
	      .concat(array[i], array.slice(i+1)), i);
	  }
	  return flatten(array, i+1);
	}
	
	/**
	 * @ngdoc filter
	 * @name fuzzyByKey
	 * @kind function
	 *
	 * @description
	 * fuzzy string searching by key
	 */
	angular.module('a8m.fuzzy-by', [])
	  .filter('fuzzyBy', ['$parse', function ( $parse ) {
	    return function (collection, property, search, csensitive) {
	
	      var sensitive = csensitive || false,
	        prop, getter;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(property)
	        || isUndefined(search)) {
	        return collection;
	      }
	
	      getter = $parse(property);
	
	      return collection.filter(function(elm) {
	
	        prop = getter(elm);
	        if(!isString(prop)) {
	          return false;
	        }
	
	        prop = (sensitive) ? prop : prop.toLowerCase();
	        search = (sensitive) ? search : search.toLowerCase();
	
	        return hasApproxPattern(prop, search) !== false
	      })
	    }
	
	 }]);
	/**
	 * @ngdoc filter
	 * @name fuzzy
	 * @kind function
	 *
	 * @description
	 * fuzzy string searching for array of strings, objects
	 */
	angular.module('a8m.fuzzy', [])
	  .filter('fuzzy', function () {
	    return function (collection, search, csensitive) {
	      var sensitive = csensitive || false;
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(search)) {
	        return collection;
	      }
	
	      search = (sensitive) ? search : search.toLowerCase();
	
	      return collection.filter(function(elm) {
	        if(isString(elm)) {
	          elm = (sensitive) ? elm : elm.toLowerCase();
	          return hasApproxPattern(elm, search) !== false
	        }
	        return (isObject(elm)) ? _hasApproximateKey(elm, search) : false;
	      });
	
	      /**
	       * checks if object has key{string} that match
	       * to fuzzy search pattern
	       * @param object
	       * @param search
	       * @returns {boolean}
	       * @private
	       */
	      function _hasApproximateKey(object, search) {
	        var properties = Object.keys(object),
	          prop, flag;
	        return 0 < properties.filter(function (elm) {
	          prop = object[elm];
	
	          //avoid iteration if we found some key that equal[performance]
	          if(flag) return true;
	
	          if (isString(prop)) {
	            prop = (sensitive) ? prop : prop.toLowerCase();
	            return flag = (hasApproxPattern(prop, search) !== false);
	          }
	
	          return false;
	
	        }).length;
	      }
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name groupBy
	 * @kind function
	 *
	 * @description
	 * Create an object composed of keys generated from the result of running each element of a collection,
	 * each key is an array of the elements.
	 */
	
	angular.module('a8m.group-by', [ 'a8m.filter-watcher' ])
	  .filter('groupBy', [ '$parse', 'filterWatcher', function ( $parse, filterWatcher ) {
	    return function (collection, property) {
	
	      if(!isObject(collection) || isUndefined(property)) {
	        return collection;
	      }
	
	      return filterWatcher.isMemoized('groupBy', arguments) ||
	        filterWatcher.memoize('groupBy', arguments, this,
	          _groupBy(collection, $parse(property)));
	
	      /**
	       * groupBy function
	       * @param collection
	       * @param getter
	       * @returns {{}}
	       */
	      function _groupBy(collection, getter) {
	        var result = {};
	        var prop;
	
	        forEach( collection, function( elm ) {
	          prop = getter(elm);
	
	          if(!result[prop]) {
	            result[prop] = [];
	          }
	          result[prop].push(elm);
	        });
	        return result;
	      }
	    }
	 }]);
	
	/**
	 * @ngdoc filter
	 * @name isEmpty
	 * @kind function
	 *
	 * @description
	 * get collection or string and return if it empty
	 */
	angular.module('a8m.is-empty', [])
	  .filter('isEmpty', function () {
	    return function(collection) {
	      return isObject(collection)
	        ? !toArray(collection).length
	        : !collection.length;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name join
	 * @kind function
	 *
	 * @description
	 * join a collection by a provided delimiter (space by default)
	 */
	angular.module('a8m.join', [])
	  .filter('join', function () {
	    return function (input, delimiter) {
	      if (isUndefined(input) || !isArray(input)) {
	        return input;
	      }
	      if (isUndefined(delimiter)) delimiter = ' ';
	
	      return input.join(delimiter);
	    };
	  })
	;
	
	/**
	 * @ngdoc filter
	 * @name last
	 * @kind function
	 *
	 * @description
	 * Gets the last element or last n elements of an array
	 * if callback is provided, is returns as long the callback return truthy
	 */
	angular.module('a8m.last', [])
	  .filter('last', ['$parse', function( $parse ) {
	    return function(collection) {
	      var n
	        , getter
	        , args
	        //cuz reverse change our src collection
	        //and we don't want side effects
	        , reversed = copy(collection);
	
	      reversed = isObject(reversed)
	        ? toArray(reversed)
	        : reversed;
	
	      if(!isArray(reversed)) {
	        return reversed;
	      }
	
	      args = Array.prototype.slice.call(arguments, 1);
	      n = (isNumber(args[0])) ? args[0] : 1;
	      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;
	
	      return (args.length)
	        //send reversed collection as arguments, and reverse it back as result
	        ? getFirstMatches(reversed.reverse(), n,(getter) ? $parse(getter) : getter).reverse()
	        //get the last element
	        : reversed[reversed.length-1];
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name map
	 * @kind function
	 *
	 * @description
	 * Returns a new collection of the results of each expression execution.
	 */
	angular.module('a8m.map', [])
	  .filter('map', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.map(function (elm) {
	        return $parse(expression)(elm);
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name omit
	 * @kind function
	 *
	 * @description
	 * filter collection by expression
	 */
	
	angular.module('a8m.omit', [])
	
	  .filter('omit', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.filter(function (elm) {
	        return !($parse(expression)(elm));
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name pick
	 * @kind function
	 *
	 * @description
	 * filter collection by expression
	 */
	
	angular.module('a8m.pick', [])
	
	  .filter('pick', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.filter(function (elm) {
	        return $parse(expression)(elm);
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name range
	 * @kind function
	 *
	 * @description
	 * rangeFilter provides some support for a for loop using numbers
	 */
	angular.module('a8m.range', [])
	  .filter('range', function () {
	    return function (input, total, start, increment, cb) {
	      start = start || 0;
	      increment = increment || 1;
	      for (var i = 0; i < parseInt(total); i++) {
	        var j = start + i * increment;
	        input.push(isFunction(cb) ? cb(j) : j);
	      }
	      return input;
	    };
	  });
	/**
	 * @ngdoc filter
	 * @name removeWith
	 * @kind function
	 *
	 * @description
	 * get collection and properties object, and removed elements
	 * with this properties
	 */
	
	angular.module('a8m.remove-with', [])
	  .filter('removeWith', function() {
	    return function (collection, object) {
	
	      if(isUndefined(object)) {
	        return collection;
	      }
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      return collection.filter(function (elm) {
	        return !objectContains(object, elm);
	      });
	    }
	  });
	
	
	/**
	 * @ngdoc filter
	 * @name remove
	 * @kind function
	 *
	 * @description
	 * remove specific members from collection
	 */
	
	angular.module('a8m.remove', [])
	
	  .filter('remove', function () {
	    return function (collection) {
	      collection = isObject(collection) ? toArray(collection) : collection;
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      return collection.filter( function( member ) {
	        return !args.some(function(nest) {
	          return equals(nest, member);
	        })
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name reverse
	 * @kind function
	 *
	 * @description
	 * Reverses a string or collection
	 */
	angular.module('a8m.reverse', [])
	    .filter('reverse',[ function () {
	      return function (input) {
	        input = isObject(input) ? toArray(input) : input;
	
	        if(isString(input)) {
	          return input.split('').reverse().join('');
	        }
	
	        return isArray(input)
	          ? input.slice().reverse()
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name searchField
	 * @kind function
	 *
	 * @description
	 * for each member, join several strings field and add them to
	 * new field called 'searchField' (use for search filtering)
	 */
	angular.module('a8m.search-field', [])
	  .filter('searchField', ['$parse', function ($parse) {
	    return function (collection) {
	
	      var get, field;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      if(!isArray(collection) || !args.length) {
	        return collection;
	      }
	
	      return collection.map(function(member) {
	
	        field = args.map(function(field) {
	          get = $parse(field);
	          return get(member);
	        }).join(' ');
	
	        return extend(member, { searchField: field });
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name toArray
	 * @kind function
	 *
	 * @description
	 * Convert objects into stable arrays.
	 * if addKey set to true,the filter also attaches a new property
	 * $key to the value containing the original key that was used in
	 * the object we are iterating over to reference the property
	 */
	angular.module('a8m.to-array', [])
	  .filter('toArray', function() {
	    return function (collection, addKey) {
	
	      if(!isObject(collection)) {
	        return collection;
	      }
	
	      return !addKey
	        ? toArray(collection)
	        : Object.keys(collection).map(function (key) {
	            return extend(collection[key], { $key: key });
	          });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name unique/uniq
	 * @kind function
	 *
	 * @description
	 * get collection and filter duplicate members
	 * if uniqueFilter get a property(nested to) as argument it's
	 * filter by this property as unique identifier
	 */
	
	angular.module('a8m.unique', [])
	  .filter({
	      unique: ['$parse', uniqFilter],
	      uniq: ['$parse', uniqFilter]
	    });
	
	function uniqFilter($parse) {
	    return function (collection, property) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if (!isArray(collection)) {
	        return collection;
	      }
	
	      //store all unique identifiers
	      var uniqueItems = [],
	          get = $parse(property);
	
	      return (isUndefined(property))
	        //if it's kind of primitive array
	        ? collection.filter(function (elm, pos, self) {
	          return self.indexOf(elm) === pos;
	        })
	        //else compare with equals
	        : collection.filter(function (elm) {
	          var prop = get(elm);
	          if(some(uniqueItems, prop)) {
	            return false;
	          }
	          uniqueItems.push(prop);
	          return true;
	      });
	
	      //checked if the unique identifier is already exist
	      function some(array, member) {
	        if(isUndefined(member)) {
	          return false;
	        }
	        return array.some(function(el) {
	          return equals(el, member);
	        });
	      }
	    }
	}
	
	/**
	 * @ngdoc filter
	 * @name where
	 * @kind function
	 *
	 * @description
	 * of each element in a collection to the given properties object,
	 * returning an array of all elements that have equivalent property values.
	 *
	 */
	angular.module('a8m.where', [])
	  .filter('where', function() {
	    return function (collection, object) {
	      if(isUndefined(object)) return collection;
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      return collection.filter(function (elm) {
	        return objectContains(object, elm);
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name xor
	 * @kind function
	 *
	 * @description
	 * Exclusive or filter by expression
	 */
	
	angular.module('a8m.xor', [])
	
	  .filter('xor', ['$parse', function($parse) {
	    return function (col1, col2, expression) {
	
	      expression = expression || false;
	
	      col1 = isObject(col1) ? toArray(col1) : col1;
	      col2 = isObject(col2) ? toArray(col2) : col2;
	
	      if(!isArray(col1) || !isArray(col2)) return col1;
	
	      return col1.concat(col2)
	        .filter(function(elm) {
	          return !(some(elm, col1) && some(elm, col2));
	        });
	
	      function some(el, col) {
	        var getter = $parse(expression);
	        return col.some(function(dElm) {
	          return expression
	            ? equals(getter(dElm), getter(el))
	            : equals(dElm, el);
	        });
	      }
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name abs
	 * @kind function
	 *
	 * @description
	 * Will return the absolute value of a number
	 */
	angular.module('a8m.math.abs', [])
	  .filter('abs', function () {
	    return function (input) {
	      return Math.abs(input);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert bytes into appropriate display 
	 * 1024 bytes => 1 KB
	 */
	angular.module('a8m.math.byteFmt', [])
	  .filter('byteFmt', function () {
	    var compared = [{str: 'B', val: 1024}];
	    ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
	      compared.push({str: el, val: compared[i].val * 1024 });
	    });
	    return function (bytes, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(bytes) && isFinite(bytes)) {
	        var i = 0;
	        while (i < compared.length-1 && bytes >= compared[i].val) i++;
	        bytes /= i > 0 ? compared[i-1].val : 1;
	        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
	      }
	      return 'NaN';
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name degrees
	 * @kind function
	 *
	 * @description
	 * Convert angle from radians to degrees
	 */
	angular.module('a8m.math.degrees', [])
	  .filter('degrees', function () {
	    return function (radians, decimal) {
	      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
	      // if degrees is not a real number, we cannot do also. quit with error "NaN"
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(radians) && isFinite(radians)) {
	        var degrees = (radians * 180) / Math.PI;
	        return Math.round(degrees * Math.pow(10,decimal)) / (Math.pow(10,decimal));
	      } else {
	        return 'NaN';
	      }
	    }
	  });
	
	 
	 
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert bytes into appropriate display 
	 * 1024 kilobytes => 1 MB
	 */
	angular.module('a8m.math.kbFmt', [])
	  .filter('kbFmt', function () {
	    var compared = [{str: 'KB', val: 1024}];
	    ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
	      compared.push({str: el, val: compared[i].val * 1024 });
	    });
	    return function (bytes, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(bytes) && isFinite(bytes)) {
	        var i = 0;
	        while (i < compared.length-1 && bytes >= compared[i].val) i++;
	        bytes /= i > 0 ? compared[i-1].val : 1;
	        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
	      }
	      return 'NaN';
	    }
	  });
	/**
	 * @ngdoc filter
	 * @name max
	 * @kind function
	 *
	 * @description
	 * Math.max will get an array and return the max value. if an expression
	 * is provided, will return max value by expression.
	 */
	angular.module('a8m.math.max', [])
	  .filter('max', ['$parse', function ($parse) {
	    return function (input, expression) {
	
	      if(!isArray(input)) {
	        return input;
	      }
	      return isUndefined(expression)
	        ? Math.max.apply(Math, input)
	        : input[indexByMax(input, expression)];
	    };
	
	    /**
	     * @private
	     * @param array
	     * @param exp
	     * @returns {number|*|Number}
	     */
	    function indexByMax(array, exp) {
	      var mappedArray = array.map(function(elm){
	        return $parse(exp)(elm);
	      });
	      return mappedArray.indexOf(Math.max.apply(Math, mappedArray));
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name min
	 * @kind function
	 *
	 * @description
	 * Math.min will get an array and return the min value. if an expression
	 * is provided, will return min value by expression.
	 */
	angular.module('a8m.math.min', [])
	  .filter('min', ['$parse', function ($parse) {
	    return function (input, expression) {
	
	      if(!isArray(input)) {
	        return input;
	      }
	      return isUndefined(expression)
	        ? Math.min.apply(Math, input)
	        : input[indexByMin(input, expression)];
	    };
	
	    /**
	     * @private
	     * @param array
	     * @param exp
	     * @returns {number|*|Number}
	     */
	    function indexByMin(array, exp) {
	      var mappedArray = array.map(function(elm){
	        return $parse(exp)(elm);
	      });
	      return mappedArray.indexOf(Math.min.apply(Math, mappedArray));
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name Percent
	 * @kind function
	 *
	 * @description
	 * percentage between two numbers
	 */
	angular.module('a8m.math.percent', [])
	  .filter('percent', function () {
	    return function (input, divided, round) {
	
	      var divider = isString(input) ? Number(input) : input;
	      divided = divided || 100;
	      round = round || false;
	
	      if (!isNumber(divider) || isNaN(divider)) return input;
	
	      return round
	        ? Math.round((divider / divided) * 100)
	        : (divider / divided) * 100;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name toRadians
	 * @kind function
	 *
	 * @description
	 * Convert angle from degrees to radians
	 */
	angular.module('a8m.math.radians', [])
	  .filter('radians', function() {
	    return function (degrees, decimal) {
	      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
	      // if degrees is not a real number, we cannot do also. quit with error "NaN"
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(degrees) && isFinite(degrees)) {
	        var radians = (degrees * 3.14159265359) / 180;
	        return Math.round(radians * Math.pow(10,decimal)) / (Math.pow(10,decimal));
	      }
	      return 'NaN';
	    }
	  });
	
	 
	 
	/**
	 * @ngdoc filter
	 * @name Radix
	 * @kind function
	 *
	 * @description
	 * converting decimal numbers to different bases(radix)
	 */
	angular.module('a8m.math.radix', [])
	  .filter('radix', function () {
	    return function (input, radix) {
	      var RANGE = /^[2-9]$|^[1-2]\d$|^3[0-6]$/;
	
	      if(!isNumber(input) || !RANGE.test(radix)) {
	        return input;
	      }
	
	      return input.toString(radix).toUpperCase();
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert number into abbreviations.
	 * i.e: K for one thousand, M for Million, B for billion
	 * e.g: number of users:235,221, decimal:1 => 235.2 K
	 */
	angular.module('a8m.math.shortFmt', [])
	  .filter('shortFmt', function () {
	    return function (number, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(number) && isFinite(number)){
	        if(number < 1e3) {
	          return '' + number;  // Coerce to string
	        } else if(number < 1e6) {
	          return convertToDecimal((number / 1e3), decimal) + ' K';
	        } else if(number < 1e9){
	          return convertToDecimal((number / 1e6), decimal) + ' M';
	        } else {
	          return convertToDecimal((number / 1e9), decimal) + ' B';
	        }
	
	      }
	      return 'NaN';
	    }
	  });
	/**
	 * @ngdoc filter
	 * @name sum
	 * @kind function
	 *
	 * @description
	 * Sum up all values within an array
	 */
	angular.module('a8m.math.sum', [])
	  .filter('sum', function () {
	    return function (input, initial) {
	      return !isArray(input)
	        ? input
	        : input.reduce(function(prev, curr) {
	          return prev + curr;
	        }, initial || 0);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name endsWith
	 * @kind function
	 *
	 * @description
	 * checks whether string ends with the ends parameter.
	 */
	angular.module('a8m.ends-with', [])
	
	  .filter('endsWith', function () {
	    return function (input, ends, csensitive) {
	
	      var sensitive = csensitive || false,
	        position;
	
	      if(!isString(input) || isUndefined(ends)) {
	        return input;
	      }
	
	      input = (sensitive) ? input : input.toLowerCase();
	      position = input.length - ends.length;
	
	      return input.indexOf((sensitive) ? ends : ends.toLowerCase(), position) !== -1;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name latinize
	 * @kind function
	 *
	 * @description
	 * remove accents/diacritics from a string
	 */
	angular.module('a8m.latinize', [])
	  .filter('latinize',[ function () {
	    var defaultDiacriticsRemovalap = [
	      {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
	      {'base':'AA','letters':'\uA732'},
	      {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
	      {'base':'AO','letters':'\uA734'},
	      {'base':'AU','letters':'\uA736'},
	      {'base':'AV','letters':'\uA738\uA73A'},
	      {'base':'AY','letters':'\uA73C'},
	      {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
	      {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
	      {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
	      {'base':'DZ','letters':'\u01F1\u01C4'},
	      {'base':'Dz','letters':'\u01F2\u01C5'},
	      {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
	      {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
	      {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
	      {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
	      {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
	      {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
	      {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
	      {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
	      {'base':'LJ','letters':'\u01C7'},
	      {'base':'Lj','letters':'\u01C8'},
	      {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
	      {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
	      {'base':'NJ','letters':'\u01CA'},
	      {'base':'Nj','letters':'\u01CB'},
	      {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
	      {'base':'OI','letters':'\u01A2'},
	      {'base':'OO','letters':'\uA74E'},
	      {'base':'OU','letters':'\u0222'},
	      {'base':'OE','letters':'\u008C\u0152'},
	      {'base':'oe','letters':'\u009C\u0153'},
	      {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
	      {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
	      {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
	      {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
	      {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
	      {'base':'TZ','letters':'\uA728'},
	      {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
	      {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
	      {'base':'VY','letters':'\uA760'},
	      {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
	      {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
	      {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
	      {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
	      {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
	      {'base':'aa','letters':'\uA733'},
	      {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
	      {'base':'ao','letters':'\uA735'},
	      {'base':'au','letters':'\uA737'},
	      {'base':'av','letters':'\uA739\uA73B'},
	      {'base':'ay','letters':'\uA73D'},
	      {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
	      {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
	      {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
	      {'base':'dz','letters':'\u01F3\u01C6'},
	      {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
	      {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
	      {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
	      {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
	      {'base':'hv','letters':'\u0195'},
	      {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
	      {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
	      {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
	      {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
	      {'base':'lj','letters':'\u01C9'},
	      {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
	      {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
	      {'base':'nj','letters':'\u01CC'},
	      {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
	      {'base':'oi','letters':'\u01A3'},
	      {'base':'ou','letters':'\u0223'},
	      {'base':'oo','letters':'\uA74F'},
	      {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
	      {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
	      {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
	      {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
	      {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
	      {'base':'tz','letters':'\uA729'},
	      {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
	      {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
	      {'base':'vy','letters':'\uA761'},
	      {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
	      {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
	      {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
	      {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	    ];
	
	    var diacriticsMap = {};
	    for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
	      var letters = defaultDiacriticsRemovalap[i].letters.split("");
	      for (var j = 0; j < letters.length ; j++){
	        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
	      }
	    }
	
	    // "what?" version ... http://jsperf.com/diacritics/12
	    function removeDiacritics (str) {
	      return str.replace(/[^\u0000-\u007E]/g, function(a){
	        return diacriticsMap[a] || a;
	      });
	    }
	
	    return function (input) {
	
	      return isString(input)
	        ? removeDiacritics(input)
	        : input;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name ltrim
	 * @kind function
	 *
	 * @description
	 * Left trim. Similar to trimFilter, but only for left side.
	 */
	angular.module('a8m.ltrim', [])
	  .filter('ltrim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp('^' + trim + '+'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name match
	 * @kind function
	 *
	 * @description
	 * Return the matched pattern in a string.
	 */
	angular.module('a8m.match', [])
	  .filter('match', function () {
	    return function (input, pattern, flag) {
	
	      var reg = new RegExp(pattern, flag);
	
	      return isString(input)
	        ? input.match(reg)
	        : null;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name phone-us
	 * @kind function
	 *
	 * @description
	 * format a string or a number into a us-style
	 * phone number in the form (***) ***-****
	 */
	angular.module('a8m.phoneUS', [])
	  .filter('phoneUS', function () {
	    return function(num) {
	      num += '';
	      return '(' + num.slice(0, 3) + ') ' + num.slice(3, 6) + '-' + num.slice(6);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name repeat
	 * @kind function
	 *
	 * @description
	 * Repeats a string n times
	 */
	angular.module('a8m.repeat', [])
	  .filter('repeat',[ function () {
	    return function (input, n, separator) {
	
	      var times = ~~n;
	
	      if(!isString(input)) {
	        return input;
	      }
	
	      return !times
	        ? input
	        : strRepeat(input, --n, separator || '');
	    }
	  }]);
	
	/**
	 * Repeats a string n times with given separator
	 * @param str string to repeat
	 * @param n number of times
	 * @param sep separator
	 * @returns {*}
	 */
	function strRepeat(str, n, sep) {
	  if(!n) {
	    return str;
	  }
	  return str + sep + strRepeat(str, --n, sep);
	}
	/**
	* @ngdoc filter
	* @name rtrim
	* @kind function
	*
	* @description
	* Right trim. Similar to trimFilter, but only for right side.
	*/
	angular.module('a8m.rtrim', [])
	  .filter('rtrim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp(trim + '+$'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name slugify
	 * @kind function
	 *
	 * @description
	 * remove spaces from string, replace with "-" or given argument
	 */
	angular.module('a8m.slugify', [])
	  .filter('slugify',[ function () {
	    return function (input, sub) {
	
	      var replace = (isUndefined(sub)) ? '-' : sub;
	
	      return isString(input)
	        ? input.toLowerCase().replace(/\s+/g, replace)
	        : input;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name split
	 * @kind function
	 *
	 * @description
	 * split a string by a provided delimiter (none '' by default) and skip first n-delimiters
	 */
	angular.module('a8m.split', [])
	  .filter('split', function () {
	    function escapeRegExp(str) {
	      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	    }
	
	    return function (input, delimiter, skip) {
	      var _regexp, _matches, _splitted, _temp;
	
	      if (isUndefined(input) || !isString(input)) {
	        return null;
	      }
	      if (isUndefined(delimiter)) delimiter = '';
	      if (isNaN(skip)) skip = 0;
	
	      _regexp = new RegExp(escapeRegExp(delimiter), 'g');
	      _matches = input.match(_regexp);
	      
	      if (isNull(_matches) || skip >= _matches.length) {
	        return [input];
	      }
	
	      if (skip === 0) return input.split(delimiter);
	      
	      _splitted = input.split(delimiter);
	      _temp = _splitted.splice(0, skip + 1);
	      _splitted.unshift(_temp.join(delimiter));
	    
	      return _splitted;
	    };
	  })
	;
	
	/**
	 * @ngdoc filter
	 * @name startWith
	 * @kind function
	 *
	 * @description
	 * checks whether string starts with the starts parameter.
	 */
	angular.module('a8m.starts-with', [])
	  .filter('startsWith', function () {
	    return function (input, start, csensitive) {
	
	      var sensitive = csensitive || false;
	
	      if(!isString(input) || isUndefined(start)) {
	        return input;
	      }
	
	      input = (sensitive) ? input : input.toLowerCase();
	
	      return !input.indexOf((sensitive) ? start : start.toLowerCase());
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name stringular
	 * @kind function
	 *
	 * @description
	 * get string with {n} and replace match with enumeration values
	 */
	angular.module('a8m.stringular', [])
	  .filter('stringular', function () {
	    return function(input) {
	
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      return input.replace(/{(\d+)}/g, function (match, number) {
	        return isUndefined(args[number]) ? match : args[number];
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name stripTags
	 * @kind function
	 *
	 * @description
	 * strip html tags from string
	 */
	angular.module('a8m.strip-tags', [])
	  .filter('stripTags', function () {
	    return function(input) {
	      return isString(input)
	        ? input.replace(/<\S[^><]*>/g, '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name test
	 * @kind function
	 *
	 * @description
	 * test if a string match a pattern.
	 */
	angular.module('a8m.test', [])
	  .filter('test', function () {
	    return function (input, pattern, flag) {
	
	      var reg = new RegExp(pattern, flag);
	
	      return isString(input)
	        ? reg.test(input)
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name trim
	 * @kind function
	 *
	 * @description
	 *  Strip whitespace (or other characters) from the beginning and end of a string
	 */
	angular.module('a8m.trim', [])
	  .filter('trim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp('^' + trim + '+|' + trim + '+$', 'g'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name truncate
	 * @kind function
	 *
	 * @description
	 * truncates a string given a specified length, providing a custom string to denote an omission.
	 */
	angular.module('a8m.truncate', [])
	  .filter('truncate', function () {
	    return function(input, length, suffix, preserve) {
	
	      length = isUndefined(length) ? input.length : length;
	      preserve = preserve || false;
	      suffix = suffix || '';
	
	      if(!isString(input) || (input.length <= length)) return input;
	
	      return input.substring(0, (preserve)
	        ? ((input.indexOf(' ', length) === -1) ? input.length : input.indexOf(' ', length))
	        : length) + suffix;
	    };
	  });
	
	/**
	 * @ngdoc filter
	 * @name ucfirst
	 * @kind function
	 *
	 * @description
	 * ucfirst
	 */
	angular.module('a8m.ucfirst', [])
	  .filter({
	    ucfirst: ucfirstFilter,
	    titleize: ucfirstFilter
	  });
	
	function ucfirstFilter() {
	  return function (input) {
	    return isString(input)
	      ? input
	      .split(' ')
	      .map(function (ch) {
	        return ch.charAt(0).toUpperCase() + ch.substring(1);
	      })
	      .join(' ')
	      : input;
	  }
	}
	
	/**
	 * @ngdoc filter
	 * @name uriComponentEncode
	 * @kind function
	 *
	 * @description
	 * get string as parameter and return encoded string
	 */
	angular.module('a8m.uri-component-encode', [])
	  .filter('uriComponentEncode',['$window', function ($window) {
	      return function (input) {
	        return isString(input)
	          ? $window.encodeURIComponent(input)
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name uriEncode
	 * @kind function
	 *
	 * @description
	 * get string as parameter and return encoded string
	 */
	angular.module('a8m.uri-encode', [])
	  .filter('uriEncode',['$window', function ($window) {
	      return function (input) {
	        return isString(input)
	          ? $window.encodeURI(input)
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name wrap
	 * @kind function
	 *
	 * @description
	 * Wrap a string with another string
	 */
	angular.module('a8m.wrap', [])
	  .filter('wrap', function () {
	    return function(input, wrap, ends) {
	      return isString(input) && isDefined(wrap)
	        ? [wrap, input, ends || wrap].join('')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc provider
	 * @name filterWatcher
	 * @kind function
	 *
	 * @description
	 * store specific filters result in $$cache, based on scope life time(avoid memory leak).
	 * on scope.$destroy remove it's cache from $$cache container
	 */
	
	angular.module('a8m.filter-watcher', [])
	  .provider('filterWatcher', function() {
	
	    this.$get = ['$window', '$rootScope', function($window, $rootScope) {
	
	      /**
	       * Cache storing
	       * @type {Object}
	       */
	      var $$cache = {};
	
	      /**
	       * Scope listeners container
	       * scope.$destroy => remove all cache keys
	       * bind to current scope.
	       * @type {Object}
	       */
	      var $$listeners = {};
	
	      /**
	       * $timeout without triggering the digest cycle
	       * @type {function}
	       */
	      var $$timeout = $window.setTimeout;
	
	      /**
	       * @description
	       * get `HashKey` string based on the given arguments.
	       * @param fName
	       * @param args
	       * @returns {string}
	       */
	      function getHashKey(fName, args) {
	        function replacerFactory() {
	          var cache = [];
	          return function(key, val) {
	            if(isObject(val) && !isNull(val)) {
	              if (~cache.indexOf(val)) return '[Circular]';
	              cache.push(val)
	            }
	            if($window == val) return '$WINDOW';
	            if($window.document == val) return '$DOCUMENT';
	            if(isScope(val)) return '$SCOPE';
	            return val;
	          }
	        }
	        return [fName, JSON.stringify(args, replacerFactory())]
	          .join('#')
	          .replace(/"/g,'');
	      }
	
	      /**
	       * @description
	       * fir on $scope.$destroy,
	       * remove cache based scope from `$$cache`,
	       * and remove itself from `$$listeners`
	       * @param event
	       */
	      function removeCache(event) {
	        var id = event.targetScope.$id;
	        forEach($$listeners[id], function(key) {
	          delete $$cache[key];
	        });
	        delete $$listeners[id];
	      }
	
	      /**
	       * @description
	       * for angular version that greater than v.1.3.0
	       * it clear cache when the digest cycle is end.
	       */
	      function cleanStateless() {
	        $$timeout(function() {
	          if(!$rootScope.$$phase)
	            $$cache = {};
	        }, 2000);
	      }
	
	      /**
	       * @description
	       * Store hashKeys in $$listeners container
	       * on scope.$destroy, remove them all(bind an event).
	       * @param scope
	       * @param hashKey
	       * @returns {*}
	       */
	      function addListener(scope, hashKey) {
	        var id = scope.$id;
	        if(isUndefined($$listeners[id])) {
	          scope.$on('$destroy', removeCache);
	          $$listeners[id] = [];
	        }
	        return $$listeners[id].push(hashKey);
	      }
	
	      /**
	       * @description
	       * return the `cacheKey` or undefined.
	       * @param filterName
	       * @param args
	       * @returns {*}
	       */
	      function $$isMemoized(filterName, args) {
	        var hashKey = getHashKey(filterName, args);
	        return $$cache[hashKey];
	      }
	
	      /**
	       * @description
	       * store `result` in `$$cache` container, based on the hashKey.
	       * add $destroy listener and return result
	       * @param filterName
	       * @param args
	       * @param scope
	       * @param result
	       * @returns {*}
	       */
	      function $$memoize(filterName, args, scope, result) {
	        var hashKey = getHashKey(filterName, args);
	        //store result in `$$cache` container
	        $$cache[hashKey] = result;
	        // for angular versions that less than 1.3
	        // add to `$destroy` listener, a cleaner callback
	        if(isScope(scope)) {
	          addListener(scope, hashKey);
	        } else {
	          cleanStateless();
	        }
	        return result;
	      }
	
	      return {
	        isMemoized: $$isMemoized,
	        memoize: $$memoize
	      }
	    }];
	  });
	  
	
	/**
	 * @ngdoc module
	 * @name angular.filters
	 * @description
	 * Bunch of useful filters for angularJS
	 */
	
	angular.module('angular.filter', [
	
	  'a8m.ucfirst',
	  'a8m.uri-encode',
	  'a8m.uri-component-encode',
	  'a8m.slugify',
	  'a8m.latinize',
	  'a8m.strip-tags',
	  'a8m.stringular',
	  'a8m.truncate',
	  'a8m.starts-with',
	  'a8m.ends-with',
	  'a8m.wrap',
	  'a8m.trim',
	  'a8m.ltrim',
	  'a8m.rtrim',
	  'a8m.repeat',
	  'a8m.test',
	  'a8m.match',
	  'a8m.split',
	  'a8m.phoneUS',
	
	  'a8m.to-array',
	  'a8m.concat',
	  'a8m.contains',
	  'a8m.unique',
	  'a8m.is-empty',
	  'a8m.after',
	  'a8m.after-where',
	  'a8m.before',
	  'a8m.before-where',
	  'a8m.defaults',
	  'a8m.where',
	  'a8m.reverse',
	  'a8m.remove',
	  'a8m.remove-with',
	  'a8m.group-by',
	  'a8m.count-by',
	  'a8m.chunk-by',
	  'a8m.search-field',
	  'a8m.fuzzy-by',
	  'a8m.fuzzy',
	  'a8m.omit',
	  'a8m.pick',
	  'a8m.every',
	  'a8m.filter-by',
	  'a8m.xor',
	  'a8m.map',
	  'a8m.first',
	  'a8m.last',
	  'a8m.flatten',
	  'a8m.join',
	  'a8m.range',
	
	  'a8m.math.max',
	  'a8m.math.min',
	  'a8m.math.abs',
	  'a8m.math.percent',
	  'a8m.math.radix',
	  'a8m.math.sum',
	  'a8m.math.degrees',
	  'a8m.math.radians',
	  'a8m.math.byteFmt',
	  'a8m.math.kbFmt',
	  'a8m.math.shortFmt',
	
	  'a8m.angular',
	  'a8m.conditions',
	  'a8m.is-null',
	
	  'a8m.filter-watcher'
	]);
	})( window, window.angular );

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1454);

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	'use strict';
	(function () {
	  var app = angular.module('ui.map', ['ui.event']);
	  function bindMapEvents(scope, eventsStr, googleObject, element) {
	    angular.forEach(eventsStr.split(' '), function (eventName) {
	      window.google.maps.event.addListener(googleObject, eventName, function (event) {
	        element.triggerHandler('map-' + eventName, event);
	        if (!scope.$$phase) {
	          scope.$apply();
	        }
	      });
	    });
	  }
	  app.value('uiMapConfig', {}).directive('uiMap', [
	    'uiMapConfig',
	    '$parse',
	    function (uiMapConfig, $parse) {
	      var mapEvents = 'bounds_changed center_changed click dblclick drag dragend ' + 'dragstart heading_changed idle maptypeid_changed mousemove mouseout ' + 'mouseover projection_changed resize rightclick tilesloaded tilt_changed ' + 'zoom_changed';
	      var options = uiMapConfig || {};
	      return {
	        restrict: 'A',
	        link: function (scope, elm, attrs) {
	          var opts = angular.extend({}, options, scope.$eval(attrs.uiOptions));
	          var map = new window.google.maps.Map(elm[0], opts);
	          var model = $parse(attrs.uiMap);
	          model.assign(scope, map);
	          bindMapEvents(scope, mapEvents, map, elm);
	        }
	      };
	    }
	  ]);
	  app.value('uiMapInfoWindowConfig', {}).directive('uiMapInfoWindow', [
	    'uiMapInfoWindowConfig',
	    '$parse',
	    '$compile',
	    function (uiMapInfoWindowConfig, $parse, $compile) {
	      var infoWindowEvents = 'closeclick content_change domready ' + 'position_changed zindex_changed';
	      var options = uiMapInfoWindowConfig || {};
	      return {
	        link: function (scope, elm, attrs) {
	          var opts = angular.extend({}, options, scope.$eval(attrs.uiOptions));
	          opts.content = elm[0];
	          var model = $parse(attrs.uiMapInfoWindow);
	          var infoWindow = model(scope);
	          if (!infoWindow) {
	            infoWindow = new window.google.maps.InfoWindow(opts);
	            model.assign(scope, infoWindow);
	          }
	          bindMapEvents(scope, infoWindowEvents, infoWindow, elm);
	          elm.replaceWith('<div></div>');
	          var _open = infoWindow.open;
	          infoWindow.open = function open(a1, a2, a3, a4, a5, a6) {
	            $compile(elm.contents())(scope);
	            _open.call(infoWindow, a1, a2, a3, a4, a5, a6);
	          };
	        }
	      };
	    }
	  ]);
	  function mapOverlayDirective(directiveName, events) {
	    app.directive(directiveName, [function () {
	        return {
	          restrict: 'A',
	          link: function (scope, elm, attrs) {
	            scope.$watch(attrs[directiveName], function (newObject) {
	              if (newObject) {
	                bindMapEvents(scope, events, newObject, elm);
	              }
	            });
	          }
	        };
	      }]);
	  }
	  mapOverlayDirective('uiMapMarker', 'animation_changed click clickable_changed cursor_changed ' + 'dblclick drag dragend draggable_changed dragstart flat_changed icon_changed ' + 'mousedown mouseout mouseover mouseup position_changed rightclick ' + 'shadow_changed shape_changed title_changed visible_changed zindex_changed');
	  mapOverlayDirective('uiMapPolyline', 'click dblclick mousedown mousemove mouseout mouseover mouseup rightclick');
	  mapOverlayDirective('uiMapPolygon', 'click dblclick mousedown mousemove mouseout mouseover mouseup rightclick');
	  mapOverlayDirective('uiMapRectangle', 'bounds_changed click dblclick mousedown mousemove mouseout mouseover ' + 'mouseup rightclick');
	  mapOverlayDirective('uiMapCircle', 'center_changed click dblclick mousedown mousemove ' + 'mouseout mouseover mouseup radius_changed rightclick');
	  mapOverlayDirective('uiMapGroundOverlay', 'click dblclick');
	}());

/***/ }),
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1462);

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.5.1
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */!function(a,b,c){"use strict";function d(a){return{require:"?ngModel",restrict:"A",link:function(c,d,e,f){function g(){var a=h(c);return b.isObject(a)&&a.hasOwnProperty("$viewValue")&&(a=a.$viewValue),a}if(!f)return void(console&&console.warn&&console.warn("Match validation requires ngModel to be on the element"));var h=a(e.match),i=a(e.matchCaseless);c.$watch(g,function(){f.$$parseAndValidate()}),f.$validators.match=function(){var a=g();return i(c)&&b.isString(a)&&b.isString(f.$viewValue)?f.$viewValue.toLowerCase()===a.toLowerCase():f.$viewValue===a}}}}b.module("validation.match",[]),b.module("validation.match").directive("match",d),d.$inject=["$parse"]}(window,window.angular);


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1464);

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('chat', []);
	
	// Common JS
	if (true) exports.chat = angular.module('chat');
	
	// define Angular Message module
	angular.module('chat').service( 'Messages', [ 'ChatCore', function(ChatCore) {
	
	    var self = this;
	
	    // Send Messages
	    self.send = function(message) {
	
	        if (!message.data) return;
	
	        ChatCore.publish({
	            to: message.to || 'global',
	            message: message.data,   
	            user: ChatCore.user()
	        });
	
	    };
	
	    // Receive Messages
	    self.receive = function(fn) {
	        self.subscription = ChatCore.subscribe(fn);
	    };
	
	    // Set/Get User
	    self.user = function(data) {
	        return ChatCore.user(data);
	    };
	
	    return self;
	
	}]);
	
	// AngularJS Chat Core Service
	angular.module('chat').service('ChatCore',
	    ['$rootScope', '$http', 'config',
	    function($rootScope, $http, config) {
	
	    var user = { 
	        id: uuid(),
	        name: 'Anonymous'
	    };
	
	    var self = this;
	
	    self.rltm = rltm(config.rltm);
	    
	    // the global room everyone is in
	    self.roomGlobal;
	
	    // my own private rooms
	    self.roomPrivate;
	
	    // everyone elses private rooms
	    self.rooms = {};
	
	    // Set User Data
	    self.user = function(data) {
	
	        if (data) {
	            angular.extend(user, data);
	        }
	
	        return user;
	
	    };
	
	    // Publish over network
	    self.publish = function(setup) {
	
	        var user = setup.user || self.user();
	
	        var data = setup.data;
	
	        if(setup.to) {
	
	            if(!self.rooms[setup.to]) {
	                self.rooms[setup.to] = self.rltm.join(setup.to);   
	            }
	
	            return self.rooms[setup.to].publish({
	                data: setup.message,
	                user: user
	            });
	
	        } else {
	
	            return self.roomGlobal.publish({
	                data: setup.message,
	                user: user
	            });
	
	        }
	
	    };
	
	    // Subscribe to new messages
	    self.subscribe = function(fn) {
	
	        self.roomGlobal = self.rltm.join('global');
	        self.roomPrivate = self.rltm.join(self.user().id);
	
	        self.roomGlobal.on('message', function(uuid, data) {
	            fn(data, false);  
	            $rootScope.$apply();
	        });
	
	        self.roomPrivate.on('message', function(uuid, data) {
	
	            fn(data, true);  
	            $rootScope.$apply();
	
	        });
	
	        return self.room;
	
	    };
	
	}]);
	
	// UUID utility
	function uuid() {
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
	    function(c) {
	        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
	        return v.toString(16);
	    });
	}
	


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1466);

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	angular.module('slick', []).directive('slick', [
	  '$timeout',
	  function ($timeout) {
	    return {
	      restrict: 'AEC',
	      scope: {
	        initOnload: '@',
	        data: '=',
	        currentIndex: '=',
	        accessibility: '@',
	        adaptiveHeight: '@',
	        arrows: '@',
	        asNavFor: '@',
	        appendArrows: '@',
	        appendDots: '@',
	        autoplay: '@',
	        autoplaySpeed: '@',
	        centerMode: '@',
	        centerPadding: '@',
	        cssEase: '@',
	        customPaging: '&',
	        dots: '@',
	        draggable: '@',
	        easing: '@',
	        fade: '@',
	        focusOnSelect: '@',
	        infinite: '@',
	        initialSlide: '@',
	        lazyLoad: '@',
	        onBeforeChange: '&',
	        onAfterChange: '&',
	        onInit: '&',
	        onReInit: '&',
	        onSetPosition: '&',
	        pauseOnHover: '@',
	        pauseOnDotsHover: '@',
	        responsive: '=',
	        rtl: '@',
	        slide: '@',
	        slidesToShow: '@',
	        slidesToScroll: '@',
	        speed: '@',
	        swipe: '@',
	        swipeToSlide: '@',
	        touchMove: '@',
	        touchThreshold: '@',
	        useCSS: '@',
	        variableWidth: '@',
	        vertical: '@',
	        prevArrow: '@',
	        nextArrow: '@'
	      },
	      link: function (scope, element, attrs) {
	        var destroySlick, initializeSlick, isInitialized;
	        destroySlick = function () {
	          return $timeout(function () {
	            var slider;
	            slider = $(element);
	            slider.unslick();
	            slider.find('.slick-list').remove();
	            return slider;
	          });
	        };
	        initializeSlick = function () {
	          return $timeout(function () {
	            var currentIndex, customPaging, slider;
	            slider = $(element);
	            if (scope.currentIndex != null) {
	              currentIndex = scope.currentIndex;
	            }
	            customPaging = function (slick, index) {
	              return scope.customPaging({
	                slick: slick,
	                index: index
	              });
	            };
	            slider.slick({
	              accessibility: scope.accessibility !== 'false',
	              adaptiveHeight: scope.adaptiveHeight === 'true',
	              arrows: scope.arrows !== 'false',
	              asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
	              appendArrows: scope.appendArrows ? $(scope.appendArrows) : $(element),
	              appendDots: scope.appendDots ? $(scope.appendDots) : $(element),
	              autoplay: scope.autoplay === 'true',
	              autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
	              centerMode: scope.centerMode === 'true',
	              centerPadding: scope.centerPadding || '50px',
	              cssEase: scope.cssEase || 'ease',
	              customPaging: attrs.customPaging ? customPaging : void 0,
	              dots: scope.dots === 'true',
	              draggable: scope.draggable !== 'false',
	              easing: scope.easing || 'linear',
	              fade: scope.fade === 'true',
	              focusOnSelect: scope.focusOnSelect === 'true',
	              infinite: scope.infinite !== 'false',
	              initialSlide: scope.initialSlide || 0,
	              lazyLoad: scope.lazyLoad || 'ondemand',
	              beforeChange: attrs.onBeforeChange ? scope.onBeforeChange : void 0,
	              onReInit: attrs.onReInit ? scope.onReInit : void 0,
	              onSetPosition: attrs.onSetPosition ? scope.onSetPosition : void 0,
	              pauseOnHover: scope.pauseOnHover !== 'false',
	              responsive: scope.responsive || void 0,
	              rtl: scope.rtl === 'true',
	              slide: scope.slide || 'div',
	              slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
	              slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
	              speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
	              swipe: scope.swipe !== 'false',
	              swipeToSlide: scope.swipeToSlide === 'true',
	              touchMove: scope.touchMove !== 'false',
	              touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
	              useCSS: scope.useCSS !== 'false',
	              variableWidth: scope.variableWidth === 'true',
	              vertical: scope.vertical === 'true',
	              prevArrow: scope.prevArrow ? $(scope.prevArrow) : void 0,
	              nextArrow: scope.nextArrow ? $(scope.nextArrow) : void 0
	            });
	            slider.on('init', function (sl) {
	              if (attrs.onInit) {
	                scope.onInit();
	              }
	              if (currentIndex != null) {
	                return sl.slideHandler(currentIndex);
	              }
	            });
	            slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
	              if (scope.onAfterChange) {
	                scope.onAfterChange();
	              }
	              if (currentIndex != null) {
	                return scope.$apply(function () {
	                  currentIndex = currentSlide;
	                  return scope.currentIndex = currentSlide;
	                });
	              }
	            });
	            return scope.$watch('currentIndex', function (newVal, oldVal) {
	              if (currentIndex != null && newVal != null && newVal !== currentIndex) {
	                return slider.slick('slickGoTo', newVal);
	              }
	            });
	          });
	        };
	        if (scope.initOnload) {
	          isInitialized = false;
	          return scope.$watch('data', function (newVal, oldVal) {
	            if (newVal != null) {
	              if (isInitialized) {
	                destroySlick();
	              }
	              initializeSlick();
	              return isInitialized = true;
	            }
	          });
	        } else {
	          return initializeSlick();
	        }
	      }
	    };
	  }
	]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1468);

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	/**
	 * @author Umed Khudoiberdiev <info@zar.tj>
	 */
	(function() {
	    'use strict';
	
	    /**
	     * @ngdoc module
	     * @name disableAll
	     * @description
	     * This module represents a disable-all directive which allows you to disable any element in the DOM.
	     */
	    angular.module('disableAll', []);
	    
	    /**
	     * @ngdoc directive
	     * @name doNotDisable
	     * @restrict A
	     * @description
	     * This directive allows you to do not disable the element even if it's under the disableAll directive
	     */
	    angular.module('disableAll').directive('skipDisable', skipDisableDirective);
	    
	    /**
	     * @ngInject
	     */
	    function skipDisableDirective() {
	        return {
	            restrict: 'A'
	        };
	    }
	
	
	    /**
	     * @ngdoc directive
	     * @name disableAll
	     * @restrict A
	     * @description
	     * This directive allows you to disable any element in the DOM. Directive turns off all clicks, disables
	     * inputs, buttons and textareas in the given element scope.
	     */
	    angular.module('disableAll').directive('disableAll', disableAllDirective);
	    
	    /**
	     * @ngInject
	     */
	    function disableAllDirective() {
	        return {
	            restrict: 'A',
	            link: function (scope, element, attrs) {
	                var disabledElement = (attrs.disableElementId) ? document.getElementById(attrs.disableElementId) : element[0];
	
	                scope.$watch(attrs.disableAll, function (isDisabled) {
	                    if (isDisabled)
	                        disableAll(disabledElement);
	                    else
	                        enableAll(disabledElement);
	                });
	
	                scope.$on('$destroy', function() {
	                    enableAll(disabledElement);
	                });
	            }
	        };
	    }
	
	    /**
	     * Disables everything in the given element.
	     *
	     * @param {HTMLElement} element
	     */
	    var disableAll = function(element) {
	        angular.element(element).addClass('disable-all');
	        element.style.color = 'gray';
	        disableElements(element.getElementsByTagName('input'));
	        disableElements(element.getElementsByTagName('button'));
	        disableElements(element.getElementsByTagName('textarea'));
	        disableElements(element.getElementsByTagName('select'));
	        element.addEventListener('click', preventDefault, true);
	    };
	
	    /**
	     * Enables everything in the given element.
	     *
	     * @param {HTMLElement} element
	     */
	    var enableAll = function(element) {
	        angular.element(element).removeClass('disable-all');
	        element.style.color = 'inherit';
	        enableElements(element.getElementsByTagName('input'));
	        enableElements(element.getElementsByTagName('button'));
	        enableElements(element.getElementsByTagName('textarea'));
	        enableElements(element.getElementsByTagName('select'));
	        element.removeEventListener('click', preventDefault, true);
	    };
	
	    /**
	     * Callback used to prevent user clicks.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    var preventDefault = function(event) {
	        for (var i = 0; i < event.target.attributes.length; i++) {
	            var atts = event.target.attributes[i];
	            if(atts.name === "skip-disable"){
	                return true;
	            }
	        }
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	    };
	
	    /**
	     * Disables given elements.
	     *
	     * @param {Array.<HTMLElement>|NodeList} elements List of dom elements that must be disabled
	     */
	    var disableElements = function(elements) {
	        var len = elements.length;
	        for (var i = 0; i < len; i++) {
	            var shouldDisable = true;
	            for (var j = 0; j < elements[i].attributes.length; j++) {
	                var atts = elements[i].attributes[j];
	                if(atts.name === "skip-disable"){
	                    shouldDisable = false;
	                    continue;
	                }
	            }
	            if (shouldDisable && elements[i].disabled === false) {
	                elements[i].disabled = true;
	                elements[i].disabledIf = true;
	            }
	        }
	    };
	
	    /**
	     * Enables given elements.
	     *
	     * @param {Array.<HTMLElement>|NodeList} elements List of dom elements that must be enabled
	     */
	    var enableElements = function(elements) {
	        var len = elements.length;
	        for (var i = 0; i < len; i++) {
	            if (elements[i].disabled === true && elements[i].disabledIf === true) {
	                elements[i].disabled = false;
	                elements[i].disabledIf = null;
	            }
	        }
	    };
	
	})();


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1470);
	__webpack_require__(1471);

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	/**
	 * dirPagination - AngularJS module for paginating (almost) anything.
	 *
	 *
	 * Credits
	 * =======
	 *
	 * Daniel Tabuenca: https://groups.google.com/d/msg/angular/an9QpzqIYiM/r8v-3W1X5vcJ
	 * for the idea on how to dynamically invoke the ng-repeat directive.
	 *
	 * I borrowed a couple of lines and a few attribute names from the AngularUI Bootstrap project:
	 * https://github.com/angular-ui/bootstrap/blob/master/src/pagination/pagination.js
	 *
	 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
	 */
	
	(function() {
	
	    /**
	     * Config
	     */
	    var moduleName = 'angularUtils.directives.dirPagination';
	    var DEFAULT_ID = '__default';
	
	    /**
	     * Module
	     */
	    angular.module(moduleName, [])
	        .directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
	        .directive('dirPaginateNoCompile', noCompileDirective)
	        .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
	        .filter('itemsPerPage', ['paginationService', itemsPerPageFilter])
	        .service('paginationService', paginationService)
	        .provider('paginationTemplate', paginationTemplateProvider)
	        .run(['$templateCache',dirPaginationControlsTemplateInstaller]);
	
	    function dirPaginateDirective($compile, $parse, paginationService) {
	
	        return  {
	            terminal: true,
	            multiElement: true,
	            priority: 100,
	            compile: dirPaginationCompileFn
	        };
	
	        function dirPaginationCompileFn(tElement, tAttrs){
	
	            var expression = tAttrs.dirPaginate;
	            // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
	            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	            var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
	            if (match[2].match(filterPattern) === null) {
	                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
	            }
	            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
	            var collectionGetter = $parse(itemsPerPageFilterRemoved);
	
	            addNoCompileAttributes(tElement);
	
	            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
	            // dir-pagination-controls directives that may be looking for this ID.
	            var rawId = tAttrs.paginationId || DEFAULT_ID;
	            paginationService.registerInstance(rawId);
	
	            return function dirPaginationLinkFn(scope, element, attrs){
	
	                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
	                // potentially register a new ID if it evaluates to a different value than the rawId.
	                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
	                
	                // (TODO: this seems sound, but I'm reverting as many bug reports followed it's introduction in 0.11.0.
	                // Needs more investigation.)
	                // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
	                // before registering using paginationId
	                // paginationService.deregisterInstance(rawId);
	                paginationService.registerInstance(paginationId);
	
	                var repeatExpression = getRepeatExpression(expression, paginationId);
	                addNgRepeatToElement(element, attrs, repeatExpression);
	
	                removeTemporaryAttributes(element);
	                var compiled =  $compile(element);
	
	                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
	                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);
	
	                if (typeof attrs.totalItems !== 'undefined') {
	                    paginationService.setAsyncModeTrue(paginationId);
	                    scope.$watch(function() {
	                        return $parse(attrs.totalItems)(scope);
	                    }, function (result) {
	                        if (0 <= result) {
	                            paginationService.setCollectionLength(paginationId, result);
	                        }
	                    });
	                } else {
	                    paginationService.setAsyncModeFalse(paginationId);
	                    scope.$watchCollection(function() {
	                        return collectionGetter(scope);
	                    }, function(collection) {
	                        if (collection) {
	                            var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
	                            paginationService.setCollectionLength(paginationId, collectionLength);
	                        }
	                    });
	                }
	
	                // Delegate to the link function returned by the new compilation of the ng-repeat
	                compiled(scope);
	                 
	                // (TODO: Reverting this due to many bug reports in v 0.11.0. Needs investigation as the
	                // principle is sound)
	                // When the scope is destroyed, we make sure to remove the reference to it in paginationService
	                // so that it can be properly garbage collected
	                // scope.$on('$destroy', function destroyDirPagination() {
	                //     paginationService.deregisterInstance(paginationId);
	                // });
	            };
	        }
	
	        /**
	         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
	         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
	         *
	         * @param expression
	         * @param paginationId
	         * @returns {*}
	         */
	        function getRepeatExpression(expression, paginationId) {
	            var repeatExpression,
	                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);
	
	            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
	                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
	            } else {
	                repeatExpression = expression;
	            }
	
	            return repeatExpression;
	        }
	
	        /**
	         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
	         * appropriate multi-element ng-repeat to the first and last element in the range.
	         * @param element
	         * @param attrs
	         * @param repeatExpression
	         */
	        function addNgRepeatToElement(element, attrs, repeatExpression) {
	            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
	                // using multiElement mode (dir-paginate-start, dir-paginate-end)
	                attrs.$set('ngRepeatStart', repeatExpression);
	                element.eq(element.length - 1).attr('ng-repeat-end', true);
	            } else {
	                attrs.$set('ngRepeat', repeatExpression);
	            }
	        }
	
	        /**
	         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
	         * @param tElement
	         */
	        function addNoCompileAttributes(tElement) {
	            angular.forEach(tElement, function(el) {
	                if (el.nodeType === 1) {
	                    angular.element(el).attr('dir-paginate-no-compile', true);
	                }
	            });
	        }
	
	        /**
	         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
	         * @param element
	         */
	        function removeTemporaryAttributes(element) {
	            angular.forEach(element, function(el) {
	                if (el.nodeType === 1) {
	                    angular.element(el).removeAttr('dir-paginate-no-compile');
	                }
	            });
	            element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
	            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
	        }
	
	        /**
	         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
	         * no current-page expression was specified.
	         *
	         * @param scope
	         * @param attrs
	         * @param paginationId
	         * @returns {*}
	         */
	        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
	            var currentPageGetter;
	            if (attrs.currentPage) {
	                currentPageGetter = $parse(attrs.currentPage);
	            } else {
	                // If the current-page attribute was not set, we'll make our own.
	                // Replace any non-alphanumeric characters which might confuse
	                // the $parse service and give unexpected results.
	                // See https://github.com/michaelbromley/angularUtils/issues/233
	                var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
	                scope[defaultCurrentPage] = 1;
	                currentPageGetter = $parse(defaultCurrentPage);
	            }
	            return currentPageGetter;
	        }
	    }
	
	    /**
	     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
	     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
	     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
	     */
	    function noCompileDirective() {
	        return {
	            priority: 5000,
	            terminal: true
	        };
	    }
	
	    function dirPaginationControlsTemplateInstaller($templateCache) {
	        $templateCache.put('angularUtils.directives.dirPagination.template', '<ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
	    }
	
	    function dirPaginationControlsDirective(paginationService, paginationTemplate) {
	
	        var numberRegex = /^\d+$/;
	
	        var DDO = {
	            restrict: 'AE',
	            scope: {
	                maxSize: '=?',
	                onPageChange: '&?',
	                paginationId: '=?',
	                autoHide: '=?'
	            },
	            link: dirPaginationControlsLinkFn
	        };
	
	        // We need to check the paginationTemplate service to see whether a template path or
	        // string has been specified, and add the `template` or `templateUrl` property to
	        // the DDO as appropriate. The order of priority to decide which template to use is
	        // (highest priority first):
	        // 1. paginationTemplate.getString()
	        // 2. attrs.templateUrl
	        // 3. paginationTemplate.getPath()
	        var templateString = paginationTemplate.getString();
	        if (templateString !== undefined) {
	            DDO.template = templateString;
	        } else {
	            DDO.templateUrl = function(elem, attrs) {
	                return attrs.templateUrl || paginationTemplate.getPath();
	            };
	        }
	        return DDO;
	
	        function dirPaginationControlsLinkFn(scope, element, attrs) {
	
	            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
	            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
	            // no corresponding dir-paginate directive and wrongly throwing an exception.
	            var rawId = attrs.paginationId ||  DEFAULT_ID;
	            var paginationId = scope.paginationId || attrs.paginationId ||  DEFAULT_ID;
	
	            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
	                var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
	                if (window.console) {
	                    console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
	                }
	            }
	
	            if (!scope.maxSize) { scope.maxSize = 9; }
	            scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
	            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
	            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;
	
	            var paginationRange = Math.max(scope.maxSize, 5);
	            scope.pages = [];
	            scope.pagination = {
	                last: 1,
	                current: 1
	            };
	            scope.range = {
	                lower: 1,
	                upper: 1,
	                total: 1
	            };
	
	            scope.$watch('maxSize', function(val) {
	                if (val) {
	                    paginationRange = Math.max(scope.maxSize, 5);
	                    generatePagination();
	                }
	            });
	
	            scope.$watch(function() {
	                if (paginationService.isRegistered(paginationId)) {
	                    return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
	                }
	            }, function(length) {
	                if (0 < length) {
	                    generatePagination();
	                }
	            });
	
	            scope.$watch(function() {
	                if (paginationService.isRegistered(paginationId)) {
	                    return (paginationService.getItemsPerPage(paginationId));
	                }
	            }, function(current, previous) {
	                if (current != previous && typeof previous !== 'undefined') {
	                    goToPage(scope.pagination.current);
	                }
	            });
	
	            scope.$watch(function() {
	                if (paginationService.isRegistered(paginationId)) {
	                    return paginationService.getCurrentPage(paginationId);
	                }
	            }, function(currentPage, previousPage) {
	                if (currentPage != previousPage) {
	                    goToPage(currentPage);
	                }
	            });
	
	            scope.setCurrent = function(num) {
	                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
	                    num = parseInt(num, 10);
	                    paginationService.setCurrentPage(paginationId, num);
	                }
	            };
	
	            /**
	             * Custom "track by" function which allows for duplicate "..." entries on long lists,
	             * yet fixes the problem of wrongly-highlighted links which happens when using
	             * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
	             * @param id
	             * @param index
	             * @returns {string}
	             */
	            scope.tracker = function(id, index) {
	                return id + '_' + index;
	            };
	
	            function goToPage(num) {
	                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
	                    var oldPageNumber = scope.pagination.current;
	
	                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
	                    scope.pagination.current = num;
	                    updateRangeValues();
	
	                    // if a callback has been set, then call it with the page number as the first argument
	                    // and the previous page number as a second argument
	                    if (scope.onPageChange) {
	                        scope.onPageChange({
	                            newPageNumber : num,
	                            oldPageNumber : oldPageNumber
	                        });
	                    }
	                }
	            }
	
	            function generatePagination() {
	                if (paginationService.isRegistered(paginationId)) {
	                    var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
	                    scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
	                    scope.pagination.current = page;
	                    scope.pagination.last = scope.pages[scope.pages.length - 1];
	                    if (scope.pagination.last < scope.pagination.current) {
	                        scope.setCurrent(scope.pagination.last);
	                    } else {
	                        updateRangeValues();
	                    }
	                }
	            }
	
	            /**
	             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
	             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
	             */
	            function updateRangeValues() {
	                if (paginationService.isRegistered(paginationId)) {
	                    var currentPage = paginationService.getCurrentPage(paginationId),
	                        itemsPerPage = paginationService.getItemsPerPage(paginationId),
	                        totalItems = paginationService.getCollectionLength(paginationId);
	
	                    scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
	                    scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
	                    scope.range.total = totalItems;
	                }
	            }
	            function isValidPageNumber(num) {
	                return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
	            }
	        }
	
	        /**
	         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
	         * links used in pagination
	         *
	         * @param currentPage
	         * @param rowsPerPage
	         * @param paginationRange
	         * @param collectionLength
	         * @returns {Array}
	         */
	        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
	            var pages = [];
	            var totalPages = Math.ceil(collectionLength / rowsPerPage);
	            var halfWay = Math.ceil(paginationRange / 2);
	            var position;
	
	            if (currentPage <= halfWay) {
	                position = 'start';
	            } else if (totalPages - halfWay < currentPage) {
	                position = 'end';
	            } else {
	                position = 'middle';
	            }
	
	            var ellipsesNeeded = paginationRange < totalPages;
	            var i = 1;
	            while (i <= totalPages && i <= paginationRange) {
	                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);
	
	                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
	                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
	                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
	                    pages.push('...');
	                } else {
	                    pages.push(pageNumber);
	                }
	                i ++;
	            }
	            return pages;
	        }
	
	        /**
	         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
	         *
	         * @param i
	         * @param currentPage
	         * @param paginationRange
	         * @param totalPages
	         * @returns {*}
	         */
	        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
	            var halfWay = Math.ceil(paginationRange/2);
	            if (i === paginationRange) {
	                return totalPages;
	            } else if (i === 1) {
	                return i;
	            } else if (paginationRange < totalPages) {
	                if (totalPages - halfWay < currentPage) {
	                    return totalPages - paginationRange + i;
	                } else if (halfWay < currentPage) {
	                    return currentPage - halfWay + i;
	                } else {
	                    return i;
	                }
	            } else {
	                return i;
	            }
	        }
	    }
	
	    /**
	     * This filter slices the collection into pages based on the current page number and number of items per page.
	     * @param paginationService
	     * @returns {Function}
	     */
	    function itemsPerPageFilter(paginationService) {
	
	        return function(collection, itemsPerPage, paginationId) {
	            if (typeof (paginationId) === 'undefined') {
	                paginationId = DEFAULT_ID;
	            }
	            if (!paginationService.isRegistered(paginationId)) {
	                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
	            }
	            var end;
	            var start;
	            if (angular.isObject(collection)) {
	                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
	                if (paginationService.isAsyncMode(paginationId)) {
	                    start = 0;
	                } else {
	                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
	                }
	                end = start + itemsPerPage;
	                paginationService.setItemsPerPage(paginationId, itemsPerPage);
	
	                if (collection instanceof Array) {
	                    // the array just needs to be sliced
	                    return collection.slice(start, end);
	                } else {
	                    // in the case of an object, we need to get an array of keys, slice that, then map back to
	                    // the original object.
	                    var slicedObject = {};
	                    angular.forEach(keys(collection).slice(start, end), function(key) {
	                        slicedObject[key] = collection[key];
	                    });
	                    return slicedObject;
	                }
	            } else {
	                return collection;
	            }
	        };
	    }
	
	    /**
	     * Shim for the Object.keys() method which does not exist in IE < 9
	     * @param obj
	     * @returns {Array}
	     */
	    function keys(obj) {
	        if (!Object.keys) {
	            var objKeys = [];
	            for (var i in obj) {
	                if (obj.hasOwnProperty(i)) {
	                    objKeys.push(i);
	                }
	            }
	            return objKeys;
	        } else {
	            return Object.keys(obj);
	        }
	    }
	
	    /**
	     * This service allows the various parts of the module to communicate and stay in sync.
	     */
	    function paginationService() {
	
	        var instances = {};
	        var lastRegisteredInstance;
	
	        this.registerInstance = function(instanceId) {
	            if (typeof instances[instanceId] === 'undefined') {
	                instances[instanceId] = {
	                    asyncMode: false
	                };
	                lastRegisteredInstance = instanceId;
	            }
	        };
	
	        this.deregisterInstance = function(instanceId) {
	            delete instances[instanceId];
	        };
	        
	        this.isRegistered = function(instanceId) {
	            return (typeof instances[instanceId] !== 'undefined');
	        };
	
	        this.getLastInstanceId = function() {
	            return lastRegisteredInstance;
	        };
	
	        this.setCurrentPageParser = function(instanceId, val, scope) {
	            instances[instanceId].currentPageParser = val;
	            instances[instanceId].context = scope;
	        };
	        this.setCurrentPage = function(instanceId, val) {
	            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
	        };
	        this.getCurrentPage = function(instanceId) {
	            var parser = instances[instanceId].currentPageParser;
	            return parser ? parser(instances[instanceId].context) : 1;
	        };
	
	        this.setItemsPerPage = function(instanceId, val) {
	            instances[instanceId].itemsPerPage = val;
	        };
	        this.getItemsPerPage = function(instanceId) {
	            return instances[instanceId].itemsPerPage;
	        };
	
	        this.setCollectionLength = function(instanceId, val) {
	            instances[instanceId].collectionLength = val;
	        };
	        this.getCollectionLength = function(instanceId) {
	            return instances[instanceId].collectionLength;
	        };
	
	        this.setAsyncModeTrue = function(instanceId) {
	            instances[instanceId].asyncMode = true;
	        };
	
	        this.setAsyncModeFalse = function(instanceId) {
	            instances[instanceId].asyncMode = false;
	        };
	
	        this.isAsyncMode = function(instanceId) {
	            return instances[instanceId].asyncMode;
	        };
	    }
	
	    /**
	     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
	     */
	    function paginationTemplateProvider() {
	
	        var templatePath = 'angularUtils.directives.dirPagination.template';
	        var templateString;
	
	        /**
	         * Set a templateUrl to be used by all instances of <dir-pagination-controls>
	         * @param {String} path
	         */
	        this.setPath = function(path) {
	            templatePath = path;
	        };
	
	        /**
	         * Set a string of HTML to be used as a template by all instances
	         * of <dir-pagination-controls>. If both a path *and* a string have been set,
	         * the string takes precedence.
	         * @param {String} str
	         */
	        this.setString = function(str) {
	            templateString = str;
	        };
	
	        this.$get = function() {
	            return {
	                getPath: function() {
	                    return templatePath;
	                },
	                getString: function() {
	                    return templateString;
	                }
	            };
	        };
	    }
	})();


/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	module.exports = "<ul class=pagination ng-if=\"1 < pages.length || !autoHide\"> <li ng-if=boundaryLinks ng-class=\"{ disabled : pagination.current == 1 }\"> <a href=\"\" ng-click=setCurrent(1)>&laquo;</a> </li> <li ng-if=directionLinks ng-class=\"{ disabled : pagination.current == 1 }\"> <a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a> </li> <li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == '...' }\"> <a href=\"\" ng-click=setCurrent(pageNumber)>{{ pageNumber }}</a> </li> <li ng-if=directionLinks ng-class=\"{ disabled : pagination.current == pagination.last }\"> <a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a> </li> <li ng-if=boundaryLinks ng-class=\"{ disabled : pagination.current == pagination.last }\"> <a href=\"\" ng-click=setCurrent(pagination.last)>&raquo;</a> </li> </ul>";

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1473);

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {(function() {
	  var picker;
	
	  picker = angular.module('daterangepicker', []);
	
	  picker.constant('dateRangePickerConfig', {
	    clearLabel: 'Clear',
	    locale: {
	      separator: ' - ',
	      format: 'YYYY-MM-DD'
	    }
	  });
	
	  picker.directive('dateRangePicker', ['$compile', '$timeout', '$parse', 'dateRangePickerConfig', function($compile, $timeout, $parse, dateRangePickerConfig) {
	    return {
	      require: 'ngModel',
	      restrict: 'A',
	      scope: {
	        min: '=',
	        max: '=',
	        model: '=ngModel',
	        opts: '=options',
	        clearable: '='
	      },
	      link: function($scope, element, attrs, modelCtrl) {
	        var _clear, _init, _initBoundaryField, _mergeOpts, _picker, _setDatePoint, _setEndDate, _setStartDate, _validate, _validateMax, _validateMin, customOpts, el, opts;
	        _mergeOpts = function() {
	          var extend, localeExtend;
	          localeExtend = angular.extend.apply(angular, Array.prototype.slice.call(arguments).map(function(opt) {
	            return opt != null ? opt.locale : void 0;
	          }).filter(function(opt) {
	            return !!opt;
	          }));
	          extend = angular.extend.apply(angular, arguments);
	          extend.locale = localeExtend;
	          return extend;
	        };
	        el = $(element);
	        customOpts = $scope.opts;
	        opts = _mergeOpts({}, dateRangePickerConfig, customOpts);
	        _picker = null;
	        _clear = function() {
	          _picker.setStartDate();
	          return _picker.setEndDate();
	        };
	        _setDatePoint = function(setter) {
	          return function(newValue) {
	            if (_picker && newValue) {
	              return setter(moment(newValue));
	            }
	          };
	        };
	        _setStartDate = _setDatePoint(function(m) {
	          if (_picker.endDate < m) {
	            _picker.setEndDate(m);
	          }
	          opts.startDate = m;
	          return _picker.setStartDate(m);
	        });
	        _setEndDate = _setDatePoint(function(m) {
	          if (_picker.startDate > m) {
	            _picker.setStartDate(m);
	          }
	          opts.endDate = m;
	          return _picker.setEndDate(m);
	        });
	        _validate = function(validator) {
	          return function(boundary, actual) {
	            if (boundary && actual) {
	              return validator(moment(boundary), moment(actual));
	            } else {
	              return true;
	            }
	          };
	        };
	        _validateMin = _validate(function(min, start) {
	          return min.isBefore(start) || min.isSame(start, 'day');
	        });
	        _validateMax = _validate(function(max, end) {
	          return max.isAfter(end) || max.isSame(end, 'day');
	        });
	        modelCtrl.$formatters.push(function(objValue) {
	          var f;
	          f = function(date) {
	            if (!moment.isMoment(date)) {
	              return moment(date).format(opts.locale.format);
	            } else {
	              return date.format(opts.locale.format);
	            }
	          };
	          if (opts.singleDatePicker && objValue) {
	            return f(objValue);
	          } else if (objValue.startDate) {
	            return [f(objValue.startDate), f(objValue.endDate)].join(opts.locale.separator);
	          } else {
	            return '';
	          }
	        });
	        modelCtrl.$render = function() {
	          if (modelCtrl.$modelValue && modelCtrl.$modelValue.startDate) {
	            _setStartDate(modelCtrl.$modelValue.startDate);
	            _setEndDate(modelCtrl.$modelValue.endDate);
	          } else {
	            _clear();
	          }
	          return el.val(modelCtrl.$viewValue);
	        };
	        modelCtrl.$parsers.push(function(val) {
	          var f, objValue, x;
	          f = function(value) {
	            return moment(value, opts.locale.format);
	          };
	          objValue = {
	            startDate: null,
	            endDate: null
	          };
	          if (angular.isString(val) && val.length > 0) {
	            if (opts.singleDatePicker) {
	              objValue = f(val);
	            } else {
	              x = val.split(opts.locale.separator).map(f);
	              objValue.startDate = x[0];
	              objValue.endDate = x[1];
	            }
	          }
	          return objValue;
	        });
	        modelCtrl.$isEmpty = function(val) {
	          return !(angular.isString(val) && val.length > 0);
	        };
	        _init = function() {
	          var eventType, results;
	          el.daterangepicker(angular.extend(opts, {
	            autoUpdateInput: false
	          }), function(start, end) {
	            return $scope.$apply(function() {
	              return $scope.model = opts.singleDatePicker ? start : {
	                startDate: start,
	                endDate: end
	              };
	            });
	          });
	          _picker = el.data('daterangepicker');
	          results = [];
	          for (eventType in opts.eventHandlers) {
	            results.push(el.on(eventType, function(e) {
	              var eventName;
	              eventName = e.type + '.' + e.namespace;
	              return $scope.$evalAsync(opts.eventHandlers[eventName]);
	            }));
	          }
	          return results;
	        };
	        _init();
	        $scope.$watch('model.startDate', function(n) {
	          return _setStartDate(n);
	        });
	        $scope.$watch('model.endDate', function(n) {
	          return _setEndDate(n);
	        });
	        _initBoundaryField = function(field, validator, modelField, optName) {
	          if (attrs[field]) {
	            modelCtrl.$validators[field] = function(value) {
	              return value && validator(opts[optName], value[modelField]);
	            };
	            return $scope.$watch(field, function(date) {
	              opts[optName] = date ? moment(date) : false;
	              return _init();
	            });
	          }
	        };
	        _initBoundaryField('min', _validateMin, 'startDate', 'minDate');
	        _initBoundaryField('max', _validateMax, 'endDate', 'maxDate');
	        if (attrs.options) {
	          $scope.$watch('opts', function(newOpts) {
	            opts = _mergeOpts(opts, newOpts);
	            return _init();
	          }, true);
	        }
	        if (attrs.clearable) {
	          $scope.$watch('clearable', function(newClearable) {
	            if (newClearable) {
	              opts = _mergeOpts(opts, {
	                locale: {
	                  cancelLabel: opts.clearLabel
	                }
	              });
	            }
	            _init();
	            if (newClearable) {
	              return el.on('cancel.daterangepicker', function() {
	                return $scope.$apply(function() {
	                  return $scope.model = opts.singleDatePicker ? null : {
	                    startDate: null,
	                    endDate: null
	                  };
	                });
	              });
	            }
	          });
	        }
	        return $scope.$on('$destroy', function() {
	          return _picker != null ? _picker.remove() : void 0;
	        });
	      }
	    };
	  }]);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1475);

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	/*
	    ng-youtube-embed v1.7.9
	    Copyright (c) 2015 Arun Michael Dsouza (amdsouza92@gmail.com)
	    Licence: MIT
	    Demo on CodePen - http://codepen.io/amdsouza92/pen/yNxyJV
	*/
	!function(){"use strict";function a(){var a=document.createElement("script"),b=document.getElementsByTagName("script")[0];a.src=g,b.parentNode.insertBefore(a,b)}function b(){for(var a=g,b=document.getElementsByTagName("script"),c=b.length;c--;)if(b[c].src==a)return!0;return!1}function c(a,b,c){var d=c?c:"";return'<iframe id="'+a.videoid+'" width="'+a.width+'" height="'+a.height+'" src="https://www.youtube.com/embed/'+d+"?enablejsapi="+a.enablejsapi+"&autoplay="+a.autoplay+"&cc_load_policy="+a.ccloadpolicy+"&color="+a.color+"&controls="+a.controls+"&disablekb="+a.disablekb+"&end="+a.end+"&fs="+a.fs+"&hl="+a.hl+"&iv_load_policy="+a.ivloadpolicy+"&playlist="+b.playlistArray+"&playsinline="+a.playsinline+"&rel="+a.rel+"&showinfo="+a.showinfo+"&start="+a.start+"&modestbranding="+a.modestbranding+"&loop="+a.loop+"&listType="+a.listType+"&list="+a.list+"&origin="+a.origin+'" frameborder="0" allowfullscreen></iframe>'}function d(a,b,d,e){var f=c(a,b,e);b.youtubeEmbedFrame=d.trustAsHtml(f)}var e=angular.module("ngYoutubeEmbed",[]),f=[],g="https://www.youtube.com/iframe_api",h=/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,i=/^(?:https?:\/\/)?(?:www\.)?(?:gaming.youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;e.service("ngYoutubeEmbedService",["$window","$rootScope",function(a,b){this.setReadyState=function(){a.onYouTubeIframeAPIReady=function(){f.forEach(function(a){b.$emit("youtubeIframeEmbedApiLoaded",a)})}};var c=[];b.$on("addNewPlayer",function(a,b){c[b.id]=b.player}),this.getPlayerById=function(a){return c[a]},this.getVideoIdByUrl=function(a){var b=a.indexOf("gaming")!==-1?i:h,c=a.match(b);return null!==c?c[1]:a}}]),e.directive("ngYoutubeEmbed",["$sce","ngYoutubeEmbedService","$rootScope",function(c,e,g){return{restrict:"E",template:'<div ng-bind-html="youtubeEmbedFrame"></div>',scope:{video:"=",onready:"=",onstatechange:"=",onplaybackqualitychange:"=",onplaybackratechange:"=",onerror:"=",onapichange:"=",autoplay:"@",ccloadpolicy:"@",color:"@",controls:"@",disablekb:"@",end:"@end",fs:"@",hl:"@",ivloadpolicy:"@",playlist:"@",playsinline:"@",rel:"@",showinfo:"@",start:"@",width:"@",height:"@",enablejsapi:"@",videoid:"@",modestbranding:"@",loop:"@",listtype:"@",list:"@",origin:"@"},link:function(h,i,j){i[0].removeAttribute("id");var k={width:h.width?h.width:500,height:h.height?h.height:350,autoplay:"true"==h.autoplay?1:0,ccloadpolicy:"true"==h.ccloadpolicy?1:0,color:"white"==h.color?"white":"red",controls:"false"==h.controls?0:1,disablekb:"false"==h.disablekb?1:0,end:h.end?h.end:"",fs:"false"==h.fs?0:1,hl:h.hl?h.hl:"",ivloadpolicy:"false"==h.ivloadpolicy?3:1,playlist:h.playlist?h.playlist:"",playsinline:"true"==h.playsinline?1:0,rel:"false"==h.rel?0:1,showinfo:"false"==h.showinfo?0:1,start:h.start?h.start:"",enablejsapi:"true"===h.enablejsapi?1:0,videoid:h.videoid?h.videoid:"",modestbranding:"true"===h.modestbranding?1:0,loop:"true"===h.loop?1:"",listType:h.listtype?h.listtype:"",list:h.list?h.list:"",origin:h.origin?h.origin:""};if(k.enablejsapi&&!b()&&(a(),e.setReadyState()),k.enablejsapi&&g.$on("youtubeIframeEmbedApiLoaded",function(a,b){if(b===k.videoid){var c=new YT.Player(b,{events:{onReady:h.onready,onStateChange:h.onstatechange,onPlaybackQualityChange:h.onplaybackqualitychange,onPlaybackRateChange:h.onplaybackratechange,onError:h.onerror,onApiChange:h.onapichange}});g.$emit("addNewPlayer",{player:c,id:b})}}),h.playlistArray=[],k.playlist)for(var l=h.playlist.split(","),m=0;m<l.length;m++)h.playlistArray.push(e.getVideoIdByUrl(l[m]));k.videoid&&k.enablejsapi?f.push(k.videoid):null,k.list&&(k.listType?d(k,h,c):console.warn("The list parameter works in conjunction with the listtype parameter, please provide a valid value for the listtype parameter in order to render a list. Read documentation here - https://github.com/ArunMichaelDsouza/ng-youtube-embed#list-string")),k.listType&&(k.list?d(k,h,c):console.warn("The listtype parameter works in conjunction with the list parameter, please provide a valid value for the list parameter in order to render a list. Read documentation here - https://github.com/ArunMichaelDsouza/ng-youtube-embed#listtype-string")),k.listType||k.list||h.video||console.warn("Please provide a valid youtube video URL or ID to render the iframe embed player. Read documentation here - https://github.com/ArunMichaelDsouza/ng-youtube-embed"),h.$watch("video",function(a){if(a){var b=e.getVideoIdByUrl(a);d(k,h,c,b)}})}}}])}();

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1477);

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '12.2.13';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;
	
	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }
	
	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };
	
	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }
	
	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];
	
	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }
	
	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];
	
	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }
	
	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }
	
	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }
	
	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }
	
	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }
	
	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }
	
	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);
	
	    if (keep && !allNewFiles.length) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });
	
	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);
	
	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }
	
	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);
	
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;
	
	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	
	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;
	
	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };
	
	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];
	
	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }
	
	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }
	
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }
	
	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	
	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));
	
	    $q.all(promises).then(function () {
	
	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }
	
	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });
	
	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');
	
	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	
	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadErrorInCaseOfNoCallback();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);
	
	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }
	
	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }
	
	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;
	
	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }
	
	      var promises = [upload.emptyPromise()];
	
	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }
	
	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });
	
	      return defer.promise;
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);
	
	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);
	
	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };
	
	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }
	
	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };
	
	  return upload;
	}]);
	


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1479);

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	/*!
	 * angular-masonry 0.16.0
	 * Pascal Hartig, https://passy.me/
	 * License: MIT
	 */
	(function () {
	  'use strict';
	  angular.module('wu.masonry', []).controller('MasonryCtrl', [
	    '$scope',
	    '$element',
	    '$timeout',
	    function controller($scope, $element, $timeout) {
	      var bricks = {};
	      var schedule = [];
	      var destroyed = false;
	      var self = this;
	      var timeout = null;
	      this.preserveOrder = false;
	      this.loadImages = true;
	      this.scheduleMasonryOnce = function scheduleMasonryOnce() {
	        var args = arguments;
	        var found = schedule.filter(function filterFn(item) {
	            return item[0] === args[0];
	          }).length > 0;
	        if (!found) {
	          this.scheduleMasonry.apply(null, arguments);
	        }
	      };
	      // Make sure it's only executed once within a reasonable time-frame in
	      // case multiple elements are removed or added at once.
	      this.scheduleMasonry = function scheduleMasonry() {
	        if (timeout) {
	          $timeout.cancel(timeout);
	        }
	        schedule.push([].slice.call(arguments));
	        timeout = $timeout(function runMasonry() {
	          if (destroyed) {
	            return;
	          }
	          schedule.forEach(function scheduleForEach(args) {
	            $element.masonry.apply($element, args);
	          });
	          schedule = [];
	        }, 30);
	      };
	      function defaultLoaded($element) {
	        $element.addClass('loaded');
	      }
	      this.addBrick = function addBrick(method, element, id) {
	        if (destroyed) {
	          return;
	        }
	        function _add() {
	          if (Object.keys(bricks).length === 0) {
	            $element.masonry('resize');
	          }
	          if (bricks[id] === undefined) {
	            // Keep track of added elements.
	            bricks[id] = true;
	            defaultLoaded(element);
	            $element.masonry(method, element, true);
	          }
	        }
	        function _layout() {
	          // I wanted to make this dynamic but ran into huuuge memory leaks
	          // that I couldn't fix. If you know how to dynamically add a
	          // callback so one could say <masonry loaded="callback($element)">
	          // please submit a pull request!
	          self.scheduleMasonryOnce('layout');
	        }
	        if (!self.loadImages) {
	          _add();
	          _layout();
	        } else if (self.preserveOrder) {
	          _add();
	          element.imagesLoaded(_layout);
	        } else {
	          element.imagesLoaded(function imagesLoaded() {
	            _add();
	            _layout();
	          });
	        }
	      };
	      this.removeBrick = function removeBrick(id, element) {
	        if (destroyed) {
	          return;
	        }
	        delete bricks[id];
	        $element.masonry('remove', element);
	        this.scheduleMasonryOnce('layout');
	      };
	      this.destroy = function destroy() {
	        destroyed = true;
	        if ($element.data('masonry')) {
	          // Gently uninitialize if still present
	          $element.masonry('destroy');
	        }
	        $scope.$emit('masonry.destroyed');
	        bricks = {};
	      };
	      this.reload = function reload() {
	        $element.masonry();
	        $scope.$emit('masonry.reloaded');
	      };
	    }
	  ]).directive('masonry', function masonryDirective() {
	    return {
	      restrict: 'AE',
	      controller: 'MasonryCtrl',
	      link: {
	        pre: function preLink(scope, element, attrs, ctrl) {
	          var attrOptions = scope.$eval(attrs.masonry || attrs.masonryOptions);
	          var options = angular.extend({
	              itemSelector: attrs.itemSelector || '.masonry-brick',
	              columnWidth: parseInt(attrs.columnWidth, 10) || attrs.columnWidth
	            }, attrOptions || {});
	          element.masonry(options);
	          scope.masonryContainer = element[0];
	          var loadImages = scope.$eval(attrs.loadImages);
	          ctrl.loadImages = loadImages !== false;
	          var preserveOrder = scope.$eval(attrs.preserveOrder);
	          ctrl.preserveOrder = preserveOrder !== false && attrs.preserveOrder !== undefined;
	          var reloadOnShow = scope.$eval(attrs.reloadOnShow);
	          if (reloadOnShow !== false && attrs.reloadOnShow !== undefined) {
	            scope.$watch(function () {
	              return element.prop('offsetParent');
	            }, function (isVisible, wasVisible) {
	              if (isVisible && !wasVisible) {
	                ctrl.reload();
	              }
	            });
	          }
	          var reloadOnResize = scope.$eval(attrs.reloadOnResize);
	          if (reloadOnResize !== false && attrs.reloadOnResize !== undefined) {
	            scope.$watch('masonryContainer.offsetWidth', function (newWidth, oldWidth) {
	              if (newWidth != oldWidth) {
	                ctrl.reload();
	              }
	            });
	          }
	          scope.$emit('masonry.created', element);
	          scope.$on('$destroy', ctrl.destroy);
	        }
	      }
	    };
	  }).directive('masonryBrick', function masonryBrickDirective() {
	    return {
	      restrict: 'AC',
	      require: '^masonry',
	      scope: true,
	      link: {
	        pre: function preLink(scope, element, attrs, ctrl) {
	          var id = scope.$id, index;
	          var prependBrick = scope.$eval(attrs.prepend);
	          var method = prependBrick ? 'prepended' : 'appended';
	          ctrl.addBrick(method, element, id);
	          element.on('$destroy', function () {
	            ctrl.removeBrick(id, element);
	          });
	          scope.$on('masonry.reload', function () {
	            ctrl.scheduleMasonryOnce('reloadItems');
	            ctrl.scheduleMasonryOnce('layout');
	          });
	          scope.$watch('$index', function () {
	            if (index !== undefined && index !== scope.$index) {
	              ctrl.scheduleMasonryOnce('reloadItems');
	              ctrl.scheduleMasonryOnce('layout');
	            }
	            index = scope.$index;
	          });
	        }
	      }
	    };
	  });
	}());

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1481);
	module.exports = __webpack_require__(1482);

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! pdfmake v0.1.36, @license MIT, @link http://pdfmake.org */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 122);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function isString(variable) {
		return typeof variable === 'string' || variable instanceof String;
	}
	
	function isNumber(variable) {
		return typeof variable === 'number' || variable instanceof Number;
	}
	
	function isBoolean(variable) {
		return typeof variable === 'boolean';
	}
	
	function isArray(variable) {
		return Array.isArray(variable);
	}
	
	function isFunction(variable) {
		return typeof variable === 'function';
	}
	
	function isObject(variable) {
		return variable !== null && typeof variable === 'object';
	}
	
	function isNull(variable) {
		return variable === null;
	}
	
	function isUndefined(variable) {
		return variable === undefined;
	}
	
	function pack() {
		var result = {};
	
		for (var i = 0, l = arguments.length; i < l; i++) {
			var obj = arguments[i];
	
			if (obj) {
				for (var key in obj) {
					if (obj.hasOwnProperty(key)) {
						result[key] = obj[key];
					}
				}
			}
		}
	
		return result;
	}
	
	function offsetVector(vector, x, y) {
		switch (vector.type) {
			case 'ellipse':
			case 'rect':
				vector.x += x;
				vector.y += y;
				break;
			case 'line':
				vector.x1 += x;
				vector.x2 += x;
				vector.y1 += y;
				vector.y2 += y;
				break;
			case 'polyline':
				for (var i = 0, l = vector.points.length; i < l; i++) {
					vector.points[i].x += x;
					vector.points[i].y += y;
				}
				break;
		}
	}
	
	function fontStringify(key, val) {
		if (key === 'font') {
			return 'font';
		}
		return val;
	}
	
	module.exports = {
		isString: isString,
		isNumber: isNumber,
		isBoolean: isBoolean,
		isArray: isArray,
		isFunction: isFunction,
		isObject: isObject,
		isNull: isNull,
		isUndefined: isUndefined,
		pack: pack,
		fontStringify: fontStringify,
		offsetVector: offsetVector
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	
	
	var base64 = __webpack_require__(124)
	var ieee754 = __webpack_require__(125)
	var isArray = __webpack_require__(76)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(10);
	var core = __webpack_require__(2);
	var ctx = __webpack_require__(20);
	var hide = __webpack_require__(13);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var store = __webpack_require__(65)('wks');
	var uid = __webpack_require__(38);
	var Symbol = __webpack_require__(10).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(19)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(14);
	var IE8_DOM_DEFINE = __webpack_require__(95);
	var toPrimitive = __webpack_require__(58);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(Buffer, __dirname) {
	
	function VirtualFileSystem() {
		this.fileSystem = {};
		this.baseSystem = {};
	}
	
	VirtualFileSystem.prototype.readFileSync = function (filename) {
		filename = fixFilename(filename);
	
		var base64content = this.baseSystem[filename];
		if (base64content) {
			return new Buffer(base64content, 'base64');
		}
	
		var content = this.fileSystem[filename];
		if (content) {
			return content;
		}
	
		throw 'File \'' + filename + '\' not found in virtual file system';
	};
	
	VirtualFileSystem.prototype.writeFileSync = function (filename, content) {
		this.fileSystem[fixFilename(filename)] = content;
	};
	
	VirtualFileSystem.prototype.bindFS = function (data) {
		this.baseSystem = data || {};
	};
	
	
	function fixFilename(filename) {
		if (filename.indexOf(__dirname) === 0) {
			filename = filename.substring(__dirname.length);
		}
	
		if (filename.indexOf('/') === 0) {
			filename = filename.substring(1);
		}
	
		return filename;
	}
	
	module.exports = new VirtualFileSystem();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, "/"))
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var NumberT, PropertyDescriptor;
	
	  NumberT = __webpack_require__(22).Number;
	
	  exports.resolveLength = function(length, stream, parent) {
	    var res;
	    if (typeof length === 'number') {
	      res = length;
	    } else if (typeof length === 'function') {
	      res = length.call(parent, parent);
	    } else if (parent && typeof length === 'string') {
	      res = parent[length];
	    } else if (stream && length instanceof NumberT) {
	      res = length.decode(stream);
	    }
	    if (isNaN(res)) {
	      throw new Error('Not a fixed size');
	    }
	    return res;
	  };
	
	  PropertyDescriptor = (function() {
	    function PropertyDescriptor(opts) {
	      var key, val;
	      if (opts == null) {
	        opts = {};
	      }
	      this.enumerable = true;
	      this.configurable = true;
	      for (key in opts) {
	        val = opts[key];
	        this[key] = val;
	      }
	    }
	
	    return PropertyDescriptor;
	
	  })();
	
	  exports.PropertyDescriptor = PropertyDescriptor;
	
	}).call(this);
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__(6);
	var createDesc = __webpack_require__(27);
	module.exports = __webpack_require__(5) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(9);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(31).EventEmitter;
	var inherits = __webpack_require__(21);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(45);
	Stream.Writable = __webpack_require__(146);
	Stream.Duplex = __webpack_require__(147);
	Stream.Transform = __webpack_require__(148);
	Stream.PassThrough = __webpack_require__(149);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(32).nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(25);
	util.inherits = __webpack_require__(21);
	/*</replacement>*/
	
	var Readable = __webpack_require__(83);
	var Writable = __webpack_require__(46);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  processNextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(54);
	var defined = __webpack_require__(56);
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// optional / simple context binding
	var aFunction = __webpack_require__(97);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var DecodeStream, Fixed, NumberT,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  DecodeStream = __webpack_require__(51);
	
	  NumberT = (function() {
	    function NumberT(type, endian) {
	      this.type = type;
	      this.endian = endian != null ? endian : 'BE';
	      this.fn = this.type;
	      if (this.type[this.type.length - 1] !== '8') {
	        this.fn += this.endian;
	      }
	    }
	
	    NumberT.prototype.size = function() {
	      return DecodeStream.TYPES[this.type];
	    };
	
	    NumberT.prototype.decode = function(stream) {
	      return stream['read' + this.fn]();
	    };
	
	    NumberT.prototype.encode = function(stream, val) {
	      return stream['write' + this.fn](val);
	    };
	
	    return NumberT;
	
	  })();
	
	  exports.Number = NumberT;
	
	  exports.uint8 = new NumberT('UInt8');
	
	  exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');
	
	  exports.uint16le = new NumberT('UInt16', 'LE');
	
	  exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');
	
	  exports.uint24le = new NumberT('UInt24', 'LE');
	
	  exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');
	
	  exports.uint32le = new NumberT('UInt32', 'LE');
	
	  exports.int8 = new NumberT('Int8');
	
	  exports.int16be = exports.int16 = new NumberT('Int16', 'BE');
	
	  exports.int16le = new NumberT('Int16', 'LE');
	
	  exports.int24be = exports.int24 = new NumberT('Int24', 'BE');
	
	  exports.int24le = new NumberT('Int24', 'LE');
	
	  exports.int32be = exports.int32 = new NumberT('Int32', 'BE');
	
	  exports.int32le = new NumberT('Int32', 'LE');
	
	  exports.floatbe = exports.float = new NumberT('Float', 'BE');
	
	  exports.floatle = new NumberT('Float', 'LE');
	
	  exports.doublebe = exports.double = new NumberT('Double', 'BE');
	
	  exports.doublele = new NumberT('Double', 'LE');
	
	  Fixed = (function(_super) {
	    __extends(Fixed, _super);
	
	    function Fixed(size, endian, fracBits) {
	      if (fracBits == null) {
	        fracBits = size >> 1;
	      }
	      Fixed.__super__.constructor.call(this, "Int" + size, endian);
	      this._point = 1 << fracBits;
	    }
	
	    Fixed.prototype.decode = function(stream) {
	      return Fixed.__super__.decode.call(this, stream) / this._point;
	    };
	
	    Fixed.prototype.encode = function(stream, val) {
	      return Fixed.__super__.encode.call(this, stream, val * this._point | 0);
	    };
	
	    return Fixed;
	
	  })(NumberT);
	
	  exports.Fixed = Fixed;
	
	  exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');
	
	  exports.fixed16le = new Fixed(16, 'LE');
	
	  exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');
	
	  exports.fixed32le = new Fixed(32, 'LE');
	
	}).call(this);
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {
	
	module.exports = {};
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $at = __webpack_require__(207)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(61)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	
	/*
	PDFObject - converts JavaScript types into their corrisponding PDF types.
	By Devon Govett
	 */
	
	(function() {
	  var PDFObject, PDFReference;
	
	  PDFObject = (function() {
	    var escapable, escapableRe, pad, swapBytes;
	
	    function PDFObject() {}
	
	    pad = function(str, length) {
	      return (Array(length + 1).join('0') + str).slice(-length);
	    };
	
	    escapableRe = /[\n\r\t\b\f\(\)\\]/g;
	
	    escapable = {
	      '\n': '\\n',
	      '\r': '\\r',
	      '\t': '\\t',
	      '\b': '\\b',
	      '\f': '\\f',
	      '\\': '\\\\',
	      '(': '\\(',
	      ')': '\\)'
	    };
	
	    swapBytes = function(buff) {
	      var a, i, j, l, ref;
	      l = buff.length;
	      if (l & 0x01) {
	        throw new Error("Buffer length must be even");
	      } else {
	        for (i = j = 0, ref = l - 1; j < ref; i = j += 2) {
	          a = buff[i];
	          buff[i] = buff[i + 1];
	          buff[i + 1] = a;
	        }
	      }
	      return buff;
	    };
	
	    PDFObject.convert = function(object) {
	      var e, i, isUnicode, items, j, key, out, ref, string, val;
	      if (typeof object === 'string') {
	        return '/' + object;
	      } else if (object instanceof String) {
	        string = object;
	        isUnicode = false;
	        for (i = j = 0, ref = string.length; j < ref; i = j += 1) {
	          if (string.charCodeAt(i) > 0x7f) {
	            isUnicode = true;
	            break;
	          }
	        }
	        if (isUnicode) {
	          string = swapBytes(new Buffer('\ufeff' + string, 'utf16le')).toString('binary');
	        }
	        string = string.replace(escapableRe, function(c) {
	          return escapable[c];
	        });
	        return '(' + string + ')';
	      } else if (Buffer.isBuffer(object)) {
	        return '<' + object.toString('hex') + '>';
	      } else if (object instanceof PDFReference) {
	        return object.toString();
	      } else if (object instanceof Date) {
	        return '(D:' + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + 'Z)';
	      } else if (Array.isArray(object)) {
	        items = ((function() {
	          var k, len, results;
	          results = [];
	          for (k = 0, len = object.length; k < len; k++) {
	            e = object[k];
	            results.push(PDFObject.convert(e));
	          }
	          return results;
	        })()).join(' ');
	        return '[' + items + ']';
	      } else if ({}.toString.call(object) === '[object Object]') {
	        out = ['<<'];
	        for (key in object) {
	          val = object[key];
	          out.push('/' + key + ' ' + PDFObject.convert(val));
	        }
	        out.push('>>');
	        return out.join('\n');
	      } else if (typeof object === 'number') {
	        return PDFObject.number(object);
	      } else {
	        return '' + object;
	      }
	    };
	
	    PDFObject.number = function(n) {
	      if (n > -1e21 && n < 1e21) {
	        return Math.round(n * 1e6) / 1e6;
	      }
	      throw new Error("unsupported number: " + n);
	    };
	
	    return PDFObject;
	
	  })();
	
	  module.exports = PDFObject;
	
	  PDFReference = __webpack_require__(87);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(201);
	var global = __webpack_require__(10);
	var hide = __webpack_require__(13);
	var Iterators = __webpack_require__(23);
	var TO_STRING_TAG = __webpack_require__(4)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(101);
	var enumBugKeys = __webpack_require__(66);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(56);
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports) {
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(1)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);
	
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	exports.f = {}.propertyIsEnumerable;
	
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(14);
	var dPs = __webpack_require__(100);
	var enumBugKeys = __webpack_require__(66);
	var IE_PROTO = __webpack_require__(64)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(96)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(205).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(63);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports) {
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var def = __webpack_require__(6).f;
	var has = __webpack_require__(18);
	var TAG = __webpack_require__(4)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};
	
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var META = __webpack_require__(38)('meta');
	var isObject = __webpack_require__(9);
	var has = __webpack_require__(18);
	var setDesc = __webpack_require__(6).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(19)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var ctx = __webpack_require__(20);
	var call = __webpack_require__(111);
	var isArrayIter = __webpack_require__(112);
	var anObject = __webpack_require__(14);
	var toLength = __webpack_require__(37);
	var getIterFn = __webpack_require__(67);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;
	
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var isString = __webpack_require__(0).isString;
	var isNumber = __webpack_require__(0).isNumber;
	var isObject = __webpack_require__(0).isObject;
	var isArray = __webpack_require__(0).isArray;
	var LineBreaker = __webpack_require__(78);
	
	var LEADING = /^(\s)+/g;
	var TRAILING = /(\s)+$/g;
	
	/**
	 * Creates an instance of TextTools - text measurement utility
	 *
	 * @constructor
	 * @param {FontProvider} fontProvider
	 */
	function TextTools(fontProvider) {
		this.fontProvider = fontProvider;
	}
	
	/**
	 * Converts an array of strings (or inline-definition-objects) into a collection
	 * of inlines and calculated minWidth/maxWidth.
	 * and their min/max widths
	 * @param  {Object} textArray - an array of inline-definition-objects (or strings)
	 * @param  {Object} styleContextStack current style stack
	 * @return {Object}                   collection of inlines, minWidth, maxWidth
	 */
	TextTools.prototype.buildInlines = function (textArray, styleContextStack) {
		var measured = measure(this.fontProvider, textArray, styleContextStack);
	
		var minWidth = 0,
			maxWidth = 0,
			currentLineWidth;
	
		measured.forEach(function (inline) {
			minWidth = Math.max(minWidth, inline.width - inline.leadingCut - inline.trailingCut);
	
			if (!currentLineWidth) {
				currentLineWidth = {width: 0, leadingCut: inline.leadingCut, trailingCut: 0};
			}
	
			currentLineWidth.width += inline.width;
			currentLineWidth.trailingCut = inline.trailingCut;
	
			maxWidth = Math.max(maxWidth, getTrimmedWidth(currentLineWidth));
	
			if (inline.lineEnd) {
				currentLineWidth = null;
			}
		});
	
		if (getStyleProperty({}, styleContextStack, 'noWrap', false)) {
			minWidth = maxWidth;
		}
	
		return {
			items: measured,
			minWidth: minWidth,
			maxWidth: maxWidth
		};
	
		function getTrimmedWidth(item) {
			return Math.max(0, item.width - item.leadingCut - item.trailingCut);
		}
	};
	
	/**
	 * Returns size of the specified string (without breaking it) using the current style
	 * @param  {String} text              text to be measured
	 * @param  {Object} styleContextStack current style stack
	 * @return {Object}                   size of the specified string
	 */
	TextTools.prototype.sizeOfString = function (text, styleContextStack) {
		text = text ? text.toString().replace(/\t/g, '    ') : '';
	
		//TODO: refactor - extract from measure
		var fontName = getStyleProperty({}, styleContextStack, 'font', 'Roboto');
		var fontSize = getStyleProperty({}, styleContextStack, 'fontSize', 12);
		var fontFeatures = getStyleProperty({}, styleContextStack, 'fontFeatures', null);
		var bold = getStyleProperty({}, styleContextStack, 'bold', false);
		var italics = getStyleProperty({}, styleContextStack, 'italics', false);
		var lineHeight = getStyleProperty({}, styleContextStack, 'lineHeight', 1);
		var characterSpacing = getStyleProperty({}, styleContextStack, 'characterSpacing', 0);
	
		var font = this.fontProvider.provideFont(fontName, bold, italics);
	
		return {
			width: widthOfString(text, font, fontSize, characterSpacing, fontFeatures),
			height: font.lineHeight(fontSize) * lineHeight,
			fontSize: fontSize,
			lineHeight: lineHeight,
			ascender: font.ascender / 1000 * fontSize,
			descender: font.descender / 1000 * fontSize
		};
	};
	
	TextTools.prototype.widthOfString = function (text, font, fontSize, characterSpacing, fontFeatures) {
		return widthOfString(text, font, fontSize, characterSpacing, fontFeatures);
	};
	
	function splitWords(text, noWrap) {
		var results = [];
		text = text.replace(/\t/g, '    ');
	
		if (noWrap) {
			results.push({text: text});
			return results;
		}
	
		var breaker = new LineBreaker(text);
		var last = 0;
		var bk;
	
		while (bk = breaker.nextBreak()) {
			var word = text.slice(last, bk.position);
	
			if (bk.required || word.match(/\r?\n$|\r$/)) { // new line
				word = word.replace(/\r?\n$|\r$/, '');
				results.push({text: word, lineEnd: true});
			} else {
				results.push({text: word});
			}
	
			last = bk.position;
		}
	
		return results;
	}
	
	function copyStyle(source, destination) {
		destination = destination || {};
		source = source || {}; //TODO: default style
	
		for (var key in source) {
			if (key != 'text' && source.hasOwnProperty(key)) {
				destination[key] = source[key];
			}
		}
	
		return destination;
	}
	
	function normalizeTextArray(array, styleContextStack) {
		function flatten(array) {
			return array.reduce(function (prev, cur) {
				var current = isArray(cur.text) ? flatten(cur.text) : cur;
				var more = [].concat(current).some(Array.isArray);
				return prev.concat(more ? flatten(current) : current);
			}, []);
		}
	
		var results = [];
	
		if (!isArray(array)) {
			array = [array];
		}
	
		array = flatten(array);
	
		for (var i = 0, l = array.length; i < l; i++) {
			var item = array[i];
			var style = null;
			var words;
	
			var noWrap = getStyleProperty(item || {}, styleContextStack, 'noWrap', false);
			if (isObject(item)) {
				words = splitWords(normalizeString(item.text), noWrap);
				style = copyStyle(item);
			} else {
				words = splitWords(normalizeString(item), noWrap);
			}
	
			for (var i2 = 0, l2 = words.length; i2 < l2; i2++) {
				var result = {
					text: words[i2].text
				};
	
				if (words[i2].lineEnd) {
					result.lineEnd = true;
				}
	
				copyStyle(style, result);
	
				results.push(result);
			}
		}
	
		return results;
	}
	
	function normalizeString(value) {
		if (value === undefined || value === null) {
			return '';
		} else if (isNumber(value)) {
			return value.toString();
		} else if (isString(value)) {
			return value;
		} else {
			return value.toString();
		}
	}
	
	function getStyleProperty(item, styleContextStack, property, defaultValue) {
		var value;
	
		if (item[property] !== undefined && item[property] !== null) {
			// item defines this property
			return item[property];
		}
	
		if (!styleContextStack) {
			return defaultValue;
		}
	
		styleContextStack.auto(item, function () {
			value = styleContextStack.getProperty(property);
		});
	
		if (value !== null && value !== undefined) {
			return value;
		} else {
			return defaultValue;
		}
	}
	
	function measure(fontProvider, textArray, styleContextStack) {
		var normalized = normalizeTextArray(textArray, styleContextStack);
	
		if (normalized.length) {
			var leadingIndent = getStyleProperty(normalized[0], styleContextStack, 'leadingIndent', 0);
	
			if (leadingIndent) {
				normalized[0].leadingCut = -leadingIndent;
				normalized[0].leadingIndent = leadingIndent;
			}
		}
	
		normalized.forEach(function (item) {
			var fontName = getStyleProperty(item, styleContextStack, 'font', 'Roboto');
			var fontSize = getStyleProperty(item, styleContextStack, 'fontSize', 12);
			var fontFeatures = getStyleProperty(item, styleContextStack, 'fontFeatures', null);
			var bold = getStyleProperty(item, styleContextStack, 'bold', false);
			var italics = getStyleProperty(item, styleContextStack, 'italics', false);
			var color = getStyleProperty(item, styleContextStack, 'color', 'black');
			var decoration = getStyleProperty(item, styleContextStack, 'decoration', null);
			var decorationColor = getStyleProperty(item, styleContextStack, 'decorationColor', null);
			var decorationStyle = getStyleProperty(item, styleContextStack, 'decorationStyle', null);
			var background = getStyleProperty(item, styleContextStack, 'background', null);
			var lineHeight = getStyleProperty(item, styleContextStack, 'lineHeight', 1);
			var characterSpacing = getStyleProperty(item, styleContextStack, 'characterSpacing', 0);
			var link = getStyleProperty(item, styleContextStack, 'link', null);
			var linkToPage = getStyleProperty(item, styleContextStack, 'linkToPage', null);
			var noWrap = getStyleProperty(item, styleContextStack, 'noWrap', null);
			var preserveLeadingSpaces = getStyleProperty(item, styleContextStack, 'preserveLeadingSpaces', false);
	
			var font = fontProvider.provideFont(fontName, bold, italics);
	
			item.width = widthOfString(item.text, font, fontSize, characterSpacing, fontFeatures);
			item.height = font.lineHeight(fontSize) * lineHeight;
	
			var leadingSpaces = item.text.match(LEADING);
	
			if (!item.leadingCut) {
				item.leadingCut = 0;
			}
	
			if (leadingSpaces && !preserveLeadingSpaces) {
				item.leadingCut += widthOfString(leadingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
			}
	
			var trailingSpaces = item.text.match(TRAILING);
			if (trailingSpaces) {
				item.trailingCut = widthOfString(trailingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
			} else {
				item.trailingCut = 0;
			}
	
			item.alignment = getStyleProperty(item, styleContextStack, 'alignment', 'left');
			item.font = font;
			item.fontSize = fontSize;
			item.fontFeatures = fontFeatures;
			item.characterSpacing = characterSpacing;
			item.color = color;
			item.decoration = decoration;
			item.decorationColor = decorationColor;
			item.decorationStyle = decorationStyle;
			item.background = background;
			item.link = link;
			item.linkToPage = linkToPage;
			item.noWrap = noWrap;
		});
	
		return normalized;
	}
	
	function widthOfString(text, font, fontSize, characterSpacing, fontFeatures) {
		return font.widthOfString(text, fontSize, fontFeatures) + ((characterSpacing || 0) * (text.length - 1));
	}
	
	module.exports = TextTools;
	
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	var UnicodeTrie, inflate;
	
	inflate = __webpack_require__(79);
	
	UnicodeTrie = (function() {
	  var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;
	
	  SHIFT_1 = 6 + 5;
	
	  SHIFT_2 = 5;
	
	  SHIFT_1_2 = SHIFT_1 - SHIFT_2;
	
	  OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
	
	  INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
	
	  INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
	
	  INDEX_SHIFT = 2;
	
	  DATA_BLOCK_LENGTH = 1 << SHIFT_2;
	
	  DATA_MASK = DATA_BLOCK_LENGTH - 1;
	
	  LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
	
	  LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
	
	  INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
	
	  UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
	
	  UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6;
	
	  INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
	
	  DATA_GRANULARITY = 1 << INDEX_SHIFT;
	
	  function UnicodeTrie(data) {
	    var isBuffer, uncompressedLength, view;
	    isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
	    if (isBuffer || data instanceof Uint8Array) {
	      if (isBuffer) {
	        this.highStart = data.readUInt32BE(0);
	        this.errorValue = data.readUInt32BE(4);
	        uncompressedLength = data.readUInt32BE(8);
	        data = data.slice(12);
	      } else {
	        view = new DataView(data.buffer);
	        this.highStart = view.getUint32(0);
	        this.errorValue = view.getUint32(4);
	        uncompressedLength = view.getUint32(8);
	        data = data.subarray(12);
	      }
	      data = inflate(data, new Uint8Array(uncompressedLength));
	      data = inflate(data, new Uint8Array(uncompressedLength));
	      this.data = new Uint32Array(data.buffer);
	    } else {
	      this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
	    }
	  }
	
	  UnicodeTrie.prototype.get = function(codePoint) {
	    var index;
	    if (codePoint < 0 || codePoint > 0x10ffff) {
	      return this.errorValue;
	    }
	    if (codePoint < 0xd800 || (codePoint > 0xdbff && codePoint <= 0xffff)) {
	      index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
	      return this.data[index];
	    }
	    if (codePoint <= 0xffff) {
	      index = (this.data[LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
	      return this.data[index];
	    }
	    if (codePoint < this.highStart) {
	      index = this.data[(INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH) + (codePoint >> SHIFT_1)];
	      index = this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
	      index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
	      return this.data[index];
	    }
	    return this.data[this.data.length - DATA_GRANULARITY];
	  };
	
	  return UnicodeTrie;
	
	})();
	
	module.exports = UnicodeTrie;
	
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var isString = __webpack_require__(0).isString;
	
	function buildColumnWidths(columns, availableWidth) {
		var autoColumns = [],
			autoMin = 0, autoMax = 0,
			starColumns = [],
			starMaxMin = 0,
			starMaxMax = 0,
			fixedColumns = [],
			initial_availableWidth = availableWidth;
	
		columns.forEach(function (column) {
			if (isAutoColumn(column)) {
				autoColumns.push(column);
				autoMin += column._minWidth;
				autoMax += column._maxWidth;
			} else if (isStarColumn(column)) {
				starColumns.push(column);
				starMaxMin = Math.max(starMaxMin, column._minWidth);
				starMaxMax = Math.max(starMaxMax, column._maxWidth);
			} else {
				fixedColumns.push(column);
			}
		});
	
		fixedColumns.forEach(function (col) {
			// width specified as %
			if (isString(col.width) && /\d+%/.test(col.width)) {
				col.width = parseFloat(col.width) * initial_availableWidth / 100;
			}
			if (col.width < (col._minWidth) && col.elasticWidth) {
				col._calcWidth = col._minWidth;
			} else {
				col._calcWidth = col.width;
			}
	
			availableWidth -= col._calcWidth;
		});
	
		// http://www.freesoft.org/CIE/RFC/1942/18.htm
		// http://www.w3.org/TR/CSS2/tables.html#width-layout
		// http://dev.w3.org/csswg/css3-tables-algorithms/Overview.src.htm
		var minW = autoMin + starMaxMin * starColumns.length;
		var maxW = autoMax + starMaxMax * starColumns.length;
		if (minW >= availableWidth) {
			// case 1 - there's no way to fit all columns within available width
			// that's actually pretty bad situation with PDF as we have no horizontal scroll
			// no easy workaround (unless we decide, in the future, to split single words)
			// currently we simply use minWidths for all columns
			autoColumns.forEach(function (col) {
				col._calcWidth = col._minWidth;
			});
	
			starColumns.forEach(function (col) {
				col._calcWidth = starMaxMin; // starMaxMin already contains padding
			});
		} else {
			if (maxW < availableWidth) {
				// case 2 - we can fit rest of the table within available space
				autoColumns.forEach(function (col) {
					col._calcWidth = col._maxWidth;
					availableWidth -= col._calcWidth;
				});
			} else {
				// maxW is too large, but minW fits within available width
				var W = availableWidth - minW;
				var D = maxW - minW;
	
				autoColumns.forEach(function (col) {
					var d = col._maxWidth - col._minWidth;
					col._calcWidth = col._minWidth + d * W / D;
					availableWidth -= col._calcWidth;
				});
			}
	
			if (starColumns.length > 0) {
				var starSize = availableWidth / starColumns.length;
	
				starColumns.forEach(function (col) {
					col._calcWidth = starSize;
				});
			}
		}
	}
	
	function isAutoColumn(column) {
		return column.width === 'auto';
	}
	
	function isStarColumn(column) {
		return column.width === null || column.width === undefined || column.width === '*' || column.width === 'star';
	}
	
	//TODO: refactor and reuse in measureTable
	function measureMinMax(columns) {
		var result = {min: 0, max: 0};
	
		var maxStar = {min: 0, max: 0};
		var starCount = 0;
	
		for (var i = 0, l = columns.length; i < l; i++) {
			var c = columns[i];
	
			if (isStarColumn(c)) {
				maxStar.min = Math.max(maxStar.min, c._minWidth);
				maxStar.max = Math.max(maxStar.max, c._maxWidth);
				starCount++;
			} else if (isAutoColumn(c)) {
				result.min += c._minWidth;
				result.max += c._maxWidth;
			} else {
				result.min += ((c.width !== undefined && c.width) || c._minWidth);
				result.max += ((c.width !== undefined && c.width) || c._maxWidth);
			}
		}
	
		if (starCount) {
			result.min += starCount * maxStar.min;
			result.max += starCount * maxStar.max;
		}
	
		return result;
	}
	
	/**
	 * Calculates column widths
	 * @private
	 */
	module.exports = {
		buildColumnWidths: buildColumnWidths,
		measureMinMax: measureMinMax,
		isAutoColumn: isAutoColumn,
		isStarColumn: isStarColumn
	};
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	exports = module.exports = __webpack_require__(83);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(46);
	exports.Duplex = __webpack_require__(16);
	exports.Transform = __webpack_require__(86);
	exports.PassThrough = __webpack_require__(145);
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(32).nextTick;
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(25);
	util.inherits = __webpack_require__(21);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(144)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(84);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(33).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(85);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(16);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(16);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(142).setImmediate, __webpack_require__(7)))
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Buffer = __webpack_require__(33).Buffer;
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	var Buffer = __webpack_require__(1).Buffer;
	var Transform = __webpack_require__(15).Transform;
	var binding = __webpack_require__(150);
	var util = __webpack_require__(49);
	var assert = __webpack_require__(88).ok;
	var kMaxLength = __webpack_require__(1).kMaxLength;
	var kRangeErrorMessage = 'Cannot create final Buffer. It would be larger ' + 'than 0x' + kMaxLength.toString(16) + ' bytes';
	
	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;
	
	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = 16 * 1024;
	
	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;
	
	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
	
	// expose all the zlib constants
	var bkeys = Object.keys(binding);
	for (var bk = 0; bk < bkeys.length; bk++) {
	  var bkey = bkeys[bk];
	  if (bkey.match(/^Z/)) {
	    Object.defineProperty(exports, bkey, {
	      enumerable: true, value: binding[bkey], writable: false
	    });
	  }
	}
	
	// translation table for return codes.
	var codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};
	
	var ckeys = Object.keys(codes);
	for (var ck = 0; ck < ckeys.length; ck++) {
	  var ckey = ckeys[ck];
	  codes[codes[ckey]] = ckey;
	}
	
	Object.defineProperty(exports, 'codes', {
	  enumerable: true, value: Object.freeze(codes), writable: false
	});
	
	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;
	
	exports.createDeflate = function (o) {
	  return new Deflate(o);
	};
	
	exports.createInflate = function (o) {
	  return new Inflate(o);
	};
	
	exports.createDeflateRaw = function (o) {
	  return new DeflateRaw(o);
	};
	
	exports.createInflateRaw = function (o) {
	  return new InflateRaw(o);
	};
	
	exports.createGzip = function (o) {
	  return new Gzip(o);
	};
	
	exports.createGunzip = function (o) {
	  return new Gunzip(o);
	};
	
	exports.createUnzip = function (o) {
	  return new Unzip(o);
	};
	
	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function (buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};
	
	exports.deflateSync = function (buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};
	
	exports.gzip = function (buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};
	
	exports.gzipSync = function (buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};
	
	exports.deflateRaw = function (buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};
	
	exports.deflateRawSync = function (buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};
	
	exports.unzip = function (buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};
	
	exports.unzipSync = function (buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};
	
	exports.inflate = function (buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};
	
	exports.inflateSync = function (buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};
	
	exports.gunzip = function (buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};
	
	exports.gunzipSync = function (buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};
	
	exports.inflateRaw = function (buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};
	
	exports.inflateRawSync = function (buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};
	
	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;
	
	  engine.on('error', onError);
	  engine.on('end', onEnd);
	
	  engine.end(buffer);
	  flow();
	
	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }
	
	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }
	
	  function onEnd() {
	    var buf;
	    var err = null;
	
	    if (nread >= kMaxLength) {
	      err = new RangeError(kRangeErrorMessage);
	    } else {
	      buf = Buffer.concat(buffers, nread);
	    }
	
	    buffers = [];
	    engine.close();
	    callback(err, buf);
	  }
	}
	
	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string') buffer = Buffer.from(buffer);
	
	  if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
	
	  var flushFlag = engine._finishFlushFlag;
	
	  return engine._processChunk(buffer, flushFlag);
	}
	
	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}
	
	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}
	
	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}
	
	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}
	
	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}
	
	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}
	
	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}
	
	function isValidFlushFlag(flag) {
	  return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
	}
	
	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.
	
	function Zlib(opts, mode) {
	  var _this = this;
	
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
	
	  Transform.call(this, opts);
	
	  if (opts.flush && !isValidFlushFlag(opts.flush)) {
	    throw new Error('Invalid flush flag: ' + opts.flush);
	  }
	  if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
	    throw new Error('Invalid flush flag: ' + opts.finishFlush);
	  }
	
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
	  this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;
	
	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }
	
	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }
	
	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }
	
	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }
	
	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }
	
	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }
	
	  this._handle = new binding.Zlib(mode);
	
	  var self = this;
	  this._hadError = false;
	  this._handle.onerror = function (message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    _close(self);
	    self._hadError = true;
	
	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };
	
	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;
	
	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;
	
	  this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
	
	  this._buffer = Buffer.allocUnsafe(this._chunkSize);
	  this._offset = 0;
	  this._level = level;
	  this._strategy = strategy;
	
	  this.once('end', this.close);
	
	  Object.defineProperty(this, '_closed', {
	    get: function () {
	      return !_this._handle;
	    },
	    configurable: true,
	    enumerable: true
	  });
	}
	
	util.inherits(Zlib, Transform);
	
	Zlib.prototype.params = function (level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }
	
	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function () {
	      assert(self._handle, 'zlib binding closed');
	      self._handle.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};
	
	Zlib.prototype.reset = function () {
	  assert(this._handle, 'zlib binding closed');
	  return this._handle.reset();
	};
	
	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function (callback) {
	  this._transform(Buffer.alloc(0), '', callback);
	};
	
	Zlib.prototype.flush = function (kind, callback) {
	  var _this2 = this;
	
	  var ws = this._writableState;
	
	  if (typeof kind === 'function' || kind === undefined && !callback) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }
	
	  if (ws.ended) {
	    if (callback) process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback) this.once('end', callback);
	  } else if (ws.needDrain) {
	    if (callback) {
	      this.once('drain', function () {
	        return _this2.flush(kind, callback);
	      });
	    }
	  } else {
	    this._flushFlag = kind;
	    this.write(Buffer.alloc(0), '', callback);
	  }
	};
	
	Zlib.prototype.close = function (callback) {
	  _close(this, callback);
	  process.nextTick(emitCloseNT, this);
	};
	
	function _close(engine, callback) {
	  if (callback) process.nextTick(callback);
	
	  // Caller may invoke .close after a zlib error (which will null _handle).
	  if (!engine._handle) return;
	
	  engine._handle.close();
	  engine._handle = null;
	}
	
	function emitCloseNT(self) {
	  self.emit('close');
	}
	
	Zlib.prototype._transform = function (chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);
	
	  if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
	
	  if (!this._handle) return cb(new Error('zlib binding closed'));
	
	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
	  // (or whatever flag was provided using opts.finishFlush).
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last) flushFlag = this._finishFlushFlag;else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }
	
	  this._processChunk(chunk, flushFlag, cb);
	};
	
	Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;
	
	  var self = this;
	
	  var async = typeof cb === 'function';
	
	  if (!async) {
	    var buffers = [];
	    var nread = 0;
	
	    var error;
	    this.on('error', function (er) {
	      error = er;
	    });
	
	    assert(this._handle, 'zlib binding closed');
	    do {
	      var res = this._handle.writeSync(flushFlag, chunk, // in
	      inOff, // in_off
	      availInBefore, // in_len
	      this._buffer, // out
	      this._offset, //out_off
	      availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));
	
	    if (this._hadError) {
	      throw error;
	    }
	
	    if (nread >= kMaxLength) {
	      _close(this);
	      throw new RangeError(kRangeErrorMessage);
	    }
	
	    var buf = Buffer.concat(buffers, nread);
	    _close(this);
	
	    return buf;
	  }
	
	  assert(this._handle, 'zlib binding closed');
	  var req = this._handle.write(flushFlag, chunk, // in
	  inOff, // in_off
	  availInBefore, // in_len
	  this._buffer, // out
	  this._offset, //out_off
	  availOutBefore); // out_len
	
	  req.buffer = chunk;
	  req.callback = callback;
	
	  function callback(availInAfter, availOutAfter) {
	    // When the callback is used in an async write, the callback's
	    // context is the `req` object that was created. The req object
	    // is === this._handle, and that's why it's important to null
	    // out the values after they are done being used. `this._handle`
	    // can stay in memory longer than the callback and buffer are needed.
	    if (this) {
	      this.buffer = null;
	      this.callback = null;
	    }
	
	    if (self._hadError) return;
	
	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');
	
	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }
	
	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = Buffer.allocUnsafe(self._chunkSize);
	    }
	
	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += availInBefore - availInAfter;
	      availInBefore = availInAfter;
	
	      if (!async) return true;
	
	      var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }
	
	    if (!async) return false;
	
	    // finished with the chunk.
	    cb();
	  }
	};
	
	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(151);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(152);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(11)))
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	(function() {
	  var EmbeddedFont, PDFFont, StandardFont, fontkit;
	
	  fontkit = __webpack_require__(167);
	
	  PDFFont = (function() {
	    PDFFont.open = function(document, src, family, id) {
	      var font;
	      if (typeof src === 'string') {
	        if (StandardFont.isStandardFont(src)) {
	          return new StandardFont(document, src, id);
	        }
	        font = fontkit.openSync(src, family);
	      } else if (Buffer.isBuffer(src)) {
	        font = fontkit.create(src, family);
	      } else if (src instanceof Uint8Array) {
	        font = fontkit.create(new Buffer(src), family);
	      } else if (src instanceof ArrayBuffer) {
	        font = fontkit.create(new Buffer(new Uint8Array(src)), family);
	      }
	      if (font == null) {
	        throw new Error('Not a supported font format or standard PDF font.');
	      }
	      return new EmbeddedFont(document, font, id);
	    };
	
	    function PDFFont() {
	      throw new Error('Cannot construct a PDFFont directly.');
	    }
	
	    PDFFont.prototype.encode = function(text) {
	      throw new Error('Must be implemented by subclasses');
	    };
	
	    PDFFont.prototype.widthOfString = function(text) {
	      throw new Error('Must be implemented by subclasses');
	    };
	
	    PDFFont.prototype.ref = function() {
	      return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
	    };
	
	    PDFFont.prototype.finalize = function() {
	      if (this.embedded || (this.dictionary == null)) {
	        return;
	      }
	      this.embed();
	      return this.embedded = true;
	    };
	
	    PDFFont.prototype.embed = function() {
	      throw new Error('Must be implemented by subclasses');
	    };
	
	    PDFFont.prototype.lineHeight = function(size, includeGap) {
	      var gap;
	      if (includeGap == null) {
	        includeGap = false;
	      }
	      gap = includeGap ? this.lineGap : 0;
	      return (this.ascender + gap - this.descender) / 1000 * size;
	    };
	
	    return PDFFont;
	
	  })();
	
	  module.exports = PDFFont;
	
	  StandardFont = __webpack_require__(292);
	
	  EmbeddedFont = __webpack_require__(294);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var DecodeStream, iconv;
	
	  try {
	    iconv = __webpack_require__(52);
	  } catch (_error) {}
	
	  DecodeStream = (function() {
	    var key;
	
	    function DecodeStream(buffer) {
	      this.buffer = buffer;
	      this.pos = 0;
	      this.length = this.buffer.length;
	    }
	
	    DecodeStream.TYPES = {
	      UInt8: 1,
	      UInt16: 2,
	      UInt24: 3,
	      UInt32: 4,
	      Int8: 1,
	      Int16: 2,
	      Int24: 3,
	      Int32: 4,
	      Float: 4,
	      Double: 8
	    };
	
	    for (key in Buffer.prototype) {
	      if (key.slice(0, 4) === 'read') {
	        (function(key) {
	          var bytes;
	          bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
	          return DecodeStream.prototype[key] = function() {
	            var ret;
	            ret = this.buffer[key](this.pos);
	            this.pos += bytes;
	            return ret;
	          };
	        })(key);
	      }
	    }
	
	    DecodeStream.prototype.readString = function(length, encoding) {
	      var buf, byte, i, _i, _ref;
	      if (encoding == null) {
	        encoding = 'ascii';
	      }
	      switch (encoding) {
	        case 'utf16le':
	        case 'ucs2':
	        case 'utf8':
	        case 'ascii':
	          return this.buffer.toString(encoding, this.pos, this.pos += length);
	        case 'utf16be':
	          buf = new Buffer(this.readBuffer(length));
	          for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
	            byte = buf[i];
	            buf[i] = buf[i + 1];
	            buf[i + 1] = byte;
	          }
	          return buf.toString('utf16le');
	        default:
	          buf = this.readBuffer(length);
	          if (iconv) {
	            try {
	              return iconv.decode(buf, encoding);
	            } catch (_error) {}
	          }
	          return buf;
	      }
	    };
	
	    DecodeStream.prototype.readBuffer = function(length) {
	      return this.buffer.slice(this.pos, this.pos += length);
	    };
	
	    DecodeStream.prototype.readUInt24BE = function() {
	      return (this.readUInt16BE() << 8) + this.readUInt8();
	    };
	
	    DecodeStream.prototype.readUInt24LE = function() {
	      return this.readUInt16LE() + (this.readUInt8() << 16);
	    };
	
	    DecodeStream.prototype.readInt24BE = function() {
	      return (this.readInt16BE() << 8) + this.readUInt8();
	    };
	
	    DecodeStream.prototype.readInt24LE = function() {
	      return this.readUInt16LE() + (this.readInt8() << 16);
	    };
	
	    return DecodeStream;
	
	  })();
	
	  module.exports = DecodeStream;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	// Some environments don't have global Buffer (e.g. React Native).
	// Solution would be installing npm modules "buffer" and "stream" explicitly.
	var Buffer = __webpack_require__(1).Buffer;
	
	var bomHandling = __webpack_require__(170),
	    iconv = module.exports;
	
	// All codecs and aliases are kept here, keyed by encoding name/alias.
	// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
	iconv.encodings = null;
	
	// Characters emitted in case of error.
	iconv.defaultCharUnicode = '�';
	iconv.defaultCharSingleByte = '?';
	
	// Public API.
	iconv.encode = function encode(str, encoding, options) {
	    str = "" + (str || ""); // Ensure string.
	
	    var encoder = iconv.getEncoder(encoding, options);
	
	    var res = encoder.write(str);
	    var trail = encoder.end();
	    
	    return (trail && trail.length > 0) ? Buffer.concat([res, trail]) : res;
	}
	
	iconv.decode = function decode(buf, encoding, options) {
	    if (typeof buf === 'string') {
	        if (!iconv.skipDecodeWarning) {
	            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
	            iconv.skipDecodeWarning = true;
	        }
	
	        buf = new Buffer("" + (buf || ""), "binary"); // Ensure buffer.
	    }
	
	    var decoder = iconv.getDecoder(encoding, options);
	
	    var res = decoder.write(buf);
	    var trail = decoder.end();
	
	    return trail ? (res + trail) : res;
	}
	
	iconv.encodingExists = function encodingExists(enc) {
	    try {
	        iconv.getCodec(enc);
	        return true;
	    } catch (e) {
	        return false;
	    }
	}
	
	// Legacy aliases to convert functions
	iconv.toEncoding = iconv.encode;
	iconv.fromEncoding = iconv.decode;
	
	// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
	iconv._codecDataCache = {};
	iconv.getCodec = function getCodec(encoding) {
	    if (!iconv.encodings)
	        iconv.encodings = __webpack_require__(171); // Lazy load all encoding definitions.
	    
	    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
	    var enc = (''+encoding).toLowerCase().replace(/[^0-9a-z]|:\d{4}$/g, "");
	
	    // Traverse iconv.encodings to find actual codec.
	    var codecOptions = {};
	    while (true) {
	        var codec = iconv._codecDataCache[enc];
	        if (codec)
	            return codec;
	
	        var codecDef = iconv.encodings[enc];
	
	        switch (typeof codecDef) {
	            case "string": // Direct alias to other encoding.
	                enc = codecDef;
	                break;
	
	            case "object": // Alias with options. Can be layered.
	                for (var key in codecDef)
	                    codecOptions[key] = codecDef[key];
	
	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;
	                
	                enc = codecDef.type;
	                break;
	
	            case "function": // Codec itself.
	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;
	
	                // The codec function must load all tables and return object with .encoder and .decoder methods.
	                // It'll be called only once (for each different options object).
	                codec = new codecDef(codecOptions, iconv);
	
	                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
	                return codec;
	
	            default:
	                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '"+enc+"')");
	        }
	    }
	}
	
	iconv.getEncoder = function getEncoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        encoder = new codec.encoder(options, codec);
	
	    if (codec.bomAware && options && options.addBOM)
	        encoder = new bomHandling.PrependBOM(encoder, options);
	
	    return encoder;
	}
	
	iconv.getDecoder = function getDecoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        decoder = new codec.decoder(options, codec);
	
	    if (codec.bomAware && !(options && options.stripBOM === false))
	        decoder = new bomHandling.StripBOM(decoder, options);
	
	    return decoder;
	}
	
	
	// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
	var nodeVer = typeof process !== 'undefined' && process.versions && process.versions.node;
	if (nodeVer) {
	
	    // Load streaming support in Node v0.10+
	    var nodeVerArr = nodeVer.split(".").map(Number);
	    if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) {
	        __webpack_require__(185)(iconv);
	    }
	
	    // Load Node primitive extensions.
	    __webpack_require__(186)(iconv);
	}
	
	if (false) {
	    console.error("iconv-lite warning: javascript files use encoding different from utf-8. See https://github.com/ashtuchkin/iconv-lite/wiki/Javascript-source-file-encodings for more info.");
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	module.exports = [["0","\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(55);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports) {
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports) {
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pIE = __webpack_require__(35);
	var createDesc = __webpack_require__(27);
	var toIObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(58);
	var has = __webpack_require__(18);
	var IE8_DOM_DEFINE = __webpack_require__(95);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(5) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(9);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3);
	var core = __webpack_require__(2);
	var fails = __webpack_require__(19);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};
	
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(200), __esModule: true };
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var LIBRARY = __webpack_require__(62);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(99);
	var hide = __webpack_require__(13);
	var has = __webpack_require__(18);
	var Iterators = __webpack_require__(23);
	var $iterCreate = __webpack_require__(203);
	var setToStringTag = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(206);
	var ITERATOR = __webpack_require__(4)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports) {
	
	module.exports = true;
	
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports) {
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var shared = __webpack_require__(65)('keys');
	var uid = __webpack_require__(38);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(10);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};
	
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports) {
	
	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var classof = __webpack_require__(68);
	var ITERATOR = __webpack_require__(4)('iterator');
	var Iterators = __webpack_require__(23);
	module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};
	
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(55);
	var TAG = __webpack_require__(4)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(103);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(216);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	exports.f = __webpack_require__(4);
	
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(10);
	var core = __webpack_require__(2);
	var LIBRARY = __webpack_require__(62);
	var wksExt = __webpack_require__(70);
	var defineProperty = __webpack_require__(6).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};
	
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports) {
	
	exports.f = Object.getOwnPropertySymbols;
	
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports) {
	
	
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(223), __esModule: true };
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(9);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};
	
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};
	
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function TraversalTracker() {
		this.events = {};
	}
	
	TraversalTracker.prototype.startTracking = function (event, callback) {
		var callbacks = this.events[event] || (this.events[event] = []);
	
		if (callbacks.indexOf(callback) < 0) {
			callbacks.push(callback);
		}
	};
	
	TraversalTracker.prototype.stopTracking = function (event, callback) {
		var callbacks = this.events[event];
	
		if (!callbacks) {
			return;
		}
	
		var index = callbacks.indexOf(callback);
		if (index >= 0) {
			callbacks.splice(index, 1);
		}
	};
	
	TraversalTracker.prototype.emit = function (event) {
		var args = Array.prototype.slice.call(arguments, 1);
		var callbacks = this.events[event];
	
		if (!callbacks) {
			return;
		}
	
		callbacks.forEach(function (callback) {
			callback.apply(this, args);
		});
	};
	
	TraversalTracker.prototype.auto = function (event, callback, innerFunction) {
		this.startTracking(event, callback);
		innerFunction();
		this.stopTracking(event, callback);
	};
	
	module.exports = TraversalTracker;
	
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var AI, AL, BA, BK, CB, CI_BRK, CJ, CP_BRK, CR, DI_BRK, ID, IN_BRK, LF, LineBreaker, NL, NS, PR_BRK, SA, SG, SP, UnicodeTrie, WJ, XX, base64, characterClasses, classTrie, data, fs, pairTable, _ref, _ref1;
	
	  UnicodeTrie = __webpack_require__(43);
	
	  
	
	  base64 = __webpack_require__(131);
	
	  _ref = __webpack_require__(132), BK = _ref.BK, CR = _ref.CR, LF = _ref.LF, NL = _ref.NL, CB = _ref.CB, BA = _ref.BA, SP = _ref.SP, WJ = _ref.WJ, SP = _ref.SP, BK = _ref.BK, LF = _ref.LF, NL = _ref.NL, AI = _ref.AI, AL = _ref.AL, SA = _ref.SA, SG = _ref.SG, XX = _ref.XX, CJ = _ref.CJ, ID = _ref.ID, NS = _ref.NS, characterClasses = _ref.characterClasses;
	
	  _ref1 = __webpack_require__(133), DI_BRK = _ref1.DI_BRK, IN_BRK = _ref1.IN_BRK, CI_BRK = _ref1.CI_BRK, CP_BRK = _ref1.CP_BRK, PR_BRK = _ref1.PR_BRK, pairTable = _ref1.pairTable;
	
	  data = base64.toByteArray("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");
	
	  classTrie = new UnicodeTrie(data);
	
	  LineBreaker = (function() {
	    var Break, mapClass, mapFirst;
	
	    function LineBreaker(string) {
	      this.string = string;
	      this.pos = 0;
	      this.lastPos = 0;
	      this.curClass = null;
	      this.nextClass = null;
	    }
	
	    LineBreaker.prototype.nextCodePoint = function() {
	      var code, next;
	      code = this.string.charCodeAt(this.pos++);
	      next = this.string.charCodeAt(this.pos);
	      if ((0xd800 <= code && code <= 0xdbff) && (0xdc00 <= next && next <= 0xdfff)) {
	        this.pos++;
	        return ((code - 0xd800) * 0x400) + (next - 0xdc00) + 0x10000;
	      }
	      return code;
	    };
	
	    mapClass = function(c) {
	      switch (c) {
	        case AI:
	          return AL;
	        case SA:
	        case SG:
	        case XX:
	          return AL;
	        case CJ:
	          return NS;
	        default:
	          return c;
	      }
	    };
	
	    mapFirst = function(c) {
	      switch (c) {
	        case LF:
	        case NL:
	          return BK;
	        case CB:
	          return BA;
	        case SP:
	          return WJ;
	        default:
	          return c;
	      }
	    };
	
	    LineBreaker.prototype.nextCharClass = function(first) {
	      if (first == null) {
	        first = false;
	      }
	      return mapClass(classTrie.get(this.nextCodePoint()));
	    };
	
	    Break = (function() {
	      function Break(position, required) {
	        this.position = position;
	        this.required = required != null ? required : false;
	      }
	
	      return Break;
	
	    })();
	
	    LineBreaker.prototype.nextBreak = function() {
	      var cur, lastClass, shouldBreak;
	      if (this.curClass == null) {
	        this.curClass = mapFirst(this.nextCharClass());
	      }
	      while (this.pos < this.string.length) {
	        this.lastPos = this.pos;
	        lastClass = this.nextClass;
	        this.nextClass = this.nextCharClass();
	        if (this.curClass === BK || (this.curClass === CR && this.nextClass !== LF)) {
	          this.curClass = mapFirst(mapClass(this.nextClass));
	          return new Break(this.lastPos, true);
	        }
	        cur = (function() {
	          switch (this.nextClass) {
	            case SP:
	              return this.curClass;
	            case BK:
	            case LF:
	            case NL:
	              return BK;
	            case CR:
	              return CR;
	            case CB:
	              return BA;
	          }
	        }).call(this);
	        if (cur != null) {
	          this.curClass = cur;
	          if (this.nextClass === CB) {
	            return new Break(this.lastPos);
	          }
	          continue;
	        }
	        shouldBreak = false;
	        switch (pairTable[this.curClass][this.nextClass]) {
	          case DI_BRK:
	            shouldBreak = true;
	            break;
	          case IN_BRK:
	            shouldBreak = lastClass === SP;
	            break;
	          case CI_BRK:
	            shouldBreak = lastClass === SP;
	            if (!shouldBreak) {
	              continue;
	            }
	            break;
	          case CP_BRK:
	            if (lastClass !== SP) {
	              continue;
	            }
	        }
	        this.curClass = this.nextClass;
	        if (shouldBreak) {
	          return new Break(this.lastPos);
	        }
	      }
	      if (this.pos >= this.string.length) {
	        if (this.lastPos < this.string.length) {
	          this.lastPos = this.string.length;
	          return new Break(this.string.length);
	        } else {
	          return null;
	        }
	      }
	    };
	
	    return LineBreaker;
	
	  })();
	
	  module.exports = LineBreaker;
	
	}).call(this);
	
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
	var TINF_OK = 0;
	var TINF_DATA_ERROR = -3;
	
	function Tree() {
	  this.table = new Uint16Array(16);   /* table of code length counts */
	  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
	}
	
	function Data(source, dest) {
	  this.source = source;
	  this.sourceIndex = 0;
	  this.tag = 0;
	  this.bitcount = 0;
	  
	  this.dest = dest;
	  this.destLen = 0;
	  
	  this.ltree = new Tree();  /* dynamic length/symbol tree */
	  this.dtree = new Tree();  /* dynamic distance tree */
	}
	
	/* --------------------------------------------------- *
	 * -- uninitialized global data (static structures) -- *
	 * --------------------------------------------------- */
	
	var sltree = new Tree();
	var sdtree = new Tree();
	
	/* extra bits and base tables for length codes */
	var length_bits = new Uint8Array(30);
	var length_base = new Uint16Array(30);
	
	/* extra bits and base tables for distance codes */
	var dist_bits = new Uint8Array(30);
	var dist_base = new Uint16Array(30);
	
	/* special ordering of code length codes */
	var clcidx = new Uint8Array([
	  16, 17, 18, 0, 8, 7, 9, 6,
	  10, 5, 11, 4, 12, 3, 13, 2,
	  14, 1, 15
	]);
	
	/* used by tinf_decode_trees, avoids allocations every call */
	var code_tree = new Tree();
	var lengths = new Uint8Array(288 + 32);
	
	/* ----------------------- *
	 * -- utility functions -- *
	 * ----------------------- */
	
	/* build extra bits and base tables */
	function tinf_build_bits_base(bits, base, delta, first) {
	  var i, sum;
	
	  /* build bits table */
	  for (i = 0; i < delta; ++i) bits[i] = 0;
	  for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;
	
	  /* build base table */
	  for (sum = first, i = 0; i < 30; ++i) {
	    base[i] = sum;
	    sum += 1 << bits[i];
	  }
	}
	
	/* build the fixed huffman trees */
	function tinf_build_fixed_trees(lt, dt) {
	  var i;
	
	  /* build fixed length tree */
	  for (i = 0; i < 7; ++i) lt.table[i] = 0;
	
	  lt.table[7] = 24;
	  lt.table[8] = 152;
	  lt.table[9] = 112;
	
	  for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
	  for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
	  for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
	  for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;
	
	  /* build fixed distance tree */
	  for (i = 0; i < 5; ++i) dt.table[i] = 0;
	
	  dt.table[5] = 32;
	
	  for (i = 0; i < 32; ++i) dt.trans[i] = i;
	}
	
	/* given an array of code lengths, build a tree */
	var offs = new Uint16Array(16);
	
	function tinf_build_tree(t, lengths, off, num) {
	  var i, sum;
	
	  /* clear code length count table */
	  for (i = 0; i < 16; ++i) t.table[i] = 0;
	
	  /* scan symbol lengths, and sum code length counts */
	  for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;
	
	  t.table[0] = 0;
	
	  /* compute offset table for distribution sort */
	  for (sum = 0, i = 0; i < 16; ++i) {
	    offs[i] = sum;
	    sum += t.table[i];
	  }
	
	  /* create code->symbol translation table (symbols sorted by code) */
	  for (i = 0; i < num; ++i) {
	    if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
	  }
	}
	
	/* ---------------------- *
	 * -- decode functions -- *
	 * ---------------------- */
	
	/* get one bit from source stream */
	function tinf_getbit(d) {
	  /* check if tag is empty */
	  if (!d.bitcount--) {
	    /* load next tag */
	    d.tag = d.source[d.sourceIndex++];
	    d.bitcount = 7;
	  }
	
	  /* shift bit out of tag */
	  var bit = d.tag & 1;
	  d.tag >>>= 1;
	
	  return bit;
	}
	
	/* read a num bit value from a stream and add base */
	function tinf_read_bits(d, num, base) {
	  if (!num)
	    return base;
	
	  while (d.bitcount < 24) {
	    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
	    d.bitcount += 8;
	  }
	
	  var val = d.tag & (0xffff >>> (16 - num));
	  d.tag >>>= num;
	  d.bitcount -= num;
	  return val + base;
	}
	
	/* given a data stream and a tree, decode a symbol */
	function tinf_decode_symbol(d, t) {
	  while (d.bitcount < 24) {
	    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
	    d.bitcount += 8;
	  }
	  
	  var sum = 0, cur = 0, len = 0;
	  var tag = d.tag;
	
	  /* get more bits while code value is above sum */
	  do {
	    cur = 2 * cur + (tag & 1);
	    tag >>>= 1;
	    ++len;
	
	    sum += t.table[len];
	    cur -= t.table[len];
	  } while (cur >= 0);
	  
	  d.tag = tag;
	  d.bitcount -= len;
	
	  return t.trans[sum + cur];
	}
	
	/* given a data stream, decode dynamic trees from it */
	function tinf_decode_trees(d, lt, dt) {
	  var hlit, hdist, hclen;
	  var i, num, length;
	
	  /* get 5 bits HLIT (257-286) */
	  hlit = tinf_read_bits(d, 5, 257);
	
	  /* get 5 bits HDIST (1-32) */
	  hdist = tinf_read_bits(d, 5, 1);
	
	  /* get 4 bits HCLEN (4-19) */
	  hclen = tinf_read_bits(d, 4, 4);
	
	  for (i = 0; i < 19; ++i) lengths[i] = 0;
	
	  /* read code lengths for code length alphabet */
	  for (i = 0; i < hclen; ++i) {
	    /* get 3 bits code length (0-7) */
	    var clen = tinf_read_bits(d, 3, 0);
	    lengths[clcidx[i]] = clen;
	  }
	
	  /* build code length tree */
	  tinf_build_tree(code_tree, lengths, 0, 19);
	
	  /* decode code lengths for the dynamic trees */
	  for (num = 0; num < hlit + hdist;) {
	    var sym = tinf_decode_symbol(d, code_tree);
	
	    switch (sym) {
	      case 16:
	        /* copy previous code length 3-6 times (read 2 bits) */
	        var prev = lengths[num - 1];
	        for (length = tinf_read_bits(d, 2, 3); length; --length) {
	          lengths[num++] = prev;
	        }
	        break;
	      case 17:
	        /* repeat code length 0 for 3-10 times (read 3 bits) */
	        for (length = tinf_read_bits(d, 3, 3); length; --length) {
	          lengths[num++] = 0;
	        }
	        break;
	      case 18:
	        /* repeat code length 0 for 11-138 times (read 7 bits) */
	        for (length = tinf_read_bits(d, 7, 11); length; --length) {
	          lengths[num++] = 0;
	        }
	        break;
	      default:
	        /* values 0-15 represent the actual code lengths */
	        lengths[num++] = sym;
	        break;
	    }
	  }
	
	  /* build dynamic trees */
	  tinf_build_tree(lt, lengths, 0, hlit);
	  tinf_build_tree(dt, lengths, hlit, hdist);
	}
	
	/* ----------------------------- *
	 * -- block inflate functions -- *
	 * ----------------------------- */
	
	/* given a stream and two trees, inflate a block of data */
	function tinf_inflate_block_data(d, lt, dt) {
	  while (1) {
	    var sym = tinf_decode_symbol(d, lt);
	
	    /* check for end of block */
	    if (sym === 256) {
	      return TINF_OK;
	    }
	
	    if (sym < 256) {
	      d.dest[d.destLen++] = sym;
	    } else {
	      var length, dist, offs;
	      var i;
	
	      sym -= 257;
	
	      /* possibly get more bits from length code */
	      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
	
	      dist = tinf_decode_symbol(d, dt);
	
	      /* possibly get more bits from distance code */
	      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
	
	      /* copy match */
	      for (i = offs; i < offs + length; ++i) {
	        d.dest[d.destLen++] = d.dest[i];
	      }
	    }
	  }
	}
	
	/* inflate an uncompressed block of data */
	function tinf_inflate_uncompressed_block(d) {
	  var length, invlength;
	  var i;
	  
	  /* unread from bitbuffer */
	  while (d.bitcount > 8) {
	    d.sourceIndex--;
	    d.bitcount -= 8;
	  }
	
	  /* get length */
	  length = d.source[d.sourceIndex + 1];
	  length = 256 * length + d.source[d.sourceIndex];
	
	  /* get one's complement of length */
	  invlength = d.source[d.sourceIndex + 3];
	  invlength = 256 * invlength + d.source[d.sourceIndex + 2];
	
	  /* check length */
	  if (length !== (~invlength & 0x0000ffff))
	    return TINF_DATA_ERROR;
	
	  d.sourceIndex += 4;
	
	  /* copy block */
	  for (i = length; i; --i)
	    d.dest[d.destLen++] = d.source[d.sourceIndex++];
	
	  /* make sure we start next block on a byte boundary */
	  d.bitcount = 0;
	
	  return TINF_OK;
	}
	
	/* inflate stream from source to dest */
	function tinf_uncompress(source, dest) {
	  var d = new Data(source, dest);
	  var bfinal, btype, res;
	
	  do {
	    /* read final block flag */
	    bfinal = tinf_getbit(d);
	
	    /* read block type (2 bits) */
	    btype = tinf_read_bits(d, 2, 0);
	
	    /* decompress block */
	    switch (btype) {
	      case 0:
	        /* decompress uncompressed block */
	        res = tinf_inflate_uncompressed_block(d);
	        break;
	      case 1:
	        /* decompress block with fixed huffman trees */
	        res = tinf_inflate_block_data(d, sltree, sdtree);
	        break;
	      case 2:
	        /* decompress block with dynamic huffman trees */
	        tinf_decode_trees(d, d.ltree, d.dtree);
	        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
	        break;
	      default:
	        res = TINF_DATA_ERROR;
	    }
	
	    if (res !== TINF_OK)
	      throw new Error('Data error');
	
	  } while (!bfinal);
	
	  if (d.destLen < d.dest.length) {
	    if (typeof d.dest.slice === 'function')
	      return d.dest.slice(0, d.destLen);
	    else
	      return d.dest.subarray(0, d.destLen);
	  }
	  
	  return d.dest;
	}
	
	/* -------------------- *
	 * -- initialization -- *
	 * -------------------- */
	
	/* build fixed huffman trees */
	tinf_build_fixed_trees(sltree, sdtree);
	
	/* build extra bits and base tables */
	tinf_build_bits_base(length_bits, length_base, 4, 3);
	tinf_build_bits_base(dist_bits, dist_base, 2, 1);
	
	/* fix a special case */
	length_bits[28] = 0;
	length_base[28] = 258;
	
	module.exports = tinf_uncompress;
	
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var isString = __webpack_require__(0).isString;
	var isArray = __webpack_require__(0).isArray;
	var isUndefined = __webpack_require__(0).isUndefined;
	var isNull = __webpack_require__(0).isNull;
	
	/**
	 * Creates an instance of StyleContextStack used for style inheritance and style overrides
	 *
	 * @constructor
	 * @this {StyleContextStack}
	 * @param {Object} named styles dictionary
	 * @param {Object} optional default style definition
	 */
	function StyleContextStack(styleDictionary, defaultStyle) {
		this.defaultStyle = defaultStyle || {};
		this.styleDictionary = styleDictionary;
		this.styleOverrides = [];
	}
	
	/**
	 * Creates cloned version of current stack
	 * @return {StyleContextStack} current stack snapshot
	 */
	StyleContextStack.prototype.clone = function () {
		var stack = new StyleContextStack(this.styleDictionary, this.defaultStyle);
	
		this.styleOverrides.forEach(function (item) {
			stack.styleOverrides.push(item);
		});
	
		return stack;
	};
	
	/**
	 * Pushes style-name or style-overrides-object onto the stack for future evaluation
	 *
	 * @param {String|Object} styleNameOrOverride style-name (referring to styleDictionary) or
	 *                                            a new dictionary defining overriding properties
	 */
	StyleContextStack.prototype.push = function (styleNameOrOverride) {
		this.styleOverrides.push(styleNameOrOverride);
	};
	
	/**
	 * Removes last style-name or style-overrides-object from the stack
	 *
	 * @param {Number} howMany - optional number of elements to be popped (if not specified,
	 *                           one element will be removed from the stack)
	 */
	StyleContextStack.prototype.pop = function (howMany) {
		howMany = howMany || 1;
	
		while (howMany-- > 0) {
			this.styleOverrides.pop();
		}
	};
	
	/**
	 * Creates a set of named styles or/and a style-overrides-object based on the item,
	 * pushes those elements onto the stack for future evaluation and returns the number
	 * of elements pushed, so they can be easily poped then.
	 *
	 * @param {Object} item - an object with optional style property and/or style overrides
	 * @return the number of items pushed onto the stack
	 */
	StyleContextStack.prototype.autopush = function (item) {
		if (isString(item)) {
			return 0;
		}
	
		var styleNames = [];
	
		if (item.style) {
			if (isArray(item.style)) {
				styleNames = item.style;
			} else {
				styleNames = [item.style];
			}
		}
	
		for (var i = 0, l = styleNames.length; i < l; i++) {
			this.push(styleNames[i]);
		}
	
		var styleProperties = [
			'font',
			'fontSize',
			'fontFeatures',
			'bold',
			'italics',
			'alignment',
			'color',
			'columnGap',
			'fillColor',
			'decoration',
			'decorationStyle',
			'decorationColor',
			'background',
			'lineHeight',
			'characterSpacing',
			'noWrap',
			'markerColor',
			'leadingIndent'
				//'tableCellPadding'
				// 'cellBorder',
				// 'headerCellBorder',
				// 'oddRowCellBorder',
				// 'evenRowCellBorder',
				// 'tableBorder'
		];
		var styleOverrideObject = {};
		var pushStyleOverrideObject = false;
	
		styleProperties.forEach(function (key) {
			if (!isUndefined(item[key]) && !isNull(item[key])) {
				styleOverrideObject[key] = item[key];
				pushStyleOverrideObject = true;
			}
		});
	
		if (pushStyleOverrideObject) {
			this.push(styleOverrideObject);
		}
	
		return styleNames.length + (pushStyleOverrideObject ? 1 : 0);
	};
	
	/**
	 * Automatically pushes elements onto the stack, using autopush based on item,
	 * executes callback and then pops elements back. Returns value returned by callback
	 *
	 * @param  {Object}   item - an object with optional style property and/or style overrides
	 * @param  {Function} function to be called between autopush and pop
	 * @return {Object} value returned by callback
	 */
	StyleContextStack.prototype.auto = function (item, callback) {
		var pushedItems = this.autopush(item);
		var result = callback();
	
		if (pushedItems > 0) {
			this.pop(pushedItems);
		}
	
		return result;
	};
	
	/**
	 * Evaluates stack and returns value of a named property
	 *
	 * @param {String} property - property name
	 * @return property value or null if not found
	 */
	StyleContextStack.prototype.getProperty = function (property) {
		if (this.styleOverrides) {
			for (var i = this.styleOverrides.length - 1; i >= 0; i--) {
				var item = this.styleOverrides[i];
	
				if (isString(item)) {
					// named-style-override
					var style = this.styleDictionary[item];
					if (style && !isUndefined(style[property]) && !isNull(style[property])) {
						return style[property];
					}
				} else if (!isUndefined(item[property]) && !isNull(item[property])) {
					// style-overrides-object
					return item[property];
				}
			}
		}
	
		return this.defaultStyle && this.defaultStyle[property];
	};
	
	module.exports = StyleContextStack;
	
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var TraversalTracker = __webpack_require__(77);
	var isString = __webpack_require__(0).isString;
	
	/**
	 * Creates an instance of DocumentContext - a store for current x, y positions and available width/height.
	 * It facilitates column divisions and vertical sync
	 */
	function DocumentContext(pageSize, pageMargins) {
		this.pages = [];
	
		this.pageMargins = pageMargins;
	
		this.x = pageMargins.left;
		this.availableWidth = pageSize.width - pageMargins.left - pageMargins.right;
		this.availableHeight = 0;
		this.page = -1;
	
		this.snapshots = [];
	
		this.endingCell = null;
	
		this.tracker = new TraversalTracker();
	
		this.addPage(pageSize);
	
		this.hasBackground = false;
	}
	
	DocumentContext.prototype.beginColumnGroup = function () {
		this.snapshots.push({
			x: this.x,
			y: this.y,
			availableHeight: this.availableHeight,
			availableWidth: this.availableWidth,
			page: this.page,
			bottomMost: {
				x: this.x,
				y: this.y,
				availableHeight: this.availableHeight,
				availableWidth: this.availableWidth,
				page: this.page
			},
			endingCell: this.endingCell,
			lastColumnWidth: this.lastColumnWidth
		});
	
		this.lastColumnWidth = 0;
	};
	
	DocumentContext.prototype.beginColumn = function (width, offset, endingCell) {
		var saved = this.snapshots[this.snapshots.length - 1];
	
		this.calculateBottomMost(saved);
	
		this.endingCell = endingCell;
		this.page = saved.page;
		this.x = this.x + this.lastColumnWidth + (offset || 0);
		this.y = saved.y;
		this.availableWidth = width;	//saved.availableWidth - offset;
		this.availableHeight = saved.availableHeight;
	
		this.lastColumnWidth = width;
	};
	
	DocumentContext.prototype.calculateBottomMost = function (destContext) {
		if (this.endingCell) {
			this.saveContextInEndingCell(this.endingCell);
			this.endingCell = null;
		} else {
			destContext.bottomMost = bottomMostContext(this, destContext.bottomMost);
		}
	};
	
	DocumentContext.prototype.markEnding = function (endingCell) {
		this.page = endingCell._columnEndingContext.page;
		this.x = endingCell._columnEndingContext.x;
		this.y = endingCell._columnEndingContext.y;
		this.availableWidth = endingCell._columnEndingContext.availableWidth;
		this.availableHeight = endingCell._columnEndingContext.availableHeight;
		this.lastColumnWidth = endingCell._columnEndingContext.lastColumnWidth;
	};
	
	DocumentContext.prototype.saveContextInEndingCell = function (endingCell) {
		endingCell._columnEndingContext = {
			page: this.page,
			x: this.x,
			y: this.y,
			availableHeight: this.availableHeight,
			availableWidth: this.availableWidth,
			lastColumnWidth: this.lastColumnWidth
		};
	};
	
	DocumentContext.prototype.completeColumnGroup = function (height) {
		var saved = this.snapshots.pop();
	
		this.calculateBottomMost(saved);
	
		this.endingCell = null;
		this.x = saved.x;
	
		var y = saved.bottomMost.y;
		if (height) {
			if (saved.page === saved.bottomMost.page) {
				if ((saved.y + height) > y) {
					y = saved.y + height;
				}
			} else {
				y += height;
			}
		}
	
		this.y = y;
		this.page = saved.bottomMost.page;
		this.availableWidth = saved.availableWidth;
		this.availableHeight = saved.bottomMost.availableHeight;
		if (height) {
			this.availableHeight -= (y - saved.bottomMost.y);
		}
		this.lastColumnWidth = saved.lastColumnWidth;
	};
	
	DocumentContext.prototype.addMargin = function (left, right) {
		this.x += left;
		this.availableWidth -= left + (right || 0);
	};
	
	DocumentContext.prototype.moveDown = function (offset) {
		this.y += offset;
		this.availableHeight -= offset;
	
		return this.availableHeight > 0;
	};
	
	DocumentContext.prototype.initializePage = function () {
		this.y = this.pageMargins.top;
		this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
		this.pageSnapshot().availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right;
	};
	
	DocumentContext.prototype.pageSnapshot = function () {
		if (this.snapshots[0]) {
			return this.snapshots[0];
		} else {
			return this;
		}
	};
	
	DocumentContext.prototype.moveTo = function (x, y) {
		if (x !== undefined && x !== null) {
			this.x = x;
			this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right;
		}
		if (y !== undefined && y !== null) {
			this.y = y;
			this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom;
		}
	};
	
	DocumentContext.prototype.beginDetachedBlock = function () {
		this.snapshots.push({
			x: this.x,
			y: this.y,
			availableHeight: this.availableHeight,
			availableWidth: this.availableWidth,
			page: this.page,
			endingCell: this.endingCell,
			lastColumnWidth: this.lastColumnWidth
		});
	};
	
	DocumentContext.prototype.endDetachedBlock = function () {
		var saved = this.snapshots.pop();
	
		this.x = saved.x;
		this.y = saved.y;
		this.availableWidth = saved.availableWidth;
		this.availableHeight = saved.availableHeight;
		this.page = saved.page;
		this.endingCell = saved.endingCell;
		this.lastColumnWidth = saved.lastColumnWidth;
	};
	
	function pageOrientation(pageOrientationString, currentPageOrientation) {
		if (pageOrientationString === undefined) {
			return currentPageOrientation;
		} else if (isString(pageOrientationString) && (pageOrientationString.toLowerCase() === 'landscape')) {
			return 'landscape';
		} else {
			return 'portrait';
		}
	}
	
	var getPageSize = function (currentPage, newPageOrientation) {
	
		newPageOrientation = pageOrientation(newPageOrientation, currentPage.pageSize.orientation);
	
		if (newPageOrientation !== currentPage.pageSize.orientation) {
			return {
				orientation: newPageOrientation,
				width: currentPage.pageSize.height,
				height: currentPage.pageSize.width
			};
		} else {
			return {
				orientation: currentPage.pageSize.orientation,
				width: currentPage.pageSize.width,
				height: currentPage.pageSize.height
			};
		}
	
	};
	
	
	DocumentContext.prototype.moveToNextPage = function (pageOrientation) {
		var nextPageIndex = this.page + 1;
	
		var prevPage = this.page;
		var prevY = this.y;
	
		var createNewPage = nextPageIndex >= this.pages.length;
		if (createNewPage) {
			var currentAvailableWidth = this.availableWidth;
			var currentPageOrientation = this.getCurrentPage().pageSize.orientation;
	
			var pageSize = getPageSize(this.getCurrentPage(), pageOrientation);
			this.addPage(pageSize);
	
			if (currentPageOrientation === pageSize.orientation) {
				this.availableWidth = currentAvailableWidth;
			}
		} else {
			this.page = nextPageIndex;
			this.initializePage();
		}
	
		return {
			newPageCreated: createNewPage,
			prevPage: prevPage,
			prevY: prevY,
			y: this.y
		};
	};
	
	
	DocumentContext.prototype.addPage = function (pageSize) {
		var page = {items: [], pageSize: pageSize};
		this.pages.push(page);
		this.page = this.pages.length - 1;
		this.initializePage();
	
		this.tracker.emit('pageAdded');
	
		return page;
	};
	
	DocumentContext.prototype.getCurrentPage = function () {
		if (this.page < 0 || this.page >= this.pages.length) {
			return null;
		}
	
		return this.pages[this.page];
	};
	
	DocumentContext.prototype.getCurrentPosition = function () {
		var pageSize = this.getCurrentPage().pageSize;
		var innerHeight = pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
		var innerWidth = pageSize.width - this.pageMargins.left - this.pageMargins.right;
	
		return {
			pageNumber: this.page + 1,
			pageOrientation: pageSize.orientation,
			pageInnerHeight: innerHeight,
			pageInnerWidth: innerWidth,
			left: this.x,
			top: this.y,
			verticalRatio: ((this.y - this.pageMargins.top) / innerHeight),
			horizontalRatio: ((this.x - this.pageMargins.left) / innerWidth)
		};
	};
	
	function bottomMostContext(c1, c2) {
		var r;
	
		if (c1.page > c2.page) {
			r = c1;
		} else if (c2.page > c1.page) {
			r = c2;
		} else {
			r = (c1.y > c2.y) ? c1 : c2;
		}
	
		return {
			page: r.page,
			x: r.x,
			y: r.y,
			availableHeight: r.availableHeight,
			availableWidth: r.availableWidth
		};
	}
	
	module.exports = DocumentContext;
	
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Creates an instance of Line
	 *
	 * @constructor
	 * @this {Line}
	 * @param {Number} Maximum width this line can have
	 */
	function Line(maxWidth) {
		this.maxWidth = maxWidth;
		this.leadingCut = 0;
		this.trailingCut = 0;
		this.inlineWidths = 0;
		this.inlines = [];
	}
	
	Line.prototype.getAscenderHeight = function () {
		var y = 0;
	
		this.inlines.forEach(function (inline) {
			y = Math.max(y, inline.font.ascender / 1000 * inline.fontSize);
		});
		return y;
	};
	
	Line.prototype.hasEnoughSpaceForInline = function (inline) {
		if (this.inlines.length === 0) {
			return true;
		}
		if (this.newLineForced) {
			return false;
		}
	
		return this.inlineWidths + inline.width - this.leadingCut - (inline.trailingCut || 0) <= this.maxWidth;
	};
	
	Line.prototype.addInline = function (inline) {
		if (this.inlines.length === 0) {
			this.leadingCut = inline.leadingCut || 0;
		}
		this.trailingCut = inline.trailingCut || 0;
	
		inline.x = this.inlineWidths - this.leadingCut;
	
		this.inlines.push(inline);
		this.inlineWidths += inline.width;
	
		if (inline.lineEnd) {
			this.newLineForced = true;
		}
	};
	
	Line.prototype.getWidth = function () {
		return this.inlineWidths - this.leadingCut - this.trailingCut;
	};
	
	/**
	 * Returns line height
	 * @return {Number}
	 */
	Line.prototype.getHeight = function () {
		var max = 0;
	
		this.inlines.forEach(function (item) {
			max = Math.max(max, item.height || 0);
		});
	
		return max;
	};
	
	module.exports = Line;
	
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(32).nextTick;
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(76);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(31).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(84);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(33).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(25);
	util.inherits = __webpack_require__(21);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(139);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(140);
	var destroyImpl = __webpack_require__(85);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(16);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(47).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(16);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(47).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(11)))
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(31).EventEmitter;
	
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(32).nextTick;
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(16);
	
	/*<replacement>*/
	var util = __webpack_require__(25);
	util.inherits = __webpack_require__(21);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	
	/*
	PDFReference - represents a reference to another object in the PDF object heirarchy
	By Devon Govett
	 */
	
	(function() {
	  var PDFObject, PDFReference, stream, zlib,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  zlib = __webpack_require__(48);
	
	  stream = __webpack_require__(15);
	
	  PDFReference = (function(superClass) {
	    extend(PDFReference, superClass);
	
	    function PDFReference(document, id, data) {
	      this.document = document;
	      this.id = id;
	      this.data = data != null ? data : {};
	      this.finalize = bind(this.finalize, this);
	      PDFReference.__super__.constructor.call(this, {
	        decodeStrings: false
	      });
	      this.gen = 0;
	      this.deflate = null;
	      this.compress = this.document.compress && !this.data.Filter;
	      this.uncompressedLength = 0;
	      this.chunks = [];
	    }
	
	    PDFReference.prototype.initDeflate = function() {
	      this.data.Filter = 'FlateDecode';
	      this.deflate = zlib.createDeflate();
	      this.deflate.on('data', (function(_this) {
	        return function(chunk) {
	          _this.chunks.push(chunk);
	          return _this.data.Length += chunk.length;
	        };
	      })(this));
	      return this.deflate.on('end', this.finalize);
	    };
	
	    PDFReference.prototype._write = function(chunk, encoding, callback) {
	      var base;
	      if (!Buffer.isBuffer(chunk)) {
	        chunk = new Buffer(chunk + '\n', 'binary');
	      }
	      this.uncompressedLength += chunk.length;
	      if ((base = this.data).Length == null) {
	        base.Length = 0;
	      }
	      if (this.compress) {
	        if (!this.deflate) {
	          this.initDeflate();
	        }
	        this.deflate.write(chunk);
	      } else {
	        this.chunks.push(chunk);
	        this.data.Length += chunk.length;
	      }
	      return callback();
	    };
	
	    PDFReference.prototype.end = function(chunk) {
	      PDFReference.__super__.end.apply(this, arguments);
	      if (this.deflate) {
	        return this.deflate.end();
	      } else {
	        return this.finalize();
	      }
	    };
	
	    PDFReference.prototype.finalize = function() {
	      var chunk, i, len, ref;
	      this.offset = this.document._offset;
	      this.document._write(this.id + " " + this.gen + " obj");
	      this.document._write(PDFObject.convert(this.data));
	      if (this.chunks.length) {
	        this.document._write('stream');
	        ref = this.chunks;
	        for (i = 0, len = ref.length; i < len; i++) {
	          chunk = ref[i];
	          this.document._write(chunk);
	        }
	        this.chunks.length = 0;
	        this.document._write('\nendstream');
	      }
	      this.document._write('endobj');
	      return this.document._refEnd(this);
	    };
	
	    PDFReference.prototype.toString = function() {
	      return this.id + " " + this.gen + " R";
	    };
	
	    return PDFReference;
	
	  })(stream.Writable);
	
	  module.exports = PDFReference;
	
	  PDFObject = __webpack_require__(26);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(49);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;
	
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;
	
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
	module.exports = [["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc",""],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93]]
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
	module.exports = [["0","\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var ArrayT, NumberT, utils;
	
	  NumberT = __webpack_require__(22).Number;
	
	  utils = __webpack_require__(12);
	
	  ArrayT = (function() {
	    function ArrayT(type, length, lengthType) {
	      this.type = type;
	      this.length = length;
	      this.lengthType = lengthType != null ? lengthType : 'count';
	    }
	
	    ArrayT.prototype.decode = function(stream, parent) {
	      var ctx, i, length, pos, res, target, _i;
	      pos = stream.pos;
	      res = [];
	      ctx = parent;
	      if (this.length != null) {
	        length = utils.resolveLength(this.length, stream, parent);
	      }
	      if (this.length instanceof NumberT) {
	        Object.defineProperties(res, {
	          parent: {
	            value: parent
	          },
	          _startOffset: {
	            value: pos
	          },
	          _currentOffset: {
	            value: 0,
	            writable: true
	          },
	          _length: {
	            value: length
	          }
	        });
	        ctx = res;
	      }
	      if ((length == null) || this.lengthType === 'bytes') {
	        target = length != null ? stream.pos + length : (parent != null ? parent._length : void 0) ? parent._startOffset + parent._length : stream.length;
	        while (stream.pos < target) {
	          res.push(this.type.decode(stream, ctx));
	        }
	      } else {
	        for (i = _i = 0; _i < length; i = _i += 1) {
	          res.push(this.type.decode(stream, ctx));
	        }
	      }
	      return res;
	    };
	
	    ArrayT.prototype.size = function(array, ctx) {
	      var item, size, _i, _len;
	      if (!array) {
	        return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
	      }
	      size = 0;
	      if (this.length instanceof NumberT) {
	        size += this.length.size();
	        ctx = {
	          parent: ctx
	        };
	      }
	      for (_i = 0, _len = array.length; _i < _len; _i++) {
	        item = array[_i];
	        size += this.type.size(item, ctx);
	      }
	      return size;
	    };
	
	    ArrayT.prototype.encode = function(stream, array, parent) {
	      var ctx, i, item, ptr, _i, _len;
	      ctx = parent;
	      if (this.length instanceof NumberT) {
	        ctx = {
	          pointers: [],
	          startOffset: stream.pos,
	          parent: parent
	        };
	        ctx.pointerOffset = stream.pos + this.size(array, ctx);
	        this.length.encode(stream, array.length);
	      }
	      for (_i = 0, _len = array.length; _i < _len; _i++) {
	        item = array[_i];
	        this.type.encode(stream, item, ctx);
	      }
	      if (this.length instanceof NumberT) {
	        i = 0;
	        while (i < ctx.pointers.length) {
	          ptr = ctx.pointers[i++];
	          ptr.type.encode(stream, ptr.val);
	        }
	      }
	    };
	
	    return ArrayT;
	
	  })();
	
	  module.exports = ArrayT;
	
	}).call(this);
	
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Struct, utils;
	
	  utils = __webpack_require__(12);
	
	  Struct = (function() {
	    function Struct(fields) {
	      this.fields = fields != null ? fields : {};
	    }
	
	    Struct.prototype.decode = function(stream, parent, length) {
	      var res, _ref;
	      if (length == null) {
	        length = 0;
	      }
	      res = this._setup(stream, parent, length);
	      this._parseFields(stream, res, this.fields);
	      if ((_ref = this.process) != null) {
	        _ref.call(res, stream);
	      }
	      return res;
	    };
	
	    Struct.prototype._setup = function(stream, parent, length) {
	      var res;
	      res = {};
	      Object.defineProperties(res, {
	        parent: {
	          value: parent
	        },
	        _startOffset: {
	          value: stream.pos
	        },
	        _currentOffset: {
	          value: 0,
	          writable: true
	        },
	        _length: {
	          value: length
	        }
	      });
	      return res;
	    };
	
	    Struct.prototype._parseFields = function(stream, res, fields) {
	      var key, type, val;
	      for (key in fields) {
	        type = fields[key];
	        if (typeof type === 'function') {
	          val = type.call(res, res);
	        } else {
	          val = type.decode(stream, res);
	        }
	        if (val !== void 0) {
	          if (val instanceof utils.PropertyDescriptor) {
	            Object.defineProperty(res, key, val);
	          } else {
	            res[key] = val;
	          }
	        }
	        res._currentOffset = stream.pos - res._startOffset;
	      }
	    };
	
	    Struct.prototype.size = function(val, parent, includePointers) {
	      var ctx, key, size, type, _ref;
	      if (val == null) {
	        val = {};
	      }
	      if (includePointers == null) {
	        includePointers = true;
	      }
	      ctx = {
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      size = 0;
	      _ref = this.fields;
	      for (key in _ref) {
	        type = _ref[key];
	        if (type.size != null) {
	          size += type.size(val[key], ctx);
	        }
	      }
	      if (includePointers) {
	        size += ctx.pointerSize;
	      }
	      return size;
	    };
	
	    Struct.prototype.encode = function(stream, val, parent) {
	      var ctx, i, key, ptr, type, _ref, _ref1;
	      if ((_ref = this.preEncode) != null) {
	        _ref.call(val, stream);
	      }
	      ctx = {
	        pointers: [],
	        startOffset: stream.pos,
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
	      _ref1 = this.fields;
	      for (key in _ref1) {
	        type = _ref1[key];
	        if (type.encode != null) {
	          type.encode(stream, val[key], ctx);
	        }
	      }
	      i = 0;
	      while (i < ctx.pointers.length) {
	        ptr = ctx.pointers[i++];
	        ptr.type.encode(stream, ptr.val, ptr.parent);
	      }
	    };
	
	    return Struct;
	
	  })();
	
	  module.exports = Struct;
	
	}).call(this);
	
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = !__webpack_require__(5) && !__webpack_require__(19)(function () {
	  return Object.defineProperty(__webpack_require__(96)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(9);
	var document = __webpack_require__(10).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {
	
	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};
	
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(13);
	
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__(6);
	var anObject = __webpack_require__(14);
	var getKeys = __webpack_require__(29);
	
	module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var has = __webpack_require__(18);
	var toIObject = __webpack_require__(17);
	var arrayIndexOf = __webpack_require__(204)(false);
	var IE_PROTO = __webpack_require__(64)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(63);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(215), __esModule: true };
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(55);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};
	
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(101);
	var hiddenKeys = __webpack_require__(66).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(74);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var dP = __webpack_require__(6).f;
	var create = __webpack_require__(36);
	var redefineAll = __webpack_require__(109);
	var ctx = __webpack_require__(20);
	var anInstance = __webpack_require__(110);
	var forOf = __webpack_require__(41);
	var $iterDefine = __webpack_require__(61);
	var step = __webpack_require__(98);
	var setSpecies = __webpack_require__(228);
	var DESCRIPTORS = __webpack_require__(5);
	var fastKey = __webpack_require__(40).fastKey;
	var validate = __webpack_require__(75);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};
	
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var hide = __webpack_require__(13);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};
	
	
	/***/ }),
	/* 110 */
	/***/ (function(module, exports) {
	
	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};
	
	
	/***/ }),
	/* 111 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(14);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};
	
	
	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// check on default Array iterator
	var Iterators = __webpack_require__(23);
	var ITERATOR = __webpack_require__(4)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};
	
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var global = __webpack_require__(10);
	var $export = __webpack_require__(3);
	var meta = __webpack_require__(40);
	var fails = __webpack_require__(19);
	var hide = __webpack_require__(13);
	var redefineAll = __webpack_require__(109);
	var forOf = __webpack_require__(41);
	var anInstance = __webpack_require__(110);
	var isObject = __webpack_require__(9);
	var setToStringTag = __webpack_require__(39);
	var dP = __webpack_require__(6).f;
	var each = __webpack_require__(229)(0);
	var DESCRIPTORS = __webpack_require__(5);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};
	
	
	/***/ }),
	/* 114 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(68);
	var from = __webpack_require__(233);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};
	
	
	/***/ }),
	/* 115 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};
	
	
	/***/ }),
	/* 116 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(97);
	var ctx = __webpack_require__(20);
	var forOf = __webpack_require__(41);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};
	
	
	/***/ }),
	/* 117 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* Copyright 2013 Google Inc. All Rights Reserved.
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	*/
	
	var BrotliInput = __webpack_require__(118).BrotliInput;
	var BrotliOutput = __webpack_require__(118).BrotliOutput;
	var BrotliBitReader = __webpack_require__(285);
	var BrotliDictionary = __webpack_require__(119);
	var HuffmanCode = __webpack_require__(120).HuffmanCode;
	var BrotliBuildHuffmanTable = __webpack_require__(120).BrotliBuildHuffmanTable;
	var Context = __webpack_require__(289);
	var Prefix = __webpack_require__(290);
	var Transform = __webpack_require__(291);
	
	var kDefaultCodeLength = 8;
	var kCodeLengthRepeatCode = 16;
	var kNumLiteralCodes = 256;
	var kNumInsertAndCopyCodes = 704;
	var kNumBlockLengthCodes = 26;
	var kLiteralContextBits = 6;
	var kDistanceContextBits = 2;
	
	var HUFFMAN_TABLE_BITS = 8;
	var HUFFMAN_TABLE_MASK = 0xff;
	/* Maximum possible Huffman table size for an alphabet size of 704, max code
	 * length 15 and root table bits 8. */
	var HUFFMAN_MAX_TABLE_SIZE = 1080;
	
	var CODE_LENGTH_CODES = 18;
	var kCodeLengthCodeOrder = new Uint8Array([
	  1, 2, 3, 4, 0, 5, 17, 6, 16, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	]);
	
	var NUM_DISTANCE_SHORT_CODES = 16;
	var kDistanceShortCodeIndexOffset = new Uint8Array([
	  3, 2, 1, 0, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2
	]);
	
	var kDistanceShortCodeValueOffset = new Int8Array([
	  0, 0, 0, 0, -1, 1, -2, 2, -3, 3, -1, 1, -2, 2, -3, 3
	]);
	
	var kMaxHuffmanTableSize = new Uint16Array([
	  256, 402, 436, 468, 500, 534, 566, 598, 630, 662, 694, 726, 758, 790, 822,
	  854, 886, 920, 952, 984, 1016, 1048, 1080
	]);
	
	function DecodeWindowBits(br) {
	  var n;
	  if (br.readBits(1) === 0) {
	    return 16;
	  }
	  
	  n = br.readBits(3);
	  if (n > 0) {
	    return 17 + n;
	  }
	  
	  n = br.readBits(3);
	  if (n > 0) {
	    return 8 + n;
	  }
	  
	  return 17;
	}
	
	/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */
	function DecodeVarLenUint8(br) {
	  if (br.readBits(1)) {
	    var nbits = br.readBits(3);
	    if (nbits === 0) {
	      return 1;
	    } else {
	      return br.readBits(nbits) + (1 << nbits);
	    }
	  }
	  return 0;
	}
	
	function MetaBlockLength() {
	  this.meta_block_length = 0;
	  this.input_end = 0;
	  this.is_uncompressed = 0;
	  this.is_metadata = false;
	}
	
	function DecodeMetaBlockLength(br) {
	  var out = new MetaBlockLength;  
	  var size_nibbles;
	  var size_bytes;
	  var i;
	  
	  out.input_end = br.readBits(1);
	  if (out.input_end && br.readBits(1)) {
	    return out;
	  }
	  
	  size_nibbles = br.readBits(2) + 4;
	  if (size_nibbles === 7) {
	    out.is_metadata = true;
	    
	    if (br.readBits(1) !== 0)
	      throw new Error('Invalid reserved bit');
	    
	    size_bytes = br.readBits(2);
	    if (size_bytes === 0)
	      return out;
	    
	    for (i = 0; i < size_bytes; i++) {
	      var next_byte = br.readBits(8);
	      if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0)
	        throw new Error('Invalid size byte');
	      
	      out.meta_block_length |= next_byte << (i * 8);
	    }
	  } else {
	    for (i = 0; i < size_nibbles; ++i) {
	      var next_nibble = br.readBits(4);
	      if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0)
	        throw new Error('Invalid size nibble');
	      
	      out.meta_block_length |= next_nibble << (i * 4);
	    }
	  }
	  
	  ++out.meta_block_length;
	  
	  if (!out.input_end && !out.is_metadata) {
	    out.is_uncompressed = br.readBits(1);
	  }
	  
	  return out;
	}
	
	/* Decodes the next Huffman code from bit-stream. */
	function ReadSymbol(table, index, br) {
	  var start_index = index;
	  
	  var nbits;
	  br.fillBitWindow();
	  index += (br.val_ >>> br.bit_pos_) & HUFFMAN_TABLE_MASK;
	  nbits = table[index].bits - HUFFMAN_TABLE_BITS;
	  if (nbits > 0) {
	    br.bit_pos_ += HUFFMAN_TABLE_BITS;
	    index += table[index].value;
	    index += (br.val_ >>> br.bit_pos_) & ((1 << nbits) - 1);
	  }
	  br.bit_pos_ += table[index].bits;
	  return table[index].value;
	}
	
	function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
	  var symbol = 0;
	  var prev_code_len = kDefaultCodeLength;
	  var repeat = 0;
	  var repeat_code_len = 0;
	  var space = 32768;
	  
	  var table = [];
	  for (var i = 0; i < 32; i++)
	    table.push(new HuffmanCode(0, 0));
	  
	  BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);
	
	  while (symbol < num_symbols && space > 0) {
	    var p = 0;
	    var code_len;
	    
	    br.readMoreInput();
	    br.fillBitWindow();
	    p += (br.val_ >>> br.bit_pos_) & 31;
	    br.bit_pos_ += table[p].bits;
	    code_len = table[p].value & 0xff;
	    if (code_len < kCodeLengthRepeatCode) {
	      repeat = 0;
	      code_lengths[symbol++] = code_len;
	      if (code_len !== 0) {
	        prev_code_len = code_len;
	        space -= 32768 >> code_len;
	      }
	    } else {
	      var extra_bits = code_len - 14;
	      var old_repeat;
	      var repeat_delta;
	      var new_len = 0;
	      if (code_len === kCodeLengthRepeatCode) {
	        new_len = prev_code_len;
	      }
	      if (repeat_code_len !== new_len) {
	        repeat = 0;
	        repeat_code_len = new_len;
	      }
	      old_repeat = repeat;
	      if (repeat > 0) {
	        repeat -= 2;
	        repeat <<= extra_bits;
	      }
	      repeat += br.readBits(extra_bits) + 3;
	      repeat_delta = repeat - old_repeat;
	      if (symbol + repeat_delta > num_symbols) {
	        throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
	      }
	      
	      for (var x = 0; x < repeat_delta; x++)
	        code_lengths[symbol + x] = repeat_code_len;
	      
	      symbol += repeat_delta;
	      
	      if (repeat_code_len !== 0) {
	        space -= repeat_delta << (15 - repeat_code_len);
	      }
	    }
	  }
	  if (space !== 0) {
	    throw new Error("[ReadHuffmanCodeLengths] space = " + space);
	  }
	  
	  for (; symbol < num_symbols; symbol++)
	    code_lengths[symbol] = 0;
	}
	
	function ReadHuffmanCode(alphabet_size, tables, table, br) {
	  var table_size = 0;
	  var simple_code_or_skip;
	  var code_lengths = new Uint8Array(alphabet_size);
	  
	  br.readMoreInput();
	  
	  /* simple_code_or_skip is used as follows:
	     1 for simple code;
	     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */
	  simple_code_or_skip = br.readBits(2);
	  if (simple_code_or_skip === 1) {
	    /* Read symbols, codes & code lengths directly. */
	    var i;
	    var max_bits_counter = alphabet_size - 1;
	    var max_bits = 0;
	    var symbols = new Int32Array(4);
	    var num_symbols = br.readBits(2) + 1;
	    while (max_bits_counter) {
	      max_bits_counter >>= 1;
	      ++max_bits;
	    }
	
	    for (i = 0; i < num_symbols; ++i) {
	      symbols[i] = br.readBits(max_bits) % alphabet_size;
	      code_lengths[symbols[i]] = 2;
	    }
	    code_lengths[symbols[0]] = 1;
	    switch (num_symbols) {
	      case 1:
	        break;
	      case 3:
	        if ((symbols[0] === symbols[1]) ||
	            (symbols[0] === symbols[2]) ||
	            (symbols[1] === symbols[2])) {
	          throw new Error('[ReadHuffmanCode] invalid symbols');
	        }
	        break;
	      case 2:
	        if (symbols[0] === symbols[1]) {
	          throw new Error('[ReadHuffmanCode] invalid symbols');
	        }
	        
	        code_lengths[symbols[1]] = 1;
	        break;
	      case 4:
	        if ((symbols[0] === symbols[1]) ||
	            (symbols[0] === symbols[2]) ||
	            (symbols[0] === symbols[3]) ||
	            (symbols[1] === symbols[2]) ||
	            (symbols[1] === symbols[3]) ||
	            (symbols[2] === symbols[3])) {
	          throw new Error('[ReadHuffmanCode] invalid symbols');
	        }
	        
	        if (br.readBits(1)) {
	          code_lengths[symbols[2]] = 3;
	          code_lengths[symbols[3]] = 3;
	        } else {
	          code_lengths[symbols[0]] = 2;
	        }
	        break;
	    }
	  } else {  /* Decode Huffman-coded code lengths. */
	    var i;
	    var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
	    var space = 32;
	    var num_codes = 0;
	    /* Static Huffman code for the code length code lengths */
	    var huff = [
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 1),
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 5)
	    ];
	    for (i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i) {
	      var code_len_idx = kCodeLengthCodeOrder[i];
	      var p = 0;
	      var v;
	      br.fillBitWindow();
	      p += (br.val_ >>> br.bit_pos_) & 15;
	      br.bit_pos_ += huff[p].bits;
	      v = huff[p].value;
	      code_length_code_lengths[code_len_idx] = v;
	      if (v !== 0) {
	        space -= (32 >> v);
	        ++num_codes;
	      }
	    }
	    
	    if (!(num_codes === 1 || space === 0))
	      throw new Error('[ReadHuffmanCode] invalid num_codes or space');
	    
	    ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
	  }
	  
	  table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
	  
	  if (table_size === 0) {
	    throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
	  }
	  
	  return table_size;
	}
	
	function ReadBlockLength(table, index, br) {
	  var code;
	  var nbits;
	  code = ReadSymbol(table, index, br);
	  nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
	  return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
	}
	
	function TranslateShortCodes(code, ringbuffer, index) {
	  var val;
	  if (code < NUM_DISTANCE_SHORT_CODES) {
	    index += kDistanceShortCodeIndexOffset[code];
	    index &= 3;
	    val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
	  } else {
	    val = code - NUM_DISTANCE_SHORT_CODES + 1;
	  }
	  return val;
	}
	
	function MoveToFront(v, index) {
	  var value = v[index];
	  var i = index;
	  for (; i; --i) v[i] = v[i - 1];
	  v[0] = value;
	}
	
	function InverseMoveToFrontTransform(v, v_len) {
	  var mtf = new Uint8Array(256);
	  var i;
	  for (i = 0; i < 256; ++i) {
	    mtf[i] = i;
	  }
	  for (i = 0; i < v_len; ++i) {
	    var index = v[i];
	    v[i] = mtf[index];
	    if (index) MoveToFront(mtf, index);
	  }
	}
	
	/* Contains a collection of huffman trees with the same alphabet size. */
	function HuffmanTreeGroup(alphabet_size, num_htrees) {
	  this.alphabet_size = alphabet_size;
	  this.num_htrees = num_htrees;
	  this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[(alphabet_size + 31) >>> 5]);  
	  this.htrees = new Uint32Array(num_htrees);
	}
	
	HuffmanTreeGroup.prototype.decode = function(br) {
	  var i;
	  var table_size;
	  var next = 0;
	  for (i = 0; i < this.num_htrees; ++i) {
	    this.htrees[i] = next;
	    table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
	    next += table_size;
	  }
	};
	
	function DecodeContextMap(context_map_size, br) {
	  var out = { num_htrees: null, context_map: null };
	  var use_rle_for_zeros;
	  var max_run_length_prefix = 0;
	  var table;
	  var i;
	  
	  br.readMoreInput();
	  var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;
	
	  var context_map = out.context_map = new Uint8Array(context_map_size);
	  if (num_htrees <= 1) {
	    return out;
	  }
	
	  use_rle_for_zeros = br.readBits(1);
	  if (use_rle_for_zeros) {
	    max_run_length_prefix = br.readBits(4) + 1;
	  }
	  
	  table = [];
	  for (i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++) {
	    table[i] = new HuffmanCode(0, 0);
	  }
	  
	  ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
	  
	  for (i = 0; i < context_map_size;) {
	    var code;
	
	    br.readMoreInput();
	    code = ReadSymbol(table, 0, br);
	    if (code === 0) {
	      context_map[i] = 0;
	      ++i;
	    } else if (code <= max_run_length_prefix) {
	      var reps = 1 + (1 << code) + br.readBits(code);
	      while (--reps) {
	        if (i >= context_map_size) {
	          throw new Error("[DecodeContextMap] i >= context_map_size");
	        }
	        context_map[i] = 0;
	        ++i;
	      }
	    } else {
	      context_map[i] = code - max_run_length_prefix;
	      ++i;
	    }
	  }
	  if (br.readBits(1)) {
	    InverseMoveToFrontTransform(context_map, context_map_size);
	  }
	  
	  return out;
	}
	
	function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
	  var ringbuffer = tree_type * 2;
	  var index = tree_type;
	  var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
	  var block_type;
	  if (type_code === 0) {
	    block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
	  } else if (type_code === 1) {
	    block_type = ringbuffers[ringbuffer + ((indexes[index] - 1) & 1)] + 1;
	  } else {
	    block_type = type_code - 2;
	  }
	  if (block_type >= max_block_type) {
	    block_type -= max_block_type;
	  }
	  block_types[tree_type] = block_type;
	  ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
	  ++indexes[index];
	}
	
	function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
	  var rb_size = ringbuffer_mask + 1;
	  var rb_pos = pos & ringbuffer_mask;
	  var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
	  var nbytes;
	
	  /* For short lengths copy byte-by-byte */
	  if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
	    while (len-- > 0) {
	      br.readMoreInput();
	      ringbuffer[rb_pos++] = br.readBits(8);
	      if (rb_pos === rb_size) {
	        output.write(ringbuffer, rb_size);
	        rb_pos = 0;
	      }
	    }
	    return;
	  }
	
	  if (br.bit_end_pos_ < 32) {
	    throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
	  }
	
	  /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */
	  while (br.bit_pos_ < 32) {
	    ringbuffer[rb_pos] = (br.val_ >>> br.bit_pos_);
	    br.bit_pos_ += 8;
	    ++rb_pos;
	    --len;
	  }
	
	  /* Copy remaining bytes from br.buf_ to ringbuffer. */
	  nbytes = (br.bit_end_pos_ - br.bit_pos_) >> 3;
	  if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
	    var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
	    for (var x = 0; x < tail; x++)
	      ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
	    
	    nbytes -= tail;
	    rb_pos += tail;
	    len -= tail;
	    br_pos = 0;
	  }
	
	  for (var x = 0; x < nbytes; x++)
	    ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
	  
	  rb_pos += nbytes;
	  len -= nbytes;
	
	  /* If we wrote past the logical end of the ringbuffer, copy the tail of the
	     ringbuffer to its beginning and flush the ringbuffer to the output. */
	  if (rb_pos >= rb_size) {
	    output.write(ringbuffer, rb_size);
	    rb_pos -= rb_size;    
	    for (var x = 0; x < rb_pos; x++)
	      ringbuffer[x] = ringbuffer[rb_size + x];
	  }
	
	  /* If we have more to copy than the remaining size of the ringbuffer, then we
	     first fill the ringbuffer from the input and then flush the ringbuffer to
	     the output */
	  while (rb_pos + len >= rb_size) {
	    nbytes = rb_size - rb_pos;
	    if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) {
	      throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
	    }
	    output.write(ringbuffer, rb_size);
	    len -= nbytes;
	    rb_pos = 0;
	  }
	
	  /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
	     flushed to the output at a later time. */
	  if (br.input_.read(ringbuffer, rb_pos, len) < len) {
	    throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
	  }
	
	  /* Restore the state of the bit reader. */
	  br.reset();
	}
	
	/* Advances the bit reader position to the next byte boundary and verifies
	   that any skipped bits are set to zero. */
	function JumpToByteBoundary(br) {
	  var new_bit_pos = (br.bit_pos_ + 7) & ~7;
	  var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
	  return pad_bits == 0;
	}
	
	function BrotliDecompressedSize(buffer) {
	  var input = new BrotliInput(buffer);
	  var br = new BrotliBitReader(input);
	  DecodeWindowBits(br);
	  var out = DecodeMetaBlockLength(br);
	  return out.meta_block_length;
	}
	
	exports.BrotliDecompressedSize = BrotliDecompressedSize;
	
	function BrotliDecompressBuffer(buffer, output_size) {
	  var input = new BrotliInput(buffer);
	  
	  if (output_size == null) {
	    output_size = BrotliDecompressedSize(buffer);
	  }
	  
	  var output_buffer = new Uint8Array(output_size);
	  var output = new BrotliOutput(output_buffer);
	  
	  BrotliDecompress(input, output);
	  
	  if (output.pos < output.buffer.length) {
	    output.buffer = output.buffer.subarray(0, output.pos);
	  }
	  
	  return output.buffer;
	}
	
	exports.BrotliDecompressBuffer = BrotliDecompressBuffer;
	
	function BrotliDecompress(input, output) {
	  var i;
	  var pos = 0;
	  var input_end = 0;
	  var window_bits = 0;
	  var max_backward_distance;
	  var max_distance = 0;
	  var ringbuffer_size;
	  var ringbuffer_mask;
	  var ringbuffer;
	  var ringbuffer_end;
	  /* This ring buffer holds a few past copy distances that will be used by */
	  /* some special distance codes. */
	  var dist_rb = [ 16, 15, 11, 4 ];
	  var dist_rb_idx = 0;
	  /* The previous 2 bytes used for context. */
	  var prev_byte1 = 0;
	  var prev_byte2 = 0;
	  var hgroup = [new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0)];
	  var block_type_trees;
	  var block_len_trees;
	  var br;
	
	  /* We need the slack region for the following reasons:
	       - always doing two 8-byte copies for fast backward copying
	       - transforms
	       - flushing the input ringbuffer when decoding uncompressed blocks */
	  var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;
	
	  br = new BrotliBitReader(input);
	
	  /* Decode window size. */
	  window_bits = DecodeWindowBits(br);
	  max_backward_distance = (1 << window_bits) - 16;
	
	  ringbuffer_size = 1 << window_bits;
	  ringbuffer_mask = ringbuffer_size - 1;
	  ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
	  ringbuffer_end = ringbuffer_size;
	
	  block_type_trees = [];
	  block_len_trees = [];
	  for (var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++) {
	    block_type_trees[x] = new HuffmanCode(0, 0);
	    block_len_trees[x] = new HuffmanCode(0, 0);
	  }
	
	  while (!input_end) {
	    var meta_block_remaining_len = 0;
	    var is_uncompressed;
	    var block_length = [ 1 << 28, 1 << 28, 1 << 28 ];
	    var block_type = [ 0 ];
	    var num_block_types = [ 1, 1, 1 ];
	    var block_type_rb = [ 0, 1, 0, 1, 0, 1 ];
	    var block_type_rb_index = [ 0 ];
	    var distance_postfix_bits;
	    var num_direct_distance_codes;
	    var distance_postfix_mask;
	    var num_distance_codes;
	    var context_map = null;
	    var context_modes = null;
	    var num_literal_htrees;
	    var dist_context_map = null;
	    var num_dist_htrees;
	    var context_offset = 0;
	    var context_map_slice = null;
	    var literal_htree_index = 0;
	    var dist_context_offset = 0;
	    var dist_context_map_slice = null;
	    var dist_htree_index = 0;
	    var context_lookup_offset1 = 0;
	    var context_lookup_offset2 = 0;
	    var context_mode;
	    var htree_command;
	
	    for (i = 0; i < 3; ++i) {
	      hgroup[i].codes = null;
	      hgroup[i].htrees = null;
	    }
	
	    br.readMoreInput();
	    
	    var _out = DecodeMetaBlockLength(br);
	    meta_block_remaining_len = _out.meta_block_length;
	    if (pos + meta_block_remaining_len > output.buffer.length) {
	      /* We need to grow the output buffer to fit the additional data. */
	      var tmp = new Uint8Array( pos + meta_block_remaining_len );
	      tmp.set( output.buffer );
	      output.buffer = tmp;
	    }    
	    input_end = _out.input_end;
	    is_uncompressed = _out.is_uncompressed;
	    
	    if (_out.is_metadata) {
	      JumpToByteBoundary(br);
	      
	      for (; meta_block_remaining_len > 0; --meta_block_remaining_len) {
	        br.readMoreInput();
	        /* Read one byte and ignore it. */
	        br.readBits(8);
	      }
	      
	      continue;
	    }
	    
	    if (meta_block_remaining_len === 0) {
	      continue;
	    }
	    
	    if (is_uncompressed) {
	      br.bit_pos_ = (br.bit_pos_ + 7) & ~7;
	      CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos,
	                                    ringbuffer, ringbuffer_mask, br);
	      pos += meta_block_remaining_len;
	      continue;
	    }
	    
	    for (i = 0; i < 3; ++i) {
	      num_block_types[i] = DecodeVarLenUint8(br) + 1;
	      if (num_block_types[i] >= 2) {
	        ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
	        ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
	        block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
	        block_type_rb_index[i] = 1;
	      }
	    }
	    
	    br.readMoreInput();
	    
	    distance_postfix_bits = br.readBits(2);
	    num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
	    distance_postfix_mask = (1 << distance_postfix_bits) - 1;
	    num_distance_codes = (num_direct_distance_codes + (48 << distance_postfix_bits));
	    context_modes = new Uint8Array(num_block_types[0]);
	
	    for (i = 0; i < num_block_types[0]; ++i) {
	       br.readMoreInput();
	       context_modes[i] = (br.readBits(2) << 1);
	    }
	    
	    var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
	    num_literal_htrees = _o1.num_htrees;
	    context_map = _o1.context_map;
	    
	    var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
	    num_dist_htrees = _o2.num_htrees;
	    dist_context_map = _o2.context_map;
	    
	    hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
	    hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
	    hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
	
	    for (i = 0; i < 3; ++i) {
	      hgroup[i].decode(br);
	    }
	
	    context_map_slice = 0;
	    dist_context_map_slice = 0;
	    context_mode = context_modes[block_type[0]];
	    context_lookup_offset1 = Context.lookupOffsets[context_mode];
	    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
	    htree_command = hgroup[1].htrees[0];
	
	    while (meta_block_remaining_len > 0) {
	      var cmd_code;
	      var range_idx;
	      var insert_code;
	      var copy_code;
	      var insert_length;
	      var copy_length;
	      var distance_code;
	      var distance;
	      var context;
	      var j;
	      var copy_dst;
	
	      br.readMoreInput();
	      
	      if (block_length[1] === 0) {
	        DecodeBlockType(num_block_types[1],
	                        block_type_trees, 1, block_type, block_type_rb,
	                        block_type_rb_index, br);
	        block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
	        htree_command = hgroup[1].htrees[block_type[1]];
	      }
	      --block_length[1];
	      cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
	      range_idx = cmd_code >> 6;
	      if (range_idx >= 2) {
	        range_idx -= 2;
	        distance_code = -1;
	      } else {
	        distance_code = 0;
	      }
	      insert_code = Prefix.kInsertRangeLut[range_idx] + ((cmd_code >> 3) & 7);
	      copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
	      insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset +
	          br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
	      copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset +
	          br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
	      prev_byte1 = ringbuffer[pos-1 & ringbuffer_mask];
	      prev_byte2 = ringbuffer[pos-2 & ringbuffer_mask];
	      for (j = 0; j < insert_length; ++j) {
	        br.readMoreInput();
	
	        if (block_length[0] === 0) {
	          DecodeBlockType(num_block_types[0],
	                          block_type_trees, 0, block_type, block_type_rb,
	                          block_type_rb_index, br);
	          block_length[0] = ReadBlockLength(block_len_trees, 0, br);
	          context_offset = block_type[0] << kLiteralContextBits;
	          context_map_slice = context_offset;
	          context_mode = context_modes[block_type[0]];
	          context_lookup_offset1 = Context.lookupOffsets[context_mode];
	          context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
	        }
	        context = (Context.lookup[context_lookup_offset1 + prev_byte1] |
	                   Context.lookup[context_lookup_offset2 + prev_byte2]);
	        literal_htree_index = context_map[context_map_slice + context];
	        --block_length[0];
	        prev_byte2 = prev_byte1;
	        prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
	        ringbuffer[pos & ringbuffer_mask] = prev_byte1;
	        if ((pos & ringbuffer_mask) === ringbuffer_mask) {
	          output.write(ringbuffer, ringbuffer_size);
	        }
	        ++pos;
	      }
	      meta_block_remaining_len -= insert_length;
	      if (meta_block_remaining_len <= 0) break;
	
	      if (distance_code < 0) {
	        var context;
	        
	        br.readMoreInput();
	        if (block_length[2] === 0) {
	          DecodeBlockType(num_block_types[2],
	                          block_type_trees, 2, block_type, block_type_rb,
	                          block_type_rb_index, br);
	          block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
	          dist_context_offset = block_type[2] << kDistanceContextBits;
	          dist_context_map_slice = dist_context_offset;
	        }
	        --block_length[2];
	        context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
	        dist_htree_index = dist_context_map[dist_context_map_slice + context];
	        distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
	        if (distance_code >= num_direct_distance_codes) {
	          var nbits;
	          var postfix;
	          var offset;
	          distance_code -= num_direct_distance_codes;
	          postfix = distance_code & distance_postfix_mask;
	          distance_code >>= distance_postfix_bits;
	          nbits = (distance_code >> 1) + 1;
	          offset = ((2 + (distance_code & 1)) << nbits) - 4;
	          distance_code = num_direct_distance_codes +
	              ((offset + br.readBits(nbits)) <<
	               distance_postfix_bits) + postfix;
	        }
	      }
	
	      /* Convert the distance code to the actual distance by possibly looking */
	      /* up past distnaces from the ringbuffer. */
	      distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
	      if (distance < 0) {
	        throw new Error('[BrotliDecompress] invalid distance');
	      }
	
	      if (pos < max_backward_distance &&
	          max_distance !== max_backward_distance) {
	        max_distance = pos;
	      } else {
	        max_distance = max_backward_distance;
	      }
	
	      copy_dst = pos & ringbuffer_mask;
	
	      if (distance > max_distance) {
	        if (copy_length >= BrotliDictionary.minDictionaryWordLength &&
	            copy_length <= BrotliDictionary.maxDictionaryWordLength) {
	          var offset = BrotliDictionary.offsetsByLength[copy_length];
	          var word_id = distance - max_distance - 1;
	          var shift = BrotliDictionary.sizeBitsByLength[copy_length];
	          var mask = (1 << shift) - 1;
	          var word_idx = word_id & mask;
	          var transform_idx = word_id >> shift;
	          offset += word_idx * copy_length;
	          if (transform_idx < Transform.kNumTransforms) {
	            var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
	            copy_dst += len;
	            pos += len;
	            meta_block_remaining_len -= len;
	            if (copy_dst >= ringbuffer_end) {
	              output.write(ringbuffer, ringbuffer_size);
	              
	              for (var _x = 0; _x < (copy_dst - ringbuffer_end); _x++)
	                ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
	            }
	          } else {
	            throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
	              " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
	          }
	        } else {
	          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
	            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
	        }
	      } else {
	        if (distance_code > 0) {
	          dist_rb[dist_rb_idx & 3] = distance;
	          ++dist_rb_idx;
	        }
	
	        if (copy_length > meta_block_remaining_len) {
	          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
	            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
	        }
	
	        for (j = 0; j < copy_length; ++j) {
	          ringbuffer[pos & ringbuffer_mask] = ringbuffer[(pos - distance) & ringbuffer_mask];
	          if ((pos & ringbuffer_mask) === ringbuffer_mask) {
	            output.write(ringbuffer, ringbuffer_size);
	          }
	          ++pos;
	          --meta_block_remaining_len;
	        }
	      }
	
	      /* When we get here, we must have inserted at least one literal and */
	      /* made a copy of at least length two, therefore accessing the last 2 */
	      /* bytes is valid. */
	      prev_byte1 = ringbuffer[(pos - 1) & ringbuffer_mask];
	      prev_byte2 = ringbuffer[(pos - 2) & ringbuffer_mask];
	    }
	
	    /* Protect pos from overflow, wrap it around at every GB of input data */
	    pos &= 0x3fffffff;
	  }
	
	  output.write(ringbuffer, pos & ringbuffer_mask);
	}
	
	exports.BrotliDecompress = BrotliDecompress;
	
	BrotliDictionary.init();
	
	
	/***/ }),
	/* 118 */
	/***/ (function(module, exports) {
	
	function BrotliInput(buffer) {
	  this.buffer = buffer;
	  this.pos = 0;
	}
	
	BrotliInput.prototype.read = function(buf, i, count) {
	  if (this.pos + count > this.buffer.length) {
	    count = this.buffer.length - this.pos;
	  }
	  
	  for (var p = 0; p < count; p++)
	    buf[i + p] = this.buffer[this.pos + p];
	  
	  this.pos += count;
	  return count;
	}
	
	exports.BrotliInput = BrotliInput;
	
	function BrotliOutput(buf) {
	  this.buffer = buf;
	  this.pos = 0;
	}
	
	BrotliOutput.prototype.write = function(buf, count) {
	  if (this.pos + count > this.buffer.length)
	    throw new Error('Output buffer is not large enough');
	  
	  this.buffer.set(buf.subarray(0, count), this.pos);
	  this.pos += count;
	  return count;
	};
	
	exports.BrotliOutput = BrotliOutput;
	
	
	/***/ }),
	/* 119 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* Copyright 2013 Google Inc. All Rights Reserved.
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	
	   Collection of static dictionary words.
	*/
	
	var data = __webpack_require__(286);
	exports.init = function() {
	  exports.dictionary = data.init();
	};
	
	exports.offsetsByLength = new Uint32Array([
	     0,     0,     0,     0,     0,  4096,  9216, 21504, 35840, 44032,
	 53248, 63488, 74752, 87040, 93696, 100864, 104704, 106752, 108928, 113536,
	 115968, 118528, 119872, 121280, 122016,
	]);
	
	exports.sizeBitsByLength = new Uint8Array([
	  0,  0,  0,  0, 10, 10, 11, 11, 10, 10,
	 10, 10, 10,  9,  9,  8,  7,  7,  8,  7,
	  7,  6,  6,  5,  5,
	]);
	
	exports.minDictionaryWordLength = 4;
	exports.maxDictionaryWordLength = 24;
	
	
	/***/ }),
	/* 120 */
	/***/ (function(module, exports) {
	
	function HuffmanCode(bits, value) {
	  this.bits = bits;   /* number of bits used for this symbol */
	  this.value = value; /* symbol value or table offset */
	}
	
	exports.HuffmanCode = HuffmanCode;
	
	var MAX_LENGTH = 15;
	
	/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
	   bit-wise reversal of the len least significant bits of key. */
	function GetNextKey(key, len) {
	  var step = 1 << (len - 1);
	  while (key & step) {
	    step >>= 1;
	  }
	  return (key & (step - 1)) + step;
	}
	
	/* Stores code in table[0], table[step], table[2*step], ..., table[end] */
	/* Assumes that end is an integer multiple of step */
	function ReplicateValue(table, i, step, end, code) {
	  do {
	    end -= step;
	    table[i + end] = new HuffmanCode(code.bits, code.value);
	  } while (end > 0);
	}
	
	/* Returns the table width of the next 2nd level table. count is the histogram
	   of bit lengths for the remaining symbols, len is the code length of the next
	   processed symbol */
	function NextTableBitSize(count, len, root_bits) {
	  var left = 1 << (len - root_bits);
	  while (len < MAX_LENGTH) {
	    left -= count[len];
	    if (left <= 0) break;
	    ++len;
	    left <<= 1;
	  }
	  return len - root_bits;
	}
	
	exports.BrotliBuildHuffmanTable = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
	  var start_table = table;
	  var code;            /* current table entry */
	  var len;             /* current code length */
	  var symbol;          /* symbol index in original or sorted table */
	  var key;             /* reversed prefix code */
	  var step;            /* step size to replicate values in current table */
	  var low;             /* low bits for current root entry */
	  var mask;            /* mask for low bits */
	  var table_bits;      /* key length of current table */
	  var table_size;      /* size of current table */
	  var total_size;      /* sum of root table size and 2nd level table sizes */
	  var sorted;          /* symbols sorted by code length */
	  var count = new Int32Array(MAX_LENGTH + 1);  /* number of codes of each length */
	  var offset = new Int32Array(MAX_LENGTH + 1);  /* offsets in sorted table for each length */
	
	  sorted = new Int32Array(code_lengths_size);
	
	  /* build histogram of code lengths */
	  for (symbol = 0; symbol < code_lengths_size; symbol++) {
	    count[code_lengths[symbol]]++;
	  }
	
	  /* generate offsets into sorted symbol table by code length */
	  offset[1] = 0;
	  for (len = 1; len < MAX_LENGTH; len++) {
	    offset[len + 1] = offset[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (symbol = 0; symbol < code_lengths_size; symbol++) {
	    if (code_lengths[symbol] !== 0) {
	      sorted[offset[code_lengths[symbol]]++] = symbol;
	    }
	  }
	  
	  table_bits = root_bits;
	  table_size = 1 << table_bits;
	  total_size = table_size;
	
	  /* special case code with only one value */
	  if (offset[MAX_LENGTH] === 1) {
	    for (key = 0; key < total_size; ++key) {
	      root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
	    }
	    
	    return total_size;
	  }
	
	  /* fill in root table */
	  key = 0;
	  symbol = 0;
	  for (len = 1, step = 2; len <= root_bits; ++len, step <<= 1) {
	    for (; count[len] > 0; --count[len]) {
	      code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
	      ReplicateValue(root_table, table + key, step, table_size, code);
	      key = GetNextKey(key, len);
	    }
	  }
	
	  /* fill in 2nd level tables and add pointers to root table */
	  mask = total_size - 1;
	  low = -1;
	  for (len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1) {
	    for (; count[len] > 0; --count[len]) {
	      if ((key & mask) !== low) {
	        table += table_size;
	        table_bits = NextTableBitSize(count, len, root_bits);
	        table_size = 1 << table_bits;
	        total_size += table_size;
	        low = key & mask;
	        root_table[start_table + low] = new HuffmanCode((table_bits + root_bits) & 0xff, ((table - start_table) - low) & 0xffff);
	      }
	      code = new HuffmanCode((len - root_bits) & 0xff, sorted[symbol++] & 0xffff);
	      ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
	      key = GetNextKey(key, len);
	    }
	  }
	  
	  return total_size;
	}
	
	
	/***/ }),
	/* 121 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	
	/*
	PDFImage - embeds images in PDF documents
	By Devon Govett
	 */
	
	(function() {
	  var Data, JPEG, PDFImage, PNG, fs;
	
	  fs = __webpack_require__(8);
	
	  Data = __webpack_require__(298);
	
	  JPEG = __webpack_require__(299);
	
	  PNG = __webpack_require__(300);
	
	  PDFImage = (function() {
	    function PDFImage() {}
	
	    PDFImage.open = function(src, label) {
	      var data, match;
	      if (Buffer.isBuffer(src)) {
	        data = src;
	      } else if (src instanceof ArrayBuffer) {
	        data = new Buffer(new Uint8Array(src));
	      } else {
	        if (match = /^data:.+;base64,(.*)$/.exec(src)) {
	          data = new Buffer(match[1], 'base64');
	        } else {
	          data = fs.readFileSync(src);
	          if (!data) {
	            return;
	          }
	        }
	      }
	      if (data[0] === 0xff && data[1] === 0xd8) {
	        return new JPEG(data, label);
	      } else if (data[0] === 0x89 && data.toString('ascii', 1, 4) === 'PNG') {
	        return new PNG(data, label);
	      } else {
	        throw new Error('Unknown image format.');
	      }
	    };
	
	    return PDFImage;
	
	  })();
	
	  module.exports = PDFImage;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 122 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["pdfMake"] = __webpack_require__(123);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))
	
	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(Buffer, global) {
	
	var PdfPrinter = __webpack_require__(126);
	var isFunction = __webpack_require__(0).isFunction;
	var FileSaver = __webpack_require__(306);
	var saveAs = FileSaver.saveAs;
	
	var defaultClientFonts = {
		Roboto: {
			normal: 'Roboto-Regular.ttf',
			bold: 'Roboto-Medium.ttf',
			italics: 'Roboto-Italic.ttf',
			bolditalics: 'Roboto-MediumItalic.ttf'
		}
	};
	
	function Document(docDefinition, tableLayouts, fonts, vfs) {
		this.docDefinition = docDefinition;
		this.tableLayouts = tableLayouts || null;
		this.fonts = fonts || defaultClientFonts;
		this.vfs = vfs;
	}
	
	function canCreatePdf() {
		// Ensure the browser provides the level of support needed
		if (!Object.keys) {
			return false;
		}
		return true;
	}
	
	Document.prototype._createDoc = function (options, callback) {
		options = options || {};
		if (this.tableLayouts) {
			options.tableLayouts = this.tableLayouts;
		}
	
		var printer = new PdfPrinter(this.fonts);
		__webpack_require__(8).bindFS(this.vfs); // bind virtual file system to file system
	
		var doc = printer.createPdfKitDocument(this.docDefinition, options);
		var chunks = [];
		var result;
	
		doc.on('readable', function () {
			var chunk;
			while ((chunk = doc.read(9007199254740991)) !== null) {
				chunks.push(chunk);
			}
		});
		doc.on('end', function () {
			result = Buffer.concat(chunks);
			callback(result, doc._pdfMakePages);
		});
		doc.end();
	};
	
	Document.prototype._getPages = function (options, cb) {
		if (!cb) {
			throw '_getPages is an async method and needs a callback argument';
		}
		this._createDoc(options, function (ignoreBuffer, pages) {
			cb(pages);
		});
	};
	
	Document.prototype._bufferToBlob = function (buffer) {
		var blob;
		try {
			blob = new Blob([buffer], {type: 'application/pdf'});
		} catch (e) {
			// Old browser which can't handle it without making it an byte array (ie10)
			if (e.name === 'InvalidStateError') {
				var byteArray = new Uint8Array(buffer);
				blob = new Blob([byteArray.buffer], {type: 'application/pdf'});
			}
		}
	
		if (!blob) {
			throw 'Could not generate blob';
		}
	
		return blob;
	};
	
	Document.prototype._openWindow = function () {
		// we have to open the window immediately and store the reference
		// otherwise popup blockers will stop us
		var win = window.open('', '_blank');
		if (win === null) {
			throw 'Open PDF in new window blocked by browser';
		}
	
		return win;
	};
	
	Document.prototype._openPdf = function (options, win) {
		if (!win) {
			win = this._openWindow();
		}
		try {
			this.getBlob(function (result) {
				var urlCreator = window.URL || window.webkitURL;
				var pdfUrl = urlCreator.createObjectURL(result);
				win.location.href = pdfUrl;
			}, options);
		} catch (e) {
			win.close();
			throw e;
		}
	};
	
	Document.prototype.open = function (options, win) {
		options = options || {};
		options.autoPrint = false;
		win = win || null;
	
		this._openPdf(options, win);
	};
	
	
	Document.prototype.print = function (options, win) {
		options = options || {};
		options.autoPrint = true;
		win = win || null;
	
		this._openPdf(options, win);
	};
	
	Document.prototype.download = function (defaultFileName, cb, options) {
		if (isFunction(defaultFileName)) {
			cb = defaultFileName;
			defaultFileName = null;
		}
	
		defaultFileName = defaultFileName || 'file.pdf';
		this.getBlob(function (result) {
			saveAs(result, defaultFileName);
	
			if (isFunction(cb)) {
				cb();
			}
		}, options);
	};
	
	Document.prototype.getBase64 = function (cb, options) {
		if (!cb) {
			throw 'getBase64 is an async method and needs a callback argument';
		}
		this.getBuffer(function (buffer) {
			cb(buffer.toString('base64'));
		}, options);
	};
	
	Document.prototype.getDataUrl = function (cb, options) {
		if (!cb) {
			throw 'getDataUrl is an async method and needs a callback argument';
		}
		this.getBuffer(function (buffer) {
			cb('data:application/pdf;base64,' + buffer.toString('base64'));
		}, options);
	};
	
	Document.prototype.getBlob = function (cb, options) {
		if (!cb) {
			throw 'getBlob is an async method and needs a callback argument';
		}
		var that = this;
		this.getBuffer(function (result) {
			var blob = that._bufferToBlob(result);
			cb(blob);
		}, options);
	};
	
	Document.prototype.getBuffer = function (cb, options) {
		if (!cb) {
			throw 'getBuffer is an async method and needs a callback argument';
		}
		this._createDoc(options, function (buffer) {
			cb(buffer);
		});
	};
	
	module.exports = {
		createPdf: function (docDefinition) {
			if (!canCreatePdf()) {
				throw 'Your browser does not provide the level of support needed';
			}
			return new Document(docDefinition, global.pdfMake.tableLayouts, global.pdfMake.fonts, global.pdfMake.vfs);
		}
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, __webpack_require__(7)))
	
	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}
	
	
	/***/ }),
	/* 125 */
	/***/ (function(module, exports) {
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}
	
	
	/***/ }),
	/* 126 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*eslint no-unused-vars: ["error", {"args": "none"}]*/
	
	
	var FontProvider = __webpack_require__(127);
	var LayoutBuilder = __webpack_require__(128);
	var PdfKit = __webpack_require__(138);
	var sizes = __webpack_require__(303);
	var ImageMeasure = __webpack_require__(304);
	var textDecorator = __webpack_require__(305);
	var TextTools = __webpack_require__(42);
	var isFunction = __webpack_require__(0).isFunction;
	var isString = __webpack_require__(0).isString;
	var isNumber = __webpack_require__(0).isNumber;
	var isBoolean = __webpack_require__(0).isBoolean;
	var isArray = __webpack_require__(0).isArray;
	
	////////////////////////////////////////
	// PdfPrinter
	
	/**
	 * @class Creates an instance of a PdfPrinter which turns document definition into a pdf
	 *
	 * @param {Object} fontDescriptors font definition dictionary
	 *
	 * @example
	 * var fontDescriptors = {
	 *	Roboto: {
	 *		normal: 'fonts/Roboto-Regular.ttf',
	 *		bold: 'fonts/Roboto-Medium.ttf',
	 *		italics: 'fonts/Roboto-Italic.ttf',
	 *		bolditalics: 'fonts/Roboto-MediumItalic.ttf'
	 *	}
	 * };
	 *
	 * var printer = new PdfPrinter(fontDescriptors);
	 */
	function PdfPrinter(fontDescriptors) {
		this.fontDescriptors = fontDescriptors;
	}
	
	/**
	 * Executes layout engine for the specified document and renders it into a pdfkit document
	 * ready to be saved.
	 *
	 * @param {Object} docDefinition document definition
	 * @param {Object} docDefinition.content an array describing the pdf structure (for more information take a look at the examples in the /examples folder)
	 * @param {Object} [docDefinition.defaultStyle] default (implicit) style definition
	 * @param {Object} [docDefinition.styles] dictionary defining all styles which can be used in the document
	 * @param {Object} [docDefinition.pageSize] page size (pdfkit units, A4 dimensions by default)
	 * @param {Number} docDefinition.pageSize.width width
	 * @param {Number} docDefinition.pageSize.height height
	 * @param {Object} [docDefinition.pageMargins] page margins (pdfkit units)
	 * @param {Number} docDefinition.maxPagesNumber maximum number of pages to render
	 *
	 * @example
	 *
	 * var docDefinition = {
	 * 	info: {
	 *		title: 'awesome Document',
	 *		author: 'john doe',
	 *		subject: 'subject of document',
	 *		keywords: 'keywords for document',
	 * 	},
	 *	content: [
	 *		'First paragraph',
	 *		'Second paragraph, this time a little bit longer',
	 *		{ text: 'Third paragraph, slightly bigger font size', fontSize: 20 },
	 *		{ text: 'Another paragraph using a named style', style: 'header' },
	 *		{ text: ['playing with ', 'inlines' ] },
	 *		{ text: ['and ', { text: 'restyling ', bold: true }, 'them'] },
	 *	],
	 *	styles: {
	 *		header: { fontSize: 30, bold: true }
	 *	}
	 * }
	 *
	 * var pdfKitDoc = printer.createPdfKitDocument(docDefinition);
	 *
	 * pdfKitDoc.pipe(fs.createWriteStream('sample.pdf'));
	 * pdfKitDoc.end();
	 *
	 * @return {Object} a pdfKit document object which can be saved or encode to data-url
	 */
	PdfPrinter.prototype.createPdfKitDocument = function (docDefinition, options) {
		options = options || {};
	
		var pageSize = fixPageSize(docDefinition.pageSize, docDefinition.pageOrientation);
		var compressPdf = isBoolean(docDefinition.compress) ? docDefinition.compress : true;
	
		this.pdfKitDoc = new PdfKit({size: [pageSize.width, pageSize.height], autoFirstPage: false, compress: compressPdf});
		setMetadata(docDefinition, this.pdfKitDoc);
	
		this.fontProvider = new FontProvider(this.fontDescriptors, this.pdfKitDoc);
	
		docDefinition.images = docDefinition.images || {};
	
		var builder = new LayoutBuilder(pageSize, fixPageMargins(docDefinition.pageMargins || 40), new ImageMeasure(this.pdfKitDoc, docDefinition.images));
	
		registerDefaultTableLayouts(builder);
		if (options.tableLayouts) {
			builder.registerTableLayouts(options.tableLayouts);
		}
	
		var pages = builder.layoutDocument(docDefinition.content, this.fontProvider, docDefinition.styles || {}, docDefinition.defaultStyle || {fontSize: 12, font: 'Roboto'}, docDefinition.background, docDefinition.header, docDefinition.footer, docDefinition.images, docDefinition.watermark, docDefinition.pageBreakBefore);
		var maxNumberPages = docDefinition.maxPagesNumber || -1;
		if (isNumber(maxNumberPages) && maxNumberPages > -1) {
			pages = pages.slice(0, maxNumberPages);
		}
	
		// if pageSize.height is set to Infinity, calculate the actual height of the page that
		// was laid out using the height of each of the items in the page.
		if (pageSize.height === Infinity) {
			var pageHeight = calculatePageHeight(pages, docDefinition.pageMargins);
			this.pdfKitDoc.options.size = [pageSize.width, pageHeight];
		}
	
		renderPages(pages, this.fontProvider, this.pdfKitDoc, options.progressCallback);
	
		if (options.autoPrint) {
			var printActionRef = this.pdfKitDoc.ref({
				Type: 'Action',
				S: 'Named',
				N: 'Print'
			});
			this.pdfKitDoc._root.data.OpenAction = printActionRef;
			printActionRef.end();
		}
		return this.pdfKitDoc;
	};
	
	function setMetadata(docDefinition, pdfKitDoc) {
		// PDF standard has these properties reserved: Title, Author, Subject, Keywords,
		// Creator, Producer, CreationDate, ModDate, Trapped.
		// To keep the pdfmake api consistent, the info field are defined lowercase.
		// Custom properties don't contain a space.
		function standardizePropertyKey(key) {
			var standardProperties = ['Title', 'Author', 'Subject', 'Keywords',
				'Creator', 'Producer', 'CreationDate', 'ModDate', 'Trapped'];
			var standardizedKey = key.charAt(0).toUpperCase() + key.slice(1);
			if (standardProperties.indexOf(standardizedKey) !== -1) {
				return standardizedKey;
			}
	
			return key.replace(/\s+/g, '');
		}
	
		pdfKitDoc.info.Producer = 'pdfmake';
		pdfKitDoc.info.Creator = 'pdfmake';
	
		if (docDefinition.info) {
			for (var key in docDefinition.info) {
				var value = docDefinition.info[key];
				if (value) {
					key = standardizePropertyKey(key);
					pdfKitDoc.info[key] = value;
				}
			}
		}
	}
	
	function calculatePageHeight(pages, margins) {
		function getItemHeight(item) {
			if (isFunction(item.item.getHeight)) {
				return item.item.getHeight();
			} else if (item.item._height) {
				return item.item._height;
			} else {
				// TODO: add support for next item types
				return 0;
			}
		}
	
		var fixedMargins = fixPageMargins(margins || 40);
		var height = fixedMargins.top + fixedMargins.bottom;
		pages.forEach(function (page) {
			page.items.forEach(function (item) {
				height += getItemHeight(item);
			});
		});
		return height;
	}
	
	function fixPageSize(pageSize, pageOrientation) {
		function isNeedSwapPageSizes(pageOrientation) {
			if (isString(pageOrientation)) {
				pageOrientation = pageOrientation.toLowerCase();
				return ((pageOrientation === 'portrait') && (size.width > size.height)) ||
					((pageOrientation === 'landscape') && (size.width < size.height));
			}
			return false;
		}
	
		// if pageSize.height is set to auto, set the height to infinity so there are no page breaks.
		if (pageSize && pageSize.height === 'auto') {
			pageSize.height = Infinity;
		}
	
		var size = pageSize2widthAndHeight(pageSize || 'A4');
		if (isNeedSwapPageSizes(pageOrientation)) { // swap page sizes
			size = {width: size.height, height: size.width};
		}
		size.orientation = size.width > size.height ? 'landscape' : 'portrait';
		return size;
	}
	
	function fixPageMargins(margin) {
		if (!margin) {
			return null;
		}
	
		if (isNumber(margin)) {
			margin = {left: margin, right: margin, top: margin, bottom: margin};
		} else if (isArray(margin)) {
			if (margin.length === 2) {
				margin = {left: margin[0], top: margin[1], right: margin[0], bottom: margin[1]};
			} else if (margin.length === 4) {
				margin = {left: margin[0], top: margin[1], right: margin[2], bottom: margin[3]};
			} else {
				throw 'Invalid pageMargins definition';
			}
		}
	
		return margin;
	}
	
	function registerDefaultTableLayouts(layoutBuilder) {
		layoutBuilder.registerTableLayouts({
			noBorders: {
				hLineWidth: function (i) {
					return 0;
				},
				vLineWidth: function (i) {
					return 0;
				},
				paddingLeft: function (i) {
					return i && 4 || 0;
				},
				paddingRight: function (i, node) {
					return (i < node.table.widths.length - 1) ? 4 : 0;
				}
			},
			headerLineOnly: {
				hLineWidth: function (i, node) {
					if (i === 0 || i === node.table.body.length) {
						return 0;
					}
					return (i === node.table.headerRows) ? 2 : 0;
				},
				vLineWidth: function (i) {
					return 0;
				},
				paddingLeft: function (i) {
					return i === 0 ? 0 : 8;
				},
				paddingRight: function (i, node) {
					return (i === node.table.widths.length - 1) ? 0 : 8;
				}
			},
			lightHorizontalLines: {
				hLineWidth: function (i, node) {
					if (i === 0 || i === node.table.body.length) {
						return 0;
					}
					return (i === node.table.headerRows) ? 2 : 1;
				},
				vLineWidth: function (i) {
					return 0;
				},
				hLineColor: function (i) {
					return i === 1 ? 'black' : '#aaa';
				},
				paddingLeft: function (i) {
					return i === 0 ? 0 : 8;
				},
				paddingRight: function (i, node) {
					return (i === node.table.widths.length - 1) ? 0 : 8;
				}
			}
		});
	}
	
	function pageSize2widthAndHeight(pageSize) {
		if (isString(pageSize)) {
			var size = sizes[pageSize.toUpperCase()];
			if (!size) {
				throw 'Page size ' + pageSize + ' not recognized';
			}
			return {width: size[0], height: size[1]};
		}
	
		return pageSize;
	}
	
	function updatePageOrientationInOptions(currentPage, pdfKitDoc) {
		var previousPageOrientation = pdfKitDoc.options.size[0] > pdfKitDoc.options.size[1] ? 'landscape' : 'portrait';
	
		if (currentPage.pageSize.orientation !== previousPageOrientation) {
			var width = pdfKitDoc.options.size[0];
			var height = pdfKitDoc.options.size[1];
			pdfKitDoc.options.size = [height, width];
		}
	}
	
	function renderPages(pages, fontProvider, pdfKitDoc, progressCallback) {
		pdfKitDoc._pdfMakePages = pages;
		pdfKitDoc.addPage();
	
		var totalItems = 0;
		if (progressCallback) {
			pages.forEach(function (page) {
				totalItems += page.items.length;
			});
		}
	
		var renderedItems = 0;
		progressCallback = progressCallback || function () {};
	
		for (var i = 0; i < pages.length; i++) {
			if (i > 0) {
				updatePageOrientationInOptions(pages[i], pdfKitDoc);
				pdfKitDoc.addPage(pdfKitDoc.options);
			}
	
			var page = pages[i];
			for (var ii = 0, il = page.items.length; ii < il; ii++) {
				var item = page.items[ii];
				switch (item.type) {
					case 'vector':
						renderVector(item.item, pdfKitDoc);
						break;
					case 'line':
						renderLine(item.item, item.item.x, item.item.y, pdfKitDoc);
						break;
					case 'image':
						renderImage(item.item, item.item.x, item.item.y, pdfKitDoc);
						break;
					case 'beginClip':
						beginClip(item.item, pdfKitDoc);
						break;
					case 'endClip':
						endClip(pdfKitDoc);
						break;
				}
				renderedItems++;
				progressCallback(renderedItems / totalItems);
			}
			if (page.watermark) {
				renderWatermark(page, pdfKitDoc);
			}
		}
	}
	
	function renderLine(line, x, y, pdfKitDoc) {
		if (line._pageNodeRef) {
			var newWidth;
			var diffWidth;
			var textTools = new TextTools(null);
			var pageNumber = line._pageNodeRef.positions[0].pageNumber.toString();
	
			line.inlines[0].text = pageNumber;
			line.inlines[0].linkToPage = pageNumber;
			newWidth = textTools.widthOfString(line.inlines[0].text, line.inlines[0].font, line.inlines[0].fontSize, line.inlines[0].characterSpacing, line.inlines[0].fontFeatures);
			diffWidth = line.inlines[0].width - newWidth;
			line.inlines[0].width = newWidth;
	
			switch (line.inlines[0].alignment) {
				case 'right':
					line.inlines[0].x += diffWidth;
					break;
				case 'center':
					line.inlines[0].x += diffWidth / 2;
					break;
			}
		}
	
		x = x || 0;
		y = y || 0;
	
		var lineHeight = line.getHeight();
		var ascenderHeight = line.getAscenderHeight();
		var descent = lineHeight - ascenderHeight;
	
		textDecorator.drawBackground(line, x, y, pdfKitDoc);
	
		//TODO: line.optimizeInlines();
		for (var i = 0, l = line.inlines.length; i < l; i++) {
			var inline = line.inlines[i];
			var shiftToBaseline = lineHeight - ((inline.font.ascender / 1000) * inline.fontSize) - descent;
			var options = {
				lineBreak: false,
				textWidth: inline.width,
				characterSpacing: inline.characterSpacing,
				wordCount: 1,
				link: inline.link
			};
	
			if (inline.fontFeatures) {
				options.features = inline.fontFeatures;
			}
	
			pdfKitDoc.fill(inline.color || 'black');
	
			pdfKitDoc._font = inline.font;
			pdfKitDoc.fontSize(inline.fontSize);
			pdfKitDoc.text(inline.text, x + inline.x, y + shiftToBaseline, options);
	
			if (inline.linkToPage) {
				var _ref = pdfKitDoc.ref({Type: 'Action', S: 'GoTo', D: [inline.linkToPage, 0, 0]}).end();
				pdfKitDoc.annotate(x + inline.x, y + shiftToBaseline, inline.width, inline.height, {Subtype: 'Link', Dest: [inline.linkToPage - 1, 'XYZ', null, null, null]});
			}
	
		}
	
		textDecorator.drawDecorations(line, x, y, pdfKitDoc);
	}
	
	function renderWatermark(page, pdfKitDoc) {
		var watermark = page.watermark;
	
		pdfKitDoc.fill(watermark.color);
		pdfKitDoc.opacity(watermark.opacity);
	
		pdfKitDoc.save();
	
		var angle = Math.atan2(pdfKitDoc.page.height, pdfKitDoc.page.width) * -180 / Math.PI;
		pdfKitDoc.rotate(angle, {origin: [pdfKitDoc.page.width / 2, pdfKitDoc.page.height / 2]});
	
		var x = pdfKitDoc.page.width / 2 - watermark.size.size.width / 2;
		var y = pdfKitDoc.page.height / 2 - watermark.size.size.height / 4;
	
		pdfKitDoc._font = watermark.font;
		pdfKitDoc.fontSize(watermark.size.fontSize);
		pdfKitDoc.text(watermark.text, x, y, {lineBreak: false});
	
		pdfKitDoc.restore();
	}
	
	function renderVector(vector, pdfKitDoc) {
		//TODO: pdf optimization (there's no need to write all properties everytime)
		pdfKitDoc.lineWidth(vector.lineWidth || 1);
		if (vector.dash) {
			pdfKitDoc.dash(vector.dash.length, {space: vector.dash.space || vector.dash.length, phase: vector.dash.phase || 0});
		} else {
			pdfKitDoc.undash();
		}
		pdfKitDoc.lineJoin(vector.lineJoin || 'miter');
		pdfKitDoc.lineCap(vector.lineCap || 'butt');
	
		//TODO: clipping
	
		switch (vector.type) {
			case 'ellipse':
				pdfKitDoc.ellipse(vector.x, vector.y, vector.r1, vector.r2);
				break;
			case 'rect':
				if (vector.r) {
					pdfKitDoc.roundedRect(vector.x, vector.y, vector.w, vector.h, vector.r);
				} else {
					pdfKitDoc.rect(vector.x, vector.y, vector.w, vector.h);
				}
	
				if (vector.linearGradient) {
					var gradient = pdfKitDoc.linearGradient(vector.x, vector.y, vector.x + vector.w, vector.y);
					var step = 1 / (vector.linearGradient.length - 1);
	
					for (var i = 0; i < vector.linearGradient.length; i++) {
						gradient.stop(i * step, vector.linearGradient[i]);
					}
	
					vector.color = gradient;
				}
				break;
			case 'line':
				pdfKitDoc.moveTo(vector.x1, vector.y1);
				pdfKitDoc.lineTo(vector.x2, vector.y2);
				break;
			case 'polyline':
				if (vector.points.length === 0) {
					break;
				}
	
				pdfKitDoc.moveTo(vector.points[0].x, vector.points[0].y);
				for (var i = 1, l = vector.points.length; i < l; i++) {
					pdfKitDoc.lineTo(vector.points[i].x, vector.points[i].y);
				}
	
				if (vector.points.length > 1) {
					var p1 = vector.points[0];
					var pn = vector.points[vector.points.length - 1];
	
					if (vector.closePath || p1.x === pn.x && p1.y === pn.y) {
						pdfKitDoc.closePath();
					}
				}
				break;
			case 'path':
				pdfKitDoc.path(vector.d);
				break;
		}
	
		if (vector.color && vector.lineColor) {
			pdfKitDoc.fillColor(vector.color, vector.fillOpacity || 1);
			pdfKitDoc.strokeColor(vector.lineColor, vector.strokeOpacity || 1);
			pdfKitDoc.fillAndStroke();
		} else if (vector.color) {
			pdfKitDoc.fillColor(vector.color, vector.fillOpacity || 1);
			pdfKitDoc.fill();
		} else {
			pdfKitDoc.strokeColor(vector.lineColor || 'black', vector.strokeOpacity || 1);
			pdfKitDoc.stroke();
		}
	}
	
	function renderImage(image, x, y, pdfKitDoc) {
		pdfKitDoc.image(image.image, image.x, image.y, {width: image._width, height: image._height});
		if (image.link) {
			pdfKitDoc.link(image.x, image.y, image._width, image._height, image.link);
		}
	}
	
	function beginClip(rect, pdfKitDoc) {
		pdfKitDoc.save();
		pdfKitDoc.addContent('' + rect.x + ' ' + rect.y + ' ' + rect.width + ' ' + rect.height + ' re');
		pdfKitDoc.clip();
	}
	
	function endClip(pdfKitDoc) {
		pdfKitDoc.restore();
	}
	
	module.exports = PdfPrinter;
	
	
	/***/ }),
	/* 127 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var isArray = __webpack_require__(0).isArray;
	
	function typeName(bold, italics) {
		var type = 'normal';
		if (bold && italics) {
			type = 'bolditalics';
		} else if (bold) {
			type = 'bold';
		} else if (italics) {
			type = 'italics';
		}
		return type;
	}
	
	function FontProvider(fontDescriptors, pdfKitDoc) {
		this.fonts = {};
		this.pdfKitDoc = pdfKitDoc;
		this.fontCache = {};
	
		for (var font in fontDescriptors) {
			if (fontDescriptors.hasOwnProperty(font)) {
				var fontDef = fontDescriptors[font];
	
				this.fonts[font] = {
					normal: fontDef.normal,
					bold: fontDef.bold,
					italics: fontDef.italics,
					bolditalics: fontDef.bolditalics
				};
			}
		}
	}
	
	FontProvider.prototype.provideFont = function (familyName, bold, italics) {
		var type = typeName(bold, italics);
		if (!this.fonts[familyName] || !this.fonts[familyName][type]) {
			throw new Error('Font \'' + familyName + '\' in style \'' + type + '\' is not defined in the font section of the document definition.');
		}
	
		this.fontCache[familyName] = this.fontCache[familyName] || {};
	
		if (!this.fontCache[familyName][type]) {
			var def = this.fonts[familyName][type];
			if (!isArray(def)) {
				def = [def];
			}
			this.fontCache[familyName][type] = this.pdfKitDoc.font.apply(this.pdfKitDoc, def)._font;
		}
	
		return this.fontCache[familyName][type];
	};
	
	module.exports = FontProvider;
	
	
	/***/ }),
	/* 128 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var TraversalTracker = __webpack_require__(77);
	var DocPreprocessor = __webpack_require__(129);
	var DocMeasure = __webpack_require__(130);
	var DocumentContext = __webpack_require__(81);
	var PageElementWriter = __webpack_require__(135);
	var ColumnCalculator = __webpack_require__(44);
	var TableProcessor = __webpack_require__(137);
	var Line = __webpack_require__(82);
	var isString = __webpack_require__(0).isString;
	var isArray = __webpack_require__(0).isArray;
	var pack = __webpack_require__(0).pack;
	var offsetVector = __webpack_require__(0).offsetVector;
	var fontStringify = __webpack_require__(0).fontStringify;
	var isFunction = __webpack_require__(0).isFunction;
	var TextTools = __webpack_require__(42);
	var StyleContextStack = __webpack_require__(80);
	
	function addAll(target, otherArray) {
		otherArray.forEach(function (item) {
			target.push(item);
		});
	}
	
	/**
	 * Creates an instance of LayoutBuilder - layout engine which turns document-definition-object
	 * into a set of pages, lines, inlines and vectors ready to be rendered into a PDF
	 *
	 * @param {Object} pageSize - an object defining page width and height
	 * @param {Object} pageMargins - an object defining top, left, right and bottom margins
	 */
	function LayoutBuilder(pageSize, pageMargins, imageMeasure) {
		this.pageSize = pageSize;
		this.pageMargins = pageMargins;
		this.tracker = new TraversalTracker();
		this.imageMeasure = imageMeasure;
		this.tableLayouts = {};
	}
	
	LayoutBuilder.prototype.registerTableLayouts = function (tableLayouts) {
		this.tableLayouts = pack(this.tableLayouts, tableLayouts);
	};
	
	/**
	 * Executes layout engine on document-definition-object and creates an array of pages
	 * containing positioned Blocks, Lines and inlines
	 *
	 * @param {Object} docStructure document-definition-object
	 * @param {Object} fontProvider font provider
	 * @param {Object} styleDictionary dictionary with style definitions
	 * @param {Object} defaultStyle default style definition
	 * @return {Array} an array of pages
	 */
	LayoutBuilder.prototype.layoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
	
		function addPageBreaksIfNecessary(linearNodeList, pages) {
	
			if (!isFunction(pageBreakBeforeFct)) {
				return false;
			}
	
			linearNodeList = linearNodeList.filter(function (node) {
				return node.positions.length > 0;
			});
	
			linearNodeList.forEach(function (node) {
				var nodeInfo = {};
				[
					'id', 'text', 'ul', 'ol', 'table', 'image', 'qr', 'canvas', 'columns',
					'headlineLevel', 'style', 'pageBreak', 'pageOrientation',
					'width', 'height'
				].forEach(function (key) {
					if (node[key] !== undefined) {
						nodeInfo[key] = node[key];
					}
				});
				nodeInfo.startPosition = node.positions[0];
				nodeInfo.pageNumbers = node.positions.map(function (node) {
					return node.pageNumber;
				}).filter(function (element, position, array) {
					return array.indexOf(element) === position;
				});
				nodeInfo.pages = pages.length;
				nodeInfo.stack = isArray(node.stack);
	
				node.nodeInfo = nodeInfo;
			});
	
			return linearNodeList.some(function (node, index, followingNodeList) {
				if (node.pageBreak !== 'before' && !node.pageBreakCalculated) {
					node.pageBreakCalculated = true;
					var pageNumber = node.nodeInfo.pageNumbers[0];
	
					var followingNodesOnPage = followingNodeList.slice(index + 1).filter(function (node0) {
						return node0.nodeInfo.pageNumbers.indexOf(pageNumber) > -1;
					});
	
					var nodesOnNextPage = followingNodeList.slice(index + 1).filter(function (node0) {
						return node0.nodeInfo.pageNumbers.indexOf(pageNumber + 1) > -1;
					});
	
					var previousNodesOnPage = followingNodeList.slice(0, index).filter(function (node0) {
						return node0.nodeInfo.pageNumbers.indexOf(pageNumber) > -1;
					});
	
					if (
						pageBreakBeforeFct(
							node.nodeInfo,
							followingNodesOnPage.map(function (node) {
								return node.nodeInfo;
							}),
							nodesOnNextPage.map(function (node) {
								return node.nodeInfo;
							}),
							previousNodesOnPage.map(function (node) {
								return node.nodeInfo;
							}))) {
						node.pageBreak = 'before';
						return true;
					}
				}
			});
		}
	
		this.docPreprocessor = new DocPreprocessor();
		this.docMeasure = new DocMeasure(fontProvider, styleDictionary, defaultStyle, this.imageMeasure, this.tableLayouts, images);
	
	
		function resetXYs(result) {
			result.linearNodeList.forEach(function (node) {
				node.resetXY();
			});
		}
	
		var result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
		while (addPageBreaksIfNecessary(result.linearNodeList, result.pages)) {
			resetXYs(result);
			result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
		}
	
		return result.pages;
	};
	
	LayoutBuilder.prototype.tryLayoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
	
		this.linearNodeList = [];
		docStructure = this.docPreprocessor.preprocessDocument(docStructure);
		docStructure = this.docMeasure.measureDocument(docStructure);
	
		this.writer = new PageElementWriter(
			new DocumentContext(this.pageSize, this.pageMargins), this.tracker);
	
		var _this = this;
		this.writer.context().tracker.startTracking('pageAdded', function () {
			_this.addBackground(background);
		});
	
		this.addBackground(background);
		this.processNode(docStructure);
		this.addHeadersAndFooters(header, footer);
		if (watermark != null) {
			this.addWatermark(watermark, fontProvider, defaultStyle);
		}
	
		return {pages: this.writer.context().pages, linearNodeList: this.linearNodeList};
	};
	
	
	LayoutBuilder.prototype.addBackground = function (background) {
		var backgroundGetter = isFunction(background) ? background : function () {
			return background;
		};
	
		var pageBackground = backgroundGetter(this.writer.context().page + 1);
	
		if (pageBackground) {
			var pageSize = this.writer.context().getCurrentPage().pageSize;
			this.writer.beginUnbreakableBlock(pageSize.width, pageSize.height);
			pageBackground = this.docPreprocessor.preprocessDocument(pageBackground);
			this.processNode(this.docMeasure.measureDocument(pageBackground));
			this.writer.commitUnbreakableBlock(0, 0);
			this.writer.context().hasBackground = true;
		}
	};
	
	LayoutBuilder.prototype.addStaticRepeatable = function (headerOrFooter, sizeFunction) {
		this.addDynamicRepeatable(function () {
			return JSON.parse(JSON.stringify(headerOrFooter)); // copy to new object
		}, sizeFunction);
	};
	
	LayoutBuilder.prototype.addDynamicRepeatable = function (nodeGetter, sizeFunction) {
		var pages = this.writer.context().pages;
	
		for (var pageIndex = 0, l = pages.length; pageIndex < l; pageIndex++) {
			this.writer.context().page = pageIndex;
	
			var node = nodeGetter(pageIndex + 1, l, this.writer.context().pages[pageIndex].pageSize);
	
			if (node) {
				var sizes = sizeFunction(this.writer.context().getCurrentPage().pageSize, this.pageMargins);
				this.writer.beginUnbreakableBlock(sizes.width, sizes.height);
				node = this.docPreprocessor.preprocessDocument(node);
				this.processNode(this.docMeasure.measureDocument(node));
				this.writer.commitUnbreakableBlock(sizes.x, sizes.y);
			}
		}
	};
	
	LayoutBuilder.prototype.addHeadersAndFooters = function (header, footer) {
		var headerSizeFct = function (pageSize, pageMargins) {
			return {
				x: 0,
				y: 0,
				width: pageSize.width,
				height: pageMargins.top
			};
		};
	
		var footerSizeFct = function (pageSize, pageMargins) {
			return {
				x: 0,
				y: pageSize.height - pageMargins.bottom,
				width: pageSize.width,
				height: pageMargins.bottom
			};
		};
	
		if (isFunction(header)) {
			this.addDynamicRepeatable(header, headerSizeFct);
		} else if (header) {
			this.addStaticRepeatable(header, headerSizeFct);
		}
	
		if (isFunction(footer)) {
			this.addDynamicRepeatable(footer, footerSizeFct);
		} else if (footer) {
			this.addStaticRepeatable(footer, footerSizeFct);
		}
	};
	
	LayoutBuilder.prototype.addWatermark = function (watermark, fontProvider, defaultStyle) {
		if (isString(watermark)) {
			watermark = {'text': watermark};
		}
	
		if (!watermark.text) { // empty watermark text
			return;
		}
	
		watermark.font = watermark.font || defaultStyle.font || 'Roboto';
		watermark.color = watermark.color || 'black';
		watermark.opacity = watermark.opacity || 0.6;
		watermark.bold = watermark.bold || false;
		watermark.italics = watermark.italics || false;
	
		var watermarkObject = {
			text: watermark.text,
			font: fontProvider.provideFont(watermark.font, watermark.bold, watermark.italics),
			size: getSize(this.pageSize, watermark, fontProvider),
			color: watermark.color,
			opacity: watermark.opacity
		};
	
		var pages = this.writer.context().pages;
		for (var i = 0, l = pages.length; i < l; i++) {
			pages[i].watermark = watermarkObject;
		}
	
		function getSize(pageSize, watermark, fontProvider) {
			var width = pageSize.width;
			var height = pageSize.height;
			var targetWidth = Math.sqrt(width * width + height * height) * 0.8; /* page diagonal * sample factor */
			var textTools = new TextTools(fontProvider);
			var styleContextStack = new StyleContextStack(null, {font: watermark.font, bold: watermark.bold, italics: watermark.italics});
			var size;
	
			/**
			 * Binary search the best font size.
			 * Initial bounds [0, 1000]
			 * Break when range < 1
			 */
			var a = 0;
			var b = 1000;
			var c = (a + b) / 2;
			while (Math.abs(a - b) > 1) {
				styleContextStack.push({
					fontSize: c
				});
				size = textTools.sizeOfString(watermark.text, styleContextStack);
				if (size.width > targetWidth) {
					b = c;
					c = (a + b) / 2;
				} else if (size.width < targetWidth) {
					a = c;
					c = (a + b) / 2;
				}
				styleContextStack.pop();
			}
			/*
			 End binary search
			 */
			return {size: size, fontSize: c};
		}
	};
	
	function decorateNode(node) {
		var x = node.x, y = node.y;
		node.positions = [];
	
		if (isArray(node.canvas)) {
			node.canvas.forEach(function (vector) {
				var x = vector.x, y = vector.y, x1 = vector.x1, y1 = vector.y1, x2 = vector.x2, y2 = vector.y2;
				vector.resetXY = function () {
					vector.x = x;
					vector.y = y;
					vector.x1 = x1;
					vector.y1 = y1;
					vector.x2 = x2;
					vector.y2 = y2;
				};
			});
		}
	
		node.resetXY = function () {
			node.x = x;
			node.y = y;
			if (isArray(node.canvas)) {
				node.canvas.forEach(function (vector) {
					vector.resetXY();
				});
			}
		};
	}
	
	LayoutBuilder.prototype.processNode = function (node) {
		var self = this;
	
		this.linearNodeList.push(node);
		decorateNode(node);
	
		applyMargins(function () {
			var unbreakable = node.unbreakable;
			if (unbreakable) {
				self.writer.beginUnbreakableBlock();
			}
	
			var absPosition = node.absolutePosition;
			if (absPosition) {
				self.writer.context().beginDetachedBlock();
				self.writer.context().moveTo(absPosition.x || 0, absPosition.y || 0);
			}
	
			var relPosition = node.relativePosition;
			if (relPosition) {
				self.writer.context().beginDetachedBlock();
				self.writer.context().moveTo((relPosition.x || 0) + self.writer.context().x, (relPosition.y || 0) + self.writer.context().y);
			}
	
			if (node.stack) {
				self.processVerticalContainer(node);
			} else if (node.columns) {
				self.processColumns(node);
			} else if (node.ul) {
				self.processList(false, node);
			} else if (node.ol) {
				self.processList(true, node);
			} else if (node.table) {
				self.processTable(node);
			} else if (node.text !== undefined) {
				self.processLeaf(node);
			} else if (node.toc) {
				self.processToc(node);
			} else if (node.image) {
				self.processImage(node);
			} else if (node.canvas) {
				self.processCanvas(node);
			} else if (node.qr) {
				self.processQr(node);
			} else if (!node._span) {
				throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
			}
	
			if (absPosition || relPosition) {
				self.writer.context().endDetachedBlock();
			}
	
			if (unbreakable) {
				self.writer.commitUnbreakableBlock();
			}
		});
	
		function applyMargins(callback) {
			var margin = node._margin;
	
			if (node.pageBreak === 'before') {
				self.writer.moveToNextPage(node.pageOrientation);
			}
	
			if (margin) {
				self.writer.context().moveDown(margin[1]);
				self.writer.context().addMargin(margin[0], margin[2]);
			}
	
			callback();
	
			if (margin) {
				self.writer.context().addMargin(-margin[0], -margin[2]);
				self.writer.context().moveDown(margin[3]);
			}
	
			if (node.pageBreak === 'after') {
				self.writer.moveToNextPage(node.pageOrientation);
			}
		}
	};
	
	// vertical container
	LayoutBuilder.prototype.processVerticalContainer = function (node) {
		var self = this;
		node.stack.forEach(function (item) {
			self.processNode(item);
			addAll(node.positions, item.positions);
	
			//TODO: paragraph gap
		});
	};
	
	// columns
	LayoutBuilder.prototype.processColumns = function (columnNode) {
		var columns = columnNode.columns;
		var availableWidth = this.writer.context().availableWidth;
		var gaps = gapArray(columnNode._gap);
	
		if (gaps) {
			availableWidth -= (gaps.length - 1) * columnNode._gap;
		}
	
		ColumnCalculator.buildColumnWidths(columns, availableWidth);
		var result = this.processRow(columns, columns, gaps);
		addAll(columnNode.positions, result.positions);
	
	
		function gapArray(gap) {
			if (!gap) {
				return null;
			}
	
			var gaps = [];
			gaps.push(0);
	
			for (var i = columns.length - 1; i > 0; i--) {
				gaps.push(gap);
			}
	
			return gaps;
		}
	};
	
	LayoutBuilder.prototype.processRow = function (columns, widths, gaps, tableBody, tableRow, height) {
		var self = this;
		var pageBreaks = [], positions = [];
	
		this.tracker.auto('pageChanged', storePageBreakData, function () {
			widths = widths || columns;
	
			self.writer.context().beginColumnGroup();
	
			for (var i = 0, l = columns.length; i < l; i++) {
				var column = columns[i];
				var width = widths[i]._calcWidth;
				var leftOffset = colLeftOffset(i);
	
				if (column.colSpan && column.colSpan > 1) {
					for (var j = 1; j < column.colSpan; j++) {
						width += widths[++i]._calcWidth + gaps[i];
					}
				}
	
				self.writer.context().beginColumn(width, leftOffset, getEndingCell(column, i));
				if (!column._span) {
					self.processNode(column);
					addAll(positions, column.positions);
				} else if (column._columnEndingContext) {
					// row-span ending
					self.writer.context().markEnding(column);
				}
			}
	
			self.writer.context().completeColumnGroup(height);
		});
	
		return {pageBreaks: pageBreaks, positions: positions};
	
		function storePageBreakData(data) {
			var pageDesc;
	
			for (var i = 0, l = pageBreaks.length; i < l; i++) {
				var desc = pageBreaks[i];
				if (desc.prevPage === data.prevPage) {
					pageDesc = desc;
					break;
				}
			}
	
			if (!pageDesc) {
				pageDesc = data;
				pageBreaks.push(pageDesc);
			}
			pageDesc.prevY = Math.max(pageDesc.prevY, data.prevY);
			pageDesc.y = Math.min(pageDesc.y, data.y);
		}
	
		function colLeftOffset(i) {
			if (gaps && gaps.length > i) {
				return gaps[i];
			}
			return 0;
		}
	
		function getEndingCell(column, columnIndex) {
			if (column.rowSpan && column.rowSpan > 1) {
				var endingRow = tableRow + column.rowSpan - 1;
				if (endingRow >= tableBody.length) {
					throw 'Row span for column ' + columnIndex + ' (with indexes starting from 0) exceeded row count';
				}
				return tableBody[endingRow][columnIndex];
			}
	
			return null;
		}
	};
	
	// lists
	LayoutBuilder.prototype.processList = function (orderedList, node) {
		var self = this,
			items = orderedList ? node.ol : node.ul,
			gapSize = node._gapSize;
	
		this.writer.context().addMargin(gapSize.width);
	
		var nextMarker;
		this.tracker.auto('lineAdded', addMarkerToFirstLeaf, function () {
			items.forEach(function (item) {
				nextMarker = item.listMarker;
				self.processNode(item);
				addAll(node.positions, item.positions);
			});
		});
	
		this.writer.context().addMargin(-gapSize.width);
	
		function addMarkerToFirstLeaf(line) {
			// I'm not very happy with the way list processing is implemented
			// (both code and algorithm should be rethinked)
			if (nextMarker) {
				var marker = nextMarker;
				nextMarker = null;
	
				if (marker.canvas) {
					var vector = marker.canvas[0];
	
					offsetVector(vector, -marker._minWidth, 0);
					self.writer.addVector(vector);
				} else if (marker._inlines) {
					var markerLine = new Line(self.pageSize.width);
					markerLine.addInline(marker._inlines[0]);
					markerLine.x = -marker._minWidth;
					markerLine.y = line.getAscenderHeight() - markerLine.getAscenderHeight();
					self.writer.addLine(markerLine, true);
				}
			}
		}
	};
	
	// tables
	LayoutBuilder.prototype.processTable = function (tableNode) {
		var processor = new TableProcessor(tableNode);
	
		processor.beginTable(this.writer);
	
		var rowHeights = tableNode.table.heights;
		for (var i = 0, l = tableNode.table.body.length; i < l; i++) {
			processor.beginRow(i, this.writer);
	
			var height;
			if (isFunction(rowHeights)) {
				height = rowHeights(i);
			} else if (isArray(rowHeights)) {
				height = rowHeights[i];
			} else {
				height = rowHeights;
			}
	
			if (height === 'auto') {
				height = undefined;
			}
	
			var result = this.processRow(tableNode.table.body[i], tableNode.table.widths, tableNode._offsets.offsets, tableNode.table.body, i, height);
			addAll(tableNode.positions, result.positions);
	
			processor.endRow(i, this.writer, result.pageBreaks);
		}
	
		processor.endTable(this.writer);
	};
	
	// leafs (texts)
	LayoutBuilder.prototype.processLeaf = function (node) {
		var line = this.buildNextLine(node);
		var currentHeight = (line) ? line.getHeight() : 0;
		var maxHeight = node.maxHeight || -1;
	
		if (node._tocItemRef) {
			line._pageNodeRef = node._tocItemRef;
		}
	
		if (node._pageRef) {
			line._pageNodeRef = node._pageRef._nodeRef;
		}
	
		while (line && (maxHeight === -1 || currentHeight < maxHeight)) {
			var positions = this.writer.addLine(line);
			node.positions.push(positions);
			line = this.buildNextLine(node);
			if (line) {
				currentHeight += line.getHeight();
			}
		}
	};
	
	LayoutBuilder.prototype.processToc = function (node) {
		if (node.toc.title) {
			this.processNode(node.toc.title);
		}
		this.processNode(node.toc._table);
	};
	
	LayoutBuilder.prototype.buildNextLine = function (textNode) {
	
		function cloneInline(inline) {
			var newInline = inline.constructor();
			for (var key in inline) {
				newInline[key] = inline[key];
			}
			return newInline;
		}
	
		if (!textNode._inlines || textNode._inlines.length === 0) {
			return null;
		}
	
		var line = new Line(this.writer.context().availableWidth);
		var textTools = new TextTools(null);
	
		while (textNode._inlines && textNode._inlines.length > 0 && line.hasEnoughSpaceForInline(textNode._inlines[0])) {
			var inline = textNode._inlines.shift();
	
			if (!inline.noWrap && inline.text.length > 1 && inline.width > line.maxWidth) {
				var widthPerChar = inline.width / inline.text.length;
				var maxChars = Math.floor(line.maxWidth / widthPerChar);
				if (maxChars < 1) {
					maxChars = 1;
				}
				if (maxChars < inline.text.length) {
					var newInline = cloneInline(inline);
	
					newInline.text = inline.text.substr(maxChars);
					inline.text = inline.text.substr(0, maxChars);
	
					newInline.width = textTools.widthOfString(newInline.text, newInline.font, newInline.fontSize, newInline.characterSpacing, newInline.fontFeatures);
					inline.width = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
	
					textNode._inlines.unshift(newInline);
				}
			}
	
			line.addInline(inline);
		}
	
		line.lastLineInParagraph = textNode._inlines.length === 0;
	
		return line;
	};
	
	// images
	LayoutBuilder.prototype.processImage = function (node) {
		var position = this.writer.addImage(node);
		node.positions.push(position);
	};
	
	LayoutBuilder.prototype.processCanvas = function (node) {
		var height = node._minHeight;
	
		if (node.absolutePosition === undefined && this.writer.context().availableHeight < height) {
			// TODO: support for canvas larger than a page
			// TODO: support for other overflow methods
	
			this.writer.moveToNextPage();
		}
	
		this.writer.alignCanvas(node);
	
		node.canvas.forEach(function (vector) {
			var position = this.writer.addVector(vector);
			node.positions.push(position);
		}, this);
	
		this.writer.context().moveDown(height);
	};
	
	LayoutBuilder.prototype.processQr = function (node) {
		var position = this.writer.addQr(node);
		node.positions.push(position);
	};
	
	module.exports = LayoutBuilder;
	
	
	/***/ }),
	/* 129 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(Buffer) {
	
	var isString = __webpack_require__(0).isString;
	var isNumber = __webpack_require__(0).isNumber;
	var isBoolean = __webpack_require__(0).isBoolean;
	var isArray = __webpack_require__(0).isArray;
	var isUndefined = __webpack_require__(0).isUndefined;
	var fontStringify = __webpack_require__(0).fontStringify;
	
	function DocPreprocessor() {
	
	}
	
	DocPreprocessor.prototype.preprocessDocument = function (docStructure) {
		this.tocs = [];
		this.nodeReferences = [];
		return this.preprocessNode(docStructure);
	};
	
	DocPreprocessor.prototype.preprocessNode = function (node) {
		// expand shortcuts and casting values
		if (isArray(node)) {
			node = {stack: node};
		} else if (isString(node)) {
			node = {text: node};
		} else if (isNumber(node) || isBoolean(node)) {
			node = {text: node.toString()};
		} else if (node === null) {
			node = {text: ''};
		} else if (Object.keys(node).length === 0) { // empty object
			node = {text: ''};
		}
	
		if (node.columns) {
			return this.preprocessColumns(node);
		} else if (node.stack) {
			return this.preprocessVerticalContainer(node);
		} else if (node.ul) {
			return this.preprocessList(node);
		} else if (node.ol) {
			return this.preprocessList(node);
		} else if (node.table) {
			return this.preprocessTable(node);
		} else if (node.text !== undefined) {
			return this.preprocessText(node);
		} else if (node.toc) {
			return this.preprocessToc(node);
		} else if (node.image) {
			return this.preprocessImage(node);
		} else if (node.canvas) {
			return this.preprocessCanvas(node);
		} else if (node.qr) {
			return this.preprocessQr(node);
		} else if (node.pageReference || node.textReference) {
			return this.preprocessText(node);
		} else {
			throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
		}
	};
	
	DocPreprocessor.prototype.preprocessColumns = function (node) {
		var columns = node.columns;
	
		for (var i = 0, l = columns.length; i < l; i++) {
			columns[i] = this.preprocessNode(columns[i]);
		}
	
		return node;
	};
	
	DocPreprocessor.prototype.preprocessVerticalContainer = function (node) {
		var items = node.stack;
	
		for (var i = 0, l = items.length; i < l; i++) {
			items[i] = this.preprocessNode(items[i]);
		}
	
		return node;
	};
	
	DocPreprocessor.prototype.preprocessList = function (node) {
		var items = node.ul || node.ol;
	
		for (var i = 0, l = items.length; i < l; i++) {
			items[i] = this.preprocessNode(items[i]);
		}
	
		return node;
	};
	
	DocPreprocessor.prototype.preprocessTable = function (node) {
		var col, row, cols, rows;
	
		for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
			for (row = 0, rows = node.table.body.length; row < rows; row++) {
				var rowData = node.table.body[row];
				var data = rowData[col];
				if (data !== undefined) {
					if (data === null) { // transform to object
						data = '';
					}
					if (!data._span) {
						rowData[col] = this.preprocessNode(data);
					}
				}
			}
		}
	
		return node;
	};
	
	DocPreprocessor.prototype.preprocessText = function (node) {
		if (node.tocItem) {
			if (!isArray(node.tocItem)) {
				node.tocItem = [node.tocItem];
			}
	
			for (var i = 0, l = node.tocItem.length; i < l; i++) {
				if (!isString(node.tocItem[i])) {
					node.tocItem[i] = '_default_';
				}
	
				var tocItemId = node.tocItem[i];
	
				if (!this.tocs[tocItemId]) {
					this.tocs[tocItemId] = {toc: {_items: [], _pseudo: true}};
				}
	
				this.tocs[tocItemId].toc._items.push(node);
			}
		}
	
		if (node.id) {
			if (this.nodeReferences[node.id]) {
				if (!this.nodeReferences[node.id]._pseudo) {
					throw "Node id '" + node.id + "' already exists";
				}
	
				this.nodeReferences[node.id]._nodeRef = node;
				this.nodeReferences[node.id]._pseudo = false;
			} else {
				this.nodeReferences[node.id] = {_nodeRef: node};
			}
		}
	
		if (node.pageReference) {
			if (!this.nodeReferences[node.pageReference]) {
				this.nodeReferences[node.pageReference] = {_nodeRef: {}, _pseudo: true};
			}
			node.text = '00000';
			node._pageRef = this.nodeReferences[node.pageReference];
		}
	
		if (node.textReference) {
			if (!this.nodeReferences[node.textReference]) {
				this.nodeReferences[node.textReference] = {_nodeRef: {}, _pseudo: true};
			}
	
			node.text = '';
			node._textRef = this.nodeReferences[node.textReference];
		}
	
		if (node.text && node.text.text) {
			node.text = [this.preprocessNode(node.text)];
		}
	
		return node;
	};
	
	DocPreprocessor.prototype.preprocessToc = function (node) {
		if (!node.toc.id) {
			node.toc.id = '_default_';
		}
	
		node.toc.title = node.toc.title ? this.preprocessNode(node.toc.title) : null;
		node.toc._items = [];
	
		if (this.tocs[node.toc.id]) {
			if (!this.tocs[node.toc.id].toc._pseudo) {
				throw "TOC '" + node.toc.id + "' already exists";
			}
	
			node.toc._items = this.tocs[node.toc.id].toc._items;
		}
	
		this.tocs[node.toc.id] = node;
	
		return node;
	};
	
	DocPreprocessor.prototype.preprocessImage = function (node) {
		if (!isUndefined(node.image.type) && !isUndefined(node.image.data) && (node.image.type === 'Buffer') && isArray(node.image.data)) {
			node.image = Buffer.from(node.image.data);
		}
		return node;
	};
	
	DocPreprocessor.prototype.preprocessCanvas = function (node) {
		return node;
	};
	
	DocPreprocessor.prototype.preprocessQr = function (node) {
		return node;
	};
	
	module.exports = DocPreprocessor;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 130 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*eslint no-unused-vars: ["error", {"args": "none"}]*/
	
	
	
	var TextTools = __webpack_require__(42);
	var StyleContextStack = __webpack_require__(80);
	var ColumnCalculator = __webpack_require__(44);
	var isString = __webpack_require__(0).isString;
	var isNumber = __webpack_require__(0).isNumber;
	var isObject = __webpack_require__(0).isObject;
	var isArray = __webpack_require__(0).isArray;
	var fontStringify = __webpack_require__(0).fontStringify;
	var pack = __webpack_require__(0).pack;
	var qrEncoder = __webpack_require__(134);
	
	/**
	 * @private
	 */
	function DocMeasure(fontProvider, styleDictionary, defaultStyle, imageMeasure, tableLayouts, images) {
		this.textTools = new TextTools(fontProvider);
		this.styleStack = new StyleContextStack(styleDictionary, defaultStyle);
		this.imageMeasure = imageMeasure;
		this.tableLayouts = tableLayouts;
		this.images = images;
		this.autoImageIndex = 1;
	}
	
	/**
	 * Measures all nodes and sets min/max-width properties required for the second
	 * layout-pass.
	 * @param  {Object} docStructure document-definition-object
	 * @return {Object}              document-measurement-object
	 */
	DocMeasure.prototype.measureDocument = function (docStructure) {
		return this.measureNode(docStructure);
	};
	
	DocMeasure.prototype.measureNode = function (node) {
	
		var self = this;
	
		return this.styleStack.auto(node, function () {
			// TODO: refactor + rethink whether this is the proper way to handle margins
			node._margin = getNodeMargin(node);
	
			if (node.columns) {
				return extendMargins(self.measureColumns(node));
			} else if (node.stack) {
				return extendMargins(self.measureVerticalContainer(node));
			} else if (node.ul) {
				return extendMargins(self.measureUnorderedList(node));
			} else if (node.ol) {
				return extendMargins(self.measureOrderedList(node));
			} else if (node.table) {
				return extendMargins(self.measureTable(node));
			} else if (node.text !== undefined) {
				return extendMargins(self.measureLeaf(node));
			} else if (node.toc) {
				return extendMargins(self.measureToc(node));
			} else if (node.image) {
				return extendMargins(self.measureImage(node));
			} else if (node.canvas) {
				return extendMargins(self.measureCanvas(node));
			} else if (node.qr) {
				return extendMargins(self.measureQr(node));
			} else {
				throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
			}
		});
	
		function extendMargins(node) {
			var margin = node._margin;
	
			if (margin) {
				node._minWidth += margin[0] + margin[2];
				node._maxWidth += margin[0] + margin[2];
			}
	
			return node;
		}
	
		function getNodeMargin() {
	
			function processSingleMargins(node, currentMargin) {
				if (node.marginLeft || node.marginTop || node.marginRight || node.marginBottom) {
					return [
						node.marginLeft || currentMargin[0] || 0,
						node.marginTop || currentMargin[1] || 0,
						node.marginRight || currentMargin[2] || 0,
						node.marginBottom || currentMargin[3] || 0
					];
				}
				return currentMargin;
			}
	
			function flattenStyleArray(styleArray) {
				var flattenedStyles = {};
				for (var i = styleArray.length - 1; i >= 0; i--) {
					var styleName = styleArray[i];
					var style = self.styleStack.styleDictionary[styleName];
					for (var key in style) {
						if (style.hasOwnProperty(key)) {
							flattenedStyles[key] = style[key];
						}
					}
				}
				return flattenedStyles;
			}
	
			function convertMargin(margin) {
				if (isNumber(margin)) {
					margin = [margin, margin, margin, margin];
				} else if (isArray(margin)) {
					if (margin.length === 2) {
						margin = [margin[0], margin[1], margin[0], margin[1]];
					}
				}
				return margin;
			}
	
			var margin = [undefined, undefined, undefined, undefined];
	
			if (node.style) {
				var styleArray = isArray(node.style) ? node.style : [node.style];
				var flattenedStyleArray = flattenStyleArray(styleArray);
	
				if (flattenedStyleArray) {
					margin = processSingleMargins(flattenedStyleArray, margin);
				}
	
				if (flattenedStyleArray.margin) {
					margin = convertMargin(flattenedStyleArray.margin);
				}
			}
	
			margin = processSingleMargins(node, margin);
	
			if (node.margin) {
				margin = convertMargin(node.margin);
			}
	
			if (margin[0] === undefined && margin[1] === undefined && margin[2] === undefined && margin[3] === undefined) {
				return null;
			} else {
				return margin;
			}
		}
	};
	
	DocMeasure.prototype.convertIfBase64Image = function (node) {
		if (/^data:image\/(jpeg|jpg|png);base64,/.test(node.image)) {
			var label = '$$pdfmake$$' + this.autoImageIndex++;
			this.images[label] = node.image;
			node.image = label;
		}
	};
	
	DocMeasure.prototype.measureImage = function (node) {
		if (this.images) {
			this.convertIfBase64Image(node);
		}
	
		var imageSize = this.imageMeasure.measureImage(node.image);
	
		if (node.fit) {
			var factor = (imageSize.width / imageSize.height > node.fit[0] / node.fit[1]) ? node.fit[0] / imageSize.width : node.fit[1] / imageSize.height;
			node._width = node._minWidth = node._maxWidth = imageSize.width * factor;
			node._height = imageSize.height * factor;
		} else {
			node._width = node._minWidth = node._maxWidth = node.width || imageSize.width;
			node._height = node.height || (imageSize.height * node._width / imageSize.width);
	
			if (isNumber(node.maxWidth) && node.maxWidth < node._width) {
				node._width = node._minWidth = node._maxWidth = node.maxWidth;
				node._height = node._width * imageSize.height / imageSize.width;
			}
	
			if (isNumber(node.maxHeight) && node.maxHeight < node._height) {
				node._height = node.maxHeight;
				node._width = node._minWidth = node._maxWidth = node._height * imageSize.width / imageSize.height;
			}
	
			if (isNumber(node.minWidth) && node.minWidth > node._width) {
				node._width = node._minWidth = node._maxWidth = node.minWidth;
				node._height = node._width * imageSize.height / imageSize.width;
			}
	
			if (isNumber(node.minHeight) && node.minHeight > node._height) {
				node._height = node.minHeight;
				node._width = node._minWidth = node._maxWidth = node._height * imageSize.width / imageSize.height;
			}
		}
	
		node._alignment = this.styleStack.getProperty('alignment');
		return node;
	};
	
	DocMeasure.prototype.measureLeaf = function (node) {
	
		if (node._textRef && node._textRef._nodeRef.text) {
			node.text = node._textRef._nodeRef.text;
		}
	
		// Make sure style properties of the node itself are considered when building inlines.
		// We could also just pass [node] to buildInlines, but that fails for bullet points.
		var styleStack = this.styleStack.clone();
		styleStack.push(node);
	
		var data = this.textTools.buildInlines(node.text, styleStack);
	
		node._inlines = data.items;
		node._minWidth = data.minWidth;
		node._maxWidth = data.maxWidth;
	
		return node;
	};
	
	DocMeasure.prototype.measureToc = function (node) {
		if (node.toc.title) {
			node.toc.title = this.measureNode(node.toc.title);
		}
	
		var body = [];
		var textStyle = node.toc.textStyle || {};
		var numberStyle = node.toc.numberStyle || textStyle;
		var textMargin = node.toc.textMargin || [0, 0, 0, 0];
		for (var i = 0, l = node.toc._items.length; i < l; i++) {
			var item = node.toc._items[i];
			var lineStyle = node.toc._items[i].tocStyle || textStyle;
			var lineMargin = node.toc._items[i].tocMargin || textMargin;
			body.push([
				{text: item.text, alignment: 'left', style: lineStyle, margin: lineMargin},
				{text: '00000', alignment: 'right', _tocItemRef: item, style: numberStyle, margin: [0, lineMargin[1], 0, lineMargin[3]]}
			]);
		}
	
	
		node.toc._table = {
			table: {
				dontBreakRows: true,
				widths: ['*', 'auto'],
				body: body
			},
			layout: 'noBorders'
		};
	
		node.toc._table = this.measureNode(node.toc._table);
	
		return node;
	};
	
	DocMeasure.prototype.measureVerticalContainer = function (node) {
		var items = node.stack;
	
		node._minWidth = 0;
		node._maxWidth = 0;
	
		for (var i = 0, l = items.length; i < l; i++) {
			items[i] = this.measureNode(items[i]);
	
			node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
			node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
		}
	
		return node;
	};
	
	DocMeasure.prototype.gapSizeForList = function () {
		return this.textTools.sizeOfString('9. ', this.styleStack);
	};
	
	DocMeasure.prototype.buildUnorderedMarker = function (styleStack, gapSize, type) {
		function buildDisc(gapSize, color) {
			// TODO: ascender-based calculations
			var radius = gapSize.fontSize / 6;
			return {
				canvas: [{
						x: radius,
						y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
						r1: radius,
						r2: radius,
						type: 'ellipse',
						color: color
					}]
			};
		}
	
		function buildSquare(gapSize, color) {
			// TODO: ascender-based calculations
			var size = gapSize.fontSize / 3;
			return {
				canvas: [{
						x: 0,
						y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - (gapSize.fontSize / 3) - (size / 2),
						h: size,
						w: size,
						type: 'rect',
						color: color
					}]
			};
		}
	
		function buildCircle(gapSize, color) {
			// TODO: ascender-based calculations
			var radius = gapSize.fontSize / 6;
			return {
				canvas: [{
						x: radius,
						y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
						r1: radius,
						r2: radius,
						type: 'ellipse',
						lineColor: color
					}]
			};
		}
	
		var marker;
		var color = styleStack.getProperty('markerColor') || styleStack.getProperty('color') || 'black';
	
		switch (type) {
			case 'circle':
				marker = buildCircle(gapSize, color);
				break;
	
			case 'square':
				marker = buildSquare(gapSize, color);
				break;
	
			case 'none':
				marker = {};
				break;
	
			case 'disc':
			default:
				marker = buildDisc(gapSize, color);
				break;
		}
	
		marker._minWidth = marker._maxWidth = gapSize.width;
		marker._minHeight = marker._maxHeight = gapSize.height;
	
		return marker;
	};
	
	DocMeasure.prototype.buildOrderedMarker = function (counter, styleStack, type, separator) {
		function prepareAlpha(counter) {
			function toAlpha(num) {
				return (num >= 26 ? toAlpha((num / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[num % 26 >> 0];
			}
	
			if (counter < 1) {
				return counter.toString();
			}
	
			return toAlpha(counter - 1);
		}
	
		function prepareRoman(counter) {
			if (counter < 1 || counter > 4999) {
				return counter.toString();
			}
			var num = counter;
			var lookup = {M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1}, roman = '', i;
			for (i in lookup) {
				while (num >= lookup[i]) {
					roman += i;
					num -= lookup[i];
				}
			}
			return roman;
		}
	
		function prepareDecimal(counter) {
			return counter.toString();
		}
	
		var counterText;
		switch (type) {
			case 'none':
				counterText = null;
				break;
	
			case 'upper-alpha':
				counterText = prepareAlpha(counter).toUpperCase();
				break;
	
			case 'lower-alpha':
				counterText = prepareAlpha(counter);
				break;
	
			case 'upper-roman':
				counterText = prepareRoman(counter);
				break;
	
			case 'lower-roman':
				counterText = prepareRoman(counter).toLowerCase();
				break;
	
			case 'decimal':
			default:
				counterText = prepareDecimal(counter);
				break;
		}
	
		if (counterText === null) {
			return {};
		}
	
		if (separator) {
			if (isArray(separator)) {
				if (separator[0]) {
					counterText = separator[0] + counterText;
				}
	
				if (separator[1]) {
					counterText += separator[1];
				}
				counterText += ' ';
			} else {
				counterText += separator + ' ';
			}
		}
	
		var textArray = {text: counterText};
		var markerColor = styleStack.getProperty('markerColor');
		if (markerColor) {
			textArray.color = markerColor;
		}
	
		return {_inlines: this.textTools.buildInlines(textArray, styleStack).items};
	};
	
	DocMeasure.prototype.measureUnorderedList = function (node) {
		var style = this.styleStack.clone();
		var items = node.ul;
		node.type = node.type || 'disc';
		node._gapSize = this.gapSizeForList();
		node._minWidth = 0;
		node._maxWidth = 0;
	
		for (var i = 0, l = items.length; i < l; i++) {
			var item = items[i] = this.measureNode(items[i]);
	
			if (!item.ol && !item.ul) {
				item.listMarker = this.buildUnorderedMarker(style, node._gapSize, item.listType || node.type);
			}
	
			node._minWidth = Math.max(node._minWidth, items[i]._minWidth + node._gapSize.width);
			node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth + node._gapSize.width);
		}
	
		return node;
	};
	
	DocMeasure.prototype.measureOrderedList = function (node) {
		var style = this.styleStack.clone();
		var items = node.ol;
		node.type = node.type || 'decimal';
		node.separator = node.separator || '.';
		node.reversed = node.reversed || false;
		if (!node.start) {
			node.start = node.reversed ? items.length : 1;
		}
		node._gapSize = this.gapSizeForList();
		node._minWidth = 0;
		node._maxWidth = 0;
	
		var counter = node.start;
		for (var i = 0, l = items.length; i < l; i++) {
			var item = items[i] = this.measureNode(items[i]);
	
			if (!item.ol && !item.ul) {
				item.listMarker = this.buildOrderedMarker(item.counter || counter, style, item.listType || node.type, node.separator);
				if (item.listMarker._inlines) {
					node._gapSize.width = Math.max(node._gapSize.width, item.listMarker._inlines[0].width);
				}
			}  // TODO: else - nested lists numbering
	
			node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
			node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
	
			if (node.reversed) {
				counter--;
			} else {
				counter++;
			}
		}
	
		node._minWidth += node._gapSize.width;
		node._maxWidth += node._gapSize.width;
	
		for (var i = 0, l = items.length; i < l; i++) {
			var item = items[i];
			if (!item.ol && !item.ul) {
				item.listMarker._minWidth = item.listMarker._maxWidth = node._gapSize.width;
			}
		}
	
		return node;
	};
	
	DocMeasure.prototype.measureColumns = function (node) {
		var columns = node.columns;
		node._gap = this.styleStack.getProperty('columnGap') || 0;
	
		for (var i = 0, l = columns.length; i < l; i++) {
			columns[i] = this.measureNode(columns[i]);
		}
	
		var measures = ColumnCalculator.measureMinMax(columns);
	
		var numGaps = (columns.length > 0) ? (columns.length - 1) : 0;
		node._minWidth = measures.min + node._gap * numGaps;
		node._maxWidth = measures.max + node._gap * numGaps;
	
		return node;
	};
	
	DocMeasure.prototype.measureTable = function (node) {
		extendTableWidths(node);
		node._layout = getLayout(this.tableLayouts);
		node._offsets = getOffsets(node._layout);
	
		var colSpans = [];
		var col, row, cols, rows;
	
		for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
			var c = node.table.widths[col];
			c._minWidth = 0;
			c._maxWidth = 0;
	
			for (row = 0, rows = node.table.body.length; row < rows; row++) {
				var rowData = node.table.body[row];
				var data = rowData[col];
				if (data === undefined) {
					console.error('Malformed table row ', rowData, 'in node ', node);
					throw 'Malformed table row, a cell is undefined.';
				}
				if (data === null) { // transform to object
					data = '';
				}
	
				if (!data._span) {
					data = rowData[col] = this.styleStack.auto(data, measureCb(this, data));
	
					if (data.colSpan && data.colSpan > 1) {
						markSpans(rowData, col, data.colSpan);
						colSpans.push({col: col, span: data.colSpan, minWidth: data._minWidth, maxWidth: data._maxWidth});
					} else {
						c._minWidth = Math.max(c._minWidth, data._minWidth);
						c._maxWidth = Math.max(c._maxWidth, data._maxWidth);
					}
				}
	
				if (data.rowSpan && data.rowSpan > 1) {
					markVSpans(node.table, row, col, data.rowSpan);
				}
			}
		}
	
		extendWidthsForColSpans();
	
		var measures = ColumnCalculator.measureMinMax(node.table.widths);
	
		node._minWidth = measures.min + node._offsets.total;
		node._maxWidth = measures.max + node._offsets.total;
	
		return node;
	
		function measureCb(_this, data) {
			return function () {
				if (isObject(data)) {
					data.fillColor = _this.styleStack.getProperty('fillColor');
				}
				return _this.measureNode(data);
			};
		}
	
		function getLayout(tableLayouts) {
			var layout = node.layout;
	
			if (isString(layout)) {
				layout = tableLayouts[layout];
			}
	
			var defaultLayout = {
				hLineWidth: function (i, node) {
					return 1;
				},
				vLineWidth: function (i, node) {
					return 1;
				},
				hLineColor: function (i, node) {
					return 'black';
				},
				vLineColor: function (i, node) {
					return 'black';
				},
				paddingLeft: function (i, node) {
					return 4;
				},
				paddingRight: function (i, node) {
					return 4;
				},
				paddingTop: function (i, node) {
					return 2;
				},
				paddingBottom: function (i, node) {
					return 2;
				},
				fillColor: function (i, node) {
					return null;
				},
				defaultBorder: true
			};
	
			return pack(defaultLayout, layout);
		}
	
		function getOffsets(layout) {
			var offsets = [];
			var totalOffset = 0;
			var prevRightPadding = 0;
	
			for (var i = 0, l = node.table.widths.length; i < l; i++) {
				var lOffset = prevRightPadding + layout.vLineWidth(i, node) + layout.paddingLeft(i, node);
				offsets.push(lOffset);
				totalOffset += lOffset;
				prevRightPadding = layout.paddingRight(i, node);
			}
	
			totalOffset += prevRightPadding + layout.vLineWidth(node.table.widths.length, node);
	
			return {
				total: totalOffset,
				offsets: offsets
			};
		}
	
		function extendWidthsForColSpans() {
			var q, j;
	
			for (var i = 0, l = colSpans.length; i < l; i++) {
				var span = colSpans[i];
	
				var currentMinMax = getMinMax(span.col, span.span, node._offsets);
				var minDifference = span.minWidth - currentMinMax.minWidth;
				var maxDifference = span.maxWidth - currentMinMax.maxWidth;
	
				if (minDifference > 0) {
					q = minDifference / span.span;
	
					for (j = 0; j < span.span; j++) {
						node.table.widths[span.col + j]._minWidth += q;
					}
				}
	
				if (maxDifference > 0) {
					q = maxDifference / span.span;
	
					for (j = 0; j < span.span; j++) {
						node.table.widths[span.col + j]._maxWidth += q;
					}
				}
			}
		}
	
		function getMinMax(col, span, offsets) {
			var result = {minWidth: 0, maxWidth: 0};
	
			for (var i = 0; i < span; i++) {
				result.minWidth += node.table.widths[col + i]._minWidth + (i ? offsets.offsets[col + i] : 0);
				result.maxWidth += node.table.widths[col + i]._maxWidth + (i ? offsets.offsets[col + i] : 0);
			}
	
			return result;
		}
	
		function markSpans(rowData, col, span) {
			for (var i = 1; i < span; i++) {
				rowData[col + i] = {
					_span: true,
					_minWidth: 0,
					_maxWidth: 0,
					rowSpan: rowData[col].rowSpan
				};
			}
		}
	
		function markVSpans(table, row, col, span) {
			for (var i = 1; i < span; i++) {
				table.body[row + i][col] = {
					_span: true,
					_minWidth: 0,
					_maxWidth: 0,
					fillColor: table.body[row][col].fillColor
				};
			}
		}
	
		function extendTableWidths(node) {
			if (!node.table.widths) {
				node.table.widths = 'auto';
			}
	
			if (isString(node.table.widths)) {
				node.table.widths = [node.table.widths];
	
				while (node.table.widths.length < node.table.body[0].length) {
					node.table.widths.push(node.table.widths[node.table.widths.length - 1]);
				}
			}
	
			for (var i = 0, l = node.table.widths.length; i < l; i++) {
				var w = node.table.widths[i];
				if (isNumber(w) || isString(w)) {
					node.table.widths[i] = {width: w};
				}
			}
		}
	};
	
	DocMeasure.prototype.measureCanvas = function (node) {
		var w = 0, h = 0;
	
		for (var i = 0, l = node.canvas.length; i < l; i++) {
			var vector = node.canvas[i];
	
			switch (vector.type) {
				case 'ellipse':
					w = Math.max(w, vector.x + vector.r1);
					h = Math.max(h, vector.y + vector.r2);
					break;
				case 'rect':
					w = Math.max(w, vector.x + vector.w);
					h = Math.max(h, vector.y + vector.h);
					break;
				case 'line':
					w = Math.max(w, vector.x1, vector.x2);
					h = Math.max(h, vector.y1, vector.y2);
					break;
				case 'polyline':
					for (var i2 = 0, l2 = vector.points.length; i2 < l2; i2++) {
						w = Math.max(w, vector.points[i2].x);
						h = Math.max(h, vector.points[i2].y);
					}
					break;
			}
		}
	
		node._minWidth = node._maxWidth = w;
		node._minHeight = node._maxHeight = h;
		node._alignment = this.styleStack.getProperty('alignment');
	
		return node;
	};
	
	DocMeasure.prototype.measureQr = function (node) {
		node = qrEncoder.measure(node);
		node._alignment = this.styleStack.getProperty('alignment');
		return node;
	};
	
	module.exports = DocMeasure;
	
	
	/***/ }),
	/* 131 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	;(function (exports) {
		'use strict';
	
	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array
	
		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)
	
		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}
	
		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr
	
			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}
	
			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0
	
			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)
	
			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length
	
			var L = 0
	
			function push (v) {
				arr[L++] = v
			}
	
			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}
	
			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}
	
			return arr
		}
	
		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length
	
			function encode (num) {
				return lookup.charAt(num)
			}
	
			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}
	
			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}
	
			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}
	
			return output
		}
	
		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))
	
	
	/***/ }),
	/* 132 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var AI, AL, B2, BA, BB, BK, CB, CJ, CL, CM, CP, CR, EX, GL, H2, H3, HL, HY, ID, IN, IS, JL, JT, JV, LF, NL, NS, NU, OP, PO, PR, QU, RI, SA, SG, SP, SY, WJ, XX, ZW;
	
	  exports.OP = OP = 0;
	
	  exports.CL = CL = 1;
	
	  exports.CP = CP = 2;
	
	  exports.QU = QU = 3;
	
	  exports.GL = GL = 4;
	
	  exports.NS = NS = 5;
	
	  exports.EX = EX = 6;
	
	  exports.SY = SY = 7;
	
	  exports.IS = IS = 8;
	
	  exports.PR = PR = 9;
	
	  exports.PO = PO = 10;
	
	  exports.NU = NU = 11;
	
	  exports.AL = AL = 12;
	
	  exports.HL = HL = 13;
	
	  exports.ID = ID = 14;
	
	  exports.IN = IN = 15;
	
	  exports.HY = HY = 16;
	
	  exports.BA = BA = 17;
	
	  exports.BB = BB = 18;
	
	  exports.B2 = B2 = 19;
	
	  exports.ZW = ZW = 20;
	
	  exports.CM = CM = 21;
	
	  exports.WJ = WJ = 22;
	
	  exports.H2 = H2 = 23;
	
	  exports.H3 = H3 = 24;
	
	  exports.JL = JL = 25;
	
	  exports.JV = JV = 26;
	
	  exports.JT = JT = 27;
	
	  exports.RI = RI = 28;
	
	  exports.AI = AI = 29;
	
	  exports.BK = BK = 30;
	
	  exports.CB = CB = 31;
	
	  exports.CJ = CJ = 32;
	
	  exports.CR = CR = 33;
	
	  exports.LF = LF = 34;
	
	  exports.NL = NL = 35;
	
	  exports.SA = SA = 36;
	
	  exports.SG = SG = 37;
	
	  exports.SP = SP = 38;
	
	  exports.XX = XX = 39;
	
	}).call(this);
	
	
	/***/ }),
	/* 133 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK;
	
	  exports.DI_BRK = DI_BRK = 0;
	
	  exports.IN_BRK = IN_BRK = 1;
	
	  exports.CI_BRK = CI_BRK = 2;
	
	  exports.CP_BRK = CP_BRK = 3;
	
	  exports.PR_BRK = PR_BRK = 4;
	
	  exports.pairTable = [[PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, CP_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, PR_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK]];
	
	}).call(this);
	
	
	/***/ }),
	/* 134 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*eslint no-unused-vars: ["error", {"args": "none"}]*/
	/*eslint no-redeclare: "off"*/
	
	
	/* qr.js -- QR code generator in Javascript (revision 2011-01-19)
	 * Written by Kang Seonghoon <public+qrjs@mearie.org>.
	 *
	 * This source code is in the public domain; if your jurisdiction does not
	 * recognize the public domain the terms of Creative Commons CC0 license
	 * apply. In the other words, you can always do what you want.
	 */
	
	
	// per-version information (cf. JIS X 0510:2004 pp. 30--36, 71)
	//
	// [0]: the degree of generator polynomial by ECC levels
	// [1]: # of code blocks by ECC levels
	// [2]: left-top positions of alignment patterns
	//
	// the number in this table (in particular, [0]) does not exactly match with
	// the numbers in the specficiation. see augumenteccs below for the reason.
	var VERSIONS = [
		null,
		[[10, 7, 17, 13], [1, 1, 1, 1], []],
		[[16, 10, 28, 22], [1, 1, 1, 1], [4, 16]],
		[[26, 15, 22, 18], [1, 1, 2, 2], [4, 20]],
		[[18, 20, 16, 26], [2, 1, 4, 2], [4, 24]],
		[[24, 26, 22, 18], [2, 1, 4, 4], [4, 28]],
		[[16, 18, 28, 24], [4, 2, 4, 4], [4, 32]],
		[[18, 20, 26, 18], [4, 2, 5, 6], [4, 20, 36]],
		[[22, 24, 26, 22], [4, 2, 6, 6], [4, 22, 40]],
		[[22, 30, 24, 20], [5, 2, 8, 8], [4, 24, 44]],
		[[26, 18, 28, 24], [5, 4, 8, 8], [4, 26, 48]],
		[[30, 20, 24, 28], [5, 4, 11, 8], [4, 28, 52]],
		[[22, 24, 28, 26], [8, 4, 11, 10], [4, 30, 56]],
		[[22, 26, 22, 24], [9, 4, 16, 12], [4, 32, 60]],
		[[24, 30, 24, 20], [9, 4, 16, 16], [4, 24, 44, 64]],
		[[24, 22, 24, 30], [10, 6, 18, 12], [4, 24, 46, 68]],
		[[28, 24, 30, 24], [10, 6, 16, 17], [4, 24, 48, 72]],
		[[28, 28, 28, 28], [11, 6, 19, 16], [4, 28, 52, 76]],
		[[26, 30, 28, 28], [13, 6, 21, 18], [4, 28, 54, 80]],
		[[26, 28, 26, 26], [14, 7, 25, 21], [4, 28, 56, 84]],
		[[26, 28, 28, 30], [16, 8, 25, 20], [4, 32, 60, 88]],
		[[26, 28, 30, 28], [17, 8, 25, 23], [4, 26, 48, 70, 92]],
		[[28, 28, 24, 30], [17, 9, 34, 23], [4, 24, 48, 72, 96]],
		[[28, 30, 30, 30], [18, 9, 30, 25], [4, 28, 52, 76, 100]],
		[[28, 30, 30, 30], [20, 10, 32, 27], [4, 26, 52, 78, 104]],
		[[28, 26, 30, 30], [21, 12, 35, 29], [4, 30, 56, 82, 108]],
		[[28, 28, 30, 28], [23, 12, 37, 34], [4, 28, 56, 84, 112]],
		[[28, 30, 30, 30], [25, 12, 40, 34], [4, 32, 60, 88, 116]],
		[[28, 30, 30, 30], [26, 13, 42, 35], [4, 24, 48, 72, 96, 120]],
		[[28, 30, 30, 30], [28, 14, 45, 38], [4, 28, 52, 76, 100, 124]],
		[[28, 30, 30, 30], [29, 15, 48, 40], [4, 24, 50, 76, 102, 128]],
		[[28, 30, 30, 30], [31, 16, 51, 43], [4, 28, 54, 80, 106, 132]],
		[[28, 30, 30, 30], [33, 17, 54, 45], [4, 32, 58, 84, 110, 136]],
		[[28, 30, 30, 30], [35, 18, 57, 48], [4, 28, 56, 84, 112, 140]],
		[[28, 30, 30, 30], [37, 19, 60, 51], [4, 32, 60, 88, 116, 144]],
		[[28, 30, 30, 30], [38, 19, 63, 53], [4, 28, 52, 76, 100, 124, 148]],
		[[28, 30, 30, 30], [40, 20, 66, 56], [4, 22, 48, 74, 100, 126, 152]],
		[[28, 30, 30, 30], [43, 21, 70, 59], [4, 26, 52, 78, 104, 130, 156]],
		[[28, 30, 30, 30], [45, 22, 74, 62], [4, 30, 56, 82, 108, 134, 160]],
		[[28, 30, 30, 30], [47, 24, 77, 65], [4, 24, 52, 80, 108, 136, 164]],
		[[28, 30, 30, 30], [49, 25, 81, 68], [4, 28, 56, 84, 112, 140, 168]]];
	
	// mode constants (cf. Table 2 in JIS X 0510:2004 p. 16)
	var MODE_TERMINATOR = 0;
	var MODE_NUMERIC = 1, MODE_ALPHANUMERIC = 2, MODE_OCTET = 4, MODE_KANJI = 8;
	
	// validation regexps
	var NUMERIC_REGEXP = /^\d*$/;
	var ALPHANUMERIC_REGEXP = /^[A-Za-z0-9 $%*+\-./:]*$/;
	var ALPHANUMERIC_OUT_REGEXP = /^[A-Z0-9 $%*+\-./:]*$/;
	
	// ECC levels (cf. Table 22 in JIS X 0510:2004 p. 45)
	var ECCLEVEL_L = 1, ECCLEVEL_M = 0, ECCLEVEL_Q = 3, ECCLEVEL_H = 2;
	
	// GF(2^8)-to-integer mapping with a reducing polynomial x^8+x^4+x^3+x^2+1
	// invariant: GF256_MAP[GF256_INVMAP[i]] == i for all i in [1,256)
	var GF256_MAP = [], GF256_INVMAP = [-1];
	for (var i = 0, v = 1; i < 255; ++i) {
		GF256_MAP.push(v);
		GF256_INVMAP[v] = i;
		v = (v * 2) ^ (v >= 128 ? 0x11d : 0);
	}
	
	// generator polynomials up to degree 30
	// (should match with polynomials in JIS X 0510:2004 Appendix A)
	//
	// generator polynomial of degree K is product of (x-\alpha^0), (x-\alpha^1),
	// ..., (x-\alpha^(K-1)). by convention, we omit the K-th coefficient (always 1)
	// from the result; also other coefficients are written in terms of the exponent
	// to \alpha to avoid the redundant calculation. (see also calculateecc below.)
	var GF256_GENPOLY = [[]];
	for (var i = 0; i < 30; ++i) {
		var prevpoly = GF256_GENPOLY[i], poly = [];
		for (var j = 0; j <= i; ++j) {
			var a = (j < i ? GF256_MAP[prevpoly[j]] : 0);
			var b = GF256_MAP[(i + (prevpoly[j - 1] || 0)) % 255];
			poly.push(GF256_INVMAP[a ^ b]);
		}
		GF256_GENPOLY.push(poly);
	}
	
	// alphanumeric character mapping (cf. Table 5 in JIS X 0510:2004 p. 19)
	var ALPHANUMERIC_MAP = {};
	for (var i = 0; i < 45; ++i) {
		ALPHANUMERIC_MAP['0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:'.charAt(i)] = i;
	}
	
	// mask functions in terms of row # and column #
	// (cf. Table 20 in JIS X 0510:2004 p. 42)
	/*jshint unused: false */
	var MASKFUNCS = [
		function (i, j) {
			return (i + j) % 2 === 0;
		},
		function (i, j) {
			return i % 2 === 0;
		},
		function (i, j) {
			return j % 3 === 0;
		},
		function (i, j) {
			return (i + j) % 3 === 0;
		},
		function (i, j) {
			return (((i / 2) | 0) + ((j / 3) | 0)) % 2 === 0;
		},
		function (i, j) {
			return (i * j) % 2 + (i * j) % 3 === 0;
		},
		function (i, j) {
			return ((i * j) % 2 + (i * j) % 3) % 2 === 0;
		},
		function (i, j) {
			return ((i + j) % 2 + (i * j) % 3) % 2 === 0;
		}];
	
	// returns true when the version information has to be embeded.
	var needsverinfo = function (ver) {
		return ver > 6;
	};
	
	// returns the size of entire QR code for given version.
	var getsizebyver = function (ver) {
		return 4 * ver + 17;
	};
	
	// returns the number of bits available for code words in this version.
	var nfullbits = function (ver) {
		/*
		 * |<--------------- n --------------->|
		 * |        |<----- n-17 ---->|        |
		 * +-------+                ///+-------+ ----
		 * |       |                ///|       |    ^
		 * |  9x9  |       @@@@@    ///|  9x8  |    |
		 * |       | # # # @5x5@ # # # |       |    |
		 * +-------+       @@@@@       +-------+    |
		 *       #                               ---|
		 *                                        ^ |
		 *       #                                |
		 *     @@@@@       @@@@@       @@@@@      | n
		 *     @5x5@       @5x5@       @5x5@   n-17
		 *     @@@@@       @@@@@       @@@@@      | |
		 *       #                                | |
		 * //////                                 v |
		 * //////#                               ---|
		 * +-------+       @@@@@       @@@@@        |
		 * |       |       @5x5@       @5x5@        |
		 * |  8x9  |       @@@@@       @@@@@        |
		 * |       |                                v
		 * +-------+                             ----
		 *
		 * when the entire code has n^2 modules and there are m^2-3 alignment
		 * patterns, we have:
		 * - 225 (= 9x9 + 9x8 + 8x9) modules for finder patterns and
		 *   format information;
		 * - 2n-34 (= 2(n-17)) modules for timing patterns;
		 * - 36 (= 3x6 + 6x3) modules for version information, if any;
		 * - 25m^2-75 (= (m^2-3)(5x5)) modules for alignment patterns
		 *   if any, but 10m-20 (= 2(m-2)x5) of them overlaps with
		 *   timing patterns.
		 */
		var v = VERSIONS[ver];
		var nbits = 16 * ver * ver + 128 * ver + 64; // finder, timing and format info.
		if (needsverinfo(ver))
			nbits -= 36; // version information
		if (v[2].length) { // alignment patterns
			nbits -= 25 * v[2].length * v[2].length - 10 * v[2].length - 55;
		}
		return nbits;
	};
	
	// returns the number of bits available for data portions (i.e. excludes ECC
	// bits but includes mode and length bits) in this version and ECC level.
	var ndatabits = function (ver, ecclevel) {
		var nbits = nfullbits(ver) & ~7; // no sub-octet code words
		var v = VERSIONS[ver];
		nbits -= 8 * v[0][ecclevel] * v[1][ecclevel]; // ecc bits
		return nbits;
	};
	
	// returns the number of bits required for the length of data.
	// (cf. Table 3 in JIS X 0510:2004 p. 16)
	var ndatalenbits = function (ver, mode) {
		switch (mode) {
			case MODE_NUMERIC:
				return (ver < 10 ? 10 : ver < 27 ? 12 : 14);
			case MODE_ALPHANUMERIC:
				return (ver < 10 ? 9 : ver < 27 ? 11 : 13);
			case MODE_OCTET:
				return (ver < 10 ? 8 : 16);
			case MODE_KANJI:
				return (ver < 10 ? 8 : ver < 27 ? 10 : 12);
		}
	};
	
	// returns the maximum length of data possible in given configuration.
	var getmaxdatalen = function (ver, mode, ecclevel) {
		var nbits = ndatabits(ver, ecclevel) - 4 - ndatalenbits(ver, mode); // 4 for mode bits
		switch (mode) {
			case MODE_NUMERIC:
				return ((nbits / 10) | 0) * 3 + (nbits % 10 < 4 ? 0 : nbits % 10 < 7 ? 1 : 2);
			case MODE_ALPHANUMERIC:
				return ((nbits / 11) | 0) * 2 + (nbits % 11 < 6 ? 0 : 1);
			case MODE_OCTET:
				return (nbits / 8) | 0;
			case MODE_KANJI:
				return (nbits / 13) | 0;
		}
	};
	
	// checks if the given data can be encoded in given mode, and returns
	// the converted data for the further processing if possible. otherwise
	// returns null.
	//
	// this function does not check the length of data; it is a duty of
	// encode function below (as it depends on the version and ECC level too).
	var validatedata = function (mode, data) {
		switch (mode) {
			case MODE_NUMERIC:
				if (!data.match(NUMERIC_REGEXP))
					return null;
				return data;
	
			case MODE_ALPHANUMERIC:
				if (!data.match(ALPHANUMERIC_REGEXP))
					return null;
				return data.toUpperCase();
	
			case MODE_OCTET:
				if (typeof data === 'string') { // encode as utf-8 string
					var newdata = [];
					for (var i = 0; i < data.length; ++i) {
						var ch = data.charCodeAt(i);
						if (ch < 0x80) {
							newdata.push(ch);
						} else if (ch < 0x800) {
							newdata.push(0xc0 | (ch >> 6),
								0x80 | (ch & 0x3f));
						} else if (ch < 0x10000) {
							newdata.push(0xe0 | (ch >> 12),
								0x80 | ((ch >> 6) & 0x3f),
								0x80 | (ch & 0x3f));
						} else {
							newdata.push(0xf0 | (ch >> 18),
								0x80 | ((ch >> 12) & 0x3f),
								0x80 | ((ch >> 6) & 0x3f),
								0x80 | (ch & 0x3f));
						}
					}
					return newdata;
				} else {
					return data;
				}
		}
	};
	
	// returns the code words (sans ECC bits) for given data and configurations.
	// requires data to be preprocessed by validatedata. no length check is
	// performed, and everything has to be checked before calling this function.
	var encode = function (ver, mode, data, maxbuflen) {
		var buf = [];
		var bits = 0, remaining = 8;
		var datalen = data.length;
	
		// this function is intentionally no-op when n=0.
		var pack = function (x, n) {
			if (n >= remaining) {
				buf.push(bits | (x >> (n -= remaining)));
				while (n >= 8)
					buf.push((x >> (n -= 8)) & 255);
				bits = 0;
				remaining = 8;
			}
			if (n > 0)
				bits |= (x & ((1 << n) - 1)) << (remaining -= n);
		};
	
		var nlenbits = ndatalenbits(ver, mode);
		pack(mode, 4);
		pack(datalen, nlenbits);
	
		switch (mode) {
			case MODE_NUMERIC:
				for (var i = 2; i < datalen; i += 3) {
					pack(parseInt(data.substring(i - 2, i + 1), 10), 10);
				}
				pack(parseInt(data.substring(i - 2), 10), [0, 4, 7][datalen % 3]);
				break;
	
			case MODE_ALPHANUMERIC:
				for (var i = 1; i < datalen; i += 2) {
					pack(ALPHANUMERIC_MAP[data.charAt(i - 1)] * 45 +
						ALPHANUMERIC_MAP[data.charAt(i)], 11);
				}
				if (datalen % 2 == 1) {
					pack(ALPHANUMERIC_MAP[data.charAt(i - 1)], 6);
				}
				break;
	
			case MODE_OCTET:
				for (var i = 0; i < datalen; ++i) {
					pack(data[i], 8);
				}
				break;
		}
	
		// final bits. it is possible that adding terminator causes the buffer
		// to overflow, but then the buffer truncated to the maximum size will
		// be valid as the truncated terminator mode bits and padding is
		// identical in appearance (cf. JIS X 0510:2004 sec 8.4.8).
		pack(MODE_TERMINATOR, 4);
		if (remaining < 8)
			buf.push(bits);
	
		// the padding to fill up the remaining space. we should not add any
		// words when the overflow already occurred.
		while (buf.length + 1 < maxbuflen)
			buf.push(0xec, 0x11);
		if (buf.length < maxbuflen)
			buf.push(0xec);
		return buf;
	};
	
	// calculates ECC code words for given code words and generator polynomial.
	//
	// this is quite similar to CRC calculation as both Reed-Solomon and CRC use
	// the certain kind of cyclic codes, which is effectively the division of
	// zero-augumented polynomial by the generator polynomial. the only difference
	// is that Reed-Solomon uses GF(2^8), instead of CRC's GF(2), and Reed-Solomon
	// uses the different generator polynomial than CRC's.
	var calculateecc = function (poly, genpoly) {
		var modulus = poly.slice(0);
		var polylen = poly.length, genpolylen = genpoly.length;
		for (var i = 0; i < genpolylen; ++i)
			modulus.push(0);
		for (var i = 0; i < polylen; ) {
			var quotient = GF256_INVMAP[modulus[i++]];
			if (quotient >= 0) {
				for (var j = 0; j < genpolylen; ++j) {
					modulus[i + j] ^= GF256_MAP[(quotient + genpoly[j]) % 255];
				}
			}
		}
		return modulus.slice(polylen);
	};
	
	// auguments ECC code words to given code words. the resulting words are
	// ready to be encoded in the matrix.
	//
	// the much of actual augumenting procedure follows JIS X 0510:2004 sec 8.7.
	// the code is simplified using the fact that the size of each code & ECC
	// blocks is almost same; for example, when we have 4 blocks and 46 data words
	// the number of code words in those blocks are 11, 11, 12, 12 respectively.
	var augumenteccs = function (poly, nblocks, genpoly) {
		var subsizes = [];
		var subsize = (poly.length / nblocks) | 0, subsize0 = 0;
		var pivot = nblocks - poly.length % nblocks;
		for (var i = 0; i < pivot; ++i) {
			subsizes.push(subsize0);
			subsize0 += subsize;
		}
		for (var i = pivot; i < nblocks; ++i) {
			subsizes.push(subsize0);
			subsize0 += subsize + 1;
		}
		subsizes.push(subsize0);
	
		var eccs = [];
		for (var i = 0; i < nblocks; ++i) {
			eccs.push(calculateecc(poly.slice(subsizes[i], subsizes[i + 1]), genpoly));
		}
	
		var result = [];
		var nitemsperblock = (poly.length / nblocks) | 0;
		for (var i = 0; i < nitemsperblock; ++i) {
			for (var j = 0; j < nblocks; ++j) {
				result.push(poly[subsizes[j] + i]);
			}
		}
		for (var j = pivot; j < nblocks; ++j) {
			result.push(poly[subsizes[j + 1] - 1]);
		}
		for (var i = 0; i < genpoly.length; ++i) {
			for (var j = 0; j < nblocks; ++j) {
				result.push(eccs[j][i]);
			}
		}
		return result;
	};
	
	// auguments BCH(p+q,q) code to the polynomial over GF(2), given the proper
	// genpoly. the both input and output are in binary numbers, and unlike
	// calculateecc genpoly should include the 1 bit for the highest degree.
	//
	// actual polynomials used for this procedure are as follows:
	// - p=10, q=5, genpoly=x^10+x^8+x^5+x^4+x^2+x+1 (JIS X 0510:2004 Appendix C)
	// - p=18, q=6, genpoly=x^12+x^11+x^10+x^9+x^8+x^5+x^2+1 (ibid. Appendix D)
	var augumentbch = function (poly, p, genpoly, q) {
		var modulus = poly << q;
		for (var i = p - 1; i >= 0; --i) {
			if ((modulus >> (q + i)) & 1)
				modulus ^= genpoly << i;
		}
		return (poly << q) | modulus;
	};
	
	// creates the base matrix for given version. it returns two matrices, one of
	// them is the actual one and the another represents the "reserved" portion
	// (e.g. finder and timing patterns) of the matrix.
	//
	// some entries in the matrix may be undefined, rather than 0 or 1. this is
	// intentional (no initialization needed!), and putdata below will fill
	// the remaining ones.
	var makebasematrix = function (ver) {
		var v = VERSIONS[ver], n = getsizebyver(ver);
		var matrix = [], reserved = [];
		for (var i = 0; i < n; ++i) {
			matrix.push([]);
			reserved.push([]);
		}
	
		var blit = function (y, x, h, w, bits) {
			for (var i = 0; i < h; ++i) {
				for (var j = 0; j < w; ++j) {
					matrix[y + i][x + j] = (bits[i] >> j) & 1;
					reserved[y + i][x + j] = 1;
				}
			}
		};
	
		// finder patterns and a part of timing patterns
		// will also mark the format information area (not yet written) as reserved.
		blit(0, 0, 9, 9, [0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x17f, 0x00, 0x40]);
		blit(n - 8, 0, 8, 9, [0x100, 0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x7f]);
		blit(0, n - 8, 9, 8, [0xfe, 0x82, 0xba, 0xba, 0xba, 0x82, 0xfe, 0x00, 0x00]);
	
		// the rest of timing patterns
		for (var i = 9; i < n - 8; ++i) {
			matrix[6][i] = matrix[i][6] = ~i & 1;
			reserved[6][i] = reserved[i][6] = 1;
		}
	
		// alignment patterns
		var aligns = v[2], m = aligns.length;
		for (var i = 0; i < m; ++i) {
			var minj = (i === 0 || i === m - 1 ? 1 : 0), maxj = (i === 0 ? m - 1 : m);
			for (var j = minj; j < maxj; ++j) {
				blit(aligns[i], aligns[j], 5, 5, [0x1f, 0x11, 0x15, 0x11, 0x1f]);
			}
		}
	
		// version information
		if (needsverinfo(ver)) {
			var code = augumentbch(ver, 6, 0x1f25, 12);
			var k = 0;
			for (var i = 0; i < 6; ++i) {
				for (var j = 0; j < 3; ++j) {
					matrix[i][(n - 11) + j] = matrix[(n - 11) + j][i] = (code >> k++) & 1;
					reserved[i][(n - 11) + j] = reserved[(n - 11) + j][i] = 1;
				}
			}
		}
	
		return {matrix: matrix, reserved: reserved};
	};
	
	// fills the data portion (i.e. unmarked in reserved) of the matrix with given
	// code words. the size of code words should be no more than available bits,
	// and remaining bits are padded to 0 (cf. JIS X 0510:2004 sec 8.7.3).
	var putdata = function (matrix, reserved, buf) {
		var n = matrix.length;
		var k = 0, dir = -1;
		for (var i = n - 1; i >= 0; i -= 2) {
			if (i == 6)
				--i; // skip the entire timing pattern column
			var jj = (dir < 0 ? n - 1 : 0);
			for (var j = 0; j < n; ++j) {
				for (var ii = i; ii > i - 2; --ii) {
					if (!reserved[jj][ii]) {
						// may overflow, but (undefined >> x)
						// is 0 so it will auto-pad to zero.
						matrix[jj][ii] = (buf[k >> 3] >> (~k & 7)) & 1;
						++k;
					}
				}
				jj += dir;
			}
			dir = -dir;
		}
		return matrix;
	};
	
	// XOR-masks the data portion of the matrix. repeating the call with the same
	// arguments will revert the prior call (convenient in the matrix evaluation).
	var maskdata = function (matrix, reserved, mask) {
		var maskf = MASKFUNCS[mask];
		var n = matrix.length;
		for (var i = 0; i < n; ++i) {
			for (var j = 0; j < n; ++j) {
				if (!reserved[i][j])
					matrix[i][j] ^= maskf(i, j);
			}
		}
		return matrix;
	};
	
	// puts the format information.
	var putformatinfo = function (matrix, reserved, ecclevel, mask) {
		var n = matrix.length;
		var code = augumentbch((ecclevel << 3) | mask, 5, 0x537, 10) ^ 0x5412;
		for (var i = 0; i < 15; ++i) {
			var r = [0, 1, 2, 3, 4, 5, 7, 8, n - 7, n - 6, n - 5, n - 4, n - 3, n - 2, n - 1][i];
			var c = [n - 1, n - 2, n - 3, n - 4, n - 5, n - 6, n - 7, n - 8, 7, 5, 4, 3, 2, 1, 0][i];
			matrix[r][8] = matrix[8][c] = (code >> i) & 1;
			// we don't have to mark those bits reserved; always done
			// in makebasematrix above.
		}
		return matrix;
	};
	
	// evaluates the resulting matrix and returns the score (lower is better).
	// (cf. JIS X 0510:2004 sec 8.8.2)
	//
	// the evaluation procedure tries to avoid the problematic patterns naturally
	// occuring from the original matrix. for example, it penaltizes the patterns
	// which just look like the finder pattern which will confuse the decoder.
	// we choose the mask which results in the lowest score among 8 possible ones.
	//
	// note: zxing seems to use the same procedure and in many cases its choice
	// agrees to ours, but sometimes it does not. practically it doesn't matter.
	var evaluatematrix = function (matrix) {
		// N1+(k-5) points for each consecutive row of k same-colored modules,
		// where k >= 5. no overlapping row counts.
		var PENALTY_CONSECUTIVE = 3;
		// N2 points for each 2x2 block of same-colored modules.
		// overlapping block does count.
		var PENALTY_TWOBYTWO = 3;
		// N3 points for each pattern with >4W:1B:1W:3B:1W:1B or
		// 1B:1W:3B:1W:1B:>4W, or their multiples (e.g. highly unlikely,
		// but 13W:3B:3W:9B:3W:3B counts).
		var PENALTY_FINDERLIKE = 40;
		// N4*k points for every (5*k)% deviation from 50% black density.
		// i.e. k=1 for 55~60% and 40~45%, k=2 for 60~65% and 35~40%, etc.
		var PENALTY_DENSITY = 10;
	
		var evaluategroup = function (groups) { // assumes [W,B,W,B,W,...,B,W]
			var score = 0;
			for (var i = 0; i < groups.length; ++i) {
				if (groups[i] >= 5)
					score += PENALTY_CONSECUTIVE + (groups[i] - 5);
			}
			for (var i = 5; i < groups.length; i += 2) {
				var p = groups[i];
				if (groups[i - 1] == p && groups[i - 2] == 3 * p && groups[i - 3] == p &&
					groups[i - 4] == p && (groups[i - 5] >= 4 * p || groups[i + 1] >= 4 * p)) {
					// this part differs from zxing...
					score += PENALTY_FINDERLIKE;
				}
			}
			return score;
		};
	
		var n = matrix.length;
		var score = 0, nblacks = 0;
		for (var i = 0; i < n; ++i) {
			var row = matrix[i];
			var groups;
	
			// evaluate the current row
			groups = [0]; // the first empty group of white
			for (var j = 0; j < n; ) {
				var k;
				for (k = 0; j < n && row[j]; ++k)
					++j;
				groups.push(k);
				for (k = 0; j < n && !row[j]; ++k)
					++j;
				groups.push(k);
			}
			score += evaluategroup(groups);
	
			// evaluate the current column
			groups = [0];
			for (var j = 0; j < n; ) {
				var k;
				for (k = 0; j < n && matrix[j][i]; ++k)
					++j;
				groups.push(k);
				for (k = 0; j < n && !matrix[j][i]; ++k)
					++j;
				groups.push(k);
			}
			score += evaluategroup(groups);
	
			// check the 2x2 box and calculate the density
			var nextrow = matrix[i + 1] || [];
			nblacks += row[0];
			for (var j = 1; j < n; ++j) {
				var p = row[j];
				nblacks += p;
				// at least comparison with next row should be strict...
				if (row[j - 1] == p && nextrow[j] === p && nextrow[j - 1] === p) {
					score += PENALTY_TWOBYTWO;
				}
			}
		}
	
		score += PENALTY_DENSITY * ((Math.abs(nblacks / n / n - 0.5) / 0.05) | 0);
		return score;
	};
	
	// returns the fully encoded QR code matrix which contains given data.
	// it also chooses the best mask automatically when mask is -1.
	var generate = function (data, ver, mode, ecclevel, mask) {
		var v = VERSIONS[ver];
		var buf = encode(ver, mode, data, ndatabits(ver, ecclevel) >> 3);
		buf = augumenteccs(buf, v[1][ecclevel], GF256_GENPOLY[v[0][ecclevel]]);
	
		var result = makebasematrix(ver);
		var matrix = result.matrix, reserved = result.reserved;
		putdata(matrix, reserved, buf);
	
		if (mask < 0) {
			// find the best mask
			maskdata(matrix, reserved, 0);
			putformatinfo(matrix, reserved, ecclevel, 0);
			var bestmask = 0, bestscore = evaluatematrix(matrix);
			maskdata(matrix, reserved, 0);
			for (mask = 1; mask < 8; ++mask) {
				maskdata(matrix, reserved, mask);
				putformatinfo(matrix, reserved, ecclevel, mask);
				var score = evaluatematrix(matrix);
				if (bestscore > score) {
					bestscore = score;
					bestmask = mask;
				}
				maskdata(matrix, reserved, mask);
			}
			mask = bestmask;
		}
	
		maskdata(matrix, reserved, mask);
		putformatinfo(matrix, reserved, ecclevel, mask);
		return matrix;
	};
	
	// the public interface is trivial; the options available are as follows:
	//
	// - version: an integer in [1,40]. when omitted (or -1) the smallest possible
	//   version is chosen.
	// - mode: one of 'numeric', 'alphanumeric', 'octet'. when omitted the smallest
	//   possible mode is chosen.
	// - eccLevel: one of 'L', 'M', 'Q', 'H'. defaults to 'L'.
	// - mask: an integer in [0,7]. when omitted (or -1) the best mask is chosen.
	//
	
	function generateFrame(data, options) {
		var MODES = {'numeric': MODE_NUMERIC, 'alphanumeric': MODE_ALPHANUMERIC,
			'octet': MODE_OCTET};
		var ECCLEVELS = {'L': ECCLEVEL_L, 'M': ECCLEVEL_M, 'Q': ECCLEVEL_Q,
			'H': ECCLEVEL_H};
	
		options = options || {};
		var ver = options.version || -1;
		var ecclevel = ECCLEVELS[(options.eccLevel || 'L').toUpperCase()];
		var mode = options.mode ? MODES[options.mode.toLowerCase()] : -1;
		var mask = 'mask' in options ? options.mask : -1;
	
		if (mode < 0) {
			if (typeof data === 'string') {
				if (data.match(NUMERIC_REGEXP)) {
					mode = MODE_NUMERIC;
				} else if (data.match(ALPHANUMERIC_OUT_REGEXP)) {
					// while encode supports case-insensitive encoding, we restrict the data to be uppercased when auto-selecting the mode.
					mode = MODE_ALPHANUMERIC;
				} else {
					mode = MODE_OCTET;
				}
			} else {
				mode = MODE_OCTET;
			}
		} else if (!(mode == MODE_NUMERIC || mode == MODE_ALPHANUMERIC ||
			mode == MODE_OCTET)) {
			throw 'invalid or unsupported mode';
		}
	
		data = validatedata(mode, data);
		if (data === null)
			throw 'invalid data format';
	
		if (ecclevel < 0 || ecclevel > 3)
			throw 'invalid ECC level';
	
		if (ver < 0) {
			for (ver = 1; ver <= 40; ++ver) {
				if (data.length <= getmaxdatalen(ver, mode, ecclevel))
					break;
			}
			if (ver > 40)
				throw 'too large data for the Qr format';
		} else if (ver < 1 || ver > 40) {
			throw 'invalid Qr version! should be between 1 and 40';
		}
	
		if (mask != -1 && (mask < 0 || mask > 8))
			throw 'invalid mask';
		//console.log('version:', ver, 'mode:', mode, 'ECC:', ecclevel, 'mask:', mask )
		return generate(data, ver, mode, ecclevel, mask);
	}
	
	
	// options
	// - modulesize: a number. this is a size of each modules in pixels, and
	//   defaults to 5px.
	// - margin: a number. this is a size of margin in *modules*, and defaults to
	//   4 (white modules). the specficiation mandates the margin no less than 4
	//   modules, so it is better not to alter this value unless you know what
	//   you're doing.
	function buildCanvas(data, options) {
	
		var canvas = [];
		var background = options.background || '#fff';
		var foreground = options.foreground || '#000';
		//var margin = options.margin || 4;
		var matrix = generateFrame(data, options);
		var n = matrix.length;
		var modSize = Math.floor(options.fit ? options.fit / n : 5);
		var size = n * modSize;
	
		canvas.push({
			type: 'rect',
			x: 0, y: 0, w: size, h: size, lineWidth: 0, color: background
		});
	
		for (var i = 0; i < n; ++i) {
			for (var j = 0; j < n; ++j) {
				if (matrix[i][j]) {
					canvas.push({
						type: 'rect',
						x: modSize * j,
						y: modSize * i,
						w: modSize,
						h: modSize,
						lineWidth: 0,
						color: foreground
					});
				}
			}
		}
	
		return {
			canvas: canvas,
			size: size
		};
	
	}
	
	function measure(node) {
		var cd = buildCanvas(node.qr, node);
		node._canvas = cd.canvas;
		node._width = node._height = node._minWidth = node._maxWidth = node._minHeight = node._maxHeight = cd.size;
		return node;
	}
	
	module.exports = {
		measure: measure
	};
	
	/***/ }),
	/* 135 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var ElementWriter = __webpack_require__(136);
	
	/**
	 * Creates an instance of PageElementWriter - an extended ElementWriter
	 * which can handle:
	 * - page-breaks (it adds new pages when there's not enough space left),
	 * - repeatable fragments (like table-headers, which are repeated everytime
	 *                         a page-break occurs)
	 * - transactions (used for unbreakable-blocks when we want to make sure
	 *                 whole block will be rendered on the same page)
	 */
	function PageElementWriter(context, tracker) {
		this.transactionLevel = 0;
		this.repeatables = [];
		this.tracker = tracker;
		this.writer = new ElementWriter(context, tracker);
	}
	
	function fitOnPage(self, addFct) {
		var position = addFct(self);
		if (!position) {
			self.moveToNextPage();
			position = addFct(self);
		}
		return position;
	}
	
	PageElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
		return fitOnPage(this, function (self) {
			return self.writer.addLine(line, dontUpdateContextPosition, index);
		});
	};
	
	PageElementWriter.prototype.addImage = function (image, index) {
		return fitOnPage(this, function (self) {
			return self.writer.addImage(image, index);
		});
	};
	
	PageElementWriter.prototype.addQr = function (qr, index) {
		return fitOnPage(this, function (self) {
			return self.writer.addQr(qr, index);
		});
	};
	
	PageElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
		return this.writer.addVector(vector, ignoreContextX, ignoreContextY, index);
	};
	
	PageElementWriter.prototype.beginClip = function (width, height) {
		return this.writer.beginClip(width, height);
	};
	
	PageElementWriter.prototype.endClip = function () {
		return this.writer.endClip();
	};
	
	PageElementWriter.prototype.alignCanvas = function (node) {
		this.writer.alignCanvas(node);
	};
	
	PageElementWriter.prototype.addFragment = function (fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
		if (!this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition)) {
			this.moveToNextPage();
			this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition);
		}
	};
	
	PageElementWriter.prototype.moveToNextPage = function (pageOrientation) {
	
		var nextPage = this.writer.context.moveToNextPage(pageOrientation);
	
		if (nextPage.newPageCreated) {
			this.repeatables.forEach(function (rep) {
				this.writer.addFragment(rep, true);
			}, this);
		} else {
			this.repeatables.forEach(function (rep) {
				this.writer.context.moveDown(rep.height);
			}, this);
		}
	
		this.writer.tracker.emit('pageChanged', {
			prevPage: nextPage.prevPage,
			prevY: nextPage.prevY,
			y: nextPage.y
		});
	};
	
	PageElementWriter.prototype.beginUnbreakableBlock = function (width, height) {
		if (this.transactionLevel++ === 0) {
			this.originalX = this.writer.context.x;
			this.writer.pushContext(width, height);
		}
	};
	
	PageElementWriter.prototype.commitUnbreakableBlock = function (forcedX, forcedY) {
		if (--this.transactionLevel === 0) {
			var unbreakableContext = this.writer.context;
			this.writer.popContext();
	
			var nbPages = unbreakableContext.pages.length;
			if (nbPages > 0) {
				// no support for multi-page unbreakableBlocks
				var fragment = unbreakableContext.pages[0];
				fragment.xOffset = forcedX;
				fragment.yOffset = forcedY;
	
				//TODO: vectors can influence height in some situations
				if (nbPages > 1) {
					// on out-of-context blocs (headers, footers, background) height should be the whole DocumentContext height
					if (forcedX !== undefined || forcedY !== undefined) {
						fragment.height = unbreakableContext.getCurrentPage().pageSize.height - unbreakableContext.pageMargins.top - unbreakableContext.pageMargins.bottom;
					} else {
						fragment.height = this.writer.context.getCurrentPage().pageSize.height - this.writer.context.pageMargins.top - this.writer.context.pageMargins.bottom;
						for (var i = 0, l = this.repeatables.length; i < l; i++) {
							fragment.height -= this.repeatables[i].height;
						}
					}
				} else {
					fragment.height = unbreakableContext.y;
				}
	
				if (forcedX !== undefined || forcedY !== undefined) {
					this.writer.addFragment(fragment, true, true, true);
				} else {
					this.addFragment(fragment);
				}
			}
		}
	};
	
	PageElementWriter.prototype.currentBlockToRepeatable = function () {
		var unbreakableContext = this.writer.context;
		var rep = {items: []};
	
		unbreakableContext.pages[0].items.forEach(function (item) {
			rep.items.push(item);
		});
	
		rep.xOffset = this.originalX;
	
		//TODO: vectors can influence height in some situations
		rep.height = unbreakableContext.y;
	
		return rep;
	};
	
	PageElementWriter.prototype.pushToRepeatables = function (rep) {
		this.repeatables.push(rep);
	};
	
	PageElementWriter.prototype.popFromRepeatables = function () {
		this.repeatables.pop();
	};
	
	PageElementWriter.prototype.context = function () {
		return this.writer.context;
	};
	
	module.exports = PageElementWriter;
	
	
	/***/ }),
	/* 136 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Line = __webpack_require__(82);
	var isNumber = __webpack_require__(0).isNumber;
	var pack = __webpack_require__(0).pack;
	var offsetVector = __webpack_require__(0).offsetVector;
	var DocumentContext = __webpack_require__(81);
	
	/**
	 * Creates an instance of ElementWriter - a line/vector writer, which adds
	 * elements to current page and sets their positions based on the context
	 */
	function ElementWriter(context, tracker) {
		this.context = context;
		this.contextStack = [];
		this.tracker = tracker;
	}
	
	function addPageItem(page, item, index) {
		if (index === null || index === undefined || index < 0 || index > page.items.length) {
			page.items.push(item);
		} else {
			page.items.splice(index, 0, item);
		}
	}
	
	ElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
		var height = line.getHeight();
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();
	
		if (context.availableHeight < height || !page) {
			return false;
		}
	
		line.x = context.x + (line.x || 0);
		line.y = context.y + (line.y || 0);
	
		this.alignLine(line);
	
		addPageItem(page, {
			type: 'line',
			item: line
		}, index);
		this.tracker.emit('lineAdded', line);
	
		if (!dontUpdateContextPosition) {
			context.moveDown(height);
		}
	
		return position;
	};
	
	ElementWriter.prototype.alignLine = function (line) {
		var width = this.context.availableWidth;
		var lineWidth = line.getWidth();
	
		var alignment = line.inlines && line.inlines.length > 0 && line.inlines[0].alignment;
	
		var offset = 0;
		switch (alignment) {
			case 'right':
				offset = width - lineWidth;
				break;
			case 'center':
				offset = (width - lineWidth) / 2;
				break;
		}
	
		if (offset) {
			line.x = (line.x || 0) + offset;
		}
	
		if (alignment === 'justify' &&
			!line.newLineForced &&
			!line.lastLineInParagraph &&
			line.inlines.length > 1) {
			var additionalSpacing = (width - lineWidth) / (line.inlines.length - 1);
	
			for (var i = 1, l = line.inlines.length; i < l; i++) {
				offset = i * additionalSpacing;
	
				line.inlines[i].x += offset;
				line.inlines[i].justifyShift = additionalSpacing;
			}
		}
	};
	
	ElementWriter.prototype.addImage = function (image, index) {
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();
	
		if (!page || (image.absolutePosition === undefined && context.availableHeight < image._height && page.items.length > 0)) {
			return false;
		}
	
		if (image._x === undefined) {
			image._x = image.x || 0;
		}
	
		image.x = context.x + image._x;
		image.y = context.y;
	
		this.alignImage(image);
	
		addPageItem(page, {
			type: 'image',
			item: image
		}, index);
	
		context.moveDown(image._height);
	
		return position;
	};
	
	ElementWriter.prototype.addQr = function (qr, index) {
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();
	
		if (!page || (qr.absolutePosition === undefined && context.availableHeight < qr._height)) {
			return false;
		}
	
		if (qr._x === undefined) {
			qr._x = qr.x || 0;
		}
	
		qr.x = context.x + qr._x;
		qr.y = context.y;
	
		this.alignImage(qr);
	
		for (var i = 0, l = qr._canvas.length; i < l; i++) {
			var vector = qr._canvas[i];
			vector.x += qr.x;
			vector.y += qr.y;
			this.addVector(vector, true, true, index);
		}
	
		context.moveDown(qr._height);
	
		return position;
	};
	
	ElementWriter.prototype.alignImage = function (image) {
		var width = this.context.availableWidth;
		var imageWidth = image._minWidth;
		var offset = 0;
		switch (image._alignment) {
			case 'right':
				offset = width - imageWidth;
				break;
			case 'center':
				offset = (width - imageWidth) / 2;
				break;
		}
	
		if (offset) {
			image.x = (image.x || 0) + offset;
		}
	};
	
	ElementWriter.prototype.alignCanvas = function (node) {
		var width = this.context.availableWidth;
		var canvasWidth = node._minWidth;
		var offset = 0;
		switch (node._alignment) {
			case 'right':
				offset = width - canvasWidth;
				break;
			case 'center':
				offset = (width - canvasWidth) / 2;
				break;
		}
		if (offset) {
			node.canvas.forEach(function (vector) {
				offsetVector(vector, offset, 0);
			});
		}
	};
	
	ElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();
	
		if (page) {
			offsetVector(vector, ignoreContextX ? 0 : context.x, ignoreContextY ? 0 : context.y);
			addPageItem(page, {
				type: 'vector',
				item: vector
			}, index);
			return position;
		}
	};
	
	ElementWriter.prototype.beginClip = function (width, height) {
		var ctx = this.context;
		var page = ctx.getCurrentPage();
		page.items.push({
			type: 'beginClip',
			item: {x: ctx.x, y: ctx.y, width: width, height: height}
		});
		return true;
	};
	
	ElementWriter.prototype.endClip = function () {
		var ctx = this.context;
		var page = ctx.getCurrentPage();
		page.items.push({
			type: 'endClip'
		});
		return true;
	};
	
	function cloneLine(line) {
		var result = new Line(line.maxWidth);
	
		for (var key in line) {
			if (line.hasOwnProperty(key)) {
				result[key] = line[key];
			}
		}
	
		return result;
	}
	
	ElementWriter.prototype.addFragment = function (block, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
		var ctx = this.context;
		var page = ctx.getCurrentPage();
	
		if (!useBlockXOffset && block.height > ctx.availableHeight) {
			return false;
		}
	
		block.items.forEach(function (item) {
			switch (item.type) {
				case 'line':
					var l = cloneLine(item.item);
	
					l.x = (l.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
					l.y = (l.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);
	
					page.items.push({
						type: 'line',
						item: l
					});
					break;
	
				case 'vector':
					var v = pack(item.item);
	
					offsetVector(v, useBlockXOffset ? (block.xOffset || 0) : ctx.x, useBlockYOffset ? (block.yOffset || 0) : ctx.y);
					page.items.push({
						type: 'vector',
						item: v
					});
					break;
	
				case 'image':
					var img = pack(item.item);
	
					img.x = (img.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
					img.y = (img.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);
	
					page.items.push({
						type: 'image',
						item: img
					});
					break;
			}
		});
	
		if (!dontUpdateContextPosition) {
			ctx.moveDown(block.height);
		}
	
		return true;
	};
	
	/**
	 * Pushes the provided context onto the stack or creates a new one
	 *
	 * pushContext(context) - pushes the provided context and makes it current
	 * pushContext(width, height) - creates and pushes a new context with the specified width and height
	 * pushContext() - creates a new context for unbreakable blocks (with current availableWidth and full-page-height)
	 */
	ElementWriter.prototype.pushContext = function (contextOrWidth, height) {
		if (contextOrWidth === undefined) {
			height = this.context.getCurrentPage().height - this.context.pageMargins.top - this.context.pageMargins.bottom;
			contextOrWidth = this.context.availableWidth;
		}
	
		if (isNumber(contextOrWidth)) {
			contextOrWidth = new DocumentContext({width: contextOrWidth, height: height}, {left: 0, right: 0, top: 0, bottom: 0});
		}
	
		this.contextStack.push(this.context);
		this.context = contextOrWidth;
	};
	
	ElementWriter.prototype.popContext = function () {
		this.context = this.contextStack.pop();
	};
	
	ElementWriter.prototype.getCurrentPositionOnPage = function () {
		return (this.contextStack[0] || this.context).getCurrentPosition();
	};
	
	
	module.exports = ElementWriter;
	
	
	/***/ }),
	/* 137 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var ColumnCalculator = __webpack_require__(44);
	var isFunction = __webpack_require__(0).isFunction;
	
	function TableProcessor(tableNode) {
		this.tableNode = tableNode;
	}
	
	TableProcessor.prototype.beginTable = function (writer) {
		var tableNode;
		var availableWidth;
		var self = this;
	
		tableNode = this.tableNode;
		this.offsets = tableNode._offsets;
		this.layout = tableNode._layout;
	
		availableWidth = writer.context().availableWidth - this.offsets.total;
		ColumnCalculator.buildColumnWidths(tableNode.table.widths, availableWidth);
	
		this.tableWidth = tableNode._offsets.total + getTableInnerContentWidth();
		this.rowSpanData = prepareRowSpanData();
		this.cleanUpRepeatables = false;
	
		this.headerRows = tableNode.table.headerRows || 0;
		this.rowsWithoutPageBreak = this.headerRows + (tableNode.table.keepWithHeaderRows || 0);
		this.dontBreakRows = tableNode.table.dontBreakRows || false;
	
		if (this.rowsWithoutPageBreak) {
			writer.beginUnbreakableBlock();
		}
	
		// update the border properties of all cells before drawing any lines
		prepareCellBorders(this.tableNode.table.body);
	
		this.drawHorizontalLine(0, writer);
	
		function getTableInnerContentWidth() {
			var width = 0;
	
			tableNode.table.widths.forEach(function (w) {
				width += w._calcWidth;
			});
	
			return width;
		}
	
		function prepareRowSpanData() {
			var rsd = [];
			var x = 0;
			var lastWidth = 0;
	
			rsd.push({left: 0, rowSpan: 0});
	
			for (var i = 0, l = self.tableNode.table.body[0].length; i < l; i++) {
				var paddings = self.layout.paddingLeft(i, self.tableNode) + self.layout.paddingRight(i, self.tableNode);
				var lBorder = self.layout.vLineWidth(i, self.tableNode);
				lastWidth = paddings + lBorder + self.tableNode.table.widths[i]._calcWidth;
				rsd[rsd.length - 1].width = lastWidth;
				x += lastWidth;
				rsd.push({left: x, rowSpan: 0, width: 0});
			}
	
			return rsd;
		}
	
		// Iterate through all cells. If the current cell is the start of a
		// rowSpan/colSpan, update the border property of the cells on its
		// bottom/right accordingly. This is needed since each iteration of the
		// line-drawing loops draws lines for a single cell, not for an entire
		// rowSpan/colSpan.
		function prepareCellBorders(body) {
			for (var rowIndex = 0; rowIndex < body.length; rowIndex++) {
				var row = body[rowIndex];
	
				for (var colIndex = 0; colIndex < row.length; colIndex++) {
					var cell = row[colIndex];
	
					if (cell.border) {
						var rowSpan = cell.rowSpan || 1;
						var colSpan = cell.colSpan || 1;
	
						for (var rowOffset = 0; rowOffset < rowSpan; rowOffset++) {
							// set left border
							if (cell.border[0] !== undefined && rowOffset > 0) {
								setBorder(rowIndex + rowOffset, colIndex, 0, cell.border[0]);
							}
	
							// set right border
							if (cell.border[2] !== undefined) {
								setBorder(rowIndex + rowOffset, colIndex + colSpan - 1, 2, cell.border[2]);
							}
						}
	
						for (var colOffset = 0; colOffset < colSpan; colOffset++) {
							// set top border
							if (cell.border[1] !== undefined && colOffset > 0) {
								setBorder(rowIndex, colIndex + colOffset, 1, cell.border[1]);
							}
	
							// set bottom border
							if (cell.border[3] !== undefined) {
								setBorder(rowIndex + rowSpan - 1, colIndex + colOffset, 3, cell.border[3]);
							}
						}
					}
				}
			}
	
			// helper function to set the border for a given cell
			function setBorder(rowIndex, colIndex, borderIndex, borderValue) {
				var cell = body[rowIndex][colIndex];
				cell.border = cell.border || {};
				cell.border[borderIndex] = borderValue;
			}
		}
	};
	
	TableProcessor.prototype.onRowBreak = function (rowIndex, writer) {
		var self = this;
		return function () {
			var offset = self.rowPaddingTop + (!self.headerRows ? self.topLineWidth : 0);
			writer.context().availableHeight -= self.reservedAtBottom;
			writer.context().moveDown(offset);
		};
	};
	
	TableProcessor.prototype.beginRow = function (rowIndex, writer) {
		this.topLineWidth = this.layout.hLineWidth(rowIndex, this.tableNode);
		this.rowPaddingTop = this.layout.paddingTop(rowIndex, this.tableNode);
		this.bottomLineWidth = this.layout.hLineWidth(rowIndex + 1, this.tableNode);
		this.rowPaddingBottom = this.layout.paddingBottom(rowIndex, this.tableNode);
	
		this.rowCallback = this.onRowBreak(rowIndex, writer);
		writer.tracker.startTracking('pageChanged', this.rowCallback);
		if (this.dontBreakRows) {
			writer.beginUnbreakableBlock();
		}
		this.rowTopY = writer.context().y;
		this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom;
	
		writer.context().availableHeight -= this.reservedAtBottom;
	
		writer.context().moveDown(this.rowPaddingTop);
	};
	
	TableProcessor.prototype.drawHorizontalLine = function (lineIndex, writer, overrideY) {
		var lineWidth = this.layout.hLineWidth(lineIndex, this.tableNode);
		if (lineWidth) {
			var offset = lineWidth / 2;
			var currentLine = null;
			var body = this.tableNode.table.body;
	
			for (var i = 0, l = this.rowSpanData.length; i < l; i++) {
				var data = this.rowSpanData[i];
				var shouldDrawLine = !data.rowSpan;
	
				// draw only if the current cell requires a top border or the cell in the
				// row above requires a bottom border
				if (shouldDrawLine && i < l - 1) {
					var topBorder = false, bottomBorder = false;
	
					// the current cell
					if (lineIndex < body.length) {
						var cell = body[lineIndex][i];
						topBorder = cell.border ? cell.border[1] : this.layout.defaultBorder;
					}
	
					// the cell in the row above
					if (lineIndex > 0) {
						var cellAbove = body[lineIndex - 1][i];
						bottomBorder = cellAbove.border ? cellAbove.border[3] : this.layout.defaultBorder;
					}
	
					shouldDrawLine = topBorder || bottomBorder;
				}
	
				if (!currentLine && shouldDrawLine) {
					currentLine = {left: data.left, width: 0};
				}
	
				if (shouldDrawLine) {
					currentLine.width += (data.width || 0);
				}
	
				var y = (overrideY || 0) + offset;
	
				if (!shouldDrawLine || i === l - 1) {
					if (currentLine && currentLine.width) {
						writer.addVector({
							type: 'line',
							x1: currentLine.left,
							x2: currentLine.left + currentLine.width,
							y1: y,
							y2: y,
							lineWidth: lineWidth,
							lineColor: isFunction(this.layout.hLineColor) ? this.layout.hLineColor(lineIndex, this.tableNode) : this.layout.hLineColor
						}, false, overrideY);
						currentLine = null;
					}
				}
			}
	
			writer.context().moveDown(lineWidth);
		}
	};
	
	TableProcessor.prototype.drawVerticalLine = function (x, y0, y1, vLineIndex, writer) {
		var width = this.layout.vLineWidth(vLineIndex, this.tableNode);
		if (width === 0) {
			return;
		}
		writer.addVector({
			type: 'line',
			x1: x + width / 2,
			x2: x + width / 2,
			y1: y0,
			y2: y1,
			lineWidth: width,
			lineColor: isFunction(this.layout.vLineColor) ? this.layout.vLineColor(vLineIndex, this.tableNode) : this.layout.vLineColor
		}, false, true);
	};
	
	TableProcessor.prototype.endTable = function (writer) {
		if (this.cleanUpRepeatables) {
			writer.popFromRepeatables();
			this.headerRepeatableHeight = null;
		}
	};
	
	TableProcessor.prototype.endRow = function (rowIndex, writer, pageBreaks) {
		var l, i;
		var self = this;
		writer.tracker.stopTracking('pageChanged', this.rowCallback);
		writer.context().moveDown(this.layout.paddingBottom(rowIndex, this.tableNode));
		writer.context().availableHeight += this.reservedAtBottom;
	
		var endingPage = writer.context().page;
		var endingY = writer.context().y;
	
		var xs = getLineXs();
	
		var ys = [];
	
		var hasBreaks = pageBreaks && pageBreaks.length > 0;
		var body = this.tableNode.table.body;
	
		ys.push({
			y0: this.rowTopY,
			page: hasBreaks ? pageBreaks[0].prevPage : endingPage
		});
	
		if (hasBreaks) {
			for (i = 0, l = pageBreaks.length; i < l; i++) {
				var pageBreak = pageBreaks[i];
				ys[ys.length - 1].y1 = pageBreak.prevY;
	
				ys.push({y0: pageBreak.y, page: pageBreak.prevPage + 1});
	
				if (this.headerRepeatableHeight) {
					ys[ys.length - 1].y0 += this.headerRepeatableHeight;
				}
			}
		}
	
		ys[ys.length - 1].y1 = endingY;
	
		var skipOrphanePadding = (ys[0].y1 - ys[0].y0 === this.rowPaddingTop);
		for (var yi = (skipOrphanePadding ? 1 : 0), yl = ys.length; yi < yl; yi++) {
			var willBreak = yi < ys.length - 1;
			var rowBreakWithoutHeader = (yi > 0 && !this.headerRows);
			var hzLineOffset = rowBreakWithoutHeader ? 0 : this.topLineWidth;
			var y1 = ys[yi].y0;
			var y2 = ys[yi].y1;
	
			if (willBreak) {
				y2 = y2 + this.rowPaddingBottom;
			}
	
			if (writer.context().page != ys[yi].page) {
				writer.context().page = ys[yi].page;
	
				//TODO: buggy, availableHeight should be updated on every pageChanged event
				// TableProcessor should be pageChanged listener, instead of processRow
				this.reservedAtBottom = 0;
			}
	
			for (i = 0, l = xs.length; i < l; i++) {
				var leftBorder = false, rightBorder = false;
				var colIndex = xs[i].index;
	
				// the current cell
				if (colIndex < body[rowIndex].length) {
					var cell = body[rowIndex][colIndex];
					leftBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
				}
	
				// the cell from before column
				if (colIndex > 0) {
					var cell = body[rowIndex][colIndex - 1];
					rightBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
				}
	
				if (leftBorder || rightBorder) {
					this.drawVerticalLine(xs[i].x, y1 - hzLineOffset, y2 + this.bottomLineWidth, xs[i].index, writer);
				}
	
				if (i < l - 1) {
					var fillColor = body[rowIndex][colIndex].fillColor;
					if (!fillColor) {
						fillColor = isFunction(this.layout.fillColor) ? this.layout.fillColor(rowIndex, this.tableNode, colIndex) : this.layout.fillColor;
					}
					if (fillColor) {
						var wBorder = (leftBorder || rightBorder) ? this.layout.vLineWidth(colIndex, this.tableNode) : 0;
						var xf = xs[i].x + wBorder;
						var yf = this.dontBreakRows ? y1 : y1 - hzLineOffset;
						writer.addVector({
							type: 'rect',
							x: xf,
							y: yf,
							w: xs[i + 1].x - xf,
							h: y2 + this.bottomLineWidth - yf,
							lineWidth: 0,
							color: fillColor
						}, false, true, writer.context().hasBackground ? 1 : 0);
					}
				}
			}
	
			if (willBreak && this.layout.hLineWhenBroken !== false) {
				this.drawHorizontalLine(rowIndex + 1, writer, y2);
			}
			if (rowBreakWithoutHeader && this.layout.hLineWhenBroken !== false) {
				this.drawHorizontalLine(rowIndex, writer, y1);
			}
		}
	
		writer.context().page = endingPage;
		writer.context().y = endingY;
	
		var row = this.tableNode.table.body[rowIndex];
		for (i = 0, l = row.length; i < l; i++) {
			if (row[i].rowSpan) {
				this.rowSpanData[i].rowSpan = row[i].rowSpan;
	
				// fix colSpans
				if (row[i].colSpan && row[i].colSpan > 1) {
					for (var j = 1; j < row[i].rowSpan; j++) {
						this.tableNode.table.body[rowIndex + j][i]._colSpan = row[i].colSpan;
					}
				}
			}
	
			if (this.rowSpanData[i].rowSpan > 0) {
				this.rowSpanData[i].rowSpan--;
			}
		}
	
		this.drawHorizontalLine(rowIndex + 1, writer);
	
		if (this.headerRows && rowIndex === this.headerRows - 1) {
			this.headerRepeatable = writer.currentBlockToRepeatable();
		}
	
		if (this.dontBreakRows) {
			writer.tracker.auto('pageChanged',
				function () {
					if (!self.headerRows && self.layout.hLineWhenBroken !== false) {
						self.drawHorizontalLine(rowIndex, writer);
					}
				},
				function () {
					writer.commitUnbreakableBlock();
				}
			);
		}
	
		if (this.headerRepeatable && (rowIndex === (this.rowsWithoutPageBreak - 1) || rowIndex === this.tableNode.table.body.length - 1)) {
			this.headerRepeatableHeight = this.headerRepeatable.height;
			writer.commitUnbreakableBlock();
			writer.pushToRepeatables(this.headerRepeatable);
			this.cleanUpRepeatables = true;
			this.headerRepeatable = null;
		}
	
		function getLineXs() {
			var result = [];
			var cols = 0;
	
			for (var i = 0, l = self.tableNode.table.body[rowIndex].length; i < l; i++) {
				if (!cols) {
					result.push({x: self.rowSpanData[i].left, index: i});
	
					var item = self.tableNode.table.body[rowIndex][i];
					cols = (item._colSpan || item.colSpan || 0);
				}
				if (cols > 0) {
					cols--;
				}
			}
	
			result.push({x: self.rowSpanData[self.rowSpanData.length - 1].left, index: self.rowSpanData.length - 1});
	
			return result;
		}
	};
	
	module.exports = TableProcessor;
	
	
	/***/ }),
	/* 138 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	
	/*
	PDFDocument - represents an entire PDF document
	By Devon Govett
	 */
	
	(function() {
	  var PDFDocument, PDFObject, PDFPage, PDFReference, fs, stream,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  stream = __webpack_require__(15);
	
	  fs = __webpack_require__(8);
	
	  PDFObject = __webpack_require__(26);
	
	  PDFReference = __webpack_require__(87);
	
	  PDFPage = __webpack_require__(161);
	
	  PDFDocument = (function(superClass) {
	    var mixin;
	
	    extend(PDFDocument, superClass);
	
	    function PDFDocument(options1) {
	      var key, ref1, ref2, val;
	      this.options = options1 != null ? options1 : {};
	      PDFDocument.__super__.constructor.apply(this, arguments);
	      this.version = 1.3;
	      this.compress = (ref1 = this.options.compress) != null ? ref1 : true;
	      this._pageBuffer = [];
	      this._pageBufferStart = 0;
	      this._offsets = [];
	      this._waiting = 0;
	      this._ended = false;
	      this._offset = 0;
	      this._root = this.ref({
	        Type: 'Catalog',
	        Pages: this.ref({
	          Type: 'Pages',
	          Count: 0,
	          Kids: []
	        })
	      });
	      this.page = null;
	      this.initColor();
	      this.initVector();
	      this.initFonts();
	      this.initText();
	      this.initImages();
	      this.info = {
	        Producer: 'PDFKit',
	        Creator: 'PDFKit',
	        CreationDate: new Date()
	      };
	      if (this.options.info) {
	        ref2 = this.options.info;
	        for (key in ref2) {
	          val = ref2[key];
	          this.info[key] = val;
	        }
	      }
	      this._write("%PDF-" + this.version);
	      this._write("%\xFF\xFF\xFF\xFF");
	      if (this.options.autoFirstPage !== false) {
	        this.addPage();
	      }
	    }
	
	    mixin = function(methods) {
	      var method, name, results;
	      results = [];
	      for (name in methods) {
	        method = methods[name];
	        results.push(PDFDocument.prototype[name] = method);
	      }
	      return results;
	    };
	
	    mixin(__webpack_require__(162));
	
	    mixin(__webpack_require__(164));
	
	    mixin(__webpack_require__(166));
	
	    mixin(__webpack_require__(295));
	
	    mixin(__webpack_require__(297));
	
	    mixin(__webpack_require__(302));
	
	    PDFDocument.prototype.addPage = function(options) {
	      var pages;
	      if (options == null) {
	        options = this.options;
	      }
	      if (!this.options.bufferPages) {
	        this.flushPages();
	      }
	      this.page = new PDFPage(this, options);
	      this._pageBuffer.push(this.page);
	      pages = this._root.data.Pages.data;
	      pages.Kids.push(this.page.dictionary);
	      pages.Count++;
	      this.x = this.page.margins.left;
	      this.y = this.page.margins.top;
	      this._ctm = [1, 0, 0, 1, 0, 0];
	      this.transform(1, 0, 0, -1, 0, this.page.height);
	      this.emit('pageAdded');
	      return this;
	    };
	
	    PDFDocument.prototype.bufferedPageRange = function() {
	      return {
	        start: this._pageBufferStart,
	        count: this._pageBuffer.length
	      };
	    };
	
	    PDFDocument.prototype.switchToPage = function(n) {
	      var page;
	      if (!(page = this._pageBuffer[n - this._pageBufferStart])) {
	        throw new Error("switchToPage(" + n + ") out of bounds, current buffer covers pages " + this._pageBufferStart + " to " + (this._pageBufferStart + this._pageBuffer.length - 1));
	      }
	      return this.page = page;
	    };
	
	    PDFDocument.prototype.flushPages = function() {
	      var i, len, page, pages;
	      pages = this._pageBuffer;
	      this._pageBuffer = [];
	      this._pageBufferStart += pages.length;
	      for (i = 0, len = pages.length; i < len; i++) {
	        page = pages[i];
	        page.end();
	      }
	    };
	
	    PDFDocument.prototype.ref = function(data) {
	      var ref;
	      ref = new PDFReference(this, this._offsets.length + 1, data);
	      this._offsets.push(null);
	      this._waiting++;
	      return ref;
	    };
	
	    PDFDocument.prototype._read = function() {};
	
	    PDFDocument.prototype._write = function(data) {
	      if (!Buffer.isBuffer(data)) {
	        data = new Buffer(data + '\n', 'binary');
	      }
	      this.push(data);
	      return this._offset += data.length;
	    };
	
	    PDFDocument.prototype.addContent = function(data) {
	      this.page.write(data);
	      return this;
	    };
	
	    PDFDocument.prototype._refEnd = function(ref) {
	      this._offsets[ref.id - 1] = ref.offset;
	      if (--this._waiting === 0 && this._ended) {
	        this._finalize();
	        return this._ended = false;
	      }
	    };
	
	    PDFDocument.prototype.write = function(filename, fn) {
	      var err;
	      err = new Error('PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. Please pipe the document into a Node stream.');
	      console.warn(err.stack);
	      this.pipe(fs.createWriteStream(filename));
	      this.end();
	      return this.once('end', fn);
	    };
	
	    PDFDocument.prototype.output = function(fn) {
	      throw new Error('PDFDocument#output is deprecated, and has been removed from PDFKit. Please pipe the document into a Node stream.');
	    };
	
	    PDFDocument.prototype.end = function() {
	      var font, key, name, ref1, ref2, val;
	      this.flushPages();
	      this._info = this.ref();
	      ref1 = this.info;
	      for (key in ref1) {
	        val = ref1[key];
	        if (typeof val === 'string') {
	          val = new String(val);
	        }
	        this._info.data[key] = val;
	      }
	      this._info.end();
	      ref2 = this._fontFamilies;
	      for (name in ref2) {
	        font = ref2[name];
	        font.finalize();
	      }
	      this._root.end();
	      this._root.data.Pages.end();
	      if (this._waiting === 0) {
	        return this._finalize();
	      } else {
	        return this._ended = true;
	      }
	    };
	
	    PDFDocument.prototype._finalize = function(fn) {
	      var i, len, offset, ref1, xRefOffset;
	      xRefOffset = this._offset;
	      this._write("xref");
	      this._write("0 " + (this._offsets.length + 1));
	      this._write("0000000000 65535 f ");
	      ref1 = this._offsets;
	      for (i = 0, len = ref1.length; i < len; i++) {
	        offset = ref1[i];
	        offset = ('0000000000' + offset).slice(-10);
	        this._write(offset + ' 00000 n ');
	      }
	      this._write('trailer');
	      this._write(PDFObject.convert({
	        Size: this._offsets.length + 1,
	        Root: this._root,
	        Info: this._info
	      }));
	      this._write('startxref');
	      this._write("" + xRefOffset);
	      this._write('%%EOF');
	      return this.push(null);
	    };
	
	    PDFDocument.prototype.toString = function() {
	      return "[object PDFDocument]";
	    };
	
	    return PDFDocument;
	
	  })(stream.Readable);
	
	  module.exports = PDFDocument;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 139 */
	/***/ (function(module, exports) {
	
	/* (ignored) */
	
	/***/ }),
	/* 140 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(33).Buffer;
	var util = __webpack_require__(141);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}
	
	/***/ }),
	/* 141 */
	/***/ (function(module, exports) {
	
	/* (ignored) */
	
	/***/ }),
	/* 142 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(143);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))
	
	/***/ }),
	/* 143 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(11)))
	
	/***/ }),
	/* 144 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))
	
	/***/ }),
	/* 145 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(86);
	
	/*<replacement>*/
	var util = __webpack_require__(25);
	util.inherits = __webpack_require__(21);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};
	
	/***/ }),
	/* 146 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(46);
	
	
	/***/ }),
	/* 147 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(16);
	
	
	/***/ }),
	/* 148 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(45).Transform
	
	
	/***/ }),
	/* 149 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(45).PassThrough
	
	
	/***/ }),
	/* 150 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(Buffer, process) {
	/* eslint camelcase: "off" */
	
	var assert = __webpack_require__(88);
	
	var Zstream = __webpack_require__(153);
	var zlib_deflate = __webpack_require__(154);
	var zlib_inflate = __webpack_require__(157);
	var constants = __webpack_require__(160);
	
	for (var key in constants) {
	  exports[key] = constants[key];
	}
	
	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;
	
	var GZIP_HEADER_ID1 = 0x1f;
	var GZIP_HEADER_ID2 = 0x8b;
	
	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
	    throw new TypeError('Bad argument');
	  }
	
	  this.dictionary = null;
	  this.err = 0;
	  this.flush = 0;
	  this.init_done = false;
	  this.level = 0;
	  this.memLevel = 0;
	  this.mode = mode;
	  this.strategy = 0;
	  this.windowBits = 0;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.gzip_id_bytes_read = 0;
	}
	
	Zlib.prototype.close = function () {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	
	  this.pending_close = false;
	
	  assert(this.init_done, 'close before init');
	  assert(this.mode <= exports.UNZIP);
	
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	
	  this.mode = exports.NONE;
	
	  this.dictionary = null;
	};
	
	Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
	  return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
	  return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
	  assert.equal(arguments.length, 8);
	
	  assert(this.init_done, 'write before init');
	  assert(this.mode !== exports.NONE, 'already finalized');
	  assert.equal(false, this.write_in_progress, 'write already in progress');
	  assert.equal(false, this.pending_close, 'close is pending');
	
	  this.write_in_progress = true;
	
	  assert.equal(false, flush === undefined, 'must provide flush value');
	
	  this.write_in_progress = true;
	
	  if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
	    throw new Error('Invalid flush value');
	  }
	
	  if (input == null) {
	    input = Buffer.alloc(0);
	    in_len = 0;
	    in_off = 0;
	  }
	
	  this.strm.avail_in = in_len;
	  this.strm.input = input;
	  this.strm.next_in = in_off;
	  this.strm.avail_out = out_len;
	  this.strm.output = out;
	  this.strm.next_out = out_off;
	  this.flush = flush;
	
	  if (!async) {
	    // sync version
	    this._process();
	
	    if (this._checkError()) {
	      return this._afterSync();
	    }
	    return;
	  }
	
	  // async version
	  var self = this;
	  process.nextTick(function () {
	    self._process();
	    self._after();
	  });
	
	  return this;
	};
	
	Zlib.prototype._afterSync = function () {
	  var avail_out = this.strm.avail_out;
	  var avail_in = this.strm.avail_in;
	
	  this.write_in_progress = false;
	
	  return [avail_in, avail_out];
	};
	
	Zlib.prototype._process = function () {
	  var next_expected_header_byte = null;
	
	  // If the avail_out is left at 0, then it means that it ran out
	  // of room.  If there was avail_out left over, then it means
	  // that all of the input was consumed.
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      this.err = zlib_deflate.deflate(this.strm, this.flush);
	      break;
	    case exports.UNZIP:
	      if (this.strm.avail_in > 0) {
	        next_expected_header_byte = this.strm.next_in;
	      }
	
	      switch (this.gzip_id_bytes_read) {
	        case 0:
	          if (next_expected_header_byte === null) {
	            break;
	          }
	
	          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
	            this.gzip_id_bytes_read = 1;
	            next_expected_header_byte++;
	
	            if (this.strm.avail_in === 1) {
	              // The only available byte was already read.
	              break;
	            }
	          } else {
	            this.mode = exports.INFLATE;
	            break;
	          }
	
	        // fallthrough
	        case 1:
	          if (next_expected_header_byte === null) {
	            break;
	          }
	
	          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
	            this.gzip_id_bytes_read = 2;
	            this.mode = exports.GUNZIP;
	          } else {
	            // There is no actual difference between INFLATE and INFLATERAW
	            // (after initialization).
	            this.mode = exports.INFLATE;
	          }
	
	          break;
	        default:
	          throw new Error('invalid number of gzip magic number bytes read');
	      }
	
	    // fallthrough
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      this.err = zlib_inflate.inflate(this.strm, this.flush
	
	      // If data was encoded with dictionary
	      );if (this.err === exports.Z_NEED_DICT && this.dictionary) {
	        // Load it
	        this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
	        if (this.err === exports.Z_OK) {
	          // And try to decode again
	          this.err = zlib_inflate.inflate(this.strm, this.flush);
	        } else if (this.err === exports.Z_DATA_ERROR) {
	          // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
	          // Make it possible for After() to tell a bad dictionary from bad
	          // input.
	          this.err = exports.Z_NEED_DICT;
	        }
	      }
	      while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
	        // Bytes remain in input buffer. Perhaps this is another compressed
	        // member in the same archive, or just trailing garbage.
	        // Trailing zero bytes are okay, though, since they are frequently
	        // used for padding.
	
	        this.reset();
	        this.err = zlib_inflate.inflate(this.strm, this.flush);
	      }
	      break;
	    default:
	      throw new Error('Unknown mode ' + this.mode);
	  }
	};
	
	Zlib.prototype._checkError = function () {
	  // Acceptable error states depend on the type of zlib stream.
	  switch (this.err) {
	    case exports.Z_OK:
	    case exports.Z_BUF_ERROR:
	      if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
	        this._error('unexpected end of file');
	        return false;
	      }
	      break;
	    case exports.Z_STREAM_END:
	      // normal statuses, not fatal
	      break;
	    case exports.Z_NEED_DICT:
	      if (this.dictionary == null) {
	        this._error('Missing dictionary');
	      } else {
	        this._error('Bad dictionary');
	      }
	      return false;
	    default:
	      // something else.
	      this._error('Zlib error');
	      return false;
	  }
	
	  return true;
	};
	
	Zlib.prototype._after = function () {
	  if (!this._checkError()) {
	    return;
	  }
	
	  var avail_out = this.strm.avail_out;
	  var avail_in = this.strm.avail_in;
	
	  this.write_in_progress = false;
	
	  // call the write() cb
	  this.callback(avail_in, avail_out);
	
	  if (this.pending_close) {
	    this.close();
	  }
	};
	
	Zlib.prototype._error = function (message) {
	  if (this.strm.msg) {
	    message = this.strm.msg;
	  }
	  this.onerror(message, this.err
	
	  // no hope of rescue.
	  );this.write_in_progress = false;
	  if (this.pending_close) {
	    this.close();
	  }
	};
	
	Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
	  assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
	
	  assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
	  assert(level >= -1 && level <= 9, 'invalid compression level');
	
	  assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
	
	  assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');
	
	  this._init(level, windowBits, memLevel, strategy, dictionary);
	  this._setDictionary();
	};
	
	Zlib.prototype.params = function () {
	  throw new Error('deflateParams Not supported');
	};
	
	Zlib.prototype.reset = function () {
	  this._reset();
	  this._setDictionary();
	};
	
	Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
	  this.level = level;
	  this.windowBits = windowBits;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	
	  this.flush = exports.Z_NO_FLUSH;
	
	  this.err = exports.Z_OK;
	
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
	    this.windowBits += 16;
	  }
	
	  if (this.mode === exports.UNZIP) {
	    this.windowBits += 32;
	  }
	
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
	    this.windowBits = -1 * this.windowBits;
	  }
	
	  this.strm = new Zstream();
	
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
	      break;
	    default:
	      throw new Error('Unknown mode ' + this.mode);
	  }
	
	  if (this.err !== exports.Z_OK) {
	    this._error('Init error');
	  }
	
	  this.dictionary = dictionary;
	
	  this.write_in_progress = false;
	  this.init_done = true;
	};
	
	Zlib.prototype._setDictionary = function () {
	  if (this.dictionary == null) {
	    return;
	  }
	
	  this.err = exports.Z_OK;
	
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
	      break;
	    default:
	      break;
	  }
	
	  if (this.err !== exports.Z_OK) {
	    this._error('Failed to set dictionary');
	  }
	};
	
	Zlib.prototype._reset = function () {
	  this.err = exports.Z_OK;
	
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	    case exports.GZIP:
	      this.err = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	    case exports.GUNZIP:
	      this.err = zlib_inflate.inflateReset(this.strm);
	      break;
	    default:
	      break;
	  }
	
	  if (this.err !== exports.Z_OK) {
	    this._error('Failed to reset stream');
	  }
	};
	
	exports.Zlib = Zlib;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, __webpack_require__(11)))
	
	/***/ }),
	/* 151 */
	/***/ (function(module, exports) {
	
	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}
	
	/***/ }),
	/* 152 */
	/***/ (function(module, exports) {
	
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}
	
	
	/***/ }),
	/* 153 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;
	
	
	/***/ }),
	/* 154 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = __webpack_require__(34);
	var trees   = __webpack_require__(155);
	var adler32 = __webpack_require__(89);
	var crc32   = __webpack_require__(90);
	var msg     = __webpack_require__(156);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/
	
	
	/***/ }),
	/* 155 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(34);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;
	
	
	/***/ }),
	/* 156 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};
	
	
	/***/ }),
	/* 157 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = __webpack_require__(34);
	var adler32       = __webpack_require__(89);
	var crc32         = __webpack_require__(90);
	var inflate_fast  = __webpack_require__(158);
	var inflate_table = __webpack_require__(159);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/
	
	
	/***/ }),
	/* 158 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};
	
	
	/***/ }),
	/* 159 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(34);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};
	
	
	/***/ }),
	/* 160 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};
	
	
	/***/ }),
	/* 161 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.12.6
	
	/*
	PDFPage - represents a single page in the PDF document
	By Devon Govett
	 */
	
	(function() {
	  var PDFPage;
	
	  PDFPage = (function() {
	    var DEFAULT_MARGINS, SIZES;
	
	    function PDFPage(document, options) {
	      var dimensions;
	      this.document = document;
	      if (options == null) {
	        options = {};
	      }
	      this.size = options.size || 'letter';
	      this.layout = options.layout || 'portrait';
	      if (typeof options.margin === 'number') {
	        this.margins = {
	          top: options.margin,
	          left: options.margin,
	          bottom: options.margin,
	          right: options.margin
	        };
	      } else {
	        this.margins = options.margins || DEFAULT_MARGINS;
	      }
	      dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
	      this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
	      this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
	      this.content = this.document.ref();
	      this.resources = this.document.ref({
	        ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI']
	      });
	      Object.defineProperties(this, {
	        fonts: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).Font != null ? base.Font : base.Font = {};
	            };
	          })(this)
	        },
	        xobjects: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).XObject != null ? base.XObject : base.XObject = {};
	            };
	          })(this)
	        },
	        ext_gstates: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).ExtGState != null ? base.ExtGState : base.ExtGState = {};
	            };
	          })(this)
	        },
	        patterns: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).Pattern != null ? base.Pattern : base.Pattern = {};
	            };
	          })(this)
	        },
	        annotations: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.dictionary.data).Annots != null ? base.Annots : base.Annots = [];
	            };
	          })(this)
	        }
	      });
	      this.dictionary = this.document.ref({
	        Type: 'Page',
	        Parent: this.document._root.data.Pages,
	        MediaBox: [0, 0, this.width, this.height],
	        Contents: this.content,
	        Resources: this.resources
	      });
	    }
	
	    PDFPage.prototype.maxY = function() {
	      return this.height - this.margins.bottom;
	    };
	
	    PDFPage.prototype.write = function(chunk) {
	      return this.content.write(chunk);
	    };
	
	    PDFPage.prototype.end = function() {
	      this.dictionary.end();
	      this.resources.end();
	      return this.content.end();
	    };
	
	    DEFAULT_MARGINS = {
	      top: 72,
	      left: 72,
	      bottom: 72,
	      right: 72
	    };
	
	    SIZES = {
	      '4A0': [4767.87, 6740.79],
	      '2A0': [3370.39, 4767.87],
	      A0: [2383.94, 3370.39],
	      A1: [1683.78, 2383.94],
	      A2: [1190.55, 1683.78],
	      A3: [841.89, 1190.55],
	      A4: [595.28, 841.89],
	      A5: [419.53, 595.28],
	      A6: [297.64, 419.53],
	      A7: [209.76, 297.64],
	      A8: [147.40, 209.76],
	      A9: [104.88, 147.40],
	      A10: [73.70, 104.88],
	      B0: [2834.65, 4008.19],
	      B1: [2004.09, 2834.65],
	      B2: [1417.32, 2004.09],
	      B3: [1000.63, 1417.32],
	      B4: [708.66, 1000.63],
	      B5: [498.90, 708.66],
	      B6: [354.33, 498.90],
	      B7: [249.45, 354.33],
	      B8: [175.75, 249.45],
	      B9: [124.72, 175.75],
	      B10: [87.87, 124.72],
	      C0: [2599.37, 3676.54],
	      C1: [1836.85, 2599.37],
	      C2: [1298.27, 1836.85],
	      C3: [918.43, 1298.27],
	      C4: [649.13, 918.43],
	      C5: [459.21, 649.13],
	      C6: [323.15, 459.21],
	      C7: [229.61, 323.15],
	      C8: [161.57, 229.61],
	      C9: [113.39, 161.57],
	      C10: [79.37, 113.39],
	      RA0: [2437.80, 3458.27],
	      RA1: [1729.13, 2437.80],
	      RA2: [1218.90, 1729.13],
	      RA3: [864.57, 1218.90],
	      RA4: [609.45, 864.57],
	      SRA0: [2551.18, 3628.35],
	      SRA1: [1814.17, 2551.18],
	      SRA2: [1275.59, 1814.17],
	      SRA3: [907.09, 1275.59],
	      SRA4: [637.80, 907.09],
	      EXECUTIVE: [521.86, 756.00],
	      FOLIO: [612.00, 936.00],
	      LEGAL: [612.00, 1008.00],
	      LETTER: [612.00, 792.00],
	      TABLOID: [792.00, 1224.00]
	    };
	
	    return PDFPage;
	
	  })();
	
	  module.exports = PDFPage;
	
	}).call(this);
	
	
	/***/ }),
	/* 162 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFGradient, PDFLinearGradient, PDFRadialGradient, namedColors, ref;
	
	  ref = __webpack_require__(163), PDFGradient = ref.PDFGradient, PDFLinearGradient = ref.PDFLinearGradient, PDFRadialGradient = ref.PDFRadialGradient;
	
	  module.exports = {
	    initColor: function() {
	      this._opacityRegistry = {};
	      this._opacityCount = 0;
	      return this._gradCount = 0;
	    },
	    _normalizeColor: function(color) {
	      var hex, part;
	      if (color instanceof PDFGradient) {
	        return color;
	      }
	      if (typeof color === 'string') {
	        if (color.charAt(0) === '#') {
	          if (color.length === 4) {
	            color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3");
	          }
	          hex = parseInt(color.slice(1), 16);
	          color = [hex >> 16, hex >> 8 & 0xff, hex & 0xff];
	        } else if (namedColors[color]) {
	          color = namedColors[color];
	        }
	      }
	      if (Array.isArray(color)) {
	        if (color.length === 3) {
	          color = (function() {
	            var i, len, results;
	            results = [];
	            for (i = 0, len = color.length; i < len; i++) {
	              part = color[i];
	              results.push(part / 255);
	            }
	            return results;
	          })();
	        } else if (color.length === 4) {
	          color = (function() {
	            var i, len, results;
	            results = [];
	            for (i = 0, len = color.length; i < len; i++) {
	              part = color[i];
	              results.push(part / 100);
	            }
	            return results;
	          })();
	        }
	        return color;
	      }
	      return null;
	    },
	    _setColor: function(color, stroke) {
	      var op, space;
	      color = this._normalizeColor(color);
	      if (!color) {
	        return false;
	      }
	      op = stroke ? 'SCN' : 'scn';
	      if (color instanceof PDFGradient) {
	        this._setColorSpace('Pattern', stroke);
	        color.apply(op);
	      } else {
	        space = color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
	        this._setColorSpace(space, stroke);
	        color = color.join(' ');
	        this.addContent(color + " " + op);
	      }
	      return true;
	    },
	    _setColorSpace: function(space, stroke) {
	      var op;
	      op = stroke ? 'CS' : 'cs';
	      return this.addContent("/" + space + " " + op);
	    },
	    fillColor: function(color, opacity) {
	      var set;
	      set = this._setColor(color, false);
	      if (set) {
	        this.fillOpacity(opacity);
	      }
	      this._fillColor = [color, opacity];
	      return this;
	    },
	    strokeColor: function(color, opacity) {
	      var set;
	      set = this._setColor(color, true);
	      if (set) {
	        this.strokeOpacity(opacity);
	      }
	      return this;
	    },
	    opacity: function(opacity) {
	      this._doOpacity(opacity, opacity);
	      return this;
	    },
	    fillOpacity: function(opacity) {
	      this._doOpacity(opacity, null);
	      return this;
	    },
	    strokeOpacity: function(opacity) {
	      this._doOpacity(null, opacity);
	      return this;
	    },
	    _doOpacity: function(fillOpacity, strokeOpacity) {
	      var dictionary, id, key, name, ref1;
	      if (!((fillOpacity != null) || (strokeOpacity != null))) {
	        return;
	      }
	      if (fillOpacity != null) {
	        fillOpacity = Math.max(0, Math.min(1, fillOpacity));
	      }
	      if (strokeOpacity != null) {
	        strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
	      }
	      key = fillOpacity + "_" + strokeOpacity;
	      if (this._opacityRegistry[key]) {
	        ref1 = this._opacityRegistry[key], dictionary = ref1[0], name = ref1[1];
	      } else {
	        dictionary = {
	          Type: 'ExtGState'
	        };
	        if (fillOpacity != null) {
	          dictionary.ca = fillOpacity;
	        }
	        if (strokeOpacity != null) {
	          dictionary.CA = strokeOpacity;
	        }
	        dictionary = this.ref(dictionary);
	        dictionary.end();
	        id = ++this._opacityCount;
	        name = "Gs" + id;
	        this._opacityRegistry[key] = [dictionary, name];
	      }
	      this.page.ext_gstates[name] = dictionary;
	      return this.addContent("/" + name + " gs");
	    },
	    linearGradient: function(x1, y1, x2, y2) {
	      return new PDFLinearGradient(this, x1, y1, x2, y2);
	    },
	    radialGradient: function(x1, y1, r1, x2, y2, r2) {
	      return new PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
	    }
	  };
	
	  namedColors = {
	    aliceblue: [240, 248, 255],
	    antiquewhite: [250, 235, 215],
	    aqua: [0, 255, 255],
	    aquamarine: [127, 255, 212],
	    azure: [240, 255, 255],
	    beige: [245, 245, 220],
	    bisque: [255, 228, 196],
	    black: [0, 0, 0],
	    blanchedalmond: [255, 235, 205],
	    blue: [0, 0, 255],
	    blueviolet: [138, 43, 226],
	    brown: [165, 42, 42],
	    burlywood: [222, 184, 135],
	    cadetblue: [95, 158, 160],
	    chartreuse: [127, 255, 0],
	    chocolate: [210, 105, 30],
	    coral: [255, 127, 80],
	    cornflowerblue: [100, 149, 237],
	    cornsilk: [255, 248, 220],
	    crimson: [220, 20, 60],
	    cyan: [0, 255, 255],
	    darkblue: [0, 0, 139],
	    darkcyan: [0, 139, 139],
	    darkgoldenrod: [184, 134, 11],
	    darkgray: [169, 169, 169],
	    darkgreen: [0, 100, 0],
	    darkgrey: [169, 169, 169],
	    darkkhaki: [189, 183, 107],
	    darkmagenta: [139, 0, 139],
	    darkolivegreen: [85, 107, 47],
	    darkorange: [255, 140, 0],
	    darkorchid: [153, 50, 204],
	    darkred: [139, 0, 0],
	    darksalmon: [233, 150, 122],
	    darkseagreen: [143, 188, 143],
	    darkslateblue: [72, 61, 139],
	    darkslategray: [47, 79, 79],
	    darkslategrey: [47, 79, 79],
	    darkturquoise: [0, 206, 209],
	    darkviolet: [148, 0, 211],
	    deeppink: [255, 20, 147],
	    deepskyblue: [0, 191, 255],
	    dimgray: [105, 105, 105],
	    dimgrey: [105, 105, 105],
	    dodgerblue: [30, 144, 255],
	    firebrick: [178, 34, 34],
	    floralwhite: [255, 250, 240],
	    forestgreen: [34, 139, 34],
	    fuchsia: [255, 0, 255],
	    gainsboro: [220, 220, 220],
	    ghostwhite: [248, 248, 255],
	    gold: [255, 215, 0],
	    goldenrod: [218, 165, 32],
	    gray: [128, 128, 128],
	    grey: [128, 128, 128],
	    green: [0, 128, 0],
	    greenyellow: [173, 255, 47],
	    honeydew: [240, 255, 240],
	    hotpink: [255, 105, 180],
	    indianred: [205, 92, 92],
	    indigo: [75, 0, 130],
	    ivory: [255, 255, 240],
	    khaki: [240, 230, 140],
	    lavender: [230, 230, 250],
	    lavenderblush: [255, 240, 245],
	    lawngreen: [124, 252, 0],
	    lemonchiffon: [255, 250, 205],
	    lightblue: [173, 216, 230],
	    lightcoral: [240, 128, 128],
	    lightcyan: [224, 255, 255],
	    lightgoldenrodyellow: [250, 250, 210],
	    lightgray: [211, 211, 211],
	    lightgreen: [144, 238, 144],
	    lightgrey: [211, 211, 211],
	    lightpink: [255, 182, 193],
	    lightsalmon: [255, 160, 122],
	    lightseagreen: [32, 178, 170],
	    lightskyblue: [135, 206, 250],
	    lightslategray: [119, 136, 153],
	    lightslategrey: [119, 136, 153],
	    lightsteelblue: [176, 196, 222],
	    lightyellow: [255, 255, 224],
	    lime: [0, 255, 0],
	    limegreen: [50, 205, 50],
	    linen: [250, 240, 230],
	    magenta: [255, 0, 255],
	    maroon: [128, 0, 0],
	    mediumaquamarine: [102, 205, 170],
	    mediumblue: [0, 0, 205],
	    mediumorchid: [186, 85, 211],
	    mediumpurple: [147, 112, 219],
	    mediumseagreen: [60, 179, 113],
	    mediumslateblue: [123, 104, 238],
	    mediumspringgreen: [0, 250, 154],
	    mediumturquoise: [72, 209, 204],
	    mediumvioletred: [199, 21, 133],
	    midnightblue: [25, 25, 112],
	    mintcream: [245, 255, 250],
	    mistyrose: [255, 228, 225],
	    moccasin: [255, 228, 181],
	    navajowhite: [255, 222, 173],
	    navy: [0, 0, 128],
	    oldlace: [253, 245, 230],
	    olive: [128, 128, 0],
	    olivedrab: [107, 142, 35],
	    orange: [255, 165, 0],
	    orangered: [255, 69, 0],
	    orchid: [218, 112, 214],
	    palegoldenrod: [238, 232, 170],
	    palegreen: [152, 251, 152],
	    paleturquoise: [175, 238, 238],
	    palevioletred: [219, 112, 147],
	    papayawhip: [255, 239, 213],
	    peachpuff: [255, 218, 185],
	    peru: [205, 133, 63],
	    pink: [255, 192, 203],
	    plum: [221, 160, 221],
	    powderblue: [176, 224, 230],
	    purple: [128, 0, 128],
	    red: [255, 0, 0],
	    rosybrown: [188, 143, 143],
	    royalblue: [65, 105, 225],
	    saddlebrown: [139, 69, 19],
	    salmon: [250, 128, 114],
	    sandybrown: [244, 164, 96],
	    seagreen: [46, 139, 87],
	    seashell: [255, 245, 238],
	    sienna: [160, 82, 45],
	    silver: [192, 192, 192],
	    skyblue: [135, 206, 235],
	    slateblue: [106, 90, 205],
	    slategray: [112, 128, 144],
	    slategrey: [112, 128, 144],
	    snow: [255, 250, 250],
	    springgreen: [0, 255, 127],
	    steelblue: [70, 130, 180],
	    tan: [210, 180, 140],
	    teal: [0, 128, 128],
	    thistle: [216, 191, 216],
	    tomato: [255, 99, 71],
	    turquoise: [64, 224, 208],
	    violet: [238, 130, 238],
	    wheat: [245, 222, 179],
	    white: [255, 255, 255],
	    whitesmoke: [245, 245, 245],
	    yellow: [255, 255, 0],
	    yellowgreen: [154, 205, 50]
	  };
	
	}).call(this);
	
	
	/***/ }),
	/* 163 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFGradient, PDFLinearGradient, PDFRadialGradient,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  PDFGradient = (function() {
	    function PDFGradient(doc) {
	      this.doc = doc;
	      this.stops = [];
	      this.embedded = false;
	      this.transform = [1, 0, 0, 1, 0, 0];
	      this._colorSpace = 'DeviceRGB';
	    }
	
	    PDFGradient.prototype.stop = function(pos, color, opacity) {
	      if (opacity == null) {
	        opacity = 1;
	      }
	      opacity = Math.max(0, Math.min(1, opacity));
	      this.stops.push([pos, this.doc._normalizeColor(color), opacity]);
	      return this;
	    };
	
	    PDFGradient.prototype.setTransform = function(m11, m12, m21, m22, dx, dy) {
	      this.transform = [m11, m12, m21, m22, dx, dy];
	      return this;
	    };
	
	    PDFGradient.prototype.embed = function(m) {
	      var bounds, encode, fn, form, grad, gstate, i, j, k, last, len, opacityPattern, pageBBox, pattern, ref, ref1, shader, stop, stops, v;
	      if (this.stops.length === 0) {
	        return;
	      }
	      this.embedded = true;
	      this.matrix = m;
	      last = this.stops[this.stops.length - 1];
	      if (last[0] < 1) {
	        this.stops.push([1, last[1], last[2]]);
	      }
	      bounds = [];
	      encode = [];
	      stops = [];
	      for (i = j = 0, ref = this.stops.length - 1; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        encode.push(0, 1);
	        if (i + 2 !== this.stops.length) {
	          bounds.push(this.stops[i + 1][0]);
	        }
	        fn = this.doc.ref({
	          FunctionType: 2,
	          Domain: [0, 1],
	          C0: this.stops[i + 0][1],
	          C1: this.stops[i + 1][1],
	          N: 1
	        });
	        stops.push(fn);
	        fn.end();
	      }
	      if (stops.length === 1) {
	        fn = stops[0];
	      } else {
	        fn = this.doc.ref({
	          FunctionType: 3,
	          Domain: [0, 1],
	          Functions: stops,
	          Bounds: bounds,
	          Encode: encode
	        });
	        fn.end();
	      }
	      this.id = 'Sh' + (++this.doc._gradCount);
	      shader = this.shader(fn);
	      shader.end();
	      pattern = this.doc.ref({
	        Type: 'Pattern',
	        PatternType: 2,
	        Shading: shader,
	        Matrix: (function() {
	          var k, len, ref1, results;
	          ref1 = this.matrix;
	          results = [];
	          for (k = 0, len = ref1.length; k < len; k++) {
	            v = ref1[k];
	            results.push(+v.toFixed(5));
	          }
	          return results;
	        }).call(this)
	      });
	      pattern.end();
	      if (this.stops.some(function(stop) {
	        return stop[2] < 1;
	      })) {
	        grad = this.opacityGradient();
	        grad._colorSpace = 'DeviceGray';
	        ref1 = this.stops;
	        for (k = 0, len = ref1.length; k < len; k++) {
	          stop = ref1[k];
	          grad.stop(stop[0], [stop[2]]);
	        }
	        grad = grad.embed(this.matrix);
	        pageBBox = [0, 0, this.doc.page.width, this.doc.page.height];
	        form = this.doc.ref({
	          Type: 'XObject',
	          Subtype: 'Form',
	          FormType: 1,
	          BBox: pageBBox,
	          Group: {
	            Type: 'Group',
	            S: 'Transparency',
	            CS: 'DeviceGray'
	          },
	          Resources: {
	            ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
	            Pattern: {
	              Sh1: grad
	            }
	          }
	        });
	        form.write("/Pattern cs /Sh1 scn");
	        form.end((pageBBox.join(" ")) + " re f");
	        gstate = this.doc.ref({
	          Type: 'ExtGState',
	          SMask: {
	            Type: 'Mask',
	            S: 'Luminosity',
	            G: form
	          }
	        });
	        gstate.end();
	        opacityPattern = this.doc.ref({
	          Type: 'Pattern',
	          PatternType: 1,
	          PaintType: 1,
	          TilingType: 2,
	          BBox: pageBBox,
	          XStep: pageBBox[2],
	          YStep: pageBBox[3],
	          Resources: {
	            ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
	            Pattern: {
	              Sh1: pattern
	            },
	            ExtGState: {
	              Gs1: gstate
	            }
	          }
	        });
	        opacityPattern.write("/Gs1 gs /Pattern cs /Sh1 scn");
	        opacityPattern.end((pageBBox.join(" ")) + " re f");
	        this.doc.page.patterns[this.id] = opacityPattern;
	      } else {
	        this.doc.page.patterns[this.id] = pattern;
	      }
	      return pattern;
	    };
	
	    PDFGradient.prototype.apply = function(op) {
	      var dx, dy, m, m0, m1, m11, m12, m2, m21, m22, m3, m4, m5, ref, ref1;
	      ref = this.doc._ctm.slice(), m0 = ref[0], m1 = ref[1], m2 = ref[2], m3 = ref[3], m4 = ref[4], m5 = ref[5];
	      ref1 = this.transform, m11 = ref1[0], m12 = ref1[1], m21 = ref1[2], m22 = ref1[3], dx = ref1[4], dy = ref1[5];
	      m = [m0 * m11 + m2 * m12, m1 * m11 + m3 * m12, m0 * m21 + m2 * m22, m1 * m21 + m3 * m22, m0 * dx + m2 * dy + m4, m1 * dx + m3 * dy + m5];
	      if (!(this.embedded && m.join(" ") === this.matrix.join(" "))) {
	        this.embed(m);
	      }
	      return this.doc.addContent("/" + this.id + " " + op);
	    };
	
	    return PDFGradient;
	
	  })();
	
	  PDFLinearGradient = (function(superClass) {
	    extend(PDFLinearGradient, superClass);
	
	    function PDFLinearGradient(doc, x1, y1, x2, y2) {
	      this.doc = doc;
	      this.x1 = x1;
	      this.y1 = y1;
	      this.x2 = x2;
	      this.y2 = y2;
	      PDFLinearGradient.__super__.constructor.apply(this, arguments);
	    }
	
	    PDFLinearGradient.prototype.shader = function(fn) {
	      return this.doc.ref({
	        ShadingType: 2,
	        ColorSpace: this._colorSpace,
	        Coords: [this.x1, this.y1, this.x2, this.y2],
	        Function: fn,
	        Extend: [true, true]
	      });
	    };
	
	    PDFLinearGradient.prototype.opacityGradient = function() {
	      return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
	    };
	
	    return PDFLinearGradient;
	
	  })(PDFGradient);
	
	  PDFRadialGradient = (function(superClass) {
	    extend(PDFRadialGradient, superClass);
	
	    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
	      this.doc = doc;
	      this.x1 = x1;
	      this.y1 = y1;
	      this.r1 = r1;
	      this.x2 = x2;
	      this.y2 = y2;
	      this.r2 = r2;
	      PDFRadialGradient.__super__.constructor.apply(this, arguments);
	    }
	
	    PDFRadialGradient.prototype.shader = function(fn) {
	      return this.doc.ref({
	        ShadingType: 3,
	        ColorSpace: this._colorSpace,
	        Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
	        Function: fn,
	        Extend: [true, true]
	      });
	    };
	
	    PDFRadialGradient.prototype.opacityGradient = function() {
	      return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
	    };
	
	    return PDFRadialGradient;
	
	  })(PDFGradient);
	
	  module.exports = {
	    PDFGradient: PDFGradient,
	    PDFLinearGradient: PDFLinearGradient,
	    PDFRadialGradient: PDFRadialGradient
	  };
	
	}).call(this);
	
	
	/***/ }),
	/* 164 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var KAPPA, SVGPath, number,
	    slice = [].slice;
	
	  SVGPath = __webpack_require__(165);
	
	  number = __webpack_require__(26).number;
	
	  KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
	
	  module.exports = {
	    initVector: function() {
	      this._ctm = [1, 0, 0, 1, 0, 0];
	      return this._ctmStack = [];
	    },
	    save: function() {
	      this._ctmStack.push(this._ctm.slice());
	      return this.addContent('q');
	    },
	    restore: function() {
	      this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0];
	      return this.addContent('Q');
	    },
	    closePath: function() {
	      return this.addContent('h');
	    },
	    lineWidth: function(w) {
	      return this.addContent((number(w)) + " w");
	    },
	    _CAP_STYLES: {
	      BUTT: 0,
	      ROUND: 1,
	      SQUARE: 2
	    },
	    lineCap: function(c) {
	      if (typeof c === 'string') {
	        c = this._CAP_STYLES[c.toUpperCase()];
	      }
	      return this.addContent(c + " J");
	    },
	    _JOIN_STYLES: {
	      MITER: 0,
	      ROUND: 1,
	      BEVEL: 2
	    },
	    lineJoin: function(j) {
	      if (typeof j === 'string') {
	        j = this._JOIN_STYLES[j.toUpperCase()];
	      }
	      return this.addContent(j + " j");
	    },
	    miterLimit: function(m) {
	      return this.addContent((number(m)) + " M");
	    },
	    dash: function(length, options) {
	      var phase, ref, space, v;
	      if (options == null) {
	        options = {};
	      }
	      if (length == null) {
	        return this;
	      }
	      if (Array.isArray(length)) {
	        length = ((function() {
	          var i, len, results;
	          results = [];
	          for (i = 0, len = length.length; i < len; i++) {
	            v = length[i];
	            results.push(number(v));
	          }
	          return results;
	        })()).join(' ');
	        phase = options.phase || 0;
	        return this.addContent("[" + length + "] " + (number(phase)) + " d");
	      } else {
	        space = (ref = options.space) != null ? ref : length;
	        phase = options.phase || 0;
	        return this.addContent("[" + (number(length)) + " " + (number(space)) + "] " + (number(phase)) + " d");
	      }
	    },
	    undash: function() {
	      return this.addContent("[] 0 d");
	    },
	    moveTo: function(x, y) {
	      return this.addContent((number(x)) + " " + (number(y)) + " m");
	    },
	    lineTo: function(x, y) {
	      return this.addContent((number(x)) + " " + (number(y)) + " l");
	    },
	    bezierCurveTo: function(cp1x, cp1y, cp2x, cp2y, x, y) {
	      return this.addContent((number(cp1x)) + " " + (number(cp1y)) + " " + (number(cp2x)) + " " + (number(cp2y)) + " " + (number(x)) + " " + (number(y)) + " c");
	    },
	    quadraticCurveTo: function(cpx, cpy, x, y) {
	      return this.addContent((number(cpx)) + " " + (number(cpy)) + " " + (number(x)) + " " + (number(y)) + " v");
	    },
	    rect: function(x, y, w, h) {
	      return this.addContent((number(x)) + " " + (number(y)) + " " + (number(w)) + " " + (number(h)) + " re");
	    },
	    roundedRect: function(x, y, w, h, r) {
	      var c;
	      if (r == null) {
	        r = 0;
	      }
	      r = Math.min(r, 0.5 * w, 0.5 * h);
	      c = r * (1.0 - KAPPA);
	      this.moveTo(x + r, y);
	      this.lineTo(x + w - r, y);
	      this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
	      this.lineTo(x + w, y + h - r);
	      this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
	      this.lineTo(x + r, y + h);
	      this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
	      this.lineTo(x, y + r);
	      this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
	      return this.closePath();
	    },
	    ellipse: function(x, y, r1, r2) {
	      var ox, oy, xe, xm, ye, ym;
	      if (r2 == null) {
	        r2 = r1;
	      }
	      x -= r1;
	      y -= r2;
	      ox = r1 * KAPPA;
	      oy = r2 * KAPPA;
	      xe = x + r1 * 2;
	      ye = y + r2 * 2;
	      xm = x + r1;
	      ym = y + r2;
	      this.moveTo(x, ym);
	      this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	      this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	      this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	      this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	      return this.closePath();
	    },
	    circle: function(x, y, radius) {
	      return this.ellipse(x, y, radius);
	    },
	    arc: function(x, y, radius, startAngle, endAngle, anticlockwise) {
	      var HALF_PI, TWO_PI, ax, ay, cp1x, cp1y, cp2x, cp2y, curAng, deltaAng, deltaCx, deltaCy, dir, handleLen, i, numSegs, ref, segAng, segIdx;
	      if (anticlockwise == null) {
	        anticlockwise = false;
	      }
	      TWO_PI = 2.0 * Math.PI;
	      HALF_PI = 0.5 * Math.PI;
	      deltaAng = endAngle - startAngle;
	      if (Math.abs(deltaAng) > TWO_PI) {
	        deltaAng = TWO_PI;
	      } else if (deltaAng !== 0 && anticlockwise !== (deltaAng < 0)) {
	        dir = anticlockwise ? -1 : 1;
	        deltaAng = dir * TWO_PI + deltaAng;
	      }
	      numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
	      segAng = deltaAng / numSegs;
	      handleLen = (segAng / HALF_PI) * KAPPA * radius;
	      curAng = startAngle;
	      deltaCx = -Math.sin(curAng) * handleLen;
	      deltaCy = Math.cos(curAng) * handleLen;
	      ax = x + Math.cos(curAng) * radius;
	      ay = y + Math.sin(curAng) * radius;
	      this.moveTo(ax, ay);
	      for (segIdx = i = 0, ref = numSegs; 0 <= ref ? i < ref : i > ref; segIdx = 0 <= ref ? ++i : --i) {
	        cp1x = ax + deltaCx;
	        cp1y = ay + deltaCy;
	        curAng += segAng;
	        ax = x + Math.cos(curAng) * radius;
	        ay = y + Math.sin(curAng) * radius;
	        deltaCx = -Math.sin(curAng) * handleLen;
	        deltaCy = Math.cos(curAng) * handleLen;
	        cp2x = ax - deltaCx;
	        cp2y = ay - deltaCy;
	        this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
	      }
	      return this;
	    },
	    polygon: function() {
	      var i, len, point, points;
	      points = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	      this.moveTo.apply(this, points.shift());
	      for (i = 0, len = points.length; i < len; i++) {
	        point = points[i];
	        this.lineTo.apply(this, point);
	      }
	      return this.closePath();
	    },
	    path: function(path) {
	      SVGPath.apply(this, path);
	      return this;
	    },
	    _windingRule: function(rule) {
	      if (/even-?odd/.test(rule)) {
	        return '*';
	      }
	      return '';
	    },
	    fill: function(color, rule) {
	      if (/(even-?odd)|(non-?zero)/.test(color)) {
	        rule = color;
	        color = null;
	      }
	      if (color) {
	        this.fillColor(color);
	      }
	      return this.addContent('f' + this._windingRule(rule));
	    },
	    stroke: function(color) {
	      if (color) {
	        this.strokeColor(color);
	      }
	      return this.addContent('S');
	    },
	    fillAndStroke: function(fillColor, strokeColor, rule) {
	      var isFillRule;
	      if (strokeColor == null) {
	        strokeColor = fillColor;
	      }
	      isFillRule = /(even-?odd)|(non-?zero)/;
	      if (isFillRule.test(fillColor)) {
	        rule = fillColor;
	        fillColor = null;
	      }
	      if (isFillRule.test(strokeColor)) {
	        rule = strokeColor;
	        strokeColor = fillColor;
	      }
	      if (fillColor) {
	        this.fillColor(fillColor);
	        this.strokeColor(strokeColor);
	      }
	      return this.addContent('B' + this._windingRule(rule));
	    },
	    clip: function(rule) {
	      return this.addContent('W' + this._windingRule(rule) + ' n');
	    },
	    transform: function(m11, m12, m21, m22, dx, dy) {
	      var m, m0, m1, m2, m3, m4, m5, v, values;
	      m = this._ctm;
	      m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5];
	      m[0] = m0 * m11 + m2 * m12;
	      m[1] = m1 * m11 + m3 * m12;
	      m[2] = m0 * m21 + m2 * m22;
	      m[3] = m1 * m21 + m3 * m22;
	      m[4] = m0 * dx + m2 * dy + m4;
	      m[5] = m1 * dx + m3 * dy + m5;
	      values = ((function() {
	        var i, len, ref, results;
	        ref = [m11, m12, m21, m22, dx, dy];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          v = ref[i];
	          results.push(number(v));
	        }
	        return results;
	      })()).join(' ');
	      return this.addContent(values + " cm");
	    },
	    translate: function(x, y) {
	      return this.transform(1, 0, 0, 1, x, y);
	    },
	    rotate: function(angle, options) {
	      var cos, rad, ref, sin, x, x1, y, y1;
	      if (options == null) {
	        options = {};
	      }
	      rad = angle * Math.PI / 180;
	      cos = Math.cos(rad);
	      sin = Math.sin(rad);
	      x = y = 0;
	      if (options.origin != null) {
	        ref = options.origin, x = ref[0], y = ref[1];
	        x1 = x * cos - y * sin;
	        y1 = x * sin + y * cos;
	        x -= x1;
	        y -= y1;
	      }
	      return this.transform(cos, sin, -sin, cos, x, y);
	    },
	    scale: function(xFactor, yFactor, options) {
	      var ref, x, y;
	      if (yFactor == null) {
	        yFactor = xFactor;
	      }
	      if (options == null) {
	        options = {};
	      }
	      if (typeof yFactor === "object") {
	        options = yFactor;
	        yFactor = xFactor;
	      }
	      x = y = 0;
	      if (options.origin != null) {
	        ref = options.origin, x = ref[0], y = ref[1];
	        x -= xFactor * x;
	        y -= yFactor * y;
	      }
	      return this.transform(xFactor, 0, 0, yFactor, x, y);
	    }
	  };
	
	}).call(this);
	
	
	/***/ }),
	/* 165 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var SVGPath;
	
	  SVGPath = (function() {
	    var apply, arcToSegments, cx, cy, parameters, parse, px, py, runners, segmentToBezier, solveArc, sx, sy;
	
	    function SVGPath() {}
	
	    SVGPath.apply = function(doc, path) {
	      var commands;
	      commands = parse(path);
	      return apply(commands, doc);
	    };
	
	    parameters = {
	      A: 7,
	      a: 7,
	      C: 6,
	      c: 6,
	      H: 1,
	      h: 1,
	      L: 2,
	      l: 2,
	      M: 2,
	      m: 2,
	      Q: 4,
	      q: 4,
	      S: 4,
	      s: 4,
	      T: 2,
	      t: 2,
	      V: 1,
	      v: 1,
	      Z: 0,
	      z: 0
	    };
	
	    parse = function(path) {
	      var args, c, cmd, curArg, foundDecimal, j, len, params, ret;
	      ret = [];
	      args = [];
	      curArg = "";
	      foundDecimal = false;
	      params = 0;
	      for (j = 0, len = path.length; j < len; j++) {
	        c = path[j];
	        if (parameters[c] != null) {
	          params = parameters[c];
	          if (cmd) {
	            if (curArg.length > 0) {
	              args[args.length] = +curArg;
	            }
	            ret[ret.length] = {
	              cmd: cmd,
	              args: args
	            };
	            args = [];
	            curArg = "";
	            foundDecimal = false;
	          }
	          cmd = c;
	        } else if ((c === " " || c === ",") || (c === "-" && curArg.length > 0 && curArg[curArg.length - 1] !== 'e') || (c === "." && foundDecimal)) {
	          if (curArg.length === 0) {
	            continue;
	          }
	          if (args.length === params) {
	            ret[ret.length] = {
	              cmd: cmd,
	              args: args
	            };
	            args = [+curArg];
	            if (cmd === "M") {
	              cmd = "L";
	            }
	            if (cmd === "m") {
	              cmd = "l";
	            }
	          } else {
	            args[args.length] = +curArg;
	          }
	          foundDecimal = c === ".";
	          curArg = c === '-' || c === '.' ? c : '';
	        } else {
	          curArg += c;
	          if (c === '.') {
	            foundDecimal = true;
	          }
	        }
	      }
	      if (curArg.length > 0) {
	        if (args.length === params) {
	          ret[ret.length] = {
	            cmd: cmd,
	            args: args
	          };
	          args = [+curArg];
	          if (cmd === "M") {
	            cmd = "L";
	          }
	          if (cmd === "m") {
	            cmd = "l";
	          }
	        } else {
	          args[args.length] = +curArg;
	        }
	      }
	      ret[ret.length] = {
	        cmd: cmd,
	        args: args
	      };
	      return ret;
	    };
	
	    cx = cy = px = py = sx = sy = 0;
	
	    apply = function(commands, doc) {
	      var c, i, j, len, name;
	      cx = cy = px = py = sx = sy = 0;
	      for (i = j = 0, len = commands.length; j < len; i = ++j) {
	        c = commands[i];
	        if (typeof runners[name = c.cmd] === "function") {
	          runners[name](doc, c.args);
	        }
	      }
	      return cx = cy = px = py = 0;
	    };
	
	    runners = {
	      M: function(doc, a) {
	        cx = a[0];
	        cy = a[1];
	        px = py = null;
	        sx = cx;
	        sy = cy;
	        return doc.moveTo(cx, cy);
	      },
	      m: function(doc, a) {
	        cx += a[0];
	        cy += a[1];
	        px = py = null;
	        sx = cx;
	        sy = cy;
	        return doc.moveTo(cx, cy);
	      },
	      C: function(doc, a) {
	        cx = a[4];
	        cy = a[5];
	        px = a[2];
	        py = a[3];
	        return doc.bezierCurveTo.apply(doc, a);
	      },
	      c: function(doc, a) {
	        doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
	        px = cx + a[2];
	        py = cy + a[3];
	        cx += a[4];
	        return cy += a[5];
	      },
	      S: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        }
	        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
	        px = a[0];
	        py = a[1];
	        cx = a[2];
	        return cy = a[3];
	      },
	      s: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        }
	        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
	        px = cx + a[0];
	        py = cy + a[1];
	        cx += a[2];
	        return cy += a[3];
	      },
	      Q: function(doc, a) {
	        px = a[0];
	        py = a[1];
	        cx = a[2];
	        cy = a[3];
	        return doc.quadraticCurveTo(a[0], a[1], cx, cy);
	      },
	      q: function(doc, a) {
	        doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
	        px = cx + a[0];
	        py = cy + a[1];
	        cx += a[2];
	        return cy += a[3];
	      },
	      T: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        } else {
	          px = cx - (px - cx);
	          py = cy - (py - cy);
	        }
	        doc.quadraticCurveTo(px, py, a[0], a[1]);
	        px = cx - (px - cx);
	        py = cy - (py - cy);
	        cx = a[0];
	        return cy = a[1];
	      },
	      t: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        } else {
	          px = cx - (px - cx);
	          py = cy - (py - cy);
	        }
	        doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
	        cx += a[0];
	        return cy += a[1];
	      },
	      A: function(doc, a) {
	        solveArc(doc, cx, cy, a);
	        cx = a[5];
	        return cy = a[6];
	      },
	      a: function(doc, a) {
	        a[5] += cx;
	        a[6] += cy;
	        solveArc(doc, cx, cy, a);
	        cx = a[5];
	        return cy = a[6];
	      },
	      L: function(doc, a) {
	        cx = a[0];
	        cy = a[1];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      l: function(doc, a) {
	        cx += a[0];
	        cy += a[1];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      H: function(doc, a) {
	        cx = a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      h: function(doc, a) {
	        cx += a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      V: function(doc, a) {
	        cy = a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      v: function(doc, a) {
	        cy += a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      Z: function(doc) {
	        doc.closePath();
	        cx = sx;
	        return cy = sy;
	      },
	      z: function(doc) {
	        doc.closePath();
	        cx = sx;
	        return cy = sy;
	      }
	    };
	
	    solveArc = function(doc, x, y, coords) {
	      var bez, ex, ey, j, large, len, results, rot, rx, ry, seg, segs, sweep;
	      rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
	      segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
	      results = [];
	      for (j = 0, len = segs.length; j < len; j++) {
	        seg = segs[j];
	        bez = segmentToBezier.apply(null, seg);
	        results.push(doc.bezierCurveTo.apply(doc, bez));
	      }
	      return results;
	    };
	
	    arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
	      var a00, a01, a10, a11, cos_th, d, i, j, pl, ref, result, segments, sfactor, sfactor_sq, sin_th, th, th0, th1, th2, th3, th_arc, x0, x1, xc, y0, y1, yc;
	      th = rotateX * (Math.PI / 180);
	      sin_th = Math.sin(th);
	      cos_th = Math.cos(th);
	      rx = Math.abs(rx);
	      ry = Math.abs(ry);
	      px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
	      py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
	      pl = (px * px) / (rx * rx) + (py * py) / (ry * ry);
	      if (pl > 1) {
	        pl = Math.sqrt(pl);
	        rx *= pl;
	        ry *= pl;
	      }
	      a00 = cos_th / rx;
	      a01 = sin_th / rx;
	      a10 = (-sin_th) / ry;
	      a11 = cos_th / ry;
	      x0 = a00 * ox + a01 * oy;
	      y0 = a10 * ox + a11 * oy;
	      x1 = a00 * x + a01 * y;
	      y1 = a10 * x + a11 * y;
	      d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
	      sfactor_sq = 1 / d - 0.25;
	      if (sfactor_sq < 0) {
	        sfactor_sq = 0;
	      }
	      sfactor = Math.sqrt(sfactor_sq);
	      if (sweep === large) {
	        sfactor = -sfactor;
	      }
	      xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
	      yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
	      th0 = Math.atan2(y0 - yc, x0 - xc);
	      th1 = Math.atan2(y1 - yc, x1 - xc);
	      th_arc = th1 - th0;
	      if (th_arc < 0 && sweep === 1) {
	        th_arc += 2 * Math.PI;
	      } else if (th_arc > 0 && sweep === 0) {
	        th_arc -= 2 * Math.PI;
	      }
	      segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
	      result = [];
	      for (i = j = 0, ref = segments; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        th2 = th0 + i * th_arc / segments;
	        th3 = th0 + (i + 1) * th_arc / segments;
	        result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
	      }
	      return result;
	    };
	
	    segmentToBezier = function(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
	      var a00, a01, a10, a11, t, th_half, x1, x2, x3, y1, y2, y3;
	      a00 = cos_th * rx;
	      a01 = -sin_th * ry;
	      a10 = sin_th * rx;
	      a11 = cos_th * ry;
	      th_half = 0.5 * (th1 - th0);
	      t = (8 / 3) * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
	      x1 = cx + Math.cos(th0) - t * Math.sin(th0);
	      y1 = cy + Math.sin(th0) + t * Math.cos(th0);
	      x3 = cx + Math.cos(th1);
	      y3 = cy + Math.sin(th1);
	      x2 = x3 + t * Math.sin(th1);
	      y2 = y3 - t * Math.cos(th1);
	      return [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
	    };
	
	    return SVGPath;
	
	  })();
	
	  module.exports = SVGPath;
	
	}).call(this);
	
	
	/***/ }),
	/* 166 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFFont;
	
	  PDFFont = __webpack_require__(50);
	
	  module.exports = {
	    initFonts: function() {
	      this._fontFamilies = {};
	      this._fontCount = 0;
	      this._fontSize = 12;
	      this._font = null;
	      this._registeredFonts = {};
	      
	    },
	    font: function(src, family, size) {
	      var cacheKey, font, id, ref;
	      if (typeof family === 'number') {
	        size = family;
	        family = null;
	      }
	      if (typeof src === 'string' && this._registeredFonts[src]) {
	        cacheKey = src;
	        ref = this._registeredFonts[src], src = ref.src, family = ref.family;
	      } else {
	        cacheKey = family || src;
	        if (typeof cacheKey !== 'string') {
	          cacheKey = null;
	        }
	      }
	      if (size != null) {
	        this.fontSize(size);
	      }
	      if (font = this._fontFamilies[cacheKey]) {
	        this._font = font;
	        return this;
	      }
	      id = 'F' + (++this._fontCount);
	      this._font = PDFFont.open(this, src, family, id);
	      if (font = this._fontFamilies[this._font.name]) {
	        this._font = font;
	        return this;
	      }
	      if (cacheKey) {
	        this._fontFamilies[cacheKey] = this._font;
	      }
	      if (this._font.name) {
	        this._fontFamilies[this._font.name] = this._font;
	      }
	      return this;
	    },
	    fontSize: function(_fontSize) {
	      this._fontSize = _fontSize;
	      return this;
	    },
	    currentLineHeight: function(includeGap) {
	      if (includeGap == null) {
	        includeGap = false;
	      }
	      return this._font.lineHeight(this._fontSize, includeGap);
	    },
	    registerFont: function(name, src, family) {
	      this._registeredFonts[name] = {
	        src: src,
	        family: family
	      };
	      return this;
	    }
	  };
	
	}).call(this);
	
	
	/***/ }),
	/* 167 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(Buffer, process) {
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var r = _interopDefault(__webpack_require__(168));
	var _Object$getOwnPropertyDescriptor = _interopDefault(__webpack_require__(197));
	var _getIterator = _interopDefault(__webpack_require__(60));
	var _Object$freeze = _interopDefault(__webpack_require__(209));
	var _Object$keys = _interopDefault(__webpack_require__(212));
	var _typeof = _interopDefault(__webpack_require__(69));
	var _Object$defineProperty = _interopDefault(__webpack_require__(74));
	var _classCallCheck = _interopDefault(__webpack_require__(106));
	var _createClass = _interopDefault(__webpack_require__(107));
	var _Map = _interopDefault(__webpack_require__(225));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(236));
	var _inherits = _interopDefault(__webpack_require__(237));
	var restructure_src_utils = __webpack_require__(12);
	var _Object$defineProperties = _interopDefault(__webpack_require__(245));
	var isEqual = _interopDefault(__webpack_require__(248));
	var _Object$assign = _interopDefault(__webpack_require__(251));
	var _String$fromCodePoint = _interopDefault(__webpack_require__(255));
	var _Array$from = _interopDefault(__webpack_require__(258));
	var _Set = _interopDefault(__webpack_require__(263));
	var unicode = _interopDefault(__webpack_require__(269));
	var UnicodeTrie = _interopDefault(__webpack_require__(43));
	var StateMachine = _interopDefault(__webpack_require__(271));
	var _Number$EPSILON = _interopDefault(__webpack_require__(280));
	var cloneDeep = _interopDefault(__webpack_require__(283));
	var inflate = _interopDefault(__webpack_require__(79));
	var brotli = _interopDefault(__webpack_require__(284));
	
	
	
	var fontkit = {};
	fontkit.logErrors = false;
	
	var formats = [];
	fontkit.registerFormat = function (format) {
	  formats.push(format);
	};
	
	fontkit.openSync = function (filename, postscriptName) {
	  var buffer = __webpack_require__(8).readFileSync(filename);
	  return fontkit.create(buffer, postscriptName);
	};
	
	fontkit.open = function (filename, postscriptName, callback) {
	  if (typeof postscriptName === 'function') {
	    callback = postscriptName;
	    postscriptName = null;
	  }
	
	  __webpack_require__(8).readFile(filename, function (err, buffer) {
	    if (err) {
	      return callback(err);
	    }
	
	    try {
	      var font = fontkit.create(buffer, postscriptName);
	    } catch (e) {
	      return callback(e);
	    }
	
	    return callback(null, font);
	  });
	
	  return;
	};
	
	fontkit.create = function (buffer, postscriptName) {
	  for (var i = 0; i < formats.length; i++) {
	    var format = formats[i];
	    if (format.probe(buffer)) {
	      var font = new format(new r.DecodeStream(buffer));
	      if (postscriptName) {
	        return font.getFont(postscriptName);
	      }
	
	      return font;
	    }
	  }
	
	  throw new Error('Unknown font format');
	};
	
	/**
	 * This decorator caches the results of a getter or method such that
	 * the results are lazily computed once, and then cached.
	 * @private
	 */
	function cache(target, key, descriptor) {
	  if (descriptor.get) {
	    var get = descriptor.get;
	    descriptor.get = function () {
	      var value = get.call(this);
	      _Object$defineProperty(this, key, { value: value });
	      return value;
	    };
	  } else if (typeof descriptor.value === 'function') {
	    var fn = descriptor.value;
	
	    return {
	      get: function get() {
	        var cache = new _Map();
	        function memoized() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var key = args.length > 0 ? args[0] : 'value';
	          if (cache.has(key)) {
	            return cache.get(key);
	          }
	
	          var result = fn.apply(this, args);
	          cache.set(key, result);
	          return result;
	        };
	
	        _Object$defineProperty(this, key, { value: memoized });
	        return memoized;
	      }
	    };
	  }
	}
	
	var SubHeader = new r.Struct({
	  firstCode: r.uint16,
	  entryCount: r.uint16,
	  idDelta: r.int16,
	  idRangeOffset: r.uint16
	});
	
	var CmapGroup = new r.Struct({
	  startCharCode: r.uint32,
	  endCharCode: r.uint32,
	  glyphID: r.uint32
	});
	
	var UnicodeValueRange = new r.Struct({
	  startUnicodeValue: r.uint24,
	  additionalCount: r.uint8
	});
	
	var UVSMapping = new r.Struct({
	  unicodeValue: r.uint24,
	  glyphID: r.uint16
	});
	
	var DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
	var NonDefaultUVS = new r.Array(UVSMapping, r.uint32);
	
	var VarSelectorRecord = new r.Struct({
	  varSelector: r.uint24,
	  defaultUVS: new r.Pointer(r.uint32, DefaultUVS, { type: 'parent' }),
	  nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, { type: 'parent' })
	});
	
	var CmapSubtable = new r.VersionedStruct(r.uint16, {
	  0: { // Byte encoding
	    length: r.uint16, // Total table length in bytes (set to 262 for format 0)
	    language: r.uint16, // Language code for this encoding subtable, or zero if language-independent
	    codeMap: new r.LazyArray(r.uint8, 256)
	  },
	
	  2: { // High-byte mapping (CJK)
	    length: r.uint16,
	    language: r.uint16,
	    subHeaderKeys: new r.Array(r.uint16, 256),
	    subHeaderCount: function subHeaderCount(t) {
	      return Math.max.apply(Math, t.subHeaderKeys);
	    },
	    subHeaders: new r.LazyArray(SubHeader, 'subHeaderCount'),
	    glyphIndexArray: new r.LazyArray(r.uint16, 'subHeaderCount')
	  },
	
	  4: { // Segment mapping to delta values
	    length: r.uint16, // Total table length in bytes
	    language: r.uint16, // Language code
	    segCountX2: r.uint16,
	    segCount: function segCount(t) {
	      return t.segCountX2 >> 1;
	    },
	    searchRange: r.uint16,
	    entrySelector: r.uint16,
	    rangeShift: r.uint16,
	    endCode: new r.LazyArray(r.uint16, 'segCount'),
	    reservedPad: new r.Reserved(r.uint16), // This value should be zero
	    startCode: new r.LazyArray(r.uint16, 'segCount'),
	    idDelta: new r.LazyArray(r.int16, 'segCount'),
	    idRangeOffset: new r.LazyArray(r.uint16, 'segCount'),
	    glyphIndexArray: new r.LazyArray(r.uint16, function (t) {
	      return (t.length - t._currentOffset) / 2;
	    })
	  },
	
	  6: { // Trimmed table
	    length: r.uint16,
	    language: r.uint16,
	    firstCode: r.uint16,
	    entryCount: r.uint16,
	    glyphIndices: new r.LazyArray(r.uint16, 'entryCount')
	  },
	
	  8: { // mixed 16-bit and 32-bit coverage
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint16,
	    is32: new r.LazyArray(r.uint8, 8192),
	    nGroups: r.uint32,
	    groups: new r.LazyArray(CmapGroup, 'nGroups')
	  },
	
	  10: { // Trimmed Array
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint32,
	    firstCode: r.uint32,
	    entryCount: r.uint32,
	    glyphIndices: new r.LazyArray(r.uint16, 'numChars')
	  },
	
	  12: { // Segmented coverage
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint32,
	    nGroups: r.uint32,
	    groups: new r.LazyArray(CmapGroup, 'nGroups')
	  },
	
	  13: { // Many-to-one range mappings (same as 12 except for group.startGlyphID)
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint32,
	    nGroups: r.uint32,
	    groups: new r.LazyArray(CmapGroup, 'nGroups')
	  },
	
	  14: { // Unicode Variation Sequences
	    length: r.uint32,
	    numRecords: r.uint32,
	    varSelectors: new r.LazyArray(VarSelectorRecord, 'numRecords')
	  }
	});
	
	var CmapEntry = new r.Struct({
	  platformID: r.uint16, // Platform identifier
	  encodingID: r.uint16, // Platform-specific encoding identifier
	  table: new r.Pointer(r.uint32, CmapSubtable, { type: 'parent', lazy: true })
	});
	
	// character to glyph mapping
	var cmap = new r.Struct({
	  version: r.uint16,
	  numSubtables: r.uint16,
	  tables: new r.Array(CmapEntry, 'numSubtables')
	});
	
	// font header
	var head = new r.Struct({
	  version: r.int32, // 0x00010000 (version 1.0)
	  revision: r.int32, // set by font manufacturer
	  checkSumAdjustment: r.uint32,
	  magicNumber: r.uint32, // set to 0x5F0F3CF5
	  flags: r.uint16,
	  unitsPerEm: r.uint16, // range from 64 to 16384
	  created: new r.Array(r.int32, 2),
	  modified: new r.Array(r.int32, 2),
	  xMin: r.int16, // for all glyph bounding boxes
	  yMin: r.int16, // for all glyph bounding boxes
	  xMax: r.int16, // for all glyph bounding boxes
	  yMax: r.int16, // for all glyph bounding boxes
	  macStyle: new r.Bitfield(r.uint16, ['bold', 'italic', 'underline', 'outline', 'shadow', 'condensed', 'extended']),
	  lowestRecPPEM: r.uint16, // smallest readable size in pixels
	  fontDirectionHint: r.int16,
	  indexToLocFormat: r.int16, // 0 for short offsets, 1 for long
	  glyphDataFormat: r.int16 // 0 for current format
	});
	
	// horizontal header
	var hhea = new r.Struct({
	  version: r.int32,
	  ascent: r.int16, // Distance from baseline of highest ascender
	  descent: r.int16, // Distance from baseline of lowest descender
	  lineGap: r.int16, // Typographic line gap
	  advanceWidthMax: r.uint16, // Maximum advance width value in 'hmtx' table
	  minLeftSideBearing: r.int16, // Maximum advance width value in 'hmtx' table
	  minRightSideBearing: r.int16, // Minimum right sidebearing value
	  xMaxExtent: r.int16,
	  caretSlopeRise: r.int16, // Used to calculate the slope of the cursor (rise/run); 1 for vertical
	  caretSlopeRun: r.int16, // 0 for vertical
	  caretOffset: r.int16, // Set to 0 for non-slanted fonts
	  reserved: new r.Reserved(r.int16, 4),
	  metricDataFormat: r.int16, // 0 for current format
	  numberOfMetrics: r.uint16 // Number of advance widths in 'hmtx' table
	});
	
	var HmtxEntry = new r.Struct({
	  advance: r.uint16,
	  bearing: r.int16
	});
	
	var hmtx = new r.Struct({
	  metrics: new r.LazyArray(HmtxEntry, function (t) {
	    return t.parent.hhea.numberOfMetrics;
	  }),
	  bearings: new r.LazyArray(r.int16, function (t) {
	    return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
	  })
	});
	
	// maxiumum profile
	var maxp = new r.Struct({
	  version: r.int32,
	  numGlyphs: r.uint16, // The number of glyphs in the font
	  maxPoints: r.uint16, // Maximum points in a non-composite glyph
	  maxContours: r.uint16, // Maximum contours in a non-composite glyph
	  maxComponentPoints: r.uint16, // Maximum points in a composite glyph
	  maxComponentContours: r.uint16, // Maximum contours in a composite glyph
	  maxZones: r.uint16, // 1 if instructions do not use the twilight zone, 2 otherwise
	  maxTwilightPoints: r.uint16, // Maximum points used in Z0
	  maxStorage: r.uint16, // Number of Storage Area locations
	  maxFunctionDefs: r.uint16, // Number of FDEFs
	  maxInstructionDefs: r.uint16, // Number of IDEFs
	  maxStackElements: r.uint16, // Maximum stack depth
	  maxSizeOfInstructions: r.uint16, // Maximum byte count for glyph instructions
	  maxComponentElements: r.uint16, // Maximum number of components referenced at “top level” for any composite glyph
	  maxComponentDepth: r.uint16 // Maximum levels of recursion; 1 for simple components
	});
	
	/**
	 * Gets an encoding name from platform, encoding, and language ids.
	 * Returned encoding names can be used in iconv-lite to decode text.
	 */
	function getEncoding(platformID, encodingID) {
	  var languageID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) {
	    return MAC_LANGUAGE_ENCODINGS[languageID];
	  }
	
	  return ENCODINGS[platformID][encodingID];
	}
	
	// Map of platform ids to encoding ids.
	var ENCODINGS = [
	// unicode
	['utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be'],
	
	// macintosh
	// Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
	// 0	Roman                 17	Malayalam
	// 1	Japanese	            18	Sinhalese
	// 2	Traditional Chinese	  19	Burmese
	// 3	Korean	              20	Khmer
	// 4	Arabic	              21	Thai
	// 5	Hebrew	              22	Laotian
	// 6	Greek	                23	Georgian
	// 7	Russian	              24	Armenian
	// 8	RSymbol	              25	Simplified Chinese
	// 9	Devanagari	          26	Tibetan
	// 10	Gurmukhi	            27	Mongolian
	// 11	Gujarati	            28	Geez
	// 12	Oriya	                29	Slavic
	// 13	Bengali	              30	Vietnamese
	// 14	Tamil	                31	Sindhi
	// 15	Telugu	              32	(Uninterpreted)
	// 16	Kannada
	['macroman', 'shift-jis', 'big5', 'euc-kr', 'iso-8859-6', 'iso-8859-8', 'macgreek', 'maccyrillic', 'symbol', 'Devanagari', 'Gurmukhi', 'Gujarati', 'Oriya', 'Bengali', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Sinhalese', 'Burmese', 'Khmer', 'macthai', 'Laotian', 'Georgian', 'Armenian', 'gb-2312-80', 'Tibetan', 'Mongolian', 'Geez', 'maccenteuro', 'Vietnamese', 'Sindhi'],
	
	// ISO (deprecated)
	['ascii'],
	
	// windows
	// Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
	['symbol', 'utf16be', 'shift-jis', 'gb18030', 'big5', 'wansung', 'johab', null, null, null, 'utf16be']];
	
	// Overrides for Mac scripts by language id.
	// See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
	var MAC_LANGUAGE_ENCODINGS = {
	  15: 'maciceland',
	  17: 'macturkish',
	  18: 'maccroatian',
	  24: 'maccenteuro',
	  25: 'maccenteuro',
	  26: 'maccenteuro',
	  27: 'maccenteuro',
	  28: 'maccenteuro',
	  30: 'maciceland',
	  37: 'macromania',
	  38: 'maccenteuro',
	  39: 'maccenteuro',
	  40: 'maccenteuro',
	  143: 'macinuit', // Unsupported by iconv-lite
	  146: 'macgaelic' // Unsupported by iconv-lite
	};
	
	// Map of platform ids to BCP-47 language codes.
	var LANGUAGES = [
	// unicode
	[], { // macintosh
	  0: 'en', 30: 'fo', 60: 'ks', 90: 'rw',
	  1: 'fr', 31: 'fa', 61: 'ku', 91: 'rn',
	  2: 'de', 32: 'ru', 62: 'sd', 92: 'ny',
	  3: 'it', 33: 'zh', 63: 'bo', 93: 'mg',
	  4: 'nl', 34: 'nl-BE', 64: 'ne', 94: 'eo',
	  5: 'sv', 35: 'ga', 65: 'sa', 128: 'cy',
	  6: 'es', 36: 'sq', 66: 'mr', 129: 'eu',
	  7: 'da', 37: 'ro', 67: 'bn', 130: 'ca',
	  8: 'pt', 38: 'cz', 68: 'as', 131: 'la',
	  9: 'no', 39: 'sk', 69: 'gu', 132: 'qu',
	  10: 'he', 40: 'si', 70: 'pa', 133: 'gn',
	  11: 'ja', 41: 'yi', 71: 'or', 134: 'ay',
	  12: 'ar', 42: 'sr', 72: 'ml', 135: 'tt',
	  13: 'fi', 43: 'mk', 73: 'kn', 136: 'ug',
	  14: 'el', 44: 'bg', 74: 'ta', 137: 'dz',
	  15: 'is', 45: 'uk', 75: 'te', 138: 'jv',
	  16: 'mt', 46: 'be', 76: 'si', 139: 'su',
	  17: 'tr', 47: 'uz', 77: 'my', 140: 'gl',
	  18: 'hr', 48: 'kk', 78: 'km', 141: 'af',
	  19: 'zh-Hant', 49: 'az-Cyrl', 79: 'lo', 142: 'br',
	  20: 'ur', 50: 'az-Arab', 80: 'vi', 143: 'iu',
	  21: 'hi', 51: 'hy', 81: 'id', 144: 'gd',
	  22: 'th', 52: 'ka', 82: 'tl', 145: 'gv',
	  23: 'ko', 53: 'mo', 83: 'ms', 146: 'ga',
	  24: 'lt', 54: 'ky', 84: 'ms-Arab', 147: 'to',
	  25: 'pl', 55: 'tg', 85: 'am', 148: 'el-polyton',
	  26: 'hu', 56: 'tk', 86: 'ti', 149: 'kl',
	  27: 'es', 57: 'mn-CN', 87: 'om', 150: 'az',
	  28: 'lv', 58: 'mn', 88: 'so', 151: 'nn',
	  29: 'se', 59: 'ps', 89: 'sw'
	},
	
	// ISO (deprecated)
	[], { // windows                                        
	  0x0436: 'af', 0x4009: 'en-IN', 0x0487: 'rw', 0x0432: 'tn',
	  0x041C: 'sq', 0x1809: 'en-IE', 0x0441: 'sw', 0x045B: 'si',
	  0x0484: 'gsw', 0x2009: 'en-JM', 0x0457: 'kok', 0x041B: 'sk',
	  0x045E: 'am', 0x4409: 'en-MY', 0x0412: 'ko', 0x0424: 'sl',
	  0x1401: 'ar-DZ', 0x1409: 'en-NZ', 0x0440: 'ky', 0x2C0A: 'es-AR',
	  0x3C01: 'ar-BH', 0x3409: 'en-PH', 0x0454: 'lo', 0x400A: 'es-BO',
	  0x0C01: 'ar', 0x4809: 'en-SG', 0x0426: 'lv', 0x340A: 'es-CL',
	  0x0801: 'ar-IQ', 0x1C09: 'en-ZA', 0x0427: 'lt', 0x240A: 'es-CO',
	  0x2C01: 'ar-JO', 0x2C09: 'en-TT', 0x082E: 'dsb', 0x140A: 'es-CR',
	  0x3401: 'ar-KW', 0x0809: 'en-GB', 0x046E: 'lb', 0x1C0A: 'es-DO',
	  0x3001: 'ar-LB', 0x0409: 'en', 0x042F: 'mk', 0x300A: 'es-EC',
	  0x1001: 'ar-LY', 0x3009: 'en-ZW', 0x083E: 'ms-BN', 0x440A: 'es-SV',
	  0x1801: 'ary', 0x0425: 'et', 0x043E: 'ms', 0x100A: 'es-GT',
	  0x2001: 'ar-OM', 0x0438: 'fo', 0x044C: 'ml', 0x480A: 'es-HN',
	  0x4001: 'ar-QA', 0x0464: 'fil', 0x043A: 'mt', 0x080A: 'es-MX',
	  0x0401: 'ar-SA', 0x040B: 'fi', 0x0481: 'mi', 0x4C0A: 'es-NI',
	  0x2801: 'ar-SY', 0x080C: 'fr-BE', 0x047A: 'arn', 0x180A: 'es-PA',
	  0x1C01: 'aeb', 0x0C0C: 'fr-CA', 0x044E: 'mr', 0x3C0A: 'es-PY',
	  0x3801: 'ar-AE', 0x040C: 'fr', 0x047C: 'moh', 0x280A: 'es-PE',
	  0x2401: 'ar-YE', 0x140C: 'fr-LU', 0x0450: 'mn', 0x500A: 'es-PR',
	  0x042B: 'hy', 0x180C: 'fr-MC', 0x0850: 'mn-CN', 0x0C0A: 'es',
	  0x044D: 'as', 0x100C: 'fr-CH', 0x0461: 'ne', 0x040A: 'es',
	  0x082C: 'az-Cyrl', 0x0462: 'fy', 0x0414: 'nb', 0x540A: 'es-US',
	  0x042C: 'az', 0x0456: 'gl', 0x0814: 'nn', 0x380A: 'es-UY',
	  0x046D: 'ba', 0x0437: 'ka', 0x0482: 'oc', 0x200A: 'es-VE',
	  0x042D: 'eu', 0x0C07: 'de-AT', 0x0448: 'or', 0x081D: 'sv-FI',
	  0x0423: 'be', 0x0407: 'de', 0x0463: 'ps', 0x041D: 'sv',
	  0x0845: 'bn', 0x1407: 'de-LI', 0x0415: 'pl', 0x045A: 'syr',
	  0x0445: 'bn-IN', 0x1007: 'de-LU', 0x0416: 'pt', 0x0428: 'tg',
	  0x201A: 'bs-Cyrl', 0x0807: 'de-CH', 0x0816: 'pt-PT', 0x085F: 'tzm',
	  0x141A: 'bs', 0x0408: 'el', 0x0446: 'pa', 0x0449: 'ta',
	  0x047E: 'br', 0x046F: 'kl', 0x046B: 'qu-BO', 0x0444: 'tt',
	  0x0402: 'bg', 0x0447: 'gu', 0x086B: 'qu-EC', 0x044A: 'te',
	  0x0403: 'ca', 0x0468: 'ha', 0x0C6B: 'qu', 0x041E: 'th',
	  0x0C04: 'zh-HK', 0x040D: 'he', 0x0418: 'ro', 0x0451: 'bo',
	  0x1404: 'zh-MO', 0x0439: 'hi', 0x0417: 'rm', 0x041F: 'tr',
	  0x0804: 'zh', 0x040E: 'hu', 0x0419: 'ru', 0x0442: 'tk',
	  0x1004: 'zh-SG', 0x040F: 'is', 0x243B: 'smn', 0x0480: 'ug',
	  0x0404: 'zh-TW', 0x0470: 'ig', 0x103B: 'smj-NO', 0x0422: 'uk',
	  0x0483: 'co', 0x0421: 'id', 0x143B: 'smj', 0x042E: 'hsb',
	  0x041A: 'hr', 0x045D: 'iu', 0x0C3B: 'se-FI', 0x0420: 'ur',
	  0x101A: 'hr-BA', 0x085D: 'iu-Latn', 0x043B: 'se', 0x0843: 'uz-Cyrl',
	  0x0405: 'cs', 0x083C: 'ga', 0x083B: 'se-SE', 0x0443: 'uz',
	  0x0406: 'da', 0x0434: 'xh', 0x203B: 'sms', 0x042A: 'vi',
	  0x048C: 'prs', 0x0435: 'zu', 0x183B: 'sma-NO', 0x0452: 'cy',
	  0x0465: 'dv', 0x0410: 'it', 0x1C3B: 'sms', 0x0488: 'wo',
	  0x0813: 'nl-BE', 0x0810: 'it-CH', 0x044F: 'sa', 0x0485: 'sah',
	  0x0413: 'nl', 0x0411: 'ja', 0x1C1A: 'sr-Cyrl-BA', 0x0478: 'ii',
	  0x0C09: 'en-AU', 0x044B: 'kn', 0x0C1A: 'sr', 0x046A: 'yo',
	  0x2809: 'en-BZ', 0x043F: 'kk', 0x181A: 'sr-Latn-BA',
	  0x1009: 'en-CA', 0x0453: 'km', 0x081A: 'sr-Latn',
	  0x2409: 'en-029', 0x0486: 'quc', 0x046C: 'nso'
	}];
	
	var NameRecord = new r.Struct({
	  platformID: r.uint16,
	  encodingID: r.uint16,
	  languageID: r.uint16,
	  nameID: r.uint16,
	  length: r.uint16,
	  string: new r.Pointer(r.uint16, new r.String('length', function (t) {
	    return getEncoding(t.platformID, t.encodingID, t.languageID);
	  }), { type: 'parent', relativeTo: 'parent.stringOffset', allowNull: false })
	});
	
	var LangTagRecord = new r.Struct({
	  length: r.uint16,
	  tag: new r.Pointer(r.uint16, new r.String('length', 'utf16be'), { type: 'parent', relativeTo: 'stringOffset' })
	});
	
	var NameTable = new r.VersionedStruct(r.uint16, {
	  0: {
	    count: r.uint16,
	    stringOffset: r.uint16,
	    records: new r.Array(NameRecord, 'count')
	  },
	  1: {
	    count: r.uint16,
	    stringOffset: r.uint16,
	    records: new r.Array(NameRecord, 'count'),
	    langTagCount: r.uint16,
	    langTags: new r.Array(LangTagRecord, 'langTagCount')
	  }
	});
	
	var NAMES = ['copyright', 'fontFamily', 'fontSubfamily', 'uniqueSubfamily', 'fullName', 'version', 'postscriptName', // Note: A font may have only one PostScript name and that name must be ASCII.
	'trademark', 'manufacturer', 'designer', 'description', 'vendorURL', 'designerURL', 'license', 'licenseURL', null, // reserved
	'preferredFamily', 'preferredSubfamily', 'compatibleFull', 'sampleText', 'postscriptCIDFontName', 'wwsFamilyName', 'wwsSubfamilyName'];
	
	NameTable.process = function (stream) {
	  var records = {};
	  for (var _iterator = this.records, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var record = _ref;
	
	    // find out what language this is for
	    var language = LANGUAGES[record.platformID][record.languageID];
	
	    if (language == null && this.langTags != null && record.languageID >= 0x8000) {
	      language = this.langTags[record.languageID - 0x8000].tag;
	    }
	
	    if (language == null) {
	      language = record.platformID + '-' + record.languageID;
	    }
	
	    // if the nameID is >= 256, it is a font feature record (AAT)
	    var key = record.nameID >= 256 ? 'fontFeatures' : NAMES[record.nameID] || record.nameID;
	    if (records[key] == null) {
	      records[key] = {};
	    }
	
	    var obj = records[key];
	    if (record.nameID >= 256) {
	      obj = obj[record.nameID] || (obj[record.nameID] = {});
	    }
	
	    if (typeof record.string === 'string' || typeof obj[language] !== 'string') {
	      obj[language] = record.string;
	    }
	  }
	
	  this.records = records;
	};
	
	NameTable.preEncode = function () {
	  if (Array.isArray(this.records)) return;
	  this.version = 0;
	
	  var records = [];
	  for (var key in this.records) {
	    var val = this.records[key];
	    if (key === 'fontFeatures') continue;
	
	    records.push({
	      platformID: 3,
	      encodingID: 1,
	      languageID: 0x409,
	      nameID: NAMES.indexOf(key),
	      length: Buffer.byteLength(val.en, 'utf16le'),
	      string: val.en
	    });
	
	    if (key === 'postscriptName') {
	      records.push({
	        platformID: 1,
	        encodingID: 0,
	        languageID: 0,
	        nameID: NAMES.indexOf(key),
	        length: val.en.length,
	        string: val.en
	      });
	    }
	  }
	
	  this.records = records;
	  this.count = records.length;
	  this.stringOffset = NameTable.size(this, null, false);
	};
	
	var OS2 = new r.VersionedStruct(r.uint16, {
	  header: {
	    xAvgCharWidth: r.int16, // average weighted advance width of lower case letters and space
	    usWeightClass: r.uint16, // visual weight of stroke in glyphs
	    usWidthClass: r.uint16, // relative change from the normal aspect ratio (width to height ratio)
	    fsType: new r.Bitfield(r.uint16, [// Indicates font embedding licensing rights
	    null, 'noEmbedding', 'viewOnly', 'editable', null, null, null, null, 'noSubsetting', 'bitmapOnly']),
	    ySubscriptXSize: r.int16, // recommended horizontal size in pixels for subscripts
	    ySubscriptYSize: r.int16, // recommended vertical size in pixels for subscripts
	    ySubscriptXOffset: r.int16, // recommended horizontal offset for subscripts
	    ySubscriptYOffset: r.int16, // recommended vertical offset form the baseline for subscripts
	    ySuperscriptXSize: r.int16, // recommended horizontal size in pixels for superscripts
	    ySuperscriptYSize: r.int16, // recommended vertical size in pixels for superscripts
	    ySuperscriptXOffset: r.int16, // recommended horizontal offset for superscripts
	    ySuperscriptYOffset: r.int16, // recommended vertical offset from the baseline for superscripts
	    yStrikeoutSize: r.int16, // width of the strikeout stroke
	    yStrikeoutPosition: r.int16, // position of the strikeout stroke relative to the baseline
	    sFamilyClass: r.int16, // classification of font-family design
	    panose: new r.Array(r.uint8, 10), // describe the visual characteristics of a given typeface
	    ulCharRange: new r.Array(r.uint32, 4),
	    vendorID: new r.String(4), // four character identifier for the font vendor
	    fsSelection: new r.Bitfield(r.uint16, [// bit field containing information about the font
	    'italic', 'underscore', 'negative', 'outlined', 'strikeout', 'bold', 'regular', 'useTypoMetrics', 'wws', 'oblique']),
	    usFirstCharIndex: r.uint16, // The minimum Unicode index in this font
	    usLastCharIndex: r.uint16 // The maximum Unicode index in this font
	  },
	
	  // The Apple version of this table ends here, but the Microsoft one continues on...
	  0: {},
	
	  1: {
	    typoAscender: r.int16,
	    typoDescender: r.int16,
	    typoLineGap: r.int16,
	    winAscent: r.uint16,
	    winDescent: r.uint16,
	    codePageRange: new r.Array(r.uint32, 2)
	  },
	
	  2: {
	    // these should be common with version 1 somehow
	    typoAscender: r.int16,
	    typoDescender: r.int16,
	    typoLineGap: r.int16,
	    winAscent: r.uint16,
	    winDescent: r.uint16,
	    codePageRange: new r.Array(r.uint32, 2),
	
	    xHeight: r.int16,
	    capHeight: r.int16,
	    defaultChar: r.uint16,
	    breakChar: r.uint16,
	    maxContent: r.uint16
	  },
	
	  5: {
	    typoAscender: r.int16,
	    typoDescender: r.int16,
	    typoLineGap: r.int16,
	    winAscent: r.uint16,
	    winDescent: r.uint16,
	    codePageRange: new r.Array(r.uint32, 2),
	
	    xHeight: r.int16,
	    capHeight: r.int16,
	    defaultChar: r.uint16,
	    breakChar: r.uint16,
	    maxContent: r.uint16,
	
	    usLowerOpticalPointSize: r.uint16,
	    usUpperOpticalPointSize: r.uint16
	  }
	});
	
	var versions = OS2.versions;
	versions[3] = versions[4] = versions[2];
	
	// PostScript information
	var post = new r.VersionedStruct(r.fixed32, {
	  header: { // these fields exist at the top of all versions
	    italicAngle: r.fixed32, // Italic angle in counter-clockwise degrees from the vertical.
	    underlinePosition: r.int16, // Suggested distance of the top of the underline from the baseline
	    underlineThickness: r.int16, // Suggested values for the underline thickness
	    isFixedPitch: r.uint32, // Whether the font is monospaced
	    minMemType42: r.uint32, // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
	    maxMemType42: r.uint32, // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
	    minMemType1: r.uint32, // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
	    maxMemType1: r.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
	  },
	
	  1: {}, // version 1 has no additional fields
	
	  2: {
	    numberOfGlyphs: r.uint16,
	    glyphNameIndex: new r.Array(r.uint16, 'numberOfGlyphs'),
	    names: new r.Array(new r.String(r.uint8))
	  },
	
	  2.5: {
	    numberOfGlyphs: r.uint16,
	    offsets: new r.Array(r.uint8, 'numberOfGlyphs')
	  },
	
	  3: {}, // version 3 has no additional fields
	
	  4: {
	    map: new r.Array(r.uint32, function (t) {
	      return t.parent.maxp.numGlyphs;
	    })
	  }
	});
	
	// An array of predefined values accessible by instructions
	var cvt = new r.Struct({
	  controlValues: new r.Array(r.int16)
	});
	
	// A list of instructions that are executed once when a font is first used.
	// These instructions are known as the font program. The main use of this table
	// is for the definition of functions that are used in many different glyph programs.
	var fpgm = new r.Struct({
	  instructions: new r.Array(r.uint8)
	});
	
	var loca = new r.VersionedStruct('head.indexToLocFormat', {
	  0: {
	    offsets: new r.Array(r.uint16)
	  },
	  1: {
	    offsets: new r.Array(r.uint32)
	  }
	});
	
	loca.process = function () {
	  if (this.version === 0) {
	    for (var i = 0; i < this.offsets.length; i++) {
	      this.offsets[i] <<= 1;
	    }
	  }
	};
	
	loca.preEncode = function () {
	  if (this.version != null) return;
	
	  // assume this.offsets is a sorted array
	  this.version = this.offsets[this.offsets.length - 1] > 0xffff ? 1 : 0;
	
	  if (this.version === 0) {
	    for (var i = 0; i < this.offsets.length; i++) {
	      this.offsets[i] >>>= 1;
	    }
	  }
	};
	
	// Set of instructions executed whenever the point size or font transformation change
	var prep = new r.Struct({
	  controlValueProgram: new r.Array(r.uint8)
	});
	
	// only used for encoding
	var glyf = new r.Array(new r.Buffer());
	
	var CFFIndex = function () {
	  function CFFIndex(type) {
	    _classCallCheck(this, CFFIndex);
	
	    this.type = type;
	  }
	
	  CFFIndex.prototype.getCFFVersion = function getCFFVersion(ctx) {
	    while (ctx && !ctx.hdrSize) {
	      ctx = ctx.parent;
	    }
	
	    return ctx ? ctx.version : -1;
	  };
	
	  CFFIndex.prototype.decode = function decode(stream, parent) {
	    var version = this.getCFFVersion(parent);
	    var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
	
	    if (count === 0) {
	      return [];
	    }
	
	    var offSize = stream.readUInt8();
	    var offsetType = void 0;
	    if (offSize === 1) {
	      offsetType = r.uint8;
	    } else if (offSize === 2) {
	      offsetType = r.uint16;
	    } else if (offSize === 3) {
	      offsetType = r.uint24;
	    } else if (offSize === 4) {
	      offsetType = r.uint32;
	    } else {
	      throw new Error("Bad offset size in CFFIndex: " + offSize + " " + stream.pos);
	    }
	
	    var ret = [];
	    var startPos = stream.pos + (count + 1) * offSize - 1;
	
	    var start = offsetType.decode(stream);
	    for (var i = 0; i < count; i++) {
	      var end = offsetType.decode(stream);
	
	      if (this.type != null) {
	        var pos = stream.pos;
	        stream.pos = startPos + start;
	
	        parent.length = end - start;
	        ret.push(this.type.decode(stream, parent));
	        stream.pos = pos;
	      } else {
	        ret.push({
	          offset: startPos + start,
	          length: end - start
	        });
	      }
	
	      start = end;
	    }
	
	    stream.pos = startPos + start;
	    return ret;
	  };
	
	  CFFIndex.prototype.size = function size(arr, parent) {
	    var size = 2;
	    if (arr.length === 0) {
	      return size;
	    }
	
	    var type = this.type || new r.Buffer();
	
	    // find maximum offset to detminine offset type
	    var offset = 1;
	    for (var i = 0; i < arr.length; i++) {
	      var item = arr[i];
	      offset += type.size(item, parent);
	    }
	
	    var offsetType = void 0;
	    if (offset <= 0xff) {
	      offsetType = r.uint8;
	    } else if (offset <= 0xffff) {
	      offsetType = r.uint16;
	    } else if (offset <= 0xffffff) {
	      offsetType = r.uint24;
	    } else if (offset <= 0xffffffff) {
	      offsetType = r.uint32;
	    } else {
	      throw new Error("Bad offset in CFFIndex");
	    }
	
	    size += 1 + offsetType.size() * (arr.length + 1);
	    size += offset - 1;
	
	    return size;
	  };
	
	  CFFIndex.prototype.encode = function encode(stream, arr, parent) {
	    stream.writeUInt16BE(arr.length);
	    if (arr.length === 0) {
	      return;
	    }
	
	    var type = this.type || new r.Buffer();
	
	    // find maximum offset to detminine offset type
	    var sizes = [];
	    var offset = 1;
	    for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var item = _ref;
	
	      var s = type.size(item, parent);
	      sizes.push(s);
	      offset += s;
	    }
	
	    var offsetType = void 0;
	    if (offset <= 0xff) {
	      offsetType = r.uint8;
	    } else if (offset <= 0xffff) {
	      offsetType = r.uint16;
	    } else if (offset <= 0xffffff) {
	      offsetType = r.uint24;
	    } else if (offset <= 0xffffffff) {
	      offsetType = r.uint32;
	    } else {
	      throw new Error("Bad offset in CFFIndex");
	    }
	
	    // write offset size
	    stream.writeUInt8(offsetType.size());
	
	    // write elements
	    offset = 1;
	    offsetType.encode(stream, offset);
	
	    for (var _iterator2 = sizes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var size = _ref2;
	
	      offset += size;
	      offsetType.encode(stream, offset);
	    }
	
	    for (var _iterator3 = arr, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var _item = _ref3;
	
	      type.encode(stream, _item, parent);
	    }
	
	    return;
	  };
	
	  return CFFIndex;
	}();
	
	var FLOAT_EOF = 0xf;
	var FLOAT_LOOKUP = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
	
	var FLOAT_ENCODE_LOOKUP = {
	  '.': 10,
	  'E': 11,
	  'E-': 12,
	  '-': 14
	};
	
	var CFFOperand = function () {
	  function CFFOperand() {
	    _classCallCheck(this, CFFOperand);
	  }
	
	  CFFOperand.decode = function decode(stream, value) {
	    if (32 <= value && value <= 246) {
	      return value - 139;
	    }
	
	    if (247 <= value && value <= 250) {
	      return (value - 247) * 256 + stream.readUInt8() + 108;
	    }
	
	    if (251 <= value && value <= 254) {
	      return -(value - 251) * 256 - stream.readUInt8() - 108;
	    }
	
	    if (value === 28) {
	      return stream.readInt16BE();
	    }
	
	    if (value === 29) {
	      return stream.readInt32BE();
	    }
	
	    if (value === 30) {
	      var str = '';
	      while (true) {
	        var b = stream.readUInt8();
	
	        var n1 = b >> 4;
	        if (n1 === FLOAT_EOF) {
	          break;
	        }
	        str += FLOAT_LOOKUP[n1];
	
	        var n2 = b & 15;
	        if (n2 === FLOAT_EOF) {
	          break;
	        }
	        str += FLOAT_LOOKUP[n2];
	      }
	
	      return parseFloat(str);
	    }
	
	    return null;
	  };
	
	  CFFOperand.size = function size(value) {
	    // if the value needs to be forced to the largest size (32 bit)
	    // e.g. for unknown pointers, set to 32768
	    if (value.forceLarge) {
	      value = 32768;
	    }
	
	    if ((value | 0) !== value) {
	      // floating point
	      var str = '' + value;
	      return 1 + Math.ceil((str.length + 1) / 2);
	    } else if (-107 <= value && value <= 107) {
	      return 1;
	    } else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) {
	      return 2;
	    } else if (-32768 <= value && value <= 32767) {
	      return 3;
	    } else {
	      return 5;
	    }
	  };
	
	  CFFOperand.encode = function encode(stream, value) {
	    // if the value needs to be forced to the largest size (32 bit)
	    // e.g. for unknown pointers, save the old value and set to 32768
	    var val = Number(value);
	
	    if (value.forceLarge) {
	      stream.writeUInt8(29);
	      return stream.writeInt32BE(val);
	    } else if ((val | 0) !== val) {
	      // floating point
	      stream.writeUInt8(30);
	
	      var str = '' + val;
	      for (var i = 0; i < str.length; i += 2) {
	        var c1 = str[i];
	        var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;
	
	        if (i === str.length - 1) {
	          var n2 = FLOAT_EOF;
	        } else {
	          var c2 = str[i + 1];
	          var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
	        }
	
	        stream.writeUInt8(n1 << 4 | n2 & 15);
	      }
	
	      if (n2 !== FLOAT_EOF) {
	        return stream.writeUInt8(FLOAT_EOF << 4);
	      }
	    } else if (-107 <= val && val <= 107) {
	      return stream.writeUInt8(val + 139);
	    } else if (108 <= val && val <= 1131) {
	      val -= 108;
	      stream.writeUInt8((val >> 8) + 247);
	      return stream.writeUInt8(val & 0xff);
	    } else if (-1131 <= val && val <= -108) {
	      val = -val - 108;
	      stream.writeUInt8((val >> 8) + 251);
	      return stream.writeUInt8(val & 0xff);
	    } else if (-32768 <= val && val <= 32767) {
	      stream.writeUInt8(28);
	      return stream.writeInt16BE(val);
	    } else {
	      stream.writeUInt8(29);
	      return stream.writeInt32BE(val);
	    }
	  };
	
	  return CFFOperand;
	}();
	
	var CFFDict = function () {
	  function CFFDict() {
	    var ops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, CFFDict);
	
	    this.ops = ops;
	    this.fields = {};
	    for (var _iterator = ops, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var field = _ref;
	
	      var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
	      this.fields[key] = field;
	    }
	  }
	
	  CFFDict.prototype.decodeOperands = function decodeOperands(type, stream, ret, operands) {
	    var _this = this;
	
	    if (Array.isArray(type)) {
	      return operands.map(function (op, i) {
	        return _this.decodeOperands(type[i], stream, ret, [op]);
	      });
	    } else if (type.decode != null) {
	      return type.decode(stream, ret, operands);
	    } else {
	      switch (type) {
	        case 'number':
	        case 'offset':
	        case 'sid':
	          return operands[0];
	        case 'boolean':
	          return !!operands[0];
	        default:
	          return operands;
	      }
	    }
	  };
	
	  CFFDict.prototype.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
	    var _this2 = this;
	
	    if (Array.isArray(type)) {
	      return operands.map(function (op, i) {
	        return _this2.encodeOperands(type[i], stream, ctx, op)[0];
	      });
	    } else if (type.encode != null) {
	      return type.encode(stream, operands, ctx);
	    } else if (typeof operands === 'number') {
	      return [operands];
	    } else if (typeof operands === 'boolean') {
	      return [+operands];
	    } else if (Array.isArray(operands)) {
	      return operands;
	    } else {
	      return [operands];
	    }
	  };
	
	  CFFDict.prototype.decode = function decode(stream, parent) {
	    var end = stream.pos + parent.length;
	    var ret = {};
	    var operands = [];
	
	    // define hidden properties
	    _Object$defineProperties(ret, {
	      parent: { value: parent },
	      _startOffset: { value: stream.pos }
	    });
	
	    // fill in defaults
	    for (var key in this.fields) {
	      var field = this.fields[key];
	      ret[field[1]] = field[3];
	    }
	
	    while (stream.pos < end) {
	      var b = stream.readUInt8();
	      if (b < 28) {
	        if (b === 12) {
	          b = b << 8 | stream.readUInt8();
	        }
	
	        var _field = this.fields[b];
	        if (!_field) {
	          throw new Error('Unknown operator ' + b);
	        }
	
	        var val = this.decodeOperands(_field[2], stream, ret, operands);
	        if (val != null) {
	          if (val instanceof restructure_src_utils.PropertyDescriptor) {
	            _Object$defineProperty(ret, _field[1], val);
	          } else {
	            ret[_field[1]] = val;
	          }
	        }
	
	        operands = [];
	      } else {
	        operands.push(CFFOperand.decode(stream, b));
	      }
	    }
	
	    return ret;
	  };
	
	  CFFDict.prototype.size = function size(dict, parent) {
	    var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    var ctx = {
	      parent: parent,
	      val: dict,
	      pointerSize: 0,
	      startOffset: parent.startOffset || 0
	    };
	
	    var len = 0;
	
	    for (var k in this.fields) {
	      var field = this.fields[k];
	      var val = dict[field[1]];
	      if (val == null || isEqual(val, field[3])) {
	        continue;
	      }
	
	      var operands = this.encodeOperands(field[2], null, ctx, val);
	      for (var _iterator2 = operands, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var op = _ref2;
	
	        len += CFFOperand.size(op);
	      }
	
	      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
	      len += key.length;
	    }
	
	    if (includePointers) {
	      len += ctx.pointerSize;
	    }
	
	    return len;
	  };
	
	  CFFDict.prototype.encode = function encode(stream, dict, parent) {
	    var ctx = {
	      pointers: [],
	      startOffset: stream.pos,
	      parent: parent,
	      val: dict,
	      pointerSize: 0
	    };
	
	    ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
	
	    for (var _iterator3 = this.ops, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var field = _ref3;
	
	      var val = dict[field[1]];
	      if (val == null || isEqual(val, field[3])) {
	        continue;
	      }
	
	      var operands = this.encodeOperands(field[2], stream, ctx, val);
	      for (var _iterator4 = operands, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	        var _ref4;
	
	        if (_isArray4) {
	          if (_i4 >= _iterator4.length) break;
	          _ref4 = _iterator4[_i4++];
	        } else {
	          _i4 = _iterator4.next();
	          if (_i4.done) break;
	          _ref4 = _i4.value;
	        }
	
	        var op = _ref4;
	
	        CFFOperand.encode(stream, op);
	      }
	
	      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
	      for (var _iterator5 = key, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	        var _ref5;
	
	        if (_isArray5) {
	          if (_i5 >= _iterator5.length) break;
	          _ref5 = _iterator5[_i5++];
	        } else {
	          _i5 = _iterator5.next();
	          if (_i5.done) break;
	          _ref5 = _i5.value;
	        }
	
	        var _op = _ref5;
	
	        stream.writeUInt8(_op);
	      }
	    }
	
	    var i = 0;
	    while (i < ctx.pointers.length) {
	      var ptr = ctx.pointers[i++];
	      ptr.type.encode(stream, ptr.val, ptr.parent);
	    }
	
	    return;
	  };
	
	  return CFFDict;
	}();
	
	var CFFPointer = function (_r$Pointer) {
	  _inherits(CFFPointer, _r$Pointer);
	
	  function CFFPointer(type) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, CFFPointer);
	
	    if (options.type == null) {
	      options.type = 'global';
	    }
	
	    return _possibleConstructorReturn(this, _r$Pointer.call(this, null, type, options));
	  }
	
	  CFFPointer.prototype.decode = function decode(stream, parent, operands) {
	    this.offsetType = {
	      decode: function decode() {
	        return operands[0];
	      }
	    };
	
	    return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
	  };
	
	  CFFPointer.prototype.encode = function encode(stream, value, ctx) {
	    if (!stream) {
	      // compute the size (so ctx.pointerSize is correct)
	      this.offsetType = {
	        size: function size() {
	          return 0;
	        }
	      };
	
	      this.size(value, ctx);
	      return [new Ptr(0)];
	    }
	
	    var ptr = null;
	    this.offsetType = {
	      encode: function encode(stream, val) {
	        return ptr = val;
	      }
	    };
	
	    _r$Pointer.prototype.encode.call(this, stream, value, ctx);
	    return [new Ptr(ptr)];
	  };
	
	  return CFFPointer;
	}(r.Pointer);
	
	var Ptr = function () {
	  function Ptr(val) {
	    _classCallCheck(this, Ptr);
	
	    this.val = val;
	    this.forceLarge = true;
	  }
	
	  Ptr.prototype.valueOf = function valueOf() {
	    return this.val;
	  };
	
	  return Ptr;
	}();
	
	var CFFBlendOp = function () {
	  function CFFBlendOp() {
	    _classCallCheck(this, CFFBlendOp);
	  }
	
	  CFFBlendOp.decode = function decode(stream, parent, operands) {
	    var numBlends = operands.pop();
	
	    // TODO: actually blend. For now just consume the deltas
	    // since we don't use any of the values anyway.
	    while (operands.length > numBlends) {
	      operands.pop();
	    }
	  };
	
	  return CFFBlendOp;
	}();
	
	var CFFPrivateDict = new CFFDict([
	// key       name                    type                                          default
	[6, 'BlueValues', 'delta', null], [7, 'OtherBlues', 'delta', null], [8, 'FamilyBlues', 'delta', null], [9, 'FamilyOtherBlues', 'delta', null], [[12, 9], 'BlueScale', 'number', 0.039625], [[12, 10], 'BlueShift', 'number', 7], [[12, 11], 'BlueFuzz', 'number', 1], [10, 'StdHW', 'number', null], [11, 'StdVW', 'number', null], [[12, 12], 'StemSnapH', 'delta', null], [[12, 13], 'StemSnapV', 'delta', null], [[12, 14], 'ForceBold', 'boolean', false], [[12, 17], 'LanguageGroup', 'number', 0], [[12, 18], 'ExpansionFactor', 'number', 0.06], [[12, 19], 'initialRandomSeed', 'number', 0], [20, 'defaultWidthX', 'number', 0], [21, 'nominalWidthX', 'number', 0], [22, 'vsindex', 'number', 0], [23, 'blend', CFFBlendOp, null], [19, 'Subrs', new CFFPointer(new CFFIndex(), { type: 'local' }), null]]);
	
	// Automatically generated from Appendix A of the CFF specification; do
	// not edit. Length should be 391.
	var standardStrings = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
	
	var StandardEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger', 'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron', 'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '', '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '', 'lslash', 'oslash', 'oe', 'germandbls'];
	
	var ExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior', '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
	
	var ISOAdobeCharset = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron'];
	
	var ExpertCharset = ['.notdef', 'space', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
	
	var ExpertSubsetCharset = ['.notdef', 'space', 'dollaroldstyle', 'dollarsuperior', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'hyphensuperior', 'colonmonetary', 'onefitted', 'rupiah', 'centoldstyle', 'figuredash', 'hypheninferior', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior'];
	
	//########################
	// Scripts and Languages #
	//########################
	
	var LangSysTable = new r.Struct({
	  reserved: new r.Reserved(r.uint16),
	  reqFeatureIndex: r.uint16,
	  featureCount: r.uint16,
	  featureIndexes: new r.Array(r.uint16, 'featureCount')
	});
	
	var LangSysRecord = new r.Struct({
	  tag: new r.String(4),
	  langSys: new r.Pointer(r.uint16, LangSysTable, { type: 'parent' })
	});
	
	var Script = new r.Struct({
	  defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
	  count: r.uint16,
	  langSysRecords: new r.Array(LangSysRecord, 'count')
	});
	
	var ScriptRecord = new r.Struct({
	  tag: new r.String(4),
	  script: new r.Pointer(r.uint16, Script, { type: 'parent' })
	});
	
	var ScriptList = new r.Array(ScriptRecord, r.uint16);
	
	//#######################
	// Features and Lookups #
	//#######################
	
	var Feature = new r.Struct({
	  featureParams: r.uint16, // pointer
	  lookupCount: r.uint16,
	  lookupListIndexes: new r.Array(r.uint16, 'lookupCount')
	});
	
	var FeatureRecord = new r.Struct({
	  tag: new r.String(4),
	  feature: new r.Pointer(r.uint16, Feature, { type: 'parent' })
	});
	
	var FeatureList = new r.Array(FeatureRecord, r.uint16);
	
	var LookupFlags = new r.Struct({
	  markAttachmentType: r.uint8,
	  flags: new r.Bitfield(r.uint8, ['rightToLeft', 'ignoreBaseGlyphs', 'ignoreLigatures', 'ignoreMarks', 'useMarkFilteringSet'])
	});
	
	function LookupList(SubTable) {
	  var Lookup = new r.Struct({
	    lookupType: r.uint16,
	    flags: LookupFlags,
	    subTableCount: r.uint16,
	    subTables: new r.Array(new r.Pointer(r.uint16, SubTable), 'subTableCount'),
	    markFilteringSet: new r.Optional(r.uint16, function (t) {
	      return t.flags.flags.useMarkFilteringSet;
	    })
	  });
	
	  return new r.LazyArray(new r.Pointer(r.uint16, Lookup), r.uint16);
	}
	
	//#################
	// Coverage Table #
	//#################
	
	var RangeRecord = new r.Struct({
	  start: r.uint16,
	  end: r.uint16,
	  startCoverageIndex: r.uint16
	});
	
	var Coverage = new r.VersionedStruct(r.uint16, {
	  1: {
	    glyphCount: r.uint16,
	    glyphs: new r.Array(r.uint16, 'glyphCount')
	  },
	  2: {
	    rangeCount: r.uint16,
	    rangeRecords: new r.Array(RangeRecord, 'rangeCount')
	  }
	});
	
	//#########################
	// Class Definition Table #
	//#########################
	
	var ClassRangeRecord = new r.Struct({
	  start: r.uint16,
	  end: r.uint16,
	  class: r.uint16
	});
	
	var ClassDef = new r.VersionedStruct(r.uint16, {
	  1: { // Class array
	    startGlyph: r.uint16,
	    glyphCount: r.uint16,
	    classValueArray: new r.Array(r.uint16, 'glyphCount')
	  },
	  2: { // Class ranges
	    classRangeCount: r.uint16,
	    classRangeRecord: new r.Array(ClassRangeRecord, 'classRangeCount')
	  }
	});
	
	//###############
	// Device Table #
	//###############
	
	var Device = new r.Struct({
	  a: r.uint16, // startSize for hinting Device, outerIndex for VariationIndex
	  b: r.uint16, // endSize for Device, innerIndex for VariationIndex
	  deltaFormat: r.uint16
	});
	
	//#############################################
	// Contextual Substitution/Positioning Tables #
	//#############################################
	
	var LookupRecord = new r.Struct({
	  sequenceIndex: r.uint16,
	  lookupListIndex: r.uint16
	});
	
	var Rule = new r.Struct({
	  glyphCount: r.uint16,
	  lookupCount: r.uint16,
	  input: new r.Array(r.uint16, function (t) {
	    return t.glyphCount - 1;
	  }),
	  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	});
	
	var RuleSet = new r.Array(new r.Pointer(r.uint16, Rule), r.uint16);
	
	var ClassRule = new r.Struct({
	  glyphCount: r.uint16,
	  lookupCount: r.uint16,
	  classes: new r.Array(r.uint16, function (t) {
	    return t.glyphCount - 1;
	  }),
	  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	});
	
	var ClassSet = new r.Array(new r.Pointer(r.uint16, ClassRule), r.uint16);
	
	var Context = new r.VersionedStruct(r.uint16, {
	  1: { // Simple context
	    coverage: new r.Pointer(r.uint16, Coverage),
	    ruleSetCount: r.uint16,
	    ruleSets: new r.Array(new r.Pointer(r.uint16, RuleSet), 'ruleSetCount')
	  },
	  2: { // Class-based context
	    coverage: new r.Pointer(r.uint16, Coverage),
	    classDef: new r.Pointer(r.uint16, ClassDef),
	    classSetCnt: r.uint16,
	    classSet: new r.Array(new r.Pointer(r.uint16, ClassSet), 'classSetCnt')
	  },
	  3: {
	    glyphCount: r.uint16,
	    lookupCount: r.uint16,
	    coverages: new r.Array(new r.Pointer(r.uint16, Coverage), 'glyphCount'),
	    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	  }
	});
	
	//######################################################
	// Chaining Contextual Substitution/Positioning Tables #
	//######################################################
	
	var ChainRule = new r.Struct({
	  backtrackGlyphCount: r.uint16,
	  backtrack: new r.Array(r.uint16, 'backtrackGlyphCount'),
	  inputGlyphCount: r.uint16,
	  input: new r.Array(r.uint16, function (t) {
	    return t.inputGlyphCount - 1;
	  }),
	  lookaheadGlyphCount: r.uint16,
	  lookahead: new r.Array(r.uint16, 'lookaheadGlyphCount'),
	  lookupCount: r.uint16,
	  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	});
	
	var ChainRuleSet = new r.Array(new r.Pointer(r.uint16, ChainRule), r.uint16);
	
	var ChainingContext = new r.VersionedStruct(r.uint16, {
	  1: { // Simple context glyph substitution
	    coverage: new r.Pointer(r.uint16, Coverage),
	    chainCount: r.uint16,
	    chainRuleSets: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
	  },
	
	  2: { // Class-based chaining context
	    coverage: new r.Pointer(r.uint16, Coverage),
	    backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
	    inputClassDef: new r.Pointer(r.uint16, ClassDef),
	    lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
	    chainCount: r.uint16,
	    chainClassSet: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
	  },
	
	  3: { // Coverage-based chaining context
	    backtrackGlyphCount: r.uint16,
	    backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
	    inputGlyphCount: r.uint16,
	    inputCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'inputGlyphCount'),
	    lookaheadGlyphCount: r.uint16,
	    lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
	    lookupCount: r.uint16,
	    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	  }
	});
	
	var _;
	
	/*******************
	 * Variation Store *
	 *******************/
	
	var F2DOT14 = new r.Fixed(16, 'BE', 14);
	var RegionAxisCoordinates = new r.Struct({
	  startCoord: F2DOT14,
	  peakCoord: F2DOT14,
	  endCoord: F2DOT14
	});
	
	var VariationRegionList = new r.Struct({
	  axisCount: r.uint16,
	  regionCount: r.uint16,
	  variationRegions: new r.Array(new r.Array(RegionAxisCoordinates, 'axisCount'), 'regionCount')
	});
	
	var DeltaSet = new r.Struct({
	  shortDeltas: new r.Array(r.int16, function (t) {
	    return t.parent.shortDeltaCount;
	  }),
	  regionDeltas: new r.Array(r.int8, function (t) {
	    return t.parent.regionIndexCount - t.parent.shortDeltaCount;
	  }),
	  deltas: function deltas(t) {
	    return t.shortDeltas.concat(t.regionDeltas);
	  }
	});
	
	var ItemVariationData = new r.Struct({
	  itemCount: r.uint16,
	  shortDeltaCount: r.uint16,
	  regionIndexCount: r.uint16,
	  regionIndexes: new r.Array(r.uint16, 'regionIndexCount'),
	  deltaSets: new r.Array(DeltaSet, 'itemCount')
	});
	
	var ItemVariationStore = new r.Struct({
	  format: r.uint16,
	  variationRegionList: new r.Pointer(r.uint32, VariationRegionList),
	  variationDataCount: r.uint16,
	  itemVariationData: new r.Array(new r.Pointer(r.uint32, ItemVariationData), 'variationDataCount')
	});
	
	/**********************
	 * Feature Variations *
	 **********************/
	
	var ConditionTable = new r.VersionedStruct(r.uint16, {
	  1: (_ = {
	    axisIndex: r.uint16
	  }, _['axisIndex'] = r.uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _)
	});
	
	var ConditionSet = new r.Struct({
	  conditionCount: r.uint16,
	  conditionTable: new r.Array(new r.Pointer(r.uint32, ConditionTable), 'conditionCount')
	});
	
	var FeatureTableSubstitutionRecord = new r.Struct({
	  featureIndex: r.uint16,
	  alternateFeatureTable: new r.Pointer(r.uint32, Feature, { type: 'parent' })
	});
	
	var FeatureTableSubstitution = new r.Struct({
	  version: r.fixed32,
	  substitutionCount: r.uint16,
	  substitutions: new r.Array(FeatureTableSubstitutionRecord, 'substitutionCount')
	});
	
	var FeatureVariationRecord = new r.Struct({
	  conditionSet: new r.Pointer(r.uint32, ConditionSet, { type: 'parent' }),
	  featureTableSubstitution: new r.Pointer(r.uint32, FeatureTableSubstitution, { type: 'parent' })
	});
	
	var FeatureVariations = new r.Struct({
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  featureVariationRecordCount: r.uint32,
	  featureVariationRecords: new r.Array(FeatureVariationRecord, 'featureVariationRecordCount')
	});
	
	// Checks if an operand is an index of a predefined value,
	// otherwise delegates to the provided type.
	
	var PredefinedOp = function () {
	  function PredefinedOp(predefinedOps, type) {
	    _classCallCheck(this, PredefinedOp);
	
	    this.predefinedOps = predefinedOps;
	    this.type = type;
	  }
	
	  PredefinedOp.prototype.decode = function decode(stream, parent, operands) {
	    if (this.predefinedOps[operands[0]]) {
	      return this.predefinedOps[operands[0]];
	    }
	
	    return this.type.decode(stream, parent, operands);
	  };
	
	  PredefinedOp.prototype.size = function size(value, ctx) {
	    return this.type.size(value, ctx);
	  };
	
	  PredefinedOp.prototype.encode = function encode(stream, value, ctx) {
	    var index = this.predefinedOps.indexOf(value);
	    if (index !== -1) {
	      return index;
	    }
	
	    return this.type.encode(stream, value, ctx);
	  };
	
	  return PredefinedOp;
	}();
	
	var CFFEncodingVersion = function (_r$Number) {
	  _inherits(CFFEncodingVersion, _r$Number);
	
	  function CFFEncodingVersion() {
	    _classCallCheck(this, CFFEncodingVersion);
	
	    return _possibleConstructorReturn(this, _r$Number.call(this, 'UInt8'));
	  }
	
	  CFFEncodingVersion.prototype.decode = function decode(stream) {
	    return r.uint8.decode(stream) & 0x7f;
	  };
	
	  return CFFEncodingVersion;
	}(r.Number);
	
	var Range1 = new r.Struct({
	  first: r.uint16,
	  nLeft: r.uint8
	});
	
	var Range2 = new r.Struct({
	  first: r.uint16,
	  nLeft: r.uint16
	});
	
	var CFFCustomEncoding = new r.VersionedStruct(new CFFEncodingVersion(), {
	  0: {
	    nCodes: r.uint8,
	    codes: new r.Array(r.uint8, 'nCodes')
	  },
	
	  1: {
	    nRanges: r.uint8,
	    ranges: new r.Array(Range1, 'nRanges')
	  }
	
	  // TODO: supplement?
	});
	
	var CFFEncoding = new PredefinedOp([StandardEncoding, ExpertEncoding], new CFFPointer(CFFCustomEncoding, { lazy: true }));
	
	// Decodes an array of ranges until the total
	// length is equal to the provided length.
	
	var RangeArray = function (_r$Array) {
	  _inherits(RangeArray, _r$Array);
	
	  function RangeArray() {
	    _classCallCheck(this, RangeArray);
	
	    return _possibleConstructorReturn(this, _r$Array.apply(this, arguments));
	  }
	
	  RangeArray.prototype.decode = function decode(stream, parent) {
	    var length = restructure_src_utils.resolveLength(this.length, stream, parent);
	    var count = 0;
	    var res = [];
	    while (count < length) {
	      var range = this.type.decode(stream, parent);
	      range.offset = count;
	      count += range.nLeft + 1;
	      res.push(range);
	    }
	
	    return res;
	  };
	
	  return RangeArray;
	}(r.Array);
	
	var CFFCustomCharset = new r.VersionedStruct(r.uint8, {
	  0: {
	    glyphs: new r.Array(r.uint16, function (t) {
	      return t.parent.CharStrings.length - 1;
	    })
	  },
	
	  1: {
	    ranges: new RangeArray(Range1, function (t) {
	      return t.parent.CharStrings.length - 1;
	    })
	  },
	
	  2: {
	    ranges: new RangeArray(Range2, function (t) {
	      return t.parent.CharStrings.length - 1;
	    })
	  }
	});
	
	var CFFCharset = new PredefinedOp([ISOAdobeCharset, ExpertCharset, ExpertSubsetCharset], new CFFPointer(CFFCustomCharset, { lazy: true }));
	
	var FDRange3 = new r.Struct({
	  first: r.uint16,
	  fd: r.uint8
	});
	
	var FDRange4 = new r.Struct({
	  first: r.uint32,
	  fd: r.uint16
	});
	
	var FDSelect = new r.VersionedStruct(r.uint8, {
	  0: {
	    fds: new r.Array(r.uint8, function (t) {
	      return t.parent.CharStrings.length;
	    })
	  },
	
	  3: {
	    nRanges: r.uint16,
	    ranges: new r.Array(FDRange3, 'nRanges'),
	    sentinel: r.uint16
	  },
	
	  4: {
	    nRanges: r.uint32,
	    ranges: new r.Array(FDRange4, 'nRanges'),
	    sentinel: r.uint32
	  }
	});
	
	var ptr = new CFFPointer(CFFPrivateDict);
	
	var CFFPrivateOp = function () {
	  function CFFPrivateOp() {
	    _classCallCheck(this, CFFPrivateOp);
	  }
	
	  CFFPrivateOp.prototype.decode = function decode(stream, parent, operands) {
	    parent.length = operands[0];
	    return ptr.decode(stream, parent, [operands[1]]);
	  };
	
	  CFFPrivateOp.prototype.size = function size(dict, ctx) {
	    return [CFFPrivateDict.size(dict, ctx, false), ptr.size(dict, ctx)[0]];
	  };
	
	  CFFPrivateOp.prototype.encode = function encode(stream, dict, ctx) {
	    return [CFFPrivateDict.size(dict, ctx, false), ptr.encode(stream, dict, ctx)[0]];
	  };
	
	  return CFFPrivateOp;
	}();
	
	var FontDict = new CFFDict([
	// key       name                   type(s)                                 default
	[18, 'Private', new CFFPrivateOp(), null], [[12, 38], 'FontName', 'sid', null]]);
	
	var CFFTopDict = new CFFDict([
	// key       name                   type(s)                                 default
	[[12, 30], 'ROS', ['sid', 'sid', 'number'], null], [0, 'version', 'sid', null], [1, 'Notice', 'sid', null], [[12, 0], 'Copyright', 'sid', null], [2, 'FullName', 'sid', null], [3, 'FamilyName', 'sid', null], [4, 'Weight', 'sid', null], [[12, 1], 'isFixedPitch', 'boolean', false], [[12, 2], 'ItalicAngle', 'number', 0], [[12, 3], 'UnderlinePosition', 'number', -100], [[12, 4], 'UnderlineThickness', 'number', 50], [[12, 5], 'PaintType', 'number', 0], [[12, 6], 'CharstringType', 'number', 2], [[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [13, 'UniqueID', 'number', null], [5, 'FontBBox', 'array', [0, 0, 0, 0]], [[12, 8], 'StrokeWidth', 'number', 0], [14, 'XUID', 'array', null], [15, 'charset', CFFCharset, ISOAdobeCharset], [16, 'Encoding', CFFEncoding, StandardEncoding], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [18, 'Private', new CFFPrivateOp(), null], [[12, 20], 'SyntheticBase', 'number', null], [[12, 21], 'PostScript', 'sid', null], [[12, 22], 'BaseFontName', 'sid', null], [[12, 23], 'BaseFontBlend', 'delta', null],
	
	// CID font specific
	[[12, 31], 'CIDFontVersion', 'number', 0], [[12, 32], 'CIDFontRevision', 'number', 0], [[12, 33], 'CIDFontType', 'number', 0], [[12, 34], 'CIDCount', 'number', 8720], [[12, 35], 'UIDBase', 'number', null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [[12, 38], 'FontName', 'sid', null]]);
	
	var VariationStore = new r.Struct({
	  length: r.uint16,
	  itemVariationStore: ItemVariationStore
	});
	
	var CFF2TopDict = new CFFDict([[[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [24, 'vstore', new CFFPointer(VariationStore), null], [25, 'maxstack', 'number', 193]]);
	
	var CFFTop = new r.VersionedStruct(r.fixed16, {
	  1: {
	    hdrSize: r.uint8,
	    offSize: r.uint8,
	    nameIndex: new CFFIndex(new r.String('length')),
	    topDictIndex: new CFFIndex(CFFTopDict),
	    stringIndex: new CFFIndex(new r.String('length')),
	    globalSubrIndex: new CFFIndex()
	  },
	
	  2: {
	    hdrSize: r.uint8,
	    length: r.uint16,
	    topDict: CFF2TopDict,
	    globalSubrIndex: new CFFIndex()
	  }
	});
	
	var CFFFont = function () {
	  function CFFFont(stream) {
	    _classCallCheck(this, CFFFont);
	
	    this.stream = stream;
	    this.decode();
	  }
	
	  CFFFont.decode = function decode(stream) {
	    return new CFFFont(stream);
	  };
	
	  CFFFont.prototype.decode = function decode() {
	    var start = this.stream.pos;
	    var top = CFFTop.decode(this.stream);
	    for (var key in top) {
	      var val = top[key];
	      this[key] = val;
	    }
	
	    if (this.version < 2) {
	      if (this.topDictIndex.length !== 1) {
	        throw new Error("Only a single font is allowed in CFF");
	      }
	
	      this.topDict = this.topDictIndex[0];
	    }
	
	    this.isCIDFont = this.topDict.ROS != null;
	    return this;
	  };
	
	  CFFFont.prototype.string = function string(sid) {
	    if (this.version >= 2) {
	      return null;
	    }
	
	    if (sid < standardStrings.length) {
	      return standardStrings[sid];
	    }
	
	    return this.stringIndex[sid - standardStrings.length];
	  };
	
	  CFFFont.prototype.getCharString = function getCharString(glyph) {
	    this.stream.pos = this.topDict.CharStrings[glyph].offset;
	    return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
	  };
	
	  CFFFont.prototype.getGlyphName = function getGlyphName(gid) {
	    // CFF2 glyph names are in the post table.
	    if (this.version >= 2) {
	      return null;
	    }
	
	    // CID-keyed fonts don't have glyph names
	    if (this.isCIDFont) {
	      return null;
	    }
	
	    var charset = this.topDict.charset;
	
	    if (Array.isArray(charset)) {
	      return charset[gid];
	    }
	
	    if (gid === 0) {
	      return '.notdef';
	    }
	
	    gid -= 1;
	
	    switch (charset.version) {
	      case 0:
	        return this.string(charset.glyphs[gid]);
	
	      case 1:
	      case 2:
	        for (var i = 0; i < charset.ranges.length; i++) {
	          var range = charset.ranges[i];
	          if (range.offset <= gid && gid <= range.offset + range.nLeft) {
	            return this.string(range.first + (gid - range.offset));
	          }
	        }
	        break;
	    }
	
	    return null;
	  };
	
	  CFFFont.prototype.fdForGlyph = function fdForGlyph(gid) {
	    if (!this.topDict.FDSelect) {
	      return null;
	    }
	
	    switch (this.topDict.FDSelect.version) {
	      case 0:
	        return this.topDict.FDSelect.fds[gid];
	
	      case 3:
	      case 4:
	        var ranges = this.topDict.FDSelect.ranges;
	
	        var low = 0;
	        var high = ranges.length - 1;
	
	        while (low <= high) {
	          var mid = low + high >> 1;
	
	          if (gid < ranges[mid].first) {
	            high = mid - 1;
	          } else if (mid < high && gid > ranges[mid + 1].first) {
	            low = mid + 1;
	          } else {
	            return ranges[mid].fd;
	          }
	        }
	      default:
	        throw new Error('Unknown FDSelect version: ' + this.topDict.FDSelect.version);
	    }
	  };
	
	  CFFFont.prototype.privateDictForGlyph = function privateDictForGlyph(gid) {
	    if (this.topDict.FDSelect) {
	      var fd = this.fdForGlyph(gid);
	      if (this.topDict.FDArray[fd]) {
	        return this.topDict.FDArray[fd].Private;
	      }
	
	      return null;
	    }
	
	    if (this.version < 2) {
	      return this.topDict.Private;
	    }
	
	    return this.topDict.FDArray[0].Private;
	  };
	
	  _createClass(CFFFont, [{
	    key: 'postscriptName',
	    get: function get() {
	      if (this.version < 2) {
	        return this.nameIndex[0];
	      }
	
	      return null;
	    }
	  }, {
	    key: 'fullName',
	    get: function get() {
	      return this.string(this.topDict.FullName);
	    }
	  }, {
	    key: 'familyName',
	    get: function get() {
	      return this.string(this.topDict.FamilyName);
	    }
	  }]);
	
	  return CFFFont;
	}();
	
	var VerticalOrigin = new r.Struct({
	  glyphIndex: r.uint16,
	  vertOriginY: r.int16
	});
	
	var VORG = new r.Struct({
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  defaultVertOriginY: r.int16,
	  numVertOriginYMetrics: r.uint16,
	  metrics: new r.Array(VerticalOrigin, 'numVertOriginYMetrics')
	});
	
	var BigMetrics = new r.Struct({
	  height: r.uint8,
	  width: r.uint8,
	  horiBearingX: r.int8,
	  horiBearingY: r.int8,
	  horiAdvance: r.uint8,
	  vertBearingX: r.int8,
	  vertBearingY: r.int8,
	  vertAdvance: r.uint8
	});
	
	var SmallMetrics = new r.Struct({
	  height: r.uint8,
	  width: r.uint8,
	  bearingX: r.int8,
	  bearingY: r.int8,
	  advance: r.uint8
	});
	
	var EBDTComponent = new r.Struct({
	  glyph: r.uint16,
	  xOffset: r.int8,
	  yOffset: r.int8
	});
	
	var ByteAligned = function ByteAligned() {
	  _classCallCheck(this, ByteAligned);
	};
	
	var BitAligned = function BitAligned() {
	  _classCallCheck(this, BitAligned);
	};
	
	var glyph = new r.VersionedStruct('version', {
	  1: {
	    metrics: SmallMetrics,
	    data: ByteAligned
	  },
	
	  2: {
	    metrics: SmallMetrics,
	    data: BitAligned
	  },
	
	  // format 3 is deprecated
	  // format 4 is not supported by Microsoft
	
	  5: {
	    data: BitAligned
	  },
	
	  6: {
	    metrics: BigMetrics,
	    data: ByteAligned
	  },
	
	  7: {
	    metrics: BigMetrics,
	    data: BitAligned
	  },
	
	  8: {
	    metrics: SmallMetrics,
	    pad: new r.Reserved(r.uint8),
	    numComponents: r.uint16,
	    components: new r.Array(EBDTComponent, 'numComponents')
	  },
	
	  9: {
	    metrics: BigMetrics,
	    pad: new r.Reserved(r.uint8),
	    numComponents: r.uint16,
	    components: new r.Array(EBDTComponent, 'numComponents')
	  },
	
	  17: {
	    metrics: SmallMetrics,
	    dataLen: r.uint32,
	    data: new r.Buffer('dataLen')
	  },
	
	  18: {
	    metrics: BigMetrics,
	    dataLen: r.uint32,
	    data: new r.Buffer('dataLen')
	  },
	
	  19: {
	    dataLen: r.uint32,
	    data: new r.Buffer('dataLen')
	  }
	});
	
	var SBitLineMetrics = new r.Struct({
	  ascender: r.int8,
	  descender: r.int8,
	  widthMax: r.uint8,
	  caretSlopeNumerator: r.int8,
	  caretSlopeDenominator: r.int8,
	  caretOffset: r.int8,
	  minOriginSB: r.int8,
	  minAdvanceSB: r.int8,
	  maxBeforeBL: r.int8,
	  minAfterBL: r.int8,
	  pad: new r.Reserved(r.int8, 2)
	});
	
	var CodeOffsetPair = new r.Struct({
	  glyphCode: r.uint16,
	  offset: r.uint16
	});
	
	var IndexSubtable = new r.VersionedStruct(r.uint16, {
	  header: {
	    imageFormat: r.uint16,
	    imageDataOffset: r.uint32
	  },
	
	  1: {
	    offsetArray: new r.Array(r.uint32, function (t) {
	      return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
	    })
	  },
	
	  2: {
	    imageSize: r.uint32,
	    bigMetrics: BigMetrics
	  },
	
	  3: {
	    offsetArray: new r.Array(r.uint16, function (t) {
	      return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
	    })
	  },
	
	  4: {
	    numGlyphs: r.uint32,
	    glyphArray: new r.Array(CodeOffsetPair, function (t) {
	      return t.numGlyphs + 1;
	    })
	  },
	
	  5: {
	    imageSize: r.uint32,
	    bigMetrics: BigMetrics,
	    numGlyphs: r.uint32,
	    glyphCodeArray: new r.Array(r.uint16, 'numGlyphs')
	  }
	});
	
	var IndexSubtableArray = new r.Struct({
	  firstGlyphIndex: r.uint16,
	  lastGlyphIndex: r.uint16,
	  subtable: new r.Pointer(r.uint32, IndexSubtable)
	});
	
	var BitmapSizeTable = new r.Struct({
	  indexSubTableArray: new r.Pointer(r.uint32, new r.Array(IndexSubtableArray, 1), { type: 'parent' }),
	  indexTablesSize: r.uint32,
	  numberOfIndexSubTables: r.uint32,
	  colorRef: r.uint32,
	  hori: SBitLineMetrics,
	  vert: SBitLineMetrics,
	  startGlyphIndex: r.uint16,
	  endGlyphIndex: r.uint16,
	  ppemX: r.uint8,
	  ppemY: r.uint8,
	  bitDepth: r.uint8,
	  flags: new r.Bitfield(r.uint8, ['horizontal', 'vertical'])
	});
	
	var EBLC = new r.Struct({
	  version: r.uint32, // 0x00020000
	  numSizes: r.uint32,
	  sizes: new r.Array(BitmapSizeTable, 'numSizes')
	});
	
	var ImageTable = new r.Struct({
	  ppem: r.uint16,
	  resolution: r.uint16,
	  imageOffsets: new r.Array(new r.Pointer(r.uint32, 'void'), function (t) {
	    return t.parent.parent.maxp.numGlyphs + 1;
	  })
	});
	
	// This is the Apple sbix table, used by the "Apple Color Emoji" font.
	// It includes several image tables with images for each bitmap glyph
	// of several different sizes.
	var sbix = new r.Struct({
	  version: r.uint16,
	  flags: new r.Bitfield(r.uint16, ['renderOutlines']),
	  numImgTables: r.uint32,
	  imageTables: new r.Array(new r.Pointer(r.uint32, ImageTable), 'numImgTables')
	});
	
	var LayerRecord = new r.Struct({
	  gid: r.uint16, // Glyph ID of layer glyph (must be in z-order from bottom to top).
	  paletteIndex: r.uint16 // Index value to use in the appropriate palette. This value must
	}); // be less than numPaletteEntries in the CPAL table, except for
	// the special case noted below. Each palette entry is 16 bits.
	// A palette index of 0xFFFF is a special case indicating that
	// the text foreground color should be used.
	
	var BaseGlyphRecord = new r.Struct({
	  gid: r.uint16, // Glyph ID of reference glyph. This glyph is for reference only
	  // and is not rendered for color.
	  firstLayerIndex: r.uint16, // Index (from beginning of the Layer Records) to the layer record.
	  // There will be numLayers consecutive entries for this base glyph.
	  numLayers: r.uint16
	});
	
	var COLR = new r.Struct({
	  version: r.uint16,
	  numBaseGlyphRecords: r.uint16,
	  baseGlyphRecord: new r.Pointer(r.uint32, new r.Array(BaseGlyphRecord, 'numBaseGlyphRecords')),
	  layerRecords: new r.Pointer(r.uint32, new r.Array(LayerRecord, 'numLayerRecords'), { lazy: true }),
	  numLayerRecords: r.uint16
	});
	
	var ColorRecord = new r.Struct({
	  blue: r.uint8,
	  green: r.uint8,
	  red: r.uint8,
	  alpha: r.uint8
	});
	
	var CPAL = new r.VersionedStruct(r.uint16, {
	  header: {
	    numPaletteEntries: r.uint16,
	    numPalettes: r.uint16,
	    numColorRecords: r.uint16,
	    colorRecords: new r.Pointer(r.uint32, new r.Array(ColorRecord, 'numColorRecords')),
	    colorRecordIndices: new r.Array(r.uint16, 'numPalettes')
	  },
	  0: {},
	  1: {
	    offsetPaletteTypeArray: new r.Pointer(r.uint32, new r.Array(r.uint32, 'numPalettes')),
	    offsetPaletteLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPalettes')),
	    offsetPaletteEntryLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPaletteEntries'))
	  }
	});
	
	var BaseCoord = new r.VersionedStruct(r.uint16, {
	  1: { // Design units only
	    coordinate: r.int16 // X or Y value, in design units
	  },
	
	  2: { // Design units plus contour point
	    coordinate: r.int16, // X or Y value, in design units
	    referenceGlyph: r.uint16, // GlyphID of control glyph
	    baseCoordPoint: r.uint16 // Index of contour point on the referenceGlyph
	  },
	
	  3: { // Design units plus Device table
	    coordinate: r.int16, // X or Y value, in design units
	    deviceTable: new r.Pointer(r.uint16, Device) // Device table for X or Y value
	  }
	});
	
	var BaseValues = new r.Struct({
	  defaultIndex: r.uint16, // Index of default baseline for this script-same index in the BaseTagList
	  baseCoordCount: r.uint16,
	  baseCoords: new r.Array(new r.Pointer(r.uint16, BaseCoord), 'baseCoordCount')
	});
	
	var FeatMinMaxRecord = new r.Struct({
	  tag: new r.String(4), // 4-byte feature identification tag-must match FeatureTag in FeatureList
	  minCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' }), // May be NULL
	  maxCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' }) // May be NULL
	});
	
	var MinMax = new r.Struct({
	  minCoord: new r.Pointer(r.uint16, BaseCoord), // May be NULL
	  maxCoord: new r.Pointer(r.uint16, BaseCoord), // May be NULL
	  featMinMaxCount: r.uint16, // May be 0
	  featMinMaxRecords: new r.Array(FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
	});
	
	var BaseLangSysRecord = new r.Struct({
	  tag: new r.String(4), // 4-byte language system identification tag
	  minMax: new r.Pointer(r.uint16, MinMax, { type: 'parent' })
	});
	
	var BaseScript = new r.Struct({
	  baseValues: new r.Pointer(r.uint16, BaseValues), // May be NULL
	  defaultMinMax: new r.Pointer(r.uint16, MinMax), // May be NULL
	  baseLangSysCount: r.uint16, // May be 0
	  baseLangSysRecords: new r.Array(BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
	});
	
	var BaseScriptRecord = new r.Struct({
	  tag: new r.String(4), // 4-byte script identification tag
	  script: new r.Pointer(r.uint16, BaseScript, { type: 'parent' })
	});
	
	var BaseScriptList = new r.Array(BaseScriptRecord, r.uint16);
	
	// Array of 4-byte baseline identification tags-must be in alphabetical order
	var BaseTagList = new r.Array(new r.String(4), r.uint16);
	
	var Axis = new r.Struct({
	  baseTagList: new r.Pointer(r.uint16, BaseTagList), // May be NULL
	  baseScriptList: new r.Pointer(r.uint16, BaseScriptList)
	});
	
	var BASE = new r.VersionedStruct(r.uint32, {
	  header: {
	    horizAxis: new r.Pointer(r.uint16, Axis), // May be NULL
	    vertAxis: new r.Pointer(r.uint16, Axis) // May be NULL
	  },
	
	  0x00010000: {},
	  0x00010001: {
	    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
	  }
	});
	
	var AttachPoint = new r.Array(r.uint16, r.uint16);
	var AttachList = new r.Struct({
	  coverage: new r.Pointer(r.uint16, Coverage),
	  glyphCount: r.uint16,
	  attachPoints: new r.Array(new r.Pointer(r.uint16, AttachPoint), 'glyphCount')
	});
	
	var CaretValue = new r.VersionedStruct(r.uint16, {
	  1: { // Design units only
	    coordinate: r.int16
	  },
	
	  2: { // Contour point
	    caretValuePoint: r.uint16
	  },
	
	  3: { // Design units plus Device table
	    coordinate: r.int16,
	    deviceTable: new r.Pointer(r.uint16, Device)
	  }
	});
	
	var LigGlyph = new r.Array(new r.Pointer(r.uint16, CaretValue), r.uint16);
	
	var LigCaretList = new r.Struct({
	  coverage: new r.Pointer(r.uint16, Coverage),
	  ligGlyphCount: r.uint16,
	  ligGlyphs: new r.Array(new r.Pointer(r.uint16, LigGlyph), 'ligGlyphCount')
	});
	
	var MarkGlyphSetsDef = new r.Struct({
	  markSetTableFormat: r.uint16,
	  markSetCount: r.uint16,
	  coverage: new r.Array(new r.Pointer(r.uint32, Coverage), 'markSetCount')
	});
	
	var GDEF = new r.VersionedStruct(r.uint32, {
	  header: {
	    glyphClassDef: new r.Pointer(r.uint16, ClassDef),
	    attachList: new r.Pointer(r.uint16, AttachList),
	    ligCaretList: new r.Pointer(r.uint16, LigCaretList),
	    markAttachClassDef: new r.Pointer(r.uint16, ClassDef)
	  },
	
	  0x00010000: {},
	  0x00010002: {
	    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef)
	  },
	  0x00010003: {
	    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
	    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
	  }
	});
	
	var ValueFormat = new r.Bitfield(r.uint16, ['xPlacement', 'yPlacement', 'xAdvance', 'yAdvance', 'xPlaDevice', 'yPlaDevice', 'xAdvDevice', 'yAdvDevice']);
	
	var types = {
	  xPlacement: r.int16,
	  yPlacement: r.int16,
	  xAdvance: r.int16,
	  yAdvance: r.int16,
	  xPlaDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
	  yPlaDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
	  xAdvDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
	  yAdvDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' })
	};
	
	var ValueRecord = function () {
	  function ValueRecord() {
	    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valueFormat';
	
	    _classCallCheck(this, ValueRecord);
	
	    this.key = key;
	  }
	
	  ValueRecord.prototype.buildStruct = function buildStruct(parent) {
	    var struct = parent;
	    while (!struct[this.key] && struct.parent) {
	      struct = struct.parent;
	    }
	
	    if (!struct[this.key]) return;
	
	    var fields = {};
	    fields.rel = function () {
	      return struct._startOffset;
	    };
	
	    var format = struct[this.key];
	    for (var key in format) {
	      if (format[key]) {
	        fields[key] = types[key];
	      }
	    }
	
	    return new r.Struct(fields);
	  };
	
	  ValueRecord.prototype.size = function size(val, ctx) {
	    return this.buildStruct(ctx).size(val, ctx);
	  };
	
	  ValueRecord.prototype.decode = function decode(stream, parent) {
	    var res = this.buildStruct(parent).decode(stream, parent);
	    delete res.rel;
	    return res;
	  };
	
	  return ValueRecord;
	}();
	
	var PairValueRecord = new r.Struct({
	  secondGlyph: r.uint16,
	  value1: new ValueRecord('valueFormat1'),
	  value2: new ValueRecord('valueFormat2')
	});
	
	var PairSet = new r.Array(PairValueRecord, r.uint16);
	
	var Class2Record = new r.Struct({
	  value1: new ValueRecord('valueFormat1'),
	  value2: new ValueRecord('valueFormat2')
	});
	
	var Anchor = new r.VersionedStruct(r.uint16, {
	  1: { // Design units only
	    xCoordinate: r.int16,
	    yCoordinate: r.int16
	  },
	
	  2: { // Design units plus contour point
	    xCoordinate: r.int16,
	    yCoordinate: r.int16,
	    anchorPoint: r.uint16
	  },
	
	  3: { // Design units plus Device tables
	    xCoordinate: r.int16,
	    yCoordinate: r.int16,
	    xDeviceTable: new r.Pointer(r.uint16, Device),
	    yDeviceTable: new r.Pointer(r.uint16, Device)
	  }
	});
	
	var EntryExitRecord = new r.Struct({
	  entryAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' }),
	  exitAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
	});
	
	var MarkRecord = new r.Struct({
	  class: r.uint16,
	  markAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
	});
	
	var MarkArray = new r.Array(MarkRecord, r.uint16);
	
	var BaseRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
	  return t.parent.classCount;
	});
	var BaseArray = new r.Array(BaseRecord, r.uint16);
	
	var ComponentRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
	  return t.parent.parent.classCount;
	});
	var LigatureAttach = new r.Array(ComponentRecord, r.uint16);
	var LigatureArray = new r.Array(new r.Pointer(r.uint16, LigatureAttach), r.uint16);
	
	var GPOSLookup = new r.VersionedStruct('lookupType', {
	  1: new r.VersionedStruct(r.uint16, { // Single Adjustment
	    1: { // Single positioning value
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat: ValueFormat,
	      value: new ValueRecord()
	    },
	    2: {
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat: ValueFormat,
	      valueCount: r.uint16,
	      values: new r.LazyArray(new ValueRecord(), 'valueCount')
	    }
	  }),
	
	  2: new r.VersionedStruct(r.uint16, { // Pair Adjustment Positioning
	    1: { // Adjustments for glyph pairs
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat1: ValueFormat,
	      valueFormat2: ValueFormat,
	      pairSetCount: r.uint16,
	      pairSets: new r.LazyArray(new r.Pointer(r.uint16, PairSet), 'pairSetCount')
	    },
	
	    2: { // Class pair adjustment
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat1: ValueFormat,
	      valueFormat2: ValueFormat,
	      classDef1: new r.Pointer(r.uint16, ClassDef),
	      classDef2: new r.Pointer(r.uint16, ClassDef),
	      class1Count: r.uint16,
	      class2Count: r.uint16,
	      classRecords: new r.LazyArray(new r.LazyArray(Class2Record, 'class2Count'), 'class1Count')
	    }
	  }),
	
	  3: { // Cursive Attachment Positioning
	    format: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    entryExitCount: r.uint16,
	    entryExitRecords: new r.Array(EntryExitRecord, 'entryExitCount')
	  },
	
	  4: { // MarkToBase Attachment Positioning
	    format: r.uint16,
	    markCoverage: new r.Pointer(r.uint16, Coverage),
	    baseCoverage: new r.Pointer(r.uint16, Coverage),
	    classCount: r.uint16,
	    markArray: new r.Pointer(r.uint16, MarkArray),
	    baseArray: new r.Pointer(r.uint16, BaseArray)
	  },
	
	  5: { // MarkToLigature Attachment Positioning
	    format: r.uint16,
	    markCoverage: new r.Pointer(r.uint16, Coverage),
	    ligatureCoverage: new r.Pointer(r.uint16, Coverage),
	    classCount: r.uint16,
	    markArray: new r.Pointer(r.uint16, MarkArray),
	    ligatureArray: new r.Pointer(r.uint16, LigatureArray)
	  },
	
	  6: { // MarkToMark Attachment Positioning
	    format: r.uint16,
	    mark1Coverage: new r.Pointer(r.uint16, Coverage),
	    mark2Coverage: new r.Pointer(r.uint16, Coverage),
	    classCount: r.uint16,
	    mark1Array: new r.Pointer(r.uint16, MarkArray),
	    mark2Array: new r.Pointer(r.uint16, BaseArray)
	  },
	
	  7: Context, // Contextual positioning
	  8: ChainingContext, // Chaining contextual positioning
	
	  9: { // Extension Positioning
	    posFormat: r.uint16,
	    lookupType: r.uint16, // cannot also be 9
	    extension: new r.Pointer(r.uint32, GPOSLookup)
	  }
	});
	
	// Fix circular reference
	GPOSLookup.versions[9].extension.type = GPOSLookup;
	
	var GPOS = new r.VersionedStruct(r.uint32, {
	  header: {
	    scriptList: new r.Pointer(r.uint16, ScriptList),
	    featureList: new r.Pointer(r.uint16, FeatureList),
	    lookupList: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
	  },
	
	  0x00010000: {},
	  0x00010001: {
	    featureVariations: new r.Pointer(r.uint32, FeatureVariations)
	  }
	});
	
	var Sequence = new r.Array(r.uint16, r.uint16);
	var AlternateSet = Sequence;
	
	var Ligature = new r.Struct({
	  glyph: r.uint16,
	  compCount: r.uint16,
	  components: new r.Array(r.uint16, function (t) {
	    return t.compCount - 1;
	  })
	});
	
	var LigatureSet = new r.Array(new r.Pointer(r.uint16, Ligature), r.uint16);
	
	var GSUBLookup = new r.VersionedStruct('lookupType', {
	  1: new r.VersionedStruct(r.uint16, { // Single Substitution
	    1: {
	      coverage: new r.Pointer(r.uint16, Coverage),
	      deltaGlyphID: r.int16
	    },
	    2: {
	      coverage: new r.Pointer(r.uint16, Coverage),
	      glyphCount: r.uint16,
	      substitute: new r.LazyArray(r.uint16, 'glyphCount')
	    }
	  }),
	
	  2: { // Multiple Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    count: r.uint16,
	    sequences: new r.LazyArray(new r.Pointer(r.uint16, Sequence), 'count')
	  },
	
	  3: { // Alternate Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    count: r.uint16,
	    alternateSet: new r.LazyArray(new r.Pointer(r.uint16, AlternateSet), 'count')
	  },
	
	  4: { // Ligature Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    count: r.uint16,
	    ligatureSets: new r.LazyArray(new r.Pointer(r.uint16, LigatureSet), 'count')
	  },
	
	  5: Context, // Contextual Substitution
	  6: ChainingContext, // Chaining Contextual Substitution
	
	  7: { // Extension Substitution
	    substFormat: r.uint16,
	    lookupType: r.uint16, // cannot also be 7
	    extension: new r.Pointer(r.uint32, GSUBLookup)
	  },
	
	  8: { // Reverse Chaining Contextual Single Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
	    lookaheadGlyphCount: r.uint16,
	    lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
	    glyphCount: r.uint16,
	    substitutes: new r.Array(r.uint16, 'glyphCount')
	  }
	});
	
	// Fix circular reference
	GSUBLookup.versions[7].extension.type = GSUBLookup;
	
	var GSUB = new r.VersionedStruct(r.uint32, {
	  header: {
	    scriptList: new r.Pointer(r.uint16, ScriptList),
	    featureList: new r.Pointer(r.uint16, FeatureList),
	    lookupList: new r.Pointer(r.uint16, new LookupList(GSUBLookup))
	  },
	
	  0x00010000: {},
	  0x00010001: {
	    featureVariations: new r.Pointer(r.uint32, FeatureVariations)
	  }
	});
	
	var JstfGSUBModList = new r.Array(r.uint16, r.uint16);
	
	var JstfPriority = new r.Struct({
	  shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
	  extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
	});
	
	var JstfLangSys = new r.Array(new r.Pointer(r.uint16, JstfPriority), r.uint16);
	
	var JstfLangSysRecord = new r.Struct({
	  tag: new r.String(4),
	  jstfLangSys: new r.Pointer(r.uint16, JstfLangSys)
	});
	
	var JstfScript = new r.Struct({
	  extenderGlyphs: new r.Pointer(r.uint16, new r.Array(r.uint16, r.uint16)), // array of glyphs to extend line length
	  defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
	  langSysCount: r.uint16,
	  langSysRecords: new r.Array(JstfLangSysRecord, 'langSysCount')
	});
	
	var JstfScriptRecord = new r.Struct({
	  tag: new r.String(4),
	  script: new r.Pointer(r.uint16, JstfScript, { type: 'parent' })
	});
	
	var JSTF = new r.Struct({
	  version: r.uint32, // should be 0x00010000
	  scriptCount: r.uint16,
	  scriptList: new r.Array(JstfScriptRecord, 'scriptCount')
	});
	
	// TODO: add this to restructure
	
	var VariableSizeNumber = function () {
	  function VariableSizeNumber(size) {
	    _classCallCheck(this, VariableSizeNumber);
	
	    this._size = size;
	  }
	
	  VariableSizeNumber.prototype.decode = function decode(stream, parent) {
	    switch (this.size(0, parent)) {
	      case 1:
	        return stream.readUInt8();
	      case 2:
	        return stream.readUInt16BE();
	      case 3:
	        return stream.readUInt24BE();
	      case 4:
	        return stream.readUInt32BE();
	    }
	  };
	
	  VariableSizeNumber.prototype.size = function size(val, parent) {
	    return restructure_src_utils.resolveLength(this._size, null, parent);
	  };
	
	  return VariableSizeNumber;
	}();
	
	var MapDataEntry = new r.Struct({
	  entry: new VariableSizeNumber(function (t) {
	    return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
	  }),
	  outerIndex: function outerIndex(t) {
	    return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
	  },
	  innerIndex: function innerIndex(t) {
	    return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
	  }
	});
	
	var DeltaSetIndexMap = new r.Struct({
	  entryFormat: r.uint16,
	  mapCount: r.uint16,
	  mapData: new r.Array(MapDataEntry, 'mapCount')
	});
	
	var HVAR = new r.Struct({
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
	  advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
	  LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
	  RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap)
	});
	
	var Signature = new r.Struct({
	  format: r.uint32,
	  length: r.uint32,
	  offset: r.uint32
	});
	
	var SignatureBlock = new r.Struct({
	  reserved: new r.Reserved(r.uint16, 2),
	  cbSignature: r.uint32, // Length (in bytes) of the PKCS#7 packet in pbSignature
	  signature: new r.Buffer('cbSignature')
	});
	
	var DSIG = new r.Struct({
	  ulVersion: r.uint32, // Version number of the DSIG table (0x00000001)
	  usNumSigs: r.uint16, // Number of signatures in the table
	  usFlag: r.uint16, // Permission flags
	  signatures: new r.Array(Signature, 'usNumSigs'),
	  signatureBlocks: new r.Array(SignatureBlock, 'usNumSigs')
	});
	
	var GaspRange = new r.Struct({
	  rangeMaxPPEM: r.uint16, // Upper limit of range, in ppem
	  rangeGaspBehavior: new r.Bitfield(r.uint16, [// Flags describing desired rasterizer behavior
	  'grayscale', 'gridfit', 'symmetricSmoothing', 'symmetricGridfit' // only in version 1, for ClearType
	  ])
	});
	
	var gasp = new r.Struct({
	  version: r.uint16, // set to 0
	  numRanges: r.uint16,
	  gaspRanges: new r.Array(GaspRange, 'numRanges') // Sorted by ppem
	});
	
	var DeviceRecord = new r.Struct({
	  pixelSize: r.uint8,
	  maximumWidth: r.uint8,
	  widths: new r.Array(r.uint8, function (t) {
	    return t.parent.parent.maxp.numGlyphs;
	  })
	});
	
	// The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
	var hdmx = new r.Struct({
	  version: r.uint16,
	  numRecords: r.int16,
	  sizeDeviceRecord: r.int32,
	  records: new r.Array(DeviceRecord, 'numRecords')
	});
	
	var KernPair = new r.Struct({
	  left: r.uint16,
	  right: r.uint16,
	  value: r.int16
	});
	
	var ClassTable = new r.Struct({
	  firstGlyph: r.uint16,
	  nGlyphs: r.uint16,
	  offsets: new r.Array(r.uint16, 'nGlyphs'),
	  max: function max(t) {
	    return t.offsets.length && Math.max.apply(Math, t.offsets);
	  }
	});
	
	var Kern2Array = new r.Struct({
	  off: function off(t) {
	    return t._startOffset - t.parent.parent._startOffset;
	  },
	  len: function len(t) {
	    return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
	  },
	  values: new r.LazyArray(r.int16, 'len')
	});
	
	var KernSubtable = new r.VersionedStruct('format', {
	  0: {
	    nPairs: r.uint16,
	    searchRange: r.uint16,
	    entrySelector: r.uint16,
	    rangeShift: r.uint16,
	    pairs: new r.Array(KernPair, 'nPairs')
	  },
	
	  2: {
	    rowWidth: r.uint16,
	    leftTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
	    rightTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
	    array: new r.Pointer(r.uint16, Kern2Array, { type: 'parent' })
	  },
	
	  3: {
	    glyphCount: r.uint16,
	    kernValueCount: r.uint8,
	    leftClassCount: r.uint8,
	    rightClassCount: r.uint8,
	    flags: r.uint8,
	    kernValue: new r.Array(r.int16, 'kernValueCount'),
	    leftClass: new r.Array(r.uint8, 'glyphCount'),
	    rightClass: new r.Array(r.uint8, 'glyphCount'),
	    kernIndex: new r.Array(r.uint8, function (t) {
	      return t.leftClassCount * t.rightClassCount;
	    })
	  }
	});
	
	var KernTable = new r.VersionedStruct('version', {
	  0: { // Microsoft uses this format
	    subVersion: r.uint16, // Microsoft has an extra sub-table version number
	    length: r.uint16, // Length of the subtable, in bytes
	    format: r.uint8, // Format of subtable
	    coverage: new r.Bitfield(r.uint8, ['horizontal', // 1 if table has horizontal data, 0 if vertical
	    'minimum', // If set to 1, the table has minimum values. If set to 0, the table has kerning values.
	    'crossStream', // If set to 1, kerning is perpendicular to the flow of the text
	    'override' // If set to 1 the value in this table replaces the accumulated value
	    ]),
	    subtable: KernSubtable,
	    padding: new r.Reserved(r.uint8, function (t) {
	      return t.length - t._currentOffset;
	    })
	  },
	  1: { // Apple uses this format
	    length: r.uint32,
	    coverage: new r.Bitfield(r.uint8, [null, null, null, null, null, 'variation', // Set if table has variation kerning values
	    'crossStream', // Set if table has cross-stream kerning values
	    'vertical' // Set if table has vertical kerning values
	    ]),
	    format: r.uint8,
	    tupleIndex: r.uint16,
	    subtable: KernSubtable,
	    padding: new r.Reserved(r.uint8, function (t) {
	      return t.length - t._currentOffset;
	    })
	  }
	});
	
	var kern = new r.VersionedStruct(r.uint16, {
	  0: { // Microsoft Version
	    nTables: r.uint16,
	    tables: new r.Array(KernTable, 'nTables')
	  },
	
	  1: { // Apple Version
	    reserved: new r.Reserved(r.uint16), // the other half of the version number
	    nTables: r.uint32,
	    tables: new r.Array(KernTable, 'nTables')
	  }
	});
	
	// Linear Threshold table
	// Records the ppem for each glyph at which the scaling becomes linear again,
	// despite instructions effecting the advance width
	var LTSH = new r.Struct({
	  version: r.uint16,
	  numGlyphs: r.uint16,
	  yPels: new r.Array(r.uint8, 'numGlyphs')
	});
	
	// PCL 5 Table
	// NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
	var PCLT = new r.Struct({
	  version: r.uint16,
	  fontNumber: r.uint32,
	  pitch: r.uint16,
	  xHeight: r.uint16,
	  style: r.uint16,
	  typeFamily: r.uint16,
	  capHeight: r.uint16,
	  symbolSet: r.uint16,
	  typeface: new r.String(16),
	  characterComplement: new r.String(8),
	  fileName: new r.String(6),
	  strokeWeight: new r.String(1),
	  widthType: new r.String(1),
	  serifStyle: r.uint8,
	  reserved: new r.Reserved(r.uint8)
	});
	
	// VDMX tables contain ascender/descender overrides for certain (usually small)
	// sizes. This is needed in order to match font metrics on Windows.
	
	var Ratio = new r.Struct({
	  bCharSet: r.uint8, // Character set
	  xRatio: r.uint8, // Value to use for x-Ratio
	  yStartRatio: r.uint8, // Starting y-Ratio value
	  yEndRatio: r.uint8 // Ending y-Ratio value
	});
	
	var vTable = new r.Struct({
	  yPelHeight: r.uint16, // yPelHeight to which values apply
	  yMax: r.int16, // Maximum value (in pels) for this yPelHeight
	  yMin: r.int16 // Minimum value (in pels) for this yPelHeight
	});
	
	var VdmxGroup = new r.Struct({
	  recs: r.uint16, // Number of height records in this group
	  startsz: r.uint8, // Starting yPelHeight
	  endsz: r.uint8, // Ending yPelHeight
	  entries: new r.Array(vTable, 'recs') // The VDMX records
	});
	
	var VDMX = new r.Struct({
	  version: r.uint16, // Version number (0 or 1)
	  numRecs: r.uint16, // Number of VDMX groups present
	  numRatios: r.uint16, // Number of aspect ratio groupings
	  ratioRanges: new r.Array(Ratio, 'numRatios'), // Ratio ranges
	  offsets: new r.Array(r.uint16, 'numRatios'), // Offset to the VDMX group for this ratio range
	  groups: new r.Array(VdmxGroup, 'numRecs') // The actual VDMX groupings
	});
	
	// Vertical Header Table
	var vhea = new r.Struct({
	  version: r.uint16, // Version number of the Vertical Header Table
	  ascent: r.int16, // The vertical typographic ascender for this font
	  descent: r.int16, // The vertical typographic descender for this font
	  lineGap: r.int16, // The vertical typographic line gap for this font
	  advanceHeightMax: r.int16, // The maximum advance height measurement found in the font
	  minTopSideBearing: r.int16, // The minimum top side bearing measurement found in the font
	  minBottomSideBearing: r.int16, // The minimum bottom side bearing measurement found in the font
	  yMaxExtent: r.int16,
	  caretSlopeRise: r.int16, // Caret slope (rise/run)
	  caretSlopeRun: r.int16,
	  caretOffset: r.int16, // Set value equal to 0 for nonslanted fonts
	  reserved: new r.Reserved(r.int16, 4),
	  metricDataFormat: r.int16, // Set to 0
	  numberOfMetrics: r.uint16 // Number of advance heights in the Vertical Metrics table
	});
	
	var VmtxEntry = new r.Struct({
	  advance: r.uint16, // The advance height of the glyph
	  bearing: r.int16 // The top sidebearing of the glyph
	});
	
	// Vertical Metrics Table
	var vmtx = new r.Struct({
	  metrics: new r.LazyArray(VmtxEntry, function (t) {
	    return t.parent.vhea.numberOfMetrics;
	  }),
	  bearings: new r.LazyArray(r.int16, function (t) {
	    return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
	  })
	});
	
	var shortFrac = new r.Fixed(16, 'BE', 14);
	
	var Correspondence = new r.Struct({
	  fromCoord: shortFrac,
	  toCoord: shortFrac
	});
	
	var Segment = new r.Struct({
	  pairCount: r.uint16,
	  correspondence: new r.Array(Correspondence, 'pairCount')
	});
	
	var avar = new r.Struct({
	  version: r.fixed32,
	  axisCount: r.uint32,
	  segment: new r.Array(Segment, 'axisCount')
	});
	
	var UnboundedArrayAccessor = function () {
	  function UnboundedArrayAccessor(type, stream, parent) {
	    _classCallCheck(this, UnboundedArrayAccessor);
	
	    this.type = type;
	    this.stream = stream;
	    this.parent = parent;
	    this.base = this.stream.pos;
	    this._items = [];
	  }
	
	  UnboundedArrayAccessor.prototype.getItem = function getItem(index) {
	    if (this._items[index] == null) {
	      var pos = this.stream.pos;
	      this.stream.pos = this.base + this.type.size(null, this.parent) * index;
	      this._items[index] = this.type.decode(this.stream, this.parent);
	      this.stream.pos = pos;
	    }
	
	    return this._items[index];
	  };
	
	  UnboundedArrayAccessor.prototype.inspect = function inspect() {
	    return '[UnboundedArray ' + this.type.constructor.name + ']';
	  };
	
	  return UnboundedArrayAccessor;
	}();
	
	var UnboundedArray = function (_r$Array) {
	  _inherits(UnboundedArray, _r$Array);
	
	  function UnboundedArray(type) {
	    _classCallCheck(this, UnboundedArray);
	
	    return _possibleConstructorReturn(this, _r$Array.call(this, type, 0));
	  }
	
	  UnboundedArray.prototype.decode = function decode(stream, parent) {
	    return new UnboundedArrayAccessor(this.type, stream, parent);
	  };
	
	  return UnboundedArray;
	}(r.Array);
	
	var LookupTable = function LookupTable() {
	  var ValueType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : r.uint16;
	
	  // Helper class that makes internal structures invisible to pointers
	  var Shadow = function () {
	    function Shadow(type) {
	      _classCallCheck(this, Shadow);
	
	      this.type = type;
	    }
	
	    Shadow.prototype.decode = function decode(stream, ctx) {
	      ctx = ctx.parent.parent;
	      return this.type.decode(stream, ctx);
	    };
	
	    Shadow.prototype.size = function size(val, ctx) {
	      ctx = ctx.parent.parent;
	      return this.type.size(val, ctx);
	    };
	
	    Shadow.prototype.encode = function encode(stream, val, ctx) {
	      ctx = ctx.parent.parent;
	      return this.type.encode(stream, val, ctx);
	    };
	
	    return Shadow;
	  }();
	
	  ValueType = new Shadow(ValueType);
	
	  var BinarySearchHeader = new r.Struct({
	    unitSize: r.uint16,
	    nUnits: r.uint16,
	    searchRange: r.uint16,
	    entrySelector: r.uint16,
	    rangeShift: r.uint16
	  });
	
	  var LookupSegmentSingle = new r.Struct({
	    lastGlyph: r.uint16,
	    firstGlyph: r.uint16,
	    value: ValueType
	  });
	
	  var LookupSegmentArray = new r.Struct({
	    lastGlyph: r.uint16,
	    firstGlyph: r.uint16,
	    values: new r.Pointer(r.uint16, new r.Array(ValueType, function (t) {
	      return t.lastGlyph - t.firstGlyph + 1;
	    }), { type: 'parent' })
	  });
	
	  var LookupSingle = new r.Struct({
	    glyph: r.uint16,
	    value: ValueType
	  });
	
	  return new r.VersionedStruct(r.uint16, {
	    0: {
	      values: new UnboundedArray(ValueType) // length == number of glyphs maybe?
	    },
	    2: {
	      binarySearchHeader: BinarySearchHeader,
	      segments: new r.Array(LookupSegmentSingle, function (t) {
	        return t.binarySearchHeader.nUnits;
	      })
	    },
	    4: {
	      binarySearchHeader: BinarySearchHeader,
	      segments: new r.Array(LookupSegmentArray, function (t) {
	        return t.binarySearchHeader.nUnits;
	      })
	    },
	    6: {
	      binarySearchHeader: BinarySearchHeader,
	      segments: new r.Array(LookupSingle, function (t) {
	        return t.binarySearchHeader.nUnits;
	      })
	    },
	    8: {
	      firstGlyph: r.uint16,
	      count: r.uint16,
	      values: new r.Array(ValueType, 'count')
	    }
	  });
	};
	
	function StateTable() {
	  var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;
	
	  var entry = _Object$assign({
	    newState: r.uint16,
	    flags: r.uint16
	  }, entryData);
	
	  var Entry = new r.Struct(entry);
	  var StateArray = new UnboundedArray(new r.Array(r.uint16, function (t) {
	    return t.nClasses;
	  }));
	
	  var StateHeader = new r.Struct({
	    nClasses: r.uint32,
	    classTable: new r.Pointer(r.uint32, new LookupTable(lookupType)),
	    stateArray: new r.Pointer(r.uint32, StateArray),
	    entryTable: new r.Pointer(r.uint32, new UnboundedArray(Entry))
	  });
	
	  return StateHeader;
	}
	
	// This is the old version of the StateTable structure
	function StateTable1() {
	  var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;
	
	  var ClassLookupTable = new r.Struct({
	    version: function version() {
	      return 8;
	    },
	    // simulate LookupTable
	    firstGlyph: r.uint16,
	    values: new r.Array(r.uint8, r.uint16)
	  });
	
	  var entry = _Object$assign({
	    newStateOffset: r.uint16,
	    // convert offset to stateArray index
	    newState: function newState(t) {
	      return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
	    },
	    flags: r.uint16
	  }, entryData);
	
	  var Entry = new r.Struct(entry);
	  var StateArray = new UnboundedArray(new r.Array(r.uint8, function (t) {
	    return t.nClasses;
	  }));
	
	  var StateHeader1 = new r.Struct({
	    nClasses: r.uint16,
	    classTable: new r.Pointer(r.uint16, ClassLookupTable),
	    stateArray: new r.Pointer(r.uint16, StateArray),
	    entryTable: new r.Pointer(r.uint16, new UnboundedArray(Entry))
	  });
	
	  return StateHeader1;
	}
	
	var BslnSubtable = new r.VersionedStruct('format', {
	  0: { // Distance-based, no mapping
	    deltas: new r.Array(r.int16, 32)
	  },
	
	  1: { // Distance-based, with mapping
	    deltas: new r.Array(r.int16, 32),
	    mappingData: new LookupTable(r.uint16)
	  },
	
	  2: { // Control point-based, no mapping
	    standardGlyph: r.uint16,
	    controlPoints: new r.Array(r.uint16, 32)
	  },
	
	  3: { // Control point-based, with mapping
	    standardGlyph: r.uint16,
	    controlPoints: new r.Array(r.uint16, 32),
	    mappingData: new LookupTable(r.uint16)
	  }
	});
	
	var bsln = new r.Struct({
	  version: r.fixed32,
	  format: r.uint16,
	  defaultBaseline: r.uint16,
	  subtable: BslnSubtable
	});
	
	var Setting = new r.Struct({
	  setting: r.uint16,
	  nameIndex: r.int16,
	  name: function name(t) {
	    return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
	  }
	});
	
	var FeatureName = new r.Struct({
	  feature: r.uint16,
	  nSettings: r.uint16,
	  settingTable: new r.Pointer(r.uint32, new r.Array(Setting, 'nSettings'), { type: 'parent' }),
	  featureFlags: new r.Bitfield(r.uint8, [null, null, null, null, null, null, 'hasDefault', 'exclusive']),
	  defaultSetting: r.uint8,
	  nameIndex: r.int16,
	  name: function name(t) {
	    return t.parent.parent.name.records.fontFeatures[t.nameIndex];
	  }
	});
	
	var feat = new r.Struct({
	  version: r.fixed32,
	  featureNameCount: r.uint16,
	  reserved1: new r.Reserved(r.uint16),
	  reserved2: new r.Reserved(r.uint32),
	  featureNames: new r.Array(FeatureName, 'featureNameCount')
	});
	
	var Axis$1 = new r.Struct({
	  axisTag: new r.String(4),
	  minValue: r.fixed32,
	  defaultValue: r.fixed32,
	  maxValue: r.fixed32,
	  flags: r.uint16,
	  nameID: r.uint16,
	  name: function name(t) {
	    return t.parent.parent.name.records.fontFeatures[t.nameID];
	  }
	});
	
	var Instance = new r.Struct({
	  nameID: r.uint16,
	  name: function name(t) {
	    return t.parent.parent.name.records.fontFeatures[t.nameID];
	  },
	  flags: r.uint16,
	  coord: new r.Array(r.fixed32, function (t) {
	    return t.parent.axisCount;
	  }),
	  postscriptNameID: new r.Optional(r.uint16, function (t) {
	    return t.parent.instanceSize - t._currentOffset > 0;
	  })
	});
	
	var fvar = new r.Struct({
	  version: r.fixed32,
	  offsetToData: r.uint16,
	  countSizePairs: r.uint16,
	  axisCount: r.uint16,
	  axisSize: r.uint16,
	  instanceCount: r.uint16,
	  instanceSize: r.uint16,
	  axis: new r.Array(Axis$1, 'axisCount'),
	  instance: new r.Array(Instance, 'instanceCount')
	});
	
	var shortFrac$1 = new r.Fixed(16, 'BE', 14);
	
	var Offset = function () {
	  function Offset() {
	    _classCallCheck(this, Offset);
	  }
	
	  Offset.decode = function decode(stream, parent) {
	    // In short format, offsets are multiplied by 2.
	    // This doesn't seem to be documented by Apple, but it
	    // is implemented this way in Freetype.
	    return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
	  };
	
	  return Offset;
	}();
	
	var gvar = new r.Struct({
	  version: r.uint16,
	  reserved: new r.Reserved(r.uint16),
	  axisCount: r.uint16,
	  globalCoordCount: r.uint16,
	  globalCoords: new r.Pointer(r.uint32, new r.Array(new r.Array(shortFrac$1, 'axisCount'), 'globalCoordCount')),
	  glyphCount: r.uint16,
	  flags: r.uint16,
	  offsetToData: r.uint32,
	  offsets: new r.Array(new r.Pointer(Offset, 'void', { relativeTo: 'offsetToData', allowNull: false }), function (t) {
	    return t.glyphCount + 1;
	  })
	});
	
	var ClassTable$1 = new r.Struct({
	  length: r.uint16,
	  coverage: r.uint16,
	  subFeatureFlags: r.uint32,
	  stateTable: new StateTable1()
	});
	
	var WidthDeltaRecord = new r.Struct({
	  justClass: r.uint32,
	  beforeGrowLimit: r.fixed32,
	  beforeShrinkLimit: r.fixed32,
	  afterGrowLimit: r.fixed32,
	  afterShrinkLimit: r.fixed32,
	  growFlags: r.uint16,
	  shrinkFlags: r.uint16
	});
	
	var WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);
	
	var ActionData = new r.VersionedStruct('actionType', {
	  0: { // Decomposition action
	    lowerLimit: r.fixed32,
	    upperLimit: r.fixed32,
	    order: r.uint16,
	    glyphs: new r.Array(r.uint16, r.uint16)
	  },
	
	  1: { // Unconditional add glyph action
	    addGlyph: r.uint16
	  },
	
	  2: { // Conditional add glyph action
	    substThreshold: r.fixed32,
	    addGlyph: r.uint16,
	    substGlyph: r.uint16
	  },
	
	  3: {}, // Stretch glyph action (no data, not supported by CoreText)
	
	  4: { // Ductile glyph action (not supported by CoreText)
	    variationAxis: r.uint32,
	    minimumLimit: r.fixed32,
	    noStretchValue: r.fixed32,
	    maximumLimit: r.fixed32
	  },
	
	  5: { // Repeated add glyph action
	    flags: r.uint16,
	    glyph: r.uint16
	  }
	});
	
	var Action = new r.Struct({
	  actionClass: r.uint16,
	  actionType: r.uint16,
	  actionLength: r.uint32,
	  actionData: ActionData,
	  padding: new r.Reserved(r.uint8, function (t) {
	    return t.actionLength - t._currentOffset;
	  })
	});
	
	var PostcompensationAction = new r.Array(Action, r.uint32);
	var PostCompensationTable = new r.Struct({
	  lookupTable: new LookupTable(new r.Pointer(r.uint16, PostcompensationAction))
	});
	
	var JustificationTable = new r.Struct({
	  classTable: new r.Pointer(r.uint16, ClassTable$1, { type: 'parent' }),
	  wdcOffset: r.uint16,
	  postCompensationTable: new r.Pointer(r.uint16, PostCompensationTable, { type: 'parent' }),
	  widthDeltaClusters: new LookupTable(new r.Pointer(r.uint16, WidthDeltaCluster, { type: 'parent', relativeTo: 'wdcOffset' }))
	});
	
	var just = new r.Struct({
	  version: r.uint32,
	  format: r.uint16,
	  horizontal: new r.Pointer(r.uint16, JustificationTable),
	  vertical: new r.Pointer(r.uint16, JustificationTable)
	});
	
	var LigatureData = {
	  action: r.uint16
	};
	
	var ContextualData = {
	  markIndex: r.uint16,
	  currentIndex: r.uint16
	};
	
	var InsertionData = {
	  currentInsertIndex: r.uint16,
	  markedInsertIndex: r.uint16
	};
	
	var SubstitutionTable = new r.Struct({
	  items: new UnboundedArray(new r.Pointer(r.uint32, new LookupTable()))
	});
	
	var SubtableData = new r.VersionedStruct('type', {
	  0: { // Indic Rearrangement Subtable
	    stateTable: new StateTable()
	  },
	
	  1: { // Contextual Glyph Substitution Subtable
	    stateTable: new StateTable(ContextualData),
	    substitutionTable: new r.Pointer(r.uint32, SubstitutionTable)
	  },
	
	  2: { // Ligature subtable
	    stateTable: new StateTable(LigatureData),
	    ligatureActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint32)),
	    components: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
	    ligatureList: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
	  },
	
	  4: { // Non-contextual Glyph Substitution Subtable
	    lookupTable: new LookupTable()
	  },
	
	  5: { // Glyph Insertion Subtable
	    stateTable: new StateTable(InsertionData),
	    insertionActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
	  }
	});
	
	var Subtable = new r.Struct({
	  length: r.uint32,
	  coverage: r.uint24,
	  type: r.uint8,
	  subFeatureFlags: r.uint32,
	  table: SubtableData,
	  padding: new r.Reserved(r.uint8, function (t) {
	    return t.length - t._currentOffset;
	  })
	});
	
	var FeatureEntry = new r.Struct({
	  featureType: r.uint16,
	  featureSetting: r.uint16,
	  enableFlags: r.uint32,
	  disableFlags: r.uint32
	});
	
	var MorxChain = new r.Struct({
	  defaultFlags: r.uint32,
	  chainLength: r.uint32,
	  nFeatureEntries: r.uint32,
	  nSubtables: r.uint32,
	  features: new r.Array(FeatureEntry, 'nFeatureEntries'),
	  subtables: new r.Array(Subtable, 'nSubtables')
	});
	
	var morx = new r.Struct({
	  version: r.uint16,
	  unused: new r.Reserved(r.uint16),
	  nChains: r.uint32,
	  chains: new r.Array(MorxChain, 'nChains')
	});
	
	var OpticalBounds = new r.Struct({
	  left: r.int16,
	  top: r.int16,
	  right: r.int16,
	  bottom: r.int16
	});
	
	var opbd = new r.Struct({
	  version: r.fixed32,
	  format: r.uint16,
	  lookupTable: new LookupTable(OpticalBounds)
	});
	
	var tables = {};
	// Required Tables
	tables.cmap = cmap;
	tables.head = head;
	tables.hhea = hhea;
	tables.hmtx = hmtx;
	tables.maxp = maxp;
	tables.name = NameTable;
	tables['OS/2'] = OS2;
	tables.post = post;
	
	// TrueType Outlines
	tables.fpgm = fpgm;
	tables.loca = loca;
	tables.prep = prep;
	tables['cvt '] = cvt;
	tables.glyf = glyf;
	
	// PostScript Outlines
	tables['CFF '] = CFFFont;
	tables['CFF2'] = CFFFont;
	tables.VORG = VORG;
	
	// Bitmap Glyphs
	tables.EBLC = EBLC;
	tables.CBLC = tables.EBLC;
	tables.sbix = sbix;
	tables.COLR = COLR;
	tables.CPAL = CPAL;
	
	// Advanced OpenType Tables
	tables.BASE = BASE;
	tables.GDEF = GDEF;
	tables.GPOS = GPOS;
	tables.GSUB = GSUB;
	tables.JSTF = JSTF;
	
	// OpenType variations tables
	tables.HVAR = HVAR;
	
	// Other OpenType Tables
	tables.DSIG = DSIG;
	tables.gasp = gasp;
	tables.hdmx = hdmx;
	tables.kern = kern;
	tables.LTSH = LTSH;
	tables.PCLT = PCLT;
	tables.VDMX = VDMX;
	tables.vhea = vhea;
	tables.vmtx = vmtx;
	
	// Apple Advanced Typography Tables
	tables.avar = avar;
	tables.bsln = bsln;
	tables.feat = feat;
	tables.fvar = fvar;
	tables.gvar = gvar;
	tables.just = just;
	tables.morx = morx;
	tables.opbd = opbd;
	
	var TableEntry = new r.Struct({
	  tag: new r.String(4),
	  checkSum: r.uint32,
	  offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
	  length: r.uint32
	});
	
	var Directory = new r.Struct({
	  tag: new r.String(4),
	  numTables: r.uint16,
	  searchRange: r.uint16,
	  entrySelector: r.uint16,
	  rangeShift: r.uint16,
	  tables: new r.Array(TableEntry, 'numTables')
	});
	
	Directory.process = function () {
	  var tables = {};
	  for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var table = _ref;
	
	    tables[table.tag] = table;
	  }
	
	  this.tables = tables;
	};
	
	Directory.preEncode = function (stream) {
	  var tables$$ = [];
	  for (var tag in this.tables) {
	    var table = this.tables[tag];
	    if (table) {
	      tables$$.push({
	        tag: tag,
	        checkSum: 0,
	        offset: new r.VoidPointer(tables[tag], table),
	        length: tables[tag].size(table)
	      });
	    }
	  }
	
	  this.tag = 'true';
	  this.numTables = tables$$.length;
	  this.tables = tables$$;
	
	  this.searchRange = Math.floor(Math.log(this.numTables) / Math.LN2) * 16;
	  this.entrySelector = Math.floor(this.searchRange / Math.LN2);
	  this.rangeShift = this.numTables * 16 - this.searchRange;
	};
	
	function binarySearch(arr, cmp) {
	  var min = 0;
	  var max = arr.length - 1;
	  while (min <= max) {
	    var mid = min + max >> 1;
	    var res = cmp(arr[mid]);
	
	    if (res < 0) {
	      max = mid - 1;
	    } else if (res > 0) {
	      min = mid + 1;
	    } else {
	      return mid;
	    }
	  }
	
	  return -1;
	}
	
	function range(index, end) {
	  var range = [];
	  while (index < end) {
	    range.push(index++);
	  }
	  return range;
	}
	
	var _class$1;
	function _applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	// iconv-lite is an optional dependency.
	try {
	  var iconv = __webpack_require__(52);
	} catch (err) {}
	
	var CmapProcessor = (_class$1 = function () {
	  function CmapProcessor(cmapTable) {
	    _classCallCheck(this, CmapProcessor);
	
	    // Attempt to find a Unicode cmap first
	    this.encoding = null;
	    this.cmap = this.findSubtable(cmapTable, [
	    // 32-bit subtables
	    [3, 10], [0, 6], [0, 4],
	
	    // 16-bit subtables
	    [3, 1], [0, 3], [0, 2], [0, 1], [0, 0]]);
	
	    // If not unicode cmap was found, and iconv-lite is installed,
	    // take the first table with a supported encoding.
	    if (!this.cmap && iconv) {
	      for (var _iterator = cmapTable.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var cmap = _ref;
	
	        var encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
	        if (iconv.encodingExists(encoding)) {
	          this.cmap = cmap.table;
	          this.encoding = encoding;
	        }
	      }
	    }
	
	    if (!this.cmap) {
	      throw new Error("Could not find a supported cmap table");
	    }
	
	    this.uvs = this.findSubtable(cmapTable, [[0, 5]]);
	    if (this.uvs && this.uvs.version !== 14) {
	      this.uvs = null;
	    }
	  }
	
	  CmapProcessor.prototype.findSubtable = function findSubtable(cmapTable, pairs) {
	    for (var _iterator2 = pairs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var _ref3 = _ref2,
	          platformID = _ref3[0],
	          encodingID = _ref3[1];
	
	      for (var _iterator3 = cmapTable.tables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref4;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref4 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref4 = _i3.value;
	        }
	
	        var cmap = _ref4;
	
	        if (cmap.platformID === platformID && cmap.encodingID === encodingID) {
	          return cmap.table;
	        }
	      }
	    }
	
	    return null;
	  };
	
	  CmapProcessor.prototype.lookup = function lookup(codepoint, variationSelector) {
	    // If there is no Unicode cmap in this font, we need to re-encode
	    // the codepoint in the encoding that the cmap supports.
	    if (this.encoding) {
	      var buf = iconv.encode(_String$fromCodePoint(codepoint), this.encoding);
	      codepoint = 0;
	      for (var i = 0; i < buf.length; i++) {
	        codepoint = codepoint << 8 | buf[i];
	      }
	
	      // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
	    } else if (variationSelector) {
	      var gid = this.getVariationSelector(codepoint, variationSelector);
	      if (gid) {
	        return gid;
	      }
	    }
	
	    var cmap = this.cmap;
	    switch (cmap.version) {
	      case 0:
	        return cmap.codeMap.get(codepoint) || 0;
	
	      case 4:
	        {
	          var min = 0;
	          var max = cmap.segCount - 1;
	          while (min <= max) {
	            var mid = min + max >> 1;
	
	            if (codepoint < cmap.startCode.get(mid)) {
	              max = mid - 1;
	            } else if (codepoint > cmap.endCode.get(mid)) {
	              min = mid + 1;
	            } else {
	              var rangeOffset = cmap.idRangeOffset.get(mid);
	              var _gid = void 0;
	
	              if (rangeOffset === 0) {
	                _gid = codepoint + cmap.idDelta.get(mid);
	              } else {
	                var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
	                _gid = cmap.glyphIndexArray.get(index) || 0;
	                if (_gid !== 0) {
	                  _gid += cmap.idDelta.get(mid);
	                }
	              }
	
	              return _gid & 0xffff;
	            }
	          }
	
	          return 0;
	        }
	
	      case 8:
	        throw new Error('TODO: cmap format 8');
	
	      case 6:
	      case 10:
	        return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
	
	      case 12:
	      case 13:
	        {
	          var _min = 0;
	          var _max = cmap.nGroups - 1;
	          while (_min <= _max) {
	            var _mid = _min + _max >> 1;
	            var group = cmap.groups.get(_mid);
	
	            if (codepoint < group.startCharCode) {
	              _max = _mid - 1;
	            } else if (codepoint > group.endCharCode) {
	              _min = _mid + 1;
	            } else {
	              if (cmap.version === 12) {
	                return group.glyphID + (codepoint - group.startCharCode);
	              } else {
	                return group.glyphID;
	              }
	            }
	          }
	
	          return 0;
	        }
	
	      case 14:
	        throw new Error('TODO: cmap format 14');
	
	      default:
	        throw new Error('Unknown cmap format ' + cmap.version);
	    }
	  };
	
	  CmapProcessor.prototype.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
	    if (!this.uvs) {
	      return 0;
	    }
	
	    var selectors = this.uvs.varSelectors.toArray();
	    var i = binarySearch(selectors, function (x) {
	      return variationSelector - x.varSelector;
	    });
	    var sel = selectors[i];
	
	    if (i !== -1 && sel.defaultUVS) {
	      i = binarySearch(sel.defaultUVS, function (x) {
	        return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? +1 : 0;
	      });
	    }
	
	    if (i !== -1 && sel.nonDefaultUVS) {
	      i = binarySearch(sel.nonDefaultUVS, function (x) {
	        return codepoint - x.unicodeValue;
	      });
	      if (i !== -1) {
	        return sel.nonDefaultUVS[i].glyphID;
	      }
	    }
	
	    return 0;
	  };
	
	  CmapProcessor.prototype.getCharacterSet = function getCharacterSet() {
	    var cmap = this.cmap;
	    switch (cmap.version) {
	      case 0:
	        return range(0, cmap.codeMap.length);
	
	      case 4:
	        {
	          var res = [];
	          var endCodes = cmap.endCode.toArray();
	          for (var i = 0; i < endCodes.length; i++) {
	            var tail = endCodes[i] + 1;
	            var start = cmap.startCode.get(i);
	            res.push.apply(res, range(start, tail));
	          }
	
	          return res;
	        }
	
	      case 8:
	        throw new Error('TODO: cmap format 8');
	
	      case 6:
	      case 10:
	        return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
	
	      case 12:
	      case 13:
	        {
	          var _res = [];
	          for (var _iterator4 = cmap.groups.toArray(), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	            var _ref5;
	
	            if (_isArray4) {
	              if (_i4 >= _iterator4.length) break;
	              _ref5 = _iterator4[_i4++];
	            } else {
	              _i4 = _iterator4.next();
	              if (_i4.done) break;
	              _ref5 = _i4.value;
	            }
	
	            var group = _ref5;
	
	            _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
	          }
	
	          return _res;
	        }
	
	      case 14:
	        throw new Error('TODO: cmap format 14');
	
	      default:
	        throw new Error('Unknown cmap format ' + cmap.version);
	    }
	  };
	
	  CmapProcessor.prototype.codePointsForGlyph = function codePointsForGlyph(gid) {
	    var cmap = this.cmap;
	    switch (cmap.version) {
	      case 0:
	        {
	          var res = [];
	          for (var i = 0; i < 256; i++) {
	            if (cmap.codeMap.get(i) === gid) {
	              res.push(i);
	            }
	          }
	
	          return res;
	        }
	
	      case 4:
	        {
	          var _res2 = [];
	          for (var _i5 = 0; _i5 < cmap.segCount; _i5++) {
	            var end = cmap.endCode.get(_i5);
	            var start = cmap.startCode.get(_i5);
	            var rangeOffset = cmap.idRangeOffset.get(_i5);
	            var delta = cmap.idDelta.get(_i5);
	
	            for (var c = start; c <= end; c++) {
	              var g = 0;
	              if (rangeOffset === 0) {
	                g = c + delta;
	              } else {
	                var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i5);
	                g = cmap.glyphIndexArray.get(index) || 0;
	                if (g !== 0) {
	                  g += delta;
	                }
	              }
	
	              if (g === gid) {
	                _res2.push(c);
	              }
	            }
	          }
	
	          return _res2;
	        }
	
	      case 12:
	        {
	          var _res3 = [];
	          for (var _iterator5 = cmap.groups.toArray(), _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	            var _ref6;
	
	            if (_isArray5) {
	              if (_i6 >= _iterator5.length) break;
	              _ref6 = _iterator5[_i6++];
	            } else {
	              _i6 = _iterator5.next();
	              if (_i6.done) break;
	              _ref6 = _i6.value;
	            }
	
	            var group = _ref6;
	
	            if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) {
	              _res3.push(group.startCharCode + (gid - group.glyphID));
	            }
	          }
	
	          return _res3;
	        }
	
	      case 13:
	        {
	          var _res4 = [];
	          for (var _iterator6 = cmap.groups.toArray(), _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
	            var _ref7;
	
	            if (_isArray6) {
	              if (_i7 >= _iterator6.length) break;
	              _ref7 = _iterator6[_i7++];
	            } else {
	              _i7 = _iterator6.next();
	              if (_i7.done) break;
	              _ref7 = _i7.value;
	            }
	
	            var _group = _ref7;
	
	            if (gid === _group.glyphID) {
	              _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
	            }
	          }
	
	          return _res4;
	        }
	
	      default:
	        throw new Error('Unknown cmap format ' + cmap.version);
	    }
	  };
	
	  return CmapProcessor;
	}(), (_applyDecoratedDescriptor$1(_class$1.prototype, 'getCharacterSet', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'getCharacterSet'), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, 'codePointsForGlyph', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'codePointsForGlyph'), _class$1.prototype)), _class$1);
	
	var KernProcessor = function () {
	  function KernProcessor(font) {
	    _classCallCheck(this, KernProcessor);
	
	    this.kern = font.kern;
	  }
	
	  KernProcessor.prototype.process = function process(glyphs, positions) {
	    for (var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++) {
	      var left = glyphs[glyphIndex].id;
	      var right = glyphs[glyphIndex + 1].id;
	      positions[glyphIndex].xAdvance += this.getKerning(left, right);
	    }
	  };
	
	  KernProcessor.prototype.getKerning = function getKerning(left, right) {
	    var res = 0;
	
	    for (var _iterator = this.kern.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var table = _ref;
	
	      if (table.coverage.crossStream) {
	        continue;
	      }
	
	      switch (table.version) {
	        case 0:
	          if (!table.coverage.horizontal) {
	            continue;
	          }
	
	          break;
	        case 1:
	          if (table.coverage.vertical || table.coverage.variation) {
	            continue;
	          }
	
	          break;
	        default:
	          throw new Error('Unsupported kerning table version ' + table.version);
	      }
	
	      var val = 0;
	      var s = table.subtable;
	      switch (table.format) {
	        case 0:
	          var pairIdx = binarySearch(s.pairs, function (pair) {
	            return left - pair.left || right - pair.right;
	          });
	
	          if (pairIdx >= 0) {
	            val = s.pairs[pairIdx].value;
	          }
	
	          break;
	
	        case 2:
	          var leftOffset = 0,
	              rightOffset = 0;
	          if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) {
	            leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
	          } else {
	            leftOffset = s.array.off;
	          }
	
	          if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) {
	            rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
	          }
	
	          var index = (leftOffset + rightOffset - s.array.off) / 2;
	          val = s.array.values.get(index);
	          break;
	
	        case 3:
	          if (left >= s.glyphCount || right >= s.glyphCount) {
	            return 0;
	          }
	
	          val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
	          break;
	
	        default:
	          throw new Error('Unsupported kerning sub-table format ' + table.format);
	      }
	
	      // Microsoft supports the override flag, which resets the result
	      // Otherwise, the sum of the results from all subtables is returned
	      if (table.coverage.override) {
	        res = val;
	      } else {
	        res += val;
	      }
	    }
	
	    return res;
	  };
	
	  return KernProcessor;
	}();
	
	/**
	 * This class is used when GPOS does not define 'mark' or 'mkmk' features
	 * for positioning marks relative to base glyphs. It uses the unicode
	 * combining class property to position marks.
	 *
	 * Based on code from Harfbuzz, thanks!
	 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
	 */
	
	var UnicodeLayoutEngine = function () {
	  function UnicodeLayoutEngine(font) {
	    _classCallCheck(this, UnicodeLayoutEngine);
	
	    this.font = font;
	  }
	
	  UnicodeLayoutEngine.prototype.positionGlyphs = function positionGlyphs(glyphs, positions) {
	    // find each base + mark cluster, and position the marks relative to the base
	    var clusterStart = 0;
	    var clusterEnd = 0;
	    for (var index = 0; index < glyphs.length; index++) {
	      var glyph = glyphs[index];
	      if (glyph.isMark) {
	        // TODO: handle ligatures
	        clusterEnd = index;
	      } else {
	        if (clusterStart !== clusterEnd) {
	          this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
	        }
	
	        clusterStart = clusterEnd = index;
	      }
	    }
	
	    if (clusterStart !== clusterEnd) {
	      this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
	    }
	
	    return positions;
	  };
	
	  UnicodeLayoutEngine.prototype.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
	    var base = glyphs[clusterStart];
	    var baseBox = base.cbox.copy();
	
	    // adjust bounding box for ligature glyphs
	    if (base.codePoints.length > 1) {
	      // LTR. TODO: RTL support.
	      baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
	    }
	
	    var xOffset = -positions[clusterStart].xAdvance;
	    var yOffset = 0;
	    var yGap = this.font.unitsPerEm / 16;
	
	    // position each of the mark glyphs relative to the base glyph
	    for (var index = clusterStart + 1; index <= clusterEnd; index++) {
	      var mark = glyphs[index];
	      var markBox = mark.cbox;
	      var position = positions[index];
	
	      var combiningClass = this.getCombiningClass(mark.codePoints[0]);
	
	      if (combiningClass !== 'Not_Reordered') {
	        position.xOffset = position.yOffset = 0;
	
	        // x positioning
	        switch (combiningClass) {
	          case 'Double_Above':
	          case 'Double_Below':
	            // LTR. TODO: RTL support.
	            position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
	            break;
	
	          case 'Attached_Below_Left':
	          case 'Below_Left':
	          case 'Above_Left':
	            // left align
	            position.xOffset += baseBox.minX - markBox.minX;
	            break;
	
	          case 'Attached_Above_Right':
	          case 'Below_Right':
	          case 'Above_Right':
	            // right align
	            position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
	            break;
	
	          default:
	            // Attached_Below, Attached_Above, Below, Above, other
	            // center align
	            position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
	        }
	
	        // y positioning
	        switch (combiningClass) {
	          case 'Double_Below':
	          case 'Below_Left':
	          case 'Below':
	          case 'Below_Right':
	          case 'Attached_Below_Left':
	          case 'Attached_Below':
	            // add a small gap between the glyphs if they are not attached
	            if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') {
	              baseBox.minY += yGap;
	            }
	
	            position.yOffset = -baseBox.minY - markBox.maxY;
	            baseBox.minY += markBox.height;
	            break;
	
	          case 'Double_Above':
	          case 'Above_Left':
	          case 'Above':
	          case 'Above_Right':
	          case 'Attached_Above':
	          case 'Attached_Above_Right':
	            // add a small gap between the glyphs if they are not attached
	            if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') {
	              baseBox.maxY += yGap;
	            }
	
	            position.yOffset = baseBox.maxY - markBox.minY;
	            baseBox.maxY += markBox.height;
	            break;
	        }
	
	        position.xAdvance = position.yAdvance = 0;
	        position.xOffset += xOffset;
	        position.yOffset += yOffset;
	      } else {
	        xOffset -= position.xAdvance;
	        yOffset -= position.yAdvance;
	      }
	    }
	
	    return;
	  };
	
	  UnicodeLayoutEngine.prototype.getCombiningClass = function getCombiningClass(codePoint) {
	    var combiningClass = unicode.getCombiningClass(codePoint);
	
	    // Thai / Lao need some per-character work
	    if ((codePoint & ~0xff) === 0x0e00) {
	      if (combiningClass === 'Not_Reordered') {
	        switch (codePoint) {
	          case 0x0e31:
	          case 0x0e34:
	          case 0x0e35:
	          case 0x0e36:
	          case 0x0e37:
	          case 0x0e47:
	          case 0x0e4c:
	          case 0x0e3d:
	          case 0x0e4e:
	            return 'Above_Right';
	
	          case 0x0eb1:
	          case 0x0eb4:
	          case 0x0eb5:
	          case 0x0eb6:
	          case 0x0eb7:
	          case 0x0ebb:
	          case 0x0ecc:
	          case 0x0ecd:
	            return 'Above';
	
	          case 0x0ebc:
	            return 'Below';
	        }
	      } else if (codePoint === 0x0e3a) {
	        // virama
	        return 'Below_Right';
	      }
	    }
	
	    switch (combiningClass) {
	      // Hebrew
	
	      case 'CCC10': // sheva
	      case 'CCC11': // hataf segol
	      case 'CCC12': // hataf patah
	      case 'CCC13': // hataf qamats
	      case 'CCC14': // hiriq
	      case 'CCC15': // tsere
	      case 'CCC16': // segol
	      case 'CCC17': // patah
	      case 'CCC18': // qamats
	      case 'CCC20': // qubuts
	      case 'CCC22':
	        // meteg
	        return 'Below';
	
	      case 'CCC23':
	        // rafe
	        return 'Attached_Above';
	
	      case 'CCC24':
	        // shin dot
	        return 'Above_Right';
	
	      case 'CCC25': // sin dot
	      case 'CCC19':
	        // holam
	        return 'Above_Left';
	
	      case 'CCC26':
	        // point varika
	        return 'Above';
	
	      case 'CCC21':
	        // dagesh
	        break;
	
	      // Arabic and Syriac
	
	      case 'CCC27': // fathatan
	      case 'CCC28': // dammatan
	      case 'CCC30': // fatha
	      case 'CCC31': // damma
	      case 'CCC33': // shadda
	      case 'CCC34': // sukun
	      case 'CCC35': // superscript alef
	      case 'CCC36':
	        // superscript alaph
	        return 'Above';
	
	      case 'CCC29': // kasratan
	      case 'CCC32':
	        // kasra
	        return 'Below';
	
	      // Thai
	
	      case 'CCC103':
	        // sara u / sara uu
	        return 'Below_Right';
	
	      case 'CCC107':
	        // mai
	        return 'Above_Right';
	
	      // Lao
	
	      case 'CCC118':
	        // sign u / sign uu
	        return 'Below';
	
	      case 'CCC122':
	        // mai
	        return 'Above';
	
	      // Tibetan
	
	      case 'CCC129': // sign aa
	      case 'CCC132':
	        // sign u
	        return 'Below';
	
	      case 'CCC130':
	        // sign i
	        return 'Above';
	    }
	
	    return combiningClass;
	  };
	
	  return UnicodeLayoutEngine;
	}();
	
	/**
	 * Represents a glyph bounding box
	 */
	var BBox = function () {
	  function BBox() {
	    var minX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
	    var minY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
	    var maxX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -Infinity;
	    var maxY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -Infinity;
	
	    _classCallCheck(this, BBox);
	
	    /**
	     * The minimum X position in the bounding box
	     * @type {number}
	     */
	    this.minX = minX;
	
	    /**
	     * The minimum Y position in the bounding box
	     * @type {number}
	     */
	    this.minY = minY;
	
	    /**
	     * The maxmimum X position in the bounding box
	     * @type {number}
	     */
	    this.maxX = maxX;
	
	    /**
	     * The maxmimum Y position in the bounding box
	     * @type {number}
	     */
	    this.maxY = maxY;
	  }
	
	  /**
	   * The width of the bounding box
	   * @type {number}
	   */
	
	
	  BBox.prototype.addPoint = function addPoint(x, y) {
	    if (Math.abs(x) !== Infinity) {
	      if (x < this.minX) {
	        this.minX = x;
	      }
	
	      if (x > this.maxX) {
	        this.maxX = x;
	      }
	    }
	
	    if (Math.abs(y) !== Infinity) {
	      if (y < this.minY) {
	        this.minY = y;
	      }
	
	      if (y > this.maxY) {
	        this.maxY = y;
	      }
	    }
	  };
	
	  BBox.prototype.copy = function copy() {
	    return new BBox(this.minX, this.minY, this.maxX, this.maxY);
	  };
	
	  _createClass(BBox, [{
	    key: "width",
	    get: function get() {
	      return this.maxX - this.minX;
	    }
	
	    /**
	     * The height of the bounding box
	     * @type {number}
	     */
	
	  }, {
	    key: "height",
	    get: function get() {
	      return this.maxY - this.minY;
	    }
	  }]);
	
	  return BBox;
	}();
	
	// This maps the Unicode Script property to an OpenType script tag
	// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
	// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
	var UNICODE_SCRIPTS = {
	  Caucasian_Albanian: 'aghb',
	  Arabic: 'arab',
	  Imperial_Aramaic: 'armi',
	  Armenian: 'armn',
	  Avestan: 'avst',
	  Balinese: 'bali',
	  Bamum: 'bamu',
	  Bassa_Vah: 'bass',
	  Batak: 'batk',
	  Bengali: ['bng2', 'beng'],
	  Bopomofo: 'bopo',
	  Brahmi: 'brah',
	  Braille: 'brai',
	  Buginese: 'bugi',
	  Buhid: 'buhd',
	  Chakma: 'cakm',
	  Canadian_Aboriginal: 'cans',
	  Carian: 'cari',
	  Cham: 'cham',
	  Cherokee: 'cher',
	  Coptic: 'copt',
	  Cypriot: 'cprt',
	  Cyrillic: 'cyrl',
	  Devanagari: ['dev2', 'deva'],
	  Deseret: 'dsrt',
	  Duployan: 'dupl',
	  Egyptian_Hieroglyphs: 'egyp',
	  Elbasan: 'elba',
	  Ethiopic: 'ethi',
	  Georgian: 'geor',
	  Glagolitic: 'glag',
	  Gothic: 'goth',
	  Grantha: 'gran',
	  Greek: 'grek',
	  Gujarati: ['gjr2', 'gujr'],
	  Gurmukhi: ['gur2', 'guru'],
	  Hangul: 'hang',
	  Han: 'hani',
	  Hanunoo: 'hano',
	  Hebrew: 'hebr',
	  Hiragana: 'hira',
	  Pahawh_Hmong: 'hmng',
	  Katakana_Or_Hiragana: 'hrkt',
	  Old_Italic: 'ital',
	  Javanese: 'java',
	  Kayah_Li: 'kali',
	  Katakana: 'kana',
	  Kharoshthi: 'khar',
	  Khmer: 'khmr',
	  Khojki: 'khoj',
	  Kannada: ['knd2', 'knda'],
	  Kaithi: 'kthi',
	  Tai_Tham: 'lana',
	  Lao: 'lao ',
	  Latin: 'latn',
	  Lepcha: 'lepc',
	  Limbu: 'limb',
	  Linear_A: 'lina',
	  Linear_B: 'linb',
	  Lisu: 'lisu',
	  Lycian: 'lyci',
	  Lydian: 'lydi',
	  Mahajani: 'mahj',
	  Mandaic: 'mand',
	  Manichaean: 'mani',
	  Mende_Kikakui: 'mend',
	  Meroitic_Cursive: 'merc',
	  Meroitic_Hieroglyphs: 'mero',
	  Malayalam: ['mlm2', 'mlym'],
	  Modi: 'modi',
	  Mongolian: 'mong',
	  Mro: 'mroo',
	  Meetei_Mayek: 'mtei',
	  Myanmar: ['mym2', 'mymr'],
	  Old_North_Arabian: 'narb',
	  Nabataean: 'nbat',
	  Nko: 'nko ',
	  Ogham: 'ogam',
	  Ol_Chiki: 'olck',
	  Old_Turkic: 'orkh',
	  Oriya: ['ory2', 'orya'],
	  Osmanya: 'osma',
	  Palmyrene: 'palm',
	  Pau_Cin_Hau: 'pauc',
	  Old_Permic: 'perm',
	  Phags_Pa: 'phag',
	  Inscriptional_Pahlavi: 'phli',
	  Psalter_Pahlavi: 'phlp',
	  Phoenician: 'phnx',
	  Miao: 'plrd',
	  Inscriptional_Parthian: 'prti',
	  Rejang: 'rjng',
	  Runic: 'runr',
	  Samaritan: 'samr',
	  Old_South_Arabian: 'sarb',
	  Saurashtra: 'saur',
	  Shavian: 'shaw',
	  Sharada: 'shrd',
	  Siddham: 'sidd',
	  Khudawadi: 'sind',
	  Sinhala: 'sinh',
	  Sora_Sompeng: 'sora',
	  Sundanese: 'sund',
	  Syloti_Nagri: 'sylo',
	  Syriac: 'syrc',
	  Tagbanwa: 'tagb',
	  Takri: 'takr',
	  Tai_Le: 'tale',
	  New_Tai_Lue: 'talu',
	  Tamil: ['tml2', 'taml'],
	  Tai_Viet: 'tavt',
	  Telugu: ['tel2', 'telu'],
	  Tifinagh: 'tfng',
	  Tagalog: 'tglg',
	  Thaana: 'thaa',
	  Thai: 'thai',
	  Tibetan: 'tibt',
	  Tirhuta: 'tirh',
	  Ugaritic: 'ugar',
	  Vai: 'vai ',
	  Warang_Citi: 'wara',
	  Old_Persian: 'xpeo',
	  Cuneiform: 'xsux',
	  Yi: 'yi  ',
	  Inherited: 'zinh',
	  Common: 'zyyy',
	  Unknown: 'zzzz'
	};
	
	var OPENTYPE_SCRIPTS = {};
	for (var script in UNICODE_SCRIPTS) {
	  var tag = UNICODE_SCRIPTS[script];
	  if (Array.isArray(tag)) {
	    for (var _iterator = tag, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var t = _ref;
	
	      OPENTYPE_SCRIPTS[t] = script;
	    }
	  } else {
	    OPENTYPE_SCRIPTS[tag] = script;
	  }
	}
	
	function fromOpenType(tag) {
	  return OPENTYPE_SCRIPTS[tag];
	}
	
	function forString(string) {
	  var len = string.length;
	  var idx = 0;
	  while (idx < len) {
	    var code = string.charCodeAt(idx++);
	
	    // Check if this is a high surrogate
	    if (0xd800 <= code && code <= 0xdbff && idx < len) {
	      var next = string.charCodeAt(idx);
	
	      // Check if this is a low surrogate
	      if (0xdc00 <= next && next <= 0xdfff) {
	        idx++;
	        code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
	      }
	    }
	
	    var _script = unicode.getScript(code);
	    if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') {
	      return UNICODE_SCRIPTS[_script];
	    }
	  }
	
	  return UNICODE_SCRIPTS.Unknown;
	}
	
	function forCodePoints(codePoints) {
	  for (var i = 0; i < codePoints.length; i++) {
	    var codePoint = codePoints[i];
	    var _script2 = unicode.getScript(codePoint);
	    if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') {
	      return UNICODE_SCRIPTS[_script2];
	    }
	  }
	
	  return UNICODE_SCRIPTS.Unknown;
	}
	
	// The scripts in this map are written from right to left
	var RTL = {
	  arab: true, // Arabic
	  hebr: true, // Hebrew
	  syrc: true, // Syriac
	  thaa: true, // Thaana
	  cprt: true, // Cypriot Syllabary
	  khar: true, // Kharosthi
	  phnx: true, // Phoenician
	  'nko ': true, // N'Ko
	  lydi: true, // Lydian
	  avst: true, // Avestan
	  armi: true, // Imperial Aramaic
	  phli: true, // Inscriptional Pahlavi
	  prti: true, // Inscriptional Parthian
	  sarb: true, // Old South Arabian
	  orkh: true, // Old Turkic, Orkhon Runic
	  samr: true, // Samaritan
	  mand: true, // Mandaic, Mandaean
	  merc: true, // Meroitic Cursive
	  mero: true, // Meroitic Hieroglyphs
	
	  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
	  mani: true, // Manichaean
	  mend: true, // Mende Kikakui
	  nbat: true, // Nabataean
	  narb: true, // Old North Arabian
	  palm: true, // Palmyrene
	  phlp: true // Psalter Pahlavi
	};
	
	function direction(script) {
	  if (RTL[script]) {
	    return 'rtl';
	  }
	
	  return 'ltr';
	}
	
	/**
	 * Represents a run of Glyph and GlyphPosition objects.
	 * Returned by the font layout method.
	 */
	
	var GlyphRun = function () {
	  function GlyphRun(glyphs, features, script, language, direction$$) {
	    _classCallCheck(this, GlyphRun);
	
	    /**
	     * An array of Glyph objects in the run
	     * @type {Glyph[]}
	     */
	    this.glyphs = glyphs;
	
	    /**
	     * An array of GlyphPosition objects for each glyph in the run
	     * @type {GlyphPosition[]}
	     */
	    this.positions = null;
	
	    /**
	     * The script that was requested for shaping. This was either passed in or detected automatically.
	     * @type {string}
	     */
	    this.script = script;
	
	    /**
	     * The language requested for shaping, as passed in. If `null`, the default language for the
	     * script was used.
	     * @type {string}
	     */
	    this.language = language || null;
	
	    /**
	     * The direction requested for shaping, as passed in (either ltr or rtl).
	     * If `null`, the default direction of the script is used.
	     * @type {string}
	     */
	    this.direction = direction$$ || direction(script);
	
	    /**
	     * The features requested during shaping. This is a combination of user
	     * specified features and features chosen by the shaper.
	     * @type {object}
	     */
	    this.features = {};
	
	    // Convert features to an object
	    if (Array.isArray(features)) {
	      for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var tag = _ref;
	
	        this.features[tag] = true;
	      }
	    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	      this.features = features;
	    }
	  }
	
	  /**
	   * The total advance width of the run.
	   * @type {number}
	   */
	
	
	  _createClass(GlyphRun, [{
	    key: 'advanceWidth',
	    get: function get() {
	      var width = 0;
	      for (var _iterator2 = this.positions, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var position = _ref2;
	
	        width += position.xAdvance;
	      }
	
	      return width;
	    }
	
	    /**
	     * The total advance height of the run.
	     * @type {number}
	     */
	
	  }, {
	    key: 'advanceHeight',
	    get: function get() {
	      var height = 0;
	      for (var _iterator3 = this.positions, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var position = _ref3;
	
	        height += position.yAdvance;
	      }
	
	      return height;
	    }
	
	    /**
	     * The bounding box containing all glyphs in the run.
	     * @type {BBox}
	     */
	
	  }, {
	    key: 'bbox',
	    get: function get() {
	      var bbox = new BBox();
	
	      var x = 0;
	      var y = 0;
	      for (var index = 0; index < this.glyphs.length; index++) {
	        var glyph = this.glyphs[index];
	        var p = this.positions[index];
	        var b = glyph.bbox;
	
	        bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
	        bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
	
	        x += p.xAdvance;
	        y += p.yAdvance;
	      }
	
	      return bbox;
	    }
	  }]);
	
	  return GlyphRun;
	}();
	
	/**
	 * Represents positioning information for a glyph in a GlyphRun.
	 */
	var GlyphPosition = function GlyphPosition() {
	  var xAdvance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var yAdvance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var xOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var yOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  _classCallCheck(this, GlyphPosition);
	
	  /**
	   * The amount to move the virtual pen in the X direction after rendering this glyph.
	   * @type {number}
	   */
	  this.xAdvance = xAdvance;
	
	  /**
	   * The amount to move the virtual pen in the Y direction after rendering this glyph.
	   * @type {number}
	   */
	  this.yAdvance = yAdvance;
	
	  /**
	   * The offset from the pen position in the X direction at which to render this glyph.
	   * @type {number}
	   */
	  this.xOffset = xOffset;
	
	  /**
	   * The offset from the pen position in the Y direction at which to render this glyph.
	   * @type {number}
	   */
	  this.yOffset = yOffset;
	};
	
	// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
	// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
	var features = {
	  allTypographicFeatures: {
	    code: 0,
	    exclusive: false,
	    allTypeFeatures: 0
	  },
	  ligatures: {
	    code: 1,
	    exclusive: false,
	    requiredLigatures: 0,
	    commonLigatures: 2,
	    rareLigatures: 4,
	    // logos: 6
	    rebusPictures: 8,
	    diphthongLigatures: 10,
	    squaredLigatures: 12,
	    abbrevSquaredLigatures: 14,
	    symbolLigatures: 16,
	    contextualLigatures: 18,
	    historicalLigatures: 20
	  },
	  cursiveConnection: {
	    code: 2,
	    exclusive: true,
	    unconnected: 0,
	    partiallyConnected: 1,
	    cursive: 2
	  },
	  letterCase: {
	    code: 3,
	    exclusive: true
	  },
	  // upperAndLowerCase: 0          # deprecated
	  // allCaps: 1                    # deprecated
	  // allLowerCase: 2               # deprecated
	  // smallCaps: 3                  # deprecated
	  // initialCaps: 4                # deprecated
	  // initialCapsAndSmallCaps: 5    # deprecated
	  verticalSubstitution: {
	    code: 4,
	    exclusive: false,
	    substituteVerticalForms: 0
	  },
	  linguisticRearrangement: {
	    code: 5,
	    exclusive: false,
	    linguisticRearrangement: 0
	  },
	  numberSpacing: {
	    code: 6,
	    exclusive: true,
	    monospacedNumbers: 0,
	    proportionalNumbers: 1,
	    thirdWidthNumbers: 2,
	    quarterWidthNumbers: 3
	  },
	  smartSwash: {
	    code: 8,
	    exclusive: false,
	    wordInitialSwashes: 0,
	    wordFinalSwashes: 2,
	    // lineInitialSwashes: 4
	    // lineFinalSwashes: 6
	    nonFinalSwashes: 8
	  },
	  diacritics: {
	    code: 9,
	    exclusive: true,
	    showDiacritics: 0,
	    hideDiacritics: 1,
	    decomposeDiacritics: 2
	  },
	  verticalPosition: {
	    code: 10,
	    exclusive: true,
	    normalPosition: 0,
	    superiors: 1,
	    inferiors: 2,
	    ordinals: 3,
	    scientificInferiors: 4
	  },
	  fractions: {
	    code: 11,
	    exclusive: true,
	    noFractions: 0,
	    verticalFractions: 1,
	    diagonalFractions: 2
	  },
	  overlappingCharacters: {
	    code: 13,
	    exclusive: false,
	    preventOverlap: 0
	  },
	  typographicExtras: {
	    code: 14,
	    exclusive: false,
	    // hyphensToEmDash: 0
	    // hyphenToEnDash: 2
	    slashedZero: 4
	  },
	  // formInterrobang: 6
	  // smartQuotes: 8
	  // periodsToEllipsis: 10
	  mathematicalExtras: {
	    code: 15,
	    exclusive: false,
	    // hyphenToMinus: 0
	    // asteristoMultiply: 2
	    // slashToDivide: 4
	    // inequalityLigatures: 6
	    // exponents: 8
	    mathematicalGreek: 10
	  },
	  ornamentSets: {
	    code: 16,
	    exclusive: true,
	    noOrnaments: 0,
	    dingbats: 1,
	    piCharacters: 2,
	    fleurons: 3,
	    decorativeBorders: 4,
	    internationalSymbols: 5,
	    mathSymbols: 6
	  },
	  characterAlternatives: {
	    code: 17,
	    exclusive: true,
	    noAlternates: 0
	  },
	  // user defined options
	  designComplexity: {
	    code: 18,
	    exclusive: true,
	    designLevel1: 0,
	    designLevel2: 1,
	    designLevel3: 2,
	    designLevel4: 3,
	    designLevel5: 4
	  },
	  styleOptions: {
	    code: 19,
	    exclusive: true,
	    noStyleOptions: 0,
	    displayText: 1,
	    engravedText: 2,
	    illuminatedCaps: 3,
	    titlingCaps: 4,
	    tallCaps: 5
	  },
	  characterShape: {
	    code: 20,
	    exclusive: true,
	    traditionalCharacters: 0,
	    simplifiedCharacters: 1,
	    JIS1978Characters: 2,
	    JIS1983Characters: 3,
	    JIS1990Characters: 4,
	    traditionalAltOne: 5,
	    traditionalAltTwo: 6,
	    traditionalAltThree: 7,
	    traditionalAltFour: 8,
	    traditionalAltFive: 9,
	    expertCharacters: 10,
	    JIS2004Characters: 11,
	    hojoCharacters: 12,
	    NLCCharacters: 13,
	    traditionalNamesCharacters: 14
	  },
	  numberCase: {
	    code: 21,
	    exclusive: true,
	    lowerCaseNumbers: 0,
	    upperCaseNumbers: 1
	  },
	  textSpacing: {
	    code: 22,
	    exclusive: true,
	    proportionalText: 0,
	    monospacedText: 1,
	    halfWidthText: 2,
	    thirdWidthText: 3,
	    quarterWidthText: 4,
	    altProportionalText: 5,
	    altHalfWidthText: 6
	  },
	  transliteration: {
	    code: 23,
	    exclusive: true,
	    noTransliteration: 0
	  },
	  // hanjaToHangul: 1
	  // hiraganaToKatakana: 2
	  // katakanaToHiragana: 3
	  // kanaToRomanization: 4
	  // romanizationToHiragana: 5
	  // romanizationToKatakana: 6
	  // hanjaToHangulAltOne: 7
	  // hanjaToHangulAltTwo: 8
	  // hanjaToHangulAltThree: 9
	  annotation: {
	    code: 24,
	    exclusive: true,
	    noAnnotation: 0,
	    boxAnnotation: 1,
	    roundedBoxAnnotation: 2,
	    circleAnnotation: 3,
	    invertedCircleAnnotation: 4,
	    parenthesisAnnotation: 5,
	    periodAnnotation: 6,
	    romanNumeralAnnotation: 7,
	    diamondAnnotation: 8,
	    invertedBoxAnnotation: 9,
	    invertedRoundedBoxAnnotation: 10
	  },
	  kanaSpacing: {
	    code: 25,
	    exclusive: true,
	    fullWidthKana: 0,
	    proportionalKana: 1
	  },
	  ideographicSpacing: {
	    code: 26,
	    exclusive: true,
	    fullWidthIdeographs: 0,
	    proportionalIdeographs: 1,
	    halfWidthIdeographs: 2
	  },
	  unicodeDecomposition: {
	    code: 27,
	    exclusive: false,
	    canonicalComposition: 0,
	    compatibilityComposition: 2,
	    transcodingComposition: 4
	  },
	  rubyKana: {
	    code: 28,
	    exclusive: false,
	    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
	    // rubyKana: 1     # deprecated - use rubyKanaOn instead
	    rubyKana: 2
	  },
	  CJKSymbolAlternatives: {
	    code: 29,
	    exclusive: true,
	    noCJKSymbolAlternatives: 0,
	    CJKSymbolAltOne: 1,
	    CJKSymbolAltTwo: 2,
	    CJKSymbolAltThree: 3,
	    CJKSymbolAltFour: 4,
	    CJKSymbolAltFive: 5
	  },
	  ideographicAlternatives: {
	    code: 30,
	    exclusive: true,
	    noIdeographicAlternatives: 0,
	    ideographicAltOne: 1,
	    ideographicAltTwo: 2,
	    ideographicAltThree: 3,
	    ideographicAltFour: 4,
	    ideographicAltFive: 5
	  },
	  CJKVerticalRomanPlacement: {
	    code: 31,
	    exclusive: true,
	    CJKVerticalRomanCentered: 0,
	    CJKVerticalRomanHBaseline: 1
	  },
	  italicCJKRoman: {
	    code: 32,
	    exclusive: false,
	    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
	    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
	    CJKItalicRoman: 2
	  },
	  caseSensitiveLayout: {
	    code: 33,
	    exclusive: false,
	    caseSensitiveLayout: 0,
	    caseSensitiveSpacing: 2
	  },
	  alternateKana: {
	    code: 34,
	    exclusive: false,
	    alternateHorizKana: 0,
	    alternateVertKana: 2
	  },
	  stylisticAlternatives: {
	    code: 35,
	    exclusive: false,
	    noStylisticAlternates: 0,
	    stylisticAltOne: 2,
	    stylisticAltTwo: 4,
	    stylisticAltThree: 6,
	    stylisticAltFour: 8,
	    stylisticAltFive: 10,
	    stylisticAltSix: 12,
	    stylisticAltSeven: 14,
	    stylisticAltEight: 16,
	    stylisticAltNine: 18,
	    stylisticAltTen: 20,
	    stylisticAltEleven: 22,
	    stylisticAltTwelve: 24,
	    stylisticAltThirteen: 26,
	    stylisticAltFourteen: 28,
	    stylisticAltFifteen: 30,
	    stylisticAltSixteen: 32,
	    stylisticAltSeventeen: 34,
	    stylisticAltEighteen: 36,
	    stylisticAltNineteen: 38,
	    stylisticAltTwenty: 40
	  },
	  contextualAlternates: {
	    code: 36,
	    exclusive: false,
	    contextualAlternates: 0,
	    swashAlternates: 2,
	    contextualSwashAlternates: 4
	  },
	  lowerCase: {
	    code: 37,
	    exclusive: true,
	    defaultLowerCase: 0,
	    lowerCaseSmallCaps: 1,
	    lowerCasePetiteCaps: 2
	  },
	  upperCase: {
	    code: 38,
	    exclusive: true,
	    defaultUpperCase: 0,
	    upperCaseSmallCaps: 1,
	    upperCasePetiteCaps: 2
	  },
	  languageTag: { // indices into ltag table
	    code: 39,
	    exclusive: true
	  },
	  CJKRomanSpacing: {
	    code: 103,
	    exclusive: true,
	    halfWidthCJKRoman: 0,
	    proportionalCJKRoman: 1,
	    defaultCJKRoman: 2,
	    fullWidthCJKRoman: 3
	  }
	};
	
	var feature = function feature(name, selector) {
	  return [features[name].code, features[name][selector]];
	};
	
	var OTMapping = {
	  rlig: feature('ligatures', 'requiredLigatures'),
	  clig: feature('ligatures', 'contextualLigatures'),
	  dlig: feature('ligatures', 'rareLigatures'),
	  hlig: feature('ligatures', 'historicalLigatures'),
	  liga: feature('ligatures', 'commonLigatures'),
	  hist: feature('ligatures', 'historicalLigatures'), // ??
	
	  smcp: feature('lowerCase', 'lowerCaseSmallCaps'),
	  pcap: feature('lowerCase', 'lowerCasePetiteCaps'),
	
	  frac: feature('fractions', 'diagonalFractions'),
	  dnom: feature('fractions', 'diagonalFractions'), // ??
	  numr: feature('fractions', 'diagonalFractions'), // ??
	  afrc: feature('fractions', 'verticalFractions'),
	  // aalt
	  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
	  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
	  // unic, vatu, vhal, vjmo, vpal, vrt2
	  // dist -> trak table?
	  // kern, vkrn -> kern table
	  // lfbd + opbd + rtbd -> opbd table?
	  // mark, mkmk -> acnt table?
	  // locl -> languageTag + ltag table
	
	  case: feature('caseSensitiveLayout', 'caseSensitiveLayout'), // also caseSensitiveSpacing
	  ccmp: feature('unicodeDecomposition', 'canonicalComposition'), // compatibilityComposition?
	  cpct: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'), // guess..., probably not given below
	  valt: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
	  swsh: feature('contextualAlternates', 'swashAlternates'),
	  cswh: feature('contextualAlternates', 'contextualSwashAlternates'),
	  curs: feature('cursiveConnection', 'cursive'), // ??
	  c2pc: feature('upperCase', 'upperCasePetiteCaps'),
	  c2sc: feature('upperCase', 'upperCaseSmallCaps'),
	
	  init: feature('smartSwash', 'wordInitialSwashes'), // ??
	  fin2: feature('smartSwash', 'wordFinalSwashes'), // ??
	  medi: feature('smartSwash', 'nonFinalSwashes'), // ??
	  med2: feature('smartSwash', 'nonFinalSwashes'), // ??
	  fin3: feature('smartSwash', 'wordFinalSwashes'), // ??
	  fina: feature('smartSwash', 'wordFinalSwashes'), // ??
	
	  pkna: feature('kanaSpacing', 'proportionalKana'),
	  half: feature('textSpacing', 'halfWidthText'), // also HalfWidthCJKRoman, HalfWidthIdeographs?
	  halt: feature('textSpacing', 'altHalfWidthText'),
	
	  hkna: feature('alternateKana', 'alternateHorizKana'),
	  vkna: feature('alternateKana', 'alternateVertKana'),
	  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
	
	  ital: feature('italicCJKRoman', 'CJKItalicRoman'),
	  lnum: feature('numberCase', 'upperCaseNumbers'),
	  onum: feature('numberCase', 'lowerCaseNumbers'),
	  mgrk: feature('mathematicalExtras', 'mathematicalGreek'),
	
	  // nalt: not enough info. what type of annotation?
	  // ornm: ditto, which ornament style?
	
	  calt: feature('contextualAlternates', 'contextualAlternates'), // or more?
	  vrt2: feature('verticalSubstitution', 'substituteVerticalForms'), // oh... below?
	  vert: feature('verticalSubstitution', 'substituteVerticalForms'),
	  tnum: feature('numberSpacing', 'monospacedNumbers'),
	  pnum: feature('numberSpacing', 'proportionalNumbers'),
	  sups: feature('verticalPosition', 'superiors'),
	  subs: feature('verticalPosition', 'inferiors'),
	  ordn: feature('verticalPosition', 'ordinals'),
	  pwid: feature('textSpacing', 'proportionalText'),
	  hwid: feature('textSpacing', 'halfWidthText'),
	  qwid: feature('textSpacing', 'quarterWidthText'), // also QuarterWidthNumbers?
	  twid: feature('textSpacing', 'thirdWidthText'), // also ThirdWidthNumbers?
	  fwid: feature('textSpacing', 'proportionalText'), //??
	  palt: feature('textSpacing', 'altProportionalText'),
	  trad: feature('characterShape', 'traditionalCharacters'),
	  smpl: feature('characterShape', 'simplifiedCharacters'),
	  jp78: feature('characterShape', 'JIS1978Characters'),
	  jp83: feature('characterShape', 'JIS1983Characters'),
	  jp90: feature('characterShape', 'JIS1990Characters'),
	  jp04: feature('characterShape', 'JIS2004Characters'),
	  expt: feature('characterShape', 'expertCharacters'),
	  hojo: feature('characterShape', 'hojoCharacters'),
	  nlck: feature('characterShape', 'NLCCharacters'),
	  tnam: feature('characterShape', 'traditionalNamesCharacters'),
	  ruby: feature('rubyKana', 'rubyKana'),
	  titl: feature('styleOptions', 'titlingCaps'),
	  zero: feature('typographicExtras', 'slashedZero'),
	
	  ss01: feature('stylisticAlternatives', 'stylisticAltOne'),
	  ss02: feature('stylisticAlternatives', 'stylisticAltTwo'),
	  ss03: feature('stylisticAlternatives', 'stylisticAltThree'),
	  ss04: feature('stylisticAlternatives', 'stylisticAltFour'),
	  ss05: feature('stylisticAlternatives', 'stylisticAltFive'),
	  ss06: feature('stylisticAlternatives', 'stylisticAltSix'),
	  ss07: feature('stylisticAlternatives', 'stylisticAltSeven'),
	  ss08: feature('stylisticAlternatives', 'stylisticAltEight'),
	  ss09: feature('stylisticAlternatives', 'stylisticAltNine'),
	  ss10: feature('stylisticAlternatives', 'stylisticAltTen'),
	  ss11: feature('stylisticAlternatives', 'stylisticAltEleven'),
	  ss12: feature('stylisticAlternatives', 'stylisticAltTwelve'),
	  ss13: feature('stylisticAlternatives', 'stylisticAltThirteen'),
	  ss14: feature('stylisticAlternatives', 'stylisticAltFourteen'),
	  ss15: feature('stylisticAlternatives', 'stylisticAltFifteen'),
	  ss16: feature('stylisticAlternatives', 'stylisticAltSixteen'),
	  ss17: feature('stylisticAlternatives', 'stylisticAltSeventeen'),
	  ss18: feature('stylisticAlternatives', 'stylisticAltEighteen'),
	  ss19: feature('stylisticAlternatives', 'stylisticAltNineteen'),
	  ss20: feature('stylisticAlternatives', 'stylisticAltTwenty')
	};
	
	// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
	
	// Add cv01-cv99 features
	for (var i = 1; i <= 99; i++) {
	  OTMapping['cv' + ('00' + i).slice(-2)] = [features.characterAlternatives.code, i];
	}
	
	// create inverse mapping
	var AATMapping = {};
	for (var ot in OTMapping) {
	  var aat = OTMapping[ot];
	  if (AATMapping[aat[0]] == null) {
	    AATMapping[aat[0]] = {};
	  }
	
	  AATMapping[aat[0]][aat[1]] = ot;
	}
	
	// Maps an array of OpenType features to AAT features
	// in the form of {featureType:{featureSetting:true}}
	function mapOTToAAT(features) {
	  var res = {};
	  for (var k in features) {
	    var r = void 0;
	    if (r = OTMapping[k]) {
	      if (res[r[0]] == null) {
	        res[r[0]] = {};
	      }
	
	      res[r[0]][r[1]] = features[k];
	    }
	  }
	
	  return res;
	}
	
	// Maps strings in a [featureType, featureSetting]
	// to their equivalent number codes
	function mapFeatureStrings(f) {
	  var type = f[0],
	      setting = f[1];
	
	  if (isNaN(type)) {
	    var typeCode = features[type] && features[type].code;
	  } else {
	    var typeCode = type;
	  }
	
	  if (isNaN(setting)) {
	    var settingCode = features[type] && features[type][setting];
	  } else {
	    var settingCode = setting;
	  }
	
	  return [typeCode, settingCode];
	}
	
	// Maps AAT features to an array of OpenType features
	// Supports both arrays in the form of [[featureType, featureSetting]]
	// and objects in the form of {featureType:{featureSetting:true}}
	// featureTypes and featureSettings can be either strings or number codes
	function mapAATToOT(features) {
	  var res = {};
	  if (Array.isArray(features)) {
	    for (var k = 0; k < features.length; k++) {
	      var r = void 0;
	      var f = mapFeatureStrings(features[k]);
	      if (r = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) {
	        res[r] = true;
	      }
	    }
	  } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	    for (var type in features) {
	      var _feature = features[type];
	      for (var setting in _feature) {
	        var _r = void 0;
	        var _f = mapFeatureStrings([type, setting]);
	        if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) {
	          res[_r] = true;
	        }
	      }
	    }
	  }
	
	  return _Object$keys(res);
	}
	
	var _class$3;
	function _applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var AATLookupTable = (_class$3 = function () {
	  function AATLookupTable(table) {
	    _classCallCheck(this, AATLookupTable);
	
	    this.table = table;
	  }
	
	  AATLookupTable.prototype.lookup = function lookup(glyph) {
	    switch (this.table.version) {
	      case 0:
	        // simple array format
	        return this.table.values.getItem(glyph);
	
	      case 2: // segment format
	      case 4:
	        {
	          var min = 0;
	          var max = this.table.binarySearchHeader.nUnits - 1;
	
	          while (min <= max) {
	            var mid = min + max >> 1;
	            var seg = this.table.segments[mid];
	
	            // special end of search value
	            if (seg.firstGlyph === 0xffff) {
	              return null;
	            }
	
	            if (glyph < seg.firstGlyph) {
	              max = mid - 1;
	            } else if (glyph > seg.lastGlyph) {
	              min = mid + 1;
	            } else {
	              if (this.table.version === 2) {
	                return seg.value;
	              } else {
	                return seg.values[glyph - seg.firstGlyph];
	              }
	            }
	          }
	
	          return null;
	        }
	
	      case 6:
	        {
	          // lookup single
	          var _min = 0;
	          var _max = this.table.binarySearchHeader.nUnits - 1;
	
	          while (_min <= _max) {
	            var mid = _min + _max >> 1;
	            var seg = this.table.segments[mid];
	
	            // special end of search value
	            if (seg.glyph === 0xffff) {
	              return null;
	            }
	
	            if (glyph < seg.glyph) {
	              _max = mid - 1;
	            } else if (glyph > seg.glyph) {
	              _min = mid + 1;
	            } else {
	              return seg.value;
	            }
	          }
	
	          return null;
	        }
	
	      case 8:
	        // lookup trimmed
	        return this.table.values[glyph - this.table.firstGlyph];
	
	      default:
	        throw new Error('Unknown lookup table format: ' + this.table.version);
	    }
	  };
	
	  AATLookupTable.prototype.glyphsForValue = function glyphsForValue(classValue) {
	    var res = [];
	
	    switch (this.table.version) {
	      case 2: // segment format
	      case 4:
	        {
	          for (var _iterator = this.table.segments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	            var _ref;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }
	
	            var segment = _ref;
	
	            if (this.table.version === 2 && segment.value === classValue) {
	              res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
	            } else {
	              for (var index = 0; index < segment.values.length; index++) {
	                if (segment.values[index] === classValue) {
	                  res.push(segment.firstGlyph + index);
	                }
	              }
	            }
	          }
	
	          break;
	        }
	
	      case 6:
	        {
	          // lookup single
	          for (var _iterator2 = this.table.segments, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	            var _ref2;
	
	            if (_isArray2) {
	              if (_i2 >= _iterator2.length) break;
	              _ref2 = _iterator2[_i2++];
	            } else {
	              _i2 = _iterator2.next();
	              if (_i2.done) break;
	              _ref2 = _i2.value;
	            }
	
	            var _segment = _ref2;
	
	            if (_segment.value === classValue) {
	              res.push(_segment.glyph);
	            }
	          }
	
	          break;
	        }
	
	      case 8:
	        {
	          // lookup trimmed
	          for (var i = 0; i < this.table.values.length; i++) {
	            if (this.table.values[i] === classValue) {
	              res.push(this.table.firstGlyph + i);
	            }
	          }
	
	          break;
	        }
	
	      default:
	        throw new Error('Unknown lookup table format: ' + this.table.version);
	    }
	
	    return res;
	  };
	
	  return AATLookupTable;
	}(), (_applyDecoratedDescriptor$3(_class$3.prototype, 'glyphsForValue', [cache], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'glyphsForValue'), _class$3.prototype)), _class$3);
	
	var START_OF_TEXT_STATE = 0;
	var END_OF_TEXT_CLASS = 0;
	var OUT_OF_BOUNDS_CLASS = 1;
	var DELETED_GLYPH_CLASS = 2;
	var DONT_ADVANCE = 0x4000;
	
	var AATStateMachine = function () {
	  function AATStateMachine(stateTable) {
	    _classCallCheck(this, AATStateMachine);
	
	    this.stateTable = stateTable;
	    this.lookupTable = new AATLookupTable(stateTable.classTable);
	  }
	
	  AATStateMachine.prototype.process = function process(glyphs, reverse, processEntry) {
	    var currentState = START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
	    var index = reverse ? glyphs.length - 1 : 0;
	    var dir = reverse ? -1 : 1;
	
	    while (dir === 1 && index <= glyphs.length || dir === -1 && index >= -1) {
	      var glyph = null;
	      var classCode = OUT_OF_BOUNDS_CLASS;
	      var shouldAdvance = true;
	
	      if (index === glyphs.length || index === -1) {
	        classCode = END_OF_TEXT_CLASS;
	      } else {
	        glyph = glyphs[index];
	        if (glyph.id === 0xffff) {
	          // deleted glyph
	          classCode = DELETED_GLYPH_CLASS;
	        } else {
	          classCode = this.lookupTable.lookup(glyph.id);
	          if (classCode == null) {
	            classCode = OUT_OF_BOUNDS_CLASS;
	          }
	        }
	      }
	
	      var row = this.stateTable.stateArray.getItem(currentState);
	      var entryIndex = row[classCode];
	      var entry = this.stateTable.entryTable.getItem(entryIndex);
	
	      if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
	        processEntry(glyph, entry, index);
	        shouldAdvance = !(entry.flags & DONT_ADVANCE);
	      }
	
	      currentState = entry.newState;
	      if (shouldAdvance) {
	        index += dir;
	      }
	    }
	
	    return glyphs;
	  };
	
	  /**
	   * Performs a depth-first traversal of the glyph strings
	   * represented by the state machine.
	   */
	
	
	  AATStateMachine.prototype.traverse = function traverse(opts) {
	    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Set();
	
	    if (visited.has(state)) {
	      return;
	    }
	
	    visited.add(state);
	
	    var _stateTable = this.stateTable,
	        nClasses = _stateTable.nClasses,
	        stateArray = _stateTable.stateArray,
	        entryTable = _stateTable.entryTable;
	
	    var row = stateArray.getItem(state);
	
	    // Skip predefined classes
	    for (var classCode = 4; classCode < nClasses; classCode++) {
	      var entryIndex = row[classCode];
	      var entry = entryTable.getItem(entryIndex);
	
	      // Try all glyphs in the class
	      for (var _iterator = this.lookupTable.glyphsForValue(classCode), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var glyph = _ref;
	
	        if (opts.enter) {
	          opts.enter(glyph, entry);
	        }
	
	        if (entry.newState !== 0) {
	          this.traverse(opts, entry.newState, visited);
	        }
	
	        if (opts.exit) {
	          opts.exit(glyph, entry);
	        }
	      }
	    }
	  };
	
	  return AATStateMachine;
	}();
	
	var _class$2;
	function _applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	// indic replacement flags
	var MARK_FIRST = 0x8000;
	var MARK_LAST = 0x2000;
	var VERB = 0x000F;
	
	// contextual substitution and glyph insertion flag
	var SET_MARK = 0x8000;
	
	// ligature entry flags
	var SET_COMPONENT = 0x8000;
	var PERFORM_ACTION = 0x2000;
	
	// ligature action masks
	var LAST_MASK = 0x80000000;
	var STORE_MASK = 0x40000000;
	var OFFSET_MASK = 0x3FFFFFFF;
	
	var REVERSE_DIRECTION = 0x400000;
	var CURRENT_INSERT_BEFORE = 0x0800;
	var MARKED_INSERT_BEFORE = 0x0400;
	var CURRENT_INSERT_COUNT = 0x03E0;
	var MARKED_INSERT_COUNT = 0x001F;
	
	var AATMorxProcessor = (_class$2 = function () {
	  function AATMorxProcessor(font) {
	    _classCallCheck(this, AATMorxProcessor);
	
	    this.processIndicRearragement = this.processIndicRearragement.bind(this);
	    this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
	    this.processLigature = this.processLigature.bind(this);
	    this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
	    this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
	    this.font = font;
	    this.morx = font.morx;
	    this.inputCache = null;
	  }
	
	  // Processes an array of glyphs and applies the specified features
	  // Features should be in the form of {featureType:{featureSetting:true}}
	
	
	  AATMorxProcessor.prototype.process = function process(glyphs) {
	    var features = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    for (var _iterator = this.morx.chains, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var chain = _ref;
	
	      var flags = chain.defaultFlags;
	
	      // enable/disable the requested features
	      for (var _iterator2 = chain.features, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var feature = _ref2;
	
	        var f = void 0;
	        if ((f = features[feature.featureType]) && f[feature.featureSetting]) {
	          flags &= feature.disableFlags;
	          flags |= feature.enableFlags;
	        }
	      }
	
	      for (var _iterator3 = chain.subtables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var subtable = _ref3;
	
	        if (subtable.subFeatureFlags & flags) {
	          this.processSubtable(subtable, glyphs);
	        }
	      }
	    }
	
	    // remove deleted glyphs
	    var index = glyphs.length - 1;
	    while (index >= 0) {
	      if (glyphs[index].id === 0xffff) {
	        glyphs.splice(index, 1);
	      }
	
	      index--;
	    }
	
	    return glyphs;
	  };
	
	  AATMorxProcessor.prototype.processSubtable = function processSubtable(subtable, glyphs) {
	    this.subtable = subtable;
	    this.glyphs = glyphs;
	    if (this.subtable.type === 4) {
	      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
	      return;
	    }
	
	    this.ligatureStack = [];
	    this.markedGlyph = null;
	    this.firstGlyph = null;
	    this.lastGlyph = null;
	    this.markedIndex = null;
	
	    var stateMachine = this.getStateMachine(subtable);
	    var process = this.getProcessor();
	
	    var reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
	    return stateMachine.process(this.glyphs, reverse, process);
	  };
	
	  AATMorxProcessor.prototype.getStateMachine = function getStateMachine(subtable) {
	    return new AATStateMachine(subtable.table.stateTable);
	  };
	
	  AATMorxProcessor.prototype.getProcessor = function getProcessor() {
	    switch (this.subtable.type) {
	      case 0:
	        return this.processIndicRearragement;
	      case 1:
	        return this.processContextualSubstitution;
	      case 2:
	        return this.processLigature;
	      case 4:
	        return this.processNoncontextualSubstitutions;
	      case 5:
	        return this.processGlyphInsertion;
	      default:
	        throw new Error('Invalid morx subtable type: ' + this.subtable.type);
	    }
	  };
	
	  AATMorxProcessor.prototype.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
	    if (entry.flags & MARK_FIRST) {
	      this.firstGlyph = index;
	    }
	
	    if (entry.flags & MARK_LAST) {
	      this.lastGlyph = index;
	    }
	
	    reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
	  };
	
	  AATMorxProcessor.prototype.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
	    var subsitutions = this.subtable.table.substitutionTable.items;
	    if (entry.markIndex !== 0xffff) {
	      var lookup = subsitutions.getItem(entry.markIndex);
	      var lookupTable = new AATLookupTable(lookup);
	      glyph = this.glyphs[this.markedGlyph];
	      var gid = lookupTable.lookup(glyph.id);
	      if (gid) {
	        this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
	      }
	    }
	
	    if (entry.currentIndex !== 0xffff) {
	      var _lookup = subsitutions.getItem(entry.currentIndex);
	      var _lookupTable = new AATLookupTable(_lookup);
	      glyph = this.glyphs[index];
	      var gid = _lookupTable.lookup(glyph.id);
	      if (gid) {
	        this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
	      }
	    }
	
	    if (entry.flags & SET_MARK) {
	      this.markedGlyph = index;
	    }
	  };
	
	  AATMorxProcessor.prototype.processLigature = function processLigature(glyph, entry, index) {
	    if (entry.flags & SET_COMPONENT) {
	      this.ligatureStack.push(index);
	    }
	
	    if (entry.flags & PERFORM_ACTION) {
	      var _ligatureStack;
	
	      var actions = this.subtable.table.ligatureActions;
	      var components = this.subtable.table.components;
	      var ligatureList = this.subtable.table.ligatureList;
	
	      var actionIndex = entry.action;
	      var last = false;
	      var ligatureIndex = 0;
	      var codePoints = [];
	      var ligatureGlyphs = [];
	
	      while (!last) {
	        var _codePoints;
	
	        var componentGlyph = this.ligatureStack.pop();
	        (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);
	
	        var action = actions.getItem(actionIndex++);
	        last = !!(action & LAST_MASK);
	        var store = !!(action & STORE_MASK);
	        var offset = (action & OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
	        offset += this.glyphs[componentGlyph].id;
	
	        var component = components.getItem(offset);
	        ligatureIndex += component;
	
	        if (last || store) {
	          var ligatureEntry = ligatureList.getItem(ligatureIndex);
	          this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
	          ligatureGlyphs.push(componentGlyph);
	          ligatureIndex = 0;
	          codePoints = [];
	        } else {
	          this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
	        }
	      }
	
	      // Put ligature glyph indexes back on the stack
	      (_ligatureStack = this.ligatureStack).push.apply(_ligatureStack, ligatureGlyphs);
	    }
	  };
	
	  AATMorxProcessor.prototype.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
	    var lookupTable = new AATLookupTable(subtable.table.lookupTable);
	
	    for (index = 0; index < glyphs.length; index++) {
	      var glyph = glyphs[index];
	      if (glyph.id !== 0xffff) {
	        var gid = lookupTable.lookup(glyph.id);
	        if (gid) {
	          // 0 means do nothing
	          glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
	        }
	      }
	    }
	  };
	
	  AATMorxProcessor.prototype._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
	    var _glyphs;
	
	    var insertions = [];
	    while (count--) {
	      var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
	      insertions.push(this.font.getGlyph(gid));
	    }
	
	    if (!isBefore) {
	      glyphIndex++;
	    }
	
	    (_glyphs = this.glyphs).splice.apply(_glyphs, [glyphIndex, 0].concat(insertions));
	  };
	
	  AATMorxProcessor.prototype.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
	    if (entry.flags & SET_MARK) {
	      this.markedIndex = index;
	    }
	
	    if (entry.markedInsertIndex !== 0xffff) {
	      var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
	      var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
	      this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
	    }
	
	    if (entry.currentInsertIndex !== 0xffff) {
	      var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
	      var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
	      this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
	    }
	  };
	
	  AATMorxProcessor.prototype.getSupportedFeatures = function getSupportedFeatures() {
	    var features = [];
	    for (var _iterator4 = this.morx.chains, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	      var _ref4;
	
	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }
	
	      var chain = _ref4;
	
	      for (var _iterator5 = chain.features, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	        var _ref5;
	
	        if (_isArray5) {
	          if (_i5 >= _iterator5.length) break;
	          _ref5 = _iterator5[_i5++];
	        } else {
	          _i5 = _iterator5.next();
	          if (_i5.done) break;
	          _ref5 = _i5.value;
	        }
	
	        var feature = _ref5;
	
	        features.push([feature.featureType, feature.featureSetting]);
	      }
	    }
	
	    return features;
	  };
	
	  AATMorxProcessor.prototype.generateInputs = function generateInputs(gid) {
	    if (!this.inputCache) {
	      this.generateInputCache();
	    }
	
	    return this.inputCache[gid] || [];
	  };
	
	  AATMorxProcessor.prototype.generateInputCache = function generateInputCache() {
	    this.inputCache = {};
	
	    for (var _iterator6 = this.morx.chains, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
	      var _ref6;
	
	      if (_isArray6) {
	        if (_i6 >= _iterator6.length) break;
	        _ref6 = _iterator6[_i6++];
	      } else {
	        _i6 = _iterator6.next();
	        if (_i6.done) break;
	        _ref6 = _i6.value;
	      }
	
	      var chain = _ref6;
	
	      var flags = chain.defaultFlags;
	
	      for (var _iterator7 = chain.subtables, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
	        var _ref7;
	
	        if (_isArray7) {
	          if (_i7 >= _iterator7.length) break;
	          _ref7 = _iterator7[_i7++];
	        } else {
	          _i7 = _iterator7.next();
	          if (_i7.done) break;
	          _ref7 = _i7.value;
	        }
	
	        var subtable = _ref7;
	
	        if (subtable.subFeatureFlags & flags) {
	          this.generateInputsForSubtable(subtable);
	        }
	      }
	    }
	  };
	
	  AATMorxProcessor.prototype.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
	    var _this = this;
	
	    // Currently, only supporting ligature subtables.
	    if (subtable.type !== 2) {
	      return;
	    }
	
	    var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
	    if (reverse) {
	      throw new Error('Reverse subtable, not supported.');
	    }
	
	    this.subtable = subtable;
	    this.ligatureStack = [];
	
	    var stateMachine = this.getStateMachine(subtable);
	    var process = this.getProcessor();
	
	    var input = [];
	    var stack = [];
	    this.glyphs = [];
	
	    stateMachine.traverse({
	      enter: function enter(glyph, entry) {
	        var glyphs = _this.glyphs;
	        stack.push({
	          glyphs: glyphs.slice(),
	          ligatureStack: _this.ligatureStack.slice()
	        });
	
	        // Add glyph to input and glyphs to process.
	        var g = _this.font.getGlyph(glyph);
	        input.push(g);
	        glyphs.push(input[input.length - 1]);
	
	        // Process ligature substitution
	        process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
	
	        // Add input to result if only one matching (non-deleted) glyph remains.
	        var count = 0;
	        var found = 0;
	        for (var i = 0; i < glyphs.length && count <= 1; i++) {
	          if (glyphs[i].id !== 0xffff) {
	            count++;
	            found = glyphs[i].id;
	          }
	        }
	
	        if (count === 1) {
	          var result = input.map(function (g) {
	            return g.id;
	          });
	          var _cache = _this.inputCache[found];
	          if (_cache) {
	            _cache.push(result);
	          } else {
	            _this.inputCache[found] = [result];
	          }
	        }
	      },
	
	      exit: function exit() {
	        var _stack$pop = stack.pop();
	
	        _this.glyphs = _stack$pop.glyphs;
	        _this.ligatureStack = _stack$pop.ligatureStack;
	
	        input.pop();
	      }
	    });
	  };
	
	  return AATMorxProcessor;
	}(), (_applyDecoratedDescriptor$2(_class$2.prototype, 'getStateMachine', [cache], _Object$getOwnPropertyDescriptor(_class$2.prototype, 'getStateMachine'), _class$2.prototype)), _class$2);
	
	function swap(glyphs, rangeA, rangeB) {
	  var reverseA = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  var reverseB = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
	  if (reverseB) {
	    end.reverse();
	  }
	
	  var start = glyphs.splice.apply(glyphs, [rangeA[0], rangeA[1]].concat(end));
	  if (reverseA) {
	    start.reverse();
	  }
	
	  glyphs.splice.apply(glyphs, [rangeB[0] - (rangeA[1] - 1), 0].concat(start));
	  return glyphs;
	}
	
	function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
	  var length = lastGlyph - firstGlyph + 1;
	  switch (verb) {
	    case 0:
	      // no change
	      return glyphs;
	
	    case 1:
	      // Ax => xA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 0]);
	
	    case 2:
	      // xD => Dx
	      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 1]);
	
	    case 3:
	      // AxD => DxA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 1]);
	
	    case 4:
	      // ABx => xAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0]);
	
	    case 5:
	      // ABx => xBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0], true, false);
	
	    case 6:
	      // xCD => CDx
	      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2]);
	
	    case 7:
	      // xCD => DCx
	      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2], false, true);
	
	    case 8:
	      // AxCD => CDxA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2]);
	
	    case 9:
	      // AxCD => DCxA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2], false, true);
	
	    case 10:
	      // ABxD => DxAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1]);
	
	    case 11:
	      // ABxD => DxBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1], true, false);
	
	    case 12:
	      // ABxCD => CDxAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2]);
	
	    case 13:
	      // ABxCD => CDxBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, false);
	
	    case 14:
	      // ABxCD => DCxAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], false, true);
	
	    case 15:
	      // ABxCD => DCxBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, true);
	
	    default:
	      throw new Error('Unknown verb: ' + verb);
	  }
	}
	
	var AATLayoutEngine = function () {
	  function AATLayoutEngine(font) {
	    _classCallCheck(this, AATLayoutEngine);
	
	    this.font = font;
	    this.morxProcessor = new AATMorxProcessor(font);
	    this.fallbackPosition = false;
	  }
	
	  AATLayoutEngine.prototype.substitute = function substitute(glyphRun) {
	    // AAT expects the glyphs to be in visual order prior to morx processing,
	    // so reverse the glyphs if the script is right-to-left.
	    if (glyphRun.direction === 'rtl') {
	      glyphRun.glyphs.reverse();
	    }
	
	    this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
	  };
	
	  AATLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    return mapAATToOT(this.morxProcessor.getSupportedFeatures());
	  };
	
	  AATLayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
	    var glyphStrings = this.morxProcessor.generateInputs(gid);
	    var result = new _Set();
	
	    for (var _iterator = glyphStrings, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var glyphs = _ref;
	
	      this._addStrings(glyphs, 0, result, '');
	    }
	
	    return result;
	  };
	
	  AATLayoutEngine.prototype._addStrings = function _addStrings(glyphs, index, strings, string) {
	    var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
	
	    for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var codePoint = _ref2;
	
	      var s = string + _String$fromCodePoint(codePoint);
	      if (index < glyphs.length - 1) {
	        this._addStrings(glyphs, index + 1, strings, s);
	      } else {
	        strings.add(s);
	      }
	    }
	  };
	
	  return AATLayoutEngine;
	}();
	
	/**
	 * ShapingPlans are used by the OpenType shapers to store which
	 * features should by applied, and in what order to apply them.
	 * The features are applied in groups called stages. A feature
	 * can be applied globally to all glyphs, or locally to only
	 * specific glyphs.
	 *
	 * @private
	 */
	
	var ShapingPlan = function () {
	  function ShapingPlan(font, script, direction) {
	    _classCallCheck(this, ShapingPlan);
	
	    this.font = font;
	    this.script = script;
	    this.direction = direction;
	    this.stages = [];
	    this.globalFeatures = {};
	    this.allFeatures = {};
	  }
	
	  /**
	   * Adds the given features to the last stage.
	   * Ignores features that have already been applied.
	   */
	
	
	  ShapingPlan.prototype._addFeatures = function _addFeatures(features, global) {
	    var stageIndex = this.stages.length - 1;
	    var stage = this.stages[stageIndex];
	    for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var feature = _ref;
	
	      if (this.allFeatures[feature] == null) {
	        stage.push(feature);
	        this.allFeatures[feature] = stageIndex;
	
	        if (global) {
	          this.globalFeatures[feature] = true;
	        }
	      }
	    }
	  };
	
	  /**
	   * Add features to the last stage
	   */
	
	
	  ShapingPlan.prototype.add = function add(arg) {
	    var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (this.stages.length === 0) {
	      this.stages.push([]);
	    }
	
	    if (typeof arg === 'string') {
	      arg = [arg];
	    }
	
	    if (Array.isArray(arg)) {
	      this._addFeatures(arg, global);
	    } else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
	      this._addFeatures(arg.global || [], true);
	      this._addFeatures(arg.local || [], false);
	    } else {
	      throw new Error("Unsupported argument to ShapingPlan#add");
	    }
	  };
	
	  /**
	   * Add a new stage
	   */
	
	
	  ShapingPlan.prototype.addStage = function addStage(arg, global) {
	    if (typeof arg === 'function') {
	      this.stages.push(arg, []);
	    } else {
	      this.stages.push([]);
	      this.add(arg, global);
	    }
	  };
	
	  ShapingPlan.prototype.setFeatureOverrides = function setFeatureOverrides(features) {
	    if (Array.isArray(features)) {
	      this.add(features);
	    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	      for (var tag in features) {
	        if (features[tag]) {
	          this.add(tag);
	        } else if (this.allFeatures[tag] != null) {
	          var stage = this.stages[this.allFeatures[tag]];
	          stage.splice(stage.indexOf(tag), 1);
	          delete this.allFeatures[tag];
	          delete this.globalFeatures[tag];
	        }
	      }
	    }
	  };
	
	  /**
	   * Assigns the global features to the given glyphs
	   */
	
	
	  ShapingPlan.prototype.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
	    for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var glyph = _ref2;
	
	      for (var feature in this.globalFeatures) {
	        glyph.features[feature] = true;
	      }
	    }
	  };
	
	  /**
	   * Executes the planned stages using the given OTProcessor
	   */
	
	
	  ShapingPlan.prototype.process = function process(processor, glyphs, positions) {
	    for (var _iterator3 = this.stages, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var stage = _ref3;
	
	      if (typeof stage === 'function') {
	        if (!positions) {
	          stage(this.font, glyphs, this);
	        }
	      } else if (stage.length > 0) {
	        processor.applyFeatures(stage, glyphs, positions);
	      }
	    }
	  };
	
	  return ShapingPlan;
	}();
	
	var _class$4;
	var _temp;
	var VARIATION_FEATURES = ['rvrn'];
	var COMMON_FEATURES = ['ccmp', 'locl', 'rlig', 'mark', 'mkmk'];
	var FRACTIONAL_FEATURES = ['frac', 'numr', 'dnom'];
	var HORIZONTAL_FEATURES = ['calt', 'clig', 'liga', 'rclt', 'curs', 'kern'];
	var DIRECTIONAL_FEATURES = {
	  ltr: ['ltra', 'ltrm'],
	  rtl: ['rtla', 'rtlm']
	};
	
	var DefaultShaper = (_temp = _class$4 = function () {
	  function DefaultShaper() {
	    _classCallCheck(this, DefaultShaper);
	  }
	
	  DefaultShaper.plan = function plan(_plan, glyphs, features) {
	    // Plan the features we want to apply
	    this.planPreprocessing(_plan);
	    this.planFeatures(_plan);
	    this.planPostprocessing(_plan, features);
	
	    // Assign the global features to all the glyphs
	    _plan.assignGlobalFeatures(glyphs);
	
	    // Assign local features to glyphs
	    this.assignFeatures(_plan, glyphs);
	  };
	
	  DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
	    plan.add({
	      global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
	      local: FRACTIONAL_FEATURES
	    });
	  };
	
	  DefaultShaper.planFeatures = function planFeatures(plan) {
	    // Do nothing by default. Let subclasses override this.
	  };
	
	  DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
	    plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
	    plan.setFeatureOverrides(userFeatures);
	  };
	
	  DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    // Enable contextual fractions
	    for (var i = 0; i < glyphs.length; i++) {
	      var glyph = glyphs[i];
	      if (glyph.codePoints[0] === 0x2044) {
	        // fraction slash
	        var start = i;
	        var end = i + 1;
	
	        // Apply numerator
	        while (start > 0 && unicode.isDigit(glyphs[start - 1].codePoints[0])) {
	          glyphs[start - 1].features.numr = true;
	          glyphs[start - 1].features.frac = true;
	          start--;
	        }
	
	        // Apply denominator
	        while (end < glyphs.length && unicode.isDigit(glyphs[end].codePoints[0])) {
	          glyphs[end].features.dnom = true;
	          glyphs[end].features.frac = true;
	          end++;
	        }
	
	        // Apply fraction slash
	        glyph.features.frac = true;
	        i = end - 1;
	      }
	    }
	  };
	
	  return DefaultShaper;
	}(), _class$4.zeroMarkWidths = 'AFTER_GPOS', _temp);
	
	var trie = new UnicodeTrie(Buffer("AAEQAAAAAAAAADGgAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0=","base64"));
	var FEATURES = ['isol', 'fina', 'fin2', 'fin3', 'medi', 'med2', 'init'];
	
	var ShapingClasses = {
	  Non_Joining: 0,
	  Left_Joining: 1,
	  Right_Joining: 2,
	  Dual_Joining: 3,
	  Join_Causing: 3,
	  ALAPH: 4,
	  'DALATH RISH': 5,
	  Transparent: 6
	};
	
	var ISOL = 'isol';
	var FINA = 'fina';
	var FIN2 = 'fin2';
	var FIN3 = 'fin3';
	var MEDI = 'medi';
	var MED2 = 'med2';
	var INIT = 'init';
	var NONE = null;
	
	// Each entry is [prevAction, curAction, nextState]
	var STATE_TABLE = [
	//   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
	// State 0: prev was U,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 6]],
	
	// State 1: prev was R or ISOL/ALAPH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN2, 5], [NONE, ISOL, 6]],
	
	// State 2: prev was D/L in ISOL form,  willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [INIT, FINA, 1], [INIT, FINA, 3], [INIT, FINA, 4], [INIT, FINA, 6]],
	
	// State 3: prev was D in FINA form,  willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [MEDI, FINA, 1], [MEDI, FINA, 3], [MEDI, FINA, 4], [MEDI, FINA, 6]],
	
	// State 4: prev was FINA ALAPH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [MED2, ISOL, 1], [MED2, ISOL, 2], [MED2, FIN2, 5], [MED2, ISOL, 6]],
	
	// State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [ISOL, ISOL, 1], [ISOL, ISOL, 2], [ISOL, FIN2, 5], [ISOL, ISOL, 6]],
	
	// State 6: prev was DALATH/RISH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN3, 5], [NONE, ISOL, 6]]];
	
	/**
	 * This is a shaper for Arabic, and other cursive scripts.
	 * It uses data from ArabicShaping.txt in the Unicode database,
	 * compiled to a UnicodeTrie by generate-data.coffee.
	 *
	 * The shaping state machine was ported from Harfbuzz.
	 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
	 */
	
	var ArabicShaper = function (_DefaultShaper) {
	  _inherits(ArabicShaper, _DefaultShaper);
	
	  function ArabicShaper() {
	    _classCallCheck(this, ArabicShaper);
	
	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }
	
	  ArabicShaper.planFeatures = function planFeatures(plan) {
	    plan.add(['ccmp', 'locl']);
	    for (var i = 0; i < FEATURES.length; i++) {
	      var feature = FEATURES[i];
	      plan.addStage(feature, false);
	    }
	
	    plan.addStage('mset');
	  };
	
	  ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    _DefaultShaper.assignFeatures.call(this, plan, glyphs);
	
	    var prev = -1;
	    var state = 0;
	    var actions = [];
	
	    // Apply the state machine to map glyphs to features
	    for (var i = 0; i < glyphs.length; i++) {
	      var curAction = void 0,
	          prevAction = void 0;
	      var glyph = glyphs[i];
	      var type = getShapingClass(glyph.codePoints[0]);
	      if (type === ShapingClasses.Transparent) {
	        actions[i] = NONE;
	        continue;
	      }
	
	      var _STATE_TABLE$state$ty = STATE_TABLE[state][type];
	      prevAction = _STATE_TABLE$state$ty[0];
	      curAction = _STATE_TABLE$state$ty[1];
	      state = _STATE_TABLE$state$ty[2];
	
	
	      if (prevAction !== NONE && prev !== -1) {
	        actions[prev] = prevAction;
	      }
	
	      actions[i] = curAction;
	      prev = i;
	    }
	
	    // Apply the chosen features to their respective glyphs
	    for (var index = 0; index < glyphs.length; index++) {
	      var feature = void 0;
	      var glyph = glyphs[index];
	      if (feature = actions[index]) {
	        glyph.features[feature] = true;
	      }
	    }
	  };
	
	  return ArabicShaper;
	}(DefaultShaper);
	
	function getShapingClass(codePoint) {
	  var res = trie.get(codePoint);
	  if (res) {
	    return res - 1;
	  }
	
	  var category = unicode.getCategory(codePoint);
	  if (category === 'Mn' || category === 'Me' || category === 'Cf') {
	    return ShapingClasses.Transparent;
	  }
	
	  return ShapingClasses.Non_Joining;
	}
	
	var GlyphIterator = function () {
	  function GlyphIterator(glyphs, options) {
	    _classCallCheck(this, GlyphIterator);
	
	    this.glyphs = glyphs;
	    this.reset(options);
	  }
	
	  GlyphIterator.prototype.reset = function reset() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    this.options = options;
	    this.flags = options.flags || {};
	    this.markAttachmentType = options.markAttachmentType || 0;
	    this.index = index;
	  };
	
	  GlyphIterator.prototype.shouldIgnore = function shouldIgnore(glyph) {
	    return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
	  };
	
	  GlyphIterator.prototype.move = function move(dir) {
	    this.index += dir;
	    while (0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index])) {
	      this.index += dir;
	    }
	
	    if (0 > this.index || this.index >= this.glyphs.length) {
	      return null;
	    }
	
	    return this.glyphs[this.index];
	  };
	
	  GlyphIterator.prototype.next = function next() {
	    return this.move(+1);
	  };
	
	  GlyphIterator.prototype.prev = function prev() {
	    return this.move(-1);
	  };
	
	  GlyphIterator.prototype.peek = function peek() {
	    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    var idx = this.index;
	    var res = this.increment(count);
	    this.index = idx;
	    return res;
	  };
	
	  GlyphIterator.prototype.peekIndex = function peekIndex() {
	    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    var idx = this.index;
	    this.increment(count);
	    var res = this.index;
	    this.index = idx;
	    return res;
	  };
	
	  GlyphIterator.prototype.increment = function increment() {
	    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    var dir = count < 0 ? -1 : 1;
	    count = Math.abs(count);
	    while (count--) {
	      this.move(dir);
	    }
	
	    return this.glyphs[this.index];
	  };
	
	  _createClass(GlyphIterator, [{
	    key: "cur",
	    get: function get() {
	      return this.glyphs[this.index] || null;
	    }
	  }]);
	
	  return GlyphIterator;
	}();
	
	var DEFAULT_SCRIPTS = ['DFLT', 'dflt', 'latn'];
	
	var OTProcessor = function () {
	  function OTProcessor(font, table) {
	    _classCallCheck(this, OTProcessor);
	
	    this.font = font;
	    this.table = table;
	
	    this.script = null;
	    this.scriptTag = null;
	
	    this.language = null;
	    this.languageTag = null;
	
	    this.features = {};
	    this.lookups = {};
	
	    // Setup variation substitutions
	    this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
	
	    // initialize to default script + language
	    this.selectScript();
	
	    // current context (set by applyFeatures)
	    this.glyphs = [];
	    this.positions = []; // only used by GPOS
	    this.ligatureID = 1;
	    this.currentFeature = null;
	  }
	
	  OTProcessor.prototype.findScript = function findScript(script) {
	    if (this.table.scriptList == null) {
	      return null;
	    }
	
	    if (!Array.isArray(script)) {
	      script = [script];
	    }
	
	    for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var s = _ref;
	
	      for (var _iterator2 = this.table.scriptList, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var entry = _ref2;
	
	        if (entry.tag === s) {
	          return entry;
	        }
	      }
	    }
	
	    return null;
	  };
	
	  OTProcessor.prototype.selectScript = function selectScript(script, language, direction$$) {
	    var changed = false;
	    var entry = void 0;
	    if (!this.script || script !== this.scriptTag) {
	      entry = this.findScript(script);
	      if (!entry) {
	        entry = this.findScript(DEFAULT_SCRIPTS);
	      }
	
	      if (!entry) {
	        return this.scriptTag;
	      }
	
	      this.scriptTag = entry.tag;
	      this.script = entry.script;
	      this.language = null;
	      this.languageTag = null;
	      changed = true;
	    }
	
	    if (!direction$$ || direction$$ !== this.direction) {
	      this.direction = direction$$ || direction(script);
	    }
	
	    if (language && language.length < 4) {
	      language += ' '.repeat(4 - language.length);
	    }
	
	    if (!language || language !== this.languageTag) {
	      this.language = null;
	
	      for (var _iterator3 = this.script.langSysRecords, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var lang = _ref3;
	
	        if (lang.tag === language) {
	          this.language = lang.langSys;
	          this.languageTag = lang.tag;
	          break;
	        }
	      }
	
	      if (!this.language) {
	        this.language = this.script.defaultLangSys;
	        this.languageTag = null;
	      }
	
	      changed = true;
	    }
	
	    // Build a feature lookup table
	    if (changed) {
	      this.features = {};
	      if (this.language) {
	        for (var _iterator4 = this.language.featureIndexes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	          var _ref4;
	
	          if (_isArray4) {
	            if (_i4 >= _iterator4.length) break;
	            _ref4 = _iterator4[_i4++];
	          } else {
	            _i4 = _iterator4.next();
	            if (_i4.done) break;
	            _ref4 = _i4.value;
	          }
	
	          var featureIndex = _ref4;
	
	          var record = this.table.featureList[featureIndex];
	          var substituteFeature = this.substituteFeatureForVariations(featureIndex);
	          this.features[record.tag] = substituteFeature || record.feature;
	        }
	      }
	    }
	
	    return this.scriptTag;
	  };
	
	  OTProcessor.prototype.lookupsForFeatures = function lookupsForFeatures() {
	    var userFeatures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var exclude = arguments[1];
	
	    var lookups = [];
	    for (var _iterator5 = userFeatures, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	      var _ref5;
	
	      if (_isArray5) {
	        if (_i5 >= _iterator5.length) break;
	        _ref5 = _iterator5[_i5++];
	      } else {
	        _i5 = _iterator5.next();
	        if (_i5.done) break;
	        _ref5 = _i5.value;
	      }
	
	      var tag = _ref5;
	
	      var feature = this.features[tag];
	      if (!feature) {
	        continue;
	      }
	
	      for (var _iterator6 = feature.lookupListIndexes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
	        var _ref6;
	
	        if (_isArray6) {
	          if (_i6 >= _iterator6.length) break;
	          _ref6 = _iterator6[_i6++];
	        } else {
	          _i6 = _iterator6.next();
	          if (_i6.done) break;
	          _ref6 = _i6.value;
	        }
	
	        var lookupIndex = _ref6;
	
	        if (exclude && exclude.indexOf(lookupIndex) !== -1) {
	          continue;
	        }
	
	        lookups.push({
	          feature: tag,
	          index: lookupIndex,
	          lookup: this.table.lookupList.get(lookupIndex)
	        });
	      }
	    }
	
	    lookups.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    return lookups;
	  };
	
	  OTProcessor.prototype.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
	    if (this.variationsIndex === -1) {
	      return null;
	    }
	
	    var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
	    var substitutions = record.featureTableSubstitution.substitutions;
	    for (var _iterator7 = substitutions, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
	      var _ref7;
	
	      if (_isArray7) {
	        if (_i7 >= _iterator7.length) break;
	        _ref7 = _iterator7[_i7++];
	      } else {
	        _i7 = _iterator7.next();
	        if (_i7.done) break;
	        _ref7 = _i7.value;
	      }
	
	      var substitution = _ref7;
	
	      if (substitution.featureIndex === featureIndex) {
	        return substitution.alternateFeatureTable;
	      }
	    }
	
	    return null;
	  };
	
	  OTProcessor.prototype.findVariationsIndex = function findVariationsIndex(coords) {
	    var variations = this.table.featureVariations;
	    if (!variations) {
	      return -1;
	    }
	
	    var records = variations.featureVariationRecords;
	    for (var i = 0; i < records.length; i++) {
	      var conditions = records[i].conditionSet.conditionTable;
	      if (this.variationConditionsMatch(conditions, coords)) {
	        return i;
	      }
	    }
	
	    return -1;
	  };
	
	  OTProcessor.prototype.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
	    return conditions.every(function (condition) {
	      var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
	      return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
	    });
	  };
	
	  OTProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
	    var lookups = this.lookupsForFeatures(userFeatures);
	    this.applyLookups(lookups, glyphs, advances);
	  };
	
	  OTProcessor.prototype.applyLookups = function applyLookups(lookups, glyphs, positions) {
	    this.glyphs = glyphs;
	    this.positions = positions;
	    this.glyphIterator = new GlyphIterator(glyphs);
	
	    for (var _iterator8 = lookups, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _getIterator(_iterator8);;) {
	      var _ref8;
	
	      if (_isArray8) {
	        if (_i8 >= _iterator8.length) break;
	        _ref8 = _iterator8[_i8++];
	      } else {
	        _i8 = _iterator8.next();
	        if (_i8.done) break;
	        _ref8 = _i8.value;
	      }
	
	      var _ref9 = _ref8,
	          feature = _ref9.feature,
	          lookup = _ref9.lookup;
	
	      this.currentFeature = feature;
	      this.glyphIterator.reset(lookup.flags);
	
	      while (this.glyphIterator.index < glyphs.length) {
	        if (!(feature in this.glyphIterator.cur.features)) {
	          this.glyphIterator.next();
	          continue;
	        }
	
	        for (var _iterator9 = lookup.subTables, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _getIterator(_iterator9);;) {
	          var _ref10;
	
	          if (_isArray9) {
	            if (_i9 >= _iterator9.length) break;
	            _ref10 = _iterator9[_i9++];
	          } else {
	            _i9 = _iterator9.next();
	            if (_i9.done) break;
	            _ref10 = _i9.value;
	          }
	
	          var table = _ref10;
	
	          var res = this.applyLookup(lookup.lookupType, table);
	          if (res) {
	            break;
	          }
	        }
	
	        this.glyphIterator.next();
	      }
	    }
	  };
	
	  OTProcessor.prototype.applyLookup = function applyLookup(lookup, table) {
	    throw new Error("applyLookup must be implemented by subclasses");
	  };
	
	  OTProcessor.prototype.applyLookupList = function applyLookupList(lookupRecords) {
	    var options = this.glyphIterator.options;
	    var glyphIndex = this.glyphIterator.index;
	
	    for (var _iterator10 = lookupRecords, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _getIterator(_iterator10);;) {
	      var _ref11;
	
	      if (_isArray10) {
	        if (_i10 >= _iterator10.length) break;
	        _ref11 = _iterator10[_i10++];
	      } else {
	        _i10 = _iterator10.next();
	        if (_i10.done) break;
	        _ref11 = _i10.value;
	      }
	
	      var lookupRecord = _ref11;
	
	      // Reset flags and find glyph index for this lookup record
	      this.glyphIterator.reset(options, glyphIndex);
	      this.glyphIterator.increment(lookupRecord.sequenceIndex);
	
	      // Get the lookup and setup flags for subtables
	      var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
	      this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
	
	      // Apply lookup subtables until one matches
	      for (var _iterator11 = lookup.subTables, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _getIterator(_iterator11);;) {
	        var _ref12;
	
	        if (_isArray11) {
	          if (_i11 >= _iterator11.length) break;
	          _ref12 = _iterator11[_i11++];
	        } else {
	          _i11 = _iterator11.next();
	          if (_i11.done) break;
	          _ref12 = _i11.value;
	        }
	
	        var table = _ref12;
	
	        if (this.applyLookup(lookup.lookupType, table)) {
	          break;
	        }
	      }
	    }
	
	    this.glyphIterator.reset(options, glyphIndex);
	    return true;
	  };
	
	  OTProcessor.prototype.coverageIndex = function coverageIndex(coverage, glyph) {
	    if (glyph == null) {
	      glyph = this.glyphIterator.cur.id;
	    }
	
	    switch (coverage.version) {
	      case 1:
	        return coverage.glyphs.indexOf(glyph);
	
	      case 2:
	        for (var _iterator12 = coverage.rangeRecords, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _getIterator(_iterator12);;) {
	          var _ref13;
	
	          if (_isArray12) {
	            if (_i12 >= _iterator12.length) break;
	            _ref13 = _iterator12[_i12++];
	          } else {
	            _i12 = _iterator12.next();
	            if (_i12.done) break;
	            _ref13 = _i12.value;
	          }
	
	          var range = _ref13;
	
	          if (range.start <= glyph && glyph <= range.end) {
	            return range.startCoverageIndex + glyph - range.start;
	          }
	        }
	
	        break;
	    }
	
	    return -1;
	  };
	
	  OTProcessor.prototype.match = function match(sequenceIndex, sequence, fn, matched) {
	    var pos = this.glyphIterator.index;
	    var glyph = this.glyphIterator.increment(sequenceIndex);
	    var idx = 0;
	
	    while (idx < sequence.length && glyph && fn(sequence[idx], glyph)) {
	      if (matched) {
	        matched.push(this.glyphIterator.index);
	      }
	
	      idx++;
	      glyph = this.glyphIterator.next();
	    }
	
	    this.glyphIterator.index = pos;
	    if (idx < sequence.length) {
	      return false;
	    }
	
	    return matched || true;
	  };
	
	  OTProcessor.prototype.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
	    return this.match(sequenceIndex, sequence, function (component, glyph) {
	      return component === glyph.id;
	    });
	  };
	
	  OTProcessor.prototype.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
	    var _this = this;
	
	    return this.match(sequenceIndex, sequence, function (component, glyph) {
	      // If the current feature doesn't apply to this glyph,
	      if (!(_this.currentFeature in glyph.features)) {
	        return false;
	      }
	
	      return component === glyph.id;
	    }, []);
	  };
	
	  OTProcessor.prototype.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
	    var _this2 = this;
	
	    return this.match(sequenceIndex, sequence, function (coverage, glyph) {
	      return _this2.coverageIndex(coverage, glyph.id) >= 0;
	    });
	  };
	
	  OTProcessor.prototype.getClassID = function getClassID(glyph, classDef) {
	    switch (classDef.version) {
	      case 1:
	        // Class array
	        var i = glyph - classDef.startGlyph;
	        if (i >= 0 && i < classDef.classValueArray.length) {
	          return classDef.classValueArray[i];
	        }
	
	        break;
	
	      case 2:
	        for (var _iterator13 = classDef.classRangeRecord, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _getIterator(_iterator13);;) {
	          var _ref14;
	
	          if (_isArray13) {
	            if (_i13 >= _iterator13.length) break;
	            _ref14 = _iterator13[_i13++];
	          } else {
	            _i13 = _iterator13.next();
	            if (_i13.done) break;
	            _ref14 = _i13.value;
	          }
	
	          var range = _ref14;
	
	          if (range.start <= glyph && glyph <= range.end) {
	            return range.class;
	          }
	        }
	
	        break;
	    }
	
	    return 0;
	  };
	
	  OTProcessor.prototype.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
	    var _this3 = this;
	
	    return this.match(sequenceIndex, sequence, function (classID, glyph) {
	      return classID === _this3.getClassID(glyph.id, classDef);
	    });
	  };
	
	  OTProcessor.prototype.applyContext = function applyContext(table) {
	    switch (table.version) {
	      case 1:
	        var index = this.coverageIndex(table.coverage);
	        if (index === -1) {
	          return false;
	        }
	
	        var set = table.ruleSets[index];
	        for (var _iterator14 = set, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _getIterator(_iterator14);;) {
	          var _ref15;
	
	          if (_isArray14) {
	            if (_i14 >= _iterator14.length) break;
	            _ref15 = _iterator14[_i14++];
	          } else {
	            _i14 = _iterator14.next();
	            if (_i14.done) break;
	            _ref15 = _i14.value;
	          }
	
	          var rule = _ref15;
	
	          if (this.sequenceMatches(1, rule.input)) {
	            return this.applyLookupList(rule.lookupRecords);
	          }
	        }
	
	        break;
	
	      case 2:
	        if (this.coverageIndex(table.coverage) === -1) {
	          return false;
	        }
	
	        index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
	        if (index === -1) {
	          return false;
	        }
	
	        set = table.classSet[index];
	        for (var _iterator15 = set, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _getIterator(_iterator15);;) {
	          var _ref16;
	
	          if (_isArray15) {
	            if (_i15 >= _iterator15.length) break;
	            _ref16 = _iterator15[_i15++];
	          } else {
	            _i15 = _iterator15.next();
	            if (_i15.done) break;
	            _ref16 = _i15.value;
	          }
	
	          var _rule = _ref16;
	
	          if (this.classSequenceMatches(1, _rule.classes, table.classDef)) {
	            return this.applyLookupList(_rule.lookupRecords);
	          }
	        }
	
	        break;
	
	      case 3:
	        if (this.coverageSequenceMatches(0, table.coverages)) {
	          return this.applyLookupList(table.lookupRecords);
	        }
	
	        break;
	    }
	
	    return false;
	  };
	
	  OTProcessor.prototype.applyChainingContext = function applyChainingContext(table) {
	    switch (table.version) {
	      case 1:
	        var index = this.coverageIndex(table.coverage);
	        if (index === -1) {
	          return false;
	        }
	
	        var set = table.chainRuleSets[index];
	        for (var _iterator16 = set, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _getIterator(_iterator16);;) {
	          var _ref17;
	
	          if (_isArray16) {
	            if (_i16 >= _iterator16.length) break;
	            _ref17 = _iterator16[_i16++];
	          } else {
	            _i16 = _iterator16.next();
	            if (_i16.done) break;
	            _ref17 = _i16.value;
	          }
	
	          var rule = _ref17;
	
	          if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) {
	            return this.applyLookupList(rule.lookupRecords);
	          }
	        }
	
	        break;
	
	      case 2:
	        if (this.coverageIndex(table.coverage) === -1) {
	          return false;
	        }
	
	        index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
	        var rules = table.chainClassSet[index];
	        if (!rules) {
	          return false;
	        }
	
	        for (var _iterator17 = rules, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _getIterator(_iterator17);;) {
	          var _ref18;
	
	          if (_isArray17) {
	            if (_i17 >= _iterator17.length) break;
	            _ref18 = _iterator17[_i17++];
	          } else {
	            _i17 = _iterator17.next();
	            if (_i17.done) break;
	            _ref18 = _i17.value;
	          }
	
	          var _rule2 = _ref18;
	
	          if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) {
	            return this.applyLookupList(_rule2.lookupRecords);
	          }
	        }
	
	        break;
	
	      case 3:
	        if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) {
	          return this.applyLookupList(table.lookupRecords);
	        }
	
	        break;
	    }
	
	    return false;
	  };
	
	  return OTProcessor;
	}();
	
	var GlyphInfo = function () {
	  function GlyphInfo(font, id) {
	    var codePoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var features = arguments[3];
	
	    _classCallCheck(this, GlyphInfo);
	
	    this._font = font;
	    this.codePoints = codePoints;
	    this.id = id;
	
	    this.features = {};
	    if (Array.isArray(features)) {
	      for (var i = 0; i < features.length; i++) {
	        var feature = features[i];
	        this.features[feature] = true;
	      }
	    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	      _Object$assign(this.features, features);
	    }
	
	    this.ligatureID = null;
	    this.ligatureComponent = null;
	    this.isLigated = false;
	    this.cursiveAttachment = null;
	    this.markAttachment = null;
	    this.shaperInfo = null;
	    this.substituted = false;
	    this.isMultiplied = false;
	  }
	
	  GlyphInfo.prototype.copy = function copy() {
	    return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
	  };
	
	  _createClass(GlyphInfo, [{
	    key: 'id',
	    get: function get() {
	      return this._id;
	    },
	    set: function set(id) {
	      this._id = id;
	      this.substituted = true;
	
	      var GDEF = this._font.GDEF;
	      if (GDEF && GDEF.glyphClassDef) {
	        // TODO: clean this up
	        var classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
	        this.isBase = classID === 1;
	        this.isLigature = classID === 2;
	        this.isMark = classID === 3;
	        this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
	      } else {
	        this.isMark = this.codePoints.every(unicode.isMark);
	        this.isBase = !this.isMark;
	        this.isLigature = this.codePoints.length > 1;
	        this.markAttachmentType = 0;
	      }
	    }
	  }]);
	
	  return GlyphInfo;
	}();
	
	var _class$5;
	var _temp$1;
	/**
	 * This is a shaper for the Hangul script, used by the Korean language.
	 * It does the following:
	 *   - decompose if unsupported by the font:
	 *     <LV>   -> <L,V>
	 *     <LVT>  -> <L,V,T>
	 *     <LV,T> -> <L,V,T>
	 *
	 *   - compose if supported by the font:
	 *     <L,V>   -> <LV>
	 *     <L,V,T> -> <LVT>
	 *     <LV,T>  -> <LVT>
	 *
	 *   - reorder tone marks (S is any valid syllable):
	 *     <S, M> -> <M, S>
	 *
	 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
	 *
	 * This logic is based on the following documents:
	 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
	 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
	 */
	var HangulShaper = (_temp$1 = _class$5 = function (_DefaultShaper) {
	  _inherits(HangulShaper, _DefaultShaper);
	
	  function HangulShaper() {
	    _classCallCheck(this, HangulShaper);
	
	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }
	
	  HangulShaper.planFeatures = function planFeatures(plan) {
	    plan.add(['ljmo', 'vjmo', 'tjmo'], false);
	  };
	
	  HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    var state = 0;
	    var i = 0;
	    while (i < glyphs.length) {
	      var action = void 0;
	      var glyph = glyphs[i];
	      var code = glyph.codePoints[0];
	      var type = getType(code);
	
	      var _STATE_TABLE$state$ty = STATE_TABLE$1[state][type];
	      action = _STATE_TABLE$state$ty[0];
	      state = _STATE_TABLE$state$ty[1];
	
	
	      switch (action) {
	        case DECOMPOSE:
	          // Decompose the composed syllable if it is not supported by the font.
	          if (!plan.font.hasGlyphForCodePoint(code)) {
	            i = decompose(glyphs, i, plan.font);
	          }
	          break;
	
	        case COMPOSE:
	          // Found a decomposed syllable. Try to compose if supported by the font.
	          i = compose(glyphs, i, plan.font);
	          break;
	
	        case TONE_MARK:
	          // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
	          reorderToneMark(glyphs, i, plan.font);
	          break;
	
	        case INVALID:
	          // Tone mark has no valid syllable to attach to, so insert a dotted circle
	          i = insertDottedCircle(glyphs, i, plan.font);
	          break;
	      }
	
	      i++;
	    }
	  };
	
	  return HangulShaper;
	}(DefaultShaper), _class$5.zeroMarkWidths = 'NONE', _temp$1);
	var HANGUL_BASE = 0xac00;
	var HANGUL_END = 0xd7a4;
	var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
	var L_BASE = 0x1100; // lead
	var V_BASE = 0x1161; // vowel
	var T_BASE = 0x11a7; // trail
	var L_COUNT = 19;
	var V_COUNT = 21;
	var T_COUNT = 28;
	var L_END = L_BASE + L_COUNT - 1;
	var V_END = V_BASE + V_COUNT - 1;
	var T_END = T_BASE + T_COUNT - 1;
	var DOTTED_CIRCLE = 0x25cc;
	
	var isL = function isL(code) {
	  return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
	};
	var isV = function isV(code) {
	  return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
	};
	var isT = function isT(code) {
	  return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
	};
	var isTone = function isTone(code) {
	  return 0x302e <= code && code <= 0x302f;
	};
	var isLVT = function isLVT(code) {
	  return HANGUL_BASE <= code && code <= HANGUL_END;
	};
	var isLV = function isLV(code) {
	  return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
	};
	var isCombiningL = function isCombiningL(code) {
	  return L_BASE <= code && code <= L_END;
	};
	var isCombiningV = function isCombiningV(code) {
	  return V_BASE <= code && code <= V_END;
	};
	var isCombiningT = function isCombiningT(code) {
	  return T_BASE + 1 && 1 <= code && code <= T_END;
	};
	
	// Character categories
	var X = 0; // Other character
	var L = 1; // Leading consonant
	var V = 2; // Medial vowel
	var T = 3; // Trailing consonant
	var LV = 4; // Composed <LV> syllable
	var LVT = 5; // Composed <LVT> syllable
	var M = 6; // Tone mark
	
	// This function classifies a character using the above categories.
	function getType(code) {
	  if (isL(code)) {
	    return L;
	  }
	  if (isV(code)) {
	    return V;
	  }
	  if (isT(code)) {
	    return T;
	  }
	  if (isLV(code)) {
	    return LV;
	  }
	  if (isLVT(code)) {
	    return LVT;
	  }
	  if (isTone(code)) {
	    return M;
	  }
	  return X;
	}
	
	// State machine actions
	var NO_ACTION = 0;
	var DECOMPOSE = 1;
	var COMPOSE = 2;
	var TONE_MARK = 4;
	var INVALID = 5;
	
	// Build a state machine that accepts valid syllables, and applies actions along the way.
	// The logic this is implementing is documented at the top of the file.
	var STATE_TABLE$1 = [
	//       X                 L                 V                T                  LV                LVT               M
	// State 0: start state
	[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]],
	
	// State 1: <L>
	[[NO_ACTION, 0], [NO_ACTION, 1], [COMPOSE, 2], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]],
	
	// State 2: <L,V> or <LV>
	[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [COMPOSE, 3], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]],
	
	// State 3: <L,V,T> or <LVT>
	[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]]];
	
	function getGlyph(font, code, features) {
	  return new GlyphInfo(font, font.glyphForCodePoint(code).id, [code], features);
	}
	
	function decompose(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyph.codePoints[0];
	
	  var s = code - HANGUL_BASE;
	  var t = T_BASE + s % T_COUNT;
	  s = s / T_COUNT | 0;
	  var l = L_BASE + s / V_COUNT | 0;
	  var v = V_BASE + s % V_COUNT;
	
	  // Don't decompose if all of the components are not available
	  if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) {
	    return i;
	  }
	
	  // Replace the current glyph with decomposed L, V, and T glyphs,
	  // and apply the proper OpenType features to each component.
	  var ljmo = getGlyph(font, l, glyph.features);
	  ljmo.features.ljmo = true;
	
	  var vjmo = getGlyph(font, v, glyph.features);
	  vjmo.features.vjmo = true;
	
	  var insert = [ljmo, vjmo];
	
	  if (t > T_BASE) {
	    var tjmo = getGlyph(font, t, glyph.features);
	    tjmo.features.tjmo = true;
	    insert.push(tjmo);
	  }
	
	  glyphs.splice.apply(glyphs, [i, 1].concat(insert));
	  return i + insert.length - 1;
	}
	
	function compose(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyphs[i].codePoints[0];
	  var type = getType(code);
	
	  var prev = glyphs[i - 1].codePoints[0];
	  var prevType = getType(prev);
	
	  // Figure out what type of syllable we're dealing with
	  var lv = void 0,
	      ljmo = void 0,
	      vjmo = void 0,
	      tjmo = void 0;
	  if (prevType === LV && type === T) {
	    // <LV,T>
	    lv = prev;
	    tjmo = glyph;
	  } else {
	    if (type === V) {
	      // <L,V>
	      ljmo = glyphs[i - 1];
	      vjmo = glyph;
	    } else {
	      // <L,V,T>
	      ljmo = glyphs[i - 2];
	      vjmo = glyphs[i - 1];
	      tjmo = glyph;
	    }
	
	    var l = ljmo.codePoints[0];
	    var v = vjmo.codePoints[0];
	
	    // Make sure L and V are combining characters
	    if (isCombiningL(l) && isCombiningV(v)) {
	      lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
	    }
	  }
	
	  var t = tjmo && tjmo.codePoints[0] || T_BASE;
	  if (lv != null && (t === T_BASE || isCombiningT(t))) {
	    var s = lv + (t - T_BASE);
	
	    // Replace with a composed glyph if supported by the font,
	    // otherwise apply the proper OpenType features to each component.
	    if (font.hasGlyphForCodePoint(s)) {
	      var del = prevType === V ? 3 : 2;
	      glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
	      return i - del + 1;
	    }
	  }
	
	  // Didn't compose (either a non-combining component or unsupported by font).
	  if (ljmo) {
	    ljmo.features.ljmo = true;
	  }
	  if (vjmo) {
	    vjmo.features.vjmo = true;
	  }
	  if (tjmo) {
	    tjmo.features.tjmo = true;
	  }
	
	  if (prevType === LV) {
	    // Sequence was originally <L,V>, which got combined earlier.
	    // Either the T was non-combining, or the LVT glyph wasn't supported.
	    // Decompose the glyph again and apply OT features.
	    decompose(glyphs, i - 1, font);
	    return i + 1;
	  }
	
	  return i;
	}
	
	function getLength(code) {
	  switch (getType(code)) {
	    case LV:
	    case LVT:
	      return 1;
	    case V:
	      return 2;
	    case T:
	      return 3;
	  }
	}
	
	function reorderToneMark(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyphs[i].codePoints[0];
	
	  // Move tone mark to the beginning of the previous syllable, unless it is zero width
	  if (font.glyphForCodePoint(code).advanceWidth === 0) {
	    return;
	  }
	
	  var prev = glyphs[i - 1].codePoints[0];
	  var len = getLength(prev);
	
	  glyphs.splice(i, 1);
	  return glyphs.splice(i - len, 0, glyph);
	}
	
	function insertDottedCircle(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyphs[i].codePoints[0];
	
	  if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
	    var dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features);
	
	    // If the tone mark is zero width, insert the dotted circle before, otherwise after
	    var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
	    glyphs.splice(idx, 0, dottedCircle);
	    i++;
	  }
	
	  return i;
	}
	
	var stateTable = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 14, 15, 16, 17], [0, 0, 0, 18, 19, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 28, 29, 30, 31, 32, 33, 0, 34, 0, 0, 35, 36, 0, 0, 37, 0], [0, 0, 0, 38, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 39, 0, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 12, 43, 0, 0, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0], [0, 0, 0, 45, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 51, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 52, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 55, 56, 57, 58, 0, 59, 0, 0, 60, 61, 0, 0, 62, 0], [0, 0, 0, 4, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 63, 64, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 63, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 0, 2, 16, 0], [0, 0, 0, 18, 65, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 0, 0], [0, 0, 0, 69, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 73, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 75, 0, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 25, 79, 0, 0, 0, 0], [0, 0, 0, 18, 19, 20, 74, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 81, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 87, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 18, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 89, 90, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 89, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 0, 0], [0, 0, 0, 94, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 96, 0, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 35, 100, 0, 0, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 102, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 108, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 28, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 110, 111, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 110, 0, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 0, 0], [0, 0, 0, 0, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 0, 0, 115, 116, 117, 118, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 39, 0, 122, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 124, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 124, 0, 0], [0, 39, 0, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 47, 47, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 128, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 129, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 134, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 135, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 136, 0, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 60, 140, 0, 0, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 0, 140, 0, 0, 0, 0], [0, 0, 0, 142, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 148, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 149, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 150, 151, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 150, 0, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 157, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 3, 4, 5, 159, 160, 8, 161, 0, 162, 0, 11, 12, 163, 0, 75, 16, 0], [0, 0, 0, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 0, 165, 0, 0, 0, 0], [0, 124, 64, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 124, 0, 0], [0, 0, 0, 0, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 167, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 172, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 75, 0, 176, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 178, 90, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 178, 0, 0], [0, 75, 0, 0, 0, 175, 179, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 180, 180, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 83, 83, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 182, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 183, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 188, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 191, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 0, 194, 0, 0, 0, 0], [0, 178, 90, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 178, 0, 0], [0, 0, 0, 0, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 198, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 96, 0, 202, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 204, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 204, 0, 0], [0, 96, 0, 0, 0, 201, 205, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 206, 206, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 104, 104, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 208, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 209, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 214, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 217, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 0, 220, 0, 0, 0, 0], [0, 204, 111, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 204, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 223, 0, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 119, 225, 0, 0, 0, 0], [0, 0, 0, 115, 116, 117, 222, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 115, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 226, 64, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 226, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 39, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 44, 44, 8, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 229, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 39, 0, 122, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 231, 231, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 232, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 131, 131, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 234, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 235, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 0, 0, 240, 241, 242, 243, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 136, 0, 247, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 249, 151, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 249, 0, 0], [0, 136, 0, 0, 0, 246, 250, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 251, 251, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 144, 144, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 253, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 254, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 262, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 0, 265, 0, 0, 0, 0], [0, 249, 151, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 249, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 158, 225, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 222, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 155, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 43, 266, 266, 8, 161, 0, 24, 0, 0, 12, 267, 0, 0, 0, 0], [0, 75, 0, 176, 43, 268, 268, 269, 161, 0, 24, 0, 0, 0, 267, 0, 75, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 271, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 272, 0, 0, 0, 0, 0, 0, 0, 0], [0, 273, 274, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 273, 0, 0], [0, 0, 0, 40, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 121, 275, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 276, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 279, 0, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 173, 281, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 278, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 169, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 282, 90, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 282, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 80, 80, 22, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 285, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 75, 0, 176, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 287, 287, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 288, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 185, 185, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 290, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 291, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 192, 281, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 278, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 189, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 76, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 175, 296, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 299, 0, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 199, 301, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 298, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 195, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 302, 111, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 302, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 96, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 101, 101, 32, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 305, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 96, 0, 202, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 307, 307, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 308, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 211, 211, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 310, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 311, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 218, 301, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 298, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 215, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 97, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 201, 316, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 320, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 223, 0, 323, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 0, 0, 121, 324, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 325, 318, 326, 327, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 64, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 121, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 46, 0, 0], [0, 0, 0, 0, 0, 329, 329, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 330, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 237, 237, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 332, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 333, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 337, 0, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 244, 339, 0, 0, 0, 0], [0, 0, 0, 240, 241, 242, 336, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 240, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 340, 151, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 340, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 136, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 141, 141, 57, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 343, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 136, 0, 247, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 345, 345, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 346, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 256, 256, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 348, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 349, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 263, 339, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 336, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 260, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 137, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 246, 354, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 355, 90, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 355, 0, 0], [0, 0, 0, 0, 0, 356, 356, 269, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 357, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 363, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 366, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 40, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 0, 281, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 372, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 279, 0, 375, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 0, 0, 175, 376, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 377, 370, 378, 379, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 90, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 175, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 82, 0, 0], [0, 0, 0, 0, 0, 381, 381, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 382, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 293, 293, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 384, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 385, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 76, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 0, 301, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 390, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 299, 0, 393, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 0, 0, 201, 394, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 395, 388, 396, 397, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 111, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 201, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 0, 0], [0, 0, 0, 0, 0, 399, 399, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 400, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 313, 313, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 402, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 403, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 97, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 407, 0, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 321, 409, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 406, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 0, 0, 317, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 410, 64, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 410, 0, 0], [0, 223, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 323, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 328, 409, 0, 0, 0, 0], [0, 0, 0, 325, 318, 326, 406, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 325, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130, 0, 0], [0, 0, 0, 0, 0, 411, 411, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 412, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 413, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 0, 339, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 417, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 337, 0, 420, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 0, 0, 246, 421, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 422, 415, 423, 424, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 151, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 246, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 143, 0, 0], [0, 0, 0, 0, 0, 426, 426, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 427, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 351, 351, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 429, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 430, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 137, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 434, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 180, 180, 269, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 359, 359, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 437, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 438, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 443, 274, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 443, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 367, 225, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 445, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 364, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 448, 0, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 373, 450, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 447, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 0, 0, 369, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 451, 90, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 451, 0, 0], [0, 279, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 375, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 380, 450, 0, 0, 0, 0], [0, 0, 0, 377, 370, 378, 447, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 377, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 0, 0], [0, 0, 0, 0, 0, 452, 452, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 453, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 454, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 457, 0, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 391, 459, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 456, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 0, 0, 387, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 460, 111, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 460, 0, 0], [0, 299, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 393, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 398, 459, 0, 0, 0, 0], [0, 0, 0, 395, 388, 396, 456, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 395, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 210, 0, 0], [0, 0, 0, 0, 0, 461, 461, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 462, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 463, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 0, 409, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 467, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 407, 0, 470, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 0, 0, 121, 471, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 472, 465, 473, 474, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 236, 0, 0], [0, 0, 0, 0, 0, 0, 476, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 479, 0, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 418, 481, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 478, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 0, 0, 414, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 482, 151, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 482, 0, 0], [0, 337, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 420, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 425, 481, 0, 0, 0, 0], [0, 0, 0, 422, 415, 423, 478, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 422, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0], [0, 0, 0, 0, 0, 483, 483, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 484, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 485, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 435, 225, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 445, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 432, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 486, 486, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 487, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 440, 440, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 489, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 490, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 497, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 0, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 0, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 0, 450, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 502, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 448, 0, 505, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 0, 0, 175, 506, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 507, 500, 508, 509, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 292, 0, 0], [0, 0, 0, 0, 0, 0, 511, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 0, 459, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 515, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 457, 0, 518, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 0, 0, 201, 519, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 520, 513, 521, 522, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 312, 0, 0], [0, 0, 0, 0, 0, 0, 524, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 527, 0, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 468, 529, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 526, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 0, 0, 464, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 530, 64, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 530, 0, 0], [0, 407, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 470, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 475, 529, 0, 0, 0, 0], [0, 0, 0, 472, 465, 473, 526, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 472, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0], [0, 0, 0, 0, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 0, 481, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 534, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 479, 0, 537, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 0, 0, 246, 538, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 539, 532, 540, 541, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 350, 0, 0], [0, 0, 0, 0, 0, 0, 543, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 358, 0, 0], [0, 0, 0, 0, 0, 544, 544, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 545, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 492, 492, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 547, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 548, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 274, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 368, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 553, 0, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 503, 555, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 552, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 0, 0, 499, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 556, 90, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 556, 0, 0], [0, 448, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 505, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 510, 555, 0, 0, 0, 0], [0, 0, 0, 507, 500, 508, 552, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 507, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 559, 0, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 516, 561, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 558, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 0, 0, 512, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 562, 111, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 562, 0, 0], [0, 457, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 518, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 523, 561, 0, 0, 0, 0], [0, 0, 0, 520, 513, 521, 558, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 520, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 97, 0, 0], [0, 0, 0, 0, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 0, 529, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 565, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 527, 0, 567, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 0, 0, 121, 568, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 569, 66, 570, 571, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 575, 0, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 535, 577, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 574, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 0, 0, 531, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 578, 151, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 578, 0, 0], [0, 479, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 537, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 542, 577, 0, 0, 0, 0], [0, 0, 0, 539, 532, 540, 574, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 539, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 137, 0, 0], [0, 0, 0, 0, 0, 0, 0, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 439, 0, 0], [0, 0, 0, 0, 0, 579, 579, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 580, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 581, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 0, 555, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 584, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 553, 0, 586, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 0, 0, 175, 587, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 588, 91, 589, 590, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 0, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 0, 561, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 594, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 559, 0, 596, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 0, 0, 201, 597, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 598, 112, 599, 600, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 566, 165, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 67, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 0, 0, 563, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 527, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 567, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 572, 165, 0, 0, 0, 0], [0, 0, 0, 569, 66, 570, 67, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 569, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 0, 577, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 605, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 575, 0, 607, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 0, 0, 246, 608, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 609, 152, 610, 611, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 491, 0, 0], [0, 0, 0, 0, 0, 0, 613, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 585, 194, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 92, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 0, 0, 582, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 553, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 586, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 591, 194, 0, 0, 0, 0], [0, 0, 0, 588, 91, 589, 92, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 588, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 595, 220, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 113, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 0, 0, 592, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 559, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 596, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 601, 220, 0, 0, 0, 0], [0, 0, 0, 598, 112, 599, 113, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 598, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 606, 265, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 153, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 0, 0, 603, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 575, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 607, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 612, 265, 0, 0, 0, 0], [0, 0, 0, 609, 152, 610, 153, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 609, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 549, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0]];
	var accepting = [false, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, false, false, true, false, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, false, false, true, true, false, false, true, true, true, false, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, false, false, false, false, false, false, false, true, true, false, false, true, true, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, false, true, true, false, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, false, true, true, false, true, true, true];
	var tags = [[], ["broken_cluster"], ["consonant_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["symbol_cluster"], [], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], ["consonant_syllable"], ["vowel_syllable"], ["standalone_cluster"]];
	var indicMachine = {
		stateTable: stateTable,
		accepting: accepting,
		tags: tags
	};
	
	var categories = ["O", "IND", "S", "GB", "B", "FM", "CGJ", "VMAbv", "VMPst", "VAbv", "VPst", "CMBlw", "VPre", "VBlw", "H", "VMBlw", "CMAbv", "MBlw", "CS", "R", "SUB", "MPst", "MPre", "FAbv", "FPst", "FBlw", "SMAbv", "SMBlw", "VMPre", "ZWNJ", "ZWJ", "WJ", "VS", "N", "HN", "MAbv"];
	var decompositions$1 = { "2507": [2503, 2494], "2508": [2503, 2519], "2888": [2887, 2902], "2891": [2887, 2878], "2892": [2887, 2903], "3018": [3014, 3006], "3019": [3015, 3006], "3020": [3014, 3031], "3144": [3142, 3158], "3264": [3263, 3285], "3271": [3270, 3285], "3272": [3270, 3286], "3274": [3270, 3266], "3275": [3270, 3266, 3285], "3402": [3398, 3390], "3403": [3399, 3390], "3404": [3398, 3415], "3546": [3545, 3530], "3548": [3545, 3535], "3549": [3545, 3535, 3530], "3550": [3545, 3551], "3635": [3661, 3634], "3763": [3789, 3762], "3955": [3953, 3954], "3957": [3953, 3956], "3958": [4018, 3968], "3959": [4018, 3953, 3968], "3960": [4019, 3968], "3961": [4019, 3953, 3968], "3969": [3953, 3968], "6971": [6970, 6965], "6973": [6972, 6965], "6976": [6974, 6965], "6977": [6975, 6965], "6979": [6978, 6965], "69934": [69937, 69927], "69935": [69938, 69927], "70475": [70471, 70462], "70476": [70471, 70487], "70843": [70841, 70842], "70844": [70841, 70832], "70846": [70841, 70845], "71098": [71096, 71087], "71099": [71097, 71087] };
	var stateTable$1 = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [2, 2, 3, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 17, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 2, 0, 24, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 27, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 39, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 49, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 53, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 51, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 54, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0]];
	var accepting$1 = [false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true];
	var tags$1 = [[], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["virama_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["number_joiner_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["numeral_cluster"]];
	var useData = {
		categories: categories,
		decompositions: decompositions$1,
		stateTable: stateTable$1,
		accepting: accepting$1,
		tags: tags$1
	};
	
	// Cateories used in the OpenType spec:
	// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
	var CATEGORIES = {
	  X: 1 << 0,
	  C: 1 << 1,
	  V: 1 << 2,
	  N: 1 << 3,
	  H: 1 << 4,
	  ZWNJ: 1 << 5,
	  ZWJ: 1 << 6,
	  M: 1 << 7,
	  SM: 1 << 8,
	  VD: 1 << 9,
	  A: 1 << 10,
	  Placeholder: 1 << 11,
	  Dotted_Circle: 1 << 12,
	  RS: 1 << 13, // Register Shifter, used in Khmer OT spec.
	  Coeng: 1 << 14, // Khmer-style Virama.
	  Repha: 1 << 15, // Atomically-encoded logical or visual repha.
	  Ra: 1 << 16,
	  CM: 1 << 17, // Consonant-Medial.
	  Symbol: 1 << 18 // Avagraha, etc that take marks (SM,A,VD).
	};
	
	// Visual positions in a syllable from left to right.
	var POSITIONS = {
	  Start: 1 << 0,
	
	  Ra_To_Become_Reph: 1 << 1,
	  Pre_M: 1 << 2,
	  Pre_C: 1 << 3,
	
	  Base_C: 1 << 4,
	  After_Main: 1 << 5,
	
	  Above_C: 1 << 6,
	
	  Before_Sub: 1 << 7,
	  Below_C: 1 << 8,
	  After_Sub: 1 << 9,
	
	  Before_Post: 1 << 10,
	  Post_C: 1 << 11,
	  After_Post: 1 << 12,
	
	  Final_C: 1 << 13,
	  SMVD: 1 << 14,
	
	  End: 1 << 15
	};
	
	var CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
	var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
	var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;
	
	var INDIC_CONFIGS = {
	  Default: {
	    hasOldSpec: false,
	    virama: 0,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  Devanagari: {
	    hasOldSpec: true,
	    virama: 0x094D,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  Bengali: {
	    hasOldSpec: true,
	    virama: 0x09CD,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Sub,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  Gurmukhi: {
	    hasOldSpec: true,
	    virama: 0x0A4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Sub,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  Gujarati: {
	    hasOldSpec: true,
	    virama: 0x0ACD,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  Oriya: {
	    hasOldSpec: true,
	    virama: 0x0B4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Main,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  Tamil: {
	    hasOldSpec: true,
	    virama: 0x0BCD,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  Telugu: {
	    hasOldSpec: true,
	    virama: 0x0C4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Post,
	    rephMode: 'Explicit',
	    blwfMode: 'Post_Only'
	  },
	
	  Kannada: {
	    hasOldSpec: true,
	    virama: 0x0CCD,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Post_Only'
	  },
	
	  Malayalam: {
	    hasOldSpec: true,
	    virama: 0x0D4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Main,
	    rephMode: 'Log_Repha',
	    blwfMode: 'Pre_And_Post'
	  },
	
	  // Handled by UniversalShaper
	  // Sinhala: {
	  //   hasOldSpec: false,
	  //   virama: 0x0DCA,
	  //   basePos: 'Last_Sinhala',
	  //   rephPos: POSITIONS.After_Main,
	  //   rephMode: 'Explicit',
	  //   blwfMode: 'Pre_And_Post'
	  // },
	
	  Khmer: {
	    hasOldSpec: false,
	    virama: 0x17D2,
	    basePos: 'First',
	    rephPos: POSITIONS.Ra_To_Become_Reph,
	    rephMode: 'Vis_Repha',
	    blwfMode: 'Pre_And_Post'
	  }
	};
	
	// Additional decompositions that aren't in Unicode
	var INDIC_DECOMPOSITIONS = {
	  // Khmer
	  0x17BE: [0x17C1, 0x17BE],
	  0x17BF: [0x17C1, 0x17BF],
	  0x17C0: [0x17C1, 0x17C0],
	  0x17C4: [0x17C1, 0x17C4],
	  0x17C5: [0x17C1, 0x17C5]
	};
	
	var _class$6;
	var _temp$2;
	var decompositions = useData.decompositions;
	
	var trie$1 = new UnicodeTrie(Buffer("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","base64"));
	var stateMachine = new StateMachine(indicMachine);
	
	/**
	 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
	 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
	 */
	var IndicShaper = (_temp$2 = _class$6 = function (_DefaultShaper) {
	  _inherits(IndicShaper, _DefaultShaper);
	
	  function IndicShaper() {
	    _classCallCheck(this, IndicShaper);
	
	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }
	
	  IndicShaper.planFeatures = function planFeatures(plan) {
	    plan.addStage(setupSyllables);
	
	    plan.addStage(['locl', 'ccmp']);
	
	    plan.addStage(initialReordering);
	
	    plan.addStage('nukt');
	    plan.addStage('akhn');
	    plan.addStage('rphf', false);
	    plan.addStage('rkrf');
	    plan.addStage('pref', false);
	    plan.addStage('blwf', false);
	    plan.addStage('abvf', false);
	    plan.addStage('half', false);
	    plan.addStage('pstf', false);
	    plan.addStage('vatu');
	    plan.addStage('cjct');
	    plan.addStage('cfar', false);
	
	    plan.addStage(finalReordering);
	
	    plan.addStage({
	      local: ['init'],
	      global: ['pres', 'abvs', 'blws', 'psts', 'haln', 'dist', 'abvm', 'blwm', 'calt', 'clig']
	    });
	
	    // Setup the indic config for the selected script
	    plan.unicodeScript = fromOpenType(plan.script);
	    plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
	    plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2';
	
	    // TODO: turn off kern (Khmer) and liga features.
	  };
	
	  IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    var _loop = function _loop(i) {
	      var codepoint = glyphs[i].codePoints[0];
	      var d = INDIC_DECOMPOSITIONS[codepoint] || decompositions[codepoint];
	      if (d) {
	        var decomposed = d.map(function (c) {
	          var g = plan.font.glyphForCodePoint(c);
	          return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
	        });
	
	        glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
	      }
	    };
	
	    // Decompose split matras
	    // TODO: do this in a more general unicode normalizer
	    for (var i = glyphs.length - 1; i >= 0; i--) {
	      _loop(i);
	    }
	  };
	
	  return IndicShaper;
	}(DefaultShaper), _class$6.zeroMarkWidths = 'NONE', _temp$2);
	function indicCategory(glyph) {
	  return trie$1.get(glyph.codePoints[0]) >> 8;
	}
	
	function indicPosition(glyph) {
	  return 1 << (trie$1.get(glyph.codePoints[0]) & 0xff);
	}
	
	var IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
	  _classCallCheck(this, IndicInfo);
	
	  this.category = category;
	  this.position = position;
	  this.syllableType = syllableType;
	  this.syllable = syllable;
	};
	
	function setupSyllables(font, glyphs) {
	  var syllable = 0;
	  var last = 0;
	  for (var _iterator = stateMachine.match(glyphs.map(indicCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var _ref2 = _ref,
	        start = _ref2[0],
	        end = _ref2[1],
	        tags = _ref2[2];
	
	    if (start > last) {
	      ++syllable;
	      for (var _i2 = last; _i2 < start; _i2++) {
	        glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
	      }
	    }
	
	    ++syllable;
	
	    // Create shaper info
	    for (var _i3 = start; _i3 <= end; _i3++) {
	      glyphs[_i3].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i3]), indicPosition(glyphs[_i3]), tags[0], syllable);
	    }
	
	    last = end + 1;
	  }
	
	  if (last < glyphs.length) {
	    ++syllable;
	    for (var i = last; i < glyphs.length; i++) {
	      glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
	    }
	  }
	}
	
	function isConsonant(glyph) {
	  return glyph.shaperInfo.category & CONSONANT_FLAGS;
	}
	
	function isJoiner(glyph) {
	  return glyph.shaperInfo.category & JOINER_FLAGS;
	}
	
	function isHalantOrCoeng(glyph) {
	  return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
	}
	
	function wouldSubstitute(glyphs, feature) {
	  for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i4 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	    var _glyph$features;
	
	    var _ref3;
	
	    if (_isArray2) {
	      if (_i4 >= _iterator2.length) break;
	      _ref3 = _iterator2[_i4++];
	    } else {
	      _i4 = _iterator2.next();
	      if (_i4.done) break;
	      _ref3 = _i4.value;
	    }
	
	    var glyph = _ref3;
	
	    glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
	  }
	
	  var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
	  GSUB.applyFeatures([feature], glyphs);
	
	  return glyphs.length === 1;
	}
	
	function consonantPosition(font, consonant, virama) {
	  var glyphs = [virama, consonant, virama];
	  if (wouldSubstitute(glyphs.slice(0, 2), 'blwf') || wouldSubstitute(glyphs.slice(1, 3), 'blwf')) {
	    return POSITIONS.Below_C;
	  } else if (wouldSubstitute(glyphs.slice(0, 2), 'pstf') || wouldSubstitute(glyphs.slice(1, 3), 'pstf')) {
	    return POSITIONS.Post_C;
	  } else if (wouldSubstitute(glyphs.slice(0, 2), 'pref') || wouldSubstitute(glyphs.slice(1, 3), 'pref')) {
	    return POSITIONS.Post_C;
	  }
	
	  return POSITIONS.Base_C;
	}
	
	function initialReordering(font, glyphs, plan) {
	  var indicConfig = plan.indicConfig;
	  var features = font._layoutEngine.engine.GSUBProcessor.features;
	
	  var dottedCircle = font.glyphForCodePoint(0x25cc).id;
	  var virama = font.glyphForCodePoint(indicConfig.virama).id;
	  if (virama) {
	    var info = new GlyphInfo(font, virama, [indicConfig.virama]);
	    for (var i = 0; i < glyphs.length; i++) {
	      if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) {
	        glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
	      }
	    }
	  }
	
	  for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
	    var _glyphs$start$shaperI = glyphs[start].shaperInfo,
	        category = _glyphs$start$shaperI.category,
	        syllableType = _glyphs$start$shaperI.syllableType;
	
	
	    if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') {
	      continue;
	    }
	
	    if (syllableType === 'broken_cluster' && dottedCircle) {
	      var g = new GlyphInfo(font, dottedCircle, [0x25cc]);
	      g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
	
	      // Insert after possible Repha.
	      var _i5 = start;
	      while (_i5 < end && glyphs[_i5].shaperInfo.category === CATEGORIES.Repha) {
	        _i5++;
	      }
	
	      glyphs.splice(_i5++, 0, g);
	      end++;
	    }
	
	    // 1. Find base consonant:
	    //
	    // The shaping engine finds the base consonant of the syllable, using the
	    // following algorithm: starting from the end of the syllable, move backwards
	    // until a consonant is found that does not have a below-base or post-base
	    // form (post-base forms have to follow below-base forms), or that is not a
	    // pre-base reordering Ra, or arrive at the first consonant. The consonant
	    // stopped at will be the base.
	
	    var base = end;
	    var limit = start;
	    var hasReph = false;
	
	    // If the syllable starts with Ra + Halant (in a script that has Reph)
	    // and has more than one consonant, Ra is excluded from candidates for
	    // base consonants.
	    if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
	      // See if it matches the 'rphf' feature.
	      var _g = [glyphs[start].copy(), glyphs[start + 1].copy(), glyphs[start + 2].copy()];
	      if (wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && wouldSubstitute(_g, 'rphf')) {
	        limit += 2;
	        while (limit < end && isJoiner(glyphs[limit])) {
	          limit++;
	        }
	        base = start;
	        hasReph = true;
	      }
	    } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
	      limit++;
	      while (limit < end && isJoiner(glyphs[limit])) {
	        limit++;
	      }
	      base = start;
	      hasReph = true;
	    }
	
	    switch (indicConfig.basePos) {
	      case 'Last':
	        {
	          // starting from the end of the syllable, move backwards
	          var _i6 = end;
	          var seenBelow = false;
	
	          do {
	            var _info = glyphs[--_i6].shaperInfo;
	
	            // until a consonant is found
	            if (isConsonant(glyphs[_i6])) {
	              // that does not have a below-base or post-base form
	              // (post-base forms have to follow below-base forms),
	              if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
	                base = _i6;
	                break;
	              }
	
	              // or that is not a pre-base reordering Ra,
	              //
	              // IMPLEMENTATION NOTES:
	              //
	              // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
	              // by the logic above already.
	              //
	
	              // or arrive at the first consonant. The consonant stopped at will
	              // be the base.
	              if (_info.position === POSITIONS.Below_C) {
	                seenBelow = true;
	              }
	
	              base = _i6;
	            } else if (start < _i6 && _info.category === CATEGORIES.ZWJ && glyphs[_i6 - 1].shaperInfo.category === CATEGORIES.H) {
	              // A ZWJ after a Halant stops the base search, and requests an explicit
	              // half form.
	              // A ZWJ before a Halant, requests a subjoined form instead, and hence
	              // search continues.  This is particularly important for Bengali
	              // sequence Ra,H,Ya that should form Ya-Phalaa by subjoining Ya.
	              break;
	            }
	          } while (_i6 > limit);
	          break;
	        }
	
	      case 'First':
	        {
	          // The first consonant is always the base.
	          base = start;
	
	          // Mark all subsequent consonants as below.
	          for (var _i7 = base + 1; _i7 < end; _i7++) {
	            if (isConsonant(glyphs[_i7])) {
	              glyphs[_i7].shaperInfo.position = POSITIONS.Below_C;
	            }
	          }
	        }
	    }
	
	    // If the syllable starts with Ra + Halant (in a script that has Reph)
	    // and has more than one consonant, Ra is excluded from candidates for
	    // base consonants.
	    //
	    //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
	    if (hasReph && base === start && limit - base <= 2) {
	      hasReph = false;
	    }
	
	    // 2. Decompose and reorder Matras:
	    //
	    // Each matra and any syllable modifier sign in the cluster are moved to the
	    // appropriate position relative to the consonant(s) in the cluster. The
	    // shaping engine decomposes two- or three-part matras into their constituent
	    // parts before any repositioning. Matra characters are classified by which
	    // consonant in a conjunct they have affinity for and are reordered to the
	    // following positions:
	    //
	    //   o Before first half form in the syllable
	    //   o After subjoined consonants
	    //   o After post-form consonant
	    //   o After main consonant (for above marks)
	    //
	    // IMPLEMENTATION NOTES:
	    //
	    // The normalize() routine has already decomposed matras for us, so we don't
	    // need to worry about that.
	
	    // 3.  Reorder marks to canonical order:
	    //
	    // Adjacent nukta and halant or nukta and vedic sign are always repositioned
	    // if necessary, so that the nukta is first.
	    //
	    // IMPLEMENTATION NOTES:
	    //
	    // We don't need to do this: the normalize() routine already did this for us.
	
	    // Reorder characters
	
	    for (var _i8 = start; _i8 < base; _i8++) {
	      var _info2 = glyphs[_i8].shaperInfo;
	      _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
	    }
	
	    if (base < end) {
	      glyphs[base].shaperInfo.position = POSITIONS.Base_C;
	    }
	
	    // Mark final consonants.  A final consonant is one appearing after a matra,
	    // like in Khmer.
	    for (var _i9 = base + 1; _i9 < end; _i9++) {
	      if (glyphs[_i9].shaperInfo.category === CATEGORIES.M) {
	        for (var j = _i9 + 1; j < end; j++) {
	          if (isConsonant(glyphs[j])) {
	            glyphs[j].shaperInfo.position = POSITIONS.Final_C;
	            break;
	          }
	        }
	        break;
	      }
	    }
	
	    // Handle beginning Ra
	    if (hasReph) {
	      glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
	    }
	
	    // For old-style Indic script tags, move the first post-base Halant after
	    // last consonant.
	    //
	    // Reports suggest that in some scripts Uniscribe does this only if there
	    // is *not* a Halant after last consonant already (eg. Kannada), while it
	    // does it unconditionally in other scripts (eg. Malayalam).  We don't
	    // currently know about other scripts, so we single out Malayalam for now.
	    //
	    // Kannada test case:
	    // U+0C9A,U+0CCD,U+0C9A,U+0CCD
	    // With some versions of Lohit Kannada.
	    // https://bugs.freedesktop.org/show_bug.cgi?id=59118
	    //
	    // Malayalam test case:
	    // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
	    // With lohit-ttf-20121122/Lohit-Malayalam.ttf
	    if (plan.isOldSpec) {
	      var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
	      for (var _i10 = base + 1; _i10 < end; _i10++) {
	        if (glyphs[_i10].shaperInfo.category === CATEGORIES.H) {
	          var _j = void 0;
	          for (_j = end - 1; _j > _i10; _j--) {
	            if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) {
	              break;
	            }
	          }
	
	          if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i10) {
	            // Move Halant to after last consonant.
	            var t = glyphs[_i10];
	            glyphs.splice.apply(glyphs, [_i10, 0].concat(glyphs.splice(_i10 + 1, _j - _i10)));
	            glyphs[_j] = t;
	          }
	
	          break;
	        }
	      }
	    }
	
	    // Attach misc marks to previous char to move with them.
	    var lastPos = POSITIONS.Start;
	    for (var _i11 = start; _i11 < end; _i11++) {
	      var _info3 = glyphs[_i11].shaperInfo;
	      if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
	        _info3.position = lastPos;
	        if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
	          // Uniscribe doesn't move the Halant with Left Matra.
	          // TEST: U+092B,U+093F,U+094DE
	          // We follow.  This is important for the Sinhala
	          // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
	          // where U+0DD9 is a left matra and U+0DCA is the virama.
	          // We don't want to move the virama with the left matra.
	          // TEST: U+0D9A,U+0DDA
	          for (var _j2 = _i11; _j2 > start; _j2--) {
	            if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
	              _info3.position = glyphs[_j2 - 1].shaperInfo.position;
	              break;
	            }
	          }
	        }
	      } else if (_info3.position !== POSITIONS.SMVD) {
	        lastPos = _info3.position;
	      }
	    }
	
	    // For post-base consonants let them own anything before them
	    // since the last consonant or matra.
	    var last = base;
	    for (var _i12 = base + 1; _i12 < end; _i12++) {
	      if (isConsonant(glyphs[_i12])) {
	        for (var _j3 = last + 1; _j3 < _i12; _j3++) {
	          if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) {
	            glyphs[_j3].shaperInfo.position = glyphs[_i12].shaperInfo.position;
	          }
	        }
	        last = _i12;
	      } else if (glyphs[_i12].shaperInfo.category === CATEGORIES.M) {
	        last = _i12;
	      }
	    }
	
	    var arr = glyphs.slice(start, end);
	    arr.sort(function (a, b) {
	      return a.shaperInfo.position - b.shaperInfo.position;
	    });
	    glyphs.splice.apply(glyphs, [start, arr.length].concat(arr));
	
	    // Find base again
	    for (var _i13 = start; _i13 < end; _i13++) {
	      if (glyphs[_i13].shaperInfo.position === POSITIONS.Base_C) {
	        base = _i13;
	        break;
	      }
	    }
	
	    // Setup features now
	
	    // Reph
	    for (var _i14 = start; _i14 < end && glyphs[_i14].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i14++) {
	      glyphs[_i14].features.rphf = true;
	    }
	
	    // Pre-base
	    var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
	    for (var _i15 = start; _i15 < base; _i15++) {
	      glyphs[_i15].features.half = true;
	      if (blwf) {
	        glyphs[_i15].features.blwf = true;
	      }
	    }
	
	    // Post-base
	    for (var _i16 = base + 1; _i16 < end; _i16++) {
	      glyphs[_i16].features.abvf = true;
	      glyphs[_i16].features.pstf = true;
	      glyphs[_i16].features.blwf = true;
	    }
	
	    if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
	      // Old-spec eye-lash Ra needs special handling.  From the
	      // spec:
	      //
	      // "The feature 'below-base form' is applied to consonants
	      // having below-base forms and following the base consonant.
	      // The exception is vattu, which may appear below half forms
	      // as well as below the base glyph. The feature 'below-base
	      // form' will be applied to all such occurrences of Ra as well."
	      //
	      // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
	      // with Sanskrit 2003 font.
	      //
	      // However, note that Ra,Halant,ZWJ is the correct way to
	      // request eyelash form of Ra, so we wouldbn't inhibit it
	      // in that sequence.
	      //
	      // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
	      for (var _i17 = start; _i17 + 1 < base; _i17++) {
	        if (glyphs[_i17].shaperInfo.category === CATEGORIES.Ra && glyphs[_i17 + 1].shaperInfo.category === CATEGORIES.H && (_i17 + 1 === base || glyphs[_i17 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
	          glyphs[_i17].features.blwf = true;
	          glyphs[_i17 + 1].features.blwf = true;
	        }
	      }
	    }
	
	    var prefLen = 2;
	    if (features.pref && base + prefLen < end) {
	      // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
	      for (var _i18 = base + 1; _i18 + prefLen - 1 < end; _i18++) {
	        var _g2 = [glyphs[_i18].copy(), glyphs[_i18 + 1].copy()];
	        if (wouldSubstitute(_g2, 'pref')) {
	          for (var _j4 = 0; _j4 < prefLen; _j4++) {
	            glyphs[_i18++].features.pref = true;
	          }
	
	          // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
	          // Read the feature spec.
	          // This allows distinguishing the following cases with MS Khmer fonts:
	          // U+1784,U+17D2,U+179A,U+17D2,U+1782
	          // U+1784,U+17D2,U+1782,U+17D2,U+179A
	          if (features.cfar) {
	            for (; _i18 < end; _i18++) {
	              glyphs[_i18].features.cfar = true;
	            }
	          }
	
	          break;
	        }
	      }
	    }
	
	    // Apply ZWJ/ZWNJ effects
	    for (var _i19 = start + 1; _i19 < end; _i19++) {
	      if (isJoiner(glyphs[_i19])) {
	        var nonJoiner = glyphs[_i19].shaperInfo.category === CATEGORIES.ZWNJ;
	        var _j5 = _i19;
	
	        do {
	          _j5--;
	
	          // ZWJ/ZWNJ should disable CJCT.  They do that by simply
	          // being there, since we don't skip them for the CJCT
	          // feature (ie. F_MANUAL_ZWJ)
	
	          // A ZWNJ disables HALF.
	          if (nonJoiner) {
	            delete glyphs[_j5].features.half;
	          }
	        } while (_j5 > start && !isConsonant(glyphs[_j5]));
	      }
	    }
	  }
	}
	
	function finalReordering(font, glyphs, plan) {
	  var indicConfig = plan.indicConfig;
	  var features = font._layoutEngine.engine.GSUBProcessor.features;
	
	  for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
	    // 4. Final reordering:
	    //
	    // After the localized forms and basic shaping forms GSUB features have been
	    // applied (see below), the shaping engine performs some final glyph
	    // reordering before applying all the remaining font features to the entire
	    // cluster.
	
	    var tryPref = !!features.pref;
	
	    // Find base again
	    var base = start;
	    for (; base < end; base++) {
	      if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
	        if (tryPref && base + 1 < end) {
	          for (var i = base + 1; i < end; i++) {
	            if (glyphs[i].features.pref) {
	              if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
	                // Ok, this was a 'pref' candidate but didn't form any.
	                // Base is around here...
	                base = i;
	                while (base < end && isHalantOrCoeng(glyphs[base])) {
	                  base++;
	                }
	                glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
	                tryPref = false;
	              }
	              break;
	            }
	          }
	        }
	
	        // For Malayalam, skip over unformed below- (but NOT post-) forms.
	        if (plan.unicodeScript === 'Malayalam') {
	          for (var _i20 = base + 1; _i20 < end; _i20++) {
	            while (_i20 < end && isJoiner(glyphs[_i20])) {
	              _i20++;
	            }
	
	            if (_i20 === end || !isHalantOrCoeng(glyphs[_i20])) {
	              break;
	            }
	
	            _i20++; // Skip halant.
	            while (_i20 < end && isJoiner(glyphs[_i20])) {
	              _i20++;
	            }
	
	            if (_i20 < end && isConsonant(glyphs[_i20]) && glyphs[_i20].shaperInfo.position === POSITIONS.Below_C) {
	              base = _i20;
	              glyphs[base].shaperInfo.position = POSITIONS.Base_C;
	            }
	          }
	        }
	
	        if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) {
	          base--;
	        }
	        break;
	      }
	    }
	
	    if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) {
	      base--;
	    }
	
	    if (base < end) {
	      while (start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS)) {
	        base--;
	      }
	    }
	
	    // o Reorder matras:
	    //
	    // If a pre-base matra character had been reordered before applying basic
	    // features, the glyph can be moved closer to the main consonant based on
	    // whether half-forms had been formed. Actual position for the matra is
	    // defined as “after last standalone halant glyph, after initial matra
	    // position and before the main consonant”. If ZWJ or ZWNJ follow this
	    // halant, position is moved after it.
	    //
	
	    if (start + 1 < end && start < base) {
	      // Otherwise there can't be any pre-base matra characters.
	      // If we lost track of base, alas, position before last thingy.
	      var newPos = base === end ? base - 2 : base - 1;
	
	      // Malayalam / Tamil do not have "half" forms or explicit virama forms.
	      // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
	      // We want to position matra after them.
	      if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
	        while (newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
	          newPos--;
	        }
	
	        // If we found no Halant we are done.
	        // Otherwise only proceed if the Halant does
	        // not belong to the Matra itself!
	        if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
	          // If ZWJ or ZWNJ follow this halant, position is moved after it.
	          if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) {
	            newPos++;
	          }
	        } else {
	          newPos = start; // No move.
	        }
	      }
	
	      if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
	        // Now go see if there's actually any matras...
	        for (var _i21 = newPos; _i21 > start; _i21--) {
	          if (glyphs[_i21 - 1].shaperInfo.position === POSITIONS.Pre_M) {
	            var oldPos = _i21 - 1;
	            if (oldPos < base && base <= newPos) {
	              // Shouldn't actually happen.
	              base--;
	            }
	
	            var tmp = glyphs[oldPos];
	            glyphs.splice.apply(glyphs, [oldPos, 0].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
	            glyphs[newPos] = tmp;
	
	            newPos--;
	          }
	        }
	      }
	    }
	
	    // o Reorder reph:
	    //
	    // Reph’s original position is always at the beginning of the syllable,
	    // (i.e. it is not reordered at the character reordering stage). However,
	    // it will be reordered according to the basic-forms shaping results.
	    // Possible positions for reph, depending on the script, are; after main,
	    // before post-base consonant forms, and after post-base consonant forms.
	
	    // Two cases:
	    //
	    // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
	    //   we should only move it if the sequence ligated to the repha form.
	    //
	    // - If repha is encoded separately and in the logical position, we should only
	    //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
	    //   to make it work without the reordering.
	    if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
	      var newRephPos = void 0;
	      var rephPos = indicConfig.rephPos;
	      var found = false;
	
	      // 1. If reph should be positioned after post-base consonant forms,
	      //    proceed to step 5.
	      if (rephPos !== POSITIONS.After_Post) {
	        //  2. If the reph repositioning class is not after post-base: target
	        //     position is after the first explicit halant glyph between the
	        //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
	        //     are following this halant, position is moved after it. If such
	        //     position is found, this is the target position. Otherwise,
	        //     proceed to the next step.
	        //
	        //     Note: in old-implementation fonts, where classifications were
	        //     fixed in shaping engine, there was no case where reph position
	        //     will be found on this step.
	        newRephPos = start + 1;
	        while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
	          newRephPos++;
	        }
	
	        if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
	          // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
	          if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
	            newRephPos++;
	          }
	
	          found = true;
	        }
	
	        // 3. If reph should be repositioned after the main consonant: find the
	        //    first consonant not ligated with main, or find the first
	        //    consonant that is not a potential pre-base reordering Ra.
	        if (!found && rephPos === POSITIONS.After_Main) {
	          newRephPos = base;
	          while (newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main) {
	            newRephPos++;
	          }
	
	          found = newRephPos < end;
	        }
	
	        // 4. If reph should be positioned before post-base consonant, find
	        //    first post-base classified consonant not ligated with main. If no
	        //    consonant is found, the target position should be before the
	        //    first matra, syllable modifier sign or vedic sign.
	        //
	        // This is our take on what step 4 is trying to say (and failing, BADLY).
	        if (!found && rephPos === POSITIONS.After_Sub) {
	          newRephPos = base;
	          while (newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD))) {
	            newRephPos++;
	          }
	
	          found = newRephPos < end;
	        }
	      }
	
	      //  5. If no consonant is found in steps 3 or 4, move reph to a position
	      //     immediately before the first post-base matra, syllable modifier
	      //     sign or vedic sign that has a reordering class after the intended
	      //     reph position. For example, if the reordering position for reph
	      //     is post-main, it will skip above-base matras that also have a
	      //     post-main position.
	      if (!found) {
	        // Copied from step 2.
	        newRephPos = start + 1;
	        while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
	          newRephPos++;
	        }
	
	        if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
	          // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
	          if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
	            newRephPos++;
	          }
	
	          found = true;
	        }
	      }
	
	      // 6. Otherwise, reorder reph to the end of the syllable.
	      if (!found) {
	        newRephPos = end - 1;
	        while (newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD) {
	          newRephPos--;
	        }
	
	        // If the Reph is to be ending up after a Matra,Halant sequence,
	        // position it before that Halant so it can interact with the Matra.
	        // However, if it's a plain Consonant,Halant we shouldn't do that.
	        // Uniscribe doesn't do this.
	        // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
	        if (isHalantOrCoeng(glyphs[newRephPos])) {
	          for (var _i22 = base + 1; _i22 < newRephPos; _i22++) {
	            if (glyphs[_i22].shaperInfo.category === CATEGORIES.M) {
	              newRephPos--;
	            }
	          }
	        }
	      }
	
	      var reph = glyphs[start];
	      glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, newRephPos - start)));
	      glyphs[newRephPos] = reph;
	
	      if (start < base && base <= newRephPos) {
	        base--;
	      }
	    }
	
	    // o Reorder pre-base reordering consonants:
	    //
	    // If a pre-base reordering consonant is found, reorder it according to
	    // the following rules:
	    if (tryPref && base + 1 < end) {
	      for (var _i23 = base + 1; _i23 < end; _i23++) {
	        if (glyphs[_i23].features.pref) {
	          // 1. Only reorder a glyph produced by substitution during application
	          //    of the <pref> feature. (Note that a font may shape a Ra consonant with
	          //    the feature generally but block it in certain contexts.)
	
	          // Note: We just check that something got substituted.  We don't check that
	          // the <pref> feature actually did it...
	          //
	          // Reorder pref only if it ligated.
	          if (glyphs[_i23].isLigated && !glyphs[_i23].isMultiplied) {
	            // 2. Try to find a target position the same way as for pre-base matra.
	            //    If it is found, reorder pre-base consonant glyph.
	            //
	            // 3. If position is not found, reorder immediately before main
	            //    consonant.
	            var _newPos = base;
	
	            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
	            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
	            // We want to position matra after them.
	            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
	              while (_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
	                _newPos--;
	              }
	
	              // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
	              // split matra, it should be reordered to *before* the left part of such matra.
	              if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
	                var _oldPos2 = _i23;
	                for (var j = base + 1; j < _oldPos2; j++) {
	                  if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
	                    _newPos--;
	                    break;
	                  }
	                }
	              }
	            }
	
	            if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) {
	              // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
	              if (_newPos < end && isJoiner(glyphs[_newPos])) {
	                _newPos++;
	              }
	            }
	
	            var _oldPos = _i23;
	            var _tmp = glyphs[_oldPos];
	            glyphs.splice.apply(glyphs, [_newPos + 1, 0].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
	            glyphs[_newPos] = _tmp;
	
	            if (_newPos <= base && base < _oldPos) {
	              base++;
	            }
	          }
	
	          break;
	        }
	      }
	    }
	
	    // Apply 'init' to the Left Matra if it's a word start.
	    if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test(unicode.getCategory(glyphs[start - 1].codePoints[0])))) {
	      glyphs[start].features.init = true;
	    }
	  }
	}
	
	function nextSyllable(glyphs, start) {
	  if (start >= glyphs.length) return start;
	  var syllable = glyphs[start].shaperInfo.syllable;
	  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}
	  return start;
	}
	
	var _class$7;
	var _temp$3;
	var categories$1 = useData.categories;
	var decompositions$2 = useData.decompositions;
	var trie$2 = new UnicodeTrie(Buffer("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","base64"));
	var stateMachine$1 = new StateMachine(useData);
	
	/**
	 * This shaper is an implementation of the Universal Shaping Engine, which
	 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
	 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
	 */
	var UniversalShaper = (_temp$3 = _class$7 = function (_DefaultShaper) {
	  _inherits(UniversalShaper, _DefaultShaper);
	
	  function UniversalShaper() {
	    _classCallCheck(this, UniversalShaper);
	
	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }
	
	  UniversalShaper.planFeatures = function planFeatures(plan) {
	    plan.addStage(setupSyllables$1);
	
	    // Default glyph pre-processing group
	    plan.addStage(['locl', 'ccmp', 'nukt', 'akhn']);
	
	    // Reordering group
	    plan.addStage(clearSubstitutionFlags);
	    plan.addStage(['rphf'], false);
	    plan.addStage(recordRphf);
	    plan.addStage(clearSubstitutionFlags);
	    plan.addStage(['pref']);
	    plan.addStage(recordPref);
	
	    // Orthographic unit shaping group
	    plan.addStage(['rkrf', 'abvf', 'blwf', 'half', 'pstf', 'vatu', 'cjct']);
	    plan.addStage(reorder);
	
	    // Topographical features
	    // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
	    // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
	
	    // Standard topographic presentation and positional feature application
	    plan.addStage(['abvs', 'blws', 'pres', 'psts', 'dist', 'abvm', 'blwm']);
	  };
	
	  UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    var _loop = function _loop(i) {
	      var codepoint = glyphs[i].codePoints[0];
	      if (decompositions$2[codepoint]) {
	        var decomposed = decompositions$2[codepoint].map(function (c) {
	          var g = plan.font.glyphForCodePoint(c);
	          return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
	        });
	
	        glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
	      }
	    };
	
	    // Decompose split vowels
	    // TODO: do this in a more general unicode normalizer
	    for (var i = glyphs.length - 1; i >= 0; i--) {
	      _loop(i);
	    }
	  };
	
	  return UniversalShaper;
	}(DefaultShaper), _class$7.zeroMarkWidths = 'BEFORE_GPOS', _temp$3);
	function useCategory(glyph) {
	  return trie$2.get(glyph.codePoints[0]);
	}
	
	var USEInfo = function USEInfo(category, syllableType, syllable) {
	  _classCallCheck(this, USEInfo);
	
	  this.category = category;
	  this.syllableType = syllableType;
	  this.syllable = syllable;
	};
	
	function setupSyllables$1(font, glyphs) {
	  var syllable = 0;
	  for (var _iterator = stateMachine$1.match(glyphs.map(useCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var _ref2 = _ref,
	        start = _ref2[0],
	        end = _ref2[1],
	        tags = _ref2[2];
	
	    ++syllable;
	
	    // Create shaper info
	    for (var i = start; i <= end; i++) {
	      glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
	    }
	
	    // Assign rphf feature
	    var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
	    for (var _i2 = start; _i2 < start + limit; _i2++) {
	      glyphs[_i2].features.rphf = true;
	    }
	  }
	}
	
	function clearSubstitutionFlags(font, glyphs) {
	  for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	    var _ref3;
	
	    if (_isArray2) {
	      if (_i3 >= _iterator2.length) break;
	      _ref3 = _iterator2[_i3++];
	    } else {
	      _i3 = _iterator2.next();
	      if (_i3.done) break;
	      _ref3 = _i3.value;
	    }
	
	    var glyph = _ref3;
	
	    glyph.substituted = false;
	  }
	}
	
	function recordRphf(font, glyphs) {
	  for (var _iterator3 = glyphs, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	    var _ref4;
	
	    if (_isArray3) {
	      if (_i4 >= _iterator3.length) break;
	      _ref4 = _iterator3[_i4++];
	    } else {
	      _i4 = _iterator3.next();
	      if (_i4.done) break;
	      _ref4 = _i4.value;
	    }
	
	    var glyph = _ref4;
	
	    if (glyph.substituted && glyph.features.rphf) {
	      // Mark a substituted repha.
	      glyph.shaperInfo.category = 'R';
	    }
	  }
	}
	
	function recordPref(font, glyphs) {
	  for (var _iterator4 = glyphs, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	    var _ref5;
	
	    if (_isArray4) {
	      if (_i5 >= _iterator4.length) break;
	      _ref5 = _iterator4[_i5++];
	    } else {
	      _i5 = _iterator4.next();
	      if (_i5.done) break;
	      _ref5 = _i5.value;
	    }
	
	    var glyph = _ref5;
	
	    if (glyph.substituted) {
	      // Mark a substituted pref as VPre, as they behave the same way.
	      glyph.shaperInfo.category = 'VPre';
	    }
	  }
	}
	
	function reorder(font, glyphs) {
	  var dottedCircle = font.glyphForCodePoint(0x25cc).id;
	
	  for (var start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)) {
	    var i = void 0,
	        j = void 0;
	    var info = glyphs[start].shaperInfo;
	    var type = info.syllableType;
	
	    // Only a few syllable types need reordering.
	    if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') {
	      continue;
	    }
	
	    // Insert a dotted circle glyph in broken clusters.
	    if (type === 'broken_cluster' && dottedCircle) {
	      var g = new GlyphInfo(font, dottedCircle, [0x25cc]);
	      g.shaperInfo = info;
	
	      // Insert after possible Repha.
	      for (i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++) {}
	      glyphs.splice(++i, 0, g);
	      end++;
	    }
	
	    // Move things forward.
	    if (info.category === 'R' && end - start > 1) {
	      // Got a repha. Reorder it to after first base, before first halant.
	      for (i = start + 1; i < end; i++) {
	        info = glyphs[i].shaperInfo;
	        if (isBase(info) || isHalant(glyphs[i])) {
	          // If we hit a halant, move before it; otherwise it's a base: move to it's
	          // place, and shift things in between backward.
	          if (isHalant(glyphs[i])) {
	            i--;
	          }
	
	          glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, i - start), [glyphs[i]]));
	          break;
	        }
	      }
	    }
	
	    // Move things back.
	    for (i = start, j = end; i < end; i++) {
	      info = glyphs[i].shaperInfo;
	      if (isBase(info) || isHalant(glyphs[i])) {
	        // If we hit a halant, move after it; otherwise it's a base: move to it's
	        // place, and shift things in between backward.
	        j = isHalant(glyphs[i]) ? i + 1 : i;
	      } else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) {
	        glyphs.splice.apply(glyphs, [j, 1, glyphs[i]].concat(glyphs.splice(j, i - j)));
	      }
	    }
	  }
	}
	
	function nextSyllable$1(glyphs, start) {
	  if (start >= glyphs.length) return start;
	  var syllable = glyphs[start].shaperInfo.syllable;
	  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}
	  return start;
	}
	
	function isHalant(glyph) {
	  return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
	}
	
	function isBase(info) {
	  return info.category === 'B' || info.category === 'GB';
	}
	
	var SHAPERS = {
	  arab: ArabicShaper, // Arabic
	  mong: ArabicShaper, // Mongolian
	  syrc: ArabicShaper, // Syriac
	  'nko ': ArabicShaper, // N'Ko
	  phag: ArabicShaper, // Phags Pa
	  mand: ArabicShaper, // Mandaic
	  mani: ArabicShaper, // Manichaean
	  phlp: ArabicShaper, // Psalter Pahlavi
	
	  hang: HangulShaper, // Hangul
	
	  bng2: IndicShaper, // Bengali
	  beng: IndicShaper, // Bengali
	  dev2: IndicShaper, // Devanagari
	  deva: IndicShaper, // Devanagari
	  gjr2: IndicShaper, // Gujarati
	  gujr: IndicShaper, // Gujarati
	  guru: IndicShaper, // Gurmukhi
	  gur2: IndicShaper, // Gurmukhi
	  knda: IndicShaper, // Kannada
	  knd2: IndicShaper, // Kannada
	  mlm2: IndicShaper, // Malayalam
	  mlym: IndicShaper, // Malayalam
	  ory2: IndicShaper, // Oriya
	  orya: IndicShaper, // Oriya
	  taml: IndicShaper, // Tamil
	  tml2: IndicShaper, // Tamil
	  telu: IndicShaper, // Telugu
	  tel2: IndicShaper, // Telugu
	  khmr: IndicShaper, // Khmer
	
	  bali: UniversalShaper, // Balinese
	  batk: UniversalShaper, // Batak
	  brah: UniversalShaper, // Brahmi
	  bugi: UniversalShaper, // Buginese
	  buhd: UniversalShaper, // Buhid
	  cakm: UniversalShaper, // Chakma
	  cham: UniversalShaper, // Cham
	  dupl: UniversalShaper, // Duployan
	  egyp: UniversalShaper, // Egyptian Hieroglyphs
	  gran: UniversalShaper, // Grantha
	  hano: UniversalShaper, // Hanunoo
	  java: UniversalShaper, // Javanese
	  kthi: UniversalShaper, // Kaithi
	  kali: UniversalShaper, // Kayah Li
	  khar: UniversalShaper, // Kharoshthi
	  khoj: UniversalShaper, // Khojki
	  sind: UniversalShaper, // Khudawadi
	  lepc: UniversalShaper, // Lepcha
	  limb: UniversalShaper, // Limbu
	  mahj: UniversalShaper, // Mahajani
	  // mand: UniversalShaper, // Mandaic
	  // mani: UniversalShaper, // Manichaean
	  mtei: UniversalShaper, // Meitei Mayek
	  modi: UniversalShaper, // Modi
	  // mong: UniversalShaper, // Mongolian
	  // 'nko ': UniversalShaper, // N’Ko
	  hmng: UniversalShaper, // Pahawh Hmong
	  // phag: UniversalShaper, // Phags-pa
	  // phlp: UniversalShaper, // Psalter Pahlavi
	  rjng: UniversalShaper, // Rejang
	  saur: UniversalShaper, // Saurashtra
	  shrd: UniversalShaper, // Sharada
	  sidd: UniversalShaper, // Siddham
	  sinh: UniversalShaper, // Sinhala
	  sund: UniversalShaper, // Sundanese
	  sylo: UniversalShaper, // Syloti Nagri
	  tglg: UniversalShaper, // Tagalog
	  tagb: UniversalShaper, // Tagbanwa
	  tale: UniversalShaper, // Tai Le
	  lana: UniversalShaper, // Tai Tham
	  tavt: UniversalShaper, // Tai Viet
	  takr: UniversalShaper, // Takri
	  tibt: UniversalShaper, // Tibetan
	  tfng: UniversalShaper, // Tifinagh
	  tirh: UniversalShaper, // Tirhuta
	
	  latn: DefaultShaper, // Latin
	  DFLT: DefaultShaper // Default
	};
	
	function choose(script) {
	  if (!Array.isArray(script)) {
	    script = [script];
	  }
	
	  for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var s = _ref;
	
	    var shaper = SHAPERS[s];
	    if (shaper) {
	      return shaper;
	    }
	  }
	
	  return DefaultShaper;
	}
	
	var GSUBProcessor = function (_OTProcessor) {
	  _inherits(GSUBProcessor, _OTProcessor);
	
	  function GSUBProcessor() {
	    _classCallCheck(this, GSUBProcessor);
	
	    return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
	  }
	
	  GSUBProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
	    var _this2 = this;
	
	    switch (lookupType) {
	      case 1:
	        {
	          // Single Substitution
	          var index = this.coverageIndex(table.coverage);
	          if (index === -1) {
	            return false;
	          }
	
	          var glyph = this.glyphIterator.cur;
	          switch (table.version) {
	            case 1:
	              glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
	              break;
	
	            case 2:
	              glyph.id = table.substitute.get(index);
	              break;
	          }
	
	          return true;
	        }
	
	      case 2:
	        {
	          // Multiple Substitution
	          var _index = this.coverageIndex(table.coverage);
	          if (_index !== -1) {
	            var _glyphs;
	
	            var sequence = table.sequences.get(_index);
	            this.glyphIterator.cur.id = sequence[0];
	            this.glyphIterator.cur.ligatureComponent = 0;
	
	            var features = this.glyphIterator.cur.features;
	            var curGlyph = this.glyphIterator.cur;
	            var replacement = sequence.slice(1).map(function (gid, i) {
	              var glyph = new GlyphInfo(_this2.font, gid, undefined, features);
	              glyph.shaperInfo = curGlyph.shaperInfo;
	              glyph.isLigated = curGlyph.isLigated;
	              glyph.ligatureComponent = i + 1;
	              glyph.substituted = true;
	              glyph.isMultiplied = true;
	              return glyph;
	            });
	
	            (_glyphs = this.glyphs).splice.apply(_glyphs, [this.glyphIterator.index + 1, 0].concat(replacement));
	            return true;
	          }
	
	          return false;
	        }
	
	      case 3:
	        {
	          // Alternate Substitution
	          var _index2 = this.coverageIndex(table.coverage);
	          if (_index2 !== -1) {
	            var USER_INDEX = 0; // TODO
	            this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
	            return true;
	          }
	
	          return false;
	        }
	
	      case 4:
	        {
	          // Ligature Substitution
	          var _index3 = this.coverageIndex(table.coverage);
	          if (_index3 === -1) {
	            return false;
	          }
	
	          for (var _iterator = table.ligatureSets.get(_index3), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	            var _ref;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }
	
	            var ligature = _ref;
	
	            var matched = this.sequenceMatchIndices(1, ligature.components);
	            if (!matched) {
	              continue;
	            }
	
	            var _curGlyph = this.glyphIterator.cur;
	
	            // Concatenate all of the characters the new ligature will represent
	            var characters = _curGlyph.codePoints.slice();
	            for (var _iterator2 = matched, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	              var _ref2;
	
	              if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	              } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	              }
	
	              var _index4 = _ref2;
	
	              characters.push.apply(characters, this.glyphs[_index4].codePoints);
	            }
	
	            // Create the replacement ligature glyph
	            var ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
	            ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
	            ligatureGlyph.isLigated = true;
	            ligatureGlyph.substituted = true;
	
	            // From Harfbuzz:
	            // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
	            //   the ligature to keep its old ligature id.  This will allow it to attach to
	            //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
	            //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
	            //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
	            //   later, we don't want them to lose their ligature id/component, otherwise
	            //   GPOS will fail to correctly position the mark ligature on top of the
	            //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
	            //
	            // - If a ligature is formed of components that some of which are also ligatures
	            //   themselves, and those ligature components had marks attached to *their*
	            //   components, we have to attach the marks to the new ligature component
	            //   positions!  Now *that*'s tricky!  And these marks may be following the
	            //   last component of the whole sequence, so we should loop forward looking
	            //   for them and update them.
	            //
	            //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
	            //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
	            //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
	            //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
	            //   the new ligature with a component value of 2.
	            //
	            //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
	            var isMarkLigature = _curGlyph.isMark;
	            for (var i = 0; i < matched.length && isMarkLigature; i++) {
	              isMarkLigature = this.glyphs[matched[i]].isMark;
	            }
	
	            ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
	
	            var lastLigID = _curGlyph.ligatureID;
	            var lastNumComps = _curGlyph.codePoints.length;
	            var curComps = lastNumComps;
	            var idx = this.glyphIterator.index + 1;
	
	            // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
	            // This allows GPOS to attach marks to the correct ligature components.
	            for (var _iterator3 = matched, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	              var _ref3;
	
	              if (_isArray3) {
	                if (_i3 >= _iterator3.length) break;
	                _ref3 = _iterator3[_i3++];
	              } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) break;
	                _ref3 = _i3.value;
	              }
	
	              var matchIndex = _ref3;
	
	              // Don't assign new ligature components for mark ligatures (see above)
	              if (isMarkLigature) {
	                idx = matchIndex;
	              } else {
	                while (idx < matchIndex) {
	                  var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
	                  this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
	                  this.glyphs[idx].ligatureComponent = ligatureComponent;
	                  idx++;
	                }
	              }
	
	              lastLigID = this.glyphs[idx].ligatureID;
	              lastNumComps = this.glyphs[idx].codePoints.length;
	              curComps += lastNumComps;
	              idx++; // skip base glyph
	            }
	
	            // Adjust ligature components for any marks following
	            if (lastLigID && !isMarkLigature) {
	              for (var _i4 = idx; _i4 < this.glyphs.length; _i4++) {
	                if (this.glyphs[_i4].ligatureID === lastLigID) {
	                  var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i4].ligatureComponent || 1, lastNumComps);
	                  this.glyphs[_i4].ligatureComponent = ligatureComponent;
	                } else {
	                  break;
	                }
	              }
	            }
	
	            // Delete the matched glyphs, and replace the current glyph with the ligature glyph
	            for (var _i5 = matched.length - 1; _i5 >= 0; _i5--) {
	              this.glyphs.splice(matched[_i5], 1);
	            }
	
	            this.glyphs[this.glyphIterator.index] = ligatureGlyph;
	            return true;
	          }
	
	          return false;
	        }
	
	      case 5:
	        // Contextual Substitution
	        return this.applyContext(table);
	
	      case 6:
	        // Chaining Contextual Substitution
	        return this.applyChainingContext(table);
	
	      case 7:
	        // Extension Substitution
	        return this.applyLookup(table.lookupType, table.extension);
	
	      default:
	        throw new Error('GSUB lookupType ' + lookupType + ' is not supported');
	    }
	  };
	
	  return GSUBProcessor;
	}(OTProcessor);
	
	var GPOSProcessor = function (_OTProcessor) {
	  _inherits(GPOSProcessor, _OTProcessor);
	
	  function GPOSProcessor() {
	    _classCallCheck(this, GPOSProcessor);
	
	    return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
	  }
	
	  GPOSProcessor.prototype.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
	    var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
	    if (value.xAdvance != null) {
	      position.xAdvance += value.xAdvance;
	    }
	
	    if (value.yAdvance != null) {
	      position.yAdvance += value.yAdvance;
	    }
	
	    if (value.xPlacement != null) {
	      position.xOffset += value.xPlacement;
	    }
	
	    if (value.yPlacement != null) {
	      position.yOffset += value.yPlacement;
	    }
	
	    // Adjustments for font variations
	    var variationProcessor = this.font._variationProcessor;
	    var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
	    if (variationProcessor && variationStore) {
	      if (value.xPlaDevice) {
	        position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
	      }
	
	      if (value.yPlaDevice) {
	        position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
	      }
	
	      if (value.xAdvDevice) {
	        position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
	      }
	
	      if (value.yAdvDevice) {
	        position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
	      }
	    }
	
	    // TODO: device tables
	  };
	
	  GPOSProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
	    switch (lookupType) {
	      case 1:
	        {
	          // Single positioning value
	          var index = this.coverageIndex(table.coverage);
	          if (index === -1) {
	            return false;
	          }
	
	          switch (table.version) {
	            case 1:
	              this.applyPositionValue(0, table.value);
	              break;
	
	            case 2:
	              this.applyPositionValue(0, table.values.get(index));
	              break;
	          }
	
	          return true;
	        }
	
	      case 2:
	        {
	          // Pair Adjustment Positioning
	          var nextGlyph = this.glyphIterator.peek();
	          if (!nextGlyph) {
	            return false;
	          }
	
	          var _index = this.coverageIndex(table.coverage);
	          if (_index === -1) {
	            return false;
	          }
	
	          switch (table.version) {
	            case 1:
	              // Adjustments for glyph pairs
	              var set = table.pairSets.get(_index);
	
	              for (var _iterator = set, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	                var _ref;
	
	                if (_isArray) {
	                  if (_i >= _iterator.length) break;
	                  _ref = _iterator[_i++];
	                } else {
	                  _i = _iterator.next();
	                  if (_i.done) break;
	                  _ref = _i.value;
	                }
	
	                var _pair = _ref;
	
	                if (_pair.secondGlyph === nextGlyph.id) {
	                  this.applyPositionValue(0, _pair.value1);
	                  this.applyPositionValue(1, _pair.value2);
	                  return true;
	                }
	              }
	
	              return false;
	
	            case 2:
	              // Class pair adjustment
	              var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
	              var class2 = this.getClassID(nextGlyph.id, table.classDef2);
	              if (class1 === -1 || class2 === -1) {
	                return false;
	              }
	
	              var pair = table.classRecords.get(class1).get(class2);
	              this.applyPositionValue(0, pair.value1);
	              this.applyPositionValue(1, pair.value2);
	              return true;
	          }
	        }
	
	      case 3:
	        {
	          // Cursive Attachment Positioning
	          var nextIndex = this.glyphIterator.peekIndex();
	          var _nextGlyph = this.glyphs[nextIndex];
	          if (!_nextGlyph) {
	            return false;
	          }
	
	          var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
	          if (!curRecord || !curRecord.exitAnchor) {
	            return false;
	          }
	
	          var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
	          if (!nextRecord || !nextRecord.entryAnchor) {
	            return false;
	          }
	
	          var entry = this.getAnchor(nextRecord.entryAnchor);
	          var exit = this.getAnchor(curRecord.exitAnchor);
	
	          var cur = this.positions[this.glyphIterator.index];
	          var next = this.positions[nextIndex];
	
	          switch (this.direction) {
	            case 'ltr':
	              cur.xAdvance = exit.x + cur.xOffset;
	
	              var d = entry.x + next.xOffset;
	              next.xAdvance -= d;
	              next.xOffset -= d;
	              break;
	
	            case 'rtl':
	              d = exit.x + cur.xOffset;
	              cur.xAdvance -= d;
	              cur.xOffset -= d;
	              next.xAdvance = entry.x + next.xOffset;
	              break;
	          }
	
	          if (this.glyphIterator.flags.rightToLeft) {
	            this.glyphIterator.cur.cursiveAttachment = nextIndex;
	            cur.yOffset = entry.y - exit.y;
	          } else {
	            _nextGlyph.cursiveAttachment = this.glyphIterator.index;
	            cur.yOffset = exit.y - entry.y;
	          }
	
	          return true;
	        }
	
	      case 4:
	        {
	          // Mark to base positioning
	          var markIndex = this.coverageIndex(table.markCoverage);
	          if (markIndex === -1) {
	            return false;
	          }
	
	          // search backward for a base glyph
	          var baseGlyphIndex = this.glyphIterator.index;
	          while (--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0)) {}
	
	          if (baseGlyphIndex < 0) {
	            return false;
	          }
	
	          var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
	          if (baseIndex === -1) {
	            return false;
	          }
	
	          var markRecord = table.markArray[markIndex];
	          var baseAnchor = table.baseArray[baseIndex][markRecord.class];
	          this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
	          return true;
	        }
	
	      case 5:
	        {
	          // Mark to ligature positioning
	          var _markIndex = this.coverageIndex(table.markCoverage);
	          if (_markIndex === -1) {
	            return false;
	          }
	
	          // search backward for a base glyph
	          var _baseGlyphIndex = this.glyphIterator.index;
	          while (--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark) {}
	
	          if (_baseGlyphIndex < 0) {
	            return false;
	          }
	
	          var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
	          if (ligIndex === -1) {
	            return false;
	          }
	
	          var ligAttach = table.ligatureArray[ligIndex];
	          var markGlyph = this.glyphIterator.cur;
	          var ligGlyph = this.glyphs[_baseGlyphIndex];
	          var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
	
	          var _markRecord = table.markArray[_markIndex];
	          var _baseAnchor = ligAttach[compIndex][_markRecord.class];
	          this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
	          return true;
	        }
	
	      case 6:
	        {
	          // Mark to mark positioning
	          var mark1Index = this.coverageIndex(table.mark1Coverage);
	          if (mark1Index === -1) {
	            return false;
	          }
	
	          // get the previous mark to attach to
	          var prevIndex = this.glyphIterator.peekIndex(-1);
	          var prev = this.glyphs[prevIndex];
	          if (!prev || !prev.isMark) {
	            return false;
	          }
	
	          var _cur = this.glyphIterator.cur;
	
	          // The following logic was borrowed from Harfbuzz
	          var good = false;
	          if (_cur.ligatureID === prev.ligatureID) {
	            if (!_cur.ligatureID) {
	              // Marks belonging to the same base
	              good = true;
	            } else if (_cur.ligatureComponent === prev.ligatureComponent) {
	              // Marks belonging to the same ligature component
	              good = true;
	            }
	          } else {
	            // If ligature ids don't match, it may be the case that one of the marks
	            // itself is a ligature, in which case match.
	            if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) {
	              good = true;
	            }
	          }
	
	          if (!good) {
	            return false;
	          }
	
	          var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
	          if (mark2Index === -1) {
	            return false;
	          }
	
	          var _markRecord2 = table.mark1Array[mark1Index];
	          var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
	          this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
	          return true;
	        }
	
	      case 7:
	        // Contextual positioning
	        return this.applyContext(table);
	
	      case 8:
	        // Chaining contextual positioning
	        return this.applyChainingContext(table);
	
	      case 9:
	        // Extension positioning
	        return this.applyLookup(table.lookupType, table.extension);
	
	      default:
	        throw new Error('Unsupported GPOS table: ' + lookupType);
	    }
	  };
	
	  GPOSProcessor.prototype.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
	    var baseCoords = this.getAnchor(baseAnchor);
	    var markCoords = this.getAnchor(markRecord.markAnchor);
	
	    var basePos = this.positions[baseGlyphIndex];
	    var markPos = this.positions[this.glyphIterator.index];
	
	    markPos.xOffset = baseCoords.x - markCoords.x;
	    markPos.yOffset = baseCoords.y - markCoords.y;
	    this.glyphIterator.cur.markAttachment = baseGlyphIndex;
	  };
	
	  GPOSProcessor.prototype.getAnchor = function getAnchor(anchor) {
	    // TODO: contour point, device tables
	    var x = anchor.xCoordinate;
	    var y = anchor.yCoordinate;
	
	    // Adjustments for font variations
	    var variationProcessor = this.font._variationProcessor;
	    var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
	    if (variationProcessor && variationStore) {
	      if (anchor.xDeviceTable) {
	        x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
	      }
	
	      if (anchor.yDeviceTable) {
	        y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
	      }
	    }
	
	    return { x: x, y: y };
	  };
	
	  GPOSProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
	    _OTProcessor.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);
	
	    for (var i = 0; i < this.glyphs.length; i++) {
	      this.fixCursiveAttachment(i);
	    }
	
	    this.fixMarkAttachment();
	  };
	
	  GPOSProcessor.prototype.fixCursiveAttachment = function fixCursiveAttachment(i) {
	    var glyph = this.glyphs[i];
	    if (glyph.cursiveAttachment != null) {
	      var j = glyph.cursiveAttachment;
	
	      glyph.cursiveAttachment = null;
	      this.fixCursiveAttachment(j);
	
	      this.positions[i].yOffset += this.positions[j].yOffset;
	    }
	  };
	
	  GPOSProcessor.prototype.fixMarkAttachment = function fixMarkAttachment() {
	    for (var i = 0; i < this.glyphs.length; i++) {
	      var glyph = this.glyphs[i];
	      if (glyph.markAttachment != null) {
	        var j = glyph.markAttachment;
	
	        this.positions[i].xOffset += this.positions[j].xOffset;
	        this.positions[i].yOffset += this.positions[j].yOffset;
	
	        if (this.direction === 'ltr') {
	          for (var k = j; k < i; k++) {
	            this.positions[i].xOffset -= this.positions[k].xAdvance;
	            this.positions[i].yOffset -= this.positions[k].yAdvance;
	          }
	        } else {
	          for (var _k = j + 1; _k < i + 1; _k++) {
	            this.positions[i].xOffset += this.positions[_k].xAdvance;
	            this.positions[i].yOffset += this.positions[_k].yAdvance;
	          }
	        }
	      }
	    }
	  };
	
	  return GPOSProcessor;
	}(OTProcessor);
	
	var OTLayoutEngine = function () {
	  function OTLayoutEngine(font) {
	    _classCallCheck(this, OTLayoutEngine);
	
	    this.font = font;
	    this.glyphInfos = null;
	    this.plan = null;
	    this.GSUBProcessor = null;
	    this.GPOSProcessor = null;
	    this.fallbackPosition = true;
	
	    if (font.GSUB) {
	      this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
	    }
	
	    if (font.GPOS) {
	      this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
	    }
	  }
	
	  OTLayoutEngine.prototype.setup = function setup(glyphRun) {
	    var _this = this;
	
	    // Map glyphs to GlyphInfo objects so data can be passed between
	    // GSUB and GPOS without mutating the real (shared) Glyph objects.
	    this.glyphInfos = glyphRun.glyphs.map(function (glyph) {
	      return new GlyphInfo(_this.font, glyph.id, [].concat(glyph.codePoints));
	    });
	
	    // Select a script based on what is available in GSUB/GPOS.
	    var script = null;
	    if (this.GPOSProcessor) {
	      script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
	    }
	
	    if (this.GSUBProcessor) {
	      script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
	    }
	
	    // Choose a shaper based on the script, and setup a shaping plan.
	    // This determines which features to apply to which glyphs.
	    this.shaper = choose(script);
	    this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
	    this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);
	
	    // Assign chosen features to output glyph run
	    for (var key in this.plan.allFeatures) {
	      glyphRun.features[key] = true;
	    }
	  };
	
	  OTLayoutEngine.prototype.substitute = function substitute(glyphRun) {
	    var _this2 = this;
	
	    if (this.GSUBProcessor) {
	      this.plan.process(this.GSUBProcessor, this.glyphInfos);
	
	      // Map glyph infos back to normal Glyph objects
	      glyphRun.glyphs = this.glyphInfos.map(function (glyphInfo) {
	        return _this2.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
	      });
	    }
	  };
	
	  OTLayoutEngine.prototype.position = function position(glyphRun) {
	    if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') {
	      this.zeroMarkAdvances(glyphRun.positions);
	    }
	
	    if (this.GPOSProcessor) {
	      this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
	    }
	
	    if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') {
	      this.zeroMarkAdvances(glyphRun.positions);
	    }
	
	    // Reverse the glyphs and positions if the script is right-to-left
	    if (glyphRun.direction === 'rtl') {
	      glyphRun.glyphs.reverse();
	      glyphRun.positions.reverse();
	    }
	
	    return this.GPOSProcessor && this.GPOSProcessor.features;
	  };
	
	  OTLayoutEngine.prototype.zeroMarkAdvances = function zeroMarkAdvances(positions) {
	    for (var i = 0; i < this.glyphInfos.length; i++) {
	      if (this.glyphInfos[i].isMark) {
	        positions[i].xAdvance = 0;
	        positions[i].yAdvance = 0;
	      }
	    }
	  };
	
	  OTLayoutEngine.prototype.cleanup = function cleanup() {
	    this.glyphInfos = null;
	    this.plan = null;
	    this.shaper = null;
	  };
	
	  OTLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    var features = [];
	
	    if (this.GSUBProcessor) {
	      this.GSUBProcessor.selectScript(script, language);
	      features.push.apply(features, _Object$keys(this.GSUBProcessor.features));
	    }
	
	    if (this.GPOSProcessor) {
	      this.GPOSProcessor.selectScript(script, language);
	      features.push.apply(features, _Object$keys(this.GPOSProcessor.features));
	    }
	
	    return features;
	  };
	
	  return OTLayoutEngine;
	}();
	
	var LayoutEngine = function () {
	  function LayoutEngine(font) {
	    _classCallCheck(this, LayoutEngine);
	
	    this.font = font;
	    this.unicodeLayoutEngine = null;
	    this.kernProcessor = null;
	
	    // Choose an advanced layout engine. We try the AAT morx table first since more
	    // scripts are currently supported because the shaping logic is built into the font.
	    if (this.font.morx) {
	      this.engine = new AATLayoutEngine(this.font);
	    } else if (this.font.GSUB || this.font.GPOS) {
	      this.engine = new OTLayoutEngine(this.font);
	    }
	  }
	
	  LayoutEngine.prototype.layout = function layout(string, features, script, language, direction) {
	    // Make the features parameter optional
	    if (typeof features === 'string') {
	      direction = language;
	      language = script;
	      script = features;
	      features = [];
	    }
	
	    // Map string to glyphs if needed
	    if (typeof string === 'string') {
	      // Attempt to detect the script from the string if not provided.
	      if (script == null) {
	        script = forString(string);
	      }
	
	      var glyphs = this.font.glyphsForString(string);
	    } else {
	      // Attempt to detect the script from the glyph code points if not provided.
	      if (script == null) {
	        var codePoints = [];
	        for (var _iterator = string, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var glyph = _ref;
	
	          codePoints.push.apply(codePoints, glyph.codePoints);
	        }
	
	        script = forCodePoints(codePoints);
	      }
	
	      var glyphs = string;
	    }
	
	    var glyphRun = new GlyphRun(glyphs, features, script, language, direction);
	
	    // Return early if there are no glyphs
	    if (glyphs.length === 0) {
	      glyphRun.positions = [];
	      return glyphRun;
	    }
	
	    // Setup the advanced layout engine
	    if (this.engine && this.engine.setup) {
	      this.engine.setup(glyphRun);
	    }
	
	    // Substitute and position the glyphs
	    this.substitute(glyphRun);
	    this.position(glyphRun);
	
	    this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
	
	    // Let the layout engine clean up any state it might have
	    if (this.engine && this.engine.cleanup) {
	      this.engine.cleanup();
	    }
	
	    return glyphRun;
	  };
	
	  LayoutEngine.prototype.substitute = function substitute(glyphRun) {
	    // Call the advanced layout engine to make substitutions
	    if (this.engine && this.engine.substitute) {
	      this.engine.substitute(glyphRun);
	    }
	  };
	
	  LayoutEngine.prototype.position = function position(glyphRun) {
	    // Get initial glyph positions
	    glyphRun.positions = glyphRun.glyphs.map(function (glyph) {
	      return new GlyphPosition(glyph.advanceWidth);
	    });
	    var positioned = null;
	
	    // Call the advanced layout engine. Returns the features applied.
	    if (this.engine && this.engine.position) {
	      positioned = this.engine.position(glyphRun);
	    }
	
	    // if there is no GPOS table, use unicode properties to position marks.
	    if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
	      if (!this.unicodeLayoutEngine) {
	        this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
	      }
	
	      this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
	    }
	
	    // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
	    if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
	      if (!this.kernProcessor) {
	        this.kernProcessor = new KernProcessor(this.font);
	      }
	
	      this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
	      glyphRun.features.kern = true;
	    }
	  };
	
	  LayoutEngine.prototype.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
	    var space = this.font.glyphForCodePoint(0x20);
	    for (var i = 0; i < glyphs.length; i++) {
	      if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
	        glyphs[i] = space;
	        positions[i].xAdvance = 0;
	        positions[i].yAdvance = 0;
	      }
	    }
	  };
	
	  LayoutEngine.prototype.isDefaultIgnorable = function isDefaultIgnorable(ch) {
	    // From DerivedCoreProperties.txt in the Unicode database,
	    // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
	    // Harfbuzz and Uniscribe do.
	    var plane = ch >> 16;
	    if (plane === 0) {
	      // BMP
	      switch (ch >> 8) {
	        case 0x00:
	          return ch === 0x00AD;
	        case 0x03:
	          return ch === 0x034F;
	        case 0x06:
	          return ch === 0x061C;
	        case 0x17:
	          return 0x17B4 <= ch && ch <= 0x17B5;
	        case 0x18:
	          return 0x180B <= ch && ch <= 0x180E;
	        case 0x20:
	          return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
	        case 0xFE:
	          return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
	        case 0xFF:
	          return 0xFFF0 <= ch && ch <= 0xFFF8;
	        default:
	          return false;
	      }
	    } else {
	      // Other planes
	      switch (plane) {
	        case 0x01:
	          return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
	        case 0x0E:
	          return 0xE0000 <= ch && ch <= 0xE0FFF;
	        default:
	          return false;
	      }
	    }
	  };
	
	  LayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    var features = [];
	
	    if (this.engine) {
	      features.push.apply(features, this.engine.getAvailableFeatures(script, language));
	    }
	
	    if (this.font.kern && features.indexOf('kern') === -1) {
	      features.push('kern');
	    }
	
	    return features;
	  };
	
	  LayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
	    var result = new _Set();
	
	    var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
	    for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var codePoint = _ref2;
	
	      result.add(_String$fromCodePoint(codePoint));
	    }
	
	    if (this.engine && this.engine.stringsForGlyph) {
	      for (var _iterator3 = this.engine.stringsForGlyph(gid), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var string = _ref3;
	
	        result.add(string);
	      }
	    }
	
	    return _Array$from(result);
	  };
	
	  return LayoutEngine;
	}();
	
	var SVG_COMMANDS = {
	  moveTo: 'M',
	  lineTo: 'L',
	  quadraticCurveTo: 'Q',
	  bezierCurveTo: 'C',
	  closePath: 'Z'
	};
	
	/**
	 * Path objects are returned by glyphs and represent the actual
	 * vector outlines for each glyph in the font. Paths can be converted
	 * to SVG path data strings, or to functions that can be applied to
	 * render the path to a graphics context.
	 */
	
	var Path = function () {
	  function Path() {
	    _classCallCheck(this, Path);
	
	    this.commands = [];
	    this._bbox = null;
	    this._cbox = null;
	  }
	
	  /**
	   * Compiles the path to a JavaScript function that can be applied with
	   * a graphics context in order to render the path.
	   * @return {string}
	   */
	
	
	  Path.prototype.toFunction = function toFunction() {
	    var cmds = this.commands.map(function (c) {
	      return '  ctx.' + c.command + '(' + c.args.join(', ') + ');';
	    });
	    return new Function('ctx', cmds.join('\n'));
	  };
	
	  /**
	   * Converts the path to an SVG path data string
	   * @return {string}
	   */
	
	
	  Path.prototype.toSVG = function toSVG() {
	    var cmds = this.commands.map(function (c) {
	      var args = c.args.map(function (arg) {
	        return Math.round(arg * 100) / 100;
	      });
	      return '' + SVG_COMMANDS[c.command] + args.join(' ');
	    });
	
	    return cmds.join('');
	  };
	
	  /**
	   * Gets the "control box" of a path.
	   * This is like the bounding box, but it includes all points including
	   * control points of bezier segments and is much faster to compute than
	   * the real bounding box.
	   * @type {BBox}
	   */
	
	
	  /**
	   * Applies a mapping function to each point in the path.
	   * @param {function} fn
	   * @return {Path}
	   */
	  Path.prototype.mapPoints = function mapPoints(fn) {
	    var path = new Path();
	
	    for (var _iterator = this.commands, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var c = _ref;
	
	      var args = [];
	      for (var _i2 = 0; _i2 < c.args.length; _i2 += 2) {
	        var _fn = fn(c.args[_i2], c.args[_i2 + 1]),
	            x = _fn[0],
	            y = _fn[1];
	
	        args.push(x, y);
	      }
	
	      path[c.command].apply(path, args);
	    }
	
	    return path;
	  };
	
	  /**
	   * Transforms the path by the given matrix.
	   */
	
	
	  Path.prototype.transform = function transform(m0, m1, m2, m3, m4, m5) {
	    return this.mapPoints(function (x, y) {
	      x = m0 * x + m2 * y + m4;
	      y = m1 * x + m3 * y + m5;
	      return [x, y];
	    });
	  };
	
	  /**
	   * Translates the path by the given offset.
	   */
	
	
	  Path.prototype.translate = function translate(x, y) {
	    return this.transform(1, 0, 0, 1, x, y);
	  };
	
	  /**
	   * Rotates the path by the given angle (in radians).
	   */
	
	
	  Path.prototype.rotate = function rotate(angle) {
	    var cos = Math.cos(angle);
	    var sin = Math.sin(angle);
	    return this.transform(cos, sin, -sin, cos, 0, 0);
	  };
	
	  /**
	   * Scales the path.
	   */
	
	
	  Path.prototype.scale = function scale(scaleX) {
	    var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
	
	    return this.transform(scaleX, 0, 0, scaleY, 0, 0);
	  };
	
	  _createClass(Path, [{
	    key: 'cbox',
	    get: function get() {
	      if (!this._cbox) {
	        var cbox = new BBox();
	        for (var _iterator2 = this.commands, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	          var _ref2;
	
	          if (_isArray2) {
	            if (_i3 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i3++];
	          } else {
	            _i3 = _iterator2.next();
	            if (_i3.done) break;
	            _ref2 = _i3.value;
	          }
	
	          var command = _ref2;
	
	          for (var _i4 = 0; _i4 < command.args.length; _i4 += 2) {
	            cbox.addPoint(command.args[_i4], command.args[_i4 + 1]);
	          }
	        }
	
	        this._cbox = _Object$freeze(cbox);
	      }
	
	      return this._cbox;
	    }
	
	    /**
	     * Gets the exact bounding box of the path by evaluating curve segments.
	     * Slower to compute than the control box, but more accurate.
	     * @type {BBox}
	     */
	
	  }, {
	    key: 'bbox',
	    get: function get() {
	      if (this._bbox) {
	        return this._bbox;
	      }
	
	      var bbox = new BBox();
	      var cx = 0,
	          cy = 0;
	
	      var f = function f(t) {
	        return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
	      };
	
	      for (var _iterator3 = this.commands, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i5 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i5++];
	        } else {
	          _i5 = _iterator3.next();
	          if (_i5.done) break;
	          _ref3 = _i5.value;
	        }
	
	        var c = _ref3;
	
	        switch (c.command) {
	          case 'moveTo':
	          case 'lineTo':
	            var _c$args = c.args,
	                x = _c$args[0],
	                y = _c$args[1];
	
	            bbox.addPoint(x, y);
	            cx = x;
	            cy = y;
	            break;
	
	          case 'quadraticCurveTo':
	          case 'bezierCurveTo':
	            if (c.command === 'quadraticCurveTo') {
	              // http://fontforge.org/bezier.html
	              var _c$args2 = c.args,
	                  qp1x = _c$args2[0],
	                  qp1y = _c$args2[1],
	                  p3x = _c$args2[2],
	                  p3y = _c$args2[3];
	
	              var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
	              var cp1y = cy + 2 / 3 * (qp1y - cy);
	              var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
	              var cp2y = p3y + 2 / 3 * (qp1y - p3y);
	            } else {
	              var _c$args3 = c.args,
	                  cp1x = _c$args3[0],
	                  cp1y = _c$args3[1],
	                  cp2x = _c$args3[2],
	                  cp2y = _c$args3[3],
	                  p3x = _c$args3[4],
	                  p3y = _c$args3[5];
	            }
	
	            // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	            bbox.addPoint(p3x, p3y);
	
	            var p0 = [cx, cy];
	            var p1 = [cp1x, cp1y];
	            var p2 = [cp2x, cp2y];
	            var p3 = [p3x, p3y];
	
	            for (var i = 0; i <= 1; i++) {
	              var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	              var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	              c = 3 * p1[i] - 3 * p0[i];
	
	              if (a === 0) {
	                if (b === 0) {
	                  continue;
	                }
	
	                var t = -c / b;
	                if (0 < t && t < 1) {
	                  if (i === 0) {
	                    bbox.addPoint(f(t), bbox.maxY);
	                  } else if (i === 1) {
	                    bbox.addPoint(bbox.maxX, f(t));
	                  }
	                }
	
	                continue;
	              }
	
	              var b2ac = Math.pow(b, 2) - 4 * c * a;
	              if (b2ac < 0) {
	                continue;
	              }
	
	              var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
	              if (0 < t1 && t1 < 1) {
	                if (i === 0) {
	                  bbox.addPoint(f(t1), bbox.maxY);
	                } else if (i === 1) {
	                  bbox.addPoint(bbox.maxX, f(t1));
	                }
	              }
	
	              var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
	              if (0 < t2 && t2 < 1) {
	                if (i === 0) {
	                  bbox.addPoint(f(t2), bbox.maxY);
	                } else if (i === 1) {
	                  bbox.addPoint(bbox.maxX, f(t2));
	                }
	              }
	            }
	
	            cx = p3x;
	            cy = p3y;
	            break;
	        }
	      }
	
	      return this._bbox = _Object$freeze(bbox);
	    }
	  }]);
	
	  return Path;
	}();
	
	var _arr = ['moveTo', 'lineTo', 'quadraticCurveTo', 'bezierCurveTo', 'closePath'];
	
	var _loop = function _loop() {
	  var command = _arr[_i6];
	  Path.prototype[command] = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    this._bbox = this._cbox = null;
	    this.commands.push({
	      command: command,
	      args: args
	    });
	
	    return this;
	  };
	};
	
	for (var _i6 = 0; _i6 < _arr.length; _i6++) {
	  _loop();
	}
	
	var StandardNames = ['.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth', 'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior', 'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla', 'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];
	
	var _class$8;
	function _applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
	 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
	 *
	 * You do not create glyph objects directly. They are created by various methods on the font object.
	 * There are several subclasses of the base Glyph class internally that may be returned depending
	 * on the font format, but they all inherit from this class.
	 */
	var Glyph = (_class$8 = function () {
	  function Glyph(id, codePoints, font) {
	    _classCallCheck(this, Glyph);
	
	    /**
	     * The glyph id in the font
	     * @type {number}
	     */
	    this.id = id;
	
	    /**
	     * An array of unicode code points that are represented by this glyph.
	     * There can be multiple code points in the case of ligatures and other glyphs
	     * that represent multiple visual characters.
	     * @type {number[]}
	     */
	    this.codePoints = codePoints;
	    this._font = font;
	
	    // TODO: get this info from GDEF if available
	    this.isMark = this.codePoints.every(unicode.isMark);
	    this.isLigature = this.codePoints.length > 1;
	  }
	
	  Glyph.prototype._getPath = function _getPath() {
	    return new Path();
	  };
	
	  Glyph.prototype._getCBox = function _getCBox() {
	    return this.path.cbox;
	  };
	
	  Glyph.prototype._getBBox = function _getBBox() {
	    return this.path.bbox;
	  };
	
	  Glyph.prototype._getTableMetrics = function _getTableMetrics(table) {
	    if (this.id < table.metrics.length) {
	      return table.metrics.get(this.id);
	    }
	
	    var metric = table.metrics.get(table.metrics.length - 1);
	    var res = {
	      advance: metric ? metric.advance : 0,
	      bearing: table.bearings.get(this.id - table.metrics.length) || 0
	    };
	
	    return res;
	  };
	
	  Glyph.prototype._getMetrics = function _getMetrics(cbox) {
	    if (this._metrics) {
	      return this._metrics;
	    }
	
	    var _getTableMetrics2 = this._getTableMetrics(this._font.hmtx),
	        advanceWidth = _getTableMetrics2.advance,
	        leftBearing = _getTableMetrics2.bearing;
	
	    // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
	
	
	    if (this._font.vmtx) {
	      var _getTableMetrics3 = this._getTableMetrics(this._font.vmtx),
	          advanceHeight = _getTableMetrics3.advance,
	          topBearing = _getTableMetrics3.bearing;
	    } else {
	      var os2 = void 0;
	      if (typeof cbox === 'undefined' || cbox === null) {
	        cbox = this.cbox;
	      }
	
	      if ((os2 = this._font['OS/2']) && os2.version > 0) {
	        var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
	        var topBearing = os2.typoAscender - cbox.maxY;
	      } else {
	        var hhea = this._font.hhea;
	
	        var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
	        var topBearing = hhea.ascent - cbox.maxY;
	      }
	    }
	
	    if (this._font._variationProcessor && this._font.HVAR) {
	      advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
	    }
	
	    return this._metrics = { advanceWidth: advanceWidth, advanceHeight: advanceHeight, leftBearing: leftBearing, topBearing: topBearing };
	  };
	
	  /**
	   * The glyph’s control box.
	   * This is often the same as the bounding box, but is faster to compute.
	   * Because of the way bezier curves are defined, some of the control points
	   * can be outside of the bounding box. Where `bbox` takes this into account,
	   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
	   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
	   * for a more detailed description.
	   *
	   * @type {BBox}
	   */
	
	
	  /**
	   * Returns a path scaled to the given font size.
	   * @param {number} size
	   * @return {Path}
	   */
	  Glyph.prototype.getScaledPath = function getScaledPath(size) {
	    var scale = 1 / this._font.unitsPerEm * size;
	    return this.path.scale(scale);
	  };
	
	  /**
	   * The glyph's advance width.
	   * @type {number}
	   */
	
	
	  Glyph.prototype._getName = function _getName() {
	    var post = this._font.post;
	
	    if (!post) {
	      return null;
	    }
	
	    switch (post.version) {
	      case 1:
	        return StandardNames[this.id];
	
	      case 2:
	        var id = post.glyphNameIndex[this.id];
	        if (id < StandardNames.length) {
	          return StandardNames[id];
	        }
	
	        return post.names[id - StandardNames.length];
	
	      case 2.5:
	        return StandardNames[this.id + post.offsets[this.id]];
	
	      case 4:
	        return String.fromCharCode(post.map[this.id]);
	    }
	  };
	
	  /**
	   * The glyph's name
	   * @type {string}
	   */
	
	
	  /**
	   * Renders the glyph to the given graphics context, at the specified font size.
	   * @param {CanvasRenderingContext2d} ctx
	   * @param {number} size
	   */
	  Glyph.prototype.render = function render(ctx, size) {
	    ctx.save();
	
	    var scale = 1 / this._font.head.unitsPerEm * size;
	    ctx.scale(scale, scale);
	
	    var fn = this.path.toFunction();
	    fn(ctx);
	    ctx.fill();
	
	    ctx.restore();
	  };
	
	  _createClass(Glyph, [{
	    key: 'cbox',
	    get: function get() {
	      return this._getCBox();
	    }
	
	    /**
	     * The glyph’s bounding box, i.e. the rectangle that encloses the
	     * glyph outline as tightly as possible.
	     * @type {BBox}
	     */
	
	  }, {
	    key: 'bbox',
	    get: function get() {
	      return this._getBBox();
	    }
	
	    /**
	     * A vector Path object representing the glyph outline.
	     * @type {Path}
	     */
	
	  }, {
	    key: 'path',
	    get: function get() {
	      // Cache the path so we only decode it once
	      // Decoding is actually performed by subclasses
	      return this._getPath();
	    }
	  }, {
	    key: 'advanceWidth',
	    get: function get() {
	      return this._getMetrics().advanceWidth;
	    }
	
	    /**
	     * The glyph's advance height.
	     * @type {number}
	     */
	
	  }, {
	    key: 'advanceHeight',
	    get: function get() {
	      return this._getMetrics().advanceHeight;
	    }
	  }, {
	    key: 'ligatureCaretPositions',
	    get: function get() {}
	  }, {
	    key: 'name',
	    get: function get() {
	      return this._getName();
	    }
	  }]);
	
	  return Glyph;
	}(), (_applyDecoratedDescriptor$4(_class$8.prototype, 'cbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'cbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'bbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'path', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'path'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceWidth', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceWidth'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceHeight', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceHeight'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'name', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'name'), _class$8.prototype)), _class$8);
	
	// The header for both simple and composite glyphs
	var GlyfHeader = new r.Struct({
	  numberOfContours: r.int16, // if negative, this is a composite glyph
	  xMin: r.int16,
	  yMin: r.int16,
	  xMax: r.int16,
	  yMax: r.int16
	});
	
	// Flags for simple glyphs
	var ON_CURVE = 1 << 0;
	var X_SHORT_VECTOR = 1 << 1;
	var Y_SHORT_VECTOR = 1 << 2;
	var REPEAT = 1 << 3;
	var SAME_X = 1 << 4;
	var SAME_Y = 1 << 5;
	
	// Flags for composite glyphs
	var ARG_1_AND_2_ARE_WORDS = 1 << 0;
	var WE_HAVE_A_SCALE = 1 << 3;
	var MORE_COMPONENTS = 1 << 5;
	var WE_HAVE_AN_X_AND_Y_SCALE = 1 << 6;
	var WE_HAVE_A_TWO_BY_TWO = 1 << 7;
	var WE_HAVE_INSTRUCTIONS = 1 << 8;
	// Represents a point in a simple glyph
	var Point = function () {
	  function Point(onCurve, endContour) {
	    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    _classCallCheck(this, Point);
	
	    this.onCurve = onCurve;
	    this.endContour = endContour;
	    this.x = x;
	    this.y = y;
	  }
	
	  Point.prototype.copy = function copy() {
	    return new Point(this.onCurve, this.endContour, this.x, this.y);
	  };
	
	  return Point;
	}();
	
	// Represents a component in a composite glyph
	
	var Component = function Component(glyphID, dx, dy) {
	  _classCallCheck(this, Component);
	
	  this.glyphID = glyphID;
	  this.dx = dx;
	  this.dy = dy;
	  this.pos = 0;
	  this.scaleX = this.scaleY = 1;
	  this.scale01 = this.scale10 = 0;
	};
	
	/**
	 * Represents a TrueType glyph.
	 */
	
	
	var TTFGlyph = function (_Glyph) {
	  _inherits(TTFGlyph, _Glyph);
	
	  function TTFGlyph() {
	    _classCallCheck(this, TTFGlyph);
	
	    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
	  }
	
	  // Parses just the glyph header and returns the bounding box
	  TTFGlyph.prototype._getCBox = function _getCBox(internal) {
	    // We need to decode the glyph if variation processing is requested,
	    // so it's easier just to recompute the path's cbox after decoding.
	    if (this._font._variationProcessor && !internal) {
	      return this.path.cbox;
	    }
	
	    var stream = this._font._getTableStream('glyf');
	    stream.pos += this._font.loca.offsets[this.id];
	    var glyph = GlyfHeader.decode(stream);
	
	    var cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
	    return _Object$freeze(cbox);
	  };
	
	  // Parses a single glyph coordinate
	
	
	  TTFGlyph.prototype._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
	    if (short) {
	      var val = stream.readUInt8();
	      if (!same) {
	        val = -val;
	      }
	
	      val += prev;
	    } else {
	      if (same) {
	        var val = prev;
	      } else {
	        var val = prev + stream.readInt16BE();
	      }
	    }
	
	    return val;
	  };
	
	  // Decodes the glyph data into points for simple glyphs,
	  // or components for composite glyphs
	
	
	  TTFGlyph.prototype._decode = function _decode() {
	    var glyfPos = this._font.loca.offsets[this.id];
	    var nextPos = this._font.loca.offsets[this.id + 1];
	
	    // Nothing to do if there is no data for this glyph
	    if (glyfPos === nextPos) {
	      return null;
	    }
	
	    var stream = this._font._getTableStream('glyf');
	    stream.pos += glyfPos;
	    var startPos = stream.pos;
	
	    var glyph = GlyfHeader.decode(stream);
	
	    if (glyph.numberOfContours > 0) {
	      this._decodeSimple(glyph, stream);
	    } else if (glyph.numberOfContours < 0) {
	      this._decodeComposite(glyph, stream, startPos);
	    }
	
	    return glyph;
	  };
	
	  TTFGlyph.prototype._decodeSimple = function _decodeSimple(glyph, stream) {
	    // this is a simple glyph
	    glyph.points = [];
	
	    var endPtsOfContours = new r.Array(r.uint16, glyph.numberOfContours).decode(stream);
	    glyph.instructions = new r.Array(r.uint8, r.uint16).decode(stream);
	
	    var flags = [];
	    var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
	
	    while (flags.length < numCoords) {
	      var flag = stream.readUInt8();
	      flags.push(flag);
	
	      // check for repeat flag
	      if (flag & REPEAT) {
	        var count = stream.readUInt8();
	        for (var j = 0; j < count; j++) {
	          flags.push(flag);
	        }
	      }
	    }
	
	    for (var i = 0; i < flags.length; i++) {
	      var flag = flags[i];
	      var point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
	      glyph.points.push(point);
	    }
	
	    var px = 0;
	    for (var i = 0; i < flags.length; i++) {
	      var flag = flags[i];
	      glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
	    }
	
	    var py = 0;
	    for (var i = 0; i < flags.length; i++) {
	      var flag = flags[i];
	      glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
	    }
	
	    if (this._font._variationProcessor) {
	      var points = glyph.points.slice();
	      points.push.apply(points, this._getPhantomPoints(glyph));
	
	      this._font._variationProcessor.transformPoints(this.id, points);
	      glyph.phantomPoints = points.slice(-4);
	    }
	
	    return;
	  };
	
	  TTFGlyph.prototype._decodeComposite = function _decodeComposite(glyph, stream) {
	    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    // this is a composite glyph
	    glyph.components = [];
	    var haveInstructions = false;
	    var flags = MORE_COMPONENTS;
	
	    while (flags & MORE_COMPONENTS) {
	      flags = stream.readUInt16BE();
	      var gPos = stream.pos - offset;
	      var glyphID = stream.readUInt16BE();
	      if (!haveInstructions) {
	        haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
	      }
	
	      if (flags & ARG_1_AND_2_ARE_WORDS) {
	        var dx = stream.readInt16BE();
	        var dy = stream.readInt16BE();
	      } else {
	        var dx = stream.readInt8();
	        var dy = stream.readInt8();
	      }
	
	      var component = new Component(glyphID, dx, dy);
	      component.pos = gPos;
	
	      if (flags & WE_HAVE_A_SCALE) {
	        // fixed number with 14 bits of fraction
	        component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	      } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
	        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	      } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
	        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	      }
	
	      glyph.components.push(component);
	    }
	
	    if (this._font._variationProcessor) {
	      var points = [];
	      for (var j = 0; j < glyph.components.length; j++) {
	        var component = glyph.components[j];
	        points.push(new Point(true, true, component.dx, component.dy));
	      }
	
	      points.push.apply(points, this._getPhantomPoints(glyph));
	
	      this._font._variationProcessor.transformPoints(this.id, points);
	      glyph.phantomPoints = points.splice(-4, 4);
	
	      for (var i = 0; i < points.length; i++) {
	        var point = points[i];
	        glyph.components[i].dx = point.x;
	        glyph.components[i].dy = point.y;
	      }
	    }
	
	    return haveInstructions;
	  };
	
	  TTFGlyph.prototype._getPhantomPoints = function _getPhantomPoints(glyph) {
	    var cbox = this._getCBox(true);
	    if (this._metrics == null) {
	      this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
	    }
	
	    var _metrics = this._metrics,
	        advanceWidth = _metrics.advanceWidth,
	        advanceHeight = _metrics.advanceHeight,
	        leftBearing = _metrics.leftBearing,
	        topBearing = _metrics.topBearing;
	
	
	    return [new Point(false, true, glyph.xMin - leftBearing, 0), new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0), new Point(false, true, 0, glyph.yMax + topBearing), new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)];
	  };
	
	  // Decodes font data, resolves composite glyphs, and returns an array of contours
	
	
	  TTFGlyph.prototype._getContours = function _getContours() {
	    var glyph = this._decode();
	    if (!glyph) {
	      return [];
	    }
	
	    var points = [];
	
	    if (glyph.numberOfContours < 0) {
	      // resolve composite glyphs
	      for (var _iterator = glyph.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var component = _ref;
	
	        var _contours = this._font.getGlyph(component.glyphID)._getContours();
	        for (var i = 0; i < _contours.length; i++) {
	          var contour = _contours[i];
	          for (var j = 0; j < contour.length; j++) {
	            var _point = contour[j];
	            var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
	            var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
	            points.push(new Point(_point.onCurve, _point.endContour, x, y));
	          }
	        }
	      }
	    } else {
	      points = glyph.points || [];
	    }
	
	    // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
	    if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
	      this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
	      this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
	      this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
	      this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
	    }
	
	    var contours = [];
	    var cur = [];
	    for (var k = 0; k < points.length; k++) {
	      var point = points[k];
	      cur.push(point);
	      if (point.endContour) {
	        contours.push(cur);
	        cur = [];
	      }
	    }
	
	    return contours;
	  };
	
	  TTFGlyph.prototype._getMetrics = function _getMetrics() {
	    if (this._metrics) {
	      return this._metrics;
	    }
	
	    var cbox = this._getCBox(true);
	    _Glyph.prototype._getMetrics.call(this, cbox);
	
	    if (this._font._variationProcessor && !this._font.HVAR) {
	      // No HVAR table, decode the glyph. This triggers recomputation of metrics.
	      this.path;
	    }
	
	    return this._metrics;
	  };
	
	  // Converts contours to a Path object that can be rendered
	
	
	  TTFGlyph.prototype._getPath = function _getPath() {
	    var contours = this._getContours();
	    var path = new Path();
	
	    for (var i = 0; i < contours.length; i++) {
	      var contour = contours[i];
	      var firstPt = contour[0];
	      var lastPt = contour[contour.length - 1];
	      var start = 0;
	
	      if (firstPt.onCurve) {
	        // The first point will be consumed by the moveTo command, so skip in the loop
	        var curvePt = null;
	        start = 1;
	      } else {
	        if (lastPt.onCurve) {
	          // Start at the last point if the first point is off curve and the last point is on curve
	          firstPt = lastPt;
	        } else {
	          // Start at the middle if both the first and last points are off curve
	          firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
	        }
	
	        var curvePt = firstPt;
	      }
	
	      path.moveTo(firstPt.x, firstPt.y);
	
	      for (var j = start; j < contour.length; j++) {
	        var pt = contour[j];
	        var prevPt = j === 0 ? firstPt : contour[j - 1];
	
	        if (prevPt.onCurve && pt.onCurve) {
	          path.lineTo(pt.x, pt.y);
	        } else if (prevPt.onCurve && !pt.onCurve) {
	          var curvePt = pt;
	        } else if (!prevPt.onCurve && !pt.onCurve) {
	          var midX = (prevPt.x + pt.x) / 2;
	          var midY = (prevPt.y + pt.y) / 2;
	          path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
	          var curvePt = pt;
	        } else if (!prevPt.onCurve && pt.onCurve) {
	          path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
	          var curvePt = null;
	        } else {
	          throw new Error("Unknown TTF path state");
	        }
	      }
	
	      // Connect the first and last points
	      if (curvePt) {
	        path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
	      }
	
	      path.closePath();
	    }
	
	    return path;
	  };
	
	  return TTFGlyph;
	}(Glyph);
	
	/**
	 * Represents an OpenType PostScript glyph, in the Compact Font Format.
	 */
	
	var CFFGlyph = function (_Glyph) {
	  _inherits(CFFGlyph, _Glyph);
	
	  function CFFGlyph() {
	    _classCallCheck(this, CFFGlyph);
	
	    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
	  }
	
	  CFFGlyph.prototype._getName = function _getName() {
	    if (this._font.CFF2) {
	      return _Glyph.prototype._getName.call(this);
	    }
	
	    return this._font['CFF '].getGlyphName(this.id);
	  };
	
	  CFFGlyph.prototype.bias = function bias(s) {
	    if (s.length < 1240) {
	      return 107;
	    } else if (s.length < 33900) {
	      return 1131;
	    } else {
	      return 32768;
	    }
	  };
	
	  CFFGlyph.prototype._getPath = function _getPath() {
	    var stream = this._font.stream;
	    var pos = stream.pos;
	
	
	    var cff = this._font.CFF2 || this._font['CFF '];
	    var str = cff.topDict.CharStrings[this.id];
	    var end = str.offset + str.length;
	    stream.pos = str.offset;
	
	    var path = new Path();
	    var stack = [];
	    var trans = [];
	
	    var width = null;
	    var nStems = 0;
	    var x = 0,
	        y = 0;
	    var usedGsubrs = void 0;
	    var usedSubrs = void 0;
	    var open = false;
	
	    this._usedGsubrs = usedGsubrs = {};
	    this._usedSubrs = usedSubrs = {};
	
	    var gsubrs = cff.globalSubrIndex || [];
	    var gsubrsBias = this.bias(gsubrs);
	
	    var privateDict = cff.privateDictForGlyph(this.id);
	    var subrs = privateDict.Subrs || [];
	    var subrsBias = this.bias(subrs);
	
	    var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
	    var vsindex = privateDict.vsindex;
	    var variationProcessor = this._font._variationProcessor;
	
	    function checkWidth() {
	      if (width == null) {
	        width = stack.shift() + privateDict.nominalWidthX;
	      }
	    }
	
	    function parseStems() {
	      if (stack.length % 2 !== 0) {
	        checkWidth();
	      }
	
	      nStems += stack.length >> 1;
	      return stack.length = 0;
	    }
	
	    function moveTo(x, y) {
	      if (open) {
	        path.closePath();
	      }
	
	      path.moveTo(x, y);
	      open = true;
	    }
	
	    var parse = function parse() {
	      while (stream.pos < end) {
	        var op = stream.readUInt8();
	        if (op < 32) {
	          switch (op) {
	            case 1: // hstem
	            case 3: // vstem
	            case 18: // hstemhm
	            case 23:
	              // vstemhm
	              parseStems();
	              break;
	
	            case 4:
	              // vmoveto
	              if (stack.length > 1) {
	                checkWidth();
	              }
	
	              y += stack.shift();
	              moveTo(x, y);
	              break;
	
	            case 5:
	              // rlineto
	              while (stack.length >= 2) {
	                x += stack.shift();
	                y += stack.shift();
	                path.lineTo(x, y);
	              }
	              break;
	
	            case 6: // hlineto
	            case 7:
	              // vlineto
	              var phase = op === 6;
	              while (stack.length >= 1) {
	                if (phase) {
	                  x += stack.shift();
	                } else {
	                  y += stack.shift();
	                }
	
	                path.lineTo(x, y);
	                phase = !phase;
	              }
	              break;
	
	            case 8:
	              // rrcurveto
	              while (stack.length > 0) {
	                var c1x = x + stack.shift();
	                var c1y = y + stack.shift();
	                var c2x = c1x + stack.shift();
	                var c2y = c1y + stack.shift();
	                x = c2x + stack.shift();
	                y = c2y + stack.shift();
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }
	              break;
	
	            case 10:
	              // callsubr
	              var index = stack.pop() + subrsBias;
	              var subr = subrs[index];
	              if (subr) {
	                usedSubrs[index] = true;
	                var p = stream.pos;
	                var e = end;
	                stream.pos = subr.offset;
	                end = subr.offset + subr.length;
	                parse();
	                stream.pos = p;
	                end = e;
	              }
	              break;
	
	            case 11:
	              // return
	              if (cff.version >= 2) {
	                break;
	              }
	              return;
	
	            case 14:
	              // endchar
	              if (cff.version >= 2) {
	                break;
	              }
	
	              if (stack.length > 0) {
	                checkWidth();
	              }
	
	              if (open) {
	                path.closePath();
	                open = false;
	              }
	              break;
	
	            case 15:
	              {
	                // vsindex
	                if (cff.version < 2) {
	                  throw new Error('vsindex operator not supported in CFF v1');
	                }
	
	                vsindex = stack.pop();
	                break;
	              }
	
	            case 16:
	              {
	                // blend
	                if (cff.version < 2) {
	                  throw new Error('blend operator not supported in CFF v1');
	                }
	
	                if (!variationProcessor) {
	                  throw new Error('blend operator in non-variation font');
	                }
	
	                var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
	                var numBlends = stack.pop();
	                var numOperands = numBlends * blendVector.length;
	                var delta = stack.length - numOperands;
	                var base = delta - numBlends;
	
	                for (var i = 0; i < numBlends; i++) {
	                  var sum = stack[base + i];
	                  for (var j = 0; j < blendVector.length; j++) {
	                    sum += blendVector[j] * stack[delta++];
	                  }
	
	                  stack[base + i] = sum;
	                }
	
	                while (numOperands--) {
	                  stack.pop();
	                }
	
	                break;
	              }
	
	            case 19: // hintmask
	            case 20:
	              // cntrmask
	              parseStems();
	              stream.pos += nStems + 7 >> 3;
	              break;
	
	            case 21:
	              // rmoveto
	              if (stack.length > 2) {
	                checkWidth();
	              }
	
	              x += stack.shift();
	              y += stack.shift();
	              moveTo(x, y);
	              break;
	
	            case 22:
	              // hmoveto
	              if (stack.length > 1) {
	                checkWidth();
	              }
	
	              x += stack.shift();
	              moveTo(x, y);
	              break;
	
	            case 24:
	              // rcurveline
	              while (stack.length >= 8) {
	                var c1x = x + stack.shift();
	                var c1y = y + stack.shift();
	                var c2x = c1x + stack.shift();
	                var c2y = c1y + stack.shift();
	                x = c2x + stack.shift();
	                y = c2y + stack.shift();
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }
	
	              x += stack.shift();
	              y += stack.shift();
	              path.lineTo(x, y);
	              break;
	
	            case 25:
	              // rlinecurve
	              while (stack.length >= 8) {
	                x += stack.shift();
	                y += stack.shift();
	                path.lineTo(x, y);
	              }
	
	              var c1x = x + stack.shift();
	              var c1y = y + stack.shift();
	              var c2x = c1x + stack.shift();
	              var c2y = c1y + stack.shift();
	              x = c2x + stack.shift();
	              y = c2y + stack.shift();
	              path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              break;
	
	            case 26:
	              // vvcurveto
	              if (stack.length % 2) {
	                x += stack.shift();
	              }
	
	              while (stack.length >= 4) {
	                c1x = x;
	                c1y = y + stack.shift();
	                c2x = c1x + stack.shift();
	                c2y = c1y + stack.shift();
	                x = c2x;
	                y = c2y + stack.shift();
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }
	              break;
	
	            case 27:
	              // hhcurveto
	              if (stack.length % 2) {
	                y += stack.shift();
	              }
	
	              while (stack.length >= 4) {
	                c1x = x + stack.shift();
	                c1y = y;
	                c2x = c1x + stack.shift();
	                c2y = c1y + stack.shift();
	                x = c2x + stack.shift();
	                y = c2y;
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }
	              break;
	
	            case 28:
	              // shortint
	              stack.push(stream.readInt16BE());
	              break;
	
	            case 29:
	              // callgsubr
	              index = stack.pop() + gsubrsBias;
	              subr = gsubrs[index];
	              if (subr) {
	                usedGsubrs[index] = true;
	                var p = stream.pos;
	                var e = end;
	                stream.pos = subr.offset;
	                end = subr.offset + subr.length;
	                parse();
	                stream.pos = p;
	                end = e;
	              }
	              break;
	
	            case 30: // vhcurveto
	            case 31:
	              // hvcurveto
	              phase = op === 31;
	              while (stack.length >= 4) {
	                if (phase) {
	                  c1x = x + stack.shift();
	                  c1y = y;
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  y = c2y + stack.shift();
	                  x = c2x + (stack.length === 1 ? stack.shift() : 0);
	                } else {
	                  c1x = x;
	                  c1y = y + stack.shift();
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  x = c2x + stack.shift();
	                  y = c2y + (stack.length === 1 ? stack.shift() : 0);
	                }
	
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	                phase = !phase;
	              }
	              break;
	
	            case 12:
	              op = stream.readUInt8();
	              switch (op) {
	                case 3:
	                  // and
	                  var a = stack.pop();
	                  var b = stack.pop();
	                  stack.push(a && b ? 1 : 0);
	                  break;
	
	                case 4:
	                  // or
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a || b ? 1 : 0);
	                  break;
	
	                case 5:
	                  // not
	                  a = stack.pop();
	                  stack.push(a ? 0 : 1);
	                  break;
	
	                case 9:
	                  // abs
	                  a = stack.pop();
	                  stack.push(Math.abs(a));
	                  break;
	
	                case 10:
	                  // add
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a + b);
	                  break;
	
	                case 11:
	                  // sub
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a - b);
	                  break;
	
	                case 12:
	                  // div
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a / b);
	                  break;
	
	                case 14:
	                  // neg
	                  a = stack.pop();
	                  stack.push(-a);
	                  break;
	
	                case 15:
	                  // eq
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a === b ? 1 : 0);
	                  break;
	
	                case 18:
	                  // drop
	                  stack.pop();
	                  break;
	
	                case 20:
	                  // put
	                  var val = stack.pop();
	                  var idx = stack.pop();
	                  trans[idx] = val;
	                  break;
	
	                case 21:
	                  // get
	                  idx = stack.pop();
	                  stack.push(trans[idx] || 0);
	                  break;
	
	                case 22:
	                  // ifelse
	                  var s1 = stack.pop();
	                  var s2 = stack.pop();
	                  var v1 = stack.pop();
	                  var v2 = stack.pop();
	                  stack.push(v1 <= v2 ? s1 : s2);
	                  break;
	
	                case 23:
	                  // random
	                  stack.push(Math.random());
	                  break;
	
	                case 24:
	                  // mul
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a * b);
	                  break;
	
	                case 26:
	                  // sqrt
	                  a = stack.pop();
	                  stack.push(Math.sqrt(a));
	                  break;
	
	                case 27:
	                  // dup
	                  a = stack.pop();
	                  stack.push(a, a);
	                  break;
	
	                case 28:
	                  // exch
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(b, a);
	                  break;
	
	                case 29:
	                  // index
	                  idx = stack.pop();
	                  if (idx < 0) {
	                    idx = 0;
	                  } else if (idx > stack.length - 1) {
	                    idx = stack.length - 1;
	                  }
	
	                  stack.push(stack[idx]);
	                  break;
	
	                case 30:
	                  // roll
	                  var n = stack.pop();
	                  var _j = stack.pop();
	
	                  if (_j >= 0) {
	                    while (_j > 0) {
	                      var t = stack[n - 1];
	                      for (var _i = n - 2; _i >= 0; _i--) {
	                        stack[_i + 1] = stack[_i];
	                      }
	
	                      stack[0] = t;
	                      _j--;
	                    }
	                  } else {
	                    while (_j < 0) {
	                      var t = stack[0];
	                      for (var _i2 = 0; _i2 <= n; _i2++) {
	                        stack[_i2] = stack[_i2 + 1];
	                      }
	
	                      stack[n - 1] = t;
	                      _j++;
	                    }
	                  }
	                  break;
	
	                case 34:
	                  // hflex
	                  c1x = x + stack.shift();
	                  c1y = y;
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  var c3x = c2x + stack.shift();
	                  var c3y = c2y;
	                  var c4x = c3x + stack.shift();
	                  var c4y = c3y;
	                  var c5x = c4x + stack.shift();
	                  var c5y = c4y;
	                  var c6x = c5x + stack.shift();
	                  var c6y = c5y;
	                  x = c6x;
	                  y = c6y;
	
	                  path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
	                  path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
	                  break;
	
	                case 35:
	                  // flex
	                  var pts = [];
	
	                  for (var _i3 = 0; _i3 <= 5; _i3++) {
	                    x += stack.shift();
	                    y += stack.shift();
	                    pts.push(x, y);
	                  }
	
	                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
	                  path.bezierCurveTo.apply(path, pts.slice(6));
	                  stack.shift(); // fd
	                  break;
	
	                case 36:
	                  // hflex1
	                  c1x = x + stack.shift();
	                  c1y = y + stack.shift();
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  c3x = c2x + stack.shift();
	                  c3y = c2y;
	                  c4x = c3x + stack.shift();
	                  c4y = c3y;
	                  c5x = c4x + stack.shift();
	                  c5y = c4y + stack.shift();
	                  c6x = c5x + stack.shift();
	                  c6y = c5y;
	                  x = c6x;
	                  y = c6y;
	
	                  path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
	                  path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
	                  break;
	
	                case 37:
	                  // flex1
	                  var startx = x;
	                  var starty = y;
	
	                  pts = [];
	                  for (var _i4 = 0; _i4 <= 4; _i4++) {
	                    x += stack.shift();
	                    y += stack.shift();
	                    pts.push(x, y);
	                  }
	
	                  if (Math.abs(x - startx) > Math.abs(y - starty)) {
	                    // horizontal
	                    x += stack.shift();
	                    y = starty;
	                  } else {
	                    x = startx;
	                    y += stack.shift();
	                  }
	
	                  pts.push(x, y);
	                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
	                  path.bezierCurveTo.apply(path, pts.slice(6));
	                  break;
	
	                default:
	                  throw new Error('Unknown op: 12 ' + op);
	              }
	              break;
	
	            default:
	              throw new Error('Unknown op: ' + op);
	          }
	        } else if (op < 247) {
	          stack.push(op - 139);
	        } else if (op < 251) {
	          var b1 = stream.readUInt8();
	          stack.push((op - 247) * 256 + b1 + 108);
	        } else if (op < 255) {
	          var b1 = stream.readUInt8();
	          stack.push(-(op - 251) * 256 - b1 - 108);
	        } else {
	          stack.push(stream.readInt32BE() / 65536);
	        }
	      }
	    };
	
	    parse();
	
	    if (open) {
	      path.closePath();
	    }
	
	    return path;
	  };
	
	  return CFFGlyph;
	}(Glyph);
	
	var SBIXImage = new r.Struct({
	  originX: r.uint16,
	  originY: r.uint16,
	  type: new r.String(4),
	  data: new r.Buffer(function (t) {
	    return t.parent.buflen - t._currentOffset;
	  })
	});
	
	/**
	 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
	 */
	
	var SBIXGlyph = function (_TTFGlyph) {
	  _inherits(SBIXGlyph, _TTFGlyph);
	
	  function SBIXGlyph() {
	    _classCallCheck(this, SBIXGlyph);
	
	    return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
	  }
	
	  /**
	   * Returns an object representing a glyph image at the given point size.
	   * The object has a data property with a Buffer containing the actual image data,
	   * along with the image type, and origin.
	   *
	   * @param {number} size
	   * @return {object}
	   */
	  SBIXGlyph.prototype.getImageForSize = function getImageForSize(size) {
	    for (var i = 0; i < this._font.sbix.imageTables.length; i++) {
	      var table = this._font.sbix.imageTables[i];
	      if (table.ppem >= size) {
	        break;
	      }
	    }
	
	    var offsets = table.imageOffsets;
	    var start = offsets[this.id];
	    var end = offsets[this.id + 1];
	
	    if (start === end) {
	      return null;
	    }
	
	    this._font.stream.pos = start;
	    return SBIXImage.decode(this._font.stream, { buflen: end - start });
	  };
	
	  SBIXGlyph.prototype.render = function render(ctx, size) {
	    var img = this.getImageForSize(size);
	    if (img != null) {
	      var scale = size / this._font.unitsPerEm;
	      ctx.image(img.data, { height: size, x: img.originX, y: (this.bbox.minY - img.originY) * scale });
	    }
	
	    if (this._font.sbix.flags.renderOutlines) {
	      _TTFGlyph.prototype.render.call(this, ctx, size);
	    }
	  };
	
	  return SBIXGlyph;
	}(TTFGlyph);
	
	var COLRLayer = function COLRLayer(glyph, color) {
	  _classCallCheck(this, COLRLayer);
	
	  this.glyph = glyph;
	  this.color = color;
	};
	
	/**
	 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
	 * Each glyph in this format contain a list of colored layers, each
	 * of which  is another vector glyph.
	 */
	
	
	var COLRGlyph = function (_Glyph) {
	  _inherits(COLRGlyph, _Glyph);
	
	  function COLRGlyph() {
	    _classCallCheck(this, COLRGlyph);
	
	    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
	  }
	
	  COLRGlyph.prototype._getBBox = function _getBBox() {
	    var bbox = new BBox();
	    for (var i = 0; i < this.layers.length; i++) {
	      var layer = this.layers[i];
	      var b = layer.glyph.bbox;
	      bbox.addPoint(b.minX, b.minY);
	      bbox.addPoint(b.maxX, b.maxY);
	    }
	
	    return bbox;
	  };
	
	  /**
	   * Returns an array of objects containing the glyph and color for
	   * each layer in the composite color glyph.
	   * @type {object[]}
	   */
	
	
	  COLRGlyph.prototype.render = function render(ctx, size) {
	    for (var _iterator = this.layers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var _ref2 = _ref,
	          glyph = _ref2.glyph,
	          color = _ref2.color;
	
	      ctx.fillColor([color.red, color.green, color.blue], color.alpha / 255 * 100);
	      glyph.render(ctx, size);
	    }
	
	    return;
	  };
	
	  _createClass(COLRGlyph, [{
	    key: 'layers',
	    get: function get() {
	      var cpal = this._font.CPAL;
	      var colr = this._font.COLR;
	      var low = 0;
	      var high = colr.baseGlyphRecord.length - 1;
	
	      while (low <= high) {
	        var mid = low + high >> 1;
	        var rec = colr.baseGlyphRecord[mid];
	
	        if (this.id < rec.gid) {
	          high = mid - 1;
	        } else if (this.id > rec.gid) {
	          low = mid + 1;
	        } else {
	          var baseLayer = rec;
	          break;
	        }
	      }
	
	      // if base glyph not found in COLR table,
	      // default to normal glyph from glyf or CFF
	      if (baseLayer == null) {
	        var g = this._font._getBaseGlyph(this.id);
	        var color = {
	          red: 0,
	          green: 0,
	          blue: 0,
	          alpha: 255
	        };
	
	        return [new COLRLayer(g, color)];
	      }
	
	      // otherwise, return an array of all the layers
	      var layers = [];
	      for (var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++) {
	        var rec = colr.layerRecords[i];
	        var color = cpal.colorRecords[rec.paletteIndex];
	        var g = this._font._getBaseGlyph(rec.gid);
	        layers.push(new COLRLayer(g, color));
	      }
	
	      return layers;
	    }
	  }]);
	
	  return COLRGlyph;
	}(Glyph);
	
	var TUPLES_SHARE_POINT_NUMBERS = 0x8000;
	var TUPLE_COUNT_MASK = 0x0fff;
	var EMBEDDED_TUPLE_COORD = 0x8000;
	var INTERMEDIATE_TUPLE = 0x4000;
	var PRIVATE_POINT_NUMBERS = 0x2000;
	var TUPLE_INDEX_MASK = 0x0fff;
	var POINTS_ARE_WORDS = 0x80;
	var POINT_RUN_COUNT_MASK = 0x7f;
	var DELTAS_ARE_ZERO = 0x80;
	var DELTAS_ARE_WORDS = 0x40;
	var DELTA_RUN_COUNT_MASK = 0x3f;
	
	/**
	 * This class is transforms TrueType glyphs according to the data from
	 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
	 * These tables allow infinite adjustments to glyph weight, width, slant,
	 * and optical size without the designer needing to specify every exact style.
	 *
	 * Apple's documentation for these tables is not great, so thanks to the
	 * Freetype project for figuring much of this out.
	 *
	 * @private
	 */
	
	var GlyphVariationProcessor = function () {
	  function GlyphVariationProcessor(font, coords) {
	    _classCallCheck(this, GlyphVariationProcessor);
	
	    this.font = font;
	    this.normalizedCoords = this.normalizeCoords(coords);
	    this.blendVectors = new _Map();
	  }
	
	  GlyphVariationProcessor.prototype.normalizeCoords = function normalizeCoords(coords) {
	    // the default mapping is linear along each axis, in two segments:
	    // from the minValue to defaultValue, and from defaultValue to maxValue.
	    var normalized = [];
	    for (var i = 0; i < this.font.fvar.axis.length; i++) {
	      var axis = this.font.fvar.axis[i];
	      if (coords[i] < axis.defaultValue) {
	        normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.defaultValue - axis.minValue + _Number$EPSILON));
	      } else {
	        normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.maxValue - axis.defaultValue + _Number$EPSILON));
	      }
	    }
	
	    // if there is an avar table, the normalized value is calculated
	    // by interpolating between the two nearest mapped values.
	    if (this.font.avar) {
	      for (var i = 0; i < this.font.avar.segment.length; i++) {
	        var segment = this.font.avar.segment[i];
	        for (var j = 0; j < segment.correspondence.length; j++) {
	          var pair = segment.correspondence[j];
	          if (j >= 1 && normalized[i] < pair.fromCoord) {
	            var prev = segment.correspondence[j - 1];
	            normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + _Number$EPSILON) / (pair.fromCoord - prev.fromCoord + _Number$EPSILON) + prev.toCoord;
	
	            break;
	          }
	        }
	      }
	    }
	
	    return normalized;
	  };
	
	  GlyphVariationProcessor.prototype.transformPoints = function transformPoints(gid, glyphPoints) {
	    if (!this.font.fvar || !this.font.gvar) {
	      return;
	    }
	
	    var gvar = this.font.gvar;
	
	    if (gid >= gvar.glyphCount) {
	      return;
	    }
	
	    var offset = gvar.offsets[gid];
	    if (offset === gvar.offsets[gid + 1]) {
	      return;
	    }
	
	    // Read the gvar data for this glyph
	    var stream = this.font.stream;
	
	    stream.pos = offset;
	    if (stream.pos >= stream.length) {
	      return;
	    }
	
	    var tupleCount = stream.readUInt16BE();
	    var offsetToData = offset + stream.readUInt16BE();
	
	    if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
	      var here = stream.pos;
	      stream.pos = offsetToData;
	      var sharedPoints = this.decodePoints();
	      offsetToData = stream.pos;
	      stream.pos = here;
	    }
	
	    var origPoints = glyphPoints.map(function (pt) {
	      return pt.copy();
	    });
	
	    tupleCount &= TUPLE_COUNT_MASK;
	    for (var i = 0; i < tupleCount; i++) {
	      var tupleDataSize = stream.readUInt16BE();
	      var tupleIndex = stream.readUInt16BE();
	
	      if (tupleIndex & EMBEDDED_TUPLE_COORD) {
	        var tupleCoords = [];
	        for (var a = 0; a < gvar.axisCount; a++) {
	          tupleCoords.push(stream.readInt16BE() / 16384);
	        }
	      } else {
	        if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) {
	          throw new Error('Invalid gvar table');
	        }
	
	        var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
	      }
	
	      if (tupleIndex & INTERMEDIATE_TUPLE) {
	        var startCoords = [];
	        for (var _a = 0; _a < gvar.axisCount; _a++) {
	          startCoords.push(stream.readInt16BE() / 16384);
	        }
	
	        var endCoords = [];
	        for (var _a2 = 0; _a2 < gvar.axisCount; _a2++) {
	          endCoords.push(stream.readInt16BE() / 16384);
	        }
	      }
	
	      // Get the factor at which to apply this tuple
	      var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
	      if (factor === 0) {
	        offsetToData += tupleDataSize;
	        continue;
	      }
	
	      var here = stream.pos;
	      stream.pos = offsetToData;
	
	      if (tupleIndex & PRIVATE_POINT_NUMBERS) {
	        var points = this.decodePoints();
	      } else {
	        var points = sharedPoints;
	      }
	
	      // points.length = 0 means there are deltas for all points
	      var nPoints = points.length === 0 ? glyphPoints.length : points.length;
	      var xDeltas = this.decodeDeltas(nPoints);
	      var yDeltas = this.decodeDeltas(nPoints);
	
	      if (points.length === 0) {
	        // all points
	        for (var _i = 0; _i < glyphPoints.length; _i++) {
	          var point = glyphPoints[_i];
	          point.x += Math.round(xDeltas[_i] * factor);
	          point.y += Math.round(yDeltas[_i] * factor);
	        }
	      } else {
	        var outPoints = origPoints.map(function (pt) {
	          return pt.copy();
	        });
	        var hasDelta = glyphPoints.map(function () {
	          return false;
	        });
	
	        for (var _i2 = 0; _i2 < points.length; _i2++) {
	          var idx = points[_i2];
	          if (idx < glyphPoints.length) {
	            var _point = outPoints[idx];
	            hasDelta[idx] = true;
	
	            _point.x += Math.round(xDeltas[_i2] * factor);
	            _point.y += Math.round(yDeltas[_i2] * factor);
	          }
	        }
	
	        this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
	
	        for (var _i3 = 0; _i3 < glyphPoints.length; _i3++) {
	          var deltaX = outPoints[_i3].x - origPoints[_i3].x;
	          var deltaY = outPoints[_i3].y - origPoints[_i3].y;
	
	          glyphPoints[_i3].x += deltaX;
	          glyphPoints[_i3].y += deltaY;
	        }
	      }
	
	      offsetToData += tupleDataSize;
	      stream.pos = here;
	    }
	  };
	
	  GlyphVariationProcessor.prototype.decodePoints = function decodePoints() {
	    var stream = this.font.stream;
	    var count = stream.readUInt8();
	
	    if (count & POINTS_ARE_WORDS) {
	      count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
	    }
	
	    var points = new Uint16Array(count);
	    var i = 0;
	    var point = 0;
	    while (i < count) {
	      var run = stream.readUInt8();
	      var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
	      var fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
	
	      for (var j = 0; j < runCount && i < count; j++) {
	        point += fn.call(stream);
	        points[i++] = point;
	      }
	    }
	
	    return points;
	  };
	
	  GlyphVariationProcessor.prototype.decodeDeltas = function decodeDeltas(count) {
	    var stream = this.font.stream;
	    var i = 0;
	    var deltas = new Int16Array(count);
	
	    while (i < count) {
	      var run = stream.readUInt8();
	      var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;
	
	      if (run & DELTAS_ARE_ZERO) {
	        i += runCount;
	      } else {
	        var fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
	        for (var j = 0; j < runCount && i < count; j++) {
	          deltas[i++] = fn.call(stream);
	        }
	      }
	    }
	
	    return deltas;
	  };
	
	  GlyphVariationProcessor.prototype.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
	    var normalized = this.normalizedCoords;
	    var gvar = this.font.gvar;
	
	    var factor = 1;
	
	    for (var i = 0; i < gvar.axisCount; i++) {
	      if (tupleCoords[i] === 0) {
	        continue;
	      }
	
	      if (normalized[i] === 0) {
	        return 0;
	      }
	
	      if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
	        if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) {
	          return 0;
	        }
	
	        factor = (factor * normalized[i] + _Number$EPSILON) / (tupleCoords[i] + _Number$EPSILON);
	      } else {
	        if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) {
	          return 0;
	        } else if (normalized[i] < tupleCoords[i]) {
	          factor = factor * (normalized[i] - startCoords[i] + _Number$EPSILON) / (tupleCoords[i] - startCoords[i] + _Number$EPSILON);
	        } else {
	          factor = factor * (endCoords[i] - normalized[i] + _Number$EPSILON) / (endCoords[i] - tupleCoords[i] + _Number$EPSILON);
	        }
	      }
	    }
	
	    return factor;
	  };
	
	  // Interpolates points without delta values.
	  // Needed for the Ø and Q glyphs in Skia.
	  // Algorithm from Freetype.
	
	
	  GlyphVariationProcessor.prototype.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
	    if (points.length === 0) {
	      return;
	    }
	
	    var point = 0;
	    while (point < points.length) {
	      var firstPoint = point;
	
	      // find the end point of the contour
	      var endPoint = point;
	      var pt = points[endPoint];
	      while (!pt.endContour) {
	        pt = points[++endPoint];
	      }
	
	      // find the first point that has a delta
	      while (point <= endPoint && !hasDelta[point]) {
	        point++;
	      }
	
	      if (point > endPoint) {
	        continue;
	      }
	
	      var firstDelta = point;
	      var curDelta = point;
	      point++;
	
	      while (point <= endPoint) {
	        // find the next point with a delta, and interpolate intermediate points
	        if (hasDelta[point]) {
	          this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
	          curDelta = point;
	        }
	
	        point++;
	      }
	
	      // shift contour if we only have a single delta
	      if (curDelta === firstDelta) {
	        this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
	      } else {
	        // otherwise, handle the remaining points at the end and beginning of the contour
	        this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
	
	        if (firstDelta > 0) {
	          this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
	        }
	      }
	
	      point = endPoint + 1;
	    }
	  };
	
	  GlyphVariationProcessor.prototype.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
	    if (p1 > p2) {
	      return;
	    }
	
	    var iterable = ['x', 'y'];
	    for (var i = 0; i < iterable.length; i++) {
	      var k = iterable[i];
	      if (inPoints[ref1][k] > inPoints[ref2][k]) {
	        var p = ref1;
	        ref1 = ref2;
	        ref2 = p;
	      }
	
	      var in1 = inPoints[ref1][k];
	      var in2 = inPoints[ref2][k];
	      var out1 = outPoints[ref1][k];
	      var out2 = outPoints[ref2][k];
	
	      // If the reference points have the same coordinate but different
	      // delta, inferred delta is zero.  Otherwise interpolate.
	      if (in1 !== in2 || out1 === out2) {
	        var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
	
	        for (var _p = p1; _p <= p2; _p++) {
	          var out = inPoints[_p][k];
	
	          if (out <= in1) {
	            out += out1 - in1;
	          } else if (out >= in2) {
	            out += out2 - in2;
	          } else {
	            out = out1 + (out - in1) * scale;
	          }
	
	          outPoints[_p][k] = out;
	        }
	      }
	    }
	  };
	
	  GlyphVariationProcessor.prototype.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
	    var deltaX = outPoints[ref].x - inPoints[ref].x;
	    var deltaY = outPoints[ref].y - inPoints[ref].y;
	
	    if (deltaX === 0 && deltaY === 0) {
	      return;
	    }
	
	    for (var p = p1; p <= p2; p++) {
	      if (p !== ref) {
	        outPoints[p].x += deltaX;
	        outPoints[p].y += deltaY;
	      }
	    }
	  };
	
	  GlyphVariationProcessor.prototype.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
	    var outerIndex = void 0,
	        innerIndex = void 0;
	
	    if (table.advanceWidthMapping) {
	      var idx = gid;
	      if (idx >= table.advanceWidthMapping.mapCount) {
	        idx = table.advanceWidthMapping.mapCount - 1;
	      }
	
	      var entryFormat = table.advanceWidthMapping.entryFormat;
	      var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
	      outerIndex = _table$advanceWidthMa.outerIndex;
	      innerIndex = _table$advanceWidthMa.innerIndex;
	    } else {
	      outerIndex = 0;
	      innerIndex = gid;
	    }
	
	    return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
	  };
	
	  // See pseudo code from `Font Variations Overview'
	  // in the OpenType specification.
	
	
	  GlyphVariationProcessor.prototype.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
	    if (outerIndex >= itemStore.itemVariationData.length) {
	      return 0;
	    }
	
	    var varData = itemStore.itemVariationData[outerIndex];
	    if (innerIndex >= varData.deltaSets.length) {
	      return 0;
	    }
	
	    var deltaSet = varData.deltaSets[innerIndex];
	    var blendVector = this.getBlendVector(itemStore, outerIndex);
	    var netAdjustment = 0;
	
	    for (var master = 0; master < varData.regionIndexCount; master++) {
	      netAdjustment += deltaSet.deltas[master] * blendVector[master];
	    }
	
	    return netAdjustment;
	  };
	
	  GlyphVariationProcessor.prototype.getBlendVector = function getBlendVector(itemStore, outerIndex) {
	    var varData = itemStore.itemVariationData[outerIndex];
	    if (this.blendVectors.has(varData)) {
	      return this.blendVectors.get(varData);
	    }
	
	    var normalizedCoords = this.normalizedCoords;
	    var blendVector = [];
	
	    // outer loop steps through master designs to be blended
	    for (var master = 0; master < varData.regionIndexCount; master++) {
	      var scalar = 1;
	      var regionIndex = varData.regionIndexes[master];
	      var axes = itemStore.variationRegionList.variationRegions[regionIndex];
	
	      // inner loop steps through axes in this region
	      for (var j = 0; j < axes.length; j++) {
	        var axis = axes[j];
	        var axisScalar = void 0;
	
	        // compute the scalar contribution of this axis
	        // ignore invalid ranges
	        if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) {
	          axisScalar = 1;
	        } else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) {
	          axisScalar = 1;
	
	          // peak of 0 means ignore this axis
	        } else if (axis.peakCoord === 0) {
	          axisScalar = 1;
	
	          // ignore this region if coords are out of range
	        } else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) {
	          axisScalar = 0;
	
	          // calculate a proportional factor
	        } else {
	          if (normalizedCoords[j] === axis.peakCoord) {
	            axisScalar = 1;
	          } else if (normalizedCoords[j] < axis.peakCoord) {
	            axisScalar = (normalizedCoords[j] - axis.startCoord + _Number$EPSILON) / (axis.peakCoord - axis.startCoord + _Number$EPSILON);
	          } else {
	            axisScalar = (axis.endCoord - normalizedCoords[j] + _Number$EPSILON) / (axis.endCoord - axis.peakCoord + _Number$EPSILON);
	          }
	        }
	
	        // take product of all the axis scalars
	        scalar *= axisScalar;
	      }
	
	      blendVector[master] = scalar;
	    }
	
	    this.blendVectors.set(varData, blendVector);
	    return blendVector;
	  };
	
	  return GlyphVariationProcessor;
	}();
	
	var Subset = function () {
	  function Subset(font) {
	    _classCallCheck(this, Subset);
	
	    this.font = font;
	    this.glyphs = [];
	    this.mapping = {};
	
	    // always include the missing glyph
	    this.includeGlyph(0);
	  }
	
	  Subset.prototype.includeGlyph = function includeGlyph(glyph) {
	    if ((typeof glyph === 'undefined' ? 'undefined' : _typeof(glyph)) === 'object') {
	      glyph = glyph.id;
	    }
	
	    if (this.mapping[glyph] == null) {
	      this.glyphs.push(glyph);
	      this.mapping[glyph] = this.glyphs.length - 1;
	    }
	
	    return this.mapping[glyph];
	  };
	
	  Subset.prototype.encodeStream = function encodeStream() {
	    var _this = this;
	
	    var s = new r.EncodeStream();
	
	    process.nextTick(function () {
	      _this.encode(s);
	      return s.end();
	    });
	
	    return s;
	  };
	
	  return Subset;
	}();
	
	// Flags for simple glyphs
	var ON_CURVE$1 = 1 << 0;
	var X_SHORT_VECTOR$1 = 1 << 1;
	var Y_SHORT_VECTOR$1 = 1 << 2;
	var REPEAT$1 = 1 << 3;
	var SAME_X$1 = 1 << 4;
	var SAME_Y$1 = 1 << 5;
	
	var Point$1 = function () {
	  function Point() {
	    _classCallCheck(this, Point);
	  }
	
	  Point.size = function size(val) {
	    return val >= 0 && val <= 255 ? 1 : 2;
	  };
	
	  Point.encode = function encode(stream, value) {
	    if (value >= 0 && value <= 255) {
	      stream.writeUInt8(value);
	    } else {
	      stream.writeInt16BE(value);
	    }
	  };
	
	  return Point;
	}();
	
	var Glyf = new r.Struct({
	  numberOfContours: r.int16, // if negative, this is a composite glyph
	  xMin: r.int16,
	  yMin: r.int16,
	  xMax: r.int16,
	  yMax: r.int16,
	  endPtsOfContours: new r.Array(r.uint16, 'numberOfContours'),
	  instructions: new r.Array(r.uint8, r.uint16),
	  flags: new r.Array(r.uint8, 0),
	  xPoints: new r.Array(Point$1, 0),
	  yPoints: new r.Array(Point$1, 0)
	});
	
	/**
	 * Encodes TrueType glyph outlines
	 */
	
	var TTFGlyphEncoder = function () {
	  function TTFGlyphEncoder() {
	    _classCallCheck(this, TTFGlyphEncoder);
	  }
	
	  TTFGlyphEncoder.prototype.encodeSimple = function encodeSimple(path) {
	    var instructions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var endPtsOfContours = [];
	    var xPoints = [];
	    var yPoints = [];
	    var flags = [];
	    var same = 0;
	    var lastX = 0,
	        lastY = 0,
	        lastFlag = 0;
	    var pointCount = 0;
	
	    for (var i = 0; i < path.commands.length; i++) {
	      var c = path.commands[i];
	
	      for (var j = 0; j < c.args.length; j += 2) {
	        var x = c.args[j];
	        var y = c.args[j + 1];
	        var flag = 0;
	
	        // If the ending point of a quadratic curve is the midpoint
	        // between the control point and the control point of the next
	        // quadratic curve, we can omit the ending point.
	        if (c.command === 'quadraticCurveTo' && j === 2) {
	          var next = path.commands[i + 1];
	          if (next && next.command === 'quadraticCurveTo') {
	            var midX = (lastX + next.args[0]) / 2;
	            var midY = (lastY + next.args[1]) / 2;
	
	            if (x === midX && y === midY) {
	              continue;
	            }
	          }
	        }
	
	        // All points except control points are on curve.
	        if (!(c.command === 'quadraticCurveTo' && j === 0)) {
	          flag |= ON_CURVE$1;
	        }
	
	        flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
	        flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);
	
	        if (flag === lastFlag && same < 255) {
	          flags[flags.length - 1] |= REPEAT$1;
	          same++;
	        } else {
	          if (same > 0) {
	            flags.push(same);
	            same = 0;
	          }
	
	          flags.push(flag);
	          lastFlag = flag;
	        }
	
	        lastX = x;
	        lastY = y;
	        pointCount++;
	      }
	
	      if (c.command === 'closePath') {
	        endPtsOfContours.push(pointCount - 1);
	      }
	    }
	
	    // Close the path if the last command didn't already
	    if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') {
	      endPtsOfContours.push(pointCount - 1);
	    }
	
	    var bbox = path.bbox;
	    var glyf = {
	      numberOfContours: endPtsOfContours.length,
	      xMin: bbox.minX,
	      yMin: bbox.minY,
	      xMax: bbox.maxX,
	      yMax: bbox.maxY,
	      endPtsOfContours: endPtsOfContours,
	      instructions: instructions,
	      flags: flags,
	      xPoints: xPoints,
	      yPoints: yPoints
	    };
	
	    var size = Glyf.size(glyf);
	    var tail = 4 - size % 4;
	
	    var stream = new r.EncodeStream(size + tail);
	    Glyf.encode(stream, glyf);
	
	    // Align to 4-byte length
	    if (tail !== 0) {
	      stream.fill(0, tail);
	    }
	
	    return stream.buffer;
	  };
	
	  TTFGlyphEncoder.prototype._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
	    var diff = value - last;
	
	    if (value === last) {
	      flag |= sameFlag;
	    } else {
	      if (-255 <= diff && diff <= 255) {
	        flag |= shortFlag;
	        if (diff < 0) {
	          diff = -diff;
	        } else {
	          flag |= sameFlag;
	        }
	      }
	
	      points.push(diff);
	    }
	
	    return flag;
	  };
	
	  return TTFGlyphEncoder;
	}();
	
	var TTFSubset = function (_Subset) {
	  _inherits(TTFSubset, _Subset);
	
	  function TTFSubset(font) {
	    _classCallCheck(this, TTFSubset);
	
	    var _this = _possibleConstructorReturn(this, _Subset.call(this, font));
	
	    _this.glyphEncoder = new TTFGlyphEncoder();
	    return _this;
	  }
	
	  TTFSubset.prototype._addGlyph = function _addGlyph(gid) {
	    var glyph = this.font.getGlyph(gid);
	    var glyf = glyph._decode();
	
	    // get the offset to the glyph from the loca table
	    var curOffset = this.font.loca.offsets[gid];
	    var nextOffset = this.font.loca.offsets[gid + 1];
	
	    var stream = this.font._getTableStream('glyf');
	    stream.pos += curOffset;
	
	    var buffer = stream.readBuffer(nextOffset - curOffset);
	
	    // if it is a compound glyph, include its components
	    if (glyf && glyf.numberOfContours < 0) {
	      buffer = new Buffer(buffer);
	      for (var _iterator = glyf.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var component = _ref;
	
	        gid = this.includeGlyph(component.glyphID);
	        buffer.writeUInt16BE(gid, component.pos);
	      }
	    } else if (glyf && this.font._variationProcessor) {
	      // If this is a TrueType variation glyph, re-encode the path
	      buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
	    }
	
	    this.glyf.push(buffer);
	    this.loca.offsets.push(this.offset);
	
	    this.hmtx.metrics.push({
	      advance: glyph.advanceWidth,
	      bearing: glyph._getMetrics().leftBearing
	    });
	
	    this.offset += buffer.length;
	    return this.glyf.length - 1;
	  };
	
	  TTFSubset.prototype.encode = function encode(stream) {
	    // tables required by PDF spec:
	    //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
	    //
	    // additional tables required for standalone fonts:
	    //   name, cmap, OS/2, post
	
	    this.glyf = [];
	    this.offset = 0;
	    this.loca = {
	      offsets: []
	    };
	
	    this.hmtx = {
	      metrics: [],
	      bearings: []
	    };
	
	    // include all the glyphs
	    // not using a for loop because we need to support adding more
	    // glyphs to the array as we go, and CoffeeScript caches the length.
	    var i = 0;
	    while (i < this.glyphs.length) {
	      this._addGlyph(this.glyphs[i++]);
	    }
	
	    var maxp = cloneDeep(this.font.maxp);
	    maxp.numGlyphs = this.glyf.length;
	
	    this.loca.offsets.push(this.offset);
	    tables.loca.preEncode.call(this.loca);
	
	    var head = cloneDeep(this.font.head);
	    head.indexToLocFormat = this.loca.version;
	
	    var hhea = cloneDeep(this.font.hhea);
	    hhea.numberOfMetrics = this.hmtx.metrics.length;
	
	    // map = []
	    // for index in [0...256]
	    //     if index < @numGlyphs
	    //         map[index] = index
	    //     else
	    //         map[index] = 0
	    //
	    // cmapTable =
	    //     version: 0
	    //     length: 262
	    //     language: 0
	    //     codeMap: map
	    //
	    // cmap =
	    //     version: 0
	    //     numSubtables: 1
	    //     tables: [
	    //         platformID: 1
	    //         encodingID: 0
	    //         table: cmapTable
	    //     ]
	
	    // TODO: subset prep, cvt, fpgm?
	    Directory.encode(stream, {
	      tables: {
	        head: head,
	        hhea: hhea,
	        loca: this.loca,
	        maxp: maxp,
	        'cvt ': this.font['cvt '],
	        prep: this.font.prep,
	        glyf: this.glyf,
	        hmtx: this.hmtx,
	        fpgm: this.font.fpgm
	
	        // name: clone @font.name
	        // 'OS/2': clone @font['OS/2']
	        // post: clone @font.post
	        // cmap: cmap
	      }
	    });
	  };
	
	  return TTFSubset;
	}(Subset);
	
	var CFFSubset = function (_Subset) {
	  _inherits(CFFSubset, _Subset);
	
	  function CFFSubset(font) {
	    _classCallCheck(this, CFFSubset);
	
	    var _this = _possibleConstructorReturn(this, _Subset.call(this, font));
	
	    _this.cff = _this.font['CFF '];
	    if (!_this.cff) {
	      throw new Error('Not a CFF Font');
	    }
	    return _this;
	  }
	
	  CFFSubset.prototype.subsetCharstrings = function subsetCharstrings() {
	    this.charstrings = [];
	    var gsubrs = {};
	
	    for (var _iterator = this.glyphs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var gid = _ref;
	
	      this.charstrings.push(this.cff.getCharString(gid));
	
	      var glyph = this.font.getGlyph(gid);
	      var path = glyph.path; // this causes the glyph to be parsed
	
	      for (var subr in glyph._usedGsubrs) {
	        gsubrs[subr] = true;
	      }
	    }
	
	    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
	  };
	
	  CFFSubset.prototype.subsetSubrs = function subsetSubrs(subrs, used) {
	    var res = [];
	    for (var i = 0; i < subrs.length; i++) {
	      var subr = subrs[i];
	      if (used[i]) {
	        this.cff.stream.pos = subr.offset;
	        res.push(this.cff.stream.readBuffer(subr.length));
	      } else {
	        res.push(new Buffer([11])); // return
	      }
	    }
	
	    return res;
	  };
	
	  CFFSubset.prototype.subsetFontdict = function subsetFontdict(topDict) {
	    topDict.FDArray = [];
	    topDict.FDSelect = {
	      version: 0,
	      fds: []
	    };
	
	    var used_fds = {};
	    var used_subrs = [];
	    for (var _iterator2 = this.glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var gid = _ref2;
	
	      var fd = this.cff.fdForGlyph(gid);
	      if (fd == null) {
	        continue;
	      }
	
	      if (!used_fds[fd]) {
	        topDict.FDArray.push(_Object$assign({}, this.cff.topDict.FDArray[fd]));
	        used_subrs.push({});
	      }
	
	      used_fds[fd] = true;
	      topDict.FDSelect.fds.push(topDict.FDArray.length - 1);
	
	      var glyph = this.font.getGlyph(gid);
	      var path = glyph.path; // this causes the glyph to be parsed
	      for (var subr in glyph._usedSubrs) {
	        used_subrs[used_subrs.length - 1][subr] = true;
	      }
	    }
	
	    for (var i = 0; i < topDict.FDArray.length; i++) {
	      var dict = topDict.FDArray[i];
	      delete dict.FontName;
	      if (dict.Private && dict.Private.Subrs) {
	        dict.Private = _Object$assign({}, dict.Private);
	        dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
	      }
	    }
	
	    return;
	  };
	
	  CFFSubset.prototype.createCIDFontdict = function createCIDFontdict(topDict) {
	    var used_subrs = {};
	    for (var _iterator3 = this.glyphs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var gid = _ref3;
	
	      var glyph = this.font.getGlyph(gid);
	      var path = glyph.path; // this causes the glyph to be parsed
	
	      for (var subr in glyph._usedSubrs) {
	        used_subrs[subr] = true;
	      }
	    }
	
	    var privateDict = _Object$assign({}, this.cff.topDict.Private);
	    privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
	
	    topDict.FDArray = [{ Private: privateDict }];
	    return topDict.FDSelect = {
	      version: 3,
	      nRanges: 1,
	      ranges: [{ first: 0, fd: 0 }],
	      sentinel: this.charstrings.length
	    };
	  };
	
	  CFFSubset.prototype.addString = function addString(string) {
	    if (!string) {
	      return null;
	    }
	
	    if (!this.strings) {
	      this.strings = [];
	    }
	
	    this.strings.push(string);
	    return standardStrings.length + this.strings.length - 1;
	  };
	
	  CFFSubset.prototype.encode = function encode(stream) {
	    this.subsetCharstrings();
	
	    var charset = {
	      version: this.charstrings.length > 255 ? 2 : 1,
	      ranges: [{ first: 1, nLeft: this.charstrings.length - 2 }]
	    };
	
	    var topDict = _Object$assign({}, this.cff.topDict);
	    topDict.Private = null;
	    topDict.charset = charset;
	    topDict.Encoding = null;
	    topDict.CharStrings = this.charstrings;
	
	    var _arr = ['version', 'Notice', 'Copyright', 'FullName', 'FamilyName', 'Weight', 'PostScript', 'BaseFontName', 'FontName'];
	    for (var _i4 = 0; _i4 < _arr.length; _i4++) {
	      var key = _arr[_i4];
	      topDict[key] = this.addString(this.cff.string(topDict[key]));
	    }
	
	    topDict.ROS = [this.addString('Adobe'), this.addString('Identity'), 0];
	    topDict.CIDCount = this.charstrings.length;
	
	    if (this.cff.isCIDFont) {
	      this.subsetFontdict(topDict);
	    } else {
	      this.createCIDFontdict(topDict);
	    }
	
	    var top = {
	      version: 1,
	      hdrSize: this.cff.hdrSize,
	      offSize: this.cff.length,
	      header: this.cff.header,
	      nameIndex: [this.cff.postscriptName],
	      topDictIndex: [topDict],
	      stringIndex: this.strings,
	      globalSubrIndex: this.gsubrs
	    };
	
	    CFFTop.encode(stream, top);
	  };
	
	  return CFFSubset;
	}(Subset);
	
	var _class;
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * This is the base class for all SFNT-based font formats in fontkit.
	 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
	 */
	var TTFFont = (_class = function () {
	  TTFFont.probe = function probe(buffer) {
	    var format = buffer.toString('ascii', 0, 4);
	    return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
	  };
	
	  function TTFFont(stream) {
	    var variationCoords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    _classCallCheck(this, TTFFont);
	
	    this.stream = stream;
	    this.variationCoords = variationCoords;
	
	    this._directoryPos = this.stream.pos;
	    this._tables = {};
	    this._glyphs = {};
	    this._decodeDirectory();
	
	    // define properties for each table to lazily parse
	    for (var tag in this.directory.tables) {
	      var table = this.directory.tables[tag];
	      if (tables[tag] && table.length > 0) {
	        _Object$defineProperty(this, tag, {
	          get: this._getTable.bind(this, table)
	        });
	      }
	    }
	  }
	
	  TTFFont.prototype._getTable = function _getTable(table) {
	    if (!(table.tag in this._tables)) {
	      try {
	        this._tables[table.tag] = this._decodeTable(table);
	      } catch (e) {
	        if (fontkit.logErrors) {
	          console.error('Error decoding table ' + table.tag);
	          console.error(e.stack);
	        }
	      }
	    }
	
	    return this._tables[table.tag];
	  };
	
	  TTFFont.prototype._getTableStream = function _getTableStream(tag) {
	    var table = this.directory.tables[tag];
	    if (table) {
	      this.stream.pos = table.offset;
	      return this.stream;
	    }
	
	    return null;
	  };
	
	  TTFFont.prototype._decodeDirectory = function _decodeDirectory() {
	    return this.directory = Directory.decode(this.stream, { _startOffset: 0 });
	  };
	
	  TTFFont.prototype._decodeTable = function _decodeTable(table) {
	    var pos = this.stream.pos;
	
	    var stream = this._getTableStream(table.tag);
	    var result = tables[table.tag].decode(stream, this, table.length);
	
	    this.stream.pos = pos;
	    return result;
	  };
	
	  /**
	   * The unique PostScript name for this font
	   * @type {string}
	   */
	
	
	  /**
	   * Gets a string from the font's `name` table
	   * `lang` is a BCP-47 language code.
	   * @return {string}
	   */
	  TTFFont.prototype.getName = function getName(key) {
	    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var record = this.name.records[key];
	    if (record) {
	      return record[lang];
	    }
	
	    return null;
	  };
	
	  /**
	   * The font's full name, e.g. "Helvetica Bold"
	   * @type {string}
	   */
	
	
	  /**
	   * Returns whether there is glyph in the font for the given unicode code point.
	   *
	   * @param {number} codePoint
	   * @return {boolean}
	   */
	  TTFFont.prototype.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
	    return !!this._cmapProcessor.lookup(codePoint);
	  };
	
	  /**
	   * Maps a single unicode code point to a Glyph object.
	   * Does not perform any advanced substitutions (there is no context to do so).
	   *
	   * @param {number} codePoint
	   * @return {Glyph}
	   */
	
	
	  TTFFont.prototype.glyphForCodePoint = function glyphForCodePoint(codePoint) {
	    return this.getGlyph(this._cmapProcessor.lookup(codePoint), [codePoint]);
	  };
	
	  /**
	   * Returns an array of Glyph objects for the given string.
	   * This is only a one-to-one mapping from characters to glyphs.
	   * For most uses, you should use font.layout (described below), which
	   * provides a much more advanced mapping supporting AAT and OpenType shaping.
	   *
	   * @param {string} string
	   * @return {Glyph[]}
	   */
	
	
	  TTFFont.prototype.glyphsForString = function glyphsForString(string) {
	    var glyphs = [];
	    var len = string.length;
	    var idx = 0;
	    var last = -1;
	    var state = -1;
	
	    while (idx <= len) {
	      var code = 0;
	      var nextState = 0;
	
	      if (idx < len) {
	        // Decode the next codepoint from UTF 16
	        code = string.charCodeAt(idx++);
	        if (0xd800 <= code && code <= 0xdbff && idx < len) {
	          var next = string.charCodeAt(idx);
	          if (0xdc00 <= next && next <= 0xdfff) {
	            idx++;
	            code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
	          }
	        }
	
	        // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
	        nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
	      } else {
	        idx++;
	      }
	
	      if (state === 0 && nextState === 1) {
	        // Variation selector following normal codepoint.
	        glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [last, code]));
	      } else if (state === 0 && nextState === 0) {
	        // Normal codepoint following normal codepoint.
	        glyphs.push(this.glyphForCodePoint(last));
	      }
	
	      last = code;
	      state = nextState;
	    }
	
	    return glyphs;
	  };
	
	  /**
	   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
	   *
	   * @param {string} string
	   * @param {string[]} [userFeatures]
	   * @param {string} [script]
	   * @param {string} [language]
	   * @param {string} [direction]
	   * @return {GlyphRun}
	   */
	  TTFFont.prototype.layout = function layout(string, userFeatures, script, language, direction) {
	    return this._layoutEngine.layout(string, userFeatures, script, language, direction);
	  };
	
	  /**
	   * Returns an array of strings that map to the given glyph id.
	   * @param {number} gid - glyph id
	   */
	
	
	  TTFFont.prototype.stringsForGlyph = function stringsForGlyph(gid) {
	    return this._layoutEngine.stringsForGlyph(gid);
	  };
	
	  /**
	   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
	   * (or mapped AAT tags) supported by the font.
	   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
	   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
	   *
	   * @type {string[]}
	   */
	
	
	  TTFFont.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    return this._layoutEngine.getAvailableFeatures(script, language);
	  };
	
	  TTFFont.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
	    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    if (!this._glyphs[glyph]) {
	      if (this.directory.tables.glyf) {
	        this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
	      } else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) {
	        this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
	      }
	    }
	
	    return this._glyphs[glyph] || null;
	  };
	
	  /**
	   * Returns a glyph object for the given glyph id.
	   * You can pass the array of code points this glyph represents for
	   * your use later, and it will be stored in the glyph object.
	   *
	   * @param {number} glyph
	   * @param {number[]} characters
	   * @return {Glyph}
	   */
	
	
	  TTFFont.prototype.getGlyph = function getGlyph(glyph) {
	    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    if (!this._glyphs[glyph]) {
	      if (this.directory.tables.sbix) {
	        this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
	      } else if (this.directory.tables.COLR && this.directory.tables.CPAL) {
	        this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
	      } else {
	        this._getBaseGlyph(glyph, characters);
	      }
	    }
	
	    return this._glyphs[glyph] || null;
	  };
	
	  /**
	   * Returns a Subset for this font.
	   * @return {Subset}
	   */
	
	
	  TTFFont.prototype.createSubset = function createSubset() {
	    if (this.directory.tables['CFF ']) {
	      return new CFFSubset(this);
	    }
	
	    return new TTFSubset(this);
	  };
	
	  /**
	   * Returns an object describing the available variation axes
	   * that this font supports. Keys are setting tags, and values
	   * contain the axis name, range, and default value.
	   *
	   * @type {object}
	   */
	
	
	  /**
	   * Returns a new font with the given variation settings applied.
	   * Settings can either be an instance name, or an object containing
	   * variation tags as specified by the `variationAxes` property.
	   *
	   * @param {object} settings
	   * @return {TTFFont}
	   */
	  TTFFont.prototype.getVariation = function getVariation(settings) {
	    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) {
	      throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
	    }
	
	    if (typeof settings === 'string') {
	      settings = this.namedVariations[settings];
	    }
	
	    if ((typeof settings === 'undefined' ? 'undefined' : _typeof(settings)) !== 'object') {
	      throw new Error('Variation settings must be either a variation name or settings object.');
	    }
	
	    // normalize the coordinates
	    var coords = this.fvar.axis.map(function (axis, i) {
	      var axisTag = axis.axisTag.trim();
	      if (axisTag in settings) {
	        return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
	      } else {
	        return axis.defaultValue;
	      }
	    });
	
	    var stream = new r.DecodeStream(this.stream.buffer);
	    stream.pos = this._directoryPos;
	
	    var font = new TTFFont(stream, coords);
	    font._tables = this._tables;
	
	    return font;
	  };
	
	  // Standardized format plugin API
	  TTFFont.prototype.getFont = function getFont(name) {
	    return this.getVariation(name);
	  };
	
	  _createClass(TTFFont, [{
	    key: 'postscriptName',
	    get: function get() {
	      var name = this.name.records.postscriptName;
	      if (name) {
	        var lang = _Object$keys(name)[0];
	        return name[lang];
	      }
	
	      return null;
	    }
	  }, {
	    key: 'fullName',
	    get: function get() {
	      return this.getName('fullName');
	    }
	
	    /**
	     * The font's family name, e.g. "Helvetica"
	     * @type {string}
	     */
	
	  }, {
	    key: 'familyName',
	    get: function get() {
	      return this.getName('fontFamily');
	    }
	
	    /**
	     * The font's sub-family, e.g. "Bold".
	     * @type {string}
	     */
	
	  }, {
	    key: 'subfamilyName',
	    get: function get() {
	      return this.getName('fontSubfamily');
	    }
	
	    /**
	     * The font's copyright information
	     * @type {string}
	     */
	
	  }, {
	    key: 'copyright',
	    get: function get() {
	      return this.getName('copyright');
	    }
	
	    /**
	     * The font's version number
	     * @type {string}
	     */
	
	  }, {
	    key: 'version',
	    get: function get() {
	      return this.getName('version');
	    }
	
	    /**
	     * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
	     * @type {number}
	     */
	
	  }, {
	    key: 'ascent',
	    get: function get() {
	      return this.hhea.ascent;
	    }
	
	    /**
	     * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
	     * @type {number}
	     */
	
	  }, {
	    key: 'descent',
	    get: function get() {
	      return this.hhea.descent;
	    }
	
	    /**
	     * The amount of space that should be included between lines
	     * @type {number}
	     */
	
	  }, {
	    key: 'lineGap',
	    get: function get() {
	      return this.hhea.lineGap;
	    }
	
	    /**
	     * The offset from the normal underline position that should be used
	     * @type {number}
	     */
	
	  }, {
	    key: 'underlinePosition',
	    get: function get() {
	      return this.post.underlinePosition;
	    }
	
	    /**
	     * The weight of the underline that should be used
	     * @type {number}
	     */
	
	  }, {
	    key: 'underlineThickness',
	    get: function get() {
	      return this.post.underlineThickness;
	    }
	
	    /**
	     * If this is an italic font, the angle the cursor should be drawn at to match the font design
	     * @type {number}
	     */
	
	  }, {
	    key: 'italicAngle',
	    get: function get() {
	      return this.post.italicAngle;
	    }
	
	    /**
	     * The height of capital letters above the baseline.
	     * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
	     * @type {number}
	     */
	
	  }, {
	    key: 'capHeight',
	    get: function get() {
	      var os2 = this['OS/2'];
	      return os2 ? os2.capHeight : this.ascent;
	    }
	
	    /**
	     * The height of lower case letters in the font.
	     * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
	     * @type {number}
	     */
	
	  }, {
	    key: 'xHeight',
	    get: function get() {
	      var os2 = this['OS/2'];
	      return os2 ? os2.xHeight : 0;
	    }
	
	    /**
	     * The number of glyphs in the font.
	     * @type {number}
	     */
	
	  }, {
	    key: 'numGlyphs',
	    get: function get() {
	      return this.maxp.numGlyphs;
	    }
	
	    /**
	     * The size of the font’s internal coordinate grid
	     * @type {number}
	     */
	
	  }, {
	    key: 'unitsPerEm',
	    get: function get() {
	      return this.head.unitsPerEm;
	    }
	
	    /**
	     * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
	     * @type {BBox}
	     */
	
	  }, {
	    key: 'bbox',
	    get: function get() {
	      return _Object$freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
	    }
	  }, {
	    key: '_cmapProcessor',
	    get: function get() {
	      return new CmapProcessor(this.cmap);
	    }
	
	    /**
	     * An array of all of the unicode code points supported by the font.
	     * @type {number[]}
	     */
	
	  }, {
	    key: 'characterSet',
	    get: function get() {
	      return this._cmapProcessor.getCharacterSet();
	    }
	  }, {
	    key: '_layoutEngine',
	    get: function get() {
	      return new LayoutEngine(this);
	    }
	  }, {
	    key: 'availableFeatures',
	    get: function get() {
	      return this._layoutEngine.getAvailableFeatures();
	    }
	  }, {
	    key: 'variationAxes',
	    get: function get() {
	      var res = {};
	      if (!this.fvar) {
	        return res;
	      }
	
	      for (var _iterator = this.fvar.axis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var axis = _ref;
	
	        res[axis.axisTag.trim()] = {
	          name: axis.name.en,
	          min: axis.minValue,
	          default: axis.defaultValue,
	          max: axis.maxValue
	        };
	      }
	
	      return res;
	    }
	
	    /**
	     * Returns an object describing the named variation instances
	     * that the font designer has specified. Keys are variation names
	     * and values are the variation settings for this instance.
	     *
	     * @type {object}
	     */
	
	  }, {
	    key: 'namedVariations',
	    get: function get() {
	      var res = {};
	      if (!this.fvar) {
	        return res;
	      }
	
	      for (var _iterator2 = this.fvar.instance, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var instance = _ref2;
	
	        var settings = {};
	        for (var i = 0; i < this.fvar.axis.length; i++) {
	          var axis = this.fvar.axis[i];
	          settings[axis.axisTag.trim()] = instance.coord[i];
	        }
	
	        res[instance.name.en] = settings;
	      }
	
	      return res;
	    }
	  }, {
	    key: '_variationProcessor',
	    get: function get() {
	      if (!this.fvar) {
	        return null;
	      }
	
	      var variationCoords = this.variationCoords;
	
	      // Ignore if no variation coords and not CFF2
	      if (!variationCoords && !this.CFF2) {
	        return null;
	      }
	
	      if (!variationCoords) {
	        variationCoords = this.fvar.axis.map(function (axis) {
	          return axis.defaultValue;
	        });
	      }
	
	      return new GlyphVariationProcessor(this, variationCoords);
	    }
	  }]);
	
	  return TTFFont;
	}(), (_applyDecoratedDescriptor(_class.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'bbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_cmapProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_cmapProcessor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'characterSet', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'characterSet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_layoutEngine', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_layoutEngine'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'variationAxes', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'variationAxes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'namedVariations', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'namedVariations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_variationProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_variationProcessor'), _class.prototype)), _class);
	
	var WOFFDirectoryEntry = new r.Struct({
	  tag: new r.String(4),
	  offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
	  compLength: r.uint32,
	  length: r.uint32,
	  origChecksum: r.uint32
	});
	
	var WOFFDirectory = new r.Struct({
	  tag: new r.String(4), // should be 'wOFF'
	  flavor: r.uint32,
	  length: r.uint32,
	  numTables: r.uint16,
	  reserved: new r.Reserved(r.uint16),
	  totalSfntSize: r.uint32,
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  metaOffset: r.uint32,
	  metaLength: r.uint32,
	  metaOrigLength: r.uint32,
	  privOffset: r.uint32,
	  privLength: r.uint32,
	  tables: new r.Array(WOFFDirectoryEntry, 'numTables')
	});
	
	WOFFDirectory.process = function () {
	  var tables = {};
	  for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var table = _ref;
	
	    tables[table.tag] = table;
	  }
	
	  this.tables = tables;
	};
	
	var WOFFFont = function (_TTFFont) {
	  _inherits(WOFFFont, _TTFFont);
	
	  function WOFFFont() {
	    _classCallCheck(this, WOFFFont);
	
	    return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
	  }
	
	  WOFFFont.probe = function probe(buffer) {
	    return buffer.toString('ascii', 0, 4) === 'wOFF';
	  };
	
	  WOFFFont.prototype._decodeDirectory = function _decodeDirectory() {
	    this.directory = WOFFDirectory.decode(this.stream, { _startOffset: 0 });
	  };
	
	  WOFFFont.prototype._getTableStream = function _getTableStream(tag) {
	    var table = this.directory.tables[tag];
	    if (table) {
	      this.stream.pos = table.offset;
	
	      if (table.compLength < table.length) {
	        this.stream.pos += 2; // skip deflate header
	        var outBuffer = new Buffer(table.length);
	        var buf = inflate(this.stream.readBuffer(table.compLength - 2), outBuffer);
	        return new r.DecodeStream(buf);
	      } else {
	        return this.stream;
	      }
	    }
	
	    return null;
	  };
	
	  return WOFFFont;
	}(TTFFont);
	
	/**
	 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
	 */
	
	var WOFF2Glyph = function (_TTFGlyph) {
	  _inherits(WOFF2Glyph, _TTFGlyph);
	
	  function WOFF2Glyph() {
	    _classCallCheck(this, WOFF2Glyph);
	
	    return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
	  }
	
	  WOFF2Glyph.prototype._decode = function _decode() {
	    // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
	    return this._font._transformedGlyphs[this.id];
	  };
	
	  WOFF2Glyph.prototype._getCBox = function _getCBox() {
	    return this.path.bbox;
	  };
	
	  return WOFF2Glyph;
	}(TTFGlyph);
	
	var Base128 = {
	  decode: function decode(stream) {
	    var result = 0;
	    var iterable = [0, 1, 2, 3, 4];
	    for (var j = 0; j < iterable.length; j++) {
	      var i = iterable[j];
	      var code = stream.readUInt8();
	
	      // If any of the top seven bits are set then we're about to overflow.
	      if (result & 0xe0000000) {
	        throw new Error('Overflow');
	      }
	
	      result = result << 7 | code & 0x7f;
	      if ((code & 0x80) === 0) {
	        return result;
	      }
	    }
	
	    throw new Error('Bad base 128 number');
	  }
	};
	
	var knownTags = ['cmap', 'head', 'hhea', 'hmtx', 'maxp', 'name', 'OS/2', 'post', 'cvt ', 'fpgm', 'glyf', 'loca', 'prep', 'CFF ', 'VORG', 'EBDT', 'EBLC', 'gasp', 'hdmx', 'kern', 'LTSH', 'PCLT', 'VDMX', 'vhea', 'vmtx', 'BASE', 'GDEF', 'GPOS', 'GSUB', 'EBSC', 'JSTF', 'MATH', 'CBDT', 'CBLC', 'COLR', 'CPAL', 'SVG ', 'sbix', 'acnt', 'avar', 'bdat', 'bloc', 'bsln', 'cvar', 'fdsc', 'feat', 'fmtx', 'fvar', 'gvar', 'hsty', 'just', 'lcar', 'mort', 'morx', 'opbd', 'prop', 'trak', 'Zapf', 'Silf', 'Glat', 'Gloc', 'Feat', 'Sill'];
	
	var WOFF2DirectoryEntry = new r.Struct({
	  flags: r.uint8,
	  customTag: new r.Optional(new r.String(4), function (t) {
	    return (t.flags & 0x3f) === 0x3f;
	  }),
	  tag: function tag(t) {
	    return t.customTag || knownTags[t.flags & 0x3f];
	  }, // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
	  length: Base128,
	  transformVersion: function transformVersion(t) {
	    return t.flags >>> 6 & 0x03;
	  },
	  transformed: function transformed(t) {
	    return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
	  },
	  transformLength: new r.Optional(Base128, function (t) {
	    return t.transformed;
	  })
	});
	
	var WOFF2Directory = new r.Struct({
	  tag: new r.String(4), // should be 'wOF2'
	  flavor: r.uint32,
	  length: r.uint32,
	  numTables: r.uint16,
	  reserved: new r.Reserved(r.uint16),
	  totalSfntSize: r.uint32,
	  totalCompressedSize: r.uint32,
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  metaOffset: r.uint32,
	  metaLength: r.uint32,
	  metaOrigLength: r.uint32,
	  privOffset: r.uint32,
	  privLength: r.uint32,
	  tables: new r.Array(WOFF2DirectoryEntry, 'numTables')
	});
	
	WOFF2Directory.process = function () {
	  var tables = {};
	  for (var i = 0; i < this.tables.length; i++) {
	    var table = this.tables[i];
	    tables[table.tag] = table;
	  }
	
	  return this.tables = tables;
	};
	
	/**
	 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
	 * See spec here: http://www.w3.org/TR/WOFF2/
	 */
	
	var WOFF2Font = function (_TTFFont) {
	  _inherits(WOFF2Font, _TTFFont);
	
	  function WOFF2Font() {
	    _classCallCheck(this, WOFF2Font);
	
	    return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
	  }
	
	  WOFF2Font.probe = function probe(buffer) {
	    return buffer.toString('ascii', 0, 4) === 'wOF2';
	  };
	
	  WOFF2Font.prototype._decodeDirectory = function _decodeDirectory() {
	    this.directory = WOFF2Directory.decode(this.stream);
	    this._dataPos = this.stream.pos;
	  };
	
	  WOFF2Font.prototype._decompress = function _decompress() {
	    // decompress data and setup table offsets if we haven't already
	    if (!this._decompressed) {
	      this.stream.pos = this._dataPos;
	      var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
	
	      var decompressedSize = 0;
	      for (var tag in this.directory.tables) {
	        var entry = this.directory.tables[tag];
	        entry.offset = decompressedSize;
	        decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
	      }
	
	      var decompressed = brotli(buffer, decompressedSize);
	      if (!decompressed) {
	        throw new Error('Error decoding compressed data in WOFF2');
	      }
	
	      this.stream = new r.DecodeStream(new Buffer(decompressed));
	      this._decompressed = true;
	    }
	  };
	
	  WOFF2Font.prototype._decodeTable = function _decodeTable(table) {
	    this._decompress();
	    return _TTFFont.prototype._decodeTable.call(this, table);
	  };
	
	  // Override this method to get a glyph and return our
	  // custom subclass if there is a glyf table.
	
	
	  WOFF2Font.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
	    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    if (!this._glyphs[glyph]) {
	      if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
	        if (!this._transformedGlyphs) {
	          this._transformGlyfTable();
	        }
	        return this._glyphs[glyph] = new WOFF2Glyph(glyph, characters, this);
	      } else {
	        return _TTFFont.prototype._getBaseGlyph.call(this, glyph, characters);
	      }
	    }
	  };
	
	  WOFF2Font.prototype._transformGlyfTable = function _transformGlyfTable() {
	    this._decompress();
	    this.stream.pos = this.directory.tables.glyf.offset;
	    var table = GlyfTable.decode(this.stream);
	    var glyphs = [];
	
	    for (var index = 0; index < table.numGlyphs; index++) {
	      var glyph = {};
	      var nContours = table.nContours.readInt16BE();
	      glyph.numberOfContours = nContours;
	
	      if (nContours > 0) {
	        // simple glyph
	        var nPoints = [];
	        var totalPoints = 0;
	
	        for (var i = 0; i < nContours; i++) {
	          var _r = read255UInt16(table.nPoints);
	          totalPoints += _r;
	          nPoints.push(totalPoints);
	        }
	
	        glyph.points = decodeTriplet(table.flags, table.glyphs, totalPoints);
	        for (var _i = 0; _i < nContours; _i++) {
	          glyph.points[nPoints[_i] - 1].endContour = true;
	        }
	
	        var instructionSize = read255UInt16(table.glyphs);
	      } else if (nContours < 0) {
	        // composite glyph
	        var haveInstructions = TTFGlyph.prototype._decodeComposite.call({ _font: this }, glyph, table.composites);
	        if (haveInstructions) {
	          var instructionSize = read255UInt16(table.glyphs);
	        }
	      }
	
	      glyphs.push(glyph);
	    }
	
	    this._transformedGlyphs = glyphs;
	  };
	
	  return WOFF2Font;
	}(TTFFont);
	
	var Substream = function () {
	  function Substream(length) {
	    _classCallCheck(this, Substream);
	
	    this.length = length;
	    this._buf = new r.Buffer(length);
	  }
	
	  Substream.prototype.decode = function decode(stream, parent) {
	    return new r.DecodeStream(this._buf.decode(stream, parent));
	  };
	
	  return Substream;
	}();
	
	// This struct represents the entire glyf table
	
	
	var GlyfTable = new r.Struct({
	  version: r.uint32,
	  numGlyphs: r.uint16,
	  indexFormat: r.uint16,
	  nContourStreamSize: r.uint32,
	  nPointsStreamSize: r.uint32,
	  flagStreamSize: r.uint32,
	  glyphStreamSize: r.uint32,
	  compositeStreamSize: r.uint32,
	  bboxStreamSize: r.uint32,
	  instructionStreamSize: r.uint32,
	  nContours: new Substream('nContourStreamSize'),
	  nPoints: new Substream('nPointsStreamSize'),
	  flags: new Substream('flagStreamSize'),
	  glyphs: new Substream('glyphStreamSize'),
	  composites: new Substream('compositeStreamSize'),
	  bboxes: new Substream('bboxStreamSize'),
	  instructions: new Substream('instructionStreamSize')
	});
	
	var WORD_CODE = 253;
	var ONE_MORE_BYTE_CODE2 = 254;
	var ONE_MORE_BYTE_CODE1 = 255;
	var LOWEST_U_CODE = 253;
	
	function read255UInt16(stream) {
	  var code = stream.readUInt8();
	
	  if (code === WORD_CODE) {
	    return stream.readUInt16BE();
	  }
	
	  if (code === ONE_MORE_BYTE_CODE1) {
	    return stream.readUInt8() + LOWEST_U_CODE;
	  }
	
	  if (code === ONE_MORE_BYTE_CODE2) {
	    return stream.readUInt8() + LOWEST_U_CODE * 2;
	  }
	
	  return code;
	}
	
	function withSign(flag, baseval) {
	  return flag & 1 ? baseval : -baseval;
	}
	
	function decodeTriplet(flags, glyphs, nPoints) {
	  var y = void 0;
	  var x = y = 0;
	  var res = [];
	
	  for (var i = 0; i < nPoints; i++) {
	    var dx = 0,
	        dy = 0;
	    var flag = flags.readUInt8();
	    var onCurve = !(flag >> 7);
	    flag &= 0x7f;
	
	    if (flag < 10) {
	      dx = 0;
	      dy = withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
	    } else if (flag < 20) {
	      dx = withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
	      dy = 0;
	    } else if (flag < 84) {
	      var b0 = flag - 20;
	      var b1 = glyphs.readUInt8();
	      dx = withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
	      dy = withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
	    } else if (flag < 120) {
	      var b0 = flag - 84;
	      dx = withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
	      dy = withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
	    } else if (flag < 124) {
	      var b1 = glyphs.readUInt8();
	      var b2 = glyphs.readUInt8();
	      dx = withSign(flag, (b1 << 4) + (b2 >> 4));
	      dy = withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
	    } else {
	      dx = withSign(flag, glyphs.readUInt16BE());
	      dy = withSign(flag >> 1, glyphs.readUInt16BE());
	    }
	
	    x += dx;
	    y += dy;
	    res.push(new Point(onCurve, false, x, y));
	  }
	
	  return res;
	}
	
	var TTCHeader = new r.VersionedStruct(r.uint32, {
	  0x00010000: {
	    numFonts: r.uint32,
	    offsets: new r.Array(r.uint32, 'numFonts')
	  },
	  0x00020000: {
	    numFonts: r.uint32,
	    offsets: new r.Array(r.uint32, 'numFonts'),
	    dsigTag: r.uint32,
	    dsigLength: r.uint32,
	    dsigOffset: r.uint32
	  }
	});
	
	var TrueTypeCollection = function () {
	  TrueTypeCollection.probe = function probe(buffer) {
	    return buffer.toString('ascii', 0, 4) === 'ttcf';
	  };
	
	  function TrueTypeCollection(stream) {
	    _classCallCheck(this, TrueTypeCollection);
	
	    this.stream = stream;
	    if (stream.readString(4) !== 'ttcf') {
	      throw new Error('Not a TrueType collection');
	    }
	
	    this.header = TTCHeader.decode(stream);
	  }
	
	  TrueTypeCollection.prototype.getFont = function getFont(name) {
	    for (var _iterator = this.header.offsets, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var offset = _ref;
	
	      var stream = new r.DecodeStream(this.stream.buffer);
	      stream.pos = offset;
	      var font = new TTFFont(stream);
	      if (font.postscriptName === name) {
	        return font;
	      }
	    }
	
	    return null;
	  };
	
	  _createClass(TrueTypeCollection, [{
	    key: 'fonts',
	    get: function get() {
	      var fonts = [];
	      for (var _iterator2 = this.header.offsets, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var offset = _ref2;
	
	        var stream = new r.DecodeStream(this.stream.buffer);
	        stream.pos = offset;
	        fonts.push(new TTFFont(stream));
	      }
	
	      return fonts;
	    }
	  }]);
	
	  return TrueTypeCollection;
	}();
	
	var DFontName = new r.String(r.uint8);
	var DFontData = new r.Struct({
	  len: r.uint32,
	  buf: new r.Buffer('len')
	});
	
	var Ref = new r.Struct({
	  id: r.uint16,
	  nameOffset: r.int16,
	  attr: r.uint8,
	  dataOffset: r.uint24,
	  handle: r.uint32
	});
	
	var Type = new r.Struct({
	  name: new r.String(4),
	  maxTypeIndex: r.uint16,
	  refList: new r.Pointer(r.uint16, new r.Array(Ref, function (t) {
	    return t.maxTypeIndex + 1;
	  }), { type: 'parent' })
	});
	
	var TypeList = new r.Struct({
	  length: r.uint16,
	  types: new r.Array(Type, function (t) {
	    return t.length + 1;
	  })
	});
	
	var DFontMap = new r.Struct({
	  reserved: new r.Reserved(r.uint8, 24),
	  typeList: new r.Pointer(r.uint16, TypeList),
	  nameListOffset: new r.Pointer(r.uint16, 'void')
	});
	
	var DFontHeader = new r.Struct({
	  dataOffset: r.uint32,
	  map: new r.Pointer(r.uint32, DFontMap),
	  dataLength: r.uint32,
	  mapLength: r.uint32
	});
	
	var DFont = function () {
	  DFont.probe = function probe(buffer) {
	    var stream = new r.DecodeStream(buffer);
	
	    try {
	      var header = DFontHeader.decode(stream);
	    } catch (e) {
	      return false;
	    }
	
	    for (var _iterator = header.map.typeList.types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var type = _ref;
	
	      if (type.name === 'sfnt') {
	        return true;
	      }
	    }
	
	    return false;
	  };
	
	  function DFont(stream) {
	    _classCallCheck(this, DFont);
	
	    this.stream = stream;
	    this.header = DFontHeader.decode(this.stream);
	
	    for (var _iterator2 = this.header.map.typeList.types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var type = _ref2;
	
	      for (var _iterator3 = type.refList, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var ref = _ref3;
	
	        if (ref.nameOffset >= 0) {
	          this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
	          ref.name = DFontName.decode(this.stream);
	        } else {
	          ref.name = null;
	        }
	      }
	
	      if (type.name === 'sfnt') {
	        this.sfnt = type;
	      }
	    }
	  }
	
	  DFont.prototype.getFont = function getFont(name) {
	    if (!this.sfnt) {
	      return null;
	    }
	
	    for (var _iterator4 = this.sfnt.refList, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	      var _ref4;
	
	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }
	
	      var ref = _ref4;
	
	      var pos = this.header.dataOffset + ref.dataOffset + 4;
	      var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
	      var font = new TTFFont(stream);
	      if (font.postscriptName === name) {
	        return font;
	      }
	    }
	
	    return null;
	  };
	
	  _createClass(DFont, [{
	    key: 'fonts',
	    get: function get() {
	      var fonts = [];
	      for (var _iterator5 = this.sfnt.refList, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	        var _ref5;
	
	        if (_isArray5) {
	          if (_i5 >= _iterator5.length) break;
	          _ref5 = _iterator5[_i5++];
	        } else {
	          _i5 = _iterator5.next();
	          if (_i5.done) break;
	          _ref5 = _i5.value;
	        }
	
	        var ref = _ref5;
	
	        var pos = this.header.dataOffset + ref.dataOffset + 4;
	        var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
	        fonts.push(new TTFFont(stream));
	      }
	
	      return fonts;
	    }
	  }]);
	
	  return DFont;
	}();
	
	// Register font formats
	fontkit.registerFormat(TTFFont);
	fontkit.registerFormat(WOFFFont);
	fontkit.registerFormat(WOFF2Font);
	fontkit.registerFormat(TrueTypeCollection);
	fontkit.registerFormat(DFont);
	
	module.exports = fontkit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, __webpack_require__(11)))
	
	/***/ }),
	/* 168 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var key, val, _ref, _ref1;
	
	  exports.EncodeStream = __webpack_require__(169);
	
	  exports.DecodeStream = __webpack_require__(51);
	
	  exports.Array = __webpack_require__(93);
	
	  exports.LazyArray = __webpack_require__(187);
	
	  exports.Bitfield = __webpack_require__(188);
	
	  exports.Boolean = __webpack_require__(189);
	
	  exports.Buffer = __webpack_require__(190);
	
	  exports.Enum = __webpack_require__(191);
	
	  exports.Optional = __webpack_require__(192);
	
	  exports.Reserved = __webpack_require__(193);
	
	  exports.String = __webpack_require__(194);
	
	  exports.Struct = __webpack_require__(94);
	
	  exports.VersionedStruct = __webpack_require__(195);
	
	  _ref = __webpack_require__(22);
	  for (key in _ref) {
	    val = _ref[key];
	    exports[key] = val;
	  }
	
	  _ref1 = __webpack_require__(196);
	  for (key in _ref1) {
	    val = _ref1[key];
	    exports[key] = val;
	  }
	
	}).call(this);
	
	
	/***/ }),
	/* 169 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var DecodeStream, EncodeStream, iconv, stream,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  stream = __webpack_require__(15);
	
	  DecodeStream = __webpack_require__(51);
	
	  try {
	    iconv = __webpack_require__(52);
	  } catch (_error) {}
	
	  EncodeStream = (function(_super) {
	    var key;
	
	    __extends(EncodeStream, _super);
	
	    function EncodeStream(bufferSize) {
	      if (bufferSize == null) {
	        bufferSize = 65536;
	      }
	      EncodeStream.__super__.constructor.apply(this, arguments);
	      this.buffer = new Buffer(bufferSize);
	      this.bufferOffset = 0;
	      this.pos = 0;
	    }
	
	    for (key in Buffer.prototype) {
	      if (key.slice(0, 5) === 'write') {
	        (function(key) {
	          var bytes;
	          bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, '')];
	          return EncodeStream.prototype[key] = function(value) {
	            this.ensure(bytes);
	            this.buffer[key](value, this.bufferOffset);
	            this.bufferOffset += bytes;
	            return this.pos += bytes;
	          };
	        })(key);
	      }
	    }
	
	    EncodeStream.prototype._read = function() {};
	
	    EncodeStream.prototype.ensure = function(bytes) {
	      if (this.bufferOffset + bytes > this.buffer.length) {
	        return this.flush();
	      }
	    };
	
	    EncodeStream.prototype.flush = function() {
	      if (this.bufferOffset > 0) {
	        this.push(new Buffer(this.buffer.slice(0, this.bufferOffset)));
	        return this.bufferOffset = 0;
	      }
	    };
	
	    EncodeStream.prototype.writeBuffer = function(buffer) {
	      this.flush();
	      this.push(buffer);
	      return this.pos += buffer.length;
	    };
	
	    EncodeStream.prototype.writeString = function(string, encoding) {
	      var buf, byte, i, _i, _ref;
	      if (encoding == null) {
	        encoding = 'ascii';
	      }
	      switch (encoding) {
	        case 'utf16le':
	        case 'ucs2':
	        case 'utf8':
	        case 'ascii':
	          return this.writeBuffer(new Buffer(string, encoding));
	        case 'utf16be':
	          buf = new Buffer(string, 'utf16le');
	          for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
	            byte = buf[i];
	            buf[i] = buf[i + 1];
	            buf[i + 1] = byte;
	          }
	          return this.writeBuffer(buf);
	        default:
	          if (iconv) {
	            return this.writeBuffer(iconv.encode(string, encoding));
	          } else {
	            throw new Error('Install iconv-lite to enable additional string encodings.');
	          }
	      }
	    };
	
	    EncodeStream.prototype.writeUInt24BE = function(val) {
	      this.ensure(3);
	      this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
	      this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
	      this.buffer[this.bufferOffset++] = val & 0xff;
	      return this.pos += 3;
	    };
	
	    EncodeStream.prototype.writeUInt24LE = function(val) {
	      this.ensure(3);
	      this.buffer[this.bufferOffset++] = val & 0xff;
	      this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
	      this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
	      return this.pos += 3;
	    };
	
	    EncodeStream.prototype.writeInt24BE = function(val) {
	      if (val >= 0) {
	        return this.writeUInt24BE(val);
	      } else {
	        return this.writeUInt24BE(val + 0xffffff + 1);
	      }
	    };
	
	    EncodeStream.prototype.writeInt24LE = function(val) {
	      if (val >= 0) {
	        return this.writeUInt24LE(val);
	      } else {
	        return this.writeUInt24LE(val + 0xffffff + 1);
	      }
	    };
	
	    EncodeStream.prototype.fill = function(val, length) {
	      var buf;
	      if (length < this.buffer.length) {
	        this.ensure(length);
	        this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
	        this.bufferOffset += length;
	        return this.pos += length;
	      } else {
	        buf = new Buffer(length);
	        buf.fill(val);
	        return this.writeBuffer(buf);
	      }
	    };
	
	    EncodeStream.prototype.end = function() {
	      this.flush();
	      return this.push(null);
	    };
	
	    return EncodeStream;
	
	  })(stream.Readable);
	
	  module.exports = EncodeStream;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 170 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var BOMChar = '\uFEFF';
	
	exports.PrependBOM = PrependBOMWrapper
	function PrependBOMWrapper(encoder, options) {
	    this.encoder = encoder;
	    this.addBOM = true;
	}
	
	PrependBOMWrapper.prototype.write = function(str) {
	    if (this.addBOM) {
	        str = BOMChar + str;
	        this.addBOM = false;
	    }
	
	    return this.encoder.write(str);
	}
	
	PrependBOMWrapper.prototype.end = function() {
	    return this.encoder.end();
	}
	
	
	//------------------------------------------------------------------------------
	
	exports.StripBOM = StripBOMWrapper;
	function StripBOMWrapper(decoder, options) {
	    this.decoder = decoder;
	    this.pass = false;
	    this.options = options || {};
	}
	
	StripBOMWrapper.prototype.write = function(buf) {
	    var res = this.decoder.write(buf);
	    if (this.pass || !res)
	        return res;
	
	    if (res[0] === BOMChar) {
	        res = res.slice(1);
	        if (typeof this.options.stripBOM === 'function')
	            this.options.stripBOM();
	    }
	
	    this.pass = true;
	    return res;
	}
	
	StripBOMWrapper.prototype.end = function() {
	    return this.decoder.end();
	}
	
	
	
	/***/ }),
	/* 171 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// Update this array if you add/rename/remove files in this directory.
	// We support Browserify by skipping automatic module discovery and requiring modules directly.
	var modules = [
	    __webpack_require__(172),
	    __webpack_require__(173),
	    __webpack_require__(174),
	    __webpack_require__(175),
	    __webpack_require__(176),
	    __webpack_require__(177),
	    __webpack_require__(178),
	    __webpack_require__(179),
	];
	
	// Put all encoding/alias/codec definitions to single object and export it. 
	for (var i = 0; i < modules.length; i++) {
	    var module = modules[i];
	    for (var enc in module)
	        if (Object.prototype.hasOwnProperty.call(module, enc))
	            exports[enc] = module[enc];
	}
	
	
	/***/ }),
	/* 172 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var Buffer = __webpack_require__(1).Buffer;
	
	// Export Node.js internal encodings.
	
	module.exports = {
	    // Encodings
	    utf8:   { type: "_internal", bomAware: true},
	    cesu8:  { type: "_internal", bomAware: true},
	    unicode11utf8: "utf8",
	
	    ucs2:   { type: "_internal", bomAware: true},
	    utf16le: "ucs2",
	
	    binary: { type: "_internal" },
	    base64: { type: "_internal" },
	    hex:    { type: "_internal" },
	
	    // Codec.
	    _internal: InternalCodec,
	};
	
	//------------------------------------------------------------------------------
	
	function InternalCodec(codecOptions, iconv) {
	    this.enc = codecOptions.encodingName;
	    this.bomAware = codecOptions.bomAware;
	
	    if (this.enc === "base64")
	        this.encoder = InternalEncoderBase64;
	    else if (this.enc === "cesu8") {
	        this.enc = "utf8"; // Use utf8 for decoding.
	        this.encoder = InternalEncoderCesu8;
	
	        // Add decoder for versions of Node not supporting CESU-8
	        if (new Buffer('eda0bdedb2a9', 'hex').toString() !== '💩') {
	            this.decoder = InternalDecoderCesu8;
	            this.defaultCharUnicode = iconv.defaultCharUnicode;
	        }
	    }
	}
	
	InternalCodec.prototype.encoder = InternalEncoder;
	InternalCodec.prototype.decoder = InternalDecoder;
	
	//------------------------------------------------------------------------------
	
	// We use node.js internal decoder. Its signature is the same as ours.
	var StringDecoder = __webpack_require__(47).StringDecoder;
	
	if (!StringDecoder.prototype.end) // Node v0.8 doesn't have this method.
	    StringDecoder.prototype.end = function() {};
	
	
	function InternalDecoder(options, codec) {
	    StringDecoder.call(this, codec.enc);
	}
	
	InternalDecoder.prototype = StringDecoder.prototype;
	
	
	//------------------------------------------------------------------------------
	// Encoder is mostly trivial
	
	function InternalEncoder(options, codec) {
	    this.enc = codec.enc;
	}
	
	InternalEncoder.prototype.write = function(str) {
	    return new Buffer(str, this.enc);
	}
	
	InternalEncoder.prototype.end = function() {
	}
	
	
	//------------------------------------------------------------------------------
	// Except base64 encoder, which must keep its state.
	
	function InternalEncoderBase64(options, codec) {
	    this.prevStr = '';
	}
	
	InternalEncoderBase64.prototype.write = function(str) {
	    str = this.prevStr + str;
	    var completeQuads = str.length - (str.length % 4);
	    this.prevStr = str.slice(completeQuads);
	    str = str.slice(0, completeQuads);
	
	    return new Buffer(str, "base64");
	}
	
	InternalEncoderBase64.prototype.end = function() {
	    return new Buffer(this.prevStr, "base64");
	}
	
	
	//------------------------------------------------------------------------------
	// CESU-8 encoder is also special.
	
	function InternalEncoderCesu8(options, codec) {
	}
	
	InternalEncoderCesu8.prototype.write = function(str) {
	    var buf = new Buffer(str.length * 3), bufIdx = 0;
	    for (var i = 0; i < str.length; i++) {
	        var charCode = str.charCodeAt(i);
	        // Naive implementation, but it works because CESU-8 is especially easy
	        // to convert from UTF-16 (which all JS strings are encoded in).
	        if (charCode < 0x80)
	            buf[bufIdx++] = charCode;
	        else if (charCode < 0x800) {
	            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	        else { // charCode will always be < 0x10000 in javascript.
	            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
	            buf[bufIdx++] = 0x80 + ((charCode >>> 6) & 0x3f);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	    }
	    return buf.slice(0, bufIdx);
	}
	
	InternalEncoderCesu8.prototype.end = function() {
	}
	
	//------------------------------------------------------------------------------
	// CESU-8 decoder is not implemented in Node v4.0+
	
	function InternalDecoderCesu8(options, codec) {
	    this.acc = 0;
	    this.contBytes = 0;
	    this.accBytes = 0;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	}
	
	InternalDecoderCesu8.prototype.write = function(buf) {
	    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, 
	        res = '';
	    for (var i = 0; i < buf.length; i++) {
	        var curByte = buf[i];
	        if ((curByte & 0xC0) !== 0x80) { // Leading byte
	            if (contBytes > 0) { // Previous code is invalid
	                res += this.defaultCharUnicode;
	                contBytes = 0;
	            }
	
	            if (curByte < 0x80) { // Single-byte code
	                res += String.fromCharCode(curByte);
	            } else if (curByte < 0xE0) { // Two-byte code
	                acc = curByte & 0x1F;
	                contBytes = 1; accBytes = 1;
	            } else if (curByte < 0xF0) { // Three-byte code
	                acc = curByte & 0x0F;
	                contBytes = 2; accBytes = 1;
	            } else { // Four or more are not supported for CESU-8.
	                res += this.defaultCharUnicode;
	            }
	        } else { // Continuation byte
	            if (contBytes > 0) { // We're waiting for it.
	                acc = (acc << 6) | (curByte & 0x3f);
	                contBytes--; accBytes++;
	                if (contBytes === 0) {
	                    // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
	                    if (accBytes === 2 && acc < 0x80 && acc > 0)
	                        res += this.defaultCharUnicode;
	                    else if (accBytes === 3 && acc < 0x800)
	                        res += this.defaultCharUnicode;
	                    else
	                        // Actually add character.
	                        res += String.fromCharCode(acc);
	                }
	            } else { // Unexpected continuation byte
	                res += this.defaultCharUnicode;
	            }
	        }
	    }
	    this.acc = acc; this.contBytes = contBytes; this.accBytes = accBytes;
	    return res;
	}
	
	InternalDecoderCesu8.prototype.end = function() {
	    var res = 0;
	    if (this.contBytes > 0)
	        res += this.defaultCharUnicode;
	    return res;
	}
	
	
	/***/ }),
	/* 173 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var Buffer = __webpack_require__(1).Buffer;
	
	// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
	
	// == UTF16-BE codec. ==========================================================
	
	exports.utf16be = Utf16BECodec;
	function Utf16BECodec() {
	}
	
	Utf16BECodec.prototype.encoder = Utf16BEEncoder;
	Utf16BECodec.prototype.decoder = Utf16BEDecoder;
	Utf16BECodec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	function Utf16BEEncoder() {
	}
	
	Utf16BEEncoder.prototype.write = function(str) {
	    var buf = new Buffer(str, 'ucs2');
	    for (var i = 0; i < buf.length; i += 2) {
	        var tmp = buf[i]; buf[i] = buf[i+1]; buf[i+1] = tmp;
	    }
	    return buf;
	}
	
	Utf16BEEncoder.prototype.end = function() {
	}
	
	
	// -- Decoding
	
	function Utf16BEDecoder() {
	    this.overflowByte = -1;
	}
	
	Utf16BEDecoder.prototype.write = function(buf) {
	    if (buf.length == 0)
	        return '';
	
	    var buf2 = new Buffer(buf.length + 1),
	        i = 0, j = 0;
	
	    if (this.overflowByte !== -1) {
	        buf2[0] = buf[0];
	        buf2[1] = this.overflowByte;
	        i = 1; j = 2;
	    }
	
	    for (; i < buf.length-1; i += 2, j+= 2) {
	        buf2[j] = buf[i+1];
	        buf2[j+1] = buf[i];
	    }
	
	    this.overflowByte = (i == buf.length-1) ? buf[buf.length-1] : -1;
	
	    return buf2.slice(0, j).toString('ucs2');
	}
	
	Utf16BEDecoder.prototype.end = function() {
	}
	
	
	// == UTF-16 codec =============================================================
	// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
	// Defaults to UTF-16LE, as it's prevalent and default in Node.
	// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
	// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
	
	// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
	
	exports.utf16 = Utf16Codec;
	function Utf16Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	}
	
	Utf16Codec.prototype.encoder = Utf16Encoder;
	Utf16Codec.prototype.decoder = Utf16Decoder;
	
	
	// -- Encoding (pass-through)
	
	function Utf16Encoder(options, codec) {
	    options = options || {};
	    if (options.addBOM === undefined)
	        options.addBOM = true;
	    this.encoder = codec.iconv.getEncoder('utf-16le', options);
	}
	
	Utf16Encoder.prototype.write = function(str) {
	    return this.encoder.write(str);
	}
	
	Utf16Encoder.prototype.end = function() {
	    return this.encoder.end();
	}
	
	
	// -- Decoding
	
	function Utf16Decoder(options, codec) {
	    this.decoder = null;
	    this.initialBytes = [];
	    this.initialBytesLen = 0;
	
	    this.options = options || {};
	    this.iconv = codec.iconv;
	}
	
	Utf16Decoder.prototype.write = function(buf) {
	    if (!this.decoder) {
	        // Codec is not chosen yet. Accumulate initial bytes.
	        this.initialBytes.push(buf);
	        this.initialBytesLen += buf.length;
	        
	        if (this.initialBytesLen < 16) // We need more bytes to use space heuristic (see below)
	            return '';
	
	        // We have enough bytes -> detect endianness.
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);
	        this.initialBytes.length = this.initialBytesLen = 0;
	    }
	
	    return this.decoder.write(buf);
	}
	
	Utf16Decoder.prototype.end = function() {
	    if (!this.decoder) {
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);
	
	        var res = this.decoder.write(buf),
	            trail = this.decoder.end();
	
	        return trail ? (res + trail) : res;
	    }
	    return this.decoder.end();
	}
	
	function detectEncoding(buf, defaultEncoding) {
	    var enc = defaultEncoding || 'utf-16le';
	
	    if (buf.length >= 2) {
	        // Check BOM.
	        if (buf[0] == 0xFE && buf[1] == 0xFF) // UTF-16BE BOM
	            enc = 'utf-16be';
	        else if (buf[0] == 0xFF && buf[1] == 0xFE) // UTF-16LE BOM
	            enc = 'utf-16le';
	        else {
	            // No BOM found. Try to deduce encoding from initial content.
	            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
	            // So, we count ASCII as if it was LE or BE, and decide from that.
	            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
	                _len = Math.min(buf.length - (buf.length % 2), 64); // Len is always even.
	
	            for (var i = 0; i < _len; i += 2) {
	                if (buf[i] === 0 && buf[i+1] !== 0) asciiCharsBE++;
	                if (buf[i] !== 0 && buf[i+1] === 0) asciiCharsLE++;
	            }
	
	            if (asciiCharsBE > asciiCharsLE)
	                enc = 'utf-16be';
	            else if (asciiCharsBE < asciiCharsLE)
	                enc = 'utf-16le';
	        }
	    }
	
	    return enc;
	}
	
	
	
	
	/***/ }),
	/* 174 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var Buffer = __webpack_require__(1).Buffer;
	
	// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
	// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
	
	exports.utf7 = Utf7Codec;
	exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
	function Utf7Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	};
	
	Utf7Codec.prototype.encoder = Utf7Encoder;
	Utf7Codec.prototype.decoder = Utf7Decoder;
	Utf7Codec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
	
	function Utf7Encoder(options, codec) {
	    this.iconv = codec.iconv;
	}
	
	Utf7Encoder.prototype.write = function(str) {
	    // Naive implementation.
	    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
	    return new Buffer(str.replace(nonDirectChars, function(chunk) {
	        return "+" + (chunk === '+' ? '' : 
	            this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) 
	            + "-";
	    }.bind(this)));
	}
	
	Utf7Encoder.prototype.end = function() {
	}
	
	
	// -- Decoding
	
	function Utf7Decoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}
	
	var base64Regex = /[A-Za-z0-9\/+]/;
	var base64Chars = [];
	for (var i = 0; i < 256; i++)
	    base64Chars[i] = base64Regex.test(String.fromCharCode(i));
	
	var plusChar = '+'.charCodeAt(0), 
	    minusChar = '-'.charCodeAt(0),
	    andChar = '&'.charCodeAt(0);
	
	Utf7Decoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;
	
	    // The decoder is more involved as we must handle chunks in stream.
	
	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '+'
	            if (buf[i] == plusChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64Chars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) {// "+-" -> "+"
	                    res += "+";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString();
	                    res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	                }
	
	                if (buf[i] != minusChar) // Minus is absorbed after base64.
	                    i--;
	
	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }
	
	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString();
	
	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);
	
	        res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	    }
	
	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;
	
	    return res;
	}
	
	Utf7Decoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(new Buffer(this.base64Accum, 'base64'), "utf16-be");
	
	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}
	
	
	// UTF-7-IMAP codec.
	// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
	// Differences:
	//  * Base64 part is started by "&" instead of "+"
	//  * Direct characters are 0x20-0x7E, except "&" (0x26)
	//  * In Base64, "," is used instead of "/"
	//  * Base64 must not be used to represent direct characters.
	//  * No implicit shift back from Base64 (should always end with '-')
	//  * String must end in non-shifted position.
	//  * "-&" while in base64 is not allowed.
	
	
	exports.utf7imap = Utf7IMAPCodec;
	function Utf7IMAPCodec(codecOptions, iconv) {
	    this.iconv = iconv;
	};
	
	Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
	Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
	Utf7IMAPCodec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	function Utf7IMAPEncoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = new Buffer(6);
	    this.base64AccumIdx = 0;
	}
	
	Utf7IMAPEncoder.prototype.write = function(str) {
	    var inBase64 = this.inBase64,
	        base64Accum = this.base64Accum,
	        base64AccumIdx = this.base64AccumIdx,
	        buf = new Buffer(str.length*5 + 10), bufIdx = 0;
	
	    for (var i = 0; i < str.length; i++) {
	        var uChar = str.charCodeAt(i);
	        if (0x20 <= uChar && uChar <= 0x7E) { // Direct character or '&'.
	            if (inBase64) {
	                if (base64AccumIdx > 0) {
	                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	                    base64AccumIdx = 0;
	                }
	
	                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	                inBase64 = false;
	            }
	
	            if (!inBase64) {
	                buf[bufIdx++] = uChar; // Write direct character
	
	                if (uChar === andChar)  // Ampersand -> '&-'
	                    buf[bufIdx++] = minusChar;
	            }
	
	        } else { // Non-direct character
	            if (!inBase64) {
	                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
	                inBase64 = true;
	            }
	            if (inBase64) {
	                base64Accum[base64AccumIdx++] = uChar >> 8;
	                base64Accum[base64AccumIdx++] = uChar & 0xFF;
	
	                if (base64AccumIdx == base64Accum.length) {
	                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
	                    base64AccumIdx = 0;
	                }
	            }
	        }
	    }
	
	    this.inBase64 = inBase64;
	    this.base64AccumIdx = base64AccumIdx;
	
	    return buf.slice(0, bufIdx);
	}
	
	Utf7IMAPEncoder.prototype.end = function() {
	    var buf = new Buffer(10), bufIdx = 0;
	    if (this.inBase64) {
	        if (this.base64AccumIdx > 0) {
	            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	            this.base64AccumIdx = 0;
	        }
	
	        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	        this.inBase64 = false;
	    }
	
	    return buf.slice(0, bufIdx);
	}
	
	
	// -- Decoding
	
	function Utf7IMAPDecoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}
	
	var base64IMAPChars = base64Chars.slice();
	base64IMAPChars[','.charCodeAt(0)] = true;
	
	Utf7IMAPDecoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;
	
	    // The decoder is more involved as we must handle chunks in stream.
	    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
	
	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '&'
	            if (buf[i] == andChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64IMAPChars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) { // "&-" -> "&"
	                    res += "&";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
	                    res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	                }
	
	                if (buf[i] != minusChar) // Minus may be absorbed after base64.
	                    i--;
	
	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }
	
	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');
	
	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);
	
	        res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	    }
	
	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;
	
	    return res;
	}
	
	Utf7IMAPDecoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(new Buffer(this.base64Accum, 'base64'), "utf16-be");
	
	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}
	
	
	
	
	/***/ }),
	/* 175 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var Buffer = __webpack_require__(1).Buffer;
	
	// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
	// correspond to encoded bytes (if 128 - then lower half is ASCII). 
	
	exports._sbcs = SBCSCodec;
	function SBCSCodec(codecOptions, iconv) {
	    if (!codecOptions)
	        throw new Error("SBCS codec is called without the data.")
	    
	    // Prepare char buffer for decoding.
	    if (!codecOptions.chars || (codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256))
	        throw new Error("Encoding '"+codecOptions.type+"' has incorrect 'chars' (must be of len 128 or 256)");
	    
	    if (codecOptions.chars.length === 128) {
	        var asciiString = "";
	        for (var i = 0; i < 128; i++)
	            asciiString += String.fromCharCode(i);
	        codecOptions.chars = asciiString + codecOptions.chars;
	    }
	
	    this.decodeBuf = new Buffer(codecOptions.chars, 'ucs2');
	    
	    // Encoding buffer.
	    var encodeBuf = new Buffer(65536);
	    encodeBuf.fill(iconv.defaultCharSingleByte.charCodeAt(0));
	
	    for (var i = 0; i < codecOptions.chars.length; i++)
	        encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
	
	    this.encodeBuf = encodeBuf;
	}
	
	SBCSCodec.prototype.encoder = SBCSEncoder;
	SBCSCodec.prototype.decoder = SBCSDecoder;
	
	
	function SBCSEncoder(options, codec) {
	    this.encodeBuf = codec.encodeBuf;
	}
	
	SBCSEncoder.prototype.write = function(str) {
	    var buf = new Buffer(str.length);
	    for (var i = 0; i < str.length; i++)
	        buf[i] = this.encodeBuf[str.charCodeAt(i)];
	    
	    return buf;
	}
	
	SBCSEncoder.prototype.end = function() {
	}
	
	
	function SBCSDecoder(options, codec) {
	    this.decodeBuf = codec.decodeBuf;
	}
	
	SBCSDecoder.prototype.write = function(buf) {
	    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
	    var decodeBuf = this.decodeBuf;
	    var newBuf = new Buffer(buf.length*2);
	    var idx1 = 0, idx2 = 0;
	    for (var i = 0; i < buf.length; i++) {
	        idx1 = buf[i]*2; idx2 = i*2;
	        newBuf[idx2] = decodeBuf[idx1];
	        newBuf[idx2+1] = decodeBuf[idx1+1];
	    }
	    return newBuf.toString('ucs2');
	}
	
	SBCSDecoder.prototype.end = function() {
	}
	
	
	/***/ }),
	/* 176 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// Manually added data to be used by sbcs codec in addition to generated one.
	
	module.exports = {
	    // Not supported by iconv, not sure why.
	    "10029": "maccenteuro",
	    "maccenteuro": {
	        "type": "_sbcs",
	        "chars": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
	    },
	
	    "808": "cp808",
	    "ibm808": "cp808",
	    "cp808": {
	        "type": "_sbcs",
	        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ "
	    },
	
	    // Aliases of generated encodings.
	    "ascii8bit": "ascii",
	    "usascii": "ascii",
	    "ansix34": "ascii",
	    "ansix341968": "ascii",
	    "ansix341986": "ascii",
	    "csascii": "ascii",
	    "cp367": "ascii",
	    "ibm367": "ascii",
	    "isoir6": "ascii",
	    "iso646us": "ascii",
	    "iso646irv": "ascii",
	    "us": "ascii",
	
	    "latin1": "iso88591",
	    "latin2": "iso88592",
	    "latin3": "iso88593",
	    "latin4": "iso88594",
	    "latin5": "iso88599",
	    "latin6": "iso885910",
	    "latin7": "iso885913",
	    "latin8": "iso885914",
	    "latin9": "iso885915",
	    "latin10": "iso885916",
	
	    "csisolatin1": "iso88591",
	    "csisolatin2": "iso88592",
	    "csisolatin3": "iso88593",
	    "csisolatin4": "iso88594",
	    "csisolatincyrillic": "iso88595",
	    "csisolatinarabic": "iso88596",
	    "csisolatingreek" : "iso88597",
	    "csisolatinhebrew": "iso88598",
	    "csisolatin5": "iso88599",
	    "csisolatin6": "iso885910",
	
	    "l1": "iso88591",
	    "l2": "iso88592",
	    "l3": "iso88593",
	    "l4": "iso88594",
	    "l5": "iso88599",
	    "l6": "iso885910",
	    "l7": "iso885913",
	    "l8": "iso885914",
	    "l9": "iso885915",
	    "l10": "iso885916",
	
	    "isoir14": "iso646jp",
	    "isoir57": "iso646cn",
	    "isoir100": "iso88591",
	    "isoir101": "iso88592",
	    "isoir109": "iso88593",
	    "isoir110": "iso88594",
	    "isoir144": "iso88595",
	    "isoir127": "iso88596",
	    "isoir126": "iso88597",
	    "isoir138": "iso88598",
	    "isoir148": "iso88599",
	    "isoir157": "iso885910",
	    "isoir166": "tis620",
	    "isoir179": "iso885913",
	    "isoir199": "iso885914",
	    "isoir203": "iso885915",
	    "isoir226": "iso885916",
	
	    "cp819": "iso88591",
	    "ibm819": "iso88591",
	
	    "cyrillic": "iso88595",
	
	    "arabic": "iso88596",
	    "arabic8": "iso88596",
	    "ecma114": "iso88596",
	    "asmo708": "iso88596",
	
	    "greek" : "iso88597",
	    "greek8" : "iso88597",
	    "ecma118" : "iso88597",
	    "elot928" : "iso88597",
	
	    "hebrew": "iso88598",
	    "hebrew8": "iso88598",
	
	    "turkish": "iso88599",
	    "turkish8": "iso88599",
	
	    "thai": "iso885911",
	    "thai8": "iso885911",
	
	    "celtic": "iso885914",
	    "celtic8": "iso885914",
	    "isoceltic": "iso885914",
	
	    "tis6200": "tis620",
	    "tis62025291": "tis620",
	    "tis62025330": "tis620",
	
	    "10000": "macroman",
	    "10006": "macgreek",
	    "10007": "maccyrillic",
	    "10079": "maciceland",
	    "10081": "macturkish",
	
	    "cspc8codepage437": "cp437",
	    "cspc775baltic": "cp775",
	    "cspc850multilingual": "cp850",
	    "cspcp852": "cp852",
	    "cspc862latinhebrew": "cp862",
	    "cpgr": "cp869",
	
	    "msee": "cp1250",
	    "mscyrl": "cp1251",
	    "msansi": "cp1252",
	    "msgreek": "cp1253",
	    "msturk": "cp1254",
	    "mshebr": "cp1255",
	    "msarab": "cp1256",
	    "winbaltrim": "cp1257",
	
	    "cp20866": "koi8r",
	    "20866": "koi8r",
	    "ibm878": "koi8r",
	    "cskoi8r": "koi8r",
	
	    "cp21866": "koi8u",
	    "21866": "koi8u",
	    "ibm1168": "koi8u",
	
	    "strk10482002": "rk1048",
	
	    "tcvn5712": "tcvn",
	    "tcvn57121": "tcvn",
	
	    "gb198880": "iso646cn",
	    "cn": "iso646cn",
	
	    "csiso14jisc6220ro": "iso646jp",
	    "jisc62201969ro": "iso646jp",
	    "jp": "iso646jp",
	
	    "cshproman8": "hproman8",
	    "r8": "hproman8",
	    "roman8": "hproman8",
	    "xroman8": "hproman8",
	    "ibm1051": "hproman8",
	
	    "mac": "macintosh",
	    "csmacintosh": "macintosh",
	};
	
	
	
	/***/ }),
	/* 177 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
	module.exports = {
	  "437": "cp437",
	  "737": "cp737",
	  "775": "cp775",
	  "850": "cp850",
	  "852": "cp852",
	  "855": "cp855",
	  "856": "cp856",
	  "857": "cp857",
	  "858": "cp858",
	  "860": "cp860",
	  "861": "cp861",
	  "862": "cp862",
	  "863": "cp863",
	  "864": "cp864",
	  "865": "cp865",
	  "866": "cp866",
	  "869": "cp869",
	  "874": "windows874",
	  "922": "cp922",
	  "1046": "cp1046",
	  "1124": "cp1124",
	  "1125": "cp1125",
	  "1129": "cp1129",
	  "1133": "cp1133",
	  "1161": "cp1161",
	  "1162": "cp1162",
	  "1163": "cp1163",
	  "1250": "windows1250",
	  "1251": "windows1251",
	  "1252": "windows1252",
	  "1253": "windows1253",
	  "1254": "windows1254",
	  "1255": "windows1255",
	  "1256": "windows1256",
	  "1257": "windows1257",
	  "1258": "windows1258",
	  "28591": "iso88591",
	  "28592": "iso88592",
	  "28593": "iso88593",
	  "28594": "iso88594",
	  "28595": "iso88595",
	  "28596": "iso88596",
	  "28597": "iso88597",
	  "28598": "iso88598",
	  "28599": "iso88599",
	  "28600": "iso885910",
	  "28601": "iso885911",
	  "28603": "iso885913",
	  "28604": "iso885914",
	  "28605": "iso885915",
	  "28606": "iso885916",
	  "windows874": {
	    "type": "_sbcs",
	    "chars": "€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "win874": "windows874",
	  "cp874": "windows874",
	  "windows1250": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "win1250": "windows1250",
	  "cp1250": "windows1250",
	  "windows1251": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "win1251": "windows1251",
	  "cp1251": "windows1251",
	  "windows1252": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "win1252": "windows1252",
	  "cp1252": "windows1252",
	  "windows1253": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "win1253": "windows1253",
	  "cp1253": "windows1253",
	  "windows1254": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "win1254": "windows1254",
	  "cp1254": "windows1254",
	  "windows1255": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "win1255": "windows1255",
	  "cp1255": "windows1255",
	  "windows1256": {
	    "type": "_sbcs",
	    "chars": "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے"
	  },
	  "win1256": "windows1256",
	  "cp1256": "windows1256",
	  "windows1257": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙"
	  },
	  "win1257": "windows1257",
	  "cp1257": "windows1257",
	  "windows1258": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "win1258": "windows1258",
	  "cp1258": "windows1258",
	  "iso88591": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28591": "iso88591",
	  "iso88592": {
	    "type": "_sbcs",
	    "chars": " Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "cp28592": "iso88592",
	  "iso88593": {
	    "type": "_sbcs",
	    "chars": " Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙"
	  },
	  "cp28593": "iso88593",
	  "iso88594": {
	    "type": "_sbcs",
	    "chars": " ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙"
	  },
	  "cp28594": "iso88594",
	  "iso88595": {
	    "type": "_sbcs",
	    "chars": " ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ"
	  },
	  "cp28595": "iso88595",
	  "iso88596": {
	    "type": "_sbcs",
	    "chars": " ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
	  },
	  "cp28596": "iso88596",
	  "iso88597": {
	    "type": "_sbcs",
	    "chars": " ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "cp28597": "iso88597",
	  "iso88598": {
	    "type": "_sbcs",
	    "chars": " �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "cp28598": "iso88598",
	  "iso88599": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "cp28599": "iso88599",
	  "iso885910": {
	    "type": "_sbcs",
	    "chars": " ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ"
	  },
	  "cp28600": "iso885910",
	  "iso885911": {
	    "type": "_sbcs",
	    "chars": " กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "cp28601": "iso885911",
	  "iso885913": {
	    "type": "_sbcs",
	    "chars": " ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’"
	  },
	  "cp28603": "iso885913",
	  "iso885914": {
	    "type": "_sbcs",
	    "chars": " Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ"
	  },
	  "cp28604": "iso885914",
	  "iso885915": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28605": "iso885915",
	  "iso885916": {
	    "type": "_sbcs",
	    "chars": " ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ"
	  },
	  "cp28606": "iso885916",
	  "cp437": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm437": "cp437",
	  "csibm437": "cp437",
	  "cp737": {
	    "type": "_sbcs",
	    "chars": "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ "
	  },
	  "ibm737": "cp737",
	  "csibm737": "cp737",
	  "cp775": {
	    "type": "_sbcs",
	    "chars": "ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ "
	  },
	  "ibm775": "cp775",
	  "csibm775": "cp775",
	  "cp850": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm850": "cp850",
	  "csibm850": "cp850",
	  "cp852": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ "
	  },
	  "ibm852": "cp852",
	  "csibm852": "cp852",
	  "cp855": {
	    "type": "_sbcs",
	    "chars": "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ "
	  },
	  "ibm855": "cp855",
	  "csibm855": "cp855",
	  "cp856": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm856": "cp856",
	  "csibm856": "cp856",
	  "cp857": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm857": "cp857",
	  "csibm857": "cp857",
	  "cp858": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm858": "cp858",
	  "csibm858": "cp858",
	  "cp860": {
	    "type": "_sbcs",
	    "chars": "ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm860": "cp860",
	  "csibm860": "cp860",
	  "cp861": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm861": "cp861",
	  "csibm861": "cp861",
	  "cp862": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm862": "cp862",
	  "csibm862": "cp862",
	  "cp863": {
	    "type": "_sbcs",
	    "chars": "ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm863": "cp863",
	  "csibm863": "cp863",
	  "cp864": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�"
	  },
	  "ibm864": "cp864",
	  "csibm864": "cp864",
	  "cp865": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm865": "cp865",
	  "csibm865": "cp865",
	  "cp866": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ "
	  },
	  "ibm866": "cp866",
	  "csibm866": "cp866",
	  "cp869": {
	    "type": "_sbcs",
	    "chars": "������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ "
	  },
	  "ibm869": "cp869",
	  "csibm869": "cp869",
	  "cp922": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ"
	  },
	  "ibm922": "cp922",
	  "csibm922": "cp922",
	  "cp1046": {
	    "type": "_sbcs",
	    "chars": "ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
	  },
	  "ibm1046": "cp1046",
	  "csibm1046": "cp1046",
	  "cp1124": {
	    "type": "_sbcs",
	    "chars": " ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ"
	  },
	  "ibm1124": "cp1124",
	  "csibm1124": "cp1124",
	  "cp1125": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ "
	  },
	  "ibm1125": "cp1125",
	  "csibm1125": "cp1125",
	  "cp1129": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1129": "cp1129",
	  "csibm1129": "cp1129",
	  "cp1133": {
	    "type": "_sbcs",
	    "chars": " ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�"
	  },
	  "ibm1133": "cp1133",
	  "csibm1133": "cp1133",
	  "cp1161": {
	    "type": "_sbcs",
	    "chars": "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ "
	  },
	  "ibm1161": "cp1161",
	  "csibm1161": "cp1161",
	  "cp1162": {
	    "type": "_sbcs",
	    "chars": "€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "ibm1162": "cp1162",
	  "csibm1162": "cp1162",
	  "cp1163": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1163": "cp1163",
	  "csibm1163": "cp1163",
	  "maccroatian": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
	  },
	  "maccyrillic": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "macgreek": {
	    "type": "_sbcs",
	    "chars": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
	  },
	  "maciceland": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macroman": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macromania": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macthai": {
	    "type": "_sbcs",
	    "chars": "«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู﻿​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����"
	  },
	  "macturkish": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macukraine": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "koi8r": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8u": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8ru": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8t": {
	    "type": "_sbcs",
	    "chars": "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "armscii8": {
	    "type": "_sbcs",
	    "chars": " �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
	  },
	  "rk1048": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "tcvn": {
	    "type": "_sbcs",
	    "chars": "\u0000ÚỤ\u0003ỪỬỮ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ"
	  },
	  "georgianacademy": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "georgianps": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "pt154": {
	    "type": "_sbcs",
	    "chars": "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "viscii": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001Ẳ\u0003\u0004ẴẪ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ"
	  },
	  "iso646cn": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "iso646jp": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "hproman8": {
	    "type": "_sbcs",
	    "chars": " ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�"
	  },
	  "macintosh": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "ascii": {
	    "type": "_sbcs",
	    "chars": "��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "tis620": {
	    "type": "_sbcs",
	    "chars": "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  }
	}
	
	/***/ }),
	/* 178 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var Buffer = __webpack_require__(1).Buffer;
	
	// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
	// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
	// To save memory and loading time, we read table files only when requested.
	
	exports._dbcs = DBCSCodec;
	
	var UNASSIGNED = -1,
	    GB18030_CODE = -2,
	    SEQ_START  = -10,
	    NODE_START = -1000,
	    UNASSIGNED_NODE = new Array(0x100),
	    DEF_CHAR = -1;
	
	for (var i = 0; i < 0x100; i++)
	    UNASSIGNED_NODE[i] = UNASSIGNED;
	
	
	// Class DBCSCodec reads and initializes mapping tables.
	function DBCSCodec(codecOptions, iconv) {
	    this.encodingName = codecOptions.encodingName;
	    if (!codecOptions)
	        throw new Error("DBCS codec is called without the data.")
	    if (!codecOptions.table)
	        throw new Error("Encoding '" + this.encodingName + "' has no data.");
	
	    // Load tables.
	    var mappingTable = codecOptions.table();
	
	
	    // Decode tables: MBCS -> Unicode.
	
	    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
	    // Trie root is decodeTables[0].
	    // Values: >=  0 -> unicode character code. can be > 0xFFFF
	    //         == UNASSIGNED -> unknown/unassigned sequence.
	    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
	    //         <= NODE_START -> index of the next node in our trie to process next byte.
	    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
	    this.decodeTables = [];
	    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.
	
	    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
	    this.decodeTableSeq = [];
	
	    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
	    for (var i = 0; i < mappingTable.length; i++)
	        this._addDecodeChunk(mappingTable[i]);
	
	    this.defaultCharUnicode = iconv.defaultCharUnicode;
	
	    
	    // Encode tables: Unicode -> DBCS.
	
	    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
	    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
	    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
	    //         == UNASSIGNED -> no conversion found. Output a default char.
	    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
	    this.encodeTable = [];
	    
	    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
	    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
	    // means end of sequence (needed when one sequence is a strict subsequence of another).
	    // Objects are kept separately from encodeTable to increase performance.
	    this.encodeTableSeq = [];
	
	    // Some chars can be decoded, but need not be encoded.
	    var skipEncodeChars = {};
	    if (codecOptions.encodeSkipVals)
	        for (var i = 0; i < codecOptions.encodeSkipVals.length; i++) {
	            var val = codecOptions.encodeSkipVals[i];
	            if (typeof val === 'number')
	                skipEncodeChars[val] = true;
	            else
	                for (var j = val.from; j <= val.to; j++)
	                    skipEncodeChars[j] = true;
	        }
	        
	    // Use decode trie to recursively fill out encode tables.
	    this._fillEncodeTable(0, 0, skipEncodeChars);
	
	    // Add more encoding pairs when needed.
	    if (codecOptions.encodeAdd) {
	        for (var uChar in codecOptions.encodeAdd)
	            if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar))
	                this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
	    }
	
	    this.defCharSB  = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
	
	
	    // Load & create GB18030 tables when needed.
	    if (typeof codecOptions.gb18030 === 'function') {
	        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
	
	        // Add GB18030 decode tables.
	        var thirdByteNodeIdx = this.decodeTables.length;
	        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = UNASSIGNED_NODE.slice(0);
	
	        var fourthByteNodeIdx = this.decodeTables.length;
	        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = UNASSIGNED_NODE.slice(0);
	
	        for (var i = 0x81; i <= 0xFE; i++) {
	            var secondByteNodeIdx = NODE_START - this.decodeTables[0][i];
	            var secondByteNode = this.decodeTables[secondByteNodeIdx];
	            for (var j = 0x30; j <= 0x39; j++)
	                secondByteNode[j] = NODE_START - thirdByteNodeIdx;
	        }
	        for (var i = 0x81; i <= 0xFE; i++)
	            thirdByteNode[i] = NODE_START - fourthByteNodeIdx;
	        for (var i = 0x30; i <= 0x39; i++)
	            fourthByteNode[i] = GB18030_CODE
	    }        
	}
	
	DBCSCodec.prototype.encoder = DBCSEncoder;
	DBCSCodec.prototype.decoder = DBCSDecoder;
	
	// Decoder helpers
	DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
	    var bytes = [];
	    for (; addr > 0; addr >>= 8)
	        bytes.push(addr & 0xFF);
	    if (bytes.length == 0)
	        bytes.push(0);
	
	    var node = this.decodeTables[0];
	    for (var i = bytes.length-1; i > 0; i--) { // Traverse nodes deeper into the trie.
	        var val = node[bytes[i]];
	
	        if (val == UNASSIGNED) { // Create new node.
	            node[bytes[i]] = NODE_START - this.decodeTables.length;
	            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
	        }
	        else if (val <= NODE_START) { // Existing node.
	            node = this.decodeTables[NODE_START - val];
	        }
	        else
	            throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
	    }
	    return node;
	}
	
	
	DBCSCodec.prototype._addDecodeChunk = function(chunk) {
	    // First element of chunk is the hex mbcs code where we start.
	    var curAddr = parseInt(chunk[0], 16);
	
	    // Choose the decoding node where we'll write our chars.
	    var writeTable = this._getDecodeTrieNode(curAddr);
	    curAddr = curAddr & 0xFF;
	
	    // Write all other elements of the chunk to the table.
	    for (var k = 1; k < chunk.length; k++) {
	        var part = chunk[k];
	        if (typeof part === "string") { // String, write as-is.
	            for (var l = 0; l < part.length;) {
	                var code = part.charCodeAt(l++);
	                if (0xD800 <= code && code < 0xDC00) { // Decode surrogate
	                    var codeTrail = part.charCodeAt(l++);
	                    if (0xDC00 <= codeTrail && codeTrail < 0xE000)
	                        writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
	                    else
	                        throw new Error("Incorrect surrogate pair in "  + this.encodingName + " at chunk " + chunk[0]);
	                }
	                else if (0x0FF0 < code && code <= 0x0FFF) { // Character sequence (our own encoding used)
	                    var len = 0xFFF - code + 2;
	                    var seq = [];
	                    for (var m = 0; m < len; m++)
	                        seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
	
	                    writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
	                    this.decodeTableSeq.push(seq);
	                }
	                else
	                    writeTable[curAddr++] = code; // Basic char
	            }
	        } 
	        else if (typeof part === "number") { // Integer, meaning increasing sequence starting with prev character.
	            var charCode = writeTable[curAddr - 1] + 1;
	            for (var l = 0; l < part; l++)
	                writeTable[curAddr++] = charCode++;
	        }
	        else
	            throw new Error("Incorrect type '" + typeof part + "' given in "  + this.encodingName + " at chunk " + chunk[0]);
	    }
	    if (curAddr > 0xFF)
	        throw new Error("Incorrect chunk in "  + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
	}
	
	// Encoder helpers
	DBCSCodec.prototype._getEncodeBucket = function(uCode) {
	    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
	    if (this.encodeTable[high] === undefined)
	        this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
	    return this.encodeTable[high];
	}
	
	DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;
	    if (bucket[low] <= SEQ_START)
	        this.encodeTableSeq[SEQ_START-bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
	    else if (bucket[low] == UNASSIGNED)
	        bucket[low] = dbcsCode;
	}
	
	DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
	    
	    // Get the root of character tree according to first character of the sequence.
	    var uCode = seq[0];
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;
	
	    var node;
	    if (bucket[low] <= SEQ_START) {
	        // There's already a sequence with  - use it.
	        node = this.encodeTableSeq[SEQ_START-bucket[low]];
	    }
	    else {
	        // There was no sequence object - allocate a new one.
	        node = {};
	        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
	        bucket[low] = SEQ_START - this.encodeTableSeq.length;
	        this.encodeTableSeq.push(node);
	    }
	
	    // Traverse the character tree, allocating new nodes as needed.
	    for (var j = 1; j < seq.length-1; j++) {
	        var oldVal = node[uCode];
	        if (typeof oldVal === 'object')
	            node = oldVal;
	        else {
	            node = node[uCode] = {}
	            if (oldVal !== undefined)
	                node[DEF_CHAR] = oldVal
	        }
	    }
	
	    // Set the leaf to given dbcsCode.
	    uCode = seq[seq.length-1];
	    node[uCode] = dbcsCode;
	}
	
	DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
	    var node = this.decodeTables[nodeIdx];
	    for (var i = 0; i < 0x100; i++) {
	        var uCode = node[i];
	        var mbCode = prefix + i;
	        if (skipEncodeChars[mbCode])
	            continue;
	
	        if (uCode >= 0)
	            this._setEncodeChar(uCode, mbCode);
	        else if (uCode <= NODE_START)
	            this._fillEncodeTable(NODE_START - uCode, mbCode << 8, skipEncodeChars);
	        else if (uCode <= SEQ_START)
	            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
	    }
	}
	
	
	
	// == Encoder ==================================================================
	
	function DBCSEncoder(options, codec) {
	    // Encoder state
	    this.leadSurrogate = -1;
	    this.seqObj = undefined;
	    
	    // Static data
	    this.encodeTable = codec.encodeTable;
	    this.encodeTableSeq = codec.encodeTableSeq;
	    this.defaultCharSingleByte = codec.defCharSB;
	    this.gb18030 = codec.gb18030;
	}
	
	DBCSEncoder.prototype.write = function(str) {
	    var newBuf = new Buffer(str.length * (this.gb18030 ? 4 : 3)), 
	        leadSurrogate = this.leadSurrogate,
	        seqObj = this.seqObj, nextChar = -1,
	        i = 0, j = 0;
	
	    while (true) {
	        // 0. Get next character.
	        if (nextChar === -1) {
	            if (i == str.length) break;
	            var uCode = str.charCodeAt(i++);
	        }
	        else {
	            var uCode = nextChar;
	            nextChar = -1;    
	        }
	
	        // 1. Handle surrogates.
	        if (0xD800 <= uCode && uCode < 0xE000) { // Char is one of surrogates.
	            if (uCode < 0xDC00) { // We've got lead surrogate.
	                if (leadSurrogate === -1) {
	                    leadSurrogate = uCode;
	                    continue;
	                } else {
	                    leadSurrogate = uCode;
	                    // Double lead surrogate found.
	                    uCode = UNASSIGNED;
	                }
	            } else { // We've got trail surrogate.
	                if (leadSurrogate !== -1) {
	                    uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
	                    leadSurrogate = -1;
	                } else {
	                    // Incomplete surrogate pair - only trail surrogate found.
	                    uCode = UNASSIGNED;
	                }
	                
	            }
	        }
	        else if (leadSurrogate !== -1) {
	            // Incomplete surrogate pair - only lead surrogate found.
	            nextChar = uCode; uCode = UNASSIGNED; // Write an error, then current char.
	            leadSurrogate = -1;
	        }
	
	        // 2. Convert uCode character.
	        var dbcsCode = UNASSIGNED;
	        if (seqObj !== undefined && uCode != UNASSIGNED) { // We are in the middle of the sequence
	            var resCode = seqObj[uCode];
	            if (typeof resCode === 'object') { // Sequence continues.
	                seqObj = resCode;
	                continue;
	
	            } else if (typeof resCode == 'number') { // Sequence finished. Write it.
	                dbcsCode = resCode;
	
	            } else if (resCode == undefined) { // Current character is not part of the sequence.
	
	                // Try default character for this sequence
	                resCode = seqObj[DEF_CHAR];
	                if (resCode !== undefined) {
	                    dbcsCode = resCode; // Found. Write it.
	                    nextChar = uCode; // Current character will be written too in the next iteration.
	
	                } else {
	                    // TODO: What if we have no default? (resCode == undefined)
	                    // Then, we should write first char of the sequence as-is and try the rest recursively.
	                    // Didn't do it for now because no encoding has this situation yet.
	                    // Currently, just skip the sequence and write current char.
	                }
	            }
	            seqObj = undefined;
	        }
	        else if (uCode >= 0) {  // Regular character
	            var subtable = this.encodeTable[uCode >> 8];
	            if (subtable !== undefined)
	                dbcsCode = subtable[uCode & 0xFF];
	            
	            if (dbcsCode <= SEQ_START) { // Sequence start
	                seqObj = this.encodeTableSeq[SEQ_START-dbcsCode];
	                continue;
	            }
	
	            if (dbcsCode == UNASSIGNED && this.gb18030) {
	                // Use GB18030 algorithm to find character(s) to write.
	                var idx = findIdx(this.gb18030.uChars, uCode);
	                if (idx != -1) {
	                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600); dbcsCode = dbcsCode % 12600;
	                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260); dbcsCode = dbcsCode % 1260;
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10); dbcsCode = dbcsCode % 10;
	                    newBuf[j++] = 0x30 + dbcsCode;
	                    continue;
	                }
	            }
	        }
	
	        // 3. Write dbcsCode character.
	        if (dbcsCode === UNASSIGNED)
	            dbcsCode = this.defaultCharSingleByte;
	        
	        if (dbcsCode < 0x100) {
	            newBuf[j++] = dbcsCode;
	        }
	        else if (dbcsCode < 0x10000) {
	            newBuf[j++] = dbcsCode >> 8;   // high byte
	            newBuf[j++] = dbcsCode & 0xFF; // low byte
	        }
	        else {
	            newBuf[j++] = dbcsCode >> 16;
	            newBuf[j++] = (dbcsCode >> 8) & 0xFF;
	            newBuf[j++] = dbcsCode & 0xFF;
	        }
	    }
	
	    this.seqObj = seqObj;
	    this.leadSurrogate = leadSurrogate;
	    return newBuf.slice(0, j);
	}
	
	DBCSEncoder.prototype.end = function() {
	    if (this.leadSurrogate === -1 && this.seqObj === undefined)
	        return; // All clean. Most often case.
	
	    var newBuf = new Buffer(10), j = 0;
	
	    if (this.seqObj) { // We're in the sequence.
	        var dbcsCode = this.seqObj[DEF_CHAR];
	        if (dbcsCode !== undefined) { // Write beginning of the sequence.
	            if (dbcsCode < 0x100) {
	                newBuf[j++] = dbcsCode;
	            }
	            else {
	                newBuf[j++] = dbcsCode >> 8;   // high byte
	                newBuf[j++] = dbcsCode & 0xFF; // low byte
	            }
	        } else {
	            // See todo above.
	        }
	        this.seqObj = undefined;
	    }
	
	    if (this.leadSurrogate !== -1) {
	        // Incomplete surrogate pair - only lead surrogate found.
	        newBuf[j++] = this.defaultCharSingleByte;
	        this.leadSurrogate = -1;
	    }
	    
	    return newBuf.slice(0, j);
	}
	
	// Export for testing
	DBCSEncoder.prototype.findIdx = findIdx;
	
	
	// == Decoder ==================================================================
	
	function DBCSDecoder(options, codec) {
	    // Decoder state
	    this.nodeIdx = 0;
	    this.prevBuf = new Buffer(0);
	
	    // Static data
	    this.decodeTables = codec.decodeTables;
	    this.decodeTableSeq = codec.decodeTableSeq;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	    this.gb18030 = codec.gb18030;
	}
	
	DBCSDecoder.prototype.write = function(buf) {
	    var newBuf = new Buffer(buf.length*2),
	        nodeIdx = this.nodeIdx, 
	        prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length,
	        seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
	        uCode;
	
	    if (prevBufOffset > 0) // Make prev buf overlap a little to make it easier to slice later.
	        prevBuf = Buffer.concat([prevBuf, buf.slice(0, 10)]);
	    
	    for (var i = 0, j = 0; i < buf.length; i++) {
	        var curByte = (i >= 0) ? buf[i] : prevBuf[i + prevBufOffset];
	
	        // Lookup in current trie node.
	        var uCode = this.decodeTables[nodeIdx][curByte];
	
	        if (uCode >= 0) { 
	            // Normal character, just use it.
	        }
	        else if (uCode === UNASSIGNED) { // Unknown char.
	            // TODO: Callback with seq.
	            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
	            uCode = this.defaultCharUnicode.charCodeAt(0);
	        }
	        else if (uCode === GB18030_CODE) {
	            var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            var ptr = (curSeq[0]-0x81)*12600 + (curSeq[1]-0x30)*1260 + (curSeq[2]-0x81)*10 + (curSeq[3]-0x30);
	            var idx = findIdx(this.gb18030.gbChars, ptr);
	            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
	        }
	        else if (uCode <= NODE_START) { // Go to next trie node.
	            nodeIdx = NODE_START - uCode;
	            continue;
	        }
	        else if (uCode <= SEQ_START) { // Output a sequence of chars.
	            var seq = this.decodeTableSeq[SEQ_START - uCode];
	            for (var k = 0; k < seq.length - 1; k++) {
	                uCode = seq[k];
	                newBuf[j++] = uCode & 0xFF;
	                newBuf[j++] = uCode >> 8;
	            }
	            uCode = seq[seq.length-1];
	        }
	        else
	            throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
	
	        // Write the character to buffer, handling higher planes using surrogate pair.
	        if (uCode > 0xFFFF) { 
	            uCode -= 0x10000;
	            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
	            newBuf[j++] = uCodeLead & 0xFF;
	            newBuf[j++] = uCodeLead >> 8;
	
	            uCode = 0xDC00 + uCode % 0x400;
	        }
	        newBuf[j++] = uCode & 0xFF;
	        newBuf[j++] = uCode >> 8;
	
	        // Reset trie node.
	        nodeIdx = 0; seqStart = i+1;
	    }
	
	    this.nodeIdx = nodeIdx;
	    this.prevBuf = (seqStart >= 0) ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
	    return newBuf.slice(0, j).toString('ucs2');
	}
	
	DBCSDecoder.prototype.end = function() {
	    var ret = '';
	
	    // Try to parse all remaining chars.
	    while (this.prevBuf.length > 0) {
	        // Skip 1 character in the buffer.
	        ret += this.defaultCharUnicode;
	        var buf = this.prevBuf.slice(1);
	
	        // Parse remaining as usual.
	        this.prevBuf = new Buffer(0);
	        this.nodeIdx = 0;
	        if (buf.length > 0)
	            ret += this.write(buf);
	    }
	
	    this.nodeIdx = 0;
	    return ret;
	}
	
	// Binary search for GB18030. Returns largest i such that table[i] <= val.
	function findIdx(table, val) {
	    if (table[0] > val)
	        return -1;
	
	    var l = 0, r = table.length;
	    while (l < r-1) { // always table[l] <= val < table[r]
	        var mid = l + Math.floor((r-l+1)/2);
	        if (table[mid] <= val)
	            l = mid;
	        else
	            r = mid;
	    }
	    return l;
	}
	
	
	
	/***/ }),
	/* 179 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// Description of supported double byte encodings and aliases.
	// Tables are not require()-d until they are needed to speed up library load.
	// require()-s are direct to support Browserify.
	
	module.exports = {
	    
	    // == Japanese/ShiftJIS ====================================================
	    // All japanese encodings are based on JIS X set of standards:
	    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
	    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
	    //              Has several variations in 1978, 1983, 1990 and 1997.
	    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
	    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
	    //              2 planes, first is superset of 0208, second - revised 0212.
	    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
	
	    // Byte encodings are:
	    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
	    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
	    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
	    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
	    //               0x00-0x7F       - lower part of 0201
	    //               0x8E, 0xA1-0xDF - upper part of 0201
	    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
	    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
	    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
	    //               Used as-is in ISO2022 family.
	    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
	    //                0201-1976 Roman, 0208-1978, 0208-1983.
	    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
	    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
	    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
	    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
	    //
	    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
	    //
	    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
	
	    'shiftjis': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(180) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	        encodeSkipVals: [{from: 0xED40, to: 0xF940}],
	    },
	    'csshiftjis': 'shiftjis',
	    'mskanji': 'shiftjis',
	    'sjis': 'shiftjis',
	    'windows31j': 'shiftjis',
	    'ms31j': 'shiftjis',
	    'xsjis': 'shiftjis',
	    'windows932': 'shiftjis',
	    'ms932': 'shiftjis',
	    '932': 'shiftjis',
	    'cp932': 'shiftjis',
	
	    'eucjp': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(181) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	    },
	
	    // TODO: KDDI extension to Shift_JIS
	    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
	    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
	
	
	    // == Chinese/GBK ==========================================================
	    // http://en.wikipedia.org/wiki/GBK
	    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
	
	    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
	    'gb2312': 'cp936',
	    'gb231280': 'cp936',
	    'gb23121980': 'cp936',
	    'csgb2312': 'cp936',
	    'csiso58gb231280': 'cp936',
	    'euccn': 'cp936',
	
	    // Microsoft's CP936 is a subset and approximation of GBK.
	    'windows936': 'cp936',
	    'ms936': 'cp936',
	    '936': 'cp936',
	    'cp936': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(53) },
	    },
	
	    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
	    'gbk': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(53).concat(__webpack_require__(91)) },
	    },
	    'xgbk': 'gbk',
	    'isoir58': 'gbk',
	
	    // GB18030 is an algorithmic extension of GBK.
	    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
	    // http://icu-project.org/docs/papers/gb18030.html
	    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
	    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
	    'gb18030': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(53).concat(__webpack_require__(91)) },
	        gb18030: function() { return __webpack_require__(182) },
	        encodeSkipVals: [0x80],
	        encodeAdd: {'€': 0xA2E3},
	    },
	
	    'chinese': 'gb18030',
	
	
	    // == Korean ===============================================================
	    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
	    'windows949': 'cp949',
	    'ms949': 'cp949',
	    '949': 'cp949',
	    'cp949': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(183) },
	    },
	
	    'cseuckr': 'cp949',
	    'csksc56011987': 'cp949',
	    'euckr': 'cp949',
	    'isoir149': 'cp949',
	    'korean': 'cp949',
	    'ksc56011987': 'cp949',
	    'ksc56011989': 'cp949',
	    'ksc5601': 'cp949',
	
	
	    // == Big5/Taiwan/Hong Kong ================================================
	    // There are lots of tables for Big5 and cp950. Please see the following links for history:
	    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
	    // Variations, in roughly number of defined chars:
	    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
	    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
	    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
	    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
	    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
	    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
	    //    Plus, it has 4 combining sequences.
	    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
	    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
	    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
	    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
	    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
	    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
	    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
	    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
	    // 
	    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
	    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
	
	    'windows950': 'cp950',
	    'ms950': 'cp950',
	    '950': 'cp950',
	    'cp950': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(92) },
	    },
	
	    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
	    'big5': 'big5hkscs',
	    'big5hkscs': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(92).concat(__webpack_require__(184)) },
	        encodeSkipVals: [0xa2cc],
	    },
	
	    'cnbig5': 'big5hkscs',
	    'csbig5': 'big5hkscs',
	    'xxbig5': 'big5hkscs',
	};
	
	
	/***/ }),
	/* 180 */
	/***/ (function(module, exports) {
	
	module.exports = [["0","\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]
	
	/***/ }),
	/* 181 */
	/***/ (function(module, exports) {
	
	module.exports = [["0","\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]
	
	/***/ }),
	/* 182 */
	/***/ (function(module, exports) {
	
	module.exports = {"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}
	
	/***/ }),
	/* 183 */
	/***/ (function(module, exports) {
	
	module.exports = [["0","\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]
	
	/***/ }),
	/* 184 */
	/***/ (function(module, exports) {
	
	module.exports = [["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]
	
	/***/ }),
	/* 185 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Buffer = __webpack_require__(1).Buffer,
	    Transform = __webpack_require__(15).Transform;
	
	
	// == Exports ==================================================================
	module.exports = function(iconv) {
	    
	    // Additional Public API.
	    iconv.encodeStream = function encodeStream(encoding, options) {
	        return new IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
	    }
	
	    iconv.decodeStream = function decodeStream(encoding, options) {
	        return new IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
	    }
	
	    iconv.supportsStreams = true;
	
	
	    // Not published yet.
	    iconv.IconvLiteEncoderStream = IconvLiteEncoderStream;
	    iconv.IconvLiteDecoderStream = IconvLiteDecoderStream;
	    iconv._collect = IconvLiteDecoderStream.prototype.collect;
	};
	
	
	// == Encoder stream =======================================================
	function IconvLiteEncoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
	    Transform.call(this, options);
	}
	
	IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteEncoderStream }
	});
	
	IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (typeof chunk != 'string')
	        return done(new Error("Iconv encoding stream needs strings as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteEncoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteEncoderStream.prototype.collect = function(cb) {
	    var chunks = [];
	    this.on('error', cb);
	    this.on('data', function(chunk) { chunks.push(chunk); });
	    this.on('end', function() {
	        cb(null, Buffer.concat(chunks));
	    });
	    return this;
	}
	
	
	// == Decoder stream =======================================================
	function IconvLiteDecoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.encoding = this.encoding = 'utf8'; // We output strings.
	    Transform.call(this, options);
	}
	
	IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteDecoderStream }
	});
	
	IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (!Buffer.isBuffer(chunk))
	        return done(new Error("Iconv decoding stream needs buffers as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res, this.encoding);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteDecoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res, this.encoding);                
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteDecoderStream.prototype.collect = function(cb) {
	    var res = '';
	    this.on('error', cb);
	    this.on('data', function(chunk) { res += chunk; });
	    this.on('end', function() {
	        cb(null, res);
	    });
	    return this;
	}
	
	
	
	/***/ }),
	/* 186 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var Buffer = __webpack_require__(1).Buffer;
	
	// == Extend Node primitives to use iconv-lite =================================
	
	module.exports = function (iconv) {
	    var original = undefined; // Place to keep original methods.
	
	    // Node authors rewrote Buffer internals to make it compatible with
	    // Uint8Array and we cannot patch key functions since then.
	    iconv.supportsNodeEncodingsExtension = !(new Buffer(0) instanceof Uint8Array);
	
	    iconv.extendNodeEncodings = function extendNodeEncodings() {
	        if (original) return;
	        original = {};
	
	        if (!iconv.supportsNodeEncodingsExtension) {
	            console.error("ACTION NEEDED: require('iconv-lite').extendNodeEncodings() is not supported in your version of Node");
	            console.error("See more info at https://github.com/ashtuchkin/iconv-lite/wiki/Node-v4-compatibility");
	            return;
	        }
	
	        var nodeNativeEncodings = {
	            'hex': true, 'utf8': true, 'utf-8': true, 'ascii': true, 'binary': true, 
	            'base64': true, 'ucs2': true, 'ucs-2': true, 'utf16le': true, 'utf-16le': true,
	        };
	
	        Buffer.isNativeEncoding = function(enc) {
	            return enc && nodeNativeEncodings[enc.toLowerCase()];
	        }
	
	        // -- SlowBuffer -----------------------------------------------------------
	        var SlowBuffer = __webpack_require__(1).SlowBuffer;
	
	        original.SlowBufferToString = SlowBuffer.prototype.toString;
	        SlowBuffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferToString.call(this, encoding, start, end);
	
	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }
	
	        original.SlowBufferWrite = SlowBuffer.prototype.write;
	        SlowBuffer.prototype.write = function(string, offset, length, encoding) {
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }
	
	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferWrite.call(this, string, offset, length, encoding);
	
	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');
	
	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;
	        }
	
	        // -- Buffer ---------------------------------------------------------------
	
	        original.BufferIsEncoding = Buffer.isEncoding;
	        Buffer.isEncoding = function(encoding) {
	            return Buffer.isNativeEncoding(encoding) || iconv.encodingExists(encoding);
	        }
	
	        original.BufferByteLength = Buffer.byteLength;
	        Buffer.byteLength = SlowBuffer.byteLength = function(str, encoding) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferByteLength.call(this, str, encoding);
	
	            // Slow, I know, but we don't have a better way yet.
	            return iconv.encode(str, encoding).length;
	        }
	
	        original.BufferToString = Buffer.prototype.toString;
	        Buffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferToString.call(this, encoding, start, end);
	
	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }
	
	        original.BufferWrite = Buffer.prototype.write;
	        Buffer.prototype.write = function(string, offset, length, encoding) {
	            var _offset = offset, _length = length, _encoding = encoding;
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }
	
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferWrite.call(this, string, _offset, _length, _encoding);
	
	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	
	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');
	
	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;
	
	            // TODO: Set _charsWritten.
	        }
	
	
	        // -- Readable -------------------------------------------------------------
	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(15).Readable;
	
	            original.ReadableSetEncoding = Readable.prototype.setEncoding;
	            Readable.prototype.setEncoding = function setEncoding(enc, options) {
	                // Use our own decoder, it has the same interface.
	                // We cannot use original function as it doesn't handle BOM-s.
	                this._readableState.decoder = iconv.getDecoder(enc, options);
	                this._readableState.encoding = enc;
	            }
	
	            Readable.prototype.collect = iconv._collect;
	        }
	    }
	
	    // Remove iconv-lite Node primitive extensions.
	    iconv.undoExtendNodeEncodings = function undoExtendNodeEncodings() {
	        if (!iconv.supportsNodeEncodingsExtension)
	            return;
	        if (!original)
	            throw new Error("require('iconv-lite').undoExtendNodeEncodings(): Nothing to undo; extendNodeEncodings() is not called.")
	
	        delete Buffer.isNativeEncoding;
	
	        var SlowBuffer = __webpack_require__(1).SlowBuffer;
	
	        SlowBuffer.prototype.toString = original.SlowBufferToString;
	        SlowBuffer.prototype.write = original.SlowBufferWrite;
	
	        Buffer.isEncoding = original.BufferIsEncoding;
	        Buffer.byteLength = original.BufferByteLength;
	        Buffer.prototype.toString = original.BufferToString;
	        Buffer.prototype.write = original.BufferWrite;
	
	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(15).Readable;
	
	            Readable.prototype.setEncoding = original.ReadableSetEncoding;
	            delete Readable.prototype.collect;
	        }
	
	        original = undefined;
	    }
	}
	
	
	/***/ }),
	/* 187 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var ArrayT, LazyArray, LazyArrayT, NumberT, inspect, utils,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  ArrayT = __webpack_require__(93);
	
	  NumberT = __webpack_require__(22).Number;
	
	  utils = __webpack_require__(12);
	
	  inspect = __webpack_require__(49).inspect;
	
	  LazyArrayT = (function(_super) {
	    __extends(LazyArrayT, _super);
	
	    function LazyArrayT() {
	      return LazyArrayT.__super__.constructor.apply(this, arguments);
	    }
	
	    LazyArrayT.prototype.decode = function(stream, parent) {
	      var length, pos, res;
	      pos = stream.pos;
	      length = utils.resolveLength(this.length, stream, parent);
	      if (this.length instanceof NumberT) {
	        parent = {
	          parent: parent,
	          _startOffset: pos,
	          _currentOffset: 0,
	          _length: length
	        };
	      }
	      res = new LazyArray(this.type, length, stream, parent);
	      stream.pos += length * this.type.size(null, parent);
	      return res;
	    };
	
	    LazyArrayT.prototype.size = function(val, ctx) {
	      if (val instanceof LazyArray) {
	        val = val.toArray();
	      }
	      return LazyArrayT.__super__.size.call(this, val, ctx);
	    };
	
	    LazyArrayT.prototype.encode = function(stream, val, ctx) {
	      if (val instanceof LazyArray) {
	        val = val.toArray();
	      }
	      return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
	    };
	
	    return LazyArrayT;
	
	  })(ArrayT);
	
	  LazyArray = (function() {
	    function LazyArray(type, length, stream, ctx) {
	      this.type = type;
	      this.length = length;
	      this.stream = stream;
	      this.ctx = ctx;
	      this.base = this.stream.pos;
	      this.items = [];
	    }
	
	    LazyArray.prototype.get = function(index) {
	      var pos;
	      if (index < 0 || index >= this.length) {
	        return void 0;
	      }
	      if (this.items[index] == null) {
	        pos = this.stream.pos;
	        this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
	        this.items[index] = this.type.decode(this.stream, this.ctx);
	        this.stream.pos = pos;
	      }
	      return this.items[index];
	    };
	
	    LazyArray.prototype.toArray = function() {
	      var i, _i, _ref, _results;
	      _results = [];
	      for (i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1) {
	        _results.push(this.get(i));
	      }
	      return _results;
	    };
	
	    LazyArray.prototype.inspect = function() {
	      return inspect(this.toArray());
	    };
	
	    return LazyArray;
	
	  })();
	
	  module.exports = LazyArrayT;
	
	}).call(this);
	
	
	/***/ }),
	/* 188 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Bitfield;
	
	  Bitfield = (function() {
	    function Bitfield(type, flags) {
	      this.type = type;
	      this.flags = flags != null ? flags : [];
	    }
	
	    Bitfield.prototype.decode = function(stream) {
	      var flag, i, res, val, _i, _len, _ref;
	      val = this.type.decode(stream);
	      res = {};
	      _ref = this.flags;
	      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
	        flag = _ref[i];
	        if (flag != null) {
	          res[flag] = !!(val & (1 << i));
	        }
	      }
	      return res;
	    };
	
	    Bitfield.prototype.size = function() {
	      return this.type.size();
	    };
	
	    Bitfield.prototype.encode = function(stream, keys) {
	      var flag, i, val, _i, _len, _ref;
	      val = 0;
	      _ref = this.flags;
	      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
	        flag = _ref[i];
	        if (flag != null) {
	          if (keys[flag]) {
	            val |= 1 << i;
	          }
	        }
	      }
	      return this.type.encode(stream, val);
	    };
	
	    return Bitfield;
	
	  })();
	
	  module.exports = Bitfield;
	
	}).call(this);
	
	
	/***/ }),
	/* 189 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var BooleanT;
	
	  BooleanT = (function() {
	    function BooleanT(type) {
	      this.type = type;
	    }
	
	    BooleanT.prototype.decode = function(stream, parent) {
	      return !!this.type.decode(stream, parent);
	    };
	
	    BooleanT.prototype.size = function(val, parent) {
	      return this.type.size(val, parent);
	    };
	
	    BooleanT.prototype.encode = function(stream, val, parent) {
	      return this.type.encode(stream, +val, parent);
	    };
	
	    return BooleanT;
	
	  })();
	
	  module.exports = BooleanT;
	
	}).call(this);
	
	
	/***/ }),
	/* 190 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var BufferT, NumberT, utils;
	
	  utils = __webpack_require__(12);
	
	  NumberT = __webpack_require__(22).Number;
	
	  BufferT = (function() {
	    function BufferT(length) {
	      this.length = length;
	    }
	
	    BufferT.prototype.decode = function(stream, parent) {
	      var length;
	      length = utils.resolveLength(this.length, stream, parent);
	      return stream.readBuffer(length);
	    };
	
	    BufferT.prototype.size = function(val, parent) {
	      if (!val) {
	        return utils.resolveLength(this.length, null, parent);
	      }
	      return val.length;
	    };
	
	    BufferT.prototype.encode = function(stream, buf, parent) {
	      if (this.length instanceof NumberT) {
	        this.length.encode(stream, buf.length);
	      }
	      return stream.writeBuffer(buf);
	    };
	
	    return BufferT;
	
	  })();
	
	  module.exports = BufferT;
	
	}).call(this);
	
	
	/***/ }),
	/* 191 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Enum;
	
	  Enum = (function() {
	    function Enum(type, options) {
	      this.type = type;
	      this.options = options != null ? options : [];
	    }
	
	    Enum.prototype.decode = function(stream) {
	      var index;
	      index = this.type.decode(stream);
	      return this.options[index] || index;
	    };
	
	    Enum.prototype.size = function() {
	      return this.type.size();
	    };
	
	    Enum.prototype.encode = function(stream, val) {
	      var index;
	      index = this.options.indexOf(val);
	      if (index === -1) {
	        throw new Error("Unknown option in enum: " + val);
	      }
	      return this.type.encode(stream, index);
	    };
	
	    return Enum;
	
	  })();
	
	  module.exports = Enum;
	
	}).call(this);
	
	
	/***/ }),
	/* 192 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Optional;
	
	  Optional = (function() {
	    function Optional(type, condition) {
	      this.type = type;
	      this.condition = condition != null ? condition : true;
	    }
	
	    Optional.prototype.decode = function(stream, parent) {
	      var condition;
	      condition = this.condition;
	      if (typeof condition === 'function') {
	        condition = condition.call(parent, parent);
	      }
	      if (condition) {
	        return this.type.decode(stream, parent);
	      }
	    };
	
	    Optional.prototype.size = function(val, parent) {
	      var condition;
	      condition = this.condition;
	      if (typeof condition === 'function') {
	        condition = condition.call(parent, parent);
	      }
	      if (condition) {
	        return this.type.size(val, parent);
	      } else {
	        return 0;
	      }
	    };
	
	    Optional.prototype.encode = function(stream, val, parent) {
	      var condition;
	      condition = this.condition;
	      if (typeof condition === 'function') {
	        condition = condition.call(parent, parent);
	      }
	      if (condition) {
	        return this.type.encode(stream, val, parent);
	      }
	    };
	
	    return Optional;
	
	  })();
	
	  module.exports = Optional;
	
	}).call(this);
	
	
	/***/ }),
	/* 193 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Reserved, utils;
	
	  utils = __webpack_require__(12);
	
	  Reserved = (function() {
	    function Reserved(type, count) {
	      this.type = type;
	      this.count = count != null ? count : 1;
	    }
	
	    Reserved.prototype.decode = function(stream, parent) {
	      stream.pos += this.size(null, parent);
	      return void 0;
	    };
	
	    Reserved.prototype.size = function(data, parent) {
	      var count;
	      count = utils.resolveLength(this.count, null, parent);
	      return this.type.size() * count;
	    };
	
	    Reserved.prototype.encode = function(stream, val, parent) {
	      return stream.fill(0, this.size(val, parent));
	    };
	
	    return Reserved;
	
	  })();
	
	  module.exports = Reserved;
	
	}).call(this);
	
	
	/***/ }),
	/* 194 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var NumberT, StringT, utils;
	
	  NumberT = __webpack_require__(22).Number;
	
	  utils = __webpack_require__(12);
	
	  StringT = (function() {
	    function StringT(length, encoding) {
	      this.length = length;
	      this.encoding = encoding != null ? encoding : 'ascii';
	    }
	
	    StringT.prototype.decode = function(stream, parent) {
	      var buffer, encoding, length, pos, string;
	      length = (function() {
	        if (this.length != null) {
	          return utils.resolveLength(this.length, stream, parent);
	        } else {
	          buffer = stream.buffer, length = stream.length, pos = stream.pos;
	          while (pos < length && buffer[pos] !== 0x00) {
	            ++pos;
	          }
	          return pos - stream.pos;
	        }
	      }).call(this);
	      encoding = this.encoding;
	      if (typeof encoding === 'function') {
	        encoding = encoding.call(parent, parent) || 'ascii';
	      }
	      string = stream.readString(length, encoding);
	      if ((this.length == null) && stream.pos < stream.length) {
	        stream.pos++;
	      }
	      return string;
	    };
	
	    StringT.prototype.size = function(val, parent) {
	      var encoding, size;
	      if (!val) {
	        return utils.resolveLength(this.length, null, parent);
	      }
	      encoding = this.encoding;
	      if (typeof encoding === 'function') {
	        encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
	      }
	      if (encoding === 'utf16be') {
	        encoding = 'utf16le';
	      }
	      size = Buffer.byteLength(val, encoding);
	      if (this.length instanceof NumberT) {
	        size += this.length.size();
	      }
	      if (this.length == null) {
	        size++;
	      }
	      return size;
	    };
	
	    StringT.prototype.encode = function(stream, val, parent) {
	      var encoding;
	      encoding = this.encoding;
	      if (typeof encoding === 'function') {
	        encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
	      }
	      if (this.length instanceof NumberT) {
	        this.length.encode(stream, Buffer.byteLength(val, encoding));
	      }
	      stream.writeString(val, encoding);
	      if (this.length == null) {
	        return stream.writeUInt8(0x00);
	      }
	    };
	
	    return StringT;
	
	  })();
	
	  module.exports = StringT;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 195 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Struct, VersionedStruct,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  Struct = __webpack_require__(94);
	
	  VersionedStruct = (function(_super) {
	    __extends(VersionedStruct, _super);
	
	    function VersionedStruct(type, versions) {
	      this.type = type;
	      this.versions = versions != null ? versions : {};
	      if (typeof this.type === 'string') {
	        this.versionGetter = new Function('parent', "return parent." + this.type);
	        this.versionSetter = new Function('parent', 'version', "return parent." + this.type + " = version");
	      }
	    }
	
	    VersionedStruct.prototype.decode = function(stream, parent, length) {
	      var fields, res, _ref;
	      if (length == null) {
	        length = 0;
	      }
	      res = this._setup(stream, parent, length);
	      if (typeof this.type === 'string') {
	        res.version = this.versionGetter(parent);
	      } else {
	        res.version = this.type.decode(stream);
	      }
	      if (this.versions.header) {
	        this._parseFields(stream, res, this.versions.header);
	      }
	      fields = this.versions[res.version];
	      if (fields == null) {
	        throw new Error("Unknown version " + res.version);
	      }
	      if (fields instanceof VersionedStruct) {
	        return fields.decode(stream, parent);
	      }
	      this._parseFields(stream, res, fields);
	      if ((_ref = this.process) != null) {
	        _ref.call(res, stream);
	      }
	      return res;
	    };
	
	    VersionedStruct.prototype.size = function(val, parent, includePointers) {
	      var ctx, fields, key, size, type, _ref;
	      if (includePointers == null) {
	        includePointers = true;
	      }
	      if (!val) {
	        throw new Error('Not a fixed size');
	      }
	      ctx = {
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      size = 0;
	      if (typeof this.type !== 'string') {
	        size += this.type.size(val.version, ctx);
	      }
	      if (this.versions.header) {
	        _ref = this.versions.header;
	        for (key in _ref) {
	          type = _ref[key];
	          if (type.size != null) {
	            size += type.size(val[key], ctx);
	          }
	        }
	      }
	      fields = this.versions[val.version];
	      if (fields == null) {
	        throw new Error("Unknown version " + val.version);
	      }
	      for (key in fields) {
	        type = fields[key];
	        if (type.size != null) {
	          size += type.size(val[key], ctx);
	        }
	      }
	      if (includePointers) {
	        size += ctx.pointerSize;
	      }
	      return size;
	    };
	
	    VersionedStruct.prototype.encode = function(stream, val, parent) {
	      var ctx, fields, i, key, ptr, type, _ref, _ref1;
	      if ((_ref = this.preEncode) != null) {
	        _ref.call(val, stream);
	      }
	      ctx = {
	        pointers: [],
	        startOffset: stream.pos,
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
	      if (typeof this.type !== 'string') {
	        this.type.encode(stream, val.version);
	      }
	      if (this.versions.header) {
	        _ref1 = this.versions.header;
	        for (key in _ref1) {
	          type = _ref1[key];
	          if (type.encode != null) {
	            type.encode(stream, val[key], ctx);
	          }
	        }
	      }
	      fields = this.versions[val.version];
	      for (key in fields) {
	        type = fields[key];
	        if (type.encode != null) {
	          type.encode(stream, val[key], ctx);
	        }
	      }
	      i = 0;
	      while (i < ctx.pointers.length) {
	        ptr = ctx.pointers[i++];
	        ptr.type.encode(stream, ptr.val, ptr.parent);
	      }
	    };
	
	    return VersionedStruct;
	
	  })(Struct);
	
	  module.exports = VersionedStruct;
	
	}).call(this);
	
	
	/***/ }),
	/* 196 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Pointer, VoidPointer, utils;
	
	  utils = __webpack_require__(12);
	
	  Pointer = (function() {
	    function Pointer(offsetType, type, options) {
	      var _base, _base1, _base2, _base3;
	      this.offsetType = offsetType;
	      this.type = type;
	      this.options = options != null ? options : {};
	      if (this.type === 'void') {
	        this.type = null;
	      }
	      if ((_base = this.options).type == null) {
	        _base.type = 'local';
	      }
	      if ((_base1 = this.options).allowNull == null) {
	        _base1.allowNull = true;
	      }
	      if ((_base2 = this.options).nullValue == null) {
	        _base2.nullValue = 0;
	      }
	      if ((_base3 = this.options).lazy == null) {
	        _base3.lazy = false;
	      }
	      if (this.options.relativeTo) {
	        this.relativeToGetter = new Function('ctx', "return ctx." + this.options.relativeTo);
	      }
	    }
	
	    Pointer.prototype.decode = function(stream, ctx) {
	      var c, decodeValue, offset, ptr, relative, val;
	      offset = this.offsetType.decode(stream, ctx);
	      if (offset === this.options.nullValue && this.options.allowNull) {
	        return null;
	      }
	      relative = (function() {
	        switch (this.options.type) {
	          case 'local':
	            return ctx._startOffset;
	          case 'immediate':
	            return stream.pos - this.offsetType.size();
	          case 'parent':
	            return ctx.parent._startOffset;
	          default:
	            c = ctx;
	            while (c.parent) {
	              c = c.parent;
	            }
	            return c._startOffset || 0;
	        }
	      }).call(this);
	      if (this.options.relativeTo) {
	        relative += this.relativeToGetter(ctx);
	      }
	      ptr = offset + relative;
	      if (this.type != null) {
	        val = null;
	        decodeValue = (function(_this) {
	          return function() {
	            var pos;
	            if (val != null) {
	              return val;
	            }
	            pos = stream.pos;
	            stream.pos = ptr;
	            val = _this.type.decode(stream, ctx);
	            stream.pos = pos;
	            return val;
	          };
	        })(this);
	        if (this.options.lazy) {
	          return new utils.PropertyDescriptor({
	            get: decodeValue
	          });
	        }
	        return decodeValue();
	      } else {
	        return ptr;
	      }
	    };
	
	    Pointer.prototype.size = function(val, ctx) {
	      var parent, type;
	      parent = ctx;
	      switch (this.options.type) {
	        case 'local':
	        case 'immediate':
	          break;
	        case 'parent':
	          ctx = ctx.parent;
	          break;
	        default:
	          while (ctx.parent) {
	            ctx = ctx.parent;
	          }
	      }
	      type = this.type;
	      if (type == null) {
	        if (!(val instanceof VoidPointer)) {
	          throw new Error("Must be a VoidPointer");
	        }
	        type = val.type;
	        val = val.value;
	      }
	      if (val && ctx) {
	        ctx.pointerSize += type.size(val, parent);
	      }
	      return this.offsetType.size();
	    };
	
	    Pointer.prototype.encode = function(stream, val, ctx) {
	      var parent, relative, type;
	      parent = ctx;
	      if (val == null) {
	        this.offsetType.encode(stream, this.options.nullValue);
	        return;
	      }
	      switch (this.options.type) {
	        case 'local':
	          relative = ctx.startOffset;
	          break;
	        case 'immediate':
	          relative = stream.pos + this.offsetType.size(val, parent);
	          break;
	        case 'parent':
	          ctx = ctx.parent;
	          relative = ctx.startOffset;
	          break;
	        default:
	          relative = 0;
	          while (ctx.parent) {
	            ctx = ctx.parent;
	          }
	      }
	      if (this.options.relativeTo) {
	        relative += this.relativeToGetter(parent.val);
	      }
	      this.offsetType.encode(stream, ctx.pointerOffset - relative);
	      type = this.type;
	      if (type == null) {
	        if (!(val instanceof VoidPointer)) {
	          throw new Error("Must be a VoidPointer");
	        }
	        type = val.type;
	        val = val.value;
	      }
	      ctx.pointers.push({
	        type: type,
	        val: val,
	        parent: parent
	      });
	      return ctx.pointerOffset += type.size(val, parent);
	    };
	
	    return Pointer;
	
	  })();
	
	  VoidPointer = (function() {
	    function VoidPointer(type, value) {
	      this.type = type;
	      this.value = value;
	    }
	
	    return VoidPointer;
	
	  })();
	
	  exports.Pointer = Pointer;
	
	  exports.VoidPointer = VoidPointer;
	
	}).call(this);
	
	
	/***/ }),
	/* 197 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(198), __esModule: true };
	
	/***/ }),
	/* 198 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(199);
	var $Object = __webpack_require__(2).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};
	
	
	/***/ }),
	/* 199 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(17);
	var $getOwnPropertyDescriptor = __webpack_require__(57).f;
	
	__webpack_require__(59)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});
	
	
	/***/ }),
	/* 200 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(28);
	__webpack_require__(24);
	module.exports = __webpack_require__(208);
	
	
	/***/ }),
	/* 201 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var addToUnscopables = __webpack_require__(202);
	var step = __webpack_require__(98);
	var Iterators = __webpack_require__(23);
	var toIObject = __webpack_require__(17);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(61)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	
	/***/ }),
	/* 202 */
	/***/ (function(module, exports) {
	
	module.exports = function () { /* empty */ };
	
	
	/***/ }),
	/* 203 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var create = __webpack_require__(36);
	var descriptor = __webpack_require__(27);
	var setToStringTag = __webpack_require__(39);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(13)(IteratorPrototype, __webpack_require__(4)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	
	/***/ }),
	/* 204 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(17);
	var toLength = __webpack_require__(37);
	var toAbsoluteIndex = __webpack_require__(102);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	
	/***/ }),
	/* 205 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var document = __webpack_require__(10).document;
	module.exports = document && document.documentElement;
	
	
	/***/ }),
	/* 206 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(18);
	var toObject = __webpack_require__(30);
	var IE_PROTO = __webpack_require__(64)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};
	
	
	/***/ }),
	/* 207 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(63);
	var defined = __webpack_require__(56);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	
	/***/ }),
	/* 208 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(14);
	var get = __webpack_require__(67);
	module.exports = __webpack_require__(2).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};
	
	
	/***/ }),
	/* 209 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(210), __esModule: true };
	
	/***/ }),
	/* 210 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(211);
	module.exports = __webpack_require__(2).Object.freeze;
	
	
	/***/ }),
	/* 211 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(40).onFreeze;
	
	__webpack_require__(59)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});
	
	
	/***/ }),
	/* 212 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(213), __esModule: true };
	
	/***/ }),
	/* 213 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(214);
	module.exports = __webpack_require__(2).Object.keys;
	
	
	/***/ }),
	/* 214 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(30);
	var $keys = __webpack_require__(29);
	
	__webpack_require__(59)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});
	
	
	/***/ }),
	/* 215 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(24);
	__webpack_require__(28);
	module.exports = __webpack_require__(70).f('iterator');
	
	
	/***/ }),
	/* 216 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(217), __esModule: true };
	
	/***/ }),
	/* 217 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(218);
	__webpack_require__(73);
	__webpack_require__(221);
	__webpack_require__(222);
	module.exports = __webpack_require__(2).Symbol;
	
	
	/***/ }),
	/* 218 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(10);
	var has = __webpack_require__(18);
	var DESCRIPTORS = __webpack_require__(5);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(99);
	var META = __webpack_require__(40).KEY;
	var $fails = __webpack_require__(19);
	var shared = __webpack_require__(65);
	var setToStringTag = __webpack_require__(39);
	var uid = __webpack_require__(38);
	var wks = __webpack_require__(4);
	var wksExt = __webpack_require__(70);
	var wksDefine = __webpack_require__(71);
	var enumKeys = __webpack_require__(219);
	var isArray = __webpack_require__(104);
	var anObject = __webpack_require__(14);
	var isObject = __webpack_require__(9);
	var toIObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(58);
	var createDesc = __webpack_require__(27);
	var _create = __webpack_require__(36);
	var gOPNExt = __webpack_require__(220);
	var $GOPD = __webpack_require__(57);
	var $DP = __webpack_require__(6);
	var $keys = __webpack_require__(29);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(105).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(35).f = $propertyIsEnumerable;
	  __webpack_require__(72).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(62)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);
	
	
	/***/ }),
	/* 219 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(29);
	var gOPS = __webpack_require__(72);
	var pIE = __webpack_require__(35);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};
	
	
	/***/ }),
	/* 220 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(17);
	var gOPN = __webpack_require__(105).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};
	
	
	/***/ }),
	/* 221 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(71)('asyncIterator');
	
	
	/***/ }),
	/* 222 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(71)('observable');
	
	
	/***/ }),
	/* 223 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(224);
	var $Object = __webpack_require__(2).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};
	
	
	/***/ }),
	/* 224 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperty: __webpack_require__(6).f });
	
	
	/***/ }),
	/* 225 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(226), __esModule: true };
	
	/***/ }),
	/* 226 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(73);
	__webpack_require__(24);
	__webpack_require__(28);
	__webpack_require__(227);
	__webpack_require__(232);
	__webpack_require__(234);
	__webpack_require__(235);
	module.exports = __webpack_require__(2).Map;
	
	
	/***/ }),
	/* 227 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var strong = __webpack_require__(108);
	var validate = __webpack_require__(75);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(113)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);
	
	
	/***/ }),
	/* 228 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var global = __webpack_require__(10);
	var core = __webpack_require__(2);
	var dP = __webpack_require__(6);
	var DESCRIPTORS = __webpack_require__(5);
	var SPECIES = __webpack_require__(4)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};
	
	
	/***/ }),
	/* 229 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(20);
	var IObject = __webpack_require__(54);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(37);
	var asc = __webpack_require__(230);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	
	/***/ }),
	/* 230 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(231);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};
	
	
	/***/ }),
	/* 231 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(9);
	var isArray = __webpack_require__(104);
	var SPECIES = __webpack_require__(4)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};
	
	
	/***/ }),
	/* 232 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(114)('Map') });
	
	
	/***/ }),
	/* 233 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var forOf = __webpack_require__(41);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};
	
	
	/***/ }),
	/* 234 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(115)('Map');
	
	
	/***/ }),
	/* 235 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(116)('Map');
	
	
	/***/ }),
	/* 236 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	/***/ }),
	/* 237 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(238);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(242);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	/***/ }),
	/* 238 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(239), __esModule: true };
	
	/***/ }),
	/* 239 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(240);
	module.exports = __webpack_require__(2).Object.setPrototypeOf;
	
	
	/***/ }),
	/* 240 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(241).set });
	
	
	/***/ }),
	/* 241 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(9);
	var anObject = __webpack_require__(14);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(20)(Function.call, __webpack_require__(57).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};
	
	
	/***/ }),
	/* 242 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(243), __esModule: true };
	
	/***/ }),
	/* 243 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(244);
	var $Object = __webpack_require__(2).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};
	
	
	/***/ }),
	/* 244 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var $export = __webpack_require__(3);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(36) });
	
	
	/***/ }),
	/* 245 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(246), __esModule: true };
	
	/***/ }),
	/* 246 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(247);
	var $Object = __webpack_require__(2).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};
	
	
	/***/ }),
	/* 247 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperties: __webpack_require__(100) });
	
	
	/***/ }),
	/* 248 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(249);
	var isArguments = __webpack_require__(250);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	
	
	/***/ }),
	/* 249 */
	/***/ (function(module, exports) {
	
	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	
	
	/***/ }),
	/* 250 */
	/***/ (function(module, exports) {
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	
	
	/***/ }),
	/* 251 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(252), __esModule: true };
	
	/***/ }),
	/* 252 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(253);
	module.exports = __webpack_require__(2).Object.assign;
	
	
	/***/ }),
	/* 253 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(254) });
	
	
	/***/ }),
	/* 254 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(29);
	var gOPS = __webpack_require__(72);
	var pIE = __webpack_require__(35);
	var toObject = __webpack_require__(30);
	var IObject = __webpack_require__(54);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(19)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;
	
	
	/***/ }),
	/* 255 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(256), __esModule: true };
	
	/***/ }),
	/* 256 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(257);
	module.exports = __webpack_require__(2).String.fromCodePoint;
	
	
	/***/ }),
	/* 257 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var $export = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(102);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});
	
	
	/***/ }),
	/* 258 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(259), __esModule: true };
	
	/***/ }),
	/* 259 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(24);
	__webpack_require__(260);
	module.exports = __webpack_require__(2).Array.from;
	
	
	/***/ }),
	/* 260 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var ctx = __webpack_require__(20);
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(30);
	var call = __webpack_require__(111);
	var isArrayIter = __webpack_require__(112);
	var toLength = __webpack_require__(37);
	var createProperty = __webpack_require__(261);
	var getIterFn = __webpack_require__(67);
	
	$export($export.S + $export.F * !__webpack_require__(262)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});
	
	
	/***/ }),
	/* 261 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $defineProperty = __webpack_require__(6);
	var createDesc = __webpack_require__(27);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};
	
	
	/***/ }),
	/* 262 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var ITERATOR = __webpack_require__(4)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};
	
	
	/***/ }),
	/* 263 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(264), __esModule: true };
	
	/***/ }),
	/* 264 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(73);
	__webpack_require__(24);
	__webpack_require__(28);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	module.exports = __webpack_require__(2).Set;
	
	
	/***/ }),
	/* 265 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var strong = __webpack_require__(108);
	var validate = __webpack_require__(75);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(113)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);
	
	
	/***/ }),
	/* 266 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(114)('Set') });
	
	
	/***/ }),
	/* 267 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(115)('Set');
	
	
	/***/ }),
	/* 268 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(116)('Set');
	
	
	/***/ }),
	/* 269 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.9.1
	var CATEGORY_BITS, CATEGORY_MASK, CATEGORY_SHIFT, COMBINING_BITS, COMBINING_MASK, COMBINING_SHIFT, EAW_BITS, EAW_MASK, EAW_SHIFT, NUMBER_BITS, NUMBER_MASK, SCRIPT_BITS, SCRIPT_MASK, SCRIPT_SHIFT, UnicodeTrie, bits, data, fs, log2, trie;
	
	UnicodeTrie = __webpack_require__(43);
	
	data = __webpack_require__(270);
	
	
	
	trie = new UnicodeTrie(Buffer("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","base64"));
	
	log2 = Math.log2 || function(n) {
	  return Math.log(n) / Math.LN2;
	};
	
	bits = function(n) {
	  return (log2(n) + 1) | 0;
	};
	
	CATEGORY_BITS = bits(data.categories.length - 1);
	
	COMBINING_BITS = bits(data.combiningClasses.length - 1);
	
	SCRIPT_BITS = bits(data.scripts.length - 1);
	
	EAW_BITS = bits(data.eaw.length - 1);
	
	NUMBER_BITS = 10;
	
	CATEGORY_SHIFT = COMBINING_BITS + SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
	
	COMBINING_SHIFT = SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
	
	SCRIPT_SHIFT = EAW_BITS + NUMBER_BITS;
	
	EAW_SHIFT = NUMBER_BITS;
	
	CATEGORY_MASK = (1 << CATEGORY_BITS) - 1;
	
	COMBINING_MASK = (1 << COMBINING_BITS) - 1;
	
	SCRIPT_MASK = (1 << SCRIPT_BITS) - 1;
	
	EAW_MASK = (1 << EAW_BITS) - 1;
	
	NUMBER_MASK = (1 << NUMBER_BITS) - 1;
	
	exports.getCategory = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.categories[(val >> CATEGORY_SHIFT) & CATEGORY_MASK];
	};
	
	exports.getCombiningClass = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.combiningClasses[(val >> COMBINING_SHIFT) & COMBINING_MASK];
	};
	
	exports.getScript = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.scripts[(val >> SCRIPT_SHIFT) & SCRIPT_MASK];
	};
	
	exports.getEastAsianWidth = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.eaw[(val >> EAW_SHIFT) & EAW_MASK];
	};
	
	exports.getNumericValue = function(codePoint) {
	  var denominator, exp, num, numerator, val;
	  val = trie.get(codePoint);
	  num = val & NUMBER_MASK;
	  if (num === 0) {
	    return null;
	  } else if (num <= 50) {
	    return num - 1;
	  } else if (num < 0x1e0) {
	    numerator = (num >> 4) - 12;
	    denominator = (num & 0xf) + 1;
	    return numerator / denominator;
	  } else if (num < 0x300) {
	    val = (num >> 5) - 14;
	    exp = (num & 0x1f) + 2;
	    while (exp > 0) {
	      val *= 10;
	      exp--;
	    }
	    return val;
	  } else {
	    val = (num >> 2) - 0xbf;
	    exp = (num & 3) + 1;
	    while (exp > 0) {
	      val *= 60;
	      exp--;
	    }
	    return val;
	  }
	};
	
	exports.isAlphabetic = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Lu' || ref === 'Ll' || ref === 'Lt' || ref === 'Lm' || ref === 'Lo' || ref === 'Nl';
	};
	
	exports.isDigit = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Nd';
	};
	
	exports.isPunctuation = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Pc' || ref === 'Pd' || ref === 'Pe' || ref === 'Pf' || ref === 'Pi' || ref === 'Po' || ref === 'Ps';
	};
	
	exports.isLowerCase = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Ll';
	};
	
	exports.isUpperCase = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Lu';
	};
	
	exports.isTitleCase = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Lt';
	};
	
	exports.isWhiteSpace = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Zs' || ref === 'Zl' || ref === 'Zp';
	};
	
	exports.isBaseForm = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Nd' || ref === 'No' || ref === 'Nl' || ref === 'Lu' || ref === 'Ll' || ref === 'Lt' || ref === 'Lm' || ref === 'Lo' || ref === 'Me' || ref === 'Mc';
	};
	
	exports.isMark = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Mn' || ref === 'Me' || ref === 'Mc';
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 270 */
	/***/ (function(module, exports) {
	
	module.exports = {"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Tirhuta","Siddham","Modi","Takri","Ahom","Warang_Citi","Pau_Cin_Hau","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Miao","Duployan","SignWriting","Mende_Kikakui"],"eaw":["N","Na","A","W","H","F"]}
	
	/***/ }),
	/* 271 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _slicedToArray = _interopDefault(__webpack_require__(272));
	var _getIterator = _interopDefault(__webpack_require__(60));
	var _defineProperty = _interopDefault(__webpack_require__(276));
	var _regeneratorRuntime = _interopDefault(__webpack_require__(277));
	var _Symbol$iterator = _interopDefault(__webpack_require__(103));
	var _classCallCheck = _interopDefault(__webpack_require__(106));
	var _createClass = _interopDefault(__webpack_require__(107));
	
	var INITIAL_STATE = 1;
	var FAIL_STATE = 0;
	
	/**
	 * A StateMachine represents a deterministic finite automaton.
	 * It can perform matches over a sequence of values, similar to a regular expression.
	 */
	
	var StateMachine = function () {
	  function StateMachine(dfa) {
	    _classCallCheck(this, StateMachine);
	
	    this.stateTable = dfa.stateTable;
	    this.accepting = dfa.accepting;
	    this.tags = dfa.tags;
	  }
	
	  /**
	   * Returns an iterable object that yields pattern matches over the input sequence.
	   * Matches are of the form [startIndex, endIndex, tags].
	   */
	
	
	  _createClass(StateMachine, [{
	    key: 'match',
	    value: function match(str) {
	      var self = this;
	      return _defineProperty({}, _Symbol$iterator, _regeneratorRuntime.mark(function _callee() {
	        var state, startRun, lastAccepting, lastState, p, c;
	        return _regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                state = INITIAL_STATE;
	                startRun = null;
	                lastAccepting = null;
	                lastState = null;
	                p = 0;
	
	              case 5:
	                if (!(p < str.length)) {
	                  _context.next = 21;
	                  break;
	                }
	
	                c = str[p];
	
	
	                lastState = state;
	                state = self.stateTable[state][c];
	
	                if (!(state === FAIL_STATE)) {
	                  _context.next = 15;
	                  break;
	                }
	
	                if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
	                  _context.next = 13;
	                  break;
	                }
	
	                _context.next = 13;
	                return [startRun, lastAccepting, self.tags[lastState]];
	
	              case 13:
	
	                // reset the state as if we started over from the initial state
	                state = self.stateTable[INITIAL_STATE][c];
	                startRun = null;
	
	              case 15:
	
	                // start a run if not in the failure state
	                if (state !== FAIL_STATE && startRun == null) {
	                  startRun = p;
	                }
	
	                // if accepting, mark the potential match end
	                if (self.accepting[state]) {
	                  lastAccepting = p;
	                }
	
	                // reset the state to the initial state if we get into the failure state
	                if (state === FAIL_STATE) {
	                  state = INITIAL_STATE;
	                }
	
	              case 18:
	                p++;
	                _context.next = 5;
	                break;
	
	              case 21:
	                if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
	                  _context.next = 24;
	                  break;
	                }
	
	                _context.next = 24;
	                return [startRun, lastAccepting, self.tags[state]];
	
	              case 24:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	    }
	
	    /**
	     * For each match over the input sequence, action functions matching
	     * the tag definitions in the input pattern are called with the startIndex,
	     * endIndex, and sub-match sequence.
	     */
	
	  }, {
	    key: 'apply',
	    value: function apply(str, actions) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _getIterator(this.match(str)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 3);
	
	          var start = _step$value[0];
	          var end = _step$value[1];
	          var tags = _step$value[2];
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = _getIterator(tags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var tag = _step2.value;
	
	              if (typeof actions[tag] === 'function') {
	                actions[tag](start, end, str.slice(start, end + 1));
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }]);
	
	  return StateMachine;
	}();
	
	module.exports = StateMachine;
	
	
	/***/ }),
	/* 272 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(273);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(60);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	/***/ }),
	/* 273 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(274), __esModule: true };
	
	/***/ }),
	/* 274 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(28);
	__webpack_require__(24);
	module.exports = __webpack_require__(275);
	
	
	/***/ }),
	/* 275 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var classof = __webpack_require__(68);
	var ITERATOR = __webpack_require__(4)('iterator');
	var Iterators = __webpack_require__(23);
	module.exports = __webpack_require__(2).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};
	
	
	/***/ }),
	/* 276 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(74);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	/***/ }),
	/* 277 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(278);
	
	
	/***/ }),
	/* 278 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(279);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	
	/***/ }),
	/* 279 */
	/***/ (function(module, exports) {
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);
	
	
	/***/ }),
	/* 280 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(281), __esModule: true };
	
	/***/ }),
	/* 281 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(282);
	module.exports = Math.pow(2, -52);
	
	
	/***/ }),
	/* 282 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });
	
	
	/***/ }),
	/* 283 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 284 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(117).BrotliDecompressBuffer;
	
	
	/***/ }),
	/* 285 */
	/***/ (function(module, exports) {
	
	/* Copyright 2013 Google Inc. All Rights Reserved.
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	
	   Bit reading helpers
	*/
	
	var BROTLI_READ_SIZE = 4096;
	var BROTLI_IBUF_SIZE =  (2 * BROTLI_READ_SIZE + 32);
	var BROTLI_IBUF_MASK =  (2 * BROTLI_READ_SIZE - 1);
	
	var kBitMask = new Uint32Array([
	  0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767,
	  65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215
	]);
	
	/* Input byte buffer, consist of a ringbuffer and a "slack" region where */
	/* bytes from the start of the ringbuffer are copied. */
	function BrotliBitReader(input) {
	  this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
	  this.input_ = input;    /* input callback */
	  
	  this.reset();
	}
	
	BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
	BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
	
	BrotliBitReader.prototype.reset = function() {
	  this.buf_ptr_ = 0;      /* next input will write here */
	  this.val_ = 0;          /* pre-fetched bits */
	  this.pos_ = 0;          /* byte position in stream */
	  this.bit_pos_ = 0;      /* current bit-reading position in val_ */
	  this.bit_end_pos_ = 0;  /* bit-reading end position from LSB of val_ */
	  this.eos_ = 0;          /* input stream is finished */
	  
	  this.readMoreInput();
	  for (var i = 0; i < 4; i++) {
	    this.val_ |= this.buf_[this.pos_] << (8 * i);
	    ++this.pos_;
	  }
	  
	  return this.bit_end_pos_ > 0;
	};
	
	/* Fills up the input ringbuffer by calling the input callback.
	
	   Does nothing if there are at least 32 bytes present after current position.
	
	   Returns 0 if either:
	    - the input callback returned an error, or
	    - there is no more input and the position is past the end of the stream.
	
	   After encountering the end of the input stream, 32 additional zero bytes are
	   copied to the ringbuffer, therefore it is safe to call this function after
	   every 32 bytes of input is read.
	*/
	BrotliBitReader.prototype.readMoreInput = function() {
	  if (this.bit_end_pos_ > 256) {
	    return;
	  } else if (this.eos_) {
	    if (this.bit_pos_ > this.bit_end_pos_)
	      throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
	  } else {
	    var dst = this.buf_ptr_;
	    var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
	    if (bytes_read < 0) {
	      throw new Error('Unexpected end of input');
	    }
	    
	    if (bytes_read < BROTLI_READ_SIZE) {
	      this.eos_ = 1;
	      /* Store 32 bytes of zero after the stream end. */
	      for (var p = 0; p < 32; p++)
	        this.buf_[dst + bytes_read + p] = 0;
	    }
	    
	    if (dst === 0) {
	      /* Copy the head of the ringbuffer to the slack region. */
	      for (var p = 0; p < 32; p++)
	        this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
	
	      this.buf_ptr_ = BROTLI_READ_SIZE;
	    } else {
	      this.buf_ptr_ = 0;
	    }
	    
	    this.bit_end_pos_ += bytes_read << 3;
	  }
	};
	
	/* Guarantees that there are at least 24 bits in the buffer. */
	BrotliBitReader.prototype.fillBitWindow = function() {    
	  while (this.bit_pos_ >= 8) {
	    this.val_ >>>= 8;
	    this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
	    ++this.pos_;
	    this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
	    this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
	  }
	};
	
	/* Reads the specified number of bits from Read Buffer. */
	BrotliBitReader.prototype.readBits = function(n_bits) {
	  if (32 - this.bit_pos_ < n_bits) {
	    this.fillBitWindow();
	  }
	  
	  var val = ((this.val_ >>> this.bit_pos_) & kBitMask[n_bits]);
	  this.bit_pos_ += n_bits;
	  return val;
	};
	
	module.exports = BrotliBitReader;
	
	
	/***/ }),
	/* 286 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var base64 = __webpack_require__(287);
	var fs = __webpack_require__(8);
	
	/**
	 * The normal dictionary-data.js is quite large, which makes it 
	 * unsuitable for browser usage. In order to make it smaller, 
	 * we read dictionary.bin, which is a compressed version of
	 * the dictionary, and on initial load, Brotli decompresses 
	 * it's own dictionary. 😜
	 */
	exports.init = function() {
	  var BrotliDecompressBuffer = __webpack_require__(117).BrotliDecompressBuffer;
	  var compressed = base64.toByteArray(__webpack_require__(288));
	  return BrotliDecompressBuffer(compressed);
	};
	
	
	/***/ }),
	/* 287 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}
	
	
	/***/ }),
	/* 288 */
	/***/ (function(module, exports) {
	
	module.exports="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";
	
	
	/***/ }),
	/* 289 */
	/***/ (function(module, exports) {
	
	/* Copyright 2013 Google Inc. All Rights Reserved.
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	
	   Lookup table to map the previous two bytes to a context id.
	
	   There are four different context modeling modes defined here:
	     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
	     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
	     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
	     CONTEXT_SIGNED: second-order context model tuned for signed integers.
	
	   The context id for the UTF8 context model is calculated as follows. If p1
	   and p2 are the previous two bytes, we calcualte the context as
	
	     context = kContextLookup[p1] | kContextLookup[p2 + 256].
	
	   If the previous two bytes are ASCII characters (i.e. < 128), this will be
	   equivalent to
	
	     context = 4 * context1(p1) + context2(p2),
	
	   where context1 is based on the previous byte in the following way:
	
	     0  : non-ASCII control
	     1  : \t, \n, \r
	     2  : space
	     3  : other punctuation
	     4  : " '
	     5  : %
	     6  : ( < [ {
	     7  : ) > ] }
	     8  : , ; :
	     9  : .
	     10 : =
	     11 : number
	     12 : upper-case vowel
	     13 : upper-case consonant
	     14 : lower-case vowel
	     15 : lower-case consonant
	
	   and context2 is based on the second last byte:
	
	     0 : control, space
	     1 : punctuation
	     2 : upper-case letter, number
	     3 : lower-case letter
	
	   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
	   stream it will be a continuation byte, value between 128 and 191), the
	   context is the same as if the second last byte was an ASCII control or space.
	
	   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
	   be a continuation byte and the context id is 2 or 3 depending on the LSB of
	   the last byte and to a lesser extent on the second last byte if it is ASCII.
	
	   If the last byte is a UTF8 continuation byte, the second last byte can be:
	     - continuation byte: the next byte is probably ASCII or lead byte (assuming
	       4-byte UTF8 characters are rare) and the context id is 0 or 1.
	     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
	     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3
	
	   The possible value combinations of the previous two bytes, the range of
	   context ids and the type of the next byte is summarized in the table below:
	
	   |--------\-----------------------------------------------------------------|
	   |         \                         Last byte                              |
	   | Second   \---------------------------------------------------------------|
	   | last byte \    ASCII            |   cont. byte        |   lead byte      |
	   |            \   (0-127)          |   (128-191)         |   (192-)         |
	   |=============|===================|=====================|==================|
	   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
	   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
	   |-------------|-------------------|---------------------|------------------|
	   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
	   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
	   |-------------|-------------------|---------------------|------------------|
	   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
	   |  (192-207)  |                   |  context: 0 - 1     |                  |
	   |-------------|-------------------|---------------------|------------------|
	   |  lead byte  | not valid         |  next: cont.        |  not valid       |
	   |  (208-)     |                   |  context: 2 - 3     |                  |
	   |-------------|-------------------|---------------------|------------------|
	
	   The context id for the signed context mode is calculated as:
	
	     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].
	
	   For any context modeling modes, the context ids can be calculated by |-ing
	   together two lookups from one table using context model dependent offsets:
	
	     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].
	
	   where offset1 and offset2 are dependent on the context mode.
	*/
	
	var CONTEXT_LSB6         = 0;
	var CONTEXT_MSB6         = 1;
	var CONTEXT_UTF8         = 2;
	var CONTEXT_SIGNED       = 3;
	
	/* Common context lookup table for all context modes. */
	exports.lookup = new Uint8Array([
	  /* CONTEXT_UTF8, last byte. */
	  /* ASCII range. */
	   0,  0,  0,  0,  0,  0,  0,  0,  0,  4,  4,  0,  0,  4,  0,  0,
	   0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,
	   8, 12, 16, 12, 12, 20, 12, 16, 24, 28, 12, 12, 32, 12, 36, 12,
	  44, 44, 44, 44, 44, 44, 44, 44, 44, 44, 32, 32, 24, 40, 28, 12,
	  12, 48, 52, 52, 52, 48, 52, 52, 52, 48, 52, 52, 52, 52, 52, 48,
	  52, 52, 52, 52, 52, 48, 52, 52, 52, 52, 52, 24, 12, 28, 12, 12,
	  12, 56, 60, 60, 60, 56, 60, 60, 60, 56, 60, 60, 60, 60, 60, 56,
	  60, 60, 60, 60, 60, 56, 60, 60, 60, 60, 60, 24, 12, 28, 12,  0,
	  /* UTF8 continuation byte range. */
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  /* UTF8 lead byte range. */
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  /* CONTEXT_UTF8 second last byte. */
	  /* ASCII range. */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1,
	  1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1,
	  1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 0,
	  /* UTF8 continuation byte range. */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  /* UTF8 lead byte range. */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  /* CONTEXT_SIGNED, second last byte. */
	  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
	  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
	  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
	  6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7,
	  /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
	   0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
	  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
	  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
	  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
	  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
	  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
	  48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 56,
	  /* CONTEXT_LSB6, last byte. */
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	  /* CONTEXT_MSB6, last byte. */
	   0,  0,  0,  0,  1,  1,  1,  1,  2,  2,  2,  2,  3,  3,  3,  3,
	   4,  4,  4,  4,  5,  5,  5,  5,  6,  6,  6,  6,  7,  7,  7,  7,
	   8,  8,  8,  8,  9,  9,  9,  9, 10, 10, 10, 10, 11, 11, 11, 11,
	  12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15,
	  16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19,
	  20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23, 23,
	  24, 24, 24, 24, 25, 25, 25, 25, 26, 26, 26, 26, 27, 27, 27, 27,
	  28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 31, 31, 31, 31,
	  32, 32, 32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 35, 35,
	  36, 36, 36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 39, 39, 39, 39,
	  40, 40, 40, 40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43, 43,
	  44, 44, 44, 44, 45, 45, 45, 45, 46, 46, 46, 46, 47, 47, 47, 47,
	  48, 48, 48, 48, 49, 49, 49, 49, 50, 50, 50, 50, 51, 51, 51, 51,
	  52, 52, 52, 52, 53, 53, 53, 53, 54, 54, 54, 54, 55, 55, 55, 55,
	  56, 56, 56, 56, 57, 57, 57, 57, 58, 58, 58, 58, 59, 59, 59, 59,
	  60, 60, 60, 60, 61, 61, 61, 61, 62, 62, 62, 62, 63, 63, 63, 63,
	  /* CONTEXT_{M,L}SB6, second last byte, */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	]);
	
	exports.lookupOffsets = new Uint16Array([
	  /* CONTEXT_LSB6 */
	  1024, 1536,
	  /* CONTEXT_MSB6 */
	  1280, 1536,
	  /* CONTEXT_UTF8 */
	  0, 256,
	  /* CONTEXT_SIGNED */
	  768, 512,
	]);
	
	
	/***/ }),
	/* 290 */
	/***/ (function(module, exports) {
	
	/* Copyright 2013 Google Inc. All Rights Reserved.
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	
	   Lookup tables to map prefix codes to value ranges. This is used during
	   decoding of the block lengths, literal insertion lengths and copy lengths.
	*/
	
	/* Represents the range of values belonging to a prefix code: */
	/* [offset, offset + 2^nbits) */
	function PrefixCodeRange(offset, nbits) {
	  this.offset = offset;
	  this.nbits = nbits;
	}
	
	exports.kBlockLengthPrefixCode = [
	  new PrefixCodeRange(1, 2), new PrefixCodeRange(5, 2), new PrefixCodeRange(9, 2), new PrefixCodeRange(13, 2),
	  new PrefixCodeRange(17, 3), new PrefixCodeRange(25, 3), new PrefixCodeRange(33, 3), new PrefixCodeRange(41, 3),
	  new PrefixCodeRange(49, 4), new PrefixCodeRange(65, 4), new PrefixCodeRange(81, 4), new PrefixCodeRange(97, 4),
	  new PrefixCodeRange(113, 5), new PrefixCodeRange(145, 5), new PrefixCodeRange(177, 5), new PrefixCodeRange(209, 5),
	  new PrefixCodeRange(241, 6), new PrefixCodeRange(305, 6), new PrefixCodeRange(369, 7), new PrefixCodeRange(497, 8),
	  new PrefixCodeRange(753, 9), new PrefixCodeRange(1265, 10), new PrefixCodeRange(2289, 11), new PrefixCodeRange(4337, 12),
	  new PrefixCodeRange(8433, 13), new PrefixCodeRange(16625, 24)
	];
	
	exports.kInsertLengthPrefixCode = [
	  new PrefixCodeRange(0, 0), new PrefixCodeRange(1, 0), new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0),
	  new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0), new PrefixCodeRange(6, 1), new PrefixCodeRange(8, 1),
	  new PrefixCodeRange(10, 2), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 3), new PrefixCodeRange(26, 3),
	  new PrefixCodeRange(34, 4), new PrefixCodeRange(50, 4), new PrefixCodeRange(66, 5), new PrefixCodeRange(98, 5),
	  new PrefixCodeRange(130, 6), new PrefixCodeRange(194, 7), new PrefixCodeRange(322, 8), new PrefixCodeRange(578, 9),
	  new PrefixCodeRange(1090, 10), new PrefixCodeRange(2114, 12), new PrefixCodeRange(6210, 14), new PrefixCodeRange(22594, 24),
	];
	
	exports.kCopyLengthPrefixCode = [
	  new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0), new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0),
	  new PrefixCodeRange(6, 0), new PrefixCodeRange(7, 0), new PrefixCodeRange(8, 0), new PrefixCodeRange(9, 0),
	  new PrefixCodeRange(10, 1), new PrefixCodeRange(12, 1), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 2),
	  new PrefixCodeRange(22, 3), new PrefixCodeRange(30, 3), new PrefixCodeRange(38, 4), new PrefixCodeRange(54, 4),
	  new PrefixCodeRange(70, 5), new PrefixCodeRange(102, 5), new PrefixCodeRange(134, 6), new PrefixCodeRange(198, 7),
	  new PrefixCodeRange(326, 8), new PrefixCodeRange(582, 9), new PrefixCodeRange(1094, 10), new PrefixCodeRange(2118, 24),
	];
	
	exports.kInsertRangeLut = [
	  0, 0, 8, 8, 0, 16, 8, 16, 16,
	];
	
	exports.kCopyRangeLut = [
	  0, 8, 0, 8, 16, 0, 16, 8, 16,
	];
	
	
	/***/ }),
	/* 291 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* Copyright 2013 Google Inc. All Rights Reserved.
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	
	   Transformations on dictionary words.
	*/
	
	var BrotliDictionary = __webpack_require__(119);
	
	var kIdentity       = 0;
	var kOmitLast1      = 1;
	var kOmitLast2      = 2;
	var kOmitLast3      = 3;
	var kOmitLast4      = 4;
	var kOmitLast5      = 5;
	var kOmitLast6      = 6;
	var kOmitLast7      = 7;
	var kOmitLast8      = 8;
	var kOmitLast9      = 9;
	var kUppercaseFirst = 10;
	var kUppercaseAll   = 11;
	var kOmitFirst1     = 12;
	var kOmitFirst2     = 13;
	var kOmitFirst3     = 14;
	var kOmitFirst4     = 15;
	var kOmitFirst5     = 16;
	var kOmitFirst6     = 17;
	var kOmitFirst7     = 18;
	var kOmitFirst8     = 19;
	var kOmitFirst9     = 20;
	
	function Transform(prefix, transform, suffix) {
	  this.prefix = new Uint8Array(prefix.length);
	  this.transform = transform;
	  this.suffix = new Uint8Array(suffix.length);
	  
	  for (var i = 0; i < prefix.length; i++)
	    this.prefix[i] = prefix.charCodeAt(i);
	  
	  for (var i = 0; i < suffix.length; i++)
	    this.suffix[i] = suffix.charCodeAt(i);
	}
	
	var kTransforms = [
	     new Transform(         "", kIdentity,       ""           ),
	     new Transform(         "", kIdentity,       " "          ),
	     new Transform(        " ", kIdentity,       " "          ),
	     new Transform(         "", kOmitFirst1,     ""           ),
	     new Transform(         "", kUppercaseFirst, " "          ),
	     new Transform(         "", kIdentity,       " the "      ),
	     new Transform(        " ", kIdentity,       ""           ),
	     new Transform(       "s ", kIdentity,       " "          ),
	     new Transform(         "", kIdentity,       " of "       ),
	     new Transform(         "", kUppercaseFirst, ""           ),
	     new Transform(         "", kIdentity,       " and "      ),
	     new Transform(         "", kOmitFirst2,     ""           ),
	     new Transform(         "", kOmitLast1,      ""           ),
	     new Transform(       ", ", kIdentity,       " "          ),
	     new Transform(         "", kIdentity,       ", "         ),
	     new Transform(        " ", kUppercaseFirst, " "          ),
	     new Transform(         "", kIdentity,       " in "       ),
	     new Transform(         "", kIdentity,       " to "       ),
	     new Transform(       "e ", kIdentity,       " "          ),
	     new Transform(         "", kIdentity,       "\""         ),
	     new Transform(         "", kIdentity,       "."          ),
	     new Transform(         "", kIdentity,       "\">"        ),
	     new Transform(         "", kIdentity,       "\n"         ),
	     new Transform(         "", kOmitLast3,      ""           ),
	     new Transform(         "", kIdentity,       "]"          ),
	     new Transform(         "", kIdentity,       " for "      ),
	     new Transform(         "", kOmitFirst3,     ""           ),
	     new Transform(         "", kOmitLast2,      ""           ),
	     new Transform(         "", kIdentity,       " a "        ),
	     new Transform(         "", kIdentity,       " that "     ),
	     new Transform(        " ", kUppercaseFirst, ""           ),
	     new Transform(         "", kIdentity,       ". "         ),
	     new Transform(        ".", kIdentity,       ""           ),
	     new Transform(        " ", kIdentity,       ", "         ),
	     new Transform(         "", kOmitFirst4,     ""           ),
	     new Transform(         "", kIdentity,       " with "     ),
	     new Transform(         "", kIdentity,       "'"          ),
	     new Transform(         "", kIdentity,       " from "     ),
	     new Transform(         "", kIdentity,       " by "       ),
	     new Transform(         "", kOmitFirst5,     ""           ),
	     new Transform(         "", kOmitFirst6,     ""           ),
	     new Transform(    " the ", kIdentity,       ""           ),
	     new Transform(         "", kOmitLast4,      ""           ),
	     new Transform(         "", kIdentity,       ". The "     ),
	     new Transform(         "", kUppercaseAll,   ""           ),
	     new Transform(         "", kIdentity,       " on "       ),
	     new Transform(         "", kIdentity,       " as "       ),
	     new Transform(         "", kIdentity,       " is "       ),
	     new Transform(         "", kOmitLast7,      ""           ),
	     new Transform(         "", kOmitLast1,      "ing "       ),
	     new Transform(         "", kIdentity,       "\n\t"       ),
	     new Transform(         "", kIdentity,       ":"          ),
	     new Transform(        " ", kIdentity,       ". "         ),
	     new Transform(         "", kIdentity,       "ed "        ),
	     new Transform(         "", kOmitFirst9,     ""           ),
	     new Transform(         "", kOmitFirst7,     ""           ),
	     new Transform(         "", kOmitLast6,      ""           ),
	     new Transform(         "", kIdentity,       "("          ),
	     new Transform(         "", kUppercaseFirst, ", "         ),
	     new Transform(         "", kOmitLast8,      ""           ),
	     new Transform(         "", kIdentity,       " at "       ),
	     new Transform(         "", kIdentity,       "ly "        ),
	     new Transform(    " the ", kIdentity,       " of "       ),
	     new Transform(         "", kOmitLast5,      ""           ),
	     new Transform(         "", kOmitLast9,      ""           ),
	     new Transform(        " ", kUppercaseFirst, ", "         ),
	     new Transform(         "", kUppercaseFirst, "\""         ),
	     new Transform(        ".", kIdentity,       "("          ),
	     new Transform(         "", kUppercaseAll,   " "          ),
	     new Transform(         "", kUppercaseFirst, "\">"        ),
	     new Transform(         "", kIdentity,       "=\""        ),
	     new Transform(        " ", kIdentity,       "."          ),
	     new Transform(    ".com/", kIdentity,       ""           ),
	     new Transform(    " the ", kIdentity,       " of the "   ),
	     new Transform(         "", kUppercaseFirst, "'"          ),
	     new Transform(         "", kIdentity,       ". This "    ),
	     new Transform(         "", kIdentity,       ","          ),
	     new Transform(        ".", kIdentity,       " "          ),
	     new Transform(         "", kUppercaseFirst, "("          ),
	     new Transform(         "", kUppercaseFirst, "."          ),
	     new Transform(         "", kIdentity,       " not "      ),
	     new Transform(        " ", kIdentity,       "=\""        ),
	     new Transform(         "", kIdentity,       "er "        ),
	     new Transform(        " ", kUppercaseAll,   " "          ),
	     new Transform(         "", kIdentity,       "al "        ),
	     new Transform(        " ", kUppercaseAll,   ""           ),
	     new Transform(         "", kIdentity,       "='"         ),
	     new Transform(         "", kUppercaseAll,   "\""         ),
	     new Transform(         "", kUppercaseFirst, ". "         ),
	     new Transform(        " ", kIdentity,       "("          ),
	     new Transform(         "", kIdentity,       "ful "       ),
	     new Transform(        " ", kUppercaseFirst, ". "         ),
	     new Transform(         "", kIdentity,       "ive "       ),
	     new Transform(         "", kIdentity,       "less "      ),
	     new Transform(         "", kUppercaseAll,   "'"          ),
	     new Transform(         "", kIdentity,       "est "       ),
	     new Transform(        " ", kUppercaseFirst, "."          ),
	     new Transform(         "", kUppercaseAll,   "\">"        ),
	     new Transform(        " ", kIdentity,       "='"         ),
	     new Transform(         "", kUppercaseFirst, ","          ),
	     new Transform(         "", kIdentity,       "ize "       ),
	     new Transform(         "", kUppercaseAll,   "."          ),
	     new Transform( "\xc2\xa0", kIdentity,       ""           ),
	     new Transform(        " ", kIdentity,       ","          ),
	     new Transform(         "", kUppercaseFirst, "=\""        ),
	     new Transform(         "", kUppercaseAll,   "=\""        ),
	     new Transform(         "", kIdentity,       "ous "       ),
	     new Transform(         "", kUppercaseAll,   ", "         ),
	     new Transform(         "", kUppercaseFirst, "='"         ),
	     new Transform(        " ", kUppercaseFirst, ","          ),
	     new Transform(        " ", kUppercaseAll,   "=\""        ),
	     new Transform(        " ", kUppercaseAll,   ", "         ),
	     new Transform(         "", kUppercaseAll,   ","          ),
	     new Transform(         "", kUppercaseAll,   "("          ),
	     new Transform(         "", kUppercaseAll,   ". "         ),
	     new Transform(        " ", kUppercaseAll,   "."          ),
	     new Transform(         "", kUppercaseAll,   "='"         ),
	     new Transform(        " ", kUppercaseAll,   ". "         ),
	     new Transform(        " ", kUppercaseFirst, "=\""        ),
	     new Transform(        " ", kUppercaseAll,   "='"         ),
	     new Transform(        " ", kUppercaseFirst, "='"         )
	];
	
	exports.kTransforms = kTransforms;
	exports.kNumTransforms = kTransforms.length;
	
	function ToUpperCase(p, i) {
	  if (p[i] < 0xc0) {
	    if (p[i] >= 97 && p[i] <= 122) {
	      p[i] ^= 32;
	    }
	    return 1;
	  }
	  
	  /* An overly simplified uppercasing model for utf-8. */
	  if (p[i] < 0xe0) {
	    p[i + 1] ^= 32;
	    return 2;
	  }
	  
	  /* An arbitrary transform for three byte characters. */
	  p[i + 2] ^= 5;
	  return 3;
	}
	
	exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
	  var prefix = kTransforms[transform].prefix;
	  var suffix = kTransforms[transform].suffix;
	  var t = kTransforms[transform].transform;
	  var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
	  var i = 0;
	  var start_idx = idx;
	  var uppercase;
	  
	  if (skip > len) {
	    skip = len;
	  }
	  
	  var prefix_pos = 0;
	  while (prefix_pos < prefix.length) {
	    dst[idx++] = prefix[prefix_pos++];
	  }
	  
	  word += skip;
	  len -= skip;
	  
	  if (t <= kOmitLast9) {
	    len -= t;
	  }
	  
	  for (i = 0; i < len; i++) {
	    dst[idx++] = BrotliDictionary.dictionary[word + i];
	  }
	  
	  uppercase = idx - len;
	  
	  if (t === kUppercaseFirst) {
	    ToUpperCase(dst, uppercase);
	  } else if (t === kUppercaseAll) {
	    while (len > 0) {
	      var step = ToUpperCase(dst, uppercase);
	      uppercase += step;
	      len -= step;
	    }
	  }
	  
	  var suffix_pos = 0;
	  while (suffix_pos < suffix.length) {
	    dst[idx++] = suffix[suffix_pos++];
	  }
	  
	  return idx - start_idx;
	}
	
	
	/***/ }),
	/* 292 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(__dirname) {// Generated by CoffeeScript 1.12.6
	(function() {
	  var AFMFont, PDFFont, StandardFont, fs,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  AFMFont = __webpack_require__(293);
	
	  PDFFont = __webpack_require__(50);
	
	  fs = __webpack_require__(8);
	
	  StandardFont = (function(superClass) {
	    var STANDARD_FONTS;
	
	    extend(StandardFont, superClass);
	
	    function StandardFont(document, name1, id) {
	      var ref;
	      this.document = document;
	      this.name = name1;
	      this.id = id;
	      this.font = new AFMFont(STANDARD_FONTS[this.name]());
	      ref = this.font, this.ascender = ref.ascender, this.descender = ref.descender, this.bbox = ref.bbox, this.lineGap = ref.lineGap;
	    }
	
	    StandardFont.prototype.embed = function() {
	      this.dictionary.data = {
	        Type: 'Font',
	        BaseFont: this.name,
	        Subtype: 'Type1',
	        Encoding: 'WinAnsiEncoding'
	      };
	      return this.dictionary.end();
	    };
	
	    StandardFont.prototype.encode = function(text) {
	      var advances, encoded, glyph, glyphs, i, j, len, positions;
	      encoded = this.font.encodeText(text);
	      glyphs = this.font.glyphsForString('' + text);
	      advances = this.font.advancesForGlyphs(glyphs);
	      positions = [];
	      for (i = j = 0, len = glyphs.length; j < len; i = ++j) {
	        glyph = glyphs[i];
	        positions.push({
	          xAdvance: advances[i],
	          yAdvance: 0,
	          xOffset: 0,
	          yOffset: 0,
	          advanceWidth: this.font.widthOfGlyph(glyph)
	        });
	      }
	      return [encoded, positions];
	    };
	
	    StandardFont.prototype.widthOfString = function(string, size) {
	      var advance, advances, glyphs, j, len, scale, width;
	      glyphs = this.font.glyphsForString('' + string);
	      advances = this.font.advancesForGlyphs(glyphs);
	      width = 0;
	      for (j = 0, len = advances.length; j < len; j++) {
	        advance = advances[j];
	        width += advance;
	      }
	      scale = size / 1000;
	      return width * scale;
	    };
	
	    StandardFont.isStandardFont = function(name) {
	      return name in STANDARD_FONTS;
	    };
	
	    STANDARD_FONTS = {
	      "Courier": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier.afm", 'utf8');
	      },
	      "Courier-Bold": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier-Bold.afm", 'utf8');
	      },
	      "Courier-Oblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier-Oblique.afm", 'utf8');
	      },
	      "Courier-BoldOblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier-BoldOblique.afm", 'utf8');
	      },
	      "Helvetica": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica.afm", 'utf8');
	      },
	      "Helvetica-Bold": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica-Bold.afm", 'utf8');
	      },
	      "Helvetica-Oblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica-Oblique.afm", 'utf8');
	      },
	      "Helvetica-BoldOblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica-BoldOblique.afm", 'utf8');
	      },
	      "Times-Roman": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-Roman.afm", 'utf8');
	      },
	      "Times-Bold": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-Bold.afm", 'utf8');
	      },
	      "Times-Italic": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-Italic.afm", 'utf8');
	      },
	      "Times-BoldItalic": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-BoldItalic.afm", 'utf8');
	      },
	      "Symbol": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Symbol.afm", 'utf8');
	      },
	      "ZapfDingbats": function() {
	        return fs.readFileSync(__dirname + "/../font/data/ZapfDingbats.afm", 'utf8');
	      }
	    };
	
	    return StandardFont;
	
	  })(PDFFont);
	
	  module.exports = StandardFont;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))
	
	/***/ }),
	/* 293 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var AFMFont, fs;
	
	  fs = __webpack_require__(8);
	
	  AFMFont = (function() {
	    var WIN_ANSI_MAP, characters;
	
	    AFMFont.open = function(filename) {
	      return new AFMFont(fs.readFileSync(filename, 'utf8'));
	    };
	
	    function AFMFont(contents) {
	      var e, i;
	      this.contents = contents;
	      this.attributes = {};
	      this.glyphWidths = {};
	      this.boundingBoxes = {};
	      this.kernPairs = {};
	      this.parse();
	      this.charWidths = (function() {
	        var j, results;
	        results = [];
	        for (i = j = 0; j <= 255; i = ++j) {
	          results.push(this.glyphWidths[characters[i]]);
	        }
	        return results;
	      }).call(this);
	      this.bbox = (function() {
	        var j, len, ref, results;
	        ref = this.attributes['FontBBox'].split(/\s+/);
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          e = ref[j];
	          results.push(+e);
	        }
	        return results;
	      }).call(this);
	      this.ascender = +(this.attributes['Ascender'] || 0);
	      this.descender = +(this.attributes['Descender'] || 0);
	      this.lineGap = (this.bbox[3] - this.bbox[1]) - (this.ascender - this.descender);
	    }
	
	    AFMFont.prototype.parse = function() {
	      var a, j, key, len, line, match, name, ref, section, value;
	      section = '';
	      ref = this.contents.split('\n');
	      for (j = 0, len = ref.length; j < len; j++) {
	        line = ref[j];
	        if (match = line.match(/^Start(\w+)/)) {
	          section = match[1];
	          continue;
	        } else if (match = line.match(/^End(\w+)/)) {
	          section = '';
	          continue;
	        }
	        switch (section) {
	          case 'FontMetrics':
	            match = line.match(/(^\w+)\s+(.*)/);
	            key = match[1];
	            value = match[2];
	            if (a = this.attributes[key]) {
	              if (!Array.isArray(a)) {
	                a = this.attributes[key] = [a];
	              }
	              a.push(value);
	            } else {
	              this.attributes[key] = value;
	            }
	            break;
	          case 'CharMetrics':
	            if (!/^CH?\s/.test(line)) {
	              continue;
	            }
	            name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
	            this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
	            break;
	          case 'KernPairs':
	            match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
	            if (match) {
	              this.kernPairs[match[1] + '\0' + match[2]] = parseInt(match[3]);
	            }
	        }
	      }
	    };
	
	    WIN_ANSI_MAP = {
	      402: 131,
	      8211: 150,
	      8212: 151,
	      8216: 145,
	      8217: 146,
	      8218: 130,
	      8220: 147,
	      8221: 148,
	      8222: 132,
	      8224: 134,
	      8225: 135,
	      8226: 149,
	      8230: 133,
	      8364: 128,
	      8240: 137,
	      8249: 139,
	      8250: 155,
	      710: 136,
	      8482: 153,
	      338: 140,
	      339: 156,
	      732: 152,
	      352: 138,
	      353: 154,
	      376: 159,
	      381: 142,
	      382: 158
	    };
	
	    AFMFont.prototype.encodeText = function(text) {
	      var char, i, j, ref, res;
	      res = [];
	      for (i = j = 0, ref = text.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        char = text.charCodeAt(i);
	        char = WIN_ANSI_MAP[char] || char;
	        res.push(char.toString(16));
	      }
	      return res;
	    };
	
	    AFMFont.prototype.glyphsForString = function(string) {
	      var charCode, glyphs, i, j, ref;
	      glyphs = [];
	      for (i = j = 0, ref = string.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        charCode = string.charCodeAt(i);
	        glyphs.push(this.characterToGlyph(charCode));
	      }
	      return glyphs;
	    };
	
	    AFMFont.prototype.characterToGlyph = function(character) {
	      return characters[WIN_ANSI_MAP[character] || character] || '.notdef';
	    };
	
	    AFMFont.prototype.widthOfGlyph = function(glyph) {
	      return this.glyphWidths[glyph] || 0;
	    };
	
	    AFMFont.prototype.getKernPair = function(left, right) {
	      return this.kernPairs[left + '\0' + right] || 0;
	    };
	
	    AFMFont.prototype.advancesForGlyphs = function(glyphs) {
	      var advances, index, j, left, len, right;
	      advances = [];
	      for (index = j = 0, len = glyphs.length; j < len; index = ++j) {
	        left = glyphs[index];
	        right = glyphs[index + 1];
	        advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
	      }
	      return advances;
	    };
	
	    characters = '.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis'.split(/\s+/);
	
	    return AFMFont;
	
	  })();
	
	  module.exports = AFMFont;
	
	}).call(this);
	
	
	/***/ }),
	/* 294 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var EmbeddedFont, PDFFont, PDFObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty,
	    slice = [].slice;
	
	  PDFFont = __webpack_require__(50);
	
	  PDFObject = __webpack_require__(26);
	
	  EmbeddedFont = (function(superClass) {
	    var toHex;
	
	    extend(EmbeddedFont, superClass);
	
	    function EmbeddedFont(document, font, id) {
	      this.document = document;
	      this.font = font;
	      this.id = id;
	      this.subset = this.font.createSubset();
	      this.unicode = [[0]];
	      this.widths = [this.font.getGlyph(0).advanceWidth];
	      this.name = this.font.postscriptName;
	      this.scale = 1000 / this.font.unitsPerEm;
	      this.ascender = this.font.ascent * this.scale;
	      this.descender = this.font.descent * this.scale;
	      this.lineGap = this.font.lineGap * this.scale;
	      this.bbox = this.font.bbox;
	      this.layoutCache = Object.create(null);
	    }
	
	    EmbeddedFont.prototype.layoutRun = function(text, features) {
	      var i, j, key, len, position, ref, run;
	      run = this.font.layout(text, features);
	      ref = run.positions;
	      for (i = j = 0, len = ref.length; j < len; i = ++j) {
	        position = ref[i];
	        for (key in position) {
	          position[key] *= this.scale;
	        }
	        position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
	      }
	      return run;
	    };
	
	    EmbeddedFont.prototype.layoutCached = function(text) {
	      var cached, run;
	      if (cached = this.layoutCache[text]) {
	        return cached;
	      }
	      run = this.layoutRun(text);
	      this.layoutCache[text] = run;
	      return run;
	    };
	
	    EmbeddedFont.prototype.layout = function(text, features, onlyWidth) {
	      var advanceWidth, glyphs, index, last, positions, ref, run;
	      if (onlyWidth == null) {
	        onlyWidth = false;
	      }
	      if (features) {
	        return this.layoutRun(text, features);
	      }
	      glyphs = onlyWidth ? null : [];
	      positions = onlyWidth ? null : [];
	      advanceWidth = 0;
	      last = 0;
	      index = 0;
	      while (index <= text.length) {
	        if ((index === text.length && last < index) || ((ref = text.charAt(index)) === ' ' || ref === '\t')) {
	          run = this.layoutCached(text.slice(last, ++index));
	          if (!onlyWidth) {
	            glyphs.push.apply(glyphs, run.glyphs);
	            positions.push.apply(positions, run.positions);
	          }
	          advanceWidth += run.advanceWidth;
	          last = index;
	        } else {
	          index++;
	        }
	      }
	      return {
	        glyphs: glyphs,
	        positions: positions,
	        advanceWidth: advanceWidth
	      };
	    };
	
	    EmbeddedFont.prototype.encode = function(text, features) {
	      var base, base1, gid, glyph, glyphs, i, j, len, positions, ref, res;
	      ref = this.layout(text, features), glyphs = ref.glyphs, positions = ref.positions;
	      res = [];
	      for (i = j = 0, len = glyphs.length; j < len; i = ++j) {
	        glyph = glyphs[i];
	        gid = this.subset.includeGlyph(glyph.id);
	        res.push(('0000' + gid.toString(16)).slice(-4));
	        if ((base = this.widths)[gid] == null) {
	          base[gid] = glyph.advanceWidth * this.scale;
	        }
	        if ((base1 = this.unicode)[gid] == null) {
	          base1[gid] = glyph.codePoints;
	        }
	      }
	      return [res, positions];
	    };
	
	    EmbeddedFont.prototype.widthOfString = function(string, size, features) {
	      var scale, width;
	      width = this.layout(string, features, true).advanceWidth;
	      scale = size / 1000;
	      return width * scale;
	    };
	
	    EmbeddedFont.prototype.embed = function() {
	      var bbox, descendantFont, descriptor, familyClass, flags, fontFile, i, isCFF, name, ref, tag;
	      isCFF = this.subset.cff != null;
	      fontFile = this.document.ref();
	      if (isCFF) {
	        fontFile.data.Subtype = 'CIDFontType0C';
	      }
	      this.subset.encodeStream().pipe(fontFile);
	      familyClass = (((ref = this.font['OS/2']) != null ? ref.sFamilyClass : void 0) || 0) >> 8;
	      flags = 0;
	      if (this.font.post.isFixedPitch) {
	        flags |= 1 << 0;
	      }
	      if ((1 <= familyClass && familyClass <= 7)) {
	        flags |= 1 << 1;
	      }
	      flags |= 1 << 2;
	      if (familyClass === 10) {
	        flags |= 1 << 3;
	      }
	      if (this.font.head.macStyle.italic) {
	        flags |= 1 << 6;
	      }
	      tag = ((function() {
	        var j, results;
	        results = [];
	        for (i = j = 0; j < 6; i = ++j) {
	          results.push(String.fromCharCode(Math.random() * 26 + 65));
	        }
	        return results;
	      })()).join('');
	      name = tag + '+' + this.font.postscriptName;
	      bbox = this.font.bbox;
	      descriptor = this.document.ref({
	        Type: 'FontDescriptor',
	        FontName: name,
	        Flags: flags,
	        FontBBox: [bbox.minX * this.scale, bbox.minY * this.scale, bbox.maxX * this.scale, bbox.maxY * this.scale],
	        ItalicAngle: this.font.italicAngle,
	        Ascent: this.ascender,
	        Descent: this.descender,
	        CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
	        XHeight: (this.font.xHeight || 0) * this.scale,
	        StemV: 0
	      });
	      if (isCFF) {
	        descriptor.data.FontFile3 = fontFile;
	      } else {
	        descriptor.data.FontFile2 = fontFile;
	      }
	      descriptor.end();
	      descendantFont = this.document.ref({
	        Type: 'Font',
	        Subtype: isCFF ? 'CIDFontType0' : 'CIDFontType2',
	        BaseFont: name,
	        CIDSystemInfo: {
	          Registry: new String('Adobe'),
	          Ordering: new String('Identity'),
	          Supplement: 0
	        },
	        FontDescriptor: descriptor,
	        W: [0, this.widths]
	      });
	      descendantFont.end();
	      this.dictionary.data = {
	        Type: 'Font',
	        Subtype: 'Type0',
	        BaseFont: name,
	        Encoding: 'Identity-H',
	        DescendantFonts: [descendantFont],
	        ToUnicode: this.toUnicodeCmap()
	      };
	      return this.dictionary.end();
	    };
	
	    toHex = function() {
	      var code, codePoints, codes;
	      codePoints = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	      codes = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = codePoints.length; j < len; j++) {
	          code = codePoints[j];
	          results.push(('0000' + code.toString(16)).slice(-4));
	        }
	        return results;
	      })();
	      return codes.join('');
	    };
	
	    EmbeddedFont.prototype.toUnicodeCmap = function() {
	      var cmap, codePoints, encoded, entries, j, k, len, len1, ref, value;
	      cmap = this.document.ref();
	      entries = [];
	      ref = this.unicode;
	      for (j = 0, len = ref.length; j < len; j++) {
	        codePoints = ref[j];
	        encoded = [];
	        for (k = 0, len1 = codePoints.length; k < len1; k++) {
	          value = codePoints[k];
	          if (value > 0xffff) {
	            value -= 0x10000;
	            encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
	            value = 0xdc00 | value & 0x3ff;
	          }
	          encoded.push(toHex(value));
	        }
	        entries.push("<" + (encoded.join(' ')) + ">");
	      }
	      cmap.end("/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n1 beginbfrange\n<0000> <" + (toHex(entries.length - 1)) + "> [" + (entries.join(' ')) + "]\nendbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend");
	      return cmap;
	    };
	
	    return EmbeddedFont;
	
	  })(PDFFont);
	
	  module.exports = EmbeddedFont;
	
	}).call(this);
	
	
	/***/ }),
	/* 295 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var LineWrapper, number;
	
	  LineWrapper = __webpack_require__(296);
	
	  number = __webpack_require__(26).number;
	
	  module.exports = {
	    initText: function() {
	      this.x = 0;
	      this.y = 0;
	      return this._lineGap = 0;
	    },
	    lineGap: function(_lineGap) {
	      this._lineGap = _lineGap;
	      return this;
	    },
	    moveDown: function(lines) {
	      if (lines == null) {
	        lines = 1;
	      }
	      this.y += this.currentLineHeight(true) * lines + this._lineGap;
	      return this;
	    },
	    moveUp: function(lines) {
	      if (lines == null) {
	        lines = 1;
	      }
	      this.y -= this.currentLineHeight(true) * lines + this._lineGap;
	      return this;
	    },
	    _text: function(text, x, y, options, lineCallback) {
	      var j, len, line, ref, wrapper;
	      options = this._initOptions(x, y, options);
	      text = text == null ? '' : '' + text;
	      if (options.wordSpacing) {
	        text = text.replace(/\s{2,}/g, ' ');
	      }
	      if (options.width) {
	        wrapper = this._wrapper;
	        if (!wrapper) {
	          wrapper = new LineWrapper(this, options);
	          wrapper.on('line', lineCallback);
	        }
	        this._wrapper = options.continued ? wrapper : null;
	        this._textOptions = options.continued ? options : null;
	        wrapper.wrap(text, options);
	      } else {
	        ref = text.split('\n');
	        for (j = 0, len = ref.length; j < len; j++) {
	          line = ref[j];
	          lineCallback(line, options);
	        }
	      }
	      return this;
	    },
	    text: function(text, x, y, options) {
	      return this._text(text, x, y, options, this._line.bind(this));
	    },
	    widthOfString: function(string, options) {
	      if (options == null) {
	        options = {};
	      }
	      return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
	    },
	    heightOfString: function(text, options) {
	      var height, lineGap, ref, x, y;
	      if (options == null) {
	        options = {};
	      }
	      ref = this, x = ref.x, y = ref.y;
	      options = this._initOptions(options);
	      options.height = 2e308;
	      lineGap = options.lineGap || this._lineGap || 0;
	      this._text(text, this.x, this.y, options, (function(_this) {
	        return function(line, options) {
	          return _this.y += _this.currentLineHeight(true) + lineGap;
	        };
	      })(this));
	      height = this.y - y;
	      this.x = x;
	      this.y = y;
	      return height;
	    },
	    list: function(list, x, y, options, wrapper) {
	      var flatten, i, indent, itemIndent, items, level, levels, midLine, r;
	      options = this._initOptions(x, y, options);
	      midLine = Math.round((this._font.ascender / 1000 * this._fontSize) / 2);
	      r = options.bulletRadius || Math.round((this._font.ascender / 1000 * this._fontSize) / 3);
	      indent = options.textIndent || r * 5;
	      itemIndent = options.bulletIndent || r * 8;
	      level = 1;
	      items = [];
	      levels = [];
	      flatten = function(list) {
	        var i, item, j, len, results;
	        results = [];
	        for (i = j = 0, len = list.length; j < len; i = ++j) {
	          item = list[i];
	          if (Array.isArray(item)) {
	            level++;
	            flatten(item);
	            results.push(level--);
	          } else {
	            items.push(item);
	            results.push(levels.push(level));
	          }
	        }
	        return results;
	      };
	      flatten(list);
	      wrapper = new LineWrapper(this, options);
	      wrapper.on('line', this._line.bind(this));
	      level = 1;
	      i = 0;
	      wrapper.on('firstLine', (function(_this) {
	        return function() {
	          var diff, l;
	          if ((l = levels[i++]) !== level) {
	            diff = itemIndent * (l - level);
	            _this.x += diff;
	            wrapper.lineWidth -= diff;
	            level = l;
	          }
	          _this.circle(_this.x - indent + r, _this.y + midLine, r);
	          return _this.fill();
	        };
	      })(this));
	      wrapper.on('sectionStart', (function(_this) {
	        return function() {
	          var pos;
	          pos = indent + itemIndent * (level - 1);
	          _this.x += pos;
	          return wrapper.lineWidth -= pos;
	        };
	      })(this));
	      wrapper.on('sectionEnd', (function(_this) {
	        return function() {
	          var pos;
	          pos = indent + itemIndent * (level - 1);
	          _this.x -= pos;
	          return wrapper.lineWidth += pos;
	        };
	      })(this));
	      wrapper.wrap(items.join('\n'), options);
	      return this;
	    },
	    _initOptions: function(x, y, options) {
	      var key, ref, val;
	      if (x == null) {
	        x = {};
	      }
	      if (options == null) {
	        options = {};
	      }
	      if (typeof x === 'object') {
	        options = x;
	        x = null;
	      }
	      options = (function() {
	        var k, opts, v;
	        opts = {};
	        for (k in options) {
	          v = options[k];
	          opts[k] = v;
	        }
	        return opts;
	      })();
	      if (this._textOptions) {
	        ref = this._textOptions;
	        for (key in ref) {
	          val = ref[key];
	          if (key !== 'continued') {
	            if (options[key] == null) {
	              options[key] = val;
	            }
	          }
	        }
	      }
	      if (x != null) {
	        this.x = x;
	      }
	      if (y != null) {
	        this.y = y;
	      }
	      if (options.lineBreak !== false) {
	        if (options.width == null) {
	          options.width = this.page.width - this.x - this.page.margins.right;
	        }
	      }
	      options.columns || (options.columns = 0);
	      if (options.columnGap == null) {
	        options.columnGap = 18;
	      }
	      return options;
	    },
	    _line: function(text, options, wrapper) {
	      var lineGap;
	      if (options == null) {
	        options = {};
	      }
	      this._fragment(text, this.x, this.y, options);
	      lineGap = options.lineGap || this._lineGap || 0;
	      if (!wrapper) {
	        return this.x += this.widthOfString(text);
	      } else {
	        return this.y += this.currentLineHeight(true) + lineGap;
	      }
	    },
	    _fragment: function(text, x, y, options) {
	      var addSegment, align, base, characterSpacing, commands, d, encoded, encodedWord, flush, hadOffset, i, j, key, last, len, len1, lineWidth, lineY, m, mode, name, pos, positions, positionsWord, ref, ref1, ref2, renderedWidth, scale, space, spaceWidth, textWidth, val, word, wordSpacing, words;
	      text = ('' + text).replace(/\n/g, '');
	      if (text.length === 0) {
	        return;
	      }
	      align = options.align || 'left';
	      wordSpacing = options.wordSpacing || 0;
	      characterSpacing = options.characterSpacing || 0;
	      if (options.width) {
	        switch (align) {
	          case 'right':
	            textWidth = this.widthOfString(text.replace(/\s+$/, ''), options);
	            x += options.lineWidth - textWidth;
	            break;
	          case 'center':
	            x += options.lineWidth / 2 - options.textWidth / 2;
	            break;
	          case 'justify':
	            words = text.trim().split(/\s+/);
	            textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
	            spaceWidth = this.widthOfString(' ') + characterSpacing;
	            wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
	        }
	      }
	      renderedWidth = options.textWidth + (wordSpacing * (options.wordCount - 1)) + (characterSpacing * (text.length - 1));
	      if (options.link) {
	        this.link(x, y, renderedWidth, this.currentLineHeight(), options.link);
	      }
	      if (options.underline || options.strike) {
	        this.save();
	        if (!options.stroke) {
	          this.strokeColor.apply(this, this._fillColor);
	        }
	        lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
	        this.lineWidth(lineWidth);
	        d = options.underline ? 1 : 2;
	        lineY = y + this.currentLineHeight() / d;
	        if (options.underline) {
	          lineY -= lineWidth;
	        }
	        this.moveTo(x, lineY);
	        this.lineTo(x + renderedWidth, lineY);
	        this.stroke();
	        this.restore();
	      }
	      this.save();
	      this.transform(1, 0, 0, -1, 0, this.page.height);
	      y = this.page.height - y - (this._font.ascender / 1000 * this._fontSize);
	      if ((base = this.page.fonts)[name = this._font.id] == null) {
	        base[name] = this._font.ref();
	      }
	      this.addContent("BT");
	      this.addContent("1 0 0 1 " + (number(x)) + " " + (number(y)) + " Tm");
	      this.addContent("/" + this._font.id + " " + (number(this._fontSize)) + " Tf");
	      mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
	      if (mode) {
	        this.addContent(mode + " Tr");
	      }
	      if (characterSpacing) {
	        this.addContent((number(characterSpacing)) + " Tc");
	      }
	      if (wordSpacing) {
	        words = text.trim().split(/\s+/);
	        wordSpacing += this.widthOfString(' ') + characterSpacing;
	        wordSpacing *= 1000 / this._fontSize;
	        encoded = [];
	        positions = [];
	        for (j = 0, len = words.length; j < len; j++) {
	          word = words[j];
	          ref = this._font.encode(word, options.features), encodedWord = ref[0], positionsWord = ref[1];
	          encoded.push.apply(encoded, encodedWord);
	          positions.push.apply(positions, positionsWord);
	          space = {};
	          ref1 = positions[positions.length - 1];
	          for (key in ref1) {
	            val = ref1[key];
	            space[key] = val;
	          }
	          space.xAdvance += wordSpacing;
	          positions[positions.length - 1] = space;
	        }
	      } else {
	        ref2 = this._font.encode(text, options.features), encoded = ref2[0], positions = ref2[1];
	      }
	      scale = this._fontSize / 1000;
	      commands = [];
	      last = 0;
	      hadOffset = false;
	      addSegment = (function(_this) {
	        return function(cur) {
	          var advance, hex;
	          if (last < cur) {
	            hex = encoded.slice(last, cur).join('');
	            advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
	            commands.push("<" + hex + "> " + (number(-advance)));
	          }
	          return last = cur;
	        };
	      })(this);
	      flush = (function(_this) {
	        return function(i) {
	          addSegment(i);
	          if (commands.length > 0) {
	            _this.addContent("[" + (commands.join(' ')) + "] TJ");
	            return commands.length = 0;
	          }
	        };
	      })(this);
	      for (i = m = 0, len1 = positions.length; m < len1; i = ++m) {
	        pos = positions[i];
	        if (pos.xOffset || pos.yOffset) {
	          flush(i);
	          this.addContent("1 0 0 1 " + (number(x + pos.xOffset * scale)) + " " + (number(y + pos.yOffset * scale)) + " Tm");
	          flush(i + 1);
	          hadOffset = true;
	        } else {
	          if (hadOffset) {
	            this.addContent("1 0 0 1 " + (number(x)) + " " + (number(y)) + " Tm");
	            hadOffset = false;
	          }
	          if (pos.xAdvance - pos.advanceWidth !== 0) {
	            addSegment(i + 1);
	          }
	        }
	        x += pos.xAdvance * scale;
	      }
	      flush(i);
	      this.addContent("ET");
	      return this.restore();
	    }
	  };
	
	}).call(this);
	
	
	/***/ }),
	/* 296 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var EventEmitter, LineBreaker, LineWrapper,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  EventEmitter = __webpack_require__(31).EventEmitter;
	
	  LineBreaker = __webpack_require__(78);
	
	  LineWrapper = (function(superClass) {
	    extend(LineWrapper, superClass);
	
	    function LineWrapper(document, options) {
	      var ref;
	      this.document = document;
	      this.indent = options.indent || 0;
	      this.characterSpacing = options.characterSpacing || 0;
	      this.wordSpacing = options.wordSpacing === 0;
	      this.columns = options.columns || 1;
	      this.columnGap = (ref = options.columnGap) != null ? ref : 18;
	      this.lineWidth = (options.width - (this.columnGap * (this.columns - 1))) / this.columns;
	      this.spaceLeft = this.lineWidth;
	      this.startX = this.document.x;
	      this.startY = this.document.y;
	      this.column = 1;
	      this.ellipsis = options.ellipsis;
	      this.continuedX = 0;
	      this.features = options.features;
	      if (options.height != null) {
	        this.height = options.height;
	        this.maxY = this.startY + options.height;
	      } else {
	        this.maxY = this.document.page.maxY();
	      }
	      this.on('firstLine', (function(_this) {
	        return function(options) {
	          var indent;
	          indent = _this.continuedX || _this.indent;
	          _this.document.x += indent;
	          _this.lineWidth -= indent;
	          return _this.once('line', function() {
	            _this.document.x -= indent;
	            _this.lineWidth += indent;
	            if (options.continued && !_this.continuedX) {
	              _this.continuedX = _this.indent;
	            }
	            if (!options.continued) {
	              return _this.continuedX = 0;
	            }
	          });
	        };
	      })(this));
	      this.on('lastLine', (function(_this) {
	        return function(options) {
	          var align;
	          align = options.align;
	          if (align === 'justify') {
	            options.align = 'left';
	          }
	          _this.lastLine = true;
	          return _this.once('line', function() {
	            _this.document.y += options.paragraphGap || 0;
	            options.align = align;
	            return _this.lastLine = false;
	          });
	        };
	      })(this));
	    }
	
	    LineWrapper.prototype.wordWidth = function(word) {
	      return this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing;
	    };
	
	    LineWrapper.prototype.eachWord = function(text, fn) {
	      var bk, breaker, fbk, l, last, lbk, shouldContinue, w, word, wordWidths;
	      breaker = new LineBreaker(text);
	      last = null;
	      wordWidths = Object.create(null);
	      while (bk = breaker.nextBreak()) {
	        word = text.slice((last != null ? last.position : void 0) || 0, bk.position);
	        w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word);
	        if (w > this.lineWidth + this.continuedX) {
	          lbk = last;
	          fbk = {};
	          while (word.length) {
	            l = word.length;
	            while (w > this.spaceLeft) {
	              w = this.wordWidth(word.slice(0, --l));
	            }
	            fbk.required = l < word.length;
	            shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
	            lbk = {
	              required: false
	            };
	            word = word.slice(l);
	            w = this.wordWidth(word);
	            if (shouldContinue === false) {
	              break;
	            }
	          }
	        } else {
	          shouldContinue = fn(word, w, bk, last);
	        }
	        if (shouldContinue === false) {
	          break;
	        }
	        last = bk;
	      }
	    };
	
	    LineWrapper.prototype.wrap = function(text, options) {
	      var buffer, emitLine, lc, nextY, textWidth, wc, y;
	      if (options.indent != null) {
	        this.indent = options.indent;
	      }
	      if (options.characterSpacing != null) {
	        this.characterSpacing = options.characterSpacing;
	      }
	      if (options.wordSpacing != null) {
	        this.wordSpacing = options.wordSpacing;
	      }
	      if (options.ellipsis != null) {
	        this.ellipsis = options.ellipsis;
	      }
	      nextY = this.document.y + this.document.currentLineHeight(true);
	      if (this.document.y > this.maxY || nextY > this.maxY) {
	        this.nextSection();
	      }
	      buffer = '';
	      textWidth = 0;
	      wc = 0;
	      lc = 0;
	      y = this.document.y;
	      emitLine = (function(_this) {
	        return function() {
	          options.textWidth = textWidth + _this.wordSpacing * (wc - 1);
	          options.wordCount = wc;
	          options.lineWidth = _this.lineWidth;
	          y = _this.document.y;
	          _this.emit('line', buffer, options, _this);
	          return lc++;
	        };
	      })(this);
	      this.emit('sectionStart', options, this);
	      this.eachWord(text, (function(_this) {
	        return function(word, w, bk, last) {
	          var lh, shouldContinue;
	          if ((last == null) || last.required) {
	            _this.emit('firstLine', options, _this);
	            _this.spaceLeft = _this.lineWidth;
	          }
	          if (w <= _this.spaceLeft) {
	            buffer += word;
	            textWidth += w;
	            wc++;
	          }
	          if (bk.required || w > _this.spaceLeft) {
	            if (bk.required) {
	              _this.emit('lastLine', options, _this);
	            }
	            lh = _this.document.currentLineHeight(true);
	            if ((_this.height != null) && _this.ellipsis && _this.document.y + lh * 2 > _this.maxY && _this.column >= _this.columns) {
	              if (_this.ellipsis === true) {
	                _this.ellipsis = '…';
	              }
	              buffer = buffer.replace(/\s+$/, '');
	              textWidth = _this.wordWidth(buffer + _this.ellipsis);
	              while (textWidth > _this.lineWidth) {
	                buffer = buffer.slice(0, -1).replace(/\s+$/, '');
	                textWidth = _this.wordWidth(buffer + _this.ellipsis);
	              }
	              buffer = buffer + _this.ellipsis;
	            }
	            if (bk.required && w > _this.spaceLeft) {
	              buffer = word;
	              textWidth = w;
	              wc = 1;
	            }
	            emitLine();
	            if (_this.document.y + lh > _this.maxY) {
	              shouldContinue = _this.nextSection();
	              if (!shouldContinue) {
	                wc = 0;
	                buffer = '';
	                return false;
	              }
	            }
	            if (bk.required) {
	              _this.spaceLeft = _this.lineWidth;
	              buffer = '';
	              textWidth = 0;
	              return wc = 0;
	            } else {
	              _this.spaceLeft = _this.lineWidth - w;
	              buffer = word;
	              textWidth = w;
	              return wc = 1;
	            }
	          } else {
	            return _this.spaceLeft -= w;
	          }
	        };
	      })(this));
	      if (wc > 0) {
	        this.emit('lastLine', options, this);
	        emitLine();
	      }
	      this.emit('sectionEnd', options, this);
	      if (options.continued === true) {
	        if (lc > 1) {
	          this.continuedX = 0;
	        }
	        this.continuedX += options.textWidth;
	        return this.document.y = y;
	      } else {
	        return this.document.x = this.startX;
	      }
	    };
	
	    LineWrapper.prototype.nextSection = function(options) {
	      var ref;
	      this.emit('sectionEnd', options, this);
	      if (++this.column > this.columns) {
	        if (this.height != null) {
	          return false;
	        }
	        this.document.addPage();
	        this.column = 1;
	        this.startY = this.document.page.margins.top;
	        this.maxY = this.document.page.maxY();
	        this.document.x = this.startX;
	        if (this.document._fillColor) {
	          (ref = this.document).fillColor.apply(ref, this.document._fillColor);
	        }
	        this.emit('pageBreak', options, this);
	      } else {
	        this.document.x += this.lineWidth + this.columnGap;
	        this.document.y = this.startY;
	        this.emit('columnBreak', options, this);
	      }
	      this.emit('sectionStart', options, this);
	      return true;
	    };
	
	    return LineWrapper;
	
	  })(EventEmitter);
	
	  module.exports = LineWrapper;
	
	}).call(this);
	
	
	/***/ }),
	/* 297 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFImage;
	
	  PDFImage = __webpack_require__(121);
	
	  module.exports = {
	    initImages: function() {
	      this._imageRegistry = {};
	      return this._imageCount = 0;
	    },
	    image: function(src, x, y, options) {
	      var base, bh, bp, bw, h, hp, image, ip, name, ref, ref1, ref2, ref3, w, wp;
	      if (options == null) {
	        options = {};
	      }
	      if (typeof x === 'object') {
	        options = x;
	        x = null;
	      }
	      x = (ref = x != null ? x : options.x) != null ? ref : this.x;
	      y = (ref1 = y != null ? y : options.y) != null ? ref1 : this.y;
	      if (typeof src === 'string') {
	        image = this._imageRegistry[src];
	      }
	      if (!image) {
	        if (src.width && src.height) {
	          image = src;
	        } else {
	          image = this.openImage(src);
	        }
	      }
	      if (!image.obj) {
	        image.embed(this);
	      }
	      if ((base = this.page.xobjects)[name = image.label] == null) {
	        base[name] = image.obj;
	      }
	      w = options.width || image.width;
	      h = options.height || image.height;
	      if (options.width && !options.height) {
	        wp = w / image.width;
	        w = image.width * wp;
	        h = image.height * wp;
	      } else if (options.height && !options.width) {
	        hp = h / image.height;
	        w = image.width * hp;
	        h = image.height * hp;
	      } else if (options.scale) {
	        w = image.width * options.scale;
	        h = image.height * options.scale;
	      } else if (options.fit) {
	        ref2 = options.fit, bw = ref2[0], bh = ref2[1];
	        bp = bw / bh;
	        ip = image.width / image.height;
	        if (ip > bp) {
	          w = bw;
	          h = bw / ip;
	        } else {
	          h = bh;
	          w = bh * ip;
	        }
	      } else if (options.cover) {
	        ref3 = options.cover, bw = ref3[0], bh = ref3[1];
	        bp = bw / bh;
	        ip = image.width / image.height;
	        if (ip > bp) {
	          h = bh;
	          w = bh * ip;
	        } else {
	          w = bw;
	          h = bw / ip;
	        }
	      }
	      if (options.fit || options.cover) {
	        if (options.align === 'center') {
	          x = x + bw / 2 - w / 2;
	        } else if (options.align === 'right') {
	          x = x + bw - w;
	        }
	        if (options.valign === 'center') {
	          y = y + bh / 2 - h / 2;
	        } else if (options.valign === 'bottom') {
	          y = y + bh - h;
	        }
	      }
	      if (this.y === y) {
	        this.y += h;
	      }
	      this.save();
	      this.transform(w, 0, 0, -h, x, y + h);
	      this.addContent("/" + image.label + " Do");
	      this.restore();
	      return this;
	    },
	    openImage: function(src) {
	      var image;
	      if (typeof src === 'string') {
	        image = this._imageRegistry[src];
	      }
	      if (!image) {
	        image = PDFImage.open(src, 'I' + (++this._imageCount));
	        if (typeof src === 'string') {
	          this._imageRegistry[src] = image;
	        }
	      }
	      return image;
	    }
	  };
	
	}).call(this);
	
	
	/***/ }),
	/* 298 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var Data;
	
	  Data = (function() {
	    function Data(data) {
	      this.data = data != null ? data : [];
	      this.pos = 0;
	      this.length = this.data.length;
	    }
	
	    Data.prototype.readByte = function() {
	      return this.data[this.pos++];
	    };
	
	    Data.prototype.writeByte = function(byte) {
	      return this.data[this.pos++] = byte;
	    };
	
	    Data.prototype.byteAt = function(index) {
	      return this.data[index];
	    };
	
	    Data.prototype.readBool = function() {
	      return !!this.readByte();
	    };
	
	    Data.prototype.writeBool = function(val) {
	      return this.writeByte(val ? 1 : 0);
	    };
	
	    Data.prototype.readUInt32 = function() {
	      var b1, b2, b3, b4;
	      b1 = this.readByte() * 0x1000000;
	      b2 = this.readByte() << 16;
	      b3 = this.readByte() << 8;
	      b4 = this.readByte();
	      return b1 + b2 + b3 + b4;
	    };
	
	    Data.prototype.writeUInt32 = function(val) {
	      this.writeByte((val >>> 24) & 0xff);
	      this.writeByte((val >> 16) & 0xff);
	      this.writeByte((val >> 8) & 0xff);
	      return this.writeByte(val & 0xff);
	    };
	
	    Data.prototype.readInt32 = function() {
	      var int;
	      int = this.readUInt32();
	      if (int >= 0x80000000) {
	        return int - 0x100000000;
	      } else {
	        return int;
	      }
	    };
	
	    Data.prototype.writeInt32 = function(val) {
	      if (val < 0) {
	        val += 0x100000000;
	      }
	      return this.writeUInt32(val);
	    };
	
	    Data.prototype.readUInt16 = function() {
	      var b1, b2;
	      b1 = this.readByte() << 8;
	      b2 = this.readByte();
	      return b1 | b2;
	    };
	
	    Data.prototype.writeUInt16 = function(val) {
	      this.writeByte((val >> 8) & 0xff);
	      return this.writeByte(val & 0xff);
	    };
	
	    Data.prototype.readInt16 = function() {
	      var int;
	      int = this.readUInt16();
	      if (int >= 0x8000) {
	        return int - 0x10000;
	      } else {
	        return int;
	      }
	    };
	
	    Data.prototype.writeInt16 = function(val) {
	      if (val < 0) {
	        val += 0x10000;
	      }
	      return this.writeUInt16(val);
	    };
	
	    Data.prototype.readString = function(length) {
	      var i, j, ref, ret;
	      ret = [];
	      for (i = j = 0, ref = length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        ret[i] = String.fromCharCode(this.readByte());
	      }
	      return ret.join('');
	    };
	
	    Data.prototype.writeString = function(val) {
	      var i, j, ref, results;
	      results = [];
	      for (i = j = 0, ref = val.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        results.push(this.writeByte(val.charCodeAt(i)));
	      }
	      return results;
	    };
	
	    Data.prototype.stringAt = function(pos, length) {
	      this.pos = pos;
	      return this.readString(length);
	    };
	
	    Data.prototype.readShort = function() {
	      return this.readInt16();
	    };
	
	    Data.prototype.writeShort = function(val) {
	      return this.writeInt16(val);
	    };
	
	    Data.prototype.readLongLong = function() {
	      var b1, b2, b3, b4, b5, b6, b7, b8;
	      b1 = this.readByte();
	      b2 = this.readByte();
	      b3 = this.readByte();
	      b4 = this.readByte();
	      b5 = this.readByte();
	      b6 = this.readByte();
	      b7 = this.readByte();
	      b8 = this.readByte();
	      if (b1 & 0x80) {
	        return ((b1 ^ 0xff) * 0x100000000000000 + (b2 ^ 0xff) * 0x1000000000000 + (b3 ^ 0xff) * 0x10000000000 + (b4 ^ 0xff) * 0x100000000 + (b5 ^ 0xff) * 0x1000000 + (b6 ^ 0xff) * 0x10000 + (b7 ^ 0xff) * 0x100 + (b8 ^ 0xff) + 1) * -1;
	      }
	      return b1 * 0x100000000000000 + b2 * 0x1000000000000 + b3 * 0x10000000000 + b4 * 0x100000000 + b5 * 0x1000000 + b6 * 0x10000 + b7 * 0x100 + b8;
	    };
	
	    Data.prototype.writeLongLong = function(val) {
	      var high, low;
	      high = Math.floor(val / 0x100000000);
	      low = val & 0xffffffff;
	      this.writeByte((high >> 24) & 0xff);
	      this.writeByte((high >> 16) & 0xff);
	      this.writeByte((high >> 8) & 0xff);
	      this.writeByte(high & 0xff);
	      this.writeByte((low >> 24) & 0xff);
	      this.writeByte((low >> 16) & 0xff);
	      this.writeByte((low >> 8) & 0xff);
	      return this.writeByte(low & 0xff);
	    };
	
	    Data.prototype.readInt = function() {
	      return this.readInt32();
	    };
	
	    Data.prototype.writeInt = function(val) {
	      return this.writeInt32(val);
	    };
	
	    Data.prototype.slice = function(start, end) {
	      return this.data.slice(start, end);
	    };
	
	    Data.prototype.read = function(bytes) {
	      var buf, i, j, ref;
	      buf = [];
	      for (i = j = 0, ref = bytes; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        buf.push(this.readByte());
	      }
	      return buf;
	    };
	
	    Data.prototype.write = function(bytes) {
	      var byte, j, len, results;
	      results = [];
	      for (j = 0, len = bytes.length; j < len; j++) {
	        byte = bytes[j];
	        results.push(this.writeByte(byte));
	      }
	      return results;
	    };
	
	    return Data;
	
	  })();
	
	  module.exports = Data;
	
	}).call(this);
	
	
	/***/ }),
	/* 299 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  var JPEG, fs,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  fs = __webpack_require__(8);
	
	  JPEG = (function() {
	    var MARKERS;
	
	    MARKERS = [0xFFC0, 0xFFC1, 0xFFC2, 0xFFC3, 0xFFC5, 0xFFC6, 0xFFC7, 0xFFC8, 0xFFC9, 0xFFCA, 0xFFCB, 0xFFCC, 0xFFCD, 0xFFCE, 0xFFCF];
	
	    function JPEG(data, label) {
	      var channels, marker, pos;
	      this.data = data;
	      this.label = label;
	      if (this.data.readUInt16BE(0) !== 0xFFD8) {
	        throw "SOI not found in JPEG";
	      }
	      pos = 2;
	      while (pos < this.data.length) {
	        marker = this.data.readUInt16BE(pos);
	        pos += 2;
	        if (indexOf.call(MARKERS, marker) >= 0) {
	          break;
	        }
	        pos += this.data.readUInt16BE(pos);
	      }
	      if (indexOf.call(MARKERS, marker) < 0) {
	        throw "Invalid JPEG.";
	      }
	      pos += 2;
	      this.bits = this.data[pos++];
	      this.height = this.data.readUInt16BE(pos);
	      pos += 2;
	      this.width = this.data.readUInt16BE(pos);
	      pos += 2;
	      channels = this.data[pos++];
	      this.colorSpace = (function() {
	        switch (channels) {
	          case 1:
	            return 'DeviceGray';
	          case 3:
	            return 'DeviceRGB';
	          case 4:
	            return 'DeviceCMYK';
	        }
	      })();
	      this.obj = null;
	    }
	
	    JPEG.prototype.embed = function(document) {
	      if (this.obj) {
	        return;
	      }
	      this.obj = document.ref({
	        Type: 'XObject',
	        Subtype: 'Image',
	        BitsPerComponent: this.bits,
	        Width: this.width,
	        Height: this.height,
	        ColorSpace: this.colorSpace,
	        Filter: 'DCTDecode'
	      });
	      if (this.colorSpace === 'DeviceCMYK') {
	        this.obj.data['Decode'] = [1.0, 0.0, 1.0, 0.0, 1.0, 0.0, 1.0, 0.0];
	      }
	      this.obj.end(this.data);
	      return this.data = null;
	    };
	
	    return JPEG;
	
	  })();
	
	  module.exports = JPEG;
	
	}).call(this);
	
	
	/***/ }),
	/* 300 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	(function() {
	  var PNG, PNGImage, zlib;
	
	  zlib = __webpack_require__(48);
	
	  PNG = __webpack_require__(301);
	
	  PNGImage = (function() {
	    function PNGImage(data, label) {
	      this.label = label;
	      this.image = new PNG(data);
	      this.width = this.image.width;
	      this.height = this.image.height;
	      this.imgData = this.image.imgData;
	      this.obj = null;
	    }
	
	    PNGImage.prototype.embed = function(document) {
	      var k, len1, mask, palette, params, rgb, val, x;
	      this.document = document;
	      if (this.obj) {
	        return;
	      }
	      this.obj = this.document.ref({
	        Type: 'XObject',
	        Subtype: 'Image',
	        BitsPerComponent: this.image.bits,
	        Width: this.width,
	        Height: this.height,
	        Filter: 'FlateDecode'
	      });
	      if (!this.image.hasAlphaChannel) {
	        params = this.document.ref({
	          Predictor: 15,
	          Colors: this.image.colors,
	          BitsPerComponent: this.image.bits,
	          Columns: this.width
	        });
	        this.obj.data['DecodeParms'] = params;
	        params.end();
	      }
	      if (this.image.palette.length === 0) {
	        this.obj.data['ColorSpace'] = this.image.colorSpace;
	      } else {
	        palette = this.document.ref();
	        palette.end(new Buffer(this.image.palette));
	        this.obj.data['ColorSpace'] = ['Indexed', 'DeviceRGB', (this.image.palette.length / 3) - 1, palette];
	      }
	      if (this.image.transparency.grayscale) {
	        val = this.image.transparency.greyscale;
	        return this.obj.data['Mask'] = [val, val];
	      } else if (this.image.transparency.rgb) {
	        rgb = this.image.transparency.rgb;
	        mask = [];
	        for (k = 0, len1 = rgb.length; k < len1; k++) {
	          x = rgb[k];
	          mask.push(x, x);
	        }
	        return this.obj.data['Mask'] = mask;
	      } else if (this.image.transparency.indexed) {
	        return this.loadIndexedAlphaChannel();
	      } else if (this.image.hasAlphaChannel) {
	        return this.splitAlphaChannel();
	      } else {
	        return this.finalize();
	      }
	    };
	
	    PNGImage.prototype.finalize = function() {
	      var sMask;
	      if (this.alphaChannel) {
	        sMask = this.document.ref({
	          Type: 'XObject',
	          Subtype: 'Image',
	          Height: this.height,
	          Width: this.width,
	          BitsPerComponent: 8,
	          Filter: 'FlateDecode',
	          ColorSpace: 'DeviceGray',
	          Decode: [0, 1]
	        });
	        sMask.end(this.alphaChannel);
	        this.obj.data['SMask'] = sMask;
	      }
	      this.obj.end(this.imgData);
	      this.image = null;
	      return this.imgData = null;
	    };
	
	    PNGImage.prototype.splitAlphaChannel = function() {
	      return this.image.decodePixels((function(_this) {
	        return function(pixels) {
	          var a, alphaChannel, colorByteSize, done, i, imgData, len, p, pixelCount;
	          colorByteSize = _this.image.colors * _this.image.bits / 8;
	          pixelCount = _this.width * _this.height;
	          imgData = new Buffer(pixelCount * colorByteSize);
	          alphaChannel = new Buffer(pixelCount);
	          i = p = a = 0;
	          len = pixels.length;
	          while (i < len) {
	            imgData[p++] = pixels[i++];
	            imgData[p++] = pixels[i++];
	            imgData[p++] = pixels[i++];
	            alphaChannel[a++] = pixels[i++];
	          }
	          done = 0;
	          zlib.deflate(imgData, function(err, imgData1) {
	            _this.imgData = imgData1;
	            if (err) {
	              throw err;
	            }
	            if (++done === 2) {
	              return _this.finalize();
	            }
	          });
	          return zlib.deflate(alphaChannel, function(err, alphaChannel1) {
	            _this.alphaChannel = alphaChannel1;
	            if (err) {
	              throw err;
	            }
	            if (++done === 2) {
	              return _this.finalize();
	            }
	          });
	        };
	      })(this));
	    };
	
	    PNGImage.prototype.loadIndexedAlphaChannel = function(fn) {
	      var transparency;
	      transparency = this.image.transparency.indexed;
	      return this.image.decodePixels((function(_this) {
	        return function(pixels) {
	          var alphaChannel, i, j, k, ref;
	          alphaChannel = new Buffer(_this.width * _this.height);
	          i = 0;
	          for (j = k = 0, ref = pixels.length; k < ref; j = k += 1) {
	            alphaChannel[i++] = transparency[pixels[j]];
	          }
	          return zlib.deflate(alphaChannel, function(err, alphaChannel1) {
	            _this.alphaChannel = alphaChannel1;
	            if (err) {
	              throw err;
	            }
	            return _this.finalize();
	          });
	        };
	      })(this));
	    };
	
	    return PNGImage;
	
	  })();
	
	  module.exports = PNGImage;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 301 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.4.0
	
	/*
	# MIT LICENSE
	# Copyright (c) 2011 Devon Govett
	# 
	# Permission is hereby granted, free of charge, to any person obtaining a copy of this 
	# software and associated documentation files (the "Software"), to deal in the Software 
	# without restriction, including without limitation the rights to use, copy, modify, merge, 
	# publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons 
	# to whom the Software is furnished to do so, subject to the following conditions:
	# 
	# The above copyright notice and this permission notice shall be included in all copies or 
	# substantial portions of the Software.
	# 
	# THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING 
	# BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND 
	# NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, 
	# DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
	# OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	*/
	
	
	(function() {
	  var PNG, fs, zlib;
	
	  fs = __webpack_require__(8);
	
	  zlib = __webpack_require__(48);
	
	  module.exports = PNG = (function() {
	
	    PNG.decode = function(path, fn) {
	      return fs.readFile(path, function(err, file) {
	        var png;
	        png = new PNG(file);
	        return png.decode(function(pixels) {
	          return fn(pixels);
	        });
	      });
	    };
	
	    PNG.load = function(path) {
	      var file;
	      file = fs.readFileSync(path);
	      return new PNG(file);
	    };
	
	    function PNG(data) {
	      var chunkSize, colors, i, index, key, section, short, text, _i, _j, _ref;
	      this.data = data;
	      this.pos = 8;
	      this.palette = [];
	      this.imgData = [];
	      this.transparency = {};
	      this.text = {};
	      while (true) {
	        chunkSize = this.readUInt32();
	        section = ((function() {
	          var _i, _results;
	          _results = [];
	          for (i = _i = 0; _i < 4; i = ++_i) {
	            _results.push(String.fromCharCode(this.data[this.pos++]));
	          }
	          return _results;
	        }).call(this)).join('');
	        switch (section) {
	          case 'IHDR':
	            this.width = this.readUInt32();
	            this.height = this.readUInt32();
	            this.bits = this.data[this.pos++];
	            this.colorType = this.data[this.pos++];
	            this.compressionMethod = this.data[this.pos++];
	            this.filterMethod = this.data[this.pos++];
	            this.interlaceMethod = this.data[this.pos++];
	            break;
	          case 'PLTE':
	            this.palette = this.read(chunkSize);
	            break;
	          case 'IDAT':
	            for (i = _i = 0; _i < chunkSize; i = _i += 1) {
	              this.imgData.push(this.data[this.pos++]);
	            }
	            break;
	          case 'tRNS':
	            this.transparency = {};
	            switch (this.colorType) {
	              case 3:
	                this.transparency.indexed = this.read(chunkSize);
	                short = 255 - this.transparency.indexed.length;
	                if (short > 0) {
	                  for (i = _j = 0; 0 <= short ? _j < short : _j > short; i = 0 <= short ? ++_j : --_j) {
	                    this.transparency.indexed.push(255);
	                  }
	                }
	                break;
	              case 0:
	                this.transparency.grayscale = this.read(chunkSize)[0];
	                break;
	              case 2:
	                this.transparency.rgb = this.read(chunkSize);
	            }
	            break;
	          case 'tEXt':
	            text = this.read(chunkSize);
	            index = text.indexOf(0);
	            key = String.fromCharCode.apply(String, text.slice(0, index));
	            this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
	            break;
	          case 'IEND':
	            this.colors = (function() {
	              switch (this.colorType) {
	                case 0:
	                case 3:
	                case 4:
	                  return 1;
	                case 2:
	                case 6:
	                  return 3;
	              }
	            }).call(this);
	            this.hasAlphaChannel = (_ref = this.colorType) === 4 || _ref === 6;
	            colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
	            this.pixelBitlength = this.bits * colors;
	            this.colorSpace = (function() {
	              switch (this.colors) {
	                case 1:
	                  return 'DeviceGray';
	                case 3:
	                  return 'DeviceRGB';
	              }
	            }).call(this);
	            this.imgData = new Buffer(this.imgData);
	            return;
	          default:
	            this.pos += chunkSize;
	        }
	        this.pos += 4;
	        if (this.pos > this.data.length) {
	          throw new Error("Incomplete or corrupt PNG file");
	        }
	      }
	      return;
	    }
	
	    PNG.prototype.read = function(bytes) {
	      var i, _i, _results;
	      _results = [];
	      for (i = _i = 0; 0 <= bytes ? _i < bytes : _i > bytes; i = 0 <= bytes ? ++_i : --_i) {
	        _results.push(this.data[this.pos++]);
	      }
	      return _results;
	    };
	
	    PNG.prototype.readUInt32 = function() {
	      var b1, b2, b3, b4;
	      b1 = this.data[this.pos++] << 24;
	      b2 = this.data[this.pos++] << 16;
	      b3 = this.data[this.pos++] << 8;
	      b4 = this.data[this.pos++];
	      return b1 | b2 | b3 | b4;
	    };
	
	    PNG.prototype.readUInt16 = function() {
	      var b1, b2;
	      b1 = this.data[this.pos++] << 8;
	      b2 = this.data[this.pos++];
	      return b1 | b2;
	    };
	
	    PNG.prototype.decodePixels = function(fn) {
	      var _this = this;
	      return zlib.inflate(this.imgData, function(err, data) {
	        var byte, c, col, i, left, length, p, pa, paeth, pb, pc, pixelBytes, pixels, pos, row, scanlineLength, upper, upperLeft, _i, _j, _k, _l, _m;
	        if (err) {
	          throw err;
	        }
	        pixelBytes = _this.pixelBitlength / 8;
	        scanlineLength = pixelBytes * _this.width;
	        pixels = new Buffer(scanlineLength * _this.height);
	        length = data.length;
	        row = 0;
	        pos = 0;
	        c = 0;
	        while (pos < length) {
	          switch (data[pos++]) {
	            case 0:
	              for (i = _i = 0; _i < scanlineLength; i = _i += 1) {
	                pixels[c++] = data[pos++];
	              }
	              break;
	            case 1:
	              for (i = _j = 0; _j < scanlineLength; i = _j += 1) {
	                byte = data[pos++];
	                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	                pixels[c++] = (byte + left) % 256;
	              }
	              break;
	            case 2:
	              for (i = _k = 0; _k < scanlineLength; i = _k += 1) {
	                byte = data[pos++];
	                col = (i - (i % pixelBytes)) / pixelBytes;
	                upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	                pixels[c++] = (upper + byte) % 256;
	              }
	              break;
	            case 3:
	              for (i = _l = 0; _l < scanlineLength; i = _l += 1) {
	                byte = data[pos++];
	                col = (i - (i % pixelBytes)) / pixelBytes;
	                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	                upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	                pixels[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
	              }
	              break;
	            case 4:
	              for (i = _m = 0; _m < scanlineLength; i = _m += 1) {
	                byte = data[pos++];
	                col = (i - (i % pixelBytes)) / pixelBytes;
	                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	                if (row === 0) {
	                  upper = upperLeft = 0;
	                } else {
	                  upper = pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	                  upperLeft = col && pixels[(row - 1) * scanlineLength + (col - 1) * pixelBytes + (i % pixelBytes)];
	                }
	                p = left + upper - upperLeft;
	                pa = Math.abs(p - left);
	                pb = Math.abs(p - upper);
	                pc = Math.abs(p - upperLeft);
	                if (pa <= pb && pa <= pc) {
	                  paeth = left;
	                } else if (pb <= pc) {
	                  paeth = upper;
	                } else {
	                  paeth = upperLeft;
	                }
	                pixels[c++] = (byte + paeth) % 256;
	              }
	              break;
	            default:
	              throw new Error("Invalid filter algorithm: " + data[pos - 1]);
	          }
	          row++;
	        }
	        return fn(pixels);
	      });
	    };
	
	    PNG.prototype.decodePalette = function() {
	      var c, i, length, palette, pos, ret, transparency, _i, _ref, _ref1;
	      palette = this.palette;
	      transparency = this.transparency.indexed || [];
	      ret = new Buffer(transparency.length + palette.length);
	      pos = 0;
	      length = palette.length;
	      c = 0;
	      for (i = _i = 0, _ref = palette.length; _i < _ref; i = _i += 3) {
	        ret[pos++] = palette[i];
	        ret[pos++] = palette[i + 1];
	        ret[pos++] = palette[i + 2];
	        ret[pos++] = (_ref1 = transparency[c++]) != null ? _ref1 : 255;
	      }
	      return ret;
	    };
	
	    PNG.prototype.copyToImageData = function(imageData, pixels) {
	      var alpha, colors, data, i, input, j, k, length, palette, v, _ref;
	      colors = this.colors;
	      palette = null;
	      alpha = this.hasAlphaChannel;
	      if (this.palette.length) {
	        palette = (_ref = this._decodedPalette) != null ? _ref : this._decodedPalette = this.decodePalette();
	        colors = 4;
	        alpha = true;
	      }
	      data = (imageData != null ? imageData.data : void 0) || imageData;
	      length = data.length;
	      input = palette || pixels;
	      i = j = 0;
	      if (colors === 1) {
	        while (i < length) {
	          k = palette ? pixels[i / 4] * 4 : j;
	          v = input[k++];
	          data[i++] = v;
	          data[i++] = v;
	          data[i++] = v;
	          data[i++] = alpha ? input[k++] : 255;
	          j = k;
	        }
	      } else {
	        while (i < length) {
	          k = palette ? pixels[i / 4] * 4 : j;
	          data[i++] = input[k++];
	          data[i++] = input[k++];
	          data[i++] = input[k++];
	          data[i++] = alpha ? input[k++] : 255;
	          j = k;
	        }
	      }
	    };
	
	    PNG.prototype.decode = function(fn) {
	      var ret,
	        _this = this;
	      ret = new Buffer(this.width * this.height * 4);
	      return this.decodePixels(function(pixels) {
	        _this.copyToImageData(ret, pixels);
	        return fn(ret);
	      });
	    };
	
	    return PNG;
	
	  })();
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 302 */
	/***/ (function(module, exports) {
	
	// Generated by CoffeeScript 1.12.6
	(function() {
	  module.exports = {
	    annotate: function(x, y, w, h, options) {
	      var key, ref, val;
	      options.Type = 'Annot';
	      options.Rect = this._convertRect(x, y, w, h);
	      options.Border = [0, 0, 0];
	      if (options.Subtype !== 'Link') {
	        if (options.C == null) {
	          options.C = this._normalizeColor(options.color || [0, 0, 0]);
	        }
	      }
	      delete options.color;
	      if (typeof options.Dest === 'string') {
	        options.Dest = new String(options.Dest);
	      }
	      for (key in options) {
	        val = options[key];
	        options[key[0].toUpperCase() + key.slice(1)] = val;
	      }
	      ref = this.ref(options);
	      this.page.annotations.push(ref);
	      ref.end();
	      return this;
	    },
	    note: function(x, y, w, h, contents, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Text';
	      options.Contents = new String(contents);
	      options.Name = 'Comment';
	      if (options.color == null) {
	        options.color = [243, 223, 92];
	      }
	      return this.annotate(x, y, w, h, options);
	    },
	    link: function(x, y, w, h, url, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Link';
	      options.A = this.ref({
	        S: 'URI',
	        URI: new String(url)
	      });
	      options.A.end();
	      return this.annotate(x, y, w, h, options);
	    },
	    _markup: function(x, y, w, h, options) {
	      var ref1, x1, x2, y1, y2;
	      if (options == null) {
	        options = {};
	      }
	      ref1 = this._convertRect(x, y, w, h), x1 = ref1[0], y1 = ref1[1], x2 = ref1[2], y2 = ref1[3];
	      options.QuadPoints = [x1, y2, x2, y2, x1, y1, x2, y1];
	      options.Contents = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    highlight: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Highlight';
	      if (options.color == null) {
	        options.color = [241, 238, 148];
	      }
	      return this._markup(x, y, w, h, options);
	    },
	    underline: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Underline';
	      return this._markup(x, y, w, h, options);
	    },
	    strike: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'StrikeOut';
	      return this._markup(x, y, w, h, options);
	    },
	    lineAnnotation: function(x1, y1, x2, y2, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Line';
	      options.Contents = new String;
	      options.L = [x1, this.page.height - y1, x2, this.page.height - y2];
	      return this.annotate(x1, y1, x2, y2, options);
	    },
	    rectAnnotation: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Square';
	      options.Contents = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    ellipseAnnotation: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Circle';
	      options.Contents = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    textAnnotation: function(x, y, w, h, text, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'FreeText';
	      options.Contents = new String(text);
	      options.DA = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    _convertRect: function(x1, y1, w, h) {
	      var m0, m1, m2, m3, m4, m5, ref1, x2, y2;
	      y2 = y1;
	      y1 += h;
	      x2 = x1 + w;
	      ref1 = this._ctm, m0 = ref1[0], m1 = ref1[1], m2 = ref1[2], m3 = ref1[3], m4 = ref1[4], m5 = ref1[5];
	      x1 = m0 * x1 + m2 * y1 + m4;
	      y1 = m1 * x1 + m3 * y1 + m5;
	      x2 = m0 * x2 + m2 * y2 + m4;
	      y2 = m1 * x2 + m3 * y2 + m5;
	      return [x1, y1, x2, y2];
	    }
	  };
	
	}).call(this);
	
	
	/***/ }),
	/* 303 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = {
		'4A0': [4767.87, 6740.79],
		'2A0': [3370.39, 4767.87],
		A0: [2383.94, 3370.39],
		A1: [1683.78, 2383.94],
		A2: [1190.55, 1683.78],
		A3: [841.89, 1190.55],
		A4: [595.28, 841.89],
		A5: [419.53, 595.28],
		A6: [297.64, 419.53],
		A7: [209.76, 297.64],
		A8: [147.40, 209.76],
		A9: [104.88, 147.40],
		A10: [73.70, 104.88],
		B0: [2834.65, 4008.19],
		B1: [2004.09, 2834.65],
		B2: [1417.32, 2004.09],
		B3: [1000.63, 1417.32],
		B4: [708.66, 1000.63],
		B5: [498.90, 708.66],
		B6: [354.33, 498.90],
		B7: [249.45, 354.33],
		B8: [175.75, 249.45],
		B9: [124.72, 175.75],
		B10: [87.87, 124.72],
		C0: [2599.37, 3676.54],
		C1: [1836.85, 2599.37],
		C2: [1298.27, 1836.85],
		C3: [918.43, 1298.27],
		C4: [649.13, 918.43],
		C5: [459.21, 649.13],
		C6: [323.15, 459.21],
		C7: [229.61, 323.15],
		C8: [161.57, 229.61],
		C9: [113.39, 161.57],
		C10: [79.37, 113.39],
		RA0: [2437.80, 3458.27],
		RA1: [1729.13, 2437.80],
		RA2: [1218.90, 1729.13],
		RA3: [864.57, 1218.90],
		RA4: [609.45, 864.57],
		SRA0: [2551.18, 3628.35],
		SRA1: [1814.17, 2551.18],
		SRA2: [1275.59, 1814.17],
		SRA3: [907.09, 1275.59],
		SRA4: [637.80, 907.09],
		EXECUTIVE: [521.86, 756.00],
		FOLIO: [612.00, 936.00],
		LEGAL: [612.00, 1008.00],
		LETTER: [612.00, 792.00],
		TABLOID: [792.00, 1224.00]
	};
	
	
	/***/ }),
	/* 304 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(Buffer) {
	
	var PDFImage = __webpack_require__(121);
	
	function ImageMeasure(pdfKitDoc, imageDictionary) {
		this.pdfKitDoc = pdfKitDoc;
		this.imageDictionary = imageDictionary || {};
	}
	
	ImageMeasure.prototype.measureImage = function (src) {
		var image, label;
		var that = this;
	
		if (!this.pdfKitDoc._imageRegistry[src]) {
			label = 'I' + (++this.pdfKitDoc._imageCount);
			try {
				image = PDFImage.open(realImageSrc(src), label);
			} catch (error) {
				image = null;
			}
			if (image === null || image === undefined) {
				throw 'invalid image, images dictionary should contain dataURL entries (or local file paths in node.js)';
			}
			image.embed(this.pdfKitDoc);
			this.pdfKitDoc._imageRegistry[src] = image;
		} else {
			image = this.pdfKitDoc._imageRegistry[src];
		}
	
		return {width: image.width, height: image.height};
	
		function realImageSrc(src) {
			var img = that.imageDictionary[src];
	
			if (!img) {
				return src;
			}
	
			var index = img.indexOf('base64,');
			if (index < 0) {
				return that.imageDictionary[src];
			}
	
			return Buffer.from(img.substring(index + 7), 'base64');
		}
	};
	
	module.exports = ImageMeasure;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))
	
	/***/ }),
	/* 305 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var isArray = __webpack_require__(0).isArray;
	
	function groupDecorations(line) {
		var groups = [], currentGroup = null;
		for (var i = 0, l = line.inlines.length; i < l; i++) {
			var inline = line.inlines[i];
			var decoration = inline.decoration;
			if (!decoration) {
				currentGroup = null;
				continue;
			}
			if (!isArray(decoration)) {
				decoration = [decoration];
			}
			var color = inline.decorationColor || inline.color || 'black';
			var style = inline.decorationStyle || 'solid';
			for (var ii = 0, ll = decoration.length; ii < ll; ii++) {
				var decorationItem = decoration[ii];
				if (!currentGroup || decorationItem !== currentGroup.decoration ||
					style !== currentGroup.decorationStyle || color !== currentGroup.decorationColor ||
					decorationItem === 'lineThrough') {
	
					currentGroup = {
						line: line,
						decoration: decorationItem,
						decorationColor: color,
						decorationStyle: style,
						inlines: [inline]
					};
					groups.push(currentGroup);
				} else {
					currentGroup.inlines.push(inline);
				}
			}
		}
	
		return groups;
	}
	
	function drawDecoration(group, x, y, pdfKitDoc) {
		function maxInline() {
			var max = 0;
			for (var i = 0, l = group.inlines.length; i < l; i++) {
				var inline = group.inlines[i];
				max = inline.fontSize > max ? i : max;
			}
			return group.inlines[max];
		}
		function width() {
			var sum = 0;
			for (var i = 0, l = group.inlines.length; i < l; i++) {
				sum += group.inlines[i].width;
			}
			return sum;
		}
		var firstInline = group.inlines[0],
			biggerInline = maxInline(),
			totalWidth = width(),
			lineAscent = group.line.getAscenderHeight(),
			ascent = biggerInline.font.ascender / 1000 * biggerInline.fontSize,
			height = biggerInline.height,
			descent = height - ascent;
	
		var lw = 0.5 + Math.floor(Math.max(biggerInline.fontSize - 8, 0) / 2) * 0.12;
	
		switch (group.decoration) {
			case 'underline':
				y += lineAscent + descent * 0.45;
				break;
			case 'overline':
				y += lineAscent - (ascent * 0.85);
				break;
			case 'lineThrough':
				y += lineAscent - (ascent * 0.25);
				break;
			default:
				throw 'Unkown decoration : ' + group.decoration;
		}
		pdfKitDoc.save();
	
		if (group.decorationStyle === 'double') {
			var gap = Math.max(0.5, lw * 2);
			pdfKitDoc.fillColor(group.decorationColor)
				.rect(x + firstInline.x, y - lw / 2, totalWidth, lw / 2).fill()
				.rect(x + firstInline.x, y + gap - lw / 2, totalWidth, lw / 2).fill();
		} else if (group.decorationStyle === 'dashed') {
			var nbDashes = Math.ceil(totalWidth / (3.96 + 2.84));
			var rdx = x + firstInline.x;
			pdfKitDoc.rect(rdx, y, totalWidth, lw).clip();
			pdfKitDoc.fillColor(group.decorationColor);
			for (var i = 0; i < nbDashes; i++) {
				pdfKitDoc.rect(rdx, y - lw / 2, 3.96, lw).fill();
				rdx += 3.96 + 2.84;
			}
		} else if (group.decorationStyle === 'dotted') {
			var nbDots = Math.ceil(totalWidth / (lw * 3));
			var rx = x + firstInline.x;
			pdfKitDoc.rect(rx, y, totalWidth, lw).clip();
			pdfKitDoc.fillColor(group.decorationColor);
			for (var ii = 0; ii < nbDots; ii++) {
				pdfKitDoc.rect(rx, y - lw / 2, lw, lw).fill();
				rx += (lw * 3);
			}
		} else if (group.decorationStyle === 'wavy') {
			var sh = 0.7, sv = 1;
			var nbWaves = Math.ceil(totalWidth / (sh * 2)) + 1;
			var rwx = x + firstInline.x - 1;
			pdfKitDoc.rect(x + firstInline.x, y - sv, totalWidth, y + sv).clip();
			pdfKitDoc.lineWidth(0.24);
			pdfKitDoc.moveTo(rwx, y);
			for (var iii = 0; iii < nbWaves; iii++) {
				pdfKitDoc.bezierCurveTo(rwx + sh, y - sv, rwx + sh * 2, y - sv, rwx + sh * 3, y)
					.bezierCurveTo(rwx + sh * 4, y + sv, rwx + sh * 5, y + sv, rwx + sh * 6, y);
				rwx += sh * 6;
			}
			pdfKitDoc.stroke(group.decorationColor);
		} else {
			pdfKitDoc.fillColor(group.decorationColor)
				.rect(x + firstInline.x, y - lw / 2, totalWidth, lw)
				.fill();
		}
		pdfKitDoc.restore();
	}
	
	function drawDecorations(line, x, y, pdfKitDoc) {
		var groups = groupDecorations(line);
		for (var i = 0, l = groups.length; i < l; i++) {
			drawDecoration(groups[i], x, y, pdfKitDoc);
		}
	}
	
	function drawBackground(line, x, y, pdfKitDoc) {
		var height = line.getHeight();
		for (var i = 0, l = line.inlines.length; i < l; i++) {
			var inline = line.inlines[i];
			if (!inline.background) {
				continue;
			}
			var justifyShift = (inline.justifyShift || 0);
			pdfKitDoc.fillColor(inline.background)
				.rect(x + inline.x - justifyShift, y, inline.width + justifyShift, height)
				.fill();
		}
	}
	
	module.exports = {
		drawBackground: drawBackground,
		drawDecorations: drawDecorations
	};
	
	/***/ }),
	/* 306 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc ? doc.createElementNS("http://www.w3.org/1999/xhtml", "a") : []
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(307) !== null) && (__webpack_require__(308) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	    return saveAs;
	  }).call(exports, __webpack_require__, exports, module),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	/***/ }),
	/* 307 */
	/***/ (function(module, exports) {
	
	module.exports = function() {
		throw new Error("define cannot be used indirect");
	};
	
	
	/***/ }),
	/* 308 */
	/***/ (function(module, exports) {
	
	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
	module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))
	
	/***/ })
	/******/ ]);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(415).Buffer))

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	this.pdfMake = this.pdfMake || {}; this.pdfMake.vfs = {
	  "Roboto-Italic.ttf": "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",
	  "Roboto-Medium.ttf": "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",
	  "Roboto-MediumItalic.ttf": "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",
	  "Roboto-Regular.ttf": "AAEAAAASAQAABAAgR0RFRtRX1FkAAg/sAAACREdQT1NKcuCzAAISMAAAUiRHU1VCw4aZEQACZFQAABfoT1MvMqCnsaYAAAGoAAAAYGNtYXBAmkl2AAAafAAAEshjdnQgJEEG5QAAL9wAAABMZnBnbWf0XKsAAC1EAAABvGdhc3AACAATAAIP4AAAAAxnbHlmHN2bBQAAOfAAAdM2aGRteDc4ERcAABWQAAAE7GhlYWT4RqsOAAABLAAAADZoaGVhCroKggAAAWQAAAAkaG10eOiEiIgAAAIIAAATiGxvY2HgyGepAAAwKAAACcZtYXhwBxIC+QAAAYgAAAAgbmFtZTVTY1kAAg0oAAACmHBvc3T/bQBkAAIPwAAAACBwcmVwdKCP7AAALwAAAADbAAEAAAACAACEKlnoXw889QAbCAAAAAAAxPARLgAAAADQ206a+hv91QkwCHMAAAAJAAIAAAAAAAAAAQAAB2z+DAAACUn6G/5KCTAAAQAAAAAAAAAAAAAAAAAABOIAAQAABOIAjwAWAFQABQABAAAAAAAOAAACAAIUAAYAAQADBIUBkAAFAAAFmgUzAAABHwWaBTMAAAPRAGYCAAAAAgAAAAAAAAAAAOAACv9QACF/AAAAIQAAAABHT09HAEAAAP/9BgD+AABmB5oCACAAAZ8AAAAABDoFsAAgACAAAgOMAGQAAAAAAAAAAAH7AAAB+wAAAg8AoAKPAIgE7QB3BH4AbgXcAGkE+QBlAWUAZwK8AIUCyAAmA3IAHASJAE4BkgAdAjUAJQIbAJADTAASBH4AcwR+AKoEfgBdBH4AXgR+ADUEfgCaBH4AhAR+AE0EfgBwBH4AZAHwAIYBsQApBBEASARkAJgELgCGA8cASwcvAGoFOAAcBPsAqQU1AHcFPwCpBIwAqQRsAKkFcwB6BbQAqQItALcEagA1BQQAqQROAKkG/ACpBbQAqQWAAHYFDACpBYAAbQTtAKgEvwBQBMYAMQUwAIwFFwAcBxkAPQUEADkEzgAPBMoAVgIfAJIDSAAoAh8ACQNYAEADnAAEAnkAOQRaAG0EfQCMBDAAXASDAF8EPQBdAscAPAR9AGAEaACMAfEAjQHp/78EDgCNAfEAnAcDAIsEagCMBJAAWwR9AIwEjABfArUAjAQgAF8CnQAJBGkAiAPgACEGAwArA/cAKQPJABYD9wBYArUAQAHzAK8CtQATBXEAgwHzAIsEYABpBKYAWwW0AGkE2AAfAesAkwToAFoDWABmBkkAWwOTAJMDwQBmBG4AfwZKAFoDqgB4Av0AggRGAGEC7wBCAu8APgKCAHsEiACaA+kAQwIWAJMB+wB0Au8AegOjAHoDwABmBdwAVQY1AFAGOQBvA8kARAd6//IERABZBYAAdgS6AKYEwgCLBsEATgSwAH4EkQBHBIgAWwScAJUFmgAdAfoAmwRzAJoETwAiAikAIgWLAKIEiACRB6EAaAdEAGEB/ACgBYcAXQK5/+QFfgBlBJIAWwWQAIwE8wCIAgP/tAQ3AGIDxACpA40AjAOrAHgDagCBAfEAjQKtAHkCKgAyA8YAewL8AF4CWgB+AAD8pwAA/W8AAPyLAAD9XgAA/CcB7/04Ag0AtwQLAHECFwCTBHMAsQWkAB8FcQBnBT4AMgSRAHgFtQCyBJEARQW7AE0FiQBaBVIAcQSFAGQEvQCgBAIALgSIAGAEUABjBCUAbQSIAJEEjgB6ApcAwwRuACUD7ABlBMQAKQSIAJEETQBlBIgAYAQsAFEEXQCPBaMAVwWaAF8GlwB6BKEAeQRC/9oGSABKBf8AKgVkAHsIkQAxCKQAsQaCAD4FtACwBQsAogYEADIHQwAbBL8AUAW0ALEFqQAvBQcATQYsAFMF2QCvBXoAlgeHALAHwACwBhIAEAbrALIFBQCjBWQAkwcnALcFGABZBGwAYQSSAJ0DWwCaBNQALgYgABUEEABYBJ4AnARSAJwEoAAsBe8AnQSdAJwEngCcA9gAKAXNAGQEvQCcBFkAZwZ4AJwGngCRBPcAHgY2AJ0EWACdBE0AZAaHAJ0EZAAvBGj/6ARNAGcGyQAnBuQAnASJ//0EngCcBwgAnAYrAIEEVv/cBysAtwX4AJkE0gAoBEYADwcLAMkGCwC8BtEAkwXhAJYJBAC2B9EAmwQjAFAD2wBMBXEAZwSLAFsFCgAWBAMALgVxAGcEiABbBwEAnAYkAH4HCACcBisAgQUyAHUERwBkBP0AdAAA/GcAAPxxAAD9ZgAA/aQAAPobAAD6LARW/9wFGwCoBIkAjARjAKIDkACRBNsAsQQFAJEFCQCjBH4AmgaMAEQFgwA+B88AqAW0AJEIMQCwBvQAkQXuAHEE0wBtBywANAVcAB8FbwCWBGoAgwVwAIoGLwA/BL3/3gUJAKMEWgCaBbIAsQSIAJEFhwBdBKgAaASoAGkEtwA6A0kAOwT2AFcGlABZBuQAZAZWADYFKwAxBEkAUgQHAHkHwQBEBnUAPwf7AKkGoQCQBPYAdgQdAGUFrQAjBSAARgVkAJYDIABvBBQAAAgpAAAEFAAACCkAAAK5AAACCgAAAVwAAAR/AAACMAAAAaIAAADRAAAAAAAAAjQAJQI0ACUFQACiBj8AkAOmAA0BmQBgAZkAMAGXACQBmQBPAtQAaALbADwCwQAkBGkARgSPAFcCsgCKA8QAlAVaAJQA9gAmB6oARAJmAGwCZgBZA6MAOwLvADYDYAB6BKYAWwZVAB8GkACnCHYAqAdjADkGKwCMBH4AXwXaAB8EIgAqBHQAIAVIAF0FTwAfBecAegPOAGgIOgCiBQEAZwUXAJgGJgBUBtcAZAbPAGMGagBZBI8AagWOAKkErwBFBJIAqATFAD8IOgBiAgz/sASCAGUEZACYBBEAPgQvAIUECAArAkwAtQKPAG4CAwBcBPMAPARuAB8EiwA8BtQAPAbUADwE7gA8BpsAXwAAAAAIMwBbCDUAXAQgADsEngBaAfz/tgGRAGcDpACDA54AgQOfAIED9ABpBA4AaQPz/14D7wBuA6QAgQH9AJ8EhQATBFAAigR8AGAEgACKA+YAigPLAIoErABjBOMAigHoAJcDzwArBFQAigO0AIoGAgCKBOMAigS7AGAEXACKBLsAWQRKAIoEIABDBCYAKAR8AHQEZwAUBhUAMQRUACYEKwANBCMARwLvAFAC7wB6Au8AQgLvAD4C7wA2Au8AWwLvAFYC7wA6Au8ATwLvAEkDlgCPArUAngQ6AB4EwwBkBUwAsQUkALIEEwCSBT0AsgQPAJIEIABDBDMAMAQ8ABYDrwCKBGcAFAS7AGAEZwAUA4kAPgTOAIoD7wA/BWcAYAUXAGAE8gB1BXIAJgR8AGAHQQAnB08AigV0ACgEzQCKBFkAigUkAC4GCwAfBD8ARwTsAIoETgCLBMEAJwQfACIFKACKBGoAPQZRAIoGrACKBR0ACAXxAIoETgCKBHsASwZ2AIoEhwBQBBEACwZHAB8EeQCLBQkAiwU3ACMFwgBgBF8ADQSoACYGYQAmBGoAPQRqAIoFwwACBMoAXgQ/AEcEuwBgBDMAMAPjAEIIIgCKBKsAKAR9AIwEMgBcBJMAWwSMAFsDeQBXBI0AjAScAFsEPQBdBH0AYAWBAH4FrgB+BZMAsgXgAH4F4wB+A9UAoASCAIMDrwCKBFgADwTPAD4C7wBQAu8ANgLvAFsC7wBWAu8AOgLvAE8C7wBJBGsAZQQuAEoGpABgBLkAggUAAHgCBv+0AgT/tAH7AJsB+//6AfsAmwH7AIYEUACKAfsAAAI1ACUFXQAlBV0AJQSGAAAExgAxAp3/9AU4ABwFOAAcBTgAHAU4ABwFOAAcBTgAHAU4ABwFNQB3BIwAqQSMAKkEjACpBIwAqQIt/+ACLQCwAi3/6QIt/9YFtACpBYAAdgWAAHYFgAB2BYAAdgWAAHYFMACMBTAAjAUwAIwFMACMBM4ADwRaAG0EWgBtBFoAbQRaAG0EWgBtBFoAbQRaAG0EMABcBD0AXQQ9AF0EPQBdBD0AXQH6/8YB+gCWAfr/zwH6/7wEagCMBJAAWwSQAFsEkABbBJAAWwSQAFsEaQCIBGkAiARpAIgEaQCIA8kAFgPJABYFOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FNQB3BDAAXAU1AHcEMABcBTUAdwQwAFwFNQB3BDAAXAU/AKkFGQBfBIwAqQQ9AF0EjACpBD0AXQSMAKkEPQBdBIwAqQQ9AF0EjACpBD0AXQVzAHoEfQBgBXMAegR9AGAFcwB6BH0AYAVzAHoEfQBgBbQAqQRoAIwCLf+3Afr/nQIt/7YB+v+cAi3/7AH6/9ICLQAYAfH/+wItAKoGlwC3A9oAjQRqADUCA/+0BQQAqQQOAI0ETgChAfEAkwROAKkB8QBXBE4AqQKHAJwETgCpAs0AnAW0AKkEagCMBbQAqQRqAIwFtACpBGoAjARq/7wFgAB2BJAAWwWAAHYEkABbBYAAdgSQAFsE7QCoArUAjATtAKgCtQBTBO0AqAK1AGMEvwBQBCAAXwS/AFAEIABfBL8AUAQgAF8EvwBQBCAAXwS/AFAEIABfBMYAMQKdAAkExgAxAp0ACQTGADECxQAJBTAAjARpAIgFMACMBGkAiAUwAIwEaQCIBTAAjARpAIgFMACMBGkAiAUwAIwEaQCIBxkAPQYDACsEzgAPA8kAFgTOAA8EygBWA/cAWATKAFYD9wBYBMoAVgP3AFgHev/yBsEATgWAAHYEiABbBID/vgSA/74EJgAoBIUAEwSFABMEhQATBIUAEwSFABMEhQATBIUAEwR8AGAD5gCKA+YAigPmAIoD5gCKAej/vgHoAI4B6P/HAej/tATjAIoEuwBgBLsAYAS7AGAEuwBgBLsAYAR8AHQEfAB0BHwAdAR8AHQEKwANBIUAEwSFABMEhQATBHwAYAR8AGAEfABgBHwAYASAAIoD5gCKA+YAigPmAIoD5gCKA+YAigSsAGMErABjBKwAYwSsAGME4wCKAej/lQHo/5QB6P/KAegABgHoAIkDzwArBFQAigO0AIIDtACKA7QAigO0AIoE4wCKBOMAigTjAIoEuwBgBLsAYAS7AGAESgCKBEoAigRKAIoEIABDBCAAQwQgAEMEIABDBCYAKAQmACgEJgAoBHwAdAR8AHQEfAB0BHwAdAR8AHQEfAB0BhUAMQQrAA0EKwANBCMARwQjAEcEIwBHBTgAHATw//AGGP/+ApEABAWU//oFMv94BWb//QKX/5sFOAAcBPsAqQSMAKkEygBWBbQAqQItALcFBACpBvwAqQW0AKkFgAB2BQwAqQTGADEEzgAPBQQAOQIt/9YEzgAPBIUAZARQAGMEiACRApcAwwRdAI8EcwCaBJAAWwSIAJoD4AAhA/cAKQKX/+YEXQCPBJAAWwRdAI8GlwB6BIwAqQRzALEEvwBQAi0AtwIt/9YEagA1BSQAsgUEAKkFBwBNBTgAHAT7AKkEcwCxBIwAqQW0ALEG/ACpBbQAqQWAAHYFtQCyBQwAqQU1AHcExgAxBQQAOQRaAG0EPQBdBJ4AnASQAFsEfQCMBDAAXAPJABYD9wApBD0AXQNbAJoEIABfAfEAjQH6/7wB6f+/BFIAnAPJABYHGQA9BgMAKwcZAD0GAwArBxkAPQYDACsEzgAPA8kAFgFlAGcCjwCIBB4AoAID/7QBmQAwBvwAqQcDAIsFOAAcBFoAbQSMAKkFtACxBD0AXQSeAJwFiQBaBZoAXwUKABYEA//7CFkAWwlJAHYEvwBQBBAAWAU1AHcEMABcBM4ADwQCAC4CLQC3B0MAGwYgABUCLQC3BTgAHARaAG0FOAAcBFoAbQd6//IGwQBOBIwAqQQ9AF0FhwBdBDcAYgQ3AGIHQwAbBiAAFQS/AFAEEABYBbQAsQSeAJwFtACxBJ4AnAWAAHYEkABbBXEAZwSLAFsFcQBnBIsAWwVkAJMETQBkBQcATQPJABYFBwBNA8kAFgUHAE0DyQAWBXoAlgRZAGcG6wCyBjYAnQUEADkD9wApBIMAXwWpAC8EoAAsBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBTgAHARa/8oFOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBIwAqQQ9AF0EjACpBD0AXQSMAKkEPQBdBIwAqQQ9AF0EjP/wBD3/ugSMAKkEPQBdBIwAqQQ9AF0EjACpBD0AXQItALcB+gCbAi0AowHxAIUFgAB2BJAAWwWAAHYEkABbBYAAdgSQAFsFgABHBJD/xAWAAHYEkABbBYAAdgSQAFsFgAB2BJAAWwV+AGUEkgBbBX4AZQSSAFsFfgBlBJIAWwV+AGUEkgBbBX4AZQSSAFsFMACMBGkAiAUwAIwEaQCIBZAAjATzAIgFkACMBPMAiAWQAIwE8wCIBZAAjATzAIgFkACMBPMAiATOAA8DyQAWBM4ADwPJABYEzgAPA8kAFgShAF8EoQBfBSQAsgRSAJwFtACpBJ0AnATGADED2AAoBQQAOQP3ACkFegCWBFkAZwV6AJYEWQBnBHMAsQNbAJoHQwAbBiAAFQYvAD8Evf/eBGgAjAUF/9QFBf/UBHMAAwNb//wFOAALBCf/0wW0ALEEngCcBbQAqQSdAJwG/ACpBe8AnQWpAC8EoAAsBM4ADwQCAC4FBAA5A/cAKQRQAGMEbAASBj8AkAR+AF0EfgBeBH4ANQR+AJoEkgBkBKYAhwVzAHoEfQBgBbQAqQRqAIwFOAAcBFoAOQSMAF8EPQApAi3/CgH6/vAFgAB2BJAAMwTtAFUCtf+LBTAAjARpACsEpv86BPsAqQR9AIwFPwCpBIMAXwU/AKkEgwBfBbQAqQRoAIwFBACpBA4AjQUEAKkEDgCNBE4AqQHxAIYG/ACpBwMAiwW0AKkEagCMBQwAqQR9AIwE7QCoArUAggS/AFAEIABfBMYAMQKdAAkFFwAcA+AAIQUXABwD4AAhBxkAPQYDACsEygBWA/cAWAXG/ngEhQATBCL/nwUf/7wCJP/ABMX/3wRn/1cE/P/4BIUAEwRQAIoD5gCKBCMARwTjAIoB6ACXBFQAigYCAIoEuwBgBFwAigQmACgEKwANBFQAJgHo/7QEKwANA+YAigOvAIoEIABDAegAlwHo/7QDzwArBFQAigQfACIEhQATBFAAigOvAIoD5gCKBOwAigYCAIoE4wCKBLsAYATOAIoEXACKBHwAYAQmACgEVAAmBD8ARwTjAIoEfABgBCsADQXDAAIE7ACKBB8AIgVnAGAFOAAcBFoAbQSMAKkEPQBdAAAAAQAABOQJCgQAAAICAgMGBQcGAgMDBAUCAgIEBQUFBQUFBQUFBQICBQUFBAgGBgYGBQUGBgIFBgUIBgYGBgYFBQYGCAYFBQIEAgQEAwUFBQUFAwUFAgIFAggFBQUFAwUDBQQHBAQEAwIDBgIFBQYFAgYEBwQEBQcEAwUDAwMFBAICAwQEBwcHBAgFBgUFCAUFBQUGAgUFAgYFCQgCBgMGBQYGAgUEBAQEAgMCBAMDAAAAAAACAgUCBQYGBgUGBQYGBgUFBQUFBQUFAwUEBQUFBQUFBgYHBQUHBwYKCgcGBgcIBQYGBgcHBggJBwgGBggGBQUEBQcFBQUFBwUFBAcFBQcHBgcFBQcFBQUICAUFCAcFCAcFBQgHCAcKCQUEBgUGBQYFCAcIBwYFBgAAAAAAAAUGBQUEBQUGBQcGCQYJCAcFCAYGBQYHBQYFBgUGBQUFBAYHCAcGBQUJBwkHBgUGBgYEBQkFCQMCAgUCAgEAAgIGBwQCAgICAwMDBQUDBAYBCQMDBAMEBQcHCggHBQcFBQYGBwQJBgYHCAgHBQYFBQUJAgUFBQUFAwMCBgUFCAgGBwAJCQUFAgIEBAQEBQQEBAIFBQUFBAQFBgIEBQQHBgUFBQUFBQUFBwUFBQMDAwMDAwMDAwMEAwUFBgYFBgUFBQUEBQUFBAUEBgYGBgUICAYFBQYHBQYFBQUGBQcIBgcFBQcFBQcFBgYGBQUHBQUGBQUFBQQJBQUFBQUEBQUFBQYGBgcHBAUEBQUDAwMDAwMDBQUHBQYCAgICAgIFAgIGBgUFAwYGBgYGBgYGBQUFBQICAgIGBgYGBgYGBgYGBQUFBQUFBQUFBQUFBQICAgIFBQUFBQUFBQUFBAQGBQYFBgUGBQYFBgUGBQYGBQUFBQUFBQUFBQYFBgUGBQYFBgUCAgICAgICAgIHBAUCBgUFAgUCBQMFAwYFBgUGBQUGBQYFBgUGAwYDBgMFBQUFBQUFBQUFBQMFAwUDBgUGBQYFBgUGBQYFCAcFBAUFBAUEBQQICAYFBQUFBQUFBQUFBQUEBAQEAgICAgYFBQUFBQUFBQUFBQUFBQUFBQUEBAQEBAUFBQUGAgICAgIEBQQEBAQGBgYFBQUFBQUFBQUFBQUFBQUFBQUFBwUFBQUFBgYHAwYGBgMGBgUFBgIGCAYGBgUFBgIFBQUFAwUFBQUEBAMFBQUHBQUFAgIFBgYGBgYFBQYIBgYGBgYFBgUFBQUFBQQEBQQFAgICBQQIBwgHCAcFBAIDBQICCAgGBQUGBQUGBgYFCQoFBQYFBQUCCAcCBgUGBQgIBQUGBQUIBwUFBgUGBQYFBgUGBQYFBgQGBAYEBgUIBwYEBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBQUFBQUFBQUFBQUFBQUFBQICAgIGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgYGBgYGBgYGBgUEBQQFBAUFBgUGBQUEBgQGBQYFBQQIBwcFBQYGBQQGBQYFBgUIBwYFBQUGBAUFBwUFBQUFBQYFBgUGBQUFAgIGBQYDBgUFBgUGBQYFBgUGBQYFBQIICAYFBgUGAwUFBQMGBAYECAcFBAcFBQYCBQUGBQUEBQYCBQcFBQUFBQIFBAQFAgIEBQUFBQQEBgcGBQUFBQUFBQYFBQYGBQYGBQUFAAAAAwAAAAMAAAAcAAMAAQAAABwAAwAKAAAGiAAEBmwAAADqAIAABgBqAAAAAgANAH4AoACsAK0AvwDGAM8A5gDvAP4BDwERASUBJwEwAVMBXwFnAX4BfwGPAZIBoQGwAfAB/wIbAjcCWQK8AscCyQLdAvMDAQMDAwkDDwMjA4oDjAOSA6EDsAO5A8kDzgPSA9YEJQQvBEUETwRiBG8EeQSGBM4E1wThBPUFAQUQBRMeAR4/HoUe8R7zHvkfTSALIBEgFSAeICIgJyAwIDMgOiA8IEQgdCB/IKQgqiCsILEguiC9IQUhEyEWISIhJiEuIV4iAiIGIg8iEiIaIh4iKyJIImAiZSXK7gL2w/sE/v///f//AAAAAAACAA0AIACgAKEArQCuAMAAxwDQAOcA8AD/ARABEgEmASgBMQFUAWABaAF/AY8BkgGgAa8B8AH6AhgCNwJZArwCxgLJAtgC8wMAAwMDCQMPAyMDhAOMA44DkwOjA7EDugPKA9ED1gQABCYEMARGBFAEYwRwBHoEiATPBNgE4gT2BQIFER4AHj4egB6gHvIe9B9NIAAgECATIBcgICAlIDAgMiA5IDwgRCB0IH8goyCmIKsgsSC5ILwhBSETIRYhIiEmIS4hWyICIgYiDyIRIhoiHiIrIkgiYCJkJcruAfbD+wH+///8//8AAQAA//b/5AGl/8IBmf/BAAABjAAAAYcAAAGDAAABgQAAAX8AAAF3AAABef8V/wb/BP73/uoBuwAAAAD+ZP5DAPD91/3W/cj9s/2n/ab9of2c/YkAAP/L/8oAAAAA/QkAAP+r/P38+gAA/LkAAPyxAAD8pgAA/KAAAP71AAD+8gAA/EkAAOWv5W/lIOVP5LTlTeVd4VvhVwAA4VThU+FR4UnjduFB427hOOEJ4P8AAODaAADg1eDO4M3ghuB54HfgbN+T4GHgNd+S3qvfht+F337fe99v31PfPN8529UTnwrfBqMCqwGvAAEAAAAAAAAAAAAAAAAAAAAAANoAAADkAAABDgAAASgAAAEoAAABKAAAAWoAAAAAAAAAAAAAAAAAAAFqAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYgAAAAABagGGAAABngAAAAAAAAG2AAAB/gAAAiYAAAJIAAACWAAAAuIAAALyAAADBgAAAAAAAAAAAAAAAAAAAAAAAAL4AAAAAAAAAAAAAAAAAAAAAAAAAAAC6AAAAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACTAJNAk4CTwJQAlEAgQJIAlwCXQJeAl8CYAJhAIIAgwJiAmMCZAJlAmYAhACFAmcCaAJpAmoCawJsAIYAhwJ3AngCeQJ6AnsCfACIAIkCfQJ+An8CgAKBAIoCRwRHAIsCSQCMArACsQKyArMCtAK1AI0CtgK3ArgCuQK6ArsCvAK9AI4AjwK+Ar8CwALBAsICwwLEAJAAkQLFAsYCxwLIAskCygCSAJMC2QLaAt0C3gLfAuACSgJLAlICbQL4AvkC+gL7AtcC2ALbAtwArQCuA1MArwNUA1UDVgCwALEDXQNeA18AsgNgA2EAswNiA2MAtANkALUDZQC2A2YDZwC3A2gAuAC5A2kDagNrA2wDbQNuA28DcADDA3IDcwDEA3EAxQDGAMcAyADJAMoAywN0AMwAzQOxA3oA0QN7ANIDfAN9A34DfwDTANQA1QOBA7IDggDWA4MA1wOEA4UA2AOGANkA2gDbA4cDgADcA4gDiQOKA4sDjAONA44A3QDeA48DkADpAOoA6wDsA5EA7QDuAO8DkgDwAPEA8gDzA5MA9AOUA5UA9QOWAPYDlwOzA5gBAQOZAQIDmgObA5wDnQEDAQQBBQOeA7QDnwEGAQcBCARdA7UDtgEWARcBGAEZA7cDuAO6A7kBJwEoBGIEYwRcASkBKgErASwBLQReBF8BLgEvBFcEWAO7A7wESQRKATABMQRgBGEBMgEzBEsETAE0ATUBNgE3ATgBOQO9A74ETQROA78DwARqBGsETwRQAToBOwRRBFIBPAE9AT4EWwE/AUAEWQRaA8EDwgPDAUEBQgRoBGkBQwFEBGQEZQRTBFQEZgRnAUUDzgPNA88D0APRA9ID0wFGAUcEVQRWA+gD6QFIAUkD6gPrBGwEbQFKA+wEbgPtA+4BaQFqBHAEbwF/BEgBhQAMAAAAAAxAAAAAAAAAAQQAAAAAAAAAAAAAAAEAAAACAAAAAgAAAAIAAAANAAAADQAAAAMAAAAgAAAAfgAAAAQAAACgAAAAoAAAAkUAAAChAAAArAAAAGMAAACtAAAArQAAAkYAAACuAAAAvwAAAG8AAADAAAAAxQAAAkwAAADGAAAAxgAAAIEAAADHAAAAzwAAAlMAAADQAAAA0AAAAkgAAADRAAAA1gAAAlwAAADXAAAA2AAAAIIAAADZAAAA3QAAAmIAAADeAAAA3wAAAIQAAADgAAAA5QAAAmcAAADmAAAA5gAAAIYAAADnAAAA7wAAAm4AAADwAAAA8AAAAIcAAADxAAAA9gAAAncAAAD3AAAA+AAAAIgAAAD5AAAA/QAAAn0AAAD+AAAA/gAAAIoAAAD/AAABDwAAAoIAAAEQAAABEAAAAkcAAAERAAABEQAABEcAAAESAAABJQAAApMAAAEmAAABJgAAAIsAAAEnAAABJwAAAkkAAAEoAAABMAAAAqcAAAExAAABMQAAAIwAAAEyAAABNwAAArAAAAE4AAABOAAAAI0AAAE5AAABQAAAArYAAAFBAAABQgAAAI4AAAFDAAABSQAAAr4AAAFKAAABSwAAAJAAAAFMAAABUQAAAsUAAAFSAAABUwAAAJIAAAFUAAABXwAAAssAAAFgAAABYQAAAtkAAAFiAAABZQAAAt0AAAFmAAABZwAAAkoAAAFoAAABfgAAAuEAAAF/AAABfwAAAJQAAAGPAAABjwAAAJUAAAGSAAABkgAAAJYAAAGgAAABoQAAAJcAAAGvAAABsAAAAJkAAAHwAAAB8AAAA6sAAAH6AAAB+gAAAlIAAAH7AAAB+wAAAm0AAAH8AAAB/wAAAvgAAAIYAAACGQAAAtcAAAIaAAACGwAAAtsAAAI3AAACNwAAAJsAAAJZAAACWQAAAJwAAAK8AAACvAAAA6wAAALGAAACxwAAAJ0AAALJAAACyQAAAJ8AAALYAAAC3QAAAKAAAALzAAAC8wAAAKYAAAMAAAADAQAAAKcAAAMDAAADAwAAAKkAAAMJAAADCQAAAKoAAAMPAAADDwAAAKsAAAMjAAADIwAAAKwAAAOEAAADhQAAAK0AAAOGAAADhgAAA1MAAAOHAAADhwAAAK8AAAOIAAADigAAA1QAAAOMAAADjAAAA1cAAAOOAAADkgAAA1gAAAOTAAADlAAAALAAAAOVAAADlwAAA10AAAOYAAADmAAAALIAAAOZAAADmgAAA2AAAAObAAADmwAAALMAAAOcAAADnQAAA2IAAAOeAAADngAAALQAAAOfAAADnwAAA2QAAAOgAAADoAAAALUAAAOhAAADoQAAA2UAAAOjAAADowAAALYAAAOkAAADpQAAA2YAAAOmAAADpgAAALcAAAOnAAADpwAAA2gAAAOoAAADqQAAALgAAAOqAAADsAAAA2kAAAOxAAADuQAAALoAAAO6AAADugAAA3AAAAO7AAADuwAAAMMAAAO8AAADvQAAA3IAAAO+AAADvgAAAMQAAAO/AAADvwAAA3EAAAPAAAADxgAAAMUAAAPHAAADxwAAA3QAAAPIAAADyQAAAMwAAAPKAAADzgAAA3UAAAPRAAAD0gAAAM4AAAPWAAAD1gAAANAAAAQAAAAEAAAAA7EAAAQBAAAEAQAAA3oAAAQCAAAEAgAAANEAAAQDAAAEAwAAA3sAAAQEAAAEBAAAANIAAAQFAAAECAAAA3wAAAQJAAAECwAAANMAAAQMAAAEDAAAA4EAAAQNAAAEDQAAA7IAAAQOAAAEDgAAA4IAAAQPAAAEDwAAANYAAAQQAAAEEAAAA4MAAAQRAAAEEQAAANcAAAQSAAAEEwAAA4QAAAQUAAAEFAAAANgAAAQVAAAEFQAAA4YAAAQWAAAEGAAAANkAAAQZAAAEGQAAA4cAAAQaAAAEGgAAA4AAAAQbAAAEGwAAANwAAAQcAAAEIgAAA4gAAAQjAAAEJAAAAN0AAAQlAAAEJQAAA48AAAQmAAAELwAAAN8AAAQwAAAEMAAAA5AAAAQxAAAENAAAAOkAAAQ1AAAENQAAA5EAAAQ2AAAEOAAAAO0AAAQ5AAAEOQAAA5IAAAQ6AAAEPQAAAPAAAAQ+AAAEPgAAA5MAAAQ/AAAEPwAAAPQAAARAAAAEQQAAA5QAAARCAAAEQgAAAPUAAARDAAAEQwAAA5YAAAREAAAERAAAAPYAAARFAAAERQAAA5cAAARGAAAETwAAAPcAAARQAAAEUAAAA7MAAARRAAAEUQAAA5gAAARSAAAEUgAAAQEAAARTAAAEUwAAA5kAAARUAAAEVAAAAQIAAARVAAAEWAAAA5oAAARZAAAEWwAAAQMAAARcAAAEXAAAA54AAARdAAAEXQAAA7QAAAReAAAEXgAAA58AAARfAAAEYQAAAQYAAARiAAAEYgAABF0AAARjAAAEbwAAAQkAAARwAAAEcQAAA7UAAARyAAAEdQAAARYAAAR2AAAEdwAAA7cAAAR4AAAEeAAAA7oAAAR5AAAEeQAAA7kAAAR6AAAEhgAAARoAAASIAAAEiQAAAScAAASKAAAEiwAABGIAAASMAAAEjAAABFwAAASNAAAEkQAAASkAAASSAAAEkwAABF4AAASUAAAElQAAAS4AAASWAAAElwAABFcAAASYAAAEmQAAA7sAAASaAAAEmwAABEkAAAScAAAEnQAAATAAAASeAAAEnwAABGAAAASgAAAEoQAAATIAAASiAAAEowAABEsAAASkAAAEqQAAATQAAASqAAAEqwAAA70AAASsAAAErQAABE0AAASuAAAErwAAA78AAASwAAAEsQAABGoAAASyAAAEswAABE8AAAS0AAAEtQAAAToAAAS2AAAEtwAABFEAAAS4AAAEugAAATwAAAS7AAAEuwAABFsAAAS8AAAEvQAAAT8AAAS+AAAEvwAABFkAAATAAAAEwgAAA8EAAATDAAAExAAAAUEAAATFAAAExgAABGgAAATHAAAEyAAAAUMAAATJAAAEygAABGQAAATLAAAEzAAABFMAAATNAAAEzgAABGYAAATPAAAE1wAAA8QAAATYAAAE2AAAAUUAAATZAAAE2QAAA84AAATaAAAE2gAAA80AAATbAAAE3wAAA88AAATgAAAE4QAAAUYAAATiAAAE9QAAA9QAAAT2AAAE9wAABFUAAAT4AAAE+QAAA+gAAAT6AAAE+wAAAUgAAAT8AAAE/QAAA+oAAAT+AAAE/wAABGwAAAUAAAAFAAAAAUoAAAUBAAAFAQAAA+wAAAUCAAAFEAAAAUsAAAURAAAFEQAABG4AAAUSAAAFEwAAA+0AAB4AAAAeAQAAA68AAB4+AAAePwAAA60AAB6AAAAehQAAA6AAAB6gAAAe8QAAA+8AAB7yAAAe8wAAA6YAAB70AAAe+QAABEEAAB9NAAAfTQAABKoAACAAAAAgCwAAAVsAACAQAAAgEQAAAWcAACATAAAgFAAAAWkAACAVAAAgFQAABHAAACAXAAAgHgAAAWsAACAgAAAgIgAAAXMAACAlAAAgJwAAAXYAACAwAAAgMAAAAXkAACAyAAAgMwAAA6gAACA5AAAgOgAAAXoAACA8AAAgPAAAA6oAACBEAAAgRAAAAXwAACB0AAAgdAAAAX0AACB/AAAgfwAAAX4AACCjAAAgowAABG8AACCkAAAgpAAAAX8AACCmAAAgqgAAAYAAACCrAAAgqwAABEgAACCsAAAgrAAAAYUAACCxAAAgsQAAAYYAACC5AAAgugAAAYcAACC8AAAgvQAAAYkAACEFAAAhBQAAAYsAACETAAAhEwAAAYwAACEWAAAhFgAAAY0AACEiAAAhIgAAAY4AACEmAAAhJgAAALkAACEuAAAhLgAAAY8AACFbAAAhXgAAAZAAACICAAAiAgAAAZQAACIGAAAiBgAAALEAACIPAAAiDwAAAZUAACIRAAAiEgAAAZYAACIaAAAiGgAAAZgAACIeAAAiHgAAAZkAACIrAAAiKwAAAZoAACJIAAAiSAAAAZsAACJgAAAiYAAAAZwAACJkAAAiZQAAAZ0AACXKAAAlygAAAZ8AAO4BAADuAgAAAaAAAPbDAAD2wwAAAaIAAPsBAAD7BAAAAaQAAP7/AAD+/wAAAaoAAP/8AAD//QAAAauwACxLsAlQWLEBAY5ZuAH/hbCEHbEJA19eLbABLCAgRWlEsAFgLbACLLABKiEtsAMsIEawAyVGUlgjWSCKIIpJZIogRiBoYWSwBCVGIGhhZFJYI2WKWS8gsABTWGkgsABUWCGwQFkbaSCwAFRYIbBAZVlZOi2wBCwgRrAEJUZSWCOKWSBGIGphZLAEJUYgamFkUlgjilkv/S2wBSxLILADJlBYUViwgEQbsEBEWRshISBFsMBQWLDARBshWVktsAYsICBFaUSwAWAgIEV9aRhEsAFgLbAHLLAGKi2wCCxLILADJlNYsEAbsABZioogsAMmU1gjIbCAioobiiNZILADJlNYIyGwwIqKG4ojWSCwAyZTWCMhuAEAioobiiNZILADJlNYIyG4AUCKihuKI1kgsAMmU1iwAyVFuAGAUFgjIbgBgCMhG7ADJUUjISMhWRshWUQtsAksS1NYRUQbISFZLbAKLLAkRS2wCyywJUUtsAwssScBiCCKU1i5QAAEAGO4CACIVFi5ACQD6HBZG7AjU1iwIIi4EABUWLkAJAPocFlZWS2wDSywQIi4IABaWLElAEQbuQAlA+hEWS2wDCuwACsAsgEOAisBsg8BAisBtw86MCUbEAAIKwC3AUg7LiEUAAgrtwJYSDgoFAAIK7cDUkM0JRYACCu3BF5NPCsZAAgrtwU2LCIZDwAIK7cGcV1GMhsACCu3B5F3XDojAAgrtwh+Z1A5GgAIK7cJVEU2JhcACCu3CnZgSzYdAAgrtwuDZE46IwAIK7cM2bKKYzwACCu3DRQRDQkGAAgrtw48MiccEQAIKwCyEAoHK7AAIEV9aRhEsjASAXOysBQBc7JQFAF0soAUAXSycBQBdbIPHAFzsm8cAXUAACoAnQCAAIoAeADUAGQATgBaAIcAYABWADQCPAC8AMQAAAAU/mAAFAKbACADIQALBDoAFASNABAFsAAUBhgAFQGmABEGwAAOAAAAAAAAAGEAYQBhAGEAYQCTALgBOAGqAjoCzQLkAw4DOANrA5ADrwPFA+YD/QRKBHgExwU8BX8F3wY+BmsG3wdGB1sHcAePB7YH1QgzCNYJFQl0CcgKDQpNCoMK6wstC0gLewvQC/QMQgx+DNMNHg2DDd8OSg50DrYO5g87D5APwA/4EBwQMxBYEH8QmhC6ETIRkBHjEkESqBL6E3QTuRPxFD0UlBSvFRoVZRWzFhcWeBa1Fx8XcRe4F+gYNhh9GMIY+hk7GVIZkhnZGgwaaBraGz0bnBu7HGAcjx01HaMdrx3MHoQemh7WHxkfaR/kIAQgTSB5IJgg0yEFIU8hWyF1IY8hqSIKIm0iqyMmI3oj6iSoJRclaCXZJjgmliaxJwEnSyeIJ9koNCi3KVEpginnKk4quCsYK2srxCvyLFUsgyynLLUs4Cz/LTgtbC2wLeMuIS4+LlsuZC6XLsgu5C8AL0MvTy91L6IwHTBKMIwwujD2MWcxwTIpMp4zEzNGM7c0IzR/NMo1SjV3NdA2PjaPNuk3RDebN944HziIOOQ5SznCOhU6izrmO1871TxHPJs81z0uPYY99D5pPq4++D9AP7E/50AsQGlAskEKQW1BuUI2QsdDIkOSRAlEL0SFRPhFcUWqRgFGSEaQRuxHGkdGR9FIB0hHSIRIyEkfSYFJy0o9SsNLHkuVTBVMikz3TV5Nmk38TlxOxE9GT+FQLVB8UOdRVlHLUjpSxVNPU99UelT8VXRVuFX+VmpW0VeKWERYw1lCWZNZ4FoVWjFaaFp+WpRbZVvYXEBcm10OXT5daF29XhJeaV7LXx9ffl/IYDFgj2DtYYxiI2JzYrZjBmNUY5ZkBmR3ZM9lM2WsZiNmi2brZ0RnU2dnZ7RoF2ieaQ5pe2neaj5qrGsVa55sIGx8bM5tIG1xbeZuFW4VbhVuFW4VbhVuFW4VbhVuFW4VbhVuFW4dbiVuL245blBudG6Ybrpu1W7hbu1vJW9jb8Rv52/zcANwF3DocQRxIXE0cUhxj3IXcrRzQ3NPdA90cnTudYt17XZmdr93KXfZeD9403kxeZN5pHm1ecZ513pIem56pnrBevV7h3vIfFN8k3yxfM99CH0VfT99Yn1ufdZ+KH60fyJ/lIBXgFeCBoJygp+C6IMTgymDmYP5hEeEtIULhVOFm4XqhgSGQ4aphv2HRIeHh76IHYheiHmIr4jyiRaJZ4mgifOKPYqbivOLWIuCi7+L74xHjJCMwIz4jUGNbI27jiqObI7IjyGPTo/KkCeQPZCikUuRrpIRkmGSppLnkymTnJQAlG6UmJTOlTSVZpWyleSWI5aJluCXQZefmA+Yg5j4mUqZiZngmjeaq5skm2CbsJv4nD6ceZy6nPmdQ52bnaed9J5jnuCfN595n/6gX6DAoR2hsKHBohyiaKK2ovijaKPLpC+kn6UxpbWmS6a9px2nb6fPqEmoUai2qRepeanwqkuqu6sHq2arzqv4rEusd6zHrQutH60zrUWtWa1rrYKtlq3srhKuk671r0OvS69Tr1uvZq9ur3qv3a/dr+WwS7CxsRCxUrG2sc2x5LH7shKyK7JEslCyXLJzsoqyobK6stGy6LL/sxizL7NGs12zdLOLs6Szu7PSs+m0ArQZtDC0R7RdtHO0jLSltLG0vbTUtOu1AbUatTC1RrVdtXa1jLWjtbq10LXmtf+2FrYttkO2XLZztou2ora4ts+25rdJt9+39rgNuCS4OrhRuGi4f7iVuKy43bj0uQq5Ibk4uU+5ZrnOulK6abp/upa6rLrDutq68bsIuxS7K7tCu1S7a7uCu5m7sLvHu9676bv0vAu8F7wjvDq8UbxdvGm8gLyXvKO8r7zEvPm9Bb0RvSi9P71LvVe9br2EvZS9q73Bvdi9774IviG+OL5Pvlu+Z75+vpS+q77Cvtm+7777vwe/E78fvza/TL9Yv2S/cL98v5O/n7+2v8y/47/5wBDAJ8BAwFnAcsCLwOjBTsFlwXzBk8GpwcLB2cHwwgfCHsI1wkvCYsJ5wpDCp8LKwvLDBcMcwzPDScNfw3jDkcOdw6nDwMPXw+3EBcQbxDHESMRhxHjEj8SmxL3E1MTtxQTFG8UxxUrFYcV3xY7F8cYIxh7GNcZMxmLGeMaOxqXHDsckxzrHUcdox3THi8eix7nH0Mfbx/HICMgUyCrINshLyFfIbsh6yJHIqMi/yNjI78j7yRHJKMk+yUrJYMlsyYLJjsmkybrJ0cnqygPKX8p2yozKpMq7ytLK6Mrzyv/LC8sXyyPLL8s7y1fLX8tny2/Ld8t/y4fLj8uXy5/Lp8uvy7fLv8vHy+DL+cwQzCfMPsxUzG/Md8x/zIfMj8yXzK/Mx8zezPXNDM0lzTzNp82vzcjN0M3Yze/OBs4OzhbOHs4mzj3ORc5NzlXOXc5lzm3Odc59zoXOjc6kzqzOtM8Hzw/PF88wz0fPT89Xz3DPeM+Pz6XPvM/Tz+rQAdAa0DPQStBh0GnQcdB90JTQnNCz0MrQ1tDi0PnRENEn0T7RRtFO0WfRgNGM0ZjRpNGw0bzRyNHQ0djR4NH30g7SFtIt0kTSW9J00nzShNKb0rLSy9LT0uzTBdMe0zfTT9Nm03zTldOu08fT4NPo0/DUCdQi1DvUU9Rq1IDUmdSx1MrU49T81RTVMdVO1VrVZtVu1XrVhtWS1Z7VtdXM1eXV/dYW1i7WR9Zf1njWkNar1sXW3tb31xDXKddC11vXdNeN16jXw9fP19vX8tgJ2CDYNthP2GfYgNiY2LHYydji2PrZFdkv2UbZXdlp2XXZgdmN2aTZu9nU2ezaBdod2jbaTtpn2n/amtq02sva4tr52xDbJ9s+21Xba9t324Pbj9ub27Lbydvg2/fcDtwl3DzcU9xq3IDcjNyY3KTcsNzH3N7c9d0L3YHdlt2i3a7dut3G3dLd3t3q3fbeAt4O3hreJt4y3j7eSt5W3mLebt523tTfMt9037PgF+B14JDgq+C34MPgz+Db4Ofg8+E94Y3h5eI74kPiT+JZ4mHiaeJx4nnigeKJ4qDit+LO4uXi/uMX4zDjSeNi43vjlOOt48bj3+P45BHkHeQp5DXkQeRN5FnkZeRx5H3klOSm5LLkvuTK5Nbk4uTu5PrlBuUd5TTlQOVM5VjlZOVw5Xzlk+Wp5bXlweXN5dnl5eXx5f3mCeYV5iHmLeY55kXmUeZZ5mHmaeZx5nnmgeaJ5pHmmeah5qnmsea55tLm6ucC5xnnIecp50LnSudh53fnf+eH54/nl+eu57bnvufG587n1ufe5+bn7uh46MTpIukq6TbpTelj6Wvpd+mD6Y/pmwAAAAUAZAAAAygFsAADAAYACQAMAA8AcbIMEBEREjmwDBCwANCwDBCwBtCwDBCwCdCwDBCwDdAAsABFWLACLxuxAhw+WbAARViwAC8bsQAQPlmyBAIAERI5sgUCABESObIHAgAREjmyCAIAERI5sQoM9LIMAgAREjmyDQIAERI5sAIQsQ4M9DAxISERIQMRAQERAQMhATUBIQMo/TwCxDb+7v66AQzkAgP+/gEC/f0FsPqkBQf9fQJ3+xECeP1eAl6IAl4AAgCg//UBewWwAAMADAAvALAARViwAi8bsQIcPlmwAEVYsAsvG7ELED5ZsgYFCitYIdgb9FmyAQYCERI5MDEBIwMzAzQ2MhYUBiImAVunDcLJN2w4OGw3AZsEFfqtLT09Wjs7AAIAiAQSAiMGAAAEAAkAGQCwAy+yAgoDERI5sAIvsAfQsAMQsAjQMDEBAyMTMwUDIxMzARUebwGMAQ4ebwGMBXj+mgHuiP6aAe4AAgB3AAAE0wWwABsAHwCPALAARViwDC8bsQwcPlmwAEVYsBAvG7EQHD5ZsABFWLACLxuxAhA+WbAARViwGi8bsRoQPlmyHQwCERI5fLAdLxiyAAMKK1gh2Bv0WbAE0LAdELAG0LAdELAL0LALL7IIAworWCHYG/RZsAsQsA7QsAsQsBLQsAgQsBTQsB0QsBbQsAAQsBjQsAgQsB7QMDEBIQMjEyM1IRMhNSETMwMhEzMDMxUjAzMVIwMjAyETIQL9/vhQj1DvAQlF/v4BHVKPUgEIUpBSzOdF4ftQkJ4BCEX++AGa/mYBmokBYosBoP5gAaD+YIv+non+ZgIjAWIAAAEAbv8wBBEGnAArAGYAsABFWLAJLxuxCRw+WbAARViwIi8bsSIQPlmyAiIJERI5sAkQsAzQsAkQsBDQsAkQshMBCitYIdgb9FmwAhCyGQEKK1gh2Bv0WbAiELAf0LAiELAm0LAiELIpAQorWCHYG/RZMDEBNCYnJiY1NDY3NTMVFhYVIzQmIyIGFRQWBBYWFRQGBxUjNSYmNTMUFjMyNgNYgZnVw7+nlai7uIZyd36FATGrUcu3lLrTuZKGg5YBd1x+M0HRoaTSFNvcF+zNjaZ7bmZ5Y3eeaqnOE7+/EefGi5Z+AAUAaf/rBYMFxQANABoAJgA0ADgAeACwAEVYsAMvG7EDHD5ZsABFWLAjLxuxIxA+WbADELAK0LAKL7IRBAorWCHYG/RZsAMQshgECitYIdgb9FmwIxCwHdCwHS+wIxCyKgQKK1gh2Bv0WbAdELIxBAorWCHYG/RZsjUjAxESObA1L7I3AyMREjmwNy8wMRM0NjMyFhUVFAYjIiY1FxQWMzI2NTU0JiIGFQE0NiAWFRUUBiAmNRcUFjMyNjU1NCYjIgYVBScBF2mng4Wlp4GCqopYSkdXVpRWAjunAQaop/78qopYSkhWV0lHWf4HaQLHaQSYg6qriEeEp6eLB05lYlVJTmZmUvzRg6moi0eDqaeLBk9lY1VKT2RjVPNCBHJCAAMAZf/sBPMFxAAeACcAMwCFALAARViwCS8bsQkcPlmwAEVYsBwvG7EcED5ZsABFWLAYLxuxGBA+WbIiHAkREjmyKgkcERI5sgMiKhESObIQKiIREjmyEQkcERI5shMcCRESObIZHAkREjmyFhEZERI5sBwQsh8BCitYIdgb9FmyIR8RERI5sAkQsjEBCitYIdgb9FkwMRM0NjcmJjU0NjMyFhUUBgcHATY1MxQHFyMnBgYjIiQFMjcBBwYVFBYDFBc3NjY1NCYjIgZldaVhQsSolsRZb2sBRESne9DeYUrHZ9X+/gHXk3r+nSGnmSJ2dkQyZExSYAGHabB1dpBHpryvhViVUk/+fYKf/6j5c0JF4ktwAakYe4J2jgPlYJBTMFc+Q1lvAAEAZwQhAP0GAAAEABAAsAMvsgIFAxESObACLzAxEwMjEzP9FYEBlQWR/pAB3wABAIX+KgKVBmsAEQAJALAOL7AELzAxEzQSEjcXBgIDBxATFhcHJicChXnwgSaSuwkBjVV1JoV57AJP4gGgAVRGenD+NP7jVf5+/uSqYHFKrgFUAAABACb+KgI3BmsAEQAJALAOL7AELzAxARQCAgcnNhITNTQCAic3FhISAjd18YQnmrsCWJ1iJ4TvdwJF3/5n/qZJcXYB8QEvINIBaQEeUHFJ/qr+ZAABABwCYQNVBbAADgAgALAARViwBC8bsQQcPlmwANAZsAAvGLAJ0BmwCS8YMDEBJTcFAzMDJRcFEwcDAycBSv7SLgEuCZkKASku/s3GfLq0fQPXWpdwAVj+o26YW/7xXgEg/udbAAABAE4AkgQ0BLYACwAaALAJL7AA0LAJELIGAQorWCHYG/RZsAPQMDEBIRUhESMRITUhETMCngGW/mq6/moBlroDDa/+NAHMrwGpAAEAHf7eATQA2wAIABcAsAkvsgQFCitYIdgb9FmwANCwAC8wMRMnNjc1MxUUBoZpXgS1Y/7eSIOLp5FlygAAAQAlAh8CDQK2AAMAEQCwAi+yAQEKK1gh2Bv0WTAxASE1IQIN/hgB6AIflwABAJD/9QF2ANEACQAbALAARViwBy8bsQcQPlmyAgUKK1gh2Bv0WTAxNzQ2MhYVFAYiJpA5cjs7cjlhMEBAMC4+PgABABL/gwMQBbAAAwATALAAL7AARViwAi8bsQIcPlkwMRcjATOxnwJgnn0GLQAAAgBz/+wECgXEAA0AGwA5ALAARViwCi8bsQocPlmwAEVYsAMvG7EDED5ZsAoQshEBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxARACIyICAzUQEjMyEhMnNCYjIgYHERQWMzI2NwQK3uzp4ATe7eveA7mEj46CAomLiYUDAm3+u/7EATUBM/cBQQE4/tP+xg3r19be/tjs4dTkAAEAqgAAAtkFtwAGADkAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvsgMBCitYIdgb9FmyAgMFERI5MDEhIxEFNSUzAtm6/osCEh0E0YmoxwAAAQBdAAAEMwXEABcATQCwAEVYsBAvG7EQHD5ZsABFWLAALxuxABA+WbIXAQorWCHYG/RZsALQsgMQFxESObAQELIJAQorWCHYG/RZsBAQsAzQshUXEBESOTAxISE1ATY2NTQmIyIGFSM0JDMyFhUUAQEhBDP8RgH4cFWKc4qZuQED2cvs/u7+egLbhQIwf59VcpKdjMn41bHX/tf+WQABAF7/7AP5BcQAJgB4ALAARViwDS8bsQ0cPlmwAEVYsBkvG7EZED5ZsgANGRESObAAL7LPAAFdsp8AAXGyLwABXbJfAAFysA0QsgYBCitYIdgb9FmwDRCwCdCwABCyJgEKK1gh2Bv0WbITJgAREjmwGRCwHNCwGRCyHwEKK1gh2Bv0WTAxATM2NjUQIyIGFSM0NjMyFhUUBgcWFhUUBCAkNTMUFjMyNjU0JicjAYaLg5b/eI+5/cPO6ntqeIP/AP5m/v+6ln6GjpyTiwMyAoZyAQCJca3l2sJfsiwmsH/E5t62c4qMg3+IAgACADUAAARQBbAACgAOAEkAsABFWLAJLxuxCRw+WbAARViwBC8bsQQQPlmyAQkEERI5sAEvsgIBCitYIdgb9FmwBtCwARCwC9CyCAYLERI5sg0JBBESOTAxATMVIxEjESE1ATMBIREHA4bKyrr9aQKMxf2BAcUWAemX/q4BUm0D8fw5AsooAAEAmv/sBC0FsAAdAGEAsABFWLABLxuxARw+WbAARViwDS8bsQ0QPlmwARCyBAEKK1gh2Bv0WbIHDQEREjmwBy+yGgEKK1gh2Bv0WbIFBxoREjmwDRCwEdCwDRCyFAEKK1gh2Bv0WbAHELAd0DAxExMhFSEDNjMyEhUUAiMiJiczFhYzMjY1NCYjIgcHzkoC6v2zLGuIx+rz2sH0Ea8RkHaBk5+EeUUxAtoC1qv+cz/++eDh/v3WvX1/sJuSsTUoAAIAhP/sBBwFsQAUACEATgCwAEVYsAAvG7EAHD5ZsABFWLANLxuxDRA+WbAAELIBAQorWCHYG/RZsgcNABESObAHL7IVAQorWCHYG/RZsA0QshwBCitYIdgb9FkwMQEVIwYEBzYzMhIVFAIjIgA1NRAAJQMiBgcVFBYzMjY1NCYDTyLY/wAUc8e+4/XO0f78AVcBU9JfoB+ieX2PkQWxnQT44YT+9NTh/vIBQf1HAZIBqQX9cHJWRLTcuJWWuQABAE0AAAQlBbAABgAyALAARViwBS8bsQUcPlmwAEVYsAEvG7EBED5ZsAUQsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITUhBCX9pcICWfzsA9gFSPq4BRiYAAADAHD/7AQOBcQAFwAhACsAYQCwAEVYsBUvG7EVHD5ZsABFWLAJLxuxCRA+WbInCRUREjmwJy+yzycBXbIaAQorWCHYG/RZsgMaJxESObIPJxoREjmwCRCyHwEKK1gh2Bv0WbAVELIiAQorWCHYG/RZMDEBFAYHFhYVFAYjIiY1NDY3JiY1NDYzMhYDNCYiBhQWMzI2ASIGFRQWMjY0JgPsc2Jyhf/Q0v2BcmFw7MHA7Zeb+peTg4KU/upth4XehYoENG2qMDG8d73g4bx2vjEwqmy42Nj8oXqamPiOjwQah3RviYnejAAAAgBk//8D+AXEABcAJABYALAARViwCy8bsQscPlmwAEVYsBMvG7ETED5ZsgMTCxESObADL7IAAwsREjmwExCyFAEKK1gh2Bv0WbADELIYAQorWCHYG/RZsAsQsh8BCitYIdgb9FkwMQEGBiMiJiY1NDY2MzISERUQAAUjNTM2NiUyNjc1NCYjIgYVFBYDPjqhYH67Zm/MiNj5/rD+rSQn5fb+7l2dJJ55epSPAoBFVHzhiJLqfP69/uk2/lf+eQWcBOf6clRKtuS7mZXBAP//AIb/9QFtBEQAJgAS9gABBwAS//cDcwAQALAARViwDS8bsQ0YPlkwMf//ACn+3gFVBEQAJwAS/98DcwEGABAMAAAQALAARViwAy8bsQMYPlkwMQABAEgAwwN6BEoABgAWALAARViwBS8bsQUYPlmwAtCwAi8wMQEFFQE1ARUBCAJy/M4DMgKE/cQBe5IBesQAAAIAmAGPA9oDzwADAAcAJQCwBy+wA9CwAy+yAAEKK1gh2Bv0WbAHELIEAQorWCHYG/RZMDEBITUhESE1IQPa/L4DQvy+A0IDLqH9wKAAAAEAhgDEA9wESwAGABYAsABFWLACLxuxAhg+WbAF0LAFLzAxAQE1ARUBNQMb/WsDVvyqAooBA77+hpL+hcAAAgBL//UDdgXEABgAIQBRALAARViwEC8bsRAcPlmwAEVYsCAvG7EgED5ZshsFCitYIdgb9FmyABsQERI5sgQQABESObAQELIJAQorWCHYG/RZsBAQsAzQshUAEBESOTAxATY2Nzc2NTQmIyIGFSM2NjMyFhUUBwcGFQM0NjIWFAYiJgFlAjJNg1RuaWZ8uQLjtr3Tom1JwTdsODhsNwGad4pUh19taXdsW6LHy7GvqmxRmP7DLT09Wjs7AAACAGr+OwbWBZcANQBCAGgAsDIvsABFWLAILxuxCBA+WbAD0LIPMggREjmwDy+yBQgPERI5sAgQsjkCCitYIdgb9FmwFdCwMhCyGwIKK1gh2Bv0WbAIELAq0LAqL7IjAgorWCHYG/RZsA8QskACCitYIdgb9FkwMQEGAiMiJwYGIyImNzYSNjMyFhcDBjMyNjcSACEiBAIHBhIEMzI2NxcGBiMiJAITEhIkMzIEEgEGFjMyNjc3EyYjIgYGygzYtbs1NotKjpITD3m/aVGAUDQTk3GMBhP+uf6yyf7ItAsMkAEn0Vq1PCU+zWn6/pizDAzeAXzv+QFkrvvyDlFYPG8kAS44QHWZAfby/uioVVPozaUBA5QrP/3W5+C0AYUBmMf+iPb4/pPBLCNzJzLhAacBGwETAbfv4P5a/pCOmGZfCQH3He4AAAIAHAAABR0FsAAHAAoARgCwAEVYsAQvG7EEHD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMjATMBIwEhAwPN/Z6JxgIsqAItxf1NAe/4AXz+hAWw+lACGgKpAAMAqQAABIgFsAAOABYAHwBVALAARViwAS8bsQEcPlmwAEVYsAAvG7EAED5ZshcAARESObAXL7IPAQorWCHYG/RZsggPFxESObAAELIQAQorWCHYG/RZsAEQsh8BCitYIdgb9FkwMTMRITIWFRQGBxYWFRQGIwERITI2NRAhJSEyNjU0JiMhqQHc7e90ZHaJ/uj+xwE9hpv+4v7AASJ+l4yP/uQFsMTAZp0rIbmAxOACqf30i3oBB5p+bHhtAAABAHf/7ATYBcQAHABFALAARViwCy8bsQscPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WbADELAc0DAxAQYEIyAAETU0EiQzMgAXIyYmIyICFRUUEjMyNjcE2Bv+4e7+/v7JkQEKr+gBGBfBGaeWuNHGsqCrHAHO5/sBcgE2jMsBNKX+/eWunP7w+43t/uiRtAACAKkAAATGBbAACwAVADkAsABFWLABLxuxARw+WbAARViwAC8bsQAQPlmwARCyDAEKK1gh2Bv0WbAAELINAQorWCHYG/RZMDEzESEyBBIXFRQCBAcDETMyEjU1NAInqQGbvgEknwGf/tnE08re9+nWBbCo/srJXc7+yqYCBRL7iwEU/1X4ARMCAAABAKkAAARGBbAACwBOALAARViwBi8bsQYcPlmwAEVYsAQvG7EEED5ZsgsEBhESObALL7IAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASERIRUhESEVIREhA+D9iQLd/GMDk/0tAncCof38nQWwnv4sAAEAqQAABC8FsAAJAEAAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmyCQIEERI5sAkvsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASERIxEhFSERIQPM/Z3AA4b9OgJjAoP9fQWwnv4OAAEAev/sBNwFxAAfAGIAsABFWLALLxuxCxw+WbAARViwAy8bsQMQPlmwCxCwD9CwCxCyEQEKK1gh2Bv0WbADELIYAQorWCHYG/RZsh4DCxESObAeL7QPHh8eAl20Px5PHgJdsh0BCitYIdgb9FkwMSUGBCMiJAInNRAAITIEFyMCISICAxUUEjMyNjcRITUhBNxK/vewsv7slwIBMwEW5AEWH8A2/t7BxwHgv2yiNf6vAhC/ammnATTLfwFJAWrp1gEh/vH+/3f1/t8wOQFHnAABAKkAAAUIBbAACwBVALAARViwBi8bsQYcPlmwAEVYsAovG7EKHD5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmwABCwCdCwCS+ynwkBcrIvCQFdsgIBCitYIdgb9FkwMSEjESERIxEzESERMwUIwf0iwMAC3sECof1fBbD9jgJyAAABALcAAAF3BbAAAwAdALAARViwAi8bsQIcPlmwAEVYsAAvG7EAED5ZMDEhIxEzAXfAwAWwAAABADX/7APMBbAADwAuALAARViwAC8bsQAcPlmwAEVYsAUvG7EFED5ZsAnQsAUQsgwBCitYIdgb9FkwMQEzERQGIyImNTMUFjMyNjcDC8H70dnywImCd5MBBbD7+dHs3sh9jJaHAAABAKkAAAUFBbAACwB0ALAARViwBS8bsQUcPlmwAEVYsAcvG7EHHD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAIFERI5QBFKAFoAagB6AIoAmgCqALoACF2yOQABXbIGBQIREjlAEzYGRgZWBmYGdgaGBpYGpga2BgldMDEBBxEjETMRATMBASMCG7LAwAKH6P3DAmrmAqW5/hQFsP0wAtD9ffzTAAEAqQAABBwFsAAFACgAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WTAxJSEVIREzAWoCsvyNwZ2dBbAAAAEAqQAABlIFsAAOAFkAsABFWLAALxuxABw+WbAARViwAi8bsQIcPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbAARViwDC8bsQwQPlmyAQAEERI5sgcABBESObIKAAQREjkwMQkCMxEjERMBIwETESMRAaEB3AHc+cAS/iKT/iMTwAWw+1wEpPpQAjcCZPtlBJj9n/3JBbAAAAEAqQAABQgFsAAJAEyyAQoLERI5ALAARViwBS8bsQUcPlmwAEVYsAgvG7EIHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmyAgUAERI5sgcFABESOTAxISMBESMRMwERMwUIwf0jwcEC378EYvueBbD7mQRnAAIAdv/sBQkFxAARAB8AOQCwAEVYsA0vG7ENHD5ZsABFWLAELxuxBBA+WbANELIVAQorWCHYG/RZsAQQshwBCitYIdgb9FkwMQEUAgQjIiQCJzU0EiQzMgQSFScQAiMiAgcVFBIzMhI3BQmQ/viwrP72kwKSAQusrwELkL/Qu7bRA9O5uswDAqnW/sGoqQE5zmnSAUKrqf6/1QIBAwEV/uv2a/v+4QEP/QAAAgCpAAAEwAWwAAoAEwBNsgoUFRESObAKELAM0ACwAEVYsAMvG7EDHD5ZsABFWLABLxuxARA+WbILAwEREjmwCy+yAAEKK1gh2Bv0WbADELISAQorWCHYG/RZMDEBESMRITIEFRQEIyUhMjY1NCYnIQFpwAIZ7wEP/vf3/qkBWZqkpI/+nAI6/cYFsPTJ1OWdkYmCnAMAAgBt/woFBgXEABUAIgBNsggjJBESObAIELAZ0ACwAEVYsBEvG7ERHD5ZsABFWLAILxuxCBA+WbIDCBEREjmwERCyGQEKK1gh2Bv0WbAIELIgAQorWCHYG/RZMDEBFAIHBQclBiMiJAInNTQSJDMyBBIVJxACIyICBxUUEiASNwUBhnkBBIP+zUhQrP72kwKSAQussAELkMDNvrXRA9EBdMwDAqnT/s9WzHn0EqkBOc5p0gFCq6r+wdUBAQEBF/7r9mv6/uABD/0AAAIAqAAABMkFsAAOABcAYbIFGBkREjmwBRCwFtAAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmwAEVYsA0vG7ENED5ZshAEAhESObAQL7IAAQorWCHYG/RZsgsABBESObAEELIWAQorWCHYG/RZMDEBIREjESEyBBUUBgcBFSMBITI2NTQmJyECv/6qwQHi9gEJk4MBVs79bgEnj6mhmP7aAk39swWw4NaIyjL9lgwC6pR8h5ABAAABAFD/7ARyBcQAJgBhsgAnKBESOQCwAEVYsAYvG7EGHD5ZsABFWLAaLxuxGhA+WbAGELAL0LAGELIOAQorWCHYG/RZsiYaBhESObAmELIUAQorWCHYG/RZsBoQsB/QsBoQsiIBCitYIdgb9FkwMQEmJjU0JDMyFhYVIzQmIyIGFRQWBBYWFRQEIyIkJjUzFBYzMjY0JgJW9+EBE9yW64HBqJmOn5cBa81j/uznlv78jcHDo5iilgKJR8+YrOF0zHmEl31vWXtme6RvsdVzyH+EmXzWdQAAAQAxAAAElwWwAAcALgCwAEVYsAYvG7EGHD5ZsABFWLACLxuxAhA+WbAGELIAAQorWCHYG/RZsATQMDEBIREjESE1IQSX/iy//i0EZgUS+u4FEp4AAQCM/+wEqgWwABIAPLIFExQREjkAsABFWLAALxuxABw+WbAARViwCS8bsQkcPlmwAEVYsAUvG7EFED5Zsg4BCitYIdgb9FkwMQERBgAHByIAJxEzERQWMzI2NREEqgH+/9wz7/7kAr6uoaOtBbD8Is7++hACAQLiA+D8Jp6vrp4D2wAAAQAcAAAE/QWwAAYAOLIABwgREjkAsABFWLABLxuxARw+WbAARViwBS8bsQUcPlmwAEVYsAMvG7EDED5ZsgABAxESOTAxJQEzASMBMwKLAaDS/eSq/eXR/wSx+lAFsAAAAQA9AAAG7QWwABIAWQCwAEVYsAMvG7EDHD5ZsABFWLAILxuxCBw+WbAARViwES8bsREcPlmwAEVYsAovG7EKED5ZsABFWLAPLxuxDxA+WbIBAwoREjmyBgMKERI5sg0DChESOTAxARc3ATMBFzcTMwEjAScHASMBMwHjHCkBIKIBGSgf4sH+n6/+1BcX/smv/qDAAcvArQP4/AiwxAPk+lAEJW9v+9sFsAABADkAAATOBbAACwBrALAARViwAS8bsQEcPlmwAEVYsAovG7EKHD5ZsABFWLAELxuxBBA+WbAARViwBy8bsQcQPlmyAAEEERI5QAmGAJYApgC2AARdsgYBBBESOUAJiQaZBqkGuQYEXbIDAAYREjmyCQYAERI5MDEBATMBASMBASMBATMChAFd4v40Adfk/pr+mOMB2P4z4QOCAi79Lv0iAjj9yALeAtIAAAEADwAABLsFsAAIADEAsABFWLABLxuxARw+WbAARViwBy8bsQccPlmwAEVYsAQvG7EEED5ZsgABBBESOTAxAQEzAREjEQEzAmUBfNr+CsD+CtwC1QLb/G/94QIfA5EAAAEAVgAABHoFsAAJAEQAsABFWLAHLxuxBxw+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WbIEAAIREjmwBxCyBQEKK1gh2Bv0WbIJBQcREjkwMSUhFSE1ASE1IRUBOQNB+9wDHvzvA/ednZAEgp6NAAABAJL+yAILBoAABwAiALAEL7AHL7IAAQorWCHYG/RZsAQQsgMBCitYIdgb9FkwMQEjETMVIREhAgu/v/6HAXkF6Pl4mAe4AAABACj/gwM4BbAAAwATALACL7AARViwAC8bsQAcPlkwMRMzASMosAJgsAWw+dMAAQAJ/sgBgwaAAAcAJQCwAi+wAS+wAhCyBQEKK1gh2Bv0WbABELIGAQorWCHYG/RZMDETIREhNTMRIwkBev6GwcEGgPhImAaIAAABAEAC2QMUBbAABgAnsgAHCBESOQCwAEVYsAMvG7EDHD5ZsADQsgEHAxESObABL7AF0DAxAQMjATMBIwGqvqwBK38BKqsEu/4eAtf9KQABAAT/aQOYAAAAAwAbALAARViwAy8bsQMQPlmyAAEKK1gh2Bv0WTAxBSE1IQOY/GwDlJeXAAABADkE2AHaBf4AAwAjALABL7IPAQFdsADQGbAALxiwARCwAtCwAi+0DwIfAgJdMDEBIwEzAdqf/v7fBNgBJgAAAgBt/+wD6gROAB4AKAB5shcpKhESObAXELAg0ACwAEVYsBcvG7EXGD5ZsABFWLAELxuxBBA+WbAARViwAC8bsQAQPlmyAhcEERI5sgsXBBESObALL7AXELIPAQorWCHYG/RZshILFxESObAEELIfAQorWCHYG/RZsAsQsiMBCitYIdgb9FkwMSEmJwYjIiY1NCQzMzU0JiMiBhUjNDY2MzIWFxEUFxUlMjY3NSMgFRQWAygQCoGzoM0BAem0dHFjhrpzxXa71AQm/gtXnCOR/qx0IFKGtYupu1Vhc2RHUZdYu6T+DpVYEI1aSN7HV2IAAgCM/+wEIAYAAA4AGQBkshIaGxESObASELAD0ACwCC+wAEVYsAwvG7EMGD5ZsABFWLADLxuxAxA+WbAARViwBi8bsQYQPlmyBQgDERI5sgoMAxESObAMELISAQorWCHYG/RZsAMQshcBCitYIdgb9FkwMQEUAiMiJwcjETMRNiASESc0JiMiBxEWMzI2BCDkwM1wCaq5cAGK4bmSibdQVbSFlAIR+P7TkX0GAP3Di/7W/v0Fvc6q/iyqzgABAFz/7APsBE4AHQBJshAeHxESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsAgQsAPQsBAQsBTQsBAQshcBCitYIdgb9FkwMSUyNjczDgIjIgARNTQ2NjMyFhcjJiYjIgYVFRQWAj5jlAivBXbFbt3++3TZlLbxCK8Ij2mNm5qDeFpdqGQBJwEAH572iNquaYfLwCO7ygAAAgBf/+wD8AYAAA8AGgBkshgbHBESObAYELAD0ACwBi+wAEVYsAMvG7EDGD5ZsABFWLAMLxuxDBA+WbAARViwCC8bsQgQPlmyBQMMERI5sgoDDBESObAMELITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMRM0EjMyFxEzESMnBiMiAjUXFBYzMjcRJiMiBl/sv75vuaoJb8a87bmYhrBRU6yImAIm+QEvggI0+gB0iAE0+Ae40J4B8ZnSAAACAF3/7APzBE4AFQAdAGmyCB4fERI5sAgQsBbQALAARViwCC8bsQgYPlmwAEVYsAAvG7EAED5ZshoIABESObAaL7S/Gs8aAl2yDAEKK1gh2Bv0WbAAELIQAQorWCHYG/RZshMIABESObAIELIWAQorWCHYG/RZMDEFIgA1NTQ2NjMyEhEVIRYWMzI2NxcGASIGByE1JiYCTdz+7HvdgdPq/SMEs4piiDNxiP7ZcJgSAh4IiBQBIfIiof2P/ur+/U2gxVBCWNEDyqOTDo2bAAEAPAAAAsoGFQAVAGOyDxYXERI5ALAARViwCC8bsQgePlmwAEVYsAMvG7EDGD5ZsABFWLARLxuxERg+WbAARViwAC8bsQAQPlmwAxCyAQEKK1gh2Bv0WbAIELINAQorWCHYG/RZsAEQsBPQsBTQMDEzESM1MzU0NjMyFwcmIyIGFRUzFSMR56uruqpAPwovNVpi5+cDq49vrr4RlglpYnKP/FUAAgBg/lYD8gROABkAJACDsiIlJhESObAiELAL0ACwAEVYsAMvG7EDGD5ZsABFWLAGLxuxBhg+WbAARViwCy8bsQsSPlmwAEVYsBcvG7EXED5ZsgUDFxESObIPFwsREjmwCxCyEQEKK1gh2Bv0WbIVAxcREjmwFxCyHQEKK1gh2Bv0WbADELIiAQorWCHYG/RZMDETNBIzMhc3MxEUBiMiJic3FjMyNjU1BiMiAjcUFjMyNxEmIyIGYOrBxm8JqfnSdeA7YHesh5dvwL7rupaHr1JVqoeYAib9ASuMePvg0vJkV2+TmIpdgAEy87fRnwHum9IAAAEAjAAAA98GAAARAEmyChITERI5ALAQL7AARViwAi8bsQIYPlmwAEVYsAUvG7EFED5ZsABFWLAOLxuxDhA+WbIAAgUREjmwAhCyCgEKK1gh2Bv0WTAxATYzIBMRIxEmJiMiBgcRIxEzAUV7xQFXA7kBaW9aiCa5uQO3l/59/TUCzHVwYE78/QYAAAIAjQAAAWgFxAADAAwAPrIGDQ4REjmwBhCwAdAAsABFWLACLxuxAhg+WbAARViwAC8bsQAQPlmwAhCwCtCwCi+yBgUKK1gh2Bv0WTAxISMRMwM0NjIWFAYiJgFVubnIN2w4OGw3BDoBHy0+Plo8PAAC/7/+SwFZBcQADAAWAEmyEBcYERI5sBAQsADQALAARViwDC8bsQwYPlmwAEVYsAMvG7EDEj5ZsggBCitYIdgb9FmwDBCwFdCwFS+yEAUKK1gh2Bv0WTAxAREQISInNRYzMjY1EQM0NjMyFhQGIiYBS/7lPTQgND5BEzc1Njg4bDYEOvtJ/sgSlAhDUwS7AR8sPz5aPDwAAAEAjQAABAwGAAAMAHUAsABFWLAELxuxBB4+WbAARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIACAIREjlAFToASgBaAGoAegCKAJoAqgC6AMoACl2yBggCERI5QBU2BkYGVgZmBnYGhgaWBqYGtgbGBgpdMDEBBxEjETMRNwEzAQEjAbp0ubljAVHh/lsB1tkB9Xn+hAYA/F93AWT+PP2KAAEAnAAAAVUGAAADAB0AsABFWLACLxuxAh4+WbAARViwAC8bsQAQPlkwMSEjETMBVbm5BgAAAAEAiwAABngETgAdAHeyBB4fERI5ALAARViwAy8bsQMYPlmwAEVYsAgvG7EIGD5ZsABFWLAALxuxABg+WbAARViwCy8bsQsQPlmwAEVYsBQvG7EUED5ZsABFWLAbLxuxGxA+WbIBCAsREjmyBQgLERI5sAgQshABCitYIdgb9FmwGNAwMQEXNjMyFzY2MyATESMRNCYjIgYHESMRNCMiBxEjEQE6BXfK41I2rXYBZAa5an1niAu657ZDuQQ6eIyuTmD+h/0rAsp0c3to/TICxeyb/OoEOgABAIwAAAPfBE4AEQBTsgsSExESOQCwAEVYsAMvG7EDGD5ZsABFWLAALxuxABg+WbAARViwBi8bsQYQPlmwAEVYsA8vG7EPED5ZsgEDBhESObADELILAQorWCHYG/RZMDEBFzYzIBMRIxEmJiMiBgcRIxEBOwZ8yAFXA7kBaW9aiCa5BDqInP59/TUCzHVwYE78/QQ6AAACAFv/7AQ0BE4ADwAbAEOyDBwdERI5sAwQsBPQALAARViwBC8bsQQYPlmwAEVYsAwvG7EMED5ZshMBCitYIdgb9FmwBBCyGQEKK1gh2Bv0WTAxEzQ2NjMyABUVFAYGIyIANRcUFjMyNjU0JiMiBlt934/dARF54ZLc/u+6p4yNpqmMiagCJ5/+iv7O/g2e+4wBMvwJtNrdx7Ld2gACAIz+YAQeBE4ADwAaAG6yExscERI5sBMQsAzQALAARViwDC8bsQwYPlmwAEVYsAkvG7EJGD5ZsABFWLAGLxuxBhI+WbAARViwAy8bsQMQPlmyBQwDERI5sgoMAxESObAMELITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMQEUAiMiJxEjETMXNjMyEhEnNCYjIgcRFjMyNgQe4sHFcbmpCXHJw+O5nIioVFOrhZ0CEff+0n399wXaeIz+2v76BLfUlf37lNMAAAIAX/5gA+8ETgAPABoAa7IYGxwREjmwGBCwA9AAsABFWLADLxuxAxg+WbAARViwBi8bsQYYPlmwAEVYsAgvG7EIEj5ZsABFWLAMLxuxDBA+WbIFAwwREjmyCgMMERI5shMBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxEzQSMzIXNzMRIxEGIyICNRcUFjMyNxEmIyIGX+rFwG8IqrlwusTpuZ2FpVdYooaeAib/ASmBbfomAgR4ATH8CLrUkgISj9UAAQCMAAAClwROAA0ARrIEDg8REjkAsABFWLALLxuxCxg+WbAARViwCC8bsQgYPlmwAEVYsAUvG7EFED5ZsAsQsgIBCitYIdgb9FmyCQsFERI5MDEBJiMiBxEjETMXNjMyFwKXKjG2Qbm0A1unNhwDlAeb/QAEOn2RDgABAF//7AO7BE4AJgBhsgknKBESOQCwAEVYsAkvG7EJGD5ZsABFWLAcLxuxHBA+WbIDHAkREjmwCRCwDdCwCRCyEAEKK1gh2Bv0WbADELIVAQorWCHYG/RZsBwQsCHQsBwQsiQBCitYIdgb9FkwMQE0JiQmJjU0NjMyFhUjNCYjIgYVFBYEFhYVFAYjIiYmNTMWFjMyNgMCcf7npU/hr7jluoFiZXJqARWsU+i5gshxuQWLcml/AR9LUzxUdFCFuL6UTG5YR0NEPlZ5V5GvXKVgXW1VAAEACf/sAlYFQAAVAF+yDhYXERI5ALAARViwAS8bsQEYPlmwAEVYsBMvG7ETGD5ZsABFWLANLxuxDRA+WbABELAA0LAAL7ABELIDAQorWCHYG/RZsA0QsggBCitYIdgb9FmwAxCwEdCwEtAwMQERMxUjERQWMzI3FQYjIiY1ESM1MxEBh8rKNkEgOElFfH7FxQVA/vqP/WFBQQyWFJaKAp+PAQYAAQCI/+wD3AQ6ABAAU7IKERIREjkAsABFWLAGLxuxBhg+WbAARViwDS8bsQ0YPlmwAEVYsAIvG7ECED5ZsABFWLAQLxuxEBA+WbIADQIREjmwAhCyCgEKK1gh2Bv0WTAxJQYjIiYnETMRFDMyNxEzESMDKGzRrbUBucjURrmwa3/JxQLA/UX2ngMT+8YAAAEAIQAAA7oEOgAGADiyAAcIERI5ALAARViwAS8bsQEYPlmwAEVYsAUvG7EFGD5ZsABFWLADLxuxAxA+WbIABQMREjkwMSUBMwEjATMB8QEMvf58jf54vfsDP/vGBDoAAAEAKwAABdMEOgAMAGCyBQ0OERI5ALAARViwAS8bsQEYPlmwAEVYsAgvG7EIGD5ZsABFWLALLxuxCxg+WbAARViwAy8bsQMQPlmwAEVYsAYvG7EGED5ZsgALAxESObIFCwMREjmyCgsDERI5MDElEzMBIwEBIwEzExMzBErQuf7Flv75/wCW/sa41fyV/wM7+8YDNPzMBDr81gMqAAEAKQAAA8oEOgALAFMAsABFWLABLxuxARg+WbAARViwCi8bsQoYPlmwAEVYsAQvG7EEED5ZsABFWLAHLxuxBxA+WbIACgQREjmyBgoEERI5sgMABhESObIJBgAREjkwMQETMwEBIwMDIwEBMwH38Nj+ngFt1vr61wFt/p7WAq8Bi/3p/d0Blf5rAiMCFwABABb+SwOwBDoADwBJsgAQERESOQCwAEVYsAEvG7EBGD5ZsABFWLAOLxuxDhg+WbAARViwBS8bsQUSPlmyAA4FERI5sgkBCitYIdgb9FmwABCwDdAwMQETMwECIycnNRcyNjc3ATMB7vzG/k1l3CNFMl5pIin+fsoBDwMr+x/+8gMNlgRMZW4ELgABAFgAAAOzBDoACQBEALAARViwBy8bsQcYPlmwAEVYsAIvG7ECED5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIRUhNQEhNSEVAToCefylAlX9tAM0l5eIAxmZgwAAAQBA/pICngY9ABgAMbITGRoREjkAsA0vsAAvsgcNABESObAHL7IfBwFdsgYDCitYIdgb9FmyEwYHERI5MDEBJiY1NTQjNTI1NTY2NxcGERUUBxYVFRIXAnixs9TUAq+zJtGnpwPO/pIy5bzH85Hy0LfhM3ND/ubK41la5c7+7UIAAAEAr/7yAUQFsAADABMAsAAvsABFWLACLxuxAhw+WTAxASMRMwFElZX+8ga+AAABABP+kgJyBj0AGAAxsgUZGhESOQCwCy+wGC+yEQsYERI5sBEvsh8RAV2yEgMKK1gh2Bv0WbIFEhEREjkwMRc2EzU0NyY1NRAnNxYWFxUUMxUiFRUUBgcTywe1tdEmsbIB1NS1r/tBAQrc51RS6csBGkNzMuG50u+R88q84jIAAAEAgwGSBO8DIgAXAEKyERgZERI5ALAARViwDy8bsQ8WPlmwANCwDxCwFNCwFC+yAwEKK1gh2Bv0WbAPELIIAQorWCHYG/RZsAMQsAvQMDEBFAYjIi4CIyIGFQc0NjMyFhYXFzI2NQTvu4lIgKlKKk5UobiLTIywQB1MXwMJntk1lCRrXgKgzkChCgJ0XwACAIv+mAFmBE0AAwAMADKyBg0OERI5sAYQsADQALACL7AARViwCy8bsQsYPlmyBgUKK1gh2Bv0WbIBAgYREjkwMRMzEyMTFAYiJjQ2MhaqqA3CyTdsODhsNwKs++wFTC0+Plo8PAABAGn/CwP5BSYAIQBSsgAiIxESOQCwAEVYsBQvG7EUGD5ZsABFWLAKLxuxChA+WbAH0LIAAQorWCHYG/RZsAoQsAPQsBQQsBHQsBQQsBjQsBQQshsBCitYIdgb9FkwMSUyNjczBgYHFSM1JgI1NTQSNzUzFRYWFyMmJiMiBhUVFBYCSmSUCK8GxpC5s8jKsbmWwAavCI9pjZubg3lZfska6eoiARzcI9QBHSHi3xfUlmmHy8Aju8oAAQBbAAAEaAXEACEAfLIcIiMREjkAsABFWLAULxuxFBw+WbAARViwBS8bsQUQPlmyHxQFERI5sB8vsl8fAXKyjx8BcbK/HwFdsgABCitYIdgb9FmwBRCyAwEKK1gh2Bv0WbAH0LAI0LAAELAN0LAfELAP0LAUELAY0LAUELIbAQorWCHYG/RZMDEBFxQHIQchNTM2Njc1JyM1MwM0NjMyFhUjNCYjIgYVEyEVAcEIPgLdAfv4TSgyAgiloAn1yL7ev39vaYIJAT8CbtyaW52dCYNgCN2dAQTH7tSxa3yaff78nQAAAgBp/+UFWwTxABsAKgA/sgIrLBESObACELAn0ACwAEVYsAIvG7ECED5ZsBDQsBAvsAIQsh8BCitYIdgb9FmwEBCyJwEKK1gh2Bv0WTAxJQYjIicHJzcmNTQ3JzcXNjMyFzcXBxYVFAcXBwEUFhYyNjY1NCYmIyIGBgRPn9HPn4aCi2hwk4KTnsPEn5WEl25mj4T8YHPE4sRxccVwccRzcISCiIeNnMrOo5eIlnh5mImao8vEn5CIAnt71Hp703t603l41AAAAQAfAAAErQWwABYAawCwAEVYsBYvG7EWHD5ZsABFWLABLxuxARw+WbAARViwDC8bsQwQPlmyDxMDK7IADBYREjm0DxMfEwJdsBMQsAPQsBMQshICCitYIdgb9FmwBtCwDxCwB9CwDxCyDgIKK1gh2Bv0WbAK0DAxAQEzASEVIRUhFSERIxEhNSE1ITUhATMCZgFs2/5eATj+gAGA/oDB/oYBev6GATn+XtwDDgKi/TB9pXz+vgFCfKV9AtAAAAIAk/7yAU0FsAADAAcAGACwAC+wAEVYsAYvG7EGHD5ZsgUBAyswMRMRMxERIxEzk7q6uv7yAxf86QPIAvYAAgBa/hEEeQXEADQARACAsiNFRhESObAjELA10ACwCC+wAEVYsCMvG7EjHD5ZshYIIxESObAWELI/AQorWCHYG/RZsgIWPxESObAIELAO0LAIELIRAQorWCHYG/RZsjAjCBESObAwELI3AQorWCHYG/RZsh03MBESObAjELAn0LAjELIqAQorWCHYG/RZMDEBFAcWFhUUBCMiJicmNTcUFjMyNjU0JicuAjU0NyYmNTQkMzIEFSM0JiMiBhUUFhYEHgIlJicGBhUUFhYEFzY2NTQmBHm6RUj+/ORwyUaLurSciKaO0bbAXbZCRwEL3ugBBLmoi46hOIcBH6lxOv3hWktQSzaFARwsTlSLAa+9VTGIZKjHODlxzQKCl3VgWWk+MG+bb7pYMYhkpsjizX2bc2JFUEFQSGGBqxgbE2VFRlBCUhEUZUVYbQAAAgBmBPAC7wXFAAgAEQAdALAHL7ICBQorWCHYG/RZsAvQsAcQsBDQsBAvMDETNDYyFhQGIiYlNDYyFhQGIiZmN2w4OGw3Aa43bDg4bDcFWy09PVo8PCstPj5aPDwAAAMAW//rBeYFxAAbACoAOQCVsic6OxESObAnELAD0LAnELA20ACwAEVYsC4vG7EuHD5ZsABFWLA2LxuxNhA+WbIDNi4REjmwAy+0DwMfAwJdsgouNhESObAKL7QAChAKAl2yDgoDERI5shECCitYIdgb9FmwAxCyGAIKK1gh2Bv0WbIbAwoREjmwNhCyIAQKK1gh2Bv0WbAuELInBAorWCHYG/RZMDEBFAYjIiY1NTQ2MzIWFSM0JiMiBhUVFBYzMjY1JRQSBCAkEjU0AiQjIgQCBzQSJCAEEhUUAgQjIiQCBF+tnp29v5ugrJJfW15sbF5cXf0BoAETAUABEqCe/u2hoP7sn3O7AUsBgAFKu7T+tcbF/rW2AlWZodO2brDTpJVjVYp7cXiKVGWErP7bpqYBJayqASKnpf7cqsoBWsfH/qbKxf6o0c8BWAAAAgCTArMDDwXEABsAJQBssg4mJxESObAOELAd0ACwAEVYsBUvG7EVHD5ZsgQmFRESObAEL7AA0LICBBUREjmyCwQVERI5sAsvsBUQsg4DCitYIdgb9FmyEQsVERI5sAQQshwDCitYIdgb9FmwCxCyIAQKK1gh2Bv0WTAxASYnBiMiJjU0NjMzNTQjIgYVJzQ2MzIWFREUFyUyNjc1IwYGFRQCagwGTIB3gqesbHxFT6GsiYWaGv6kK1gccFNZAsEiJlZ8Z294NIc2Mwxngo+G/sRhUXsoG44BPzNe//8AZgCXA2QDswAmAXr6/gAHAXoBRP/+AAEAfwF3A74DIAAFABoAsAQvsAHQsAEvsAQQsgIBCitYIdgb9FkwMQEjESE1IQO+uv17Az8BdwEIoQAEAFr/6wXlBcQADgAeADQAPQCpsjY+PxESObA2ELAL0LA2ELAT0LA2ELAj0ACwAEVYsAMvG7EDHD5ZsABFWLALLxuxCxA+WbITBAorWCHYG/RZsAMQshsECitYIdgb9FmyIAsDERI5sCAvsiIDCxESObAiL7QAIhAiAl2yNSAiERI5sDUvsr81AV20ADUQNQJdsh8CCitYIdgb9FmyKB81ERI5sCAQsC/QsC8vsCIQsj0CCitYIdgb9FkwMRM0EiQgBBIVFAIEIyIkAjcUEgQzMiQSNTQCJCMiBAIFESMRITIWFRQHFhcVFBcVIyY0JyYnJzM2NjU0JiMjWrsBSwGAAUq7tP61xsX+tbZzoAEToKEBFJ2d/uyhoP7snwHAjQEUmamAegERkQ4DEHOwnEhYTmSKAtnKAVrHx/6mysX+qNHPAVjHrP7bpqkBIqyrASGnpf7c9f6uA1GDfXtBMpo9ViYQJLkRYASAAkI2ST0AAAEAeAUhA0IFsAADABEAsAEvsgIDCitYIdgb9FkwMQEhNSEDQv02AsoFIY8AAgCCA8ACfAXEAAsAFgAvALAARViwAy8bsQMcPlmwDNCwDC+yCQIKK1gh2Bv0WbADELISAgorWCHYG/RZMDETNDYzMhYVFAYjIiYXMjY1NCYjIgYUFoKVamiTk2hplv82Sko2N0tLBMBonJtpapaWFkc5OktPbEoAAgBhAAAD9QTzAAsADwBGALAJL7AARViwDS8bsQ0QPlmwCRCwANCwCRCyBgEKK1gh2Bv0WbAD0LANELIOAQorWCHYG/RZsgUOBhESObQLBRsFAl0wMQEhFSERIxEhNSERMwEhNSECiQFs/pSn/n8BgacBQfy9A0MDVpf+YgGelwGd+w2YAAABAEICmwKrBbsAFgBUsggXGBESOQCwAEVYsA4vG7EOHD5ZsABFWLAALxuxABQ+WbIWAgorWCHYG/RZsALQsgMOFhESObAOELIIAgorWCHYG/RZsA4QsAvQshQWDhESOTAxASE1ATY1NCYjIgYVIzQ2IBYVFA8CIQKr/akBLG1APEtHnacBCJprVLABjwKbbAEaZkUxPUw5cpR/bmhrT5EAAQA+Ao8CmgW6ACYAibIgJygREjkAsABFWLAOLxuxDhw+WbAARViwGS8bsRkUPlmyABkOERI5sAAvtm8AfwCPAANdsj8AAXG2DwAfAC8AA12yXwABcrAOELIHAgorWCHYG/RZsgoOGRESObAAELImBAorWCHYG/RZshQmABESObIdGQ4REjmwGRCyIAIKK1gh2Bv0WTAxATMyNjU0JiMiBhUjNDYzMhYVFAYHFhUUBiMiJjUzFBYzMjY1NCcjAQlUSkg/RjlLnaN8iZxGQpWqiISmnk9DRkmcWARlPTAtOjMpYnt5aDdbGSmPan1+ay08PDNxAgAAAQB7BNgCHAX+AAMAIwCwAi+yDwIBXbAA0LAAL7QPAB8AAl2wAhCwA9AZsAMvGDAxATMBIwE84P70lQX+/toAAAEAmv5gA+4EOgASAFCyDRMUERI5ALAARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLAQLxuxEBI+WbAARViwDS8bsQ0QPlmyBAEKK1gh2Bv0WbILBw0REjkwMQERFhYzMjcRMxEjJwYjIicRIxEBUwFndMc+uqcJXaqTUbkEOv2Ho5yYAyD7xnOHSf4rBdoAAQBDAAADQAWwAAoAK7ICCwwREjkAsABFWLAILxuxCBw+WbAARViwAC8bsQAQPlmyAQAIERI5MDEhESMiJDU0JDMhEQKGVOb+9wEK5gENAgj+1tX/+lAAAAEAkwJrAXkDSQAJABayAwoLERI5ALACL7EICitY2BvcWTAxEzQ2MhYVFAYiJpM5cjs7cjkC2TBAQDAvPz8AAQB0/k0BqgAAAA4AQbIFDxAREjkAsABFWLAALxuxABA+WbAARViwBi8bsQYSPlm0EwYjBgJdsgEGABESObEHCitY2BvcWbABELAN0DAxIQcWFRQGIycyNjU0Jic3AR0MmaCPB09XQGIgNBuSYXFrNC8sKgmGAAEAegKiAe8FtwAGAECyAQcIERI5ALAARViwBS8bsQUcPlmwAEVYsAAvG7EAFD5ZsgQABRESObAEL7IDAgorWCHYG/RZsgIDBRESOTAxASMRBzUlMwHvndgBYxICogJZOYB1AAACAHoCsgMnBcQADAAaAECyAxscERI5sAMQsBDQALAARViwAy8bsQMcPlmyChsDERI5sAovshADCitYIdgb9FmwAxCyFwMKK1gh2Bv0WTAxEzQ2MzIWFRUUBiAmNRcUFjMyNjU1NCYjIgYHeryam7y7/sy+o2FUU19hU1FgAgRjnsPBpkqfwsKlBmRyc2VOY3JuYQD//wBmAJgDeAO1ACYBew0AAAcBewFqAAD//wBVAAAFkQWtACcB1f/bApgAJwF8ARgACAEHAdgC1gAAABAAsABFWLAFLxuxBRw+WTAx//8AUAAABckFrQAnAXwA7AAIACcB1f/WApgBBwHWAx4AAAAQALAARViwCS8bsQkcPlkwMf//AG8AAAXtBbsAJwF8AZcACAAnAdgDMgAAAQcB1wAxApsAEACwAEVYsCEvG7EhHD5ZMDEAAgBE/n8DeARNABgAIgBXsgkjJBESObAJELAc0ACwEC+wAEVYsCEvG7EhGD5ZsgAQIRESObIDEAAREjmwEBCyCQEKK1gh2Bv0WbAQELAM0LIVABAREjmwIRCyGwUKK1gh2Bv0WTAxAQ4DBwcUFjMyNjUzBgYjIiY1NDc3NjUTFAYiJjU0NjIWAkwBKWC4CwJ0bWR9uQLht8TWoG1CwTdsODhsNwKoan92wWMlbXNxW6HMybOtr3FOkgE9LT4+LSw8PAAC//IAAAdXBbAADwASAHcAsABFWLAGLxuxBhw+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZshEGABESObARL7ICAQorWCHYG/RZsAYQsggBCitYIdgb9FmyCwAGERI5sAsvsgwBCitYIdgb9FmwABCyDgEKK1gh2Bv0WbISBgAREjkwMSEhAyEDIwEhFSETIRUhEyEBIQMHV/yND/3MzeIDcAO3/U0UAk79uBYCwfqvAcgfAWH+nwWwmP4pl/3tAXgC3QABAFkAzgPdBGMACwA4ALADL7IJDAMREjmwCS+yCgkDERI5sgQDCRESObIBCgQREjmwAxCwBdCyBwQKERI5sAkQsAvQMDETAQE3AQEXAQEHAQFZAUr+uHcBSQFJd/64AUp3/rX+tQFJAVABT3v+sQFPe/6x/rB7AVH+rwAAAwB2/6MFHQXsABcAIAApAGayBCorERI5sAQQsB3QsAQQsCbQALAARViwEC8bsRAcPlmwAEVYsAQvG7EEED5ZshoQBBESObIjEAQREjmwIxCwG9CwEBCyHQEKK1gh2Bv0WbAaELAk0LAEELImAQorWCHYG/RZMDEBFAIEIyInByM3JhE1NBIkMzIXNzMHFhMFFBcBJiMiAgcFNCcBFjMyEjcFCZD++LCrg2GOkL6SAQus1pRnjZ+JAvwsYgI0Zqa20QMDFTj921t5uswDAqnW/sGoUpvnwAFoU9IBQqt9pf+7/tpj9I0DiG/+6/YNtoP8j0ABD/0AAgCmAAAEXQWwAA0AFgBXsgkXGBESObAJELAQ0ACwAEVYsAAvG7EAHD5ZsABFWLALLxuxCxA+WbIBAAsREjmwAS+yEAALERI5sBAvsgkBCitYIdgb9FmwARCyDgEKK1gh2Bv0WTAxAREhMhYWFRQEIyERIxETESEyNjU0JicBYAEXk9x3/vjj/u66ugEVjqCgiAWw/ttpwn7C5/7HBbD+Q/3el3h7lwEAAQCL/+wEagYSACoAabIhKywREjkAsABFWLAFLxuxBR4+WbAARViwEy8bsRMQPlmwAEVYsAAvG7EAED5ZsgoTBRESObIOBRMREjmwExCyGgEKK1gh2Bv0WbIgEwUREjmyIwUTERI5sAUQsigBCitYIdgb9FkwMSEjETQ2MzIWFRQGFRQeAhUUBiMiJic3FhYzMjY1NC4CNTQ2NTQmIyIRAUS5z7q0xYBLvFbLtlG1JisxhzVrcUq9V4toWNoEV9Drs599y0UzX5CITJ+yLBybICxeUjRgk4pRWc9UXmv+2wADAE7/7AZ8BE4AKgA1AD0AxrICPj8REjmwAhCwLtCwAhCwOdAAsABFWLAXLxuxFxg+WbAARViwHS8bsR0YPlmwAEVYsAAvG7EAED5ZsABFWLAFLxuxBRA+WbICHQAREjmyDAUXERI5sAwvtL8MzwwCXbAXELIQAQorWCHYG/RZshMMFxESObIaHQAREjmyOh0AERI5sDovtL86zzoCXbIhAQorWCHYG/RZsAAQsiUBCitYIdgb9FmyKB0AERI5sCvQsAwQsi8BCitYIdgb9FmwEBCwNtAwMQUgJwYGIyImNTQ2MzM1NCYjIgYVJzQ2MzIWFzY2MzISFRUhFhYzMjc3FwYlMjY3NSMGBhUUFgEiBgchNTQmBO7++4hB4o2nvOPd325oaYy48rtzsDI/rmnS6P0oB66VlHkvQJ78CUieMuR1jGoDUHOVEQIahhS0Vl6tl52uVWt7blETj7VTU09X/v/pc7C/TB+IeZZKNu0CblNNXQM0q4sfhJMAAAIAfv/sBC0GLAAdACsAVLIHLC0REjmwBxCwKNAAsABFWLAZLxuxGR4+WbAARViwBy8bsQcQPlmyDxkHERI5sA8vshEZBxESObIiAQorWCHYG/RZsAcQsigBCitYIdgb9FkwMQESERUUBgYjIiYmNTQ2NjMyFyYnByc3Jic3Fhc3FwMnJiYjIgYVFBYzMjY1AzT5ddiGh9x5cM+Bo3kwjdpJwIS3Oe+vvUloAiGLXJGip4B9mQUV/vj+Z12e/ZCB4IaT6YJyw42UY4NbMZ82i4Fk/PM4PUm/p4zE4rgAAAMARwCsBC0EugADAA0AFwBOsgcYGRESObAHELAA0LAHELAR0ACwAi+yAQEKK1gh2Bv0WbACELEMCitY2BvcWbEGCitY2BvcWbABELEQCitY2BvcWbEWCitY2BvcWTAxASE1IQE0NjIWFRQGIiYRNDYyFhUUBiImBC38GgPm/aA5cjs7cjk5cjs7cjkCWLgBOjBAQDAvPj78/jBAQDAuPz8AAAMAW/96BDQEuAAVAB0AJgBjsgQnKBESObAEELAb0LAEELAj0ACwAEVYsAQvG7EEGD5ZsABFWLAPLxuxDxA+WbIjAQorWCHYG/RZsiEjBBESObAhELAY0LAEELIbAQorWCHYG/RZshkbDxESObAZELAg0DAxEzQ2NjMyFzczBxYRFAYGIyInByM3JhMUFwEmIyIGBTQnARYzMjY1W3vhj25eSXxmw3zgkGhWSnxkzblhAVc+SIqoAmZX/qw3QounAief/YsqlM2a/sCe/okjlcuVATfCbwK2INq1tm/9UBnbuQACAJX+YAQnBgAADwAaAGSyGBscERI5sBgQsAzQALAIL7AARViwDC8bsQwYPlmwAEVYsAYvG7EGEj5ZsABFWLADLxuxAxA+WbIFDAMREjmyCgwDERI5sAwQshMBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxARQCIyInESMRMxE2MzISESc0JiMiBxEWMzI2BCfiwcVxublxwsPjuZyIqFRTq4WdAhH3/tJ9/fcHoP3KhP7a/voEt9SV/fuU0wAAAgAdAAAFiAWwABMAFwBrALAARViwDy8bsQ8cPlmwAEVYsAgvG7EIED5ZshQIDxESObAUL7IQFA8REjmwEC+wANCwEBCyFwEKK1gh2Bv0WbAD0LAIELAF0LAUELIHAQorWCHYG/RZsBcQsArQsBAQsA3QsA8QsBLQMDEBMxUjESMRIREjESM1MxEzESERMwEhNSEFAoaGwf0jwYaGwQLdwfxiAt39IwSOjvwAAqH9XwQAjgEi/t4BIv2OwgABAJsAAAFVBDoAAwAdALAARViwAi8bsQIYPlmwAEVYsAAvG7EAED5ZMDEhIxEzAVW6ugQ6AAABAJoAAAQ/BDoADABoALAARViwBC8bsQQYPlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmwAhCwBtCwBi+ynwYBXbS/Bs8GAl2yLwYBXbL/BgFdsgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAb9rurpbAY3f/jwB6OkBzf4zBDr+NgHK/fP90wAAAQAiAAAEGwWwAA0AWwCwAEVYsAwvG7EMHD5ZsABFWLAGLxuxBhA+WbIBDAYREjmwAS+wANCwARCyAgEKK1gh2Bv0WbAD0LAGELIEAQorWCHYG/RZsAMQsAjQsAnQsAAQsAvQsArQMDEBJRUFESEVIREHNTcRMwFpAQf++QKy/I2GhsEDS1R9VP3PnQKRKn0qAqIAAAEAIgAAAgoGAAALAEoAsABFWLAKLxuxCh4+WbAARViwBC8bsQQQPlmyAQQKERI5sAEvsADQsAEQsgIBCitYIdgb9FmwA9CwBtCwB9CwABCwCdCwCNAwMQE3FQcRIxEHNTcRMwFsnp66kJC6A2U9ez39FgKjN3s3AuIAAQCi/ksE8QWwABMAWrIGFBUREjkAsABFWLAALxuxABw+WbAARViwEC8bsRAcPlmwAEVYsAQvG7EEEj5ZsABFWLAOLxuxDhA+WbAEELIJAQorWCHYG/RZsg0OEBESObISDgAREjkwMQERFAYjIic3FjMyNTUBESMRMwERBPGrnD02DiU9iP0zwMACzQWw+f2ouhKaDtBHBGr7lgWw+5gEaAAAAQCR/ksD8AROABoAYbINGxwREjkAsABFWLADLxuxAxg+WbAARViwAC8bsQAYPlmwAEVYsAovG7EKEj5ZsABFWLAYLxuxGBA+WbIBGAMREjmwChCyDwEKK1gh2Bv0WbADELIVAQorWCHYG/RZMDEBFzYzMhYXERQGIyInNxYzMjURNCYjIgcRIxEBNw10y7O4AqebPTYOI0KJb32vUboEOpqu0Mv89KS4Ep0NwgL3i4CF/NQEOgACAGj/6wcJBcQAFwAjAJGyASQlERI5sAEQsBrQALAARViwDC8bsQwcPlmwAEVYsA4vG7EOHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmwDhCyEAEKK1gh2Bv0WbITAA4REjmwEy+yFAEKK1gh2Bv0WbAAELIWAQorWCHYG/RZsAMQshgBCitYIdgb9FmwDBCyHQEKK1gh2Bv0WTAxISEGIyImAicRNBI2MzIXIRUhESEVIREhBTI3ESYjIgYHERQWBwn8sLJyov6MAYv+onyqA0b9LQJ3/YkC3fuMcWZtbK3CAsMVlgEPqwE1rAERlxSe/iyd/fwbDgSOD+XP/sfT6wAAAwBh/+wHAAROACAALAA0AJayBjU2ERI5sAYQsCbQsAYQsDDQALAARViwBC8bsQQYPlmwAEVYsAovG7EKGD5ZsABFWLAXLxuxFxA+WbAARViwHS8bsR0QPlmyBwoXERI5sjEKFxESObAxL7IOAQorWCHYG/RZsBcQshIBCitYIdgb9FmyFAoXERI5shoKFxESObAk0LAEELIqAQorWCHYG/RZsC3QMDETNDY2MzIWFzY2MzIWFRUhFhYzMjcXBiMiJicGBiMiADUXFBYzMjY1NCYjIgYlIgYHITU0JmF5246JyT1BxHDP6v0yB6SGvHhKifWHzT8+x4bc/vi5oIuJoKGKh6IELWOWFgIOiQInoP6JdWRmc/7rdKrFbH6EcGRjcQEw/gm32NfOttnW1qOKGn2WAAABAKAAAAKCBhUADAAysgMNDhESOQCwAEVYsAQvG7EEHj5ZsABFWLAALxuxABA+WbAEELIJAQorWCHYG/RZMDEzETY2MzIXByYjIhURoAGwojtUFygztwSuqb4Vjgvd+2AAAAIAXf/sBRIFxAAXAB8AW7IAICEREjmwGNAAsABFWLAQLxuxEBw+WbAARViwAC8bsQAQPlmyBRAAERI5sAUvsBAQsgkBCitYIdgb9FmwABCyGAEKK1gh2Bv0WbAFELIbAQorWCHYG/RZMDEFIAARNSE1EAIjIgcHJzc2MyAAERUUAgQnMhI3IRUUFgK5/uP+wQP09N2liz0vFp7oAS4BZJz+6qep3g/8z9MUAVkBRXUHAQIBHDoajw1Y/of+sVTF/r+2ngEF2yLa5AAB/+T+SwK8BhUAHgBxshQfIBESOQCwAEVYsBUvG7EVHj5ZsABFWLAQLxuxEBg+WbAARViwHS8bsR0YPlmwAEVYsAUvG7EFEj5ZsB0QsgABCitYIdgb9FmwBRCyCgEKK1gh2Bv0WbAAELAO0LAP0LAVELIaAQorWCHYG/RZMDEBIxEUBiMiJzcWMzI2NREjNTM1NjYzMhcHJiMiBxUzAmDLqJo9Mg4eQ0FHq6sCr6E7VBYmPKsEywOr+/6ntxKTDWhcBASPeKe8FZMKw3oAAAIAZf/sBZ0GNwAXACUAU7IEJicREjmwBBCwItAAsABFWLANLxuxDRw+WbAARViwBC8bsQQQPlmyDw0EERI5sA8QsBXQsA0QshsBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxARQCBCMiJAInNTQSJDMyFzY2NTMQBRYXBxACIyICBxUUEjMyEhEE+JD++LCr/vaVAZIBC6zwm2Bdp/75YQG+z7220QPTub/LAqnW/sGoqAE+z2TSAUGsmweDhP6zPaz2BAECARb+6/Zr+/7hARoBAQAAAgBb/+wEugSwABYAIwBTshMkJRESObATELAa0ACwAEVYsAQvG7EEGD5ZsABFWLATLxuxExA+WbIGBBMREjmwBhCwDNCwExCyGgEKK1gh2Bv0WbAEELIhAQorWCHYG/RZMDETNDY2MzIXNjY1MxAHFhUVFAYGIyIANRcUFjMyNjU1NCYjIgZbe+GPz4hHQJbPSXzgkN7+8bmnjYunqYuKqAInn/2LighkgP7dM4qpFp7+iQEz+wm02tu5ELXa2gAAAQCM/+wGHQYCABoATLIMGxwREjkAsABFWLASLxuxEhw+WbAARViwGi8bsRocPlmwAEVYsA0vG7ENED5ZsgENGhESObABELAI0LANELIWAQorWCHYG/RZMDEBFTY2NTMUBgcRBgIHByIAJxEzERQWMzI2NREEqnNhn7HCAfTTSe/+5AK+rqGjrQWw1QuJk9LRDP1+x/78FgQBAuID4Pwmnq+ungPbAAEAiP/sBQ8EkAAZAGCyBxobERI5ALAARViwEy8bsRMYPlmwAEVYsA0vG7ENGD5ZsABFWLAILxuxCBA+WbAARViwBS8bsQUQPlmyFQgTERI5sBUQsAPQsgYIExESObAIELIQAQorWCHYG/RZMDEBFAYHESMnBiMiJicRMxEUMzI3ETMVPgI1BQ+ToLAEbNGttQG5yNRGuUREHQSQtJME/Ltrf8nFAsD9RfaeAxODAiNIbAAB/7T+SwFlBDoADQAoALAARViwAC8bsQAYPlmwAEVYsAQvG7EEEj5ZsgkBCitYIdgb9FkwMQERFAYjIic3FjMyNjURAWWqmDs0Dh5DQUgEOvttqrISkw1oXASTAAIAYv/sA+kETwAUABwAZbIIHR4REjmwCBCwFdAAsABFWLAALxuxABg+WbAARViwCC8bsQgQPlmyDQAIERI5sA0vsAAQshABCitYIdgb9FmyEgAIERI5sAgQshUBCitYIdgb9FmwDRCyGAEKK1gh2Bv0WTAxATIAFRUUBgYnIiY1NSEmJiMiByc2ATI2NyEVFBYB/9wBDnzYetDpAs0HoYi6e0mMAQ5ilxX984kET/7U+SSV+I0B/ul0qMhsfYb8NaSJGn2WAAEAqQTkAwYGAAAIADQAsAQvsAfQsAcvtA8HHwcCXbIFBAcREjkZsAUvGLAB0BmwAS8YsAQQsALQsgMEBxESOTAxARUjJwcjNRMzAwaZlpWZ9nAE7gqqqgwBEAAAAQCMBOMC9gX/AAgAIACwBC+wAdCwAS+0DwEfAQJdsgAEARESObAI0LAILzAxATczFQMjAzUzAcCWoP5x+50FVaoK/u4BEgr//wB4BSEDQgWwAQYAcAAAAAoAsAEvsQID9DAxAAEAgQTLAtgF1wAMACayCQ0OERI5ALADL7IPAwFdsgkECitYIdgb9FmwBtCwBi+wDNAwMQEUBiAmNTMUFjMyNjUC2KX+9KaXTElGTwXXeZOUeEZPTkcAAQCNBO4BaAXCAAgAGLICCQoREjkAsAcvsgIFCitYIdgb9FkwMRM0NjIWFAYiJo03bDg4bDcFVy0+Plo8PAACAHkEtAInBlAACQAUACqyAxUWERI5sAMQsA3QALADL7AH0LAHL7I/BwFdsAMQsA3QsAcQsBLQMDEBFAYjIiY0NjIWBRQWMzI2NCYjIgYCJ3xbXHt7uHv+tUMxMERDMTJCBYBXdXasenpWL0RCYkVGAAABADL+TwGSADgAEAAusgUREhESOQCwEC+wAEVYsAovG7EKEj5ZsgUDCitYIdgb9Fm2DxAfEC8QA10wMSEHBhUUMzI3FwYjIiY1NDY3AX46cU4wNA1GWllnhnstW1ZIGnksaFZZmjgAAAEAewTZAz4F6AAXAD4AsAMvsAjQsAgvtA8IHwgCXbADELAL0LALL7AIELIPAworWCHYG/RZsAMQshQDCitYIdgb9FmwDxCwF9AwMQEUBiMiLgIjIgYVJzQ2MzIeAjMyNjUDPntcKTxhKxwpOnx5XSM4YDMfKzkF3GyGFD4NPzEHa4wUOhJELQACAF4E0AMsBf8AAwAHADsAsAIvsADQsAAvtA8AHwACXbACELAD0BmwAy8YsAAQsAXQsAUvsAIQsAbQsAYvsAMQsAfQGbAHLxgwMQEzASMDMwMjAl3P/vOpbcXalgX//tEBL/7RAAACAH7+awHV/7UACwAWADQAsAMvQAsAAxADIAMwA0ADBV2wCdCwCS9ACTAJQAlQCWAJBF2yAAkBXbAO0LADELAU0DAxFzQ2MzIWFRQGIyImNxQWMjY1NCYjIgZ+ZEpHYmBJTGJXNEYwMCMlMvJGYWBHRl1eRSMwMCMkMjQAAfynBNj+SAX+AAMAHgCwAS+wANAZsAAvGLABELAC0LACL7QPAh8CAl0wMQEjATP+SJ/+/uAE2AEmAAH9bwTY/xAF/gADAB4AsAIvsAHQsAEvtA8BHwECXbACELAD0BmwAy8YMDEBMwEj/jDg/vSVBf7+2v///IsE2f9OBegABwCk/BAAAAAB/V4E2f6UBnQADgAuALAAL7IPAAFdsAfQsAcvQAkPBx8HLwc/BwRdsAbQsgEABhESObINAAcREjkwMQEnNjY0JiM3MhYVFAYHB/10AUtGW0sHlZpOTQEE2ZkFHk4namdVPVALRwAC/CcE5P8HBe4AAwAHADcAsAEvsADQGbAALxiwARCwBdCwBS+wBtCwBi+2DwYfBi8GA12wA9CwAy+wABCwBNAZsAQvGDAxASMBMwEjAzP+Aqn+zuEB/5b2zgTkAQr+9gEKAAH9OP6i/hP/dgAIABEAsAIvsgcFCitYIdgb9FkwMQU0NjIWFAYiJv04N2w4OGw39S0+Plo8PAAAAQC3BO4BmwY/AAMAHQCwAi+wANCwAC+yDwABXbIDAgAREjkZsAMvGDAxEzMDI+2udHAGP/6vAAADAHEE8AODBogAAwAMABUANwCwCy+wAtCwAi+wAdCwAS+wAhCwA9AZsAMvGLALELIGBQorWCHYG/RZsA/QsAsQsBTQsBQvMDEBMwMjBTQ2MhYUBiImJTQ2MhYUBiImAeG8ZYf+wDdsODhsNwI3N2w4OGw3Boj++CUtPT1aPDwrLT4+Wjw8//8AkwJrAXkDSQEGAHgAAAAGALACLzAxAAEAsQAABDAFsAAFACsAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmwBBCyAAEKK1gh2Bv0WTAxASERIxEhBDD9QsEDfwUS+u4FsAACAB8AAAVzBbAAAwAGAC8AsABFWLAALxuxABw+WbAARViwAi8bsQIQPlmyBAEKK1gh2Bv0WbIGAgAREjkwMQEzASElIQEChqoCQ/qsAQYDTP5nBbD6UJ0EKAADAGf/7AT6BcQAAwAVACMAd7IIJCUREjmwCBCwAdCwCBCwINAAsABFWLARLxuxERw+WbAARViwCC8bsQgQPlmyAggRERI5sAIvss8CAV2y/wIBXbIvAgFdtL8CzwICcbIBAQorWCHYG/RZsBEQshkBCitYIdgb9FmwCBCyIAEKK1gh2Bv0WTAxASE1IQUUAgQjIiQCJzU0EiQzMgQSFwcQAiMiAgcVFBIzMhI3A8D9+wIFATqP/vixrP72kwKSAQusrwEIkQK/0Lu20QPRu7rMAwKTmILV/sKqqQE5zmnSAUKrqP7FzwsBAwEV/uv2a/r+4AEP/QABADIAAAUDBbAABgAxALAARViwAy8bsQMcPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbIAAwEREjkwMQEBIwEzASMCmv5mzgISrAITzwSJ+3cFsPpQAAADAHgAAAQhBbAAAwAHAAsATwCwAEVYsAgvG7EIHD5ZsABFWLACLxuxAhA+WbIAAQorWCHYG/RZsAIQsAXQsAUvsi8FAV2yBgEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDE3IRUhEyEVIQMhFSF4A6n8V1cC8v0OUwOU/GydnQM/nQMOngABALIAAAUBBbAABwA4ALAARViwBi8bsQYcPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEhIxEhESMRIQUBwf0ywARPBRL67gWwAAEARQAABEQFsAAMADwAsABFWLAILxuxCBw+WbAARViwAy8bsQMQPlmyAQEKK1gh2Bv0WbAF0LAIELIKAQorWCHYG/RZsAfQMDEBASEVITUBATUhFSEBAvL+QwMP/AEB4f4fA879JAG7As79z52PAkoCR5Ce/dQAAAMATQAABXQFsAAUABsAIwBssgokJRESObAKELAV0LAKELAc0ACwAEVYsBMvG7ETHD5ZsABFWLAJLxuxCRA+WbISEwkREjmwEi+wANCyCAkTERI5sAgvsAvQsAgQsh0BCitYIdgb9FmwFdCwEhCyFgEKK1gh2Bv0WbAc0DAxATIEFhUUBgQjFSM1IiQmEDY2MzUzAxEjIgYQFgERMzI2NTQmA0KgAQOPkv8AoMKi/v6Pkf+jwsIFrMPCAXQErMPDBPeM/Jud/Yuvr436ATj9jLn7ngMK0v6Y0AMK/PbRtbPRAAABAFoAAAUhBbAAGABcsgAZGhESOQCwAEVYsAQvG7EEHD5ZsABFWLARLxuxERw+WbAARViwFy8bsRccPlmwAEVYsAsvG7ELED5ZshYECxESObAWL7AA0LAWELINAQorWCHYG/RZsArQMDEBNjY1ETMRFAYGBxEjESYAJxEzERYWFxEzAxacrsF/7Z/B5/7vA8ABpZXBAgsX16oCDf3wn/WTD/6WAWoXASrtAhj976PXGQOkAAABAHEAAATLBcQAJABcshklJhESOQCwAEVYsBkvG7EZHD5ZsABFWLAOLxuxDhA+WbAARViwIy8bsSMQPlmwDhCyEAEKK1gh2Bv0WbAN0LAA0LAZELIGAQorWCHYG/RZsBAQsCHQsCLQMDElNhI3NTQmIAYVFRQSFxUhNTMmAjU1NBI2MzIWEhcVFAIHMxUhAuGKmgPC/q7AnZH+FN1qeI3+oaD9jgN4atz+HKIbARzqhuf2+uVx8P7YHKKdZgEzom+6ASSfnP7ktIKg/s1mnQAAAgBk/+sEdwROABYAIQB8sh8iIxESObAfELAT0ACwAEVYsBMvG7ETGD5ZsABFWLAWLxuxFhg+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsAgQsgMBCitYIdgb9FmyChMIERI5shUTCBESObAMELIaAQorWCHYG/RZsBMQsh8BCitYIdgb9FkwMQERFjMyNxcGIyInBiMiAjU1EBIzMhc3ARQWMzI3ESYjIgYD7gJOEw8XMEqTJmvRwOTixMtrEf3MkoetUlWohpUEOvzjjAWJIqWlARv0DwEIAT2hjf26r8O6Ab684wAAAgCg/oAETQXEABQAKgBpsgArLBESObAY0ACwDy+wAEVYsAAvG7EAHD5ZsABFWLAMLxuxDBA+WbIoAAwREjmwKC+yJQEKK1gh2Bv0WbIGJSgREjmyDgwAERI5sAAQshgBCitYIdgb9FmwDBCyHwEKK1gh2Bv0WTAxATIWFRQGBxYWFRQGIyInESMRNDY2ATQmIyIGBxEWFjMyNjU0JicjNTMyNgJdwetiWHuD+c21eLp6zwFniGtslgEskF6GmoxtllV4fgXE265bmC4tw4LN71/+NQWxbLxr/ntmh45r/MM0P6CBdqUDmHcAAQAu/mAD3wQ6AAgAOLIACQoREjkAsABFWLABLxuxARg+WbAARViwBy8bsQcYPlmwAEVYsAQvG7EEEj5ZsgAHBBESOTAxAQEzAREjEQEzAgoBGL3+hbr+hL0BFAMm+//+JwHgA/oAAgBg/+wEJwYcAB4AKgBeshQrLBESObAUELAi0ACwAEVYsAMvG7EDHj5ZsABFWLAULxuxFBA+WbADELIIAQorWCHYG/RZshsUAxESObAbL7IoCworWCHYG/RZsAzQsBQQsiIBCitYIdgb9FkwMRM0NjMyFwcmIyIGFRQEEhcVFAYGIyIANTU0EjcnJiYTFBYzMjY1NCYnIgbdy6+LhgKXfFZlAbvPBXbbkd7++byQAWNrPqGJiKCpfYikBPWInzegO0g+bJn+88QnmfOFASfyDaUBCCMFJ4z9Y7DLysaI2xnNAAEAY//sA+wETQAlAG+yAyYnERI5ALAARViwFS8bsRUYPlmwAEVYsAovG7EKED5ZsgMBCitYIdgb9FmwChCwBtCwChCwItCwIi+yLyIBXbK/IgFdsiMBCitYIdgb9FmyDyMiERI5shkVIhESObAVELIcAQorWCHYG/RZMDEBFBYzMjY1MxQGIyImNTQ3JiY1NDYzMhYVIzQmIyIGFRQzMxUjBgEek3Zxm7n/xsz4zVhi58q6+bmPa3CH9MTg6gEwTWJuUZu5sZO6QiR6SZSms45GZVtKoJQGAAEAbf6BA8MFsAAfAEuyCCAhERI5ALAPL7AARViwAC8bsQAcPlmyHQEKK1gh2Bv0WbAB0LIVIAAREjmyAhUAERI5sBUQsgcBCitYIdgb9FmyHAAVERI5MDEBFQEGBhUUFhcXFhYVBgYHJzY2NTQkJyYmNTQSNwEhNQPD/qKKZkNS91FHAmxDYi8z/sw2Z1uSfwEd/YMFsHj+VaHlhVphGUgYWE5FrDZUNVUtRE4YLZmBggFAlgFDmAABAJH+YQPwBE4AEgBTsgwTFBESOQCwAEVYsAMvG7EDGD5ZsABFWLAALxuxABg+WbAARViwBy8bsQcSPlmwAEVYsBAvG7EQED5ZsgEQAxESObADELIMAQorWCHYG/RZMDEBFzYzMhYXESMRNCYjIgYHESMRATgLeMi+rgG5bIBcgiK6BDqInMXM+6QEUYh8V0787wQ6AAADAHr/7AQSBcQADQAWAB4AkrIDHyAREjmwAxCwE9CwAxCwG9AAsABFWLAKLxuxChw+WbAARViwAy8bsQMQPlmyDgMKERI5sA4vsl8OAV2y/w4BXbSPDp8OAnG0vw7PDgJxsi8OAXGyzw4BXbIvDgFdtO8O/w4CcbAKELITAQorWCHYG/RZsA4QshgBCitYIdgb9FmwAxCyGwEKK1gh2Bv0WTAxARACIyICAzUQEjMyEhMFITU0JiMiBhUFIRUUFiA2NwQS7N/b7gTs397rBP0hAiWLiIaMAiX925IBBI0CAoD+v/6tAUwBNM0BPQFO/rz+zSw34/Hx488n5frw4wAAAQDD//QCSwQ6AAwAKACwAEVYsAAvG7EAGD5ZsABFWLAJLxuxCRA+WbIEAQorWCHYG/RZMDEBERQWMzI3FwYjIhERAXw3QDAnAUZJ+QQ6/Nc/QAyXEwEmAyAAAQAl/+8EOwXuABoAULIQGxwREjkAsAAvsABFWLALLxuxCxA+WbAARViwES8bsREQPlmwCxCyBwEKK1gh2Bv0WbIQAAsREjmwEBCwE9CwABCyFwEKK1gh2Bv0WTAxATIWFwEWFjM3FwYjIiYmJwMBIwEnJiYjByc2AQVieCEBqxQtIyYGJCpNTj4d5v7izgGKYBc1LS8BKgXuUF/7qzMnA5gMJVZQAlH89QQF6zguAo4MAAEAZf53A6kFxAAtAFayAy4vERI5ALAXL7AARViwKy8bsSscPlmyAgEKK1gh2Bv0WbIILisREjmwCC+yCQEKK1gh2Bv0WbIeLisREjmwHhCyDwEKK1gh2Bv0WbIlCQgREjkwMQEmIyIGFRQhMxUjBgYVFBYEFhcWFRQGByc3NjU0LgQ1NDY3JiY1NCQzMhcDcoRhjaABTYWWtseQAQ98IE9oSGs5MUzmqXdBpJZ2gwEC5JFwBQgkZ1XbmAKco3CdQSUUMWlApz1UQDw+Jy4zQmmZb5HLLiqYYJ+5JwABACn/9ASkBDoAFABcsgsVFhESOQCwAEVYsBMvG7ETGD5ZsABFWLAKLxuxChA+WbAARViwDy8bsQ8QPlmwExCyAAEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAAQsA3QsA7QsBHQsBLQMDEBIxEUFjMyNxcGIyIRESERIxEjNSEEcZw2QTAnAUZJ+f5vuakESAOh/XJAQQyXEwEmAof8XwOhmQACAJH+YAQfBE4ADwAbAFeyEhwdERI5sBIQsADQALAARViwAC8bsQAYPlmwAEVYsAovG7EKEj5ZsABFWLAHLxuxBxA+WbIJAAcREjmyEgEKK1gh2Bv0WbAAELIYAQorWCHYG/RZMDEBMhIXFxQCIyInESMRNDY2AxYzMjY1NCYjIgYVAlDP9AsB4L/DcrpxzYRTq4eWkYV1kARO/ub+QvD+6Hz9+APknuyA/MiTw8PN4NipAAABAGX+igPhBE4AIgBJsgAjJBESOQCwFC+wAEVYsAAvG7EAGD5ZsABFWLAbLxuxGxA+WbAAELAE0LAAELIHAQorWCHYG/RZsBsQsg0BCitYIdgb9FkwMQEyFhUjNCYjIgYVFRAFFxYWFQYGByc3NjU0JicmAjU1NDY2Aj2956+Gb4SbAUCGYlACY0piLzFGVuz4d9cETtW0boPbsyD+/GMmHWBQP6c+VTY8RisrEzQBAdMqmPuJAAIAYP/sBHsEOgARAB0ATLIIHh8REjmwCBCwFdAAsABFWLAQLxuxEBg+WbAARViwCC8bsQgQPlmwEBCyAAEKK1gh2Bv0WbAIELIVAQorWCHYG/RZsAAQsBvQMDEBIRYRFRQGBiMiADU1NDY2NyEBFBYzMjY1NCYjIgYEe/7kyHrdjNr+9nbZjAJA/J+gioufoYuJnwOhlP7vEYzriAEv/w2Y8ogB/de319nLrM7MAAEAUf/sA9kEOgAQAEmyChESERI5ALAARViwDy8bsQ8YPlmwAEVYsAkvG7EJED5ZsA8QsgABCitYIdgb9FmwCRCyBAEKK1gh2Bv0WbAAELAN0LAO0DAxASERFDMyNxcGIyImJxEhNSED2f6NaSsxKkxqfXUB/qUDiAOk/WmFGoI0k5ICk5YAAQCP/+wD9gQ6ABIAPLIOExQREjkAsABFWLAALxuxABg+WbAARViwCC8bsQgYPlmwAEVYsA4vG7EOED5ZsgMBCitYIdgb9FkwMQEREDMyNjUmAzMWERAAIyImJxEBScmBqgV2w3H+/9rCyAIEOv15/s/6tucBIfH+6f75/sHg1wKXAAIAV/4iBUwEOgAZACIAXLIPIyQREjmwDxCwGtAAsBgvsABFWLAGLxuxBhg+WbAARViwEC8bsRAYPlmwAEVYsBcvG7EXED5ZsADQsBcQshoBCitYIdgb9FmwDNCwEBCyIAEKK1gh2Bv0WTAxBSQANTQSNxcGBxQWFxE0NjMyFhYVFAAFESMTNjY1JiYjIhUCbP8A/uuBf2WhCrWminGC4YL+3v77ubmqxAWlgkIRFwEz+6gBB1eFjPWt5RoCzGl9jfiV8/7XFf4zAmYW3qSp2FIAAAEAX/4oBUMEOgAZAFiyABobERI5ALANL7AARViwAC8bsQAYPlmwAEVYsAYvG7EGGD5ZsABFWLATLxuxExg+WbAARViwDC8bsQwQPlmyAQEKK1gh2Bv0WbAMELAP0LABELAY0DAxARE2NjUmAzMWERAABREjESYAEREzERYWFxEDHKvDBXrCdv7j/va5//77ugKmogQ6/E4Y5bLoARvs/un+/f7QFf45AckaATYBEwHm/g7C5BkDsQABAHr/7AYZBDoAIwBashskJRESOQCwAEVYsAAvG7EAGD5ZsABFWLATLxuxExg+WbAARViwGS8bsRkQPlmwAEVYsB4vG7EeED5ZsgUBCitYIdgb9FmyCQAeERI5sA7QshsTGRESOTAxAQIHFBYzMjY1ETMRFhYzMjY1JgMzFhEQAiMiJwYGIyICERA3AcSKB3JqbHG7AXFranIHisOHz7zwVSmkd7zPhwQ6/uXvy+OtpgEt/s6kquLM7wEb9P7q/u3+z+51eQExARMBH+sAAAIAef/sBHkFxgAfACgAbrIUKSoREjmwFBCwJtAAsABFWLAZLxuxGRw+WbAARViwBi8bsQYQPlmyHRkGERI5sB0vsgIBCitYIdgb9FmyCxkGERI5sAYQsg8BCitYIdgb9FmwAhCwE9CwHRCwI9CwGRCyJgEKK1gh2Bv0WTAxAQYHFQYGIyImNRE3ERQWMzI2NTUmADU0NjMyFhURNjcBFBYXESYjIhUEeTxTAuXIy/e6jHx0gtn+87iWn7I/SP2UoooFk5QCcxcJptPu99cBRwL+sI+bkpimHwEa2aC7xbL+oQUTAVKFvR4BaMbEAAAB/9oAAARuBbwAGgBJsgAbHBESOQCwAEVYsAQvG7EEHD5ZsABFWLAXLxuxFxw+WbAARViwDS8bsQ0QPlmyAAQNERI5sAQQsgkBCitYIdgb9FmwEtAwMQETNjYzMhcHJiMiBwERIxEBJiMiByc2MzIWFwIk4StrV0g0JA0nRiT+17/+2CdDJw0kNEdYayoDBgH7Y1gblwhP/Xf9xgI8AodPCJYcVF0AAgBK/+wGGwQ6ABIAJgBwsggnKBESObAIELAe0ACwAEVYsBEvG7ERGD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmwERCyAAEKK1gh2Bv0WbIIEQYREjmwD9CwENCwFdCwFtCwChCyGwEKK1gh2Bv0WbIfChEREjmwJNAwMQEjFhUQAiMiJwYjIgIRNDcjNSEBJichBgcUFjMyNjcRMxEWFjMyNgYbiEC8q/FTU/CqvUB0BdH+/gRK/LtLBGBYaXECuwJxalZgA6Gsxf7v/s3v7wEwARS/spn99qrHyKnL46eiAQf++aKn4gABACr/9QWxBbAAGABhshEZGhESOQCwAEVYsBcvG7EXHD5ZsABFWLAJLxuxCRA+WbAXELIAAQorWCHYG/RZsgQXCRESObAEL7AJELIKAQorWCHYG/RZsAQQshABCitYIdgb9FmwABCwFdCwFtAwMQEhETYzMgQQBCMnMjY1JiYjIgcRIxEhNSEElP32nYT0ARL+/O0Cm5gCo6KWisH+YQRqBRL+OTDx/k7jlpGUjpYu/VoFEp4AAAEAe//sBNwFxAAfAIayAyAhERI5ALAARViwCy8bsQscPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmyFgMLERI5sBYvtL8WzxYCcbLPFgFdsp8WAXGy/xYBXbIvFgFdsl8WAXKyjxYBcrIXAQorWCHYG/RZsAMQshwBCitYIdgb9FmwAxCwH9AwMQEGBCMgABE1NBIkMzIAFyMmJiMiAgchFSEVFBIzMjY3BNwb/uHu/v7+yY8BC7DoARgXwBmnl7nOAgI6/cbGsqCrHAHO5/sBcgE2i8kBNaf+/eWsnv7x6p0C7f7okbQAAgAxAAAIOwWwABgAIQB0sgkiIxESObAJELAZ0ACwAEVYsAAvG7EAHD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyAQAIERI5sAEvsAAQsgoBCitYIdgb9FmwEBCyEgEKK1gh2Bv0WbABELIZAQorWCHYG/RZsBIQsBrQsBvQMDEBESEWBBUUBAchESEDAgIGByM1Nz4CNxMBESEyNjU0JicE7gFp3gEG/v7e/dP+ABoPWayQPyhdZDQLHgN3AV+Mop2KBbD9ywPwy8bzBAUS/b/+3v7ciQKdAgdr6vMCwv0t/cCehICcAgACALEAAAhNBbAAEgAbAIKyARwdERI5sAEQsBPQALAARViwEi8bsRIcPlmwAEVYsAIvG7ECHD5ZsABFWLAPLxuxDxA+WbAARViwDC8bsQwQPlmyAAIPERI5sAAvsgQMAhESObAEL7AAELIOAQorWCHYG/RZsAQQshMBCitYIdgb9FmwDBCyFAEKK1gh2Bv0WTAxASERMxEhFgQVFAQHIREhESMRMwERITI2NTQmJwFyAs7AAWriAQH+/9/90/0ywcEDjgFfjqCYigM5Anf9ngPivb/pBAKc/WQFsP0B/fWOenSMAwABAD4AAAXUBbAAFQBdsg4WFxESOQCwAEVYsBQvG7EUHD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmwFBCyAAEKK1gh2Bv0WbIEFAgREjmwBC+yDQEKK1gh2Bv0WbAAELAS0LAT0DAxASERNjMyFhcRIxEmJiMiBxEjESE1IQSm/fCgr/ryA8EBiaSppsD+aARoBRL+UCja3f4tAc6Yhir9PgUSngABALD+mQT/BbAACwBIALAJL7AARViwAC8bsQAcPlmwAEVYsAQvG7EEHD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAD0DAxEzMRIREzESERIxEhsMECzsD+QMH+MgWw+u0FE/pQ/pkBZwACAKIAAASxBbAADAAVAFuyDxYXERI5sA8QsAPQALAARViwCy8bsQscPlmwAEVYsAkvG7EJED5ZsAsQsgABCitYIdgb9FmyAgsJERI5sAIvsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxASERIRYEFRQEByERIQERITI2NTQmJwQh/UIBauQBAP7+3/3SA3/9QgFfj5+ZjQUS/kwD5MTF6gQFsP0Q/d2YgHuOAgACADL+mgXJBbAADgAVAFuyEhYXERI5sBIQsAvQALAEL7AARViwCy8bsQscPlmwAEVYsAIvG7ECED5ZsAQQsAHQsAIQsgYBCitYIdgb9FmwDdCwDtCwD9CwENCwCxCyEQEKK1gh2Bv0WTAxASMRIREjAzM2EjcTIREzISERIQMGAgXHv/vrwAF3Xm8OIANnvvu7Asb+ExUNa/6bAWX+mgIDagFl1QJv+u0Edf5U+/6eAAEAGwAABzUFsAAVAIYAsABFWLAJLxuxCRw+WbAARViwDS8bsQ0cPlmwAEVYsBEvG7ERHD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsBQvG7EUED5ZsAIQsBDQsBAvsi8QAV2yzxABXbIAAQorWCHYG/RZsATQsggQABESObAQELAL0LITABAREjkwMQEjESMRIwEjAQEzATMRMxEzATMBASMEqJzApf5k8AHq/jzjAYOlwJ4Bg+L+PAHq7wKY/WgCmP1oAwACsP2IAnj9iAJ4/VH8/wABAFD/7ARqBcQAKABysgMpKhESOQCwAEVYsAsvG7ELHD5ZsABFWLAWLxuxFhA+WbALELIDAQorWCHYG/RZsAsQsAbQsiUWCxESObAlL7LPJQFdsp8lAXGyJAEKK1gh2Bv0WbIRJCUREjmwFhCwG9CwFhCyHgEKK1gh2Bv0WTAxATQmIyIGFSM0NjYzMgQVFAYHBBUUBCMiJiY1MxQWMzI2NRAlIzUzNjYDlKmZgK3Af+SK9AEOfG8BAf7c9JHthMC2jJ27/sO0s5KWBCl0iY1odLhn28NlpjBW/8TmZ76Dc5mSeAEABZ4DfgABALEAAAT/BbAACQBdALAARViwAC8bsQAcPlmwAEVYsAcvG7EHHD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAACERI5QAmKBJoEqgS6BARdsgkAAhESOUAJhQmVCaUJtQkEXTAxATMRIxEBIxEzEQQ/wMD9M8HBBbD6UARi+54FsPueAAABAC8AAAT2BbAAEQBNsgQSExESOQCwAEVYsAAvG7EAHD5ZsABFWLABLxuxARA+WbAARViwCS8bsQkQPlmwABCyAwEKK1gh2Bv0WbAJELILAQorWCHYG/RZMDEBESMRIQMCAgYHIzU3PgI3EwT2wP32Gg9ZrJA/KF1kNAseBbD6UAUS/b/+3v7ciQKdAgdr6vMCwgAAAQBN/+sEywWwABEASrIEEhMREjkAsABFWLABLxuxARw+WbAARViwEC8bsRAcPlmwAEVYsAcvG7EHED5ZsgABBxESObILAQorWCHYG/RZsg8HEBESOTAxAQEzAQ4CIyInNxcyPwIBMwKdAU/f/f00WnlbTxYGW2kzGSb+ENcCYwNN+0N0YTMJmARlNFkENgAAAwBT/8QF4wXsABgAIQAqAFuyDCssERI5sAwQsCDQsAwQsCLQALALL7AXL7IVFwsREjmwFS+wANCyCQsXERI5sAkvsA3QsBUQshkBCitYIdgb9FmwCRCyJAEKK1gh2Bv0WbAf0LAZELAi0DAxATMWBBIVFAIEByMVIzUjIiQCEBIkMzM1MwMiBhUUFjMzETMRMzI2NTQmIwN4H6UBEJeY/vSkI7ocp/7vl5cBEaccuta829q/Grocv9fXwwUeAZj+9aWm/vKXAsTEmAEMAU4BDJjO/pvnzc7lA2f8mevKyOoAAAEAr/6hBZcFsAALADsAsAkvsABFWLAALxuxABw+WbAARViwBC8bsQQcPlmwAEVYsAovG7EKED5ZsgIBCitYIdgb9FmwBtAwMRMzESERMxEzAyMRIa/BAs7AmRKt+9cFsPrtBRP68f4AAV8AAAEAlgAABMgFsAASAEayBRMUERI5ALAARViwAC8bsQAcPlmwAEVYsAovG7EKHD5ZsABFWLABLxuxARA+WbIPAAEREjmwDy+yBgEKK1gh2Bv0WTAxAREjEQYGIyImJxEzERYWMzI3EQTIwWmsbvnyA8EBiaO+xQWw+lACWx4X2N8B0/4ymIY2ArYAAAEAsAAABtcFsAALAEgAsABFWLAALxuxABw+WbAARViwAy8bsQMcPlmwAEVYsAcvG7EHHD5ZsABFWLAJLxuxCRA+WbIBAQorWCHYG/RZsAXQsAbQMDEBESERMxEhETMRIREBcQH1vwHywPnZBbD67QUT+u0FE/pQBbAAAQCw/qEHagWwAA8AVACwCy+wAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwBy8bsQccPlmwAEVYsA0vG7ENED5ZsgEBCitYIdgb9FmwBdCwBtCwCdCwCtCwAtAwMQERIREzESERMxEzAyMRIREBcQH1vwHywJMSpfn9BbD67QUT+u0FE/rn/goBXwWwAAACABAAAAW4BbAADAAVAF6yARYXERI5sAEQsA3QALAARViwAC8bsQAcPlmwAEVYsAkvG7EJED5ZsgIACRESObACL7AAELILAQorWCHYG/RZsAIQsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxEyERITIEFRQEByERIQERITI2NTQmJxACWwFa7wEE/v7i/db+ZgJbAV+On5mMBbD9ruXGxesDBRj9qP3dmIB7jgIAAAMAsgAABjAFsAAKABMAFwBtshIYGRESObASELAG0LASELAV0ACwAEVYsAkvG7EJHD5ZsABFWLAWLxuxFhw+WbAARViwBy8bsQcQPlmwAEVYsBQvG7EUED5ZsgAJBxESObAAL7ILAQorWCHYG/RZsAcQsgwBCitYIdgb9FkwMQEhFgQVFAQHIREzEREhMjY1NCYnASMRMwFyAWrkAQD+/t/908ABX4+fmY0DV8DAA14D5MTF6gQFsP0Q/d2YgHuOAv1ABbAAAAIAowAABLEFsAAKABMATbINFBUREjmwDRCwAdAAsABFWLAJLxuxCRw+WbAARViwBy8bsQcQPlmyAAkHERI5sAAvsgsBCitYIdgb9FmwBxCyDAEKK1gh2Bv0WTAxASEWBBUUBAchETMRESEyNjU0JicBYwFq5AEA/v7f/dPAAV+Pn5mNA14D5MTF6gQFsP0Q/d2YgHuOAgAAAQCT/+wE9AXEAB8Aj7IMICEREjkAsABFWLATLxuxExw+WbAARViwHC8bsRwQPlmwANCwHBCyAwEKK1gh2Bv0WbIIHBMREjmwCC+07wj/CAJxss8IAV2yLwgBcbS/CM8IAnGynwgBcbL/CAFdsi8IAV2yXwgBcrKPCAFysgYBCitYIdgb9FmwExCyDAEKK1gh2Bv0WbATELAP0DAxARYWMzISNyE1ITQCIyIGByM2ADMyBBIVFRQCBCMiJCcBVByroK3JAv3DAj3PupanGcEXARjosAELj47+/aju/uEbAc60kQEO8J7tARScruUBA6f+y8mRyf7MpfvnAAIAt//sBtoFxAAXACUAobIhJicREjmwIRCwEtAAsABFWLATLxuxExw+WbAARViwDS8bsQ0cPlmwAEVYsAQvG7EEED5ZsABFWLAKLxuxChA+WbIPCg0REjmwDy+yXw8BXbL/DwFdtE8PXw8CcbSPD58PAnGyLw8BcbLPDwFdsi8PAV2yzw8BcbIIAQorWCHYG/RZsBMQshsBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxARQCBCMiJAInIxEjETMRMzYSJDMyBBIVJxACIyICBxUUEjMyEjcG2pD++LCm/vmVCNHAwNADkAEKrK8BC5C/0Lu20QPTubrMAwKp1v7BqKABKsf9gwWw/WTOATerqf6/1QIBAwEV/uv2a/v+4QEP/QAAAgBZAAAEZAWwAAwAFQBhshAWFxESObAQELAK0ACwAEVYsAovG7EKHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmyEQoAERI5sBEvsgEBCitYIdgb9FmyBQEKERI5sAoQshIBCitYIdgb9FkwMSERIQEjASQRNCQzIREBFBYXIREhIgYDo/6w/tPNAVL+5gER8wHP/O2lkwEa/u+cpQI3/ckCbG8BHtDn+lAD+YSgAQI+lAACAGH/7AQoBhEAGwAoAGKyHCkqERI5sBwQsAjQALAARViwEi8bsRIePlmwAEVYsAgvG7EIED5ZsgASCBESObAAL7IXABIREjmyDxIXERI5shoACBESObIcAQorWCHYG/RZsAgQsiMBCitYIdgb9FkwMQEyEhUVFAYGIyIANTUQEjc2NjUzFAYHBwYGBzYXIgYVFRQWMzI2NTQmAmfM9XbdkNr+9v33jGKYcXyKpaUZk6+IoKGJiqChA/z+798RmfGFASP1WgFVAZIsGUg/fYwdHye5mqqYt6IQrsvMxJm5AAMAnQAABCkEOgAOABYAHACOshgdHhESObAYELAC0LAYELAW0ACwAEVYsAEvG7EBGD5ZsABFWLAALxuxABA+WbIXAQAREjmwFy+0vxfPFwJdtJ8XrxcCcbL/FwFdsg8XAXG0Lxc/FwJdtG8XfxcCcrIPAQorWCHYG/RZsggPFxESObAAELIQAQorWCHYG/RZsAEQshsBCitYIdgb9FkwMTMRITIWFRQGBxYWFRQGIwERITI2NTQjJTMgECcjnQGm2OdaWGJ328j+0AEydHPu/tXvAQT2/QQ6l5JLeSAXhl2VngHb/rpWTqKUATAFAAABAJoAAANHBDoABQArALAARViwBC8bsQQYPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIQNH/g26Aq0DofxfBDoAAgAu/sIEkwQ6AA4AFABbshIVFhESObASELAE0ACwDC+wAEVYsAQvG7EEGD5ZsABFWLAKLxuxChA+WbIAAQorWCHYG/RZsAbQsAfQsAwQsAnQsAcQsA/QsBDQsAQQshEBCitYIdgb9FkwMTc3NhMTIREzESMRIREjEyEhESEDAoNAbA8RArmLuf0NuQEBLwHx/rMLEZdPjAEYAbD8Xf4rAT7+wgHVAvj+/v69AAEAFQAABgQEOgAVAJAAsABFWLAJLxuxCRg+WbAARViwDS8bsQ0YPlmwAEVYsBEvG7ERGD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsBQvG7EUED5ZsAIQsBDQsBAvsr8QAV2y/xABXbIvEAFdss8QAXGyAAEKK1gh2Bv0WbAE0LIIEAAREjmwEBCwC9CyEwAQERI5MDEBIxEjESMBIwEBMwEzETMRMwEzAQEjA+uCuYL+0eoBg/6i4AEXf7l+ARng/qEBg+oB1v4qAdb+KgIwAgr+QAHA/kABwP31/dEAAQBY/+0DrARNACYAhrIDJygREjkAsABFWLAKLxuxChg+WbAARViwFS8bsRUQPlmwChCyAwEKK1gh2Bv0WbIlChUREjmwJS+0LyU/JQJdtL8lzyUCXbSfJa8lAnG0byV/JQJysgYlChESObIiAQorWCHYG/RZshAiJRESObIZFQoREjmwFRCyHAEKK1gh2Bv0WTAxATQmIyIGFSM0NjMyFhUUBgcWFRQGIyImNTMUFjMyNjU0JiMjNTM2At90ZWKDuOyxvtRYUb3mwLvzuI1paoJtc7nJvQMSTFlmRY20o5dJeiRAvJWut5xPcWJOW0+cBQABAJwAAAQBBDoACQBFALAARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAcCERI5sgkHAhESOTAxATMRIxEBIxEzEQNIubn+Dbm5BDr7xgMV/OsEOvzqAAABAJwAAAQ/BDoADAB3ALAARViwBC8bsQQYPlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmwAhCwBtCwBi+ynwYBXbL/BgFdss8GAXGynwYBcbS/Bs8GAl2yLwYBXbJvBgFysgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAd2Hurp5AWzg/lQB0OsBzf4zBDr+NgHK/fj9zgABACwAAAQDBDoADwBNsgQQERESOQCwAEVYsAAvG7EAGD5ZsABFWLABLxuxARA+WbAARViwCC8bsQgQPlmwABCyAwEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDEBESMRIQMCBgcjNTc2NjcTBAO6/pAWEpekSjVaTgsUBDr7xgOh/mv+6fAFowQKvP4BzwAAAQCdAAAFUgQ6AAwAWQCwAEVYsAEvG7EBGD5ZsABFWLALLxuxCxg+WbAARViwAy8bsQMQPlmwAEVYsAYvG7EGED5ZsABFWLAJLxuxCRA+WbIACwMREjmyBQsDERI5sggLAxESOTAxJQEzESMRASMBESMRMwL7AXDnuf6igP6bufD1A0X7xgMT/O0DJPzcBDoAAQCcAAAEAAQ6AAsAigCwAEVYsAYvG7EGGD5ZsABFWLAKLxuxChg+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAAQsAnQsAkvsm8JAV20vwnPCQJdsj8JAXG0zwnfCQJxsg8JAXK0nwmvCQJxsv8JAV2yDwkBcbKfCQFdsi8JAV20bwl/CQJysgIBCitYIdgb9FkwMSEjESERIxEzESERMwQAuf4PuroB8bkBzv4yBDr+KwHVAAEAnAAABAEEOgAHADgAsABFWLAGLxuxBhg+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAYQsgIBCitYIdgb9FkwMSEjESERIxEhBAG5/g66A2UDofxfBDoAAQAoAAADsAQ6AAcAMQCwAEVYsAYvG7EGGD5ZsABFWLACLxuxAhA+WbAGELIAAQorWCHYG/RZsATQsAXQMDEBIREjESE1IQOw/pW5/pwDiAOk/FwDpJYAAAMAZP5gBWkGAAAaACUAMAB/sgcxMhESObAHELAg0LAHELAr0ACwBi+wAEVYsAMvG7EDGD5ZsABFWLAKLxuxChg+WbAARViwEy8bsRMSPlmwAEVYsBAvG7EQED5ZsABFWLAXLxuxFxA+WbAKELIeAQorWCHYG/RZsBAQsiMBCitYIdgb9FmwKdCwHhCwLtAwMRMQEjMyFxEzETYzMhIRFAIjIicRIxEGIyICNSU0JiMiBxEWMzI2JRQWMzI3ESYjIgZk0rdVQLlGXrjS0bdhRblCVbbRBEyMez8vLUN8ifxtgno6Lyo9eoQCCQEPATYdAc/+KyP+yv7c7/7mIP5VAagdARr1D8zhFPzxEcCytrwSAxER2gAAAQCc/r8EggQ6AAsAOwCwCC+wAEVYsAAvG7EAGD5ZsABFWLAELxuxBBg+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAG0DAxEzMRIREzETMDIxEhnLoB8rmBEqb80gQ6/F0Do/xd/igBQQAAAQBnAAADvQQ7ABAARrIEERIREjkAsABFWLAILxuxCBg+WbAARViwDy8bsQ8YPlmwAEVYsAAvG7EAED5ZsgwPABESObAML7IEAQorWCHYG/RZMDEhIxEGIyImJxEzERYzMjcRMwO9unqAy9UCuQXkgHq6AYgg0MABQ/638iACGgABAJwAAAXgBDoACwBIALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAHLxuxBxg+WbAARViwCS8bsQkQPlmyAQEKK1gh2Bv0WbAF0LAG0DAxAREhETMRIREzESERAVYBjLkBi7r6vAQ6/F0Do/xdA6P7xgQ6AAEAkf6/Bm0EOgAPAEsAsAwvsABFWLAALxuxABg+WbAARViwAy8bsQMYPlmwAEVYsAcvG7EHGD5ZsABFWLANLxuxDRA+WbIBAQorWCHYG/RZsAXQsAnQMDEBESERMxEhETMRMwMjESERAUsBjLkBi7qYEqb63AQ6/F0Do/xdA6P8Xf4oAUEEOgACAB4AAAS/BDoADAAVAF6yARYXERI5sAEQsA3QALAARViwAC8bsQAYPlmwAEVYsAkvG7EJED5ZsgIACRESObACL7AAELILAQorWCHYG/RZsAIQsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxEyERIRYWFRQGIyERIQERITI2NTQmJx4B+gEZuNbcuv42/r8B+gETaHJvZAQ6/osCvKGixAOi/oz+aWtdWnMCAAADAJ0AAAV/BDoACgAOABcAbbIGGBkREjmwBhCwDNCwBhCwE9AAsABFWLAJLxuxCRg+WbAARViwDS8bsQ0YPlmwAEVYsAcvG7EHED5ZsABFWLALLxuxCxA+WbIADQcREjmwAC+yDwEKK1gh2Bv0WbAHELIQAQorWCHYG/RZMDEBIRYWFRQGIyERMwEjETMBESEyNjU0JicBVgEZuNbcuv42uQQpurr71wETaHJvZALFAryhosQEOvvGBDr99P5pa11acwIAAgCdAAAD/QQ6AAoAEwBNsgcUFRESObAHELAN0ACwAEVYsAkvG7EJGD5ZsABFWLAHLxuxBxA+WbIACQcREjmwAC+yCwEKK1gh2Bv0WbAHELIMAQorWCHYG/RZMDEBIRYWFRQGIyERMxERITI2NTQmJwFWARm41ty6/ja5ARNocm9kAsUCvKGixAQ6/fT+aWtdWnMCAAEAZP/sA+AETgAfAIKyACAhERI5ALAARViwCC8bsQgYPlmwAEVYsBAvG7EQED5ZsAgQsgABCitYIdgb9FmyHQgQERI5sB0vtC8dPx0CXbS/Hc8dAl20nx2vHQJxtG8dfx0CcrIDCB0REjmyFBAIERI5sBAQshcBCitYIdgb9FmwHRCyGgEKK1gh2Bv0WTAxASIGFSM0NjYzMgAVFRQGBiMiJjUzFBYzMjY3ITUhJiYCCGORsHbEatMBBXfXirTwsI5md5oM/moBlA6WA7Z+Vl2qZf7P9h+Y+4ngp2aLuKGYkrEAAAIAnf/sBjAETgAUAB8AnbINICEREjmwDRCwFdAAsABFWLAULxuxFBg+WbAARViwBC8bsQQYPlmwAEVYsBEvG7ERED5ZsABFWLAMLxuxDBA+WbIAERQREjmwAC+0vwDPAAJdtJ8ArwACcbL/AAFdsg8AAXG0LwA/AAJdtl8AbwB/AANyshABCitYIdgb9FmwDBCyGAEKK1gh2Bv0WbAEELIdAQorWCHYG/RZMDEBITYAMzIAFxcUBgYjIgAnIREjETMBFBYgNjU0JiMiBgFWAQQVAQnK1AEOCwF84JDR/vYQ/v25uQG6pwEapaiMiqgCb9gBB/7i5Tqe/okBEdr+KQQ6/de02t7Gsd7aAAACAC8AAAPHBDoADQAWAGGyFBcYERI5sBQQsA3QALAARViwAC8bsQAYPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbISAAEREjmwEi+yAwEKK1gh2Bv0WbIHAwAREjmwABCyEwEKK1gh2Bv0WTAxAREjESEDIwEmJjU0NjcDFBYXIREhIgYDx7r+6f/IARBob9663mxZASb+9md6BDr7xgGl/lsBwSafapS1Af60T2EBAWdlAAH/6P5LA98GAAAiAISyDSMkERI5ALAfL7AARViwBC8bsQQYPlmwAEVYsBkvG7EZED5ZsABFWLAKLxuxChI+WbK/HwFdsi8fAV2yDx8BXbIeGR8REjmwHi+wIdCyAQEKK1gh2Bv0WbICGQQREjmwChCyDwEKK1gh2Bv0WbAEELIVAQorWCHYG/RZsAEQsBvQMDEBIRE2MyATERQGIyInNxYyNjURNCYjIgYHESMRIzUzNTMVIQJj/uJ7xQFXA6qYPTYPI4JIaXBaiCa5pKS5AR4Euf7+l/59/NyqshKTDWhcAyB4cmBO/P0EuZivrwABAGf/7AP3BE4AHwCcsgAgIRESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsgMIEBESObIbEAgREjmwGy+0DxsfGwJytL8bzxsCXbSfG68bAnG0zxvfGwJxsv8bAV2yDxsBcbQvGz8bAl20bxt/GwJysr8bAXKyFBAbERI5sBAQshcBCitYIdgb9FmwGxCyHAEKK1gh2Bv0WTAxJTI2NzMOAiMiABE1NDY2MzIWFyMmJiMiBgchFSEWFgJIY5QIsAV4xG7e/v112JS28QiwCI9ogpoKAZT+bAqZg3haXqhjASgBAB6f94barmmHsZ2YoK0AAgAnAAAGhgQ6ABYAHwB5sgkgIRESObAJELAX0ACwAEVYsAAvG7EAGD5ZsABFWLAILxuxCBA+WbAARViwDy8bsQ8QPlmyAQAIERI5sAEvsAAQsgoBCitYIdgb9FmwDxCyEQEKK1gh2Bv0WbABELIXAQorWCHYG/RZsAgQshgBCitYIdgb9FkwMQERIRYWFRQGByERIQMCBgcjNTc2NjcTAREhMjY1NCYnA98BHrbT07f+Kf6vFxScpUE2VU0NFwK8ARNldXJjBDr+ZAO1lJO8AwOh/lr+6+QCowQKp9MCD/3M/o9pVlFgAQAAAgCcAAAGpwQ6ABIAGwB7sgEcHRESObABELAT0ACwAEVYsAIvG7ECGD5ZsABFWLARLxuxERg+WbAARViwCy8bsQsQPlmwAEVYsA8vG7EPED5ZsgERCxESObABL7AE0LABELINAQorWCHYG/RZsAQQshMBCitYIdgb9FmwCxCyFAEKK1gh2Bv0WTAxASERMxEhFhYVFAYjIREhESMRMwERITI2NTQmJwFWAfG5ASK00dm9/jb+D7q6AqoBE2V1cmMCoQGZ/mMEsZaXuwIK/fYEOv3M/o9pVlFgAQAB//0AAAPfBgAAGQB5sgwaGxESOQCwFi+wAEVYsAQvG7EEGD5ZsABFWLAHLxuxBxA+WbAARViwEC8bsRAQPlmyvxYBXbIvFgFdsg8WAV2yGRAWERI5sBkvsgABCitYIdgb9FmyAgQHERI5sAQQsgwBCitYIdgb9FmwABCwEtCwGRCwFNAwMQEhETYzIBMRIxEmJiMiBgcRIxEjNTM1MxUhAnn+zHvFAVcDuQFpb1qIJrmPj7kBNAS+/vmX/n39NQLMdXBgTvz9BL6Xq6sAAAEAnP6cBAEEOgALAEUAsAgvsABFWLAALxuxABg+WbAARViwAy8bsQMYPlmwAEVYsAUvG7EFED5ZsABFWLAJLxuxCRA+WbIBAQorWCHYG/RZMDEBESERMxEhESMRIREBVgHyuf6tuf6nBDr8XQOj+8b+nAFkBDoAAAEAnP/sBnUFsAAgAGCyByEiERI5ALAARViwAC8bsQAcPlmwAEVYsA4vG7EOHD5ZsABFWLAXLxuxFxw+WbAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsgcABBESObITAQorWCHYG/RZsBzQMDEBERQGIyImJwYGIyImJxEzERQWMzI2NREzERQWMzI2NREGdeHDbasxNLJxvdcBwXJicoLHfGlqegWw+97G3FdZWVfbwwQm+917iol8BCP73X2IiX0EIgABAIH/6wWtBDoAHgBgsgYfIBESOQCwAEVYsAAvG7EAGD5ZsABFWLAMLxuxDBg+WbAARViwFS8bsRUYPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbIGFQQREjmyEQEKK1gh2Bv0WbAa0DAxAREUBiMiJwYjIiYnETMRFhYzMjY1ETMRFBYzMjY3EQWtyq7GWV/Op8ABuQFbU2JvumVcWWUBBDr9J7DGlJTDsALc/SNmdXhnAtn9J2d4dWYC3QAC/9wAAAP8BhYAEQAaAHGyFBscERI5sBQQsAPQALAARViwDi8bsQ4ePlmwAEVYsAgvG7EIED5ZshEOCBESObARL7IAAQorWCHYG/RZsgIOCBESObACL7AAELAK0LARELAM0LACELISAQorWCHYG/RZsAgQshMBCitYIdgb9FkwMQEhESEWFhAGByERIzUzETMRIQERITI2NTQmJwKW/r8BGLvU1Lf+Kr+/ugFB/r8BEmlxb2QEOv6wAsr+ttEDBDqXAUX+u/2B/kV3ZGF9AgAAAQC3/+0GoAXFACYAh7IeJygREjkAsABFWLAFLxuxBRw+WbAARViwJi8bsSYcPlmwAEVYsB0vG7EdED5ZsABFWLAjLxuxIxA+WbIQBR0REjmwEC+wANCwBRCwCdCwBRCyDAEKK1gh2Bv0WbAQELIRAQorWCHYG/RZsB0QshYBCitYIdgb9FmwHRCwGdCwERCwIdAwMQEzNhIkMzIAFyMmJiMiAgchFSEVFBIzMjY3MwYEIyAAETUjESMRMwF4xwWTAQas5gEZGMAZp5e0zwYCHv3ixrKjqRzAG/7h7v7+/snHwcEDQMEBJp7/AOisnv774pca7f7ok7Ln+wFyATYU/VcFsAABAJn/7AWhBE4AJADEsgMlJhESOQCwAEVYsAQvG7EEGD5ZsABFWLAkLxuxJBg+WbAARViwIS8bsSEQPlmwAEVYsBwvG7EcED5Zsg8cBBESObAPL7S/D88PAl20Pw9PDwJxtM8P3w8CcbQPDx8PAnK0nw+vDwJxsv8PAV2yDw8BcbQvDz8PAl20bw9/DwJysADQsggPBBESObAEELILAQorWCHYG/RZsA8QshABCitYIdgb9FmwHBCyFAEKK1gh2Bv0WbIXHAQREjmwEBCwH9AwMQEzNhIzMhYXIyYmIyIGByEVIRYWMzI2NzMOAiMiAicjESMRMwFTvxD/0bbxCLAIj2iEmAoBtf5LCpmDY5QIsAV4xG7R/hDAuroCZ98BCNquaYexnpegrXhaXqhjAQbe/jAEOgAAAgAoAAAE5AWwAAsADgBWALAARViwCC8bsQgcPlmwAEVYsAIvG7ECED5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCyDggCERI5MDEBIxEjESMDIwEzASMBIQMDiaq8npjFAg2rAgTF/Z8Bk8cBtv5KAbb+SgWw+lACWgJJAAACAA8AAAQlBDoACwAQAFYAsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsABFWLAKLxuxChA+WbINAggREjmwDS+yAQEKK1gh2Bv0WbAE0LIPCAIREjkwMQEjESMRIwMjATMBIwEhAycHAu11uXx3vQG6nwG9vv4ZAS+AGBgBKf7XASn+1wQ6+8YBwQE7WVkAAAIAyQAABvUFsAATABYAfACwAEVYsAIvG7ECHD5ZsABFWLASLxuxEhw+WbAARViwBC8bsQQQPlmwAEVYsAgvG7EIED5ZsABFWLAMLxuxDBA+WbAARViwEC8bsRAQPlmyFQIEERI5sBUvsADQsBUQsgYBCitYIdgb9FmwCtCwBhCwDtCyFgIEERI5MDEBIQEzASMDIxEjESMDIxMhESMRMwEhAwGKAYcBNasCBMWWqryemMWe/rPBwQJFAZPHAlkDV/pQAbb+SgG2/koBuP5IBbD8qgJJAAACALwAAAXkBDoAEwAYAH8AsABFWLACLxuxAhg+WbAARViwEi8bsRIYPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbAARViwDC8bsQwQPlmwAEVYsBAvG7EQED5ZsgAQEhESObAAL7AB0LIOAQorWCHYG/RZsAvQsAfQsAEQsBTQsBXQshcSBBESOTAxASEBMwEjAyMRIxEjAyMTIxEjETMBIQMnBwF2AQ8BA58Bvb56dbl8d7150bq6AckBL4AYGAHBAnn7xgEp/tcBKf7XASj+2AQ6/YcBO1lZAAACAJMAAAY/BbAAHQAhAHayHiIjERI5sB4QsA7QALAARViwHC8bsRwcPlmwAEVYsAUvG7EFED5ZsABFWLANLxuxDRA+WbAARViwFS8bsRUQPlmyAQ0cERI5sAEvsgoBCitYIdgb9FmwENCwARCwGtCwARCwHtCwHBCyIAEKK1gh2Bv0WTAxATMyFhcRIxEmJicjBxEjEScjIgYHESMRNjYzMwEhATMBIQRBG/TsA8EBfJqFFcENiJ6CBMAD7PMq/ngEsv2fEAEa/bsDKtTY/oIBeJCCAiP9lwJ2FnuN/nwBftjUAob9egHoAAACAJYAAAVLBDoAGwAfAHOyHCAhERI5sBwQsBTQALAARViwBi8bsQYYPlmwAEVYsBsvG7EbED5ZsABFWLAULxuxFBA+WbAARViwDC8bsQwQPlmyHBQGERI5sBwvsATQsBwQsAfQshABCitYIdgb9FmwF9CwBhCyHgEKK1gh2Bv0WTAxMzU2NjcBIQEWFhcVIzUmJiMjBxEjEScjIgYHFQEzEyGWBMrS/uEDv/7gzsUCugJzjDULuQY+jHUCAaIIt/6Lts3SBgHf/iEL09CtsZKBE/5PAbsJfpWxAlwBRgACALYAAAhyBbAAIgAmAJOyJicoERI5sCYQsB7QALAARViwCC8bsQgcPlmwAEVYsAsvG7ELHD5ZsABFWLAFLxuxBRA+WbAARViwIi8bsSIQPlmwAEVYsBsvG7EbED5ZsABFWLATLxuxExA+WbIJBQgREjmwCS+yBAEKK1gh2Bv0WbAJELAj0LAN0LAEELAe0LAY0LALELImAQorWCHYG/RZMDEhETY3IREjETMRIQEhATMyFhcRIxEmJicjBxEjEScjIgYHEQEzASECxQFP/mLBwQNZ/nkEs/54G/TsA8EBfJqFFsAOh56CBAIVEAEa/bsBeLNp/WwFsP18AoT9etTY/oIBeJCCAiX9mQJ1F3uN/nwDKgHoAAIAmwAABzsEOgAhACUAlrIeJicREjmwHhCwJdAAsABFWLAHLxuxBxg+WbAARViwCy8bsQsYPlmwAEVYsAAvG7EAED5ZsABFWLAFLxuxBRA+WbAARViwES8bsREQPlmwAEVYsBkvG7EZED5ZsgoLABESObAKL7IdAQorWCHYG/RZsAPQsAoQsA3QsB0QsBbQsAoQsCLQsAsQsiQBCitYIdgb9FkwMSE1NjchESMRMxEhASEBFhYXFSM1JiYjIwcRIxEnIwYGBxUBMxMhAoYCRv6HuroC0f7hA7/+4M7FAroCc4w1C7kGS4VvAgGiCLf+i6+taP48BDr+IgHe/iEL09CtsZKBE/5PAbsJAoCTrwJcAUYAAAIAUP5GA6oHhgApADIAh7IqMzQREjmwKhCwAtAAsBkvsC4vsABFWLAFLxuxBRw+WbAARViwEi8bsRIQPlmwBRCyAwEKK1gh2Bv0WbIoBRIREjmwKC+yJQEKK1gh2Bv0WbIMJSgREjmwEhCyHwEKK1gh2Bv0WbIPLgFdsC4QsCvQsCsvtA8rHysCXbIqLisREjmwMtAwMQE0JiMhNSEyBBUUBgcWFhUUBCMjBhUUFxcHJiY1NDY3MzY2NRAlIzUzIAM3MxUDIwM1MwLanYf+zgEr3gEGgXOCif734DSNgh9Keo2lojSGn/6+mYYBP7yXoP5y+p0EKm6AmNiyZ6QtKa2CxOUDbWlCD301qGN6gwEBlHkBCAWYA6WqCv7uARIKAAIATP5GA3YGMAApADIAnrIuMzQREjmwLhCwH9AAsBgvsC4vsABFWLAFLxuxBRg+WbAARViwES8bsREQPlmwBRCyAwEKK1gh2Bv0WbIoBREREjmwKC+0Lyg/KAJdtL8ozygCXbSfKK8oAnG0byh/KAJysiUBCitYIdgb9FmyDCUoERI5sBEQsh4BCitYIdgb9FmwLhCwK9CwKy+0DysfKwJdsiouKxESObAy0DAxATQmJyE1ITIWFRQGBxYVFAYjIwYVFBcXByYmNTQ2NzM2NzY1NCUjNTMgAzczFQMjAzUzAqd/cP7JASfK7mZb1/PIMo2CH0t8iqWiNnJDP/7omYgBE9qXoP5y+p0DCUNTApmqi0l3JEKvlK8DbWlCD303qGF6gwECMC5IogOYAx2qCv7uARIKAAADAGf/7AT6BcQAEQAYAB8AibIEICEREjmwBBCwEtCwBBCwGdAAsABFWLANLxuxDRw+WbAARViwBC8bsQQQPlmwDRCyEgEKK1gh2Bv0WbIWDQQREjmwFi+yLxYBXbLPFgFdsi8WAXGy/xYBXbJfFgFdtE8WXxYCcbKfFgFxsAQQshkBCitYIdgb9FmwFhCyHAEKK1gh2Bv0WTAxARQCBCMiJAInNTQSJDMyBBIXASICByEmAgMyEjchFhIE+o/++LGs/vaTApIBC6yvAQiRAv22ttAEAxQEzra2ygj87AjTAqnV/sKqqQE5zmnSAUKrqP7FzwIN/u3y+AEN+3ABAPTs/vgAAAMAW//sBDQETgAPABUAHACHsgQdHhESObAEELAT0LAEELAW0ACwAEVYsAQvG7EEGD5ZsABFWLAMLxuxDBA+WbIaDAQREjmwGi+0vxrPGgJdtJ8arxoCcbL/GgFdsg8aAXG0Lxo/GgJdtM8a3xoCcbIQAQorWCHYG/RZsAwQshQBCitYIdgb9FmwBBCyFgEKK1gh2Bv0WTAxEzQ2NjMyABcXFAYGIyIANQUhFhYgNgEiBgchJiZbe+GP1AEOCwF84JDe/vEDHP2fDaQBAqH+3H2iDwJeEqMCJ5/9i/7i5Tqe/okBM/tEm7i6Anm1k5exAAEAFgAABN0FwwAPAEayAhARERI5ALAARViwBi8bsQYcPlmwAEVYsA8vG7EPHD5ZsABFWLAMLxuxDBA+WbIBBgwREjmwBhCyCAEKK1gh2Bv0WTAxARc3ATY2MxcHIgYHASMBMwJDISMBCDOGZy4BQEAf/nyq/gfQAXaCgQM/l3gBqzxU+3kFsAABAC4AAAQLBE0AEQBGsgISExESOQCwAEVYsAUvG7EFGD5ZsABFWLARLxuxERg+WbAARViwDi8bsQ4QPlmyAQUOERI5sAUQsgoBCitYIdgb9FkwMQEXNxM2MzIXByYjIgYHASMBMwHbFxmdTaxHIxUNHR88EP7Xjf6DvQE8ZGQCH/IYlAgwLfy0BDoAAAIAZ/9zBPoGNAATACcAUrIFKCkREjmwBRCwGdAAsABFWLANLxuxDRw+WbAARViwAy8bsQMQPlmwBtCwDRCwENCyFwEKK1gh2Bv0WbAa0LADELIkAQorWCHYG/RZsCHQMDEBEAAHFSM1JgADNRAANzUzFRYAESc0AicVIzUGAhUVFBIXNTMVNhI1BPr+/uO55f7xAQEO57niAQO/mY25k6OkkrmPlwKp/t3+kSOBfx8BcQEjYAEkAXYfdngl/pD+2QfgAQkjYWQf/u7fXd7+7B9mZCIBC+IAAAIAW/+JBDQEtQATACUAWLIDJicREjmwAxCwHNAAsABFWLADLxuxAxg+WbAARViwEC8bsRAQPlmwAxCwBtCwEBCwDdCwEBCyIwEKK1gh2Bv0WbAU0LADELIdAQorWCHYG/RZsBrQMDETNBI3NTMVFhIVFRQCBxUjNSYCNQE2NjU0JicVIzUGBhUUFhc1M1vUubm62d22ubTZAkZjdnRluWJycWO5AifSASoicG8g/tjdENj+2B1rbB8BJ9z+eR/Nq5HQIGJhIdClkssiZgAAAwCc/+sGbwdRACwAQABJAKayCkpLERI5sAoQsDLQsAoQsEnQALAARViwFC8bsRQcPlmwAEVYsA0vG7ENED5ZsBQQsADQsA0QsAfQsgoNFBESObAUELIVAQorWCHYG/RZsA0QshwBCitYIdgb9FmyIBQNERI5sCXQsBUQsCzQsBQQsDjQsDgvsC/Qsi0CCitYIdgb9FmwLxCwNNCwNC+yPAIKK1gh2Bv0WbA4ELBE0LBJ0LBJLzAxATIWFREUBiMiJicGBiMiJicRNDYzFSIGFREUFjMyNjURMxEUFjMyNjURNCYjExUjIi4CIyIVFSM1NDYzMh4CATY3NTMVFAYHBNu72dm7cLI0NLBwudgE2L1jcXJicoLBgnNjcG9kaCtQgrg0GHGAf24oSL9q/kBCA51bOwWv8Nb9xtTwVVhYVejNAkrU8Z6dif3EjJuJfAGs/lR6i5yMAjqInwHCfyJQDHAPJG5sEVIb/pBQPGlmMnUgAAMAfv/rBaoF8QArAD8ASACssglJShESObAJELA80LAJELBI0ACwAEVYsBMvG7ETGD5ZsABFWLAMLxuxDBA+WbATELAA0LAMELAH0LIJDBMREjmwExCyFAEKK1gh2Bv0WbAMELIbAQorWCHYG/RZsh8TDBESObAk0LAUELAr0LATELA30LA3L7At0LAtL7IsAgorWCHYG/RZsC0QsDPQsDMvsjsCCitYIdgb9FmwNxCwQ9CwQy+wSNCwSC8wMQEyFhURFAYjIicGBiMiJicRNDYzFSIGFREUFjMyNjU1MxUWFjMyNjURNCYjExUjIi4CIyIVFSM1NDYzMh4CATY3NTMVFAYHBEKowMCo0F8vnGKjwQTAqFJdXFNib7kBcGFRXV1RqixPfsAwGHKAf28pSrdt/kFBA55bOwRE28L+38HalUtK0LsBMsHbmIh8/t57iXhn6+5ndYh9ASF8iAHHfyBSC28PJG5sElAc/oZOP2hmMnUgAAIAnP/sBnUHAwAgACgAgrIHKSoREjmwBxCwJ9AAsABFWLAPLxuxDxw+WbAARViwFy8bsRccPlmwAEVYsCAvG7EgHD5ZsABFWLAKLxuxChA+WbAE0LIHCg8REjmwChCyEwEKK1gh2Bv0WbAc0LAPELAn0LAnL7Ao0LAoL7IiBgorWCHYG/RZsCgQsCXQsCUvMDEBERQGIyImJwYGIyImJxEzERQWMzI2NREzERQWMzI2NRElNSEXIRUjNQZ14cNtqzE0snG91wHBcmJygsd8aWp6/EIDLAH+tagFsPvextxXWVlX28MEJvvde4qJfAQj+919iIl9BCLoa2t9fQAAAgCB/+sFrQWwAB4AJgCFsgYnKBESObAGELAj0ACwAEVYsA0vG7ENGD5ZsABFWLAVLxuxFRg+WbAARViwHi8bsR4YPlmwAEVYsAgvG7EIED5ZsATQsAQvsgYIDRESObAIELIRAQorWCHYG/RZsBrQsA0QsCXQsCUvsCbQsCYvsiAGCitYIdgb9FmwJhCwI9CwIy8wMQERFAYjIicGIyImJxEzERYWMzI2NREzERQWMzI2NxEBNSEXIRUjNQWtyq7GWV/Op8ABuQFbU2JvumVcWWUB/JMDLAP+s6kEOv0nsMaUlMOwAtz9I2Z1eGcC2f0nZ3h1ZgLdAQtra4CAAAABAHX+hAS8BcUAGQBJshgaGxESOQCwAC+wAEVYsAovG7EKHD5ZsABFWLACLxuxAhA+WbAKELAO0LAKELIRAQorWCHYG/RZsAIQshkBCitYIdgb9FkwMQEjESYANTU0EiQzMgAXIyYmIyICFRUUEhczAxS/2P74jgEAoPcBIALBArWhoM3FnXz+hAFsHAFW//SxASCf/vjgnqz+/NT0yv77BAABAGT+ggPgBE4AGQBJshgaGxESOQCwAC+wAEVYsAovG7EKGD5ZsABFWLACLxuxAhA+WbAKELAO0LAKELIRAQorWCHYG/RZsAIQshgBCitYIdgb9FkwMQEjESYCNTU0NjYzMhYVIzQmIyIGFRUUFhczAqK5sdR314uz8K+PZYScloJt/oIBcB4BJtkjmfmK4ahljNq1H6jbAwAAAQB0AAAEkAU+ABMAEwCwDi+wAEVYsAQvG7EEED5ZMDEBBQclAyMTJTcFEyU3BRMzAwUHJQJYASFE/t22qOH+30QBJc3+3kYBI7yl5wElSP7gAb6se6r+vwGOq3urAW2rfasBS/5oq3qqAAH8ZwSm/ycF/AAHABEAsAAvsgMGCitYIdgb9FkwMQEVJzchJxcV/Q2mAQIbAaUFI30B6WwB2AAAAfxxBRf/ZAYVABMALgCwDi+wCNCwCC+yAAIKK1gh2Bv0WbAOELAF0LAFL7AOELIPAgorWCHYG/RZMDEBMhYVFSM1NCMiBwcGByM1Mj4C/nZvf4ByKi1viXY8bGrBRwYVbG4kDnASLzoCfhtTEQAB/WYFFv5UBlcABQAMALABL7AF0LAFLzAxATUzFRcH/WazO00F3HuMdEEAAAH9pAUW/pMGVwAFAAwAsAMvsADQsAAvMDEBJzcnMxX98U07AbUFFkF0jHsACPob/sQBtgWvAAwAGgAnADUAQgBPAFwAagB6ALBFL7BTL7BgL7A4L7AARViwAi8bsQIcPlmyCQsKK1gh2Bv0WbBFELAQ0LBFELJMCworWCHYG/RZsBfQsFMQsB7QsFMQsloLCitYIdgb9FmwJdCwYBCwK9CwYBCyZwsKK1gh2Bv0WbAy0LA4ELI/CworWCHYG/RZMDEBNDYyFhUjNCYjIgYVATQ2MzIWFSM0JiMiBhUTNDYzMhYVIzQmIgYVATQ2MzIWFSM0JiMiBhUBNDYyFhUjNCYjIgYVATQ2MhYVIzQmIyIGFQE0NjMyFhUjNCYiBhUTNDYzMhYVIzQmIyIGFf0Ic750cDMwLjMB3nRdX3VxNS4sM0h1XV90cDVcM/7LdF1fdHA1Li0z/U9zvnRwMzAuM/1NdL50cDMwLjP+3nVdX3RwNVwzNXVdX3VxNS4tMwTzVGhoVC43NTD+61RoZ1UxNDUw/glVZ2hUMTQ3Lv35VGhoVDE0Ny7+5FRoaFQuNzcuBRpUaGhULjc1MP4JVWdoVDE0Ny79+VVnZ1UxNDUwAAj6LP5jAWsFxgAEAAkADgATABgAHQAiACcAOQCwIS+wEi+wCy+wGy+wJi+wAEVYsAcvG7EHHD5ZsABFWLAWLxuxFho+WbAARViwAi8bsQISPlkwMQUXAyMTAycTMwMBNwUVJQUHJTUFATclFwUBBwUnJQMnAzcTARcTBwP+Lwt6YEY6DHpgRgIdDQFN/qb7dQ3+swFaA5wCAUBE/tv88wL+wEUBJisRlEHGA2ARlELEPA7+rQFhBKIOAVL+oP4RDHxiRzsMfGJHAa4QmUTI/I4RmUXIAuQCAUZF/tX84wL+u0cBKwAAAv/cAAAD/AZxABEAGgB0shQbHBESObAUELAD0ACwAEVYsAwvG7EMHD5ZsABFWLAQLxuxEBw+WbAARViwCC8bsQgQPlmwEBCyAAEKK1gh2Bv0WbICDAgREjmwAi+wABCwCtCwC9CwAhCyEgEKK1gh2Bv0WbAIELITAQorWCHYG/RZMDEBIREhFhYQBgchESM1MzUzFSEBESEyNjU0JicClv6/ARi71NS3/iq/v7oBQf6/ARJpcW9kBRj90gLK/rbRAwUYmMHB/KL+RXdkYX0CAAIAqAAABNcFsAAOABsAVLIEHB0REjmwBBCwF9AAsABFWLADLxuxAxw+WbAARViwAS8bsQEQPlmyFgMBERI5sBYvsgABCitYIdgb9FmyCQADERI5sAMQshQBCitYIdgb9FkwMQERIxEhMgQVFAcXBycGIwE2NTQmJyERITI3JzcBacECGewBE2d+bYt2qAEZJaWR/qABWGJFbm4COv3GBbDyy7pwimeZNwEbQVuCnQL9xR15ZgAAAgCM/mAEIwROABMAIgB1shwjJBESObAcELAQ0ACwAEVYsBAvG7EQGD5ZsABFWLANLxuxDRg+WbAARViwCi8bsQoSPlmwAEVYsAcvG7EHED5ZsgIHEBESObIJEAcREjmyDhAHERI5sBAQshcBCitYIdgb9FmwBxCyHAEKK1gh2Bv0WTAxARQHFwcnBiMiJxEjETMXNjMyEhEnNCYjIgcRFjMyNyc3FzYEHmpvbm5Zc8VxuakJccnD47mciKhUU6tSPGZuWjICEe6XfWZ7OH399wXaeIz+2v76BLfUlf37lCdzZ2diAAABAKIAAAQjBwAACQA1sgMKCxESOQCwCC+wAEVYsAYvG7EGHD5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEBIxUhESMRIREzBCMD/ULAAsi5BRgG+u4FsAFQAAABAJEAAANCBXYABwAuALAGL7AARViwBC8bsQQYPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIREzA0L+CboB+LkDofxfBDoBPAABALH+3wR8BbAAFQBbsgoWFxESOQCwCS+wAEVYsBQvG7EUHD5ZsABFWLASLxuxEhA+WbAUELIAAQorWCHYG/RZsgMUCRESObADL7AJELIKAQorWCHYG/RZsAMQshABCitYIdgb9FkwMQEhETMgABEQAiMnMjY1JiYjIxEjESEEMP1CsgEcATz15AKRkAHMzrXBA38FEv4v/s/+8P74/ueTw8vL1P1hBbAAAAEAkf7lA74EOgAWAFuyCxcYERI5ALAKL7AARViwFS8bsRUYPlmwAEVYsBMvG7ETED5ZsBUQsgABCitYIdgb9FmyAxUKERI5sAMvsAoQsgsBCitYIdgb9FmwAxCyEQEKK1gh2Bv0WTAxASERMzIAFRQGBgcnNjY1NCYjIxEjESEDPv4NbO8BGGKqdTCAeLKYcLoCrQOh/uT+/NdiyIYVkiGZeZGo/h0EOgAAAQCjAAAE/wWwABQAYgCwAEVYsAAvG7EAHD5ZsABFWLAMLxuxDBw+WbAARViwAi8bsQIQPlmwAEVYsAovG7EKED5ZsA/QsA8vsi8PAV2yzw8BXbIIAQorWCHYG/RZsgEIDxESObAF0LAPELAS0DAxCQIjASMVIzUjESMRMxEzETMRMwEE0v5wAb3x/qJQlGjBwWiUTQFDBbD9Tv0CAo709P1yBbD9fwEA/wACgQAAAQCaAAAEfwQ6ABQAewCwAEVYsA0vG7ENGD5ZsABFWLAULxuxFBg+WbAARViwCi8bsQoQPlmwAEVYsAMvG7EDED5ZsAoQsA7QsA4vsp8OAV2y/w4BXbKfDgFxtL8Ozw4CXbIvDgFdsm8OAXKyCQEKK1gh2Bv0WbIBCQ4REjmwBdCwDhCwEtAwMQkCIwEjFSM1IxEjETMRMzUzFTMBBFr+rgF36/7rMpRlurpllCoBAwQ6/f79yAHNwsL+MwQ6/jbV1QHKAAEARAAABosFsAAOAGsAsABFWLAGLxuxBhw+WbAARViwCi8bsQocPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIBgIREjmwCC+yLwgBXbLPCAFdsgEBCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbIMAQgREjkwMQEjESMRITUhETMBMwEBIwOQsMH+JQKclgH87/3UAlbsAo79cgUYmP1+AoL9P/0RAAEAPgAABX0EOgAOAIAAsABFWLAGLxuxBhg+WbAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbACELAJ0LAJL7KfCQFdsv8JAV2ynwkBcbS/Cc8JAl2yLwkBXbJvCQFysgABCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbIMAAkREjkwMQEjESMRITUhETMBMwEBIwMbiLr+ZQJVegFr4f5TAdHrAc3+MwOhmf42Acr9+P3OAAABAKgAAAeEBbAADQBeALAARViwAi8bsQIcPlmwAEVYsAwvG7EMHD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmwAdCwAS+yLwEBXbACELIEAQorWCHYG/RZsAEQsggBCitYIdgb9FkwMQEhESEVIREjESERIxEzAWkC3gM9/YPA/SLBwQM+AnKY+ugCof1fBbAAAQCRAAAFaQQ6AA0AmwCwAEVYsAIvG7ECGD5ZsABFWLAMLxuxDBg+WbAARViwBi8bsQYQPlmwAEVYsAovG7EKED5ZsAYQsAHQsAEvsm8BAV20vwHPAQJdsj8BAXG0zwHfAQJxsg8BAXK0nwGvAQJxsv8BAV2yDwEBcbKfAQFdsi8BAV20bwF/AQJysAIQsgQBCitYIdgb9FmwARCyCAEKK1gh2Bv0WTAxASERIRUhESMRIREjETMBSwHxAi3+jLn+D7q6AmUB1Zn8XwHO/jIEOgAAAQCw/t8HzQWwABcAaLIRGBkREjkAsAcvsABFWLAWLxuxFhw+WbAARViwFC8bsRQQPlmwAEVYsBEvG7ERED5ZsgEWBxESObABL7AHELIIAQorWCHYG/RZsAEQsg4BCitYIdgb9FmwFhCyEgEKK1gh2Bv0WTAxATMgABEQAiMnMjY1JiYjIxEjESERIxEhBP92ARwBPPXkApGQAczOecH9MsAETwNB/s/+8P74/ueTw8vL1P1hBRL67gWwAAABAJH+5QawBDoAGABoshIZGhESOQCwCC+wAEVYsBcvG7EXGD5ZsABFWLAVLxuxFRA+WbAARViwEi8bsRIQPlmyARcIERI5sAEvsAgQsgkBCitYIdgb9FmwARCyDwEKK1gh2Bv0WbAXELITAQorWCHYG/RZMDEBMzIAFQcGBgcnNjY1NCYjIxEjESERIxEhA/ag+AEiAxTRmTB8e7ygpLn+DroDZQKF/vzXJqPhG5Igln2Sp/4dA6H8XwQ6AAIAcf/kBaIFxQAoADYAm7IYNzgREjmwGBCwKdAAsABFWLANLxuxDRw+WbAARViwHy8bsR8cPlmwAEVYsAQvG7EEED5ZsADQsAAvsgIEHxESObACL7ANELIOAQorWCHYG/RZsAQQshUBCitYIdgb9FmwAhCyLAEKK1gh2Bv0WbIXAiwREjmyJiwCERI5sAAQsigBCitYIdgb9FmwHxCyMwEKK1gh2Bv0WTAxBSInBiMiJAI1NTQSNjMXIgYVFRQSMzI3JgI1NTQ2NjMyEhUVFAIHFjMBFBYXNjY1NTQmIyIGFQWi17OOrLL+5J910oQBdpTsv0Y4eYRovXa25m9maHn9fXh1Ymh5Y2F6HElCsgFCxKyxASKjpf7Zpuz+1w1hARWq45r9jf7M/eue/vZfGgI0mO1KSOeN+bHO0rIAAAIAbf/rBJwETwAkAC8AorIEMDEREjmwBBCwJdAAsABFWLAMLxuxDBg+WbAARViwHC8bsRwYPlmwAEVYsAQvG7EEED5ZsABFWLAALxuxABA+WbICBBwREjmwAi+wDBCyDQEKK1gh2Bv0WbAEELIUAQorWCHYG/RZsAIQsicBCitYIdgb9FmyFhQnERI5sAAQsiQBCitYIdgb9FmyIickERI5sBwQsiwBCitYIdgb9FkwMQUiJwYjIiYCNTU0EjMVIgYVFRQWMzI3JhE1NDYzMhYVFRQHFjMBFBc2NzU0JiIGBwScsox2j4zhf8WbSV2piS4swa2PjLKAT2H+D59mA0l4RgEMOUKVARKnOs0BDp6tkjjB8AuiARFewOv5zmLjnRUBqdZ0c7p1gp6NegAAAQA0/qEGkwWwABMAWwCwES+wAEVYsAcvG7EHHD5ZsABFWLAMLxuxDBw+WbAARViwEy8bsRMQPlmwBxCyCAEKK1gh2Bv0WbAA0LAHELAF0LAD0LAC0LATELIKAQorWCHYG/RZsA7QMDEBITUhNTMVIRUhESERMxEzAyMRIQGr/okBd8EBgf5/As7BmBKs+9YFGJcBAZf7hQUT+vH+AAFfAAEAH/6/BRYEOgAPAEsAsA0vsABFWLADLxuxAxg+WbAARViwDy8bsQ8QPlmwAxCyBAEKK1gh2Bv0WbAA0LAPELIGAQorWCHYG/RZsAMQsAjQsAYQsArQMDEBITUhFSMRIREzETMDIxEhATH+7gLE+QHyuoASpfzSA6OXl/z0A6P8Xf4oAUEAAQCWAAAEyAWwABcAT7IEGBkREjkAsABFWLAALxuxABw+WbAARViwCi8bsQocPlmwAEVYsAwvG7EMED5ZsgcADBESObAHL7AE0LAHELIQAQorWCHYG/RZsBPQMDEBERYWMxEzETY3ETMRIxEGBxUjNSImJxEBVwGJoJV5eMHBcn+V+O8EBbD+MpqEATb+0g0hArb6UAJbIg3u6NnaAdcAAAEAgwAAA9kEOwAWAE+yBhcYERI5ALAARViwCy8bsQsYPlmwAEVYsBUvG7EVGD5ZsABFWLAALxuxABA+WbIPFQAREjmwDy+yBwEKK1gh2Bv0WbAE0LAPELAS0DAxISMRBgcVIzUmJicRMxEWFxEzETY3ETMD2bpGU5awuwK5Ba+WVEW6AYgTCYeFDcy1AUP+tdMaARj+6goRAhoAAAEAigAABLwFsAARAEayBRITERI5ALAARViwAS8bsQEcPlmwAEVYsAAvG7EAED5ZsABFWLAJLxuxCRA+WbIFAQAREjmwBS+yDgEKK1gh2Bv0WTAxMxEzETYzMhYXESMRJiYjIgcRisG5yvnyA8EBiaO7yAWw/aU12N/+LQHOmIY3/UsAAAIAP//qBb0FwwAdACUAZLIXJicREjmwFxCwJNAAsABFWLAPLxuxDxw+WbAARViwAC8bsQAQPlmyHw8AERI5sB8vshMBCitYIdgb9FmwBNCwHxCwC9CwABCyGAEKK1gh2Bv0WbAPELIjAQorWCHYG/RZMDEFIAARNSYmNTMUFhc0EjYzIAARFSEVFBYzMjcXBgYBITU0JiMiAgPp/uL+s5mmmFBXjv2WAQIBHPyC3syzpi9A0v3gAr6zq57CFgFRASlbE8WiWn0UtAEfov6j/r5sXdz3U48tNQNaIdnl/v0AAv/e/+wEYwROABkAIQByshQiIxESObAUELAb0ACwAEVYsA0vG7ENGD5ZsABFWLAALxuxABA+WbIeDQAREjmwHi+0vx7PHgJdshEBCitYIdgb9FmwA9CwHhCwCdCwABCyFQEKK1gh2Bv0WbIXDQAREjmwDRCyGgEKK1gh2Bv0WTAxBSIANSYmNTMUFz4CMzISERUhFhYzMjcXBgEiBgchNSYmAr3c/ux4d5NlFITIcNPq/SMEs4qub3GI/tlwmBICHgiIFAEh+h2uhpMwgslu/ur+/U2gxZJY0QPKo5MOjZsAAAEAo/7WBMwFsAAWAF2yFRcYERI5ALAOL7AARViwAi8bsQIcPlmwAEVYsAYvG7EGHD5ZsABFWLAALxuxABA+WbIEAAIREjmwBC+wCNCwDhCyDwEKK1gh2Bv0WbAEELIWAQorWCHYG/RZMDEhIxEzETMBMwEWABUQAiMnMjY1JiYnIQFkwcGFAgHi/fj4AQ355gKQkALHx/7sBbD9jwJx/YgW/tL6/vj+5JjBycrSAQAAAQCa/v4EGQQ6ABYAebINFxgREjkAsAcvsABFWLARLxuxERg+WbAARViwFS8bsRUYPlmwAEVYsA8vG7EPED5ZsBPQsBMvsp8TAV2y/xMBXbKfEwFxtL8TzxMCXbIvEwFdss8TAXGwANCwBxCyCAEKK1gh2Bv0WbATELIOAQorWCHYG/RZMDEBFhYVFAYGByc2NTQmJyMRIxEzETMBMwJ/w85krHAw+K2lsrq6WwGK4AJkH+K0XcV8E5I55oqSAv4zBDr+NgHKAAABALH+SwT+BbAAFQCnsgoWFxESOQCwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwCC8bsQgSPlmwAEVYsBMvG7ETED5ZsALQsAIvsl8CAV2yzwIBXbIfAgFxtG8CfwICcbS/As8CAnG0DwIfAgJysu8CAXGynwIBcbJPAgFxsv8CAV2yrwIBXbIvAgFdsj8CAXKwCBCyDQEKK1gh2Bv0WbACELIRAQorWCHYG/RZMDEBESERMxEUBiMiJzcWMzI2NREhESMRAXICzMCrnDw2DiU9QUj9NMEFsP1uApL5/ai6EpoOZ1wC1f1/BbAAAAEAkf5LA/UEOgAWAJ+yChcYERI5ALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAILxuxCBI+WbAARViwFC8bsRQQPlmwAtCwAi+ybwIBXbS/As8CAl2yPwIBcbTPAt8CAnGyDwIBcrSfAq8CAnGy/wIBXbIPAgFxsp8CAV2yLwIBXbRvAn8CAnKwCBCyDgEKK1gh2Bv0WbACELISAQorWCHYG/RZMDEBESERMxEUBiMiJzcWFxcyNjURIREjEQFLAfG5q5g8NA8RPBRCSP4PugQ6/isB1fttqrISkwcFAWhcAif+MgQ6AAACAF3/7AUSBcQAFwAfAF6yCCAhERI5sAgQsBjQALAARViwAC8bsQAcPlmwAEVYsAgvG7EIED5Zsg0ACBESObANL7AAELIRAQorWCHYG/RZsAgQshgBCitYIdgb9FmwDRCyGwEKK1gh2Bv0WTAxASAAERUUAgQjIAARNSE1EAIjIgcHJzc2ATISNyEVFBYCgAEuAWSc/uqn/uP+wQP09N2liz0vFp4BIaneD/zP0wXE/of+sVTF/r+2AVkBRXUHAQIBHDoajw1Y+sYBBdsi2uQAAQBo/+sELAWwABsAZ7ILHB0REjkAsABFWLACLxuxAhw+WbAARViwCy8bsQsQPlmwAhCyAAEKK1gh2Bv0WbAE0LIFAgsREjmwBS+wCxCwENCwCxCyEwEKK1gh2Bv0WbAFELIZAQorWCHYG/RZsAUQsBvQMDEBITUhFwEWFhUUBCMiJiY1MxQWMzI2NTQmIyM1Ax39dgNrAf5r2en+8+CG23bAnHuJo6aejQUSnn3+Hg7nxsPoab6CcpqSeJ2OlwAAAQBp/nUEKAQ6ABoAWrILGxwREjkAsAsvsABFWLACLxuxAhg+WbIAAQorWCHYG/RZsATQsgUCCxESObAFL7ALELAQ0LALELITAQorWCHYG/RZsAUQshgDCitYIdgb9FmwBRCwGtAwMQEhNSEXARYWFRQEIyImJjUzFBYzMjY1ECUjNQMM/YgDZQH+ctTo/vTehNd6up59jaT+yaADoZl2/hEQ4cXD52a/g3GflXkBIgiX//8AOv5LBHQFsAAmALBEAAAmAd6rQAAHAa8A8AAA//8AO/5LA5YEOgAmAOtPAAAmAd6sjgEHAa8A4QAAAAgAsgAGAV0wMQACAFcAAARlBbAACgATAFCyBBQVERI5sAQQsA3QALAARViwAS8bsQEcPlmwAEVYsAMvG7EDED5ZsgABAxESObAAL7ADELILAQorWCHYG/RZsAAQsgwBCitYIdgb9FkwMQERMxEhIiQ1NDY3AREhIgYVFBYXA6PC/d/k/vf/4AFt/qGMoZ+KA3MCPfpQ8svH6wT9KgI4loCCnwEAAgBZAAAGZwWwABcAHwBasgcgIRESObAHELAY0ACwAEVYsAgvG7EIHD5ZsABFWLAALxuxABA+WbIHCAAREjmwBy+wABCyGAEKK1gh2Bv0WbAK0LIQAAgREjmwBxCyGQEKK1gh2Bv0WTAxISIkNTQkNyERMxE3NjY3NiczFxYHBgYjJREhIgYUFhcCR+X+9wEB4wFqwVhvcgMEQLoWLwME5cP+7/6gjp6YhfTJxu0DAj366wECknuip0SXbsPonQI4l/6fBAAAAgBk/+cGbgYYAB8AKwCDshosLRESObAaELAq0ACwAEVYsAYvG7EGHj5ZsABFWLADLxuxAxg+WbAARViwGC8bsRgQPlmwAEVYsBwvG7EcED5ZsgUDGBESObAYELILAQorWCHYG/RZshEDGBESObIaAxgREjmwAxCyIgEKK1gh2Bv0WbAcELIoAQorWCHYG/RZMDETEBIzMhcRMxEGFjM2Njc2JzcWFgcOAiMGJwYjIgI1ASYjIgYVFBYzMjcnZOLEt2q5Al9OiZcEBEGzHCkCAnnZifJObNvA5ALHUqGHlJGIp1MFAgkBCAE9gwJN+0FfeALQvbrYAWbHZqn5hAS6tgEb9AExht/erb+TPgAAAQA2/+MF1QWwACcAY7IQKCkREjkAsABFWLAJLxuxCRw+WbAARViwIS8bsSEQPlmyASgJERI5sAEvsgABCitYIdgb9FmwCRCyBwEKK1gh2Bv0WbIPAAEREjmwIRCyFQEKK1gh2Bv0WbIaIQkREjkwMRM1MzY2NTQhITUhFhYVFAcWExUUFjM2Njc2JzMXFgcGAiMEAzU0Jif+m5+T/sv+oAFr7/zt2wVTQXSGBARBuhcwAwT2x/69D4d1AnmeAnuD+54B0cnoYkX+/FBPWwLOubvYWLuA/f7XCAFNQHiQAQABADH/4wToBDoAJwBgsg8oKRESOQCwAEVYsB8vG7EfGD5ZsABFWLAOLxuxDhA+WbICAQorWCHYG/RZsgcOHxESObIXKB8REjmwFy+yFAEKK1gh2Bv0WbAfELIdAQorWCHYG/RZsiUUFxESOTAxJQYzNjY3NiczFhYHBgYjBiYnNTQjIyczNjY1NCYjISchFhYVFAcWFwLnAl9wdgMEQrQtGAEE57iHiQfYzQLAem59df77BgEYxNy8tgTVWAKbiZmmhoA5zfADcINHnZYBV0pVXZYDp5idSjSyAAEAUv7XA/UFrwAhAF2yICIjERI5ALAXL7AARViwCS8bsQkcPlmwAEVYsBovG7EaED5ZsgEiCRESObABL7IAAQorWCHYG/RZsAkQsgcBCitYIdgb9FmyDwABERI5sBoQsRIKK1jYG9xZMDETNTM2NjUQISE1IRYWFRQHFhMVMxUUBgcnNjcjJic1NCYjr6mkm/7K/vEBIej05d4EqWFNalEOazwDkncCeZcBfYUBBZcD0sniZEb++KmUYchASHNuNKuPfo0AAAEAef7HA9kEOgAgAF2yICEiERI5ALAXL7AARViwCC8bsQgYPlmwAEVYsBovG7EaED5ZsgEhCBESObABL7IAAQorWCHYG/RZsAgQsgYBCitYIdgb9FmyDwABERI5sBoQsRIKK1jYG9xZMDETJzM2NTQjITUhFhcWFRQHFhcVMxUUBgcnNjcjJic1NCPCAdvp9f7pASfdbFa+vQGaYk1pVA1nMwLaAbiXAqGylgNnU4ShSTXKTJRhyj5IdH0hhV60AAEARP/rB3AFsAAjAGKyACQlERI5ALAARViwDi8bsQ4cPlmwAEVYsCAvG7EgED5ZsABFWLAHLxuxBxA+WbAOELIAAQorWCHYG/RZsAcQsggBCitYIdgb9FmwIBCyEwEKK1gh2Bv0WbIZDiAREjkwMQEhAwICBgcjNTc+AjcTIREUFjMyNjc2JzcWFgcGAgcHIiY1BCf+GhoPWayQPyhdZDQLHgNfWU+ClwQCP7ocKQID6cMus7cFEv2//t7+3IkCnQIHa+rzAsL7rGB0zbzA0gFmx2bs/toSArq0AAABAD//6wY6BDoAIQBisiAiIxESOQCwAEVYsAwvG7EMGD5ZsABFWLAeLxuxHhA+WbAARViwBi8bsQYQPlmwDBCyAAEKK1gh2Bv0WbAGELIHAQorWCHYG/RZsB4QshEBCitYIdgb9FmyFh4MERI5MDEBIQMCBgcjNTc2NjcTIREUFjMyNjc2JzMXFgcOAiMiJicDMf67FxScpUE2VU0NFwKvWk9sewQEQbMWMAMCbL54rrMBA6H+Wv7r5AKjBAqn0wIP/SFgebersstQsXya5nm4sQABAKn/5wdxBbAAHQCushQeHxESOQCwAEVYsAAvG7EAHD5ZsABFWLAZLxuxGRw+WbAARViwES8bsREQPlmwAEVYsBcvG7EXED5ZsBEQsgQBCitYIdgb9FmyCgARERI5sBcQsBzQsBwvsu8cAXGyXxwBXbLPHAFdsh8cAXG0bxx/HAJxtL8czxwCcbKfHAFxsk8cAXGy/xwBXbKvHAFdsi8cAV20DxwfHAJysj8cAXKyFQEKK1gh2Bv0WTAxAREUFjM2Njc2JzcWFgcOAiMGJicRIREjETMRIREE6V1KhpQEBEK7GysCAnvYiqu1CP1CwcECvgWw+6xlbwLNurfbAWLKZ6j7gwS4uwEn/X8FsP1uApIAAQCQ/+cGTQQ6ABwAo7IbHR4REjkAsABFWLAELxuxBBg+WbAARViwCC8bsQgYPlmwAEVYsBkvG7EZED5ZsABFWLACLxuxAhA+WbAH0LAHL7JvBwFdtL8HzwcCXbI/BwFxtM8H3wcCcbIPBwFytJ8HrwcCcbL/BwFdsg8HAXGynwcBXbIvBwFdtG8HfwcCcrIAAQorWCHYG/RZsBkQsg0BCitYIdgb9FmyEhkIERI5MDEBIREjETMRIREzERQWMzY2NzYnMxcWBwYCIwYmJwND/ga5uQH6uVxNbHwEBEGyFzADBOa7p7MIAc3+MwQ6/ioB1v0hZHUCtaus0VOxeer+8QS3uwABAHb/6wSgBcUAIgBHshUjJBESOQCwAEVYsAkvG7EJHD5ZsABFWLAALxuxABA+WbAJELIOAQorWCHYG/RZsAAQshYBCitYIdgb9FmyGwAJERI5MDEFIiQCJxE0EiQzMhcHJiMiAhUVFBYWMzY2NzYnMxcWBw4CArmk/viVApQBCqXchzuGoqzXYrBxjZYDAzW6JhMBAnveFZsBGK0BEK8BHp1YikT+/tL+g9V1ApmGms+zW1uIyW0AAQBl/+sDxwROAB4ARLITHyAREjkAsABFWLATLxuxExg+WbAARViwCy8bsQsQPlmyAAEKK1gh2Bv0WbIFCxMREjmwExCyGAEKK1gh2Bv0WTAxJTY2NzQnMxYHBgYjIgA1NTQ2NjMyFwcmIyIGFRUUFgJRYFoCFLIcAQTErdz+8HbWi7lgLGOKg5umggJQWXpyllaZqQEy9x6X+YxCkDrcsx+r2wABACP/5wVHBbAAGABNsgUZGhESOQCwAEVYsAIvG7ECHD5ZsABFWLAVLxuxFRA+WbACELIAAQorWCHYG/RZsATQsAXQsBUQsgkBCitYIdgb9FmyDgIVERI5MDEBITUhFSERFBYzNjYSJzcWFgcOAiMGJicB/v4lBID+HFxMhpQIQrobKwMCedmJqrcIBRKenvxIYHIC0AFu2wFiymep+YQEt7wAAAEARv/nBLcEOgAYAE2yFhkaERI5ALAARViwAi8bsQIYPlmwAEVYsBUvG7EVED5ZsAIQsgABCitYIdgb9FmwBNCwBdCwFRCyCQEKK1gh2Bv0WbIOFQIREjkwMQEhNSEVIREUFjM2Njc2JzMWFgcGBiMGJicBrP6aA4v+lV5NcXcDBECyKhsBBOi5qrMIA6SWlv21Y3QCnYmXrn2MPNDvBLm5AAEAlv/sBP8FxQApAG+yJCorERI5ALAARViwFi8bsRYcPlmwAEVYsAsvG7ELED5ZsgMBCitYIdgb9FmwCxCwBtCyJQsWERI5sCUvss8lAV2ynyUBcbImAQorWCHYG/RZshAmJRESObAWELAb0LAWELIeAQorWCHYG/RZMDEBFBYzMjY1MxQGBiMgJDU0JSYmNTQkITIWFhUjNCYjIgYVFBYXMxUjBgYBWM+wm8zBjf6d/vv+xAEUeIYBJQEGk/WMwcGSp8Kto8TEsbUBkniSmHSDvmflxf9WMKZlxNtlunVnj4h2dX0CngJ+AAIAbwRwAskF1gAFAA0AIwCwCy+wB9CwBy+wAdCwAS+wCxCwBNCwBC+wBdAZsAUvGDAxARMzFQMjATMVFhcHJjUBkXTE31n+3qgDUEmyBJQBQhX+wwFSW3tVO1+7AP//ACUCHwINArYABgARAAD//wAlAh8CDQK2AAYAEQAA//8AogKLBI0DIgBGAZfZAEzNQAD//wCQAosFyQMiAEYBl4QAZmZAAP//AA3+bAOhAAAAJwBDAAn/AwEGAEMJAAAUAEAJAwITAiMCMwIEXbKwAgFdMDEAAQBgBDEBeAYTAAgAIbIICQoREjkAsABFWLAALxuxAB4+WbIFCQAREjmwBS8wMQEXBgcVIzU0NgEOal0DuGEGE0h/k4h0ZsgAAQAwBBYBRwYAAAgAIbIICQoREjkAsABFWLAELxuxBB4+WbIACQQREjmwAC8wMRMnNjc1MxUGBplpXQO3AWEEFkiCkJCCZMcAAQAk/uUBOwC1AAgAHrIICQoREjkAsAkvsgQFCitYIdgb9FmwANCwAC8wMRMnNjc1MxUUBo1pWwO5Y/7lSX+SdmRlygABAE8EFgFnBgAACAAMALAIL7AE0LAELzAxARUWFwcmJic1AQYEXWpNXwIGAJOQf0hAwmGHAP//AGgEMQK7BhMAJgFsCAAABwFsAUMAAP//ADwEFgKGBgAAJgFtDAAABwFtAT8AAAACACT+0wJkAPYACAARADCyChITERI5sAoQsAXQALASL7IEBQorWCHYG/RZsADQsAAvsAnQsAkvsAQQsA3QMDETJzY3NTMVFAYXJzY3NTMVFAaNaVsDuWPdaVsDumH+00iJmbmkbNNASImZuaRr0QAAAQBGAAAEJAWwAAsASwCwAEVYsAgvG7EIHD5ZsABFWLAGLxuxBhg+WbAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZsAoQsgABCitYIdgb9FmwBNCwBdAwMQEhESMRITUhETMRIQQk/my6/nABkLoBlAOh/F8DoZkBdv6KAAEAV/5gBDQFsAATAHwAsABFWLAMLxuxDBw+WbAARViwCi8bsQoYPlmwAEVYsA4vG7EOGD5ZsABFWLACLxuxAhI+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgYBCitYIdgb9FmwDhCyCAEKK1gh2Bv0WbAJ0LAQ0LAR0LAGELAS0LAT0DAxISERIxEhNSERITUhETMRIRUhESEENP5quv5zAY3+cwGNugGW/moBlv5gAaCXAwqZAXb+ipn89gAAAQCKAhcCIgPLAA0AFrIKDg8REjkAsAMvsQoKK1jYG9xZMDETNDYzMhYVFRQGIyImNYpvXFtybl5dbwMEV3BtXSVXbm9Y//8AlP/1Ay8A0QAmABIEAAAHABIBuQAA//8AlP/1BM4A0QAmABIEAAAnABIBuQAAAAcAEgNYAAAAAQAmAh4AzwK3AAMADwCwAi+xAQorWNgb3FkwMRMjNTPPqakCHpkAAAYARP/rB1cFxQAVACMAJwA1AEMAUQC4sgJSUxESObACELAb0LACELAm0LACELAo0LACELA20LACELBJ0ACwAEVYsBkvG7EZHD5ZsABFWLASLxuxEhA+WbAD0LADL7AH0LAHL7ASELAO0LAOL7AZELAg0LAgL7IkEhkREjmwJC+yJhkSERI5sCYvsBIQsisECitYIdgb9FmwAxCyMgQKK1gh2Bv0WbArELA50LAyELBA0LAgELJHBAorWCHYG/RZsBkQsk4ECitYIdgb9FkwMQE0NjMyFzYzMhYVFRQGIyInBiMiJjUBNDYzMhYVFRQGIyImNQEnARcDFBYzMjY1NTQmIyIGFQUUFjMyNjU1NCYjIgYVARQWMzI2NTU0JiMiBhUDN6eDmE1Pl4Oop4KZT0yXgqr9DaeDhKelhIKqAWloAsdos1hKSFZXSUdZActYSUhWV0lIV/tCWEpHV1ZKSFgBZYOpeXmoi0eDqXh4p4sDe4OqqohIgaqni/wcQgRyQvw3T2VjVUpPZGNUSk9lZlJKT2RkUwLqTmViVUlOZmVTAAABAGwAmQIgA7UABgAQALAFL7ICBwUREjmwAi8wMQEBIwE1ATMBHgECjf7ZASeNAib+cwGEEwGFAAEAWQCYAg4DtQAGABAAsAAvsgMHABESObADLzAxEwEVASMBAecBJ/7ZjgEC/v4Dtf57E/57AY4BjwABADsAbgNqBSIAAwAJALAAL7ACLzAxNycBF6NoAsdobkIEckIA//8ANgKQArsFpQMHAdgAAAKQABMAsABFWLAJLxuxCRw+WbAN0DAxAAABAHoCiwL4BboADwBTsgoQERESOQCwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwDS8bsQ0UPlmwAEVYsAYvG7EGFD5ZsgENAxESObADELIKAworWCHYG/RZMDETFzYzIBERIxEmIyIHESMR+h5KkgEEqgONbiyqBat7iv7G/gsB5rlt/c4DIAAAAQBbAAAEaAXEACkAlrIhKisREjkAsABFWLAZLxuxGRw+WbAARViwBi8bsQYQPlmyKRkGERI5sCkvsgACCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbAI0LAJ0LAAELAO0LApELAQ0LApELAV0LAVL7YPFR8VLxUDXbISAgorWCHYG/RZsBkQsB3QsBkQsiABCitYIdgb9FmwFRCwJNCwEhCwJtAwMQEhFxQHIQchNTM2Njc1JyM1MycjNTMnNDYzMhYVIzQmIyIGFRchFSEXIQMV/rEDPgLdAfv4TSgyAgOqpgSinQb1yL7ev39vaYIGAVz+qQQBUwHWRJpbnZ0Jg2AIRX2IfbfH7tSxa3yafbd9iAAFAB8AAAY2BbAAGwAfACMAJgApALEAsABFWLAXLxuxFxw+WbAARViwGi8bsRocPlmwAEVYsAwvG7EMED5ZsABFWLAJLxuxCRA+WbIQDBcREjmwEC+wFNCwFC+0DxQfFAJdsCTQsCQvsBjQsBgvsADQsAAvsBQQshMBCitYIdgb9FmwH9CwI9CwA9CwEBCwHNCwHC+wINCwIC+wBNCwBC+wEBCyDwEKK1gh2Bv0WbAL0LAp0LAH0LImFwwREjmyJwkaERI5MDEBMxUjFTMVIxEjASERIxEjNTM1IzUzETMBIREzASEnIwUzNSElMycBNSMFV9/f39/C/sH+YsDZ2dnZwAFRAY+//GEBO2HaAhTM/tT+THd3AuBoA6yYlJj+GAHo/hgB6JiUmAIE/fwCBPzQlJSUmLb8558AAAIAp//sBgMFsAAfACgAorIjKSoREjmwIxCwEdAAsABFWLAWLxuxFhw+WbAARViwGi8bsRoYPlmwAEVYsB4vG7EeGD5ZsABFWLAKLxuxChA+WbAARViwFC8bsRQQPlmwHhCyAAEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAAQsA7QsA/QsiEUFhESObAhL7ISAQorWCHYG/RZsB4QsB3QsB0vsBYQsicBCitYIdgb9FkwMQEjERQWMzI3FwYjIiY1ESMGBgcjESMRITIWFzMRMxEzATMyNjU0JicjBf7KNkEjNAFJRnx+jxTnx8m5AXnK7RSPusr7YsCLi4eEywOr/WFBQQyWFJaKAp+3vQL9ywWwwLYBBv76/pKNl5iOAv//AKj/7AgQBbAAJgA2AAAABwBXBFUAAAAHADkAAAcpBbAAHwAjACcAKwAwADUAOgC3ALAARViwHi8bsR4cPlmwAEVYsBsvG7EbHD5ZsABFWLACLxuxAhw+WbAARViwDS8bsQ0QPlmwAEVYsBAvG7EQED5ZshQQGxESObAUL7AY0LAYL7Ac0LA20LAA0LAE0LAYELIXAQorWCHYG/RZsCfQsCPQsCvQsAfQsBQQsCTQsCDQsCjQsAjQsBQQshMBCitYIdgb9FmwMtCwD9CwLdCwC9CyNBAeERI5sDQQsC/QsjkeEBESOTAxASETMwMzFSMHMxUhAyMDIQMjAyE1MycjNTMDMxMhEzMDIScjBTM3IQUzNyETIxcXNyUjFxc3ATMnJwcEhwFTbMFzlbov6f7ydK+I/oSNr3X+9uUvtpFzwG4BVoih4wEkN7T+eqU3/vgDP6Us/vm5WQwpH/zpVwYdKAFEXRcXFwPUAdz+JJjCmP4eAeL+HgHimMKYAdz+JAHc/MrCwsLCwv6mKrLGFhfArQIcUW9vAAACAIwAAAWeBDoADQAbAGQAsABFWLAWLxuxFhg+WbAARViwAC8bsQAYPlmwAEVYsAsvG7ELED5ZsABFWLAOLxuxDhA+WbIRAQorWCHYG/RZsgURABESObAFL7AAELIKAQorWCHYG/RZsg8KCxESObAPLzAxATIWFxEjETQmJyERIxEBETMRITI2NxEzEQYGBwK6r6gEuWVv/r25AYm5AT5xZwG5AqWtBDrBv/6jAUx/eAH8XwQ6+8YC3f27dX4Cr/1OwsQCAAABAF//7AQcBcQAIwCHshUkJRESOQCwAEVYsBYvG7EWHD5ZsABFWLAJLxuxCRA+WbIjCRYREjmwIy+yAAIKK1gh2Bv0WbAJELIEAQorWCHYG/RZsAAQsAzQsCMQsA/QsCMQsB/QsB8vtg8fHx8vHwNdsiACCitYIdgb9FmwENCwHxCwE9CwFhCyGwEKK1gh2Bv0WTAxASEWFjMyNxcGIyIAAyM1MzUjNTMSADMyFwcmIyIGByEVIRUhA1H+gAS0pXRmFHh4+P7jBrKysrIKAR3zaocUbW6ksQYBf/6AAYACHcPSIqAeASUBDHyJfQEGAR8foiPLvH2JAAQAHwAABbwFsAAZAB4AIwAoALgAsABFWLALLxuxCxw+WbAARViwAS8bsQEQPlmwCxCyKAEKK1gh2Bv0WbIkKAEREjmwJC+ycCQBcbYAJBAkICQDXbIcAQorWCHYG/RZsB3QsB0vsnAdAXG2AB0QHSAdA12yIAEKK1gh2Bv0WbAh0LAhL7JwIQFxsiAhAV2yAAEKK1gh2Bv0WbAgELAD0LAdELAG0LAGL7AcELAH0LAkELAK0LAkELAP0LAcELAS0LAdELAU0LAULzAxAREjESM1MzUjNTM1ITIWFzMVIxcHMxUjBiEBJyEVIQchFSEyASEmIyEBpcDGxsbGAhmx6zbswwMCwuVr/owBRAT9bQKVP/2qAVms/fsCSlSe/qgCOv3GAzCXXpf0hHCXMiyX9gG3NF6XWQHlVgAAAQAqAAAD+AWwABoAZgCwAEVYsBkvG7EZHD5ZsABFWLAMLxuxDBA+WbAZELIYAQorWCHYG/RZsAHQsBgQsBTQsBQvsAPQsBQQshMBCitYIdgb9FmwBtCwExCwDtCwDi+yCQEKK1gh2Bv0WbINCQ4REjkwMQEjFhczByMGBiMBFSMBJzM2NjchNyEmJyE3IQPK7EARyS6YEvbbAe3j/e4B+X2cFf29LgITMPb+5y8DnQUSUXWesrT9xAwCaX0Ba1yevgieAAEAIP/uBBoFsAAeAI0AsABFWLARLxuxERw+WbAARViwBS8bsQUQPlmyExEFERI5sBMvsBfQsBcvsgAXAV2yGAEKK1gh2Bv0WbAZ0LAI0LAJ0LAXELAW0LAL0LAK0LATELIUAQorWCHYG/RZsBXQsAzQsA3QsBMQsBLQsA/QsA7QsAUQshoBCitYIdgb9FmyHgURERI5sB4vMDEBFQYCBCMiJxEHNTc1BzU3ETMRNxUHFTcVBxE2EhE1BBoCkP73r1Bs9PT09MD7+/v7vskDA2TS/semEgJab7JvmW+ybwFZ/v9zsnOZc7Jz/d4CARABCVgAAQBdAAAE6wQ6ABcAXLIAGBkREjkAsABFWLAWLxuxFhg+WbAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsABFWLAQLxuxEBA+WbIAChYREjmwAC+yCQEKK1gh2Bv0WbAM0LAAELAV0DAxARYAERUjNSYCJxEjEQYCBxUjNRIANzUzAv/nAQW5Ap6TuY+fArkDAQffuQNxIf6N/tq3yN8BBSD9NALKIf712MbFAR0BbSLJAAIAHwAABQMFsAAWAB8AbQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIGAwwREjmwBi+yBQEKK1gh2Bv0WbAB0LAGELAK0LAKL7QPCh8KAl2yCQEKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAMELIfAQorWCHYG/RZMDEBIREjESM1MzUjNTMRITIEFRQEByEVIQEhMjY1NCYnIQL8/rG/z8/PzwIZ6gES/vny/qMBT/6xAVqboqiP/qABE/7tAROeiZ0C2e7L1ecBiQEmkox/nQEABAB6/+sFgwXFABsAJwA1ADkAt7IcOjsREjmwHBCwANCwHBCwKNCwHBCwONAAsABFWLAKLxuxChw+WbAARViwJS8bsSUQPlmwChCwA9CwAy+yDgoDERI5tioOOg5KDgNdsAoQshEECitYIdgb9FmwAxCyGAQKK1gh2Bv0WbIbAwoREjm0NhtGGwJdsiUbAV2wJRCwH9CwHy+wJRCyKwQKK1gh2Bv0WbAfELIyBAorWCHYG/RZsjYlChESObA2L7I4CiUREjmwOC8wMQEUBiMiJjU1NDYzMhYVIzQmIyIGFRUUFjMyNjUBNDYgFhUVFAYgJjUXFBYzMjY1NTQmIyIGFQUnARcCqJh7eqGee3mciklCQU1PQT1MARCnAQaop/78qopYSkhWV0lHWf4GaQLHaQQebpCoiUeCq5FvOk1mUklOZUw6/UeDqaiLR4Opp4sGT2VjVUpPZGNU80IEckIAAAIAaP/rA2oGEwAXACEAZLITIiMREjmwExCwGNAAsABFWLAMLxuxDB4+WbAARViwAC8bsQAQPlmyBgwAERI5sAYvsgUBCitYIdgb9FmwE9CwABCyFwEKK1gh2Bv0WbAGELAY0LAMELIfAQorWCHYG/RZMDEFIiY1BiM1MjcRNjYzMhYVFRQCBxUUFjMDNjY1NTQmIyIHAszC0mJucV8BnYV4l86ra3DbWWcwJmcDFerrHLAjAiSyxq2TJcH+j2timo0CY1X1eydSTNEAAAQAogAAB8YFwAADABAAHgAoAKOyHykqERI5sB8QsAHQsB8QsATQsB8QsBHQALAARViwJy8bsSccPlmwAEVYsCUvG7ElHD5ZsABFWLAHLxuxBxw+WbAARViwIi8bsSIQPlmwAEVYsCAvG7EgED5ZsAcQsA3QsALQsAIvshACAV2yAQMKK1gh2Bv0WbANELIUAworWCHYG/RZsAcQshsDCitYIdgb9FmyISUgERI5siYgJRESOTAxASE1IQE0NiAWFRUUBiMiJjUXFBYzMjY3NTQmIyIGFQEjAREjETMBETMHpP2ZAmf9dboBOLu5nJ66o19WVF0BX1VUX/68zP2vucsCVLcBnI4CPZu+u6Ndnbq7oQVia2pgZWFra2P7mwRu+5IFsPuPBHEAAgBnA5cEOAWwAAwAFABtALAARViwBi8bsQYcPlmwAEVYsAkvG7EJHD5ZsABFWLATLxuxExw+WbIBFQYREjmwAS+yAAkBERI5sgMBBhESObAE0LIIAQkREjmwARCwC9CwBhCxDQorWNgb3FmwARCwD9CwDRCwEdCwEtAwMQEDIwMRIxEzExMzESMBIxEjESM1IQPejDSMWnCQkHBa/guTW5QBggUh/nYBif53Ahn+cQGP/ecByP44AchRAAACAJj/7ASTBE4AFQAcAGKyAh0eERI5sAIQsBbQALAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZshoKAhESObAaL7IPCgorWCHYG/RZsAIQshMKCitYIdgb9FmyFQoCERI5sAoQshYKCitYIdgb9FkwMSUGIyImAjU0EjYzMhYWFxUhERYzMjcBIgcRIREmBBa3u5H0h5D4hIXjhAP9AHeaxKz+kJd6AhxzXnKdAQGTjwEDn4vzkD7+uG56Ayp6/usBHnH//wBU//UFswWbACcB1f/aAoYAJwF8AOYAAAAHAdwDFAAA//8AZP/1BlMFtAAnAdcAJgKUACcBfAGlAAAABwHcA7QAAP//AGP/9QZJBaQAJwHZAAgCjwAnAXwBgwAAAAcB3AOqAAD//wBZ//UF/QWkACcB2wAfAo8AJwF8ASAAAAAHAdwDXgAAAAIAav/rBDIF7AAbACoAW7IVKywREjmwFRCwI9AAsA0vsABFWLAVLxuxFRA+WbIADRUREjmwAC+yAwAVERI5sA0QsgcBCitYIdgb9FmwABCyHAEKK1gh2Bv0WbAVELIjAQorWCHYG/RZMDEBMhYXLgIjIgcnNzYzIAARFRQCBiMiADU1NAAXIgYVFRQWMzI2NTUnJiYCPF2mOg5ppmCBmxAxdJcBBwEfeN6Q2v74AQDkjJ+fio6fBBygA/5NRIzZeTuXFTD+Tv5uMrz+1qUBI/YO3AEQmLugEKrP+ds9D1pqAAABAKn/KwTlBbAABwAnALAEL7AARViwBi8bsQYcPlmwBBCwAdCwBhCyAgEKK1gh2Bv0WTAxBSMRIREjESEE5bn9NrkEPNUF7foTBoUAAQBF/vMEqwWwAAwANQCwAy+wAEVYsAgvG7EIHD5ZsAMQsgIBCitYIdgb9FmwBdCwCBCyCgEKK1gh2Bv0WbAH0DAxAQEhFSE1AQE1IRUhAQNr/bsDhfuaAmH9nwQZ/McCRgJB/UqYjwLMAtKQmP1CAAEAqAKLA+sDIgADABsAsABFWLACLxuxAhY+WbIBAQorWCHYG/RZMDEBITUhA+v8vQNDAouXAAEAPwAABJgFsAAIADyyAwkKERI5ALAHL7AARViwAS8bsQEcPlmwAEVYsAMvG7EDED5ZsgABAxESObAHELIGAQorWCHYG/RZMDEBATMBIwMjNSECMAGrvf3ijfW5ATsBHASU+lACdJoAAwBi/+sHywROABwALAA8AG+yBz0+ERI5sAcQsCTQsAcQsDTQALAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsBPQsBMvsBnQsBkvsgcZBBESObIWGQQREjmwChCyIAEKK1gh2Bv0WbATELIpAQorWCHYG/RZsDDQsCAQsDnQMDEBFAIGIyImJwYGIyImAjU1NBI2MzIWFzY2MzIAFQUUFjMyNjc3NS4CIyIGFSU0JiMiBgcHFR4CMzI2NQfLft+Jke5QUeyQid6Aft+Ike1RUO+SzgEW+VCmiHK5NAsYcpJQhqYF96aFc7w1CRZ1kFCIpQIPk/8Akbixs7aPAQCXGJMBAJK3s7G5/sHzDbHcvKMnKmPAYdy5CK7fvagfKmHFYN64AAH/sP5LAo4GFQAVAD2yAhYXERI5ALAARViwDi8bsQ4ePlmwAEVYsAMvG7EDEj5ZsggBCitYIdgb9FmwDhCyEwEKK1gh2Bv0WTAxBRQGIyInNxYzMjURNDYzMhcHJiMiFQFlpJ45OhIuIZuxoTxUGCU2tmuiqBSRDbEFGaq+FY4L2wACAGUBGAQLA/QAFQArAI2yHCwtERI5sBwQsAXQALADL7IPAwFdsA3QsA0vsgANAV2yCAEKK1gh2Bv0WbADELAK0LAKL7ADELISAQorWCHYG/RZsA0QsBXQsBUvsA0QsBnQsBkvsCPQsCMvsgAjAV2yHgEKK1gh2Bv0WbAZELAg0LAgL7AZELIoAQorWCHYG/RZsCMQsCvQsCsvMDETNjYzNhcXFjMyNxUGIyInJyYHIgYHBzY2MzYXFxYzMjcXBiMiJycmByIGB2Ywg0JSSphCToZmZ4VOQqFET0KDMAEwgkJSSpVEUIVmAWeFTkKYSlJCgzADhTM6AiNOH4C+bR9THwJEPOUzOwIjTSGAvW0fTiMCRDwAAAEAmACbA9oE1QATADcAsBMvsgABCitYIdgb9FmwBNCwExCwB9CwExCwD9CwDy+yEAEKK1gh2Bv0WbAI0LAPELAL0DAxASEHJzcjNSE3ITUhExcHMxUhByED2v3tjl9srgELlf5gAf6ZX3fD/t+UAbUBj/Q7uaD/oQEGO8uh/wD//wA+AAIDgQQ+AGYAIABhQAA5mgEHAZf/lv13AB0AsABFWLAFLxuxBRg+WbAARViwCC8bsQgQPlkwMQD//wCFAAED3ARRAGYAIgBzQAA5mgEHAZf/3f12AB0AsABFWLACLxuxAhg+WbAARViwCC8bsQgQPlkwMQAAAgArAAAD3AWwAAUACQA4sggKCxESObAIELAB0ACwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxA+WbIGAAMREjmyCAADERI5MDEBMwEBIwkEAbyMAZT+cI3+bAHW/ukBHAEYBbD9J/0pAtcCD/3x/fICDgD//wC1AKcBmwT1ACcAEgAlALIABwASACUEJAACAG4CeQIzBDoAAwAHACwAsABFWLACLxuxAhg+WbAARViwBi8bsQYYPlmwAhCwANCwAC+wBNCwBdAwMRMjETMBIxEz+42NATiNjQJ5AcH+PwHBAAABAFz/XwFXAO8ACAAgsggJChESOQCwCS+wBNCwBC+0QARQBAJdsADQsAAvMDEXJzY3NTMVFAbFaUgCsU+hSG1/XExbswD//wA8AAAE9gYVACYASgAAAAcASgIsAAAAAgAfAAADzQYVABUAGQCDsggaGxESObAIELAX0ACwAEVYsAgvG7EIHj5ZsABFWLADLxuxAxg+WbAARViwES8bsREYPlmwAEVYsBgvG7EYGD5ZsABFWLAALxuxABA+WbAARViwFi8bsRYQPlmwAxCyAQEKK1gh2Bv0WbAIELINAQorWCHYG/RZsAEQsBPQsBTQMDEzESM1MzU0NjMyFwcmIyIGFRUzFSMRISMRM8qrq8+9cKsffXF3ad3dAkm6ugOrj1y1yj2cMmtrXo/8VQQ6AAEAPAAAA+kGFQAWAFwAsABFWLASLxuxEh4+WbAARViwBi8bsQYYPlmwAEVYsAkvG7EJED5ZsABFWLAWLxuxFhA+WbASELICAQorWCHYG/RZsAYQsgcBCitYIdgb9FmwC9CwBhCwDtAwMQEmIyIVFTMVIxEjESM1MzU2NjMyBREjAzB8TMjn57mrqwHAsWUBK7kFYxTSa4/8VQOrj3atuD36KAAAAgA8AAAGMgYVACcAKwCdALAARViwFi8bsRYePlmwAEVYsAgvG7EIHj5ZsABFWLAgLxuxIBg+WbAARViwEi8bsRIYPlmwAEVYsAQvG7EEGD5ZsABFWLAqLxuxKhg+WbAARViwKS8bsSkQPlmwAEVYsCMvG7EjED5ZsABFWLAnLxuxJxA+WbAgELIhAQorWCHYG/RZsCXQsAHQsAgQsg0BCitYIdgb9FmwG9AwMTMRIzUzNTQ2MzIXByYjIgYVFSE1NDYzMhcHJiMiBhUVMxUjESMRIREhIxEz56uruqpAPwovNVpiAZDPvXCrH31yd2ne3rn+cASSubkDq49vrr4RlglpYnJctco9nDJqbF6P/FUDq/xVBDoAAAEAPAAABjIGFQAoAGoAsABFWLAILxuxCB4+WbAARViwIS8bsSEYPlmwAEVYsCgvG7EoED5ZsCEQsiIBCitYIdgb9FmwJtCwAdCwIRCwEtCwBNCwCBCyDQEKK1gh2Bv0WbAIELAW0LAoELAl0LAa0LANELAd0DAxMxEjNTM1NDYzMhcHJiMiBhUVITU2NjMyBREjESYjIhUVMxUjESMRIRHnq6u6qkA/Ci81WmIBkAHAsWUBK7l8TMjn57n+cAOrj2+uvhGWCWlicnatuD36KAVjFNJrj/xVA6v8VQABADz/7ASbBhUAJgBzALAARViwIS8bsSEePlmwAEVYsB0vG7EdGD5ZsABFWLAYLxuxGBA+WbAARViwCi8bsQoQPlmwHRCwENCwJdCyAQEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAEQsA7QsCEQshUBCitYIdgb9FmwDhCwGtAwMQEjERQWMzI3FwYjIiY1ESM1MxEmJyciFREjESM1MzU0NjMyFhcRMwSWyjZBIzQBSUZ8fsXFPWYYt7mrq7OgXdtaygOr/WFBQQyWFJaKAp+PAR8cBwHd+2ADq49wrb45LP6KAAABAF//7AZUBhEATAC5shZNThESOQCwAEVYsEcvG7FHHj5ZsABFWLAPLxuxDxg+WbAARViwSy8bsUsYPlmwAEVYsEAvG7FAGD5ZsABFWLAJLxuxCRA+WbAARViwLC8bsSwQPlmwSxCyAQEKK1gh2Bv0WbAJELIEAQorWCHYG/RZsAEQsA3QsEcQshQBCitYIdgb9FmwQBCyIAEKK1gh2Bv0WbI6LEAREjmwOhCyJQEKK1gh2Bv0WbAsELI0AQorWCHYG/RZMDEBIxEUMzI3FwYjIiY1ESM1MzU0JiMiBhUUHgIVIzQmIyIGFRQWBBYWFRQGIyImJjUzFhYzMjY1NCYkJiY1NDYzMhcmNTQ2MzIWFRUzBk/KdyM0AU1CdoS8vGZiWFwfJR66gWJlcmoBFaxT6LmCyHG5BYtyaX9x/uelT+GvYFYsypu5ycoDq/1+nwyWFKaXAoKPVXJ1WEY7aXB8TExuWEdDRD5WeVeRr1ylYF1tVUdLUzxUdFCFuB5uUnylx8NNAAAWAFv+cgfuBa4ADQAaACgANwA9AEMASQBPAFYAWgBeAGIAZgBqAG4AdgB6AH4AggCGAIoAjgG+shCPkBESObAQELAA0LAQELAb0LAQELAw0LAQELA80LAQELA+0LAQELBG0LAQELBK0LAQELBQ0LAQELBX0LAQELBb0LAQELBh0LAQELBj0LAQELBn0LAQELBt0LAQELBw0LAQELB30LAQELB70LAQELB/0LAQELCE0LAQELCI0LAQELCM0ACwPS+wAEVYsEYvG7FGHD5Zsn5JAyuyensDK7KCdwMrsn86AyuyCj1GERI5sAovsAPQsAMvsA7QsA4vsAoQsA/QsA8vslAODxESObBQL7JvBworWCHYG/RZshVQbxESObAKELIeBworWCHYG/RZsAMQsiUHCitYIdgb9FmwDxCwKdCwKS+wDhCwLtCwLi+yNAcKK1gh2Bv0WbA9ELI8CgorWCHYG/RZsD0QsGvQsGfQsGPQsD7QsDwQsGzQsGjQsGTQsD/QsDoQsEHQsEYQsGDQsFzQsFjQsEvQskoKCitYIdgb9FmwWtCwXtCwYtCwR9CwSRCwTtCwDhCyUQcKK1gh2Bv0WbAPELJ2BworWCHYG/RZsHcQsITQsHoQsIXQsHsQsIjQsH4QsInQsH8QsIzQsIIQsI3QMDEBFAYjIiYnNTQ2MzIWFxMRMzIWFRQHFhYVFCMBNCYjIgYVFRQWMzI2NQEzERQGIyImNTMUMzI2NQERMxUzFSE1MzUzEQERIRUjFSU1IREjNQEVMzI1NCcTNSEVITUhFSE1IRUBNSEVITUhFSE1IRUTMzI1NCYjIwEjNTM1IzUzESM1MyUjNTM1IzUzESM1MwM5gWRmgAJ+aGWAAkO8YnJUMjTQ/o9KQUBKSkJASQO6XGlSWG1daCk2+cRxxAUox2/4bQE1xAXsATZv/Fx+Z2LLARb9WwEV/VwBFAIKARb9WwEV/VwBFLxddjo8XfzxcXFxcXFxByJvb29vb28B1GJ5eF51X3x4Xv6zAiVJTVQgDUYtmwFIRU5ORXBFTk5FAU/+hk5dUVNbNiz8yQE7ynFxyv7FBh8BHXSpqXT+46n8tqlTUgQDSnR0dHR0dPk4cXFxcXFxA8RQKR7+0/x++vwV+X78fvr8FfkABQBc/dUH1whzAAMAHAAgACQAKABSsxEPEAQrswQPHAQrswoPFwQrsAQQsB3QsBwQsB7QALAhL7AlL7IcHgMrsCUQsADQsAAvsCEQsALQsAIvsg0AAhESObANL7IfHgIREjmwHy8wMQkDBTQ2NzY2NTQmIyIGBzM2NjMyFhUUBwYGFRcjFTMDMxUjAzMVIwQYA7/8QfxEBA8eJEpcp5WQoALLAjorOThdWy/KyspLBAQCBAQGUvwx/DEDz/E6Ohgnh0qAl4t/MzRANF88QVxMW6r9TAQKngQAAQA7AAAD0gWwAAYAMgCwAEVYsAUvG7EFHD5ZsABFWLABLxuxARA+WbAFELIDAQorWCHYG/RZsgADBRESOTAxAQEjASE1IQPS/b66AkD9JQOXBUj6uAUYmAAAAgBa/+wERAROABAAHAA2ALAARViwBC8bsQQYPlmwAEVYsAwvG7EMED5ZshQBCitYIdgb9FmwBBCyGgEKK1gh2Bv0WTAxEzQ2NjMyABUVFAYGIyImJic3FBYzMjY1NCYjIgZagOOQ3QEafuWSj+OBArmvjY6usY2LrwInnP+M/sz7Dp38jIj5mgqw3uDEr+DeAAAB/7b+SwFnAJgADAAnALANL7AARViwBC8bsQQSPlmyCQEKK1gh2Bv0WbANELAM0LAMLzAxJRUGBiMiJzcWMzI1NQFnAaqXOzQOHkOJmPWosBKdDcLpAAEAZ/6ZASEAmQADABIAsAQvsALQsAIvsAHQsAEvMDEBIxEzASG6uv6ZAgAAAgCDBNkC0gbQAA0AIQB7ALADL7AH0LAHL0ANDwcfBy8HPwdPB18HBl2wAxCyCgQKK1gh2Bv0WbAHELAN0LANL7AHELAR0LARL7AU0LAUL0ALDxQfFC8UPxRPFAVdsBEQsBfQsBcvsBQQshsECitYIdgb9FmwERCyHgQKK1gh2Bv0WbAbELAh0DAxARQGIyImNTMUFjMyNjUTFAYjIiYjIgYVJzQ2MzIWMzI2NQLSoYaHoZZKSEdKjWBGOncsIjBTYEUwgSwjMAWuX3Z2XzZAQDYBCkppSzMmFUtrSzMmAAACAIEE4ALKBwMADQAcAGUAsAMvsAfQsAcvQA0PBx8HLwc/B08HXwcGXbADELIKBAorWCHYG/RZsAcQsA3QsA0vsAcQsA7QsA4vsBXQsBUvQA8PFR8VLxU/FU8VXxVvFQddsBTQsg8UDhESObIbDhUREjkwMQEUBiMiJjUzFBYzMjY1Jyc2NjU0IzcyFhUUBgcHAsqhg4ShkkpJRUzJAUpCoAeQlFFEAQWwXnJzXTU+PTYRfAQYHTtSTkIyOwc+AAACAIEE3wLgBooADQARAF8AsAMvsAfQsAcvQA0PBx8HLwc/B08HXwcGXbADELIKBAorWCHYG/RZsAcQsA3QsA0vsAcQsBDQsBAvsA/QsA8vQA8PDx8PLw8/D08PXw9vDwddsBAQsBHQGbARLxgwMQEUBiMiJjUzFBYzMjY1JzMHIwLgqIeIqJhPSUdPYJmkZgWwX3JyXzc9PzXaxgACAGkE5ANGBtQABgAaAIUAsAMvsAHQsAEvsAbQsAYvQAkPBh8GLwY/BgRdsgQDBhESORmwBC8YsADQsgIGARESObAGELAK0LAKL7Q/Ck8KAl2wDdCwDS9ADQ8NHw0vDT8NTw1fDQZdsAoQsBDQsBAvsA0QshQECitYIdgb9FmwChCyFwQKK1gh2Bv0WbAUELAa0DAxASMnByMlMzcUBiMiJiMiBhUnNDYzMhYzMjY1A0aqxcWpAS2Dw2BBNm4oHTZNYEAqfCYfNATknp705T5eRy4dEz9iRi0cAAIAaQTkA+wGzwAGABUAYQCwAy+wBdCwBS+2DwUfBS8FA12yBAMFERI5GbAELxiwANCwAxCwAdCwAS+yAgUDERI5sAfQsAcvsA7QsA4vQA0PDh8OLw4/Dk8OXw4GXbAN0LIIBw0REjmyFA4HERI5MDEBIycHIwEzFyc2NjU0IzcyFhUUBgcHA0aqxcWpARC8vgFBO40FgIZKPAEE5Lq6AQZ8gwQaIUNcWEk7Qgc8AAL/XgTPA0YGggAGAAoAXQCwAy+yDwMBXbAE0BmwBC8YsADQGbAALxiwAxCwAdCwAS+wBtCwBi+2DwYfBi8GA12yAgMGERI5sAMQsAjQsAgvsAfQGbAHLxiwCBCwCtCwCi+2DwofCi8KA10wMQEjJwcjATMFIwMzA0bFqqrEASKY/o+MyMcEz56eAQZVAQIAAAIAbgThBFgGlQAGAAoAXQCwAy+yDwMBXbAF0LAFL7AA0LAAL7YPAB8ALwADXbADELAC0BmwAi8YsgQDABESObAG0BmwBi8YsAMQsAnQsAkvsAfQsAcvtg8HHwcvBwNdsAkQsArQGbAKLxgwMQEzASMnByMBMwMjAZKYASLFqarGAyLIyY0F6P75n58BtP79AAIAgQTfAuAGigANABEAXwCwAy+wB9CwBy9ADQ8HHwcvBz8HTwdfBwZdsAMQsgoECitYIdgb9FmwBxCwDdCwDS+wBxCwEdCwES+wD9CwDy9ADw8PHw8vDz8PTw9fD28PB12wERCwENAZsBAvGDAxARQGIyImNTMUFjMyNjUlMxcjAuCoh4iomE9JR0/+pppwZQWwX3JyXzc9PzXaxgAAAQCfBI4BlgY7AAgADACwAC+wBNCwBC8wMQEXBgcVIzU0NgErazsDuVQGO1Njb4iCTa0AAAIAEwAABHAEjQAHAAoARgCwAEVYsAQvG7EEGj5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMjATMBIwEhAwNG/fhuvQHfpgHYvP3GAZHHARf+6QSN+3MBrgH9AAMAigAAA+8EjQAOABYAHgBoALAARViwAS8bsQEaPlmwAEVYsAAvG7EAED5ZshcAARESObAXL7K/FwFdtB8XLxcCXbTfF+8XAl2yDwEKK1gh2Bv0WbIIDxcREjmwABCyEAEKK1gh2Bv0WbABELIeAQorWCHYG/RZMDEzESEyFhUUBgcWFhUUBgcBESEyNjU0IyUzMjY1NCcjigGW0d5fWGN02sn+9wEGc3rr/vjqbHzl7QSNo5tRfiEYlWWergECEv6FYlXEjVVTqAUAAAEAYP/wBDAEnQAcAEyyAx0eERI5ALAARViwCy8bsQsaPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WbADELAc0DAxAQYGIyIAETU0NjYzMhYXIyYmIyIGBxUUFjMyNjcEMBT80eD+8XvnmMz3E7kSjX6ZpwGfl4eNFAF5u84BJwEDXqT5iNO7gnTLvWq9z2+DAAIAigAABB8EjQAKABQARrICFRYREjmwAhCwFNAAsABFWLABLxuxARo+WbAARViwAC8bsQAQPlmwARCyCwEKK1gh2Bv0WbAAELIMAQorWCHYG/RZMDEzESEyFhYXFRQAIQMRMzI2NTU0JiOKAWmi+4wD/sn++Z6kusa9twSNhfafTfz+1gP0/KPQwEDAzQABAIoAAAOuBI0ACwBUALAARViwBi8bsQYaPlmwAEVYsAQvG7EEED5ZsAvQsAsvst8LAV2yHwsBXbIAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASERIRUhESEVIREhA1f97AJr/NwDHv2bAhQCDv6JlwSNmf6yAAEAigAAA5sEjQAJAEEAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmwCdCwCS+yHwkBXbIAAQorWCHYG/RZsAQQsgYBCitYIdgb9FkwMQEhESMRIRUhESEDS/34uQMR/agCCAHz/g0EjZn+mAAAAQBj//AENQSdAB0AX7IKHh8REjkAsABFWLAKLxuxCho+WbAARViwAy8bsQMQPlmyHQoDERI5sB0vsg0dChESObAKELIQAQorWCHYG/RZsAMQshcBCitYIdgb9FmwHRCyGgMKK1gh2Bv0WTAxJQYGIyIAJzUQADMyFhcjJiMiBhUVFBYzMjc1ITUhBDVC6Zfu/uACAQvyyPIbuCb1n6a5oLZR/ucB0ZZTUwEq/FoBBgEnvLXZzsdUvtdK7pAAAAEAigAABFgEjQALAFMAsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbIJAAoREjl8sAkvGLKjCQFdsgIBCitYIdgb9FkwMSEjESERIxEzESERMwRYuf2kubkCXLkB8v4OBI39/QIDAAABAJcAAAFRBI0AAwAdALAARViwAi8bsQIaPlmwAEVYsAAvG7EAED5ZMDEhIxEzAVG6ugSNAAABACv/8ANNBI0ADwA1sgUQERESOQCwAEVYsAAvG7EAGj5ZsABFWLAFLxuxBRA+WbAJ0LAFELIMAQorWCHYG/RZMDEBMxEUBiMiJjUzFBYzMjY1ApK71LHC27pxclxuBI38xZ3Ft6ReZm1fAAABAIoAAARXBI0ADABMALAARViwBC8bsQQaPlmwAEVYsAgvG7EIGj5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAIIERI5sgYCBBESObIKAggREjkwMQEHESMRMxE3ATMBASMB1pO5uYIBjeP+IQIB4QIHjv6HBI391ZABm/35/XoAAAEAigAAA4sEjQAFACgAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WTAxJSEVIREzAUMCSPz/uZeXBI0AAAEAigAABXcEjQAOAGCyAQ8QERI5ALAARViwAC8bsQAaPlmwAEVYsAIvG7ECGj5ZsABFWLAELxuxBBA+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsgEABBESObIHAAQREjmyCgAEERI5MDEJAjMRIxETASMBExEjEQF6AYcBhfG4E/5yiP5zE7gEjfxxA4/7cwGRAhX8WgOi/e/+bwSNAAEAigAABFgEjQAJAEUAsABFWLAFLxuxBRo+WbAARViwCC8bsQgaPlmwAEVYsAAvG7EAED5ZsABFWLADLxuxAxA+WbICBQAREjmyBwUAERI5MDEhIwERIxEzAREzBFi4/aO5uQJduANs/JQEjfyTA20AAAIAYP/wBFoEnQANABsARrIDHB0REjmwAxCwEdAAsABFWLAKLxuxCho+WbAARViwAy8bsQMQPlmwChCyEQEKK1gh2Bv0WbADELIYAQorWCHYG/RZMDEBEAAjIgARNRAAMzIAFwc0JiMiBhUVFBYzMjY1BFr+7Ojl/ucBF+XpARMCt6yblq+wl5ypAiT++/7RATIBBz4BAgE0/tD/BcbS1sVCw9fTxwACAIoAAAQbBI0ACgATAE2yChQVERI5sAoQsAzQALAARViwAy8bsQMaPlmwAEVYsAEvG7EBED5ZsgsDARESObALL7IAAQorWCHYG/RZsAMQshIBCitYIdgb9FkwMQERIxEhMhYVFAYjJSEyNjU0JichAUO5AdPM8urW/ugBGnyIiHf+4QG2/koEjceoqr6YamRgdwEAAgBZ/zYEVwSdABMAIQBNsggiIxESObAIELAe0ACwAEVYsBAvG7EQGj5ZsABFWLAILxuxCBA+WbIDCBAREjmwEBCyFwEKK1gh2Bv0WbAIELIeAQorWCHYG/RZMDEBFAYHFwclBiMiABE1NBI2MzIAESc0JiMiBgcVFBYzMjY1BFVwZth8/vk2RuT+5X/oluoBFbesnJSsBK6YnKoCJKbzRqBvxw0BMQEIPqkBA4r+zf75BsbSz7lVwtjTxwACAIoAAAQlBI0ADQAWAGGyFRcYERI5sBUQsAXQALAARViwBC8bsQQaPlmwAEVYsAIvG7ECED5ZsABFWLAMLxuxDBA+WbIPBAIREjmwDy+yAAEKK1gh2Bv0WbIKAAQREjmwBBCyFQEKK1gh2Bv0WTAxASERIxEhMhYVFAcBFSMBMzI2NTQmIyMCWv7puQGq1efrASDG/eT2dYmGfvABwf4/BI26quRZ/h4KAlhtXWRuAAEAQ//wA90EnQAlAFoAsABFWLAJLxuxCRo+WbAARViwHC8bsRwQPlmyAhwJERI5sAkQsA3QsAkQshABCitYIdgb9FmwAhCyFgEKK1gh2Bv0WbAcELAg0LAcELIjAQorWCHYG/RZMDEBNCYkJyY1NDYzMhYVIzQmIyIGFRQWBBYWFRQGIyIkNTMUFjMyNgMjef7aVsPzv8T5uY15cYZ7ATiwVvPHz/7vupqMfoIBKlBYSitis4+yyJxia1lQQVhQZYhbk6nLomZyWwABACgAAAP9BI0ABwAuALAARViwBi8bsQYaPlmwAEVYsAIvG7ECED5ZsAYQsgABCitYIdgb9FmwBNAwMQEhESMRITUhA/3+cbn+cwPVA/T8DAP0mQABAHT/8AQKBI0AEQA8sgQSExESOQCwAEVYsAAvG7EAGj5ZsABFWLAILxuxCBo+WbAARViwBC8bsQQQPlmyDQEKK1gh2Bv0WTAxAREUBiMiJicRMxEUFjMyNjURBAr60dL2A7ePhYOPBI389Lbb07YDFPz0eYF/ewMMAAEAFAAABFMEjQAIADEAsABFWLADLxuxAxo+WbAARViwBy8bsQcaPlmwAEVYsAUvG7EFED5ZsgEDBRESOTAxARc3ATMBIwEzAhoZGgFAxv43rf43xwEkXlwDa/tzBI0AAAEAMQAABfEEjQASAGCyDhMUERI5ALAARViwAy8bsQMaPlmwAEVYsAgvG7EIGj5ZsABFWLARLxuxERo+WbAARViwCi8bsQoQPlmwAEVYsA8vG7EPED5ZsgEDChESObIGAwoREjmyDQMKERI5MDEBFzcTMxMXNxMzASMBJwcBIwEzAa8LD/il9A0Mxrj+1q7+/AEB/vSt/te3ASZQQAN3/IY7UANl+3MDlQUF/GsEjQAAAQAmAAAEMQSNAAsAUwCwAEVYsAEvG7EBGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQQPlmwAEVYsAcvG7EHED5ZsgABBBESObIGAQQREjmyAwAGERI5sgkGABESOTAxAQEzAQEjAQEjAQEzAigBH9z+dQGZ3P7V/tjcAZb+c9sC2gGz/b79tQG7/kUCSwJCAAABAA0AAAQcBI0ACAAxALAARViwAS8bsQEaPlmwAEVYsAcvG7EHGj5ZsABFWLAELxuxBBA+WbIAAQQREjkwMQEBMwERIxEBMwIUATjQ/lK5/ljQAkoCQ/0K/mkBogLrAAABAEcAAAPgBI0ACQBEALAARViwBy8bsQcaPlmwAEVYsAIvG7ECED5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIRUhNQEhNSEVAS8CsfxnApj9cQN4l5d8A3iZeQAAAgBQ//UCnQMgAA0AFwBGsgMYGRESObADELAQ0ACwAEVYsAovG7EKFj5ZsABFWLADLxuxAxA+WbAKELIQAgorWCHYG/RZsAMQshUCCitYIdgb9FkwMQEUBiMiJic1NDYzMhYXJzQjIgcVFDMyNwKdmI2LnAGbi42YAp2KhQSLhAQBRaKurKCOo66snQfAtLPCtQABAHoAAAHvAxUABgA1ALAARViwBS8bsQUWPlmwAEVYsAEvG7EBED5ZsgQFARESObAEL7IDAgorWCHYG/RZsALQMDEhIxEHNSUzAe+d2AFjEgJZOYB1AAEAQgAAAqsDIAAWAFSyCBcYERI5ALAARViwDi8bsQ4WPlmwAEVYsAAvG7EAED5ZshUCCitYIdgb9FmwAtCyFBUOERI5sgMOFBESObAOELIIAgorWCHYG/RZsA4QsAvQMDEhITUBNjU0JiMiBhUjNDYgFhUUDwIhAqv9qQEsbUA8S0edpwEImmtUsAGPbAEaZkUxPUw5cpR/bmhrT5EAAQA+//UCmgMgACYAcQCwAEVYsA4vG7EOFj5ZsABFWLAZLxuxGRA+WbIAGQ4REjl8sAAvGLaAAJAAoAADXbAOELIHAgorWCHYG/RZsgoABxESObAAELImAgorWCHYG/RZshQmABESObAZELIgAgorWCHYG/RZsh0mIBESOTAxATMyNjU0JiMiBhUjNDYzMhYVFAYHFhUUBiMiJjUzFBYzMjY1NCcjAQlUSkg/RjlLnaN8iZxGQpWqiISmnk9DRkmcWAHLPTAtOjMpYnt5aDdbGSmPan1+ay08PDNxAgAAAgA2AAACuwMVAAoADgBJALAARViwCS8bsQkWPlmwAEVYsAQvG7EEED5ZsgEJBBESObABL7ICAgorWCHYG/RZsAbQsAEQsAvQsggLBhESObINCQQREjkwMQEzFSMVIzUhJwEzATMRBwJQa2ud/okGAXmh/oTfEQErgqmpZgIG/hYBIRwAAQBb//UCpwMVABsAYQCwAEVYsAEvG7EBFj5ZsABFWLANLxuxDRA+WbABELIECQorWCHYG/RZsgcNARESObAHL7IZAgorWCHYG/RZsgUHGRESObANELAR0LANELITAgorWCHYG/RZsAcQsBvQMDETEyEVIQc2MzIWFRQGIyImJzMWMzI2NTQmIyIHcDIB3v6jFkFKgI+ghnmnBpsKgUFITkpJOwGDAZKEqh2JeXyRfmVjS0Q+TSsAAAIAVv/1AqsDHgATAB8ATgCwAEVYsAAvG7EAFj5ZsABFWLAMLxuxDBA+WbAAELIBAgorWCHYG/RZsgYMABESObAGL7IUAgorWCHYG/RZsAwQshsCCitYIdgb9FkwMQEVIwQHNjMyFhUUBiMiJjU1NDY3AyIGBxUUFjMyNjQmAigR/vQXSHJ2h5+Ei6fezX4zTRFTPz1ORwMegwLbTZF3dJqmlzPQ5AX+biwgIlRVT3xMAAABADoAAAKlAxUABgAyALAARViwBS8bsQUWPlmwAEVYsAIvG7ECED5ZsAUQsgQCCitYIdgb9FmyAAUEERI5MDEBASMBITUhAqX+o6YBXf47AmsCu/1FApOCAAADAE//9QKfAyAAEwAeACgAegCwAEVYsBEvG7ERFj5ZsABFWLAGLxuxBhA+WbIkBhEREjmwJC+23yTvJP8kA122DyQfJC8kA12y/yQBcbQPJB8kAnKyFwIKK1gh2Bv0WbICJBcREjmyDBckERI5sAYQsh0CCitYIdgb9FmwERCyHwIKK1gh2Bv0WTAxARQHFhUUBiAmNTQ2NyY1NDYzMhYDNCYjIgYVFBYyNgMiBhUUFjI2NCYCi3eLoP7woEpAd5d9fpeJTj4/S0x+TIw3Pz9wP0ACQ3Y3O4NqeXlqQmEbN3Zndnb+OjQ6OjQ1OjoB8DUwLjg4XDcAAAIASf/5ApUDIAASAB4AWgCwAEVYsAgvG7EIFj5ZsABFWLAPLxuxDxA+WbICDwgREjmwAi+2DwIfAi8CA12wDxCyEAIKK1gh2Bv0WbACELITAgorWCHYG/RZsAgQshkCCitYIdgb9FkwMQEGIyImNTQ2MzIWFxUQBQc1MjYnMjc1NCYjIgYVFBYB9kVldo2jgYmcA/5zN5aEe14qTzw7TEoBQEGKfnmgpZQ9/mQUAX9inkc8U1BUQ0FOAAEAjwKLAwsDIgADABEAsAIvsgEBCitYIdgb9FkwMQEhNSEDC/2EAnwCi5cAAwCeBEACbgZyAAMADwAbAHIAsABFWLANLxuxDRg+WbAH0LAHL0AJPwdPB18HbwcEXbAC0LACL7Y/Ak8CXwIDXbAA0LAAL0ARDwAfAC8APwBPAF8AbwB/AAhdsAIQsAPQGbADLxiwDRCyEwcKK1gh2Bv0WbAHELIZBworWCHYG/RZMDEBMwcjBzQ2MzIWFRQGIyImNxQWMzI2NTQmIyIGAbG93HKCZEhEY2FGSGRVMyQjMDAjJTIGcrjXRmFeSUdcXkUjMjEkJjI0AAMAHv5KBBEETgApADcARACPALAARViwJi8bsSYYPlmwAEVYsBYvG7EWEj5ZsCYQsCnQsCkvsgADCitYIdgb9FmyCBYmERI5sAgvsg4IFhESObAOL7SQDqAOAl2yNwEKK1gh2Bv0WbIcNw4REjmyIAgmERI5sBYQsjABCitYIdgb9FmwCBCyOwEKK1gh2Bv0WbAmELJCAQorWCHYG/RZMDEBIxYXFRQGBiMiJwYVFBczFhYVFAYGIyImNTQ2NyY1NDcmNTU0NjMyFyEBBgYVFBYzMjY1NCYnIwMUFjMyNjU1NCYiBhUEEZc6AW/DeE9JNHq3yM6N9JfR/15UOHOu8btQRwFv/Tw4PJSDks1obO90jGlniorSigOnVGkZYqZeFSpAUAIBlY9UoWCbelOKKi9KfFJqxQudyhT7+BpdN0pZckxKQQICpVN7elgSV3h4WgAAAgBk/+sEWAROABAAHABhALAARViwCS8bsQkYPlmwAEVYsAwvG7EMGD5ZsABFWLACLxuxAhA+WbAARViwEC8bsRAQPlmyAAIJERI5sgsJAhESObACELIUAQorWCHYG/RZsAkQshoBCitYIdgb9FkwMSUCISICNTUQEjMgEzczAxMjARQWMzITNSYmIyIGA4Js/vLA5OLEAQlsIrBqcbD9dZKH00gckmuGlfH++gEb9A8BCAE9/v/t/eL95AH0r8MBhyS+y+MAAgCxAAAE4wWvABYAHgBhshgfIBESObAYELAE0ACwAEVYsAMvG7EDHD5ZsABFWLABLxuxARA+WbAARViwDy8bsQ8QPlmyFwMBERI5sBcvsgABCitYIdgb9FmyCRcAERI5sAMQsh0BCitYIdgb9FkwMQERIxEhMhYVFAcWExUWFxUjJic1NCYjJSEyNjUQISEBcsECDvD77d4FAkHGOwOMf/6eATminf7P/rkCdP2MBa/SzOVjRf76nI09GDasi3iPnXyEAQAAAQCyAAAFHQWwAAwAaACwAEVYsAQvG7EEHD5ZsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgYCBBESOXywBi8YtGMGcwYCXbQzBkMGAl2ykwYBXbIBAQorWCHYG/RZsgoBBhESOTAxASMRIxEzETMBMwEBIwIjscDAlgH97/3UAlXrAo79cgWw/X4Cgv0+/RIAAAEAkgAABBQGAAAMAFMAsABFWLAELxuxBB4+WbAARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIHCAIREjmwBy+yAAEKK1gh2Bv0WbIKAAcREjkwMQEjESMRMxEzATMBASMBzIC6un4BO9v+hgGu2wH1/gsGAPyOAaz+E/2zAAEAsgAABPoFsAALAEwAsABFWLADLxuxAxw+WbAARViwBy8bsQccPlmwAEVYsAEvG7EBED5ZsABFWLAKLxuxChA+WbIAAwEREjmyBQMBERI5sgkABRESOTAxAREjETMRMwEzAQEjAXLAwAwCY/H9awK97QK1/UsFsP15Aof9O/0VAAABAJIAAAPxBhgADABMALAARViwBC8bsQQePlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAgCERI5sgYIAhESObIKBgAREjkwMQEjESMRMxEzATMBASMBUAS6ugEBivD+KwH/5AHz/g0GGPx1Aa3+Df25AAABAEP/EwPdBXMAKwBmALAARViwCS8bsQkaPlmwAEVYsCIvG7EiED5ZsgIiCRESObAJELAM0LAJELAQ0LAJELITAQorWCHYG/RZsAIQshkBCitYIdgb9FmwIhCwH9CwIhCwJtCwIhCyKQEKK1gh2Bv0WTAxATQmJCcmNTQ2NzUzFRYWFSM0JiMiBhUUFgQWFhUUBgcVIzUmJjUzFBYzMjYDI3n+2lbDy6aVo8a5jXlxhnsBOLBWw6mVut+6mox+ggEqUFhKK2KzgqwQ2dsVwohia1lQQVhQZYhbgqYQ4eETwpRmclsAAAEAMAAAA+8EnQAgAGAAsABFWLAULxuxFBo+WbAARViwBy8bsQcQPlmyDwcUERI5sA8vsg4ECitYIdgb9FmwAdCwBxCyBAEKK1gh2Bv0WbAI0LAUELAY0LAUELIbAQorWCHYG/RZsA8QsB/QMDEBIRcWByEHITUzNjc3JyM1MycmNjMyFhUjNCYjIgYXFyEDHf5wAQU4ApQB/IQKTwkBAaSgBAbLtbfKuWhgXWgEBAGUAfQiy2+YmBfdRiJ5e8nszLdwd4+KewAAAQAWAAAEJQSNABcAigCwAEVYsBcvG7EXGj5ZsABFWLABLxuxARo+WbAARViwDS8bsQ0QPlmyAA0XERI5shANFxESObAQL7IPEAFdsBTQsBQvtA8UHxQCcUAPDxQfFC8UPxRPFF8UbxQHXbAD0LAUELITBAorWCHYG/RZsAbQsBAQsAjQsBAQsg8ECitYIdgb9FmwC9AwMQEBMwEzFSEHFSEVIRUjNSE1ITUhNSEBMwIdATjQ/pv7/sEFAUT+vLn+vAFE/rwBAP6c0AJLAkL9jHkJQnjd3XhLeQJ0AAEAigAAA4UEjQAFADKyAQYHERI5ALAARViwBC8bsQQaPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIQOF/b65AvsD9PwMBI0AAAIAFAAABFMEjQADAAgAPLIFCQoREjmwBRCwAtAAsABFWLACLxuxAho+WbAARViwAC8bsQAQPlmyBQIAERI5sgcBCitYIdgb9FkwMSEhATMDJwcBIQRT+8EBya09Ghn++AJDBI3+3Vxe/TAAAAMAYP/wBFoEnQADABEAHwBeALAARViwDi8bsQ4aPlmwAEVYsAcvG7EHED5ZsgIHDhESOXywAi8YtGACcAICcbRgAnACAl2yAQEKK1gh2Bv0WbAOELIVAQorWCHYG/RZsAcQshwBCitYIdgb9FkwMQEhNSEFEAAjIgARNRAAMzIAFwc0JiMiBhUVFBYzMjY1A1X+HwHhAQX+7Ojl/ucBF+XpARMCt6yblq+wl5ypAfmZbv77/tEBMgEHPgECATT+0P8FxtLWxULD19PHAAEAFAAABFMEjQAIADiyBwkKERI5ALAARViwAi8bsQIaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbIHAgAREjkwMTMjATMBIwEnB9vHAcmtAcnG/sAaGQSN+3MDalxeAAADAD4AAANLBI0AAwAHAAsAY7IEDA0REjmwBBCwAdCwBBCwCdAAsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmyAgEKK1gh2Bv0WbIHCgAREjmwBy+yvwcBXbIEAQorWCHYG/RZsAoQsggBCitYIdgb9FkwMSEhNSEDITUhEyE1IQNL/PMDDUP9dwKJQ/zzAw2YAXuYAUmZAAEAigAABEQEjQAHAD+yAQgJERI5ALAARViwBi8bsQYaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEhIxEhESMRIQREuv25uQO6A/T8DASNAAABAD8AAAPIBI0ADABDsgYNDhESOQCwAEVYsAgvG7EIGj5ZsABFWLADLxuxAxA+WbIBAQorWCHYG/RZsAXQsAgQsgoBCitYIdgb9FmwB9AwMQEBIRUhNQEBNSEVIQECb/62AqP8dwFR/q8DV/2PAUoCOv5fmZABtwG2kJn+XwADAGAAAAUGBI0AEQAXAB4AXACwAEVYsBAvG7EQGj5ZsABFWLAILxuxCBA+WbIPEAgREjmwDy+wANCyCQgQERI5sAkvsAbQsAkQshQBCitYIdgb9FmwDxCyFQEKK1gh2Bv0WbAb0LAUELAc0DAxARYEFRQEBxUjNSYkNTQkNzUzARAFEQYGBTQmJxE2NgMQ5gEQ/u3juen+8gEQ57n+CAE/mqUDNqaYmKYEFg36y838DW5uDfvMzfsNdv21/tgRAnMJl5iZlQn9jgqWAAABAGAAAAS2BI0AFQBcsgAWFxESOQCwAEVYsAMvG7EDGj5ZsABFWLAPLxuxDxo+WbAARViwFC8bsRQaPlmwAEVYsAkvG7EJED5ZshMDCRESObATL7AA0LATELILAQorWCHYG/RZsAjQMDEBJBERMxEGAgcRIxEmAicRMxEQBREzAugBFbkD8tm62fAFugEUugG7MwFrATT+vfP+4hj+3wEfFAEd8gFL/sv+ji0C1AABAHUAAAR+BJ0AIQBcsgciIxESOQCwAEVYsBgvG7EYGj5ZsABFWLAPLxuxDxA+WbAARViwIC8bsSAQPlmwDxCyEQEKK1gh2Bv0WbAO0LAA0LAYELIHAQorWCHYG/RZsBEQsB7QsB/QMDElNjY1NTQmIyIGFRUUFhcVITUzJhE1NAAzMgAVFRAHMxUhAruIf66dnKyNf/4+r7MBG+foARyytf49nR/fzSazwMG3IczfIJ2XnQE6Hu4BI/7c9Rz+y5yXAAEAJv/sBSwEjQAZAGuyFhobERI5ALAARViwAi8bsQIaPlmwAEVYsA4vG7EOED5ZsABFWLAYLxuxGBA+WbACELIAAQorWCHYG/RZsATQsAXQsggCDhESObAIL7AOELIPAQorWCHYG/RZsAgQshUBCitYIdgb9FkwMQEhNSEVIRE2MzIWFRQGIzUyNjU0JiMiBxEjAYr+nAOJ/pSXnNTi5eCNf32AnZa5A/SZmf7XMdDEvr6XbXiDeTL9zgAAAQBg//AEMASdAB4AfbIDHyAREjkAsABFWLALLxuxCxo+WbAARViwAy8bsQMQPlmyDwsDERI5sAsQshIBCitYIdgb9FmyFgsDERI5fLAWLxiyoBYBXbRgFnAWAl2yMBYBcbRgFnAWAnGyFwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsh4DCxESOTAxAQYGIyIAETU0NjYzMhYXIyYmIyIGByEVIRYWMzI2NwQwFPzR4P7xe+eYzPcTuRKNfpmiBgG//kEEoZGHjRQBebvOAScBA16k+YjTu4J0w6+YssJvgwACACcAAAb7BI0AFwAgAHayBCEiERI5sAQQsBjQALAARViwEi8bsRIaPlmwAEVYsAMvG7EDED5ZsABFWLALLxuxCxA+WbASELIFAQorWCHYG/RZsAsQsg4BCitYIdgb9FmyFBIDERI5sBQvshgBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WTAxARQGByERIQMOAgcjNzc2NhMTIREhFhYlESEyNjU0JiMG++bD/iv+Xg8LTZd7OwQuYFEKFAMOASTB4P07ARVyhINzAW6lxwID9P5l7fZ1AaUBBL4BCQIc/koEwS3+WXVjX3AAAgCKAAAHCQSNABIAGwCJsgEcHRESObABELAT0ACwAEVYsAIvG7ECGj5ZsABFWLARLxuxERo+WbAARViwCy8bsQsQPlmwAEVYsA8vG7EPED5ZsgECCxESOXywAS8YsqABAV2yBAILERI5sAQvsAEQsg0BCitYIdgb9FmwBBCyEwEKK1gh2Bv0WbALELIUAQorWCHYG/RZMDEBIREzESEWFhUUBgchESERIxEzAREhMjY1NCYnAUMCSLkBJMHg5sP+K/24ubkDAQEVc4R9bgKKAgP+SgTBpKXHAgHy/g4Ejf2y/ll3YVtxAwAAAQAoAAAFLgSNABUAWrIHFhcREjkAsABFWLACLxuxAho+WbAARViwDC8bsQwQPlmwAEVYsBQvG7EUED5ZsAIQsgABCitYIdgb9FmwBNCwBdCyCAIMERI5sAgvshEBCitYIdgb9FkwMQEhNSEVIRE2MzIWFxEjETQmIyIHESMBi/6dA4n+lJOg1N4Eun1/nZa6A/SZmf7XMcrB/o8BZId5Mv3OAAABAIr+mwRDBI0ACwBPsgMMDRESOQCwAi+wAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsggBCitYIdgb9FmwCdAwMSEhESMRIREzESERMwRD/oG5/n+5Ake5/psBZQSN/AsD9QACAIoAAAQIBI0ADAAVAF6yAxYXERI5sAMQsA3QALAARViwCy8bsQsaPlmwAEVYsAkvG7EJED5ZsAsQsgABCitYIdgb9FmyAwsJERI5sAMvsAkQsg0BCitYIdgb9FmwAxCyEwEKK1gh2Bv0WTAxASERITIWFRQGByERIQEyNjU0JichEQOV/a4BEc7m5MX+KwML/sNzhH1u/t8D9/7gxKWkyAIEjfwLd2FbcQP+WQACAC7+rATnBI0ADwAVAFuyExYXERI5sBMQsAXQALAJL7AARViwBS8bsQUaPlmwAEVYsAsvG7ELED5ZsgABCitYIdgb9FmwB9CwCNCwCRCwDdCwCBCwENCwEdCwBRCyEgEKK1gh2Bv0WTAxNzc2NjcTIREzESMRIREjEyEhESEDAoUpR0cHDgMHj7n8uroBAS4CQv5kDBGYMVb92AGZ/Av+FAFU/q0B6wNc/sj+mQABAB8AAAXrBI0AFQCRsgEWFxESOQCwAEVYsAkvG7EJGj5ZsABFWLANLxuxDRo+WbAARViwES8bsREaPlmwAEVYsAIvG7ECED5ZsABFWLAGLxuxBhA+WbAARViwFC8bsRQQPlmyEAkCERI5fLAQLxiyoBABXbRgEHAQAl2yAAEKK1gh2Bv0WbAE0LITEAAREjmwExCwCNCwEBCwC9AwMQEjESMRIwEjAQEzATMRMxEzATMBASMDxWO6ZP7F6gGG/p7gASxZulkBLOD+nAGI6gH2/goB9v4KAlECPP4DAf3+AwH9/c39pgAAAQBH//AD1ASdACgAfbIkKSoREjkAsABFWLAKLxuxCho+WbAARViwFi8bsRYQPlmwChCyAwEKK1gh2Bv0WbIGChYREjmyJwoWERI5sCcvtB8nLycCXbK/JwFdtN8n7ycCXbIkAQorWCHYG/RZshAkJxESObIcFgoREjmwFhCyHwEKK1gh2Bv0WTAxATQmIyIGFSM0NjMyFhUUBgcWFhUUBiMiJicmNTMWFjMyNjU0JSM1MzYDCIp9boG67bzT7m5ndnH+1VupPXm5BYN5iJL+/52c7wNQVF1YT461qJZWjSkkkluetCwuWZ1WYGBYwQWYBQABAIoAAARhBI0ACQBMsgAKCxESOQCwAEVYsAAvG7EAGj5ZsABFWLAHLxuxBxo+WbAARViwAi8bsQIQPlmwAEVYsAUvG7EFED5ZsgQAAhESObIJAAIREjkwMQEzESMRASMRMxEDqLm5/Zu5uQSN+3MDdPyMBI38jAABAIsAAAQsBI0ADABosgoNDhESOQCwAEVYsAQvG7EEGj5ZsABFWLAILxuxCBo+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgYCBBESOXywBi8YsqAGAV20YAZwBgJdsgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAa5qublkAYXf/jUB6+8B9v4KBI3+AwH9/cX9rgAAAQAnAAAENgSNAA8ATbIEEBEREjkAsABFWLAALxuxABo+WbAARViwAS8bsQEQPlmwAEVYsAgvG7EIED5ZsAAQsgMBCitYIdgb9FmwCBCyCgEKK1gh2Bv0WTAxAREjESEDAgIHIzc3NjY3EwQ2uf5eDw2ksEQEKV5QDRkEjftzA/T+gv6q/uUFpQMHnuICXgAAAQAi/+wECwSNABEAQ7IBEhMREjkAsABFWLACLxuxAho+WbAARViwEC8bsRAaPlmwAEVYsAgvG7EIED5ZsgEIAhESObIMAQorWCHYG/RZMDEBFwEzAQcGBwciJzcXMjY3ATMB9S0BFNX+XiVQqiZQFAZcMUkg/mbWAjB4AtX8RUmRCwEIkwUxOwOfAAABAIr+rATxBI0ACwBFsgkMDRESOQCwAi+wAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAI0LAJ0DAxJTMDIxEhETMRIREzBEStEqX8ULkCR7qY/hQBVASN/AsD9QAAAQA9AAAD3wSNABEARrIEEhMREjkAsABFWLAILxuxCBo+WbAARViwEC8bsRAaPlmwAEVYsAAvG7EAED5Zsg0IABESObANL7IEAQorWCHYG/RZMDEhIxEGIyImJxEzERQWMzI3ETMD37mQo9TeBLl+f52WuQHCMMrBAXD+nYd5MgIxAAEAigAABcYEjQALAE+yBQwNERI5ALAARViwAi8bsQIaPlmwAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmyBAEKK1gh2Bv0WbAI0LAJ0DAxISERMxEhETMRIREzBcb6xLkBiLoBiLkEjfwLA/X8CwP1AAEAiv6sBnUEjQAPAFiyCxARERI5ALACL7AARViwBi8bsQYaPlmwAEVYsAovG7EKGj5ZsABFWLAOLxuxDho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAI0LAJ0LAM0LAN0DAxJTMDIxEhETMRIREzESERMwXHrhKm+s25AYi6AYi6mP4UAVQEjfwLA/X8CwP1AAACAAgAAATWBI0ADQAWAF6yCBcYERI5sAgQsBXQALAARViwBy8bsQcaPlmwAEVYsAMvG7EDED5ZsAcQsgUBCitYIdgb9FmyCgcDERI5sAovsAMQsg4BCitYIdgb9FmwChCyFAEKK1gh2Bv0WTAxARQGByERITUhESEyFhYBMjY1NCYjIREE1uTE/ir+sAIKARaEwmj+UXKEg3P+6wFupMgCA/SZ/kpYo/68dWNfcP5Z//8AigAABWcEjQAmAggAAAAHAcIEFgAAAAIAigAABAgEjQAKABMAULIIFBUREjmwCBCwC9AAsABFWLAFLxuxBRo+WbAARViwAy8bsQMQPlmyCAUDERI5sAgvsAMQsgsBCitYIdgb9FmwCBCyEQEKK1gh2Bv0WTAxARQGByERMxEhMhYBMjY1NCYnIREECOTF/iu5ARHO5v5Qc4R9bv7fAW6kyAIEjf5KxP6Fd2FbcQP+WQABAEv/8AQbBJ0AHgB6sgMfIBESOQCwAEVYsBMvG7ETGj5ZsABFWLAbLxuxGxA+WbIAGxMREjmyAwEKK1gh2Bv0WbIJExsREjl8sAkvGLKgCQFdtGAJcAkCXbIwCQFxtGAJcAkCcbIGAQorWCHYG/RZsBMQsgwBCitYIdgb9FmyDxMbERI5MDEBFhYzMjY3ITUhJiYjIgYHIzY2MzIAFxUUBgYjIiYnAQQUjYeNogf+QQG+BaOYfo0SuRP3zOQBEQV44pXP/hQBeYNvu7mYr8N0grvT/t/0daP5h867AAACAIr/8AYVBJ0AEwAhAIqyBCIjERI5sAQQsBjQALAARViwEC8bsRAaPlmwAEVYsAsvG7ELGj5ZsABFWLADLxuxAxA+WbAARViwCC8bsQgQPlmyDQgLERI5fLANLxi0YA1wDQJxsqANAV20YA1wDQJdsgYBCitYIdgb9FmwEBCyFwEKK1gh2Bv0WbADELIeAQorWCHYG/RZMDEBEAAjIgAnIxEjETMRMzYAMzIAFwc0JiMiBhUVFBYzMjY1BhX+7Ojd/usM2Lm52A4BFNrpARMCt6yblq+wl5ypAiT++/7RARzy/gIEjf4J8QEW/tD/BcbS1sVCw9fTxwAAAgBQAAAD/ASNAA0AFABhshMVFhESObATELAH0ACwAEVYsAcvG7EHGj5ZsABFWLAALxuxABA+WbAARViwCS8bsQkQPlmyEQcAERI5sBEvsgsBCitYIdgb9FmyAQsHERI5sAcQshIBCitYIdgb9FkwMTMBJiY1NDY3IREjESEDExQXIREhIlABInpx3MgB0bn+0P8u5gEb/u/wAg0mnWihsgL7cwHf/iEDMLQEAXwAAQALAAAD5wSNAA0AULIBDg8REjkAsABFWLAILxuxCBo+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASMRIxEjNTMRIRUhETMCh+K54eEC+/2+4gH9/gMB/ZcB+Zn+oAAAAQAf/qwGIgSNABkAqrIIGhsREjkAsABFWLAQLxuxEBo+WbAARViwFC8bsRQaPlmwAEVYsBgvG7EYGj5ZsABFWLANLxuxDRA+WbAARViwCi8bsQoQPlmwAEVYsAUvG7EFED5ZshcKGBESOXywFy8YsqAXAV20YBdwFwJdtGAXcBcCcbIHAQorWCHYG/RZsgAHFxESObAFELIBAQorWCHYG/RZsAcQsAvQsg8XBxESObAXELAS0DAxAQEzESMRIwEjESMRIwEjAQEzATMRMxEzATMEYwEmmad6/sRjumT+xeoBhv6e4AEsWbpZASzgAlr+PP4WAVQB9v4KAfb+CgJRAjz+AwH9/gMB/QABAIv+rAROBI0AEACAsgAREhESOQCwAy+wAEVYsAsvG7ELGj5ZsABFWLAPLxuxDxo+WbAARViwCS8bsQkQPlmwAEVYsAUvG7EFED5Zsg0JCxESOXywDS8YtGANcA0CcbKgDQFdtGANcA0CXbIIAQorWCHYG/RZsgAIDRESObAFELIBAQorWCHYG/RZMDEBATMRIxEjASMRIxEzETMBMwJBAW+eqGn+cWq5uWQBhd8CUv5E/hYBVAH2/goEjf4DAf0AAAEAiwAABOcEjQAUAHiyCxUWERI5ALAARViwBi8bsQYaPlmwAEVYsBMvG7ETGj5ZsABFWLAJLxuxCRA+WbAARViwES8bsREQPlmyABETERI5fLAALxiyoAABXbRgAHAAAl20YABwAAJxsATQsAAQshABCitYIdgb9FmyCBAAERI5sAzQMDEBMzUzFTMBMwEBIwEjFSM1IxEjETMBRFCUPAGE4P40Aevv/nFBlFC5uQKQ5OQB/f3F/a4B9s7O/goEjQAAAQAjAAAFFQSNAA4AfbIADxAREjkAsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIAgYREjl8sAgvGLKgCAFdtGAIcAgCXbRgCHAIAnGyAQEKK1gh2Bv0WbAGELIEAQorWCHYG/RZsgwBCBESOTAxASMRIxEhNSERMwEzAQEjApdpuv6vAgtjAYXg/jQB6+8B9v4KA/WY/gMB/f3F/a4AAgBg/+sFWwSfACMALgCUshQvMBESObAUELAk0ACwAEVYsAsvG7ELGj5ZsABFWLAbLxuxGxo+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgIEGxESObACL7ALELIMAQorWCHYG/RZsAQQshMBCitYIdgb9FmwAhCyJgEKK1gh2Bv0WbIVEyYREjmyIQImERI5sBsQsiwBCitYIdgb9FkwMQUiJwYjIAARNRASMxciBhUVFBYzMjcmAzU0EjMyEhUVEAcWMwEQFzYRNTQmIyIDBVvZpomj/ur+xvTSAX6Q0Mc2MuMBz7W4zbZedv2S4bZiasYFFDs8AUUBKhoBAwEonsPIIejlCLIBRSfrAQT+//E4/tqyEgH9/sx5gQEeOKyj/sP//wANAAAEHASNACYB0gAAAQcB3gBE/t4ACACyAAoBXTAxAAEAJv6sBHEEjQAQAGuyCxESERI5ALAHL7AARViwAS8bsQEaPlmwAEVYsA8vG7EPGj5ZsABFWLAJLxuxCRA+WbAARViwDC8bsQwQPlmyAAEMERI5sgsMARESObIDCwAREjmwCRCyBAEKK1gh2Bv0WbIOAAsREjkwMQEBMwEBNTMRIxEjAQEjAQEzAigBH9z+dQExqKh0/tX+2NwBlv5z2wLaAbP9vv5KAf4WAVQBu/5FAksCQgAAAQAm/qwF8gSNAA8AXLIJEBEREjkAsAIvsABFWLAILxuxCBo+WbAARViwDi8bsQ4aPlmwAEVYsAQvG7EEED5ZsgABCitYIdgb9FmwCBCyBgEKK1gh2Bv0WbAK0LAL0LAAELAM0LAN0DAxJTMDIxEhESE1IRUhESERMwVErhKl/FD+mwOJ/pUCRrqY/hQBVAP0mZn8pAP1AAABAD0AAAPfBI0AFwBPsgQYGRESOQCwAEVYsAsvG7ELGj5ZsABFWLAWLxuxFho+WbAARViwAC8bsQAQPlmyEAsAERI5sBAvsgcBCitYIdgb9FmwBNCwEBCwE9AwMSEjEQYHFSM1JiYnETMRFBYXNTMVNjcRMwPfuWNplbzJA7lnaJVnZbkBwiELxsMKyboBbf6de3gL8O0LIgIxAAABAIoAAAQsBI0AEQBGsgQSExESOQCwAEVYsAAvG7EAGj5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyBAAIERI5sAQvsg0BCitYIdgb9FkwMRMzETYzMhYXESMRNCYjIgcRI4q5mpnU3gS5fn+Ym7kEjf4+McrB/o8BZId5M/3PAAACAAL/8AVrBJ0AHAAkAGmyFSUmERI5sBUQsB7QALAARViwDi8bsQ4aPlmwAEVYsAAvG7EAED5ZsiEOABESObAhL7K/IQFdshIBCitYIdgb9FmwA9CwIRCwCtCwABCyFgEKK1gh2Bv0WbAOELIdAQorWCHYG/RZMDEFIgA1JiY1MxQWFz4CMzIAERUhFBYzMjY3FwYGAyIGByE1NCYDkf/+zqa4mV9mBYfpjvgBEPyuwbdMh1A5PLiWj7UGApmuEAEi8wvGqF53DJPsgf7r/v2CscAfKJIoLwQRwqQboaoAAAIAXv/wBGkEnQAWAB4AXrIIHyAREjmwCBCwF9AAsABFWLAALxuxABo+WbAARViwCC8bsQgQPlmyDQAIERI5sA0vsAAQshEBCitYIdgb9FmwCBCyFwEKK1gh2Bv0WbANELIaAQorWCHYG/RZMDEBMgAXFRQGBiMiABE1ITU0JiMiByc2NhMyNjchFRQWAkf3ASkChOyT+P7wA1LBt5OQOUHAiZGzBv1nrQSd/uDviJn0iQEVAQGCAbHBSJIpL/vtxqEboKwAAAEAR//tA9QEjQAcAG2yGh0eERI5ALAARViwAi8bsQIaPlmwAEVYsAsvG7ELED5ZsAIQsgABCitYIdgb9FmyBAACERI5sgULAhESObAFL7IRCwIREjmwCxCyFAEKK1gh2Bv0WbAFELIaAQorWCHYG/RZshwFGhESOTAxASE1IRcBFhYVFAYjIiYnJjUzFhYzMjY1NCYjIzUCs/28AzgC/qmx0fzXWas8erkFiXOIkoqGgAP0mXb+mxDFi6e+LS5anllkaGpfaqUAAwBg//AEWgSdAA0AFAAbAHOyAxwdERI5sAMQsA7QsAMQsBXQALAARViwCi8bsQoaPlmwAEVYsAMvG7EDED5Zsg4BCitYIdgb9FmyGQoDERI5fLAZLxiyoBkBXbRgGXAZAl20YBlwGQJxshEBCitYIdgb9FmwChCyFQEKK1gh2Bv0WTAxARAAIyIAETUQADMyABcBMjY3IRYWEyIGByEmJgRa/uzo5f7nARfl6QETAv4Ek6gJ/XYKrY2RqwgCigmqAiT++/7RATIBBz4BAgE0/tD//hy8tLDAA3fDrLO8AAABADAAAAPvBJ0AJwCush0oKRESOQCwAEVYsB0vG7EdGj5ZsABFWLAMLxuxDBA+WbIGHQwREjmwBi+yDwYBcbIPBgFdsk8GAXGwAdCwAS9ACR8BLwE/AU8BBF2yAAEBXbICBAorWCHYG/RZsAYQsgcECitYIdgb9FmwDBCyCgEKK1gh2Bv0WbAO0LAP0LAHELAR0LAGELAT0LACELAW0LABELAY0LIhAR0REjmwHRCyJAEKK1gh2Bv0WTAxASEVIRcVIRUhBgchByE1MzY3IzUzNScjNTMnJjYzMhYVIzQmIyIGFwGHAZb+bgMBj/5sCiQClAH8hAo/FJ+lA6KeAgbLtbfKuWhgXWgEAqh5XRB5akeYmBKfeRBdeUDJ7My3cHePigAAAQBC//ADngSdACEAnrIUIiMREjkAsABFWLAVLxuxFRo+WbAARViwCC8bsQgQPlmyIRUIERI5sCEvsg8hAV20ECEgIQJdsgAECitYIdgb9FmwCBCyAwEKK1gh2Bv0WbAAELAL0LAhELAN0LAhELAS0LASL0AJHxIvEj8STxIEXbIAEgFdsg8ECitYIdgb9FmwFRCyGgEKK1gh2Bv0WbASELAc0LAPELAe0DAxASESITI3FwYjIiYnIzUzNSM1MzY2MzIXByYjIAMhFSEVIQMv/mggAQJiaBt2b9P1FJuXl5sW9c9ghxVZef8AIAGY/mQBnAGW/vEclR7azHlteczcH5Uc/vB5bQAABACKAAAHrQSdAAMAEAAeACgAqLIfKSoREjmwHxCwAdCwHxCwBNCwHxCwEdAAsABFWLAnLxuxJxo+WbAARViwJS8bsSUaPlmwAEVYsAcvG7EHGj5ZsABFWLAiLxuxIhA+WbAARViwIC8bsSAQPlmwBxCwDdCwDS+wAtCwAi+0AAIQAgJdsgEDCitYIdgb9FmwDRCyFAMKK1gh2Bv0WbAHELIbAworWCHYG/RZsiEnIBESObImICcREjkwMSUhNSEBNDYgFhUVFAYjIiY1FxQWMzI2NTU0JiMiBhUBIwERIxEzAREzB2790wIt/ZK8ATS9vpeZv6NeV1ReYVNSYf61uP2jubkCXbi9jgIDlbq4m1CYtrecBVlqaVxSWmhnXvy1A2z8lASN/JMDbQAAAgAoAAAEZgSNABYAHwCDsgAgIRESObAY0ACwAEVYsAwvG7EMGj5ZsABFWLACLxuxAhA+WbIWDAIREjmwFi+yAAEKK1gh2Bv0WbAE0LAWELAG0LAWELAL0LALL0AJDwsfCy8LPwsEXbS/C88LAl2yCAEKK1gh2Bv0WbAT0LALELAX0LAMELIeAQorWCHYG/RZMDElIRUjNSM1MzUjNTMRITIWFRQGByEVISUhMjY1NCYjIQKk/v66wMDAwAHPxerjvv7dAQL+/gEVcoOEcP7qtLS0mFmYAlDMqKXLBFnxeGJkegAAAgCM/+wENAYAABAAGwBkshQcHRESObAUELAN0ACwCS+wAEVYsA0vG7ENGD5ZsABFWLAELxuxBBA+WbAARViwBy8bsQcQPlmyBg0EERI5sgsNBBESObANELIUAQorWCHYG/RZsAQQshkBCitYIdgb9FkwMQEUBgYjIicHIxEzETYzMhIRJzQmIyIHERYzMjYENG/JgNFwD6C5cMXJ8bmjjLdQVbSKowISn/yLlYEGAP3Di/7T/v8HtNaq/iyr2AAAAQBc/+wD7wROAB0ASbIAHh8REjkAsABFWLAQLxuxEBg+WbAARViwCC8bsQgQPlmyAAEKK1gh2Bv0WbAIELAD0LAQELAU0LAQELIXAQorWCHYG/RZMDElMjY3Mw4CIyIANTU0NjYzMhYXIyYmIyIGFRUUFgJAY5QIsAV4xG7f/vt225O28QiwCI9oj5udg3haXqhjASr8IJ35htquaYfOvyG8yQACAFv/7AQABgAAEQAcAGSyGh0eERI5sBoQsATQALAHL7AARViwBC8bsQQYPlmwAEVYsA0vG7ENED5ZsABFWLAJLxuxCRA+WbIGBA0REjmyCwQNERI5sA0QshUBCitYIdgb9FmwBBCyGgEKK1gh2Bv0WTAxEzQ2NjMyFxEzESMnBiMiJiYnNxQWMzI3ESYjIgZbcc6Avm+5oQ5vynzLdQG5qIqvUlOsjacCJp/8jYICNPoAeIyM+5gGsdifAfGZ1gACAFv+VgQABE4AGwAmAHyyHycoERI5sB8QsAvQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLALLxuxCxI+WbAARViwGC8bsRgQPlmyBQMYERI5sAsQshIBCitYIdgb9FmyFgMYERI5sBgQsh8BCitYIdgb9FmwAxCyJAEKK1gh2Bv0WTAxEzQSMzIXNzMRBgIjIiYnNxYWMzI2NTUGIyICNRcUFjMyNxEmIyIGW/jGzG8PnQL04FbISDc/n0+Vim/Bwvq5pouvU1OtjqUCJvYBMpSA/A7v/v03MooqMrCoKIEBOPQHsNmhAeud1wD//wBXAAAChgW3AAYAFa0AAAIAjP5gBDIETgAQABsAbrIZHB0REjmwGRCwDdAAsABFWLANLxuxDRg+WbAARViwCi8bsQoYPlmwAEVYsAcvG7EHEj5ZsABFWLAELxuxBBA+WbIGDQQREjmyCw0EERI5sA0QshQBCitYIdgb9FmwBBCyGQEKK1gh2Bv0WTAxARQGBiMiJxEjETMXNjMyEhcHNCYjIgcRFjMyNgQybsiBxXG5nw90ysHuCripj6hUU6uMqgIRnvyLff33Bdp9kf7p6iew25X9+5TfAAACAFv+YAP/BE4ADwAaAGuyGBscERI5sBgQsAPQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLAILxuxCBI+WbAARViwDC8bsQwQPlmyBQMMERI5sgoDDBESObITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMRM0EjMyFzczESMRBiMiAjUXFBYzMjcRJiMiBlv3zMRvDqC5cLrH+rmqjKZWWKKOqgIl9QE0hnL6JgIEeAE19geu35MCEY/fAAIAXf/sA/METgAUABwAYrIIHR4REjmwCBCwFdAAsABFWLAILxuxCBg+WbAARViwAC8bsQAQPlmyGQgAERI5sBkvtL8ZzxkCXbIMAQorWCHYG/RZsAAQshABCitYIdgb9FmwCBCyFQEKK1gh2Bv0WTAxBSIAJyc0NjYzMhIVFSEWFjMyNxcGASIGByE1NCYCceX+3QsBfN2A1ej9JAjCmaB4OYP+7nOYEQIgiRQBF+NOm/WK/v7wdJ3IWn9yA8qglhmDmgACAGD+VgPyBE4AGgAlAHyyIyYnERI5sCMQsAvQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLALLxuxCxI+WbAARViwFy8bsRcQPlmyBQMXERI5sAsQshEBCitYIdgb9FmyFQMXERI5sBcQsh4BCitYIdgb9FmwAxCyIwEKK1gh2Bv0WTAxEzQSMzIXNzMRFAYjIiYnNxYzMjY1NQYjIgI1FxQWMzI3ESYjIgZg6MPKcBCd9eFSr0E3eo+ViW/Avuu6lYivUlWqiZYCJfoBL5N//AXq/y0pikmnnjqAATL6CLXToAHum9AAAQB+/+sFHQXFAB4ATLIMHyAREjkAsABFWLAMLxuxDBw+WbAARViwAy8bsQMQPlmwDBCwENCwDBCyEwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsAMQsB7QMDEBBgAjIiQCJzU0EiQzMgAXIyYmIyICERUUEhYzMjY3BRwY/tvusf7hogGdARuy7QEvGcEYv53A6m7IfaGwGgHO3/78tAFHy0TTAUqz/vrjo6j+y/7+N6H/AJCdqQABAH7/6wUeBcQAIgBtsgwjJBESOQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIQAwwREjmwEC+wDBCyEwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsiIMAxESObAiL7Q/Ik8iAl20DyIfIgJdsh8BCitYIdgb9FkwMSUGBCMiJAInNTQSJDMyBBcjJiYjIgIHBxQSFjMyNjcRITUhBR5D/uOwu/7WqAObARy18QEhIsAeupy17AoBeNOFcrUq/rACD75hcrQBR9It2wFOtuXalYz+3PJGrP72jDowAUabAAIAsgAABREFsAALABUARrIDFhcREjmwAxCwFdAAsABFWLABLxuxARw+WbAARViwAC8bsQAQPlmwARCyDAEKK1gh2Bv0WbAAELINAQorWCHYG/RZMDEzESEyBBIXFRQCBAcDETMyABE1NAAjsgGxwQE4sQSt/sLL6d/qARP+9+gFsKz+xMg+0P7BsQIFEvuLASoBAyT8ASgAAgB+/+sFXwXFABEAIgBGsgQjJBESObAEELAf0ACwAEVYsA0vG7ENHD5ZsABFWLAELxuxBBA+WbANELIWAQorWCHYG/RZsAQQsh8BCitYIdgb9FkwMQEUAgQjIiQCJzU0EiQzMgQSFwc0AiYjIgYGBxUUEhYzMhI1BV+i/uKvq/7hpgKkASGrrQEgowG/bsd9eMZyAXHJecHvAsLO/rC5uQFKyDfNAU+8uf60zAWiAQCPj/6cNaD+/pIBO/8AAAIAfv8EBV8FxQAVACYATbIIJygREjmwCBCwI9AAsABFWLARLxuxERw+WbAARViwCC8bsQgQPlmyAwgRERI5sBEQshoBCitYIdgb9FmwCBCyIwEKK1gh2Bv0WTAxARQCBxcHJQYjIiQCJzU0EiQzMgQSFSc0AiYjIgYGBxUUEhYzMhI1BV+plPqD/sw5PKv+4KQDogEirK4BIaK/bsd9eMdxAXHJecHvAsLU/qxaw3nzDLoBRsY6zAFQvrv+sM4BowEBj5D/nDOg/v6SATv/AAABAKAAAALJBI0ABgAyALAARViwBS8bsQUaPlmwAEVYsAAvG7EAED5ZsgQABRESObAEL7IDAQorWCHYG/RZMDEhIxEFNSUzAsm5/pACCh8DpouoygABAIMAAAQgBKAAGABUsgkZGhESOQCwAEVYsBEvG7ERGj5ZsABFWLAALxuxABA+WbIXAQorWCHYG/RZsALQshYXERESObIDERYREjmwERCyCQEKK1gh2Bv0WbARELAM0DAxISE1ATY3NzQmIyIGFSM0NjYzMhYVFAcBIQQg/IcB/X0KA31mepW5eNJ+u+HF/oYCeIMByXNUNVRsjnVwv2y4mLG0/qwAAQCKAAADhQXEAAcAMrIDCAkREjkAsABFWLAGLxuxBho+WbAARViwBC8bsQQQPlmwBhCyAgEKK1gh2Bv0WTAxATMRIREjESECzLn9vrkCQgXE/jD8DASNAAEAD/6jA94EjQAYAE4AsAsvsABFWLACLxuxAho+WbIBAQorWCHYG/RZsATQsgULAhESObAFL7ALELIQAQorWCHYG/RZsAUQshcBCitYIdgb9FmyGBcFERI5MDEBITUhFQEWFhUUACMiJzcWMzI2NTQmIyM1AuT9dANy/oCy4v7M/8rSNKWxtNe5wDwD9Jl2/mwY9rP5/tpni1jKpaulZwACAD7+tgSgBI0ACgAOAEsAsABFWLAJLxuxCRo+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsgABCitYIdgb9FmwBhCwBdCwBS+wABCwDNCyDQkCERI5MDElMxUjESMRITUBMwEhEQcD28XFuv0dAtbH/TwCChyWl/63AUltBCH8CQL8NQD//wBQAo0CnQW4AwcB1AAAApgAEwCwAEVYsAovG7EKHD5ZsBDQMDEA//8ANgKYArsFrQMHAdgAAAKYABMAsABFWLAJLxuxCRw+WbAN0DAxAP//AFsCjQKnBa0DBwHZAAACmAAQALAARViwAS8bsQEcPlkwMf//AFYCjQKrBbYDBwHaAAACmAATALAARViwAC8bsQAcPlmwFNAwMQD//wA6ApgCpQWtAwcB2wAAApgAEACwAEVYsAUvG7EFHD5ZMDH//wBPAo0CnwW4AwcB3AAAApgAGQCwAEVYsBEvG7ERHD5ZsBfQsBEQsB/QMDEA//8ASQKRApUFuAMHAd0AAAKYABMAsABFWLAILxuxCBw+WbAZ0DAxAAABAGX+oAQFBIwAGwBOALANL7AARViwAS8bsQEaPlmyBAEKK1gh2Bv0WbIHDQEREjmwBy+yGAEKK1gh2Bv0WbIFBxgREjmwDRCyEgEKK1gh2Bv0WbAHELAb0DAxExMhFSEDNjc2EhUUACMiJzcWMzI2NTQmIyIGB4ZmAxT9fjZvlcjx/uDx4K86gtOZv6WHanUiAXQDGKv+dEACAv714e/+4nKLZc+kj7Y6UwAAAQBK/rYD8gSNAAYAJQCwAS+wAEVYsAUvG7EFGj5ZsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITUhA/L9oLoCV/0bA6gEI/qTBT+YAAIAYP/wBm0EnQATAB0AmrIVHh8REjmwFRCwCtAAsABFWLAJLxuxCRo+WbAARViwCy8bsQsaPlmwAEVYsAIvG7ECED5ZsABFWLAALxuxABA+WbALELIMAQorWCHYG/RZsAAQsA/QsA8vsh8PAV2y3w8BXbIQAQorWCHYG/RZsAAQshMBCitYIdgb9FmwAhCyFAEKK1gh2Bv0WbAJELIXAQorWCHYG/RZMDEhIQUiABE1EAAzBSEVIREhFSERIQU3ESciBhUVFBYGbf1j/o7l/ucBF+UBWwKv/ZsCFP3sAmz78erslq+wEAEyAQc+AQIBNBCZ/rKY/okNBwNnCdbFQsPXAAIAgv6pBD8EoQAYACUASwCwFC+wAEVYsAwvG7EMGj5ZsBQQsgABCitYIdgb9FmyBRQMERI5sAUvsgMFDBESObIaAQorWCHYG/RZsAwQsiABCitYIdgb9FkwMQUyNjcGIyICNTQ2NjMyABMVFAIEIyInNxYTMjY3NTQmIyIGFRQWAd+x3BV3t9L/ddKE6wEFApL+86+fdiZ64GmfIqGSf5ijv/TZaQEU4pzsfv7c/vb63P66rjyOMgH8XFKUxcXDq5XJAAACAHj/6wSJBKEACwAZADkAsABFWLAILxuxCBo+WbAARViwAy8bsQMQPlmwCBCyDwEKK1gh2Bv0WbADELIWAQorWCHYG/RZMDEBEAAgAAM1EAAgABMnNCYjIgYHFRQWMzI2NwSJ/uj+Iv7mAQEZAd4BGQG6sp2bsgK2m5qxAgI8/ur+xQE8ARQUARQBPv7E/usNyuLgxTTJ5d3KAP///7T+SwFlBDoABgCbAAD///+0/ksBZQQ6AAYAmwAA//8AmwAAAVUEOgAGAIwAAP////r+WQFaBDoAJgCMAAAABgCjyAr//wCbAAABVQQ6AAYAjAAA//8Ahv6sAWEEOgAmAIwAAAAHAKwDTgAKAAEAiv/sA/kEnQAhAFwAsABFWLAVLxuxFRo+WbAARViwEC8bsRAQPlmwAEVYsB8vG7EfED5ZsgIBCitYIdgb9FmyGR8VERI5sBkvsQgKK1jYG9xZsBkQsArQsBUQsg0BCitYIdgb9FkwMSUWMzI2NTQmIyM1EyYjIgMRIxE2NjMyFhcBFhYVFAYjIicBw1JYYXKIh1TtTmPTBLgBxclrw2X+7qm217V3aLUze2NiVYkBJz7+9f0GAvXS1lVi/rYPo4aszDEA//8AJQIfAg0CtgIGABEAAAACACUAAATkBbAADwAdAGYAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvss8EAV2yLwQBXbKfBAFxsgEBCitYIdgb9FmwEdCwABCyEgEKK1gh2Bv0WbAFELIbAQorWCHYG/RZsAQQsBzQMDEzESM1MxEhMgQSFxUUAgQHEyERMzISNzU0AicjESHHoqIBm74BJJ8Bn/7ZxEf+5sne9wHp1uABGgKalwJ/qP7KyV3O/sqmAgKa/gMBEvld+AETAv4fAAACACUAAATkBbAADwAdAGYAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvss8EAV2yLwQBXbKfBAFxsgEBCitYIdgb9FmwEdCwABCyEgEKK1gh2Bv0WbAFELIbAQorWCHYG/RZsAQQsBzQMDEzESM1MxEhMgQSFxUUAgQHEyERMzISNzU0AicjESHHoqIBm74BJJ8Bn/7ZxEf+5sne9wHp1uABGgKalwJ/qP7KyV3O/sqmAgKa/gMBEvld+AETAv4fAAABAAAAAAP9BgAAGQBqALAXL7AARViwBC8bsQQYPlmwAEVYsBAvG7EQED5ZsABFWLAILxuxCBA+WbIvFwFdsg8XAV2yFRAXERI5sBUvshIBCitYIdgb9FmwAdCyAhAEERI5sAQQsgwBCitYIdgb9FmwFRCwGNAwMQEhETYzIBMRIxEmJiMiBgcRIxEjNTM1MxUhAnz+53vFAVcDuQFpb1qIJrmqqrkBGQTS/uWX/n39NQLMdXBgTvz9BNKXl5cAAQAxAAAElwWwAA8ATACwAEVYsAovG7EKHD5ZsABFWLACLxuxAhA+WbIPCgIREjmwDy+yAAEKK1gh2Bv0WbAE0LAPELAG0LAKELIIAQorWCHYG/RZsAzQMDEBIxEjESM1MxEhNSEVIREzA6rnv9bW/i0EZv4s5wM3/MkDN5cBRJ6e/rwAAf/0/+wCcAVAAB0AcwCwAEVYsAEvG7EBGD5ZsABFWLARLxuxERA+WbABELAA0LAAL7ABELIEAQorWCHYG/RZsAEQsAXQsAUvsgAFAV2yCAEKK1gh2Bv0WbARELIMAQorWCHYG/RZsAgQsBXQsAUQsBjQsAQQsBnQsAEQsBzQMDEBETMVIxUzFSMRFBYzMjcVBiMiJjURIzUzNSM1MxEBh8rK6ek2QSA4SUV8ftraxcUFQP76j7qX/rJBQQyWFJaKAU6Xuo8BBv//ABwAAAUdBzQCJgAlAAABBwBEATABNgAUALAARViwBC8bsQQcPlmxDAj0MDH//wAcAAAFHQc0AiYAJQAAAQcAdQG/ATYAFACwAEVYsAUvG7EFHD5ZsQ0I9DAx//8AHAAABR0HNgImACUAAAEHAJ0AyQE2ABQAsABFWLAELxuxBBw+WbEPBvQwMf//ABwAAAUdByICJgAlAAABBwCkAMUBOgAUALAARViwBS8bsQUcPlmxDgT0MDH//wAcAAAFHQb7AiYAJQAAAQcAagD5ATYAFwCwAEVYsAQvG7EEHD5ZsREE9LAb0DAxAP//ABwAAAUdB5ECJgAlAAABBwCiAVABQQAXALAARViwBC8bsQQcPlmxDgb0sBjQMDEA//8AHAAABR0HlAImACUAAAAHAd8BWgEi//8Ad/5EBNgFxAImACcAAAAHAHkB0v/3//8AqQAABEYHQAImACkAAAEHAEQA+wFCABQAsABFWLAGLxuxBhw+WbENCPQwMf//AKkAAARGB0ACJgApAAABBwB1AYoBQgAUALAARViwBi8bsQYcPlmxDgj0MDH//wCpAAAERgdCAiYAKQAAAQcAnQCUAUIAFACwAEVYsAYvG7EGHD5ZsRAG9DAx//8AqQAABEYHBwImACkAAAEHAGoAxAFCABcAsABFWLAGLxuxBhw+WbESBPSwG9AwMQD////gAAABgQdAAiYALQAAAQcARP+nAUIAFACwAEVYsAIvG7ECHD5ZsQUI9DAx//8AsAAAAlEHQAImAC0AAAEHAHUANQFCABQAsABFWLADLxuxAxw+WbEGCPQwMf///+kAAAJGB0ICJgAtAAABBwCd/0ABQgAUALAARViwAi8bsQIcPlmxCAb0MDH////WAAACXwcHAiYALQAAAQcAav9wAUIAFwCwAEVYsAIvG7ECHD5ZsQoE9LAU0DAxAP//AKkAAAUIByICJgAyAAABBwCkAPsBOgAUALAARViwBi8bsQYcPlmxDQT0MDH//wB2/+wFCQc2AiYAMwAAAQcARAFSATgAFACwAEVYsA0vG7ENHD5ZsSEI9DAx//8Adv/sBQkHNgImADMAAAEHAHUB4QE4ABQAsABFWLANLxuxDRw+WbEiCPQwMf//AHb/7AUJBzgCJgAzAAABBwCdAOsBOAAUALAARViwDS8bsQ0cPlmxIgb0MDH//wB2/+wFCQckAiYAMwAAAQcApADnATwAFACwAEVYsA0vG7ENHD5ZsSME9DAx//8Adv/sBQkG/QImADMAAAEHAGoBGwE4ABcAsABFWLANLxuxDRw+WbEnBPSwMNAwMQD//wCM/+wEqgc0AiYAOQAAAQcARAErATYAFACwAEVYsAovG7EKHD5ZsRQI9DAx//8AjP/sBKoHNAImADkAAAEHAHUBugE2ABQAsABFWLASLxuxEhw+WbEVCPQwMf//AIz/7ASqBzYCJgA5AAABBwCdAMQBNgAUALAARViwCi8bsQocPlmxFwb0MDH//wCM/+wEqgb7AiYAOQAAAQcAagD0ATYAFwCwAEVYsAovG7EKHD5ZsRkE9LAj0DAxAP//AA8AAAS7BzQCJgA9AAABBwB1AYgBNgAUALAARViwAS8bsQEcPlmxCwj0MDH//wBt/+wD6gX+AiYARQAAAQcARADVAAAAFACwAEVYsBcvG7EXGD5ZsSoJ9DAx//8Abf/sA+oF/gImAEUAAAEHAHUBZAAAABQAsABFWLAXLxuxFxg+WbErCfQwMf//AG3/7APqBgACJgBFAAABBgCdbgAAFACwAEVYsBcvG7EXGD5ZsSsB9DAx//8Abf/sA+oF7AImAEUAAAEGAKRqBAAUALAARViwFy8bsRcYPlmxLAH0MDH//wBt/+wD6gXFAiYARQAAAQcAagCeAAAAFwCwAEVYsBcvG7EXGD5ZsTAB9LA50DAxAP//AG3/7APqBlsCJgBFAAABBwCiAPUACwAXALAARViwFy8bsRcYPlmxLAT0sDbQMDEA//8Abf/sA+oGXwImAEUAAAAHAd8A///t//8AXP5EA+wETgImAEcAAAAHAHkBP//3//8AXf/sA/MF/gImAEkAAAEHAEQAxQAAABQAsABFWLAILxuxCBg+WbEfCfQwMf//AF3/7APzBf4CJgBJAAABBwB1AVQAAAAUALAARViwCC8bsQgYPlmxIAn0MDH//wBd/+wD8wYAAiYASQAAAQYAnV4AABQAsABFWLAILxuxCBg+WbEgAfQwMf//AF3/7APzBcUCJgBJAAABBwBqAI4AAAAXALAARViwCC8bsQgYPlmxJQH0sC7QMDEA////xgAAAWcF/QImAIwAAAEGAESN/wAUALAARViwAi8bsQIYPlmxBQn0MDH//wCWAAACNwX9AiYAjAAAAQYAdRv/ABQAsABFWLADLxuxAxg+WbEGCfQwMf///88AAAIsBf8CJgCMAAABBwCd/yb//wAUALAARViwAi8bsQIYPlmxCAH0MDH///+8AAACRQXEAiYAjAAAAQcAav9W//8AFwCwAEVYsAIvG7ECGD5ZsQsB9LAU0DAxAP//AIwAAAPfBewCJgBSAAABBgCkYQQAFACwAEVYsAMvG7EDGD5ZsRUB9DAx//8AW//sBDQF/gImAFMAAAEHAEQAzwAAABQAsABFWLAELxuxBBg+WbEdCfQwMf//AFv/7AQ0Bf4CJgBTAAABBwB1AV4AAAAUALAARViwBC8bsQQYPlmxHgn0MDH//wBb/+wENAYAAiYAUwAAAQYAnWgAABQAsABFWLAELxuxBBg+WbEeAfQwMf//AFv/7AQ0BewCJgBTAAABBgCkZAQAFACwAEVYsAQvG7EEGD5ZsR8B9DAx//8AW//sBDQFxQImAFMAAAEHAGoAmAAAABcAsABFWLAELxuxBBg+WbEjAfSwLNAwMQD//wCI/+wD3AX+AiYAWQAAAQcARADHAAAAFACwAEVYsAcvG7EHGD5ZsRIJ9DAx//8AiP/sA9wF/gImAFkAAAEHAHUBVgAAABQAsABFWLANLxuxDRg+WbETCfQwMf//AIj/7APcBgACJgBZAAABBgCdYAAAFACwAEVYsAcvG7EHGD5ZsRUB9DAx//8AiP/sA9wFxQImAFkAAAEHAGoAkAAAABcAsABFWLAHLxuxBxg+WbEYAfSwIdAwMQD//wAW/ksDsAX+AiYAXQAAAQcAdQEbAAAAFACwAEVYsAEvG7EBGD5ZsRIJ9DAx//8AFv5LA7AFxQImAF0AAAEGAGpVAAAXALAARViwDy8bsQ8YPlmxFwH0sCDQMDEA//8AHAAABR0G7gImACUAAAEHAHAAxwE+ABMAsABFWLAELxuxBBw+WbAM3DAxAP//AG3/7APqBbgCJgBFAAABBgBwbAgAEwCwAEVYsBcvG7EXGD5ZsCrcMDEA//8AHAAABR0HDgImACUAAAEHAKAA9AE3ABMAsABFWLAELxuxBBw+WbAN3DAxAP//AG3/7APqBdgCJgBFAAABBwCgAJkAAQATALAARViwFy8bsRcYPlmwK9wwMQAAAgAc/k8FHQWwABYAGQBnALAARViwFi8bsRYcPlmwAEVYsBQvG7EUED5ZsABFWLABLxuxARA+WbAARViwDC8bsQwSPlmyBwMKK1gh2Bv0WbABELAR0LARL7IXFBYREjmwFy+yEwEKK1gh2Bv0WbIZFhQREjkwMQEBIwcGFRQzMjcXBiMiJjU0NwMhAyMBAyEDAvACLSY6cU4wNA1GWllnqYf9nonGAiyjAe/4BbD6UC1bVkgaeSxoVpBsAXP+hAWw/GoCqQAAAgBt/k8D6gROAC0ANwCQALAARViwFy8bsRcYPlmwAEVYsAQvG7EEED5ZsABFWLAeLxuxHhA+WbAARViwKS8bsSkSPlmwHhCwANCwAC+yAgQXERI5sgsXBBESObALL7AXELIPAQorWCHYG/RZshILFxESObApELIkAworWCHYG/RZsAQQsi4BCitYIdgb9FmwCxCyMwEKK1gh2Bv0WTAxJSYnBiMiJjU0JDMzNTQmIyIGFSM0NjYzMhYXERQXFSMHBhUUMzI3FwYjIiY1NCcyNjc1IyAVFBYDJA8HgbOgzQEB6bR0cWOGunPFdrvUBCYhOnFOMDQNRlpZZ4hXnCOR/qx0ByZFhrWLqbtVYXNkR1GXWLuk/g6VWBAtW1ZIGnksaFaQ8FpI3sdXYgD//wB3/+wE2AdVAiYAJwAAAQcAdQHGAVcAFACwAEVYsAsvG7ELHD5ZsR8I9DAx//8AXP/sA+wF/gImAEcAAAEHAHUBMwAAABQAsABFWLAQLxuxEBg+WbEgCfQwMf//AHf/7ATYB1cCJgAnAAABBwCdANABVwAUALAARViwCy8bsQscPlmxHwb0MDH//wBc/+wD7AYAAiYARwAAAQYAnT0AABQAsABFWLAQLxuxEBg+WbEgAfQwMf//AHf/7ATYBxkCJgAnAAABBwChAa4BVwAUALAARViwCy8bsQscPlmxIwT0MDH//wBc/+wD7AXCAiYARwAAAQcAoQEbAAAAFACwAEVYsBAvG7EQGD5ZsSQB9DAx//8Ad//sBNgHVwImACcAAAEHAJ4A5gFYABQAsABFWLALLxuxCxw+WbEhBvQwMf//AFz/7APsBgACJgBHAAABBgCeUwEAFACwAEVYsBAvG7EQGD5ZsSIB9DAx//8AqQAABMYHQgImACgAAAEHAJ4AnwFDABQAsABFWLABLxuxARw+WbEbBvQwMf//AF//7AUrBgIAJgBIAAABBwGiA9QFEwBIALLwHwFysh8fAV2ynx8BXbIfHwFxtM8f3x8CcbLfHwFysl8fAXKyTx8BcbLPHwFdtE8fXx8CXbJgHwFdsuAfAXGy4B8BXTAx//8AqQAABEYG+gImACkAAAEHAHAAkgFKABMAsABFWLAGLxuxBhw+WbAN3DAxAP//AF3/7APzBbgCJgBJAAABBgBwXAgAEwCwAEVYsAgvG7EIGD5ZsB/cMDEA//8AqQAABEYHGgImACkAAAEHAKAAvwFDABMAsABFWLAGLxuxBhw+WbAP3DAxAP//AF3/7APzBdgCJgBJAAABBwCgAIkAAQATALAARViwCC8bsQgYPlmwIdwwMQD//wCpAAAERgcEAiYAKQAAAQcAoQFyAUIAFACwAEVYsAYvG7EGHD5ZsRME9DAx//8AXf/sA/MFwgImAEkAAAEHAKEBPAAAABQAsABFWLAILxuxCBg+WbElAfQwMQABAKn+TwRGBbAAGwB2ALAARViwFi8bsRYcPlmwAEVYsBUvG7EVED5ZsABFWLAPLxuxDxI+WbAARViwBC8bsQQQPlmyGhUWERI5sBovsgEBCitYIdgb9FmwFRCyAgEKK1gh2Bv0WbAPELIKAworWCHYG/RZsBYQshkBCitYIdgb9FkwMQEhESEVIwcGFRQzMjcXBiMiJjU0NyERIRUhESED4P2JAt1JOnFOMDQNRlpZZ5v9XQOT/S0CdwKh/fydLVtWSBp5LGhWimkFsJ7+LAAAAgBd/mgD8wROACUALQB6ALAARViwGi8bsRoYPlmwAEVYsA0vG7ENEj5ZsABFWLASLxuxEhA+WbAE0LANELIIAworWCHYG/RZsioSGhESObAqL7S/Ks8qAl2yHgEKK1gh2Bv0WbASELIiAQorWCHYG/RZsiUSGhESObAaELImAQorWCHYG/RZMDElBgczBwYVFDMyNxcGIyImNTQ3JgA1NTQ2NjMyEhEVIRYWMzI2NwEiBgchNSYmA+VHcwE6cU4wNA1GWllnYtr+9XvdgdPq/SMEs4piiDP+wnCYEgIeCIi9bjYtW1ZIGnksaFZsWgQBIe8hof2P/ur+/U2gxVBCAqGjkw6NmwD//wCpAAAERgdCAiYAKQAAAQcAngCqAUMAFACwAEVYsAYvG7EGHD5ZsREG9DAx//8AXf/sA/MGAAImAEkAAAEGAJ50AQAUALAARViwCC8bsQgYPlmxIgH0MDH//wB6/+wE3AdXAiYAKwAAAQcAnQDIAVcAFACwAEVYsAsvG7ELHD5ZsSIG9DAx//8AYP5WA/IGAAImAEsAAAEGAJ1VAAAUALAARViwAy8bsQMYPlmxJwH0MDH//wB6/+wE3AcvAiYAKwAAAQcAoADzAVgAEwCwAEVYsAsvG7ELHD5ZsCLcMDEA//8AYP5WA/IF2AImAEsAAAEHAKAAgAABABMAsABFWLADLxuxAxg+WbAn3DAxAP//AHr/7ATcBxkCJgArAAABBwChAaYBVwAUALAARViwCy8bsQscPlmxJwT0MDH//wBg/lYD8gXCAiYASwAAAQcAoQEzAAAAFACwAEVYsAMvG7EDGD5ZsSwB9DAx//8Aev3/BNwFxAImACsAAAAHAaIBo/6g//8AYP5WA/IGkwImAEsAAAEHAbkBKwBYABMAsABFWLADLxuxAxg+WbAq3DAxAP//AKkAAAUIB0ICJgAsAAABBwCdAPEBQgAUALAARViwBy8bsQccPlmxEAb0MDH//wCMAAAD3wdBAiYATAAAAQcAnQAdAUEACQCwES+wFNwwMQD///+3AAACegcuAiYALQAAAQcApP88AUYAFACwAEVYsAMvG7EDHD5ZsQcE9DAx////nQAAAmAF6gImAIwAAAEHAKT/IgACABQAsABFWLADLxuxAxg+WbEHAfQwMf///7YAAAKABvoCJgAtAAABBwBw/z4BSgATALAARViwAi8bsQIcPlmwBdwwMQD///+cAAACZgW2AiYAjAAAAQcAcP8kAAYAEwCwAEVYsAIvG7ECGD5ZsAXcMDEA////7AAAAkMHGgImAC0AAAEHAKD/awFDABMAsABFWLACLxuxAhw+WbAH3DAxAP///9IAAAIpBdcCJgCMAAABBwCg/1EAAAATALAARViwAi8bsQIYPlmwB9wwMQD//wAY/lgBeAWwAiYALQAAAAYAo+YJ////+/5PAWgFxAImAE0AAAAGAKPJAP//AKoAAAGFBwQCJgAtAAABBwChAB0BQgAUALAARViwAi8bsQIcPlmxCwT0MDH//wC3/+wF+QWwACYALQAAAAcALgItAAD//wCN/ksDSgXEACYATQAAAAcATgHxAAD//wA1/+wEggc1AiYALgAAAQcAnQF8ATUAFACwAEVYsAAvG7EAHD5ZsRQG9DAx////tP5LAjkF2AImAJsAAAEHAJ3/M//YABQAsABFWLANLxuxDRg+WbESBPQwMf//AKn9/wUFBbACJgAvAAAABwGiAZT+oP//AI39/wQMBgACJgBPAAAABwGiARH+oP//AKEAAAQcBy8CJgAwAAABBwB1ACYBMQAUALAARViwBS8bsQUcPlmxCAj0MDH//wCTAAACNAeUAiYAUAAAAQcAdQAYAZYAFACwAEVYsAMvG7EDHj5ZsQYJ9DAx//8Aqf3/BBwFsAImADAAAAAHAaIBbP6g//8AV/3/AVUGAAImAFAAAAAHAaL/+/6g//8AqQAABBwFsQImADAAAAEHAaIB1QTCABAAsABFWLAKLxuxChw+WTAx//8AnAAAAq0GAgAmAFAAAAEHAaIBVgUTAFAAsh8IAV2ynwgBXbQfCC8IAnGyrwgBcbQvCD8IAnKy3wgBcrZfCG8IfwgDcrTPCN8IAnGyTwgBcbLPCAFdtE8IXwgCXbJgCAFdsvAIAXIwMf//AKkAAAQcBbACJgAwAAAABwChAbz9xf//AJwAAAKgBgAAJgBQAAAABwChATj9tv//AKkAAAUIBzQCJgAyAAABBwB1AfUBNgAUALAARViwCC8bsQgcPlmxDAj0MDH//wCMAAAD3wX+AiYAUgAAAQcAdQFbAAAAFACwAEVYsAMvG7EDGD5ZsRQJ9DAx//8Aqf3/BQgFsAImADIAAAAHAaIB0P6g//8AjP3/A98ETgImAFIAAAAHAaIBM/6g//8AqQAABQgHNgImADIAAAEHAJ4BFQE3ABQAsABFWLAGLxuxBhw+WbEPBvQwMf//AIwAAAPfBgACJgBSAAABBgCeewEAFACwAEVYsAMvG7EDGD5ZsRYB9DAx////vAAAA98GBAImAFIAAAEHAaL/YAUVAAYAsBcvMDH//wB2/+wFCQbwAiYAMwAAAQcAcADpAUAAEwCwAEVYsA0vG7ENHD5ZsCHcMDEA//8AW//sBDQFuAImAFMAAAEGAHBmCAATALAARViwBC8bsQQYPlmwHdwwMQD//wB2/+wFCQcQAiYAMwAAAQcAoAEWATkAEwCwAEVYsA0vG7ENHD5ZsCLcMDEA//8AW//sBDQF2AImAFMAAAEHAKAAkwABABMAsABFWLAELxuxBBg+WbAf3DAxAP//AHb/7AUJBzcCJgAzAAABBwClAWsBOAAXALAARViwDS8bsQ0cPlmxJgj0sCLQMDEA//8AW//sBDQF/wImAFMAAAEHAKUA6AAAABcAsABFWLAELxuxBBg+WbEiCfSwHtAwMQD//wCoAAAEyQc0AiYANgAAAQcAdQGAATYAFACwAEVYsAQvG7EEHD5ZsRoI9DAx//8AjAAAAtIF/gImAFYAAAEHAHUAtgAAABQAsABFWLALLxuxCxg+WbEQCfQwMf//AKj9/wTJBbACJgA2AAAABwGiAWP+oP//AFP9/wKXBE4CJgBWAAAABwGi//f+oP//AKgAAATJBzYCJgA2AAABBwCeAKABNwAUALAARViwBC8bsQQcPlmxHQb0MDH//wBjAAACzQYAAiYAVgAAAQYAntcBABQAsABFWLALLxuxCxg+WbESAfQwMf//AFD/7ARyBzYCJgA3AAABBwB1AY0BOAAUALAARViwBi8bsQYcPlmxKQj0MDH//wBf/+wDuwX+AiYAVwAAAQcAdQFRAAAAFACwAEVYsAkvG7EJGD5ZsSkJ9DAx//8AUP/sBHIHOAImADcAAAEHAJ0AlwE4ABQAsABFWLAGLxuxBhw+WbEpBvQwMf//AF//7AO7BgACJgBXAAABBgCdWwAAFACwAEVYsAkvG7EJGD5ZsSkB9DAx//8AUP5NBHIFxAImADcAAAAHAHkBnwAA//8AX/5FA7sETgImAFcAAAAHAHkBXf/4//8AUP3/BHIFxAImADcAAAAHAaIBdf6g//8AX/3/A7sETgImAFcAAAAHAaIBM/6g//8AUP/sBHIHOAImADcAAAEHAJ4ArQE5ABQAsABFWLAGLxuxBhw+WbErBvQwMf//AF//7AO7BgACJgBXAAABBgCecQEAFACwAEVYsAkvG7EJGD5ZsSsB9DAx//8AMf3/BJcFsAImADgAAAAHAaIBZv6g//8ACf3/AlYFQAImAFgAAAAHAaIAxf6g//8AMf5NBJcFsAImADgAAAAHAHkBkAAA//8ACf5NApkFQAImAFgAAAAHAHkA7wAA//8AMQAABJcHNgImADgAAAEHAJ4AogE3ABQAsABFWLAGLxuxBhw+WbENBvQwMf//AAn/7ALsBnkAJgBYAAAABwGiAZUFiv//AIz/7ASqByICJgA5AAABBwCkAMABOgAUALAARViwEi8bsRIcPlmxFgT0MDH//wCI/+wD3AXsAiYAWQAAAQYApFwEABQAsABFWLANLxuxDRg+WbEUAfQwMf//AIz/7ASqBu4CJgA5AAABBwBwAMIBPgATALAARViwEi8bsRIcPlmwE9wwMQD//wCI/+wD3AW4AiYAWQAAAQYAcF4IABMAsABFWLAHLxuxBxg+WbAS3DAxAP//AIz/7ASqBw4CJgA5AAABBwCgAO8BNwATALAARViwCi8bsQocPlmwFtwwMQD//wCI/+wD3AXYAiYAWQAAAQcAoACLAAEAEwCwAEVYsAcvG7EHGD5ZsBTcMDEA//8AjP/sBKoHkQImADkAAAEHAKIBSwFBABcAsABFWLAKLxuxChw+WbEWBvSwINAwMQD//wCI/+wD3AZbAiYAWQAAAQcAogDnAAsAFwCwAEVYsAcvG7EHGD5ZsRQE9LAe0DAxAP//AIz/7ASqBzUCJgA5AAABBwClAUQBNgAXALAARViwEi8bsRIcPlmxFQj0sBnQMDEA//8AiP/sBAwF/wImAFkAAAEHAKUA4AAAABcAsABFWLANLxuxDRg+WbETCfSwF9AwMQAAAQCM/nsEqgWwACAAUwCwAEVYsBgvG7EYHD5ZsABFWLANLxuxDRI+WbAARViwEy8bsRMQPlmwGBCwINCyBBMgERI5sA0QsggDCitYIdgb9FmwExCyHAEKK1gh2Bv0WTAxAREGBgcGFRQzMjcXBiMiJjU0NwciACcRMxEUFjMyNjURBKoBioObTjA0DUZaWWdPFu/+5AK+rqGjrQWw/CGU4jtyYEgaeSxoVmFTAQEC4gPg/Caer66eA9sAAQCI/k8D5gQ6AB8AbQCwAEVYsBcvG7EXGD5ZsABFWLAdLxuxHRg+WbAARViwHy8bsR8QPlmwAEVYsBIvG7ESED5ZsABFWLAKLxuxChI+WbIFAworWCHYG/RZsB8QsA/QsA8vshASHRESObASELIaAQorWCHYG/RZMDEhBwYVFDMyNxcGIyImNTQ3JwYjIiYnETMRFDMyNxEzEQPSOnFOMDQNRlpZZ6YEbNGttQG5yNRGuS1bVkgaeSxoVo9qZX/JxQLA/UX2ngMT+8b//wA9AAAG7Qc2AiYAOwAAAQcAnQHFATYAFACwAEVYsAMvG7EDHD5ZsRcG9DAx//8AKwAABdMGAAImAFsAAAEHAJ0BJAAAABQAsABFWLAMLxuxDBg+WbEPAfQwMf//AA8AAAS7BzYCJgA9AAABBwCdAJIBNgAUALAARViwAS8bsQEcPlmxCwb0MDH//wAW/ksDsAYAAiYAXQAAAQYAnSUAABQAsABFWLAPLxuxDxg+WbEUAfQwMf//AA8AAAS7BvsCJgA9AAABBwBqAMIBNgAXALAARViwCC8bsQgcPlmxEAT0sBnQMDEA//8AVgAABHoHNAImAD4AAAEHAHUBhwE2ABQAsABFWLAHLxuxBxw+WbEMCPQwMf//AFgAAAOzBf4CJgBeAAABBwB1ASEAAAAUALAARViwBy8bsQcYPlmxDAn0MDH//wBWAAAEegb4AiYAPgAAAQcAoQFvATYAFACwAEVYsAcvG7EHHD5ZsREE9DAx//8AWAAAA7MFwgImAF4AAAEHAKEBCQAAABQAsABFWLAHLxuxBxg+WbERAfQwMf//AFYAAAR6BzYCJgA+AAABBwCeAKcBNwAUALAARViwBy8bsQccPlmxDwb0MDH//wBYAAADswYAAiYAXgAAAQYAnkEBABQAsABFWLAHLxuxBxg+WbEPAfQwMf////IAAAdXB0ACJgCBAAABBwB1AskBQgAUALAARViwBi8bsQYcPlmxFQj0MDH//wBO/+wGfAX/AiYAhgAAAQcAdQJ6AAEAFACwAEVYsB0vG7EdGD5ZsUAJ9DAx//8Adv+jBR0HfgImAIMAAAEHAHUB6QGAABQAsABFWLAQLxuxEBw+WbEsCPQwMf//AFv/egQ0Bf4CJgCJAAABBwB1ATcAAAAUALAARViwBC8bsQQYPlmxKQn0MDH///++AAAEHwSNAiYBvQAAAQcB3v8v/3gALACyHxgBcbTfGO8YAnG0HxgvGAJdsh8YAXKyTxgBcbTvGP8YAl2yXxgBXTAx////vgAABB8EjQImAb0AAAEHAd7/L/94ADYAtO8X/xcCXbJPFwFxsh8XAXKy3xcBcrJvFwFytN8X7xcCcbIfFwFxsl8XAV20HxcvFwJdMDH//wAoAAAD/QSNAiYBzQAAAQYB3kXgAA0AsgMKAV2ysAoBXTAxAP//ABMAAARwBhwCJgG6AAABBwBEANUAHgAUALAARViwBC8bsQQaPlmxDAb0MDH//wATAAAEcAYcAiYBugAAAQcAdQFkAB4AFACwAEVYsAUvG7EFGj5ZsQ0G9DAx//8AEwAABHAGHgImAboAAAEGAJ1uHgAUALAARViwBC8bsQQaPlmxDwT0MDH//wATAAAEcAYKAiYBugAAAQYApGoiABQAsABFWLAFLxuxBRo+WbEOAvQwMf//ABMAAARwBeMCJgG6AAABBwBqAJ4AHgAXALAARViwBC8bsQQaPlmxEgL0sBvQMDEA//8AEwAABHAGeQImAboAAAEHAKIA9QApABcAsABFWLAELxuxBBo+WbEOBvSwGNAwMQD//wATAAAEcAZ8AiYBugAAAAcB3wD/AAr//wBg/koEMASdAiYBvAAAAAcAeQF0//3//wCKAAADrgYcAiYBvgAAAQcARACoAB4AFACwAEVYsAYvG7EGGj5ZsQ0G9DAx//8AigAAA64GHAImAb4AAAEHAHUBNwAeABQAsABFWLAHLxuxBxo+WbEOBvQwMf//AIoAAAOuBh4CJgG+AAABBgCdQR4AFACwAEVYsAYvG7EGGj5ZsRAE9DAx//8AigAAA64F4wImAb4AAAEGAGpxHgAXALAARViwBi8bsQYaPlmxEwL0sBzQMDEA////vgAAAV8GHAImAcIAAAEGAESFHgAUALAARViwAi8bsQIaPlmxBQb0MDH//wCOAAACLwYcAiYBwgAAAQYAdRMeABQAsABFWLADLxuxAxo+WbEGBvQwMf///8cAAAIkBh4CJgHCAAABBwCd/x4AHgAUALAARViwAi8bsQIaPlmxCAT0MDH///+0AAACPQXjAiYBwgAAAQcAav9OAB4AFwCwAEVYsAIvG7ECGj5ZsQsC9LAU0DAxAP//AIoAAARYBgoCJgHHAAABBwCkAJUAIgAUALAARViwBi8bsQYaPlmxDQL0MDH//wBg//AEWgYcAiYByAAAAQcARADuAB4AFACwAEVYsAovG7EKGj5ZsR0G9DAx//8AYP/wBFoGHAImAcgAAAEHAHUBfQAeABQAsABFWLAKLxuxCho+WbEeBvQwMf//AGD/8ARaBh4CJgHIAAABBwCdAIcAHgAUALAARViwCi8bsQoaPlmxIAT0MDH//wBg//AEWgYKAiYByAAAAQcApACDACIAFACwAEVYsAovG7EKGj5ZsR8C9DAx//8AYP/wBFoF4wImAcgAAAEHAGoAtwAeABcAsABFWLAKLxuxCho+WbEjAvSwLNAwMQD//wB0//AECgYcAiYBzgAAAQcARADPAB4AFACwAEVYsAkvG7EJGj5ZsRMG9DAx//8AdP/wBAoGHAImAc4AAAEHAHUBXgAeABQAsABFWLARLxuxERo+WbEUBvQwMf//AHT/8AQKBh4CJgHOAAABBgCdaB4AFACwAEVYsAkvG7EJGj5ZsRYE9DAx//8AdP/wBAoF4wImAc4AAAEHAGoAmAAeABcAsABFWLAJLxuxCRo+WbEZAvSwItAwMQD//wANAAAEHAYcAiYB0gAAAQcAdQEzAB4AFACwAEVYsAEvG7EBGj5ZsQsG9DAx//8AEwAABHAF1gImAboAAAEGAHBsJgATALAARViwBC8bsQQaPlmwDNwwMQD//wATAAAEcAX2AiYBugAAAQcAoACZAB8AFACwAEVYsAQvG7EEGj5ZsQ4I9DAxAAIAE/5PBHAEjQAWABkAZwCwAEVYsAAvG7EAGj5ZsABFWLAULxuxFBA+WbAARViwAS8bsQEQPlmwAEVYsAwvG7EMEj5ZsgcDCitYIdgb9FmwARCwEdCwES+yFxQAERI5sBcvshMBCitYIdgb9FmyGQAUERI5MDEBASMHBhUUMzI3FwYjIiY1NDcDIQMjAQMhAwKYAdgmOnFOMDQNRlpZZ7Bo/fhuvQHfeAGRxwSN+3MtW1ZIGnksaFaUbAEK/ukEjf0hAf0A//8AYP/wBDAGHAImAbwAAAEHAHUBaQAeABQAsABFWLALLxuxCxo+WbEfBvQwMf//AGD/8AQwBh4CJgG8AAABBgCdcx4AFACwAEVYsAsvG7ELGj5ZsSEE9DAx//8AYP/wBDAF4AImAbwAAAEHAKEBUQAeABQAsABFWLALLxuxCxo+WbEjAvQwMf//AGD/8AQwBh4CJgG8AAABBwCeAIkAHwAUALAARViwCy8bsQsaPlmxIQb0MDH//wCKAAAEHwYeAiYBvQAAAQYAnjIfABQAsABFWLABLxuxARo+WbEaBvQwMf//AIoAAAOuBdYCJgG+AAABBgBwPyYAEwCwAEVYsAYvG7EGGj5ZsA3cMDEA//8AigAAA64F9gImAb4AAAEGAKBsHwAUALAARViwBi8bsQYaPlmxDwj0MDH//wCKAAADrgXgAiYBvgAAAQcAoQEfAB4AFACwAEVYsAYvG7EGGj5ZsRMC9DAxAAEAiv5PA64EjQAbAHgAsABFWLAWLxuxFho+WbAARViwFC8bsRQQPlmwAEVYsA8vG7EPEj5ZsBQQsBvQsBsvsh8bAV2y3xsBXbIAAQorWCHYG/RZsBQQsgIBCitYIdgb9FmwFBCwBdCwDxCyCgMKK1gh2Bv0WbAWELIZAQorWCHYG/RZMDEBIREhFSMHBhUUMzI3FwYjIiY1NDchESEVIREhA1f97AJrPTpxTjA0DUZaWWeb/coDHv2bAhQCDv6Jly1bVkgaeSxoVoppBI2Z/rIA//8AigAAA64GHgImAb4AAAEGAJ5XHwAUALAARViwBi8bsQYaPlmxEQb0MDH//wBj//AENQYeAiYBwAAAAQYAnXEeABQAsABFWLAKLxuxCho+WbEgBPQwMf//AGP/8AQ1BfYCJgHAAAABBwCgAJwAHwAUALAARViwCi8bsQoaPlmxIAj0MDH//wBj//AENQXgAiYBwAAAAQcAoQFPAB4AFACwAEVYsAovG7EKGj5ZsSUC9DAx//8AY/38BDUEnQImAcAAAAAHAaIBT/6d//8AigAABFgGHgImAcEAAAEHAJ0AkAAeABQAsABFWLAHLxuxBxo+WbEQBPQwMf///5UAAAJYBgoCJgHCAAABBwCk/xoAIgAUALAARViwAy8bsQMaPlmxBwL0MDH///+UAAACXgXWAiYBwgAAAQcAcP8cACYAEwCwAEVYsAIvG7ECGj5ZsAXcMDEA////ygAAAiEF9gImAcIAAAEHAKD/SQAfABQAsABFWLACLxuxAho+WbEHCPQwMf//AAb+TwFmBI0CJgHCAAAABgCj1AD//wCJAAABZAXgAiYBwgAAAQYAofweABQAsABFWLACLxuxAho+WbELAvQwMf//ACv/8AQNBh4CJgHDAAABBwCdAQcAHgAUALAARViwAC8bsQAaPlmxFAT0MDH//wCK/fwEVwSNAiYBxAAAAAcBogEU/p3//wCCAAADiwYcAiYBxQAAAQYAdQceABQAsABFWLAFLxuxBRo+WbEIBvQwMf//AIr9/AOLBI0CJgHFAAAABwGiARD+nf//AIoAAAOLBI4CJgHFAAABBwGiAX4DnwAQALAARViwCi8bsQoaPlkwMf//AIoAAAOLBI0CJgHFAAAABwChAWb9N///AIoAAARYBhwCJgHHAAABBwB1AY8AHgAUALAARViwCC8bsQgaPlmxDAb0MDH//wCK/fwEWASNAiYBxwAAAAcBogFs/p3//wCKAAAEWAYeAiYBxwAAAQcAngCvAB8AFACwAEVYsAYvG7EGGj5ZsQ8G9DAx//8AYP/wBFoF1gImAcgAAAEHAHAAhQAmABMAsABFWLAKLxuxCho+WbAd3DAxAP//AGD/8ARaBfYCJgHIAAABBwCgALIAHwAUALAARViwCi8bsQoaPlmxHwj0MDH//wBg//AEWgYdAiYByAAAAQcApQEHAB4AFwCwAEVYsAovG7EKGj5ZsR4G9LAi0DAxAP//AIoAAAQlBhwCJgHLAAABBwB1AScAHgAUALAARViwBS8bsQUaPlmxGQb0MDH//wCK/fwEJQSNAiYBywAAAAcBogEN/p3//wCKAAAEJQYeAiYBywAAAQYAnkcfABQAsABFWLAELxuxBBo+WbEcBvQwMf//AEP/8APdBhwCJgHMAAABBwB1AT4AHgAUALAARViwCS8bsQkaPlmxKAb0MDH//wBD//AD3QYeAiYBzAAAAQYAnUgeABQAsABFWLAJLxuxCRo+WbEqBPQwMf//AEP+TQPdBJ0CJgHMAAAABwB5AVMAAP//AEP/8APdBh4CJgHMAAABBgCeXh8AFACwAEVYsAkvG7EJGj5ZsSoG9DAx//8AKP38A/0EjQImAc0AAAAHAaIBFP6d//8AKAAAA/0GHgImAc0AAAEGAJ5RHwAUALAARViwBi8bsQYaPlmxDQb0MDH//wAo/k8D/QSNAiYBzQAAAAcAeQE+AAL//wB0//AECgYKAiYBzgAAAQYApGQiABQAsABFWLARLxuxERo+WbEVAvQwMf//AHT/8AQKBdYCJgHOAAABBgBwZiYAEwCwAEVYsAkvG7EJGj5ZsBPcMDEA//8AdP/wBAoF9gImAc4AAAEHAKAAkwAfABQAsABFWLAJLxuxCRo+WbEVCPQwMf//AHT/8AQKBnkCJgHOAAABBwCiAO8AKQAXALAARViwCS8bsQkaPlmxFQb0sB/QMDEA//8AdP/wBBQGHQImAc4AAAEHAKUA6AAeABcAsABFWLARLxuxERo+WbEUBvSwGNAwMQAAAQB0/nQECgSNACAAUwCwAEVYsBgvG7EYGj5ZsABFWLAOLxuxDhI+WbAARViwEy8bsRMQPlmwGBCwINCyBRMgERI5sA4QsgkDCitYIdgb9FmwExCyHAEKK1gh2Bv0WTAxAREUBgcHBhUUMzI3FwYjIiY1NDciJicRMxEUFjMyNjURBAp4bzJsTjA0DUZaWWdazfkEt4+Fg48EjfzzerowKFtSSBp5LGhWaFbOuAMX/PR5gX97AwwA//8AMQAABfEGHgImAdAAAAEHAJ0BOwAeABQAsABFWLADLxuxAxo+WbEXBPQwMf//AA0AAAQcBh4CJgHSAAABBgCdPR4AFACwAEVYsAgvG7EIGj5ZsQ0E9DAx//8ADQAABBwF4wImAdIAAAEGAGptHgAXALAARViwCC8bsQgaPlmxEAL0sBnQMDEA//8ARwAAA+AGHAImAdMAAAEHAHUBMwAeABQAsABFWLAILxuxCBo+WbEMBvQwMf//AEcAAAPgBeACJgHTAAABBwChARsAHgAUALAARViwBy8bsQcaPlmxEQL0MDH//wBHAAAD4AYeAiYB0wAAAQYAnlMfABQAsABFWLAHLxuxBxo+WbEPBvQwMf//ABwAAAUdBj8CJgAlAAAABgCtBAD////wAAAEqgY/ACYAKWQAAAcArf85AAD////+AAAFbAZBACYALGQAAAcArf9HAAL//wAEAAAB2wZAACYALWQAAAcArf9NAAH////6/+wFHQY/ACYAMxQAAAcArf9DAAD///94AAAFHwY/ACYAPWQAAAcArf7BAAD////9AAAE3wY/ACYAuRQAAAcArf9GAAD///+b//QCrQZ0AiYAwgAAAQcArv8q/+wAHQCwAEVYsAwvG7EMGD5ZsRgB9LAP0LAYELAh0DAxAP//ABwAAAUdBbACBgAlAAD//wCpAAAEiAWwAgYAJgAA//8AqQAABEYFsAIGACkAAP//AFYAAAR6BbACBgA+AAD//wCpAAAFCAWwAgYALAAA//8AtwAAAXcFsAIGAC0AAP//AKkAAAUFBbACBgAvAAD//wCpAAAGUgWwAgYAMQAA//8AqQAABQgFsAIGADIAAP//AHb/7AUJBcQCBgAzAAD//wCpAAAEwAWwAgYANAAA//8AMQAABJcFsAIGADgAAP//AA8AAAS7BbACBgA9AAD//wA5AAAEzgWwAgYAPAAA////1gAAAl8HBwImAC0AAAEHAGr/cAFCABcAsABFWLACLxuxAhw+WbELBPSwFNAwMQD//wAPAAAEuwb7AiYAPQAAAQcAagDCATYAFwCwAEVYsAgvG7EIHD5ZsRAE9LAZ0DAxAP//AGT/6wR3BjoCJgC6AAABBwCtAXX/+wAUALAARViwEy8bsRMYPlmxJAH0MDH//wBj/+wD7AY5AiYAvgAAAQcArQEr//oAFACwAEVYsBUvG7EVGD5ZsSgB9DAx//8Akf5hA/AGOgImAMAAAAEHAK0BRv/7ABQAsABFWLADLxuxAxg+WbEVAfQwMf//AMP/9AJLBiUCJgDCAAABBgCtKuYAFACwAEVYsAwvG7EMGD5ZsQ8B9DAx//8Aj//sA/YGdAImAMoAAAEGAK4h7AAdALAARViwAC8bsQAYPlmxHQH0sBXQsB0QsCfQMDEA//8AmgAABD8EOgIGAI0AAP//AFv/7AQ0BE4CBgBTAAD//wCa/mAD7gQ6AgYAdgAA//8AIQAAA7oEOgIGAFoAAP//ACkAAAPKBDoCBgBcAAD////m//QCbwWxAiYAwgAAAQYAaoDsABcAsABFWLAMLxuxDBg+WbEUAfSwHdAwMQD//wCP/+wD9gWxAiYAygAAAQYAanfsABcAsABFWLAALxuxABg+WbEaAfSwI9AwMQD//wBb/+wENAY6AiYAUwAAAQcArQFD//sAFACwAEVYsAQvG7EEGD5ZsR4B9DAx//8Aj//sA/YGJQImAMoAAAEHAK0BIv/mABQAsABFWLAALxuxABg+WbEVAfQwMf//AHr/7AYZBiICJgDNAAABBwCtAlP/4wAUALAARViwAC8bsQAYPlmxJgH0MDH//wCpAAAERgcHAiYAKQAAAQcAagDEAUIAFwCwAEVYsAYvG7EGHD5ZsRME9LAc0DAxAP//ALEAAAQwB0ACJgCwAAABBwB1AZABQgAUALAARViwBC8bsQQcPlmxCAj0MDEAAQBQ/+wEcgXEACYAYbIAJygREjkAsABFWLAGLxuxBhw+WbAARViwGi8bsRoQPlmwBhCwC9CwBhCyDgEKK1gh2Bv0WbImGgYREjmwJhCyFAEKK1gh2Bv0WbAaELAf0LAaELIiAQorWCHYG/RZMDEBJiY1NCQzMhYWFSM0JiMiBhUUFgQWFhUUBCMiJCY1MxQWMzI2NCYCVvfhARPcluuBwaiZjp+XAWvNY/7s55b+/I3Bw6OYopYCiUfPmKzhdMx5hJd9b1l7Znukb7HVc8h/hJl81nUA//8AtwAAAXcFsAIGAC0AAP///9YAAAJfBwcCJgAtAAABBwBq/3ABQgAXALAARViwAi8bsQIcPlmxCwT0sBTQMDEA//8ANf/sA8wFsAIGAC4AAP//ALIAAAUdBbACBgHjAAD//wCpAAAFBQcuAiYALwAAAQcAdQF7ATAAFACwAEVYsAUvG7EFHD5ZsQ4I9DAx//8ATf/rBMsHGgImAN0AAAEHAKAA2gFDABMAsABFWLARLxuxERw+WbAV3DAxAP//ABwAAAUdBbACBgAlAAD//wCpAAAEiAWwAgYAJgAA//8AsQAABDAFsAIGALAAAP//AKkAAARGBbACBgApAAD//wCxAAAE/wcaAiYA2wAAAQcAoAExAUMAEwCwAEVYsAgvG7EIHD5ZsA3cMDEA//8AqQAABlIFsAIGADEAAP//AKkAAAUIBbACBgAsAAD//wB2/+wFCQXEAgYAMwAA//8AsgAABQEFsAIGALUAAP//AKkAAATABbACBgA0AAD//wB3/+wE2AXEAgYAJwAA//8AMQAABJcFsAIGADgAAP//ADkAAATOBbACBgA8AAD//wBt/+wD6gROAgYARQAA//8AXf/sA/METgIGAEkAAP//AJwAAAQBBcQCJgDvAAABBwCgAKL/7QATALAARViwCC8bsQgYPlmwDdwwMQD//wBb/+wENAROAgYAUwAA//8AjP5gBB4ETgIGAFQAAAABAFz/7APsBE4AHQBJshAeHxESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsAgQsAPQsBAQsBTQsBAQshcBCitYIdgb9FkwMSUyNjczDgIjIgARNTQ2NjMyFhcjJiYjIgYVFRQWAj5jlAivBXbFbt3++3TZlLbxCK8Ij2mNm5qDeFpdqGQBJwEAH572iNquaYfLwCO7ygD//wAW/ksDsAQ6AgYAXQAA//8AKQAAA8oEOgIGAFwAAP//AF3/7APzBcUCJgBJAAABBwBqAI4AAAAXALAARViwCC8bsQgYPlmxJQH0sC7QMDEA//8AmgAAA0cF6gImAOsAAAEHAHUAzf/sABQAsABFWLAELxuxBBg+WbEICfQwMf//AF//7AO7BE4CBgBXAAD//wCNAAABaAXEAgYATQAA////vAAAAkUFxAImAIwAAAEHAGr/Vv//ABcAsABFWLACLxuxAhg+WbELAfSwFNAwMQD///+//ksBWQXEAgYATgAA//8AnAAABD8F6QImAPAAAAEHAHUBO//rABQAsABFWLAELxuxBBg+WbEPCfQwMf//ABb+SwOwBdgCJgBdAAABBgCgUAEAEwCwAEVYsA8vG7EPGD5ZsBPcMDEA//8APQAABu0HNAImADsAAAEHAEQCLAE2ABQAsABFWLADLxuxAxw+WbEUCPQwMf//ACsAAAXTBf4CJgBbAAABBwBEAYsAAAAUALAARViwCy8bsQsYPlmxDgn0MDH//wA9AAAG7Qc0AiYAOwAAAQcAdQK7ATYAFACwAEVYsAQvG7EEHD5ZsRUI9DAx//8AKwAABdMF/gImAFsAAAEHAHUCGgAAABQAsABFWLAMLxuxDBg+WbEPCfQwMf//AD0AAAbtBvsCJgA7AAABBwBqAfUBNgAXALAARViwAy8bsQMcPlmxGgT0sCPQMDEA//8AKwAABdMFxQImAFsAAAEHAGoBVAAAABcAsABFWLALLxuxCxg+WbEUAfSwHdAwMQD//wAPAAAEuwc0AiYAPQAAAQcARAD5ATYAFACwAEVYsAgvG7EIHD5ZsQoI9DAx//8AFv5LA7AF/gImAF0AAAEHAEQAjAAAABQAsABFWLAPLxuxDxg+WbERCfQwMf//AGcEIQD9BgACBgALAAD//wCIBBICIwYAAgYABgAA//8AoP/1A4oFsAAmAAUAAAAHAAUCDwAA////tP5LAj8F2AImAJsAAAEHAJ7/Sf/ZABQAsABFWLANLxuxDRg+WbETAfQwMf//ADAEFgFHBgACBgFtAAD//wCpAAAGUgc0AiYAMQAAAQcAdQKZATYAFACwAEVYsAIvG7ECHD5ZsREI9DAx//8AiwAABngF/gImAFEAAAEHAHUCrQAAABQAsABFWLADLxuxAxg+WbEgCfQwMf//ABz+awUdBbACJgAlAAAABwCmAX8AAP//AG3+awPqBE4CJgBFAAAABwCmAMcAAP//AKkAAARGB0ACJgApAAABBwBEAPsBQgAUALAARViwBi8bsQYcPlmxDQj0MDH//wCxAAAE/wdAAiYA2wAAAQcARAFtAUIAFACwAEVYsAgvG7EIHD5ZsQsI9DAx//8AXf/sA/MF/gImAEkAAAEHAEQAxQAAABQAsABFWLAILxuxCBg+WbEfCfQwMf//AJwAAAQBBeoCJgDvAAABBwBEAN7/7AAUALAARViwCC8bsQgYPlmxCwn0MDH//wBaAAAFIQWwAgYAuAAA//8AX/4oBUMEOgIGAMwAAP//ABYAAATdBugCJgEYAAABBwCrBDkA+gAXALAARViwDy8bsQ8cPlmxEQj0sBXQMDEA////+wAABAsFwQImARkAAAEHAKsD1P/TABcAsABFWLARLxuxERg+WbETCfSwF9AwMQD//wBb/ksIQAROACYAUwAAAAcAXQSQAAD//wB2/ksJMAXEACYAMwAAAAcAXQWAAAD//wBQ/lEEagXEAiYA2gAAAAcBsAGc/7j//wBY/lIDrARNAiYA7gAAAAcBsAFD/7n//wB3/lEE2AXEAiYAJwAAAAcBsAHl/7j//wBc/lED7AROAiYARwAAAAcBsAFS/7j//wAPAAAEuwWwAgYAPQAA//8ALv5gA98EOgIGALwAAP//ALcAAAF3BbACBgAtAAD//wAbAAAHNQcaAiYA2QAAAQcAoAH4AUMAEwCwAEVYsA0vG7ENHD5ZsBncMDEA//8AFQAABgQFxAImAO0AAAEHAKABX//tABMAsABFWLANLxuxDRg+WbAZ3DAxAP//ALcAAAF3BbACBgAtAAD//wAcAAAFHQcOAiYAJQAAAQcAoAD0ATcAEwCwAEVYsAQvG7EEHD5ZsA7cMDEA//8Abf/sA+oF2AImAEUAAAEHAKAAmQABABMAsABFWLAXLxuxFxg+WbAs3DAxAP//ABwAAAUdBvsCJgAlAAABBwBqAPkBNgAUALAARViwBC8bsQQcPlmxEgT0MDH//wBt/+wD6gXFAiYARQAAAQcAagCeAAAAFwCwAEVYsBcvG7EXGD5ZsTAB9LA50DAxAP////IAAAdXBbACBgCBAAD//wBO/+wGfAROAgYAhgAA//8AqQAABEYHGgImACkAAAEHAKAAvwFDABMAsABFWLAGLxuxBhw+WbAP3DAxAP//AF3/7APzBdgCJgBJAAABBwCgAIkAAQATALAARViwCC8bsQgYPlmwIdwwMQD//wBd/+wFEgbZAiYBRQAAAQcAagDTARQAFwCwAEVYsAAvG7EAHD5ZsScE9LAw0DAxAP//AGL/7APpBE8CBgCcAAD//wBi/+wD6QXGAiYAnAAAAQcAagCHAAEAFwCwAEVYsAAvG7EAGD5ZsSQB9LAt0DAxAP//ABsAAAc1BwcCJgDZAAABBwBqAf0BQgAXALAARViwDS8bsQ0cPlmxHQT0sCbQMDEA//8AFQAABgQFsQImAO0AAAEHAGoBZP/sABcAsABFWLANLxuxDRg+WbEdAfSwJtAwMQD//wBQ/+wEagccAiYA2gAAAQcAagC3AVcAFwCwAEVYsAsvG7ELHD5ZsTAE9LA50DAxAP//AFj/7QOsBcUCJgDuAAABBgBqXgAAFwCwAEVYsAovG7EKGD5ZsS4B9LA30DAxAP//ALEAAAT/BvoCJgDbAAABBwBwAQQBSgATALAARViwCC8bsQgcPlmwC9wwMQD//wCcAAAEAQWkAiYA7wAAAQYAcHX0ABMAsABFWLAHLxuxBxg+WbAL3DAxAP//ALEAAAT/BwcCJgDbAAABBwBqATYBQgAXALAARViwCC8bsQgcPlmxEQT0sBrQMDEA//8AnAAABAEFsQImAO8AAAEHAGoAp//sABcAsABFWLAILxuxCBg+WbERAfSwGtAwMQD//wB2/+wFCQb9AiYAMwAAAQcAagEbATgAFwCwAEVYsA0vG7ENHD5ZsScE9LAw0DAxAP//AFv/7AQ0BcUCJgBTAAABBwBqAJgAAAAXALAARViwBC8bsQQYPlmxIwH0sCzQMDEA//8AZ//sBPoFxAIGARYAAP//AFv/7AQ0BE4CBgEXAAD//wBn/+wE+gcCAiYBFgAAAQcAagEOAT0AFwCwAEVYsA0vG7ENHD5ZsScE9LAw0DAxAP//AFv/7AQ0BccCJgEXAAABBwBqAIgAAgAXALAARViwBC8bsQQYPlmxJAH0sC3QMDEA//8Ak//sBPQHHQImAOYAAAEHAGoBDQFYABcAsABFWLATLxuxExw+WbEnBPSwMNAwMQD//wBk/+wD4AXFAiYA/gAAAQYAanwAABcAsABFWLAILxuxCBg+WbEnAfSwMNAwMQD//wBN/+sEywb6AiYA3QAAAQcAcACtAUoAEwCwAEVYsBEvG7ERHD5ZsBPcMDEA//8AFv5LA7AFuAImAF0AAAEGAHAjCAATALAARViwDi8bsQ4YPlmwEdwwMQD//wBN/+sEywcHAiYA3QAAAQcAagDfAUIAFwCwAEVYsBEvG7ERHD5ZsRkE9LAi0DAxAP//ABb+SwOwBcUCJgBdAAABBgBqVQAAFwCwAEVYsA8vG7EPGD5ZsRcB9LAg0DAxAP//AE3/6wTLB0ECJgDdAAABBwClAS8BQgAXALAARViwAS8bsQEcPlmxFAj0sBjQMDEA//8AFv5LA9EF/wImAF0AAAEHAKUApQAAABcAsABFWLAPLxuxDxg+WbEWCfSwEtAwMQD//wCWAAAEyAcHAiYA4AAAAQcAagEJAUIAFwCwAEVYsAsvG7ELHD5ZsRoE9LAj0DAxAP//AGcAAAO9BbECJgD4AAABBgBqZOwAFwCwAEVYsAkvG7EJGD5ZsRgB9LAh0DAxAP//ALIAAAYwBwcAJgDlDwAAJwAtBLkAAAEHAGoB0wFCABcAsABFWLAKLxuxChw+WbEfBPSwKNAwMQD//wCdAAAFfwWxACYA/QAAACcAjAQqAAABBwBqAW3/7AAXALAARViwCi8bsQoYPlmxHwH0sCjQMDEA//8AOf5LBQ4FsAImADwAAAAHAa8DpwAA//8AKf5LBBwEOgImAFwAAAAHAa8CtQAA//8AX//sA/AGAAIGAEgAAP//AC/+SwWsBbACJgDcAAAABwGvBEUAAP//ACz+SwS7BDoCJgDxAAAABwGvA1QAAP//ABz+ogUdBbACJgAlAAAABwCsBQIAAP//AG3+ogPqBE4CJgBFAAAABwCsBEoAAP//ABwAAAUdB7oCJgAlAAABBwCqBO4BRgAUALAARViwBC8bsQQcPlmxCwj0MDH//wBt/+wD6gaEAiYARQAAAQcAqgSTABAAFACwAEVYsBcvG7EXGD5ZsSkB9DAx//8AHAAABR0HwwImACUAAAEHAbcAwwEuABcAsABFWLAFLxuxBRw+WbEODPSwFNAwMQD//wBt/+wEwAaOAiYARQAAAQYBt2j5ABcAsABFWLAXLxuxFxg+WbEsCPSwMtAwMQD//wAcAAAFHQe/AiYAJQAAAQcBtgDHAT0AFwCwAEVYsAQvG7EEHD5ZsQ4M9LAT0DAxAP///8r/7APqBokCJgBFAAABBgG2bAcAFwCwAEVYsBcvG7EXGD5ZsSwI9LAx0DAxAP//ABwAAAUdB+oCJgAlAAABBwG1AMgBGwAXALAARViwBS8bsQUcPlmxDAz0sCDQMDEA//8Abf/sBFkGtQImAEUAAAEGAbVt5gAXALAARViwFy8bsRcYPlmxKgj0sDDQMDEA//8AHAAABR0H2gImACUAAAEHAbQAxwEGABcAsABFWLAFLxuxBRw+WbEMDPSwFdAwMQD//wBt/+wD6galAiYARQAAAQYBtGzRABcAsABFWLAXLxuxFxg+WbEqCPSwM9AwMQD//wAc/qIFHQc2AiYAJQAAACcAnQDJATYBBwCsBQIAAAAUALAARViwBC8bsQQcPlmxDwb0MDH//wBt/qID6gYAAiYARQAAACYAnW4AAQcArARKAAAAFACwAEVYsBcvG7EXGD5ZsS0B9DAx//8AHAAABR0HtwImACUAAAEHAbMA6gEtABcAsABFWLAELxuxBBw+WbEOB/SwG9AwMQD//wBt/+wD6gaCAiYARQAAAQcBswCP//gAFwCwAEVYsBcvG7EXGD5ZsSwE9LA50DAxAP//ABwAAAUdB7cCJgAlAAABBwG4AOoBLQAXALAARViwBC8bsQQcPlmxDgf0sBzQMDEA//8Abf/sA+oGggImAEUAAAEHAbgAj//4ABcAsABFWLAXLxuxFxg+WbEsBPSwOtAwMQD//wAcAAAFHQhAAiYAJQAAAQcBsgDuAT0AFwCwAEVYsAQvG7EEHD5ZsQ4H9LAn0DAxAP//AG3/7APqBwoCJgBFAAABBwGyAJMABwAXALAARViwFy8bsRcYPlmxLAT0sEXQMDEA//8AHAAABR0IFQImACUAAAEHAbEA7gFFABcAsABFWLAELxuxBBw+WbEOB/SwHNAwMQD//wBt/+wD6gbfAiYARQAAAQcBsQCTAA8AFwCwAEVYsBcvG7EXGD5ZsSwE9LA60DAxAP//ABz+ogUdBw4CJgAlAAAAJwCgAPQBNwEHAKwFAgAAABMAsABFWLAELxuxBBw+WbAO3DAxAP//AG3+ogPqBdgCJgBFAAAAJwCgAJkAAQEHAKwESgAAABMAsABFWLAXLxuxFxg+WbAs3DAxAP//AKn+ogRGBbACJgApAAAABwCsBMAAAP//AF3+ogPzBE4CJgBJAAAABwCsBIwAAP//AKkAAARGB8YCJgApAAABBwCqBLkBUgAUALAARViwBi8bsQYcPlmxDAj0MDH//wBd/+wD8waEAiYASQAAAQcAqgSDABAAFACwAEVYsAgvG7EIGD5ZsR4B9DAx//8AqQAABEYHLgImACkAAAEHAKQAkAFGABQAsABFWLAGLxuxBhw+WbEPBPQwMf//AF3/7APzBewCJgBJAAABBgCkWgQAFACwAEVYsAgvG7EIGD5ZsSEB9DAx//8AqQAABOYHzwImACkAAAEHAbcAjgE6ABcAsABFWLAHLxuxBxw+WbEPDPSwFdAwMQD//wBd/+wEsAaOAiYASQAAAQYBt1j5ABcAsABFWLAILxuxCBg+WbEhCPSwJ9AwMQD////wAAAERgfLAiYAKQAAAQcBtgCSAUkAFwCwAEVYsAYvG7EGHD5ZsQ8M9LAU0DAxAP///7r/7APzBokCJgBJAAABBgG2XAcAFwCwAEVYsAgvG7EIGD5ZsSEI9LAm0DAxAP//AKkAAAR/B/YCJgApAAABBwG1AJMBJwAXALAARViwBi8bsQYcPlmxDwz0sBPQMDEA//8AXf/sBEkGtQImAEkAAAEGAbVd5gAXALAARViwCC8bsQgYPlmxHwj0sCXQMDEA//8AqQAABEYH5gImACkAAAEHAbQAkgESABcAsABFWLAGLxuxBhw+WbEPDPSwFtAwMQD//wBd/+wD8walAiYASQAAAQYBtFzRABcAsABFWLAILxuxCBg+WbEhCPSwKNAwMQD//wCp/qIERgdCAiYAKQAAACcAnQCUAUIBBwCsBMAAAAAUALAARViwBi8bsQYcPlmxEAb0MDH//wBd/qID8wYAAiYASQAAACYAnV4AAQcArASMAAAAFACwAEVYsAgvG7EIGD5ZsSAB9DAx//8AtwAAAfgHxgImAC0AAAEHAKoDZAFSABQAsABFWLACLxuxAhw+WbEECPQwMf//AJsAAAHeBoICJgCMAAABBwCqA0oADgAUALAARViwAi8bsQIYPlmxBAH0MDH//wCj/qIBfgWwAiYALQAAAAcArANrAAD//wCF/qIBaAXEAiYATQAAAAcArANNAAD//wB2/qIFCQXEAiYAMwAAAAcArAUYAAD//wBb/qIENAROAiYAUwAAAAcArASdAAD//wB2/+wFCQe8AiYAMwAAAQcAqgUQAUgAFACwAEVYsA0vG7ENHD5ZsS4I9DAx//8AW//sBDQGhAImAFMAAAEHAKoEjQAQABQAsABFWLAELxuxBBg+WbEqAfQwMf//AHb/7AU9B8UCJgAzAAABBwG3AOUBMAAXALAARViwDS8bsQ0cPlmxIwz0sCnQMDEA//8AW//sBLoGjgImAFMAAAEGAbdi+QAXALAARViwBC8bsQQYPlmxHwj0sCXQMDEA//8AR//sBQkHwQImADMAAAEHAbYA6QE/ABcAsABFWLANLxuxDRw+WbEhDPSwKNAwMQD////E/+wENAaJAiYAUwAAAQYBtmYHABcAsABFWLAELxuxBBg+WbEdCPSwJNAwMQD//wB2/+wFCQfsAiYAMwAAAQcBtQDqAR0AFwCwAEVYsA0vG7ENHD5ZsSEM9LAn0DAxAP//AFv/7ARTBrUCJgBTAAABBgG1Z+YAFwCwAEVYsAQvG7EEGD5ZsR0I9LAj0DAxAP//AHb/7AUJB9wCJgAzAAABBwG0AOkBCAAXALAARViwDS8bsQ0cPlmxIQz0sCrQMDEA//8AW//sBDQGpQImAFMAAAEGAbRm0QAXALAARViwBC8bsQQYPlmxHQj0sCbQMDEA//8Adv6iBQkHOAImADMAAAAnAJ0A6wE4AQcArAUYAAAAFACwAEVYsA0vG7ENHD5ZsSIG9DAx//8AW/6iBDQGAAImAFMAAAAmAJ1oAAEHAKwEnQAAABQAsABFWLAELxuxBBg+WbEeAfQwMf//AGX/7AWdBy8CJgCXAAABBwB1Ad0BMQAUALAARViwDS8bsQ0cPlmxKAj0MDH//wBb/+wEugX+AiYAmAAAAQcAdQFlAAAAFACwAEVYsAQvG7EEGD5ZsSYJ9DAx//8AZf/sBZ0HLwImAJcAAAEHAEQBTgExABQAsABFWLANLxuxDRw+WbEnCPQwMf//AFv/7AS6Bf4CJgCYAAABBwBEANYAAAAUALAARViwBC8bsQQYPlmxJQn0MDH//wBl/+wFnQe1AiYAlwAAAQcAqgUMAUEAFACwAEVYsA0vG7ENHD5ZsTQI9DAx//8AW//sBLoGhAImAJgAAAEHAKoElAAQABQAsABFWLAELxuxBBg+WbEyAfQwMf//AGX/7AWdBx0CJgCXAAABBwCkAOMBNQAUALAARViwDS8bsQ0cPlmxKQT0MDH//wBb/+wEugXsAiYAmAAAAQYApGsEABQAsABFWLAELxuxBBg+WbEnAfQwMf//AGX+ogWdBjcCJgCXAAAABwCsBQkAAP//AFv+ogS6BLACJgCYAAAABwCsBJsAAP//AIz+ogSqBbACJgA5AAAABwCsBO4AAP//AIj+ogPcBDoCJgBZAAAABwCsBFEAAP//AIz/7ASqB7oCJgA5AAABBwCqBOkBRgAUALAARViwCi8bsQocPlmxEwj0MDH//wCI/+wD3AaEAiYAWQAAAQcAqgSFABAAFACwAEVYsAcvG7EHGD5ZsREB9DAx//8AjP/sBh0HQAImAJkAAAEHAHUB1AFCABQAsABFWLAaLxuxGhw+WbEdCPQwMf//AIj/7AUPBeoCJgCaAAABBwB1AWP/7AAUALAARViwEy8bsRMYPlmxHAn0MDH//wCM/+wGHQdAAiYAmQAAAQcARAFFAUIAFACwAEVYsBIvG7ESHD5ZsRwI9DAx//8AiP/sBQ8F6gImAJoAAAEHAEQA1P/sABQAsABFWLANLxuxDRg+WbEbCfQwMf//AIz/7AYdB8YCJgCZAAABBwCqBQMBUgAUALAARViwGi8bsRocPlmxKQj0MDH//wCI/+wFDwZwAiYAmgAAAQcAqgSS//wAFACwAEVYsBMvG7ETGD5ZsSgB9DAx//8AjP/sBh0HLgImAJkAAAEHAKQA2gFGABQAsABFWLASLxuxEhw+WbEeBPQwMf//AIj/7AUPBdgCJgCaAAABBgCkafAAFACwAEVYsBMvG7ETGD5ZsR0B9DAx//8AjP6iBh0GAgImAJkAAAAHAKwFCQAA//8AiP6iBQ8EkAImAJoAAAAHAKwEVwAA//8AD/6iBLsFsAImAD0AAAAHAKwEuwAA//8AFv4FA7AEOgImAF0AAAAHAKwFHP9j//8ADwAABLsHugImAD0AAAEHAKoEtwFGABQAsABFWLAILxuxCBw+WbEJCPQwMf//ABb+SwOwBoQCJgBdAAABBwCqBEoAEAAUALAARViwDy8bsQ8YPlmxEAH0MDH//wAPAAAEuwciAiYAPQAAAQcApACOAToAFACwAEVYsAEvG7EBHD5ZsQwE9DAx//8AFv5LA7AF7AImAF0AAAEGAKQhBAAUALAARViwAS8bsQEYPlmxEwH0MDEAAgBf/+wErAYAABcAIgB/ALAUL7AARViwDS8bsQ0YPlmwAEVYsAMvG7EDED5ZsABFWLAGLxuxBhA+WbIPFAFdsi8UAV2yEwMUERI5sBMvshABCitYIdgb9FmwAdCyBAYNERI5sg8NBhESObATELAW0LAGELIbAQorWCHYG/RZsA0QsiABCitYIdgb9FkwMQEjESMnBiMiAjU1NBIzMhcRITUhNTMVMwEUFjMyNxEmIyIGBKy8qglvxrzt7L++b/75AQe5vPxsmIawUVOsiJgE0vsudIgBNPgO+QEvggEGl5eX/Ki40J4B8ZnSAP//AF/+zQSsBgAAJgBIAAAAJwHeAaECRwEHAEMAn/9kAAgAsi8eAV0wMf//ALL+mAVEBbACJgHjAAAABwGwBCP/////AJz+mQSBBDoCJgDwAAAABwGwA2AAAP//AKn+mQWpBbACJgAsAAAABwGwBIgAAP//AJz+mQSiBDoCJgDzAAAABwGwA4EAAP//ADH+mQSXBbACJgA4AAAABwGwAj8AAP//ACj+mQOwBDoCJgD1AAAABwGwAcYAAP//ADn+mQT4BbACJgA8AAAABwGwA9cAAP//ACn+mQQGBDoCJgBcAAAABwGwAuUAAP//AJb+mQVmBbACJgDgAAAABwGwBEUAAP//AGf+mQReBDsCJgD4AAAABwGwAz0AAP//AJb+mQTIBbACJgDgAAAABwGwAv4AAP//AGf+mQO9BDsCJgD4AAAABwGwAfUAAP//ALH+mQQwBbACJgCwAAAABwGwAO8AAP//AJr+mQNHBDoCJgDrAAAABwGwANUAAP//ABv+mQeCBbACJgDZAAAABwGwBmEAAP//ABX+mQY9BDoCJgDtAAAABwGwBRwAAP//AD/+VQW9BcMCJgE/AAAABwGwAwb/vP///97+WQRjBE4CJgFAAAAABwGwAgH/wP//AIwAAAPfBgACBgBMAAAAAv/UAAAEsQWwABIAGwBhALAARViwDy8bsQ8cPlmwAEVYsAovG7EKED5ZsgIKDxESObACL7IODwIREjmwDi+yCwEKK1gh2Bv0WbAB0LAOELAR0LACELITAQorWCHYG/RZsAoQshQBCitYIdgb9FkwMQEjFSEWBBUUBAchESM1MzUzFTMDESEyNjU0JicCUO0BauQBAP7+3/3Tz8/A7e0BX4+fmY0EUPID5MTF6gQEUJfJyf3Z/d2YgHuOAgAC/9QAAASxBbAAEgAbAGEAsABFWLAQLxuxEBw+WbAARViwCi8bsQoQPlmyAgoQERI5sAIvshECEBESObARL7IBAQorWCHYG/RZsAvQsBEQsA7QsAIQshMBCitYIdgb9FmwChCyFAEKK1gh2Bv0WTAxASMVIRYEFRQEByERIzUzNTMVMwMRITI2NTQmJwJQ7QFq5AEA/v7f/dPPz8Dt7QFfj5+ZjQRQ8gPkxMXqBARQl8nJ/dn93ZiAe44CAAEAAwAABDAFsAANAE4AsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsnoNAV2yAAEKK1gh2Bv0WbAE0LANELAG0LAIELIKAQorWCHYG/RZMDEBIREjESM1MxEhFSERIQJ//vPBrq4Df/1CAQ0CrP1UAqyXAm2e/jEAAAH//AAAA0cEOgANAEkAsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASERIxEjNTMRIRUhESECeP7cup6eAq3+DQEkAd/+IQHflwHEmf7VAAEACwAABTEFsAAUAH4AsABFWLAILxuxCBw+WbAARViwEC8bsRAcPlmwAEVYsAIvG7ECED5ZsABFWLATLxuxExA+WbIOCAIREjmwDi+yLw4BXbLPDgFdsgEBCitYIdgb9FmyBwgCERI5sAcvsgQBCitYIdgb9FmwBxCwCtCwBBCwDNCyEgEOERI5MDEBIxEjESM1MzUzFSEVIREzATMBASMCN7HAu7vAAQH+/5YB/e/91AJV6wKO/XIEN5fi4pf+9wKC/T79EgAAAf/TAAAEKAYAABQAdACwAEVYsAgvG7EIHj5ZsABFWLAQLxuxEBg+WbAARViwAi8bsQIQPlmwAEVYsBMvG7ETED5Zsg4QAhESObAOL7IBAQorWCHYG/RZsgcIEBESObAHL7IEAQorWCHYG/RZsAcQsArQsAQQsAzQshIBDhESOTAxASMRIxEjNTM1MxUzFSMRMwEzAQEjAeCAutPTuu/vfgE72/6GAa7bAfX+CwTBl6iol/3NAaz+E/2zAP//ALH+mwWyBxoCJgDbAAAAJwCgATEBQwEHABAEfv+9ABMAsABFWLAILxuxCBw+WbAN3DAxAP//AJz+mwS1BcQCJgDvAAAAJwCgAKL/7QEHABADgf+9ABMAsABFWLAILxuxCBg+WbAN3DAxAP//AKn+mwW7BbACJgAsAAAABwAQBIf/vf//AJz+mwS0BDoCJgDzAAAABwAQA4D/vf//AKn+mwb4BbACJgAxAAAABwAQBcT/vf//AJ3+mwYGBDoCJgDyAAAABwAQBNL/vf//AC/+mwWoBbACJgDcAAAABwAQBHT/vf//ACz+mwS3BDoCJgDxAAAABwAQA4P/vQABAA8AAAS7BbAADgBWsgoPEBESOQCwAEVYsAgvG7EIHD5ZsABFWLALLxuxCxw+WbAARViwAi8bsQIQPlmyBggCERI5sAYvsgUBCitYIdgb9FmwANCyCggCERI5sAYQsA7QMDEBIxEjESM1MwEzAQEzATMDpuHA25T+UdwBegF82v5RmgIJ/fcCCZcDEP0lAtv88AAAAQAu/mAD3wQ6AA4AY7IKDxAREjkAsABFWLAILxuxCBg+WbAARViwCy8bsQsYPlmwAEVYsAIvG7ECEj5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmyBgEKK1gh2Bv0WbIKCwAREjmwDdCwDtAwMQUjESMRIzUzATMBATMBMwNK5rrcv/6hvQEfARi9/qPIC/5rAZWXA6782gMm/FIAAAEAOQAABM4FsAARAGMAsABFWLALLxuxCxw+WbAARViwDi8bsQ4cPlmwAEVYsAIvG7ECED5ZsABFWLAFLxuxBRA+WbIRCwIREjmwES+yAAEKK1gh2Bv0WbIECwIREjmwB9CwERCwCdCyDQsCERI5MDEBIwEjAQEjASM1MwEzAQEzATMDxKQBruT+mv6Y4wGvoJH+a+EBXwFd4v5rlgKe/WICOP3IAp6XAnv90gIu/YUAAQApAAADygQ6ABEAYwCwAEVYsAsvG7ELGD5ZsABFWLAOLxuxDhg+WbAARViwAi8bsQIQPlmwAEVYsAUvG7EFED5ZshEOAhESObARL7IAAQorWCHYG/RZsgQOAhESObAH0LARELAJ0LINDgIREjkwMQEjASMDAyMBIzUzATMTEzMBMwM8swFB1vr61wFBqp7+1tbt8Nj+1qcB4f4fAZX+awHhlwHC/nUBi/4+//8AY//sA+wETQIGAL4AAP//ABIAAAQvBbACJgAqAAAABwHe/4P+f///AJACiwXJAyIARgGXhABmZkAA//8AXQAABDMFxAIGABYAAP//AF7/7AP5BcQCBgAXAAD//wA1AAAEUAWwAgYAGAAA//8Amv/sBC0FsAIGABkAAP//AGT//wP4BcQABgAdAAD//wCH/+wEHgXEAAYAFBQA//8Aev/sBNwHVQImACsAAAEHAHUBvgFXABQAsABFWLALLxuxCxw+WbEiCPQwMf//AGD+VgPyBf4CJgBLAAABBwB1AUsAAAAUALAARViwAy8bsQMYPlmxJwn0MDH//wCpAAAFCAc0AiYAMgAAAQcARAFmATYAFACwAEVYsAYvG7EGHD5ZsQsI9DAx//8AjAAAA98F/gImAFIAAAEHAEQAzAAAABQAsABFWLADLxuxAxg+WbETCfQwMf//ABwAAAUdByACJgAlAAABBwCrBG0BMgAXALAARViwBC8bsQQcPlmxDAj0sBDQMDEA//8AOf/sA+oF6wImAEUAAAEHAKsEEv/9ABcAsABFWLAXLxuxFxg+WbEqCfSwLtAwMQD//wBfAAAERgcsAiYAKQAAAQcAqwQ4AT4AFwCwAEVYsAYvG7EGHD5ZsQ0I9LAR0DAxAP//ACn/7APzBesCJgBJAAABBwCrBAL//QAXALAARViwCC8bsQgYPlmxHwn0sCPQMDEA////CgAAAeoHLAImAC0AAAEHAKsC4wE+ABcAsABFWLACLxuxAhw+WbEFCPSwCdAwMQD///7wAAAB0AXpAiYAjAAAAQcAqwLJ//sAFwCwAEVYsAIvG7ECGD5ZsQUJ9LAJ0DAxAP//AHb/7AUJByICJgAzAAABBwCrBI8BNAAXALAARViwDS8bsQ0cPlmxIQj0sCXQMDEA//8AM//sBDQF6wImAFMAAAEHAKsEDP/9ABcAsABFWLAELxuxBBg+WbEdCfSwIdAwMQD//wBVAAAEyQcgAiYANgAAAQcAqwQuATIAFwCwAEVYsAQvG7EEHD5ZsRkI9LAd0DAxAP///4sAAAKXBesCJgBWAAABBwCrA2T//QAXALAARViwCy8bsQsYPlmxDwn0sBPQMDEA//8AjP/sBKoHIAImADkAAAEHAKsEaAEyABcAsABFWLAJLxuxCRw+WbEUCPSwGNAwMQD//wAr/+wD3AXrAiYAWQAAAQcAqwQE//0AFwCwAEVYsAcvG7EHGD5ZsRIJ9LAW0DAxAP///zoAAATSBj8AJgDPZAAABwCt/oMAAP//AKn+ogSIBbACJgAmAAAABwCsBLoAAP//AIz+ogQgBgACJgBGAAAABwCsBKsAAP//AKn+ogTGBbACJgAoAAAABwCsBLkAAP//AF/+ogPwBgACJgBIAAAABwCsBL0AAP//AKn9/wTGBbACJgAoAAAABwGiAWX+oP//AF/9/wPwBgACJgBIAAAABwGiAWn+oP//AKn+ogUIBbACJgAsAAAABwCsBR8AAP//AIz+ogPfBgACJgBMAAAABwCsBKEAAP//AKkAAAUFBy4CJgAvAAABBwB1AXsBMAAUALAARViwBS8bsQUcPlmxDgj0MDH//wCNAAAEDAc/AiYATwAAAQcAdQFEAUEACQCwBS+wD9wwMQD//wCp/qIFBQWwAiYALwAAAAcArAToAAD//wCN/qIEDAYAAiYATwAAAAcArARlAAD//wCp/qIEHAWwAiYAMAAAAAcArATAAAD//wCG/qIBYQYAAiYAUAAAAAcArANOAAD//wCp/qIGUgWwAiYAMQAAAAcArAXSAAD//wCL/qIGeAROAiYAUQAAAAcArAXWAAD//wCp/qIFCAWwAiYAMgAAAAcArAUkAAD//wCM/qID3wROAiYAUgAAAAcArASHAAD//wCpAAAEwAdAAiYANAAAAQcAdQF8AUIAFACwAEVYsAMvG7EDHD5ZsRYI9DAx//8AjP5gBB4F9QImAFQAAAEHAHUBk//3ABQAsABFWLAMLxuxDBg+WbEdCfQwMf//AKj+ogTJBbACJgA2AAAABwCsBLcAAP//AIL+ogKXBE4CJgBWAAAABwCsA0oAAP//AFD+ogRyBcQCJgA3AAAABwCsBMkAAP//AF/+ogO7BE4CJgBXAAAABwCsBIcAAP//ADH+ogSXBbACJgA4AAAABwCsBLoAAP//AAn+ogJWBUACJgBYAAAABwCsBBkAAP//ABwAAAT9By4CJgA6AAABBwCkALQBRgAUALAARViwBi8bsQYcPlmxCgT0MDH//wAhAAADugXjAiYAWgAAAQYApB37ABQAsABFWLABLxuxARg+WbEKAfQwMf//ABz+ogT9BbACJgA6AAAABwCsBOQAAP//ACH+ogO6BDoCJgBaAAAABwCsBE0AAP//AD3+ogbtBbACJgA7AAAABwCsBe8AAP//ACv+ogXTBDoCJgBbAAAABwCsBVMAAP//AFb+ogR6BbACJgA+AAAABwCsBLoAAP//AFj+ogOzBDoCJgBeAAAABwCsBGIAAP///nj/7AVPBdYAJgAzRgAABwFa/gkAAP//ABMAAARwBRwCJgG6AAAABwCt/9z+3f///58AAAPqBR8AJgG+PAAABwCt/uj+4P///7wAAASUBRwAJgHBPAAABwCt/wX+3f///8AAAAGNBR4AJgHCPAAABwCt/wn+3////9//8ARkBRwAJgHICgAABwCt/yj+3f///1cAAARYBRwAJgHSPAAABwCt/qD+3f////gAAASIBRsAJgHzCgAABwCt/0H+3P//ABMAAARwBI0CBgG6AAD//wCKAAAD7wSNAgYBuwAA//8AigAAA64EjQIGAb4AAP//AEcAAAPgBI0CBgHTAAD//wCKAAAEWASNAgYBwQAA//8AlwAAAVEEjQIGAcIAAP//AIoAAARXBI0CBgHEAAD//wCKAAAFdwSNAgYBxgAA//8AYP/wBFoEnQIGAcgAAP//AIoAAAQbBI0CBgHJAAD//wAoAAAD/QSNAgYBzQAA//8ADQAABBwEjQIGAdIAAP//ACYAAAQxBI0CBgHRAAD///+0AAACPQXjAiYBwgAAAQcAav9OAB4AFwCwAEVYsAIvG7ECGj5ZsQsC9LAU0DAxAP//AA0AAAQcBeMCJgHSAAABBgBqbR4AFwCwAEVYsAgvG7EIGj5ZsRAC9LAZ0DAxAP//AIoAAAOuBeMCJgG+AAABBgBqcR4AFwCwAEVYsAYvG7EGGj5ZsRMC9LAc0DAxAP//AIoAAAOFBhwCJgHqAAABBwB1ATQAHgAUALAARViwBC8bsQQaPlmxCAb0MDH//wBD//AD3QSdAgYBzAAA//8AlwAAAVEEjQIGAcIAAP///7QAAAI9BeMCJgHCAAABBwBq/04AHgAXALAARViwAi8bsQIaPlmxCwL0sBTQMDEA//8AK//wA00EjQIGAcMAAP//AIoAAARXBhwCJgHEAAABBwB1ASUAHgAUALAARViwBS8bsQUaPlmxDwb0MDH//wAi/+wECwX2AiYCAQAAAQYAoGcfABQAsABFWLACLxuxAho+WbEUCPQwMf//ABMAAARwBI0CBgG6AAD//wCKAAAD7wSNAgYBuwAA//8AigAAA4UEjQIGAeoAAP//AIoAAAOuBI0CBgG+AAD//wCKAAAEYQX2AiYB/gAAAQcAoADJAB8AFACwAEVYsAgvG7EIGj5ZsQ0I9DAx//8AigAABXcEjQIGAcYAAP//AIoAAARYBI0CBgHBAAD//wBg//AEWgSdAgYByAAA//8AigAABEQEjQIGAe8AAP//AIoAAAQbBI0CBgHJAAD//wBg//AEMASdAgYBvAAA//8AKAAAA/0EjQIGAc0AAP//ACYAAAQxBI0CBgHRAAAAAQBH/lAD1ASdACkAmgCwAEVYsAovG7EKGj5ZsABFWLAZLxuxGRA+WbAARViwGC8bsRgSPlmwChCyAwEKK1gh2Bv0WbIGChkREjmyJxkKERI5fLAnLxiy8CcBXbIAJwFxsqAnAV20YCdwJwJdsjAnAXG0YCdwJwJxsiYBCitYIdgb9FmyECYnERI5sBkQsBbQsh0ZChESObAZELIgAQorWCHYG/RZMDEBNCYjIgYVIzQ2MzIWFRQGBxYWFRQGBxEjESYmNTMWFjMyNjU0JSM1MzYDCIp9boG67bzT7m5ndnHLr7qjtrkFg3mIkv7/nZzvA1BUXVhPjrWollaNKSSSW4yvEv5bAacUrYhWYGBYwQWYBQAAAQCK/pkE+gSNAA8AXQCwAS+wAEVYsAkvG7EJGj5ZsABFWLADLxuxAxA+WbAARViwBi8bsQYQPlmyCwMJERI5fLALLxiyoAsBXbIEAQorWCHYG/RZsAkQsAzQsAMQsg4BCitYIdgb9FkwMQEjESMRIREjETMRIREzETME+rqh/aS5uQJcuaL+mQFnAfL+DgSN/f0CA/wMAAABAGD+VgQwBJ0AHwBYALAARViwDi8bsQ4aPlmwAEVYsAMvG7EDED5ZsABFWLAFLxuxBRI+WbADELAG0LAOELAS0LAOELIVAQorWCHYG/RZsAMQshwBCitYIdgb9FmwAxCwH9AwMQEGBgcRIxEmAjU1NDY2MzIWFyMmJiMiBgcVFBYzMjY3BDAUy6m6t9d755jM9xO5Eo1+macBn5eHjRQBeajHFP5gAaIeAR7jYaT5iNO7gnTLvWq9z2+D//8ADQAABBwEjQIGAdIAAP//AAL+UQVrBJ0CJgIXAAAABwGwArz/uP//AIoAAARhBdYCJgH+AAABBwBwAJwAJgATALAARViwCC8bsQgaPlmwC9wwMQD//wAi/+wECwXWAiYCAQAAAQYAcDomABMAsABFWLARLxuxERo+WbAT3DAxAP//AGAAAAUGBI0CBgHxAAD//wAc/k8FHQWwAiYAJQAAAAcAowF8AAD//wBt/k8D6gROAiYARQAAAAcAowDEAAD//wCp/lkERgWwAiYAKQAAAAcAowE6AAr//wBd/k8D8wROAiYASQAAAAcAowEGAAAAAAAAAA0AogADAAEECQAAAF4AAAADAAEECQABAAwAXgADAAEECQACAA4AagADAAEECQADAAwAXgADAAEECQAEAAwAXgADAAEECQAFACwAeAADAAEECQAGABwApAADAAEECQAHAEAAwAADAAEECQAJAAwBAAADAAEECQALABQBDAADAAEECQAMACYBIAADAAEECQANAFwBRgADAAEECQAOAFQBogBDAG8AcAB5AHIAaQBnAGgAdAAgADIAMAAxADEAIABHAG8AbwBnAGwAZQAgAEkAbgBjAC4AIABBAGwAbAAgAFIAaQBnAGgAdABzACAAUgBlAHMAZQByAHYAZQBkAC4AUgBvAGIAbwB0AG8AUgBlAGcAdQBsAGEAcgBWAGUAcgBzAGkAbwBuACAAMgAuADAAMAAxADEAMAAxADsAIAAyADAAMQA0AFIAbwBiAG8AdABvAC0AUgBlAGcAdQBsAGEAcgBSAG8AYgBvAHQAbwAgAGkAcwAgAGEAIAB0AHIAYQBkAGUAbQBhAHIAawAgAG8AZgAgAEcAbwBvAGcAbABlAC4ARwBvAG8AZwBsAGUARwBvAG8AZwBsAGUALgBjAG8AbQBDAGgAcgBpAHMAdABpAGEAbgAgAFIAbwBiAGUAcgB0AHMAbwBuAEwAaQBjAGUAbgBzAGUAZAAgAHUAbgBkAGUAcgAgAHQAaABlACAAQQBwAGEAYwBoAGUAIABMAGkAYwBlAG4AcwBlACwAIABWAGUAcgBzAGkAbwBuACAAMgAuADAAaAB0AHQAcAA6AC8ALwB3AHcAdwAuAGEAcABhAGMAaABlAC4AbwByAGcALwBsAGkAYwBlAG4AcwBlAHMALwBMAEkAQwBFAE4AUwBFAC0AMgAuADAAAwAAAAAAAP9qAGQAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAIACAAC//8ADwABAAAADAAAAAAAAAACAF4AJQA+AAEARQBeAAEAeQB5AAMAgQCBAAEAgwCDAAEAhgCGAAEAiQCJAAEAiwCVAAEAlwCcAAEAowCjAAMApwCsAAMAsACwAAEAuQC6AAEAvgC+AAEAwADAAAEAwgDCAAEAxgDGAAEAygDKAAEAzADNAAEAzwDQAAEA0gDSAAEA2QDdAAEA4ADgAAEA5ADkAAEA5gDoAAEA6gD6AAEA/AD8AAEA/gEAAAEBAgECAAEBBwEIAAEBFQEZAAEBGwEbAAEBHwEhAAEBIwEkAAMBOAE5AAEBPgFAAAEBRQFFAAEBTQFNAAEBTwFPAAEBUwFTAAEBVQFXAAEBWQFZAAEBogGiAAMBowGpAAIBugHTAAEB4gHiAAEB5AHkAAEB6gHqAAEB8wHzAAEB9QH1AAEB/AH+AAECAAIBAAECAwIDAAECBwIHAAECCQILAAECEQIRAAECFgIYAAECGgIaAAECPgJDAAECRwKvAAECsgNYAAEDWwNqAAEDcQNxAAEDcwN3AAEDegN/AAEDgQOEAAEDhgOKAAEDjAOnAAEDqwOrAAEDrQO0AAEDtgO4AAEDvQO/AAEDwQPNAAEDzwPZAAED3APsAAED7wRIAAEESwRLAAEETQRNAAEETwRQAAEEWwRbAAEEYgRkAAEEZgRmAAEEagRqAAEEbARtAAEEbwRvAAEEdwSGAAEEhwSHAAIEiASwAAEEsgTKAAEEzATQAAEE0gTVAAEE1wTZAAEE2wTcAAEE3gThAAEAAQAAAAoAXACaAARERkxUABpjeXJsAChncmVrADZsYXRuAEQABAAAAAD//wACAAAABAAEAAAAAP//AAIAAQAFAAQAAAAA//8AAgACAAYABAAAAAD//wACAAMABwAIY3BzcAAyY3BzcAAyY3BzcAAyY3BzcAAya2VybgA4a2VybgA4a2VybgA4a2VybgA4AAAAAQAAAAAAAQABAAIABgHYAAEAAAABAAgAAQAKAAUAJABIAAEA3gAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAkgCwALEAsgCzALQAtQC2ALcAuAC5ANEA0gDTANQA1QDWANcA2ADZANoA2wDcAN0A3gDfAOAA4QDiAOMA5ADlAOYA5wDoASwBMAEyATgBOgE8AT4BPwFFAUYBfwGFAYoBjQJHAkgCSgJMAk0CTgJPAlACUQJSAlMCVAJVAlYCVwJYAlkCWgJbAlwCXQJeAl8CYAJhAmICYwJkAmUCZgKDAoUChwKJAosCjQKPApECkwKVApcCmQKbAp0CnwKhAqMCpQKnAqkCqwKtAq8CsgK0ArYCuAK6ArwCvgLAAsICxQLHAskCywLNAs8C0QLTAtUC2QLbAt0C3wLhAuMC5QLnAukC6wLtAu8C8QLyAvQC9gNTA1QDVQNWA1cDWANZA1sDXANdA14DXwNgA2EDYgNkA2UDZgNnA2gDaQNqA3oDewN8A30DfgN/A4ADgQOCA4MDhAOFA4YDhwOIA4kDigOLA4wDjQOOA48DuwO9A78D1APaA+AESQRLBE8EVwRZBF4EagACAAAABAAOD84V8jViAAEDVAAEAAABpQrSCtIGggtwCoAK/g+aDAAGiA7uDu4MRg6gCiIO7g7uD5oKigaSDGYMRgrYCqwNUg8QCl4L4gsQDBYGmA22DbYNtgwgCxAKUAxMDbAMTAsQBqYN5gtwD5oLcAasBrIGvAbCBsgMTAbOBtgNtgb+BxQHKgcwB0YHTAdSB4QHigeQDcANwAe+Du4H4AgCDVIIMA7uDu4LJg7uDu4IRg3ADcAIeAiCCIwIpg1ICLgNsAjSCOgLEAkyCUwJaAloCxAJYgloCWgJaAtwDCAK2AxMCxAN5g1IDqAOoA1ICtIK0grSCtIK0gmKCbAJugnECeIJ9AoGChgK/g+aD5oPmg+aDGYLcAtwC3ALcAtwC3ALcAr+DAAMAAwADAAO7g7uDu4O7g7uD5oPmg+aD5oPmgxGDEYMRgxGDxAL4gviC+IL4gviC+IL4gwWDBYMFgwWDbYMIAwgDCAMIAwgDEwMTAtwC+ILcAviC3AL4gr+Cv4K/gr+D5oMAAwWDAAMFgwADBYMAAwWDAAMFg7uDbYO7g7uDu4O7g7uDEYOoAoiCiIKIgoiDu4Ntg7uDbYO7g22DbYPmgwgD5oMIA+aDCAKUApQClAMZgxmDGYMRgxGDEYMRgxGDEYKrA8QDEwPEApeCl4KXgtwDAAO7g7uD5oPEAtwCoAMAApeDu4O7g6gDu4O7g+aCooMZg8QDVIO7g8QDbYMIAxMDCAMAA3mDu4O7gxGDqAOoAsmC3AKgA3mDAAO7g7uD5oKigr+DGYNUgviDBYMIAsQDEwNsAwWDUgMTAqsCqwKrA8QDEwK0grSCtIO7g22C3AL4gwADBYK2AxMCv4PEAxMDu4NUg2wDu4LcAviC3AL4gwADBYMFgwWDVINsA+aDCAMIAsQCyYMTAsmDEwLJgxMDVINsAtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gwADBYMAAwWDAAMFgwADBYMAAwWDAAMFgwADBYMAAwWDu4O7g+aDCAPmgwgD5oMIA+aDCAPmgwgD5oMIA+aDCAMIAxGDEYPEAxMDxAMTA8QDEwOoA7uDGYNUg2wDeYNSA1SDbANtg3ADeYOoA7uDu4PEA+aAAIAhwAGAAYAAAALAAsAAQATABMAAgAlACoAAwAsADUACQA4AD4AEwBFAEYAGgBJAEoAHABMAEwAHgBRAFQAHwBWAFYAIwBaAFoAJABcAF0AJQCKAIoAJwCcAJwAKACwALQAKQC2ALgALgC6ALoAMQC8AL0AMgC/AMAANADCAMQANgDGAMsAOQDRANEAPwDTAN0AQADfAN8ASwDhAOMATADlAOcATwDpAO0AUgDwAPAAVwD1APcAWAD6APsAWwD9AP8AXQEDAQQAYAEJAQkAYgEMAQwAYwEXARkAZAErAS0AZwEwATAAagEyATIAawFJAUkAbAFsAW0AbQFvAXEAbwG6AboAcgG9Ab0AcwHEAcUAdAHIAcgAdgHKAcsAdwHNAc0AeQIoAigAegIqAisAewJHAkgAfQJKAkoAfwJMAm0AgAJvAnIAogJ3AnwApgKBAokArAKLAosAtQKNAo0AtgKPAo8AtwKRApEAuAKTApwAuQKlAqcAwwKpAqkAxgKrAqsAxwKtAq0AyAKvAq8AyQKyArIAygK0ArQAywK2ArYAzAK4ArgAzQK6AroAzgK8ArwAzwK+AsoA0ALMAswA3QLOAs4A3gLQAtAA3wLbAtsA4ALdAt0A4QLfAt8A4gLhAuEA4wLjAuMA5ALlAuUA5QLnAucA5gLpAukA5wLrAusA6ALtAu0A6QLvAvIA6gL0AvQA7gL2AvYA7wNTA1gA8ANbA2oA9gNtA20BBgNxA3EBBwNzA3MBCAN3A3cBCQN6A3sBCgN9A4YBDAOIA4oBFgOMA5EBGQOTA5QBHwOWA5kBIQOfA6ABJQOiA6IBJwOkA6QBKAOmA6kBKQOsA7EBLQOzA7MBMwO3A7gBNAO9A70BNgO/A8gBNwPLA8wBQQPOA9EBQwPYA9kBRwPdA90BSQPfA+UBSgPqA+sBUQPvBBcBUwQZBBkBfAQbBCgBfQQwBDABiwQzBDMBjAQ1BDUBjQRBBEYBjgRJBEkBlARLBEsBlQRNBE0BlgRPBFABlwRVBFgBmQRbBFsBnQRdBF4BngRgBGABoARkBGQBoQRmBGYBogRqBGoBowSqBKoBpAABABP/IAACAFb/5gG6/8AAAQG6AA4AAwANABQAQQASAGEAEwABAPX/9QABAMMADQACALf/wgDDABAAAQDD/+IAAQDG//IAAQDDAA4AAgDJ/+0A9f/AAAkAvv/mAMH/6wDC/+kAxP/wAMX/5wDJ/+MAy//OAMz/1ADN/9sABQDB/+wAwwAPAMX/6gDJ/8QAy//nAAUASv/pAMH/7gDDABAAxf/sAMn/IAABAMMADwAFAMn/6gDs/+4A9f+rATP/7AFY/+wAAQD1/9UAAQDJAAsADABKAAwAxQALAMkADAG6/78BvP/uAcD/7AHI/+0Byv/sAcz/9QHNAA4BzwANAdIADQABAPX/2AABAPX/qgALAOX/1AD1/8kBCP/lAR//4wEz/8QBPP/hAU3/1AFO//UBT//nAVf/0gFY/8kACADl/8kA9f/fAQj/7QEf/+sBM//fAT//6QFO//UBWP/gAAgA5f/mAPX/0AEz/84BPP/oAU3/5wFP/+0BV//mAVj/0AALANgAFADl/+AA7AATATz/4QE9/+ABQP/hAUX/6QFN/98BT//eAVf/3wFZ//IABQAb//IA5f/xAU3/8gFP//IBV//yAAwA2AATAOX/5gDm//QA7AASAPX/5wEz/+cBPP/lAT3/6AFN/+YBT//mAVf/5gFY/+cAAgDY/+IBV//kAAIA2P/hAOz/5AAGAOz/7gD1/+4BCP/0AR//8QEz/+8BWP/vAAQA9f/0AQj/9QEz//UBWP/1AAYA7AAUAPX/7QD7/+IBM//tAT3/7QFY/+0ABQEb/+sBvP/rAcD/6QHI/+sByv/rABIASgANAMb/qwDH/8AAy//VAOz/qgEb/+IBHwAMAU4ACwFQAAsBuv+/Abz/7gHA/+wByP/tAcr/7AHM//UBzQAOAc8ADQHSAA0ABgDsABQA9f/wAQAADAEz//ABPf/mAVj/8AAFAOwAOgD1/+MBM//iAT3/4wFY/+MAAQDs/+8ACAD1/7oBCP/PAR//2wEz/1ABPf+dAU7/8AFQ//IBWP9MAAkBvP/yAcD/8gHI//IByv/yAc3/wAHO/+wBz//HAdD/2AHS/78AAgHP/+4B0P/1AAIByP/rAcr/6wAHAcj/7wHK//ABzf+7Ac7/7AHP/7cB0P/VAdL/tAAEAc3/7gHP//EB0f/sAdL/6gAEAc3/6QHP/+sB0P/xAdL/5QAEAc3/8gHP//EB0P/1AdL/7gACAc8ADQHSAA0ACwBb/6QBugATAbz/8wHA//EByP/yAcr/8QHN/zsBzv/aAc//VAHQ/5EB0v8/AAMASgAPAFgAMgBbABEACABb/+UAt//LAMz/5AG6AA0BvP/tAcD/6wHI/+wByv/sAAIBEAALAVf/5gAIAFgADgCB/58Aw//eAMb/5QDY/6gA7P/KAUr/4wG6/8YACQANAA8AQQAMAFb/6wBhAA4Buv/LAbz/6QHA/+cByP/nAcr/5wABAFsACwAJAA0AFABBABEAVv/iAGEAEwG6/7QBvP/ZAcD/2QHI/9kByv/ZAAQADf/mAEH/9ABh/+8BQP/tAAUAyf/qAOz/7gD1/7ABM//sAVj/7AASANj/rgDlABIA6v/gAOz/rQDu/9YA/P/fAQD/0gEG/+ABG//OASv/3QEt/+IBMf/gATf/4AE9/+kBQP/aAUr/vQFU/98BVwARABwAI//DAFj/7wBb/98Amf/uALf/5QC4/9EAwwARAMn/yADYABMA5f/FAPX/ygEz/58BPP9RAT3/ewE//8oBQP/dAUX/8gFN/3UBT//KAVf/TwFY/4wBwP/1Acj/9QHN/8cBzv/xAc//zQHQ/90B0v/EAAcA9f/wAQj/8QEf//MBM//xAU7/8wFQ/+kBWP/TAAUASv/uAFv/6gHP//AB0P/tAdL/8AACAPX/9QFt/7AACQDJ/+oA7P+4APX/6gEI//ABH//xATP/6wFO//UBWP/sAW3/sAABAbr/6wAGAEoADQDFAAsAxv/qAMkADADs/8gBG//xADgABP/YAFb/tQBb/8cAbf64AHz/KACB/00Ahv+OAIn/oQC3/64Avv9+AML/ZwDF/4cAxv9lAMn/ngDL/2oAzP9zAM3/XgDY/6UA5QAPAOn/5ADq/6AA7P90AO7/gAD1/7IA/P99AP7/gAEA/3kBBv99AQj/fwEb/5gBH//aASv/gQEt/5gBMf99ATP/swE3/6ABPf98AT//mgFA/2wBRf/mAUr/awFO/5IBUP+tAVT/ewFXAA8BWP+RAVn/8gG6/68BvP+5AcD/uQHI/7kByv+5Acz/vAHN//EB0P/xAdH/7QACAOz/yQEb/+4AFwC3/9QAwf/tAMMAEQDJ/+AAy//nAMz/5QDN/+4A2AASAOn/6QD1/9cBM//XAT3/0wE//9YBQP/FAUX/5wFNAA0BTwAMAVj/1gFZ//IBvP/pAcD/5wHI/+cByv/pAAEBG//xAAIA9f/AAW3/sAAJAOX/wwD1/88BM//OATz/5wE//98BTf/RAU//7AFX/6ABWP/RAC4AVv9tAFv/jABt/b8AfP59AIH+vACG/ysAif9LALf/YQC+/w8Awv7oAMX/HwDG/uUAyf9GAMv+7QDM/v0Azf7ZANj/UgDlAAUA6f+9AOr/SQDs/v4A7v8TAPX/aAD8/w4A/v8TAQD/BwEG/w4BCP8RARv/PAEf/6wBK/8VAS3/PAEx/w4BM/9qATf/SQE9/wwBP/8/AUD+8QFF/8ABSv7vAU7/MQFQ/18BVP8KAVcABQFY/zABWf/VABMAW//BALf/xQDJ/7QA6f/XAPX/uQEI/7IBG//SAR//yAEz/6ABPf/FAUX/5AFO/8wBUP/MAVj/ywFZ/+8BvP/oAcD/5gHI/+cByv/nAAgA2AAVAOwAFQE8/+QBPf/lAT//5AFN/+MBT//iAVf/5AAiAAr/4gANABQADv/PAEEAEgBK/+oAVv/YAFj/6gBhABMAbf+uAHz/zQCB/6AAhv/BAIn/wAC3/9AAu//qAL7/xgC/AA0Awf/pAML/1gDF/+gAxv+6AMn/6QDL/8sAzP/aAM3/xwF1/9MBuv+rAbz/zQHA/8sByP/LAcr/ywHN//MB0P/zAdH/7wAJAIH/3wC0//MAtv/wAMP/6gDY/98A5f/gAVf/4AG6/+0B0f/1AAEAGAAEAAAABwAqAFQAqgPcBFoExAUGAAEABwAEAAwAKgA1ADYAPwBKAAoAOP/YANH/2ADV/9gBMv/YATr/2ALb/9gC3f/YAt//2AOO/9gETf/YABUAOgAUADsAEgA9ABYBGAAUAmYAFgLtABIC7wAWAvEAFgNYABYDZwAWA2oAFgOgABIDogASA6QAEgOmABYDtwAUA78AFgRBABYEQwAWBEUAFgRqABYAzAAQ/xYAEv8WACX/VgAu/vgAOAAUAEX/3gBH/+sASP/rAEn/6wBL/+sAU//rAFX/6wBZ/+oAWv/oAF3/6ACT/+sAmP/rAJr/6gCx/1YAs/9WALr/6wC8/+gAx//rAMj/6wDK/+oA0QAUANUAFAD2/+sBAv/rAQz/VgEX/+sBGf/oAR3/6wEh/+sBMgAUATn/6wE6ABQBS//rAUz/6wFW/+sBbv8WAXL/FgF2/xYBd/8WAkz/VgJN/1YCTv9WAk//VgJQ/1YCUf9WAlL/VgJn/94CaP/eAmn/3gJq/94Ca//eAmz/3gJt/94Cbv/rAm//6wJw/+sCcf/rAnL/6wJ4/+sCef/rAnr/6wJ7/+sCfP/rAn3/6gJ+/+oCf//qAoD/6gKB/+gCgv/oAoP/VgKE/94Chf9WAob/3gKH/1YCiP/eAor/6wKM/+sCjv/rApD/6wKS/+sClP/rApb/6wKY/+sCmv/rApz/6wKe/+sCoP/rAqL/6wKk/+sCsv74Asb/6wLI/+sCyv/rAtsAFALdABQC3wAUAuL/6gLk/+oC5v/qAuj/6gLq/+oC7P/qAvD/6ANT/1YDW/9WA2v/6wNv/+oDcf/rA3P/6AN2/+oDd//rA3j/6gN//vgDg/9WA44AFAOQ/94Dkf/rA5P/6wOV/+sDlv/oA5j/6wOf/+gDp//oA6//VgOw/94Ds//rA7j/6AO5/+sDvv/rA8D/6APF/1YDxv/eA8f/VgPI/94DzP/rA87/6wPP/+sD2f/rA9v/6wPd/+sD4f/oA+P/6APl/+gD7P/rA+//VgPw/94D8f9WA/L/3gPz/1YD9P/eA/X/VgP2/94D9/9WA/j/3gP5/1YD+v/eA/v/VgP8/94D/f9WA/7/3gP//1YEAP/eBAH/VgQC/94EA/9WBAT/3gQF/1YEBv/eBAj/6wQK/+sEDP/rBA7/6wQQ/+sEEv/rBBT/6wQW/+sEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/6wQs/+sELv/rBDD/6wQy/+sENP/qBDb/6gQ4/+oEOv/qBDz/6gQ+/+oEQP/qBEL/6ARE/+gERv/oBE0AFAAfADj/1QA6/+QAO//sAD3/3QDR/9UA1f/VARj/5AEy/9UBOv/VAmb/3QLb/9UC3f/VAt//1QLt/+wC7//dAvH/3QNY/90DZ//dA2r/3QOO/9UDoP/sA6L/7AOk/+wDpv/dA7f/5AO//90EQf/dBEP/3QRF/90ETf/VBGr/3QAaADj/sAA6/+0APf/QANH/sADV/7ABGP/tATL/sAE6/7ACZv/QAtv/sALd/7AC3/+wAu//0ALx/9ADWP/QA2f/0ANq/9ADjv+wA6b/0AO3/+0Dv//QBEH/0ARD/9AERf/QBE3/sARq/9AAEAAu/+4AOf/uAmL/7gJj/+4CZP/uAmX/7gKy/+4C4f/uAuP/7gLl/+4C5//uAun/7gLr/+4Df//uBDP/7gQ1/+4ARwAGABAACwAQAEf/6ABI/+gASf/oAEv/6ABV/+gAk//oAJj/6AC6/+gAx//oAMj/6AD2/+gBAv/oAR3/6AEh/+gBOf/oAUv/6AFM/+gBVv/oAWwAEAFtABABbwAQAXAAEAFxABACbv/oAm//6AJw/+gCcf/oAnL/6AKK/+gCjP/oAo7/6AKQ/+gCkv/oApT/6AKW/+gCmP/oApr/6AKc/+gCnv/oAqD/6AKi/+gCpP/oA2v/6AOR/+gDlf/oA5j/6AOoABADqQAQA6wAEAOz/+gDuf/oA77/6APM/+gDzv/oA8//6APb/+gD7P/oBAj/6AQK/+gEDP/oBA7/6AQQ/+gEEv/oBBT/6AQW/+gEKv/oBCz/6AQu/+gEMv/oAAEAVgAEAAAAJgCmAZwB+gIUAlYCzAPCBLgFkgYsCMYKjAteDFQOGg5MDn4O/BDiEVgSKhRMFQIWaBciF6gYBhjIGT4ewBlQGqIc4B0CHhgelh7AHuoAAQAmAE8AWABbAF8AnAC0ALYAtwC4AL8AwgDDAMQAyQDLAMwAzQDRANUA1wDYANoA4gDmAOcA6ADpAOoA7ADuAPAA9QD3APoA/wECASEBbQA9AEf/7ABI/+wASf/sAEv/7ABV/+wAk//sAJj/7AC6/+wAx//sAMj/7AD2/+wBAv/sAR3/7AEh/+wBOf/sAUv/7AFM/+wBVv/sAm7/7AJv/+wCcP/sAnH/7AJy/+wCiv/sAoz/7AKO/+wCkP/sApL/7AKU/+wClv/sApj/7AKa/+wCnP/sAp7/7AKg/+wCov/sAqT/7ANr/+wDkf/sA5X/7AOY/+wDs//sA7n/7AO+/+wDzP/sA87/7APP/+wD2//sA+z/7AQI/+wECv/sBAz/7AQO/+wEEP/sBBL/7AQU/+wEFv/sBCr/7AQs/+wELv/sBDL/7AAXAFP/7AEX/+wCeP/sAnn/7AJ6/+wCe//sAnz/7ALG/+wCyP/sAsr/7ANx/+wDd//sA5P/7APZ/+wD3f/sBBz/7AQe/+wEIP/sBCL/7AQk/+wEJv/sBCj/7AQw/+wABgAQ/4QAEv+EAW7/hAFy/4QBdv+EAXf/hAAQAC7/7AA5/+wCYv/sAmP/7AJk/+wCZf/sArL/7ALh/+wC4//sAuX/7ALn/+wC6f/sAuv/7AN//+wEM//sBDX/7AAdAAb/8gAL//IAWv/zAF3/8wC8//MBGf/zAWz/8gFt//IBb//yAXD/8gFx//ICgf/zAoL/8wLw//MDc//zA5b/8wOf//MDp//zA6j/8gOp//IDrP/yA7j/8wPA//MD4f/zA+P/8wPl//MEQv/zBET/8wRG//MAPQAn//MAK//zADP/8wA1//MAg//zAJL/8wCX//MAsv/zANL/8wEH//MBFv/zARr/8wEc//MBHv/zASD/8wE4//MBVf/zAij/8wIp//MCK//zAiz/8wJT//MCXf/zAl7/8wJf//MCYP/zAmH/8wKJ//MCi//zAo3/8wKP//MCnf/zAp//8wKh//MCo//zAsX/8wLH//MCyf/zAvr/8wNX//MDZP/zA4r/8wON//MDuv/zA73/8wPY//MD2v/zA9z/8wQb//MEHf/zBB//8wQh//MEI//zBCX/8wQn//MEKf/zBCv/8wQt//MEL//zBDH/8wSq//MAPQAn/+YAK//mADP/5gA1/+YAg//mAJL/5gCX/+YAsv/mANL/5gEH/+YBFv/mARr/5gEc/+YBHv/mASD/5gE4/+YBVf/mAij/5gIp/+YCK//mAiz/5gJT/+YCXf/mAl7/5gJf/+YCYP/mAmH/5gKJ/+YCi//mAo3/5gKP/+YCnf/mAp//5gKh/+YCo//mAsX/5gLH/+YCyf/mAvr/5gNX/+YDZP/mA4r/5gON/+YDuv/mA73/5gPY/+YD2v/mA9z/5gQb/+YEHf/mBB//5gQh/+YEI//mBCX/5gQn/+YEKf/mBCv/5gQt/+YEL//mBDH/5gSq/+YANgAl/+QAPP/SAD3/0wCx/+QAs//kANn/0gEM/+QCTP/kAk3/5AJO/+QCT//kAlD/5AJR/+QCUv/kAmb/0wKD/+QChf/kAof/5ALv/9MC8f/TA1P/5ANY/9MDW//kA2f/0wNo/9IDav/TA4P/5AOP/9IDpv/TA6//5AO//9MDwv/SA8X/5APH/+QD0P/SA+r/0gPv/+QD8f/kA/P/5AP1/+QD9//kA/n/5AP7/+QD/f/kA///5AQB/+QEA//kBAX/5ARB/9MEQ//TBEX/0wRP/9IEV//SBGr/0wAmABD/HgAS/x4AJf/NALH/zQCz/80BDP/NAW7/HgFy/x4Bdv8eAXf/HgJM/80CTf/NAk7/zQJP/80CUP/NAlH/zQJS/80Cg//NAoX/zQKH/80DU//NA1v/zQOD/80Dr//NA8X/zQPH/80D7//NA/H/zQPz/80D9f/NA/f/zQP5/80D+//NA/3/zQP//80EAf/NBAP/zQQF/80ApgBH/9wASP/cAEn/3ABL/9wAUf/zAFL/8wBT/9YAVP/zAFX/3ABZ/90AWv/hAF3/4QCT/9wAmP/cAJr/3QC6/9wAvP/hAMD/8wDH/9wAyP/cAMr/3QDr//MA7//zAPD/8wDy//MA8//zAPT/8wD2/9wA9//zAPn/8wD6//MA/f/zAP//8wEC/9wBBP/zARf/1gEZ/+EBHf/cASH/3AE1//MBOf/cAUT/8wFJ//MBS//cAUz/3AFW/9wCbv/cAm//3AJw/9wCcf/cAnL/3AJ3//MCeP/WAnn/1gJ6/9YCe//WAnz/1gJ9/90Cfv/dAn//3QKA/90Cgf/hAoL/4QKK/9wCjP/cAo7/3AKQ/9wCkv/cApT/3AKW/9wCmP/cApr/3AKc/9wCnv/cAqD/3AKi/9wCpP/cAr//8wLB//MCw//zAsT/8wLG/9YCyP/WAsr/1gLi/90C5P/dAub/3QLo/90C6v/dAuz/3QLw/+EDa//cA23/8wNv/90Dcf/WA3P/4QN2/90Dd//WA3j/3QOR/9wDkv/zA5P/1gOU//MDlf/cA5b/4QOY/9wDmf/zA57/8wOf/+EDp//hA67/8wOz/9wDtP/zA7j/4QO5/9wDvv/cA8D/4QPM/9wDzv/cA8//3APV//MD1//zA9n/1gPb/9wD3f/WA+H/4QPj/+ED5f/hA+n/8wPs/9wECP/cBAr/3AQM/9wEDv/cBBD/3AQS/9wEFP/cBBb/3AQc/9YEHv/WBCD/1gQi/9YEJP/WBCb/1gQo/9YEKv/cBCz/3AQu/9wEMP/WBDL/3AQ0/90ENv/dBDj/3QQ6/90EPP/dBD7/3QRA/90EQv/hBET/4QRG/+EESv/zBEz/8wRW//MEY//zBGX/8wRn//MAcQAG/9oAC//aAEf/8ABI//AASf/wAEv/8ABV//AAWf/vAFr/3ABd/9wAk//wAJj/8ACa/+8Auv/wALz/3ADH//AAyP/wAMr/7wD2//ABAv/wARn/3AEd//ABIf/wATn/8AFL//ABTP/wAVb/8AFs/9oBbf/aAW//2gFw/9oBcf/aAm7/8AJv//ACcP/wAnH/8AJy//ACff/vAn7/7wJ//+8CgP/vAoH/3AKC/9wCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALi/+8C5P/vAub/7wLo/+8C6v/vAuz/7wLw/9wDa//wA2//7wNz/9wDdv/vA3j/7wOR//ADlf/wA5b/3AOY//ADn//cA6f/3AOo/9oDqf/aA6z/2gOz//ADuP/cA7n/8AO+//ADwP/cA8z/8APO//ADz//wA9v/8APh/9wD4//cA+X/3APs//AECP/wBAr/8AQM//AEDv/wBBD/8AQS//AEFP/wBBb/8AQq//AELP/wBC7/8AQy//AENP/vBDb/7wQ4/+8EOv/vBDz/7wQ+/+8EQP/vBEL/3ARE/9wERv/cADQABv+gAAv/oABZ//EAWv/FAF3/xQCa//EAvP/FAMr/8QEZ/8UBbP+gAW3/oAFv/6ABcP+gAXH/oAJ9//ECfv/xAn//8QKA//ECgf/FAoL/xQLi//EC5P/xAub/8QLo//EC6v/xAuz/8QLw/8UDb//xA3P/xQN2//EDeP/xA5b/xQOf/8UDp//FA6j/oAOp/6ADrP+gA7j/xQPA/8UD4f/FA+P/xQPl/8UENP/xBDb/8QQ4//EEOv/xBDz/8QQ+//EEQP/xBEL/xQRE/8UERv/FAD0AR//nAEj/5wBJ/+cAS//nAFX/5wCT/+cAmP/nALr/5wDH/+cAyP/nAPb/5wEC/+cBHf/nASH/5wE5/+cBS//nAUz/5wFW/+cCbv/nAm//5wJw/+cCcf/nAnL/5wKK/+cCjP/nAo7/5wKQ/+cCkv/nApT/5wKW/+cCmP/nApr/5wKc/+cCnv/nAqD/5wKi/+cCpP/nA2v/5wOR/+cDlf/nA5j/5wOz/+cDuf/nA77/5wPM/+cDzv/nA8//5wPb/+cD7P/nBAj/5wQK/+cEDP/nBA7/5wQQ/+cEEv/nBBT/5wQW/+cEKv/nBCz/5wQu/+cEMv/nAHEABgAMAAsADABH/+gASP/oAEn/6ABL/+gAU//qAFX/6ABaAAsAXQALAJP/6ACY/+gAuv/oALwACwDH/+gAyP/oAPb/6AEC/+gBF//qARkACwEd/+gBIf/oATn/6AFL/+gBTP/oAVb/6AFsAAwBbQAMAW8ADAFwAAwBcQAMAm7/6AJv/+gCcP/oAnH/6AJy/+gCeP/qAnn/6gJ6/+oCe//qAnz/6gKBAAsCggALAor/6AKM/+gCjv/oApD/6AKS/+gClP/oApb/6AKY/+gCmv/oApz/6AKe/+gCoP/oAqL/6AKk/+gCxv/qAsj/6gLK/+oC8AALA2v/6ANx/+oDcwALA3f/6gOR/+gDk//qA5X/6AOWAAsDmP/oA58ACwOnAAsDqAAMA6kADAOsAAwDs//oA7gACwO5/+gDvv/oA8AACwPM/+gDzv/oA8//6APZ/+oD2//oA93/6gPhAAsD4wALA+UACwPs/+gECP/oBAr/6AQM/+gEDv/oBBD/6AQS/+gEFP/oBBb/6AQc/+oEHv/qBCD/6gQi/+oEJP/qBCb/6gQo/+oEKv/oBCz/6AQu/+gEMP/qBDL/6ARCAAsERAALBEYACwAMAFz/7QBe/+0A7f/tAvP/7QL1/+0C9//tA5f/7QPD/+0D0f/tA+v/7QRQ/+0EWP/tAAwAXP/yAF7/8gDt//IC8//yAvX/8gL3//IDl//yA8P/8gPR//ID6//yBFD/8gRY//IAHwBa//QAXP/yAF3/9ABe//MAvP/0AO3/8gEZ//QCgf/0AoL/9ALw//QC8//zAvX/8wL3//MDc//0A5b/9AOX//IDn//0A6f/9AO4//QDwP/0A8P/8gPR//ID4f/0A+P/9APl//QD6//yBEL/9ARE//QERv/0BFD/8gRY//IAeQAG/8oAC//KADj/0gA6/9QAPP/0AD3/0wBR/9EAUv/RAFT/0QBa/+YAXP/vAF3/5gC8/+YAwP/RANH/0gDV/9IA2f/0AN3/7QDg/+EA6//RAO3/7wDv/9EA8P/RAPL/0QDz/9EA9P/RAPf/0QD5/9EA+v/RAP3/0QD//9EBBP/RARj/1AEZ/+YBMv/SATX/0QE6/9IBRP/RAUn/0QFs/8oBbf/KAW//ygFw/8oBcf/KAmb/0wJ3/9ECgf/mAoL/5gK//9ECwf/RAsP/0QLE/9EC2//SAt3/0gLf/9IC7//TAvD/5gLx/9MDWP/TA2f/0wNo//QDav/TA23/0QNz/+YDgv/tA47/0gOP//QDkv/RA5T/0QOW/+YDl//vA5n/0QOe/9EDn//mA6b/0wOn/+YDqP/KA6n/ygOs/8oDrv/RA7T/0QO3/9QDuP/mA7//0wPA/+YDwv/0A8P/7wPQ//QD0f/vA9X/0QPX/9ED4P/tA+H/5gPi/+0D4//mA+T/7QPl/+YD5v/hA+n/0QPq//QD6//vBEH/0wRC/+YEQ//TBET/5gRF/9MERv/mBEr/0QRM/9EETf/SBE//9ARQ/+8EUf/hBFP/4QRW/9EEV//0BFj/7wRj/9EEZf/RBGf/0QRq/9MAHQA4/74AWv/vAF3/7wC8/+8A0f++ANX/vgEZ/+8BMv++ATr/vgKB/+8Cgv/vAtv/vgLd/74C3/++AvD/7wNz/+8Djv++A5b/7wOf/+8Dp//vA7j/7wPA/+8D4f/vA+P/7wPl/+8EQv/vBET/7wRG/+8ETf++ADQAOP/mADr/5wA8//IAPf/nAFz/8QDR/+YA1f/mANn/8gDd/+4A4P/oAO3/8QEY/+cBMv/mATr/5gJm/+cC2//mAt3/5gLf/+YC7//nAvH/5wNY/+cDZ//nA2j/8gNq/+cDgv/uA47/5gOP//IDl//xA6b/5wO3/+cDv//nA8L/8gPD//ED0P/yA9H/8QPg/+4D4v/uA+T/7gPm/+gD6v/yA+v/8QRB/+cEQ//nBEX/5wRN/+YET//yBFD/8QRR/+gEU//oBFf/8gRY//EEav/nAIgAJQAQACf/6AAr/+gAM//oADX/6AA4/+AAOv/gAD3/3wCD/+gAkv/oAJf/6ACxABAAsv/oALMAEADR/+AA0v/oANMAEADV/+AA3AAQAOD/4QDxABAA+P/gAQMAEAEH/+gBDAAQARb/6AEY/+ABGv/oARz/6AEe/+gBIP/oATL/4AE4/+gBOv/gAVEAEAFV/+gCKP/oAin/6AIr/+gCLP/oAkwAEAJNABACTgAQAk8AEAJQABACUQAQAlIAEAJT/+gCXf/oAl7/6AJf/+gCYP/oAmH/6AJm/98CgwAQAoUAEAKHABACif/oAov/6AKN/+gCj//oAp3/6AKf/+gCof/oAqP/6ALF/+gCx//oAsn/6ALb/+AC3f/gAt//4ALv/98C8f/fAvr/6ANTABADV//oA1j/3wNbABADZP/oA2f/3wNq/98DgwAQA4r/6AON/+gDjv/gA6b/3wOvABADt//gA7r/6AO9/+gDv//fA8UAEAPHABAD2P/oA9r/6APc/+gD5v/hA+f/4APtABAD7gAQA+8AEAPxABAD8wAQA/UAEAP3ABAD+QAQA/sAEAP9ABAD/wAQBAEAEAQDABAEBQAQBBv/6AQd/+gEH//oBCH/6AQj/+gEJf/oBCf/6AQp/+gEK//oBC3/6AQv/+gEMf/oBEH/3wRD/98ERf/fBE3/4ARR/+EEUv/gBFP/4QRU/+AEaAAQBGkAEARq/98Eqv/oAC0AOP/xADr/9AA8//QAPf/wANH/8QDT//UA1f/xANn/9ADc//UA3f/zARj/9AEy//EBOv/xAVH/9QJm//AC2//xAt3/8QLf//EC7//wAvH/8ANY//ADZ//wA2j/9ANq//ADgv/zA47/8QOP//QDpv/wA7f/9AO///ADwv/0A9D/9APg//MD4v/zA+T/8wPq//QD7f/1BEH/8ARD//AERf/wBE3/8QRP//QEV//0BGj/9QRq//AAWQAlAA8AOP/mADr/5gA8AA4APf/mALEADwCzAA8A0f/mANMADgDV/+YA2QAOANwADgDdAAsA4P/lAPEADwD4/+gBAwAPAQwADwEY/+YBMv/mATr/5gFRAA4CTAAPAk0ADwJOAA8CTwAPAlAADwJRAA8CUgAPAmb/5gKDAA8ChQAPAocADwLb/+YC3f/mAt//5gLv/+YC8f/mA1MADwNY/+YDWwAPA2f/5gNoAA4Dav/mA4IACwODAA8Djv/mA48ADgOm/+YDrwAPA7f/5gO//+YDwgAOA8UADwPHAA8D0AAOA+AACwPiAAsD5AALA+b/5QPn/+gD6gAOA+0ADgPuAA8D7wAPA/EADwPzAA8D9QAPA/cADwP5AA8D+wAPA/0ADwP/AA8EAQAPBAMADwQFAA8EQf/mBEP/5gRF/+YETf/mBE8ADgRR/+UEUv/oBFP/5QRU/+gEVwAOBGgADgRpAA8Eav/mAC4AOP/jADz/5QA9/+QA0f/jANP/5QDV/+MA2f/lANz/5QDd/+kA8f/qAQP/6gEy/+MBOv/jAVH/5QJm/+QC2//jAt3/4wLf/+MC7//kAvH/5ANY/+QDZ//kA2j/5QNq/+QDgv/pA47/4wOP/+UDpv/kA7//5APC/+UD0P/lA+D/6QPi/+kD5P/pA+r/5QPt/+UD7v/qBEH/5ARD/+QERf/kBE3/4wRP/+UEV//lBGj/5QRp/+oEav/kACEAOP/iADz/5ADR/+IA0//kANX/4gDZ/+QA3P/kAN3/6QDx/+sBA//rATL/4gE6/+IBUf/kAtv/4gLd/+IC3//iA2j/5AOC/+kDjv/iA4//5APC/+QD0P/kA+D/6QPi/+kD5P/pA+r/5APt/+QD7v/rBE3/4gRP/+QEV//kBGj/5ARp/+sAFwA4/+sAPf/zANH/6wDV/+sBMv/rATr/6wJm//MC2//rAt3/6wLf/+sC7//zAvH/8wNY//MDZ//zA2r/8wOO/+sDpv/zA7//8wRB//MEQ//zBEX/8wRN/+sEav/zADAAUf/vAFL/7wBU/+8AXP/wAMD/7wDr/+8A7f/wAO//7wDw/+8A8v/vAPP/7wD0/+8A9//vAPn/7wD6/+8A/f/vAP//7wEE/+8BNf/vAUT/7wFJ/+8Cd//vAr//7wLB/+8Cw//vAsT/7wNt/+8Dkv/vA5T/7wOX//ADmf/vA57/7wOu/+8DtP/vA8P/8APR//AD1f/vA9f/7wPp/+8D6//wBEr/7wRM/+8EUP/wBFb/7wRY//AEY//vBGX/7wRn/+8AHQAG//IAC//yAFr/9QBd//UAvP/1ARn/9QFs//IBbf/yAW//8gFw//IBcf/yAoH/9QKC//UC8P/1A3P/9QOW//UDn//1A6f/9QOo//IDqf/yA6z/8gO4//UDwP/1A+H/9QPj//UD5f/1BEL/9QRE//UERv/1AAQA+P/tA+f/7QRS/+0EVP/tAFQAR//wAEj/8ABJ//AAS//wAFP/6wBV//AAk//wAJj/8AC6//AAx//wAMj/8AD2//ABAv/wARf/6wEd//ABIf/wATn/8AFL//ABTP/wAVb/8AJu//ACb//wAnD/8AJx//ACcv/wAnj/6wJ5/+sCev/rAnv/6wJ8/+sCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALG/+sCyP/rAsr/6wNr//ADcf/rA3f/6wOR//ADk//rA5X/8AOY//ADs//wA7n/8AO+//ADzP/wA87/8APP//AD2f/rA9v/8APd/+sD7P/wBAj/8AQK//AEDP/wBA7/8AQQ//AEEv/wBBT/8AQW//AEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/8AQs//AELv/wBDD/6wQy//AAjwAGAA0ACwANAEX/8ABH/7AASP+wAEn/sABL/7AAU//WAFX/sABaAAsAXQALAJP/sACY/7AAuv+wALwACwDI/7AA8f+vAPb/sAEC/7ABA/+vARf/1gEZAAsBHf+wASH/sAE5/7ABS/+wAUz/sAFW/7ABbAANAW0ADQFvAA0BcAANAXEADQJn//ACaP/wAmn/8AJq//ACa//wAmz/8AJt//ACbv+wAm//sAJw/7ACcf+wAnL/sAJ4/9YCef/WAnr/1gJ7/9YCfP/WAoEACwKCAAsChP/wAob/8AKI//ACiv+wAoz/sAKO/7ACkP+wApL/sAKU/7AClv+wApj/sAKa/7ACnP+wAp7/sAKg/7ACov+wAqT/sALG/9YCyP/WAsr/1gLwAAsDa/+wA3H/1gNzAAsDd//WA5D/8AOR/7ADk//WA5X/sAOWAAsDmP+wA58ACwOnAAsDqAANA6kADQOsAA0DsP/wA7P/sAO4AAsDuf+wA77/sAPAAAsDxv/wA8j/8APM/7ADzv+wA8//sAPZ/9YD2/+wA93/1gPhAAsD4wALA+UACwPs/7AD7v+vA/D/8APy//AD9P/wA/b/8AP4//AD+v/wA/z/8AP+//AEAP/wBAL/8AQE//AEBv/wBAj/sAQK/7AEDP+wBA7/sAQQ/7AEEv+wBBT/sAQW/7AEHP/WBB7/1gQg/9YEIv/WBCT/1gQm/9YEKP/WBCr/sAQs/7AELv+wBDD/1gQy/7AEQgALBEQACwRGAAsEaf+vAAgA8QAQAPj/8AEDABAD5//wA+4AEARS//AEVP/wBGkAEABFAEcADABIAAwASQAMAEsADABVAAwAkwAMAJgADAC6AAwAxwAMAMgADADxABgA9gAMAPj/9wECAAwBAwAYAR0ADAEhAAwBOQAMAUsADAFMAAwBVgAMAm4ADAJvAAwCcAAMAnEADAJyAAwCigAMAowADAKOAAwCkAAMApIADAKUAAwClgAMApgADAKaAAwCnAAMAp4ADAKgAAwCogAMAqQADANrAAwDkQAMA5UADAOYAAwDswAMA7kADAO+AAwDzAAMA84ADAPPAAwD2wAMA+f/9wPsAAwD7gAYBAgADAQKAAwEDAAMBA4ADAQQAAwEEgAMBBQADAQWAAwEKgAMBCwADAQuAAwEMgAMBFL/9wRU//cEaQAYAB8AWv/0AFz/8ABd//QAvP/0AO3/8ADx//MBA//zARn/9AKB//QCgv/0AvD/9ANz//QDlv/0A5f/8AOf//QDp//0A7j/9APA//QDw//wA9H/8APh//QD4//0A+X/9APr//AD7v/zBEL/9ARE//QERv/0BFD/8ARY//AEaf/zAAoABv/WAAv/1gFs/9YBbf/WAW//1gFw/9YBcf/WA6j/1gOp/9YDrP/WAAoABv/1AAv/9QFs//UBbf/1AW//9QFw//UBcf/1A6j/9QOp//UDrP/1ACEATAAgAE8AIABQACAAU/+AAFf/kAEX/4ACeP+AAnn/gAJ6/4ACe/+AAnz/gALG/4ACyP+AAsr/gALS/5AC1P+QAtb/kALY/5AC2v+QA3H/gAN3/4ADk/+AA5r/kAPZ/4AD3f+ABBz/gAQe/4AEIP+ABCL/gAQk/4AEJv+ABCj/gAQw/4AAAgeKAAQAAApeEb4AIQAdAAAAEf/O/48AEv/1/+//iP/0/7v/f//1AAz/qf+i/8kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+UAAAAA/+j/yQAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAD/5QARAAAAAAAAAAAAAP/jAAAAAAAA/+T/5AAAABIAEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/4QAAAAAAAAAAAAAAAAAAAAD/5QAAAAD/6v/VAAAAAP/r/+r/mv/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+YAAAAAAAAAAAAA/+0AAAAU/+8AAAAAAAAAAAAAAAAAAAAAAAD/7QAAAAAAAAAAAAAAAAAAAAD/y/+4/3z/fv/kAAAAAP+dAA8AEP+h/8QAEAAQAAAAAP+xAAD/JgAA/53/s/8Y/5P/8P+P/4z/EAAA/5L/cv8M/w//vQAAAAD/RAAFAAf/S/+GAAcABwAAAAD/PgAA/noAAP9E/2r+Yv8z/9H/LP8nAAAAAAAAAAAAAP/YAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAAAAAAAP/Y/6MAAP/hAAAAAP/lAAAAAP/pAAAAAAAAAAAAAAAAAAAAAAAA/+YAAP/A/+kAAAAAAAAAAAAAAAD/ewAAAAD/v//K/rAAAP9x/u3/1AAA/1H/EQAAAAAAEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAA8AAP/ZAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAA/3b/4f68/+b/8wAAAAAAAAAA//UAAP84AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9QAAAAD/8wAAAAD/0gAAAAD/5AAAAAAAAAAAAAD/tQAA/x8AAP/UAAD/2wAAAAD/0gAAAAAAAAAR/+H/0QAR/+cAAAAA/+sAAAAA/+sAAAAOAAAAAAAAAAAAAAAAAAD/5gAA/9IAAAAAAAAAAAAAAAAAAP/sAAAAAP/j/6AAAP+/ABEAEf/Z/+IAEgASAAAAAP+iAA3/LQAA/7//6f/M/9j/8P+3/8b/oAAAAAAAAAAAAAAAAAAAAAD/4QAAAA7/7QAAAAAAAAAAAAD/1QAA/4UAAP/hAAD/xAAAAAD/3wAAAAAAAAAA/+UAAAAA/+YAAAAA/+sAAAAA/+0AAAAAAAAAAAAAAA0AAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAD/ygAA/+n/u//pAAAAAP+9AAAAEgAAAAAAAAASAAAAAP+lAAD+bQAA/70AAP+J/5oAAP+R/9IAAAAAAAD/8QAAAAAAAAAA/70AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAD/8gAAAAD/4wAAAAAAAAAA//EAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAAAAD/8wAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/xAAD/8AAAAAD/eAAAAAAAAAAA//AAAAAAAAAAAAAAAAAAAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAAAA//8QAAAAAAAAAAAAAAAAAAAAAAAAAA/5UAAP/zAAAAAAAAAAD/8QAAAAAAAAAAABIAAAAAAAAAAAAQ/+wAAAAAAAAAAAAAAAAAAAAAAAAAAP+FAAD/7QAAAAAAAAAA/9gAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+V/8MAAAAAAAAAAAAAAAAAAAAA/4gAAAAAAAD/xQAAAAD/7AAA/87/sAAAAAAAAAAAAAAAAAAAAAD/VgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//UAAAAAAAAAAAAA/8AAAAAA/vUAAAAA/8j/rf/n/+sAAP/wAAAAAAAA/8kAAAAAAAAAAAAAAAAAAAAA/93/2QAAAAAAAP95AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAIAeAAGAAYAAAALAAsAAQAQABAAAgASABIAAwAlACkABAAsADQACQA4AD4AEgBFAEcAGQBJAEkAHABMAEwAHQBRAFQAHgBWAFYAIgBaAFoAIwBcAF4AJACKAIoAJwCwALMAKAC8ALwALADAAMAALQDGAMYALgDTANQALwDWANYAMQDZANkAMgDbAN0AMwDfAN8ANgDhAOEANwDjAOMAOADlAOUAOQDrAOsAOgDtAO0AOwD2APYAPAD7APsAPQD9AP4APgEDAQQAQAEJAQkAQgEMAQwAQwEXARkARAErAS0ARwEwATAASgEyATIASwFJAUkATAFsAXIATQF2AXcAVAIoAigAVgIqAisAVwJHAkgAWQJKAkoAWwJMAnIAXAJ3AnwAgwKBApEAiQKTApwAmgKlAqcApAKpAqkApwKrAqsAqAKtAq0AqQKvAq8AqgKyArIAqwK0ArQArAK2ArYArQK4ArgArgK6AroArwK8ArwAsAK+AsoAsQLMAswAvgLOAs4AvwLQAtAAwALbAtsAwQLdAt0AwgLfAt8AwwLhAuEAxALjAuMAxQLlAuUAxgLnAucAxwLpAukAyALrAusAyQLtAu0AygLvAvcAywNTA1gA1ANbA2oA2gNtA20A6gNxA3EA6wNzA3MA7AN3A3cA7QN6A3sA7gN9A4YA8AOIA4oA+gOMA5EA/QOTA5kBAwOfA6ABCgOiA6IBDAOkA6QBDQOmA6kBDgOsA7EBEgOzA7MBGAO3A7gBGQO9A8gBGwPLA8wBJwPOA9EBKQPYA9kBLQPdA90BLwPfA+UBMAPqA+sBNwPvBBcBOQQZBBkBYgQbBCgBYwQwBDABcQQzBDMBcgQ1BDUBcwRBBEYBdARJBEkBegRLBEsBewRNBE0BfARPBFABfQRVBFgBfwRbBFsBgwRdBF4BhARgBGABhgRkBGQBhwRmBGYBiARqBGoBiQSqBKoBigACAToABgAGAB0ACwALAB0AEAAQAB4AEgASAB4AJgAmAAEAJwAnAAQAKAAoAAMAKQApAAUALAAtAAIALgAuAAwALwAvAAkAMAAwAAoAMQAyAAIAMwAzAAMANAA0AAsAOAA4AAYAOQA5AAwAOgA6AA0AOwA7ABAAPAA8AA4APQA9AA8APgA+ABEARQBFABMARgBGABUARwBHABQASQBJABYATABMABcAUQBSABcAUwBTABgAVABUABUAVgBWABoAWgBaABkAXABcABsAXQBdABkAXgBeABwAigCKABUAsACwAAcAsgCyAAMAvAC8ABkAwADAABcAxgDGABUA0wDUAB8A1gDWAAIA2QDZAA4A2wDcAAIA3QDdABIA3wDfAAIA4QDhAAIA4wDjAB8A5QDlAB8A6wDrAAgA7QDtABsA9gD2ABUA+wD7ACAA/QD9ACAA/gD+ABUBAwEEACABCQEJACABFwEXABgBGAEYAA0BGQEZABkBKwErABUBLAEsAAcBLQEtAAgBMAEwAAkBMgEyAAkBSQFJAAgBbAFtAB0BbgFuAB4BbwFxAB0BcgFyAB4BdgF3AB4CKAIoAAQCKgIrAAMCRwJIAAMCSgJKAAYCUwJTAAQCVAJXAAUCWAJcAAICXQJhAAMCYgJlAAwCZgJmAA8CZwJtABMCbgJuABQCbwJyABYCdwJ3ABcCeAJ8ABgCgQKCABkChAKEABMChgKGABMCiAKIABMCiQKJAAQCigKKABQCiwKLAAQCjAKMABQCjQKNAAQCjgKOABQCjwKPAAQCkAKQABQCkQKRAAMCkwKTAAUClAKUABYClQKVAAUClgKWABYClwKXAAUCmAKYABYCmQKZAAUCmgKaABYCmwKbAAUCnAKcABYCpQKlAAICpgKmABcCpwKnAAICqQKpAAICqwKrAAICrQKtAAICrwKvAAICsgKyAAwCtAK0AAkCtgK2AAoCuAK4AAoCugK6AAoCvAK8AAoCvgK+AAICvwK/ABcCwALAAAICwQLBABcCwgLCAAICwwLEABcCxQLFAAMCxgLGABgCxwLHAAMCyALIABgCyQLJAAMCygLKABgCzALMABoCzgLOABoC0ALQABoC2wLbAAYC3QLdAAYC3wLfAAYC4QLhAAwC4wLjAAwC5QLlAAwC5wLnAAwC6QLpAAwC6wLrAAwC7QLtABAC7wLvAA8C8ALwABkC8QLxAA8C8gLyABEC8wLzABwC9AL0ABEC9QL1ABwC9gL2ABEC9wL3ABwDVANUAAUDVQNWAAIDVwNXAAMDWANYAA8DXANcAAEDXQNdAAUDXgNeABEDXwNgAAIDYQNhAAkDYgNjAAIDZANkAAMDZQNlAAsDZgNmAAYDZwNnAA8DaANoAA4DaQNpAAIDagNqAA8DbQNtABcDcQNxABgDcwNzABkDdwN3ABgDegN6AAUDewN7AAcDfQN+AAIDfwN/AAwDgAOBAAkDggOCABIDhAOEAAEDhQOFAAcDhgOGAAUDiAOJAAIDigOKAAMDjAOMAAsDjQONAAQDjgOOAAYDjwOPAA4DkAOQABMDkQORABYDkwOTABgDlAOUABUDlQOVABQDlgOWABkDlwOXABsDmAOYABYDmQOZAAgDnwOfABkDoAOgABADogOiABADpAOkABADpgOmAA8DpwOnABkDqAOpAB0DrAOsAB0DrQOtAAIDrgOuABcDsAOwABMDsQOxAAUDswOzABYDtwO3AA0DuAO4ABkDvQO9AAQDvgO+ABQDvwO/AA8DwAPAABkDwQPBAAIDwgPCAA4DwwPDABsDxAPEAAIDxgPGABMDyAPIABMDywPLAAUDzAPMABYDzgPPABYD0APQAA4D0QPRABsD2APYAAMD2QPZABgD3QPdABgD3wPfABUD4APgABID4QPhABkD4gPiABID4wPjABkD5APkABID5QPlABkD6gPqAA4D6wPrABsD8APwABMD8gPyABMD9AP0ABMD9gP2ABMD+AP4ABMD+gP6ABMD/AP8ABMD/gP+ABMEAAQAABMEAgQCABMEBAQEABMEBgQGABMEBwQHAAUECAQIABYECQQJAAUECgQKABYECwQLAAUEDAQMABYEDQQNAAUEDgQOABYEDwQPAAUEEAQQABYEEQQRAAUEEgQSABYEEwQTAAUEFAQUABYEFQQVAAUEFgQWABYEFwQXAAIEGQQZAAIEGwQbAAMEHAQcABgEHQQdAAMEHgQeABgEHwQfAAMEIAQgABgEIQQhAAMEIgQiABgEIwQjAAMEJAQkABgEJQQlAAMEJgQmABgEJwQnAAMEKAQoABgEMAQwABgEMwQzAAwENQQ1AAwEQQRBAA8EQgRCABkEQwRDAA8ERAREABkERQRFAA8ERgRGABkESQRJAAkESwRLAAIETQRNAAYETwRPAA4EUARQABsEVQRVAAcEVgRWAAgEVwRXAA4EWARYABsEWwRbABcEXQRdAB8EXgReAAcEYARgAAkEZARkAAIEZgRmAAIEagRqAA8EqgSqAAMAAgFtAAYABgAHAAsACwAHABAAEAATABEAEQAXABIAEgATACUAJQARACcAJwAFACsAKwAFAC4ALgAcADMAMwAFADUANQAFADcANwAZADgAOAAKADkAOQAGADoAOgANADsAOwAJADwAPAASAD0APQAOAD4APgAUAEUARQAaAEcASQAVAEsASwAVAFEAUgAYAFMAUwAIAFQAVAAYAFUAVQAVAFcAVwAbAFkAWQALAFoAWgACAFwAXAAWAF0AXQACAF4AXgAMAIMAgwAFAJIAkgAFAJMAkwAVAJcAlwAFAJgAmAAVAJoAmgALALEAsQARALIAsgAFALMAswARALoAugAVALwAvAACAMAAwAAYAMcAyAAVAMoAygALANEA0QAKANIA0gAFANMA0wABANUA1QAKANkA2QASANwA3AABAN0A3QAQAOAA4AAPAOsA6wAYAO0A7QAWAO8A8AAYAPEA8QAEAPIA9AAYAPYA9gAVAPcA9wAYAPgA+AADAPkA+gAYAP0A/QAYAP8A/wAYAQIBAgAVAQMBAwAEAQQBBAAYAQcBBwAFAQwBDAARARYBFgAFARcBFwAIARgBGAANARkBGQACARoBGgAFARwBHAAFAR0BHQAVAR4BHgAFASABIAAFASEBIQAVATIBMgAKATUBNQAYATgBOAAFATkBOQAVAToBOgAKAUQBRAAYAUkBSQAYAUsBTAAVAVEBUQABAVUBVQAFAVYBVgAVAWkBagAXAWwBbQAHAW4BbgATAW8BcQAHAXIBcgATAXYBdwATAigCKQAFAisCLAAFAkYCRgAXAkwCUgARAlMCUwAFAl0CYQAFAmICZQAGAmYCZgAOAmcCbQAaAm4CcgAVAncCdwAYAngCfAAIAn0CgAALAoECggACAoMCgwARAoQChAAaAoUChQARAoYChgAaAocChwARAogCiAAaAokCiQAFAooCigAVAosCiwAFAowCjAAVAo0CjQAFAo4CjgAVAo8CjwAFApACkAAVApICkgAVApQClAAVApYClgAVApgCmAAVApoCmgAVApwCnAAVAp0CnQAFAp4CngAVAp8CnwAFAqACoAAVAqECoQAFAqICogAVAqMCowAFAqQCpAAVArICsgAcAr8CvwAYAsECwQAYAsMCxAAYAsUCxQAFAsYCxgAIAscCxwAFAsgCyAAIAskCyQAFAsoCygAIAtEC0QAZAtIC0gAbAtMC0wAZAtQC1AAbAtUC1QAZAtYC1gAbAtcC1wAZAtgC2AAbAtkC2QAZAtoC2gAbAtsC2wAKAt0C3QAKAt8C3wAKAuEC4QAGAuIC4gALAuMC4wAGAuQC5AALAuUC5QAGAuYC5gALAucC5wAGAugC6AALAukC6QAGAuoC6gALAusC6wAGAuwC7AALAu0C7QAJAu8C7wAOAvAC8AACAvEC8QAOAvIC8gAUAvMC8wAMAvQC9AAUAvUC9QAMAvYC9gAUAvcC9wAMAvoC+gAFA1MDUwARA1cDVwAFA1gDWAAOA1sDWwARA14DXgAUA2QDZAAFA2cDZwAOA2gDaAASA2oDagAOA2sDawAVA20DbQAYA28DbwALA3EDcQAIA3MDcwACA3YDdgALA3cDdwAIA3gDeAALA38DfwAcA4IDggAQA4MDgwARA4oDigAFA40DjQAFA44DjgAKA48DjwASA5ADkAAaA5EDkQAVA5IDkgAYA5MDkwAIA5QDlAAYA5UDlQAVA5YDlgACA5cDlwAWA5gDmAAVA5kDmQAYA5oDmgAbA54DngAYA58DnwACA6ADoAAJA6IDogAJA6QDpAAJA6YDpgAOA6cDpwACA6gDqQAHA6wDrAAHA64DrgAYA68DrwARA7ADsAAaA7MDswAVA7QDtAAYA7cDtwANA7gDuAACA7kDuQAVA7oDugAFA70DvQAFA74DvgAVA78DvwAOA8ADwAACA8IDwgASA8MDwwAWA8UDxQARA8YDxgAaA8cDxwARA8gDyAAaA8wDzAAVA84DzwAVA9AD0AASA9ED0QAWA9UD1QAYA9cD1wAYA9gD2AAFA9kD2QAIA9oD2gAFA9sD2wAVA9wD3AAFA90D3QAIA+AD4AAQA+ED4QACA+ID4gAQA+MD4wACA+QD5AAQA+UD5QACA+YD5gAPA+cD5wADA+kD6QAYA+oD6gASA+sD6wAWA+wD7AAVA+0D7QABA+4D7gAEA+8D7wARA/AD8AAaA/ED8QARA/ID8gAaA/MD8wARA/QD9AAaA/UD9QARA/YD9gAaA/cD9wARA/gD+AAaA/kD+QARA/oD+gAaA/sD+wARA/wD/AAaA/0D/QARA/4D/gAaA/8D/wARBAAEAAAaBAEEAQARBAIEAgAaBAMEAwARBAQEBAAaBAUEBQARBAYEBgAaBAgECAAVBAoECgAVBAwEDAAVBA4EDgAVBBAEEAAVBBIEEgAVBBQEFAAVBBYEFgAVBBsEGwAFBBwEHAAIBB0EHQAFBB4EHgAIBB8EHwAFBCAEIAAIBCEEIQAFBCIEIgAIBCMEIwAFBCQEJAAIBCUEJQAFBCYEJgAIBCcEJwAFBCgEKAAIBCkEKQAFBCoEKgAVBCsEKwAFBCwELAAVBC0ELQAFBC4ELgAVBC8ELwAFBDAEMAAIBDEEMQAFBDIEMgAVBDMEMwAGBDQENAALBDUENQAGBDYENgALBDgEOAALBDoEOgALBDwEPAALBD4EPgALBEAEQAALBEEEQQAOBEIEQgACBEMEQwAOBEQERAACBEUERQAOBEYERgACBEoESgAYBEwETAAYBE0ETQAKBE8ETwASBFAEUAAWBFEEUQAPBFIEUgADBFMEUwAPBFQEVAADBFYEVgAYBFcEVwASBFgEWAAWBGMEYwAYBGUEZQAYBGcEZwAYBGgEaAABBGkEaQAEBGoEagAOBHAEcAAXBKoEqgAFAAEAAAAKAgYG8AAEREZMVAAaY3lybABIZ3JlawB2bGF0bgCkAAQAAAAA//8AEgAAAAoAFAAeACgANABBAEsAVQBfAGkAcwB9AIcAkQCbAKUArwAEAAAAAP//ABIAAQALABUAHwApADUAQgBMAFYAYABqAHQAfgCIAJIAnACmALAABAAAAAD//wASAAIADAAWACAAKgA2AEMATQBXAGEAawB1AH8AiQCTAJ0ApwCxACgABkFaRSAAVENSVCAAfk1PTCAAqE5BViAA1FJPTSABAFRVUiABLAAA//8AEwADAA0AFwAhACsAMgA3AEQATgBYAGIAbAB2AIAAigCUAJ4AqACyAAD//wASAAQADgAYACIALAA4AEUATwBZAGMAbQB3AIEAiwCVAJ8AqQCzAAD//wASAAUADwAZACMALQA5AEYAUABaAGQAbgB4AIIAjACWAKAAqgC0AAD//wATAAYAEAAaACQALgA6AD4ARwBRAFsAZQBvAHkAgwCNAJcAoQCrALUAAP//ABMABwARABsAJQAvADsAPwBIAFIAXABmAHAAegCEAI4AmACiAKwAtgAA//8AEwAIABIAHAAmADAAPABAAEkAUwBdAGcAcQB7AIUAjwCZAKMArQC3AAD//wATAAkAEwAdACcAMQAzAD0ASgBUAF4AaAByAHwAhgCQAJoApACuALgAuWMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmxpZ2EEfGxpZ2EEhGxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxvY2wEkGxvY2wElmxvY2wEnG51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqHBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5AAAAAEAAAAAAAIAAgADAAAAAQAHAAAAAQAYAAAAAwAVABYAFwAAAAIACAAJAAAAAQAJAAAAAQAUAAAAAQAEAAAAAQAGAAAAAQAFAAAAAQAZAAAAAQARAAAAAQATAAAAAQABAAAAAQAKAAAAAQALAAAAAQAMAAAAAQANAAAAAQAOAAAAAQAPAAAAAQAQAAAAAQASABsAOAPGBrQHYA3wDfAOBg4oDl4OhA6yDsYO2g7uDwAPGg9cD3oPmA/KD/wQLhBCEHoQbBB6EKYAAQAAAAEACAACAcQA3wHnAboBuwG8Ab0BvgG/AcABwQHCAcMBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0AHRAdIB0wHoAekCRAI7AeoB6wHsAe0B7gHvAfAB8QHyAfMB9AH1AfYB9wH4AfkB+gH7AfwB/QH+AgACAQTdAgICAwIEAgUCBgIHAggCCQIKAgsCLwIPAhACEQIUAhUCFgIXAhgCGQIbAhwCHgIdAvwC/QL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZAxoDGwMcAx0DHgMfAyADIQMiAyMDJAMlAyYDJwMoAykDKgMrAywDLQMuAy8DMAMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNPA1ADUQNSBKsErAStBK4ErwSwBLEEsgSzBLQEtQS2BLcEuAS5BLoEuwS8BL0EvgS/BMAEwQTCBMMExATFBMYB/wTHBMgEyQTKBMsEzATNBM4EzwTQBNEE0gTTBNQE1QTWBNgE2QTbAhoE3AIOBNcCEwINBNoCDAISAAEA3wAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAhQCSALAAsQCyALMAtAC1ALYAtwC4ALkA0QDSANMA1ADVANYA1wDYANkA2gDbANwA3QDeAN8A4ADhAOIA4wDkAOUA5gDnAOgBLAEwATIBOAE6ATwBPgE/AUUBRgF/AYUBigGNAkcCSAJKAkwCTQJOAk8CUAJRAlICUwJUAlUCVgJXAlgCWQJaAlsCXAJdAl4CXwJgAmECYgJjAmQCZQJmAoMChQKHAokCiwKNAo8CkQKTApUClwKZApsCnQKfAqECowKlAqcCqQKrAq0CrwKyArQCtgK4AroCvAK+AsACwgLFAscCyQLLAs0CzwLRAtMC1QLZAtsC3QLfAuEC4wLlAucC6QLrAu0C7wLxAvIC9AL2A1MDVANVA1YDVwNYA1kDWwNcA10DXgNfA2ADYQNiA2QDZQNmA2cDaANpA2oDegN7A3wDfQN+A38DgAOBA4IDgwOEA4UDhgOHA4gDiQOKA4sDjAONA44DjwO7A70DvwPUA9oD4ARJBEsETwRXBFkEXgRqAAEAAAABAAgAAgF0ALcBugG7AbwBvQG+Ab8BwAHBAcIBwwHEAcUBxgHHAcgByQHKAcsBzAHNAc4BzwHQAdEB0gHTAv0DMAI7AfoEygTLAfsB/AH9Af4B/wIABM4EzwTRBNQE3QICAgMCBAIFAgYCBwIIAgkCCgILAfQB9QH2AfcB+AH5Ai8CDwIQAhECFAIVAhcCGQL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZA08DGgMbAxwDHQMeAx8DIAMhAyIDIwMkAyUDJgMnAygDKQMqAysDLAMtAy4DLwMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNQA1EDUgTJBMwEzQTQBNIE0wIBBNUEwQTCBMMExATFBMYExwTIBNYE2ATZAhgE2wIaBNwC/AIOBNcCEwINBNoCFgIMAhIAAQC3AEUARgBHAEgASQBKAEsATABNAE4ATwBQAFEAUgBTAFQAVQBWAFcAWABZAFoAWwBcAF0AXgCHAIwAkwDpAOoA6wDsAO0A7gDvAPAA8QDyAPMA9AD1APYA9wD4APkA+gD7APwA/QD+AP8BAAEBAQIBAwEEAQUBBgEtATEBMwE5ATsBPQFAAUcCSwJnAmgCaQJqAmsCbAJtAm4CbwJwAnECcgJzAnQCdQJ2AncCeAJ5AnoCewJ8An0CfgJ/AoACgQKCAoQChgKIAooCjAKOApACkgKUApYCmAKaApwCngKgAqICpAKmAqgCqgKsAq4CswK1ArcCuQK7Ar0CvwLBAsMCxgLIAsoCzALOAtAC0gLUAtYC2gLcAt4C4ALiAuQC5gLoAuoC7ALuAvAC8wL1AvcDkAORA5IDkwOUA5UDlgOXA5gDmQOaA5sDnAOdA54DnwO8A74DwAPOA9UD2wPhBEcESgRMBFAEWARaBFsEXwRrAAYAAAAGABIAKgBCAFoAcgCKAAMAAAABABIAAQCQAAEAAAAaAAEAAQBNAAMAAAABABIAAQB4AAEAAAAaAAEAAQBOAAMAAAABABIAAQBgAAEAAAAaAAEAAQKuAAMAAAABABIAAQBIAAEAAAAaAAEAAQObAAMAAAABABIAAQAwAAEAAAAaAAEAAQOdAAMAAAABABIAAQAYAAEAAAAaAAEAAQQaAAIAAQCnAKsAAAAEAAAAAQAIAAEGHgA2AHIApACuALgAygD8AQ4BGAFKAWQBfgGQAboB7AH2AhgCMgJEAnYCiAKiAswC3gMQAxoDJAM2A2gDcgN8A4YDoAO6A8wD9gQoBDIEVARuBIAEsgTEBN4FCAUaBSQFLgU4BUIFbAWWBcAF6gYUAAYADgAUABoAIAAmACwCTAACAKcCTQACAKgCTwACAKkD8QACAKoEewACAKsD7wACAKwAAQAEBIgAAgCsAAEABAKJAAIAqAACAAYADASKAAIArASMAAIBogAGAA4AFAAaACAAJgAsAlQAAgCnAlUAAgCoBAsAAgCpBAkAAgCqBH0AAgCrBAcAAgCsAAIABgAMBHcAAgCoAqMAAgGiAAEABASOAAIArAAGAA4AFAAaACAAJgAsAlgAAgCnAlkAAgCoAqcAAgCpBBcAAgCqBH8AAgCrBBkAAgCsAAMACAAOABQEkAACAKgEkgACAKwCtAACAaIAAwAIAA4AFAK2AAIAqASUAAIArAK4AAIBogACAAYADAOtAAIAqASWAAIArAAFAAwAEgAYAB4AJAR5AAIApwK+AAIAqAJcAAIAqQSYAAIArALAAAIBogAGAA4AFAAaACAAJgAsAl0AAgCnAl4AAgCoAmAAAgCpBB0AAgCqBIEAAgCrBBsAAgCsAAEABASaAAIAqAAEAAoAEAAWABwCywACAKgEgwACAKsEnAACAKwCzQACAaIAAwAIAA4AFALRAAIAqASeAAIArALXAAIBogACAAYADASgAAIArALbAAIBogAGAA4AFAAaACAAJgAsAmIAAgCnAmMAAgCoAuEAAgCpBDUAAgCqBIUAAgCrBDMAAgCsAAIABgAMBKIAAgCpBKQAAgCsAAMACAAOABQDoAACAKcDogACAKgEpgACAKwABQAMABIAGAAeACQDpgACAKcCZgACAKgERQACAKkEQwACAKoEQQACAKwAAgAGAAwC8gACAKgEqAACAKwABgAOABQAGgAgACYALAJnAAIApwJoAAIAqAJqAAIAqQPyAAIAqgR8AAIAqwPwAAIArAABAAQEiQACAKwAAQAEAooAAgCoAAIABgAMBIsAAgCsBI0AAgGiAAYADgAUABoAIAAmACwCbwACAKcCcAACAKgEDAACAKkECgACAKoEfgACAKsECAACAKwAAQAEBHgAAgCoAAEABASPAAIArAABAAQEGgACAKwAAwAIAA4AFASRAAIAqASTAAIArAK1AAIBogADAAgADgAUArcAAgCoBJUAAgCsArkAAgGiAAIABgAMA64AAgCoBJcAAgCsAAUADAASABgAHgAkBHoAAgCnAr8AAgCoAncAAgCpBJkAAgCsAsEAAgGiAAYADgAUABoAIAAmACwCeAACAKcCeQACAKgCewACAKkEHgACAKoEggACAKsEHAACAKwAAQAEBJsAAgCoAAQACgAQABYAHALMAAIAqASEAAIAqwSdAAIArALOAAIBogADAAgADgAUAtIAAgCoBJ8AAgCsAtgAAgGiAAIABgAMBKEAAgCsAtwAAgGiAAYADgAUABoAIAAmACwCfQACAKcCfgACAKgC4gACAKkENgACAKoEhgACAKsENAACAKwAAgAGAAwEowACAKkEpQACAKwAAwAIAA4AFAOhAAIApwOjAAIAqASnAAIArAAFAAwAEgAYAB4AJAOnAAIApwKBAAIAqARGAAIAqQREAAIAqgRCAAIArAACAAYADALzAAIAqASpAAIArAABAAQC+AACAKgAAQAEAvoAAgCoAAEABAL5AAIAqAABAAQC+wACAKgABQAMABIAGAAeACQCcwACAKcCdAACAKgCqAACAKkEGAACAKoEgAACAKsABQAMABIAGAAeACQEKwACAKcEKQACAKgELwACAKkELQACAKoEMQACAKwABQAMABIAGAAeACQELAACAKcEKgACAKgEMAACAKkELgACAKoEMgACAKwABQAMABIAGAAeACQEOQACAKcENwACAKgEPQACAKkEOwACAKoEPwACAKwABQAMABIAGAAeACQEOgACAKcEOAACAKgEPgACAKkEPAACAKoEQAACAKwAAQAEBIcAAgCoAAIAEQAlACkAAAArAC0ABQAvADQACAA2ADsADgA9AD4AFABFAEkAFgBLAE0AGwBPAFQAHgBWAFsAJABdAF4AKgCBAIEALACDAIMALQCGAIYALgCJAIkALwCMAIwAMACXAJoAMQDPAM8ANQABAAAAAQAIAAEABgACAAEAAgLVAtYAAQAAAAEACAACAA4ABATeBN8E4AThAAEABAKHAogCmQKaAAQAAAABAAgAAQAmAAIACgAcAAIABgAMAaMAAgBKAagAAgBYAAEABAGpAAIAWAABAAIASgBXAAQAAAABAAgAAQBEAAIACgAUAAEABAGkAAIATQABAAQBpgACAE0ABAAAAAEACAABAB4AAgAKABQAAQAEAaUAAgBQAAEABAGnAAIAUAABAAIASgGjAAEAAAABAAgAAQAGAZUAAQABAEsAAQAAAAEACAABAAYBJwABAAEAugABAAAAAQAIAAEABgGsAAEAAQA2AAEAAAABAAgAAgAcAAIB4wHkAAEAAAABAAgAAgAKAAIB5QHmAAEAAgAvAE8AAQAAAAEACAACAB4ADAIoAioCKQIrAiwCHwIgAiECIgGuAiQCJQABAAwAJwAoACsAMwA1AEYARwBIAEsAUwBUAFUAAQAAAAEACAACAAwAAwImAicCJwABAAMASQBLAiIAAQAAAAEACAACAGYACAI9Ai0CLgIwAjECOQI6AjwAAQAAAAEACAACABYACAAbABUAFgAXABgAGQAdABQAAQAIAa0CIwRxBHIEcwR0BHUEdgABAAAAAQAIAAIAFgAIBHYCIwRxBHIEcwR0Aa0EdQABAAgAFAAVABYAFwAYABkAGwAdAAEAAAABAAgAAgAWAAgAFQAWABcAGAAZABsAHQAUAAEACAItAi4CMAIxAjkCOgI8Aj0AAQAAAAEACAABAAYBaQABAAEAEwAGAAAAAQAIAAMAAQASAAEAUgAAAAEAAAAaAAIAAgF8AXwAAAHUAd0AAQABAAAAAQAIAAEAKAHAAAEAAAABAAgAAgAaAAoCMgB6AHMAdAIzAjQCNQI2AjcCOAACAAEAFAAdAAAAAQAAAAEACAACACYAEAHUAdUB1gHXAdgB2QHaAdsB3AHdAkACPgJBAkICPwJDAAEAEAAUABUAFgAXABgAGQAaABsAHAAdAE0ATgKuA5sDnQQa"
	};

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1484);

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	(function() {
	    'use strict';
	
	    /*
	     * Encapsulation of Nick Galbreath's base64.js library for AngularJS
	     * Original notice included below
	     */
	
	    /*
	     * Copyright (c) 2010 Nick Galbreath
	     * http://code.google.com/p/stringencoders/source/browse/#svn/trunk/javascript
	     *
	     * Permission is hereby granted, free of charge, to any person
	     * obtaining a copy of this software and associated documentation
	     * files (the "Software"), to deal in the Software without
	     * restriction, including without limitation the rights to use,
	     * copy, modify, merge, publish, distribute, sublicense, and/or sell
	     * copies of the Software, and to permit persons to whom the
	     * Software is furnished to do so, subject to the following
	     * conditions:
	     *
	     * The above copyright notice and this permission notice shall be
	     * included in all copies or substantial portions of the Software.
	     *
	     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	     * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	     * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	     * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	     * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	     * OTHER DEALINGS IN THE SOFTWARE.
	     */
	
	    /* base64 encode/decode compatible with window.btoa/atob
	     *
	     * window.atob/btoa is a Firefox extension to convert binary data (the "b")
	     * to base64 (ascii, the "a").
	     *
	     * It is also found in Safari and Chrome.  It is not available in IE.
	     *
	     * if (!window.btoa) window.btoa = base64.encode
	     * if (!window.atob) window.atob = base64.decode
	     *
	     * The original spec's for atob/btoa are a bit lacking
	     * https://developer.mozilla.org/en/DOM/window.atob
	     * https://developer.mozilla.org/en/DOM/window.btoa
	     *
	     * window.btoa and base64.encode takes a string where charCodeAt is [0,255]
	     * If any character is not [0,255], then an exception is thrown.
	     *
	     * window.atob and base64.decode take a base64-encoded string
	     * If the input length is not a multiple of 4, or contains invalid characters
	     *   then an exception is thrown.
	     */
	
	    angular.module('base64', []).constant('$base64', (function() {
	
	        var PADCHAR = '=';
	
	        var ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	        function getbyte64(s,i) {
	            var idx = ALPHA.indexOf(s.charAt(i));
	            if (idx == -1) {
	                throw "Cannot decode base64";
	            }
	            return idx;
	        }
	
	        function decode(s) {
	            // convert to string
	            s = "" + s;
	            var pads, i, b10;
	            var imax = s.length;
	            if (imax == 0) {
	                return s;
	            }
	
	            if (imax % 4 != 0) {
	                throw "Cannot decode base64";
	            }
	
	            pads = 0;
	            if (s.charAt(imax -1) == PADCHAR) {
	                pads = 1;
	                if (s.charAt(imax -2) == PADCHAR) {
	                    pads = 2;
	                }
	                // either way, we want to ignore this last block
	                imax -= 4;
	            }
	
	            var x = [];
	            for (i = 0; i < imax; i += 4) {
	                b10 = (getbyte64(s,i) << 18) | (getbyte64(s,i+1) << 12) |
	                    (getbyte64(s,i+2) << 6) | getbyte64(s,i+3);
	                x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff, b10 & 0xff));
	            }
	
	            switch (pads) {
	                case 1:
	                    b10 = (getbyte64(s,i) << 18) | (getbyte64(s,i+1) << 12) | (getbyte64(s,i+2) << 6);
	                    x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff));
	                    break;
	                case 2:
	                    b10 = (getbyte64(s,i) << 18) | (getbyte64(s,i+1) << 12);
	                    x.push(String.fromCharCode(b10 >> 16));
	                    break;
	            }
	            return x.join('');
	        }
	
	        function getbyte(s,i) {
	            var x = s.charCodeAt(i);
	            if (x > 255) {
	                throw "INVALID_CHARACTER_ERR: DOM Exception 5";
	            }
	            return x;
	        }
	
	        function encode(s) {
	            if (arguments.length != 1) {
	                throw "SyntaxError: Not enough arguments";
	            }
	
	            var i, b10;
	            var x = [];
	
	            // convert to string
	            s = "" + s;
	
	            var imax = s.length - s.length % 3;
	
	            if (s.length == 0) {
	                return s;
	            }
	            for (i = 0; i < imax; i += 3) {
	                b10 = (getbyte(s,i) << 16) | (getbyte(s,i+1) << 8) | getbyte(s,i+2);
	                x.push(ALPHA.charAt(b10 >> 18));
	                x.push(ALPHA.charAt((b10 >> 12) & 0x3F));
	                x.push(ALPHA.charAt((b10 >> 6) & 0x3f));
	                x.push(ALPHA.charAt(b10 & 0x3f));
	            }
	            switch (s.length - imax) {
	                case 1:
	                    b10 = getbyte(s,i) << 16;
	                    x.push(ALPHA.charAt(b10 >> 18) + ALPHA.charAt((b10 >> 12) & 0x3F) +
	                        PADCHAR + PADCHAR);
	                    break;
	                case 2:
	                    b10 = (getbyte(s,i) << 16) | (getbyte(s,i+1) << 8);
	                    x.push(ALPHA.charAt(b10 >> 18) + ALPHA.charAt((b10 >> 12) & 0x3F) +
	                        ALPHA.charAt((b10 >> 6) & 0x3f) + PADCHAR);
	                    break;
	            }
	            return x.join('');
	        }
	
	        return {
	            encode: encode,
	            decode: decode
	        };
	    })());
	
	})();


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _globalConfig = __webpack_require__(238);
	
	var _globalConfig2 = _interopRequireDefault(_globalConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  /**
	   * Config
	   */
	  var moduleName = 'ngBreadCrumb';
	  var _templateUrl = 'ngBreadCrumbTemplate.html';
	
	  /**
	   * Module
	   */
	  var module;
	  // try {
	  //     module = angular.module(moduleName);
	  // } catch (err) {
	  //     // named module does not exist, so create one
	  //     module = angular.module(moduleName, ['ui.router']);
	  // }
	  angular.module(moduleName, []).directive('uiBreadcrumbs', ['$interpolate', '$state', '$stateParams', '$rootScope', '$cookies', 'GlobalSrv', '$interval', 'GlobalConfig', uiBreadcrumbs]);
	
	  function uiBreadcrumbs($interpolate, $state, $stateParams, $rootScope, $cookies, GlobalSrv, $interval, GlobalConfig) {
	    return {
	      restrict: 'E',
	      templateUrl: function templateUrl(elem, attrs) {
	        return attrs.templateUrl || _templateUrl;
	      },
	      scope: {
	        displaynameProperty: '@',
	        abstractProxyProperty: '@?'
	      },
	      link: function link(scope) {
	        scope.breadcrumbs = [];
	        var roleId = false;
	        //let roleId = $cookies.get('hasRoleId')
	
	        var getCurrentUser = $interval(function () {
	          var cookieUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false;
	          if (cookieUser) {
	            roleId = $cookies.get('hasRoleId') ? JSON.parse($cookies.get('hasRoleId')) : false;
	            if (roleId) {
	              loadContent();
	              $interval.cancel(getCurrentUser);
	            }
	          }
	        }, 500);
	
	        function loadContent() {
	          if ($state.$current.name !== '') {
	            updateBreadcrumbsArray();
	            if (scope.breadcrumbs[1] && !scope.breadcrumbs[1].order) {
	              scope.breadcrumbs.shift();
	            }
	          }
	
	          scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
	            updateBreadcrumbsArray();
	            if (scope.breadcrumbs[1] && !scope.breadcrumbs[1].order) {
	              scope.breadcrumbs.shift();
	            }
	            $rootScope.previousState = to;
	          });
	        }
	
	        function filterOptions(breadcrumbs, callback) {
	          var currentUser = JSON.parse($cookies.get('currentUser'));
	          var breadcrumbsNew = [];
	          var params = {
	            ID_ROLE: roleId,
	            ID_TEACHER: $stateParams.teacherId,
	            ID_USER: currentUser.id,
	            WORKPLAN_ID: $stateParams.workplanId
	          };
	          GlobalSrv.roles.getAccessModules(params).$promise.then(function (response) {
	            console.log("response--------->", response);
	            //console.log("breadcrumbs--/->",breadcrumbs)
	            if (!response.status) {
	              console.log('Ocurrio un error en el servicio');
	            } else {
	              for (var i in breadcrumbs) {
	                for (var x in response.data) {
	                  if (breadcrumbs[i].displayName.toLowerCase() == response.data[x].ds_name.toLowerCase() || breadcrumbs[i].displayName.toLowerCase() == 'resumen' || breadcrumbs[i].displayName.toLowerCase() == 'inicio') //|| breadcrumbs[i].displayName.toLowerCase() == 'inicio'
	                    {
	                      breadcrumbsNew.push(breadcrumbs[i]);
	                      break;
	                    }
	                }
	              }
	              // console.log("breadcrumbsNew--->",breadcrumbsNew)
	              callback(breadcrumbsNew);
	            }
	          }, function (err) {
	            console.log('Imposible conectar con el servicio');
	          });
	        }
	        /**
	         * Start with the current state and traverse up the path to build the
	         * array of breadcrumbs that can be used in an ng-repeat in the template.
	         */
	        function updateBreadcrumbsArray() {
	          var currentState = $state.$current;
	          var breadcrumbs = setSiblingsOnBreadcrumbsArray(currentState);
	          if (roleId == _globalConfig2.default.userRolesIds.reviewer && ($stateParams.stage == GlobalConfig.workplanStages.reviewExecution || $stateParams.stage == GlobalConfig.workplanStages.review)) {
	            filterOptions(breadcrumbs, function (data) {
	              buildingBreadcrumbs(data, currentState);
	            });
	          } else {
	            buildingBreadcrumbs(breadcrumbs, currentState);
	          }
	        }
	
	        function buildingBreadcrumbs(breadcrumbs, currentState) {
	          var workingState;
	          var displayName;
	
	          if (currentState && currentState.name !== '') {
	            workingState = getWorkingState(currentState);
	            if (workingState) {
	              displayName = getDisplayName(workingState);
	              if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs) && displayName !== "Inicio") //&& displayName !== "Inicio"
	                {
	                  var active = false;
	                  var order = null;
	                  var route = null;
	                  if (workingState == $state.$current) {
	                    active = true;
	                    order = workingState.data ? workingState.data.order : null;
	                  }
	
	                  if (workingState.redirectTo) {
	                    route = $state.href(workingState.redirectTo);
	                  } else {
	                    route = $state.href(workingState.name);
	                  }
	
	                  breadcrumbs.push({
	                    displayName: displayName,
	                    route: route,
	                    active: active,
	                    order: order
	                  });
	                }
	            }
	            currentState = currentState.parent;
	          }
	          breadcrumbs.sort(function (a, b) {
	            if (b.order == null) return 1;
	            return a.order - b.order;
	          });
	          scope.breadcrumbs = breadcrumbs;
	        }
	
	        /**
	         * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
	         * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
	         * set it to `false` which means this breadcrumb level will be skipped entirely.
	         * @param currentState
	         * @returns {*}
	         */
	        function getWorkingState(currentState) {
	          var proxyStateName;
	          var workingState = currentState;
	          if (currentState.abstract === true) {
	            if (typeof scope.abstractProxyProperty !== 'undefined') {
	              proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
	              if (proxyStateName) {
	                workingState = $state.get(proxyStateName);
	              } else {
	                workingState = false;
	              }
	            } else {
	              workingState = false;
	            }
	          }
	          return workingState;
	        }
	
	        /**
	         * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
	         * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
	         * properties on the state config object, by using the usual {{ }} syntax.
	         * @param currentState
	         * @returns {*}
	         */
	        function getDisplayName(currentState) {
	          var interpolationContext;
	          var propertyReference;
	          var displayName;
	
	          if (!scope.displaynameProperty) {
	            // if the displayname-property attribute was not specified, default to the state's name
	            return currentState.name;
	          }
	          propertyReference = getObjectValue(scope.displaynameProperty, currentState);
	
	          if (propertyReference === false) {
	            return false;
	          } else if (typeof propertyReference === 'undefined') {
	            return currentState.name;
	          } else {
	            // use the $interpolate service to handle any bindings in the propertyReference string.
	            interpolationContext = typeof currentState.locals !== 'undefined' ? currentState.locals.globals : currentState;
	            displayName = $interpolate(propertyReference)(interpolationContext);
	            return displayName;
	          }
	        }
	
	        /**
	         * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
	         * value found at that path.
	         *
	         * @param objectPath
	         * @param context
	         * @returns {*}
	         */
	        function getObjectValue(objectPath, context) {
	          var i;
	          var propertyArray = objectPath.split('.');
	          var propertyReference = context;
	
	          for (i = 0; i < propertyArray.length; i++) {
	            if (angular.isDefined(propertyReference[propertyArray[i]])) {
	              propertyReference = propertyReference[propertyArray[i]];
	            } else {
	              // if the specified property was not found, default to the state's name
	              return undefined;
	            }
	          }
	          return propertyReference;
	        }
	
	        /**
	         * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
	         * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
	         * @param state
	         * @param breadcrumbs
	         * @returns {boolean}
	         */
	        function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
	          var i;
	          var alreadyUsed = false;
	          for (i = 0; i < breadcrumbs.length; i++) {
	            if (breadcrumbs[i].route === state.name) {
	              alreadyUsed = true;
	            }
	          }
	          return alreadyUsed;
	        }
	
	        function setSiblingsOnBreadcrumbsArray(currentState) {
	          var displayName = void 0;
	          var breadcrumbs = [];
	          var workingState = getWorkingState(currentState);
	          //console.log("workingState", workingState)
	          if (workingState && workingState.data && workingState.data.siblings) {
	            for (var i = workingState.data.siblings.length - 1; i >= 0; i--) {
	              var workingStateSibling = $state.get(workingState.data.siblings[i].name);
	              //console.log("workingStateSibling------>",workingStateSibling)
	              if (workingStateSibling) {
	                displayName = getDisplayName(workingStateSibling);
	                var order = workingState.data.siblings[i].order;
	                var rolesAllowed = workingState.data.siblings[i].rolesAllowed || [];
	                var hideLink = workingState.data.siblings[i].hideLink;
	                var params = workingState.data.siblings[i].params;
	                var paramsRoute = {};
	                if (params) {
	                  for (var param in params) {
	                    paramsRoute[param] = $stateParams[params[param]];
	                  }
	                }
	                //console.log("workingState.data", workingState.data)
	                var route = $state.href(workingStateSibling.name, paramsRoute);
	
	                if (displayName !== false) {
	                  if (rolesAllowed.length > 0 && rolesAllowed.findIndex(function (el) {
	                    return el == roleId;
	                  }) >= 0 || rolesAllowed.length == 0) {
	                    breadcrumbs.push({
	                      displayName: displayName,
	                      route: route,
	                      order: order,
	                      hideLink: hideLink
	                    });
	                  }
	                }
	              }
	            }
	          }
	          return breadcrumbs;
	        }
	      }
	    };
	  };
	})(); /**
	       * uiBreadcrumbs automatic breadcrumbs directive for AngularJS & Angular ui-router.
	       *
	       * https://github.com/michaelbromley/angularUtils/tree/master/src/directives/uiBreadcrumbs
	       *
	       * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
	       */

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	(function () {
	  angular.module('uplannerPermission', []).factory('permissions', ['$rootScope', permissions]).directive('hasPermission', ['permissions', hasPermission]).directive('hasDisabled', ['permissions', hasDisabled]).run(['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'permissions', 'permissionList', function ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, permissions, permissionList) {
	    $rootScope.$state = $state;
	    $rootScope.$stateParams = $stateParams;
	    // console.log("run",permissionList )
	    permissions.setPermissions(permissionList);
	  }]);
	  function hasPermission(permissions) {
	    return {
	      link: link
	    };
	    function link(scope, element, attrs) {
	      //console.log("--------");
	
	      if (!_.isString(attrs.hasPermission)) {
	        throw 'hasPermission value must be a string';
	      }
	      var value = attrs.hasPermission.trim();
	      var notPermissionFlag = value[0] === '!';
	      // console.log('vignesh',value+'',notPermissionFlag);
	      if (notPermissionFlag) {
	        value = value.slice(1).trim();
	      }
	
	      function toggleVisibilityBasedOnPermission() {
	
	        var hasPermission = permissions.hasPermission(value);
	        // console.log("permissionsChang", value)
	        if (hasPermission) {
	          // console.log("true , permision chan" , element)
	          $(element).show();
	        } else {
	          // console.log("false , permision chan" , element)
	          $(element).hide();
	        }
	      }
	      function toggleVisibilityBasedOnPermissionDisabled() {
	
	        var hasPermission = permissions.hasPermission(value);
	        // console.log("permissionsChang", value)
	        if (hasPermission) {
	          // console.log("true , permision chan" , element)
	          $(element).prop("disabled", false);
	        } else {
	          // console.log("false , permision chan" , element)
	          $(element).prop("disabled", true);
	        }
	      }
	      toggleVisibilityBasedOnPermission();
	      scope.$on('permissionsChanged', toggleVisibilityBasedOnPermission);
	    }
	  }
	  function hasDisabled(permissions) {
	    return {
	      link: link
	    };
	    function link(scope, element, attrs) {
	      console.log("link disabled");
	
	      if (!_.isString(attrs.hasDisabled)) {
	        throw 'hasDisabled value must be a string';
	      }
	      var value = attrs.hasDisabled.trim();
	      var notPermissionFlag = value[0] === '!';
	      // console.log('vignesh',value+'',notPermissionFlag);
	      if (notPermissionFlag) {
	        value = value.slice(1).trim();
	      }
	      console.log("value--->", value);
	
	      function toggleVisibilityBasedOnPermission() {
	
	        var hasPermission = permissions.hasPermission(value);
	        !hasPermission ? $(element).attr("disabled", "disabled").off('click') : $(element).removeAttr("disabled");
	      }
	
	      toggleVisibilityBasedOnPermission();
	      scope.$on('permissionsChanged', toggleVisibilityBasedOnPermission);
	    }
	  }
	  function permissions($rootScope) {
	
	    var permissionList;
	    return {
	      setPermissions: setPermissions,
	      hasPermission: hasPermission
	    };
	    function setPermissions(permission) {
	      permissionList = permission;
	      // console.log("setPermissions", $rootScope.$broadcast)
	
	      $rootScope.$broadcast('permissionsChanged');
	    }
	    function hasPermission(permission) {
	      /* console.log(permission')
	      ;            console.log(permissionList); */
	      /*permission = permission.trim();
	      console.log(typeof permissionList);*/
	      // console.log("change peermission ",permissionList)
	      if (typeof permissionList !== 'undefined') {
	        //console.log("permissionList[permission]-->",permissionList[permission] )
	        if (typeof permissionList[permission] === 'undefined') {
	          // console.log("false")
	          // return false;
	          return false; // false para que valide las funcionalidades
	        } else {
	          return permissionList[permission];
	        }
	      }
	    }
	  }
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(149)))

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	/*!
	 * ui-grid - v3.0.7 - 2015-10-06
	 * Copyright (c) 2015 ; License: MIT 
	 */
	
	(function () {
	  'use strict';
	  angular.module('ui.grid.i18n', []);
	  angular.module('ui.grid', ['ui.grid.i18n']);
	})();
	(function () {
	  'use strict';
	  angular.module('ui.grid').constant('uiGridConstants', {
	    LOG_DEBUG_MESSAGES: true,
	    LOG_WARN_MESSAGES: true,
	    LOG_ERROR_MESSAGES: true,
	    CUSTOM_FILTERS: /CUSTOM_FILTERS/g,
	    COL_FIELD: /COL_FIELD/g,
	    MODEL_COL_FIELD: /MODEL_COL_FIELD/g,
	    TOOLTIP: /title=\"TOOLTIP\"/g,
	    DISPLAY_CELL_TEMPLATE: /DISPLAY_CELL_TEMPLATE/g,
	    TEMPLATE_REGEXP: /<.+>/,
	    FUNC_REGEXP: /(\([^)]*\))?$/,
	    DOT_REGEXP: /\./g,
	    APOS_REGEXP: /'/g,
	    BRACKET_REGEXP: /^(.*)((?:\s*\[\s*\d+\s*\]\s*)|(?:\s*\[\s*"(?:[^"\\]|\\.)*"\s*\]\s*)|(?:\s*\[\s*'(?:[^'\\]|\\.)*'\s*\]\s*))(.*)$/,
	    COL_CLASS_PREFIX: 'ui-grid-col',
	    events: {
	      GRID_SCROLL: 'uiGridScroll',
	      COLUMN_MENU_SHOWN: 'uiGridColMenuShown',
	      ITEM_DRAGGING: 'uiGridItemDragStart', // For any item being dragged
	      COLUMN_HEADER_CLICK: 'uiGridColumnHeaderClick'
	    },
	    // copied from http://www.lsauer.com/2011/08/javascript-keymap-keycodes-in-json.html
	    keymap: {
	      TAB: 9,
	      STRG: 17,
	      CAPSLOCK: 20,
	      CTRL: 17,
	      CTRLRIGHT: 18,
	      CTRLR: 18,
	      SHIFT: 16,
	      RETURN: 13,
	      ENTER: 13,
	      BACKSPACE: 8,
	      BCKSP: 8,
	      ALT: 18,
	      ALTR: 17,
	      ALTRIGHT: 17,
	      SPACE: 32,
	      WIN: 91,
	      MAC: 91,
	      FN: null,
	      PG_UP: 33,
	      PG_DOWN: 34,
	      UP: 38,
	      DOWN: 40,
	      LEFT: 37,
	      RIGHT: 39,
	      ESC: 27,
	      DEL: 46,
	      F1: 112,
	      F2: 113,
	      F3: 114,
	      F4: 115,
	      F5: 116,
	      F6: 117,
	      F7: 118,
	      F8: 119,
	      F9: 120,
	      F10: 121,
	      F11: 122,
	      F12: 123
	    },
	    ASC: 'asc',
	    DESC: 'desc',
	    filter: {
	      STARTS_WITH: 2,
	      ENDS_WITH: 4,
	      EXACT: 8,
	      CONTAINS: 16,
	      GREATER_THAN: 32,
	      GREATER_THAN_OR_EQUAL: 64,
	      LESS_THAN: 128,
	      LESS_THAN_OR_EQUAL: 256,
	      NOT_EQUAL: 512,
	      SELECT: 'select',
	      INPUT: 'input'
	    },
	
	    aggregationTypes: {
	      sum: 2,
	      count: 4,
	      avg: 8,
	      min: 16,
	      max: 32
	    },
	
	    // TODO(c0bra): Create full list of these somehow. NOTE: do any allow a space before or after them?
	    CURRENCY_SYMBOLS: ['ƒ', '$', '£', '$', '¤', '¥', '៛', '₩', '₱', '฿', '₫'],
	
	    scrollDirection: {
	      UP: 'up',
	      DOWN: 'down',
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: 'none'
	
	    },
	
	    dataChange: {
	      ALL: 'all',
	      EDIT: 'edit',
	      ROW: 'row',
	      COLUMN: 'column',
	      OPTIONS: 'options'
	    },
	    scrollbars: {
	      NEVER: 0,
	      ALWAYS: 1
	      //WHEN_NEEDED: 2
	    }
	  });
	
	})();
	angular.module('ui.grid').directive('uiGridCell', ['$compile', '$parse', 'gridUtil', 'uiGridConstants', function ($compile, $parse, gridUtil, uiGridConstants) {
	  var uiGridCell = {
	    priority: 0,
	    scope: false,
	    require: '?^uiGrid',
	    compile: function() {
	      return {
	        pre: function($scope, $elm, $attrs, uiGridCtrl) {
	          function compileTemplate() {
	            var compiledElementFn = $scope.col.compiledElementFn;
	
	            compiledElementFn($scope, function(clonedElement, scope) {
	              $elm.append(clonedElement);
	            });
	          }
	
	          // If the grid controller is present, use it to get the compiled cell template function
	          if (uiGridCtrl && $scope.col.compiledElementFn) {
	             compileTemplate();
	          }
	          // No controller, compile the element manually (for unit tests)
	          else {
	            if ( uiGridCtrl && !$scope.col.compiledElementFn ){
	              // gridUtil.logError('Render has been called before precompile.  Please log a ui-grid issue');  
	
	              $scope.col.getCompiledElementFn()
	                .then(function (compiledElementFn) {
	                  compiledElementFn($scope, function(clonedElement, scope) {
	                    $elm.append(clonedElement);
	                  });
	                });
	            }
	            else {
	              var html = $scope.col.cellTemplate
	                .replace(uiGridConstants.MODEL_COL_FIELD, 'row.entity.' + gridUtil.preEval($scope.col.field))
	                .replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var cellElement = $compile(html)($scope);
	              $elm.append(cellElement);
	            }
	          }
	        },
	        post: function($scope, $elm, $attrs, uiGridCtrl) {
	          var initColClass = $scope.col.getColClass(false);
	          $elm.addClass(initColClass);
	
	          var classAdded;
	          var updateClass = function( grid ){
	            var contents = $elm;
	            if ( classAdded ){
	              contents.removeClass( classAdded );
	              classAdded = null;
	            }
	
	            if (angular.isFunction($scope.col.cellClass)) {
	              classAdded = $scope.col.cellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	            }
	            else {
	              classAdded = $scope.col.cellClass;
	            }
	            contents.addClass(classAdded);
	          };
	
	          if ($scope.col.cellClass) {
	            updateClass();
	          }
	          
	          // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	          var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN, uiGridConstants.dataChange.EDIT]);
	          
	          // watch the col and row to see if they change - which would indicate that we've scrolled or sorted or otherwise
	          // changed the row/col that this cell relates to, and we need to re-evaluate cell classes and maybe other things
	          var cellChangeFunction = function( n, o ){
	            if ( n !== o ) {
	              if ( classAdded || $scope.col.cellClass ){
	                updateClass();
	              }
	
	              // See if the column's internal class has changed
	              var newColClass = $scope.col.getColClass(false);
	              if (newColClass !== initColClass) {
	                $elm.removeClass(initColClass);
	                $elm.addClass(newColClass);
	                initColClass = newColClass;
	              }
	            }
	          };
	
	          // TODO(c0bra): Turn this into a deep array watch
	/*        shouldn't be needed any more given track by col.name
	          var colWatchDereg = $scope.$watch( 'col', cellChangeFunction );
	*/
	          var rowWatchDereg = $scope.$watch( 'row', cellChangeFunction );
	          
	          
	          var deregisterFunction = function() {
	            dataChangeDereg();
	//            colWatchDereg();
	            rowWatchDereg(); 
	          };
	          
	          $scope.$on( '$destroy', deregisterFunction );
	          $elm.on( '$destroy', deregisterFunction );
	        }
	      };
	    }
	  };
	
	  return uiGridCell;
	}]);
	
	
	(function(){
	
	angular.module('ui.grid')
	.service('uiGridColumnMenuService', [ 'i18nService', 'uiGridConstants', 'gridUtil',
	function ( i18nService, uiGridConstants, gridUtil ) {
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:uiGridColumnMenuService
	 *
	 *  @description Services for working with column menus, factored out
	 *  to make the code easier to understand
	 */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name initialize
	     * @description  Sets defaults, puts a reference to the $scope on
	     * the uiGridController
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {controller} uiGridCtrl the uiGridController for the grid
	     * we're on
	     *
	     */
	    initialize: function( $scope, uiGridCtrl ){
	      $scope.grid = uiGridCtrl.grid;
	
	      // Store a reference to this link/controller in the main uiGrid controller
	      // to allow showMenu later
	      uiGridCtrl.columnMenuScope = $scope;
	
	      // Save whether we're shown or not so the columns can check
	      $scope.menuShown = false;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name setColMenuItemWatch
	     * @description  Setup a watch on $scope.col.menuItems, and update
	     * menuItems based on this.  $scope.col needs to be set by the column
	     * before calling the menu.
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {controller} uiGridCtrl the uiGridController for the grid
	     * we're on
	     *
	     */
	    setColMenuItemWatch: function ( $scope ){
	      var deregFunction = $scope.$watch('col.menuItems', function (n, o) {
	        if (typeof(n) !== 'undefined' && n && angular.isArray(n)) {
	          n.forEach(function (item) {
	            if (typeof(item.context) === 'undefined' || !item.context) {
	              item.context = {};
	            }
	            item.context.col = $scope.col;
	          });
	
	          $scope.menuItems = $scope.defaultMenuItems.concat(n);
	        }
	        else {
	          $scope.menuItems = $scope.defaultMenuItems;
	        }
	      });
	
	      $scope.$on( '$destroy', deregFunction );
	    },
	
	
	    /**
	     * @ngdoc boolean
	     * @name enableSorting
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When enabled, this setting adds sort
	     * widgets to the column header, allowing sorting of the data in the individual column.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name sortable
	     * @description  determines whether this column is sortable
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    sortable: function( $scope ) {
	      if ( $scope.grid.options.enableSorting && typeof($scope.col) !== 'undefined' && $scope.col && $scope.col.enableSorting) {
	        return true;
	      }
	      else {
	        return false;
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name isActiveSort
	     * @description  determines whether the requested sort direction is current active, to
	     * allow highlighting in the menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {string} direction the direction that we'd have selected for us to be active
	     *
	     */
	    isActiveSort: function( $scope, direction ){
	      return (typeof($scope.col) !== 'undefined' && typeof($scope.col.sort) !== 'undefined' &&
	              typeof($scope.col.sort.direction) !== 'undefined' && $scope.col.sort.direction === direction);
	
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name suppressRemoveSort
	     * @description  determines whether we should suppress the removeSort option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    suppressRemoveSort: function( $scope ) {
	      if ($scope.col && $scope.col.suppressRemoveSort) {
	        return true;
	      }
	      else {
	        return false;
	      }
	    },
	
	
	    /**
	     * @ngdoc boolean
	     * @name enableHiding
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When set to false, this setting prevents a user from hiding the column
	     * using the column menu or the grid menu.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name hideable
	     * @description  determines whether a column can be hidden, by checking the enableHiding columnDef option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    hideable: function( $scope ) {
	      if (typeof($scope.col) !== 'undefined' && $scope.col && $scope.col.colDef && $scope.col.colDef.enableHiding === false ) {
	        return false;
	      }
	      else {
	        return true;
	      }
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getDefaultMenuItems
	     * @description  returns the default menu items for a column menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    getDefaultMenuItems: function( $scope ){
	      return [
	        {
	          title: i18nService.getSafeText('sort.ascending'),
	          icon: 'ui-grid-icon-sort-alt-up',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.ASC);
	          },
	          shown: function () {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.ASC);
	          }
	        },
	        {
	          title: i18nService.getSafeText('sort.descending'),
	          icon: 'ui-grid-icon-sort-alt-down',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.DESC);
	          },
	          shown: function() {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.DESC);
	          }
	        },
	        {
	          title: i18nService.getSafeText('sort.remove'),
	          icon: 'ui-grid-icon-cancel',
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.unsortColumn();
	          },
	          shown: function() {
	            return service.sortable( $scope ) &&
	                   typeof($scope.col) !== 'undefined' && (typeof($scope.col.sort) !== 'undefined' &&
	                   typeof($scope.col.sort.direction) !== 'undefined') && $scope.col.sort.direction !== null &&
	                  !service.suppressRemoveSort( $scope );
	          }
	        },
	        {
	          title: i18nService.getSafeText('column.hide'),
	          icon: 'ui-grid-icon-cancel',
	          shown: function() {
	            return service.hideable( $scope );
	          },
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.hideColumn();
	          }
	        },
	        {
	          title: i18nService.getSafeText('columnMenu.close'),
	          screenReaderOnly: true,
	          shown: function(){
	            return true;
	          },
	          action: function($event){
	            $event.stopPropagation();
	          }
	        }
	      ];
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getColumnElementPosition
	     * @description  gets the position information needed to place the column
	     * menu below the column header
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridCol} column the column we want to position below
	     * @param {element} $columnElement the column element we want to position below
	     * @returns {hash} containing left, top, offset, height, width
	     *
	     */
	    getColumnElementPosition: function( $scope, column, $columnElement ){
	      var positionData = {};
	      positionData.left = $columnElement[0].offsetLeft;
	      positionData.top = $columnElement[0].offsetTop;
	      positionData.parentLeft = $columnElement[0].offsetParent.offsetLeft;
	
	      // Get the grid scrollLeft
	      positionData.offset = 0;
	      if (column.grid.options.offsetLeft) {
	        positionData.offset = column.grid.options.offsetLeft;
	      }
	
	      positionData.height = gridUtil.elementHeight($columnElement, true);
	      positionData.width = gridUtil.elementWidth($columnElement, true);
	
	      return positionData;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name repositionMenu
	     * @description  Reposition the menu below the new column.  If the menu has no child nodes
	     * (i.e. it's not currently visible) then we guess it's width at 100, we'll be called again
	     * later to fix it
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridCol} column the column we want to position below
	     * @param {hash} positionData a hash containing left, top, offset, height, width
	     * @param {element} $elm the column menu element that we want to reposition
	     * @param {element} $columnElement the column element that we want to reposition underneath
	     *
	     */
	    repositionMenu: function( $scope, column, positionData, $elm, $columnElement ) {
	      var menu = $elm[0].querySelectorAll('.ui-grid-menu');
	      var containerId = column.renderContainer ? column.renderContainer : 'body';
	      var renderContainer = column.grid.renderContainers[containerId];
	
	      // It's possible that the render container of the column we're attaching to is
	      // offset from the grid (i.e. pinned containers), we need to get the difference in the offsetLeft
	      // between the render container and the grid
	      var renderContainerElm = gridUtil.closestElm($columnElement, '.ui-grid-render-container');
	      var renderContainerOffset = renderContainerElm.getBoundingClientRect().left - $scope.grid.element[0].getBoundingClientRect().left;
	
	      var containerScrollLeft = renderContainerElm.querySelectorAll('.ui-grid-viewport')[0].scrollLeft;
	
	      // default value the last width for _this_ column, otherwise last width for _any_ column, otherwise default to 170
	      var myWidth = column.lastMenuWidth ? column.lastMenuWidth : ( $scope.lastMenuWidth ? $scope.lastMenuWidth : 170);
	      var paddingRight = column.lastMenuPaddingRight ? column.lastMenuPaddingRight : ( $scope.lastMenuPaddingRight ? $scope.lastMenuPaddingRight : 10);
	
	      if ( menu.length !== 0 ){
	        var mid = menu[0].querySelectorAll('.ui-grid-menu-mid');
	        if ( mid.length !== 0 && !angular.element(mid).hasClass('ng-hide') ) {
	          myWidth = gridUtil.elementWidth(menu, true);
	          $scope.lastMenuWidth = myWidth;
	          column.lastMenuWidth = myWidth;
	
	          // TODO(c0bra): use padding-left/padding-right based on document direction (ltr/rtl), place menu on proper side
	          // Get the column menu right padding
	          paddingRight = parseInt(gridUtil.getStyles(angular.element(menu)[0])['paddingRight'], 10);
	          $scope.lastMenuPaddingRight = paddingRight;
	          column.lastMenuPaddingRight = paddingRight;
	        }
	      }
	
	      var left = positionData.left + renderContainerOffset - containerScrollLeft + positionData.parentLeft + positionData.width - myWidth + paddingRight;
	      if (left < positionData.offset){
	        left = positionData.offset;
	      }
	
	      $elm.css('left', left + 'px');
	      $elm.css('top', (positionData.top + positionData.height) + 'px');
	    }
	
	  };
	
	  return service;
	}])
	
	
	.directive('uiGridColumnMenu', ['$timeout', 'gridUtil', 'uiGridConstants', 'uiGridColumnMenuService', '$document',
	function ($timeout, gridUtil, uiGridConstants, uiGridColumnMenuService, $document) {
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridColumnMenu
	 * @description  Provides the column menu framework, leverages uiGridMenu underneath
	 *
	 */
	
	  var uiGridColumnMenu = {
	    priority: 0,
	    scope: true,
	    require: '^uiGrid',
	    templateUrl: 'ui-grid/uiGridColumnMenu',
	    replace: true,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      var self = this;
	
	      uiGridColumnMenuService.initialize( $scope, uiGridCtrl );
	
	      $scope.defaultMenuItems = uiGridColumnMenuService.getDefaultMenuItems( $scope );
	
	      // Set the menu items for use with the column menu. The user can later add additional items via the watch
	      $scope.menuItems = $scope.defaultMenuItems;
	      uiGridColumnMenuService.setColMenuItemWatch( $scope );
	
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name showMenu
	       * @description Shows the column menu.  If the menu is already displayed it
	       * calls the menu to ask it to hide (it will animate), then it repositions the menu
	       * to the right place whilst hidden (it will make an assumption on menu width),
	       * then it asks the menu to show (it will animate), then it repositions the menu again
	       * once we can calculate it's size.
	       * @param {GridCol} column the column we want to position below
	       * @param {element} $columnElement the column element we want to position below
	       */
	      $scope.showMenu = function(column, $columnElement, event) {
	        // Swap to this column
	        $scope.col = column;
	
	        // Get the position information for the column element
	        var colElementPosition = uiGridColumnMenuService.getColumnElementPosition( $scope, column, $columnElement );
	
	        if ($scope.menuShown) {
	          // we want to hide, then reposition, then show, but we want to wait for animations
	          // we set a variable, and then rely on the menu-hidden event to call the reposition and show
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.hideThenShow = true;
	
	          $scope.$broadcast('hide-menu', { originalEvent: event });
	        } else {
	          self.shown = $scope.menuShown = true;
	          uiGridColumnMenuService.repositionMenu( $scope, column, colElementPosition, $elm, $columnElement );
	
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.$broadcast('show-menu', { originalEvent: event });
	        }
	      };
	
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name hideMenu
	       * @description Hides the column menu.
	       * @param {boolean} broadcastTrigger true if we were triggered by a broadcast
	       * from the menu itself - in which case don't broadcast again as we'll get
	       * an infinite loop
	       */
	      $scope.hideMenu = function( broadcastTrigger ) {
	        $scope.menuShown = false;
	        if ( !broadcastTrigger ){
	          $scope.$broadcast('hide-menu');
	        }
	      };
	
	
	      $scope.$on('menu-hidden', function() {
	        if ( $scope.hideThenShow ){
	          delete $scope.hideThenShow;
	
	          uiGridColumnMenuService.repositionMenu( $scope, $scope.col, $scope.colElementPosition, $elm, $scope.colElement );
	          $scope.$broadcast('show-menu');
	
	          $scope.menuShown = true;
	        } else {
	          $scope.hideMenu( true );
	
	          if ($scope.col) {
	            //Focus on the menu button
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + $scope.col.getColClass()+ ' .ui-grid-column-menu-button', $scope.col.grid, false);
	          }
	        }
	      });
	
	      $scope.$on('menu-shown', function() {
	        $timeout( function() {
	          uiGridColumnMenuService.repositionMenu( $scope, $scope.col, $scope.colElementPosition, $elm, $scope.colElement );
	          delete $scope.colElementPosition;
	          delete $scope.columnElement;
	        }, 200);
	      });
	
	
	      /* Column methods */
	      $scope.sortColumn = function (event, dir) {
	        event.stopPropagation();
	
	        $scope.grid.sortColumn($scope.col, dir, true)
	          .then(function () {
	            $scope.grid.refresh();
	            $scope.hideMenu();
	          });
	      };
	
	      $scope.unsortColumn = function () {
	        $scope.col.unsort();
	
	        $scope.grid.refresh();
	        $scope.hideMenu();
	      };
	
	      //Since we are hiding this column the default hide action will fail so we need to focus somewhere else.
	      var setFocusOnHideColumn = function(){
	        $timeout(function(){
	          // Get the UID of the first
	          var focusToGridMenu = function(){
	            return gridUtil.focus.byId('grid-menu', $scope.grid);
	          };
	
	          var thisIndex;
	          $scope.grid.columns.some(function(element, index){
	            if (angular.equals(element, $scope.col)) {
	              thisIndex = index;
	              return true;
	            }
	          });
	
	          var previousVisibleCol;
	          // Try and find the next lower or nearest column to focus on
	          $scope.grid.columns.some(function(element, index){
	            if (!element.visible){
	              return false;
	            } // This columns index is below the current column index
	            else if ( index < thisIndex){
	              previousVisibleCol = element;
	            } // This elements index is above this column index and we haven't found one that is lower
	            else if ( index > thisIndex && !previousVisibleCol) {
	              // This is the next best thing
	              previousVisibleCol = element;
	              // We've found one so use it.
	              return true;
	            } // We've reached an element with an index above this column and the previousVisibleCol variable has been set
	            else if (index > thisIndex && previousVisibleCol) {
	              // We are done.
	              return true;
	            }
	          });
	          // If found then focus on it
	          if (previousVisibleCol){
	            var colClass = previousVisibleCol.getColClass();
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + colClass+ ' .ui-grid-header-cell-primary-focus', true).then(angular.noop, function(reason){
	              if (reason !== 'canceled'){ // If this is canceled then don't perform the action
	                //The fallback action is to focus on the grid menu
	                return focusToGridMenu();
	              }
	            });
	          } else {
	            // Fallback action to focus on the grid menu
	            focusToGridMenu();
	          }
	        });
	      };
	
	      $scope.hideColumn = function () {
	        $scope.col.colDef.visible = false;
	        $scope.col.visible = false;
	
	        $scope.grid.queueGridRefresh();
	        $scope.hideMenu();
	        $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	        $scope.grid.api.core.raise.columnVisibilityChanged( $scope.col );
	
	        // We are hiding so the default action of focusing on the button that opened this menu will fail.
	        setFocusOnHideColumn();
	      };
	    },
	
	
	
	    controller: ['$scope', function ($scope) {
	      var self = this;
	
	      $scope.$watch('menuItems', function (n, o) {
	        self.menuItems = n;
	      });
	    }]
	  };
	
	  return uiGridColumnMenu;
	
	}]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFilter', ['$compile', '$templateCache', 'i18nService', 'gridUtil', function ($compile, $templateCache, i18nService, gridUtil) {
	
	    return {
	      compile: function() {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            $scope.col.updateFilters = function( filterable ){
	              $elm.children().remove();
	              if ( filterable ){
	                var template = $scope.col.filterHeaderTemplate;
	
	                $elm.append($compile(template)($scope));
	              }
	            };
	
	            $scope.$on( '$destroy', function() {
	              delete $scope.col.updateFilters;
	            });
	          },
	          post: function ($scope, $elm, $attrs, controllers){
	            $scope.aria = i18nService.getSafeText('headerCell.aria');
	            $scope.removeFilter = function(colFilter, index){
	              colFilter.term = null;
	              //Set the focus to the filter input after the action disables the button
	              gridUtil.focus.bySelector($elm, '.ui-grid-filter-input-' + index);
	            };
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooterCell', ['$timeout', 'gridUtil', 'uiGridConstants', '$compile',
	  function ($timeout, gridUtil, uiGridConstants, $compile) {
	    var uiGridFooterCell = {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      replace: true,
	      require: '^uiGrid',
	      compile: function compile(tElement, tAttrs, transclude) {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var cellFooter = $compile($scope.col.footerCellTemplate)($scope);
	            $elm.append(cellFooter);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            //$elm.addClass($scope.col.getColClass(false));
	            $scope.grid = uiGridCtrl.grid;
	
	            var initColClass = $scope.col.getColClass(false);
	            $elm.addClass(initColClass);
	
	            // apply any footerCellClass
	            var classAdded;
	            var updateClass = function( grid ){
	              var contents = $elm;
	              if ( classAdded ){
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	  
	              if (angular.isFunction($scope.col.footerCellClass)) {
	                classAdded = $scope.col.footerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.footerCellClass;
	              }
	              contents.addClass(classAdded);
	            };
	  
	            if ($scope.col.footerCellClass) {
	              updateClass();
	            }
	
	            $scope.col.updateAggregationValue();
	
	            // Watch for column changes so we can alter the col cell class properly
	/* shouldn't be needed any more, given track by col.name
	            $scope.$watch('col', function (n, o) {
	              if (n !== o) {
	                // See if the column's internal class has changed
	                var newColClass = $scope.col.getColClass(false);
	                if (newColClass !== initColClass) {
	                  $elm.removeClass(initColClass);
	                  $elm.addClass(newColClass);
	                  initColClass = newColClass;
	                }
	              }
	            });
	*/
	
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN]);
	            // listen for visible rows change and update aggregation values
	            $scope.grid.api.core.on.rowsRendered( $scope, $scope.col.updateAggregationValue );
	            $scope.grid.api.core.on.rowsRendered( $scope, updateClass );
	            $scope.$on( '$destroy', dataChangeDereg );
	          }
	        };
	      }
	    };
	
	    return uiGridFooterCell;
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', function ($templateCache, $compile, uiGridConstants, gridUtil, $timeout) {
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      // priority: 1000,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            containerCtrl.footer = $elm;
	
	            var footerTemplate = $scope.grid.options.footerTemplate;
	            gridUtil.getTemplate(footerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.append(newElm);
	
	                if (containerCtrl) {
	                  // Inject a reference to the footer viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	
	                  if (footerViewport) {
	                    containerCtrl.footerViewport = footerViewport;
	                  }
	                }
	              });
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-footer link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate footer cells
	            gridUtil.disableAnimations($elm);
	
	            containerCtrl.footer = $elm;
	
	            var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	            if (footerViewport) {
	              containerCtrl.footerViewport = footerViewport;
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', function ($templateCache, $compile, uiGridConstants, gridUtil, $timeout) {
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      // priority: 1000,
	      require: '^uiGrid',
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            $scope.grid = uiGridCtrl.grid;
	
	
	
	            var footerTemplate = $scope.grid.options.gridFooterTemplate;
	            gridUtil.getTemplate(footerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.append(newElm);
	              });
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridGroupPanel', ["$compile", "uiGridConstants", "gridUtil", function($compile, uiGridConstants, gridUtil) {
	    var defaultTemplate = 'ui-grid/ui-grid-group-panel';
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      require: '?^uiGrid',
	      scope: false,
	      compile: function($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var groupPanelTemplate = $scope.grid.options.groupPanelTemplate  || defaultTemplate;
	
	             gridUtil.getTemplate(groupPanelTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	                
	                var newElm = $compile(template)($scope);
	                $elm.append(newElm);
	              });
	          },
	
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            $elm.bind('$destroy', function() {
	              // scrollUnbinder();
	            });
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeaderCell', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'ScrollEvent', 'i18nService',
	  function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, ScrollEvent, i18nService) {
	    // Do stuff after mouse has been down this many ms on the header cell
	    var mousedownTimeout = 500;
	    var changeModeTimeout = 500;    // length of time between a touch event and a mouse event being recognised again, and vice versa
	
	    var uiGridHeaderCell = {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      replace: true,
	      compile: function() {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var cellHeader = $compile($scope.col.headerCellTemplate)($scope);
	            $elm.append(cellHeader);
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var renderContainerCtrl = controllers[1];
	
	            $scope.i18n = {
	              headerCell: i18nService.getSafeText('headerCell'),
	              sort: i18nService.getSafeText('sort')
	            };
	            $scope.getSortDirectionAriaLabel = function(){
	              var col = $scope.col;
	              //Trying to recreate this sort of thing but it was getting messy having it in the template.
	              //Sort direction {{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending':'none')}}. {{col.sort.priority ? {{columnPriorityText}} {{col.sort.priority}} : ''}
	              var sortDirectionText = col.sort.direction === uiGridConstants.ASC ? $scope.i18n.sort.ascending : ( col.sort.direction === uiGridConstants.DESC ? $scope.i18n.sort.descending : $scope.i18n.sort.none);
	              var label = sortDirectionText;
	              //Append the priority if it exists
	              if (col.sort.priority) {
	                label = label + '. ' + $scope.i18n.headerCell.priority + ' ' + col.sort.priority;
	              }
	              return label;
	            };
	
	            $scope.grid = uiGridCtrl.grid;
	
	            $scope.renderContainer = uiGridCtrl.grid.renderContainers[renderContainerCtrl.containerId];
	
	            var initColClass = $scope.col.getColClass(false);
	            $elm.addClass(initColClass);
	
	            // Hide the menu by default
	            $scope.menuShown = false;
	
	            // Put asc and desc sort directions in scope
	            $scope.asc = uiGridConstants.ASC;
	            $scope.desc = uiGridConstants.DESC;
	
	            // Store a reference to menu element
	            var $colMenu = angular.element( $elm[0].querySelectorAll('.ui-grid-header-cell-menu') );
	
	            var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	
	            // apply any headerCellClass
	            var classAdded;
	            var previousMouseX;
	
	            // filter watchers
	            var filterDeregisters = [];
	
	
	            /*
	             * Our basic approach here for event handlers is that we listen for a down event (mousedown or touchstart).
	             * Once we have a down event, we need to work out whether we have a click, a drag, or a
	             * hold.  A click would sort the grid (if sortable).  A drag would be used by moveable, so
	             * we ignore it.  A hold would open the menu.
	             *
	             * So, on down event, we put in place handlers for move and up events, and a timer.  If the
	             * timer expires before we see a move or up, then we have a long press and hence a column menu open.
	             * If the up happens before the timer, then we have a click, and we sort if the column is sortable.
	             * If a move happens before the timer, then we are doing column move, so we do nothing, the moveable feature
	             * will handle it.
	             *
	             * To deal with touch enabled devices that also have mice, we only create our handlers when
	             * we get the down event, and we create the corresponding handlers - if we're touchstart then
	             * we get touchmove and touchend, if we're mousedown then we get mousemove and mouseup.
	             *
	             * We also suppress the click action whilst this is happening - otherwise after the mouseup there
	             * will be a click event and that can cause the column menu to close
	             *
	             */
	
	            $scope.downFn = function( event ){
	              event.stopPropagation();
	
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Don't show the menu if it's not the left button
	              if (event.button && event.button !== 0) {
	                return;
	              }
	              previousMouseX = event.pageX;
	
	              $scope.mousedownStartTime = (new Date()).getTime();
	              $scope.mousedownTimeout = $timeout(function() { }, mousedownTimeout);
	
	              $scope.mousedownTimeout.then(function () {
	                if ( $scope.colMenu ) {
	                  uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm, event);
	                }
	              });
	
	              uiGridCtrl.fireEvent(uiGridConstants.events.COLUMN_HEADER_CLICK, {event: event, columnName: $scope.col.colDef.name});
	
	              $scope.offAllEvents();
	              if ( event.type === 'touchstart'){
	                $document.on('touchend', $scope.upFn);
	                $document.on('touchmove', $scope.moveFn);
	              } else if ( event.type === 'mousedown' ){
	                $document.on('mouseup', $scope.upFn);
	                $document.on('mousemove', $scope.moveFn);
	              }
	            };
	
	            $scope.upFn = function( event ){
	              event.stopPropagation();
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	
	              var mousedownEndTime = (new Date()).getTime();
	              var mousedownTime = mousedownEndTime - $scope.mousedownStartTime;
	
	              if (mousedownTime > mousedownTimeout) {
	                // long click, handled above with mousedown
	              }
	              else {
	                // short click
	                if ( $scope.sortable ){
	                  $scope.handleClick(event);
	                }
	              }
	            };
	
	            $scope.moveFn = function( event ){
	              // Chrome is known to fire some bogus move events.
	              var changeValue = event.pageX - previousMouseX;
	              if ( changeValue === 0 ){ return; }
	
	              // we're a move, so do nothing and leave for column move (if enabled) to take over
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	            };
	
	            $scope.clickFn = function ( event ){
	              event.stopPropagation();
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	
	            $scope.offAllEvents = function(){
	              $contentsElm.off('touchstart', $scope.downFn);
	              $contentsElm.off('mousedown', $scope.downFn);
	
	              $document.off('touchend', $scope.upFn);
	              $document.off('mouseup', $scope.upFn);
	
	              $document.off('touchmove', $scope.moveFn);
	              $document.off('mousemove', $scope.moveFn);
	
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	            $scope.onDownEvents = function( type ){
	              // If there is a previous event, then wait a while before
	              // activating the other mode - i.e. if the last event was a touch event then
	              // don't enable mouse events for a wee while (500ms or so)
	              // Avoids problems with devices that emulate mouse events when you have touch events
	
	              switch (type){
	                case 'touchmove':
	                case 'touchend':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $timeout(function(){
	                    $contentsElm.on('mousedown', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                case 'mousemove':
	                case 'mouseup':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	                  $timeout(function(){
	                    $contentsElm.on('touchstart', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                default:
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	              }
	            };
	
	
	            var updateHeaderOptions = function( grid ){
	              var contents = $elm;
	              if ( classAdded ){
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	
	              if (angular.isFunction($scope.col.headerCellClass)) {
	                classAdded = $scope.col.headerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.headerCellClass;
	              }
	              contents.addClass(classAdded);
	
	              var rightMostContainer = $scope.grid.renderContainers['right'] ? $scope.grid.renderContainers['right'] : $scope.grid.renderContainers['body'];
	              $scope.isLastCol = ( $scope.col === rightMostContainer.visibleColumnCache[ rightMostContainer.visibleColumnCache.length - 1 ] );
	
	              // Figure out whether this column is sortable or not
	              if (uiGridCtrl.grid.options.enableSorting && $scope.col.enableSorting) {
	                $scope.sortable = true;
	              }
	              else {
	                $scope.sortable = false;
	              }
	
	              // Figure out whether this column is filterable or not
	              var oldFilterable = $scope.filterable;
	              if (uiGridCtrl.grid.options.enableFiltering && $scope.col.enableFiltering) {
	                $scope.filterable = true;
	              }
	              else {
	                $scope.filterable = false;
	              }
	
	              if ( oldFilterable !== $scope.filterable){
	                if ( typeof($scope.col.updateFilters) !== 'undefined' ){
	                  $scope.col.updateFilters($scope.filterable);
	                }
	
	                // if column is filterable add a filter watcher
	                if ($scope.filterable) {
	                  $scope.col.filters.forEach( function(filter, i) {
	                    filterDeregisters.push($scope.$watch('col.filters[' + i + '].term', function(n, o) {
	                      if (n !== o) {
	                        uiGridCtrl.grid.api.core.raise.filterChanged();
	                        uiGridCtrl.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	                        uiGridCtrl.grid.queueGridRefresh();
	                      }
	                    }));
	                  });
	                  $scope.$on('$destroy', function() {
	                    filterDeregisters.forEach( function(filterDeregister) {
	                      filterDeregister();
	                    });
	                  });
	                } else {
	                  filterDeregisters.forEach( function(filterDeregister) {
	                    filterDeregister();
	                  });
	                }
	
	              }
	
	              // figure out whether we support column menus
	              if ($scope.col.grid.options && $scope.col.grid.options.enableColumnMenus !== false &&
	                      $scope.col.colDef && $scope.col.colDef.enableColumnMenu !== false){
	                $scope.colMenu = true;
	              } else {
	                $scope.colMenu = false;
	              }
	
	              /**
	              * @ngdoc property
	              * @name enableColumnMenu
	              * @propertyOf ui.grid.class:GridOptions.columnDef
	              * @description if column menus are enabled, controls the column menus for this specific
	              * column (i.e. if gridOptions.enableColumnMenus, then you can control column menus
	              * using this option. If gridOptions.enableColumnMenus === false then you get no column
	              * menus irrespective of the value of this option ).  Defaults to true.
	              *
	              */
	              /**
	              * @ngdoc property
	              * @name enableColumnMenus
	              * @propertyOf ui.grid.class:GridOptions.columnDef
	              * @description Override for column menus everywhere - if set to false then you get no
	              * column menus.  Defaults to true.
	              *
	              */
	
	              $scope.offAllEvents();
	
	              if ($scope.sortable || $scope.colMenu) {
	                $scope.onDownEvents();
	
	                $scope.$on('$destroy', function () {
	                  $scope.offAllEvents();
	                });
	              }
	            };
	
	/*
	            $scope.$watch('col', function (n, o) {
	              if (n !== o) {
	                // See if the column's internal class has changed
	                var newColClass = $scope.col.getColClass(false);
	                if (newColClass !== initColClass) {
	                  $elm.removeClass(initColClass);
	                  $elm.addClass(newColClass);
	                  initColClass = newColClass;
	                }
	              }
	            });
	*/
	            updateHeaderOptions();
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateHeaderOptions, [uiGridConstants.dataChange.COLUMN]);
	
	            $scope.$on( '$destroy', dataChangeDereg );
	
	            $scope.handleClick = function(event) {
	              // If the shift key is being held down, add this column to the sort
	              var add = false;
	              if (event.shiftKey) {
	                add = true;
	              }
	
	              // Sort this column then rebuild the grid's rows
	              uiGridCtrl.grid.sortColumn($scope.col, add)
	                .then(function () {
	                  if (uiGridCtrl.columnMenuScope) { uiGridCtrl.columnMenuScope.hideMenu(); }
	                  uiGridCtrl.grid.refresh();
	                });
	            };
	
	
	            $scope.toggleMenu = function(event) {
	              event.stopPropagation();
	
	              // If the menu is already showing...
	              if (uiGridCtrl.columnMenuScope.menuShown) {
	                // ... and we're the column the menu is on...
	                if (uiGridCtrl.columnMenuScope.col === $scope.col) {
	                  // ... hide it
	                  uiGridCtrl.columnMenuScope.hideMenu();
	                }
	                // ... and we're NOT the column the menu is on
	                else {
	                  // ... move the menu to our column
	                  uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm);
	                }
	              }
	              // If the menu is NOT showing
	              else {
	                // ... show it on our column
	                uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm);
	              }
	            };
	          }
	        };
	      }
	    };
	
	    return uiGridHeaderCell;
	  }]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeader', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', 'ScrollEvent',
	    function($templateCache, $compile, uiGridConstants, gridUtil, $timeout, ScrollEvent) {
	    var defaultTemplate = 'ui-grid/ui-grid-header';
	    var emptyTemplate = 'ui-grid/ui-grid-no-header';
	
	    return {
	      restrict: 'EA',
	      // templateUrl: 'ui-grid/ui-grid-header',
	      replace: true,
	      // priority: 1000,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            updateHeaderReferences();
	            
	            var headerTemplate;
	            if (!$scope.grid.options.showHeader) {
	              headerTemplate = emptyTemplate;
	            }
	            else {
	              headerTemplate = ($scope.grid.options.headerTemplate) ? $scope.grid.options.headerTemplate : defaultTemplate;            
	            }
	
	            gridUtil.getTemplate(headerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	                
	                var newElm = $compile(template)($scope);
	                $elm.replaceWith(newElm);
	
	                // And update $elm to be the new element
	                $elm = newElm;
	
	                updateHeaderReferences();
	
	                if (containerCtrl) {
	                  // Inject a reference to the header viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	
	
	                  if (headerViewport) {
	                    containerCtrl.headerViewport = headerViewport;
	                    angular.element(headerViewport).on('scroll', scrollHandler);
	                    $scope.$on('$destroy', function () {
	                      angular.element(headerViewport).off('scroll', scrollHandler);
	                    });
	                  }
	                }
	
	                $scope.grid.queueRefresh();
	              });
	
	            function updateHeaderReferences() {
	              containerCtrl.header = containerCtrl.colContainer.header = $elm;
	
	              var headerCanvases = $elm[0].getElementsByClassName('ui-grid-header-canvas');
	
	              if (headerCanvases.length > 0) {
	                containerCtrl.headerCanvas = containerCtrl.colContainer.headerCanvas = headerCanvases[0];
	              }
	              else {
	                containerCtrl.headerCanvas = null;
	              }
	            }
	
	            function scrollHandler(evt) {
	              if (uiGridCtrl.grid.isScrollingHorizontally) {
	                return;
	              }
	              var newScrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.headerViewport, uiGridCtrl.grid);
	              var horizScrollPercentage = containerCtrl.colContainer.scrollHorizontal(newScrollLeft);
	
	              var scrollEvent = new ScrollEvent(uiGridCtrl.grid, null, containerCtrl.colContainer, ScrollEvent.Sources.ViewPortScroll);
	              scrollEvent.newScrollLeft = newScrollLeft;
	              if ( horizScrollPercentage > -1 ){
	                scrollEvent.x = { percentage: horizScrollPercentage };
	              }
	
	              uiGridCtrl.grid.scrollContainers(null, scrollEvent);
	            }
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-header link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate header cells
	            gridUtil.disableAnimations($elm);
	
	            function updateColumnWidths() {
	              // this styleBuilder always runs after the renderContainer, so we can rely on the column widths
	              // already being populated correctly
	
	              var columnCache = containerCtrl.colContainer.visibleColumnCache;
	              
	              // Build the CSS
	              // uiGridCtrl.grid.columns.forEach(function (column) {
	              var ret = '';
	              var canvasWidth = 0;
	              columnCache.forEach(function (column) {
	                ret = ret + column.getColClassDefinition();
	                canvasWidth += column.drawnWidth;
	              });
	
	              containerCtrl.colContainer.canvasWidth = canvasWidth;
	              
	              // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	              return ret;
	            }
	            
	            containerCtrl.header = $elm;
	            
	            var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	            if (headerViewport) {
	              containerCtrl.headerViewport = headerViewport;
	            }
	
	            //todo: remove this if by injecting gridCtrl into unit tests
	            if (uiGridCtrl) {
	              uiGridCtrl.grid.registerStyleComputation({
	                priority: 15,
	                func: updateColumnWidths
	              });
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.service('uiGridGridMenuService', [ 'gridUtil', 'i18nService', 'uiGridConstants', function( gridUtil, i18nService, uiGridConstants ) {
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.gridMenuService
	   *
	   *  @description Methods for working with the grid menu
	   */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.gridMenuService
	     * @name initialize
	     * @description Sets up the gridMenu. Most importantly, sets our
	     * scope onto the grid object as grid.gridMenuScope, allowing us
	     * to operate when passed only the grid.  Second most importantly,
	     * we register the 'addToGridMenu' and 'removeFromGridMenu' methods
	     * on the core api.
	     * @param {$scope} $scope the scope of this gridMenu
	     * @param {Grid} grid the grid to which this gridMenu is associated
	     */
	    initialize: function( $scope, grid ){
	      grid.gridMenuScope = $scope;
	      $scope.grid = grid;
	      $scope.registeredMenuItems = [];
	
	      // not certain this is needed, but would be bad to create a memory leak
	      $scope.$on('$destroy', function() {
	        if ( $scope.grid && $scope.grid.gridMenuScope ){
	          $scope.grid.gridMenuScope = null;
	        }
	        if ( $scope.grid ){
	          $scope.grid = null;
	        }
	        if ( $scope.registeredMenuItems ){
	          $scope.registeredMenuItems = null;
	        }
	      });
	
	      $scope.registeredMenuItems = [];
	
	      /**
	       * @ngdoc function
	       * @name addToGridMenu
	       * @methodOf ui.grid.core.api:PublicApi
	       * @description add items to the grid menu.  Used by features
	       * to add their menu items if they are enabled, can also be used by
	       * end users to add menu items.  This method has the advantage of allowing
	       * remove again, which can simplify management of which items are included
	       * in the menu when.  (Noting that in most cases the shown and active functions
	       * provide a better way to handle visibility of menu items)
	       * @param {Grid} grid the grid on which we are acting
	       * @param {array} items menu items in the format as described in the tutorial, with
	       * the added note that if you want to use remove you must also specify an `id` field,
	       * which is provided when you want to remove an item.  The id should be unique.
	       *
	       */
	      grid.api.registerMethod( 'core', 'addToGridMenu', service.addToGridMenu );
	
	      /**
	       * @ngdoc function
	       * @name removeFromGridMenu
	       * @methodOf ui.grid.core.api:PublicApi
	       * @description Remove an item from the grid menu based on a provided id. Assumes
	       * that the id is unique, removes only the last instance of that id. Does nothing if
	       * the specified id is not found
	       * @param {Grid} grid the grid on which we are acting
	       * @param {string} id the id we'd like to remove from the menu
	       *
	       */
	      grid.api.registerMethod( 'core', 'removeFromGridMenu', service.removeFromGridMenu );
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name addToGridMenu
	     * @propertyOf ui.grid.gridMenuService
	     * @description add items to the grid menu.  Used by features
	     * to add their menu items if they are enabled, can also be used by
	     * end users to add menu items.  This method has the advantage of allowing
	     * remove again, which can simplify management of which items are included
	     * in the menu when.  (Noting that in most cases the shown and active functions
	     * provide a better way to handle visibility of menu items)
	     * @param {Grid} grid the grid on which we are acting
	     * @param {array} items menu items in the format as described in the tutorial, with
	     * the added note that if you want to use remove you must also specify an `id` field,
	     * which is provided when you want to remove an item.  The id should be unique.
	     *
	     */
	    addToGridMenu: function( grid, menuItems ) {
	      if ( !angular.isArray( menuItems ) ) {
	        gridUtil.logError( 'addToGridMenu: menuItems must be an array, and is not, not adding any items');
	      } else {
	        if ( grid.gridMenuScope ){
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems ? grid.gridMenuScope.registeredMenuItems : [];
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems.concat( menuItems );
	        } else {
	          gridUtil.logError( 'Asked to addToGridMenu, but gridMenuScope not present.  Timing issue?  Please log issue with ui-grid');
	        }
	      }
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name removeFromGridMenu
	     * @methodOf ui.grid.gridMenuService
	     * @description Remove an item from the grid menu based on a provided id.  Assumes
	     * that the id is unique, removes only the last instance of that id.  Does nothing if
	     * the specified id is not found.  If there is no gridMenuScope or registeredMenuItems
	     * then do nothing silently - the desired result is those menu items not be present and they
	     * aren't.
	     * @param {Grid} grid the grid on which we are acting
	     * @param {string} id the id we'd like to remove from the menu
	     *
	     */
	    removeFromGridMenu: function( grid, id ){
	      var foundIndex = -1;
	
	      if ( grid && grid.gridMenuScope ){
	        grid.gridMenuScope.registeredMenuItems.forEach( function( value, index ) {
	          if ( value.id === id ){
	            if (foundIndex > -1) {
	              gridUtil.logError( 'removeFromGridMenu: found multiple items with the same id, removing only the last' );
	            } else {
	
	              foundIndex = index;
	            }
	          }
	        });
	      }
	
	      if ( foundIndex > -1 ){
	        grid.gridMenuScope.registeredMenuItems.splice( foundIndex, 1 );
	      }
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuCustomItems
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) An array of menu items that should be added to
	     * the gridMenu.  Follow the format documented in the tutorial for column
	     * menu customisation.  The context provided to the action function will
	     * include context.grid.  An alternative if working with dynamic menus is to use the
	     * provided api - core.addToGridMenu and core.removeFromGridMenu, which handles
	     * some of the management of items for you.
	     *
	     */
	    /**
	     * @ngdoc boolean
	     * @name gridMenuShowHideColumns
	     * @propertyOf ui.grid.class:GridOptions
	     * @description true by default, whether the grid menu should allow hide/show
	     * of columns
	     *
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.gridMenuService
	     * @name getMenuItems
	     * @description Decides the menu items to show in the menu.  This is a
	     * combination of:
	     *
	     * - the default menu items that are always included,
	     * - any menu items that have been provided through the addMenuItem api. These
	     *   are typically added by features within the grid
	     * - any menu items included in grid.options.gridMenuCustomItems.  These can be
	     *   changed dynamically, as they're always recalculated whenever we show the
	     *   menu
	     * @param {$scope} $scope the scope of this gridMenu, from which we can find all
	     * the information that we need
	     * @returns {array} an array of menu items that can be shown
	     */
	    getMenuItems: function( $scope ) {
	      var menuItems = [
	        // this is where we add any menu items we want to always include
	      ];
	
	      if ( $scope.grid.options.gridMenuCustomItems ){
	        if ( !angular.isArray( $scope.grid.options.gridMenuCustomItems ) ){
	          gridUtil.logError( 'gridOptions.gridMenuCustomItems must be an array, and is not');
	        } else {
	          menuItems = menuItems.concat( $scope.grid.options.gridMenuCustomItems );
	        }
	      }
	
	      var clearFilters = [{
	        title: i18nService.getSafeText('gridMenu.clearAllFilters'),
	        action: function ($event) {
	          $scope.grid.clearAllFilters(undefined, true, undefined);
	        },
	        shown: function() {
	          return $scope.grid.options.enableFiltering;
	        },
	        order: 100
	      }];
	      menuItems = menuItems.concat( clearFilters );
	
	      menuItems = menuItems.concat( $scope.registeredMenuItems );
	
	      if ( $scope.grid.options.gridMenuShowHideColumns !== false ){
	        menuItems = menuItems.concat( service.showHideColumns( $scope ) );
	      }
	
	      menuItems.sort(function(a, b){
	        return a.order - b.order;
	      });
	
	      return menuItems;
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuTitleFilter
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) A function that takes a title string
	     * (usually the col.displayName), and converts it into a display value.  The function
	     * must return either a string or a promise.
	     *
	     * Used for internationalization of the grid menu column names - for angular-translate
	     * you can pass $translate as the function, for i18nService you can pass getSafeText as the
	     * function
	     * @example
	     * <pre>
	     *   gridOptions = {
	     *     gridMenuTitleFilter: $translate
	     *   }
	     * </pre>
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.gridMenuService
	     * @name showHideColumns
	     * @description Adds two menu items for each of the columns in columnDefs.  One
	     * menu item for hide, one menu item for show.  Each is visible when appropriate
	     * (show when column is not visible, hide when column is visible).  Each toggles
	     * the visible property on the columnDef using toggleColumnVisibility
	     * @param {$scope} $scope of a gridMenu, which contains a reference to the grid
	     */
	    showHideColumns: function( $scope ){
	      var showHideColumns = [];
	      if ( !$scope.grid.options.columnDefs || $scope.grid.options.columnDefs.length === 0 || $scope.grid.columns.length === 0 ) {
	        return showHideColumns;
	      }
	
	      // add header for columns
	      showHideColumns.push({
	        title: i18nService.getSafeText('gridMenu.columns'),
	        order: 300
	      });
	
	      $scope.grid.options.gridMenuTitleFilter = $scope.grid.options.gridMenuTitleFilter ? $scope.grid.options.gridMenuTitleFilter : function( title ) { return title; };
	
	      $scope.grid.options.columnDefs.forEach( function( colDef, index ){
	        if ( colDef.enableHiding !== false ){
	          // add hide menu item - shows an OK icon as we only show when column is already visible
	          var menuItem = {
	            icon: 'ui-grid-icon-ok',
	            action: function($event) {
	              $event.stopPropagation();
	              service.toggleColumnVisibility( this.context.gridCol );
	            },
	            shown: function() {
	              return this.context.gridCol.colDef.visible === true || this.context.gridCol.colDef.visible === undefined;
	            },
	            context: { gridCol: $scope.grid.getColumn(colDef.name || colDef.field) },
	            leaveOpen: true,
	            order: 301 + index * 2
	          };
	          service.setMenuItemTitle( menuItem, colDef, $scope.grid );
	          showHideColumns.push( menuItem );
	
	          // add show menu item - shows no icon as we only show when column is invisible
	          menuItem = {
	            icon: 'ui-grid-icon-cancel',
	            action: function($event) {
	              $event.stopPropagation();
	              service.toggleColumnVisibility( this.context.gridCol );
	            },
	            shown: function() {
	              return !(this.context.gridCol.colDef.visible === true || this.context.gridCol.colDef.visible === undefined);
	            },
	            context: { gridCol: $scope.grid.getColumn(colDef.name || colDef.field) },
	            leaveOpen: true,
	            order: 301 + index * 2 + 1
	          };
	          service.setMenuItemTitle( menuItem, colDef, $scope.grid );
	          showHideColumns.push( menuItem );
	        }
	      });
	      return showHideColumns;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.gridMenuService
	     * @name setMenuItemTitle
	     * @description Handles the response from gridMenuTitleFilter, adding it directly to the menu
	     * item if it returns a string, otherwise waiting for the promise to resolve or reject then
	     * putting the result into the title
	     * @param {object} menuItem the menuItem we want to put the title on
	     * @param {object} colDef the colDef from which we can get displayName, name or field
	     * @param {Grid} grid the grid, from which we can get the options.gridMenuTitleFilter
	     *
	     */
	    setMenuItemTitle: function( menuItem, colDef, grid ){
	      var title = grid.options.gridMenuTitleFilter( colDef.displayName || gridUtil.readableColumnName(colDef.name) || colDef.field );
	
	      if ( typeof(title) === 'string' ){
	        menuItem.title = title;
	      } else if ( title.then ){
	        // must be a promise
	        menuItem.title = "";
	        title.then( function( successValue ) {
	          menuItem.title = successValue;
	        }, function( errorValue ) {
	          menuItem.title = errorValue;
	        });
	      } else {
	        gridUtil.logError('Expected gridMenuTitleFilter to return a string or a promise, it has returned neither, bad config');
	        menuItem.title = 'badconfig';
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.gridMenuService
	     * @name toggleColumnVisibility
	     * @description Toggles the visibility of an individual column.  Expects to be
	     * provided a context that has on it a gridColumn, which is the column that
	     * we'll operate upon.  We change the visibility, and refresh the grid as appropriate
	     * @param {GridCol} gridCol the column that we want to toggle
	     *
	     */
	    toggleColumnVisibility: function( gridCol ) {
	      gridCol.colDef.visible = !( gridCol.colDef.visible === true || gridCol.colDef.visible === undefined );
	
	      gridCol.grid.refresh();
	      gridCol.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	      gridCol.grid.api.core.raise.columnVisibilityChanged( gridCol );
	    }
	  };
	
	  return service;
	}])
	
	
	
	.directive('uiGridMenuButton', ['gridUtil', 'uiGridConstants', 'uiGridGridMenuService', 'i18nService',
	function (gridUtil, uiGridConstants, uiGridGridMenuService, i18nService) {
	
	  return {
	    priority: 0,
	    scope: true,
	    require: ['^uiGrid'],
	    templateUrl: 'ui-grid/ui-grid-menu-button',
	    replace: true,
	
	    link: function ($scope, $elm, $attrs, controllers) {
	      var uiGridCtrl = controllers[0];
	
	      // For the aria label
	      $scope.i18n = {
	        aria: i18nService.getSafeText('gridMenu.aria')
	      };
	
	      uiGridGridMenuService.initialize($scope, uiGridCtrl.grid);
	
	      $scope.shown = false;
	
	      $scope.toggleMenu = function () {
	        if ( $scope.shown ){
	          $scope.$broadcast('hide-menu');
	          $scope.shown = false;
	        } else {
	          $scope.menuItems = uiGridGridMenuService.getMenuItems( $scope );
	          $scope.$broadcast('show-menu');
	          $scope.shown = true;
	        }
	      };
	
	      $scope.$on('menu-hidden', function() {
	        $scope.shown = false;
	        gridUtil.focus.bySelector($elm, '.ui-grid-icon-container');
	      });
	    }
	  };
	
	}]);
	
	})();
	
	(function(){
	
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridMenu
	 * @element style
	 * @restrict A
	 *
	 * @description
	 * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	 *
	 * @example
	 <doc:example module="app">
	 <doc:source>
	 <script>
	 var app = angular.module('app', ['ui.grid']);
	
	 app.controller('MainCtrl', ['$scope', function ($scope) {
	
	 }]);
	 </script>
	
	 <div ng-controller="MainCtrl">
	   <div ui-grid-menu shown="true"  ></div>
	 </div>
	 </doc:source>
	 <doc:scenario>
	 </doc:scenario>
	 </doc:example>
	 */
	angular.module('ui.grid')
	
	.directive('uiGridMenu', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'i18nService',
	function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, i18nService) {
	  var uiGridMenu = {
	    priority: 0,
	    scope: {
	      // shown: '&',
	      menuItems: '=',
	      autoHide: '=?'
	    },
	    require: '?^uiGrid',
	    templateUrl: 'ui-grid/uiGridMenu',
	    replace: false,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      var self = this;
	      var menuMid;
	      var $animate;
	
	      $scope.i18n = {
	        close: i18nService.getSafeText('columnMenu.close')
	      };
	
	    // *** Show/Hide functions ******
	      self.showMenu = $scope.showMenu = function(event, args) {
	        if ( !$scope.shown ){
	
	          /*
	           * In order to animate cleanly we remove the ng-if, wait a digest cycle, then
	           * animate the removal of the ng-hide.  We can't successfully (so far as I can tell)
	           * animate removal of the ng-if, as the menu items aren't there yet.  And we don't want
	           * to rely on ng-show only, as that leaves elements in the DOM that are needlessly evaluated
	           * on scroll events.
	           *
	           * Note when testing animation that animations don't run on the tutorials.  When debugging it looks
	           * like they do, but angular has a default $animate provider that is just a stub, and that's what's
	           * being called.  ALso don't be fooled by the fact that your browser has actually loaded the
	           * angular-translate.js, it's not using it.  You need to test animations in an external application.
	           */
	          $scope.shown = true;
	
	          $timeout( function() {
	            $scope.shownMid = true;
	            $scope.$emit('menu-shown');
	          });
	        } else if ( !$scope.shownMid ) {
	          // we're probably doing a hide then show, so we don't need to wait for ng-if
	          $scope.shownMid = true;
	          $scope.$emit('menu-shown');
	        }
	
	        var docEventType = 'click';
	        if (args && args.originalEvent && args.originalEvent.type && args.originalEvent.type === 'touchstart') {
	          docEventType = args.originalEvent.type;
	        }
	
	        // Turn off an existing document click handler
	        angular.element(document).off('click touchstart', applyHideMenu);
	
	        // Turn on the document click handler, but in a timeout so it doesn't apply to THIS click if there is one
	        $timeout(function() {
	          angular.element(document).on(docEventType, applyHideMenu);
	        });
	        //automatically set the focus to the first button element in the now open menu.
	        gridUtil.focus.bySelector($elm, 'button[type=button]', true);
	      };
	
	
	      self.hideMenu = $scope.hideMenu = function(event, args) {
	        if ( $scope.shown ){
	          /*
	           * In order to animate cleanly we animate the addition of ng-hide, then use a $timeout to
	           * set the ng-if (shown = false) after the animation runs.  In theory we can cascade off the
	           * callback on the addClass method, but it is very unreliable with unit tests for no discernable reason.
	           *
	           * The user may have clicked on the menu again whilst
	           * we're waiting, so we check that the mid isn't shown before applying the ng-if.
	           */
	          $scope.shownMid = false;
	          $timeout( function() {
	            if ( !$scope.shownMid ){
	              $scope.shown = false;
	              $scope.$emit('menu-hidden');
	            }
	          }, 200);
	        }
	
	        angular.element(document).off('click touchstart', applyHideMenu);
	      };
	
	      $scope.$on('hide-menu', function (event, args) {
	        $scope.hideMenu(event, args);
	      });
	
	      $scope.$on('show-menu', function (event, args) {
	        $scope.showMenu(event, args);
	      });
	
	
	    // *** Auto hide when click elsewhere ******
	      var applyHideMenu = function(){
	        if ($scope.shown) {
	          $scope.$apply(function () {
	            $scope.hideMenu();
	          });
	        }
	      };
	
	      if (typeof($scope.autoHide) === 'undefined' || $scope.autoHide === undefined) {
	        $scope.autoHide = true;
	      }
	
	      if ($scope.autoHide) {
	        angular.element($window).on('resize', applyHideMenu);
	      }
	
	      $scope.$on('$destroy', function () {
	        angular.element(document).off('click touchstart', applyHideMenu);
	      });
	
	
	      $scope.$on('$destroy', function() {
	        angular.element($window).off('resize', applyHideMenu);
	      });
	
	      if (uiGridCtrl) {
	       $scope.$on('$destroy', uiGridCtrl.grid.api.core.on.scrollBegin($scope, applyHideMenu ));
	      }
	
	      $scope.$on('$destroy', $scope.$on(uiGridConstants.events.ITEM_DRAGGING, applyHideMenu ));
	    },
	
	
	    controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
	      var self = this;
	    }]
	  };
	
	  return uiGridMenu;
	}])
	
	.directive('uiGridMenuItem', ['gridUtil', '$compile', 'i18nService', function (gridUtil, $compile, i18nService) {
	  var uiGridMenuItem = {
	    priority: 0,
	    scope: {
	      name: '=',
	      active: '=',
	      action: '=',
	      icon: '=',
	      shown: '=',
	      context: '=',
	      templateUrl: '=',
	      leaveOpen: '=',
	      screenReaderOnly: '='
	    },
	    require: ['?^uiGrid', '^uiGridMenu'],
	    templateUrl: 'ui-grid/uiGridMenuItem',
	    replace: false,
	    compile: function($elm, $attrs) {
	      return {
	        pre: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0],
	              uiGridMenuCtrl = controllers[1];
	
	          if ($scope.templateUrl) {
	            gridUtil.getTemplate($scope.templateUrl)
	                .then(function (contents) {
	                  var template = angular.element(contents);
	
	                  var newElm = $compile(template)($scope);
	                  $elm.replaceWith(newElm);
	                });
	          }
	        },
	        post: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0],
	              uiGridMenuCtrl = controllers[1];
	
	          // TODO(c0bra): validate that shown and active are functions if they're defined. An exception is already thrown above this though
	          // if (typeof($scope.shown) !== 'undefined' && $scope.shown && typeof($scope.shown) !== 'function') {
	          //   throw new TypeError("$scope.shown is defined but not a function");
	          // }
	          if (typeof($scope.shown) === 'undefined' || $scope.shown === null) {
	            $scope.shown = function() { return true; };
	          }
	
	          $scope.itemShown = function () {
	            var context = {};
	            if ($scope.context) {
	              context.context = $scope.context;
	            }
	
	            if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	              context.grid = uiGridCtrl.grid;
	            }
	
	            return $scope.shown.call(context);
	          };
	
	          $scope.itemAction = function($event,title) {
	            gridUtil.logDebug('itemAction');
	            $event.stopPropagation();
	
	            if (typeof($scope.action) === 'function') {
	              var context = {};
	
	              if ($scope.context) {
	                context.context = $scope.context;
	              }
	
	              // Add the grid to the function call context if the uiGrid controller is present
	              if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	                context.grid = uiGridCtrl.grid;
	              }
	
	              $scope.action.call(context, $event, title);
	
	              if ( !$scope.leaveOpen ){
	                $scope.$emit('hide-menu');
	              } else {
	                /*
	                 * XXX: Fix after column refactor
	                 * Ideally the focus would remain on the item.
	                 * However, since there are two menu items that have their 'show' property toggled instead. This is a quick fix.
	                 */
	                gridUtil.focus.bySelector(angular.element(gridUtil.closestElm($elm, ".ui-grid-menu-items")), 'button[type=button]', true);
	              }
	            }
	          };
	
	          $scope.i18n = i18nService.get();
	        }
	      };
	    }
	  };
	
	  return uiGridMenuItem;
	}]);
	
	})();
	
	(function(){
	  'use strict';
	  /**
	   * @ngdoc overview
	   * @name ui.grid.directive:uiGridOneBind
	   * @summary A group of directives that provide a one time bind to a dom element.
	   * @description A group of directives that provide a one time bind to a dom element.
	   * As one time bindings are not supported in Angular 1.2.* this directive provdes this capability.
	   * This is done to reduce the number of watchers on the dom.
	   * <br/>
	   * <h2>Short Example ({@link ui.grid.directive:uiGridOneBindSrc ui-grid-one-bind-src})</h2>
	   * <pre>
	        <div ng-init="imageName = 'myImageDir.jpg'">
	          <img ui-grid-one-bind-src="imageName"></img>
	        </div>
	     </pre>
	   * Will become:
	   * <pre>
	       <div ng-init="imageName = 'myImageDir.jpg'">
	         <img ui-grid-one-bind-src="imageName" src="myImageDir.jpg"></img>
	       </div>
	     </pre>
	     </br>
	     <h2>Short Example ({@link ui.grid.directive:uiGridOneBindText ui-grid-one-bind-text})</h2>
	   * <pre>
	        <div ng-init="text='Add this text'" ui-grid-one-bind-text="text"></div>
	     </pre>
	   * Will become:
	   * <pre>
	   <div ng-init="text='Add this text'" ui-grid-one-bind-text="text">Add this text</div>
	     </pre>
	     </br>
	   * <b>Note:</b> This behavior is slightly different for the {@link ui.grid.directive:uiGridOneBindIdGrid uiGridOneBindIdGrid}
	   * and {@link ui.grid.directive:uiGridOneBindAriaLabelledbyGrid uiGridOneBindAriaLabelledbyGrid} directives.
	   *
	   */
	  //https://github.com/joshkurz/Black-Belt-AngularJS-Directives/blob/master/directives/Optimization/oneBind.js
	  var oneBinders = angular.module('ui.grid');
	  angular.forEach([
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindSrc
	       * @memberof ui.grid.directive:uiGridOneBind
	       * @element img
	       * @restrict A
	       * @param {String} uiGridOneBindSrc The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the src dom tag.
	       *
	       */
	      {tag: 'Src', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindText
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindText The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the text dom tag.
	       */
	      {tag: 'Text', method: 'text'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHref
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHref The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the href dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Href', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindClass
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindClass The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @param {Object} uiGridOneBindClass The object that you want to bind. At least one of the values in the object must be something other than null or undefined for the watcher to be removed.
	       *                                    this is to prevent the watcher from being removed before the scope is initialized.
	       * @param {Array} uiGridOneBindClass An array of classes to bind to this element.
	       * @description One time binding for the class dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Class', method: 'addClass'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHtml
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHtml The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the html method on a dom element. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Html', method: 'html'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAlt
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAlt The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the alt dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Alt', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindStyle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindStyle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the style dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Style', method: 'css'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindValue
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindValue The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Value', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindId
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindId The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Id', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindIdGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindIdGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the id dom tag.
	       * <h1>Important Note!</h1>
	       * If the id tag passed as a parameter does <b>not</b> contain the grid id as a substring
	       * then the directive will search the scope and the parent controller (if it is a uiGridController) for the grid.id value.
	       * If this value is found then it is appended to the begining of the id tag. If the grid is not found then the directive throws an error.
	       * This is done in order to ensure uniqueness of id tags across the grid.
	       * This is to prevent two grids in the same document having duplicate id tags.
	       */
	      {tag: 'Id', directiveName:'IdGrid', method: 'attr', appendGridId: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindTitle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindTitle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the title dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Title', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabel
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabel The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-label dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text" aria-label="Add this text"></div>
	         </pre>
	       */
	      {tag: 'Label', method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledby
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId" aria-labelledby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledbyGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId" aria-labelledby-Grid="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', directiveName:'LabelledbyGrid', appendGridId:true, method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedby
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-describedby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId" aria-describedby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedbyGrid
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId" aria-describedby="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', directiveName:'DescribedbyGrid', appendGridId:true, method: 'attr', aria:true}],
	    function(v){
	
	      var baseDirectiveName = 'uiGridOneBind';
	      //If it is an aria tag then append the aria label seperately
	      //This is done because the aria tags are formatted aria-* and the directive name can't have a '-' character in it.
	      //If the diretiveName has to be overridden then it does so here. This is because the tag being modified and the directive sometimes don't match up.
	      var directiveName = (v.aria ? baseDirectiveName + 'Aria' : baseDirectiveName) + (v.directiveName ? v.directiveName : v.tag);
	      oneBinders.directive(directiveName, ['gridUtil', function(gridUtil){
	        return {
	          restrict: 'A',
	          require: ['?uiGrid','?^uiGrid'],
	          link: function(scope, iElement, iAttrs, controllers){
	            /* Appends the grid id to the beginnig of the value. */
	            var appendGridId = function(val){
	              var grid; //Get an instance of the grid if its available
	              //If its available in the scope then we don't need to try to find it elsewhere
	              if (scope.grid) {
	                grid = scope.grid;
	              }
	              //Another possible location to try to find the grid
	              else if (scope.col && scope.col.grid){
	                grid = scope.col.grid;
	              }
	              //Last ditch effort: Search through the provided controllers.
	              else if (!controllers.some( //Go through the controllers till one has the element we need
	                function(controller){
	                  if (controller && controller.grid) {
	                    grid = controller.grid;
	                    return true; //We've found the grid
	                  }
	              })){
	                //We tried our best to find it for you
	                gridUtil.logError("["+directiveName+"] A valid grid could not be found to bind id. Are you using this directive " +
	                                 "within the correct scope? Trying to generate id: [gridID]-" + val);
	                throw new Error("No valid grid could be found");
	              }
	
	              if (grid){
	                var idRegex = new RegExp(grid.id.toString());
	                //If the grid id hasn't been appended already in the template declaration
	                if (!idRegex.test(val)){
	                  val = grid.id.toString() + '-' + val;
	                }
	              }
	              return val;
	            };
	
	            // The watch returns a function to remove itself.
	            var rmWatcher = scope.$watch(iAttrs[directiveName], function(newV){
	              if (newV){
	                //If we are trying to add an id element then we also apply the grid id if it isn't already there
	                if (v.appendGridId) {
	                  var newIdString = null;
	                  //Append the id to all of the new ids.
	                  angular.forEach( newV.split(' '), function(s){
	                    newIdString = (newIdString ? (newIdString + ' ') : '') +  appendGridId(s);
	                  });
	                  newV = newIdString;
	                }
	
	                // Append this newValue to the dom element.
	                switch (v.method) {
	                  case 'attr': //The attr method takes two paraams the tag and the value
	                    if (v.aria) {
	                      //If it is an aria element then append the aria prefix
	                      iElement[v.method]('aria-' + v.tag.toLowerCase(),newV);
	                    } else {
	                      iElement[v.method](v.tag.toLowerCase(),newV);
	                    }
	                    break;
	                  case 'addClass':
	                    //Pulled from https://github.com/Pasvaz/bindonce/blob/master/bindonce.js
	                    if (angular.isObject(newV) && !angular.isArray(newV)) {
	                      var results = [];
	                      var nonNullFound = false; //We don't want to remove the binding unless the key is actually defined
	                      angular.forEach(newV, function (value, index) {
	                        if (value !== null && typeof(value) !== "undefined"){
	                          nonNullFound = true; //A non null value for a key was found so the object must have been initialized
	                          if (value) {results.push(index);}
	                        }
	                      });
	                      //A non null value for a key wasn't found so assume that the scope values haven't been fully initialized
	                      if (!nonNullFound){
	                        return; // If not initialized then the watcher should not be removed yet.
	                      }
	                      newV = results;
	                    }
	
	                    if (newV) {
	                      iElement.addClass(angular.isArray(newV) ? newV.join(' ') : newV);
	                    } else {
	                      return;
	                    }
	                    break;
	                  default:
	                    iElement[v.method](newV);
	                    break;
	                }
	
	                //Removes the watcher on itself after the bind
	                rmWatcher();
	              }
	            // True ensures that equality is determined using angular.equals instead of ===
	            }, true); //End rm watchers
	          } //End compile function
	        }; //End directive return
	      } // End directive function
	    ]); //End directive
	  }); // End angular foreach
	})();
	
	(function () {
	  'use strict';
	
	  var module = angular.module('ui.grid');
	
	  module.directive('uiGridRenderContainer', ['$timeout', '$document', 'uiGridConstants', 'gridUtil', 'ScrollEvent',
	    function($timeout, $document, uiGridConstants, gridUtil, ScrollEvent) {
	    return {
	      replace: true,
	      transclude: true,
	      templateUrl: 'ui-grid/uiGridRenderContainer',
	      require: ['^uiGrid', 'uiGridRenderContainer'],
	      scope: {
	        containerId: '=',
	        rowContainerName: '=',
	        colContainerName: '=',
	        bindScrollHorizontal: '=',
	        bindScrollVertical: '=',
	        enableVerticalScrollbar: '=',
	        enableHorizontalScrollbar: '='
	      },
	      controller: 'uiGridRenderContainer as RenderContainer',
	      compile: function () {
	        return {
	          pre: function prelink($scope, $elm, $attrs, controllers) {
	
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	            var grid = $scope.grid = uiGridCtrl.grid;
	
	            // Verify that the render container for this element exists
	            if (!$scope.rowContainerName) {
	              throw "No row render container name specified";
	            }
	            if (!$scope.colContainerName) {
	              throw "No column render container name specified";
	            }
	
	            if (!grid.renderContainers[$scope.rowContainerName]) {
	              throw "Row render container '" + $scope.rowContainerName + "' is not registered.";
	            }
	            if (!grid.renderContainers[$scope.colContainerName]) {
	              throw "Column render container '" + $scope.colContainerName + "' is not registered.";
	            }
	
	            var rowContainer = $scope.rowContainer = grid.renderContainers[$scope.rowContainerName];
	            var colContainer = $scope.colContainer = grid.renderContainers[$scope.colContainerName];
	
	            containerCtrl.containerId = $scope.containerId;
	            containerCtrl.rowContainer = rowContainer;
	            containerCtrl.colContainer = colContainer;
	          },
	          post: function postlink($scope, $elm, $attrs, controllers) {
	
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            var grid = uiGridCtrl.grid;
	            var rowContainer = containerCtrl.rowContainer;
	            var colContainer = containerCtrl.colContainer;
	            var scrollTop = null;
	            var scrollLeft = null;
	
	
	            var renderContainer = grid.renderContainers[$scope.containerId];
	
	            // Put the container name on this element as a class
	            $elm.addClass('ui-grid-render-container-' + $scope.containerId);
	
	            // Scroll the render container viewport when the mousewheel is used
	            gridUtil.on.mousewheel($elm, function (event) {
	              var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.RenderContainerMouseWheel);
	              if (event.deltaY !== 0) {
	                var scrollYAmount = event.deltaY * -1 * event.deltaFactor;
	
	                scrollTop = containerCtrl.viewport[0].scrollTop;
	
	                // Get the scroll percentage
	                scrollEvent.verticalScrollLength = rowContainer.getVerticalScrollLength();
	                var scrollYPercentage = (scrollTop + scrollYAmount) / scrollEvent.verticalScrollLength;
	
	                // If we should be scrolled 100%, make sure the scrollTop matches the maximum scroll length
	                //   Viewports that have "overflow: hidden" don't let the mousewheel scroll all the way to the bottom without this check
	                if (scrollYPercentage >= 1 && scrollTop < scrollEvent.verticalScrollLength) {
	                  containerCtrl.viewport[0].scrollTop = scrollEvent.verticalScrollLength;
	                }
	
	                // Keep scrollPercentage within the range 0-1.
	                if (scrollYPercentage < 0) { scrollYPercentage = 0; }
	                else if (scrollYPercentage > 1) { scrollYPercentage = 1; }
	
	                scrollEvent.y = { percentage: scrollYPercentage, pixels: scrollYAmount };
	              }
	              if (event.deltaX !== 0) {
	                var scrollXAmount = event.deltaX * event.deltaFactor;
	
	                // Get the scroll percentage
	                scrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.viewport, grid);
	                scrollEvent.horizontalScrollLength = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
	                var scrollXPercentage = (scrollLeft + scrollXAmount) / scrollEvent.horizontalScrollLength;
	
	                // Keep scrollPercentage within the range 0-1.
	                if (scrollXPercentage < 0) { scrollXPercentage = 0; }
	                else if (scrollXPercentage > 1) { scrollXPercentage = 1; }
	
	                scrollEvent.x = { percentage: scrollXPercentage, pixels: scrollXAmount };
	              }
	
	              // Let the parent container scroll if the grid is already at the top/bottom
	              if ((event.deltaY !== 0 && (scrollEvent.atTop(scrollTop) || scrollEvent.atBottom(scrollTop))) ||
	                  (event.deltaX !== 0 && (scrollEvent.atLeft(scrollLeft) || scrollEvent.atRight(scrollLeft)))) {
	                //parent controller scrolls
	              }
	              else {
	                event.preventDefault();
	                event.stopPropagation();
	                scrollEvent.fireThrottledScrollingEvent('', scrollEvent);
	              }
	
	            });
	
	            $elm.bind('$destroy', function() {
	              $elm.unbind('keydown');
	
	              ['touchstart', 'touchmove', 'touchend','keydown', 'wheel', 'mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'].forEach(function (eventName) {
	                $elm.unbind(eventName);
	              });
	            });
	
	            // TODO(c0bra): Handle resizing the inner canvas based on the number of elements
	            function update() {
	              var ret = '';
	
	              var canvasWidth = colContainer.canvasWidth;
	              var viewportWidth = colContainer.getViewportWidth();
	
	              var canvasHeight = rowContainer.getCanvasHeight();
	
	              //add additional height for scrollbar on left and right container
	              //if ($scope.containerId !== 'body') {
	              //  canvasHeight -= grid.scrollbarHeight;
	              //}
	
	              var viewportHeight = rowContainer.getViewportHeight();
	              //shorten the height to make room for a scrollbar placeholder
	              if (colContainer.needsHScrollbarPlaceholder()) {
	                viewportHeight -= grid.scrollbarHeight;
	              }
	
	              var headerViewportWidth,
	                  footerViewportWidth;
	              headerViewportWidth = footerViewportWidth = colContainer.getHeaderViewportWidth();
	
	              // Set canvas dimensions
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-canvas { width: ' + canvasWidth + 'px; height: ' + canvasHeight + 'px; }';
	
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-header-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
	
	              if (renderContainer.explicitHeaderCanvasHeight) {
	                ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-header-canvas { height: ' + renderContainer.explicitHeaderCanvasHeight + 'px; }';
	              }
	              else {
	                ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-header-canvas { height: inherit; }';
	              }
	
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-viewport { width: ' + viewportWidth + 'px; height: ' + viewportHeight + 'px; }';
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-header-viewport { width: ' + headerViewportWidth + 'px; }';
	
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-footer-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-footer-viewport { width: ' + footerViewportWidth + 'px; }';
	
	              return ret;
	            }
	
	            uiGridCtrl.grid.registerStyleComputation({
	              priority: 6,
	              func: update
	            });
	          }
	        };
	      }
	    };
	
	  }]);
	
	  module.controller('uiGridRenderContainer', ['$scope', 'gridUtil', function ($scope, gridUtil) {
	
	  }]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridRow', ['gridUtil', function(gridUtil) {
	    return {
	      replace: true,
	      // priority: 2001,
	      // templateUrl: 'ui-grid/ui-grid-row',
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: {
	         row: '=uiGridRow',
	         //rowRenderIndex is added to scope to give the true visual index of the row to any directives that need it
	         rowRenderIndex: '='
	      },
	      compile: function() {
	        return {
	          pre: function($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            var grid = uiGridCtrl.grid;
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            // Function for attaching the template to this scope
	            var clonedElement, cloneScope;
	            function compileTemplate() {
	              $scope.row.getRowTemplateFn.then(function (compiledElementFn) {
	                // var compiledElementFn = $scope.row.compiledElementFn;
	
	                // Create a new scope for the contents of this row, so we can destroy it later if need be
	                var newScope = $scope.$new();
	
	                compiledElementFn(newScope, function (newElm, scope) {
	                  // If we already have a cloned element, we need to remove it and destroy its scope
	                  if (clonedElement) {
	                    clonedElement.remove();
	                    cloneScope.$destroy();
	                  }
	
	                  // Empty the row and append the new element
	                  $elm.empty().append(newElm);
	
	                  // Save the new cloned element and scope
	                  clonedElement = newElm;
	                  cloneScope = newScope;
	                });
	              });
	            }
	
	            // Initially attach the compiled template to this scope
	            compileTemplate();
	
	            // If the row's compiled element function changes, we need to replace this element's contents with the new compiled template
	            $scope.$watch('row.getRowTemplateFn', function (newFunc, oldFunc) {
	              if (newFunc !== oldFunc) {
	                compileTemplate();
	              }
	            });
	          },
	          post: function($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	(function(){
	// 'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.directive:uiGridStyle
	   * @element style
	   * @restrict A
	   *
	   * @description
	   * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.myStyle = '.blah { border: 1px solid }';
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <style ui-grid-style>{{ myStyle }}</style>
	   <span class="blah">I am in a box.</span>
	   </div>
	   </doc:source>
	   <doc:scenario>
	      it('should apply the right class to the element', function () {
	        element(by.css('.blah')).getCssValue('border-top-width')
	          .then(function(c) {
	            expect(c).toContain('1px');
	          });
	      });
	   </doc:scenario>
	   </doc:example>
	   */
	
	
	  angular.module('ui.grid').directive('uiGridStyle', ['gridUtil', '$interpolate', function(gridUtil, $interpolate) {
	    return {
	      // restrict: 'A',
	      // priority: 1000,
	      // require: '?^uiGrid',
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        // gridUtil.logDebug('ui-grid-style link');
	        // if (uiGridCtrl === undefined) {
	        //    gridUtil.logWarn('[ui-grid-style link] uiGridCtrl is undefined!');
	        // }
	
	        var interpolateFn = $interpolate($elm.text(), true);
	
	        if (interpolateFn) {
	          $scope.$watch(interpolateFn, function(value) {
	            $elm.text(value);
	          });
	        }
	
	          // uiGridCtrl.recalcRowStyles = function() {
	          //   var offset = (scope.options.offsetTop || 0) - (scope.options.excessRows * scope.options.rowHeight);
	          //   var rowHeight = scope.options.rowHeight;
	
	          //   var ret = '';
	          //   var rowStyleCount = uiGridCtrl.minRowsToRender() + (scope.options.excessRows * 2);
	          //   for (var i = 1; i <= rowStyleCount; i++) {
	          //     ret = ret + ' .grid' + scope.gridId + ' .ui-grid-row:nth-child(' + i + ') { top: ' + offset + 'px; }';
	          //     offset = offset + rowHeight;
	          //   }
	
	          //   scope.rowStyles = ret;
	          // };
	
	          // uiGridCtrl.styleComputions.push(uiGridCtrl.recalcRowStyles);
	
	      }
	    };
	  }]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridViewport', ['gridUtil','ScrollEvent','uiGridConstants', '$log',
	    function(gridUtil, ScrollEvent, uiGridConstants, $log) {
	      return {
	        replace: true,
	        scope: {},
	        controllerAs: 'Viewport',
	        templateUrl: 'ui-grid/uiGridViewport',
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        link: function($scope, $elm, $attrs, controllers) {
	          // gridUtil.logDebug('viewport post-link');
	
	          var uiGridCtrl = controllers[0];
	          var containerCtrl = controllers[1];
	
	          $scope.containerCtrl = containerCtrl;
	
	          var rowContainer = containerCtrl.rowContainer;
	          var colContainer = containerCtrl.colContainer;
	
	          var grid = uiGridCtrl.grid;
	
	          $scope.grid = uiGridCtrl.grid;
	
	          // Put the containers in scope so we can get rows and columns from them
	          $scope.rowContainer = containerCtrl.rowContainer;
	          $scope.colContainer = containerCtrl.colContainer;
	
	          // Register this viewport with its container
	          containerCtrl.viewport = $elm;
	
	
	          $elm.on('scroll', scrollHandler);
	
	          var ignoreScroll = false;
	
	          function scrollHandler(evt) {
	            //Leaving in this commented code in case it can someday be used
	            //It does improve performance, but because the horizontal scroll is normalized,
	            //  using this code will lead to the column header getting slightly out of line with columns
	            //
	            //if (ignoreScroll && (grid.isScrollingHorizontally || grid.isScrollingHorizontally)) {
	            //  //don't ask for scrollTop if we just set it
	            //  ignoreScroll = false;
	            //  return;
	            //}
	            //ignoreScroll = true;
	
	            var newScrollTop = $elm[0].scrollTop;
	            var newScrollLeft = gridUtil.normalizeScrollLeft($elm, grid);
	
	            var vertScrollPercentage = rowContainer.scrollVertical(newScrollTop);
	            var horizScrollPercentage = colContainer.scrollHorizontal(newScrollLeft);
	
	            var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.ViewPortScroll);
	            scrollEvent.newScrollLeft = newScrollLeft;
	            scrollEvent.newScrollTop = newScrollTop;
	            if ( horizScrollPercentage > -1 ){
	              scrollEvent.x = { percentage: horizScrollPercentage };
	            }
	
	            if ( vertScrollPercentage > -1 ){
	              scrollEvent.y = { percentage: vertScrollPercentage };
	            }
	
	            grid.scrollContainers($scope.$parent.containerId, scrollEvent);
	          }
	
	          if ($scope.$parent.bindScrollVertical) {
	            grid.addVerticalScrollSync($scope.$parent.containerId, syncVerticalScroll);
	          }
	
	          if ($scope.$parent.bindScrollHorizontal) {
	            grid.addHorizontalScrollSync($scope.$parent.containerId, syncHorizontalScroll);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'header', syncHorizontalHeader);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'footer', syncHorizontalFooter);
	          }
	
	          function syncVerticalScroll(scrollEvent){
	            containerCtrl.prevScrollArgs = scrollEvent;
	            var newScrollTop = scrollEvent.getNewScrollTop(rowContainer,containerCtrl.viewport);
	            $elm[0].scrollTop = newScrollTop;
	
	          }
	
	          function syncHorizontalScroll(scrollEvent){
	            containerCtrl.prevScrollArgs = scrollEvent;
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	            $elm[0].scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	          }
	
	          function syncHorizontalHeader(scrollEvent){
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	            if (containerCtrl.headerViewport) {
	              containerCtrl.headerViewport.scrollLeft = gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	          function syncHorizontalFooter(scrollEvent){
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	            if (containerCtrl.footerViewport) {
	              containerCtrl.footerViewport.scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	
	        },
	        controller: ['$scope', function ($scope) {
	          this.rowStyle = function (index) {
	            var rowContainer = $scope.rowContainer;
	            var colContainer = $scope.colContainer;
	
	            var styles = {};
	
	            if (index === 0 && rowContainer.currentTopRow !== 0) {
	              // The row offset-top is just the height of the rows above the current top-most row, which are no longer rendered
	              var hiddenRowWidth = (rowContainer.currentTopRow) * rowContainer.grid.options.rowHeight;
	
	              // return { 'margin-top': hiddenRowWidth + 'px' };
	              styles['margin-top'] = hiddenRowWidth + 'px';
	            }
	
	            if (colContainer.currentFirstColumn !== 0) {
	              if (colContainer.grid.isRTL()) {
	                styles['margin-right'] = colContainer.columnOffset + 'px';
	              }
	              else {
	                styles['margin-left'] = colContainer.columnOffset + 'px';
	              }
	            }
	
	            return styles;
	          };
	        }]
	      };
	    }
	  ]);
	
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.directive('uiGridVisible', function uiGridVisibleAction() {
	  return function ($scope, $elm, $attr) {
	    $scope.$watch($attr.uiGridVisible, function (visible) {
	        // $elm.css('visibility', visible ? 'visible' : 'hidden');
	        $elm[visible ? 'removeClass' : 'addClass']('ui-grid-invisible');
	    });
	  };
	});
	
	})();
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').controller('uiGridController', ['$scope', '$element', '$attrs', 'gridUtil', '$q', 'uiGridConstants',
	                    '$templateCache', 'gridClassFactory', '$timeout', '$parse', '$compile',
	    function ($scope, $elm, $attrs, gridUtil, $q, uiGridConstants,
	              $templateCache, gridClassFactory, $timeout, $parse, $compile) {
	      // gridUtil.logDebug('ui-grid controller');
	
	      var self = this;
	
	      self.grid = gridClassFactory.createGrid($scope.uiGrid);
	
	      //assign $scope.$parent if appScope not already assigned
	      self.grid.appScope = self.grid.appScope || $scope.$parent;
	
	      $elm.addClass('grid' + self.grid.id);
	      self.grid.rtl = gridUtil.getStyles($elm[0])['direction'] === 'rtl';
	
	
	      // angular.extend(self.grid.options, );
	
	      //all properties of grid are available on scope
	      $scope.grid = self.grid;
	
	      if ($attrs.uiGridColumns) {
	        $attrs.$observe('uiGridColumns', function(value) {
	          self.grid.options.columnDefs = value;
	          self.grid.buildColumns()
	            .then(function(){
	              self.grid.preCompileCellTemplates();
	
	              self.grid.refreshCanvas(true);
	            });
	        });
	      }
	
	
	      // if fastWatch is set we watch only the length and the reference, not every individual object
	      var deregFunctions = [];
	      if (self.grid.options.fastWatch) {
	        self.uiGrid = $scope.uiGrid;
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watch($scope.uiGrid.data, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() {
	            if ( self.grid.appScope[$scope.uiGrid.data] ){
	              return self.grid.appScope[$scope.uiGrid.data].length; 
	            } else {
	              return undefined;
	            } 
	          }, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.data.length; }, dataWatchFunction) );
	        }
	        deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	        deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.columnDefs.length; }, columnDefsWatchFunction) );
	      } else {
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watchCollection($scope.uiGrid.data, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	        }
	        deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	      }
	      
	
	      function columnDefsWatchFunction(n, o) {
	        if (n && n !== o) {
	          self.grid.options.columnDefs = n;
	          self.grid.buildColumns({ orderByColumnDefs: true })
	            .then(function(){
	
	              self.grid.preCompileCellTemplates();
	
	              self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.COLUMN);
	            });
	        }
	      }
	
	      function dataWatchFunction(newData) {
	        // gridUtil.logDebug('dataWatch fired');
	        var promises = [];
	        
	        if ( self.grid.options.fastWatch ){
	          if (angular.isString($scope.uiGrid.data)) {
	            newData = self.grid.appScope[$scope.uiGrid.data];
	          } else {
	            newData = $scope.uiGrid.data;
	          }
	        }
	        
	        if (newData) {
	          // columns length is greater than the number of row header columns, which don't count because they're created automatically
	          var hasColumns = self.grid.columns.length > (self.grid.rowHeaderColumns ? self.grid.rowHeaderColumns.length : 0);
	
	          if (
	            // If we have no columns
	            !hasColumns &&
	            // ... and we don't have a ui-grid-columns attribute, which would define columns for us
	            !$attrs.uiGridColumns &&
	            // ... and we have no pre-defined columns
	            self.grid.options.columnDefs.length === 0 &&
	            // ... but we DO have data
	            newData.length > 0
	          ) {
	            // ... then build the column definitions from the data that we have
	            self.grid.buildColumnDefsFromData(newData);
	          }
	
	          // If we haven't built columns before and either have some columns defined or some data defined
	          if (!hasColumns && (self.grid.options.columnDefs.length > 0 || newData.length > 0)) {
	            // Build the column set, then pre-compile the column cell templates
	            promises.push(self.grid.buildColumns()
	              .then(function() {
	                self.grid.preCompileCellTemplates();
	              }));
	          }
	
	          $q.all(promises).then(function() {
	            self.grid.modifyRows(newData)
	              .then(function () {
	                // if (self.viewport) {
	                  self.grid.redrawInPlace(true);
	                // }
	
	                $scope.$evalAsync(function() {
	                  self.grid.refreshCanvas(true);
	                  self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.ROW);
	                });
	              });
	          });
	        }
	      }
	
	      var styleWatchDereg = $scope.$watch(function () { return self.grid.styleComputations; }, function() {
	        self.grid.refreshCanvas(true);
	      });
	
	      $scope.$on('$destroy', function() {
	        deregFunctions.forEach( function( deregFn ){ deregFn(); });
	        styleWatchDereg();
	      });
	
	      self.fireEvent = function(eventName, args) {
	        // Add the grid to the event arguments if it's not there
	        if (typeof(args) === 'undefined' || args === undefined) {
	          args = {};
	        }
	
	        if (typeof(args.grid) === 'undefined' || args.grid === undefined) {
	          args.grid = self.grid;
	        }
	
	        $scope.$broadcast(eventName, args);
	      };
	
	      self.innerCompile = function innerCompile(elm) {
	        $compile(elm)($scope);
	      };
	
	    }]);
	
	/**
	 *  @ngdoc directive
	 *  @name ui.grid.directive:uiGrid
	 *  @element div
	 *  @restrict EA
	 *  @param {Object} uiGrid Options for the grid to use
	 *
	 *  @description Create a very basic grid.
	 *
	 *  @example
	    <example module="app">
	      <file name="app.js">
	        var app = angular.module('app', ['ui.grid']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.data = [
	            { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	          ];
	        }]);
	      </file>
	      <file name="index.html">
	        <div ng-controller="MainCtrl">
	          <div ui-grid="{ data: data }"></div>
	        </div>
	      </file>
	    </example>
	 */
	angular.module('ui.grid').directive('uiGrid', uiGridDirective);
	
	uiGridDirective.$inject = ['$compile', '$templateCache', '$timeout', '$window', 'gridUtil', 'uiGridConstants'];
	function uiGridDirective($compile, $templateCache, $timeout, $window, gridUtil, uiGridConstants) {
	  return {
	    templateUrl: 'ui-grid/ui-grid',
	    scope: {
	      uiGrid: '='
	    },
	    replace: true,
	    transclude: true,
	    controller: 'uiGridController',
	    compile: function () {
	      return {
	        post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var grid = uiGridCtrl.grid;
	          // Initialize scrollbars (TODO: move to controller??)
	          uiGridCtrl.scrollbars = [];
	          grid.element = $elm;
	
	
	          // See if the grid has a rendered width, if not, wait a bit and try again
	          var sizeCheckInterval = 100; // ms
	          var maxSizeChecks = 20; // 2 seconds total
	          var sizeChecks = 0;
	
	          // Setup (event listeners) the grid
	          setup();
	
	          // And initialize it
	          init();
	
	          // Mark rendering complete so API events can happen
	          grid.renderingComplete();
	
	          // If the grid doesn't have size currently, wait for a bit to see if it gets size
	          checkSize();
	
	          /*-- Methods --*/
	
	          function checkSize() {
	            // If the grid has no width and we haven't checked more than <maxSizeChecks> times, check again in <sizeCheckInterval> milliseconds
	            if ($elm[0].offsetWidth <= 0 && sizeChecks < maxSizeChecks) {
	              setTimeout(checkSize, sizeCheckInterval);
	              sizeChecks++;
	            }
	            else {
	              $timeout(init);
	            }
	          }
	
	          // Setup event listeners and watchers
	          function setup() {
	            // Bind to window resize events
	            angular.element($window).on('resize', gridResize);
	
	            // Unbind from window resize events when the grid is destroyed
	            $elm.on('$destroy', function () {
	              angular.element($window).off('resize', gridResize);
	            });
	
	            // If we add a left container after render, we need to watch and react
	            $scope.$watch(function () { return grid.hasLeftContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	
	            // If we add a right container after render, we need to watch and react
	            $scope.$watch(function () { return grid.hasRightContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	          }
	
	          // Initialize the directive
	          function init() {
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	
	            // Default canvasWidth to the grid width, in case we don't get any column definitions to calculate it from
	            grid.canvasWidth = uiGridCtrl.grid.gridWidth;
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            // If the grid isn't tall enough to fit a single row, it's kind of useless. Resize it to fit a minimum number of rows
	            if (grid.gridHeight < grid.options.rowHeight && grid.options.enableMinHeightCheck) {
	              autoAdjustHeight();
	            }
	
	            // Run initial canvas refresh
	            grid.refreshCanvas(true);
	          }
	
	          // Set the grid's height ourselves in the case that its height would be unusably small
	          function autoAdjustHeight() {
	            // Figure out the new height
	            var contentHeight = grid.options.minRowsToShow * grid.options.rowHeight;
	            var headerHeight = grid.options.showHeader ? grid.options.headerRowHeight : 0;
	            var footerHeight = grid.calcFooterHeight();
	            
	            var scrollbarHeight = 0;
	            if (grid.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	              scrollbarHeight = gridUtil.getScrollbarWidth();
	            }
	
	            var maxNumberOfFilters = 0;
	            // Calculates the maximum number of filters in the columns
	            angular.forEach(grid.options.columnDefs, function(col) {
	              if (col.hasOwnProperty('filter')) {
	                if (maxNumberOfFilters < 1) {
	                    maxNumberOfFilters = 1;
	                }
	              }
	              else if (col.hasOwnProperty('filters')) {
	                if (maxNumberOfFilters < col.filters.length) {
	                    maxNumberOfFilters = col.filters.length;
	                }
	              }
	            });
	
	            if (grid.options.enableFiltering) {
	              var allColumnsHaveFilteringTurnedOff = grid.options.columnDefs.every(function(col) {
	                return col.enableFiltering === false;
	              });
	
	              if (!allColumnsHaveFilteringTurnedOff) {
	                maxNumberOfFilters++;
	              }
	            }
	
	            var filterHeight = maxNumberOfFilters * headerHeight;
	
	            var newHeight = headerHeight + contentHeight + footerHeight + scrollbarHeight + filterHeight;
	
	            $elm.css('height', newHeight + 'px');
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	          }
	
	          // Resize the grid on window resize events
	          function gridResize($event) {
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            grid.refreshCanvas(true);
	          }
	        }
	      };
	    }
	  };
	}
	
	})();
	
	(function(){
	  'use strict';
	
	  // TODO: rename this file to ui-grid-pinned-container.js
	
	  angular.module('ui.grid').directive('uiGridPinnedContainer', ['gridUtil', function (gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      template: '<div class="ui-grid-pinned-container"><div ui-grid-render-container container-id="side" row-container-name="\'body\'" col-container-name="side" bind-scroll-vertical="true" class="{{ side }} ui-grid-render-container-{{ side }}"></div></div>',
	      scope: {
	        side: '=uiGridPinnedContainer'
	      },
	      require: '^uiGrid',
	      compile: function compile() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            // gridUtil.logDebug('ui-grid-pinned-container ' + $scope.side + ' link');
	
	            var grid = uiGridCtrl.grid;
	
	            var myWidth = 0;
	
	            $elm.addClass('ui-grid-pinned-container-' + $scope.side);
	
	            // Monkey-patch the viewport width function
	            if ($scope.side === 'left' || $scope.side === 'right') {
	              grid.renderContainers[$scope.side].getViewportWidth = monkeyPatchedGetViewportWidth;
	            }
	
	            function monkeyPatchedGetViewportWidth() {
	              /*jshint validthis: true */
	              var self = this;
	
	              var viewportWidth = 0;
	              self.visibleColumnCache.forEach(function (column) {
	                viewportWidth += column.drawnWidth;
	              });
	
	              var adjustment = self.getViewportAdjustment();
	
	              viewportWidth = viewportWidth + adjustment.width;
	
	              return viewportWidth;
	            }
	
	            function updateContainerWidth() {
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                var cols = grid.renderContainers[$scope.side].visibleColumnCache;
	                var width = 0;
	                for (var i = 0; i < cols.length; i++) {
	                  var col = cols[i];
	                  width += col.drawnWidth || col.width || 0;
	                }
	
	                return width;
	              }
	            }
	
	            function updateContainerDimensions() {
	              var ret = '';
	
	              // Column containers
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                myWidth = updateContainerWidth();
	
	                // gridUtil.logDebug('myWidth', myWidth);
	
	                // TODO(c0bra): Subtract sum of col widths from grid viewport width and update it
	                $elm.attr('style', null);
	
	             //   var myHeight = grid.renderContainers.body.getViewportHeight(); // + grid.horizontalScrollbarHeight;
	
	                ret += '.grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ', .grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ' .ui-grid-render-container-' + $scope.side + ' .ui-grid-viewport { width: ' + myWidth + 'px; } ';
	              }
	
	              return ret;
	            }
	
	            grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	              myWidth = updateContainerWidth();
	
	              // Subtract our own width
	              adjustment.width -= myWidth;
	              adjustment.side = $scope.side;
	
	              return adjustment;
	            });
	
	            // Register style computation to adjust for columns in `side`'s render container
	            grid.registerStyleComputation({
	              priority: 15,
	              func: updateContainerDimensions
	            });
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.factory('Grid', ['$q', '$compile', '$parse', 'gridUtil', 'uiGridConstants', 'GridOptions', 'GridColumn', 'GridRow', 'GridApi', 'rowSorter', 'rowSearcher', 'GridRenderContainer', '$timeout','ScrollEvent',
	    function($q, $compile, $parse, gridUtil, uiGridConstants, GridOptions, GridColumn, GridRow, GridApi, rowSorter, rowSearcher, GridRenderContainer, $timeout, ScrollEvent) {
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.core.api:PublicApi
	   * @description Public Api for the core grid features
	   *
	   */
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:Grid
	   * @description Grid is the main viewModel.  Any properties or methods needed to maintain state are defined in
	   * this prototype.  One instance of Grid is created per Grid directive instance.
	   * @param {object} options Object map of options to pass into the grid. An 'id' property is expected.
	   */
	  var Grid = function Grid(options) {
	    var self = this;
	    // Get the id out of the options, then remove it
	    if (options !== undefined && typeof(options.id) !== 'undefined' && options.id) {
	      if (!/^[_a-zA-Z0-9-]+$/.test(options.id)) {
	        throw new Error("Grid id '" + options.id + '" is invalid. It must follow CSS selector syntax rules.');
	      }
	    }
	    else {
	      throw new Error('No ID provided. An ID must be given when creating a grid.');
	    }
	
	    self.id = options.id;
	    delete options.id;
	
	    // Get default options
	    self.options = GridOptions.initialize( options );
	
	    /**
	     * @ngdoc object
	     * @name appScope
	     * @propertyOf ui.grid.class:Grid
	     * @description reference to the application scope (the parent scope of the ui-grid element).  Assigned in ui-grid controller
	     * <br/>
	     * use gridOptions.appScopeProvider to override the default assignment of $scope.$parent with any reference
	     */
	    self.appScope = self.options.appScopeProvider;
	
	    self.headerHeight = self.options.headerRowHeight;
	
	
	    /**
	     * @ngdoc object
	     * @name footerHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total footer height gridFooter + columnFooter
	     */
	    self.footerHeight = self.calcFooterHeight();
	
	
	    /**
	     * @ngdoc object
	     * @name columnFooterHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total column footer height
	     */
	    self.columnFooterHeight = self.calcColumnFooterHeight();
	
	    self.rtl = false;
	    self.gridHeight = 0;
	    self.gridWidth = 0;
	    self.columnBuilders = [];
	    self.rowBuilders = [];
	    self.rowsProcessors = [];
	    self.columnsProcessors = [];
	    self.styleComputations = [];
	    self.viewportAdjusters = [];
	    self.rowHeaderColumns = [];
	    self.dataChangeCallbacks = {};
	    self.verticalScrollSyncCallBackFns = {};
	    self.horizontalScrollSyncCallBackFns = {};
	
	    // self.visibleRowCache = [];
	
	    // Set of 'render' containers for self grid, which can render sets of rows
	    self.renderContainers = {};
	
	    // Create a
	    self.renderContainers.body = new GridRenderContainer('body', self);
	
	    self.cellValueGetterCache = {};
	
	    // Cached function to use with custom row templates
	    self.getRowTemplateFn = null;
	
	
	    //representation of the rows on the grid.
	    //these are wrapped references to the actual data rows (options.data)
	    self.rows = [];
	
	    //represents the columns on the grid
	    self.columns = [];
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingVertically
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling vertically. Set to false via debounced method
	     */
	    self.isScrollingVertically = false;
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingHorizontally
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling horizontally. Set to false via debounced method
	     */
	    self.isScrollingHorizontally = false;
	
	    /**
	     * @ngdoc property
	     * @name scrollDirection
	     * @propertyOf ui.grid.class:Grid
	     * @description set one of the uiGridConstants.scrollDirection values (UP, DOWN, LEFT, RIGHT, NONE), which tells
	     * us which direction we are scrolling. Set to NONE via debounced method
	     */
	    self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	
	    //if true, grid will not respond to any scroll events
	    self.disableScrolling = false;
	
	
	    function vertical (scrollEvent) {
	      self.isScrollingVertically = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedVertical = gridUtil.debounce(vertical, self.options.scrollDebounce);
	    var debouncedVerticalMinDelay = gridUtil.debounce(vertical, 0);
	
	    function horizontal (scrollEvent) {
	      self.isScrollingHorizontally = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedHorizontal = gridUtil.debounce(horizontal, self.options.scrollDebounce);
	    var debouncedHorizontalMinDelay = gridUtil.debounce(horizontal, 0);
	
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingVertically
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingVertically to true and sets it to false in a debounced function
	     */
	    self.flagScrollingVertically = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingVertically = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedVerticalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedVertical(scrollEvent);
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingHorizontally
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingHorizontally to true and sets it to false in a debounced function
	     */
	    self.flagScrollingHorizontally = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingHorizontally = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedHorizontalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedHorizontal(scrollEvent);
	      }
	    };
	
	    self.scrollbarHeight = 0;
	    self.scrollbarWidth = 0;
	    if (self.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	      self.scrollbarHeight = gridUtil.getScrollbarWidth();
	    }
	
	    if (self.options.enableVerticalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	      self.scrollbarWidth = gridUtil.getScrollbarWidth();
	    }
	
	
	
	    self.api = new GridApi(self);
	
	    /**
	     * @ngdoc function
	     * @name refresh
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Refresh the rendered grid on screen.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     * If you only want to resize the grid, not regenerate all the rows
	     * and columns, you should consider directly calling refreshCanvas instead.
	     *
	     */
	    self.api.registerMethod( 'core', 'refresh', this.refresh );
	
	    /**
	     * @ngdoc function
	     * @name queueGridRefresh
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Request a refresh of the rendered grid on screen, if multiple
	     * calls to queueGridRefresh are made within a digest cycle only one will execute.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     */
	    self.api.registerMethod( 'core', 'queueGridRefresh', this.queueGridRefresh );
	
	    /**
	     * @ngdoc function
	     * @name refreshRows
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Runs only the rowProcessors, columns remain as they were.
	     * It then calls redrawInPlace and refreshCanvas, which adjust the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'refreshRows', this.refreshRows );
	
	    /**
	     * @ngdoc function
	     * @name queueRefresh
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Requests execution of refreshCanvas, if multiple requests are made
	     * during a digest cycle only one will run.  RefreshCanvas updates the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'queueRefresh', this.queueRefresh );
	
	    /**
	     * @ngdoc function
	     * @name handleWindowResize
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Trigger a grid resize, normally this would be picked
	     * up by a watch on window size, but in some circumstances it is necessary
	     * to call this manually
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'handleWindowResize', this.handleWindowResize );
	
	
	    /**
	     * @ngdoc function
	     * @name addRowHeaderColumn
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description adds a row header column to the grid
	     * @param {object} column def
	     *
	     */
	    self.api.registerMethod( 'core', 'addRowHeaderColumn', this.addRowHeaderColumn );
	
	    /**
	     * @ngdoc function
	     * @name scrollToIfNecessary
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridCol} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     *
	     */
	    self.api.registerMethod( 'core', 'scrollToIfNecessary', function(gridRow, gridCol) { return self.scrollToIfNecessary(gridRow, gridCol);} );
	
	    /**
	     * @ngdoc function
	     * @name scrollTo
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    self.api.registerMethod( 'core', 'scrollTo', function (rowEntity, colDef) { return self.scrollTo(rowEntity, colDef);}  );
	
	    /**
	     * @ngdoc function
	     * @name registerRowsProcessor
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description
	     * Register a "rows processor" function. When the rows are updated,
	     * the grid calls each registered "rows processor", which has a chance
	     * to alter the set of rows (sorting, etc) as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedRowsToProcess, columns )} processorFunction rows processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated rows list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, sort manipulations running at 60-65, filter is running at 100,
	     * sort is at 200, grouping and treeview at 400-410, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerRowsProcessor', this.registerRowsProcessor  );
	
	    /**
	     * @ngdoc function
	     * @name registerColumnsProcessor
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description
	     * Register a "columns processor" function. When the columns are updated,
	     * the grid calls each registered "columns processor", which has a chance
	     * to alter the set of columns as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedColumnsToProcess, rows )} processorFunction columns processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated columns list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerColumnsProcessor', this.registerColumnsProcessor  );
	
	
	
	    /**
	     * @ngdoc function
	     * @name sortHandleNulls
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description A null handling method that can be used when building custom sort
	     * functions
	     * @example
	     * <pre>
	     *   mySortFn = function(a, b) {
	     *   var nulls = $scope.gridApi.core.sortHandleNulls(a, b);
	     *   if ( nulls !== null ){
	     *     return nulls;
	     *   } else {
	     *     // your code for sorting here
	     *   };
	     * </pre>
	     * @param {object} a sort value a
	     * @param {object} b sort value b
	     * @returns {number} null if there were no nulls/undefineds, otherwise returns
	     * a sort value that should be passed back from the sort function
	     *
	     */
	    self.api.registerMethod( 'core', 'sortHandleNulls', rowSorter.handleNulls );
	
	
	    /**
	     * @ngdoc function
	     * @name sortChanged
	     * @methodOf  ui.grid.core.api:PublicApi
	     * @description The sort criteria on one or more columns has
	     * changed.  Provides as parameters the grid and the output of
	     * getColumnSorting, which is an array of gridColumns
	     * that have sorting on them, sorted in priority order.
	     *
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back an array of columns with
	     * sorts on them, in priority order.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.sortChanged( $scope, function(sortColumns){
	     *        // do something
	     *      });
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'sortChanged' );
	
	      /**
	     * @ngdoc function
	     * @name columnVisibilityChanged
	     * @methodOf  ui.grid.core.api:PublicApi
	     * @description The visibility of a column has changed,
	     * the column itself is passed out as a parameter of the event.
	     * 
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back the GridCol that has changed.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.columnVisibilityChanged( $scope, function (column) {
	     *        // do something
	     *      } );
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'columnVisibilityChanged' );
	
	    /**
	     * @ngdoc method
	     * @name notifyDataChange
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Notify the grid that a data or config change has occurred,
	     * where that change isn't something the grid was otherwise noticing.  This
	     * might be particularly relevant where you've changed values within the data
	     * and you'd like cell classes to be re-evaluated, or changed config within
	     * the columnDef and you'd like headerCellClasses to be re-evaluated.
	     * @param {string} type one of the
	     * uiGridConstants.dataChange values (ALL, ROW, EDIT, COLUMN), which tells
	     * us which refreshes to fire.
	     *
	     */
	    self.api.registerMethod( 'core', 'notifyDataChange', this.notifyDataChange );
	
	    /**
	     * @ngdoc method
	     * @name clearAllFilters
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Clears all filters and optionally refreshes the visible rows.
	     * @param {object} refreshRows Defaults to true.
	     * @param {object} clearConditions Defaults to false.
	     * @param {object} clearFlags Defaults to false.
	     * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	     */
	    self.api.registerMethod('core', 'clearAllFilters', this.clearAllFilters);
	
	    self.registerDataChangeCallback( self.columnRefreshCallback, [uiGridConstants.dataChange.COLUMN]);
	    self.registerDataChangeCallback( self.processRowsCallback, [uiGridConstants.dataChange.EDIT]);
	    self.registerDataChangeCallback( self.updateFooterHeightCallback, [uiGridConstants.dataChange.OPTIONS]);
	
	    self.registerStyleComputation({
	      priority: 10,
	      func: self.getFooterStyles
	    });
	  };
	
	   Grid.prototype.calcFooterHeight = function () {
	     if (!this.hasFooter()) {
	       return 0;
	     }
	
	     var height = 0;
	     if (this.options.showGridFooter) {
	       height += this.options.gridFooterHeight;
	     }
	
	     height += this.calcColumnFooterHeight();
	
	     return height;
	   };
	
	   Grid.prototype.calcColumnFooterHeight = function () {
	     var height = 0;
	
	     if (this.options.showColumnFooter) {
	       height += this.options.columnFooterHeight;
	     }
	
	     return height;
	   };
	
	   Grid.prototype.getFooterStyles = function () {
	     var style = '.grid' + this.id + ' .ui-grid-footer-aggregates-row { height: ' + this.options.columnFooterHeight + 'px; }';
	     style += ' .grid' + this.id + ' .ui-grid-footer-info { height: ' + this.options.gridFooterHeight + 'px; }';
	     return style;
	   };
	
	  Grid.prototype.hasFooter = function () {
	   return this.options.showGridFooter || this.options.showColumnFooter;
	  };
	
	  /**
	   * @ngdoc function
	   * @name isRTL
	   * @methodOf ui.grid.class:Grid
	   * @description Returns true if grid is RightToLeft
	   */
	  Grid.prototype.isRTL = function () {
	    return this.rtl;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name registerColumnBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates columns from column definitions, the columnbuilders will be called to add
	   * additional properties to the column.
	   * @param {function(colDef, col, gridOptions)} columnBuilder function to be called
	   */
	  Grid.prototype.registerColumnBuilder = function registerColumnBuilder(columnBuilder) {
	    this.columnBuilders.push(columnBuilder);
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumnDefsFromData
	   * @methodOf ui.grid.class:Grid
	   * @description Populates columnDefs from the provided data
	   * @param {function(colDef, col, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.buildColumnDefsFromData = function (dataRows){
	    this.options.columnDefs =  gridUtil.getColumnsFromData(dataRows, this.options.excludeProperties);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerRowBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates rows from gridOptions.data, the rowBuilders will be called to add
	   * additional properties to the row.
	   * @param {function(row, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.registerRowBuilder = function registerRowBuilder(rowBuilder) {
	    this.rowBuilders.push(rowBuilder);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name registerDataChangeCallback
	   * @methodOf ui.grid.class:Grid
	   * @description When a data change occurs, the data change callbacks of the specified type
	   * will be called.  The rules are:
	   *
	   * - when the data watch fires, that is considered a ROW change (the data watch only notices
	   *   added or removed rows)
	   * - when the api is called to inform us of a change, the declared type of that change is used
	   * - when a cell edit completes, the EDIT callbacks are triggered
	   * - when the columnDef watch fires, the COLUMN callbacks are triggered
	   * - when the options watch fires, the OPTIONS callbacks are triggered
	   *
	   * For a given event:
	   * - ALL calls ROW, EDIT, COLUMN, OPTIONS and ALL callbacks
	   * - ROW calls ROW and ALL callbacks
	   * - EDIT calls EDIT and ALL callbacks
	   * - COLUMN calls COLUMN and ALL callbacks
	   * - OPTIONS calls OPTIONS and ALL callbacks
	   *
	   * @param {function(grid)} callback function to be called
	   * @param {array} types the types of data change you want to be informed of.  Values from
	   * the uiGridConstants.dataChange values ( ALL, EDIT, ROW, COLUMN, OPTIONS ).  Optional and defaults to
	   * ALL
	   * @returns {function} deregister function - a function that can be called to deregister this callback
	   */
	  Grid.prototype.registerDataChangeCallback = function registerDataChangeCallback(callback, types, _this) {
	    var uid = gridUtil.nextUid();
	    if ( !types ){
	      types = [uiGridConstants.dataChange.ALL];
	    }
	    if ( !Array.isArray(types)){
	      gridUtil.logError("Expected types to be an array or null in registerDataChangeCallback, value passed was: " + types );
	    }
	    this.dataChangeCallbacks[uid] = { callback: callback, types: types, _this:_this };
	
	    var self = this;
	    var deregisterFunction = function() {
	      delete self.dataChangeCallbacks[uid];
	    };
	    return deregisterFunction;
	  };
	
	  /**
	   * @ngdoc function
	   * @name callDataChangeCallbacks
	   * @methodOf ui.grid.class:Grid
	   * @description Calls the callbacks based on the type of data change that
	   * has occurred. Always calls the ALL callbacks, calls the ROW, EDIT, COLUMN and OPTIONS callbacks if the
	   * event type is matching, or if the type is ALL.
	   * @param {number} type the type of event that occurred - one of the
	   * uiGridConstants.dataChange values (ALL, ROW, EDIT, COLUMN, OPTIONS)
	   */
	  Grid.prototype.callDataChangeCallbacks = function callDataChangeCallbacks(type, options) {
	    angular.forEach( this.dataChangeCallbacks, function( callback, uid ){
	      if ( callback.types.indexOf( uiGridConstants.dataChange.ALL ) !== -1 ||
	           callback.types.indexOf( type ) !== -1 ||
	           type === uiGridConstants.dataChange.ALL ) {
	        if (callback._this) {
	           callback.callback.apply(callback._this,this);
	        }
	        else {
	          callback.callback( this );
	        }
	      }
	    }, this);
	  };
	
	  /**
	   * @ngdoc function
	   * @name notifyDataChange
	   * @methodOf ui.grid.class:Grid
	   * @description Notifies us that a data change has occurred, used in the public
	   * api for users to tell us when they've changed data or some other event that
	   * our watches cannot pick up
	   * @param {string} type the type of event that occurred - one of the
	   * uiGridConstants.dataChange values (ALL, ROW, EDIT, COLUMN)
	   */
	  Grid.prototype.notifyDataChange = function notifyDataChange(type) {
	    var constants = uiGridConstants.dataChange;
	    if ( type === constants.ALL ||
	         type === constants.COLUMN ||
	         type === constants.EDIT ||
	         type === constants.ROW ||
	         type === constants.OPTIONS ){
	      this.callDataChangeCallbacks( type );
	    } else {
	      gridUtil.logError("Notified of a data change, but the type was not recognised, so no action taken, type was: " + type);
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name columnRefreshCallback
	   * @methodOf ui.grid.class:Grid
	   * @description refreshes the grid when a column refresh
	   * is notified, which triggers handling of the visible flag.
	   * This is called on uiGridConstants.dataChange.COLUMN, and is
	   * registered as a dataChangeCallback in grid.js
	   * @param {string} name column name
	   */
	  Grid.prototype.columnRefreshCallback = function columnRefreshCallback( grid ){
	    grid.buildColumns();
	    grid.queueGridRefresh();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name processRowsCallback
	   * @methodOf ui.grid.class:Grid
	   * @description calls the row processors, specifically
	   * intended to reset the sorting when an edit is called,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.EDIT
	   * @param {string} name column name
	   */
	  Grid.prototype.processRowsCallback = function processRowsCallback( grid ){
	    grid.queueGridRefresh();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateFooterHeightCallback
	   * @methodOf ui.grid.class:Grid
	   * @description recalculates the footer height,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.OPTIONS
	   * @param {string} name column name
	   */
	  Grid.prototype.updateFooterHeightCallback = function updateFooterHeightCallback( grid ){
	    grid.footerHeight = grid.calcFooterHeight();
	    grid.columnFooterHeight = grid.calcColumnFooterHeight();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid column for the column name
	   * @param {string} name column name
	   */
	  Grid.prototype.getColumn = function getColumn(name) {
	    var columns = this.columns.filter(function (column) {
	      return column.colDef.name === name;
	    });
	    return columns.length > 0 ? columns[0] : null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColDef
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid colDef for the column name
	   * @param {string} name column.field
	   */
	  Grid.prototype.getColDef = function getColDef(name) {
	    var colDefs = this.options.columnDefs.filter(function (colDef) {
	      return colDef.name === name;
	    });
	    return colDefs.length > 0 ? colDefs[0] : null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name assignTypes
	   * @methodOf ui.grid.class:Grid
	   * @description uses the first row of data to assign colDef.type for any types not defined.
	   */
	  /**
	   * @ngdoc property
	   * @name type
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description the type of the column, used in sorting.  If not provided then the
	   * grid will guess the type.  Add this only if the grid guessing is not to your
	   * satisfaction.  One of:
	   * - 'string'
	   * - 'boolean'
	   * - 'number'
	   * - 'date'
	   * - 'object'
	   * - 'numberStr'
	   * Note that if you choose date, your dates should be in a javascript date type
	   *
	   */
	  Grid.prototype.assignTypes = function(){
	    var self = this;
	    self.options.columnDefs.forEach(function (colDef, index) {
	
	      //Assign colDef type if not specified
	      if (!colDef.type) {
	        var col = new GridColumn(colDef, index, self);
	        var firstRow = self.rows.length > 0 ? self.rows[0] : null;
	        if (firstRow) {
	          colDef.type = gridUtil.guessType(self.getCellValue(firstRow, col));
	        }
	        else {
	          colDef.type = 'string';
	        }
	      }
	    });
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name isRowHeaderColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if the column is a row Header
	   * @param {object} column column
	   */
	  Grid.prototype.isRowHeaderColumn = function isRowHeaderColumn(column) {
	    return this.rowHeaderColumns.indexOf(column) !== -1;
	  };
	
	  /**
	  * @ngdoc function
	  * @name addRowHeaderColumn
	  * @methodOf ui.grid.class:Grid
	  * @description adds a row header column to the grid
	  * @param {object} column def
	  */
	  Grid.prototype.addRowHeaderColumn = function addRowHeaderColumn(colDef) {
	    var self = this;
	    var rowHeaderCol = new GridColumn(colDef, gridUtil.nextUid(), self);
	    rowHeaderCol.isRowHeader = true;
	    if (self.isRTL()) {
	      self.createRightContainer();
	      rowHeaderCol.renderContainer = 'right';
	    }
	    else {
	      self.createLeftContainer();
	      rowHeaderCol.renderContainer = 'left';
	    }
	
	    // relies on the default column builder being first in array, as it is instantiated
	    // as part of grid creation
	    self.columnBuilders[0](colDef,rowHeaderCol,self.options)
	      .then(function(){
	        rowHeaderCol.enableFiltering = false;
	        rowHeaderCol.enableSorting = false;
	        rowHeaderCol.enableHiding = false;
	        self.rowHeaderColumns.push(rowHeaderCol);
	        self.buildColumns()
	          .then( function() {
	            self.preCompileCellTemplates();
	            self.queueGridRefresh();
	          });
	      });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getOnlyDataColumns
	   * @methodOf ui.grid.class:Grid
	   * @description returns all columns except for rowHeader columns
	   */
	  Grid.prototype.getOnlyDataColumns = function getOnlyDataColumns() {
	    var self = this;
	    var cols = [];
	    self.columns.forEach(function (col) {
	      if (self.rowHeaderColumns.indexOf(col) === -1) {
	        cols.push(col);
	      }
	    });
	    return cols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumns
	   * @methodOf ui.grid.class:Grid
	   * @description creates GridColumn objects from the columnDefinition.  Calls each registered
	   * columnBuilder to further process the column
	   * @param {object} options  An object contains options to use when building columns
	   *
	   * * **orderByColumnDefs**: defaults to **false**. When true, `buildColumns` will reorder existing columns according to the order within the column definitions.
	   *
	   * @returns {Promise} a promise to load any needed column resources
	   */
	  Grid.prototype.buildColumns = function buildColumns(opts) {
	    var options = {
	      orderByColumnDefs: false
	    };
	
	    angular.extend(options, opts);
	
	    // gridUtil.logDebug('buildColumns');
	    var self = this;
	    var builderPromises = [];
	    var headerOffset = self.rowHeaderColumns.length;
	    var i;
	
	    // Remove any columns for which a columnDef cannot be found
	    // Deliberately don't use forEach, as it doesn't like splice being called in the middle
	    // Also don't cache columns.length, as it will change during this operation
	    for (i = 0; i < self.columns.length; i++){
	      if (!self.getColDef(self.columns[i].name)) {
	        self.columns.splice(i, 1);
	        i--;
	      }
	    }
	
	    //add row header columns to the grid columns array _after_ columns without columnDefs have been removed
	    self.rowHeaderColumns.forEach(function (rowHeaderColumn) {
	      self.columns.unshift(rowHeaderColumn);
	    });
	
	
	    // look at each column def, and update column properties to match.  If the column def
	    // doesn't have a column, then splice in a new gridCol
	    self.options.columnDefs.forEach(function (colDef, index) {
	      self.preprocessColDef(colDef);
	      var col = self.getColumn(colDef.name);
	
	      if (!col) {
	        col = new GridColumn(colDef, gridUtil.nextUid(), self);
	        self.columns.splice(index + headerOffset, 0, col);
	      }
	      else {
	        // tell updateColumnDef that the column was pre-existing
	        col.updateColumnDef(colDef, false);
	      }
	
	      self.columnBuilders.forEach(function (builder) {
	        builderPromises.push(builder.call(self, colDef, col, self.options));
	      });
	    });
	
	    /*** Reorder columns if necessary ***/
	    if (!!options.orderByColumnDefs) {
	      // Create a shallow copy of the columns as a cache
	      var columnCache = self.columns.slice(0);
	
	      // We need to allow for the "row headers" when mapping from the column defs array to the columns array
	      //   If we have a row header in columns[0] and don't account for it   we'll overwrite it with the column in columnDefs[0]
	
	      // Go through all the column defs, use the shorter of columns length and colDefs.length because if a user has given two columns the same name then
	      // columns will be shorter than columnDefs.  In this situation we'll avoid an error, but the user will still get an unexpected result
	      var len = Math.min(self.options.columnDefs.length, self.columns.length);
	      for (i = 0; i < len; i++) {
	        // If the column at this index has a different name than the column at the same index in the column defs...
	        if (self.columns[i + headerOffset].name !== self.options.columnDefs[i].name) {
	          // Replace the one in the cache with the appropriate column
	          columnCache[i + headerOffset] = self.getColumn(self.options.columnDefs[i].name);
	        }
	        else {
	          // Otherwise just copy over the one from the initial columns
	          columnCache[i + headerOffset] = self.columns[i + headerOffset];
	        }
	      }
	
	      // Empty out the columns array, non-destructively
	      self.columns.length = 0;
	
	      // And splice in the updated, ordered columns from the cache
	      Array.prototype.splice.apply(self.columns, [0, 0].concat(columnCache));
	    }
	
	    return $q.all(builderPromises).then(function(){
	      if (self.rows.length > 0){
	        self.assignTypes();
	      }
	    });
	  };
	
	/**
	 * @ngdoc function
	 * @name preCompileCellTemplates
	 * @methodOf ui.grid.class:Grid
	 * @description precompiles all cell templates
	 */
	  Grid.prototype.preCompileCellTemplates = function() {
	    var self = this;
	
	    var preCompileTemplate = function( col ) {
	      var html = col.cellTemplate.replace(uiGridConstants.MODEL_COL_FIELD, self.getQualifiedColField(col));
	      html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	      var compiledElementFn = $compile(html);
	      col.compiledElementFn = compiledElementFn;
	
	      if (col.compiledElementFnDefer) {
	        col.compiledElementFnDefer.resolve(col.compiledElementFn);
	      }
	    };
	
	    this.columns.forEach(function (col) {
	      if ( col.cellTemplate ){
	        preCompileTemplate( col );
	      } else if ( col.cellTemplatePromise ){
	        col.cellTemplatePromise.then( function() {
	          preCompileTemplate( col );
	        });
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getGridQualifiedColField
	   * @methodOf ui.grid.class:Grid
	   * @description Returns the $parse-able accessor for a column within its $scope
	   * @param {GridColumn} col col object
	   */
	  Grid.prototype.getQualifiedColField = function (col) {
	    return 'row.entity.' + gridUtil.preEval(col.field);
	  };
	
	  /**
	   * @ngdoc function
	   * @name createLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the left render container if it doesn't already exist
	   */
	  Grid.prototype.createLeftContainer = function() {
	    if (!this.hasLeftContainer()) {
	      this.renderContainers.left = new GridRenderContainer('left', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name createRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the right render container if it doesn't already exist
	   */
	  Grid.prototype.createRightContainer = function() {
	    if (!this.hasRightContainer()) {
	      this.renderContainers.right = new GridRenderContainer('right', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if leftContainer exists
	   */
	  Grid.prototype.hasLeftContainer = function() {
	    return this.renderContainers.left !== undefined;
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if rightContainer exists
	   */
	  Grid.prototype.hasRightContainer = function() {
	    return this.renderContainers.right !== undefined;
	  };
	
	
	      /**
	   * undocumented function
	   * @name preprocessColDef
	   * @methodOf ui.grid.class:Grid
	   * @description defaults the name property from field to maintain backwards compatibility with 2.x
	   * validates that name or field is present
	   */
	  Grid.prototype.preprocessColDef = function preprocessColDef(colDef) {
	    var self = this;
	
	    if (!colDef.field && !colDef.name) {
	      throw new Error('colDef.name or colDef.field property is required');
	    }
	
	    //maintain backwards compatibility with 2.x
	    //field was required in 2.x.  now name is required
	    if (colDef.name === undefined && colDef.field !== undefined) {
	      // See if the column name already exists:
	      var newName = colDef.field,
	        counter = 2;
	      while (self.getColumn(newName)) {
	        newName = colDef.field + counter.toString();
	        counter++;
	      }
	      colDef.name = newName;
	    }
	  };
	
	  // Return a list of items that exist in the `n` array but not the `o` array. Uses optional property accessors passed as third & fourth parameters
	  Grid.prototype.newInN = function newInN(o, n, oAccessor, nAccessor) {
	    var self = this;
	
	    var t = [];
	    for (var i = 0; i < n.length; i++) {
	      var nV = nAccessor ? n[i][nAccessor] : n[i];
	
	      var found = false;
	      for (var j = 0; j < o.length; j++) {
	        var oV = oAccessor ? o[j][oAccessor] : o[j];
	        if (self.options.rowEquality(nV, oV)) {
	          found = true;
	          break;
	        }
	      }
	      if (!found) {
	        t.push(nV);
	      }
	    }
	
	    return t;
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRow
	   * @methodOf ui.grid.class:Grid
	   * @description returns the GridRow that contains the rowEntity
	   * @param {object} rowEntity the gridOptions.data array element instance
	   * @param {array} rows [optional] the rows to look in - if not provided then
	   * looks in grid.rows
	   */
	  Grid.prototype.getRow = function getRow(rowEntity, lookInRows) {
	    var self = this;
	
	    lookInRows = typeof(lookInRows) === 'undefined' ? self.rows : lookInRows;
	
	    var rows = lookInRows.filter(function (row) {
	      return self.options.rowEquality(row.entity, rowEntity);
	    });
	    return rows.length > 0 ? rows[0] : null;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name modifyRows
	   * @methodOf ui.grid.class:Grid
	   * @description creates or removes GridRow objects from the newRawData array.  Calls each registered
	   * rowBuilder to further process the row
	   * @param {array} newRawData Modified set of data
	   *
	   * This method aims to achieve three things:
	   * 1. the resulting rows array is in the same order as the newRawData, we'll call
	   * rowsProcessors immediately after to sort the data anyway
	   * 2. if we have row hashing available, we try to use the rowHash to find the row
	   * 3. no memory leaks - rows that are no longer in newRawData need to be garbage collected
	   *
	   * The basic logic flow makes use of the newRawData, oldRows and oldHash, and creates
	   * the newRows and newHash
	   *
	   * ```
	   * newRawData.forEach newEntity
	   *   if (hashing enabled)
	   *     check oldHash for newEntity
	   *   else
	   *     look for old row directly in oldRows
	   *   if !oldRowFound     // must be a new row
	   *     create newRow
	   *   append to the newRows and add to newHash
	   *   run the processors
	   * ```
	   * 
	   * Rows are identified using the hashKey if configured.  If not configured, then rows
	   * are identified using the gridOptions.rowEquality function
	   * 
	   * This method is useful when trying to select rows immediately after loading data without
	   * using a $timeout/$interval, e.g.:
	   * 
	   *   $scope.gridOptions.data =  someData;
	   *   $scope.gridApi.grid.modifyRows($scope.gridOptions.data);
	   *   $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
	   * 
	   * OR to persist row selection after data update (e.g. rows selected, new data loaded, want
	   * originally selected rows to be re-selected))
	   */
	  Grid.prototype.modifyRows = function modifyRows(newRawData) {
	    var self = this;
	    var oldRows = self.rows.slice(0);
	    var oldRowHash = self.rowHashMap || self.createRowHashMap();
	    self.rowHashMap = self.createRowHashMap();
	    self.rows.length = 0;
	
	    newRawData.forEach( function( newEntity, i ) {
	      var newRow;
	      if ( self.options.enableRowHashing ){
	        // if hashing is enabled, then this row will be in the hash if we already know about it
	        newRow = oldRowHash.get( newEntity );
	      } else {
	        // otherwise, manually search the oldRows to see if we can find this row
	        newRow = self.getRow(newEntity, oldRows);
	      }
	
	      // if we didn't find the row, it must be new, so create it
	      if ( !newRow ){
	        newRow = self.processRowBuilders(new GridRow(newEntity, i, self));
	      }
	
	      self.rows.push( newRow );
	      self.rowHashMap.put( newEntity, newRow );
	    });
	
	    self.assignTypes();
	
	    var p1 = $q.when(self.processRowsProcessors(self.rows))
	      .then(function (renderableRows) {
	        return self.setVisibleRows(renderableRows);
	      });
	
	    var p2 = $q.when(self.processColumnsProcessors(self.columns))
	      .then(function (renderableColumns) {
	        return self.setVisibleColumns(renderableColumns);
	      });
	
	    return $q.all([p1, p2]);
	  };
	
	
	  /**
	   * Private Undocumented Method
	   * @name addRows
	   * @methodOf ui.grid.class:Grid
	   * @description adds the newRawData array of rows to the grid and calls all registered
	   * rowBuilders. this keyword will reference the grid
	   */
	  Grid.prototype.addRows = function addRows(newRawData) {
	    var self = this;
	
	    var existingRowCount = self.rows.length;
	    for (var i = 0; i < newRawData.length; i++) {
	      var newRow = self.processRowBuilders(new GridRow(newRawData[i], i + existingRowCount, self));
	
	      if (self.options.enableRowHashing) {
	        var found = self.rowHashMap.get(newRow.entity);
	        if (found) {
	          found.row = newRow;
	        }
	      }
	
	      self.rows.push(newRow);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name processRowBuilders
	   * @methodOf ui.grid.class:Grid
	   * @description processes all RowBuilders for the gridRow
	   * @param {GridRow} gridRow reference to gridRow
	   * @returns {GridRow} the gridRow with all additional behavior added
	   */
	  Grid.prototype.processRowBuilders = function processRowBuilders(gridRow) {
	    var self = this;
	
	    self.rowBuilders.forEach(function (builder) {
	      builder.call(self, gridRow, self.options);
	    });
	
	    return gridRow;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerStyleComputation
	   * @methodOf ui.grid.class:Grid
	   * @description registered a styleComputation function
	   *
	   * If the function returns a value it will be appended into the grid's `<style>` block
	   * @param {function($scope)} styleComputation function
	   */
	  Grid.prototype.registerStyleComputation = function registerStyleComputation(styleComputationInfo) {
	    this.styleComputations.push(styleComputationInfo);
	  };
	
	
	  // NOTE (c0bra): We already have rowBuilders. I think these do exactly the same thing...
	  // Grid.prototype.registerRowFilter = function(filter) {
	  //   // TODO(c0bra): validate filter?
	
	  //   this.rowFilters.push(filter);
	  // };
	
	  // Grid.prototype.removeRowFilter = function(filter) {
	  //   var idx = this.rowFilters.indexOf(filter);
	
	  //   if (typeof(idx) !== 'undefined' && idx !== undefined) {
	  //     this.rowFilters.slice(idx, 1);
	  //   }
	  // };
	
	  // Grid.prototype.processRowFilters = function(rows) {
	  //   var self = this;
	  //   self.rowFilters.forEach(function (filter) {
	  //     filter.call(self, rows);
	  //   });
	  // };
	
	
	  /**
	   * @ngdoc function
	   * @name registerRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @description
	   *
	   * Register a "rows processor" function. When the rows are updated,
	   * the grid calls each registered "rows processor", which has a chance
	   * to alter the set of rows (sorting, etc) as long as the count is not
	   * modified.
	   *
	   * @param {function(renderedRowsToProcess, columns )} processorFunction rows processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and must
	   * return the updated rows list, which is passed to the next processor in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   *
	   */
	  Grid.prototype.registerRowsProcessor = function registerRowsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.rowsProcessors.push({processor: processor, priority: priority});
	    this.rowsProcessors.sort(function sortByPriority( a, b ){
	      return a.priority - b.priority;
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderableRows)} rows processor function
	   * @description Remove a registered rows processor
	   */
	  Grid.prototype.removeRowsProcessor = function removeRowsProcessor(processor) {
	    var idx = -1;
	    this.rowsProcessors.forEach(function(rowsProcessor, index){
	      if ( rowsProcessor.processor === processor ){
	        idx = index;
	      }
	    });
	
	    if ( idx !== -1 ) {
	      this.rowsProcessors.splice(idx, 1);
	    }
	  };
	
	  /**
	   * Private Undocumented Method
	   * @name processRowsProcessors
	   * @methodOf ui.grid.class:Grid
	   * @param {Array[GridRow]} The array of "renderable" rows
	   * @param {Array[GridColumn]} The array of columns
	   * @description Run all the registered rows processors on the array of renderable rows
	   */
	  Grid.prototype.processRowsProcessors = function processRowsProcessors(renderableRows) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableRows = renderableRows.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.rowsProcessors.length === 0) {
	      return $q.when(myRenderableRows);
	    }
	
	    // Counter for iterating through rows processors
	    var i = 0;
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedRowsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.rowsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedRowsToProcess, self.columns) )
	        .then(function handleProcessedRows(processedRows) {
	          // Check for errors
	          if (!processedRows) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedRows)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.rowsProcessors.length - 1) {
	            return startProcessor(i, processedRows);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(processedRows);
	          }
	        });
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableRows);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleRows = function setVisibleRows(rows) {
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.canvasHeightShouldUpdate = true;
	
	      if ( typeof(container.visibleRowCache) === 'undefined' ){
	        container.visibleRowCache = [];
	      } else {
	        container.visibleRowCache.length = 0;
	      }
	    }
	
	    // rows.forEach(function (row) {
	    for (var ri = 0; ri < rows.length; ri++) {
	      var row = rows[ri];
	
	      var targetContainer = (typeof(row.renderContainer) !== 'undefined' && row.renderContainer) ? row.renderContainer : 'body';
	
	      // If the row is visible
	      if (row.visible) {
	        self.renderContainers[targetContainer].visibleRowCache.push(row);
	      }
	    }
	    self.api.core.raise.rowsRendered(this.api);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerColumnsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderedColumnsToProcess, rows)} columnProcessor column processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and
	   * which must return an updated renderedColumnsToProcess which can be passed to the next processor
	   * in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   * @description
	
	     Register a "columns processor" function. When the columns are updated,
	     the grid calls each registered "columns processor", which has a chance
	     to alter the set of columns, as long as the count is not modified.
	   */
	  Grid.prototype.registerColumnsProcessor = function registerColumnsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.columnsProcessors.push({processor: processor, priority: priority});
	    this.columnsProcessors.sort(function sortByPriority( a, b ){
	      return a.priority - b.priority;
	    });
	  };
	
	  Grid.prototype.removeColumnsProcessor = function removeColumnsProcessor(processor) {
	    var idx = this.columnsProcessors.indexOf(processor);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.columnsProcessors.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.processColumnsProcessors = function processColumnsProcessors(renderableColumns) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableColumns = renderableColumns.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.columnsProcessors.length === 0) {
	      return $q.when(myRenderableColumns);
	    }
	
	    // Counter for iterating through rows processors
	    var i = 0;
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedColumnsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.columnsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedColumnsToProcess, self.rows) )
	        .then(function handleProcessedRows(processedColumns) {
	          // Check for errors
	          if (!processedColumns) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedColumns)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.columnsProcessors.length - 1) {
	            return startProcessor(i, myRenderableColumns);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(myRenderableColumns);
	          }
	        });
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableColumns);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleColumns = function setVisibleColumns(columns) {
	    // gridUtil.logDebug('setVisibleColumns');
	
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.visibleColumnCache.length = 0;
	    }
	
	    for (var ci = 0; ci < columns.length; ci++) {
	      var column = columns[ci];
	
	      // If the column is visible
	      if (column.visible) {
	        // If the column has a container specified
	        if (typeof(column.renderContainer) !== 'undefined' && column.renderContainer) {
	          self.renderContainers[column.renderContainer].visibleColumnCache.push(column);
	        }
	        // If not, put it into the body container
	        else {
	          self.renderContainers.body.visibleColumnCache.push(column);
	        }
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name handleWindowResize
	   * @methodOf ui.grid.class:Grid
	   * @description Triggered when the browser window resizes; automatically resizes the grid
	   */
	  Grid.prototype.handleWindowResize = function handleWindowResize($event) {
	    var self = this;
	
	    self.gridWidth = gridUtil.elementWidth(self.element);
	    self.gridHeight = gridUtil.elementHeight(self.element);
	
	    self.queueRefresh();
	  };
	
	  /**
	   * @ngdoc function
	   * @name queueRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refreshCanvas, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueRefresh = function queueRefresh() {
	    var self = this;
	
	    if (self.refreshCanceller) {
	      $timeout.cancel(self.refreshCanceller);
	    }
	
	    self.refreshCanceller = $timeout(function () {
	      self.refreshCanvas(true);
	    });
	
	    self.refreshCanceller.then(function () {
	      self.refreshCanceller = null;
	    });
	
	    return self.refreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name queueGridRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refresh, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueGridRefresh = function queueGridRefresh() {
	    var self = this;
	
	    if (self.gridRefreshCanceller) {
	      $timeout.cancel(self.gridRefreshCanceller);
	    }
	
	    self.gridRefreshCanceller = $timeout(function () {
	      self.refresh(true);
	    });
	
	    self.gridRefreshCanceller.then(function () {
	      self.gridRefreshCanceller = null;
	    });
	
	    return self.gridRefreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateCanvasHeight
	   * @methodOf ui.grid.class:Grid
	   * @description flags all render containers to update their canvas height
	   */
	  Grid.prototype.updateCanvasHeight = function updateCanvasHeight() {
	    var self = this;
	
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	        container.canvasHeightShouldUpdate = true;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildStyles
	   * @methodOf ui.grid.class:Grid
	   * @description calls each styleComputation function
	   */
	  // TODO: this used to take $scope, but couldn't see that it was used
	  Grid.prototype.buildStyles = function buildStyles() {
	    // gridUtil.logDebug('buildStyles');
	
	    var self = this;
	
	    self.customStyles = '';
	
	    self.styleComputations
	      .sort(function(a, b) {
	        if (a.priority === null) { return 1; }
	        if (b.priority === null) { return -1; }
	        if (a.priority === null && b.priority === null) { return 0; }
	        return a.priority - b.priority;
	      })
	      .forEach(function (compInfo) {
	        // this used to provide $scope as a second parameter, but I couldn't find any
	        // style builders that used it, so removed it as part of moving to grid from controller
	        var ret = compInfo.func.call(self);
	
	        if (angular.isString(ret)) {
	          self.customStyles += '\n' + ret;
	        }
	      });
	  };
	
	
	  Grid.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewport = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	    self.columns.forEach(function(col, i) {
	      if (totalWidth < viewport) {
	        totalWidth += col.drawnWidth;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.columns[j].drawnWidth;
	        }
	        if (currWidth < viewport) {
	          min++;
	        }
	      }
	    });
	
	    return min;
	  };
	
	  Grid.prototype.getBodyHeight = function getBodyHeight() {
	    // Start with the viewportHeight
	    var bodyHeight = this.getViewportHeight();
	
	    // Add the horizontal scrollbar height if there is one
	    //if (typeof(this.horizontalScrollbarHeight) !== 'undefined' && this.horizontalScrollbarHeight !== undefined && this.horizontalScrollbarHeight > 0) {
	    //  bodyHeight = bodyHeight + this.horizontalScrollbarHeight;
	    //}
	
	    return bodyHeight;
	  };
	
	  // NOTE: viewport drawable height is the height of the grid minus the header row height (including any border)
	  // TODO(c0bra): account for footer height
	  Grid.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var viewPortHeight = this.gridHeight - this.headerHeight - this.footerHeight;
	
	    // Account for native horizontal scrollbar, if present
	    //if (typeof(this.horizontalScrollbarHeight) !== 'undefined' && this.horizontalScrollbarHeight !== undefined && this.horizontalScrollbarHeight > 0) {
	    //  viewPortHeight = viewPortHeight - this.horizontalScrollbarHeight;
	    //}
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    //gridUtil.logDebug('viewPortHeight', viewPortHeight);
	
	    return viewPortHeight;
	  };
	
	  Grid.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewPortWidth = this.gridWidth;
	
	    //if (typeof(this.verticalScrollbarWidth) !== 'undefined' && this.verticalScrollbarWidth !== undefined && this.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth - this.verticalScrollbarWidth;
	    //}
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortWidth = viewPortWidth + adjustment.width;
	
	    //gridUtil.logDebug('getviewPortWidth', viewPortWidth);
	
	    return viewPortWidth;
	  };
	
	  Grid.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    var viewPortWidth = this.getViewportWidth();
	
	    //if (typeof(this.verticalScrollbarWidth) !== 'undefined' && this.verticalScrollbarWidth !== undefined && this.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth + this.verticalScrollbarWidth;
	    //}
	
	    return viewPortWidth;
	  };
	
	  Grid.prototype.addVerticalScrollSync = function (containerId, callBackFn) {
	    this.verticalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	  Grid.prototype.addHorizontalScrollSync = function (containerId, callBackFn) {
	    this.horizontalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	/**
	 * Scroll needed containers by calling their ScrollSyncs
	 * @param sourceContainerId the containerId that has already set it's top/left.
	 *         can be empty string which means all containers need to set top/left
	 * @param scrollEvent
	 */
	  Grid.prototype.scrollContainers = function (sourceContainerId, scrollEvent) {
	
	    if (scrollEvent.y) {
	      //default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var verts = ['body','left', 'right'];
	
	      this.flagScrollingVertically(scrollEvent);
	
	      if (sourceContainerId === 'body') {
	        verts = ['left', 'right'];
	      }
	      else if (sourceContainerId === 'left') {
	        verts = ['body', 'right'];
	      }
	      else if (sourceContainerId === 'right') {
	        verts = ['body', 'left'];
	      }
	
	      for (var i = 0; i < verts.length; i++) {
	        var id = verts[i];
	        if (this.verticalScrollSyncCallBackFns[id]) {
	          this.verticalScrollSyncCallBackFns[id](scrollEvent);
	        }
	      }
	
	    }
	
	    if (scrollEvent.x) {
	      //default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var horizs = ['body','bodyheader', 'bodyfooter'];
	
	      this.flagScrollingHorizontally(scrollEvent);
	      if (sourceContainerId === 'body') {
	        horizs = ['bodyheader', 'bodyfooter'];
	      }
	
	      for (var j = 0; j < horizs.length; j++) {
	        var idh = horizs[j];
	        if (this.horizontalScrollSyncCallBackFns[idh]) {
	          this.horizontalScrollSyncCallBackFns[idh](scrollEvent);
	        }
	      }
	
	    }
	
	  };
	
	  Grid.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  Grid.prototype.removeViewportAdjuster = function registerViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  Grid.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    // var count = 0;
	
	    // this.rows.forEach(function (row) {
	    //   if (row.visible) {
	    //     count++;
	    //   }
	    // });
	
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleRowCache.length;
	  };
	
	   Grid.prototype.getVisibleRows = function getVisibleRows() {
	    return this.renderContainers.body.visibleRowCache;
	   };
	
	  Grid.prototype.getVisibleColumnCount = function getVisibleColumnCount() {
	    // var count = 0;
	
	    // this.rows.forEach(function (row) {
	    //   if (row.visible) {
	    //     count++;
	    //   }
	    // });
	
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleColumnCache.length;
	  };
	
	
	  Grid.prototype.searchRows = function searchRows(renderableRows) {
	    return rowSearcher.search(this, renderableRows, this.columns);
	  };
	
	  Grid.prototype.sortByColumn = function sortByColumn(renderableRows) {
	    return rowSorter.sort(this, renderableRows, this.columns);
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the value of a cell for a particular row and column
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellValue = function getCellValue(row, col){
	    if ( typeof(row.entity[ '$$' + col.uid ]) !== 'undefined' ) {
	      return row.entity[ '$$' + col.uid].rendered;
	    } else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined' ){
	      return row.entity[col.field];
	    } else {
	      if (!col.cellValueGetterCache) {
	        col.cellValueGetterCache = $parse(row.getEntityQualifiedColField(col));
	      }
	
	      return col.cellValueGetterCache(row);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellDisplayValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the displayed value of a cell after applying any the `cellFilter`
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellDisplayValue = function getCellDisplayValue(row, col) {
	    if ( !col.cellDisplayGetterCache ) {
	      var custom_filter = col.cellFilter ? " | " + col.cellFilter : "";
	
	      if (typeof(row.entity['$$' + col.uid]) !== 'undefined') {
	        col.cellDisplayGetterCache = $parse(row.entity['$$' + col.uid].rendered + custom_filter);
	      } else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined') {
	        col.cellDisplayGetterCache = $parse(row.entity[col.field] + custom_filter);
	      } else {
	        col.cellDisplayGetterCache = $parse(row.getEntityQualifiedColField(col) + custom_filter);
	      }
	    }
	
	    return col.cellDisplayGetterCache(row);
	  };
	
	
	  Grid.prototype.getNextColumnSortPriority = function getNextColumnSortPriority() {
	    var self = this,
	        p = 0;
	
	    self.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority && col.sort.priority > p) {
	        p = col.sort.priority;
	      }
	    });
	
	    return p + 1;
	  };
	
	  /**
	   * @ngdoc function
	   * @name resetColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @param {GridColumn} [excludedColumn] Optional GridColumn to exclude from having its sorting reset
	   */
	  Grid.prototype.resetColumnSorting = function resetColumnSorting(excludeCol) {
	    var self = this;
	
	    self.columns.forEach(function (col) {
	      if (col !== excludeCol && !col.suppressRemoveSort) {
	        col.sort = {};
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @returns {Array[GridColumn]} An array of GridColumn objects
	   */
	  Grid.prototype.getColumnSorting = function getColumnSorting() {
	    var self = this;
	
	    var sortedCols = [], myCols;
	
	    // Iterate through all the columns, sorted by priority
	    // Make local copy of column list, because sorting is in-place and we do not want to
	    // change the original sequence of columns
	    myCols = self.columns.slice(0);
	    myCols.sort(rowSorter.prioritySort).forEach(function (col) {
	      if (col.sort && typeof(col.sort.direction) !== 'undefined' && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortedCols.push(col);
	      }
	    });
	
	    return sortedCols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name sortColumn
	   * @methodOf ui.grid.class:Grid
	   * @description Set the sorting on a given column, optionally resetting any existing sorting on the Grid.
	   * Emits the sortChanged event whenever the sort criteria are changed.
	   * @param {GridColumn} column Column to set the sorting on
	   * @param {uiGridConstants.ASC|uiGridConstants.DESC} [direction] Direction to sort by, either descending or ascending.
	   *   If not provided, the column will iterate through the sort directions
	   *   specified in the {@link ui.grid.class:GridOptions.columnDef#sortDirectionCycle sortDirectionCycle} attribute.
	   * @param {boolean} [add] Add this column to the sorting. If not provided or set to `false`, the Grid will reset any existing sorting and sort
	   *   by this column only
	   * @returns {Promise} A resolved promise that supplies the column.
	   */
	
	  Grid.prototype.sortColumn = function sortColumn(column, directionOrAdd, add) {
	    var self = this,
	        direction = null;
	
	    if (typeof(column) === 'undefined' || !column) {
	      throw new Error('No column parameter provided');
	    }
	
	    // Second argument can either be a direction or whether to add this column to the existing sort.
	    //   If it's a boolean, it's an add, otherwise, it's a direction
	    if (typeof(directionOrAdd) === 'boolean') {
	      add = directionOrAdd;
	    }
	    else {
	      direction = directionOrAdd;
	    }
	
	    if (!add) {
	      self.resetColumnSorting(column);
	      column.sort.priority = 0;
	      // Get the actual priority since there may be columns which have suppressRemoveSort set
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	    else if (!column.sort.priority){
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	
	    if (!direction) {
	      // Find the current position in the cycle (or -1).
	      var i = column.sortDirectionCycle.indexOf(column.sort.direction ? column.sort.direction : null);
	      // Proceed to the next position in the cycle (or start at the beginning).
	      i = (i+1) % column.sortDirectionCycle.length;
	      // If suppressRemoveSort is set, and the next position in the cycle would
	      // remove the sort, skip it.
	      if (column.colDef && column.suppressRemoveSort && !column.sortDirectionCycle[i]) {
	        i = (i+1) % column.sortDirectionCycle.length;
	      }
	
	      if (column.sortDirectionCycle[i]) {
	        column.sort.direction = column.sortDirectionCycle[i];
	      } else {
	        column.sort = {};
	      }
	    }
	    else {
	      column.sort.direction = direction;
	    }
	
	    self.api.core.raise.sortChanged( self, self.getColumnSorting() );
	
	    return $q.when(column);
	  };
	
	  /**
	   * communicate to outside world that we are done with initial rendering
	   */
	  Grid.prototype.renderingComplete = function(){
	    if (angular.isFunction(this.options.onRegisterApi)) {
	      this.options.onRegisterApi(this.api);
	    }
	    this.api.core.raise.renderingComplete( this.api );
	  };
	
	  Grid.prototype.createRowHashMap = function createRowHashMap() {
	    var self = this;
	
	    var hashMap = new RowHashMap();
	    hashMap.grid = self;
	
	    return hashMap;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name refresh
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered grid on screen.
	   * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed.
	   */
	  Grid.prototype.refresh = function refresh(rowsAltered) {
	    var self = this;
	
	    var p1 = self.processRowsProcessors(self.rows).then(function (renderableRows) {
	      self.setVisibleRows(renderableRows);
	    });
	
	    var p2 = self.processColumnsProcessors(self.columns).then(function (renderableColumns) {
	      self.setVisibleColumns(renderableColumns);
	    });
	
	    return $q.all([p1, p2]).then(function () {
	      self.redrawInPlace(rowsAltered);
	
	      self.refreshCanvas(true);
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshRows
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered rows on screen?  Note: not functional at present
	   * @returns {promise} promise that is resolved when render completes?
	   *
	   */
	  Grid.prototype.refreshRows = function refreshRows() {
	    var self = this;
	
	    return self.processRowsProcessors(self.rows)
	      .then(function (renderableRows) {
	        self.setVisibleRows(renderableRows);
	
	        self.redrawInPlace();
	
	        self.refreshCanvas( true );
	      });
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshCanvas
	   * @methodOf ui.grid.class:Grid
	   * @description Builds all styles and recalculates much of the grid sizing
	   * @param {object} buildStyles optional parameter.  Use TBD
	   * @returns {promise} promise that is resolved when the canvas
	   * has been refreshed
	   *
	   */
	  Grid.prototype.refreshCanvas = function(buildStyles) {
	    var self = this;
	
	    if (buildStyles) {
	      self.buildStyles();
	    }
	
	    var p = $q.defer();
	
	    // Get all the header heights
	    var containerHeadersToRecalc = [];
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	
	        // Skip containers that have no canvasWidth set yet
	        if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	          continue;
	        }
	
	        if (container.header || container.headerCanvas) {
	          container.explicitHeaderHeight = container.explicitHeaderHeight || null;
	          container.explicitHeaderCanvasHeight = container.explicitHeaderCanvasHeight || null;
	
	          containerHeadersToRecalc.push(container);
	        }
	      }
	    }
	
	    /*
	     *
	     * Here we loop through the headers, measuring each element as well as any header "canvas" it has within it.
	     *
	     * If any header is less than the largest header height, it will be resized to that so that we don't have headers
	     * with different heights, which looks like a rendering problem
	     *
	     * We'll do the same thing with the header canvases, and give the header CELLS an explicit height if their canvas
	     * is smaller than the largest canvas height. That was header cells without extra controls like filtering don't
	     * appear shorter than other cells.
	     *
	     */
	    if (containerHeadersToRecalc.length > 0) {
	      // Build the styles without the explicit header heights
	      if (buildStyles) {
	        self.buildStyles();
	      }
	
	      // Putting in a timeout as it's not calculating after the grid element is rendered and filled out
	      $timeout(function() {
	        // var oldHeaderHeight = self.grid.headerHeight;
	        // self.grid.headerHeight = gridUtil.outerElementHeight(self.header);
	
	        var rebuildStyles = false;
	
	        // Get all the header heights
	        var maxHeaderHeight = 0;
	        var maxHeaderCanvasHeight = 0;
	        var i, container;
	        var getHeight = function(oldVal, newVal){
	          if ( oldVal !== newVal){
	            rebuildStyles = true;
	          }
	          return newVal;
	        };
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          // Skip containers that have no canvasWidth set yet
	          if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	            continue;
	          }
	
	          if (container.header) {
	            var headerHeight = container.headerHeight = getHeight(container.headerHeight, parseInt(gridUtil.outerElementHeight(container.header), 10));
	
	            // Get the "inner" header height, that is the height minus the top and bottom borders, if present. We'll use it to make sure all the headers have a consistent height
	            var topBorder = gridUtil.getBorderSize(container.header, 'top');
	            var bottomBorder = gridUtil.getBorderSize(container.header, 'bottom');
	            var innerHeaderHeight = parseInt(headerHeight - topBorder - bottomBorder, 10);
	
	            innerHeaderHeight  = innerHeaderHeight < 0 ? 0 : innerHeaderHeight;
	
	            container.innerHeaderHeight = innerHeaderHeight;
	
	            // If the header doesn't have an explicit height set, save the largest header height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderHeight && innerHeaderHeight > maxHeaderHeight) {
	              maxHeaderHeight = innerHeaderHeight;
	            }
	          }
	
	          if (container.headerCanvas) {
	            var headerCanvasHeight = container.headerCanvasHeight = getHeight(container.headerCanvasHeight, parseInt(gridUtil.outerElementHeight(container.headerCanvas), 10));
	
	
	            // If the header doesn't have an explicit canvas height, save the largest header canvas height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderCanvasHeight && headerCanvasHeight > maxHeaderCanvasHeight) {
	              maxHeaderCanvasHeight = headerCanvasHeight;
	            }
	          }
	        }
	
	        // Go through all the headers
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          /* If:
	              1. We have a max header height
	              2. This container has a header height defined
	              3. And either this container has an explicit header height set, OR its header height is less than the max
	
	              then:
	
	              Give this container's header an explicit height so it will line up with the tallest header
	          */
	          if (
	            maxHeaderHeight > 0 && typeof(container.headerHeight) !== 'undefined' && container.headerHeight !== null &&
	            (container.explicitHeaderHeight || container.headerHeight < maxHeaderHeight)
	          ) {
	            container.explicitHeaderHeight = getHeight(container.explicitHeaderHeight, maxHeaderHeight);
	          }
	
	          // Do the same as above except for the header canvas
	          if (
	            maxHeaderCanvasHeight > 0 && typeof(container.headerCanvasHeight) !== 'undefined' && container.headerCanvasHeight !== null &&
	            (container.explicitHeaderCanvasHeight || container.headerCanvasHeight < maxHeaderCanvasHeight)
	          ) {
	            container.explicitHeaderCanvasHeight = getHeight(container.explicitHeaderCanvasHeight, maxHeaderCanvasHeight);
	          }
	        }
	
	        // Rebuild styles if the header height has changed
	        //   The header height is used in body/viewport calculations and those are then used in other styles so we need it to be available
	        if (buildStyles && rebuildStyles) {
	          self.buildStyles();
	        }
	
	        p.resolve();
	      });
	    }
	    else {
	      // Timeout still needs to be here to trigger digest after styles have been rebuilt
	      $timeout(function() {
	        p.resolve();
	      });
	    }
	
	    return p.promise;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name redrawCanvas
	   * @methodOf ui.grid.class:Grid
	   * @description Redraw the rows and columns based on our current scroll position
	   * @param {boolean} [rowsAdded] Optional to indicate rows are added and the scroll percentage must be recalculated
	   *
	   */
	  Grid.prototype.redrawInPlace = function redrawInPlace(rowsAdded) {
	    // gridUtil.logDebug('redrawInPlace');
	
	    var self = this;
	
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      // gridUtil.logDebug('redrawing container', i);
	
	      if (rowsAdded) {
	        container.adjustRows(container.prevScrollTop, null);
	        container.adjustColumns(container.prevScrollLeft, null);
	      }
	      else {
	        container.adjustRows(null, container.prevScrolltopPercentage);
	        container.adjustColumns(null, container.prevScrollleftPercentage);
	      }
	    }
	  };
	
	    /**
	     * @ngdoc function
	     * @name hasLeftContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if leftContainer has columns
	     */
	    Grid.prototype.hasLeftContainerColumns = function () {
	      return this.hasLeftContainer() && this.renderContainers.left.renderedColumns.length > 0;
	    };
	
	    /**
	     * @ngdoc function
	     * @name hasRightContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if rightContainer has columns
	     */
	    Grid.prototype.hasRightContainerColumns = function () {
	      return this.hasRightContainer() && this.renderContainers.right.renderedColumns.length > 0;
	    };
	
	    /**
	     * @ngdoc method
	     * @methodOf  ui.grid.class:Grid
	     * @name scrollToIfNecessary
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridCol} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     */
	    Grid.prototype.scrollToIfNecessary = function (gridRow, gridCol) {
	      var self = this;
	
	      var scrollEvent = new ScrollEvent(self, 'uiGrid.scrollToIfNecessary');
	
	      // Alias the visible row and column caches
	      var visRowCache = self.renderContainers.body.visibleRowCache;
	      var visColCache = self.renderContainers.body.visibleColumnCache;
	
	      /*-- Get the top, left, right, and bottom "scrolled" edges of the grid --*/
	
	      // The top boundary is the current Y scroll position PLUS the header height, because the header can obscure rows when the grid is scrolled downwards
	      var topBound = self.renderContainers.body.prevScrollTop + self.headerHeight;
	
	      // Don't the let top boundary be less than 0
	      topBound = (topBound < 0) ? 0 : topBound;
	
	      // The left boundary is the current X scroll position
	      var leftBound = self.renderContainers.body.prevScrollLeft;
	
	      // The bottom boundary is the current Y scroll position, plus the height of the grid, but minus the header height.
	      //   Basically this is the viewport height added on to the scroll position
	      var bottomBound = self.renderContainers.body.prevScrollTop + self.gridHeight - self.renderContainers.body.headerHeight - self.footerHeight -  self.scrollbarWidth;
	
	      // If there's a horizontal scrollbar, remove its height from the bottom boundary, otherwise we'll be letting it obscure rows
	      //if (self.horizontalScrollbarHeight) {
	      //  bottomBound = bottomBound - self.horizontalScrollbarHeight;
	      //}
	
	      // The right position is the current X scroll position minus the grid width
	      var rightBound = self.renderContainers.body.prevScrollLeft + Math.ceil(self.renderContainers.body.getViewportWidth());
	
	      // If there's a vertical scrollbar, subtract it from the right boundary or we'll allow it to obscure cells
	      //if (self.verticalScrollbarWidth) {
	      //  rightBound = rightBound - self.verticalScrollbarWidth;
	      //}
	
	      // We were given a row to scroll to
	      if (gridRow !== null) {
	        // This is the index of the row we want to scroll to, within the list of rows that can be visible
	        var seekRowIndex = visRowCache.indexOf(gridRow);
	
	        // Total vertical scroll length of the grid
	        var scrollLength = (self.renderContainers.body.getCanvasHeight() - self.renderContainers.body.getViewportHeight());
	
	        // Add the height of the native horizontal scrollbar to the scroll length, if it's there. Otherwise it will mask over the final row
	        //if (self.horizontalScrollbarHeight && self.horizontalScrollbarHeight > 0) {
	        //  scrollLength = scrollLength + self.horizontalScrollbarHeight;
	        //}
	
	        // This is the minimum amount of pixels we need to scroll vertical in order to see this row.
	        var pixelsToSeeRow = ((seekRowIndex + 1) * self.options.rowHeight);
	
	        // Don't let the pixels required to see the row be less than zero
	        pixelsToSeeRow = (pixelsToSeeRow < 0) ? 0 : pixelsToSeeRow;
	
	        var scrollPixels, percentage;
	
	        // If the scroll position we need to see the row is LESS than the top boundary, i.e. obscured above the top of the self...
	        if (pixelsToSeeRow < topBound) {
	          // Get the different between the top boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          scrollPixels = self.renderContainers.body.prevScrollTop - (topBound - pixelsToSeeRow);
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          percentage = scrollPixels / scrollLength;
	          scrollEvent.y = { percentage: percentage  };
	        }
	        // Otherwise if the scroll position we need to see the row is MORE than the bottom boundary, i.e. obscured below the bottom of the self...
	        else if (pixelsToSeeRow > bottomBound) {
	          // Get the different between the bottom boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          scrollPixels = pixelsToSeeRow - bottomBound + self.renderContainers.body.prevScrollTop;
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          percentage = scrollPixels / scrollLength;
	          scrollEvent.y = { percentage: percentage  };
	        }
	      }
	
	      // We were given a column to scroll to
	      if (gridCol !== null) {
	        // This is the index of the row we want to scroll to, within the list of rows that can be visible
	        var seekColumnIndex = visColCache.indexOf(gridCol);
	
	        // Total vertical scroll length of the grid
	        var horizScrollLength = (self.renderContainers.body.getCanvasWidth() - self.renderContainers.body.getViewportWidth());
	
	        // Add the height of the native horizontal scrollbar to the scroll length, if it's there. Otherwise it will mask over the final row
	        // if (self.verticalScrollbarWidth && self.verticalScrollbarWidth > 0) {
	        //   horizScrollLength = horizScrollLength + self.verticalScrollbarWidth;
	        // }
	
	        // This is the minimum amount of pixels we need to scroll vertical in order to see this column
	        var columnLeftEdge = 0;
	        for (var i = 0; i < seekColumnIndex; i++) {
	          var col = visColCache[i];
	          columnLeftEdge += col.drawnWidth;
	        }
	        columnLeftEdge = (columnLeftEdge < 0) ? 0 : columnLeftEdge;
	
	        var columnRightEdge = columnLeftEdge + gridCol.drawnWidth;
	
	        // Don't let the pixels required to see the column be less than zero
	        columnRightEdge = (columnRightEdge < 0) ? 0 : columnRightEdge;
	
	        var horizScrollPixels, horizPercentage;
	
	        // If the scroll position we need to see the row is LESS than the top boundary, i.e. obscured above the top of the self...
	        if (columnLeftEdge < leftBound) {
	          // Get the different between the top boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          horizScrollPixels = self.renderContainers.body.prevScrollLeft - (leftBound - columnLeftEdge);
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          horizPercentage = horizScrollPixels / horizScrollLength;
	          horizPercentage = (horizPercentage > 1) ? 1 : horizPercentage;
	          scrollEvent.x = { percentage: horizPercentage  };
	        }
	        // Otherwise if the scroll position we need to see the row is MORE than the bottom boundary, i.e. obscured below the bottom of the self...
	        else if (columnRightEdge > rightBound) {
	          // Get the different between the bottom boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          horizScrollPixels = columnRightEdge - rightBound + self.renderContainers.body.prevScrollLeft;
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          horizPercentage = horizScrollPixels / horizScrollLength;
	          horizPercentage = (horizPercentage > 1) ? 1 : horizPercentage;
	          scrollEvent.x = { percentage: horizPercentage  };
	        }
	      }
	
	      var deferred = $q.defer();
	
	      // If we need to scroll on either the x or y axes, fire a scroll event
	      if (scrollEvent.y || scrollEvent.x) {
	        scrollEvent.withDelay = false;
	        self.scrollContainers('',scrollEvent);
	        var dereg = self.api.core.on.scrollEnd(null,function() {
	          deferred.resolve(scrollEvent);
	          dereg();
	        });
	      }
	      else {
	        deferred.resolve();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.class:Grid
	     * @name scrollTo
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    Grid.prototype.scrollTo = function (rowEntity, colDef) {
	      var gridRow = null, gridCol = null;
	
	      if (rowEntity !== null && typeof(rowEntity) !== 'undefined' ) {
	        gridRow = this.getRow(rowEntity);
	      }
	
	      if (colDef !== null && typeof(colDef) !== 'undefined' ) {
	        gridCol = this.getColumn(colDef.name ? colDef.name : colDef.field);
	      }
	      return this.scrollToIfNecessary(gridRow, gridCol);
	    };
	
	  /**
	   * @ngdoc function
	   * @name clearAllFilters
	   * @methodOf ui.grid.class:Grid
	   * @description Clears all filters and optionally refreshes the visible rows.
	   * @param {object} refreshRows Defaults to true.
	   * @param {object} clearConditions Defaults to false.
	   * @param {object} clearFlags Defaults to false.
	   * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	   */
	  Grid.prototype.clearAllFilters = function clearAllFilters(refreshRows, clearConditions, clearFlags) {
	    // Default `refreshRows` to true because it will be the most commonly desired behaviour.
	    if (refreshRows === undefined) {
	      refreshRows = true;
	    }
	    if (clearConditions === undefined) {
	      clearConditions = false;
	    }
	    if (clearFlags === undefined) {
	      clearFlags = false;
	    }
	
	    this.columns.forEach(function(column) {
	      column.filters.forEach(function(filter) {
	        filter.term = undefined;
	
	        if (clearConditions) {
	          filter.condition = undefined;
	        }
	
	        if (clearFlags) {
	          filter.flags = undefined;
	        }
	      });
	    });
	
	    if (refreshRows) {
	      return this.refreshRows();
	    }
	  };
	
	
	      // Blatantly stolen from Angular as it isn't exposed (yet? 2.0?)
	  function RowHashMap() {}
	
	  RowHashMap.prototype = {
	    /**
	     * Store key value pair
	     * @param key key to store can be any type
	     * @param value value to store can be any type
	     */
	    put: function(key, value) {
	      this[this.grid.options.rowIdentity(key)] = value;
	    },
	
	    /**
	     * @param key
	     * @returns {Object} the value for the key
	     */
	    get: function(key) {
	      return this[this.grid.options.rowIdentity(key)];
	    },
	
	    /**
	     * Remove the key/value pair
	     * @param key
	     */
	    remove: function(key) {
	      var value = this[key = this.grid.options.rowIdentity(key)];
	      delete this[key];
	      return value;
	    }
	  };
	
	
	
	  return Grid;
	
	}]);
	
	})();
	
	(function () {
	
	  angular.module('ui.grid')
	    .factory('GridApi', ['$q', '$rootScope', 'gridUtil', 'uiGridConstants', 'GridRow', 'uiGridGridMenuService',
	      function ($q, $rootScope, gridUtil, uiGridConstants, GridRow, uiGridGridMenuService) {
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:GridApi
	         * @description GridApi provides the ability to register public methods events inside the grid and allow
	         * for other components to use the api via featureName.raise.methodName and featureName.on.eventName(function(args){}.
	         * <br/>
	         * To listen to events, you must add a callback to gridOptions.onRegisterApi
	         * <pre>
	         *   $scope.gridOptions.onRegisterApi = function(gridApi){
	         *      gridApi.cellNav.on.navigate($scope,function(newRowCol, oldRowCol){
	         *          $log.log('navigation event');
	         *      });
	         *   };
	         * </pre>
	         * @param {object} grid grid that owns api
	         */
	        var GridApi = function GridApi(grid) {
	          this.grid = grid;
	          this.listeners = [];
	          
	          /**
	           * @ngdoc function
	           * @name renderingComplete
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Rendering is complete, called at the same
	           * time as `onRegisterApi`, but provides a way to obtain
	           * that same event within features without stopping end
	           * users from getting at the onRegisterApi method.
	           * 
	           * Included in gridApi so that it's always there - otherwise
	           * there is still a timing problem with when a feature can
	           * call this. 
	           * 
	           * @param {GridApi} gridApi the grid api, as normally 
	           * returned in the onRegisterApi method
	           * 
	           * @example
	           * <pre>
	           *      gridApi.core.on.renderingComplete( grid );
	           * </pre>
	           */
	          this.registerEvent( 'core', 'renderingComplete' );
	
	          /**
	           * @ngdoc event
	           * @name filterChanged
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised after the filter is changed.  The nature
	           * of the watch expression doesn't allow notification of what changed,
	           * so the receiver of this event will need to re-extract the filter 
	           * conditions from the columns.
	           * 
	           */
	          this.registerEvent( 'core', 'filterChanged' );
	
	          /**
	           * @ngdoc function
	           * @name setRowInvisible
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Sets an override on the row to make it always invisible,
	           * which will override any filtering or other visibility calculations.  
	           * If the row is currently visible then sets it to invisible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * @param {object} rowEntity gridOptions.data[] array instance
	           */
	          this.registerMethod( 'core', 'setRowInvisible', GridRow.prototype.setRowInvisible );
	      
	          /**
	           * @ngdoc function
	           * @name clearRowInvisible
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Clears any override on visibility for the row so that it returns to 
	           * using normal filtering and other visibility calculations.  
	           * If the row is currently invisible then sets it to visible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * TODO: if a filter is active then we can't just set it to visible?
	           * @param {object} rowEntity gridOptions.data[] array instance
	           */
	          this.registerMethod( 'core', 'clearRowInvisible', GridRow.prototype.clearRowInvisible );
	      
	          /**
	           * @ngdoc function
	           * @name getVisibleRows
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Returns all visible rows
	           * @param {Grid} grid the grid you want to get visible rows from
	           * @returns {array} an array of gridRow
	           */
	          this.registerMethod( 'core', 'getVisibleRows', this.grid.getVisibleRows );
	          
	          /**
	           * @ngdoc event
	           * @name rowsVisibleChanged
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised after the rows that are visible
	           * change.  The filtering is zero-based, so it isn't possible
	           * to say which rows changed (unlike in the selection feature).
	           * We can plausibly know which row was changed when setRowInvisible
	           * is called, but in that situation the user already knows which row
	           * they changed.  When a filter runs we don't know what changed,
	           * and that is the one that would have been useful.
	           *
	           */
	          this.registerEvent( 'core', 'rowsVisibleChanged' );
	
	          /**
	           * @ngdoc event
	           * @name rowsRendered
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised after the cache of visible rows is changed.
	           */
	          this.registerEvent( 'core', 'rowsRendered' );
	
	
	          /**
	           * @ngdoc event
	           * @name scrollBegin
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised when scroll begins.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollBegin' );
	
	          /**
	           * @ngdoc event
	           * @name scrollEnd
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised when scroll has finished.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollEnd' );
	
	          /**
	           * @ngdoc event
	           * @name canvasHeightChanged
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised when the canvas height has changed
	           * <br/>
	           * arguments: oldHeight, newHeight
	           */
	          this.registerEvent( 'core', 'canvasHeightChanged');
	        };
	
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:suppressEvents
	         * @methodOf ui.grid.class:GridApi
	         * @description Used to execute a function while disabling the specified event listeners.
	         * Disables the listenerFunctions, executes the callbackFn, and then enables
	         * the listenerFunctions again
	         * @param {object} listenerFuncs listenerFunc or array of listenerFuncs to suppress. These must be the same
	         * functions that were used in the .on.eventName method
	         * @param {object} callBackFn function to execute
	         * @example
	         * <pre>
	         *    var navigate = function (newRowCol, oldRowCol){
	         *       //do something on navigate
	         *    }
	         *
	         *    gridApi.cellNav.on.navigate(scope,navigate);
	         *
	         *
	         *    //call the scrollTo event and suppress our navigate listener
	         *    //scrollTo will still raise the event for other listeners
	         *    gridApi.suppressEvents(navigate, function(){
	         *       gridApi.cellNav.scrollTo(aRow, aCol);
	         *    });
	         *
	         * </pre>
	         */
	        GridApi.prototype.suppressEvents = function (listenerFuncs, callBackFn) {
	          var self = this;
	          var listeners = angular.isArray(listenerFuncs) ? listenerFuncs : [listenerFuncs];
	
	          //find all registered listeners
	          var foundListeners = self.listeners.filter(function(listener) {
	            return listeners.some(function(l) {
	              return listener.handler === l;
	            });
	          });
	
	          //deregister all the listeners
	          foundListeners.forEach(function(l){
	            l.dereg();
	          });
	
	          callBackFn();
	
	          //reregister all the listeners
	          foundListeners.forEach(function(l){
	              l.dereg = registerEventWithAngular(l.eventId, l.handler, self.grid, l._this);
	          });
	
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerEvent
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature.  The event will get a
	         * .raise and .on prepended to it
	         * <br>
	         * .raise.eventName() - takes no arguments
	         * <br/>
	         * <br/>
	         * .on.eventName(scope, callBackFn, _this)
	         * <br/>
	         * scope - a scope reference to add a deregister call to the scopes .$on('destroy').  Scope is optional and can be a null value,
	         * but in this case you must deregister it yourself via the returned deregister function
	         * <br/>
	         * callBackFn - The function to call
	         * <br/>
	         * _this - optional this context variable for callbackFn. If omitted, grid.api will be used for the context
	         * <br/>
	         * .on.eventName returns a dereg funtion that will remove the listener.  It's not necessary to use it as the listener
	         * will be removed when the scope is destroyed.
	         * @param {string} featureName name of the feature that raises the event
	         * @param {string} eventName  name of the event
	         */
	        GridApi.prototype.registerEvent = function (featureName, eventName) {
	          var self = this;
	          if (!self[featureName]) {
	            self[featureName] = {};
	          }
	
	          var feature = self[featureName];
	          if (!feature.on) {
	            feature.on = {};
	            feature.raise = {};
	          }
	
	          var eventId = self.grid.id + featureName + eventName;
	
	          // gridUtil.logDebug('Creating raise event method ' + featureName + '.raise.' + eventName);
	          feature.raise[eventName] = function () {
	            $rootScope.$emit.apply($rootScope, [eventId].concat(Array.prototype.slice.call(arguments)));
	          };
	
	          // gridUtil.logDebug('Creating on event method ' + featureName + '.on.' + eventName);
	          feature.on[eventName] = function (scope, handler, _this) {
	            if ( scope !== null && typeof(scope.$on) === 'undefined' ){
	              gridUtil.logError('asked to listen on ' + featureName + '.on.' + eventName + ' but scope wasn\'t passed in the input parameters.  It is legitimate to pass null, but you\'ve passed something else, so you probably forgot to provide scope rather than did it deliberately, not registering');
	              return;
	            }
	            var deregAngularOn = registerEventWithAngular(eventId, handler, self.grid, _this);
	
	            //track our listener so we can turn off and on
	            var listener = {handler: handler, dereg: deregAngularOn, eventId: eventId, scope: scope, _this:_this};
	            self.listeners.push(listener);
	
	            var removeListener = function(){
	              listener.dereg();
	              var index = self.listeners.indexOf(listener);
	              self.listeners.splice(index,1);
	            };
	
	            //destroy tracking when scope is destroyed
	            if (scope) {
	              scope.$on('$destroy', function() {
	                removeListener();
	              });
	            }
	
	
	            return removeListener;
	          };
	        };
	
	        function registerEventWithAngular(eventId, handler, grid, _this) {
	          return $rootScope.$on(eventId, function (event) {
	            var args = Array.prototype.slice.call(arguments);
	            args.splice(0, 1); //remove evt argument
	            handler.apply(_this ? _this : grid.api, args);
	          });
	        }
	
	        /**
	         * @ngdoc function
	         * @name registerEventsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and events from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <pre>
	         * {featureName:
	         *        {
	         *          eventNameOne:function(args){},
	         *          eventNameTwo:function(args){}
	         *        }
	         *  }
	         * </pre>
	         * @param {object} eventObjectMap map of feature/event names
	         */
	        GridApi.prototype.registerEventsFromObject = function (eventObjectMap) {
	          var self = this;
	          var features = [];
	          angular.forEach(eventObjectMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, events: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.events.push(propName);
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.events.forEach(function (event) {
	              self.registerEvent(feature.name, event);
	            });
	          });
	
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethod
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature
	         * @param {string} featureName name of the feature
	         * @param {string} methodName  name of the method
	         * @param {object} callBackFn function to execute
	         * @param {object} _this binds callBackFn 'this' to _this.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethod = function (featureName, methodName, callBackFn, _this) {
	          if (!this[featureName]) {
	            this[featureName] = {};
	          }
	
	          var feature = this[featureName];
	
	          feature[methodName] = gridUtil.createBoundedWrapper(_this || this.grid, callBackFn);
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethodsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and methods from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <br>
	         * {featureName:
	         *        {
	         *          methodNameOne:function(args){},
	         *          methodNameTwo:function(args){}
	         *        }
	         * @param {object} eventObjectMap map of feature/event names
	         * @param {object} _this binds this to _this for all functions.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethodsFromObject = function (methodMap, _this) {
	          var self = this;
	          var features = [];
	          angular.forEach(methodMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, methods: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.methods.push({name: propName, fn: prop});
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.methods.forEach(function (method) {
	              self.registerMethod(feature.name, method.name, method.fn, _this);
	            });
	          });
	
	        };
	        
	        return GridApi;
	
	      }]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.factory('GridColumn', ['gridUtil', 'uiGridConstants', 'i18nService', function(gridUtil, uiGridConstants, i18nService) {
	
	  /**
	   * ******************************************************************************************
	   * PaulL1: Ugly hack here in documentation.  These properties are clearly properties of GridColumn,
	   * and need to be noted as such for those extending and building ui-grid itself.
	   * However, from an end-developer perspective, they interact with all these through columnDefs,
	   * and they really need to be documented there.  I feel like they're relatively static, and
	   * I can't find an elegant way for ngDoc to reference to both....so I've duplicated each
	   * comment block.  Ugh.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridColumn
	   * @description (mandatory) each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description (mandatory) each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Column name that will be shown in the header.  If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Column name that will be shown in the header.  If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridColumn
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.
	   * See the angular docs on binding expressions.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.    * See the angular docs on binding expressions.    *
	   */
	
	  /**
	   * @ngdoc property
	   * @name filter
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filter on this column.
	   * @example
	   * <pre>{ term: 'text', condition: uiGridConstants.filter.STARTS_WITH, placeholder: 'type to filter...', ariaLabel: 'Filter for text', flags: { caseSensitive: false }, type: uiGridConstants.filter.SELECT, [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ] }</pre>
	   *
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridColumn
	   * @description Represents the viewModel for each column.  Any state or methods needed for a Grid Column
	   * are defined on this prototype
	   * @param {ColumnDef} colDef the column def to associate with this column
	   * @param {number} uid the unique and immutable uid we'd like to allocate to this column
	   * @param {Grid} grid the grid we'd like to create this column in
	   */
	  function GridColumn(colDef, uid, grid) {
	    var self = this;
	
	    self.grid = grid;
	    self.uid = uid;
	
	    self.updateColumnDef(colDef, true);
	
	    /**
	     * @ngdoc function
	     * @name hideColumn
	     * @methodOf ui.grid.class:GridColumn
	     * @description Hides the column by setting colDef.visible = false
	     */
	    GridColumn.prototype.hideColumn = function() {
	      this.colDef.visible = false;
	    };
	
	    self.aggregationValue = undefined;
	
	    // The footer cell registers to listen for the rowsRendered event, and calls this.  Needed to be
	    // in something with a scope so that the dereg would get called
	    self.updateAggregationValue = function() {
	
	     // gridUtil.logDebug('getAggregationValue for Column ' + self.colDef.name);
	
	      /**
	       * @ngdoc property
	       * @name aggregationType
	       * @propertyOf ui.grid.class:GridOptions.columnDef
	       * @description The aggregation that you'd like to show in the columnFooter for this
	       * column.  Valid values are in uiGridConstants, and currently include `uiGridConstants.aggregationTypes.count`,
	       * `uiGridConstants.aggregationTypes.sum`, `uiGridConstants.aggregationTypes.avg`, `uiGridConstants.aggregationTypes.min`,
	       * `uiGridConstants.aggregationTypes.max`.
	       *
	       * You can also provide a function as the aggregation type, in this case your function needs to accept the full
	       * set of visible rows, and return a value that should be shown
	       */
	      if (!self.aggregationType) {
	        self.aggregationValue = undefined;
	        return;
	      }
	
	      var result = 0;
	      var visibleRows = self.grid.getVisibleRows();
	
	      var cellValues = function(){
	        var values = [];
	        visibleRows.forEach(function (row) {
	          var cellValue = self.grid.getCellValue(row, self);
	          var cellNumber = Number(cellValue);
	          if (!isNaN(cellNumber)) {
	            values.push(cellNumber);
	          }
	        });
	        return values;
	      };
	
	      if (angular.isFunction(self.aggregationType)) {
	        self.aggregationValue = self.aggregationType(visibleRows, self);
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.count) {
	        self.aggregationValue = self.grid.getVisibleRowCount();
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.sum) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.avg) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        result = result / cellValues().length;
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.min) {
	        self.aggregationValue = Math.min.apply(null, cellValues());
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.max) {
	        self.aggregationValue = Math.max.apply(null, cellValues());
	      }
	      else {
	        self.aggregationValue = '\u00A0';
	      }
	    };
	
	//     var throttledUpdateAggregationValue = gridUtil.throttle(updateAggregationValue, self.grid.options.aggregationCalcThrottle, { trailing: true, context: self.name });
	
	    /**
	     * @ngdoc function
	     * @name getAggregationValue
	     * @methodOf ui.grid.class:GridColumn
	     * @description gets the aggregation value based on the aggregation type for this column.
	     * Debounced using scrollDebounce option setting
	     */
	    this.getAggregationValue =  function() {
	//      if (!self.grid.isScrollingVertically && !self.grid.isScrollingHorizontally) {
	//        throttledUpdateAggregationValue();
	//      }
	
	      return self.aggregationValue;
	    };
	  }
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name setPropertyOrDefault
	   * @description Sets a property on the column using the passed in columnDef, and
	   * setting the defaultValue if the value cannot be found on the colDef
	   * @param {ColumnDef} colDef the column def to look in for the property value
	   * @param {string} propName the property name we'd like to set
	   * @param {object} defaultValue the value to use if the colDef doesn't provide the setting
	   */
	  GridColumn.prototype.setPropertyOrDefault = function (colDef, propName, defaultValue) {
	    var self = this;
	
	    // Use the column definition filter if we were passed it
	    if (typeof(colDef[propName]) !== 'undefined' && colDef[propName]) {
	      self[propName] = colDef[propName];
	    }
	    // Otherwise use our own if it's set
	    else if (typeof(self[propName]) !== 'undefined') {
	      self[propName] = self[propName];
	    }
	    // Default to empty object for the filter
	    else {
	      self[propName] = defaultValue ? defaultValue : {};
	    }
	  };
	
	
	
	  /**
	   * @ngdoc property
	   * @name width
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the column width.  Can be either
	   * a number or a percentage, or an * for auto.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', width: 100},
	   *                                          { field: 'field2', width: '20%'},
	   *                                          { field: 'field3', width: '*' }]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name minWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the minimum column width.  Should be a number.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', minWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name maxWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the maximum column width.  Should be a number.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', maxWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name visible
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets whether or not the column is visible
	   * </br>Default is true
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *     { field: 'field1', visible: true},
	   *     { field: 'field2', visible: false }
	   *   ]; </pre>
	   *
	   */
	
	 /**
	  * @ngdoc property
	  * @name sort
	  * @propertyOf ui.grid.class:GridOptions.columnDef
	  * @description An object of sort information, attributes are:
	  *
	  * - direction: values are uiGridConstants.ASC or uiGridConstants.DESC
	  * - ignoreSort: if set to true this sort is ignored (used by tree to manipulate the sort functionality)
	  * - priority: says what order to sort the columns in (lower priority gets sorted first).
	  * @example
	  * <pre>
	  *   $scope.gridOptions.columnDefs = [{
	  *     field: 'field1',
	  *     sort: {
	  *       direction: uiGridConstants.ASC,
	  *       ignoreSort: true,
	  *       priority: 0
	  *      }
	  *   }];
	  * </pre>
	  */
	
	
	  /**
	   * @ngdoc property
	   * @name sortingAlgorithm
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Algorithm to use for sorting this column. Takes 'a' and 'b' parameters
	   * like any normal sorting function with additional 'rowA', 'rowB', and 'direction' parameters
	   * that are the row objects and the current direction of the sort respectively.
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Specify multiple filter fields.
	   * @example
	   * <pre>$scope.gridOptions.columnDefs = [
	   *   {
	   *     field: 'field1', filters: [
	   *       {
	   *         term: 'aa',
	   *         condition: uiGridConstants.filter.STARTS_WITH,
	   *         placeholder: 'starts with...',
	   *         ariaLabel: 'Filter for field1',
	   *         flags: { caseSensitive: false },
	   *         type: uiGridConstants.filter.SELECT,
	   *         selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *       },
	   *       {
	   *         condition: uiGridConstants.filter.ENDS_WITH,
	   *         placeholder: 'ends with...'
	   *       }
	   *     ]
	   *   }
	   * ]; </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filters for this column. Includes 'term' property bound to filter input elements.
	   * @example
	   * <pre>[
	   *   {
	   *     term: 'foo', // ngModel for <input>
	   *     condition: uiGridConstants.filter.STARTS_WITH,
	   *     placeholder: 'starts with...',
	   *     ariaLabel: 'Filter for foo',
	   *     flags: { caseSensitive: false },
	   *     type: uiGridConstants.filter.SELECT,
	   *     selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *   },
	   *   {
	   *     term: 'baz',
	   *     condition: uiGridConstants.filter.ENDS_WITH,
	   *     placeholder: 'ends with...'
	   *   }
	   * ] </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name menuItems
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description used to add menu items to a column.  Refer to the tutorial on this
	   * functionality.  A number of settings are supported:
	   *
	   * - title: controls the title that is displayed in the menu
	   * - icon: the icon shown alongside that title
	   * - action: the method to call when the menu is clicked
	   * - shown: a function to evaluate to determine whether or not to show the item
	   * - active: a function to evaluate to determine whether or not the item is currently selected
	   * - context: context to pass to the action function, available in this.context in your handler
	   * - leaveOpen: if set to true, the menu should stay open after the action, defaults to false
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *   { field: 'field1', menuItems: [
	   *     {
	   *       title: 'Outer Scope Alert',
	   *       icon: 'ui-grid-icon-info-circled',
	   *       action: function($event) {
	   *         this.context.blargh(); // $scope.blargh() would work too, this is just an example
	   *       },
	   *       shown: function() { return true; },
	   *       active: function() { return true; },
	   *       context: $scope
	   *     },
	   *     {
	   *       title: 'Grid ID',
	   *       action: function() {
	   *         alert('Grid ID: ' + this.grid.id);
	   *       }
	   *     }
	   *   ] }]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name updateColumnDef
	   * @description Moves settings from the columnDef down onto the column,
	   * and sets properties as appropriate
	   * @param {ColumnDef} colDef the column def to look in for the property value
	   * @param {boolean} isNew whether the column is being newly created, if not
	   * we're updating an existing column, and some items such as the sort shouldn't
	   * be copied down
	   */
	  GridColumn.prototype.updateColumnDef = function(colDef, isNew) {
	    var self = this;
	
	    self.colDef = colDef;
	
	    if (colDef.name === undefined) {
	      throw new Error('colDef.name is required for column at index ' + self.grid.options.columnDefs.indexOf(colDef));
	    }
	
	    self.displayName = (colDef.displayName === undefined) ? gridUtil.readableColumnName(colDef.name) : colDef.displayName;
	
	    if (!angular.isNumber(self.width) || !self.hasCustomWidth || colDef.allowCustomWidthOverride) {
	      var colDefWidth = colDef.width;
	      var parseErrorMsg = "Cannot parse column width '" + colDefWidth + "' for column named '" + colDef.name + "'";
	      self.hasCustomWidth = false;
	
	      if (!angular.isString(colDefWidth) && !angular.isNumber(colDefWidth)) {
	        self.width = '*';
	      } else if (angular.isString(colDefWidth)) {
	        // See if it ends with a percent
	        if (gridUtil.endsWith(colDefWidth, '%')) {
	          // If so we should be able to parse the non-percent-sign part to a number
	          var percentStr = colDefWidth.replace(/%/g, '');
	          var percent = parseInt(percentStr, 10);
	          if (isNaN(percent)) {
	            throw new Error(parseErrorMsg);
	          }
	          self.width = colDefWidth;
	        }
	        // And see if it's a number string
	        else if (colDefWidth.match(/^(\d+)$/)) {
	          self.width = parseInt(colDefWidth.match(/^(\d+)$/)[1], 10);
	        }
	        // Otherwise it should be a string of asterisks
	        else if (colDefWidth.match(/^\*+$/)) {
	          self.width = colDefWidth;
	        }
	        // No idea, throw an Error
	        else {
	          throw new Error(parseErrorMsg);
	        }
	      }
	      // Is a number, use it as the width
	      else {
	        self.width = colDefWidth;
	      }
	    }
	
	    ['minWidth', 'maxWidth'].forEach(function (name) {
	      var minOrMaxWidth = colDef[name];
	      var parseErrorMsg = "Cannot parse column " + name + " '" + minOrMaxWidth + "' for column named '" + colDef.name + "'";
	
	      if (!angular.isString(minOrMaxWidth) && !angular.isNumber(minOrMaxWidth)) {
	        //Sets default minWidth and maxWidth values
	        self[name] = ((name === 'minWidth') ? 30 : 9000);
	      } else if (angular.isString(minOrMaxWidth)) {
	        if (minOrMaxWidth.match(/^(\d+)$/)) {
	          self[name] = parseInt(minOrMaxWidth.match(/^(\d+)$/)[1], 10);
	        } else {
	          throw new Error(parseErrorMsg);
	        }
	      } else {
	        self[name] = minOrMaxWidth;
	      }
	    });
	
	    //use field if it is defined; name if it is not
	    self.field = (colDef.field === undefined) ? colDef.name : colDef.field;
	
	    if ( typeof( self.field ) !== 'string' ){
	      gridUtil.logError( 'Field is not a string, this is likely to break the code, Field is: ' + self.field );
	    }
	
	    self.name = colDef.name;
	
	    // Use colDef.displayName as long as it's not undefined, otherwise default to the field name
	    self.displayName = (colDef.displayName === undefined) ? gridUtil.readableColumnName(colDef.name) : colDef.displayName;
	
	    //self.originalIndex = index;
	
	    self.aggregationType = angular.isDefined(colDef.aggregationType) ? colDef.aggregationType : null;
	    self.footerCellTemplate = angular.isDefined(colDef.footerCellTemplate) ? colDef.footerCellTemplate : null;
	
	    /**
	     * @ngdoc property
	     * @name cellTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the cell.
	     * If set to false, no tooltip.  If true, the cell value is shown in the tooltip (useful
	     * if you have long values in your cells), if a function then that function is called
	     * passing in the row and the col `cellTooltip( row, col )`, and the return value is shown in the tooltip,
	     * if it is a static string then displays that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.cellTooltip) === 'undefined' || colDef.cellTooltip === false ) {
	      self.cellTooltip = false;
	    } else if ( colDef.cellTooltip === true ){
	      self.cellTooltip = function(row, col) {
	        return self.grid.getCellValue( row, col );
	      };
	    } else if (typeof(colDef.cellTooltip) === 'function' ){
	      self.cellTooltip = colDef.cellTooltip;
	    } else {
	      self.cellTooltip = function ( row, col ){
	        return col.colDef.cellTooltip;
	      };
	    }
	
	    /**
	     * @ngdoc property
	     * @name headerTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the header cell.
	     * If set to false, no tooltip.  If true, the displayName is shown in the tooltip (useful
	     * if you have long values in your headers), if a function then that function is called
	     * passing in the row and the col `headerTooltip( col )`, and the return value is shown in the tooltip,
	     * if a static string then shows that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.headerTooltip) === 'undefined' || colDef.headerTooltip === false ) {
	      self.headerTooltip = false;
	    } else if ( colDef.headerTooltip === true ){
	      self.headerTooltip = function(col) {
	        return col.displayName;
	      };
	    } else if (typeof(colDef.headerTooltip) === 'function' ){
	      self.headerTooltip = colDef.headerTooltip;
	    } else {
	      self.headerTooltip = function ( col ) {
	        return col.colDef.headerTooltip;
	      };
	    }
	
	
	    /**
	     * @ngdoc property
	     * @name footerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(row,rowRenderIndex, col, colRenderIndex) that returns a class name
	     *
	     */
	    self.footerCellClass = colDef.footerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellClass can be a string specifying the class to append to a cell
	     * or it can be a function(row,rowRenderIndex, col, colRenderIndex) that returns a class name
	     *
	     */
	    self.cellClass = colDef.cellClass;
	
	    /**
	     * @ngdoc property
	     * @name headerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(row,rowRenderIndex, col, colRenderIndex) that returns a class name
	     *
	     */
	    self.headerCellClass = colDef.headerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellFilter is a filter to apply to the content of each cell
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].cellFilter = 'date'
	     *
	     */
	    self.cellFilter = colDef.cellFilter ? colDef.cellFilter : "";
	
	    /**
	     * @ngdoc boolean
	     * @name sortCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * sorting the data. Note that when using this option uiGrid will assume that the displayed value is
	     * a string, and use the {@link ui.grid.class:RowSorter#sortAlpha sortAlpha} `sortFn`. It is possible
	     * to return a non-string value from an angularjs filter, in which case you should define a {@link ui.grid.class:GridOptions.columnDef#sortingAlgorithm sortingAlgorithm}
	     * for the column which hanldes the returned type. You may specify one of the `sortingAlgorithms`
	     * found in the {@link ui.grid.RowSorter rowSorter} service.
	     */
	    self.sortCellFiltered = colDef.sortCellFiltered ? true : false;
	
	    /**
	     * @ngdoc boolean
	     * @name filterCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * applying "search" `filters`.
	     */
	    self.filterCellFiltered = colDef.filterCellFiltered ? true : false;
	
	    /**
	     * @ngdoc property
	     * @name headerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellFilter is a filter to apply to the content of the column header
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].headerCellFilter = 'translate'
	     *
	     */
	    self.headerCellFilter = colDef.headerCellFilter ? colDef.headerCellFilter : "";
	
	    /**
	     * @ngdoc property
	     * @name footerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellFilter is a filter to apply to the content of the column footer
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].footerCellFilter = 'date'
	     *
	     */
	    self.footerCellFilter = colDef.footerCellFilter ? colDef.footerCellFilter : "";
	
	    self.visible = gridUtil.isNullOrUndefined(colDef.visible) || colDef.visible;
	
	    self.headerClass = colDef.headerClass;
	    //self.cursor = self.sortable ? 'pointer' : 'default';
	
	    // Turn on sorting by default
	    self.enableSorting = typeof(colDef.enableSorting) !== 'undefined' ? colDef.enableSorting : true;
	    self.sortingAlgorithm = colDef.sortingAlgorithm;
	
	    /**
	     * @ngdoc property
	     * @name sortDirectionCycle
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) An array of sort directions, specifying the order that they
	     * should cycle through as the user repeatedly clicks on the column heading.
	     * The default is `[null, uiGridConstants.ASC, uiGridConstants.DESC]`. Null
	     * refers to the unsorted state. This does not affect the initial sort
	     * direction; use the {@link ui.grid.class:GridOptions.columnDef#sort sort}
	     * property for that. If
	     * {@link ui.grid.class:GridOptions.columnDef#suppressRemoveSort suppressRemoveSort}
	     * is also set, the unsorted state will be skipped even if it is listed here.
	     * Each direction may not appear in the list more than once (e.g. `[ASC,
	     * DESC, DESC]` is not allowed), and the list may not be empty.
	     */
	    self.sortDirectionCycle = typeof(colDef.sortDirectionCycle) !== 'undefined' ?
	      colDef.sortDirectionCycle :
	      [null, uiGridConstants.ASC, uiGridConstants.DESC];
	
	    /**
	     * @ngdoc boolean
	     * @name suppressRemoveSort
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When enabled, this setting hides the removeSort option
	     * in the menu, and prevents users from manually removing the sort
	     */
	    if ( typeof(self.suppressRemoveSort) === 'undefined'){
	      self.suppressRemoveSort = typeof(colDef.suppressRemoveSort) !== 'undefined' ? colDef.suppressRemoveSort : false;
	    }
	
	    /**
	     * @ngdoc property
	     * @name enableFiltering
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description turn off filtering for an individual column, where
	     * you've turned on filtering for the overall grid
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].enableFiltering = false;
	     *
	     */
	    // Turn on filtering by default (it's disabled by default at the Grid level)
	    self.enableFiltering = typeof(colDef.enableFiltering) !== 'undefined' ? colDef.enableFiltering : true;
	
	    // self.menuItems = colDef.menuItems;
	    self.setPropertyOrDefault(colDef, 'menuItems', []);
	
	    // Use the column definition sort if we were passed it, but only if this is a newly added column
	    if ( isNew ){
	      self.setPropertyOrDefault(colDef, 'sort');
	    }
	
	    // Set up default filters array for when one is not provided.
	    //   In other words, this (in column def):
	    //
	    //       filter: { term: 'something', flags: {}, condition: [CONDITION] }
	    //
	    //   is just shorthand for this:
	    //
	    //       filters: [{ term: 'something', flags: {}, condition: [CONDITION] }]
	    //
	    var defaultFilters = [];
	    if (colDef.filter) {
	      defaultFilters.push(colDef.filter);
	    }
	    else if ( colDef.filters ){
	      defaultFilters = colDef.filters;
	    } else {
	      // Add an empty filter definition object, which will
	      // translate to a guessed condition and no pre-populated
	      // value for the filter <input>.
	      defaultFilters.push({});
	    }
	
	    /**
	     * @ngdoc property
	     * @name filter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Specify a single filter field on this column.
	     *
	     * A filter consists of a condition, a term, and a placeholder:
	     *
	     * - condition defines how rows are chosen as matching the filter term. This can be set to
	     * one of the constants in uiGridConstants.filter, or you can supply a custom filter function
	     * that gets passed the following arguments: [searchTerm, cellValue, row, column].
	     * - term: If set, the filter field will be pre-populated
	     * with this value.
	     * - placeholder: String that will be set to the `<input>.placeholder` attribute.
	     * - ariaLabel: String that will be set to the `<input>.ariaLabel` attribute. This is what is read as a label to screen reader users.
	     * - noTerm: set this to true if you have defined a custom function in condition, and
	     * your custom function doesn't require a term (so it can run even when the term is null)
	     * - flags: only flag currently available is `caseSensitive`, set to false if you don't want
	     * case sensitive matching
	     * - type: defaults to uiGridConstants.filter.INPUT, which gives a text box.  If set to uiGridConstants.filter.SELECT
	     * then a select box will be shown with options selectOptions
	     * - selectOptions: options in the format `[ { value: 1, label: 'male' }]`.  No i18n filter is provided, you need
	     * to perform the i18n on the values before you provide them
	     * - disableCancelFilterButton: defaults to false. If set to true then the 'x' button that cancels/clears the filter
	     * will not be shown.
	     * @example
	     * <pre>$scope.gridOptions.columnDefs = [
	     *   {
	     *     field: 'field1',
	     *     filter: {
	     *       term: 'xx',
	     *       condition: uiGridConstants.filter.STARTS_WITH,
	     *       placeholder: 'starts with...',
	     *       ariaLabel: 'Starts with filter for field1',
	     *       flags: { caseSensitive: false },
	     *       type: uiGridConstants.filter.SELECT,
	     *       selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ],
	     *       disableCancelFilterButton: true
	     *     }
	     *   }
	     * ]; </pre>
	     *
	     */
	
	    /*
	
	
	    /*
	
	      self.filters = [
	        {
	          term: 'search term'
	          condition: uiGridConstants.filter.CONTAINS,
	          placeholder: 'my placeholder',
	          ariaLabel: 'Starts with filter for field1',
	          flags: {
	            caseSensitive: true
	          }
	        }
	      ]
	
	    */
	
	    // Only set filter if this is a newly added column, if we're updating an existing
	    // column then we don't want to put the default filter back if the user may have already
	    // removed it.
	    // However, we do want to keep the settings if they change, just not the term
	    if ( isNew ) {
	      self.setPropertyOrDefault(colDef, 'filter');
	      self.setPropertyOrDefault(colDef, 'filters', defaultFilters);
	    } else if ( self.filters.length === defaultFilters.length ) {
	      self.filters.forEach( function( filter, index ){
	        if (typeof(defaultFilters[index].placeholder) !== 'undefined') {
	          filter.placeholder = defaultFilters[index].placeholder;
	        }
	        if (typeof(defaultFilters[index].ariaLabel) !== 'undefined') {
	          filter.ariaLabel = defaultFilters[index].ariaLabel;
	        }
	        if (typeof(defaultFilters[index].flags) !== 'undefined') {
	          filter.flags = defaultFilters[index].flags;
	        }
	        if (typeof(defaultFilters[index].type) !== 'undefined') {
	          filter.type = defaultFilters[index].type;
	        }
	        if (typeof(defaultFilters[index].selectOptions) !== 'undefined') {
	          filter.selectOptions = defaultFilters[index].selectOptions;
	        }
	      });
	    }
	
	    // Remove this column from the grid sorting, include inside build columns so has
	    // access to self - all seems a bit dodgy but doesn't work otherwise so have left
	    // as is
	    GridColumn.prototype.unsort = function () {
	      this.sort = {};
	      self.grid.api.core.raise.sortChanged( self.grid, self.grid.getColumnSorting() );
	    };
	
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColClass
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class name for the column
	   * @param {bool} prefixDot  if true, will return .className instead of className
	   */
	  GridColumn.prototype.getColClass = function (prefixDot) {
	    var cls = uiGridConstants.COL_CLASS_PREFIX + this.uid;
	
	    return prefixDot ? '.' + cls : cls;
	  };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedLeft
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the left render container
	     */
	    GridColumn.prototype.isPinnedLeft = function () {
	      return this.renderContainer === 'left';
	    };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedRight
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the right render container
	     */
	    GridColumn.prototype.isPinnedRight = function () {
	      return this.renderContainer === 'right';
	    };
	
	
	    /**
	   * @ngdoc function
	   * @name getColClassDefinition
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class definition for th column
	   */
	  GridColumn.prototype.getColClassDefinition = function () {
	    return ' .grid' + this.grid.id + ' ' + this.getColClass(true) + ' { min-width: ' + this.drawnWidth + 'px; max-width: ' + this.drawnWidth + 'px; }';
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRenderContainer
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the render container object that this column belongs to.
	   *
	   * Columns will be default be in the `body` render container if they aren't allocated to one specifically.
	   */
	  GridColumn.prototype.getRenderContainer = function getRenderContainer() {
	    var self = this;
	
	    var containerId = self.renderContainer;
	
	    if (containerId === null || containerId === '' || containerId === undefined) {
	      containerId = 'body';
	    }
	
	    return self.grid.renderContainers[containerId];
	  };
	
	  /**
	   * @ngdoc function
	   * @name showColumn
	   * @methodOf ui.grid.class:GridColumn
	   * @description Makes the column visible by setting colDef.visible = true
	   */
	  GridColumn.prototype.showColumn = function() {
	      this.colDef.visible = true;
	  };
	
	
	  /**
	   * @ngdoc property
	   * @name aggregationHideLabel
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description defaults to false, if set to true hides the label text
	   * in the aggregation footer, so only the value is displayed.
	   *
	   */
	  /**
	   * @ngdoc function
	   * @name getAggregationText
	   * @methodOf ui.grid.class:GridColumn
	   * @description Gets the aggregation label from colDef.aggregationLabel if
	   * specified or by using i18n, including deciding whether or not to display
	   * based on colDef.aggregationHideLabel.
	   *
	   * @param {string} label the i18n lookup value to use for the column label
	   *
	   */
	  GridColumn.prototype.getAggregationText = function () {
	    var self = this;
	    if ( self.colDef.aggregationHideLabel ){
	      return '';
	    }
	    else if ( self.colDef.aggregationLabel ) {
	      return self.colDef.aggregationLabel;
	    }
	    else {
	      switch ( self.colDef.aggregationType ){
	        case uiGridConstants.aggregationTypes.count:
	          return i18nService.getSafeText('aggregation.count');
	        case uiGridConstants.aggregationTypes.sum:
	          return i18nService.getSafeText('aggregation.sum');
	        case uiGridConstants.aggregationTypes.avg:
	          return i18nService.getSafeText('aggregation.avg');
	        case uiGridConstants.aggregationTypes.min:
	          return i18nService.getSafeText('aggregation.min');
	        case uiGridConstants.aggregationTypes.max:
	          return i18nService.getSafeText('aggregation.max');
	        default:
	          return '';
	      }
	    }
	  };
	
	  GridColumn.prototype.getCellTemplate = function () {
	    var self = this;
	
	    return self.cellTemplatePromise;
	  };
	
	  GridColumn.prototype.getCompiledElementFn = function () {
	    var self = this;
	
	    return self.compiledElementFnDefer.promise;
	  };
	
	  return GridColumn;
	}]);
	
	})();
	
	  (function(){
	
	angular.module('ui.grid')
	.factory('GridOptions', ['gridUtil','uiGridConstants', function(gridUtil,uiGridConstants) {
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridOptions
	   * @description Default GridOptions class.  GridOptions are defined by the application developer and overlaid
	   * over this object.  Setting gridOptions within your controller is the most common method for an application
	   * developer to configure the behaviour of their ui-grid
	   *
	   * @example To define your gridOptions within your controller:
	   * <pre>$scope.gridOptions = {
	   *   data: $scope.myData,
	   *   columnDefs: [
	   *     { name: 'field1', displayName: 'pretty display name' },
	   *     { name: 'field2', visible: false }
	   *  ]
	   * };</pre>
	   *
	   * You can then use this within your html template, when you define your grid:
	   * <pre>&lt;div ui-grid="gridOptions"&gt;&lt;/div&gt;</pre>
	   *
	   * To provide default options for all of the grids within your application, use an angular
	   * decorator to modify the GridOptions factory.
	   * <pre>
	   * app.config(function($provide){
	   *   $provide.decorator('GridOptions',function($delegate){
	   *     var gridOptions;
	   *     gridOptions = angular.copy($delegate);
	   *     gridOptions.initialize = function(options) {
	   *       var initOptions;
	   *       initOptions = $delegate.initialize(options);
	   *       initOptions.enableColumnMenus = false;
	   *       return initOptions;
	   *     };
	   *     return gridOptions;
	   *   });
	   * });
	   * </pre>
	   */
	  return {
	    initialize: function( baseOptions ){
	      /**
	       * @ngdoc function
	       * @name onRegisterApi
	       * @propertyOf ui.grid.class:GridOptions
	       * @description A callback that returns the gridApi once the grid is instantiated, which is
	       * then used to interact with the grid programatically.
	       *
	       * Note that the gridApi.core.renderingComplete event is identical to this
	       * callback, but has the advantage that it can be called from multiple places
	       * if needed
	       *
	       * @example
	       * <pre>
	       *   $scope.gridOptions.onRegisterApi = function ( gridApi ) {
	       *     $scope.gridApi = gridApi;
	       *     $scope.gridApi.selection.selectAllRows( $scope.gridApi.grid );
	       *   };
	       * </pre>
	       *
	       */
	      baseOptions.onRegisterApi = baseOptions.onRegisterApi || angular.noop();
	
	      /**
	       * @ngdoc object
	       * @name data
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (mandatory) Array of data to be rendered into the grid, providing the data source or data binding for
	       * the grid.
	       *
	       * Most commonly the data is an array of objects, where each object has a number of attributes.
	       * Each attribute automatically becomes a column in your grid.  This array could, for example, be sourced from
	       * an angularJS $resource query request.  The array can also contain complex objects, refer the binding tutorial
	       * for examples of that.
	       *
	       * The most flexible usage is to set your data on $scope:
	       *
	       * `$scope.data = data;`
	       *
	       * And then direct the grid to resolve whatever is in $scope.data:
	       *
	       * `$scope.gridOptions.data = 'data';`
	       *
	       * This is the most flexible approach as it allows you to replace $scope.data whenever you feel like it without
	       * getting pointer issues.
	       *
	       * Alternatively you can directly set the data array:
	       *
	       * `$scope.gridOptions.data = [ ];`
	       * or
	       *
	       * `$http.get('/data/100.json')
	       * .success(function(data) {
	       *   $scope.myData = data;
	       *   $scope.gridOptions.data = $scope.myData;
	       *  });`
	       *
	       * Where you do this, you need to take care in updating the data - you can't just update `$scope.myData` to some other
	       * array, you need to update $scope.gridOptions.data to point to that new array as well.
	       *
	       */
	      baseOptions.data = baseOptions.data || [];
	
	      /**
	       * @ngdoc array
	       * @name columnDefs
	       * @propertyOf  ui.grid.class:GridOptions
	       * @description Array of columnDef objects.  Only required property is name.
	       * The individual options available in columnDefs are documented in the
	       * {@link ui.grid.class:GridOptions.columnDef columnDef} section
	       * </br>_field property can be used in place of name for backwards compatibility with 2.x_
	       *  @example
	       *
	       * <pre>var columnDefs = [{name:'field1'}, {name:'field2'}];</pre>
	       *
	       */
	      baseOptions.columnDefs = baseOptions.columnDefs || [];
	
	      /**
	       * @ngdoc object
	       * @name ui.grid.class:GridOptions.columnDef
	       * @description Definition / configuration of an individual column, which would typically be
	       * one of many column definitions within the gridOptions.columnDefs array
	       * @example
	       * <pre>{name:'field1', field: 'field1', filter: { term: 'xxx' }}</pre>
	       *
	       */
	
	
	      /**
	       * @ngdoc array
	       * @name excludeProperties
	       * @propertyOf  ui.grid.class:GridOptions
	       * @description Array of property names in data to ignore when auto-generating column names.  Provides the
	       * inverse of columnDefs - columnDefs is a list of columns to include, excludeProperties is a list of columns
	       * to exclude.
	       *
	       * If columnDefs is defined, this will be ignored.
	       *
	       * Defaults to ['$$hashKey']
	       */
	
	      baseOptions.excludeProperties = baseOptions.excludeProperties || ['$$hashKey'];
	
	      /**
	       * @ngdoc boolean
	       * @name enableRowHashing
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting allows uiGrid to add
	       * `$$hashKey`-type properties (similar to Angular) to elements in the `data` array. This allows
	       * the grid to maintain state while vastly speeding up the process of altering `data` by adding/moving/removing rows.
	       *
	       * Note that this DOES add properties to your data that you may not want, but they are stripped out when using `angular.toJson()`. IF
	       * you do not want this at all you can disable this setting but you will take a performance hit if you are using large numbers of rows
	       * and are altering the data set often.
	       */
	      baseOptions.enableRowHashing = baseOptions.enableRowHashing !== false;
	
	      /**
	       * @ngdoc function
	       * @name rowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function is used to get and, if necessary, set the value uniquely identifying this row (i.e. if an identity is not present it will set one).
	       *
	       * By default it returns the `$$hashKey` property if it exists. If it doesn't it uses gridUtil.nextUid() to generate one
	       */
	      baseOptions.rowIdentity = baseOptions.rowIdentity || function rowIdentity(row) {
	        return gridUtil.hashKey(row);
	      };
	
	      /**
	       * @ngdoc function
	       * @name getRowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function returns the identity value uniquely identifying this row, if one is not present it does not set it.
	       *
	       * By default it returns the `$$hashKey` property but can be overridden to use any property or set of properties you want.
	       */
	      baseOptions.getRowIdentity = baseOptions.getRowIdentity || function getRowIdentity(row) {
	        return row.$$hashKey;
	      };
	
	      /**
	       * @ngdoc property
	       * @name flatEntityAccess
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Set to true if your columns are all related directly to fields in a flat object structure - i.e.
	       * each of your columns associate directly with a property on each of the entities in your data array.
	       *
	       * In that situation we can avoid all the logic associated with complex binding to functions or to properties of sub-objects,
	       * which can provide a significant speed improvement with large data sets when filtering or sorting.
	       *
	       * By default false
	       */
	      baseOptions.flatEntityAccess = baseOptions.flatEntityAccess === true;
	
	      /**
	       * @ngdoc property
	       * @name showHeader
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When set to false, this setting will replace the
	       * standard header template with '<div></div>', resulting in no header being shown.
	       */
	      baseOptions.showHeader = typeof(baseOptions.showHeader) !== "undefined" ? baseOptions.showHeader : true;
	
	      /* (NOTE): Don't show this in the docs. We only use it internally
	       * @ngdoc property
	       * @name headerRowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the header in pixels, defaults to 30
	       *
	       */
	      if (!baseOptions.showHeader) {
	        baseOptions.headerRowHeight = 0;
	      }
	      else {
	        baseOptions.headerRowHeight = typeof(baseOptions.headerRowHeight) !== "undefined" ? baseOptions.headerRowHeight : 30;
	      }
	
	      /**
	       * @ngdoc property
	       * @name rowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the row in pixels, defaults to 30
	       *
	       */
	      baseOptions.rowHeight = baseOptions.rowHeight || 30;
	
	      /**
	       * @ngdoc integer
	       * @name minRowsToShow
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Minimum number of rows to show when the grid doesn't have a defined height. Defaults to "10".
	       */
	      baseOptions.minRowsToShow = typeof(baseOptions.minRowsToShow) !== "undefined" ? baseOptions.minRowsToShow : 10;
	
	      /**
	       * @ngdoc property
	       * @name showGridFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the footer, defaults to false
	       * The footer display Total Rows and Visible Rows (filtered rows)
	       */
	      baseOptions.showGridFooter = baseOptions.showGridFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name showColumnFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the column footer, defaults to false
	       * The column footer displays column aggregates
	       */
	      baseOptions.showColumnFooter = baseOptions.showColumnFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name columnFooterHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the footer rows (column footer and grid footer) in pixels
	       *
	       */
	      baseOptions.columnFooterHeight = typeof(baseOptions.columnFooterHeight) !== "undefined" ? baseOptions.columnFooterHeight : 30;
	      baseOptions.gridFooterHeight = typeof(baseOptions.gridFooterHeight) !== "undefined" ? baseOptions.gridFooterHeight : 30;
	
	      baseOptions.columnWidth = typeof(baseOptions.columnWidth) !== "undefined" ? baseOptions.columnWidth : 50;
	
	      /**
	       * @ngdoc property
	       * @name maxVisibleColumnCount
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 200
	       *
	       */
	      baseOptions.maxVisibleColumnCount = typeof(baseOptions.maxVisibleColumnCount) !== "undefined" ? baseOptions.maxVisibleColumnCount : 200;
	
	      /**
	       * @ngdoc property
	       * @name virtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of data elements goes over this number, defaults to 20
	       */
	      baseOptions.virtualizationThreshold = typeof(baseOptions.virtualizationThreshold) !== "undefined" ? baseOptions.virtualizationThreshold : 20;
	
	      /**
	       * @ngdoc property
	       * @name columnVirtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of columns goes over this number, defaults to 10
	       */
	      baseOptions.columnVirtualizationThreshold = typeof(baseOptions.columnVirtualizationThreshold) !== "undefined" ? baseOptions.columnVirtualizationThreshold : 10;
	
	      /**
	       * @ngdoc property
	       * @name excessRows
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra rows to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessRows = typeof(baseOptions.excessRows) !== "undefined" ? baseOptions.excessRows : 4;
	      /**
	       * @ngdoc property
	       * @name scrollThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 4
	       */
	      baseOptions.scrollThreshold = typeof(baseOptions.scrollThreshold) !== "undefined" ? baseOptions.scrollThreshold : 4;
	
	      /**
	       * @ngdoc property
	       * @name excessColumns
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra columns to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessColumns = typeof(baseOptions.excessColumns) !== "undefined" ? baseOptions.excessColumns : 4;
	      /**
	       * @ngdoc property
	       * @name horizontalScrollThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 4
	       */
	      baseOptions.horizontalScrollThreshold = typeof(baseOptions.horizontalScrollThreshold) !== "undefined" ? baseOptions.horizontalScrollThreshold : 2;
	
	
	      /**
	       * @ngdoc property
	       * @name aggregationCalcThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle aggregation calcuations, defaults to 500ms
	       */
	      baseOptions.aggregationCalcThrottle = typeof(baseOptions.aggregationCalcThrottle) !== "undefined" ? baseOptions.aggregationCalcThrottle : 500;
	
	      /**
	       * @ngdoc property
	       * @name wheelScrollThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle scroll events to, defaults to 70ms
	       */
	      baseOptions.wheelScrollThrottle = typeof(baseOptions.wheelScrollThrottle) !== "undefined" ? baseOptions.wheelScrollThrottle : 70;
	
	
	      /**
	       * @ngdoc property
	       * @name scrollDebounce
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to debounce scroll events, defaults to 300ms
	       */
	      baseOptions.scrollDebounce = typeof(baseOptions.scrollDebounce) !== "undefined" ? baseOptions.scrollDebounce : 300;
	
	      /**
	       * @ngdoc boolean
	       * @name enableSorting
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting adds sort
	       * widgets to the column headers, allowing sorting of the data for the entire grid.
	       * Sorting can then be disabled on individual columns using the columnDefs.
	       */
	      baseOptions.enableSorting = baseOptions.enableSorting !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableFiltering
	       * @propertyOf ui.grid.class:GridOptions
	       * @description False by default. When enabled, this setting adds filter
	       * boxes to each column header, allowing filtering within the column for the entire grid.
	       * Filtering can then be disabled on individual columns using the columnDefs.
	       */
	      baseOptions.enableFiltering = baseOptions.enableFiltering === true;
	
	      /**
	       * @ngdoc boolean
	       * @name enableColumnMenus
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting displays a column
	       * menu within each column.
	       */
	      baseOptions.enableColumnMenus = baseOptions.enableColumnMenus !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableVerticalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description uiGridConstants.scrollbars.ALWAYS by default. This settings controls the vertical scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER
	       */
	      baseOptions.enableVerticalScrollbar = typeof(baseOptions.enableVerticalScrollbar) !== "undefined" ? baseOptions.enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableHorizontalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description uiGridConstants.scrollbars.ALWAYS by default. This settings controls the horizontal scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER
	       */
	      baseOptions.enableHorizontalScrollbar = typeof(baseOptions.enableHorizontalScrollbar) !== "undefined" ? baseOptions.enableHorizontalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableMinHeightCheck
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, a newly initialized grid will check to see if it is tall enough to display
	       * at least one row of data.  If the grid is not tall enough, it will resize the DOM element to display minRowsToShow number
	       * of rows.
	       */
	       baseOptions.enableMinHeightCheck = baseOptions.enableMinHeightCheck !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name minimumColumnSize
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Columns can't be smaller than this, defaults to 10 pixels
	       */
	      baseOptions.minimumColumnSize = typeof(baseOptions.minimumColumnSize) !== "undefined" ? baseOptions.minimumColumnSize : 10;
	
	      /**
	       * @ngdoc function
	       * @name rowEquality
	       * @methodOf ui.grid.class:GridOptions
	       * @description By default, rows are compared using object equality.  This option can be overridden
	       * to compare on any data item property or function
	       * @param {object} entityA First Data Item to compare
	       * @param {object} entityB Second Data Item to compare
	       */
	      baseOptions.rowEquality = baseOptions.rowEquality || function(entityA, entityB) {
	        return entityA === entityB;
	      };
	
	      /**
	       * @ngdoc string
	       * @name headerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Null by default. When provided, this setting uses a custom header
	       * template, rather than the default template. Can be set to either the name of a template file:
	       * <pre>  $scope.gridOptions.headerTemplate = 'header_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.headerTemplate = '<div class="ui-grid-top-panel" style="text-align: center">I am a Custom Grid Header</div>'</pre>
	       * or the id of a precompiled template (TBD how to use this).
	       * </br>Refer to the custom header tutorial for more information.
	       * If you want no header at all, you can set to an empty div:
	       * <pre>  $scope.gridOptions.headerTemplate = '<div></div>';</pre>
	       *
	       * If you want to only have a static header, then you can set to static content.  If
	       * you want to tailor the existing column headers, then you should look at the
	       * current 'ui-grid-header.html' template in github as your starting point.
	       *
	       */
	      baseOptions.headerTemplate = baseOptions.headerTemplate || null;
	
	      /**
	       * @ngdoc string
	       * @name footerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-footer by default.  This footer shows the per-column
	       * aggregation totals.
	       * When provided, this setting uses a custom footer template. Can be set to either the name of a template file 'footer_template.html', inline html
	       * <pre>'<div class="ui-grid-bottom-panel" style="text-align: center">I am a Custom Grid Footer</div>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.footerTemplate = baseOptions.footerTemplate || 'ui-grid/ui-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name gridFooterTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-grid-footer by default. This template by default shows the
	       * total items at the bottom of the grid, and the selected items if selection is enabled.
	       */
	      baseOptions.gridFooterTemplate = baseOptions.gridFooterTemplate || 'ui-grid/ui-grid-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name rowTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/ui-grid-row' by default. When provided, this setting uses a
	       * custom row template.  Can be set to either the name of a template file:
	       * <pre> $scope.gridOptions.rowTemplate = 'row_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.rowTemplate = '<div style="background-color: aquamarine" ng-click="grid.appScope.fnOne(row)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';</pre>
	       * or the id of a precompiled template (TBD how to use this) can be provided.
	       * </br>Refer to the custom row template tutorial for more information.
	       */
	      baseOptions.rowTemplate = baseOptions.rowTemplate || 'ui-grid/ui-grid-row';
	
	      /**
	       * @ngdoc object
	       * @name appScopeProvider
	       * @propertyOf ui.grid.class:GridOptions
	       * @description by default, the parent scope of the ui-grid element will be assigned to grid.appScope
	       * this property allows you to assign any reference you want to grid.appScope
	       */
	      baseOptions.appScopeProvider = baseOptions.appScopeProvider || null;
	
	      return baseOptions;
	    }
	  };
	
	
	}]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridRenderContainer
	   * @description The grid has render containers, allowing the ability to have pinned columns.  If the grid
	   * is right-to-left then there may be a right render container, if left-to-right then there may
	   * be a left render container.  There is always a body render container.
	   * @param {string} name The name of the render container ('body', 'left', or 'right')
	   * @param {Grid} grid the grid the render container is in
	   * @param {object} options the render container options
	   */
	.factory('GridRenderContainer', ['gridUtil', 'uiGridConstants', function(gridUtil, uiGridConstants) {
	  function GridRenderContainer(name, grid, options) {
	    var self = this;
	
	    // if (gridUtil.type(grid) !== 'Grid') {
	    //   throw new Error('Grid argument is not a Grid object');
	    // }
	
	    self.name = name;
	
	    self.grid = grid;
	
	    // self.rowCache = [];
	    // self.columnCache = [];
	
	    self.visibleRowCache = [];
	    self.visibleColumnCache = [];
	
	    self.renderedRows = [];
	    self.renderedColumns = [];
	
	    self.prevScrollTop = 0;
	    self.prevScrolltopPercentage = 0;
	    self.prevRowScrollIndex = 0;
	
	    self.prevScrollLeft = 0;
	    self.prevScrollleftPercentage = 0;
	    self.prevColumnScrollIndex = 0;
	
	    self.columnStyles = "";
	
	    self.viewportAdjusters = [];
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasHScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a horizontal scrollbar
	     */
	    self.hasHScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasVScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a vertical scrollbar
	     */
	    self.hasVScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeightShouldUpdate
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container should recalculate the canvas size
	     */
	    self.canvasHeightShouldUpdate = true;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeight
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description last calculated canvas height value
	     */
	    self.$$canvasHeight = 0;
	
	    if (options && angular.isObject(options)) {
	      angular.extend(self, options);
	    }
	
	    grid.registerStyleComputation({
	      priority: 5,
	      func: function () {
	        self.updateColumnWidths();
	        return self.columnStyles;
	      }
	    });
	  }
	
	
	  GridRenderContainer.prototype.reset = function reset() {
	    // this.rowCache.length = 0;
	    // this.columnCache.length = 0;
	
	    this.visibleColumnCache.length = 0;
	    this.visibleRowCache.length = 0;
	
	    this.renderedRows.length = 0;
	    this.renderedColumns.length = 0;
	  };
	
	  // TODO(c0bra): calculate size?? Should this be in a stackable directive?
	
	
	  GridRenderContainer.prototype.containsColumn = function (col) {
	     return this.visibleColumnCache.indexOf(col) !== -1;
	  };
	
	  GridRenderContainer.prototype.minRowsToRender = function minRowsToRender() {
	    var self = this;
	    var minRows = 0;
	    var rowAddedHeight = 0;
	    var viewPortHeight = self.getViewportHeight();
	    for (var i = self.visibleRowCache.length - 1; rowAddedHeight < viewPortHeight && i >= 0; i--) {
	      rowAddedHeight += self.visibleRowCache[i].height;
	      minRows++;
	    }
	    return minRows;
	  };
	
	  GridRenderContainer.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewportWidth = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	    // self.columns.forEach(function(col, i) {
	    for (var i = 0; i < self.visibleColumnCache.length; i++) {
	      var col = self.visibleColumnCache[i];
	
	      if (totalWidth < viewportWidth) {
	        totalWidth += col.drawnWidth ? col.drawnWidth : 0;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.visibleColumnCache[j].drawnWidth ? self.visibleColumnCache[j].drawnWidth : 0;
	        }
	        if (currWidth < viewportWidth) {
	          min++;
	        }
	      }
	    }
	
	    return min;
	  };
	
	  GridRenderContainer.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    return this.visibleRowCache.length;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Registers an adjuster to the render container's available width or height.  Adjusters are used
	   * to tell the render container that there is something else consuming space, and to adjust it's size
	   * appropriately.
	   * @param {function} func the adjuster function we want to register
	   */
	
	  GridRenderContainer.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Removes an adjuster, should be used when your element is destroyed
	   * @param {function} func the adjuster function we want to remove
	   */
	  GridRenderContainer.prototype.removeViewportAdjuster = function removeViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (idx > -1) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getViewportAdjustment
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Gets the adjustment based on the viewportAdjusters.
	   * @returns {object} a hash of { height: x, width: y }.  Usually the values will be negative
	   */
	  GridRenderContainer.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  GridRenderContainer.prototype.getMargin = function getMargin(side) {
	    var self = this;
	
	    var amount = 0;
	
	    self.viewportAdjusters.forEach(function (func) {
	      var adjustment = func.call(this, { height: 0, width: 0 });
	
	      if (adjustment.side && adjustment.side === side) {
	        amount += adjustment.width * -1;
	      }
	    });
	
	    return amount;
	  };
	
	  GridRenderContainer.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var headerHeight = (self.headerHeight) ? self.headerHeight : self.grid.headerHeight;
	
	    var viewPortHeight = self.grid.gridHeight - headerHeight - self.grid.footerHeight;
	
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    return viewPortHeight;
	  };
	
	  GridRenderContainer.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewportWidth = self.grid.gridWidth;
	
	    //if (typeof(self.grid.verticalScrollbarWidth) !== 'undefined' && self.grid.verticalScrollbarWidth !== undefined && self.grid.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth - self.grid.verticalScrollbarWidth;
	    //}
	
	    // var viewportWidth = 0;\
	    // self.visibleColumnCache.forEach(function (column) {
	    //   viewportWidth += column.drawnWidth;
	    // });
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewportWidth = viewportWidth + adjustment.width;
	
	    return viewportWidth;
	  };
	
	  GridRenderContainer.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    var self = this;
	
	    var viewportWidth = this.getViewportWidth();
	
	    //if (typeof(self.grid.verticalScrollbarWidth) !== 'undefined' && self.grid.verticalScrollbarWidth !== undefined && self.grid.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth + self.grid.verticalScrollbarWidth;
	    //}
	
	    // var adjustment = self.getViewportAdjustment();
	    // viewPortWidth = viewPortWidth + adjustment.width;
	
	    return viewportWidth;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getCanvasHeight
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Returns the total canvas height.   Only recalculates if canvasHeightShouldUpdate = false
	   * @returns {number} total height of all the visible rows in the container
	   */
	  GridRenderContainer.prototype.getCanvasHeight = function getCanvasHeight() {
	    var self = this;
	
	    if (!self.canvasHeightShouldUpdate) {
	      return self.$$canvasHeight;
	    }
	
	    var oldCanvasHeight = self.$$canvasHeight;
	
	    self.$$canvasHeight =  0;
	
	    self.visibleRowCache.forEach(function(row){
	      self.$$canvasHeight += row.height;
	    });
	
	
	    self.canvasHeightShouldUpdate = false;
	
	    self.grid.api.core.raise.canvasHeightChanged(oldCanvasHeight, self.$$canvasHeight);
	
	    return self.$$canvasHeight;
	  };
	
	  GridRenderContainer.prototype.getVerticalScrollLength = function getVerticalScrollLength() {
	    return this.getCanvasHeight() - this.getViewportHeight() + this.grid.scrollbarHeight;
	  };
	
	  GridRenderContainer.prototype.getCanvasWidth = function getCanvasWidth() {
	    var self = this;
	
	    var ret = self.canvasWidth;
	
	    return ret;
	  };
	
	  GridRenderContainer.prototype.setRenderedRows = function setRenderedRows(newRows) {
	    this.renderedRows.length = newRows.length;
	    for (var i = 0; i < newRows.length; i++) {
	      this.renderedRows[i] = newRows[i];
	    }
	  };
	
	  GridRenderContainer.prototype.setRenderedColumns = function setRenderedColumns(newColumns) {
	    var self = this;
	
	    // OLD:
	    this.renderedColumns.length = newColumns.length;
	    for (var i = 0; i < newColumns.length; i++) {
	      this.renderedColumns[i] = newColumns[i];
	    }
	
	    this.updateColumnOffset();
	  };
	
	  GridRenderContainer.prototype.updateColumnOffset = function updateColumnOffset() {
	    // Calculate the width of the columns on the left side that are no longer rendered.
	    //  That will be the offset for the columns as we scroll horizontally.
	    var hiddenColumnsWidth = 0;
	    for (var i = 0; i < this.currentFirstColumn; i++) {
	      hiddenColumnsWidth += this.visibleColumnCache[i].drawnWidth;
	    }
	
	    this.columnOffset = hiddenColumnsWidth;
	  };
	
	  GridRenderContainer.prototype.scrollVertical = function (newScrollTop) {
	    var vertScrollPercentage = -1;
	
	    if (newScrollTop !== this.prevScrollTop) {
	      var yDiff = newScrollTop - this.prevScrollTop;
	
	      if (yDiff > 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.DOWN; }
	      if (yDiff < 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.UP; }
	
	      var vertScrollLength = this.getVerticalScrollLength();
	
	      vertScrollPercentage = newScrollTop / vertScrollLength;
	
	      // console.log('vert', vertScrollPercentage, newScrollTop, vertScrollLength);
	
	      if (vertScrollPercentage > 1) { vertScrollPercentage = 1; }
	      if (vertScrollPercentage < 0) { vertScrollPercentage = 0; }
	
	      this.adjustScrollVertical(newScrollTop, vertScrollPercentage);
	      return vertScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.scrollHorizontal = function(newScrollLeft){
	    var horizScrollPercentage = -1;
	
	    // Handle RTL here
	
	    if (newScrollLeft !== this.prevScrollLeft) {
	      var xDiff = newScrollLeft - this.prevScrollLeft;
	
	      if (xDiff > 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.RIGHT; }
	      if (xDiff < 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.LEFT; }
	
	      var horizScrollLength = (this.canvasWidth - this.getViewportWidth());
	      if (horizScrollLength !== 0) {
	        horizScrollPercentage = newScrollLeft / horizScrollLength;
	      }
	      else {
	        horizScrollPercentage = 0;
	      }
	
	      this.adjustScrollHorizontal(newScrollLeft, horizScrollPercentage);
	      return horizScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.adjustScrollVertical = function adjustScrollVertical(scrollTop, scrollPercentage, force) {
	    if (this.prevScrollTop === scrollTop && !force) {
	      return;
	    }
	
	    if (typeof(scrollTop) === 'undefined' || scrollTop === undefined || scrollTop === null) {
	      scrollTop = (this.getCanvasHeight() - this.getViewportHeight()) * scrollPercentage;
	    }
	
	    this.adjustRows(scrollTop, scrollPercentage, false);
	
	    this.prevScrollTop = scrollTop;
	    this.prevScrolltopPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustScrollHorizontal = function adjustScrollHorizontal(scrollLeft, scrollPercentage, force) {
	    if (this.prevScrollLeft === scrollLeft && !force) {
	      return;
	    }
	
	    if (typeof(scrollLeft) === 'undefined' || scrollLeft === undefined || scrollLeft === null) {
	      scrollLeft = (this.getCanvasWidth() - this.getViewportWidth()) * scrollPercentage;
	    }
	
	    this.adjustColumns(scrollLeft, scrollPercentage);
	
	    this.prevScrollLeft = scrollLeft;
	    this.prevScrollleftPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustRows = function adjustRows(scrollTop, scrollPercentage, postDataLoaded) {
	    var self = this;
	
	    var minRows = self.minRowsToRender();
	
	    var rowCache = self.visibleRowCache;
	
	    var maxRowIndex = rowCache.length - minRows;
	
	    // console.log('scroll%1', scrollPercentage);
	
	    // Calculate the scroll percentage according to the scrollTop location, if no percentage was provided
	    if ((typeof(scrollPercentage) === 'undefined' || scrollPercentage === null) && scrollTop) {
	      scrollPercentage = scrollTop / self.getVerticalScrollLength();
	    }
	
	    var rowIndex = Math.ceil(Math.min(maxRowIndex, maxRowIndex * scrollPercentage));
	
	    // console.log('maxRowIndex / scroll%', maxRowIndex, scrollPercentage, rowIndex);
	
	    // Define a max row index that we can't scroll past
	    if (rowIndex > maxRowIndex) {
	      rowIndex = maxRowIndex;
	    }
	
	    var newRange = [];
	    if (rowCache.length > self.grid.options.virtualizationThreshold) {
	      if (!(typeof(scrollTop) === 'undefined' || scrollTop === null)) {
	        // Have we hit the threshold going down?
	        if ( !self.grid.suppressParentScrollDown && self.prevScrollTop < scrollTop && rowIndex < self.prevRowScrollIndex + self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	        //Have we hit the threshold going up?
	        if ( !self.grid.suppressParentScrollUp && self.prevScrollTop > scrollTop && rowIndex > self.prevRowScrollIndex - self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	      }
	      var rangeStart = {};
	      var rangeEnd = {};
	
	      rangeStart = Math.max(0, rowIndex - self.grid.options.excessRows);
	      rangeEnd = Math.min(rowCache.length, rowIndex + minRows + self.grid.options.excessRows);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleRowCache.length;
	      newRange = [0, Math.max(maxLen, minRows + self.grid.options.excessRows)];
	    }
	
	    self.updateViewableRowRange(newRange);
	
	    self.prevRowScrollIndex = rowIndex;
	  };
	
	  GridRenderContainer.prototype.adjustColumns = function adjustColumns(scrollLeft, scrollPercentage) {
	    var self = this;
	
	    var minCols = self.minColumnsToRender();
	
	    var columnCache = self.visibleColumnCache;
	    var maxColumnIndex = columnCache.length - minCols;
	
	    // Calculate the scroll percentage according to the scrollLeft location, if no percentage was provided
	    if ((typeof(scrollPercentage) === 'undefined' || scrollPercentage === null) && scrollLeft) {
	      var horizScrollLength = (self.getCanvasWidth() - self.getViewportWidth());
	      scrollPercentage = scrollLeft / horizScrollLength;
	    }
	
	    var colIndex = Math.ceil(Math.min(maxColumnIndex, maxColumnIndex * scrollPercentage));
	
	    // Define a max row index that we can't scroll past
	    if (colIndex > maxColumnIndex) {
	      colIndex = maxColumnIndex;
	    }
	
	    var newRange = [];
	    if (columnCache.length > self.grid.options.columnVirtualizationThreshold && self.getCanvasWidth() > self.getViewportWidth()) {
	      /* Commented the following lines because otherwise the moved column wasn't visible immediately on the new position
	       * in the case of many columns with horizontal scroll, one had to scroll left or right and then return in order to see it
	      // Have we hit the threshold going down?
	      if (self.prevScrollLeft < scrollLeft && colIndex < self.prevColumnScrollIndex + self.grid.options.horizontalScrollThreshold && colIndex < maxColumnIndex) {
	        return;
	      }
	      //Have we hit the threshold going up?
	      if (self.prevScrollLeft > scrollLeft && colIndex > self.prevColumnScrollIndex - self.grid.options.horizontalScrollThreshold && colIndex < maxColumnIndex) {
	        return;
	      }*/
	
	      var rangeStart = Math.max(0, colIndex - self.grid.options.excessColumns);
	      var rangeEnd = Math.min(columnCache.length, colIndex + minCols + self.grid.options.excessColumns);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleColumnCache.length;
	
	      newRange = [0, Math.max(maxLen, minCols + self.grid.options.excessColumns)];
	    }
	
	    self.updateViewableColumnRange(newRange);
	
	    self.prevColumnScrollIndex = colIndex;
	  };
	
	  // Method for updating the visible rows
	  GridRenderContainer.prototype.updateViewableRowRange = function updateViewableRowRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var rowArr = uiGridCtrl.grid.rows.slice(renderedRange[0], renderedRange[1]);
	    var rowArr = this.visibleRowCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the top-most rendered row
	    this.currentTopRow = renderedRange[0];
	
	    this.setRenderedRows(rowArr);
	  };
	
	  // Method for updating the visible columns
	  GridRenderContainer.prototype.updateViewableColumnRange = function updateViewableColumnRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var columnArr = uiGridCtrl.grid.columns.slice(renderedRange[0], renderedRange[1]);
	    var columnArr = this.visibleColumnCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the left-most rendered columns
	    this.currentFirstColumn = renderedRange[0];
	
	    this.setRenderedColumns(columnArr);
	  };
	
	  GridRenderContainer.prototype.headerCellWrapperStyle = function () {
	    var self = this;
	
	    if (self.currentFirstColumn !== 0) {
	      var offset = self.columnOffset;
	
	      if (self.grid.isRTL()) {
	        return { 'margin-right': offset + 'px' };
	      }
	      else {
	        return { 'margin-left': offset + 'px' };
	      }
	    }
	
	    return null;
	  };
	
	    /**
	     *  @ngdoc boolean
	     *  @name updateColumnWidths
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description Determine the appropriate column width of each column across all render containers.
	     *
	     *  Column width is easy when each column has a specified width.  When columns are variable width (i.e.
	     *  have an * or % of the viewport) then we try to calculate so that things fit in.  The problem is that
	     *  we have multiple render containers, and we don't want one render container to just take the whole viewport
	     *  when it doesn't need to - we want things to balance out across the render containers.
	     *
	     *  To do this, we use this method to calculate all the renderContainers, recognising that in a given render
	     *  cycle it'll get called once per render container, so it needs to return the same values each time.
	     *
	     *  The constraints on this method are therefore:
	     *  - must return the same value when called multiple times, to do this it needs to rely on properties of the
	     *    columns, but not properties that change when this is called (so it shouldn't rely on drawnWidth)
	     *
	     *  The general logic of this method is:
	     *  - calculate our total available width
	     *  - look at all the columns across all render containers, and work out which have widths and which have
	     *    constraints such as % or * or something else
	     *  - for those with *, count the total number of * we see and add it onto a running total, add this column to an * array
	     *  - for those with a %, allocate the % as a percentage of the viewport, having consideration of min and max
	     *  - for those with manual width (in pixels) we set the drawnWidth to the specified width
	     *  - we end up with an asterisks array still to process
	     *  - we look at our remaining width.  If it's greater than zero, we divide it up among the asterisk columns, then process
	     *    them for min and max width constraints
	     *  - if it's zero or less, we set the asterisk columns to their minimum widths
	     *  - we use parseInt quite a bit, as we try to make all our column widths integers
	     */
	  GridRenderContainer.prototype.updateColumnWidths = function () {
	    var self = this;
	
	    var asterisksArray = [],
	        asteriskNum = 0,
	        usedWidthSum = 0,
	        ret = '';
	
	    // Get the width of the viewport
	    var availableWidth = self.grid.getViewportWidth() - self.grid.scrollbarWidth;
	
	    // get all the columns across all render containers, we have to calculate them all or one render container
	    // could consume the whole viewport
	    var columnCache = [];
	    angular.forEach(self.grid.renderContainers, function( container, name){
	      columnCache = columnCache.concat(container.visibleColumnCache);
	    });
	
	    // look at each column, process any manual values or %, put the * into an array to look at later
	    columnCache.forEach(function(column, i) {
	      var width = 0;
	      // Skip hidden columns
	      if (!column.visible) { return; }
	
	      if (angular.isNumber(column.width)) {
	        // pixel width, set to this value
	        width = parseInt(column.width, 10);
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	
	      } else if (gridUtil.endsWith(column.width, "%")) {
	        // percentage width, set to percentage of the viewport
	        width = parseInt(parseInt(column.width.replace(/%/g, ''), 10) / 100 * availableWidth);
	
	        if ( width > column.maxWidth ){
	          width = column.maxWidth;
	        }
	
	        if ( width < column.minWidth ){
	          width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	      } else if (angular.isString(column.width) && column.width.indexOf('*') !== -1) {
	        // is an asterisk column, the gridColumn already checked the string consists only of '****'
	        asteriskNum = asteriskNum + column.width.length;
	        asterisksArray.push(column);
	      }
	    });
	
	    // Get the remaining width (available width subtracted by the used widths sum)
	    var remainingWidth = availableWidth - usedWidthSum;
	
	    var i, column, colWidth;
	
	    if (asterisksArray.length > 0) {
	      // the width that each asterisk value would be assigned (this can be negative)
	      var asteriskVal = remainingWidth / asteriskNum;
	
	      asterisksArray.forEach(function( column ){
	        var width = parseInt(column.width.length * asteriskVal, 10);
	
	        if ( width > column.maxWidth ){
	          width = column.maxWidth;
	        }
	
	        if ( width < column.minWidth ){
	          width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	      });
	    }
	
	    // If the grid width didn't divide evenly into the column widths and we have pixels left over, or our
	    // calculated widths would have the grid narrower than the available space,
	    // dole the remainder out one by one to make everything fit
	    var processColumnUpwards = function(column){
	      if ( column.drawnWidth < column.maxWidth && leftoverWidth > 0) {
	        column.drawnWidth++;
	        usedWidthSum++;
	        leftoverWidth--;
	        columnsToChange = true;
	      }
	    };
	
	    var leftoverWidth = availableWidth - usedWidthSum;
	    var columnsToChange = true;
	
	    while (leftoverWidth > 0 && columnsToChange) {
	      columnsToChange = false;
	      asterisksArray.forEach(processColumnUpwards);
	    }
	
	    // We can end up with too much width even though some columns aren't at their max width, in this situation
	    // we can trim the columns a little
	    var processColumnDownwards = function(column){
	      if ( column.drawnWidth > column.minWidth && excessWidth > 0) {
	        column.drawnWidth--;
	        usedWidthSum--;
	        excessWidth--;
	        columnsToChange = true;
	      }
	    };
	
	    var excessWidth =  usedWidthSum - availableWidth;
	    columnsToChange = true;
	
	    while (excessWidth > 0 && columnsToChange) {
	      columnsToChange = false;
	      asterisksArray.forEach(processColumnDownwards);
	    }
	
	
	    // all that was across all the renderContainers, now we need to work out what that calculation decided for
	    // our renderContainer
	    var canvasWidth = 0;
	    self.visibleColumnCache.forEach(function(column){
	      if ( column.visible ){
	        canvasWidth = canvasWidth + column.drawnWidth;
	      }
	    });
	
	    // Build the CSS
	    columnCache.forEach(function (column) {
	      ret = ret + column.getColClassDefinition();
	    });
	
	    self.canvasWidth = canvasWidth;
	
	    // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	    // return ret;
	
	    // Set this render container's column styles so they can be used in style computation
	    this.columnStyles = ret;
	  };
	
	  GridRenderContainer.prototype.needsHScrollbarPlaceholder = function () {
	    return this.grid.options.enableHorizontalScrollbar && !this.hasHScrollbar && !this.grid.disableScrolling;
	  };
	
	  GridRenderContainer.prototype.getViewportStyle = function () {
	    var self = this;
	    var styles = {};
	
	    self.hasHScrollbar = false;
	    self.hasVScrollbar = false;
	
	    if (self.grid.disableScrolling) {
	      styles['overflow-x'] = 'hidden';
	      styles['overflow-y'] = 'hidden';
	      return styles;
	    }
	
	    if (self.name === 'body') {
	      self.hasHScrollbar = self.grid.options.enableHorizontalScrollbar !== uiGridConstants.scrollbars.NEVER;
	      if (!self.grid.isRTL()) {
	        if (!self.grid.hasRightContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	      else {
	        if (!self.grid.hasLeftContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	    }
	    else if (self.name === 'left') {
	      self.hasVScrollbar = self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	    else {
	      self.hasVScrollbar = !self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	
	    styles['overflow-x'] = self.hasHScrollbar ? 'scroll' : 'hidden';
	    styles['overflow-y'] = self.hasVScrollbar ? 'scroll' : 'hidden';
	
	
	    return styles;
	
	
	  };
	
	  return GridRenderContainer;
	}]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.factory('GridRow', ['gridUtil', function(gridUtil) {
	
	   /**
	   * @ngdoc function
	   * @name ui.grid.class:GridRow
	   * @description GridRow is the viewModel for one logical row on the grid.  A grid Row is not necessarily a one-to-one
	   * relation to gridOptions.data.
	   * @param {object} entity the array item from GridOptions.data
	   * @param {number} index the current position of the row in the array
	   * @param {Grid} reference to the parent grid
	   */
	  function GridRow(entity, index, grid) {
	
	     /**
	      *  @ngdoc object
	      *  @name grid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference back to the grid
	      */
	     this.grid = grid;
	
	     /**
	      *  @ngdoc object
	      *  @name entity
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference to an item in gridOptions.data[]
	      */
	    this.entity = entity;
	
	     /**
	      *  @ngdoc object
	      *  @name uid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description  UniqueId of row
	      */
	     this.uid = gridUtil.nextUid();
	
	     /**
	      *  @ngdoc object
	      *  @name visible
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description If true, the row will be rendered
	      */
	    // Default to true
	    this.visible = true;
	
	
	    this.$$height = grid.options.rowHeight;
	
	  }
	
	    /**
	     *  @ngdoc object
	     *  @name height
	     *  @propertyOf  ui.grid.class:GridRow
	     *  @description height of each individual row. changing the height will flag all
	     *  row renderContainers to recalculate their canvas height
	     */
	    Object.defineProperty(GridRow.prototype, 'height', {
	      get: function() {
	        return this.$$height;
	      },
	      set: function(height) {
	        if (height !== this.$$height) {
	          this.grid.updateCanvasHeight();
	          this.$$height = height;
	        }
	      }
	    });
	
	  /**
	   * @ngdoc function
	   * @name getQualifiedColField
	   * @methodOf ui.grid.class:GridRow
	   * @description returns the qualified field name as it exists on scope
	   * ie: row.entity.fieldA
	   * @param {GridCol} col column instance
	   * @returns {string} resulting name that can be evaluated on scope
	   */
	    GridRow.prototype.getQualifiedColField = function(col) {
	      return 'row.' + this.getEntityQualifiedColField(col);
	    };
	
	    /**
	     * @ngdoc function
	     * @name getEntityQualifiedColField
	     * @methodOf ui.grid.class:GridRow
	     * @description returns the qualified field name minus the row path
	     * ie: entity.fieldA
	     * @param {GridCol} col column instance
	     * @returns {string} resulting name that can be evaluated against a row
	     */
	  GridRow.prototype.getEntityQualifiedColField = function(col) {
	    return gridUtil.preEval('entity.' + col.field);
	  };
	  
	  
	  /**
	   * @ngdoc function
	   * @name setRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   * 
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.setRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.setThisRowInvisible().
	   * 
	   * @param {GridRow} row the row we want to set to invisible
	   * 
	   */
	  GridRow.prototype.setRowInvisible = function ( row ) {
	    if (row && row.setThisRowInvisible){
	      row.setThisRowInvisible( 'user' );
	    }
	  };
	  
	  
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Clears an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   * 
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.clearRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.clearThisRowInvisible().
	   * 
	   * @param {GridRow} row the row we want to clear the invisible flag
	   * 
	   */
	  GridRow.prototype.clearRowInvisible = function ( row ) {
	    if (row && row.clearThisRowInvisible){
	      row.clearThisRowInvisible( 'user' );
	    }
	  };
	  
	  
	  /**
	   * @ngdoc function
	   * @name setThisRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility
	   *
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.setThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if ( !this.invisibleReason ){
	      this.invisibleReason = {};
	    }
	    this.invisibleReason[reason] = true;
	    this.evaluateRowVisibility( fromRowsProcessor);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf ui.grid.class:GridRow
	   * @description Clears any override on the row visibility, returning it 
	   * to normal visibility calculations.  Emits the rowsVisibleChanged
	   * event
	   * 
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.clearThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if (typeof(this.invisibleReason) !== 'undefined' ) {
	      delete this.invisibleReason[reason];
	    }
	    this.evaluateRowVisibility( fromRowsProcessor );
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name evaluateRowVisibility
	   * @methodOf ui.grid.class:GridRow
	   * @description Determines whether the row should be visible based on invisibleReason, 
	   * and if it changes the row visibility, then emits the rowsVisibleChanged event.
	   * 
	   * Queues a grid refresh, but doesn't call it directly to avoid hitting lots of grid refreshes.
	   * @param {boolean} fromRowProcessor if true, then it won't raise events or queue the refresh, the
	   * row processor does that already
	   */
	  GridRow.prototype.evaluateRowVisibility = function ( fromRowProcessor ) {
	    var newVisibility = true;
	    if ( typeof(this.invisibleReason) !== 'undefined' ){
	      angular.forEach(this.invisibleReason, function( value, key ){
	        if ( value ){
	          newVisibility = false;
	        }
	      });
	    }
	    
	    if ( typeof(this.visible) === 'undefined' || this.visible !== newVisibility ){
	      this.visible = newVisibility;
	      if ( !fromRowProcessor ){
	        this.grid.queueGridRefresh();
	        this.grid.api.core.raise.rowsVisibleChanged(this);
	      }
	    }
	  };
	  
	
	  return GridRow;
	}]);
	
	})();
	
	(function(){
	  'use strict';
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridRowColumn
	   * @param {GridRow} row The row for this pair
	   * @param {GridColumn} column The column for this pair
	   * @description A row and column pair that represents the intersection of these two entities.
	   * Must be instantiated as a constructor using the `new` keyword.
	   */
	  angular.module('ui.grid')
	  .factory('GridRowColumn', ['$parse', '$filter',
	    function GridRowColumnFactory($parse, $filter){
	      var GridRowColumn = function GridRowColumn(row, col) {
	        if ( !(this instanceof GridRowColumn)){
	          throw "Using GridRowColumn as a function insead of as a constructor. Must be called with `new` keyword";
	        }
	
	        /**
	         * @ngdoc object
	         * @name row
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridRow }
	         */
	        this.row = row;
	        /**
	         * @ngdoc object
	         * @name col
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridColumn }
	         */
	        this.col = col;
	      };
	
	      /**
	       * @ngdoc function
	       * @name getIntersectionValueRaw
	       * @methodOf ui.grid.class:GridRowColumn
	       * @description Gets the intersection of where the row and column meet.
	       * @returns {String|Number|Object} The value from the grid data that this GridRowColumn points too.
	       *          If the column has a cellFilter this will NOT return the filtered value.
	       */
	      GridRowColumn.prototype.getIntersectionValueRaw = function(){
	        var getter = $parse(this.row.getEntityQualifiedColField(this.col));
	        var context = this.row;
	        return getter(context);
	      };
	      /**
	       * @ngdoc function
	       * @name getIntersectionValueFiltered
	       * @methodOf ui.grid.class:GridRowColumn
	       * @description Gets the intersection of where the row and column meet.
	       * @returns {String|Number|Object} The value from the grid data that this GridRowColumn points too.
	       *          If the column has a cellFilter this will also apply the filter to it and return the value that the filter displays.
	       */
	      GridRowColumn.prototype.getIntersectionValueFiltered = function(){
	        var value = this.getIntersectionValueRaw();
	        if (this.col.cellFilter && this.col.cellFilter !== ''){
	          var getFilterIfExists = function(filterName){
	            try {
	              return $filter(filterName);
	            } catch (e){
	              return null;
	            }
	          };
	          var filter = getFilterIfExists(this.col.cellFilter);
	          if (filter) { // Check if this is filter name or a filter string
	            value = filter(value);
	          } else { // We have the template version of a filter so we need to parse it apart
	            // Get the filter params out using a regex
	            // Test out this regex here https://regex101.com/r/rC5eR5/2
	            var re = /([^:]*):([^:]*):?([\s\S]+)?/;
	            var matches;
	            if ((matches = re.exec(this.col.cellFilter)) !== null) {
	                // View your result using the matches-variable.
	                // eg matches[0] etc.
	                value = $filter(matches[1])(value, matches[2], matches[3]);
	            }
	          }
	        }
	        return value;
	      };
	      return GridRowColumn;
	    }
	  ]);
	})();
	
	(function () {
	  angular.module('ui.grid')
	    .factory('ScrollEvent', ['gridUtil', function (gridUtil) {
	
	      /**
	       * @ngdoc function
	       * @name ui.grid.class:ScrollEvent
	       * @description Model for all scrollEvents
	       * @param {Grid} grid that owns the scroll event
	       * @param {GridRenderContainer} sourceRowContainer that owns the scroll event. Can be null
	       * @param {GridRenderContainer} sourceColContainer that owns the scroll event. Can be null
	       * @param {string} source the source of the event - from uiGridConstants.scrollEventSources or a string value of directive/service/factory.functionName
	       */
	      function ScrollEvent(grid, sourceRowContainer, sourceColContainer, source) {
	        var self = this;
	        if (!grid) {
	          throw new Error("grid argument is required");
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grid
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description A reference back to the grid
	         */
	         self.grid = grid;
	
	
	
	        /**
	         *  @ngdoc object
	         *  @name source
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description the source of the scroll event. limited to values from uiGridConstants.scrollEventSources
	         */
	        self.source = source;
	
	
	        /**
	         *  @ngdoc object
	         *  @name noDelay
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description most scroll events from the mouse or trackpad require delay to operate properly
	         *  set to false to eliminate delay.  Useful for scroll events that the grid causes, such as scrolling to make a row visible.
	         */
	        self.withDelay = true;
	
	        self.sourceRowContainer = sourceRowContainer;
	        self.sourceColContainer = sourceColContainer;
	
	        self.newScrollLeft = null;
	        self.newScrollTop = null;
	        self.x = null;
	        self.y = null;
	
	        self.verticalScrollLength = -9999999;
	        self.horizontalScrollLength = -999999;
	
	
	        /**
	         *  @ngdoc function
	         *  @name fireThrottledScrollingEvent
	         *  @methodOf  ui.grid.class:ScrollEvent
	         *  @description fires a throttled event using grid.api.core.raise.scrollEvent
	         */
	        self.fireThrottledScrollingEvent = gridUtil.throttle(function(sourceContainerId) {
	          self.grid.scrollContainers(sourceContainerId, self);
	        }, self.grid.options.wheelScrollThrottle, {trailing: true});
	
	      }
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollLeft
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollLeft property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollLeft = function(colContainer, viewport){
	        var self = this;
	
	        if (!self.newScrollLeft){
	          var scrollWidth = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
	
	          var oldScrollLeft = gridUtil.normalizeScrollLeft(viewport, self.grid);
	
	          var scrollXPercentage;
	          if (typeof(self.x.percentage) !== 'undefined' && self.x.percentage !== undefined) {
	            scrollXPercentage = self.x.percentage;
	          }
	          else if (typeof(self.x.pixels) !== 'undefined' && self.x.pixels !== undefined) {
	            scrollXPercentage = self.x.percentage = (oldScrollLeft + self.x.pixels) / scrollWidth;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event X axis");
	          }
	
	          return Math.max(0, scrollXPercentage * scrollWidth);
	        }
	
	        return self.newScrollLeft;
	      };
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollTop
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollTop property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollTop = function(rowContainer, viewport){
	        var self = this;
	
	
	        if (!self.newScrollTop){
	          var scrollLength = rowContainer.getVerticalScrollLength();
	
	          var oldScrollTop = viewport[0].scrollTop;
	
	          var scrollYPercentage;
	          if (typeof(self.y.percentage) !== 'undefined' && self.y.percentage !== undefined) {
	            scrollYPercentage = self.y.percentage;
	          }
	          else if (typeof(self.y.pixels) !== 'undefined' && self.y.pixels !== undefined) {
	            scrollYPercentage = self.y.percentage = (oldScrollTop + self.y.pixels) / scrollLength;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event Y axis");
	          }
	
	          return Math.max(0, scrollYPercentage * scrollLength);
	        }
	
	        return self.newScrollTop;
	      };
	
	      ScrollEvent.prototype.atTop = function(scrollTop) {
	        return (this.y && (this.y.percentage === 0 || this.verticalScrollLength < 0) && scrollTop === 0);
	      };
	
	      ScrollEvent.prototype.atBottom = function(scrollTop) {
	        return (this.y && (this.y.percentage === 1 || this.verticalScrollLength === 0) && scrollTop > 0);
	      };
	
	      ScrollEvent.prototype.atLeft = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 0 || this.horizontalScrollLength < 0) && scrollLeft === 0);
	      };
	
	      ScrollEvent.prototype.atRight = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 1 || this.horizontalScrollLength ===0) && scrollLeft > 0);
	      };
	
	
	      ScrollEvent.Sources = {
	        ViewPortScroll: 'ViewPortScroll',
	        RenderContainerMouseWheel: 'RenderContainerMouseWheel',
	        RenderContainerTouchMove: 'RenderContainerTouchMove',
	        Other: 99
	      };
	
	      return ScrollEvent;
	    }]);
	
	
	
	})();
	
	(function () {
	  'use strict';
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.service:gridClassFactory
	   *
	   *  @description factory to return dom specific instances of a grid
	   *
	   */
	  angular.module('ui.grid').service('gridClassFactory', ['gridUtil', '$q', '$compile', '$templateCache', 'uiGridConstants', 'Grid', 'GridColumn', 'GridRow',
	    function (gridUtil, $q, $compile, $templateCache, uiGridConstants, Grid, GridColumn, GridRow) {
	
	      var service = {
	        /**
	         * @ngdoc method
	         * @name createGrid
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Creates a new grid instance. Each instance will have a unique id
	         * @param {object} options An object map of options to pass into the created grid instance.
	         * @returns {Grid} grid
	         */
	        createGrid : function(options) {
	          options = (typeof(options) !== 'undefined') ? options : {};
	          options.id = gridUtil.newId();
	          var grid = new Grid(options);
	
	          // NOTE/TODO: rowTemplate should always be defined...
	          if (grid.options.rowTemplate) {
	            var rowTemplateFnPromise = $q.defer();
	            grid.getRowTemplateFn = rowTemplateFnPromise.promise;
	            
	            gridUtil.getTemplate(grid.options.rowTemplate)
	              .then(
	                function (template) {
	                  var rowTemplateFn = $compile(template);
	                  rowTemplateFnPromise.resolve(rowTemplateFn);
	                },
	                function (res) {
	                  // Todo handle response error here?
	                  throw new Error("Couldn't fetch/use row template '" + grid.options.rowTemplate + "'");
	                });
	          }
	
	          grid.registerColumnBuilder(service.defaultColumnBuilder);
	
	          // Row builder for custom row templates
	          grid.registerRowBuilder(service.rowTemplateAssigner);
	
	          // Reset all rows to visible initially
	          grid.registerRowsProcessor(function allRowsVisible(rows) {
	            rows.forEach(function (row) {
	              row.evaluateRowVisibility( true );
	            }, 50);
	
	            return rows;
	          });
	
	          grid.registerColumnsProcessor(function allColumnsVisible(columns) {
	            columns.forEach(function (column) {
	              column.visible = true;
	            });
	
	            return columns;
	          }, 50);
	
	          grid.registerColumnsProcessor(function(renderableColumns) {
	              renderableColumns.forEach(function (column) {
	                  if (column.colDef.visible === false) {
	                      column.visible = false;
	                  }
	              });
	
	              return renderableColumns;
	          }, 50);
	
	
	          grid.registerRowsProcessor(grid.searchRows, 100);
	
	          // Register the default row processor, it sorts rows by selected columns
	          if (grid.options.externalSort && angular.isFunction(grid.options.externalSort)) {
	            grid.registerRowsProcessor(grid.options.externalSort, 200);
	          }
	          else {
	            grid.registerRowsProcessor(grid.sortByColumn, 200);
	          }
	
	          return grid;
	        },
	
	        /**
	         * @ngdoc function
	         * @name defaultColumnBuilder
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Processes designTime column definitions and applies them to col for the
	         *              core grid features
	         * @param {object} colDef reference to column definition
	         * @param {GridColumn} col reference to gridCol
	         * @param {object} gridOptions reference to grid options
	         */
	        defaultColumnBuilder: function (colDef, col, gridOptions) {
	
	          var templateGetPromises = [];
	
	          // Abstracts the standard template processing we do for every template type.
	          var processTemplate = function( templateType, providedType, defaultTemplate, filterType, tooltipType ) {
	            if ( !colDef[templateType] ){
	              col[providedType] = defaultTemplate;
	            } else {
	              col[providedType] = colDef[templateType];
	            }
	 
	             templateGetPromises.push(gridUtil.getTemplate(col[providedType])
	                .then(
	                function (template) {
	                  if ( angular.isFunction(template) ) { template = template(); }
	                  var tooltipCall = ( tooltipType === 'cellTooltip' ) ? 'col.cellTooltip(row,col)' : 'col.headerTooltip(col)';
	                  if ( tooltipType && col[tooltipType] === false ){
	                    template = template.replace(uiGridConstants.TOOLTIP, '');
	                  } else if ( tooltipType && col[tooltipType] ){
	                    template = template.replace(uiGridConstants.TOOLTIP, 'title="{{' + tooltipCall + ' CUSTOM_FILTERS }}"');
	                  }
	
	                  if ( filterType ){
	                    col[templateType] = template.replace(uiGridConstants.CUSTOM_FILTERS, function() {
	                      return col[filterType] ? "|" + col[filterType] : "";
	                    });
	                  } else {
	                    col[templateType] = template;
	                  }
	                },
	                function (res) {
	                  throw new Error("Couldn't fetch/use colDef." + templateType + " '" + colDef[templateType] + "'");
	                })
	            );
	
	          };
	
	
	          /**
	           * @ngdoc property
	           * @name cellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for each cell in this column.  The default
	           * is ui-grid/uiGridCell.  If you are using the cellNav feature, this template
	           * must contain a div that can receive focus.
	           *
	           */
	          processTemplate( 'cellTemplate', 'providedCellTemplate', 'ui-grid/uiGridCell', 'cellFilter', 'cellTooltip' );
	          col.cellTemplatePromise = templateGetPromises[0];
	
	          /**
	           * @ngdoc property
	           * @name headerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the header for this column.  The default
	           * is ui-grid/uiGridHeaderCell
	           *
	           */
	          processTemplate( 'headerCellTemplate', 'providedHeaderCellTemplate', 'ui-grid/uiGridHeaderCell', 'headerCellFilter', 'headerTooltip' );
	
	          /**
	           * @ngdoc property
	           * @name footerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the footer for this column.  The default
	           * is ui-grid/uiGridFooterCell
	           *
	           */
	          processTemplate( 'footerCellTemplate', 'providedFooterCellTemplate', 'ui-grid/uiGridFooterCell', 'footerCellFilter' );
	
	          /**
	           * @ngdoc property
	           * @name filterHeaderTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the filter input.  The default is ui-grid/ui-grid-filter
	           *
	           */
	          processTemplate( 'filterHeaderTemplate', 'providedFilterHeaderTemplate', 'ui-grid/ui-grid-filter' );
	
	          // Create a promise for the compiled element function
	          col.compiledElementFnDefer = $q.defer();
	
	          return $q.all(templateGetPromises);
	        },
	        
	
	        rowTemplateAssigner: function rowTemplateAssigner(row) {
	          var grid = this;
	
	          // Row has no template assigned to it
	          if (!row.rowTemplate) {
	            // Use the default row template from the grid
	            row.rowTemplate = grid.options.rowTemplate;
	
	            // Use the grid's function for fetching the compiled row template function
	            row.getRowTemplateFn = grid.getRowTemplateFn;
	          }
	          // Row has its own template assigned
	          else {
	            // Create a promise for the compiled row template function
	            var perRowTemplateFnPromise = $q.defer();
	            row.getRowTemplateFn = perRowTemplateFnPromise.promise;
	
	            // Get the row template
	            gridUtil.getTemplate(row.rowTemplate)
	              .then(function (template) {
	                // Compile the template
	                var rowTemplateFn = $compile(template);
	                
	                // Resolve the compiled template function promise
	                perRowTemplateFnPromise.resolve(rowTemplateFn);
	              },
	              function (res) {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use row template '" + row.rowTemplate + "'");
	              });
	          }
	
	          return row.getRowTemplateFn;
	        }
	      };
	
	      //class definitions (moved to separate factories)
	
	      return service;
	    }]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
	
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:rowSearcher
	 *
	 *  @description Service for searching/filtering rows based on column value conditions.
	 */
	module.service('rowSearcher', ['gridUtil', 'uiGridConstants', function (gridUtil, uiGridConstants) {
	  var defaultCondition = uiGridConstants.filter.CONTAINS;
	
	  var rowSearcher = {};
	
	  /**
	   * @ngdoc function
	   * @name getTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Get the term from a filter
	   * Trims leading and trailing whitespace
	   * @param {object} filter object to use
	   * @returns {object} Parsed term
	   */
	  rowSearcher.getTerm = function getTerm(filter) {
	    if (typeof(filter.term) === 'undefined') { return filter.term; }
	    
	    var term = filter.term;
	
	    // Strip leading and trailing whitespace if the term is a string
	    if (typeof(term) === 'string') {
	      term = term.trim();
	    }
	
	    return term;
	  };
	
	  /**
	   * @ngdoc function
	   * @name stripTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Remove leading and trailing asterisk (*) from the filter's term
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.stripTerm = function stripTerm(filter) {
	    var term = rowSearcher.getTerm(filter);
	
	    if (typeof(term) === 'string') {
	      return escapeRegExp(term.replace(/(^\*|\*$)/g, ''));
	    }
	    else {
	      return term;
	    }
	  };
	  
	
	  /**
	   * @ngdoc function
	   * @name guessCondition
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Guess the condition for a filter based on its term
	   * <br>
	   * Defaults to STARTS_WITH. Uses CONTAINS for strings beginning and ending with *s (*bob*).
	   * Uses STARTS_WITH for strings ending with * (bo*). Uses ENDS_WITH for strings starting with * (*ob).
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.guessCondition = function guessCondition(filter) {
	    if (typeof(filter.term) === 'undefined' || !filter.term) {
	      return defaultCondition;
	    }
	
	    var term = rowSearcher.getTerm(filter);
	    
	    if (/\*/.test(term)) {
	      var regexpFlags = '';
	      if (!filter.flags || !filter.flags.caseSensitive) {
	        regexpFlags += 'i';
	      }
	
	      var reText = term.replace(/(\\)?\*/g, function ($0, $1) { return $1 ? $0 : '[\\s\\S]*?'; });
	      return new RegExp('^' + reText + '$', regexpFlags);
	    }
	    // Otherwise default to default condition
	    else {
	      return defaultCondition;
	    }
	  };
	  
	  
	  /**
	   * @ngdoc function
	   * @name setupFilters
	   * @methodOf ui.grid.service:rowSearcher
	   * @description For a given columns filters (either col.filters, or [col.filter] can be passed in),
	   * do all the parsing and pre-processing and store that data into a new filters object.  The object
	   * has the condition, the flags, the stripped term, and a parsed reg exp if there was one.
	   * 
	   * We could use a forEach in here, since it's much less performance sensitive, but since we're using 
	   * for loops everywhere else in this module...
	   * 
	   * @param {array} filters the filters from the column (col.filters or [col.filter])
	   * @returns {array} An array of parsed/preprocessed filters
	   */
	  rowSearcher.setupFilters = function setupFilters( filters ){
	    var newFilters = [];
	    
	    var filtersLength = filters.length;
	    for ( var i = 0; i < filtersLength; i++ ){
	      var filter = filters[i];
	      
	      if ( filter.noTerm || !gridUtil.isNullOrUndefined(filter.term) ){
	        var newFilter = {};
	        
	        var regexpFlags = '';
	        if (!filter.flags || !filter.flags.caseSensitive) {
	          regexpFlags += 'i';
	        }
	    
	        if ( !gridUtil.isNullOrUndefined(filter.term) ){
	          // it is possible to have noTerm.  We don't need to copy that across, it was just a flag to avoid
	          // getting the filter ignored if the filter was a function that didn't use a term
	          newFilter.term = rowSearcher.stripTerm(filter);
	        }
	        
	        if ( filter.condition ){
	          newFilter.condition = filter.condition;
	        } else {
	          newFilter.condition = rowSearcher.guessCondition(filter);
	        }
	
	        newFilter.flags = angular.extend( { caseSensitive: false, date: false }, filter.flags );
	
	        if (newFilter.condition === uiGridConstants.filter.STARTS_WITH) {
	          newFilter.startswithRE = new RegExp('^' + newFilter.term, regexpFlags);
	        }
	        
	         if (newFilter.condition === uiGridConstants.filter.ENDS_WITH) {
	          newFilter.endswithRE = new RegExp(newFilter.term + '$', regexpFlags);
	        }
	
	        if (newFilter.condition === uiGridConstants.filter.CONTAINS) {
	          newFilter.containsRE = new RegExp(newFilter.term, regexpFlags);
	        }
	
	        if (newFilter.condition === uiGridConstants.filter.EXACT) {
	          newFilter.exactRE = new RegExp('^' + newFilter.term + '$', regexpFlags);
	        }
	        
	        newFilters.push(newFilter);
	      }
	    }
	    return newFilters;
	  };
	  
	
	  /**
	   * @ngdoc function
	   * @name runColumnFilter
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Runs a single pre-parsed filter against a cell, returning true
	   * if the cell matches that one filter.
	   * 
	   * @param {Grid} grid the grid we're working against
	   * @param {GridRow} row the row we're matching against
	   * @param {GridCol} column the column that we're working against
	   * @param {object} filter the specific, preparsed, filter that we want to test
	   * @returns {boolean} true if we match (row stays visible)
	   */
	  rowSearcher.runColumnFilter = function runColumnFilter(grid, row, column, filter) {
	    // Cache typeof condition
	    var conditionType = typeof(filter.condition);
	
	    // Term to search for.
	    var term = filter.term;
	
	    // Get the column value for this row
	    var value;
	    if ( column.filterCellFiltered ){
	      value = grid.getCellDisplayValue(row, column);
	    } else {
	      value = grid.getCellValue(row, column);
	    }
	
	
	    // If the filter's condition is a RegExp, then use it
	    if (filter.condition instanceof RegExp) {
	      return filter.condition.test(value);
	    }
	
	    // If the filter's condition is a function, run it
	    if (conditionType === 'function') {
	      return filter.condition(term, value, row, column);
	    }
	
	    if (filter.startswithRE) {
	      return filter.startswithRE.test(value);
	    }
	
	    if (filter.endswithRE) {
	      return filter.endswithRE.test(value);
	    }
	
	    if (filter.containsRE) {
	      return filter.containsRE.test(value);
	    }
	
	    if (filter.exactRE) {
	      return filter.exactRE.test(value);
	    }
	
	    if (filter.condition === uiGridConstants.filter.NOT_EQUAL) {
	      var regex = new RegExp('^' + term + '$');
	      return !regex.exec(value);
	    }
	
	    if (typeof(value) === 'number' && typeof(term) === 'string' ){
	      // if the term has a decimal in it, it comes through as '9\.4', we need to take out the \
	      // the same for negative numbers
	      // TODO: I suspect the right answer is to look at escapeRegExp at the top of this code file, maybe it's not needed?
	      var tempFloat = parseFloat(term.replace(/\\\./,'.').replace(/\\\-/,'-'));
	      if (!isNaN(tempFloat)) {
	        term = tempFloat;
	      }
	    }
	
	    if (filter.flags.date === true) {
	      value = new Date(value);
	      // If the term has a dash in it, it comes through as '\-' -- we need to take out the '\'.
	      term = new Date(term.replace(/\\/g, ''));
	    }
	
	    if (filter.condition === uiGridConstants.filter.GREATER_THAN) {
	      return (value > term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.GREATER_THAN_OR_EQUAL) {
	      return (value >= term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.LESS_THAN) {
	      return (value < term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.LESS_THAN_OR_EQUAL) {
	      return (value <= term);
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc boolean
	   * @name useExternalFiltering
	   * @propertyOf ui.grid.class:GridOptions
	   * @description False by default. When enabled, this setting suppresses the internal filtering.
	   * All UI logic will still operate, allowing filter conditions to be set and modified.
	   * 
	   * The external filter logic can listen for the `filterChange` event, which fires whenever
	   * a filter has been adjusted.
	   */
	  /**
	   * @ngdoc function
	   * @name searchColumn
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Process provided filters on provided column against a given row. If the row meets 
	   * the conditions on all the filters, return true.
	   * @param {Grid} grid Grid to search in
	   * @param {GridRow} row Row to search on
	   * @param {GridCol} column Column with the filters to use
	   * @param {array} filters array of pre-parsed/preprocessed filters to apply
	   * @returns {boolean} Whether the column matches or not.
	   */
	  rowSearcher.searchColumn = function searchColumn(grid, row, column, filters) {
	    if (grid.options.useExternalFiltering) {
	      return true;
	    }
	
	    var filtersLength = filters.length;
	    for (var i = 0; i < filtersLength; i++) {
	      var filter = filters[i];
	
	      var ret = rowSearcher.runColumnFilter(grid, row, column, filter);
	      if (!ret) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name search
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Run a search across the given rows and columns, marking any rows that don't 
	   * match the stored col.filters or col.filter as invisible.
	   * @param {Grid} grid Grid instance to search inside
	   * @param {Array[GridRow]} rows GridRows to filter
	   * @param {Array[GridColumn]} columns GridColumns with filters to process
	   */
	  rowSearcher.search = function search(grid, rows, columns) {
	    /*
	     * Added performance optimisations into this code base, as this logic creates deeply nested
	     * loops and is therefore very performance sensitive.  In particular, avoiding forEach as
	     * this impacts some browser optimisers (particularly Chrome), using iterators instead
	     */
	
	    // Don't do anything if we weren't passed any rows
	    if (!rows) {
	      return;
	    }
	
	    // don't filter if filtering currently disabled
	    if (!grid.options.enableFiltering){
	      return rows;
	    }
	
	    // Build list of filters to apply
	    var filterData = [];
	
	    var colsLength = columns.length;
	
	    var hasTerm = function( filters ) {
	      var hasTerm = false;
	
	      filters.forEach( function (filter) {
	        if ( !gridUtil.isNullOrUndefined(filter.term) && filter.term !== '' || filter.noTerm ){
	          hasTerm = true;
	        }
	      });
	
	      return hasTerm;
	    };
	
	    for (var i = 0; i < colsLength; i++) {
	      var col = columns[i];
	
	      if (typeof(col.filters) !== 'undefined' && hasTerm(col.filters) ) {
	        filterData.push( { col: col, filters: rowSearcher.setupFilters(col.filters) } );
	      }
	    }
	
	    if (filterData.length > 0) {
	      // define functions outside the loop, performance optimisation
	      var foreachRow = function(grid, row, col, filters){
	        if ( row.visible && !rowSearcher.searchColumn(grid, row, col, filters) ) {
	          row.visible = false;
	        }
	      };
	
	      var foreachFilterCol = function(grid, filterData){
	        var rowsLength = rows.length;
	        for ( var i = 0; i < rowsLength; i++){
	          foreachRow(grid, rows[i], filterData.col, filterData.filters);  
	        }
	      };
	
	      // nested loop itself - foreachFilterCol, which in turn calls foreachRow
	      var filterDataLength = filterData.length;
	      for ( var j = 0; j < filterDataLength; j++){
	        foreachFilterCol( grid, filterData[j] );  
	      }
	
	      if (grid.api.core.raise.rowsVisibleChanged) {
	        grid.api.core.raise.rowsVisibleChanged();
	      }
	
	      // drop any invisible rows
	      // keeping these, as needed with filtering for trees - we have to come back and make parent nodes visible if child nodes are selected in the filter
	      // rows = rows.filter(function(row){ return row.visible; });
	
	    }
	
	    return rows;
	  };
	
	  return rowSearcher;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	/**
	 * @ngdoc object
	 * @name ui.grid.class:RowSorter
	 * @description RowSorter provides the default sorting mechanisms, 
	 * including guessing column types and applying appropriate sort 
	 * algorithms
	 * 
	 */ 
	
	module.service('rowSorter', ['$parse', 'uiGridConstants', function ($parse, uiGridConstants) {
	  var currencyRegexStr = 
	    '(' +
	    uiGridConstants.CURRENCY_SYMBOLS
	      .map(function (a) { return '\\' + a; }) // Escape all the currency symbols ($ at least will jack up this regex)
	      .join('|') + // Join all the symbols together with |s
	    ')?';
	
	  // /^[-+]?[£$¤¥]?[\d,.]+%?$/
	  var numberStrRegex = new RegExp('^[-+]?' + currencyRegexStr + '[\\d,.]+' + currencyRegexStr + '%?$');
	
	  var rowSorter = {
	    // Cache of sorting functions. Once we create them, we don't want to keep re-doing it
	    //   this takes a piece of data from the cell and tries to determine its type and what sorting
	    //   function to use for it
	    colSortFnCache: {}
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name guessSortFn
	   * @description Assigns a sort function to use based on the itemType in the column
	   * @param {string} itemType one of 'number', 'boolean', 'string', 'date', 'object'.  And
	   * error will be thrown for any other type.
	   * @returns {function} a sort function that will sort that type
	   */
	  rowSorter.guessSortFn = function guessSortFn(itemType) {
	    switch (itemType) {
	      case "number":
	        return rowSorter.sortNumber;
	      case "numberStr":
	        return rowSorter.sortNumberStr;
	      case "boolean":
	        return rowSorter.sortBool;
	      case "string":
	        return rowSorter.sortAlpha;
	      case "date":
	        return rowSorter.sortDate;
	      case "object":
	        return rowSorter.basicSort;
	      default:
	        throw new Error('No sorting function found for type:' + itemType);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name handleNulls
	   * @description Sorts nulls and undefined to the bottom (top when
	   * descending).  Called by each of the internal sorters before
	   * attempting to sort.  Note that this method is available on the core api
	   * via gridApi.core.sortHandleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} null if there were no nulls/undefineds, otherwise returns
	   * a sort value that should be passed back from the sort function
	   */
	  rowSorter.handleNulls = function handleNulls(a, b) {
	    // We want to allow zero values and false values to be evaluated in the sort function
	    if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
	      // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
	      if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
	        return 0;
	      }
	      else if (!a && a !== 0 && a !== false) {
	        return 1;
	      }
	      else if (!b && b !== 0 && b !== false) {
	        return -1;
	      }
	    }
	    return null;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name basicSort
	   * @description Sorts any values that provide the < method, including strings
	   * or numbers.  Handles nulls and undefined through calling handleNulls 
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.basicSort = function basicSort(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      if (a === b) {
	        return 0;
	      }
	      if (a < b) {
	        return -1;
	      }
	      return 1;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name sortNumber
	   * @description Sorts numerical values.  Handles nulls and undefined through calling handleNulls 
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumber = function sortNumber(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      return a - b;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name sortNumberStr
	   * @description Sorts numerical values that are stored in a string (i.e. parses them to numbers first).  
	   * Handles nulls and undefined through calling handleNulls 
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumberStr = function sortNumberStr(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      var numA, // The parsed number form of 'a'
	          numB, // The parsed number form of 'b'
	          badA = false,
	          badB = false;
	  
	      // Try to parse 'a' to a float
	      numA = parseFloat(a.replace(/[^0-9.-]/g, ''));
	  
	      // If 'a' couldn't be parsed to float, flag it as bad
	      if (isNaN(numA)) {
	          badA = true;
	      }
	  
	      // Try to parse 'b' to a float
	      numB = parseFloat(b.replace(/[^0-9.-]/g, ''));
	  
	      // If 'b' couldn't be parsed to float, flag it as bad
	      if (isNaN(numB)) {
	          badB = true;
	      }
	  
	      // We want bad ones to get pushed to the bottom... which effectively is "greater than"
	      if (badA && badB) {
	          return 0;
	      }
	  
	      if (badA) {
	          return 1;
	      }
	  
	      if (badB) {
	          return -1;
	      }
	  
	      return numA - numB;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name sortAlpha
	   * @description Sorts string values. Handles nulls and undefined through calling handleNulls 
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortAlpha = function sortAlpha(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      var strA = a.toString().toLowerCase(),
	          strB = b.toString().toLowerCase();
	  
	      return strA === strB ? 0 : (strA < strB ? -1 : 1);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name sortDate
	   * @description Sorts date values. Handles nulls and undefined through calling handleNulls.
	   * Handles date strings by converting to Date object if not already an instance of Date
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortDate = function sortDate(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      if (!(a instanceof Date)) {
	        a = new Date(a);
	      }
	      if (!(b instanceof Date)){
	        b = new Date(b);
	      }
	      var timeA = a.getTime(),
	          timeB = b.getTime();
	  
	      return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name sortBool
	   * @description Sorts boolean values, true is considered larger than false. 
	   * Handles nulls and undefined through calling handleNulls 
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortBool = function sortBool(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      if (a && b) {
	        return 0;
	      }
	  
	      if (!a && !b) {
	        return 0;
	      }
	      else {
	        return a ? 1 : -1;
	      }
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name getSortFn
	   * @description Get the sort function for the column.  Looks first in 
	   * rowSorter.colSortFnCache using the column name, failing that it
	   * looks at col.sortingAlgorithm (and puts it in the cache), failing that
	   * it guesses the sort algorithm based on the data type.
	   * 
	   * The cache currently seems a bit pointless, as none of the work we do is
	   * processor intensive enough to need caching.  Presumably in future we might
	   * inspect the row data itself to guess the sort function, and in that case
	   * it would make sense to have a cache, the infrastructure is in place to allow
	   * that.
	   * 
	   * @param {Grid} grid the grid to consider
	   * @param {GridCol} col the column to find a function for
	   * @param {array} rows an array of grid rows.  Currently unused, but presumably in future
	   * we might inspect the rows themselves to decide what sort of data might be there
	   * @returns {function} the sort function chosen for the column
	   */
	  rowSorter.getSortFn = function getSortFn(grid, col, rows) {
	    var sortFn, item;
	
	    // See if we already figured out what to use to sort the column and have it in the cache
	    if (rowSorter.colSortFnCache[col.colDef.name]) {
	      sortFn = rowSorter.colSortFnCache[col.colDef.name];
	    }
	    // If the column has its OWN sorting algorithm, use that
	    else if (col.sortingAlgorithm !== undefined) {
	      sortFn = col.sortingAlgorithm;
	      rowSorter.colSortFnCache[col.colDef.name] = col.sortingAlgorithm;
	    }
	    // Always default to sortAlpha when sorting after a cellFilter
	    else if ( col.sortCellFiltered && col.cellFilter ){
	      sortFn = rowSorter.sortAlpha;
	      rowSorter.colSortFnCache[col.colDef.name] = sortFn;
	    }
	    // Try and guess what sort function to use
	    else {
	      // Guess the sort function
	      sortFn = rowSorter.guessSortFn(col.colDef.type);
	
	      // If we found a sort function, cache it
	      if (sortFn) {
	        rowSorter.colSortFnCache[col.colDef.name] = sortFn;
	      }
	      else {
	        // We assign the alpha sort because anything that is null/undefined will never get passed to
	        // the actual sorting function. It will get caught in our null check and returned to be sorted
	        // down to the bottom
	        sortFn = rowSorter.sortAlpha;
	      }
	    }
	
	    return sortFn;
	  };
	
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name prioritySort
	   * @description Used where multiple columns are present in the sort criteria,
	   * we determine which column should take precedence in the sort by sorting
	   * the columns based on their sort.priority
	   * 
	   * @param {gridColumn} a column a
	   * @param {gridColumn} b column b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.prioritySort = function (a, b) {
	    // Both columns have a sort priority
	    if (a.sort.priority !== undefined && b.sort.priority !== undefined) {
	      // A is higher priority
	      if (a.sort.priority < b.sort.priority) {
	        return -1;
	      }
	      // Equal
	      else if (a.sort.priority === b.sort.priority) {
	        return 0;
	      }
	      // B is higher
	      else {
	        return 1;
	      }
	    }
	    // Only A has a priority
	    else if (a.sort.priority || a.sort.priority === 0) {
	      return -1;
	    }
	    // Only B has a priority
	    else if (b.sort.priority || b.sort.priority === 0) {
	      return 1;
	    }
	    // Neither has a priority
	    else {
	      return 0;
	    }
	  };
	
	
	  /**
	   * @ngdoc object
	   * @name useExternalSorting
	   * @propertyOf ui.grid.class:GridOptions
	   * @description Prevents the internal sorting from executing.  Events will
	   * still be fired when the sort changes, and the sort information on
	   * the columns will be updated, allowing an external sorter (for example,
	   * server sorting) to be implemented.  Defaults to false. 
	   * 
	   */
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:RowSorter
	   * @name sort
	   * @description sorts the grid 
	   * @param {Object} grid the grid itself
	   * @param {array} rows the rows to be sorted
	   * @param {array} columns the columns in which to look
	   * for sort criteria
	   * @returns {array} sorted rows
	   */
	  rowSorter.sort = function rowSorterSort(grid, rows, columns) {
	    // first make sure we are even supposed to do work
	    if (!rows) {
	      return;
	    }
	    
	    if (grid.options.useExternalSorting){
	      return rows;
	    }
	
	    // Build the list of columns to sort by
	    var sortCols = [];
	    columns.forEach(function (col) {
	      if (col.sort && !col.sort.ignoreSort && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortCols.push(col);
	      }
	    });
	
	    // Sort the "sort columns" by their sort priority
	    sortCols = sortCols.sort(rowSorter.prioritySort);
	
	    // Now rows to sort by, maintain original order
	    if (sortCols.length === 0) {
	      return rows;
	    }
	
	    // Re-usable variables
	    var col, direction;
	
	    // put a custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    var setIndex = function( row, idx ){
	      row.entity.$$uiGridIndex = idx;
	    };
	    rows.forEach(setIndex);
	
	    // IE9-11 HACK.... the 'rows' variable would be empty where we call rowSorter.getSortFn(...) below. We have to use a separate reference
	    // var d = data.slice(0);
	    var r = rows.slice(0);
	
	    // Now actually sort the data
	    var rowSortFn = function (rowA, rowB) {
	      var tem = 0,
	          idx = 0,
	          sortFn;
	
	      while (tem === 0 && idx < sortCols.length) {
	        // grab the metadata for the rest of the logic
	        col = sortCols[idx];
	        direction = sortCols[idx].sort.direction;
	
	        sortFn = rowSorter.getSortFn(grid, col, r);
	
	        var propA, propB;
	
	        if ( col.sortCellFiltered ){
	          propA = grid.getCellDisplayValue(rowA, col);
	          propB = grid.getCellDisplayValue(rowB, col);
	        } else {
	          propA = grid.getCellValue(rowA, col);
	          propB = grid.getCellValue(rowB, col);
	        }
	
	        tem = sortFn(propA, propB, rowA, rowB, direction);
	
	        idx++;
	      }
	
	      // Chrome doesn't implement a stable sort function.  If our sort returns 0 
	      // (i.e. the items are equal), and we're at the last sort column in the list,
	      // then return the previous order using our custom
	      // index variable
	      if (tem === 0 ) {
	        return rowA.entity.$$uiGridIndex - rowB.entity.$$uiGridIndex;
	      }
	
	      // Made it this far, we don't have to worry about null & undefined
	      if (direction === uiGridConstants.ASC) {
	        return tem;
	      } else {
	        return 0 - tem;
	      }
	    };
	
	    var newRows = rows.sort(rowSortFn);
	    
	    // remove the custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    var clearIndex = function( row, idx ){
	       delete row.entity.$$uiGridIndex;
	    };
	    rows.forEach(clearIndex);
	    
	    return newRows;
	  };
	
	  return rowSorter;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	var bindPolyfill;
	if (typeof Function.prototype.bind !== "function") {
	  bindPolyfill = function() {
	    var slice = Array.prototype.slice;
	    return function(context) {
	      var fn = this,
	        args = slice.call(arguments, 1);
	      if (args.length) {
	        return function() {
	          return arguments.length ? fn.apply(context, args.concat(slice.call(arguments))) : fn.apply(context, args);
	        };
	      }
	      return function() {
	        return arguments.length ? fn.apply(context, arguments) : fn.call(context);
	      };
	    };
	  };
	}
	
	function getStyles (elem) {
	  var e = elem;
	  if (typeof(e.length) !== 'undefined' && e.length) {
	    e = elem[0];
	  }
	
	  return e.ownerDocument.defaultView.getComputedStyle(e, null);
	}
	
	var rnumnonpx = new RegExp( "^(" + (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source + ")(?!px)[a-z%]+$", "i" ),
	    // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	    // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	    rdisplayswap = /^(block|none|table(?!-c[ea]).+)/,
	    cssShow = { position: "absolute", visibility: "hidden", display: "block" };
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	  var i = extra === ( isBorderBox ? 'border' : 'content' ) ?
	          // If we already have the right measurement, avoid augmentation
	          4 :
	          // Otherwise initialize for horizontal or vertical properties
	          name === 'width' ? 1 : 0,
	
	          val = 0;
	
	  var sides = ['Top', 'Right', 'Bottom', 'Left'];
	
	  for ( ; i < 4; i += 2 ) {
	    var side = sides[i];
	    // dump('side', side);
	
	    // both box models exclude margin, so add it if we want it
	    if ( extra === 'margin' ) {
	      var marg = parseFloat(styles[extra + side]);
	      if (!isNaN(marg)) {
	        val += marg;
	      }
	    }
	    // dump('val1', val);
	
	    if ( isBorderBox ) {
	      // border-box includes padding, so remove it if we want content
	      if ( extra === 'content' ) {
	        var padd = parseFloat(styles['padding' + side]);
	        if (!isNaN(padd)) {
	          val -= padd;
	          // dump('val2', val);
	        }
	      }
	
	      // at this point, extra isn't border nor margin, so remove border
	      if ( extra !== 'margin' ) {
	        var bordermarg = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(bordermarg)) {
	          val -= bordermarg;
	          // dump('val3', val);
	        }
	      }
	    }
	    else {
	      // at this point, extra isn't content, so add padding
	      var nocontentPad = parseFloat(styles['padding' + side]);
	      if (!isNaN(nocontentPad)) {
	        val += nocontentPad;
	        // dump('val4', val);
	      }
	
	      // at this point, extra isn't content nor padding, so add border
	      if ( extra !== 'padding') {
	        var nocontentnopad = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(nocontentnopad)) {
	          val += nocontentnopad;
	          // dump('val5', val);
	        }
	      }
	    }
	  }
	
	  // dump('augVal', val);
	
	  return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	  // Start with offset property, which is equivalent to the border-box value
	  var valueIsBorderBox = true,
	          val, // = name === 'width' ? elem.offsetWidth : elem.offsetHeight,
	          styles = getStyles(elem),
	          isBorderBox = styles['boxSizing'] === 'border-box';
	
	  // some non-html elements return undefined for offsetWidth, so check for null/undefined
	  // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	  // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	  if ( val <= 0 || val == null ) {
	    // Fall back to computed then uncomputed css if necessary
	    val = styles[name];
	    if ( val < 0 || val == null ) {
	      val = elem.style[ name ];
	    }
	
	    // Computed unit is not pixels. Stop here and return.
	    if ( rnumnonpx.test(val) ) {
	      return val;
	    }
	
	    // we need the check for style in case a browser which returns unreliable values
	    // for getComputedStyle silently falls back to the reliable elem.style
	    valueIsBorderBox = isBorderBox &&
	            ( true || val === elem.style[ name ] ); // use 'true' instead of 'support.boxSizingReliable()'
	
	    // Normalize "", auto, and prepare for extra
	    val = parseFloat( val ) || 0;
	  }
	
	  // use the active box-sizing model to add/subtract irrelevant styles
	  var ret = ( val +
	    augmentWidthOrHeight(
	      elem,
	      name,
	      extra || ( isBorderBox ? "border" : "content" ),
	      valueIsBorderBox,
	      styles
	    )
	  );
	
	  // dump('ret', ret, val);
	  return ret;
	}
	
	function getLineHeight(elm) {
	  elm = angular.element(elm)[0];
	  var parent = elm.parentElement;
	
	  if (!parent) {
	    parent = document.getElementsByTagName('body')[0];
	  }
	
	  return parseInt( getStyles(parent).fontSize ) || parseInt( getStyles(elm).fontSize ) || 16;
	}
	
	var uid = ['0', '0', '0', '0'];
	var uidPrefix = 'uiGrid-';
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:GridUtil
	 *
	 *  @description Grid utility functions
	 */
	module.service('gridUtil', ['$log', '$window', '$document', '$http', '$templateCache', '$timeout', '$interval', '$injector', '$q', '$interpolate', 'uiGridConstants',
	  function ($log, $window, $document, $http, $templateCache, $timeout, $interval, $injector, $q, $interpolate, uiGridConstants) {
	  var s = {
	
	    augmentWidthOrHeight: augmentWidthOrHeight,
	
	    getStyles: getStyles,
	
	    /**
	     * @ngdoc method
	     * @name createBoundedWrapper
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {object} Object to bind 'this' to
	     * @param {method} Method to bind
	     * @returns {Function} The wrapper that performs the binding
	     *
	     * @description
	     * Binds given method to given object.
	     *
	     * By means of a wrapper, ensures that ``method`` is always bound to
	     * ``object`` regardless of its calling environment.
	     * Iow, inside ``method``, ``this`` always points to ``object``.
	     *
	     * See http://alistapart.com/article/getoutbindingsituations
	     *
	     */
	    createBoundedWrapper: function(object, method) {
	        return function() {
	            return method.apply(object, arguments);
	        };
	    },
	
	
	    /**
	     * @ngdoc method
	     * @name readableColumnName
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} columnName Column name as a string
	     * @returns {string} Column name appropriately capitalized and split apart
	     *
	       @example
	       <example module="app">
	        <file name="app.js">
	          var app = angular.module('app', ['ui.grid']);
	
	          app.controller('MainCtrl', ['$scope', 'gridUtil', function ($scope, gridUtil) {
	            $scope.name = 'firstName';
	            $scope.columnName = function(name) {
	              return gridUtil.readableColumnName(name);
	            };
	          }]);
	        </file>
	        <file name="index.html">
	          <div ng-controller="MainCtrl">
	            <strong>Column name:</strong> <input ng-model="name" />
	            <br>
	            <strong>Output:</strong> <span ng-bind="columnName(name)"></span>
	          </div>
	        </file>
	      </example>
	     */
	    readableColumnName: function (columnName) {
	      // Convert underscores to spaces
	      if (typeof(columnName) === 'undefined' || columnName === undefined || columnName === null) { return columnName; }
	
	      if (typeof(columnName) !== 'string') {
	        columnName = String(columnName);
	      }
	
	      return columnName.replace(/_+/g, ' ')
	        // Replace a completely all-capsed word with a first-letter-capitalized version
	        .replace(/^[A-Z]+$/, function (match) {
	          return angular.lowercase(angular.uppercase(match.charAt(0)) + match.slice(1));
	        })
	        // Capitalize the first letter of words
	        .replace(/([\w\u00C0-\u017F]+)/g, function (match) {
	          return angular.uppercase(match.charAt(0)) + match.slice(1);
	        })
	        // Put a space in between words that have partial capilizations (i.e. 'firstName' becomes 'First Name')
	        // .replace(/([A-Z]|[A-Z]\w+)([A-Z])/g, "$1 $2");
	        // .replace(/(\w+?|\w)([A-Z])/g, "$1 $2");
	        .replace(/(\w+?(?=[A-Z]))/g, '$1 ');
	    },
	
	    /**
	     * @ngdoc method
	     * @name getColumnsFromData
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a list of column names, given a data set
	     *
	     * @param {string} data Data array for grid
	     * @returns {Object} Column definitions with field accessor and column name
	     *
	     * @example
	       <pre>
	         var data = [
	           { firstName: 'Bob', lastName: 'Jones' },
	           { firstName: 'Frank', lastName: 'Smith' }
	         ];
	
	         var columnDefs = GridUtil.getColumnsFromData(data, excludeProperties);
	
	         columnDefs == [
	          {
	            field: 'firstName',
	            name: 'First Name'
	          },
	          {
	            field: 'lastName',
	            name: 'Last Name'
	          }
	         ];
	       </pre>
	     */
	    getColumnsFromData: function (data, excludeProperties) {
	      var columnDefs = [];
	
	      if (!data || typeof(data[0]) === 'undefined' || data[0] === undefined) { return []; }
	      if (angular.isUndefined(excludeProperties)) { excludeProperties = []; }
	
	      var item = data[0];
	
	      angular.forEach(item,function (prop, propName) {
	        if ( excludeProperties.indexOf(propName) === -1){
	          columnDefs.push({
	            name: propName
	          });
	        }
	      });
	
	      return columnDefs;
	    },
	
	    /**
	     * @ngdoc method
	     * @name newId
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a unique ID string
	     *
	     * @returns {string} Unique string
	     *
	     * @example
	       <pre>
	        var id = GridUtil.newId();
	
	        # 1387305700482;
	       </pre>
	     */
	    newId: (function() {
	      var seedId = new Date().getTime();
	      return function() {
	          return seedId += 1;
	      };
	    })(),
	
	
	    /**
	     * @ngdoc method
	     * @name getTemplate
	     * @methodOf ui.grid.service:GridUtil
	     * @description Get's template from cache / element / url
	     *
	     * @param {string|element|promise} Either a string representing the template id, a string representing the template url,
	     *   an jQuery/Angualr element, or a promise that returns the template contents to use.
	     * @returns {object} a promise resolving to template contents
	     *
	     * @example
	     <pre>
	     GridUtil.getTemplate(url).then(function (contents) {
	          alert(contents);
	        })
	     </pre>
	     */
	    getTemplate: function (template) {
	      // Try to fetch the template out of the templateCache
	      if ($templateCache.get(template)) {
	        return s.postProcessTemplate($templateCache.get(template));
	      }
	
	      // See if the template is itself a promise
	      if (template.hasOwnProperty('then')) {
	        return template.then(s.postProcessTemplate);
	      }
	
	      // If the template is an element, return the element
	      try {
	        if (angular.element(template).length > 0) {
	          return $q.when(template).then(s.postProcessTemplate);
	        }
	      }
	      catch (err){
	        //do nothing; not valid html
	      }
	
	      s.logDebug('fetching url', template);
	
	      // Default to trying to fetch the template as a url with $http
	      return $http({ method: 'GET', url: template})
	        .then(
	          function (result) {
	            var templateHtml = result.data.trim();
	            //put in templateCache for next call
	            $templateCache.put(template, templateHtml);
	            return templateHtml;
	          },
	          function (err) {
	            throw new Error("Could not get template " + template + ": " + err);
	          }
	        )
	        .then(s.postProcessTemplate);
	    },
	
	    //
	    postProcessTemplate: function (template) {
	      var startSym = $interpolate.startSymbol(),
	          endSym = $interpolate.endSymbol();
	
	      // If either of the interpolation symbols have been changed, we need to alter this template
	      if (startSym !== '{{' || endSym !== '}}') {
	        template = template.replace(/\{\{/g, startSym);
	        template = template.replace(/\}\}/g, endSym);
	      }
	
	      return $q.when(template);
	    },
	
	    /**
	     * @ngdoc method
	     * @name guessType
	     * @methodOf ui.grid.service:GridUtil
	     * @description guesses the type of an argument
	     *
	     * @param {string/number/bool/object} item variable to examine
	     * @returns {string} one of the following
	     * - 'string'
	     * - 'boolean'
	     * - 'number'
	     * - 'date'
	     * - 'object'
	     */
	    guessType : function (item) {
	      var itemType = typeof(item);
	
	      // Check for numbers and booleans
	      switch (itemType) {
	        case "number":
	        case "boolean":
	        case "string":
	          return itemType;
	        default:
	          if (angular.isDate(item)) {
	            return "date";
	          }
	          return "object";
	      }
	    },
	
	
	  /**
	    * @ngdoc method
	    * @name elementWidth
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} element DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element width in pixels, accounting for any borders, etc.
	    */
	    elementWidth: function (elem) {
	
	    },
	
	    /**
	    * @ngdoc method
	    * @name elementHeight
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} element DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element height in pixels, accounting for any borders, etc.
	    */
	    elementHeight: function (elem) {
	
	    },
	
	    // Thanks to http://stackoverflow.com/a/13382873/888165
	    getScrollbarWidth: function() {
	        var outer = document.createElement("div");
	        outer.style.visibility = "hidden";
	        outer.style.width = "100px";
	        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	
	        document.body.appendChild(outer);
	
	        var widthNoScroll = outer.offsetWidth;
	        // force scrollbars
	        outer.style.overflow = "scroll";
	
	        // add innerdiv
	        var inner = document.createElement("div");
	        inner.style.width = "100%";
	        outer.appendChild(inner);
	
	        var widthWithScroll = inner.offsetWidth;
	
	        // remove divs
	        outer.parentNode.removeChild(outer);
	
	        return widthNoScroll - widthWithScroll;
	    },
	
	    swap: function( elem, options, callback, args ) {
	      var ret, name,
	              old = {};
	
	      // Remember the old values, and insert the new ones
	      for ( name in options ) {
	        old[ name ] = elem.style[ name ];
	        elem.style[ name ] = options[ name ];
	      }
	
	      ret = callback.apply( elem, args || [] );
	
	      // Revert the old values
	      for ( name in options ) {
	        elem.style[ name ] = old[ name ];
	      }
	
	      return ret;
	    },
	
	    fakeElement: function( elem, options, callback, args ) {
	      var ret, name,
	          newElement = angular.element(elem).clone()[0];
	
	      for ( name in options ) {
	        newElement.style[ name ] = options[ name ];
	      }
	
	      angular.element(document.body).append(newElement);
	
	      ret = callback.call( newElement, newElement );
	
	      angular.element(newElement).remove();
	
	      return ret;
	    },
	
	    /**
	    * @ngdoc method
	    * @name normalizeWheelEvent
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {event} event A mouse wheel event
	    *
	    * @returns {event} A normalized event
	    *
	    * @description
	    * Given an event from this list:
	    *
	    * `wheel, mousewheel, DomMouseScroll, MozMousePixelScroll`
	    *
	    * "normalize" it
	    * so that it stays consistent no matter what browser it comes from (i.e. scale it correctly and make sure the direction is right.)
	    */
	    normalizeWheelEvent: function (event) {
	      // var toFix = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'];
	      // var toBind = 'onwheel' in document || document.documentMode >= 9 ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'];
	      var lowestDelta, lowestDeltaXY;
	
	      var orgEvent   = event || window.event,
	          args       = [].slice.call(arguments, 1),
	          delta      = 0,
	          deltaX     = 0,
	          deltaY     = 0,
	          absDelta   = 0,
	          absDeltaXY = 0,
	          fn;
	
	      // event = $.event.fix(orgEvent);
	      // event.type = 'mousewheel';
	
	      // NOTE: jQuery masks the event and stores it in the event as originalEvent
	      if (orgEvent.originalEvent) {
	        orgEvent = orgEvent.originalEvent;
	      }
	
	      // Old school scrollwheel delta
	      if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta; }
	      if ( orgEvent.detail )     { delta = orgEvent.detail * -1; }
	
	      // At a minimum, setup the deltaY to be delta
	      deltaY = delta;
	
	      // Firefox < 17 related to DOMMouseScroll event
	      if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
	          deltaY = 0;
	          deltaX = delta * -1;
	      }
	
	      // New school wheel delta (wheel event)
	      if ( orgEvent.deltaY ) {
	          deltaY = orgEvent.deltaY * -1;
	          delta  = deltaY;
	      }
	      if ( orgEvent.deltaX ) {
	          deltaX = orgEvent.deltaX;
	          delta  = deltaX * -1;
	      }
	
	      // Webkit
	      if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY; }
	      if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = orgEvent.wheelDeltaX; }
	
	      // Look for lowest delta to normalize the delta values
	      absDelta = Math.abs(delta);
	      if ( !lowestDelta || absDelta < lowestDelta ) { lowestDelta = absDelta; }
	      absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
	      if ( !lowestDeltaXY || absDeltaXY < lowestDeltaXY ) { lowestDeltaXY = absDeltaXY; }
	
	      // Get a whole value for the deltas
	      fn     = delta > 0 ? 'floor' : 'ceil';
	      delta  = Math[fn](delta  / lowestDelta);
	      deltaX = Math[fn](deltaX / lowestDeltaXY);
	      deltaY = Math[fn](deltaY / lowestDeltaXY);
	
	      return {
	        delta: delta,
	        deltaX: deltaX,
	        deltaY: deltaY
	      };
	    },
	
	    // Stolen from Modernizr
	    // TODO: make this, and everythign that flows from it, robust
	    //http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
	    isTouchEnabled: function() {
	      var bool;
	
	      if (('ontouchstart' in $window) || $window.DocumentTouch && $document instanceof DocumentTouch) {
	        bool = true;
	      }
	
	      return bool;
	    },
	
	    isNullOrUndefined: function(obj) {
	      if (obj === undefined || obj === null) {
	        return true;
	      }
	      return false;
	    },
	
	    endsWith: function(str, suffix) {
	      if (!str || !suffix || typeof str !== "string") {
	        return false;
	      }
	      return str.indexOf(suffix, str.length - suffix.length) !== -1;
	    },
	
	    arrayContainsObjectWithProperty: function(array, propertyName, propertyValue) {
	        var found = false;
	        angular.forEach(array, function (object) {
	            if (object[propertyName] === propertyValue) {
	                found = true;
	            }
	        });
	        return found;
	    },
	
	    //// Shim requestAnimationFrame
	    //requestAnimationFrame: $window.requestAnimationFrame && $window.requestAnimationFrame.bind($window) ||
	    //                       $window.webkitRequestAnimationFrame && $window.webkitRequestAnimationFrame.bind($window) ||
	    //                       function(fn) {
	    //                         return $timeout(fn, 10, false);
	    //                       },
	
	    numericAndNullSort: function (a, b) {
	      if (a === null) { return 1; }
	      if (b === null) { return -1; }
	      if (a === null && b === null) { return 0; }
	      return a - b;
	    },
	
	    // Disable ngAnimate animations on an element
	    disableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, false);
	        } else {
	          $animate.enabled(false, element);
	        }
	      }
	      catch (e) {}
	    },
	
	    enableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, true);
	        } else {
	          $animate.enabled(true, element);
	        }
	        return $animate;
	      }
	      catch (e) {}
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet. 2.0 maybe?)
	    nextUid: function nextUid() {
	      var index = uid.length;
	      var digit;
	
	      while (index) {
	        index--;
	        digit = uid[index].charCodeAt(0);
	        if (digit === 57 /*'9'*/) {
	          uid[index] = 'A';
	          return uidPrefix + uid.join('');
	        }
	        if (digit === 90  /*'Z'*/) {
	          uid[index] = '0';
	        } else {
	          uid[index] = String.fromCharCode(digit + 1);
	          return uidPrefix + uid.join('');
	        }
	      }
	      uid.unshift('0');
	
	      return uidPrefix + uid.join('');
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet. 2.0 maybe?)
	    hashKey: function hashKey(obj) {
	      var objType = typeof obj,
	          key;
	
	      if (objType === 'object' && obj !== null) {
	        if (typeof (key = obj.$$hashKey) === 'function') {
	          // must invoke on object to keep the right this
	          key = obj.$$hashKey();
	        }
	        else if (typeof(obj.$$hashKey) !== 'undefined' && obj.$$hashKey) {
	          key = obj.$$hashKey;
	        }
	        else if (key === undefined) {
	          key = obj.$$hashKey = s.nextUid();
	        }
	      }
	      else {
	        key = obj;
	      }
	
	      return objType + ':' + key;
	    },
	
	    resetUids: function () {
	      uid = ['0', '0', '0'];
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logError
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * error messages if uiGridConstants.LOG_ERROR_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logError: function( logMessage ){
	      if ( uiGridConstants.LOG_ERROR_MESSAGES ){
	        $log.error( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logWarn
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * warning messages if uiGridConstants.LOG_WARN_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logWarn: function( logMessage ){
	      if ( uiGridConstants.LOG_WARN_MESSAGES ){
	        $log.warn( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logDebug
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * debug messages if uiGridConstants.LOG_DEBUG_MESSAGES is set to true
	     *
	     */
	    logDebug: function() {
	      if ( uiGridConstants.LOG_DEBUG_MESSAGES ){
	        $log.debug.apply($log, arguments);
	      }
	    }
	
	  };
	
	  /**
	   * @ngdoc object
	   * @name focus
	   * @propertyOf ui.grid.service:GridUtil
	   * @description Provies a set of methods to set the document focus inside the grid.
	   * See {@link ui.grid.service:GridUtil.focus} for more information.
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.service:GridUtil.focus
	   * @description Provies a set of methods to set the document focus inside the grid.
	   * Timeouts are utilized to ensure that the focus is invoked after any other event has been triggered.
	   * e.g. click events that need to run before the focus or
	   * inputs elements that are in a disabled state but are enabled when those events
	   * are triggered.
	   */
	  s.focus = {
	    queue: [],
	    //http://stackoverflow.com/questions/25596399/set-element-focus-in-angular-way
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byId
	     * @description Sets the focus of the document to the given id value.
	     * If provided with the grid object it will automatically append the grid id.
	     * This is done to encourage unique dom id's as it allows for multiple grids on a
	     * page.
	     * @param {String} id the id of the dom element to set the focus on
	     * @param {Object=} Grid the grid object for this grid instance. See: {@link ui.grid.class:Grid}
	     * @param {Number} Grid.id the unique id for this grid. Already set on an initialized grid object.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byId: function (id, Grid) {
	      this._purgeQueue();
	      var promise = $timeout(function() {
	        var elementID = (Grid && Grid.id ? Grid.id + '-' : '') + id;
	        var element = $window.document.getElementById(elementID);
	        if (element) {
	          element.focus();
	        } else {
	          s.logWarn('[focus.byId] Element id ' + elementID + ' was not found.');
	        }
	      });
	      this.queue.push(promise);
	      return promise;
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byElement
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} element the DOM element to set the focus on
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byElement: function(element){
	      if (!angular.isElement(element)){
	        s.logWarn("Trying to focus on an element that isn\'t an element.");
	        return $q.reject('not-element');
	      }
	      element = angular.element(element);
	      this._purgeQueue();
	      var promise = $timeout(function(){
	        if (element){
	          element[0].focus();
	        }
	      });
	      this.queue.push(promise);
	      return promise;
	    },
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name bySelector
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} parentElement the parent/ancestor of the dom element that you are selecting using the query selector
	     * @param {String} querySelector finds the dom element using the {@link http://www.w3schools.com/jsref/met_document_queryselector.asp querySelector}
	     * @param {boolean} [aSync=false] If true then the selector will be querried inside of a timeout. Otherwise the selector will be querried imidately
	     * then the focus will be called.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    bySelector: function(parentElement, querySelector, aSync){
	      var self = this;
	      if (!angular.isElement(parentElement)){
	        throw new Error("The parent element is not an element.");
	      }
	      // Ensure that this is an angular element.
	      // It is fine if this is already an angular element.
	      parentElement = angular.element(parentElement);
	      var focusBySelector = function(){
	        var element = parentElement[0].querySelector(querySelector);
	        return self.byElement(element);
	      };
	      this._purgeQueue();
	      if (aSync){ //Do this asynchronysly
	        var promise = $timeout(focusBySelector);
	        this.queue.push($timeout(focusBySelector));
	        return promise;
	      } else {
	        return focusBySelector();
	      }
	    },
	    _purgeQueue: function(){
	      this.queue.forEach(function(element){
	        $timeout.cancel(element);
	      });
	      this.queue = [];
	    }
	  };
	
	
	  ['width', 'height'].forEach(function (name) {
	    var capsName = angular.uppercase(name.charAt(0)) + name.substr(1);
	    s['element' + capsName] = function (elem, extra) {
	      var e = elem;
	      if (e && typeof(e.length) !== 'undefined' && e.length) {
	        e = elem[0];
	      }
	
	      if (e) {
	        var styles = getStyles(e);
	        return e.offsetWidth === 0 && rdisplayswap.test(styles.display) ?
	                  s.swap(e, cssShow, function() {
	                    return getWidthOrHeight(e, name, extra );
	                  }) :
	                  getWidthOrHeight( e, name, extra );
	      }
	      else {
	        return null;
	      }
	    };
	
	    s['outerElement' + capsName] = function (elem, margin) {
	      return elem ? s['element' + capsName].call(this, elem, margin ? 'margin' : 'border') : null;
	    };
	  });
	
	  // http://stackoverflow.com/a/24107550/888165
	  s.closestElm = function closestElm(el, selector) {
	    if (typeof(el.length) !== 'undefined' && el.length) {
	      el = el[0];
	    }
	
	    var matchesFn;
	
	    // find vendor prefix
	    ['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
	        if (typeof document.body[fn] === 'function') {
	            matchesFn = fn;
	            return true;
	        }
	        return false;
	    });
	
	    // traverse parents
	    var parent;
	    while (el !== null) {
	      parent = el.parentElement;
	      if (parent !== null && parent[matchesFn](selector)) {
	          return parent;
	      }
	      el = parent;
	    }
	
	    return null;
	  };
	
	  s.type = function (obj) {
	    var text = Function.prototype.toString.call(obj.constructor);
	    return text.match(/function (.*?)\(/)[1];
	  };
	
	  s.getBorderSize = function getBorderSize(elem, borderType) {
	    if (typeof(elem.length) !== 'undefined' && elem.length) {
	      elem = elem[0];
	    }
	
	    var styles = getStyles(elem);
	
	    // If a specific border is supplied, like 'top', read the 'borderTop' style property
	    if (borderType) {
	      borderType = 'border' + borderType.charAt(0).toUpperCase() + borderType.slice(1);
	    }
	    else {
	      borderType = 'border';
	    }
	
	    borderType += 'Width';
	
	    var val = parseInt(styles[borderType], 10);
	
	    if (isNaN(val)) {
	      return 0;
	    }
	    else {
	      return val;
	    }
	  };
	
	  // http://stackoverflow.com/a/22948274/888165
	  // TODO: Opera? Mobile?
	  s.detectBrowser = function detectBrowser() {
	    var userAgent = $window.navigator.userAgent;
	
	    var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer|trident\//i};
	
	    for (var key in browsers) {
	      if (browsers[key].test(userAgent)) {
	        return key;
	      }
	    }
	
	    return 'unknown';
	  };
	
	  // Borrowed from https://github.com/othree/jquery.rtl-scroll-type
	  // Determine the scroll "type" this browser is using for RTL
	  s.rtlScrollType = function rtlScrollType() {
	    if (rtlScrollType.type) {
	      return rtlScrollType.type;
	    }
	
	    var definer = angular.element('<div dir="rtl" style="font-size: 14px; width: 1px; height: 1px; position: absolute; top: -1000px; overflow: scroll">A</div>')[0],
	        type = 'reverse';
	
	    document.body.appendChild(definer);
	
	    if (definer.scrollLeft > 0) {
	      type = 'default';
	    }
	    else {
	      definer.scrollLeft = 1;
	      if (definer.scrollLeft === 0) {
	        type = 'negative';
	      }
	    }
	
	    angular.element(definer).remove();
	    rtlScrollType.type = type;
	
	    return type;
	  };
	
	    /**
	     * @ngdoc method
	     * @name normalizeScrollLeft
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {element} element The element to get the `scrollLeft` from.
	     * @param {grid} grid -  grid used to normalize (uses the rtl property)
	     *
	     * @returns {number} A normalized scrollLeft value for the current browser.
	     *
	     * @description
	     * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method normalizes them
	     */
	  s.normalizeScrollLeft = function normalizeScrollLeft(element, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    var scrollLeft = element.scrollLeft;
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          return element.scrollWidth - scrollLeft - element.clientWidth;
	        case 'negative':
	          return Math.abs(scrollLeft);
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	  /**
	  * @ngdoc method
	  * @name denormalizeScrollLeft
	  * @methodOf ui.grid.service:GridUtil
	  *
	  * @param {element} element The element to normalize the `scrollLeft` value for
	  * @param {number} scrollLeft The `scrollLeft` value to denormalize.
	  * @param {grid} grid The grid that owns the scroll event.
	  *
	  * @returns {number} A normalized scrollLeft value for the current browser.
	  *
	  * @description
	  * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method denormalizes a value for the current browser.
	  */
	  s.denormalizeScrollLeft = function denormalizeScrollLeft(element, scrollLeft, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          // Get the max scroll for the element
	          var maxScrollLeft = element.scrollWidth - element.clientWidth;
	
	          // Subtract the current scroll amount from the max scroll
	          return maxScrollLeft - scrollLeft;
	        case 'negative':
	          return scrollLeft * -1;
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	    /**
	     * @ngdoc method
	     * @name preEval
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} path Path to evaluate
	     *
	     * @returns {string} A path that is normalized.
	     *
	     * @description
	     * Takes a field path and converts it to bracket notation to allow for special characters in path
	     * @example
	     * <pre>
	     * gridUtil.preEval('property') == 'property'
	     * gridUtil.preEval('nested.deep.prop-erty') = "nested['deep']['prop-erty']"
	     * </pre>
	     */
	  s.preEval = function (path) {
	    var m = uiGridConstants.BRACKET_REGEXP.exec(path);
	    if (m) {
	      return (m[1] ? s.preEval(m[1]) : m[1]) + m[2] + (m[3] ? s.preEval(m[3]) : m[3]);
	    } else {
	      path = path.replace(uiGridConstants.APOS_REGEXP, '\\\'');
	      var parts = path.split(uiGridConstants.DOT_REGEXP);
	      var preparsed = [parts.shift()];    // first item must be var notation, thus skip
	      angular.forEach(parts, function (part) {
	        preparsed.push(part.replace(uiGridConstants.FUNC_REGEXP, '\']$1'));
	      });
	      return preparsed.join('[\'');
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name debounce
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to debounce
	   * @param {number} wait milliseconds to delay
	   * @param {boolean} immediate execute before delay
	   *
	   * @returns {function} A function that can be executed as debounced function
	   *
	   * @description
	   * Copied from https://github.com/shahata/angular-debounce
	   * Takes a function, decorates it to execute only 1 time after multiple calls, and returns the decorated function
	   * @example
	   * <pre>
	   * var debouncedFunc =  gridUtil.debounce(function(){alert('debounced');}, 500);
	   * debouncedFunc();
	   * debouncedFunc();
	   * debouncedFunc();
	   * </pre>
	   */
	  s.debounce =  function (func, wait, immediate) {
	    var timeout, args, context, result;
	    function debounce() {
	      /* jshint validthis:true */
	      context = this;
	      args = arguments;
	      var later = function () {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	        }
	      };
	      var callNow = immediate && !timeout;
	      if (timeout) {
	        $timeout.cancel(timeout);
	      }
	      timeout = $timeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	      }
	      return result;
	    }
	    debounce.cancel = function () {
	      $timeout.cancel(timeout);
	      timeout = null;
	    };
	    return debounce;
	  };
	
	  /**
	   * @ngdoc method
	   * @name throttle
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to throttle
	   * @param {number} wait milliseconds to delay after first trigger
	   * @param {Object} params to use in throttle.
	   *
	   * @returns {function} A function that can be executed as throttled function
	   *
	   * @description
	   * Adapted from debounce function (above)
	   * Potential keys for Params Object are:
	   *    trailing (bool) - whether to trigger after throttle time ends if called multiple times
	   * Updated to use $interval rather than $timeout, as protractor (e2e tests) is able to work with $interval,
	   * but not with $timeout
	   *
	   * Note that when using throttle, you need to use throttle to create a new function upfront, then use the function
	   * return from that call each time you need to call throttle.  If you call throttle itself repeatedly, the lastCall
	   * variable will get overwritten and the throttling won't work
	   *
	   * @example
	   * <pre>
	   * var throttledFunc =  gridUtil.throttle(function(){console.log('throttled');}, 500, {trailing: true});
	   * throttledFunc(); //=> logs throttled
	   * throttledFunc(); //=> queues attempt to log throttled for ~500ms (since trailing param is truthy)
	   * throttledFunc(); //=> updates arguments to keep most-recent request, but does not do anything else.
	   * </pre>
	   */
	  s.throttle = function(func, wait, options){
	    options = options || {};
	    var lastCall = 0, queued = null, context, args;
	
	    function runFunc(endDate){
	      lastCall = +new Date();
	      func.apply(context, args);
	      $interval(function(){ queued = null; }, 0, 1);
	    }
	
	    return function(){
	      /* jshint validthis:true */
	      context = this;
	      args = arguments;
	      if (queued === null){
	        var sinceLast = +new Date() - lastCall;
	        if (sinceLast > wait){
	          runFunc();
	        }
	        else if (options.trailing){
	          queued = $interval(runFunc, wait - sinceLast, 1);
	        }
	      }
	    };
	  };
	
	  s.on = {};
	  s.off = {};
	  s._events = {};
	
	  s.addOff = function (eventName) {
	    s.off[eventName] = function (elm, fn) {
	      var idx = s._events[eventName].indexOf(fn);
	      if (idx > 0) {
	        s._events[eventName].removeAt(idx);
	      }
	    };
	  };
	
	  var mouseWheeltoBind = ( 'onwheel' in document || document.documentMode >= 9 ) ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	      nullLowestDeltaTimeout,
	      lowestDelta;
	
	  s.on.mousewheel = function (elm, fn) {
	    if (!elm || !fn) { return; }
	
	    var $elm = angular.element(elm);
	
	    // Store the line height and page height for this particular element
	    $elm.data('mousewheel-line-height', getLineHeight($elm));
	    $elm.data('mousewheel-page-height', s.elementHeight($elm));
	    if (!$elm.data('mousewheel-callbacks')) { $elm.data('mousewheel-callbacks', {}); }
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    cbs[fn] = (Function.prototype.bind || bindPolyfill).call(mousewheelHandler, $elm[0], fn);
	
	    // Bind all the mousew heel events
	    for ( var i = mouseWheeltoBind.length; i; ) {
	      $elm.on(mouseWheeltoBind[--i], cbs[fn]);
	    }
	  };
	  s.off.mousewheel = function (elm, fn) {
	    var $elm = angular.element(elm);
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    var handler = cbs[fn];
	
	    if (handler) {
	      for ( var i = mouseWheeltoBind.length; i; ) {
	        $elm.off(mouseWheeltoBind[--i], handler);
	      }
	    }
	
	    delete cbs[fn];
	
	    if (Object.keys(cbs).length === 0) {
	      $elm.removeData('mousewheel-line-height');
	      $elm.removeData('mousewheel-page-height');
	      $elm.removeData('mousewheel-callbacks');
	    }
	  };
	
	  function mousewheelHandler(fn, event) {
	    var $elm = angular.element(this);
	
	    var delta      = 0,
	        deltaX     = 0,
	        deltaY     = 0,
	        absDelta   = 0,
	        offsetX    = 0,
	        offsetY    = 0;
	
	    // jQuery masks events
	    if (event.originalEvent) { event = event.originalEvent; }
	
	    if ( 'detail'      in event ) { deltaY = event.detail * -1;      }
	    if ( 'wheelDelta'  in event ) { deltaY = event.wheelDelta;       }
	    if ( 'wheelDeltaY' in event ) { deltaY = event.wheelDeltaY;      }
	    if ( 'wheelDeltaX' in event ) { deltaX = event.wheelDeltaX * -1; }
	
	    // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	    if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	      deltaX = deltaY * -1;
	      deltaY = 0;
	    }
	
	    // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	    delta = deltaY === 0 ? deltaX : deltaY;
	
	    // New school wheel delta (wheel event)
	    if ( 'deltaY' in event ) {
	      deltaY = event.deltaY * -1;
	      delta  = deltaY;
	    }
	    if ( 'deltaX' in event ) {
	      deltaX = event.deltaX;
	      if ( deltaY === 0 ) { delta  = deltaX * -1; }
	    }
	
	    // No change actually happened, no reason to go any further
	    if ( deltaY === 0 && deltaX === 0 ) { return; }
	
	    // Need to convert lines and pages to pixels if we aren't already in pixels
	    // There are three delta modes:
	    //   * deltaMode 0 is by pixels, nothing to do
	    //   * deltaMode 1 is by lines
	    //   * deltaMode 2 is by pages
	    if ( event.deltaMode === 1 ) {
	        var lineHeight = $elm.data('mousewheel-line-height');
	        delta  *= lineHeight;
	        deltaY *= lineHeight;
	        deltaX *= lineHeight;
	    }
	    else if ( event.deltaMode === 2 ) {
	        var pageHeight = $elm.data('mousewheel-page-height');
	        delta  *= pageHeight;
	        deltaY *= pageHeight;
	        deltaX *= pageHeight;
	    }
	
	    // Store lowest absolute delta to normalize the delta values
	    absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );
	
	    if ( !lowestDelta || absDelta < lowestDelta ) {
	      lowestDelta = absDelta;
	
	      // Adjust older deltas if necessary
	      if ( shouldAdjustOldDeltas(event, absDelta) ) {
	        lowestDelta /= 40;
	      }
	    }
	
	    // Get a whole, normalized value for the deltas
	    delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	    deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	    deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);
	
	    event.deltaMode = 0;
	
	    // Normalise offsetX and offsetY properties
	    // if ($elm[0].getBoundingClientRect ) {
	    //   var boundingRect = $(elm)[0].getBoundingClientRect();
	    //   offsetX = event.clientX - boundingRect.left;
	    //   offsetY = event.clientY - boundingRect.top;
	    // }
	
	    // event.deltaX = deltaX;
	    // event.deltaY = deltaY;
	    // event.deltaFactor = lowestDelta;
	
	    var newEvent = {
	      originalEvent: event,
	      deltaX: deltaX,
	      deltaY: deltaY,
	      deltaFactor: lowestDelta,
	      preventDefault: function () { event.preventDefault(); },
	      stopPropagation: function () { event.stopPropagation(); }
	    };
	
	    // Clearout lowestDelta after sometime to better
	    // handle multiple device types that give
	    // a different lowestDelta
	    // Ex: trackpad = 3 and mouse wheel = 120
	    if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
	    nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
	
	    fn.call($elm[0], newEvent);
	  }
	
	  function nullLowestDelta() {
	    lowestDelta = null;
	  }
	
	  function shouldAdjustOldDeltas(orgEvent, absDelta) {
	    // If this is an older event and the delta is divisable by 120,
	    // then we are assuming that the browser is treating this as an
	    // older mouse wheel event and that we should divide the deltas
	    // by 40 to try and get a more usable deltaFactor.
	    // Side note, this actually impacts the reported scroll distance
	    // in older browsers and can cause scrolling to be slower than native.
	    // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	    return orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
	  }
	
	  return s;
	}]);
	
	// Add 'px' to the end of a number string if it doesn't have it already
	module.filter('px', function() {
	  return function(str) {
	    if (str.match(/^[\d\.]+$/)) {
	      return str + 'px';
	    }
	    else {
	      return str;
	    }
	  };
	});
	
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      var lang = {
	              aggregate: {
	                  label: 'položky'
	              },
	              groupPanel: {
	                  description: 'Přesuňte záhlaví zde pro vytvoření skupiny dle sloupce.'
	              },
	              search: {
	                  placeholder: 'Hledat...',
	                  showingItems: 'Zobrazuji položky:',
	                  selectedItems: 'Vybrané položky:',
	                  totalItems: 'Celkem položek:',
	                  size: 'Velikost strany:',
	                  first: 'První strana',
	                  next: 'Další strana',
	                  previous: 'Předchozí strana',
	                  last: 'Poslední strana'
	              },
	              menu: {
	                  text: 'Vyberte sloupec:'
	              },
	              sort: {
	                  ascending: 'Seřadit od A-Z',
	                  descending: 'Seřadit od Z-A',
	                  remove: 'Odebrat seřazení'
	              },
	              column: {
	                  hide: 'Schovat sloupec'
	              },
	              aggregation: {
	                  count: 'celkem řádků: ',
	                  sum: 'celkem: ',
	                  avg: 'avg: ',
	                  min: 'min.: ',
	                  max: 'max.: '
	              },
	              pinning: {
	                  pinLeft: 'Zamknout vlevo',
	                  pinRight: 'Zamknout vpravo',
	                  unpin: 'Odemknout'
	              },
	              gridMenu: {
	                  columns: 'Sloupce:',
	                  importerTitle: 'Importovat soubor',
	                  exporterAllAsCsv: 'Exportovat všechna data do csv',
	                  exporterVisibleAsCsv: 'Exportovat viditelná data do csv',
	                  exporterSelectedAsCsv: 'Exportovat vybraná data do csv',
	                  exporterAllAsPdf: 'Exportovat všechna data do pdf',
	                  exporterVisibleAsPdf: 'Exportovat viditelná data do pdf',
	                  exporterSelectedAsPdf: 'Exportovat vybraná data do pdf',
	                  clearAllFilters: 'Odstranit všechny filtry'
	              },
	              importer: {
	                  noHeaders: 'Názvy sloupců se nepodařilo získat, obsahuje soubor záhlaví?',
	                  noObjects: 'Data se nepodařilo zpracovat, obsahuje soubor řádky mimo záhlaví?',
	                  invalidCsv: 'Soubor nelze zpracovat, jedná se o CSV?',
	                  invalidJson: 'Soubor nelze zpracovat, je to JSON?',
	                  jsonNotArray: 'Soubor musí obsahovat json. Ukončuji..'
	              },
	              pagination: {
	                  sizes: 'položek na stránku',
	                  totalItems: 'položek'
	              },
	              grouping: {
	                  group: 'Seskupit',
	                  ungroup: 'Odebrat seskupení',
	                  aggregate_count: 'Agregace: Count',
	                  aggregate_sum: 'Agregace: Sum',
	                  aggregate_max: 'Agregace: Max',
	                  aggregate_min: 'Agregace: Min',
	                  aggregate_avg: 'Agregace: Avg',
	                  aggregate_remove: 'Agregace: Odebrat'
	              }
	          };
	
	          // support varianty of different czech keys.
	          $delegate.add('cs', lang);
	          $delegate.add('cz', lang);
	          $delegate.add('cs-cz', lang);
	          $delegate.add('cs-CZ', lang);
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function(){
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('da', {
	        aggregate:{
	          label: 'artikler'
	        },
	        groupPanel:{
	          description: 'Grupér rækker udfra en kolonne ved at trække dens overskift hertil.'
	        },
	        search:{
	          placeholder: 'Søg...',
	          showingItems: 'Viste rækker:',
	          selectedItems: 'Valgte rækker:',
	          totalItems: 'Rækker totalt:',
	          size: 'Side størrelse:',
	          first: 'Første side',
	          next: 'Næste side',
	          previous: 'Forrige side',
	          last: 'Sidste side'
	        },
	        menu:{
	          text: 'Vælg kolonner:'
	        },
	        column: {
	          hide: 'Skjul kolonne'
	        },
	        aggregation: {
	          count: 'samlede rækker: ',
	          sum: 'smalede: ',
	          avg: 'gns: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('de', {
	        aggregate: {
	          label: 'Eintrag'
	        },
	        groupPanel: {
	          description: 'Ziehen Sie eine Spaltenüberschrift hierhin, um nach dieser Spalte zu gruppieren.'
	        },
	        search: {
	          placeholder: 'Suche...',
	          showingItems: 'Zeige Einträge:',
	          selectedItems: 'Ausgewählte Einträge:',
	          totalItems: 'Einträge gesamt:',
	          size: 'Einträge pro Seite:',
	          first: 'Erste Seite',
	          next: 'Nächste Seite',
	          previous: 'Vorherige Seite',
	          last: 'Letzte Seite'
	        },
	        menu: {
	          text: 'Spalten auswählen:'
	        },
	        sort: {
	          ascending: 'aufsteigend sortieren',
	          descending: 'absteigend sortieren',
	          remove: 'Sortierung zurücksetzen'
	        },
	        column: {
	          hide: 'Spalte ausblenden'
	        },
	        aggregation: {
	          count: 'Zeilen insgesamt: ',
	          sum: 'gesamt: ',
	          avg: 'Durchschnitt: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	            pinLeft: 'Links anheften',
	            pinRight: 'Rechts anheften',
	            unpin: 'Lösen'
	        },
	        gridMenu: {
	          columns: 'Spalten:',
	          importerTitle: 'Datei importieren',
	          exporterAllAsCsv: 'Alle Daten als CSV exportieren',
	          exporterVisibleAsCsv: 'sichtbare Daten als CSV exportieren',
	          exporterSelectedAsCsv: 'markierte Daten als CSV exportieren',
	          exporterAllAsPdf: 'Alle Daten als PDF exportieren',
	          exporterVisibleAsPdf: 'sichtbare Daten als PDF exportieren',
	          exporterSelectedAsPdf: 'markierte Daten als CSV exportieren',
	          clearAllFilters: 'Alle filter reinigen'
	        },
	        importer: {
	          noHeaders: 'Es konnten keine Spaltennamen ermittelt werden. Sind in der Datei Spaltendefinitionen enthalten?',
	          noObjects: 'Es konnten keine Zeileninformationen gelesen werden, Sind in der Datei außer den Spaltendefinitionen auch Daten enthalten?',
	          invalidCsv: 'Die Datei konnte nicht eingelesen werden, ist es eine gültige CSV-Datei?',
	          invalidJson: 'Die Datei konnte nicht eingelesen werden. Enthält sie gültiges JSON?',
	          jsonNotArray: 'Die importierte JSON-Datei muß ein Array enthalten. Breche Import ab.'
	        },
	        pagination: {
	            sizes: 'Einträge pro Seite',
	            totalItems: 'Einträge'
	        },
	        grouping: {
	            group: 'Gruppieren',
	            ungroup: 'Gruppierung aufheben',
	            aggregate_count: 'Agg: Anzahl',
	            aggregate_sum: 'Agg: Summe',
	            aggregate_max: 'Agg: Maximum',
	            aggregate_min: 'Agg: Minimum',
	            aggregate_avg: 'Agg: Mittelwert',
	            aggregate_remove: 'Aggregation entfernen'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('en', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter for column',
	            removeFilter: 'Remove Filter',
	            columnMenuButtonLabel: 'Column Menu'
	          },
	          priority: 'Priority:',
	          filterLabel: "Filter for column: "
	        },
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Drag a column header here and drop it to group by that column.'
	        },
	        search: {
	          placeholder: 'Search...',
	          showingItems: 'Showing Items:',
	          selectedItems: 'Selected Items:',
	          totalItems: 'Total Items:',
	          size: 'Page Size:',
	          first: 'First Page',
	          next: 'Next Page',
	          previous: 'Previous Page',
	          last: 'Last Page'
	        },
	        menu: {
	          text: 'Choose Columns:'
	        },
	        sort: {
	          ascending: 'Sort Ascending',
	          descending: 'Sort Descending',
	          none: 'Sort None',
	          remove: 'Remove Sort'
	        },
	        column: {
	          hide: 'Hide Column'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Pin Left',
	          pinRight: 'Pin Right',
	          unpin: 'Unpin'
	        },
	        columnMenu: {
	          close: 'Close'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Page to first',
	            pageBack: 'Page back',
	            pageSelected: 'Selected page',
	            pageForward: 'Page forward',
	            pageToLast: 'Page to last'
	          },
	          sizes: 'items per page',
	          totalItems: 'items',
	          through: 'through',
	          of: 'of'
	        },
	        grouping: {
	          group: 'Group',
	          ungroup: 'Ungroup',
	          aggregate_count: 'Agg: Count',
	          aggregate_sum: 'Agg: Sum',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Avg',
	          aggregate_remove: 'Agg: Remove'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('es', {
	        aggregate: {
	          label: 'Artículos'
	        },
	        groupPanel: {
	          description: 'Arrastre un encabezado de columna aquí y suéltelo para agrupar por esa columna.'
	        },
	        search: {
	          placeholder: 'Buscar...',
	          showingItems: 'Artículos Mostrados:',
	          selectedItems: 'Artículos Seleccionados:',
	          totalItems: 'Artículos Totales:',
	          size: 'Tamaño de Página:',
	          first: 'Primera Página',
	          next: 'Página Siguiente',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Elegir columnas:'
	        },
	        sort: {
	          ascending: 'Orden Ascendente',
	          descending: 'Orden Descendente',
	          remove: 'Sin Ordenar'
	        },
	        column: {
	          hide: 'Ocultar la columna'
	        },
	        aggregation: {
	          count: 'filas totales: ',
	          sum: 'total: ',
	          avg: 'media: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fijar a la Izquierda',
	          pinRight: 'Fijar a la Derecha',
	          unpin: 'Quitar Fijación'
	        },
	        gridMenu: {
	          columns: 'Columnas:',
	          importerTitle: 'Importar archivo',
	          exporterAllAsCsv: 'Exportar todo como csv',
	          exporterVisibleAsCsv: 'Exportar vista como csv',
	          exporterSelectedAsCsv: 'Exportar selección como csv',
	          exporterAllAsPdf: 'Exportar todo como pdf',
	          exporterVisibleAsPdf: 'Exportar vista como pdf',
	          exporterSelectedAsPdf: 'Exportar selección como pdf',
	          clearAllFilters: 'Limpiar todos los filtros'
	        },
	        importer: {
	          noHeaders: 'No fue posible derivar los nombres de las columnas, ¿tiene encabezados el archivo?',
	          noObjects: 'No fue posible obtener registros, ¿contiene datos el archivo, aparte de los encabezados?',
	          invalidCsv: 'No fue posible procesar el archivo, ¿es un CSV válido?',
	          invalidJson: 'No fue posible procesar el archivo, ¿es un Json válido?',
	          jsonNotArray: 'El archivo json importado debe contener un array, abortando.'
	        },
	        pagination: {
	          sizes: 'registros por página',
	          totalItems: 'registros',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Cont',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Máx',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Prom',
	          aggregate_remove: 'Agr: Quitar'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	/**
	 * Translated by: R. Salarmehr
	 *                M. Hosseynzade
	 *                Using Vajje.com online dictionary.
	 */
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('fa', {
	        aggregate: {
	          label: 'قلم'
	        },
	        groupPanel: {
	          description: 'عنوان یک ستون را بگیر و به گروهی از آن ستون رها کن.'
	        },
	        search: {
	          placeholder: 'جستجو...',
	          showingItems: 'نمایش اقلام:',
	          selectedItems: 'قلم\u200cهای انتخاب شده:',
	          totalItems: 'مجموع اقلام:',
	          size: 'اندازه\u200cی صفحه:',
	          first: 'اولین صفحه',
	          next: 'صفحه\u200cی\u200cبعدی',
	          previous: 'صفحه\u200cی\u200c قبلی',
	          last: 'آخرین صفحه'
	        },
	        menu: {
	          text: 'ستون\u200cهای انتخابی:'
	        },
	        sort: {
	          ascending: 'ترتیب صعودی',
	          descending: 'ترتیب نزولی',
	          remove: 'حذف مرتب کردن'
	        },
	        column: {
	          hide: 'پنهان\u200cکردن ستون'
	        },
	        aggregation: {
	          count: 'تعداد: ',
	          sum: 'مجموع: ',
	          avg: 'میانگین: ',
	          min: 'کمترین: ',
	          max: 'بیشترین: '
	        },
	        pinning: {
	          pinLeft: 'پین کردن سمت چپ',
	          pinRight: 'پین کردن سمت راست',
	          unpin: 'حذف پین'
	        },
	        gridMenu: {
	          columns: 'ستون\u200cها:',
	          importerTitle: 'وارد کردن فایل',
	          exporterAllAsCsv: 'خروجی تمام داده\u200cها در فایل csv',
	          exporterVisibleAsCsv: 'خروجی داده\u200cهای قابل مشاهده در فایل csv',
	          exporterSelectedAsCsv: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل csv',
	          exporterAllAsPdf: 'خروجی تمام داده\u200cها در فایل pdf',
	          exporterVisibleAsPdf: 'خروجی داده\u200cهای قابل مشاهده در فایل pdf',
	          exporterSelectedAsPdf: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل pdf',
	          clearAllFilters: 'پاک کردن تمام فیلتر'
	        },
	        importer: {
	          noHeaders: 'نام ستون قابل استخراج نیست. آیا فایل عنوان دارد؟',
	          noObjects: 'اشیا قابل استخراج نیستند. آیا به جز عنوان\u200cها در فایل داده وجود دارد؟',
	          invalidCsv: 'فایل قابل پردازش نیست. آیا فرمت  csv  معتبر است؟',
	          invalidJson: 'فایل قابل پردازش نیست. آیا فرمت json   معتبر است؟',
	          jsonNotArray: 'فایل json وارد شده باید حاوی آرایه باشد. عملیات ساقط شد.'
	        },
	        pagination: {
	          sizes: 'اقلام در هر صفحه',
	          totalItems: 'اقلام',
	          of: 'از'
	        },
	        grouping: {
	          group: 'گروه\u200cبندی',
	          ungroup: 'حذف گروه\u200cبندی',
	          aggregate_count: 'Agg: تعداد',
	          aggregate_sum: 'Agg: جمع',
	          aggregate_max: 'Agg: بیشینه',
	          aggregate_min: 'Agg: کمینه',
	          aggregate_avg: 'Agg: میانگین',
	          aggregate_remove: 'Agg: حذف'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fi', {
	        aggregate: {
	          label: 'rivit'
	        },
	        groupPanel: {
	          description: 'Raahaa ja pudota otsikko tähän ryhmittääksesi sarakkeen mukaan.'
	        },
	        search: {
	          placeholder: 'Hae...',
	          showingItems: 'Näytetään rivejä:',
	          selectedItems: 'Valitut rivit:',
	          totalItems: 'Rivejä yht.:',
	          size: 'Näytä:',
	          first: 'Ensimmäinen sivu',
	          next: 'Seuraava sivu',
	          previous: 'Edellinen sivu',
	          last: 'Viimeinen sivu'
	        },
	        menu: {
	          text: 'Valitse sarakkeet:'
	        },
	        sort: {
	          ascending: 'Järjestä nouseva',
	          descending: 'Järjestä laskeva',
	          remove: 'Poista järjestys'
	        },
	        column: {
	          hide: 'Piilota sarake'
	        },
	        aggregation: {
	          count: 'Rivejä yht.: ',
	          sum: 'Summa: ',
	          avg: 'K.a.: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	         pinLeft: 'Lukitse vasemmalle',
	          pinRight: 'Lukitse oikealle',
	          unpin: 'Poista lukitus'
	        },
	        gridMenu: {
	          columns: 'Sarakkeet:',
	          importerTitle: 'Tuo tiedosto',
	          exporterAllAsCsv: 'Vie tiedot csv-muodossa',
	          exporterVisibleAsCsv: 'Vie näkyvä tieto csv-muodossa',
	          exporterSelectedAsCsv: 'Vie valittu tieto csv-muodossa',
	          exporterAllAsPdf: 'Vie tiedot pdf-muodossa',
	          exporterVisibleAsPdf: 'Vie näkyvä tieto pdf-muodossa',
	          exporterSelectedAsPdf: 'Vie valittu tieto pdf-muodossa',
	          clearAllFilters: 'Puhdista kaikki suodattimet'
	        },
	        importer: {
	          noHeaders: 'Sarakkeen nimiä ei voitu päätellä, onko tiedostossa otsikkoriviä?',
	          noObjects: 'Tietoja ei voitu lukea, onko tiedostossa muuta kuin otsikkot?',
	          invalidCsv: 'Tiedostoa ei voitu käsitellä, oliko se CSV-muodossa?',
	          invalidJson: 'Tiedostoa ei voitu käsitellä, oliko se JSON-muodossa?',
	          jsonNotArray: 'Tiedosto ei sisältänyt taulukkoa, lopetetaan.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fr', {
	        aggregate: {
	          label: 'éléments'
	        },
	        groupPanel: {
	          description: 'Faites glisser une en-tête de colonne ici pour créer un groupe de colonnes.'
	        },
	        search: {
	          placeholder: 'Recherche...',
	          showingItems: 'Affichage des éléments :',
	          selectedItems: 'Éléments sélectionnés :',
	          totalItems: 'Nombre total d\'éléments:',
	          size: 'Taille de page:',
	          first: 'Première page',
	          next: 'Page Suivante',
	          previous: 'Page précédente',
	          last: 'Dernière page'
	        },
	        menu: {
	          text: 'Choisir des colonnes :'
	        },
	        sort: {
	          ascending: 'Trier par ordre croissant',
	          descending: 'Trier par ordre décroissant',
	          remove: 'Enlever le tri'
	        },
	        column: {
	          hide: 'Cacher la colonne'
	        },
	        aggregation: {
	          count: 'lignes totales: ',
	          sum: 'total: ',
	          avg: 'moy: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Épingler à gauche',
	          pinRight: 'Épingler à droite',
	          unpin: 'Détacher'
	        },
	        gridMenu: {
	          columns: 'Colonnes:',
	          importerTitle: 'Importer un fichier',
	          exporterAllAsCsv: 'Exporter toutes les données en CSV',
	          exporterVisibleAsCsv: 'Exporter les données visibles en CSV',
	          exporterSelectedAsCsv: 'Exporter les données sélectionnées en CSV',
	          exporterAllAsPdf: 'Exporter toutes les données en PDF',
	          exporterVisibleAsPdf: 'Exporter les données visibles en PDF',
	          exporterSelectedAsPdf: 'Exporter les données sélectionnées en PDF',
	          clearAllFilters: 'Nettoyez tous les filtres'
	        },
	        importer: {
	          noHeaders: 'Impossible de déterminer le nom des colonnes, le fichier possède-t-il une en-tête ?',
	          noObjects: 'Aucun objet trouvé, le fichier possède-t-il des données autres que l\'en-tête ?',
	          invalidCsv: 'Le fichier n\'a pas pu être traité, le CSV est-il valide ?',
	          invalidJson: 'Le fichier n\'a pas pu être traité, le JSON est-il valide ?',
	          jsonNotArray: 'Le fichier JSON importé doit contenir un tableau, abandon.'
	        },
	        pagination: {
	          sizes: 'éléments par page',
	          totalItems: 'éléments',
	          of: 'sur'
	        },
	        grouping: {
	          group: 'Grouper',
	          ungroup: 'Dégrouper',
	          aggregate_count: 'Agg: Compte',
	          aggregate_sum: 'Agg: Somme',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Moy',
	          aggregate_remove: 'Agg: Retirer'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('he', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'גרור עמודה לכאן ושחרר בכדי לקבץ עמודה זו.'
	        },
	        search: {
	          placeholder: 'חפש...',
	          showingItems: 'מציג:',
	          selectedItems: 'סה"כ נבחרו:',
	          totalItems: 'סה"כ רשומות:',
	          size: 'תוצאות בדף:',
	          first: 'דף ראשון',
	          next: 'דף הבא',
	          previous: 'דף קודם',
	          last: 'דף אחרון'
	        },
	        menu: {
	          text: 'בחר עמודות:'
	        },
	        sort: {
	          ascending: 'סדר עולה',
	          descending: 'סדר יורד',
	          remove: 'בטל'
	        },
	        column: {
	          hide: 'טור הסתר'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          clearAllFilters: 'Clean all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('hy', {
	        aggregate: {
	          label: 'տվյալներ'
	        },
	        groupPanel: {
	          description: 'Ըստ սյան խմբավորելու համար քաշեք և գցեք վերնագիրն այստեղ։'
	        },
	        search: {
	          placeholder: 'Փնտրում...',
	          showingItems: 'Ցուցադրված տվյալներ՝',
	          selectedItems: 'Ընտրված:',
	          totalItems: 'Ընդամենը՝',
	          size: 'Տողերի քանակը էջում՝',
	          first: 'Առաջին էջ',
	          next: 'Հաջորդ էջ',
	          previous: 'Նախորդ էջ',
	          last: 'Վերջին էջ'
	        },
	        menu: {
	          text: 'Ընտրել սյուները:'
	        },
	        sort: {
	          ascending: 'Աճման կարգով',
	          descending: 'Նվազման կարգով',
	          remove: 'Հանել '
	        },
	        column: {
	          hide: 'Թաքցնել սյունը'
	        },
	        aggregation: {
	          count: 'ընդամենը տող՝ ',
	          sum: 'ընդամենը՝ ',
	          avg: 'միջին՝ ',
	          min: 'մին՝ ',
	          max: 'մաքս՝ '
	        },
	        pinning: {
	          pinLeft: 'Կպցնել ձախ կողմում',
	          pinRight: 'Կպցնել աջ կողմում',
	          unpin: 'Արձակել'
	        },
	        gridMenu: {
	          columns: 'Սյուներ:',
	          importerTitle: 'Ներմուծել ֆայլ',
	          exporterAllAsCsv: 'Արտահանել ամբողջը CSV',
	          exporterVisibleAsCsv: 'Արտահանել երևացող տվյալները CSV',
	          exporterSelectedAsCsv: 'Արտահանել ընտրված տվյալները CSV',
	          exporterAllAsPdf: 'Արտահանել PDF',
	          exporterVisibleAsPdf: 'Արտահանել երևացող տվյալները PDF',
	          exporterSelectedAsPdf: 'Արտահանել ընտրված տվյալները PDF',
	          clearAllFilters: 'Մաքրել բոլոր ֆիլտրերը'
	        },
	        importer: {
	          noHeaders: 'Հնարավոր չեղավ որոշել սյան վերնագրերը։ Արդյո՞ք ֆայլը ունի վերնագրեր։',
	          noObjects: 'Հնարավոր չեղավ կարդալ տվյալները։ Արդյո՞ք ֆայլում կան տվյալներ։',
	          invalidCsv: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր CSV է։',
	          invalidJson: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր Json է։',
	          jsonNotArray: 'Ներմուծված json ֆայլը պետք է պարունակի զանգված, կասեցվում է։'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('it', {
	        aggregate: {
	          label: 'elementi'
	        },
	        groupPanel: {
	          description: 'Trascina un\'intestazione all\'interno del gruppo della colonna.'
	        },
	        search: {
	          placeholder: 'Ricerca...',
	          showingItems: 'Mostra:',
	          selectedItems: 'Selezionati:',
	          totalItems: 'Totali:',
	          size: 'Tot Pagine:',
	          first: 'Prima',
	          next: 'Prossima',
	          previous: 'Precedente',
	          last: 'Ultima'
	        },
	        menu: {
	          text: 'Scegli le colonne:'
	        },
	        sort: {
	          ascending: 'Asc.',
	          descending: 'Desc.',
	          remove: 'Annulla ordinamento'
	        },
	        column: {
	          hide: 'Nascondi'
	        },
	        aggregation: {
	          count: 'righe totali: ',
	          sum: 'tot: ',
	          avg: 'media: ',
	          min: 'minimo: ',
	          max: 'massimo: '
	        },
	        pinning: {
	         pinLeft: 'Blocca a sx',
	          pinRight: 'Blocca a dx',
	          unpin: 'Blocca in alto'
	        },
	        gridMenu: {
	          columns: 'Colonne:',
	          importerTitle: 'Importa',
	          exporterAllAsCsv: 'Esporta tutti i dati in CSV',
	          exporterVisibleAsCsv: 'Esporta i dati visibili in CSV',
	          exporterSelectedAsCsv: 'Esporta i dati selezionati in CSV',
	          exporterAllAsPdf: 'Esporta tutti i dati in PDF',
	          exporterVisibleAsPdf: 'Esporta i dati visibili in PDF',
	          exporterSelectedAsPdf: 'Esporta i dati selezionati in PDF',
	          clearAllFilters: 'Pulire tutti i filtri'
	        },
	        importer: {
	          noHeaders: 'Impossibile reperire i nomi delle colonne, sicuro che siano indicati all\'interno del file?',
	          noObjects: 'Impossibile reperire gli oggetti, sicuro che siano indicati all\'interno del file?',
	          invalidCsv: 'Impossibile elaborare il file, sicuro che sia un CSV?',
	          invalidJson: 'Impossibile elaborare il file, sicuro che sia un JSON valido?',
	          jsonNotArray: 'Errore! Il file JSON da importare deve contenere un array.'
	        },
	        grouping: {
	          group: 'Raggruppa',
	          ungroup: 'Separa',
	          aggregate_count: 'Agg: N. Elem.',
	          aggregate_sum: 'Agg: Somma',
	          aggregate_max: 'Agg: Massimo',
	          aggregate_min: 'Agg: Minimo',
	          aggregate_avg: 'Agg: Media',
	          aggregate_remove: 'Agg: Rimuovi'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ja', {
	        aggregate: {
	          label: '項目'
	        },
	        groupPanel: {
	          description: 'ここに列ヘッダをドラッグアンドドロップして、その列でグループ化します。'
	        },
	        search: {
	          placeholder: '検索...',
	          showingItems: '表示中の項目:',
	          selectedItems: '選択した項目:',
	          totalItems: '項目の総数:',
	          size: 'ページサイズ:',
	          first: '最初のページ',
	          next: '次のページ',
	          previous: '前のページ',
	          last: '前のページ'
	        },
	        menu: {
	          text: '列の選択:'
	        },
	        sort: {
	          ascending: '昇順に並べ替え',
	          descending: '降順に並べ替え',
	          remove: '並べ替えの解除'
	        },
	        column: {
	          hide: '列の非表示'
	        },
	        aggregation: {
	          count: '合計行数: ',
	          sum: '合計: ',
	          avg: '平均: ',
	          min: '最小: ',
	          max: '最大: '
	        },
	        pinning: {
	          pinLeft: '左に固定',
	          pinRight: '右に固定',
	          unpin: '固定解除'
	        },
	        gridMenu: {
	          columns: '列:',
	          importerTitle: 'ファイルのインポート',
	          exporterAllAsCsv: 'すべてのデータをCSV形式でエクスポート',
	          exporterVisibleAsCsv: '表示中のデータをCSV形式でエクスポート',
	          exporterSelectedAsCsv: '選択したデータをCSV形式でエクスポート',
	          exporterAllAsPdf: 'すべてのデータをPDF形式でエクスポート',
	          exporterVisibleAsPdf: '表示中のデータをPDF形式でエクスポート',
	          exporterSelectedAsPdf: '選択したデータをPDF形式でエクスポート',
	          clearAllFilters: 'すべてのフィルタを清掃してください'
	        },
	        importer: {
	          noHeaders: '列名を取得できません。ファイルにヘッダが含まれていることを確認してください。',
	          noObjects: 'オブジェクトを取得できません。ファイルにヘッダ以外のデータが含まれていることを確認してください。',
	          invalidCsv: 'ファイルを処理できません。ファイルが有効なCSV形式であることを確認してください。',
	          invalidJson: 'ファイルを処理できません。ファイルが有効なJSON形式であることを確認してください。',
	          jsonNotArray: 'インポートしたJSONファイルには配列が含まれている必要があります。処理を中止します。'
	        },
	        pagination: {
	          sizes: '項目/ページ',
	          totalItems: '項目'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ko', {
	        aggregate: {
	          label: '아이템'
	        },
	        groupPanel: {
	          description: '컬럼으로 그룹핑하기 위해서는 컬럼 헤더를 끌어 떨어뜨려 주세요.'
	        },
	        search: {
	          placeholder: '검색...',
	          showingItems: '항목 보여주기:',
	          selectedItems: '선택 항목:',
	          totalItems: '전체 항목:',
	          size: '페이지 크기:',
	          first: '첫번째 페이지',
	          next: '다음 페이지',
	          previous: '이전 페이지',
	          last: '마지막 페이지'
	        },
	        menu: {
	          text: '컬럼을 선택하세요:'
	        },
	        sort: {
	          ascending: '오름차순 정렬',
	          descending: '내림차순 정렬',
	          remove: '소팅 제거'
	        },
	        column: {
	          hide: '컬럼 제거'
	        },
	        aggregation: {
	          count: '전체 갯수: ',
	          sum: '전체: ',
	          avg: '평균: ',
	          min: '최소: ',
	          max: '최대: '
	        },
	        pinning: {
	         pinLeft: '왼쪽 핀',
	          pinRight: '오른쪽 핀',
	          unpin: '핀 제거'
	        },
	        gridMenu: {
	          columns: '컬럼:',
	          importerTitle: '파일 가져오기',
	          exporterAllAsCsv: 'csv로 모든 데이터 내보내기',
	          exporterVisibleAsCsv: 'csv로 보이는 데이터 내보내기',
	          exporterSelectedAsCsv: 'csv로 선택된 데이터 내보내기',
	          exporterAllAsPdf: 'pdf로 모든 데이터 내보내기',
	          exporterVisibleAsPdf: 'pdf로 보이는 데이터 내보내기',
	          exporterSelectedAsPdf: 'pdf로 선택 데이터 내보내기',
	          clearAllFilters: '모든 필터를 청소'
	        },
	        importer: {
	          noHeaders: '컬럼명이 지정되어 있지 않습니다. 파일에 헤더가 명시되어 있는지 확인해 주세요.',
	          noObjects: '데이터가 지정되어 있지 않습니다. 데이터가 파일에 있는지 확인해 주세요.',
	          invalidCsv: '파일을 처리할 수 없습니다. 올바른 csv인지 확인해 주세요.',
	          invalidJson: '파일을 처리할 수 없습니다. 올바른 json인지 확인해 주세요.',
	          jsonNotArray: 'json 파일은 배열을 포함해야 합니다.'
	        },
	        pagination: {
	          sizes: '페이지당 항목',
	          totalItems: '전체 항목'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('nl', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Sleep hier een kolomnaam heen om op te groeperen.'
	        },
	        search: {
	          placeholder: 'Zoeken...',
	          showingItems: 'Getoonde items:',
	          selectedItems: 'Geselecteerde items:',
	          totalItems: 'Totaal aantal items:',
	          size: 'Items per pagina:',
	          first: 'Eerste pagina',
	          next: 'Volgende pagina',
	          previous: 'Vorige pagina',
	          last: 'Laatste pagina'
	        },
	        menu: {
	          text: 'Kies kolommen:'
	        },
	        sort: {
	          ascending: 'Sorteer oplopend',
	          descending: 'Sorteer aflopend',
	          remove: 'Verwijder sortering'
	        },
	        column: {
	          hide: 'Verberg kolom'
	        },
	        aggregation: {
	          count: 'Aantal rijen: ',
	          sum: 'Som: ',
	          avg: 'Gemiddelde: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Zet links vast',
	          pinRight: 'Zet rechts vast',
	          unpin: 'Maak los'
	        },
	        gridMenu: {
	          columns: 'Kolommen:',
	          importerTitle: 'Importeer bestand',
	          exporterAllAsCsv: 'Exporteer alle data als csv',
	          exporterVisibleAsCsv: 'Exporteer zichtbare data als csv',
	          exporterSelectedAsCsv: 'Exporteer geselecteerde data als csv',
	          exporterAllAsPdf: 'Exporteer alle data als pdf',
	          exporterVisibleAsPdf: 'Exporteer zichtbare data als pdf',
	          exporterSelectedAsPdf: 'Exporteer geselecteerde data als pdf',
	          clearAllFilters: 'Reinig alle filters'
	        },
	        importer: {
	          noHeaders: 'Kolomnamen kunnen niet worden afgeleid. Heeft het bestand een header?',
	          noObjects: 'Objecten kunnen niet worden afgeleid. Bevat het bestand data naast de headers?',
	          invalidCsv: 'Het bestand kan niet verwerkt worden. Is het een valide csv bestand?',
	          invalidJson: 'Het bestand kan niet verwerkt worden. Is het valide json?',
	          jsonNotArray: 'Het json bestand moet een array bevatten. De actie wordt geannuleerd.'
	        },
	        pagination: {
	            sizes: 'items per pagina',
	            totalItems: 'items',
	            of: 'van de'
	        },
	        grouping: {
	            group: 'Groepeer',
	            ungroup: 'Groepering opheffen',
	            aggregate_count: 'Agg: Aantal',
	            aggregate_sum: 'Agg: Som',
	            aggregate_max: 'Agg: Max',
	            aggregate_min: 'Agg: Min',
	            aggregate_avg: 'Agg: Gem',
	            aggregate_remove: 'Agg: Verwijder'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt-br', {
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Items Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        gridMenu: {
	          columns: 'Colunas:',
	          importerTitle: 'Importar arquivo',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O arquivo tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no arquivo, além dos cabeçalhos?',
	          invalidCsv: 'Arquivo não pode ser processado. É um CSV válido?',
	          invalidJson: 'Arquivo não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Arquivo json importado tem que conter um array. Abortando.'
	        },
	        pagination: {
	          sizes: 'itens por página',
	          totalItems: 'itens'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt', {
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Itens Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        gridMenu: {
	          columns: 'Colunas:',
	          importerTitle: 'Importar ficheiro',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O ficheiro tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no ficheiro, além dos cabeçalhos?',
	          invalidCsv: 'Ficheiro não pode ser processado. É um CSV válido?',
	          invalidJson: 'Ficheiro não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Ficheiro json importado tem que conter um array. Interrompendo.'
	        },
	        pagination: {
	          sizes: 'itens por página',
	          totalItems: 'itens',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ru', {
	        aggregate: {
	          label: 'элементы'
	        },
	        groupPanel: {
	          description: 'Для группировки по столбцу перетащите сюда его название.'
	        },
	        search: {
	          placeholder: 'Поиск...',
	          showingItems: 'Показать элементы:',
	          selectedItems: 'Выбранные элементы:',
	          totalItems: 'Всего элементов:',
	          size: 'Размер страницы:',
	          first: 'Первая страница',
	          next: 'Следующая страница',
	          previous: 'Предыдущая страница',
	          last: 'Последняя страница'
	        },
	        menu: {
	          text: 'Выбрать столбцы:'
	        },
	        sort: {
	          ascending: 'По возрастанию',
	          descending: 'По убыванию',
	          remove: 'Убрать сортировку'
	        },
	        column: {
	          hide: 'Спрятать столбец'
	        },
	        aggregation: {
	          count: 'всего строк: ',
	          sum: 'итого: ',
	          avg: 'среднее: ',
	          min: 'мин: ',
	          max: 'макс: '
	        },
					pinning: {
						pinLeft: 'Закрепить слева',
						pinRight: 'Закрепить справа',
						unpin: 'Открепить'
					},
	        gridMenu: {
	          columns: 'Столбцы:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Экспортировать всё в CSV',
	          exporterVisibleAsCsv: 'Экспортировать видимые данные в CSV',
	          exporterSelectedAsCsv: 'Экспортировать выбранные данные в CSV',
	          exporterAllAsPdf: 'Экспортировать всё в PDF',
	          exporterVisibleAsPdf: 'Экспортировать видимые данные в PDF',
	          exporterSelectedAsPdf: 'Экспортировать выбранные данные в PDF',
	          clearAllFilters: 'Очистите все фильтры'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('sk', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Pretiahni sem názov stĺpca pre zoskupenie podľa toho stĺpca.'
	        },
	        search: {
	          placeholder: 'Hľadaj...',
	          showingItems: 'Zobrazujem položky:',
	          selectedItems: 'Vybraté položky:',
	          totalItems: 'Počet položiek:',
	          size: 'Počet:',
	          first: 'Prvá strana',
	          next: 'Ďalšia strana',
	          previous: 'Predchádzajúca strana',
	          last: 'Posledná strana'
	        },
	        menu: {
	          text: 'Vyberte stĺpce:'
	        },
	        sort: {
	          ascending: 'Zotriediť vzostupne',
	          descending: 'Zotriediť zostupne',
	          remove: 'Vymazať triedenie'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('sv', {
	        aggregate: {
	          label: 'Artiklar'
	        },
	        groupPanel: {
	          description: 'Dra en kolumnrubrik hit och släpp den för att gruppera efter den kolumnen.'
	        },
	        search: {
	          placeholder: 'Sök...',
	          showingItems: 'Visar artiklar:',
	          selectedItems: 'Valda artiklar:',
	          totalItems: 'Antal artiklar:',
	          size: 'Sidstorlek:',
	          first: 'Första sidan',
	          next: 'Nästa sida',
	          previous: 'Föregående sida',
	          last: 'Sista sidan'
	        },
	        menu: {
	          text: 'Välj kolumner:'
	        },
	        sort: {
	          ascending: 'Sortera stigande',
	          descending: 'Sortera fallande',
	          remove: 'Inaktivera sortering'
	        },
	        column: {
	          hide: 'Göm kolumn'
	        },
	        aggregation: {
	          count: 'Antal rader: ',
	          sum: 'Summa: ',
	          avg: 'Genomsnitt: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Fäst vänster',
	          pinRight: 'Fäst höger',
	          unpin: 'Lösgör'
	        },
	        gridMenu: {
	          columns: 'Kolumner:',
	          importerTitle: 'Importera fil',
	          exporterAllAsCsv: 'Exportera all data som CSV',
	          exporterVisibleAsCsv: 'Exportera synlig data som CSV',
	          exporterSelectedAsCsv: 'Exportera markerad data som CSV',
	          exporterAllAsPdf: 'Exportera all data som PDF',
	          exporterVisibleAsPdf: 'Exportera synlig data som PDF',
	          exporterSelectedAsPdf: 'Exportera markerad data som PDF',
	          clearAllFilters: 'Rengör alla filter'
	        },
	        importer: {
	          noHeaders: 'Kolumnnamn kunde inte härledas. Har filen ett sidhuvud?',
	          noObjects: 'Objekt kunde inte härledas. Har filen data undantaget sidhuvud?',
	          invalidCsv: 'Filen kunde inte behandlas, är den en giltig CSV?',
	          invalidJson: 'Filen kunde inte behandlas, är den en giltig JSON?',
	          jsonNotArray: 'Importerad JSON-fil måste innehålla ett fält. Import avbruten.'
	        },
	        pagination: {
	          sizes: 'Artiklar per sida',
	          totalItems: 'Artiklar'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ta', {
	        aggregate: {
	          label: 'உருப்படிகள்'
	        },
	        groupPanel: {
	          description: 'ஒரு பத்தியை குழுவாக அமைக்க அப்பத்தியின் தலைப்பை இங்கே  இழுத்து வரவும் '
	        },
	        search: {
	          placeholder: 'தேடல் ...',
	          showingItems: 'உருப்படிகளை காண்பித்தல்:',
	          selectedItems: 'தேர்ந்தெடுக்கப்பட்ட  உருப்படிகள்:',
	          totalItems: 'மொத்த உருப்படிகள்:',
	          size: 'பக்க அளவு: ',
	          first: 'முதல் பக்கம்',
	          next: 'அடுத்த பக்கம்',
	          previous: 'முந்தைய பக்கம் ',
	          last: 'இறுதி பக்கம்'
	        },
	        menu: {
	          text: 'பத்திகளை தேர்ந்தெடு:'
	        },
	        sort: {
	          ascending: 'மேலிருந்து கீழாக',
	          descending: 'கீழிருந்து மேலாக',
	          remove: 'வரிசையை நீக்கு'
	        },
	        column: {
	          hide: 'பத்தியை மறைத்து வை '
	        },
	        aggregation: {
	          count: 'மொத்த வரிகள்:',
	          sum: 'மொத்தம்: ',
	          avg: 'சராசரி: ',
	          min: 'குறைந்தபட்ச: ',
	          max: 'அதிகபட்ச: '
	        },
	        pinning: {
	         pinLeft: 'இடதுபுறமாக தைக்க ',
	          pinRight: 'வலதுபுறமாக தைக்க',
	          unpin: 'பிரி'
	        },
	        gridMenu: {
	          columns: 'பத்திகள்:',
	          importerTitle: 'கோப்பு : படித்தல்',
	          exporterAllAsCsv: 'எல்லா தரவுகளையும் கோப்பாக்கு: csv',
	          exporterVisibleAsCsv: 'இருக்கும் தரவுகளை கோப்பாக்கு: csv',
	          exporterSelectedAsCsv: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: csv',
	          exporterAllAsPdf: 'எல்லா தரவுகளையும் கோப்பாக்கு: pdf',
	          exporterVisibleAsPdf: 'இருக்கும் தரவுகளை கோப்பாக்கு: pdf',
	          exporterSelectedAsPdf: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: pdf',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'பத்தியின் தலைப்புகளை பெற இயலவில்லை, கோப்பிற்கு தலைப்பு உள்ளதா?',
	          noObjects: 'இலக்குகளை உருவாக்க முடியவில்லை, கோப்பில் தலைப்புகளை தவிர தரவு ஏதேனும் உள்ளதா? ',
	          invalidCsv:	'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - csv',
	          invalidJson: 'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - json',
	          jsonNotArray: 'படித்த கோப்பில் வரிசைகள் உள்ளது, நடைமுறை ரத்து செய் : json'
	        },
	        pagination: {
	          sizes		: 'உருப்படிகள் / பக்கம்',
	          totalItems	: 'உருப்படிகள் '
	        },
	        grouping: {
	          group	: 'குழு',
	          ungroup : 'பிரி',
	          aggregate_count	: 'மதிப்பீட்டு : எண்ணு',
	          aggregate_sum : 'மதிப்பீட்டு : கூட்டல்',
	          aggregate_max	: 'மதிப்பீட்டு : அதிகபட்சம்',
	          aggregate_min	: 'மதிப்பீட்டு : குறைந்தபட்சம்',
	          aggregate_avg	: 'மதிப்பீட்டு : சராசரி',
	          aggregate_remove : 'மதிப்பீட்டு : நீக்கு'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	/**
	 * @ngdoc overview
	 * @name ui.grid.i18n
	 * @description
	 *
	 *  # ui.grid.i18n
	 * This module provides i18n functions to ui.grid and any application that wants to use it
	
	 *
	 * <div doc-module-components="ui.grid.i18n"></div>
	 */
	
	(function () {
	  var DIRECTIVE_ALIASES = ['uiT', 'uiTranslate'];
	  var FILTER_ALIASES = ['t', 'uiTranslate'];
	
	  var module = angular.module('ui.grid.i18n');
	
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.i18n.constant:i18nConstants
	   *
	   *  @description constants available in i18n module
	   */
	  module.constant('i18nConstants', {
	    MISSING: '[MISSING]',
	    UPDATE_EVENT: '$uiI18n',
	
	    LOCALE_DIRECTIVE_ALIAS: 'uiI18n',
	    // default to english
	    DEFAULT_LANG: 'en'
	  });
	
	//    module.config(['$provide', function($provide) {
	//        $provide.decorator('i18nService', ['$delegate', function($delegate) {}])}]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.i18n.service:i18nService
	   *
	   *  @description Services for i18n
	   */
	  module.service('i18nService', ['$log', 'i18nConstants', '$rootScope',
	    function ($log, i18nConstants, $rootScope) {
	
	      var langCache = {
	        _langs: {},
	        current: null,
	        get: function (lang) {
	          return this._langs[lang.toLowerCase()];
	        },
	        add: function (lang, strings) {
	          var lower = lang.toLowerCase();
	          if (!this._langs[lower]) {
	            this._langs[lower] = {};
	          }
	          angular.extend(this._langs[lower], strings);
	        },
	        getAllLangs: function () {
	          var langs = [];
	          if (!this._langs) {
	            return langs;
	          }
	
	          for (var key in this._langs) {
	            langs.push(key);
	          }
	
	          return langs;
	        },
	        setCurrent: function (lang) {
	          this.current = lang.toLowerCase();
	        },
	        getCurrentLang: function () {
	          return this.current;
	        }
	      };
	
	      var service = {
	
	        /**
	         * @ngdoc service
	         * @name add
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  Adds the languages and strings to the cache. Decorate this service to
	         * add more translation strings
	         * @param {string} lang language to add
	         * @param {object} stringMaps of strings to add grouped by property names
	         * @example
	         * <pre>
	         *      i18nService.add('en', {
	         *         aggregate: {
	         *                 label1: 'items',
	         *                 label2: 'some more items'
	         *                 }
	         *         },
	         *         groupPanel: {
	         *              description: 'Drag a column header here and drop it to group by that column.'
	         *           }
	         *      }
	         * </pre>
	         */
	        add: function (langs, stringMaps) {
	          if (typeof(langs) === 'object') {
	            angular.forEach(langs, function (lang) {
	              if (lang) {
	                langCache.add(lang, stringMaps);
	              }
	            });
	          } else {
	            langCache.add(langs, stringMaps);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getAllLangs
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @returns {array} string
	         */
	        getAllLangs: function () {
	          return langCache.getAllLangs();
	        },
	
	        /**
	         * @ngdoc service
	         * @name get
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @param {string} lang to return.  If not specified, returns current language
	         * @returns {object} the translation string maps for the language
	         */
	        get: function (lang) {
	          var language = lang ? lang : service.getCurrentLang();
	          return langCache.get(language);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getSafeText
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  returns the text specified in the path or a Missing text if text is not found
	         * @param {string} path property path to use for retrieving text from string map
	         * @param {string} lang to return.  If not specified, returns current language
	         * @returns {object} the translation for the path
	         * @example
	         * <pre>
	         * i18nService.getSafeText('sort.ascending')
	         * </pre>
	         */
	        getSafeText: function (path, lang) {
	          var language = lang ? lang : service.getCurrentLang();
	          var trans = langCache.get(language);
	
	          if (!trans) {
	            return i18nConstants.MISSING;
	          }
	
	          var paths = path.split('.');
	          var current = trans;
	
	          for (var i = 0; i < paths.length; ++i) {
	            if (current[paths[i]] === undefined || current[paths[i]] === null) {
	              return i18nConstants.MISSING;
	            } else {
	              current = current[paths[i]];
	            }
	          }
	
	          return current;
	
	        },
	
	        /**
	         * @ngdoc service
	         * @name setCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description sets the current language to use in the application
	         * $broadcasts the Update_Event on the $rootScope
	         * @param {string} lang to set
	         * @example
	         * <pre>
	         * i18nService.setCurrentLang('fr');
	         * </pre>
	         */
	
	        setCurrentLang: function (lang) {
	          if (lang) {
	            langCache.setCurrent(lang);
	            $rootScope.$broadcast(i18nConstants.UPDATE_EVENT);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description returns the current language used in the application
	         */
	        getCurrentLang: function () {
	          var lang = langCache.getCurrentLang();
	          if (!lang) {
	            lang = i18nConstants.DEFAULT_LANG;
	            langCache.setCurrent(lang);
	          }
	          return lang;
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	  var localeDirective = function (i18nService, i18nConstants) {
	    return {
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var alias = i18nConstants.LOCALE_DIRECTIVE_ALIAS;
	            // check for watchable property
	            var lang = $scope.$eval($attrs[alias]);
	            if (lang) {
	              $scope.$watch($attrs[alias], function () {
	                i18nService.setCurrentLang(lang);
	              });
	            } else if ($attrs.$$observers) {
	              $attrs.$observe(alias, function () {
	                i18nService.setCurrentLang($attrs[alias] || i18nConstants.DEFAULT_LANG);
	              });
	            }
	          }
	        };
	      }
	    };
	  };
	
	  module.directive('uiI18n', ['i18nService', 'i18nConstants', localeDirective]);
	
	  // directive syntax
	  var uitDirective = function ($parse, i18nService, i18nConstants) {
	    return {
	      restrict: 'EA',
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var alias1 = DIRECTIVE_ALIASES[0],
	              alias2 = DIRECTIVE_ALIASES[1];
	            var token = $attrs[alias1] || $attrs[alias2] || $elm.html();
	            var missing = i18nConstants.MISSING + token;
	            var observer;
	            if ($attrs.$$observers) {
	              var prop = $attrs[alias1] ? alias1 : alias2;
	              observer = $attrs.$observe(prop, function (result) {
	                if (result) {
	                  $elm.html($parse(result)(i18nService.getCurrentLang()) || missing);
	                }
	              });
	            }
	            var getter = $parse(token);
	            var listener = $scope.$on(i18nConstants.UPDATE_EVENT, function (evt) {
	              if (observer) {
	                observer($attrs[alias1] || $attrs[alias2]);
	              } else {
	                // set text based on i18n current language
	                $elm.html(getter(i18nService.get()) || missing);
	              }
	            });
	            $scope.$on('$destroy', listener);
	
	            $elm.html(getter(i18nService.get()) || missing);
	          }
	        };
	      }
	    };
	  };
	
	  angular.forEach( DIRECTIVE_ALIASES, function ( alias ) {
	    module.directive( alias, ['$parse', 'i18nService', 'i18nConstants', uitDirective] );
	  } );
	
	  // optional filter syntax
	  var uitFilter = function ($parse, i18nService, i18nConstants) {
	    return function (data) {
	      var getter = $parse(data);
	      // set text based on i18n current language
	      return getter(i18nService.get()) || i18nConstants.MISSING + data;
	    };
	  };
	
	  angular.forEach( FILTER_ALIASES, function ( alias ) {
	    module.filter( alias, ['$parse', 'i18nService', 'i18nConstants', uitFilter] );
	  } );
	
	
	})();
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-cn', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: '列过滤器',
	            removeFilter: '移除过滤器',
	            columnMenuButtonLabel: '列菜单'
	          },
	          priority: '优先级:',
	          filterLabel: "列过滤器: "
	        },
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表头到此处进行分组'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已显示行数：',
	          selectedItems: '已选择行数：',
	          totalItems: '总行数：',
	          size: '每页显示行数：',
	          first: '首页',
	          next: '下一页',
	          previous: '上一页',
	          last: '末页'
	        },
	        menu: {
	          text: '选择列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          none: '无序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隐藏列'
	        },
	        aggregation: {
	          count: '计数：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左侧固定',
	          pinRight: '右侧固定',
	          unpin: '取消固定'
	        },
	        columnMenu: {
	          close: '关闭'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: '表格菜单'
	          },
	          columns: '列：',
	          importerTitle: '导入文件',
	          exporterAllAsCsv: '导出全部数据到CSV',
	          exporterVisibleAsCsv: '导出可见数据到CSV',
	          exporterSelectedAsCsv: '导出已选数据到CSV',
	          exporterAllAsPdf: '导出全部数据到PDF',
	          exporterVisibleAsPdf: '导出可见数据到PDF',
	          exporterSelectedAsPdf: '导出已选数据到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '无法获取列名，确定文件包含表头？',
	          noObjects: '无法获取数据，确定文件包含数据？',
	          invalidCsv: '无法处理文件，确定是合法的CSV文件？',
	          invalidJson: '无法处理文件，确定是合法的JSON文件？',
	          jsonNotArray: '导入的文件不是JSON数组！'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: '第一页',
	            pageBack: '上一页',
	            pageSelected: '当前页',
	            pageForward: '下一页',
	            pageToLast: '最后一页'
	          },
	          sizes: '行每页',
	          totalItems: '行',
	          through: '至',
	          of: '共'
	        },
	        grouping: {
	          group: '分组',
	          ungroup: '取消分组',
	          aggregate_count: '合计: 计数',
	          aggregate_sum: '合计: 求和',
	          aggregate_max: '合计: 最大',
	          aggregate_min: '合计: 最小',
	          aggregate_avg: '合计: 平均',
	          aggregate_remove: '合计: 移除'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-tw', {
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表頭到此處進行分組'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已顯示行數：',
	          selectedItems: '已選擇行數：',
	          totalItems: '總行數：',
	          size: '每頁顯示行數：',
	          first: '首頁',
	          next: '下壹頁',
	          previous: '上壹頁',
	          last: '末頁'
	        },
	        menu: {
	          text: '選擇列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隱藏列'
	        },
	        aggregation: {
	          count: '計數：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左側固定',
	          pinRight: '右側固定',
	          unpin: '取消固定'
	        },
	        gridMenu: {
	          columns: '列：',
	          importerTitle: '導入文件',
	          exporterAllAsCsv: '導出全部數據到CSV',
	          exporterVisibleAsCsv: '導出可見數據到CSV',
	          exporterSelectedAsCsv: '導出已選數據到CSV',
	          exporterAllAsPdf: '導出全部數據到PDF',
	          exporterVisibleAsPdf: '導出可見數據到PDF',
	          exporterSelectedAsPdf: '導出已選數據到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '無法獲取列名，確定文件包含表頭？',
	          noObjects: '無法獲取數據，確定文件包含數據？',
	          invalidCsv: '無法處理文件，確定是合法的CSV文件？',
	          invalidJson: '無法處理文件，確定是合法的JSON文件？',
	          jsonNotArray: '導入的文件不是JSON數組！'
	        },
	        pagination: {
	          sizes: '行每頁',
	          totalItems: '行'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.autoResize
	   *
	   *  @description
	   *
	   *  #ui.grid.autoResize
	   *
	   *  <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   *  This module provides auto-resizing functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.autoResize', ['ui.grid']);
	
	
	  module.directive('uiGridAutoResize', ['$timeout', 'gridUtil', function ($timeout, gridUtil) {
	    return {
	      require: 'uiGrid',
	      scope: false,
	      link: function ($scope, $elm, $attrs, uiGridCtrl) {
	        var prevGridWidth, prevGridHeight;
	
	        function getDimensions() {
	          prevGridHeight = gridUtil.elementHeight($elm);
	          prevGridWidth = gridUtil.elementWidth($elm);
	        }
	
	        // Initialize the dimensions
	        getDimensions();
	
	        var resizeTimeoutId;
	        function startTimeout() {
	          clearTimeout(resizeTimeoutId);
	
	          resizeTimeoutId = setTimeout(function () {
	            var newGridHeight = gridUtil.elementHeight($elm);
	            var newGridWidth = gridUtil.elementWidth($elm);
	
	            if (newGridHeight !== prevGridHeight || newGridWidth !== prevGridWidth) {
	              uiGridCtrl.grid.gridHeight = newGridHeight;
	              uiGridCtrl.grid.gridWidth = newGridWidth;
	
	              $scope.$apply(function () {
	                uiGridCtrl.grid.refresh()
	                  .then(function () {
	                    getDimensions();
	
	                    startTimeout();
	                  });
	              });
	            }
	            else {
	              startTimeout();
	            }
	          }, 250);
	        }
	
	        startTimeout();
	
	        $scope.$on('$destroy', function() {
	          clearTimeout(resizeTimeoutId);
	        });
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.cellNav
	   *
	   *  @description
	
	      #ui.grid.cellNav
	
	      <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	
	      This module provides auto-resizing functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.cellNav', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.cellNav.constant:uiGridCellNavConstants
	   *
	   *  @description constants available in cellNav
	   */
	  module.constant('uiGridCellNavConstants', {
	    FEATURE_NAME: 'gridCellNav',
	    CELL_NAV_EVENT: 'cellNav',
	    direction: {LEFT: 0, RIGHT: 1, UP: 2, DOWN: 3, PG_UP: 4, PG_DOWN: 5},
	    EVENT_TYPE: {
	      KEYDOWN: 0,
	      CLICK: 1,
	      CLEAR: 2
	    }
	  });
	
	
	  module.factory('uiGridCellNavFactory', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', 'GridRowColumn', '$q',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, GridRowColumn, $q) {
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.object:CellNav
	       *  @description returns a CellNav prototype function
	       *  @param {object} rowContainer container for rows
	       *  @param {object} colContainer parent column container
	       *  @param {object} leftColContainer column container to the left of parent
	       *  @param {object} rightColContainer column container to the right of parent
	       */
	      var UiGridCellNav = function UiGridCellNav(rowContainer, colContainer, leftColContainer, rightColContainer) {
	        this.rows = rowContainer.visibleRowCache;
	        this.columns = colContainer.visibleColumnCache;
	        this.leftColumns = leftColContainer ? leftColContainer.visibleColumnCache : [];
	        this.rightColumns = rightColContainer ? rightColContainer.visibleColumnCache : [];
	        this.bodyContainer = rowContainer;
	      };
	
	      /** returns focusable columns of all containers */
	      UiGridCellNav.prototype.getFocusableCols = function () {
	        var allColumns = this.leftColumns.concat(this.columns, this.rightColumns);
	
	        return allColumns.filter(function (col) {
	          return col.colDef.allowCellFocus;
	        });
	      };
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.api:GridRow
	       *
	       *  @description GridRow settings for cellNav feature, these are available to be
	       *  set only internally (for example, by other features)
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name allowCellFocus
	       *  @propertyOf  ui.grid.cellNav.api:GridRow
	       *  @description Enable focus on a cell within this row.  If set to false then no cells
	       *  in this row can be focused - group header rows as an example would set this to false.
	       *  <br/>Defaults to true
	       */
	      /** returns focusable rows */
	      UiGridCellNav.prototype.getFocusableRows = function () {
	        return this.rows.filter(function(row) {
	          return row.allowCellFocus !== false;
	        });
	      };
	
	      UiGridCellNav.prototype.getNextRowCol = function (direction, curRow, curCol) {
	        switch (direction) {
	          case uiGridCellNavConstants.direction.LEFT:
	            return this.getRowColLeft(curRow, curCol);
	          case uiGridCellNavConstants.direction.RIGHT:
	            return this.getRowColRight(curRow, curCol);
	          case uiGridCellNavConstants.direction.UP:
	            return this.getRowColUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.DOWN:
	            return this.getRowColDown(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_UP:
	            return this.getRowColPageUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_DOWN:
	            return this.getRowColPageDown(curRow, curCol);
	        }
	
	      };
	
	      UiGridCellNav.prototype.initializeSelection = function () {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        if (focusableCols.length === 0 || focusableRows.length === 0) {
	          return null;
	        }
	
	        var curRowIndex = 0;
	        var curColIndex = 0;
	        return new GridRowColumn(focusableRows[0], focusableCols[0]); //return same row
	      };
	
	      UiGridCellNav.prototype.getRowColLeft = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 1
	        if (curColIndex === -1) {
	          curColIndex = 1;
	        }
	
	        var nextColIndex = curColIndex === 0 ? focusableCols.length - 1 : curColIndex - 1;
	
	        //get column to left
	        if (nextColIndex > curColIndex) {
	          // On the first row
	          // if (curRowIndex === 0 && curColIndex === 0) {
	          //   return null;
	          // }
	          if (curRowIndex === 0) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); //return same row
	          }
	          else {
	            //up one row and far right column
	            return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	
	
	      UiGridCellNav.prototype.getRowColRight = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	        var nextColIndex = curColIndex === focusableCols.length - 1 ? 0 : curColIndex + 1;
	
	        if (nextColIndex < curColIndex) {
	          if (curRowIndex === focusableRows.length - 1) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); //return same row
	          }
	          else {
	            //down one row and far left column
	            return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === focusableRows.length - 1) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); //return same row
	        }
	        else {
	          //down one row
	          return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex >= focusableRows.length - pageSize) {
	          return new GridRowColumn(focusableRows[focusableRows.length - 1], focusableCols[curColIndex]); //return last row
	        }
	        else {
	          //down one page
	          return new GridRowColumn(focusableRows[curRowIndex + pageSize], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === 0) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); //return same row
	        }
	        else {
	          //up one row
	          return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex - pageSize < 0) {
	          return new GridRowColumn(focusableRows[0], focusableCols[curColIndex]); //return first row
	        }
	        else {
	          //up one page
	          return new GridRowColumn(focusableRows[curRowIndex - pageSize], focusableCols[curColIndex]);
	        }
	      };
	      return UiGridCellNav;
	    }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.cellNav.service:uiGridCellNavService
	   *
	   *  @description Services for cell navigation features. If you don't like the key maps we use,
	   *  or the direction cells navigation, override with a service decorator (see angular docs)
	   */
	  module.service('uiGridCellNavService', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', '$q', 'uiGridCellNavFactory', 'GridRowColumn', 'ScrollEvent',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, $q, UiGridCellNav, GridRowColumn, ScrollEvent) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	          grid.registerColumnBuilder(service.cellNavColumnBuilder);
	
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav:Grid.cellNav
	           * @description cellNav properties added to grid class
	           */
	          grid.cellNav = {};
	          grid.cellNav.lastRowCol = null;
	          grid.cellNav.focusedCells = [];
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:PublicApi
	           *
	           *  @description Public Api for cellNav feature
	           */
	          var publicApi = {
	            events: {
	              cellNav: {
	                /**
	                 * @ngdoc event
	                 * @name navigate
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description raised when the active cell is changed
	                 * <pre>
	                 *      gridApi.cellNav.on.navigate(scope,function(newRowcol, oldRowCol){})
	                 * </pre>
	                 * @param {object} newRowCol new position
	                 * @param {object} oldRowCol old position
	                 */
	                navigate: function (newRowCol, oldRowCol) {},
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyDown
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyDown event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keydown event on a cell
	                 * <br/>
	                 * @param {object} event keydown event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyDown: function (event, rowCol) {},
	
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyPress
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyPress event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keypress event on a cell
	                 * <br/>
	                 * @param {object} event keypress event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyPress: function (event, rowCol) {}
	              }
	            },
	            methods: {
	              cellNav: {
	                /**
	                 * @ngdoc function
	                 * @name scrollToFocus
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description brings the specified row and column into view, and sets focus
	                 * to that cell
	                 * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus
	                 * @param {object} colDef to make visible and set focus
	                 * @returns {promise} a promise that is resolved after any scrolling is finished
	                 */
	                scrollToFocus: function (rowEntity, colDef) {
	                  return service.scrollToFocus(grid, rowEntity, colDef);
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getFocusedCell
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the current (or last if Grid does not have focus) focused row and column
	                 * <br> value is null if no selection has occurred
	                 */
	                getFocusedCell: function () {
	                  return grid.cellNav.lastRowCol;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getCurrentSelection
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns an array containing the current selection
	                 * <br> array is empty if no selection has occurred
	                 */
	                getCurrentSelection: function () {
	                  return grid.cellNav.focusedCells;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name rowColSelectIndex
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the index in the order in which the GridRowColumn was selected, returns -1 if the GridRowColumn
	                 * isn't selected
	                 * @param {object} rowCol the rowCol to evaluate
	                 */
	                rowColSelectIndex: function (rowCol) {
	                  //return gridUtil.arrayContainsObjectWithProperty(grid.cellNav.focusedCells, 'col.uid', rowCol.col.uid) &&
	                  var index = -1;
	                  for (var i = 0; i < grid.cellNav.focusedCells.length; i++) {
	                    if (grid.cellNav.focusedCells[i].col.uid === rowCol.col.uid &&
	                      grid.cellNav.focusedCells[i].row.uid === rowCol.row.uid) {
	                      index = i;
	                      break;
	                    }
	                  }
	                  return index;
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:GridOptions
	           *
	           *  @description GridOptions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelectCells
	           *  @propertyOf  ui.grid.cellNav.api:GridOptions
	           *  @description Enable multiple cell selection only when using the ctrlKey or shiftKey.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelectCells = gridOptions.modifierKeysToMultiSelectCells === true;
	
	        },
	
	        /**
	         * @ngdoc service
	         * @name decorateRenderContainers
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  decorates grid renderContainers with cellNav functions
	         */
	        decorateRenderContainers: function (grid) {
	
	          var rightContainer = grid.hasRightContainer() ? grid.renderContainers.right : null;
	          var leftContainer = grid.hasLeftContainer() ? grid.renderContainers.left : null;
	
	          if (leftContainer !== null) {
	            grid.renderContainers.left.cellNav = new UiGridCellNav(grid.renderContainers.body, leftContainer, rightContainer, grid.renderContainers.body);
	          }
	          if (rightContainer !== null) {
	            grid.renderContainers.right.cellNav = new UiGridCellNav(grid.renderContainers.body, rightContainer, grid.renderContainers.body, leftContainer);
	          }
	
	          grid.renderContainers.body.cellNav = new UiGridCellNav(grid.renderContainers.body, grid.renderContainers.body, leftContainer, rightContainer);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getDirection
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  determines which direction to for a given keyDown event
	         * @returns {uiGridCellNavConstants.direction} direction
	         */
	        getDirection: function (evt) {
	          if (evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey)) {
	            return uiGridCellNavConstants.direction.LEFT;
	          }
	          if (evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB) {
	            return uiGridCellNavConstants.direction.RIGHT;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ) {
	            return uiGridCellNavConstants.direction.UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_UP){
	            return uiGridCellNavConstants.direction.PG_UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER && !(evt.ctrlKey || evt.altKey)) {
	            return uiGridCellNavConstants.direction.DOWN;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_DOWN){
	            return uiGridCellNavConstants.direction.PG_DOWN;
	          }
	
	          return null;
	        },
	
	        /**
	         * @ngdoc service
	         * @name cellNavColumnBuilder
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description columnBuilder function that adds cell navigation properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        cellNavColumnBuilder: function (colDef, col, gridOptions) {
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:ColumnDef
	           *
	           *  @description Column Definitions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name allowCellFocus
	           *  @propertyOf  ui.grid.cellNav.api:ColumnDef
	           *  @description Enable focus on a cell within this column.
	           *  <br/>Defaults to true
	           */
	          colDef.allowCellFocus = colDef.allowCellFocus === undefined ? true : colDef.allowCellFocus;
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name scrollToFocus
	         * @description Scroll the grid such that the specified
	         * row and column is in view, and set focus to the cell in that row and column
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus to
	         * @param {object} colDef to make visible and set focus to
	         * @returns {promise} a promise that is resolved after any scrolling is finished
	         */
	        scrollToFocus: function (grid, rowEntity, colDef) {
	          var gridRow = null, gridCol = null;
	
	          if (typeof(rowEntity) !== 'undefined' && rowEntity !== null) {
	            gridRow = grid.getRow(rowEntity);
	          }
	
	          if (typeof(colDef) !== 'undefined' && colDef !== null) {
	            gridCol = grid.getColumn(colDef.name ? colDef.name : colDef.field);
	          }
	          return grid.api.core.scrollToIfNecessary(gridRow, gridCol).then(function () {
	            var rowCol = { row: gridRow, col: gridCol };
	
	            // Broadcast the navigation
	            if (gridRow !== null && gridCol !== null) {
	              grid.cellNav.broadcastCellNav(rowCol);
	            }
	          });
	
	
	
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name getLeftWidth
	         * @description Get the current drawn width of the columns in the
	         * grid up to the numbered column, and add an apportionment for the
	         * column that we're on.  So if we are on column 0, we want to scroll
	         * 0% (i.e. exclude this column from calc).  If we're on the last column
	         * we want to scroll to 100% (i.e. include this column in the calc). So
	         * we include (thisColIndex / totalNumberCols) % of this column width
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {gridCol} upToCol the column to total up to and including
	         */
	        getLeftWidth: function (grid, upToCol) {
	          var width = 0;
	
	          if (!upToCol) {
	            return width;
	          }
	
	          var lastIndex = grid.renderContainers.body.visibleColumnCache.indexOf( upToCol );
	
	          // total column widths up-to but not including the passed in column
	          grid.renderContainers.body.visibleColumnCache.forEach( function( col, index ) {
	            if ( index < lastIndex ){
	              width += col.drawnWidth;
	            }
	          });
	
	          // pro-rata the final column based on % of total columns.
	          var percentage = lastIndex === 0 ? 0 : (lastIndex + 1) / grid.renderContainers.body.visibleColumnCache.length;
	          width += upToCol.drawnWidth * percentage;
	
	          return width;
	        }
	      };
	
	      return service;
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiCellNav
	   *  @element div
	   *  @restrict EA
	   *
	   *  @description Adds cell navigation features to the grid columns
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.cellNav']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'title'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-cellnav></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridCellnav', ['gridUtil', 'uiGridCellNavService', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn', '$timeout', '$compile',
	    function (gridUtil, uiGridCellNavService, uiGridCellNavConstants, uiGridConstants, GridRowColumn, $timeout, $compile) {
	      return {
	        replace: true,
	        priority: -150,
	        require: '^uiGrid',
	        scope: false,
	        controller: function () {},
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var _scope = $scope;
	
	              var grid = uiGridCtrl.grid;
	              uiGridCellNavService.initializeGrid(grid);
	
	              uiGridCtrl.cellNav = {};
	
	              //Ensure that the object has all of the methods we expect it to
	              uiGridCtrl.cellNav.makeRowCol = function (obj) {
	                if (!(obj instanceof GridRowColumn)) {
	                  obj = new GridRowColumn(obj.row, obj.col);
	                }
	                return obj;
	              };
	
	              uiGridCtrl.cellNav.getActiveCell = function () {
	                var elms = $elm[0].getElementsByClassName('ui-grid-cell-focus');
	                if (elms.length > 0){
	                  return elms[0];
	                }
	
	                return undefined;
	              };
	
	              uiGridCtrl.cellNav.broadcastCellNav = grid.cellNav.broadcastCellNav = function (newRowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                newRowCol = uiGridCtrl.cellNav.makeRowCol(newRowCol);
	
	                uiGridCtrl.cellNav.broadcastFocus(newRowCol, modifierDown, originEvt);
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT, newRowCol, modifierDown, originEvt);
	              };
	
	              uiGridCtrl.cellNav.clearFocus = grid.cellNav.clearFocus = function () {
	                grid.cellNav.focusedCells = [];
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT);
	              };
	
	              uiGridCtrl.cellNav.broadcastFocus = function (rowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                rowCol = uiGridCtrl.cellNav.makeRowCol(rowCol);
	
	                var row = rowCol.row,
	                  col = rowCol.col;
	
	                var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	
	                if (grid.cellNav.lastRowCol === null || rowColSelectIndex === -1) {
	                  var newRowCol = new GridRowColumn(row, col);
	
	                  grid.api.cellNav.raise.navigate(newRowCol, grid.cellNav.lastRowCol);
	                  grid.cellNav.lastRowCol = newRowCol;
	                  if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells && modifierDown) {
	                    grid.cellNav.focusedCells.push(rowCol);
	                  } else {
	                    grid.cellNav.focusedCells = [rowCol];
	                  }
	                } else if (grid.options.modifierKeysToMultiSelectCells && modifierDown &&
	                  rowColSelectIndex >= 0) {
	
	                  grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                }
	              };
	
	              uiGridCtrl.cellNav.handleKeyDown = function (evt) {
	                var direction = uiGridCellNavService.getDirection(evt);
	                if (direction === null) {
	                  return null;
	                }
	
	                var containerId = 'body';
	                if (evt.uiGridTargetRenderContainerId) {
	                  containerId = evt.uiGridTargetRenderContainerId;
	                }
	
	                // Get the last-focused row+col combo
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol) {
	                  // Figure out which new row+combo we're navigating to
	                  var rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(direction, lastRowCol.row, lastRowCol.col);
	                  var focusableCols = uiGridCtrl.grid.renderContainers[containerId].cellNav.getFocusableCols();
	                  var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	                  // Shift+tab on top-left cell should exit cellnav on render container
	                  if (
	                    // Navigating left
	                    direction === uiGridCellNavConstants.direction.LEFT &&
	                    // New col is last col (i.e. wrap around)
	                    rowCol.col === focusableCols[focusableCols.length - 1] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	                  // Tab on bottom-right cell should exit cellnav on render container
	                  else if (
	                    direction === uiGridCellNavConstants.direction.RIGHT &&
	                    // New col is first col (i.e. wrap around)
	                    rowCol.col === focusableCols[0] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    !evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	
	                  // Scroll to the new cell, if it's not completely visible within the render container's viewport
	                  grid.scrollToIfNecessary(rowCol.row, rowCol.col).then(function () {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol);
	                  });
	
	
	                  evt.stopPropagation();
	                  evt.preventDefault();
	
	                  return false;
	                }
	              };
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var _scope = $scope;
	              var grid = uiGridCtrl.grid;
	
	              function addAriaLiveRegion(){
	                // Thanks to google docs for the inspiration behind how to do this
	                // XXX: Why is this entire mess nessasary?
	                // Because browsers take a lot of coercing to get them to read out live regions
	                //http://www.paciellogroup.com/blog/2012/06/html5-accessibility-chops-aria-rolealert-browser-support/
	                var ariaNotifierDomElt = '<div ' +
	                                           'id="' + grid.id +'-aria-speakable" ' +
	                                           'class="ui-grid-a11y-ariascreenreader-speakable ui-grid-offscreen" ' +
	                                           'aria-live="assertive" ' +
	                                           'role="region" ' +
	                                           'aria-atomic="true" ' +
	                                           'aria-hidden="false" ' +
	                                           'aria-relevant="additions" ' +
	                                           '>' +
	                                           '&nbsp;' +
	                                         '</div>';
	
	                var ariaNotifier = $compile(ariaNotifierDomElt)($scope);
	                $elm.prepend(ariaNotifier);
	                $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, function (evt, rowCol, modifierDown, originEvt) {
	                  /*
	                   * If the cell nav event was because of a focus event then we don't want to
	                   * change the notifier text.
	                   * Reasoning: Voice Over fires a focus events when moving arround the grid.
	                   * If the screen reader is handing the grid nav properly then we don't need to
	                   * use the alert to notify the user of the movement.
	                   * In all other cases we do want a notification event.
	                   */
	                  if (originEvt && originEvt.type === 'focus'){return;}
	
	                  function setNotifyText(text){
	                    if (text === ariaNotifier.text()){return;}
	                    ariaNotifier[0].style.clip = 'rect(0px,0px,0px,0px)';
	                    /*
	                     * This is how google docs handles clearing the div. Seems to work better than setting the text of the div to ''
	                     */
	                    ariaNotifier[0].innerHTML = "";
	                    ariaNotifier[0].style.visibility = 'hidden';
	                    ariaNotifier[0].style.visibility = 'visible';
	                    if (text !== ''){
	                      ariaNotifier[0].style.clip = 'auto';
	                      /*
	                       * The space after the text is something that google docs does.
	                       */
	                      ariaNotifier[0].appendChild(document.createTextNode(text + " "));
	                      ariaNotifier[0].style.visibility = 'hidden';
	                      ariaNotifier[0].style.visibility = 'visible';
	                    }
	                  }
	
	                  var values = [];
	                  var currentSelection = grid.api.cellNav.getCurrentSelection();
	                  for (var i = 0; i < currentSelection.length; i++) {
	                    values.push(currentSelection[i].getIntersectionValueFiltered());
	                  }
	                  var cellText = values.toString();
	                  setNotifyText(cellText);
	
	                });
	              }
	              addAriaLiveRegion();
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridRenderContainer', ['$timeout', '$document', 'gridUtil', 'uiGridConstants', 'uiGridCellNavService', '$compile','uiGridCellNavConstants',
	    function ($timeout, $document, gridUtil, uiGridConstants, uiGridCellNavService, $compile, uiGridCellNavConstants) {
	      return {
	        replace: true,
	        priority: -99999, //this needs to run very last
	        require: ['^uiGrid', 'uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                 renderContainerCtrl = controllers[1],
	                 uiGridCellnavCtrl = controllers[2];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	
	              var grid = uiGridCtrl.grid;
	
	              //run each time a render container is created
	              uiGridCellNavService.decorateRenderContainers(grid);
	
	              // focusser only created for body
	              if (containerId !== 'body') {
	                return;
	              }
	
	
	
	              if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells){
	                $elm.attr('aria-multiselectable', true);
	              } else {
	                $elm.attr('aria-multiselectable', false);
	              }
	
	              //add an element with no dimensions that can be used to set focus and capture keystrokes
	              var focuser = $compile('<div class="ui-grid-focuser" role="region" aria-live="assertive" aria-atomic="false" tabindex="0" aria-controls="' + grid.id +'-aria-speakable '+ grid.id + '-grid-container' +'" aria-owns="' + grid.id + '-grid-container' + '"></div>')($scope);
	              $elm.append(focuser);
	
	              focuser.on('focus', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (rowCol === null) {
	                  rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(uiGridCellNavConstants.direction.DOWN, null, null);
	                  if (rowCol.row && rowCol.col) {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol);
	                  }
	                }
	              });
	
	              uiGridCellnavCtrl.setAriaActivedescendant = function(id){
	                $elm.attr('aria-activedescendant', id);
	              };
	
	              uiGridCellnavCtrl.removeAriaActivedescendant = function(id){
	                if ($elm.attr('aria-activedescendant') === id){
	                  $elm.attr('aria-activedescendant', '');
	                }
	              };
	
	
	              uiGridCtrl.focus = function () {
	                gridUtil.focus.byElement(focuser[0]);
	                //allow for first time grid focus
	              };
	
	              var viewPortKeyDownWasRaisedForRowCol = null;
	              // Bind to keydown events in the render container
	              focuser.on('keydown', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                var result = uiGridCtrl.cellNav.handleKeyDown(evt);
	                if (result === null) {
	                  uiGridCtrl.grid.api.cellNav.raise.viewPortKeyDown(evt, rowCol);
	                  viewPortKeyDownWasRaisedForRowCol = rowCol;
	                }
	              });
	              //Bind to keypress events in the render container
	              //keypress events are needed by edit function so the key press
	              //that initiated an edit is not lost
	              //must fire the event in a timeout so the editor can
	              //initialize and subscribe to the event on another event loop
	              focuser.on('keypress', function (evt) {
	                if (viewPortKeyDownWasRaisedForRowCol) {
	                  $timeout(function () {
	                    uiGridCtrl.grid.api.cellNav.raise.viewPortKeyPress(evt, viewPortKeyDownWasRaisedForRowCol);
	                  },4);
	
	                  viewPortKeyDownWasRaisedForRowCol = null;
	                }
	              });
	
	              $scope.$on('$destroy', function(){
	                //Remove all event handlers associated with this focuser.
	                focuser.off();
	              });
	
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridViewport', ['$timeout', '$document', 'gridUtil', 'uiGridConstants', 'uiGridCellNavService', 'uiGridCellNavConstants','$log','$compile',
	    function ($timeout, $document, gridUtil, uiGridConstants, uiGridCellNavService, uiGridCellNavConstants, $log, $compile) {
	      return {
	        replace: true,
	        priority: -99999, //this needs to run very last
	        require: ['^uiGrid', '^uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                renderContainerCtrl = controllers[1];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	              //no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              var grid = uiGridCtrl.grid;
	
	              grid.api.core.on.scrollBegin($scope, function (args) {
	
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                //if not in my container, move on
	                //todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.clearFocus();
	
	              });
	
	              grid.api.core.on.scrollEnd($scope, function (args) {
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                //if not in my container, move on
	                //todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.broadcastCellNav(lastRowCol);
	
	              });
	
	              grid.api.cellNav.on.navigate($scope, function () {
	                //focus again because it can be lost
	                 uiGridCtrl.focus();
	              });
	
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *  @description Stacks on top of ui.grid.uiGridCell to provide cell navigation
	   */
	  module.directive('uiGridCell', ['$timeout', '$document', 'uiGridCellNavService', 'gridUtil', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn',
	    function ($timeout, $document, uiGridCellNavService, gridUtil, uiGridCellNavConstants, uiGridConstants, GridRowColumn) {
	      return {
	        priority: -150, // run after default uiGridCell directive and ui.grid.edit uiGridCell
	        restrict: 'A',
	        require: ['^uiGrid', '?^uiGridCellnav'],
	        scope: false,
	        link: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0],
	              uiGridCellnavCtrl = controllers[1];
	          // Skip attaching cell-nav specific logic if the directive is not attached above us
	          if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	          if (!$scope.col.colDef.allowCellFocus) {
	            return;
	          }
	
	          //Convinience local variables
	          var grid = uiGridCtrl.grid;
	          $scope.focused = false;
	
	          // Make this cell focusable but only with javascript/a mouse click
	          $elm.attr('tabindex', -1);
	
	          // When a cell is clicked, broadcast a cellNav event saying that this row+col combo is now focused
	          $elm.find('div').on('click', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), evt.ctrlKey || evt.metaKey, evt);
	
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	
	          /*
	           * XXX Hack for screen readers.
	           * This allows the grid to focus using only the screen reader cursor.
	           * Since the focus event doesn't include key press information we can't use it
	           * as our primary source of the event.
	           */
	          $elm.on('mousedown', preventMouseDown);
	
	          //turn on and off for edit events
	          if (uiGridCtrl.grid.api.edit) {
	            uiGridCtrl.grid.api.edit.on.beginCellEdit($scope, function () {
	              $elm.off('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.afterCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.cancelCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	          }
	
	          function preventMouseDown(evt) {
	            //Prevents the foucus event from firing if the click event is already going to fire.
	            //If both events fire it will cause bouncing behavior.
	            evt.preventDefault();
	          }
	
	          //You can only focus on elements with a tabindex value
	          $elm.on('focus', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), false, evt);
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	          // This event is fired for all cells.  If the cell matches, then focus is set
	          $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, function (evt, rowCol, modifierDown) {
	            var isFocused = grid.cellNav.focusedCells.some(function(focusedRowCol, index){
	              return (focusedRowCol.row === $scope.row && focusedRowCol.col === $scope.col);
	            });
	            if (isFocused){
	              setFocused();
	            } else {
	              clearFocus();
	            }
	          });
	
	          function setFocused() {
	            if (!$scope.focused){
	              var div = $elm.find('div');
	              div.addClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', true);
	              uiGridCellnavCtrl.setAriaActivedescendant($elm.attr('id'));
	              $scope.focused = true;
	            }
	          }
	
	          function clearFocus() {
	            if ($scope.focused){
	              var div = $elm.find('div');
	              div.removeClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', false);
	              uiGridCellnavCtrl.removeAriaActivedescendant($elm.attr('id'));
	              $scope.focused = false;
	            }
	          }
	
	          $scope.$on('$destroy', function () {
	            //.off withouth paramaters removes all handlers
	            $elm.find('div').off();
	            $elm.off();
	          });
	        }
	      };
	    }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.edit
	   * @description
	   *
	   * # ui.grid.edit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides cell editing capability to ui.grid. The goal was to emulate keying data in a spreadsheet via
	   * a keyboard.
	   * <br/>
	   * <br/>
	   * To really get the full spreadsheet-like data entry, the ui.grid.cellNav module should be used. This will allow the
	   * user to key data and then tab, arrow, or enter to the cells beside or below.
	   *
	   * <div doc-module-components="ui.grid.edit"></div>
	   */
	
	  var module = angular.module('ui.grid.edit', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.constant:uiGridEditConstants
	   *
	   *  @description constants available in edit module
	   */
	  module.constant('uiGridEditConstants', {
	    EDITABLE_CELL_TEMPLATE: /EDITABLE_CELL_TEMPLATE/g,
	    //must be lowercase because template bulder converts to lower
	    EDITABLE_CELL_DIRECTIVE: /editable_cell_directive/g,
	    events: {
	      BEGIN_CELL_EDIT: 'uiGridEventBeginCellEdit',
	      END_CELL_EDIT: 'uiGridEventEndCellEdit',
	      CANCEL_CELL_EDIT: 'uiGridEventCancelCellEdit'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.edit.service:uiGridEditService
	   *
	   *  @description Services for editing features
	   */
	  module.service('uiGridEditService', ['$q', 'uiGridConstants', 'gridUtil',
	    function ($q, uiGridConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          service.defaultGridOptions(grid.options);
	
	          grid.registerColumnBuilder(service.editColumnBuilder);
	          grid.edit = {};
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:PublicApi
	           *
	           *  @description Public Api for edit feature
	           */
	          var publicApi = {
	            events: {
	              edit: {
	                /**
	                 * @ngdoc event
	                 * @name afterCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is complete
	                 * <pre>
	                 *      gridApi.edit.on.afterCellEdit(scope,function(rowEntity, colDef){})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} newValue new value
	                 * @param {object} oldValue old value
	                 */
	                afterCellEdit: function (rowEntity, colDef, newValue, oldValue) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name beginCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing starts on a cell
	                 * <pre>
	                 *      gridApi.edit.on.beginCellEdit(scope,function(rowEntity, colDef){})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} triggerEvent the event that triggered the edit.  Useful to prevent losing keystrokes on some
	                 *                 complex editors
	                 */
	                beginCellEdit: function (rowEntity, colDef, triggerEvent) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name cancelCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is cancelled on a cell
	                 * <pre>
	                 *      gridApi.edit.on.cancelCellEdit(scope,function(rowEntity, colDef){})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 */
	                cancelCellEdit: function (rowEntity, colDef) {
	                }
	              }
	            },
	            methods: {
	              edit: { }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          //grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:GridOptions
	           *
	           *  @description Options for configuring the edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If defined, sets the default value for the editable flag on each individual colDefs
	           *  if their individual enableCellEdit configuration is not defined. Defaults to undefined.
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, either a value or function to be used by all columns before editing.
	           *  If falsy, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope){
	           *    //use $scope.row.entity and $scope.col.colDef to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          gridOptions.cellEditableCondition = gridOptions.cellEditableCondition === undefined ? true : gridOptions.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, cellTemplate to use as the editor for all columns.
	           *  <br/> defaults to 'ui-grid/cellTextEditor'
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br/>_requires cellNav feature and the edit feature to be enabled_
	           */
	            //enableCellEditOnFocus can only be used if cellnav module is used
	          gridOptions.enableCellEditOnFocus = gridOptions.enableCellEditOnFocus === undefined ? false : gridOptions.enableCellEditOnFocus;
	        },
	
	        /**
	         * @ngdoc service
	         * @name editColumnBuilder
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description columnBuilder function that adds edit properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        editColumnBuilder: function (colDef, col, gridOptions) {
	
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:ColumnDef
	           *
	           *  @description Column Definition for edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description enable editing on column
	           */
	          colDef.enableCellEdit = colDef.enableCellEdit === undefined ? (gridOptions.enableCellEdit === undefined ?
	            (colDef.type !== 'object') : gridOptions.enableCellEdit) : colDef.enableCellEdit;
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description If specified, either a value or function evaluated before editing cell.  If falsy, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope){
	           *    //use $scope.row.entity and $scope.col.colDef to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          colDef.cellEditableCondition = colDef.cellEditableCondition === undefined ? gridOptions.cellEditableCondition :  colDef.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description cell template to be used when editing this column. Can be Url or text template
	           *  <br/>Defaults to gridOptions.editableCellTemplate
	           */
	          if (colDef.enableCellEdit) {
	            colDef.editableCellTemplate = colDef.editableCellTemplate || gridOptions.editableCellTemplate || 'ui-grid/cellEditor';
	
	            promises.push(gridUtil.getTemplate(colDef.editableCellTemplate)
	              .then(
	              function (template) {
	                col.editableCellTemplate = template;
	              },
	              function (res) {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use colDef.editableCellTemplate '" + colDef.editableCellTemplate + "'");
	              }));
	          }
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @requires ui.grid.cellNav
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br>_requires both the cellNav feature and the edit feature to be enabled_
	           */
	            //enableCellEditOnFocus can only be used if cellnav module is used
	          colDef.enableCellEditOnFocus = colDef.enableCellEditOnFocus === undefined ? gridOptions.enableCellEditOnFocus : colDef.enableCellEditOnFocus;
	
	
	          /**
	           *  @ngdoc string
	           *  @name editModelField
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description a bindable string value that is used when binding to edit controls instead of colDef.field
	           *  <br/> example: You have a complex property on and object like state:{abbrev:'MS',name:'Mississippi'}.  The
	           *  grid should display state.name in the cell and sort/filter based on the state.name property but the editor
	           *  requires the full state object.
	           *  <br/>colDef.field = 'state.name'
	           *  <br/>colDef.editModelField = 'state'
	           */
	          //colDef.editModelField
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc service
	         * @name isStartEditKey
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description  Determines if a keypress should start editing.  Decorate this service to override with your
	         * own key events.  See service decorator in angular docs.
	         * @param {Event} evt keydown event
	         * @returns {boolean} true if an edit should start
	         */
	        isStartEditKey: function (evt) {
	          if (evt.metaKey ||
	              evt.keyCode === uiGridConstants.keymap.ESC ||
	              evt.keyCode === uiGridConstants.keymap.SHIFT ||
	              evt.keyCode === uiGridConstants.keymap.CTRL ||
	              evt.keyCode === uiGridConstants.keymap.ALT ||
	              evt.keyCode === uiGridConstants.keymap.WIN ||
	              evt.keyCode === uiGridConstants.keymap.CAPSLOCK ||
	
	             evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB ||
	
	            evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER) {
	            return false;
	
	          }
	          return true;
	        }
	
	
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds editing features to the ui-grid directive.
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.edit']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridEdit', ['gridUtil', 'uiGridEditService', function (gridUtil, uiGridEditService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridEditService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridRenderContainer
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds keydown listeners to renderContainer element so we can capture when to begin edits
	   *
	   */
	  module.directive('uiGridViewport', [ 'uiGridEditConstants',
	    function ( uiGridEditConstants) {
	      return {
	        replace: true,
	        priority: -99998, //run before cellNav
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0];
	
	              // Skip attaching if edit and cellNav is not enabled
	              if (!uiGridCtrl.grid.api.edit || !uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId =  controllers[1].containerId;
	              //no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              //refocus on the grid
	              $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	              $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide in-line editing capabilities to the cell
	   *  Editing Actions.
	   *
	   *  Binds edit start events to the uiGridCell element.  When the events fire, the gridCell element is appended
	   *  with the columnDef.editableCellTemplate element ('cellEditor.html' by default).
	   *
	   *  The editableCellTemplate should respond to uiGridEditConstants.events.BEGIN\_CELL\_EDIT angular event
	   *  and do the initial steps needed to edit the cell (setfocus on input element, etc).
	   *
	   *  When the editableCellTemplate recognizes that the editing is ended (blur event, Enter key, etc.)
	   *  it should emit the uiGridEditConstants.events.END\_CELL\_EDIT event.
	   *
	   *  If editableCellTemplate recognizes that the editing has been cancelled (esc key)
	   *  it should emit the uiGridEditConstants.events.CANCEL\_CELL\_EDIT event.  The original value
	   *  will be set back on the model by the uiGridCell directive.
	   *
	   *  Events that invoke editing:
	   *    - dblclick
	   *    - F2 keydown (when using cell selection)
	   *
	   *  Events that end editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be Esc keydown
	   *
	   *  Grid Events that end editing:
	   *    - uiGridConstants.events.GRID_SCROLL
	   *
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.api:GridRow
	   *
	   *  @description GridRow options for edit feature, these are available to be
	   *  set internally only, by other features
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name enableCellEdit
	   *  @propertyOf  ui.grid.edit.api:GridRow
	   *  @description enable editing on row, grouping for example might disable editing on group header rows
	   */
	
	  module.directive('uiGridCell',
	    ['$compile', '$injector', '$timeout', 'uiGridConstants', 'uiGridEditConstants', 'gridUtil', '$parse', 'uiGridEditService', '$rootScope',
	      function ($compile, $injector, $timeout, uiGridConstants, uiGridEditConstants, gridUtil, $parse, uiGridEditService, $rootScope) {
	        var touchstartTimeout = 500;
	        if ($injector.has('uiGridCellNavService')) {
	          var uiGridCellNavService = $injector.get('uiGridCellNavService');
	        }
	
	        return {
	          priority: -100, // run after default uiGridCell directive
	          restrict: 'A',
	          scope: false,
	          require: '?^uiGrid',
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var html;
	            var origCellValue;
	            var inEdit = false;
	            var cellModel;
	            var cancelTouchstartTimeout;
	
	            var editCellScope;
	
	            if (!$scope.col.colDef.enableCellEdit) {
	              return;
	            }
	
	            var cellNavNavigateDereg = function() {};
	            var viewPortKeyDownDereg = function() {};
	
	
	            var setEditable = function() {
	              if ($scope.col.colDef.enableCellEdit && $scope.row.enableCellEdit !== false) {
	                if (!$scope.beginEditEventsWired) { //prevent multiple attachments
	                  registerBeginEditEvents();
	                }
	              } else {
	                if ($scope.beginEditEventsWired) {
	                  cancelBeginEditEvents();
	                }
	              }
	            };
	
	            setEditable();
	
	            var rowWatchDereg = $scope.$watch('row', function (n, o) {
	              if (n !== o) {
	                setEditable();
	              }
	            });
	
	
	            $scope.$on( '$destroy', rowWatchDereg );
	
	            function registerBeginEditEvents() {
	              $elm.on('dblclick', beginEdit);
	
	              // Add touchstart handling. If the users starts a touch and it doesn't end after X milliseconds, then start the edit
	              $elm.on('touchstart', touchStart);
	
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	
	                viewPortKeyDownDereg = uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                  if (rowCol === null) {
	                    return;
	                  }
	
	                  if (rowCol.row === $scope.row && rowCol.col === $scope.col && !$scope.col.colDef.enableCellEditOnFocus) {
	                    //important to do this before scrollToIfNecessary
	                    beginEditKeyDown(evt);
	                  }
	                });
	
	                cellNavNavigateDereg = uiGridCtrl.grid.api.cellNav.on.navigate($scope, function (newRowCol, oldRowCol) {
	                  if ($scope.col.colDef.enableCellEditOnFocus) {
	                    // Don't begin edit if the cell hasn't changed
	                    if ((!oldRowCol || newRowCol.row !== oldRowCol.row || newRowCol.col !== oldRowCol.col) &&
	                      newRowCol.row === $scope.row && newRowCol.col === $scope.col) {
	                      $timeout(function () {
	                        beginEdit();
	                      });
	                    }
	                  }
	                });
	              }
	
	              $scope.beginEditEventsWired = true;
	
	            }
	
	            function touchStart(event) {
	              // jQuery masks events
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Bind touchend handler
	              $elm.on('touchend', touchEnd);
	
	              // Start a timeout
	              cancelTouchstartTimeout = $timeout(function() { }, touchstartTimeout);
	
	              // Timeout's done! Start the edit
	              cancelTouchstartTimeout.then(function () {
	                // Use setTimeout to start the edit because beginEdit expects to be outside of $digest
	                setTimeout(beginEdit, 0);
	
	                // Undbind the touchend handler, we don't need it anymore
	                $elm.off('touchend', touchEnd);
	              });
	            }
	
	            // Cancel any touchstart timeout
	            function touchEnd(event) {
	              $timeout.cancel(cancelTouchstartTimeout);
	              $elm.off('touchend', touchEnd);
	            }
	
	            function cancelBeginEditEvents() {
	              $elm.off('dblclick', beginEdit);
	              $elm.off('keydown', beginEditKeyDown);
	              $elm.off('touchstart', touchStart);
	              cellNavNavigateDereg();
	              viewPortKeyDownDereg();
	              $scope.beginEditEventsWired = false;
	            }
	
	            function beginEditKeyDown(evt) {
	              if (uiGridEditService.isStartEditKey(evt)) {
	                beginEdit(evt);
	              }
	            }
	
	            function shouldEdit(col, row) {
	              return !row.isSaving &&
	                ( angular.isFunction(col.colDef.cellEditableCondition) ?
	                    col.colDef.cellEditableCondition($scope) :
	                    col.colDef.cellEditableCondition );
	            }
	
	
	            function beginEdit(triggerEvent) {
	              //we need to scroll the cell into focus before invoking the editor
	              $scope.grid.api.core.scrollToIfNecessary($scope.row, $scope.col)
	                .then(function () {
	                  beginEditAfterScroll(triggerEvent);
	                });
	            }
	
	            /**
	             *  @ngdoc property
	             *  @name editDropdownOptionsArray
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description an array of values in the format
	             *  [ {id: xxx, value: xxx} ], which is populated
	             *  into the edit dropdown
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownIdLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "id" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'id'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownRowEntityOptionsArrayPath
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description a path to a property on row.entity containing an
	             *  array of values in the format
	             *  [ {id: xxx, value: xxx} ], which will be used to populate
	             *  the edit dropdown.  This can be used when the dropdown values are dependent on
	             *  the backing row entity.
	             *  If this property is set then editDropdownOptionsArray will be ignored.
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownRowEntityOptionsArrayPath: 'foo.bars[0].baz',
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownValueLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "value" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'value'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownFilter
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description A filter that you would like to apply to the values in the options list
	             *  of the dropdown.  For example if you were using angular-translate you might set this
	             *  to `'translate'`
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status', editDropdownFilter: 'translate' }
	             *      ],
	             *  </pre>
	             *
	             */
	            function beginEditAfterScroll(triggerEvent) {
	              // If we are already editing, then just skip this so we don't try editing twice...
	              if (inEdit) {
	                return;
	              }
	
	              if (!shouldEdit($scope.col, $scope.row)) {
	                return;
	              }
	
	
	              cellModel = $parse($scope.row.getQualifiedColField($scope.col));
	              //get original value from the cell
	              origCellValue = cellModel($scope);
	
	              html = $scope.col.editableCellTemplate;
	
	              if ($scope.col.colDef.editModelField) {
	                html = html.replace(uiGridConstants.MODEL_COL_FIELD, gridUtil.preEval('row.entity.' + $scope.col.colDef.editModelField));
	              }
	              else {
	                html = html.replace(uiGridConstants.MODEL_COL_FIELD, $scope.row.getQualifiedColField($scope.col));
	              }
	
	              html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var optionFilter = $scope.col.colDef.editDropdownFilter ? '|' + $scope.col.colDef.editDropdownFilter : '';
	              html = html.replace(uiGridConstants.CUSTOM_FILTERS, optionFilter);
	
	              var inputType = 'text';
	              switch ($scope.col.colDef.type){
	                case 'boolean':
	                  inputType = 'checkbox';
	                  break;
	                case 'number':
	                  inputType = 'number';
	                  break;
	                case 'date':
	                  inputType = 'date';
	                  break;
	              }
	              html = html.replace('INPUT_TYPE', inputType);
	
	              var editDropdownRowEntityOptionsArrayPath = $scope.col.colDef.editDropdownRowEntityOptionsArrayPath;
	              if (editDropdownRowEntityOptionsArrayPath) {
	                $scope.editDropdownOptionsArray =  resolveObjectFromPath($scope.row.entity, editDropdownRowEntityOptionsArrayPath);
	              }
	              else {
	                $scope.editDropdownOptionsArray = $scope.col.colDef.editDropdownOptionsArray;
	              }
	              $scope.editDropdownIdLabel = $scope.col.colDef.editDropdownIdLabel ? $scope.col.colDef.editDropdownIdLabel : 'id';
	              $scope.editDropdownValueLabel = $scope.col.colDef.editDropdownValueLabel ? $scope.col.colDef.editDropdownValueLabel : 'value';
	
	              var cellElement;
	              var createEditor = function(){
	                inEdit = true;
	                cancelBeginEditEvents();
	                var cellElement = angular.element(html);
	                $elm.append(cellElement);
	                editCellScope = $scope.$new();
	                $compile(cellElement)(editCellScope);
	                var gridCellContentsEl = angular.element($elm.children()[0]);
	                gridCellContentsEl.addClass('ui-grid-cell-contents-hidden');
	              };
	              if (!$rootScope.$$phase) {
	                $scope.$apply(createEditor);
	              } else {
	                createEditor();
	              }
	
	              //stop editing when grid is scrolled
	              var deregOnGridScroll = $scope.col.grid.api.core.on.scrollBegin($scope, function () {
	                if ($scope.grid.disableScrolling) {
	                  return;
	                }
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	                deregOnCancelCellEdit();
	              });
	
	              //end editing
	              var deregOnEndCellEdit = $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnEndCellEdit();
	                deregOnGridScroll();
	                deregOnCancelCellEdit();
	              });
	
	              //cancel editing
	              var deregOnCancelCellEdit = $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                cancelEdit();
	                deregOnCancelCellEdit();
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	              });
	
	              $scope.$broadcast(uiGridEditConstants.events.BEGIN_CELL_EDIT, triggerEvent);
	              $timeout(function () {
	                //execute in a timeout to give any complex editor templates a cycle to completely render
	                $scope.grid.api.edit.raise.beginCellEdit($scope.row.entity, $scope.col.colDef, triggerEvent);
	              });
	            }
	
	            function endEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	
	              //sometimes the events can't keep up with the keyboard and grid focus is lost, so always focus
	              //back to grid here. The focus call needs to be before the $destroy and removal of the control,
	              //otherwise ng-model-options of UpdateOn: 'blur' will not work.
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                uiGridCtrl.focus();
	              }
	
	              var gridCellContentsEl = angular.element($elm.children()[0]);
	              //remove edit element
	              editCellScope.$destroy();
	              angular.element($elm.children()[1]).remove();
	              gridCellContentsEl.removeClass('ui-grid-cell-contents-hidden');
	              inEdit = false;
	              registerBeginEditEvents();
	              $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.EDIT );
	            }
	
	            function cancelEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	              cellModel.assign($scope, origCellValue);
	              $scope.$apply();
	
	              $scope.grid.api.edit.raise.cancelCellEdit($scope.row.entity, $scope.col.colDef);
	              endEdit();
	            }
	
	            // resolves a string path against the given object
	            // shamelessly borrowed from
	            // http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key
	            function resolveObjectFromPath(object, path) {
	              path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
	              path = path.replace(/^\./, '');           // strip a leading dot
	              var a = path.split('.');
	              while (a.length) {
	                  var n = a.shift();
	                  if (n in object) {
	                      object = object[n];
	                  } else {
	                      return;
	                  }
	              }
	              return object;
	            }
	
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditor
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditor',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants','$timeout', 'uiGridEditService',
	      function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl, renderContainerCtrl, ngModel;
	                if (controllers[0]) { uiGridCtrl = controllers[0]; }
	                if (controllers[1]) { renderContainerCtrl = controllers[1]; }
	                if (controllers[2]) { ngModel = controllers[2]; }
	
	                //set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function (evt,triggerEvent) {
	                  $timeout(function () {
	                    $elm[0].focus();
	                    //only select text if it is not being replaced below in the cellNav viewPortKeyPress
	                    if ($scope.col.colDef.enableCellEditOnFocus || !(uiGridCtrl && uiGridCtrl.grid.api.cellNav)) {
	                      $elm[0].select();
	                    }
	                    else {
	                      //some browsers (Chrome) stupidly, imo, support the w3 standard that number, email, ...
	                      //fields should not allow setSelectionRange.  We ignore the error for those browsers
	                      //https://www.w3.org/Bugs/Public/show_bug.cgi?id=24796
	                      try {
	                        $elm[0].setSelectionRange($elm[0].value.length, $elm[0].value.length);
	                      }
	                      catch (ex) {
	                        //ignore
	                      }
	                    }
	                  });
	
	                  //set the keystroke that started the edit event
	                  //we must do this because the BeginEdit is done in a different event loop than the intitial
	                  //keydown event
	                  //fire this event for the keypress that is received
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    var viewPortKeyDownUnregister = uiGridCtrl.grid.api.cellNav.on.viewPortKeyPress($scope, function (evt, rowCol) {
	                      if (uiGridEditService.isStartEditKey(evt)) {
	                        ngModel.$setViewValue(String.fromCharCode(evt.keyCode), evt);
	                        ngModel.$render();
	                      }
	                      viewPortKeyDownUnregister();
	                    });
	                  }
	
	                  $elm.on('blur', function (evt) {
	                    $scope.stopEdit(evt);
	                  });
	                });
	
	
	                $scope.deepEdit = false;
	
	                $scope.stopEdit = function (evt) {
	                  if ($scope.inputForm && !$scope.inputForm.$valid) {
	                    evt.stopPropagation();
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                  else {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  }
	                  $scope.deepEdit = false;
	                };
	
	
	                $elm.on('click', function (evt) {
	                  if ($elm[0].type !== 'checkbox') {
	                    $scope.deepEdit = true;
	                    $timeout(function () {
	                      $scope.grid.disableScrolling = true;
	                    });
	                  }
	                });
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	
	                  if ($scope.deepEdit &&
	                    (evt.keyCode === uiGridConstants.keymap.LEFT ||
	                     evt.keyCode === uiGridConstants.keymap.RIGHT ||
	                     evt.keyCode === uiGridConstants.keymap.UP ||
	                     evt.keyCode === uiGridConstants.keymap.DOWN)) {
	                    evt.stopPropagation();
	                  }
	                  // Pass the keydown event off to the cellNav service, if it exists
	                  else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    //handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	
	                  return true;
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:input
	   *  @element input
	   *  @restrict E
	   *
	   *  @description directive to provide binding between input[date] value and ng-model for angular 1.2
	   *  It is similar to input[date] directive of angular 1.3
	   *
	   *  Supported date format for input is 'yyyy-MM-dd'
	   *  The directive will set the $valid property of input element and the enclosing form to false if
	   *  model is invalid date or value of input is entered wrong.
	   *
	   */
	    module.directive('uiGridEditor', ['$filter', function ($filter) {
	      function parseDateString(dateString) {
	        if (typeof(dateString) === 'undefined' || dateString === '') {
	          return null;
	        }
	        var parts = dateString.split('-');
	        if (parts.length !== 3) {
	          return null;
	        }
	        var year = parseInt(parts[0], 10);
	        var month = parseInt(parts[1], 10);
	        var day = parseInt(parts[2], 10);
	
	        if (month < 1 || year < 1 || day < 1) {
	          return null;
	        }
	        return new Date(year, (month - 1), day);
	      }
	      return {
	        priority: -100, // run after default uiGridEditor directive
	        require: '?ngModel',
	        link: function (scope, element, attrs, ngModel) {
	
	          if (angular.version.minor === 2 && attrs.type && attrs.type === 'date' && ngModel) {
	
	            ngModel.$formatters.push(function (modelValue) {
	              ngModel.$setValidity(null,(!modelValue || !isNaN(modelValue.getTime())));
	              return $filter('date')(modelValue, 'yyyy-MM-dd');
	            });
	
	            ngModel.$parsers.push(function (viewValue) {
	              if (viewValue && viewValue.length > 0) {
	                var dateValue = parseDateString(viewValue);
	                ngModel.$setValidity(null, (dateValue && !isNaN(dateValue.getTime())));
	                return dateValue;
	              }
	              else {
	                ngModel.$setValidity(null, true);
	                return null;
	              }
	            });
	          }
	        }
	      };
	    }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditDropdown
	   *  @element div
	   *  @restrict A
	   *
	   *  @description dropdown editor for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown, and any left/right nav
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditDropdown',
	    ['uiGridConstants', 'uiGridEditConstants',
	      function (uiGridConstants, uiGridEditConstants) {
	        return {
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          scope: true,
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl = controllers[0];
	                var renderContainerCtrl = controllers[1];
	
	                //set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $elm[0].focus();
	                  $elm[0].style.width = ($elm[0].parentElement.offsetWidth - 1) + 'px';
	                  $elm.on('blur', function (evt) {
	                    $scope.stopEdit(evt);
	                  });
	                });
	
	
	                $scope.stopEdit = function (evt) {
	                  // no need to validate a dropdown - invalid values shouldn't be
	                  // available in the list
	                  $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                };
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    //handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	                  return true;
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditFileChooser
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditFileChooser',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants','$timeout',
	      function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl, renderContainerCtrl;
	                if (controllers[0]) { uiGridCtrl = controllers[0]; }
	                if (controllers[1]) { renderContainerCtrl = controllers[1]; }
	                var grid = uiGridCtrl.grid;
	
	                var handleFileSelect = function( event ){
	                  var target = event.srcElement || event.target;
	
	                  if (target && target.files && target.files.length > 0) {
	                    /**
	                     *  @ngdoc property
	                     *  @name editFileChooserCallback
	                     *  @propertyOf  ui.grid.edit.api:ColumnDef
	                     *  @description A function that should be called when any files have been chosen
	                     *  by the user.  You should use this to process the files appropriately for your
	                     *  application.
	                     *
	                     *  It passes the gridCol, the gridRow (from which you can get gridRow.entity),
	                     *  and the files.  The files are in the format as returned from the file chooser,
	                     *  an array of files, with each having useful information such as:
	                     *  - `files[0].lastModifiedDate`
	                     *  - `files[0].name`
	                     *  - `files[0].size`  (appears to be in bytes)
	                     *  - `files[0].type`  (MIME type by the looks)
	                     *
	                     *  Typically you would do something with these files - most commonly you would
	                     *  use the filename or read the file itself in.  The example function does both.
	                     *
	                     *  @example
	                     *  <pre>
	                     *  editFileChooserCallBack: function(gridRow, gridCol, files ){
	                     *    // ignore all but the first file, it can only choose one anyway
	                     *    // set the filename into this column
	                     *    gridRow.entity.filename = file[0].name;
	                     *
	                     *    // read the file and set it into a hidden column, which we may do stuff with later
	                     *    var setFile = function(fileContent){
	                     *      gridRow.entity.file = fileContent.currentTarget.result;
	                     *    };
	                     *    var reader = new FileReader();
	                     *    reader.onload = setFile;
	                     *    reader.readAsText( files[0] );
	                     *  }
	                     *  </pre>
	                     */
	                    if ( typeof($scope.col.colDef.editFileChooserCallback) === 'function' ) {
	                      $scope.col.colDef.editFileChooserCallback($scope.row, $scope.col, target.files);
	                    } else {
	                      gridUtil.logError('You need to set colDef.editFileChooserCallback to use the file chooser');
	                    }
	
	                    target.form.reset();
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  } else {
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                };
	
	                $elm[0].addEventListener('change', handleFileSelect, false);  // TODO: why the false on the end?  Google
	
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $elm[0].focus();
	                  $elm[0].select();
	
	                  $elm.on('blur', function (evt) {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  });
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.expandable
	   * @description
	   *
	   * # ui.grid.expandable
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to create subgrids with the ability to expand a row
	   * to show the subgrid.
	   *
	   * <div doc-module-components="ui.grid.expandable"></div>
	   */
	  var module = angular.module('ui.grid.expandable', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.expandable.service:uiGridExpandableService
	   *
	   *  @description Services for the expandable grid
	   */
	  module.service('uiGridExpandableService', ['gridUtil', '$compile', function (gridUtil, $compile) {
	    var service = {
	      initializeGrid: function (grid) {
	
	        grid.expandable = {};
	        grid.expandable.expandedAll = false;
	
	        /**
	         *  @ngdoc object
	         *  @name enableExpandable
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Whether or not to use expandable feature, allows you to turn off expandable on specific grids
	         *  within your application, or in specific modes on _this_ grid. Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      enableExpandable: false
	         *    }
	         *  </pre>
	         */
	        grid.options.enableExpandable = grid.options.enableExpandable !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowHeight
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Height in pixels of the expanded subgrid.  Defaults to
	         *  150
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeight: 150
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeight = grid.options.expandableRowHeight || 150;
	
	        /**
	         *  @ngdoc object
	         *  @name
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Width in pixels of the expandable column. Defaults to 40
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeaderWidth: 40
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeaderWidth = grid.options.expandableRowHeaderWidth || 40;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowTemplate
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Mandatory. The template for your expanded row
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowTemplate: 'expandableRowTemplate.html'
	         *    }
	         *  </pre>
	         */
	        if ( grid.options.enableExpandable && !grid.options.expandableRowTemplate ){
	          gridUtil.logError( 'You have not set the expandableRowTemplate, disabling expandable module' );
	          grid.options.enableExpandable = false;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:PublicApi
	         *
	         *  @description Public Api for expandable feature
	         */
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:GridOptions
	         *
	         *  @description Options for configuring the expandable feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        var publicApi = {
	          events: {
	            expandable: {
	              /**
	               * @ngdoc event
	               * @name rowExpandedStateChanged
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when cell editing is complete
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedStateChanged(scope,function(row){})
	               * </pre>
	               * @param {GridRow} row the row that was expanded
	               */
	              rowExpandedBeforeStateChanged: function(scope,row){
	              },
	              rowExpandedStateChanged: function (scope, row) {
	              }
	            }
	          },
	
	          methods: {
	            expandable: {
	              /**
	               * @ngdoc method
	               * @name toggleRowExpansion
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle a specific row
	               * <pre>
	               *      gridApi.expandable.toggleRowExpansion(rowEntity);
	               * </pre>
	               * @param {object} rowEntity the data entity for the row you want to expand
	               */
	              toggleRowExpansion: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	                if (row !== null) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	
	              /**
	               * @ngdoc method
	               * @name expandAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Expand all subgrids.
	               * <pre>
	               *      gridApi.expandable.expandAllRows();
	               * </pre>
	               */
	              expandAllRows: function() {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name collapseAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Collapse all subgrids.
	               * <pre>
	               *      gridApi.expandable.collapseAllRows();
	               * </pre>
	               */
	              collapseAllRows: function() {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name toggleAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle all subgrids.
	               * <pre>
	               *      gridApi.expandable.toggleAllRows();
	               * </pre>
	               */
	              toggleAllRows: function() {
	                service.toggleAllRows(grid);
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      toggleRowExpansion: function (grid, row) {
	        // trigger the "before change" event. Can change row height dynamically this way.
	        grid.api.expandable.raise.rowExpandedBeforeStateChanged(row);
	        row.isExpanded = !row.isExpanded;
	        if (angular.isUndefined(row.expandedRowHeight)){
	          row.expandedRowHeight = grid.options.expandableRowHeight;
	        }
	              
	        if (row.isExpanded) {
	          row.height = row.grid.options.rowHeight + row.expandedRowHeight;
	        }
	        else {
	          row.height = row.grid.options.rowHeight;
	          grid.expandable.expandedAll = false;
	        }
	        grid.api.expandable.raise.rowExpandedStateChanged(row);
	      },
	
	      expandAllRows: function(grid, $scope) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (!row.isExpanded) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = true;
	        grid.queueGridRefresh();
	      },
	
	      collapseAllRows: function(grid) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (row.isExpanded) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = false;
	        grid.queueGridRefresh();
	      },
	
	      toggleAllRows: function(grid) {
	        if (grid.expandable.expandedAll) {
	          service.collapseAllRows(grid);
	        }
	        else {
	          service.expandAllRows(grid);
	        }
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc object
	   *  @name enableExpandableRowHeader
	   *  @propertyOf  ui.grid.expandable.api:GridOptions
	   *  @description Show a rowHeader to provide the expandable buttons.  If set to false then implies
	   *  you're going to use a custom method for expanding and collapsing the subgrids. Defaults to true.
	   *  @example
	   *  <pre>
	   *    $scope.gridOptions = {
	   *      enableExpandableRowHeader: false
	   *    }
	   *  </pre>
	   */
	  module.directive('uiGridExpandable', ['uiGridExpandableService', '$templateCache',
	    function (uiGridExpandableService, $templateCache) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              if ( uiGridCtrl.grid.options.enableExpandableRowHeader !== false ) {
	                var expandableRowHeaderColDef = {
	                  name: 'expandableButtons',
	                  displayName: '',
	                  exporterSuppressExport: true,
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  width: uiGridCtrl.grid.options.expandableRowHeaderWidth || 40
	                };
	                expandableRowHeaderColDef.cellTemplate = $templateCache.get('ui-grid/expandableRowHeader');
	                expandableRowHeaderColDef.headerCellTemplate = $templateCache.get('ui-grid/expandableTopRowHeader');
	                uiGridCtrl.grid.addRowHeaderColumn(expandableRowHeaderColDef);
	              }
	              uiGridExpandableService.initializeGrid(uiGridCtrl.grid);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGrid
	   *  @description stacks on the uiGrid directive to register child grid with parent row when child is created
	   */
	  module.directive('uiGrid', ['uiGridExpandableService', '$templateCache',
	    function (uiGridExpandableService, $templateCache) {
	      return {
	        replace: true,
	        priority: 599,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              uiGridCtrl.grid.api.core.on.renderingComplete($scope, function() {
	                //if a parent grid row is on the scope, then add the parentRow property to this childGrid
	                if ($scope.row && $scope.row.grid && $scope.row.grid.options && $scope.row.grid.options.enableExpandable) {
	
	                  /**
	                   *  @ngdoc directive
	                   *  @name ui.grid.expandable.class:Grid
	                   *  @description Additional Grid properties added by expandable module
	                   */
	
	                  /**
	                   *  @ngdoc object
	                   *  @name parentRow
	                   *  @propertyOf ui.grid.expandable.class:Grid
	                   *  @description reference to the expanded parent row that owns this grid
	                   */
	                  uiGridCtrl.grid.parentRow = $scope.row;
	
	                  //todo: adjust height on parent row when child grid height changes. we need some sort of gridHeightChanged event
	                 // uiGridCtrl.grid.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
	                 //   uiGridCtrl.grid.parentRow = newHeight;
	                 // });
	                }
	
	              });
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridExpandableRow
	   *  @description directive to render the expandable row template
	   */
	  module.directive('uiGridExpandableRow',
	  ['uiGridExpandableService', '$timeout', '$compile', 'uiGridConstants','gridUtil','$interval', '$log',
	    function (uiGridExpandableService, $timeout, $compile, uiGridConstants, gridUtil, $interval, $log) {
	
	      return {
	        replace: false,
	        priority: 0,
	        scope: false,
	
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              gridUtil.getTemplate($scope.grid.options.expandableRowTemplate).then(
	                function (template) {
	                  if ($scope.grid.options.expandableRowScope) {
	                    var expandableRowScope = $scope.grid.options.expandableRowScope;
	                    for (var property in expandableRowScope) {
	                      if (expandableRowScope.hasOwnProperty(property)) {
	                        $scope[property] = expandableRowScope[property];
	                      }
	                    }
	                  }
	                  var expandedRowElement = $compile(template)($scope);
	                  $elm.append(expandedRowElement);
	                  $scope.row.expandedRendered = true;
	              });
	            },
	
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              $scope.$on('$destroy', function() {
	                $scope.row.expandedRendered = false;
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridRow
	   *  @description stacks on the uiGridRow directive to add support for expandable rows
	   */
	  module.directive('uiGridRow',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm, $attrs) {
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	                $scope.expandableRow = {};
	
	                $scope.expandableRow.shouldRenderExpand = function () {
	                  var ret = $scope.colContainer.name === 'body' &&  $scope.grid.options.enableExpandable !== false && $scope.row.isExpanded && (!$scope.grid.isScrollingVertically || $scope.row.expandedRendered);
	                  return ret;
	                };
	
	                $scope.expandableRow.shouldRenderFiller = function () {
	                  var ret = $scope.row.isExpanded && ( $scope.colContainer.name !== 'body' || ($scope.grid.isScrollingVertically && !$scope.row.expandedRendered));
	                  return ret;
	                };
	
	 /*
	  * Commented out @PaulL1.  This has no purpose that I can see, and causes #2964.  If this code needs to be reinstated for some
	  * reason it needs to use drawnWidth, not width, and needs to check column visibility.  It should really use render container
	  * visible column cache also instead of checking column.renderContainer.
	                  function updateRowContainerWidth() {
	                      var grid = $scope.grid;
	                      var colWidth = 0;
	                      grid.columns.forEach( function (column) {
	                          if (column.renderContainer === 'left') {
	                            colWidth += column.width;
	                          }
	                      });
	                      colWidth = Math.floor(colWidth);
	                      return '.grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.colContainer.name + ', .grid' + grid.id +
	                          ' .ui-grid-pinned-container-' + $scope.colContainer.name + ' .ui-grid-render-container-' + $scope.colContainer.name +
	                          ' .ui-grid-viewport .ui-grid-canvas .ui-grid-row { width: ' + colWidth + 'px; }';
	                  }
	
	                  if ($scope.colContainer.name === 'left') {
	                      $scope.grid.registerStyleComputation({
	                          priority: 15,
	                          func: updateRowContainerWidth
	                      });
	                  }*/
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridViewport
	   *  @description stacks on the uiGridViewport directive to append the expandable row html elements to the
	   *  default gridRow template
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var rowRepeatDiv = angular.element($elm.children().children()[0]);
	            var expandedRowFillerElement = $templateCache.get('ui-grid/expandableScrollFiller');
	            var expandedRowElement = $templateCache.get('ui-grid/expandableRow');
	            rowRepeatDiv.append(expandedRowElement);
	            rowRepeatDiv.append(expandedRowFillerElement);
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	/* global console */
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.exporter
	   * @description
	   *
	   * # ui.grid.exporter
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to exporter data from the grid.
	   *
	   * Data can be exported in a range of formats, and all data, visible
	   * data, or selected rows can be exported, with all columns or visible
	   * columns.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate, or enable the gridMenu
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.exporter"></div>
	   */
	
	  var module = angular.module('ui.grid.exporter', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.exporter.constant:uiGridExporterConstants
	   *
	   *  @description constants available in exporter module
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name ALL
	   * @description export all data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name VISIBLE
	   * @description export only visible data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name SELECTED
	   * @description export all data, including data not visible.  Can
	   * be set only for rowTypes, selection of only some columns is
	   * not supported
	   */
	  module.constant('uiGridExporterConstants', {
	    featureName: 'exporter',
	    ALL: 'all',
	    VISIBLE: 'visible',
	    SELECTED: 'selected',
	    CSV_CONTENT: 'CSV_CONTENT',
	    BUTTON_LABEL: 'BUTTON_LABEL',
	    FILE_NAME: 'FILE_NAME'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.exporter.service:uiGridExporterService
	   *
	   *  @description Services for exporter feature
	   */
	  module.service('uiGridExporterService', ['$q', 'uiGridExporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService',
	    function ($q, uiGridExporterConstants, gridUtil, $compile, $interval, i18nService) {
	
	      var service = {
	
	        delay: 100,
	
	        initializeGrid: function (grid) {
	
	          //add feature namespace and any properties to grid for needed state
	          grid.exporter = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.exporter.api:PublicApi
	           *
	           *  @description Public Api for exporter feature
	           */
	          var publicApi = {
	            events: {
	              exporter: {
	              }
	            },
	            methods: {
	              exporter: {
	                /**
	                 * @ngdoc function
	                 * @name csvExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in csv format,
	                 * the data exported is selected based on the provided options
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                csvExport: function (rowTypes, colTypes) {
	                  service.csvExport(grid, rowTypes, colTypes);
	                },
	                /**
	                 * @ngdoc function
	                 * @name pdfExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in pdf format,
	                 * the data exported is selected based on the provided options
	                 * Note that this function has a dependency on pdfMake, all
	                 * going well this has been installed for you.
	                 * The resulting pdf opens in a new browser window.
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                pdfExport: function (rowTypes, colTypes) {
	                  service.pdfExport(grid, rowTypes, colTypes);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if (grid.api.core.addToGridMenu){
	            service.addToMenu( grid );
	          } else {
	            // order of registration is not guaranteed, register in a little while
	            $interval( function() {
	              if (grid.api.core.addToGridMenu){
	                service.addToMenu( grid );
	              }
	            }, this.delay, 1);
	          }
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:GridOptions
	           *
	           * @description GridOptions for exporter feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:ColumnDef
	           * @description ColumnDef settings for exporter
	           */
	          /**
	           * @ngdoc object
	           * @name exporterSuppressMenu
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Don't show the export menu button, implying the user
	           * will roll their own UI for calling the exporter
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterSuppressMenu = gridOptions.exporterSuppressMenu === true;
	          /**
	           * @ngdoc object
	           * @name exporterMenuLabel
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The text to show on the exporter menu button
	           * link
	           * <br/>Defaults to 'Export'
	           */
	          gridOptions.exporterMenuLabel = gridOptions.exporterMenuLabel ? gridOptions.exporterMenuLabel : 'Export';
	          /**
	           * @ngdoc object
	           * @name exporterSuppressColumns
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Columns that should not be exported.  The selectionRowHeader is already automatically
	           * suppressed, but if you had a button column or some other "system" column that shouldn't be shown in the
	           * output then add it in this list.  You should provide an array of column names.
	           * <br/>Defaults to: []
	           * <pre>
	           *   gridOptions.exporterSuppressColumns = [ 'buttons' ];
	           * </pre>
	           */
	          gridOptions.exporterSuppressColumns = gridOptions.exporterSuppressColumns ? gridOptions.exporterSuppressColumns : [];
	          /**
	           * @ngdoc object
	           * @name exporterCsvColumnSeparator
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The character to use as column separator
	           * link
	           * <br/>Defaults to ','
	           */
	          gridOptions.exporterCsvColumnSeparator = gridOptions.exporterCsvColumnSeparator ? gridOptions.exporterCsvColumnSeparator : ',';
	          /**
	           * @ngdoc object
	           * @name exporterCsvFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded csv.
	           * This will only work in some browsers.
	           * <br/>Defaults to 'download.csv'
	           */
	          gridOptions.exporterCsvFilename = gridOptions.exporterCsvFilename ? gridOptions.exporterCsvFilename : 'download.csv';
	          /**
	           * @ngdoc object
	           * @name exporterPdfFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded pdf, only used in IE (other browsers open pdfs in a new window)
	           * <br/>Defaults to 'download.pdf'
	           */
	          gridOptions.exporterPdfFilename = gridOptions.exporterPdfFilename ? gridOptions.exporterPdfFilename : 'download.pdf';
	          /**
	           * @ngdoc object
	           * @name exporterOlderExcelCompatibility
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Some versions of excel don't like the utf-16 BOM on the front, and it comes
	           * through as ï»¿ in the first column header.  Setting this option to false will suppress this, at the
	           * expense of proper utf-16 handling in applications that do recognise the BOM
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterOlderExcelCompatibility = gridOptions.exporterOlderExcelCompatibility === true;
	          /**
	           * @ngdoc object
	           * @name exporterPdfDefaultStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     fontSize: 11
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfDefaultStyle = gridOptions.exporterPdfDefaultStyle ? gridOptions.exporterPdfDefaultStyle : { fontSize: 11 };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The table style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     margin: [0, 5, 0, 15]
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableStyle = gridOptions.exporterPdfTableStyle ? gridOptions.exporterPdfTableStyle : { margin: [0, 5, 0, 15] };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableHeaderStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The tableHeader style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     bold: true,
	           *     fontSize: 12,
	           *     color: 'black'
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableHeaderStyle = gridOptions.exporterPdfTableHeaderStyle ? gridOptions.exporterPdfTableHeaderStyle : { bold: true, fontSize: 12, color: 'black' };
	          /**
	           * @ngdoc object
	           * @name exporterPdfHeader
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = 'My Header';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfHeader: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfHeader = gridOptions.exporterPdfHeader ? gridOptions.exporterPdfHeader : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfFooter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = 'My Footer';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfFooter: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfFooter = gridOptions.exporterPdfFooter ? gridOptions.exporterPdfFooter : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfOrientation
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake value,
	           * 'landscape' or 'portrait'
	           * <br/>Defaults to landscape
	           */
	          gridOptions.exporterPdfOrientation = gridOptions.exporterPdfOrientation ? gridOptions.exporterPdfOrientation : 'landscape';
	          /**
	           * @ngdoc object
	           * @name exporterPdfPageSize
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake
	           * paper size, usually 'A4' or 'LETTER'
	           * {@link https://github.com/bpampuch/pdfmake/blob/master/src/standardPageSizes.js pdfMake page sizes}
	           * <br/>Defaults to A4
	           */
	          gridOptions.exporterPdfPageSize = gridOptions.exporterPdfPageSize ? gridOptions.exporterPdfPageSize : 'A4';
	          /**
	           * @ngdoc object
	           * @name exporterPdfMaxGridWidth
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The maxium grid width - the current grid width
	           * will be scaled to match this, with any fixed width columns
	           * being adjusted accordingly.
	           * <br/>Defaults to 720 (for A4 landscape), use 670 for LETTER
	           */
	          gridOptions.exporterPdfMaxGridWidth = gridOptions.exporterPdfMaxGridWidth ? gridOptions.exporterPdfMaxGridWidth : 720;
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableLayout
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A tableLayout in pdfMake format,
	           * controls gridlines and the like.  We use the default
	           * layout usually.
	           * <br/>Defaults to null, which means no layout
	           */
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuAllData
	           * @porpertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add export all data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuAllData = gridOptions.exporterMenuAllData !== undefined ? gridOptions.exporterMenuAllData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuCsv
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add csv export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuCsv = gridOptions.exporterMenuCsv !== undefined ? gridOptions.exporterMenuCsv : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuPdf
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add pdf export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuPdf = gridOptions.exporterMenuPdf !== undefined ? gridOptions.exporterMenuPdf : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterPdfCustomFormatter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A custom callback routine that changes the pdf document, adding any
	           * custom styling or content that is supported by pdfMake.  Takes in the complete docDefinition, and
	           * must return an updated docDefinition ready for pdfMake.
	           * @example
	           * In this example we add a style to the style array, so that we can use it in our
	           * footer definition.
	           * <pre>
	           *   gridOptions.exporterPdfCustomFormatter = function ( docDefinition ) {
	           *     docDefinition.styles.footerStyle = { bold: true, fontSize: 10 };
	           *     return docDefinition;
	           *   }
	           *
	           *   gridOptions.exporterPdfFooter = { text: 'My footer', style: 'footerStyle' }
	           * </pre>
	           */
	          gridOptions.exporterPdfCustomFormatter = ( gridOptions.exporterPdfCustomFormatter && typeof( gridOptions.exporterPdfCustomFormatter ) === 'function' ) ? gridOptions.exporterPdfCustomFormatter : function ( docDef ) { return docDef; };
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilterUseName
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Defaults to false, which leads to `displayName` being passed into the headerFilter.
	           * If set to true, then will pass `name` instead.
	           *
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilterUseName = true;
	           * </pre>
	           */
	          gridOptions.exporterHeaderFilterUseName = gridOptions.exporterHeaderFilterUseName === true;
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to apply to the header displayNames before exporting.  Useful for internationalisation,
	           * for example if you were using angular-translate you'd set this to `$translate.instant`.  Note that this
	           * call must be synchronous, it cannot be a call that returns a promise.
	           *
	           * Behaviour can be changed to pass in `name` instead of `displayName` through use of `exporterHeaderFilterUseName: true`.
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = function( displayName ){ return 'col: ' + name; };
	           * </pre>
	           * OR
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = $translate.instant;
	           * </pre>
	           */
	
	          /**
	           * @ngdoc function
	           * @name exporterFieldCallback
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call for each field before exporting it.  Allows
	           * massaging of raw data into a display format, for example if you have applied
	           * filters to convert codes into decodes, or you require
	           * a specific date format in the exported content.
	           *
	           * The method is called once for each field exported, and provides the grid, the
	           * gridCol and the GridRow for you to use as context in massaging the data.
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {GridRow} row the row from which the data comes
	           * @param {GridCol} col the column from which the data comes
	           * @param {object} value the value for your massaging
	           * @returns {object} you must return the massaged value ready for exporting
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ){
	           *     if ( col.name === 'status' ){
	           *       value = decodeStatus( value );
	           *     }
	           *     return value;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterFieldCallback = gridOptions.exporterFieldCallback ? gridOptions.exporterFieldCallback : function( grid, row, col, value ) { return value; };
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataFn
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description This promise is needed when exporting all rows,
	           * and the data need to be provided by server side. Default is null.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterAllDataFn = gridOptions.exporterAllDataFn ? gridOptions.exporterAllDataFn : null;
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataPromise
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description DEPRECATED - exporterAllDataFn used to be
	           * called this, but it wasn't a promise, it was a function that returned
	           * a promise.  Deprecated, but supported for backward compatibility, use
	           * exporterAllDataFn instead.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          if ( gridOptions.exporterAllDataFn == null && gridOptions.exporterAllDataPromise ) {
	            gridOptions.exporterAllDataFn = gridOptions.exporterAllDataPromise;
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Adds export items to the grid menu,
	         * allowing the user to select export options
	         * @param {Grid} grid the grid from which data should be exported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsCsv'),
	              action: function ($event) {
	                this.grid.api.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return this.grid.options.exporterMenuCsv && this.grid.options.exporterMenuAllData;
	              },
	              order: 200
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsCsv'),
	              action: function ($event) {
	                this.grid.api.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return this.grid.options.exporterMenuCsv;
	              },
	              order: 201
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsCsv'),
	              action: function ($event) {
	                this.grid.api.exporter.csvExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return this.grid.options.exporterMenuCsv &&
	                       ( this.grid.api.selection && this.grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: 202
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsPdf'),
	              action: function ($event) {
	                this.grid.api.exporter.pdfExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return this.grid.options.exporterMenuPdf && this.grid.options.exporterMenuAllData;
	              },
	              order: 203
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsPdf'),
	              action: function ($event) {
	                this.grid.api.exporter.pdfExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return this.grid.options.exporterMenuPdf;
	              },
	              order: 204
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsPdf'),
	              action: function ($event) {
	                this.grid.api.exporter.pdfExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return this.grid.options.exporterMenuPdf &&
	                       ( this.grid.api.selection && this.grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: 205
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name csvExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in csv format,
	         * the data exported is selected based on the provided options
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        csvExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function() {
	            var exportColumnHeaders = grid.options.showHeader ? self.getColumnHeaders(grid, colTypes) : [];
	            var exportData = self.getData(grid, rowTypes, colTypes);
	            var csvContent = self.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
	
	            self.downloadFile (grid.options.exporterCsvFilename, csvContent, grid.options.exporterOlderExcelCompatibility);
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name loadAllDataIfNeeded
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description When using server side pagination, use exporterAllDataFn to
	         * load all data before continuing processing.
	         * When using client side pagination, return a resolved promise so processing
	         * continues immediately
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        loadAllDataIfNeeded: function (grid, rowTypes, colTypes) {
	          if ( rowTypes === uiGridExporterConstants.ALL && grid.rows.length !== grid.options.totalItems && grid.options.exporterAllDataFn) {
	            return grid.options.exporterAllDataFn()
	              .then(function() {
	                grid.modifyRows(grid.options.data);
	              });
	          } else {
	            var deferred = $q.defer();
	            deferred.resolve();
	            return deferred.promise;
	          }
	        },
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterSuppressExport
	         * @description Suppresses export for this column.  Used by selection and expandable.
	         */
	
	        /**
	         * @ngdoc function
	         * @name getColumnHeaders
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets the column headers from the grid to use
	         * as a title row for the exported file, all headers have
	         * headerCellFilters applied as appropriate.
	         *
	         * Column headers are an array of objects, each object has
	         * name, displayName, width and align attributes.  Only name is
	         * used for csv, all attributes are used for pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        getColumnHeaders: function (grid, colTypes) {
	          var headers = [];
	          var columns;
	
	          if ( colTypes === uiGridExporterConstants.ALL ){
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns,rightColumns);
	          }
	
	          columns.forEach( function( gridCol, index ) {
	            if ( gridCol.colDef.exporterSuppressExport !== true &&
	                 grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ){
	              headers.push({
	                name: gridCol.field,
	                displayName: grid.options.exporterHeaderFilter ? ( grid.options.exporterHeaderFilterUseName ? grid.options.exporterHeaderFilter(gridCol.name) : grid.options.exporterHeaderFilter(gridCol.displayName) ) : gridCol.displayName,
	                width: gridCol.drawnWidth ? gridCol.drawnWidth : gridCol.width,
	                align: gridCol.colDef.type === 'number' ? 'right' : 'left'
	              });
	            }
	          });
	
	          return headers;
	        },
	
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterPdfAlign
	         * @description the alignment you'd like for this specific column when
	         * exported into a pdf.  Can be 'left', 'right', 'center' or any other
	         * valid pdfMake alignment option.
	         */
	
	
	        /**
	         * @ngdoc object
	         * @name ui.grid.exporter.api:GridRow
	         * @description GridRow settings for exporter
	         */
	        /**
	         * @ngdoc object
	         * @name exporterEnableExporting
	         * @propertyOf  ui.grid.exporter.api:GridRow
	         * @description If set to false, then don't export this row, notwithstanding visible or
	         * other settings
	         * <br/>Defaults to true
	         */
	
	        /**
	         * @ngdoc function
	         * @name getData
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets data from the grid based on the provided options,
	         * all cells have cellFilters applied as appropriate.  Any rows marked
	         * `exporterEnableExporting: false` will not be exported
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        getData: function (grid, rowTypes, colTypes) {
	          var data = [];
	          var rows;
	          var columns;
	
	          switch ( rowTypes ) {
	            case uiGridExporterConstants.ALL:
	              rows = grid.rows;
	              break;
	            case uiGridExporterConstants.VISIBLE:
	              rows = grid.getVisibleRows();
	              break;
	            case uiGridExporterConstants.SELECTED:
	              if ( grid.api.selection ){
	                rows = grid.api.selection.getSelectedGridRows();
	              } else {
	                gridUtil.logError('selection feature must be enabled to allow selected rows to be exported');
	              }
	              break;
	          }
	
	          if ( colTypes === uiGridExporterConstants.ALL ){
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns,rightColumns);
	          }
	
	          rows.forEach( function( row, index ) {
	
	            if (row.exporterEnableExporting !== false) {
	              var extractedRow = [];
	
	
	              columns.forEach( function( gridCol, index ) {
	              if ( (gridCol.visible || colTypes === uiGridExporterConstants.ALL ) &&
	                   gridCol.colDef.exporterSuppressExport !== true &&
	                   grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ){
	                  var extractedField = { value: grid.options.exporterFieldCallback( grid, row, gridCol, grid.getCellValue( row, gridCol ) ) };
	                  if ( gridCol.colDef.exporterPdfAlign ) {
	                    extractedField.alignment = gridCol.colDef.exporterPdfAlign;
	                  }
	                  extractedRow.push(extractedField);
	                }
	              });
	
	              data.push(extractedRow);
	            }
	          });
	
	          return data;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatAsCSV
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Formats the column headers and data as a CSV,
	         * and sends that data to the user
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @returns {string} csv the formatted csv as a string
	         */
	        formatAsCsv: function (exportColumnHeaders, exportData, separator) {
	          var self = this;
	
	          var bareHeaders = exportColumnHeaders.map(function(header){return { value: header.displayName };});
	
	          var csv = bareHeaders.length > 0 ? (self.formatRowAsCsv(this, separator)(bareHeaders) + '\n') : '';
	
	          csv += exportData.map(this.formatRowAsCsv(this, separator)).join('\n');
	
	          return csv;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a csv string
	         * @returns {string} a csv-ified version of the row
	         */
	        formatRowAsCsv: function (exporter, separator) {
	          return function (row) {
	            return row.map(exporter.formatFieldAsCsv).join(separator);
	          };
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {field} field the field to be turned into a csv string,
	         * may be of any type
	         * @returns {string} a csv-ified version of the field
	         */
	        formatFieldAsCsv: function (field) {
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            return '';
	          }
	          if (typeof(field.value) === 'number') {
	            return field.value;
	          }
	          if (typeof(field.value) === 'boolean') {
	            return (field.value ? 'TRUE' : 'FALSE') ;
	          }
	          if (typeof(field.value) === 'string') {
	            return '"' + field.value.replace(/"/g,'""') + '"';
	          }
	
	          return JSON.stringify(field.value);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name isIE
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Checks whether current browser is IE and returns it's version if it is
	        */
	        isIE: function () {
	          var match = navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
	          return match ? parseInt(match[1]) : false;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadFile
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Triggers download of a csv file.  Logic provided
	         * by @cssensei (from his colleagues at https://github.com/ifeelgoods) in issue #2391
	         * @param {string} fileName the filename we'd like our file to be
	         * given
	         * @param {string} csvContent the csv content that we'd like to
	         * download as a file
	         * @param {boolean} exporterOlderExcelCompatibility whether or not we put a utf-16 BOM on the from (\uFEFF)
	         */
	        downloadFile: function (fileName, csvContent, exporterOlderExcelCompatibility) {
	          var D = document;
	          var a = D.createElement('a');
	          var strMimeType = 'application/octet-stream;charset=utf-8';
	          var rawFile;
	          var ieVersion;
	
	          ieVersion = this.isIE();
	          if (ieVersion && ieVersion < 10) {
	            var frame = D.createElement('iframe');
	            document.body.appendChild(frame);
	
	            frame.contentWindow.document.open("text/html", "replace");
	            frame.contentWindow.document.write('sep=,\r\n' + csvContent);
	            frame.contentWindow.document.close();
	            frame.contentWindow.focus();
	            frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	            document.body.removeChild(frame);
	            return true;
	          }
	
	          // IE10+
	          if (navigator.msSaveBlob) {
	            return navigator.msSaveOrOpenBlob(
	              new Blob(
	                [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	                { type: strMimeType } ),
	              fileName
	            );
	          }
	
	          //html5 A[download]
	          if ('download' in a) {
	            var blob = new Blob(
	              [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	              { type: strMimeType }
	            );
	            rawFile = URL.createObjectURL(blob);
	            a.setAttribute('download', fileName);
	          } else {
	            rawFile = 'data:' + strMimeType + ',' + encodeURIComponent(csvContent);
	            a.setAttribute('target', '_blank');
	          }
	
	          a.href = rawFile;
	          a.setAttribute('style', 'display:none;');
	          D.body.appendChild(a);
	          setTimeout(function() {
	            if (a.click) {
	              a.click();
	              // Workaround for Safari 5
	            } else if (document.createEvent) {
	              var eventObj = document.createEvent('MouseEvents');
	              eventObj.initEvent('click', true, true);
	              a.dispatchEvent(eventObj);
	            }
	            D.body.removeChild(a);
	
	          }, this.delay);
	        },
	
	        /**
	         * @ngdoc function
	         * @name pdfExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in pdf format,
	         * the data exported is selected based on the provided options.
	         * Note that this function has a dependency on pdfMake, which must
	         * be installed.  The resulting pdf opens in a new
	         * browser window.
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        pdfExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function () {
	            var exportColumnHeaders = self.getColumnHeaders(grid, colTypes);
	            var exportData = self.getData(grid, rowTypes, colTypes);
	            var docDefinition = self.prepareAsPdf(grid, exportColumnHeaders, exportData);
	
	            if (self.isIE()) {
	              self.downloadPDF(grid.options.exporterPdfFilename, docDefinition);
	            } else {
	              pdfMake.createPdf(docDefinition).open();
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Generates and retrieves the pdf as a blob, then downloads
	         * it as a file.  Only used in IE, in all other browsers we use the native
	         * pdfMake.open function to just open the PDF
	         * @param {string} fileName the filename to give to the pdf, can be set
	         * through exporterPdfFilename
	         * @param {object} docDefinition a pdf docDefinition that we can generate
	         * and get a blob from
	         */
	        downloadPDF: function (fileName, docDefinition) {
	          var D = document;
	          var a = D.createElement('a');
	          var strMimeType = 'application/octet-stream;charset=utf-8';
	          var rawFile;
	          var ieVersion;
	
	          ieVersion = this.isIE();
	          var doc = pdfMake.createPdf(docDefinition);
	          var blob;
	
	          doc.getBuffer( function (buffer) {
	            blob = new Blob([buffer]);
	
	            if (ieVersion && ieVersion < 10) {
	              var frame = D.createElement('iframe');
	              document.body.appendChild(frame);
	
	              frame.contentWindow.document.open("text/html", "replace");
	              frame.contentWindow.document.write(blob);
	              frame.contentWindow.document.close();
	              frame.contentWindow.focus();
	              frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	              document.body.removeChild(frame);
	              return true;
	            }
	
	            // IE10+
	            if (navigator.msSaveBlob) {
	              return navigator.msSaveBlob(
	                blob, fileName
	              );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name renderAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders the data into a pdf, and opens that pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @returns {object} a pdfMake format document definition, ready
	         * for generation
	         */
	        prepareAsPdf: function(grid, exportColumnHeaders, exportData) {
	          var headerWidths = this.calculatePdfHeaderWidths( grid, exportColumnHeaders );
	
	          var headerColumns = exportColumnHeaders.map( function( header ) {
	            return { text: header.displayName, style: 'tableHeader' };
	          });
	
	          var stringData = exportData.map(this.formatRowAsPdf(this));
	
	          var allData = [headerColumns].concat(stringData);
	
	          var docDefinition = {
	            pageOrientation: grid.options.exporterPdfOrientation,
	            pageSize: grid.options.exporterPdfPageSize,
	            content: [{
	              style: 'tableStyle',
	              table: {
	                headerRows: 1,
	                widths: headerWidths,
	                body: allData
	              }
	            }],
	            styles: {
	              tableStyle: grid.options.exporterPdfTableStyle,
	              tableHeader: grid.options.exporterPdfTableHeaderStyle
	            },
	            defaultStyle: grid.options.exporterPdfDefaultStyle
	          };
	
	          if ( grid.options.exporterPdfLayout ){
	            docDefinition.layout = grid.options.exporterPdfLayout;
	          }
	
	          if ( grid.options.exporterPdfHeader ){
	            docDefinition.header = grid.options.exporterPdfHeader;
	          }
	
	          if ( grid.options.exporterPdfFooter ){
	            docDefinition.footer = grid.options.exporterPdfFooter;
	          }
	
	          if ( grid.options.exporterPdfCustomFormatter ){
	            docDefinition = grid.options.exporterPdfCustomFormatter( docDefinition );
	          }
	          return docDefinition;
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name calculatePdfHeaderWidths
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Determines the column widths base on the
	         * widths we got from the grid.  If the column is drawn
	         * then we have a drawnWidth.  If the column is not visible
	         * then we have '*', 'x%' or a width.  When columns are
	         * not visible they don't contribute to the overall gridWidth,
	         * so we need to adjust to allow for extra columns
	         *
	         * Our basic heuristic is to take the current gridWidth, plus
	         * numeric columns and call this the base gridwidth.
	         *
	         * To that we add 100 for any '*' column, and x% of the base gridWidth
	         * for any column that is a %
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportHeaders array of header information
	         * @returns {object} an array of header widths
	         */
	        calculatePdfHeaderWidths: function ( grid, exportHeaders ) {
	          var baseGridWidth = 0;
	          exportHeaders.forEach( function(value){
	            if (typeof(value.width) === 'number'){
	              baseGridWidth += value.width;
	            }
	          });
	
	          var extraColumns = 0;
	          exportHeaders.forEach( function(value){
	            if (value.width === '*'){
	              extraColumns += 100;
	            }
	            if (typeof(value.width) === 'string' && value.width.match(/(\d)*%/)) {
	              var percent = parseInt(value.width.match(/(\d)*%/)[0]);
	
	              value.width = baseGridWidth * percent / 100;
	              extraColumns += value.width;
	            }
	          });
	
	          var gridWidth = baseGridWidth + extraColumns;
	
	          return exportHeaders.map(function( header ) {
	            return header.width === '*' ? header.width : header.width * grid.options.exporterPdfMaxGridWidth / gridWidth;
	          });
	
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a row in a format consumable by PDF,
	         * mainly meaning casting everything to a string
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a csv string
	         * @returns {string} a csv-ified version of the row
	         */
	        formatRowAsPdf: function ( exporter ) {
	          return function( row ) {
	            return row.map(exporter.formatFieldAsPdfString);
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a pdf-able field, which
	         * is different from a csv field only in that strings don't have quotes
	         * around them
	         * @param {field} field the field to be turned into a pdf string,
	         * may be of any type
	         * @returns {string} a string-ified version of the field
	         */
	        formatFieldAsPdfString: function (field) {
	          var returnVal;
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            returnVal = '';
	          } else if (typeof(field.value) === 'number') {
	            returnVal = field.value.toString();
	          } else if (typeof(field.value) === 'boolean') {
	            returnVal = (field.value ? 'TRUE' : 'FALSE') ;
	          } else if (typeof(field.value) === 'string') {
	            returnVal = field.value.replace(/"/g,'""');
	          } else {
	            returnVal = JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');
	          }
	
	          if (field.alignment && typeof(field.alignment) === 'string' ){
	            returnVal = { text: returnVal, alignment: field.alignment };
	          }
	
	          return returnVal;
	        }
	      };
	
	      return service;
	
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.exporter.directive:uiGridExporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds exporter features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.exporter']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        enableGridMenu: true,
	        exporterMenuCsv: false,
	        columnDefs: [
	          {name: 'name', enableCellEdit: true},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-exporter></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridExporter', ['uiGridExporterConstants', 'uiGridExporterService', 'gridUtil', '$compile',
	    function (uiGridExporterConstants, uiGridExporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridExporterService.initializeGrid(uiGridCtrl.grid);
	          uiGridCtrl.grid.exporter.$scope = $scope;
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.grouping
	   * @description
	   *
	   * # ui.grid.grouping
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides grouping of rows based on the data in them, similar
	   * in concept to excel grouping.  You can group multiple columns, resulting in
	   * nested grouping.
	   *
	   * In concept this feature is similar to sorting + grid footer/aggregation, it
	   * sorts the data based on the grouped columns, then creates group rows that
	   * reflect a break in the data.  Each of those group rows can have aggregations for
	   * the data within that group.
	   *
	   * This feature leverages treeBase to provide the tree functionality itself,
	   * the key thing this feature does therefore is to set treeLevels on the rows
	   * and insert the group headers.
	   *
	   * Design information:
	   * -------------------
	   *
	   * Each column will get new menu items - group by, and aggregate by.  Group by
	   * will cause this column to be sorted (if not already), and will move this column
	   * to the front of the sorted columns (i.e. grouped columns take precedence over
	   * sorted columns).  It will respect the sort order already set if there is one,
	   * and it will allow the sorting logic to change that sort order, it just forces
	   * the column to the front of the sorting.  You can group by multiple columns, the
	   * logic will add this column to the sorting after any already grouped columns.
	   *
	   * Once a grouping is defined, grouping logic is added to the rowsProcessors.  This
	   * will process the rows, identifying a break in the data value, and inserting a grouping row.
	   * Grouping rows have specific attributes on them:
	   *
	   *  - internalRow = true: tells us that this isn't a real row, so we can ignore it
	   *    from any processing that it looking at core data rows.  This is used by the core
	   *    logic (or will be one day), as it's not grouping specific
	   *  - groupHeader = true: tells us this is a groupHeader.  This is used by the grouping logic
	   *    to know if this is a groupHeader row or not
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  In order to avoid the row instantiation
	   * time, and to preserve state across invocations, we hold a cache of the rows that we created
	   * last time, and we use them again this time if we can.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.grouping"></div>
	   */
	
	  var module = angular.module('ui.grid.grouping', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.grouping.constant:uiGridGroupingConstants
	   *
	   *  @description constants available in grouping module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridGroupingConstants', {
	    featureName: "grouping",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.grouping.service:uiGridGroupingService
	   *
	   *  @description Services for grouping features
	   */
	  module.service('uiGridGroupingService', ['$q', 'uiGridGroupingConstants', 'gridUtil', 'rowSorter', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'uiGridTreeBaseService',
	  function ($q, uiGridGroupingConstants, gridUtil, rowSorter, GridRow, gridClassFactory, i18nService, uiGridConstants, uiGridTreeBaseService) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        //add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.grid:grouping
	         *
	         *  @description Grid properties and functions added for grouping
	         */
	        grid.grouping = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.grouping.grid:grouping
	         *  @name groupHeaderCache
	         *
	         *  @description Cache that holds the group header rows we created last time, we'll
	         *  reuse these next time, not least because they hold our expanded states.
	         *
	         *  We need to take care with these that they don't become a memory leak, we
	         *  create a new cache each time using the values from the old cache.  This works
	         *  so long as we're creating group rows for invisible rows as well.
	         *
	         *  The cache is a nested hash, indexed on the value we grouped by.  So if we
	         *  grouped by gender then age, we'd maybe have something like:
	         *  ```
	         *    {
	         *      male: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          22: { row: <pointer to the old row> },
	         *          31: { row: <pointer to the old row> }
	         *      },
	         *      female: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          28: { row: <pointer to the old row> },
	         *          55: { row: <pointer to the old row> }
	         *      }
	         *    }
	         *  ```
	         *
	         *  We create new rows for any missing rows, this means that they come in as collapsed.
	         *
	         */
	        grid.grouping.groupHeaderCache = {};
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.groupRows, 400);
	
	        grid.registerColumnBuilder( service.groupingColumnBuilder);
	
	        grid.registerColumnsProcessor(service.groupingColumnProcessor, 400);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:PublicApi
	         *
	         *  @description Public Api for grouping feature
	         */
	        var publicApi = {
	          events: {
	            grouping: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name aggregationChanged
	               * @description raised whenever aggregation is changed, added or removed from a column
	               *
	               * <pre>
	               *      gridApi.grouping.on.aggregationChanged(scope,function(col){})
	               * </pre>
	               * @param {gridCol} col the column which on which aggregation changed. The aggregation
	               * type is available as `col.treeAggregation.type`
	               */
	              aggregationChanged: {},
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name groupingChanged
	               * @description raised whenever the grouped columns changes
	               *
	               * <pre>
	               *      gridApi.grouping.on.groupingChanged(scope,function(col){})
	               * </pre>
	               * @param {gridCol} col the column which on which grouping changed. The new grouping is
	               * available as `col.grouping`
	               */
	              groupingChanged: {}
	            }
	          },
	          methods: {
	            grouping: {
	              /**
	               * @ngdoc function
	               * @name getGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Get the grouping configuration for this grid,
	               * used by the saveState feature.  Adds expandedState to the information
	               * provided by the internal getGrouping, and removes any aggregations that have a source
	               * of grouping (i.e. will be automatically reapplied when we regroup the column)
	               * Returned grouping is an object
	               *   `{ grouping: groupArray, treeAggregations: aggregateArray, expandedState: hash }`
	               * where grouping contains an array of objects:
	               *   `{ field: column.field, colName: column.name, groupPriority: column.grouping.groupPriority }`
	               * and aggregations contains an array of objects:
	               *   `{ field: column.field, colName: column.name, aggregation: column.grouping.aggregation }`
	               * and expandedState is a hash of the currently expanded nodes
	               *
	               * The groupArray will be sorted by groupPriority.
	               *
	               * @param {boolean} getExpanded whether or not to return the expanded state
	               * @returns {object} grouping configuration
	               */
	              getGrouping: function ( getExpanded ) {
	                var grouping = service.getGrouping(grid);
	
	                grouping.grouping.forEach( function( group ) {
	                  group.colName = group.col.name;
	                  delete group.col;
	                });
	
	                grouping.aggregations.forEach( function( aggregation ) {
	                  aggregation.colName = aggregation.col.name;
	                  delete aggregation.col;
	                });
	
	                grouping.aggregations = grouping.aggregations.filter( function( aggregation ){
	                  return !aggregation.aggregation.source || aggregation.aggregation.source !== 'grouping';
	                });
	
	                if ( getExpanded ){
	                  grouping.rowExpandedStates = service.getRowExpandedStates( grid.grouping.groupingHeaderCache );
	                }
	
	                return grouping;
	              },
	
	              /**
	               * @ngdoc function
	               * @name setGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Set the grouping configuration for this grid,
	               * used by the saveState feature, but can also be used by any
	               * user to specify a combined grouping and aggregation configuration
	               * @param {object} config the config you want to apply, in the format
	               * provided out by getGrouping
	               */
	              setGrouping: function ( config ) {
	                service.setGrouping(grid, config);
	              },
	
	              /**
	               * @ngdoc function
	               * @name groupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Adds this column to the existing grouping, at the end of the priority order.
	               * If the column doesn't have a sort, adds one, by default ASC
	               *
	               * This column will move to the left of any non-group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to group
	               */
	              groupColumn: function( columnName ) {
	                var column = grid.getColumn(columnName);
	                service.groupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name ungroupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Removes the groupPriority from this column.  If the
	               * column was previously aggregated the aggregation will come back.
	               * The sort will remain.
	               *
	               * This column will move to the right of any other group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to ungroup
	               */
	              ungroupColumn: function( columnName ) {
	                var column = grid.getColumn(columnName);
	                service.ungroupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name clearGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	               * as we don't know whether that sorting was added by grouping or was there beforehand
	               *
	               */
	              clearGrouping: function() {
	                service.clearGrouping(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name aggregateColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Sets the aggregation type on a column, if the
	               * column is currently grouped then it removes the grouping first.
	               * If the aggregationDef is null then will result in the aggregation
	               * being removed
	               *
	               * @param {string} columnName the column we want to aggregate
	               * @param {string} or {function} aggregationDef one of the recognised types
	               * from uiGridGroupingConstants or a custom aggregation function.
	               * @param {string} aggregationLabel (optional) The label to use for this aggregation.
	               */
	              aggregateColumn: function( columnName, aggregationDef, aggregationLabel){
	                var column = grid.getColumn(columnName);
	                service.aggregateColumn( grid, column, aggregationDef, aggregationLabel);
	              }
	
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	        grid.api.core.on.sortChanged( $scope, service.tidyPriorities);
	
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:GridOptions
	         *
	         *  @description GridOptions for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Enable row grouping for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableGrouping = gridOptions.enableGrouping !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowCounts
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description shows counts on the groupHeader rows. Not that if you are using a cellFilter or a
	         *  sortingAlgorithm which relies on a specific format or data type, showing counts may cause that
	         *  to break, since the group header rows will always be a string with groupingShowCounts enabled.
	         *  <br/>Defaults to true except on columns of type 'date'
	         */
	        gridOptions.groupingShowCounts = gridOptions.groupingShowCounts !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingNullLabel
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description The string to use for the grouping header row label on rows which contain a null or undefined value in the grouped column.
	         *  <br/>Defaults to "Null"
	         */
	        gridOptions.groupingNullLabel = typeof(gridOptions.groupingNullLabel) === 'undefined' ? 'Null' : gridOptions.groupingNullLabel;
	
	        /**
	         *  @ngdoc object
	         *  @name enableGroupHeaderSelection
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Allows group header rows to be selected.
	         *  <br/>Defaults to false
	         */
	        gridOptions.enableGroupHeaderSelection = gridOptions.enableGroupHeaderSelection === true;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnBuilder
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the grouping defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridCol} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      groupingColumnBuilder: function (colDef, col, gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:ColumnDef
	         *
	         *  @description ColumnDef for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Enable grouping on this column
	         *  <br/>Defaults to true.
	         */
	        if (colDef.enableGrouping === false){
	          return;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Set the grouping for a column.  Format is:
	         *  ```
	         *    {
	         *      groupPriority: <number, starts at 0, if less than 0 or undefined then we're aggregating in this column>
	         *    }
	         *  ```
	         *
	         *  **Note that aggregation used to be included in grouping, but is now separately set on the column via treeAggregation
	         *  setting in treeBase**
	         *
	         *  We group in the priority order given, this will also put these columns to the high order of the sort irrespective
	         *  of the sort priority given them.  If there is no sort defined then we sort ascending, if there is a sort defined then
	         *  we use that sort.
	         *
	         *  If the groupPriority is undefined or less than 0, then we expect to be aggregating, and we look at the
	         *  aggregation types to determine what sort of aggregation we can do.  Values are in the constants file, but
	         *  include SUM, COUNT, MAX, MIN
	         *
	         *  groupPriorities should generally be sequential, if they're not then the next time getGrouping is called
	         *  we'll renumber them to be sequential.
	         *  <br/>Defaults to undefined.
	         */
	
	        if ( typeof(col.grouping) === 'undefined' && typeof(colDef.grouping) !== 'undefined') {
	          col.grouping = angular.copy(colDef.grouping);
	          if ( typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority > -1 ){
	            col.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	            col.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	          }
	        } else if (typeof(col.grouping) === 'undefined'){
	          col.grouping = {};
	        }
	
	        if (typeof(col.grouping) !== 'undefined' && typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority >= 0){
	          col.suppressRemoveSort = true;
	        }
	
	        var groupColumn = {
	          name: 'ui.grid.grouping.group',
	          title: i18nService.get().grouping.group,
	          icon: 'ui-grid-icon-indent-right',
	          shown: function () {
	            return typeof(this.context.col.grouping) === 'undefined' ||
	                   typeof(this.context.col.grouping.groupPriority) === 'undefined' ||
	                   this.context.col.grouping.groupPriority < 0;
	          },
	          action: function () {
	            service.groupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var ungroupColumn = {
	          name: 'ui.grid.grouping.ungroup',
	          title: i18nService.get().grouping.ungroup,
	          icon: 'ui-grid-icon-indent-left',
	          shown: function () {
	            return typeof(this.context.col.grouping) !== 'undefined' &&
	                   typeof(this.context.col.grouping.groupPriority) !== 'undefined' &&
	                   this.context.col.grouping.groupPriority >= 0;
	          },
	          action: function () {
	            service.ungroupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var aggregateRemove = {
	          name: 'ui.grid.grouping.aggregateRemove',
	          title: i18nService.get().grouping.aggregate_remove,
	          shown: function () {
	            return typeof(this.context.col.treeAggregationFn) !== 'undefined';
	          },
	          action: function () {
	            service.aggregateColumn( this.context.col.grid, this.context.col, null);
	          }
	        };
	
	        // generic adder for the aggregation menus, which follow a pattern
	        var addAggregationMenu = function(type, title){
	          title = title || i18nService.get().grouping['aggregate_' + type] || type;
	          var menuItem = {
	            name: 'ui.grid.grouping.aggregate' + type,
	            title: title,
	            shown: function () {
	              return typeof(this.context.col.treeAggregation) === 'undefined' ||
	                     typeof(this.context.col.treeAggregation.type) === 'undefined' ||
	                     this.context.col.treeAggregation.type !== type;
	            },
	            action: function () {
	              service.aggregateColumn( this.context.col.grid, this.context.col, type);
	            }
	          };
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregate' + type)) {
	            col.menuItems.push(menuItem);
	          }
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowGroupingMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the grouping (group and ungroup items) menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowGroupingMenu !== false ){
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.group')) {
	            col.menuItems.push(groupColumn);
	          }
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.ungroup')) {
	            col.menuItems.push(ungroupColumn);
	          }
	        }
	
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowAggregationMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the aggregation menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowAggregationMenu !== false ){
	          angular.forEach(uiGridTreeBaseService.nativeAggregations(), function(aggregationDef, name){
	            addAggregationMenu(name);
	          });
	          angular.forEach(gridOptions.treeCustomAggregations, function(aggregationDef, name){
	            addAggregationMenu(name, aggregationDef.menuTitle);
	          });
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregateRemove')) {
	            col.menuItems.push(aggregateRemove);
	          }
	        }
	      },
	
	
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnProcessor
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the columns around based on which are grouped
	       *
	       * @param {array} columns the columns to consider rendering
	       * @param {array} rows the grid rows, which we don't use but are passed to us
	       * @returns {array} updated columns array
	       */
	      groupingColumnProcessor: function( columns, rows ) {
	        var grid = this;
	
	        columns = service.moveGroupColumns(this, columns, rows);
	        return columns;
	      },
	
	      /**
	       * @ngdoc function
	       * @name groupedFinalizerFn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Used on group columns to display the rendered value and optionally
	       * display the count of rows.
	       *
	       * @param {aggregation} the aggregation entity for a grouped column
	       */
	      groupedFinalizerFn: function( aggregation ){
	        var col = this;
	
	        if ( typeof(aggregation.groupVal) !== 'undefined') {
	          aggregation.rendered = aggregation.groupVal;
	          if ( col.grid.options.groupingShowCounts && col.colDef.type !== 'date' ){
	            aggregation.rendered += (' (' + aggregation.value + ')');
	          }
	        } else {
	          aggregation.rendered = null;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name moveGroupColumns
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the column order so that the grouped columns are lined up
	       * to the left (well, unless you're RTL, then it's the right).  By doing this in
	       * the columnsProcessor, we make it transient - when the column is ungrouped it'll
	       * go back to where it was.
	       *
	       * Does nothing if the option `moveGroupColumns` is set to false.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} columns the columns that we should process/move
	       * @param {array} rows the grid rows
	       * @returns {array} updated columns
	       */
	      moveGroupColumns: function( grid, columns, rows ){
	        if ( grid.options.moveGroupColumns === false){
	          return columns;
	        }
	
	        columns.forEach( function(column, index){
	          // position used to make stable sort in moveGroupColumns
	          column.groupingPosition = index;
	        });
	
	        columns.sort(function(a, b){
	          var a_group, b_group;
	          if (a.isRowHeader){
	            a_group = -1000;
	          }
	          else if ( typeof(a.grouping) === 'undefined' || typeof(a.grouping.groupPriority) === 'undefined' || a.grouping.groupPriority < 0){
	            a_group = null;
	          } else {
	            a_group = a.grouping.groupPriority;
	          }
	
	          if (b.isRowHeader){
	            b_group = -1000;
	          }
	          else if ( typeof(b.grouping) === 'undefined' || typeof(b.grouping.groupPriority) === 'undefined' || b.grouping.groupPriority < 0){
	            b_group = null;
	          } else {
	            b_group = b.grouping.groupPriority;
	          }
	
	          // groups get sorted to the top
	          if ( a_group !== null && b_group === null) { return -1; }
	          if ( b_group !== null && a_group === null) { return 1; }
	          if ( a_group !== null && b_group !== null) {return a_group - b_group; }
	
	          return a.groupingPosition - b.groupingPosition;
	        });
	
	        columns.forEach( function(column, index) {
	          delete column.groupingPosition;
	        });
	
	        return columns;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Adds this column to the existing grouping, at the end of the priority order.
	       * If the column doesn't have a sort, adds one, by default ASC
	       *
	       * This column will move to the left of any non-group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridCol} column the column we want to group
	       */
	      groupColumn: function( grid, column){
	        if ( typeof(column.grouping) === 'undefined' ){
	          column.grouping = {};
	        }
	
	        // set the group priority to the next number in the hierarchy
	        var existingGrouping = service.getGrouping( grid );
	        column.grouping.groupPriority = existingGrouping.grouping.length;
	
	        // add sort if not present
	        if ( !column.sort ){
	          column.sort = { direction: uiGridConstants.ASC };
	        } else if ( typeof(column.sort.direction) === 'undefined' || column.sort.direction === null ){
	          column.sort.direction = uiGridConstants.ASC;
	        }
	
	        column.treeAggregation = { type: uiGridGroupingConstants.aggregation.COUNT, source: 'grouping' };
	        column.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	        column.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	
	        grid.api.grouping.raise.groupingChanged(column);
	        // This indirectly calls service.tidyPriorities( grid );
	        grid.api.core.raise.sortChanged(grid, grid.getColumnSorting());
	
	        grid.queueGridRefresh();
	      },
	
	
	       /**
	       * @ngdoc function
	       * @name ungroupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Removes the groupPriority from this column.  If the
	       * column was previously aggregated the aggregation will come back.
	       * The sort will remain.
	       *
	       * This column will move to the right of any other group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridCol} column the column we want to ungroup
	       */
	      ungroupColumn: function( grid, column){
	        if ( typeof(column.grouping) === 'undefined' ){
	          return;
	        }
	
	        delete column.grouping.groupPriority;
	        delete column.treeAggregation;
	        delete column.customTreeAggregationFinalizer;
	
	        service.tidyPriorities( grid );
	
	        grid.api.grouping.raise.groupingChanged(column);
	
	        grid.queueGridRefresh();
	      },
	
	      /**
	       * @ngdoc function
	       * @name aggregateColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the aggregation type on a column, if the
	       * column is currently grouped then it removes the grouping first.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridCol} column the column we want to aggregate
	       * @param {string} one of the recognised types from uiGridGroupingConstants or one of the custom aggregations from gridOptions
	       */
	      aggregateColumn: function( grid, column, aggregationType){
	
	        if (typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0){
	          service.ungroupColumn( grid, column );
	        }
	
	        var aggregationDef = {};
	        if ( typeof(grid.options.treeCustomAggregations[aggregationType]) !== 'undefined' ){
	          aggregationDef = grid.options.treeCustomAggregations[aggregationType];
	        } else if ( typeof(uiGridTreeBaseService.nativeAggregations()[aggregationType]) !== 'undefined' ){
	          aggregationDef = uiGridTreeBaseService.nativeAggregations()[aggregationType];
	        }
	
	        column.treeAggregation = { type: aggregationType, label:  i18nService.get().aggregation[aggregationDef.label] || aggregationDef.label };
	        column.treeAggregationFn = aggregationDef.aggregationFn;
	        column.treeAggregationFinalizerFn = aggregationDef.finalizerFn;
	
	        grid.api.grouping.raise.aggregationChanged(column);
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set the grouping based on a config object, used by the save state feature
	       * (more specifically, by the restore function in that feature )
	       *
	       * @param {Grid} grid grid object
	       * @param {object} config the config we want to set, same format as that returned by getGrouping
	       */
	      setGrouping: function ( grid, config ){
	        if ( typeof(config) === 'undefined' ){
	          return;
	        }
	
	        // first remove any existing grouping
	        service.clearGrouping(grid);
	
	        if ( config.grouping && config.grouping.length && config.grouping.length > 0 ){
	          config.grouping.forEach( function( group ) {
	            var col = grid.getColumn(group.colName);
	
	            if ( col ) {
	              service.groupColumn( grid, col );
	            }
	          });
	        }
	
	        if ( config.aggregations && config.aggregations.length ){
	          config.aggregations.forEach( function( aggregation ) {
	            var col = grid.getColumn(aggregation.colName);
	
	            if ( col ) {
	              service.aggregateColumn( grid, col, aggregation.aggregation.type );
	            }
	          });
	        }
	
	        if ( config.rowExpandedStates ){
	          service.applyRowExpandedStates( grid.grouping.groupingHeaderCache, config.rowExpandedStates );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name clearGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	       * as we don't know whether that sorting was added by grouping or was there beforehand
	       *
	       * @param {Grid} grid grid object
	       */
	      clearGrouping: function( grid ) {
	        var currentGrouping = service.getGrouping(grid);
	
	        if ( currentGrouping.grouping.length > 0 ){
	          currentGrouping.grouping.forEach( function( group ) {
	            if (!group.col){
	              // should have a group.colName if there's no col
	              group.col = grid.getColumn(group.colName);
	            }
	            service.ungroupColumn(grid, group.col);
	          });
	        }
	
	        if ( currentGrouping.aggregations.length > 0 ){
	          currentGrouping.aggregations.forEach( function( aggregation ){
	            if (!aggregation.col){
	              // should have a group.colName if there's no col
	              aggregation.col = grid.getColumn(aggregation.colName);
	            }
	            service.aggregateColumn(grid, aggregation.col, null);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name tidyPriorities
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Renumbers groupPriority and sortPriority such that
	       * groupPriority is contiguous, and sortPriority either matches
	       * groupPriority (for group columns), and otherwise is contiguous and
	       * higher than groupPriority.
	       *
	       * @param {Grid} grid grid object
	       */
	      tidyPriorities: function( grid ){
	        // if we're called from sortChanged, grid is in this, not passed as param, the param can be a column or undefined
	        if ( ( typeof(grid) === 'undefined' || typeof(grid.grid) !== 'undefined' ) && typeof(this.grid) !== 'undefined' ) {
	          grid = this.grid;
	        }
	
	        var groupArray = [];
	        var sortArray = [];
	
	        grid.columns.forEach( function(column, index){
	          if ( typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0){
	            groupArray.push(column);
	          } else if ( typeof(column.sort) !== 'undefined' && typeof(column.sort.priority) !== 'undefined' && column.sort.priority >= 0){
	            sortArray.push(column);
	          }
	        });
	
	        groupArray.sort(function(a, b){ return a.grouping.groupPriority - b.grouping.groupPriority; });
	        groupArray.forEach( function(column, index){
	          column.grouping.groupPriority = index;
	          column.suppressRemoveSort = true;
	          if ( typeof(column.sort) === 'undefined'){
	            column.sort = {};
	          }
	          column.sort.priority = index;
	        });
	
	        var i = groupArray.length;
	        sortArray.sort(function(a, b){ return a.sort.priority - b.sort.priority; });
	        sortArray.forEach( function(column, index){
	          column.sort.priority = i;
	          column.suppressRemoveSort = column.colDef.suppressRemoveSort;
	          i++;
	        });
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupRows
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description The rowProcessor that creates the groupHeaders (i.e. does
	       * the actual grouping).
	       *
	       * Assumes it is always called after the sorting processor, guaranteed by the priority setting
	       *
	       * Processes all the rows in order, inserting a groupHeader row whenever there is a change
	       * in value of a grouped row, based on the sortAlgorithm used for the column.  The group header row
	       * is looked up in the groupHeaderCache, and used from there if there is one. The entity is reset
	       * to {} if one is found.
	       *
	       * As it processes it maintains a `processingState` array. This records, for each level of grouping we're
	       * working with, the following information:
	       * ```
	       *   {
	       *     fieldName: name,
	       *     col: col,
	       *     initialised: boolean,
	       *     currentValue: value,
	       *     currentRow: gridRow,
	       *   }
	       * ```
	       * We look for changes in the currentValue at any of the levels.  Where we find a change we:
	       *
	       * - create a new groupHeader row in the array
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows, including our new group rows
	       */
	      groupRows: function( renderableRows ) {
	        if (renderableRows.length === 0){
	          return renderableRows;
	        }
	
	        var grid = this;
	        grid.grouping.oldGroupingHeaderCache = grid.grouping.groupingHeaderCache || {};
	        grid.grouping.groupingHeaderCache = {};
	
	        var processingState = service.initialiseProcessingState( grid );
	
	        // processes each of the fields we are grouping by, checks if the value has changed and inserts a groupHeader
	        // Broken out as shouldn't create functions in a loop.
	        var updateProcessingState = function( groupFieldState, stateIndex ) {
	          var fieldValue = grid.getCellValue(row, groupFieldState.col);
	
	          // look for change of value - and insert a header
	          if ( !groupFieldState.initialised || rowSorter.getSortFn(grid, groupFieldState.col, renderableRows)(fieldValue, groupFieldState.currentValue) !== 0 ){
	            service.insertGroupHeader( grid, renderableRows, i, processingState, stateIndex );
	            i++;
	          }
	        };
	
	        // use a for loop because it's tolerant of the array length changing whilst we go - we can
	        // manipulate the iterator when we insert groupHeader rows
	        for (var i = 0; i < renderableRows.length; i++ ){
	          var row = renderableRows[i];
	
	          if ( row.visible ){
	            processingState.forEach( updateProcessingState );
	          }
	        }
	
	        delete grid.grouping.oldGroupingHeaderCache;
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name initialiseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Creates the processing state array that is used
	       * for groupRows.
	       *
	       * @param {Grid} grid grid object
	       * @returns {array} an array in the format described in the groupRows method,
	       * initialised with blank values
	       */
	      initialiseProcessingState: function( grid ){
	        var processingState = [];
	        var columnSettings = service.getGrouping( grid );
	
	        columnSettings.grouping.forEach( function( groupItem, index){
	          processingState.push({
	            fieldName: groupItem.field,
	            col: groupItem.col,
	            initialised: false,
	            currentValue: null,
	            currentRow: null
	          });
	        });
	
	        return processingState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Get the grouping settings from the columns.  As a side effect
	       * this always renumbers the grouping starting at 0
	       * @param {Grid} grid grid object
	       * @returns {array} an array of the group fields, in order of priority
	       */
	      getGrouping: function( grid ){
	        var groupArray = [];
	        var aggregateArray = [];
	
	        // get all the grouping
	        grid.columns.forEach( function(column, columnIndex){
	          if ( column.grouping ){
	            if ( typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0){
	              groupArray.push({ field: column.field, col: column, groupPriority: column.grouping.groupPriority, grouping: column.grouping });
	            }
	          }
	          if ( column.treeAggregation && column.treeAggregation.type ){
	            aggregateArray.push({ field: column.field, col: column, aggregation: column.treeAggregation });
	          }
	        });
	
	        // sort grouping into priority order
	        groupArray.sort( function(a, b){
	          return a.groupPriority - b.groupPriority;
	        });
	
	        // renumber the priority in case it was somewhat messed up, then remove the grouping reference
	        groupArray.forEach( function( group, index) {
	          group.grouping.groupPriority = index;
	          group.groupPriority = index;
	          delete group.grouping;
	        });
	
	        return { grouping: groupArray, aggregations: aggregateArray };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name insertGroupHeader
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Create a group header row, and link it to the various configuration
	       * items that we use.
	       *
	       * Look for the row in the oldGroupingHeaderCache, write the row into the new groupingHeaderCache.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} renderableRows the rows that we are processing
	       * @param {number} rowIndex the row we were up to processing
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header -
	       * i.e. the column that we want to create a header for
	       */
	      insertGroupHeader: function( grid, renderableRows, rowIndex, processingState, stateIndex ) {
	        // set the value that caused the end of a group into the header row and the processing state
	        var fieldName = processingState[stateIndex].fieldName;
	        var col = processingState[stateIndex].col;
	
	        var newValue = grid.getCellValue(renderableRows[rowIndex], col);
	        var newDisplayValue = newValue;
	        if ( typeof(newValue) === 'undefined' || newValue === null ) {
	          newDisplayValue = grid.options.groupingNullLabel;
	        }
	
	        var cacheItem = grid.grouping.oldGroupingHeaderCache;
	        for ( var i = 0; i < stateIndex; i++ ){
	          if ( cacheItem && cacheItem[processingState[i].currentValue] ){
	            cacheItem = cacheItem[processingState[i].currentValue].children;
	          }
	        }
	
	        var headerRow;
	        if ( cacheItem && cacheItem[newValue]){
	          headerRow = cacheItem[newValue].row;
	          headerRow.entity = {};
	        } else {
	          headerRow = new GridRow( {}, null, grid );
	          gridClassFactory.rowTemplateAssigner.call(grid, headerRow);
	        }
	
	        headerRow.entity['$$' + processingState[stateIndex].col.uid] = { groupVal: newDisplayValue };
	        headerRow.treeLevel = stateIndex;
	        headerRow.groupHeader = true;
	        headerRow.internalRow = true;
	        headerRow.enableCellEdit = false;
	        headerRow.enableSelection = grid.options.enableGroupHeaderSelection;
	        processingState[stateIndex].initialised = true;
	        processingState[stateIndex].currentValue = newValue;
	        processingState[stateIndex].currentRow = headerRow;
	
	        // set all processing states below this one to not be initialised - change of this state
	        // means all those need to start again
	        service.finaliseProcessingState( processingState, stateIndex + 1);
	
	        // insert our new header row
	        renderableRows.splice(rowIndex, 0, headerRow);
	
	        // add our new header row to the cache
	        cacheItem = grid.grouping.groupingHeaderCache;
	        for ( i = 0; i < stateIndex; i++ ){
	          cacheItem = cacheItem[processingState[i].currentValue].children;
	        }
	        cacheItem[newValue] = { row: headerRow, children: {} };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name finaliseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set all processing states lower than the one that had a break in value to
	       * no longer be initialised.  Render the counts into the entity ready for display.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header, all
	       * processing states after this need to be finalised
	       */
	      finaliseProcessingState: function( processingState, stateIndex ){
	        for ( var i = stateIndex; i < processingState.length; i++){
	          processingState[i].initialised = false;
	          processingState[i].currentRow = null;
	          processingState[i].currentValue = null;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Extract the groupHeaderCache hash, pulling out only the states.
	       *
	       * The example below shows a grid that is grouped by gender then age
	       *
	       * <pre>
	       *   {
	       *     male: {
	       *       state: 'expanded',
	       *       children: {
	       *         22: { state: 'expanded' },
	       *         30: { state: 'collapsed' }
	       *       }
	       *     },
	       *     female: {
	       *       state: 'expanded',
	       *       children: {
	       *         28: { state: 'expanded' },
	       *         55: { state: 'collapsed' }
	       *       }
	       *     }
	       *   }
	       * </pre>
	       *
	       * @param {Grid} grid grid object
	       * @returns {hash} the expanded states as a hash
	       */
	      getRowExpandedStates: function(treeChildren){
	        if ( typeof(treeChildren) === 'undefined' ){
	          return {};
	        }
	
	        var newChildren = {};
	
	        angular.forEach( treeChildren, function( value, key ){
	          newChildren[key] = { state: value.row.treeNode.state };
	          if ( value.children ){
	            newChildren[key].children = service.getRowExpandedStates( value.children );
	          } else {
	            newChildren[key].children = {};
	          }
	        });
	
	        return newChildren;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name applyRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Take a hash in the format as created by getRowExpandedStates,
	       * and apply it to the grid.grouping.groupHeaderCache.
	       *
	       * Takes a treeSubset, and applies to a treeSubset - so can be called
	       * recursively.
	       *
	       * @param {object} currentNode can be grid.grouping.groupHeaderCache, or any of
	       * the children of that hash
	       * @returns {hash} expandedStates can be the full expanded states, or children
	       * of that expanded states (which hopefully matches the subset of the groupHeaderCache)
	       */
	      applyRowExpandedStates: function( currentNode, expandedStates ){
	        if ( typeof(expandedStates) === 'undefined' ){
	          return;
	        }
	
	        angular.forEach(expandedStates, function( value, key ) {
	          if ( currentNode[key] ){
	            currentNode[key].row.treeNode.state = value.state;
	
	            if (value.children && currentNode[key].children){
	              service.applyRowExpandedStates( currentNode[key].children, value.children );
	            }
	          }
	        });
	      }
	
	
	    };
	
	    return service;
	
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.grouping.directive:uiGridGrouping
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds grouping features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.grouping']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-grouping></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridGrouping', ['uiGridGroupingConstants', 'uiGridGroupingService', '$templateCache',
	  function (uiGridGroupingConstants, uiGridGroupingService, $templateCache) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableGrouping !== false){
	              uiGridGroupingService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.importer
	   * @description
	   *
	   * # ui.grid.importer
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to import data into the grid. It
	   * uses the column defs to work out which data belongs in which column,
	   * and creates entities from a configured class (typically a $resource).
	   *
	   * If the rowEdit feature is enabled, it also calls save on those newly
	   * created objects, and then displays any errors in the imported data.
	   *
	   * Currently the importer imports only CSV and json files, although provision has been
	   * made to process other file formats, and these can be added over time.
	   *
	   * For json files, the properties within each object in the json must match the column names
	   * (to put it another way, the importer doesn't process the json, it just copies the objects
	   * within the json into a new instance of the specified object type)
	   *
	   * For CSV import, the default column identification relies on each column in the
	   * header row matching a column.name or column.displayName. Optionally, a column identification
	   * callback can be used.  This allows matching using other attributes, which is particularly
	   * useful if your application has internationalised column headings (i.e. the headings that
	   * the user sees don't match the column names).
	   *
	   * The importer makes use of the grid menu as the UI for requesting an
	   * import.
	   *
	   * <div ui-grid-importer></div>
	   */
	
	  var module = angular.module('ui.grid.importer', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.importer.constant:uiGridImporterConstants
	   *
	   *  @description constants available in importer module
	   */
	
	  module.constant('uiGridImporterConstants', {
	    featureName: 'importer'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.importer.service:uiGridImporterService
	   *
	   *  @description Services for importer feature
	   */
	  module.service('uiGridImporterService', ['$q', 'uiGridConstants', 'uiGridImporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService', '$window',
	    function ($q, uiGridConstants, uiGridImporterConstants, gridUtil, $compile, $interval, i18nService, $window) {
	
	      var service = {
	
	        initializeGrid: function ($scope, grid) {
	
	          //add feature namespace and any properties to grid for needed state
	          grid.importer = {
	            $scope: $scope
	          };
	
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.importer.api:PublicApi
	           *
	           *  @description Public Api for importer feature
	           */
	          var publicApi = {
	            events: {
	              importer: {
	              }
	            },
	            methods: {
	              importer: {
	                /**
	                 * @ngdoc function
	                 * @name importFile
	                 * @methodOf  ui.grid.importer.api:PublicApi
	                 * @description Imports a file into the grid using the file object
	                 * provided.  Bypasses the grid menu
	                 * @param {File} fileObject the file we want to import, as a javascript
	                 * File object
	                 */
	                importFile: function ( fileObject ) {
	                  service.importThisFile( grid, fileObject );
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if ( grid.options.enableImporter && grid.options.importerShowMenu ){
	            if ( grid.api.core.addToGridMenu ){
	              service.addToMenu( grid );
	            } else {
	              // order of registration is not guaranteed, register in a little while
	              $interval( function() {
	                if (grid.api.core.addToGridMenu){
	                  service.addToMenu( grid );
	                }
	              }, 100, 1);
	            }
	          }
	        },
	
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.importer.api:GridOptions
	           *
	           * @description GridOptions for importer feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name enableImporter
	           * @description Whether or not importer is enabled.  Automatically set
	           * to false if the user's browser does not support the required fileApi.
	           * Otherwise defaults to true.
	           *
	           */
	          if (gridOptions.enableImporter  || gridOptions.enableImporter === undefined) {
	            if ( !($window.hasOwnProperty('File') && $window.hasOwnProperty('FileReader') && $window.hasOwnProperty('FileList') && $window.hasOwnProperty('Blob')) ) {
	              gridUtil.logError('The File APIs are not fully supported in this browser, grid importer cannot be used.');
	              gridOptions.enableImporter = false;
	            } else {
	              gridOptions.enableImporter = true;
	            }
	          } else {
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerProcessHeaders
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will process headers using custom
	           * logic.  Set this callback function if the headers that your user will provide in their
	           * import file don't necessarily match the grid header or field names.  This might commonly
	           * occur where your application is internationalised, and therefore the field names
	           * that the user recognises are in a different language than the field names that
	           * ui-grid knows about.
	           *
	           * Defaults to the internal `processHeaders` method, which seeks to match using both
	           * displayName and column.name.  Any non-matching columns are discarded.
	           *
	           * Your callback routine should respond by processing the header array, and returning an array
	           * of matching column names.  A null value in any given position means "don't import this column"
	           *
	           * <pre>
	           *      gridOptions.importerProcessHeaders: function( headerArray ) {
	           *        var myHeaderColumns = [];
	           *        var thisCol;
	           *        headerArray.forEach( function( value, index ) {
	           *          thisCol = mySpecialLookupFunction( value );
	           *          myHeaderColumns.push( thisCol.name );
	           *        });
	           *
	           *        return myHeaderCols;
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into
	           * @param {array} headerArray an array of the text from the first row of the csv file,
	           * which you need to match to column.names
	           * @returns {array} array of matching column names, in the same order as the headerArray
	           *
	           */
	          gridOptions.importerProcessHeaders = gridOptions.importerProcessHeaders || service.processHeaders;
	
	          /**
	           * @ngdoc method
	           * @name importerHeaderFilter
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will filter (usually translate) a single
	           * header.  Used when you want to match the passed in column names to the column
	           * displayName after the header filter.
	           *
	           * Your callback routine needs to return the filtered header value.
	           * <pre>
	           *      gridOptions.importerHeaderFilter: function( displayName ) {
	           *        return $translate.instant( displayName );
	           *      })
	           * </pre>
	           *
	           * or:
	           * <pre>
	           *      gridOptions.importerHeaderFilter: $translate.instant
	           * </pre>
	           * @param {string} displayName the displayName that we'd like to translate
	           * @returns {string} the translated name
	           *
	           */
	          gridOptions.importerHeaderFilter = gridOptions.importerHeaderFilter || function( displayName ) { return displayName; };
	
	          /**
	           * @ngdoc method
	           * @name importerErrorCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that provides custom error handling, rather
	           * than the standard grid behaviour of an alert box and a console message.  You
	           * might use this to internationalise the console log messages, or to write to a
	           * custom logging routine that returned errors to the server.
	           *
	           * <pre>
	           *      gridOptions.importerErrorCallback: function( grid, errorKey, consoleMessage, context ) {
	           *        myUserDisplayRoutine( errorKey );
	           *        myLoggingRoutine( consoleMessage, context );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful if you're positioning messages
	           * in some way
	           * @param {string} errorKey one of the i18n keys the importer can return - importer.noHeaders,
	           * importer.noObjects, importer.invalidCsv, importer.invalidJson, importer.jsonNotArray
	           * @param {string} consoleMessage the English console message that importer would have written
	           * @param {object} context the context data that importer would have appended to that console message,
	           * often the file content itself or the element that is in error
	           *
	           */
	          if ( !gridOptions.importerErrorCallback ||  typeof(gridOptions.importerErrorCallback) !== 'function' ){
	            delete gridOptions.importerErrorCallback;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerDataAddCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A mandatory callback function that adds data to the source data array.  The grid
	           * generally doesn't add rows to the source data array, it is tidier to handle this through a user
	           * callback.
	           *
	           * <pre>
	           *      gridOptions.importerDataAddCallback: function( grid, newObjects ) {
	           *        $scope.myData = $scope.myData.concat( newObjects );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful in some way
	           * @param {array} newObjects an array of new objects that you should add to your data
	           *
	           */
	          if ( gridOptions.enableImporter === true && !gridOptions.importerDataAddCallback ) {
	            gridUtil.logError("You have not set an importerDataAddCallback, importer is disabled");
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc object
	           * @name importerNewObject
	           * @propertyOf  ui.grid.importer.api:GridOptions
	           * @description An object on which we call `new` to create each new row before inserting it into
	           * the data array.  Typically this would be a $resource entity, which means that if you're using
	           * the rowEdit feature, you can directly call save on this entity when the save event is triggered.
	           *
	           * Defaults to a vanilla javascript object
	           *
	           * @example
	           * <pre>
	           *   gridOptions.importerNewObject = MyRes;
	           * </pre>
	           *
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name importerShowMenu
	           * @description Whether or not to show an item in the grid menu.  Defaults to true.
	           *
	           */
	          gridOptions.importerShowMenu = gridOptions.importerShowMenu !== false;
	
	          /**
	           * @ngdoc method
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @name importerObjectCallback
	           * @description A callback that massages the data for each object.  For example,
	           * you might have data stored as a code value, but display the decode.  This callback
	           * can be used to change the decoded value back into a code.  Defaults to doing nothing.
	           * @param {Grid} grid in case you need it
	           * @param {object} newObject the new object as importer has created it, modify it
	           * then return the modified version
	           * @returns {object} the modified object
	           * @example
	           * <pre>
	           *   gridOptions.importerObjectCallback = function ( grid, newObject ) {
	           *     switch newObject.status {
	           *       case 'Active':
	           *         newObject.status = 1;
	           *         break;
	           *       case 'Inactive':
	           *         newObject.status = 2;
	           *         break;
	           *     }
	           *     return newObject;
	           *   };
	           * </pre>
	           */
	          gridOptions.importerObjectCallback = gridOptions.importerObjectCallback || function( grid, newObject ) { return newObject; };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.importer.service:uiGridImporterService
	         * @description Adds import menu item to the grid menu,
	         * allowing the user to request import of a file
	         * @param {Grid} grid the grid into which data should be imported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.importerTitle'),
	              order: 150
	            },
	            {
	              templateUrl: 'ui-grid/importerMenuItemContainer',
	              action: function ($event) {
	                this.grid.api.importer.importAFile( grid );
	              },
	              order: 151
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importThisFile
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Imports the provided file into the grid using the file object
	         * provided.  Bypasses the grid menu
	         * @param {Grid} grid the grid we're importing into
	         * @param {File} fileObject the file we want to import, as returned from the File
	         * javascript object
	         */
	        importThisFile: function ( grid, fileObject ) {
	          if (!fileObject){
	            gridUtil.logError( 'No file object provided to importThisFile, should be impossible, aborting');
	            return;
	          }
	
	          var reader = new FileReader();
	
	          switch ( fileObject.type ){
	            case 'application/json':
	              reader.onload = service.importJsonClosure( grid );
	              break;
	            default:
	              reader.onload = service.importCsvClosure( grid );
	              break;
	          }
	
	          reader.readAsText( fileObject );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a json file into the grid.
	         * The json data is imported into new objects of type `gridOptions.importerNewObject`,
	         * and if the rowEdit feature is enabled the rows are marked as dirty
	         * @param {Grid} grid the grid we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a FileObject
	         */
	        importJsonClosure: function( grid ) {
	          return function( importFile ){
	            var newObjects = [];
	            var newObject;
	
	            var importArray = service.parseJson( grid, importFile );
	            if (importArray === null){
	              return;
	            }
	            importArray.forEach(  function( value, index ) {
	              newObject = service.newObject( grid );
	              angular.extend( newObject, value );
	              newObject = grid.options.importerObjectCallback( grid, newObject );
	              newObjects.push( newObject );
	            });
	
	            service.addObjects( grid, newObjects );
	
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a json file, returns the parsed data.
	         * Displays an error if file doesn't parse
	         * @param {Grid} grid the grid that we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a FileObject
	         * @returns {array} array of objects from the imported json
	         */
	        parseJson: function( grid, importFile ){
	          var loadedObjects;
	          try {
	            loadedObjects = JSON.parse( importFile.target.result );
	          } catch (e) {
	            service.alertError( grid, 'importer.invalidJson', 'File could not be processed, is it valid json? Content was: ', importFile.target.result );
	            return;
	          }
	
	          if ( !Array.isArray( loadedObjects ) ){
	            service.alertError( grid, 'importer.jsonNotarray', 'Import failed, file is not an array, file was: ', importFile.target.result );
	            return [];
	          } else {
	            return loadedObjects;
	          }
	        },
	
	
	
	        /**
	         * @ngdoc function
	         * @name importCsvClosure
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a csv file into the grid
	         * (allowing it to be used in the reader.onload event)
	         * @param {Grid} grid the grid that we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a file object
	         */
	        importCsvClosure: function( grid ) {
	          return function( importFile ){
	            var importArray = service.parseCsv( importFile );
	            if ( !importArray || importArray.length < 1 ){
	              service.alertError( grid, 'importer.invalidCsv', 'File could not be processed, is it valid csv? Content was: ', importFile.target.result );
	              return;
	            }
	
	            var newObjects = service.createCsvObjects( grid, importArray );
	            if ( !newObjects || newObjects.length === 0 ){
	              service.alertError( grid, 'importer.noObjects', 'Objects were not able to be derived, content was: ', importFile.target.result );
	              return;
	            }
	
	            service.addObjects( grid, newObjects );
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseCsv
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a csv file into an array of arrays, with the first
	         * array being the headers, and the remaining arrays being the data.
	         * The logic for this comes from https://github.com/thetalecrafter/excel.js/blob/master/src/csv.js,
	         * which is noted as being under the MIT license.  The code is modified to pass the jscs yoda condition
	         * checker
	         * @param {FileObject} importFile the file that we want to import, as a
	         * file object
	         */
	        parseCsv: function( importFile ) {
	          var csv = importFile.target.result;
	
	          // use the CSV-JS library to parse
	          return CSV.parse(csv);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name createCsvObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Converts an array of arrays (representing the csv file)
	         * into a set of objects.  Uses the provided `gridOptions.importerNewObject`
	         * to create the objects, and maps the header row into the individual columns
	         * using either `gridOptions.importerProcessHeaders`, or by using a native method
	         * of matching to either the displayName, column name or column field of
	         * the columns in the column defs.  The resulting objects will have attributes
	         * that are named based on the column.field or column.name, in that order.
	         * @param {Grid} grid the grid that we want to import into
	         * @param {Array} importArray the data that we want to import, as an array
	         */
	        createCsvObjects: function( grid, importArray ){
	          // pull off header row and turn into headers
	          var headerMapping = grid.options.importerProcessHeaders( grid, importArray.shift() );
	          if ( !headerMapping || headerMapping.length === 0 ){
	            service.alertError( grid, 'importer.noHeaders', 'Column names could not be derived, content was: ', importArray );
	            return [];
	          }
	
	          var newObjects = [];
	          var newObject;
	          importArray.forEach( function( row, index ) {
	            newObject = service.newObject( grid );
	            if ( row !== null ){
	              row.forEach( function( field, index ){
	                if ( headerMapping[index] !== null ){
	                  newObject[ headerMapping[index] ] = field;
	                }
	              });
	            }
	            newObject = grid.options.importerObjectCallback( grid, newObject );
	            newObjects.push( newObject );
	          });
	
	          return newObjects;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name processHeaders
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Determines the columns that the header row from
	         * a csv (or other) file represents.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         * @returns {array} an array of the attribute names that should be used
	         * for that column, based on matching the headers or creating the headers
	         *
	         */
	        processHeaders: function( grid, headerRow ) {
	          var headers = [];
	          if ( !grid.options.columnDefs || grid.options.columnDefs.length === 0 ){
	            // we are going to create new columnDefs for all these columns, so just remove
	            // spaces from the names to create fields
	            headerRow.forEach( function( value, index ) {
	              headers.push( value.replace( /[^0-9a-zA-Z\-_]/g, '_' ) );
	            });
	            return headers;
	          } else {
	            var lookupHash = service.flattenColumnDefs( grid, grid.options.columnDefs );
	            headerRow.forEach(  function( value, index ) {
	              if ( lookupHash[value] ) {
	                headers.push( lookupHash[value] );
	              } else if ( lookupHash[ value.toLowerCase() ] ) {
	                headers.push( lookupHash[ value.toLowerCase() ] );
	              } else {
	                headers.push( null );
	              }
	            });
	            return headers;
	          }
	        },
	
	
	        /**
	         * @name flattenColumnDefs
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Runs through the column defs and creates a hash of
	         * the displayName, name and field, and of each of those values forced to lower case,
	         * with each pointing to the field or name
	         * (whichever is present).  Used to lookup column headers and decide what
	         * attribute name to give to the resulting field.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} columnDefs the columnDefs that we should flatten
	         * @returns {hash} the flattened version of the column def information, allowing
	         * us to look up a value by `flattenedHash[ headerValue ]`
	         */
	        flattenColumnDefs: function( grid, columnDefs ){
	          var flattenedHash = {};
	          columnDefs.forEach(  function( columnDef, index) {
	            if ( columnDef.name ){
	              flattenedHash[ columnDef.name ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.name.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.field ){
	              flattenedHash[ columnDef.field ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.field.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName ){
	              flattenedHash[ columnDef.displayName ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.displayName.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName && grid.options.importerHeaderFilter ){
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName) ] = columnDef.field || columnDef.name;
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName).toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	          });
	
	          return flattenedHash;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Inserts our new objects into the grid data, and
	         * sets the rows to dirty if the rowEdit feature is being used
	         *
	         * Does this by registering a watch on dataChanges, which essentially
	         * is waiting on the result of the grid data watch, and downstream processing.
	         *
	         * When the callback is called, it deregisters itself - we don't want to run
	         * again next time data is added.
	         *
	         * If we never get called, we deregister on destroy.
	         *
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} newObjects the objects we want to insert into the grid data
	         * @returns {object} the new object
	         */
	        addObjects: function( grid, newObjects, $scope ){
	          if ( grid.api.rowEdit ){
	            var dataChangeDereg = grid.registerDataChangeCallback( function() {
	              grid.api.rowEdit.setRowsDirty( newObjects );
	              dataChangeDereg();
	            }, [uiGridConstants.dataChange.ROW] );
	
	            grid.importer.$scope.$on( '$destroy', dataChangeDereg );
	          }
	
	          grid.importer.$scope.$apply( grid.options.importerDataAddCallback( grid, newObjects ) );
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name newObject
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Makes a new object based on `gridOptions.importerNewObject`,
	         * or based on an empty object if not present
	         * @param {Grid} grid the grid we're importing into
	         * @returns {object} the new object
	         */
	        newObject: function( grid ){
	          if ( typeof(grid.options) !== "undefined" && typeof(grid.options.importerNewObject) !== "undefined" ){
	            return new grid.options.importerNewObject();
	          } else {
	            return {};
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name alertError
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Provides an internationalised user alert for the failure,
	         * and logs a console message including diagnostic content.
	         * Optionally, if the the `gridOptions.importerErrorCallback` routine
	         * is defined, then calls that instead, allowing user specified error routines
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         */
	        alertError: function( grid, alertI18nToken, consoleMessage, context ){
	          if ( grid.options.importerErrorCallback ){
	            grid.options.importerErrorCallback( grid, alertI18nToken, consoleMessage, context );
	          } else {
	            $window.alert(i18nService.getSafeText( alertI18nToken ));
	            gridUtil.logError(consoleMessage + context );
	          }
	        }
	      };
	
	      return service;
	
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds importer features to grid
	   *
	   */
	  module.directive('uiGridImporter', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridImporterService.initializeGrid($scope, uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporterMenuItem
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Handles the processing from the importer menu item - once a file is
	   *  selected
	   *
	   */
	  module.directive('uiGridImporterMenuItem', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        templateUrl: 'ui-grid/importerMenuItem',
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var handleFileSelect = function( event ){
	            var target = event.srcElement || event.target;
	
	            if (target && target.files && target.files.length === 1) {
	              var fileObject = target.files[0];
	              uiGridImporterService.importThisFile( grid, fileObject );
	              target.form.reset();
	            }
	          };
	
	          var fileChooser = $elm[0].querySelectorAll('.ui-grid-importer-file-chooser');
	          var grid = uiGridCtrl.grid;
	
	          if ( fileChooser.length !== 1 ){
	            gridUtil.logError('Found > 1 or < 1 file choosers within the menu item, error, cannot continue');
	          } else {
	            fileChooser[0].addEventListener('change', handleFileSelect, false);  // TODO: why the false on the end?  Google
	          }
	        }
	      };
	    }
	  ]);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.infiniteScroll
	   *
	   *  @description
	   *
	   * #ui.grid.infiniteScroll
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides infinite scroll functionality to ui-grid
	   *
	   */
	  var module = angular.module('ui.grid.infiniteScroll', ['ui.grid']);
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	   *
	   *  @description Service for infinite scroll features
	   */
	  module.service('uiGridInfiniteScrollService', ['gridUtil', '$compile', '$timeout', 'uiGridConstants', 'ScrollEvent', '$q', function (gridUtil, $compile, $timeout, uiGridConstants, ScrollEvent, $q) {
	
	    var service = {
	
	      /**
	       * @ngdoc function
	       * @name initializeGrid
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This method register events and methods into grid public API
	       */
	
	      initializeGrid: function(grid, $scope) {
	        service.defaultGridOptions(grid.options);
	
	        if (!grid.options.enableInfiniteScroll){
	          return;
	        }
	
	        grid.infiniteScroll = { dataLoading: false };
	        service.setScrollDirections( grid, grid.options.infiniteScrollUp, grid.options.infiniteScrollDown );
	          grid.api.core.on.scrollEnd($scope, service.handleScroll);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:PublicAPI
	         *
	         *  @description Public API for infinite scroll feature
	         */
	        var publicApi = {
	          events: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreData
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches bottom percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreData: function ($scope, fn) {
	              },
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreDataTop
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches top percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreDataTop: function ($scope, fn) {
	              }
	            }
	          },
	          methods: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc function
	               * @name dataLoaded
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have loaded the additional data
	               * requested.  You should set scrollUp and scrollDown to indicate
	               * whether there are still more pages in each direction.
	               *
	               * If you call dataLoaded without first calling `saveScrollPercentage` then we will
	               * scroll the user to the start of the newly loaded data, which usually gives a smooth scroll
	               * experience, but can give a jumpy experience with large `infiniteScrollRowsFromEnd` values, and
	               * on variable speed internet connections.  Using `saveScrollPercentage` as demonstrated in the tutorial
	               * should give a smoother scrolling experience for users.
	               *
	               * See infinite_scroll tutorial for example of usage
	               * @param {boolean} scrollUp if set to false flags that there are no more pages upwards, so don't fire
	               * any more infinite scroll events upward
	               * @param {boolean} scrollDown if set to false flags that there are no more pages downwards, so don't
	               * fire any more infinite scroll events downward
	               * @returns {promise} a promise that is resolved when the grid scrolling is fully adjusted.  If you're
	               * planning to remove pages, you should wait on this promise first, or you'll break the scroll positioning
	               */
	              dataLoaded: function( scrollUp, scrollDown ) {
	                service.setScrollDirections(grid, scrollUp, scrollDown);
	
	                var promise = service.adjustScroll(grid).then(function() {
	                  grid.infiniteScroll.dataLoading = false;
	                });
	
	                return promise;
	              },
	
	              /**
	               * @ngdoc function
	               * @name resetScroll
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have taken some action that makes the current
	               * scroll position invalid.  For example, if you're using external sorting and you've resorted
	               * then you might reset the scroll, or if you've otherwise substantially changed the data, perhaps
	               * you've reused an existing grid for a new data set
	               *
	               * You must tell us whether there is data upwards or downwards after the reset
	               *
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               * @returns {promise} promise that is resolved when the scroll reset is complete
	               */
	              resetScroll: function( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown);
	
	                return service.adjustInfiniteScrollPosition(grid, 0);
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name saveScrollPercentage
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Saves the scroll percentage and number of visible rows before you adjust the data,
	               * used if you're subsequently going to call `dataRemovedTop` or `dataRemovedBottom`
	               */
	              saveScrollPercentage: function() {
	                grid.infiniteScroll.prevScrollTop = grid.renderContainers.body.prevScrollTop;
	                grid.infiniteScroll.previousVisibleRows = grid.getVisibleRowCount();
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedTop
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the top
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedTop: function( scrollUp, scrollDown ) {
	                service.dataRemovedTop( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedBottom
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the bottom
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedBottom: function( scrollUp, scrollDown ) {
	                service.dataRemovedBottom( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name setScrollDirections
	               * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	               * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	               * and also sets the grid.suppressParentScroll
	               * @param {boolean} scrollUp whether there are pages available up - defaults to false
	               * @param {boolean} scrollDown whether there are pages available down - defaults to true
	               */
	              setScrollDirections:  function ( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown );
	              }
	
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:GridOptions
	         *
	         *  @description GridOptions for infinite scroll feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableInfiniteScroll
	         *  @propertyOf  ui.grid.infiniteScroll.api:GridOptions
	         *  @description Enable infinite scrolling for this grid
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableInfiniteScroll = gridOptions.enableInfiniteScroll !== false;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollRowsFromEnd
	         * @propertyOf ui.grid.class:GridOptions
	         * @description This setting controls how close to the end of the dataset a user gets before
	         * more data is requested by the infinite scroll, whether scrolling up or down.  This allows you to
	         * 'prefetch' rows before the user actually runs out of scrolling.
	         *
	         * Note that if you set this value too high it may give jumpy scrolling behaviour, if you're getting
	         * this behaviour you could use the `saveScrollPercentageMethod` right before loading your data, and we'll
	         * preserve that scroll position
	         *
	         * <br> Defaults to 20
	         */
	        gridOptions.infiniteScrollRowsFromEnd = gridOptions.infiniteScrollRowsFromEnd || 20;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollUp
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll up, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreDataTop event when the user hits the top of the scrollbar.
	         * <br> Defaults to false
	         */
	        gridOptions.infiniteScrollUp = gridOptions.infiniteScrollUp === true;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollDown
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll down, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreData event when the user hits the bottom of the scrollbar.
	         * <br> Defaults to true
	         */
	        gridOptions.infiniteScrollDown = gridOptions.infiniteScrollDown !== false;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setScrollDirections
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	       * and also sets the grid.suppressParentScroll
	       * @param {grid} grid the grid we're operating on
	       * @param {boolean} scrollUp whether there are pages available up - defaults to false
	       * @param {boolean} scrollDown whether there are pages available down - defaults to true
	       */
	      setScrollDirections:  function ( grid, scrollUp, scrollDown ) {
	        grid.infiniteScroll.scrollUp = ( scrollUp === true );
	        grid.suppressParentScrollUp = ( scrollUp === true );
	
	        grid.infiniteScroll.scrollDown = ( scrollDown !== false);
	        grid.suppressParentScrollDown = ( scrollDown !== false);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name handleScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Called whenever the grid scrolls, determines whether the scroll should
	       * trigger an infinite scroll request for more data
	       * @param {object} args the args from the event
	       */
	      handleScroll:  function (args) {
	        // don't request data if already waiting for data, or if source is coming from ui.grid.adjustInfiniteScrollPosition() function
	        if ( args.grid.infiniteScroll && args.grid.infiniteScroll.dataLoading || args.source === 'ui.grid.adjustInfiniteScrollPosition' ){
	          return;
	        }
	
	        if (args.y) {
	          var percentage;
	          var targetPercentage = args.grid.options.infiniteScrollRowsFromEnd / args.grid.renderContainers.body.visibleRowCache.length;
	          if (args.grid.scrollDirection === uiGridConstants.scrollDirection.UP ) {
	            percentage = args.y.percentage;
	            if (percentage <= targetPercentage){
	              service.loadData(args.grid);
	            }
	          } else if (args.grid.scrollDirection === uiGridConstants.scrollDirection.DOWN) {
	            percentage = 1 - args.y.percentage;
	            if (percentage <= targetPercentage){
	              service.loadData(args.grid);
	            }
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name loadData
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * and whether there are more pages upwards or downwards.  It also stores the number of rows that we had previously,
	       * and clears out any saved scroll position so that we know whether or not the user calls `saveScrollPercentage`
	       * @param {Grid} grid the grid we're working on
	       */
	      loadData: function (grid) {
	        // save number of currently visible rows to calculate new scroll position later - we know that we want
	        // to be at approximately the row we're currently at
	        grid.infiniteScroll.previousVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        grid.infiniteScroll.direction = grid.scrollDirection;
	        delete grid.infiniteScroll.prevScrollTop;
	
	        if (grid.scrollDirection === uiGridConstants.scrollDirection.UP && grid.infiniteScroll.scrollUp ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreDataTop();
	        } else if (grid.scrollDirection === uiGridConstants.scrollDirection.DOWN && grid.infiniteScroll.scrollDown ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreData();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Once we are informed that data has been loaded, adjust the scroll position to account for that
	       * addition and to make things look clean.
	       *
	       * If we're scrolling up we scroll to the first row of the old data set -
	       * so we're assuming that you would have gotten to the top of the grid (from the 20% need more data trigger) by
	       * the time the data comes back.  If we're scrolling down we scoll to the last row of the old data set - so we're
	       * assuming that you would have gotten to the bottom of the grid (from the 80% need more data trigger) by the time
	       * the data comes back.
	       *
	       * Neither of these are good assumptions, but making this a smoother experience really requires
	       * that trigger to not be a percentage, and to be much closer to the end of the data (say, 5 rows off the end).  Even then
	       * it'd be better still to actually run into the end.  But if the data takes a while to come back, they may have scrolled
	       * somewhere else in the mean-time, in which case they'll get a jump back to the new data.  Anyway, this will do for
	       * now, until someone wants to do better.
	       * @param {Grid} grid the grid we're working on
	       * @returns {promise} a promise that is resolved when scrolling has finished
	       */
	      adjustScroll: function(grid){
	        var promise = $q.defer();
	        $timeout(function () {
	          var newPercentage, viewportHeight, rowHeight, newVisibleRows, oldTop, newTop;
	
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight;
	          rowHeight = grid.options.rowHeight;
	
	          if ( grid.infiniteScroll.direction === undefined ){
	            // called from initialize, tweak our scroll up a little
	            service.adjustInfiniteScrollPosition(grid, 0);
	          }
	
	          newVisibleRows = grid.getVisibleRowCount();
	
	          // in case not enough data is loaded to enable scroller - load more data
	          var canvasHeight = rowHeight * newVisibleRows;
	          if (grid.infiniteScroll.scrollDown && (viewportHeight > canvasHeight)) {
	            grid.api.infiniteScroll.raise.needLoadMoreData();
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.UP ){
	            oldTop = grid.infiniteScroll.prevScrollTop || 0;
	            newTop = oldTop + (newVisibleRows - grid.infiniteScroll.previousVisibleRows)*rowHeight;
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $timeout( function() {
	              promise.resolve();
	            });
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.DOWN ){
	            newTop = grid.infiniteScroll.prevScrollTop || (grid.infiniteScroll.previousVisibleRows*rowHeight - viewportHeight);
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $timeout( function() {
	              promise.resolve();
	            });
	          }
	        }, 0);
	
	        return promise.promise;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustInfiniteScrollPosition
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * @param {Grid} grid the grid we're working on
	       * @param {number} scrollTop the position through the grid that we want to scroll to
	       * @returns {promise} a promise that is resolved when the scrolling finishes
	       */
	      adjustInfiniteScrollPosition: function (grid, scrollTop) {
	        var scrollEvent = new ScrollEvent(grid, null, null, 'ui.grid.adjustInfiniteScrollPosition'),
	          visibleRows = grid.getVisibleRowCount(),
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight,
	          rowHeight = grid.options.rowHeight,
	          scrollHeight = visibleRows*rowHeight-viewportHeight;
	
	        //for infinite scroll, if there are pages upwards then never allow it to be at the zero position so the up button can be active
	        if (scrollTop === 0 && grid.infiniteScroll.scrollUp) {
	          // using pixels results in a relative scroll, hence we have to use percentage
	          scrollEvent.y = {percentage: 1/scrollHeight};
	        }
	        else {
	          scrollEvent.y = {percentage: scrollTop/scrollHeight};
	        }
	        grid.scrollContainers('', scrollEvent);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedTop
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the top. You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       * @returns {promise} a promise that is resolved when the scrolling finishes
	       */
	      dataRemovedTop: function( grid, scrollUp, scrollDown ) {
	        var newVisibleRows, oldTop, newTop, rowHeight;
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        oldTop = grid.infiniteScroll.prevScrollTop;
	        rowHeight = grid.options.rowHeight;
	
	        // since we removed from the top, our new scroll row will be the old scroll row less the number
	        // of rows removed
	        newTop = oldTop - ( grid.infiniteScroll.previousVisibleRows - newVisibleRows )*rowHeight;
	
	        return service.adjustInfiniteScrollPosition( grid, newTop );
	      },
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedBottom
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the bottom.  You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       */
	      dataRemovedBottom: function( grid, scrollUp, scrollDown ) {
	        var newTop;
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newTop = grid.infiniteScroll.prevScrollTop;
	
	        return service.adjustInfiniteScrollPosition( grid, newTop );
	      }
	    };
	    return service;
	  }]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.infiniteScroll.directive:uiGridInfiniteScroll
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds infinite scroll features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.infiniteScroll']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	            { name: 'Sam', car: 'Lexus' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'car'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-infinite-scroll="20"></div>
	   </div>
	   </file>
	   </example>
	   */
	
	  module.directive('uiGridInfiniteScroll', ['uiGridInfiniteScrollService',
	    function (uiGridInfiniteScrollService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: '^uiGrid',
	        compile: function($scope, $elm, $attr){
	          return {
	            pre: function($scope, $elm, $attr, uiGridCtrl) {
	              uiGridInfiniteScrollService.initializeGrid(uiGridCtrl.grid, $scope);
	            },
	            post: function($scope, $elm, $attr) {
	            }
	          };
	        }
	      };
	    }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.moveColumns
	   * @description
	   *
	   * # ui.grid.moveColumns
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides column moving capability to ui.grid. It enables to change the position of columns.
	   * <div doc-module-components="ui.grid.moveColumns"></div>
	   */
	  var module = angular.module('ui.grid.moveColumns', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.moveColumns.service:uiGridMoveColumnService
	   *  @description Service for column moving feature.
	   */
	  module.service('uiGridMoveColumnService', ['$q', '$timeout', '$log', 'ScrollEvent', 'uiGridConstants', 'gridUtil', function ($q, $timeout, $log, ScrollEvent, uiGridConstants, gridUtil) {
	
	    var service = {
	      initializeGrid: function (grid) {
	        var self = this;
	        this.registerPublicApi(grid);
	        this.defaultGridOptions(grid.options);
	        grid.moveColumns = {orderCache: []}; // Used to cache the order before columns are rebuilt
	        grid.registerColumnBuilder(self.movableColumnBuilder);
	        grid.registerDataChangeCallback(self.verifyColumnOrder, [uiGridConstants.dataChange.COLUMN]);
	      },
	      registerPublicApi: function (grid) {
	        var self = this;
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:PublicApi
	         *  @description Public Api for column moving feature.
	         */
	        var publicApi = {
	          events: {
	            /**
	             * @ngdoc event
	             * @name columnPositionChanged
	             * @eventOf  ui.grid.moveColumns.api:PublicApi
	             * @description raised when column is moved
	             * <pre>
	             *      gridApi.colMovable.on.columnPositionChanged(scope,function(colDef, originalPosition, newPosition){})
	             * </pre>
	             * @param {object} colDef the column that was moved
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              columnPositionChanged: function (colDef, originalPosition, newPosition) {
	              }
	            }
	          },
	          methods: {
	            /**
	             * @ngdoc method
	             * @name moveColumn
	             * @methodOf  ui.grid.moveColumns.api:PublicApi
	             * @description Method can be used to change column position.
	             * <pre>
	             *      gridApi.colMovable.moveColumn(oldPosition, newPosition)
	             * </pre>
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              moveColumn: function (originalPosition, finalPosition) {
	                var columns = grid.columns;
	                if (!angular.isNumber(originalPosition) || !angular.isNumber(finalPosition)) {
	                  gridUtil.logError('MoveColumn: Please provide valid values for originalPosition and finalPosition');
	                  return;
	                }
	                var nonMovableColumns = 0;
	                for (var i = 0; i < columns.length; i++) {
	                  if ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true) {
	                    nonMovableColumns++;
	                  }
	                }
	                if (originalPosition >= (columns.length - nonMovableColumns) || finalPosition >= (columns.length - nonMovableColumns)) {
	                  gridUtil.logError('MoveColumn: Invalid values for originalPosition, finalPosition');
	                  return;
	                }
	                var findPositionForRenderIndex = function (index) {
	                  var position = index;
	                  for (var i = 0; i <= position; i++) {
	                    if (angular.isDefined(columns[i]) && ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true)) {
	                      position++;
	                    }
	                  }
	                  return position;
	                };
	                self.redrawColumnAtPosition(grid, findPositionForRenderIndex(originalPosition), findPositionForRenderIndex(finalPosition));
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	      defaultGridOptions: function (gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:GridOptions
	         *
	         *  @description Options for configuring the move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:GridOptions
	         *  @description If defined, sets the default value for the colMovable flag on each individual colDefs
	         *  if their individual enableColumnMoving configuration is not defined. Defaults to true.
	         */
	        gridOptions.enableColumnMoving = gridOptions.enableColumnMoving !== false;
	      },
	      movableColumnBuilder: function (colDef, col, gridOptions) {
	        var promises = [];
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:ColumnDef
	         *
	         *  @description Column Definition for move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:ColumnDef
	         *  @description Enable column moving for the column.
	         */
	        colDef.enableColumnMoving = colDef.enableColumnMoving === undefined ? gridOptions.enableColumnMoving
	          : colDef.enableColumnMoving;
	        return $q.all(promises);
	      },
	      /**
	       * @ngdoc method
	       * @name updateColumnCache
	       * @methodOf  ui.grid.moveColumns
	       * @description Cache the current order of columns, so we can restore them after new columnDefs are defined
	       */
	      updateColumnCache: function(grid){
	        grid.moveColumns.orderCache = grid.getOnlyDataColumns();
	      },
	      /**
	       * @ngdoc method
	       * @name verifyColumnOrder
	       * @methodOf  ui.grid.moveColumns
	       * @description dataChangeCallback which uses the cached column order to restore the column order
	       * when it is reset by altering the columnDefs array.
	       */
	      verifyColumnOrder: function(grid){
	        var headerRowOffset = grid.rowHeaderColumns.length;
	        var newIndex;
	
	        angular.forEach(grid.moveColumns.orderCache, function(cacheCol, cacheIndex){
	          newIndex = grid.columns.indexOf(cacheCol);
	          if ( newIndex !== -1 && newIndex - headerRowOffset !== cacheIndex ){
	            var column = grid.columns.splice(newIndex, 1)[0];
	            grid.columns.splice(cacheIndex + headerRowOffset, 0, column);
	          }
	        });
	      },
	      redrawColumnAtPosition: function (grid, originalPosition, newPosition) {
	
	        var columns = grid.columns;
	
	        var originalColumn = columns[originalPosition];
	        if (originalColumn.colDef.enableColumnMoving) {
	          if (originalPosition > newPosition) {
	            for (var i1 = originalPosition; i1 > newPosition; i1--) {
	              columns[i1] = columns[i1 - 1];
	            }
	          }
	          else if (newPosition > originalPosition) {
	            for (var i2 = originalPosition; i2 < newPosition; i2++) {
	              columns[i2] = columns[i2 + 1];
	            }
	          }
	          columns[newPosition] = originalColumn;
	          service.updateColumnCache(grid);
	          grid.queueGridRefresh();
	          $timeout(function () {
	            grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	            grid.api.colMovable.raise.columnPositionChanged(originalColumn.colDef, originalPosition, newPosition);
	          });
	        }
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridMoveColumns
	   *  @element div
	   *  @restrict A
	   *  @description Adds column moving features to the ui-grid directive.
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.moveColumns']);
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	        $scope.data = [
	          { name: 'Bob', title: 'CEO', age: 45 },
	          { name: 'Frank', title: 'Lowly Developer', age: 25 },
	          { name: 'Jenny', title: 'Highly Developer', age: 35 }
	        ];
	        $scope.columnDefs = [
	          {name: 'name'},
	          {name: 'title'},
	          {name: 'age'}
	        ];
	      }]);
	   </file>
	   <file name="main.css">
	   .grid {
	      width: 100%;
	      height: 150px;
	    }
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div class="grid" ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-move-columns></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridMoveColumns', ['uiGridMoveColumnService', function (uiGridMoveColumnService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridMoveColumnService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridHeaderCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridHeaderCell to provide capability to be able to move it to reposition column.
	   *
	   *  On receiving mouseDown event headerCell is cloned, now as the mouse moves the cloned header cell also moved in the grid.
	   *  In case the moving cloned header cell reaches the left or right extreme of grid, grid scrolling is triggered (if horizontal scroll exists).
	   *  On mouseUp event column is repositioned at position where mouse is released and cloned header cell is removed.
	   *
	   *  Events that invoke cloning of header cell:
	   *    - mousedown
	   *
	   *  Events that invoke movement of cloned header cell:
	   *    - mousemove
	   *
	   *  Events that invoke repositioning of column:
	   *    - mouseup
	   */
	  module.directive('uiGridHeaderCell', ['$q', 'gridUtil', 'uiGridMoveColumnService', '$document', '$log', 'uiGridConstants', 'ScrollEvent',
	    function ($q, gridUtil, uiGridMoveColumnService, $document, $log, uiGridConstants, ScrollEvent) {
	      return {
	        priority: -10,
	        require: '^uiGrid',
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              if ($scope.col.colDef.enableColumnMoving) {
	
	                /*
	                 * Our general approach to column move is that we listen to a touchstart or mousedown
	                 * event over the column header.  When we hear one, then we wait for a move of the same type
	                 * - if we are a touchstart then we listen for a touchmove, if we are a mousedown we listen for
	                 * a mousemove (i.e. a drag) before we decide that there's a move underway.  If there's never a move,
	                 * and we instead get a mouseup or a touchend, then we just drop out again and do nothing.
	                 *
	                 */
	                var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	                var gridLeft;
	                var previousMouseX;
	                var totalMouseMovement;
	                var rightMoveLimit;
	                var elmCloned = false;
	                var movingElm;
	                var reducedWidth;
	                var moveOccurred = false;
	
	                var downFn = function( event ){
	                  //Setting some variables required for calculations.
	                  gridLeft = $scope.grid.element[0].getBoundingClientRect().left;
	                  if ( $scope.grid.hasLeftContainer() ){
	                    gridLeft += $scope.grid.renderContainers.left.header[0].getBoundingClientRect().width;
	                  }
	
	                  previousMouseX = event.pageX;
	                  totalMouseMovement = 0;
	                  rightMoveLimit = gridLeft + $scope.grid.getViewportWidth();
	
	                  if ( event.type === 'mousedown' ){
	                    $document.on('mousemove', moveFn);
	                    $document.on('mouseup', upFn);
	                  } else if ( event.type === 'touchstart' ){
	                    $document.on('touchmove', moveFn);
	                    $document.on('touchend', upFn);
	                  }
	                };
	
	                var moveFn = function( event ) {
	                  var changeValue = event.pageX - previousMouseX;
	                  if ( changeValue === 0 ){ return; }
	                  //Disable text selection in Chrome during column move
	                  document.onselectstart = function() { return false; };
	
	                  moveOccurred = true;
	
	                  if (!elmCloned) {
	                    cloneElement();
	                  }
	                  else if (elmCloned) {
	                    moveElement(changeValue);
	                    previousMouseX = event.pageX;
	                  }
	                };
	
	                var upFn = function( event ){
	                  //Re-enable text selection after column move
	                  document.onselectstart = null;
	
	                  //Remove the cloned element on mouse up.
	                  if (movingElm) {
	                    movingElm.remove();
	                    elmCloned = false;
	                  }
	
	                  offAllEvents();
	                  onDownEvents();
	
	                  if (!moveOccurred){
	                    return;
	                  }
	
	                  var columns = $scope.grid.columns;
	                  var columnIndex = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (columns[i].colDef.name !== $scope.col.colDef.name) {
	                      columnIndex++;
	                    }
	                    else {
	                      break;
	                    }
	                  }
	
	                  //Case where column should be moved to a position on its left
	                  if (totalMouseMovement < 0) {
	                    var totalColumnsLeftWidth = 0;
	                    for (var il = columnIndex - 1; il >= 0; il--) {
	                      if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                        totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                        if (totalColumnsLeftWidth > Math.abs(totalMouseMovement)) {
	                          uiGridMoveColumnService.redrawColumnAtPosition
	                          ($scope.grid, columnIndex, il + 1);
	                          break;
	                        }
	                      }
	                    }
	                    //Case where column should be moved to beginning of the grid.
	                    if (totalColumnsLeftWidth < Math.abs(totalMouseMovement)) {
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, 0);
	                    }
	                  }
	
	                  //Case where column should be moved to a position on its right
	                  else if (totalMouseMovement > 0) {
	                    var totalColumnsRightWidth = 0;
	                    for (var ir = columnIndex + 1; ir < columns.length; ir++) {
	                      if (angular.isUndefined(columns[ir].colDef.visible) || columns[ir].colDef.visible === true) {
	                        totalColumnsRightWidth += columns[ir].drawnWidth || columns[ir].width || columns[ir].colDef.width;
	                        if (totalColumnsRightWidth > totalMouseMovement) {
	                          uiGridMoveColumnService.redrawColumnAtPosition
	                          ($scope.grid, columnIndex, ir - 1);
	                          break;
	                        }
	                      }
	                    }
	                    //Case where column should be moved to end of the grid.
	                    if (totalColumnsRightWidth < totalMouseMovement) {
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, columns.length - 1);
	                    }
	                  }
	                };
	
	                var onDownEvents = function(){
	                  $contentsElm.on('touchstart', downFn);
	                  $contentsElm.on('mousedown', downFn);
	                };
	
	                var offAllEvents = function() {
	                  $contentsElm.off('touchstart', downFn);
	                  $contentsElm.off('mousedown', downFn);
	
	                  $document.off('mousemove', moveFn);
	                  $document.off('touchmove', moveFn);
	
	                  $document.off('mouseup', upFn);
	                  $document.off('touchend', upFn);
	                };
	
	                onDownEvents();
	
	
	                var cloneElement = function () {
	                  elmCloned = true;
	
	                  //Cloning header cell and appending to current header cell.
	                  movingElm = $elm.clone();
	                  $elm.parent().append(movingElm);
	
	                  //Left of cloned element should be aligned to original header cell.
	                  movingElm.addClass('movingColumn');
	                  var movingElementStyles = {};
	                  var elmLeft;
	                  if (gridUtil.detectBrowser() === 'safari') {
	                    //Correction for Safari getBoundingClientRect,
	                    //which does not correctly compute when there is an horizontal scroll
	                    elmLeft = $elm[0].offsetLeft + $elm[0].offsetWidth - $elm[0].getBoundingClientRect().width;
	                  }
	                  else {
	                    elmLeft = $elm[0].getBoundingClientRect().left;
	                  }
	                  movingElementStyles.left = (elmLeft - gridLeft) + 'px';
	                  var gridRight = $scope.grid.element[0].getBoundingClientRect().right;
	                  var elmRight = $elm[0].getBoundingClientRect().right;
	                  if (elmRight > gridRight) {
	                    reducedWidth = $scope.col.drawnWidth + (gridRight - elmRight);
	                    movingElementStyles.width = reducedWidth + 'px';
	                  }
	                  movingElm.css(movingElementStyles);
	                };
	
	                var moveElement = function (changeValue) {
	                  //Calculate total column width
	                  var columns = $scope.grid.columns;
	                  var totalColumnWidth = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (angular.isUndefined(columns[i].colDef.visible) || columns[i].colDef.visible === true) {
	                      totalColumnWidth += columns[i].drawnWidth || columns[i].width || columns[i].colDef.width;
	                    }
	                  }
	
	                  //Calculate new position of left of column
	                  var currentElmLeft = movingElm[0].getBoundingClientRect().left - 1;
	                  var currentElmRight = movingElm[0].getBoundingClientRect().right;
	                  var newElementLeft;
	
	                  newElementLeft = currentElmLeft - gridLeft + changeValue;
	                  newElementLeft = newElementLeft < rightMoveLimit ? newElementLeft : rightMoveLimit;
	
	                  //Update css of moving column to adjust to new left value or fire scroll in case column has reached edge of grid
	                  if ((currentElmLeft >= gridLeft || changeValue > 0) && (currentElmRight <= rightMoveLimit || changeValue < 0)) {
	                    movingElm.css({visibility: 'visible', 'left': newElementLeft + 'px'});
	                  }
	                  else if (totalColumnWidth > Math.ceil(uiGridCtrl.grid.gridWidth)) {
	                    changeValue *= 8;
	                    var scrollEvent = new ScrollEvent($scope.col.grid, null, null, 'uiGridHeaderCell.moveElement');
	                    scrollEvent.x = {pixels: changeValue};
	                    scrollEvent.grid.scrollContainers('',scrollEvent);
	                  }
	
	                  //Calculate total width of columns on the left of the moving column and the mouse movement
	                  var totalColumnsLeftWidth = 0;
	                  for (var il = 0; il < columns.length; il++) {
	                    if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                      if (columns[il].colDef.name !== $scope.col.colDef.name) {
	                        totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                      }
	                      else {
	                        break;
	                      }
	                    }
	                  }
	                  if ($scope.newScrollLeft === undefined) {
	                    totalMouseMovement += changeValue;
	                  }
	                  else {
	                    totalMouseMovement = $scope.newScrollLeft + newElementLeft - totalColumnsLeftWidth;
	                  }
	
	                  //Increase width of moving column, in case the rightmost column was moved and its width was
	                  //decreased because of overflow
	                  if (reducedWidth < $scope.col.drawnWidth) {
	                    reducedWidth += Math.abs(changeValue);
	                    movingElm.css({'width': reducedWidth + 'px'});
	                  }
	                };
	              }
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pagination
	   *
	   * @description
	   *
	   * # ui.grid.pagination
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides pagination support to ui-grid
	   */
	  var module = angular.module('ui.grid.pagination', ['ng', 'ui.grid']);
	
	  /**
	   * @ngdoc service
	   * @name ui.grid.pagination.service:uiGridPaginationService
	   *
	   * @description Service for the pagination feature
	   */
	  module.service('uiGridPaginationService', ['gridUtil',
	    function (gridUtil) {
	      var service = {
	        /**
	         * @ngdoc method
	         * @name initializeGrid
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @description Attaches the service to a certain grid
	         * @param {Grid} grid The grid we want to work with
	         */
	        initializeGrid: function (grid) {
	          service.defaultGridOptions(grid.options);
	
	          /**
	          * @ngdoc object
	          * @name ui.grid.pagination.api:PublicAPI
	          *
	          * @description Public API for the pagination feature
	          */
	          var publicApi = {
	            events: {
	              pagination: {
	              /**
	               * @ngdoc event
	               * @name paginationChanged
	               * @eventOf ui.grid.pagination.api:PublicAPI
	               * @description This event fires when the pageSize or currentPage changes
	               * @param {int} currentPage requested page number
	               * @param {int} pageSize requested page size
	               */
	                paginationChanged: function (currentPage, pageSize) { }
	              }
	            },
	            methods: {
	              pagination: {
	                /**
	                 * @ngdoc method
	                 * @name getPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the number of the current page
	                 */
	                getPage: function () {
	                  return grid.options.enablePagination ? grid.options.paginationCurrentPage : null;
	                },
	                /**
	                 * @ngdoc method
	                 * @name getTotalPages
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the total number of pages
	                 */
	                getTotalPages: function () {
	                  if (!grid.options.enablePagination) {
	                    return null;
	                  }
	
	                  return (grid.options.totalItems === 0) ? 1 : Math.ceil(grid.options.totalItems / grid.options.paginationPageSize);
	                },
	                /**
	                 * @ngdoc method
	                 * @name nextPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the next page, if possible
	                 */
	                nextPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  if (grid.options.totalItems > 0) {
	                    grid.options.paginationCurrentPage = Math.min(
	                      grid.options.paginationCurrentPage + 1,
	                      publicApi.methods.pagination.getTotalPages()
	                    );
	                  } else {
	                    grid.options.paginationCurrentPage++;
	                  }
	                },
	                /**
	                 * @ngdoc method
	                 * @name previousPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the previous page, if we're not on the first page
	                 */
	                previousPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.max(grid.options.paginationCurrentPage - 1, 1);
	                },
	                /**
	                 * @ngdoc method
	                 * @name seek
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the requested page
	                 * @param {int} page The number of the page that should be displayed
	                 */
	                seek: function (page) {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	                  if (!angular.isNumber(page) || page < 1) {
	                    throw 'Invalid page number: ' + page;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.min(page, publicApi.methods.pagination.getTotalPages());
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          var processPagination = function( renderableRows ){
	            if (grid.options.useExternalPagination || !grid.options.enablePagination) {
	              return renderableRows;
	            }
	            //client side pagination
	            var pageSize = parseInt(grid.options.paginationPageSize, 10);
	            var currentPage = parseInt(grid.options.paginationCurrentPage, 10);
	
	            var visibleRows = renderableRows.filter(function (row) { return row.visible; });
	            grid.options.totalItems = visibleRows.length;
	
	            var firstRow = (currentPage - 1) * pageSize;
	            if (firstRow > visibleRows.length) {
	              currentPage = grid.options.paginationCurrentPage = 1;
	              firstRow = (currentPage - 1) * pageSize;
	            }
	            return visibleRows.slice(firstRow, firstRow + pageSize);
	          };
	
	          grid.registerRowsProcessor(processPagination, 900 );
	
	        },
	        defaultGridOptions: function (gridOptions) {
	          /**
	           * @ngdoc object
	           * @name ui.grid.pagination.api:GridOptions
	           *
	           * @description GridOptions for the pagination feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @name enablePagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables pagination, defaults to true
	           */
	          gridOptions.enablePagination = gridOptions.enablePagination !== false;
	          /**
	           * @ngdoc property
	           * @name enablePaginationControls
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables the paginator at the bottom of the grid. Turn this off, if you want to implement your
	           *              own controls outside the grid.
	           */
	          gridOptions.enablePaginationControls = gridOptions.enablePaginationControls !== false;
	          /**
	           * @ngdoc property
	           * @name useExternalPagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Disables client side pagination. When true, handle the paginationChanged event and set data
	           *              and totalItems, defaults to `false`
	           */
	          gridOptions.useExternalPagination = gridOptions.useExternalPagination === true;
	          /**
	           * @ngdoc property
	           * @name totalItems
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Total number of items, set automatically when client side pagination, needs set by user
	           *              for server side pagination
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.totalItems)) {
	            gridOptions.totalItems = 0;
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSizes
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Array of page sizes, defaults to `[250, 500, 1000]`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSizes)) {
	            gridOptions.paginationPageSizes = [250, 500, 1000];
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSize
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Page size, defaults to the first item in paginationPageSizes, or 0 if paginationPageSizes is empty
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSize)) {
	            if (gridOptions.paginationPageSizes.length > 0) {
	              gridOptions.paginationPageSize = gridOptions.paginationPageSizes[0];
	            } else {
	              gridOptions.paginationPageSize = 0;
	            }
	          }
	          /**
	           * @ngdoc property
	           * @name paginationCurrentPage
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Current page number, defaults to 1
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationCurrentPage)) {
	            gridOptions.paginationCurrentPage = 1;
	          }
	
	          /**
	           * @ngdoc property
	           * @name paginationTemplate
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description A custom template for the pager, defaults to `ui-grid/pagination`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationTemplate)) {
	            gridOptions.paginationTemplate = 'ui-grid/pagination';
	          }
	        },
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @name uiGridPaginationService
	         * @description  Raises paginationChanged and calls refresh for client side pagination
	         * @param {Grid} grid the grid for which the pagination changed
	         * @param {int} currentPage requested page number
	         * @param {int} pageSize requested page size
	         */
	        onPaginationChanged: function (grid, currentPage, pageSize) {
	            grid.api.pagination.raise.paginationChanged(currentPage, pageSize);
	            if (!grid.options.useExternalPagination) {
	              grid.queueGridRefresh(); //client side pagination
	            }
	        }
	      };
	
	      return service;
	    }
	  ]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPagination
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds pagination features to grid
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.pagination']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	        { name: 'Sam', car: 'Lexus' },
	        { name: 'Joe', car: 'Dodge' },
	        { name: 'Bob', car: 'Buick' },
	        { name: 'Cindy', car: 'Ford' },
	        { name: 'Brian', car: 'Audi' },
	        { name: 'Malcom', car: 'Mercedes Benz' },
	        { name: 'Dave', car: 'Ford' },
	        { name: 'Stacey', car: 'Audi' },
	        { name: 'Amy', car: 'Acura' },
	        { name: 'Scott', car: 'Toyota' },
	        { name: 'Ryan', car: 'BMW' },
	      ];
	
	      $scope.gridOptions = {
	        data: 'data',
	        paginationPageSizes: [5, 10, 25],
	        paginationPageSize: 5,
	        columnDefs: [
	          {name: 'name'},
	          {name: 'car'}
	        ]
	       }
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-pagination></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridPagination', ['gridUtil', 'uiGridPaginationService',
	    function (gridUtil, uiGridPaginationService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: 'uiGrid',
	        link: {
	          pre: function ($scope, $elm, $attr, uiGridCtrl) {
	            uiGridPaginationService.initializeGrid(uiGridCtrl.grid);
	
	            gridUtil.getTemplate(uiGridCtrl.grid.options.paginationTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	                $elm.append(template);
	                uiGridCtrl.innerCompile(template);
	              });
	          }
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPager
	   *  @element div
	   *
	   *  @description Panel for handling pagination
	   */
	  module.directive('uiGridPager', ['uiGridPaginationService', 'uiGridConstants', 'gridUtil', 'i18nService',
	    function (uiGridPaginationService, uiGridConstants, gridUtil, i18nService) {
	      return {
	        priority: -200,
	        scope: true,
	        require: '^uiGrid',
	        link: function ($scope, $elm, $attr, uiGridCtrl) {
	          var defaultFocusElementSelector = '.ui-grid-pager-control-input';
	          $scope.aria = i18nService.getSafeText('pagination.aria'); //Returns an object with all of the aria labels
	
	          $scope.paginationApi = uiGridCtrl.grid.api.pagination;
	          $scope.sizesLabel = i18nService.getSafeText('pagination.sizes');
	          $scope.totalItemsLabel = i18nService.getSafeText('pagination.totalItems');
	          $scope.paginationOf = i18nService.getSafeText('pagination.of');
	          $scope.paginationThrough = i18nService.getSafeText('pagination.through');
	
	          var options = uiGridCtrl.grid.options;
	
	          uiGridCtrl.grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	            adjustment.height = adjustment.height - gridUtil.elementHeight($elm);
	            return adjustment;
	          });
	
	          var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(function (grid) {
	            if (!grid.options.useExternalPagination) {
	              grid.options.totalItems = grid.rows.length;
	            }
	          }, [uiGridConstants.dataChange.ROW]);
	
	          $scope.$on('$destroy', dataChangeDereg);
	
	          var setShowing = function () {
	            $scope.showingLow = ((options.paginationCurrentPage - 1) * options.paginationPageSize) + 1;
	            $scope.showingHigh = Math.min(options.paginationCurrentPage * options.paginationPageSize, options.totalItems);
	          };
	
	          var deregT = $scope.$watch('grid.options.totalItems + grid.options.paginationPageSize', setShowing);
	
	          var deregP = $scope.$watch('grid.options.paginationCurrentPage + grid.options.paginationPageSize', function (newValues, oldValues) {
	              if (newValues === oldValues || oldValues === undefined) {
	                return;
	              }
	
	              if (!angular.isNumber(options.paginationCurrentPage) || options.paginationCurrentPage < 1) {
	                options.paginationCurrentPage = 1;
	                return;
	              }
	
	              if (options.totalItems > 0 && options.paginationCurrentPage > $scope.paginationApi.getTotalPages()) {
	                options.paginationCurrentPage = $scope.paginationApi.getTotalPages();
	                return;
	              }
	
	              setShowing();
	              uiGridPaginationService.onPaginationChanged($scope.grid, options.paginationCurrentPage, options.paginationPageSize);
	            }
	          );
	
	          $scope.$on('$destroy', function() {
	            deregT();
	            deregP();
	          });
	
	          $scope.cantPageForward = function () {
	            if (options.totalItems > 0) {
	              return options.paginationCurrentPage >= $scope.paginationApi.getTotalPages();
	            } else {
	              return options.data.length < 1;
	            }
	          };
	
	          $scope.cantPageToLast = function () {
	            if (options.totalItems > 0) {
	              return $scope.cantPageForward();
	            } else {
	              return true;
	            }
	          };
	
	          $scope.cantPageBackward = function () {
	            return options.paginationCurrentPage <= 1;
	          };
	
	          var focusToInputIf = function(condition){
	            if (condition){
	              gridUtil.focus.bySelector($elm, defaultFocusElementSelector);
	            }
	          };
	
	          //Takes care of setting focus to the middle element when focus is lost
	          $scope.pageFirstPageClick = function () {
	            $scope.paginationApi.seek(1);
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pagePreviousPageClick = function () {
	            $scope.paginationApi.previousPage();
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pageNextPageClick = function () {
	            $scope.paginationApi.nextPage();
	            focusToInputIf($scope.cantPageForward());
	          };
	
	          $scope.pageLastPageClick = function () {
	            $scope.paginationApi.seek($scope.paginationApi.getTotalPages());
	            focusToInputIf($scope.cantPageToLast());
	          };
	
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pinning
	   * @description
	   *
	   * # ui.grid.pinning
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides column pinning to the end user via menu options in the column header
	   *
	   * <div doc-module-components="ui.grid.pinning"></div>
	   */
	
	  var module = angular.module('ui.grid.pinning', ['ui.grid']);
	
	  module.constant('uiGridPinningConstants', {
	    container: {
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: ''
	    }
	  });
	
	  module.service('uiGridPinningService', ['gridUtil', 'GridRenderContainer', 'i18nService', 'uiGridPinningConstants', function (gridUtil, GridRenderContainer, i18nService, uiGridPinningConstants) {
	    var service = {
	
	      initializeGrid: function (grid) {
	        service.defaultGridOptions(grid.options);
	
	        // Register a column builder to add new menu items for pinning left and right
	        grid.registerColumnBuilder(service.pinningColumnBuilder);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:PublicApi
	         *
	         *  @description Public Api for pinning feature
	         */
	        var publicApi = {
	          events: {
	            pinning: {
	              /**
	               * @ngdoc event
	               * @name columnPin
	               * @eventOf ui.grid.pinning.api:PublicApi
	               * @description raised when column pin state has changed
	               * <pre>
	               *   gridApi.pinning.on.columnPinned(scope, function(colDef){})
	               * </pre>
	               * @param {object} colDef the column that was changed
	               * @param {string} container the render container the column is in ('left', 'right', '')
	               */
	              columnPinned: function(colDef, container) {
	              }
	            }
	          },
	          methods: {
	            pinning: {
	              /**
	               * @ngdoc function
	               * @name pinColumn
	               * @methodOf ui.grid.pinning.api:PublicApi
	               * @description pin column left, right, or none
	               * <pre>
	               *   gridApi.pinning.pinColumn(col, uiGridPinningConstants.container.LEFT)
	               * </pre>
	               * @param {gridColumn} col the column being pinned
	               * @param {string} container one of the recognised types
	               * from uiGridPinningConstants
	               */
	              pinColumn: function(col, container) {
	                service.pinColumn(grid, col, container);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:GridOptions
	         *
	         *  @description GridOptions for pinning feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Enable pinning for the entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enablePinning = gridOptions.enablePinning !== false;
	
	      },
	
	      pinningColumnBuilder: function (colDef, col, gridOptions) {
	        //default to true unless gridOptions or colDef is explicitly false
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:ColumnDef
	         *
	         *  @description ColumnDef for pinning feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Enable pinning for the individual column.
	         *  <br/>Defaults to true
	         */
	        colDef.enablePinning = colDef.enablePinning === undefined ? gridOptions.enablePinning : colDef.enablePinning;
	
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedLeft
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned left when grid is rendered
	         *  <br/>Defaults to false
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedRight
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned right when grid is rendered
	         *  <br/>Defaults to false
	         */
	        if (colDef.pinnedLeft) {
	          col.renderContainer = 'left';
	          col.grid.createLeftContainer();
	        }
	        else if (colDef.pinnedRight) {
	          col.renderContainer = 'right';
	          col.grid.createRightContainer();
	        }
	
	        if (!colDef.enablePinning) {
	          return;
	        }
	
	        var pinColumnLeftAction = {
	          name: 'ui.grid.pinning.pinLeft',
	          title: i18nService.get().pinning.pinLeft,
	          icon: 'ui-grid-icon-left-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'left';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.LEFT);
	          }
	        };
	
	        var pinColumnRightAction = {
	          name: 'ui.grid.pinning.pinRight',
	          title: i18nService.get().pinning.pinRight,
	          icon: 'ui-grid-icon-right-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'right';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.RIGHT);
	          }
	        };
	
	        var removePinAction = {
	          name: 'ui.grid.pinning.unpin',
	          title: i18nService.get().pinning.unpin,
	          icon: 'ui-grid-icon-cancel',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) !== 'undefined' && this.context.col.renderContainer !== null && this.context.col.renderContainer !== 'body';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.UNPIN);
	          }
	        };
	
	        if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinLeft')) {
	          col.menuItems.push(pinColumnLeftAction);
	        }
	        if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinRight')) {
	          col.menuItems.push(pinColumnRightAction);
	        }
	        if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.unpin')) {
	          col.menuItems.push(removePinAction);
	        }
	      },
	
	      pinColumn: function(grid, col, container) {
	        if (container === uiGridPinningConstants.container.NONE) {
	          col.renderContainer = null;
	        }
	        else {
	          col.renderContainer = container;
	          if (container === uiGridPinningConstants.container.LEFT) {
	            grid.createLeftContainer();
	          }
	          else if (container === uiGridPinningConstants.container.RIGHT) {
	            grid.createRightContainer();
	          }
	        }
	
	        grid.refresh()
	        .then(function() {
	          grid.api.pinning.raise.columnPinned( col.colDef, container );
	        });
	      }
	    };
	
	    return service;
	  }]);
	
	  module.directive('uiGridPinning', ['gridUtil', 'uiGridPinningService',
	    function (gridUtil, uiGridPinningService) {
	      return {
	        require: 'uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridPinningService.initializeGrid(uiGridCtrl.grid);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            }
	          };
	        }
	      };
	    }]);
	
	
	})();
	
	(function(){
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.resizeColumns
	   * @description
	   *
	   * # ui.grid.resizeColumns
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module allows columns to be resized.
	   */
	  var module = angular.module('ui.grid.resizeColumns', ['ui.grid']);
	
	  module.service('uiGridResizeColumnsService', ['gridUtil', '$q', '$timeout',
	    function (gridUtil, $q, $timeout) {
	
	      var service = {
	        defaultGridOptions: function(gridOptions){
	          //default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:GridOptions
	           *
	           *  @description GridOptions for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:GridOptions
	           *  @description Enable column resizing on the entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableColumnResizing = gridOptions.enableColumnResizing !== false;
	
	          //legacy support
	          //use old name if it is explicitly false
	          if (gridOptions.enableColumnResize === false){
	            gridOptions.enableColumnResizing = false;
	          }
	        },
	
	        colResizerColumnBuilder: function (colDef, col, gridOptions) {
	
	          var promises = [];
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:ColumnDef
	           *
	           *  @description ColumnDef for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:ColumnDef
	           *  @description Enable column resizing on an individual column
	           *  <br/>Defaults to GridOptions.enableColumnResizing
	           */
	          //default to true unless gridOptions or colDef is explicitly false
	          colDef.enableColumnResizing = colDef.enableColumnResizing === undefined ? gridOptions.enableColumnResizing : colDef.enableColumnResizing;
	
	
	          //legacy support of old option name
	          if (colDef.enableColumnResize === false){
	            colDef.enableColumnResizing = false;
	          }
	
	          return $q.all(promises);
	        },
	
	        registerPublicApi: function (grid) {
	            /**
	             *  @ngdoc object
	             *  @name ui.grid.resizeColumns.api:PublicApi
	             *  @description Public Api for column resize feature.
	             */
	            var publicApi = {
	              events: {
	                /**
	                 * @ngdoc event
	                 * @name columnSizeChanged
	                 * @eventOf  ui.grid.resizeColumns.api:PublicApi
	                 * @description raised when column is resized
	                 * <pre>
	                 *      gridApi.colResizable.on.columnSizeChanged(scope,function(colDef, deltaChange){})
	                 * </pre>
	                 * @param {object} colDef the column that was resized
	                 * @param {integer} delta of the column size change
	                 */
	                colResizable: {
	                  columnSizeChanged: function (colDef, deltaChange) {
	                  }
	                }
	              }
	            };
	            grid.api.registerEventsFromObject(publicApi.events);
	        },
	
	        fireColumnSizeChanged: function (grid, colDef, deltaChange) {
	          $timeout(function () {
	            if ( grid.api.colResizable ){
	              grid.api.colResizable.raise.columnSizeChanged(colDef, deltaChange);
	            } else {
	              gridUtil.logError("The resizeable api is not registered, this may indicate that you've included the module but not added the 'ui-grid-resize-columns' directive to your grid definition.  Cannot raise any events.");
	            }
	          });
	        },
	
	        // get either this column, or the column next to this column, to resize,
	        // returns the column we're going to resize
	        findTargetCol: function(col, position, rtlMultiplier){
	          var renderContainer = col.getRenderContainer();
	
	          if (position === 'left') {
	            // Get the column to the left of this one
	            var colIndex = renderContainer.visibleColumnCache.indexOf(col);
	            return renderContainer.visibleColumnCache[colIndex - 1 * rtlMultiplier];
	          } else {
	            return col;
	          }
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridResizeColumns
	   * @element div
	   * @restrict A
	   * @description
	   * Enables resizing for all columns on the grid. If, for some reason, you want to use the ui-grid-resize-columns directive, but not allow column resizing, you can explicitly set the
	   * option to false. This prevents resizing for the entire grid, regardless of individual columnDef options.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <div class="testGrid" ui-grid="gridOpts" ui-grid-resize-columns ></div>
	   </div>
	   </doc:source>
	   <doc:scenario>
	
	   </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridResizeColumns', ['gridUtil', 'uiGridResizeColumnsService', function (gridUtil, uiGridResizeColumnsService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridResizeColumnsService.defaultGridOptions(uiGridCtrl.grid.options);
	            uiGridCtrl.grid.registerColumnBuilder( uiGridResizeColumnsService.colResizerColumnBuilder);
	            uiGridResizeColumnsService.registerPublicApi(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  // Extend the uiGridHeaderCell directive
	  module.directive('uiGridHeaderCell', ['gridUtil', '$templateCache', '$compile', '$q', 'uiGridResizeColumnsService', 'uiGridConstants', '$timeout', function (gridUtil, $templateCache, $compile, $q, uiGridResizeColumnsService, uiGridConstants, $timeout) {
	    return {
	      // Run after the original uiGridHeaderCell
	      priority: -10,
	      require: '^uiGrid',
	      // scope: false,
	      compile: function() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var grid = uiGridCtrl.grid;
	
	            if (grid.options.enableColumnResizing) {
	              var columnResizerElm = $templateCache.get('ui-grid/columnResizer');
	
	              var rtlMultiplier = 1;
	              //when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	              if (grid.isRTL()) {
	                $scope.position = 'left';
	                rtlMultiplier = -1;
	              }
	
	              var displayResizers = function(){
	
	                // remove any existing resizers.
	                var resizers = $elm[0].getElementsByClassName('ui-grid-column-resizer');
	                for ( var i = 0; i < resizers.length; i++ ){
	                  angular.element(resizers[i]).remove();
	                }
	
	                // get the target column for the left resizer
	                var otherCol = uiGridResizeColumnsService.findTargetCol($scope.col, 'left', rtlMultiplier);
	                var renderContainer = $scope.col.getRenderContainer();
	
	                // Don't append the left resizer if this is the first column or the column to the left of this one has resizing disabled
	                if (otherCol && renderContainer.visibleColumnCache.indexOf($scope.col) !== 0 && otherCol.colDef.enableColumnResizing !== false) {
	                  var resizerLeft = angular.element(columnResizerElm).clone();
	                  resizerLeft.attr('position', 'left');
	
	                  $elm.prepend(resizerLeft);
	                  $compile(resizerLeft)($scope);
	                }
	
	                // Don't append the right resizer if this column has resizing disabled
	                if ($scope.col.colDef.enableColumnResizing !== false) {
	                  var resizerRight = angular.element(columnResizerElm).clone();
	                  resizerRight.attr('position', 'right');
	
	                  $elm.append(resizerRight);
	                  $compile(resizerRight)($scope);
	                }
	              };
	
	              displayResizers();
	
	              var waitDisplay = function(){
	                $timeout(displayResizers);
	              };
	
	              var dataChangeDereg = grid.registerDataChangeCallback( waitDisplay, [uiGridConstants.dataChange.COLUMN] );
	
	              $scope.$on( '$destroy', dataChangeDereg );
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridColumnResizer
	   * @element div
	   * @restrict A
	   *
	   * @description
	   * Draggable handle that controls column resizing.
	   *
	   * @example
	   <doc:example module="app">
	     <doc:source>
	       <script>
	        var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            enableColumnResizing: true,
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	       </script>
	
	       <div ng-controller="MainCtrl">
	        <div class="testGrid" ui-grid="gridOpts"></div>
	       </div>
	     </doc:source>
	     <doc:scenario>
	      // TODO: e2e specs?
	
	      // TODO: post-resize a horizontal scroll event should be fired
	     </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridColumnResizer', ['$document', 'gridUtil', 'uiGridConstants', 'uiGridResizeColumnsService', function ($document, gridUtil, uiGridConstants, uiGridResizeColumnsService) {
	    var resizeOverlay = angular.element('<div class="ui-grid-resize-overlay"></div>');
	
	    var resizer = {
	      priority: 0,
	      scope: {
	        col: '=',
	        position: '@',
	        renderIndex: '='
	      },
	      require: '?^uiGrid',
	      link: function ($scope, $elm, $attrs, uiGridCtrl) {
	        var startX = 0,
	            x = 0,
	            gridLeft = 0,
	            rtlMultiplier = 1;
	
	        //when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	        if (uiGridCtrl.grid.isRTL()) {
	          $scope.position = 'left';
	          rtlMultiplier = -1;
	        }
	
	        if ($scope.position === 'left') {
	          $elm.addClass('left');
	        }
	        else if ($scope.position === 'right') {
	          $elm.addClass('right');
	        }
	
	        // Refresh the grid canvas
	        //   takes an argument representing the diff along the X-axis that the resize had
	        function refreshCanvas(xDiff) {
	          // Then refresh the grid canvas, rebuilding the styles so that the scrollbar updates its size
	          uiGridCtrl.grid.refreshCanvas(true).then( function() {
	            uiGridCtrl.grid.queueGridRefresh();
	          });
	        }
	
	        // Check that the requested width isn't wider than the maxWidth, or narrower than the minWidth
	        // Returns the new recommended with, after constraints applied
	        function constrainWidth(col, width){
	          var newWidth = width;
	
	          // If the new width would be less than the column's allowably minimum width, don't allow it
	          if (col.minWidth && newWidth < col.minWidth) {
	            newWidth = col.minWidth;
	          }
	          else if (col.maxWidth && newWidth > col.maxWidth) {
	            newWidth = col.maxWidth;
	          }
	
	          return newWidth;
	        }
	
	
	        /*
	         * Our approach to event handling aims to deal with both touch devices and mouse devices
	         * We register down handlers on both touch and mouse.  When a touchstart or mousedown event
	         * occurs, we register the corresponding touchmove/touchend, or mousemove/mouseend events.
	         *
	         * This way we can listen for both without worrying about the fact many touch devices also emulate
	         * mouse events - basically whichever one we hear first is what we'll go with.
	         */
	        function moveFunction(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          x = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          if (x < 0) { x = 0; }
	          else if (x > uiGridCtrl.grid.gridWidth) { x = uiGridCtrl.grid.gridWidth; }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          if (!uiGridCtrl.grid.element.hasClass('column-resizing')) {
	            uiGridCtrl.grid.element.addClass('column-resizing');
	          }
	
	          // Get the diff along the X axis
	          var xDiff = x - startX;
	
	          // Get the width that this mouse would give the column
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          x = x + ( constrainWidth(col, newWidth) - newWidth ) * rtlMultiplier;
	
	          resizeOverlay.css({ left: x + 'px' });
	
	          uiGridCtrl.fireEvent(uiGridConstants.events.ITEM_DRAGGING);
	        }
	
	
	        function upFunction(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          uiGridCtrl.grid.element.removeClass('column-resizing');
	
	          resizeOverlay.remove();
	
	          // Resize the column
	          x = (event.changedTouches ? event.changedTouches[0] : event).clientX - gridLeft;
	          var xDiff = x - startX;
	
	          if (xDiff === 0) {
	            // no movement, so just reset event handlers, including turning back on both
	            // down events - we turned one off when this event started
	            offAllEvents();
	            onDownEvents();
	            return;
	          }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Get the new width
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          col.width = constrainWidth(col, newWidth);
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);
	
	          // stop listening of up and move events - wait for next down
	          // reset the down events - we will have turned one off when this event started
	          offAllEvents();
	          onDownEvents();
	        }
	
	
	        var downFunction = function(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.stopPropagation();
	
	          // Get the left offset of the grid
	          // gridLeft = uiGridCtrl.grid.element[0].offsetLeft;
	          gridLeft = uiGridCtrl.grid.element[0].getBoundingClientRect().left;
	
	          // Get the starting X position, which is the X coordinate of the click minus the grid's offset
	          startX = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          // Append the resizer overlay
	          uiGridCtrl.grid.element.append(resizeOverlay);
	
	          // Place the resizer overlay at the start position
	          resizeOverlay.css({ left: startX });
	
	          // Add handlers for move and up events - if we were mousedown then we listen for mousemove and mouseup, if
	          // we were touchdown then we listen for touchmove and touchup.  Also remove the handler for the equivalent
	          // down event - so if we're touchdown, then remove the mousedown handler until this event is over, if we're
	          // mousedown then remove the touchdown handler until this event is over, this avoids processing duplicate events
	          if ( event.type === 'touchstart' ){
	            $document.on('touchend', upFunction);
	            $document.on('touchmove', moveFunction);
	            $elm.off('mousedown', downFunction);
	          } else {
	            $document.on('mouseup', upFunction);
	            $document.on('mousemove', moveFunction);
	            $elm.off('touchstart', downFunction);
	          }
	        };
	
	        var onDownEvents = function() {
	          $elm.on('mousedown', downFunction);
	          $elm.on('touchstart', downFunction);
	        };
	
	        var offAllEvents = function() {
	          $document.off('mouseup', upFunction);
	          $document.off('touchend', upFunction);
	          $document.off('mousemove', moveFunction);
	          $document.off('touchmove', moveFunction);
	          $elm.off('mousedown', downFunction);
	          $elm.off('touchstart', downFunction);
	        };
	
	        onDownEvents();
	
	
	        // On doubleclick, resize to fit all rendered cells
	        var dblClickFn = function(event, args){
	          event.stopPropagation();
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Go through the rendered rows and find out the max size for the data in this column
	          var maxWidth = 0;
	          var xDiff = 0;
	
	          // Get the parent render container element
	          var renderContainerElm = gridUtil.closestElm($elm, '.ui-grid-render-container');
	
	          // Get the cell contents so we measure correctly. For the header cell we have to account for the sort icon and the menu buttons, if present
	          var cells = renderContainerElm.querySelectorAll('.' + uiGridConstants.COL_CLASS_PREFIX + col.uid + ' .ui-grid-cell-contents');
	          Array.prototype.forEach.call(cells, function (cell) {
	              // Get the cell width
	              // gridUtil.logDebug('width', gridUtil.elementWidth(cell));
	
	              // Account for the menu button if it exists
	              var menuButton;
	              if (angular.element(cell).parent().hasClass('ui-grid-header-cell')) {
	                menuButton = angular.element(cell).parent()[0].querySelectorAll('.ui-grid-column-menu-button');
	              }
	
	              gridUtil.fakeElement(cell, {}, function(newElm) {
	                // Make the element float since it's a div and can expand to fill its container
	                var e = angular.element(newElm);
	                e.attr('style', 'float: left');
	
	                var width = gridUtil.elementWidth(e);
	
	                if (menuButton) {
	                  var menuButtonWidth = gridUtil.elementWidth(menuButton);
	                  width = width + menuButtonWidth;
	                }
	
	                if (width > maxWidth) {
	                  maxWidth = width;
	                  xDiff = maxWidth - width;
	                }
	              });
	            });
	
	          // check we're not outside the allowable bounds for this column
	          col.width = constrainWidth(col, maxWidth);
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);        };
	        $elm.on('dblclick', dblClickFn);
	
	        $elm.on('$destroy', function() {
	          $elm.off('dblclick', dblClickFn);
	          offAllEvents();
	        });
	      }
	    };
	
	    return resizer;
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.rowEdit
	   * @description
	   *
	   * # ui.grid.rowEdit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module extends the edit feature to provide tracking and saving of rows
	   * of data.  The tutorial provides more information on how this feature is best
	   * used {@link tutorial/205_row_editable here}.
	   * <br/>
	   * This feature depends on usage of the ui-grid-edit feature, and also benefits
	   * from use of ui-grid-cellNav to provide the full spreadsheet-like editing
	   * experience
	   *
	   */
	
	  var module = angular.module('ui.grid.rowEdit', ['ui.grid', 'ui.grid.edit', 'ui.grid.cellNav']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.rowEdit.constant:uiGridRowEditConstants
	   *
	   *  @description constants available in row edit module
	   */
	  module.constant('uiGridRowEditConstants', {
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.rowEdit.service:uiGridRowEditService
	   *
	   *  @description Services for row editing features
	   */
	  module.service('uiGridRowEditService', ['$interval', '$q', 'uiGridConstants', 'uiGridRowEditConstants', 'gridUtil',
	    function ($interval, $q, uiGridConstants, uiGridRowEditConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (scope, grid) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:PublicApi
	           *
	           *  @description Public Api for rowEdit feature
	           */
	
	          grid.rowEdit = {};
	
	          var publicApi = {
	            events: {
	              rowEdit: {
	                /**
	                 * @ngdoc event
	                 * @eventOf ui.grid.rowEdit.api:PublicApi
	                 * @name saveRow
	                 * @description raised when a row is ready for saving.  Once your
	                 * row has saved you may need to use angular.extend to update the
	                 * data entity with any changed data from your save (for example,
	                 * lock version information if you're using optimistic locking,
	                 * or last update time/user information).
	                 *
	                 * Your method should call setSavePromise somewhere in the body before
	                 * returning control.  The feature will then wait, with the gridRow greyed out
	                 * whilst this promise is being resolved.
	                 *
	                 * <pre>
	                 *      gridApi.rowEdit.on.saveRow(scope,function(rowEntity){})
	                 * </pre>
	                 * and somewhere within the event handler:
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise( rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @returns {promise} Your saveRow method should return a promise, the
	                 * promise should either be resolved (implying successful save), or
	                 * rejected (implying an error).
	                 */
	                saveRow: function (rowEntity) {
	                }
	              }
	            },
	            methods: {
	              rowEdit: {
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setSavePromise
	                 * @description Sets the promise associated with the row save, mandatory that
	                 * the saveRow event handler calls this method somewhere before returning.
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise(rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity a data row from the grid for which a save has
	                 * been initiated
	                 * @param {promise} savePromise the promise that will be resolved when the
	                 * save is successful, or rejected if the save fails
	                 *
	                 */
	                setSavePromise: function ( rowEntity, savePromise) {
	                  service.setSavePromise(grid, rowEntity, savePromise);
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getDirtyRows
	                 * @description Returns all currently dirty rows
	                 * <pre>
	                 *      gridApi.rowEdit.getDirtyRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently dirty
	                 *
	                 */
	                getDirtyRows: function () {
	                  return grid.rowEdit.dirtyRows ? grid.rowEdit.dirtyRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getErrorRows
	                 * @description Returns all currently errored rows
	                 * <pre>
	                 *      gridApi.rowEdit.getErrorRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently in error
	                 *
	                 */
	                getErrorRows: function () {
	                  return grid.rowEdit.errorRows ? grid.rowEdit.errorRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name flushDirtyRows
	                 * @description Triggers a save event for all currently dirty rows, could
	                 * be used where user presses a save button or navigates away from the page
	                 * <pre>
	                 *      gridApi.rowEdit.flushDirtyRows(grid)
	                 * </pre>
	                 * @returns {promise} a promise that represents the aggregate of all
	                 * of the individual save promises - i.e. it will be resolved when all
	                 * the individual save promises have been resolved.
	                 *
	                 */
	                flushDirtyRows: function () {
	                  return service.flushDirtyRows(grid);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsDirty
	                 * @description Sets each of the rows passed in dataRows
	                 * to be dirty.  note that if you have only just inserted the
	                 * rows into your data you will need to wait for a $digest cycle
	                 * before the gridRows are present - so often you would wrap this
	                 * call in a $interval or $timeout
	                 * <pre>
	                 *      $interval( function() {
	                 *        gridApi.rowEdit.setRowsDirty(myDataRows);
	                 *      }, 0, 1);
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set dirty.
	                 *
	                 */
	                setRowsDirty: function ( dataRows) {
	                  service.setRowsDirty(grid, dataRows);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsClean
	                 * @description Sets each of the rows passed in dataRows
	                 * to be clean, removing them from the dirty cache and the error cache,
	                 * and clearing the error flag and the dirty flag
	                 * <pre>
	                 *      var gridRows = $scope.gridApi.rowEdit.getDirtyRows();
	                 *      var dataRows = gridRows.map( function( gridRow ) { return gridRow.entity; });
	                 *      $scope.gridApi.rowEdit.setRowsClean( dataRows );
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set clean.
	                 *
	                 */
	                setRowsClean: function ( dataRows) {
	                  service.setRowsClean(grid, dataRows);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          grid.api.core.on.renderingComplete( scope, function ( gridApi ) {
	            grid.api.edit.on.afterCellEdit( scope, service.endEditCell );
	            grid.api.edit.on.beginCellEdit( scope, service.beginEditCell );
	            grid.api.edit.on.cancelCellEdit( scope, service.cancelEditCell );
	
	            if ( grid.api.cellNav ) {
	              grid.api.cellNav.on.navigate( scope, service.navigate );
	            }
	          });
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:GridOptions
	           *
	           *  @description Options for configuring the rowEdit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name saveRow
	         * @description  Returns a function that saves the specified row from the grid,
	         * and returns a promise
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @param {GridRow} gridRow the row that should be saved
	         * @returns {function} the saveRow function returns a function.  That function
	         * in turn, when called, returns a promise relating to the save callback
	         */
	        saveRow: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            gridRow.isSaving = true;
	
	            if ( gridRow.rowEditSavePromise ){
	              // don't save the row again if it's already saving - that causes stale object exceptions
	              return gridRow.rowEditSavePromise;
	            }
	
	            var promise = grid.api.rowEdit.raise.saveRow( gridRow.entity );
	
	            if ( gridRow.rowEditSavePromise ){
	              gridRow.rowEditSavePromise.then( self.processSuccessPromise( grid, gridRow ), self.processErrorPromise( grid, gridRow ));
	            } else {
	              gridUtil.logError( 'A promise was not returned when saveRow event was raised, either nobody is listening to event, or event handler did not return a promise' );
	            }
	            return promise;
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf  ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setSavePromise
	         * @description Sets the promise associated with the row save, mandatory that
	         * the saveRow event handler calls this method somewhere before returning.
	         * <pre>
	         *      gridApi.rowEdit.setSavePromise(grid, rowEntity)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be returned
	         * @param {object} rowEntity a data row from the grid for which a save has
	         * been initiated
	         * @param {promise} savePromise the promise that will be resolved when the
	         * save is successful, or rejected if the save fails
	         *
	         */
	        setSavePromise: function (grid, rowEntity, savePromise) {
	          var gridRow = grid.getRow( rowEntity );
	          gridRow.rowEditSavePromise = savePromise;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processSuccessPromise
	         * @description  Returns a function that processes the successful
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that has been saved
	         * @returns {function} the success handling function
	         */
	        processSuccessPromise: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.isDirty;
	            delete gridRow.isError;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	            self.removeRow( grid.rowEdit.errorRows, gridRow );
	            self.removeRow( grid.rowEdit.dirtyRows, gridRow );
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processErrorPromise
	         * @description  Returns a function that processes the failed
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that is now in error
	         * @returns {function} the error handling function
	         */
	        processErrorPromise: function ( grid, gridRow ) {
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	
	            gridRow.isError = true;
	
	            if (!grid.rowEdit.errorRows){
	              grid.rowEdit.errorRows = [];
	            }
	            if (!service.isRowPresent( grid.rowEdit.errorRows, gridRow ) ){
	              grid.rowEdit.errorRows.push( gridRow );
	            }
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name removeRow
	         * @description  Removes a row from a cache of rows - either
	         * grid.rowEdit.errorRows or grid.rowEdit.dirtyRows.  If the row
	         * is not present silently does nothing.
	         * @param {array} rowArray the array from which to remove the row
	         * @param {GridRow} gridRow the row that should be removed
	         */
	        removeRow: function( rowArray, removeGridRow ){
	          if (typeof(rowArray) === 'undefined' || rowArray === null){
	            return;
	          }
	
	          rowArray.forEach( function( gridRow, index ){
	            if ( gridRow.uid === removeGridRow.uid ){
	              rowArray.splice( index, 1);
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name isRowPresent
	         * @description  Checks whether a row is already present
	         * in the given array
	         * @param {array} rowArray the array in which to look for the row
	         * @param {GridRow} gridRow the row that should be looked for
	         */
	        isRowPresent: function( rowArray, removeGridRow ){
	          var present = false;
	          rowArray.forEach( function( gridRow, index ){
	            if ( gridRow.uid === removeGridRow.uid ){
	              present = true;
	            }
	          });
	          return present;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name flushDirtyRows
	         * @description Triggers a save event for all currently dirty rows, could
	         * be used where user presses a save button or navigates away from the page
	         * <pre>
	         *      gridApi.rowEdit.flushDirtyRows(grid)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @returns {promise} a promise that represents the aggregate of all
	         * of the individual save promises - i.e. it will be resolved when all
	         * the individual save promises have been resolved.
	         *
	         */
	        flushDirtyRows: function(grid){
	          var promises = [];
	          grid.api.rowEdit.getDirtyRows().forEach( function( gridRow ){
	            service.saveRow( grid, gridRow )();
	            promises.push( gridRow.rowEditSavePromise );
	          });
	
	          return $q.all( promises );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name endEditCell
	         * @description Receives an afterCellEdit event from the edit function,
	         * and sets flags as appropriate.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * was edited
	         */
	        endEditCell: function( rowEntity, colDef, newValue, previousValue ){
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ){ gridUtil.logError( 'Unable to find rowEntity in grid data, dirty flag cannot be set' ); return; }
	
	          if ( newValue !== previousValue || gridRow.isDirty ){
	            if ( !grid.rowEdit.dirtyRows ){
	              grid.rowEdit.dirtyRows = [];
	            }
	
	            if ( !gridRow.isDirty ){
	              gridRow.isDirty = true;
	              grid.rowEdit.dirtyRows.push( gridRow );
	            }
	
	            delete gridRow.isError;
	
	            service.considerSetTimer( grid, gridRow );
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name beginEditCell
	         * @description Receives a beginCellEdit event from the edit function,
	         * and cancels any rowEditSaveTimers if present, as the user is still editing
	         * this row.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * editing has commenced
	         */
	        beginEditCell: function( rowEntity, colDef ){
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ){ gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be cancelled' ); return; }
	
	          service.cancelTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelEditCell
	         * @description Receives a cancelCellEdit event from the edit function,
	         * and if the row was already dirty, restarts the save timer.  If the row
	         * was not already dirty, then it's not dirty now either and does nothing.
	         *
	         * Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         *
	         * @param {object} rowEntity the data entity for which the cell
	         * editing was cancelled
	         */
	        cancelEditCell: function( rowEntity, colDef ){
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ){ gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be set' ); return; }
	
	          service.considerSetTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name navigate
	         * @description cellNav tells us that the selected cell has changed.  If
	         * the new row had a timer running, then stop it similar to in a beginCellEdit
	         * call.  If the old row is dirty and not the same as the new row, then
	         * start a timer on it.
	         * @param {object} newRowCol the row and column that were selected
	         * @param {object} oldRowCol the row and column that was left
	         *
	         */
	        navigate: function( newRowCol, oldRowCol ){
	          var grid = this.grid;
	          if ( newRowCol.row.rowEditSaveTimer ){
	            service.cancelTimer( grid, newRowCol.row );
	          }
	
	          if ( oldRowCol && oldRowCol.row && oldRowCol.row !== newRowCol.row ){
	            service.considerSetTimer( grid, oldRowCol.row );
	          }
	        },
	
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.rowEdit.api:GridOptions
	         * @name rowEditWaitInterval
	         * @description How long the grid should wait for another change on this row
	         * before triggering a save (in milliseconds).  If set to -1, then saves are
	         * never triggered by timer (implying that the user will call flushDirtyRows()
	         * manually)
	         *
	         * @example
	         * Setting the wait interval to 4 seconds
	         * <pre>
	         *   $scope.gridOptions = { rowEditWaitInterval: 4000 }
	         * </pre>
	         *
	         */
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name considerSetTimer
	         * @description Consider setting a timer on this row (if it is dirty).  if there is a timer running
	         * on the row and the row isn't currently saving, cancel it, using cancelTimer, then if the row is
	         * dirty and not currently saving then set a new timer
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        considerSetTimer: function( grid, gridRow ){
	          service.cancelTimer( grid, gridRow );
	
	          if ( gridRow.isDirty && !gridRow.isSaving ){
	            if ( grid.options.rowEditWaitInterval !== -1 ){
	              var waitTime = grid.options.rowEditWaitInterval ? grid.options.rowEditWaitInterval : 2000;
	              gridRow.rowEditSaveTimer = $interval( service.saveRow( grid, gridRow ), waitTime, 1);
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelTimer
	         * @description cancel the $interval for any timer running on this row
	         * then delete the timer itself
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        cancelTimer: function( grid, gridRow ){
	          if ( gridRow.rowEditSaveTimer && !gridRow.isSaving ){
	            $interval.cancel(gridRow.rowEditSaveTimer);
	            delete gridRow.rowEditSaveTimer;
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsDirty
	         * @description Sets each of the rows passed in dataRows
	         * to be dirty.  note that if you have only just inserted the
	         * rows into your data you will need to wait for a $digest cycle
	         * before the gridRows are present - so often you would wrap this
	         * call in a $interval or $timeout
	         * <pre>
	         *      $interval( function() {
	         *        gridApi.rowEdit.setRowsDirty( myDataRows);
	         *      }, 0, 1);
	         * </pre>
	         * @param {object} grid the grid for which rows should be set dirty
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set dirty.
	         *
	         */
	        setRowsDirty: function( grid, myDataRows ) {
	          var gridRow;
	          myDataRows.forEach( function( value, index ){
	            gridRow = grid.getRow( value );
	            if ( gridRow ){
	              if ( !grid.rowEdit.dirtyRows ){
	                grid.rowEdit.dirtyRows = [];
	              }
	
	              if ( !gridRow.isDirty ){
	                gridRow.isDirty = true;
	                grid.rowEdit.dirtyRows.push( gridRow );
	              }
	
	              delete gridRow.isError;
	
	              service.considerSetTimer( grid, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsDirty, row was: " + value );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsClean
	         * @description Sets each of the rows passed in dataRows
	         * to be clean, clearing the dirty flag and the error flag, and removing
	         * the rows from the dirty and error caches.
	         * @param {object} grid the grid for which rows should be set clean
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set clean.
	         *
	         */
	        setRowsClean: function( grid, myDataRows ) {
	          var gridRow;
	
	          myDataRows.forEach( function( value, index ){
	            gridRow = grid.getRow( value );
	            if ( gridRow ){
	              delete gridRow.isDirty;
	              service.removeRow( grid.rowEdit.dirtyRows, gridRow );
	              service.cancelTimer( grid, gridRow );
	
	              delete gridRow.isError;
	              service.removeRow( grid.rowEdit.errorRows, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsClean, row was: " + value );
	            }
	          });
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds row editing features to the ui-grid-edit directive.
	   *
	   */
	  module.directive('uiGridRowEdit', ['gridUtil', 'uiGridRowEditService', 'uiGridEditConstants',
	  function (gridUtil, uiGridRowEditService, uiGridEditConstants) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridRowEditService.initializeGrid($scope, uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row to allow coloring of saving and error rows
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'uiGridConstants', 'gridUtil', '$parse',
	      function ($compile, uiGridConstants, gridUtil, $parse) {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	            var existingNgClass = rowRepeatDiv.attr("ng-class");
	            var newNgClass = '';
	            if ( existingNgClass ) {
	              newNgClass = existingNgClass.slice(0, -1) + ", 'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            } else {
	              newNgClass = "{'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            }
	            rowRepeatDiv.attr("ng-class", newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.saveState
	   * @description
	   *
	   * # ui.grid.saveState
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to save the grid state, and restore
	   * it when the user returns to the page.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate. Usually the navigate events would be used to save
	   * the grid state and restore it.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.save-state"></div>
	   */
	
	  var module = angular.module('ui.grid.saveState', ['ui.grid', 'ui.grid.selection', 'ui.grid.cellNav', 'ui.grid.grouping', 'ui.grid.pinning', 'ui.grid.treeView']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.saveState.constant:uiGridSaveStateConstants
	   *
	   *  @description constants available in save state module
	   */
	
	  module.constant('uiGridSaveStateConstants', {
	    featureName: 'saveState'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.saveState.service:uiGridSaveStateService
	   *
	   *  @description Services for saveState feature
	   */
	  module.service('uiGridSaveStateService', ['$q', 'uiGridSaveStateConstants', 'gridUtil', '$compile', '$interval', 'uiGridConstants',
	    function ($q, uiGridSaveStateConstants, gridUtil, $compile, $interval, uiGridConstants ) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          //add feature namespace and any properties to grid for needed state
	          grid.saveState = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.saveState.api:PublicApi
	           *
	           *  @description Public Api for saveState feature
	           */
	          var publicApi = {
	            events: {
	              saveState: {
	              }
	            },
	            methods: {
	              saveState: {
	                /**
	                 * @ngdoc function
	                 * @name save
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Packages the current state of the grid into
	                 * an object, and provides it to the user for saving
	                 * @returns {object} the state as a javascript object that can be saved
	                 */
	                save: function () {
	                  return service.save(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name restore
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Restores the provided state into the grid
	                 * @param {scope} $scope a scope that we can broadcast on
	                 * @param {object} state the state that should be restored into the grid
	                 */
	                restore: function ( $scope, state) {
	                  service.restore(grid, $scope, state);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.saveState.api:GridOptions
	           *
	           * @description GridOptions for saveState feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name saveWidths
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current column widths.  Note that unless
	           * you've provided the user with some way to resize their columns (say
	           * the resize columns feature), then this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveWidths = gridOptions.saveWidths !== false;
	          /**
	           * @ngdoc object
	           * @name saveOrder
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Restore the current column order.  Note that unless
	           * you've provided the user with some way to reorder their columns (for
	           * example the move columns feature), this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveOrder = gridOptions.saveOrder !== false;
	          /**
	           * @ngdoc object
	           * @name saveScroll
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current scroll position.  Note that this
	           * is saved as the percentage of the grid scrolled - so if your
	           * user returns to a grid with a significantly different number of
	           * rows (perhaps some data has been deleted) then the scroll won't
	           * actually show the same rows as before.  If you want to scroll to
	           * a specific row then you should instead use the saveFocus option, which
	           * is the default.
	           *
	           * Note that this element will only be saved if the cellNav feature is
	           * enabled
	           * <br/>Defaults to false
	           */
	          gridOptions.saveScroll = gridOptions.saveScroll === true;
	          /**
	           * @ngdoc object
	           * @name saveFocus
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current focused cell.  On returning
	           * to this focused cell we'll also scroll.  This option is
	           * preferred to the saveScroll option, so is set to true by
	           * default.  If saveScroll is set to true then this option will
	           * be disabled.
	           *
	           * By default this option saves the current row number and column
	           * number, and returns to that row and column.  However, if you define
	           * a saveRowIdentity function, then it will return you to the currently
	           * selected column within that row (in a business sense - so if some
	           * rows have been deleted, it will still find the same data, presuming it
	           * still exists in the list.  If it isn't in the list then it will instead
	           * return to the same row number - i.e. scroll percentage)
	           *
	           * Note that this option will do nothing if the cellNav
	           * feature is not enabled.
	           *
	           * <br/>Defaults to true (unless saveScroll is true)
	           */
	          gridOptions.saveFocus = gridOptions.saveScroll !== true && gridOptions.saveFocus !== false;
	          /**
	           * @ngdoc object
	           * @name saveRowIdentity
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description A function that can be called, passing in a rowEntity,
	           * and that will return a unique id for that row.  This might simply
	           * return the `id` field from that row (if you have one), or it might
	           * concatenate some fields within the row to make a unique value.
	           *
	           * This value will be used to find the same row again and set the focus
	           * to it, if it exists when we return.
	           *
	           * <br/>Defaults to undefined
	           */
	          /**
	           * @ngdoc object
	           * @name saveVisible
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save whether or not columns are visible.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveVisible = gridOptions.saveVisible !== false;
	          /**
	           * @ngdoc object
	           * @name saveSort
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current sort state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSort = gridOptions.saveSort !== false;
	          /**
	           * @ngdoc object
	           * @name saveFilter
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current filter state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveFilter = gridOptions.saveFilter !== false;
	          /**
	           * @ngdoc object
	           * @name saveSelection
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the currently selected rows.  If the `saveRowIdentity` callback
	           * is defined, then it will save the id of the row and select that.  If not, then
	           * it will attempt to select the rows by row number, which will give the wrong results
	           * if the data set has changed in the mean-time.
	           *
	           * Note that this option only does anything
	           * if the selection feature is enabled.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSelection = gridOptions.saveSelection !== false;
	          /**
	           * @ngdoc object
	           * @name saveGrouping
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping configuration.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveGrouping = gridOptions.saveGrouping !== false;
	          /**
	           * @ngdoc object
	           * @name saveGroupingExpandedStates
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping row expanded states.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * This can be quite a bit of data, in many cases you wouldn't want to save this
	           * information.
	           *
	           * <br/>Defaults to false
	           */
	          gridOptions.saveGroupingExpandedStates = gridOptions.saveGroupingExpandedStates === true;
	          /**
	           * @ngdoc object
	           * @name savePinning
	           * @propertyOf ui.grid.saveState.api:GridOptions
	           * @description Save pinning state for columns.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.savePinning = gridOptions.savePinning !== false;
	          /**
	           * @ngdoc object
	           * @name saveTreeView
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the treeView configuration.  If set to true and the
	           * treeView feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveTreeView = gridOptions.saveTreeView !== false;
	        },
	
	
	
	        /**
	         * @ngdoc function
	         * @name save
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the current grid state into an object, and
	         * passes that object back to the caller
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the state ready to be saved
	         */
	        save: function (grid) {
	          var savedState = {};
	
	          savedState.columns = service.saveColumns( grid );
	          savedState.scrollFocus = service.saveScrollFocus( grid );
	          savedState.selection = service.saveSelection( grid );
	          savedState.grouping = service.saveGrouping( grid );
	          savedState.treeView = service.saveTreeView( grid );
	
	          return savedState;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restore
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Applies the provided state to the grid
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} state the state we'd like to restore
	         */
	        restore: function( grid, $scope, state ){
	          if ( state.columns ) {
	            service.restoreColumns( grid, state.columns );
	          }
	
	          if ( state.scrollFocus ){
	            service.restoreScrollFocus( grid, $scope, state.scrollFocus );
	          }
	
	          if ( state.selection ){
	            service.restoreSelection( grid, state.selection );
	          }
	
	          if ( state.grouping ){
	            service.restoreGrouping( grid, state.grouping );
	          }
	
	          if ( state.treeView ){
	            service.restoreTreeView( grid, state.treeView );
	          }
	
	          grid.refresh();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the column setup, including sort, filters, ordering,
	         * pinning and column widths.
	         *
	         * Works through the current columns, storing them in order.  Stores the
	         * column name, then the visible flag, width, sort and filters for each column.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the columns state ready to be saved
	         */
	        saveColumns: function( grid ) {
	          var columns = [];
	          grid.getOnlyDataColumns().forEach( function( column ) {
	            var savedColumn = {};
	            savedColumn.name = column.name;
	
	            if ( grid.options.saveVisible ){
	              savedColumn.visible = column.visible;
	            }
	
	            if ( grid.options.saveWidths ){
	              savedColumn.width = column.width;
	            }
	
	            // these two must be copied, not just pointed too - otherwise our saved state is pointing to the same object as current state
	            if ( grid.options.saveSort ){
	              savedColumn.sort = angular.copy( column.sort );
	            }
	
	            if ( grid.options.saveFilter ){
	              savedColumn.filters = [];
	              column.filters.forEach( function( filter ){
	                var copiedFilter = {};
	                angular.forEach( filter, function( value, key) {
	                  if ( key !== 'condition' && key !== '$$hashKey' && key !== 'placeholder'){
	                    copiedFilter[key] = value;
	                  }
	                });
	                savedColumn.filters.push(copiedFilter);
	              });
	            }
	
	            if ( !!grid.api.pinning && grid.options.savePinning ){
	              savedColumn.pinned = column.renderContainer ? column.renderContainer : '';
	            }
	
	            columns.push( savedColumn );
	          });
	
	          return columns;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently scroll or focus.
	         *
	         * If cellNav isn't present then does nothing - we can't return
	         * to the scroll position without cellNav anyway.
	         *
	         * If the cellNav module is present, and saveFocus is true, then
	         * it saves the currently focused cell.  If rowIdentity is present
	         * then saves using rowIdentity, otherwise saves visibleRowNum.
	         *
	         * If the cellNav module is not present, and saveScroll is true, then
	         * it approximates the current scroll row and column, and saves that.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the selection state ready to be saved
	         */
	        saveScrollFocus: function( grid ){
	          if ( !grid.api.cellNav ){
	            return {};
	          }
	
	          var scrollFocus = {};
	          if ( grid.options.saveFocus ){
	            scrollFocus.focus = true;
	            var rowCol = grid.api.cellNav.getFocusedCell();
	            if ( rowCol !== null ) {
	              if ( rowCol.col !== null ){
	                scrollFocus.colName = rowCol.col.colDef.name;
	              }
	              if ( rowCol.row !== null ){
	                scrollFocus.rowVal = service.getRowVal( grid, rowCol.row );
	              }
	            }
	          }
	
	          if ( grid.options.saveScroll || grid.options.saveFocus && !scrollFocus.colName && !scrollFocus.rowVal ) {
	            scrollFocus.focus = false;
	            if ( grid.renderContainers.body.prevRowScrollIndex ){
	              scrollFocus.rowVal = service.getRowVal( grid, grid.renderContainers.body.visibleRowCache[ grid.renderContainers.body.prevRowScrollIndex ]);
	            }
	
	            if ( grid.renderContainers.body.prevColScrollIndex ){
	              scrollFocus.colName = grid.renderContainers.body.visibleColumnCache[ grid.renderContainers.body.prevColScrollIndex ].name;
	            }
	          }
	
	          return scrollFocus;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently selected rows, if the selection feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the selection state ready to be saved
	         */
	        saveSelection: function( grid ){
	          if ( !grid.api.selection || !grid.options.saveSelection ){
	            return [];
	          }
	
	          var selection = grid.api.selection.getSelectedGridRows().map( function( gridRow ) {
	            return service.getRowVal( grid, gridRow );
	          });
	
	          return selection;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the grouping state, if the grouping feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the grouping state ready to be saved
	         */
	        saveGrouping: function( grid ){
	          if ( !grid.api.grouping || !grid.options.saveGrouping ){
	            return {};
	          }
	
	          return grid.api.grouping.getGrouping( grid.options.saveGroupingExpandedStates );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the tree view state, if the tree feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the tree view state ready to be saved
	         */
	        saveTreeView: function( grid ){
	          if ( !grid.api.treeView || !grid.options.saveTreeView ){
	            return {};
	          }
	
	          return grid.api.treeView.getTreeView();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name getRowVal
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Helper function that gets either the rowNum or
	         * the saveRowIdentity, given a gridRow
	         * @param {Grid} grid the grid the row is in
	         * @param {GridRow} gridRow the row we want the rowNum for
	         * @returns {object} an object containing { identity: true/false, row: rowNumber/rowIdentity }
	         *
	         */
	        getRowVal: function( grid, gridRow ){
	          if ( !gridRow ) {
	            return null;
	          }
	
	          var rowVal = {};
	          if ( grid.options.saveRowIdentity ){
	            rowVal.identity = true;
	            rowVal.row = grid.options.saveRowIdentity( gridRow.entity );
	          } else {
	            rowVal.identity = false;
	            rowVal.row = grid.renderContainers.body.visibleRowCache.indexOf( gridRow );
	          }
	          return rowVal;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the columns, including order, visible, width,
	         * pinning, sort and filters.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} columnsState the list of columns we had before, with their state
	         */
	        restoreColumns: function( grid, columnsState ){
	          var isSortChanged = false;
	
	          columnsState.forEach( function( columnState, index ) {
	            var currentCol = grid.getColumn( columnState.name );
	
	            if ( currentCol && !grid.isRowHeaderColumn(currentCol) ){
	              if ( grid.options.saveVisible &&
	                   ( currentCol.visible !== columnState.visible ||
	                     currentCol.colDef.visible !== columnState.visible ) ){
	                currentCol.visible = columnState.visible;
	                currentCol.colDef.visible = columnState.visible;
	                grid.api.core.raise.columnVisibilityChanged(currentCol);
	              }
	
	              if ( grid.options.saveWidths ){
	                currentCol.width = columnState.width;
	              }
	
	              if ( grid.options.saveSort &&
	                   !angular.equals(currentCol.sort, columnState.sort) &&
	                   !( currentCol.sort === undefined && angular.isEmpty(columnState.sort) ) ){
	                currentCol.sort = angular.copy( columnState.sort );
	                isSortChanged = true;
	              }
	
	              if ( grid.options.saveFilter &&
	                   !angular.equals(currentCol.filters, columnState.filters ) ){
	                columnState.filters.forEach( function( filter, index ){
	                  angular.extend( currentCol.filters[index], filter );
	                  if ( typeof(filter.term) === 'undefined' || filter.term === null ){
	                    delete currentCol.filters[index].term;
	                  }
	                });
	                grid.api.core.raise.filterChanged();
	              }
	
	              if ( !!grid.api.pinning && grid.options.savePinning && currentCol.renderContainer !== columnState.pinned ){
	                grid.api.pinning.pinColumn(currentCol, columnState.pinned);
	              }
	
	              var currentIndex = grid.getOnlyDataColumns().indexOf( currentCol );
	              if (currentIndex !== -1) {
	                if (grid.options.saveOrder && currentIndex !== index) {
	                  var column = grid.columns.splice(currentIndex + grid.rowHeaderColumns.length, 1)[0];
	                  grid.columns.splice(index + grid.rowHeaderColumns.length, 0, column);
	                }
	              }
	            }
	          });
	
	          if ( isSortChanged ) {
	            grid.api.core.raise.sortChanged( grid, grid.getColumnSorting() );
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Scrolls to the position that was saved.  If focus is true, then
	         * sets focus to the specified row/col.  If focus is false, then scrolls to the
	         * specified row/col.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} scrollFocusState the scroll/focus state ready to be restored
	         */
	        restoreScrollFocus: function( grid, $scope, scrollFocusState ){
	          if ( !grid.api.cellNav ){
	            return;
	          }
	
	          var colDef, row;
	          if ( scrollFocusState.colName ){
	            var colDefs = grid.options.columnDefs.filter( function( colDef ) { return colDef.name === scrollFocusState.colName; });
	            if ( colDefs.length > 0 ){
	              colDef = colDefs[0];
	            }
	          }
	
	          if ( scrollFocusState.rowVal && scrollFocusState.rowVal.row ){
	            if ( scrollFocusState.rowVal.identity ){
	              row = service.findRowByIdentity( grid, scrollFocusState.rowVal );
	            } else {
	              row = grid.renderContainers.body.visibleRowCache[ scrollFocusState.rowVal.row ];
	            }
	          }
	
	          var entity = row && row.entity ? row.entity : null ;
	
	          if ( colDef || entity ) {
	            if (scrollFocusState.focus ){
	              grid.api.cellNav.scrollToFocus( entity, colDef );
	            } else {
	              grid.scrollTo( entity, colDef );
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Selects the rows that are provided in the selection
	         * state.  If you are using `saveRowIdentity` and more than one row matches the identity
	         * function then only the first is selected.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} selectionState the selection state ready to be restored
	         */
	        restoreSelection: function( grid, selectionState ){
	          if ( !grid.api.selection ){
	            return;
	          }
	
	          grid.api.selection.clearSelectedRows();
	
	          selectionState.forEach(  function( rowVal ) {
	            if ( rowVal.identity ){
	              var foundRow = service.findRowByIdentity( grid, rowVal );
	
	              if ( foundRow ){
	                grid.api.selection.selectRow( foundRow.entity );
	              }
	
	            } else {
	              grid.api.selection.selectRowByVisibleIndex( rowVal.row );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the grouping configuration, if the grouping feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} groupingState the grouping state ready to be restored
	         */
	        restoreGrouping: function( grid, groupingState ){
	          if ( !grid.api.grouping || typeof(groupingState) === 'undefined' || groupingState === null || angular.equals(groupingState, {}) ){
	            return;
	          }
	
	          grid.api.grouping.setGrouping( groupingState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name restoreTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the tree view configuration, if the tree view feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} treeViewState the tree view state ready to be restored
	         */
	        restoreTreeView: function( grid, treeViewState ){
	          if ( !grid.api.treeView || typeof(treeViewState) === 'undefined' || treeViewState === null || angular.equals(treeViewState, {}) ){
	            return;
	          }
	
	          grid.api.treeView.setTreeView( treeViewState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name findRowByIdentity
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Finds a row given it's identity value, returns the first found row
	         * if any are found, otherwise returns null if no rows are found.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} rowVal the row we'd like to find
	         * @returns {gridRow} the found row, or null if none found
	         */
	        findRowByIdentity: function( grid, rowVal ){
	          if ( !grid.options.saveRowIdentity ){
	            return null;
	          }
	
	          var filteredRows = grid.rows.filter( function( gridRow ) {
	            if ( grid.options.saveRowIdentity( gridRow.entity ) === rowVal.row ){
	              return true;
	            } else {
	              return false;
	            }
	          });
	
	          if ( filteredRows.length > 0 ){
	            return filteredRows[0];
	          } else {
	            return null;
	          }
	        }
	      };
	
	      return service;
	
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.saveState.directive:uiGridSaveState
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds saveState features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.saveState']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	        { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        columnDefs: [
	          {name: 'name'},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-save-state></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSaveState', ['uiGridSaveStateConstants', 'uiGridSaveStateService', 'gridUtil', '$compile',
	    function (uiGridSaveStateConstants, uiGridSaveStateService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridSaveStateService.initializeGrid(uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.selection
	   * @description
	   *
	   * # ui.grid.selection
	   * This module provides row selection
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * <div doc-module-components="ui.grid.selection"></div>
	   */
	
	  var module = angular.module('ui.grid.selection', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.selection.constant:uiGridSelectionConstants
	   *
	   *  @description constants available in selection module
	   */
	  module.constant('uiGridSelectionConstants', {
	    featureName: "selection",
	    selectionRowHeaderColName: 'selectionRowHeaderCol'
	  });
	
	  //add methods to GridRow
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('GridRow', ['$delegate', function($delegate) {
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.selection.api:GridRow
	       *
	       *  @description GridRow prototype functions added for selection
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name enableSelection
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Enable row selection for this row, only settable by internal code.
	       *
	       *  The grouping feature, for example, might set group header rows to not be selectable.
	       *  <br/>Defaults to true
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name isSelected
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Selected state of row.  Should be readonly. Make any changes to selected state using setSelected().
	       *  <br/>Defaults to false
	       */
	
	
	        /**
	         * @ngdoc function
	         * @name setSelected
	         * @methodOf ui.grid.selection.api:GridRow
	         * @description Sets the isSelected property and updates the selectedCount
	         * Changes to isSelected state should only be made via this function
	         * @param {bool} selected value to set
	         */
	        $delegate.prototype.setSelected = function(selected) {
	          this.isSelected = selected;
	          if (selected) {
	            this.grid.selection.selectedCount++;
	          }
	          else {
	            this.grid.selection.selectedCount--;
	          }
	        };
	
	      return $delegate;
	    }]);
	  }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.selection.service:uiGridSelectionService
	   *
	   *  @description Services for selection features
	   */
	  module.service('uiGridSelectionService', ['$q', '$templateCache', 'uiGridSelectionConstants', 'gridUtil',
	    function ($q, $templateCache, uiGridSelectionConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          //add feature namespace and any properties to grid for needed
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.grid:selection
	           *
	           *  @description Grid properties and functions added for selection
	           */
	          grid.selection = {};
	          grid.selection.lastSelectedRow = null;
	          grid.selection.selectAll = false;
	
	
	          /**
	           *  @ngdoc object
	           *  @name selectedCount
	           *  @propertyOf  ui.grid.selection.grid:selection
	           *  @description Current count of selected rows
	           *  @example
	           *  var count = grid.selection.selectedCount
	           */
	          grid.selection.selectedCount = 0;
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:PublicApi
	           *
	           *  @description Public Api for selection feature
	           */
	          var publicApi = {
	            events: {
	              selection: {
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChanged
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * @param {GridRow} row the row that was selected/deselected
	                 * @param {Event} event object if raised from an event
	                 */
	                rowSelectionChanged: function (scope, row, evt) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChangedBatch
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * in bulk, if the `enableSelectionBatchEvent` option is set to true
	                 * (which it is by default).  This allows more efficient processing
	                 * of bulk events.
	                 * @param {array} rows the rows that were selected/deselected
	                 * @param {Event} event object if raised from an event
	                 */
	                rowSelectionChangedBatch: function (scope, rows, evt) {
	                }
	              }
	            },
	            methods: {
	              selection: {
	                /**
	                 * @ngdoc function
	                 * @name toggleRowSelection
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Toggles data row as selected or unselected
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} event object if raised from an event
	                 */
	                toggleRowSelection: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} event object if raised from an event
	                 */
	                selectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRowByVisibleIndex
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the specified row by visible index (i.e. if you
	                 * specify row 0 you'll get the first visible row selected).  In this context
	                 * visible means of those rows that are theoretically visible (i.e. not filtered),
	                 * rather than rows currently rendered on the screen.
	                 * @param {number} index index within the rowsVisible array
	                 * @param {Event} event object if raised from an event
	                 */
	                selectRowByVisibleIndex: function ( rowNum, evt ) {
	                  var row = grid.renderContainers.body.visibleRowCache[rowNum];
	                  if (row !== null && typeof(row) !== 'undefined' && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description UnSelect the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} event object if raised from an event
	                 */
	                unSelectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null && row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all rows.  Does nothing if multiSelect = false
	                 * @param {Event} event object if raised from an event
	                 */
	                selectAllRows: function (evt) {
	                  if (grid.options.multiSelect === false) {
	                    return;
	                  }
	
	                  var changedRows = [];
	                  grid.rows.forEach(function (row) {
	                    if ( !row.isSelected && row.enableSelection !== false ){
	                      row.setSelected(true);
	                      service.decideRaiseSelectionEvent( grid, row, changedRows, evt );
	                    }
	                  });
	                  service.decideRaiseSelectionBatchEvent( grid, changedRows, evt );
	                  grid.selection.selectAll = true;
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllVisibleRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all visible rows.  Does nothing if multiSelect = false
	                 * @param {Event} event object if raised from an event
	                 */
	                selectAllVisibleRows: function (evt) {
	                  if (grid.options.multiSelect === false) {
	                    return;
	                  }
	
	                  var changedRows = [];
	                  grid.rows.forEach(function (row) {
	                    if (row.visible) {
	                      if (!row.isSelected && row.enableSelection !== false){
	                        row.setSelected(true);
	                        service.decideRaiseSelectionEvent( grid, row, changedRows, evt );
	                      }
	                    } else {
	                      if (row.isSelected){
	                        row.setSelected(false);
	                        service.decideRaiseSelectionEvent( grid, row, changedRows, evt );
	                      }
	                    }
	                  });
	                  service.decideRaiseSelectionBatchEvent( grid, changedRows, evt );
	                  grid.selection.selectAll = true;
	                },
	                /**
	                 * @ngdoc function
	                 * @name clearSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Unselects all rows
	                 * @param {Event} event object if raised from an event
	                 */
	                clearSelectedRows: function (evt) {
	                  service.clearSelectedRows(grid, evt);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selectedRow's entity references
	                 */
	                getSelectedRows: function () {
	                  return service.getSelectedRows(grid).map(function (gridRow) {
	                    return gridRow.entity;
	                  });
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedGridRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selectedRow's as gridRows
	                 */
	                getSelectedGridRows: function () {
	                  return service.getSelectedRows(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name setMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.multiSelect to true or false
	                 * @param {bool} multiSelect true to allow multiple rows
	                 */
	                setMultiSelect: function (multiSelect) {
	                  grid.options.multiSelect = multiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name setModifierKeysToMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.modifierKeysToMultiSelect to true or false
	                 * @param {bool} modifierKeysToMultiSelect true to only allow multiple rows when using ctrlKey or shiftKey is used
	                 */
	                setModifierKeysToMultiSelect: function (modifierKeysToMultiSelect) {
	                  grid.options.modifierKeysToMultiSelect = modifierKeysToMultiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectAllState
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Returns whether or not the selectAll checkbox is currently ticked.  The
	                 * grid doesn't automatically select rows when you add extra data - so when you add data
	                 * you need to explicitly check whether the selectAll is set, and then call setVisible rows
	                 * if it is
	                 */
	                getSelectAllState: function () {
	                  return grid.selection.selectAll;
	                }
	
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:GridOptions
	           *
	           *  @description GridOptions for selection feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable row selection for entire grid.
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowSelection = gridOptions.enableRowSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name multiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection for entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.multiSelect = gridOptions.multiSelect !== false;
	          /**
	           *  @ngdoc object
	           *  @name noUnselect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Prevent a row from being unselected.  Works in conjunction
	           *  with `multiselect = false` and `gridApi.selection.selectRow()` to allow
	           *  you to create a single selection only grid - a row is always selected, you
	           *  can only select different rows, you can't unselect the row.
	           *  <br/>Defaults to false
	           */
	          gridOptions.noUnselect = gridOptions.noUnselect === true;
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection only when using the ctrlKey or shiftKey. Requires multiSelect to be true.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelect = gridOptions.modifierKeysToMultiSelect === true;
	          /**
	           *  @ngdoc object
	           *  @name enableRowHeaderSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable a row header to be used for selection
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowHeaderSelection = gridOptions.enableRowHeaderSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableFullRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable selection by clicking anywhere on the row.  Defaults to
	           *  false if `enableRowHeaderSelection` is true, otherwise defaults to false.
	           */
	          if ( typeof(gridOptions.enableFullRowSelection) === 'undefined' ){
	            gridOptions.enableFullRowSelection = !gridOptions.enableRowHeaderSelection;
	          }
	          /**
	           *  @ngdoc object
	           *  @name enableSelectAll
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable the select all checkbox at the top of the selectionRowHeader
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectAll = gridOptions.enableSelectAll !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableSelectionBatchEvent
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description If selected rows are changed in bulk, either via the API or
	           *  via the selectAll checkbox, then a separate event is fired.  Setting this
	           *  option to false will cause the rowSelectionChanged event to be called multiple times
	           *  instead
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectionBatchEvent = gridOptions.enableSelectionBatchEvent !== false;
	          /**
	           *  @ngdoc object
	           *  @name selectionRowHeaderWidth
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description can be used to set a custom width for the row header selection column
	           *  <br/>Defaults to 30px
	           */
	          gridOptions.selectionRowHeaderWidth = angular.isDefined(gridOptions.selectionRowHeaderWidth) ? gridOptions.selectionRowHeaderWidth : 30;
	
	          /**
	           *  @ngdoc object
	           *  @name enableFooterTotalSelected
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Shows the total number of selected items in footer if true.
	           *  <br/>Defaults to true.
	           *  <br/>GridOptions.showGridFooter must also be set to true.
	           */
	          gridOptions.enableFooterTotalSelected = gridOptions.enableFooterTotalSelected !== false;
	
	          /**
	           *  @ngdoc object
	           *  @name isRowSelectable
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Makes it possible to specify a method that evaluates for each row and sets its "enableSelection" property.
	           */
	
	          gridOptions.isRowSelectable = angular.isDefined(gridOptions.isRowSelectable) ? gridOptions.isRowSelectable : angular.noop;
	        },
	
	        /**
	         * @ngdoc function
	         * @name toggleRowSelection
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Toggles row as selected or unselected
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row to select or deselect
	         * @param {Event} event object if resulting from event
	         * @param {bool} multiSelect if false, only one row at time can be selected
	         * @param {bool} noUnselect if true then rows cannot be unselected
	         */
	        toggleRowSelection: function (grid, row, evt, multiSelect, noUnselect) {
	          var selected = row.isSelected;
	
	          if ( row.enableSelection === false && !selected ){
	            return;
	          }
	
	          var selectedRows;
	          if (!multiSelect && !selected) {
	            service.clearSelectedRows(grid, evt);
	          } else if (!multiSelect && selected) {
	            selectedRows = service.getSelectedRows(grid);
	            if (selectedRows.length > 1) {
	              selected = false; // Enable reselect of the row
	              service.clearSelectedRows(grid, evt);
	            }
	          }
	
	          if (selected && noUnselect){
	            // don't deselect the row
	          } else {
	            row.setSelected(!selected);
	            if (row.isSelected === true) {
	              grid.selection.lastSelectedRow = row;
	            }
	
	            selectedRows = service.getSelectedRows(grid);
	            grid.selection.selectAll = grid.rows.length === selectedRows.length;
	
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          }
	        },
	        /**
	         * @ngdoc function
	         * @name shiftSelect
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description selects a group of rows from the last selected row using the shift key
	         * @param {Grid} grid grid object
	         * @param {GridRow} clicked row
	         * @param {Event} event object if raised from an event
	         * @param {bool} multiSelect if false, does nothing this is for multiSelect only
	         */
	        shiftSelect: function (grid, row, evt, multiSelect) {
	          if (!multiSelect) {
	            return;
	          }
	          var selectedRows = service.getSelectedRows(grid);
	          var fromRow = selectedRows.length > 0 ? grid.renderContainers.body.visibleRowCache.indexOf(grid.selection.lastSelectedRow) : 0;
	          var toRow = grid.renderContainers.body.visibleRowCache.indexOf(row);
	          //reverse select direction
	          if (fromRow > toRow) {
	            var tmp = fromRow;
	            fromRow = toRow;
	            toRow = tmp;
	          }
	
	          var changedRows = [];
	          for (var i = fromRow; i <= toRow; i++) {
	            var rowToSelect = grid.renderContainers.body.visibleRowCache[i];
	            if (rowToSelect) {
	              if ( !rowToSelect.isSelected && rowToSelect.enableSelection !== false ){
	                rowToSelect.setSelected(true);
	                grid.selection.lastSelectedRow = rowToSelect;
	                service.decideRaiseSelectionEvent( grid, rowToSelect, changedRows, evt );
	              }
	            }
	          }
	          service.decideRaiseSelectionBatchEvent( grid, changedRows, evt );
	        },
	        /**
	         * @ngdoc function
	         * @name getSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Returns all the selected rows
	         * @param {Grid} grid grid object
	         */
	        getSelectedRows: function (grid) {
	          return grid.rows.filter(function (row) {
	            return row.isSelected;
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name clearSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Clears all selected rows
	         * @param {Grid} grid grid object
	         * @param {Event} event object if raised from an event
	         */
	        clearSelectedRows: function (grid, evt) {
	          var changedRows = [];
	          service.getSelectedRows(grid).forEach(function (row) {
	            if ( row.isSelected ){
	              row.setSelected(false);
	              service.decideRaiseSelectionEvent( grid, row, changedRows, evt );
	            }
	          });
	          service.decideRaiseSelectionBatchEvent( grid, changedRows, evt );
	          grid.selection.selectAll = false;
	          grid.selection.selectedCount = 0;
	        },
	
	        /**
	         * @ngdoc function
	         * @name decideRaiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether to raise a single event or a batch event
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row that has changed
	         * @param {array} changedRows an array to which we can append the changed
	         * @param {Event} event object if raised from an event
	         * row if we're doing batch events
	         */
	        decideRaiseSelectionEvent: function( grid, row, changedRows, evt ){
	          if ( !grid.options.enableSelectionBatchEvent ){
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          } else {
	            changedRows.push(row);
	          }
	        },
	
	        /**
	         * @ngdoc function
	         * @name raiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether we need to raise a batch event, and
	         * raises it if we do.
	         * @param {Grid} grid grid object
	         * @param {array} changedRows an array of changed rows, only populated
	         * @param {Event} event object if raised from an event
	         * if we're doing batch events
	         */
	        decideRaiseSelectionBatchEvent: function( grid, changedRows, evt ){
	          if ( changedRows.length > 0 ){
	            grid.api.selection.raise.rowSelectionChangedBatch(changedRows, evt);
	          }
	        }
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridSelection
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds selection features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.selection']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-selection></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSelection', ['uiGridSelectionConstants', 'uiGridSelectionService', '$templateCache', 'uiGridConstants',
	    function (uiGridSelectionConstants, uiGridSelectionService, $templateCache, uiGridConstants) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridSelectionService.initializeGrid(uiGridCtrl.grid);
	              if (uiGridCtrl.grid.options.enableRowHeaderSelection) {
	                var selectionRowHeaderDef = {
	                  name: uiGridSelectionConstants.selectionRowHeaderColName,
	                  displayName: '',
	                  width:  uiGridCtrl.grid.options.selectionRowHeaderWidth,
	                  minWidth: 10,
	                  cellTemplate: 'ui-grid/selectionRowHeader',
	                  headerCellTemplate: 'ui-grid/selectionHeaderCell',
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  exporterSuppressExport: true,
	                  allowCellFocus: true
	                };
	
	                uiGridCtrl.grid.addRowHeaderColumn(selectionRowHeaderDef);
	              }
	
	              var processorSet = false;
	
	              var processSelectableRows = function( rows ){
	                rows.forEach(function(row){
	                  row.enableSelection = uiGridCtrl.grid.options.isRowSelectable(row);
	                });
	                return rows;
	              };
	
	              var updateOptions = function(){
	                if (uiGridCtrl.grid.options.isRowSelectable !== angular.noop && processorSet !== true) {
	                  uiGridCtrl.grid.registerRowsProcessor(processSelectableRows, 500);
	                  processorSet = true;
	                }
	              };
	
	              updateOptions();
	
	              var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback( updateOptions, [uiGridConstants.dataChange.OPTIONS] );
	
	              $scope.$on( '$destroy', dataChangeDereg);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionRowHeaderButtons', ['$templateCache', 'uiGridSelectionService', 'gridUtil',
	    function ($templateCache, uiGridSelectionService, gridUtil) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionRowHeaderButtons'),
	        scope: true,
	        require: '^uiGrid',
	        link: function($scope, $elm, $attrs, uiGridCtrl) {
	          var self = uiGridCtrl.grid;
	          $scope.selectButtonClick = selectButtonClick;
	
	          // On IE, prevent mousedowns on the select button from starting a selection.
	          //   If this is not done and you shift+click on another row, the browser will select a big chunk of text
	          if (gridUtil.detectBrowser() === 'ie') {
	            $elm.on('mousedown', selectButtonMouseDown);
	          }
	
	
	          function selectButtonClick(row, evt) {
	            evt.stopPropagation();
	
	            if (evt.shiftKey) {
	              uiGridSelectionService.shiftSelect(self, row, evt, self.options.multiSelect);
	            }
	            else if (evt.ctrlKey || evt.metaKey) {
	              uiGridSelectionService.toggleRowSelection(self, row, evt, self.options.multiSelect, self.options.noUnselect);
	            }
	            else {
	              uiGridSelectionService.toggleRowSelection(self, row, evt, (self.options.multiSelect && !self.options.modifierKeysToMultiSelect), self.options.noUnselect);
	            }
	          }
	
	          function selectButtonMouseDown(evt) {
	            if (evt.ctrlKey || evt.shiftKey) {
	              evt.target.onselectstart = function () { return false; };
	              window.setTimeout(function () { evt.target.onselectstart = null; }, 0);
	            }
	          }
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionSelectAllButtons', ['$templateCache', 'uiGridSelectionService',
	    function ($templateCache, uiGridSelectionService) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionSelectAllButtons'),
	        scope: false,
	        link: function($scope, $elm, $attrs, uiGridCtrl) {
	          var self = $scope.col.grid;
	
	          $scope.headerButtonClick = function(row, evt) {
	            if ( self.selection.selectAll ){
	              uiGridSelectionService.clearSelectedRows(self, evt);
	              if ( self.options.noUnselect ){
	                self.api.selection.selectRowByVisibleIndex(0, evt);
	              }
	              self.selection.selectAll = false;
	            } else {
	              if ( self.options.multiSelect ){
	                self.api.selection.selectAllVisibleRows(evt);
	                self.selection.selectAll = true;
	              }
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'uiGridConstants', 'uiGridSelectionConstants', 'gridUtil', '$parse', 'uiGridSelectionService',
	      function ($compile, uiGridConstants, uiGridSelectionConstants, gridUtil, $parse, uiGridSelectionService) {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	            var existingNgClass = rowRepeatDiv.attr("ng-class");
	            var newNgClass = '';
	            if ( existingNgClass ) {
	              newNgClass = existingNgClass.slice(0, -1) + ",'ui-grid-row-selected': row.isSelected}";
	            } else {
	              newNgClass = "{'ui-grid-row-selected': row.isSelected}";
	            }
	            rowRepeatDiv.attr("ng-class", newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide selection feature
	   */
	  module.directive('uiGridCell',
	    ['$compile', 'uiGridConstants', 'uiGridSelectionConstants', 'gridUtil', '$parse', 'uiGridSelectionService', '$timeout',
	      function ($compile, uiGridConstants, uiGridSelectionConstants, gridUtil, $parse, uiGridSelectionService, $timeout) {
	        return {
	          priority: -200, // run after default uiGridCell directive
	          restrict: 'A',
	          require: '?^uiGrid',
	          scope: false,
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            var touchStartTime = 0;
	            var touchTimeout = 300;
	
	            // Bind to keydown events in the render container
	            if (uiGridCtrl.grid.api.cellNav) {
	
	              uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                if (rowCol === null ||
	                  rowCol.row !== $scope.row ||
	                  rowCol.col !== $scope.col) {
	                  return;
	                }
	
	                if (evt.keyCode === 32 && $scope.col.colDef.name === "selectionRowHeaderCol") {
	                  uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect), $scope.grid.options.noUnselect);
	                  $scope.$apply();
	                }
	
	              //  uiGridCellNavService.scrollToIfNecessary(uiGridCtrl.grid, rowCol.row, rowCol.col);
	              });
	            }
	
	            //$elm.bind('keydown', function (evt) {
	            //  if (evt.keyCode === 32 && $scope.col.colDef.name === "selectionRowHeaderCol") {
	            //    uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect), $scope.grid.options.noUnselect);
	            //    $scope.$apply();
	            //  }
	            //});
	
	            var selectCells = function(evt){
	              // if we get a click, then stop listening for touchend
	              $elm.off('touchend', touchEnd);
	
	              if (evt.shiftKey) {
	                uiGridSelectionService.shiftSelect($scope.grid, $scope.row, evt, $scope.grid.options.multiSelect);
	              }
	              else if (evt.ctrlKey || evt.metaKey) {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, $scope.grid.options.multiSelect, $scope.grid.options.noUnselect);
	              }
	              else {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect), $scope.grid.options.noUnselect);
	              }
	              $scope.$apply();
	
	              // don't re-enable the touchend handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the mouse to the screen if you have both modes of input
	              $timeout(function() {
	                $elm.on('touchend', touchEnd);
	              }, touchTimeout);
	            };
	
	            var touchStart = function(evt){
	              touchStartTime = (new Date()).getTime();
	
	              // if we get a touch event, then stop listening for click
	              $elm.off('click', selectCells);
	            };
	
	            var touchEnd = function(evt) {
	              var touchEndTime = (new Date()).getTime();
	              var touchTime = touchEndTime - touchStartTime;
	
	              if (touchTime < touchTimeout ) {
	                // short touch
	                selectCells(evt);
	              }
	
	              // don't re-enable the click handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the screen to the mouse if you have both modes of input
	              $timeout(function() {
	                $elm.on('click', selectCells);
	              }, touchTimeout);
	            };
	
	            function registerRowSelectionEvents() {
	              if ($scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection) {
	                $elm.addClass('ui-grid-disable-selection');
	                $elm.on('touchstart', touchStart);
	                $elm.on('touchend', touchEnd);
	                $elm.on('click', selectCells);
	
	                $scope.registered = true;
	              }
	            }
	
	            function deregisterRowSelectionEvents() {
	              if ($scope.registered){
	                $elm.removeClass('ui-grid-disable-selection');
	
	                $elm.off('touchstart', touchStart);
	                $elm.off('touchend', touchEnd);
	                $elm.off('click', selectCells);
	
	                $scope.registered = false;
	              }
	            }
	
	            registerRowSelectionEvents();
	            // register a dataChange callback so that we can change the selection configuration dynamically
	            // if the user changes the options
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( function() {
	              if ( $scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection &&
	                !$scope.registered ){
	                registerRowSelectionEvents();
	              } else if ( ( !$scope.grid.options.enableRowSelection || !$scope.grid.options.enableFullRowSelection ) &&
	                $scope.registered ){
	                deregisterRowSelectionEvents();
	              }
	            }, [uiGridConstants.dataChange.OPTIONS] );
	
	            $elm.on( '$destroy', dataChangeDereg);
	          }
	        };
	      }]);
	
	  module.directive('uiGridGridFooter', ['$compile', 'uiGridConstants', 'gridUtil', function ($compile, uiGridConstants, gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      priority: -1000,
	      require: '^uiGrid',
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            if (!uiGridCtrl.grid.options.showGridFooter) {
	              return;
	            }
	
	
	            gridUtil.getTemplate('ui-grid/gridFooterSelectedItems')
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	
	                angular.element($elm[0].getElementsByClassName('ui-grid-grid-footer')[0]).append(newElm);
	              });
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeBase
	   * @description
	   *
	   * # ui.grid.treeBase
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides base tree handling functions that are shared by other features, notably grouping
	   * and treeView.  It provides a tree view of the data, with nodes in that
	   * tree and leaves.
	   *
	   * Design information:
	   * -------------------
	   *
	   * The raw data that is provided must come with a $$treeLevel on any non-leaf node.  Grouping will create
	   * these on all the group header rows, treeView will expect these to be set in the raw data by the user.
	   * TreeBase will run a rowsProcessor that:
	   *  - builds `treeBase.tree` out of the provided rows
	   *  - permits a recursive sort of the tree
	   *  - maintains the expand/collapse state of each node
	   *  - provides the expand/collapse all button and the expand/collapse buttons
	   *  - maintains the count of children for each node
	   *
	   * Each row is updated with a link to the tree node that represents it.  Refer {@link ui.grid.treeBase.grid:treeBase.tree tree documentation}
	   * for information.
	   *
	   *  TreeBase adds information to the rows
	   *  - treeLevel: if present and > -1 tells us the level (level 0 is the top level)
	   *  - treeNode: pointer to the node in the grid.treeBase.tree that refers
	   *    to this row, allowing us to manipulate the state
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  We recall the expanded state
	   * across invocations of the rowsProcessors by the reference to the treeNode on the individual
	   * rows.  We rebuild the tree itself quite frequently, when we do this we use the saved treeNodes to
	   * get the state, but we overwrite the other data in that treeNode.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * We rely on the rowsProcessors to do the actual expanding and collapsing, so we set the flags we want into
	   * grid.treeBase.tree, then call refresh.  This is because we can't easily change the visible
	   * row cache without calling the processors, and once we've built the logic into the rowProcessors we may as
	   * well use it all the time.
	   *
	   * Tree base provides sorting (on non-grouped columns).
	   *
	   * Sorting works in two passes.  The standard sorting is performed for any columns that are important to building
	   * the tree (for example, any grouped columns).  Then after the tree is built, a recursive tree sort is performed
	   * for the remaining sort columns (including the original sort) - these columns are sorted within each tree level
	   * (so all the level 1 nodes are sorted, then all the level 2 nodes within each level 1 node etc).
	   *
	   * To achieve this we make use of the `ignoreSort` property on the sort configuration.  The parent feature (treeView or grouping)
	   * must provide a rowsProcessor that runs with very low priority (typically in the 60-65 range), and that sets
	   * the `ignoreSort`on any sort that it wants to run on the tree.  TreeBase will clear the ignoreSort on all sorts - so it
	   * will turn on any sorts that haven't run.  It will then call a recursive sort on the tree.
	   *
	   * Tree base provides treeAggregation.  It checks the treeAggregation configuration on each column, and aggregates based on
	   * the logic provided as it builds the tree. Footer aggregation from the uiGrid core should not be used with treeBase aggregation,
	   * since it operates on all visible rows, as opposed to to leaf nodes only. Setting `showColumnFooter: true` will show the
	   * treeAggregations in the column footer.  Aggregation information will be collected in the format:
	   *
	   * ```
	   *   {
	   *     type: 'count',
	   *     value: 4,
	   *     label: 'count: ',
	   *     rendered: 'count: 4'
	   *   }
	   * ```
	   *
	   * A callback is provided to format the value once it is finalised (aka a valueFilter).
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeBase"></div>
	   */
	
	  var module = angular.module('ui.grid.treeBase', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.constant:uiGridTreeBaseConstants
	   *
	   *  @description constants available in treeBase module.
	   *
	   *  These constants are manually copied into grouping and treeView,
	   *  as I haven't found a way to simply include them, and it's not worth
	   *  investing time in for something that changes very infrequently.
	   *
	   */
	  module.constant('uiGridTreeBaseConstants', {
	    featureName: "treeBase",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeBase.service:uiGridTreeBaseService
	   *
	   *  @description Services for treeBase feature
	   */
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.api:ColumnDef
	   *
	   *  @description ColumnDef for tree feature, these are available to be
	   *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	   */
	
	  module.service('uiGridTreeBaseService', ['$q', 'uiGridTreeBaseConstants', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'rowSorter',
	  function ($q, uiGridTreeBaseConstants, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants, rowSorter) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	
	        //add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.grid:treeBase
	         *
	         *  @description Grid properties and functions added for treeBase
	         */
	        grid.treeBase = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name numberLevels
	         *
	         *  @description Total number of tree levels currently used, calculated by the rowsProcessor by
	         *  retaining the highest tree level it sees
	         */
	        grid.treeBase.numberLevels = 0;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name expandAll
	         *
	         *  @description Whether or not the expandAll box is selected
	         */
	        grid.treeBase.expandAll = false;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name tree
	         *
	         *  @description Tree represented as a nested array that holds the state of each node, along with a
	         *  pointer to the row.  The array order is material - we will display the children in the order
	         *  they are stored in the array
	         *
	         *  Each node stores:
	         *
	         *    - the state of this node
	         *    - an array of children of this node
	         *    - a pointer to the parent of this node (reverse pointer, allowing us to walk up the tree)
	         *    - the number of children of this node
	         *    - aggregation information calculated from the nodes
	         *
	         *  ```
	         *    [{
	         *      state: 'expanded',
	         *      row: <reference to row>,
	         *      parentRow: null,
	         *      aggregations: [{
	         *        type: 'count',
	         *        col: <gridCol>,
	         *        value: 2,
	         *        label: 'count: ',
	         *        rendered: 'count: 2'
	         *      }],
	         *      children: [
	         *        {
	         *          state: 'expanded',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: '<gridCol>,
	         *            value: 4,
	         *            label: 'count: ',
	         *            rendered: 'count: 4'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        },
	         *        {
	         *          state: 'collapsed',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: <gridCol>,
	         *            value: 3,
	         *            label: 'count: ',
	         *            rendered: 'count: 3'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        }
	         *      ]
	         *    }, {<another level 0 node maybe>} ]
	         *  ```
	         *  Missing state values are false - meaning they aren't expanded.
	         *
	         *  This is used because the rowProcessors run every time the grid is refreshed, so
	         *  we'd lose the expanded state every time the grid was refreshed.  This instead gives
	         *  us a reliable lookup that persists across rowProcessors.
	         *
	         *  This tree is rebuilt every time we run the rowsProcessors.  Since each row holds a pointer
	         *  to it's tree node we can persist expand/collapse state across calls to rowsProcessor, we discard
	         *  all transient information on the tree (children, childCount) and recalculate it
	         *
	         */
	        grid.treeBase.tree = {};
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.treeRows, 410);
	
	        grid.registerColumnBuilder( service.treeBaseColumnBuilder );
	
	        service.createRowHeader( grid );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:PublicApi
	         *
	         *  @description Public Api for treeBase feature
	         */
	        var publicApi = {
	          events: {
	            treeBase: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowExpanded
	               * @description raised whenever a row is expanded.  If you are dynamically
	               * rendering your tree you can listen to this event, and then retrieve
	               * the children of this row and load them into the grid data.
	               *
	               * When the data is loaded the grid will automatically refresh to show these new rows
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowExpanded(scope,function(row){})
	               * </pre>
	               * @param {gridRow} row the row that was expanded.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowExpanded: {},
	
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowCollapsed
	               * @description raised whenever a row is collapsed.  Doesn't really have
	               * a purpose at the moment, included for symmetry
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowCollapsed(scope,function(row){})
	               * </pre>
	               * @param {gridRow} row the row that was collapsed.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowCollapsed: {}
	            }
	          },
	
	          methods: {
	            treeBase: {
	              /**
	               * @ngdoc function
	               * @name expandAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Expands all tree rows
	               */
	              expandAllRows: function () {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all tree rows
	               */
	              collapseAllRows: function () {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name toggleRowTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description  call expand if the row is collapsed, collapse if it is expanded
	               * @param {gridRow} row the row you wish to toggle
	               */
	              toggleRowTreeState: function (row) {
	                service.toggleRowTreeState(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand the immediate children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               */
	              expandRow: function (row) {
	                service.expandRow(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand all children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               */
	              expandRowChildren: function (row) {
	                service.expandRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse  the specified row.  When
	               * you expand the row again, all grandchildren will retain their state
	               * @param {gridRow} row the row you wish to collapse
	               */
	              collapseRow: function ( row ) {
	                service.collapseRow(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all children of the specified row.  When
	               * you expand the row again, all grandchildren will be collapsed
	               * @param {gridRow} row the row you wish to collapse children for
	               */
	              collapseRowChildren: function ( row ) {
	                service.collapseRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name getTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the tree state for this grid,
	               * used by the saveState feature
	               * Returned treeState as an object
	               *   `{ expandedState: { uid: 'expanded', uid: 'collapsed' } }`
	               * where expandedState is a hash of row uid and the current expanded state
	               *
	               * @returns {object} tree state
	               *
	               * TODO - this needs work - we need an identifier that persists across instantiations,
	               * not uid.  This really means we need a row identity defined, but that won't work for
	               * grouping.  Perhaps this needs to be moved up to treeView and grouping, rather than
	               * being in base.
	               */
	              getTreeExpandedState: function () {
	                return { expandedState: service.getTreeState(grid) };
	              },
	
	              /**
	               * @ngdoc function
	               * @name setTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Set the expanded states of the tree
	               * @param {object} config the config you want to apply, in the format
	               * provided by getTreeState
	               */
	              setTreeState: function ( config ) {
	                service.setTreeState( grid, config );
	              },
	
	              /**
	               * @ngdoc function
	               * @name getRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the children of the specified row
	               * @param {GridRow} row the row you want the children of
	               * @returns {Array} array of children of this row, the children
	               * are all gridRows
	               */
	              getRowChildren: function ( row ){
	                return row.treeNode.children.map( function( childNode ){
	                  return childNode.row;
	                });
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:GridOptions
	         *
	         *  @description GridOptions for treeBase feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderBaseWidth
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Base width of the tree header, provides for a single level of tree.  This
	         *  is incremented by `treeIndent` for each extra level
	         *  <br/>Defaults to 30
	         */
	        gridOptions.treeRowHeaderBaseWidth = gridOptions.treeRowHeaderBaseWidth || 30;
	
	        /**
	         *  @ngdoc object
	         *  @name treeIndent
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Number of pixels of indent for the icon at each tree level, wider indents are visually more pleasing,
	         *  but will make the tree row header wider
	         *  <br/>Defaults to 10
	         */
	        gridOptions.treeIndent = gridOptions.treeIndent || 10;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeRowHeader
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to false, don't create the row header.  Youll need to programatically control the expand
	         *  states
	         *  <br/>Defaults to true
	         */
	        gridOptions.showTreeRowHeader = gridOptions.showTreeRowHeader !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeExpandNoChildren
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, show the expand/collapse button even if there are no
	         *  children of a node.  You'd use this if you're planning to dynamically load the children
	         *
	         *  <br/>Defaults to true, grouping overrides to false
	         */
	        gridOptions.showTreeExpandNoChildren = gridOptions.showTreeExpandNoChildren !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderAlwaysVisible
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, row header even if there are no tree nodes
	         *
	         *  <br/>Defaults to true
	         */
	        gridOptions.treeRowHeaderAlwaysVisible = gridOptions.treeRowHeaderAlwaysVisible !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeCustomAggregations
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Define custom aggregation functions. The properties of this object will be
	         *  aggregation types available for use on columnDef with {@link ui.grid.treeBase.api:ColumnDef treeAggregationType} or through the column menu.
	         *  If a function defined here uses the same name as one of the native aggregations, this one will take precedence.
	         *  The object format is:
	         *
	         *  <pre>
	         *    {
	         *      aggregationName: {
	         *        label: (optional) string,
	         *        aggregationFn: function( aggregation, fieldValue, numValue, row ){...},
	         *        finalizerFn: (optional) function( aggregation ){...}
	       *        },
	         *      mean: {
	         *        label: 'mean',
	         *        aggregationFn: function( aggregation, fieldValue, numValue ){
	       *            aggregation.count = (aggregation.count || 1) + 1;
	         *          aggregation.sum = (aggregation.sum || 0) + numValue;
	         *        },
	         *        finalizerFn: function( aggregation ){
	         *          aggregation.value = aggregation.sum / aggregation.count
	         *        }
	         *      }
	         *    }
	         *  </pre>
	         *
	         *  <br/>The `finalizerFn` may be used to manipulate the value before rendering, or to
	         *  apply a custom rendered value. If `aggregation.rendered` is left undefined, the value will be
	         *  rendered. Note that the native aggregation functions use an `finalizerFn` to concatenate
	         *  the label and the value.
	         *
	         *  <br/>Defaults to {}
	         */
	        gridOptions.treeCustomAggregations = gridOptions.treeCustomAggregations || {};
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeBaseColumnBuilder
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Sets the tree defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridCol} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      treeBaseColumnBuilder: function (colDef, col, gridOptions) {
	
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that aggregates rows into some form of
	         *  total.  Aggregations run row-by-row, the function needs to be capable of
	         *  creating a running total.
	         *
	         *  The function will be provided the aggregation item (in which you can store running
	         *  totals), the row value that is to be aggregated, and that same row value converted to
	         *  a number (most aggregations work on numbers)
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFn = function ( aggregation, fieldValue, numValue, row ){
	         *      // calculates the average of the squares of the values
	         *      if ( typeof(aggregation.count) === 'undefined' ){
	         *        aggregation.count = 0;
	         *      }
	         *      aggregation.count++;
	         *
	         *      if ( !isNaN(numValue) ){
	         *        if ( typeof(aggregation.total) === 'undefined' ){
	         *          aggregation.total = 0;
	         *        }
	         *        aggregation.total = aggregation.total + numValue * numValue;
	         *      }
	         *
	         *      aggregation.value = aggregation.total / aggregation.count;
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined. May be overwritten by treeAggregationType, the two options should not be used together.
	         */
	        if ( typeof(colDef.customTreeAggregationFn) !== 'undefined' ){
	          col.treeAggregationFn = colDef.customTreeAggregationFn;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationType
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Use one of the native or grid-level aggregation methods for calculating aggregations on this column.
	         *  Native method are in the constants file and include: SUM, COUNT, MIN, MAX, AVG. This may also be the property the
	         *  name of an aggregation function defined with {@link ui.grid.treeBase.api:GridOptions treeCustomAggregations}.
	         *
	         *  <pre>
	         *      treeAggregationType = uiGridTreeBaseConstants.aggregation.SUM,
	         *    }
	         *  </pre>
	         *
	         *  If you are using aggregations you should either:
	         *
	         *   - also use grouping, in which case the aggregations are displayed in the group header, OR
	         *   - use treeView, in which case you can set `treeAggregationUpdateEntity: true` in the colDef, and
	         *     treeBase will store the aggregation information in the entity, or you can set `treeAggregationUpdateEntity: false`
	         *     in the colDef, and you need to manual retrieve the calculated aggregations from the row.treeNode.aggregations
	         *
	         *  <br/>Takes precendence over a treeAggregationFn, the two options should not be used together.
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(colDef.treeAggregationType) !== 'undefined' ){
	          col.treeAggregation = { type: colDef.treeAggregationType };
	          if ( typeof(gridOptions.treeCustomAggregations[colDef.treeAggregationType]) !== 'undefined' ){
	            col.treeAggregationFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregationFinalizerFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].finalizerFn;
	            col.treeAggregation.label = gridOptions.treeCustomAggregations[colDef.treeAggregationType].label;
	          } else if ( typeof(service.nativeAggregations()[colDef.treeAggregationType]) !== 'undefined' ){
	            col.treeAggregationFn = service.nativeAggregations()[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregation.label = service.nativeAggregations()[colDef.treeAggregationType].label;
	          }
	        }
	
	         /**
	         *  @ngdoc object
	         *  @name treeAggregationLabel
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom label to use for this aggregation. If provided we don't use native i18n.
	         */
	        if ( typeof(colDef.treeAggregationLabel) !== 'undefined' ){
	          if (typeof(col.treeAggregation) === 'undefined' ){
	            col.treeAggregation = {};
	          }
	          col.treeAggregation.label = colDef.treeAggregationLabel;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationUpdateEntity
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Store calculated aggregations into the entity, allowing them
	         *  to be displayed in the grid using a standard cellTemplate.  This defaults to true,
	         *  if you are using grouping then you shouldn't set it to false, as then the aggregations won't
	         *  display.
	         *
	         *  If you are using treeView in most cases you'll want to set this to true.  This will result in
	         *  getCellValue returning the aggregation rather than whatever was stored in the cell attribute on
	         *  the entity.  If you want to render the underlying entity value (and do something else with the aggregation)
	         *  then you could use a custom cellTemplate to display `row.entity.myAttribute`, rather than using getCellValue.
	         *
	         *  <br/>Defaults to true
	         *
	         *  @example
	         *  <pre>
	         *    gridOptions.columns = [{
	         *      name: 'myCol',
	         *      treeAggregation: { type: uiGridTreeBaseConstants.aggregation.SUM },
	         *      treeAggregationUpdateEntity: true
	         *      cellTemplate: '<div>{{row.entity.myCol + " " + row.treeNode.aggregations[0].rendered}}</div>'
	         *    }];
	         * </pre>
	         */
	        col.treeAggregationUpdateEntity = colDef.treeAggregationUpdateEntity !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFinalizerFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that populates aggregation.rendered, this is called when
	         *  a particular aggregation has been fully calculated, and we want to render the value.
	         *
	         *  With the native aggregation options we just concatenate `aggregation.label` and
	         *  `aggregation.value`, but if you wanted to apply a filter or otherwise manipulate the label
	         *  or the value, you can do so with this function. This function will be called after the
	         *  the default `finalizerFn`.
	         *
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFinalizerFn = function ( aggregation ){
	         *      aggregation.rendered = aggregation.label + aggregation.value / 100 + '%';
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(col.customTreeAggregationFinalizerFn) === 'undefined' ){
	          col.customTreeAggregationFinalizerFn = colDef.customTreeAggregationFinalizerFn;
	        }
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createRowHeader
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Create the rowHeader.  If treeRowHeaderAlwaysVisible then
	       * set it to visible, otherwise set it to invisible
	       *
	       * @param {Grid} grid grid object
	       */
	      createRowHeader: function( grid ){
	        var rowHeaderColumnDef = {
	          name: uiGridTreeBaseConstants.rowHeaderColName,
	          displayName: '',
	          width:  grid.options.treeRowHeaderBaseWidth,
	          minWidth: 10,
	          cellTemplate: 'ui-grid/treeBaseRowHeader',
	          headerCellTemplate: 'ui-grid/treeBaseHeaderCell',
	          enableColumnResizing: false,
	          enableColumnMenu: false,
	          exporterSuppressExport: true,
	          allowCellFocus: true
	        };
	
	        rowHeaderColumnDef.visible = grid.options.treeRowHeaderAlwaysVisible;
	        grid.addRowHeaderColumn( rowHeaderColumnDef );
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      expandAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.EXPANDED);
	        });
	        grid.treeBase.expandAll = true;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      collapseAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.COLLAPSED);
	        });
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setAllNodes
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Works through a subset of grid.treeBase.rowExpandedStates, setting
	       * all child nodes (and their descendents) of the provided node to the given state.
	       *
	       * Calls itself recursively on all nodes so as to achieve this.
	       *
	       * @param {Grid} grid the grid we're operating on (so we can raise events)
	       * @param {object} treeNode a node in the tree that we want to update
	       * @param {string} targetState the state we want to set it to
	       */
	      setAllNodes: function (grid, treeNode, targetState) {
	        if ( typeof(treeNode.state) !== 'undefined' && treeNode.state !== targetState ){
	          treeNode.state = targetState;
	
	          if ( targetState === uiGridTreeBaseConstants.EXPANDED ){
	            grid.api.treeBase.raise.rowExpanded(treeNode.row);
	          } else {
	            grid.api.treeBase.raise.rowCollapsed(treeNode.row);
	          }
	        }
	
	        // set all child nodes
	        if ( treeNode.children ){
	          treeNode.children.forEach(function( childNode ){
	            service.setAllNodes(grid, childNode, targetState);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name toggleRowTreeState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Toggles the expand or collapse state of this grouped row, if
	       * it's a parent row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to toggle
	       */
	      toggleRowTreeState: function ( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        if (row.treeNode.state === uiGridTreeBaseConstants.EXPANDED){
	          service.collapseRow(grid, row);
	        } else {
	          service.expandRow(grid, row);
	        }
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing only immediate children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       */
	      expandRow: function ( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        if ( row.treeNode.state !== uiGridTreeBaseConstants.EXPANDED ){
	          row.treeNode.state = uiGridTreeBaseConstants.EXPANDED;
	          grid.api.treeBase.raise.rowExpanded(row);
	          grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing all children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       */
	      expandRowChildren: function ( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.EXPANDED);
	        grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRow: function( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        if ( row.treeNode.state !== uiGridTreeBaseConstants.COLLAPSED ){
	          row.treeNode.state = uiGridTreeBaseConstants.COLLAPSED;
	          grid.treeBase.expandAll = false;
	          grid.api.treeBase.raise.rowCollapsed(row);
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row and all children
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRowChildren: function( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.COLLAPSED);
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name allExpanded
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Returns true if all rows are expanded, false
	       * if they're not.  Walks the tree to determine this.  Used
	       * to set the expandAll state.
	       *
	       * If the node has no children, then return true (it's immaterial
	       * whether it is expanded).  If the node has children, then return
	       * false if this node is collapsed, or if any child node is not all expanded
	       *
	       * @param {object} tree the grid to check
	       * @returns {boolean} whether or not the tree is all expanded
	       */
	      allExpanded: function( tree ){
	        var allExpanded = true;
	        tree.forEach( function( node ){
	          if ( !service.allExpandedInternal( node ) ){
	            allExpanded = false;
	          }
	        });
	        return allExpanded;
	      },
	
	      allExpandedInternal: function( treeNode ){
	        if ( treeNode.children && treeNode.children.length > 0 ){
	          if ( treeNode.state === uiGridTreeBaseConstants.COLLAPSED ){
	            return false;
	          }
	          var allExpanded = true;
	          treeNode.children.forEach( function( node ){
	            if ( !service.allExpandedInternal( node ) ){
	              allExpanded = false;
	            }
	          });
	          return allExpanded;
	        } else {
	          return true;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description The rowProcessor that adds the nodes to the tree, and sets the visible
	       * state of each row based on it's parent state
	       *
	       * Assumes it is always called after the sorting processor, and the grouping processor if there is one.
	       * Performs any tree sorts itself after having built the tree
	       *
	       * Processes all the rows in order, setting the group level based on the $$treeLevel in the associated
	       * entity, and setting the visible state based on the parent's state.
	       *
	       * Calculates the deepest level of tree whilst it goes, and updates that so that the header column can be correctly
	       * sized.
	       *
	       * Aggregates if necessary along the way.
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows
	       */
	      treeRows: function( renderableRows ) {
	        if (renderableRows.length === 0){
	          return renderableRows;
	        }
	
	        var grid = this;
	        var currentLevel = 0;
	        var currentState = uiGridTreeBaseConstants.EXPANDED;
	        var parents = [];
	
	        grid.treeBase.tree = service.createTree( grid, renderableRows );
	        service.updateRowHeaderWidth( grid );
	
	        service.sortTree( grid );
	        service.fixFilter( grid );
	
	        return service.renderTree( grid.treeBase.tree );
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createOrUpdateRowHeaderWidth
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Calculates the rowHeader width.
	       *
	       * If rowHeader is always present, updates the width.
	       *
	       * If rowHeader is only sometimes present (`treeRowHeaderAlwaysVisible: false`), determines whether there
	       * should be one, then creates or removes it as appropriate, with the created rowHeader having the
	       * right width.
	       *
	       * If there's never a rowHeader then never creates one: `showTreeRowHeader: false`
	       *
	       * @param {Grid} grid the grid we want to set the row header on
	       */
	      updateRowHeaderWidth: function( grid ){
	        var rowHeader = grid.getColumn(uiGridTreeBaseConstants.rowHeaderColName);
	
	        var newWidth = grid.options.treeRowHeaderBaseWidth + grid.options.treeIndent * Math.max(grid.treeBase.numberLevels - 1, 0);
	        if ( rowHeader && newWidth !== rowHeader.width ){
	          rowHeader.width = newWidth;
	          grid.queueRefresh();
	        }
	
	        var newVisibility = true;
	        if ( grid.options.showTreeRowHeader === false ){
	          newVisibility = false;
	        }
	        if ( grid.options.treeRowHeaderAlwaysVisible === false && grid.treeBase.numberLevels <= 0 ){
	          newVisibility = false;
	        }
	        if ( rowHeader.visible !== newVisibility ) {
	          rowHeader.visible = newVisibility;
	          rowHeader.colDef.visible = newVisibility;
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name renderTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates an array of rows based on the tree, exporting only
	       * the visible nodes and leaves
	       *
	       * @param {array} nodeList the list of nodes - can be grid.treeBase.tree, or can be node.children when
	       * we're calling recursively
	       * @returns {array} renderable rows
	       */
	      renderTree: function( nodeList ){
	        var renderableRows = [];
	
	        nodeList.forEach( function ( node ){
	          if ( node.row.visible ){
	            renderableRows.push( node.row );
	          }
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ){
	            renderableRows = renderableRows.concat( service.renderTree( node.children ) );
	          }
	        });
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree from the renderableRows
	       *
	       * @param {Grid} grid the grid
	       * @param {array} renderableRows the rows we want to create a tree from
	       * @returns {object} the tree we've build
	       */
	      createTree: function( grid, renderableRows ) {
	        var currentLevel = -1;
	        var parents = [];
	        var currentState;
	        grid.treeBase.tree = [];
	        grid.treeBase.numberLevels = 0;
	        var aggregations = service.getAggregations( grid );
	
	        var createNode = function( row ){
	          if ( typeof(row.entity.$$treeLevel) !== 'undefined' && row.treeLevel !== row.entity.$$treeLevel ){
	            row.treeLevel = row.entity.$$treeLevel;
	          }
	
	          if ( row.treeLevel <= currentLevel ){
	            // pop any levels that aren't parents of this level, formatting the aggregation at the same time
	            while ( row.treeLevel <= currentLevel ){
	              var lastParent = parents.pop();
	              service.finaliseAggregations( lastParent );
	              currentLevel--;
	            }
	
	            // reset our current state based on the new parent, set to expanded if this is a level 0 node
	            if ( parents.length > 0 ){
	              currentState = service.setCurrentState(parents);
	            } else {
	              currentState = uiGridTreeBaseConstants.EXPANDED;
	            }
	          }
	
	          // aggregate if this is a leaf node
	          if ( ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) && row.visible  ){
	            service.aggregate( grid, row, parents );
	          }
	
	          // add this node to the tree
	          service.addOrUseNode(grid, row, parents, aggregations);
	
	          if ( typeof(row.treeLevel) !== 'undefined' && row.treeLevel !== null && row.treeLevel >= 0 ){
	            parents.push(row);
	            currentLevel++;
	            currentState = service.setCurrentState(parents);
	          }
	
	          // update the tree number of levels, so we can set header width if we need to
	          if ( grid.treeBase.numberLevels < row.treeLevel + 1){
	            grid.treeBase.numberLevels = row.treeLevel + 1;
	          }
	        };
	
	        renderableRows.forEach( createNode );
	
	        // finalise remaining aggregations
	        while ( parents.length > 0 ){
	          var lastParent = parents.pop();
	          service.finaliseAggregations( lastParent );
	        }
	
	        return grid.treeBase.tree;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name addOrUseNode
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree node for this row.  If this row already has a treeNode
	       * recorded against it, preserves the state, but otherwise overwrites the data.
	       *
	       * @param {grid} grid the grid we're operating on
	       * @param {gridRow} row the row we want to set
	       * @param {array} parents an array of the parents this row should have
	       * @param {array} aggregationBase empty aggregation information
	       * @returns {undefined} updates the parents array, updates the row to have a treeNode, and updates the
	       * grid.treeBase.tree
	       */
	      addOrUseNode: function( grid, row, parents, aggregationBase ){
	        var newAggregations = [];
	        aggregationBase.forEach( function(aggregation){
	          newAggregations.push(service.buildAggregationObject(aggregation.col));
	        });
	
	        var newNode = { state: uiGridTreeBaseConstants.COLLAPSED, row: row, parentRow: null, aggregations: newAggregations, children: [] };
	        if ( row.treeNode ){
	          newNode.state = row.treeNode.state;
	        }
	        if ( parents.length > 0 ){
	          newNode.parentRow = parents[parents.length - 1];
	        }
	        row.treeNode = newNode;
	
	        if ( parents.length === 0 ){
	          grid.treeBase.tree.push( newNode );
	        } else {
	          parents[parents.length - 1].treeNode.children.push( newNode );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setCurrentState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks at the parents array to determine our current state.
	       * If any node in the hierarchy is collapsed, then return collapsed, otherwise return
	       * expanded.
	       *
	       * @param {array} parents an array of the parents this row should have
	       * @returns {string} the state we should be setting to any nodes we see
	       */
	      setCurrentState: function( parents ){
	        var currentState = uiGridTreeBaseConstants.EXPANDED;
	        parents.forEach( function(parent){
	          if ( parent.treeNode.state === uiGridTreeBaseConstants.COLLAPSED ){
	            currentState = uiGridTreeBaseConstants.COLLAPSED;
	          }
	        });
	        return currentState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name sortTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Performs a recursive sort on the tree nodes, sorting the
	       * children of each node and putting them back into the children array.
	       *
	       * Before doing this it turns back on all the sortIgnore - things that were previously
	       * ignored we process now.  Since we're sorting within the nodes, presumably anything
	       * that was already sorted is how we derived the nodes, we can keep those sorts too.
	       *
	       * We only sort tree nodes that are expanded - no point in wasting effort sorting collapsed
	       * nodes
	       *
	       * @param {Grid} grid the grid to get the aggregation information from
	       * @returns {array} the aggregation information
	       */
	      sortTree: function( grid ){
	        grid.columns.forEach( function( column ) {
	          if ( column.sort && column.sort.ignoreSort ){
	            delete column.sort.ignoreSort;
	          }
	        });
	
	        grid.treeBase.tree = service.sortInternal( grid, grid.treeBase.tree );
	      },
	
	      sortInternal: function( grid, treeList ){
	        var rows = treeList.map( function( node ){
	          return node.row;
	        });
	
	        rows = rowSorter.sort( grid, rows, grid.columns );
	
	        var treeNodes = rows.map( function( row ){
	          return row.treeNode;
	        });
	
	        treeNodes.forEach( function( node ){
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ){
	            node.children = service.sortInternal( grid, node.children );
	          }
	        });
	
	        return treeNodes;
	      },
	
	      /**
	       * @ngdoc function
	       * @name fixFilter
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description After filtering has run, we need to go back through the tree
	       * and make sure the parent rows are always visible if any of the child rows
	       * are visible (filtering may make a child visible, but the parent may not
	       * match the filter criteria)
	       *
	       * This has a risk of being computationally expensive, we do it by walking
	       * the tree and remembering whether there are any invisible nodes on the
	       * way down.
	       *
	       * @param {Grid} grid the grid to fix filters on
	       */
	      fixFilter: function( grid ){
	        var parentsVisible;
	
	        grid.treeBase.tree.forEach( function( node ){
	          if ( node.children && node.children.length > 0 ){
	            parentsVisible = node.row.visible;
	            service.fixFilterInternal( node.children, parentsVisible );
	          }
	        });
	      },
	
	      fixFilterInternal: function( nodes, parentsVisible) {
	        nodes.forEach( function( node ){
	          if ( node.row.visible && !parentsVisible ){
	            service.setParentsVisible( node );
	            parentsVisible = true;
	          }
	
	          if ( node.children && node.children.length > 0 ){
	            if ( service.fixFilterInternal( node.children, ( parentsVisible && node.row.visible ) ) ) {
	              parentsVisible = true;
	            }
	          }
	        });
	
	        return parentsVisible;
	      },
	
	      setParentsVisible: function( node ){
	        while ( node.parentRow ){
	          node.parentRow.visible = true;
	          node = node.parentRow.treeNode;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name buildAggregationObject
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Build the object which is stored on the column for holding meta-data about the aggregation.
	       * This method should only be called with columns which have an aggregation.
	       *
	       * @param {Column} the column which this object relates to
	       * @returns {object} {col: Column object, label: string, type: string (optional)}
	       */
	      buildAggregationObject: function( column ){
	        var newAggregation = { col: column };
	
	        if ( column.treeAggregation && column.treeAggregation.type ){
	          newAggregation.type = column.treeAggregation.type;
	        }
	
	        if ( column.treeAggregation && column.treeAggregation.label ){
	          newAggregation.label = column.treeAggregation.label;
	        }
	
	        return newAggregation;
	      },
	
	      /**
	       * @ngdoc function
	       * @name getAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks through the grid columns to find those with aggregations,
	       * and collates the aggregation information into an array, returns that array
	       *
	       * @param {Grid} grid the grid to get the aggregation information from
	       * @returns {array} the aggregation information
	       */
	      getAggregations: function( grid ){
	        var aggregateArray = [];
	
	        grid.columns.forEach( function(column){
	          if ( typeof(column.treeAggregationFn) !== 'undefined' ){
	            aggregateArray.push( service.buildAggregationObject(column) );
	
	            if ( grid.options.showColumnFooter && typeof(column.colDef.aggregationType) === 'undefined' && column.treeAggregation ){
	              // Add aggregation object for footer
	              column.treeFooterAggregation = service.buildAggregationObject(column);
	              column.aggregationType = service.treeFooterAggregationType;
	            }
	          }
	        });
	        return aggregateArray;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name aggregate
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Accumulate the data from this row onto the aggregations for each parent
	       *
	       * Iterate over the parents, then iterate over the aggregations for each of those parents,
	       * and perform the aggregation for each individual aggregation
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to set grouping visibility on
	       * @param {array} parents the parents that we would want to aggregate onto
	       */
	      aggregate: function( grid, row, parents ){
	        if ( parents.length === 0 && row.treeNode && row.treeNode.aggregations ){
	          row.treeNode.aggregations.forEach(function(aggregation){
	            // Calculate aggregations for footer even if there are no grouped rows
	            if ( typeof(aggregation.col.treeFooterAggregation) !== 'undefined' ) {
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	            }
	          });
	        }
	
	        parents.forEach( function( parent, index ){
	          if ( parent.treeNode.aggregations ){
	            parent.treeNode.aggregations.forEach( function( aggregation ){
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              aggregation.col.treeAggregationFn(aggregation, fieldValue, numValue, row);
	
	              if ( index === 0 && typeof(aggregation.col.treeFooterAggregation) !== 'undefined' ){
	                aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	              }
	            });
	          }
	        });
	      },
	
	
	      // Aggregation routines - no doco needed as self evident
	      nativeAggregations: function() {
	        var nativeAggregations = {
	          count: {
	            label: i18nService.get().aggregation.count,
	            menuTitle: i18nService.get().grouping.aggregate_count,
	            aggregationFn: function (aggregation, fieldValue, numValue) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = 1;
	              } else {
	                aggregation.value++;
	              }
	            }
	          },
	
	          sum: {
	            label: i18nService.get().aggregation.sum,
	            menuTitle: i18nService.get().grouping.aggregate_sum,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (!isNaN(numValue)) {
	                if (typeof(aggregation.value) === 'undefined') {
	                  aggregation.value = numValue;
	                } else {
	                  aggregation.value += numValue;
	                }
	              }
	            }
	          },
	
	          min: {
	            label: i18nService.get().aggregation.min,
	            menuTitle: i18nService.get().grouping.aggregate_min,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = fieldValue;
	              } else {
	                if (typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue < aggregation.value || aggregation.value === null)) {
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          max: {
	            label: i18nService.get().aggregation.max,
	            menuTitle: i18nService.get().grouping.aggregate_max,
	            aggregationFn: function( aggregation, fieldValue, numValue ){
	              if ( typeof(aggregation.value) === 'undefined' ){
	                aggregation.value = fieldValue;
	              } else {
	                if ( typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue > aggregation.value || aggregation.value === null)){
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          avg: {
	            label: i18nService.get().aggregation.avg,
	            menuTitle: i18nService.get().grouping.aggregate_avg,
	            aggregationFn: function( aggregation, fieldValue, numValue ){
	              if ( typeof(aggregation.count) === 'undefined' ){
	                aggregation.count = 1;
	              } else {
	                aggregation.count++;
	              }
	
	              if ( isNaN(numValue) ){
	                return;
	              }
	
	              if ( typeof(aggregation.value) === 'undefined' || typeof(aggregation.sum) === 'undefined' ){
	                aggregation.value = numValue;
	                aggregation.sum = numValue;
	              } else {
	                aggregation.sum += numValue;
	                aggregation.value = aggregation.sum / aggregation.count;
	              }
	            }
	          }
	        };
	        return nativeAggregations;
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregation
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Helper function used to finalize aggregation nodes and footer cells
	       *
	       * @param {gridRow} row the parent we're finalising
	       * @param {aggregation} the aggregation object manipulated by the aggregationFn
	       */
	      finaliseAggregation: function(row, aggregation){
	        if ( aggregation.col.treeAggregationUpdateEntity && typeof(row) !== 'undefined' && typeof(row.entity[ '$$' + aggregation.col.uid ]) !== 'undefined' ){
	          angular.extend( aggregation, row.entity[ '$$' + aggregation.col.uid ]);
	        }
	
	        if ( typeof(aggregation.col.treeAggregationFinalizerFn) === 'function' ){
	          aggregation.col.treeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.col.customTreeAggregationFinalizerFn) === 'function' ){
	          aggregation.col.customTreeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.rendered) === 'undefined' ){
	          aggregation.rendered = aggregation.label ? aggregation.label + aggregation.value : aggregation.value;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Format the data from the aggregation into the rendered text
	       * e.g. if we had label: 'sum: ' and value: 25, we'd create 'sum: 25'.
	       *
	       * As part of this we call any formatting callback routines we've been provided.
	       *
	       * We write our aggregation out to the row.entity if treeAggregationUpdateEntity is
	       * set on the column - we don't overwrite any information that's already there, we append
	       * to it so that grouping can have set the groupVal beforehand without us overwriting it.
	       *
	       * We need to copy the data from the row.entity first before we finalise the aggregation,
	       * we need that information for the finaliserFn
	       *
	       * @param {gridRow} row the parent we're finalising
	       */
	      finaliseAggregations: function( row ){
	        if ( typeof(row.treeNode.aggregations) === 'undefined' ){
	          return;
	        }
	
	        row.treeNode.aggregations.forEach( function( aggregation ) {
	          service.finaliseAggregation(row, aggregation);
	
	          if ( aggregation.col.treeAggregationUpdateEntity ){
	            var aggregationCopy = {};
	            angular.forEach( aggregation, function( value, key ){
	              if ( aggregation.hasOwnProperty(key) && key !== 'col' ){
	                aggregationCopy[key] = value;
	              }
	            });
	
	            row.entity[ '$$' + aggregation.col.uid ] = aggregationCopy;
	          }
	        });
	      },
	
	      /**
	       * @ngdoc function
	       * @name treeFooterAggregationType
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Uses the tree aggregation functions and finalizers to set the
	       * column footer aggregations.
	       *
	       * @param {rows} visible rows. not used, but accepted to match signature of GridColumn.aggregationType
	       * @param {gridColumn} the column we are finalizing
	       */
	      treeFooterAggregationType: function( rows, column ) {
	        service.finaliseAggregation(undefined, column.treeFooterAggregation);
	        if ( typeof(column.treeFooterAggregation.value) === 'undefined' || column.treeFooterAggregation.rendered === null ){
	          // The was apparently no aggregation performed (perhaps this is a grouped column
	          return '';
	        }
	        return column.treeFooterAggregation.rendered;
	      }
	    };
	
	    return service;
	
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeRowHeaderButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse button on rows
	   */
	  module.directive('uiGridTreeBaseRowHeaderButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseRowHeaderButtons'),
	      scope: true,
	      require: '^uiGrid',
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var self = uiGridCtrl.grid;
	        $scope.treeButtonClick = function(row, evt) {
	          uiGridTreeBaseService.toggleRowTreeState(self, row, evt);
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeBaseExpandAllButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse all button
	   */
	  module.directive('uiGridTreeBaseExpandAllButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseExpandAllButtons'),
	      scope: false,
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var self = $scope.col.grid;
	
	        $scope.headerButtonClick = function(row, evt) {
	          if ( self.treeBase.expandAll ){
	            uiGridTreeBaseService.collapseAllRows(self, evt);
	          } else {
	            uiGridTreeBaseService.expandAllRows(self, evt);
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to set formatting on a tree header row
	   */
	  module.directive('uiGridViewport',
	  ['$compile', 'uiGridConstants', 'gridUtil', '$parse',
	    function ($compile, uiGridConstants, gridUtil, $parse) {
	      return {
	        priority: -200, // run after default  directive
	        scope: false,
	        compile: function ($elm, $attrs) {
	          var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	          var existingNgClass = rowRepeatDiv.attr("ng-class");
	          var newNgClass = '';
	          if ( existingNgClass ) {
	            newNgClass = existingNgClass.slice(0, -1) + ",'ui-grid-tree-header-row': row.treeLevel > -1}";
	          } else {
	            newNgClass = "{'ui-grid-tree-header-row': row.treeLevel > -1}";
	          }
	          rowRepeatDiv.attr("ng-class", newNgClass);
	
	          return {
	            pre: function ($scope, $elm, $attrs, controllers) {
	
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeView
	   * @description
	   *
	   * # ui.grid.treeView
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides a tree view of the data that it is provided, with nodes in that
	   * tree and leaves.  Unlike grouping, the tree is an inherent property of the data and must
	   * be provided with your data array.
	   *
	   * Design information:
	   * -------------------
	   *
	   * TreeView uses treeBase for the underlying functionality, and is a very thin wrapper around
	   * that logic.  Most of the design information has now moved to treebase.
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeView"></div>
	   */
	
	  var module = angular.module('ui.grid.treeView', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeView.constant:uiGridTreeViewConstants
	   *
	   *  @description constants available in treeView module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridTreeViewConstants', {
	    featureName: "treeView",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeView.service:uiGridTreeViewService
	   *
	   *  @description Services for treeView features
	   */
	  module.service('uiGridTreeViewService', ['$q', 'uiGridTreeViewConstants', 'uiGridTreeBaseConstants', 'uiGridTreeBaseService', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants',
	  function ($q, uiGridTreeViewConstants, uiGridTreeBaseConstants, uiGridTreeBaseService, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.grid:treeView
	         *
	         *  @description Grid properties and functions added for treeView
	         */
	        grid.treeView = {};
	
	        grid.registerRowsProcessor(service.adjustSorting, 60);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:PublicApi
	         *
	         *  @description Public Api for treeView feature
	         */
	        var publicApi = {
	          events: {
	            treeView: {
	            }
	          },
	          methods: {
	            treeView: {
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:GridOptions
	         *
	         *  @description GridOptions for treeView feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         *
	         *  Many tree options are set on treeBase, make sure to look at that feature in
	         *  conjunction with these options.
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableTreeView
	         *  @propertyOf  ui.grid.treeView.api:GridOptions
	         *  @description Enable row tree view for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableTreeView = gridOptions.enableTreeView !== false;
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustSorting
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Trees cannot be sorted the same as flat lists of rows -
	       * trees are sorted recursively within each level - so the children of each
	       * node are sorted, but not the full set of rows.
	       *
	       * To achieve this, we suppress the normal sorting by setting ignoreSort on
	       * each of the sort columns.  When the treeBase rowsProcessor runs it will then
	       * unignore these, and will perform a recursive sort against the tree that it builds.
	       *
	       * @param {array} renderableRows the rows that we need to pass on through
	       * @returns {array} renderableRows that we passed on through
	       */
	      adjustSorting: function( renderableRows ) {
	        var grid = this;
	
	        grid.columns.forEach( function( column ){
	          if ( column.sort ){
	            column.sort.ignoreSort = true;
	          }
	        });
	
	        return renderableRows;
	      }
	
	    };
	
	    return service;
	
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeView.directive:uiGridTreeView
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds treeView features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.treeView']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-tree-view></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridTreeView', ['uiGridTreeViewConstants', 'uiGridTreeViewService', '$templateCache',
	  function (uiGridTreeViewConstants, uiGridTreeViewService, $templateCache) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableTreeView !== false){
	              uiGridTreeViewService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	angular.module('ui.grid').run(['$templateCache', function($templateCache) {
	  'use strict';
	
	  $templateCache.put('ui-grid/ui-grid-filter',
	    "<div class=\"ui-grid-filter-container\" ng-repeat=\"colFilter in col.filters\" ng-class=\"{'ui-grid-filter-cancel-button-hidden' : colFilter.disableCancelFilterButton === true }\"><div ng-if=\"colFilter.type !== 'select'\"><input type=\"text\" class=\"ui-grid-filter-input ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\"><div role=\"button\" class=\"ui-grid-filter-button\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== ''\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div><div ng-if=\"colFilter.type === 'select'\"><select class=\"ui-grid-filter-select ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || aria.defaultFilterLabel}}\" aria-label=\"{{colFilter.ariaLabel || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div role=\"button\" class=\"ui-grid-filter-button-select\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-footer',
	    "<div class=\"ui-grid-footer-panel ui-grid-footer-aggregates-row\"><!-- tfooter --><div class=\"ui-grid-footer ui-grid-footer-viewport\"><div class=\"ui-grid-footer-canvas\"><div class=\"ui-grid-footer-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-footer-cell-row\"><div ui-grid-footer-cell role=\"gridcell\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" col=\"col\" render-index=\"$index\" class=\"ui-grid-footer-cell ui-grid-clearfix\"></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-grid-footer',
	    "<div class=\"ui-grid-footer-info ui-grid-grid-footer\"><span>{{'search.totalItems' | t}} {{grid.rows.length}}</span> <span ng-if=\"grid.renderContainers.body.visibleRowCache.length !== grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-group-panel',
	    "<div class=\"ui-grid-group-panel\"><div ui-t=\"groupPanel.description\" class=\"description\" ng-show=\"groupings.length == 0\"></div><ul ng-show=\"groupings.length > 0\" class=\"ngGroupList\"><li class=\"ngGroupItem\" ng-repeat=\"group in configGroups\"><span class=\"ngGroupElement\"><span class=\"ngGroupName\">{{group.displayName}} <span ng-click=\"removeGroup($index)\" class=\"ngRemoveGroup\">x</span></span> <span ng-hide=\"$last\" class=\"ngGroupArrow\"></span></span></li></ul></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-header',
	    "<div role=\"rowgroup\" class=\"ui-grid-header\"><!-- theader --><div class=\"ui-grid-top-panel\"><div class=\"ui-grid-header-viewport\"><div class=\"ui-grid-header-canvas\"><div class=\"ui-grid-header-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-header-cell-row\"><div class=\"ui-grid-header-cell ui-grid-clearfix\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" ui-grid-header-cell col=\"col\" render-index=\"$index\"></div></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-menu-button',
	    "<div class=\"ui-grid-menu-button\"><div role=\"button\" ui-grid-one-bind-id-grid=\"'grid-menu'\" class=\"ui-grid-icon-container\" ng-click=\"toggleMenu()\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-menu\" ui-grid-one-bind-aria-label=\"i18n.aria.buttonLabel\">&nbsp;</i></div><div ui-grid-menu menu-items=\"menuItems\"></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-no-header',
	    "<div class=\"ui-grid-top-panel\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-row',
	    "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid',
	    "<div ui-i18n=\"en\" class=\"ui-grid\"><!-- TODO (c0bra): add \"scoped\" attr here, eventually? --><style ui-grid-style>.grid{{ grid.id }} {\n" +
	    "      /* Styles for the grid */\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row, .grid{{ grid.id }} .ui-grid-cell, .grid{{ grid.id }} .ui-grid-cell .ui-grid-vertical-bar {\n" +
	    "      height: {{ grid.options.rowHeight }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row:last-child .ui-grid-cell {\n" +
	    "      border-bottom-width: {{ ((grid.getTotalRowHeight() < grid.getViewportHeight()) && '1') || '0' }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    {{ grid.verticalScrollbarStyles }}\n" +
	    "    {{ grid.horizontalScrollbarStyles }}\n" +
	    "\n" +
	    "    /*\n" +
	    "    .ui-grid[dir=rtl] .ui-grid-viewport {\n" +
	    "      padding-left: {{ grid.verticalScrollbarWidth }}px;\n" +
	    "    }\n" +
	    "    */\n" +
	    "\n" +
	    "    {{ grid.customStyles }}</style><div class=\"ui-grid-contents-wrapper\"><div ui-grid-menu-button ng-if=\"grid.options.enableGridMenu\"></div><div ng-if=\"grid.hasLeftContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'left'\"></div><div ui-grid-render-container container-id=\"'body'\" col-container-name=\"'body'\" row-container-name=\"'body'\" bind-scroll-horizontal=\"true\" bind-scroll-vertical=\"true\" enable-horizontal-scrollbar=\"grid.options.enableHorizontalScrollbar\" enable-vertical-scrollbar=\"grid.options.enableVerticalScrollbar\"></div><div ng-if=\"grid.hasRightContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'right'\"></div><div ui-grid-grid-footer ng-if=\"grid.options.showGridFooter\"></div><div ui-grid-column-menu ng-if=\"grid.options.enableColumnMenus\"></div><div ng-transclude></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridCell',
	    "<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridColumnMenu',
	    "<div class=\"ui-grid-column-menu\"><div ui-grid-menu menu-items=\"menuItems\"><!-- <div class=\"ui-grid-column-menu\">\n" +
	    "    <div class=\"inner\" ng-show=\"menuShown\">\n" +
	    "      <ul>\n" +
	    "        <div ng-show=\"grid.options.enableSorting\">\n" +
	    "          <li ng-click=\"sortColumn($event, asc)\" ng-class=\"{ 'selected' : col.sort.direction == asc }\"><i class=\"ui-grid-icon-sort-alt-up\"></i> Sort Ascending</li>\n" +
	    "          <li ng-click=\"sortColumn($event, desc)\" ng-class=\"{ 'selected' : col.sort.direction == desc }\"><i class=\"ui-grid-icon-sort-alt-down\"></i> Sort Descending</li>\n" +
	    "          <li ng-show=\"col.sort.direction\" ng-click=\"unsortColumn()\"><i class=\"ui-grid-icon-cancel\"></i> Remove Sort</li>\n" +
	    "        </div>\n" +
	    "      </ul>\n" +
	    "    </div>\n" +
	    "  </div> --></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridFooterCell',
	    "<div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><div>{{ col.getAggregationText() + ( col.getAggregationValue() CUSTOM_FILTERS ) }}</div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridHeaderCell',
	    "<div role=\"columnheader\" ng-class=\"{ 'sortable': sortable }\" ui-grid-one-bind-aria-labelledby-grid=\"col.uid + '-header-text ' + col.uid + '-sortdir-text'\" aria-sort=\"{{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending' : (!col.sort.direction ? 'none' : 'other'))}}\"><div role=\"button\" tabindex=\"0\" class=\"ui-grid-cell-contents ui-grid-header-cell-primary-focus\" col-index=\"renderIndex\" title=\"TOOLTIP\"><span class=\"ui-grid-header-cell-label\" ui-grid-one-bind-id-grid=\"col.uid + '-header-text'\">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-one-bind-id-grid=\"col.uid + '-sortdir-text'\" ui-grid-visible=\"col.sort.direction\" aria-label=\"{{getSortDirectionAriaLabel()}}\"><i ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\" title=\"{{col.sort.priority ? i18n.headerCell.priority + ' ' + col.sort.priority : null}}\" aria-hidden=\"true\"></i> <sub class=\"ui-grid-sort-priority-number\">{{col.sort.priority}}</sub></span></div><div role=\"button\" tabindex=\"0\" ui-grid-one-bind-id-grid=\"col.uid + '-menu-button'\" class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event)\" ng-class=\"{'ui-grid-column-menu-button-last-col': isLastCol}\" ui-grid-one-bind-aria-label=\"i18n.headerCell.aria.columnMenuButtonLabel\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-angle-down\" aria-hidden=\"true\">&nbsp;</i></div><div ui-grid-filter></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenu',
	    "<div class=\"ui-grid-menu\" ng-if=\"shown\"><div class=\"ui-grid-menu-mid\" ng-show=\"shownMid\"><div class=\"ui-grid-menu-inner\"><button type=\"button\" ng-focus=\"focus=true\" ng-blur=\"focus=false\" class=\"ui-grid-menu-close-button\" ng-class=\"{'ui-grid-sr-only': (!focus)}\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"i18n.close\"></i></button><ul role=\"menu\" class=\"ui-grid-menu-items\"><li ng-repeat=\"item in menuItems\" role=\"menuitem\" ui-grid-menu-item ui-grid-one-bind-id=\"'menuitem-'+$index\" action=\"item.action\" name=\"item.title\" active=\"item.active\" icon=\"item.icon\" shown=\"item.shown\" context=\"item.context\" template-url=\"item.templateUrl\" leave-open=\"item.leaveOpen\" screen-reader-only=\"item.screenReaderOnly\"></li></ul></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenuItem',
	    "<button type=\"button\" class=\"ui-grid-menu-item\" ng-click=\"itemAction($event, title)\" ng-show=\"itemShown()\" ng-class=\"{ 'ui-grid-menu-item-active': active(), 'ui-grid-sr-only': (!focus && screenReaderOnly) }\" aria-pressed=\"{{active()}}\" tabindex=\"0\" ng-focus=\"focus=true\" ng-blur=\"focus=false\"><i ng-class=\"icon\" aria-hidden=\"true\">&nbsp;</i> {{ name }}</button>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridRenderContainer',
	    "<div role=\"grid\" ui-grid-one-bind-id-grid=\"'grid-container'\" class=\"ui-grid-render-container\" ng-style=\"{ 'margin-left': colContainer.getMargin('left') + 'px', 'margin-right': colContainer.getMargin('right') + 'px' }\"><!-- All of these dom elements are replaced in place --><div ui-grid-header></div><div ui-grid-viewport></div><div ng-if=\"colContainer.needsHScrollbarPlaceholder()\" class=\"ui-grid-scrollbar-placeholder\" ng-style=\"{height:colContainer.grid.scrollbarHeight + 'px'}\"></div><ui-grid-footer ng-if=\"grid.options.showColumnFooter\"></ui-grid-footer></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridViewport',
	    "<div role=\"rowgroup\" class=\"ui-grid-viewport\" ng-style=\"colContainer.getViewportStyle()\"><!-- tbody --><div class=\"ui-grid-canvas\"><div ng-repeat=\"(rowRenderIndex, row) in rowContainer.renderedRows track by $index\" class=\"ui-grid-row\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div role=\"row\" ui-grid-row=\"row\" row-render-index=\"rowRenderIndex\"></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellEditor',
	    "<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-class=\"'colt' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/dropdownEditor',
	    "<div><form name=\"inputForm\"><select ng-class=\"'colt' + col.uid\" ui-grid-edit-dropdown ng-model=\"MODEL_COL_FIELD\" ng-options=\"field[editDropdownIdLabel] as field[editDropdownValueLabel] CUSTOM_FILTERS for field in editDropdownOptionsArray\"></select></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/fileChooserEditor',
	    "<div><form name=\"inputForm\"><input ng-class=\"'colt' + col.uid\" ui-grid-edit-file-chooser type=\"file\" id=\"files\" name=\"files[]\" ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRow',
	    "<div ui-grid-expandable-row ng-if=\"expandableRow.shouldRenderExpand()\" class=\"expandableRow\" style=\"float:left; margin-top: 1px; margin-bottom: 1px\" ng-style=\"{width: (grid.renderContainers.body.getCanvasWidth()) + 'px', height: row.expandedRowHeight + 'px'}\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><i ng-class=\"{ 'ui-grid-icon-plus-squared' : !row.isExpanded, 'ui-grid-icon-minus-squared' : row.isExpanded }\" ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity)\"></i></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableScrollFiller',
	    "<div ng-if=\"expandableRow.shouldRenderFiller()\" ng-class=\"{scrollFiller:true, scrollFillerClass:(colContainer.name === 'body')}\" ng-style=\"{ width: (grid.getViewportWidth()) + 'px', height: row.expandedRowHeight + 2 + 'px', 'margin-left': grid.options.rowHeader.rowHeaderWidth + 'px' }\"><i class=\"ui-grid-icon-spin5 ui-grid-animate-spin\" ng-style=\"{'margin-top': ( row.expandedRowHeight/2 - 5) + 'px', 'margin-left' : ((grid.getViewportWidth() - grid.options.rowHeader.rowHeaderWidth)/2 - 5) + 'px'}\"></i></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableTopRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><i ng-class=\"{ 'ui-grid-icon-plus-squared' : !grid.expandable.expandedAll, 'ui-grid-icon-minus-squared' : grid.expandable.expandedAll }\" ng-click=\"grid.api.expandable.toggleAllRows()\"></i></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/csvLink',
	    "<span class=\"ui-grid-exporter-csv-link-span\"><a href=\"data:text/csv;charset=UTF-8,CSV_CONTENT\" download=\"FILE_NAME\">LINK_LABEL</a></span>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItem',
	    "<li class=\"ui-grid-menu-item\"><form><input class=\"ui-grid-importer-file-chooser\" type=\"file\" id=\"files\" name=\"files[]\"></form></li>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItemContainer',
	    "<div ui-grid-importer-menu-item></div>"
	  );
	
	
	  $templateCache.put('ui-grid/pagination',
	    "<div role=\"contentinfo\" class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div role=\"menubar\" class=\"ui-grid-pager-control\"><button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle\"><div class=\"first-bar\"></div></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle prev-triangle\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/</abbr> {{ paginationApi.getTotalPages() }}</span> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div class=\"last-triangle next-triangle\"></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div class=\"last-triangle\"><div class=\"last-bar\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select><span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{showingLow}} <abbr ui-grid-one-bind-title=\"paginationThrough\">-</abbr> {{showingHigh}} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/columnResizer',
	    "<div ui-grid-column-resizer ng-if=\"grid.options.enableColumnResizing\" class=\"ui-grid-column-resizer\" col=\"col\" position=\"right\" render-index=\"renderIndex\" unselectable=\"on\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/gridFooterSelectedItems',
	    "<span ng-if=\"grid.selection.selectedCount !== 0 && grid.options.enableFooterTotalSelected\">({{\"search.selectedItems\" | t}} {{grid.selection.selectedCount}})</span>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionHeaderCell',
	    "<div><!-- <div class=\"ui-grid-vertical-bar\">&nbsp;</div> --><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-selection-select-all-buttons ng-if=\"grid.options.enableSelectAll\"></ui-grid-selection-select-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeader',
	    "<div class=\"ui-grid-disable-selection\"><div class=\"ui-grid-cell-contents\"><ui-grid-selection-row-header-buttons></ui-grid-selection-row-header-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeaderButtons',
	    "<div class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok\" ng-class=\"{'ui-grid-row-selected': row.isSelected}\" ng-click=\"selectButtonClick(row, $event)\">&nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionSelectAllButtons',
	    "<div class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok\" ng-class=\"{'ui-grid-all-selected': grid.selection.selectAll}\" ng-click=\"headerButtonClick($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseExpandAllButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" ng-class=\"{'ui-grid-icon-minus-squared': grid.treeBase.numberLevels > 0 && grid.treeBase.expandAll, 'ui-grid-icon-plus-squared': grid.treeBase.numberLevels > 0 && !grid.treeBase.expandAll}\" ng-click=\"headerButtonClick($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseHeaderCell',
	    "<div><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-tree-base-expand-all-buttons></ui-grid-tree-base-expand-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeader',
	    "<div class=\"ui-grid-cell-contents\"><ui-grid-tree-base-row-header-buttons></ui-grid-tree-base-row-header-buttons></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeaderButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" ng-class=\"{'ui-grid-tree-base-header': row.treeLevel > -1 }\" ng-click=\"treeButtonClick(row, $event)\"><i ng-class=\"{'ui-grid-icon-minus-squared': ( ( grid.options.showTreeExpandNoChildren && row.treeLevel > -1 ) || ( row.treeNode.children && row.treeNode.children.length > 0 ) ) && row.treeNode.state === 'expanded', 'ui-grid-icon-plus-squared': ( ( grid.options.showTreeExpandNoChildren && row.treeLevel > -1 ) || ( row.treeNode.children && row.treeNode.children.length > 0 ) ) && row.treeNode.state === 'collapsed'}\" ng-style=\"{'padding-left': grid.options.treeIndent * row.treeLevel + 'px'}\"></i> &nbsp;</div>"
	  );
	
	}]);


/***/ }),
/* 1488 */
1199,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  var callWithJQuery;
	
	  callWithJQuery = function(pivotModule) {
	    if (true) {
	      return pivotModule(__webpack_require__(149), __webpack_require__(1233));
	    } else if (typeof define === "function" && define.amd) {
	      return define(["jquery", "c3"], pivotModule);
	    } else {
	      return pivotModule(jQuery, c3);
	    }
	  };
	
	  callWithJQuery(function($, c3) {
	    var makeC3Chart;
	    makeC3Chart = function(chartOpts) {
	      if (chartOpts == null) {
	        chartOpts = {};
	      }
	      return function(pivotData, opts) {
	        var agg, attrs, base, base1, base2, base3, base4, base5, base6, base7, c, categories, colKey, colKeys, columns, dataColumns, defaults, formatter, fullAggName, groupByTitle, h, hAxisTitle, headers, i, j, k, l, len, len1, len2, len3, len4, m, numCharsInHAxis, numSeries, params, ref, ref1, ref2, ref3, renderArea, result, rotationAngle, row, rowHeader, rowKey, rowKeys, s, scatterData, series, title, titleText, vAxisTitle, val, vals, x, xs, y;
	        defaults = {
	          localeStrings: {
	            vs: "vs",
	            by: "by"
	          },
	          c3: {}
	        };
	        opts = $.extend(true, {}, defaults, opts);
	        if ((base = opts.c3).size == null) {
	          base.size = {};
	        }
	        if ((base1 = opts.c3.size).width == null) {
	          base1.width = window.innerWidth / 1.4;
	        }
	        if ((base2 = opts.c3.size).height == null) {
	          base2.height = window.innerHeight / 1.4 - 50;
	        }
	        if (chartOpts.type == null) {
	          chartOpts.type = "line";
	        }
	        if (chartOpts.horizontal == null) {
	          chartOpts.horizontal = false;
	        }
	        if (chartOpts.stacked == null) {
	          chartOpts.stacked = false;
	        }
	        rowKeys = pivotData.getRowKeys();
	        if (rowKeys.length === 0) {
	          rowKeys.push([]);
	        }
	        colKeys = pivotData.getColKeys();
	        if (colKeys.length === 0) {
	          colKeys.push([]);
	        }
	        headers = (function() {
	          var i, len, results;
	          results = [];
	          for (i = 0, len = colKeys.length; i < len; i++) {
	            h = colKeys[i];
	            results.push(h.join("-"));
	          }
	          return results;
	        })();
	        rotationAngle = 0;
	        fullAggName = pivotData.aggregatorName;
	        if (pivotData.valAttrs.length) {
	          fullAggName += "(" + (pivotData.valAttrs.join(", ")) + ")";
	        }
	        if (chartOpts.type === "scatter") {
	          scatterData = {
	            x: {},
	            y: {},
	            t: {}
	          };
	          attrs = pivotData.rowAttrs.concat(pivotData.colAttrs);
	          vAxisTitle = (ref = attrs[0]) != null ? ref : "";
	          hAxisTitle = (ref1 = attrs[1]) != null ? ref1 : "";
	          groupByTitle = attrs.slice(2).join("-");
	          titleText = vAxisTitle;
	          if (hAxisTitle !== "") {
	            titleText += " " + opts.localeStrings.vs + " " + hAxisTitle;
	          }
	          if (groupByTitle !== "") {
	            titleText += " " + opts.localeStrings.by + " " + groupByTitle;
	          }
	          for (i = 0, len = rowKeys.length; i < len; i++) {
	            rowKey = rowKeys[i];
	            for (j = 0, len1 = colKeys.length; j < len1; j++) {
	              colKey = colKeys[j];
	              agg = pivotData.getAggregator(rowKey, colKey);
	              if (agg.value() != null) {
	                vals = rowKey.concat(colKey);
	                series = vals.slice(2).join("-");
	                if (series === "") {
	                  series = "series";
	                }
	                if ((base3 = scatterData.x)[series] == null) {
	                  base3[series] = [];
	                }
	                if ((base4 = scatterData.y)[series] == null) {
	                  base4[series] = [];
	                }
	                y = (ref2 = vals[0]) != null ? ref2 : 0;
	                x = (ref3 = vals[1]) != null ? ref3 : 0;
	                scatterData.y[series].push(y);
	                scatterData.x[series].push(x);
	                if ((base5 = scatterData.t)[series] == null) {
	                  base5[series] = {};
	                }
	                if ((base6 = scatterData.t[series])[x] == null) {
	                  base6[x] = {};
	                }
	                scatterData.t[series][x][y] = agg.value();
	              }
	            }
	          }
	        } else {
	          numCharsInHAxis = 0;
	          for (k = 0, len2 = headers.length; k < len2; k++) {
	            x = headers[k];
	            numCharsInHAxis += x.length;
	          }
	          if (numCharsInHAxis > 50) {
	            rotationAngle = 45;
	          }
	          columns = [];
	          for (l = 0, len3 = rowKeys.length; l < len3; l++) {
	            rowKey = rowKeys[l];
	            rowHeader = rowKey.join("-");
	            row = [rowHeader === "" ? fullAggName : rowHeader];
	            for (m = 0, len4 = colKeys.length; m < len4; m++) {
	              colKey = colKeys[m];
	              val = parseFloat(pivotData.getAggregator(rowKey, colKey).value());
	              if (isFinite(val)) {
	                row.push(val);
	              } else {
	                row.push(null);
	              }
	            }
	            columns.push(row);
	          }
	          vAxisTitle = fullAggName;
	          if (chartOpts.horizontal) {
	            hAxisTitle = pivotData.rowAttrs.join("-");
	            groupByTitle = pivotData.colAttrs.join("-");
	          } else {
	            hAxisTitle = pivotData.colAttrs.join("-");
	            groupByTitle = pivotData.rowAttrs.join("-");
	          }
	          titleText = fullAggName;
	          if (hAxisTitle !== "") {
	            titleText += " " + opts.localeStrings.vs + " " + hAxisTitle;
	          }
	          if (groupByTitle !== "") {
	            titleText += " " + opts.localeStrings.by + " " + groupByTitle;
	          }
	        }
	        title = $("<p>", {
	          style: "text-align: center; font-weight: bold"
	        });
	        title.text(titleText);
	        formatter = pivotData.getAggregator([], []).format;
	        params = {
	          axis: {
	            rotated: chartOpts.horizontal,
	            y: {
	              label: vAxisTitle,
	              tick: {}
	            },
	            x: {
	              label: hAxisTitle,
	              tick: {
	                rotate: rotationAngle,
	                multiline: false
	              }
	            }
	          },
	          data: {
	            type: chartOpts.type,
	            order: null
	          },
	          tooltip: {
	            grouped: false
	          },
	          color: {
	            pattern: ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"]
	          }
	        };
	        params = $.extend(true, {}, params, opts.c3);
	        if (chartOpts.type === "scatter") {
	          xs = {};
	          numSeries = 0;
	          dataColumns = [];
	          for (s in scatterData.x) {
	            numSeries += 1;
	            xs[s] = s + "_x";
	            dataColumns.push([s + "_x"].concat(scatterData.x[s]));
	            dataColumns.push([s].concat(scatterData.y[s]));
	          }
	          params.data.xs = xs;
	          params.data.columns = dataColumns;
	          params.axis.x.tick = {
	            fit: false
	          };
	          if (numSeries === 1) {
	            params.legend = {
	              show: false
	            };
	          }
	          params.tooltip.format = {
	            title: function() {
	              return fullAggName;
	            },
	            name: function() {
	              return "";
	            },
	            value: function(a, b, c, d, e) {
	              var ref4;
	              ref4 = e[0], series = ref4.name, y = ref4.value, x = ref4.x;
	              return formatter(scatterData.t[series][x][y]);
	            }
	          };
	        } else {
	          params.axis.x.type = 'category';
	          if ((base7 = params.axis.y.tick).format == null) {
	            base7.format = function(v) {
	              return formatter(v);
	            };
	          }
	          params.tooltip.format = {
	            value: function(v) {
	              return formatter(v);
	            }
	          };
	          if (chartOpts.horizontal) {
	            categories = (function() {
	              var len5, n, results;
	              results = [];
	              for (n = 0, len5 = columns.length; n < len5; n++) {
	                c = columns[n];
	                results.push(c.shift());
	              }
	              return results;
	            })();
	            if (categories.length === 1 && categories[0] === fullAggName) {
	              categories = [""];
	            }
	            params.axis.x.categories = categories;
	            if (headers.length === 1 && headers[0] === "") {
	              headers = [fullAggName];
	            }
	            columns.unshift(headers);
	            params.data.rows = columns;
	          } else {
	            params.axis.x.categories = headers;
	            params.data.columns = columns;
	          }
	        }
	        if (chartOpts.stacked) {
	          if (chartOpts.horizontal) {
	            params.data.groups = [
	              (function() {
	                var len5, n, results;
	                results = [];
	                for (n = 0, len5 = colKeys.length; n < len5; n++) {
	                  x = colKeys[n];
	                  results.push(x.join("-"));
	                }
	                return results;
	              })()
	            ];
	          } else {
	            params.data.groups = [
	              (function() {
	                var len5, n, results;
	                results = [];
	                for (n = 0, len5 = rowKeys.length; n < len5; n++) {
	                  x = rowKeys[n];
	                  results.push(x.join("-"));
	                }
	                return results;
	              })()
	            ];
	          }
	        }
	        renderArea = $("<div>", {
	          style: "display:none;"
	        }).appendTo($("body"));
	        result = $("<div>").appendTo(renderArea);
	        params.bindto = result[0];
	        c3.generate(params);
	        result.detach();
	        renderArea.remove();
	        return $("<div>").append(title, result);
	      };
	    };
	    return $.pivotUtilities.c3_renderers = {
	      "Horizontal Bar Chart": makeC3Chart({
	        type: "bar",
	        horizontal: true
	      }),
	      "Horizontal Stacked Bar Chart": makeC3Chart({
	        type: "bar",
	        stacked: true,
	        horizontal: true
	      }),
	      "Bar Chart": makeC3Chart({
	        type: "bar"
	      }),
	      "Stacked Bar Chart": makeC3Chart({
	        type: "bar",
	        stacked: true
	      }),
	      "Line Chart": makeC3Chart(),
	      "Area Chart": makeC3Chart({
	        type: "area",
	        stacked: true
	      }),
	      "Scatter Chart": makeC3Chart({
	        type: "scatter"
	      })
	    };
	  });
	
	}).call(this);
	
	//# sourceMappingURL=c3_renderers.js.map


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  var callWithJQuery;
	
	  callWithJQuery = function(pivotModule) {
	    if (true) {
	      return pivotModule(__webpack_require__(149), __webpack_require__(1237));
	    } else if (typeof define === "function" && define.amd) {
	      return define(["jquery", "d3"], pivotModule);
	    } else {
	      return pivotModule(jQuery, d3);
	    }
	  };
	
	  callWithJQuery(function($, d3) {
	    return $.pivotUtilities.d3_renderers = {
	      Treemap: function(pivotData, opts) {
	        var addToTree, color, defaults, height, i, len, ref, result, rowKey, tree, treemap, value, width;
	        defaults = {
	          localeStrings: {},
	          d3: {
	            width: function() {
	              return $(window).width() / 1.4;
	            },
	            height: function() {
	              return $(window).height() / 1.4;
	            }
	          }
	        };
	        opts = $.extend(true, {}, defaults, opts);
	        result = $("<div>").css({
	          width: "100%",
	          height: "100%"
	        });
	        tree = {
	          name: "All",
	          children: []
	        };
	        addToTree = function(tree, path, value) {
	          var child, i, len, newChild, ref, x;
	          if (path.length === 0) {
	            tree.value = value;
	            return;
	          }
	          if (tree.children == null) {
	            tree.children = [];
	          }
	          x = path.shift();
	          ref = tree.children;
	          for (i = 0, len = ref.length; i < len; i++) {
	            child = ref[i];
	            if (!(child.name === x)) {
	              continue;
	            }
	            addToTree(child, path, value);
	            return;
	          }
	          newChild = {
	            name: x
	          };
	          addToTree(newChild, path, value);
	          return tree.children.push(newChild);
	        };
	        ref = pivotData.getRowKeys();
	        for (i = 0, len = ref.length; i < len; i++) {
	          rowKey = ref[i];
	          value = pivotData.getAggregator(rowKey, []).value();
	          if (value != null) {
	            addToTree(tree, rowKey, value);
	          }
	        }
	        color = d3.scale.category10();
	        width = opts.d3.width();
	        height = opts.d3.height();
	        treemap = d3.layout.treemap().size([width, height]).sticky(true).value(function(d) {
	          return d.size;
	        });
	        d3.select(result[0]).append("div").style("position", "relative").style("width", width + "px").style("height", height + "px").datum(tree).selectAll(".node").data(treemap.padding([15, 0, 0, 0]).value(function(d) {
	          return d.value;
	        }).nodes).enter().append("div").attr("class", "node").style("background", function(d) {
	          if (d.children != null) {
	            return "lightgrey";
	          } else {
	            return color(d.name);
	          }
	        }).text(function(d) {
	          return d.name;
	        }).call(function() {
	          this.style("left", function(d) {
	            return d.x + "px";
	          }).style("top", function(d) {
	            return d.y + "px";
	          }).style("width", function(d) {
	            return Math.max(0, d.dx - 1) + "px";
	          }).style("height", function(d) {
	            return Math.max(0, d.dy - 1) + "px";
	          });
	        });
	        return result;
	      }
	    };
	  });
	
	}).call(this);
	
	//# sourceMappingURL=d3_renderers.js.map


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  var callWithJQuery;
	
	  callWithJQuery = function(pivotModule) {
	    if (true) {
	      return pivotModule(__webpack_require__(149));
	    } else if (typeof define === "function" && define.amd) {
	      return define(["jquery"], pivotModule);
	    } else {
	      return pivotModule(jQuery);
	    }
	  };
	
	  callWithJQuery(function($) {
	    return $.pivotUtilities.export_renderers = {
	      "TSV Export": function(pivotData, opts) {
	        var agg, colAttrs, colKey, colKeys, defaults, i, j, k, l, len, len1, len2, len3, len4, len5, m, n, r, result, row, rowAttr, rowAttrs, rowKey, rowKeys, text;
	        defaults = {
	          localeStrings: {}
	        };
	        opts = $.extend(true, {}, defaults, opts);
	        rowKeys = pivotData.getRowKeys();
	        if (rowKeys.length === 0) {
	          rowKeys.push([]);
	        }
	        colKeys = pivotData.getColKeys();
	        if (colKeys.length === 0) {
	          colKeys.push([]);
	        }
	        rowAttrs = pivotData.rowAttrs;
	        colAttrs = pivotData.colAttrs;
	        result = [];
	        row = [];
	        for (i = 0, len = rowAttrs.length; i < len; i++) {
	          rowAttr = rowAttrs[i];
	          row.push(rowAttr);
	        }
	        if (colKeys.length === 1 && colKeys[0].length === 0) {
	          row.push(pivotData.aggregatorName);
	        } else {
	          for (j = 0, len1 = colKeys.length; j < len1; j++) {
	            colKey = colKeys[j];
	            row.push(colKey.join("-"));
	          }
	        }
	        result.push(row);
	        for (k = 0, len2 = rowKeys.length; k < len2; k++) {
	          rowKey = rowKeys[k];
	          row = [];
	          for (l = 0, len3 = rowKey.length; l < len3; l++) {
	            r = rowKey[l];
	            row.push(r);
	          }
	          for (m = 0, len4 = colKeys.length; m < len4; m++) {
	            colKey = colKeys[m];
	            agg = pivotData.getAggregator(rowKey, colKey);
	            if (agg.value() != null) {
	              row.push(agg.value());
	            } else {
	              row.push("");
	            }
	          }
	          result.push(row);
	        }
	        text = "";
	        for (n = 0, len5 = result.length; n < len5; n++) {
	          r = result[n];
	          text += r.join("\t") + "\n";
	        }
	        return $("<textarea>").text(text).css({
	          width: ($(window).width() / 2) + "px",
	          height: ($(window).height() / 2) + "px"
	        });
	      }
	    };
	  });
	
	}).call(this);
	
	//# sourceMappingURL=export_renderers.js.map


/***/ }),
/* 1497 */
1199,
/* 1498 */,
/* 1499 */
1199,
/* 1500 */,
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1502))

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	module.exports = "/**\n * angular-ui-utils - Swiss-Army-Knife of AngularJS tools (with no external dependencies!)\n * @version v0.2.3 - 2015-03-30\n * @link http://angular-ui.github.com\n * @license MIT License, http://www.opensource.org/licenses/MIT\n */\nangular.module('ui.alias', []).config(['$compileProvider', 'uiAliasConfig', function($compileProvider, uiAliasConfig){\n  'use strict';\n\n  uiAliasConfig = uiAliasConfig || {};\n  angular.forEach(uiAliasConfig, function(config, alias){\n    if (angular.isString(config)) {\n      config = {\n        replace: true,\n        template: config\n      };\n    }\n    $compileProvider.directive(alias, function(){\n      return config;\n    });\n  });\n}]);\n\n/**\n * General-purpose Event binding. Bind any event not natively supported by Angular\n * Pass an object with keynames for events to ui-event\n * Allows $event object and $params object to be passed\n *\n * @example <input ui-event=\"{ focus : 'counter++', blur : 'someCallback()' }\">\n * @example <input ui-event=\"{ myCustomEvent : 'myEventHandler($event, $params)'}\">\n *\n * @param ui-event {string|object literal} The event to bind to as a string or a hash of events with their callbacks\n */\nangular.module('ui.event',[]).directive('uiEvent', ['$parse',\n  function ($parse) {\n    'use strict';\n\n    return function ($scope, elm, attrs) {\n      var events = $scope.$eval(attrs.uiEvent);\n      angular.forEach(events, function (uiEvent, eventName) {\n        var fn = $parse(uiEvent);\n        elm.bind(eventName, function (evt) {\n          var params = Array.prototype.slice.call(arguments);\n          //Take out first paramater (event object);\n          params = params.splice(1);\n          fn($scope, {$event: evt, $params: params});\n          if (!$scope.$$phase) {\n            $scope.$apply();\n          }\n        });\n      });\n    };\n  }]);\n\n/**\n * A replacement utility for internationalization very similar to sprintf.\n *\n * @param replace {mixed} The tokens to replace depends on type\n *  string: all instances of $0 will be replaced\n *  array: each instance of $0, $1, $2 etc. will be placed with each array item in corresponding order\n *  object: all attributes will be iterated through, with :key being replaced with its corresponding value\n * @return string\n *\n * @example: 'Hello :name, how are you :day'.format({ name:'John', day:'Today' })\n * @example: 'Records $0 to $1 out of $2 total'.format(['10', '20', '3000'])\n * @example: '$0 agrees to all mentions $0 makes in the event that $0 hits a tree while $0 is driving drunk'.format('Bob')\n */\nangular.module('ui.format',[]).filter('format', function(){\n  'use strict';\n\n  return function(value, replace) {\n    var target = value;\n    if (angular.isString(target) && replace !== undefined) {\n      if (!angular.isArray(replace) && !angular.isObject(replace)) {\n        replace = [replace];\n      }\n      if (angular.isArray(replace)) {\n        var rlen = replace.length;\n        var rfx = function (str, i) {\n          i = parseInt(i, 10);\n          return (i >= 0 && i < rlen) ? replace[i] : str;\n        };\n        target = target.replace(/\\$([0-9]+)/g, rfx);\n      }\n      else {\n        angular.forEach(replace, function(value, key){\n          target = target.split(':' + key).join(value);\n        });\n      }\n    }\n    return target;\n  };\n});\n\n/**\n * Wraps the\n * @param text {string} haystack to search through\n * @param search {string} needle to search for\n * @param [caseSensitive] {boolean} optional boolean to use case-sensitive searching\n */\nangular.module('ui.highlight',[]).filter('highlight', function () {\n  'use strict';\n\n  return function (text, search, caseSensitive) {\n    if (text && (search || angular.isNumber(search))) {\n      text = text.toString();\n      search = search.toString();\n      if (caseSensitive) {\n        return text.split(search).join('<span class=\"ui-match\">' + search + '</span>');\n      } else {\n        return text.replace(new RegExp(search, 'gi'), '<span class=\"ui-match\">$&</span>');\n      }\n    } else {\n      return text;\n    }\n  };\n});\n\n// modeled after: angular-1.0.7/src/ng/directive/ngInclude.js\nangular.module('ui.include',[])\n.directive('uiInclude', ['$http', '$templateCache', '$anchorScroll', '$compile',\n                 function($http,   $templateCache,   $anchorScroll,   $compile) {\n  'use strict';\n\n  return {\n    restrict: 'ECA',\n    terminal: true,\n    compile: function(element, attr) {\n      var srcExp = attr.uiInclude || attr.src,\n          fragExp = attr.fragment || '',\n          onloadExp = attr.onload || '',\n          autoScrollExp = attr.autoscroll;\n\n      return function(scope, element) {\n        var changeCounter = 0,\n            childScope;\n\n        var clearContent = function() {\n          if (childScope) {\n            childScope.$destroy();\n            childScope = null;\n          }\n\n          element.html('');\n        };\n\n        function ngIncludeWatchAction() {\n          var thisChangeId = ++changeCounter;\n          var src = scope.$eval(srcExp);\n          var fragment = scope.$eval(fragExp);\n\n          if (src) {\n            $http.get(src, {cache: $templateCache}).success(function(response) {\n              if (thisChangeId !== changeCounter) { return; }\n\n              if (childScope) { childScope.$destroy(); }\n              childScope = scope.$new();\n\n              var contents;\n              if (fragment) {\n                contents = angular.element('<div/>').html(response).find(fragment);\n              }\n              else {\n                contents = angular.element('<div/>').html(response).contents();\n              }\n              element.html(contents);\n              $compile(contents)(childScope);\n\n              if (angular.isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {\n                $anchorScroll();\n              }\n\n              childScope.$emit('$includeContentLoaded');\n              scope.$eval(onloadExp);\n            }).error(function() {\n              if (thisChangeId === changeCounter) { clearContent(); }\n            });\n          } else { clearContent(); }\n        }\n\n        scope.$watch(fragExp, ngIncludeWatchAction);\n        scope.$watch(srcExp, ngIncludeWatchAction);\n      };\n    }\n  };\n}]);\n\n/**\n * Provides an easy way to toggle a checkboxes indeterminate property\n *\n * @example <input type=\"checkbox\" ui-indeterminate=\"isUnkown\">\n */\nangular.module('ui.indeterminate',[]).directive('uiIndeterminate', [\n  function () {\n    'use strict';\n\n    return {\n      compile: function(tElm, tAttrs) {\n        if (!tAttrs.type || tAttrs.type.toLowerCase() !== 'checkbox') {\n          return angular.noop;\n        }\n\n        return function ($scope, elm, attrs) {\n          $scope.$watch(attrs.uiIndeterminate, function(newVal) {\n            elm[0].indeterminate = !!newVal;\n          });\n        };\n      }\n    };\n  }]);\n\n/**\n * Converts variable-esque naming conventions to something presentational, capitalized words separated by space.\n * @param {String} value The value to be parsed and prettified.\n * @param {String} [inflector] The inflector to use. Default: humanize.\n * @return {String}\n * @example {{ 'Here Is my_phoneNumber' | inflector:'humanize' }} => Here Is My Phone Number\n *          {{ 'Here Is my_phoneNumber' | inflector:'underscore' }} => here_is_my_phone_number\n *          {{ 'Here Is my_phoneNumber' | inflector:'variable' }} => hereIsMyPhoneNumber\n */\nangular.module('ui.inflector',[]).filter('inflector', function () {\n  'use strict';\n\n  function tokenize(text) {\n    text = text.replace(/([A-Z])|([\\-|\\_])/g, function(_, $1) { return ' ' + ($1 || ''); });\n    return text.replace(/\\s\\s+/g, ' ').trim().toLowerCase().split(' ');\n  }\n\n  function capitalizeTokens(tokens) {\n    var result = [];\n    angular.forEach(tokens, function(token) {\n      result.push(token.charAt(0).toUpperCase() + token.substr(1));\n    });\n    return result;\n  }\n\n  var inflectors = {\n    humanize: function (value) {\n      return capitalizeTokens(tokenize(value)).join(' ');\n    },\n    underscore: function (value) {\n      return tokenize(value).join('_');\n    },\n    variable: function (value) {\n      value = tokenize(value);\n      value = value[0] + capitalizeTokens(value.slice(1)).join('');\n      return value;\n    }\n  };\n\n  return function (text, inflector) {\n    if (inflector !== false && angular.isString(text)) {\n      inflector = inflector || 'humanize';\n      return inflectors[inflector](text);\n    } else {\n      return text;\n    }\n  };\n});\n\n/**\n * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.\n *\n * It is possible to specify a default set of parameters for each jQuery plugin.\n * Under the jq key, namespace each plugin by that which will be passed to ui-jq.\n * Unfortunately, at this time you can only pre-define the first parameter.\n * @example { jq : { datepicker : { showOn:'click' } } }\n *\n * @param ui-jq {string} The $elm.[pluginName]() to call.\n * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function\n *     Multiple parameters can be separated by commas\n * @param [ui-refresh] {expression} Watch expression and refire plugin on changes\n *\n * @example <input ui-jq=\"datepicker\" ui-options=\"{showOn:'click'},secondParameter,thirdParameter\" ui-refresh=\"iChange\">\n */\nangular.module('ui.jq',[]).\n  value('uiJqConfig',{}).\n  directive('uiJq', ['uiJqConfig', '$timeout', function uiJqInjectingFunction(uiJqConfig, $timeout) {\n  'use strict';\n\n\n  return {\n    restrict: 'A',\n    compile: function uiJqCompilingFunction(tElm, tAttrs) {\n\n      if (!angular.isFunction(tElm[tAttrs.uiJq])) {\n        throw new Error('ui-jq: The \"' + tAttrs.uiJq + '\" function does not exist');\n      }\n      var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];\n\n      return function uiJqLinkingFunction(scope, elm, attrs) {\n\n        // If change compatibility is enabled, the form input's \"change\" event will trigger an \"input\" event\n        if (attrs.ngModel && elm.is('select,input,textarea')) {\n          elm.bind('change', function() {\n            elm.trigger('input');\n          });\n        }\n\n        function createLinkOptions(){\n          var linkOptions = [];\n\n          // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method\n          if (attrs.uiOptions) {\n            linkOptions = scope.$eval('[' + attrs.uiOptions + ']');\n            if (angular.isObject(options) && angular.isObject(linkOptions[0])) {\n              linkOptions[0] = angular.extend({}, options, linkOptions[0]);\n            }\n          } else if (options) {\n            linkOptions = [options];\n          }\n          return linkOptions;\n        }\n\n        // Call jQuery method and pass relevant options\n        function callPlugin() {\n          $timeout(function() {\n            elm[attrs.uiJq].apply(elm, createLinkOptions());\n          }, 0, false);\n        }\n\n        // If ui-refresh is used, re-fire the the method upon every change\n        if (attrs.uiRefresh) {\n          scope.$watch(attrs.uiRefresh, function() {\n            callPlugin();\n          });\n        }\n        callPlugin();\n      };\n    }\n  };\n}]);\n\nangular.module('ui.keypress',[]).\nfactory('keypressHelper', ['$parse', function keypress($parse){\n  'use strict';\n\n  var keysByCode = {\n    8: 'backspace',\n    9: 'tab',\n    13: 'enter',\n    27: 'esc',\n    32: 'space',\n    33: 'pageup',\n    34: 'pagedown',\n    35: 'end',\n    36: 'home',\n    37: 'left',\n    38: 'up',\n    39: 'right',\n    40: 'down',\n    45: 'insert',\n    46: 'delete'\n  };\n\n  var capitaliseFirstLetter = function (string) {\n    return string.charAt(0).toUpperCase() + string.slice(1);\n  };\n\n  return function(mode, scope, elm, attrs) {\n    var params, combinations = [];\n    params = scope.$eval(attrs['ui'+capitaliseFirstLetter(mode)]);\n\n    // Prepare combinations for simple checking\n    angular.forEach(params, function (v, k) {\n      var combination, expression;\n      expression = $parse(v);\n\n      angular.forEach(k.split(' '), function(variation) {\n        combination = {\n          expression: expression,\n          keys: {}\n        };\n        angular.forEach(variation.split('-'), function (value) {\n          combination.keys[value] = true;\n        });\n        combinations.push(combination);\n      });\n    });\n\n    // Check only matching of pressed keys one of the conditions\n    elm.bind(mode, function (event) {\n      // No need to do that inside the cycle\n      var metaPressed = !!(event.metaKey && !event.ctrlKey);\n      var altPressed = !!event.altKey;\n      var ctrlPressed = !!event.ctrlKey;\n      var shiftPressed = !!event.shiftKey;\n      var keyCode = event.keyCode;\n\n      // normalize keycodes\n      if (mode === 'keypress' && !shiftPressed && keyCode >= 97 && keyCode <= 122) {\n        keyCode = keyCode - 32;\n      }\n\n      // Iterate over prepared combinations\n      angular.forEach(combinations, function (combination) {\n\n        var mainKeyPressed = combination.keys[keysByCode[keyCode]] || combination.keys[keyCode.toString()];\n\n        var metaRequired = !!combination.keys.meta;\n        var altRequired = !!combination.keys.alt;\n        var ctrlRequired = !!combination.keys.ctrl;\n        var shiftRequired = !!combination.keys.shift;\n\n        if (\n          mainKeyPressed &&\n          ( metaRequired === metaPressed ) &&\n          ( altRequired === altPressed ) &&\n          ( ctrlRequired === ctrlPressed ) &&\n          ( shiftRequired === shiftPressed )\n        ) {\n          // Run the function\n          scope.$apply(function () {\n            combination.expression(scope, { '$event': event });\n          });\n        }\n      });\n    });\n  };\n}]);\n\n/**\n * Bind one or more handlers to particular keys or their combination\n * @param hash {mixed} keyBindings Can be an object or string where keybinding expression of keys or keys combinations and AngularJS Exspressions are set. Object syntax: \"{ keys1: expression1 [, keys2: expression2 [ , ... ]]}\". String syntax: \"\"expression1 on keys1 [ and expression2 on keys2 [ and ... ]]\"\". Expression is an AngularJS Expression, and key(s) are dash-separated combinations of keys and modifiers (one or many, if any. Order does not matter). Supported modifiers are 'ctrl', 'shift', 'alt' and key can be used either via its keyCode (13 for Return) or name. Named keys are 'backspace', 'tab', 'enter', 'esc', 'space', 'pageup', 'pagedown', 'end', 'home', 'left', 'up', 'right', 'down', 'insert', 'delete'.\n * @example <input ui-keypress=\"{enter:'x = 1', 'ctrl-shift-space':'foo()', 'shift-13':'bar()'}\" /> <input ui-keypress=\"foo = 2 on ctrl-13 and bar('hello') on shift-esc\" />\n **/\nangular.module('ui.keypress').directive('uiKeydown', ['keypressHelper', function(keypressHelper){\n  'use strict';\n\n  return {\n    link: function (scope, elm, attrs) {\n      keypressHelper('keydown', scope, elm, attrs);\n    }\n  };\n}]);\n\nangular.module('ui.keypress').directive('uiKeypress', ['keypressHelper', function(keypressHelper){\n  'use strict';\n\n  return {\n    link: function (scope, elm, attrs) {\n      keypressHelper('keypress', scope, elm, attrs);\n    }\n  };\n}]);\n\nangular.module('ui.keypress').directive('uiKeyup', ['keypressHelper', function(keypressHelper){\n  'use strict';\n\n  return {\n    link: function (scope, elm, attrs) {\n      keypressHelper('keyup', scope, elm, attrs);\n    }\n  };\n}]);\n\n/*\n Attaches input mask onto input element\n */\nangular.module('ui.mask', [])\n  .value('uiMaskConfig', {\n    'maskDefinitions': {\n      '9': /\\d/,\n      'A': /[a-zA-Z]/,\n      '*': /[a-zA-Z0-9]/\n    },\n    'clearOnBlur': true\n  })\n  .directive('uiMask', ['uiMaskConfig', '$parse', function (maskConfig, $parse) {\n    'use strict';\n\n    return {\n      priority: 100,\n      require: 'ngModel',\n      restrict: 'A',\n      compile: function uiMaskCompilingFunction(){\n        var options = maskConfig;\n\n        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller){\n          var maskProcessed = false, eventsBound = false,\n            maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,\n          // Minimum required length of the value to be considered valid\n            minRequiredLength,\n            value, valueMasked, isValid,\n          // Vars for initializing/uninitializing\n            originalPlaceholder = iAttrs.placeholder,\n            originalMaxlength = iAttrs.maxlength,\n          // Vars used exclusively in eventHandler()\n            oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength;\n\n          function initialize(maskAttr){\n            if (!angular.isDefined(maskAttr)) {\n              return uninitialize();\n            }\n            processRawMask(maskAttr);\n            if (!maskProcessed) {\n              return uninitialize();\n            }\n            initializeElement();\n            bindEventListeners();\n            return true;\n          }\n\n          function initPlaceholder(placeholderAttr) {\n            if(! angular.isDefined(placeholderAttr)) {\n              return;\n            }\n\n            maskPlaceholder = placeholderAttr;\n\n            // If the mask is processed, then we need to update the value\n            if (maskProcessed) {\n              eventHandler();\n            }\n          }\n\n          function formatter(fromModelValue){\n            if (!maskProcessed) {\n              return fromModelValue;\n            }\n            value = unmaskValue(fromModelValue || '');\n            isValid = validateValue(value);\n            controller.$setValidity('mask', isValid);\n            return isValid && value.length ? maskValue(value) : undefined;\n          }\n\n          function parser(fromViewValue){\n            if (!maskProcessed) {\n              return fromViewValue;\n            }\n            value = unmaskValue(fromViewValue || '');\n            isValid = validateValue(value);\n            // We have to set viewValue manually as the reformatting of the input\n            // value performed by eventHandler() doesn't happen until after\n            // this parser is called, which causes what the user sees in the input\n            // to be out-of-sync with what the controller's $viewValue is set to.\n            controller.$viewValue = value.length ? maskValue(value) : '';\n            controller.$setValidity('mask', isValid);\n            if (value === '' && iAttrs.required) {\n                controller.$setValidity('required', !controller.$error.required);\n            }\n            return isValid ? value : undefined;\n          }\n\n          var linkOptions = {};\n\n          if (iAttrs.uiOptions) {\n            linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');\n            if (angular.isObject(linkOptions[0])) {\n              // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge\n              linkOptions = (function(original, current){\n                for(var i in original) {\n                  if (Object.prototype.hasOwnProperty.call(original, i)) {\n                    if (current[i] === undefined) {\n                      current[i] = angular.copy(original[i]);\n                    } else {\n                      angular.extend(current[i], original[i]);\n                    }\n                  }\n                }\n                return current;\n              })(options, linkOptions[0]);\n            }\n          } else {\n            linkOptions = options;\n          }\n\n          iAttrs.$observe('uiMask', initialize);\n          iAttrs.$observe('placeholder', initPlaceholder);\n          var modelViewValue = false;\n          iAttrs.$observe('modelViewValue', function(val) {\n            if(val === 'true') {\n              modelViewValue = true;\n            }\n          });\n          scope.$watch(iAttrs.ngModel, function(val) {\n            if(modelViewValue && val) {\n              var model = $parse(iAttrs.ngModel);\n              model.assign(scope, controller.$viewValue);\n            }\n          });\n          controller.$formatters.push(formatter);\n          controller.$parsers.push(parser);\n\n          function uninitialize(){\n            maskProcessed = false;\n            unbindEventListeners();\n\n            if (angular.isDefined(originalPlaceholder)) {\n              iElement.attr('placeholder', originalPlaceholder);\n            } else {\n              iElement.removeAttr('placeholder');\n            }\n\n            if (angular.isDefined(originalMaxlength)) {\n              iElement.attr('maxlength', originalMaxlength);\n            } else {\n              iElement.removeAttr('maxlength');\n            }\n\n            iElement.val(controller.$modelValue);\n            controller.$viewValue = controller.$modelValue;\n            return false;\n          }\n\n          function initializeElement(){\n            value = oldValueUnmasked = unmaskValue(controller.$viewValue || '');\n            valueMasked = oldValue = maskValue(value);\n            isValid = validateValue(value);\n            var viewValue = isValid && value.length ? valueMasked : '';\n            if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask\n              iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);\n            }\n            iElement.attr('placeholder', maskPlaceholder);\n            iElement.val(viewValue);\n            controller.$viewValue = viewValue;\n            // Not using $setViewValue so we don't clobber the model value and dirty the form\n            // without any kind of user interaction.\n          }\n\n          function bindEventListeners(){\n            if (eventsBound) {\n              return;\n            }\n            iElement.bind('blur', blurHandler);\n            iElement.bind('mousedown mouseup', mouseDownUpHandler);\n            iElement.bind('input keyup click focus', eventHandler);\n            eventsBound = true;\n          }\n\n          function unbindEventListeners(){\n            if (!eventsBound) {\n              return;\n            }\n            iElement.unbind('blur', blurHandler);\n            iElement.unbind('mousedown', mouseDownUpHandler);\n            iElement.unbind('mouseup', mouseDownUpHandler);\n            iElement.unbind('input', eventHandler);\n            iElement.unbind('keyup', eventHandler);\n            iElement.unbind('click', eventHandler);\n            iElement.unbind('focus', eventHandler);\n            eventsBound = false;\n          }\n\n          function validateValue(value){\n            // Zero-length value validity is ngRequired's determination\n            return value.length ? value.length >= minRequiredLength : true;\n          }\n\n          function unmaskValue(value){\n            var valueUnmasked = '',\n              maskPatternsCopy = maskPatterns.slice();\n            // Preprocess by stripping mask components from value\n            value = value.toString();\n            angular.forEach(maskComponents, function (component){\n              value = value.replace(component, '');\n            });\n            angular.forEach(value.split(''), function (chr){\n              if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {\n                valueUnmasked += chr;\n                maskPatternsCopy.shift();\n              }\n            });\n            return valueUnmasked;\n          }\n\n          function maskValue(unmaskedValue){\n            var valueMasked = '',\n                maskCaretMapCopy = maskCaretMap.slice();\n\n            angular.forEach(maskPlaceholder.split(''), function (chr, i){\n              if (unmaskedValue.length && i === maskCaretMapCopy[0]) {\n                valueMasked  += unmaskedValue.charAt(0) || '_';\n                unmaskedValue = unmaskedValue.substr(1);\n                maskCaretMapCopy.shift();\n              }\n              else {\n                valueMasked += chr;\n              }\n            });\n            return valueMasked;\n          }\n\n          function getPlaceholderChar(i) {\n            var placeholder = iAttrs.placeholder;\n\n            if (typeof placeholder !== 'undefined' && placeholder[i]) {\n              return placeholder[i];\n            } else {\n              return '_';\n            }\n          }\n\n          // Generate array of mask components that will be stripped from a masked value\n          // before processing to prevent mask components from being added to the unmasked value.\n          // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.\n          // If a maskable char is followed by a mask char and has a mask\n          // char behind it, we'll split it into it's own component so if\n          // a user is aggressively deleting in the input and a char ahead\n          // of the maskable char gets deleted, we'll still be able to strip\n          // it in the unmaskValue() preprocessing.\n          function getMaskComponents() {\n            return maskPlaceholder.replace(/[_]+/g, '_').replace(/([^_]+)([a-zA-Z0-9])([^_])/g, '$1$2_$3').split('_');\n          }\n\n          function processRawMask(mask){\n            var characterCount = 0;\n\n            maskCaretMap    = [];\n            maskPatterns    = [];\n            maskPlaceholder = '';\n\n            if (typeof mask === 'string') {\n              minRequiredLength = 0;\n\n              var isOptional = false,\n                  numberOfOptionalCharacters = 0,\n                  splitMask  = mask.split('');\n\n              angular.forEach(splitMask, function (chr, i){\n                if (linkOptions.maskDefinitions[chr]) {\n\n                  maskCaretMap.push(characterCount);\n\n                  maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);\n                  maskPatterns.push(linkOptions.maskDefinitions[chr]);\n\n                  characterCount++;\n                  if (!isOptional) {\n                    minRequiredLength++;\n                  }\n                }\n                else if (chr === '?') {\n                  isOptional = true;\n                  numberOfOptionalCharacters++;\n                }\n                else {\n                  maskPlaceholder += chr;\n                  characterCount++;\n                }\n              });\n            }\n            // Caret position immediately following last position is valid.\n            maskCaretMap.push(maskCaretMap.slice().pop() + 1);\n\n            maskComponents = getMaskComponents();\n            maskProcessed  = maskCaretMap.length > 1 ? true : false;\n          }\n\n          function blurHandler(){\n            if (linkOptions.clearOnBlur) {\n              oldCaretPosition = 0;\n              oldSelectionLength = 0;\n              if (!isValid || value.length === 0) {\n                valueMasked = '';\n                iElement.val('');\n                scope.$apply(function () {\n                  controller.$setViewValue('');\n                });\n              }\n            }\n          }\n\n          function mouseDownUpHandler(e){\n            if (e.type === 'mousedown') {\n              iElement.bind('mouseout', mouseoutHandler);\n            } else {\n              iElement.unbind('mouseout', mouseoutHandler);\n            }\n          }\n\n          iElement.bind('mousedown mouseup', mouseDownUpHandler);\n\n          function mouseoutHandler(){\n            /*jshint validthis: true */\n            oldSelectionLength = getSelectionLength(this);\n            iElement.unbind('mouseout', mouseoutHandler);\n          }\n\n          function eventHandler(e){\n            /*jshint validthis: true */\n            e = e || {};\n            // Allows more efficient minification\n            var eventWhich = e.which,\n              eventType = e.type;\n\n            // Prevent shift and ctrl from mucking with old values\n            if (eventWhich === 16 || eventWhich === 91) { return;}\n\n            var val = iElement.val(),\n              valOld = oldValue,\n              valMasked,\n              valUnmasked = unmaskValue(val),\n              valUnmaskedOld = oldValueUnmasked,\n              valAltered = false,\n\n              caretPos = getCaretPosition(this) || 0,\n              caretPosOld = oldCaretPosition || 0,\n              caretPosDelta = caretPos - caretPosOld,\n              caretPosMin = maskCaretMap[0],\n              caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),\n\n              selectionLenOld = oldSelectionLength || 0,\n              isSelected = getSelectionLength(this) > 0,\n              wasSelected = selectionLenOld > 0,\n\n            // Case: Typing a character to overwrite a selection\n              isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),\n            // Case: Delete and backspace behave identically on a selection\n              isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),\n              isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes\n\n              isKeyLeftArrow = eventWhich === 37,\n            // Necessary due to \"input\" event not providing a key code\n              isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),\n              isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0 ) && !wasSelected),\n\n            // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below\n            // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of\n            // non-mask character. Also applied to click since users are (arguably) more likely to backspace\n            // a character when clicking within a filled input.\n              caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;\n\n            oldSelectionLength = getSelectionLength(this);\n\n            // These events don't require any action\n            if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup'))) {\n              return;\n            }\n\n            // Value Handling\n            // ==============\n\n            // User attempted to delete but raw value was unaffected--correct this grievous offense\n            if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {\n              while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {\n                caretPos--;\n              }\n              while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {\n                caretPos++;\n              }\n              var charIndex = maskCaretMap.indexOf(caretPos);\n              // Strip out non-mask character that user would have deleted if mask hadn't been in the way.\n              valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);\n              valAltered = true;\n            }\n\n            // Update values\n            valMasked = maskValue(valUnmasked);\n\n            oldValue = valMasked;\n            oldValueUnmasked = valUnmasked;\n            iElement.val(valMasked);\n            if (valAltered) {\n              // We've altered the raw value after it's been $digest'ed, we need to $apply the new value.\n              scope.$apply(function (){\n                controller.$setViewValue(valUnmasked);\n              });\n            }\n\n            // Caret Repositioning\n            // ===================\n\n            // Ensure that typing always places caret ahead of typed character in cases where the first char of\n            // the input is a mask char and the caret is placed at the 0 position.\n            if (isAddition && (caretPos <= caretPosMin)) {\n              caretPos = caretPosMin + 1;\n            }\n\n            if (caretBumpBack) {\n              caretPos--;\n            }\n\n            // Make sure caret is within min and max position limits\n            caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;\n\n            // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits\n            while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {\n              caretPos += caretBumpBack ? -1 : 1;\n            }\n\n            if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {\n              caretPos++;\n            }\n            oldCaretPosition = caretPos;\n            setCaretPosition(this, caretPos);\n          }\n\n          function isValidCaretPosition(pos){ return maskCaretMap.indexOf(pos) > -1; }\n\n          function getCaretPosition(input){\n            if (!input) return 0;\n            if (input.selectionStart !== undefined) {\n              return input.selectionStart;\n            } else if (document.selection) {\n              // Curse you IE\n              input.focus();\n              var selection = document.selection.createRange();\n              selection.moveStart('character', input.value ? -input.value.length : 0);\n              return selection.text.length;\n            }\n            return 0;\n          }\n\n          function setCaretPosition(input, pos){\n            if (!input) return 0;\n            if (input.offsetWidth === 0 || input.offsetHeight === 0) {\n              return; // Input's hidden\n            }\n            if (input.setSelectionRange) {\n              input.focus();\n              input.setSelectionRange(pos, pos);\n            }\n            else if (input.createTextRange) {\n              // Curse you IE\n              var range = input.createTextRange();\n              range.collapse(true);\n              range.moveEnd('character', pos);\n              range.moveStart('character', pos);\n              range.select();\n            }\n          }\n\n          function getSelectionLength(input){\n            if (!input) return 0;\n            if (input.selectionStart !== undefined) {\n              return (input.selectionEnd - input.selectionStart);\n            }\n            if (document.selection) {\n              return (document.selection.createRange().text.length);\n            }\n            return 0;\n          }\n\n          // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf\n          if (!Array.prototype.indexOf) {\n            Array.prototype.indexOf = function (searchElement /*, fromIndex */){\n              if (this === null) {\n                throw new TypeError();\n              }\n              var t = Object(this);\n              var len = t.length >>> 0;\n              if (len === 0) {\n                return -1;\n              }\n              var n = 0;\n              if (arguments.length > 1) {\n                n = Number(arguments[1]);\n                if (n !== n) { // shortcut for verifying if it's NaN\n                  n = 0;\n                } else if (n !== 0 && n !== Infinity && n !== -Infinity) {\n                  n = (n > 0 || -1) * Math.floor(Math.abs(n));\n                }\n              }\n              if (n >= len) {\n                return -1;\n              }\n              var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);\n              for (; k < len; k++) {\n                if (k in t && t[k] === searchElement) {\n                  return k;\n                }\n              }\n              return -1;\n            };\n          }\n\n        };\n      }\n    };\n  }\n]);\n\n/**\n * Add a clear button to form inputs to reset their value\n */\nangular.module('ui.reset',[]).value('uiResetConfig',null).directive('uiReset', ['uiResetConfig', function (uiResetConfig) {\n  'use strict';\n\n  var resetValue = null;\n  if (uiResetConfig !== undefined){\n      resetValue = uiResetConfig;\n  }\n  return {\n    require: 'ngModel',\n    link: function (scope, elm, attrs, ctrl) {\n      var aElement;\n      aElement = angular.element('<a class=\"ui-reset\" />');\n      elm.wrap('<span class=\"ui-resetwrap\" />').after(aElement);\n      aElement.bind('click', function (e) {\n        e.preventDefault();\n        scope.$apply(function () {\n          if (attrs.uiReset){\n            ctrl.$setViewValue(scope.$eval(attrs.uiReset));\n          }else{\n            ctrl.$setViewValue(resetValue);\n          }\n          ctrl.$render();\n        });\n      });\n    }\n  };\n}]);\n\n/**\n * Set a $uiRoute boolean to see if the current route matches\n */\nangular.module('ui.route', []).directive('uiRoute', ['$location', '$parse', function ($location, $parse) {\n  'use strict';\n\n  return {\n    restrict: 'AC',\n    scope: true,\n    compile: function(tElement, tAttrs) {\n      var useProperty;\n      if (tAttrs.uiRoute) {\n        useProperty = 'uiRoute';\n      } else if (tAttrs.ngHref) {\n        useProperty = 'ngHref';\n      } else if (tAttrs.href) {\n        useProperty = 'href';\n      } else {\n        throw new Error('uiRoute missing a route or href property on ' + tElement[0]);\n      }\n      return function ($scope, elm, attrs) {\n        var modelSetter = $parse(attrs.ngModel || attrs.routeModel || '$uiRoute').assign;\n        var watcher = angular.noop;\n\n        // Used by href and ngHref\n        function staticWatcher(newVal) {\n          var hash = newVal.indexOf('#');\n          if (hash > -1){\n            newVal = newVal.substr(hash + 1);\n          }\n          watcher = function watchHref() {\n            modelSetter($scope, ($location.path().indexOf(newVal) > -1));\n          };\n          watcher();\n        }\n        // Used by uiRoute\n        function regexWatcher(newVal) {\n          var hash = newVal.indexOf('#');\n          if (hash > -1){\n            newVal = newVal.substr(hash + 1);\n          }\n          watcher = function watchRegex() {\n            var regexp = new RegExp('^' + newVal + '$', ['i']);\n            modelSetter($scope, regexp.test($location.path()));\n          };\n          watcher();\n        }\n\n        switch (useProperty) {\n          case 'uiRoute':\n            // if uiRoute={{}} this will be undefined, otherwise it will have a value and $observe() never gets triggered\n            if (attrs.uiRoute){\n              regexWatcher(attrs.uiRoute);\n            }else{\n              attrs.$observe('uiRoute', regexWatcher);\n            }\n            break;\n          case 'ngHref':\n            // Setup watcher() every time ngHref changes\n            if (attrs.ngHref){\n              staticWatcher(attrs.ngHref);\n            }else{\n              attrs.$observe('ngHref', staticWatcher);\n            }\n            break;\n          case 'href':\n            // Setup watcher()\n            staticWatcher(attrs.href);\n        }\n\n        $scope.$on('$routeChangeSuccess', function(){\n          watcher();\n        });\n\n        //Added for compatibility with ui-router\n        $scope.$on('$stateChangeSuccess', function(){\n          watcher();\n        });\n      };\n    }\n  };\n}]);\n\nangular.module('ui.scroll.jqlite', ['ui.scroll']).service('jqLiteExtras', [\n  '$log', '$window', function(console, window) {\n    'use strict';\n\n    return {\n      registerFor: function(element) {\n        var convertToPx, css, getMeasurements, getStyle, getWidthHeight, isWindow, scrollTo;\n        css = angular.element.prototype.css;\n        element.prototype.css = function(name, value) {\n          var elem, self;\n          self = this;\n          elem = self[0];\n          if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {\n            return css.call(self, name, value);\n          }\n        };\n        isWindow = function(obj) {\n          return obj && obj.document && obj.location && obj.alert && obj.setInterval;\n        };\n        scrollTo = function(self, direction, value) {\n          var elem, method, preserve, prop, _ref;\n          elem = self[0];\n          _ref = {\n            top: ['scrollTop', 'pageYOffset', 'scrollLeft'],\n            left: ['scrollLeft', 'pageXOffset', 'scrollTop']\n          }[direction], method = _ref[0], prop = _ref[1], preserve = _ref[2];\n          if (isWindow(elem)) {\n            if (angular.isDefined(value)) {\n              return elem.scrollTo(self[preserve].call(self), value);\n            } else {\n              if (prop in elem) {\n                return elem[prop];\n              } else {\n                return elem.document.documentElement[method];\n              }\n            }\n          } else {\n            if (angular.isDefined(value)) {\n              return elem[method] = value;\n            } else {\n              return elem[method];\n            }\n          }\n        };\n        if (window.getComputedStyle) {\n          getStyle = function(elem) {\n            return window.getComputedStyle(elem, null);\n          };\n          convertToPx = function(elem, value) {\n            return parseFloat(value);\n          };\n        } else {\n          getStyle = function(elem) {\n            return elem.currentStyle;\n          };\n          convertToPx = function(elem, value) {\n            var core_pnum, left, result, rnumnonpx, rs, rsLeft, style;\n            core_pnum = /[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source;\n            rnumnonpx = new RegExp('^(' + core_pnum + ')(?!px)[a-z%]+$', 'i');\n            if (!rnumnonpx.test(value)) {\n              return parseFloat(value);\n            } else {\n              style = elem.style;\n              left = style.left;\n              rs = elem.runtimeStyle;\n              rsLeft = rs && rs.left;\n              if (rs) {\n                rs.left = style.left;\n              }\n              style.left = value;\n              result = style.pixelLeft;\n              style.left = left;\n              if (rsLeft) {\n                rs.left = rsLeft;\n              }\n              return result;\n            }\n          };\n        }\n        getMeasurements = function(elem, measure) {\n          var base, borderA, borderB, computedMarginA, computedMarginB, computedStyle, dirA, dirB, marginA, marginB, paddingA, paddingB, _ref;\n          if (isWindow(elem)) {\n            base = document.documentElement[{\n              height: 'clientHeight',\n              width: 'clientWidth'\n            }[measure]];\n            return {\n              base: base,\n              padding: 0,\n              border: 0,\n              margin: 0\n            };\n          }\n          _ref = {\n            width: [elem.offsetWidth, 'Left', 'Right'],\n            height: [elem.offsetHeight, 'Top', 'Bottom']\n          }[measure], base = _ref[0], dirA = _ref[1], dirB = _ref[2];\n          computedStyle = getStyle(elem);\n          paddingA = convertToPx(elem, computedStyle['padding' + dirA]) || 0;\n          paddingB = convertToPx(elem, computedStyle['padding' + dirB]) || 0;\n          borderA = convertToPx(elem, computedStyle['border' + dirA + 'Width']) || 0;\n          borderB = convertToPx(elem, computedStyle['border' + dirB + 'Width']) || 0;\n          computedMarginA = computedStyle['margin' + dirA];\n          computedMarginB = computedStyle['margin' + dirB];\n          marginA = convertToPx(elem, computedMarginA) || 0;\n          marginB = convertToPx(elem, computedMarginB) || 0;\n          return {\n            base: base,\n            padding: paddingA + paddingB,\n            border: borderA + borderB,\n            margin: marginA + marginB\n          };\n        };\n        getWidthHeight = function(elem, direction, measure) {\n          var computedStyle, measurements, result;\n          measurements = getMeasurements(elem, direction);\n          if (measurements.base > 0) {\n            return {\n              base: measurements.base - measurements.padding - measurements.border,\n              outer: measurements.base,\n              outerfull: measurements.base + measurements.margin\n            }[measure];\n          } else {\n            computedStyle = getStyle(elem);\n            result = computedStyle[direction];\n            if (result < 0 || result === null) {\n              result = elem.style[direction] || 0;\n            }\n            result = parseFloat(result) || 0;\n            return {\n              base: result - measurements.padding - measurements.border,\n              outer: result,\n              outerfull: result + measurements.padding + measurements.border + measurements.margin\n            }[measure];\n          }\n        };\n        return angular.forEach({\n          before: function(newElem) {\n            var children, elem, i, parent, self, _i, _ref;\n            self = this;\n            elem = self[0];\n            parent = self.parent();\n            children = parent.contents();\n            if (children[0] === elem) {\n              return parent.prepend(newElem);\n            } else {\n              for (i = _i = 1, _ref = children.length - 1; 1 <= _ref ? _i <= _ref : _i >= _ref; i = 1 <= _ref ? ++_i : --_i) {\n                if (children[i] === elem) {\n                  angular.element(children[i - 1]).after(newElem);\n                  return;\n                }\n              }\n              throw new Error('invalid DOM structure ' + elem.outerHTML);\n            }\n          },\n          height: function(value) {\n            var self;\n            self = this;\n            if (angular.isDefined(value)) {\n              if (angular.isNumber(value)) {\n                value = value + 'px';\n              }\n              return css.call(self, 'height', value);\n            } else {\n              return getWidthHeight(this[0], 'height', 'base');\n            }\n          },\n          outerHeight: function(option) {\n            return getWidthHeight(this[0], 'height', option ? 'outerfull' : 'outer');\n          },\n          /*\n          UIScroller no longer relies on jQuery method offset. The jQLite implementation of the method\n          is kept here just for the reference. Also the offset setter method was never implemented\n          */\n\n          offset: function(value) {\n            var box, doc, docElem, elem, self, win;\n            self = this;\n            if (arguments.length) {\n              if (value === void 0) {\n                return self;\n              } else {\n                throw new Error('offset setter method is not implemented');\n              }\n            }\n            box = {\n              top: 0,\n              left: 0\n            };\n            elem = self[0];\n            doc = elem && elem.ownerDocument;\n            if (!doc) {\n              return;\n            }\n            docElem = doc.documentElement;\n            if (elem.getBoundingClientRect != null) {\n              box = elem.getBoundingClientRect();\n            }\n            win = doc.defaultView || doc.parentWindow;\n            return {\n              top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),\n              left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)\n            };\n          },\n          scrollTop: function(value) {\n            return scrollTo(this, 'top', value);\n          },\n          scrollLeft: function(value) {\n            return scrollTo(this, 'left', value);\n          }\n        }, function(value, key) {\n          if (!element.prototype[key]) {\n            return element.prototype[key] = value;\n          }\n        });\n      }\n    };\n  }\n]).run([\n  '$log', '$window', 'jqLiteExtras', function(console, window, jqLiteExtras) {\n    'use strict';\n\n    if (!window.jQuery) {\n      return jqLiteExtras.registerFor(angular.element);\n    }\n  }\n]);\n\n/*\n//# sourceURL=src/scripts/ui-scroll-jqlite.js\n*/\n\n\n/*\n globals: angular, window\n\n List of used element methods available in JQuery but not in JQuery Lite\n\n element.before(elem)\n element.height()\n element.outerHeight(true)\n element.height(value) = only for Top/Bottom padding elements\n element.scrollTop()\n element.scrollTop(value)\n */\n\nangular.module('ui.scroll', []).directive('uiScrollViewport', [\n  '$log', function() {\n    'use strict';\n\n    return {\n      controller: [\n        '$scope', '$element', function(scope, element) {\n          this.viewport = element;\n          return this;\n        }\n      ]\n    };\n  }\n]).directive('uiScroll', [\n  '$log', '$injector', '$rootScope', '$timeout', function(console, $injector, $rootScope, $timeout) {\n    'use strict';\n\n    return {\n      require: ['?^uiScrollViewport'],\n      transclude: 'element',\n      priority: 1000,\n      terminal: true,\n      compile: function(elementTemplate, attr, linker) {\n        return function($scope, element, $attr, controllers) {\n          var adapter, adapterOnScope, adjustBuffer, adjustRowHeight, applyUpdate, bof, bottomVisiblePos, buffer, bufferPadding, bufferSize, builder, clipBottom, clipTop, datasource, datasourceName, doAdjustment, doDelete, doInsert, doUpdate, enqueueFetch, eof, eventListener, fetch, finalize, first, getValueChain, hideElementBeforeAppend, insert, isDatasourceValid, itemName, loading, log, match, next, pending, reload, removeFromBuffer, resizeAndScrollHandler, ridActual, scrollHeight, setValueChain, shouldLoadBottom, shouldLoadTop, showElementAfterRender, topVisible, topVisiblePos, viewport, viewportScope, wheelHandler;\n          log = console.debug || console.log;\n          match = $attr.uiScroll.match(/^\\s*(\\w+)\\s+in\\s+([\\w\\.]+)\\s*$/);\n          if (!match) {\n            throw new Error('Expected uiScroll in form of \\'_item_ in _datasource_\\' but got \\'' + $attr.uiScroll + '\\'');\n          }\n          itemName = match[1];\n          datasourceName = match[2];\n          getValueChain = function(targetScope, target) {\n            var chain;\n            if (!targetScope) {\n              return;\n            }\n            chain = target.match(/^([\\w]+)\\.(.+)$/);\n            if (!chain || chain.length !== 3) {\n              return targetScope[target];\n            }\n            return getValueChain(targetScope[chain[1]], chain[2]);\n          };\n          setValueChain = function(targetScope, target, value, doNotSet) {\n            var chain;\n            if (!targetScope || !target) {\n              return;\n            }\n            if (!(chain = target.match(/^([\\w]+)\\.(.+)$/))) {\n              if (target.indexOf('.') !== -1) {\n                return;\n              }\n            }\n            if (!chain || chain.length !== 3) {\n              if (!angular.isObject(targetScope[target]) && !doNotSet) {\n                return targetScope[target] = value;\n              }\n              return targetScope[target] = value;\n            }\n            if (!angular.isObject(targetScope[chain[1]]) && !doNotSet) {\n              targetScope[chain[1]] = {};\n            }\n            return setValueChain(targetScope[chain[1]], chain[2], value, doNotSet);\n          };\n          datasource = getValueChain($scope, datasourceName);\n          isDatasourceValid = function() {\n            return angular.isObject(datasource) && typeof datasource.get === 'function';\n          };\n          if (!isDatasourceValid()) {\n            datasource = $injector.get(datasourceName);\n            if (!isDatasourceValid()) {\n              throw new Error('' + datasourceName + ' is not a valid datasource');\n            }\n          }\n          bufferSize = Math.max(3, +$attr.bufferSize || 10);\n          bufferPadding = function() {\n            return viewport.outerHeight() * Math.max(0.1, +$attr.padding || 0.1);\n          };\n          scrollHeight = function(elem) {\n            var _ref;\n            return (_ref = elem[0].scrollHeight) != null ? _ref : elem[0].document.documentElement.scrollHeight;\n          };\n          builder = null;\n          linker($scope.$new(), function(template) {\n            var bottomPadding, createPadding, padding, repeaterType, topPadding, viewport;\n            repeaterType = template[0].localName;\n            if (repeaterType === 'dl') {\n              throw new Error('ui-scroll directive does not support <' + template[0].localName + '> as a repeating tag: ' + template[0].outerHTML);\n            }\n            if (repeaterType !== 'li' && repeaterType !== 'tr') {\n              repeaterType = 'div';\n            }\n            viewport = controllers[0] && controllers[0].viewport ? controllers[0].viewport : angular.element(window);\n            viewport.css({\n              'overflow-y': 'auto',\n              'display': 'block'\n            });\n            padding = function(repeaterType) {\n              var div, result, table;\n              switch (repeaterType) {\n                case 'tr':\n                  table = angular.element('<table><tr><td><div></div></td></tr></table>');\n                  div = table.find('div');\n                  result = table.find('tr');\n                  result.paddingHeight = function() {\n                    return div.height.apply(div, arguments);\n                  };\n                  return result;\n                default:\n                  result = angular.element('<' + repeaterType + '></' + repeaterType + '>');\n                  result.paddingHeight = result.height;\n                  return result;\n              }\n            };\n            createPadding = function(padding, element, direction) {\n              element[{\n                top: 'before',\n                bottom: 'after'\n              }[direction]](padding);\n              return {\n                paddingHeight: function() {\n                  return padding.paddingHeight.apply(padding, arguments);\n                },\n                insert: function(element) {\n                  return padding[{\n                    top: 'after',\n                    bottom: 'before'\n                  }[direction]](element);\n                }\n              };\n            };\n            topPadding = createPadding(padding(repeaterType), element, 'top');\n            bottomPadding = createPadding(padding(repeaterType), element, 'bottom');\n            $scope.$on('$destroy', template.remove);\n            return builder = {\n              viewport: viewport,\n              topPadding: topPadding.paddingHeight,\n              bottomPadding: bottomPadding.paddingHeight,\n              append: bottomPadding.insert,\n              prepend: topPadding.insert,\n              bottomDataPos: function() {\n                return scrollHeight(viewport) - bottomPadding.paddingHeight();\n              },\n              topDataPos: function() {\n                return topPadding.paddingHeight();\n              }\n            };\n          });\n          viewport = builder.viewport;\n          viewportScope = viewport.scope() || $rootScope;\n          topVisible = function(item) {\n            adapter.topVisible = item.scope[itemName];\n            adapter.topVisibleElement = item.element;\n            adapter.topVisibleScope = item.scope;\n            if ($attr.topVisible) {\n              setValueChain(viewportScope, $attr.topVisible, adapter.topVisible);\n            }\n            if ($attr.topVisibleElement) {\n              setValueChain(viewportScope, $attr.topVisibleElement, adapter.topVisibleElement);\n            }\n            if ($attr.topVisibleScope) {\n              setValueChain(viewportScope, $attr.topVisibleScope, adapter.topVisibleScope);\n            }\n            if (typeof datasource.topVisible === 'function') {\n              return datasource.topVisible(item);\n            }\n          };\n          loading = function(value) {\n            adapter.isLoading = value;\n            if ($attr.isLoading) {\n              setValueChain($scope, $attr.isLoading, value);\n            }\n            if (typeof datasource.loading === 'function') {\n              return datasource.loading(value);\n            }\n          };\n          ridActual = 0;\n          first = 1;\n          next = 1;\n          buffer = [];\n          pending = [];\n          eof = false;\n          bof = false;\n          removeFromBuffer = function(start, stop) {\n            var i, _i;\n            for (i = _i = start; start <= stop ? _i < stop : _i > stop; i = start <= stop ? ++_i : --_i) {\n              buffer[i].scope.$destroy();\n              buffer[i].element.remove();\n            }\n            return buffer.splice(start, stop - start);\n          };\n          reload = function() {\n            ridActual++;\n            first = 1;\n            next = 1;\n            removeFromBuffer(0, buffer.length);\n            builder.topPadding(0);\n            builder.bottomPadding(0);\n            pending = [];\n            eof = false;\n            bof = false;\n            return adjustBuffer(ridActual);\n          };\n          bottomVisiblePos = function() {\n            return viewport.scrollTop() + viewport.outerHeight();\n          };\n          topVisiblePos = function() {\n            return viewport.scrollTop();\n          };\n          shouldLoadBottom = function() {\n            return !eof && builder.bottomDataPos() < bottomVisiblePos() + bufferPadding();\n          };\n          clipBottom = function() {\n            var bottomHeight, i, item, itemHeight, itemTop, newRow, overage, rowTop, _i, _ref;\n            bottomHeight = 0;\n            overage = 0;\n            for (i = _i = _ref = buffer.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {\n              item = buffer[i];\n              itemTop = item.element.offset().top;\n              newRow = rowTop !== itemTop;\n              rowTop = itemTop;\n              if (newRow) {\n                itemHeight = item.element.outerHeight(true);\n              }\n              if (builder.bottomDataPos() - bottomHeight - itemHeight > bottomVisiblePos() + bufferPadding()) {\n                if (newRow) {\n                  bottomHeight += itemHeight;\n                }\n                overage++;\n                eof = false;\n              } else {\n                if (newRow) {\n                  break;\n                }\n                overage++;\n              }\n            }\n            if (overage > 0) {\n              builder.bottomPadding(builder.bottomPadding() + bottomHeight);\n              removeFromBuffer(buffer.length - overage, buffer.length);\n              return next -= overage;\n            }\n          };\n          shouldLoadTop = function() {\n            return !bof && (builder.topDataPos() > topVisiblePos() - bufferPadding());\n          };\n          clipTop = function() {\n            var item, itemHeight, itemTop, newRow, overage, rowTop, topHeight, _i, _len;\n            topHeight = 0;\n            overage = 0;\n            for (_i = 0, _len = buffer.length; _i < _len; _i++) {\n              item = buffer[_i];\n              itemTop = item.element.offset().top;\n              newRow = rowTop !== itemTop;\n              rowTop = itemTop;\n              if (newRow) {\n                itemHeight = item.element.outerHeight(true);\n              }\n              if (builder.topDataPos() + topHeight + itemHeight < topVisiblePos() - bufferPadding()) {\n                if (newRow) {\n                  topHeight += itemHeight;\n                }\n                overage++;\n                bof = false;\n              } else {\n                if (newRow) {\n                  break;\n                }\n                overage++;\n              }\n            }\n            if (overage > 0) {\n              builder.topPadding(builder.topPadding() + topHeight);\n              removeFromBuffer(0, overage);\n              return first += overage;\n            }\n          };\n          enqueueFetch = function(rid, direction) {\n            if (!adapter.isLoading) {\n              loading(true);\n            }\n            if (pending.push(direction) === 1) {\n              return fetch(rid);\n            }\n          };\n          hideElementBeforeAppend = function(element) {\n            element.displayTemp = element.css('display');\n            return element.css('display', 'none');\n          };\n          showElementAfterRender = function(element) {\n            if (element.hasOwnProperty('displayTemp')) {\n              return element.css('display', element.displayTemp);\n            }\n          };\n          insert = function(index, item) {\n            var itemScope, toBeAppended, wrapper;\n            itemScope = $scope.$new();\n            itemScope[itemName] = item;\n            toBeAppended = index > first;\n            itemScope.$index = index;\n            if (toBeAppended) {\n              itemScope.$index--;\n            }\n            wrapper = {\n              scope: itemScope\n            };\n            linker(itemScope, function(clone) {\n              wrapper.element = clone;\n              if (toBeAppended) {\n                if (index === next) {\n                  hideElementBeforeAppend(clone);\n                  builder.append(clone);\n                  return buffer.push(wrapper);\n                } else {\n                  buffer[index - first].element.after(clone);\n                  return buffer.splice(index - first + 1, 0, wrapper);\n                }\n              } else {\n                hideElementBeforeAppend(clone);\n                builder.prepend(clone);\n                return buffer.unshift(wrapper);\n              }\n            });\n            return {\n              appended: toBeAppended,\n              wrapper: wrapper\n            };\n          };\n          adjustRowHeight = function(appended, wrapper) {\n            var newHeight;\n            if (appended) {\n              return builder.bottomPadding(Math.max(0, builder.bottomPadding() - wrapper.element.outerHeight(true)));\n            } else {\n              newHeight = builder.topPadding() - wrapper.element.outerHeight(true);\n              if (newHeight >= 0) {\n                return builder.topPadding(newHeight);\n              } else {\n                return viewport.scrollTop(viewport.scrollTop() + wrapper.element.outerHeight(true));\n              }\n            }\n          };\n          doAdjustment = function(rid, finalize) {\n            var item, itemHeight, itemTop, newRow, rowTop, topHeight, _i, _len, _results;\n            if (shouldLoadBottom()) {\n              enqueueFetch(rid, true);\n            } else {\n              if (shouldLoadTop()) {\n                enqueueFetch(rid, false);\n              }\n            }\n            if (finalize) {\n              finalize(rid);\n            }\n            if (pending.length === 0) {\n              topHeight = 0;\n              _results = [];\n              for (_i = 0, _len = buffer.length; _i < _len; _i++) {\n                item = buffer[_i];\n                itemTop = item.element.offset().top;\n                newRow = rowTop !== itemTop;\n                rowTop = itemTop;\n                if (newRow) {\n                  itemHeight = item.element.outerHeight(true);\n                }\n                if (newRow && (builder.topDataPos() + topHeight + itemHeight < topVisiblePos())) {\n                  _results.push(topHeight += itemHeight);\n                } else {\n                  if (newRow) {\n                    topVisible(item);\n                  }\n                  break;\n                }\n              }\n              return _results;\n            }\n          };\n          adjustBuffer = function(rid, newItems, finalize) {\n            if (newItems && newItems.length) {\n              return $timeout(function() {\n                var elt, itemTop, row, rowTop, rows, _i, _j, _len, _len1;\n                rows = [];\n                for (_i = 0, _len = newItems.length; _i < _len; _i++) {\n                  row = newItems[_i];\n                  elt = row.wrapper.element;\n                  showElementAfterRender(elt);\n                  itemTop = elt.offset().top;\n                  if (rowTop !== itemTop) {\n                    rows.push(row);\n                    rowTop = itemTop;\n                  }\n                }\n                for (_j = 0, _len1 = rows.length; _j < _len1; _j++) {\n                  row = rows[_j];\n                  adjustRowHeight(row.appended, row.wrapper);\n                }\n                return doAdjustment(rid, finalize);\n              });\n            } else {\n              return doAdjustment(rid, finalize);\n            }\n          };\n          finalize = function(rid, newItems) {\n            return adjustBuffer(rid, newItems, function() {\n              pending.shift();\n              if (pending.length === 0) {\n                return loading(false);\n              } else {\n                return fetch(rid);\n              }\n            });\n          };\n          fetch = function(rid) {\n            var direction;\n            direction = pending[0];\n            if (direction) {\n              if (buffer.length && !shouldLoadBottom()) {\n                return finalize(rid);\n              } else {\n                return datasource.get(next, bufferSize, function(result) {\n                  var item, newItems, _i, _len;\n                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {\n                    return;\n                  }\n                  newItems = [];\n                  if (result.length < bufferSize) {\n                    eof = true;\n                    builder.bottomPadding(0);\n                  }\n                  if (result.length > 0) {\n                    clipTop();\n                    for (_i = 0, _len = result.length; _i < _len; _i++) {\n                      item = result[_i];\n                      newItems.push(insert(++next, item));\n                    }\n                  }\n                  return finalize(rid, newItems);\n                });\n              }\n            } else {\n              if (buffer.length && !shouldLoadTop()) {\n                return finalize(rid);\n              } else {\n                return datasource.get(first - bufferSize, bufferSize, function(result) {\n                  var i, newItems, _i, _ref;\n                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {\n                    return;\n                  }\n                  newItems = [];\n                  if (result.length < bufferSize) {\n                    bof = true;\n                    builder.topPadding(0);\n                  }\n                  if (result.length > 0) {\n                    if (buffer.length) {\n                      clipBottom();\n                    }\n                    for (i = _i = _ref = result.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {\n                      newItems.unshift(insert(--first, result[i]));\n                    }\n                  }\n                  return finalize(rid, newItems);\n                });\n              }\n            }\n          };\n          resizeAndScrollHandler = function() {\n            if (!$rootScope.$$phase && !adapter.isLoading) {\n              adjustBuffer();\n              return $scope.$apply();\n            }\n          };\n          wheelHandler = function(event) {\n            var scrollTop, yMax;\n            scrollTop = viewport[0].scrollTop;\n            yMax = viewport[0].scrollHeight - viewport[0].clientHeight;\n            if ((scrollTop === 0 && !bof) || (scrollTop === yMax && !eof)) {\n              return event.preventDefault();\n            }\n          };\n          viewport.bind('resize', resizeAndScrollHandler);\n          viewport.bind('scroll', resizeAndScrollHandler);\n          viewport.bind('mousewheel', wheelHandler);\n          $scope.$watch(datasource.revision, reload);\n          if (datasource.scope) {\n            eventListener = datasource.scope.$new();\n          } else {\n            eventListener = $scope.$new();\n          }\n          $scope.$on('$destroy', function() {\n            var item, _i, _len;\n            for (_i = 0, _len = buffer.length; _i < _len; _i++) {\n              item = buffer[_i];\n              item.scope.$destroy();\n              item.element.remove();\n            }\n            viewport.unbind('resize', resizeAndScrollHandler);\n            viewport.unbind('scroll', resizeAndScrollHandler);\n            return viewport.unbind('mousewheel', wheelHandler);\n          });\n          adapter = {};\n          adapter.isLoading = false;\n          applyUpdate = function(wrapper, newItems) {\n            var i, inserted, item, ndx, newItem, oldItemNdx, _i, _j, _k, _len, _len1, _len2;\n            inserted = [];\n            if (angular.isArray(newItems)) {\n              if (newItems.length) {\n                if (newItems.length === 1 && newItems[0] === wrapper.scope[itemName]) {\n                  return inserted;\n                } else {\n                  ndx = wrapper.scope.$index;\n                  if (ndx > first) {\n                    oldItemNdx = ndx - first;\n                  } else {\n                    oldItemNdx = 1;\n                  }\n                  for (i = _i = 0, _len = newItems.length; _i < _len; i = ++_i) {\n                    newItem = newItems[i];\n                    inserted.push(insert(ndx + i, newItem));\n                  }\n                  removeFromBuffer(oldItemNdx, oldItemNdx + 1);\n                  for (i = _j = 0, _len1 = buffer.length; _j < _len1; i = ++_j) {\n                    item = buffer[i];\n                    item.scope.$index = first + i;\n                  }\n                }\n              } else {\n                removeFromBuffer(wrapper.scope.$index - first, wrapper.scope.$index - first + 1);\n                next--;\n                for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {\n                  item = buffer[i];\n                  item.scope.$index = first + i;\n                }\n              }\n            }\n            return inserted;\n          };\n          adapter.applyUpdates = function(arg1, arg2) {\n            var inserted, wrapper, _i, _len, _ref, _ref1;\n            inserted = [];\n            ridActual++;\n            if (angular.isFunction(arg1)) {\n              _ref = buffer.slice(0);\n              for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n                wrapper = _ref[_i];\n                inserted.concat(inserted, applyUpdate(wrapper, arg1(wrapper.scope[itemName], wrapper.scope, wrapper.element)));\n              }\n            } else {\n              if (arg1 % 1 === 0) {\n                if ((0 <= (_ref1 = arg1 - first - 1) && _ref1 < buffer.length)) {\n                  inserted = applyUpdate(buffer[arg1 - first], arg2);\n                }\n              } else {\n                throw new Error('applyUpdates - ' + arg1 + ' is not a valid index or outside of range');\n              }\n            }\n            return adjustBuffer(ridActual, inserted);\n          };\n          if ($attr.adapter) {\n            adapterOnScope = getValueChain($scope, $attr.adapter);\n            if (!adapterOnScope) {\n              setValueChain($scope, $attr.adapter, {});\n              adapterOnScope = getValueChain($scope, $attr.adapter);\n            }\n            angular.extend(adapterOnScope, adapter);\n            adapter = adapterOnScope;\n          }\n          doUpdate = function(locator, newItem) {\n            var wrapper, _fn, _i, _len, _ref;\n            if (angular.isFunction(locator)) {\n              _fn = function(wrapper) {\n                return locator(wrapper.scope);\n              };\n              for (_i = 0, _len = buffer.length; _i < _len; _i++) {\n                wrapper = buffer[_i];\n                _fn(wrapper);\n              }\n            } else {\n              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {\n                buffer[locator - first - 1].scope[itemName] = newItem;\n              }\n            }\n            return null;\n          };\n          doDelete = function(locator) {\n            var i, item, temp, wrapper, _fn, _i, _j, _k, _len, _len1, _len2, _ref;\n            if (angular.isFunction(locator)) {\n              temp = [];\n              for (_i = 0, _len = buffer.length; _i < _len; _i++) {\n                item = buffer[_i];\n                temp.unshift(item);\n              }\n              _fn = function(wrapper) {\n                if (locator(wrapper.scope)) {\n                  removeFromBuffer(temp.length - 1 - i, temp.length - i);\n                  return next--;\n                }\n              };\n              for (i = _j = 0, _len1 = temp.length; _j < _len1; i = ++_j) {\n                wrapper = temp[i];\n                _fn(wrapper);\n              }\n            } else {\n              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {\n                removeFromBuffer(locator - first - 1, locator - first);\n                next--;\n              }\n            }\n            for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {\n              item = buffer[i];\n              item.scope.$index = first + i;\n            }\n            return adjustBuffer();\n          };\n          doInsert = function(locator, item) {\n            var i, inserted, _i, _len, _ref;\n            inserted = [];\n            if (angular.isFunction(locator)) {\n              throw new Error('not implemented - Insert with locator function');\n            } else {\n              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {\n                inserted.push(insert(locator, item));\n                next++;\n              }\n            }\n            for (i = _i = 0, _len = buffer.length; _i < _len; i = ++_i) {\n              item = buffer[i];\n              item.scope.$index = first + i;\n            }\n            return adjustBuffer(null, inserted);\n          };\n          eventListener.$on('insert.item', function(event, locator, item) {\n            return doInsert(locator, item);\n          });\n          eventListener.$on('update.items', function(event, locator, newItem) {\n            return doUpdate(locator, newItem);\n          });\n          return eventListener.$on('delete.items', function(event, locator) {\n            return doDelete(locator);\n          });\n        };\n      }\n    };\n  }\n]);\n\n/*\n//# sourceURL=src/scripts/ui-scroll.js\n*/\n\n\n/**\n * Adds a 'ui-scrollfix' class to the element when the page scrolls past it's position.\n * @param [offset] {int} optional Y-offset to override the detected offset.\n *   Takes 300 (absolute) or -300 or +300 (relative to detected)\n */\nangular.module('ui.scrollfix',[]).directive('uiScrollfix', ['$window', function ($window) {\n  'use strict';\n\n  function getWindowScrollTop() {\n    if (angular.isDefined($window.pageYOffset)) {\n      return $window.pageYOffset;\n    } else {\n      var iebody = (document.compatMode && document.compatMode !== 'BackCompat') ? document.documentElement : document.body;\n      return iebody.scrollTop;\n    }\n  }\n  return {\n    require: '^?uiScrollfixTarget',\n    link: function (scope, elm, attrs, uiScrollfixTarget) {\n      var absolute = true,\n          shift = 0,\n          fixLimit,\n          $target = uiScrollfixTarget && uiScrollfixTarget.$element || angular.element($window);\n\n      if (!attrs.uiScrollfix) {\n          absolute = false;\n      } else if (typeof(attrs.uiScrollfix) === 'string') {\n        // charAt is generally faster than indexOf: http://jsperf.com/indexof-vs-charat\n        if (attrs.uiScrollfix.charAt(0) === '-') {\n          absolute = false;\n          shift = - parseFloat(attrs.uiScrollfix.substr(1));\n        } else if (attrs.uiScrollfix.charAt(0) === '+') {\n          absolute = false;\n          shift = parseFloat(attrs.uiScrollfix.substr(1));\n        }\n      }\n\n      fixLimit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;\n\n      function onScroll() {\n\n        var limit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;\n\n        // if pageYOffset is defined use it, otherwise use other crap for IE\n        var offset = uiScrollfixTarget ? $target[0].scrollTop : getWindowScrollTop();\n        if (!elm.hasClass('ui-scrollfix') && offset > limit) {\n          elm.addClass('ui-scrollfix');\n          fixLimit = limit;\n        } else if (elm.hasClass('ui-scrollfix') && offset < fixLimit) {\n          elm.removeClass('ui-scrollfix');\n        }\n      }\n\n      $target.on('scroll', onScroll);\n\n      // Unbind scroll event handler when directive is removed\n      scope.$on('$destroy', function() {\n        $target.off('scroll', onScroll);\n      });\n    }\n  };\n}]).directive('uiScrollfixTarget', [function () {\n  'use strict';\n  return {\n    controller: ['$element', function($element) {\n      this.$element = $element;\n    }]\n  };\n}]);\n\n/**\n * uiShow Directive\n *\n * Adds a 'ui-show' class to the element instead of display:block\n * Created to allow tighter control  of CSS without bulkier directives\n *\n * @param expression {boolean} evaluated expression to determine if the class should be added\n */\nangular.module('ui.showhide',[])\n.directive('uiShow', [function () {\n  'use strict';\n\n  return function (scope, elm, attrs) {\n    scope.$watch(attrs.uiShow, function (newVal) {\n      if (newVal) {\n        elm.addClass('ui-show');\n      } else {\n        elm.removeClass('ui-show');\n      }\n    });\n  };\n}])\n\n/**\n * uiHide Directive\n *\n * Adds a 'ui-hide' class to the element instead of display:block\n * Created to allow tighter control  of CSS without bulkier directives\n *\n * @param expression {boolean} evaluated expression to determine if the class should be added\n */\n.directive('uiHide', [function () {\n  'use strict';\n\n  return function (scope, elm, attrs) {\n    scope.$watch(attrs.uiHide, function (newVal) {\n      if (newVal) {\n        elm.addClass('ui-hide');\n      } else {\n        elm.removeClass('ui-hide');\n      }\n    });\n  };\n}])\n\n/**\n * uiToggle Directive\n *\n * Adds a class 'ui-show' if true, and a 'ui-hide' if false to the element instead of display:block/display:none\n * Created to allow tighter control  of CSS without bulkier directives. This also allows you to override the\n * default visibility of the element using either class.\n *\n * @param expression {boolean} evaluated expression to determine if the class should be added\n */\n.directive('uiToggle', [function () {\n  'use strict';\n\n  return function (scope, elm, attrs) {\n    scope.$watch(attrs.uiToggle, function (newVal) {\n      if (newVal) {\n        elm.removeClass('ui-hide').addClass('ui-show');\n      } else {\n        elm.removeClass('ui-show').addClass('ui-hide');\n      }\n    });\n  };\n}]);\n\n/**\n * Filters out all duplicate items from an array by checking the specified key\n * @param [key] {string} the name of the attribute of each object to compare for uniqueness\n if the key is empty, the entire object will be compared\n if the key === false then no filtering will be performed\n * @return {array}\n */\nangular.module('ui.unique',[]).filter('unique', ['$parse', function ($parse) {\n  'use strict';\n\n  return function (items, filterOn) {\n\n    if (filterOn === false) {\n      return items;\n    }\n\n    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {\n      var newItems = [],\n        get = angular.isString(filterOn) ? $parse(filterOn) : function (item) { return item; };\n\n      var extractValueToCompare = function (item) {\n        return angular.isObject(item) ? get(item) : item;\n      };\n\n      angular.forEach(items, function (item) {\n        var isDuplicate = false;\n\n        for (var i = 0; i < newItems.length; i++) {\n          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {\n            isDuplicate = true;\n            break;\n          }\n        }\n        if (!isDuplicate) {\n          newItems.push(item);\n        }\n\n      });\n      items = newItems;\n    }\n    return items;\n  };\n}]);\n\n/*\n * Author: Remy Alain Ticona Carbajal http://realtica.org\n * Description: The main objective of ng-uploader is to have a user control,\n * clean, simple, customizable, and above all very easy to implement.\n * Licence: MIT\n */\n\nangular.module('ui.uploader', []).service('uiUploader', uiUploader);\n\nuiUploader.$inject = ['$log'];\n\nfunction uiUploader($log) {\n    'use strict';\n\n    /*jshint validthis: true */\n    var self = this;\n    self.files = [];\n    self.options = {};\n    self.activeUploads = 0;\n    $log.info('uiUploader loaded');\n    \n    function addFiles(files) {\n        for (var i = 0; i < files.length; i++) {\n            self.files.push(files[i]);\n        }\n    }\n\n    function getFiles() {\n        return self.files;\n    }\n\n    function startUpload(options) {\n        self.options = options;\n        for (var i = 0; i < self.files.length; i++) {\n            if (self.activeUploads == self.options.concurrency) {\n                break;\n            }\n            if (self.files[i].active)\n                continue;\n            ajaxUpload(self.files[i], self.options.url);\n        }\n    }\n    \n    function removeFile(file){\n        self.files.splice(self.files.indexOf(file),1);\n    }\n    \n    function removeAll(){\n        self.files.splice(0,self.files.length);\n    }\n    \n    return {\n        addFiles: addFiles,\n        getFiles: getFiles,\n        files: self.files,\n        startUpload: startUpload,\n        removeFile: removeFile,\n        removeAll:removeAll\n    };\n    \n    function getHumanSize(bytes) {\n        var sizes = ['n/a', 'bytes', 'KiB', 'MiB', 'GiB', 'TB', 'PB', 'EiB', 'ZiB', 'YiB'];\n        var i = +Math.floor(Math.log(bytes) / Math.log(1024));\n        return (bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0) + ' ' + sizes[isNaN(bytes) ? 0 : i + 1];\n    }\n\n    function ajaxUpload(file, url) {\n        var xhr, formData, prop, data = '',\n            key = '' || 'file';\n        self.activeUploads += 1;\n        file.active = true;\n        xhr = new window.XMLHttpRequest();\n        formData = new window.FormData();\n        xhr.open('POST', url);\n\n        // Triggered when upload starts:\n        xhr.upload.onloadstart = function() {};\n\n        // Triggered many times during upload:\n        xhr.upload.onprogress = function(event) {\n            if (!event.lengthComputable) {\n                return;\n            }\n            // Update file size because it might be bigger than reported by\n            // the fileSize:\n            //$log.info(\"progres..\");\n            //console.info(event.loaded);\n            file.loaded = event.loaded;\n            file.humanSize = getHumanSize(event.loaded);\n            self.options.onProgress(file);\n        };\n\n        // Triggered when upload is completed:\n        xhr.onload = function() {\n            self.activeUploads -= 1;\n            startUpload(self.options);\n            self.options.onCompleted(file, xhr.responseText);\n        };\n\n        // Triggered when upload fails:\n        xhr.onerror = function() {};\n\n        // Append additional data if provided:\n        if (data) {\n            for (prop in data) {\n                if (data.hasOwnProperty(prop)) {\n                    formData.append(prop, data[prop]);\n                }\n            }\n        }\n\n        // Append file data:\n        formData.append(key, file, file.name);\n\n        // Initiate upload:\n        xhr.send(formData);\n\n        return xhr;\n    }\n\n}\n\n/**\r\n * General-purpose validator for ngModel.\r\n * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using\r\n * an arbitrary validation function requires creation of a custom formatters and / or parsers.\r\n * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).\r\n * A validator function will trigger validation on both model and input changes.\r\n *\r\n * @example <input ui-validate=\" 'myValidatorFunction($value)' \">\r\n * @example <input ui-validate=\"{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }\">\r\n * @example <input ui-validate=\"{ foo : '$value > anotherModel' }\" ui-validate-watch=\" 'anotherModel' \">\r\n * @example <input ui-validate=\"{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }\" ui-validate-watch=\" { foo : 'anotherModel' } \">\r\n *\r\n * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.\r\n * If an object literal is passed a key denotes a validation error key while a value should be a validator function.\r\n * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.\r\n */\r\nangular.module('ui.validate',[]).directive('uiValidate', function () {\r\n  'use strict';\r\n\r\n  return {\r\n    restrict: 'A',\r\n    require: 'ngModel',\r\n    link: function (scope, elm, attrs, ctrl) {\r\n      var validateFn, validators = {},\r\n          validateExpr = scope.$eval(attrs.uiValidate);\r\n\r\n      if (!validateExpr){ return;}\r\n\r\n      if (angular.isString(validateExpr)) {\r\n        validateExpr = { validator: validateExpr };\r\n      }\r\n\r\n      angular.forEach(validateExpr, function (exprssn, key) {\r\n        validateFn = function (valueToValidate) {\r\n          var expression = scope.$eval(exprssn, { '$value' : valueToValidate });\r\n          if (angular.isObject(expression) && angular.isFunction(expression.then)) {\r\n            // expression is a promise\r\n            expression.then(function(){\r\n              ctrl.$setValidity(key, true);\r\n            }, function(){\r\n              ctrl.$setValidity(key, false);\r\n            });\r\n            return valueToValidate;\r\n          } else if (expression) {\r\n            // expression is true\r\n            ctrl.$setValidity(key, true);\r\n            return valueToValidate;\r\n          } else {\r\n            // expression is false\r\n            ctrl.$setValidity(key, false);\r\n            return valueToValidate;\r\n          }\r\n        };\r\n        validators[key] = validateFn;\r\n        ctrl.$formatters.push(validateFn);\r\n        ctrl.$parsers.push(validateFn);\r\n      });\r\n\r\n      function apply_watch(watch)\r\n      {\r\n          //string - update all validators on expression change\r\n          if (angular.isString(watch))\r\n          {\r\n              scope.$watch(watch, function(){\r\n                  angular.forEach(validators, function(validatorFn){\r\n                      validatorFn(ctrl.$modelValue);\r\n                  });\r\n              });\r\n              return;\r\n          }\r\n\r\n          //array - update all validators on change of any expression\r\n          if (angular.isArray(watch))\r\n          {\r\n              angular.forEach(watch, function(expression){\r\n                  scope.$watch(expression, function()\r\n                  {\r\n                      angular.forEach(validators, function(validatorFn){\r\n                          validatorFn(ctrl.$modelValue);\r\n                      });\r\n                  });\r\n              });\r\n              return;\r\n          }\r\n\r\n          //object - update appropriate validator\r\n          if (angular.isObject(watch))\r\n          {\r\n              angular.forEach(watch, function(expression, validatorKey)\r\n              {\r\n                  //value is string - look after one expression\r\n                  if (angular.isString(expression))\r\n                  {\r\n                      scope.$watch(expression, function(){\r\n                          validators[validatorKey](ctrl.$modelValue);\r\n                      });\r\n                  }\r\n\r\n                  //value is array - look after all expressions in array\r\n                  if (angular.isArray(expression))\r\n                  {\r\n                      angular.forEach(expression, function(intExpression)\r\n                      {\r\n                          scope.$watch(intExpression, function(){\r\n                              validators[validatorKey](ctrl.$modelValue);\r\n                          });\r\n                      });\r\n                  }\r\n              });\r\n          }\r\n      }\r\n      // Support for ui-validate-watch\r\n      if (attrs.uiValidateWatch){\r\n          apply_watch( scope.$eval(attrs.uiValidateWatch) );\r\n      }\r\n    }\r\n  };\r\n});\r\n\nangular.module('ui.utils',  [\n  'ui.event',\n  'ui.format',\n  'ui.highlight',\n  'ui.include',\n  'ui.indeterminate',\n  'ui.inflector',\n  'ui.jq',\n  'ui.keypress',\n  'ui.mask',\n  'ui.reset',\n  'ui.route',\n  'ui.scrollfix',\n  'ui.scroll',\n  'ui.scroll.jqlite',\n  'ui.showhide',\n  'ui.unique',\n  'ui.validate'\n]);\n"

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1504))

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	module.exports = "!function(a,b){\"object\"==typeof exports&&\"undefined\"!=typeof module?module.exports=b():\"function\"==typeof define&&define.amd?define(b):a.proj4=b()}(this,function(){\"use strict\";function a(a,b){if(a[b])return a[b];for(var c,d,e=Object.keys(a),f=b.toLowerCase().replace(Ub,\"\"),g=-1;++g<e.length;)if(c=e[g],d=c.toLowerCase().replace(Ub,\"\"),d===f)return a[c]}function b(a){if(\"string\"!=typeof a)throw new Error(\"not a string\");this.text=a.trim(),this.level=0,this.place=0,this.root=null,this.stack=[],this.currentObject=null,this.state=Wb}function c(a){var c=new b(a);return c.output()}function d(a,b,c){Array.isArray(b)&&(c.unshift(b),b=null);var d=b?{}:a,f=c.reduce(function(a,b){return e(b,a),a},d);b&&(a[b]=f)}function e(a,b){if(!Array.isArray(a))return void(b[a]=!0);var c=a.shift();if(\"PARAMETER\"===c&&(c=a.shift()),1===a.length)return Array.isArray(a[0])?(b[c]={},void e(a[0],b[c])):void(b[c]=a[0]);if(!a.length)return void(b[c]=!0);if(\"TOWGS84\"===c)return void(b[c]=a);Array.isArray(c)||(b[c]={});var f;switch(c){case\"UNIT\":case\"PRIMEM\":case\"VERT_DATUM\":return b[c]={name:a[0].toLowerCase(),convert:a[1]},void(3===a.length&&e(a[2],b[c]));case\"SPHEROID\":case\"ELLIPSOID\":return b[c]={name:a[0],a:a[1],rf:a[2]},void(4===a.length&&e(a[3],b[c]));case\"PROJECTEDCRS\":case\"PROJCRS\":case\"GEOGCS\":case\"GEOCCS\":case\"PROJCS\":case\"LOCAL_CS\":case\"GEODCRS\":case\"GEODETICCRS\":case\"GEODETICDATUM\":case\"EDATUM\":case\"ENGINEERINGDATUM\":case\"VERT_CS\":case\"VERTCRS\":case\"VERTICALCRS\":case\"COMPD_CS\":case\"COMPOUNDCRS\":case\"ENGINEERINGCRS\":case\"ENGCRS\":case\"FITTED_CS\":case\"LOCAL_DATUM\":case\"DATUM\":return a[0]=[\"name\",a[0]],void d(b,c,a);default:for(f=-1;++f<a.length;)if(!Array.isArray(a[f]))return e(a,b[c]);return d(b,c,a)}}function f(a,b){var c=b[0],d=b[1];!(c in a)&&d in a&&(a[c]=a[d],3===b.length&&(a[c]=b[2](a[c])))}function g(a){return a*fc}function h(a){function b(b){var c=a.to_meter||1;return b*c}\"GEOGCS\"===a.type?a.projName=\"longlat\":\"LOCAL_CS\"===a.type?(a.projName=\"identity\",a.local=!0):\"object\"==typeof a.PROJECTION?a.projName=Object.keys(a.PROJECTION)[0]:a.projName=a.PROJECTION,a.UNIT&&(a.units=a.UNIT.name.toLowerCase(),\"metre\"===a.units&&(a.units=\"meter\"),a.UNIT.convert&&(\"GEOGCS\"===a.type?a.DATUM&&a.DATUM.SPHEROID&&(a.to_meter=a.UNIT.convert*a.DATUM.SPHEROID.a):(a.to_meter=a.UNIT.convert,10)));var c=a.GEOGCS;\"GEOGCS\"===a.type&&(c=a),c&&(c.DATUM?a.datumCode=c.DATUM.name.toLowerCase():a.datumCode=c.name.toLowerCase(),\"d_\"===a.datumCode.slice(0,2)&&(a.datumCode=a.datumCode.slice(2)),\"new_zealand_geodetic_datum_1949\"!==a.datumCode&&\"new_zealand_1949\"!==a.datumCode||(a.datumCode=\"nzgd49\"),\"wgs_1984\"===a.datumCode&&(\"Mercator_Auxiliary_Sphere\"===a.PROJECTION&&(a.sphere=!0),a.datumCode=\"wgs84\"),\"_ferro\"===a.datumCode.slice(-6)&&(a.datumCode=a.datumCode.slice(0,-6)),\"_jakarta\"===a.datumCode.slice(-8)&&(a.datumCode=a.datumCode.slice(0,-8)),~a.datumCode.indexOf(\"belge\")&&(a.datumCode=\"rnb72\"),c.DATUM&&c.DATUM.SPHEROID&&(a.ellps=c.DATUM.SPHEROID.name.replace(\"_19\",\"\").replace(/[Cc]larke\\_18/,\"clrk\"),\"international\"===a.ellps.toLowerCase().slice(0,13)&&(a.ellps=\"intl\"),a.a=c.DATUM.SPHEROID.a,a.rf=parseFloat(c.DATUM.SPHEROID.rf,10)),~a.datumCode.indexOf(\"osgb_1936\")&&(a.datumCode=\"osgb36\"),~a.datumCode.indexOf(\"osni_1952\")&&(a.datumCode=\"osni52\"),(~a.datumCode.indexOf(\"tm65\")||~a.datumCode.indexOf(\"geodetic_datum_of_1965\"))&&(a.datumCode=\"ire65\")),a.b&&!isFinite(a.b)&&(a.b=a.a);var d=function(b){return f(a,b)},e=[[\"standard_parallel_1\",\"Standard_Parallel_1\"],[\"standard_parallel_2\",\"Standard_Parallel_2\"],[\"false_easting\",\"False_Easting\"],[\"false_northing\",\"False_Northing\"],[\"central_meridian\",\"Central_Meridian\"],[\"latitude_of_origin\",\"Latitude_Of_Origin\"],[\"latitude_of_origin\",\"Central_Parallel\"],[\"scale_factor\",\"Scale_Factor\"],[\"k0\",\"scale_factor\"],[\"latitude_of_center\",\"Latitude_of_center\"],[\"lat0\",\"latitude_of_center\",g],[\"longitude_of_center\",\"Longitude_Of_Center\"],[\"longc\",\"longitude_of_center\",g],[\"x0\",\"false_easting\",b],[\"y0\",\"false_northing\",b],[\"long0\",\"central_meridian\",g],[\"lat0\",\"latitude_of_origin\",g],[\"lat0\",\"standard_parallel_1\",g],[\"lat1\",\"standard_parallel_1\",g],[\"lat2\",\"standard_parallel_2\",g],[\"alpha\",\"azimuth\",g],[\"srsCode\",\"name\"]];e.forEach(d),a.long0||!a.longc||\"Albers_Conic_Equal_Area\"!==a.projName&&\"Lambert_Azimuthal_Equal_Area\"!==a.projName||(a.long0=a.longc),a.lat_ts||!a.lat1||\"Stereographic_South_Pole\"!==a.projName&&\"Polar Stereographic (variant B)\"!==a.projName||(a.lat0=g(a.lat1>0?90:-90),a.lat_ts=a.lat1)}function i(a){var b=this;if(2===arguments.length){var c=arguments[1];\"string\"==typeof c?\"+\"===c.charAt(0)?i[a]=Vb(arguments[1]):i[a]=gc(arguments[1]):i[a]=c}else if(1===arguments.length){if(Array.isArray(a))return a.map(function(a){Array.isArray(a)?i.apply(b,a):i(a)});if(\"string\"==typeof a){if(a in i)return i[a]}else\"EPSG\"in a?i[\"EPSG:\"+a.EPSG]=a:\"ESRI\"in a?i[\"ESRI:\"+a.ESRI]=a:\"IAU2000\"in a?i[\"IAU2000:\"+a.IAU2000]=a:console.log(a);return}}function j(a){return\"string\"==typeof a}function k(a){return a in i}function l(a){return hc.some(function(b){return a.indexOf(b)>-1})}function m(a){return\"+\"===a[0]}function n(a){return j(a)?k(a)?i[a]:l(a)?gc(a):m(a)?Vb(a):void 0:a}function o(){var a=this.b/this.a;this.es=1-a*a,\"x0\"in this||(this.x0=0),\"y0\"in this||(this.y0=0),this.e=Math.sqrt(this.es),this.lat_ts?this.sphere?this.k0=Math.cos(this.lat_ts):this.k0=jc(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts)):this.k0||(this.k?this.k0=this.k:this.k0=1)}function p(a){var b=a.x,c=a.y;if(c*Ob>90&&-90>c*Ob&&b*Ob>180&&-180>b*Ob)return null;var d,e;if(Math.abs(Math.abs(c)-Ib)<=Mb)return null;if(this.sphere)d=this.x0+this.a*this.k0*lc(b-this.long0),e=this.y0+this.a*this.k0*Math.log(Math.tan(Pb+.5*c));else{var f=Math.sin(c),g=mc(this.e,c,f);d=this.x0+this.a*this.k0*lc(b-this.long0),e=this.y0-this.a*this.k0*Math.log(g)}return a.x=d,a.y=e,a}function q(a){var b,c,d=a.x-this.x0,e=a.y-this.y0;if(this.sphere)c=Ib-2*Math.atan(Math.exp(-e/(this.a*this.k0)));else{var f=Math.exp(-e/(this.a*this.k0));if(c=nc(this.e,f),-9999===c)return null}return b=lc(this.long0+d/(this.a*this.k0)),a.x=b,a.y=c,a}function r(){}function s(a){return a}function t(a,b){var c=uc.length;return a.names?(uc[c]=a,a.names.forEach(function(a){tc[a.toLowerCase()]=c}),this):(console.log(b),!0)}function u(a){if(!a)return!1;var b=a.toLowerCase();return\"undefined\"!=typeof tc[b]&&uc[tc[b]]?uc[tc[b]]:void 0}function v(){sc.forEach(t)}function w(a,b,c,d){var e=a*a,f=b*b,g=(e-f)/e,h=0;d?(a*=1-g*(Jb+g*(Kb+g*Lb)),e=a*a,g=0):h=Math.sqrt(g);var i=(e-f)/f;return{es:g,e:h,ep2:i}}function x(b,c,d,e,f){if(!b){var g=a(wc,e);g||(g=xc),b=g.a,c=g.b,d=g.rf}return d&&!c&&(c=(1-1/d)*b),(0===d||Math.abs(b-c)<Mb)&&(f=!0,c=b),{a:b,b:c,rf:d,sphere:f}}function y(a,b,c,d,e,f){var g={};return void 0===a||\"none\"===a?g.datum_type=Gb:g.datum_type=Fb,b&&(g.datum_params=b.map(parseFloat),0===g.datum_params[0]&&0===g.datum_params[1]&&0===g.datum_params[2]||(g.datum_type=Db),g.datum_params.length>3&&(0===g.datum_params[3]&&0===g.datum_params[4]&&0===g.datum_params[5]&&0===g.datum_params[6]||(g.datum_type=Eb,g.datum_params[3]*=Hb,g.datum_params[4]*=Hb,g.datum_params[5]*=Hb,g.datum_params[6]=g.datum_params[6]/1e6+1))),g.a=c,g.b=d,g.es=e,g.ep2=f,g}function z(b,c){if(!(this instanceof z))return new z(b);c=c||function(a){if(a)throw a};var d=n(b);if(\"object\"!=typeof d)return void c(b);var e=z.projections.get(d.projName);if(!e)return void c(b);if(d.datumCode&&\"none\"!==d.datumCode){var f=a(yc,d.datumCode);f&&(d.datum_params=f.towgs84?f.towgs84.split(\",\"):null,d.ellps=f.ellipse,d.datumName=f.datumName?f.datumName:d.datumCode)}d.k0=d.k0||1,d.axis=d.axis||\"enu\",d.ellps=d.ellps||\"wgs84\";var g=x(d.a,d.b,d.rf,d.ellps,d.sphere),h=w(g.a,g.b,g.rf,d.R_A),i=d.datum||y(d.datumCode,d.datum_params,g.a,g.b,h.es,h.ep2);ic(this,d),ic(this,e),this.a=g.a,this.b=g.b,this.rf=g.rf,this.sphere=g.sphere,this.es=h.es,this.e=h.e,this.ep2=h.ep2,this.datum=i,this.init(),c(null,this)}function A(a,b){return a.datum_type!==b.datum_type?!1:a.a!==b.a||Math.abs(a.es-b.es)>5e-11?!1:a.datum_type===Db?a.datum_params[0]===b.datum_params[0]&&a.datum_params[1]===b.datum_params[1]&&a.datum_params[2]===b.datum_params[2]:a.datum_type===Eb?a.datum_params[0]===b.datum_params[0]&&a.datum_params[1]===b.datum_params[1]&&a.datum_params[2]===b.datum_params[2]&&a.datum_params[3]===b.datum_params[3]&&a.datum_params[4]===b.datum_params[4]&&a.datum_params[5]===b.datum_params[5]&&a.datum_params[6]===b.datum_params[6]:!0}function B(a,b,c){var d,e,f,g,h=a.x,i=a.y,j=a.z?a.z:0;if(-Ib>i&&i>-1.001*Ib)i=-Ib;else if(i>Ib&&1.001*Ib>i)i=Ib;else if(-Ib>i||i>Ib)return null;return h>Math.PI&&(h-=2*Math.PI),e=Math.sin(i),g=Math.cos(i),f=e*e,d=c/Math.sqrt(1-b*f),{x:(d+j)*g*Math.cos(h),y:(d+j)*g*Math.sin(h),z:(d*(1-b)+j)*e}}function C(a,b,c,d){var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u=1e-12,v=u*u,w=30,x=a.x,y=a.y,z=a.z?a.z:0;if(e=Math.sqrt(x*x+y*y),f=Math.sqrt(x*x+y*y+z*z),u>e/c){if(r=0,u>f/c)return s=Ib,t=-d,{x:a.x,y:a.y,z:a.z}}else r=Math.atan2(y,x);g=z/f,h=e/f,i=1/Math.sqrt(1-b*(2-b)*h*h),l=h*(1-b)*i,m=g*i,q=0;do q++,k=c/Math.sqrt(1-b*m*m),t=e*l+z*m-k*(1-b*m*m),j=b*k/(k+t),i=1/Math.sqrt(1-j*(2-j)*h*h),n=h*(1-j)*i,o=g*i,p=o*l-n*m,l=n,m=o;while(p*p>v&&w>q);return s=Math.atan(o/Math.abs(n)),{x:r,y:s,z:t}}function D(a,b,c){if(b===Db)return{x:a.x+c[0],y:a.y+c[1],z:a.z+c[2]};if(b===Eb){var d=c[0],e=c[1],f=c[2],g=c[3],h=c[4],i=c[5],j=c[6];return{x:j*(a.x-i*a.y+h*a.z)+d,y:j*(i*a.x+a.y-g*a.z)+e,z:j*(-h*a.x+g*a.y+a.z)+f}}}function E(a,b,c){if(b===Db)return{x:a.x-c[0],y:a.y-c[1],z:a.z-c[2]};if(b===Eb){var d=c[0],e=c[1],f=c[2],g=c[3],h=c[4],i=c[5],j=c[6],k=(a.x-d)/j,l=(a.y-e)/j,m=(a.z-f)/j;return{x:k+i*l-h*m,y:-i*k+l+g*m,z:h*k-g*l+m}}}function F(a){return a===Db||a===Eb}function G(a){if(\"function\"==typeof Number.isFinite){if(Number.isFinite(a))return;throw new TypeError(\"coordinates must be finite numbers\")}if(\"number\"!=typeof a||a!==a||!isFinite(a))throw new TypeError(\"coordinates must be finite numbers\")}function H(a,b){return(a.datum.datum_type===Db||a.datum.datum_type===Eb)&&\"WGS84\"!==b.datumCode||(b.datum.datum_type===Db||b.datum.datum_type===Eb)&&\"WGS84\"!==a.datumCode}function I(a,b,c){var d;return Array.isArray(c)&&(c=Bc(c)),Cc(c),a.datum&&b.datum&&H(a,b)&&(d=new z(\"WGS84\"),c=I(a,d,c),a=d),\"enu\"!==a.axis&&(c=Ac(a,!1,c)),\"longlat\"===a.projName?c={x:c.x*Nb,y:c.y*Nb}:(a.to_meter&&(c={x:c.x*a.to_meter,y:c.y*a.to_meter}),c=a.inverse(c)),a.from_greenwich&&(c.x+=a.from_greenwich),c=zc(a.datum,b.datum,c),b.from_greenwich&&(c={x:c.x-b.from_greenwich,y:c.y}),\"longlat\"===b.projName?c={x:c.x*Ob,y:c.y*Ob}:(c=b.forward(c),b.to_meter&&(c={x:c.x/b.to_meter,y:c.y/b.to_meter})),\"enu\"!==b.axis?Ac(b,!0,c):c}function J(a,b,c){var d,e,f;return Array.isArray(c)?(d=I(a,b,c),3===c.length?[d.x,d.y,d.z]:[d.x,d.y]):(e=I(a,b,c),f=Object.keys(c),2===f.length?e:(f.forEach(function(a){\"x\"!==a&&\"y\"!==a&&(e[a]=c[a])}),e))}function K(a){return a instanceof z?a:a.oProj?a.oProj:z(a)}function L(a,b,c){a=K(a);var d,e=!1;return\"undefined\"==typeof b?(b=a,a=Dc,e=!0):(\"undefined\"!=typeof b.x||Array.isArray(b))&&(c=b,b=a,a=Dc,e=!0),b=K(b),c?J(a,b,c):(d={forward:function(c){return J(a,b,c)},inverse:function(c){return J(b,a,c)}},e&&(d.oProj=b),d)}function M(a,b){return b=b||5,U(R({lat:a[1],lon:a[0]}),b)}function N(a){var b=S(Y(a.toUpperCase()));return b.lat&&b.lon?[b.lon,b.lat,b.lon,b.lat]:[b.left,b.bottom,b.right,b.top]}function O(a){var b=S(Y(a.toUpperCase()));return b.lat&&b.lon?[b.lon,b.lat]:[(b.left+b.right)/2,(b.top+b.bottom)/2]}function P(a){return a*(Math.PI/180)}function Q(a){return 180*(a/Math.PI)}function R(a){var b,c,d,e,f,g,h,i,j,k=a.lat,l=a.lon,m=6378137,n=.00669438,o=.9996,p=P(k),q=P(l);j=Math.floor((l+180)/6)+1,180===l&&(j=60),k>=56&&64>k&&l>=3&&12>l&&(j=32),k>=72&&84>k&&(l>=0&&9>l?j=31:l>=9&&21>l?j=33:l>=21&&33>l?j=35:l>=33&&42>l&&(j=37)),b=6*(j-1)-180+3,i=P(b),c=n/(1-n),d=m/Math.sqrt(1-n*Math.sin(p)*Math.sin(p)),e=Math.tan(p)*Math.tan(p),f=c*Math.cos(p)*Math.cos(p),g=Math.cos(p)*(q-i),h=m*((1-n/4-3*n*n/64-5*n*n*n/256)*p-(3*n/8+3*n*n/32+45*n*n*n/1024)*Math.sin(2*p)+(15*n*n/256+45*n*n*n/1024)*Math.sin(4*p)-35*n*n*n/3072*Math.sin(6*p));var r=o*d*(g+(1-e+f)*g*g*g/6+(5-18*e+e*e+72*f-58*c)*g*g*g*g*g/120)+5e5,s=o*(h+d*Math.tan(p)*(g*g/2+(5-e+9*f+4*f*f)*g*g*g*g/24+(61-58*e+e*e+600*f-330*c)*g*g*g*g*g*g/720));return 0>k&&(s+=1e7),{northing:Math.round(s),easting:Math.round(r),zoneNumber:j,zoneLetter:T(k)}}function S(a){var b=a.northing,c=a.easting,d=a.zoneLetter,e=a.zoneNumber;if(0>e||e>60)return null;var f,g,h,i,j,k,l,m,n,o,p=.9996,q=6378137,r=.00669438,s=(1-Math.sqrt(1-r))/(1+Math.sqrt(1-r)),t=c-5e5,u=b;\"N\">d&&(u-=1e7),m=6*(e-1)-180+3,f=r/(1-r),l=u/p,n=l/(q*(1-r/4-3*r*r/64-5*r*r*r/256)),o=n+(3*s/2-27*s*s*s/32)*Math.sin(2*n)+(21*s*s/16-55*s*s*s*s/32)*Math.sin(4*n)+151*s*s*s/96*Math.sin(6*n),g=q/Math.sqrt(1-r*Math.sin(o)*Math.sin(o)),h=Math.tan(o)*Math.tan(o),i=f*Math.cos(o)*Math.cos(o),j=q*(1-r)/Math.pow(1-r*Math.sin(o)*Math.sin(o),1.5),k=t/(g*p);var v=o-g*Math.tan(o)/j*(k*k/2-(5+3*h+10*i-4*i*i-9*f)*k*k*k*k/24+(61+90*h+298*i+45*h*h-252*f-3*i*i)*k*k*k*k*k*k/720);v=Q(v);var w=(k-(1+2*h+i)*k*k*k/6+(5-2*i+28*h-3*i*i+8*f+24*h*h)*k*k*k*k*k/120)/Math.cos(o);w=m+Q(w);var x;if(a.accuracy){var y=S({northing:a.northing+a.accuracy,easting:a.easting+a.accuracy,zoneLetter:a.zoneLetter,zoneNumber:a.zoneNumber});x={top:y.lat,right:y.lon,bottom:v,left:w}}else x={lat:v,lon:w};return x}function T(a){var b=\"Z\";return 84>=a&&a>=72?b=\"X\":72>a&&a>=64?b=\"W\":64>a&&a>=56?b=\"V\":56>a&&a>=48?b=\"U\":48>a&&a>=40?b=\"T\":40>a&&a>=32?b=\"S\":32>a&&a>=24?b=\"R\":24>a&&a>=16?b=\"Q\":16>a&&a>=8?b=\"P\":8>a&&a>=0?b=\"N\":0>a&&a>=-8?b=\"M\":-8>a&&a>=-16?b=\"L\":-16>a&&a>=-24?b=\"K\":-24>a&&a>=-32?b=\"J\":-32>a&&a>=-40?b=\"H\":-40>a&&a>=-48?b=\"G\":-48>a&&a>=-56?b=\"F\":-56>a&&a>=-64?b=\"E\":-64>a&&a>=-72?b=\"D\":-72>a&&a>=-80&&(b=\"C\"),b}function U(a,b){var c=\"00000\"+a.easting,d=\"00000\"+a.northing;return a.zoneNumber+a.zoneLetter+V(a.easting,a.northing,a.zoneNumber)+c.substr(c.length-5,b)+d.substr(d.length-5,b)}function V(a,b,c){var d=W(c),e=Math.floor(a/1e5),f=Math.floor(b/1e5)%20;return X(e,f,d)}function W(a){var b=a%Ec;return 0===b&&(b=Ec),b}function X(a,b,c){var d=c-1,e=Fc.charCodeAt(d),f=Gc.charCodeAt(d),g=e+a-1,h=f+b,i=!1;g>Lc&&(g=g-Lc+Hc-1,i=!0),(g===Ic||Ic>e&&g>Ic||(g>Ic||Ic>e)&&i)&&g++,(g===Jc||Jc>e&&g>Jc||(g>Jc||Jc>e)&&i)&&(g++,g===Ic&&g++),g>Lc&&(g=g-Lc+Hc-1),h>Kc?(h=h-Kc+Hc-1,i=!0):i=!1,(h===Ic||Ic>f&&h>Ic||(h>Ic||Ic>f)&&i)&&h++,(h===Jc||Jc>f&&h>Jc||(h>Jc||Jc>f)&&i)&&(h++,h===Ic&&h++),h>Kc&&(h=h-Kc+Hc-1);var j=String.fromCharCode(g)+String.fromCharCode(h);return j}function Y(a){if(a&&0===a.length)throw\"MGRSPoint coverting from nothing\";for(var b,c=a.length,d=null,e=\"\",f=0;!/[A-Z]/.test(b=a.charAt(f));){if(f>=2)throw\"MGRSPoint bad conversion from: \"+a;e+=b,f++}var g=parseInt(e,10);if(0===f||f+3>c)throw\"MGRSPoint bad conversion from: \"+a;var h=a.charAt(f++);if(\"A\">=h||\"B\"===h||\"Y\"===h||h>=\"Z\"||\"I\"===h||\"O\"===h)throw\"MGRSPoint zone letter \"+h+\" not handled: \"+a;d=a.substring(f,f+=2);for(var i=W(g),j=Z(d.charAt(0),i),k=$(d.charAt(1),i);k<_(h);)k+=2e6;var l=c-f;if(l%2!==0)throw\"MGRSPoint has to have an even number \\nof digits after the zone letter and two 100km letters - front \\nhalf for easting meters, second half for \\nnorthing meters\"+a;var m,n,o,p,q,r=l/2,s=0,t=0;return r>0&&(m=1e5/Math.pow(10,r),n=a.substring(f,f+r),s=parseFloat(n)*m,o=a.substring(f+r),t=parseFloat(o)*m),p=s+j,q=t+k,{easting:p,northing:q,zoneLetter:h,zoneNumber:g,accuracy:m}}function Z(a,b){for(var c=Fc.charCodeAt(b-1),d=1e5,e=!1;c!==a.charCodeAt(0);){if(c++,c===Ic&&c++,c===Jc&&c++,c>Lc){if(e)throw\"Bad character: \"+a;c=Hc,e=!0}d+=1e5}return d}function $(a,b){if(a>\"V\")throw\"MGRSPoint given invalid Northing \"+a;for(var c=Gc.charCodeAt(b-1),d=0,e=!1;c!==a.charCodeAt(0);){if(c++,c===Ic&&c++,c===Jc&&c++,c>Kc){if(e)throw\"Bad character: \"+a;c=Hc,e=!0}d+=1e5}return d}function _(a){var b;switch(a){case\"C\":b=11e5;break;case\"D\":b=2e6;break;case\"E\":b=28e5;break;case\"F\":b=37e5;break;case\"G\":b=46e5;break;case\"H\":b=55e5;break;case\"J\":b=64e5;break;case\"K\":b=73e5;break;case\"L\":b=82e5;break;case\"M\":b=91e5;break;case\"N\":b=0;break;case\"P\":b=8e5;break;case\"Q\":b=17e5;break;case\"R\":b=26e5;break;case\"S\":b=35e5;break;case\"T\":b=44e5;break;case\"U\":b=53e5;break;case\"V\":b=62e5;break;case\"W\":b=7e6;break;case\"X\":b=79e5;break;default:b=-1}if(b>=0)return b;throw\"Invalid zone letter: \"+a}function Point(a,b,c){if(!(this instanceof Point))return new Point(a,b,c);if(Array.isArray(a))this.x=a[0],this.y=a[1],this.z=a[2]||0;else if(\"object\"==typeof a)this.x=a.x,this.y=a.y,this.z=a.z||0;else if(\"string\"==typeof a&&\"undefined\"==typeof b){var d=a.split(\",\");this.x=parseFloat(d[0],10),this.y=parseFloat(d[1],10),this.z=parseFloat(d[2],10)||0}else this.x=a,this.y=b,this.z=c||0;console.warn(\"proj4.Point will be removed in version 3, use proj4.toPoint\")}function aa(){this.x0=void 0!==this.x0?this.x0:0,this.y0=void 0!==this.y0?this.y0:0,this.long0=void 0!==this.long0?this.long0:0,this.lat0=void 0!==this.lat0?this.lat0:0,this.es&&(this.en=$c(this.es),this.ml0=_c(this.lat0,Math.sin(this.lat0),Math.cos(this.lat0),this.en))}function ba(a){var b,c,d,e=a.x,f=a.y,g=lc(e-this.long0),h=Math.sin(f),i=Math.cos(f);if(this.es){var j=i*g,k=Math.pow(j,2),l=this.ep2*Math.pow(i,2),m=Math.pow(l,2),n=Math.abs(i)>Mb?Math.tan(f):0,o=Math.pow(n,2),p=Math.pow(o,2);b=1-this.es*Math.pow(h,2),j/=Math.sqrt(b);var q=_c(f,h,i,this.en);c=this.a*(this.k0*j*(1+k/6*(1-o+l+k/20*(5-18*o+p+14*l-58*o*l+k/42*(61+179*p-p*o-479*o)))))+this.x0,d=this.a*(this.k0*(q-this.ml0+h*g*j/2*(1+k/12*(5-o+9*l+4*m+k/30*(61+p-58*o+270*l-330*o*l+k/56*(1385+543*p-p*o-3111*o))))))+this.y0}else{var r=i*Math.sin(g);if(Math.abs(Math.abs(r)-1)<Mb)return 93;if(c=.5*this.a*this.k0*Math.log((1+r)/(1-r))+this.x0,d=i*Math.cos(g)/Math.sqrt(1-Math.pow(r,2)),r=Math.abs(d),r>=1){if(r-1>Mb)return 93;d=0}else d=Math.acos(d);0>f&&(d=-d),d=this.a*this.k0*(d-this.lat0)+this.y0}return a.x=c,a.y=d,a}function ca(a){var b,c,d,e,f=(a.x-this.x0)*(1/this.a),g=(a.y-this.y0)*(1/this.a);if(this.es)if(b=this.ml0+g/this.k0,c=bd(b,this.es,this.en),Math.abs(c)<Ib){var h=Math.sin(c),i=Math.cos(c),j=Math.abs(i)>Mb?Math.tan(c):0,k=this.ep2*Math.pow(i,2),l=Math.pow(k,2),m=Math.pow(j,2),n=Math.pow(m,2);b=1-this.es*Math.pow(h,2);var o=f*Math.sqrt(b)/this.k0,p=Math.pow(o,2);b*=j,d=c-b*p/(1-this.es)*.5*(1-p/12*(5+3*m-9*k*m+k-4*l-p/30*(61+90*m-252*k*m+45*n+46*k-p/56*(1385+3633*m+4095*n+1574*n*m)))),e=lc(this.long0+o*(1-p/6*(1+2*m+k-p/20*(5+28*m+24*n+8*k*m+6*k-p/42*(61+662*m+1320*n+720*n*m))))/i)}else d=Ib*kc(g),e=0;else{var q=Math.exp(f/this.k0),r=.5*(q-1/q),s=this.lat0+g/this.k0,t=Math.cos(s);b=Math.sqrt((1-Math.pow(t,2))/(1+Math.pow(r,2))),d=Math.asin(b),0>g&&(d=-d),e=0===r&&0===t?0:lc(Math.atan2(r,t)+this.long0)}return a.x=e,a.y=d,a}function da(){if(void 0===this.es||this.es<=0)throw new Error(\"incorrect elliptical usage\");this.x0=void 0!==this.x0?this.x0:0,this.y0=void 0!==this.y0?this.y0:0,this.long0=void 0!==this.long0?this.long0:0,this.lat0=void 0!==this.lat0?this.lat0:0,this.cgb=[],this.cbg=[],this.utg=[],this.gtu=[];var a=this.es/(1+Math.sqrt(1-this.es)),b=a/(2-a),c=b;this.cgb[0]=b*(2+b*(-2/3+b*(-2+b*(116/45+b*(26/45+b*(-2854/675)))))),this.cbg[0]=b*(-2+b*(2/3+b*(4/3+b*(-82/45+b*(32/45+b*(4642/4725)))))),c*=b,this.cgb[1]=c*(7/3+b*(-1.6+b*(-227/45+b*(2704/315+b*(2323/945))))),this.cbg[1]=c*(5/3+b*(-16/15+b*(-13/9+b*(904/315+b*(-1522/945))))),c*=b,this.cgb[2]=c*(56/15+b*(-136/35+b*(-1262/105+b*(73814/2835)))),this.cbg[2]=c*(-26/15+b*(34/21+b*(1.6+b*(-12686/2835)))),c*=b,this.cgb[3]=c*(4279/630+b*(-332/35+b*(-399572/14175))),this.cbg[3]=c*(1237/630+b*(-2.4+b*(-24832/14175))),c*=b,this.cgb[4]=c*(4174/315+b*(-144838/6237)),this.cbg[4]=c*(-734/315+b*(109598/31185)),c*=b,this.cgb[5]=c*(601676/22275),this.cbg[5]=c*(444337/155925),c=Math.pow(b,2),this.Qn=this.k0/(1+b)*(1+c*(.25+c*(1/64+c/256))),this.utg[0]=b*(-.5+b*(2/3+b*(-37/96+b*(1/360+b*(81/512+b*(-96199/604800)))))),this.gtu[0]=b*(.5+b*(-2/3+b*(5/16+b*(41/180+b*(-127/288+b*(7891/37800)))))),this.utg[1]=c*(-1/48+b*(-1/15+b*(437/1440+b*(-46/105+b*(1118711/3870720))))),this.gtu[1]=c*(13/48+b*(-0.6+b*(557/1440+b*(281/630+b*(-1983433/1935360))))),c*=b,this.utg[2]=c*(-17/480+b*(37/840+b*(209/4480+b*(-5569/90720)))),this.gtu[2]=c*(61/240+b*(-103/140+b*(15061/26880+b*(167603/181440)))),c*=b,this.utg[3]=c*(-4397/161280+b*(11/504+b*(830251/7257600))),this.gtu[3]=c*(49561/161280+b*(-179/168+b*(6601661/7257600))),c*=b,this.utg[4]=c*(-4583/161280+b*(108847/3991680)),this.gtu[4]=c*(34729/80640+b*(-3418889/1995840)),c*=b,this.utg[5]=c*(-20648693/638668800),this.gtu[5]=.6650675310896665*c;var d=id(this.cbg,this.lat0);this.Zb=-this.Qn*(d+jd(this.gtu,2*d))}function ea(a){var b=lc(a.x-this.long0),c=a.y;c=id(this.cbg,c);var d=Math.sin(c),e=Math.cos(c),f=Math.sin(b),g=Math.cos(b);c=Math.atan2(d,g*e),b=Math.atan2(f*e,fd(d,e*g)),b=hd(Math.tan(b));var h=ld(this.gtu,2*c,2*b);c+=h[0],b+=h[1];var i,j;return Math.abs(b)<=2.623395162778?(i=this.a*(this.Qn*b)+this.x0,j=this.a*(this.Qn*c+this.Zb)+this.y0):(i=1/0,j=1/0),a.x=i,a.y=j,a}function fa(a){var b=(a.x-this.x0)*(1/this.a),c=(a.y-this.y0)*(1/this.a);c=(c-this.Zb)/this.Qn,b/=this.Qn;var d,e;if(Math.abs(b)<=2.623395162778){var f=ld(this.utg,2*c,2*b);c+=f[0],b+=f[1],b=Math.atan(ed(b));var g=Math.sin(c),h=Math.cos(c),i=Math.sin(b),j=Math.cos(b);c=Math.atan2(g*j,fd(i,j*h)),b=Math.atan2(i,j*h),d=lc(b+this.long0),e=id(this.cgb,c)}else d=1/0,e=1/0;return a.x=d,a.y=e,a}function ga(){var a=od(this.zone,this.long0);if(void 0===a)throw new Error(\"unknown utm zone\");this.lat0=0,this.long0=(6*Math.abs(a)-183)*Nb,this.x0=5e5,this.y0=this.utmSouth?1e7:0,this.k0=.9996,nd.init.apply(this),this.forward=nd.forward,this.inverse=nd.inverse}function ha(){var a=Math.sin(this.lat0),b=Math.cos(this.lat0);b*=b,this.rc=Math.sqrt(1-this.es)/(1-this.es*a*a),this.C=Math.sqrt(1+this.es*b*b/(1-this.es)),this.phic0=Math.asin(a/this.C),this.ratexp=.5*this.C*this.e,this.K=Math.tan(.5*this.phic0+Pb)/(Math.pow(Math.tan(.5*this.lat0+Pb),this.C)*sd(this.e*a,this.ratexp))}function ia(a){var b=a.x,c=a.y;return a.y=2*Math.atan(this.K*Math.pow(Math.tan(.5*c+Pb),this.C)*sd(this.e*Math.sin(c),this.ratexp))-Ib,a.x=this.C*b,a}function ja(a){for(var b=1e-14,c=a.x/this.C,d=a.y,e=Math.pow(Math.tan(.5*d+Pb)/this.K,1/this.C),f=td;f>0&&(d=2*Math.atan(e*sd(this.e*Math.sin(a.y),-.5*this.e))-Ib,!(Math.abs(d-a.y)<b));--f)a.y=d;return f?(a.x=c,a.y=d,a):null}function ka(){vd.init.apply(this),this.rc&&(this.sinc0=Math.sin(this.phic0),this.cosc0=Math.cos(this.phic0),this.R2=2*this.rc,this.title||(this.title=\"Oblique Stereographic Alternative\"))}function la(a){var b,c,d,e;return a.x=lc(a.x-this.long0),vd.forward.apply(this,[a]),b=Math.sin(a.y),c=Math.cos(a.y),d=Math.cos(a.x),e=this.k0*this.R2/(1+this.sinc0*b+this.cosc0*c*d),a.x=e*c*Math.sin(a.x),a.y=e*(this.cosc0*b-this.sinc0*c*d),a.x=this.a*a.x+this.x0,a.y=this.a*a.y+this.y0,a}function ma(a){var b,c,d,e,f;if(a.x=(a.x-this.x0)/this.a,a.y=(a.y-this.y0)/this.a,a.x/=this.k0,a.y/=this.k0,f=Math.sqrt(a.x*a.x+a.y*a.y)){var g=2*Math.atan2(f,this.R2);b=Math.sin(g),c=Math.cos(g),e=Math.asin(c*this.sinc0+a.y*b*this.cosc0/f),d=Math.atan2(a.x*b,f*this.cosc0*c-a.y*this.sinc0*b)}else e=this.phic0,d=0;return a.x=d,a.y=e,vd.inverse.apply(this,[a]),a.x=lc(a.x+this.long0),a}function na(a,b,c){return b*=c,Math.tan(.5*(Ib+a))*Math.pow((1-b)/(1+b),.5*c)}function oa(){this.coslat0=Math.cos(this.lat0),this.sinlat0=Math.sin(this.lat0),this.sphere?1===this.k0&&!isNaN(this.lat_ts)&&Math.abs(this.coslat0)<=Mb&&(this.k0=.5*(1+kc(this.lat0)*Math.sin(this.lat_ts))):(Math.abs(this.coslat0)<=Mb&&(this.lat0>0?this.con=1:this.con=-1),this.cons=Math.sqrt(Math.pow(1+this.e,1+this.e)*Math.pow(1-this.e,1-this.e)),1===this.k0&&!isNaN(this.lat_ts)&&Math.abs(this.coslat0)<=Mb&&(this.k0=.5*this.cons*jc(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts))/mc(this.e,this.con*this.lat_ts,this.con*Math.sin(this.lat_ts))),this.ms1=jc(this.e,this.sinlat0,this.coslat0),this.X0=2*Math.atan(this.ssfn_(this.lat0,this.sinlat0,this.e))-Ib,this.cosX0=Math.cos(this.X0),this.sinX0=Math.sin(this.X0))}function pa(a){var b,c,d,e,f,g,h=a.x,i=a.y,j=Math.sin(i),k=Math.cos(i),l=lc(h-this.long0);return Math.abs(Math.abs(h-this.long0)-Math.PI)<=Mb&&Math.abs(i+this.lat0)<=Mb?(a.x=NaN,a.y=NaN,a):this.sphere?(b=2*this.k0/(1+this.sinlat0*j+this.coslat0*k*Math.cos(l)),a.x=this.a*b*k*Math.sin(l)+this.x0,a.y=this.a*b*(this.coslat0*j-this.sinlat0*k*Math.cos(l))+this.y0,a):(c=2*Math.atan(this.ssfn_(i,j,this.e))-Ib,e=Math.cos(c),d=Math.sin(c),Math.abs(this.coslat0)<=Mb?(f=mc(this.e,i*this.con,this.con*j),g=2*this.a*this.k0*f/this.cons,a.x=this.x0+g*Math.sin(h-this.long0),a.y=this.y0-this.con*g*Math.cos(h-this.long0),a):(Math.abs(this.sinlat0)<Mb?(b=2*this.a*this.k0/(1+e*Math.cos(l)),a.y=b*d):(b=2*this.a*this.k0*this.ms1/(this.cosX0*(1+this.sinX0*d+this.cosX0*e*Math.cos(l))),a.y=b*(this.cosX0*d-this.sinX0*e*Math.cos(l))+this.y0),a.x=b*e*Math.sin(l)+this.x0,a))}function qa(a){a.x-=this.x0,a.y-=this.y0;var b,c,d,e,f,g=Math.sqrt(a.x*a.x+a.y*a.y);if(this.sphere){var h=2*Math.atan(g/(.5*this.a*this.k0));return b=this.long0,c=this.lat0,Mb>=g?(a.x=b,a.y=c,a):(c=Math.asin(Math.cos(h)*this.sinlat0+a.y*Math.sin(h)*this.coslat0/g),b=lc(Math.abs(this.coslat0)<Mb?this.lat0>0?this.long0+Math.atan2(a.x,-1*a.y):this.long0+Math.atan2(a.x,a.y):this.long0+Math.atan2(a.x*Math.sin(h),g*this.coslat0*Math.cos(h)-a.y*this.sinlat0*Math.sin(h))),a.x=b,a.y=c,a)}if(Math.abs(this.coslat0)<=Mb){if(Mb>=g)return c=this.lat0,b=this.long0,a.x=b,a.y=c,a;a.x*=this.con,a.y*=this.con,d=g*this.cons/(2*this.a*this.k0),c=this.con*nc(this.e,d),b=this.con*lc(this.con*this.long0+Math.atan2(a.x,-1*a.y))}else e=2*Math.atan(g*this.cosX0/(2*this.a*this.k0*this.ms1)),b=this.long0,Mb>=g?f=this.X0:(f=Math.asin(Math.cos(e)*this.sinX0+a.y*Math.sin(e)*this.cosX0/g),b=lc(this.long0+Math.atan2(a.x*Math.sin(e),g*this.cosX0*Math.cos(e)-a.y*this.sinX0*Math.sin(e)))),c=-1*nc(this.e,Math.tan(.5*(Ib+f)));return a.x=b,a.y=c,a}function ra(){var a=this.lat0;this.lambda0=this.long0;var b=Math.sin(a),c=this.a,d=this.rf,e=1/d,f=2*e-Math.pow(e,2),g=this.e=Math.sqrt(f);this.R=this.k0*c*Math.sqrt(1-f)/(1-f*Math.pow(b,2)),this.alpha=Math.sqrt(1+f/(1-f)*Math.pow(Math.cos(a),4)),this.b0=Math.asin(b/this.alpha);var h=Math.log(Math.tan(Math.PI/4+this.b0/2)),i=Math.log(Math.tan(Math.PI/4+a/2)),j=Math.log((1+g*b)/(1-g*b));this.K=h-this.alpha*i+this.alpha*g/2*j}function sa(a){var b=Math.log(Math.tan(Math.PI/4-a.y/2)),c=this.e/2*Math.log((1+this.e*Math.sin(a.y))/(1-this.e*Math.sin(a.y))),d=-this.alpha*(b+c)+this.K,e=2*(Math.atan(Math.exp(d))-Math.PI/4),f=this.alpha*(a.x-this.lambda0),g=Math.atan(Math.sin(f)/(Math.sin(this.b0)*Math.tan(e)+Math.cos(this.b0)*Math.cos(f))),h=Math.asin(Math.cos(this.b0)*Math.sin(e)-Math.sin(this.b0)*Math.cos(e)*Math.cos(f));return a.y=this.R/2*Math.log((1+Math.sin(h))/(1-Math.sin(h)))+this.y0,a.x=this.R*g+this.x0,a}function ta(a){for(var b=a.x-this.x0,c=a.y-this.y0,d=b/this.R,e=2*(Math.atan(Math.exp(c/this.R))-Math.PI/4),f=Math.asin(Math.cos(this.b0)*Math.sin(e)+Math.sin(this.b0)*Math.cos(e)*Math.cos(d)),g=Math.atan(Math.sin(d)/(Math.cos(this.b0)*Math.cos(d)-Math.sin(this.b0)*Math.tan(e))),h=this.lambda0+g/this.alpha,i=0,j=f,k=-1e3,l=0;Math.abs(j-k)>1e-7;){if(++l>20)return;i=1/this.alpha*(Math.log(Math.tan(Math.PI/4+f/2))-this.K)+this.e*Math.log(Math.tan(Math.PI/4+Math.asin(this.e*Math.sin(j))/2)),k=j,j=2*Math.atan(Math.exp(i))-Math.PI/2}return a.x=h,a.y=j,a}function ua(){this.no_off=this.no_off||!1,this.no_rot=this.no_rot||!1,isNaN(this.k0)&&(this.k0=1);var a=Math.sin(this.lat0),b=Math.cos(this.lat0),c=this.e*a;this.bl=Math.sqrt(1+this.es/(1-this.es)*Math.pow(b,4)),this.al=this.a*this.bl*this.k0*Math.sqrt(1-this.es)/(1-c*c);var d=mc(this.e,this.lat0,a),e=this.bl/b*Math.sqrt((1-this.es)/(1-c*c));1>e*e&&(e=1);var f,g;if(isNaN(this.longc)){var h=mc(this.e,this.lat1,Math.sin(this.lat1)),i=mc(this.e,this.lat2,Math.sin(this.lat2));this.lat0>=0?this.el=(e+Math.sqrt(e*e-1))*Math.pow(d,this.bl):this.el=(e-Math.sqrt(e*e-1))*Math.pow(d,this.bl);var j=Math.pow(h,this.bl),k=Math.pow(i,this.bl);f=this.el/j,g=.5*(f-1/f);var l=(this.el*this.el-k*j)/(this.el*this.el+k*j),m=(k-j)/(k+j),n=lc(this.long1-this.long2);this.long0=.5*(this.long1+this.long2)-Math.atan(l*Math.tan(.5*this.bl*n)/m)/this.bl,this.long0=lc(this.long0);var o=lc(this.long1-this.long0);this.gamma0=Math.atan(Math.sin(this.bl*o)/g),this.alpha=Math.asin(e*Math.sin(this.gamma0))}else f=this.lat0>=0?e+Math.sqrt(e*e-1):e-Math.sqrt(e*e-1),this.el=f*Math.pow(d,this.bl),g=.5*(f-1/f),this.gamma0=Math.asin(Math.sin(this.alpha)/e),this.long0=this.longc-Math.asin(g*Math.tan(this.gamma0))/this.bl;this.no_off?this.uc=0:this.lat0>=0?this.uc=this.al/this.bl*Math.atan2(Math.sqrt(e*e-1),Math.cos(this.alpha)):this.uc=-1*this.al/this.bl*Math.atan2(Math.sqrt(e*e-1),Math.cos(this.alpha))}function va(a){var b,c,d,e=a.x,f=a.y,g=lc(e-this.long0);if(Math.abs(Math.abs(f)-Ib)<=Mb)d=f>0?-1:1,c=this.al/this.bl*Math.log(Math.tan(Pb+d*this.gamma0*.5)),b=-1*d*Ib*this.al/this.bl;else{var h=mc(this.e,f,Math.sin(f)),i=this.el/Math.pow(h,this.bl),j=.5*(i-1/i),k=.5*(i+1/i),l=Math.sin(this.bl*g),m=(j*Math.sin(this.gamma0)-l*Math.cos(this.gamma0))/k;c=Math.abs(Math.abs(m)-1)<=Mb?Number.POSITIVE_INFINITY:.5*this.al*Math.log((1-m)/(1+m))/this.bl,b=Math.abs(Math.cos(this.bl*g))<=Mb?this.al*this.bl*g:this.al*Math.atan2(j*Math.cos(this.gamma0)+l*Math.sin(this.gamma0),Math.cos(this.bl*g))/this.bl}return this.no_rot?(a.x=this.x0+b,a.y=this.y0+c):(b-=this.uc,a.x=this.x0+c*Math.cos(this.alpha)+b*Math.sin(this.alpha),a.y=this.y0+b*Math.cos(this.alpha)-c*Math.sin(this.alpha)),a}function wa(a){var b,c;this.no_rot?(c=a.y-this.y0,b=a.x-this.x0):(c=(a.x-this.x0)*Math.cos(this.alpha)-(a.y-this.y0)*Math.sin(this.alpha),b=(a.y-this.y0)*Math.cos(this.alpha)+(a.x-this.x0)*Math.sin(this.alpha),b+=this.uc);var d=Math.exp(-1*this.bl*c/this.al),e=.5*(d-1/d),f=.5*(d+1/d),g=Math.sin(this.bl*b/this.al),h=(g*Math.cos(this.gamma0)+e*Math.sin(this.gamma0))/f,i=Math.pow(this.el/Math.sqrt((1+h)/(1-h)),1/this.bl);return Math.abs(h-1)<Mb?(a.x=this.long0,a.y=Ib):Math.abs(h+1)<Mb?(a.x=this.long0,a.y=-1*Ib):(a.y=nc(this.e,i),a.x=lc(this.long0-Math.atan2(e*Math.cos(this.gamma0)-g*Math.sin(this.gamma0),Math.cos(this.bl*b/this.al))/this.bl)),a}function xa(){if(this.lat2||(this.lat2=this.lat1),this.k0||(this.k0=1),this.x0=this.x0||0,this.y0=this.y0||0,!(Math.abs(this.lat1+this.lat2)<Mb)){var a=this.b/this.a;this.e=Math.sqrt(1-a*a);var b=Math.sin(this.lat1),c=Math.cos(this.lat1),d=jc(this.e,b,c),e=mc(this.e,this.lat1,b),f=Math.sin(this.lat2),g=Math.cos(this.lat2),h=jc(this.e,f,g),i=mc(this.e,this.lat2,f),j=mc(this.e,this.lat0,Math.sin(this.lat0));Math.abs(this.lat1-this.lat2)>Mb?this.ns=Math.log(d/h)/Math.log(e/i):this.ns=b,isNaN(this.ns)&&(this.ns=b),this.f0=d/(this.ns*Math.pow(e,this.ns)),this.rh=this.a*this.f0*Math.pow(j,this.ns),this.title||(this.title=\"Lambert Conformal Conic\")}}function ya(a){var b=a.x,c=a.y;Math.abs(2*Math.abs(c)-Math.PI)<=Mb&&(c=kc(c)*(Ib-2*Mb));var d,e,f=Math.abs(Math.abs(c)-Ib);if(f>Mb)d=mc(this.e,c,Math.sin(c)),e=this.a*this.f0*Math.pow(d,this.ns);else{if(f=c*this.ns,0>=f)return null;e=0}var g=this.ns*lc(b-this.long0);return a.x=this.k0*(e*Math.sin(g))+this.x0,a.y=this.k0*(this.rh-e*Math.cos(g))+this.y0,a}function za(a){var b,c,d,e,f,g=(a.x-this.x0)/this.k0,h=this.rh-(a.y-this.y0)/this.k0;this.ns>0?(b=Math.sqrt(g*g+h*h),c=1):(b=-Math.sqrt(g*g+h*h),c=-1);var i=0;if(0!==b&&(i=Math.atan2(c*g,c*h)),0!==b||this.ns>0){if(c=1/this.ns,d=Math.pow(b/(this.a*this.f0),c),e=nc(this.e,d),-9999===e)return null}else e=-Ib;return f=lc(i/this.ns+this.long0),a.x=f,a.y=e,a}function Aa(){this.a=6377397.155,this.es=.006674372230614,this.e=Math.sqrt(this.es),this.lat0||(this.lat0=.863937979737193),this.long0||(this.long0=.4334234309119251),this.k0||(this.k0=.9999),this.s45=.785398163397448,this.s90=2*this.s45,this.fi0=this.lat0,this.e2=this.es,this.e=Math.sqrt(this.e2),this.alfa=Math.sqrt(1+this.e2*Math.pow(Math.cos(this.fi0),4)/(1-this.e2)),this.uq=1.04216856380474,this.u0=Math.asin(Math.sin(this.fi0)/this.alfa),this.g=Math.pow((1+this.e*Math.sin(this.fi0))/(1-this.e*Math.sin(this.fi0)),this.alfa*this.e/2),this.k=Math.tan(this.u0/2+this.s45)/Math.pow(Math.tan(this.fi0/2+this.s45),this.alfa)*this.g,\nthis.k1=this.k0,this.n0=this.a*Math.sqrt(1-this.e2)/(1-this.e2*Math.pow(Math.sin(this.fi0),2)),this.s0=1.37008346281555,this.n=Math.sin(this.s0),this.ro0=this.k1*this.n0/Math.tan(this.s0),this.ad=this.s90-this.uq}function Ba(a){var b,c,d,e,f,g,h,i=a.x,j=a.y,k=lc(i-this.long0);return b=Math.pow((1+this.e*Math.sin(j))/(1-this.e*Math.sin(j)),this.alfa*this.e/2),c=2*(Math.atan(this.k*Math.pow(Math.tan(j/2+this.s45),this.alfa)/b)-this.s45),d=-k*this.alfa,e=Math.asin(Math.cos(this.ad)*Math.sin(c)+Math.sin(this.ad)*Math.cos(c)*Math.cos(d)),f=Math.asin(Math.cos(c)*Math.sin(d)/Math.cos(e)),g=this.n*f,h=this.ro0*Math.pow(Math.tan(this.s0/2+this.s45),this.n)/Math.pow(Math.tan(e/2+this.s45),this.n),a.y=h*Math.cos(g)/1,a.x=h*Math.sin(g)/1,this.czech||(a.y*=-1,a.x*=-1),a}function Ca(a){var b,c,d,e,f,g,h,i,j=a.x;a.x=a.y,a.y=j,this.czech||(a.y*=-1,a.x*=-1),g=Math.sqrt(a.x*a.x+a.y*a.y),f=Math.atan2(a.y,a.x),e=f/Math.sin(this.s0),d=2*(Math.atan(Math.pow(this.ro0/g,1/this.n)*Math.tan(this.s0/2+this.s45))-this.s45),b=Math.asin(Math.cos(this.ad)*Math.sin(d)-Math.sin(this.ad)*Math.cos(d)*Math.cos(e)),c=Math.asin(Math.cos(d)*Math.sin(e)/Math.cos(b)),a.x=this.long0-c/this.alfa,h=b,i=0;var k=0;do a.y=2*(Math.atan(Math.pow(this.k,-1/this.alfa)*Math.pow(Math.tan(b/2+this.s45),1/this.alfa)*Math.pow((1+this.e*Math.sin(h))/(1-this.e*Math.sin(h)),this.e/2))-this.s45),Math.abs(h-a.y)<1e-10&&(i=1),h=a.y,k+=1;while(0===i&&15>k);return k>=15?null:a}function Da(){this.sphere||(this.e0=Jd(this.es),this.e1=Kd(this.es),this.e2=Ld(this.es),this.e3=Md(this.es),this.ml0=this.a*Id(this.e0,this.e1,this.e2,this.e3,this.lat0))}function Ea(a){var b,c,d=a.x,e=a.y;if(d=lc(d-this.long0),this.sphere)b=this.a*Math.asin(Math.cos(e)*Math.sin(d)),c=this.a*(Math.atan2(Math.tan(e),Math.cos(d))-this.lat0);else{var f=Math.sin(e),g=Math.cos(e),h=Nd(this.a,this.e,f),i=Math.tan(e)*Math.tan(e),j=d*Math.cos(e),k=j*j,l=this.es*g*g/(1-this.es),m=this.a*Id(this.e0,this.e1,this.e2,this.e3,e);b=h*j*(1-k*i*(1/6-(8-i+8*l)*k/120)),c=m-this.ml0+h*f/g*k*(.5+(5-i+6*l)*k/24)}return a.x=b+this.x0,a.y=c+this.y0,a}function Fa(a){a.x-=this.x0,a.y-=this.y0;var b,c,d=a.x/this.a,e=a.y/this.a;if(this.sphere){var f=e+this.lat0;b=Math.asin(Math.sin(f)*Math.cos(d)),c=Math.atan2(Math.tan(d),Math.cos(f))}else{var g=this.ml0/this.a+e,h=Pd(g,this.e0,this.e1,this.e2,this.e3);if(Math.abs(Math.abs(h)-Ib)<=Mb)return a.x=this.long0,a.y=Ib,0>e&&(a.y*=-1),a;var i=Nd(this.a,this.e,Math.sin(h)),j=i*i*i/this.a/this.a*(1-this.es),k=Math.pow(Math.tan(h),2),l=d*this.a/i,m=l*l;b=h-i*Math.tan(h)/j*l*l*(.5-(1+3*k)*l*l/24),c=l*(1-m*(k/3+(1+3*k)*k*m/15))/Math.cos(h)}return a.x=lc(c+this.long0),a.y=Od(b),a}function Ga(){var a=Math.abs(this.lat0);if(Math.abs(a-Ib)<Mb?this.mode=this.lat0<0?this.S_POLE:this.N_POLE:Math.abs(a)<Mb?this.mode=this.EQUIT:this.mode=this.OBLIQ,this.es>0){var b;switch(this.qp=Sd(this.e,1),this.mmf=.5/(1-this.es),this.apa=Ja(this.es),this.mode){case this.N_POLE:this.dd=1;break;case this.S_POLE:this.dd=1;break;case this.EQUIT:this.rq=Math.sqrt(.5*this.qp),this.dd=1/this.rq,this.xmf=1,this.ymf=.5*this.qp;break;case this.OBLIQ:this.rq=Math.sqrt(.5*this.qp),b=Math.sin(this.lat0),this.sinb1=Sd(this.e,b)/this.qp,this.cosb1=Math.sqrt(1-this.sinb1*this.sinb1),this.dd=Math.cos(this.lat0)/(Math.sqrt(1-this.es*b*b)*this.rq*this.cosb1),this.ymf=(this.xmf=this.rq)/this.dd,this.xmf*=this.dd}}else this.mode===this.OBLIQ&&(this.sinph0=Math.sin(this.lat0),this.cosph0=Math.cos(this.lat0))}function Ha(a){var b,c,d,e,f,g,h,i,j,k,l=a.x,m=a.y;if(l=lc(l-this.long0),this.sphere){if(f=Math.sin(m),k=Math.cos(m),d=Math.cos(l),this.mode===this.OBLIQ||this.mode===this.EQUIT){if(c=this.mode===this.EQUIT?1+k*d:1+this.sinph0*f+this.cosph0*k*d,Mb>=c)return null;c=Math.sqrt(2/c),b=c*k*Math.sin(l),c*=this.mode===this.EQUIT?f:this.cosph0*f-this.sinph0*k*d}else if(this.mode===this.N_POLE||this.mode===this.S_POLE){if(this.mode===this.N_POLE&&(d=-d),Math.abs(m+this.phi0)<Mb)return null;c=Pb-.5*m,c=2*(this.mode===this.S_POLE?Math.cos(c):Math.sin(c)),b=c*Math.sin(l),c*=d}}else{switch(h=0,i=0,j=0,d=Math.cos(l),e=Math.sin(l),f=Math.sin(m),g=Sd(this.e,f),this.mode!==this.OBLIQ&&this.mode!==this.EQUIT||(h=g/this.qp,i=Math.sqrt(1-h*h)),this.mode){case this.OBLIQ:j=1+this.sinb1*h+this.cosb1*i*d;break;case this.EQUIT:j=1+i*d;break;case this.N_POLE:j=Ib+m,g=this.qp-g;break;case this.S_POLE:j=m-Ib,g=this.qp+g}if(Math.abs(j)<Mb)return null;switch(this.mode){case this.OBLIQ:case this.EQUIT:j=Math.sqrt(2/j),c=this.mode===this.OBLIQ?this.ymf*j*(this.cosb1*h-this.sinb1*i*d):(j=Math.sqrt(2/(1+i*d)))*h*this.ymf,b=this.xmf*j*i*e;break;case this.N_POLE:case this.S_POLE:g>=0?(b=(j=Math.sqrt(g))*e,c=d*(this.mode===this.S_POLE?j:-j)):b=c=0}}return a.x=this.a*b+this.x0,a.y=this.a*c+this.y0,a}function Ia(a){a.x-=this.x0,a.y-=this.y0;var b,c,d,e,f,g,h,i=a.x/this.a,j=a.y/this.a;if(this.sphere){var k,l=0,m=0;if(k=Math.sqrt(i*i+j*j),c=.5*k,c>1)return null;switch(c=2*Math.asin(c),this.mode!==this.OBLIQ&&this.mode!==this.EQUIT||(m=Math.sin(c),l=Math.cos(c)),this.mode){case this.EQUIT:c=Math.abs(k)<=Mb?0:Math.asin(j*m/k),i*=m,j=l*k;break;case this.OBLIQ:c=Math.abs(k)<=Mb?this.phi0:Math.asin(l*this.sinph0+j*m*this.cosph0/k),i*=m*this.cosph0,j=(l-Math.sin(c)*this.sinph0)*k;break;case this.N_POLE:j=-j,c=Ib-c;break;case this.S_POLE:c-=Ib}b=0!==j||this.mode!==this.EQUIT&&this.mode!==this.OBLIQ?Math.atan2(i,j):0}else{if(h=0,this.mode===this.OBLIQ||this.mode===this.EQUIT){if(i/=this.dd,j*=this.dd,g=Math.sqrt(i*i+j*j),Mb>g)return a.x=0,a.y=this.phi0,a;e=2*Math.asin(.5*g/this.rq),d=Math.cos(e),i*=e=Math.sin(e),this.mode===this.OBLIQ?(h=d*this.sinb1+j*e*this.cosb1/g,f=this.qp*h,j=g*this.cosb1*d-j*this.sinb1*e):(h=j*e/g,f=this.qp*h,j=g*d)}else if(this.mode===this.N_POLE||this.mode===this.S_POLE){if(this.mode===this.N_POLE&&(j=-j),f=i*i+j*j,!f)return a.x=0,a.y=this.phi0,a;h=1-f/this.qp,this.mode===this.S_POLE&&(h=-h)}b=Math.atan2(i,j),c=Ka(Math.asin(h),this.apa)}return a.x=lc(this.long0+b),a.y=c,a}function Ja(a){var b,c=[];return c[0]=a*Xd,b=a*a,c[0]+=b*Yd,c[1]=b*$d,b*=a,c[0]+=b*Zd,c[1]+=b*_d,c[2]=b*ae,c}function Ka(a,b){var c=a+a;return a+b[0]*Math.sin(c)+b[1]*Math.sin(c+c)+b[2]*Math.sin(c+c+c)}function La(){Math.abs(this.lat1+this.lat2)<Mb||(this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e3=Math.sqrt(this.es),this.sin_po=Math.sin(this.lat1),this.cos_po=Math.cos(this.lat1),this.t1=this.sin_po,this.con=this.sin_po,this.ms1=jc(this.e3,this.sin_po,this.cos_po),this.qs1=Sd(this.e3,this.sin_po,this.cos_po),this.sin_po=Math.sin(this.lat2),this.cos_po=Math.cos(this.lat2),this.t2=this.sin_po,this.ms2=jc(this.e3,this.sin_po,this.cos_po),this.qs2=Sd(this.e3,this.sin_po,this.cos_po),this.sin_po=Math.sin(this.lat0),this.cos_po=Math.cos(this.lat0),this.t3=this.sin_po,this.qs0=Sd(this.e3,this.sin_po,this.cos_po),Math.abs(this.lat1-this.lat2)>Mb?this.ns0=(this.ms1*this.ms1-this.ms2*this.ms2)/(this.qs2-this.qs1):this.ns0=this.con,this.c=this.ms1*this.ms1+this.ns0*this.qs1,this.rh=this.a*Math.sqrt(this.c-this.ns0*this.qs0)/this.ns0)}function Ma(a){var b=a.x,c=a.y;this.sin_phi=Math.sin(c),this.cos_phi=Math.cos(c);var d=Sd(this.e3,this.sin_phi,this.cos_phi),e=this.a*Math.sqrt(this.c-this.ns0*d)/this.ns0,f=this.ns0*lc(b-this.long0),g=e*Math.sin(f)+this.x0,h=this.rh-e*Math.cos(f)+this.y0;return a.x=g,a.y=h,a}function Na(a){var b,c,d,e,f,g;return a.x-=this.x0,a.y=this.rh-a.y+this.y0,this.ns0>=0?(b=Math.sqrt(a.x*a.x+a.y*a.y),d=1):(b=-Math.sqrt(a.x*a.x+a.y*a.y),d=-1),e=0,0!==b&&(e=Math.atan2(d*a.x,d*a.y)),d=b*this.ns0/this.a,this.sphere?g=Math.asin((this.c-d*d)/(2*this.ns0)):(c=(this.c-d*d)/this.ns0,g=this.phi1z(this.e3,c)),f=lc(e/this.ns0+this.long0),a.x=f,a.y=g,a}function Oa(a,b){var c,d,e,f,g,h=de(.5*b);if(Mb>a)return h;for(var i=a*a,j=1;25>=j;j++)if(c=Math.sin(h),d=Math.cos(h),e=a*c,f=1-e*e,g=.5*f*f/d*(b/(1-i)-c/f+.5/a*Math.log((1-e)/(1+e))),h+=g,Math.abs(g)<=1e-7)return h;return null}function Pa(){this.sin_p14=Math.sin(this.lat0),this.cos_p14=Math.cos(this.lat0),this.infinity_dist=1e3*this.a,this.rc=1}function Qa(a){var b,c,d,e,f,g,h,i,j=a.x,k=a.y;return d=lc(j-this.long0),b=Math.sin(k),c=Math.cos(k),e=Math.cos(d),g=this.sin_p14*b+this.cos_p14*c*e,f=1,g>0||Math.abs(g)<=Mb?(h=this.x0+this.a*f*c*Math.sin(d)/g,i=this.y0+this.a*f*(this.cos_p14*b-this.sin_p14*c*e)/g):(h=this.x0+this.infinity_dist*c*Math.sin(d),i=this.y0+this.infinity_dist*(this.cos_p14*b-this.sin_p14*c*e)),a.x=h,a.y=i,a}function Ra(a){var b,c,d,e,f,g;return a.x=(a.x-this.x0)/this.a,a.y=(a.y-this.y0)/this.a,a.x/=this.k0,a.y/=this.k0,(b=Math.sqrt(a.x*a.x+a.y*a.y))?(e=Math.atan2(b,this.rc),c=Math.sin(e),d=Math.cos(e),g=de(d*this.sin_p14+a.y*c*this.cos_p14/b),f=Math.atan2(a.x*c,b*this.cos_p14*d-a.y*this.sin_p14*c),f=lc(this.long0+f)):(g=this.phic0,f=0),a.x=f,a.y=g,a}function Sa(){this.sphere||(this.k0=jc(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts)))}function Ta(a){var b,c,d=a.x,e=a.y,f=lc(d-this.long0);if(this.sphere)b=this.x0+this.a*f*Math.cos(this.lat_ts),c=this.y0+this.a*Math.sin(e)/Math.cos(this.lat_ts);else{var g=Sd(this.e,Math.sin(e));b=this.x0+this.a*this.k0*f,c=this.y0+this.a*g*.5/this.k0}return a.x=b,a.y=c,a}function Ua(a){a.x-=this.x0,a.y-=this.y0;var b,c;return this.sphere?(b=lc(this.long0+a.x/this.a/Math.cos(this.lat_ts)),c=Math.asin(a.y/this.a*Math.cos(this.lat_ts))):(c=ie(this.e,2*a.y*this.k0/this.a),b=lc(this.long0+a.x/(this.a*this.k0))),a.x=b,a.y=c,a}function Va(){this.x0=this.x0||0,this.y0=this.y0||0,this.lat0=this.lat0||0,this.long0=this.long0||0,this.lat_ts=this.lat_ts||0,this.title=this.title||\"Equidistant Cylindrical (Plate Carre)\",this.rc=Math.cos(this.lat_ts)}function Wa(a){var b=a.x,c=a.y,d=lc(b-this.long0),e=Od(c-this.lat0);return a.x=this.x0+this.a*d*this.rc,a.y=this.y0+this.a*e,a}function Xa(a){var b=a.x,c=a.y;return a.x=lc(this.long0+(b-this.x0)/(this.a*this.rc)),a.y=Od(this.lat0+(c-this.y0)/this.a),a}function Ya(){this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e=Math.sqrt(this.es),this.e0=Jd(this.es),this.e1=Kd(this.es),this.e2=Ld(this.es),this.e3=Md(this.es),this.ml0=this.a*Id(this.e0,this.e1,this.e2,this.e3,this.lat0)}function Za(a){var b,c,d,e=a.x,f=a.y,g=lc(e-this.long0);if(d=g*Math.sin(f),this.sphere)Math.abs(f)<=Mb?(b=this.a*g,c=-1*this.a*this.lat0):(b=this.a*Math.sin(d)/Math.tan(f),c=this.a*(Od(f-this.lat0)+(1-Math.cos(d))/Math.tan(f)));else if(Math.abs(f)<=Mb)b=this.a*g,c=-1*this.ml0;else{var h=Nd(this.a,this.e,Math.sin(f))/Math.tan(f);b=h*Math.sin(d),c=this.a*Id(this.e0,this.e1,this.e2,this.e3,f)-this.ml0+h*(1-Math.cos(d))}return a.x=b+this.x0,a.y=c+this.y0,a}function $a(a){var b,c,d,e,f,g,h,i,j;if(d=a.x-this.x0,e=a.y-this.y0,this.sphere)if(Math.abs(e+this.a*this.lat0)<=Mb)b=lc(d/this.a+this.long0),c=0;else{g=this.lat0+e/this.a,h=d*d/this.a/this.a+g*g,i=g;var k;for(f=ne;f;--f)if(k=Math.tan(i),j=-1*(g*(i*k+1)-i-.5*(i*i+h)*k)/((i-g)/k-1),i+=j,Math.abs(j)<=Mb){c=i;break}b=lc(this.long0+Math.asin(d*Math.tan(i)/this.a)/Math.sin(c))}else if(Math.abs(e+this.ml0)<=Mb)c=0,b=lc(this.long0+d/this.a);else{g=(this.ml0+e)/this.a,h=d*d/this.a/this.a+g*g,i=g;var l,m,n,o,p;for(f=ne;f;--f)if(p=this.e*Math.sin(i),l=Math.sqrt(1-p*p)*Math.tan(i),m=this.a*Id(this.e0,this.e1,this.e2,this.e3,i),n=this.e0-2*this.e1*Math.cos(2*i)+4*this.e2*Math.cos(4*i)-6*this.e3*Math.cos(6*i),o=m/this.a,j=(g*(l*o+1)-o-.5*l*(o*o+h))/(this.es*Math.sin(2*i)*(o*o+h-2*g*o)/(4*l)+(g-o)*(l*n-2/Math.sin(2*i))-n),i-=j,Math.abs(j)<=Mb){c=i;break}l=Math.sqrt(1-this.es*Math.pow(Math.sin(c),2))*Math.tan(c),b=lc(this.long0+Math.asin(d*l/this.a)/Math.sin(c))}return a.x=b,a.y=c,a}function _a(){this.A=[],this.A[1]=.6399175073,this.A[2]=-.1358797613,this.A[3]=.063294409,this.A[4]=-.02526853,this.A[5]=.0117879,this.A[6]=-.0055161,this.A[7]=.0026906,this.A[8]=-.001333,this.A[9]=67e-5,this.A[10]=-34e-5,this.B_re=[],this.B_im=[],this.B_re[1]=.7557853228,this.B_im[1]=0,this.B_re[2]=.249204646,this.B_im[2]=.003371507,this.B_re[3]=-.001541739,this.B_im[3]=.04105856,this.B_re[4]=-.10162907,this.B_im[4]=.01727609,this.B_re[5]=-.26623489,this.B_im[5]=-.36249218,this.B_re[6]=-.6870983,this.B_im[6]=-1.1651967,this.C_re=[],this.C_im=[],this.C_re[1]=1.3231270439,this.C_im[1]=0,this.C_re[2]=-.577245789,this.C_im[2]=-.007809598,this.C_re[3]=.508307513,this.C_im[3]=-.112208952,this.C_re[4]=-.15094762,this.C_im[4]=.18200602,this.C_re[5]=1.01418179,this.C_im[5]=1.64497696,this.C_re[6]=1.9660549,this.C_im[6]=2.5127645,this.D=[],this.D[1]=1.5627014243,this.D[2]=.5185406398,this.D[3]=-.03333098,this.D[4]=-.1052906,this.D[5]=-.0368594,this.D[6]=.007317,this.D[7]=.0122,this.D[8]=.00394,this.D[9]=-.0013}function ab(a){var b,c=a.x,d=a.y,e=d-this.lat0,f=c-this.long0,g=e/Hb*1e-5,h=f,i=1,j=0;for(b=1;10>=b;b++)i*=g,j+=this.A[b]*i;var k,l,m=j,n=h,o=1,p=0,q=0,r=0;for(b=1;6>=b;b++)k=o*m-p*n,l=p*m+o*n,o=k,p=l,q=q+this.B_re[b]*o-this.B_im[b]*p,r=r+this.B_im[b]*o+this.B_re[b]*p;return a.x=r*this.a+this.x0,a.y=q*this.a+this.y0,a}function bb(a){var b,c,d,e=a.x,f=a.y,g=e-this.x0,h=f-this.y0,i=h/this.a,j=g/this.a,k=1,l=0,m=0,n=0;for(b=1;6>=b;b++)c=k*i-l*j,d=l*i+k*j,k=c,l=d,m=m+this.C_re[b]*k-this.C_im[b]*l,n=n+this.C_im[b]*k+this.C_re[b]*l;for(var o=0;o<this.iterations;o++){var p,q,r=m,s=n,t=i,u=j;for(b=2;6>=b;b++)p=r*m-s*n,q=s*m+r*n,r=p,s=q,t+=(b-1)*(this.B_re[b]*r-this.B_im[b]*s),u+=(b-1)*(this.B_im[b]*r+this.B_re[b]*s);r=1,s=0;var v=this.B_re[1],w=this.B_im[1];for(b=2;6>=b;b++)p=r*m-s*n,q=s*m+r*n,r=p,s=q,v+=b*(this.B_re[b]*r-this.B_im[b]*s),w+=b*(this.B_im[b]*r+this.B_re[b]*s);var x=v*v+w*w;m=(t*v+u*w)/x,n=(u*v-t*w)/x}var y=m,z=n,A=1,B=0;for(b=1;9>=b;b++)A*=y,B+=this.D[b]*A;var C=this.lat0+B*Hb*1e5,D=this.long0+z;return a.x=D,a.y=C,a}function cb(){}function db(a){var b=a.x,c=a.y,d=lc(b-this.long0),e=this.x0+this.a*d,f=this.y0+this.a*Math.log(Math.tan(Math.PI/4+c/2.5))*1.25;return a.x=e,a.y=f,a}function eb(a){a.x-=this.x0,a.y-=this.y0;var b=lc(this.long0+a.x/this.a),c=2.5*(Math.atan(Math.exp(.8*a.y/this.a))-Math.PI/4);return a.x=b,a.y=c,a}function fb(){this.sphere?(this.n=1,this.m=0,this.es=0,this.C_y=Math.sqrt((this.m+1)/this.n),this.C_x=this.C_y/(this.m+1)):this.en=$c(this.es)}function gb(a){var b,c,d=a.x,e=a.y;if(d=lc(d-this.long0),this.sphere){if(this.m)for(var f=this.n*Math.sin(e),g=ue;g;--g){var h=(this.m*e+Math.sin(e)-f)/(this.m+Math.cos(e));if(e-=h,Math.abs(h)<Mb)break}else e=1!==this.n?Math.asin(this.n*Math.sin(e)):e;b=this.a*this.C_x*d*(this.m+Math.cos(e)),c=this.a*this.C_y*e}else{var i=Math.sin(e),j=Math.cos(e);c=this.a*_c(e,i,j,this.en),b=this.a*d*j/Math.sqrt(1-this.es*i*i)}return a.x=b,a.y=c,a}function hb(a){var b,c,d,e;return a.x-=this.x0,d=a.x/this.a,a.y-=this.y0,b=a.y/this.a,this.sphere?(b/=this.C_y,d/=this.C_x*(this.m+Math.cos(b)),this.m?b=de((this.m*b+Math.sin(b))/this.n):1!==this.n&&(b=de(Math.sin(b)/this.n)),d=lc(d+this.long0),b=Od(b)):(b=bd(a.y/this.a,this.es,this.en),e=Math.abs(b),Ib>e?(e=Math.sin(b),c=this.long0+a.x*Math.sqrt(1-this.es*e*e)/(this.a*Math.cos(b)),d=lc(c)):Ib>e-Mb&&(d=this.long0)),a.x=d,a.y=b,a}function ib(){}function jb(a){for(var b=a.x,c=a.y,d=lc(b-this.long0),e=c,f=Math.PI*Math.sin(c);;){var g=-(e+Math.sin(e)-f)/(1+Math.cos(e));if(e+=g,Math.abs(g)<Mb)break}e/=2,Math.PI/2-Math.abs(c)<Mb&&(d=0);var h=.900316316158*this.a*d*Math.cos(e)+this.x0,i=1.4142135623731*this.a*Math.sin(e)+this.y0;return a.x=h,a.y=i,a}function kb(a){var b,c;a.x-=this.x0,a.y-=this.y0,c=a.y/(1.4142135623731*this.a),Math.abs(c)>.999999999999&&(c=.999999999999),b=Math.asin(c);var d=lc(this.long0+a.x/(.900316316158*this.a*Math.cos(b)));d<-Math.PI&&(d=-Math.PI),d>Math.PI&&(d=Math.PI),c=(2*b+Math.sin(2*b))/Math.PI,Math.abs(c)>1&&(c=1);var e=Math.asin(c);return a.x=d,a.y=e,a}function lb(){Math.abs(this.lat1+this.lat2)<Mb||(this.lat2=this.lat2||this.lat1,this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e=Math.sqrt(this.es),this.e0=Jd(this.es),this.e1=Kd(this.es),this.e2=Ld(this.es),this.e3=Md(this.es),this.sinphi=Math.sin(this.lat1),this.cosphi=Math.cos(this.lat1),this.ms1=jc(this.e,this.sinphi,this.cosphi),this.ml1=Id(this.e0,this.e1,this.e2,this.e3,this.lat1),Math.abs(this.lat1-this.lat2)<Mb?this.ns=this.sinphi:(this.sinphi=Math.sin(this.lat2),this.cosphi=Math.cos(this.lat2),this.ms2=jc(this.e,this.sinphi,this.cosphi),this.ml2=Id(this.e0,this.e1,this.e2,this.e3,this.lat2),this.ns=(this.ms1-this.ms2)/(this.ml2-this.ml1)),this.g=this.ml1+this.ms1/this.ns,this.ml0=Id(this.e0,this.e1,this.e2,this.e3,this.lat0),this.rh=this.a*(this.g-this.ml0))}function mb(a){var b,c=a.x,d=a.y;if(this.sphere)b=this.a*(this.g-d);else{var e=Id(this.e0,this.e1,this.e2,this.e3,d);b=this.a*(this.g-e)}var f=this.ns*lc(c-this.long0),g=this.x0+b*Math.sin(f),h=this.y0+this.rh-b*Math.cos(f);return a.x=g,a.y=h,a}function nb(a){a.x-=this.x0,a.y=this.rh-a.y+this.y0;var b,c,d,e;this.ns>=0?(c=Math.sqrt(a.x*a.x+a.y*a.y),b=1):(c=-Math.sqrt(a.x*a.x+a.y*a.y),b=-1);var f=0;if(0!==c&&(f=Math.atan2(b*a.x,b*a.y)),this.sphere)return e=lc(this.long0+f/this.ns),d=Od(this.g-c/this.a),a.x=e,a.y=d,a;var g=this.g-c/this.a;return d=Pd(g,this.e0,this.e1,this.e2,this.e3),e=lc(this.long0+f/this.ns),a.x=e,a.y=d,a}function ob(){this.R=this.a}function pb(a){var b,c,d=a.x,e=a.y,f=lc(d-this.long0);Math.abs(e)<=Mb&&(b=this.x0+this.R*f,c=this.y0);var g=de(2*Math.abs(e/Math.PI));(Math.abs(f)<=Mb||Math.abs(Math.abs(e)-Ib)<=Mb)&&(b=this.x0,c=e>=0?this.y0+Math.PI*this.R*Math.tan(.5*g):this.y0+Math.PI*this.R*-Math.tan(.5*g));var h=.5*Math.abs(Math.PI/f-f/Math.PI),i=h*h,j=Math.sin(g),k=Math.cos(g),l=k/(j+k-1),m=l*l,n=l*(2/j-1),o=n*n,p=Math.PI*this.R*(h*(l-o)+Math.sqrt(i*(l-o)*(l-o)-(o+i)*(m-o)))/(o+i);0>f&&(p=-p),b=this.x0+p;var q=i+l;return p=Math.PI*this.R*(n*q-h*Math.sqrt((o+i)*(i+1)-q*q))/(o+i),c=e>=0?this.y0+p:this.y0-p,a.x=b,a.y=c,a}function qb(a){var b,c,d,e,f,g,h,i,j,k,l,m,n;return a.x-=this.x0,a.y-=this.y0,l=Math.PI*this.R,d=a.x/l,e=a.y/l,f=d*d+e*e,g=-Math.abs(e)*(1+f),h=g-2*e*e+d*d,i=-2*g+1+2*e*e+f*f,n=e*e/i+(2*h*h*h/i/i/i-9*g*h/i/i)/27,j=(g-h*h/3/i)/i,k=2*Math.sqrt(-j/3),l=3*n/j/k,Math.abs(l)>1&&(l=l>=0?1:-1),m=Math.acos(l)/3,c=a.y>=0?(-k*Math.cos(m+Math.PI/3)-h/3/i)*Math.PI:-(-k*Math.cos(m+Math.PI/3)-h/3/i)*Math.PI,b=Math.abs(d)<Mb?this.long0:lc(this.long0+Math.PI*(f-1+Math.sqrt(1+2*(d*d-e*e)+f*f))/2/d),a.x=b,a.y=c,a}function rb(){this.sin_p12=Math.sin(this.lat0),this.cos_p12=Math.cos(this.lat0)}function sb(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=a.x,z=a.y,A=Math.sin(a.y),B=Math.cos(a.y),C=lc(y-this.long0);return this.sphere?Math.abs(this.sin_p12-1)<=Mb?(a.x=this.x0+this.a*(Ib-z)*Math.sin(C),a.y=this.y0-this.a*(Ib-z)*Math.cos(C),a):Math.abs(this.sin_p12+1)<=Mb?(a.x=this.x0+this.a*(Ib+z)*Math.sin(C),a.y=this.y0+this.a*(Ib+z)*Math.cos(C),a):(s=this.sin_p12*A+this.cos_p12*B*Math.cos(C),q=Math.acos(s),r=q/Math.sin(q),a.x=this.x0+this.a*r*B*Math.sin(C),a.y=this.y0+this.a*r*(this.cos_p12*A-this.sin_p12*B*Math.cos(C)),a):(b=Jd(this.es),c=Kd(this.es),d=Ld(this.es),e=Md(this.es),Math.abs(this.sin_p12-1)<=Mb?(f=this.a*Id(b,c,d,e,Ib),g=this.a*Id(b,c,d,e,z),a.x=this.x0+(f-g)*Math.sin(C),a.y=this.y0-(f-g)*Math.cos(C),a):Math.abs(this.sin_p12+1)<=Mb?(f=this.a*Id(b,c,d,e,Ib),g=this.a*Id(b,c,d,e,z),a.x=this.x0+(f+g)*Math.sin(C),a.y=this.y0+(f+g)*Math.cos(C),a):(h=A/B,i=Nd(this.a,this.e,this.sin_p12),j=Nd(this.a,this.e,A),k=Math.atan((1-this.es)*h+this.es*i*this.sin_p12/(j*B)),l=Math.atan2(Math.sin(C),this.cos_p12*Math.tan(k)-this.sin_p12*Math.cos(C)),t=0===l?Math.asin(this.cos_p12*Math.sin(k)-this.sin_p12*Math.cos(k)):Math.abs(Math.abs(l)-Math.PI)<=Mb?-Math.asin(this.cos_p12*Math.sin(k)-this.sin_p12*Math.cos(k)):Math.asin(Math.sin(C)*Math.cos(k)/Math.sin(l)),m=this.e*this.sin_p12/Math.sqrt(1-this.es),n=this.e*this.cos_p12*Math.cos(l)/Math.sqrt(1-this.es),o=m*n,p=n*n,u=t*t,v=u*t,w=v*t,x=w*t,q=i*t*(1-u*p*(1-p)/6+v/8*o*(1-2*p)+w/120*(p*(4-7*p)-3*m*m*(1-7*p))-x/48*o),a.x=this.x0+q*Math.sin(l),a.y=this.y0+q*Math.cos(l),a))}function tb(a){a.x-=this.x0,a.y-=this.y0;var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x;if(this.sphere){if(b=Math.sqrt(a.x*a.x+a.y*a.y),b>2*Ib*this.a)return;return c=b/this.a,d=Math.sin(c),e=Math.cos(c),f=this.long0,Math.abs(b)<=Mb?g=this.lat0:(g=de(e*this.sin_p12+a.y*d*this.cos_p12/b),h=Math.abs(this.lat0)-Ib,f=lc(Math.abs(h)<=Mb?this.lat0>=0?this.long0+Math.atan2(a.x,-a.y):this.long0-Math.atan2(-a.x,a.y):this.long0+Math.atan2(a.x*d,b*this.cos_p12*e-a.y*this.sin_p12*d))),a.x=f,a.y=g,a}return i=Jd(this.es),j=Kd(this.es),k=Ld(this.es),l=Md(this.es),Math.abs(this.sin_p12-1)<=Mb?(m=this.a*Id(i,j,k,l,Ib),b=Math.sqrt(a.x*a.x+a.y*a.y),n=m-b,g=Pd(n/this.a,i,j,k,l),f=lc(this.long0+Math.atan2(a.x,-1*a.y)),a.x=f,a.y=g,a):Math.abs(this.sin_p12+1)<=Mb?(m=this.a*Id(i,j,k,l,Ib),b=Math.sqrt(a.x*a.x+a.y*a.y),n=b-m,g=Pd(n/this.a,i,j,k,l),f=lc(this.long0+Math.atan2(a.x,a.y)),a.x=f,a.y=g,a):(b=Math.sqrt(a.x*a.x+a.y*a.y),q=Math.atan2(a.x,a.y),o=Nd(this.a,this.e,this.sin_p12),r=Math.cos(q),s=this.e*this.cos_p12*r,t=-s*s/(1-this.es),u=3*this.es*(1-t)*this.sin_p12*this.cos_p12*r/(1-this.es),v=b/o,w=v-t*(1+t)*Math.pow(v,3)/6-u*(1+3*t)*Math.pow(v,4)/24,x=1-t*w*w/2-v*w*w*w/6,p=Math.asin(this.sin_p12*Math.cos(w)+this.cos_p12*Math.sin(w)*r),f=lc(this.long0+Math.asin(Math.sin(q)*Math.sin(w)/Math.cos(p))),g=Math.atan((1-this.es*x*this.sin_p12/Math.sin(p))*Math.tan(p)/(1-this.es)),a.x=f,a.y=g,a)}function ub(){this.sin_p14=Math.sin(this.lat0),this.cos_p14=Math.cos(this.lat0)}function vb(a){var b,c,d,e,f,g,h,i,j=a.x,k=a.y;return d=lc(j-this.long0),b=Math.sin(k),c=Math.cos(k),e=Math.cos(d),g=this.sin_p14*b+this.cos_p14*c*e,f=1,(g>0||Math.abs(g)<=Mb)&&(h=this.a*f*c*Math.sin(d),i=this.y0+this.a*f*(this.cos_p14*b-this.sin_p14*c*e)),a.x=h,a.y=i,a}function wb(a){var b,c,d,e,f,g,h;return a.x-=this.x0,a.y-=this.y0,b=Math.sqrt(a.x*a.x+a.y*a.y),c=de(b/this.a),d=Math.sin(c),e=Math.cos(c),g=this.long0,Math.abs(b)<=Mb?(h=this.lat0,a.x=g,a.y=h,a):(h=de(e*this.sin_p14+a.y*d*this.cos_p14/b),f=Math.abs(this.lat0)-Ib,Math.abs(f)<=Mb?(g=lc(this.lat0>=0?this.long0+Math.atan2(a.x,-a.y):this.long0-Math.atan2(-a.x,a.y)),a.x=g,a.y=h,a):(g=lc(this.long0+Math.atan2(a.x*d,b*this.cos_p14*e-a.y*this.sin_p14*d)),a.x=g,a.y=h,a))}function xb(){this.x0=this.x0||0,this.y0=this.y0||0,this.lat0=this.lat0||0,this.long0=this.long0||0,this.lat_ts=this.lat_ts||0,this.title=this.title||\"Quadrilateralized Spherical Cube\",this.lat0>=Ib-Pb/2?this.face=He.TOP:this.lat0<=-(Ib-Pb/2)?this.face=He.BOTTOM:Math.abs(this.long0)<=Pb?this.face=He.FRONT:Math.abs(this.long0)<=Ib+Pb?this.face=this.long0>0?He.RIGHT:He.LEFT:this.face=He.BACK,0!==this.es&&(this.one_minus_f=1-(this.a-this.b)/this.a,this.one_minus_f_squared=this.one_minus_f*this.one_minus_f)}function yb(a){var b,c,d,e,f,g,h={x:0,y:0},i={value:0};if(a.x-=this.long0,b=0!==this.es?Math.atan(this.one_minus_f_squared*Math.tan(a.y)):a.y,c=a.x,this.face===He.TOP)e=Ib-b,c>=Pb&&Ib+Pb>=c?(i.value=Ie.AREA_0,d=c-Ib):c>Ib+Pb||-(Ib+Pb)>=c?(i.value=Ie.AREA_1,d=c>0?c-Rb:c+Rb):c>-(Ib+Pb)&&-Pb>=c?(i.value=Ie.AREA_2,d=c+Ib):(i.value=Ie.AREA_3,d=c);else if(this.face===He.BOTTOM)e=Ib+b,c>=Pb&&Ib+Pb>=c?(i.value=Ie.AREA_0,d=-c+Ib):Pb>c&&c>=-Pb?(i.value=Ie.AREA_1,d=-c):-Pb>c&&c>=-(Ib+Pb)?(i.value=Ie.AREA_2,d=-c-Ib):(i.value=Ie.AREA_3,d=c>0?-c+Rb:-c-Rb);else{var j,k,l,m,n,o,p;this.face===He.RIGHT?c=Bb(c,+Ib):this.face===He.BACK?c=Bb(c,+Rb):this.face===He.LEFT&&(c=Bb(c,-Ib)),m=Math.sin(b),n=Math.cos(b),o=Math.sin(c),p=Math.cos(c),j=n*p,k=n*o,l=m,this.face===He.FRONT?(e=Math.acos(j),d=Ab(e,l,k,i)):this.face===He.RIGHT?(e=Math.acos(k),d=Ab(e,l,-j,i)):this.face===He.BACK?(e=Math.acos(-j),d=Ab(e,l,-k,i)):this.face===He.LEFT?(e=Math.acos(-k),d=Ab(e,l,j,i)):(e=d=0,i.value=Ie.AREA_0)}return g=Math.atan(12/Rb*(d+Math.acos(Math.sin(d)*Math.cos(Pb))-Ib)),f=Math.sqrt((1-Math.cos(e))/(Math.cos(g)*Math.cos(g))/(1-Math.cos(Math.atan(1/Math.cos(d))))),i.value===Ie.AREA_1?g+=Ib:i.value===Ie.AREA_2?g+=Rb:i.value===Ie.AREA_3&&(g+=1.5*Rb),h.x=f*Math.cos(g),h.y=f*Math.sin(g),h.x=h.x*this.a+this.x0,h.y=h.y*this.a+this.y0,a.x=h.x,a.y=h.y,a}function zb(a){var b,c,d,e,f,g,h,i,j,k={lam:0,phi:0},l={value:0};if(a.x=(a.x-this.x0)/this.a,a.y=(a.y-this.y0)/this.a,c=Math.atan(Math.sqrt(a.x*a.x+a.y*a.y)),b=Math.atan2(a.y,a.x),a.x>=0&&a.x>=Math.abs(a.y)?l.value=Ie.AREA_0:a.y>=0&&a.y>=Math.abs(a.x)?(l.value=Ie.AREA_1,b-=Ib):a.x<0&&-a.x>=Math.abs(a.y)?(l.value=Ie.AREA_2,b=0>b?b+Rb:b-Rb):(l.value=Ie.AREA_3,b+=Ib),j=Rb/12*Math.tan(b),f=Math.sin(j)/(Math.cos(j)-1/Math.sqrt(2)),g=Math.atan(f),d=Math.cos(b),e=Math.tan(c),h=1-d*d*e*e*(1-Math.cos(Math.atan(1/Math.cos(g)))),-1>h?h=-1:h>1&&(h=1),this.face===He.TOP)i=Math.acos(h),k.phi=Ib-i,l.value===Ie.AREA_0?k.lam=g+Ib:l.value===Ie.AREA_1?k.lam=0>g?g+Rb:g-Rb:l.value===Ie.AREA_2?k.lam=g-Ib:k.lam=g;else if(this.face===He.BOTTOM)i=Math.acos(h),k.phi=i-Ib,l.value===Ie.AREA_0?k.lam=-g+Ib:l.value===Ie.AREA_1?k.lam=-g:l.value===Ie.AREA_2?k.lam=-g-Ib:k.lam=0>g?-g-Rb:-g+Rb;else{var m,n,o;m=h,j=m*m,o=j>=1?0:Math.sqrt(1-j)*Math.sin(g),j+=o*o,n=j>=1?0:Math.sqrt(1-j),l.value===Ie.AREA_1?(j=n,n=-o,o=j):l.value===Ie.AREA_2?(n=-n,o=-o):l.value===Ie.AREA_3&&(j=n,n=o,o=-j),this.face===He.RIGHT?(j=m,m=-n,n=j):this.face===He.BACK?(m=-m,n=-n):this.face===He.LEFT&&(j=m,m=n,n=-j),k.phi=Math.acos(-o)-Ib,k.lam=Math.atan2(n,m),this.face===He.RIGHT?k.lam=Bb(k.lam,-Ib):this.face===He.BACK?k.lam=Bb(k.lam,-Rb):this.face===He.LEFT&&(k.lam=Bb(k.lam,+Ib))}if(0!==this.es){var p,q,r;p=k.phi<0?1:0,q=Math.tan(k.phi),r=this.b/Math.sqrt(q*q+this.one_minus_f_squared),k.phi=Math.atan(Math.sqrt(this.a*this.a-r*r)/(this.one_minus_f*r)),p&&(k.phi=-k.phi)}return k.lam+=this.long0,a.x=k.lam,a.y=k.phi,a}function Ab(a,b,c,d){var e;return Mb>a?(d.value=Ie.AREA_0,e=0):(e=Math.atan2(b,c),Math.abs(e)<=Pb?d.value=Ie.AREA_0:e>Pb&&Ib+Pb>=e?(d.value=Ie.AREA_1,e-=Ib):e>Ib+Pb||-(Ib+Pb)>=e?(d.value=Ie.AREA_2,e=e>=0?e-Rb:e+Rb):(d.value=Ie.AREA_3,e+=Ib)),e}function Bb(a,b){var c=a+b;return-Rb>c?c+=Qb:c>+Rb&&(c-=Qb),c}var Cb=function(a){a(\"EPSG:4326\",\"+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees\"),a(\"EPSG:4269\",\"+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees\"),a(\"EPSG:3857\",\"+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs\"),a.WGS84=a[\"EPSG:4326\"],a[\"EPSG:3785\"]=a[\"EPSG:3857\"],a.GOOGLE=a[\"EPSG:3857\"],a[\"EPSG:900913\"]=a[\"EPSG:3857\"],a[\"EPSG:102113\"]=a[\"EPSG:3857\"]},Db=1,Eb=2,Fb=4,Gb=5,Hb=484813681109536e-20,Ib=Math.PI/2,Jb=.16666666666666666,Kb=.04722222222222222,Lb=.022156084656084655,Mb=1e-10,Nb=.017453292519943295,Ob=57.29577951308232,Pb=Math.PI/4,Qb=2*Math.PI,Rb=3.14159265359,Sb={};Sb.greenwich=0,Sb.lisbon=-9.131906111111,Sb.paris=2.337229166667,Sb.bogota=-74.080916666667,Sb.madrid=-3.687938888889,Sb.rome=12.452333333333,Sb.bern=7.439583333333,Sb.jakarta=106.807719444444,Sb.ferro=-17.666666666667,Sb.brussels=4.367975,Sb.stockholm=18.058277777778,Sb.athens=23.7163375,Sb.oslo=10.722916666667;var Tb={ft:{to_meter:.3048},\"us-ft\":{to_meter:1200/3937}},Ub=/[\\s_\\-\\/\\(\\)]/g,Vb=function(b){var c,d,e,f={},g=b.split(\"+\").map(function(a){return a.trim()}).filter(function(a){return a}).reduce(function(a,b){var c=b.split(\"=\");return c.push(!0),a[c[0].toLowerCase()]=c[1],a},{}),h={proj:\"projName\",datum:\"datumCode\",rf:function(a){f.rf=parseFloat(a)},lat_0:function(a){f.lat0=a*Nb},lat_1:function(a){f.lat1=a*Nb},lat_2:function(a){f.lat2=a*Nb},lat_ts:function(a){f.lat_ts=a*Nb},lon_0:function(a){f.long0=a*Nb},lon_1:function(a){f.long1=a*Nb},lon_2:function(a){f.long2=a*Nb},alpha:function(a){f.alpha=parseFloat(a)*Nb},lonc:function(a){f.longc=a*Nb},x_0:function(a){f.x0=parseFloat(a)},y_0:function(a){f.y0=parseFloat(a)},k_0:function(a){f.k0=parseFloat(a)},k:function(a){f.k0=parseFloat(a)},a:function(a){f.a=parseFloat(a)},b:function(a){f.b=parseFloat(a)},r_a:function(){f.R_A=!0},zone:function(a){f.zone=parseInt(a,10)},south:function(){f.utmSouth=!0},towgs84:function(a){f.datum_params=a.split(\",\").map(function(a){return parseFloat(a)})},to_meter:function(a){f.to_meter=parseFloat(a)},units:function(b){f.units=b;var c=a(Tb,b);c&&(f.to_meter=c.to_meter)},from_greenwich:function(a){f.from_greenwich=a*Nb},pm:function(b){var c=a(Sb,b);f.from_greenwich=(c?c:parseFloat(b))*Nb},nadgrids:function(a){\"@null\"===a?f.datumCode=\"none\":f.nadgrids=a},axis:function(a){var b=\"ewnsud\";3===a.length&&-1!==b.indexOf(a.substr(0,1))&&-1!==b.indexOf(a.substr(1,1))&&-1!==b.indexOf(a.substr(2,1))&&(f.axis=a)}};for(c in g)d=g[c],c in h?(e=h[c],\"function\"==typeof e?e(d):f[e]=d):f[c]=d;return\"string\"==typeof f.datumCode&&\"WGS84\"!==f.datumCode&&(f.datumCode=f.datumCode.toLowerCase()),f},Wb=1,Xb=2,Yb=3,Zb=4,$b=5,_b=-1,ac=/\\s/,bc=/[A-Za-z]/,cc=/[A-Za-z84]/,dc=/[,\\]]/,ec=/[\\d\\.E\\-\\+]/;b.prototype.readCharicter=function(){var a=this.text[this.place++];if(this.state!==Zb)for(;ac.test(a);){if(this.place>=this.text.length)return;a=this.text[this.place++]}switch(this.state){case Wb:return this.neutral(a);case Xb:return this.keyword(a);case Zb:return this.quoted(a);case $b:return this.afterquote(a);case Yb:return this.number(a);case _b:return}},b.prototype.afterquote=function(a){if('\"'===a)return this.word+='\"',void(this.state=Zb);if(dc.test(a))return this.word=this.word.trim(),void this.afterItem(a);throw new Error(\"havn't handled \\\"\"+a+'\" in afterquote yet, index '+this.place)},b.prototype.afterItem=function(a){return\",\"===a?(null!==this.word&&this.currentObject.push(this.word),this.word=null,void(this.state=Wb)):\"]\"===a?(this.level--,null!==this.word&&(this.currentObject.push(this.word),this.word=null),this.state=Wb,this.currentObject=this.stack.pop(),void(this.currentObject||(this.state=_b))):void 0},b.prototype.number=function(a){if(ec.test(a))return void(this.word+=a);if(dc.test(a))return this.word=parseFloat(this.word),void this.afterItem(a);throw new Error(\"havn't handled \\\"\"+a+'\" in number yet, index '+this.place)},b.prototype.quoted=function(a){return'\"'===a?void(this.state=$b):void(this.word+=a)},b.prototype.keyword=function(a){if(cc.test(a))return void(this.word+=a);if(\"[\"===a){var b=[];return b.push(this.word),this.level++,null===this.root?this.root=b:this.currentObject.push(b),this.stack.push(this.currentObject),this.currentObject=b,void(this.state=Wb)}if(dc.test(a))return void this.afterItem(a);throw new Error(\"havn't handled \\\"\"+a+'\" in keyword yet, index '+this.place)},b.prototype.neutral=function(a){if(bc.test(a))return this.word=a,void(this.state=Xb);if('\"'===a)return this.word=\"\",void(this.state=Zb);if(ec.test(a))return this.word=a,void(this.state=Yb);if(dc.test(a))return void this.afterItem(a);throw new Error(\"havn't handled \\\"\"+a+'\" in neutral yet, index '+this.place)},b.prototype.output=function(){for(;this.place<this.text.length;)this.readCharicter();if(this.state===_b)return this.root;throw new Error('unable to parse string \"'+this.text+'\". State is '+this.state)};var fc=.017453292519943295,gc=function(a){var b=c(a),d=b.shift(),f=b.shift();b.unshift([\"name\",f]),b.unshift([\"type\",d]);var g={};return e(b,g),h(g),g};Cb(i);var hc=[\"PROJECTEDCRS\",\"PROJCRS\",\"GEOGCS\",\"GEOCCS\",\"PROJCS\",\"LOCAL_CS\",\"GEODCRS\",\"GEODETICCRS\",\"GEODETICDATUM\",\"ENGCRS\",\"ENGINEERINGCRS\"],ic=function(a,b){a=a||{};var c,d;if(!b)return a;for(d in b)c=b[d],void 0!==c&&(a[d]=c);return a},jc=function(a,b,c){var d=a*b;return c/Math.sqrt(1-d*d)},kc=function(a){return 0>a?-1:1},lc=function(a){return Math.abs(a)<=Rb?a:a-kc(a)*Qb},mc=function(a,b,c){var d=a*c,e=.5*a;return d=Math.pow((1-d)/(1+d),e),Math.tan(.5*(Ib-b))/d},nc=function(a,b){for(var c,d,e=.5*a,f=Ib-2*Math.atan(b),g=0;15>=g;g++)if(c=a*Math.sin(f),d=Ib-2*Math.atan(b*Math.pow((1-c)/(1+c),e))-f,f+=d,Math.abs(d)<=1e-10)return f;return-9999},oc=[\"Mercator\",\"Popular Visualisation Pseudo Mercator\",\"Mercator_1SP\",\"Mercator_Auxiliary_Sphere\",\"merc\"],pc={init:o,forward:p,inverse:q,names:oc},qc=[\"longlat\",\"identity\"],rc={init:r,forward:s,inverse:s,names:qc},sc=[pc,rc],tc={},uc=[],vc={start:v,add:t,get:u},wc={};wc.MERIT={a:6378137,rf:298.257,ellipseName:\"MERIT 1983\"},wc.SGS85={a:6378136,rf:298.257,ellipseName:\"Soviet Geodetic System 85\"},wc.GRS80={a:6378137,rf:298.257222101,ellipseName:\"GRS 1980(IUGG, 1980)\"},wc.IAU76={a:6378140,rf:298.257,ellipseName:\"IAU 1976\"},wc.airy={a:6377563.396,b:6356256.91,ellipseName:\"Airy 1830\"\n},wc.APL4={a:6378137,rf:298.25,ellipseName:\"Appl. Physics. 1965\"},wc.NWL9D={a:6378145,rf:298.25,ellipseName:\"Naval Weapons Lab., 1965\"},wc.mod_airy={a:6377340.189,b:6356034.446,ellipseName:\"Modified Airy\"},wc.andrae={a:6377104.43,rf:300,ellipseName:\"Andrae 1876 (Den., Iclnd.)\"},wc.aust_SA={a:6378160,rf:298.25,ellipseName:\"Australian Natl & S. Amer. 1969\"},wc.GRS67={a:6378160,rf:298.247167427,ellipseName:\"GRS 67(IUGG 1967)\"},wc.bessel={a:6377397.155,rf:299.1528128,ellipseName:\"Bessel 1841\"},wc.bess_nam={a:6377483.865,rf:299.1528128,ellipseName:\"Bessel 1841 (Namibia)\"},wc.clrk66={a:6378206.4,b:6356583.8,ellipseName:\"Clarke 1866\"},wc.clrk80={a:6378249.145,rf:293.4663,ellipseName:\"Clarke 1880 mod.\"},wc.clrk58={a:6378293.645208759,rf:294.2606763692654,ellipseName:\"Clarke 1858\"},wc.CPM={a:6375738.7,rf:334.29,ellipseName:\"Comm. des Poids et Mesures 1799\"},wc.delmbr={a:6376428,rf:311.5,ellipseName:\"Delambre 1810 (Belgium)\"},wc.engelis={a:6378136.05,rf:298.2566,ellipseName:\"Engelis 1985\"},wc.evrst30={a:6377276.345,rf:300.8017,ellipseName:\"Everest 1830\"},wc.evrst48={a:6377304.063,rf:300.8017,ellipseName:\"Everest 1948\"},wc.evrst56={a:6377301.243,rf:300.8017,ellipseName:\"Everest 1956\"},wc.evrst69={a:6377295.664,rf:300.8017,ellipseName:\"Everest 1969\"},wc.evrstSS={a:6377298.556,rf:300.8017,ellipseName:\"Everest (Sabah & Sarawak)\"},wc.fschr60={a:6378166,rf:298.3,ellipseName:\"Fischer (Mercury Datum) 1960\"},wc.fschr60m={a:6378155,rf:298.3,ellipseName:\"Fischer 1960\"},wc.fschr68={a:6378150,rf:298.3,ellipseName:\"Fischer 1968\"},wc.helmert={a:6378200,rf:298.3,ellipseName:\"Helmert 1906\"},wc.hough={a:6378270,rf:297,ellipseName:\"Hough\"},wc.intl={a:6378388,rf:297,ellipseName:\"International 1909 (Hayford)\"},wc.kaula={a:6378163,rf:298.24,ellipseName:\"Kaula 1961\"},wc.lerch={a:6378139,rf:298.257,ellipseName:\"Lerch 1979\"},wc.mprts={a:6397300,rf:191,ellipseName:\"Maupertius 1738\"},wc.new_intl={a:6378157.5,b:6356772.2,ellipseName:\"New International 1967\"},wc.plessis={a:6376523,rf:6355863,ellipseName:\"Plessis 1817 (France)\"},wc.krass={a:6378245,rf:298.3,ellipseName:\"Krassovsky, 1942\"},wc.SEasia={a:6378155,b:6356773.3205,ellipseName:\"Southeast Asia\"},wc.walbeck={a:6376896,b:6355834.8467,ellipseName:\"Walbeck\"},wc.WGS60={a:6378165,rf:298.3,ellipseName:\"WGS 60\"},wc.WGS66={a:6378145,rf:298.25,ellipseName:\"WGS 66\"},wc.WGS7={a:6378135,rf:298.26,ellipseName:\"WGS 72\"};var xc=wc.WGS84={a:6378137,rf:298.257223563,ellipseName:\"WGS 84\"};wc.sphere={a:6370997,b:6370997,ellipseName:\"Normal Sphere (r=6370997)\"};var yc={};yc.wgs84={towgs84:\"0,0,0\",ellipse:\"WGS84\",datumName:\"WGS84\"},yc.ch1903={towgs84:\"674.374,15.056,405.346\",ellipse:\"bessel\",datumName:\"swiss\"},yc.ggrs87={towgs84:\"-199.87,74.79,246.62\",ellipse:\"GRS80\",datumName:\"Greek_Geodetic_Reference_System_1987\"},yc.nad83={towgs84:\"0,0,0\",ellipse:\"GRS80\",datumName:\"North_American_Datum_1983\"},yc.nad27={nadgrids:\"@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat\",ellipse:\"clrk66\",datumName:\"North_American_Datum_1927\"},yc.potsdam={towgs84:\"606.0,23.0,413.0\",ellipse:\"bessel\",datumName:\"Potsdam Rauenberg 1950 DHDN\"},yc.carthage={towgs84:\"-263.0,6.0,431.0\",ellipse:\"clark80\",datumName:\"Carthage 1934 Tunisia\"},yc.hermannskogel={towgs84:\"653.0,-212.0,449.0\",ellipse:\"bessel\",datumName:\"Hermannskogel\"},yc.osni52={towgs84:\"482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15\",ellipse:\"airy\",datumName:\"Irish National\"},yc.ire65={towgs84:\"482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15\",ellipse:\"mod_airy\",datumName:\"Ireland 1965\"},yc.rassadiran={towgs84:\"-133.63,-157.5,-158.62\",ellipse:\"intl\",datumName:\"Rassadiran\"},yc.nzgd49={towgs84:\"59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993\",ellipse:\"intl\",datumName:\"New Zealand Geodetic Datum 1949\"},yc.osgb36={towgs84:\"446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894\",ellipse:\"airy\",datumName:\"Airy 1830\"},yc.s_jtsk={towgs84:\"589,76,480\",ellipse:\"bessel\",datumName:\"S-JTSK (Ferro)\"},yc.beduaram={towgs84:\"-106,-87,188\",ellipse:\"clrk80\",datumName:\"Beduaram\"},yc.gunung_segara={towgs84:\"-403,684,41\",ellipse:\"bessel\",datumName:\"Gunung Segara Jakarta\"},yc.rnb72={towgs84:\"106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1\",ellipse:\"intl\",datumName:\"Reseau National Belge 1972\"},z.projections=vc,z.projections.start();var zc=function(a,b,c){return A(a,b)?c:a.datum_type===Gb||b.datum_type===Gb?c:a.es!==b.es||a.a!==b.a||F(a.datum_type)||F(b.datum_type)?(c=B(c,a.es,a.a),F(a.datum_type)&&(c=D(c,a.datum_type,a.datum_params)),F(b.datum_type)&&(c=E(c,b.datum_type,b.datum_params)),C(c,b.es,b.a,b.b)):c},Ac=function(a,b,c){var d,e,f,g=c.x,h=c.y,i=c.z||0,j={};for(f=0;3>f;f++)if(!b||2!==f||void 0!==c.z)switch(0===f?(d=g,e=\"x\"):1===f?(d=h,e=\"y\"):(d=i,e=\"z\"),a.axis[f]){case\"e\":j[e]=d;break;case\"w\":j[e]=-d;break;case\"n\":j[e]=d;break;case\"s\":j[e]=-d;break;case\"u\":void 0!==c[e]&&(j.z=d);break;case\"d\":void 0!==c[e]&&(j.z=-d);break;default:return null}return j},Bc=function(a){var b={x:a[0],y:a[1]};return a.length>2&&(b.z=a[2]),a.length>3&&(b.m=a[3]),b},Cc=function(a){G(a.x),G(a.y)},Dc=z(\"WGS84\"),Ec=6,Fc=\"AJSAJS\",Gc=\"AFAFAF\",Hc=65,Ic=73,Jc=79,Kc=86,Lc=90,Mc={forward:M,inverse:N,toPoint:O};Point.fromMGRS=function(a){return new Point(O(a))},Point.prototype.toMGRS=function(a){return M([this.x,this.y],a)};var Nc=\"2.4.4\",Oc=1,Pc=.25,Qc=.046875,Rc=.01953125,Sc=.01068115234375,Tc=.75,Uc=.46875,Vc=.013020833333333334,Wc=.007120768229166667,Xc=.3645833333333333,Yc=.005696614583333333,Zc=.3076171875,$c=function(a){var b=[];b[0]=Oc-a*(Pc+a*(Qc+a*(Rc+a*Sc))),b[1]=a*(Tc-a*(Qc+a*(Rc+a*Sc)));var c=a*a;return b[2]=c*(Uc-a*(Vc+a*Wc)),c*=a,b[3]=c*(Xc-a*Yc),b[4]=c*a*Zc,b},_c=function(a,b,c,d){return c*=b,b*=b,d[0]*a-c*(d[1]+b*(d[2]+b*(d[3]+b*d[4])))},ad=20,bd=function(a,b,c){for(var d=1/(1-b),e=a,f=ad;f;--f){var g=Math.sin(e),h=1-b*g*g;if(h=(_c(e,g,Math.cos(e),c)-a)*(h*Math.sqrt(h))*d,e-=h,Math.abs(h)<Mb)return e}return e},cd=[\"Transverse_Mercator\",\"Transverse Mercator\",\"tmerc\"],dd={init:aa,forward:ba,inverse:ca,names:cd},ed=function(a){var b=Math.exp(a);return b=(b-1/b)/2},fd=function(a,b){a=Math.abs(a),b=Math.abs(b);var c=Math.max(a,b),d=Math.min(a,b)/(c?c:1);return c*Math.sqrt(1+Math.pow(d,2))},gd=function(a){var b=1+a,c=b-1;return 0===c?a:a*Math.log(b)/c},hd=function(a){var b=Math.abs(a);return b=gd(b*(1+b/(fd(1,b)+1))),0>a?-b:b},id=function(a,b){for(var c,d=2*Math.cos(2*b),e=a.length-1,f=a[e],g=0;--e>=0;)c=-g+d*f+a[e],g=f,f=c;return b+c*Math.sin(2*b)},jd=function(a,b){for(var c,d=2*Math.cos(b),e=a.length-1,f=a[e],g=0;--e>=0;)c=-g+d*f+a[e],g=f,f=c;return Math.sin(b)*c},kd=function(a){var b=Math.exp(a);return b=(b+1/b)/2},ld=function(a,b,c){for(var d,e,f=Math.sin(b),g=Math.cos(b),h=ed(c),i=kd(c),j=2*g*i,k=-2*f*h,l=a.length-1,m=a[l],n=0,o=0,p=0;--l>=0;)d=o,e=n,o=m,n=p,m=-d+j*o-k*n+a[l],p=-e+k*o+j*n;return j=f*i,k=g*h,[j*m-k*p,j*p+k*m]},md=[\"Extended_Transverse_Mercator\",\"Extended Transverse Mercator\",\"etmerc\"],nd={init:da,forward:ea,inverse:fa,names:md},od=function(a,b){if(void 0===a){if(a=Math.floor(30*(lc(b)+Math.PI)/Math.PI)+1,0>a)return 0;if(a>60)return 60}return a},pd=\"etmerc\",qd=[\"Universal Transverse Mercator System\",\"utm\"],rd={init:ga,names:qd,dependsOn:pd},sd=function(a,b){return Math.pow((1-a)/(1+a),b)},td=20,ud=[\"gauss\"],vd={init:ha,forward:ia,inverse:ja,names:ud},wd=[\"Stereographic_North_Pole\",\"Oblique_Stereographic\",\"Polar_Stereographic\",\"sterea\",\"Oblique Stereographic Alternative\"],xd={init:ka,forward:la,inverse:ma,names:wd},yd=[\"stere\",\"Stereographic_South_Pole\",\"Polar Stereographic (variant B)\"],zd={init:oa,forward:pa,inverse:qa,names:yd,ssfn_:na},Ad=[\"somerc\"],Bd={init:ra,forward:sa,inverse:ta,names:Ad},Cd=[\"Hotine_Oblique_Mercator\",\"Hotine Oblique Mercator\",\"Hotine_Oblique_Mercator_Azimuth_Natural_Origin\",\"Hotine_Oblique_Mercator_Azimuth_Center\",\"omerc\"],Dd={init:ua,forward:va,inverse:wa,names:Cd},Ed=[\"Lambert Tangential Conformal Conic Projection\",\"Lambert_Conformal_Conic\",\"Lambert_Conformal_Conic_2SP\",\"lcc\"],Fd={init:xa,forward:ya,inverse:za,names:Ed},Gd=[\"Krovak\",\"krovak\"],Hd={init:Aa,forward:Ba,inverse:Ca,names:Gd},Id=function(a,b,c,d,e){return a*e-b*Math.sin(2*e)+c*Math.sin(4*e)-d*Math.sin(6*e)},Jd=function(a){return 1-.25*a*(1+a/16*(3+1.25*a))},Kd=function(a){return.375*a*(1+.25*a*(1+.46875*a))},Ld=function(a){return.05859375*a*a*(1+.75*a)},Md=function(a){return a*a*a*(35/3072)},Nd=function(a,b,c){var d=b*c;return a/Math.sqrt(1-d*d)},Od=function(a){return Math.abs(a)<Ib?a:a-kc(a)*Math.PI},Pd=function(a,b,c,d,e){var f,g;f=a/b;for(var h=0;15>h;h++)if(g=(a-(b*f-c*Math.sin(2*f)+d*Math.sin(4*f)-e*Math.sin(6*f)))/(b-2*c*Math.cos(2*f)+4*d*Math.cos(4*f)-6*e*Math.cos(6*f)),f+=g,Math.abs(g)<=1e-10)return f;return NaN},Qd=[\"Cassini\",\"Cassini_Soldner\",\"cass\"],Rd={init:Da,forward:Ea,inverse:Fa,names:Qd},Sd=function(a,b){var c;return a>1e-7?(c=a*b,(1-a*a)*(b/(1-c*c)-.5/a*Math.log((1-c)/(1+c)))):2*b},Td=1,Ud=2,Vd=3,Wd=4,Xd=.3333333333333333,Yd=.17222222222222222,Zd=.10257936507936508,$d=.06388888888888888,_d=.0664021164021164,ae=.016415012942191543,be=[\"Lambert Azimuthal Equal Area\",\"Lambert_Azimuthal_Equal_Area\",\"laea\"],ce={init:Ga,forward:Ha,inverse:Ia,names:be,S_POLE:Td,N_POLE:Ud,EQUIT:Vd,OBLIQ:Wd},de=function(a){return Math.abs(a)>1&&(a=a>1?1:-1),Math.asin(a)},ee=[\"Albers_Conic_Equal_Area\",\"Albers\",\"aea\"],fe={init:La,forward:Ma,inverse:Na,names:ee,phi1z:Oa},ge=[\"gnom\"],he={init:Pa,forward:Qa,inverse:Ra,names:ge},ie=function(a,b){var c=1-(1-a*a)/(2*a)*Math.log((1-a)/(1+a));if(Math.abs(Math.abs(b)-c)<1e-6)return 0>b?-1*Ib:Ib;for(var d,e,f,g,h=Math.asin(.5*b),i=0;30>i;i++)if(e=Math.sin(h),f=Math.cos(h),g=a*e,d=Math.pow(1-g*g,2)/(2*f)*(b/(1-a*a)-e/(1-g*g)+.5/a*Math.log((1-g)/(1+g))),h+=d,Math.abs(d)<=1e-10)return h;return NaN},je=[\"cea\"],ke={init:Sa,forward:Ta,inverse:Ua,names:je},le=[\"Equirectangular\",\"Equidistant_Cylindrical\",\"eqc\"],me={init:Va,forward:Wa,inverse:Xa,names:le},ne=20,oe=[\"Polyconic\",\"poly\"],pe={init:Ya,forward:Za,inverse:$a,names:oe},qe=[\"New_Zealand_Map_Grid\",\"nzmg\"],re={init:_a,forward:ab,inverse:bb,names:qe},se=[\"Miller_Cylindrical\",\"mill\"],te={init:cb,forward:db,inverse:eb,names:se},ue=20,ve=[\"Sinusoidal\",\"sinu\"],we={init:fb,forward:gb,inverse:hb,names:ve},xe=[\"Mollweide\",\"moll\"],ye={init:ib,forward:jb,inverse:kb,names:xe},ze=[\"Equidistant_Conic\",\"eqdc\"],Ae={init:lb,forward:mb,inverse:nb,names:ze},Be=[\"Van_der_Grinten_I\",\"VanDerGrinten\",\"vandg\"],Ce={init:ob,forward:pb,inverse:qb,names:Be},De=[\"Azimuthal_Equidistant\",\"aeqd\"],Ee={init:rb,forward:sb,inverse:tb,names:De},Fe=[\"ortho\"],Ge={init:ub,forward:vb,inverse:wb,names:Fe},He={FRONT:1,RIGHT:2,BACK:3,LEFT:4,TOP:5,BOTTOM:6},Ie={AREA_0:1,AREA_1:2,AREA_2:3,AREA_3:4},Je=[\"Quadrilateralized Spherical Cube\",\"Quadrilateralized_Spherical_Cube\",\"qsc\"],Ke={init:xb,forward:yb,inverse:zb,names:Je},Le=function(proj4){proj4.Proj.projections.add(dd),proj4.Proj.projections.add(nd),proj4.Proj.projections.add(rd),proj4.Proj.projections.add(xd),proj4.Proj.projections.add(zd),proj4.Proj.projections.add(Bd),proj4.Proj.projections.add(Dd),proj4.Proj.projections.add(Fd),proj4.Proj.projections.add(Hd),proj4.Proj.projections.add(Rd),proj4.Proj.projections.add(ce),proj4.Proj.projections.add(fe),proj4.Proj.projections.add(he),proj4.Proj.projections.add(ke),proj4.Proj.projections.add(me),proj4.Proj.projections.add(pe),proj4.Proj.projections.add(re),proj4.Proj.projections.add(te),proj4.Proj.projections.add(we),proj4.Proj.projections.add(ye),proj4.Proj.projections.add(Ae),proj4.Proj.projections.add(Ce),proj4.Proj.projections.add(Ee),proj4.Proj.projections.add(Ge),proj4.Proj.projections.add(Ke)};return L.defaultDatum=\"WGS84\",L.Proj=z,L.WGS84=new L.Proj(\"WGS84\"),L.Point=Point,L.toPoint=Bc,L.defs=i,L.transform=I,L.mgrs=Mc,L.version=Nc,Le(L),L});"

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1506))

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	module.exports = "/*\n Highcharts JS v4.2.7 (2016-09-21)\n\n (c) 2009-2016 Torstein Honsi\n\n License: www.highcharts.com/license\n*/\n(function(D,ea){typeof module===\"object\"&&module.exports?module.exports=D.document?ea(D):ea:D.Highcharts=ea(D)})(typeof window!==\"undefined\"?window:this,function(D){function ea(a,b){var c=\"Highcharts error #\"+a+\": www.highcharts.com/errors/\"+a;if(b)throw Error(c);D.console&&console.log(c)}function tb(a,b,c){this.options=b;this.elem=a;this.prop=c}function E(){var a,b=arguments,c,d={},e=function(a,b){var c,d;typeof a!==\"object\"&&(a={});for(d in b)b.hasOwnProperty(d)&&(c=b[d],a[d]=u.isObject(c,!0)&&\nd!==\"renderTo\"&&typeof c.nodeType!==\"number\"?e(a[d]||{},c):b[d]);return a};b[0]===!0&&(d=b[1],b=Array.prototype.slice.call(b,2));c=b.length;for(a=0;a<c;a++)d=e(d,b[a]);return d}function B(a,b){return parseInt(a,b||10)}function ya(a){return typeof a===\"string\"}function za(a){a=Object.prototype.toString.call(a);return a===\"[object Array]\"||a===\"[object Array Iterator]\"}function ra(a,b){for(var c=a.length;c--;)if(a[c]===b){a.splice(c,1);break}}function s(a){return a!==z&&a!==null}function O(a,b,c){var d,\ne;if(ya(b))s(c)?a.setAttribute(b,c):a&&a.getAttribute&&(e=a.getAttribute(b));else if(s(b)&&ba(b))for(d in b)a.setAttribute(d,b[d]);return e}function ua(a){return za(a)?a:[a]}function Sa(a,b,c){if(b)return setTimeout(a,b,c);a.call(0,c)}function M(a,b){if(Aa&&!fa&&b&&b.opacity!==z)b.filter=\"alpha(opacity=\"+b.opacity*100+\")\";x(a.style,b)}function ca(a,b,c,d,e){a=y.createElement(a);b&&x(a,b);e&&M(a,{padding:0,border:\"none\",margin:0});c&&M(a,c);d&&d.appendChild(a);return a}function sa(a,b){var c=function(){};\nc.prototype=new a;x(c.prototype,b);return c}function Ga(a,b,c){return Array((b||2)+1-String(a).length).join(c||0)+a}function ab(a){return(bb&&bb(a)||ub||0)*6E4}function Na(a,b){for(var c=\"{\",d=!1,e,f,g,h,i,j=[];(c=a.indexOf(c))!==-1;){e=a.slice(0,c);if(d){f=e.split(\":\");g=f.shift().split(\".\");i=g.length;e=b;for(h=0;h<i;h++)e=e[g[h]];if(f.length)f=f.join(\":\"),g=/\\.([0-9])/,h=T.lang,i=void 0,/f$/.test(f)?(i=(i=f.match(g))?i[1]:-1,e!==null&&(e=u.numberFormat(e,i,h.decimalPoint,f.indexOf(\",\")>-1?h.thousandsSep:\n\"\"))):e=Ta(f,e)}j.push(e);a=a.slice(c+1);c=(d=!d)?\"}\":\"{\"}j.push(a);return j.join(\"\")}function vb(a){return Z.pow(10,V(Z.log(a)/Z.LN10))}function wb(a,b,c,d,e){var f,g=a,c=p(c,1);f=a/c;b||(b=[1,2,2.5,5,10],d===!1&&(c===1?b=[1,2,5,10]:c<=0.1&&(b=[1/c])));for(d=0;d<b.length;d++)if(g=b[d],e&&g*c>=a||!e&&f<=(b[d]+(b[d+1]||b[d]))/2)break;g*=c;return g}function kb(a,b){var c=a.length,d,e;for(e=0;e<c;e++)a[e].safeI=e;a.sort(function(a,c){d=b(a,c);return d===0?a.safeI-c.safeI:d});for(e=0;e<c;e++)delete a[e].safeI}\nfunction Oa(a){for(var b=a.length,c=a[0];b--;)a[b]<c&&(c=a[b]);return c}function Ha(a){for(var b=a.length,c=a[0];b--;)a[b]>c&&(c=a[b]);return c}function Ua(a,b){for(var c in a)a[c]&&a[c]!==b&&a[c].destroy&&a[c].destroy(),delete a[c]}function Va(a){lb||(lb=ca(Pa));a&&lb.appendChild(a);lb.innerHTML=\"\"}function $(a,b){return parseFloat(a.toPrecision(b||14))}function cb(a,b){b.renderer.globalAnimation=p(a,b.animation)}function Wa(a){return ba(a)?E(a):{duration:a?500:0}}function Hb(){var a=T.global,b=\na.useUTC,c=b?\"getUTC\":\"get\",d=b?\"setUTC\":\"set\";ma=a.Date||D.Date;ub=b&&a.timezoneOffset;bb=b&&a.getTimezoneOffset;mb=function(a,c,d,h,i,j){var k;b?(k=ma.UTC.apply(0,arguments),k+=ab(k)):k=(new ma(a,c,p(d,1),p(h,0),p(i,0),p(j,0))).getTime();return k};xb=c+\"Minutes\";yb=c+\"Hours\";zb=c+\"Day\";Xa=c+\"Date\";db=c+\"Month\";eb=c+\"FullYear\";Ib=d+\"Milliseconds\";Jb=d+\"Seconds\";Kb=d+\"Minutes\";Lb=d+\"Hours\";nb=d+\"Date\";Ab=d+\"Month\";Bb=d+\"FullYear\"}function na(a){if(!(this instanceof na))return new na(a);this.init(a)}\nfunction J(){}function Ya(a,b,c,d){this.axis=a;this.pos=b;this.type=c||\"\";this.isNew=!0;!c&&!d&&this.addLabel()}function Mb(a,b,c,d,e){var f=a.chart.inverted;this.axis=a;this.isNegative=c;this.options=b;this.x=d;this.total=null;this.points={};this.stack=e;this.rightCliff=this.leftCliff=0;this.alignOptions={align:b.align||(f?c?\"left\":\"right\":\"center\"),verticalAlign:b.verticalAlign||(f?\"middle\":c?\"bottom\":\"top\"),y:p(b.y,f?4:c?14:-6),x:p(b.x,f?c?-6:6:0)};this.textAlign=b.textAlign||(f?c?\"right\":\"left\":\n\"center\")}var z,y=D.document,Z=Math,C=Z.round,V=Z.floor,va=Z.ceil,t=Z.max,F=Z.min,Q=Z.abs,W=Z.cos,da=Z.sin,ta=Z.PI,ka=ta*2/360,Ba=D.navigator&&D.navigator.userAgent||\"\",Nb=D.opera,Aa=/(msie|trident|edge)/i.test(Ba)&&!Nb,ob=y&&y.documentMode===8,pb=!Aa&&/AppleWebKit/.test(Ba),Qa=/Firefox/.test(Ba),Ob=/(Mobile|Android|Windows Phone)/.test(Ba),Ia=\"http://www.w3.org/2000/svg\",fa=y&&y.createElementNS&&!!y.createElementNS(Ia,\"svg\").createSVGRect,Sb=Qa&&parseInt(Ba.split(\"Firefox/\")[1],10)<4,la=y&&!fa&&\n!Aa&&!!y.createElement(\"canvas\").getContext,fb,gb,Pb={},Cb=0,lb,T,Ta,G,Ca=function(){},U=[],hb=0,Pa=\"div\",X=\"M\",S=\"L\",Tb=/[0-9]/g,qb=[\"plotTop\",\"marginRight\",\"marginBottom\",\"plotLeft\"],ma,mb,ub,bb,xb,yb,zb,Xa,db,eb,Ib,Jb,Kb,Lb,nb,Ab,Bb,L={},u;u=D.Highcharts?ea(16,!0):{win:D};u.seriesTypes=L;var Ja=[],oa,pa,q,Da,Db,Ea,N,Y,H,Za,Ka;tb.prototype={dSetter:function(){var a=this.paths[0],b=this.paths[1],c=[],d=this.now,e=a.length,f;if(d===1)c=this.toD;else if(e===b.length&&d<1)for(;e--;)f=parseFloat(a[e]),\nc[e]=isNaN(f)?a[e]:d*parseFloat(b[e]-f)+f;else c=b;this.elem.attr(\"d\",c)},update:function(){var a=this.elem,b=this.prop,c=this.now,d=this.options.step;if(this[b+\"Setter\"])this[b+\"Setter\"]();else a.attr?a.element&&a.attr(b,c):a.style[b]=c+this.unit;d&&d.call(a,c,this)},run:function(a,b,c){var d=this,e=function(a){return e.stopped?!1:d.step(a)},f;this.startTime=+new ma;this.start=a;this.end=b;this.unit=c;this.now=this.start;this.pos=0;e.elem=this.elem;if(e()&&Ja.push(e)===1)e.timerId=setInterval(function(){for(f=\n0;f<Ja.length;f++)Ja[f]()||Ja.splice(f--,1);Ja.length||clearInterval(e.timerId)},13)},step:function(a){var b=+new ma,c,d=this.options;c=this.elem;var e=d.complete,f=d.duration,g=d.curAnim,h;if(c.attr&&!c.element)c=!1;else if(a||b>=f+this.startTime){this.now=this.end;this.pos=1;this.update();a=g[this.prop]=!0;for(h in g)g[h]!==!0&&(a=!1);a&&e&&e.call(c);c=!1}else this.pos=d.easing((b-this.startTime)/f),this.now=this.start+(this.end-this.start)*this.pos,this.update(),c=!0;return c},initPath:function(a,\nb,c){function d(a){for(n=a.length;n--;)(a[n]===X||a[n]===S)&&a.splice(n+1,0,a[n+1],a[n+2],a[n+1],a[n+2])}function e(a,b){for(;a.length<l;){a[0]=b[l-a.length];var c=a.slice(0,k);[].splice.apply(a,[0,0].concat(c));o&&(c=a.slice(a.length-k),[].splice.apply(a,[a.length,0].concat(c)),n--)}a[0]=\"M\"}function f(a,b){for(var c=(l-a.length)/k;c>0&&c--;)m=a.slice().splice(a.length/A-k,k*A),m[0]=b[l-k-c*k],j&&(m[k-6]=m[k-2],m[k-5]=m[k-1]),[].splice.apply(a,[a.length/A,0].concat(m)),o&&c--}var b=b||\"\",g,h=a.startX,\ni=a.endX,j=b.indexOf(\"C\")>-1,k=j?7:3,l,m,n,b=b.split(\" \"),c=c.slice(),o=a.isArea,A=o?2:1,r;j&&(d(b),d(c));if(h&&i){for(n=0;n<h.length;n++)if(h[n]===i[0]){g=n;break}else if(h[0]===i[i.length-h.length+n]){g=n;r=!0;break}g===void 0&&(b=[])}b.length&&u.isNumber(g)&&(l=c.length+g*A*k,r?(e(b,c),f(c,b)):(e(c,b),f(b,c)));return[b,c]}};var x=u.extend=function(a,b){var c;a||(a={});for(c in b)a[c]=b[c];return a},ba=u.isObject=function(a,b){return a&&typeof a===\"object\"&&(!b||!za(a))},I=u.isNumber=function(a){return typeof a===\n\"number\"&&!isNaN(a)},p=u.pick=function(){var a=arguments,b,c,d=a.length;for(b=0;b<d;b++)if(c=a[b],c!==z&&c!==null)return c},ib=u.wrap=function(a,b,c){var d=a[b];a[b]=function(){var a=Array.prototype.slice.call(arguments);a.unshift(d);return c.apply(this,a)}};Ta=function(a,b,c){if(!s(b)||isNaN(b))return T.lang.invalidDate||\"\";var a=p(a,\"%Y-%m-%d %H:%M:%S\"),d=new ma(b-ab(b)),e,f=d[yb](),g=d[zb](),h=d[Xa](),i=d[db](),j=d[eb](),k=T.lang,l=k.weekdays,m=k.shortWeekdays,d=x({a:m?m[g]:l[g].substr(0,3),A:l[g],\nd:Ga(h),e:Ga(h,2,\" \"),w:g,b:k.shortMonths[i],B:k.months[i],m:Ga(i+1),y:j.toString().substr(2,2),Y:j,H:Ga(f),k:f,I:Ga(f%12||12),l:f%12||12,M:Ga(d[xb]()),p:f<12?\"AM\":\"PM\",P:f<12?\"am\":\"pm\",S:Ga(d.getSeconds()),L:Ga(C(b%1E3),3)},u.dateFormats);for(e in d)for(;a.indexOf(\"%\"+e)!==-1;)a=a.replace(\"%\"+e,typeof d[e]===\"function\"?d[e](b):d[e]);return c?a.substr(0,1).toUpperCase()+a.substr(1):a};G={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};u.numberFormat=\nfunction(a,b,c,d){var a=+a||0,b=+b,e=T.lang,f=(a.toString().split(\".\")[1]||\"\").length,g,h,i=Math.abs(a);b===-1?b=Math.min(f,20):I(b)||(b=2);g=String(B(i.toFixed(b)));h=g.length>3?g.length%3:0;c=p(c,e.decimalPoint);d=p(d,e.thousandsSep);a=a<0?\"-\":\"\";a+=h?g.substr(0,h)+d:\"\";a+=g.substr(h).replace(/(\\d{3})(?=\\d)/g,\"$1\"+d);b&&(d=Math.abs(i-g+Math.pow(10,-Math.max(b,f)-1)),a+=c+d.toFixed(b).slice(2));return a};Math.easeInOutSine=function(a){return-0.5*(Math.cos(Math.PI*a)-1)};oa=function(a,b){var c;if(b===\n\"width\")return Math.min(a.offsetWidth,a.scrollWidth)-oa(a,\"padding-left\")-oa(a,\"padding-right\");else if(b===\"height\")return Math.min(a.offsetHeight,a.scrollHeight)-oa(a,\"padding-top\")-oa(a,\"padding-bottom\");return(c=D.getComputedStyle(a,void 0))&&B(c.getPropertyValue(b))};pa=function(a,b){return b.indexOf?b.indexOf(a):[].indexOf.call(b,a)};Da=function(a,b){return[].filter.call(a,b)};Ea=function(a,b){for(var c=[],d=0,e=a.length;d<e;d++)c[d]=b.call(a[d],a[d],d,a);return c};Db=function(a){var b=y.documentElement,\na=a.getBoundingClientRect();return{top:a.top+(D.pageYOffset||b.scrollTop)-(b.clientTop||0),left:a.left+(D.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}};Ka=function(a){for(var b=Ja.length;b--;)if(Ja[b].elem===a)Ja[b].stopped=!0};q=function(a,b){return Array.prototype.forEach.call(a,b)};N=function(a,b,c){function d(b){b.target=b.srcElement||D;c.call(a,b)}var e=a.hcEvents=a.hcEvents||{};if(a.addEventListener)a.addEventListener(b,c,!1);else if(a.attachEvent){if(!a.hcEventsIE)a.hcEventsIE={};a.hcEventsIE[c.toString()]=\nd;a.attachEvent(\"on\"+b,d)}e[b]||(e[b]=[]);e[b].push(c)};Y=function(a,b,c){function d(b,c){a.removeEventListener?a.removeEventListener(b,c,!1):a.attachEvent&&(c=a.hcEventsIE[c.toString()],a.detachEvent(\"on\"+b,c))}function e(){var c,e,f;if(a.nodeName)for(f in b?(c={},c[b]=!0):c=g,c)if(g[f])for(e=g[f].length;e--;)d(f,g[f][e])}var f,g=a.hcEvents,h;if(g)b?(f=g[b]||[],c?(h=pa(c,f),h>-1&&(f.splice(h,1),g[b]=f),d(b,c)):(e(),g[b]=[])):(e(),a.hcEvents={})};H=function(a,b,c,d){var e;e=a.hcEvents;var f,g,c=c||\n{};if(y.createEvent&&(a.dispatchEvent||a.fireEvent))e=y.createEvent(\"Events\"),e.initEvent(b,!0,!0),e.target=a,x(e,c),a.dispatchEvent?a.dispatchEvent(e):a.fireEvent(b,e);else if(e){e=e[b]||[];f=e.length;if(!c.preventDefault)c.preventDefault=function(){c.defaultPrevented=!0};c.target=a;if(!c.type)c.type=b;for(b=0;b<f;b++)(g=e[b])&&g.call(a,c)===!1&&c.preventDefault()}d&&!c.defaultPrevented&&d(c)};Za=function(a,b,c){var d,e=\"\",f,g,h;ba(c)||(d=arguments,c={duration:d[2],easing:d[3],complete:d[4]});if(!I(c.duration))c.duration=\n400;c.easing=typeof c.easing===\"function\"?c.easing:Math[c.easing]||Math.easeInOutSine;c.curAnim=E(b);for(h in b)g=new tb(a,c,h),f=null,h===\"d\"?(g.paths=g.initPath(a,a.d,b.d),g.toD=b.d,d=0,f=1):a.attr?d=a.attr(h):(d=parseFloat(oa(a,h))||0,h!==\"opacity\"&&(e=\"px\")),f||(f=b[h]),f.match&&f.match(\"px\")&&(f=f.replace(/px/g,\"\")),g.run(d,f,e)};if(D.jQuery)D.jQuery.fn.highcharts=function(){var a=[].slice.call(arguments);if(this[0])return a[0]?(new (u[ya(a[0])?a.shift():\"Chart\"])(this[0],a[0],a[1]),this):U[O(this[0],\n\"data-highcharts-chart\")]};y&&!y.defaultView&&(oa=function(a,b){var c;c={width:\"clientWidth\",height:\"clientHeight\"}[b];if(a.style[b])return B(a.style[b]);b===\"opacity\"&&(b=\"filter\");if(c)return a.style.zoom=1,Math.max(a[c]-2*oa(a,\"padding\"),0);c=a.currentStyle[b.replace(/\\-(\\w)/g,function(a,b){return b.toUpperCase()})];b===\"filter\"&&(c=c.replace(/alpha\\(opacity=([0-9]+)\\)/,function(a,b){return b/100}));return c===\"\"?1:B(c)});Array.prototype.forEach||(q=function(a,b){for(var c=0,d=a.length;c<d;c++)if(b.call(a[c],\na[c],c,a)===!1)return c});Array.prototype.indexOf||(pa=function(a,b){var c,d=0;if(b)for(c=b.length;d<c;d++)if(b[d]===a)return d;return-1});Array.prototype.filter||(Da=function(a,b){for(var c=[],d=0,e=a.length;d<e;d++)b(a[d],d)&&c.push(a[d]);return c});u.Fx=tb;u.inArray=pa;u.each=q;u.grep=Da;u.offset=Db;u.map=Ea;u.addEvent=N;u.removeEvent=Y;u.fireEvent=H;u.animate=Za;u.animObject=Wa;u.stop=Ka;T={colors:\"#7cb5ec,#434348,#90ed7d,#f7a35c,#8085e9,#f15c80,#e4d354,#2b908f,#f45b5b,#91e8e1\".split(\",\"),symbols:[\"circle\",\n\"diamond\",\"square\",\"triangle\",\"triangle-down\"],lang:{loading:\"Loading...\",months:\"January,February,March,April,May,June,July,August,September,October,November,December\".split(\",\"),shortMonths:\"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec\".split(\",\"),weekdays:\"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday\".split(\",\"),decimalPoint:\".\",numericSymbols:\"k,M,G,T,P,E\".split(\",\"),resetZoom:\"Reset zoom\",resetZoomTitle:\"Reset zoom level 1:1\",thousandsSep:\" \"},global:{useUTC:!0,canvasToolsURL:\"http://code.highcharts.com/modules/canvas-tools.js\",\nVMLRadialGradientURL:\"http://code.highcharts.com/4.2.7/gfx/vml-radial-gradient.png\"},chart:{borderColor:\"#4572A7\",borderRadius:0,defaultSeriesType:\"line\",ignoreHiddenSeries:!0,spacing:[10,10,15,10],backgroundColor:\"#FFFFFF\",plotBorderColor:\"#C0C0C0\",resetZoomButton:{theme:{zIndex:20},position:{align:\"right\",x:-10,y:10}},width:null,height:null},title:{text:\"Chart title\",align:\"center\",margin:15,style:{color:\"#333333\",fontSize:\"18px\"},widthAdjust:-44},subtitle:{text:\"\",align:\"center\",style:{color:\"#555555\"},\nwidthAdjust:-44},plotOptions:{line:{allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},lineWidth:2,marker:{lineWidth:0,radius:4,lineColor:\"#FFFFFF\",states:{hover:{enabled:!0,lineWidthPlus:1,radiusPlus:2},select:{fillColor:\"#FFFFFF\",lineColor:\"#000000\",lineWidth:2}}},point:{events:{}},dataLabels:{align:\"center\",formatter:function(){return this.y===null?\"\":u.numberFormat(this.y,-1)},style:{color:\"contrast\",fontSize:\"11px\",fontWeight:\"bold\",textShadow:\"0 0 6px contrast, 0 0 3px contrast\"},\nverticalAlign:\"bottom\",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{lineWidthPlus:1,marker:{},halo:{size:10,opacity:0.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3}},labels:{style:{position:\"absolute\",color:\"#3E576F\"}},legend:{enabled:!0,align:\"center\",layout:\"horizontal\",labelFormatter:function(){return this.name},borderColor:\"#909090\",borderRadius:0,navigation:{activeColor:\"#274b6d\",inactiveColor:\"#CCC\"},shadow:!1,itemStyle:{color:\"#333333\",fontSize:\"12px\",\nfontWeight:\"bold\"},itemHoverStyle:{color:\"#000\"},itemHiddenStyle:{color:\"#CCC\"},itemCheckboxStyle:{position:\"absolute\",width:\"13px\",height:\"13px\"},symbolPadding:5,verticalAlign:\"bottom\",x:0,y:0,title:{style:{fontWeight:\"bold\"}}},loading:{labelStyle:{fontWeight:\"bold\",position:\"relative\",top:\"45%\"},style:{position:\"absolute\",backgroundColor:\"white\",opacity:0.5,textAlign:\"center\"}},tooltip:{enabled:!0,animation:fa,backgroundColor:\"rgba(249, 249, 249, .85)\",borderWidth:1,borderRadius:3,dateTimeLabelFormats:{millisecond:\"%A, %b %e, %H:%M:%S.%L\",\nsecond:\"%A, %b %e, %H:%M:%S\",minute:\"%A, %b %e, %H:%M\",hour:\"%A, %b %e, %H:%M\",day:\"%A, %b %e, %Y\",week:\"Week from %A, %b %e, %Y\",month:\"%B %Y\",year:\"%Y\"},footerFormat:\"\",headerFormat:'<span style=\"font-size: 10px\">{point.key}</span><br/>',pointFormat:'<span style=\"color:{point.color}\">\\u25cf</span> {series.name}: <b>{point.y}</b><br/>',shadow:!0,snap:Ob?25:10,style:{color:\"#333333\",cursor:\"default\",fontSize:\"12px\",padding:\"8px\",pointerEvents:\"none\",whiteSpace:\"nowrap\"}},credits:{enabled:!0,text:\"Highcharts.com\",\nhref:\"http://www.highcharts.com\",position:{align:\"right\",x:-10,verticalAlign:\"bottom\",y:-5},style:{cursor:\"pointer\",color:\"#909090\",fontSize:\"9px\"}}};var ga=T.plotOptions,ha=ga.line;Hb();na.prototype={parsers:[{regex:/rgba\\(\\s*([0-9]{1,3})\\s*,\\s*([0-9]{1,3})\\s*,\\s*([0-9]{1,3})\\s*,\\s*([0-9]?(?:\\.[0-9]+)?)\\s*\\)/,parse:function(a){return[B(a[1]),B(a[2]),B(a[3]),parseFloat(a[4],10)]}},{regex:/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,parse:function(a){return[B(a[1],16),B(a[2],16),B(a[3],16),\n1]}},{regex:/rgb\\(\\s*([0-9]{1,3})\\s*,\\s*([0-9]{1,3})\\s*,\\s*([0-9]{1,3})\\s*\\)/,parse:function(a){return[B(a[1]),B(a[2]),B(a[3]),1]}}],init:function(a){var b,c,d,e;if((this.input=a)&&a.stops)this.stops=Ea(a.stops,function(a){return new na(a[1])});else for(d=this.parsers.length;d--&&!c;)e=this.parsers[d],(b=e.regex.exec(a))&&(c=e.parse(b));this.rgba=c||[]},get:function(a){var b=this.input,c=this.rgba,d;this.stops?(d=E(b),d.stops=[].concat(d.stops),q(this.stops,function(b,c){d.stops[c]=[d.stops[c][0],\nb.get(a)]})):d=c&&I(c[0])?a===\"rgb\"||!a&&c[3]===1?\"rgb(\"+c[0]+\",\"+c[1]+\",\"+c[2]+\")\":a===\"a\"?c[3]:\"rgba(\"+c.join(\",\")+\")\":b;return d},brighten:function(a){var b,c=this.rgba;if(this.stops)q(this.stops,function(b){b.brighten(a)});else if(I(a)&&a!==0)for(b=0;b<3;b++)c[b]+=B(a*255),c[b]<0&&(c[b]=0),c[b]>255&&(c[b]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this}};J.prototype={opacity:1,textProps:\"direction,fontSize,fontWeight,fontFamily,fontStyle,color,lineHeight,width,textDecoration,textOverflow,textShadow\".split(\",\"),\ninit:function(a,b){this.element=b===\"span\"?ca(b):y.createElementNS(Ia,b);this.renderer=a},animate:function(a,b,c){b=p(b,this.renderer.globalAnimation,!0);Ka(this);if(b){if(c)b.complete=c;Za(this,a,b)}else this.attr(a,null,c);return this},colorGradient:function(a,b,c){var d=this.renderer,e,f,g,h,i,j,k,l,m,n,o,A=[],r;a.linearGradient?f=\"linearGradient\":a.radialGradient&&(f=\"radialGradient\");if(f){g=a[f];i=d.gradients;k=a.stops;n=c.radialReference;za(g)&&(a[f]=g={x1:g[0],y1:g[1],x2:g[2],y2:g[3],gradientUnits:\"userSpaceOnUse\"});\nf===\"radialGradient\"&&n&&!s(g.gradientUnits)&&(h=g,g=E(g,d.getRadialAttr(n,h),{gradientUnits:\"userSpaceOnUse\"}));for(o in g)o!==\"id\"&&A.push(o,g[o]);for(o in k)A.push(k[o]);A=A.join(\",\");i[A]?n=i[A].attr(\"id\"):(g.id=n=\"highcharts-\"+Cb++,i[A]=j=d.createElement(f).attr(g).add(d.defs),j.radAttr=h,j.stops=[],q(k,function(a){a[1].indexOf(\"rgba\")===0?(e=na(a[1]),l=e.get(\"rgb\"),m=e.get(\"a\")):(l=a[1],m=1);a=d.createElement(\"stop\").attr({offset:a[0],\"stop-color\":l,\"stop-opacity\":m}).add(j);j.stops.push(a)}));\nr=\"url(\"+d.url+\"#\"+n+\")\";c.setAttribute(b,r);c.gradient=A;a.toString=function(){return r}}},applyTextShadow:function(a){var b=this.element,c,d=a.indexOf(\"contrast\")!==-1,e={},f=this.renderer.forExport,g=f||b.style.textShadow!==z&&!Aa;if(d)e.textShadow=a=a.replace(/contrast/g,this.renderer.getContrast(b.style.fill));if(pb||f)e.textRendering=\"geometricPrecision\";g?this.css(e):(this.fakeTS=!0,this.ySetter=this.xSetter,c=[].slice.call(b.getElementsByTagName(\"tspan\")),q(a.split(/\\s?,\\s?/g),function(a){var d=\nb.firstChild,e,f,a=a.split(\" \");e=a[a.length-1];(f=a[a.length-2])&&q(c,function(a,c){var g;c===0&&(a.setAttribute(\"x\",b.getAttribute(\"x\")),c=b.getAttribute(\"y\"),a.setAttribute(\"y\",c||0),c===null&&b.setAttribute(\"y\",0));g=a.cloneNode(1);O(g,{\"class\":\"highcharts-text-shadow\",fill:e,stroke:e,\"stroke-opacity\":1/t(B(f),3),\"stroke-width\":f,\"stroke-linejoin\":\"round\"});b.insertBefore(g,d)})}))},attr:function(a,b,c){var d,e=this.element,f,g=this,h;typeof a===\"string\"&&b!==z&&(d=a,a={},a[d]=b);if(typeof a===\n\"string\")g=(this[a+\"Getter\"]||this._defaultGetter).call(this,a,e);else{for(d in a){b=a[d];h=!1;this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)/.test(d)&&(f||(this.symbolAttr(a),f=!0),h=!0);if(this.rotation&&(d===\"x\"||d===\"y\"))this.doTransform=!0;h||(h=this[d+\"Setter\"]||this._defaultSetter,h.call(this,b,d,e),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(d)&&this.updateShadows(d,b,h))}if(this.doTransform)this.updateTransform(),this.doTransform=!1}c&&\nc();return g},updateShadows:function(a,b,c){for(var d=this.shadows,e=d.length;e--;)c.call(d[e],a===\"height\"?Math.max(b-(d[e].cutHeight||0),0):a===\"d\"?this.d:b,a,d[e])},addClass:function(a){var b=this.element,c=O(b,\"class\")||\"\";c.indexOf(a)===-1&&O(b,\"class\",c+\" \"+a);return this},symbolAttr:function(a){var b=this;q(\"x,y,r,start,end,width,height,innerR,anchorX,anchorY\".split(\",\"),function(c){b[c]=p(a[c],b[c])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr(\"clip-path\",\na?\"url(\"+this.renderer.url+\"#\"+a.id+\")\":\"none\")},crisp:function(a){var b,c={},d,e=this.strokeWidth||0;d=C(e)%2/2;a.x=V(a.x||this.x||0)+d;a.y=V(a.y||this.y||0)+d;a.width=V((a.width||this.width||0)-2*d);a.height=V((a.height||this.height||0)-2*d);a.strokeWidth=e;for(b in a)this[b]!==a[b]&&(this[b]=c[b]=a[b]);return c},css:function(a){var b=this.styles,c={},d=this.element,e,f,g=\"\";e=!b;if(a&&a.color)a.fill=a.color;if(b)for(f in a)a[f]!==b[f]&&(c[f]=a[f],e=!0);if(e){e=this.textWidth=a&&a.width&&d.nodeName.toLowerCase()===\n\"text\"&&B(a.width)||this.textWidth;b&&(a=x(b,c));this.styles=a;e&&(la||!fa&&this.renderer.forExport)&&delete a.width;if(Aa&&!fa)M(this.element,a);else{b=function(a,b){return\"-\"+b.toLowerCase()};for(f in a)g+=f.replace(/([A-Z])/g,b)+\":\"+a[f]+\";\";O(d,\"style\",g)}e&&this.added&&this.renderer.buildText(this)}return this},on:function(a,b){var c=this,d=c.element;gb&&a===\"click\"?(d.ontouchstart=function(a){c.touchEventFired=ma.now();a.preventDefault();b.call(d,a)},d.onclick=function(a){(Ba.indexOf(\"Android\")===\n-1||ma.now()-(c.touchEventFired||0)>1100)&&b.call(d,a)}):d[\"on\"+a]=b;return this},setRadialReference:function(a){var b=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,b.radAttr));return this},translate:function(a,b){return this.attr({translateX:a,translateY:b})},invert:function(){this.inverted=!0;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,c=this.scaleX,\nd=this.scaleY,e=this.inverted,f=this.rotation,g=this.element;e&&(a+=this.attr(\"width\"),b+=this.attr(\"height\"));a=[\"translate(\"+a+\",\"+b+\")\"];e?a.push(\"rotate(90) scale(-1,1)\"):f&&a.push(\"rotate(\"+f+\" \"+(g.getAttribute(\"x\")||0)+\" \"+(g.getAttribute(\"y\")||0)+\")\");(s(c)||s(d))&&a.push(\"scale(\"+p(c,1)+\" \"+p(d,1)+\")\");a.length&&g.setAttribute(\"transform\",a.join(\" \"))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,b,c){var d,e,f,g,h={};e=this.renderer;f=e.alignedObjects;\nif(a){if(this.alignOptions=a,this.alignByTranslate=b,!c||ya(c))this.alignTo=d=c||\"renderer\",ra(f,this),f.push(this),c=null}else a=this.alignOptions,b=this.alignByTranslate,d=this.alignTo;c=p(c,e[d],e);d=a.align;e=a.verticalAlign;f=(c.x||0)+(a.x||0);g=(c.y||0)+(a.y||0);if(d===\"right\"||d===\"center\")f+=(c.width-(a.width||0))/{right:1,center:2}[d];h[b?\"translateX\":\"x\"]=C(f);if(e===\"bottom\"||e===\"middle\")g+=(c.height-(a.height||0))/({bottom:1,middle:2}[e]||1);h[b?\"translateY\":\"y\"]=C(g);this[this.placed?\n\"animate\":\"attr\"](h);this.placed=!0;this.alignAttr=h;return this},getBBox:function(a,b){var c,d=this.renderer,e,f,g,h=this.element,i=this.styles;e=this.textStr;var j,k=h.style,l,m=d.cache,n=d.cacheKeys,o;f=p(b,this.rotation);g=f*ka;e!==z&&(o=e.toString().replace(Tb,\"0\")+[\"\",f||0,i&&i.fontSize,h.style.width].join(\",\"));o&&!a&&(c=m[o]);if(!c){if(h.namespaceURI===Ia||d.forExport){try{l=this.fakeTS&&function(a){q(h.querySelectorAll(\".highcharts-text-shadow\"),function(b){b.style.display=a})},Qa&&k.textShadow?\n(j=k.textShadow,k.textShadow=\"\"):l&&l(\"none\"),c=h.getBBox?x({},h.getBBox()):{width:h.offsetWidth,height:h.offsetHeight},j?k.textShadow=j:l&&l(\"\")}catch(A){}if(!c||c.width<0)c={width:0,height:0}}else c=this.htmlGetBBox();if(d.isSVG){d=c.width;e=c.height;if(Aa&&i&&i.fontSize===\"11px\"&&e.toPrecision(3)===\"16.9\")c.height=e=14;if(f)c.width=Q(e*da(g))+Q(d*W(g)),c.height=Q(e*W(g))+Q(d*da(g))}if(o&&c.height>0){for(;n.length>250;)delete m[n.shift()];m[o]||n.push(o);m[o]=c}}return c},show:function(a){return this.attr({visibility:a?\n\"inherit\":\"visible\"})},hide:function(){return this.attr({visibility:\"hidden\"})},fadeOut:function(a){var b=this;b.animate({opacity:0},{duration:a||150,complete:function(){b.attr({y:-9999})}})},add:function(a){var b=this.renderer,c=this.element,d;if(a)this.parentGroup=a;this.parentInverted=a&&a.inverted;this.textStr!==void 0&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)d=this.zIndexSetter();d||(a?a.element:b.box).appendChild(c);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=\na.parentNode;b&&b.removeChild(a)},destroy:function(){var a=this,b=a.element||{},c=a.shadows,d=a.renderer.isSVG&&b.nodeName===\"SPAN\"&&a.parentGroup,e,f;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;Ka(a);if(a.clipPath)a.clipPath=a.clipPath.destroy();if(a.stops){for(f=0;f<a.stops.length;f++)a.stops[f]=a.stops[f].destroy();a.stops=null}a.safeRemoveChild(b);for(c&&q(c,function(b){a.safeRemoveChild(b)});d&&d.div&&d.div.childNodes.length===0;)b=d.parentGroup,a.safeRemoveChild(d.div),delete d.div,\nd=b;a.alignTo&&ra(a.renderer.alignedObjects,a);for(e in a)delete a[e];return null},shadow:function(a,b,c){var d=[],e,f,g=this.element,h,i,j,k;if(a){i=p(a.width,3);j=(a.opacity||0.15)/i;k=this.parentInverted?\"(-1,-1)\":\"(\"+p(a.offsetX,1)+\", \"+p(a.offsetY,1)+\")\";for(e=1;e<=i;e++){f=g.cloneNode(0);h=i*2+1-2*e;O(f,{isShadow:\"true\",stroke:a.color||\"black\",\"stroke-opacity\":j*e,\"stroke-width\":h,transform:\"translate\"+k,fill:\"none\"});if(c)O(f,\"height\",t(O(f,\"height\")-h,0)),f.cutHeight=h;b?b.element.appendChild(f):\ng.parentNode.insertBefore(f,g);d.push(f)}this.shadows=d}return this},xGetter:function(a){this.element.nodeName===\"circle\"&&(a={x:\"cx\",y:\"cy\"}[a]||a);return this._defaultGetter(a)},_defaultGetter:function(a){a=p(this[a],this.element?this.element.getAttribute(a):null,0);/^[\\-0-9\\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,b,c){a&&a.join&&(a=a.join(\" \"));/(NaN| {2}|^$)/.test(a)&&(a=\"M 0 0\");c.setAttribute(b,a);this[b]=a},dashstyleSetter:function(a){var b,c=this[\"stroke-width\"];c===\n\"inherit\"&&(c=1);if(a=a&&a.toLowerCase()){a=a.replace(\"shortdashdotdot\",\"3,1,1,1,1,1,\").replace(\"shortdashdot\",\"3,1,1,1\").replace(\"shortdot\",\"1,1,\").replace(\"shortdash\",\"3,1,\").replace(\"longdash\",\"8,3,\").replace(/dot/g,\"1,3,\").replace(\"dash\",\"4,3,\").replace(/,$/,\"\").split(\",\");for(b=a.length;b--;)a[b]=B(a[b])*c;a=a.join(\",\").replace(/NaN/g,\"none\");this.element.setAttribute(\"stroke-dasharray\",a)}},alignSetter:function(a){this.element.setAttribute(\"text-anchor\",{left:\"start\",center:\"middle\",right:\"end\"}[a])},\ntitleSetter:function(a){var b=this.element.getElementsByTagName(\"title\")[0];b||(b=y.createElementNS(Ia,\"title\"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(y.createTextNode(String(p(a),\"\").replace(/<[^>]*>/g,\"\")))},textSetter:function(a){if(a!==this.textStr)delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this)},fillSetter:function(a,b,c){typeof a===\"string\"?c.setAttribute(b,a):a&&this.colorGradient(a,b,c)},visibilitySetter:function(a,b,\nc){a===\"inherit\"?c.removeAttribute(b):c.setAttribute(b,a)},zIndexSetter:function(a,b){var c=this.renderer,d=this.parentGroup,c=(d||c).element||c.box,e,f,g=this.element,h;e=this.added;var i;if(s(a))g.zIndex=a,a=+a,this[b]===a&&(e=!1),this[b]=a;if(e){if((a=this.zIndex)&&d)d.handleZ=!0;d=c.childNodes;for(i=0;i<d.length&&!h;i++)if(e=d[i],f=e.zIndex,e!==g&&(B(f)>a||!s(a)&&s(f)))c.insertBefore(g,e),h=!0;h||c.appendChild(g)}return h},_defaultSetter:function(a,b,c){c.setAttribute(b,a)}};J.prototype.yGetter=\nJ.prototype.xGetter;J.prototype.translateXSetter=J.prototype.translateYSetter=J.prototype.rotationSetter=J.prototype.verticalAlignSetter=J.prototype.scaleXSetter=J.prototype.scaleYSetter=function(a,b){this[b]=a;this.doTransform=!0};J.prototype.opacitySetter=J.prototype.displaySetter=function(a,b,c){this[b]=a;c.setAttribute(b,a)};J.prototype[\"stroke-widthSetter\"]=J.prototype.strokeSetter=function(a,b,c){this[b]=a;if(this.stroke&&this[\"stroke-width\"])this.strokeWidth=this[\"stroke-width\"],J.prototype.fillSetter.call(this,\nthis.stroke,\"stroke\",c),c.setAttribute(\"stroke-width\",this[\"stroke-width\"]),this.hasStroke=!0;else if(b===\"stroke-width\"&&a===0&&this.hasStroke)c.removeAttribute(\"stroke\"),this.hasStroke=!1};var Fa=function(){this.init.apply(this,arguments)};Fa.prototype={Element:J,init:function(a,b,c,d,e,f){var g,d=this.createElement(\"svg\").attr({version:\"1.1\"}).css(this.getStyle(d));g=d.element;a.appendChild(g);a.innerHTML.indexOf(\"xmlns\")===-1&&O(g,\"xmlns\",Ia);this.isSVG=!0;this.box=g;this.boxWrapper=d;this.alignedObjects=\n[];this.url=(Qa||pb)&&y.getElementsByTagName(\"base\").length?D.location.href.replace(/#.*?$/,\"\").replace(/([\\('\\)])/g,\"\\\\$1\").replace(/ /g,\"%20\"):\"\";this.createElement(\"desc\").add().element.appendChild(y.createTextNode(\"Created with Highcharts 4.2.7\"));this.defs=this.createElement(\"defs\").add();this.allowHTML=f;this.forExport=e;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);var h;if(Qa&&a.getBoundingClientRect)this.subPixelFix=b=function(){M(a,{left:0,top:0});\nh=a.getBoundingClientRect();M(a,{left:va(h.left)-h.left+\"px\",top:va(h.top)-h.top+\"px\"})},b(),N(D,\"resize\",b)},getStyle:function(a){return this.style=x({fontFamily:'\"Lucida Grande\", \"Lucida Sans Unicode\", Arial, Helvetica, sans-serif',fontSize:\"12px\"},a)},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();Ua(this.gradients||{});this.gradients=null;if(a)this.defs=a.destroy();this.subPixelFix&&Y(D,\"resize\",\nthis.subPixelFix);return this.alignedObjects=null},createElement:function(a){var b=new this.Element;b.init(this,a);return b},draw:function(){},getRadialAttr:function(a,b){return{cx:a[0]-a[2]/2+b.cx*a[2],cy:a[1]-a[2]/2+b.cy*a[2],r:b.r*a[2]}},buildText:function(a){for(var b=a.element,c=this,d=c.forExport,e=p(a.textStr,\"\").toString(),f=e.indexOf(\"<\")!==-1,g=b.childNodes,h,i,j,k=O(b,\"x\"),l=a.styles,m=a.textWidth,n=l&&l.lineHeight,o=l&&l.textShadow,A=l&&l.textOverflow===\"ellipsis\",r=g.length,K=m&&!a.added&&\nthis.box,w=function(a){return n?B(n):c.fontMetrics(/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:l&&l.fontSize||c.style.fontSize||12,a).h},v=function(a){return a.replace(/&lt;/g,\"<\").replace(/&gt;/g,\">\")};r--;)b.removeChild(g[r]);!f&&!o&&!A&&!m&&e.indexOf(\" \")===-1?b.appendChild(y.createTextNode(v(e))):(h=/<.*style=\"([^\"]+)\".*>/,i=/<.*href=\"(http[^\"]+)\".*>/,K&&K.appendChild(b),e=f?e.replace(/<(b|strong)>/g,'<span style=\"font-weight:bold\">').replace(/<(i|em)>/g,'<span style=\"font-style:italic\">').replace(/<a/g,\n\"<span\").replace(/<\\/(b|strong|i|em|a)>/g,\"</span>\").split(/<br.*?>/g):[e],e=Da(e,function(a){return a!==\"\"}),q(e,function(e,f){var g,n=0,e=e.replace(/^\\s+|\\s+$/g,\"\").replace(/<span/g,\"|||<span\").replace(/<\\/span>/g,\"</span>|||\");g=e.split(\"|||\");q(g,function(e){if(e!==\"\"||g.length===1){var o={},r=y.createElementNS(Ia,\"tspan\"),p;h.test(e)&&(p=e.match(h)[1].replace(/(;| |^)color([ :])/,\"$1fill$2\"),O(r,\"style\",p));i.test(e)&&!d&&(O(r,\"onclick\",'location.href=\"'+e.match(i)[1]+'\"'),M(r,{cursor:\"pointer\"}));\ne=v(e.replace(/<(.|\\n)*?>/g,\"\")||\" \");if(e!==\" \"){r.appendChild(y.createTextNode(e));if(n)o.dx=0;else if(f&&k!==null)o.x=k;O(r,o);b.appendChild(r);!n&&f&&(!fa&&d&&M(r,{display:\"block\"}),O(r,\"dy\",w(r)));if(m){for(var o=e.replace(/([^\\^])-/g,\"$1- \").split(\" \"),q=l.whiteSpace===\"nowrap\",K=g.length>1||f||o.length>1&&!q,Ra,s,La=[],t=w(r),x=1,C=a.rotation,u=e,z=u.length;(K||A)&&(o.length||La.length);)a.rotation=0,Ra=a.getBBox(!0),s=Ra.width,!fa&&c.forExport&&(s=c.measureSpanWidth(r.firstChild.data,a.styles)),\nRa=s>m,j===void 0&&(j=Ra),A&&j?(z/=2,u===\"\"||!Ra&&z<0.5?o=[]:(u=e.substring(0,u.length+(Ra?-1:1)*va(z)),o=[u+(m>3?\"\\u2026\":\"\")],r.removeChild(r.firstChild))):!Ra||o.length===1?(o=La,La=[],o.length&&!q&&(x++,r=y.createElementNS(Ia,\"tspan\"),O(r,{dy:t,x:k}),p&&O(r,\"style\",p),b.appendChild(r)),s>m&&(m=s)):(r.removeChild(r.firstChild),La.unshift(o.pop())),o.length&&r.appendChild(y.createTextNode(o.join(\" \").replace(/- /g,\"-\")));a.rotation=C}n++}}})}),j&&a.attr(\"title\",a.textStr),K&&K.removeChild(b),o&&\na.applyTextShadow&&a.applyTextShadow(o))},getContrast:function(a){a=na(a).rgba;return a[0]+a[1]+a[2]>384?\"#000000\":\"#FFFFFF\"},button:function(a,b,c,d,e,f,g,h,i){var j=this.label(a,b,c,i,null,null,null,null,\"button\"),k=0,l,m,n,o,A,r,a={x1:0,y1:0,x2:0,y2:1},e=E({\"stroke-width\":1,stroke:\"#CCCCCC\",fill:{linearGradient:a,stops:[[0,\"#FEFEFE\"],[1,\"#F6F6F6\"]]},r:2,padding:5,style:{color:\"black\"}},e);n=e.style;delete e.style;f=E(e,{stroke:\"#68A\",fill:{linearGradient:a,stops:[[0,\"#FFF\"],[1,\"#ACF\"]]}},f);o=\nf.style;delete f.style;g=E(e,{stroke:\"#68A\",fill:{linearGradient:a,stops:[[0,\"#9BD\"],[1,\"#CDF\"]]}},g);A=g.style;delete g.style;h=E(e,{style:{color:\"#CCC\"}},h);r=h.style;delete h.style;N(j.element,Aa?\"mouseover\":\"mouseenter\",function(){k!==3&&j.attr(f).css(o)});N(j.element,Aa?\"mouseout\":\"mouseleave\",function(){k!==3&&(l=[e,f,g][k],m=[n,o,A][k],j.attr(l).css(m))});j.setState=function(a){(j.state=k=a)?a===2?j.attr(g).css(A):a===3&&j.attr(h).css(r):j.attr(e).css(n)};return j.on(\"click\",function(a){k!==\n3&&d.call(j,a)}).attr(e).css(x({cursor:\"default\"},n))},crispLine:function(a,b){a[1]===a[4]&&(a[1]=a[4]=C(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=C(a[2])+b%2/2);return a},path:function(a){var b={fill:\"none\"};za(a)?b.d=a:ba(a)&&x(b,a);return this.createElement(\"path\").attr(b)},circle:function(a,b,c){a=ba(a)?a:{x:a,y:b,r:c};b=this.createElement(\"circle\");b.xSetter=b.ySetter=function(a,b,c){c.setAttribute(\"c\"+b,a)};return b.attr(a)},arc:function(a,b,c,d,e,f){if(ba(a))b=a.y,c=a.r,d=a.innerR,e=a.start,f=a.end,\na=a.x;a=this.symbol(\"arc\",a||0,b||0,c||0,c||0,{innerR:d||0,start:e||0,end:f||0});a.r=c;return a},rect:function(a,b,c,d,e,f){var e=ba(a)?a.r:e,g=this.createElement(\"rect\"),a=ba(a)?a:a===z?{}:{x:a,y:b,width:t(c,0),height:t(d,0)};if(f!==z)g.strokeWidth=f,a=g.crisp(a);if(e)a.r=e;g.rSetter=function(a,b,c){O(c,{rx:a,ry:a})};return g.attr(a)},setSize:function(a,b,c){var d=this.alignedObjects,e=d.length;this.width=a;this.height=b;for(this.boxWrapper[p(c,!0)?\"animate\":\"attr\"]({width:a,height:b});e--;)d[e].align()},\ng:function(a){var b=this.createElement(\"g\");return s(a)?b.attr({\"class\":\"highcharts-\"+a}):b},image:function(a,b,c,d,e){var f={preserveAspectRatio:\"none\"};arguments.length>1&&x(f,{x:b,y:c,width:d,height:e});f=this.createElement(\"image\").attr(f);f.element.setAttributeNS?f.element.setAttributeNS(\"http://www.w3.org/1999/xlink\",\"href\",a):f.element.setAttribute(\"hc-svg-href\",a);return f},symbol:function(a,b,c,d,e,f){var g=this,h,i=this.symbols[a],i=i&&i(C(b),C(c),d,e,f),j=/^url\\((.*?)\\)$/,k,l;if(i)h=this.path(i),\nx(h,{symbolName:a,x:b,y:c,width:d,height:e}),f&&x(h,f);else if(j.test(a))l=function(a,b){a.element&&(a.attr({width:b[0],height:b[1]}),a.alignByTranslate||a.translate(C((d-b[0])/2),C((e-b[1])/2)))},k=a.match(j)[1],a=Pb[k]||f&&f.width&&f.height&&[f.width,f.height],h=this.image(k).attr({x:b,y:c}),h.isImg=!0,a?l(h,a):(h.attr({width:0,height:0}),ca(\"img\",{onload:function(){var a=U[g.chartIndex];this.width===0&&(M(this,{position:\"absolute\",top:\"-999em\"}),y.body.appendChild(this));l(h,Pb[k]=[this.width,\nthis.height]);this.parentNode&&this.parentNode.removeChild(this);g.imgCount--;if(!g.imgCount&&a&&a.onload)a.onload()},src:k}),this.imgCount++);return h},symbols:{circle:function(a,b,c,d){var e=0.166*c;return[X,a+c/2,b,\"C\",a+c+e,b,a+c+e,b+d,a+c/2,b+d,\"C\",a-e,b+d,a-e,b,a+c/2,b,\"Z\"]},square:function(a,b,c,d){return[X,a,b,S,a+c,b,a+c,b+d,a,b+d,\"Z\"]},triangle:function(a,b,c,d){return[X,a+c/2,b,S,a+c,b+d,a,b+d,\"Z\"]},\"triangle-down\":function(a,b,c,d){return[X,a,b,S,a+c,b,a+c/2,b+d,\"Z\"]},diamond:function(a,\nb,c,d){return[X,a+c/2,b,S,a+c,b+d/2,a+c/2,b+d,a,b+d/2,\"Z\"]},arc:function(a,b,c,d,e){var f=e.start,c=e.r||c||d,g=e.end-0.001,d=e.innerR,h=e.open,i=W(f),j=da(f),k=W(g),g=da(g),e=e.end-f<ta?0:1;return[X,a+c*i,b+c*j,\"A\",c,c,0,e,1,a+c*k,b+c*g,h?X:S,a+d*k,b+d*g,\"A\",d,d,0,e,0,a+d*i,b+d*j,h?\"\":\"Z\"]},callout:function(a,b,c,d,e){var f=F(e&&e.r||0,c,d),g=f+6,h=e&&e.anchorX,e=e&&e.anchorY,i;i=[\"M\",a+f,b,\"L\",a+c-f,b,\"C\",a+c,b,a+c,b,a+c,b+f,\"L\",a+c,b+d-f,\"C\",a+c,b+d,a+c,b+d,a+c-f,b+d,\"L\",a+f,b+d,\"C\",a,b+d,a,b+\nd,a,b+d-f,\"L\",a,b+f,\"C\",a,b,a,b,a+f,b];h&&h>c&&e>b+g&&e<b+d-g?i.splice(13,3,\"L\",a+c,e-6,a+c+6,e,a+c,e+6,a+c,b+d-f):h&&h<0&&e>b+g&&e<b+d-g?i.splice(33,3,\"L\",a,e+6,a-6,e,a,e-6,a,b+f):e&&e>d&&h>a+g&&h<a+c-g?i.splice(23,3,\"L\",h+6,b+d,h,b+d+6,h-6,b+d,a+f,b+d):e&&e<0&&h>a+g&&h<a+c-g&&i.splice(3,3,\"L\",h-6,b,h,b-6,h+6,b,c-f,b);return i}},clipRect:function(a,b,c,d){var e=\"highcharts-\"+Cb++,f=this.createElement(\"clipPath\").attr({id:e}).add(this.defs),a=this.rect(a,b,c,d,0).add(f);a.id=e;a.clipPath=f;a.count=\n0;return a},text:function(a,b,c,d){var e=la||!fa&&this.forExport,f={};if(d&&(this.allowHTML||!this.forExport))return this.html(a,b,c);f.x=Math.round(b||0);if(c)f.y=Math.round(c);if(a||a===0)f.text=a;a=this.createElement(\"text\").attr(f);e&&a.css({position:\"absolute\"});if(!d)a.xSetter=function(a,b,c){var d=c.getElementsByTagName(\"tspan\"),e,f=c.getAttribute(b),m;for(m=0;m<d.length;m++)e=d[m],e.getAttribute(b)===f&&e.setAttribute(b,a);c.setAttribute(b,a)};return a},fontMetrics:function(a,b){var c,d,a=\na||this.style.fontSize;!a&&b&&D.getComputedStyle&&(b=b.element||b,a=(c=D.getComputedStyle(b,\"\"))&&c.fontSize);a=/px/.test(a)?B(a):/em/.test(a)?parseFloat(a)*12:12;c=a<24?a+3:C(a*1.2);d=C(c*0.8);return{h:c,b:d,f:a}},rotCorr:function(a,b,c){var d=a;b&&c&&(d=t(d*W(b*ka),4));return{x:-a/3*da(b*ka),y:d}},label:function(a,b,c,d,e,f,g,h,i){var j=this,k=j.g(i),l=j.text(\"\",0,0,g).attr({zIndex:1}),m,n,o=0,A=3,r=0,p,w,v,La,rb=0,aa={},t,u=/^url\\((.*?)\\)$/.test(d),y=u,F,D,B;F=function(){var a,b;a=l.element.style;\nn=(p===void 0||w===void 0||k.styles.textAlign)&&s(l.textStr)&&l.getBBox();k.width=(p||n.width||0)+2*A+r;k.height=(w||n.height||0)+2*A;t=A+j.fontMetrics(a&&a.fontSize,l).b;if(y){if(!m)a=rb,b=(h?-t:0)+rb,k.box=m=j.symbols[d]||u?j.symbol(d,a,b,k.width,k.height,aa):j.rect(a,b,k.width,k.height,0,aa[\"stroke-width\"]),m.isImg||m.attr(\"fill\",\"none\"),m.add(k);m.isImg||m.attr(x({width:C(k.width),height:C(k.height)},aa));aa=null}};D=function(){var a=k.styles,a=a&&a.textAlign,b=r+A,c;c=h?0:t;if(s(p)&&n&&(a===\n\"center\"||a===\"right\"))b+={center:0.5,right:1}[a]*(p-n.width);if(b!==l.x||c!==l.y)l.attr(\"x\",b),c!==z&&l.attr(\"y\",c);l.x=b;l.y=c};B=function(a,b){m?m.attr(a,b):aa[a]=b};k.onAdd=function(){l.add(k);k.attr({text:a||a===0?a:\"\",x:b,y:c});m&&s(e)&&k.attr({anchorX:e,anchorY:f})};k.widthSetter=function(a){p=a};k.heightSetter=function(a){w=a};k.paddingSetter=function(a){if(s(a)&&a!==A)A=k.padding=a,D()};k.paddingLeftSetter=function(a){s(a)&&a!==r&&(r=a,D())};k.alignSetter=function(a){a={left:0,center:0.5,\nright:1}[a];a!==o&&(o=a,n&&k.attr({x:v}))};k.textSetter=function(a){a!==z&&l.textSetter(a);F();D()};k[\"stroke-widthSetter\"]=function(a,b){a&&(y=!0);rb=a%2/2;B(b,a)};k.strokeSetter=k.fillSetter=k.rSetter=function(a,b){b===\"fill\"&&a&&(y=!0);B(b,a)};k.anchorXSetter=function(a,b){e=a;B(b,C(a)-rb-v)};k.anchorYSetter=function(a,b){f=a;B(b,a-La)};k.xSetter=function(a){k.x=a;o&&(a-=o*((p||n.width)+2*A));v=C(a);k.attr(\"translateX\",v)};k.ySetter=function(a){La=k.y=C(a);k.attr(\"translateY\",La)};var G=k.css;\nreturn x(k,{css:function(a){if(a){var b={},a=E(a);q(k.textProps,function(c){a[c]!==z&&(b[c]=a[c],delete a[c])});l.css(b)}return G.call(k,a)},getBBox:function(){return{width:n.width+2*A,height:n.height+2*A,x:n.x-A,y:n.y-A}},shadow:function(a){m&&m.shadow(a);return k},destroy:function(){Y(k.element,\"mouseenter\");Y(k.element,\"mouseleave\");l&&(l=l.destroy());m&&(m=m.destroy());J.prototype.destroy.call(k);k=j=F=D=B=null}})}};fb=Fa;x(J.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&b.tagName===\n\"SPAN\"&&a.width)delete a.width,this.textWidth=b,this.updateTransform();if(a&&a.textOverflow===\"ellipsis\")a.whiteSpace=\"nowrap\",a.overflow=\"hidden\";this.styles=x(this.styles,a);M(this.element,a);return this},htmlGetBBox:function(){var a=this.element;if(a.nodeName===\"text\")a.style.position=\"absolute\";return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,c=this.translateX||0,d=this.translateY||\n0,e=this.x||0,f=this.y||0,g=this.textAlign||\"left\",h={left:0,center:0.5,right:1}[g],i=this.shadows,j=this.styles;M(b,{marginLeft:c,marginTop:d});i&&q(i,function(a){M(a,{marginLeft:c+1,marginTop:d+1})});this.inverted&&q(b.childNodes,function(c){a.invertChild(c,b)});if(b.tagName===\"SPAN\"){var i=this.rotation,k=B(this.textWidth),l=j&&j.whiteSpace,m=[i,g,b.innerHTML,this.textWidth,this.textAlign].join(\",\");if(m!==this.cTT){j=a.fontMetrics(b.style.fontSize).b;s(i)&&this.setSpanRotation(i,h,j);M(b,{width:\"\",\nwhiteSpace:l||\"nowrap\"});if(b.offsetWidth>k&&/[ \\-]/.test(b.textContent||b.innerText))M(b,{width:k+\"px\",display:\"block\",whiteSpace:l||\"normal\"});this.getSpanCorrection(b.offsetWidth,j,h,i,g)}M(b,{left:e+(this.xCorr||0)+\"px\",top:f+(this.yCorr||0)+\"px\"});if(pb)j=b.offsetHeight;this.cTT=m}}else this.alignOnAdd=!0},setSpanRotation:function(a,b,c){var d={},e=Aa?\"-ms-transform\":pb?\"-webkit-transform\":Qa?\"MozTransform\":Nb?\"-o-transform\":\"\";d[e]=d.transform=\"rotate(\"+a+\"deg)\";d[e+(Qa?\"Origin\":\"-origin\")]=\nd.transformOrigin=b*100+\"% \"+c+\"px\";M(this.element,d)},getSpanCorrection:function(a,b,c){this.xCorr=-a*c;this.yCorr=-b}});x(Fa.prototype,{html:function(a,b,c){var d=this.createElement(\"span\"),e=d.element,f=d.renderer,g=f.isSVG,h=function(a,b){q([\"display\",\"opacity\",\"visibility\"],function(c){ib(a,c+\"Setter\",function(a,c,d,e){a.call(this,c,d,e);b[d]=c})})};d.textSetter=function(a){a!==e.innerHTML&&delete this.bBox;e.innerHTML=this.textStr=a;d.htmlUpdateTransform()};g&&h(d,d.element.style);d.xSetter=\nd.ySetter=d.alignSetter=d.rotationSetter=function(a,b){b===\"align\"&&(b=\"textAlign\");d[b]=a;d.htmlUpdateTransform()};d.attr({text:a,x:C(b),y:C(c)}).css({position:\"absolute\",fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});e.style.whiteSpace=\"nowrap\";d.css=d.htmlCss;if(g)d.add=function(a){var b,c=f.box.parentNode,g=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)g.push(a),a=a.parentGroup;q(g.reverse(),function(a){var d,e=O(a.element,\"class\");e&&(e={className:e});b=a.div=a.div||ca(Pa,\ne,{position:\"absolute\",left:(a.translateX||0)+\"px\",top:(a.translateY||0)+\"px\",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||c);d=b.style;x(a,{translateXSetter:function(b,c){d.left=b+\"px\";a[c]=b;a.doTransform=!0},translateYSetter:function(b,c){d.top=b+\"px\";a[c]=b;a.doTransform=!0}});h(a,d)})}}else b=c;b.appendChild(e);d.added=!0;d.alignOnAdd&&d.htmlUpdateTransform();return d};return d}});var P;if(!fa&&!la){P={init:function(a,b){var c=[\"<\",b,' filled=\"f\" stroked=\"f\"'],\nd=[\"position: \",\"absolute\",\";\"],e=b===Pa;(b===\"shape\"||e)&&d.push(\"left:0;top:0;width:1px;height:1px;\");d.push(\"visibility: \",e?\"hidden\":\"visible\");c.push(' style=\"',d.join(\"\"),'\"/>');if(b)c=e||b===\"span\"||b===\"img\"?c.join(\"\"):a.prepVML(c),this.element=ca(c);this.renderer=a},add:function(a){var b=this.renderer,c=this.element,d=b.box,e=a&&a.inverted,d=a?a.element||a:d;if(a)this.parentGroup=a;e&&b.invertChild(c,d);d.appendChild(c);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();\nif(this.onAdd)this.onAdd();return this},updateTransform:J.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=W(a*ka),c=da(a*ka);M(this.element,{filter:a?[\"progid:DXImageTransform.Microsoft.Matrix(M11=\",b,\", M12=\",-c,\", M21=\",c,\", M22=\",b,\", sizingMethod='auto expand')\"].join(\"\"):\"none\"})},getSpanCorrection:function(a,b,c,d,e){var f=d?W(d*ka):1,g=d?da(d*ka):0,h=p(this.elemHeight,this.element.offsetHeight),i;this.xCorr=f<0&&-a;this.yCorr=g<0&&-h;i=f*g<0;this.xCorr+=g*b*(i?\n1-c:c);this.yCorr-=f*b*(d?i?c:1-c:1);e&&e!==\"left\"&&(this.xCorr-=a*c*(f<0?-1:1),d&&(this.yCorr-=h*c*(g<0?-1:1)),M(this.element,{textAlign:e}))},pathToVML:function(a){for(var b=a.length,c=[];b--;)if(I(a[b]))c[b]=C(a[b]*10)-5;else if(a[b]===\"Z\")c[b]=\"x\";else if(c[b]=a[b],a.isArc&&(a[b]===\"wa\"||a[b]===\"at\"))c[b+5]===c[b+7]&&(c[b+7]+=a[b+7]>a[b+5]?1:-1),c[b+6]===c[b+8]&&(c[b+8]+=a[b+8]>a[b+6]?1:-1);return c.join(\" \")||\"x\"},clip:function(a){var b=this,c;a?(c=a.members,ra(c,b),c.push(b),b.destroyClip=function(){ra(c,\nb)},a=a.getCSS(b)):(b.destroyClip&&b.destroyClip(),a={clip:ob?\"inherit\":\"rect(auto)\"});return b.css(a)},css:J.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&Va(a)},destroy:function(){this.destroyClip&&this.destroyClip();return J.prototype.destroy.apply(this)},on:function(a,b){this.element[\"on\"+a]=function(){var a=D.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var c,a=a.split(/[ ,]/);c=a.length;if(c===9||c===11)a[c-4]=a[c-2]=B(a[c-2])-10*b;return a.join(\" \")},\nshadow:function(a,b,c){var d=[],e,f=this.element,g=this.renderer,h,i=f.style,j,k=f.path,l,m,n,o;k&&typeof k.value!==\"string\"&&(k=\"x\");m=k;if(a){n=p(a.width,3);o=(a.opacity||0.15)/n;for(e=1;e<=3;e++){l=n*2+1-2*e;c&&(m=this.cutOffPath(k.value,l+0.5));j=['<shape isShadow=\"true\" strokeweight=\"',l,'\" filled=\"false\" path=\"',m,'\" coordsize=\"10 10\" style=\"',f.style.cssText,'\" />'];h=ca(g.prepVML(j),null,{left:B(i.left)+p(a.offsetX,1),top:B(i.top)+p(a.offsetY,1)});if(c)h.cutOff=l+1;j=['<stroke color=\"',a.color||\n\"black\",'\" opacity=\"',o*e,'\"/>'];ca(g.prepVML(j),null,null,h);b?b.element.appendChild(h):f.parentNode.insertBefore(h,f);d.push(h)}this.shadows=d}return this},updateShadows:Ca,setAttr:function(a,b){ob?this.element[a]=b:this.element.setAttribute(a,b)},classSetter:function(a){this.element.className=a},dashstyleSetter:function(a,b,c){(c.getElementsByTagName(\"stroke\")[0]||ca(this.renderer.prepVML([\"<stroke/>\"]),null,null,c))[b]=a||\"solid\";this[b]=a},dSetter:function(a,b,c){var d=this.shadows,a=a||[];this.d=\na.join&&a.join(\" \");c.path=a=this.pathToVML(a);if(d)for(c=d.length;c--;)d[c].path=d[c].cutOff?this.cutOffPath(a,d[c].cutOff):a;this.setAttr(b,a)},fillSetter:function(a,b,c){var d=c.nodeName;if(d===\"SPAN\")c.style.color=a;else if(d!==\"IMG\")c.filled=a!==\"none\",this.setAttr(\"fillcolor\",this.renderer.color(a,c,b,this))},\"fill-opacitySetter\":function(a,b,c){ca(this.renderer.prepVML([\"<\",b.split(\"-\")[0],' opacity=\"',a,'\"/>']),null,null,c)},opacitySetter:Ca,rotationSetter:function(a,b,c){c=c.style;this[b]=\nc[b]=a;c.left=-C(da(a*ka)+1)+\"px\";c.top=C(W(a*ka))+\"px\"},strokeSetter:function(a,b,c){this.setAttr(\"strokecolor\",this.renderer.color(a,c,b,this))},\"stroke-widthSetter\":function(a,b,c){c.stroked=!!a;this[b]=a;I(a)&&(a+=\"px\");this.setAttr(\"strokeweight\",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,c){a===\"inherit\"&&(a=\"visible\");this.shadows&&q(this.shadows,function(c){c.style[b]=a});c.nodeName===\"DIV\"&&(a=a===\"hidden\"?\"-999em\":0,ob||(c.style[b]=a?\"visible\":\"hidden\"),\nb=\"top\");c.style[b]=a},displaySetter:function(a,b,c){c.style[b]=a},xSetter:function(a,b,c){this[b]=a;b===\"x\"?b=\"left\":b===\"y\"&&(b=\"top\");this.updateClipping?(this[b]=a,this.updateClipping()):c.style[b]=a},zIndexSetter:function(a,b,c){c.style[b]=a}};P[\"stroke-opacitySetter\"]=P[\"fill-opacitySetter\"];u.VMLElement=P=sa(J,P);P.prototype.ySetter=P.prototype.widthSetter=P.prototype.heightSetter=P.prototype.xSetter;var Eb={Element:P,isIE8:Ba.indexOf(\"MSIE 8.0\")>-1,init:function(a,b,c,d){var e;this.alignedObjects=\n[];d=this.createElement(Pa).css(x(this.getStyle(d),{position:\"relative\"}));e=d.element;a.appendChild(d.element);this.isVML=!0;this.box=e;this.boxWrapper=d;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);if(!y.namespaces.hcv){y.namespaces.add(\"hcv\",\"urn:schemas-microsoft-com:vml\");try{y.createStyleSheet().cssText=\"hcv\\\\:fill, hcv\\\\:path, hcv\\\\:shape, hcv\\\\:stroke{ behavior:url(#default#VML); display: inline-block; } \"}catch(f){y.styleSheets[0].cssText+=\"hcv\\\\:fill, hcv\\\\:path, hcv\\\\:shape, hcv\\\\:stroke{ behavior:url(#default#VML); display: inline-block; } \"}}},\nisHidden:function(){return!this.box.offsetWidth},clipRect:function(a,b,c,d){var e=this.createElement(),f=ba(a);return x(e,{members:[],count:0,left:(f?a.x:a)+1,top:(f?a.y:b)+1,width:(f?a.width:c)-1,height:(f?a.height:d)-1,getCSS:function(a){var b=a.element,c=b.nodeName,a=a.inverted,d=this.top-(c===\"shape\"?b.offsetTop:0),e=this.left,b=e+this.width,f=d+this.height,d={clip:\"rect(\"+C(a?e:d)+\"px,\"+C(a?f:b)+\"px,\"+C(a?b:f)+\"px,\"+C(a?d:e)+\"px)\"};!a&&ob&&c===\"DIV\"&&x(d,{width:b+\"px\",height:f+\"px\"});return d},\nupdateClipping:function(){q(e.members,function(a){a.element&&a.css(e.getCSS(a))})}})},color:function(a,b,c,d){var e=this,f,g=/^rgba/,h,i,j=\"none\";a&&a.linearGradient?i=\"gradient\":a&&a.radialGradient&&(i=\"pattern\");if(i){var k,l,m=a.linearGradient||a.radialGradient,n,o,A,r,p,w=\"\",a=a.stops,v,s=[],t=function(){h=['<fill colors=\"'+s.join(\",\")+'\" opacity=\"',A,'\" o:opacity2=\"',o,'\" type=\"',i,'\" ',w,'focus=\"100%\" method=\"any\" />'];ca(e.prepVML(h),null,null,b)};n=a[0];v=a[a.length-1];n[0]>0&&a.unshift([0,\nn[1]]);v[0]<1&&a.push([1,v[1]]);q(a,function(a,b){g.test(a[1])?(f=na(a[1]),k=f.get(\"rgb\"),l=f.get(\"a\")):(k=a[1],l=1);s.push(a[0]*100+\"% \"+k);b?(A=l,r=k):(o=l,p=k)});if(c===\"fill\")if(i===\"gradient\")c=m.x1||m[0]||0,a=m.y1||m[1]||0,n=m.x2||m[2]||0,m=m.y2||m[3]||0,w='angle=\"'+(90-Z.atan((m-a)/(n-c))*180/ta)+'\"',t();else{var j=m.r,aa=j*2,x=j*2,u=m.cx,C=m.cy,z=b.radialReference,y,j=function(){z&&(y=d.getBBox(),u+=(z[0]-y.x)/y.width-0.5,C+=(z[1]-y.y)/y.height-0.5,aa*=z[2]/y.width,x*=z[2]/y.height);w='src=\"'+\nT.global.VMLRadialGradientURL+'\" size=\"'+aa+\",\"+x+'\" origin=\"0.5,0.5\" position=\"'+u+\",\"+C+'\" color2=\"'+p+'\" ';t()};d.added?j():d.onAdd=j;j=r}else j=k}else if(g.test(a)&&b.tagName!==\"IMG\")f=na(a),d[c+\"-opacitySetter\"](f.get(\"a\"),c,b),j=f.get(\"rgb\");else{j=b.getElementsByTagName(c);if(j.length)j[0].opacity=1,j[0].type=\"solid\";j=a}return j},prepVML:function(a){var b=this.isIE8,a=a.join(\"\");b?(a=a.replace(\"/>\",' xmlns=\"urn:schemas-microsoft-com:vml\" />'),a=a.indexOf('style=\"')===-1?a.replace(\"/>\",' style=\"display:inline-block;behavior:url(#default#VML);\" />'):\na.replace('style=\"','style=\"display:inline-block;behavior:url(#default#VML);')):a=a.replace(\"<\",\"<hcv:\");return a},text:Fa.prototype.html,path:function(a){var b={coordsize:\"10 10\"};za(a)?b.d=a:ba(a)&&x(b,a);return this.createElement(\"shape\").attr(b)},circle:function(a,b,c){var d=this.symbol(\"circle\");if(ba(a))c=a.r,b=a.y,a=a.x;d.isCircle=!0;d.r=c;return d.attr({x:a,y:b})},g:function(a){var b;a&&(b={className:\"highcharts-\"+a,\"class\":\"highcharts-\"+a});return this.createElement(Pa).attr(b)},image:function(a,\nb,c,d,e){var f=this.createElement(\"img\").attr({src:a});arguments.length>1&&f.attr({x:b,y:c,width:d,height:e});return f},createElement:function(a){return a===\"rect\"?this.symbol(a):Fa.prototype.createElement.call(this,a)},invertChild:function(a,b){var c=this,d=b.style,e=a.tagName===\"IMG\"&&a.style;M(a,{flip:\"x\",left:B(d.width)-(e?B(e.top):1),top:B(d.height)-(e?B(e.left):1),rotation:-90});q(a.childNodes,function(b){c.invertChild(b,a)})},symbols:{arc:function(a,b,c,d,e){var f=e.start,g=e.end,h=e.r||c||\nd,c=e.innerR,d=W(f),i=da(f),j=W(g),k=da(g);if(g-f===0)return[\"x\"];f=[\"wa\",a-h,b-h,a+h,b+h,a+h*d,b+h*i,a+h*j,b+h*k];e.open&&!c&&f.push(\"e\",X,a,b);f.push(\"at\",a-c,b-c,a+c,b+c,a+c*j,b+c*k,a+c*d,b+c*i,\"x\",\"e\");f.isArc=!0;return f},circle:function(a,b,c,d,e){e&&(c=d=2*e.r);e&&e.isCircle&&(a-=c/2,b-=d/2);return[\"wa\",a,b,a+c,b+d,a+c,b+d/2,a+c,b+d/2,\"e\"]},rect:function(a,b,c,d,e){return Fa.prototype.symbols[!s(e)||!e.r?\"square\":\"callout\"].call(0,a,b,c,d,e)}}};u.VMLRenderer=P=function(){this.init.apply(this,\narguments)};P.prototype=E(Fa.prototype,Eb);fb=P}Fa.prototype.measureSpanWidth=function(a,b){var c=y.createElement(\"span\"),d;d=y.createTextNode(a);c.appendChild(d);M(c,b);this.box.appendChild(c);d=c.offsetWidth;Va(c);return d};var Qb;if(la)u.CanVGRenderer=P=function(){Ia=\"http://www.w3.org/1999/xhtml\"},P.prototype.symbols={},Qb=function(){function a(){var a=b.length,d;for(d=0;d<a;d++)b[d]();b=[]}var b=[];return{push:function(c,d){if(b.length===0){var e=y.getElementsByTagName(\"head\")[0],f=y.createElement(\"script\");\nf.type=\"text/javascript\";f.src=d;f.onload=a;e.appendChild(f)}b.push(c)}}}(),fb=P;Ya.prototype={addLabel:function(){var a=this.axis,b=a.options,c=a.chart,d=a.categories,e=a.names,f=this.pos,g=b.labels,h=a.tickPositions,i=f===h[0],j=f===h[h.length-1],e=d?p(d[f],e[f],f):f,d=this.label,h=h.info,k;a.isDatetimeAxis&&h&&(k=b.dateTimeLabelFormats[h.higherRanks[f]||h.unitName]);this.isFirst=i;this.isLast=j;b=a.labelFormatter.call({axis:a,chart:c,isFirst:i,isLast:j,dateTimeLabelFormat:k,value:a.isLog?$(a.lin2log(e)):\ne});s(d)?d&&d.attr({text:b}):(this.labelLength=(this.label=d=s(b)&&g.enabled?c.renderer.text(b,0,0,g.useHTML).css(E(g.style)).add(a.labelGroup):null)&&d.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?\"height\":\"width\"]:0},handleOverflow:function(a){var b=this.axis,c=a.x,d=b.chart.chartWidth,e=b.chart.spacing,f=p(b.labelLeft,F(b.pos,e[3])),e=p(b.labelRight,t(b.pos+b.len,d-e[1])),g=this.label,h=this.rotation,i={left:0,center:0.5,right:1}[b.labelAlign],\nj=g.getBBox().width,k=b.getSlotWidth(),l=k,m=1,n,o={};if(h)h<0&&c-i*j<f?n=C(c/W(h*ka)-f):h>0&&c+i*j>e&&(n=C((d-c)/W(h*ka)));else if(d=c+(1-i)*j,c-i*j<f?l=a.x+l*(1-i)-f:d>e&&(l=e-a.x+l*i,m=-1),l=F(k,l),l<k&&b.labelAlign===\"center\"&&(a.x+=m*(k-l-i*(k-F(j,l)))),j>l||b.autoRotation&&g.styles.width)n=l;if(n){o.width=n;if(!b.options.labels.style.textOverflow)o.textOverflow=\"ellipsis\";g.css(o)}},getPosition:function(a,b,c,d){var e=this.axis,f=e.chart,g=d&&f.oldChartHeight||f.chartHeight;return{x:a?e.translate(b+\nc,null,null,d)+e.transB:e.left+e.offset+(e.opposite?(d&&f.oldChartWidth||f.chartWidth)-e.right-e.left:0),y:a?g-e.bottom+e.offset-(e.opposite?e.height:0):g-e.translate(b+c,null,null,d)-e.transB}},getLabelPosition:function(a,b,c,d,e,f,g,h){var i=this.axis,j=i.transA,k=i.reversed,l=i.staggerLines,m=i.tickRotCorr||{x:0,y:0},n=e.y;s(n)||(n=i.side===0?c.rotation?-8:-c.getBBox().height:i.side===2?m.y+8:W(c.rotation*ka)*(m.y-c.getBBox(!1,0).height/2));a=a+e.x+m.x-(f&&d?f*j*(k?-1:1):0);b=b+n-(f&&!d?f*j*(k?\n1:-1):0);l&&(c=g/(h||1)%l,i.opposite&&(c=l-c-1),b+=c*(i.labelOffset/l));return{x:a,y:C(b)}},getMarkPath:function(a,b,c,d,e,f){return f.crispLine([X,a,b,S,a+(e?0:-c),b+(e?c:0)],d)},render:function(a,b,c){var d=this.axis,e=d.options,f=d.chart.renderer,g=d.horiz,h=this.type,i=this.label,j=this.pos,k=e.labels,l=this.gridLine,m=h?h+\"Grid\":\"grid\",n=h?h+\"Tick\":\"tick\",o=e[m+\"LineWidth\"],A=e[m+\"LineColor\"],r=e[m+\"LineDashStyle\"],m=d.tickSize(n),n=e[n+\"Color\"],q=this.mark,w=k.step,v=!0,s=d.tickmarkOffset,t=\nthis.getPosition(g,j,s,b),aa=t.x,t=t.y,x=g&&aa===d.pos+d.len||!g&&t===d.pos?-1:1,c=p(c,1);this.isActive=!0;if(o){j=d.getPlotLinePath(j+s,o*x,b,!0);if(l===z){l={stroke:A,\"stroke-width\":o};if(r)l.dashstyle=r;if(!h)l.zIndex=1;if(b)l.opacity=0;this.gridLine=l=o?f.path(j).attr(l).add(d.gridGroup):null}if(!b&&l&&j)l[this.isNew?\"attr\":\"animate\"]({d:j,opacity:c})}if(m)d.opposite&&(m[0]=-m[0]),h=this.getMarkPath(aa,t,m[0],m[1]*x,g,f),q?q.animate({d:h,opacity:c}):this.mark=f.path(h).attr({stroke:n,\"stroke-width\":m[1],\nopacity:c}).add(d.axisGroup);if(i&&I(aa))i.xy=t=this.getLabelPosition(aa,t,i,g,k,s,a,w),this.isFirst&&!this.isLast&&!p(e.showFirstLabel,1)||this.isLast&&!this.isFirst&&!p(e.showLastLabel,1)?v=!1:g&&!d.isRadial&&!k.step&&!k.rotation&&!b&&c!==0&&this.handleOverflow(t),w&&a%w&&(v=!1),v&&I(t.y)?(t.opacity=c,i[this.isNew?\"attr\":\"animate\"](t)):(Ka(i),i.attr(\"y\",-9999)),this.isNew=!1},destroy:function(){Ua(this,this.axis)}};u.PlotLineOrBand=function(a,b){this.axis=a;if(b)this.options=b,this.id=b.id};u.PlotLineOrBand.prototype=\n{render:function(){var a=this,b=a.axis,c=b.horiz,d=a.options,e=d.label,f=a.label,g=d.width,h=d.to,i=d.from,j=s(i)&&s(h),k=d.value,l=d.dashStyle,m=a.svgElem,n=[],o,A=d.color,r=p(d.zIndex,0),q=d.events,w={},v=b.chart.renderer,n=b.log2lin;b.isLog&&(i=n(i),h=n(h),k=n(k));if(g){if(n=b.getPlotLinePath(k,g),w={stroke:A,\"stroke-width\":g},l)w.dashstyle=l}else if(j){n=b.getPlotBandPath(i,h,d);if(A)w.fill=A;if(d.borderWidth)w.stroke=d.borderColor,w[\"stroke-width\"]=d.borderWidth}else return;w.zIndex=r;if(m)if(n)m.show(),\nm.animate({d:n});else{if(m.hide(),f)a.label=f=f.destroy()}else if(n&&n.length&&(a.svgElem=m=v.path(n).attr(w).add(),q))for(o in d=function(b){m.on(b,function(c){q[b].apply(a,[c])})},q)d(o);e&&s(e.text)&&n&&n.length&&b.width>0&&b.height>0&&!n.flat?(e=E({align:c&&j&&\"center\",x:c?!j&&4:10,verticalAlign:!c&&j&&\"middle\",y:c?j?16:10:j?6:-4,rotation:c&&!j&&90},e),this.renderLabel(e,n,j,r)):f&&f.hide();return a},renderLabel:function(a,b,c,d){var e=this.label,f=this.axis.chart.renderer;if(!e)e={align:a.textAlign||\na.align,rotation:a.rotation},e.zIndex=d,this.label=e=f.text(a.text,0,0,a.useHTML).attr(e).css(a.style).add();d=[b[1],b[4],c?b[6]:b[1]];b=[b[2],b[5],c?b[7]:b[2]];c=Oa(d);f=Oa(b);e.align(a,!1,{x:c,y:f,width:Ha(d)-c,height:Ha(b)-f});e.show()},destroy:function(){ra(this.axis.plotLinesAndBands,this);delete this.axis;Ua(this)}};var ia=u.Axis=function(){this.init.apply(this,arguments)};ia.prototype={defaultOptions:{dateTimeLabelFormats:{millisecond:\"%H:%M:%S.%L\",second:\"%H:%M:%S\",minute:\"%H:%M\",hour:\"%H:%M\",\nday:\"%e. %b\",week:\"%e. %b\",month:\"%b '%y\",year:\"%Y\"},endOnTick:!1,gridLineColor:\"#D8D8D8\",labels:{enabled:!0,style:{color:\"#606060\",cursor:\"default\",fontSize:\"11px\"},x:0},lineColor:\"#C0D0E0\",lineWidth:1,minPadding:0.01,maxPadding:0.01,minorGridLineColor:\"#E0E0E0\",minorGridLineWidth:1,minorTickColor:\"#A0A0A0\",minorTickLength:2,minorTickPosition:\"outside\",startOfWeek:1,startOnTick:!1,tickColor:\"#C0D0E0\",tickLength:10,tickmarkPlacement:\"between\",tickPixelInterval:100,tickPosition:\"outside\",title:{align:\"middle\",\nstyle:{color:\"#707070\"}},type:\"linear\"},defaultYAxisOptions:{endOnTick:!0,gridLineWidth:1,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},lineWidth:0,maxPadding:0.05,minPadding:0.05,startOnTick:!0,title:{rotation:270,text:\"Values\"},stackLabels:{enabled:!1,formatter:function(){return u.numberFormat(this.total,-1)},style:E(ga.line.dataLabels.style,{color:\"#000000\"})}},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],\nx:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,b){var c=b.isX;this.chart=a;this.horiz=a.inverted?!c:c;this.isXAxis=c;this.coll=this.coll||(c?\"xAxis\":\"yAxis\");this.opposite=b.opposite;this.side=b.side||(this.horiz?this.opposite?0:2:this.opposite?1:3);this.setOptions(b);var d=this.options,e=d.type;this.labelFormatter=d.labels.formatter||this.defaultLabelFormatter;this.userOptions=b;this.minPixelPadding=0;this.reversed=d.reversed;this.visible=\nd.visible!==!1;this.zoomEnabled=d.zoomEnabled!==!1;this.hasNames=e===\"category\"||d.categories===!0;this.categories=d.categories||this.hasNames;this.names=this.names||[];this.isLog=e===\"logarithmic\";this.isDatetimeAxis=e===\"datetime\";this.isLinked=s(d.linkedTo);this.ticks={};this.labelEdge=[];this.minorTicks={};this.plotLinesAndBands=[];this.alternateBands={};this.len=0;this.minRange=this.userMinRange=d.minRange||d.maxZoom;this.range=d.range;this.offset=d.offset||0;this.stacks={};this.oldStacks={};\nthis.stacksTouched=0;this.min=this.max=null;this.crosshair=p(d.crosshair,ua(a.options.tooltip.crosshairs)[c?0:1],!1);var f,d=this.options.events;pa(this,a.axes)===-1&&(c?a.axes.splice(a.xAxis.length,0,this):a.axes.push(this),a[this.coll].push(this));this.series=this.series||[];if(a.inverted&&c&&this.reversed===z)this.reversed=!0;this.removePlotLine=this.removePlotBand=this.removePlotBandOrLine;for(f in d)N(this,f,d[f]);if(this.isLog)this.val2lin=this.log2lin,this.lin2val=this.lin2log},setOptions:function(a){this.options=\nE(this.defaultOptions,this.coll===\"yAxis\"&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],E(T[this.coll],a))},defaultLabelFormatter:function(){var a=this.axis,b=this.value,c=a.categories,d=this.dateTimeLabelFormat,e=T.lang.numericSymbols,f=e&&e.length,g,h=a.options.labels.format,a=a.isLog?b:a.tickInterval;if(h)g=Na(h,this);else if(c)g=b;else if(d)g=Ta(d,b);else if(f&&a>=1E3)for(;f--&&g===z;)c=\nMath.pow(1E3,f+1),a>=c&&b*10%c===0&&e[f]!==null&&b!==0&&(g=u.numberFormat(b/c,-1)+e[f]);g===z&&(g=Q(b)>=1E4?u.numberFormat(b,-1):u.numberFormat(b,-1,z,\"\"));return g},getSeriesExtremes:function(){var a=this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();q(a.series,function(c){if(c.visible||!b.options.chart.ignoreHiddenSeries){var d=c.options,e=d.threshold,f;a.hasVisibleSeries=!0;a.isLog&&e<=0&&(e=null);if(a.isXAxis){if(d=\nc.xData,d.length)c=Oa(d),!I(c)&&!(c instanceof ma)&&(d=Da(d,function(a){return I(a)}),c=Oa(d)),a.dataMin=F(p(a.dataMin,d[0]),c),a.dataMax=t(p(a.dataMax,d[0]),Ha(d))}else{c.getExtremes();f=c.dataMax;c=c.dataMin;if(s(c)&&s(f))a.dataMin=F(p(a.dataMin,c),c),a.dataMax=t(p(a.dataMax,f),f);if(s(e))a.threshold=e;if(!d.softThreshold||a.isLog)a.softThreshold=!1}}})},translate:function(a,b,c,d,e,f){var g=this.linkedParent||this,h=1,i=0,j=d?g.oldTransA:g.transA,d=d?g.oldMin:g.min,k=g.minPixelPadding,e=(g.isOrdinal||\ng.isBroken||g.isLog&&e)&&g.lin2val;if(!j)j=g.transA;if(c)h*=-1,i=g.len;g.reversed&&(h*=-1,i-=h*(g.sector||g.len));b?(a=a*h+i,a-=k,a=a/j+d,e&&(a=g.lin2val(a))):(e&&(a=g.val2lin(a)),f===\"between\"&&(f=0.5),a=h*(a-d)*j+i+h*k+(I(f)?j*f*g.pointRange:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,d,e){var f=this.chart,g=this.left,h=this.top,\ni,j,k=c&&f.oldChartHeight||f.chartHeight,l=c&&f.oldChartWidth||f.chartWidth,m;i=this.transB;var n=function(a,b,c){if(a<b||a>c)d?a=F(t(b,a),c):m=!0;return a},e=p(e,this.translate(a,null,null,c)),a=c=C(e+i);i=j=C(k-e-i);I(e)?this.horiz?(i=h,j=k-this.bottom,a=c=n(a,g,g+this.width)):(a=g,c=l-this.right,i=j=n(i,h,h+this.height)):m=!0;return m&&!d?null:f.renderer.crispLine([X,a,i,S,c,j],b||1)},getLinearTickPositions:function(a,b,c){var d,e=$(V(b/a)*a),f=$(va(c/a)*a),g=[];if(b===c&&I(b))return[b];for(b=\ne;b<=f;){g.push(b);b=$(b+a);if(b===d)break;d=b}return g},getMinorTickPositions:function(){var a=this.options,b=this.tickPositions,c=this.minorTickInterval,d=[],e,f=this.pointRangePadding||0;e=this.min-f;var f=this.max+f,g=f-e;if(g&&g/c<this.len/3)if(this.isLog){f=b.length;for(e=1;e<f;e++)d=d.concat(this.getLogTickPositions(c,b[e-1],b[e],!0))}else if(this.isDatetimeAxis&&a.minorTickInterval===\"auto\")d=d.concat(this.getTimeTicks(this.normalizeTimeTickInterval(c),e,f,a.startOfWeek));else for(b=e+(b[0]-\ne)%c;b<=f;b+=c)d.push(b);d.length!==0&&this.trimTicks(d,a.startOnTick,a.endOnTick);return d},adjustForMinRange:function(){var a=this.options,b=this.min,c=this.max,d,e=this.dataMax-this.dataMin>=this.minRange,f,g,h,i,j,k;if(this.isXAxis&&this.minRange===z&&!this.isLog)s(a.min)||s(a.max)?this.minRange=null:(q(this.series,function(a){i=a.xData;for(g=j=a.xIncrement?1:i.length-1;g>0;g--)if(h=i[g]-i[g-1],f===z||h<f)f=h}),this.minRange=F(f*5,this.dataMax-this.dataMin));if(c-b<this.minRange)k=this.minRange,\nd=(k-c+b)/2,d=[b-d,p(a.min,b-d)],e&&(d[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=Ha(d),c=[b+k,p(a.max,b+k)],e&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),c=Oa(c),c-b<k&&(d[0]=c-k,d[1]=p(a.min,c-k),b=Ha(d));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:q(this.series,function(b){var c=b.closestPointRange;!b.noSharedTooltip&&s(c)&&(a=s(a)?F(a,c):c)});return a},nameToX:function(a){var b=za(this.categories),c=b?this.categories:this.names,d=a.options.x,\ne;a.series.requireSorting=!1;s(d)||(d=this.options.nameToX===!1?a.series.autoIncrement():pa(a.name,c));if(d===-1){if(!b)e=c.length}else e=d;this.names[e]=a.name;return e},updateNames:function(){var a=this;if(this.names.length>0)this.names.length=0,this.minRange=void 0,q(this.series||[],function(b){b.processedXData||(b.processData(),b.generatePoints());q(b.points,function(c,d){var e;if(c.options&&c.options.x===void 0&&(e=a.nameToX(c),e!==c.x))c.x=e,b.xData[d]=e})})},setAxisTranslation:function(a){var b=\nthis,c=b.max-b.min,d=b.axisPointRange||0,e,f=0,g=0,h=b.linkedParent,i=!!b.categories,j=b.transA,k=b.isXAxis;if(k||i||d)if(h?(f=h.minPointOffset,g=h.pointRangePadding):(e=b.getClosest(),q(b.series,function(a){var c=i?1:k?p(a.options.pointRange,e,0):b.axisPointRange||0,a=a.options.pointPlacement;d=t(d,c);b.single||(f=t(f,ya(a)?0:c/2),g=t(g,a===\"on\"?0:c))})),h=b.ordinalSlope&&e?b.ordinalSlope/e:1,b.minPointOffset=f*=h,b.pointRangePadding=g*=h,b.pointRange=F(d,c),k)b.closestPointRange=e;if(a)b.oldTransA=\nj;b.translationSlope=b.transA=j=b.len/(c+g||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=j*f},minFromRange:function(){return this.max-this.range},setTickInterval:function(a){var b=this,c=b.chart,d=b.options,e=b.isLog,f=b.log2lin,g=b.isDatetimeAxis,h=b.isXAxis,i=b.isLinked,j=d.maxPadding,k=d.minPadding,l=d.tickInterval,m=d.tickPixelInterval,n=b.categories,o=b.threshold,A=b.softThreshold,r,K,w,v;!g&&!n&&!i&&this.getTickAmount();w=p(b.userMin,d.min);v=p(b.userMax,d.max);i?(b.linkedParent=c[b.coll][d.linkedTo],\nc=b.linkedParent.getExtremes(),b.min=p(c.min,c.dataMin),b.max=p(c.max,c.dataMax),d.type!==b.linkedParent.options.type&&ea(11,1)):(!A&&s(o)&&(b.dataMin>=o?(r=o,k=0):b.dataMax<=o&&(K=o,j=0)),b.min=p(w,r,b.dataMin),b.max=p(v,K,b.dataMax));if(e)!a&&F(b.min,p(b.dataMin,b.min))<=0&&ea(10,1),b.min=$(f(b.min),15),b.max=$(f(b.max),15);if(b.range&&s(b.max))b.userMin=b.min=w=t(b.min,b.minFromRange()),b.userMax=v=b.max,b.range=null;H(b,\"foundExtremes\");b.beforePadding&&b.beforePadding();b.adjustForMinRange();\nif(!n&&!b.axisPointRange&&!b.usePercentage&&!i&&s(b.min)&&s(b.max)&&(f=b.max-b.min))!s(w)&&k&&(b.min-=f*k),!s(v)&&j&&(b.max+=f*j);if(I(d.floor))b.min=t(b.min,d.floor);if(I(d.ceiling))b.max=F(b.max,d.ceiling);if(A&&s(b.dataMin))if(o=o||0,!s(w)&&b.min<o&&b.dataMin>=o)b.min=o;else if(!s(v)&&b.max>o&&b.dataMax<=o)b.max=o;b.tickInterval=b.min===b.max||b.min===void 0||b.max===void 0?1:i&&!l&&m===b.linkedParent.options.tickPixelInterval?l=b.linkedParent.tickInterval:p(l,this.tickAmount?(b.max-b.min)/t(this.tickAmount-\n1,1):void 0,n?1:(b.max-b.min)*m/t(b.len,m));h&&!a&&q(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();if(b.postProcessTickInterval)b.tickInterval=b.postProcessTickInterval(b.tickInterval);if(b.pointRange&&!l)b.tickInterval=t(b.pointRange,b.tickInterval);a=p(d.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);if(!l&&b.tickInterval<a)b.tickInterval=a;if(!g&&!e&&!l)b.tickInterval=wb(b.tickInterval,\nnull,vb(b.tickInterval),p(d.allowDecimals,!(b.tickInterval>0.5&&b.tickInterval<5&&b.max>1E3&&b.max<9999)),!!this.tickAmount);if(!this.tickAmount)b.tickInterval=b.unsquish();this.setTickPositions()},setTickPositions:function(){var a=this.options,b,c=a.tickPositions,d=a.tickPositioner,e=a.startOnTick,f=a.endOnTick,g;this.tickmarkOffset=this.categories&&a.tickmarkPlacement===\"between\"&&this.tickInterval===1?0.5:0;this.minorTickInterval=a.minorTickInterval===\"auto\"&&this.tickInterval?this.tickInterval/\n5:a.minorTickInterval;this.tickPositions=b=c&&c.slice();if(!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,d&&(d=d.apply(this,[this.min,this.max]))))this.tickPositions=\nb=d;if(!this.isLinked)this.trimTicks(b,e,f),this.min===this.max&&s(this.min)&&!this.tickAmount&&(g=!0,this.min-=0.5,this.max+=0.5),this.single=g,!c&&!d&&this.adjustTickAmount()},trimTicks:function(a,b,c){var d=a[0],e=a[a.length-1],f=this.minPointOffset||0;if(b)this.min=d;else for(;this.min-f>a[0];)a.shift();if(c)this.max=e;else for(;this.max+f<a[a.length-1];)a.pop();a.length===0&&s(d)&&a.push((e+d)/2)},alignToOthers:function(){var a={},b,c=this.options;this.chart.options.chart.alignTicks!==!1&&c.alignTicks!==\n!1&&q(this.chart[this.coll],function(c){var e=c.options,e=[c.horiz?e.left:e.top,e.width,e.height,e.pane].join(\",\");c.series.length&&(a[e]?b=!0:a[e]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=a.tickPixelInterval;!s(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=va(this.len/c)+1);if(b<4)this.finalTickAmt=b,b=5;this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,\nc=this.tickAmount,d=this.finalTickAmt,e=b&&b.length;if(e<c){for(;b.length<c;)b.push($(b[b.length-1]+a));this.transA*=(e-1)/(c-1);this.max=b[b.length-1]}else e>c&&(this.tickInterval*=2,this.setTickPositions());if(s(d)){for(a=c=b.length;a--;)(d===3&&a%2===1||d<=2&&a>0&&a<c-1)&&b.splice(a,1);this.finalTickAmt=z}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;q(this.series,function(b){if(b.isDirtyData||\nb.isDirty||b.xAxis.isDirty)a=!0});if(b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()){if(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,!this.isDirty)this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax}else this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,c,d,e){var f=this,g=f.chart,\nc=p(c,!0);q(f.series,function(a){delete a.kdTree});e=x(e,{min:a,max:b});H(f,\"setExtremes\",e,function(){f.userMin=a;f.userMax=b;f.eventArgs=e;c&&g.redraw(d)})},zoom:function(a,b){var c=this.dataMin,d=this.dataMax,e=this.options,f=F(c,p(e.min,c)),e=t(d,p(e.max,d));this.allowZoomOutside||(s(c)&&a<=f&&(a=f),s(d)&&b>=e&&(b=e));this.displayBtn=a!==z||b!==z;this.setExtremes(a,b,!1,z,{trigger:\"zoom\"});return!0},setAxisSize:function(){var a=this.chart,b=this.options,c=b.offsetLeft||0,d=this.horiz,e=p(b.width,\na.plotWidth-c+(b.offsetRight||0)),f=p(b.height,a.plotHeight),g=p(b.top,a.plotTop),b=p(b.left,a.plotLeft+c),c=/%$/;c.test(f)&&(f=Math.round(parseFloat(f)/100*a.plotHeight));c.test(g)&&(g=Math.round(parseFloat(g)/100*a.plotHeight+a.plotTop));this.left=b;this.top=g;this.width=e;this.height=f;this.bottom=a.chartHeight-f-g;this.right=a.chartWidth-e-b;this.len=t(d?e:f,0);this.pos=d?b:g},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?$(b(this.min)):this.min,max:a?$(b(this.max)):this.max,\ndataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,c=this.lin2log,d=b?c(this.min):this.min,b=b?c(this.max):this.max;a===null?a=d:d>a?a=d:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(p(a,0)-this.side*90+720)%360;return a>15&&a<165?\"right\":a>195&&a<345?\"left\":\"center\"},tickSize:function(a){var b=this.options,c=b[a+\"Length\"],d=p(b[a+\"Width\"],a===\"tick\"&&this.isXAxis?1:0);if(d&&c)return b[a+\"Position\"]===\n\"inside\"&&(c=-c),[c,d]},labelMetrics:function(){return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize,this.ticks[0]&&this.ticks[0].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,c=this.tickInterval,d=c,e=this.len/(((this.categories?1:0)+this.max-this.min)/c),f,g=a.rotation,h=this.labelMetrics(),i,j=Number.MAX_VALUE,k,l=function(a){a/=e||1;a=a>1?va(a):1;return a*c};b?(k=!a.staggerLines&&!a.step&&(s(g)?[g]:e<p(a.autoRotationLimit,80)&&a.autoRotation))&&q(k,function(a){var b;\nif(a===g||a&&a>=-90&&a<=90)i=l(Q(h.h/da(ka*a))),b=i+Q(a/360),b<j&&(j=b,f=a,d=i)}):a.step||(d=l(h.h));this.autoRotation=k;this.labelRotation=p(f,g);return d},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,d=Math.max(this.tickPositions.length-(this.categories?0:1),1),e=a.margin[3];return b&&(c.step||0)<2&&!c.rotation&&(this.staggerLines||1)*a.plotWidth/d||!b&&(e&&e-a.spacing[3]||a.chartWidth*0.33)},renderUnsquish:function(){var a=this.chart,b=a.renderer,c=this.tickPositions,\nd=this.ticks,e=this.options.labels,f=this.horiz,g=this.getSlotWidth(),h=t(1,C(g-2*(e.padding||5))),i={},j=this.labelMetrics(),k=e.style.textOverflow,l,m=0,n,o;if(!ya(e.rotation))i.rotation=e.rotation||0;q(c,function(a){if((a=d[a])&&a.labelLength>m)m=a.labelLength});this.maxLabelLength=m;if(this.autoRotation)m>h&&m>j.h?i.rotation=this.labelRotation:this.labelRotation=0;else if(g&&(l={width:h+\"px\"},!k)){l.textOverflow=\"clip\";for(n=c.length;!f&&n--;)if(o=c[n],h=d[o].label)if(h.styles.textOverflow===\n\"ellipsis\"?h.css({textOverflow:\"clip\"}):d[o].labelLength>g&&h.css({width:g+\"px\"}),h.getBBox().height>this.len/c.length-(j.h-j.f))h.specCss={textOverflow:\"ellipsis\"}}if(i.rotation&&(l={width:(m>a.chartHeight*0.5?a.chartHeight*0.33:a.chartHeight)+\"px\"},!k))l.textOverflow=\"ellipsis\";if(this.labelAlign=e.align||this.autoLabelAlign(this.labelRotation))i.align=this.labelAlign;q(c,function(a){var b=(a=d[a])&&a.label;if(b)b.attr(i),l&&b.css(E(l,b.specCss)),delete b.specCss,a.rotation=i.rotation});this.tickRotCorr=\nb.rotCorr(j.b,this.labelRotation||0,this.side!==0)},hasData:function(){return this.hasVisibleSeries||s(this.min)&&s(this.max)&&!!this.tickPositions},getOffset:function(){var a=this,b=a.chart,c=b.renderer,d=a.options,e=a.tickPositions,f=a.ticks,g=a.horiz,h=a.side,i=b.inverted?[1,0,3,2][h]:h,j,k,l=0,m,n=0,o=d.title,A=d.labels,r=0,K=a.opposite,w=b.axisOffset,b=b.clipOffset,v=[-1,1,1,-1][h],x,u=a.axisParent,aa=this.tickSize(\"tick\");j=a.hasData();a.showAxis=k=j||p(d.showEmpty,!0);a.staggerLines=a.horiz&&\nA.staggerLines;if(!a.axisGroup)a.gridGroup=c.g(\"grid\").attr({zIndex:d.gridZIndex||1}).add(u),a.axisGroup=c.g(\"axis\").attr({zIndex:d.zIndex||2}).add(u),a.labelGroup=c.g(\"axis-labels\").attr({zIndex:A.zIndex||7}).addClass(\"highcharts-\"+a.coll.toLowerCase()+\"-labels\").add(u);if(j||a.isLinked){if(q(e,function(b){f[b]?f[b].addLabel():f[b]=new Ya(a,b)}),a.renderUnsquish(),A.reserveSpace!==!1&&(h===0||h===2||{1:\"left\",3:\"right\"}[h]===a.labelAlign||a.labelAlign===\"center\")&&q(e,function(a){r=t(f[a].getLabelSize(),\nr)}),a.staggerLines)r*=a.staggerLines,a.labelOffset=r*(a.opposite?-1:1)}else for(x in f)f[x].destroy(),delete f[x];if(o&&o.text&&o.enabled!==!1){if(!a.axisTitle)(x=o.textAlign)||(x=(g?{low:\"left\",middle:\"center\",high:\"right\"}:{low:K?\"right\":\"left\",middle:\"center\",high:K?\"left\":\"right\"})[o.align]),a.axisTitle=c.text(o.text,0,0,o.useHTML).attr({zIndex:7,rotation:o.rotation||0,align:x}).addClass(\"highcharts-\"+this.coll.toLowerCase()+\"-title\").css(o.style).add(a.axisGroup),a.axisTitle.isNew=!0;if(k)l=\na.axisTitle.getBBox()[g?\"height\":\"width\"],m=o.offset,n=s(m)?0:p(o.margin,g?5:10);a.axisTitle[k?\"show\":\"hide\"](!0)}a.offset=v*p(d.offset,w[h]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};c=h===0?-a.labelMetrics().h:h===2?a.tickRotCorr.y:0;n=Math.abs(r)+n;r&&(n-=c,n+=v*(g?p(A.y,a.tickRotCorr.y+v*8):A.x));a.axisTitleMargin=p(m,n);w[h]=t(w[h],a.axisTitleMargin+l+v*a.offset,n,j&&e.length&&aa?aa[0]:0);d=d.offset?0:V(d.lineWidth/2)*2;b[i]=t(b[i],d)},getLinePath:function(a){var b=this.chart,c=this.opposite,d=\nthis.offset,e=this.horiz,f=this.left+(c?this.width:0)+d,d=b.chartHeight-this.bottom-(c?this.height:0)+d;c&&(a*=-1);return b.renderer.crispLine([X,e?this.left:f,e?d:this.top,S,e?b.chartWidth-this.right:f,e?d:b.chartHeight-this.bottom],a)},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,d=this.len,e=this.options.title,f=a?b:c,g=this.opposite,h=this.offset,i=e.x||0,j=e.y||0,k=this.chart.renderer.fontMetrics(e.style.fontSize).f,d={low:f+(a?0:d),middle:f+d/2,high:f+(a?d:0)}[e.align],\nb=(a?c+this.height:b)+(a?1:-1)*(g?-1:1)*this.axisTitleMargin+(this.side===2?k:0);return{x:a?d+i:b+(g?this.width:0)+h+i,y:a?b+j-(g?this.height:0)+h:d+j}},render:function(){var a=this,b=a.chart,c=b.renderer,d=a.options,e=a.isLog,f=a.lin2log,g=a.isLinked,h=a.tickPositions,i=a.axisTitle,j=a.ticks,k=a.minorTicks,l=a.alternateBands,m=d.stackLabels,n=d.alternateGridColor,o=a.tickmarkOffset,A=d.lineWidth,r,p=b.hasRendered&&I(a.oldMin),w=a.showAxis,v=Wa(c.globalAnimation),s,t;a.labelEdge.length=0;a.overlap=\n!1;q([j,k,l],function(a){for(var b in a)a[b].isActive=!1});if(a.hasData()||g){a.minorTickInterval&&!a.categories&&q(a.getMinorTickPositions(),function(b){k[b]||(k[b]=new Ya(a,b,\"minor\"));p&&k[b].isNew&&k[b].render(null,!0);k[b].render(null,!1,1)});if(h.length&&(q(h,function(b,c){if(!g||b>=a.min&&b<=a.max)j[b]||(j[b]=new Ya(a,b)),p&&j[b].isNew&&j[b].render(c,!0,0.1),j[b].render(c)}),o&&(a.min===0||a.single)))j[-1]||(j[-1]=new Ya(a,-1,null,!0)),j[-1].render(-1);n&&q(h,function(c,d){t=h[d+1]!==z?h[d+\n1]+o:a.max-o;if(d%2===0&&c<a.max&&t<=a.max+(b.polar?-o:o))l[c]||(l[c]=new u.PlotLineOrBand(a)),s=c+o,l[c].options={from:e?f(s):s,to:e?f(t):t,color:n},l[c].render(),l[c].isActive=!0});if(!a._addedPlotLB)q((d.plotLines||[]).concat(d.plotBands||[]),function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=!0}q([j,k,l],function(a){var c,d,e=[],f=v.duration;for(c in a)if(!a[c].isActive)a[c].render(c,!1,0),a[c].isActive=!1,e.push(c);Sa(function(){for(d=e.length;d--;)a[e[d]]&&!a[e[d]].isActive&&(a[e[d]].destroy(),\ndelete a[e[d]])},a===l||!b.hasRendered||!f?0:f)});if(A)r=a.getLinePath(A),a.axisLine?a.axisLine.animate({d:r}):a.axisLine=c.path(r).attr({stroke:d.lineColor,\"stroke-width\":A,zIndex:7}).add(a.axisGroup),a.axisLine[w?\"show\":\"hide\"](!0);if(i&&w)i[i.isNew?\"attr\":\"animate\"](a.getTitlePosition()),i.isNew=!1;m&&m.enabled&&a.renderStackTotals();a.isDirty=!1},redraw:function(){this.visible&&(this.render(),q(this.plotLinesAndBands,function(a){a.render()}));q(this.series,function(a){a.isDirty=!0})},destroy:function(a){var b=\nthis,c=b.stacks,d,e=b.plotLinesAndBands;a||Y(b);for(d in c)Ua(c[d]),c[d]=null;q([b.ticks,b.minorTicks,b.alternateBands],function(a){Ua(a)});for(a=e.length;a--;)e[a].destroy();q(\"stackTotalGroup,axisLine,axisTitle,axisGroup,gridGroup,labelGroup,cross\".split(\",\"),function(a){b[a]&&(b[a]=b[a].destroy())});this._addedPlotLB=this.chart._labelPanes=this.ordinalSlope=void 0},drawCrosshair:function(a,b){var c,d=this.crosshair,e,f;a||(a=this.cross&&this.cross.e);if(!this.crosshair||(s(b)||!p(d.snap,!0))===\n!1)this.hideCrosshair();else if(p(d.snap,!0)?s(b)&&(c=this.isXAxis?b.plotX:this.len-b.plotY):c=this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos,c=this.isRadial?this.getPlotLinePath(this.isXAxis?b.x:p(b.stackY,b.y))||null:this.getPlotLinePath(null,null,null,null,c)||null,c===null)this.hideCrosshair();else{e=this.categories&&!this.isRadial;f=p(d.width,e?this.transA:1);if(this.cross)this.cross.attr({d:c,visibility:\"visible\",\"stroke-width\":f});else{e={\"pointer-events\":\"none\",\"stroke-width\":f,stroke:d.color||\n(e?\"rgba(155,200,255,0.2)\":\"#C0C0C0\"),zIndex:p(d.zIndex,2)};if(d.dashStyle)e.dashstyle=d.dashStyle;this.cross=this.chart.renderer.path(c).attr(e).add()}this.cross.e=a}},hideCrosshair:function(){this.cross&&this.cross.hide()}};x(ia.prototype,{getPlotBandPath:function(a,b){var c=this.getPlotLinePath(b,null,null,!0),d=this.getPlotLinePath(a,null,null,!0);d&&c?(d.flat=d.toString()===c.toString(),d.push(c[4],c[5],c[1],c[2])):d=null;return d},addPlotBand:function(a){return this.addPlotBandOrLine(a,\"plotBands\")},\naddPlotLine:function(a){return this.addPlotBandOrLine(a,\"plotLines\")},addPlotBandOrLine:function(a,b){var c=(new u.PlotLineOrBand(this,a)).render(),d=this.userOptions;c&&(b&&(d[b]=d[b]||[],d[b].push(a)),this.plotLinesAndBands.push(c));return c},removePlotBandOrLine:function(a){for(var b=this.plotLinesAndBands,c=this.options,d=this.userOptions,e=b.length;e--;)b[e].id===a&&b[e].destroy();q([c.plotLines||[],d.plotLines||[],c.plotBands||[],d.plotBands||[]],function(b){for(e=b.length;e--;)b[e].id===a&&\nra(b,b[e])})}});ia.prototype.getTimeTicks=function(a,b,c,d){var e=[],f={},g=T.global.useUTC,h,i=new ma(b-ab(b)),j=a.unitRange,k=a.count;if(s(b)){i[Ib](j>=G.second?0:k*V(i.getMilliseconds()/k));if(j>=G.second)i[Jb](j>=G.minute?0:k*V(i.getSeconds()/k));if(j>=G.minute)i[Kb](j>=G.hour?0:k*V(i[xb]()/k));if(j>=G.hour)i[Lb](j>=G.day?0:k*V(i[yb]()/k));if(j>=G.day)i[nb](j>=G.month?1:k*V(i[Xa]()/k));j>=G.month&&(i[Ab](j>=G.year?0:k*V(i[db]()/k)),h=i[eb]());j>=G.year&&(h-=h%k,i[Bb](h));if(j===G.week)i[nb](i[Xa]()-\ni[zb]()+p(d,1));b=1;if(ub||bb)i=i.getTime(),i=new ma(i+ab(i));h=i[eb]();for(var d=i.getTime(),l=i[db](),m=i[Xa](),n=!g||!!bb,o=(G.day+(g?ab(i):i.getTimezoneOffset()*6E4))%G.day;d<c;)e.push(d),j===G.year?d=mb(h+b*k,0):j===G.month?d=mb(h,l+b*k):n&&(j===G.day||j===G.week)?d=mb(h,l,m+b*k*(j===G.day?1:7)):d+=j*k,b++;e.push(d);q(Da(e,function(a){return j<=G.hour&&a%G.day===o}),function(a){f[a]=\"day\"})}e.info=x(a,{higherRanks:f,totalRange:j*k});return e};ia.prototype.normalizeTimeTickInterval=function(a,\nb){var c=b||[[\"millisecond\",[1,2,5,10,20,25,50,100,200,500]],[\"second\",[1,2,5,10,15,30]],[\"minute\",[1,2,5,10,15,30]],[\"hour\",[1,2,3,4,6,8,12]],[\"day\",[1,2]],[\"week\",[1,2]],[\"month\",[1,2,3,4,6]],[\"year\",null]],d=c[c.length-1],e=G[d[0]],f=d[1],g;for(g=0;g<c.length;g++)if(d=c[g],e=G[d[0]],f=d[1],c[g+1]&&a<=(e*f[f.length-1]+G[c[g+1][0]])/2)break;e===G.year&&a<5*e&&(f=[1,2,5]);c=wb(a/e,f,d[0]===\"year\"?t(vb(a/e),1):1);return{unitRange:e,count:c,unitName:d[0]}};ia.prototype.getLogTickPositions=function(a,\nb,c,d){var e=this.options,f=this.len,g=this.lin2log,h=this.log2lin,i=[];if(!d)this._minorAutoInterval=null;if(a>=0.5)a=C(a),i=this.getLinearTickPositions(a,b,c);else if(a>=0.08)for(var f=V(b),j,k,l,m,n,e=a>0.3?[1,2,4]:a>0.15?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];f<c+1&&!n;f++){k=e.length;for(j=0;j<k&&!n;j++)l=h(g(f)*e[j]),l>b&&(!d||m<=c)&&m!==z&&i.push(m),m>c&&(n=!0),m=l}else if(b=g(b),c=g(c),a=e[d?\"minorTickInterval\":\"tickInterval\"],a=p(a===\"auto\"?null:a,this._minorAutoInterval,(c-b)*(e.tickPixelInterval/\n(d?5:1))/((d?f/this.tickPositions.length:f)||1)),a=wb(a,null,vb(a)),i=Ea(this.getLinearTickPositions(a,b,c),h),!d)this._minorAutoInterval=a/5;if(!d)this.tickInterval=a;return i};ia.prototype.log2lin=function(a){return Z.log(a)/Z.LN10};ia.prototype.lin2log=function(a){return Z.pow(10,a)};var Rb=u.Tooltip=function(){this.init.apply(this,arguments)};Rb.prototype={init:function(a,b){var c=b.borderWidth,d=b.style,e=B(d.padding);this.chart=a;this.options=b;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=\n!0;this.label=a.renderer.label(\"\",0,0,b.shape||\"callout\",null,null,b.useHTML,null,\"tooltip\").attr({padding:e,fill:b.backgroundColor,\"stroke-width\":c,r:b.borderRadius,zIndex:8,display:\"none\"}).css(d).css({padding:0}).add();la||this.label.shadow(b.shadow);this.shared=b.shared},destroy:function(){if(this.label)this.label=this.label.destroy();clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,b,c,d){var e=this,f=e.now,g=e.options.animation!==!1&&!e.isHidden&&(Q(a-f.x)>1||\nQ(b-f.y)>1),h=e.followPointer||e.len>1;x(f,{x:g?(2*f.x+a)/3:a,y:g?(f.y+b)/2:b,anchorX:h?z:g?(2*f.anchorX+c)/3:c,anchorY:h?z:g?(f.anchorY+d)/2:d});e.label.attr(f);if(g)clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(a,b,c,d)},32)},hide:function(a){var b=this;clearTimeout(this.hideTimer);a=p(a,this.options.hideDelay,500);if(!this.isHidden)this.hideTimer=Sa(function(){b.label[a?\"fadeOut\":\"hide\"]();b.isHidden=!0},a)},getAnchor:function(a,b){var c,d=this.chart,e=d.inverted,\nf=d.plotTop,g=d.plotLeft,h=0,i=0,j,k,a=ua(a);c=a[0].tooltipPos;this.followPointer&&b&&(b.chartX===z&&(b=d.pointer.normalize(b)),c=[b.chartX-d.plotLeft,b.chartY-f]);c||(q(a,function(a){j=a.series.yAxis;k=a.series.xAxis;h+=a.plotX+(!e&&k?k.left-g:0);i+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!e&&j?j.top-f:0)}),h/=a.length,i/=a.length,c=[e?d.plotWidth-i:h,this.shared&&!e&&a.length>1&&b?b.chartY-f:e?d.plotHeight-h:i]);return Ea(c,C)},getPosition:function(a,b,c){var d=this.chart,e=this.distance,\nf={},g=c.h||0,h,i=[\"y\",d.chartHeight,b,c.plotY+d.plotTop,d.plotTop,d.plotTop+d.plotHeight],j=[\"x\",d.chartWidth,a,c.plotX+d.plotLeft,d.plotLeft,d.plotLeft+d.plotWidth],k=!this.followPointer&&p(c.ttBelow,!d.inverted===!!c.negative),l=function(a,b,c,d,h,i){var j=c<d-e,m=d+e+c<b,l=d-e-c;d+=e;if(k&&m)f[a]=d;else if(!k&&j)f[a]=l;else if(j)f[a]=F(i-c,l-g<0?l:l-g);else if(m)f[a]=t(h,d+g+c>b?d:d+g);else return!1},m=function(a,b,c,d){var g;d<e||d>b-e?g=!1:f[a]=d<c/2?1:d>b-c/2?b-c-2:d-c/2;return g},n=function(a){var b=\ni;i=j;j=b;h=a},o=function(){l.apply(0,i)!==!1?m.apply(0,j)===!1&&!h&&(n(!0),o()):h?f.x=f.y=0:(n(!0),o())};(d.inverted||this.len>1)&&n();o();return f},defaultFormatter:function(a){var b=this.points||ua(this),c;c=[a.tooltipFooterHeaderFormatter(b[0])];c=c.concat(a.bodyFormatter(b));c.push(a.tooltipFooterHeaderFormatter(b[0],!0));return c.join(\"\")},refresh:function(a,b){var c=this.chart,d=this.label,e=this.options,f,g,h,i={},j,k=[];j=e.formatter||this.defaultFormatter;var i=c.hoverPoints,l,m=this.shared;\nclearTimeout(this.hideTimer);this.followPointer=ua(a)[0].series.tooltipOptions.followPointer;h=this.getAnchor(a,b);f=h[0];g=h[1];m&&(!a.series||!a.series.noSharedTooltip)?(c.hoverPoints=a,i&&q(i,function(a){a.setState()}),q(a,function(a){a.setState(\"hover\");k.push(a.getLabelConfig())}),i={x:a[0].category,y:a[0].y},i.points=k,this.len=k.length,a=a[0]):i=a.getLabelConfig();j=j.call(i,this);i=a.series;this.distance=p(i.tooltipOptions.distance,16);j===!1?this.hide():(this.isHidden&&(Ka(d),d.attr({opacity:1,\ndisplay:\"block\"}).show()),d.attr({text:j}),l=e.borderColor||a.color||i.color||\"#606060\",d.attr({stroke:l}),this.updatePosition({plotX:f,plotY:g,negative:a.negative,ttBelow:a.ttBelow,h:h[2]||0}),this.isHidden=!1);H(c,\"tooltipRefresh\",{text:j,x:f+c.plotLeft,y:g+c.plotTop,borderColor:l})},updatePosition:function(a){var b=this.chart,c=this.label,c=(this.options.positioner||this.getPosition).call(this,c.width,c.height,a);this.move(C(c.x),C(c.y||0),a.plotX+b.plotLeft,a.plotY+b.plotTop)},getXDateFormat:function(a,\nb,c){var d,b=b.dateTimeLabelFormats,e=c&&c.closestPointRange,f,g={millisecond:15,second:12,minute:9,hour:6,day:3},h,i=\"millisecond\";if(e){h=Ta(\"%m-%d %H:%M:%S.%L\",a.x);for(f in G){if(e===G.week&&+Ta(\"%w\",a.x)===c.options.startOfWeek&&h.substr(6)===\"00:00:00.000\"){f=\"week\";break}if(G[f]>e){f=i;break}if(g[f]&&h.substr(g[f])!==\"01-01 00:00:00.000\".substr(g[f]))break;f!==\"week\"&&(i=f)}f&&(d=b[f])}else d=b.day;return d||b.year},tooltipFooterHeaderFormatter:function(a,b){var c=b?\"footer\":\"header\",d=a.series,\ne=d.tooltipOptions,f=e.xDateFormat,g=d.xAxis,h=g&&g.options.type===\"datetime\"&&I(a.key),c=e[c+\"Format\"];h&&!f&&(f=this.getXDateFormat(a,e,g));h&&f&&(c=c.replace(\"{point.key}\",\"{point.key:\"+f+\"}\"));return Na(c,{point:a,series:d})},bodyFormatter:function(a){return Ea(a,function(a){var c=a.series.tooltipOptions;return(c.pointFormatter||a.point.tooltipFormatter).call(a.point,c.pointFormat)})}};var ja;gb=y&&y.documentElement.ontouchstart!==z;var $a=u.Pointer=function(a,b){this.init(a,b)};$a.prototype=\n{init:function(a,b){var c=b.chart,d=c.events,e=la?\"\":c.zoomType,c=a.inverted,f;this.options=b;this.chart=a;this.zoomX=f=/x/.test(e);this.zoomY=e=/y/.test(e);this.zoomHor=f&&!c||e&&c;this.zoomVert=e&&!c||f&&c;this.hasZoom=f||e;this.runChartClick=d&&!!d.click;this.pinchDown=[];this.lastValidTouch={};if(u.Tooltip&&b.tooltip.enabled)a.tooltip=new Rb(a,b.tooltip),this.followTouchMove=p(b.tooltip.followTouchMove,!0);this.setDOMEvents()},normalize:function(a,b){var c,d,a=a||D.event;if(!a.target)a.target=\na.srcElement;d=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;if(!b)this.chartPosition=b=Db(this.chart.container);d.pageX===z?(c=t(a.x,a.clientX-b.left),d=a.y):(c=d.pageX-b.left,d=d.pageY-b.top);return x(a,{chartX:C(c),chartY:C(d)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};q(this.chart.axes,function(c){b[c.isXAxis?\"xAxis\":\"yAxis\"].push({axis:c,value:c.toValue(a[c.horiz?\"chartX\":\"chartY\"])})});return b},runPointActions:function(a){var b=this.chart,c=b.series,d=b.tooltip,\ne=d?d.shared:!1,f=!0,g=b.hoverPoint,h=b.hoverSeries,i,j,k,l=[],m;if(!e&&!h)for(i=0;i<c.length;i++)if(c[i].directTouch||!c[i].options.stickyTracking)c=[];h&&(e?h.noSharedTooltip:h.directTouch)&&g?l=[g]:(!e&&h&&!h.options.stickyTracking&&(c=[h]),q(c,function(b){j=b.noSharedTooltip&&e;k=!e&&b.directTouch;b.visible&&!j&&!k&&p(b.options.enableMouseTracking,!0)&&(m=b.searchPoint(a,!j&&b.kdDimensions===1))&&m.series&&l.push(m)}),l.sort(function(a,b){var c=a.distX-b.distX,d=a.dist-b.dist,e=a.series.group.zIndex>\nb.series.group.zIndex?-1:1;return c!==0?c:d!==0?d:e}));if(e)for(i=l.length;i--;)(l[i].clientX!==l[0].clientX||l[i].series.noSharedTooltip)&&l.splice(i,1);if(l[0]&&(l[0]!==this.hoverPoint||d&&d.isHidden)){if(e&&!l[0].series.noSharedTooltip){for(i=0;i>=0;i--)l[i].onMouseOver(a,l[i]!==(h&&h.directTouch&&g||l[0]));if(h&&h.directTouch&&g&&g!==l[0])g.onMouseOver(a,!1);l.length&&d&&d.refresh(l.sort(function(a,b){return a.series.index-b.series.index}),a)}else if(d&&d.refresh(l[0],a),!h||!h.directTouch)l[0].onMouseOver(a);\nthis.prevKDPoint=l[0];f=!1}f&&(c=h&&h.tooltipOptions.followPointer,d&&c&&!d.isHidden&&(c=d.getAnchor([{}],a),d.updatePosition({plotX:c[0],plotY:c[1]})));if(!this._onDocumentMouseMove)this._onDocumentMouseMove=function(a){if(U[ja])U[ja].pointer.onDocumentMouseMove(a)},N(y,\"mousemove\",this._onDocumentMouseMove);q(e?l:[p(g,l[0])],function(c){q(b.axes,function(b){(!c||c.series&&c.series[b.coll]===b)&&b.drawCrosshair(a,c)})})},reset:function(a,b){var c=this.chart,d=c.hoverSeries,e=c.hoverPoint,f=c.hoverPoints,\ng=c.tooltip,h=g&&g.shared?f:e;a&&h&&q(ua(h),function(b){b.series.isCartesian&&b.plotX===void 0&&(a=!1)});if(a)g&&h&&(g.refresh(h),e&&(e.setState(e.state,!0),q(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();f&&q(f,function(a){a.setState()});if(d)d.onMouseOut();g&&g.hide(b);if(this._onDocumentMouseMove)Y(y,\"mousemove\",this._onDocumentMouseMove),this._onDocumentMouseMove=null;q(c.axes,function(a){a.hideCrosshair()});this.hoverX=this.prevKDPoint=c.hoverPoints=c.hoverPoint=\nnull}},scaleGroups:function(a,b){var c=this.chart,d;q(c.series,function(e){d=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&(e.group.attr(d),e.markerGroup&&(e.markerGroup.attr(d),e.markerGroup.clip(b?c.clipRect:null)),e.dataLabelsGroup&&e.dataLabelsGroup.attr(d))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,\nd=a.chartX,e=a.chartY,f=this.zoomHor,g=this.zoomVert,h=b.plotLeft,i=b.plotTop,j=b.plotWidth,k=b.plotHeight,l,m=this.selectionMarker,n=this.mouseDownX,o=this.mouseDownY,p=c.panKey&&a[c.panKey+\"Key\"];if(!m||!m.touch)if(d<h?d=h:d>h+j&&(d=h+j),e<i?e=i:e>i+k&&(e=i+k),this.hasDragged=Math.sqrt(Math.pow(n-d,2)+Math.pow(o-e,2)),this.hasDragged>10){l=b.isInsidePlot(n-h,o-i);if(b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&l&&!p&&!m)this.selectionMarker=m=b.renderer.rect(h,i,f?1:j,g?1:k,0).attr({fill:c.selectionMarkerFill||\n\"rgba(69,114,167,0.25)\",zIndex:7}).add();m&&f&&(d-=n,m.attr({width:Q(d),x:(d>0?0:d)+n}));m&&g&&(d=e-o,m.attr({height:Q(d),y:(d>0?0:d)+o}));l&&!m&&c.panning&&b.pan(a,c.panning)}},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,xAxis:[],yAxis:[]},f=this.selectionMarker,g=f.attr?f.attr(\"x\"):f.x,h=f.attr?f.attr(\"y\"):f.y,i=f.attr?f.attr(\"width\"):f.width,j=f.attr?f.attr(\"height\"):f.height,k;if(this.hasDragged||d)q(c.axes,function(c){if(c.zoomEnabled&&\ns(c.min)&&(d||b[{xAxis:\"zoomX\",yAxis:\"zoomY\"}[c.coll]])){var f=c.horiz,n=a.type===\"touchend\"?c.minPixelPadding:0,o=c.toValue((f?g:h)+n),f=c.toValue((f?g+i:h+j)-n);e[c.coll].push({axis:c,min:F(o,f),max:t(o,f)});k=!0}}),k&&H(c,\"selection\",e,function(a){c.zoom(x(a,d?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();d&&this.scaleGroups()}if(c)M(c.container,{cursor:c._cursor}),c.cancelClick=this.hasDragged>10,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[]},\nonContainerMouseDown:function(a){a=this.normalize(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(a){U[ja]&&U[ja].pointer.drop(a)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition,a=this.normalize(a,c);c&&!this.inClass(a.target,\"highcharts-tracker\")&&!b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)&&this.reset()},onContainerMouseLeave:function(a){var b=U[ja];if(b&&(a.relatedTarget||a.toElement))b.pointer.reset(),b.pointer.chartPosition=\nnull},onContainerMouseMove:function(a){var b=this.chart;if(!s(ja)||!U[ja]||!U[ja].mouseIsDown)ja=b.index;a=this.normalize(a);a.returnValue=!1;b.mouseIsDown===\"mousedown\"&&this.drag(a);(this.inClass(a.target,\"highcharts-tracker\")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop))&&!b.openMenu&&this.runPointActions(a)},inClass:function(a,b){for(var c;a;){if(c=O(a,\"class\")){if(c.indexOf(b)!==-1)return!0;if(c.indexOf(\"highcharts-container\")!==-1)return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=\nthis.chart.hoverSeries,a=a.relatedTarget||a.toElement;if(b&&a&&!b.options.stickyTracking&&!this.inClass(a,\"highcharts-tooltip\")&&!this.inClass(a,\"highcharts-series-\"+b.index))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,e=b.plotTop,a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,\"highcharts-tracker\")?(H(c.series,\"click\",x(a,{point:c})),b.hoverPoint&&c.firePointEvent(\"click\",a)):(x(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-\ne)&&H(b,\"click\",a)))},setDOMEvents:function(){var a=this,b=a.chart.container;b.onmousedown=function(b){a.onContainerMouseDown(b)};b.onmousemove=function(b){a.onContainerMouseMove(b)};b.onclick=function(b){a.onContainerClick(b)};N(b,\"mouseleave\",a.onContainerMouseLeave);hb===1&&N(y,\"mouseup\",a.onDocumentMouseUp);if(gb)b.ontouchstart=function(b){a.onContainerTouchStart(b)},b.ontouchmove=function(b){a.onContainerTouchMove(b)},hb===1&&N(y,\"touchend\",a.onDocumentTouchEnd)},destroy:function(){var a;Y(this.chart.container,\n\"mouseleave\",this.onContainerMouseLeave);hb||(Y(y,\"mouseup\",this.onDocumentMouseUp),Y(y,\"touchend\",this.onDocumentTouchEnd));clearInterval(this.tooltipTimeout);for(a in this)this[a]=null}};x(u.Pointer.prototype,{pinchTranslate:function(a,b,c,d,e,f){(this.zoomHor||this.pinchHor)&&this.pinchTranslateDirection(!0,a,b,c,d,e,f);(this.zoomVert||this.pinchVert)&&this.pinchTranslateDirection(!1,a,b,c,d,e,f)},pinchTranslateDirection:function(a,b,c,d,e,f,g,h){var i=this.chart,j=a?\"x\":\"y\",k=a?\"X\":\"Y\",l=\"chart\"+\nk,m=a?\"width\":\"height\",n=i[\"plot\"+(a?\"Left\":\"Top\")],o,p,r=h||1,q=i.inverted,w=i.bounds[a?\"h\":\"v\"],v=b.length===1,t=b[0][l],s=c[0][l],x=!v&&b[1][l],u=!v&&c[1][l],z,c=function(){!v&&Q(t-x)>20&&(r=h||Q(s-u)/Q(t-x));p=(n-s)/r+t;o=i[\"plot\"+(a?\"Width\":\"Height\")]/r};c();b=p;b<w.min?(b=w.min,z=!0):b+o>w.max&&(b=w.max-o,z=!0);z?(s-=0.8*(s-g[j][0]),v||(u-=0.8*(u-g[j][1])),c()):g[j]=[s,u];q||(f[j]=p-n,f[m]=o);f=q?1/r:r;e[m]=o;e[j]=b;d[q?a?\"scaleY\":\"scaleX\":\"scale\"+k]=r;d[\"translate\"+k]=f*n+(s-f*t)},pinch:function(a){var b=\nthis,c=b.chart,d=b.pinchDown,e=a.touches,f=e.length,g=b.lastValidTouch,h=b.hasZoom,i=b.selectionMarker,j={},k=f===1&&(b.inClass(a.target,\"highcharts-tracker\")&&c.runTrackerClick||b.runChartClick),l={};if(f>1)b.initiated=!0;h&&b.initiated&&!k&&a.preventDefault();Ea(e,function(a){return b.normalize(a)});if(a.type===\"touchstart\")q(e,function(a,b){d[b]={chartX:a.chartX,chartY:a.chartY}}),g.x=[d[0].chartX,d[1]&&d[1].chartX],g.y=[d[0].chartY,d[1]&&d[1].chartY],q(c.axes,function(a){if(a.zoomEnabled){var b=\nc.bounds[a.horiz?\"h\":\"v\"],d=a.minPixelPadding,e=a.toPixels(p(a.options.min,a.dataMin)),f=a.toPixels(p(a.options.max,a.dataMax)),g=F(e,f),e=t(e,f);b.min=F(a.pos,g-d);b.max=t(a.pos+a.len,e+d)}}),b.res=!0;else if(d.length){if(!i)b.selectionMarker=i=x({destroy:Ca,touch:!0},c.plotBox);b.pinchTranslate(d,e,j,i,l,g);b.hasPinched=h;b.scaleGroups(j,l);if(!h&&b.followTouchMove&&f===1)this.runPointActions(b.normalize(a));else if(b.res)b.res=!1,this.reset(!1,0)}},touch:function(a,b){var c=this.chart,d;ja=c.index;\nif(a.touches.length===1)if(a=this.normalize(a),c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop)&&!c.openMenu){b&&this.runPointActions(a);if(a.type===\"touchmove\")c=this.pinchDown,d=c[0]?Math.sqrt(Math.pow(c[0].chartX-a.chartX,2)+Math.pow(c[0].chartY-a.chartY,2))>=4:!1;p(d,!0)&&this.pinch(a)}else b&&this.reset();else a.touches.length===2&&this.pinch(a)},onContainerTouchStart:function(a){this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(a){U[ja]&&U[ja].pointer.drop(a)}});\nif(D.PointerEvent||D.MSPointerEvent){var wa={},Fb=!!D.PointerEvent,Ub=function(){var a,b=[];b.item=function(a){return this[a]};for(a in wa)wa.hasOwnProperty(a)&&b.push({pageX:wa[a].pageX,pageY:wa[a].pageY,target:wa[a].target});return b},Gb=function(a,b,c,d){if((a.pointerType===\"touch\"||a.pointerType===a.MSPOINTER_TYPE_TOUCH)&&U[ja])d(a),d=U[ja].pointer,d[b]({type:c,target:a.currentTarget,preventDefault:Ca,touches:Ub()})};x($a.prototype,{onContainerPointerDown:function(a){Gb(a,\"onContainerTouchStart\",\n\"touchstart\",function(a){wa[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){Gb(a,\"onContainerTouchMove\",\"touchmove\",function(a){wa[a.pointerId]={pageX:a.pageX,pageY:a.pageY};if(!wa[a.pointerId].target)wa[a.pointerId].target=a.currentTarget})},onDocumentPointerUp:function(a){Gb(a,\"onDocumentTouchEnd\",\"touchend\",function(a){delete wa[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,Fb?\"pointerdown\":\"MSPointerDown\",this.onContainerPointerDown);\na(this.chart.container,Fb?\"pointermove\":\"MSPointerMove\",this.onContainerPointerMove);a(y,Fb?\"pointerup\":\"MSPointerUp\",this.onDocumentPointerUp)}});ib($a.prototype,\"init\",function(a,b,c){a.call(this,b,c);this.hasZoom&&M(b.container,{\"-ms-touch-action\":\"none\",\"touch-action\":\"none\"})});ib($a.prototype,\"setDOMEvents\",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(N)});ib($a.prototype,\"destroy\",function(a){this.batchMSEvents(Y);a.call(this)})}var sb=u.Legend=function(a,\nb){this.init(a,b)};sb.prototype={init:function(a,b){var c=this,d=b.itemStyle,e=b.itemMarginTop||0;this.options=b;if(b.enabled)c.itemStyle=d,c.itemHiddenStyle=E(d,b.itemHiddenStyle),c.itemMarginTop=e,c.padding=d=p(b.padding,8),c.initialItemX=d,c.initialItemY=d-5,c.maxItemWidth=0,c.chart=a,c.itemHeight=0,c.symbolWidth=p(b.symbolWidth,16),c.pages=[],c.render(),N(c.chart,\"endResize\",function(){c.positionCheckboxes()})},colorizeItem:function(a,b){var c=this.options,d=a.legendItem,e=a.legendLine,f=a.legendSymbol,\ng=this.itemHiddenStyle.color,c=b?c.itemStyle.color:g,h=b?a.legendColor||a.color||\"#CCC\":g,g=a.options&&a.options.marker,i={fill:h},j;d&&d.css({fill:c,color:c});e&&e.attr({stroke:h});if(f){if(g&&f.isMarker)for(j in i.stroke=h,g=a.convertAttribs(g),g)d=g[j],d!==z&&(i[j]=d);f.attr(i)}},positionItem:function(a){var b=this.options,c=b.symbolPadding,b=!b.rtl,d=a._legendItemPos,e=d[0],d=d[1],f=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?e:this.legendWidth-e-2*c-4,d);if(f)f.x=e,f.y=d},destroyItem:function(a){var b=\na.checkbox;q([\"legendItem\",\"legendLine\",\"legendSymbol\",\"legendGroup\"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&Va(a.checkbox)},destroy:function(){var a=this.group,b=this.box;if(b)this.box=b.destroy();if(a)this.group=a.destroy()},positionCheckboxes:function(a){var b=this.group.alignAttr,c,d=this.clipHeight||this.legendHeight,e=this.titleHeight;if(b)c=b.translateY,q(this.allItems,function(f){var g=f.checkbox,h;g&&(h=c+e+g.y+(a||0)+3,M(g,{left:b.translateX+f.checkboxOffset+g.x-20+\"px\",top:h+\"px\",\ndisplay:h>c-6&&h<c+d-6?\"\":\"none\"}))})},renderTitle:function(){var a=this.padding,b=this.options.title,c=0;if(b.text){if(!this.title)this.title=this.chart.renderer.label(b.text,a-3,a-4,null,null,null,null,null,\"legend-title\").attr({zIndex:1}).css(b.style).add(this.group);a=this.title.getBBox();c=a.height;this.offsetWidth=a.width;this.contentGroup.attr({translateY:c})}this.titleHeight=c},setText:function(a){var b=this.options;a.legendItem.attr({text:b.labelFormat?Na(b.labelFormat,a):b.labelFormatter.call(a)})},\nrenderItem:function(a){var b=this.chart,c=b.renderer,d=this.options,e=d.layout===\"horizontal\",f=this.symbolWidth,g=d.symbolPadding,h=this.itemStyle,i=this.itemHiddenStyle,j=this.padding,k=e?p(d.itemDistance,20):0,l=!d.rtl,m=d.width,n=d.itemMarginBottom||0,o=this.itemMarginTop,A=this.initialItemX,r=a.legendItem,q=a.series&&a.series.drawLegendSymbol?a.series:a,w=q.options,w=this.createCheckboxForItem&&w&&w.showCheckbox,v=d.useHTML;if(!r){a.legendGroup=c.g(\"legend-item\").attr({zIndex:1}).add(this.scrollGroup);\na.legendItem=r=c.text(\"\",l?f+g:-g,this.baseline||0,v).css(E(a.visible?h:i)).attr({align:l?\"left\":\"right\",zIndex:2}).add(a.legendGroup);if(!this.baseline)this.fontMetrics=c.fontMetrics(h.fontSize,r),this.baseline=this.fontMetrics.f+3+o,r.attr(\"y\",this.baseline);q.drawLegendSymbol(this,a);this.setItemEvents&&this.setItemEvents(a,r,v,h,i);w&&this.createCheckboxForItem(a)}this.colorizeItem(a,a.visible);this.setText(a);c=r.getBBox();f=a.checkboxOffset=d.itemWidth||a.legendItemWidth||f+g+c.width+k+(w?20:\n0);this.itemHeight=g=C(a.legendItemHeight||c.height);if(e&&this.itemX-A+f>(m||b.chartWidth-2*j-A-d.x))this.itemX=A,this.itemY+=o+this.lastLineHeight+n,this.lastLineHeight=0;this.maxItemWidth=t(this.maxItemWidth,f);this.lastItemY=o+this.itemY+n;this.lastLineHeight=t(g,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=f:(this.itemY+=o+g+n,this.lastLineHeight=g);this.offsetWidth=m||t((e?this.itemX-A-k:f)+j,this.offsetWidth)},getAllItems:function(){var a=[];q(this.chart.series,\nfunction(b){var c=b.options;if(p(c.showInLegend,!s(c.linkedTo)?z:!1,!0))a=a.concat(b.legendItems||(c.legendType===\"point\"?b.data:b))});return a},adjustMargins:function(a,b){var c=this.chart,d=this.options,e=d.align.charAt(0)+d.verticalAlign.charAt(0)+d.layout.charAt(0);d.floating||q([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(f,g){f.test(e)&&!s(a[g])&&(c[qb[g]]=t(c[qb[g]],c.legend[(g+1)%2?\"legendHeight\":\"legendWidth\"]+[1,-1,-1,1][g]*d[g%2?\"x\":\"y\"]+p(d.margin,12)+b[g]))})},\nrender:function(){var a=this,b=a.chart,c=b.renderer,d=a.group,e,f,g,h,i=a.box,j=a.options,k=a.padding,l=j.borderWidth,m=j.backgroundColor;a.itemX=a.initialItemX;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;if(!d)a.group=d=c.g(\"legend\").attr({zIndex:7}).add(),a.contentGroup=c.g().attr({zIndex:1}).add(d),a.scrollGroup=c.g().add(a.contentGroup);a.renderTitle();e=a.getAllItems();kb(e,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});j.reversed&&\ne.reverse();a.allItems=e;a.display=f=!!e.length;a.lastLineHeight=0;q(e,function(b){a.renderItem(b)});g=(j.width||a.offsetWidth)+k;h=a.lastItemY+a.lastLineHeight+a.titleHeight;h=a.handleOverflow(h);h+=k;if(l||m){if(i){if(g>0&&h>0)i[i.isNew?\"attr\":\"animate\"](i.crisp({width:g,height:h})),i.isNew=!1}else a.box=i=c.rect(0,0,g,h,j.borderRadius,l||0).attr({stroke:j.borderColor,\"stroke-width\":l||0,fill:m||\"none\"}).add(d).shadow(j.shadow),i.isNew=!0;i[f?\"show\":\"hide\"]()}a.legendWidth=g;a.legendHeight=h;q(e,\nfunction(b){a.positionItem(b)});f&&d.align(x({width:g,height:h},j),!0,\"spacingBox\");b.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,c=this.chart,d=c.renderer,e=this.options,f=e.y,f=c.spacingBox.height+(e.verticalAlign===\"top\"?-f:f)-this.padding,g=e.maxHeight,h,i=this.clipRect,j=e.navigation,k=p(j.animation,!0),l=j.arrowSize||12,m=this.nav,n=this.pages,o=this.padding,A,r=this.allItems,s=function(a){i.attr({height:a});if(b.contentGroup.div)b.contentGroup.div.style.clip=\n\"rect(\"+o+\"px,9999px,\"+(o+a)+\"px,0)\"};e.layout===\"horizontal\"&&(f/=2);g&&(f=F(f,g));n.length=0;if(a>f&&j.enabled!==!1){this.clipHeight=h=t(f-20-this.titleHeight-o,0);this.currentPage=p(this.currentPage,1);this.fullHeight=a;q(r,function(a,b){var c=a._legendItemPos[1],d=C(a.legendItem.getBBox().height),e=n.length;if(!e||c-n[e-1]>h&&(A||c)!==n[e-1])n.push(A||c),e++;b===r.length-1&&c+d-n[e-1]>h&&n.push(c);c!==A&&(A=c)});if(!i)i=b.clipRect=d.clipRect(0,o,9999,0),b.contentGroup.clip(i);s(h);if(!m)this.nav=\nm=d.g().attr({zIndex:1}).add(this.group),this.up=d.symbol(\"triangle\",0,0,l,l).on(\"click\",function(){b.scroll(-1,k)}).add(m),this.pager=d.text(\"\",15,10).css(j.style).add(m),this.down=d.symbol(\"triangle-down\",0,0,l,l).on(\"click\",function(){b.scroll(1,k)}).add(m);b.scroll(0);a=f}else if(m)s(c.chartHeight),m.hide(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0;return a},scroll:function(a,b){var c=this.pages,d=c.length,e=this.currentPage+a,f=this.clipHeight,g=this.options.navigation,h=g.activeColor,\ng=g.inactiveColor,i=this.pager,j=this.padding;e>d&&(e=d);if(e>0)b!==z&&cb(b,this.chart),this.nav.attr({translateX:j,translateY:f+this.padding+7+this.titleHeight,visibility:\"visible\"}),this.up.attr({fill:e===1?g:h}).css({cursor:e===1?\"default\":\"pointer\"}),i.attr({text:e+\"/\"+d}),this.down.attr({x:18+this.pager.getBBox().width,fill:e===d?g:h}).css({cursor:e===d?\"default\":\"pointer\"}),c=-c[e-1]+this.initialItemY,this.scrollGroup.animate({translateY:c}),this.currentPage=e,this.positionCheckboxes(c)}};P=\nu.LegendSymbolMixin={drawRectangle:function(a,b){var c=a.options.symbolHeight||a.fontMetrics.f;b.legendSymbol=this.chart.renderer.rect(0,a.baseline-c+1,a.symbolWidth,c,a.options.symbolRadius||0).attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,c=b.marker,d=a.symbolWidth,e=this.chart.renderer,f=this.legendGroup,a=a.baseline-C(a.fontMetrics.b*0.3),g;if(b.lineWidth){g={\"stroke-width\":b.lineWidth};if(b.dashStyle)g.dashstyle=b.dashStyle;this.legendLine=e.path([X,0,a,S,\nd,a]).attr(g).add(f)}if(c&&c.enabled!==!1)b=c.radius,this.legendSymbol=c=e.symbol(this.symbol,d/2-b,a-b,2*b,2*b,c).add(f),c.isMarker=!0}};(/Trident\\/7\\.0/.test(Ba)||Qa)&&ib(sb.prototype,\"positionItem\",function(a,b){var c=this,d=function(){b._legendItemPos&&a.call(c,b)};d();setTimeout(d)});var jb=u.Chart=function(){this.getArgs.apply(this,arguments)};u.chart=function(a,b,c){return new jb(a,b,c)};jb.prototype={callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(ya(a[0])||a[0].nodeName)this.renderTo=\na.shift();this.init(a[0],a[1])},init:function(a,b){var c,d=a.series;a.series=null;c=E(T,a);c.series=a.series=d;this.userOptions=a;d=c.chart;this.margin=this.splashArray(\"margin\",d);this.spacing=this.splashArray(\"spacing\",d);var e=d.events;this.bounds={h:{},v:{}};this.callback=b;this.isResizing=0;this.options=c;this.axes=[];this.series=[];this.hasCartesianSeries=d.showAxes;var f=this,g;f.index=U.length;U.push(f);hb++;d.reflow!==!1&&N(f,\"load\",function(){f.initReflow()});if(e)for(g in e)N(f,g,e[g]);\nf.xAxis=[];f.yAxis=[];f.animation=la?!1:p(d.animation,!0);f.pointCount=f.colorCounter=f.symbolCounter=0;f.firstRender()},initSeries:function(a){var b=this.options.chart;(b=L[a.type||b.type||b.defaultSeriesType])||ea(17,!0);b=new b;b.init(this,a);return b},isInsidePlot:function(a,b,c){var d=c?b:a,a=c?a:b;return d>=0&&d<=this.plotWidth&&a>=0&&a<=this.plotHeight},redraw:function(a){var b=this.axes,c=this.series,d=this.pointer,e=this.legend,f=this.isDirtyLegend,g,h,i=this.hasCartesianSeries,j=this.isDirtyBox,\nk=c.length,l=k,m=this.renderer,n=m.isHidden(),o=[];cb(a,this);n&&this.cloneRenderTo();for(this.layOutTitles();l--;)if(a=c[l],a.options.stacking&&(g=!0,a.isDirty)){h=!0;break}if(h)for(l=k;l--;)if(a=c[l],a.options.stacking)a.isDirty=!0;q(c,function(a){a.isDirty&&a.options.legendType===\"point\"&&(a.updateTotals&&a.updateTotals(),f=!0);a.isDirtyData&&H(a,\"updatedData\")});if(f&&e.options.enabled)e.render(),this.isDirtyLegend=!1;g&&this.getStacks();if(i&&!this.isResizing)this.maxTicks=null,q(b,function(a){a.updateNames();\na.setScale()});this.getMargins();i&&(q(b,function(a){a.isDirty&&(j=!0)}),q(b,function(a){var b=a.min+\",\"+a.max;if(a.extKey!==b)a.extKey=b,o.push(function(){H(a,\"afterSetExtremes\",x(a.eventArgs,a.getExtremes()));delete a.eventArgs});(j||g)&&a.redraw()}));j&&this.drawChartBox();q(c,function(a){a.isDirty&&a.visible&&(!a.isCartesian||a.xAxis)&&a.redraw()});d&&d.reset(!0);m.draw();H(this,\"redraw\");n&&this.cloneRenderTo(!0);q(o,function(a){a.call()})},get:function(a){var b=this.axes,c=this.series,d,e;for(d=\n0;d<b.length;d++)if(b[d].options.id===a)return b[d];for(d=0;d<c.length;d++)if(c[d].options.id===a)return c[d];for(d=0;d<c.length;d++){e=c[d].points||[];for(b=0;b<e.length;b++)if(e[b].id===a)return e[b]}return null},getAxes:function(){var a=this,b=this.options,c=b.xAxis=ua(b.xAxis||{}),b=b.yAxis=ua(b.yAxis||{});q(c,function(a,b){a.index=b;a.isX=!0});q(b,function(a,b){a.index=b});c=c.concat(b);q(c,function(b){new ia(a,b)})},getSelectedPoints:function(){var a=[];q(this.series,function(b){a=a.concat(Da(b.points||\n[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return Da(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var g;var d=this,e=d.options,f;f=e.title=E(e.title,a);g=e.subtitle=E(e.subtitle,b),e=g;q([[\"title\",a,f],[\"subtitle\",b,e]],function(a){var b=a[0],c=d[b],e=a[1],a=a[2];c&&e&&(d[b]=c=c.destroy());a&&a.text&&!c&&(d[b]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,\"class\":\"highcharts-\"+b,zIndex:a.zIndex||4}).css(a.style).add())});d.layOutTitles(c)},\nlayOutTitles:function(a){var b=0,c=this.title,d=this.subtitle,e=this.options,f=e.title,e=e.subtitle,g=this.renderer,h=this.spacingBox;if(c&&(c.css({width:(f.width||h.width+f.widthAdjust)+\"px\"}).align(x({y:g.fontMetrics(f.style.fontSize,c).b-3},f),!1,h),!f.floating&&!f.verticalAlign))b=c.getBBox().height;d&&(d.css({width:(e.width||h.width+e.widthAdjust)+\"px\"}).align(x({y:b+(f.margin-13)+g.fontMetrics(e.style.fontSize,c).b},e),!1,h),!e.floating&&!e.verticalAlign&&(b=va(b+d.getBBox().height)));c=this.titleOffset!==\nb;this.titleOffset=b;if(!this.isDirtyBox&&c)this.isDirtyBox=c,this.hasRendered&&p(a,!0)&&this.isDirtyBox&&this.redraw()},getChartSize:function(){var a=this.options.chart,b=a.width,a=a.height,c=this.renderToClone||this.renderTo;if(!s(b))this.containerWidth=oa(c,\"width\");if(!s(a))this.containerHeight=oa(c,\"height\");this.chartWidth=t(0,b||this.containerWidth||600);this.chartHeight=t(0,p(a,this.containerHeight>19?this.containerHeight:400))},cloneRenderTo:function(a){var b=this.renderToClone,c=this.container;\nif(a){if(b){for(;b.childNodes.length;)this.renderTo.appendChild(b.firstChild);Va(b);delete this.renderToClone}}else c&&c.parentNode===this.renderTo&&this.renderTo.removeChild(c),this.renderToClone=b=this.renderTo.cloneNode(0),M(b,{position:\"absolute\",top:\"-9999px\",display:\"block\"}),b.style.setProperty&&b.style.setProperty(\"display\",\"block\",\"important\"),y.body.appendChild(b),c&&b.appendChild(c)},getContainer:function(){var a,b=this.options,c=b.chart,d,e;a=this.renderTo;var f=\"highcharts-\"+Cb++;if(!a)this.renderTo=\na=c.renderTo;if(ya(a))this.renderTo=a=y.getElementById(a);a||ea(13,!0);d=B(O(a,\"data-highcharts-chart\"));I(d)&&U[d]&&U[d].hasRendered&&U[d].destroy();O(a,\"data-highcharts-chart\",this.index);a.innerHTML=\"\";!c.skipClone&&!a.offsetWidth&&this.cloneRenderTo();this.getChartSize();d=this.chartWidth;e=this.chartHeight;this.container=a=ca(Pa,{className:\"highcharts-container\"+(c.className?\" \"+c.className:\"\"),id:f},x({position:\"relative\",overflow:\"hidden\",width:d+\"px\",height:e+\"px\",textAlign:\"left\",lineHeight:\"normal\",\nzIndex:0,\"-webkit-tap-highlight-color\":\"rgba(0,0,0,0)\"},c.style),this.renderToClone||a);this._cursor=a.style.cursor;this.renderer=new (u[c.renderer]||fb)(a,d,e,c.style,c.forExport,b.exporting&&b.exporting.allowHTML);la&&this.renderer.create(this,a,d,e);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,c=this.margin,d=this.titleOffset;this.resetMargins();if(d&&!s(c[0]))this.plotTop=t(this.plotTop,d+this.options.title.margin+b[0]);this.legend.display&&this.legend.adjustMargins(c,\nb);this.extraBottomMargin&&(this.marginBottom+=this.extraBottomMargin);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&q(a.axes,function(a){a.visible&&a.getOffset()});q(qb,function(d,e){s(c[e])||(a[d]+=b[e])});a.setChartSize()},reflow:function(a){var b=this,c=b.options.chart,d=b.renderTo,e=s(c.width),f=c.width||oa(d,\"width\"),c=c.height||oa(d,\"height\"),d=a?a.target:D;if(!e&&\n!b.isPrinting&&f&&c&&(d===D||d===y)){if(f!==b.containerWidth||c!==b.containerHeight)clearTimeout(b.reflowTimeout),b.reflowTimeout=Sa(function(){b.container&&b.setSize(void 0,void 0,!1)},a?100:0);b.containerWidth=f;b.containerHeight=c}},initReflow:function(){var a=this,b=function(b){a.reflow(b)};N(D,\"resize\",b);N(a,\"destroy\",function(){Y(D,\"resize\",b)})},setSize:function(a,b,c){var d=this,e=d.renderer;d.isResizing+=1;cb(c,d);d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;if(a!==void 0)d.options.chart.width=\na;if(b!==void 0)d.options.chart.height=b;d.getChartSize();a=e.globalAnimation;(a?Za:M)(d.container,{width:d.chartWidth+\"px\",height:d.chartHeight+\"px\"},a);d.setChartSize(!0);e.setSize(d.chartWidth,d.chartHeight,c);d.maxTicks=null;q(d.axes,function(a){a.isDirty=!0;a.setScale()});q(d.series,function(a){a.isDirty=!0});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(c);d.oldChartHeight=null;H(d,\"resize\");Sa(function(){d&&H(d,\"endResize\",null,function(){d.isResizing-=1})},Wa(a).duration)},\nsetChartSize:function(a){var b=this.inverted,c=this.renderer,d=this.chartWidth,e=this.chartHeight,f=this.options.chart,g=this.spacing,h=this.clipOffset,i,j,k,l;this.plotLeft=i=C(this.plotLeft);this.plotTop=j=C(this.plotTop);this.plotWidth=k=t(0,C(d-i-this.marginRight));this.plotHeight=l=t(0,C(e-j-this.marginBottom));this.plotSizeX=b?l:k;this.plotSizeY=b?k:l;this.plotBorderWidth=f.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:g[3],y:g[0],width:d-g[3]-g[1],height:e-g[0]-g[2]};this.plotBox=c.plotBox=\n{x:i,y:j,width:k,height:l};d=2*V(this.plotBorderWidth/2);b=va(t(d,h[3])/2);c=va(t(d,h[0])/2);this.clipBox={x:b,y:c,width:V(this.plotSizeX-t(d,h[1])/2-b),height:t(0,V(this.plotSizeY-t(d,h[2])/2-c))};a||q(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this;q(qb,function(b,c){a[b]=p(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,d=this.chartHeight,\ne=this.chartBackground,f=this.plotBackground,g=this.plotBorder,h=this.plotBGImage,i=a.borderWidth||0,j=a.backgroundColor,k=a.plotBackgroundColor,l=a.plotBackgroundImage,m=a.plotBorderWidth||0,n,o=this.plotLeft,p=this.plotTop,r=this.plotWidth,q=this.plotHeight,w=this.plotBox,v=this.clipRect,s=this.clipBox;n=i+(a.shadow?8:0);if(i||j)if(e)e.animate(e.crisp({width:c-n,height:d-n}));else{e={fill:j||\"none\"};if(i)e.stroke=a.borderColor,e[\"stroke-width\"]=i;this.chartBackground=b.rect(n/2,n/2,c-n,d-n,a.borderRadius,\ni).attr(e).addClass(\"highcharts-background\").add().shadow(a.shadow)}if(k)f?f.animate(w):this.plotBackground=b.rect(o,p,r,q,0).attr({fill:k}).add().shadow(a.plotShadow);if(l)h?h.animate(w):this.plotBGImage=b.image(l,o,p,r,q).add();v?v.animate({width:s.width,height:s.height}):this.clipRect=b.clipRect(s);if(m)g?(g.strokeWidth=-m,g.animate(g.crisp({x:o,y:p,width:r,height:q}))):this.plotBorder=b.rect(o,p,r,q,0,-m).attr({stroke:a.plotBorderColor,\"stroke-width\":m,fill:\"none\",zIndex:1}).add();this.isDirtyBox=\n!1},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,e,f;q([\"inverted\",\"angular\",\"polar\"],function(g){c=L[b.type||b.defaultSeriesType];f=a[g]||b[g]||c&&c.prototype[g];for(e=d&&d.length;!f&&e--;)(c=L[d[e].type])&&c.prototype[g]&&(f=!0);a[g]=f})},linkSeries:function(){var a=this,b=a.series;q(b,function(a){a.linkedSeries.length=0});q(b,function(b){var d=b.options.linkedTo;if(ya(d)&&(d=d===\":previous\"?a.series[b.index-1]:a.get(d))&&d.linkedParent!==b)d.linkedSeries.push(b),\nb.linkedParent=d,b.visible=p(b.options.visible,d.options.visible,b.visible)})},renderSeries:function(){q(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&q(b.items,function(c){var d=x(b.style,c.style),e=B(d.left)+a.plotLeft,f=B(d.top)+a.plotTop+12;delete d.left;delete d.top;a.renderer.text(c.html,e,f).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,d,e,f,g;this.setTitle();this.legend=\nnew sb(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();d=this.plotWidth;e=this.plotHeight-=21;q(a,function(a){a.setScale()});this.getAxisMargins();f=d/this.plotWidth>1.1;g=e/this.plotHeight>1.05;if(f||g)this.maxTicks=null,q(a,function(a){(a.horiz&&f||!a.horiz&&g)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&q(a,function(a){a.visible&&a.render()});if(!this.seriesGroup)this.seriesGroup=b.g(\"series-group\").attr({zIndex:3}).add();\nthis.renderSeries();this.renderLabels();this.showCredits(c.credits);this.hasRendered=!0},showCredits:function(a){if(a.enabled&&!this.credits)this.credits=this.renderer.text(a.text,0,0).on(\"click\",function(){if(a.href)D.location.href=a.href}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position)},destroy:function(){var a=this,b=a.axes,c=a.series,d=a.container,e,f=d&&d.parentNode;H(a,\"destroy\");U[a.index]=z;hb--;a.renderTo.removeAttribute(\"data-highcharts-chart\");Y(a);for(e=b.length;e--;)b[e]=\nb[e].destroy();for(e=c.length;e--;)c[e]=c[e].destroy();q(\"title,subtitle,chartBackground,plotBackground,plotBGImage,plotBorder,seriesGroup,clipRect,credits,pointer,scroller,rangeSelector,legend,resetZoomButton,tooltip,renderer\".split(\",\"),function(b){var c=a[b];c&&c.destroy&&(a[b]=c.destroy())});if(d)d.innerHTML=\"\",Y(d),f&&Va(d);for(e in a)delete a[e]},isReadyToRender:function(){var a=this;return!fa&&D==D.top&&y.readyState!==\"complete\"||la&&!D.canvg?(la?Qb.push(function(){a.firstRender()},a.options.global.canvasToolsURL):\ny.attachEvent(\"onreadystatechange\",function(){y.detachEvent(\"onreadystatechange\",a.firstRender);y.readyState===\"complete\"&&a.firstRender()}),!1):!0},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();H(a,\"init\");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();q(b.series||[],function(b){a.initSeries(b)});a.linkSeries();H(a,\"beforeRender\");if(u.Pointer)a.pointer=new $a(a,b);a.render();a.renderer.draw();if(!a.renderer.imgCount&&a.onload)a.onload();\na.cloneRenderTo(!0)}},onload:function(){var a=this;q([this.callback].concat(this.callbacks),function(b){b&&a.index!==void 0&&b.apply(a,[a])});H(a,\"load\");this.onload=null},splashArray:function(a,b){var c=b[a],c=ba(c)?c:[c,c,c,c];return[p(b[a+\"Top\"],c[0]),p(b[a+\"Right\"],c[1]),p(b[a+\"Bottom\"],c[2]),p(b[a+\"Left\"],c[3])]}};var Eb=u.CenteredSeriesMixin={getCenter:function(){var a=this.options,b=this.chart,c=2*(a.slicedOffset||0),d=b.plotWidth-2*c,b=b.plotHeight-2*c,e=a.center,e=[p(e[0],\"50%\"),p(e[1],\"50%\"),\na.size||\"100%\",a.innerSize||0],f=F(d,b),g,h;for(g=0;g<4;++g)h=e[g],a=g<2||g===2&&/%$/.test(h),e[g]=(/%$/.test(h)?[d,b,f,e[2]][g]*parseFloat(h)/100:parseFloat(h))+(a?c:0);e[3]>e[2]&&(e[3]=e[2]);return e}},Ma=function(){};Ma.prototype={init:function(a,b,c){this.series=a;this.color=a.color;this.applyOptions(b,c);this.pointAttr={};if(a.options.colorByPoint&&(b=a.options.colors||a.chart.options.colors,this.color=this.color||b[a.colorCounter++],a.colorCounter===b.length))a.colorCounter=0;a.chart.pointCount++;\nreturn this},applyOptions:function(a,b){var c=this.series,d=c.options.pointValKey||c.pointValKey,a=Ma.prototype.optionsToObject.call(this,a);x(this,a);this.options=this.options?x(this.options,a):a;a.group&&delete this.group;if(d)this.y=this[d];this.isNull=p(this.isValid&&!this.isValid(),this.x===null||!I(this.y,!0));if(\"name\"in this&&b===void 0&&c.xAxis&&c.xAxis.hasNames)this.x=c.xAxis.nameToX(this);if(this.x===void 0&&c)this.x=b===void 0?c.autoIncrement(this):b;return this},optionsToObject:function(a){var b=\n{},c=this.series,d=c.options.keys,e=d||c.pointArrayMap||[\"y\"],f=e.length,g=0,h=0;if(I(a)||a===null)b[e[0]]=a;else if(za(a)){if(!d&&a.length>f){c=typeof a[0];if(c===\"string\")b.name=a[0];else if(c===\"number\")b.x=a[0];g++}for(;h<f;){if(!d||a[g]!==void 0)b[e[h]]=a[g];g++;h++}}else if(typeof a===\"object\"){b=a;if(a.dataLabels)c._hasPointLabels=!0;if(a.marker)c._hasPointMarkers=!0}return b},destroy:function(){var a=this.series.chart,b=a.hoverPoints,c;a.pointCount--;if(b&&(this.setState(),ra(b,this),!b.length))a.hoverPoints=\nnull;if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)Y(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(c in this)this[c]=null},destroyElements:function(){for(var a=[\"graphic\",\"dataLabel\",\"dataLabelUpper\",\"connector\",\"shadowGroup\"],b,c=6;c--;)b=a[c],this[b]&&(this[b]=this[b].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,\ntotal:this.total||this.stackTotal}},tooltipFormatter:function(a){var b=this.series,c=b.tooltipOptions,d=p(c.valueDecimals,\"\"),e=c.valuePrefix||\"\",f=c.valueSuffix||\"\";q(b.pointArrayMap||[\"y\"],function(b){b=\"{point.\"+b;if(e||f)a=a.replace(b+\"}\",e+b+\"}\"+f);a=a.replace(b+\"}\",b+\":,.\"+d+\"f}\")});return Na(a,{point:this,series:this.series})},firePointEvent:function(a,b,c){var d=this,e=this.series.options;(e.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&this.importEvents();a===\"click\"&&\ne.allowPointSelect&&(c=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});H(this,a,b,c)},visible:!0};var R=u.Series=function(){};R.prototype={isCartesian:!0,type:\"line\",pointClass:Ma,sorted:!0,requireSorting:!0,pointAttrToOptions:{stroke:\"lineColor\",\"stroke-width\":\"lineWidth\",fill:\"fillColor\",r:\"radius\"},directTouch:!1,axisTypes:[\"xAxis\",\"yAxis\"],colorCounter:0,parallelArrays:[\"x\",\"y\"],init:function(a,b){var c=this,d,e,f=a.series,g=function(a,b){return p(a.options.index,a._i)-\np(b.options.index,b._i)};c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();x(c,{name:b.name,state:\"\",pointAttr:{},visible:b.visible!==!1,selected:b.selected===!0});if(la)b.animation=!1;e=b.events;for(d in e)N(c,d,e[d]);if(e&&e.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();q(c.parallelArrays,function(a){c[a+\"Data\"]=[]});c.setData(b.data,!1);if(c.isCartesian)a.hasCartesianSeries=!0;f.push(c);c._i=f.length-\n1;kb(f,g);this.yAxis&&kb(this.yAxis.series,g);q(f,function(a,b){a.index=b;a.name=a.name||\"Series \"+(b+1)})},bindAxes:function(){var a=this,b=a.options,c=a.chart,d;q(a.axisTypes||[],function(e){q(c[e],function(c){d=c.options;if(b[e]===d.index||b[e]!==z&&b[e]===d.id||b[e]===z&&d.index===0)c.series.push(a),a[e]=c,c.isDirty=!0});!a[e]&&a.optionalAxis!==e&&ea(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,e=I(b)?function(d){var e=d===\"y\"&&c.toYData?c.toYData(a):a[d];c[d+\"Data\"][b]=\ne}:function(a){Array.prototype[b].apply(c[a+\"Data\"],Array.prototype.slice.call(d,2))};q(c.parallelArrays,e)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,b=p(b,a.pointStart,0);this.pointInterval=c=p(this.pointInterval,a.pointInterval,1);d&&(a=new ma(b),d===\"day\"?a=+a[nb](a[Xa]()+c):d===\"month\"?a=+a[Ab](a[db]()+c):d===\"year\"&&(a=+a[Bb](a[eb]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options.plotOptions,b=b.userOptions||\n{},d=b.plotOptions||{},e=c[this.type];this.userOptions=a;c=E(e,c.series,a);this.tooltipOptions=E(T.tooltip,T.plotOptions[this.type].tooltip,b.tooltip,d.series&&d.series.tooltip,d[this.type]&&d[this.type].tooltip,a.tooltip);e.marker===null&&delete c.marker;this.zoneAxis=c.zoneAxis;a=this.zones=(c.zones||[]).slice();if((c.negativeColor||c.negativeFillColor)&&!c.zones)a.push({value:c[this.zoneAxis+\"Threshold\"]||c.threshold||0,color:c.negativeColor,fillColor:c.negativeFillColor});a.length&&s(a[a.length-\n1].value)&&a.push({color:this.color,fillColor:this.fillColor});return c},getCyclic:function(a,b,c){var d=this.userOptions,e=\"_\"+a+\"Index\",f=a+\"Counter\";b||(s(d[e])?b=d[e]:(d[e]=b=this.chart[f]%c.length,this.chart[f]+=1),b=c[b]);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic(\"color\",this.options.color||ga[this.type].color,this.chart.options.colors)},getSymbol:function(){var a=this.options.marker;this.getCyclic(\"symbol\",a.symbol,this.chart.options.symbols);\nif(/^url/.test(this.symbol))a.radius=0},drawLegendSymbol:P.drawLineMarker,setData:function(a,b,c,d){var e=this,f=e.points,g=f&&f.length||0,h,i=e.options,j=e.chart,k=null,l=e.xAxis,m=i.turboThreshold,n=this.xData,o=this.yData,A=(h=e.pointArrayMap)&&h.length,a=a||[];h=a.length;b=p(b,!0);if(d!==!1&&h&&g===h&&!e.cropped&&!e.hasGroupedData&&e.visible)q(a,function(a,b){f[b].update&&a!==i.data[b]&&f[b].update(a,!1,null,!1)});else{e.xIncrement=null;e.colorCounter=0;q(this.parallelArrays,function(a){e[a+\"Data\"].length=\n0});if(m&&h>m){for(c=0;k===null&&c<h;)k=a[c],c++;if(I(k))for(c=0;c<h;c++)n[c]=this.autoIncrement(),o[c]=a[c];else if(za(k))if(A)for(c=0;c<h;c++)k=a[c],n[c]=k[0],o[c]=k.slice(1,A+1);else for(c=0;c<h;c++)k=a[c],n[c]=k[0],o[c]=k[1];else ea(12)}else for(c=0;c<h;c++)a[c]!==z&&(k={series:e},e.pointClass.prototype.applyOptions.apply(k,[a[c]]),e.updateParallelArrays(k,c));ya(o[0])&&ea(14,!0);e.data=[];e.options.data=e.userOptions.data=a;for(c=g;c--;)f[c]&&f[c].destroy&&f[c].destroy();if(l)l.minRange=l.userMinRange;\ne.isDirty=e.isDirtyData=j.isDirtyBox=!0;c=!1}i.legendType===\"point\"&&(this.processData(),this.generatePoints());b&&j.redraw(c)},processData:function(a){var b=this.xData,c=this.yData,d=b.length,e;e=0;var f,g,h=this.xAxis,i,j=this.options;i=j.cropThreshold;var k=this.getExtremesFromAll||j.getExtremesFromAll,l=this.isCartesian,j=h&&h.val2lin,m=h&&h.isLog,n,o;if(l&&!this.isDirty&&!h.isDirty&&!this.yAxis.isDirty&&!a)return!1;if(h)a=h.getExtremes(),n=a.min,o=a.max;if(l&&this.sorted&&!k&&(!i||d>i||this.forceCrop))if(b[d-\n1]<n||b[0]>o)b=[],c=[];else if(b[0]<n||b[d-1]>o)e=this.cropData(this.xData,this.yData,n,o),b=e.xData,c=e.yData,e=e.start,f=!0;for(i=b.length||1;--i;)d=m?j(b[i])-j(b[i-1]):b[i]-b[i-1],d>0&&(g===z||d<g)?g=d:d<0&&this.requireSorting&&ea(15);this.cropped=f;this.cropStart=e;this.processedXData=b;this.processedYData=c;this.closestPointRange=g},cropData:function(a,b,c,d){var e=a.length,f=0,g=e,h=p(this.cropShoulder,1),i;for(i=0;i<e;i++)if(a[i]>=c){f=t(0,i-h);break}for(c=i;c<e;c++)if(a[c]>d){g=c+h;break}return{xData:a.slice(f,\ng),yData:b.slice(f,g),start:f,end:g}},generatePoints:function(){var a=this.options.data,b=this.data,c,d=this.processedXData,e=this.processedYData,f=this.pointClass,g=d.length,h=this.cropStart||0,i,j=this.hasGroupedData,k,l=[],m;if(!b&&!j)b=[],b.length=a.length,b=this.data=b;for(m=0;m<g;m++)i=h+m,j?(l[m]=(new f).init(this,[d[m]].concat(ua(e[m]))),l[m].dataGroup=this.groupMap[m]):(b[i]?k=b[i]:a[i]!==z&&(b[i]=k=(new f).init(this,a[i],d[m])),l[m]=k),l[m].index=i;if(b&&(g!==(c=b.length)||j))for(m=0;m<\nc;m++)if(m===h&&!j&&(m+=g),b[m])b[m].destroyElements(),b[m].plotX=z;this.data=b;this.points=l},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,e=[],f=0;d=this.xAxis.getExtremes();var g=d.min,h=d.max,i,j,k,l,a=a||this.stackedYData||this.processedYData||[];d=a.length;for(l=0;l<d;l++)if(j=c[l],k=a[l],i=(I(k,!0)||za(k))&&(!b.isLog||k.length||k>0),j=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[l+1]||j)>=g&&(c[l-1]||j)<=h,i&&j)if(i=k.length)for(;i--;)k[i]!==\nnull&&(e[f++]=k[i]);else e[f++]=k;this.dataMin=Oa(e);this.dataMax=Ha(e)},translate:function(){this.processedXData||this.processData();this.generatePoints();for(var a=this.options,b=a.stacking,c=this.xAxis,d=c.categories,e=this.yAxis,f=this.points,g=f.length,h=!!this.modifyValue,i=a.pointPlacement,j=i===\"between\"||I(i),k=a.threshold,l=a.startFromThreshold?k:0,m,n,o,q,r=Number.MAX_VALUE,a=0;a<g;a++){var K=f[a],w=K.x,v=K.y;n=K.low;var x=b&&e.stacks[(this.negStacks&&v<(l?0:k)?\"-\":\"\")+this.stackKey],u;\nif(e.isLog&&v!==null&&v<=0)K.isNull=!0;K.plotX=m=$(F(t(-1E5,c.translate(w,0,0,0,1,i,this.type===\"flags\")),1E5));if(b&&this.visible&&!K.isNull&&x&&x[w])q=this.getStackIndicator(q,w,this.index),u=x[w],v=u.points[q.key],n=v[0],v=v[1],n===l&&q.key===x[w].base&&(n=p(k,e.min)),e.isLog&&n<=0&&(n=null),K.total=K.stackTotal=u.total,K.percentage=u.total&&K.y/u.total*100,K.stackY=v,u.setOffset(this.pointXOffset||0,this.barW||0);K.yBottom=s(n)?e.translate(n,0,1,0,1):null;h&&(v=this.modifyValue(v,K));K.plotY=\nn=typeof v===\"number\"&&v!==Infinity?F(t(-1E5,e.translate(v,0,1,0,1)),1E5):z;K.isInside=n!==z&&n>=0&&n<=e.len&&m>=0&&m<=c.len;K.clientX=j?$(c.translate(w,0,0,0,1,i)):m;K.negative=K.y<(k||0);K.category=d&&d[K.x]!==z?d[K.x]:K.x;K.isNull||(o!==void 0&&(r=F(r,Q(m-o))),o=m)}this.closestPointRangePx=r},getValidPoints:function(a,b){var c=this.chart;return Da(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,\nd=b.renderer,e=b.inverted,f=this.clipBox,g=f||b.clipBox,h=this.sharedClipKey||[\"_sharedClip\",a&&a.duration,a&&a.easing,g.height,c.xAxis,c.yAxis].join(\",\"),i=b[h],j=b[h+\"m\"];if(!i){if(a)g.width=0,b[h+\"m\"]=j=d.clipRect(-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight);b[h]=i=d.clipRect(g);i.count={length:0}}a&&!i.count[this.index]&&(i.count[this.index]=!0,i.count.length+=1);if(c.clip!==!1)this.group.clip(a||f?i:b.clipRect),this.markerGroup.clip(j),this.sharedClipKey=h;a||(i.count[this.index]&&\n(delete i.count[this.index],i.count.length-=1),i.count.length===0&&h&&b[h]&&(f||(b[h]=b[h].destroy()),b[h+\"m\"]&&(b[h+\"m\"]=b[h+\"m\"].destroy())))},animate:function(a){var b=this.chart,c=Wa(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX},c),b[d+\"m\"]&&b[d+\"m\"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();H(this,\"afterAnimate\")},drawPoints:function(){var a,b=this.points,c=this.chart,d,e,f,g,h,i,j,\nk,l=this.options.marker,m=this.pointAttr[\"\"],n,o,q,r=this.markerGroup,s=p(l.enabled,this.xAxis.isRadial,this.closestPointRangePx>2*l.radius);if(l.enabled!==!1||this._hasPointMarkers)for(f=b.length;f--;)if(g=b[f],d=V(g.plotX),e=g.plotY,k=g.graphic,n=g.marker||{},o=!!g.marker,a=s&&n.enabled===z||n.enabled,q=g.isInside,a&&I(e)&&g.y!==null)if(a=g.pointAttr[g.selected?\"select\":\"\"]||m,h=a.r,i=p(n.symbol,this.symbol),j=i.indexOf(\"url\")===0,k)k[q?\"show\":\"hide\"](!0).attr(a).animate(x({x:d-h,y:e-h},k.symbolName?\n{width:2*h,height:2*h}:{}));else{if(q&&(h>0||j))g.graphic=c.renderer.symbol(i,d-h,e-h,2*h,2*h,o?n:l).attr(a).add(r)}else if(k)g.graphic=k.destroy()},convertAttribs:function(a,b,c,d){var e=this.pointAttrToOptions,f,g,h={},a=a||{},b=b||{},c=c||{},d=d||{};for(f in e)g=e[f],h[f]=p(a[g],b[f],c[f],d[f]);return h},getAttribs:function(){var a=this,b=a.options,c=ga[a.type].marker?b.marker:b,d=c.states,e=d.hover,f,g=a.color,h=a.options.negativeColor,i={stroke:g,fill:g},j=a.points||[],k,l=[],m,n=a.pointAttrToOptions;\nf=a.hasPointSpecificOptions;var o=c.lineColor,A=c.fillColor;k=b.turboThreshold;var r=a.zones,t=a.zoneAxis||\"y\",w,v;b.marker?(e.radius=+e.radius||+c.radius+ +e.radiusPlus,e.lineWidth=e.lineWidth||c.lineWidth+e.lineWidthPlus):(e.color=e.color||na(e.color||g).brighten(e.brightness).get(),e.negativeColor=e.negativeColor||na(e.negativeColor||h).brighten(e.brightness).get());l[\"\"]=a.convertAttribs(c,i);q([\"hover\",\"select\"],function(b){l[b]=a.convertAttribs(d[b],l[\"\"])});a.pointAttr=l;g=j.length;if(!k||\ng<k||f)for(;g--;){k=j[g];if((c=k.options&&k.options.marker||k.options)&&c.enabled===!1)c.radius=0;i=null;if(r.length){f=0;for(i=r[f];k[t]>=i.value;)i=r[++f];k.color=k.fillColor=i=p(i.color,a.color)}f=b.colorByPoint||k.color;if(k.options)for(v in n)s(c[n[v]])&&(f=!0);if(f){c=c||{};m=[];d=c.states||{};f=d.hover=d.hover||{};if(!b.marker||k.negative&&!f.fillColor&&!e.fillColor)f[a.pointAttrToOptions.fill]=f.color||!k.options.color&&e[k.negative&&h?\"negativeColor\":\"color\"]||na(k.color).brighten(f.brightness||\ne.brightness).get();w={color:k.color};if(!A)w.fillColor=k.color;if(!o)w.lineColor=k.color;c.hasOwnProperty(\"color\")&&!c.color&&delete c.color;if(i&&!e.fillColor)f.fillColor=i;m[\"\"]=a.convertAttribs(x(w,c),l[\"\"]);m.hover=a.convertAttribs(d.hover,l.hover,m[\"\"]);m.select=a.convertAttribs(d.select,l.select,m[\"\"])}else m=l;k.pointAttr=m}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\\/533/.test(Ba),d,e=a.data||[],f,g,h;H(a,\"destroy\");Y(a);q(a.axisTypes||[],function(b){if(h=a[b])ra(h.series,a),\nh.isDirty=h.forceRedraw=!0});a.legendItem&&a.chart.legend.destroyItem(a);for(d=e.length;d--;)(f=e[d])&&f.destroy&&f.destroy();a.points=null;clearTimeout(a.animationTimeout);for(g in a)a[g]instanceof J&&!a[g].survive&&(d=c&&g===\"group\"?\"hide\":\"destroy\",a[g][d]());if(b.hoverSeries===a)b.hoverSeries=null;ra(b.series,a);for(g in a)delete a[g]},getGraphPath:function(a,b,c){var d=this,e=d.options,f=e.step,g,h=[],i=[],j,a=a||d.points;(g=a.reversed)&&a.reverse();(f={right:1,center:2}[f]||f&&3)&&g&&(f=4-f);\ne.connectNulls&&!b&&!c&&(a=this.getValidPoints(a));q(a,function(g,l){var m=g.plotX,n=g.plotY,o=a[l-1];if((g.leftCliff||o&&o.rightCliff)&&!c)j=!0;g.isNull&&!s(b)&&l>0?j=!e.connectNulls:g.isNull&&!b?j=!0:(l===0||j?o=[X,g.plotX,g.plotY]:d.getPointSpline?o=d.getPointSpline(a,g,l):f?(o=f===1?[S,o.plotX,n]:f===2?[S,(o.plotX+m)/2,o.plotY,S,(o.plotX+m)/2,n]:[S,m,o.plotY],o.push(S,m,n)):o=[S,m,n],i.push(g.x),f&&i.push(g.x),h.push.apply(h,o),j=!1)});h.xMap=i;return d.graphPath=h},drawGraph:function(){var a=\nthis,b=this.options,c=[[\"graph\",b.lineColor||this.color,b.dashStyle]],d=b.lineWidth,e=b.linecap!==\"square\",f=(this.gappedPath||this.getGraphPath).call(this);q(this.zones,function(d,e){c.push([\"zoneGraph\"+e,d.color||a.color,d.dashStyle||b.dashStyle])});q(c,function(c,h){var i=c[0],j=a[i];if(j)j.endX=f.xMap,j.animate({d:f});else if(d&&f.length)j={stroke:c[1],\"stroke-width\":d,fill:\"none\",zIndex:1},c[2]?j.dashstyle=c[2]:e&&(j[\"stroke-linecap\"]=j[\"stroke-linejoin\"]=\"round\"),j=a[i]=a.chart.renderer.path(f).attr(j).add(a.group).shadow(h<\n2&&b.shadow);if(j)j.startX=f.xMap,j.isArea=f.isArea})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,e,f,g=this.clips||[],h,i=this.graph,j=this.area,k=t(b.chartWidth,b.chartHeight),l=this[(this.zoneAxis||\"y\")+\"Axis\"],m,n,o=b.inverted,A,r,s,w,v=!1;if(d.length&&(i||j)&&l&&l.min!==z)n=l.reversed,A=l.horiz,i&&i.hide(),j&&j.hide(),m=l.getExtremes(),q(d,function(d,q){e=n?A?b.plotWidth:0:A?0:l.toPixels(m.min);e=F(t(p(f,e),0),k);f=F(t(C(l.toPixels(p(d.value,m.max),!0)),0),k);v&&\n(e=f=l.toPixels(m.max));r=Math.abs(e-f);s=F(e,f);w=t(e,f);if(l.isXAxis){if(h={x:o?w:s,y:0,width:r,height:k},!A)h.x=b.plotHeight-h.x}else if(h={x:0,y:o?w:s,width:k,height:r},A)h.y=b.plotWidth-h.y;o&&c.isVML&&(h=l.isXAxis?{x:0,y:n?s:w,height:h.width,width:b.chartWidth}:{x:h.y-b.plotLeft-b.spacingBox.x,y:0,width:h.height,height:b.chartHeight});g[q]?g[q].animate(h):(g[q]=c.clipRect(h),i&&a[\"zoneGraph\"+q].clip(g[q]),j&&a[\"zoneArea\"+q].clip(g[q]));v=d.value>m.max}),this.clips=g},invertGroups:function(){function a(){var a=\n{width:b.yAxis.len,height:b.xAxis.len};q([\"group\",\"markerGroup\"],function(c){b[c]&&b[c].attr(a).invert()})}var b=this,c=b.chart;if(b.xAxis)N(c,\"resize\",a),N(b,\"destroy\",function(){Y(c,\"resize\",a)}),a(),b.invertGroups=a},plotGroup:function(a,b,c,d,e){var f=this[a],g=!f;g&&(this[a]=f=this.chart.renderer.g(b).attr({zIndex:d||0.1}).add(e),f.addClass(\"highcharts-series-\"+this.index));f.attr({visibility:c})[g?\"attr\":\"animate\"](this.getPlotBox());return f},getPlotBox:function(){var a=this.chart,b=this.xAxis,\nc=this.yAxis;if(a.inverted)b=c,c=this.xAxis;return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,d=a.options,e=!!a.animate&&b.renderer.isSVG&&Wa(d.animation).duration,f=a.visible?\"inherit\":\"hidden\",g=d.zIndex,h=a.hasRendered,i=b.seriesGroup;c=a.plotGroup(\"group\",\"series\",f,g,i);a.markerGroup=a.plotGroup(\"markerGroup\",\"markers\",f,g,i);e&&a.animate(!0);a.getAttribs();c.inverted=a.isCartesian?b.inverted:!1;a.drawGraph&&(a.drawGraph(),\na.applyZones());q(a.points,function(a){a.redraw&&a.redraw()});a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&a.options.enableMouseTracking!==!1&&a.drawTracker();b.inverted&&a.invertGroups();d.clip!==!1&&!a.sharedClipKey&&!h&&c.clip(b.clipRect);e&&a.animate();if(!h)a.animationTimeout=Sa(function(){a.afterAnimate()},e);a.isDirty=a.isDirtyData=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,e=this.yAxis;\nc&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:p(d&&d.left,a.plotLeft),translateY:p(e&&e.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdDimensions:1,kdAxisArray:[\"clientX\",\"plotY\"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:e?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,e,f){var g,h;if(h=c&&\nc.length)return g=b.kdAxisArray[e%f],c.sort(function(a,b){return a[g]-b[g]}),h=Math.floor(h/2),{point:c[h],left:a(c.slice(0,h),e+1,f),right:a(c.slice(h+1),e+1,f)}}var b=this,c=b.kdDimensions;delete b.kdTree;Sa(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c)},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,j,k){var l=b.point,m=d.kdAxisArray[j%k],n,o,p=l;o=s(a[e])&&s(l[e])?Math.pow(a[e]-l[e],2):null;n=s(a[f])&&s(l[f])?Math.pow(a[f]-l[f],2):null;n=(o||0)+(n||0);l.dist=\ns(n)?Math.sqrt(n):Number.MAX_VALUE;l.distX=s(o)?Math.sqrt(o):Number.MAX_VALUE;m=a[m]-l[m];n=m<0?\"left\":\"right\";o=m<0?\"right\":\"left\";b[n]&&(n=c(a,b[n],j+1,k),p=n[g]<p[g]?n:l);b[o]&&Math.sqrt(m*m)<p[g]&&(a=c(a,b[o],j+1,k),p=a[g]<p[g]?a:p);return p}var d=this,e=this.kdAxisArray[0],f=this.kdAxisArray[1],g=b?\"distX\":\"dist\";this.kdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,this.kdDimensions,this.kdDimensions)}};Mb.prototype={destroy:function(){Ua(this,this.axis)},render:function(a){var b=\nthis.options,c=b.format,c=c?Na(c,this):b.formatter.call(this);this.label?this.label.attr({text:c,visibility:\"hidden\"}):this.label=this.axis.chart.renderer.text(c,null,null,b.useHTML).css(b.style).attr({align:this.textAlign,rotation:b.rotation,visibility:\"hidden\"}).add(a)},setOffset:function(a,b){var c=this.axis,d=c.chart,e=d.inverted,f=c.reversed,f=this.isNegative&&!f||!this.isNegative&&f,g=c.translate(c.usePercentage?100:this.total,0,0,0,1),c=c.translate(0),c=Q(g-c),h=d.xAxis[0].translate(this.x)+\na,i=d.plotHeight,f={x:e?f?g:g-c:h,y:e?i-h-b:f?i-g-c:i-g,width:e?c:b,height:e?b:c};if(e=this.label)e.align(this.alignOptions,null,f),f=e.alignAttr,e[this.options.crop===!1||d.isInsidePlot(f.x,f.y)?\"show\":\"hide\"](!0)}};jb.prototype.getStacks=function(){var a=this;q(a.yAxis,function(a){if(a.stacks&&a.hasVisibleSeries)a.oldStacks=a.stacks});q(a.series,function(b){if(b.options.stacking&&(b.visible===!0||a.options.chart.ignoreHiddenSeries===!1))b.stackKey=b.type+p(b.options.stack,\"\")})};ia.prototype.buildStacks=\nfunction(){var a=this.series,b,c=p(this.options.reversedStacks,!0),d=a.length,e;if(!this.isXAxis){this.usePercentage=!1;for(e=d;e--;)a[c?e:d-e-1].setStackedPoints();for(e=d;e--;)b=a[c?e:d-e-1],b.setStackCliffs&&b.setStackCliffs();if(this.usePercentage)for(e=0;e<d;e++)a[e].setPercentStacks()}};ia.prototype.renderStackTotals=function(){var a=this.chart,b=a.renderer,c=this.stacks,d,e,f=this.stackTotalGroup;if(!f)this.stackTotalGroup=f=b.g(\"stack-labels\").attr({visibility:\"visible\",zIndex:6}).add();f.translate(a.plotLeft,\na.plotTop);for(d in c)for(e in a=c[d],a)a[e].render(f)};ia.prototype.resetStacks=function(){var a=this.stacks,b,c;if(!this.isXAxis)for(b in a)for(c in a[b])a[b][c].touched<this.stacksTouched?(a[b][c].destroy(),delete a[b][c]):(a[b][c].total=null,a[b][c].cum=0)};ia.prototype.cleanStacks=function(){var a,b,c;if(!this.isXAxis){if(this.oldStacks)a=this.stacks=this.oldStacks;for(b in a)for(c in a[b])a[b][c].cum=a[b][c].total}};R.prototype.setStackedPoints=function(){if(this.options.stacking&&!(this.visible!==\n!0&&this.chart.options.chart.ignoreHiddenSeries!==!1)){var a=this.processedXData,b=this.processedYData,c=[],d=b.length,e=this.options,f=e.threshold,g=e.startFromThreshold?f:0,h=e.stack,e=e.stacking,i=this.stackKey,j=\"-\"+i,k=this.negStacks,l=this.yAxis,m=l.stacks,n=l.oldStacks,o,q,r,x,w,v,u;l.stacksTouched+=1;for(w=0;w<d;w++){v=a[w];u=b[w];o=this.getStackIndicator(o,v,this.index);x=o.key;r=(q=k&&u<(g?0:f))?j:i;m[r]||(m[r]={});if(!m[r][v])n[r]&&n[r][v]?(m[r][v]=n[r][v],m[r][v].total=null):m[r][v]=new Mb(l,\nl.options.stackLabels,q,v,h);r=m[r][v];if(u!==null){r.points[x]=r.points[this.index]=[p(r.cum,g)];if(!s(r.cum))r.base=x;r.touched=l.stacksTouched;o.index>0&&this.singleStacks===!1&&(r.points[x][0]=r.points[this.index+\",\"+v+\",0\"][0])}e===\"percent\"?(q=q?i:j,k&&m[q]&&m[q][v]?(q=m[q][v],r.total=q.total=t(q.total,r.total)+Q(u)||0):r.total=$(r.total+(Q(u)||0))):r.total=$(r.total+(u||0));r.cum=p(r.cum,g)+(u||0);if(u!==null)r.points[x].push(r.cum),c[w]=r.cum}if(e===\"percent\")l.usePercentage=!0;this.stackedYData=\nc;l.oldStacks={}}};R.prototype.setPercentStacks=function(){var a=this,b=a.stackKey,c=a.yAxis.stacks,d=a.processedXData,e;q([b,\"-\"+b],function(b){var f;for(var g=d.length,h,i;g--;)if(h=d[g],e=a.getStackIndicator(e,h,a.index),f=(i=c[b]&&c[b][h])&&i.points[e.key],h=f)i=i.total?100/i.total:0,h[0]=$(h[0]*i),h[1]=$(h[1]*i),a.stackedYData[g]=h[1]})};R.prototype.getStackIndicator=function(a,b,c){!s(a)||a.x!==b?a={x:b,index:0}:a.index++;a.key=[c,b,a.index].join(\",\");return a};x(jb.prototype,{addSeries:function(a,\nb,c){var d,e=this;a&&(b=p(b,!0),H(e,\"addSeries\",{options:a},function(){d=e.initSeries(a);e.isDirtyLegend=!0;e.linkSeries();b&&e.redraw(c)}));return d},addAxis:function(a,b,c,d){var e=b?\"xAxis\":\"yAxis\",f=this.options,a=E(a,{index:this[e].length,isX:b});new ia(this,a);f[e]=ua(f[e]||{});f[e].push(a);p(c,!0)&&this.redraw(d)},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,e=c.loading,f=function(){d&&M(d,{left:b.plotLeft+\"px\",top:b.plotTop+\"px\",width:b.plotWidth+\"px\",height:b.plotHeight+\n\"px\"})};if(!d)b.loadingDiv=d=ca(Pa,{className:\"highcharts-loading\"},x(e.style,{zIndex:10,display:\"none\"}),b.container),b.loadingSpan=ca(\"span\",null,e.labelStyle,d),N(b,\"redraw\",f);b.loadingSpan.innerHTML=a||c.lang.loading;if(!b.loadingShown)M(d,{opacity:0,display:\"\"}),Za(d,{opacity:e.style.opacity},{duration:e.showDuration||0}),b.loadingShown=!0;f()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&Za(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){M(b,{display:\"none\"})}});\nthis.loadingShown=!1}});x(Ma.prototype,{update:function(a,b,c,d){function e(){f.applyOptions(a);if(f.y===null&&h)f.graphic=h.destroy();if(ba(a,!0))f.redraw=function(){if(h&&h.element&&a&&a.marker&&a.marker.symbol)f.graphic=h.destroy();if(a&&a.dataLabels&&f.dataLabel)f.dataLabel=f.dataLabel.destroy();f.redraw=null};i=f.index;g.updateParallelArrays(f,i);k.data[i]=ba(k.data[i],!0)?f.options:a;g.isDirty=g.isDirtyData=!0;if(!g.fixedBox&&g.hasCartesianSeries)j.isDirtyBox=!0;if(k.legendType===\"point\")j.isDirtyLegend=\n!0;b&&j.redraw(c)}var f=this,g=f.series,h=f.graphic,i,j=g.chart,k=g.options,b=p(b,!0);d===!1?e():f.firePointEvent(\"update\",{options:a},e)},remove:function(a,b){this.series.removePoint(pa(this,this.series.data),a,b)}});x(R.prototype,{addPoint:function(a,b,c,d){var e=this.options,f=this.data,g=this.chart,h=this.xAxis&&this.xAxis.names,i=e.data,j,k,l=this.xData,m,n,b=p(b,!0);j={series:this};this.pointClass.prototype.applyOptions.apply(j,[a]);n=j.x;m=l.length;if(this.requireSorting&&n<l[m-1])for(k=!0;m&&\nl[m-1]>n;)m--;this.updateParallelArrays(j,\"splice\",m,0,0);this.updateParallelArrays(j,m);if(h&&j.name)h[n]=j.name;i.splice(m,0,a);k&&(this.data.splice(m,0,null),this.processData());e.legendType===\"point\"&&this.generatePoints();c&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(j,\"shift\"),i.shift()));this.isDirtyData=this.isDirty=!0;b&&(this.getAttribs(),g.redraw(d))},removePoint:function(a,b,c){var d=this,e=d.data,f=e[a],g=d.points,h=d.chart,i=function(){g&&g.length===e.length&&\ng.splice(a,1);e.splice(a,1);d.options.data.splice(a,1);d.updateParallelArrays(f||{series:d},\"splice\",a,1);f&&f.destroy();d.isDirty=!0;d.isDirtyData=!0;b&&h.redraw()};cb(c,h);b=p(b,!0);f?f.firePointEvent(\"remove\",null,i):i()},remove:function(a,b,c){function d(){e.destroy();f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();p(a,!0)&&f.redraw(b)}var e=this,f=e.chart;c!==!1?H(e,\"remove\",null,d):d()},update:function(a,b){var c=this,d=this.chart,e=this.userOptions,f=this.type,g=L[f].prototype,h=[\"group\",\"markerGroup\",\n\"dataLabelsGroup\"],i;if(a.type&&a.type!==f||a.zIndex!==void 0)h.length=0;q(h,function(a){h[a]=c[a];delete c[a]});a=E(e,{animation:!1,index:this.index,pointStart:this.xData[0]},{data:this.options.data},a);this.remove(!1,null,!1);for(i in g)this[i]=z;x(this,L[a.type||f].prototype);q(h,function(a){c[a]=h[a]});this.init(d,a);d.linkSeries();p(b,!0)&&d.redraw(!1)}});x(ia.prototype,{update:function(a,b){var c=this.chart,a=c.options[this.coll][this.options.index]=E(this.userOptions,a);this.destroy(!0);this.init(c,\nx(a,{events:z}));c.isDirtyBox=!0;p(b,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,d=this.series,e=d.length;e--;)d[e]&&d[e].remove(!1);ra(b.axes,this);ra(b[c],this);b.options[c].splice(this.options.index,1);q(b[c],function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;p(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}});var xa=sa(R);L.line=xa;ga.area=E(ha,{softThreshold:!1,threshold:0});\nvar qa=sa(R,{type:\"area\",singleStacks:!1,getStackPoints:function(){var a=[],b=[],c=this.xAxis,d=this.yAxis,e=d.stacks[this.stackKey],f={},g=this.points,h=this.index,i=d.series,j=i.length,k,l=p(d.options.reversedStacks,!0)?1:-1,m,n;if(this.options.stacking){for(m=0;m<g.length;m++)f[g[m].x]=g[m];for(n in e)e[n].total!==null&&b.push(n);b.sort(function(a,b){return a-b});k=Ea(i,function(){return this.visible});q(b,function(g,i){var n=0,p,s;if(f[g]&&!f[g].isNull)a.push(f[g]),q([-1,1],function(a){var c=\na===1?\"rightNull\":\"leftNull\",d=0,n=e[b[i+a]];if(n)for(m=h;m>=0&&m<j;)p=n.points[m],p||(m===h?f[g][c]=!0:k[m]&&(s=e[g].points[m])&&(d-=s[1]-s[0])),m+=l;f[g][a===1?\"rightCliff\":\"leftCliff\"]=d});else{for(m=h;m>=0&&m<j;){if(p=e[g].points[m]){n=p[1];break}m+=l}n=d.toPixels(n,!0);a.push({isNull:!0,plotX:c.toPixels(g,!0),plotY:n,yBottom:n})}})}return a},getGraphPath:function(a){var b=R.prototype.getGraphPath,c=this.options,d=c.stacking,e=this.yAxis,f,g,h=[],i=[],j=this.index,k,l=e.stacks[this.stackKey],\nm=c.threshold,n=e.getThreshold(c.threshold),o,c=c.connectNulls||d===\"percent\",q=function(b,c,f){var g=a[b],b=d&&l[g.x].points[j],o=g[f+\"Null\"]||0,f=g[f+\"Cliff\"]||0,p,q,g=!0;f||o?(p=(o?b[0]:b[1])+f,q=b[0]+f,g=!!o):!d&&a[c]&&a[c].isNull&&(p=q=m);p!==void 0&&(i.push({plotX:k,plotY:p===null?n:e.getThreshold(p),isNull:g}),h.push({plotX:k,plotY:q===null?n:e.getThreshold(q),doCurve:!1}))},a=a||this.points;d&&(a=this.getStackPoints());for(f=0;f<a.length;f++)if(g=a[f].isNull,k=p(a[f].rectPlotX,a[f].plotX),\no=p(a[f].yBottom,n),!g||c){c||q(f,f-1,\"left\");if(!g||d||!c)i.push(a[f]),h.push({x:f,plotX:k,plotY:o});c||q(f,f+1,\"right\")}f=b.call(this,i,!0,!0);h.reversed=!0;g=b.call(this,h,!0,!0);g.length&&(g[0]=S);g=f.concat(g);b=b.call(this,i,!1,c);g.xMap=f.xMap;this.areaPath=g;return b},drawGraph:function(){this.areaPath=[];R.prototype.drawGraph.apply(this);var a=this,b=this.areaPath,c=this.options,d=[[\"area\",this.color,c.fillColor]];q(this.zones,function(b,f){d.push([\"zoneArea\"+f,b.color||a.color,b.fillColor||\nc.fillColor])});q(d,function(d){var f=d[0],g=a[f];g?(g.endX=b.xMap,g.animate({d:b})):(g={fill:d[2]||d[1],zIndex:0},d[2]||(g[\"fill-opacity\"]=p(c.fillOpacity,0.75)),g=a[f]=a.chart.renderer.path(b).attr(g).add(a.group),g.isArea=!0);g.startX=b.xMap;g.shiftUnit=c.step?2:1})},drawLegendSymbol:P.drawRectangle});L.area=qa;ga.spline=E(ha);xa=sa(R,{type:\"spline\",getPointSpline:function(a,b,c){var d=b.plotX,e=b.plotY,f=a[c-1],c=a[c+1],g,h,i,j;if(f&&!f.isNull&&f.doCurve!==!1&&c&&!c.isNull&&c.doCurve!==!1){a=\nf.plotY;i=c.plotX;var c=c.plotY,k=0;g=(1.5*d+f.plotX)/2.5;h=(1.5*e+a)/2.5;i=(1.5*d+i)/2.5;j=(1.5*e+c)/2.5;i!==g&&(k=(j-h)*(i-d)/(i-g)+e-j);h+=k;j+=k;h>a&&h>e?(h=t(a,e),j=2*e-h):h<a&&h<e&&(h=F(a,e),j=2*e-h);j>c&&j>e?(j=t(c,e),h=2*e-j):j<c&&j<e&&(j=F(c,e),h=2*e-j);b.rightContX=i;b.rightContY=j}b=[\"C\",p(f.rightContX,f.plotX),p(f.rightContY,f.plotY),p(g,d),p(h,e),d,e];f.rightContX=f.rightContY=null;return b}});L.spline=xa;ga.areaspline=E(ga.area);qa=qa.prototype;xa=sa(xa,{type:\"areaspline\",getStackPoints:qa.getStackPoints,\ngetGraphPath:qa.getGraphPath,setStackCliffs:qa.setStackCliffs,drawGraph:qa.drawGraph,drawLegendSymbol:P.drawRectangle});L.areaspline=xa;ga.column=E(ha,{borderColor:\"#FFFFFF\",borderRadius:0,groupPadding:0.2,marker:null,pointPadding:0.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{brightness:0.1,shadow:!1,halo:!1},select:{color:\"#C0C0C0\",borderColor:\"#000000\",shadow:!1}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},\nthreshold:0});xa=sa(R,{type:\"column\",pointAttrToOptions:{stroke:\"borderColor\",fill:\"color\",r:\"borderRadius\"},cropShoulder:0,directTouch:!0,trackerGroups:[\"group\",\"dataLabelsGroup\"],negStacks:!0,init:function(){R.prototype.init.apply(this,arguments);var a=this,b=a.chart;b.hasRendered&&q(b.series,function(b){if(b.type===a.type)b.isDirty=!0})},getColumnMetrics:function(){var a=this,b=a.options,c=a.xAxis,d=a.yAxis,e=c.reversed,f,g={},h=0;b.grouping===!1?h=1:q(a.chart.series,function(b){var c=b.options,\ne=b.yAxis,i;if(b.type===a.type&&b.visible&&d.len===e.len&&d.pos===e.pos)c.stacking?(f=b.stackKey,g[f]===z&&(g[f]=h++),i=g[f]):c.grouping!==!1&&(i=h++),b.columnIndex=i});var i=F(Q(c.transA)*(c.ordinalSlope||b.pointRange||c.closestPointRange||c.tickInterval||1),c.len),j=i*b.groupPadding,k=(i-2*j)/h,b=F(b.maxPointWidth||c.len,p(b.pointWidth,k*(1-2*b.pointPadding)));a.columnMetrics={width:b,offset:(k-b)/2+(j+((a.columnIndex||0)+(e?1:0))*k-i/2)*(e?-1:1)};return a.columnMetrics},crispCol:function(a,b,c,\nd){var e=this.chart,f=this.borderWidth,g=-(f%2?0.5:0),f=f%2?0.5:1;e.inverted&&e.renderer.isVML&&(f+=1);c=Math.round(a+c)+g;a=Math.round(a)+g;c-=a;d=Math.round(b+d)+f;g=Q(b)<=0.5&&d>0.5;b=Math.round(b)+f;d-=b;g&&d&&(b-=1,d+=1);return{x:a,y:b,width:c,height:d}},translate:function(){var a=this,b=a.chart,c=a.options,d=a.borderWidth=p(c.borderWidth,a.closestPointRange*a.xAxis.transA<2?0:1),e=a.yAxis,f=a.translatedThreshold=e.getThreshold(c.threshold),g=p(c.minPointLength,5),h=a.getColumnMetrics(),i=h.width,\nj=a.barW=t(i,1+2*d),k=a.pointXOffset=h.offset;b.inverted&&(f-=0.5);c.pointPadding&&(j=va(j));R.prototype.translate.apply(a);q(a.points,function(c){var d=F(p(c.yBottom,f),9E4),h=999+Q(d),h=F(t(-h,c.plotY),e.len+h),o=c.plotX+k,q=j,r=F(h,d),s,w=t(h,d)-r;Q(w)<g&&g&&(w=g,s=!e.reversed&&!c.negative||e.reversed&&c.negative,r=Q(r-f)>g?d-g:f-(s?g:0));c.barX=o;c.pointWidth=i;c.tooltipPos=b.inverted?[e.len+e.pos-b.plotLeft-h,a.xAxis.len-o-q/2,w]:[o+q/2,h+e.pos-b.plotTop,w];c.shapeType=\"rect\";c.shapeArgs=a.crispCol.apply(a,\nc.isNull?[c.plotX,e.len/2,0,0]:[o,r,q,w])})},getSymbol:Ca,drawLegendSymbol:P.drawRectangle,drawGraph:Ca,drawPoints:function(){var a=this,b=this.chart,c=a.options,d=b.renderer,e=c.animationLimit||250,f,g;q(a.points,function(h){var i=h.graphic,j;if(I(h.plotY)&&h.y!==null)f=h.shapeArgs,j=s(a.borderWidth)?{\"stroke-width\":a.borderWidth}:{},g=h.pointAttr[h.selected?\"select\":\"\"]||a.pointAttr[\"\"],i?(Ka(i),i.attr(j).attr(g)[b.pointCount<e?\"animate\":\"attr\"](E(f))):h.graphic=d[h.shapeType](f).attr(j).attr(g).add(h.group||\na.group).shadow(c.shadow,null,c.stacking&&!c.borderRadius);else if(i)h.graphic=i.destroy()})},animate:function(a){var b=this,c=this.yAxis,d=b.options,e=this.chart.inverted,f={};if(fa)a?(f.scaleY=0.001,a=F(c.pos+c.len,t(c.pos,c.toPixels(d.threshold))),e?f.translateX=a-c.len:f.translateY=a,b.group.attr(f)):(f[e?\"translateX\":\"translateY\"]=c.pos,b.group.animate(f,x(Wa(b.options.animation),{step:function(a,c){b.group.attr({scaleY:t(0.001,c.pos)})}})),b.animate=null)},remove:function(){var a=this,b=a.chart;\nb.hasRendered&&q(b.series,function(b){if(b.type===a.type)b.isDirty=!0});R.prototype.remove.apply(a,arguments)}});L.column=xa;ga.bar=E(ga.column);qa=sa(xa,{type:\"bar\",inverted:!0});L.bar=qa;ga.scatter=E(ha,{lineWidth:0,marker:{enabled:!0},tooltip:{headerFormat:'<span style=\"color:{point.color}\">\\u25cf</span> <span style=\"font-size: 10px;\"> {series.name}</span><br/>',pointFormat:\"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>\"}});qa=sa(R,{type:\"scatter\",sorted:!1,requireSorting:!1,noSharedTooltip:!0,\ntrackerGroups:[\"group\",\"markerGroup\",\"dataLabelsGroup\"],takeOrdinalPosition:!1,kdDimensions:2,drawGraph:function(){this.options.lineWidth&&R.prototype.drawGraph.call(this)}});L.scatter=qa;ga.pie=E(ha,{borderColor:\"#FFFFFF\",borderWidth:1,center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return this.y===null?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:\"point\",marker:null,size:null,showInLegend:!1,slicedOffset:10,states:{hover:{brightness:0.1,\nshadow:!1}},stickyTracking:!1,tooltip:{followPointer:!0}});ha={type:\"pie\",isCartesian:!1,pointClass:sa(Ma,{init:function(){Ma.prototype.init.apply(this,arguments);var a=this,b;a.name=p(a.name,\"Slice\");b=function(b){a.slice(b.type===\"select\")};N(a,\"select\",b);N(a,\"unselect\",b);return a},setVisible:function(a,b){var c=this,d=c.series,e=d.chart,f=d.options.ignoreHiddenPoint,b=p(b,f);if(a!==c.visible){c.visible=c.options.visible=a=a===z?!c.visible:a;d.options.data[pa(c,d.data)]=c.options;q([\"graphic\",\n\"dataLabel\",\"connector\",\"shadowGroup\"],function(b){if(c[b])c[b][a?\"show\":\"hide\"](!0)});c.legendItem&&e.legend.colorizeItem(c,a);!a&&c.state===\"hover\"&&c.setState(\"\");if(f)d.isDirty=!0;b&&e.redraw()}},slice:function(a,b,c){var d=this.series;cb(c,d.chart);p(b,!0);this.sliced=this.options.sliced=a=s(a)?a:!this.sliced;d.options.data[pa(this,d.data)]=this.options;a=a?this.slicedTranslation:{translateX:0,translateY:0};this.graphic.animate(a);this.shadowGroup&&this.shadowGroup.animate(a)},haloPath:function(a){var b=\nthis.shapeArgs,c=this.series.chart;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.plotLeft+b.x,c.plotTop+b.y,b.r+a,b.r+a,{innerR:this.shapeArgs.r,start:b.start,end:b.end})}}),requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:[\"group\",\"dataLabelsGroup\"],axisTypes:[],pointAttrToOptions:{stroke:\"borderColor\",\"stroke-width\":\"borderWidth\",fill:\"color\"},animate:function(a){var b=this,c=b.points,d=b.startAngleRad;if(!a)q(c,function(a){var c=a.graphic,g=a.shapeArgs;\nc&&(c.attr({r:a.startR||b.center[3]/2,start:d,end:d}),c.animate({r:g.r,start:g.start,end:g.end},b.options.animation))}),b.animate=null},updateTotals:function(){var a,b=0,c=this.points,d=c.length,e,f=this.options.ignoreHiddenPoint;for(a=0;a<d;a++){e=c[a];if(e.y<0)e.y=null;b+=f&&!e.visible?0:e.y}this.total=b;for(a=0;a<d;a++)e=c[a],e.percentage=b>0&&(e.visible||!f)?e.y/b*100:0,e.total=b},generatePoints:function(){R.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();\nvar b=0,c=this.options,d=c.slicedOffset,e=d+c.borderWidth,f,g,h,i=c.startAngle||0,j=this.startAngleRad=ta/180*(i-90),i=(this.endAngleRad=ta/180*(p(c.endAngle,i+360)-90))-j,k=this.points,l=c.dataLabels.distance,c=c.ignoreHiddenPoint,m,n=k.length,o;if(!a)this.center=a=this.getCenter();this.getX=function(b,c){h=Z.asin(F((b-a[1])/(a[2]/2+l),1));return a[0]+(c?-1:1)*W(h)*(a[2]/2+l)};for(m=0;m<n;m++){o=k[m];f=j+b*i;if(!c||o.visible)b+=o.percentage/100;g=j+b*i;o.shapeType=\"arc\";o.shapeArgs={x:a[0],y:a[1],\nr:a[2]/2,innerR:a[3]/2,start:C(f*1E3)/1E3,end:C(g*1E3)/1E3};h=(g+f)/2;h>1.5*ta?h-=2*ta:h<-ta/2&&(h+=2*ta);o.slicedTranslation={translateX:C(W(h)*d),translateY:C(da(h)*d)};f=W(h)*a[2]/2;g=da(h)*a[2]/2;o.tooltipPos=[a[0]+f*0.7,a[1]+g*0.7];o.half=h<-ta/2||h>ta/2?1:0;o.angle=h;e=F(e,l/2);o.labelPos=[a[0]+f+W(h)*l,a[1]+g+da(h)*l,a[0]+f+W(h)*e,a[1]+g+da(h)*e,a[0]+f,a[1]+g,l<0?\"center\":o.half?\"right\":\"left\",h]}},drawGraph:null,drawPoints:function(){var a=this,b=a.chart.renderer,c,d,e=a.options.shadow,f,\ng,h,i;if(e&&!a.shadowGroup)a.shadowGroup=b.g(\"shadow\").add(a.group);q(a.points,function(j){if(j.y!==null){d=j.graphic;h=j.shapeArgs;f=j.shadowGroup;g=j.pointAttr[j.selected?\"select\":\"\"];if(!g.stroke)g.stroke=g.fill;if(e&&!f)f=j.shadowGroup=b.g(\"shadow\").add(a.shadowGroup);c=j.sliced?j.slicedTranslation:{translateX:0,translateY:0};f&&f.attr(c);if(d)d.setRadialReference(a.center).attr(g).animate(x(h,c));else{i={\"stroke-linejoin\":\"round\"};if(!j.visible)i.visibility=\"hidden\";j.graphic=d=b[j.shapeType](h).setRadialReference(a.center).attr(g).attr(i).attr(c).add(a.group).shadow(e,\nf)}}})},searchPoint:Ca,sortByAngle:function(a,b){a.sort(function(a,d){return a.angle!==void 0&&(d.angle-a.angle)*b})},drawLegendSymbol:P.drawRectangle,getCenter:Eb.getCenter,getSymbol:Ca};ha=sa(R,ha);L.pie=ha;R.prototype.drawDataLabels=function(){var a=this,b=a.options,c=b.cursor,d=b.dataLabels,e=a.points,f,g,h=a.hasRendered||0,i,j,k=p(d.defer,!0),l=a.chart.renderer;if(d.enabled||a._hasPointLabels)a.dlProcessOptions&&a.dlProcessOptions(d),j=a.plotGroup(\"dataLabelsGroup\",\"data-labels\",k&&!h?\"hidden\":\n\"visible\",d.zIndex||6),k&&(j.attr({opacity:+h}),h||N(a,\"afterAnimate\",function(){a.visible&&j.show(!0);j[b.animation?\"animate\":\"attr\"]({opacity:1},{duration:200})})),g=d,q(e,function(e){var h,k=e.dataLabel,q,r,t=e.connector,w=!0,v,u={};f=e.dlOptions||e.options&&e.options.dataLabels;h=p(f&&f.enabled,g.enabled)&&e.y!==null;if(k&&!h)e.dataLabel=k.destroy();else if(h){d=E(g,f);v=d.style;h=d.rotation;q=e.getLabelConfig();i=d.format?Na(d.format,q):d.formatter.call(q,d);v.color=p(d.color,v.color,a.color,\n\"black\");if(k)if(s(i))k.attr({text:i}),w=!1;else{if(e.dataLabel=k=k.destroy(),t)e.connector=t.destroy()}else if(s(i)){k={fill:d.backgroundColor,stroke:d.borderColor,\"stroke-width\":d.borderWidth,r:d.borderRadius||0,rotation:h,padding:d.padding,zIndex:1};if(v.color===\"contrast\")u.color=d.inside||d.distance<0||b.stacking?l.getContrast(e.color||a.color):\"#000000\";if(c)u.cursor=c;for(r in k)k[r]===z&&delete k[r];k=e.dataLabel=l[h?\"text\":\"label\"](i,0,-9999,d.shape,null,null,d.useHTML).attr(k).css(x(v,u)).add(j).shadow(d.shadow)}k&&\na.alignDataLabel(e,k,d,null,w)}})};R.prototype.alignDataLabel=function(a,b,c,d,e){var f=this.chart,g=f.inverted,h=p(a.plotX,-9999),i=p(a.plotY,-9999),j=b.getBBox(),k=f.renderer.fontMetrics(c.style.fontSize).b,l=c.rotation,m=c.align,n=this.visible&&(a.series.forceDL||f.isInsidePlot(h,C(i),g)||d&&f.isInsidePlot(h,g?d.x+1:d.y+d.height-1,g)),o=p(c.overflow,\"justify\")===\"justify\";if(n)d=x({x:g?f.plotWidth-i:h,y:C(g?f.plotHeight-h:i),width:0,height:0},d),x(c,{width:j.width,height:j.height}),l?(o=!1,g=f.renderer.rotCorr(k,\nl),g={x:d.x+c.x+d.width/2+g.x,y:d.y+c.y+{top:0,middle:0.5,bottom:1}[c.verticalAlign]*d.height},b[e?\"attr\":\"animate\"](g).attr({align:m}),h=(l+720)%360,h=h>180&&h<360,m===\"left\"?g.y-=h?j.height:0:m===\"center\"?(g.x-=j.width/2,g.y-=j.height/2):m===\"right\"&&(g.x-=j.width,g.y-=h?0:j.height)):(b.align(c,null,d),g=b.alignAttr),o?this.justifyDataLabel(b,c,g,j,d,e):p(c.crop,!0)&&(n=f.isInsidePlot(g.x,g.y)&&f.isInsidePlot(g.x+j.width,g.y+j.height)),c.shape&&!l&&b.attr({anchorX:a.plotX,anchorY:a.plotY});if(!n)Ka(b),\nb.attr({y:-9999}),b.placed=!1};R.prototype.justifyDataLabel=function(a,b,c,d,e,f){var g=this.chart,h=b.align,i=b.verticalAlign,j,k,l=a.box?0:a.padding||0;j=c.x+l;if(j<0)h===\"right\"?b.align=\"left\":b.x=-j,k=!0;j=c.x+d.width-l;if(j>g.plotWidth)h===\"left\"?b.align=\"right\":b.x=g.plotWidth-j,k=!0;j=c.y+l;if(j<0)i===\"bottom\"?b.verticalAlign=\"top\":b.y=-j,k=!0;j=c.y+d.height-l;if(j>g.plotHeight)i===\"top\"?b.verticalAlign=\"bottom\":b.y=g.plotHeight-j,k=!0;if(k)a.placed=!f,a.align(b,null,e)};if(L.pie)L.pie.prototype.drawDataLabels=\nfunction(){var a=this,b=a.data,c,d=a.chart,e=a.options.dataLabels,f=p(e.connectorPadding,10),g=p(e.connectorWidth,1),h=d.plotWidth,i=d.plotHeight,j,k,l=p(e.softConnector,!0),m=e.distance,n=a.center,o=n[2]/2,s=n[1],r=m>0,u,w,v,x=[[],[]],z,y,D,E,B,G=[0,0,0,0],M=function(a,b){return b.y-a.y};if(a.visible&&(e.enabled||a._hasPointLabels)){R.prototype.drawDataLabels.apply(a);q(b,function(a){if(a.dataLabel&&a.visible)x[a.half].push(a),a.dataLabel._pos=null});for(E=2;E--;){var H=[],N=[],I=x[E],L=I.length,\nJ;if(L){a.sortByAngle(I,E-0.5);for(B=b=0;!b&&I[B];)b=I[B]&&I[B].dataLabel&&(I[B].dataLabel.getBBox().height||21),B++;if(m>0){w=F(s+o+m,d.plotHeight);for(B=t(0,s-o-m);B<=w;B+=b)H.push(B);w=H.length;if(L>w){c=[].concat(I);c.sort(M);for(B=L;B--;)c[B].rank=B;for(B=L;B--;)I[B].rank>=w&&I.splice(B,1);L=I.length}for(B=0;B<L;B++){c=I[B];v=c.labelPos;c=9999;var P,O;for(O=0;O<w;O++)P=Q(H[O]-v[1]),P<c&&(c=P,J=O);if(J<B&&H[B]!==null)J=B;else for(w<L-B+J&&H[B]!==null&&(J=w-L+B);H[J]===null;)J++;N.push({i:J,y:H[J]});\nH[J]=null}N.sort(M)}for(B=0;B<L;B++){c=I[B];v=c.labelPos;u=c.dataLabel;D=c.visible===!1?\"hidden\":\"inherit\";c=v[1];if(m>0){if(w=N.pop(),J=w.i,y=w.y,c>y&&H[J+1]!==null||c<y&&H[J-1]!==null)y=F(t(0,c),d.plotHeight)}else y=c;z=e.justify?n[0]+(E?-1:1)*(o+m):a.getX(y===s-o-m||y===s+o+m?c:y,E);u._attr={visibility:D,align:v[6]};u._pos={x:z+e.x+({left:f,right:-f}[v[6]]||0),y:y+e.y-10};u.connX=z;u.connY=y;if(this.options.size===null)w=u.width,z-w<f?G[3]=t(C(w-z+f),G[3]):z+w>h-f&&(G[1]=t(C(z+w-h+f),G[1])),y-\nb/2<0?G[0]=t(C(-y+b/2),G[0]):y+b/2>i&&(G[2]=t(C(y+b/2-i),G[2]))}}}if(Ha(G)===0||this.verifyDataLabelOverflow(G))this.placeDataLabels(),r&&g&&q(this.points,function(b){j=b.connector;v=b.labelPos;if((u=b.dataLabel)&&u._pos&&b.visible)D=u._attr.visibility,z=u.connX,y=u.connY,k=l?[X,z+(v[6]===\"left\"?5:-5),y,\"C\",z,y,2*v[2]-v[4],2*v[3]-v[5],v[2],v[3],S,v[4],v[5]]:[X,z+(v[6]===\"left\"?5:-5),y,S,v[2],v[3],S,v[4],v[5]],j?(j.animate({d:k}),j.attr(\"visibility\",D)):b.connector=j=a.chart.renderer.path(k).attr({\"stroke-width\":g,\nstroke:e.connectorColor||b.color||\"#606060\",visibility:D}).add(a.dataLabelsGroup);else if(j)b.connector=j.destroy()})}},L.pie.prototype.placeDataLabels=function(){q(this.points,function(a){var b=a.dataLabel;if(b&&a.visible)(a=b._pos)?(b.attr(b._attr),b[b.moved?\"animate\":\"attr\"](a),b.moved=!0):b&&b.attr({y:-9999})})},L.pie.prototype.alignDataLabel=Ca,L.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,d=c.center,e=c.minSize||80,f=e,g;d[0]!==null?f=t(b[2]-t(a[1],a[3]),\ne):(f=t(b[2]-a[1]-a[3],e),b[0]+=(a[3]-a[1])/2);d[1]!==null?f=t(F(f,b[2]-t(a[0],a[2])),e):(f=t(F(f,b[2]-a[0]-a[2]),e),b[1]+=(a[0]-a[2])/2);f<b[2]?(b[2]=f,b[3]=Math.min(/%$/.test(c.innerSize||0)?f*parseFloat(c.innerSize||0)/100:parseFloat(c.innerSize||0),f),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):g=!0;return g};if(L.column)L.column.prototype.alignDataLabel=function(a,b,c,d,e){var f=this.chart.inverted,g=a.series,h=a.dlBox||a.shapeArgs,i=p(a.below,a.plotY>p(this.translatedThreshold,\ng.yAxis.len)),j=p(c.inside,!!this.options.stacking);if(h){d=E(h);if(d.y<0)d.height+=d.y,d.y=0;h=d.y+d.height-g.yAxis.len;h>0&&(d.height-=h);f&&(d={x:g.yAxis.len-d.y-d.height,y:g.xAxis.len-d.x-d.width,width:d.height,height:d.width});if(!j)f?(d.x+=i?0:d.width,d.width=0):(d.y+=i?d.height:0,d.height=0)}c.align=p(c.align,!f||j?\"center\":i?\"right\":\"left\");c.verticalAlign=p(c.verticalAlign,f||j?\"middle\":i?\"top\":\"bottom\");R.prototype.alignDataLabel.call(this,a,b,c,d,e)};(function(a){var b=a.Chart,c=a.each,\nd=a.pick,e=a.addEvent;b.prototype.callbacks.push(function(a){function b(){var e=[];c(a.series,function(a){var b=a.options.dataLabels,f=a.dataLabelCollections||[\"dataLabel\"];(b.enabled||a._hasPointLabels)&&!b.allowOverlap&&a.visible&&c(f,function(b){c(a.points,function(a){if(a[b])a[b].labelrank=d(a.labelrank,a.shapeArgs&&a.shapeArgs.height),e.push(a[b])})})});a.hideOverlappingLabels(e)}b();e(a,\"redraw\",b)});b.prototype.hideOverlappingLabels=function(a){var b=a.length,d,e,j,k,l,m,n,o,p;for(e=0;e<b;e++)if(d=\na[e])d.oldOpacity=d.opacity,d.newOpacity=1;a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(e=0;e<b;e++){j=a[e];for(d=e+1;d<b;++d)if(k=a[d],j&&k&&j.placed&&k.placed&&j.newOpacity!==0&&k.newOpacity!==0&&(l=j.alignAttr,m=k.alignAttr,n=j.parentGroup,o=k.parentGroup,p=2*(j.box?0:j.padding),l=!(m.x+o.translateX>l.x+n.translateX+(j.width-p)||m.x+o.translateX+(k.width-p)<l.x+n.translateX||m.y+o.translateY>l.y+n.translateY+(j.height-p)||m.y+o.translateY+(k.height-p)<l.y+n.translateY)))(j.labelrank<\nk.labelrank?j:k).newOpacity=0}c(a,function(a){var b,c;if(a){c=a.newOpacity;if(a.oldOpacity!==c&&a.placed)c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?\"animate\":\"attr\"](a.alignAttr,null,b);a.isOld=!0}})}})(u);ha=u.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart,c=b.pointer,d=a.options.cursor,e=d&&{cursor:d},f=function(a){for(var c=a.target,d;c&&!d;)d=c.point,c=c.parentNode;if(d!==z&&d!==b.hoverPoint)d.onMouseOver(a)};q(a.points,function(a){if(a.graphic)a.graphic.element.point=\na;if(a.dataLabel)a.dataLabel.element.point=a});if(!a._hasTracking)q(a.trackerGroups,function(b){if(a[b]&&(a[b].addClass(\"highcharts-tracker\").on(\"mouseover\",f).on(\"mouseout\",function(a){c.onTrackerMouseOut(a)}).css(e),gb))a[b].on(\"touchstart\",f)}),a._hasTracking=!0},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,f=a.chart,g=f.pointer,h=f.renderer,i=f.options.tooltip.snap,j=a.tracker,k=b.cursor,l=k&&{cursor:k},m=function(){if(f.hoverSeries!==\na)a.onMouseOver()},n=\"rgba(192,192,192,\"+(fa?1.0E-4:0.002)+\")\";if(e&&!c)for(k=e+1;k--;)d[k]===X&&d.splice(k+1,0,d[k+1]-i,d[k+2],S),(k&&d[k]===X||k===e)&&d.splice(k,0,S,d[k-2]+i,d[k-1]);j?j.attr({d:d}):(a.tracker=h.path(d).attr({\"stroke-linejoin\":\"round\",visibility:a.visible?\"visible\":\"hidden\",stroke:n,fill:c?n:\"none\",\"stroke-width\":b.lineWidth+(c?0:2*i),zIndex:2}).add(a.group),q([a.tracker,a.markerGroup],function(a){a.addClass(\"highcharts-tracker\").on(\"mouseover\",m).on(\"mouseout\",function(a){g.onTrackerMouseOut(a)}).css(l);\nif(gb)a.on(\"touchstart\",m)}))}};if(L.column)xa.prototype.drawTracker=ha.drawTrackerPoint;if(L.pie)L.pie.prototype.drawTracker=ha.drawTrackerPoint;if(L.scatter)qa.prototype.drawTracker=ha.drawTrackerPoint;x(sb.prototype,{setItemEvents:function(a,b,c,d,e){var f=this;(c?b:a.legendGroup).on(\"mouseover\",function(){a.setState(\"hover\");b.css(f.options.itemHoverStyle)}).on(\"mouseout\",function(){b.css(a.visible?d:e);a.setState()}).on(\"click\",function(b){var c=function(){a.setVisible&&a.setVisible()},b={browserEvent:b};\na.firePointEvent?a.firePointEvent(\"legendItemClick\",b,c):H(a,\"legendItemClick\",b,c)})},createCheckboxForItem:function(a){a.checkbox=ca(\"input\",{type:\"checkbox\",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);N(a.checkbox,\"click\",function(b){H(a.series||a,\"checkboxClick\",{checked:b.target.checked,item:a},function(){a.select()})})}});T.legend.itemStyle.cursor=\"pointer\";x(jb.prototype,{showResetZoom:function(){var a=this,b=T.lang,c=a.options.chart.resetZoomButton,\nd=c.theme,e=d.states,f=c.relativeTo===\"chart\"?null:\"plotBox\";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,e&&e.hover).attr({align:c.position.align,title:b.resetZoomTitle}).add().align(c.position,!1,f)},zoomOut:function(){var a=this;H(a,\"selection\",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var b,c=this.pointer,d=!1,e;!a||a.resetSelection?q(this.axes,function(a){b=a.zoom()}):q(a.xAxis.concat(a.yAxis),function(a){var e=a.axis,h=e.isXAxis;if(c[h?\n\"zoomX\":\"zoomY\"]||c[h?\"pinchX\":\"pinchY\"])b=e.zoom(a.min,a.max),e.displayBtn&&(d=!0)});e=this.resetZoomButton;if(d&&!e)this.showResetZoom();else if(!d&&ba(e))this.resetZoomButton=e.destroy();b&&this.redraw(p(this.options.chart.animation,a&&a.animation,this.pointCount<100))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&q(d,function(a){a.setState()});q(b===\"xy\"?[1,0]:[1],function(b){var b=c[b?\"xAxis\":\"yAxis\"][0],d=b.horiz,h=a[d?\"chartX\":\"chartY\"],d=d?\"mouseDownX\":\"mouseDownY\",i=c[d],j=(b.pointRange||\n0)/2,k=b.getExtremes(),l=b.toValue(i-h,!0)+j,j=b.toValue(i+b.len-h,!0)-j,i=i>h;if(b.series.length&&(i||l>F(k.dataMin,k.min))&&(!i||j<t(k.dataMax,k.max)))b.setExtremes(l,j,!1,!1,{trigger:\"pan\"}),e=!0;c[d]=h});e&&c.redraw(!1);M(c.container,{cursor:\"move\"})}});x(Ma.prototype,{select:function(a,b){var c=this,d=c.series,e=d.chart,a=p(a,!c.selected);c.firePointEvent(a?\"select\":\"unselect\",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[pa(c,d.data)]=c.options;c.setState(a&&\"select\");\nb||q(e.getSelectedPoints(),function(a){if(a.selected&&a!==c)a.selected=a.options.selected=!1,d.options.data[pa(a,d.data)]=a.options,a.setState(\"\"),a.firePointEvent(\"unselect\")})})},onMouseOver:function(a,b){var c=this.series,d=c.chart,e=d.tooltip,f=d.hoverPoint;if(d.hoverSeries!==c)c.onMouseOver();if(f&&f!==this)f.onMouseOut();if(this.series&&(this.firePointEvent(\"mouseOver\"),e&&(!e.shared||c.noSharedTooltip)&&e.refresh(this,a),this.setState(\"hover\"),!b))d.hoverPoint=this},onMouseOut:function(){var a=\nthis.series.chart,b=a.hoverPoints;this.firePointEvent(\"mouseOut\");if(!b||pa(this,b)===-1)this.setState(),a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var a=E(this.series.options.point,this.options).events,b;this.events=a;for(b in a)N(this,b,a[b]);this.hasImportedEvents=!0}},setState:function(a,b){var c=V(this.plotX),d=this.plotY,e=this.series,f=e.options.states,g=ga[e.type].marker&&e.options.marker,h=g&&!g.enabled,i=g&&g.states[a],j=i&&i.enabled===!1,k=e.stateMarkerGraphic,\nl=this.marker||{},m=e.chart,n=e.halo,o,a=a||\"\";o=this.pointAttr[a]||e.pointAttr[a];if(!(a===this.state&&!b||this.selected&&a!==\"select\"||f[a]&&f[a].enabled===!1||a&&(j||h&&i.enabled===!1)||a&&l.states&&l.states[a]&&l.states[a].enabled===!1)){if(this.graphic)g=g&&this.graphic.symbolName&&o.r,this.graphic.attr(E(o,g?{x:c-g,y:d-g,width:2*g,height:2*g}:{})),k&&k.hide();else{if(a&&i)if(g=i.radius,l=l.symbol||e.symbol,k&&k.currentSymbol!==l&&(k=k.destroy()),k)k[b?\"animate\":\"attr\"]({x:c-g,y:d-g});else if(l)e.stateMarkerGraphic=\nk=m.renderer.symbol(l,c-g,d-g,2*g,2*g).attr(o).add(e.markerGroup),k.currentSymbol=l;if(k)k[a&&m.isInsidePlot(c,d,m.inverted)?\"show\":\"hide\"](),k.element.point=this}if((c=f[a]&&f[a].halo)&&c.size){if(!n)e.halo=n=m.renderer.path().add(m.seriesGroup);n.attr(x({fill:this.color||e.color,\"fill-opacity\":c.opacity,zIndex:-1},c.attributes))[b?\"animate\":\"attr\"]({d:this.haloPath(c.size)})}else n&&n.attr({d:[]});this.state=a}},haloPath:function(a){var b=this.series,c=b.chart,d=b.getPlotBox(),e=c.inverted,f=Math.floor(this.plotX);\nreturn c.renderer.symbols.circle(d.translateX+(e?b.yAxis.len-this.plotY:f)-a,d.translateY+(e?b.xAxis.len-f:this.plotY)-a,a*2,a*2)}});x(R.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&H(this,\"mouseOver\");this.setState(\"hover\");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&H(this,\"mouseOut\");c&&!a.stickyTracking&&\n(!c.shared||this.noSharedTooltip)&&c.hide();this.setState()},setState:function(a){var b=this.options,c=this.graph,d=b.states,e=b.lineWidth,b=0,a=a||\"\";if(this.state!==a&&(this.state=a,!(d[a]&&d[a].enabled===!1)&&(a&&(e=d[a].lineWidth||e+(d[a].lineWidthPlus||0)),c&&!c.dashstyle))){a={\"stroke-width\":e};for(c.attr(a);this[\"zoneGraph\"+b];)this[\"zoneGraph\"+b].attr(a),b+=1}},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,g=d.options.chart.ignoreHiddenSeries,h=c.visible;f=(c.visible=a=c.options.visible=\nc.userOptions.visible=a===void 0?!h:a)?\"show\":\"hide\";q([\"group\",\"dataLabelsGroup\",\"markerGroup\",\"tracker\"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&q(d.series,function(a){if(a.options.stacking&&a.visible)a.isDirty=!0});q(c.linkedSeries,function(b){b.setVisible(a,!1)});if(g)d.isDirtyBox=!0;b!==!1&&d.redraw();H(c,f)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},\nselect:function(a){this.selected=a=a===z?!this.selected:a;if(this.checkbox)this.checkbox.checked=a;H(this,a?\"select\":\"unselect\")},drawTracker:ha.drawTrackerGraph});x(u,{Color:na,Point:Ma,Tick:Ya,Renderer:fb,SVGElement:J,SVGRenderer:Fa,arrayMin:Oa,arrayMax:Ha,charts:U,correctFloat:$,dateFormat:Ta,error:ea,format:Na,pathAnim:void 0,getOptions:function(){return T},hasBidiBug:Sb,isTouchDevice:Ob,setOptions:function(a){T=E(!0,T,a);Hb();return T},addEvent:N,removeEvent:Y,createElement:ca,discardElement:Va,\ncss:M,each:q,map:Ea,merge:E,splat:ua,stableSort:kb,extendClass:sa,pInt:B,svg:fa,canvas:la,vml:!fa&&!la,product:\"Highcharts\",version:\"4.2.7\"});return u});\n"

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1508))

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	module.exports = "/*\n Highcharts JS v4.2.7 (2016-09-21)\n\n (c) 2009-2016 Torstein Honsi\n\n License: www.highcharts.com/license\n*/\n(function(m){typeof module===\"object\"&&module.exports?module.exports=m:m(Highcharts)})(function(m){function M(a,b,c){this.init(a,b,c)}var R=m.arrayMin,S=m.arrayMax,s=m.each,J=m.extend,G=m.isNumber,v=m.merge,T=m.map,r=m.pick,B=m.pInt,H=m.correctFloat,p=m.getOptions().plotOptions,i=m.seriesTypes,t=m.extendClass,N=m.splat,w=m.wrap,O=m.Axis,z=m.Tick,I=m.Point,U=m.Pointer,V=m.CenteredSeriesMixin,C=m.TrackerMixin,x=m.Series,y=Math,F=y.round,D=y.floor,P=y.max,W=m.Color,n=function(){};J(M.prototype,{init:function(a,\nb,c){var d=this,g=d.defaultOptions;d.chart=b;d.options=a=v(g,b.angular?{background:{}}:void 0,a);(a=a.background)&&s([].concat(N(a)).reverse(),function(a){var b=a.backgroundColor,g=c.userOptions,a=v(d.defaultBackgroundOptions,a);if(b)a.backgroundColor=b;a.color=a.backgroundColor;c.options.plotBands.unshift(a);g.plotBands=g.plotBands||[];g.plotBands!==c.options.plotBands&&g.plotBands.unshift(a)})},defaultOptions:{center:[\"50%\",\"50%\"],size:\"85%\",startAngle:0},defaultBackgroundOptions:{shape:\"circle\",\nborderWidth:1,borderColor:\"silver\",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,\"#FFF\"],[1,\"#DDD\"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:\"105%\"}});var A=O.prototype,z=z.prototype,X={getOffset:n,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:n,setCategories:n,setTitle:n},Q={isRadial:!0,defaultRadialGaugeOptions:{labels:{align:\"center\",x:0,y:null},minorGridLineWidth:0,minorTickInterval:\"auto\",minorTickLength:10,minorTickPosition:\"inside\",\nminorTickWidth:1,tickLength:10,tickPosition:\"inside\",tickWidth:2,title:{rotation:0},zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:\"circle\",labels:{align:\"right\",x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(a){a=this.options=v(this.defaultOptions,this.defaultRadialOptions,a);if(!a.plotBands)a.plotBands=[]},getOffset:function(){A.getOffset.call(this);\nthis.chart.axisOffset[this.side]=0;this.center=this.pane.center=V.getCenter.call(this.pane)},getLinePath:function(a,b){var c=this.center,d,g=this.chart;d=r(b,c[2]/2-this.offset);this.isCircular||b!==void 0?c=this.chart.renderer.symbols.arc(this.left+c[0],this.top+c[1],d,d,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0}):(d=this.postTranslate(this.angleRad,d),c=[\"M\",c[0]+g.plotLeft,c[1]+g.plotTop,\"L\",d.x,d.y]);return c},setAxisTranslation:function(){A.setAxisTranslation.call(this);\nif(this.center)this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0},beforeSetTickPositions:function(){(this.autoConnect=this.isCircular&&r(this.userMax,this.options.max)===void 0&&this.endAngleRad-this.startAngleRad===2*Math.PI)&&(this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0)},setAxisSize:function(){A.setAxisSize.call(this);if(this.isRadial){this.center=\nthis.pane.center=m.CenteredSeriesMixin.getCenter.call(this.pane);if(this.isCircular)this.sector=this.endAngleRad-this.startAngleRad;this.len=this.width=this.height=this.center[2]*r(this.sector,1)/2}},getPosition:function(a,b){return this.postTranslate(this.isCircular?this.translate(a):this.angleRad,r(this.isCircular?b:this.translate(a),this.center[2]/2)-this.offset)},postTranslate:function(a,b){var c=this.chart,d=this.center,a=this.startAngleRad+a;return{x:c.plotLeft+d[0]+Math.cos(a)*b,y:c.plotTop+\nd[1]+Math.sin(a)*b}},getPlotBandPath:function(a,b,c){var d=this.center,g=this.startAngleRad,e=d[2]/2,j=[r(c.outerRadius,\"100%\"),c.innerRadius,r(c.thickness,10)],l=Math.min(this.offset,0),h=/%$/,f,k=this.isCircular;this.options.gridLineInterpolation===\"polygon\"?d=this.getPlotLinePath(a).concat(this.getPlotLinePath(b,!0)):(a=Math.max(a,this.min),b=Math.min(b,this.max),k||(j[0]=this.translate(a),j[1]=this.translate(b)),j=T(j,function(a){h.test(a)&&(a=B(a,10)*e/100);return a}),c.shape===\"circle\"||!k?\n(a=-Math.PI/2,b=Math.PI*1.5,f=!0):(a=g+this.translate(a),b=g+this.translate(b)),j[0]-=l,j[2]-=l,d=this.chart.renderer.symbols.arc(this.left+d[0],this.top+d[1],j[0],j[0],{start:Math.min(a,b),end:Math.max(a,b),innerR:r(j[1],j[0]-j[2]),open:f}));return d},getPlotLinePath:function(a,b){var c=this,d=c.center,g=c.chart,e=c.getPosition(a),j,l,h;c.isCircular?h=[\"M\",d[0]+g.plotLeft,d[1]+g.plotTop,\"L\",e.x,e.y]:c.options.gridLineInterpolation===\"circle\"?(a=c.translate(a))&&(h=c.getLinePath(0,a)):(s(g.xAxis,\nfunction(a){a.pane===c.pane&&(j=a)}),h=[],a=c.translate(a),d=j.tickPositions,j.autoConnect&&(d=d.concat([d[0]])),b&&(d=[].concat(d).reverse()),s(d,function(e,b){l=j.getPosition(e,a);h.push(b?\"L\":\"M\",l.x,l.y)}));return h},getTitlePosition:function(){var a=this.center,b=this.chart,c=this.options.title;return{x:b.plotLeft+a[0]+(c.x||0),y:b.plotTop+a[1]-{high:0.5,middle:0.25,low:0}[c.align]*a[2]+(c.y||0)}}};w(A,\"init\",function(a,b,c){var k;var d=b.angular,g=b.polar,e=c.isX,j=d&&e,l,h=b.options,f=c.pane||\n0;if(d){if(J(this,j?X:Q),l=!e)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else if(g)J(this,Q),this.defaultRadialOptions=(l=e)?this.defaultRadialXOptions:v(this.defaultYAxisOptions,this.defaultRadialYOptions);if(d||g)b.inverted=!1,h.chart.zoomType=null;a.call(this,b,c);if(!j&&(d||g)){a=this.options;if(!b.panes)b.panes=[];this.pane=(k=b.panes[f]=b.panes[f]||new M(N(h.pane)[f],b,this),b=k);b=b.options;this.angleRad=(a.angle||0)*Math.PI/180;this.startAngleRad=(b.startAngle-90)*Math.PI/180;\nthis.endAngleRad=(r(b.endAngle,b.startAngle+360)-90)*Math.PI/180;this.offset=a.offset||0;this.isCircular=l}});w(A,\"autoLabelAlign\",function(a){if(!this.isRadial)return a.apply(this,[].slice.call(arguments,1))});w(z,\"getPosition\",function(a,b,c,d,g){var e=this.axis;return e.getPosition?e.getPosition(c):a.call(this,b,c,d,g)});w(z,\"getLabelPosition\",function(a,b,c,d,g,e,j,l,h){var f=this.axis,k=e.y,o=20,u=e.align,i=(f.translate(this.pos)+f.startAngleRad+Math.PI/2)/Math.PI*180%360;f.isRadial?(a=f.getPosition(this.pos,\nf.center[2]/2+r(e.distance,-25)),e.rotation===\"auto\"?d.attr({rotation:i}):k===null&&(k=f.chart.renderer.fontMetrics(d.styles.fontSize).b-d.getBBox().height/2),u===null&&(f.isCircular?(this.label.getBBox().width>f.len*f.tickInterval/(f.max-f.min)&&(o=0),u=i>o&&i<180-o?\"left\":i>180+o&&i<360-o?\"right\":\"center\"):u=\"center\",d.attr({align:u})),a.x+=e.x,a.y+=k):a=a.call(this,b,c,d,g,e,j,l,h);return a});w(z,\"getMarkPath\",function(a,b,c,d,g,e,j){var l=this.axis;l.isRadial?(a=l.getPosition(this.pos,l.center[2]/\n2+d),b=[\"M\",b,c,\"L\",a.x,a.y]):b=a.call(this,b,c,d,g,e,j);return b});p.arearange=v(p.area,{lineWidth:1,marker:null,threshold:null,tooltip:{pointFormat:'<span style=\"color:{series.color}\">\\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0},states:{hover:{halo:!1}}});i.arearange=t(i.area,{type:\"arearange\",pointArrayMap:[\"low\",\"high\"],dataLabelCollections:[\"dataLabel\",\"dataLabelUpper\"],toYData:function(a){return[a.low,\na.high]},pointValKey:\"low\",deferTranslatePolar:!0,highToXY:function(a){var b=this.chart,c=this.xAxis.postTranslate(a.rectPlotX,this.yAxis.len-a.plotHigh);a.plotHighX=c.x-b.plotLeft;a.plotHigh=c.y-b.plotTop},translate:function(){var a=this,b=a.yAxis;i.area.prototype.translate.apply(a);s(a.points,function(a){var d=a.low,g=a.high,e=a.plotY;g===null||d===null?a.isNull=!0:(a.plotLow=e,a.plotHigh=b.translate(g,0,1,0,1))});this.chart.polar&&s(this.points,function(b){a.highToXY(b)})},getGraphPath:function(a){var b=\n[],c=[],d,g=i.area.prototype.getGraphPath,e,j,l;l=this.options;var h=l.step,a=a||this.points;for(d=a.length;d--;)e=a[d],!e.isNull&&!l.connectEnds&&(!a[d+1]||a[d+1].isNull)&&c.push({plotX:e.plotX,plotY:e.plotY,doCurve:!1}),j={polarPlotY:e.polarPlotY,rectPlotX:e.rectPlotX,yBottom:e.yBottom,plotX:r(e.plotHighX,e.plotX),plotY:e.plotHigh,isNull:e.isNull},c.push(j),b.push(j),!e.isNull&&!l.connectEnds&&(!a[d-1]||a[d-1].isNull)&&c.push({plotX:e.plotX,plotY:e.plotY,doCurve:!1});a=g.call(this,a);if(h)h===!0&&\n(h=\"left\"),l.step={left:\"right\",center:\"center\",right:\"left\"}[h];b=g.call(this,b);c=g.call(this,c);l.step=h;l=[].concat(a,b);!this.chart.polar&&c[0]===\"M\"&&(c[0]=\"L\");this.graphPath=l;this.areaPath=this.areaPath.concat(a,c);l.isArea=!0;l.xMap=a.xMap;this.areaPath.xMap=a.xMap;return l},drawDataLabels:function(){var a=this.data,b=a.length,c,d=[],g=x.prototype,e=this.options.dataLabels,j=e.align,l=e.verticalAlign,h=e.inside,f,k,o=this.chart.inverted;if(e.enabled||this._hasPointLabels){for(c=b;c--;)if(f=\na[c]){k=h?f.plotHigh<f.plotLow:f.plotHigh>f.plotLow;f.y=f.high;f._plotY=f.plotY;f.plotY=f.plotHigh;d[c]=f.dataLabel;f.dataLabel=f.dataLabelUpper;f.below=k;if(o){if(!j)e.align=k?\"right\":\"left\"}else if(!l)e.verticalAlign=k?\"top\":\"bottom\";e.x=e.xHigh;e.y=e.yHigh}g.drawDataLabels&&g.drawDataLabels.apply(this,arguments);for(c=b;c--;)if(f=a[c]){k=h?f.plotHigh<f.plotLow:f.plotHigh>f.plotLow;f.dataLabelUpper=f.dataLabel;f.dataLabel=d[c];f.y=f.low;f.plotY=f._plotY;f.below=!k;if(o){if(!j)e.align=k?\"left\":\"right\"}else if(!l)e.verticalAlign=\nk?\"bottom\":\"top\";e.x=e.xLow;e.y=e.yLow}g.drawDataLabels&&g.drawDataLabels.apply(this,arguments)}e.align=j;e.verticalAlign=l},alignDataLabel:function(){i.column.prototype.alignDataLabel.apply(this,arguments)},setStackedPoints:n,getSymbol:n,drawPoints:n});p.areasplinerange=v(p.arearange);i.areasplinerange=t(i.arearange,{type:\"areasplinerange\",getPointSpline:i.spline.prototype.getPointSpline});(function(){var a=i.column.prototype;p.columnrange=v(p.column,p.arearange,{lineWidth:1,pointRange:null});i.columnrange=\nt(i.arearange,{type:\"columnrange\",translate:function(){var b=this,c=b.yAxis,d=b.xAxis,g=d.startAngleRad,e,j=b.chart,l=b.xAxis.isRadial,h;a.translate.apply(b);s(b.points,function(a){var k=a.shapeArgs,o=b.options.minPointLength,u,i;a.plotHigh=h=c.translate(a.high,0,1,0,1);a.plotLow=a.plotY;i=h;u=r(a.rectPlotY,a.plotY)-h;Math.abs(u)<o?(o-=u,u+=o,i-=o/2):u<0&&(u*=-1,i-=u);l?(e=a.barX+g,a.shapeType=\"path\",a.shapeArgs={d:b.polarArc(i+u,i,e,e+a.pointWidth)}):(k.height=u,k.y=i,a.tooltipPos=j.inverted?[c.len+\nc.pos-j.plotLeft-i-u/2,d.len+d.pos-j.plotTop-k.x-k.width/2,u]:[d.left-j.plotLeft+k.x+k.width/2,c.pos-j.plotTop+i+u/2,u])})},directTouch:!0,trackerGroups:[\"group\",\"dataLabelsGroup\"],drawGraph:n,crispCol:a.crispCol,pointAttrToOptions:a.pointAttrToOptions,drawPoints:a.drawPoints,drawTracker:a.drawTracker,getColumnMetrics:a.getColumnMetrics,animate:function(){return a.animate.apply(this,arguments)},polarArc:function(){return a.polarArc.apply(this,arguments)}})})();p.gauge=v(p.line,{dataLabels:{enabled:!0,\ndefer:!1,y:15,borderWidth:1,borderColor:\"silver\",borderRadius:3,crop:!1,verticalAlign:\"top\",zIndex:2},dial:{},pivot:{},tooltip:{headerFormat:\"\"},showInLegend:!1});C={type:\"gauge\",pointClass:t(I,{setState:function(a){this.state=a}}),angular:!0,directTouch:!0,drawGraph:n,fixedBox:!0,forceDL:!0,noSharedTooltip:!0,trackerGroups:[\"group\",\"dataLabelsGroup\"],translate:function(){var a=this.yAxis,b=this.options,c=a.center;this.generatePoints();s(this.points,function(d){var g=v(b.dial,d.dial),e=B(r(g.radius,\n80))*c[2]/200,j=B(r(g.baseLength,70))*e/100,l=B(r(g.rearLength,10))*e/100,h=g.baseWidth||3,f=g.topWidth||1,k=b.overshoot,o=a.startAngleRad+a.translate(d.y,null,null,null,!0);G(k)?(k=k/180*Math.PI,o=Math.max(a.startAngleRad-k,Math.min(a.endAngleRad+k,o))):b.wrap===!1&&(o=Math.max(a.startAngleRad,Math.min(a.endAngleRad,o)));o=o*180/Math.PI;d.shapeType=\"path\";d.shapeArgs={d:g.path||[\"M\",-l,-h/2,\"L\",j,-h/2,e,-f/2,e,f/2,j,h/2,-l,h/2,\"z\"],translateX:c[0],translateY:c[1],rotation:o};d.plotX=c[0];d.plotY=\nc[1]})},drawPoints:function(){var a=this,b=a.yAxis.center,c=a.pivot,d=a.options,g=d.pivot,e=a.chart.renderer;s(a.points,function(b){var g=b.graphic,c=b.shapeArgs,f=c.d,k=v(d.dial,b.dial);g?(g.animate(c),c.d=f):b.graphic=e[b.shapeType](c).attr({stroke:k.borderColor||\"none\",\"stroke-width\":k.borderWidth||0,fill:k.backgroundColor||\"black\",rotation:c.rotation,zIndex:1}).add(a.group)});c?c.animate({translateX:b[0],translateY:b[1]}):a.pivot=e.circle(0,0,r(g.radius,5)).attr({\"stroke-width\":g.borderWidth||\n0,stroke:g.borderColor||\"silver\",fill:g.backgroundColor||\"black\",zIndex:2}).translate(b[0],b[1]).add(a.group)},animate:function(a){var b=this;if(!a)s(b.points,function(a){var d=a.graphic;d&&(d.attr({rotation:b.yAxis.startAngleRad*180/Math.PI}),d.animate({rotation:a.shapeArgs.rotation},b.options.animation))}),b.animate=null},render:function(){this.group=this.plotGroup(\"group\",\"series\",this.visible?\"visible\":\"hidden\",this.options.zIndex,this.chart.seriesGroup);x.prototype.render.call(this);this.group.clip(this.chart.clipRect)},\nsetData:function(a,b){x.prototype.setData.call(this,a,!1);this.processData();this.generatePoints();r(b,!0)&&this.chart.redraw()},drawTracker:C&&C.drawTrackerPoint};i.gauge=t(i.line,C);p.boxplot=v(p.column,{fillColor:\"#FFFFFF\",lineWidth:1,medianWidth:2,states:{hover:{brightness:-0.3}},threshold:null,tooltip:{pointFormat:'<span style=\"color:{point.color}\">\\u25cf</span> <b> {series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'},\nwhiskerLength:\"50%\",whiskerWidth:2});i.boxplot=t(i.column,{type:\"boxplot\",pointArrayMap:[\"low\",\"q1\",\"median\",\"q3\",\"high\"],toYData:function(a){return[a.low,a.q1,a.median,a.q3,a.high]},pointValKey:\"high\",pointAttrToOptions:{fill:\"fillColor\",stroke:\"color\",\"stroke-width\":\"lineWidth\"},drawDataLabels:n,translate:function(){var a=this.yAxis,b=this.pointArrayMap;i.column.prototype.translate.apply(this);s(this.points,function(c){s(b,function(b){c[b]!==null&&(c[b+\"Plot\"]=a.translate(c[b],0,1,0,1))})})},drawPoints:function(){var a=\nthis,b=a.options,c=a.chart.renderer,d,g,e,j,l,h,f,k,o,i,m,K,L,p,v,n,w,t,x,y,C,B,z=a.doQuartiles!==!1,A,E=a.options.whiskerLength;s(a.points,function(q){o=q.graphic;C=q.shapeArgs;m={};p={};n={};B=q.color||a.color;if(q.plotY!==void 0)if(d=q.pointAttr[q.selected?\"selected\":\"\"],w=C.width,t=D(C.x),x=t+w,y=F(w/2),g=D(z?q.q1Plot:q.lowPlot),e=D(z?q.q3Plot:q.lowPlot),j=D(q.highPlot),l=D(q.lowPlot),m.stroke=q.stemColor||b.stemColor||B,m[\"stroke-width\"]=r(q.stemWidth,b.stemWidth,b.lineWidth),m.dashstyle=q.stemDashStyle||\nb.stemDashStyle,p.stroke=q.whiskerColor||b.whiskerColor||B,p[\"stroke-width\"]=r(q.whiskerWidth,b.whiskerWidth,b.lineWidth),n.stroke=q.medianColor||b.medianColor||B,n[\"stroke-width\"]=r(q.medianWidth,b.medianWidth,b.lineWidth),f=m[\"stroke-width\"]%2/2,k=t+y+f,i=[\"M\",k,e,\"L\",k,j,\"M\",k,g,\"L\",k,l],z&&(f=d[\"stroke-width\"]%2/2,k=D(k)+f,g=D(g)+f,e=D(e)+f,t+=f,x+=f,K=[\"M\",t,e,\"L\",t,g,\"L\",x,g,\"L\",x,e,\"L\",t,e,\"z\"]),E&&(f=p[\"stroke-width\"]%2/2,j+=f,l+=f,A=/%$/.test(E)?y*parseFloat(E)/100:E/2,L=[\"M\",k-A,j,\"L\",k+\nA,j,\"M\",k-A,l,\"L\",k+A,l]),f=n[\"stroke-width\"]%2/2,h=F(q.medianPlot)+f,v=[\"M\",t,h,\"L\",x,h],o)q.stem.animate({d:i}),E&&q.whiskers.animate({d:L}),z&&q.box.animate({d:K}),q.medianShape.animate({d:v});else{q.graphic=o=c.g().add(a.group);q.stem=c.path(i).attr(m).add(o);if(E)q.whiskers=c.path(L).attr(p).add(o);if(z)q.box=c.path(K).attr(d).add(o);q.medianShape=c.path(v).attr(n).add(o)}})},setStackedPoints:n});p.errorbar=v(p.boxplot,{color:\"#000000\",grouping:!1,linkedTo:\":previous\",tooltip:{pointFormat:'<span style=\"color:{point.color}\">\\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},\nwhiskerWidth:null});i.errorbar=t(i.boxplot,{type:\"errorbar\",pointArrayMap:[\"low\",\"high\"],toYData:function(a){return[a.low,a.high]},pointValKey:\"high\",doQuartiles:!1,drawDataLabels:i.arearange?function(){var a=this.pointValKey;i.arearange.prototype.drawDataLabels.call(this);s(this.data,function(b){b.y=b[a]})}:n,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||i.column.prototype.getColumnMetrics.call(this)}});p.waterfall=v(p.column,{lineWidth:1,lineColor:\"#333\",\ndashStyle:\"dot\",borderColor:\"#333\",dataLabels:{inside:!0},states:{hover:{lineWidthPlus:0}}});i.waterfall=t(i.column,{type:\"waterfall\",upColorProp:\"fill\",pointValKey:\"y\",pointClass:t(I,{isValid:function(){return G(this.y,!0)||this.isSum||this.isIntermediateSum}}),translate:function(){var a=this.options,b=this.yAxis,c,d,g,e,j,l,h,f,k,o=r(a.minPointLength,5),u=a.threshold,m=a.stacking;i.column.prototype.translate.apply(this);this.minPointLengthOffset=0;h=f=u;d=this.points;for(c=0,a=d.length;c<a;c++){g=\nd[c];l=this.processedYData[c];e=g.shapeArgs;k=(j=m&&b.stacks[(this.negStacks&&l<u?\"-\":\"\")+this.stackKey])?j[g.x].points[this.index+\",\"+c]:[0,l];if(g.isSum)g.y=H(l);else if(g.isIntermediateSum)g.y=H(l-f);j=P(h,h+g.y)+k[0];e.y=b.toPixels(j,!0);g.isSum?(e.y=b.toPixels(k[1],!0),e.height=Math.min(b.toPixels(k[0],!0),b.len)-e.y+this.minPointLengthOffset):g.isIntermediateSum?(e.y=b.toPixels(k[1],!0),e.height=Math.min(b.toPixels(f,!0),b.len)-e.y+this.minPointLengthOffset,f=k[1]):(e.height=l>0?b.toPixels(h,\n!0)-e.y:b.toPixels(h,!0)-b.toPixels(h-l,!0),h+=l);e.height<0&&(e.y+=e.height,e.height*=-1);g.plotY=e.y=F(e.y)-this.borderWidth%2/2;e.height=P(F(e.height),0.001);g.yBottom=e.y+e.height;if(e.height<=o)e.height=o,this.minPointLengthOffset+=o;e.y-=this.minPointLengthOffset;e=g.plotY+(g.negative?e.height:0)-this.minPointLengthOffset;this.chart.inverted?g.tooltipPos[0]=b.len-e:g.tooltipPos[1]=e}},processData:function(a){var b=this.yData,c=this.options.data,d,g=b.length,e,j,l,h,f,k;j=e=l=h=this.options.threshold||\n0;for(k=0;k<g;k++)f=b[k],d=c&&c[k]?c[k]:{},f===\"sum\"||d.isSum?b[k]=H(j):f===\"intermediateSum\"||d.isIntermediateSum?b[k]=H(e):(j+=f,e+=f),l=Math.min(j,l),h=Math.max(j,h);x.prototype.processData.call(this,a);this.dataMin=l;this.dataMax=h},toYData:function(a){return a.isSum?a.x===0?null:\"sum\":a.isIntermediateSum?a.x===0?null:\"intermediateSum\":a.y},getAttribs:function(){i.column.prototype.getAttribs.apply(this,arguments);var a=this,b=a.options,c=b.states,d=b.upColor||a.color,b=m.Color(d).brighten(b.states.hover.brightness).get(),\ng=v(a.pointAttr),e=a.upColorProp;g[\"\"][e]=d;g.hover[e]=c.hover.upColor||b;g.select[e]=c.select.upColor||d;s(a.points,function(b){if(!b.options.color)b.y>0?(b.pointAttr=g,b.color=d):b.pointAttr=a.pointAttr})},getGraphPath:function(){var a=this.data,b=a.length,c=F(this.options.lineWidth+this.borderWidth)%2/2,d=[],g,e,j;for(j=1;j<b;j++)e=a[j].shapeArgs,g=a[j-1].shapeArgs,e=[\"M\",g.x+g.width,g.y+c,\"L\",e.x,g.y+c],a[j-1].y<0&&(e[2]+=g.height,e[5]+=g.height),d=d.concat(e);return d},getExtremes:n,drawGraph:x.prototype.drawGraph});\np.polygon=v(p.scatter,{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:\"\"},trackByArea:!0});i.polygon=t(i.scatter,{type:\"polygon\",getGraphPath:function(){for(var a=x.prototype.getGraphPath.call(this),b=a.length+1;b--;)(b===a.length||a[b]===\"M\")&&b>0&&a.splice(b,0,\"z\");return this.areaPath=a},drawGraph:function(){this.options.fillColor=this.color;i.area.prototype.drawGraph.call(this)},drawLegendSymbol:m.LegendSymbolMixin.drawRectangle,drawTracker:x.prototype.drawTracker,\nsetStackedPoints:n});p.bubble=v(p.scatter,{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:\"middle\"},marker:{lineColor:null,lineWidth:1},minSize:8,maxSize:\"20%\",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:\"({point.x}, {point.y}), Size: {point.z}\"},turboThreshold:0,zThreshold:0,zoneAxis:\"z\"});C=t(I,{haloPath:function(){return I.prototype.haloPath.call(this,this.shapeArgs.r+this.series.options.states.hover.halo.size)},ttBelow:!1});i.bubble=t(i.scatter,\n{type:\"bubble\",pointClass:C,pointArrayMap:[\"y\",\"z\"],parallelArrays:[\"x\",\"y\",\"z\"],trackerGroups:[\"group\",\"dataLabelsGroup\"],bubblePadding:!0,zoneAxis:\"z\",pointAttrToOptions:{stroke:\"lineColor\",\"stroke-width\":\"lineWidth\",fill:\"fillColor\"},applyOpacity:function(a){var b=this.options.marker,c=r(b.fillOpacity,0.5),a=a||b.fillColor||this.color;c!==1&&(a=W(a).setOpacity(c).get(\"rgba\"));return a},convertAttribs:function(){var a=x.prototype.convertAttribs.apply(this,arguments);a.fill=this.applyOpacity(a.fill);\nreturn a},getRadii:function(a,b,c,d){var g,e,j,l=this.zData,h=[],f=this.options,k=f.sizeBy!==\"width\",o=f.zThreshold,i=b-a;for(e=0,g=l.length;e<g;e++)j=l[e],f.sizeByAbsoluteValue&&j!==null&&(j=Math.abs(j-o),b=Math.max(b-o,Math.abs(a-o)),a=0),j===null?j=null:j<a?j=c/2-1:(j=i>0?(j-a)/i:0.5,k&&j>=0&&(j=Math.sqrt(j)),j=y.ceil(c+j*(d-c))/2),h.push(j);this.radii=h},animate:function(a){var b=this.options.animation;if(!a)s(this.points,function(a){var d=a.graphic,a=a.shapeArgs;d&&a&&(d.attr(\"r\",1),d.animate({r:a.r},\nb))}),this.animate=null},translate:function(){var a,b=this.data,c,d,g=this.radii;i.scatter.prototype.translate.call(this);for(a=b.length;a--;)c=b[a],d=g?g[a]:0,G(d)&&d>=this.minPxSize/2?(c.shapeType=\"circle\",c.shapeArgs={x:c.plotX,y:c.plotY,r:d},c.dlBox={x:c.plotX-d,y:c.plotY-d,width:2*d,height:2*d}):c.shapeArgs=c.plotY=c.dlBox=void 0},drawLegendSymbol:function(a,b){var c=this.chart.renderer,d=c.fontMetrics(a.itemStyle.fontSize).f/2;b.legendSymbol=c.circle(d,a.baseline-d,d).attr({zIndex:3}).add(b.legendGroup);\nb.legendSymbol.isMarker=!0},drawPoints:i.column.prototype.drawPoints,alignDataLabel:i.column.prototype.alignDataLabel,buildKDTree:n,applyZones:n});O.prototype.beforePadding=function(){var a=this,b=this.len,c=this.chart,d=0,g=b,e=this.isXAxis,j=e?\"xData\":\"yData\",l=this.min,h={},f=y.min(c.plotWidth,c.plotHeight),k=Number.MAX_VALUE,i=-Number.MAX_VALUE,m=this.max-l,p=b/m,n=[];s(this.series,function(b){var g=b.options;if(b.bubblePadding&&(b.visible||!c.options.chart.ignoreHiddenSeries))if(a.allowZoomOutside=\n!0,n.push(b),e)s([\"minSize\",\"maxSize\"],function(a){var b=g[a],e=/%$/.test(b),b=B(b);h[a]=e?f*b/100:b}),b.minPxSize=h.minSize,b.maxPxSize=h.maxSize,b=b.zData,b.length&&(k=r(g.zMin,y.min(k,y.max(R(b),g.displayNegative===!1?g.zThreshold:-Number.MAX_VALUE))),i=r(g.zMax,y.max(i,S(b))))});s(n,function(b){var c=b[j],f=c.length,h;e&&b.getRadii(k,i,b.minPxSize,b.maxPxSize);if(m>0)for(;f--;)G(c[f])&&a.dataMin<=c[f]&&c[f]<=a.dataMax&&(h=b.radii[f],d=Math.min((c[f]-l)*p-h,d),g=Math.max((c[f]-l)*p+h,g))});n.length&&\nm>0&&!this.isLog&&(g-=b,p*=(b+d-g)/b,s([[\"min\",\"userMin\",d],[\"max\",\"userMax\",g]],function(b){r(a.options[b[0]],a[b[1]])===void 0&&(a[b[0]]+=b[2]/p)}))};(function(){function a(a,b){var c=this.chart,d=this.options.animation,h=this.group,f=this.markerGroup,k=this.xAxis.center,i=c.plotLeft,m=c.plotTop;if(c.polar){if(c.renderer.isSVG)d===!0&&(d={}),b?(c={translateX:k[0]+i,translateY:k[1]+m,scaleX:0.001,scaleY:0.001},h.attr(c),f&&f.attr(c)):(c={translateX:i,translateY:m,scaleX:1,scaleY:1},h.animate(c,d),\nf&&f.animate(c,d),this.animate=null)}else a.call(this,b)}var b=x.prototype,c=U.prototype,d;b.searchPointByAngle=function(a){var b=this.chart,c=this.xAxis.pane.center;return this.searchKDTree({clientX:180+Math.atan2(a.chartX-c[0]-b.plotLeft,a.chartY-c[1]-b.plotTop)*(-180/Math.PI)})};w(b,\"buildKDTree\",function(a){if(this.chart.polar)this.kdByAngle?this.searchPoint=this.searchPointByAngle:this.kdDimensions=2;a.apply(this)});b.toXY=function(a){var b,c=this.chart,d=a.plotX;b=a.plotY;a.rectPlotX=d;a.rectPlotY=\nb;b=this.xAxis.postTranslate(a.plotX,this.yAxis.len-b);a.plotX=a.polarPlotX=b.x-c.plotLeft;a.plotY=a.polarPlotY=b.y-c.plotTop;this.kdByAngle?(c=(d/Math.PI*180+this.xAxis.pane.options.startAngle)%360,c<0&&(c+=360),a.clientX=c):a.clientX=a.plotX};i.spline&&w(i.spline.prototype,\"getPointSpline\",function(a,b,c,d){var h,f,k,i,m,p,n;if(this.chart.polar){h=c.plotX;f=c.plotY;a=b[d-1];k=b[d+1];this.connectEnds&&(a||(a=b[b.length-2]),k||(k=b[1]));if(a&&k)i=a.plotX,m=a.plotY,b=k.plotX,p=k.plotY,i=(1.5*h+i)/\n2.5,m=(1.5*f+m)/2.5,k=(1.5*h+b)/2.5,n=(1.5*f+p)/2.5,b=Math.sqrt(Math.pow(i-h,2)+Math.pow(m-f,2)),p=Math.sqrt(Math.pow(k-h,2)+Math.pow(n-f,2)),i=Math.atan2(m-f,i-h),m=Math.atan2(n-f,k-h),n=Math.PI/2+(i+m)/2,Math.abs(i-n)>Math.PI/2&&(n-=Math.PI),i=h+Math.cos(n)*b,m=f+Math.sin(n)*b,k=h+Math.cos(Math.PI+n)*p,n=f+Math.sin(Math.PI+n)*p,c.rightContX=k,c.rightContY=n;d?(c=[\"C\",a.rightContX||a.plotX,a.rightContY||a.plotY,i||h,m||f,h,f],a.rightContX=a.rightContY=null):c=[\"M\",h,f]}else c=a.call(this,b,c,d);\nreturn c});w(b,\"translate\",function(a){var b=this.chart;a.call(this);if(b.polar&&(this.kdByAngle=b.tooltip&&b.tooltip.shared,!this.preventPostTranslate)){a=this.points;for(b=a.length;b--;)this.toXY(a[b])}});w(b,\"getGraphPath\",function(a,b){var c=this,d,h;if(this.chart.polar){b=b||this.points;for(d=0;d<b.length;d++)if(!b[d].isNull){h=d;break}if(this.options.connectEnds!==!1&&h!==void 0)this.connectEnds=!0,b.splice(b.length,0,b[h]);s(b,function(a){a.polarPlotY===void 0&&c.toXY(a)})}return a.apply(this,\n[].slice.call(arguments,1))});w(b,\"animate\",a);if(i.column)d=i.column.prototype,d.polarArc=function(a,b,c,d){var h=this.xAxis.center,f=this.yAxis.len;return this.chart.renderer.symbols.arc(h[0],h[1],f-b,null,{start:c,end:d,innerR:f-r(a,f)})},w(d,\"animate\",a),w(d,\"translate\",function(a){var b=this.xAxis,c=b.startAngleRad,d,h,f;this.preventPostTranslate=!0;a.call(this);if(b.isRadial){d=this.points;for(f=d.length;f--;)h=d[f],a=h.barX+c,h.shapeType=\"path\",h.shapeArgs={d:this.polarArc(h.yBottom,h.plotY,\na,a+h.pointWidth)},this.toXY(h),h.tooltipPos=[h.plotX,h.plotY],h.ttBelow=h.plotY>b.center[1]}}),w(d,\"alignDataLabel\",function(a,c,d,i,h,f){if(this.chart.polar){a=c.rectPlotX/Math.PI*180;if(i.align===null)i.align=a>20&&a<160?\"left\":a>200&&a<340?\"right\":\"center\";if(i.verticalAlign===null)i.verticalAlign=a<45||a>315?\"bottom\":a>135&&a<225?\"top\":\"middle\";b.alignDataLabel.call(this,c,d,i,h,f)}else a.call(this,c,d,i,h,f)});w(c,\"getCoordinates\",function(a,b){var c=this.chart,d={xAxis:[],yAxis:[]};c.polar?\ns(c.axes,function(a){var f=a.isXAxis,g=a.center,i=b.chartX-g[0]-c.plotLeft,g=b.chartY-g[1]-c.plotTop;d[f?\"xAxis\":\"yAxis\"].push({axis:a,value:a.translate(f?Math.PI-Math.atan2(i,g):Math.sqrt(Math.pow(i,2)+Math.pow(g,2)),!0)})}):d=a.call(this,b);return d})})()});\n"

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1510))

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	module.exports = "/*\n Highcharts JS v4.2.7 (2016-09-21)\n Data module\n\n (c) 2012-2016 Torstein Honsi\n\n License: www.highcharts.com/license\n*/\n(function(g){typeof module===\"object\"&&module.exports?module.exports=g:g(Highcharts)})(function(g){var v=g.win.document,k=g.each,w=g.pick,s=g.inArray,t=g.isNumber,x=g.splat,l,p=function(b,a){this.init(b,a)};g.extend(p.prototype,{init:function(b,a){this.options=b;this.chartOptions=a;this.columns=b.columns||this.rowsToColumns(b.rows)||[];this.firstRowAsNames=w(b.firstRowAsNames,!0);this.decimalRegex=b.decimalPoint&&RegExp(\"^(-?[0-9]+)\"+b.decimalPoint+\"([0-9]+)$\");this.rawColumns=[];this.columns.length?\nthis.dataFound():(this.parseCSV(),this.parseTable(),this.parseGoogleSpreadsheet())},getColumnDistribution:function(){var b=this.chartOptions,a=this.options,e=[],f=function(b){return(g.seriesTypes[b||\"line\"].prototype.pointArrayMap||[0]).length},d=b&&b.chart&&b.chart.type,c=[],h=[],r=0,i;k(b&&b.series||[],function(b){c.push(f(b.type||d))});k(a&&a.seriesMapping||[],function(b){e.push(b.x||0)});e.length===0&&e.push(0);k(a&&a.seriesMapping||[],function(a){var e=new l,o,n=c[r]||f(d),m=g.seriesTypes[((b&&\nb.series||[])[r]||{}).type||d||\"line\"].prototype.pointArrayMap||[\"y\"];e.addColumnReader(a.x,\"x\");for(o in a)a.hasOwnProperty(o)&&o!==\"x\"&&e.addColumnReader(a[o],o);for(i=0;i<n;i++)e.hasReader(m[i])||e.addColumnReader(void 0,m[i]);h.push(e);r++});a=g.seriesTypes[d||\"line\"].prototype.pointArrayMap;a===void 0&&(a=[\"y\"]);this.valueCount={global:f(d),xColumns:e,individual:c,seriesBuilders:h,globalPointArrayMap:a}},dataFound:function(){if(this.options.switchRowsAndColumns)this.columns=this.rowsToColumns(this.columns);\nthis.getColumnDistribution();this.parseTypes();this.parsed()!==!1&&this.complete()},parseCSV:function(){var b=this,a=this.options,e=a.csv,f=this.columns,d=a.startRow||0,c=a.endRow||Number.MAX_VALUE,h=a.startColumn||0,r=a.endColumn||Number.MAX_VALUE,i,g,u=0;e&&(g=e.replace(/\\r\\n/g,\"\\n\").replace(/\\r/g,\"\\n\").split(a.lineDelimiter||\"\\n\"),i=a.itemDelimiter||(e.indexOf(\"\\t\")!==-1?\"\\t\":\",\"),k(g,function(a,e){var g=b.trim(a),q=g.indexOf(\"#\")===0;e>=d&&e<=c&&!q&&g!==\"\"&&(g=a.split(i),k(g,function(b,a){a>=\nh&&a<=r&&(f[a-h]||(f[a-h]=[]),f[a-h][u]=b)}),u+=1)}),this.dataFound())},parseTable:function(){var b=this.options,a=b.table,e=this.columns,f=b.startRow||0,d=b.endRow||Number.MAX_VALUE,c=b.startColumn||0,h=b.endColumn||Number.MAX_VALUE;a&&(typeof a===\"string\"&&(a=v.getElementById(a)),k(a.getElementsByTagName(\"tr\"),function(b,a){a>=f&&a<=d&&k(b.children,function(b,d){if((b.tagName===\"TD\"||b.tagName===\"TH\")&&d>=c&&d<=h)e[d-c]||(e[d-c]=[]),e[d-c][a-f]=b.innerHTML})}),this.dataFound())},parseGoogleSpreadsheet:function(){var b=\nthis,a=this.options,e=a.googleSpreadsheetKey,f=this.columns,d=a.startRow||0,c=a.endRow||Number.MAX_VALUE,h=a.startColumn||0,g=a.endColumn||Number.MAX_VALUE,i,q;e&&jQuery.ajax({dataType:\"json\",url:\"https://spreadsheets.google.com/feeds/cells/\"+e+\"/\"+(a.googleSpreadsheetWorksheet||\"od6\")+\"/public/values?alt=json-in-script&callback=?\",error:a.error,success:function(a){var a=a.feed.entry,e,n=a.length,m=0,l=0,j;for(j=0;j<n;j++)e=a[j],m=Math.max(m,e.gs$cell.col),l=Math.max(l,e.gs$cell.row);for(j=0;j<m;j++)if(j>=\nh&&j<=g)f[j-h]=[],f[j-h].length=Math.min(l,c-d);for(j=0;j<n;j++)if(e=a[j],i=e.gs$cell.row-1,q=e.gs$cell.col-1,q>=h&&q<=g&&i>=d&&i<=c)f[q-h][i-d]=e.content.$t;k(f,function(a){for(j=0;j<a.length;j++)a[j]===void 0&&(a[j]=null)});b.dataFound()}})},trim:function(b,a){typeof b===\"string\"&&(b=b.replace(/^\\s+|\\s+$/g,\"\"),a&&/^[0-9\\s]+$/.test(b)&&(b=b.replace(/\\s/g,\"\")),this.decimalRegex&&(b=b.replace(this.decimalRegex,\"$1.$2\")));return b},parseTypes:function(){for(var b=this.columns,a=b.length;a--;)this.parseColumn(b[a],\na)},parseColumn:function(b,a){var e=this.rawColumns,f=this.columns,d=b.length,c,h,g,i,l=this.firstRowAsNames,k=s(a,this.valueCount.xColumns)!==-1,o=[],n=this.chartOptions,m,p=(this.options.columnTypes||[])[a],n=k&&(n&&n.xAxis&&x(n.xAxis)[0].type===\"category\"||p===\"string\");for(e[a]||(e[a]=[]);d--;)if(c=o[d]||b[d],g=this.trim(c),i=this.trim(c,!0),h=parseFloat(i),e[a][d]===void 0&&(e[a][d]=g),n||d===0&&l)b[d]=g;else if(+i===h)b[d]=h,h>31536E6&&p!==\"float\"?b.isDatetime=!0:b.isNumeric=!0,b[d+1]!==void 0&&\n(m=h>b[d+1]);else if(h=this.parseDate(c),k&&t(h)&&p!==\"float\"){if(o[d]=c,b[d]=h,b.isDatetime=!0,b[d+1]!==void 0){c=h>b[d+1];if(c!==m&&m!==void 0)this.alternativeFormat?(this.dateFormat=this.alternativeFormat,d=b.length,this.alternativeFormat=this.dateFormats[this.dateFormat].alternative):b.unsorted=!0;m=c}}else if(b[d]=g===\"\"?null:g,d!==0&&(b.isDatetime||b.isNumeric))b.mixed=!0;k&&b.mixed&&(f[a]=e[a]);if(k&&m&&this.options.sort)for(a=0;a<f.length;a++)f[a].reverse(),l&&f[a].unshift(f[a].pop())},dateFormats:{\"YYYY-mm-dd\":{regex:/^([0-9]{4})[\\-\\/\\.]([0-9]{2})[\\-\\/\\.]([0-9]{2})$/,\nparser:function(b){return Date.UTC(+b[1],b[2]-1,+b[3])}},\"dd/mm/YYYY\":{regex:/^([0-9]{1,2})[\\-\\/\\.]([0-9]{1,2})[\\-\\/\\.]([0-9]{4})$/,parser:function(b){return Date.UTC(+b[3],b[2]-1,+b[1])},alternative:\"mm/dd/YYYY\"},\"mm/dd/YYYY\":{regex:/^([0-9]{1,2})[\\-\\/\\.]([0-9]{1,2})[\\-\\/\\.]([0-9]{4})$/,parser:function(b){return Date.UTC(+b[3],b[1]-1,+b[2])}},\"dd/mm/YY\":{regex:/^([0-9]{1,2})[\\-\\/\\.]([0-9]{1,2})[\\-\\/\\.]([0-9]{2})$/,parser:function(b){return Date.UTC(+b[3]+2E3,b[2]-1,+b[1])},alternative:\"mm/dd/YY\"},\n\"mm/dd/YY\":{regex:/^([0-9]{1,2})[\\-\\/\\.]([0-9]{1,2})[\\-\\/\\.]([0-9]{2})$/,parser:function(b){return Date.UTC(+b[3]+2E3,b[1]-1,+b[2])}}},parseDate:function(b){var a=this.options.parseDate,e,f,d=this.options.dateFormat||this.dateFormat,c;if(a)e=a(b);else if(typeof b===\"string\"){if(d)a=this.dateFormats[d],(c=b.match(a.regex))&&(e=a.parser(c));else for(f in this.dateFormats)if(a=this.dateFormats[f],c=b.match(a.regex)){this.dateFormat=f;this.alternativeFormat=a.alternative;e=a.parser(c);break}c||(c=Date.parse(b),\ntypeof c===\"object\"&&c!==null&&c.getTime?e=c.getTime()-c.getTimezoneOffset()*6E4:t(c)&&(e=c-(new Date(c)).getTimezoneOffset()*6E4))}return e},rowsToColumns:function(b){var a,e,f,d,c;if(b){c=[];e=b.length;for(a=0;a<e;a++){d=b[a].length;for(f=0;f<d;f++)c[f]||(c[f]=[]),c[f][a]=b[a][f]}}return c},parsed:function(){if(this.options.parsed)return this.options.parsed.call(this,this.columns)},getFreeIndexes:function(b,a){var e,f,d=[],c=[],h;for(f=0;f<b;f+=1)d.push(!0);for(e=0;e<a.length;e+=1){h=a[e].getReferencedColumnIndexes();\nfor(f=0;f<h.length;f+=1)d[h[f]]=!1}for(f=0;f<d.length;f+=1)d[f]&&c.push(f);return c},complete:function(){var b=this.columns,a,e=this.options,f,d,c,h,g=[],i;if(e.complete||e.afterComplete){for(c=0;c<b.length;c++)if(this.firstRowAsNames)b[c].name=b[c].shift();f=[];d=this.getFreeIndexes(b.length,this.valueCount.seriesBuilders);for(c=0;c<this.valueCount.seriesBuilders.length;c++)i=this.valueCount.seriesBuilders[c],i.populateColumns(d)&&g.push(i);for(;d.length>0;){i=new l;i.addColumnReader(0,\"x\");c=s(0,\nd);c!==-1&&d.splice(c,1);for(c=0;c<this.valueCount.global;c++)i.addColumnReader(void 0,this.valueCount.globalPointArrayMap[c]);i.populateColumns(d)&&g.push(i)}g.length>0&&g[0].readers.length>0&&(i=b[g[0].readers[0].columnIndex],i!==void 0&&(i.isDatetime?a=\"datetime\":i.isNumeric||(a=\"category\")));if(a===\"category\")for(c=0;c<g.length;c++){i=g[c];for(d=0;d<i.readers.length;d++)if(i.readers[d].configName===\"x\")i.readers[d].configName=\"name\"}for(c=0;c<g.length;c++){i=g[c];d=[];for(h=0;h<b[0].length;h++)d[h]=\ni.read(b,h);f[c]={data:d};if(i.name)f[c].name=i.name;if(a===\"category\")f[c].turboThreshold=0}b={series:f};if(a&&(b.xAxis={type:a},a===\"category\"))b.xAxis.nameToX=!1;e.complete&&e.complete(b);e.afterComplete&&e.afterComplete(b)}}});g.Data=p;g.data=function(b,a){return new p(b,a)};g.wrap(g.Chart.prototype,\"init\",function(b,a,e){var f=this;a&&a.data?g.data(g.extend(a.data,{afterComplete:function(d){var c,h;if(a.hasOwnProperty(\"series\"))if(typeof a.series===\"object\")for(c=Math.max(a.series.length,d.series.length);c--;)h=\na.series[c]||{},a.series[c]=g.merge(h,d.series[c]);else delete a.series;a=g.merge(d,a);b.call(f,a,e)}}),a):b.call(f,a,e)});l=function(){this.readers=[];this.pointIsArray=!0};l.prototype.populateColumns=function(b){var a=!0;k(this.readers,function(a){if(a.columnIndex===void 0)a.columnIndex=b.shift()});k(this.readers,function(b){b.columnIndex===void 0&&(a=!1)});return a};l.prototype.read=function(b,a){var e=this.pointIsArray,f=e?[]:{},d;k(this.readers,function(c){var d=b[c.columnIndex][a];e?f.push(d):\nf[c.configName]=d});if(this.name===void 0&&this.readers.length>=2&&(d=this.getReferencedColumnIndexes(),d.length>=2))d.shift(),d.sort(),this.name=b[d.shift()].name;return f};l.prototype.addColumnReader=function(b,a){this.readers.push({columnIndex:b,configName:a});if(!(a===\"x\"||a===\"y\"||a===void 0))this.pointIsArray=!1};l.prototype.getReferencedColumnIndexes=function(){var b,a=[],e;for(b=0;b<this.readers.length;b+=1)e=this.readers[b],e.columnIndex!==void 0&&a.push(e.columnIndex);return a};l.prototype.hasReader=\nfunction(b){var a,e;for(a=0;a<this.readers.length;a+=1)if(e=this.readers[a],e.configName===b)return!0}});\n"

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1512))

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	module.exports = "/*\n Highmaps JS v4.2.7 (2016-09-21)\n Highmaps as a plugin for Highcharts 4.1.x or Highstock 2.1.x (x being the patch version of this file)\n\n (c) 2011-2016 Torstein Honsi\n\n License: www.highcharts.com/license\n*/\n(function(h){typeof module===\"object\"&&module.exports?module.exports=h:h(Highcharts)})(function(h){function H(a){if(a)a.preventDefault&&a.preventDefault(),a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0}function M(a,b){var c,d,e,f,g=!1,i=a.x,k=a.y;for(c=0,d=b.length-1;c<b.length;d=c++)e=b[c][1]>k,f=b[d][1]>k,e!==f&&i<(b[d][0]-b[c][0])*(k-b[c][1])/(b[d][1]-b[c][1])+b[c][0]&&(g=!g);return g}function N(a,b,c,d,e,f,g,i){return[\"M\",a+e,b,\"L\",a+c-f,b,\"C\",a+c-f/2,b,a+c,b+f/2,a+c,b+f,\"L\",a+c,b+d-\ng,\"C\",a+c,b+d-g/2,a+c-g/2,b+d,a+c-g,b+d,\"L\",a+i,b+d,\"C\",a+i/2,b+d,a,b+d-i/2,a,b+d-i,\"L\",a,b+e,\"C\",a,b+e/2,a+e/2,b,a+e,b,\"Z\"]}var T=h.animObject,n=h.Axis,q=h.Chart,w=h.Color,s=h.Point,I=h.Pointer,D=h.Legend,J=h.LegendSymbolMixin,U=h.Renderer,y=h.Series,K=h.SVGRenderer,O=h.VMLRenderer,A=h.win,P=A.document,L=h.addEvent,l=h.each,E=h.error,o=h.extend,t=h.extendClass,Q=h.format,V=h.map,F=h.isNumber,p=h.merge,m=h.pick,B=h.getOptions(),j=h.seriesTypes,v=B.plotOptions,u=h.wrap,r=function(){};u(n.prototype,\n\"getSeriesExtremes\",function(a){var b=this.isXAxis,c,d,e=[],f;b&&l(this.series,function(a,b){if(a.useMapGeometry)e[b]=a.xData,a.xData=[]});a.call(this);if(b&&(c=m(this.dataMin,Number.MAX_VALUE),d=m(this.dataMax,-Number.MAX_VALUE),l(this.series,function(a,b){if(a.useMapGeometry)c=Math.min(c,m(a.minX,c)),d=Math.max(d,m(a.maxX,c)),a.xData=e[b],f=!0}),f))this.dataMin=c,this.dataMax=d});u(n.prototype,\"setAxisTranslation\",function(a){var b=this.chart,c=b.plotWidth/b.plotHeight,b=b.xAxis[0],d;a.call(this);\nthis.coll===\"yAxis\"&&b.transA!==void 0&&l(this.series,function(a){a.preserveAspectRatio&&(d=!0)});if(d&&(this.transA=b.transA=Math.min(this.transA,b.transA),a=c/((b.max-b.min)/(this.max-this.min)),a=a<1?this:b,c=(a.max-a.min)*a.transA,a.pixelPadding=a.len-c,a.minPixelPadding=a.pixelPadding/2,c=a.fixTo)){c=c[1]-a.toValue(c[0],!0);c*=a.transA;if(Math.abs(c)>a.minPixelPadding||a.min===a.dataMin&&a.max===a.dataMax)c=0;a.minPixelPadding-=c}});u(n.prototype,\"render\",function(a){a.call(this);this.fixTo=\nnull});var C=h.ColorAxis=function(){this.init.apply(this,arguments)};o(C.prototype,n.prototype);o(C.prototype,{defaultColorAxisOptions:{lineWidth:0,minPadding:0,maxPadding:0,gridLineWidth:1,tickPixelInterval:72,startOnTick:!0,endOnTick:!0,offset:0,marker:{animation:{duration:50},color:\"gray\",width:0.01},labels:{overflow:\"justify\"},minColor:\"#EFEFFF\",maxColor:\"#003875\",tickLength:5,showInLegend:!0},init:function(a,b){var c=a.options.legend.layout!==\"vertical\",d;this.coll=\"colorAxis\";d=p(this.defaultColorAxisOptions,\n{side:c?2:1,reversed:!c},b,{opposite:!c,showEmpty:!1,title:null});n.prototype.init.call(this,a,d);b.dataClasses&&this.initDataClasses(b);this.initStops(b);this.horiz=c;this.zoomEnabled=!1;this.defaultLegendLength=200},tweenColors:function(a,b,c){var d;!b.rgba.length||!a.rgba.length?a=b.input||\"none\":(a=a.rgba,b=b.rgba,d=b[3]!==1||a[3]!==1,a=(d?\"rgba(\":\"rgb(\")+Math.round(b[0]+(a[0]-b[0])*(1-c))+\",\"+Math.round(b[1]+(a[1]-b[1])*(1-c))+\",\"+Math.round(b[2]+(a[2]-b[2])*(1-c))+(d?\",\"+(b[3]+(a[3]-b[3])*(1-\nc)):\"\")+\")\");return a},initDataClasses:function(a){var b=this,c=this.chart,d,e=0,f=this.options,g=a.dataClasses.length;this.dataClasses=d=[];this.legendItems=[];l(a.dataClasses,function(a,k){var h,a=p(a);d.push(a);if(!a.color)f.dataClassColor===\"category\"?(h=c.options.colors,a.color=h[e++],e===h.length&&(e=0)):a.color=b.tweenColors(w(f.minColor),w(f.maxColor),g<2?0.5:k/(g-1))})},initStops:function(a){this.stops=a.stops||[[0,this.options.minColor],[1,this.options.maxColor]];l(this.stops,function(a){a.color=\nw(a[1])})},setOptions:function(a){n.prototype.setOptions.call(this,a);this.options.crosshair=this.options.marker},setAxisSize:function(){var a=this.legendSymbol,b=this.chart,c=b.options.legend||{},d,e;a?(this.left=c=a.attr(\"x\"),this.top=d=a.attr(\"y\"),this.width=e=a.attr(\"width\"),this.height=a=a.attr(\"height\"),this.right=b.chartWidth-c-e,this.bottom=b.chartHeight-d-a,this.len=this.horiz?e:a,this.pos=this.horiz?c:d):this.len=(this.horiz?c.symbolWidth:c.symbolHeight)||this.defaultLegendLength},toColor:function(a,\nb){var c,d=this.stops,e,f=this.dataClasses,g,i;if(f)for(i=f.length;i--;){if(g=f[i],e=g.from,d=g.to,(e===void 0||a>=e)&&(d===void 0||a<=d)){c=g.color;if(b)b.dataClass=i;break}}else{this.isLog&&(a=this.val2lin(a));c=1-(this.max-a)/(this.max-this.min||1);for(i=d.length;i--;)if(c>d[i][0])break;e=d[i]||d[i+1];d=d[i+1]||e;c=1-(d[0]-c)/(d[0]-e[0]||1);c=this.tweenColors(e.color,d.color,c)}return c},getOffset:function(){var a=this.legendGroup,b=this.chart.axisOffset[this.side];if(a){this.axisParent=a;n.prototype.getOffset.call(this);\nif(!this.added)this.added=!0,this.labelLeft=0,this.labelRight=this.width;this.chart.axisOffset[this.side]=b}},setLegendColor:function(){var a,b=this.options,c=this.reversed;a=c?1:0;c=c?0:1;a=this.horiz?[a,0,c,0]:[0,c,0,a];this.legendColor={linearGradient:{x1:a[0],y1:a[1],x2:a[2],y2:a[3]},stops:b.stops||[[0,b.minColor],[1,b.maxColor]]}},drawLegendSymbol:function(a,b){var c=a.padding,d=a.options,e=this.horiz,f=m(d.symbolWidth,e?this.defaultLegendLength:12),g=m(d.symbolHeight,e?12:this.defaultLegendLength),\ni=m(d.labelPadding,e?16:30),d=m(d.itemDistance,10);this.setLegendColor();b.legendSymbol=this.chart.renderer.rect(0,a.baseline-11,f,g).attr({zIndex:1}).add(b.legendGroup);this.legendItemWidth=f+c+(e?d:i);this.legendItemHeight=g+c+(e?i:0)},setState:r,visible:!0,setVisible:r,getSeriesExtremes:function(){var a;if(this.series.length)a=this.series[0],this.dataMin=a.valueMin,this.dataMax=a.valueMax},drawCrosshair:function(a,b){var c=b&&b.plotX,d=b&&b.plotY,e,f=this.pos,g=this.len;if(b)e=this.toPixels(b[b.series.colorKey]),\ne<f?e=f-2:e>f+g&&(e=f+g+2),b.plotX=e,b.plotY=this.len-e,n.prototype.drawCrosshair.call(this,a,b),b.plotX=c,b.plotY=d,this.cross&&this.cross.attr({fill:this.crosshair.color}).add(this.legendGroup)},getPlotLinePath:function(a,b,c,d,e){return F(e)?this.horiz?[\"M\",e-4,this.top-6,\"L\",e+4,this.top-6,e,this.top,\"Z\"]:[\"M\",this.left,e,\"L\",this.left-6,e+6,this.left-6,e-6,\"Z\"]:n.prototype.getPlotLinePath.call(this,a,b,c,d)},update:function(a,b){var c=this.chart,d=c.legend;l(this.series,function(a){a.isDirtyData=\n!0});if(a.dataClasses&&d.allItems)l(d.allItems,function(a){a.isDataClass&&a.legendGroup.destroy()}),c.isDirtyLegend=!0;c.options[this.coll]=p(this.userOptions,a);n.prototype.update.call(this,a,b);this.legendItem&&(this.setLegendColor(),d.colorizeItem(this,!0))},getDataClassLegendSymbols:function(){var a=this,b=this.chart,c=this.legendItems,d=b.options.legend,e=d.valueDecimals,f=d.valueSuffix||\"\",g;c.length||l(this.dataClasses,function(d,k){var x=!0,z=d.from,m=d.to;g=\"\";z===void 0?g=\"< \":m===void 0&&\n(g=\"> \");z!==void 0&&(g+=h.numberFormat(z,e)+f);z!==void 0&&m!==void 0&&(g+=\" - \");m!==void 0&&(g+=h.numberFormat(m,e)+f);c.push(o({chart:b,name:g,options:{},drawLegendSymbol:J.drawRectangle,visible:!0,setState:r,isDataClass:!0,setVisible:function(){x=this.visible=!x;l(a.series,function(a){l(a.points,function(a){a.dataClass===k&&a.setVisible(x)})});b.legend.colorizeItem(this,x)}},d))});return c},name:\"\"});l([\"fill\",\"stroke\"],function(a){h.Fx.prototype[a+\"Setter\"]=function(){this.elem.attr(a,C.prototype.tweenColors(w(this.start),\nw(this.end),this.pos))}});u(q.prototype,\"getAxes\",function(a){var b=this.options.colorAxis;a.call(this);this.colorAxis=[];b&&new C(this,b)});u(D.prototype,\"getAllItems\",function(a){var b=[],c=this.chart.colorAxis[0];c&&(c.options.showInLegend&&(c.options.dataClasses?b=b.concat(c.getDataClassLegendSymbols()):b.push(c)),l(c.series,function(a){a.options.showInLegend=!1}));return b.concat(a.call(this))});var D={setVisible:function(a){var b=this,c=a?\"show\":\"hide\";l([\"graphic\",\"dataLabel\"],function(a){if(b[a])b[a][c]()})}},\nR={pointAttrToOptions:{stroke:\"borderColor\",\"stroke-width\":\"borderWidth\",fill:\"color\",dashstyle:\"dashStyle\"},pointArrayMap:[\"value\"],axisTypes:[\"xAxis\",\"yAxis\",\"colorAxis\"],optionalAxis:\"colorAxis\",trackerGroups:[\"group\",\"markerGroup\",\"dataLabelsGroup\"],getSymbol:r,parallelArrays:[\"x\",\"y\",\"value\"],colorKey:\"value\",translateColors:function(){var a=this,b=this.options.nullColor,c=this.colorAxis,d=this.colorKey;l(this.data,function(e){var f=e[d];if(f=e.options.color||(f===null?b:c&&f!==void 0?c.toColor(f,\ne):e.color||a.color))e.color=f})}};o(q.prototype,{renderMapNavigation:function(){var a=this,b=this.options.mapNavigation,c=b.buttons,d,e,f,g,i=function(b){this.handler.call(a,b);H(b)};if(m(b.enableButtons,b.enabled)&&!a.renderer.forExport)for(d in a.mapNavButtons=[],c)if(c.hasOwnProperty(d))f=p(b.buttonOptions,c[d]),e=f.theme,e.style=p(f.theme.style,f.style),g=e.states,e=a.renderer.button(f.text,0,0,i,e,g&&g.hover,g&&g.select,0,d===\"zoomIn\"?\"topbutton\":\"bottombutton\").attr({width:f.width,height:f.height,\ntitle:a.options.lang[d],zIndex:5}).add(),e.handler=f.onclick,e.align(o(f,{width:e.width,height:2*e.height}),null,f.alignTo),L(e.element,\"dblclick\",H),a.mapNavButtons.push(e)},fitToBox:function(a,b){l([[\"x\",\"width\"],[\"y\",\"height\"]],function(c){var d=c[0],c=c[1];a[d]+a[c]>b[d]+b[c]&&(a[c]>b[c]?(a[c]=b[c],a[d]=b[d]):a[d]=b[d]+b[c]-a[c]);a[c]>b[c]&&(a[c]=b[c]);a[d]<b[d]&&(a[d]=b[d])});return a},mapZoom:function(a,b,c,d,e){var f=this.xAxis[0],g=f.max-f.min,i=m(b,f.min+g/2),k=g*a,g=this.yAxis[0],h=g.max-\ng.min,z=m(c,g.min+h/2);h*=a;i=this.fitToBox({x:i-k*(d?(d-f.pos)/f.len:0.5),y:z-h*(e?(e-g.pos)/g.len:0.5),width:k,height:h},{x:f.dataMin,y:g.dataMin,width:f.dataMax-f.dataMin,height:g.dataMax-g.dataMin});k=i.x<=f.dataMin&&i.width>=f.dataMax-f.dataMin&&i.y<=g.dataMin&&i.height>=g.dataMax-g.dataMin;if(d)f.fixTo=[d-f.pos,b];if(e)g.fixTo=[e-g.pos,c];a!==void 0&&!k?(f.setExtremes(i.x,i.x+i.width,!1),g.setExtremes(i.y,i.y+i.height,!1)):(f.setExtremes(void 0,void 0,!1),g.setExtremes(void 0,void 0,!1));this.redraw()}});\nu(q.prototype,\"render\",function(a){var b=this,c=b.options.mapNavigation;b.renderMapNavigation();a.call(b);(m(c.enableDoubleClickZoom,c.enabled)||c.enableDoubleClickZoomTo)&&L(b.container,\"dblclick\",function(a){b.pointer.onContainerDblClick(a)});m(c.enableMouseWheelZoom,c.enabled)&&L(b.container,P.onmousewheel===void 0?\"DOMMouseScroll\":\"mousewheel\",function(a){b.pointer.onContainerMouseWheel(a);H(a);return!1})});o(I.prototype,{onContainerDblClick:function(a){var b=this.chart,a=this.normalize(a);b.options.mapNavigation.enableDoubleClickZoomTo?\nb.pointer.inClass(a.target,\"highcharts-tracker\")&&b.hoverPoint&&b.hoverPoint.zoomTo():b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)&&b.mapZoom(0.5,b.xAxis[0].toValue(a.chartX),b.yAxis[0].toValue(a.chartY),a.chartX,a.chartY)},onContainerMouseWheel:function(a){var b=this.chart,c,a=this.normalize(a);c=a.detail||-(a.wheelDelta/120);b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)&&b.mapZoom(Math.pow(b.options.mapNavigation.mouseWheelSensitivity,c),b.xAxis[0].toValue(a.chartX),b.yAxis[0].toValue(a.chartY),\na.chartX,a.chartY)}});u(I.prototype,\"init\",function(a,b,c){a.call(this,b,c);if(m(c.mapNavigation.enableTouchZoom,c.mapNavigation.enabled))this.pinchX=this.pinchHor=this.pinchY=this.pinchVert=this.hasZoom=!0});u(I.prototype,\"pinchTranslate\",function(a,b,c,d,e,f,g){a.call(this,b,c,d,e,f,g);this.chart.options.chart.type===\"map\"&&this.hasZoom&&(a=d.scaleX>d.scaleY,this.pinchTranslateDirection(!a,b,c,d,e,f,g,a?d.scaleX:d.scaleY))});var G=P.documentElement.style.vectorEffect!==void 0;v.map=p(v.scatter,\n{allAreas:!0,animation:!1,nullColor:\"#F8F8F8\",borderColor:\"silver\",borderWidth:1,marker:null,stickyTracking:!1,dataLabels:{formatter:function(){return this.point.value},inside:!0,verticalAlign:\"middle\",crop:!1,overflow:!1,padding:0},turboThreshold:0,tooltip:{followPointer:!0,pointFormat:\"{point.name}: {point.value}<br/>\"},states:{normal:{animation:!0},hover:{brightness:0.2,halo:null}}});var S=t(s,o({applyOptions:function(a,b){var c=s.prototype.applyOptions.call(this,a,b),d=this.series,e=d.joinBy;\nif(d.mapData)if(e=c[e[1]]!==void 0&&d.mapMap[c[e[1]]]){if(d.xyFromShape)c.x=e._midX,c.y=e._midY;o(c,e)}else c.value=c.value||null;return c},onMouseOver:function(a){clearTimeout(this.colorInterval);if(this.value!==null||this.series.options.nullInteraction)s.prototype.onMouseOver.call(this,a);else this.series.onMouseOut(a)},onMouseOut:function(){var a=this,b=+new Date,c=w(a.color),d=w(a.pointAttr.hover.fill),e=T(a.series.options.states.normal.animation).duration,f;if(e&&c.rgba.length===4&&d.rgba.length===\n4&&a.state!==\"select\")f=a.pointAttr[\"\"].fill,delete a.pointAttr[\"\"].fill,clearTimeout(a.colorInterval),a.colorInterval=setInterval(function(){var g=(new Date-b)/e,f=a.graphic;g>1&&(g=1);f&&f.attr(\"fill\",C.prototype.tweenColors.call(0,d,c,g));g>=1&&clearTimeout(a.colorInterval)},13);s.prototype.onMouseOut.call(a);if(f)a.pointAttr[\"\"].fill=f},zoomTo:function(){var a=this.series;a.xAxis.setExtremes(this._minX,this._maxX,!1);a.yAxis.setExtremes(this._minY,this._maxY,!1);a.chart.redraw()}},D));j.map=t(j.scatter,\np(R,{type:\"map\",pointClass:S,supportsDrilldown:!0,getExtremesFromAll:!0,useMapGeometry:!0,forceDL:!0,searchPoint:r,directTouch:!0,preserveAspectRatio:!0,getBox:function(a){var b=Number.MAX_VALUE,c=-b,d=b,e=-b,f=b,g=b,i=this.xAxis,k=this.yAxis,x;l(a||[],function(a){if(a.path){if(typeof a.path===\"string\")a.path=h.splitPath(a.path);var i=a.path||[],k=i.length,l=!1,j=-b,p=b,o=-b,n=b,q=a.properties;if(!a._foundBox){for(;k--;)F(i[k])&&(l?(j=Math.max(j,i[k]),p=Math.min(p,i[k])):(o=Math.max(o,i[k]),n=Math.min(n,\ni[k])),l=!l);a._midX=p+(j-p)*(a.middleX||q&&q[\"hc-middle-x\"]||0.5);a._midY=n+(o-n)*(a.middleY||q&&q[\"hc-middle-y\"]||0.5);a._maxX=j;a._minX=p;a._maxY=o;a._minY=n;a.labelrank=m(a.labelrank,(j-p)*(o-n));a._foundBox=!0}c=Math.max(c,a._maxX);d=Math.min(d,a._minX);e=Math.max(e,a._maxY);f=Math.min(f,a._minY);g=Math.min(a._maxX-a._minX,a._maxY-a._minY,g);x=!0}});if(x){this.minY=Math.min(f,m(this.minY,b));this.maxY=Math.max(e,m(this.maxY,-b));this.minX=Math.min(d,m(this.minX,b));this.maxX=Math.max(c,m(this.maxX,\n-b));if(i&&i.options.minRange===void 0)i.minRange=Math.min(5*g,(this.maxX-this.minX)/5,i.minRange||b);if(k&&k.options.minRange===void 0)k.minRange=Math.min(5*g,(this.maxY-this.minY)/5,k.minRange||b)}},getExtremes:function(){y.prototype.getExtremes.call(this,this.valueData);this.chart.hasRendered&&this.isDirtyData&&this.getBox(this.options.data);this.valueMin=this.dataMin;this.valueMax=this.dataMax;this.dataMin=this.minY;this.dataMax=this.maxY},translatePath:function(a){var b=!1,c=this.xAxis,d=this.yAxis,\ne=c.min,f=c.transA,c=c.minPixelPadding,g=d.min,i=d.transA,d=d.minPixelPadding,k,h=[];if(a)for(k=a.length;k--;)F(a[k])?(h[k]=b?(a[k]-e)*f+c:(a[k]-g)*i+d,b=!b):h[k]=a[k];return h},setData:function(a,b,c,d){var e=this.options,f=e.mapData,g=e.joinBy,i=g===null,k=[],m={},j,n,o;i&&(g=\"_i\");g=this.joinBy=h.splat(g);g[1]||(g[1]=g[0]);a&&l(a,function(b,c){F(b)&&(a[c]={value:b});if(i)a[c]._i=c});this.getBox(a);if(f){if(f.type===\"FeatureCollection\"){if(f[\"hc-transform\"])for(j in this.chart.mapTransforms=n=f[\"hc-transform\"],\nn)if(n.hasOwnProperty(j)&&j.rotation)j.cosAngle=Math.cos(j.rotation),j.sinAngle=Math.sin(j.rotation);f=h.geojson(f,this.type,this)}this.mapData=f;for(o=0;o<f.length;o++)j=f[o],n=j.properties,j._i=o,g[0]&&n&&n[g[0]]&&(j[g[0]]=n[g[0]]),m[j[g[0]]]=j;this.mapMap=m;a&&g[1]&&l(a,function(a){m[a[g[1]]]&&k.push(m[a[g[1]]])});e.allAreas?(this.getBox(f),a=a||[],k=\"|\"+V(k,function(a){return a[g[0]]}).join(\"|\")+\"|\",l(f,function(b){if(!g[0]||k.indexOf(\"|\"+b[g[0]]+\"|\")===-1)a.push(p(b,{value:null})),d=!1})):this.getBox(k)}y.prototype.setData.call(this,\na,b,c,d)},drawGraph:r,drawDataLabels:r,doFullTranslate:function(){return this.isDirtyData||this.chart.isResizing||this.chart.renderer.isVML||!this.baseTrans},translate:function(){var a=this,b=a.xAxis,c=a.yAxis,d=a.doFullTranslate();a.generatePoints();l(a.data,function(e){e.plotX=b.toPixels(e._midX,!0);e.plotY=c.toPixels(e._midY,!0);if(d)e.shapeType=\"path\",e.shapeArgs={d:a.translatePath(e.path)},G&&(e.shapeArgs[\"vector-effect\"]=\"non-scaling-stroke\")});a.translateColors()},drawPoints:function(){var a=\nthis,b=a.xAxis,c=a.yAxis,d=a.group,e=a.chart,f=e.renderer,g,i=this.baseTrans;if(!a.transformGroup)a.transformGroup=f.g().attr({scaleX:1,scaleY:1}).add(d),a.transformGroup.survive=!0;a.doFullTranslate()?(e.hasRendered&&a.pointAttrToOptions.fill===\"color\"&&l(a.points,function(a){if(a.shapeArgs)a.shapeArgs.fill=a.pointAttr[m(a.state,\"\")].fill}),G||l(a.points,function(b){b=b.pointAttr[\"\"];b[\"stroke-width\"]===a.pointAttr[\"\"][\"stroke-width\"]&&(b[\"stroke-width\"]=\"inherit\")}),a.group=a.transformGroup,j.column.prototype.drawPoints.apply(a),\na.group=d,l(a.points,function(a){a.graphic&&(a.name&&a.graphic.addClass(\"highcharts-name-\"+a.name.replace(\" \",\"-\").toLowerCase()),a.properties&&a.properties[\"hc-key\"]&&a.graphic.addClass(\"highcharts-key-\"+a.properties[\"hc-key\"].toLowerCase()),G||(a.graphic[\"stroke-widthSetter\"]=r))}),this.baseTrans={originX:b.min-b.minPixelPadding/b.transA,originY:c.min-c.minPixelPadding/c.transA+(c.reversed?0:c.len/c.transA),transAX:b.transA,transAY:c.transA},this.transformGroup.animate({translateX:0,translateY:0,\nscaleX:1,scaleY:1})):(g=b.transA/i.transAX,d=c.transA/i.transAY,b=b.toPixels(i.originX,!0),c=c.toPixels(i.originY,!0),g>0.99&&g<1.01&&d>0.99&&d<1.01&&(d=g=1,b=Math.round(b),c=Math.round(c)),this.transformGroup.animate({translateX:b,translateY:c,scaleX:g,scaleY:d}));G||a.group.element.setAttribute(\"stroke-width\",a.options[a.pointAttrToOptions[\"stroke-width\"]]/(g||1));this.drawMapDataLabels()},drawMapDataLabels:function(){y.prototype.drawDataLabels.call(this);this.dataLabelsGroup&&this.dataLabelsGroup.clip(this.chart.clipRect)},\nrender:function(){var a=this,b=y.prototype.render;a.chart.renderer.isVML&&a.data.length>3E3?setTimeout(function(){b.call(a)}):b.call(a)},animate:function(a){var b=this.options.animation,c=this.group,d=this.xAxis,e=this.yAxis,f=d.pos,g=e.pos;if(this.chart.renderer.isSVG)b===!0&&(b={duration:1E3}),a?c.attr({translateX:f+d.len/2,translateY:g+e.len/2,scaleX:0.001,scaleY:0.001}):(c.animate({translateX:f,translateY:g,scaleX:1,scaleY:1},b),this.animate=null)},animateDrilldown:function(a){var b=this.chart.plotBox,\nc=this.chart.drilldownLevels[this.chart.drilldownLevels.length-1],d=c.bBox,e=this.chart.options.drilldown.animation;if(!a)a=Math.min(d.width/b.width,d.height/b.height),c.shapeArgs={scaleX:a,scaleY:a,translateX:d.x,translateY:d.y},l(this.points,function(a){a.graphic&&a.graphic.attr(c.shapeArgs).animate({scaleX:1,scaleY:1,translateX:0,translateY:0},e)}),this.animate=null},drawLegendSymbol:J.drawRectangle,animateDrillupFrom:function(a){j.column.prototype.animateDrillupFrom.call(this,a)},animateDrillupTo:function(a){j.column.prototype.animateDrillupTo.call(this,\na)}}));v.mapline=p(v.map,{lineWidth:1,fillColor:\"none\"});j.mapline=t(j.map,{type:\"mapline\",pointAttrToOptions:{stroke:\"color\",\"stroke-width\":\"lineWidth\",fill:\"fillColor\",dashstyle:\"dashStyle\"},drawLegendSymbol:j.line.prototype.drawLegendSymbol});v.mappoint=p(v.scatter,{dataLabels:{enabled:!0,formatter:function(){return this.point.name},crop:!1,defer:!1,overflow:!1,style:{color:\"#000000\"}}});j.mappoint=t(j.scatter,{type:\"mappoint\",forceDL:!0,pointClass:t(s,{applyOptions:function(a,b){var c=a.lat!==\nvoid 0&&a.lon!==void 0?p(a,this.series.chart.fromLatLonToPoint(a)):a;return s.prototype.applyOptions.call(this,c,b)}})});if(j.bubble)v.mapbubble=p(v.bubble,{animationLimit:500,tooltip:{pointFormat:\"{point.name}: {point.z}\"}}),j.mapbubble=t(j.bubble,{pointClass:t(s,{applyOptions:function(a,b){var c;a&&a.lat!==void 0&&a.lon!==void 0?(c=s.prototype.applyOptions.call(this,a,b),c=o(c,this.series.chart.fromLatLonToPoint(c))):c=S.prototype.applyOptions.call(this,a,b);return c},ttBelow:!1}),xyFromShape:!0,\ntype:\"mapbubble\",pointArrayMap:[\"z\"],getMapData:j.map.prototype.getMapData,getBox:j.map.prototype.getBox,setData:j.map.prototype.setData});B.plotOptions.heatmap=p(B.plotOptions.scatter,{animation:!1,borderWidth:0,nullColor:\"#F8F8F8\",dataLabels:{formatter:function(){return this.point.value},inside:!0,verticalAlign:\"middle\",crop:!1,overflow:!1,padding:0},marker:null,pointRange:null,tooltip:{pointFormat:\"{point.x}, {point.y}: {point.value}<br/>\"},states:{normal:{animation:!0},hover:{halo:!1,brightness:0.2}}});\nj.heatmap=t(j.scatter,p(R,{type:\"heatmap\",pointArrayMap:[\"y\",\"value\"],hasPointSpecificOptions:!0,pointClass:t(s,D),supportsDrilldown:!0,getExtremesFromAll:!0,directTouch:!0,init:function(){var a;j.scatter.prototype.init.apply(this,arguments);a=this.options;a.pointRange=m(a.pointRange,a.colsize||1);this.yAxis.axisPointRange=a.rowsize||1},translate:function(){var a=this.options,b=this.xAxis,c=this.yAxis,d=function(a,b,c){return Math.min(Math.max(b,a),c)};this.generatePoints();l(this.points,function(e){var f=\n(a.colsize||1)/2,g=(a.rowsize||1)/2,i=d(Math.round(b.len-b.translate(e.x-f,0,1,0,1)),-b.len,2*b.len),f=d(Math.round(b.len-b.translate(e.x+f,0,1,0,1)),-b.len,2*b.len),h=d(Math.round(c.translate(e.y-g,0,1,0,1)),-c.len,2*c.len),g=d(Math.round(c.translate(e.y+g,0,1,0,1)),-c.len,2*c.len);e.plotX=e.clientX=(i+f)/2;e.plotY=(h+g)/2;e.shapeType=\"rect\";e.shapeArgs={x:Math.min(i,f),y:Math.min(h,g),width:Math.abs(f-i),height:Math.abs(g-h)}});this.translateColors();this.chart.hasRendered&&l(this.points,function(a){a.shapeArgs.fill=\na.options.color||a.color})},drawPoints:j.column.prototype.drawPoints,animate:r,getBox:r,drawLegendSymbol:J.drawRectangle,alignDataLabel:j.column.prototype.alignDataLabel,getExtremes:function(){y.prototype.getExtremes.call(this,this.valueData);this.valueMin=this.dataMin;this.valueMax=this.dataMax;y.prototype.getExtremes.call(this)}}));q.prototype.transformFromLatLon=function(a,b){if(A.proj4===void 0)return E(21),{x:0,y:null};var c=A.proj4(b.crs,[a.lon,a.lat]),d=b.cosAngle||b.rotation&&Math.cos(b.rotation),\ne=b.sinAngle||b.rotation&&Math.sin(b.rotation),c=b.rotation?[c[0]*d+c[1]*e,-c[0]*e+c[1]*d]:c;return{x:((c[0]-(b.xoffset||0))*(b.scale||1)+(b.xpan||0))*(b.jsonres||1)+(b.jsonmarginX||0),y:(((b.yoffset||0)-c[1])*(b.scale||1)+(b.ypan||0))*(b.jsonres||1)-(b.jsonmarginY||0)}};q.prototype.transformToLatLon=function(a,b){if(A.proj4===void 0)E(21);else{var c={x:((a.x-(b.jsonmarginX||0))/(b.jsonres||1)-(b.xpan||0))/(b.scale||1)+(b.xoffset||0),y:((-a.y-(b.jsonmarginY||0))/(b.jsonres||1)+(b.ypan||0))/(b.scale||\n1)+(b.yoffset||0)},d=b.cosAngle||b.rotation&&Math.cos(b.rotation),e=b.sinAngle||b.rotation&&Math.sin(b.rotation),c=A.proj4(b.crs,\"WGS84\",b.rotation?{x:c.x*d+c.y*-e,y:c.x*e+c.y*d}:c);return{lat:c.y,lon:c.x}}};q.prototype.fromPointToLatLon=function(a){var b=this.mapTransforms,c;if(b){for(c in b)if(b.hasOwnProperty(c)&&b[c].hitZone&&M({x:a.x,y:-a.y},b[c].hitZone.coordinates[0]))return this.transformToLatLon(a,b[c]);return this.transformToLatLon(a,b[\"default\"])}else E(22)};q.prototype.fromLatLonToPoint=\nfunction(a){var b=this.mapTransforms,c,d;if(!b)return E(22),{x:0,y:null};for(c in b)if(b.hasOwnProperty(c)&&b[c].hitZone&&(d=this.transformFromLatLon(a,b[c]),M({x:d.x,y:-d.y},b[c].hitZone.coordinates[0])))return d;return this.transformFromLatLon(a,b[\"default\"])};h.geojson=function(a,b,c){var d=[],e=[],f=function(a){var b,c=a.length;e.push(\"M\");for(b=0;b<c;b++)b===1&&e.push(\"L\"),e.push(a[b][0],-a[b][1])},b=b||\"map\";l(a.features,function(a){var c=a.geometry,h=c.type,c=c.coordinates,a=a.properties,j;\ne=[];b===\"map\"||b===\"mapbubble\"?(h===\"Polygon\"?(l(c,f),e.push(\"Z\")):h===\"MultiPolygon\"&&(l(c,function(a){l(a,f)}),e.push(\"Z\")),e.length&&(j={path:e})):b===\"mapline\"?(h===\"LineString\"?f(c):h===\"MultiLineString\"&&l(c,f),e.length&&(j={path:e})):b===\"mappoint\"&&h===\"Point\"&&(j={x:c[0],y:-c[1]});j&&d.push(o(j,{name:a.name||a.NAME,properties:a}))});if(c&&a.copyrightShort)c.chart.mapCredits=Q(c.chart.options.credits.mapText,{geojson:a}),c.chart.mapCreditsFull=Q(c.chart.options.credits.mapTextFull,{geojson:a});\nreturn d};u(q.prototype,\"showCredits\",function(a,b){if(this.mapCredits)b.href=null;a.call(this,h.merge(b,{text:b.text+(this.mapCredits||\"\")}));this.credits&&this.mapCreditsFull&&this.credits.attr({title:this.mapCreditsFull})});o(B.lang,{zoomIn:\"Zoom in\",zoomOut:\"Zoom out\"});B.mapNavigation={buttonOptions:{alignTo:\"plotBox\",align:\"left\",verticalAlign:\"top\",x:0,width:18,height:18,style:{fontSize:\"15px\",fontWeight:\"bold\",textAlign:\"center\"},theme:{\"stroke-width\":1}},buttons:{zoomIn:{onclick:function(){this.mapZoom(0.5)},\ntext:\"+\",y:0},zoomOut:{onclick:function(){this.mapZoom(2)},text:\"-\",y:28}},mouseWheelSensitivity:1.1};h.splitPath=function(a){var b,a=a.replace(/([A-Za-z])/g,\" $1 \"),a=a.replace(/^\\s*/,\"\").replace(/\\s*$/,\"\"),a=a.split(/[ ,]+/);for(b=0;b<a.length;b++)/[a-zA-Z]/.test(a[b])||(a[b]=parseFloat(a[b]));return a};h.maps={};K.prototype.symbols.topbutton=function(a,b,c,d,e){return N(a-1,b-1,c,d,e.r,e.r,0,0)};K.prototype.symbols.bottombutton=function(a,b,c,d,e){return N(a-1,b-1,c,d,0,0,e.r,e.r)};U===O&&l([\"topbutton\",\n\"bottombutton\"],function(a){O.prototype.symbols[a]=K.prototype.symbols[a]});h.Map=h.mapChart=function(a,b,c){var d=typeof a===\"string\"||a.nodeName,e=arguments[d?1:0],f={endOnTick:!1,gridLineWidth:0,lineWidth:0,minPadding:0,maxPadding:0,startOnTick:!1,title:null,tickPositions:[]},g,i=h.getOptions().credits;g=e.series;e.series=null;e=p({chart:{panning:\"xy\",type:\"map\"},credits:{mapText:m(i.mapText,' \\u00a9 <a href=\"{geojson.copyrightUrl}\">{geojson.copyrightShort}</a>'),mapTextFull:m(i.mapTextFull,\"{geojson.copyright}\")},\nxAxis:f,yAxis:p(f,{reversed:!0})},e,{chart:{inverted:!1,alignTicks:!1}});e.series=g;return d?new q(a,e,c):new q(e,b)}});\n"

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1514))

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	module.exports = "/*\n Highcharts JS v4.2.7 (2016-09-21)\n Exporting module\n\n (c) 2010-2016 Torstein Honsi\n\n License: www.highcharts.com/license\n*/\n(function(f){typeof module===\"object\"&&module.exports?module.exports=f:f(Highcharts)})(function(f){var s=f.win,j=s.document,B=f.Chart,u=f.addEvent,C=f.removeEvent,D=f.fireEvent,r=f.createElement,t=f.discardElement,w=f.css,l=f.merge,m=f.each,q=f.extend,F=f.splat,G=Math.max,H=f.isTouchDevice,I=f.Renderer.prototype.symbols,z=f.getOptions(),A;q(z.lang,{printChart:\"Print chart\",downloadPNG:\"Download PNG image\",downloadJPEG:\"Download JPEG image\",downloadPDF:\"Download PDF document\",downloadSVG:\"Download SVG vector image\",\ncontextButtonTitle:\"Chart context menu\"});z.navigation={menuStyle:{border:\"1px solid #A0A0A0\",background:\"#FFFFFF\",padding:\"5px 0\"},menuItemStyle:{padding:\"0 10px\",background:\"none\",color:\"#303030\",fontSize:H?\"14px\":\"11px\"},menuItemHoverStyle:{background:\"#4572A5\",color:\"#FFFFFF\"},buttonOptions:{symbolFill:\"#E0E0E0\",symbolSize:14,symbolStroke:\"#666\",symbolStrokeWidth:3,symbolX:12.5,symbolY:10.5,align:\"right\",buttonSpacing:3,height:22,theme:{fill:\"white\",stroke:\"none\"},verticalAlign:\"top\",width:24}};\nz.exporting={type:\"image/png\",url:\"https://export.highcharts.com/\",printMaxWidth:780,scale:2,buttons:{contextButton:{menuClassName:\"highcharts-contextmenu\",symbol:\"menu\",_titleKey:\"contextButtonTitle\",menuItems:[{textKey:\"printChart\",onclick:function(){this.print()}},{separator:!0},{textKey:\"downloadPNG\",onclick:function(){this.exportChart()}},{textKey:\"downloadJPEG\",onclick:function(){this.exportChart({type:\"image/jpeg\"})}},{textKey:\"downloadPDF\",onclick:function(){this.exportChart({type:\"application/pdf\"})}},\n{textKey:\"downloadSVG\",onclick:function(){this.exportChart({type:\"image/svg+xml\"})}}]}}};f.post=function(a,b,e){var c,a=r(\"form\",l({method:\"post\",action:a,enctype:\"multipart/form-data\"},e),{display:\"none\"},j.body);for(c in b)r(\"input\",{type:\"hidden\",name:c,value:b[c]},null,a);a.submit();t(a)};q(B.prototype,{sanitizeSVG:function(a){return a.replace(/zIndex=\"[^\"]+\"/g,\"\").replace(/isShadow=\"[^\"]+\"/g,\"\").replace(/symbolName=\"[^\"]+\"/g,\"\").replace(/jQuery[0-9]+=\"[^\"]+\"/g,\"\").replace(/url\\((\"|&quot;)(\\S+)(\"|&quot;)\\)/g,\n\"url($2)\").replace(/url\\([^#]+#/g,\"url(#\").replace(/<svg /,'<svg xmlns:xlink=\"http://www.w3.org/1999/xlink\" ').replace(/ (NS[0-9]+\\:)?href=/g,\" xlink:href=\").replace(/\\n/,\" \").replace(/<\\/svg>.*?$/,\"</svg>\").replace(/(fill|stroke)=\"rgba\\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\\.]+)\\)\"/g,'$1=\"rgb($2)\" $1-opacity=\"$3\"').replace(/&nbsp;/g,\"\\u00a0\").replace(/&shy;/g,\"\\u00ad\").replace(/<IMG /g,\"<image \").replace(/<(\\/?)TITLE>/g,\"<$1title>\").replace(/height=([^\" ]+)/g,'height=\"$1\"').replace(/width=([^\" ]+)/g,\n'width=\"$1\"').replace(/hc-svg-href=\"([^\"]+)\">/g,'xlink:href=\"$1\"/>').replace(/ id=([^\" >]+)/g,' id=\"$1\"').replace(/class=([^\" >]+)/g,'class=\"$1\"').replace(/ transform /g,\" \").replace(/:(path|rect)/g,\"$1\").replace(/style=\"([^\"]+)\"/g,function(a){return a.toLowerCase()})},getChartHTML:function(){return this.container.innerHTML},getSVG:function(a){var b=this,e,c,g,k,h,d=l(b.options,a),n=d.exporting.allowHTML;if(!j.createElementNS)j.createElementNS=function(a,b){return j.createElement(b)};c=r(\"div\",null,\n{position:\"absolute\",top:\"-9999em\",width:b.chartWidth+\"px\",height:b.chartHeight+\"px\"},j.body);g=b.renderTo.style.width;h=b.renderTo.style.height;g=d.exporting.sourceWidth||d.chart.width||/px$/.test(g)&&parseInt(g,10)||600;h=d.exporting.sourceHeight||d.chart.height||/px$/.test(h)&&parseInt(h,10)||400;q(d.chart,{animation:!1,renderTo:c,forExport:!0,renderer:\"SVGRenderer\",width:g,height:h});d.exporting.enabled=!1;delete d.data;d.series=[];m(b.series,function(a){k=l(a.userOptions,{animation:!1,enableMouseTracking:!1,\nshowCheckbox:!1,visible:a.visible});k.isInternal||d.series.push(k)});a&&m([\"xAxis\",\"yAxis\"],function(b){m(F(a[b]),function(a,c){d[b][c]=l(d[b][c],a)})});e=new f.Chart(d,b.callback);m([\"xAxis\",\"yAxis\"],function(a){m(b[a],function(b,c){var d=e[a][c],f=b.getExtremes(),g=f.userMin,f=f.userMax;d&&(g!==void 0||f!==void 0)&&d.setExtremes(g,f,!0,!1)})});g=e.getChartHTML();d=null;e.destroy();t(c);if(n&&(c=g.match(/<\\/svg>(.*?$)/)))c='<foreignObject x=\"0\" y=\"0\" width=\"200\" height=\"200\"><body xmlns=\"http://www.w3.org/1999/xhtml\">'+\nc[1]+\"</body></foreignObject>\",g=g.replace(\"</svg>\",c+\"</svg>\");g=this.sanitizeSVG(g);return g=g.replace(/(url\\(#highcharts-[0-9]+)&quot;/g,\"$1\").replace(/&quot;/g,\"'\")},getSVGForExport:function(a,b){var e=this.options.exporting;return this.getSVG(l({chart:{borderRadius:0}},e.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,b){var e=this.getSVGForExport(a,b),a=l(this.options.exporting,a);f.post(a.url,\n{filename:a.filename||\"chart\",type:a.type,width:a.width||0,scale:a.scale,svg:e},a.formAttributes)},print:function(){var a=this,b=a.container,e=[],c=b.parentNode,f=j.body,k=f.childNodes,h=a.options.exporting.printMaxWidth,d,n;if(!a.isPrinting){a.isPrinting=!0;a.pointer.reset(null,0);D(a,\"beforePrint\");if(n=h&&a.chartWidth>h)d=[a.options.chart.width,void 0,!1],a.setSize(h,void 0,!1);m(k,function(a,b){if(a.nodeType===1)e[b]=a.style.display,a.style.display=\"none\"});f.appendChild(b);s.focus();s.print();\nsetTimeout(function(){c.appendChild(b);m(k,function(a,b){if(a.nodeType===1)a.style.display=e[b]});a.isPrinting=!1;n&&a.setSize.apply(a,d);D(a,\"afterPrint\")},1E3)}},contextMenu:function(a,b,e,c,f,k,h){var d=this,n=d.options.navigation,l=n.menuItemStyle,o=d.chartWidth,p=d.chartHeight,E=\"cache-\"+a,i=d[E],v=G(f,k),x,y,s,t=function(b){d.pointer.inClass(b.target,a)||y()};if(!i)d[E]=i=r(\"div\",{className:a},{position:\"absolute\",zIndex:1E3,padding:v+\"px\"},d.container),x=r(\"div\",null,q({MozBoxShadow:\"3px 3px 10px #888\",\nWebkitBoxShadow:\"3px 3px 10px #888\",boxShadow:\"3px 3px 10px #888\"},n.menuStyle),i),y=function(){w(i,{display:\"none\"});h&&h.setState(0);d.openMenu=!1},u(i,\"mouseleave\",function(){s=setTimeout(y,500)}),u(i,\"mouseenter\",function(){clearTimeout(s)}),u(j,\"mouseup\",t),u(d,\"destroy\",function(){C(j,\"mouseup\",t)}),m(b,function(a){if(a){var b=a.separator?r(\"hr\",null,null,x):r(\"div\",{onmouseover:function(){w(this,n.menuItemHoverStyle)},onmouseout:function(){w(this,l)},onclick:function(b){b&&b.stopPropagation();\ny();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},q({cursor:\"pointer\"},l),x);d.exportDivElements.push(b)}}),d.exportDivElements.push(x,i),d.exportMenuWidth=i.offsetWidth,d.exportMenuHeight=i.offsetHeight;b={display:\"block\"};e+d.exportMenuWidth>o?b.right=o-e-f-v+\"px\":b.left=e-v+\"px\";c+k+d.exportMenuHeight>p&&h.alignOptions.verticalAlign!==\"top\"?b.bottom=p-c-v+\"px\":b.top=c+k-v+\"px\";w(i,b);d.openMenu=!0},addButton:function(a){var b=this,e=b.renderer,c=l(b.options.navigation.buttonOptions,\na),g=c.onclick,k=c.menuItems,h,d,n={stroke:c.symbolStroke,fill:c.symbolFill},j=c.symbolSize||12;if(!b.btnCount)b.btnCount=0;if(!b.exportDivElements)b.exportDivElements=[],b.exportSVGElements=[];if(c.enabled!==!1){var o=c.theme,p=o.states,m=p&&p.hover,p=p&&p.select,i;delete o.states;g?i=function(a){a.stopPropagation();g.call(b,a)}:k&&(i=function(){b.contextMenu(d.menuClassName,k,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});c.text&&c.symbol?o.paddingLeft=f.pick(o.paddingLeft,25):c.text||\nq(o,{width:c.width,height:c.height,padding:0});d=e.button(c.text,0,0,i,o,m,p).attr({title:b.options.lang[c._titleKey],\"stroke-linecap\":\"round\",zIndex:3});d.menuClassName=a.menuClassName||\"highcharts-menu-\"+b.btnCount++;c.symbol&&(h=e.symbol(c.symbol,c.symbolX-j/2,c.symbolY-j/2,j,j).attr(q(n,{\"stroke-width\":c.symbolStrokeWidth||1,zIndex:1})).add(d));d.add().align(q(c,{width:d.width,x:f.pick(c.x,A)}),!0,\"spacingBox\");A+=(d.width+c.buttonSpacing)*(c.align===\"right\"?-1:1);b.exportSVGElements.push(d,h)}},\ndestroyExport:function(a){var a=a.target,b,e;for(b=0;b<a.exportSVGElements.length;b++)if(e=a.exportSVGElements[b])e.onclick=e.ontouchstart=null,a.exportSVGElements[b]=e.destroy();for(b=0;b<a.exportDivElements.length;b++)e=a.exportDivElements[b],C(e,\"mouseleave\"),a.exportDivElements[b]=e.onmouseout=e.onmouseover=e.ontouchstart=e.onclick=null,t(e)}});I.menu=function(a,b,e,c){return[\"M\",a,b+2.5,\"L\",a+e,b+2.5,\"M\",a,b+c/2+0.5,\"L\",a+e,b+c/2+0.5,\"M\",a,b+c-1.5,\"L\",a+e,b+c-1.5]};B.prototype.callbacks.push(function(a){var b,\ne=a.options.exporting,c=e.buttons;A=0;if(e.enabled!==!1){for(b in c)a.addButton(c[b]);u(a,\"destroy\",a.destroyExport)}})});\n"

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1516))

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	module.exports = "/**\n * highcharts-ng\n * @version v0.0.12 - 2016-08-07\n * @link https://github.com/pablojim/highcharts-ng\n * @author Barry Fitzgerald <>\n * @license MIT License, http://www.opensource.org/licenses/MIT\n */\n\nif (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports){\n  module.exports = 'highcharts-ng';\n}\n\n(function () {\n  'use strict';\n  /*global angular: false, Highcharts: false */\n\n\n  angular.module('highcharts-ng', [])\n    .factory('highchartsNG', ['$q', '$window', highchartsNG])\n    .directive('highchart', ['highchartsNG', '$timeout', highchart]);\n\n  //IE8 support\n  function indexOf(arr, find, i /*opt*/) {\n    if (i === undefined) i = 0;\n    if (i < 0) i += arr.length;\n    if (i < 0) i = 0;\n    for (var n = arr.length; i < n; i++)\n      if (i in arr && arr[i] === find)\n        return i;\n    return -1;\n  }\n\n  function prependMethod(obj, method, func) {\n    var original = obj[method];\n    obj[method] = function () {\n      var args = Array.prototype.slice.call(arguments);\n      func.apply(this, args);\n      if (original) {\n        return original.apply(this, args);\n      } else {\n        return;\n      }\n\n    };\n  }\n\n  function deepExtend(destination, source) {\n    //Slightly strange behaviour in edge cases (e.g. passing in non objects)\n    //But does the job for current use cases.\n    if (angular.isArray(source)) {\n      destination = angular.isArray(destination) ? destination : [];\n      for (var i = 0; i < source.length; i++) {\n        destination[i] = deepExtend(destination[i] || {}, source[i]);\n      }\n    } else if (angular.isObject(source)) {\n      destination = angular.isObject(destination) ? destination : {};\n      for (var property in source) {\n        destination[property] = deepExtend(destination[property] || {}, source[property]);\n      }\n    } else {\n      destination = source;\n    }\n    return destination;\n  }\n\n  function highchartsNG($q, $window) {\n    var highchartsProm = $q.when($window.Highcharts);\n\n    function getHighchartsOnce() {\n      return highchartsProm;\n    }\n\n    return {\n      getHighcharts: getHighchartsOnce,\n      ready: function ready(callback, thisArg) {\n        getHighchartsOnce().then(function() {\n          callback.call(thisArg);\n        });\n      }\n    };\n  }\n\n  function highchart(highchartsNGUtils, $timeout) {\n\n    // acceptable shared state\n    var seriesId = 0;\n    var ensureIds = function (series) {\n      var changed = false;\n      angular.forEach(series, function(s) {\n        if (!angular.isDefined(s.id)) {\n          s.id = 'series-' + seriesId++;\n          changed = true;\n        }\n      });\n      return changed;\n    };\n\n    // immutable\n    var axisNames = [ 'xAxis', 'yAxis' ];\n    var chartTypeMap = {\n      'stock': 'StockChart',\n      'map':   'Map',\n      'chart': 'Chart'\n    };\n\n    var getMergedOptions = function (scope, element, config) {\n      var mergedOptions = {};\n\n      var defaultOptions = {\n        chart: {\n          events: {}\n        },\n        title: {},\n        subtitle: {},\n        series: [],\n        credits: {},\n        plotOptions: {},\n        navigator: {enabled: false},\n        xAxis: {\n          events: {}\n        },\n        yAxis: {\n          events: {}\n        }\n      };\n\n      if (config.options) {\n        mergedOptions = deepExtend(defaultOptions, config.options);\n      } else {\n        mergedOptions = defaultOptions;\n      }\n      mergedOptions.chart.renderTo = element[0];\n\n      angular.forEach(axisNames, function(axisName) {\n        if(angular.isDefined(config[axisName])) {\n          mergedOptions[axisName] = deepExtend(mergedOptions[axisName] || {}, config[axisName]);\n\n          if(angular.isDefined(config[axisName].currentMin) ||\n              angular.isDefined(config[axisName].currentMax)) {\n\n            prependMethod(mergedOptions.chart.events, 'selection', function(e){\n              var thisChart = this;\n              if (e[axisName]) {\n                scope.$apply(function () {\n                  scope.config[axisName].currentMin = e[axisName][0].min;\n                  scope.config[axisName].currentMax = e[axisName][0].max;\n                });\n              } else {\n                //handle reset button - zoom out to all\n                scope.$apply(function () {\n                  scope.config[axisName].currentMin = thisChart[axisName][0].dataMin;\n                  scope.config[axisName].currentMax = thisChart[axisName][0].dataMax;\n                });\n              }\n            });\n\n            prependMethod(mergedOptions.chart.events, 'addSeries', function(e){\n              scope.config[axisName].currentMin = this[axisName][0].min || scope.config[axisName].currentMin;\n              scope.config[axisName].currentMax = this[axisName][0].max || scope.config[axisName].currentMax;\n            });\n            prependMethod(mergedOptions[axisName].events, 'setExtremes', function (e) {\n              if (e.trigger && e.trigger !== 'zoom') { // zoom trigger is handled by selection event\n                $timeout(function () {\n                  scope.config[axisName].currentMin = e.min;\n                  scope.config[axisName].currentMax = e.max;\n                  scope.config[axisName].min = e.min; // set min and max to adjust scrollbar/navigator\n                  scope.config[axisName].max = e.max;\n                }, 0);\n              }\n            });\n          }\n        }\n      });\n\n      if(config.title) {\n        mergedOptions.title = config.title;\n      }\n      if (config.subtitle) {\n        mergedOptions.subtitle = config.subtitle;\n      }\n      if (config.credits) {\n        mergedOptions.credits = config.credits;\n      }\n      if(config.size) {\n        if (config.size.width) {\n          mergedOptions.chart.width = config.size.width;\n        }\n        if (config.size.height) {\n          mergedOptions.chart.height = config.size.height;\n        }\n      }\n      return mergedOptions;\n    };\n\n    var updateZoom = function (axis, modelAxis) {\n      var extremes = axis.getExtremes();\n      if(modelAxis.currentMin !== extremes.dataMin || modelAxis.currentMax !== extremes.dataMax) {\n        if (axis.setExtremes) {\n          axis.setExtremes(modelAxis.currentMin, modelAxis.currentMax, false);\n        } else {\n          axis.detachedsetExtremes(modelAxis.currentMin, modelAxis.currentMax, false);\n        }\n      }\n    };\n\n    var processExtremes = function(chart, axis, axisName) {\n      if(axis.currentMin || axis.currentMax) {\n        chart[axisName][0].setExtremes(axis.currentMin, axis.currentMax, true);\n      }\n    };\n\n    var chartOptionsWithoutEasyOptions = function (options) {\n      return angular.extend(\n        deepExtend({}, options),\n        { data: null, visible: null }\n      );\n    };\n\n    var getChartType = function(scope) {\n      if (scope.config === undefined) return 'Chart';\n      return chartTypeMap[('' + scope.config.chartType).toLowerCase()] ||\n             (scope.config.useHighStocks ? 'StockChart' : 'Chart');\n    };\n\n    function linkWithHighcharts(Highcharts, scope, element, attrs) {\n      // We keep some chart-specific variables here as a closure\n      // instead of storing them on 'scope'.\n\n      // prevSeriesOptions is maintained by processSeries\n      var prevSeriesOptions = {};\n      // chart is maintained by initChart\n      var chart = false;\n\n      var processSeries = function(series, seriesOld) {\n        var i;\n        var ids = [];\n\n        if(series) {\n          var setIds = ensureIds(series);\n          if(setIds && !scope.disableDataWatch) {\n            //If we have set some ids this will trigger another digest cycle.\n            //In this scenario just return early and let the next cycle take care of changes\n            return false;\n          }\n\n          //Find series to add or update\n          angular.forEach(series, function(s, idx) {\n            ids.push(s.id);\n            var chartSeries = chart.get(s.id);\n            if (chartSeries) {\n              if (!angular.equals(prevSeriesOptions[s.id], chartOptionsWithoutEasyOptions(s))) {\n                chartSeries.update(angular.copy(s), false);\n              } else {\n                if (s.visible !== undefined && chartSeries.visible !== s.visible) {\n                  chartSeries.setVisible(s.visible, false);\n                }\n                \n                // Make sure the current series index can be accessed in seriesOld\n                if (idx < seriesOld.length) {\n                  var sOld = seriesOld[idx];\n                  var sCopy = angular.copy(sOld);\n                  \n                  // Get the latest data point from the new series\n                  var ptNew = s.data[s.data.length - 1];\n                  \n                  // Check if the new and old series are identical with the latest data point added\n                  // If so, call addPoint without shifting\n                  sCopy.data.push(ptNew);\n                  if (angular.equals(sCopy, s)) {\n                    chartSeries.addPoint(ptNew, false);\n                  }\n                  \n                  // Check if the data change was a push and shift operation\n                  // If so, call addPoint WITH shifting\n                  else {\n                    sCopy.data.shift();\n                    if (angular.equals(sCopy, s)) {\n                      chartSeries.addPoint(ptNew, false, true);\n                    }\n                    else {\n                      chartSeries.setData(angular.copy(s.data), false);\n                    }\n                  }\n                }\n                else {\n                  chartSeries.setData(angular.copy(s.data), false);\n                }\n              }\n            } else {\n              chart.addSeries(angular.copy(s), false);\n            }\n            prevSeriesOptions[s.id] = chartOptionsWithoutEasyOptions(s);\n          });\n\n          //  Shows no data text if all series are empty\n          if(scope.config.noData) {\n            var chartContainsData = false;\n\n            for(i = 0; i < series.length; i++) {\n              if (series[i].data && series[i].data.length > 0) {\n                chartContainsData = true;\n\n                break;\n              }\n            }\n\n            if (!chartContainsData) {\n              chart.showLoading(scope.config.noData);\n            } else {\n              chart.hideLoading();\n            }\n          }\n        }\n\n        //Now remove any missing series\n        for(i = chart.series.length - 1; i >= 0; i--) {\n          var s = chart.series[i];\n          if (s.options.id !== 'highcharts-navigator-series' && indexOf(ids, s.options.id) < 0) {\n            s.remove(false);\n          }\n        }\n\n        return true;\n      };\n\n      var initChart = function() {\n        if (chart) chart.destroy();\n        prevSeriesOptions = {};\n        var config = scope.config || {};\n        var mergedOptions = getMergedOptions(scope, element, config);\n        var func = config.func || undefined;\n        var chartType = getChartType(scope);\n\n        chart = new Highcharts[chartType](mergedOptions, func);\n\n        for (var i = 0; i < axisNames.length; i++) {\n          if (config[axisNames[i]]) {\n            processExtremes(chart, config[axisNames[i]], axisNames[i]);\n          }\n        }\n        if(config.loading) {\n          chart.showLoading();\n        }\n        config.getHighcharts = function() {\n          return chart;\n        };\n\n      };\n      initChart();\n\n\n      if(scope.disableDataWatch){\n        scope.$watchCollection('config.series', function (newSeries, oldSeries) {\n          processSeries(newSeries);\n          chart.redraw();\n        });\n      } else {\n        scope.$watch('config.series', function (newSeries, oldSeries) {\n          var needsRedraw = processSeries(newSeries, oldSeries);\n          if(needsRedraw) {\n            chart.redraw();\n          }\n        }, true);\n      }\n\n      scope.$watch('config.title', function (newTitle) {\n        chart.setTitle(newTitle, true);\n      }, true);\n\n      scope.$watch('config.subtitle', function (newSubtitle) {\n        chart.setTitle(true, newSubtitle);\n      }, true);\n\n      scope.$watch('config.loading', function (loading) {\n        if(loading) {\n          chart.showLoading(loading === true ? null : loading);\n        } else {\n          chart.hideLoading();\n        }\n      });\n      scope.$watch('config.noData', function (noData) {\n        if(scope.config && scope.config.loading) {\n          chart.showLoading(noData);\n        }\n      }, true);\n\n      scope.$watch('config.credits.enabled', function (enabled) {\n        if (enabled) {\n          chart.credits.show();\n        } else if (chart.credits) {\n          chart.credits.hide();\n        }\n      });\n\n      scope.$watch(getChartType, function (chartType, oldChartType) {\n        if (chartType === oldChartType) return;\n        initChart();\n      });\n\n      angular.forEach(axisNames, function(axisName) {\n        scope.$watch('config.' + axisName, function(newAxes) {\n          if (!newAxes) {\n            return;\n          }\n\n          if (angular.isArray(newAxes)) {\n\n            for (var axisIndex = 0; axisIndex < newAxes.length; axisIndex++) {\n              var axis = newAxes[axisIndex];\n\n              if (axisIndex < chart[axisName].length) {\n                chart[axisName][axisIndex].update(axis, false);\n                updateZoom(chart[axisName][axisIndex], angular.copy(axis));\n              }\n\n            }\n\n          } else {\n            // update single axis\n            chart[axisName][0].update(newAxes, false);\n            updateZoom(chart[axisName][0], angular.copy(newAxes));\n          }\n\n          chart.redraw();\n        }, true);\n      });\n      scope.$watch('config.options', function (newOptions, oldOptions, scope) {\n        //do nothing when called on registration\n        if (newOptions === oldOptions) return;\n        initChart();\n        processSeries(scope.config.series);\n        chart.redraw();\n      }, true);\n\n      scope.$watch('config.size', function (newSize, oldSize) {\n        if(newSize === oldSize) return;\n        if(newSize) {\n          chart.setSize(newSize.width || chart.chartWidth, newSize.height || chart.chartHeight);\n        }\n      }, true);\n\n      scope.$on('highchartsng.reflow', function () {\n        chart.reflow();\n      });\n\n      scope.$on('$destroy', function() {\n        if (chart) {\n          try{\n            chart.destroy();\n          }catch(ex){\n            // fail silently as highcharts will throw exception if element doesn't exist\n          }\n\n          $timeout(function(){\n            element.remove();\n          }, 0);\n        }\n      });\n    }\n\n    function link(scope, element, attrs) {\n      function highchartsCb(Highcarts) {\n        linkWithHighcharts(Highcharts, scope, element, attrs);\n      }\n      highchartsNGUtils\n        .getHighcharts()\n        .then(highchartsCb);\n    }\n\n    return {\n      restrict: 'EAC',\n      replace: true,\n      template: '<div></div>',\n      scope: {\n        config: '=',\n        disableDataWatch: '='\n      },\n      link: link\n    };\n  }\n}());\n"

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1518))

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	module.exports = "//! moment.js\n\n;(function (global, factory) {\n    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :\n    typeof define === 'function' && define.amd ? define(factory) :\n    global.moment = factory()\n}(this, (function () { 'use strict';\n\n    var hookCallback;\n\n    function hooks () {\n        return hookCallback.apply(null, arguments);\n    }\n\n    // This is done to register the method called with moment()\n    // without creating circular dependencies.\n    function setHookCallback (callback) {\n        hookCallback = callback;\n    }\n\n    function isArray(input) {\n        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';\n    }\n\n    function isObject(input) {\n        // IE8 will treat undefined and null as object if it wasn't for\n        // input != null\n        return input != null && Object.prototype.toString.call(input) === '[object Object]';\n    }\n\n    function isObjectEmpty(obj) {\n        if (Object.getOwnPropertyNames) {\n            return (Object.getOwnPropertyNames(obj).length === 0);\n        } else {\n            var k;\n            for (k in obj) {\n                if (obj.hasOwnProperty(k)) {\n                    return false;\n                }\n            }\n            return true;\n        }\n    }\n\n    function isUndefined(input) {\n        return input === void 0;\n    }\n\n    function isNumber(input) {\n        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';\n    }\n\n    function isDate(input) {\n        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';\n    }\n\n    function map(arr, fn) {\n        var res = [], i;\n        for (i = 0; i < arr.length; ++i) {\n            res.push(fn(arr[i], i));\n        }\n        return res;\n    }\n\n    function hasOwnProp(a, b) {\n        return Object.prototype.hasOwnProperty.call(a, b);\n    }\n\n    function extend(a, b) {\n        for (var i in b) {\n            if (hasOwnProp(b, i)) {\n                a[i] = b[i];\n            }\n        }\n\n        if (hasOwnProp(b, 'toString')) {\n            a.toString = b.toString;\n        }\n\n        if (hasOwnProp(b, 'valueOf')) {\n            a.valueOf = b.valueOf;\n        }\n\n        return a;\n    }\n\n    function createUTC (input, format, locale, strict) {\n        return createLocalOrUTC(input, format, locale, strict, true).utc();\n    }\n\n    function defaultParsingFlags() {\n        // We need to deep clone this object.\n        return {\n            empty           : false,\n            unusedTokens    : [],\n            unusedInput     : [],\n            overflow        : -2,\n            charsLeftOver   : 0,\n            nullInput       : false,\n            invalidMonth    : null,\n            invalidFormat   : false,\n            userInvalidated : false,\n            iso             : false,\n            parsedDateParts : [],\n            meridiem        : null,\n            rfc2822         : false,\n            weekdayMismatch : false\n        };\n    }\n\n    function getParsingFlags(m) {\n        if (m._pf == null) {\n            m._pf = defaultParsingFlags();\n        }\n        return m._pf;\n    }\n\n    var some;\n    if (Array.prototype.some) {\n        some = Array.prototype.some;\n    } else {\n        some = function (fun) {\n            var t = Object(this);\n            var len = t.length >>> 0;\n\n            for (var i = 0; i < len; i++) {\n                if (i in t && fun.call(this, t[i], i, t)) {\n                    return true;\n                }\n            }\n\n            return false;\n        };\n    }\n\n    function isValid(m) {\n        if (m._isValid == null) {\n            var flags = getParsingFlags(m);\n            var parsedParts = some.call(flags.parsedDateParts, function (i) {\n                return i != null;\n            });\n            var isNowValid = !isNaN(m._d.getTime()) &&\n                flags.overflow < 0 &&\n                !flags.empty &&\n                !flags.invalidMonth &&\n                !flags.invalidWeekday &&\n                !flags.weekdayMismatch &&\n                !flags.nullInput &&\n                !flags.invalidFormat &&\n                !flags.userInvalidated &&\n                (!flags.meridiem || (flags.meridiem && parsedParts));\n\n            if (m._strict) {\n                isNowValid = isNowValid &&\n                    flags.charsLeftOver === 0 &&\n                    flags.unusedTokens.length === 0 &&\n                    flags.bigHour === undefined;\n            }\n\n            if (Object.isFrozen == null || !Object.isFrozen(m)) {\n                m._isValid = isNowValid;\n            }\n            else {\n                return isNowValid;\n            }\n        }\n        return m._isValid;\n    }\n\n    function createInvalid (flags) {\n        var m = createUTC(NaN);\n        if (flags != null) {\n            extend(getParsingFlags(m), flags);\n        }\n        else {\n            getParsingFlags(m).userInvalidated = true;\n        }\n\n        return m;\n    }\n\n    // Plugins that add properties should also add the key here (null value),\n    // so we can properly clone ourselves.\n    var momentProperties = hooks.momentProperties = [];\n\n    function copyConfig(to, from) {\n        var i, prop, val;\n\n        if (!isUndefined(from._isAMomentObject)) {\n            to._isAMomentObject = from._isAMomentObject;\n        }\n        if (!isUndefined(from._i)) {\n            to._i = from._i;\n        }\n        if (!isUndefined(from._f)) {\n            to._f = from._f;\n        }\n        if (!isUndefined(from._l)) {\n            to._l = from._l;\n        }\n        if (!isUndefined(from._strict)) {\n            to._strict = from._strict;\n        }\n        if (!isUndefined(from._tzm)) {\n            to._tzm = from._tzm;\n        }\n        if (!isUndefined(from._isUTC)) {\n            to._isUTC = from._isUTC;\n        }\n        if (!isUndefined(from._offset)) {\n            to._offset = from._offset;\n        }\n        if (!isUndefined(from._pf)) {\n            to._pf = getParsingFlags(from);\n        }\n        if (!isUndefined(from._locale)) {\n            to._locale = from._locale;\n        }\n\n        if (momentProperties.length > 0) {\n            for (i = 0; i < momentProperties.length; i++) {\n                prop = momentProperties[i];\n                val = from[prop];\n                if (!isUndefined(val)) {\n                    to[prop] = val;\n                }\n            }\n        }\n\n        return to;\n    }\n\n    var updateInProgress = false;\n\n    // Moment prototype object\n    function Moment(config) {\n        copyConfig(this, config);\n        this._d = new Date(config._d != null ? config._d.getTime() : NaN);\n        if (!this.isValid()) {\n            this._d = new Date(NaN);\n        }\n        // Prevent infinite loop in case updateOffset creates new moment\n        // objects.\n        if (updateInProgress === false) {\n            updateInProgress = true;\n            hooks.updateOffset(this);\n            updateInProgress = false;\n        }\n    }\n\n    function isMoment (obj) {\n        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);\n    }\n\n    function absFloor (number) {\n        if (number < 0) {\n            // -0 -> 0\n            return Math.ceil(number) || 0;\n        } else {\n            return Math.floor(number);\n        }\n    }\n\n    function toInt(argumentForCoercion) {\n        var coercedNumber = +argumentForCoercion,\n            value = 0;\n\n        if (coercedNumber !== 0 && isFinite(coercedNumber)) {\n            value = absFloor(coercedNumber);\n        }\n\n        return value;\n    }\n\n    // compare two arrays, return the number of differences\n    function compareArrays(array1, array2, dontConvert) {\n        var len = Math.min(array1.length, array2.length),\n            lengthDiff = Math.abs(array1.length - array2.length),\n            diffs = 0,\n            i;\n        for (i = 0; i < len; i++) {\n            if ((dontConvert && array1[i] !== array2[i]) ||\n                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {\n                diffs++;\n            }\n        }\n        return diffs + lengthDiff;\n    }\n\n    function warn(msg) {\n        if (hooks.suppressDeprecationWarnings === false &&\n                (typeof console !==  'undefined') && console.warn) {\n            console.warn('Deprecation warning: ' + msg);\n        }\n    }\n\n    function deprecate(msg, fn) {\n        var firstTime = true;\n\n        return extend(function () {\n            if (hooks.deprecationHandler != null) {\n                hooks.deprecationHandler(null, msg);\n            }\n            if (firstTime) {\n                var args = [];\n                var arg;\n                for (var i = 0; i < arguments.length; i++) {\n                    arg = '';\n                    if (typeof arguments[i] === 'object') {\n                        arg += '\\n[' + i + '] ';\n                        for (var key in arguments[0]) {\n                            arg += key + ': ' + arguments[0][key] + ', ';\n                        }\n                        arg = arg.slice(0, -2); // Remove trailing comma and space\n                    } else {\n                        arg = arguments[i];\n                    }\n                    args.push(arg);\n                }\n                warn(msg + '\\nArguments: ' + Array.prototype.slice.call(args).join('') + '\\n' + (new Error()).stack);\n                firstTime = false;\n            }\n            return fn.apply(this, arguments);\n        }, fn);\n    }\n\n    var deprecations = {};\n\n    function deprecateSimple(name, msg) {\n        if (hooks.deprecationHandler != null) {\n            hooks.deprecationHandler(name, msg);\n        }\n        if (!deprecations[name]) {\n            warn(msg);\n            deprecations[name] = true;\n        }\n    }\n\n    hooks.suppressDeprecationWarnings = false;\n    hooks.deprecationHandler = null;\n\n    function isFunction(input) {\n        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';\n    }\n\n    function set (config) {\n        var prop, i;\n        for (i in config) {\n            prop = config[i];\n            if (isFunction(prop)) {\n                this[i] = prop;\n            } else {\n                this['_' + i] = prop;\n            }\n        }\n        this._config = config;\n        // Lenient ordinal parsing accepts just a number in addition to\n        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.\n        // TODO: Remove \"ordinalParse\" fallback in next major release.\n        this._dayOfMonthOrdinalParseLenient = new RegExp(\n            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +\n                '|' + (/\\d{1,2}/).source);\n    }\n\n    function mergeConfigs(parentConfig, childConfig) {\n        var res = extend({}, parentConfig), prop;\n        for (prop in childConfig) {\n            if (hasOwnProp(childConfig, prop)) {\n                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {\n                    res[prop] = {};\n                    extend(res[prop], parentConfig[prop]);\n                    extend(res[prop], childConfig[prop]);\n                } else if (childConfig[prop] != null) {\n                    res[prop] = childConfig[prop];\n                } else {\n                    delete res[prop];\n                }\n            }\n        }\n        for (prop in parentConfig) {\n            if (hasOwnProp(parentConfig, prop) &&\n                    !hasOwnProp(childConfig, prop) &&\n                    isObject(parentConfig[prop])) {\n                // make sure changes to properties don't modify parent config\n                res[prop] = extend({}, res[prop]);\n            }\n        }\n        return res;\n    }\n\n    function Locale(config) {\n        if (config != null) {\n            this.set(config);\n        }\n    }\n\n    var keys;\n\n    if (Object.keys) {\n        keys = Object.keys;\n    } else {\n        keys = function (obj) {\n            var i, res = [];\n            for (i in obj) {\n                if (hasOwnProp(obj, i)) {\n                    res.push(i);\n                }\n            }\n            return res;\n        };\n    }\n\n    var defaultCalendar = {\n        sameDay : '[Today at] LT',\n        nextDay : '[Tomorrow at] LT',\n        nextWeek : 'dddd [at] LT',\n        lastDay : '[Yesterday at] LT',\n        lastWeek : '[Last] dddd [at] LT',\n        sameElse : 'L'\n    };\n\n    function calendar (key, mom, now) {\n        var output = this._calendar[key] || this._calendar['sameElse'];\n        return isFunction(output) ? output.call(mom, now) : output;\n    }\n\n    var defaultLongDateFormat = {\n        LTS  : 'h:mm:ss A',\n        LT   : 'h:mm A',\n        L    : 'MM/DD/YYYY',\n        LL   : 'MMMM D, YYYY',\n        LLL  : 'MMMM D, YYYY h:mm A',\n        LLLL : 'dddd, MMMM D, YYYY h:mm A'\n    };\n\n    function longDateFormat (key) {\n        var format = this._longDateFormat[key],\n            formatUpper = this._longDateFormat[key.toUpperCase()];\n\n        if (format || !formatUpper) {\n            return format;\n        }\n\n        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {\n            return val.slice(1);\n        });\n\n        return this._longDateFormat[key];\n    }\n\n    var defaultInvalidDate = 'Invalid date';\n\n    function invalidDate () {\n        return this._invalidDate;\n    }\n\n    var defaultOrdinal = '%d';\n    var defaultDayOfMonthOrdinalParse = /\\d{1,2}/;\n\n    function ordinal (number) {\n        return this._ordinal.replace('%d', number);\n    }\n\n    var defaultRelativeTime = {\n        future : 'in %s',\n        past   : '%s ago',\n        s  : 'a few seconds',\n        ss : '%d seconds',\n        m  : 'a minute',\n        mm : '%d minutes',\n        h  : 'an hour',\n        hh : '%d hours',\n        d  : 'a day',\n        dd : '%d days',\n        M  : 'a month',\n        MM : '%d months',\n        y  : 'a year',\n        yy : '%d years'\n    };\n\n    function relativeTime (number, withoutSuffix, string, isFuture) {\n        var output = this._relativeTime[string];\n        return (isFunction(output)) ?\n            output(number, withoutSuffix, string, isFuture) :\n            output.replace(/%d/i, number);\n    }\n\n    function pastFuture (diff, output) {\n        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];\n        return isFunction(format) ? format(output) : format.replace(/%s/i, output);\n    }\n\n    var aliases = {};\n\n    function addUnitAlias (unit, shorthand) {\n        var lowerCase = unit.toLowerCase();\n        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;\n    }\n\n    function normalizeUnits(units) {\n        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;\n    }\n\n    function normalizeObjectUnits(inputObject) {\n        var normalizedInput = {},\n            normalizedProp,\n            prop;\n\n        for (prop in inputObject) {\n            if (hasOwnProp(inputObject, prop)) {\n                normalizedProp = normalizeUnits(prop);\n                if (normalizedProp) {\n                    normalizedInput[normalizedProp] = inputObject[prop];\n                }\n            }\n        }\n\n        return normalizedInput;\n    }\n\n    var priorities = {};\n\n    function addUnitPriority(unit, priority) {\n        priorities[unit] = priority;\n    }\n\n    function getPrioritizedUnits(unitsObj) {\n        var units = [];\n        for (var u in unitsObj) {\n            units.push({unit: u, priority: priorities[u]});\n        }\n        units.sort(function (a, b) {\n            return a.priority - b.priority;\n        });\n        return units;\n    }\n\n    function zeroFill(number, targetLength, forceSign) {\n        var absNumber = '' + Math.abs(number),\n            zerosToFill = targetLength - absNumber.length,\n            sign = number >= 0;\n        return (sign ? (forceSign ? '+' : '') : '-') +\n            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;\n    }\n\n    var formattingTokens = /(\\[[^\\[]*\\])|(\\\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;\n\n    var localFormattingTokens = /(\\[[^\\[]*\\])|(\\\\)?(LTS|LT|LL?L?L?|l{1,4})/g;\n\n    var formatFunctions = {};\n\n    var formatTokenFunctions = {};\n\n    // token:    'M'\n    // padded:   ['MM', 2]\n    // ordinal:  'Mo'\n    // callback: function () { this.month() + 1 }\n    function addFormatToken (token, padded, ordinal, callback) {\n        var func = callback;\n        if (typeof callback === 'string') {\n            func = function () {\n                return this[callback]();\n            };\n        }\n        if (token) {\n            formatTokenFunctions[token] = func;\n        }\n        if (padded) {\n            formatTokenFunctions[padded[0]] = function () {\n                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);\n            };\n        }\n        if (ordinal) {\n            formatTokenFunctions[ordinal] = function () {\n                return this.localeData().ordinal(func.apply(this, arguments), token);\n            };\n        }\n    }\n\n    function removeFormattingTokens(input) {\n        if (input.match(/\\[[\\s\\S]/)) {\n            return input.replace(/^\\[|\\]$/g, '');\n        }\n        return input.replace(/\\\\/g, '');\n    }\n\n    function makeFormatFunction(format) {\n        var array = format.match(formattingTokens), i, length;\n\n        for (i = 0, length = array.length; i < length; i++) {\n            if (formatTokenFunctions[array[i]]) {\n                array[i] = formatTokenFunctions[array[i]];\n            } else {\n                array[i] = removeFormattingTokens(array[i]);\n            }\n        }\n\n        return function (mom) {\n            var output = '', i;\n            for (i = 0; i < length; i++) {\n                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];\n            }\n            return output;\n        };\n    }\n\n    // format date using native date object\n    function formatMoment(m, format) {\n        if (!m.isValid()) {\n            return m.localeData().invalidDate();\n        }\n\n        format = expandFormat(format, m.localeData());\n        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);\n\n        return formatFunctions[format](m);\n    }\n\n    function expandFormat(format, locale) {\n        var i = 5;\n\n        function replaceLongDateFormatTokens(input) {\n            return locale.longDateFormat(input) || input;\n        }\n\n        localFormattingTokens.lastIndex = 0;\n        while (i >= 0 && localFormattingTokens.test(format)) {\n            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);\n            localFormattingTokens.lastIndex = 0;\n            i -= 1;\n        }\n\n        return format;\n    }\n\n    var match1         = /\\d/;            //       0 - 9\n    var match2         = /\\d\\d/;          //      00 - 99\n    var match3         = /\\d{3}/;         //     000 - 999\n    var match4         = /\\d{4}/;         //    0000 - 9999\n    var match6         = /[+-]?\\d{6}/;    // -999999 - 999999\n    var match1to2      = /\\d\\d?/;         //       0 - 99\n    var match3to4      = /\\d\\d\\d\\d?/;     //     999 - 9999\n    var match5to6      = /\\d\\d\\d\\d\\d\\d?/; //   99999 - 999999\n    var match1to3      = /\\d{1,3}/;       //       0 - 999\n    var match1to4      = /\\d{1,4}/;       //       0 - 9999\n    var match1to6      = /[+-]?\\d{1,6}/;  // -999999 - 999999\n\n    var matchUnsigned  = /\\d+/;           //       0 - inf\n    var matchSigned    = /[+-]?\\d+/;      //    -inf - inf\n\n    var matchOffset    = /Z|[+-]\\d\\d:?\\d\\d/gi; // +00:00 -00:00 +0000 -0000 or Z\n    var matchShortOffset = /Z|[+-]\\d\\d(?::?\\d\\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z\n\n    var matchTimestamp = /[+-]?\\d+(\\.\\d{1,3})?/; // 123456789 123456789.123\n\n    // any word (or two) characters or numbers including two/three word month in arabic.\n    // includes scottish gaelic two word and hyphenated months\n    var matchWord = /[0-9]{0,256}['a-z\\u00A0-\\u05FF\\u0700-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFF07\\uFF10-\\uFFEF]{1,256}|[\\u0600-\\u06FF\\/]{1,256}(\\s*?[\\u0600-\\u06FF]{1,256}){1,2}/i;\n\n    var regexes = {};\n\n    function addRegexToken (token, regex, strictRegex) {\n        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {\n            return (isStrict && strictRegex) ? strictRegex : regex;\n        };\n    }\n\n    function getParseRegexForToken (token, config) {\n        if (!hasOwnProp(regexes, token)) {\n            return new RegExp(unescapeFormat(token));\n        }\n\n        return regexes[token](config._strict, config._locale);\n    }\n\n    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript\n    function unescapeFormat(s) {\n        return regexEscape(s.replace('\\\\', '').replace(/\\\\(\\[)|\\\\(\\])|\\[([^\\]\\[]*)\\]|\\\\(.)/g, function (matched, p1, p2, p3, p4) {\n            return p1 || p2 || p3 || p4;\n        }));\n    }\n\n    function regexEscape(s) {\n        return s.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g, '\\\\$&');\n    }\n\n    var tokens = {};\n\n    function addParseToken (token, callback) {\n        var i, func = callback;\n        if (typeof token === 'string') {\n            token = [token];\n        }\n        if (isNumber(callback)) {\n            func = function (input, array) {\n                array[callback] = toInt(input);\n            };\n        }\n        for (i = 0; i < token.length; i++) {\n            tokens[token[i]] = func;\n        }\n    }\n\n    function addWeekParseToken (token, callback) {\n        addParseToken(token, function (input, array, config, token) {\n            config._w = config._w || {};\n            callback(input, config._w, config, token);\n        });\n    }\n\n    function addTimeToArrayFromToken(token, input, config) {\n        if (input != null && hasOwnProp(tokens, token)) {\n            tokens[token](input, config._a, config, token);\n        }\n    }\n\n    var YEAR = 0;\n    var MONTH = 1;\n    var DATE = 2;\n    var HOUR = 3;\n    var MINUTE = 4;\n    var SECOND = 5;\n    var MILLISECOND = 6;\n    var WEEK = 7;\n    var WEEKDAY = 8;\n\n    // FORMATTING\n\n    addFormatToken('Y', 0, 0, function () {\n        var y = this.year();\n        return y <= 9999 ? '' + y : '+' + y;\n    });\n\n    addFormatToken(0, ['YY', 2], 0, function () {\n        return this.year() % 100;\n    });\n\n    addFormatToken(0, ['YYYY',   4],       0, 'year');\n    addFormatToken(0, ['YYYYY',  5],       0, 'year');\n    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');\n\n    // ALIASES\n\n    addUnitAlias('year', 'y');\n\n    // PRIORITIES\n\n    addUnitPriority('year', 1);\n\n    // PARSING\n\n    addRegexToken('Y',      matchSigned);\n    addRegexToken('YY',     match1to2, match2);\n    addRegexToken('YYYY',   match1to4, match4);\n    addRegexToken('YYYYY',  match1to6, match6);\n    addRegexToken('YYYYYY', match1to6, match6);\n\n    addParseToken(['YYYYY', 'YYYYYY'], YEAR);\n    addParseToken('YYYY', function (input, array) {\n        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);\n    });\n    addParseToken('YY', function (input, array) {\n        array[YEAR] = hooks.parseTwoDigitYear(input);\n    });\n    addParseToken('Y', function (input, array) {\n        array[YEAR] = parseInt(input, 10);\n    });\n\n    // HELPERS\n\n    function daysInYear(year) {\n        return isLeapYear(year) ? 366 : 365;\n    }\n\n    function isLeapYear(year) {\n        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;\n    }\n\n    // HOOKS\n\n    hooks.parseTwoDigitYear = function (input) {\n        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);\n    };\n\n    // MOMENTS\n\n    var getSetYear = makeGetSet('FullYear', true);\n\n    function getIsLeapYear () {\n        return isLeapYear(this.year());\n    }\n\n    function makeGetSet (unit, keepTime) {\n        return function (value) {\n            if (value != null) {\n                set$1(this, unit, value);\n                hooks.updateOffset(this, keepTime);\n                return this;\n            } else {\n                return get(this, unit);\n            }\n        };\n    }\n\n    function get (mom, unit) {\n        return mom.isValid() ?\n            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;\n    }\n\n    function set$1 (mom, unit, value) {\n        if (mom.isValid() && !isNaN(value)) {\n            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {\n                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));\n            }\n            else {\n                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);\n            }\n        }\n    }\n\n    // MOMENTS\n\n    function stringGet (units) {\n        units = normalizeUnits(units);\n        if (isFunction(this[units])) {\n            return this[units]();\n        }\n        return this;\n    }\n\n\n    function stringSet (units, value) {\n        if (typeof units === 'object') {\n            units = normalizeObjectUnits(units);\n            var prioritized = getPrioritizedUnits(units);\n            for (var i = 0; i < prioritized.length; i++) {\n                this[prioritized[i].unit](units[prioritized[i].unit]);\n            }\n        } else {\n            units = normalizeUnits(units);\n            if (isFunction(this[units])) {\n                return this[units](value);\n            }\n        }\n        return this;\n    }\n\n    function mod(n, x) {\n        return ((n % x) + x) % x;\n    }\n\n    var indexOf;\n\n    if (Array.prototype.indexOf) {\n        indexOf = Array.prototype.indexOf;\n    } else {\n        indexOf = function (o) {\n            // I know\n            var i;\n            for (i = 0; i < this.length; ++i) {\n                if (this[i] === o) {\n                    return i;\n                }\n            }\n            return -1;\n        };\n    }\n\n    function daysInMonth(year, month) {\n        if (isNaN(year) || isNaN(month)) {\n            return NaN;\n        }\n        var modMonth = mod(month, 12);\n        year += (month - modMonth) / 12;\n        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);\n    }\n\n    // FORMATTING\n\n    addFormatToken('M', ['MM', 2], 'Mo', function () {\n        return this.month() + 1;\n    });\n\n    addFormatToken('MMM', 0, 0, function (format) {\n        return this.localeData().monthsShort(this, format);\n    });\n\n    addFormatToken('MMMM', 0, 0, function (format) {\n        return this.localeData().months(this, format);\n    });\n\n    // ALIASES\n\n    addUnitAlias('month', 'M');\n\n    // PRIORITY\n\n    addUnitPriority('month', 8);\n\n    // PARSING\n\n    addRegexToken('M',    match1to2);\n    addRegexToken('MM',   match1to2, match2);\n    addRegexToken('MMM',  function (isStrict, locale) {\n        return locale.monthsShortRegex(isStrict);\n    });\n    addRegexToken('MMMM', function (isStrict, locale) {\n        return locale.monthsRegex(isStrict);\n    });\n\n    addParseToken(['M', 'MM'], function (input, array) {\n        array[MONTH] = toInt(input) - 1;\n    });\n\n    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {\n        var month = config._locale.monthsParse(input, token, config._strict);\n        // if we didn't find a month name, mark the date as invalid.\n        if (month != null) {\n            array[MONTH] = month;\n        } else {\n            getParsingFlags(config).invalidMonth = input;\n        }\n    });\n\n    // LOCALES\n\n    var MONTHS_IN_FORMAT = /D[oD]?(\\[[^\\[\\]]*\\]|\\s)+MMMM?/;\n    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');\n    function localeMonths (m, format) {\n        if (!m) {\n            return isArray(this._months) ? this._months :\n                this._months['standalone'];\n        }\n        return isArray(this._months) ? this._months[m.month()] :\n            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];\n    }\n\n    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');\n    function localeMonthsShort (m, format) {\n        if (!m) {\n            return isArray(this._monthsShort) ? this._monthsShort :\n                this._monthsShort['standalone'];\n        }\n        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :\n            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];\n    }\n\n    function handleStrictParse(monthName, format, strict) {\n        var i, ii, mom, llc = monthName.toLocaleLowerCase();\n        if (!this._monthsParse) {\n            // this is not used\n            this._monthsParse = [];\n            this._longMonthsParse = [];\n            this._shortMonthsParse = [];\n            for (i = 0; i < 12; ++i) {\n                mom = createUTC([2000, i]);\n                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();\n                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();\n            }\n        }\n\n        if (strict) {\n            if (format === 'MMM') {\n                ii = indexOf.call(this._shortMonthsParse, llc);\n                return ii !== -1 ? ii : null;\n            } else {\n                ii = indexOf.call(this._longMonthsParse, llc);\n                return ii !== -1 ? ii : null;\n            }\n        } else {\n            if (format === 'MMM') {\n                ii = indexOf.call(this._shortMonthsParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._longMonthsParse, llc);\n                return ii !== -1 ? ii : null;\n            } else {\n                ii = indexOf.call(this._longMonthsParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._shortMonthsParse, llc);\n                return ii !== -1 ? ii : null;\n            }\n        }\n    }\n\n    function localeMonthsParse (monthName, format, strict) {\n        var i, mom, regex;\n\n        if (this._monthsParseExact) {\n            return handleStrictParse.call(this, monthName, format, strict);\n        }\n\n        if (!this._monthsParse) {\n            this._monthsParse = [];\n            this._longMonthsParse = [];\n            this._shortMonthsParse = [];\n        }\n\n        // TODO: add sorting\n        // Sorting makes sure if one month (or abbr) is a prefix of another\n        // see sorting in computeMonthsParse\n        for (i = 0; i < 12; i++) {\n            // make the regex if we don't have it already\n            mom = createUTC([2000, i]);\n            if (strict && !this._longMonthsParse[i]) {\n                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');\n                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');\n            }\n            if (!strict && !this._monthsParse[i]) {\n                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');\n                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');\n            }\n            // test the regex\n            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {\n                return i;\n            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {\n                return i;\n            } else if (!strict && this._monthsParse[i].test(monthName)) {\n                return i;\n            }\n        }\n    }\n\n    // MOMENTS\n\n    function setMonth (mom, value) {\n        var dayOfMonth;\n\n        if (!mom.isValid()) {\n            // No op\n            return mom;\n        }\n\n        if (typeof value === 'string') {\n            if (/^\\d+$/.test(value)) {\n                value = toInt(value);\n            } else {\n                value = mom.localeData().monthsParse(value);\n                // TODO: Another silent failure?\n                if (!isNumber(value)) {\n                    return mom;\n                }\n            }\n        }\n\n        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));\n        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);\n        return mom;\n    }\n\n    function getSetMonth (value) {\n        if (value != null) {\n            setMonth(this, value);\n            hooks.updateOffset(this, true);\n            return this;\n        } else {\n            return get(this, 'Month');\n        }\n    }\n\n    function getDaysInMonth () {\n        return daysInMonth(this.year(), this.month());\n    }\n\n    var defaultMonthsShortRegex = matchWord;\n    function monthsShortRegex (isStrict) {\n        if (this._monthsParseExact) {\n            if (!hasOwnProp(this, '_monthsRegex')) {\n                computeMonthsParse.call(this);\n            }\n            if (isStrict) {\n                return this._monthsShortStrictRegex;\n            } else {\n                return this._monthsShortRegex;\n            }\n        } else {\n            if (!hasOwnProp(this, '_monthsShortRegex')) {\n                this._monthsShortRegex = defaultMonthsShortRegex;\n            }\n            return this._monthsShortStrictRegex && isStrict ?\n                this._monthsShortStrictRegex : this._monthsShortRegex;\n        }\n    }\n\n    var defaultMonthsRegex = matchWord;\n    function monthsRegex (isStrict) {\n        if (this._monthsParseExact) {\n            if (!hasOwnProp(this, '_monthsRegex')) {\n                computeMonthsParse.call(this);\n            }\n            if (isStrict) {\n                return this._monthsStrictRegex;\n            } else {\n                return this._monthsRegex;\n            }\n        } else {\n            if (!hasOwnProp(this, '_monthsRegex')) {\n                this._monthsRegex = defaultMonthsRegex;\n            }\n            return this._monthsStrictRegex && isStrict ?\n                this._monthsStrictRegex : this._monthsRegex;\n        }\n    }\n\n    function computeMonthsParse () {\n        function cmpLenRev(a, b) {\n            return b.length - a.length;\n        }\n\n        var shortPieces = [], longPieces = [], mixedPieces = [],\n            i, mom;\n        for (i = 0; i < 12; i++) {\n            // make the regex if we don't have it already\n            mom = createUTC([2000, i]);\n            shortPieces.push(this.monthsShort(mom, ''));\n            longPieces.push(this.months(mom, ''));\n            mixedPieces.push(this.months(mom, ''));\n            mixedPieces.push(this.monthsShort(mom, ''));\n        }\n        // Sorting makes sure if one month (or abbr) is a prefix of another it\n        // will match the longer piece.\n        shortPieces.sort(cmpLenRev);\n        longPieces.sort(cmpLenRev);\n        mixedPieces.sort(cmpLenRev);\n        for (i = 0; i < 12; i++) {\n            shortPieces[i] = regexEscape(shortPieces[i]);\n            longPieces[i] = regexEscape(longPieces[i]);\n        }\n        for (i = 0; i < 24; i++) {\n            mixedPieces[i] = regexEscape(mixedPieces[i]);\n        }\n\n        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');\n        this._monthsShortRegex = this._monthsRegex;\n        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');\n        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');\n    }\n\n    function createDate (y, m, d, h, M, s, ms) {\n        // can't just apply() to create a date:\n        // https://stackoverflow.com/q/181348\n        var date = new Date(y, m, d, h, M, s, ms);\n\n        // the date constructor remaps years 0-99 to 1900-1999\n        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {\n            date.setFullYear(y);\n        }\n        return date;\n    }\n\n    function createUTCDate (y) {\n        var date = new Date(Date.UTC.apply(null, arguments));\n\n        // the Date.UTC function remaps years 0-99 to 1900-1999\n        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {\n            date.setUTCFullYear(y);\n        }\n        return date;\n    }\n\n    // start-of-first-week - start-of-year\n    function firstWeekOffset(year, dow, doy) {\n        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)\n            fwd = 7 + dow - doy,\n            // first-week day local weekday -- which local weekday is fwd\n            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;\n\n        return -fwdlw + fwd - 1;\n    }\n\n    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday\n    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {\n        var localWeekday = (7 + weekday - dow) % 7,\n            weekOffset = firstWeekOffset(year, dow, doy),\n            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,\n            resYear, resDayOfYear;\n\n        if (dayOfYear <= 0) {\n            resYear = year - 1;\n            resDayOfYear = daysInYear(resYear) + dayOfYear;\n        } else if (dayOfYear > daysInYear(year)) {\n            resYear = year + 1;\n            resDayOfYear = dayOfYear - daysInYear(year);\n        } else {\n            resYear = year;\n            resDayOfYear = dayOfYear;\n        }\n\n        return {\n            year: resYear,\n            dayOfYear: resDayOfYear\n        };\n    }\n\n    function weekOfYear(mom, dow, doy) {\n        var weekOffset = firstWeekOffset(mom.year(), dow, doy),\n            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,\n            resWeek, resYear;\n\n        if (week < 1) {\n            resYear = mom.year() - 1;\n            resWeek = week + weeksInYear(resYear, dow, doy);\n        } else if (week > weeksInYear(mom.year(), dow, doy)) {\n            resWeek = week - weeksInYear(mom.year(), dow, doy);\n            resYear = mom.year() + 1;\n        } else {\n            resYear = mom.year();\n            resWeek = week;\n        }\n\n        return {\n            week: resWeek,\n            year: resYear\n        };\n    }\n\n    function weeksInYear(year, dow, doy) {\n        var weekOffset = firstWeekOffset(year, dow, doy),\n            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);\n        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;\n    }\n\n    // FORMATTING\n\n    addFormatToken('w', ['ww', 2], 'wo', 'week');\n    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');\n\n    // ALIASES\n\n    addUnitAlias('week', 'w');\n    addUnitAlias('isoWeek', 'W');\n\n    // PRIORITIES\n\n    addUnitPriority('week', 5);\n    addUnitPriority('isoWeek', 5);\n\n    // PARSING\n\n    addRegexToken('w',  match1to2);\n    addRegexToken('ww', match1to2, match2);\n    addRegexToken('W',  match1to2);\n    addRegexToken('WW', match1to2, match2);\n\n    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {\n        week[token.substr(0, 1)] = toInt(input);\n    });\n\n    // HELPERS\n\n    // LOCALES\n\n    function localeWeek (mom) {\n        return weekOfYear(mom, this._week.dow, this._week.doy).week;\n    }\n\n    var defaultLocaleWeek = {\n        dow : 0, // Sunday is the first day of the week.\n        doy : 6  // The week that contains Jan 1st is the first week of the year.\n    };\n\n    function localeFirstDayOfWeek () {\n        return this._week.dow;\n    }\n\n    function localeFirstDayOfYear () {\n        return this._week.doy;\n    }\n\n    // MOMENTS\n\n    function getSetWeek (input) {\n        var week = this.localeData().week(this);\n        return input == null ? week : this.add((input - week) * 7, 'd');\n    }\n\n    function getSetISOWeek (input) {\n        var week = weekOfYear(this, 1, 4).week;\n        return input == null ? week : this.add((input - week) * 7, 'd');\n    }\n\n    // FORMATTING\n\n    addFormatToken('d', 0, 'do', 'day');\n\n    addFormatToken('dd', 0, 0, function (format) {\n        return this.localeData().weekdaysMin(this, format);\n    });\n\n    addFormatToken('ddd', 0, 0, function (format) {\n        return this.localeData().weekdaysShort(this, format);\n    });\n\n    addFormatToken('dddd', 0, 0, function (format) {\n        return this.localeData().weekdays(this, format);\n    });\n\n    addFormatToken('e', 0, 0, 'weekday');\n    addFormatToken('E', 0, 0, 'isoWeekday');\n\n    // ALIASES\n\n    addUnitAlias('day', 'd');\n    addUnitAlias('weekday', 'e');\n    addUnitAlias('isoWeekday', 'E');\n\n    // PRIORITY\n    addUnitPriority('day', 11);\n    addUnitPriority('weekday', 11);\n    addUnitPriority('isoWeekday', 11);\n\n    // PARSING\n\n    addRegexToken('d',    match1to2);\n    addRegexToken('e',    match1to2);\n    addRegexToken('E',    match1to2);\n    addRegexToken('dd',   function (isStrict, locale) {\n        return locale.weekdaysMinRegex(isStrict);\n    });\n    addRegexToken('ddd',   function (isStrict, locale) {\n        return locale.weekdaysShortRegex(isStrict);\n    });\n    addRegexToken('dddd',   function (isStrict, locale) {\n        return locale.weekdaysRegex(isStrict);\n    });\n\n    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {\n        var weekday = config._locale.weekdaysParse(input, token, config._strict);\n        // if we didn't get a weekday name, mark the date as invalid\n        if (weekday != null) {\n            week.d = weekday;\n        } else {\n            getParsingFlags(config).invalidWeekday = input;\n        }\n    });\n\n    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {\n        week[token] = toInt(input);\n    });\n\n    // HELPERS\n\n    function parseWeekday(input, locale) {\n        if (typeof input !== 'string') {\n            return input;\n        }\n\n        if (!isNaN(input)) {\n            return parseInt(input, 10);\n        }\n\n        input = locale.weekdaysParse(input);\n        if (typeof input === 'number') {\n            return input;\n        }\n\n        return null;\n    }\n\n    function parseIsoWeekday(input, locale) {\n        if (typeof input === 'string') {\n            return locale.weekdaysParse(input) % 7 || 7;\n        }\n        return isNaN(input) ? null : input;\n    }\n\n    // LOCALES\n\n    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');\n    function localeWeekdays (m, format) {\n        if (!m) {\n            return isArray(this._weekdays) ? this._weekdays :\n                this._weekdays['standalone'];\n        }\n        return isArray(this._weekdays) ? this._weekdays[m.day()] :\n            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];\n    }\n\n    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');\n    function localeWeekdaysShort (m) {\n        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;\n    }\n\n    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');\n    function localeWeekdaysMin (m) {\n        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;\n    }\n\n    function handleStrictParse$1(weekdayName, format, strict) {\n        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();\n        if (!this._weekdaysParse) {\n            this._weekdaysParse = [];\n            this._shortWeekdaysParse = [];\n            this._minWeekdaysParse = [];\n\n            for (i = 0; i < 7; ++i) {\n                mom = createUTC([2000, 1]).day(i);\n                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();\n                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();\n                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();\n            }\n        }\n\n        if (strict) {\n            if (format === 'dddd') {\n                ii = indexOf.call(this._weekdaysParse, llc);\n                return ii !== -1 ? ii : null;\n            } else if (format === 'ddd') {\n                ii = indexOf.call(this._shortWeekdaysParse, llc);\n                return ii !== -1 ? ii : null;\n            } else {\n                ii = indexOf.call(this._minWeekdaysParse, llc);\n                return ii !== -1 ? ii : null;\n            }\n        } else {\n            if (format === 'dddd') {\n                ii = indexOf.call(this._weekdaysParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._shortWeekdaysParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._minWeekdaysParse, llc);\n                return ii !== -1 ? ii : null;\n            } else if (format === 'ddd') {\n                ii = indexOf.call(this._shortWeekdaysParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._weekdaysParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._minWeekdaysParse, llc);\n                return ii !== -1 ? ii : null;\n            } else {\n                ii = indexOf.call(this._minWeekdaysParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._weekdaysParse, llc);\n                if (ii !== -1) {\n                    return ii;\n                }\n                ii = indexOf.call(this._shortWeekdaysParse, llc);\n                return ii !== -1 ? ii : null;\n            }\n        }\n    }\n\n    function localeWeekdaysParse (weekdayName, format, strict) {\n        var i, mom, regex;\n\n        if (this._weekdaysParseExact) {\n            return handleStrictParse$1.call(this, weekdayName, format, strict);\n        }\n\n        if (!this._weekdaysParse) {\n            this._weekdaysParse = [];\n            this._minWeekdaysParse = [];\n            this._shortWeekdaysParse = [];\n            this._fullWeekdaysParse = [];\n        }\n\n        for (i = 0; i < 7; i++) {\n            // make the regex if we don't have it already\n\n            mom = createUTC([2000, 1]).day(i);\n            if (strict && !this._fullWeekdaysParse[i]) {\n                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\\\.?') + '$', 'i');\n                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\\\.?') + '$', 'i');\n                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\\\.?') + '$', 'i');\n            }\n            if (!this._weekdaysParse[i]) {\n                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');\n                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');\n            }\n            // test the regex\n            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {\n                return i;\n            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {\n                return i;\n            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {\n                return i;\n            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {\n                return i;\n            }\n        }\n    }\n\n    // MOMENTS\n\n    function getSetDayOfWeek (input) {\n        if (!this.isValid()) {\n            return input != null ? this : NaN;\n        }\n        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();\n        if (input != null) {\n            input = parseWeekday(input, this.localeData());\n            return this.add(input - day, 'd');\n        } else {\n            return day;\n        }\n    }\n\n    function getSetLocaleDayOfWeek (input) {\n        if (!this.isValid()) {\n            return input != null ? this : NaN;\n        }\n        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;\n        return input == null ? weekday : this.add(input - weekday, 'd');\n    }\n\n    function getSetISODayOfWeek (input) {\n        if (!this.isValid()) {\n            return input != null ? this : NaN;\n        }\n\n        // behaves the same as moment#day except\n        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)\n        // as a setter, sunday should belong to the previous week.\n\n        if (input != null) {\n            var weekday = parseIsoWeekday(input, this.localeData());\n            return this.day(this.day() % 7 ? weekday : weekday - 7);\n        } else {\n            return this.day() || 7;\n        }\n    }\n\n    var defaultWeekdaysRegex = matchWord;\n    function weekdaysRegex (isStrict) {\n        if (this._weekdaysParseExact) {\n            if (!hasOwnProp(this, '_weekdaysRegex')) {\n                computeWeekdaysParse.call(this);\n            }\n            if (isStrict) {\n                return this._weekdaysStrictRegex;\n            } else {\n                return this._weekdaysRegex;\n            }\n        } else {\n            if (!hasOwnProp(this, '_weekdaysRegex')) {\n                this._weekdaysRegex = defaultWeekdaysRegex;\n            }\n            return this._weekdaysStrictRegex && isStrict ?\n                this._weekdaysStrictRegex : this._weekdaysRegex;\n        }\n    }\n\n    var defaultWeekdaysShortRegex = matchWord;\n    function weekdaysShortRegex (isStrict) {\n        if (this._weekdaysParseExact) {\n            if (!hasOwnProp(this, '_weekdaysRegex')) {\n                computeWeekdaysParse.call(this);\n            }\n            if (isStrict) {\n                return this._weekdaysShortStrictRegex;\n            } else {\n                return this._weekdaysShortRegex;\n            }\n        } else {\n            if (!hasOwnProp(this, '_weekdaysShortRegex')) {\n                this._weekdaysShortRegex = defaultWeekdaysShortRegex;\n            }\n            return this._weekdaysShortStrictRegex && isStrict ?\n                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;\n        }\n    }\n\n    var defaultWeekdaysMinRegex = matchWord;\n    function weekdaysMinRegex (isStrict) {\n        if (this._weekdaysParseExact) {\n            if (!hasOwnProp(this, '_weekdaysRegex')) {\n                computeWeekdaysParse.call(this);\n            }\n            if (isStrict) {\n                return this._weekdaysMinStrictRegex;\n            } else {\n                return this._weekdaysMinRegex;\n            }\n        } else {\n            if (!hasOwnProp(this, '_weekdaysMinRegex')) {\n                this._weekdaysMinRegex = defaultWeekdaysMinRegex;\n            }\n            return this._weekdaysMinStrictRegex && isStrict ?\n                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;\n        }\n    }\n\n\n    function computeWeekdaysParse () {\n        function cmpLenRev(a, b) {\n            return b.length - a.length;\n        }\n\n        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],\n            i, mom, minp, shortp, longp;\n        for (i = 0; i < 7; i++) {\n            // make the regex if we don't have it already\n            mom = createUTC([2000, 1]).day(i);\n            minp = this.weekdaysMin(mom, '');\n            shortp = this.weekdaysShort(mom, '');\n            longp = this.weekdays(mom, '');\n            minPieces.push(minp);\n            shortPieces.push(shortp);\n            longPieces.push(longp);\n            mixedPieces.push(minp);\n            mixedPieces.push(shortp);\n            mixedPieces.push(longp);\n        }\n        // Sorting makes sure if one weekday (or abbr) is a prefix of another it\n        // will match the longer piece.\n        minPieces.sort(cmpLenRev);\n        shortPieces.sort(cmpLenRev);\n        longPieces.sort(cmpLenRev);\n        mixedPieces.sort(cmpLenRev);\n        for (i = 0; i < 7; i++) {\n            shortPieces[i] = regexEscape(shortPieces[i]);\n            longPieces[i] = regexEscape(longPieces[i]);\n            mixedPieces[i] = regexEscape(mixedPieces[i]);\n        }\n\n        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');\n        this._weekdaysShortRegex = this._weekdaysRegex;\n        this._weekdaysMinRegex = this._weekdaysRegex;\n\n        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');\n        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');\n        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');\n    }\n\n    // FORMATTING\n\n    function hFormat() {\n        return this.hours() % 12 || 12;\n    }\n\n    function kFormat() {\n        return this.hours() || 24;\n    }\n\n    addFormatToken('H', ['HH', 2], 0, 'hour');\n    addFormatToken('h', ['hh', 2], 0, hFormat);\n    addFormatToken('k', ['kk', 2], 0, kFormat);\n\n    addFormatToken('hmm', 0, 0, function () {\n        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);\n    });\n\n    addFormatToken('hmmss', 0, 0, function () {\n        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +\n            zeroFill(this.seconds(), 2);\n    });\n\n    addFormatToken('Hmm', 0, 0, function () {\n        return '' + this.hours() + zeroFill(this.minutes(), 2);\n    });\n\n    addFormatToken('Hmmss', 0, 0, function () {\n        return '' + this.hours() + zeroFill(this.minutes(), 2) +\n            zeroFill(this.seconds(), 2);\n    });\n\n    function meridiem (token, lowercase) {\n        addFormatToken(token, 0, 0, function () {\n            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);\n        });\n    }\n\n    meridiem('a', true);\n    meridiem('A', false);\n\n    // ALIASES\n\n    addUnitAlias('hour', 'h');\n\n    // PRIORITY\n    addUnitPriority('hour', 13);\n\n    // PARSING\n\n    function matchMeridiem (isStrict, locale) {\n        return locale._meridiemParse;\n    }\n\n    addRegexToken('a',  matchMeridiem);\n    addRegexToken('A',  matchMeridiem);\n    addRegexToken('H',  match1to2);\n    addRegexToken('h',  match1to2);\n    addRegexToken('k',  match1to2);\n    addRegexToken('HH', match1to2, match2);\n    addRegexToken('hh', match1to2, match2);\n    addRegexToken('kk', match1to2, match2);\n\n    addRegexToken('hmm', match3to4);\n    addRegexToken('hmmss', match5to6);\n    addRegexToken('Hmm', match3to4);\n    addRegexToken('Hmmss', match5to6);\n\n    addParseToken(['H', 'HH'], HOUR);\n    addParseToken(['k', 'kk'], function (input, array, config) {\n        var kInput = toInt(input);\n        array[HOUR] = kInput === 24 ? 0 : kInput;\n    });\n    addParseToken(['a', 'A'], function (input, array, config) {\n        config._isPm = config._locale.isPM(input);\n        config._meridiem = input;\n    });\n    addParseToken(['h', 'hh'], function (input, array, config) {\n        array[HOUR] = toInt(input);\n        getParsingFlags(config).bigHour = true;\n    });\n    addParseToken('hmm', function (input, array, config) {\n        var pos = input.length - 2;\n        array[HOUR] = toInt(input.substr(0, pos));\n        array[MINUTE] = toInt(input.substr(pos));\n        getParsingFlags(config).bigHour = true;\n    });\n    addParseToken('hmmss', function (input, array, config) {\n        var pos1 = input.length - 4;\n        var pos2 = input.length - 2;\n        array[HOUR] = toInt(input.substr(0, pos1));\n        array[MINUTE] = toInt(input.substr(pos1, 2));\n        array[SECOND] = toInt(input.substr(pos2));\n        getParsingFlags(config).bigHour = true;\n    });\n    addParseToken('Hmm', function (input, array, config) {\n        var pos = input.length - 2;\n        array[HOUR] = toInt(input.substr(0, pos));\n        array[MINUTE] = toInt(input.substr(pos));\n    });\n    addParseToken('Hmmss', function (input, array, config) {\n        var pos1 = input.length - 4;\n        var pos2 = input.length - 2;\n        array[HOUR] = toInt(input.substr(0, pos1));\n        array[MINUTE] = toInt(input.substr(pos1, 2));\n        array[SECOND] = toInt(input.substr(pos2));\n    });\n\n    // LOCALES\n\n    function localeIsPM (input) {\n        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays\n        // Using charAt should be more compatible.\n        return ((input + '').toLowerCase().charAt(0) === 'p');\n    }\n\n    var defaultLocaleMeridiemParse = /[ap]\\.?m?\\.?/i;\n    function localeMeridiem (hours, minutes, isLower) {\n        if (hours > 11) {\n            return isLower ? 'pm' : 'PM';\n        } else {\n            return isLower ? 'am' : 'AM';\n        }\n    }\n\n\n    // MOMENTS\n\n    // Setting the hour should keep the time, because the user explicitly\n    // specified which hour they want. So trying to maintain the same hour (in\n    // a new timezone) makes sense. Adding/subtracting hours does not follow\n    // this rule.\n    var getSetHour = makeGetSet('Hours', true);\n\n    var baseConfig = {\n        calendar: defaultCalendar,\n        longDateFormat: defaultLongDateFormat,\n        invalidDate: defaultInvalidDate,\n        ordinal: defaultOrdinal,\n        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,\n        relativeTime: defaultRelativeTime,\n\n        months: defaultLocaleMonths,\n        monthsShort: defaultLocaleMonthsShort,\n\n        week: defaultLocaleWeek,\n\n        weekdays: defaultLocaleWeekdays,\n        weekdaysMin: defaultLocaleWeekdaysMin,\n        weekdaysShort: defaultLocaleWeekdaysShort,\n\n        meridiemParse: defaultLocaleMeridiemParse\n    };\n\n    // internal storage for locale config files\n    var locales = {};\n    var localeFamilies = {};\n    var globalLocale;\n\n    function normalizeLocale(key) {\n        return key ? key.toLowerCase().replace('_', '-') : key;\n    }\n\n    // pick the locale from the array\n    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each\n    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root\n    function chooseLocale(names) {\n        var i = 0, j, next, locale, split;\n\n        while (i < names.length) {\n            split = normalizeLocale(names[i]).split('-');\n            j = split.length;\n            next = normalizeLocale(names[i + 1]);\n            next = next ? next.split('-') : null;\n            while (j > 0) {\n                locale = loadLocale(split.slice(0, j).join('-'));\n                if (locale) {\n                    return locale;\n                }\n                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {\n                    //the next array item is better than a shallower substring of this one\n                    break;\n                }\n                j--;\n            }\n            i++;\n        }\n        return globalLocale;\n    }\n\n    function loadLocale(name) {\n        var oldLocale = null;\n        // TODO: Find a better way to register and load all the locales in Node\n        if (!locales[name] && (typeof module !== 'undefined') &&\n                module && module.exports) {\n            try {\n                oldLocale = globalLocale._abbr;\n                var aliasedRequire = require;\n                aliasedRequire('./locale/' + name);\n                getSetGlobalLocale(oldLocale);\n            } catch (e) {}\n        }\n        return locales[name];\n    }\n\n    // This function will load locale and then set the global locale.  If\n    // no arguments are passed in, it will simply return the current global\n    // locale key.\n    function getSetGlobalLocale (key, values) {\n        var data;\n        if (key) {\n            if (isUndefined(values)) {\n                data = getLocale(key);\n            }\n            else {\n                data = defineLocale(key, values);\n            }\n\n            if (data) {\n                // moment.duration._locale = moment._locale = data;\n                globalLocale = data;\n            }\n            else {\n                if ((typeof console !==  'undefined') && console.warn) {\n                    //warn user if arguments are passed but the locale could not be set\n                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');\n                }\n            }\n        }\n\n        return globalLocale._abbr;\n    }\n\n    function defineLocale (name, config) {\n        if (config !== null) {\n            var locale, parentConfig = baseConfig;\n            config.abbr = name;\n            if (locales[name] != null) {\n                deprecateSimple('defineLocaleOverride',\n                        'use moment.updateLocale(localeName, config) to change ' +\n                        'an existing locale. moment.defineLocale(localeName, ' +\n                        'config) should only be used for creating a new locale ' +\n                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');\n                parentConfig = locales[name]._config;\n            } else if (config.parentLocale != null) {\n                if (locales[config.parentLocale] != null) {\n                    parentConfig = locales[config.parentLocale]._config;\n                } else {\n                    locale = loadLocale(config.parentLocale);\n                    if (locale != null) {\n                        parentConfig = locale._config;\n                    } else {\n                        if (!localeFamilies[config.parentLocale]) {\n                            localeFamilies[config.parentLocale] = [];\n                        }\n                        localeFamilies[config.parentLocale].push({\n                            name: name,\n                            config: config\n                        });\n                        return null;\n                    }\n                }\n            }\n            locales[name] = new Locale(mergeConfigs(parentConfig, config));\n\n            if (localeFamilies[name]) {\n                localeFamilies[name].forEach(function (x) {\n                    defineLocale(x.name, x.config);\n                });\n            }\n\n            // backwards compat for now: also set the locale\n            // make sure we set the locale AFTER all child locales have been\n            // created, so we won't end up with the child locale set.\n            getSetGlobalLocale(name);\n\n\n            return locales[name];\n        } else {\n            // useful for testing\n            delete locales[name];\n            return null;\n        }\n    }\n\n    function updateLocale(name, config) {\n        if (config != null) {\n            var locale, tmpLocale, parentConfig = baseConfig;\n            // MERGE\n            tmpLocale = loadLocale(name);\n            if (tmpLocale != null) {\n                parentConfig = tmpLocale._config;\n            }\n            config = mergeConfigs(parentConfig, config);\n            locale = new Locale(config);\n            locale.parentLocale = locales[name];\n            locales[name] = locale;\n\n            // backwards compat for now: also set the locale\n            getSetGlobalLocale(name);\n        } else {\n            // pass null for config to unupdate, useful for tests\n            if (locales[name] != null) {\n                if (locales[name].parentLocale != null) {\n                    locales[name] = locales[name].parentLocale;\n                } else if (locales[name] != null) {\n                    delete locales[name];\n                }\n            }\n        }\n        return locales[name];\n    }\n\n    // returns locale data\n    function getLocale (key) {\n        var locale;\n\n        if (key && key._locale && key._locale._abbr) {\n            key = key._locale._abbr;\n        }\n\n        if (!key) {\n            return globalLocale;\n        }\n\n        if (!isArray(key)) {\n            //short-circuit everything else\n            locale = loadLocale(key);\n            if (locale) {\n                return locale;\n            }\n            key = [key];\n        }\n\n        return chooseLocale(key);\n    }\n\n    function listLocales() {\n        return keys(locales);\n    }\n\n    function checkOverflow (m) {\n        var overflow;\n        var a = m._a;\n\n        if (a && getParsingFlags(m).overflow === -2) {\n            overflow =\n                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :\n                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :\n                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :\n                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :\n                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :\n                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :\n                -1;\n\n            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {\n                overflow = DATE;\n            }\n            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {\n                overflow = WEEK;\n            }\n            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {\n                overflow = WEEKDAY;\n            }\n\n            getParsingFlags(m).overflow = overflow;\n        }\n\n        return m;\n    }\n\n    // Pick the first defined of two or three arguments.\n    function defaults(a, b, c) {\n        if (a != null) {\n            return a;\n        }\n        if (b != null) {\n            return b;\n        }\n        return c;\n    }\n\n    function currentDateArray(config) {\n        // hooks is actually the exported moment object\n        var nowValue = new Date(hooks.now());\n        if (config._useUTC) {\n            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];\n        }\n        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];\n    }\n\n    // convert an array to a date.\n    // the array should mirror the parameters below\n    // note: all values past the year are optional and will default to the lowest possible value.\n    // [year, month, day , hour, minute, second, millisecond]\n    function configFromArray (config) {\n        var i, date, input = [], currentDate, expectedWeekday, yearToUse;\n\n        if (config._d) {\n            return;\n        }\n\n        currentDate = currentDateArray(config);\n\n        //compute day of the year from weeks and weekdays\n        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {\n            dayOfYearFromWeekInfo(config);\n        }\n\n        //if the day of the year is set, figure out what it is\n        if (config._dayOfYear != null) {\n            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);\n\n            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {\n                getParsingFlags(config)._overflowDayOfYear = true;\n            }\n\n            date = createUTCDate(yearToUse, 0, config._dayOfYear);\n            config._a[MONTH] = date.getUTCMonth();\n            config._a[DATE] = date.getUTCDate();\n        }\n\n        // Default to current date.\n        // * if no year, month, day of month are given, default to today\n        // * if day of month is given, default month and year\n        // * if month is given, default only year\n        // * if year is given, don't default anything\n        for (i = 0; i < 3 && config._a[i] == null; ++i) {\n            config._a[i] = input[i] = currentDate[i];\n        }\n\n        // Zero out whatever was not defaulted, including time\n        for (; i < 7; i++) {\n            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];\n        }\n\n        // Check for 24:00:00.000\n        if (config._a[HOUR] === 24 &&\n                config._a[MINUTE] === 0 &&\n                config._a[SECOND] === 0 &&\n                config._a[MILLISECOND] === 0) {\n            config._nextDay = true;\n            config._a[HOUR] = 0;\n        }\n\n        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);\n        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();\n\n        // Apply timezone offset from input. The actual utcOffset can be changed\n        // with parseZone.\n        if (config._tzm != null) {\n            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);\n        }\n\n        if (config._nextDay) {\n            config._a[HOUR] = 24;\n        }\n\n        // check for mismatching day of week\n        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {\n            getParsingFlags(config).weekdayMismatch = true;\n        }\n    }\n\n    function dayOfYearFromWeekInfo(config) {\n        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;\n\n        w = config._w;\n        if (w.GG != null || w.W != null || w.E != null) {\n            dow = 1;\n            doy = 4;\n\n            // TODO: We need to take the current isoWeekYear, but that depends on\n            // how we interpret now (local, utc, fixed offset). So create\n            // a now version of current config (take local/utc/offset flags, and\n            // create now).\n            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);\n            week = defaults(w.W, 1);\n            weekday = defaults(w.E, 1);\n            if (weekday < 1 || weekday > 7) {\n                weekdayOverflow = true;\n            }\n        } else {\n            dow = config._locale._week.dow;\n            doy = config._locale._week.doy;\n\n            var curWeek = weekOfYear(createLocal(), dow, doy);\n\n            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);\n\n            // Default to current week.\n            week = defaults(w.w, curWeek.week);\n\n            if (w.d != null) {\n                // weekday -- low day numbers are considered next week\n                weekday = w.d;\n                if (weekday < 0 || weekday > 6) {\n                    weekdayOverflow = true;\n                }\n            } else if (w.e != null) {\n                // local weekday -- counting starts from begining of week\n                weekday = w.e + dow;\n                if (w.e < 0 || w.e > 6) {\n                    weekdayOverflow = true;\n                }\n            } else {\n                // default to begining of week\n                weekday = dow;\n            }\n        }\n        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {\n            getParsingFlags(config)._overflowWeeks = true;\n        } else if (weekdayOverflow != null) {\n            getParsingFlags(config)._overflowWeekday = true;\n        } else {\n            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);\n            config._a[YEAR] = temp.year;\n            config._dayOfYear = temp.dayOfYear;\n        }\n    }\n\n    // iso 8601 regex\n    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)\n    var extendedIsoRegex = /^\\s*((?:[+-]\\d{6}|\\d{4})-(?:\\d\\d-\\d\\d|W\\d\\d-\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?::\\d\\d(?::\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/;\n    var basicIsoRegex = /^\\s*((?:[+-]\\d{6}|\\d{4})(?:\\d\\d\\d\\d|W\\d\\d\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?:\\d\\d(?:\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/;\n\n    var tzRegex = /Z|[+-]\\d\\d(?::?\\d\\d)?/;\n\n    var isoDates = [\n        ['YYYYYY-MM-DD', /[+-]\\d{6}-\\d\\d-\\d\\d/],\n        ['YYYY-MM-DD', /\\d{4}-\\d\\d-\\d\\d/],\n        ['GGGG-[W]WW-E', /\\d{4}-W\\d\\d-\\d/],\n        ['GGGG-[W]WW', /\\d{4}-W\\d\\d/, false],\n        ['YYYY-DDD', /\\d{4}-\\d{3}/],\n        ['YYYY-MM', /\\d{4}-\\d\\d/, false],\n        ['YYYYYYMMDD', /[+-]\\d{10}/],\n        ['YYYYMMDD', /\\d{8}/],\n        // YYYYMM is NOT allowed by the standard\n        ['GGGG[W]WWE', /\\d{4}W\\d{3}/],\n        ['GGGG[W]WW', /\\d{4}W\\d{2}/, false],\n        ['YYYYDDD', /\\d{7}/]\n    ];\n\n    // iso time formats and regexes\n    var isoTimes = [\n        ['HH:mm:ss.SSSS', /\\d\\d:\\d\\d:\\d\\d\\.\\d+/],\n        ['HH:mm:ss,SSSS', /\\d\\d:\\d\\d:\\d\\d,\\d+/],\n        ['HH:mm:ss', /\\d\\d:\\d\\d:\\d\\d/],\n        ['HH:mm', /\\d\\d:\\d\\d/],\n        ['HHmmss.SSSS', /\\d\\d\\d\\d\\d\\d\\.\\d+/],\n        ['HHmmss,SSSS', /\\d\\d\\d\\d\\d\\d,\\d+/],\n        ['HHmmss', /\\d\\d\\d\\d\\d\\d/],\n        ['HHmm', /\\d\\d\\d\\d/],\n        ['HH', /\\d\\d/]\n    ];\n\n    var aspNetJsonRegex = /^\\/?Date\\((\\-?\\d+)/i;\n\n    // date from iso format\n    function configFromISO(config) {\n        var i, l,\n            string = config._i,\n            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),\n            allowTime, dateFormat, timeFormat, tzFormat;\n\n        if (match) {\n            getParsingFlags(config).iso = true;\n\n            for (i = 0, l = isoDates.length; i < l; i++) {\n                if (isoDates[i][1].exec(match[1])) {\n                    dateFormat = isoDates[i][0];\n                    allowTime = isoDates[i][2] !== false;\n                    break;\n                }\n            }\n            if (dateFormat == null) {\n                config._isValid = false;\n                return;\n            }\n            if (match[3]) {\n                for (i = 0, l = isoTimes.length; i < l; i++) {\n                    if (isoTimes[i][1].exec(match[3])) {\n                        // match[2] should be 'T' or space\n                        timeFormat = (match[2] || ' ') + isoTimes[i][0];\n                        break;\n                    }\n                }\n                if (timeFormat == null) {\n                    config._isValid = false;\n                    return;\n                }\n            }\n            if (!allowTime && timeFormat != null) {\n                config._isValid = false;\n                return;\n            }\n            if (match[4]) {\n                if (tzRegex.exec(match[4])) {\n                    tzFormat = 'Z';\n                } else {\n                    config._isValid = false;\n                    return;\n                }\n            }\n            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');\n            configFromStringAndFormat(config);\n        } else {\n            config._isValid = false;\n        }\n    }\n\n    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3\n    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\\s)?(\\d{1,2})\\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\s(\\d{2,4})\\s(\\d\\d):(\\d\\d)(?::(\\d\\d))?\\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\\d{4}))$/;\n\n    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {\n        var result = [\n            untruncateYear(yearStr),\n            defaultLocaleMonthsShort.indexOf(monthStr),\n            parseInt(dayStr, 10),\n            parseInt(hourStr, 10),\n            parseInt(minuteStr, 10)\n        ];\n\n        if (secondStr) {\n            result.push(parseInt(secondStr, 10));\n        }\n\n        return result;\n    }\n\n    function untruncateYear(yearStr) {\n        var year = parseInt(yearStr, 10);\n        if (year <= 49) {\n            return 2000 + year;\n        } else if (year <= 999) {\n            return 1900 + year;\n        }\n        return year;\n    }\n\n    function preprocessRFC2822(s) {\n        // Remove comments and folding whitespace and replace multiple-spaces with a single space\n        return s.replace(/\\([^)]*\\)|[\\n\\t]/g, ' ').replace(/(\\s\\s+)/g, ' ').replace(/^\\s\\s*/, '').replace(/\\s\\s*$/, '');\n    }\n\n    function checkWeekday(weekdayStr, parsedInput, config) {\n        if (weekdayStr) {\n            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.\n            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),\n                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();\n            if (weekdayProvided !== weekdayActual) {\n                getParsingFlags(config).weekdayMismatch = true;\n                config._isValid = false;\n                return false;\n            }\n        }\n        return true;\n    }\n\n    var obsOffsets = {\n        UT: 0,\n        GMT: 0,\n        EDT: -4 * 60,\n        EST: -5 * 60,\n        CDT: -5 * 60,\n        CST: -6 * 60,\n        MDT: -6 * 60,\n        MST: -7 * 60,\n        PDT: -7 * 60,\n        PST: -8 * 60\n    };\n\n    function calculateOffset(obsOffset, militaryOffset, numOffset) {\n        if (obsOffset) {\n            return obsOffsets[obsOffset];\n        } else if (militaryOffset) {\n            // the only allowed military tz is Z\n            return 0;\n        } else {\n            var hm = parseInt(numOffset, 10);\n            var m = hm % 100, h = (hm - m) / 100;\n            return h * 60 + m;\n        }\n    }\n\n    // date and time from ref 2822 format\n    function configFromRFC2822(config) {\n        var match = rfc2822.exec(preprocessRFC2822(config._i));\n        if (match) {\n            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);\n            if (!checkWeekday(match[1], parsedArray, config)) {\n                return;\n            }\n\n            config._a = parsedArray;\n            config._tzm = calculateOffset(match[8], match[9], match[10]);\n\n            config._d = createUTCDate.apply(null, config._a);\n            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);\n\n            getParsingFlags(config).rfc2822 = true;\n        } else {\n            config._isValid = false;\n        }\n    }\n\n    // date from iso format or fallback\n    function configFromString(config) {\n        var matched = aspNetJsonRegex.exec(config._i);\n\n        if (matched !== null) {\n            config._d = new Date(+matched[1]);\n            return;\n        }\n\n        configFromISO(config);\n        if (config._isValid === false) {\n            delete config._isValid;\n        } else {\n            return;\n        }\n\n        configFromRFC2822(config);\n        if (config._isValid === false) {\n            delete config._isValid;\n        } else {\n            return;\n        }\n\n        // Final attempt, use Input Fallback\n        hooks.createFromInputFallback(config);\n    }\n\n    hooks.createFromInputFallback = deprecate(\n        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +\n        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +\n        'discouraged and will be removed in an upcoming major release. Please refer to ' +\n        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',\n        function (config) {\n            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));\n        }\n    );\n\n    // constant that refers to the ISO standard\n    hooks.ISO_8601 = function () {};\n\n    // constant that refers to the RFC 2822 form\n    hooks.RFC_2822 = function () {};\n\n    // date from string and format string\n    function configFromStringAndFormat(config) {\n        // TODO: Move this to another part of the creation flow to prevent circular deps\n        if (config._f === hooks.ISO_8601) {\n            configFromISO(config);\n            return;\n        }\n        if (config._f === hooks.RFC_2822) {\n            configFromRFC2822(config);\n            return;\n        }\n        config._a = [];\n        getParsingFlags(config).empty = true;\n\n        // This array is used to make a Date, either with `new Date` or `Date.UTC`\n        var string = '' + config._i,\n            i, parsedInput, tokens, token, skipped,\n            stringLength = string.length,\n            totalParsedInputLength = 0;\n\n        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];\n\n        for (i = 0; i < tokens.length; i++) {\n            token = tokens[i];\n            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];\n            // console.log('token', token, 'parsedInput', parsedInput,\n            //         'regex', getParseRegexForToken(token, config));\n            if (parsedInput) {\n                skipped = string.substr(0, string.indexOf(parsedInput));\n                if (skipped.length > 0) {\n                    getParsingFlags(config).unusedInput.push(skipped);\n                }\n                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);\n                totalParsedInputLength += parsedInput.length;\n            }\n            // don't parse if it's not a known token\n            if (formatTokenFunctions[token]) {\n                if (parsedInput) {\n                    getParsingFlags(config).empty = false;\n                }\n                else {\n                    getParsingFlags(config).unusedTokens.push(token);\n                }\n                addTimeToArrayFromToken(token, parsedInput, config);\n            }\n            else if (config._strict && !parsedInput) {\n                getParsingFlags(config).unusedTokens.push(token);\n            }\n        }\n\n        // add remaining unparsed input length to the string\n        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;\n        if (string.length > 0) {\n            getParsingFlags(config).unusedInput.push(string);\n        }\n\n        // clear _12h flag if hour is <= 12\n        if (config._a[HOUR] <= 12 &&\n            getParsingFlags(config).bigHour === true &&\n            config._a[HOUR] > 0) {\n            getParsingFlags(config).bigHour = undefined;\n        }\n\n        getParsingFlags(config).parsedDateParts = config._a.slice(0);\n        getParsingFlags(config).meridiem = config._meridiem;\n        // handle meridiem\n        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);\n\n        configFromArray(config);\n        checkOverflow(config);\n    }\n\n\n    function meridiemFixWrap (locale, hour, meridiem) {\n        var isPm;\n\n        if (meridiem == null) {\n            // nothing to do\n            return hour;\n        }\n        if (locale.meridiemHour != null) {\n            return locale.meridiemHour(hour, meridiem);\n        } else if (locale.isPM != null) {\n            // Fallback\n            isPm = locale.isPM(meridiem);\n            if (isPm && hour < 12) {\n                hour += 12;\n            }\n            if (!isPm && hour === 12) {\n                hour = 0;\n            }\n            return hour;\n        } else {\n            // this is not supposed to happen\n            return hour;\n        }\n    }\n\n    // date from string and array of format strings\n    function configFromStringAndArray(config) {\n        var tempConfig,\n            bestMoment,\n\n            scoreToBeat,\n            i,\n            currentScore;\n\n        if (config._f.length === 0) {\n            getParsingFlags(config).invalidFormat = true;\n            config._d = new Date(NaN);\n            return;\n        }\n\n        for (i = 0; i < config._f.length; i++) {\n            currentScore = 0;\n            tempConfig = copyConfig({}, config);\n            if (config._useUTC != null) {\n                tempConfig._useUTC = config._useUTC;\n            }\n            tempConfig._f = config._f[i];\n            configFromStringAndFormat(tempConfig);\n\n            if (!isValid(tempConfig)) {\n                continue;\n            }\n\n            // if there is any input that was not parsed add a penalty for that format\n            currentScore += getParsingFlags(tempConfig).charsLeftOver;\n\n            //or tokens\n            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;\n\n            getParsingFlags(tempConfig).score = currentScore;\n\n            if (scoreToBeat == null || currentScore < scoreToBeat) {\n                scoreToBeat = currentScore;\n                bestMoment = tempConfig;\n            }\n        }\n\n        extend(config, bestMoment || tempConfig);\n    }\n\n    function configFromObject(config) {\n        if (config._d) {\n            return;\n        }\n\n        var i = normalizeObjectUnits(config._i);\n        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {\n            return obj && parseInt(obj, 10);\n        });\n\n        configFromArray(config);\n    }\n\n    function createFromConfig (config) {\n        var res = new Moment(checkOverflow(prepareConfig(config)));\n        if (res._nextDay) {\n            // Adding is smart enough around DST\n            res.add(1, 'd');\n            res._nextDay = undefined;\n        }\n\n        return res;\n    }\n\n    function prepareConfig (config) {\n        var input = config._i,\n            format = config._f;\n\n        config._locale = config._locale || getLocale(config._l);\n\n        if (input === null || (format === undefined && input === '')) {\n            return createInvalid({nullInput: true});\n        }\n\n        if (typeof input === 'string') {\n            config._i = input = config._locale.preparse(input);\n        }\n\n        if (isMoment(input)) {\n            return new Moment(checkOverflow(input));\n        } else if (isDate(input)) {\n            config._d = input;\n        } else if (isArray(format)) {\n            configFromStringAndArray(config);\n        } else if (format) {\n            configFromStringAndFormat(config);\n        }  else {\n            configFromInput(config);\n        }\n\n        if (!isValid(config)) {\n            config._d = null;\n        }\n\n        return config;\n    }\n\n    function configFromInput(config) {\n        var input = config._i;\n        if (isUndefined(input)) {\n            config._d = new Date(hooks.now());\n        } else if (isDate(input)) {\n            config._d = new Date(input.valueOf());\n        } else if (typeof input === 'string') {\n            configFromString(config);\n        } else if (isArray(input)) {\n            config._a = map(input.slice(0), function (obj) {\n                return parseInt(obj, 10);\n            });\n            configFromArray(config);\n        } else if (isObject(input)) {\n            configFromObject(config);\n        } else if (isNumber(input)) {\n            // from milliseconds\n            config._d = new Date(input);\n        } else {\n            hooks.createFromInputFallback(config);\n        }\n    }\n\n    function createLocalOrUTC (input, format, locale, strict, isUTC) {\n        var c = {};\n\n        if (locale === true || locale === false) {\n            strict = locale;\n            locale = undefined;\n        }\n\n        if ((isObject(input) && isObjectEmpty(input)) ||\n                (isArray(input) && input.length === 0)) {\n            input = undefined;\n        }\n        // object construction must be done this way.\n        // https://github.com/moment/moment/issues/1423\n        c._isAMomentObject = true;\n        c._useUTC = c._isUTC = isUTC;\n        c._l = locale;\n        c._i = input;\n        c._f = format;\n        c._strict = strict;\n\n        return createFromConfig(c);\n    }\n\n    function createLocal (input, format, locale, strict) {\n        return createLocalOrUTC(input, format, locale, strict, false);\n    }\n\n    var prototypeMin = deprecate(\n        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',\n        function () {\n            var other = createLocal.apply(null, arguments);\n            if (this.isValid() && other.isValid()) {\n                return other < this ? this : other;\n            } else {\n                return createInvalid();\n            }\n        }\n    );\n\n    var prototypeMax = deprecate(\n        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',\n        function () {\n            var other = createLocal.apply(null, arguments);\n            if (this.isValid() && other.isValid()) {\n                return other > this ? this : other;\n            } else {\n                return createInvalid();\n            }\n        }\n    );\n\n    // Pick a moment m from moments so that m[fn](other) is true for all\n    // other. This relies on the function fn to be transitive.\n    //\n    // moments should either be an array of moment objects or an array, whose\n    // first element is an array of moment objects.\n    function pickBy(fn, moments) {\n        var res, i;\n        if (moments.length === 1 && isArray(moments[0])) {\n            moments = moments[0];\n        }\n        if (!moments.length) {\n            return createLocal();\n        }\n        res = moments[0];\n        for (i = 1; i < moments.length; ++i) {\n            if (!moments[i].isValid() || moments[i][fn](res)) {\n                res = moments[i];\n            }\n        }\n        return res;\n    }\n\n    // TODO: Use [].sort instead?\n    function min () {\n        var args = [].slice.call(arguments, 0);\n\n        return pickBy('isBefore', args);\n    }\n\n    function max () {\n        var args = [].slice.call(arguments, 0);\n\n        return pickBy('isAfter', args);\n    }\n\n    var now = function () {\n        return Date.now ? Date.now() : +(new Date());\n    };\n\n    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];\n\n    function isDurationValid(m) {\n        for (var key in m) {\n            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {\n                return false;\n            }\n        }\n\n        var unitHasDecimal = false;\n        for (var i = 0; i < ordering.length; ++i) {\n            if (m[ordering[i]]) {\n                if (unitHasDecimal) {\n                    return false; // only allow non-integers for smallest unit\n                }\n                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {\n                    unitHasDecimal = true;\n                }\n            }\n        }\n\n        return true;\n    }\n\n    function isValid$1() {\n        return this._isValid;\n    }\n\n    function createInvalid$1() {\n        return createDuration(NaN);\n    }\n\n    function Duration (duration) {\n        var normalizedInput = normalizeObjectUnits(duration),\n            years = normalizedInput.year || 0,\n            quarters = normalizedInput.quarter || 0,\n            months = normalizedInput.month || 0,\n            weeks = normalizedInput.week || 0,\n            days = normalizedInput.day || 0,\n            hours = normalizedInput.hour || 0,\n            minutes = normalizedInput.minute || 0,\n            seconds = normalizedInput.second || 0,\n            milliseconds = normalizedInput.millisecond || 0;\n\n        this._isValid = isDurationValid(normalizedInput);\n\n        // representation for dateAddRemove\n        this._milliseconds = +milliseconds +\n            seconds * 1e3 + // 1000\n            minutes * 6e4 + // 1000 * 60\n            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978\n        // Because of dateAddRemove treats 24 hours as different from a\n        // day when working around DST, we need to store them separately\n        this._days = +days +\n            weeks * 7;\n        // It is impossible to translate months into days without knowing\n        // which months you are are talking about, so we have to store\n        // it separately.\n        this._months = +months +\n            quarters * 3 +\n            years * 12;\n\n        this._data = {};\n\n        this._locale = getLocale();\n\n        this._bubble();\n    }\n\n    function isDuration (obj) {\n        return obj instanceof Duration;\n    }\n\n    function absRound (number) {\n        if (number < 0) {\n            return Math.round(-1 * number) * -1;\n        } else {\n            return Math.round(number);\n        }\n    }\n\n    // FORMATTING\n\n    function offset (token, separator) {\n        addFormatToken(token, 0, 0, function () {\n            var offset = this.utcOffset();\n            var sign = '+';\n            if (offset < 0) {\n                offset = -offset;\n                sign = '-';\n            }\n            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);\n        });\n    }\n\n    offset('Z', ':');\n    offset('ZZ', '');\n\n    // PARSING\n\n    addRegexToken('Z',  matchShortOffset);\n    addRegexToken('ZZ', matchShortOffset);\n    addParseToken(['Z', 'ZZ'], function (input, array, config) {\n        config._useUTC = true;\n        config._tzm = offsetFromString(matchShortOffset, input);\n    });\n\n    // HELPERS\n\n    // timezone chunker\n    // '+10:00' > ['10',  '00']\n    // '-1530'  > ['-15', '30']\n    var chunkOffset = /([\\+\\-]|\\d\\d)/gi;\n\n    function offsetFromString(matcher, string) {\n        var matches = (string || '').match(matcher);\n\n        if (matches === null) {\n            return null;\n        }\n\n        var chunk   = matches[matches.length - 1] || [];\n        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];\n        var minutes = +(parts[1] * 60) + toInt(parts[2]);\n\n        return minutes === 0 ?\n          0 :\n          parts[0] === '+' ? minutes : -minutes;\n    }\n\n    // Return a moment from input, that is local/utc/zone equivalent to model.\n    function cloneWithOffset(input, model) {\n        var res, diff;\n        if (model._isUTC) {\n            res = model.clone();\n            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();\n            // Use low-level api, because this fn is low-level api.\n            res._d.setTime(res._d.valueOf() + diff);\n            hooks.updateOffset(res, false);\n            return res;\n        } else {\n            return createLocal(input).local();\n        }\n    }\n\n    function getDateOffset (m) {\n        // On Firefox.24 Date#getTimezoneOffset returns a floating point.\n        // https://github.com/moment/moment/pull/1871\n        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;\n    }\n\n    // HOOKS\n\n    // This function will be called whenever a moment is mutated.\n    // It is intended to keep the offset in sync with the timezone.\n    hooks.updateOffset = function () {};\n\n    // MOMENTS\n\n    // keepLocalTime = true means only change the timezone, without\n    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->\n    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset\n    // +0200, so we adjust the time as needed, to be valid.\n    //\n    // Keeping the time actually adds/subtracts (one hour)\n    // from the actual represented time. That is why we call updateOffset\n    // a second time. In case it wants us to change the offset again\n    // _changeInProgress == true case, then we have to adjust, because\n    // there is no such time in the given timezone.\n    function getSetOffset (input, keepLocalTime, keepMinutes) {\n        var offset = this._offset || 0,\n            localAdjust;\n        if (!this.isValid()) {\n            return input != null ? this : NaN;\n        }\n        if (input != null) {\n            if (typeof input === 'string') {\n                input = offsetFromString(matchShortOffset, input);\n                if (input === null) {\n                    return this;\n                }\n            } else if (Math.abs(input) < 16 && !keepMinutes) {\n                input = input * 60;\n            }\n            if (!this._isUTC && keepLocalTime) {\n                localAdjust = getDateOffset(this);\n            }\n            this._offset = input;\n            this._isUTC = true;\n            if (localAdjust != null) {\n                this.add(localAdjust, 'm');\n            }\n            if (offset !== input) {\n                if (!keepLocalTime || this._changeInProgress) {\n                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);\n                } else if (!this._changeInProgress) {\n                    this._changeInProgress = true;\n                    hooks.updateOffset(this, true);\n                    this._changeInProgress = null;\n                }\n            }\n            return this;\n        } else {\n            return this._isUTC ? offset : getDateOffset(this);\n        }\n    }\n\n    function getSetZone (input, keepLocalTime) {\n        if (input != null) {\n            if (typeof input !== 'string') {\n                input = -input;\n            }\n\n            this.utcOffset(input, keepLocalTime);\n\n            return this;\n        } else {\n            return -this.utcOffset();\n        }\n    }\n\n    function setOffsetToUTC (keepLocalTime) {\n        return this.utcOffset(0, keepLocalTime);\n    }\n\n    function setOffsetToLocal (keepLocalTime) {\n        if (this._isUTC) {\n            this.utcOffset(0, keepLocalTime);\n            this._isUTC = false;\n\n            if (keepLocalTime) {\n                this.subtract(getDateOffset(this), 'm');\n            }\n        }\n        return this;\n    }\n\n    function setOffsetToParsedOffset () {\n        if (this._tzm != null) {\n            this.utcOffset(this._tzm, false, true);\n        } else if (typeof this._i === 'string') {\n            var tZone = offsetFromString(matchOffset, this._i);\n            if (tZone != null) {\n                this.utcOffset(tZone);\n            }\n            else {\n                this.utcOffset(0, true);\n            }\n        }\n        return this;\n    }\n\n    function hasAlignedHourOffset (input) {\n        if (!this.isValid()) {\n            return false;\n        }\n        input = input ? createLocal(input).utcOffset() : 0;\n\n        return (this.utcOffset() - input) % 60 === 0;\n    }\n\n    function isDaylightSavingTime () {\n        return (\n            this.utcOffset() > this.clone().month(0).utcOffset() ||\n            this.utcOffset() > this.clone().month(5).utcOffset()\n        );\n    }\n\n    function isDaylightSavingTimeShifted () {\n        if (!isUndefined(this._isDSTShifted)) {\n            return this._isDSTShifted;\n        }\n\n        var c = {};\n\n        copyConfig(c, this);\n        c = prepareConfig(c);\n\n        if (c._a) {\n            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);\n            this._isDSTShifted = this.isValid() &&\n                compareArrays(c._a, other.toArray()) > 0;\n        } else {\n            this._isDSTShifted = false;\n        }\n\n        return this._isDSTShifted;\n    }\n\n    function isLocal () {\n        return this.isValid() ? !this._isUTC : false;\n    }\n\n    function isUtcOffset () {\n        return this.isValid() ? this._isUTC : false;\n    }\n\n    function isUtc () {\n        return this.isValid() ? this._isUTC && this._offset === 0 : false;\n    }\n\n    // ASP.NET json date format regex\n    var aspNetRegex = /^(\\-|\\+)?(?:(\\d*)[. ])?(\\d+)\\:(\\d+)(?:\\:(\\d+)(\\.\\d*)?)?$/;\n\n    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html\n    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere\n    // and further modified to allow for strings containing both week and day\n    var isoRegex = /^(-|\\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;\n\n    function createDuration (input, key) {\n        var duration = input,\n            // matching against regexp is expensive, do it on demand\n            match = null,\n            sign,\n            ret,\n            diffRes;\n\n        if (isDuration(input)) {\n            duration = {\n                ms : input._milliseconds,\n                d  : input._days,\n                M  : input._months\n            };\n        } else if (isNumber(input)) {\n            duration = {};\n            if (key) {\n                duration[key] = input;\n            } else {\n                duration.milliseconds = input;\n            }\n        } else if (!!(match = aspNetRegex.exec(input))) {\n            sign = (match[1] === '-') ? -1 : 1;\n            duration = {\n                y  : 0,\n                d  : toInt(match[DATE])                         * sign,\n                h  : toInt(match[HOUR])                         * sign,\n                m  : toInt(match[MINUTE])                       * sign,\n                s  : toInt(match[SECOND])                       * sign,\n                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match\n            };\n        } else if (!!(match = isoRegex.exec(input))) {\n            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;\n            duration = {\n                y : parseIso(match[2], sign),\n                M : parseIso(match[3], sign),\n                w : parseIso(match[4], sign),\n                d : parseIso(match[5], sign),\n                h : parseIso(match[6], sign),\n                m : parseIso(match[7], sign),\n                s : parseIso(match[8], sign)\n            };\n        } else if (duration == null) {// checks for null or undefined\n            duration = {};\n        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {\n            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));\n\n            duration = {};\n            duration.ms = diffRes.milliseconds;\n            duration.M = diffRes.months;\n        }\n\n        ret = new Duration(duration);\n\n        if (isDuration(input) && hasOwnProp(input, '_locale')) {\n            ret._locale = input._locale;\n        }\n\n        return ret;\n    }\n\n    createDuration.fn = Duration.prototype;\n    createDuration.invalid = createInvalid$1;\n\n    function parseIso (inp, sign) {\n        // We'd normally use ~~inp for this, but unfortunately it also\n        // converts floats to ints.\n        // inp may be undefined, so careful calling replace on it.\n        var res = inp && parseFloat(inp.replace(',', '.'));\n        // apply sign while we're at it\n        return (isNaN(res) ? 0 : res) * sign;\n    }\n\n    function positiveMomentsDifference(base, other) {\n        var res = {milliseconds: 0, months: 0};\n\n        res.months = other.month() - base.month() +\n            (other.year() - base.year()) * 12;\n        if (base.clone().add(res.months, 'M').isAfter(other)) {\n            --res.months;\n        }\n\n        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));\n\n        return res;\n    }\n\n    function momentsDifference(base, other) {\n        var res;\n        if (!(base.isValid() && other.isValid())) {\n            return {milliseconds: 0, months: 0};\n        }\n\n        other = cloneWithOffset(other, base);\n        if (base.isBefore(other)) {\n            res = positiveMomentsDifference(base, other);\n        } else {\n            res = positiveMomentsDifference(other, base);\n            res.milliseconds = -res.milliseconds;\n            res.months = -res.months;\n        }\n\n        return res;\n    }\n\n    // TODO: remove 'name' arg after deprecation is removed\n    function createAdder(direction, name) {\n        return function (val, period) {\n            var dur, tmp;\n            //invert the arguments, but complain about it\n            if (period !== null && !isNaN(+period)) {\n                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +\n                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');\n                tmp = val; val = period; period = tmp;\n            }\n\n            val = typeof val === 'string' ? +val : val;\n            dur = createDuration(val, period);\n            addSubtract(this, dur, direction);\n            return this;\n        };\n    }\n\n    function addSubtract (mom, duration, isAdding, updateOffset) {\n        var milliseconds = duration._milliseconds,\n            days = absRound(duration._days),\n            months = absRound(duration._months);\n\n        if (!mom.isValid()) {\n            // No op\n            return;\n        }\n\n        updateOffset = updateOffset == null ? true : updateOffset;\n\n        if (months) {\n            setMonth(mom, get(mom, 'Month') + months * isAdding);\n        }\n        if (days) {\n            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);\n        }\n        if (milliseconds) {\n            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);\n        }\n        if (updateOffset) {\n            hooks.updateOffset(mom, days || months);\n        }\n    }\n\n    var add      = createAdder(1, 'add');\n    var subtract = createAdder(-1, 'subtract');\n\n    function getCalendarFormat(myMoment, now) {\n        var diff = myMoment.diff(now, 'days', true);\n        return diff < -6 ? 'sameElse' :\n                diff < -1 ? 'lastWeek' :\n                diff < 0 ? 'lastDay' :\n                diff < 1 ? 'sameDay' :\n                diff < 2 ? 'nextDay' :\n                diff < 7 ? 'nextWeek' : 'sameElse';\n    }\n\n    function calendar$1 (time, formats) {\n        // We want to compare the start of today, vs this.\n        // Getting start-of-today depends on whether we're local/utc/offset or not.\n        var now = time || createLocal(),\n            sod = cloneWithOffset(now, this).startOf('day'),\n            format = hooks.calendarFormat(this, sod) || 'sameElse';\n\n        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);\n\n        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));\n    }\n\n    function clone () {\n        return new Moment(this);\n    }\n\n    function isAfter (input, units) {\n        var localInput = isMoment(input) ? input : createLocal(input);\n        if (!(this.isValid() && localInput.isValid())) {\n            return false;\n        }\n        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');\n        if (units === 'millisecond') {\n            return this.valueOf() > localInput.valueOf();\n        } else {\n            return localInput.valueOf() < this.clone().startOf(units).valueOf();\n        }\n    }\n\n    function isBefore (input, units) {\n        var localInput = isMoment(input) ? input : createLocal(input);\n        if (!(this.isValid() && localInput.isValid())) {\n            return false;\n        }\n        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');\n        if (units === 'millisecond') {\n            return this.valueOf() < localInput.valueOf();\n        } else {\n            return this.clone().endOf(units).valueOf() < localInput.valueOf();\n        }\n    }\n\n    function isBetween (from, to, units, inclusivity) {\n        inclusivity = inclusivity || '()';\n        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&\n            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));\n    }\n\n    function isSame (input, units) {\n        var localInput = isMoment(input) ? input : createLocal(input),\n            inputMs;\n        if (!(this.isValid() && localInput.isValid())) {\n            return false;\n        }\n        units = normalizeUnits(units || 'millisecond');\n        if (units === 'millisecond') {\n            return this.valueOf() === localInput.valueOf();\n        } else {\n            inputMs = localInput.valueOf();\n            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();\n        }\n    }\n\n    function isSameOrAfter (input, units) {\n        return this.isSame(input, units) || this.isAfter(input,units);\n    }\n\n    function isSameOrBefore (input, units) {\n        return this.isSame(input, units) || this.isBefore(input,units);\n    }\n\n    function diff (input, units, asFloat) {\n        var that,\n            zoneDelta,\n            output;\n\n        if (!this.isValid()) {\n            return NaN;\n        }\n\n        that = cloneWithOffset(input, this);\n\n        if (!that.isValid()) {\n            return NaN;\n        }\n\n        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;\n\n        units = normalizeUnits(units);\n\n        switch (units) {\n            case 'year': output = monthDiff(this, that) / 12; break;\n            case 'month': output = monthDiff(this, that); break;\n            case 'quarter': output = monthDiff(this, that) / 3; break;\n            case 'second': output = (this - that) / 1e3; break; // 1000\n            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60\n            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60\n            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst\n            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst\n            default: output = this - that;\n        }\n\n        return asFloat ? output : absFloor(output);\n    }\n\n    function monthDiff (a, b) {\n        // difference in months\n        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),\n            // b is in (anchor - 1 month, anchor + 1 month)\n            anchor = a.clone().add(wholeMonthDiff, 'months'),\n            anchor2, adjust;\n\n        if (b - anchor < 0) {\n            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');\n            // linear across the month\n            adjust = (b - anchor) / (anchor - anchor2);\n        } else {\n            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');\n            // linear across the month\n            adjust = (b - anchor) / (anchor2 - anchor);\n        }\n\n        //check for negative zero, return zero if negative zero\n        return -(wholeMonthDiff + adjust) || 0;\n    }\n\n    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';\n    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';\n\n    function toString () {\n        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');\n    }\n\n    function toISOString(keepOffset) {\n        if (!this.isValid()) {\n            return null;\n        }\n        var utc = keepOffset !== true;\n        var m = utc ? this.clone().utc() : this;\n        if (m.year() < 0 || m.year() > 9999) {\n            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');\n        }\n        if (isFunction(Date.prototype.toISOString)) {\n            // native implementation is ~50x faster, use it when we can\n            if (utc) {\n                return this.toDate().toISOString();\n            } else {\n                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));\n            }\n        }\n        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');\n    }\n\n    /**\n     * Return a human readable representation of a moment that can\n     * also be evaluated to get a new moment which is the same\n     *\n     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects\n     */\n    function inspect () {\n        if (!this.isValid()) {\n            return 'moment.invalid(/* ' + this._i + ' */)';\n        }\n        var func = 'moment';\n        var zone = '';\n        if (!this.isLocal()) {\n            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';\n            zone = 'Z';\n        }\n        var prefix = '[' + func + '(\"]';\n        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';\n        var datetime = '-MM-DD[T]HH:mm:ss.SSS';\n        var suffix = zone + '[\")]';\n\n        return this.format(prefix + year + datetime + suffix);\n    }\n\n    function format (inputString) {\n        if (!inputString) {\n            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;\n        }\n        var output = formatMoment(this, inputString);\n        return this.localeData().postformat(output);\n    }\n\n    function from (time, withoutSuffix) {\n        if (this.isValid() &&\n                ((isMoment(time) && time.isValid()) ||\n                 createLocal(time).isValid())) {\n            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);\n        } else {\n            return this.localeData().invalidDate();\n        }\n    }\n\n    function fromNow (withoutSuffix) {\n        return this.from(createLocal(), withoutSuffix);\n    }\n\n    function to (time, withoutSuffix) {\n        if (this.isValid() &&\n                ((isMoment(time) && time.isValid()) ||\n                 createLocal(time).isValid())) {\n            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);\n        } else {\n            return this.localeData().invalidDate();\n        }\n    }\n\n    function toNow (withoutSuffix) {\n        return this.to(createLocal(), withoutSuffix);\n    }\n\n    // If passed a locale key, it will set the locale for this\n    // instance.  Otherwise, it will return the locale configuration\n    // variables for this instance.\n    function locale (key) {\n        var newLocaleData;\n\n        if (key === undefined) {\n            return this._locale._abbr;\n        } else {\n            newLocaleData = getLocale(key);\n            if (newLocaleData != null) {\n                this._locale = newLocaleData;\n            }\n            return this;\n        }\n    }\n\n    var lang = deprecate(\n        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',\n        function (key) {\n            if (key === undefined) {\n                return this.localeData();\n            } else {\n                return this.locale(key);\n            }\n        }\n    );\n\n    function localeData () {\n        return this._locale;\n    }\n\n    function startOf (units) {\n        units = normalizeUnits(units);\n        // the following switch intentionally omits break keywords\n        // to utilize falling through the cases.\n        switch (units) {\n            case 'year':\n                this.month(0);\n                /* falls through */\n            case 'quarter':\n            case 'month':\n                this.date(1);\n                /* falls through */\n            case 'week':\n            case 'isoWeek':\n            case 'day':\n            case 'date':\n                this.hours(0);\n                /* falls through */\n            case 'hour':\n                this.minutes(0);\n                /* falls through */\n            case 'minute':\n                this.seconds(0);\n                /* falls through */\n            case 'second':\n                this.milliseconds(0);\n        }\n\n        // weeks are a special case\n        if (units === 'week') {\n            this.weekday(0);\n        }\n        if (units === 'isoWeek') {\n            this.isoWeekday(1);\n        }\n\n        // quarters are also special\n        if (units === 'quarter') {\n            this.month(Math.floor(this.month() / 3) * 3);\n        }\n\n        return this;\n    }\n\n    function endOf (units) {\n        units = normalizeUnits(units);\n        if (units === undefined || units === 'millisecond') {\n            return this;\n        }\n\n        // 'date' is an alias for 'day', so it should be considered as such.\n        if (units === 'date') {\n            units = 'day';\n        }\n\n        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');\n    }\n\n    function valueOf () {\n        return this._d.valueOf() - ((this._offset || 0) * 60000);\n    }\n\n    function unix () {\n        return Math.floor(this.valueOf() / 1000);\n    }\n\n    function toDate () {\n        return new Date(this.valueOf());\n    }\n\n    function toArray () {\n        var m = this;\n        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];\n    }\n\n    function toObject () {\n        var m = this;\n        return {\n            years: m.year(),\n            months: m.month(),\n            date: m.date(),\n            hours: m.hours(),\n            minutes: m.minutes(),\n            seconds: m.seconds(),\n            milliseconds: m.milliseconds()\n        };\n    }\n\n    function toJSON () {\n        // new Date(NaN).toJSON() === null\n        return this.isValid() ? this.toISOString() : null;\n    }\n\n    function isValid$2 () {\n        return isValid(this);\n    }\n\n    function parsingFlags () {\n        return extend({}, getParsingFlags(this));\n    }\n\n    function invalidAt () {\n        return getParsingFlags(this).overflow;\n    }\n\n    function creationData() {\n        return {\n            input: this._i,\n            format: this._f,\n            locale: this._locale,\n            isUTC: this._isUTC,\n            strict: this._strict\n        };\n    }\n\n    // FORMATTING\n\n    addFormatToken(0, ['gg', 2], 0, function () {\n        return this.weekYear() % 100;\n    });\n\n    addFormatToken(0, ['GG', 2], 0, function () {\n        return this.isoWeekYear() % 100;\n    });\n\n    function addWeekYearFormatToken (token, getter) {\n        addFormatToken(0, [token, token.length], 0, getter);\n    }\n\n    addWeekYearFormatToken('gggg',     'weekYear');\n    addWeekYearFormatToken('ggggg',    'weekYear');\n    addWeekYearFormatToken('GGGG',  'isoWeekYear');\n    addWeekYearFormatToken('GGGGG', 'isoWeekYear');\n\n    // ALIASES\n\n    addUnitAlias('weekYear', 'gg');\n    addUnitAlias('isoWeekYear', 'GG');\n\n    // PRIORITY\n\n    addUnitPriority('weekYear', 1);\n    addUnitPriority('isoWeekYear', 1);\n\n\n    // PARSING\n\n    addRegexToken('G',      matchSigned);\n    addRegexToken('g',      matchSigned);\n    addRegexToken('GG',     match1to2, match2);\n    addRegexToken('gg',     match1to2, match2);\n    addRegexToken('GGGG',   match1to4, match4);\n    addRegexToken('gggg',   match1to4, match4);\n    addRegexToken('GGGGG',  match1to6, match6);\n    addRegexToken('ggggg',  match1to6, match6);\n\n    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {\n        week[token.substr(0, 2)] = toInt(input);\n    });\n\n    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {\n        week[token] = hooks.parseTwoDigitYear(input);\n    });\n\n    // MOMENTS\n\n    function getSetWeekYear (input) {\n        return getSetWeekYearHelper.call(this,\n                input,\n                this.week(),\n                this.weekday(),\n                this.localeData()._week.dow,\n                this.localeData()._week.doy);\n    }\n\n    function getSetISOWeekYear (input) {\n        return getSetWeekYearHelper.call(this,\n                input, this.isoWeek(), this.isoWeekday(), 1, 4);\n    }\n\n    function getISOWeeksInYear () {\n        return weeksInYear(this.year(), 1, 4);\n    }\n\n    function getWeeksInYear () {\n        var weekInfo = this.localeData()._week;\n        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);\n    }\n\n    function getSetWeekYearHelper(input, week, weekday, dow, doy) {\n        var weeksTarget;\n        if (input == null) {\n            return weekOfYear(this, dow, doy).year;\n        } else {\n            weeksTarget = weeksInYear(input, dow, doy);\n            if (week > weeksTarget) {\n                week = weeksTarget;\n            }\n            return setWeekAll.call(this, input, week, weekday, dow, doy);\n        }\n    }\n\n    function setWeekAll(weekYear, week, weekday, dow, doy) {\n        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),\n            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);\n\n        this.year(date.getUTCFullYear());\n        this.month(date.getUTCMonth());\n        this.date(date.getUTCDate());\n        return this;\n    }\n\n    // FORMATTING\n\n    addFormatToken('Q', 0, 'Qo', 'quarter');\n\n    // ALIASES\n\n    addUnitAlias('quarter', 'Q');\n\n    // PRIORITY\n\n    addUnitPriority('quarter', 7);\n\n    // PARSING\n\n    addRegexToken('Q', match1);\n    addParseToken('Q', function (input, array) {\n        array[MONTH] = (toInt(input) - 1) * 3;\n    });\n\n    // MOMENTS\n\n    function getSetQuarter (input) {\n        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);\n    }\n\n    // FORMATTING\n\n    addFormatToken('D', ['DD', 2], 'Do', 'date');\n\n    // ALIASES\n\n    addUnitAlias('date', 'D');\n\n    // PRIORITY\n    addUnitPriority('date', 9);\n\n    // PARSING\n\n    addRegexToken('D',  match1to2);\n    addRegexToken('DD', match1to2, match2);\n    addRegexToken('Do', function (isStrict, locale) {\n        // TODO: Remove \"ordinalParse\" fallback in next major release.\n        return isStrict ?\n          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :\n          locale._dayOfMonthOrdinalParseLenient;\n    });\n\n    addParseToken(['D', 'DD'], DATE);\n    addParseToken('Do', function (input, array) {\n        array[DATE] = toInt(input.match(match1to2)[0]);\n    });\n\n    // MOMENTS\n\n    var getSetDayOfMonth = makeGetSet('Date', true);\n\n    // FORMATTING\n\n    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');\n\n    // ALIASES\n\n    addUnitAlias('dayOfYear', 'DDD');\n\n    // PRIORITY\n    addUnitPriority('dayOfYear', 4);\n\n    // PARSING\n\n    addRegexToken('DDD',  match1to3);\n    addRegexToken('DDDD', match3);\n    addParseToken(['DDD', 'DDDD'], function (input, array, config) {\n        config._dayOfYear = toInt(input);\n    });\n\n    // HELPERS\n\n    // MOMENTS\n\n    function getSetDayOfYear (input) {\n        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;\n        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');\n    }\n\n    // FORMATTING\n\n    addFormatToken('m', ['mm', 2], 0, 'minute');\n\n    // ALIASES\n\n    addUnitAlias('minute', 'm');\n\n    // PRIORITY\n\n    addUnitPriority('minute', 14);\n\n    // PARSING\n\n    addRegexToken('m',  match1to2);\n    addRegexToken('mm', match1to2, match2);\n    addParseToken(['m', 'mm'], MINUTE);\n\n    // MOMENTS\n\n    var getSetMinute = makeGetSet('Minutes', false);\n\n    // FORMATTING\n\n    addFormatToken('s', ['ss', 2], 0, 'second');\n\n    // ALIASES\n\n    addUnitAlias('second', 's');\n\n    // PRIORITY\n\n    addUnitPriority('second', 15);\n\n    // PARSING\n\n    addRegexToken('s',  match1to2);\n    addRegexToken('ss', match1to2, match2);\n    addParseToken(['s', 'ss'], SECOND);\n\n    // MOMENTS\n\n    var getSetSecond = makeGetSet('Seconds', false);\n\n    // FORMATTING\n\n    addFormatToken('S', 0, 0, function () {\n        return ~~(this.millisecond() / 100);\n    });\n\n    addFormatToken(0, ['SS', 2], 0, function () {\n        return ~~(this.millisecond() / 10);\n    });\n\n    addFormatToken(0, ['SSS', 3], 0, 'millisecond');\n    addFormatToken(0, ['SSSS', 4], 0, function () {\n        return this.millisecond() * 10;\n    });\n    addFormatToken(0, ['SSSSS', 5], 0, function () {\n        return this.millisecond() * 100;\n    });\n    addFormatToken(0, ['SSSSSS', 6], 0, function () {\n        return this.millisecond() * 1000;\n    });\n    addFormatToken(0, ['SSSSSSS', 7], 0, function () {\n        return this.millisecond() * 10000;\n    });\n    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {\n        return this.millisecond() * 100000;\n    });\n    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {\n        return this.millisecond() * 1000000;\n    });\n\n\n    // ALIASES\n\n    addUnitAlias('millisecond', 'ms');\n\n    // PRIORITY\n\n    addUnitPriority('millisecond', 16);\n\n    // PARSING\n\n    addRegexToken('S',    match1to3, match1);\n    addRegexToken('SS',   match1to3, match2);\n    addRegexToken('SSS',  match1to3, match3);\n\n    var token;\n    for (token = 'SSSS'; token.length <= 9; token += 'S') {\n        addRegexToken(token, matchUnsigned);\n    }\n\n    function parseMs(input, array) {\n        array[MILLISECOND] = toInt(('0.' + input) * 1000);\n    }\n\n    for (token = 'S'; token.length <= 9; token += 'S') {\n        addParseToken(token, parseMs);\n    }\n    // MOMENTS\n\n    var getSetMillisecond = makeGetSet('Milliseconds', false);\n\n    // FORMATTING\n\n    addFormatToken('z',  0, 0, 'zoneAbbr');\n    addFormatToken('zz', 0, 0, 'zoneName');\n\n    // MOMENTS\n\n    function getZoneAbbr () {\n        return this._isUTC ? 'UTC' : '';\n    }\n\n    function getZoneName () {\n        return this._isUTC ? 'Coordinated Universal Time' : '';\n    }\n\n    var proto = Moment.prototype;\n\n    proto.add               = add;\n    proto.calendar          = calendar$1;\n    proto.clone             = clone;\n    proto.diff              = diff;\n    proto.endOf             = endOf;\n    proto.format            = format;\n    proto.from              = from;\n    proto.fromNow           = fromNow;\n    proto.to                = to;\n    proto.toNow             = toNow;\n    proto.get               = stringGet;\n    proto.invalidAt         = invalidAt;\n    proto.isAfter           = isAfter;\n    proto.isBefore          = isBefore;\n    proto.isBetween         = isBetween;\n    proto.isSame            = isSame;\n    proto.isSameOrAfter     = isSameOrAfter;\n    proto.isSameOrBefore    = isSameOrBefore;\n    proto.isValid           = isValid$2;\n    proto.lang              = lang;\n    proto.locale            = locale;\n    proto.localeData        = localeData;\n    proto.max               = prototypeMax;\n    proto.min               = prototypeMin;\n    proto.parsingFlags      = parsingFlags;\n    proto.set               = stringSet;\n    proto.startOf           = startOf;\n    proto.subtract          = subtract;\n    proto.toArray           = toArray;\n    proto.toObject          = toObject;\n    proto.toDate            = toDate;\n    proto.toISOString       = toISOString;\n    proto.inspect           = inspect;\n    proto.toJSON            = toJSON;\n    proto.toString          = toString;\n    proto.unix              = unix;\n    proto.valueOf           = valueOf;\n    proto.creationData      = creationData;\n    proto.year       = getSetYear;\n    proto.isLeapYear = getIsLeapYear;\n    proto.weekYear    = getSetWeekYear;\n    proto.isoWeekYear = getSetISOWeekYear;\n    proto.quarter = proto.quarters = getSetQuarter;\n    proto.month       = getSetMonth;\n    proto.daysInMonth = getDaysInMonth;\n    proto.week           = proto.weeks        = getSetWeek;\n    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;\n    proto.weeksInYear    = getWeeksInYear;\n    proto.isoWeeksInYear = getISOWeeksInYear;\n    proto.date       = getSetDayOfMonth;\n    proto.day        = proto.days             = getSetDayOfWeek;\n    proto.weekday    = getSetLocaleDayOfWeek;\n    proto.isoWeekday = getSetISODayOfWeek;\n    proto.dayOfYear  = getSetDayOfYear;\n    proto.hour = proto.hours = getSetHour;\n    proto.minute = proto.minutes = getSetMinute;\n    proto.second = proto.seconds = getSetSecond;\n    proto.millisecond = proto.milliseconds = getSetMillisecond;\n    proto.utcOffset            = getSetOffset;\n    proto.utc                  = setOffsetToUTC;\n    proto.local                = setOffsetToLocal;\n    proto.parseZone            = setOffsetToParsedOffset;\n    proto.hasAlignedHourOffset = hasAlignedHourOffset;\n    proto.isDST                = isDaylightSavingTime;\n    proto.isLocal              = isLocal;\n    proto.isUtcOffset          = isUtcOffset;\n    proto.isUtc                = isUtc;\n    proto.isUTC                = isUtc;\n    proto.zoneAbbr = getZoneAbbr;\n    proto.zoneName = getZoneName;\n    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);\n    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);\n    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);\n    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);\n    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);\n\n    function createUnix (input) {\n        return createLocal(input * 1000);\n    }\n\n    function createInZone () {\n        return createLocal.apply(null, arguments).parseZone();\n    }\n\n    function preParsePostFormat (string) {\n        return string;\n    }\n\n    var proto$1 = Locale.prototype;\n\n    proto$1.calendar        = calendar;\n    proto$1.longDateFormat  = longDateFormat;\n    proto$1.invalidDate     = invalidDate;\n    proto$1.ordinal         = ordinal;\n    proto$1.preparse        = preParsePostFormat;\n    proto$1.postformat      = preParsePostFormat;\n    proto$1.relativeTime    = relativeTime;\n    proto$1.pastFuture      = pastFuture;\n    proto$1.set             = set;\n\n    proto$1.months            =        localeMonths;\n    proto$1.monthsShort       =        localeMonthsShort;\n    proto$1.monthsParse       =        localeMonthsParse;\n    proto$1.monthsRegex       = monthsRegex;\n    proto$1.monthsShortRegex  = monthsShortRegex;\n    proto$1.week = localeWeek;\n    proto$1.firstDayOfYear = localeFirstDayOfYear;\n    proto$1.firstDayOfWeek = localeFirstDayOfWeek;\n\n    proto$1.weekdays       =        localeWeekdays;\n    proto$1.weekdaysMin    =        localeWeekdaysMin;\n    proto$1.weekdaysShort  =        localeWeekdaysShort;\n    proto$1.weekdaysParse  =        localeWeekdaysParse;\n\n    proto$1.weekdaysRegex       =        weekdaysRegex;\n    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;\n    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;\n\n    proto$1.isPM = localeIsPM;\n    proto$1.meridiem = localeMeridiem;\n\n    function get$1 (format, index, field, setter) {\n        var locale = getLocale();\n        var utc = createUTC().set(setter, index);\n        return locale[field](utc, format);\n    }\n\n    function listMonthsImpl (format, index, field) {\n        if (isNumber(format)) {\n            index = format;\n            format = undefined;\n        }\n\n        format = format || '';\n\n        if (index != null) {\n            return get$1(format, index, field, 'month');\n        }\n\n        var i;\n        var out = [];\n        for (i = 0; i < 12; i++) {\n            out[i] = get$1(format, i, field, 'month');\n        }\n        return out;\n    }\n\n    // ()\n    // (5)\n    // (fmt, 5)\n    // (fmt)\n    // (true)\n    // (true, 5)\n    // (true, fmt, 5)\n    // (true, fmt)\n    function listWeekdaysImpl (localeSorted, format, index, field) {\n        if (typeof localeSorted === 'boolean') {\n            if (isNumber(format)) {\n                index = format;\n                format = undefined;\n            }\n\n            format = format || '';\n        } else {\n            format = localeSorted;\n            index = format;\n            localeSorted = false;\n\n            if (isNumber(format)) {\n                index = format;\n                format = undefined;\n            }\n\n            format = format || '';\n        }\n\n        var locale = getLocale(),\n            shift = localeSorted ? locale._week.dow : 0;\n\n        if (index != null) {\n            return get$1(format, (index + shift) % 7, field, 'day');\n        }\n\n        var i;\n        var out = [];\n        for (i = 0; i < 7; i++) {\n            out[i] = get$1(format, (i + shift) % 7, field, 'day');\n        }\n        return out;\n    }\n\n    function listMonths (format, index) {\n        return listMonthsImpl(format, index, 'months');\n    }\n\n    function listMonthsShort (format, index) {\n        return listMonthsImpl(format, index, 'monthsShort');\n    }\n\n    function listWeekdays (localeSorted, format, index) {\n        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');\n    }\n\n    function listWeekdaysShort (localeSorted, format, index) {\n        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');\n    }\n\n    function listWeekdaysMin (localeSorted, format, index) {\n        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');\n    }\n\n    getSetGlobalLocale('en', {\n        dayOfMonthOrdinalParse: /\\d{1,2}(th|st|nd|rd)/,\n        ordinal : function (number) {\n            var b = number % 10,\n                output = (toInt(number % 100 / 10) === 1) ? 'th' :\n                (b === 1) ? 'st' :\n                (b === 2) ? 'nd' :\n                (b === 3) ? 'rd' : 'th';\n            return number + output;\n        }\n    });\n\n    // Side effect imports\n\n    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);\n    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);\n\n    var mathAbs = Math.abs;\n\n    function abs () {\n        var data           = this._data;\n\n        this._milliseconds = mathAbs(this._milliseconds);\n        this._days         = mathAbs(this._days);\n        this._months       = mathAbs(this._months);\n\n        data.milliseconds  = mathAbs(data.milliseconds);\n        data.seconds       = mathAbs(data.seconds);\n        data.minutes       = mathAbs(data.minutes);\n        data.hours         = mathAbs(data.hours);\n        data.months        = mathAbs(data.months);\n        data.years         = mathAbs(data.years);\n\n        return this;\n    }\n\n    function addSubtract$1 (duration, input, value, direction) {\n        var other = createDuration(input, value);\n\n        duration._milliseconds += direction * other._milliseconds;\n        duration._days         += direction * other._days;\n        duration._months       += direction * other._months;\n\n        return duration._bubble();\n    }\n\n    // supports only 2.0-style add(1, 's') or add(duration)\n    function add$1 (input, value) {\n        return addSubtract$1(this, input, value, 1);\n    }\n\n    // supports only 2.0-style subtract(1, 's') or subtract(duration)\n    function subtract$1 (input, value) {\n        return addSubtract$1(this, input, value, -1);\n    }\n\n    function absCeil (number) {\n        if (number < 0) {\n            return Math.floor(number);\n        } else {\n            return Math.ceil(number);\n        }\n    }\n\n    function bubble () {\n        var milliseconds = this._milliseconds;\n        var days         = this._days;\n        var months       = this._months;\n        var data         = this._data;\n        var seconds, minutes, hours, years, monthsFromDays;\n\n        // if we have a mix of positive and negative values, bubble down first\n        // check: https://github.com/moment/moment/issues/2166\n        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||\n                (milliseconds <= 0 && days <= 0 && months <= 0))) {\n            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;\n            days = 0;\n            months = 0;\n        }\n\n        // The following code bubbles up values, see the tests for\n        // examples of what that means.\n        data.milliseconds = milliseconds % 1000;\n\n        seconds           = absFloor(milliseconds / 1000);\n        data.seconds      = seconds % 60;\n\n        minutes           = absFloor(seconds / 60);\n        data.minutes      = minutes % 60;\n\n        hours             = absFloor(minutes / 60);\n        data.hours        = hours % 24;\n\n        days += absFloor(hours / 24);\n\n        // convert days to months\n        monthsFromDays = absFloor(daysToMonths(days));\n        months += monthsFromDays;\n        days -= absCeil(monthsToDays(monthsFromDays));\n\n        // 12 months -> 1 year\n        years = absFloor(months / 12);\n        months %= 12;\n\n        data.days   = days;\n        data.months = months;\n        data.years  = years;\n\n        return this;\n    }\n\n    function daysToMonths (days) {\n        // 400 years have 146097 days (taking into account leap year rules)\n        // 400 years have 12 months === 4800\n        return days * 4800 / 146097;\n    }\n\n    function monthsToDays (months) {\n        // the reverse of daysToMonths\n        return months * 146097 / 4800;\n    }\n\n    function as (units) {\n        if (!this.isValid()) {\n            return NaN;\n        }\n        var days;\n        var months;\n        var milliseconds = this._milliseconds;\n\n        units = normalizeUnits(units);\n\n        if (units === 'month' || units === 'year') {\n            days   = this._days   + milliseconds / 864e5;\n            months = this._months + daysToMonths(days);\n            return units === 'month' ? months : months / 12;\n        } else {\n            // handle milliseconds separately because of floating point math errors (issue #1867)\n            days = this._days + Math.round(monthsToDays(this._months));\n            switch (units) {\n                case 'week'   : return days / 7     + milliseconds / 6048e5;\n                case 'day'    : return days         + milliseconds / 864e5;\n                case 'hour'   : return days * 24    + milliseconds / 36e5;\n                case 'minute' : return days * 1440  + milliseconds / 6e4;\n                case 'second' : return days * 86400 + milliseconds / 1000;\n                // Math.floor prevents floating point math errors here\n                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;\n                default: throw new Error('Unknown unit ' + units);\n            }\n        }\n    }\n\n    // TODO: Use this.as('ms')?\n    function valueOf$1 () {\n        if (!this.isValid()) {\n            return NaN;\n        }\n        return (\n            this._milliseconds +\n            this._days * 864e5 +\n            (this._months % 12) * 2592e6 +\n            toInt(this._months / 12) * 31536e6\n        );\n    }\n\n    function makeAs (alias) {\n        return function () {\n            return this.as(alias);\n        };\n    }\n\n    var asMilliseconds = makeAs('ms');\n    var asSeconds      = makeAs('s');\n    var asMinutes      = makeAs('m');\n    var asHours        = makeAs('h');\n    var asDays         = makeAs('d');\n    var asWeeks        = makeAs('w');\n    var asMonths       = makeAs('M');\n    var asYears        = makeAs('y');\n\n    function clone$1 () {\n        return createDuration(this);\n    }\n\n    function get$2 (units) {\n        units = normalizeUnits(units);\n        return this.isValid() ? this[units + 's']() : NaN;\n    }\n\n    function makeGetter(name) {\n        return function () {\n            return this.isValid() ? this._data[name] : NaN;\n        };\n    }\n\n    var milliseconds = makeGetter('milliseconds');\n    var seconds      = makeGetter('seconds');\n    var minutes      = makeGetter('minutes');\n    var hours        = makeGetter('hours');\n    var days         = makeGetter('days');\n    var months       = makeGetter('months');\n    var years        = makeGetter('years');\n\n    function weeks () {\n        return absFloor(this.days() / 7);\n    }\n\n    var round = Math.round;\n    var thresholds = {\n        ss: 44,         // a few seconds to seconds\n        s : 45,         // seconds to minute\n        m : 45,         // minutes to hour\n        h : 22,         // hours to day\n        d : 26,         // days to month\n        M : 11          // months to year\n    };\n\n    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize\n    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {\n        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);\n    }\n\n    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {\n        var duration = createDuration(posNegDuration).abs();\n        var seconds  = round(duration.as('s'));\n        var minutes  = round(duration.as('m'));\n        var hours    = round(duration.as('h'));\n        var days     = round(duration.as('d'));\n        var months   = round(duration.as('M'));\n        var years    = round(duration.as('y'));\n\n        var a = seconds <= thresholds.ss && ['s', seconds]  ||\n                seconds < thresholds.s   && ['ss', seconds] ||\n                minutes <= 1             && ['m']           ||\n                minutes < thresholds.m   && ['mm', minutes] ||\n                hours   <= 1             && ['h']           ||\n                hours   < thresholds.h   && ['hh', hours]   ||\n                days    <= 1             && ['d']           ||\n                days    < thresholds.d   && ['dd', days]    ||\n                months  <= 1             && ['M']           ||\n                months  < thresholds.M   && ['MM', months]  ||\n                years   <= 1             && ['y']           || ['yy', years];\n\n        a[2] = withoutSuffix;\n        a[3] = +posNegDuration > 0;\n        a[4] = locale;\n        return substituteTimeAgo.apply(null, a);\n    }\n\n    // This function allows you to set the rounding function for relative time strings\n    function getSetRelativeTimeRounding (roundingFunction) {\n        if (roundingFunction === undefined) {\n            return round;\n        }\n        if (typeof(roundingFunction) === 'function') {\n            round = roundingFunction;\n            return true;\n        }\n        return false;\n    }\n\n    // This function allows you to set a threshold for relative time strings\n    function getSetRelativeTimeThreshold (threshold, limit) {\n        if (thresholds[threshold] === undefined) {\n            return false;\n        }\n        if (limit === undefined) {\n            return thresholds[threshold];\n        }\n        thresholds[threshold] = limit;\n        if (threshold === 's') {\n            thresholds.ss = limit - 1;\n        }\n        return true;\n    }\n\n    function humanize (withSuffix) {\n        if (!this.isValid()) {\n            return this.localeData().invalidDate();\n        }\n\n        var locale = this.localeData();\n        var output = relativeTime$1(this, !withSuffix, locale);\n\n        if (withSuffix) {\n            output = locale.pastFuture(+this, output);\n        }\n\n        return locale.postformat(output);\n    }\n\n    var abs$1 = Math.abs;\n\n    function sign(x) {\n        return ((x > 0) - (x < 0)) || +x;\n    }\n\n    function toISOString$1() {\n        // for ISO strings we do not use the normal bubbling rules:\n        //  * milliseconds bubble up until they become hours\n        //  * days do not bubble at all\n        //  * months bubble up until they become years\n        // This is because there is no context-free conversion between hours and days\n        // (think of clock changes)\n        // and also not between days and months (28-31 days per month)\n        if (!this.isValid()) {\n            return this.localeData().invalidDate();\n        }\n\n        var seconds = abs$1(this._milliseconds) / 1000;\n        var days         = abs$1(this._days);\n        var months       = abs$1(this._months);\n        var minutes, hours, years;\n\n        // 3600 seconds -> 60 minutes -> 1 hour\n        minutes           = absFloor(seconds / 60);\n        hours             = absFloor(minutes / 60);\n        seconds %= 60;\n        minutes %= 60;\n\n        // 12 months -> 1 year\n        years  = absFloor(months / 12);\n        months %= 12;\n\n\n        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js\n        var Y = years;\n        var M = months;\n        var D = days;\n        var h = hours;\n        var m = minutes;\n        var s = seconds ? seconds.toFixed(3).replace(/\\.?0+$/, '') : '';\n        var total = this.asSeconds();\n\n        if (!total) {\n            // this is the same as C#'s (Noda) and python (isodate)...\n            // but not other JS (goog.date)\n            return 'P0D';\n        }\n\n        var totalSign = total < 0 ? '-' : '';\n        var ymSign = sign(this._months) !== sign(total) ? '-' : '';\n        var daysSign = sign(this._days) !== sign(total) ? '-' : '';\n        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';\n\n        return totalSign + 'P' +\n            (Y ? ymSign + Y + 'Y' : '') +\n            (M ? ymSign + M + 'M' : '') +\n            (D ? daysSign + D + 'D' : '') +\n            ((h || m || s) ? 'T' : '') +\n            (h ? hmsSign + h + 'H' : '') +\n            (m ? hmsSign + m + 'M' : '') +\n            (s ? hmsSign + s + 'S' : '');\n    }\n\n    var proto$2 = Duration.prototype;\n\n    proto$2.isValid        = isValid$1;\n    proto$2.abs            = abs;\n    proto$2.add            = add$1;\n    proto$2.subtract       = subtract$1;\n    proto$2.as             = as;\n    proto$2.asMilliseconds = asMilliseconds;\n    proto$2.asSeconds      = asSeconds;\n    proto$2.asMinutes      = asMinutes;\n    proto$2.asHours        = asHours;\n    proto$2.asDays         = asDays;\n    proto$2.asWeeks        = asWeeks;\n    proto$2.asMonths       = asMonths;\n    proto$2.asYears        = asYears;\n    proto$2.valueOf        = valueOf$1;\n    proto$2._bubble        = bubble;\n    proto$2.clone          = clone$1;\n    proto$2.get            = get$2;\n    proto$2.milliseconds   = milliseconds;\n    proto$2.seconds        = seconds;\n    proto$2.minutes        = minutes;\n    proto$2.hours          = hours;\n    proto$2.days           = days;\n    proto$2.weeks          = weeks;\n    proto$2.months         = months;\n    proto$2.years          = years;\n    proto$2.humanize       = humanize;\n    proto$2.toISOString    = toISOString$1;\n    proto$2.toString       = toISOString$1;\n    proto$2.toJSON         = toISOString$1;\n    proto$2.locale         = locale;\n    proto$2.localeData     = localeData;\n\n    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);\n    proto$2.lang = lang;\n\n    // Side effect imports\n\n    // FORMATTING\n\n    addFormatToken('X', 0, 0, 'unix');\n    addFormatToken('x', 0, 0, 'valueOf');\n\n    // PARSING\n\n    addRegexToken('x', matchSigned);\n    addRegexToken('X', matchTimestamp);\n    addParseToken('X', function (input, array, config) {\n        config._d = new Date(parseFloat(input, 10) * 1000);\n    });\n    addParseToken('x', function (input, array, config) {\n        config._d = new Date(toInt(input));\n    });\n\n    // Side effect imports\n\n\n    hooks.version = '2.22.2';\n\n    setHookCallback(createLocal);\n\n    hooks.fn                    = proto;\n    hooks.min                   = min;\n    hooks.max                   = max;\n    hooks.now                   = now;\n    hooks.utc                   = createUTC;\n    hooks.unix                  = createUnix;\n    hooks.months                = listMonths;\n    hooks.isDate                = isDate;\n    hooks.locale                = getSetGlobalLocale;\n    hooks.invalid               = createInvalid;\n    hooks.duration              = createDuration;\n    hooks.isMoment              = isMoment;\n    hooks.weekdays              = listWeekdays;\n    hooks.parseZone             = createInZone;\n    hooks.localeData            = getLocale;\n    hooks.isDuration            = isDuration;\n    hooks.monthsShort           = listMonthsShort;\n    hooks.weekdaysMin           = listWeekdaysMin;\n    hooks.defineLocale          = defineLocale;\n    hooks.updateLocale          = updateLocale;\n    hooks.locales               = listLocales;\n    hooks.weekdaysShort         = listWeekdaysShort;\n    hooks.normalizeUnits        = normalizeUnits;\n    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;\n    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;\n    hooks.calendarFormat        = getCalendarFormat;\n    hooks.prototype             = proto;\n\n    // currently HTML5 input type only supports 24-hour formats\n    hooks.HTML5_FMT = {\n        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type=\"datetime-local\" />\n        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type=\"datetime-local\" step=\"1\" />\n        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type=\"datetime-local\" step=\"0.001\" />\n        DATE: 'YYYY-MM-DD',                             // <input type=\"date\" />\n        TIME: 'HH:mm',                                  // <input type=\"time\" />\n        TIME_SECONDS: 'HH:mm:ss',                       // <input type=\"time\" step=\"1\" />\n        TIME_MS: 'HH:mm:ss.SSS',                        // <input type=\"time\" step=\"0.001\" />\n        WEEK: 'YYYY-[W]WW',                             // <input type=\"week\" />\n        MONTH: 'YYYY-MM'                                // <input type=\"month\" />\n    };\n\n    return hooks;\n\n})));\n"

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1520))

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	module.exports = "//! moment.js locale configuration\n\n;(function (global, factory) {\n   typeof exports === 'object' && typeof module !== 'undefined'\n       && typeof require === 'function' ? factory(require('../moment')) :\n   typeof define === 'function' && define.amd ? define(['../moment'], factory) :\n   factory(global.moment)\n}(this, (function (moment) { 'use strict';\n\n\n    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),\n        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');\n\n    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];\n    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\\.?|feb\\.?|mar\\.?|abr\\.?|may\\.?|jun\\.?|jul\\.?|ago\\.?|sep\\.?|oct\\.?|nov\\.?|dic\\.?)/i;\n\n    var es = moment.defineLocale('es', {\n        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),\n        monthsShort : function (m, format) {\n            if (!m) {\n                return monthsShortDot;\n            } else if (/-MMM-/.test(format)) {\n                return monthsShort[m.month()];\n            } else {\n                return monthsShortDot[m.month()];\n            }\n        },\n        monthsRegex : monthsRegex,\n        monthsShortRegex : monthsRegex,\n        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,\n        monthsShortStrictRegex : /^(ene\\.?|feb\\.?|mar\\.?|abr\\.?|may\\.?|jun\\.?|jul\\.?|ago\\.?|sep\\.?|oct\\.?|nov\\.?|dic\\.?)/i,\n        monthsParse : monthsParse,\n        longMonthsParse : monthsParse,\n        shortMonthsParse : monthsParse,\n        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),\n        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),\n        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),\n        weekdaysParseExact : true,\n        longDateFormat : {\n            LT : 'H:mm',\n            LTS : 'H:mm:ss',\n            L : 'DD/MM/YYYY',\n            LL : 'D [de] MMMM [de] YYYY',\n            LLL : 'D [de] MMMM [de] YYYY H:mm',\n            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'\n        },\n        calendar : {\n            sameDay : function () {\n                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';\n            },\n            nextDay : function () {\n                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';\n            },\n            nextWeek : function () {\n                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';\n            },\n            lastDay : function () {\n                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';\n            },\n            lastWeek : function () {\n                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';\n            },\n            sameElse : 'L'\n        },\n        relativeTime : {\n            future : 'en %s',\n            past : 'hace %s',\n            s : 'unos segundos',\n            ss : '%d segundos',\n            m : 'un minuto',\n            mm : '%d minutos',\n            h : 'una hora',\n            hh : '%d horas',\n            d : 'un día',\n            dd : '%d días',\n            M : 'un mes',\n            MM : '%d meses',\n            y : 'un año',\n            yy : '%d años'\n        },\n        dayOfMonthOrdinalParse : /\\d{1,2}º/,\n        ordinal : '%dº',\n        week : {\n            dow : 1, // Monday is the first day of the week.\n            doy : 4  // The week that contains Jan 4th is the first week of the year.\n        }\n    });\n\n    return es;\n\n})));\n"

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1522))

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	module.exports = "/**\n * angular-bootstrap-calendar - A pure AngularJS bootstrap themed responsive calendar that can display events and has views for year, month, week and day\n * @version v0.26.1\n * @link https://github.com/mattlewis92/angular-bootstrap-calendar\n * @license MIT\n */\n(function webpackUniversalModuleDefinition(root, factory) {\n\tif(typeof exports === 'object' && typeof module === 'object')\n\t\tmodule.exports = factory(require(\"angular\"), (function webpackLoadOptionalExternalModule() { try { return require(\"interact.js\"); } catch(e) {} }()), require(\"moment\"));\n\telse if(typeof define === 'function' && define.amd)\n\t\tdefine([\"angular\", \"interact\", \"moment\"], factory);\n\telse if(typeof exports === 'object')\n\t\texports[\"angularBootstrapCalendarModuleName\"] = factory(require(\"angular\"), (function webpackLoadOptionalExternalModule() { try { return require(\"interact.js\"); } catch(e) {} }()), require(\"moment\"));\n\telse\n\t\troot[\"angularBootstrapCalendarModuleName\"] = factory(root[\"angular\"], root[\"interact\"], root[\"moment\"]);\n})(this, function(__WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_76__, __WEBPACK_EXTERNAL_MODULE_78__) {\nreturn /******/ (function(modules) { // webpackBootstrap\n/******/ \t// The module cache\n/******/ \tvar installedModules = {};\n\n/******/ \t// The require function\n/******/ \tfunction __webpack_require__(moduleId) {\n\n/******/ \t\t// Check if module is in cache\n/******/ \t\tif(installedModules[moduleId])\n/******/ \t\t\treturn installedModules[moduleId].exports;\n\n/******/ \t\t// Create a new module (and put it into the cache)\n/******/ \t\tvar module = installedModules[moduleId] = {\n/******/ \t\t\texports: {},\n/******/ \t\t\tid: moduleId,\n/******/ \t\t\tloaded: false\n/******/ \t\t};\n\n/******/ \t\t// Execute the module function\n/******/ \t\tmodules[moduleId].call(module.exports, module, module.exports, __webpack_require__);\n\n/******/ \t\t// Flag the module as loaded\n/******/ \t\tmodule.loaded = true;\n\n/******/ \t\t// Return the exports of the module\n/******/ \t\treturn module.exports;\n/******/ \t}\n\n\n/******/ \t// expose the modules object (__webpack_modules__)\n/******/ \t__webpack_require__.m = modules;\n\n/******/ \t// expose the module cache\n/******/ \t__webpack_require__.c = installedModules;\n\n/******/ \t// __webpack_public_path__\n/******/ \t__webpack_require__.p = \"\";\n\n/******/ \t// Load entry module and return exports\n/******/ \treturn __webpack_require__(0);\n/******/ })\n/************************************************************************/\n/******/ ([\n/* 0 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\t__webpack_require__(8);\n\n\tvar angular = __webpack_require__(12);\n\n\tfunction requireAll(r) {\n\t  r.keys().forEach(r);\n\t}\n\n\tvar templates = {};\n\n\tif (true) {\n\n\t  var templatesContext = __webpack_require__(13);\n\n\t  templatesContext.keys().forEach(function(templateName) {\n\t    var templateNameWithoutPrefix = templateName.replace('./', '');\n\t    var cacheTemplateName = 'mwl/' + templateNameWithoutPrefix;\n\t    var configTemplateName = templateNameWithoutPrefix.replace('.html', '');\n\t    templates[configTemplateName] = {\n\t      cacheTemplateName: cacheTemplateName,\n\t      template: templatesContext(templateName)\n\t    };\n\t  });\n\n\t}\n\n\tmodule.exports = angular\n\t  .module('mwl.calendar', [])\n\t  .config([\"calendarConfig\", function(calendarConfig) {\n\t    angular.forEach(templates, function(template, templateName) {\n\t      if (!calendarConfig.templates[templateName]) {\n\t        calendarConfig.templates[templateName] = template.cacheTemplateName;\n\t      }\n\t    });\n\t  }])\n\t  .run([\"$templateCache\", \"$interpolate\", function($templateCache, $interpolate) {\n\n\t    angular.forEach(templates, function(template) {\n\t      if (!$templateCache.get(template.cacheTemplateName)) {\n\t        var templateContents = template.template\n\t          .replace('{{', $interpolate.startSymbol())\n\t          .replace('}}', $interpolate.endSymbol());\n\t        $templateCache.put(template.cacheTemplateName, templateContents);\n\t      }\n\t    });\n\n\t  }]).name;\n\n\trequireAll(__webpack_require__(23));\n\trequireAll(__webpack_require__(65));\n\trequireAll(__webpack_require__(70));\n\n\n/***/ },\n/* 1 */,\n/* 2 */,\n/* 3 */,\n/* 4 */,\n/* 5 */,\n/* 6 */,\n/* 7 */,\n/* 8 */\n/***/ function(module, exports) {\n\n\t// removed by extract-text-webpack-plugin\n\n/***/ },\n/* 9 */,\n/* 10 */,\n/* 11 */,\n/* 12 */\n/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_12__;\n\n/***/ },\n/* 13 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar map = {\n\t\t\"./calendar.html\": 14,\n\t\t\"./calendarDayView.html\": 15,\n\t\t\"./calendarHourList.html\": 16,\n\t\t\"./calendarMonthCell.html\": 17,\n\t\t\"./calendarMonthCellEvents.html\": 18,\n\t\t\"./calendarMonthView.html\": 19,\n\t\t\"./calendarSlideBox.html\": 20,\n\t\t\"./calendarWeekView.html\": 21,\n\t\t\"./calendarYearView.html\": 22\n\t};\n\tfunction webpackContext(req) {\n\t\treturn __webpack_require__(webpackContextResolve(req));\n\t};\n\tfunction webpackContextResolve(req) {\n\t\treturn map[req] || (function() { throw new Error(\"Cannot find module '\" + req + \"'.\") }());\n\t};\n\twebpackContext.keys = function webpackContextKeys() {\n\t\treturn Object.keys(map);\n\t};\n\twebpackContext.resolve = webpackContextResolve;\n\tmodule.exports = webpackContext;\n\twebpackContext.id = 13;\n\n\n/***/ },\n/* 14 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div\\n  class=\\\"cal-context\\\"\\n  ng-switch=\\\"vm.view\\\"\\n  ng-if=\\\"vm.templatesLoaded\\\">\\n\\n  <div class=\\\"alert alert-danger\\\" ng-switch-default>The value passed to the view attribute of the calendar is not set</div>\\n\\n  <div class=\\\"alert alert-danger\\\" ng-hide=\\\"vm.viewDate\\\">The value passed to view-date attribute of the calendar is not set</div>\\n\\n  <mwl-calendar-year\\n    events=\\\"vm.events\\\"\\n    view-date=\\\"vm.viewDate\\\"\\n    on-event-click=\\\"vm.onEventClick\\\"\\n    on-event-times-changed=\\\"vm.onEventTimesChanged\\\"\\n    on-timespan-click=\\\"vm.onTimespanClick\\\"\\n    cell-is-open=\\\"vm.cellIsOpen\\\"\\n    cell-modifier=\\\"vm.cellModifier\\\"\\n    slide-box-disabled=\\\"vm.slideBoxDisabled\\\"\\n    custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n    template-scope=\\\"vm.templateScope\\\"\\n    cell-auto-open-disabled=\\\"vm.cellAutoOpenDisabled\\\"\\n    ng-switch-when=\\\"year\\\">\\n  </mwl-calendar-year>\\n\\n  <mwl-calendar-month\\n    events=\\\"vm.events\\\"\\n    view-date=\\\"vm.viewDate\\\"\\n    on-event-click=\\\"vm.onEventClick\\\"\\n    on-event-times-changed=\\\"vm.onEventTimesChanged\\\"\\n    on-timespan-click=\\\"vm.onTimespanClick\\\"\\n    on-date-range-select=\\\"vm.onDateRangeSelect\\\"\\n    cell-is-open=\\\"vm.cellIsOpen\\\"\\n    cell-modifier=\\\"vm.cellModifier\\\"\\n    slide-box-disabled=\\\"vm.slideBoxDisabled\\\"\\n    custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n    template-scope=\\\"vm.templateScope\\\"\\n    cell-auto-open-disabled=\\\"vm.cellAutoOpenDisabled\\\"\\n    ng-switch-when=\\\"month\\\">\\n  </mwl-calendar-month>\\n\\n  <mwl-calendar-week\\n    events=\\\"vm.events\\\"\\n    view-date=\\\"vm.viewDate\\\"\\n    on-event-click=\\\"vm.onEventClick\\\"\\n    on-event-times-changed=\\\"vm.onEventTimesChanged\\\"\\n    day-view-start=\\\"vm.dayViewStart\\\"\\n    day-view-end=\\\"vm.dayViewEnd\\\"\\n    day-view-split=\\\"vm.dayViewSplit\\\"\\n    day-view-event-chunk-size=\\\"vm.dayViewEventChunkSize\\\"\\n    on-timespan-click=\\\"vm.onTimespanClick\\\"\\n    on-date-range-select=\\\"vm.onDateRangeSelect\\\"\\n    custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n    cell-modifier=\\\"vm.cellModifier\\\"\\n    template-scope=\\\"vm.templateScope\\\"\\n    ng-switch-when=\\\"week\\\">\\n  </mwl-calendar-week>\\n\\n  <mwl-calendar-day\\n    events=\\\"vm.events\\\"\\n    view-date=\\\"vm.viewDate\\\"\\n    on-event-click=\\\"vm.onEventClick\\\"\\n    on-event-times-changed=\\\"vm.onEventTimesChanged\\\"\\n    on-timespan-click=\\\"vm.onTimespanClick\\\"\\n    on-date-range-select=\\\"vm.onDateRangeSelect\\\"\\n    day-view-start=\\\"vm.dayViewStart\\\"\\n    day-view-end=\\\"vm.dayViewEnd\\\"\\n    day-view-split=\\\"vm.dayViewSplit\\\"\\n    day-view-event-chunk-size=\\\"vm.dayViewEventChunkSize\\\"\\n    custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n    cell-modifier=\\\"vm.cellModifier\\\"\\n    template-scope=\\\"vm.templateScope\\\"\\n    ng-switch-when=\\\"day\\\">\\n  </mwl-calendar-day>\\n</div>\\n\";\n\n/***/ },\n/* 15 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div class=\\\"cal-week-box cal-all-day-events-box\\\" ng-if=\\\"vm.allDayEvents.length > 0\\\">\\n  <div class=\\\"cal-day-panel clearfix\\\">\\n    <div class=\\\"row\\\">\\n      <div class=\\\"col-xs-12\\\">\\n        <div class=\\\"cal-row-fluid\\\">\\n          <div\\n            class=\\\"cal-cell-6 day-highlight\\\"\\n            ng-style=\\\"{backgroundColor: event.color.secondary}\\\"\\n            data-event-class\\n            ng-repeat=\\\"event in vm.allDayEvents track by event.calendarEventId\\\">\\n            <strong>\\n              <span ng-bind=\\\"event.startsAt | calendarDate:'datetime':true\\\"></span>\\n              <span ng-if=\\\"event.endsAt\\\">\\n                - <span ng-bind=\\\"event.endsAt | calendarDate:'datetime':true\\\"></span>\\n              </span>\\n            </strong>\\n            <a\\n              href=\\\"javascript:;\\\"\\n              class=\\\"event-item\\\"\\n              ng-bind-html=\\\"vm.calendarEventTitle.dayView(event) | calendarTrustAsHtml\\\">\\n            </a>\\n          </div>\\n        </div>\\n      </div>\\n    </div>\\n  </div>\\n</div>\\n\\n<div class=\\\"cal-day-box\\\">\\n  <div class=\\\"cal-day-panel clearfix\\\" ng-style=\\\"{height: vm.dayViewHeight + 'px', minWidth: vm.viewWidth + 'px'}\\\">\\n\\n    <mwl-calendar-hour-list\\n      day-view-start=\\\"vm.dayViewStart\\\"\\n      day-view-end=\\\"vm.dayViewEnd\\\"\\n      day-view-split=\\\"vm.dayViewSplit\\\"\\n      on-timespan-click=\\\"vm.onTimespanClick\\\"\\n      on-date-range-select=\\\"vm.onDateRangeSelect\\\"\\n      on-event-times-changed=\\\"vm.onEventTimesChanged\\\"\\n      view-date=\\\"vm.viewDate\\\"\\n      custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n      template-scope=\\\"vm.templateScope\\\"\\n      cell-modifier=\\\"vm.cellModifier\\\">\\n    </mwl-calendar-hour-list>\\n\\n    <div\\n      class=\\\"pull-left day-event day-highlight\\\"\\n      ng-repeat=\\\"dayEvent in vm.nonAllDayEvents track by dayEvent.event.calendarEventId\\\"\\n      ng-class=\\\"dayEvent.event.cssClass\\\"\\n      ng-style=\\\"{\\n        top: dayEvent.top - 1 + 'px',\\n        left: dayEvent.left + 60 + 'px',\\n        height: dayEvent.height + 'px',\\n        backgroundColor: dayEvent.event.color.secondary,\\n        borderColor: dayEvent.event.color.primary\\n      }\\\"\\n      mwl-draggable=\\\"dayEvent.event.draggable === true\\\"\\n      axis=\\\"'xy'\\\"\\n      snap-grid=\\\"{y: vm.dayViewEventChunkSize || 30, x: 50}\\\"\\n      on-drag=\\\"vm.eventDragged(dayEvent.event, y / 30)\\\"\\n      on-drag-end=\\\"vm.eventDragComplete(dayEvent.event, y / 30)\\\"\\n      mwl-resizable=\\\"dayEvent.event.resizable === true && dayEvent.event.endsAt\\\"\\n      resize-edges=\\\"{top: true, bottom: true}\\\"\\n      on-resize=\\\"vm.eventResized(dayEvent.event, edge, y / 30)\\\"\\n      on-resize-end=\\\"vm.eventResizeComplete(dayEvent.event, edge, y / 30)\\\"\\n      uib-tooltip-html=\\\"vm.calendarEventTitle.dayViewTooltip(dayEvent.event) | calendarTrustAsHtml\\\"\\n      tooltip-append-to-body=\\\"true\\\">\\n\\n      <span class=\\\"cal-hours\\\">\\n        <span ng-show=\\\"dayEvent.top == 0\\\"><span ng-bind=\\\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'day':true\\\"></span>, </span>\\n        <span ng-bind=\\\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'time':true\\\"></span>\\n      </span>\\n      <a\\n        href=\\\"javascript:;\\\"\\n        class=\\\"event-item\\\"\\n        ng-click=\\\"vm.onEventClick({calendarEvent: dayEvent.event})\\\">\\n        <span ng-bind-html=\\\"vm.calendarEventTitle.dayView(dayEvent.event) | calendarTrustAsHtml\\\"></span>\\n      </a>\\n\\n      <a\\n        href=\\\"javascript:;\\\"\\n        class=\\\"event-item-action\\\"\\n        ng-repeat=\\\"action in dayEvent.event.actions track by $index\\\"\\n        ng-class=\\\"action.cssClass\\\"\\n        ng-bind-html=\\\"action.label | calendarTrustAsHtml\\\"\\n        ng-click=\\\"action.onClick({calendarEvent: dayEvent.event})\\\">\\n      </a>\\n\\n    </div>\\n\\n  </div>\\n\\n</div>\\n\";\n\n/***/ },\n/* 16 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div class=\\\"cal-day-panel-hour\\\">\\n\\n  <div class=\\\"cal-day-hour\\\" ng-repeat=\\\"hour in vm.hourGrid track by $index\\\">\\n\\n    <div\\n      class=\\\"cal-day-hour-part\\\"\\n      ng-repeat=\\\"segment in hour.segments track by $index\\\"\\n      ng-class=\\\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\\n                vm.dateRangeSelect.startDate <= segment.date &&\\n                segment.date < vm.dateRangeSelect.endDate }, segment.cssClass]\\\"\\n      ng-click=\\\"vm.onTimespanClick({calendarDate: segment.date})\\\"\\n      mwl-droppable\\n      on-drop=\\\"vm.eventDropped(dropData.event, segment.date)\\\"\\n      mwl-drag-select=\\\"!!vm.onDateRangeSelect\\\"\\n      on-drag-select-start=\\\"vm.onDragSelectStart(segment.date)\\\"\\n      on-drag-select-move=\\\"vm.onDragSelectMove(segment.nextSegmentDate)\\\"\\n      on-drag-select-end=\\\"vm.onDragSelectEnd(segment.nextSegmentDate)\\\"\\n      ng-if=\\\"!vm.dayWidth\\\">\\n      <div class=\\\"cal-day-hour-part-time\\\">\\n        <strong ng-bind=\\\"segment.date | calendarDate:'hour':true\\\" ng-show=\\\"segment.isStart\\\"></strong>\\n      </div>\\n    </div>\\n\\n    <div\\n      class=\\\"cal-day-hour-part\\\"\\n      ng-repeat=\\\"segment in hour.segments track by $index\\\"\\n      ng-if=\\\"vm.dayWidth\\\">\\n      <div class=\\\"cal-day-hour-part-time\\\">\\n        <strong ng-bind=\\\"segment.date | calendarDate:'hour':true\\\" ng-show=\\\"segment.isStart\\\"></strong>\\n        &nbsp;\\n      </div>\\n      <div\\n        class=\\\"cal-day-hour-part-spacer\\\"\\n        ng-repeat=\\\"day in segment.days track by $index\\\"\\n        ng-style=\\\"{width: vm.dayWidth + 'px'}\\\"\\n        ng-class=\\\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\\n                vm.dateRangeSelect.startDate <= day.date &&\\n                day.date < vm.dateRangeSelect.endDate }, day.cssClass]\\\"\\n        ng-click=\\\"vm.onTimespanClick({calendarDate: day.date})\\\"\\n        mwl-droppable\\n        on-drop=\\\"vm.eventDropped(dropData.event, day.date)\\\"\\n        mwl-drag-select=\\\"!!vm.onDateRangeSelect\\\"\\n        on-drag-select-start=\\\"vm.onDragSelectStart(day.date)\\\"\\n        on-drag-select-move=\\\"vm.onDragSelectMove(day.nextSegmentDate)\\\"\\n        on-drag-select-end=\\\"vm.onDragSelectEnd(day.nextSegmentDate)\\\">\\n      </div>\\n    </div>\\n\\n  </div>\\n\\n</div>\\n\";\n\n/***/ },\n/* 17 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div\\n  mwl-droppable\\n  on-drop=\\\"vm.handleEventDrop(dropData.event, day.date, dropData.draggedFromDate)\\\"\\n  mwl-drag-select=\\\"!!vm.onDateRangeSelect\\\"\\n  on-drag-select-start=\\\"vm.onDragSelectStart(day)\\\"\\n  on-drag-select-move=\\\"vm.onDragSelectMove(day)\\\"\\n  on-drag-select-end=\\\"vm.onDragSelectEnd(day)\\\"\\n  class=\\\"cal-month-day {{ day.cssClass }}\\\"\\n  ng-class=\\\"{\\n    'cal-day-outmonth': !day.inMonth,\\n    'cal-day-inmonth': day.inMonth,\\n    'cal-day-weekend': day.isWeekend,\\n    'cal-day-past': day.isPast,\\n    'cal-day-today': day.isToday,\\n    'cal-day-future': day.isFuture,\\n    'cal-day-selected': vm.dateRangeSelect && vm.dateRangeSelect.startDate <= day.date && day.date <= vm.dateRangeSelect.endDate,\\n    'cal-day-open': dayIndex === vm.openDayIndex\\n  }\\\">\\n\\n  <small\\n    class=\\\"cal-events-num badge badge-important pull-left\\\"\\n    ng-show=\\\"day.badgeTotal > 0\\\"\\n    ng-bind=\\\"day.badgeTotal\\\">\\n  </small>\\n\\n  <span\\n    class=\\\"pull-right\\\"\\n    data-cal-date\\n    ng-click=\\\"vm.calendarCtrl.dateClicked(day.date)\\\"\\n    ng-bind=\\\"day.label\\\">\\n  </span>\\n\\n  <div class=\\\"cal-day-tick\\\" ng-show=\\\"dayIndex === vm.openDayIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\\\">\\n    <i class=\\\"glyphicon glyphicon-chevron-up\\\"></i>\\n    <i class=\\\"fa fa-chevron-up\\\"></i>\\n  </div>\\n\\n  <ng-include src=\\\"vm.customTemplateUrls.calendarMonthCellEvents || vm.calendarConfig.templates.calendarMonthCellEvents\\\"></ng-include>\\n\\n  <div id=\\\"cal-week-box\\\" ng-if=\\\"$first && rowHovered\\\">\\n    <span ng-bind=\\\"vm.getWeekNumberLabel(day)\\\"></span>\\n  </div>\\n\\n</div>\\n\";\n\n/***/ },\n/* 18 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div class=\\\"events-list\\\" ng-show=\\\"day.events.length > 0\\\">\\n  <a\\n    ng-repeat=\\\"event in day.events | orderBy:'startsAt' track by event.calendarEventId\\\"\\n    href=\\\"javascript:;\\\"\\n    ng-click=\\\"$event.stopPropagation(); vm.onEventClick({calendarEvent: event})\\\"\\n    class=\\\"pull-left event\\\"\\n    ng-class=\\\"event.cssClass\\\"\\n    ng-style=\\\"{backgroundColor: event.color.primary}\\\"\\n    ng-mouseenter=\\\"vm.highlightEvent(event, true)\\\"\\n    ng-mouseleave=\\\"vm.highlightEvent(event, false)\\\"\\n    tooltip-append-to-body=\\\"true\\\"\\n    uib-tooltip-html=\\\"vm.calendarEventTitle.monthViewTooltip(event) | calendarTrustAsHtml\\\"\\n    mwl-draggable=\\\"event.draggable === true\\\"\\n    drop-data=\\\"{event: event, draggedFromDate: day.date.toDate()}\\\">\\n  </a>\\n</div>\\n\";\n\n/***/ },\n/* 19 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div class=\\\"cal-row-fluid cal-row-head\\\">\\n\\n  <div class=\\\"cal-cell1\\\" ng-repeat=\\\"day in vm.weekDays track by $index\\\" ng-bind=\\\"day\\\"></div>\\n\\n</div>\\n<div class=\\\"cal-month-box\\\">\\n\\n  <div\\n    ng-repeat=\\\"rowOffset in vm.monthOffsets track by rowOffset\\\"\\n    ng-mouseenter=\\\"rowHovered = true\\\"\\n    ng-mouseleave=\\\"rowHovered = false\\\">\\n    <div class=\\\"cal-row-fluid cal-before-eventlist\\\">\\n      <div\\n        ng-repeat=\\\"day in vm.view | calendarLimitTo:7:rowOffset track by $index\\\"\\n        ng-init=\\\"dayIndex = vm.view.indexOf(day)\\\"\\n        class=\\\"cal-cell1 cal-cell {{ day.highlightClass }}\\\"\\n        ng-style=\\\"{backgroundColor: day.backgroundColor}\\\"\\n        ng-click=\\\"vm.dayClicked(day, false, $event)\\\"\\n        ng-class=\\\"{pointer: day.events.length > 0}\\\">\\n        <ng-include src=\\\"vm.customTemplateUrls.calendarMonthCell || vm.calendarConfig.templates.calendarMonthCell\\\"></ng-include>\\n      </div>\\n    </div>\\n\\n    <mwl-calendar-slide-box\\n      is-open=\\\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\\\"\\n      events=\\\"vm.view[vm.openDayIndex].events\\\"\\n      on-event-click=\\\"vm.onEventClick\\\"\\n      cell=\\\"vm.view[vm.openDayIndex]\\\"\\n      custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n      template-scope=\\\"vm.templateScope\\\">\\n    </mwl-calendar-slide-box>\\n\\n  </div>\\n\\n</div>\\n\";\n\n/***/ },\n/* 20 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div class=\\\"cal-slide-box\\\" uib-collapse=\\\"vm.isCollapsed\\\" mwl-collapse-fallback=\\\"vm.isCollapsed\\\">\\n  <div class=\\\"cal-slide-content cal-event-list\\\">\\n    <ul class=\\\"unstyled list-unstyled\\\">\\n\\n      <li\\n        ng-repeat=\\\"event in vm.events | orderBy:'startsAt' track by event.calendarEventId\\\"\\n        ng-class=\\\"event.cssClass\\\"\\n        mwl-draggable=\\\"event.draggable === true\\\"\\n        drop-data=\\\"{event: event}\\\">\\n        <span class=\\\"pull-left event\\\" ng-style=\\\"{backgroundColor: event.color.primary}\\\"></span>\\n        &nbsp;\\n        <a\\n          href=\\\"javascript:;\\\"\\n          class=\\\"event-item\\\"\\n          ng-click=\\\"vm.onEventClick({calendarEvent: event})\\\">\\n          <span ng-bind-html=\\\"isMonthView ? vm.calendarEventTitle.monthView(event) : vm.calendarEventTitle.yearView(event) | calendarTrustAsHtml\\\"></span>\\n        </a>\\n\\n        <a\\n          href=\\\"javascript:;\\\"\\n          class=\\\"event-item-action\\\"\\n          ng-class=\\\"action.cssClass\\\"\\n          ng-repeat=\\\"action in event.actions track by $index\\\"\\n          ng-bind-html=\\\"action.label | calendarTrustAsHtml\\\"\\n          ng-click=\\\"action.onClick({calendarEvent: event})\\\">\\n        </a>\\n\\n      </li>\\n\\n    </ul>\\n  </div>\\n</div>\\n\";\n\n/***/ },\n/* 21 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div class=\\\"cal-week-box\\\" ng-class=\\\"{'cal-day-box': vm.showTimes}\\\">\\n  <div class=\\\"cal-row-fluid cal-row-head\\\">\\n\\n    <div\\n      class=\\\"cal-cell1\\\"\\n      ng-repeat=\\\"day in vm.view.days track by $index\\\"\\n      ng-class=\\\"{\\n        'cal-day-weekend': day.isWeekend,\\n        'cal-day-past': day.isPast,\\n        'cal-day-today': day.isToday,\\n        'cal-day-future': day.isFuture}\\\"\\n      mwl-element-dimensions=\\\"vm.dayColumnDimensions\\\"\\n      mwl-droppable\\n      on-drop=\\\"vm.eventDropped(dropData.event, day.date)\\\">\\n\\n      <span ng-bind=\\\"day.weekDayLabel\\\"></span>\\n      <br>\\n      <small>\\n        <span\\n          data-cal-date\\n          ng-click=\\\"vm.calendarCtrl.dateClicked(day.date)\\\"\\n          class=\\\"pointer\\\"\\n          ng-bind=\\\"day.dayLabel\\\">\\n        </span>\\n      </small>\\n\\n    </div>\\n\\n  </div>\\n\\n  <div class=\\\"cal-day-panel clearfix\\\" ng-style=\\\"{height: vm.showTimes ? (vm.dayViewHeight + 'px') : 'auto'}\\\">\\n\\n    <mwl-calendar-hour-list\\n      day-view-start=\\\"vm.dayViewStart\\\"\\n      day-view-end=\\\"vm.dayViewEnd\\\"\\n      day-view-split=\\\"vm.dayViewSplit\\\"\\n      day-width=\\\"vm.dayColumnDimensions.width\\\"\\n      view-date=\\\"vm.viewDate\\\"\\n      on-timespan-click=\\\"vm.onTimespanClick\\\"\\n      on-date-range-select=\\\"vm.onDateRangeSelect\\\"\\n      custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n      cell-modifier=\\\"vm.cellModifier\\\"\\n      template-scope=\\\"vm.templateScope\\\"\\n      ng-if=\\\"vm.showTimes\\\">\\n    </mwl-calendar-hour-list>\\n\\n    <div class=\\\"row\\\" ng-repeat=\\\"row in vm.view.eventRows track by $index\\\">\\n      <div class=\\\"col-xs-12\\\">\\n        <div class=\\\"cal-row-fluid\\\">\\n          <div\\n            ng-repeat=\\\"eventRow in row.row track by eventRow.event.calendarEventId\\\"\\n            ng-class=\\\"'cal-cell' + (vm.showTimes ? 1 : eventRow.span) + (vm.showTimes ? '' : ' cal-offset' + eventRow.offset)\\\"\\n            ng-style=\\\"{\\n              top: vm.showTimes ? ((eventRow.top) + 'px') : 'auto',\\n              position: vm.showTimes ? 'absolute' : 'inherit',\\n              width: vm.showTimes ? (vm.dayColumnDimensions.width + 'px') : '',\\n              left: vm.showTimes ? (vm.dayColumnDimensions.width * eventRow.offset) + 15 + 'px' : ''\\n            }\\\">\\n            <div\\n              class=\\\"day-highlight\\\"\\n              ng-class=\\\"[eventRow.event.cssClass, !vm.showTimes && eventRow.startsBeforeWeek ? '' : 'border-left-rounded', !vm.showTimes && eventRow.endsAfterWeek ? '' : 'border-right-rounded']\\\"\\n              ng-style=\\\"{backgroundColor: eventRow.event.color.secondary}\\\"\\n              data-event-class\\n              mwl-draggable=\\\"eventRow.event.draggable === true\\\"\\n              axis=\\\"vm.showTimes ? 'xy' : 'x'\\\"\\n              snap-grid=\\\"vm.showTimes ? {x: vm.dayColumnDimensions.width, y: vm.dayViewEventChunkSize || 30} : {x: vm.dayColumnDimensions.width}\\\"\\n              on-drag=\\\"vm.tempTimeChanged(eventRow.event, y / 30)\\\"\\n              on-drag-end=\\\"vm.weekDragged(eventRow.event, x / vm.dayColumnDimensions.width, y / 30)\\\"\\n              mwl-resizable=\\\"eventRow.event.resizable === true && eventRow.event.endsAt && !vm.showTimes\\\"\\n              resize-edges=\\\"{left: true, right: true}\\\"\\n              on-resize-end=\\\"vm.weekResized(eventRow.event, edge, x / vm.dayColumnDimensions.width)\\\">\\n              <strong ng-bind=\\\"(eventRow.event.tempStartsAt || eventRow.event.startsAt) | calendarDate:'time':true\\\" ng-show=\\\"vm.showTimes\\\"></strong>\\n              <a\\n                href=\\\"javascript:;\\\"\\n                ng-click=\\\"vm.onEventClick({calendarEvent: eventRow.event})\\\"\\n                class=\\\"event-item\\\"\\n                ng-bind-html=\\\"vm.calendarEventTitle.weekView(eventRow.event) | calendarTrustAsHtml\\\"\\n                uib-tooltip-html=\\\"vm.calendarEventTitle.weekViewTooltip(eventRow.event) | calendarTrustAsHtml\\\"\\n                tooltip-placement=\\\"left\\\"\\n                tooltip-append-to-body=\\\"true\\\">\\n              </a>\\n            </div>\\n          </div>\\n        </div>\\n      </div>\\n\\n    </div>\\n\\n  </div>\\n</div>\\n\";\n\n/***/ },\n/* 22 */\n/***/ function(module, exports) {\n\n\tmodule.exports = \"<div class=\\\"cal-year-box\\\">\\n  <div ng-repeat=\\\"rowOffset in [0, 4, 8] track by rowOffset\\\">\\n    <div class=\\\"row cal-before-eventlist\\\">\\n      <div\\n        class=\\\"span3 col-md-3 col-xs-6 cal-cell {{ day.cssClass }}\\\"\\n        ng-repeat=\\\"month in vm.view | calendarLimitTo:4:rowOffset track by $index\\\"\\n        ng-init=\\\"monthIndex = vm.view.indexOf(month)\\\"\\n        ng-click=\\\"vm.monthClicked(month, false, $event)\\\"\\n        ng-class=\\\"{pointer: month.events.length > 0, 'cal-day-today': month.isToday}\\\"\\n        mwl-droppable\\n        on-drop=\\\"vm.handleEventDrop(dropData.event, month.date)\\\">\\n\\n        <span\\n          class=\\\"pull-right\\\"\\n          data-cal-date\\n          ng-click=\\\"vm.calendarCtrl.dateClicked(month.date)\\\"\\n          ng-bind=\\\"month.label\\\">\\n        </span>\\n\\n        <small\\n          class=\\\"cal-events-num badge badge-important pull-left\\\"\\n          ng-show=\\\"month.badgeTotal > 0\\\"\\n          ng-bind=\\\"month.badgeTotal\\\">\\n        </small>\\n\\n        <div\\n          class=\\\"cal-day-tick\\\"\\n          ng-show=\\\"monthIndex === vm.openMonthIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\\\">\\n          <i class=\\\"glyphicon glyphicon-chevron-up\\\"></i>\\n          <i class=\\\"fa fa-chevron-up\\\"></i>\\n        </div>\\n\\n      </div>\\n    </div>\\n\\n    <mwl-calendar-slide-box\\n      is-open=\\\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\\\"\\n      events=\\\"vm.view[vm.openMonthIndex].events\\\"\\n      on-event-click=\\\"vm.onEventClick\\\"\\n      cell=\\\"vm.view[vm.openMonthIndex]\\\"\\n      custom-template-urls=\\\"vm.customTemplateUrls\\\"\\n      template-scope=\\\"vm.templateScope\\\">\\n    </mwl-calendar-slide-box>\\n\\n  </div>\\n\\n</div>\\n\";\n\n/***/ },\n/* 23 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar map = {\n\t\t\"./mwlCalendar.js\": 24,\n\t\t\"./mwlCalendarDay.js\": 25,\n\t\t\"./mwlCalendarHourList.js\": 26,\n\t\t\"./mwlCalendarMonth.js\": 53,\n\t\t\"./mwlCalendarSlideBox.js\": 54,\n\t\t\"./mwlCalendarWeek.js\": 55,\n\t\t\"./mwlCalendarYear.js\": 56,\n\t\t\"./mwlCollapseFallback.js\": 57,\n\t\t\"./mwlDateModifier.js\": 58,\n\t\t\"./mwlDragSelect.js\": 59,\n\t\t\"./mwlDraggable.js\": 60,\n\t\t\"./mwlDroppable.js\": 61,\n\t\t\"./mwlDynamicDirectiveTemplate.js\": 62,\n\t\t\"./mwlElementDimensions.js\": 63,\n\t\t\"./mwlResizable.js\": 64\n\t};\n\tfunction webpackContext(req) {\n\t\treturn __webpack_require__(webpackContextResolve(req));\n\t};\n\tfunction webpackContextResolve(req) {\n\t\treturn map[req] || (function() { throw new Error(\"Cannot find module '\" + req + \"'.\") }());\n\t};\n\twebpackContext.keys = function webpackContextKeys() {\n\t\treturn Object.keys(map);\n\t};\n\twebpackContext.resolve = webpackContextResolve;\n\tmodule.exports = webpackContext;\n\twebpackContext.id = 23;\n\n\n/***/ },\n/* 24 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\tvar LOG_PREFIX = 'Bootstrap calendar:';\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCalendarCtrl', [\"$scope\", \"$log\", \"$timeout\", \"$attrs\", \"$locale\", \"moment\", \"calendarTitle\", \"calendarHelper\", function($scope, $log, $timeout, $attrs, $locale, moment, calendarTitle, calendarHelper) {\n\n\t    var vm = this;\n\n\t    if (vm.slideBoxDisabled) {\n\t      $log.warn(LOG_PREFIX, 'The `slide-box-disabled` option is deprecated and will be removed in the next release. ' +\n\t        'Instead set `cell-auto-open-disabled` to true');\n\t    }\n\n\t    vm.events = vm.events || [];\n\n\t    vm.changeView = function(view, newDay) {\n\t      vm.view = view;\n\t      vm.viewDate = newDay;\n\t    };\n\n\t    vm.dateClicked = function(date) {\n\n\t      var rawDate = moment(date).toDate();\n\n\t      var nextView = {\n\t        year: 'month',\n\t        month: 'day',\n\t        week: 'day'\n\t      };\n\n\t      if (vm.onViewChangeClick({calendarDate: rawDate, calendarNextView: nextView[vm.view]}) !== false) {\n\t        vm.changeView(nextView[vm.view], rawDate);\n\t      }\n\n\t    };\n\n\t    var previousDate = moment(vm.viewDate);\n\t    var previousView = vm.view;\n\n\t    function checkEventIsValid(event) {\n\t      if (!event.startsAt) {\n\t        $log.warn(LOG_PREFIX, 'Event is missing the startsAt field', event);\n\t      } else if (!angular.isDate(event.startsAt)) {\n\t        $log.warn(LOG_PREFIX, 'Event startsAt should be a javascript date object. Do `new Date(event.startsAt)` to fix it.', event);\n\t      }\n\n\t      if (event.endsAt) {\n\t        if (!angular.isDate(event.endsAt)) {\n\t          $log.warn(LOG_PREFIX, 'Event endsAt should be a javascript date object. Do `new Date(event.endsAt)` to fix it.', event);\n\t        }\n\t        if (moment(event.startsAt).isAfter(moment(event.endsAt))) {\n\t          $log.warn(LOG_PREFIX, 'Event cannot start after it finishes', event);\n\t        }\n\t      }\n\t    }\n\n\t    function refreshCalendar() {\n\n\t      if (calendarTitle[vm.view] && angular.isDefined($attrs.viewTitle)) {\n\t        vm.viewTitle = calendarTitle[vm.view](vm.viewDate);\n\t      }\n\n\t      vm.events.forEach(function(event, index) {\n\t        checkEventIsValid(event);\n\t        event.calendarEventId = index;\n\t      });\n\n\t      //if on-timespan-click=\"calendarDay = calendarDate\" is set then don't update the view as nothing needs to change\n\t      var currentDate = moment(vm.viewDate);\n\t      var shouldUpdate = true;\n\t      if (\n\t        previousDate.clone().startOf(vm.view).isSame(currentDate.clone().startOf(vm.view)) &&\n\t        !previousDate.isSame(currentDate) &&\n\t        vm.view === previousView\n\t      ) {\n\t        shouldUpdate = false;\n\t      }\n\t      previousDate = currentDate;\n\t      previousView = vm.view;\n\n\t      if (shouldUpdate) {\n\t        // a $timeout is required as $broadcast is synchronous so if a new events array is set the calendar won't update\n\t        $timeout(function() {\n\t          $scope.$broadcast('calendar.refreshView');\n\t        });\n\t      }\n\t    }\n\n\t    calendarHelper.loadTemplates().then(function() {\n\t      vm.templatesLoaded = true;\n\n\t      var eventsWatched = false;\n\n\t      //Refresh the calendar when any of these variables change.\n\t      $scope.$watchGroup([\n\t        'vm.viewDate',\n\t        'vm.view',\n\t        'vm.cellIsOpen',\n\t        function() {\n\t          return moment.locale() + $locale.id; //Auto update the calendar when the locale changes\n\t        }\n\t      ], function() {\n\t        if (!eventsWatched) {\n\t          eventsWatched = true;\n\t          //need to deep watch events hence why it isn't included in the watch group\n\t          $scope.$watch('vm.events', refreshCalendar, true); //this will call refreshCalendar when the watcher starts (i.e. now)\n\t        } else {\n\t          refreshCalendar();\n\t        }\n\t      });\n\n\t    }).catch(function(err) {\n\t      $log.error('Could not load all calendar templates', err);\n\t    });\n\n\t  }])\n\t  .directive('mwlCalendar', function() {\n\n\t    return {\n\t      template: '<div mwl-dynamic-directive-template name=\"calendar\" overrides=\"vm.customTemplateUrls\"></div>',\n\t      restrict: 'E',\n\t      scope: {\n\t        events: '=',\n\t        view: '=',\n\t        viewTitle: '=?',\n\t        viewDate: '=',\n\t        cellIsOpen: '=?',\n\t        cellAutoOpenDisabled: '=?',\n\t        slideBoxDisabled: '=?',\n\t        customTemplateUrls: '=?',\n\t        onEventClick: '&',\n\t        onEventTimesChanged: '&',\n\t        onTimespanClick: '&',\n\t        onDateRangeSelect: '&?',\n\t        onViewChangeClick: '&',\n\t        cellModifier: '&',\n\t        dayViewStart: '@',\n\t        dayViewEnd: '@',\n\t        dayViewSplit: '@',\n\t        dayViewEventChunkSize: '@',\n\t        templateScope: '=?'\n\t      },\n\t      controller: 'MwlCalendarCtrl as vm',\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 25 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCalendarDayCtrl', [\"$scope\", \"moment\", \"calendarHelper\", \"calendarEventTitle\", function($scope, moment, calendarHelper, calendarEventTitle) {\n\n\t    var vm = this;\n\n\t    vm.calendarEventTitle = calendarEventTitle;\n\n\t    function refreshView() {\n\t      vm.dayViewSplit = vm.dayViewSplit || 30;\n\t      vm.dayViewHeight = calendarHelper.getDayViewHeight(\n\t        vm.dayViewStart,\n\t        vm.dayViewEnd,\n\t        vm.dayViewSplit\n\t      );\n\n\t      var view = calendarHelper.getDayView(\n\t        vm.events,\n\t        vm.viewDate,\n\t        vm.dayViewStart,\n\t        vm.dayViewEnd,\n\t        vm.dayViewSplit\n\t      );\n\n\t      vm.allDayEvents = view.allDayEvents;\n\t      vm.nonAllDayEvents = view.events;\n\t      vm.viewWidth = view.width + 62;\n\n\t    }\n\n\t    $scope.$on('calendar.refreshView', refreshView);\n\n\t    $scope.$watchGroup([\n\t      'vm.dayViewStart',\n\t      'vm.dayViewEnd',\n\t      'vm.dayViewSplit'\n\t    ], refreshView);\n\n\t    vm.eventDragComplete = function(event, minuteChunksMoved) {\n\t      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;\n\t      var newStart = moment(event.startsAt).add(minutesDiff, 'minutes');\n\t      var newEnd = moment(event.endsAt).add(minutesDiff, 'minutes');\n\t      delete event.tempStartsAt;\n\n\t      vm.onEventTimesChanged({\n\t        calendarEvent: event,\n\t        calendarNewEventStart: newStart.toDate(),\n\t        calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null\n\t      });\n\t    };\n\n\t    vm.eventDragged = function(event, minuteChunksMoved) {\n\t      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;\n\t      event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();\n\t    };\n\n\t    vm.eventResizeComplete = function(event, edge, minuteChunksMoved) {\n\t      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;\n\t      var start = moment(event.startsAt);\n\t      var end = moment(event.endsAt);\n\t      if (edge === 'start') {\n\t        start.add(minutesDiff, 'minutes');\n\t      } else {\n\t        end.add(minutesDiff, 'minutes');\n\t      }\n\t      delete event.tempStartsAt;\n\n\t      vm.onEventTimesChanged({\n\t        calendarEvent: event,\n\t        calendarNewEventStart: start.toDate(),\n\t        calendarNewEventEnd: end.toDate()\n\t      });\n\t    };\n\n\t    vm.eventResized = function(event, edge, minuteChunksMoved) {\n\t      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;\n\t      if (edge === 'start') {\n\t        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();\n\t      }\n\t    };\n\n\t  }])\n\t  .directive('mwlCalendarDay', function() {\n\n\t    return {\n\t      template: '<div mwl-dynamic-directive-template name=\"calendarDayView\" overrides=\"vm.customTemplateUrls\"></div>',\n\t      restrict: 'E',\n\t      require: '^mwlCalendar',\n\t      scope: {\n\t        events: '=',\n\t        viewDate: '=',\n\t        onEventClick: '=',\n\t        onEventTimesChanged: '=',\n\t        onTimespanClick: '=',\n\t        onDateRangeSelect: '=',\n\t        dayViewStart: '=',\n\t        dayViewEnd: '=',\n\t        dayViewSplit: '=',\n\t        dayViewEventChunkSize: '=',\n\t        customTemplateUrls: '=?',\n\t        cellModifier: '=',\n\t        templateScope: '='\n\t      },\n\t      controller: 'MwlCalendarDayCtrl as vm',\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 26 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\tvar calendarUtils = __webpack_require__(27);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCalendarHourListCtrl', [\"$scope\", \"moment\", \"calendarHelper\", \"calendarConfig\", function($scope, moment, calendarHelper, calendarConfig) {\n\t    var vm = this;\n\n\t    function updateDays() {\n\n\t      vm.dayViewSplit = parseInt(vm.dayViewSplit);\n\t      var dayStart = (vm.dayViewStart || '00:00').split(':');\n\t      var dayEnd = (vm.dayViewEnd || '23:59').split(':');\n\t      vm.hourGrid = calendarUtils.getDayViewHourGrid({\n\t        viewDate: calendarConfig.showTimesOnWeekView ? moment(vm.viewDate).startOf('week').toDate() : moment(vm.viewDate).toDate(),\n\t        hourSegments: 60 / vm.dayViewSplit,\n\t        dayStart: {\n\t          hour: dayStart[0],\n\t          minute: dayStart[1]\n\t        },\n\t        dayEnd: {\n\t          hour: dayEnd[0],\n\t          minute: dayEnd[1]\n\t        }\n\t      });\n\n\t      vm.hourGrid.forEach(function(hour) {\n\t        hour.segments.forEach(function(segment) {\n\n\t          segment.date = moment(segment.date);\n\t          segment.nextSegmentDate = segment.date.clone().add(vm.dayViewSplit, 'minutes');\n\n\t          if (calendarConfig.showTimesOnWeekView) {\n\n\t            segment.days = [];\n\n\t            for (var i = 0; i < 7; i++) {\n\t              var day = {\n\t                date: moment(segment.date).add(i, 'days')\n\t              };\n\t              day.nextSegmentDate = day.date.clone().add(vm.dayViewSplit, 'minutes');\n\t              vm.cellModifier({calendarCell: day});\n\t              segment.days.push(day);\n\t            }\n\n\t          } else {\n\t            vm.cellModifier({calendarCell: segment});\n\t          }\n\n\t        });\n\t      });\n\n\t    }\n\n\t    var originalLocale = moment.locale();\n\n\t    $scope.$on('calendar.refreshView', function() {\n\n\t      if (originalLocale !== moment.locale()) {\n\t        originalLocale = moment.locale();\n\t        updateDays();\n\t      }\n\n\t    });\n\n\t    $scope.$watchGroup([\n\t      'vm.dayViewStart',\n\t      'vm.dayViewEnd',\n\t      'vm.dayViewSplit',\n\t      'vm.viewDate'\n\t    ], function() {\n\t      updateDays();\n\t    });\n\n\t    vm.eventDropped = function(event, date) {\n\t      var newStart = moment(date);\n\t      var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);\n\n\t      vm.onEventTimesChanged({\n\t        calendarEvent: event,\n\t        calendarDate: date,\n\t        calendarNewEventStart: newStart.toDate(),\n\t        calendarNewEventEnd: newEnd ? newEnd.toDate() : null\n\t      });\n\t    };\n\n\t    vm.onDragSelectStart = function(date, dayIndex) {\n\t      if (!vm.dateRangeSelect) {\n\t        vm.dateRangeSelect = {\n\t          active: true,\n\t          startDate: date,\n\t          endDate: date,\n\t          dayIndex: dayIndex\n\t        };\n\t      }\n\t    };\n\n\t    vm.onDragSelectMove = function(date) {\n\t      if (vm.dateRangeSelect) {\n\t        vm.dateRangeSelect.endDate = date;\n\t      }\n\t    };\n\n\t    vm.onDragSelectEnd = function(date) {\n\t      if (vm.dateRangeSelect) {\n\t        vm.dateRangeSelect.endDate = date;\n\t        if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {\n\t          vm.onDateRangeSelect({calendarRangeStartDate: vm.dateRangeSelect.startDate, calendarRangeEndDate: vm.dateRangeSelect.endDate});\n\t        }\n\t        delete vm.dateRangeSelect;\n\t      }\n\t    };\n\n\t  }])\n\t  .directive('mwlCalendarHourList', function() {\n\n\t    return {\n\t      restrict: 'E',\n\t      template: '<div mwl-dynamic-directive-template name=\"calendarHourList\" overrides=\"vm.customTemplateUrls\"></div>',\n\t      controller: 'MwlCalendarHourListCtrl as vm',\n\t      scope: {\n\t        viewDate: '=',\n\t        dayViewStart: '=',\n\t        dayViewEnd: '=',\n\t        dayViewSplit: '=',\n\t        dayWidth: '=?',\n\t        onTimespanClick: '=',\n\t        onDateRangeSelect: '=',\n\t        onEventTimesChanged: '=',\n\t        customTemplateUrls: '=?',\n\t        cellModifier: '=',\n\t        templateScope: '='\n\t      },\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 27 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t(function webpackUniversalModuleDefinition(root, factory) {\n\t\tif(true)\n\t\t\tmodule.exports = factory(__webpack_require__(28), __webpack_require__(31), __webpack_require__(32), __webpack_require__(33), __webpack_require__(37), __webpack_require__(39), __webpack_require__(40), __webpack_require__(41), __webpack_require__(42), __webpack_require__(43), __webpack_require__(44), __webpack_require__(45), __webpack_require__(46), __webpack_require__(48), __webpack_require__(49), __webpack_require__(35), __webpack_require__(50), __webpack_require__(51), __webpack_require__(52));\n\t\telse if(typeof define === 'function' && define.amd)\n\t\t\tdefine([, , , , , , , , , , , , , , , , , , ], factory);\n\t\telse if(typeof exports === 'object')\n\t\t\texports[\"calendarUtils\"] = factory(require(\"date-fns/add_days/index\"), require(\"date-fns/add_hours/index\"), require(\"date-fns/add_minutes/index\"), require(\"date-fns/difference_in_days/index\"), require(\"date-fns/difference_in_minutes/index\"), require(\"date-fns/difference_in_seconds/index\"), require(\"date-fns/end_of_day/index\"), require(\"date-fns/end_of_month/index\"), require(\"date-fns/end_of_week/index\"), require(\"date-fns/get_day/index\"), require(\"date-fns/is_same_day/index\"), require(\"date-fns/is_same_month/index\"), require(\"date-fns/is_same_second/index\"), require(\"date-fns/set_hours/index\"), require(\"date-fns/set_minutes/index\"), require(\"date-fns/start_of_day/index\"), require(\"date-fns/start_of_minute/index\"), require(\"date-fns/start_of_month/index\"), require(\"date-fns/start_of_week/index\"));\n\t\telse\n\t\t\troot[\"calendarUtils\"] = factory(root[\"dateFns\"][\"addDays\"], root[\"dateFns\"][\"addHours\"], root[\"dateFns\"][\"addMinutes\"], root[\"dateFns\"][\"differenceInDays\"], root[\"dateFns\"][\"differenceInMinutes\"], root[\"dateFns\"][\"differenceInSeconds\"], root[\"dateFns\"][\"endOfDay\"], root[\"dateFns\"][\"endOfMonth\"], root[\"dateFns\"][\"endOfWeek\"], root[\"dateFns\"][\"getDay\"], root[\"dateFns\"][\"isSameDay\"], root[\"dateFns\"][\"isSameMonth\"], root[\"dateFns\"][\"isSameSecond\"], root[\"dateFns\"][\"setHours\"], root[\"dateFns\"][\"setMinutes\"], root[\"dateFns\"][\"startOfDay\"], root[\"dateFns\"][\"startOfMinute\"], root[\"dateFns\"][\"startOfMonth\"], root[\"dateFns\"][\"startOfWeek\"]);\n\t})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_18__) {\n\treturn /******/ (function(modules) { // webpackBootstrap\n\t/******/ \t// The module cache\n\t/******/ \tvar installedModules = {};\n\n\t/******/ \t// The require function\n\t/******/ \tfunction __webpack_require__(moduleId) {\n\n\t/******/ \t\t// Check if module is in cache\n\t/******/ \t\tif(installedModules[moduleId])\n\t/******/ \t\t\treturn installedModules[moduleId].exports;\n\n\t/******/ \t\t// Create a new module (and put it into the cache)\n\t/******/ \t\tvar module = installedModules[moduleId] = {\n\t/******/ \t\t\ti: moduleId,\n\t/******/ \t\t\tl: false,\n\t/******/ \t\t\texports: {}\n\t/******/ \t\t};\n\n\t/******/ \t\t// Execute the module function\n\t/******/ \t\tmodules[moduleId].call(module.exports, module, module.exports, __webpack_require__);\n\n\t/******/ \t\t// Flag the module as loaded\n\t/******/ \t\tmodule.l = true;\n\n\t/******/ \t\t// Return the exports of the module\n\t/******/ \t\treturn module.exports;\n\t/******/ \t}\n\n\n\t/******/ \t// expose the modules object (__webpack_modules__)\n\t/******/ \t__webpack_require__.m = modules;\n\n\t/******/ \t// expose the module cache\n\t/******/ \t__webpack_require__.c = installedModules;\n\n\t/******/ \t// identity function for calling harmory imports with the correct context\n\t/******/ \t__webpack_require__.i = function(value) { return value; };\n\n\t/******/ \t// define getter function for harmory exports\n\t/******/ \t__webpack_require__.d = function(exports, name, getter) {\n\t/******/ \t\tObject.defineProperty(exports, name, {\n\t/******/ \t\t\tconfigurable: false,\n\t/******/ \t\t\tenumerable: true,\n\t/******/ \t\t\tget: getter\n\t/******/ \t\t});\n\t/******/ \t};\n\n\t/******/ \t// getDefaultExport function for compatibility with non-harmony modules\n\t/******/ \t__webpack_require__.n = function(module) {\n\t/******/ \t\tvar getter = module && module.__esModule ?\n\t/******/ \t\t\tfunction getDefault() { return module['default']; } :\n\t/******/ \t\t\tfunction getModuleExports() { return module; };\n\t/******/ \t\t__webpack_require__.d(getter, 'a', getter);\n\t/******/ \t\treturn getter;\n\t/******/ \t};\n\n\t/******/ \t// Object.prototype.hasOwnProperty.call\n\t/******/ \t__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };\n\n\t/******/ \t// __webpack_public_path__\n\t/******/ \t__webpack_require__.p = \"\";\n\n\t/******/ \t// Load entry module and return exports\n\t/******/ \treturn __webpack_require__(__webpack_require__.s = 19);\n\t/******/ })\n\t/************************************************************************/\n\t/******/ ([\n\t/* 0 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_0__;\n\n\t/***/ },\n\t/* 1 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_1__;\n\n\t/***/ },\n\t/* 2 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_2__;\n\n\t/***/ },\n\t/* 3 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_3__;\n\n\t/***/ },\n\t/* 4 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_4__;\n\n\t/***/ },\n\t/* 5 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_5__;\n\n\t/***/ },\n\t/* 6 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_6__;\n\n\t/***/ },\n\t/* 7 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_7__;\n\n\t/***/ },\n\t/* 8 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_8__;\n\n\t/***/ },\n\t/* 9 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_9__;\n\n\t/***/ },\n\t/* 10 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_10__;\n\n\t/***/ },\n\t/* 11 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_11__;\n\n\t/***/ },\n\t/* 12 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_12__;\n\n\t/***/ },\n\t/* 13 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_13__;\n\n\t/***/ },\n\t/* 14 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_14__;\n\n\t/***/ },\n\t/* 15 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_15__;\n\n\t/***/ },\n\t/* 16 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_16__;\n\n\t/***/ },\n\t/* 17 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_17__;\n\n\t/***/ },\n\t/* 18 */\n\t/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_18__;\n\n\t/***/ },\n\t/* 19 */\n\t/***/ function(module, exports, __webpack_require__) {\n\n\t\"use strict\";\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__ = __webpack_require__(6);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__ = __webpack_require__(2);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__ = __webpack_require__(3);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__ = __webpack_require__(15);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__ = __webpack_require__(10);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__ = __webpack_require__(9);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__ = __webpack_require__(18);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__ = __webpack_require__(0);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__ = __webpack_require__(8);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__ = __webpack_require__(5);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__ = __webpack_require__(17);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__ = __webpack_require__(7);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__ = __webpack_require__(11);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__ = __webpack_require__(12);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__ = __webpack_require__(13);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__ = __webpack_require__(14);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__ = __webpack_require__(16);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__ = __webpack_require__(4);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__ = __webpack_require__(1);\n\t/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__);\n\t/* harmony export (binding) */ __webpack_require__.d(exports, \"getWeekViewEventOffset\", function() { return getWeekViewEventOffset; });\n\t/* harmony export (binding) */ __webpack_require__.d(exports, \"getWeekViewHeader\", function() { return getWeekViewHeader; });\n\t/* harmony export (binding) */ __webpack_require__.d(exports, \"getWeekView\", function() { return getWeekView; });\n\t/* harmony export (binding) */ __webpack_require__.d(exports, \"getMonthView\", function() { return getMonthView; });\n\t/* harmony export (binding) */ __webpack_require__.d(exports, \"getDayView\", function() { return getDayView; });\n\t/* harmony export (binding) */ __webpack_require__.d(exports, \"getDayViewHourGrid\", function() { return getDayViewHourGrid; });\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\tvar WEEKEND_DAY_NUMBERS = [0, 6];\n\tvar DAYS_IN_WEEK = 7;\n\tvar HOURS_IN_DAY = 24;\n\tvar MINUTES_IN_HOUR = 60;\n\tvar getWeekViewEventSpan = function (event, offset, startOfWeek) {\n\t    var span = 1;\n\t    if (event.end) {\n\t        var begin = event.start < startOfWeek ? startOfWeek : event.start;\n\t        span = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(event.end), 1), __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(begin));\n\t        if (span > DAYS_IN_WEEK) {\n\t            span = DAYS_IN_WEEK;\n\t        }\n\t    }\n\t    var totalLength = offset + span;\n\t    if (totalLength > DAYS_IN_WEEK) {\n\t        span -= (totalLength - DAYS_IN_WEEK);\n\t    }\n\t    return span;\n\t};\n\tvar getWeekViewEventOffset = function (event, startOfWeek) {\n\t    var offset = 0;\n\t    if (__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.start) > startOfWeek) {\n\t        offset = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.start), startOfWeek);\n\t    }\n\t    return offset;\n\t};\n\tvar isEventIsPeriod = function (_a) {\n\t    var event = _a.event, periodStart = _a.periodStart, periodEnd = _a.periodEnd;\n\t    var eventStart = event.start;\n\t    var eventEnd = event.end || event.start;\n\t    if (eventStart > periodStart && eventStart < periodEnd) {\n\t        return true;\n\t    }\n\t    if (eventEnd > periodStart && eventEnd < periodEnd) {\n\t        return true;\n\t    }\n\t    if (eventStart < periodStart && eventEnd > periodEnd) {\n\t        return true;\n\t    }\n\t    if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodEnd)) {\n\t        return true;\n\t    }\n\t    if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodEnd)) {\n\t        return true;\n\t    }\n\t    return false;\n\t};\n\tvar getEventsInPeriod = function (_a) {\n\t    var events = _a.events, periodStart = _a.periodStart, periodEnd = _a.periodEnd;\n\t    return events.filter(function (event) { return isEventIsPeriod({ event: event, periodStart: periodStart, periodEnd: periodEnd }); });\n\t};\n\tvar getWeekDay = function (_a) {\n\t    var date = _a.date;\n\t    var today = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(new Date());\n\t    return {\n\t        date: date,\n\t        isPast: date < today,\n\t        isToday: __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default()(date, today),\n\t        isFuture: date > today,\n\t        isWeekend: WEEKEND_DAY_NUMBERS.indexOf(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(date)) > -1\n\t    };\n\t};\n\tvar getWeekViewHeader = function (_a) {\n\t    var viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn;\n\t    var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });\n\t    var days = [];\n\t    for (var i = 0; i < DAYS_IN_WEEK; i++) {\n\t        var date = __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default()(start, i);\n\t        days.push(getWeekDay({ date: date }));\n\t    }\n\t    return days;\n\t};\n\tvar getWeekView = function (_a) {\n\t    var events = _a.events, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn;\n\t    var startOfViewWeek = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });\n\t    var endOfViewWeek = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });\n\t    var eventsMapped = getEventsInPeriod({ events: events, periodStart: startOfViewWeek, periodEnd: endOfViewWeek }).map(function (event) {\n\t        var offset = getWeekViewEventOffset(event, startOfViewWeek);\n\t        var span = getWeekViewEventSpan(event, offset, startOfViewWeek);\n\t        return {\n\t            event: event,\n\t            offset: offset,\n\t            span: span,\n\t            startsBeforeWeek: event.start < startOfViewWeek,\n\t            endsAfterWeek: (event.end || event.start) > endOfViewWeek\n\t        };\n\t    }).sort(function (itemA, itemB) {\n\t        var startSecondsDiff = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemA.event.start, itemB.event.start);\n\t        if (startSecondsDiff === 0) {\n\t            return __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemB.event.end || itemB.event.start, itemA.event.end || itemA.event.start);\n\t        }\n\t        return startSecondsDiff;\n\t    });\n\t    var eventRows = [];\n\t    var allocatedEvents = [];\n\t    eventsMapped.forEach(function (event, index) {\n\t        if (allocatedEvents.indexOf(event) === -1) {\n\t            allocatedEvents.push(event);\n\t            var rowSpan_1 = event.span + event.offset;\n\t            var otherRowEvents = eventsMapped.slice(index + 1).filter(function (nextEvent) {\n\t                if (nextEvent.offset >= rowSpan_1 &&\n\t                    rowSpan_1 + nextEvent.span <= DAYS_IN_WEEK &&\n\t                    allocatedEvents.indexOf(nextEvent) === -1) {\n\t                    nextEvent.offset -= rowSpan_1;\n\t                    rowSpan_1 += nextEvent.span + nextEvent.offset;\n\t                    allocatedEvents.push(nextEvent);\n\t                    return true;\n\t                }\n\t            });\n\t            eventRows.push({\n\t                row: [\n\t                    event\n\t                ].concat(otherRowEvents)\n\t            });\n\t        }\n\t    });\n\t    return eventRows;\n\t};\n\tvar getMonthView = function (_a) {\n\t    var events = _a.events, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn;\n\t    var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(__WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default()(viewDate), { weekStartsOn: weekStartsOn });\n\t    var end = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default()(viewDate), { weekStartsOn: weekStartsOn });\n\t    var eventsInMonth = getEventsInPeriod({\n\t        events: events,\n\t        periodStart: start,\n\t        periodEnd: end\n\t    });\n\t    var days = [];\n\t    for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(end, start) + 1; i++) {\n\t        var date = __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default()(start, i);\n\t        var day = getWeekDay({ date: date });\n\t        var events_1 = getEventsInPeriod({\n\t            events: eventsInMonth,\n\t            periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(date),\n\t            periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(date)\n\t        });\n\t        day.inMonth = __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default()(date, viewDate);\n\t        day.events = events_1;\n\t        day.badgeTotal = events_1.length;\n\t        days.push(day);\n\t    }\n\t    var rows = Math.floor(days.length / 7);\n\t    var rowOffsets = [];\n\t    for (var i = 0; i < rows; i++) {\n\t        rowOffsets.push(i * 7);\n\t    }\n\t    return {\n\t        rowOffsets: rowOffsets,\n\t        days: days\n\t    };\n\t};\n\tvar getDayView = function (_a) {\n\t    var events = _a.events, viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd, eventWidth = _a.eventWidth, segmentHeight = _a.segmentHeight;\n\t    var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);\n\t    var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);\n\t    var previousDayEvents = [];\n\t    var dayViewEvents = getEventsInPeriod({\n\t        events: events.filter(function (event) { return !event.allDay; }),\n\t        periodStart: startOfView,\n\t        periodEnd: endOfView\n\t    }).sort(function (eventA, eventB) {\n\t        return eventA.start.valueOf() - eventB.start.valueOf();\n\t    }).map(function (event) {\n\t        var eventStart = event.start;\n\t        var eventEnd = event.end || eventStart;\n\t        var startsBeforeDay = eventStart < startOfView;\n\t        var endsAfterDay = eventEnd > endOfView;\n\t        var hourHeightModifier = (hourSegments * segmentHeight) / MINUTES_IN_HOUR;\n\t        var top = 0;\n\t        if (eventStart > startOfView) {\n\t            top += __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(eventStart, startOfView);\n\t        }\n\t        top *= hourHeightModifier;\n\t        var startDate = startsBeforeDay ? startOfView : eventStart;\n\t        var endDate = endsAfterDay ? endOfView : eventEnd;\n\t        var height = __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(endDate, startDate);\n\t        if (!event.end) {\n\t            height = segmentHeight;\n\t        }\n\t        else {\n\t            height *= hourHeightModifier;\n\t        }\n\t        var bottom = top + height;\n\t        var overlappingPreviousEvents = previousDayEvents.filter(function (previousEvent) {\n\t            var previousEventTop = previousEvent.top;\n\t            var previousEventBottom = previousEvent.top + previousEvent.height;\n\t            if (top < previousEventBottom && previousEventBottom < bottom) {\n\t                return true;\n\t            }\n\t            else if (previousEventTop <= top && bottom <= previousEventBottom) {\n\t                return true;\n\t            }\n\t            return false;\n\t        });\n\t        var left = 0;\n\t        while (overlappingPreviousEvents.some(function (previousEvent) { return previousEvent.left === left; })) {\n\t            left += eventWidth;\n\t        }\n\t        var dayEvent = {\n\t            event: event,\n\t            height: height,\n\t            width: eventWidth,\n\t            top: top,\n\t            left: left,\n\t            startsBeforeDay: startsBeforeDay,\n\t            endsAfterDay: endsAfterDay\n\t        };\n\t        if (height > 0) {\n\t            previousDayEvents.push(dayEvent);\n\t        }\n\t        return dayEvent;\n\t    }).filter(function (dayEvent) { return dayEvent.height > 0; });\n\t    var width = Math.max.apply(Math, dayViewEvents.map(function (event) { return event.left + event.width; }));\n\t    var allDayEvents = getEventsInPeriod({\n\t        events: events.filter(function (event) { return event.allDay; }),\n\t        periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startOfView),\n\t        periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(endOfView)\n\t    });\n\t    return {\n\t        events: dayViewEvents,\n\t        width: width,\n\t        allDayEvents: allDayEvents\n\t    };\n\t};\n\tvar getDayViewHourGrid = function (_a) {\n\t    var viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd;\n\t    var hours = [];\n\t    var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);\n\t    var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);\n\t    var segmentDuration = MINUTES_IN_HOUR / hourSegments;\n\t    var startOfViewDay = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate);\n\t    for (var i = 0; i < HOURS_IN_DAY; i++) {\n\t        var segments = [];\n\t        for (var j = 0; j < hourSegments; j++) {\n\t            var date = __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(startOfViewDay, i), j * segmentDuration);\n\t            if (date >= startOfView && date < endOfView) {\n\t                segments.push({\n\t                    date: date,\n\t                    isStart: j === 0\n\t                });\n\t            }\n\t        }\n\t        if (segments.length > 0) {\n\t            hours.push({ segments: segments });\n\t        }\n\t    }\n\t    return hours;\n\t};\n\n\n\t/***/ }\n\t/******/ ])\n\t});\n\t;\n\n/***/ },\n/* 28 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Day Helpers\n\t * @summary Add the specified number of days to the given date.\n\t *\n\t * @description\n\t * Add the specified number of days to the given date.\n\t *\n\t * @param {Date|String|Number} date - the date to be changed\n\t * @param {Number} amount - the amount of days to be added\n\t * @returns {Date} the new date with the days added\n\t *\n\t * @example\n\t * // Add 10 days to 1 September 2014:\n\t * var result = addDays(new Date(2014, 8, 1), 10)\n\t * //=> Thu Sep 11 2014 00:00:00\n\t */\n\tfunction addDays (dirtyDate, amount) {\n\t  var date = parse(dirtyDate)\n\t  date.setDate(date.getDate() + amount)\n\t  return date\n\t}\n\n\tmodule.exports = addDays\n\n\n/***/ },\n/* 29 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar isDate = __webpack_require__(30)\n\n\tvar MILLISECONDS_IN_HOUR = 3600000\n\tvar MILLISECONDS_IN_MINUTE = 60000\n\tvar DEFAULT_ADDITIONAL_DIGITS = 2\n\n\tvar parseTokenDateTimeDelimeter = /[T ]/\n\tvar parseTokenPlainTime = /:/\n\n\t// year tokens\n\tvar parseTokenYY = /^(\\d{2})$/\n\tvar parseTokensYYY = [\n\t  /^([+-]\\d{2})$/, // 0 additional digits\n\t  /^([+-]\\d{3})$/, // 1 additional digit\n\t  /^([+-]\\d{4})$/ // 2 additional digits\n\t]\n\n\tvar parseTokenYYYY = /^(\\d{4})/\n\tvar parseTokensYYYYY = [\n\t  /^([+-]\\d{4})/, // 0 additional digits\n\t  /^([+-]\\d{5})/, // 1 additional digit\n\t  /^([+-]\\d{6})/ // 2 additional digits\n\t]\n\n\t// date tokens\n\tvar parseTokenMM = /^-(\\d{2})$/\n\tvar parseTokenDDD = /^-?(\\d{3})$/\n\tvar parseTokenMMDD = /^-?(\\d{2})-?(\\d{2})$/\n\tvar parseTokenWww = /^-?W(\\d{2})$/\n\tvar parseTokenWwwD = /^-?W(\\d{2})-?(\\d{1})$/\n\n\t// time tokens\n\tvar parseTokenHH = /^(\\d{2}([.,]\\d*)?)$/\n\tvar parseTokenHHMM = /^(\\d{2}):?(\\d{2}([.,]\\d*)?)$/\n\tvar parseTokenHHMMSS = /^(\\d{2}):?(\\d{2}):?(\\d{2}([.,]\\d*)?)$/\n\n\t// timezone tokens\n\tvar parseTokenTimezone = /([Z+-].*)$/\n\tvar parseTokenTimezoneZ = /^(Z)$/\n\tvar parseTokenTimezoneHH = /^([+-])(\\d{2})$/\n\tvar parseTokenTimezoneHHMM = /^([+-])(\\d{2}):?(\\d{2})$/\n\n\t/**\n\t * @category Common Helpers\n\t * @summary Parse the ISO-8601-formatted date.\n\t *\n\t * @description\n\t * Parse the date string representation.\n\t * It accepts complete ISO 8601 formats as well as partial implementations.\n\t *\n\t * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601\n\t *\n\t * @param {String} dateString - the ISO 8601 formatted string to parse\n\t * @param {Object} [options] - the object with options\n\t * @param {Number} [options.additionalDigits=2] - the additional number of digits in the extended year format: 0, 1, or 2\n\t * @returns {Date} the parsed date in the local time zone\n\t *\n\t * @example\n\t * // Parse string '2014-02-11T11:30:30':\n\t * var result = parse('2014-02-11T11:30:30')\n\t * //=> Tue Feb 11 2014 11:30:30\n\t *\n\t * @example\n\t * // Parse string '+02014101',\n\t * // if the additional number of digits in the extended year format is 1:\n\t * var result = parse('+02014101', {additionalDigits: 1})\n\t * //=> Fri Apr 11 2014 00:00:00\n\t */\n\tfunction parse (dateString, options) {\n\t  if (isDate(dateString)) {\n\t    // Prevent the date to lose the milliseconds when passed to new Date() in IE10\n\t    return new Date(dateString.getTime())\n\t  } else if (typeof dateString !== 'string') {\n\t    return new Date(dateString)\n\t  }\n\n\t  options = options || {}\n\t  var additionalDigits = options.additionalDigits\n\t  if (additionalDigits == null) {\n\t    additionalDigits = DEFAULT_ADDITIONAL_DIGITS\n\t  }\n\n\t  var dateStrings = splitDateString(dateString)\n\n\t  var parseYearResult = parseYear(dateStrings.date, additionalDigits)\n\t  var year = parseYearResult.year\n\t  var restDateString = parseYearResult.restDateString\n\n\t  var date = parseDate(restDateString, year)\n\n\t  if (date) {\n\t    var timestamp = date.getTime()\n\t    var time = 0\n\t    var offset\n\n\t    if (dateStrings.time) {\n\t      time = parseTime(dateStrings.time)\n\t    }\n\n\t    if (dateStrings.timezone) {\n\t      offset = parseTimezone(dateStrings.timezone)\n\t    } else {\n\t      // get offset accurate to hour in timezones that change offset\n\t      offset = new Date(timestamp + time).getTimezoneOffset()\n\t      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()\n\t    }\n\n\t    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)\n\t  } else {\n\t    return new Date(dateString)\n\t  }\n\t}\n\n\tfunction splitDateString (dateString) {\n\t  var dateStrings = {}\n\t  var array = dateString.split(parseTokenDateTimeDelimeter)\n\t  var timeString\n\n\t  if (parseTokenPlainTime.test(array[0])) {\n\t    dateStrings.date = null\n\t    timeString = array[0]\n\t  } else {\n\t    dateStrings.date = array[0]\n\t    timeString = array[1]\n\t  }\n\n\t  if (timeString) {\n\t    var token = parseTokenTimezone.exec(timeString)\n\t    if (token) {\n\t      dateStrings.time = timeString.replace(token[1], '')\n\t      dateStrings.timezone = token[1]\n\t    } else {\n\t      dateStrings.time = timeString\n\t    }\n\t  }\n\n\t  return dateStrings\n\t}\n\n\tfunction parseYear (dateString, additionalDigits) {\n\t  var parseTokenYYY = parseTokensYYY[additionalDigits]\n\t  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]\n\n\t  var token\n\n\t  // YYYY or ±YYYYY\n\t  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)\n\t  if (token) {\n\t    var yearString = token[1]\n\t    return {\n\t      year: parseInt(yearString, 10),\n\t      restDateString: dateString.slice(yearString.length)\n\t    }\n\t  }\n\n\t  // YY or ±YYY\n\t  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)\n\t  if (token) {\n\t    var centuryString = token[1]\n\t    return {\n\t      year: parseInt(centuryString, 10) * 100,\n\t      restDateString: dateString.slice(centuryString.length)\n\t    }\n\t  }\n\n\t  // Invalid ISO-formatted year\n\t  return {\n\t    year: null\n\t  }\n\t}\n\n\tfunction parseDate (dateString, year) {\n\t  // Invalid ISO-formatted year\n\t  if (year === null) {\n\t    return null\n\t  }\n\n\t  var token\n\t  var date\n\t  var month\n\t  var week\n\n\t  // YYYY\n\t  if (dateString.length === 0) {\n\t    date = new Date(0)\n\t    date.setUTCFullYear(year)\n\t    return date\n\t  }\n\n\t  // YYYY-MM\n\t  token = parseTokenMM.exec(dateString)\n\t  if (token) {\n\t    date = new Date(0)\n\t    month = parseInt(token[1], 10) - 1\n\t    date.setUTCFullYear(year, month)\n\t    return date\n\t  }\n\n\t  // YYYY-DDD or YYYYDDD\n\t  token = parseTokenDDD.exec(dateString)\n\t  if (token) {\n\t    date = new Date(0)\n\t    var dayOfYear = parseInt(token[1], 10)\n\t    date.setUTCFullYear(year, 0, dayOfYear)\n\t    return date\n\t  }\n\n\t  // YYYY-MM-DD or YYYYMMDD\n\t  token = parseTokenMMDD.exec(dateString)\n\t  if (token) {\n\t    date = new Date(0)\n\t    month = parseInt(token[1], 10) - 1\n\t    var day = parseInt(token[2], 10)\n\t    date.setUTCFullYear(year, month, day)\n\t    return date\n\t  }\n\n\t  // YYYY-Www or YYYYWww\n\t  token = parseTokenWww.exec(dateString)\n\t  if (token) {\n\t    week = parseInt(token[1], 10) - 1\n\t    return dayOfISOYear(year, week)\n\t  }\n\n\t  // YYYY-Www-D or YYYYWwwD\n\t  token = parseTokenWwwD.exec(dateString)\n\t  if (token) {\n\t    week = parseInt(token[1], 10) - 1\n\t    var dayOfWeek = parseInt(token[2], 10) - 1\n\t    return dayOfISOYear(year, week, dayOfWeek)\n\t  }\n\n\t  // Invalid ISO-formatted date\n\t  return null\n\t}\n\n\tfunction parseTime (timeString) {\n\t  var token\n\t  var hours\n\t  var minutes\n\n\t  // hh\n\t  token = parseTokenHH.exec(timeString)\n\t  if (token) {\n\t    hours = parseFloat(token[1].replace(',', '.'))\n\t    return (hours % 24) * MILLISECONDS_IN_HOUR\n\t  }\n\n\t  // hh:mm or hhmm\n\t  token = parseTokenHHMM.exec(timeString)\n\t  if (token) {\n\t    hours = parseInt(token[1], 10)\n\t    minutes = parseFloat(token[2].replace(',', '.'))\n\t    return (hours % 24) * MILLISECONDS_IN_HOUR +\n\t      minutes * MILLISECONDS_IN_MINUTE\n\t  }\n\n\t  // hh:mm:ss or hhmmss\n\t  token = parseTokenHHMMSS.exec(timeString)\n\t  if (token) {\n\t    hours = parseInt(token[1], 10)\n\t    minutes = parseInt(token[2], 10)\n\t    var seconds = parseFloat(token[3].replace(',', '.'))\n\t    return (hours % 24) * MILLISECONDS_IN_HOUR +\n\t      minutes * MILLISECONDS_IN_MINUTE +\n\t      seconds * 1000\n\t  }\n\n\t  // Invalid ISO-formatted time\n\t  return null\n\t}\n\n\tfunction parseTimezone (timezoneString) {\n\t  var token\n\t  var absoluteOffset\n\n\t  // Z\n\t  token = parseTokenTimezoneZ.exec(timezoneString)\n\t  if (token) {\n\t    return 0\n\t  }\n\n\t  // ±hh\n\t  token = parseTokenTimezoneHH.exec(timezoneString)\n\t  if (token) {\n\t    absoluteOffset = parseInt(token[2], 10) * 60\n\t    return (token[1] === '+') ? -absoluteOffset : absoluteOffset\n\t  }\n\n\t  // ±hh:mm or ±hhmm\n\t  token = parseTokenTimezoneHHMM.exec(timezoneString)\n\t  if (token) {\n\t    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)\n\t    return (token[1] === '+') ? -absoluteOffset : absoluteOffset\n\t  }\n\n\t  return 0\n\t}\n\n\tfunction dayOfISOYear (isoYear, week, day) {\n\t  week = week || 0\n\t  day = day || 0\n\t  var date = new Date(0)\n\t  date.setUTCFullYear(isoYear, 0, 4)\n\t  var diff = week * 7 + day + 1 - date.getUTCDay()\n\t  date.setUTCDate(date.getUTCDate() + diff)\n\t  return date\n\t}\n\n\tmodule.exports = parse\n\n\n/***/ },\n/* 30 */\n/***/ function(module, exports) {\n\n\t/**\n\t * @category Common Helpers\n\t * @summary Is the given argument an instance of Date?\n\t *\n\t * @description\n\t * Is the given argument an instance of Date?\n\t *\n\t * @param {*} argument - the argument to check\n\t * @returns {Boolean} the given argument is an instance of Date\n\t *\n\t * @example\n\t * // Is 'mayonnaise' a Date?\n\t * var result = isDate('mayonnaise')\n\t * //=> false\n\t */\n\tfunction isDate (argument) {\n\t  return argument instanceof Date\n\t}\n\n\tmodule.exports = isDate\n\n\n/***/ },\n/* 31 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Hour Helpers\n\t * @summary Add the specified number of hours to the given date.\n\t *\n\t * @description\n\t * Add the specified number of hours to the given date.\n\t *\n\t * @param {Date|String|Number} date - the date to be changed\n\t * @param {Number} amount - the amount of hours to be added\n\t * @returns {Date} the new date with the hours added\n\t *\n\t * @example\n\t * // Add 2 hours to 10 July 2014 23:00:00:\n\t * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)\n\t * //=> Fri Jul 11 2014 01:00:00\n\t */\n\tfunction addHours (dirtyDate, amount) {\n\t  var date = parse(dirtyDate)\n\t  date.setHours(date.getHours() + amount)\n\t  return date\n\t}\n\n\tmodule.exports = addHours\n\n\n/***/ },\n/* 32 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Minute Helpers\n\t * @summary Add the specified number of minutes to the given date.\n\t *\n\t * @description\n\t * Add the specified number of minutes to the given date.\n\t *\n\t * @param {Date|String|Number} date - the date to be changed\n\t * @param {Number} amount - the amount of minutes to be added\n\t * @returns {Date} the new date with the minutes added\n\t *\n\t * @example\n\t * // Add 30 minutes to 10 July 2014 12:00:00:\n\t * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)\n\t * //=> Thu Jul 10 2014 12:30:00\n\t */\n\tfunction addMinutes (dirtyDate, amount) {\n\t  var date = parse(dirtyDate)\n\t  date.setMinutes(date.getMinutes() + amount)\n\t  return date\n\t}\n\n\tmodule.exports = addMinutes\n\n\n/***/ },\n/* 33 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\tvar differenceInCalendarDays = __webpack_require__(34)\n\tvar compareAsc = __webpack_require__(36)\n\n\t/**\n\t * @category Day Helpers\n\t * @summary Get the number of full days between the given dates.\n\t *\n\t * @description\n\t * Get the number of full days between the given dates.\n\t *\n\t * @param {Date|String|Number} dateLeft - the later date\n\t * @param {Date|String|Number} dateRight - the earlier date\n\t * @returns {Number} the number of full days\n\t *\n\t * @example\n\t * // How many full days are between\n\t * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?\n\t * var result = differenceInDays(\n\t *   new Date(2012, 6, 2, 0, 0),\n\t *   new Date(2011, 6, 2, 23, 0)\n\t * )\n\t * //=> 365\n\t */\n\tfunction differenceInDays (dirtyDateLeft, dirtyDateRight) {\n\t  var dateLeft = parse(dirtyDateLeft)\n\t  var dateRight = parse(dirtyDateRight)\n\n\t  var sign = compareAsc(dateLeft, dateRight)\n\t  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))\n\t  dateLeft.setDate(dateLeft.getDate() - sign * difference)\n\n\t  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full\n\t  // If so, result must be decreased by 1 in absolute value\n\t  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign\n\t  return sign * (difference - isLastDayNotFull)\n\t}\n\n\tmodule.exports = differenceInDays\n\n\n/***/ },\n/* 34 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar startOfDay = __webpack_require__(35)\n\n\tvar MILLISECONDS_IN_MINUTE = 60000\n\tvar MILLISECONDS_IN_DAY = 86400000\n\n\t/**\n\t * @category Day Helpers\n\t * @summary Get the number of calendar days between the given dates.\n\t *\n\t * @description\n\t * Get the number of calendar days between the given dates.\n\t *\n\t * @param {Date|String|Number} dateLeft - the later date\n\t * @param {Date|String|Number} dateRight - the earlier date\n\t * @returns {Number} the number of calendar days\n\t *\n\t * @example\n\t * // How many calendar days are between\n\t * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?\n\t * var result = differenceInCalendarDays(\n\t *   new Date(2012, 6, 2, 0, 0),\n\t *   new Date(2011, 6, 2, 23, 0)\n\t * )\n\t * //=> 366\n\t */\n\tfunction differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {\n\t  var startOfDayLeft = startOfDay(dirtyDateLeft)\n\t  var startOfDayRight = startOfDay(dirtyDateRight)\n\n\t  var timestampLeft = startOfDayLeft.getTime() -\n\t    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE\n\t  var timestampRight = startOfDayRight.getTime() -\n\t    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE\n\n\t  // Round the number of days to the nearest integer\n\t  // because the number of milliseconds in a day is not constant\n\t  // (e.g. it's different in the day of the daylight saving time clock shift)\n\t  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)\n\t}\n\n\tmodule.exports = differenceInCalendarDays\n\n\n/***/ },\n/* 35 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Day Helpers\n\t * @summary Return the start of a day for the given date.\n\t *\n\t * @description\n\t * Return the start of a day for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @returns {Date} the start of a day\n\t *\n\t * @example\n\t * // The start of a day for 2 September 2014 11:55:00:\n\t * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))\n\t * //=> Tue Sep 02 2014 00:00:00\n\t */\n\tfunction startOfDay (dirtyDate) {\n\t  var date = parse(dirtyDate)\n\t  date.setHours(0, 0, 0, 0)\n\t  return date\n\t}\n\n\tmodule.exports = startOfDay\n\n\n/***/ },\n/* 36 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Common Helpers\n\t * @summary Compare the two dates and return -1, 0 or 1.\n\t *\n\t * @description\n\t * Compare the two dates and return 1 if the first date is after the second,\n\t * -1 if the first date is before the second or 0 if dates are equal.\n\t *\n\t * @param {Date|String|Number} dateLeft - the first date to compare\n\t * @param {Date|String|Number} dateRight - the second date to compare\n\t * @returns {Number} the result of the comparison\n\t *\n\t * @example\n\t * // Compare 11 February 1987 and 10 July 1989:\n\t * var result = compareAsc(\n\t *   new Date(1987, 1, 11),\n\t *   new Date(1989, 6, 10)\n\t * )\n\t * //=> -1\n\t *\n\t * @example\n\t * // Sort the array of dates:\n\t * var result = [\n\t *   new Date(1995, 6, 2),\n\t *   new Date(1987, 1, 11),\n\t *   new Date(1989, 6, 10)\n\t * ].sort(compareAsc)\n\t * //=> [\n\t * //   Wed Feb 11 1987 00:00:00,\n\t * //   Mon Jul 10 1989 00:00:00,\n\t * //   Sun Jul 02 1995 00:00:00\n\t * // ]\n\t */\n\tfunction compareAsc (dirtyDateLeft, dirtyDateRight) {\n\t  var dateLeft = parse(dirtyDateLeft)\n\t  var timeLeft = dateLeft.getTime()\n\t  var dateRight = parse(dirtyDateRight)\n\t  var timeRight = dateRight.getTime()\n\n\t  if (timeLeft < timeRight) {\n\t    return -1\n\t  } else if (timeLeft > timeRight) {\n\t    return 1\n\t  } else {\n\t    return 0\n\t  }\n\t}\n\n\tmodule.exports = compareAsc\n\n\n/***/ },\n/* 37 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar differenceInMilliseconds = __webpack_require__(38)\n\n\tvar MILLISECONDS_IN_MINUTE = 60000\n\n\t/**\n\t * @category Minute Helpers\n\t * @summary Get the number of minutes between the given dates.\n\t *\n\t * @description\n\t * Get the number of minutes between the given dates.\n\t *\n\t * @param {Date|String|Number} dateLeft - the later date\n\t * @param {Date|String|Number} dateRight - the earlier date\n\t * @returns {Number} the number of minutes\n\t *\n\t * @example\n\t * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?\n\t * var result = differenceInMinutes(\n\t *   new Date(2014, 6, 2, 12, 20, 0),\n\t *   new Date(2014, 6, 2, 12, 7, 59)\n\t * )\n\t * //=> 12\n\t */\n\tfunction differenceInMinutes (dirtyDateLeft, dirtyDateRight) {\n\t  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE\n\t  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)\n\t}\n\n\tmodule.exports = differenceInMinutes\n\n\n/***/ },\n/* 38 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Millisecond Helpers\n\t * @summary Get the number of milliseconds between the given dates.\n\t *\n\t * @description\n\t * Get the number of milliseconds between the given dates.\n\t *\n\t * @param {Date|String|Number} dateLeft - the later date\n\t * @param {Date|String|Number} dateRight - the earlier date\n\t * @returns {Number} the number of milliseconds\n\t *\n\t * @example\n\t * // How many milliseconds are between\n\t * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?\n\t * var result = differenceInMilliseconds(\n\t *   new Date(2014, 6, 2, 12, 30, 21, 700),\n\t *   new Date(2014, 6, 2, 12, 30, 20, 600)\n\t * )\n\t * //=> 1100\n\t */\n\tfunction differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {\n\t  var dateLeft = parse(dirtyDateLeft)\n\t  var dateRight = parse(dirtyDateRight)\n\t  return dateLeft.getTime() - dateRight.getTime()\n\t}\n\n\tmodule.exports = differenceInMilliseconds\n\n\n/***/ },\n/* 39 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar differenceInMilliseconds = __webpack_require__(38)\n\n\t/**\n\t * @category Second Helpers\n\t * @summary Get the number of seconds between the given dates.\n\t *\n\t * @description\n\t * Get the number of seconds between the given dates.\n\t *\n\t * @param {Date|String|Number} dateLeft - the later date\n\t * @param {Date|String|Number} dateRight - the earlier date\n\t * @returns {Number} the number of seconds\n\t *\n\t * @example\n\t * // How many seconds are between\n\t * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?\n\t * var result = differenceInSeconds(\n\t *   new Date(2014, 6, 2, 12, 30, 20, 0),\n\t *   new Date(2014, 6, 2, 12, 30, 7, 999)\n\t * )\n\t * //=> 12\n\t */\n\tfunction differenceInSeconds (dirtyDateLeft, dirtyDateRight) {\n\t  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000\n\t  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)\n\t}\n\n\tmodule.exports = differenceInSeconds\n\n\n/***/ },\n/* 40 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Day Helpers\n\t * @summary Return the end of a day for the given date.\n\t *\n\t * @description\n\t * Return the end of a day for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @returns {Date} the end of a day\n\t *\n\t * @example\n\t * // The end of a day for 2 September 2014 11:55:00:\n\t * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))\n\t * //=> Tue Sep 02 2014 23:59:59.999\n\t */\n\tfunction endOfDay (dirtyDate) {\n\t  var date = parse(dirtyDate)\n\t  date.setHours(23, 59, 59, 999)\n\t  return date\n\t}\n\n\tmodule.exports = endOfDay\n\n\n/***/ },\n/* 41 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Month Helpers\n\t * @summary Return the end of a month for the given date.\n\t *\n\t * @description\n\t * Return the end of a month for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @returns {Date} the end of a month\n\t *\n\t * @example\n\t * // The end of a month for 2 September 2014 11:55:00:\n\t * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))\n\t * //=> Tue Sep 30 2014 23:59:59.999\n\t */\n\tfunction endOfMonth (dirtyDate) {\n\t  var date = parse(dirtyDate)\n\t  var month = date.getMonth()\n\t  date.setFullYear(date.getFullYear(), month + 1, 0)\n\t  date.setHours(23, 59, 59, 999)\n\t  return date\n\t}\n\n\tmodule.exports = endOfMonth\n\n\n/***/ },\n/* 42 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Week Helpers\n\t * @summary Return the end of a week for the given date.\n\t *\n\t * @description\n\t * Return the end of a week for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @param {Object} [options] - the object with options\n\t * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)\n\t * @returns {Date} the end of a week\n\t *\n\t * @example\n\t * // The end of a week for 2 September 2014 11:55:00:\n\t * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))\n\t * //=> Sat Sep 06 2014 23:59:59.999\n\t *\n\t * @example\n\t * // If week starts at Monday, the end of a week for 2 September 2014 11:55:00:\n\t * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})\n\t * //=> Sun Sep 07 2014 23:59:59.999\n\t */\n\tfunction endOfWeek (dirtyDate, options) {\n\t  var weekStartsOn = options ? (options.weekStartsOn || 0) : 0\n\n\t  var date = parse(dirtyDate)\n\t  var day = date.getDay()\n\t  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)\n\n\t  date.setDate(date.getDate() + diff)\n\t  date.setHours(23, 59, 59, 999)\n\t  return date\n\t}\n\n\tmodule.exports = endOfWeek\n\n\n/***/ },\n/* 43 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Weekday Helpers\n\t * @summary Get the day of the week of the given date.\n\t *\n\t * @description\n\t * Get the day of the week of the given date.\n\t *\n\t * @param {Date|String|Number} date - the given date\n\t * @returns {Number} the day of week\n\t *\n\t * @example\n\t * // Which day of the week is 29 February 2012?\n\t * var result = getDay(new Date(2012, 1, 29))\n\t * //=> 3\n\t */\n\tfunction getDay (dirtyDate) {\n\t  var date = parse(dirtyDate)\n\t  var day = date.getDay()\n\t  return day\n\t}\n\n\tmodule.exports = getDay\n\n\n/***/ },\n/* 44 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar startOfDay = __webpack_require__(35)\n\n\t/**\n\t * @category Day Helpers\n\t * @summary Are the given dates in the same day?\n\t *\n\t * @description\n\t * Are the given dates in the same day?\n\t *\n\t * @param {Date|String|Number} dateLeft - the first date to check\n\t * @param {Date|String|Number} dateRight - the second date to check\n\t * @returns {Boolean} the dates are in the same day\n\t *\n\t * @example\n\t * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?\n\t * var result = isSameDay(\n\t *   new Date(2014, 8, 4, 6, 0),\n\t *   new Date(2014, 8, 4, 18, 0)\n\t * )\n\t * //=> true\n\t */\n\tfunction isSameDay (dirtyDateLeft, dirtyDateRight) {\n\t  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)\n\t  var dateRightStartOfDay = startOfDay(dirtyDateRight)\n\n\t  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()\n\t}\n\n\tmodule.exports = isSameDay\n\n\n/***/ },\n/* 45 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Month Helpers\n\t * @summary Are the given dates in the same month?\n\t *\n\t * @description\n\t * Are the given dates in the same month?\n\t *\n\t * @param {Date|String|Number} dateLeft - the first date to check\n\t * @param {Date|String|Number} dateRight - the second date to check\n\t * @returns {Boolean} the dates are in the same month\n\t *\n\t * @example\n\t * // Are 2 September 2014 and 25 September 2014 in the same month?\n\t * var result = isSameMonth(\n\t *   new Date(2014, 8, 2),\n\t *   new Date(2014, 8, 25)\n\t * )\n\t * //=> true\n\t */\n\tfunction isSameMonth (dirtyDateLeft, dirtyDateRight) {\n\t  var dateLeft = parse(dirtyDateLeft)\n\t  var dateRight = parse(dirtyDateRight)\n\t  return dateLeft.getFullYear() === dateRight.getFullYear() &&\n\t    dateLeft.getMonth() === dateRight.getMonth()\n\t}\n\n\tmodule.exports = isSameMonth\n\n\n/***/ },\n/* 46 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar startOfSecond = __webpack_require__(47)\n\n\t/**\n\t * @category Second Helpers\n\t * @summary Are the given dates in the same second?\n\t *\n\t * @description\n\t * Are the given dates in the same second?\n\t *\n\t * @param {Date|String|Number} dateLeft - the first date to check\n\t * @param {Date|String|Number} dateRight - the second date to check\n\t * @returns {Boolean} the dates are in the same second\n\t *\n\t * @example\n\t * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500\n\t * // in the same second?\n\t * var result = isSameSecond(\n\t *   new Date(2014, 8, 4, 6, 30, 15),\n\t *   new Date(2014, 8, 4, 6, 30, 15, 500)\n\t * )\n\t * //=> true\n\t */\n\tfunction isSameSecond (dirtyDateLeft, dirtyDateRight) {\n\t  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)\n\t  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)\n\n\t  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()\n\t}\n\n\tmodule.exports = isSameSecond\n\n\n/***/ },\n/* 47 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Second Helpers\n\t * @summary Return the start of a second for the given date.\n\t *\n\t * @description\n\t * Return the start of a second for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @returns {Date} the start of a second\n\t *\n\t * @example\n\t * // The start of a second for 1 December 2014 22:15:45.400:\n\t * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))\n\t * //=> Mon Dec 01 2014 22:15:45.000\n\t */\n\tfunction startOfSecond (dirtyDate) {\n\t  var date = parse(dirtyDate)\n\t  date.setMilliseconds(0)\n\t  return date\n\t}\n\n\tmodule.exports = startOfSecond\n\n\n/***/ },\n/* 48 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Hour Helpers\n\t * @summary Set the hours to the given date.\n\t *\n\t * @description\n\t * Set the hours to the given date.\n\t *\n\t * @param {Date|String|Number} date - the date to be changed\n\t * @param {Number} hours - the hours of the new date\n\t * @returns {Date} the new date with the hours setted\n\t *\n\t * @example\n\t * // Set 4 hours to 1 September 2014 11:30:00:\n\t * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)\n\t * //=> Mon Sep 01 2014 04:30:00\n\t */\n\tfunction setHours (dirtyDate, hours) {\n\t  var date = parse(dirtyDate)\n\t  date.setHours(hours)\n\t  return date\n\t}\n\n\tmodule.exports = setHours\n\n\n/***/ },\n/* 49 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Minute Helpers\n\t * @summary Set the minutes to the given date.\n\t *\n\t * @description\n\t * Set the minutes to the given date.\n\t *\n\t * @param {Date|String|Number} date - the date to be changed\n\t * @param {Number} minutes - the minutes of the new date\n\t * @returns {Date} the new date with the minutes setted\n\t *\n\t * @example\n\t * // Set 45 minutes to 1 September 2014 11:30:40:\n\t * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)\n\t * //=> Mon Sep 01 2014 11:45:40\n\t */\n\tfunction setMinutes (dirtyDate, minutes) {\n\t  var date = parse(dirtyDate)\n\t  date.setMinutes(minutes)\n\t  return date\n\t}\n\n\tmodule.exports = setMinutes\n\n\n/***/ },\n/* 50 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Minute Helpers\n\t * @summary Return the start of a minute for the given date.\n\t *\n\t * @description\n\t * Return the start of a minute for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @returns {Date} the start of a minute\n\t *\n\t * @example\n\t * // The start of a minute for 1 December 2014 22:15:45.400:\n\t * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))\n\t * //=> Mon Dec 01 2014 22:15:00\n\t */\n\tfunction startOfMinute (dirtyDate) {\n\t  var date = parse(dirtyDate)\n\t  date.setSeconds(0, 0)\n\t  return date\n\t}\n\n\tmodule.exports = startOfMinute\n\n\n/***/ },\n/* 51 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Month Helpers\n\t * @summary Return the start of a month for the given date.\n\t *\n\t * @description\n\t * Return the start of a month for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @returns {Date} the start of a month\n\t *\n\t * @example\n\t * // The start of a month for 2 September 2014 11:55:00:\n\t * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))\n\t * //=> Mon Sep 01 2014 00:00:00\n\t */\n\tfunction startOfMonth (dirtyDate) {\n\t  var date = parse(dirtyDate)\n\t  date.setDate(1)\n\t  date.setHours(0, 0, 0, 0)\n\t  return date\n\t}\n\n\tmodule.exports = startOfMonth\n\n\n/***/ },\n/* 52 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar parse = __webpack_require__(29)\n\n\t/**\n\t * @category Week Helpers\n\t * @summary Return the start of a week for the given date.\n\t *\n\t * @description\n\t * Return the start of a week for the given date.\n\t * The result will be in the local timezone.\n\t *\n\t * @param {Date|String|Number} date - the original date\n\t * @param {Object} [options] - the object with options\n\t * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)\n\t * @returns {Date} the start of a week\n\t *\n\t * @example\n\t * // The start of a week for 2 September 2014 11:55:00:\n\t * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))\n\t * //=> Sun Aug 31 2014 00:00:00\n\t *\n\t * @example\n\t * // If week starts at Monday, the start of a week for 2 September 2014 11:55:00:\n\t * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})\n\t * //=> Mon Sep 01 2014 00:00:00\n\t */\n\tfunction startOfWeek (dirtyDate, options) {\n\t  var weekStartsOn = options ? (options.weekStartsOn || 0) : 0\n\n\t  var date = parse(dirtyDate)\n\t  var day = date.getDay()\n\t  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn\n\n\t  date.setDate(date.getDate() - diff)\n\t  date.setHours(0, 0, 0, 0)\n\t  return date\n\t}\n\n\tmodule.exports = startOfWeek\n\n\n/***/ },\n/* 53 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCalendarMonthCtrl', [\"$scope\", \"moment\", \"calendarHelper\", \"calendarConfig\", \"calendarEventTitle\", function($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {\n\n\t    var vm = this;\n\t    vm.calendarConfig = calendarConfig;\n\t    vm.calendarEventTitle = calendarEventTitle;\n\t    vm.openRowIndex = null;\n\n\t    function toggleCell() {\n\t      vm.openRowIndex = null;\n\t      vm.openDayIndex = null;\n\n\t      if (vm.cellIsOpen && vm.view) {\n\t        vm.view.forEach(function(day, dayIndex) {\n\t          if (moment(vm.viewDate).startOf('day').isSame(day.date)) {\n\t            vm.openDayIndex = dayIndex;\n\t            vm.openRowIndex = Math.floor(dayIndex / 7);\n\t          }\n\t        });\n\t      }\n\t    }\n\n\t    $scope.$on('calendar.refreshView', function() {\n\n\t      vm.weekDays = calendarHelper.getWeekDayNames();\n\n\t      var monthView = calendarHelper.getMonthView(vm.events, vm.viewDate, vm.cellModifier);\n\t      vm.view = monthView.days;\n\t      vm.monthOffsets = monthView.rowOffsets;\n\n\t      if (vm.cellAutoOpenDisabled) {\n\t        toggleCell();\n\t      } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openRowIndex === null) {\n\t        //Auto open the calendar to the current day if set\n\t        vm.openDayIndex = null;\n\t        vm.view.forEach(function(day) {\n\t          if (day.inMonth && moment(vm.viewDate).startOf('day').isSame(day.date)) {\n\t            vm.dayClicked(day, true);\n\t          }\n\t        });\n\t      }\n\n\t    });\n\n\t    if (vm.cellAutoOpenDisabled) {\n\t      $scope.$watchGroup([\n\t        'vm.cellIsOpen',\n\t        'vm.viewDate'\n\t      ], toggleCell);\n\t    }\n\n\t    vm.dayClicked = function(day, dayClickedFirstRun, $event) {\n\n\t      if (!dayClickedFirstRun) {\n\t        vm.onTimespanClick({\n\t          calendarDate: day.date.toDate(),\n\t          calendarCell: day,\n\t          $event: $event\n\t        });\n\t        if ($event && $event.defaultPrevented) {\n\t          return;\n\t        }\n\t      }\n\n\t      if (!vm.cellAutoOpenDisabled) {\n\t        vm.openRowIndex = null;\n\t        var dayIndex = vm.view.indexOf(day);\n\t        if (dayIndex === vm.openDayIndex) { //the day has been clicked and is already open\n\t          vm.openDayIndex = null; //close the open day\n\t          vm.cellIsOpen = false;\n\t        } else {\n\t          vm.openDayIndex = dayIndex;\n\t          vm.openRowIndex = Math.floor(dayIndex / 7);\n\t          vm.cellIsOpen = true;\n\t        }\n\t      }\n\n\t    };\n\n\t    vm.highlightEvent = function(event, shouldAddClass) {\n\n\t      vm.view.forEach(function(day) {\n\t        delete day.highlightClass;\n\t        delete day.backgroundColor;\n\t        if (shouldAddClass) {\n\t          var dayContainsEvent = day.events.indexOf(event) > -1;\n\t          if (dayContainsEvent) {\n\t            day.backgroundColor = event.color ? event.color.secondary : '';\n\t          }\n\t        }\n\t      });\n\n\t    };\n\n\t    vm.handleEventDrop = function(event, newDayDate, draggedFromDate) {\n\n\t      var newStart = moment(event.startsAt)\n\t        .date(moment(newDayDate).date())\n\t        .month(moment(newDayDate).month())\n\t        .year(moment(newDayDate).year());\n\n\t      var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);\n\n\t      vm.onEventTimesChanged({\n\t        calendarEvent: event,\n\t        calendarDate: newDayDate,\n\t        calendarNewEventStart: newStart.toDate(),\n\t        calendarNewEventEnd: newEnd ? newEnd.toDate() : null,\n\t        calendarDraggedFromDate: draggedFromDate\n\t      });\n\t    };\n\n\t    vm.getWeekNumberLabel = function(day) {\n\t      var weekNumber = day.date.clone().add(1, 'day').isoWeek();\n\t      if (typeof calendarConfig.i18nStrings.weekNumber === 'function') {\n\t        return calendarConfig.i18nStrings.weekNumber({weekNumber: weekNumber});\n\t      } else {\n\t        return calendarConfig.i18nStrings.weekNumber.replace('{week}', weekNumber);\n\t      }\n\t    };\n\n\t    vm.onDragSelectStart = function(day) {\n\t      if (!vm.dateRangeSelect) {\n\t        vm.dateRangeSelect = {\n\t          startDate: day.date,\n\t          endDate: day.date\n\t        };\n\t      }\n\t    };\n\n\t    vm.onDragSelectMove = function(day) {\n\t      if (vm.dateRangeSelect) {\n\t        vm.dateRangeSelect.endDate = day.date;\n\t      }\n\t    };\n\n\t    vm.onDragSelectEnd = function(day) {\n\t      vm.dateRangeSelect.endDate = day.date;\n\t      if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {\n\t        vm.onDateRangeSelect({\n\t          calendarRangeStartDate: vm.dateRangeSelect.startDate.clone().startOf('day').toDate(),\n\t          calendarRangeEndDate: vm.dateRangeSelect.endDate.clone().endOf('day').toDate()\n\t        });\n\t      }\n\t      delete vm.dateRangeSelect;\n\t    };\n\n\t  }])\n\t  .directive('mwlCalendarMonth', function() {\n\n\t    return {\n\t      template: '<div mwl-dynamic-directive-template name=\"calendarMonthView\" overrides=\"vm.customTemplateUrls\"></div>',\n\t      restrict: 'E',\n\t      require: '^mwlCalendar',\n\t      scope: {\n\t        events: '=',\n\t        viewDate: '=',\n\t        onEventClick: '=',\n\t        onEventTimesChanged: '=',\n\t        onDateRangeSelect: '=',\n\t        cellIsOpen: '=',\n\t        cellAutoOpenDisabled: '=',\n\t        onTimespanClick: '=',\n\t        cellModifier: '=',\n\t        slideBoxDisabled: '=',\n\t        customTemplateUrls: '=?',\n\t        templateScope: '=',\n\t      },\n\t      controller: 'MwlCalendarMonthCtrl as vm',\n\t      link: function(scope, element, attrs, calendarCtrl) {\n\t        scope.vm.calendarCtrl = calendarCtrl;\n\t      },\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 54 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCalendarSlideBoxCtrl', [\"$scope\", \"$timeout\", \"calendarConfig\", \"calendarEventTitle\", function($scope, $timeout, calendarConfig, calendarEventTitle) {\n\n\t    var vm = this;\n\t    vm.calendarConfig = calendarConfig;\n\t    vm.calendarEventTitle = calendarEventTitle;\n\n\t    vm.isCollapsed = true;\n\t    $scope.$watch('vm.isOpen', function(isOpen) {\n\t      //events must be populated first to set the element height before animation will work\n\t      $timeout(function() {\n\t        vm.isCollapsed = !isOpen;\n\t      });\n\t    });\n\n\t  }])\n\t  .directive('mwlCalendarSlideBox', function() {\n\n\t    return {\n\t      restrict: 'E',\n\t      template: '<div mwl-dynamic-directive-template name=\"calendarSlideBox\" overrides=\"vm.customTemplateUrls\"></div>',\n\t      replace: true,\n\t      controller: 'MwlCalendarSlideBoxCtrl as vm',\n\t      require: ['^?mwlCalendarMonth', '^?mwlCalendarYear'],\n\t      link: function(scope, elm, attrs, ctrls) {\n\t        scope.isMonthView = !!ctrls[0];\n\t        scope.isYearView = !!ctrls[1];\n\t      },\n\t      scope: {\n\t        isOpen: '=',\n\t        events: '=',\n\t        onEventClick: '=',\n\t        cell: '=',\n\t        customTemplateUrls: '=?',\n\t        templateScope: '='\n\t      },\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 55 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCalendarWeekCtrl', [\"$scope\", \"moment\", \"calendarHelper\", \"calendarConfig\", \"calendarEventTitle\", function($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {\n\n\t    var vm = this;\n\n\t    vm.showTimes = calendarConfig.showTimesOnWeekView;\n\t    vm.calendarEventTitle = calendarEventTitle;\n\n\t    $scope.$on('calendar.refreshView', function() {\n\t      vm.dayViewSplit = vm.dayViewSplit || 30;\n\t      vm.dayViewHeight = calendarHelper.getDayViewHeight(\n\t        vm.dayViewStart,\n\t        vm.dayViewEnd,\n\t        vm.dayViewSplit\n\t      );\n\t      if (vm.showTimes) {\n\t        vm.view = calendarHelper.getWeekViewWithTimes(\n\t          vm.events,\n\t          vm.viewDate,\n\t          vm.dayViewStart,\n\t          vm.dayViewEnd,\n\t          vm.dayViewSplit\n\t        );\n\t      } else {\n\t        vm.view = calendarHelper.getWeekView(vm.events, vm.viewDate);\n\t      }\n\t    });\n\n\t    vm.weekDragged = function(event, daysDiff, minuteChunksMoved) {\n\n\t      var newStart = moment(event.startsAt).add(daysDiff, 'days');\n\t      var newEnd = moment(event.endsAt).add(daysDiff, 'days');\n\n\t      if (minuteChunksMoved) {\n\t        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;\n\t        newStart = newStart.add(minutesDiff, 'minutes');\n\t        newEnd = newEnd.add(minutesDiff, 'minutes');\n\t      }\n\n\t      delete event.tempStartsAt;\n\n\t      vm.onEventTimesChanged({\n\t        calendarEvent: event,\n\t        calendarNewEventStart: newStart.toDate(),\n\t        calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null\n\t      });\n\t    };\n\n\t    vm.eventDropped = function(event, date) {\n\t      var daysDiff = moment(date).diff(moment(event.startsAt), 'days');\n\t      vm.weekDragged(event, daysDiff);\n\t    };\n\n\t    vm.weekResized = function(event, edge, daysDiff) {\n\n\t      var start = moment(event.startsAt);\n\t      var end = moment(event.endsAt);\n\t      if (edge === 'start') {\n\t        start.add(daysDiff, 'days');\n\t      } else {\n\t        end.add(daysDiff, 'days');\n\t      }\n\n\t      vm.onEventTimesChanged({\n\t        calendarEvent: event,\n\t        calendarNewEventStart: start.toDate(),\n\t        calendarNewEventEnd: end.toDate()\n\t      });\n\n\t    };\n\n\t    vm.tempTimeChanged = function(event, minuteChunksMoved) {\n\t      var minutesDiff = minuteChunksMoved * vm.dayViewSplit;\n\t      event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();\n\t    };\n\n\t  }])\n\t  .directive('mwlCalendarWeek', function() {\n\n\t    return {\n\t      template: '<div mwl-dynamic-directive-template name=\"calendarWeekView\" overrides=\"vm.customTemplateUrls\"></div>',\n\t      restrict: 'E',\n\t      require: '^mwlCalendar',\n\t      scope: {\n\t        events: '=',\n\t        viewDate: '=',\n\t        onEventClick: '=',\n\t        onEventTimesChanged: '=',\n\t        dayViewStart: '=',\n\t        dayViewEnd: '=',\n\t        dayViewSplit: '=',\n\t        dayViewEventChunkSize: '=',\n\t        onTimespanClick: '=',\n\t        onDateRangeSelect: '=',\n\t        customTemplateUrls: '=?',\n\t        cellModifier: '=',\n\t        templateScope: '='\n\t      },\n\t      controller: 'MwlCalendarWeekCtrl as vm',\n\t      link: function(scope, element, attrs, calendarCtrl) {\n\t        scope.vm.calendarCtrl = calendarCtrl;\n\t      },\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 56 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCalendarYearCtrl', [\"$scope\", \"moment\", \"calendarHelper\", function($scope, moment, calendarHelper) {\n\n\t    var vm = this;\n\t    vm.openMonthIndex = null;\n\n\t    function toggleCell() {\n\t      vm.openRowIndex = null;\n\t      vm.openMonthIndex = null;\n\n\t      if (vm.cellIsOpen && vm.view) {\n\t        vm.view.forEach(function(month, monthIndex) {\n\t          if (moment(vm.viewDate).startOf('month').isSame(month.date)) {\n\t            vm.openMonthIndex = monthIndex;\n\t            vm.openRowIndex = Math.floor(monthIndex / 4);\n\t          }\n\t        });\n\t      }\n\t    }\n\n\t    $scope.$on('calendar.refreshView', function() {\n\t      vm.view = calendarHelper.getYearView(vm.events, vm.viewDate, vm.cellModifier);\n\n\t      if (vm.cellAutoOpenDisabled) {\n\t        toggleCell();\n\t      } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openMonthIndex === null) {\n\t        //Auto open the calendar to the current day if set\n\t        vm.openMonthIndex = null;\n\t        vm.view.forEach(function(month) {\n\t          if (moment(vm.viewDate).startOf('month').isSame(month.date)) {\n\t            vm.monthClicked(month, true);\n\t          }\n\t        });\n\t      }\n\n\t    });\n\n\t    if (vm.cellAutoOpenDisabled) {\n\t      $scope.$watchGroup([\n\t        'vm.cellIsOpen',\n\t        'vm.viewDate'\n\t      ], toggleCell);\n\t    }\n\n\t    vm.monthClicked = function(month, monthClickedFirstRun, $event) {\n\n\t      if (!monthClickedFirstRun) {\n\t        vm.onTimespanClick({\n\t          calendarDate: month.date.toDate(),\n\t          calendarCell: month,\n\t          $event: $event\n\t        });\n\t        if ($event && $event.defaultPrevented) {\n\t          return;\n\t        }\n\t      }\n\n\t      if (!vm.cellAutoOpenDisabled) {\n\t        vm.openRowIndex = null;\n\t        var monthIndex = vm.view.indexOf(month);\n\t        if (monthIndex === vm.openMonthIndex) { //the month has been clicked and is already open\n\t          vm.openMonthIndex = null; //close the open month\n\t          vm.cellIsOpen = false;\n\t        } else {\n\t          vm.openMonthIndex = monthIndex;\n\t          vm.openRowIndex = Math.floor(monthIndex / 4);\n\t          vm.cellIsOpen = true;\n\t        }\n\t      }\n\n\t    };\n\n\t    vm.handleEventDrop = function(event, newMonthDate) {\n\t      var newStart = moment(event.startsAt)\n\t        .month(moment(newMonthDate).month())\n\t        .year(moment(newMonthDate).year());\n\t      var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);\n\n\t      vm.onEventTimesChanged({\n\t        calendarEvent: event,\n\t        calendarDate: newMonthDate,\n\t        calendarNewEventStart: newStart.toDate(),\n\t        calendarNewEventEnd: newEnd ? newEnd.toDate() : null\n\t      });\n\t    };\n\n\t  }])\n\t  .directive('mwlCalendarYear', function() {\n\n\t    return {\n\t      template: '<div mwl-dynamic-directive-template name=\"calendarYearView\" overrides=\"vm.customTemplateUrls\"></div>',\n\t      restrict: 'E',\n\t      require: '^mwlCalendar',\n\t      scope: {\n\t        events: '=',\n\t        viewDate: '=',\n\t        onEventClick: '=',\n\t        onEventTimesChanged: '=',\n\t        cellIsOpen: '=',\n\t        cellAutoOpenDisabled: '=',\n\t        onTimespanClick: '=',\n\t        cellModifier: '=',\n\t        slideBoxDisabled: '=',\n\t        customTemplateUrls: '=?',\n\t        templateScope: '='\n\t      },\n\t      controller: 'MwlCalendarYearCtrl as vm',\n\t      link: function(scope, element, attrs, calendarCtrl) {\n\t        scope.vm.calendarCtrl = calendarCtrl;\n\t      },\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 57 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlCollapseFallbackCtrl', [\"$scope\", \"$attrs\", \"$element\", function($scope, $attrs, $element) {\n\n\t    $scope.$watch($attrs.mwlCollapseFallback, function(shouldCollapse) {\n\t      if (shouldCollapse) {\n\t        $element.addClass('ng-hide');\n\t      } else {\n\t        $element.removeClass('ng-hide');\n\t      }\n\t    });\n\n\t  }])\n\t  .directive('mwlCollapseFallback', [\"$injector\", function($injector) {\n\n\t    if ($injector.has('uibCollapseDirective')) {\n\t      return {};\n\t    }\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlCollapseFallbackCtrl'\n\t    };\n\n\t  }]);\n\n\n/***/ },\n/* 58 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlDateModifierCtrl', [\"$element\", \"$attrs\", \"$scope\", \"moment\", function($element, $attrs, $scope, moment) {\n\n\t    var vm = this;\n\n\t    function onClick() {\n\t      if (angular.isDefined($attrs.setToToday)) {\n\t        vm.date = new Date();\n\t      } else if (angular.isDefined($attrs.increment)) {\n\t        vm.date = moment(vm.date).add(1, vm.increment).toDate();\n\t      } else if (angular.isDefined($attrs.decrement)) {\n\t        vm.date = moment(vm.date).subtract(1, vm.decrement).toDate();\n\t      }\n\t      $scope.$apply();\n\t    }\n\n\t    $element.bind('click', onClick);\n\n\t    $scope.$on('$destroy', function() {\n\t      $element.unbind('click', onClick);\n\t    });\n\n\t  }])\n\t  .directive('mwlDateModifier', function() {\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlDateModifierCtrl as vm',\n\t      scope: {\n\t        date: '=',\n\t        increment: '=',\n\t        decrement: '='\n\t      },\n\t      bindToController: true\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 59 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlDragSelectCtrl', [\"$scope\", \"$element\", \"$parse\", \"$attrs\", function($scope, $element, $parse, $attrs) {\n\n\t    function handleMouseEvent(callbackName) {\n\t      return function(event) {\n\t        if (callbackName) {\n\t          $parse(callbackName)($scope);\n\t          $scope.$apply();\n\t        }\n\t        event.preventDefault();\n\t      };\n\t    }\n\n\t    var onMouseDown = handleMouseEvent($attrs.onDragSelectStart);\n\t    var onMouseMove = handleMouseEvent($attrs.onDragSelectMove);\n\t    var onMouseUp = handleMouseEvent($attrs.onDragSelectEnd);\n\n\t    function enableMouseListeners() {\n\t      $element.on('mousedown', onMouseDown);\n\t      $element.on('mousemove', onMouseMove);\n\t      $element.on('mouseup', onMouseUp);\n\t    }\n\n\t    function disableMouseListeners() {\n\t      $element.off('mousedown', onMouseDown);\n\t      $element.off('mousemove', onMouseMove);\n\t      $element.off('mouseup', onMouseUp);\n\t    }\n\n\t    $scope.$watch($attrs.mwlDragSelect, function(isEnabled) {\n\t      if (isEnabled) {\n\t        enableMouseListeners();\n\t      } else {\n\t        disableMouseListeners();\n\t      }\n\t    });\n\n\t    $scope.$on('$destroy', function() {\n\t      disableMouseListeners();\n\t    });\n\n\t  }])\n\t  .directive('mwlDragSelect', function() {\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlDragSelectCtrl'\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 60 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlDraggableCtrl', [\"$element\", \"$scope\", \"$window\", \"$parse\", \"$attrs\", \"$timeout\", \"interact\", function($element, $scope, $window, $parse, $attrs, $timeout, interact) {\n\n\t    if (!interact) {\n\t      return;\n\t    }\n\n\t    var snap, snapGridDimensions;\n\t    if ($attrs.snapGrid) {\n\t      snapGridDimensions = $parse($attrs.snapGrid)($scope);\n\t      snap = {\n\t        targets: [\n\t          interact.createSnapGrid(snapGridDimensions)\n\t        ]\n\t      };\n\t    }\n\n\t    function translateElement(elm, transformValue) {\n\t      return elm\n\t        .css('-ms-transform', transformValue)\n\t        .css('-webkit-transform', transformValue)\n\t        .css('transform', transformValue);\n\t    }\n\n\t    interact($element[0]).draggable({\n\t      snap: snap,\n\t      onstart: function(event) {\n\t        angular.element(event.target).addClass('dragging-active');\n\t        event.target.dropData = $parse($attrs.dropData)($scope);\n\t        event.target.style.pointerEvents = 'none';\n\t        if ($attrs.onDragStart) {\n\t          $parse($attrs.onDragStart)($scope);\n\t          $scope.$apply();\n\t        }\n\t      },\n\t      onmove: function(event) {\n\n\t        var elm = angular.element(event.target);\n\t        var x = (parseFloat(elm.attr('data-x')) || 0) + (event.dx || 0);\n\t        var y = (parseFloat(elm.attr('data-y')) || 0) + (event.dy || 0);\n\n\t        switch ($parse($attrs.axis)($scope)) {\n\t          case 'x':\n\t            y = 0;\n\t            break;\n\n\t          case 'y':\n\t            x = 0;\n\t            break;\n\n\t          default:\n\t        }\n\n\t        if ($window.getComputedStyle(elm[0]).position === 'static') {\n\t          elm.css('position', 'relative');\n\t        }\n\n\t        translateElement(elm, 'translate(' + x + 'px, ' + y + 'px)')\n\t          .css('z-index', 50)\n\t          .attr('data-x', x)\n\t          .attr('data-y', y);\n\n\t        if ($attrs.onDrag) {\n\t          $parse($attrs.onDrag)($scope, {x: x, y: y});\n\t          $scope.$apply();\n\t        }\n\n\t      },\n\t      onend: function(event) {\n\n\t        var elm = angular.element(event.target);\n\t        var x = elm.attr('data-x');\n\t        var y = elm.attr('data-y');\n\n\t        event.target.style.pointerEvents = 'auto';\n\t        if ($attrs.onDragEnd) {\n\t          $parse($attrs.onDragEnd)($scope, {x: x, y: y});\n\t          $scope.$apply();\n\t        }\n\n\t        $timeout(function() {\n\t          translateElement(elm, '')\n\t            .css('z-index', 'auto')\n\t            .removeAttr('data-x')\n\t            .removeAttr('data-y')\n\t            .removeClass('dragging-active');\n\t        });\n\n\t      }\n\t    });\n\n\t    $scope.$watch($attrs.mwlDraggable, function(enabled) {\n\t      interact($element[0]).draggable({\n\t        enabled: enabled\n\t      });\n\t    });\n\n\t    $scope.$on('$destroy', function() {\n\t      interact($element[0]).unset();\n\t    });\n\n\t  }])\n\t  .directive('mwlDraggable', function() {\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlDraggableCtrl'\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 61 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlDroppableCtrl', [\"$element\", \"$scope\", \"$parse\", \"$attrs\", \"interact\", function($element, $scope, $parse, $attrs, interact) {\n\n\t    if (!interact) {\n\t      return;\n\t    }\n\n\t    var DROP_ACTIVE_CLASS = $attrs.dropActiveClass || 'drop-active';\n\n\t    interact($element[0]).dropzone({\n\t      ondragenter: function(event) {\n\t        angular.element(event.target).addClass(DROP_ACTIVE_CLASS);\n\t      },\n\t      ondragleave: function(event) {\n\t        angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);\n\t      },\n\t      ondropdeactivate: function(event) {\n\t        angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);\n\t      },\n\t      ondrop: function(event) {\n\t        if (event.relatedTarget.dropData) {\n\t          $parse($attrs.onDrop)($scope, {dropData: event.relatedTarget.dropData});\n\t          $scope.$apply();\n\t        }\n\t      }\n\t    });\n\n\t    $scope.$on('$destroy', function() {\n\t      interact($element[0]).unset();\n\t    });\n\n\t  }])\n\t  .directive('mwlDroppable', function() {\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlDroppableCtrl'\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 62 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlDynamicDirectiveTemplateCtrl', [\"$compile\", \"$scope\", \"$attrs\", \"$element\", \"$templateCache\", \"$log\", \"calendarConfig\", function($compile, $scope, $attrs, $element, $templateCache, $log, calendarConfig) {\n\n\t    $scope.$watch($attrs.overrides, function(overrides) {\n\n\t      var templateName = calendarConfig.templates[$attrs.name];\n\t      if (\n\t        overrides &&\n\t        angular.isObject(overrides) &&\n\t        overrides[$attrs.name]\n\t      ) {\n\t        if ($templateCache.get(overrides[$attrs.name])) {\n\t          templateName = overrides[$attrs.name];\n\t        } else {\n\t          $log.warn('Bootstrap Calendar', 'The custom template for ' + overrides[$attrs.name] +\n\t            ' was not found in the template cache. Please ensure it is pre-loaded via a script tag ' +\n\t            '<script type=\"text/ng-template\" id=\"' + overrides[$attrs.name] + '\">Custom template content</script> or ' +\n\t            'via a tool such as https://www.npmjs.com/package/gulp-angular-templatecache');\n\t        }\n\t      }\n\t      var template = $templateCache.get(templateName);\n\t      $element.html(template);\n\t      $compile($element.contents())($scope);\n\n\t    });\n\n\t  }])\n\t  .directive('mwlDynamicDirectiveTemplate', function() {\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlDynamicDirectiveTemplateCtrl'\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 63 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlElementDimensionsCtrl', [\"$element\", \"$scope\", \"$parse\", \"$attrs\", \"$window\", function($element, $scope, $parse, $attrs, $window) {\n\n\t    function setDimensions() {\n\t      $parse($attrs.mwlElementDimensions).assign($scope, {\n\t        width: $element[0].offsetWidth,\n\t        height: $element[0].offsetHeight\n\t      });\n\t      $scope.$applyAsync();\n\t    }\n\n\t    var win = angular.element($window);\n\n\t    win.bind('resize', setDimensions);\n\n\t    setDimensions();\n\n\t    $scope.$on('$destroy', function() {\n\t      win.unbind('resize', setDimensions);\n\t    });\n\n\t  }])\n\t  .directive('mwlElementDimensions', function() {\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlElementDimensionsCtrl'\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 64 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .controller('MwlResizableCtrl', [\"$element\", \"$scope\", \"$parse\", \"$attrs\", \"$timeout\", \"interact\", function($element, $scope, $parse, $attrs, $timeout, interact) {\n\n\t    if (!interact) {\n\t      return;\n\t    }\n\n\t    var snap, snapGridDimensions;\n\t    if ($attrs.snapGrid) {\n\t      snapGridDimensions = $parse($attrs.snapGrid)($scope);\n\t      snap = {\n\t        targets: [\n\t          interact.createSnapGrid(snapGridDimensions)\n\t        ]\n\t      };\n\t    }\n\n\t    var originalDimensions = {};\n\t    var originalDimensionsStyle = {};\n\t    var resizeEdge;\n\n\t    function getUnitsResized(edge, elm) {\n\t      var unitsResized = {};\n\t      unitsResized.edge = edge;\n\t      if (edge === 'start') {\n\t        unitsResized.x = elm.data('x');\n\t        unitsResized.y = elm.data('y');\n\t      } else if (edge === 'end') {\n\t        unitsResized.x = parseFloat(elm.css('width').replace('px', '')) - originalDimensions.width;\n\t        unitsResized.y = parseFloat(elm.css('height').replace('px', '')) - originalDimensions.height;\n\t      }\n\t      return unitsResized;\n\t    }\n\n\t    interact($element[0]).resizable({\n\t      edges: $parse($attrs.resizeEdges)($scope),\n\t      snap: snap,\n\t      onstart: function(event) {\n\n\t        resizeEdge = 'end';\n\t        var elm = angular.element(event.target);\n\t        originalDimensions.height = elm[0].offsetHeight;\n\t        originalDimensions.width = elm[0].offsetWidth;\n\t        originalDimensionsStyle.height = elm.css('height');\n\t        originalDimensionsStyle.width = elm.css('width');\n\n\t      },\n\t      onmove: function(event) {\n\n\t        if (event.rect.width > 0 && event.rect.height > 0) {\n\t          var elm = angular.element(event.target);\n\t          var x = parseFloat(elm.data('x') || 0);\n\t          var y = parseFloat(elm.data('y') || 0);\n\n\t          elm.css({\n\t            width: event.rect.width + 'px',\n\t            height: event.rect.height + 'px'\n\t          });\n\n\t          // translate when resizing from top or left edges\n\t          x += event.deltaRect.left;\n\t          y += event.deltaRect.top;\n\n\t          elm.css('transform', 'translate(' + x + 'px,' + y + 'px)');\n\n\t          elm.data('x', x);\n\t          elm.data('y', y);\n\n\t          if (event.deltaRect.left !== 0 || event.deltaRect.top !== 0) {\n\t            resizeEdge = 'start';\n\t          }\n\n\t          if ($attrs.onResize) {\n\t            $parse($attrs.onResize)($scope, getUnitsResized(resizeEdge, elm));\n\t            $scope.$apply();\n\t          }\n\n\t        }\n\n\t      },\n\t      onend: function(event) {\n\n\t        var elm = angular.element(event.target);\n\t        var unitsResized = getUnitsResized(resizeEdge, elm);\n\n\t        $timeout(function() {\n\t          elm\n\t            .data('x', null)\n\t            .data('y', null)\n\t            .css({\n\t              transform: '',\n\t              width: originalDimensionsStyle.width,\n\t              height: originalDimensionsStyle.height\n\t            });\n\t        });\n\n\t        if ($attrs.onResizeEnd) {\n\t          $parse($attrs.onResizeEnd)($scope, unitsResized);\n\t          $scope.$apply();\n\t        }\n\n\t      }\n\t    });\n\n\t    $scope.$watch($attrs.mwlResizable, function(enabled) {\n\t      interact($element[0]).resizable({\n\t        enabled: enabled\n\t      });\n\t    });\n\n\t    $scope.$on('$destroy', function() {\n\t      interact($element[0]).unset();\n\t    });\n\n\t  }])\n\t  .directive('mwlResizable', function() {\n\n\t    return {\n\t      restrict: 'A',\n\t      controller: 'MwlResizableCtrl'\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 65 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar map = {\n\t\t\"./calendarDate.js\": 66,\n\t\t\"./calendarLimitTo.js\": 67,\n\t\t\"./calendarTruncateEventTitle.js\": 68,\n\t\t\"./calendarTrustAsHtml.js\": 69\n\t};\n\tfunction webpackContext(req) {\n\t\treturn __webpack_require__(webpackContextResolve(req));\n\t};\n\tfunction webpackContextResolve(req) {\n\t\treturn map[req] || (function() { throw new Error(\"Cannot find module '\" + req + \"'.\") }());\n\t};\n\twebpackContext.keys = function webpackContextKeys() {\n\t\treturn Object.keys(map);\n\t};\n\twebpackContext.resolve = webpackContextResolve;\n\tmodule.exports = webpackContext;\n\twebpackContext.id = 65;\n\n\n/***/ },\n/* 66 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .filter('calendarDate', [\"calendarHelper\", \"calendarConfig\", function(calendarHelper, calendarConfig) {\n\n\t    function calendarDate(date, format, getFromConfig) {\n\n\t      if (getFromConfig === true) {\n\t        format = calendarConfig.dateFormats[format];\n\t      }\n\n\t      return calendarHelper.formatDate(date, format);\n\n\t    }\n\n\t    // This is stateful because the locale can change as well\n\t    // as calendarConfig.dateFormats which would change the value outside of this filter\n\t    calendarDate.$stateful = true;\n\n\t    return calendarDate;\n\n\t  }]);\n\n\n/***/ },\n/* 67 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .filter('calendarLimitTo', [\"limitToFilter\", function(limitToFilter) {\n\n\t    if (angular.version.minor >= 4) { //1.4+ supports the begin attribute\n\t      return limitToFilter;\n\t    }\n\n\t    //Copied from the angular source. Only 1.4 has the begin functionality.\n\t    return function(input, limit, begin) {\n\t      if (Math.abs(Number(limit)) === Infinity) {\n\t        limit = Number(limit);\n\t      } else {\n\t        limit = parseInt(limit);\n\t      }\n\t      if (isNaN(limit)) {\n\t        return input;\n\t      }\n\n\t      if (angular.isNumber(input)) {\n\t        input = input.toString();\n\t      }\n\t      if (!angular.isArray(input) && !angular.isString(input)) {\n\t        return input;\n\t      }\n\n\t      begin = (!begin || isNaN(begin)) ? 0 : parseInt(begin);\n\t      begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;\n\n\t      if (limit >= 0) {\n\t        return input.slice(begin, begin + limit);\n\t      } else if (begin === 0) {\n\t        return input.slice(limit, input.length);\n\t      } else {\n\t        return input.slice(Math.max(0, begin + limit), begin);\n\t      }\n\t    };\n\n\t  }]);\n\n\n/***/ },\n/* 68 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .filter('calendarTruncateEventTitle', function() {\n\n\t    return function(string, length, boxHeight) {\n\t      if (!string) {\n\t        return '';\n\t      }\n\n\t      //Only truncate if if actually needs truncating\n\t      if (string.length >= length && string.length / 20 > boxHeight / 30) {\n\t        return string.substr(0, length) + '...';\n\t      } else {\n\t        return string;\n\t      }\n\t    };\n\n\t  });\n\n\n/***/ },\n/* 69 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .filter('calendarTrustAsHtml', [\"$sce\", function($sce) {\n\n\t    return function(text) {\n\t      return $sce.trustAsHtml(text);\n\t    };\n\n\t  }]);\n\n\n/***/ },\n/* 70 */\n/***/ function(module, exports, __webpack_require__) {\n\n\tvar map = {\n\t\t\"./calendarConfig.js\": 71,\n\t\t\"./calendarEventTitle.js\": 72,\n\t\t\"./calendarHelper.js\": 73,\n\t\t\"./calendarTitle.js\": 74,\n\t\t\"./interact.js\": 75,\n\t\t\"./moment.js\": 77\n\t};\n\tfunction webpackContext(req) {\n\t\treturn __webpack_require__(webpackContextResolve(req));\n\t};\n\tfunction webpackContextResolve(req) {\n\t\treturn map[req] || (function() { throw new Error(\"Cannot find module '\" + req + \"'.\") }());\n\t};\n\twebpackContext.keys = function webpackContextKeys() {\n\t\treturn Object.keys(map);\n\t};\n\twebpackContext.resolve = webpackContextResolve;\n\tmodule.exports = webpackContext;\n\twebpackContext.id = 70;\n\n\n/***/ },\n/* 71 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .constant('calendarConfig', {\n\t    allDateFormats: {\n\t      angular: {\n\t        date: {\n\t          hour: 'ha',\n\t          day: 'd MMM',\n\t          month: 'MMMM',\n\t          weekDay: 'EEEE',\n\t          time: 'HH:mm',\n\t          datetime: 'MMM d, h:mm a'\n\t        },\n\t        title: {\n\t          day: 'EEEE d MMMM, yyyy',\n\t          week: 'Week {week} of {year}',\n\t          month: 'MMMM yyyy',\n\t          year: 'yyyy'\n\t        }\n\t      },\n\t      moment: {\n\t        date: {\n\t          hour: 'ha',\n\t          day: 'D MMM',\n\t          month: 'MMMM',\n\t          weekDay: 'dddd',\n\t          time: 'HH:mm',\n\t          datetime: 'MMM D, h:mm a'\n\t        },\n\t        title: {\n\t          day: 'dddd D MMMM, YYYY',\n\t          week: 'Week {week} of {year}',\n\t          month: 'MMMM YYYY',\n\t          year: 'YYYY'\n\t        }\n\t      }\n\t    },\n\t    get dateFormats() {\n\t      return this.allDateFormats[this.dateFormatter].date;\n\t    },\n\t    get titleFormats() {\n\t      return this.allDateFormats[this.dateFormatter].title;\n\t    },\n\t    dateFormatter: 'angular',\n\t    showTimesOnWeekView: false,\n\t    displayAllMonthEvents: false,\n\t    i18nStrings: {\n\t      weekNumber: 'Week {week}'\n\t    },\n\t    templates: {},\n\t    colorTypes: {\n\t      info: {\n\t        primary: '#1e90ff',\n\t        secondary: '#d1e8ff'\n\t      },\n\t      important: {\n\t        primary: '#ad2121',\n\t        secondary: '#fae3e3'\n\t      },\n\t      warning: {\n\t        primary: '#e3bc08',\n\t        secondary: '#fdf1ba'\n\t      },\n\t      inverse: {\n\t        primary: '#1b1b1b',\n\t        secondary: '#c1c1c1'\n\t      },\n\t      special: {\n\t        primary: '#800080',\n\t        secondary: '#ffe6ff'\n\t      },\n\t      success: {\n\t        primary: '#006400',\n\t        secondary: '#caffca'\n\t      }\n\t    }\n\t  });\n\n\n/***/ },\n/* 72 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .factory('calendarEventTitle', [\"calendarDateFilter\", \"calendarTruncateEventTitleFilter\", function(calendarDateFilter, calendarTruncateEventTitleFilter) {\n\n\t    function yearView(event) {\n\t      return event.title + ' (' + calendarDateFilter(event.startsAt, 'datetime', true) + ')';\n\t    }\n\n\t    function monthView(event) {\n\t      return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';\n\t    }\n\n\t    function monthViewTooltip(event) {\n\t      return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;\n\t    }\n\n\t    function weekView(event) {\n\t      return event.title;\n\t    }\n\n\t    function weekViewTooltip(event) {\n\t      return event.title;\n\t    }\n\n\t    function dayView(event) {\n\t      return event.allDay ? event.title : calendarTruncateEventTitleFilter(event.title, 20, event.height);\n\t    }\n\n\t    function dayViewTooltip(event) {\n\t      return event.title;\n\t    }\n\n\t    return {\n\t      yearView: yearView,\n\t      monthView: monthView,\n\t      monthViewTooltip: monthViewTooltip,\n\t      weekView: weekView,\n\t      weekViewTooltip: weekViewTooltip,\n\t      dayView: dayView,\n\t      dayViewTooltip: dayViewTooltip\n\t    };\n\n\t  }]);\n\n\n/***/ },\n/* 73 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\tvar calendarUtils = __webpack_require__(27);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .factory('calendarHelper', [\"$q\", \"$templateRequest\", \"dateFilter\", \"moment\", \"calendarConfig\", function($q, $templateRequest, dateFilter, moment, calendarConfig) {\n\n\t    function formatDate(date, format) {\n\t      if (calendarConfig.dateFormatter === 'angular') {\n\t        return dateFilter(moment(date).toDate(), format);\n\t      } else if (calendarConfig.dateFormatter === 'moment') {\n\t        return moment(date).format(format);\n\t      } else {\n\t        throw new Error('Unknown date formatter: ' + calendarConfig.dateFormatter);\n\t      }\n\t    }\n\n\t    function adjustEndDateFromStartDiff(oldStart, newStart, oldEnd) {\n\t      if (!oldEnd) {\n\t        return oldEnd;\n\t      }\n\t      var diffInSeconds = moment(newStart).diff(moment(oldStart));\n\t      return moment(oldEnd).add(diffInSeconds);\n\t    }\n\n\t    function getRecurringEventPeriod(eventPeriod, recursOn, containerPeriodStart) {\n\n\t      var eventStart = moment(eventPeriod.start);\n\t      var eventEnd = moment(eventPeriod.end);\n\t      var periodStart = moment(containerPeriodStart);\n\n\t      if (recursOn) {\n\n\t        switch (recursOn) {\n\t          case 'year':\n\t            eventStart.set({\n\t              year: periodStart.year()\n\t            });\n\t            break;\n\n\t          case 'month':\n\t            eventStart.set({\n\t              year: periodStart.year(),\n\t              month: periodStart.month()\n\t            });\n\t            break;\n\n\t          default:\n\t            throw new Error('Invalid value (' + recursOn + ') given for recurs on. Can only be year or month.');\n\t        }\n\n\t        eventEnd = adjustEndDateFromStartDiff(eventPeriod.start, eventStart, eventEnd);\n\n\t      }\n\n\t      return {start: eventStart, end: eventEnd};\n\n\t    }\n\n\t    function eventIsInPeriod(event, periodStart, periodEnd) {\n\n\t      periodStart = moment(periodStart);\n\t      periodEnd = moment(periodEnd);\n\n\t      var eventPeriod = getRecurringEventPeriod({start: event.startsAt, end: event.endsAt || event.startsAt}, event.recursOn, periodStart);\n\t      var eventStart = eventPeriod.start;\n\t      var eventEnd = eventPeriod.end;\n\n\t      return (eventStart.isAfter(periodStart) && eventStart.isBefore(periodEnd)) ||\n\t        (eventEnd.isAfter(periodStart) && eventEnd.isBefore(periodEnd)) ||\n\t        (eventStart.isBefore(periodStart) && eventEnd.isAfter(periodEnd)) ||\n\t        eventStart.isSame(periodStart) ||\n\t        eventEnd.isSame(periodEnd);\n\n\t    }\n\n\t    function filterEventsInPeriod(events, startPeriod, endPeriod) {\n\t      return events.filter(function(event) {\n\t        return eventIsInPeriod(event, startPeriod, endPeriod);\n\t      });\n\t    }\n\n\t    function getEventsInPeriod(calendarDate, period, allEvents) {\n\t      var startPeriod = moment(calendarDate).startOf(period);\n\t      var endPeriod = moment(calendarDate).endOf(period);\n\t      return filterEventsInPeriod(allEvents, startPeriod, endPeriod);\n\t    }\n\n\t    function getBadgeTotal(events) {\n\t      return events.filter(function(event) {\n\t        return event.incrementsBadgeTotal !== false;\n\t      }).length;\n\t    }\n\n\t    function getWeekDayNames() {\n\t      var weekdays = [];\n\t      var count = 0;\n\t      while (count < 7) {\n\t        weekdays.push(formatDate(moment().weekday(count++), calendarConfig.dateFormats.weekDay));\n\t      }\n\t      return weekdays;\n\t    }\n\n\t    function getYearView(events, viewDate, cellModifier) {\n\n\t      var view = [];\n\t      var eventsInPeriod = getEventsInPeriod(viewDate, 'year', events);\n\t      var month = moment(viewDate).startOf('year');\n\t      var count = 0;\n\t      while (count < 12) {\n\t        var startPeriod = month.clone();\n\t        var endPeriod = startPeriod.clone().endOf('month');\n\t        var periodEvents = filterEventsInPeriod(eventsInPeriod, startPeriod, endPeriod);\n\t        var cell = {\n\t          label: formatDate(startPeriod, calendarConfig.dateFormats.month),\n\t          isToday: startPeriod.isSame(moment().startOf('month')),\n\t          events: periodEvents,\n\t          date: startPeriod,\n\t          badgeTotal: getBadgeTotal(periodEvents)\n\t        };\n\n\t        cellModifier({calendarCell: cell});\n\t        view.push(cell);\n\t        month.add(1, 'month');\n\t        count++;\n\t      }\n\n\t      return view;\n\n\t    }\n\n\t    function getMonthView(events, viewDate, cellModifier) {\n\n\t      // hack required to work with the calendar-utils api\n\t      events.forEach(function(event) {\n\t        event.start = event.startsAt;\n\t        event.end = event.endsAt;\n\t      });\n\n\t      var view = calendarUtils.getMonthView({\n\t        events: events,\n\t        viewDate: viewDate,\n\t        weekStartsOn: moment().startOf('week').day()\n\t      });\n\n\t      view.days = view.days.map(function(day) {\n\t        day.date = moment(day.date);\n\t        day.label = day.date.date();\n\t        day.badgeTotal = getBadgeTotal(day.events);\n\t        if (!calendarConfig.displayAllMonthEvents && !day.inMonth) {\n\t          day.events = [];\n\t        }\n\t        cellModifier({calendarCell: day});\n\t        return day;\n\t      });\n\n\t      // remove hack\n\t      events.forEach(function(event) {\n\t        delete event.start;\n\t        delete event.end;\n\t      });\n\n\t      return view;\n\n\t    }\n\n\t    function getWeekView(events, viewDate) {\n\n\t      var days = calendarUtils.getWeekViewHeader({\n\t        viewDate: viewDate,\n\t        weekStartsOn: moment().startOf('week').day()\n\t      }).map(function(day) {\n\t        day.date = moment(day.date);\n\t        day.weekDayLabel = formatDate(day.date, calendarConfig.dateFormats.weekDay);\n\t        day.dayLabel = formatDate(day.date, calendarConfig.dateFormats.day);\n\t        return day;\n\t      });\n\n\t      var startOfWeek = moment(viewDate).startOf('week');\n\t      var endOfWeek = moment(viewDate).endOf('week');\n\n\t      var eventRows = calendarUtils.getWeekView({\n\t        viewDate: viewDate,\n\t        weekStartsOn: moment().startOf('week').day(),\n\t        events: filterEventsInPeriod(events, startOfWeek, endOfWeek).map(function(event) {\n\n\t          var weekViewStart = moment(startOfWeek).startOf('day');\n\n\t          var eventPeriod = getRecurringEventPeriod({\n\t            start: moment(event.startsAt),\n\t            end: moment(event.endsAt || event.startsAt)\n\t          }, event.recursOn, weekViewStart);\n\n\t          eventPeriod.originalEvent = event;\n\n\t          return eventPeriod;\n\n\t        })\n\t      }).map(function(eventRow) {\n\n\t        eventRow.row = eventRow.row.map(function(rowEvent) {\n\t          rowEvent.event = rowEvent.event.originalEvent;\n\t          return rowEvent;\n\t        });\n\n\t        return eventRow;\n\n\t      });\n\n\t      return {days: days, eventRows: eventRows};\n\n\t    }\n\n\t    function getDayView(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit) {\n\n\t      var dayStart = (dayViewStart || '00:00').split(':');\n\t      var dayEnd = (dayViewEnd || '23:59').split(':');\n\n\t      var view = calendarUtils.getDayView({\n\t        events: events.map(function(event) { // hack required to work with event API\n\t          event.start = event.startsAt;\n\t          event.end = event.endsAt;\n\t          return event;\n\t        }),\n\t        viewDate: viewDate,\n\t        hourSegments: 60 / dayViewSplit,\n\t        dayStart: {\n\t          hour: dayStart[0],\n\t          minute: dayStart[1]\n\t        },\n\t        dayEnd: {\n\t          hour: dayEnd[0],\n\t          minute: dayEnd[1]\n\t        },\n\t        eventWidth: 150,\n\t        segmentHeight: 30\n\t      });\n\n\t      // remove hack to work with new event API\n\t      events.forEach(function(event) {\n\t        delete event.start;\n\t        delete event.end;\n\t      });\n\n\t      return view;\n\n\t    }\n\n\t    function getWeekViewWithTimes(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit) {\n\t      var weekView = getWeekView(events, viewDate);\n\t      var newEvents = [];\n\t      var flattenedEvents = [];\n\t      weekView.eventRows.forEach(function(row) {\n\t        row.row.forEach(function(eventRow) {\n\t          flattenedEvents.push(eventRow.event);\n\t        });\n\t      });\n\t      weekView.days.forEach(function(day) {\n\t        var dayEvents = flattenedEvents.filter(function(event) {\n\t          return moment(event.startsAt).startOf('day').isSame(moment(day.date).startOf('day'));\n\t        });\n\t        var newDayEvents = getDayView(\n\t          dayEvents,\n\t          day.date,\n\t          dayViewStart,\n\t          dayViewEnd,\n\t          dayViewSplit\n\t        ).events;\n\t        newEvents = newEvents.concat(newDayEvents);\n\t      });\n\t      weekView.eventRows = [{\n\t        row: newEvents.map(function(dayEvent) {\n\t          var event = dayEvent.event;\n\t          return {\n\t            event: event,\n\t            top: dayEvent.top,\n\t            offset: calendarUtils.getWeekViewEventOffset(\n\t              {start: event.startsAt, end: event.endsAt},\n\t              moment(viewDate).startOf('week')\n\t            )\n\t          };\n\t        })\n\t      }];\n\t      return weekView;\n\t    }\n\n\t    function getDayViewHeight(dayViewStart, dayViewEnd, dayViewSplit) {\n\t      var dayViewStartM = moment(dayViewStart || '00:00', 'HH:mm');\n\t      var dayViewEndM = moment(dayViewEnd || '23:59', 'HH:mm');\n\t      var hourHeight = (60 / dayViewSplit) * 30;\n\t      return ((dayViewEndM.diff(dayViewStartM, 'minutes') / 60) * hourHeight) + 3;\n\t    }\n\n\t    function loadTemplates() {\n\n\t      var templatePromises = Object.keys(calendarConfig.templates).map(function(key) {\n\t        var templateUrl = calendarConfig.templates[key];\n\t        return $templateRequest(templateUrl);\n\t      });\n\n\t      return $q.all(templatePromises);\n\n\t    }\n\n\t    return {\n\t      getWeekDayNames: getWeekDayNames,\n\t      getYearView: getYearView,\n\t      getMonthView: getMonthView,\n\t      getWeekView: getWeekView,\n\t      getDayView: getDayView,\n\t      getWeekViewWithTimes: getWeekViewWithTimes,\n\t      getDayViewHeight: getDayViewHeight,\n\t      adjustEndDateFromStartDiff: adjustEndDateFromStartDiff,\n\t      formatDate: formatDate,\n\t      loadTemplates: loadTemplates,\n\t      eventIsInPeriod: eventIsInPeriod //expose for testing only\n\t    };\n\n\t  }]);\n\n\n/***/ },\n/* 74 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .factory('calendarTitle', [\"moment\", \"calendarConfig\", \"calendarHelper\", function(moment, calendarConfig, calendarHelper) {\n\n\t    function day(viewDate) {\n\t      return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.day);\n\t    }\n\n\t    function week(viewDate) {\n\t      return calendarConfig.titleFormats.week\n\t        .replace('{week}', moment(viewDate).isoWeek())\n\t        .replace('{year}', moment(viewDate).startOf('week').format('YYYY'));\n\t    }\n\n\t    function month(viewDate) {\n\t      return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.month);\n\t    }\n\n\t    function year(viewDate) {\n\t      return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.year);\n\t    }\n\n\t    return {\n\t      day: day,\n\t      week: week,\n\t      month: month,\n\t      year: year\n\t    };\n\n\t  }]);\n\n\n/***/ },\n/* 75 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\tvar interact;\n\ttry {\n\t  interact = __webpack_require__(76);\n\t} catch (e) {\n\t  /* istanbul ignore next */\n\t  interact = null;\n\t}\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .constant('interact', interact);\n\n\n/***/ },\n/* 76 */\n/***/ function(module, exports) {\n\n\tif(typeof __WEBPACK_EXTERNAL_MODULE_76__ === 'undefined') {var e = new Error(\"Cannot find module \\\"undefined\\\"\"); e.code = 'MODULE_NOT_FOUND'; throw e;}\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_76__;\n\n/***/ },\n/* 77 */\n/***/ function(module, exports, __webpack_require__) {\n\n\t'use strict';\n\n\tvar angular = __webpack_require__(12);\n\tvar moment = __webpack_require__(78);\n\n\tangular\n\t  .module('mwl.calendar')\n\t  .constant('moment', moment);\n\n\n/***/ },\n/* 78 */\n/***/ function(module, exports) {\n\n\tmodule.exports = __WEBPACK_EXTERNAL_MODULE_78__;\n\n/***/ }\n/******/ ])\n});\n;"

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1524))

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	module.exports = "(function (root, factory) {\n    /* istanbul ignore next */\n    if (typeof define === 'function' && define.amd) {\n        define(['angular'], factory);\n    } else if (typeof module === 'object' && module.exports) {\n        module.exports = factory(require('angular'));\n    } else {\n        root.angularClipboard = factory(root.angular);\n  }\n}(this, function (angular) {\n\nreturn angular.module('angular-clipboard', [])\n    .factory('clipboard', ['$document', '$window', function ($document, $window) {\n        function createNode(text, context) {\n            var node = $document[0].createElement('textarea');\n            node.style.position = 'absolute';\n            node.textContent = text;\n            node.style.left = '-10000px';\n            node.style.top = ($window.pageYOffset || $document[0].documentElement.scrollTop) + 'px';\n            return node;\n        }\n\n        function copyNode(node) {\n            try {\n                // Set inline style to override css styles\n                $document[0].body.style.webkitUserSelect = 'initial';\n\n                var selection = $document[0].getSelection();\n                selection.removeAllRanges();\n                node.select();\n\n                if(!$document[0].execCommand('copy')) {\n                    throw('failure copy');\n                }\n                selection.removeAllRanges();\n            } finally {\n                // Reset inline style\n                $document[0].body.style.webkitUserSelect = '';\n            }\n        }\n\n        function copyText(text, context) {\n            var node = createNode(text, context);\n            $document[0].body.appendChild(node);\n            copyNode(node);\n            $document[0].body.removeChild(node);\n        }\n\n        return {\n            copyText: copyText,\n            supported: 'queryCommandSupported' in $document[0] && $document[0].queryCommandSupported('copy')\n        };\n    }])\n    .directive('clipboard', ['clipboard', function (clipboard) {\n        return {\n            restrict: 'A',\n            scope: {\n                onCopied: '&',\n                onError: '&',\n                text: '=',\n                supported: '=?'\n            },\n            link: function (scope, element) {\n                scope.supported = clipboard.supported;\n\n                element.on('click', function (event) {\n                    try {\n                        clipboard.copyText(scope.text, element[0]);\n                        if (angular.isFunction(scope.onCopied)) {\n                            scope.$evalAsync(scope.onCopied());\n                        }\n                    } catch (err) {\n                        if (angular.isFunction(scope.onError)) {\n                            scope.$evalAsync(scope.onError({err: err}));\n                        }\n                    }\n                });\n            }\n        };\n    }]);\n\n}));\n"

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1526))

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	module.exports = "/*! pdfmake v0.1.36, @license MIT, @link http://pdfmake.org */\n!function(t,e){if(\"object\"==typeof exports&&\"object\"==typeof module)module.exports=e();else if(\"function\"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)(\"object\"==typeof exports?exports:t)[r]=n[r]}}(\"undefined\"!=typeof self?self:this,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:r})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,\"a\",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p=\"\",n(n.s=122)}([function(t,e,n){\"use strict\";t.exports={isString:function(t){return\"string\"==typeof t||t instanceof String},isNumber:function(t){return\"number\"==typeof t||t instanceof Number},isBoolean:function(t){return\"boolean\"==typeof t},isArray:function(t){return Array.isArray(t)},isFunction:function(t){return\"function\"==typeof t},isObject:function(t){return null!==t&&\"object\"==typeof t},isNull:function(t){return null===t},isUndefined:function(t){return void 0===t},pack:function(){for(var t={},e=0,n=arguments.length;e<n;e++){var r=arguments[e];if(r)for(var i in r)r.hasOwnProperty(i)&&(t[i]=r[i])}return t},fontStringify:function(t,e){return\"font\"===t?\"font\":e},offsetVector:function(t,e,n){switch(t.type){case\"ellipse\":case\"rect\":t.x+=e,t.y+=n;break;case\"line\":t.x1+=e,t.x2+=e,t.y1+=n,t.y2+=n;break;case\"polyline\":for(var r=0,i=t.points.length;r<i;r++)t.points[r].x+=e,t.points[r].y+=n}}}},function(t,e,n){\"use strict\";(function(t){var r=n(124),i=n(125),a=n(76);function o(){return l.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function s(t,e){if(o()<e)throw new RangeError(\"Invalid typed array length\");return l.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=l.prototype:(null===t&&(t=new l(e)),t.length=e),t}function l(t,e,n){if(!(l.TYPED_ARRAY_SUPPORT||this instanceof l))return new l(t,e,n);if(\"number\"==typeof t){if(\"string\"==typeof e)throw new Error(\"If encoding is specified then the first argument must be a string\");return h(this,t)}return u(this,t,e,n)}function u(t,e,n,r){if(\"number\"==typeof e)throw new TypeError('\"value\" argument must not be a number');return\"undefined\"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function(t,e,n,r){if(e.byteLength,n<0||e.byteLength<n)throw new RangeError(\"'offset' is out of bounds\");if(e.byteLength<n+(r||0))throw new RangeError(\"'length' is out of bounds\");e=void 0===n&&void 0===r?new Uint8Array(e):void 0===r?new Uint8Array(e,n):new Uint8Array(e,n,r);l.TYPED_ARRAY_SUPPORT?(t=e).__proto__=l.prototype:t=f(t,e);return t}(t,e,n,r):\"string\"==typeof e?function(t,e,n){\"string\"==typeof n&&\"\"!==n||(n=\"utf8\");if(!l.isEncoding(n))throw new TypeError('\"encoding\" must be a valid string encoding');var r=0|p(e,n),i=(t=s(t,r)).write(e,n);i!==r&&(t=t.slice(0,i));return t}(t,e,n):function(t,e){if(l.isBuffer(e)){var n=0|d(e.length);return 0===(t=s(t,n)).length?t:(e.copy(t,0,0,n),t)}if(e){if(\"undefined\"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||\"length\"in e)return\"number\"!=typeof e.length||(r=e.length)!=r?s(t,0):f(t,e);if(\"Buffer\"===e.type&&a(e.data))return f(t,e.data)}var r;throw new TypeError(\"First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.\")}(t,e)}function c(t){if(\"number\"!=typeof t)throw new TypeError('\"size\" argument must be a number');if(t<0)throw new RangeError('\"size\" argument must not be negative')}function h(t,e){if(c(e),t=s(t,e<0?0:0|d(e)),!l.TYPED_ARRAY_SUPPORT)for(var n=0;n<e;++n)t[n]=0;return t}function f(t,e){var n=e.length<0?0:0|d(e.length);t=s(t,n);for(var r=0;r<n;r+=1)t[r]=255&e[r];return t}function d(t){if(t>=o())throw new RangeError(\"Attempt to allocate Buffer larger than maximum size: 0x\"+o().toString(16)+\" bytes\");return 0|t}function p(t,e){if(l.isBuffer(t))return t.length;if(\"undefined\"!=typeof ArrayBuffer&&\"function\"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;\"string\"!=typeof t&&(t=\"\"+t);var n=t.length;if(0===n)return 0;for(var r=!1;;)switch(e){case\"ascii\":case\"latin1\":case\"binary\":return n;case\"utf8\":case\"utf-8\":case void 0:return F(t).length;case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return 2*n;case\"hex\":return n>>>1;case\"base64\":return D(t).length;default:if(r)return F(t).length;e=(\"\"+e).toLowerCase(),r=!0}}function g(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function y(t,e,n,r,i){if(0===t.length)return-1;if(\"string\"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=i?0:t.length-1),n<0&&(n=t.length+n),n>=t.length){if(i)return-1;n=t.length-1}else if(n<0){if(!i)return-1;n=0}if(\"string\"==typeof e&&(e=l.from(e,r)),l.isBuffer(e))return 0===e.length?-1:v(t,e,n,r,i);if(\"number\"==typeof e)return e&=255,l.TYPED_ARRAY_SUPPORT&&\"function\"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,n):Uint8Array.prototype.lastIndexOf.call(t,e,n):v(t,[e],n,r,i);throw new TypeError(\"val must be string, number or Buffer\")}function v(t,e,n,r,i){var a,o=1,s=t.length,l=e.length;if(void 0!==r&&(\"ucs2\"===(r=String(r).toLowerCase())||\"ucs-2\"===r||\"utf16le\"===r||\"utf-16le\"===r)){if(t.length<2||e.length<2)return-1;o=2,s/=2,l/=2,n/=2}function u(t,e){return 1===o?t[e]:t.readUInt16BE(e*o)}if(i){var c=-1;for(a=n;a<s;a++)if(u(t,a)===u(e,-1===c?0:a-c)){if(-1===c&&(c=a),a-c+1===l)return c*o}else-1!==c&&(a-=a-c),c=-1}else for(n+l>s&&(n=s-l),a=n;a>=0;a--){for(var h=!0,f=0;f<l;f++)if(u(t,a+f)!==u(e,f)){h=!1;break}if(h)return a}return-1}function b(t,e,n,r){n=Number(n)||0;var i=t.length-n;r?(r=Number(r))>i&&(r=i):r=i;var a=e.length;if(a%2!=0)throw new TypeError(\"Invalid hex string\");r>a/2&&(r=a/2);for(var o=0;o<r;++o){var s=parseInt(e.substr(2*o,2),16);if(isNaN(s))return o;t[n+o]=s}return o}function m(t,e,n,r){return z(function(t){for(var e=[],n=0;n<t.length;++n)e.push(255&t.charCodeAt(n));return e}(e),t,n,r)}function w(t,e,n){return 0===e&&n===t.length?r.fromByteArray(t):r.fromByteArray(t.slice(e,n))}function x(t,e,n){n=Math.min(t.length,n);for(var r=[],i=e;i<n;){var a,o,s,l,u=t[i],c=null,h=u>239?4:u>223?3:u>191?2:1;if(i+h<=n)switch(h){case 1:u<128&&(c=u);break;case 2:128==(192&(a=t[i+1]))&&(l=(31&u)<<6|63&a)>127&&(c=l);break;case 3:a=t[i+1],o=t[i+2],128==(192&a)&&128==(192&o)&&(l=(15&u)<<12|(63&a)<<6|63&o)>2047&&(l<55296||l>57343)&&(c=l);break;case 4:a=t[i+1],o=t[i+2],s=t[i+3],128==(192&a)&&128==(192&o)&&128==(192&s)&&(l=(15&u)<<18|(63&a)<<12|(63&o)<<6|63&s)>65535&&l<1114112&&(c=l)}null===c?(c=65533,h=1):c>65535&&(c-=65536,r.push(c>>>10&1023|55296),c=56320|1023&c),r.push(c),i+=h}return function(t){var e=t.length;if(e<=S)return String.fromCharCode.apply(String,t);var n=\"\",r=0;for(;r<e;)n+=String.fromCharCode.apply(String,t.slice(r,r+=S));return n}(r)}e.Buffer=l,e.SlowBuffer=function(t){+t!=t&&(t=0);return l.alloc(+t)},e.INSPECT_MAX_BYTES=50,l.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&\"function\"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=o(),l.poolSize=8192,l._augment=function(t){return t.__proto__=l.prototype,t},l.from=function(t,e,n){return u(null,t,e,n)},l.TYPED_ARRAY_SUPPORT&&(l.prototype.__proto__=Uint8Array.prototype,l.__proto__=Uint8Array,\"undefined\"!=typeof Symbol&&Symbol.species&&l[Symbol.species]===l&&Object.defineProperty(l,Symbol.species,{value:null,configurable:!0})),l.alloc=function(t,e,n){return r=null,a=e,o=n,c(i=t),i<=0?s(r,i):void 0!==a?\"string\"==typeof o?s(r,i).fill(a,o):s(r,i).fill(a):s(r,i);var r,i,a,o},l.allocUnsafe=function(t){return h(null,t)},l.allocUnsafeSlow=function(t){return h(null,t)},l.isBuffer=function(t){return!(null==t||!t._isBuffer)},l.compare=function(t,e){if(!l.isBuffer(t)||!l.isBuffer(e))throw new TypeError(\"Arguments must be Buffers\");if(t===e)return 0;for(var n=t.length,r=e.length,i=0,a=Math.min(n,r);i<a;++i)if(t[i]!==e[i]){n=t[i],r=e[i];break}return n<r?-1:r<n?1:0},l.isEncoding=function(t){switch(String(t).toLowerCase()){case\"hex\":case\"utf8\":case\"utf-8\":case\"ascii\":case\"latin1\":case\"binary\":case\"base64\":case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return!0;default:return!1}},l.concat=function(t,e){if(!a(t))throw new TypeError('\"list\" argument must be an Array of Buffers');if(0===t.length)return l.alloc(0);var n;if(void 0===e)for(e=0,n=0;n<t.length;++n)e+=t[n].length;var r=l.allocUnsafe(e),i=0;for(n=0;n<t.length;++n){var o=t[n];if(!l.isBuffer(o))throw new TypeError('\"list\" argument must be an Array of Buffers');o.copy(r,i),i+=o.length}return r},l.byteLength=p,l.prototype._isBuffer=!0,l.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError(\"Buffer size must be a multiple of 16-bits\");for(var e=0;e<t;e+=2)g(this,e,e+1);return this},l.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError(\"Buffer size must be a multiple of 32-bits\");for(var e=0;e<t;e+=4)g(this,e,e+3),g(this,e+1,e+2);return this},l.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError(\"Buffer size must be a multiple of 64-bits\");for(var e=0;e<t;e+=8)g(this,e,e+7),g(this,e+1,e+6),g(this,e+2,e+5),g(this,e+3,e+4);return this},l.prototype.toString=function(){var t=0|this.length;return 0===t?\"\":0===arguments.length?x(this,0,t):function(t,e,n){var r=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return\"\";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return\"\";if((n>>>=0)<=(e>>>=0))return\"\";for(t||(t=\"utf8\");;)switch(t){case\"hex\":return C(this,e,n);case\"utf8\":case\"utf-8\":return x(this,e,n);case\"ascii\":return _(this,e,n);case\"latin1\":case\"binary\":return k(this,e,n);case\"base64\":return w(this,e,n);case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return A(this,e,n);default:if(r)throw new TypeError(\"Unknown encoding: \"+t);t=(t+\"\").toLowerCase(),r=!0}}.apply(this,arguments)},l.prototype.equals=function(t){if(!l.isBuffer(t))throw new TypeError(\"Argument must be a Buffer\");return this===t||0===l.compare(this,t)},l.prototype.inspect=function(){var t=\"\",n=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString(\"hex\",0,n).match(/.{2}/g).join(\" \"),this.length>n&&(t+=\" ... \")),\"<Buffer \"+t+\">\"},l.prototype.compare=function(t,e,n,r,i){if(!l.isBuffer(t))throw new TypeError(\"Argument must be a Buffer\");if(void 0===e&&(e=0),void 0===n&&(n=t?t.length:0),void 0===r&&(r=0),void 0===i&&(i=this.length),e<0||n>t.length||r<0||i>this.length)throw new RangeError(\"out of range index\");if(r>=i&&e>=n)return 0;if(r>=i)return-1;if(e>=n)return 1;if(this===t)return 0;for(var a=(i>>>=0)-(r>>>=0),o=(n>>>=0)-(e>>>=0),s=Math.min(a,o),u=this.slice(r,i),c=t.slice(e,n),h=0;h<s;++h)if(u[h]!==c[h]){a=u[h],o=c[h];break}return a<o?-1:o<a?1:0},l.prototype.includes=function(t,e,n){return-1!==this.indexOf(t,e,n)},l.prototype.indexOf=function(t,e,n){return y(this,t,e,n,!0)},l.prototype.lastIndexOf=function(t,e,n){return y(this,t,e,n,!1)},l.prototype.write=function(t,e,n,r){if(void 0===e)r=\"utf8\",n=this.length,e=0;else if(void 0===n&&\"string\"==typeof e)r=e,n=this.length,e=0;else{if(!isFinite(e))throw new Error(\"Buffer.write(string, encoding, offset[, length]) is no longer supported\");e|=0,isFinite(n)?(n|=0,void 0===r&&(r=\"utf8\")):(r=n,n=void 0)}var i=this.length-e;if((void 0===n||n>i)&&(n=i),t.length>0&&(n<0||e<0)||e>this.length)throw new RangeError(\"Attempt to write outside buffer bounds\");r||(r=\"utf8\");for(var a,o,s,l,u,c,h,f,d,p=!1;;)switch(r){case\"hex\":return b(this,t,e,n);case\"utf8\":case\"utf-8\":return f=e,d=n,z(F(t,(h=this).length-f),h,f,d);case\"ascii\":return m(this,t,e,n);case\"latin1\":case\"binary\":return m(this,t,e,n);case\"base64\":return l=this,u=e,c=n,z(D(t),l,u,c);case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return o=e,s=n,z(function(t,e){for(var n,r,i,a=[],o=0;o<t.length&&!((e-=2)<0);++o)n=t.charCodeAt(o),r=n>>8,i=n%256,a.push(i),a.push(r);return a}(t,(a=this).length-o),a,o,s);default:if(p)throw new TypeError(\"Unknown encoding: \"+r);r=(\"\"+r).toLowerCase(),p=!0}},l.prototype.toJSON=function(){return{type:\"Buffer\",data:Array.prototype.slice.call(this._arr||this,0)}};var S=4096;function _(t,e,n){var r=\"\";n=Math.min(t.length,n);for(var i=e;i<n;++i)r+=String.fromCharCode(127&t[i]);return r}function k(t,e,n){var r=\"\";n=Math.min(t.length,n);for(var i=e;i<n;++i)r+=String.fromCharCode(t[i]);return r}function C(t,e,n){var r=t.length;(!e||e<0)&&(e=0),(!n||n<0||n>r)&&(n=r);for(var i=\"\",a=e;a<n;++a)i+=R(t[a]);return i}function A(t,e,n){for(var r=t.slice(e,n),i=\"\",a=0;a<r.length;a+=2)i+=String.fromCharCode(r[a]+256*r[a+1]);return i}function P(t,e,n){if(t%1!=0||t<0)throw new RangeError(\"offset is not uint\");if(t+e>n)throw new RangeError(\"Trying to access beyond buffer length\")}function E(t,e,n,r,i,a){if(!l.isBuffer(t))throw new TypeError('\"buffer\" argument must be a Buffer instance');if(e>i||e<a)throw new RangeError('\"value\" argument is out of bounds');if(n+r>t.length)throw new RangeError(\"Index out of range\")}function I(t,e,n,r){e<0&&(e=65535+e+1);for(var i=0,a=Math.min(t.length-n,2);i<a;++i)t[n+i]=(e&255<<8*(r?i:1-i))>>>8*(r?i:1-i)}function T(t,e,n,r){e<0&&(e=4294967295+e+1);for(var i=0,a=Math.min(t.length-n,4);i<a;++i)t[n+i]=e>>>8*(r?i:3-i)&255}function O(t,e,n,r,i,a){if(n+r>t.length)throw new RangeError(\"Index out of range\");if(n<0)throw new RangeError(\"Index out of range\")}function L(t,e,n,r,a){return a||O(t,0,n,4),i.write(t,e,n,r,23,4),n+4}function B(t,e,n,r,a){return a||O(t,0,n,8),i.write(t,e,n,r,52,8),n+8}l.prototype.slice=function(t,e){var n,r=this.length;if((t=~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),(e=void 0===e?r:~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),e<t&&(e=t),l.TYPED_ARRAY_SUPPORT)(n=this.subarray(t,e)).__proto__=l.prototype;else{var i=e-t;n=new l(i,void 0);for(var a=0;a<i;++a)n[a]=this[a+t]}return n},l.prototype.readUIntLE=function(t,e,n){t|=0,e|=0,n||P(t,e,this.length);for(var r=this[t],i=1,a=0;++a<e&&(i*=256);)r+=this[t+a]*i;return r},l.prototype.readUIntBE=function(t,e,n){t|=0,e|=0,n||P(t,e,this.length);for(var r=this[t+--e],i=1;e>0&&(i*=256);)r+=this[t+--e]*i;return r},l.prototype.readUInt8=function(t,e){return e||P(t,1,this.length),this[t]},l.prototype.readUInt16LE=function(t,e){return e||P(t,2,this.length),this[t]|this[t+1]<<8},l.prototype.readUInt16BE=function(t,e){return e||P(t,2,this.length),this[t]<<8|this[t+1]},l.prototype.readUInt32LE=function(t,e){return e||P(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},l.prototype.readUInt32BE=function(t,e){return e||P(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},l.prototype.readIntLE=function(t,e,n){t|=0,e|=0,n||P(t,e,this.length);for(var r=this[t],i=1,a=0;++a<e&&(i*=256);)r+=this[t+a]*i;return r>=(i*=128)&&(r-=Math.pow(2,8*e)),r},l.prototype.readIntBE=function(t,e,n){t|=0,e|=0,n||P(t,e,this.length);for(var r=e,i=1,a=this[t+--r];r>0&&(i*=256);)a+=this[t+--r]*i;return a>=(i*=128)&&(a-=Math.pow(2,8*e)),a},l.prototype.readInt8=function(t,e){return e||P(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},l.prototype.readInt16LE=function(t,e){e||P(t,2,this.length);var n=this[t]|this[t+1]<<8;return 32768&n?4294901760|n:n},l.prototype.readInt16BE=function(t,e){e||P(t,2,this.length);var n=this[t+1]|this[t]<<8;return 32768&n?4294901760|n:n},l.prototype.readInt32LE=function(t,e){return e||P(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},l.prototype.readInt32BE=function(t,e){return e||P(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},l.prototype.readFloatLE=function(t,e){return e||P(t,4,this.length),i.read(this,t,!0,23,4)},l.prototype.readFloatBE=function(t,e){return e||P(t,4,this.length),i.read(this,t,!1,23,4)},l.prototype.readDoubleLE=function(t,e){return e||P(t,8,this.length),i.read(this,t,!0,52,8)},l.prototype.readDoubleBE=function(t,e){return e||P(t,8,this.length),i.read(this,t,!1,52,8)},l.prototype.writeUIntLE=function(t,e,n,r){(t=+t,e|=0,n|=0,r)||E(this,t,e,n,Math.pow(2,8*n)-1,0);var i=1,a=0;for(this[e]=255&t;++a<n&&(i*=256);)this[e+a]=t/i&255;return e+n},l.prototype.writeUIntBE=function(t,e,n,r){(t=+t,e|=0,n|=0,r)||E(this,t,e,n,Math.pow(2,8*n)-1,0);var i=n-1,a=1;for(this[e+i]=255&t;--i>=0&&(a*=256);)this[e+i]=t/a&255;return e+n},l.prototype.writeUInt8=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,1,255,0),l.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},l.prototype.writeUInt16LE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,2,65535,0),l.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):I(this,t,e,!0),e+2},l.prototype.writeUInt16BE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,2,65535,0),l.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):I(this,t,e,!1),e+2},l.prototype.writeUInt32LE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,4,4294967295,0),l.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):T(this,t,e,!0),e+4},l.prototype.writeUInt32BE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,4,4294967295,0),l.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):T(this,t,e,!1),e+4},l.prototype.writeIntLE=function(t,e,n,r){if(t=+t,e|=0,!r){var i=Math.pow(2,8*n-1);E(this,t,e,n,i-1,-i)}var a=0,o=1,s=0;for(this[e]=255&t;++a<n&&(o*=256);)t<0&&0===s&&0!==this[e+a-1]&&(s=1),this[e+a]=(t/o>>0)-s&255;return e+n},l.prototype.writeIntBE=function(t,e,n,r){if(t=+t,e|=0,!r){var i=Math.pow(2,8*n-1);E(this,t,e,n,i-1,-i)}var a=n-1,o=1,s=0;for(this[e+a]=255&t;--a>=0&&(o*=256);)t<0&&0===s&&0!==this[e+a+1]&&(s=1),this[e+a]=(t/o>>0)-s&255;return e+n},l.prototype.writeInt8=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,1,127,-128),l.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},l.prototype.writeInt16LE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,2,32767,-32768),l.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):I(this,t,e,!0),e+2},l.prototype.writeInt16BE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,2,32767,-32768),l.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):I(this,t,e,!1),e+2},l.prototype.writeInt32LE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,4,2147483647,-2147483648),l.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):T(this,t,e,!0),e+4},l.prototype.writeInt32BE=function(t,e,n){return t=+t,e|=0,n||E(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),l.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):T(this,t,e,!1),e+4},l.prototype.writeFloatLE=function(t,e,n){return L(this,t,e,!0,n)},l.prototype.writeFloatBE=function(t,e,n){return L(this,t,e,!1,n)},l.prototype.writeDoubleLE=function(t,e,n){return B(this,t,e,!0,n)},l.prototype.writeDoubleBE=function(t,e,n){return B(this,t,e,!1,n)},l.prototype.copy=function(t,e,n,r){if(n||(n=0),r||0===r||(r=this.length),e>=t.length&&(e=t.length),e||(e=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError(\"targetStart out of bounds\");if(n<0||n>=this.length)throw new RangeError(\"sourceStart out of bounds\");if(r<0)throw new RangeError(\"sourceEnd out of bounds\");r>this.length&&(r=this.length),t.length-e<r-n&&(r=t.length-e+n);var i,a=r-n;if(this===t&&n<e&&e<r)for(i=a-1;i>=0;--i)t[i+e]=this[i+n];else if(a<1e3||!l.TYPED_ARRAY_SUPPORT)for(i=0;i<a;++i)t[i+e]=this[i+n];else Uint8Array.prototype.set.call(t,this.subarray(n,n+a),e);return a},l.prototype.fill=function(t,e,n,r){if(\"string\"==typeof t){if(\"string\"==typeof e?(r=e,e=0,n=this.length):\"string\"==typeof n&&(r=n,n=this.length),1===t.length){var i=t.charCodeAt(0);i<256&&(t=i)}if(void 0!==r&&\"string\"!=typeof r)throw new TypeError(\"encoding must be a string\");if(\"string\"==typeof r&&!l.isEncoding(r))throw new TypeError(\"Unknown encoding: \"+r)}else\"number\"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<n)throw new RangeError(\"Out of range index\");if(n<=e)return this;var a;if(e>>>=0,n=void 0===n?this.length:n>>>0,t||(t=0),\"number\"==typeof t)for(a=e;a<n;++a)this[a]=t;else{var o=l.isBuffer(t)?t:F(new l(t,r).toString()),s=o.length;for(a=0;a<n-e;++a)this[a+e]=o[a%s]}return this};var M=/[^+\\/0-9A-Za-z-_]/g;function R(t){return t<16?\"0\"+t.toString(16):t.toString(16)}function F(t,e){var n;e=e||1/0;for(var r=t.length,i=null,a=[],o=0;o<r;++o){if((n=t.charCodeAt(o))>55295&&n<57344){if(!i){if(n>56319){(e-=3)>-1&&a.push(239,191,189);continue}if(o+1===r){(e-=3)>-1&&a.push(239,191,189);continue}i=n;continue}if(n<56320){(e-=3)>-1&&a.push(239,191,189),i=n;continue}n=65536+(i-55296<<10|n-56320)}else i&&(e-=3)>-1&&a.push(239,191,189);if(i=null,n<128){if((e-=1)<0)break;a.push(n)}else if(n<2048){if((e-=2)<0)break;a.push(n>>6|192,63&n|128)}else if(n<65536){if((e-=3)<0)break;a.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error(\"Invalid code point\");if((e-=4)<0)break;a.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return a}function D(t){return r.toByteArray(function(t){var e;if((t=(e=t,e.trim?e.trim():e.replace(/^\\s+|\\s+$/g,\"\")).replace(M,\"\")).length<2)return\"\";for(;t.length%4!=0;)t+=\"=\";return t}(t))}function z(t,e,n,r){for(var i=0;i<r&&!(i+n>=e.length||i>=t.length);++i)e[i+n]=t[i];return i}}).call(e,n(7))},function(t,e){var n=t.exports={version:\"2.5.3\"};\"number\"==typeof __e&&(__e=n)},function(t,e,n){var r=n(10),i=n(2),a=n(20),o=n(13),s=\"prototype\",l=function(t,e,n){var u,c,h,f=t&l.F,d=t&l.G,p=t&l.S,g=t&l.P,y=t&l.B,v=t&l.W,b=d?i:i[e]||(i[e]={}),m=b[s],w=d?r:p?r[e]:(r[e]||{})[s];for(u in d&&(n=e),n)(c=!f&&w&&void 0!==w[u])&&u in b||(h=c?w[u]:n[u],b[u]=d&&\"function\"!=typeof w[u]?n[u]:y&&c?a(h,r):v&&w[u]==h?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e[s]=t[s],e}(h):g&&\"function\"==typeof h?a(Function.call,h):h,g&&((b.virtual||(b.virtual={}))[u]=h,t&l.R&&m&&!m[u]&&o(m,u,h)))};l.F=1,l.G=2,l.S=4,l.P=8,l.B=16,l.W=32,l.U=64,l.R=128,t.exports=l},function(t,e,n){var r=n(65)(\"wks\"),i=n(38),a=n(10).Symbol,o=\"function\"==typeof a;(t.exports=function(t){return r[t]||(r[t]=o&&a[t]||(o?a:i)(\"Symbol.\"+t))}).store=r},function(t,e,n){t.exports=!n(19)(function(){return 7!=Object.defineProperty({},\"a\",{get:function(){return 7}}).a})},function(t,e,n){var r=n(14),i=n(95),a=n(58),o=Object.defineProperty;e.f=n(5)?Object.defineProperty:function(t,e,n){if(r(t),e=a(e,!0),r(n),i)try{return o(t,e,n)}catch(t){}if(\"get\"in n||\"set\"in n)throw TypeError(\"Accessors not supported!\");return\"value\"in n&&(t[e]=n.value),t}},function(t,e){var n;n=function(){return this}();try{n=n||Function(\"return this\")()||(0,eval)(\"this\")}catch(t){\"object\"==typeof window&&(n=window)}t.exports=n},function(t,e,n){\"use strict\";(function(e,n){function r(){this.fileSystem={},this.baseSystem={}}function i(t){return 0===t.indexOf(n)&&(t=t.substring(n.length)),0===t.indexOf(\"/\")&&(t=t.substring(1)),t}r.prototype.readFileSync=function(t){t=i(t);var n=this.baseSystem[t];if(n)return new e(n,\"base64\");var r=this.fileSystem[t];if(r)return r;throw\"File '\"+t+\"' not found in virtual file system\"},r.prototype.writeFileSync=function(t,e){this.fileSystem[i(t)]=e},r.prototype.bindFS=function(t){this.baseSystem=t||{}},t.exports=new r}).call(e,n(1).Buffer,\"/\")},function(t,e){t.exports=function(t){return\"object\"==typeof t?null!==t:\"function\"==typeof t}},function(t,e){var n=t.exports=\"undefined\"!=typeof window&&window.Math==Math?window:\"undefined\"!=typeof self&&self.Math==Math?self:Function(\"return this\")();\"number\"==typeof __g&&(__g=n)},function(t,e){var n,r,i=t.exports={};function a(){throw new Error(\"setTimeout has not been defined\")}function o(){throw new Error(\"clearTimeout has not been defined\")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===a||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n=\"function\"==typeof setTimeout?setTimeout:a}catch(t){n=a}try{r=\"function\"==typeof clearTimeout?clearTimeout:o}catch(t){r=o}}();var l,u=[],c=!1,h=-1;function f(){c&&l&&(c=!1,l.length?u=l.concat(u):h=-1,u.length&&d())}function d(){if(!c){var t=s(f);c=!0;for(var e=u.length;e;){for(l=u,u=[];++h<e;)l&&l[h].run();h=-1,e=u.length}l=null,c=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===o||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function p(t,e){this.fun=t,this.array=e}function g(){}i.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];u.push(new p(t,e)),1!==u.length||c||s(d)},p.prototype.run=function(){this.fun.apply(null,this.array)},i.title=\"browser\",i.browser=!0,i.env={},i.argv=[],i.version=\"\",i.versions={},i.on=g,i.addListener=g,i.once=g,i.off=g,i.removeListener=g,i.removeAllListeners=g,i.emit=g,i.prependListener=g,i.prependOnceListener=g,i.listeners=function(t){return[]},i.binding=function(t){throw new Error(\"process.binding is not supported\")},i.cwd=function(){return\"/\"},i.chdir=function(t){throw new Error(\"process.chdir is not supported\")},i.umask=function(){return 0}},function(t,e,n){(function(){var t,r;t=n(22).Number,e.resolveLength=function(e,n,r){var i;if(\"number\"==typeof e?i=e:\"function\"==typeof e?i=e.call(r,r):r&&\"string\"==typeof e?i=r[e]:n&&e instanceof t&&(i=e.decode(n)),isNaN(i))throw new Error(\"Not a fixed size\");return i},r=function(t){var e,n;for(e in null==t&&(t={}),this.enumerable=!0,this.configurable=!0,t)n=t[e],this[e]=n},e.PropertyDescriptor=r}).call(this)},function(t,e,n){var r=n(6),i=n(27);t.exports=n(5)?function(t,e,n){return r.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(9);t.exports=function(t){if(!r(t))throw TypeError(t+\" is not an object!\");return t}},function(t,e,n){t.exports=i;var r=n(31).EventEmitter;function i(){r.call(this)}n(21)(i,r),i.Readable=n(45),i.Writable=n(146),i.Duplex=n(147),i.Transform=n(148),i.PassThrough=n(149),i.Stream=i,i.prototype.pipe=function(t,e){var n=this;function i(e){t.writable&&!1===t.write(e)&&n.pause&&n.pause()}function a(){n.readable&&n.resume&&n.resume()}n.on(\"data\",i),t.on(\"drain\",a),t._isStdio||e&&!1===e.end||(n.on(\"end\",s),n.on(\"close\",l));var o=!1;function s(){o||(o=!0,t.end())}function l(){o||(o=!0,\"function\"==typeof t.destroy&&t.destroy())}function u(t){if(c(),0===r.listenerCount(this,\"error\"))throw t}function c(){n.removeListener(\"data\",i),t.removeListener(\"drain\",a),n.removeListener(\"end\",s),n.removeListener(\"close\",l),n.removeListener(\"error\",u),t.removeListener(\"error\",u),n.removeListener(\"end\",c),n.removeListener(\"close\",c),t.removeListener(\"close\",c)}return n.on(\"error\",u),t.on(\"error\",u),n.on(\"end\",c),n.on(\"close\",c),t.on(\"close\",c),t.emit(\"pipe\",n),t}},function(t,e,n){\"use strict\";var r=n(32).nextTick,i=Object.keys||function(t){var e=[];for(var n in t)e.push(n);return e};t.exports=h;var a=n(25);a.inherits=n(21);var o=n(83),s=n(46);a.inherits(h,o);for(var l=i(s.prototype),u=0;u<l.length;u++){var c=l[u];h.prototype[c]||(h.prototype[c]=s.prototype[c])}function h(t){if(!(this instanceof h))return new h(t);o.call(this,t),s.call(this,t),t&&!1===t.readable&&(this.readable=!1),t&&!1===t.writable&&(this.writable=!1),this.allowHalfOpen=!0,t&&!1===t.allowHalfOpen&&(this.allowHalfOpen=!1),this.once(\"end\",f)}function f(){this.allowHalfOpen||this._writableState.ended||r(d,this)}function d(t){t.end()}Object.defineProperty(h.prototype,\"destroyed\",{get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed&&this._writableState.destroyed)},set:function(t){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=t,this._writableState.destroyed=t)}}),h.prototype._destroy=function(t,e){this.push(null),this.end(),r(e,t)}},function(t,e,n){var r=n(54),i=n(56);t.exports=function(t){return r(i(t))}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(97);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,i){return t.call(e,n,r,i)}}return function(){return t.apply(e,arguments)}}},function(t,e){\"function\"==typeof Object.create?t.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:t.exports=function(t,e){t.super_=e;var n=function(){};n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t}},function(t,e,n){(function(){var t,r,i,a={}.hasOwnProperty;t=n(51),i=function(){function e(t,e){this.type=t,this.endian=null!=e?e:\"BE\",this.fn=this.type,\"8\"!==this.type[this.type.length-1]&&(this.fn+=this.endian)}return e.prototype.size=function(){return t.TYPES[this.type]},e.prototype.decode=function(t){return t[\"read\"+this.fn]()},e.prototype.encode=function(t,e){return t[\"write\"+this.fn](e)},e}(),e.Number=i,e.uint8=new i(\"UInt8\"),e.uint16be=e.uint16=new i(\"UInt16\",\"BE\"),e.uint16le=new i(\"UInt16\",\"LE\"),e.uint24be=e.uint24=new i(\"UInt24\",\"BE\"),e.uint24le=new i(\"UInt24\",\"LE\"),e.uint32be=e.uint32=new i(\"UInt32\",\"BE\"),e.uint32le=new i(\"UInt32\",\"LE\"),e.int8=new i(\"Int8\"),e.int16be=e.int16=new i(\"Int16\",\"BE\"),e.int16le=new i(\"Int16\",\"LE\"),e.int24be=e.int24=new i(\"Int24\",\"BE\"),e.int24le=new i(\"Int24\",\"LE\"),e.int32be=e.int32=new i(\"Int32\",\"BE\"),e.int32le=new i(\"Int32\",\"LE\"),e.floatbe=e.float=new i(\"Float\",\"BE\"),e.floatle=new i(\"Float\",\"LE\"),e.doublebe=e.double=new i(\"Double\",\"BE\"),e.doublele=new i(\"Double\",\"LE\"),r=function(t){function e(t,n,r){null==r&&(r=t>>1),e.__super__.constructor.call(this,\"Int\"+t,n),this._point=1<<r}return function(t,e){for(var n in e)a.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(e,i),e.prototype.decode=function(t){return e.__super__.decode.call(this,t)/this._point},e.prototype.encode=function(t,n){return e.__super__.encode.call(this,t,n*this._point|0)},e}(),e.Fixed=r,e.fixed16be=e.fixed16=new r(16,\"BE\"),e.fixed16le=new r(16,\"LE\"),e.fixed32be=e.fixed32=new r(32,\"BE\"),e.fixed32le=new r(32,\"LE\")}).call(this)},function(t,e){t.exports={}},function(t,e,n){\"use strict\";var r=n(207)(!0);n(61)(String,\"String\",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){(function(t){function n(t){return Object.prototype.toString.call(t)}e.isArray=function(t){return Array.isArray?Array.isArray(t):\"[object Array]\"===n(t)},e.isBoolean=function(t){return\"boolean\"==typeof t},e.isNull=function(t){return null===t},e.isNullOrUndefined=function(t){return null==t},e.isNumber=function(t){return\"number\"==typeof t},e.isString=function(t){return\"string\"==typeof t},e.isSymbol=function(t){return\"symbol\"==typeof t},e.isUndefined=function(t){return void 0===t},e.isRegExp=function(t){return\"[object RegExp]\"===n(t)},e.isObject=function(t){return\"object\"==typeof t&&null!==t},e.isDate=function(t){return\"[object Date]\"===n(t)},e.isError=function(t){return\"[object Error]\"===n(t)||t instanceof Error},e.isFunction=function(t){return\"function\"==typeof t},e.isPrimitive=function(t){return null===t||\"boolean\"==typeof t||\"number\"==typeof t||\"string\"==typeof t||\"symbol\"==typeof t||void 0===t},e.isBuffer=t.isBuffer}).call(e,n(1).Buffer)},function(t,e,n){(function(e){(function(){var r,i;r=function(){var t,n,r,a;function o(){}return r=function(t,e){return(Array(e+1).join(\"0\")+t).slice(-e)},n=/[\\n\\r\\t\\b\\f\\(\\)\\\\]/g,t={\"\\n\":\"\\\\n\",\"\\r\":\"\\\\r\",\"\\t\":\"\\\\t\",\"\\b\":\"\\\\b\",\"\\f\":\"\\\\f\",\"\\\\\":\"\\\\\\\\\",\"(\":\"\\\\(\",\")\":\"\\\\)\"},a=function(t){var e,n,r,i,a;if(1&(i=t.length))throw new Error(\"Buffer length must be even\");for(n=r=0,a=i-1;r<a;n=r+=2)e=t[n],t[n]=t[n+1],t[n+1]=e;return t},o.convert=function(s){var l,u,c,h,f,d,p,g,y;if(\"string\"==typeof s)return\"/\"+s;if(s instanceof String){for(c=!1,u=h=0,p=(g=s).length;h<p;u=h+=1)if(g.charCodeAt(u)>127){c=!0;break}return c&&(g=a(new e(\"\\ufeff\"+g,\"utf16le\")).toString(\"binary\")),\"(\"+(g=g.replace(n,function(e){return t[e]}))+\")\"}if(e.isBuffer(s))return\"<\"+s.toString(\"hex\")+\">\";if(s instanceof i)return s.toString();if(s instanceof Date)return\"(D:\"+r(s.getUTCFullYear(),4)+r(s.getUTCMonth()+1,2)+r(s.getUTCDate(),2)+r(s.getUTCHours(),2)+r(s.getUTCMinutes(),2)+r(s.getUTCSeconds(),2)+\"Z)\";if(Array.isArray(s))return\"[\"+function(){var t,e,n;for(n=[],t=0,e=s.length;t<e;t++)l=s[t],n.push(o.convert(l));return n}().join(\" \")+\"]\";if(\"[object Object]\"==={}.toString.call(s)){for(f in d=[\"<<\"],s)y=s[f],d.push(\"/\"+f+\" \"+o.convert(y));return d.push(\">>\"),d.join(\"\\n\")}return\"number\"==typeof s?o.number(s):\"\"+s},o.number=function(t){if(t>-1e21&&t<1e21)return Math.round(1e6*t)/1e6;throw new Error(\"unsupported number: \"+t)},o}(),t.exports=r,i=n(87)}).call(this)}).call(e,n(1).Buffer)},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){n(201);for(var r=n(10),i=n(13),a=n(23),o=n(4)(\"toStringTag\"),s=\"CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList\".split(\",\"),l=0;l<s.length;l++){var u=s[l],c=r[u],h=c&&c.prototype;h&&!h[o]&&i(h,o,u),a[u]=a.Array}},function(t,e,n){var r=n(101),i=n(66);t.exports=Object.keys||function(t){return r(t,i)}},function(t,e,n){var r=n(56);t.exports=function(t){return Object(r(t))}},function(t,e){function n(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function r(t){return\"function\"==typeof t}function i(t){return\"object\"==typeof t&&null!==t}function a(t){return void 0===t}t.exports=n,n.EventEmitter=n,n.prototype._events=void 0,n.prototype._maxListeners=void 0,n.defaultMaxListeners=10,n.prototype.setMaxListeners=function(t){if(\"number\"!=typeof t||t<0||isNaN(t))throw TypeError(\"n must be a positive number\");return this._maxListeners=t,this},n.prototype.emit=function(t){var e,n,o,s,l,u;if(this._events||(this._events={}),\"error\"===t&&(!this._events.error||i(this._events.error)&&!this._events.error.length)){if((e=arguments[1])instanceof Error)throw e;var c=new Error('Uncaught, unspecified \"error\" event. ('+e+\")\");throw c.context=e,c}if(a(n=this._events[t]))return!1;if(r(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:s=Array.prototype.slice.call(arguments,1),n.apply(this,s)}else if(i(n))for(s=Array.prototype.slice.call(arguments,1),o=(u=n.slice()).length,l=0;l<o;l++)u[l].apply(this,s);return!0},n.prototype.on=n.prototype.addListener=function(t,e){var o;if(!r(e))throw TypeError(\"listener must be a function\");return this._events||(this._events={}),this._events.newListener&&this.emit(\"newListener\",t,r(e.listener)?e.listener:e),this._events[t]?i(this._events[t])?this._events[t].push(e):this._events[t]=[this._events[t],e]:this._events[t]=e,i(this._events[t])&&!this._events[t].warned&&(o=a(this._maxListeners)?n.defaultMaxListeners:this._maxListeners)&&o>0&&this._events[t].length>o&&(this._events[t].warned=!0,console.trace),this},n.prototype.once=function(t,e){if(!r(e))throw TypeError(\"listener must be a function\");var n=!1;function i(){this.removeListener(t,i),n||(n=!0,e.apply(this,arguments))}return i.listener=e,this.on(t,i),this},n.prototype.removeListener=function(t,e){var n,a,o,s;if(!r(e))throw TypeError(\"listener must be a function\");if(!this._events||!this._events[t])return this;if(o=(n=this._events[t]).length,a=-1,n===e||r(n.listener)&&n.listener===e)delete this._events[t],this._events.removeListener&&this.emit(\"removeListener\",t,e);else if(i(n)){for(s=o;s-- >0;)if(n[s]===e||n[s].listener&&n[s].listener===e){a=s;break}if(a<0)return this;1===n.length?(n.length=0,delete this._events[t]):n.splice(a,1),this._events.removeListener&&this.emit(\"removeListener\",t,e)}return this},n.prototype.removeAllListeners=function(t){var e,n;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[t]&&delete this._events[t],this;if(0===arguments.length){for(e in this._events)\"removeListener\"!==e&&this.removeAllListeners(e);return this.removeAllListeners(\"removeListener\"),this._events={},this}if(r(n=this._events[t]))this.removeListener(t,n);else if(n)for(;n.length;)this.removeListener(t,n[n.length-1]);return delete this._events[t],this},n.prototype.listeners=function(t){return this._events&&this._events[t]?r(this._events[t])?[this._events[t]]:this._events[t].slice():[]},n.prototype.listenerCount=function(t){if(this._events){var e=this._events[t];if(r(e))return 1;if(e)return e.length}return 0},n.listenerCount=function(t,e){return t.listenerCount(e)}},function(t,e,n){\"use strict\";(function(e){!e.version||0===e.version.indexOf(\"v0.\")||0===e.version.indexOf(\"v1.\")&&0!==e.version.indexOf(\"v1.8.\")?t.exports={nextTick:function(t,n,r,i){if(\"function\"!=typeof t)throw new TypeError('\"callback\" argument must be a function');var a,o,s=arguments.length;switch(s){case 0:case 1:return e.nextTick(t);case 2:return e.nextTick(function(){t.call(null,n)});case 3:return e.nextTick(function(){t.call(null,n,r)});case 4:return e.nextTick(function(){t.call(null,n,r,i)});default:for(a=new Array(s-1),o=0;o<a.length;)a[o++]=arguments[o];return e.nextTick(function(){t.apply(null,a)})}}}:t.exports=e}).call(e,n(11))},function(t,e,n){var r=n(1),i=r.Buffer;function a(t,e){for(var n in t)e[n]=t[n]}function o(t,e,n){return i(t,e,n)}i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow?t.exports=r:(a(r,e),e.Buffer=o),a(i,o),o.from=function(t,e,n){if(\"number\"==typeof t)throw new TypeError(\"Argument must not be a number\");return i(t,e,n)},o.alloc=function(t,e,n){if(\"number\"!=typeof t)throw new TypeError(\"Argument must be a number\");var r=i(t);return void 0!==e?\"string\"==typeof n?r.fill(e,n):r.fill(e):r.fill(0),r},o.allocUnsafe=function(t){if(\"number\"!=typeof t)throw new TypeError(\"Argument must be a number\");return i(t)},o.allocUnsafeSlow=function(t){if(\"number\"!=typeof t)throw new TypeError(\"Argument must be a number\");return r.SlowBuffer(t)}},function(t,e,n){\"use strict\";var r=\"undefined\"!=typeof Uint8Array&&\"undefined\"!=typeof Uint16Array&&\"undefined\"!=typeof Int32Array;e.assign=function(t){for(var e,n,r=Array.prototype.slice.call(arguments,1);r.length;){var i=r.shift();if(i){if(\"object\"!=typeof i)throw new TypeError(i+\"must be non-object\");for(var a in i)e=i,n=a,Object.prototype.hasOwnProperty.call(e,n)&&(t[a]=i[a])}}return t},e.shrinkBuf=function(t,e){return t.length===e?t:t.subarray?t.subarray(0,e):(t.length=e,t)};var i={arraySet:function(t,e,n,r,i){if(e.subarray&&t.subarray)t.set(e.subarray(n,n+r),i);else for(var a=0;a<r;a++)t[i+a]=e[n+a]},flattenChunks:function(t){var e,n,r,i,a,o;for(r=0,e=0,n=t.length;e<n;e++)r+=t[e].length;for(o=new Uint8Array(r),i=0,e=0,n=t.length;e<n;e++)a=t[e],o.set(a,i),i+=a.length;return o}},a={arraySet:function(t,e,n,r,i){for(var a=0;a<r;a++)t[i+a]=e[n+a]},flattenChunks:function(t){return[].concat.apply([],t)}};e.setTyped=function(t){t?(e.Buf8=Uint8Array,e.Buf16=Uint16Array,e.Buf32=Int32Array,e.assign(e,i)):(e.Buf8=Array,e.Buf16=Array,e.Buf32=Array,e.assign(e,a))},e.setTyped(r)},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(14),i=n(100),a=n(66),o=n(64)(\"IE_PROTO\"),s=function(){},l=\"prototype\",u=function(){var t,e=n(96)(\"iframe\"),r=a.length;for(e.style.display=\"none\",n(205).appendChild(e),e.src=\"javascript:\",(t=e.contentWindow.document).open(),t.write(\"<script>document.F=Object<\\/script>\"),t.close(),u=t.F;r--;)delete u[l][a[r]];return u()};t.exports=Object.create||function(t,e){var n;return null!==t?(s[l]=r(t),n=new s,s[l]=null,n[o]=t):n=u(),void 0===e?n:i(n,e)}},function(t,e,n){var r=n(63),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return\"Symbol(\".concat(void 0===t?\"\":t,\")_\",(++n+r).toString(36))}},function(t,e,n){var r=n(6).f,i=n(18),a=n(4)(\"toStringTag\");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,a)&&r(t,a,{configurable:!0,value:e})}},function(t,e,n){var r=n(38)(\"meta\"),i=n(9),a=n(18),o=n(6).f,s=0,l=Object.isExtensible||function(){return!0},u=!n(19)(function(){return l(Object.preventExtensions({}))}),c=function(t){o(t,r,{value:{i:\"O\"+ ++s,w:{}}})},h=t.exports={KEY:r,NEED:!1,fastKey:function(t,e){if(!i(t))return\"symbol\"==typeof t?t:(\"string\"==typeof t?\"S\":\"P\")+t;if(!a(t,r)){if(!l(t))return\"F\";if(!e)return\"E\";c(t)}return t[r].i},getWeak:function(t,e){if(!a(t,r)){if(!l(t))return!0;if(!e)return!1;c(t)}return t[r].w},onFreeze:function(t){return u&&h.NEED&&l(t)&&!a(t,r)&&c(t),t}}},function(t,e,n){var r=n(20),i=n(111),a=n(112),o=n(14),s=n(37),l=n(67),u={},c={};(e=t.exports=function(t,e,n,h,f){var d,p,g,y,v=f?function(){return t}:l(t),b=r(n,h,e?2:1),m=0;if(\"function\"!=typeof v)throw TypeError(t+\" is not iterable!\");if(a(v)){for(d=s(t.length);d>m;m++)if((y=e?b(o(p=t[m])[0],p[1]):b(t[m]))===u||y===c)return y}else for(g=v.call(t);!(p=g.next()).done;)if((y=i(g,b,p.value,e))===u||y===c)return y}).BREAK=u,e.RETURN=c},function(t,e,n){\"use strict\";var r=n(0).isString,i=n(0).isNumber,a=n(0).isObject,o=n(0).isArray,s=n(78),l=/^(\\s)+/g,u=/(\\s)+$/g;function c(t){this.fontProvider=t}function h(t,e){var n=[];if(t=t.replace(/\\t/g,\"    \"),e)return n.push({text:t}),n;for(var r,i=new s(t),a=0;r=i.nextBreak();){var o=t.slice(a,r.position);r.required||o.match(/\\r?\\n$|\\r$/)?(o=o.replace(/\\r?\\n$|\\r$/,\"\"),n.push({text:o,lineEnd:!0})):n.push({text:o}),a=r.position}return n}function f(t,e){for(var n in e=e||{},t=t||{})\"text\"!=n&&t.hasOwnProperty(n)&&(e[n]=t[n]);return e}function d(t){return null==t?\"\":i(t)?t.toString():r(t)?t:t.toString()}function p(t,e,n,r){var i;return void 0!==t[n]&&null!==t[n]?t[n]:e?(e.auto(t,function(){i=e.getProperty(n)}),null!=i?i:r):r}function g(t,e,n,r,i){return e.widthOfString(t,n,i)+(r||0)*(t.length-1)}c.prototype.buildInlines=function(t,e){var n,r=function(t,e,n){var r=function(t,e){var n=[];o(t)||(t=[t]);t=function t(e){return e.reduce(function(e,n){var r=o(n.text)?t(n.text):n,i=[].concat(r).some(Array.isArray);return e.concat(i?t(r):r)},[])}(t);for(var r=0,i=t.length;r<i;r++){var s,l=t[r],u=null,c=p(l||{},e,\"noWrap\",!1);a(l)?(s=h(d(l.text),c),u=f(l)):s=h(d(l),c);for(var g=0,y=s.length;g<y;g++){var v={text:s[g].text};s[g].lineEnd&&(v.lineEnd=!0),f(u,v),n.push(v)}}return n}(e,n);if(r.length){var i=p(r[0],n,\"leadingIndent\",0);i&&(r[0].leadingCut=-i,r[0].leadingIndent=i)}return r.forEach(function(e){var r=p(e,n,\"font\",\"Roboto\"),i=p(e,n,\"fontSize\",12),a=p(e,n,\"fontFeatures\",null),o=p(e,n,\"bold\",!1),s=p(e,n,\"italics\",!1),c=p(e,n,\"color\",\"black\"),h=p(e,n,\"decoration\",null),f=p(e,n,\"decorationColor\",null),d=p(e,n,\"decorationStyle\",null),y=p(e,n,\"background\",null),v=p(e,n,\"lineHeight\",1),b=p(e,n,\"characterSpacing\",0),m=p(e,n,\"link\",null),w=p(e,n,\"linkToPage\",null),x=p(e,n,\"noWrap\",null),S=p(e,n,\"preserveLeadingSpaces\",!1),_=t.provideFont(r,o,s);e.width=g(e.text,_,i,b,a),e.height=_.lineHeight(i)*v;var k=e.text.match(l);e.leadingCut||(e.leadingCut=0),k&&!S&&(e.leadingCut+=g(k[0],_,i,b,a));var C=e.text.match(u);e.trailingCut=C?g(C[0],_,i,b,a):0,e.alignment=p(e,n,\"alignment\",\"left\"),e.font=_,e.fontSize=i,e.fontFeatures=a,e.characterSpacing=b,e.color=c,e.decoration=h,e.decorationColor=f,e.decorationStyle=d,e.background=y,e.link=m,e.linkToPage=w,e.noWrap=x}),r}(this.fontProvider,t,e),i=0,s=0;return r.forEach(function(t){var e;i=Math.max(i,t.width-t.leadingCut-t.trailingCut),n||(n={width:0,leadingCut:t.leadingCut,trailingCut:0}),n.width+=t.width,n.trailingCut=t.trailingCut,s=Math.max(s,(e=n,Math.max(0,e.width-e.leadingCut-e.trailingCut))),t.lineEnd&&(n=null)}),p({},e,\"noWrap\",!1)&&(i=s),{items:r,minWidth:i,maxWidth:s}},c.prototype.sizeOfString=function(t,e){t=t?t.toString().replace(/\\t/g,\"    \"):\"\";var n=p({},e,\"font\",\"Roboto\"),r=p({},e,\"fontSize\",12),i=p({},e,\"fontFeatures\",null),a=p({},e,\"bold\",!1),o=p({},e,\"italics\",!1),s=p({},e,\"lineHeight\",1),l=p({},e,\"characterSpacing\",0),u=this.fontProvider.provideFont(n,a,o);return{width:g(t,u,r,l,i),height:u.lineHeight(r)*s,fontSize:r,lineHeight:s,ascender:u.ascender/1e3*r,descender:u.descender/1e3*r}},c.prototype.widthOfString=function(t,e,n,r,i){return g(t,e,n,r,i)},t.exports=c},function(t,e,n){var r,i;i=n(79),r=function(){function t(t){var e,n,r;(e=\"function\"==typeof t.readUInt32BE&&\"function\"==typeof t.slice)||t instanceof Uint8Array?(e?(this.highStart=t.readUInt32BE(0),this.errorValue=t.readUInt32BE(4),n=t.readUInt32BE(8),t=t.slice(12)):(r=new DataView(t.buffer),this.highStart=r.getUint32(0),this.errorValue=r.getUint32(4),n=r.getUint32(8),t=t.subarray(12)),t=i(t,new Uint8Array(n)),t=i(t,new Uint8Array(n)),this.data=new Uint32Array(t.buffer)):(this.data=t.data,this.highStart=t.highStart,this.errorValue=t.errorValue)}return 11,5,6,32,64,63,2,32,31,2048,32,2080,2080,32,2112,4,t.prototype.get=function(t){var e;return t<0||t>1114111?this.errorValue:t<55296||t>56319&&t<=65535?(e=(this.data[t>>5]<<2)+(31&t),this.data[e]):t<=65535?(e=(this.data[2048+(t-55296>>5)]<<2)+(31&t),this.data[e]):t<this.highStart?(e=this.data[2080+(t>>11)],e=((e=this.data[e+(t>>5&63)])<<2)+(31&t),this.data[e]):this.data[this.data.length-4]},t}(),t.exports=r},function(t,e,n){\"use strict\";var r=n(0).isString;function i(t){return\"auto\"===t.width}function a(t){return null===t.width||void 0===t.width||\"*\"===t.width||\"star\"===t.width}t.exports={buildColumnWidths:function(t,e){var n=[],o=0,s=0,l=[],u=0,c=0,h=[],f=e;t.forEach(function(t){i(t)?(n.push(t),o+=t._minWidth,s+=t._maxWidth):a(t)?(l.push(t),u=Math.max(u,t._minWidth),c=Math.max(c,t._maxWidth)):h.push(t)}),h.forEach(function(t){r(t.width)&&/\\d+%/.test(t.width)&&(t.width=parseFloat(t.width)*f/100),t.width<t._minWidth&&t.elasticWidth?t._calcWidth=t._minWidth:t._calcWidth=t.width,e-=t._calcWidth});var d=o+u*l.length,p=s+c*l.length;if(d>=e)n.forEach(function(t){t._calcWidth=t._minWidth}),l.forEach(function(t){t._calcWidth=u});else{if(p<e)n.forEach(function(t){t._calcWidth=t._maxWidth,e-=t._calcWidth});else{var g=e-d,y=p-d;n.forEach(function(t){var n=t._maxWidth-t._minWidth;t._calcWidth=t._minWidth+n*g/y,e-=t._calcWidth})}if(l.length>0){var v=e/l.length;l.forEach(function(t){t._calcWidth=v})}}},measureMinMax:function(t){for(var e={min:0,max:0},n={min:0,max:0},r=0,o=0,s=t.length;o<s;o++){var l=t[o];a(l)?(n.min=Math.max(n.min,l._minWidth),n.max=Math.max(n.max,l._maxWidth),r++):i(l)?(e.min+=l._minWidth,e.max+=l._maxWidth):(e.min+=void 0!==l.width&&l.width||l._minWidth,e.max+=void 0!==l.width&&l.width||l._maxWidth)}return r&&(e.min+=r*n.min,e.max+=r*n.max),e},isAutoColumn:i,isStarColumn:a}},function(t,e,n){(e=t.exports=n(83)).Stream=e,e.Readable=e,e.Writable=n(46),e.Duplex=n(16),e.Transform=n(86),e.PassThrough=n(145)},function(t,e,n){\"use strict\";(function(e,r,i){var a=n(32).nextTick;function o(t){var e=this;this.next=null,this.entry=null,this.finish=function(){!function(t,e,n){var r=t.entry;t.entry=null;for(;r;){var i=r.callback;e.pendingcb--,i(n),r=r.next}e.corkedRequestsFree?e.corkedRequestsFree.next=t:e.corkedRequestsFree=t}(e,t)}}t.exports=b;var s,l=!e.browser&&[\"v0.10\",\"v0.9.\"].indexOf(e.version.slice(0,5))>-1?r:a;b.WritableState=v;var u=n(25);u.inherits=n(21);var c={deprecate:n(144)},h=n(84),f=n(33).Buffer,d=i.Uint8Array||function(){};var p,g=n(85);function y(){}function v(t,e){s=s||n(16),t=t||{};var r=e instanceof s;this.objectMode=!!t.objectMode,r&&(this.objectMode=this.objectMode||!!t.writableObjectMode);var i=t.highWaterMark,u=t.writableHighWaterMark,c=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:r&&(u||0===u)?u:c,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var h=!1===t.decodeStrings;this.decodeStrings=!h,this.defaultEncoding=t.defaultEncoding||\"utf8\",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){!function(t,e){var n=t._writableState,r=n.sync,i=n.writecb;if(d=n,d.writing=!1,d.writecb=null,d.length-=d.writelen,d.writelen=0,e)s=t,u=n,c=r,h=e,f=i,--u.pendingcb,c?(a(f,h),a(k,s,u),s._writableState.errorEmitted=!0,s.emit(\"error\",h)):(f(h),s._writableState.errorEmitted=!0,s.emit(\"error\",h),k(s,u));else{var o=S(n);o||n.corked||n.bufferProcessing||!n.bufferedRequest||x(t,n),r?l(w,t,n,o,i):w(t,n,o,i)}var s,u,c,h,f;var d}(e,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new o(this)}function b(t){if(s=s||n(16),!(p.call(b,this)||this instanceof s))return new b(t);this._writableState=new v(t,this),this.writable=!0,t&&(\"function\"==typeof t.write&&(this._write=t.write),\"function\"==typeof t.writev&&(this._writev=t.writev),\"function\"==typeof t.destroy&&(this._destroy=t.destroy),\"function\"==typeof t.final&&(this._final=t.final)),h.call(this)}function m(t,e,n,r,i,a,o){e.writelen=r,e.writecb=o,e.writing=!0,e.sync=!0,n?t._writev(i,e.onwrite):t._write(i,a,e.onwrite),e.sync=!1}function w(t,e,n,r){var i,a;n||(i=t,0===(a=e).length&&a.needDrain&&(a.needDrain=!1,i.emit(\"drain\"))),e.pendingcb--,r(),k(t,e)}function x(t,e){e.bufferProcessing=!0;var n=e.bufferedRequest;if(t._writev&&n&&n.next){var r=e.bufferedRequestCount,i=new Array(r),a=e.corkedRequestsFree;a.entry=n;for(var s=0,l=!0;n;)i[s]=n,n.isBuf||(l=!1),n=n.next,s+=1;i.allBuffers=l,m(t,e,!0,e.length,i,\"\",a.finish),e.pendingcb++,e.lastBufferedRequest=null,a.next?(e.corkedRequestsFree=a.next,a.next=null):e.corkedRequestsFree=new o(e),e.bufferedRequestCount=0}else{for(;n;){var u=n.chunk,c=n.encoding,h=n.callback;if(m(t,e,!1,e.objectMode?1:u.length,u,c,h),n=n.next,e.bufferedRequestCount--,e.writing)break}null===n&&(e.lastBufferedRequest=null)}e.bufferedRequest=n,e.bufferProcessing=!1}function S(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function _(t,e){t._final(function(n){e.pendingcb--,n&&t.emit(\"error\",n),e.prefinished=!0,t.emit(\"prefinish\"),k(t,e)})}function k(t,e){var n,r,i=S(e);return i&&(n=t,(r=e).prefinished||r.finalCalled||(\"function\"==typeof n._final?(r.pendingcb++,r.finalCalled=!0,a(_,n,r)):(r.prefinished=!0,n.emit(\"prefinish\"))),0===e.pendingcb&&(e.finished=!0,t.emit(\"finish\"))),i}u.inherits(b,h),v.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(v.prototype,\"buffer\",{get:c.deprecate(function(){return this.getBuffer()},\"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.\",\"DEP0003\")})}catch(t){}}(),\"function\"==typeof Symbol&&Symbol.hasInstance&&\"function\"==typeof Function.prototype[Symbol.hasInstance]?(p=Function.prototype[Symbol.hasInstance],Object.defineProperty(b,Symbol.hasInstance,{value:function(t){return!!p.call(this,t)||this===b&&(t&&t._writableState instanceof v)}})):p=function(t){return t instanceof this},b.prototype.pipe=function(){this.emit(\"error\",new Error(\"Cannot pipe, not readable\"))},b.prototype.write=function(t,e,n){var r,i,o,s,l,u,c,h,p,g,v,b=this._writableState,w=!1,x=!b.objectMode&&(r=t,f.isBuffer(r)||r instanceof d);return x&&!f.isBuffer(t)&&(i=t,t=f.from(i)),\"function\"==typeof e&&(n=e,e=null),x?e=\"buffer\":e||(e=b.defaultEncoding),\"function\"!=typeof n&&(n=y),b.ended?(p=this,g=n,v=new Error(\"write after end\"),p.emit(\"error\",v),a(g,v)):(x||(o=this,s=b,u=n,c=!0,h=!1,null===(l=t)?h=new TypeError(\"May not write null values to stream\"):\"string\"==typeof l||void 0===l||s.objectMode||(h=new TypeError(\"Invalid non-string/buffer chunk\")),h&&(o.emit(\"error\",h),a(u,h),c=!1),c))&&(b.pendingcb++,w=function(t,e,n,r,i,a){if(!n){var o=function(t,e,n){t.objectMode||!1===t.decodeStrings||\"string\"!=typeof e||(e=f.from(e,n));return e}(e,r,i);r!==o&&(n=!0,i=\"buffer\",r=o)}var s=e.objectMode?1:r.length;e.length+=s;var l=e.length<e.highWaterMark;l||(e.needDrain=!0);if(e.writing||e.corked){var u=e.lastBufferedRequest;e.lastBufferedRequest={chunk:r,encoding:i,isBuf:n,callback:a,next:null},u?u.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else m(t,e,!1,s,r,i,a);return l}(this,b,x,t,e,n)),w},b.prototype.cork=function(){this._writableState.corked++},b.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.finished||t.bufferProcessing||!t.bufferedRequest||x(this,t))},b.prototype.setDefaultEncoding=function(t){if(\"string\"==typeof t&&(t=t.toLowerCase()),!([\"hex\",\"utf8\",\"utf-8\",\"ascii\",\"binary\",\"base64\",\"ucs2\",\"ucs-2\",\"utf16le\",\"utf-16le\",\"raw\"].indexOf((t+\"\").toLowerCase())>-1))throw new TypeError(\"Unknown encoding: \"+t);return this._writableState.defaultEncoding=t,this},b.prototype._write=function(t,e,n){n(new Error(\"_write() is not implemented\"))},b.prototype._writev=null,b.prototype.end=function(t,e,n){var r=this._writableState;\"function\"==typeof t?(n=t,t=null,e=null):\"function\"==typeof e&&(n=e,e=null),null!=t&&this.write(t,e),r.corked&&(r.corked=1,this.uncork()),r.ending||r.finished||function(t,e,n){e.ending=!0,k(t,e),n&&(e.finished?a(n):t.once(\"finish\",n));e.ended=!0,t.writable=!1}(this,r,n)},Object.defineProperty(b.prototype,\"destroyed\",{get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(t){this._writableState&&(this._writableState.destroyed=t)}}),b.prototype.destroy=g.destroy,b.prototype._undestroy=g.undestroy,b.prototype._destroy=function(t,e){this.end(),e(t)}}).call(e,n(11),n(142).setImmediate,n(7))},function(t,e,n){\"use strict\";var r=n(33).Buffer,i=r.isEncoding||function(t){switch((t=\"\"+t)&&t.toLowerCase()){case\"hex\":case\"utf8\":case\"utf-8\":case\"ascii\":case\"binary\":case\"base64\":case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":case\"raw\":return!0;default:return!1}};function a(t){var e;switch(this.encoding=function(t){var e=function(t){if(!t)return\"utf8\";for(var e;;)switch(t){case\"utf8\":case\"utf-8\":return\"utf8\";case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return\"utf16le\";case\"latin1\":case\"binary\":return\"latin1\";case\"base64\":case\"ascii\":case\"hex\":return t;default:if(e)return;t=(\"\"+t).toLowerCase(),e=!0}}(t);if(\"string\"!=typeof e&&(r.isEncoding===i||!i(t)))throw new Error(\"Unknown encoding: \"+t);return e||t}(t),this.encoding){case\"utf16le\":this.text=l,this.end=u,e=4;break;case\"utf8\":this.fillLast=s,e=4;break;case\"base64\":this.text=c,this.end=h,e=3;break;default:return this.write=f,void(this.end=d)}this.lastNeed=0,this.lastTotal=0,this.lastChar=r.allocUnsafe(e)}function o(t){return t<=127?0:t>>5==6?2:t>>4==14?3:t>>3==30?4:-1}function s(t){var e=this.lastTotal-this.lastNeed,n=function(t,e,n){if(128!=(192&e[0]))return t.lastNeed=0,\"�\".repeat(n);if(t.lastNeed>1&&e.length>1){if(128!=(192&e[1]))return t.lastNeed=1,\"�\".repeat(n+1);if(t.lastNeed>2&&e.length>2&&128!=(192&e[2]))return t.lastNeed=2,\"�\".repeat(n+2)}}(this,t,e);return void 0!==n?n:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function l(t,e){if((t.length-e)%2==0){var n=t.toString(\"utf16le\",e);if(n){var r=n.charCodeAt(n.length-1);if(r>=55296&&r<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1],n.slice(0,-1)}return n}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString(\"utf16le\",e,t.length-1)}function u(t){var e=t&&t.length?this.write(t):\"\";if(this.lastNeed){var n=this.lastTotal-this.lastNeed;return e+this.lastChar.toString(\"utf16le\",0,n)}return e}function c(t,e){var n=(t.length-e)%3;return 0===n?t.toString(\"base64\",e):(this.lastNeed=3-n,this.lastTotal=3,1===n?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString(\"base64\",e,t.length-n))}function h(t){var e=t&&t.length?this.write(t):\"\";return this.lastNeed?e+this.lastChar.toString(\"base64\",0,3-this.lastNeed):e}function f(t){return t.toString(this.encoding)}function d(t){return t&&t.length?this.write(t):\"\"}e.StringDecoder=a,a.prototype.write=function(t){if(0===t.length)return\"\";var e,n;if(this.lastNeed){if(void 0===(e=this.fillLast(t)))return\"\";n=this.lastNeed,this.lastNeed=0}else n=0;return n<t.length?e?e+this.text(t,n):this.text(t,n):e||\"\"},a.prototype.end=function(t){var e=t&&t.length?this.write(t):\"\";return this.lastNeed?e+\"�\".repeat(this.lastTotal-this.lastNeed):e},a.prototype.text=function(t,e){var n=function(t,e,n){var r=e.length-1;if(r<n)return 0;var i=o(e[r]);if(i>=0)return i>0&&(t.lastNeed=i-1),i;if(--r<n)return 0;if((i=o(e[r]))>=0)return i>0&&(t.lastNeed=i-2),i;if(--r<n)return 0;if((i=o(e[r]))>=0)return i>0&&(2===i?i=0:t.lastNeed=i-3),i;return 0}(this,t,e);if(!this.lastNeed)return t.toString(\"utf8\",e);this.lastTotal=n;var r=t.length-(n-this.lastNeed);return t.copy(this.lastChar,0,r),t.toString(\"utf8\",e,r)},a.prototype.fillLast=function(t){if(this.lastNeed<=t.length)return t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),this.lastNeed-=t.length}},function(t,e,n){\"use strict\";(function(t){var r=n(1).Buffer,i=n(15).Transform,a=n(150),o=n(49),s=n(88).ok,l=n(1).kMaxLength,u=\"Cannot create final Buffer. It would be larger than 0x\"+l.toString(16)+\" bytes\";a.Z_MIN_WINDOWBITS=8,a.Z_MAX_WINDOWBITS=15,a.Z_DEFAULT_WINDOWBITS=15,a.Z_MIN_CHUNK=64,a.Z_MAX_CHUNK=1/0,a.Z_DEFAULT_CHUNK=16384,a.Z_MIN_MEMLEVEL=1,a.Z_MAX_MEMLEVEL=9,a.Z_DEFAULT_MEMLEVEL=8,a.Z_MIN_LEVEL=-1,a.Z_MAX_LEVEL=9,a.Z_DEFAULT_LEVEL=a.Z_DEFAULT_COMPRESSION;for(var c=Object.keys(a),h=0;h<c.length;h++){var f=c[h];f.match(/^Z/)&&Object.defineProperty(e,f,{enumerable:!0,value:a[f],writable:!1})}for(var d={Z_OK:a.Z_OK,Z_STREAM_END:a.Z_STREAM_END,Z_NEED_DICT:a.Z_NEED_DICT,Z_ERRNO:a.Z_ERRNO,Z_STREAM_ERROR:a.Z_STREAM_ERROR,Z_DATA_ERROR:a.Z_DATA_ERROR,Z_MEM_ERROR:a.Z_MEM_ERROR,Z_BUF_ERROR:a.Z_BUF_ERROR,Z_VERSION_ERROR:a.Z_VERSION_ERROR},p=Object.keys(d),g=0;g<p.length;g++){var y=p[g];d[d[y]]=y}function v(t,e,n){var i=[],a=0;function o(){for(var e;null!==(e=t.read());)i.push(e),a+=e.length;t.once(\"readable\",o)}function s(){var e,o=null;a>=l?o=new RangeError(u):e=r.concat(i,a),i=[],t.close(),n(o,e)}t.on(\"error\",function(e){t.removeListener(\"end\",s),t.removeListener(\"readable\",o),n(e)}),t.on(\"end\",s),t.end(e),o()}function b(t,e){if(\"string\"==typeof e&&(e=r.from(e)),!r.isBuffer(e))throw new TypeError(\"Not a string or buffer\");var n=t._finishFlushFlag;return t._processChunk(e,n)}function m(t){if(!(this instanceof m))return new m(t);P.call(this,t,a.DEFLATE)}function w(t){if(!(this instanceof w))return new w(t);P.call(this,t,a.INFLATE)}function x(t){if(!(this instanceof x))return new x(t);P.call(this,t,a.GZIP)}function S(t){if(!(this instanceof S))return new S(t);P.call(this,t,a.GUNZIP)}function _(t){if(!(this instanceof _))return new _(t);P.call(this,t,a.DEFLATERAW)}function k(t){if(!(this instanceof k))return new k(t);P.call(this,t,a.INFLATERAW)}function C(t){if(!(this instanceof C))return new C(t);P.call(this,t,a.UNZIP)}function A(t){return t===a.Z_NO_FLUSH||t===a.Z_PARTIAL_FLUSH||t===a.Z_SYNC_FLUSH||t===a.Z_FULL_FLUSH||t===a.Z_FINISH||t===a.Z_BLOCK}function P(t,n){var o=this;if(this._opts=t=t||{},this._chunkSize=t.chunkSize||e.Z_DEFAULT_CHUNK,i.call(this,t),t.flush&&!A(t.flush))throw new Error(\"Invalid flush flag: \"+t.flush);if(t.finishFlush&&!A(t.finishFlush))throw new Error(\"Invalid flush flag: \"+t.finishFlush);if(this._flushFlag=t.flush||a.Z_NO_FLUSH,this._finishFlushFlag=void 0!==t.finishFlush?t.finishFlush:a.Z_FINISH,t.chunkSize&&(t.chunkSize<e.Z_MIN_CHUNK||t.chunkSize>e.Z_MAX_CHUNK))throw new Error(\"Invalid chunk size: \"+t.chunkSize);if(t.windowBits&&(t.windowBits<e.Z_MIN_WINDOWBITS||t.windowBits>e.Z_MAX_WINDOWBITS))throw new Error(\"Invalid windowBits: \"+t.windowBits);if(t.level&&(t.level<e.Z_MIN_LEVEL||t.level>e.Z_MAX_LEVEL))throw new Error(\"Invalid compression level: \"+t.level);if(t.memLevel&&(t.memLevel<e.Z_MIN_MEMLEVEL||t.memLevel>e.Z_MAX_MEMLEVEL))throw new Error(\"Invalid memLevel: \"+t.memLevel);if(t.strategy&&t.strategy!=e.Z_FILTERED&&t.strategy!=e.Z_HUFFMAN_ONLY&&t.strategy!=e.Z_RLE&&t.strategy!=e.Z_FIXED&&t.strategy!=e.Z_DEFAULT_STRATEGY)throw new Error(\"Invalid strategy: \"+t.strategy);if(t.dictionary&&!r.isBuffer(t.dictionary))throw new Error(\"Invalid dictionary: it should be a Buffer instance\");this._handle=new a.Zlib(n);var s=this;this._hadError=!1,this._handle.onerror=function(t,n){E(s),s._hadError=!0;var r=new Error(t);r.errno=n,r.code=e.codes[n],s.emit(\"error\",r)};var l=e.Z_DEFAULT_COMPRESSION;\"number\"==typeof t.level&&(l=t.level);var u=e.Z_DEFAULT_STRATEGY;\"number\"==typeof t.strategy&&(u=t.strategy),this._handle.init(t.windowBits||e.Z_DEFAULT_WINDOWBITS,l,t.memLevel||e.Z_DEFAULT_MEMLEVEL,u,t.dictionary),this._buffer=r.allocUnsafe(this._chunkSize),this._offset=0,this._level=l,this._strategy=u,this.once(\"end\",this.close),Object.defineProperty(this,\"_closed\",{get:function(){return!o._handle},configurable:!0,enumerable:!0})}function E(e,n){n&&t.nextTick(n),e._handle&&(e._handle.close(),e._handle=null)}function I(t){t.emit(\"close\")}Object.defineProperty(e,\"codes\",{enumerable:!0,value:Object.freeze(d),writable:!1}),e.Deflate=m,e.Inflate=w,e.Gzip=x,e.Gunzip=S,e.DeflateRaw=_,e.InflateRaw=k,e.Unzip=C,e.createDeflate=function(t){return new m(t)},e.createInflate=function(t){return new w(t)},e.createDeflateRaw=function(t){return new _(t)},e.createInflateRaw=function(t){return new k(t)},e.createGzip=function(t){return new x(t)},e.createGunzip=function(t){return new S(t)},e.createUnzip=function(t){return new C(t)},e.deflate=function(t,e,n){return\"function\"==typeof e&&(n=e,e={}),v(new m(e),t,n)},e.deflateSync=function(t,e){return b(new m(e),t)},e.gzip=function(t,e,n){return\"function\"==typeof e&&(n=e,e={}),v(new x(e),t,n)},e.gzipSync=function(t,e){return b(new x(e),t)},e.deflateRaw=function(t,e,n){return\"function\"==typeof e&&(n=e,e={}),v(new _(e),t,n)},e.deflateRawSync=function(t,e){return b(new _(e),t)},e.unzip=function(t,e,n){return\"function\"==typeof e&&(n=e,e={}),v(new C(e),t,n)},e.unzipSync=function(t,e){return b(new C(e),t)},e.inflate=function(t,e,n){return\"function\"==typeof e&&(n=e,e={}),v(new w(e),t,n)},e.inflateSync=function(t,e){return b(new w(e),t)},e.gunzip=function(t,e,n){return\"function\"==typeof e&&(n=e,e={}),v(new S(e),t,n)},e.gunzipSync=function(t,e){return b(new S(e),t)},e.inflateRaw=function(t,e,n){return\"function\"==typeof e&&(n=e,e={}),v(new k(e),t,n)},e.inflateRawSync=function(t,e){return b(new k(e),t)},o.inherits(P,i),P.prototype.params=function(n,r,i){if(n<e.Z_MIN_LEVEL||n>e.Z_MAX_LEVEL)throw new RangeError(\"Invalid compression level: \"+n);if(r!=e.Z_FILTERED&&r!=e.Z_HUFFMAN_ONLY&&r!=e.Z_RLE&&r!=e.Z_FIXED&&r!=e.Z_DEFAULT_STRATEGY)throw new TypeError(\"Invalid strategy: \"+r);if(this._level!==n||this._strategy!==r){var o=this;this.flush(a.Z_SYNC_FLUSH,function(){s(o._handle,\"zlib binding closed\"),o._handle.params(n,r),o._hadError||(o._level=n,o._strategy=r,i&&i())})}else t.nextTick(i)},P.prototype.reset=function(){return s(this._handle,\"zlib binding closed\"),this._handle.reset()},P.prototype._flush=function(t){this._transform(r.alloc(0),\"\",t)},P.prototype.flush=function(e,n){var i=this,o=this._writableState;(\"function\"==typeof e||void 0===e&&!n)&&(n=e,e=a.Z_FULL_FLUSH),o.ended?n&&t.nextTick(n):o.ending?n&&this.once(\"end\",n):o.needDrain?n&&this.once(\"drain\",function(){return i.flush(e,n)}):(this._flushFlag=e,this.write(r.alloc(0),\"\",n))},P.prototype.close=function(e){E(this,e),t.nextTick(I,this)},P.prototype._transform=function(t,e,n){var i,o=this._writableState,s=(o.ending||o.ended)&&(!t||o.length===t.length);return null===t||r.isBuffer(t)?this._handle?(s?i=this._finishFlushFlag:(i=this._flushFlag,t.length>=o.length&&(this._flushFlag=this._opts.flush||a.Z_NO_FLUSH)),void this._processChunk(t,i,n)):n(new Error(\"zlib binding closed\")):n(new Error(\"invalid input\"))},P.prototype._processChunk=function(t,e,n){var i=t&&t.length,a=this._chunkSize-this._offset,o=0,c=this,h=\"function\"==typeof n;if(!h){var f,d=[],p=0;this.on(\"error\",function(t){f=t}),s(this._handle,\"zlib binding closed\");do{var g=this._handle.writeSync(e,t,o,i,this._buffer,this._offset,a)}while(!this._hadError&&b(g[0],g[1]));if(this._hadError)throw f;if(p>=l)throw E(this),new RangeError(u);var y=r.concat(d,p);return E(this),y}s(this._handle,\"zlib binding closed\");var v=this._handle.write(e,t,o,i,this._buffer,this._offset,a);function b(l,u){if(this&&(this.buffer=null,this.callback=null),!c._hadError){var f=a-u;if(s(f>=0,\"have should not go down\"),f>0){var g=c._buffer.slice(c._offset,c._offset+f);c._offset+=f,h?c.push(g):(d.push(g),p+=g.length)}if((0===u||c._offset>=c._chunkSize)&&(a=c._chunkSize,c._offset=0,c._buffer=r.allocUnsafe(c._chunkSize)),0===u){if(o+=i-l,i=l,!h)return!0;var y=c._handle.write(e,t,o,i,c._buffer,c._offset,c._chunkSize);return y.callback=b,void(y.buffer=t)}if(!h)return!1;n()}}v.buffer=t,v.callback=b},o.inherits(m,P),o.inherits(w,P),o.inherits(x,P),o.inherits(S,P),o.inherits(_,P),o.inherits(k,P),o.inherits(C,P)}).call(e,n(11))},function(t,e,n){(function(t,r){var i=/%[sdj%]/g;e.format=function(t){if(!v(t)){for(var e=[],n=0;n<arguments.length;n++)e.push(s(arguments[n]));return e.join(\" \")}n=1;for(var r=arguments,a=r.length,o=String(t).replace(i,function(t){if(\"%%\"===t)return\"%\";if(n>=a)return t;switch(t){case\"%s\":return String(r[n++]);case\"%d\":return Number(r[n++]);case\"%j\":try{return JSON.stringify(r[n++])}catch(t){return\"[Circular]\"}default:return t}}),l=r[n];n<a;l=r[++n])g(l)||!w(l)?o+=\" \"+l:o+=\" \"+s(l);return o},e.deprecate=function(n,i){if(b(t.process))return function(){return e.deprecate(n,i).apply(this,arguments)};if(!0===r.noDeprecation)return n;var a=!1;return function(){if(!a){if(r.throwDeprecation)throw new Error(i);r.traceDeprecation,a=!0}return n.apply(this,arguments)}};var a,o={};function s(t,n){var r={seen:[],stylize:u};return arguments.length>=3&&(r.depth=arguments[2]),arguments.length>=4&&(r.colors=arguments[3]),p(n)?r.showHidden=n:n&&e._extend(r,n),b(r.showHidden)&&(r.showHidden=!1),b(r.depth)&&(r.depth=2),b(r.colors)&&(r.colors=!1),b(r.customInspect)&&(r.customInspect=!0),r.colors&&(r.stylize=l),c(r,t,r.depth)}function l(t,e){var n=s.styles[e];return n?\"\u001b[\"+s.colors[n][0]+\"m\"+t+\"\u001b[\"+s.colors[n][1]+\"m\":t}function u(t,e){return t}function c(t,n,r){if(t.customInspect&&n&&_(n.inspect)&&n.inspect!==e.inspect&&(!n.constructor||n.constructor.prototype!==n)){var i=n.inspect(r,t);return v(i)||(i=c(t,i,r)),i}var a=function(t,e){if(b(e))return t.stylize(\"undefined\",\"undefined\");if(v(e)){var n=\"'\"+JSON.stringify(e).replace(/^\"|\"$/g,\"\").replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"')+\"'\";return t.stylize(n,\"string\")}if(y(e))return t.stylize(\"\"+e,\"number\");if(p(e))return t.stylize(\"\"+e,\"boolean\");if(g(e))return t.stylize(\"null\",\"null\")}(t,n);if(a)return a;var o,s=Object.keys(n),l=(o={},s.forEach(function(t,e){o[t]=!0}),o);if(t.showHidden&&(s=Object.getOwnPropertyNames(n)),S(n)&&(s.indexOf(\"message\")>=0||s.indexOf(\"description\")>=0))return h(n);if(0===s.length){if(_(n)){var u=n.name?\": \"+n.name:\"\";return t.stylize(\"[Function\"+u+\"]\",\"special\")}if(m(n))return t.stylize(RegExp.prototype.toString.call(n),\"regexp\");if(x(n))return t.stylize(Date.prototype.toString.call(n),\"date\");if(S(n))return h(n)}var w,k=\"\",A=!1,P=[\"{\",\"}\"];(d(n)&&(A=!0,P=[\"[\",\"]\"]),_(n))&&(k=\" [Function\"+(n.name?\": \"+n.name:\"\")+\"]\");return m(n)&&(k=\" \"+RegExp.prototype.toString.call(n)),x(n)&&(k=\" \"+Date.prototype.toUTCString.call(n)),S(n)&&(k=\" \"+h(n)),0!==s.length||A&&0!=n.length?r<0?m(n)?t.stylize(RegExp.prototype.toString.call(n),\"regexp\"):t.stylize(\"[Object]\",\"special\"):(t.seen.push(n),w=A?function(t,e,n,r,i){for(var a=[],o=0,s=e.length;o<s;++o)C(e,String(o))?a.push(f(t,e,n,r,String(o),!0)):a.push(\"\");return i.forEach(function(i){i.match(/^\\d+$/)||a.push(f(t,e,n,r,i,!0))}),a}(t,n,r,l,s):s.map(function(e){return f(t,n,r,l,e,A)}),t.seen.pop(),function(t,e,n){if(t.reduce(function(t,e){return 0,e.indexOf(\"\\n\")>=0&&0,t+e.replace(/\\u001b\\[\\d\\d?m/g,\"\").length+1},0)>60)return n[0]+(\"\"===e?\"\":e+\"\\n \")+\" \"+t.join(\",\\n  \")+\" \"+n[1];return n[0]+e+\" \"+t.join(\", \")+\" \"+n[1]}(w,k,P)):P[0]+k+P[1]}function h(t){return\"[\"+Error.prototype.toString.call(t)+\"]\"}function f(t,e,n,r,i,a){var o,s,l;if((l=Object.getOwnPropertyDescriptor(e,i)||{value:e[i]}).get?s=l.set?t.stylize(\"[Getter/Setter]\",\"special\"):t.stylize(\"[Getter]\",\"special\"):l.set&&(s=t.stylize(\"[Setter]\",\"special\")),C(r,i)||(o=\"[\"+i+\"]\"),s||(t.seen.indexOf(l.value)<0?(s=g(n)?c(t,l.value,null):c(t,l.value,n-1)).indexOf(\"\\n\")>-1&&(s=a?s.split(\"\\n\").map(function(t){return\"  \"+t}).join(\"\\n\").substr(2):\"\\n\"+s.split(\"\\n\").map(function(t){return\"   \"+t}).join(\"\\n\")):s=t.stylize(\"[Circular]\",\"special\")),b(o)){if(a&&i.match(/^\\d+$/))return s;(o=JSON.stringify(\"\"+i)).match(/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?(o=o.substr(1,o.length-2),o=t.stylize(o,\"name\")):(o=o.replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"').replace(/(^\"|\"$)/g,\"'\"),o=t.stylize(o,\"string\"))}return o+\": \"+s}function d(t){return Array.isArray(t)}function p(t){return\"boolean\"==typeof t}function g(t){return null===t}function y(t){return\"number\"==typeof t}function v(t){return\"string\"==typeof t}function b(t){return void 0===t}function m(t){return w(t)&&\"[object RegExp]\"===k(t)}function w(t){return\"object\"==typeof t&&null!==t}function x(t){return w(t)&&\"[object Date]\"===k(t)}function S(t){return w(t)&&(\"[object Error]\"===k(t)||t instanceof Error)}function _(t){return\"function\"==typeof t}function k(t){return Object.prototype.toString.call(t)}e.debuglog=function(t){if(b(a)&&(a=r.env.NODE_DEBUG||\"\"),t=t.toUpperCase(),!o[t])if(new RegExp(\"\\\\b\"+t+\"\\\\b\",\"i\").test(a)){r.pid;o[t]=function(){e.format.apply(e,arguments)}}else o[t]=function(){};return o[t]},e.inspect=s,s.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},s.styles={special:\"cyan\",number:\"yellow\",boolean:\"yellow\",undefined:\"grey\",null:\"bold\",string:\"green\",date:\"magenta\",regexp:\"red\"},e.isArray=d,e.isBoolean=p,e.isNull=g,e.isNullOrUndefined=function(t){return null==t},e.isNumber=y,e.isString=v,e.isSymbol=function(t){return\"symbol\"==typeof t},e.isUndefined=b,e.isRegExp=m,e.isObject=w,e.isDate=x,e.isError=S,e.isFunction=_,e.isPrimitive=function(t){return null===t||\"boolean\"==typeof t||\"number\"==typeof t||\"string\"==typeof t||\"symbol\"==typeof t||void 0===t},e.isBuffer=n(151);function C(t,e){return Object.prototype.hasOwnProperty.call(t,e)}e.log=function(){},e.inherits=n(152),e._extend=function(t,e){if(!e||!w(e))return t;for(var n=Object.keys(e),r=n.length;r--;)t[n[r]]=e[n[r]];return t}}).call(e,n(7),n(11))},function(t,e,n){(function(e){(function(){var r,i,a,o;o=n(167),i=function(){function t(){throw new Error(\"Cannot construct a PDFFont directly.\")}return t.open=function(t,n,i,s){var l;if(\"string\"==typeof n){if(a.isStandardFont(n))return new a(t,n,s);l=o.openSync(n,i)}else e.isBuffer(n)?l=o.create(n,i):n instanceof Uint8Array?l=o.create(new e(n),i):n instanceof ArrayBuffer&&(l=o.create(new e(new Uint8Array(n)),i));if(null==l)throw new Error(\"Not a supported font format or standard PDF font.\");return new r(t,l,s)},t.prototype.encode=function(t){throw new Error(\"Must be implemented by subclasses\")},t.prototype.widthOfString=function(t){throw new Error(\"Must be implemented by subclasses\")},t.prototype.ref=function(){return null!=this.dictionary?this.dictionary:this.dictionary=this.document.ref()},t.prototype.finalize=function(){if(!this.embedded&&null!=this.dictionary)return this.embed(),this.embedded=!0},t.prototype.embed=function(){throw new Error(\"Must be implemented by subclasses\")},t.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.descender)/1e3*t},t}(),t.exports=i,a=n(292),r=n(294)}).call(this)}).call(e,n(1).Buffer)},function(t,e,n){(function(e){(function(){var r,i;try{i=n(52)}catch(t){}r=function(){var t;function n(t){this.buffer=t,this.pos=0,this.length=this.buffer.length}for(t in n.TYPES={UInt8:1,UInt16:2,UInt24:3,UInt32:4,Int8:1,Int16:2,Int24:3,Int32:4,Float:4,Double:8},e.prototype)\"read\"===t.slice(0,4)&&function(t){var e;e=n.TYPES[t.replace(/read|[BL]E/g,\"\")],n.prototype[t]=function(){var n;return n=this.buffer[t](this.pos),this.pos+=e,n}}(t);return n.prototype.readString=function(t,n){var r,a,o,s,l;switch(null==n&&(n=\"ascii\"),n){case\"utf16le\":case\"ucs2\":case\"utf8\":case\"ascii\":return this.buffer.toString(n,this.pos,this.pos+=t);case\"utf16be\":for(o=s=0,l=(r=new e(this.readBuffer(t))).length-1;s<l;o=s+=2)a=r[o],r[o]=r[o+1],r[o+1]=a;return r.toString(\"utf16le\");default:if(r=this.readBuffer(t),i)try{return i.decode(r,n)}catch(t){}return r}},n.prototype.readBuffer=function(t){return this.buffer.slice(this.pos,this.pos+=t)},n.prototype.readUInt24BE=function(){return(this.readUInt16BE()<<8)+this.readUInt8()},n.prototype.readUInt24LE=function(){return this.readUInt16LE()+(this.readUInt8()<<16)},n.prototype.readInt24BE=function(){return(this.readInt16BE()<<8)+this.readUInt8()},n.prototype.readInt24LE=function(){return this.readUInt16LE()+(this.readInt8()<<16)},n}(),t.exports=r}).call(this)}).call(e,n(1).Buffer)},function(t,e,n){\"use strict\";(function(e){var r=n(1).Buffer,i=n(170),a=t.exports;a.encodings=null,a.defaultCharUnicode=\"�\",a.defaultCharSingleByte=\"?\",a.encode=function(t,e,n){t=\"\"+(t||\"\");var i=a.getEncoder(e,n),o=i.write(t),s=i.end();return s&&s.length>0?r.concat([o,s]):o},a.decode=function(t,e,n){\"string\"==typeof t&&(a.skipDecodeWarning||(a.skipDecodeWarning=!0),t=new r(\"\"+(t||\"\"),\"binary\"));var i=a.getDecoder(e,n),o=i.write(t),s=i.end();return s?o+s:o},a.encodingExists=function(t){try{return a.getCodec(t),!0}catch(t){return!1}},a.toEncoding=a.encode,a.fromEncoding=a.decode,a._codecDataCache={},a.getCodec=function(t){a.encodings||(a.encodings=n(171));for(var e=(\"\"+t).toLowerCase().replace(/[^0-9a-z]|:\\d{4}$/g,\"\"),r={};;){var i=a._codecDataCache[e];if(i)return i;var o=a.encodings[e];switch(typeof o){case\"string\":e=o;break;case\"object\":for(var s in o)r[s]=o[s];r.encodingName||(r.encodingName=e),e=o.type;break;case\"function\":return r.encodingName||(r.encodingName=e),i=new o(r,a),a._codecDataCache[r.encodingName]=i,i;default:throw new Error(\"Encoding not recognized: '\"+t+\"' (searched as: '\"+e+\"')\")}}},a.getEncoder=function(t,e){var n=a.getCodec(t),r=new n.encoder(e,n);return n.bomAware&&e&&e.addBOM&&(r=new i.PrependBOM(r,e)),r},a.getDecoder=function(t,e){var n=a.getCodec(t),r=new n.decoder(e,n);return!n.bomAware||e&&!1===e.stripBOM||(r=new i.StripBOM(r,e)),r};var o=void 0!==e&&e.versions&&e.versions.node;if(o){var s=o.split(\".\").map(Number);(s[0]>0||s[1]>=10)&&n(185)(a),n(186)(a)}}).call(e,n(11))},function(t,e){t.exports=[[\"0\",\"\\0\",127,\"€\"],[\"8140\",\"丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪\",5,\"乲乴\",9,\"乿\",6,\"亇亊\"],[\"8180\",\"亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂\",6,\"伋伌伒\",4,\"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾\",4,\"佄佅佇\",5,\"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢\"],[\"8240\",\"侤侫侭侰\",4,\"侶\",8,\"俀俁係俆俇俈俉俋俌俍俒\",4,\"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿\",11],[\"8280\",\"個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯\",10,\"倻倽倿偀偁偂偄偅偆偉偊偋偍偐\",4,\"偖偗偘偙偛偝\",7,\"偦\",5,\"偭\",8,\"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎\",20,\"傤傦傪傫傭\",4,\"傳\",6,\"傼\"],[\"8340\",\"傽\",17,\"僐\",5,\"僗僘僙僛\",10,\"僨僩僪僫僯僰僱僲僴僶\",4,\"僼\",9,\"儈\"],[\"8380\",\"儉儊儌\",5,\"儓\",13,\"儢\",28,\"兂兇兊兌兎兏児兒兓兗兘兙兛兝\",4,\"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦\",4,\"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒\",5],[\"8440\",\"凘凙凚凜凞凟凢凣凥\",5,\"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄\",5,\"剋剎剏剒剓剕剗剘\"],[\"8480\",\"剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳\",9,\"剾劀劃\",4,\"劉\",6,\"劑劒劔\",6,\"劜劤劥劦劧劮劯劰労\",9,\"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務\",5,\"勠勡勢勣勥\",10,\"勱\",7,\"勻勼勽匁匂匃匄匇匉匊匋匌匎\"],[\"8540\",\"匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯\",9,\"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏\"],[\"8580\",\"厐\",4,\"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯\",6,\"厷厸厹厺厼厽厾叀參\",4,\"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝\",4,\"呣呥呧呩\",7,\"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡\"],[\"8640\",\"咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠\",4,\"哫哬哯哰哱哴\",5,\"哻哾唀唂唃唄唅唈唊\",4,\"唒唓唕\",5,\"唜唝唞唟唡唥唦\"],[\"8680\",\"唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋\",4,\"啑啒啓啔啗\",4,\"啝啞啟啠啢啣啨啩啫啯\",5,\"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠\",6,\"喨\",8,\"喲喴営喸喺喼喿\",4,\"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗\",4,\"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸\",4,\"嗿嘂嘃嘄嘅\"],[\"8740\",\"嘆嘇嘊嘋嘍嘐\",7,\"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀\",11,\"噏\",4,\"噕噖噚噛噝\",4],[\"8780\",\"噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽\",7,\"嚇\",6,\"嚐嚑嚒嚔\",14,\"嚤\",10,\"嚰\",6,\"嚸嚹嚺嚻嚽\",12,\"囋\",8,\"囕囖囘囙囜団囥\",5,\"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國\",6],[\"8840\",\"園\",9,\"圝圞圠圡圢圤圥圦圧圫圱圲圴\",4,\"圼圽圿坁坃坄坅坆坈坉坋坒\",4,\"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀\"],[\"8880\",\"垁垇垈垉垊垍\",4,\"垔\",6,\"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹\",8,\"埄\",6,\"埌埍埐埑埓埖埗埛埜埞埡埢埣埥\",7,\"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥\",4,\"堫\",4,\"報堲堳場堶\",7],[\"8940\",\"堾\",5,\"塅\",6,\"塎塏塐塒塓塕塖塗塙\",4,\"塟\",5,\"塦\",4,\"塭\",16,\"塿墂墄墆墇墈墊墋墌\"],[\"8980\",\"墍\",4,\"墔\",4,\"墛墜墝墠\",7,\"墪\",17,\"墽墾墿壀壂壃壄壆\",10,\"壒壓壔壖\",13,\"壥\",5,\"壭壯壱売壴壵壷壸壺\",7,\"夃夅夆夈\",4,\"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻\"],[\"8a40\",\"夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛\",4,\"奡奣奤奦\",12,\"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦\"],[\"8a80\",\"妧妬妭妰妱妳\",5,\"妺妼妽妿\",6,\"姇姈姉姌姍姎姏姕姖姙姛姞\",4,\"姤姦姧姩姪姫姭\",11,\"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪\",6,\"娳娵娷\",4,\"娽娾娿婁\",4,\"婇婈婋\",9,\"婖婗婘婙婛\",5],[\"8b40\",\"婡婣婤婥婦婨婩婫\",8,\"婸婹婻婼婽婾媀\",17,\"媓\",6,\"媜\",13,\"媫媬\"],[\"8b80\",\"媭\",4,\"媴媶媷媹\",4,\"媿嫀嫃\",5,\"嫊嫋嫍\",4,\"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬\",4,\"嫲\",22,\"嬊\",11,\"嬘\",25,\"嬳嬵嬶嬸\",7,\"孁\",6],[\"8c40\",\"孈\",7,\"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏\"],[\"8c80\",\"寑寔\",8,\"寠寢寣實寧審\",4,\"寯寱\",6,\"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧\",6,\"屰屲\",6,\"屻屼屽屾岀岃\",4,\"岉岊岋岎岏岒岓岕岝\",4,\"岤\",4],[\"8d40\",\"岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅\",5,\"峌\",5,\"峓\",5,\"峚\",6,\"峢峣峧峩峫峬峮峯峱\",9,\"峼\",4],[\"8d80\",\"崁崄崅崈\",5,\"崏\",4,\"崕崗崘崙崚崜崝崟\",4,\"崥崨崪崫崬崯\",4,\"崵\",7,\"崿\",7,\"嵈嵉嵍\",10,\"嵙嵚嵜嵞\",10,\"嵪嵭嵮嵰嵱嵲嵳嵵\",12,\"嶃\",21,\"嶚嶛嶜嶞嶟嶠\"],[\"8e40\",\"嶡\",21,\"嶸\",12,\"巆\",6,\"巎\",12,\"巜巟巠巣巤巪巬巭\"],[\"8e80\",\"巰巵巶巸\",4,\"巿帀帄帇帉帊帋帍帎帒帓帗帞\",7,\"帨\",4,\"帯帰帲\",4,\"帹帺帾帿幀幁幃幆\",5,\"幍\",6,\"幖\",4,\"幜幝幟幠幣\",14,\"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨\",4,\"庮\",4,\"庴庺庻庼庽庿\",6],[\"8f40\",\"廆廇廈廋\",5,\"廔廕廗廘廙廚廜\",11,\"廩廫\",8,\"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤\"],[\"8f80\",\"弨弫弬弮弰弲\",6,\"弻弽弾弿彁\",14,\"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢\",5,\"復徫徬徯\",5,\"徶徸徹徺徻徾\",4,\"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇\"],[\"9040\",\"怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰\",4,\"怶\",4,\"怽怾恀恄\",6,\"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀\"],[\"9080\",\"悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽\",7,\"惇惈惉惌\",4,\"惒惓惔惖惗惙惛惞惡\",4,\"惪惱惲惵惷惸惻\",4,\"愂愃愄愅愇愊愋愌愐\",4,\"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬\",18,\"慀\",6],[\"9140\",\"慇慉態慍慏慐慒慓慔慖\",6,\"慞慟慠慡慣慤慥慦慩\",6,\"慱慲慳慴慶慸\",18,\"憌憍憏\",4,\"憕\"],[\"9180\",\"憖\",6,\"憞\",8,\"憪憫憭\",9,\"憸\",5,\"憿懀懁懃\",4,\"應懌\",4,\"懓懕\",16,\"懧\",13,\"懶\",8,\"戀\",5,\"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸\",4,\"扂扄扅扆扊\"],[\"9240\",\"扏扐払扖扗扙扚扜\",6,\"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋\",5,\"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁\"],[\"9280\",\"拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳\",5,\"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖\",7,\"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙\",6,\"採掤掦掫掯掱掲掵掶掹掻掽掿揀\"],[\"9340\",\"揁揂揃揅揇揈揊揋揌揑揓揔揕揗\",6,\"揟揢揤\",4,\"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆\",4,\"損搎搑搒搕\",5,\"搝搟搢搣搤\"],[\"9380\",\"搥搧搨搩搫搮\",5,\"搵\",4,\"搻搼搾摀摂摃摉摋\",6,\"摓摕摖摗摙\",4,\"摟\",7,\"摨摪摫摬摮\",9,\"摻\",6,\"撃撆撈\",8,\"撓撔撗撘撚撛撜撝撟\",4,\"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆\",6,\"擏擑擓擔擕擖擙據\"],[\"9440\",\"擛擜擝擟擠擡擣擥擧\",24,\"攁\",7,\"攊\",7,\"攓\",4,\"攙\",8],[\"9480\",\"攢攣攤攦\",4,\"攬攭攰攱攲攳攷攺攼攽敀\",4,\"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數\",14,\"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱\",7,\"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘\",7,\"旡旣旤旪旫\"],[\"9540\",\"旲旳旴旵旸旹旻\",4,\"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷\",4,\"昽昿晀時晄\",6,\"晍晎晐晑晘\"],[\"9580\",\"晙晛晜晝晞晠晢晣晥晧晩\",4,\"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘\",4,\"暞\",8,\"暩\",4,\"暯\",4,\"暵暶暷暸暺暻暼暽暿\",25,\"曚曞\",7,\"曧曨曪\",5,\"曱曵曶書曺曻曽朁朂會\"],[\"9640\",\"朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠\",5,\"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗\",4,\"杝杢杣杤杦杧杫杬杮東杴杶\"],[\"9680\",\"杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹\",7,\"柂柅\",9,\"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵\",7,\"柾栁栂栃栄栆栍栐栒栔栕栘\",4,\"栞栟栠栢\",6,\"栫\",6,\"栴栵栶栺栻栿桇桋桍桏桒桖\",5],[\"9740\",\"桜桝桞桟桪桬\",7,\"桵桸\",8,\"梂梄梇\",7,\"梐梑梒梔梕梖梘\",9,\"梣梤梥梩梪梫梬梮梱梲梴梶梷梸\"],[\"9780\",\"梹\",6,\"棁棃\",5,\"棊棌棎棏棐棑棓棔棖棗棙棛\",4,\"棡棢棤\",9,\"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆\",4,\"椌椏椑椓\",11,\"椡椢椣椥\",7,\"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃\",16,\"楕楖楘楙楛楜楟\"],[\"9840\",\"楡楢楤楥楧楨楩楪楬業楯楰楲\",4,\"楺楻楽楾楿榁榃榅榊榋榌榎\",5,\"榖榗榙榚榝\",9,\"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽\"],[\"9880\",\"榾榿槀槂\",7,\"構槍槏槑槒槓槕\",5,\"槜槝槞槡\",11,\"槮槯槰槱槳\",9,\"槾樀\",9,\"樋\",11,\"標\",5,\"樠樢\",5,\"権樫樬樭樮樰樲樳樴樶\",6,\"樿\",4,\"橅橆橈\",7,\"橑\",6,\"橚\"],[\"9940\",\"橜\",4,\"橢橣橤橦\",10,\"橲\",6,\"橺橻橽橾橿檁檂檃檅\",8,\"檏檒\",4,\"檘\",7,\"檡\",5],[\"9980\",\"檧檨檪檭\",114,\"欥欦欨\",6],[\"9a40\",\"欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍\",11,\"歚\",7,\"歨歩歫\",13,\"歺歽歾歿殀殅殈\"],[\"9a80\",\"殌殎殏殐殑殔殕殗殘殙殜\",4,\"殢\",7,\"殫\",7,\"殶殸\",6,\"毀毃毄毆\",4,\"毌毎毐毑毘毚毜\",4,\"毢\",7,\"毬毭毮毰毱毲毴毶毷毸毺毻毼毾\",6,\"氈\",4,\"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋\",4,\"汑汒汓汖汘\"],[\"9b40\",\"汙汚汢汣汥汦汧汫\",4,\"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘\"],[\"9b80\",\"泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟\",5,\"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽\",4,\"涃涄涆涇涊涋涍涏涐涒涖\",4,\"涜涢涥涬涭涰涱涳涴涶涷涹\",5,\"淁淂淃淈淉淊\"],[\"9c40\",\"淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽\",7,\"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵\"],[\"9c80\",\"渶渷渹渻\",7,\"湅\",7,\"湏湐湑湒湕湗湙湚湜湝湞湠\",10,\"湬湭湯\",14,\"満溁溂溄溇溈溊\",4,\"溑\",6,\"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪\",5],[\"9d40\",\"滰滱滲滳滵滶滷滸滺\",7,\"漃漄漅漇漈漊\",4,\"漐漑漒漖\",9,\"漡漢漣漥漦漧漨漬漮漰漲漴漵漷\",6,\"漿潀潁潂\"],[\"9d80\",\"潃潄潅潈潉潊潌潎\",9,\"潙潚潛潝潟潠潡潣潤潥潧\",5,\"潯潰潱潳潵潶潷潹潻潽\",6,\"澅澆澇澊澋澏\",12,\"澝澞澟澠澢\",4,\"澨\",10,\"澴澵澷澸澺\",5,\"濁濃\",5,\"濊\",6,\"濓\",10,\"濟濢濣濤濥\"],[\"9e40\",\"濦\",7,\"濰\",32,\"瀒\",7,\"瀜\",6,\"瀤\",6],[\"9e80\",\"瀫\",9,\"瀶瀷瀸瀺\",17,\"灍灎灐\",13,\"灟\",11,\"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞\",12,\"炰炲炴炵炶為炾炿烄烅烆烇烉烋\",12,\"烚\"],[\"9f40\",\"烜烝烞烠烡烢烣烥烪烮烰\",6,\"烸烺烻烼烾\",10,\"焋\",4,\"焑焒焔焗焛\",10,\"焧\",7,\"焲焳焴\"],[\"9f80\",\"焵焷\",13,\"煆煇煈煉煋煍煏\",12,\"煝煟\",4,\"煥煩\",4,\"煯煰煱煴煵煶煷煹煻煼煾\",5,\"熅\",4,\"熋熌熍熎熐熑熒熓熕熖熗熚\",4,\"熡\",6,\"熩熪熫熭\",5,\"熴熶熷熸熺\",8,\"燄\",9,\"燏\",4],[\"a040\",\"燖\",9,\"燡燢燣燤燦燨\",5,\"燯\",9,\"燺\",11,\"爇\",19],[\"a080\",\"爛爜爞\",9,\"爩爫爭爮爯爲爳爴爺爼爾牀\",6,\"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅\",4,\"犌犎犐犑犓\",11,\"犠\",11,\"犮犱犲犳犵犺\",6,\"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛\"],[\"a1a1\",\"　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈\",7,\"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓\"],[\"a2a1\",\"ⅰ\",9],[\"a2b1\",\"⒈\",19,\"⑴\",19,\"①\",9],[\"a2e5\",\"㈠\",9],[\"a2f1\",\"Ⅰ\",11],[\"a3a1\",\"！＂＃￥％\",88,\"￣\"],[\"a4a1\",\"ぁ\",82],[\"a5a1\",\"ァ\",85],[\"a6a1\",\"Α\",16,\"Σ\",6],[\"a6c1\",\"α\",16,\"σ\",6],[\"a6e0\",\"︵︶︹︺︿﹀︽︾﹁﹂﹃﹄\"],[\"a6ee\",\"︻︼︷︸︱\"],[\"a6f4\",\"︳︴\"],[\"a7a1\",\"А\",5,\"ЁЖ\",25],[\"a7d1\",\"а\",5,\"ёж\",25],[\"a840\",\"ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═\",35,\"▁\",6],[\"a880\",\"█\",7,\"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞\"],[\"a8a1\",\"āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ\"],[\"a8bd\",\"ńň\"],[\"a8c0\",\"ɡ\"],[\"a8c5\",\"ㄅ\",36],[\"a940\",\"〡\",8,\"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤\"],[\"a959\",\"℡㈱\"],[\"a95c\",\"‐\"],[\"a960\",\"ー゛゜ヽヾ〆ゝゞ﹉\",9,\"﹔﹕﹖﹗﹙\",8],[\"a980\",\"﹢\",4,\"﹨﹩﹪﹫\"],[\"a996\",\"〇\"],[\"a9a4\",\"─\",75],[\"aa40\",\"狜狝狟狢\",5,\"狪狫狵狶狹狽狾狿猀猂猄\",5,\"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀\",8],[\"aa80\",\"獉獊獋獌獎獏獑獓獔獕獖獘\",7,\"獡\",10,\"獮獰獱\"],[\"ab40\",\"獲\",11,\"獿\",4,\"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣\",5,\"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃\",4],[\"ab80\",\"珋珌珎珒\",6,\"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳\",4],[\"ac40\",\"珸\",10,\"琄琇琈琋琌琍琎琑\",8,\"琜\",5,\"琣琤琧琩琫琭琯琱琲琷\",4,\"琽琾琿瑀瑂\",11],[\"ac80\",\"瑎\",6,\"瑖瑘瑝瑠\",12,\"瑮瑯瑱\",4,\"瑸瑹瑺\"],[\"ad40\",\"瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑\",10,\"璝璟\",7,\"璪\",15,\"璻\",12],[\"ad80\",\"瓈\",9,\"瓓\",8,\"瓝瓟瓡瓥瓧\",6,\"瓰瓱瓲\"],[\"ae40\",\"瓳瓵瓸\",6,\"甀甁甂甃甅\",7,\"甎甐甒甔甕甖甗甛甝甞甠\",4,\"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘\"],[\"ae80\",\"畝\",7,\"畧畨畩畫\",6,\"畳畵當畷畺\",4,\"疀疁疂疄疅疇\"],[\"af40\",\"疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦\",4,\"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇\"],[\"af80\",\"瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄\"],[\"b040\",\"癅\",6,\"癎\",5,\"癕癗\",4,\"癝癟癠癡癢癤\",6,\"癬癭癮癰\",7,\"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛\"],[\"b080\",\"皜\",7,\"皥\",8,\"皯皰皳皵\",9,\"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥\"],[\"b140\",\"盄盇盉盋盌盓盕盙盚盜盝盞盠\",4,\"盦\",7,\"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎\",10,\"眛眜眝眞眡眣眤眥眧眪眫\"],[\"b180\",\"眬眮眰\",4,\"眹眻眽眾眿睂睄睅睆睈\",7,\"睒\",7,\"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳\"],[\"b240\",\"睝睞睟睠睤睧睩睪睭\",11,\"睺睻睼瞁瞂瞃瞆\",5,\"瞏瞐瞓\",11,\"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶\",4],[\"b280\",\"瞼瞾矀\",12,\"矎\",8,\"矘矙矚矝\",4,\"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖\"],[\"b340\",\"矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃\",5,\"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚\"],[\"b380\",\"硛硜硞\",11,\"硯\",7,\"硸硹硺硻硽\",6,\"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚\"],[\"b440\",\"碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨\",7,\"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚\",9],[\"b480\",\"磤磥磦磧磩磪磫磭\",4,\"磳磵磶磸磹磻\",5,\"礂礃礄礆\",6,\"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮\"],[\"b540\",\"礍\",5,\"礔\",9,\"礟\",4,\"礥\",14,\"礵\",4,\"礽礿祂祃祄祅祇祊\",8,\"祔祕祘祙祡祣\"],[\"b580\",\"祤祦祩祪祫祬祮祰\",6,\"祹祻\",4,\"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠\"],[\"b640\",\"禓\",6,\"禛\",11,\"禨\",10,\"禴\",4,\"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙\",5,\"秠秡秢秥秨秪\"],[\"b680\",\"秬秮秱\",6,\"秹秺秼秾秿稁稄稅稇稈稉稊稌稏\",4,\"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二\"],[\"b740\",\"稝稟稡稢稤\",14,\"稴稵稶稸稺稾穀\",5,\"穇\",9,\"穒\",4,\"穘\",16],[\"b780\",\"穩\",6,\"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服\"],[\"b840\",\"窣窤窧窩窪窫窮\",4,\"窴\",10,\"竀\",10,\"竌\",9,\"竗竘竚竛竜竝竡竢竤竧\",5,\"竮竰竱竲竳\"],[\"b880\",\"竴\",4,\"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹\"],[\"b940\",\"笯笰笲笴笵笶笷笹笻笽笿\",5,\"筆筈筊筍筎筓筕筗筙筜筞筟筡筣\",10,\"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆\",6,\"箎箏\"],[\"b980\",\"箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹\",7,\"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈\"],[\"ba40\",\"篅篈築篊篋篍篎篏篐篒篔\",4,\"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲\",4,\"篸篹篺篻篽篿\",7,\"簈簉簊簍簎簐\",5,\"簗簘簙\"],[\"ba80\",\"簚\",4,\"簠\",5,\"簨簩簫\",12,\"簹\",5,\"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖\"],[\"bb40\",\"籃\",9,\"籎\",36,\"籵\",5,\"籾\",9],[\"bb80\",\"粈粊\",6,\"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴\",4,\"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕\"],[\"bc40\",\"粿糀糂糃糄糆糉糋糎\",6,\"糘糚糛糝糞糡\",6,\"糩\",5,\"糰\",7,\"糹糺糼\",13,\"紋\",5],[\"bc80\",\"紑\",14,\"紡紣紤紥紦紨紩紪紬紭紮細\",6,\"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件\"],[\"bd40\",\"紷\",54,\"絯\",7],[\"bd80\",\"絸\",32,\"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸\"],[\"be40\",\"継\",12,\"綧\",6,\"綯\",42],[\"be80\",\"線\",32,\"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻\"],[\"bf40\",\"緻\",62],[\"bf80\",\"縺縼\",4,\"繂\",4,\"繈\",21,\"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀\"],[\"c040\",\"繞\",35,\"纃\",23,\"纜纝纞\"],[\"c080\",\"纮纴纻纼绖绤绬绹缊缐缞缷缹缻\",6,\"罃罆\",9,\"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐\"],[\"c140\",\"罖罙罛罜罝罞罠罣\",4,\"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂\",7,\"羋羍羏\",4,\"羕\",4,\"羛羜羠羢羣羥羦羨\",6,\"羱\"],[\"c180\",\"羳\",4,\"羺羻羾翀翂翃翄翆翇翈翉翋翍翏\",4,\"翖翗翙\",5,\"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿\"],[\"c240\",\"翤翧翨翪翫翬翭翯翲翴\",6,\"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫\",5,\"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗\"],[\"c280\",\"聙聛\",13,\"聫\",5,\"聲\",11,\"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫\"],[\"c340\",\"聾肁肂肅肈肊肍\",5,\"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇\",4,\"胏\",6,\"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋\"],[\"c380\",\"脌脕脗脙脛脜脝脟\",12,\"脭脮脰脳脴脵脷脹\",4,\"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸\"],[\"c440\",\"腀\",5,\"腇腉腍腎腏腒腖腗腘腛\",4,\"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃\",4,\"膉膋膌膍膎膐膒\",5,\"膙膚膞\",4,\"膤膥\"],[\"c480\",\"膧膩膫\",7,\"膴\",5,\"膼膽膾膿臄臅臇臈臉臋臍\",6,\"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁\"],[\"c540\",\"臔\",14,\"臤臥臦臨臩臫臮\",4,\"臵\",5,\"臽臿舃與\",4,\"舎舏舑舓舕\",5,\"舝舠舤舥舦舧舩舮舲舺舼舽舿\"],[\"c580\",\"艀艁艂艃艅艆艈艊艌艍艎艐\",7,\"艙艛艜艝艞艠\",7,\"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗\"],[\"c640\",\"艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸\"],[\"c680\",\"苺苼\",4,\"茊茋茍茐茒茓茖茘茙茝\",9,\"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐\"],[\"c740\",\"茾茿荁荂荄荅荈荊\",4,\"荓荕\",4,\"荝荢荰\",6,\"荹荺荾\",6,\"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡\",6,\"莬莭莮\"],[\"c780\",\"莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠\"],[\"c840\",\"菮華菳\",4,\"菺菻菼菾菿萀萂萅萇萈萉萊萐萒\",5,\"萙萚萛萞\",5,\"萩\",7,\"萲\",5,\"萹萺萻萾\",7,\"葇葈葉\"],[\"c880\",\"葊\",6,\"葒\",4,\"葘葝葞葟葠葢葤\",4,\"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁\"],[\"c940\",\"葽\",4,\"蒃蒄蒅蒆蒊蒍蒏\",7,\"蒘蒚蒛蒝蒞蒟蒠蒢\",12,\"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗\"],[\"c980\",\"蓘\",4,\"蓞蓡蓢蓤蓧\",4,\"蓭蓮蓯蓱\",10,\"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳\"],[\"ca40\",\"蔃\",8,\"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢\",8,\"蔭\",9,\"蔾\",4,\"蕄蕅蕆蕇蕋\",10],[\"ca80\",\"蕗蕘蕚蕛蕜蕝蕟\",4,\"蕥蕦蕧蕩\",8,\"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱\"],[\"cb40\",\"薂薃薆薈\",6,\"薐\",10,\"薝\",6,\"薥薦薧薩薫薬薭薱\",5,\"薸薺\",6,\"藂\",6,\"藊\",4,\"藑藒\"],[\"cb80\",\"藔藖\",5,\"藝\",6,\"藥藦藧藨藪\",14,\"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔\"],[\"cc40\",\"藹藺藼藽藾蘀\",4,\"蘆\",10,\"蘒蘓蘔蘕蘗\",15,\"蘨蘪\",13,\"蘹蘺蘻蘽蘾蘿虀\"],[\"cc80\",\"虁\",11,\"虒虓處\",4,\"虛虜虝號虠虡虣\",7,\"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃\"],[\"cd40\",\"虭虯虰虲\",6,\"蚃\",6,\"蚎\",4,\"蚔蚖\",5,\"蚞\",4,\"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻\",4,\"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜\"],[\"cd80\",\"蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威\"],[\"ce40\",\"蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀\",6,\"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚\",5,\"蝡蝢蝦\",7,\"蝯蝱蝲蝳蝵\"],[\"ce80\",\"蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎\",4,\"螔螕螖螘\",6,\"螠\",4,\"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺\"],[\"cf40\",\"螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁\",4,\"蟇蟈蟉蟌\",4,\"蟔\",6,\"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯\",9],[\"cf80\",\"蟺蟻蟼蟽蟿蠀蠁蠂蠄\",5,\"蠋\",7,\"蠔蠗蠘蠙蠚蠜\",4,\"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓\"],[\"d040\",\"蠤\",13,\"蠳\",5,\"蠺蠻蠽蠾蠿衁衂衃衆\",5,\"衎\",5,\"衕衖衘衚\",6,\"衦衧衪衭衯衱衳衴衵衶衸衹衺\"],[\"d080\",\"衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗\",4,\"袝\",4,\"袣袥\",5,\"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄\"],[\"d140\",\"袬袮袯袰袲\",4,\"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚\",4,\"裠裡裦裧裩\",6,\"裲裵裶裷裺裻製裿褀褁褃\",5],[\"d180\",\"褉褋\",4,\"褑褔\",4,\"褜\",4,\"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶\"],[\"d240\",\"褸\",8,\"襂襃襅\",24,\"襠\",5,\"襧\",19,\"襼\"],[\"d280\",\"襽襾覀覂覄覅覇\",26,\"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐\"],[\"d340\",\"覢\",30,\"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴\",6],[\"d380\",\"觻\",4,\"訁\",5,\"計\",21,\"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉\"],[\"d440\",\"訞\",31,\"訿\",8,\"詉\",21],[\"d480\",\"詟\",25,\"詺\",6,\"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧\"],[\"d540\",\"誁\",7,\"誋\",7,\"誔\",46],[\"d580\",\"諃\",32,\"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政\"],[\"d640\",\"諤\",34,\"謈\",27],[\"d680\",\"謤謥謧\",30,\"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑\"],[\"d740\",\"譆\",31,\"譧\",4,\"譭\",25],[\"d780\",\"讇\",24,\"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座\"],[\"d840\",\"谸\",8,\"豂豃豄豅豈豊豋豍\",7,\"豖豗豘豙豛\",5,\"豣\",6,\"豬\",6,\"豴豵豶豷豻\",6,\"貃貄貆貇\"],[\"d880\",\"貈貋貍\",6,\"貕貖貗貙\",20,\"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝\"],[\"d940\",\"貮\",62],[\"d980\",\"賭\",32,\"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼\"],[\"da40\",\"贎\",14,\"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸\",8,\"趂趃趆趇趈趉趌\",4,\"趒趓趕\",9,\"趠趡\"],[\"da80\",\"趢趤\",12,\"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺\"],[\"db40\",\"跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾\",6,\"踆踇踈踋踍踎踐踑踒踓踕\",7,\"踠踡踤\",4,\"踫踭踰踲踳踴踶踷踸踻踼踾\"],[\"db80\",\"踿蹃蹅蹆蹌\",4,\"蹓\",5,\"蹚\",11,\"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝\"],[\"dc40\",\"蹳蹵蹷\",4,\"蹽蹾躀躂躃躄躆躈\",6,\"躑躒躓躕\",6,\"躝躟\",11,\"躭躮躰躱躳\",6,\"躻\",7],[\"dc80\",\"軃\",10,\"軏\",21,\"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥\"],[\"dd40\",\"軥\",62],[\"dd80\",\"輤\",32,\"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺\"],[\"de40\",\"轅\",32,\"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆\"],[\"de80\",\"迉\",4,\"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖\"],[\"df40\",\"這逜連逤逥逧\",5,\"逰\",4,\"逷逹逺逽逿遀遃遅遆遈\",4,\"過達違遖遙遚遜\",5,\"遤遦遧適遪遫遬遯\",4,\"遶\",6,\"遾邁\"],[\"df80\",\"還邅邆邇邉邊邌\",4,\"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼\"],[\"e040\",\"郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅\",19,\"鄚鄛鄜\"],[\"e080\",\"鄝鄟鄠鄡鄤\",10,\"鄰鄲\",6,\"鄺\",8,\"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼\"],[\"e140\",\"酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀\",4,\"醆醈醊醎醏醓\",6,\"醜\",5,\"醤\",5,\"醫醬醰醱醲醳醶醷醸醹醻\"],[\"e180\",\"醼\",10,\"釈釋釐釒\",9,\"針\",8,\"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺\"],[\"e240\",\"釦\",62],[\"e280\",\"鈥\",32,\"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧\",5,\"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂\"],[\"e340\",\"鉆\",45,\"鉵\",16],[\"e380\",\"銆\",7,\"銏\",24,\"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾\"],[\"e440\",\"銨\",5,\"銯\",24,\"鋉\",31],[\"e480\",\"鋩\",32,\"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑\"],[\"e540\",\"錊\",51,\"錿\",10],[\"e580\",\"鍊\",31,\"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣\"],[\"e640\",\"鍬\",34,\"鎐\",27],[\"e680\",\"鎬\",29,\"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩\"],[\"e740\",\"鏎\",7,\"鏗\",54],[\"e780\",\"鐎\",32,\"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡\",6,\"缪缫缬缭缯\",4,\"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬\"],[\"e840\",\"鐯\",14,\"鐿\",43,\"鑬鑭鑮鑯\"],[\"e880\",\"鑰\",20,\"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹\"],[\"e940\",\"锧锳锽镃镈镋镕镚镠镮镴镵長\",7,\"門\",42],[\"e980\",\"閫\",32,\"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋\"],[\"ea40\",\"闌\",27,\"闬闿阇阓阘阛阞阠阣\",6,\"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗\"],[\"ea80\",\"陘陙陚陜陝陞陠陣陥陦陫陭\",4,\"陳陸\",12,\"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰\"],[\"eb40\",\"隌階隑隒隓隕隖隚際隝\",9,\"隨\",7,\"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖\",9,\"雡\",6,\"雫\"],[\"eb80\",\"雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗\",4,\"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻\"],[\"ec40\",\"霡\",8,\"霫霬霮霯霱霳\",4,\"霺霻霼霽霿\",18,\"靔靕靗靘靚靜靝靟靣靤靦靧靨靪\",7],[\"ec80\",\"靲靵靷\",4,\"靽\",7,\"鞆\",4,\"鞌鞎鞏鞐鞓鞕鞖鞗鞙\",4,\"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐\"],[\"ed40\",\"鞞鞟鞡鞢鞤\",6,\"鞬鞮鞰鞱鞳鞵\",46],[\"ed80\",\"韤韥韨韮\",4,\"韴韷\",23,\"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨\"],[\"ee40\",\"頏\",62],[\"ee80\",\"顎\",32,\"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶\",4,\"钼钽钿铄铈\",6,\"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪\"],[\"ef40\",\"顯\",5,\"颋颎颒颕颙颣風\",37,\"飏飐飔飖飗飛飜飝飠\",4],[\"ef80\",\"飥飦飩\",30,\"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒\",4,\"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤\",8,\"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔\"],[\"f040\",\"餈\",4,\"餎餏餑\",28,\"餯\",26],[\"f080\",\"饊\",9,\"饖\",12,\"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨\",4,\"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦\",6,\"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙\"],[\"f140\",\"馌馎馚\",10,\"馦馧馩\",47],[\"f180\",\"駙\",32,\"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃\"],[\"f240\",\"駺\",62],[\"f280\",\"騹\",32,\"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒\"],[\"f340\",\"驚\",17,\"驲骃骉骍骎骔骕骙骦骩\",6,\"骲骳骴骵骹骻骽骾骿髃髄髆\",4,\"髍髎髏髐髒體髕髖髗髙髚髛髜\"],[\"f380\",\"髝髞髠髢髣髤髥髧髨髩髪髬髮髰\",8,\"髺髼\",6,\"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋\"],[\"f440\",\"鬇鬉\",5,\"鬐鬑鬒鬔\",10,\"鬠鬡鬢鬤\",10,\"鬰鬱鬳\",7,\"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕\",5],[\"f480\",\"魛\",32,\"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤\"],[\"f540\",\"魼\",62],[\"f580\",\"鮻\",32,\"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜\"],[\"f640\",\"鯜\",62],[\"f680\",\"鰛\",32,\"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅\",5,\"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞\",5,\"鲥\",4,\"鲫鲭鲮鲰\",7,\"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋\"],[\"f740\",\"鰼\",62],[\"f780\",\"鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾\",4,\"鳈鳉鳑鳒鳚鳛鳠鳡鳌\",4,\"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄\"],[\"f840\",\"鳣\",62],[\"f880\",\"鴢\",32],[\"f940\",\"鵃\",62],[\"f980\",\"鶂\",32],[\"fa40\",\"鶣\",62],[\"fa80\",\"鷢\",32],[\"fb40\",\"鸃\",27,\"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴\",9,\"麀\"],[\"fb80\",\"麁麃麄麅麆麉麊麌\",5,\"麔\",8,\"麞麠\",5,\"麧麨麩麪\"],[\"fc40\",\"麫\",8,\"麵麶麷麹麺麼麿\",4,\"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰\",8,\"黺黽黿\",6],[\"fc80\",\"鼆\",4,\"鼌鼏鼑鼒鼔鼕鼖鼘鼚\",5,\"鼡鼣\",8,\"鼭鼮鼰鼱\"],[\"fd40\",\"鼲\",4,\"鼸鼺鼼鼿\",4,\"齅\",10,\"齒\",38],[\"fd80\",\"齹\",5,\"龁龂龍\",11,\"龜龝龞龡\",4,\"郎凉秊裏隣\"],[\"fe40\",\"兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩\"]]},function(t,e,n){var r=n(55);t.exports=Object(\"z\").propertyIsEnumerable(0)?Object:function(t){return\"String\"==r(t)?t.split(\"\"):Object(t)}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(null==t)throw TypeError(\"Can't call method on  \"+t);return t}},function(t,e,n){var r=n(35),i=n(27),a=n(17),o=n(58),s=n(18),l=n(95),u=Object.getOwnPropertyDescriptor;e.f=n(5)?u:function(t,e){if(t=a(t),e=o(e,!0),l)try{return u(t,e)}catch(t){}if(s(t,e))return i(!r.f.call(t,e),t[e])}},function(t,e,n){var r=n(9);t.exports=function(t,e){if(!r(t))return t;var n,i;if(e&&\"function\"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;if(\"function\"==typeof(n=t.valueOf)&&!r(i=n.call(t)))return i;if(!e&&\"function\"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;throw TypeError(\"Can't convert object to primitive value\")}},function(t,e,n){var r=n(3),i=n(2),a=n(19);t.exports=function(t,e){var n=(i.Object||{})[t]||Object[t],o={};o[t]=e(n),r(r.S+r.F*a(function(){n(1)}),\"Object\",o)}},function(t,e,n){t.exports={default:n(200),__esModule:!0}},function(t,e,n){\"use strict\";var r=n(62),i=n(3),a=n(99),o=n(13),s=n(18),l=n(23),u=n(203),c=n(39),h=n(206),f=n(4)(\"iterator\"),d=!([].keys&&\"next\"in[].keys()),p=\"values\",g=function(){return this};t.exports=function(t,e,n,y,v,b,m){u(n,e,y);var w,x,S,_=function(t){if(!d&&t in P)return P[t];switch(t){case\"keys\":case p:return function(){return new n(this,t)}}return function(){return new n(this,t)}},k=e+\" Iterator\",C=v==p,A=!1,P=t.prototype,E=P[f]||P[\"@@iterator\"]||v&&P[v],I=!d&&E||_(v),T=v?C?_(\"entries\"):I:void 0,O=\"Array\"==e&&P.entries||E;if(O&&(S=h(O.call(new t)))!==Object.prototype&&S.next&&(c(S,k,!0),r||s(S,f)||o(S,f,g)),C&&E&&E.name!==p&&(A=!0,I=function(){return E.call(this)}),r&&!m||!d&&!A&&P[f]||o(P,f,I),l[e]=I,l[k]=g,v)if(w={values:C?I:_(p),keys:b?I:_(\"keys\"),entries:T},m)for(x in w)x in P||a(P,x,w[x]);else i(i.P+i.F*(d||A),e,w);return w}},function(t,e){t.exports=!0},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(65)(\"keys\"),i=n(38);t.exports=function(t){return r[t]||(r[t]=i(t))}},function(t,e,n){var r=n(10),i=\"__core-js_shared__\",a=r[i]||(r[i]={});t.exports=function(t){return a[t]||(a[t]={})}},function(t,e){t.exports=\"constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf\".split(\",\")},function(t,e,n){var r=n(68),i=n(4)(\"iterator\"),a=n(23);t.exports=n(2).getIteratorMethod=function(t){if(null!=t)return t[i]||t[\"@@iterator\"]||a[r(t)]}},function(t,e,n){var r=n(55),i=n(4)(\"toStringTag\"),a=\"Arguments\"==r(function(){return arguments}());t.exports=function(t){var e,n,o;return void 0===t?\"Undefined\":null===t?\"Null\":\"string\"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),i))?n:a?r(e):\"Object\"==(o=r(e))&&\"function\"==typeof e.callee?\"Arguments\":o}},function(t,e,n){\"use strict\";e.__esModule=!0;var r=o(n(103)),i=o(n(216)),a=\"function\"==typeof i.default&&\"symbol\"==typeof r.default?function(t){return typeof t}:function(t){return t&&\"function\"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?\"symbol\":typeof t};function o(t){return t&&t.__esModule?t:{default:t}}e.default=\"function\"==typeof i.default&&\"symbol\"===a(r.default)?function(t){return void 0===t?\"undefined\":a(t)}:function(t){return t&&\"function\"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?\"symbol\":void 0===t?\"undefined\":a(t)}},function(t,e,n){e.f=n(4)},function(t,e,n){var r=n(10),i=n(2),a=n(62),o=n(70),s=n(6).f;t.exports=function(t){var e=i.Symbol||(i.Symbol=a?{}:r.Symbol||{});\"_\"==t.charAt(0)||t in e||s(e,t,{value:o.f(t)})}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e){},function(t,e,n){t.exports={default:n(223),__esModule:!0}},function(t,e,n){var r=n(9);t.exports=function(t,e){if(!r(t)||t._t!==e)throw TypeError(\"Incompatible receiver, \"+e+\" required!\");return t}},function(t,e){var n={}.toString;t.exports=Array.isArray||function(t){return\"[object Array]\"==n.call(t)}},function(t,e,n){\"use strict\";function r(){this.events={}}r.prototype.startTracking=function(t,e){var n=this.events[t]||(this.events[t]=[]);n.indexOf(e)<0&&n.push(e)},r.prototype.stopTracking=function(t,e){var n=this.events[t];if(n){var r=n.indexOf(e);r>=0&&n.splice(r,1)}},r.prototype.emit=function(t){var e=Array.prototype.slice.call(arguments,1),n=this.events[t];n&&n.forEach(function(t){t.apply(this,e)})},r.prototype.auto=function(t,e,n){this.startTracking(t,e),n(),this.stopTracking(t,e)},t.exports=r},function(t,e,n){(function(){var e,r,i,a,o,s,l,u,c,h,f,d,p,g,y,v,b,m,w,x,S,_,k,C,A,P,E;w=n(43),_=n(131),P=n(132),P.BK,c=P.CR,P.LF,P.NL,o=P.CB,i=P.BA,P.SP,x=P.WJ,m=P.SP,a=P.BK,d=P.LF,g=P.NL,e=P.AI,r=P.AL,v=P.SA,b=P.SG,S=P.XX,l=P.CJ,P.ID,y=P.NS,P.characterClasses,E=n(133),h=E.DI_BRK,f=E.IN_BRK,s=E.CI_BRK,u=E.CP_BRK,E.PR_BRK,A=E.pairTable,C=_.toByteArray(\"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\"),k=new w(C),p=function(){var t,n,p;function w(t){this.string=t,this.pos=0,this.lastPos=0,this.curClass=null,this.nextClass=null}return w.prototype.nextCodePoint=function(){var t,e;return t=this.string.charCodeAt(this.pos++),e=this.string.charCodeAt(this.pos),55296<=t&&t<=56319&&56320<=e&&e<=57343?(this.pos++,1024*(t-55296)+(e-56320)+65536):t},n=function(t){switch(t){case e:return r;case v:case b:case S:return r;case l:return y;default:return t}},p=function(t){switch(t){case d:case g:return a;case o:return i;case m:return x;default:return t}},w.prototype.nextCharClass=function(t){return null==t&&(t=!1),n(k.get(this.nextCodePoint()))},t=function(t,e){this.position=t,this.required=null!=e&&e},w.prototype.nextBreak=function(){var e,r,l;for(null==this.curClass&&(this.curClass=p(this.nextCharClass()));this.pos<this.string.length;){if(this.lastPos=this.pos,r=this.nextClass,this.nextClass=this.nextCharClass(),this.curClass===a||this.curClass===c&&this.nextClass!==d)return this.curClass=p(n(this.nextClass)),new t(this.lastPos,!0);if(null==(e=function(){switch(this.nextClass){case m:return this.curClass;case a:case d:case g:return a;case c:return c;case o:return i}}.call(this))){switch(l=!1,A[this.curClass][this.nextClass]){case h:l=!0;break;case f:l=r===m;break;case s:if(!(l=r===m))continue;break;case u:if(r!==m)continue}if(this.curClass=this.nextClass,l)return new t(this.lastPos)}else if(this.curClass=e,this.nextClass===o)return new t(this.lastPos)}if(this.pos>=this.string.length)return this.lastPos<this.string.length?(this.lastPos=this.string.length,new t(this.string.length)):null},w}(),t.exports=p}).call(this)},function(t,e){var n=0,r=-3;function i(){this.table=new Uint16Array(16),this.trans=new Uint16Array(288)}var a=new i,o=new i,s=new Uint8Array(30),l=new Uint16Array(30),u=new Uint8Array(30),c=new Uint16Array(30),h=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),f=new i,d=new Uint8Array(320);function p(t,e,n,r){var i,a;for(i=0;i<n;++i)t[i]=0;for(i=0;i<30-n;++i)t[i+n]=i/n|0;for(a=r,i=0;i<30;++i)e[i]=a,a+=1<<t[i]}var g=new Uint16Array(16);function y(t,e,n,r){var i,a;for(i=0;i<16;++i)t.table[i]=0;for(i=0;i<r;++i)t.table[e[n+i]]++;for(t.table[0]=0,a=0,i=0;i<16;++i)g[i]=a,a+=t.table[i];for(i=0;i<r;++i)e[n+i]&&(t.trans[g[e[n+i]]++]=i)}function v(t){t.bitcount--||(t.tag=t.source[t.sourceIndex++],t.bitcount=7);var e=1&t.tag;return t.tag>>>=1,e}function b(t,e,n){if(!e)return n;for(;t.bitcount<24;)t.tag|=t.source[t.sourceIndex++]<<t.bitcount,t.bitcount+=8;var r=t.tag&65535>>>16-e;return t.tag>>>=e,t.bitcount-=e,r+n}function m(t,e){for(;t.bitcount<24;)t.tag|=t.source[t.sourceIndex++]<<t.bitcount,t.bitcount+=8;for(var n=0,r=0,i=0,a=t.tag;r=2*r+(1&a),a>>>=1,++i,n+=e.table[i],(r-=e.table[i])>=0;);return t.tag=a,t.bitcount-=i,e.trans[n+r]}function w(t,e,n){var r,i,a,o,s,l;for(r=b(t,5,257),i=b(t,5,1),a=b(t,4,4),o=0;o<19;++o)d[o]=0;for(o=0;o<a;++o){var u=b(t,3,0);d[h[o]]=u}for(y(f,d,0,19),s=0;s<r+i;){var c=m(t,f);switch(c){case 16:var p=d[s-1];for(l=b(t,2,3);l;--l)d[s++]=p;break;case 17:for(l=b(t,3,3);l;--l)d[s++]=0;break;case 18:for(l=b(t,7,11);l;--l)d[s++]=0;break;default:d[s++]=c}}y(e,d,0,r),y(n,d,r,i)}function x(t,e,r){for(;;){var i,a,o,h,f=m(t,e);if(256===f)return n;if(f<256)t.dest[t.destLen++]=f;else for(i=b(t,s[f-=257],l[f]),a=m(t,r),h=o=t.destLen-b(t,u[a],c[a]);h<o+i;++h)t.dest[t.destLen++]=t.dest[h]}}function S(t){for(var e,i;t.bitcount>8;)t.sourceIndex--,t.bitcount-=8;if((e=256*(e=t.source[t.sourceIndex+1])+t.source[t.sourceIndex])!==(65535&~(256*t.source[t.sourceIndex+3]+t.source[t.sourceIndex+2])))return r;for(t.sourceIndex+=4,i=e;i;--i)t.dest[t.destLen++]=t.source[t.sourceIndex++];return t.bitcount=0,n}!function(t,e){var n;for(n=0;n<7;++n)t.table[n]=0;for(t.table[7]=24,t.table[8]=152,t.table[9]=112,n=0;n<24;++n)t.trans[n]=256+n;for(n=0;n<144;++n)t.trans[24+n]=n;for(n=0;n<8;++n)t.trans[168+n]=280+n;for(n=0;n<112;++n)t.trans[176+n]=144+n;for(n=0;n<5;++n)e.table[n]=0;for(e.table[5]=32,n=0;n<32;++n)e.trans[n]=n}(a,o),p(s,l,4,3),p(u,c,2,1),s[28]=0,l[28]=258,t.exports=function(t,e){var s,l,u=new function(t,e){this.source=t,this.sourceIndex=0,this.tag=0,this.bitcount=0,this.dest=e,this.destLen=0,this.ltree=new i,this.dtree=new i}(t,e);do{switch(s=v(u),b(u,2,0)){case 0:l=S(u);break;case 1:l=x(u,a,o);break;case 2:w(u,u.ltree,u.dtree),l=x(u,u.ltree,u.dtree);break;default:l=r}if(l!==n)throw new Error(\"Data error\")}while(!s);return u.destLen<u.dest.length?\"function\"==typeof u.dest.slice?u.dest.slice(0,u.destLen):u.dest.subarray(0,u.destLen):u.dest}},function(t,e,n){\"use strict\";var r=n(0).isString,i=n(0).isArray,a=n(0).isUndefined,o=n(0).isNull;function s(t,e){this.defaultStyle=e||{},this.styleDictionary=t,this.styleOverrides=[]}s.prototype.clone=function(){var t=new s(this.styleDictionary,this.defaultStyle);return this.styleOverrides.forEach(function(e){t.styleOverrides.push(e)}),t},s.prototype.push=function(t){this.styleOverrides.push(t)},s.prototype.pop=function(t){for(t=t||1;t-- >0;)this.styleOverrides.pop()},s.prototype.autopush=function(t){if(r(t))return 0;var e=[];t.style&&(e=i(t.style)?t.style:[t.style]);for(var n=0,s=e.length;n<s;n++)this.push(e[n]);var l={},u=!1;return[\"font\",\"fontSize\",\"fontFeatures\",\"bold\",\"italics\",\"alignment\",\"color\",\"columnGap\",\"fillColor\",\"decoration\",\"decorationStyle\",\"decorationColor\",\"background\",\"lineHeight\",\"characterSpacing\",\"noWrap\",\"markerColor\",\"leadingIndent\"].forEach(function(e){a(t[e])||o(t[e])||(l[e]=t[e],u=!0)}),u&&this.push(l),e.length+(u?1:0)},s.prototype.auto=function(t,e){var n=this.autopush(t),r=e();return n>0&&this.pop(n),r},s.prototype.getProperty=function(t){if(this.styleOverrides)for(var e=this.styleOverrides.length-1;e>=0;e--){var n=this.styleOverrides[e];if(r(n)){var i=this.styleDictionary[n];if(i&&!a(i[t])&&!o(i[t]))return i[t]}else if(!a(n[t])&&!o(n[t]))return n[t]}return this.defaultStyle&&this.defaultStyle[t]},t.exports=s},function(t,e,n){\"use strict\";var r=n(77),i=n(0).isString;function a(t,e){this.pages=[],this.pageMargins=e,this.x=e.left,this.availableWidth=t.width-e.left-e.right,this.availableHeight=0,this.page=-1,this.snapshots=[],this.endingCell=null,this.tracker=new r,this.addPage(t),this.hasBackground=!1}a.prototype.beginColumnGroup=function(){this.snapshots.push({x:this.x,y:this.y,availableHeight:this.availableHeight,availableWidth:this.availableWidth,page:this.page,bottomMost:{x:this.x,y:this.y,availableHeight:this.availableHeight,availableWidth:this.availableWidth,page:this.page},endingCell:this.endingCell,lastColumnWidth:this.lastColumnWidth}),this.lastColumnWidth=0},a.prototype.beginColumn=function(t,e,n){var r=this.snapshots[this.snapshots.length-1];this.calculateBottomMost(r),this.endingCell=n,this.page=r.page,this.x=this.x+this.lastColumnWidth+(e||0),this.y=r.y,this.availableWidth=t,this.availableHeight=r.availableHeight,this.lastColumnWidth=t},a.prototype.calculateBottomMost=function(t){this.endingCell?(this.saveContextInEndingCell(this.endingCell),this.endingCell=null):t.bottomMost=function(t,e){var n;n=t.page>e.page?t:e.page>t.page?e:t.y>e.y?t:e;return{page:n.page,x:n.x,y:n.y,availableHeight:n.availableHeight,availableWidth:n.availableWidth}}(this,t.bottomMost)},a.prototype.markEnding=function(t){this.page=t._columnEndingContext.page,this.x=t._columnEndingContext.x,this.y=t._columnEndingContext.y,this.availableWidth=t._columnEndingContext.availableWidth,this.availableHeight=t._columnEndingContext.availableHeight,this.lastColumnWidth=t._columnEndingContext.lastColumnWidth},a.prototype.saveContextInEndingCell=function(t){t._columnEndingContext={page:this.page,x:this.x,y:this.y,availableHeight:this.availableHeight,availableWidth:this.availableWidth,lastColumnWidth:this.lastColumnWidth}},a.prototype.completeColumnGroup=function(t){var e=this.snapshots.pop();this.calculateBottomMost(e),this.endingCell=null,this.x=e.x;var n=e.bottomMost.y;t&&(e.page===e.bottomMost.page?e.y+t>n&&(n=e.y+t):n+=t),this.y=n,this.page=e.bottomMost.page,this.availableWidth=e.availableWidth,this.availableHeight=e.bottomMost.availableHeight,t&&(this.availableHeight-=n-e.bottomMost.y),this.lastColumnWidth=e.lastColumnWidth},a.prototype.addMargin=function(t,e){this.x+=t,this.availableWidth-=t+(e||0)},a.prototype.moveDown=function(t){return this.y+=t,this.availableHeight-=t,this.availableHeight>0},a.prototype.initializePage=function(){this.y=this.pageMargins.top,this.availableHeight=this.getCurrentPage().pageSize.height-this.pageMargins.top-this.pageMargins.bottom,this.pageSnapshot().availableWidth=this.getCurrentPage().pageSize.width-this.pageMargins.left-this.pageMargins.right},a.prototype.pageSnapshot=function(){return this.snapshots[0]?this.snapshots[0]:this},a.prototype.moveTo=function(t,e){null!=t&&(this.x=t,this.availableWidth=this.getCurrentPage().pageSize.width-this.x-this.pageMargins.right),null!=e&&(this.y=e,this.availableHeight=this.getCurrentPage().pageSize.height-this.y-this.pageMargins.bottom)},a.prototype.beginDetachedBlock=function(){this.snapshots.push({x:this.x,y:this.y,availableHeight:this.availableHeight,availableWidth:this.availableWidth,page:this.page,endingCell:this.endingCell,lastColumnWidth:this.lastColumnWidth})},a.prototype.endDetachedBlock=function(){var t=this.snapshots.pop();this.x=t.x,this.y=t.y,this.availableWidth=t.availableWidth,this.availableHeight=t.availableHeight,this.page=t.page,this.endingCell=t.endingCell,this.lastColumnWidth=t.lastColumnWidth};var o=function(t,e){var n,r;return n=e,r=t.pageSize.orientation,(e=void 0===n?r:i(n)&&\"landscape\"===n.toLowerCase()?\"landscape\":\"portrait\")!==t.pageSize.orientation?{orientation:e,width:t.pageSize.height,height:t.pageSize.width}:{orientation:t.pageSize.orientation,width:t.pageSize.width,height:t.pageSize.height}};a.prototype.moveToNextPage=function(t){var e=this.page+1,n=this.page,r=this.y,i=e>=this.pages.length;if(i){var a=this.availableWidth,s=this.getCurrentPage().pageSize.orientation,l=o(this.getCurrentPage(),t);this.addPage(l),s===l.orientation&&(this.availableWidth=a)}else this.page=e,this.initializePage();return{newPageCreated:i,prevPage:n,prevY:r,y:this.y}},a.prototype.addPage=function(t){var e={items:[],pageSize:t};return this.pages.push(e),this.page=this.pages.length-1,this.initializePage(),this.tracker.emit(\"pageAdded\"),e},a.prototype.getCurrentPage=function(){return this.page<0||this.page>=this.pages.length?null:this.pages[this.page]},a.prototype.getCurrentPosition=function(){var t=this.getCurrentPage().pageSize,e=t.height-this.pageMargins.top-this.pageMargins.bottom,n=t.width-this.pageMargins.left-this.pageMargins.right;return{pageNumber:this.page+1,pageOrientation:t.orientation,pageInnerHeight:e,pageInnerWidth:n,left:this.x,top:this.y,verticalRatio:(this.y-this.pageMargins.top)/e,horizontalRatio:(this.x-this.pageMargins.left)/n}},t.exports=a},function(t,e,n){\"use strict\";function r(t){this.maxWidth=t,this.leadingCut=0,this.trailingCut=0,this.inlineWidths=0,this.inlines=[]}r.prototype.getAscenderHeight=function(){var t=0;return this.inlines.forEach(function(e){t=Math.max(t,e.font.ascender/1e3*e.fontSize)}),t},r.prototype.hasEnoughSpaceForInline=function(t){return 0===this.inlines.length||!this.newLineForced&&this.inlineWidths+t.width-this.leadingCut-(t.trailingCut||0)<=this.maxWidth},r.prototype.addInline=function(t){0===this.inlines.length&&(this.leadingCut=t.leadingCut||0),this.trailingCut=t.trailingCut||0,t.x=this.inlineWidths-this.leadingCut,this.inlines.push(t),this.inlineWidths+=t.width,t.lineEnd&&(this.newLineForced=!0)},r.prototype.getWidth=function(){return this.inlineWidths-this.leadingCut-this.trailingCut},r.prototype.getHeight=function(){var t=0;return this.inlines.forEach(function(e){t=Math.max(t,e.height||0)}),t},t.exports=r},function(t,e,n){\"use strict\";(function(e,r){var i=n(32).nextTick;t.exports=m;var a,o=n(76);m.ReadableState=b;n(31).EventEmitter;var s=function(t,e){return t.listeners(e).length},l=n(84),u=n(33).Buffer,c=e.Uint8Array||function(){};var h=n(25);h.inherits=n(21);var f=n(139),d=void 0;d=f&&f.debuglog?f.debuglog(\"stream\"):function(){};var p,g=n(140),y=n(85);h.inherits(m,l);var v=[\"error\",\"close\",\"destroy\",\"pause\",\"resume\"];function b(t,e){t=t||{};var r=e instanceof(a=a||n(16));this.objectMode=!!t.objectMode,r&&(this.objectMode=this.objectMode||!!t.readableObjectMode);var i=t.highWaterMark,o=t.readableHighWaterMark,s=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:r&&(o||0===o)?o:s,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new g,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=t.defaultEncoding||\"utf8\",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,t.encoding&&(p||(p=n(47).StringDecoder),this.decoder=new p(t.encoding),this.encoding=t.encoding)}function m(t){if(a=a||n(16),!(this instanceof m))return new m(t);this._readableState=new b(t,this),this.readable=!0,t&&(\"function\"==typeof t.read&&(this._read=t.read),\"function\"==typeof t.destroy&&(this._destroy=t.destroy)),l.call(this)}function w(t,e,n,r,i){var a,o,s,l=t._readableState;null===e?(l.reading=!1,function(t,e){if(e.ended)return;if(e.decoder){var n=e.decoder.end();n&&n.length&&(e.buffer.push(n),e.length+=e.objectMode?1:n.length)}e.ended=!0,k(t)}(t,l)):(i||(a=function(t,e){var n;r=e,u.isBuffer(r)||r instanceof c||\"string\"==typeof e||void 0===e||t.objectMode||(n=new TypeError(\"Invalid non-string/buffer chunk\"));var r;return n}(l,e)),a?t.emit(\"error\",a):l.objectMode||e&&e.length>0?(\"string\"==typeof e||l.objectMode||Object.getPrototypeOf(e)===u.prototype||(o=e,e=u.from(o)),r?l.endEmitted?t.emit(\"error\",new Error(\"stream.unshift() after end event\")):x(t,l,e,!0):l.ended?t.emit(\"error\",new Error(\"stream.push() after EOF\")):(l.reading=!1,l.decoder&&!n?(e=l.decoder.write(e),l.objectMode||0!==e.length?x(t,l,e,!1):A(t,l)):x(t,l,e,!1))):r||(l.reading=!1));return!(s=l).ended&&(s.needReadable||s.length<s.highWaterMark||0===s.length)}function x(t,e,n,r){e.flowing&&0===e.length&&!e.sync?(t.emit(\"data\",n),t.read(0)):(e.length+=e.objectMode?1:n.length,r?e.buffer.unshift(n):e.buffer.push(n),e.needReadable&&k(t)),A(t,e)}Object.defineProperty(m.prototype,\"destroyed\",{get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(t){this._readableState&&(this._readableState.destroyed=t)}}),m.prototype.destroy=y.destroy,m.prototype._undestroy=y.undestroy,m.prototype._destroy=function(t,e){this.push(null),e(t)},m.prototype.push=function(t,e){var n,r=this._readableState;return r.objectMode?n=!0:\"string\"==typeof t&&((e=e||r.defaultEncoding)!==r.encoding&&(t=u.from(t,e),e=\"\"),n=!0),w(this,t,e,!1,n)},m.prototype.unshift=function(t){return w(this,t,null,!0,!1)},m.prototype.isPaused=function(){return!1===this._readableState.flowing},m.prototype.setEncoding=function(t){return p||(p=n(47).StringDecoder),this._readableState.decoder=new p(t),this._readableState.encoding=t,this};var S=8388608;function _(t,e){return t<=0||0===e.length&&e.ended?0:e.objectMode?1:t!=t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=((n=t)>=S?n=S:(n--,n|=n>>>1,n|=n>>>2,n|=n>>>4,n|=n>>>8,n|=n>>>16,n++),n)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0));var n}function k(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(d(\"emitReadable\",e.flowing),e.emittedReadable=!0,e.sync?i(C,t):C(t))}function C(t){d(\"emit readable\"),t.emit(\"readable\"),T(t)}function A(t,e){e.readingMore||(e.readingMore=!0,i(P,t,e))}function P(t,e){for(var n=e.length;!e.reading&&!e.flowing&&!e.ended&&e.length<e.highWaterMark&&(d(\"maybeReadMore read 0\"),t.read(0),n!==e.length);)n=e.length;e.readingMore=!1}function E(t){d(\"readable nexttick read 0\"),t.read(0)}function I(t,e){e.reading||(d(\"resume read 0\"),t.read(0)),e.resumeScheduled=!1,e.awaitDrain=0,t.emit(\"resume\"),T(t),e.flowing&&!e.reading&&t.read(0)}function T(t){var e=t._readableState;for(d(\"flow\",e.flowing);e.flowing&&null!==t.read(););}function O(t,e){return 0===e.length?null:(e.objectMode?n=e.buffer.shift():!t||t>=e.length?(n=e.decoder?e.buffer.join(\"\"):1===e.buffer.length?e.buffer.head.data:e.buffer.concat(e.length),e.buffer.clear()):n=function(t,e,n){var r;t<e.head.data.length?(r=e.head.data.slice(0,t),e.head.data=e.head.data.slice(t)):r=t===e.head.data.length?e.shift():n?function(t,e){var n=e.head,r=1,i=n.data;t-=i.length;for(;n=n.next;){var a=n.data,o=t>a.length?a.length:t;if(o===a.length?i+=a:i+=a.slice(0,t),0===(t-=o)){o===a.length?(++r,n.next?e.head=n.next:e.head=e.tail=null):(e.head=n,n.data=a.slice(o));break}++r}return e.length-=r,i}(t,e):function(t,e){var n=u.allocUnsafe(t),r=e.head,i=1;r.data.copy(n),t-=r.data.length;for(;r=r.next;){var a=r.data,o=t>a.length?a.length:t;if(a.copy(n,n.length-t,0,o),0===(t-=o)){o===a.length?(++i,r.next?e.head=r.next:e.head=e.tail=null):(e.head=r,r.data=a.slice(o));break}++i}return e.length-=i,n}(t,e);return r}(t,e.buffer,e.decoder),n);var n}function L(t){var e=t._readableState;if(e.length>0)throw new Error('\"endReadable()\" called on non-empty stream');e.endEmitted||(e.ended=!0,i(B,e,t))}function B(t,e){t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit(\"end\"))}function M(t,e){for(var n=0,r=t.length;n<r;n++)if(t[n]===e)return n;return-1}m.prototype.read=function(t){d(\"read\",t),t=parseInt(t,10);var e=this._readableState,n=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&(e.length>=e.highWaterMark||e.ended))return d(\"read: emitReadable\",e.length,e.ended),0===e.length&&e.ended?L(this):k(this),null;if(0===(t=_(t,e))&&e.ended)return 0===e.length&&L(this),null;var r,i=e.needReadable;return d(\"need readable\",i),(0===e.length||e.length-t<e.highWaterMark)&&d(\"length less than watermark\",i=!0),e.ended||e.reading?d(\"reading or ended\",i=!1):i&&(d(\"do read\"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=_(n,e))),null===(r=t>0?O(t,e):null)?(e.needReadable=!0,t=0):e.length-=t,0===e.length&&(e.ended||(e.needReadable=!0),n!==t&&e.ended&&L(this)),null!==r&&this.emit(\"data\",r),r},m.prototype._read=function(t){this.emit(\"error\",new Error(\"_read() is not implemented\"))},m.prototype.pipe=function(t,e){var n=this,a=this._readableState;switch(a.pipesCount){case 0:a.pipes=t;break;case 1:a.pipes=[a.pipes,t];break;default:a.pipes.push(t)}a.pipesCount+=1,d(\"pipe count=%d opts=%j\",a.pipesCount,e);var l=(!e||!1!==e.end)&&t!==r.stdout&&t!==r.stderr?c:w;function u(e,r){d(\"onunpipe\"),e===n&&r&&!1===r.hasUnpiped&&(r.hasUnpiped=!0,d(\"cleanup\"),t.removeListener(\"close\",b),t.removeListener(\"finish\",m),t.removeListener(\"drain\",f),t.removeListener(\"error\",v),t.removeListener(\"unpipe\",u),n.removeListener(\"end\",c),n.removeListener(\"end\",w),n.removeListener(\"data\",y),p=!0,!a.awaitDrain||t._writableState&&!t._writableState.needDrain||f())}function c(){d(\"onend\"),t.end()}a.endEmitted?i(l):n.once(\"end\",l),t.on(\"unpipe\",u);var h,f=(h=n,function(){var t=h._readableState;d(\"pipeOnDrain\",t.awaitDrain),t.awaitDrain&&t.awaitDrain--,0===t.awaitDrain&&s(h,\"data\")&&(t.flowing=!0,T(h))});t.on(\"drain\",f);var p=!1;var g=!1;function y(e){d(\"ondata\"),g=!1,!1!==t.write(e)||g||((1===a.pipesCount&&a.pipes===t||a.pipesCount>1&&-1!==M(a.pipes,t))&&!p&&(d(\"false write response, pause\",n._readableState.awaitDrain),n._readableState.awaitDrain++,g=!0),n.pause())}function v(e){d(\"onerror\",e),w(),t.removeListener(\"error\",v),0===s(t,\"error\")&&t.emit(\"error\",e)}function b(){t.removeListener(\"finish\",m),w()}function m(){d(\"onfinish\"),t.removeListener(\"close\",b),w()}function w(){d(\"unpipe\"),n.unpipe(t)}return n.on(\"data\",y),function(t,e,n){if(\"function\"==typeof t.prependListener)return t.prependListener(e,n);t._events&&t._events[e]?o(t._events[e])?t._events[e].unshift(n):t._events[e]=[n,t._events[e]]:t.on(e,n)}(t,\"error\",v),t.once(\"close\",b),t.once(\"finish\",m),t.emit(\"pipe\",n),a.flowing||(d(\"pipe resume\"),n.resume()),t},m.prototype.unpipe=function(t){var e=this._readableState,n={hasUnpiped:!1};if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes?this:(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit(\"unpipe\",this,n),this);if(!t){var r=e.pipes,i=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var a=0;a<i;a++)r[a].emit(\"unpipe\",this,n);return this}var o=M(e.pipes,t);return-1===o?this:(e.pipes.splice(o,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit(\"unpipe\",this,n),this)},m.prototype.addListener=m.prototype.on=function(t,e){var n=l.prototype.on.call(this,t,e);if(\"data\"===t)!1!==this._readableState.flowing&&this.resume();else if(\"readable\"===t){var r=this._readableState;r.endEmitted||r.readableListening||(r.readableListening=r.needReadable=!0,r.emittedReadable=!1,r.reading?r.length&&k(this):i(E,this))}return n},m.prototype.resume=function(){var t,e,n=this._readableState;return n.flowing||(d(\"resume\"),n.flowing=!0,t=this,(e=n).resumeScheduled||(e.resumeScheduled=!0,i(I,t,e))),this},m.prototype.pause=function(){return d(\"call pause flowing=%j\",this._readableState.flowing),!1!==this._readableState.flowing&&(d(\"pause\"),this._readableState.flowing=!1,this.emit(\"pause\")),this},m.prototype.wrap=function(t){var e=this,n=this._readableState,r=!1;for(var i in t.on(\"end\",function(){if(d(\"wrapped end\"),n.decoder&&!n.ended){var t=n.decoder.end();t&&t.length&&e.push(t)}e.push(null)}),t.on(\"data\",function(i){(d(\"wrapped data\"),n.decoder&&(i=n.decoder.write(i)),n.objectMode&&null==i)||(n.objectMode||i&&i.length)&&(e.push(i)||(r=!0,t.pause()))}),t)void 0===this[i]&&\"function\"==typeof t[i]&&(this[i]=function(e){return function(){return t[e].apply(t,arguments)}}(i));for(var a=0;a<v.length;a++)t.on(v[a],this.emit.bind(this,v[a]));return this._read=function(e){d(\"wrapped _read\",e),r&&(r=!1,t.resume())},this},m._fromList=O}).call(e,n(7),n(11))},function(t,e,n){t.exports=n(31).EventEmitter},function(t,e,n){\"use strict\";var r=n(32).nextTick;function i(t,e){t.emit(\"error\",e)}t.exports={destroy:function(t,e){var n=this,a=this._readableState&&this._readableState.destroyed,o=this._writableState&&this._writableState.destroyed;return a||o?(e?e(t):!t||this._writableState&&this._writableState.errorEmitted||r(i,this,t),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(t||null,function(t){!e&&t?(r(i,n,t),n._writableState&&(n._writableState.errorEmitted=!0)):e&&e(t)}),this)},undestroy:function(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}}},function(t,e,n){\"use strict\";t.exports=a;var r=n(16),i=n(25);function a(t){if(!(this instanceof a))return new a(t);r.call(this,t),this._transformState={afterTransform:function(t,e){var n=this._transformState;n.transforming=!1;var r=n.writecb;if(!r)return this.emit(\"error\",new Error(\"write callback called multiple times\"));n.writechunk=null,n.writecb=null,null!=e&&this.push(e),r(t);var i=this._readableState;i.reading=!1,(i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,t&&(\"function\"==typeof t.transform&&(this._transform=t.transform),\"function\"==typeof t.flush&&(this._flush=t.flush)),this.on(\"prefinish\",o)}function o(){var t=this;\"function\"==typeof this._flush?this._flush(function(e,n){s(t,e,n)}):s(this,null,null)}function s(t,e,n){if(e)return t.emit(\"error\",e);if(null!=n&&t.push(n),t._writableState.length)throw new Error(\"Calling transform done when ws.length != 0\");if(t._transformState.transforming)throw new Error(\"Calling transform done when still transforming\");return t.push(null)}i.inherits=n(21),i.inherits(a,r),a.prototype.push=function(t,e){return this._transformState.needTransform=!1,r.prototype.push.call(this,t,e)},a.prototype._transform=function(t,e,n){throw new Error(\"_transform() is not implemented\")},a.prototype._write=function(t,e,n){var r=this._transformState;if(r.writecb=n,r.writechunk=t,r.writeencoding=e,!r.transforming){var i=this._readableState;(r.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},a.prototype._read=function(t){var e=this._transformState;null!==e.writechunk&&e.writecb&&!e.transforming?(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform)):e.needTransform=!0},a.prototype._destroy=function(t,e){var n=this;r.prototype._destroy.call(this,t,function(t){e(t),n.emit(\"close\")})}},function(t,e,n){(function(e){(function(){var r,i,a,o,s=function(t,e){return function(){return t.apply(e,arguments)}},l={}.hasOwnProperty;o=n(48),a=n(15),i=function(t){function n(t,e,r){this.document=t,this.id=e,this.data=null!=r?r:{},this.finalize=s(this.finalize,this),n.__super__.constructor.call(this,{decodeStrings:!1}),this.gen=0,this.deflate=null,this.compress=this.document.compress&&!this.data.Filter,this.uncompressedLength=0,this.chunks=[]}return function(t,e){for(var n in e)l.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(n,a.Writable),n.prototype.initDeflate=function(){var t;return this.data.Filter=\"FlateDecode\",this.deflate=o.createDeflate(),this.deflate.on(\"data\",(t=this,function(e){return t.chunks.push(e),t.data.Length+=e.length})),this.deflate.on(\"end\",this.finalize)},n.prototype._write=function(t,n,r){var i;return e.isBuffer(t)||(t=new e(t+\"\\n\",\"binary\")),this.uncompressedLength+=t.length,null==(i=this.data).Length&&(i.Length=0),this.compress?(this.deflate||this.initDeflate(),this.deflate.write(t)):(this.chunks.push(t),this.data.Length+=t.length),r()},n.prototype.end=function(t){return n.__super__.end.apply(this,arguments),this.deflate?this.deflate.end():this.finalize()},n.prototype.finalize=function(){var t,e,n,i;if(this.offset=this.document._offset,this.document._write(this.id+\" \"+this.gen+\" obj\"),this.document._write(r.convert(this.data)),this.chunks.length){for(this.document._write(\"stream\"),e=0,n=(i=this.chunks).length;e<n;e++)t=i[e],this.document._write(t);this.chunks.length=0,this.document._write(\"\\nendstream\")}return this.document._write(\"endobj\"),this.document._refEnd(this)},n.prototype.toString=function(){return this.id+\" \"+this.gen+\" R\"},n}(),t.exports=i,r=n(26)}).call(this)}).call(e,n(1).Buffer)},function(t,e,n){\"use strict\";(function(e){function r(t,e){if(t===e)return 0;for(var n=t.length,r=e.length,i=0,a=Math.min(n,r);i<a;++i)if(t[i]!==e[i]){n=t[i],r=e[i];break}return n<r?-1:r<n?1:0}function i(t){return e.Buffer&&\"function\"==typeof e.Buffer.isBuffer?e.Buffer.isBuffer(t):!(null==t||!t._isBuffer)}var a=n(49),o=Object.prototype.hasOwnProperty,s=Array.prototype.slice,l=\"foo\"===function(){}.name;function u(t){return Object.prototype.toString.call(t)}function c(t){return!i(t)&&(\"function\"==typeof e.ArrayBuffer&&(\"function\"==typeof ArrayBuffer.isView?ArrayBuffer.isView(t):!!t&&(t instanceof DataView||!!(t.buffer&&t.buffer instanceof ArrayBuffer))))}var h=t.exports=v,f=/\\s*function\\s+([^\\(\\s]*)\\s*/;function d(t){if(a.isFunction(t)){if(l)return t.name;var e=t.toString().match(f);return e&&e[1]}}function p(t,e){return\"string\"==typeof t?t.length<e?t:t.slice(0,e):t}function g(t){if(l||!a.isFunction(t))return a.inspect(t);var e=d(t);return\"[Function\"+(e?\": \"+e:\"\")+\"]\"}function y(t,e,n,r,i){throw new h.AssertionError({message:n,actual:t,expected:e,operator:r,stackStartFunction:i})}function v(t,e){t||y(t,!0,e,\"==\",h.ok)}function b(t,e,n,o){if(t===e)return!0;if(i(t)&&i(e))return 0===r(t,e);if(a.isDate(t)&&a.isDate(e))return t.getTime()===e.getTime();if(a.isRegExp(t)&&a.isRegExp(e))return t.source===e.source&&t.global===e.global&&t.multiline===e.multiline&&t.lastIndex===e.lastIndex&&t.ignoreCase===e.ignoreCase;if(null!==t&&\"object\"==typeof t||null!==e&&\"object\"==typeof e){if(c(t)&&c(e)&&u(t)===u(e)&&!(t instanceof Float32Array||t instanceof Float64Array))return 0===r(new Uint8Array(t.buffer),new Uint8Array(e.buffer));if(i(t)!==i(e))return!1;var l=(o=o||{actual:[],expected:[]}).actual.indexOf(t);return-1!==l&&l===o.expected.indexOf(e)||(o.actual.push(t),o.expected.push(e),function(t,e,n,r){if(null==t||null==e)return!1;if(a.isPrimitive(t)||a.isPrimitive(e))return t===e;if(n&&Object.getPrototypeOf(t)!==Object.getPrototypeOf(e))return!1;var i=m(t),o=m(e);if(i&&!o||!i&&o)return!1;if(i)return t=s.call(t),e=s.call(e),b(t,e,n);var l,u,c=S(t),h=S(e);if(c.length!==h.length)return!1;for(c.sort(),h.sort(),u=c.length-1;u>=0;u--)if(c[u]!==h[u])return!1;for(u=c.length-1;u>=0;u--)if(l=c[u],!b(t[l],e[l],n,r))return!1;return!0}(t,e,n,o))}return n?t===e:t==e}function m(t){return\"[object Arguments]\"==Object.prototype.toString.call(t)}function w(t,e){if(!t||!e)return!1;if(\"[object RegExp]\"==Object.prototype.toString.call(e))return e.test(t);try{if(t instanceof e)return!0}catch(t){}return!Error.isPrototypeOf(e)&&!0===e.call({},t)}function x(t,e,n,r){var i;if(\"function\"!=typeof e)throw new TypeError('\"block\" argument must be a function');\"string\"==typeof n&&(r=n,n=null),i=function(t){var e;try{t()}catch(t){e=t}return e}(e),r=(n&&n.name?\" (\"+n.name+\").\":\".\")+(r?\" \"+r:\".\"),t&&!i&&y(i,n,\"Missing expected exception\"+r);var o=\"string\"==typeof r,s=!t&&i&&!n;if((!t&&a.isError(i)&&o&&w(i,n)||s)&&y(i,n,\"Got unwanted exception\"+r),t&&i&&n&&!w(i,n)||!t&&i)throw i}h.AssertionError=function(t){var e;this.name=\"AssertionError\",this.actual=t.actual,this.expected=t.expected,this.operator=t.operator,t.message?(this.message=t.message,this.generatedMessage=!1):(this.message=p(g((e=this).actual),128)+\" \"+e.operator+\" \"+p(g(e.expected),128),this.generatedMessage=!0);var n=t.stackStartFunction||y;if(Error.captureStackTrace)Error.captureStackTrace(this,n);else{var r=new Error;if(r.stack){var i=r.stack,a=d(n),o=i.indexOf(\"\\n\"+a);if(o>=0){var s=i.indexOf(\"\\n\",o+1);i=i.substring(s+1)}this.stack=i}}},a.inherits(h.AssertionError,Error),h.fail=y,h.ok=v,h.equal=function(t,e,n){t!=e&&y(t,e,n,\"==\",h.equal)},h.notEqual=function(t,e,n){t==e&&y(t,e,n,\"!=\",h.notEqual)},h.deepEqual=function(t,e,n){b(t,e,!1)||y(t,e,n,\"deepEqual\",h.deepEqual)},h.deepStrictEqual=function(t,e,n){b(t,e,!0)||y(t,e,n,\"deepStrictEqual\",h.deepStrictEqual)},h.notDeepEqual=function(t,e,n){b(t,e,!1)&&y(t,e,n,\"notDeepEqual\",h.notDeepEqual)},h.notDeepStrictEqual=function t(e,n,r){b(e,n,!0)&&y(e,n,r,\"notDeepStrictEqual\",t)},h.strictEqual=function(t,e,n){t!==e&&y(t,e,n,\"===\",h.strictEqual)},h.notStrictEqual=function(t,e,n){t===e&&y(t,e,n,\"!==\",h.notStrictEqual)},h.throws=function(t,e,n){x(!0,t,e,n)},h.doesNotThrow=function(t,e,n){x(!1,t,e,n)},h.ifError=function(t){if(t)throw t};var S=Object.keys||function(t){var e=[];for(var n in t)o.call(t,n)&&e.push(n);return e}}).call(e,n(7))},function(t,e,n){\"use strict\";t.exports=function(t,e,n,r){for(var i=65535&t|0,a=t>>>16&65535|0,o=0;0!==n;){for(n-=o=n>2e3?2e3:n;a=a+(i=i+e[r++]|0)|0,--o;);i%=65521,a%=65521}return i|a<<16|0}},function(t,e,n){\"use strict\";var r=function(){for(var t,e=[],n=0;n<256;n++){t=n;for(var r=0;r<8;r++)t=1&t?3988292384^t>>>1:t>>>1;e[n]=t}return e}();t.exports=function(t,e,n,i){var a=r,o=i+n;t^=-1;for(var s=i;s<o;s++)t=t>>>8^a[255&(t^e[s])];return-1^t}},function(t,e){t.exports=[[\"a140\",\"\",62],[\"a180\",\"\",32],[\"a240\",\"\",62],[\"a280\",\"\",32],[\"a2ab\",\"\",5],[\"a2e3\",\"€\"],[\"a2ef\",\"\"],[\"a2fd\",\"\"],[\"a340\",\"\",62],[\"a380\",\"\",31,\"　\"],[\"a440\",\"\",62],[\"a480\",\"\",32],[\"a4f4\",\"\",10],[\"a540\",\"\",62],[\"a580\",\"\",32],[\"a5f7\",\"\",7],[\"a640\",\"\",62],[\"a680\",\"\",32],[\"a6b9\",\"\",7],[\"a6d9\",\"\",6],[\"a6ec\",\"\"],[\"a6f3\",\"\"],[\"a6f6\",\"\",8],[\"a740\",\"\",62],[\"a780\",\"\",32],[\"a7c2\",\"\",14],[\"a7f2\",\"\",12],[\"a896\",\"\",10],[\"a8bc\",\"\"],[\"a8bf\",\"ǹ\"],[\"a8c1\",\"\"],[\"a8ea\",\"\",20],[\"a958\",\"\"],[\"a95b\",\"\"],[\"a95d\",\"\"],[\"a989\",\"〾⿰\",11],[\"a997\",\"\",12],[\"a9f0\",\"\",14],[\"aaa1\",\"\",93],[\"aba1\",\"\",93],[\"aca1\",\"\",93],[\"ada1\",\"\",93],[\"aea1\",\"\",93],[\"afa1\",\"\",93],[\"d7fa\",\"\",4],[\"f8a1\",\"\",93],[\"f9a1\",\"\",93],[\"faa1\",\"\",93],[\"fba1\",\"\",93],[\"fca1\",\"\",93],[\"fda1\",\"\",93],[\"fe50\",\"⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌\"],[\"fe80\",\"䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓\",6,\"䶮\",93]]},function(t,e){t.exports=[[\"0\",\"\\0\",127],[\"a140\",\"　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚\"],[\"a1a1\",\"﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢\",4,\"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／\"],[\"a240\",\"＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁\",7,\"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭\"],[\"a2a1\",\"╮╰╯═╞╪╡◢◣◥◤╱╲╳０\",9,\"Ⅰ\",9,\"〡\",8,\"十卄卅Ａ\",25,\"ａ\",21],[\"a340\",\"ｗｘｙｚΑ\",16,\"Σ\",6,\"α\",16,\"σ\",6,\"ㄅ\",10],[\"a3a1\",\"ㄐ\",25,\"˙ˉˊˇˋ\"],[\"a3e1\",\"€\"],[\"a440\",\"一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才\"],[\"a4a1\",\"丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙\"],[\"a540\",\"世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外\"],[\"a5a1\",\"央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全\"],[\"a640\",\"共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年\"],[\"a6a1\",\"式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣\"],[\"a740\",\"作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍\"],[\"a7a1\",\"均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠\"],[\"a840\",\"杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒\"],[\"a8a1\",\"芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵\"],[\"a940\",\"咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居\"],[\"a9a1\",\"屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊\"],[\"aa40\",\"昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠\"],[\"aaa1\",\"炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附\"],[\"ab40\",\"陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品\"],[\"aba1\",\"哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷\"],[\"ac40\",\"拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗\"],[\"aca1\",\"活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄\"],[\"ad40\",\"耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥\"],[\"ada1\",\"迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪\"],[\"ae40\",\"哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙\"],[\"aea1\",\"恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓\"],[\"af40\",\"浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷\"],[\"afa1\",\"砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃\"],[\"b040\",\"虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡\"],[\"b0a1\",\"陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀\"],[\"b140\",\"娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽\"],[\"b1a1\",\"情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺\"],[\"b240\",\"毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶\"],[\"b2a1\",\"瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼\"],[\"b340\",\"莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途\"],[\"b3a1\",\"部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠\"],[\"b440\",\"婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍\"],[\"b4a1\",\"插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋\"],[\"b540\",\"溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘\"],[\"b5a1\",\"窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁\"],[\"b640\",\"詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑\"],[\"b6a1\",\"間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼\"],[\"b740\",\"媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業\"],[\"b7a1\",\"楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督\"],[\"b840\",\"睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫\"],[\"b8a1\",\"腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊\"],[\"b940\",\"辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴\"],[\"b9a1\",\"飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇\"],[\"ba40\",\"愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢\"],[\"baa1\",\"滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬\"],[\"bb40\",\"罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤\"],[\"bba1\",\"說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜\"],[\"bc40\",\"劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂\"],[\"bca1\",\"慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃\"],[\"bd40\",\"瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯\"],[\"bda1\",\"翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞\"],[\"be40\",\"輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉\"],[\"bea1\",\"鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡\"],[\"bf40\",\"濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊\"],[\"bfa1\",\"縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚\"],[\"c040\",\"錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇\"],[\"c0a1\",\"嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬\"],[\"c140\",\"瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪\"],[\"c1a1\",\"薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁\"],[\"c240\",\"駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘\"],[\"c2a1\",\"癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦\"],[\"c340\",\"鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸\"],[\"c3a1\",\"獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類\"],[\"c440\",\"願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼\"],[\"c4a1\",\"纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴\"],[\"c540\",\"護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬\"],[\"c5a1\",\"禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒\"],[\"c640\",\"讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲\"],[\"c940\",\"乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕\"],[\"c9a1\",\"氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋\"],[\"ca40\",\"汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘\"],[\"caa1\",\"吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇\"],[\"cb40\",\"杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓\"],[\"cba1\",\"芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢\"],[\"cc40\",\"坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋\"],[\"cca1\",\"怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲\"],[\"cd40\",\"泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺\"],[\"cda1\",\"矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏\"],[\"ce40\",\"哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛\"],[\"cea1\",\"峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺\"],[\"cf40\",\"柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂\"],[\"cfa1\",\"洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀\"],[\"d040\",\"穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪\"],[\"d0a1\",\"苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱\"],[\"d140\",\"唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧\"],[\"d1a1\",\"恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤\"],[\"d240\",\"毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸\"],[\"d2a1\",\"牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐\"],[\"d340\",\"笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢\"],[\"d3a1\",\"荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐\"],[\"d440\",\"酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅\"],[\"d4a1\",\"唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏\"],[\"d540\",\"崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟\"],[\"d5a1\",\"捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉\"],[\"d640\",\"淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏\"],[\"d6a1\",\"痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟\"],[\"d740\",\"耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷\"],[\"d7a1\",\"蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪\"],[\"d840\",\"釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷\"],[\"d8a1\",\"堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔\"],[\"d940\",\"惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒\"],[\"d9a1\",\"晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞\"],[\"da40\",\"湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖\"],[\"daa1\",\"琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥\"],[\"db40\",\"罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳\"],[\"dba1\",\"菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺\"],[\"dc40\",\"軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈\"],[\"dca1\",\"隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆\"],[\"dd40\",\"媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤\"],[\"dda1\",\"搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼\"],[\"de40\",\"毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓\"],[\"dea1\",\"煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓\"],[\"df40\",\"稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯\"],[\"dfa1\",\"腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤\"],[\"e040\",\"觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿\"],[\"e0a1\",\"遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠\"],[\"e140\",\"凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠\"],[\"e1a1\",\"寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉\"],[\"e240\",\"榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊\"],[\"e2a1\",\"漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓\"],[\"e340\",\"禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞\"],[\"e3a1\",\"耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻\"],[\"e440\",\"裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍\"],[\"e4a1\",\"銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘\"],[\"e540\",\"噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉\"],[\"e5a1\",\"憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒\"],[\"e640\",\"澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙\"],[\"e6a1\",\"獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟\"],[\"e740\",\"膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢\"],[\"e7a1\",\"蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧\"],[\"e840\",\"踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓\"],[\"e8a1\",\"銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮\"],[\"e940\",\"噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺\"],[\"e9a1\",\"憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸\"],[\"ea40\",\"澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙\"],[\"eaa1\",\"瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘\"],[\"eb40\",\"蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠\"],[\"eba1\",\"諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌\"],[\"ec40\",\"錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕\"],[\"eca1\",\"魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎\"],[\"ed40\",\"檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶\"],[\"eda1\",\"瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞\"],[\"ee40\",\"蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞\"],[\"eea1\",\"謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜\"],[\"ef40\",\"鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰\"],[\"efa1\",\"鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶\"],[\"f040\",\"璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒\"],[\"f0a1\",\"臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧\"],[\"f140\",\"蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪\"],[\"f1a1\",\"鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰\"],[\"f240\",\"徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛\"],[\"f2a1\",\"礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕\"],[\"f340\",\"譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦\"],[\"f3a1\",\"鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲\"],[\"f440\",\"嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩\"],[\"f4a1\",\"禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿\"],[\"f540\",\"鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛\"],[\"f5a1\",\"鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥\"],[\"f640\",\"蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺\"],[\"f6a1\",\"騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚\"],[\"f740\",\"糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊\"],[\"f7a1\",\"驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾\"],[\"f840\",\"讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏\"],[\"f8a1\",\"齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚\"],[\"f940\",\"纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊\"],[\"f9a1\",\"龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓\"]]},function(t,e,n){(function(){var e,r,i;r=n(22).Number,i=n(12),e=function(){function t(t,e,n){this.type=t,this.length=e,this.lengthType=null!=n?n:\"count\"}return t.prototype.decode=function(t,e){var n,a,o,s,l,u;if(o=t.pos,s=[],n=e,null!=this.length&&(a=i.resolveLength(this.length,t,e)),this.length instanceof r&&(Object.defineProperties(s,{parent:{value:e},_startOffset:{value:o},_currentOffset:{value:0,writable:!0},_length:{value:a}}),n=s),null==a||\"bytes\"===this.lengthType)for(l=null!=a?t.pos+a:(null!=e?e._length:void 0)?e._startOffset+e._length:t.length;t.pos<l;)s.push(this.type.decode(t,n));else for(u=0;u<a;u+=1)s.push(this.type.decode(t,n));return s},t.prototype.size=function(t,e){var n,a,o,s;if(!t)return this.type.size(null,e)*i.resolveLength(this.length,null,e);for(a=0,this.length instanceof r&&(a+=this.length.size(),e={parent:e}),o=0,s=t.length;o<s;o++)n=t[o],a+=this.type.size(n,e);return a},t.prototype.encode=function(t,e,n){var i,a,o,s,l,u;for(i=n,this.length instanceof r&&((i={pointers:[],startOffset:t.pos,parent:n}).pointerOffset=t.pos+this.size(e,i),this.length.encode(t,e.length)),l=0,u=e.length;l<u;l++)o=e[l],this.type.encode(t,o,i);if(this.length instanceof r)for(a=0;a<i.pointers.length;)(s=i.pointers[a++]).type.encode(t,s.val)},t}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e,r;r=n(12),e=function(){function t(t){this.fields=null!=t?t:{}}return t.prototype.decode=function(t,e,n){var r,i;return null==n&&(n=0),r=this._setup(t,e,n),this._parseFields(t,r,this.fields),null!=(i=this.process)&&i.call(r,t),r},t.prototype._setup=function(t,e,n){var r;return r={},Object.defineProperties(r,{parent:{value:e},_startOffset:{value:t.pos},_currentOffset:{value:0,writable:!0},_length:{value:n}}),r},t.prototype._parseFields=function(t,e,n){var i,a,o;for(i in n)void 0!==(o=\"function\"==typeof(a=n[i])?a.call(e,e):a.decode(t,e))&&(o instanceof r.PropertyDescriptor?Object.defineProperty(e,i,o):e[i]=o),e._currentOffset=t.pos-e._startOffset},t.prototype.size=function(t,e,n){var r,i,a,o,s;for(i in null==t&&(t={}),null==n&&(n=!0),r={parent:e,val:t,pointerSize:0},a=0,s=this.fields)null!=(o=s[i]).size&&(a+=o.size(t[i],r));return n&&(a+=r.pointerSize),a},t.prototype.encode=function(t,e,n){var r,i,a,o,s,l,u;for(a in null!=(l=this.preEncode)&&l.call(e,t),(r={pointers:[],startOffset:t.pos,parent:n,val:e,pointerSize:0}).pointerOffset=t.pos+this.size(e,r,!1),u=this.fields)null!=(s=u[a]).encode&&s.encode(t,e[a],r);for(i=0;i<r.pointers.length;)(o=r.pointers[i++]).type.encode(t,o.val,o.parent)},t}(),t.exports=e}).call(this)},function(t,e,n){t.exports=!n(5)&&!n(19)(function(){return 7!=Object.defineProperty(n(96)(\"div\"),\"a\",{get:function(){return 7}}).a})},function(t,e,n){var r=n(9),i=n(10).document,a=r(i)&&r(i.createElement);t.exports=function(t){return a?i.createElement(t):{}}},function(t,e){t.exports=function(t){if(\"function\"!=typeof t)throw TypeError(t+\" is not a function!\");return t}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){t.exports=n(13)},function(t,e,n){var r=n(6),i=n(14),a=n(29);t.exports=n(5)?Object.defineProperties:function(t,e){i(t);for(var n,o=a(e),s=o.length,l=0;s>l;)r.f(t,n=o[l++],e[n]);return t}},function(t,e,n){var r=n(18),i=n(17),a=n(204)(!1),o=n(64)(\"IE_PROTO\");t.exports=function(t,e){var n,s=i(t),l=0,u=[];for(n in s)n!=o&&r(s,n)&&u.push(n);for(;e.length>l;)r(s,n=e[l++])&&(~a(u,n)||u.push(n));return u}},function(t,e,n){var r=n(63),i=Math.max,a=Math.min;t.exports=function(t,e){return(t=r(t))<0?i(t+e,0):a(t,e)}},function(t,e,n){t.exports={default:n(215),__esModule:!0}},function(t,e,n){var r=n(55);t.exports=Array.isArray||function(t){return\"Array\"==r(t)}},function(t,e,n){var r=n(101),i=n(66).concat(\"length\",\"prototype\");e.f=Object.getOwnPropertyNames||function(t){return r(t,i)}},function(t,e,n){\"use strict\";e.__esModule=!0,e.default=function(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}},function(t,e,n){\"use strict\";e.__esModule=!0;var r,i=n(74),a=(r=i)&&r.__esModule?r:{default:r};e.default=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),(0,a.default)(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}()},function(t,e,n){\"use strict\";var r=n(6).f,i=n(36),a=n(109),o=n(20),s=n(110),l=n(41),u=n(61),c=n(98),h=n(228),f=n(5),d=n(40).fastKey,p=n(75),g=f?\"_s\":\"size\",y=function(t,e){var n,r=d(e);if(\"F\"!==r)return t._i[r];for(n=t._f;n;n=n.n)if(n.k==e)return n};t.exports={getConstructor:function(t,e,n,u){var c=t(function(t,r){s(t,c,e,\"_i\"),t._t=e,t._i=i(null),t._f=void 0,t._l=void 0,t[g]=0,null!=r&&l(r,n,t[u],t)});return a(c.prototype,{clear:function(){for(var t=p(this,e),n=t._i,r=t._f;r;r=r.n)r.r=!0,r.p&&(r.p=r.p.n=void 0),delete n[r.i];t._f=t._l=void 0,t[g]=0},delete:function(t){var n=p(this,e),r=y(n,t);if(r){var i=r.n,a=r.p;delete n._i[r.i],r.r=!0,a&&(a.n=i),i&&(i.p=a),n._f==r&&(n._f=i),n._l==r&&(n._l=a),n[g]--}return!!r},forEach:function(t){p(this,e);for(var n,r=o(t,arguments.length>1?arguments[1]:void 0,3);n=n?n.n:this._f;)for(r(n.v,n.k,this);n&&n.r;)n=n.p},has:function(t){return!!y(p(this,e),t)}}),f&&r(c.prototype,\"size\",{get:function(){return p(this,e)[g]}}),c},def:function(t,e,n){var r,i,a=y(t,e);return a?a.v=n:(t._l=a={i:i=d(e,!0),k:e,v:n,p:r=t._l,n:void 0,r:!1},t._f||(t._f=a),r&&(r.n=a),t[g]++,\"F\"!==i&&(t._i[i]=a)),t},getEntry:y,setStrong:function(t,e,n){u(t,e,function(t,n){this._t=p(t,e),this._k=n,this._l=void 0},function(){for(var t=this,e=t._k,n=t._l;n&&n.r;)n=n.p;return t._t&&(t._l=n=n?n.n:t._t._f)?c(0,\"keys\"==e?n.k:\"values\"==e?n.v:[n.k,n.v]):(t._t=void 0,c(1))},n?\"entries\":\"values\",!n,!0),h(e)}}},function(t,e,n){var r=n(13);t.exports=function(t,e,n){for(var i in e)n&&t[i]?t[i]=e[i]:r(t,i,e[i]);return t}},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+\": incorrect invocation!\");return t}},function(t,e,n){var r=n(14);t.exports=function(t,e,n,i){try{return i?e(r(n)[0],n[1]):e(n)}catch(e){var a=t.return;throw void 0!==a&&r(a.call(t)),e}}},function(t,e,n){var r=n(23),i=n(4)(\"iterator\"),a=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||a[i]===t)}},function(t,e,n){\"use strict\";var r=n(10),i=n(3),a=n(40),o=n(19),s=n(13),l=n(109),u=n(41),c=n(110),h=n(9),f=n(39),d=n(6).f,p=n(229)(0),g=n(5);t.exports=function(t,e,n,y,v,b){var m=r[t],w=m,x=v?\"set\":\"add\",S=w&&w.prototype,_={};return g&&\"function\"==typeof w&&(b||S.forEach&&!o(function(){(new w).entries().next()}))?(w=e(function(e,n){c(e,w,t,\"_c\"),e._c=new m,null!=n&&u(n,v,e[x],e)}),p(\"add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON\".split(\",\"),function(t){var e=\"add\"==t||\"set\"==t;t in S&&(!b||\"clear\"!=t)&&s(w.prototype,t,function(n,r){if(c(this,w,t),!e&&b&&!h(n))return\"get\"==t&&void 0;var i=this._c[t](0===n?0:n,r);return e?this:i})}),b||d(w.prototype,\"size\",{get:function(){return this._c.size}})):(w=y.getConstructor(e,t,v,x),l(w.prototype,n),a.NEED=!0),f(w,t),_[t]=w,i(i.G+i.W+i.F,_),b||y.setStrong(w,t,v),w}},function(t,e,n){var r=n(68),i=n(233);t.exports=function(t){return function(){if(r(this)!=t)throw TypeError(t+\"#toJSON isn't generic\");return i(this)}}},function(t,e,n){\"use strict\";var r=n(3);t.exports=function(t){r(r.S,t,{of:function(){for(var t=arguments.length,e=new Array(t);t--;)e[t]=arguments[t];return new this(e)}})}},function(t,e,n){\"use strict\";var r=n(3),i=n(97),a=n(20),o=n(41);t.exports=function(t){r(r.S,t,{from:function(t){var e,n,r,s,l=arguments[1];return i(this),(e=void 0!==l)&&i(l),null==t?new this:(n=[],e?(r=0,s=a(l,arguments[2],2),o(t,!1,function(t){n.push(s(t,r++))})):o(t,!1,n.push,n),new this(n))}})}},function(t,e,n){var r=n(118).BrotliInput,i=n(118).BrotliOutput,a=n(285),o=n(119),s=n(120).HuffmanCode,l=n(120).BrotliBuildHuffmanTable,u=n(289),c=n(290),h=n(291),f=8,d=16,p=256,g=704,y=26,v=6,b=2,m=8,w=255,x=1080,S=18,_=new Uint8Array([1,2,3,4,0,5,17,6,16,7,8,9,10,11,12,13,14,15]),k=16,C=new Uint8Array([3,2,1,0,3,3,3,3,3,3,2,2,2,2,2,2]),A=new Int8Array([0,0,0,0,-1,1,-2,2,-3,3,-1,1,-2,2,-3,3]),P=new Uint16Array([256,402,436,468,500,534,566,598,630,662,694,726,758,790,822,854,886,920,952,984,1016,1048,1080]);function E(t){var e;return 0===t.readBits(1)?16:(e=t.readBits(3))>0?17+e:(e=t.readBits(3))>0?8+e:17}function I(t){if(t.readBits(1)){var e=t.readBits(3);return 0===e?1:t.readBits(e)+(1<<e)}return 0}function T(t){var e,n,r,i=new function(){this.meta_block_length=0,this.input_end=0,this.is_uncompressed=0,this.is_metadata=!1};if(i.input_end=t.readBits(1),i.input_end&&t.readBits(1))return i;if(7===(e=t.readBits(2)+4)){if(i.is_metadata=!0,0!==t.readBits(1))throw new Error(\"Invalid reserved bit\");if(0===(n=t.readBits(2)))return i;for(r=0;r<n;r++){var a=t.readBits(8);if(r+1===n&&n>1&&0===a)throw new Error(\"Invalid size byte\");i.meta_block_length|=a<<8*r}}else for(r=0;r<e;++r){var o=t.readBits(4);if(r+1===e&&e>4&&0===o)throw new Error(\"Invalid size nibble\");i.meta_block_length|=o<<4*r}return++i.meta_block_length,i.input_end||i.is_metadata||(i.is_uncompressed=t.readBits(1)),i}function O(t,e,n){var r;return n.fillBitWindow(),(r=t[e+=n.val_>>>n.bit_pos_&w].bits-m)>0&&(n.bit_pos_+=m,e+=t[e].value,e+=n.val_>>>n.bit_pos_&(1<<r)-1),n.bit_pos_+=t[e].bits,t[e].value}function L(t,e,n,r){var i,a,o=new Uint8Array(t);if(r.readMoreInput(),1===(a=r.readBits(2))){for(var u=t-1,c=0,h=new Int32Array(4),p=r.readBits(2)+1;u;)u>>=1,++c;for(g=0;g<p;++g)h[g]=r.readBits(c)%t,o[h[g]]=2;switch(o[h[0]]=1,p){case 1:break;case 3:if(h[0]===h[1]||h[0]===h[2]||h[1]===h[2])throw new Error(\"[ReadHuffmanCode] invalid symbols\");break;case 2:if(h[0]===h[1])throw new Error(\"[ReadHuffmanCode] invalid symbols\");o[h[1]]=1;break;case 4:if(h[0]===h[1]||h[0]===h[2]||h[0]===h[3]||h[1]===h[2]||h[1]===h[3]||h[2]===h[3])throw new Error(\"[ReadHuffmanCode] invalid symbols\");r.readBits(1)?(o[h[2]]=3,o[h[3]]=3):o[h[0]]=2}}else{var g,y=new Uint8Array(S),v=32,b=0,w=[new s(2,0),new s(2,4),new s(2,3),new s(3,2),new s(2,0),new s(2,4),new s(2,3),new s(4,1),new s(2,0),new s(2,4),new s(2,3),new s(3,2),new s(2,0),new s(2,4),new s(2,3),new s(4,5)];for(g=a;g<S&&v>0;++g){var x,k=_[g],C=0;r.fillBitWindow(),C+=r.val_>>>r.bit_pos_&15,r.bit_pos_+=w[C].bits,x=w[C].value,y[k]=x,0!==x&&(v-=32>>x,++b)}if(1!==b&&0!==v)throw new Error(\"[ReadHuffmanCode] invalid num_codes or space\");!function(t,e,n,r){for(var i=0,a=f,o=0,u=0,c=32768,h=[],p=0;p<32;p++)h.push(new s(0,0));for(l(h,0,5,t,S);i<e&&c>0;){var g,y=0;if(r.readMoreInput(),r.fillBitWindow(),y+=r.val_>>>r.bit_pos_&31,r.bit_pos_+=h[y].bits,(g=255&h[y].value)<d)o=0,n[i++]=g,0!==g&&(a=g,c-=32768>>g);else{var v,b,m=g-14,w=0;if(g===d&&(w=a),u!==w&&(o=0,u=w),v=o,o>0&&(o-=2,o<<=m),i+(b=(o+=r.readBits(m)+3)-v)>e)throw new Error(\"[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols\");for(var x=0;x<b;x++)n[i+x]=u;i+=b,0!==u&&(c-=b<<15-u)}}if(0!==c)throw new Error(\"[ReadHuffmanCodeLengths] space = \"+c);for(;i<e;i++)n[i]=0}(y,t,o,r)}if(0===(i=l(e,n,m,o,t)))throw new Error(\"[ReadHuffmanCode] BuildHuffmanTable failed: \");return i}function B(t,e,n){var r,i;return r=O(t,e,n),i=c.kBlockLengthPrefixCode[r].nbits,c.kBlockLengthPrefixCode[r].offset+n.readBits(i)}function M(t,e){for(var n=t[e],r=e;r;--r)t[r]=t[r-1];t[0]=n}function R(t,e){this.alphabet_size=t,this.num_htrees=e,this.codes=new Array(e+e*P[t+31>>>5]),this.htrees=new Uint32Array(e)}function F(t,e){var n,r,i={num_htrees:null,context_map:null},a=0;e.readMoreInput();var o=i.num_htrees=I(e)+1,l=i.context_map=new Uint8Array(t);if(o<=1)return i;for(e.readBits(1)&&(a=e.readBits(4)+1),n=[],r=0;r<x;r++)n[r]=new s(0,0);for(L(o+a,n,0,e),r=0;r<t;){var u;if(e.readMoreInput(),0===(u=O(n,0,e)))l[r]=0,++r;else if(u<=a)for(var c=1+(1<<u)+e.readBits(u);--c;){if(r>=t)throw new Error(\"[DecodeContextMap] i >= context_map_size\");l[r]=0,++r}else l[r]=u-a,++r}return e.readBits(1)&&function(t,e){var n,r=new Uint8Array(256);for(n=0;n<256;++n)r[n]=n;for(n=0;n<e;++n){var i=t[n];t[n]=r[i],i&&M(r,i)}}(l,t),i}function D(t,e,n,r,i,a,o){var s,l=2*n,u=n,c=O(e,n*x,o);(s=0===c?i[l+(1&a[u])]:1===c?i[l+(a[u]-1&1)]+1:c-2)>=t&&(s-=t),r[n]=s,i[l+(1&a[u])]=s,++a[u]}function z(t,e,n,r,i,o){var s,l=i+1,u=n&i,c=o.pos_&a.IBUF_MASK;if(e<8||o.bit_pos_+(e<<3)<o.bit_end_pos_)for(;e-- >0;)o.readMoreInput(),r[u++]=o.readBits(8),u===l&&(t.write(r,l),u=0);else{if(o.bit_end_pos_<32)throw new Error(\"[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32\");for(;o.bit_pos_<32;)r[u]=o.val_>>>o.bit_pos_,o.bit_pos_+=8,++u,--e;if(c+(s=o.bit_end_pos_-o.bit_pos_>>3)>a.IBUF_MASK){for(var h=a.IBUF_MASK+1-c,f=0;f<h;f++)r[u+f]=o.buf_[c+f];s-=h,u+=h,e-=h,c=0}for(f=0;f<s;f++)r[u+f]=o.buf_[c+f];if(e-=s,(u+=s)>=l){t.write(r,l),u-=l;for(f=0;f<u;f++)r[f]=r[l+f]}for(;u+e>=l;){if(s=l-u,o.input_.read(r,u,s)<s)throw new Error(\"[CopyUncompressedBlockToOutput] not enough bytes\");t.write(r,l),e-=s,u=0}if(o.input_.read(r,u,e)<e)throw new Error(\"[CopyUncompressedBlockToOutput] not enough bytes\");o.reset()}}function N(t){var e=new r(t),n=new a(e);return E(n),T(n).meta_block_length}function U(t,e){var n,r,i,l,f,d,m,w,S,_,P,M,N,U,W,G,V=0,j=0,H=0,q=[16,15,11,4],Z=0,Y=0,X=0,K=[new R(0,0),new R(0,0),new R(0,0)],J=128+a.READ_SIZE;i=(1<<(r=E(_=new a(t))))-16,f=(l=1<<r)-1,d=new Uint8Array(l+J+o.maxDictionaryWordLength),m=l,w=[],S=[];for(var Q=0;Q<3*x;Q++)w[Q]=new s(0,0),S[Q]=new s(0,0);for(;!j;){var $,tt,et,nt,rt,it,at,ot,st,lt,ut,ct=0,ht=[1<<28,1<<28,1<<28],ft=[0],dt=[1,1,1],pt=[0,1,0,1,0,1],gt=[0],yt=null,vt=null,bt=0,mt=null,wt=0,xt=0,St=0;for(n=0;n<3;++n)K[n].codes=null,K[n].htrees=null;_.readMoreInput();var _t=T(_);if(V+(ct=_t.meta_block_length)>e.buffer.length){var kt=new Uint8Array(V+ct);kt.set(e.buffer),e.buffer=kt}if(j=_t.input_end,$=_t.is_uncompressed,_t.is_metadata)for(void 0,G=(W=_).bit_pos_+7&-8,W.readBits(G-W.bit_pos_);ct>0;--ct)_.readMoreInput(),_.readBits(8);else if(0!==ct)if($)_.bit_pos_=_.bit_pos_+7&-8,z(e,ct,V,d,f,_),V+=ct;else{for(n=0;n<3;++n)dt[n]=I(_)+1,dt[n]>=2&&(L(dt[n]+2,w,n*x,_),L(y,S,n*x,_),ht[n]=B(S,n*x,_),gt[n]=1);for(_.readMoreInput(),nt=(1<<(tt=_.readBits(2)))-1,rt=(et=k+(_.readBits(4)<<tt))+(48<<tt),yt=new Uint8Array(dt[0]),n=0;n<dt[0];++n)_.readMoreInput(),yt[n]=_.readBits(2)<<1;var Ct=F(dt[0]<<v,_);at=Ct.num_htrees,it=Ct.context_map;var At=F(dt[2]<<b,_);for(st=At.num_htrees,ot=At.context_map,K[0]=new R(p,at),K[1]=new R(g,dt[1]),K[2]=new R(rt,st),n=0;n<3;++n)K[n].decode(_);for(vt=0,mt=0,lt=yt[ft[0]],xt=u.lookupOffsets[lt],St=u.lookupOffsets[lt+1],ut=K[1].htrees[0];ct>0;){var Pt,Et,It,Tt,Ot,Lt,Bt,Mt,Rt,Ft,Dt,zt;for(_.readMoreInput(),0===ht[1]&&(D(dt[1],w,1,ft,pt,gt,_),ht[1]=B(S,x,_),ut=K[1].htrees[ft[1]]),--ht[1],(Et=(Pt=O(K[1].codes,ut,_))>>6)>=2?(Et-=2,Bt=-1):Bt=0,It=c.kInsertRangeLut[Et]+(Pt>>3&7),Tt=c.kCopyRangeLut[Et]+(7&Pt),Ot=c.kInsertLengthPrefixCode[It].offset+_.readBits(c.kInsertLengthPrefixCode[It].nbits),Lt=c.kCopyLengthPrefixCode[Tt].offset+_.readBits(c.kCopyLengthPrefixCode[Tt].nbits),Y=d[V-1&f],X=d[V-2&f],Rt=0;Rt<Ot;++Rt)_.readMoreInput(),0===ht[0]&&(D(dt[0],w,0,ft,pt,gt,_),ht[0]=B(S,0,_),vt=ft[0]<<v,lt=yt[ft[0]],xt=u.lookupOffsets[lt],St=u.lookupOffsets[lt+1]),bt=it[vt+(u.lookup[xt+Y]|u.lookup[St+X])],--ht[0],X=Y,Y=O(K[0].codes,K[0].htrees[bt],_),d[V&f]=Y,(V&f)===f&&e.write(d,l),++V;if((ct-=Ot)<=0)break;if(Bt<0)if(_.readMoreInput(),0===ht[2]&&(D(dt[2],w,2,ft,pt,gt,_),ht[2]=B(S,2*x,_),mt=ft[2]<<b),--ht[2],wt=ot[mt+(255&(Lt>4?3:Lt-2))],(Bt=O(K[2].codes,K[2].htrees[wt],_))>=et)zt=(Bt-=et)&nt,Bt=et+((Nt=(2+(1&(Bt>>=tt))<<(Dt=1+(Bt>>1)))-4)+_.readBits(Dt)<<tt)+zt;if(M=q,N=Z,U=void 0,(P=Bt)<k?(N+=C[P],U=M[N&=3]+A[P]):U=P-k+1,(Mt=U)<0)throw new Error(\"[BrotliDecompress] invalid distance\");if(Ft=V&f,Mt>(H=V<i&&H!==i?V:i)){if(!(Lt>=o.minDictionaryWordLength&&Lt<=o.maxDictionaryWordLength))throw new Error(\"Invalid backward reference. pos: \"+V+\" distance: \"+Mt+\" len: \"+Lt+\" bytes left: \"+ct);var Nt=o.offsetsByLength[Lt],Ut=Mt-H-1,Wt=o.sizeBitsByLength[Lt],Gt=Ut>>Wt;if(Nt+=(Ut&(1<<Wt)-1)*Lt,!(Gt<h.kNumTransforms))throw new Error(\"Invalid backward reference. pos: \"+V+\" distance: \"+Mt+\" len: \"+Lt+\" bytes left: \"+ct);var Vt=h.transformDictionaryWord(d,Ft,Nt,Lt,Gt);if(V+=Vt,ct-=Vt,(Ft+=Vt)>=m){e.write(d,l);for(var jt=0;jt<Ft-m;jt++)d[jt]=d[m+jt]}}else{if(Bt>0&&(q[3&Z]=Mt,++Z),Lt>ct)throw new Error(\"Invalid backward reference. pos: \"+V+\" distance: \"+Mt+\" len: \"+Lt+\" bytes left: \"+ct);for(Rt=0;Rt<Lt;++Rt)d[V&f]=d[V-Mt&f],(V&f)===f&&e.write(d,l),++V,--ct}Y=d[V-1&f],X=d[V-2&f]}V&=1073741823}}e.write(d,V&f)}R.prototype.decode=function(t){var e,n=0;for(e=0;e<this.num_htrees;++e)this.htrees[e]=n,n+=L(this.alphabet_size,this.codes,n,t)},e.BrotliDecompressedSize=N,e.BrotliDecompressBuffer=function(t,e){var n=new r(t);null==e&&(e=N(t));var a=new Uint8Array(e),o=new i(a);return U(n,o),o.pos<o.buffer.length&&(o.buffer=o.buffer.subarray(0,o.pos)),o.buffer},e.BrotliDecompress=U,o.init()},function(t,e){function n(t){this.buffer=t,this.pos=0}function r(t){this.buffer=t,this.pos=0}n.prototype.read=function(t,e,n){this.pos+n>this.buffer.length&&(n=this.buffer.length-this.pos);for(var r=0;r<n;r++)t[e+r]=this.buffer[this.pos+r];return this.pos+=n,n},e.BrotliInput=n,r.prototype.write=function(t,e){if(this.pos+e>this.buffer.length)throw new Error(\"Output buffer is not large enough\");return this.buffer.set(t.subarray(0,e),this.pos),this.pos+=e,e},e.BrotliOutput=r},function(t,e,n){var r=n(286);e.init=function(){e.dictionary=r.init()},e.offsetsByLength=new Uint32Array([0,0,0,0,0,4096,9216,21504,35840,44032,53248,63488,74752,87040,93696,100864,104704,106752,108928,113536,115968,118528,119872,121280,122016]),e.sizeBitsByLength=new Uint8Array([0,0,0,0,10,10,11,11,10,10,10,10,10,9,9,8,7,7,8,7,7,6,6,5,5]),e.minDictionaryWordLength=4,e.maxDictionaryWordLength=24},function(t,e){function n(t,e){this.bits=t,this.value=e}e.HuffmanCode=n;var r=15;function i(t,e){for(var n=1<<e-1;t&n;)n>>=1;return(t&n-1)+n}function a(t,e,r,i,a){for(;t[e+(i-=r)]=new n(a.bits,a.value),i>0;);}function o(t,e,n){for(var i=1<<e-n;e<r&&!((i-=t[e])<=0);)++e,i<<=1;return e-n}e.BrotliBuildHuffmanTable=function(t,e,s,l,u){var c,h,f,d,p,g,y,v,b,m,w=e,x=new Int32Array(r+1),S=new Int32Array(r+1);for(m=new Int32Array(u),h=0;h<u;h++)x[l[h]]++;for(S[1]=0,c=1;c<r;c++)S[c+1]=S[c]+x[c];for(h=0;h<u;h++)0!==l[h]&&(m[S[l[h]]++]=h);if(b=v=1<<(y=s),1===S[r]){for(f=0;f<b;++f)t[e+f]=new n(0,65535&m[0]);return b}for(f=0,h=0,c=1,d=2;c<=s;++c,d<<=1)for(;x[c]>0;--x[c])a(t,e+f,d,v,new n(255&c,65535&m[h++])),f=i(f,c);for(g=b-1,p=-1,c=s+1,d=2;c<=r;++c,d<<=1)for(;x[c]>0;--x[c])(f&g)!==p&&(e+=v,b+=v=1<<(y=o(x,c,s)),t[w+(p=f&g)]=new n(y+s&255,e-w-p&65535)),a(t,e+(f>>s),d,v,new n(c-s&255,65535&m[h++])),f=i(f,c);return b}},function(t,e,n){(function(e){(function(){var r,i,a,o;o=n(8),n(298),r=n(299),a=n(300),i=function(){function t(){}return t.open=function(t,n){var i,s;if(e.isBuffer(t))i=t;else if(t instanceof ArrayBuffer)i=new e(new Uint8Array(t));else if(s=/^data:.+;base64,(.*)$/.exec(t))i=new e(s[1],\"base64\");else if(!(i=o.readFileSync(t)))return;if(255===i[0]&&216===i[1])return new r(i,n);if(137===i[0]&&\"PNG\"===i.toString(\"ascii\",1,4))return new a(i,n);throw new Error(\"Unknown image format.\")},t}(),t.exports=i}).call(this)}).call(e,n(1).Buffer)},function(t,e,n){(function(e){t.exports=e.pdfMake=n(123)}).call(e,n(7))},function(t,e,n){\"use strict\";(function(e,r){var i=n(126),a=n(0).isFunction,o=n(306).saveAs,s={Roboto:{normal:\"Roboto-Regular.ttf\",bold:\"Roboto-Medium.ttf\",italics:\"Roboto-Italic.ttf\",bolditalics:\"Roboto-MediumItalic.ttf\"}};function l(t,e,n,r){this.docDefinition=t,this.tableLayouts=e||null,this.fonts=n||s,this.vfs=r}l.prototype._createDoc=function(t,r){t=t||{},this.tableLayouts&&(t.tableLayouts=this.tableLayouts);var a=new i(this.fonts);n(8).bindFS(this.vfs);var o,s=a.createPdfKitDocument(this.docDefinition,t),l=[];s.on(\"readable\",function(){for(var t;null!==(t=s.read(9007199254740991));)l.push(t)}),s.on(\"end\",function(){o=e.concat(l),r(o,s._pdfMakePages)}),s.end()},l.prototype._getPages=function(t,e){if(!e)throw\"_getPages is an async method and needs a callback argument\";this._createDoc(t,function(t,n){e(n)})},l.prototype._bufferToBlob=function(t){var e;try{e=new Blob([t],{type:\"application/pdf\"})}catch(r){if(\"InvalidStateError\"===r.name){var n=new Uint8Array(t);e=new Blob([n.buffer],{type:\"application/pdf\"})}}if(!e)throw\"Could not generate blob\";return e},l.prototype._openWindow=function(){var t=window.open(\"\",\"_blank\");if(null===t)throw\"Open PDF in new window blocked by browser\";return t},l.prototype._openPdf=function(t,e){e||(e=this._openWindow());try{this.getBlob(function(t){var n=(window.URL||window.webkitURL).createObjectURL(t);e.location.href=n},t)}catch(t){throw e.close(),t}},l.prototype.open=function(t,e){(t=t||{}).autoPrint=!1,e=e||null,this._openPdf(t,e)},l.prototype.print=function(t,e){(t=t||{}).autoPrint=!0,e=e||null,this._openPdf(t,e)},l.prototype.download=function(t,e,n){a(t)&&(e=t,t=null),t=t||\"file.pdf\",this.getBlob(function(n){o(n,t),a(e)&&e()},n)},l.prototype.getBase64=function(t,e){if(!t)throw\"getBase64 is an async method and needs a callback argument\";this.getBuffer(function(e){t(e.toString(\"base64\"))},e)},l.prototype.getDataUrl=function(t,e){if(!t)throw\"getDataUrl is an async method and needs a callback argument\";this.getBuffer(function(e){t(\"data:application/pdf;base64,\"+e.toString(\"base64\"))},e)},l.prototype.getBlob=function(t,e){if(!t)throw\"getBlob is an async method and needs a callback argument\";var n=this;this.getBuffer(function(e){var r=n._bufferToBlob(e);t(r)},e)},l.prototype.getBuffer=function(t,e){if(!t)throw\"getBuffer is an async method and needs a callback argument\";this._createDoc(e,function(e){t(e)})},t.exports={createPdf:function(t){if(!Object.keys)throw\"Your browser does not provide the level of support needed\";return new l(t,r.pdfMake.tableLayouts,r.pdfMake.fonts,r.pdfMake.vfs)}}}).call(e,n(1).Buffer,n(7))},function(t,e,n){\"use strict\";e.byteLength=function(t){return 3*t.length/4-u(t)},e.toByteArray=function(t){var e,n,r,o,s,l=t.length;o=u(t),s=new a(3*l/4-o),n=o>0?l-4:l;var c=0;for(e=0;e<n;e+=4)r=i[t.charCodeAt(e)]<<18|i[t.charCodeAt(e+1)]<<12|i[t.charCodeAt(e+2)]<<6|i[t.charCodeAt(e+3)],s[c++]=r>>16&255,s[c++]=r>>8&255,s[c++]=255&r;2===o?(r=i[t.charCodeAt(e)]<<2|i[t.charCodeAt(e+1)]>>4,s[c++]=255&r):1===o&&(r=i[t.charCodeAt(e)]<<10|i[t.charCodeAt(e+1)]<<4|i[t.charCodeAt(e+2)]>>2,s[c++]=r>>8&255,s[c++]=255&r);return s},e.fromByteArray=function(t){for(var e,n=t.length,i=n%3,a=\"\",o=[],s=0,l=n-i;s<l;s+=16383)o.push(c(t,s,s+16383>l?l:s+16383));1===i?(e=t[n-1],a+=r[e>>2],a+=r[e<<4&63],a+=\"==\"):2===i&&(e=(t[n-2]<<8)+t[n-1],a+=r[e>>10],a+=r[e>>4&63],a+=r[e<<2&63],a+=\"=\");return o.push(a),o.join(\"\")};for(var r=[],i=[],a=\"undefined\"!=typeof Uint8Array?Uint8Array:Array,o=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",s=0,l=o.length;s<l;++s)r[s]=o[s],i[o.charCodeAt(s)]=s;function u(t){var e=t.length;if(e%4>0)throw new Error(\"Invalid string. Length must be a multiple of 4\");return\"=\"===t[e-2]?2:\"=\"===t[e-1]?1:0}function c(t,e,n){for(var i,a,o=[],s=e;s<n;s+=3)i=(t[s]<<16&16711680)+(t[s+1]<<8&65280)+(255&t[s+2]),o.push(r[(a=i)>>18&63]+r[a>>12&63]+r[a>>6&63]+r[63&a]);return o.join(\"\")}i[\"-\".charCodeAt(0)]=62,i[\"_\".charCodeAt(0)]=63},function(t,e){e.read=function(t,e,n,r,i){var a,o,s=8*i-r-1,l=(1<<s)-1,u=l>>1,c=-7,h=n?i-1:0,f=n?-1:1,d=t[e+h];for(h+=f,a=d&(1<<-c)-1,d>>=-c,c+=s;c>0;a=256*a+t[e+h],h+=f,c-=8);for(o=a&(1<<-c)-1,a>>=-c,c+=r;c>0;o=256*o+t[e+h],h+=f,c-=8);if(0===a)a=1-u;else{if(a===l)return o?NaN:1/0*(d?-1:1);o+=Math.pow(2,r),a-=u}return(d?-1:1)*o*Math.pow(2,a-r)},e.write=function(t,e,n,r,i,a){var o,s,l,u=8*a-i-1,c=(1<<u)-1,h=c>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=r?0:a-1,p=r?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,o=c):(o=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-o))<1&&(o--,l*=2),(e+=o+h>=1?f/l:f*Math.pow(2,1-h))*l>=2&&(o++,l/=2),o+h>=c?(s=0,o=c):o+h>=1?(s=(e*l-1)*Math.pow(2,i),o+=h):(s=e*Math.pow(2,h-1)*Math.pow(2,i),o=0));i>=8;t[n+d]=255&s,d+=p,s/=256,i-=8);for(o=o<<i|s,u+=i;u>0;t[n+d]=255&o,d+=p,o/=256,u-=8);t[n+d-p]|=128*g}},function(t,e,n){\"use strict\";var r=n(127),i=n(128),a=n(138),o=n(303),s=n(304),l=n(305),u=n(42),c=n(0).isFunction,h=n(0).isString,f=n(0).isNumber,d=n(0).isBoolean,p=n(0).isArray;function g(t){this.fontDescriptors=t}function y(t){if(!t)return null;if(f(t))t={left:t,right:t,top:t,bottom:t};else if(p(t))if(2===t.length)t={left:t[0],top:t[1],right:t[0],bottom:t[1]};else{if(4!==t.length)throw\"Invalid pageMargins definition\";t={left:t[0],top:t[1],right:t[2],bottom:t[3]}}return t}function v(t,e){var n=e.options.size[0]>e.options.size[1]?\"landscape\":\"portrait\";if(t.pageSize.orientation!==n){var r=e.options.size[0],i=e.options.size[1];e.options.size=[i,r]}}function b(t,e,n,r){if(t._pageNodeRef){var i,a,o=new u(null),s=t._pageNodeRef.positions[0].pageNumber.toString();switch(t.inlines[0].text=s,t.inlines[0].linkToPage=s,i=o.widthOfString(t.inlines[0].text,t.inlines[0].font,t.inlines[0].fontSize,t.inlines[0].characterSpacing,t.inlines[0].fontFeatures),a=t.inlines[0].width-i,t.inlines[0].width=i,t.inlines[0].alignment){case\"right\":t.inlines[0].x+=a;break;case\"center\":t.inlines[0].x+=a/2}}e=e||0,n=n||0;var c=t.getHeight(),h=c-t.getAscenderHeight();l.drawBackground(t,e,n,r);for(var f=0,d=t.inlines.length;f<d;f++){var p=t.inlines[f],g=c-p.font.ascender/1e3*p.fontSize-h,y={lineBreak:!1,textWidth:p.width,characterSpacing:p.characterSpacing,wordCount:1,link:p.link};if(p.fontFeatures&&(y.features=p.fontFeatures),r.fill(p.color||\"black\"),r._font=p.font,r.fontSize(p.fontSize),r.text(p.text,e+p.x,n+g,y),p.linkToPage){r.ref({Type:\"Action\",S:\"GoTo\",D:[p.linkToPage,0,0]}).end();r.annotate(e+p.x,n+g,p.width,p.height,{Subtype:\"Link\",Dest:[p.linkToPage-1,\"XYZ\",null,null,null]})}}l.drawDecorations(t,e,n,r)}function m(t,e){var n=t.watermark;e.fill(n.color),e.opacity(n.opacity),e.save();var r=-180*Math.atan2(e.page.height,e.page.width)/Math.PI;e.rotate(r,{origin:[e.page.width/2,e.page.height/2]});var i=e.page.width/2-n.size.size.width/2,a=e.page.height/2-n.size.size.height/4;e._font=n.font,e.fontSize(n.size.fontSize),e.text(n.text,i,a,{lineBreak:!1}),e.restore()}function w(t,e){switch(e.lineWidth(t.lineWidth||1),t.dash?e.dash(t.dash.length,{space:t.dash.space||t.dash.length,phase:t.dash.phase||0}):e.undash(),e.lineJoin(t.lineJoin||\"miter\"),e.lineCap(t.lineCap||\"butt\"),t.type){case\"ellipse\":e.ellipse(t.x,t.y,t.r1,t.r2);break;case\"rect\":if(t.r?e.roundedRect(t.x,t.y,t.w,t.h,t.r):e.rect(t.x,t.y,t.w,t.h),t.linearGradient){for(var n=e.linearGradient(t.x,t.y,t.x+t.w,t.y),r=1/(t.linearGradient.length-1),i=0;i<t.linearGradient.length;i++)n.stop(i*r,t.linearGradient[i]);t.color=n}break;case\"line\":e.moveTo(t.x1,t.y1),e.lineTo(t.x2,t.y2);break;case\"polyline\":if(0===t.points.length)break;e.moveTo(t.points[0].x,t.points[0].y);i=1;for(var a=t.points.length;i<a;i++)e.lineTo(t.points[i].x,t.points[i].y);if(t.points.length>1){var o=t.points[0],s=t.points[t.points.length-1];(t.closePath||o.x===s.x&&o.y===s.y)&&e.closePath()}break;case\"path\":e.path(t.d)}t.color&&t.lineColor?(e.fillColor(t.color,t.fillOpacity||1),e.strokeColor(t.lineColor,t.strokeOpacity||1),e.fillAndStroke()):t.color?(e.fillColor(t.color,t.fillOpacity||1),e.fill()):(e.strokeColor(t.lineColor||\"black\",t.strokeOpacity||1),e.stroke())}function x(t,e,n,r){r.image(t.image,t.x,t.y,{width:t._width,height:t._height}),t.link&&r.link(t.x,t.y,t._width,t._height,t.link)}function S(t,e){e.save(),e.addContent(t.x+\" \"+t.y+\" \"+t.width+\" \"+t.height+\" re\"),e.clip()}g.prototype.createPdfKitDocument=function(t,e){e=e||{};var n=function(t,e){t&&\"auto\"===t.height&&(t.height=1/0);var n=function(t){if(h(t)){var e=o[t.toUpperCase()];if(!e)throw\"Page size \"+t+\" not recognized\";return{width:e[0],height:e[1]}}return t}(t||\"A4\");(function(t){if(h(t))return\"portrait\"===(t=t.toLowerCase())&&n.width>n.height||\"landscape\"===t&&n.width<n.height;return!1})(e)&&(n={width:n.height,height:n.width});return n.orientation=n.width>n.height?\"landscape\":\"portrait\",n}(t.pageSize,t.pageOrientation),l=!d(t.compress)||t.compress;this.pdfKitDoc=new a({size:[n.width,n.height],autoFirstPage:!1,compress:l}),function(t,e){function n(t){var e=t.charAt(0).toUpperCase()+t.slice(1);return-1!==[\"Title\",\"Author\",\"Subject\",\"Keywords\",\"Creator\",\"Producer\",\"CreationDate\",\"ModDate\",\"Trapped\"].indexOf(e)?e:t.replace(/\\s+/g,\"\")}if(e.info.Producer=\"pdfmake\",e.info.Creator=\"pdfmake\",t.info)for(var r in t.info){var i=t.info[r];i&&(r=n(r),e.info[r]=i)}}(t,this.pdfKitDoc),this.fontProvider=new r(this.fontDescriptors,this.pdfKitDoc),t.images=t.images||{};var u=new i(n,y(t.pageMargins||40),new s(this.pdfKitDoc,t.images));u.registerTableLayouts({noBorders:{hLineWidth:function(t){return 0},vLineWidth:function(t){return 0},paddingLeft:function(t){return t?4:0},paddingRight:function(t,e){return t<e.table.widths.length-1?4:0}},headerLineOnly:{hLineWidth:function(t,e){return 0===t||t===e.table.body.length?0:t===e.table.headerRows?2:0},vLineWidth:function(t){return 0},paddingLeft:function(t){return 0===t?0:8},paddingRight:function(t,e){return t===e.table.widths.length-1?0:8}},lightHorizontalLines:{hLineWidth:function(t,e){return 0===t||t===e.table.body.length?0:t===e.table.headerRows?2:1},vLineWidth:function(t){return 0},hLineColor:function(t){return 1===t?\"black\":\"#aaa\"},paddingLeft:function(t){return 0===t?0:8},paddingRight:function(t,e){return t===e.table.widths.length-1?0:8}}}),e.tableLayouts&&u.registerTableLayouts(e.tableLayouts);var p,g,_,k,C=u.layoutDocument(t.content,this.fontProvider,t.styles||{},t.defaultStyle||{fontSize:12,font:\"Roboto\"},t.background,t.header,t.footer,t.images,t.watermark,t.pageBreakBefore),A=t.maxPagesNumber||-1;if(f(A)&&A>-1&&(C=C.slice(0,A)),n.height===1/0){var P=(p=C,g=t.pageMargins,_=y(g||40),k=_.top+_.bottom,p.forEach(function(t){t.items.forEach(function(t){var e;k+=c((e=t).item.getHeight)?e.item.getHeight():e.item._height?e.item._height:0})}),k);this.pdfKitDoc.options.size=[n.width,P]}if(function(t,e,n,r){n._pdfMakePages=t,n.addPage();var i=0;r&&t.forEach(function(t){i+=t.items.length});var a=0;r=r||function(){};for(var o=0;o<t.length;o++){o>0&&(v(t[o],n),n.addPage(n.options));for(var s=t[o],l=0,u=s.items.length;l<u;l++){var c=s.items[l];switch(c.type){case\"vector\":w(c.item,n);break;case\"line\":b(c.item,c.item.x,c.item.y,n);break;case\"image\":x(c.item,c.item.x,c.item.y,n);break;case\"beginClip\":S(c.item,n);break;case\"endClip\":n.restore()}r(++a/i)}s.watermark&&m(s,n)}}(C,this.fontProvider,this.pdfKitDoc,e.progressCallback),e.autoPrint){var E=this.pdfKitDoc.ref({Type:\"Action\",S:\"Named\",N:\"Print\"});this.pdfKitDoc._root.data.OpenAction=E,E.end()}return this.pdfKitDoc},t.exports=g},function(t,e,n){\"use strict\";var r=n(0).isArray;function i(t,e){for(var n in this.fonts={},this.pdfKitDoc=e,this.fontCache={},t)if(t.hasOwnProperty(n)){var r=t[n];this.fonts[n]={normal:r.normal,bold:r.bold,italics:r.italics,bolditalics:r.bolditalics}}}i.prototype.provideFont=function(t,e,n){var i,a,o,s=(a=n,o=\"normal\",(i=e)&&a?o=\"bolditalics\":i?o=\"bold\":a&&(o=\"italics\"),o);if(!this.fonts[t]||!this.fonts[t][s])throw new Error(\"Font '\"+t+\"' in style '\"+s+\"' is not defined in the font section of the document definition.\");if(this.fontCache[t]=this.fontCache[t]||{},!this.fontCache[t][s]){var l=this.fonts[t][s];r(l)||(l=[l]),this.fontCache[t][s]=this.pdfKitDoc.font.apply(this.pdfKitDoc,l)._font}return this.fontCache[t][s]},t.exports=i},function(t,e,n){\"use strict\";var r=n(77),i=n(129),a=n(130),o=n(81),s=n(135),l=n(44),u=n(137),c=n(82),h=n(0).isString,f=n(0).isArray,d=n(0).pack,p=n(0).offsetVector,g=n(0).fontStringify,y=n(0).isFunction,v=n(42),b=n(80);function m(t,e){e.forEach(function(e){t.push(e)})}function w(t,e,n){this.pageSize=t,this.pageMargins=e,this.tracker=new r,this.imageMeasure=n,this.tableLayouts={}}w.prototype.registerTableLayouts=function(t){this.tableLayouts=d(this.tableLayouts,t)},w.prototype.layoutDocument=function(t,e,n,r,o,s,l,u,c,h){function d(t,e){return!!y(h)&&((t=t.filter(function(t){return t.positions.length>0})).forEach(function(t){var n={};[\"id\",\"text\",\"ul\",\"ol\",\"table\",\"image\",\"qr\",\"canvas\",\"columns\",\"headlineLevel\",\"style\",\"pageBreak\",\"pageOrientation\",\"width\",\"height\"].forEach(function(e){void 0!==t[e]&&(n[e]=t[e])}),n.startPosition=t.positions[0],n.pageNumbers=t.positions.map(function(t){return t.pageNumber}).filter(function(t,e,n){return n.indexOf(t)===e}),n.pages=e.length,n.stack=f(t.stack),t.nodeInfo=n}),t.some(function(t,e,n){if(\"before\"!==t.pageBreak&&!t.pageBreakCalculated){t.pageBreakCalculated=!0;var r=t.nodeInfo.pageNumbers[0],i=n.slice(e+1).filter(function(t){return t.nodeInfo.pageNumbers.indexOf(r)>-1}),a=n.slice(e+1).filter(function(t){return t.nodeInfo.pageNumbers.indexOf(r+1)>-1}),o=n.slice(0,e).filter(function(t){return t.nodeInfo.pageNumbers.indexOf(r)>-1});if(h(t.nodeInfo,i.map(function(t){return t.nodeInfo}),a.map(function(t){return t.nodeInfo}),o.map(function(t){return t.nodeInfo})))return t.pageBreak=\"before\",!0}}))}this.docPreprocessor=new i,this.docMeasure=new a(e,n,r,this.imageMeasure,this.tableLayouts,u);for(var p=this.tryLayoutDocument(t,e,n,r,o,s,l,u,c);d(p.linearNodeList,p.pages);)p.linearNodeList.forEach(function(t){t.resetXY()}),p=this.tryLayoutDocument(t,e,n,r,o,s,l,u,c);return p.pages},w.prototype.tryLayoutDocument=function(t,e,n,r,i,a,l,u,c,h){this.linearNodeList=[],t=this.docPreprocessor.preprocessDocument(t),t=this.docMeasure.measureDocument(t),this.writer=new s(new o(this.pageSize,this.pageMargins),this.tracker);var f=this;return this.writer.context().tracker.startTracking(\"pageAdded\",function(){f.addBackground(i)}),this.addBackground(i),this.processNode(t),this.addHeadersAndFooters(a,l),null!=c&&this.addWatermark(c,e,r),{pages:this.writer.context().pages,linearNodeList:this.linearNodeList}},w.prototype.addBackground=function(t){var e=(y(t)?t:function(){return t})(this.writer.context().page+1);if(e){var n=this.writer.context().getCurrentPage().pageSize;this.writer.beginUnbreakableBlock(n.width,n.height),e=this.docPreprocessor.preprocessDocument(e),this.processNode(this.docMeasure.measureDocument(e)),this.writer.commitUnbreakableBlock(0,0),this.writer.context().hasBackground=!0}},w.prototype.addStaticRepeatable=function(t,e){this.addDynamicRepeatable(function(){return JSON.parse(JSON.stringify(t))},e)},w.prototype.addDynamicRepeatable=function(t,e){for(var n=0,r=this.writer.context().pages.length;n<r;n++){this.writer.context().page=n;var i=t(n+1,r,this.writer.context().pages[n].pageSize);if(i){var a=e(this.writer.context().getCurrentPage().pageSize,this.pageMargins);this.writer.beginUnbreakableBlock(a.width,a.height),i=this.docPreprocessor.preprocessDocument(i),this.processNode(this.docMeasure.measureDocument(i)),this.writer.commitUnbreakableBlock(a.x,a.y)}}},w.prototype.addHeadersAndFooters=function(t,e){var n=function(t,e){return{x:0,y:0,width:t.width,height:e.top}},r=function(t,e){return{x:0,y:t.height-e.bottom,width:t.width,height:e.bottom}};y(t)?this.addDynamicRepeatable(t,n):t&&this.addStaticRepeatable(t,n),y(e)?this.addDynamicRepeatable(e,r):e&&this.addStaticRepeatable(e,r)},w.prototype.addWatermark=function(t,e,n){if(h(t)&&(t={text:t}),t.text){t.font=t.font||n.font||\"Roboto\",t.color=t.color||\"black\",t.opacity=t.opacity||.6,t.bold=t.bold||!1,t.italics=t.italics||!1;for(var r={text:t.text,font:e.provideFont(t.font,t.bold,t.italics),size:function(t,e,n){var r,i=t.width,a=t.height,o=.8*Math.sqrt(i*i+a*a),s=new v(n),l=new b(null,{font:e.font,bold:e.bold,italics:e.italics}),u=0,c=1e3,h=(u+c)/2;for(;Math.abs(u-c)>1;)l.push({fontSize:h}),(r=s.sizeOfString(e.text,l)).width>o?h=(u+(c=h))/2:r.width<o&&(h=((u=h)+c)/2),l.pop();return{size:r,fontSize:h}}(this.pageSize,t,e),color:t.color,opacity:t.opacity},i=this.writer.context().pages,a=0,o=i.length;a<o;a++)i[a].watermark=r}},w.prototype.processNode=function(t){var e,n,r,i=this;this.linearNodeList.push(t),n=(e=t).x,r=e.y,e.positions=[],f(e.canvas)&&e.canvas.forEach(function(t){var e=t.x,n=t.y,r=t.x1,i=t.y1,a=t.x2,o=t.y2;t.resetXY=function(){t.x=e,t.y=n,t.x1=r,t.y1=i,t.x2=a,t.y2=o}}),e.resetXY=function(){e.x=n,e.y=r,f(e.canvas)&&e.canvas.forEach(function(t){t.resetXY()})},function(e){var n=t._margin;\"before\"===t.pageBreak&&i.writer.moveToNextPage(t.pageOrientation);n&&(i.writer.context().moveDown(n[1]),i.writer.context().addMargin(n[0],n[2]));e(),n&&(i.writer.context().addMargin(-n[0],-n[2]),i.writer.context().moveDown(n[3]));\"after\"===t.pageBreak&&i.writer.moveToNextPage(t.pageOrientation)}(function(){var e=t.unbreakable;e&&i.writer.beginUnbreakableBlock();var n=t.absolutePosition;n&&(i.writer.context().beginDetachedBlock(),i.writer.context().moveTo(n.x||0,n.y||0));var r=t.relativePosition;if(r&&(i.writer.context().beginDetachedBlock(),i.writer.context().moveTo((r.x||0)+i.writer.context().x,(r.y||0)+i.writer.context().y)),t.stack)i.processVerticalContainer(t);else if(t.columns)i.processColumns(t);else if(t.ul)i.processList(!1,t);else if(t.ol)i.processList(!0,t);else if(t.table)i.processTable(t);else if(void 0!==t.text)i.processLeaf(t);else if(t.toc)i.processToc(t);else if(t.image)i.processImage(t);else if(t.canvas)i.processCanvas(t);else if(t.qr)i.processQr(t);else if(!t._span)throw\"Unrecognized document structure: \"+JSON.stringify(t,g);(n||r)&&i.writer.context().endDetachedBlock(),e&&i.writer.commitUnbreakableBlock()})},w.prototype.processVerticalContainer=function(t){var e=this;t.stack.forEach(function(n){e.processNode(n),m(t.positions,n.positions)})},w.prototype.processColumns=function(t){var e=t.columns,n=this.writer.context().availableWidth,r=function(t){if(!t)return null;var n=[];n.push(0);for(var r=e.length-1;r>0;r--)n.push(t);return n}(t._gap);r&&(n-=(r.length-1)*t._gap),l.buildColumnWidths(e,n);var i=this.processRow(e,e,r);m(t.positions,i.positions)},w.prototype.processRow=function(t,e,n,r,i,a){var o=this,s=[],l=[];return this.tracker.auto(\"pageChanged\",function(t){for(var e,n=0,r=s.length;n<r;n++){var i=s[n];if(i.prevPage===t.prevPage){e=i;break}}e||(e=t,s.push(e));e.prevY=Math.max(e.prevY,t.prevY),e.y=Math.min(e.y,t.y)},function(){e=e||t,o.writer.context().beginColumnGroup();for(var r=0,i=t.length;r<i;r++){var s=t[r],h=e[r]._calcWidth,f=u(r);if(s.colSpan&&s.colSpan>1)for(var d=1;d<s.colSpan;d++)h+=e[++r]._calcWidth+n[r];o.writer.context().beginColumn(h,f,c(s,r)),s._span?s._columnEndingContext&&o.writer.context().markEnding(s):(o.processNode(s),m(l,s.positions))}o.writer.context().completeColumnGroup(a)}),{pageBreaks:s,positions:l};function u(t){return n&&n.length>t?n[t]:0}function c(t,e){if(t.rowSpan&&t.rowSpan>1){var n=i+t.rowSpan-1;if(n>=r.length)throw\"Row span for column \"+e+\" (with indexes starting from 0) exceeded row count\";return r[n][e]}return null}},w.prototype.processList=function(t,e){var n,r=this,i=t?e.ol:e.ul,a=e._gapSize;this.writer.context().addMargin(a.width),this.tracker.auto(\"lineAdded\",function(t){if(n){var e=n;if(n=null,e.canvas){var i=e.canvas[0];p(i,-e._minWidth,0),r.writer.addVector(i)}else if(e._inlines){var a=new c(r.pageSize.width);a.addInline(e._inlines[0]),a.x=-e._minWidth,a.y=t.getAscenderHeight()-a.getAscenderHeight(),r.writer.addLine(a,!0)}}},function(){i.forEach(function(t){n=t.listMarker,r.processNode(t),m(e.positions,t.positions)})}),this.writer.context().addMargin(-a.width)},w.prototype.processTable=function(t){var e=new u(t);e.beginTable(this.writer);for(var n=t.table.heights,r=0,i=t.table.body.length;r<i;r++){var a;e.beginRow(r,this.writer),\"auto\"===(a=y(n)?n(r):f(n)?n[r]:n)&&(a=void 0);var o=this.processRow(t.table.body[r],t.table.widths,t._offsets.offsets,t.table.body,r,a);m(t.positions,o.positions),e.endRow(r,this.writer,o.pageBreaks)}e.endTable(this.writer)},w.prototype.processLeaf=function(t){var e=this.buildNextLine(t),n=e?e.getHeight():0,r=t.maxHeight||-1;for(t._tocItemRef&&(e._pageNodeRef=t._tocItemRef),t._pageRef&&(e._pageNodeRef=t._pageRef._nodeRef);e&&(-1===r||n<r);){var i=this.writer.addLine(e);t.positions.push(i),(e=this.buildNextLine(t))&&(n+=e.getHeight())}},w.prototype.processToc=function(t){t.toc.title&&this.processNode(t.toc.title),this.processNode(t.toc._table)},w.prototype.buildNextLine=function(t){function e(t){var e=t.constructor();for(var n in t)e[n]=t[n];return e}if(!t._inlines||0===t._inlines.length)return null;for(var n=new c(this.writer.context().availableWidth),r=new v(null);t._inlines&&t._inlines.length>0&&n.hasEnoughSpaceForInline(t._inlines[0]);){var i=t._inlines.shift();if(!i.noWrap&&i.text.length>1&&i.width>n.maxWidth){var a=i.width/i.text.length,o=Math.floor(n.maxWidth/a);if(o<1&&(o=1),o<i.text.length){var s=e(i);s.text=i.text.substr(o),i.text=i.text.substr(0,o),s.width=r.widthOfString(s.text,s.font,s.fontSize,s.characterSpacing,s.fontFeatures),i.width=r.widthOfString(i.text,i.font,i.fontSize,i.characterSpacing,i.fontFeatures),t._inlines.unshift(s)}}n.addInline(i)}return n.lastLineInParagraph=0===t._inlines.length,n},w.prototype.processImage=function(t){var e=this.writer.addImage(t);t.positions.push(e)},w.prototype.processCanvas=function(t){var e=t._minHeight;void 0===t.absolutePosition&&this.writer.context().availableHeight<e&&this.writer.moveToNextPage(),this.writer.alignCanvas(t),t.canvas.forEach(function(e){var n=this.writer.addVector(e);t.positions.push(n)},this),this.writer.context().moveDown(e)},w.prototype.processQr=function(t){var e=this.writer.addQr(t);t.positions.push(e)},t.exports=w},function(t,e,n){\"use strict\";(function(e){var r=n(0).isString,i=n(0).isNumber,a=n(0).isBoolean,o=n(0).isArray,s=n(0).isUndefined,l=n(0).fontStringify;function u(){}u.prototype.preprocessDocument=function(t){return this.tocs=[],this.nodeReferences=[],this.preprocessNode(t)},u.prototype.preprocessNode=function(t){if(o(t)?t={stack:t}:r(t)?t={text:t}:i(t)||a(t)?t={text:t.toString()}:null===t?t={text:\"\"}:0===Object.keys(t).length&&(t={text:\"\"}),t.columns)return this.preprocessColumns(t);if(t.stack)return this.preprocessVerticalContainer(t);if(t.ul)return this.preprocessList(t);if(t.ol)return this.preprocessList(t);if(t.table)return this.preprocessTable(t);if(void 0!==t.text)return this.preprocessText(t);if(t.toc)return this.preprocessToc(t);if(t.image)return this.preprocessImage(t);if(t.canvas)return this.preprocessCanvas(t);if(t.qr)return this.preprocessQr(t);if(t.pageReference||t.textReference)return this.preprocessText(t);throw\"Unrecognized document structure: \"+JSON.stringify(t,l)},u.prototype.preprocessColumns=function(t){for(var e=t.columns,n=0,r=e.length;n<r;n++)e[n]=this.preprocessNode(e[n]);return t},u.prototype.preprocessVerticalContainer=function(t){for(var e=t.stack,n=0,r=e.length;n<r;n++)e[n]=this.preprocessNode(e[n]);return t},u.prototype.preprocessList=function(t){for(var e=t.ul||t.ol,n=0,r=e.length;n<r;n++)e[n]=this.preprocessNode(e[n]);return t},u.prototype.preprocessTable=function(t){var e,n,r,i;for(e=0,r=t.table.body[0].length;e<r;e++)for(n=0,i=t.table.body.length;n<i;n++){var a=t.table.body[n],o=a[e];void 0!==o&&(null===o&&(o=\"\"),o._span||(a[e]=this.preprocessNode(o)))}return t},u.prototype.preprocessText=function(t){if(t.tocItem){o(t.tocItem)||(t.tocItem=[t.tocItem]);for(var e=0,n=t.tocItem.length;e<n;e++){r(t.tocItem[e])||(t.tocItem[e]=\"_default_\");var i=t.tocItem[e];this.tocs[i]||(this.tocs[i]={toc:{_items:[],_pseudo:!0}}),this.tocs[i].toc._items.push(t)}}if(t.id)if(this.nodeReferences[t.id]){if(!this.nodeReferences[t.id]._pseudo)throw\"Node id '\"+t.id+\"' already exists\";this.nodeReferences[t.id]._nodeRef=t,this.nodeReferences[t.id]._pseudo=!1}else this.nodeReferences[t.id]={_nodeRef:t};return t.pageReference&&(this.nodeReferences[t.pageReference]||(this.nodeReferences[t.pageReference]={_nodeRef:{},_pseudo:!0}),t.text=\"00000\",t._pageRef=this.nodeReferences[t.pageReference]),t.textReference&&(this.nodeReferences[t.textReference]||(this.nodeReferences[t.textReference]={_nodeRef:{},_pseudo:!0}),t.text=\"\",t._textRef=this.nodeReferences[t.textReference]),t.text&&t.text.text&&(t.text=[this.preprocessNode(t.text)]),t},u.prototype.preprocessToc=function(t){if(t.toc.id||(t.toc.id=\"_default_\"),t.toc.title=t.toc.title?this.preprocessNode(t.toc.title):null,t.toc._items=[],this.tocs[t.toc.id]){if(!this.tocs[t.toc.id].toc._pseudo)throw\"TOC '\"+t.toc.id+\"' already exists\";t.toc._items=this.tocs[t.toc.id].toc._items}return this.tocs[t.toc.id]=t,t},u.prototype.preprocessImage=function(t){return s(t.image.type)||s(t.image.data)||\"Buffer\"!==t.image.type||!o(t.image.data)||(t.image=e.from(t.image.data)),t},u.prototype.preprocessCanvas=function(t){return t},u.prototype.preprocessQr=function(t){return t},t.exports=u}).call(e,n(1).Buffer)},function(t,e,n){\"use strict\";var r=n(42),i=n(80),a=n(44),o=n(0).isString,s=n(0).isNumber,l=n(0).isObject,u=n(0).isArray,c=n(0).fontStringify,h=n(0).pack,f=n(134);function d(t,e,n,a,o,s){this.textTools=new r(t),this.styleStack=new i(e,n),this.imageMeasure=a,this.tableLayouts=o,this.images=s,this.autoImageIndex=1}d.prototype.measureDocument=function(t){return this.measureNode(t)},d.prototype.measureNode=function(t){var e=this;return this.styleStack.auto(t,function(){if(t._margin=function(){function n(t,e){return t.marginLeft||t.marginTop||t.marginRight||t.marginBottom?[t.marginLeft||e[0]||0,t.marginTop||e[1]||0,t.marginRight||e[2]||0,t.marginBottom||e[3]||0]:e}function r(t){return s(t)?t=[t,t,t,t]:u(t)&&2===t.length&&(t=[t[0],t[1],t[0],t[1]]),t}var i=[void 0,void 0,void 0,void 0];if(t.style){var a=u(t.style)?t.style:[t.style],o=function(t){for(var n={},r=t.length-1;r>=0;r--){var i=t[r],a=e.styleStack.styleDictionary[i];for(var o in a)a.hasOwnProperty(o)&&(n[o]=a[o])}return n}(a);o&&(i=n(o,i)),o.margin&&(i=r(o.margin))}i=n(t,i),t.margin&&(i=r(t.margin));return void 0===i[0]&&void 0===i[1]&&void 0===i[2]&&void 0===i[3]?null:i}(),t.columns)return n(e.measureColumns(t));if(t.stack)return n(e.measureVerticalContainer(t));if(t.ul)return n(e.measureUnorderedList(t));if(t.ol)return n(e.measureOrderedList(t));if(t.table)return n(e.measureTable(t));if(void 0!==t.text)return n(e.measureLeaf(t));if(t.toc)return n(e.measureToc(t));if(t.image)return n(e.measureImage(t));if(t.canvas)return n(e.measureCanvas(t));if(t.qr)return n(e.measureQr(t));throw\"Unrecognized document structure: \"+JSON.stringify(t,c)});function n(t){var e=t._margin;return e&&(t._minWidth+=e[0]+e[2],t._maxWidth+=e[0]+e[2]),t}},d.prototype.convertIfBase64Image=function(t){if(/^data:image\\/(jpeg|jpg|png);base64,/.test(t.image)){var e=\"$$pdfmake$$\"+this.autoImageIndex++;this.images[e]=t.image,t.image=e}},d.prototype.measureImage=function(t){this.images&&this.convertIfBase64Image(t);var e=this.imageMeasure.measureImage(t.image);if(t.fit){var n=e.width/e.height>t.fit[0]/t.fit[1]?t.fit[0]/e.width:t.fit[1]/e.height;t._width=t._minWidth=t._maxWidth=e.width*n,t._height=e.height*n}else t._width=t._minWidth=t._maxWidth=t.width||e.width,t._height=t.height||e.height*t._width/e.width,s(t.maxWidth)&&t.maxWidth<t._width&&(t._width=t._minWidth=t._maxWidth=t.maxWidth,t._height=t._width*e.height/e.width),s(t.maxHeight)&&t.maxHeight<t._height&&(t._height=t.maxHeight,t._width=t._minWidth=t._maxWidth=t._height*e.width/e.height),s(t.minWidth)&&t.minWidth>t._width&&(t._width=t._minWidth=t._maxWidth=t.minWidth,t._height=t._width*e.height/e.width),s(t.minHeight)&&t.minHeight>t._height&&(t._height=t.minHeight,t._width=t._minWidth=t._maxWidth=t._height*e.width/e.height);return t._alignment=this.styleStack.getProperty(\"alignment\"),t},d.prototype.measureLeaf=function(t){t._textRef&&t._textRef._nodeRef.text&&(t.text=t._textRef._nodeRef.text);var e=this.styleStack.clone();e.push(t);var n=this.textTools.buildInlines(t.text,e);return t._inlines=n.items,t._minWidth=n.minWidth,t._maxWidth=n.maxWidth,t},d.prototype.measureToc=function(t){t.toc.title&&(t.toc.title=this.measureNode(t.toc.title));for(var e=[],n=t.toc.textStyle||{},r=t.toc.numberStyle||n,i=t.toc.textMargin||[0,0,0,0],a=0,o=t.toc._items.length;a<o;a++){var s=t.toc._items[a],l=t.toc._items[a].tocStyle||n,u=t.toc._items[a].tocMargin||i;e.push([{text:s.text,alignment:\"left\",style:l,margin:u},{text:\"00000\",alignment:\"right\",_tocItemRef:s,style:r,margin:[0,u[1],0,u[3]]}])}return t.toc._table={table:{dontBreakRows:!0,widths:[\"*\",\"auto\"],body:e},layout:\"noBorders\"},t.toc._table=this.measureNode(t.toc._table),t},d.prototype.measureVerticalContainer=function(t){var e=t.stack;t._minWidth=0,t._maxWidth=0;for(var n=0,r=e.length;n<r;n++)e[n]=this.measureNode(e[n]),t._minWidth=Math.max(t._minWidth,e[n]._minWidth),t._maxWidth=Math.max(t._maxWidth,e[n]._maxWidth);return t},d.prototype.gapSizeForList=function(){return this.textTools.sizeOfString(\"9. \",this.styleStack)},d.prototype.buildUnorderedMarker=function(t,e,n){var r,i,a,o,s,l,u,c,h,f,d=t.getProperty(\"markerColor\")||t.getProperty(\"color\")||\"black\";switch(n){case\"circle\":h=d,r={canvas:[{x:f=(c=e).fontSize/6,y:c.height/c.lineHeight+c.descender-c.fontSize/3,r1:f,r2:f,type:\"ellipse\",lineColor:h}]};break;case\"square\":l=d,u=(s=e).fontSize/3,r={canvas:[{x:0,y:s.height/s.lineHeight+s.descender-s.fontSize/3-u/2,h:u,w:u,type:\"rect\",color:l}]};break;case\"none\":r={};break;case\"disc\":default:a=d,r={canvas:[{x:o=(i=e).fontSize/6,y:i.height/i.lineHeight+i.descender-i.fontSize/3,r1:o,r2:o,type:\"ellipse\",color:a}]}}return r._minWidth=r._maxWidth=e.width,r._minHeight=r._maxHeight=e.height,r},d.prototype.buildOrderedMarker=function(t,e,n,r){function i(t){return t<1?t.toString():function t(e){return(e>=26?t((e/26>>0)-1):\"\")+\"abcdefghijklmnopqrstuvwxyz\"[e%26>>0]}(t-1)}function a(t){if(t<1||t>4999)return t.toString();var e,n=t,r={M:1e3,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},i=\"\";for(e in r)for(;n>=r[e];)i+=e,n-=r[e];return i}var o;switch(n){case\"none\":o=null;break;case\"upper-alpha\":o=i(t).toUpperCase();break;case\"lower-alpha\":o=i(t);break;case\"upper-roman\":o=a(t);break;case\"lower-roman\":o=a(t).toLowerCase();break;case\"decimal\":default:o=t.toString()}if(null===o)return{};r&&(u(r)?(r[0]&&(o=r[0]+o),r[1]&&(o+=r[1]),o+=\" \"):o+=r+\" \");var s={text:o},l=e.getProperty(\"markerColor\");return l&&(s.color=l),{_inlines:this.textTools.buildInlines(s,e).items}},d.prototype.measureUnorderedList=function(t){var e=this.styleStack.clone(),n=t.ul;t.type=t.type||\"disc\",t._gapSize=this.gapSizeForList(),t._minWidth=0,t._maxWidth=0;for(var r=0,i=n.length;r<i;r++){var a=n[r]=this.measureNode(n[r]);a.ol||a.ul||(a.listMarker=this.buildUnorderedMarker(e,t._gapSize,a.listType||t.type)),t._minWidth=Math.max(t._minWidth,n[r]._minWidth+t._gapSize.width),t._maxWidth=Math.max(t._maxWidth,n[r]._maxWidth+t._gapSize.width)}return t},d.prototype.measureOrderedList=function(t){var e=this.styleStack.clone(),n=t.ol;t.type=t.type||\"decimal\",t.separator=t.separator||\".\",t.reversed=t.reversed||!1,t.start||(t.start=t.reversed?n.length:1),t._gapSize=this.gapSizeForList(),t._minWidth=0,t._maxWidth=0;for(var r=t.start,i=0,a=n.length;i<a;i++){(o=n[i]=this.measureNode(n[i])).ol||o.ul||(o.listMarker=this.buildOrderedMarker(o.counter||r,e,o.listType||t.type,t.separator),o.listMarker._inlines&&(t._gapSize.width=Math.max(t._gapSize.width,o.listMarker._inlines[0].width))),t._minWidth=Math.max(t._minWidth,n[i]._minWidth),t._maxWidth=Math.max(t._maxWidth,n[i]._maxWidth),t.reversed?r--:r++}t._minWidth+=t._gapSize.width,t._maxWidth+=t._gapSize.width;for(i=0,a=n.length;i<a;i++){var o;(o=n[i]).ol||o.ul||(o.listMarker._minWidth=o.listMarker._maxWidth=t._gapSize.width)}return t},d.prototype.measureColumns=function(t){var e=t.columns;t._gap=this.styleStack.getProperty(\"columnGap\")||0;for(var n=0,r=e.length;n<r;n++)e[n]=this.measureNode(e[n]);var i=a.measureMinMax(e),o=e.length>0?e.length-1:0;return t._minWidth=i.min+t._gap*o,t._maxWidth=i.max+t._gap*o,t},d.prototype.measureTable=function(t){!function(t){t.table.widths||(t.table.widths=\"auto\");if(o(t.table.widths))for(t.table.widths=[t.table.widths];t.table.widths.length<t.table.body[0].length;)t.table.widths.push(t.table.widths[t.table.widths.length-1]);for(var e=0,n=t.table.widths.length;e<n;e++){var r=t.table.widths[e];(s(r)||o(r))&&(t.table.widths[e]={width:r})}}(t),t._layout=function(e){var n=t.layout;o(n)&&(n=e[n]);return h({hLineWidth:function(t,e){return 1},vLineWidth:function(t,e){return 1},hLineColor:function(t,e){return\"black\"},vLineColor:function(t,e){return\"black\"},paddingLeft:function(t,e){return 4},paddingRight:function(t,e){return 4},paddingTop:function(t,e){return 2},paddingBottom:function(t,e){return 2},fillColor:function(t,e){return null},defaultBorder:!0},n)}(this.tableLayouts),t._offsets=function(e){for(var n=[],r=0,i=0,a=0,o=t.table.widths.length;a<o;a++){var s=i+e.vLineWidth(a,t)+e.paddingLeft(a,t);n.push(s),r+=s,i=e.paddingRight(a,t)}return{total:r+=i+e.vLineWidth(t.table.widths.length,t),offsets:n}}(t._layout);var e,n,r,i,u=[];for(e=0,r=t.table.body[0].length;e<r;e++){var c=t.table.widths[e];for(c._minWidth=0,c._maxWidth=0,n=0,i=t.table.body.length;n<i;n++){var f=t.table.body[n],d=f[e];if(void 0===d)throw\"Malformed table row, a cell is undefined.\";null===d&&(d=\"\"),d._span||((d=f[e]=this.styleStack.auto(d,g(this,d))).colSpan&&d.colSpan>1?(v(f,e,d.colSpan),u.push({col:e,span:d.colSpan,minWidth:d._minWidth,maxWidth:d._maxWidth})):(c._minWidth=Math.max(c._minWidth,d._minWidth),c._maxWidth=Math.max(c._maxWidth,d._maxWidth))),d.rowSpan&&d.rowSpan>1&&b(t.table,n,e,d.rowSpan)}}!function(){for(var e,n,r=0,i=u.length;r<i;r++){var a=u[r],o=y(a.col,a.span,t._offsets),s=a.minWidth-o.minWidth,l=a.maxWidth-o.maxWidth;if(s>0)for(e=s/a.span,n=0;n<a.span;n++)t.table.widths[a.col+n]._minWidth+=e;if(l>0)for(e=l/a.span,n=0;n<a.span;n++)t.table.widths[a.col+n]._maxWidth+=e}}();var p=a.measureMinMax(t.table.widths);return t._minWidth=p.min+t._offsets.total,t._maxWidth=p.max+t._offsets.total,t;function g(t,e){return function(){return l(e)&&(e.fillColor=t.styleStack.getProperty(\"fillColor\")),t.measureNode(e)}}function y(e,n,r){for(var i={minWidth:0,maxWidth:0},a=0;a<n;a++)i.minWidth+=t.table.widths[e+a]._minWidth+(a?r.offsets[e+a]:0),i.maxWidth+=t.table.widths[e+a]._maxWidth+(a?r.offsets[e+a]:0);return i}function v(t,e,n){for(var r=1;r<n;r++)t[e+r]={_span:!0,_minWidth:0,_maxWidth:0,rowSpan:t[e].rowSpan}}function b(t,e,n,r){for(var i=1;i<r;i++)t.body[e+i][n]={_span:!0,_minWidth:0,_maxWidth:0,fillColor:t.body[e][n].fillColor}}},d.prototype.measureCanvas=function(t){for(var e=0,n=0,r=0,i=t.canvas.length;r<i;r++){var a=t.canvas[r];switch(a.type){case\"ellipse\":e=Math.max(e,a.x+a.r1),n=Math.max(n,a.y+a.r2);break;case\"rect\":e=Math.max(e,a.x+a.w),n=Math.max(n,a.y+a.h);break;case\"line\":e=Math.max(e,a.x1,a.x2),n=Math.max(n,a.y1,a.y2);break;case\"polyline\":for(var o=0,s=a.points.length;o<s;o++)e=Math.max(e,a.points[o].x),n=Math.max(n,a.points[o].y)}}return t._minWidth=t._maxWidth=e,t._minHeight=t._maxHeight=n,t._alignment=this.styleStack.getProperty(\"alignment\"),t},d.prototype.measureQr=function(t){return(t=f.measure(t))._alignment=this.styleStack.getProperty(\"alignment\"),t},t.exports=d},function(t,e,n){var r=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\";!function(t){\"use strict\";var e=\"undefined\"!=typeof Uint8Array?Uint8Array:Array,n=\"+\".charCodeAt(0),i=\"/\".charCodeAt(0),a=\"0\".charCodeAt(0),o=\"a\".charCodeAt(0),s=\"A\".charCodeAt(0),l=\"-\".charCodeAt(0),u=\"_\".charCodeAt(0);function c(t){var e=t.charCodeAt(0);return e===n||e===l?62:e===i||e===u?63:e<a?-1:e<a+10?e-a+26+26:e<s+26?e-s:e<o+26?e-o+26:void 0}t.toByteArray=function(t){var n,r,i,a,o,s;if(t.length%4>0)throw new Error(\"Invalid string. Length must be a multiple of 4\");var l=t.length;o=\"=\"===t.charAt(l-2)?2:\"=\"===t.charAt(l-1)?1:0,s=new e(3*t.length/4-o),i=o>0?t.length-4:t.length;var u=0;function h(t){s[u++]=t}for(n=0,r=0;n<i;n+=4,r+=3)h((16711680&(a=c(t.charAt(n))<<18|c(t.charAt(n+1))<<12|c(t.charAt(n+2))<<6|c(t.charAt(n+3))))>>16),h((65280&a)>>8),h(255&a);return 2===o?h(255&(a=c(t.charAt(n))<<2|c(t.charAt(n+1))>>4)):1===o&&(h((a=c(t.charAt(n))<<10|c(t.charAt(n+1))<<4|c(t.charAt(n+2))>>2)>>8&255),h(255&a)),s},t.fromByteArray=function(t){var e,n,i,a,o=t.length%3,s=\"\";function l(t){return r.charAt(t)}for(e=0,i=t.length-o;e<i;e+=3)n=(t[e]<<16)+(t[e+1]<<8)+t[e+2],s+=l((a=n)>>18&63)+l(a>>12&63)+l(a>>6&63)+l(63&a);switch(o){case 1:s+=l((n=t[t.length-1])>>2),s+=l(n<<4&63),s+=\"==\";break;case 2:s+=l((n=(t[t.length-2]<<8)+t[t.length-1])>>10),s+=l(n>>4&63),s+=l(n<<2&63),s+=\"=\"}return s}}(e)},function(t,e){(function(){e.OP=0,e.CL=1,e.CP=2,e.QU=3,e.GL=4,e.NS=5,e.EX=6,e.SY=7,e.IS=8,e.PR=9,e.PO=10,e.NU=11,e.AL=12,e.HL=13,e.ID=14,e.IN=15,e.HY=16,e.BA=17,e.BB=18,e.B2=19,e.ZW=20,e.CM=21,e.WJ=22,e.H2=23,e.H3=24,e.JL=25,e.JV=26,e.JT=27,e.RI=28,e.AI=29,e.BK=30,e.CB=31,e.CJ=32,e.CR=33,e.LF=34,e.NL=35,e.SA=36,e.SG=37,e.SP=38,e.XX=39}).call(this)},function(t,e){(function(){e.DI_BRK=0,e.IN_BRK=1,e.CI_BRK=2,e.CP_BRK=3,e.PR_BRK=4,e.pairTable=[[4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,3,4,4,4,4,4,4,4],[0,4,4,1,1,4,4,4,4,1,1,0,0,0,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,1,4,4,4,4,1,1,1,1,1,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[4,4,4,1,1,1,4,4,4,1,1,1,1,1,1,1,1,1,1,1,4,2,4,1,1,1,1,1,1],[1,4,4,1,1,1,4,4,4,1,1,1,1,1,1,1,1,1,1,1,4,2,4,1,1,1,1,1,1],[0,4,4,1,1,1,4,4,4,0,0,0,0,0,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,1,1,4,4,4,0,0,0,0,0,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,1,1,4,4,4,0,0,1,0,0,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,1,1,4,4,4,0,0,1,1,1,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[1,4,4,1,1,1,4,4,4,0,0,1,1,1,1,0,1,1,0,0,4,2,4,1,1,1,1,1,0],[1,4,4,1,1,1,4,4,4,0,0,1,1,1,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[1,4,4,1,1,1,4,4,4,1,1,1,1,1,0,1,1,1,0,0,4,2,4,0,0,0,0,0,0],[1,4,4,1,1,1,4,4,4,0,0,1,1,1,0,1,1,1,0,0,4,2,4,0,0,0,0,0,0],[1,4,4,1,1,1,4,4,4,0,0,1,1,1,0,1,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,1,1,4,4,4,0,1,0,0,0,0,1,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,1,1,4,4,4,0,0,0,0,0,0,1,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,0,1,4,4,4,0,0,1,0,0,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[0,4,4,1,0,1,4,4,4,0,0,0,0,0,0,0,1,1,0,0,4,2,4,0,0,0,0,0,0],[1,4,4,1,1,1,4,4,4,1,1,1,1,1,1,1,1,1,1,1,4,2,4,1,1,1,1,1,1],[0,4,4,1,1,1,4,4,4,0,0,0,0,0,0,0,1,1,0,4,4,2,4,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0],[1,4,4,1,1,1,4,4,4,0,0,1,1,1,0,1,1,1,0,0,4,2,4,0,0,0,0,0,0],[1,4,4,1,1,1,4,4,4,1,1,1,1,1,1,1,1,1,1,1,4,2,4,1,1,1,1,1,1],[0,4,4,1,1,1,4,4,4,0,1,0,0,0,0,1,1,1,0,0,4,2,4,0,0,0,1,1,0],[0,4,4,1,1,1,4,4,4,0,1,0,0,0,0,1,1,1,0,0,4,2,4,0,0,0,0,1,0],[0,4,4,1,1,1,4,4,4,0,1,0,0,0,0,1,1,1,0,0,4,2,4,1,1,1,1,0,0],[0,4,4,1,1,1,4,4,4,0,1,0,0,0,0,1,1,1,0,0,4,2,4,0,0,0,1,1,0],[0,4,4,1,1,1,4,4,4,0,1,0,0,0,0,1,1,1,0,0,4,2,4,0,0,0,0,1,0],[0,4,4,1,1,1,4,4,4,0,0,0,0,0,0,0,1,1,0,0,4,2,4,0,0,0,0,0,1]]}).call(this)},function(t,e,n){\"use strict\";for(var r=[null,[[10,7,17,13],[1,1,1,1],[]],[[16,10,28,22],[1,1,1,1],[4,16]],[[26,15,22,18],[1,1,2,2],[4,20]],[[18,20,16,26],[2,1,4,2],[4,24]],[[24,26,22,18],[2,1,4,4],[4,28]],[[16,18,28,24],[4,2,4,4],[4,32]],[[18,20,26,18],[4,2,5,6],[4,20,36]],[[22,24,26,22],[4,2,6,6],[4,22,40]],[[22,30,24,20],[5,2,8,8],[4,24,44]],[[26,18,28,24],[5,4,8,8],[4,26,48]],[[30,20,24,28],[5,4,11,8],[4,28,52]],[[22,24,28,26],[8,4,11,10],[4,30,56]],[[22,26,22,24],[9,4,16,12],[4,32,60]],[[24,30,24,20],[9,4,16,16],[4,24,44,64]],[[24,22,24,30],[10,6,18,12],[4,24,46,68]],[[28,24,30,24],[10,6,16,17],[4,24,48,72]],[[28,28,28,28],[11,6,19,16],[4,28,52,76]],[[26,30,28,28],[13,6,21,18],[4,28,54,80]],[[26,28,26,26],[14,7,25,21],[4,28,56,84]],[[26,28,28,30],[16,8,25,20],[4,32,60,88]],[[26,28,30,28],[17,8,25,23],[4,26,48,70,92]],[[28,28,24,30],[17,9,34,23],[4,24,48,72,96]],[[28,30,30,30],[18,9,30,25],[4,28,52,76,100]],[[28,30,30,30],[20,10,32,27],[4,26,52,78,104]],[[28,26,30,30],[21,12,35,29],[4,30,56,82,108]],[[28,28,30,28],[23,12,37,34],[4,28,56,84,112]],[[28,30,30,30],[25,12,40,34],[4,32,60,88,116]],[[28,30,30,30],[26,13,42,35],[4,24,48,72,96,120]],[[28,30,30,30],[28,14,45,38],[4,28,52,76,100,124]],[[28,30,30,30],[29,15,48,40],[4,24,50,76,102,128]],[[28,30,30,30],[31,16,51,43],[4,28,54,80,106,132]],[[28,30,30,30],[33,17,54,45],[4,32,58,84,110,136]],[[28,30,30,30],[35,18,57,48],[4,28,56,84,112,140]],[[28,30,30,30],[37,19,60,51],[4,32,60,88,116,144]],[[28,30,30,30],[38,19,63,53],[4,28,52,76,100,124,148]],[[28,30,30,30],[40,20,66,56],[4,22,48,74,100,126,152]],[[28,30,30,30],[43,21,70,59],[4,26,52,78,104,130,156]],[[28,30,30,30],[45,22,74,62],[4,30,56,82,108,134,160]],[[28,30,30,30],[47,24,77,65],[4,24,52,80,108,136,164]],[[28,30,30,30],[49,25,81,68],[4,28,56,84,112,140,168]]],i=1,a=2,o=4,s=/^\\d*$/,l=/^[A-Za-z0-9 $%*+\\-./:]*$/,u=/^[A-Z0-9 $%*+\\-./:]*$/,c=1,h=0,f=3,d=2,p=[],g=[-1],y=0,v=1;y<255;++y)p.push(v),g[v]=y,v=2*v^(v>=128?285:0);var b=[[]];for(y=0;y<30;++y){for(var m=b[y],w=[],x=0;x<=y;++x){var S=x<y?p[m[x]]:0,_=p[(y+(m[x-1]||0))%255];w.push(g[S^_])}b.push(w)}var k={};for(y=0;y<45;++y)k[\"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:\".charAt(y)]=y;var C=[function(t,e){return(t+e)%2==0},function(t,e){return t%2==0},function(t,e){return e%3==0},function(t,e){return(t+e)%3==0},function(t,e){return((t/2|0)+(e/3|0))%2==0},function(t,e){return t*e%2+t*e%3==0},function(t,e){return(t*e%2+t*e%3)%2==0},function(t,e){return((t+e)%2+t*e%3)%2==0}],A=function(t){return t>6},P=function(t,e){var n,i,a,o=-8&(i=r[n=t],a=16*n*n+128*n+64,A(n)&&(a-=36),i[2].length&&(a-=25*i[2].length*i[2].length-10*i[2].length-55),a),s=r[t];return o-=8*s[0][e]*s[1][e]},E=function(t,e){switch(e){case i:return t<10?10:t<27?12:14;case a:return t<10?9:t<27?11:13;case o:return t<10?8:16;case 8:return t<10?8:t<27?10:12}},I=function(t,e,n){var r=P(t,n)-4-E(t,e);switch(e){case i:return 3*(r/10|0)+(r%10<4?0:r%10<7?1:2);case a:return 2*(r/11|0)+(r%11<6?0:1);case o:return r/8|0;case 8:return r/13|0}},T=function(t,e){switch(t){case i:return e.match(s)?e:null;case a:return e.match(l)?e.toUpperCase():null;case o:if(\"string\"==typeof e){for(var n=[],r=0;r<e.length;++r){var u=e.charCodeAt(r);u<128?n.push(u):u<2048?n.push(192|u>>6,128|63&u):u<65536?n.push(224|u>>12,128|u>>6&63,128|63&u):n.push(240|u>>18,128|u>>12&63,128|u>>6&63,128|63&u)}return n}return e}},O=function(t,e){for(var n=t.slice(0),r=t.length,i=e.length,a=0;a<i;++a)n.push(0);for(a=0;a<r;){var o=g[n[a++]];if(o>=0)for(var s=0;s<i;++s)n[a+s]^=p[(o+e[s])%255]}return n.slice(r)},L=function(t,e,n,r){for(var i=t<<r,a=e-1;a>=0;--a)i>>r+a&1&&(i^=n<<a);return t<<r|i},B=function(t,e,n){for(var r=C[n],i=t.length,a=0;a<i;++a)for(var o=0;o<i;++o)e[a][o]||(t[a][o]^=r(a,o));return t},M=function(t,e,n,r){for(var i=t.length,a=21522^L(n<<3|r,5,1335,10),o=0;o<15;++o){var s=[i-1,i-2,i-3,i-4,i-5,i-6,i-7,i-8,7,5,4,3,2,1,0][o];t[[0,1,2,3,4,5,7,8,i-7,i-6,i-5,i-4,i-3,i-2,i-1][o]][8]=t[8][s]=a>>o&1}return t},R=function(t){for(var e=function(t){for(var e=0,n=0;n<t.length;++n)t[n]>=5&&(e+=t[n]-5+3);for(n=5;n<t.length;n+=2){var r=t[n];t[n-1]==r&&t[n-2]==3*r&&t[n-3]==r&&t[n-4]==r&&(t[n-5]>=4*r||t[n+1]>=4*r)&&(e+=40)}return e},n=t.length,r=0,i=0,a=0;a<n;++a){var o,s=t[a];o=[0];for(var l=0;l<n;){for(u=0;l<n&&s[l];++u)++l;for(o.push(u),u=0;l<n&&!s[l];++u)++l;o.push(u)}r+=e(o),o=[0];for(l=0;l<n;){var u;for(u=0;l<n&&t[l][a];++u)++l;for(o.push(u),u=0;l<n&&!t[l][a];++u)++l;o.push(u)}r+=e(o);var c=t[a+1]||[];i+=s[0];for(l=1;l<n;++l){var h=s[l];i+=h,s[l-1]==h&&c[l]===h&&c[l-1]===h&&(r+=3)}}return r+=10*(Math.abs(i/n/n-.5)/.05|0)},F=function(t,e,n,s,l){var u=r[e],c=function(t,e,n,r){var s=[],l=0,u=8,c=n.length,h=function(t,e){if(e>=u){for(s.push(l|t>>(e-=u));e>=8;)s.push(t>>(e-=8)&255);l=0,u=8}e>0&&(l|=(t&(1<<e)-1)<<(u-=e))},f=E(t,e);switch(h(e,4),h(c,f),e){case i:for(var d=2;d<c;d+=3)h(parseInt(n.substring(d-2,d+1),10),10);h(parseInt(n.substring(d-2),10),[0,4,7][c%3]);break;case a:for(d=1;d<c;d+=2)h(45*k[n.charAt(d-1)]+k[n.charAt(d)],11);c%2==1&&h(k[n.charAt(d-1)],6);break;case o:for(d=0;d<c;++d)h(n[d],8)}for(h(0,4),u<8&&s.push(l);s.length+1<r;)s.push(236,17);return s.length<r&&s.push(236),s}(e,n,t,P(e,s)>>3);c=function(t,e,n){for(var r=[],i=t.length/e|0,a=0,o=e-t.length%e,s=0;s<o;++s)r.push(a),a+=i;for(s=o;s<e;++s)r.push(a),a+=i+1;r.push(a);var l=[];for(s=0;s<e;++s)l.push(O(t.slice(r[s],r[s+1]),n));var u=[],c=t.length/e|0;for(s=0;s<c;++s)for(var h=0;h<e;++h)u.push(t[r[h]+s]);for(h=o;h<e;++h)u.push(t[r[h+1]-1]);for(s=0;s<n.length;++s)for(h=0;h<e;++h)u.push(l[h][s]);return u}(c,u[1][s],b[u[0][s]]);var h=function(t){for(var e=r[t],n=4*t+17,i=[],a=[],o=0;o<n;++o)i.push([]),a.push([]);var s=function(t,e,n,r,o){for(var s=0;s<n;++s)for(var l=0;l<r;++l)i[t+s][e+l]=o[s]>>l&1,a[t+s][e+l]=1};s(0,0,9,9,[127,65,93,93,93,65,383,0,64]),s(n-8,0,8,9,[256,127,65,93,93,93,65,127]),s(0,n-8,9,8,[254,130,186,186,186,130,254,0,0]);for(o=9;o<n-8;++o)i[6][o]=i[o][6]=1&~o,a[6][o]=a[o][6]=1;var l=e[2],u=l.length;for(o=0;o<u;++o)for(var c=0===o?u-1:u,h=0===o||o===u-1?1:0;h<c;++h)s(l[o],l[h],5,5,[31,17,21,17,31]);if(A(t)){var f=L(t,6,7973,12),d=0;for(o=0;o<6;++o)for(h=0;h<3;++h)i[o][n-11+h]=i[n-11+h][o]=f>>d++&1,a[o][n-11+h]=a[n-11+h][o]=1}return{matrix:i,reserved:a}}(e),f=h.matrix,d=h.reserved;if(function(t,e,n){for(var r=t.length,i=0,a=-1,o=r-1;o>=0;o-=2){6==o&&--o;for(var s=a<0?r-1:0,l=0;l<r;++l){for(var u=o;u>o-2;--u)e[s][u]||(t[s][u]=n[i>>3]>>(7&~i)&1,++i);s+=a}a=-a}}(f,d,c),l<0){B(f,d,0),M(f,0,s,0);var p=0,g=R(f);for(B(f,d,0),l=1;l<8;++l){B(f,d,l),M(f,0,s,l);var y=R(f);g>y&&(g=y,p=l),B(f,d,l)}l=p}return B(f,d,l),M(f,0,s,l),f};function D(t,e){var n=[],r=e.background||\"#fff\",l=e.foreground||\"#000\",p=function(t,e){var n={numeric:i,alphanumeric:a,octet:o},r={L:c,M:h,Q:f,H:d},l=(e=e||{}).version||-1,p=r[(e.eccLevel||\"L\").toUpperCase()],g=e.mode?n[e.mode.toLowerCase()]:-1,y=\"mask\"in e?e.mask:-1;if(g<0)g=\"string\"==typeof t?t.match(s)?i:t.match(u)?a:o:o;else if(g!=i&&g!=a&&g!=o)throw\"invalid or unsupported mode\";if(null===(t=T(g,t)))throw\"invalid data format\";if(p<0||p>3)throw\"invalid ECC level\";if(l<0){for(l=1;l<=40&&!(t.length<=I(l,g,p));++l);if(l>40)throw\"too large data for the Qr format\"}else if(l<1||l>40)throw\"invalid Qr version! should be between 1 and 40\";if(-1!=y&&(y<0||y>8))throw\"invalid mask\";return F(t,l,g,p,y)}(t,e),g=p.length,y=Math.floor(e.fit?e.fit/g:5),v=g*y;n.push({type:\"rect\",x:0,y:0,w:v,h:v,lineWidth:0,color:r});for(var b=0;b<g;++b)for(var m=0;m<g;++m)p[b][m]&&n.push({type:\"rect\",x:y*m,y:y*b,w:y,h:y,lineWidth:0,color:l});return{canvas:n,size:v}}t.exports={measure:function(t){var e=D(t.qr,t);return t._canvas=e.canvas,t._width=t._height=t._minWidth=t._maxWidth=t._minHeight=t._maxHeight=e.size,t}}},function(t,e,n){\"use strict\";var r=n(136);function i(t,e){this.transactionLevel=0,this.repeatables=[],this.tracker=e,this.writer=new r(t,e)}function a(t,e){var n=e(t);return n||(t.moveToNextPage(),n=e(t)),n}i.prototype.addLine=function(t,e,n){return a(this,function(r){return r.writer.addLine(t,e,n)})},i.prototype.addImage=function(t,e){return a(this,function(n){return n.writer.addImage(t,e)})},i.prototype.addQr=function(t,e){return a(this,function(n){return n.writer.addQr(t,e)})},i.prototype.addVector=function(t,e,n,r){return this.writer.addVector(t,e,n,r)},i.prototype.beginClip=function(t,e){return this.writer.beginClip(t,e)},i.prototype.endClip=function(){return this.writer.endClip()},i.prototype.alignCanvas=function(t){this.writer.alignCanvas(t)},i.prototype.addFragment=function(t,e,n,r){this.writer.addFragment(t,e,n,r)||(this.moveToNextPage(),this.writer.addFragment(t,e,n,r))},i.prototype.moveToNextPage=function(t){var e=this.writer.context.moveToNextPage(t);e.newPageCreated?this.repeatables.forEach(function(t){this.writer.addFragment(t,!0)},this):this.repeatables.forEach(function(t){this.writer.context.moveDown(t.height)},this),this.writer.tracker.emit(\"pageChanged\",{prevPage:e.prevPage,prevY:e.prevY,y:e.y})},i.prototype.beginUnbreakableBlock=function(t,e){0==this.transactionLevel++&&(this.originalX=this.writer.context.x,this.writer.pushContext(t,e))},i.prototype.commitUnbreakableBlock=function(t,e){if(0==--this.transactionLevel){var n=this.writer.context;this.writer.popContext();var r=n.pages.length;if(r>0){var i=n.pages[0];if(i.xOffset=t,i.yOffset=e,r>1)if(void 0!==t||void 0!==e)i.height=n.getCurrentPage().pageSize.height-n.pageMargins.top-n.pageMargins.bottom;else{i.height=this.writer.context.getCurrentPage().pageSize.height-this.writer.context.pageMargins.top-this.writer.context.pageMargins.bottom;for(var a=0,o=this.repeatables.length;a<o;a++)i.height-=this.repeatables[a].height}else i.height=n.y;void 0!==t||void 0!==e?this.writer.addFragment(i,!0,!0,!0):this.addFragment(i)}}},i.prototype.currentBlockToRepeatable=function(){var t=this.writer.context,e={items:[]};return t.pages[0].items.forEach(function(t){e.items.push(t)}),e.xOffset=this.originalX,e.height=t.y,e},i.prototype.pushToRepeatables=function(t){this.repeatables.push(t)},i.prototype.popFromRepeatables=function(){this.repeatables.pop()},i.prototype.context=function(){return this.writer.context},t.exports=i},function(t,e,n){\"use strict\";var r=n(82),i=n(0).isNumber,a=n(0).pack,o=n(0).offsetVector,s=n(81);function l(t,e){this.context=t,this.contextStack=[],this.tracker=e}function u(t,e,n){null==n||n<0||n>t.items.length?t.items.push(e):t.items.splice(n,0,e)}l.prototype.addLine=function(t,e,n){var r=t.getHeight(),i=this.context,a=i.getCurrentPage(),o=this.getCurrentPositionOnPage();return!(i.availableHeight<r||!a)&&(t.x=i.x+(t.x||0),t.y=i.y+(t.y||0),this.alignLine(t),u(a,{type:\"line\",item:t},n),this.tracker.emit(\"lineAdded\",t),e||i.moveDown(r),o)},l.prototype.alignLine=function(t){var e=this.context.availableWidth,n=t.getWidth(),r=t.inlines&&t.inlines.length>0&&t.inlines[0].alignment,i=0;switch(r){case\"right\":i=e-n;break;case\"center\":i=(e-n)/2}if(i&&(t.x=(t.x||0)+i),\"justify\"===r&&!t.newLineForced&&!t.lastLineInParagraph&&t.inlines.length>1)for(var a=(e-n)/(t.inlines.length-1),o=1,s=t.inlines.length;o<s;o++)i=o*a,t.inlines[o].x+=i,t.inlines[o].justifyShift=a},l.prototype.addImage=function(t,e){var n=this.context,r=n.getCurrentPage(),i=this.getCurrentPositionOnPage();return!(!r||void 0===t.absolutePosition&&n.availableHeight<t._height&&r.items.length>0)&&(void 0===t._x&&(t._x=t.x||0),t.x=n.x+t._x,t.y=n.y,this.alignImage(t),u(r,{type:\"image\",item:t},e),n.moveDown(t._height),i)},l.prototype.addQr=function(t,e){var n=this.context,r=n.getCurrentPage(),i=this.getCurrentPositionOnPage();if(!r||void 0===t.absolutePosition&&n.availableHeight<t._height)return!1;void 0===t._x&&(t._x=t.x||0),t.x=n.x+t._x,t.y=n.y,this.alignImage(t);for(var a=0,o=t._canvas.length;a<o;a++){var s=t._canvas[a];s.x+=t.x,s.y+=t.y,this.addVector(s,!0,!0,e)}return n.moveDown(t._height),i},l.prototype.alignImage=function(t){var e=this.context.availableWidth,n=t._minWidth,r=0;switch(t._alignment){case\"right\":r=e-n;break;case\"center\":r=(e-n)/2}r&&(t.x=(t.x||0)+r)},l.prototype.alignCanvas=function(t){var e=this.context.availableWidth,n=t._minWidth,r=0;switch(t._alignment){case\"right\":r=e-n;break;case\"center\":r=(e-n)/2}r&&t.canvas.forEach(function(t){o(t,r,0)})},l.prototype.addVector=function(t,e,n,r){var i=this.context,a=i.getCurrentPage(),s=this.getCurrentPositionOnPage();if(a)return o(t,e?0:i.x,n?0:i.y),u(a,{type:\"vector\",item:t},r),s},l.prototype.beginClip=function(t,e){var n=this.context;return n.getCurrentPage().items.push({type:\"beginClip\",item:{x:n.x,y:n.y,width:t,height:e}}),!0},l.prototype.endClip=function(){return this.context.getCurrentPage().items.push({type:\"endClip\"}),!0},l.prototype.addFragment=function(t,e,n,i){var s=this.context,l=s.getCurrentPage();return!(!e&&t.height>s.availableHeight)&&(t.items.forEach(function(i){switch(i.type){case\"line\":var u=function(t){var e=new r(t.maxWidth);for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}(i.item);u.x=(u.x||0)+(e?t.xOffset||0:s.x),u.y=(u.y||0)+(n?t.yOffset||0:s.y),l.items.push({type:\"line\",item:u});break;case\"vector\":var c=a(i.item);o(c,e?t.xOffset||0:s.x,n?t.yOffset||0:s.y),l.items.push({type:\"vector\",item:c});break;case\"image\":var h=a(i.item);h.x=(h.x||0)+(e?t.xOffset||0:s.x),h.y=(h.y||0)+(n?t.yOffset||0:s.y),l.items.push({type:\"image\",item:h})}}),i||s.moveDown(t.height),!0)},l.prototype.pushContext=function(t,e){void 0===t&&(e=this.context.getCurrentPage().height-this.context.pageMargins.top-this.context.pageMargins.bottom,t=this.context.availableWidth),i(t)&&(t=new s({width:t,height:e},{left:0,right:0,top:0,bottom:0})),this.contextStack.push(this.context),this.context=t},l.prototype.popContext=function(){this.context=this.contextStack.pop()},l.prototype.getCurrentPositionOnPage=function(){return(this.contextStack[0]||this.context).getCurrentPosition()},t.exports=l},function(t,e,n){\"use strict\";var r=n(44),i=n(0).isFunction;function a(t){this.tableNode=t}a.prototype.beginTable=function(t){var e,n,i,a=this;e=this.tableNode,this.offsets=e._offsets,this.layout=e._layout,n=t.context().availableWidth-this.offsets.total,r.buildColumnWidths(e.table.widths,n),this.tableWidth=e._offsets.total+(i=0,e.table.widths.forEach(function(t){i+=t._calcWidth}),i),this.rowSpanData=function(){var t=[],e=0,n=0;t.push({left:0,rowSpan:0});for(var r=0,i=a.tableNode.table.body[0].length;r<i;r++){var o=a.layout.paddingLeft(r,a.tableNode)+a.layout.paddingRight(r,a.tableNode),s=a.layout.vLineWidth(r,a.tableNode);n=o+s+a.tableNode.table.widths[r]._calcWidth,t[t.length-1].width=n,e+=n,t.push({left:e,rowSpan:0,width:0})}return t}(),this.cleanUpRepeatables=!1,this.headerRows=e.table.headerRows||0,this.rowsWithoutPageBreak=this.headerRows+(e.table.keepWithHeaderRows||0),this.dontBreakRows=e.table.dontBreakRows||!1,this.rowsWithoutPageBreak&&t.beginUnbreakableBlock(),function(t){for(var e=0;e<t.length;e++)for(var n=t[e],r=0;r<n.length;r++){var i=n[r];if(i.border){for(var a=i.rowSpan||1,o=i.colSpan||1,s=0;s<a;s++)void 0!==i.border[0]&&s>0&&u(e+s,r,0,i.border[0]),void 0!==i.border[2]&&u(e+s,r+o-1,2,i.border[2]);for(var l=0;l<o;l++)void 0!==i.border[1]&&l>0&&u(e,r+l,1,i.border[1]),void 0!==i.border[3]&&u(e+a-1,r+l,3,i.border[3])}}function u(e,n,r,i){var a=t[e][n];a.border=a.border||{},a.border[r]=i}}(this.tableNode.table.body),this.drawHorizontalLine(0,t)},a.prototype.onRowBreak=function(t,e){var n=this;return function(){var t=n.rowPaddingTop+(n.headerRows?0:n.topLineWidth);e.context().availableHeight-=n.reservedAtBottom,e.context().moveDown(t)}},a.prototype.beginRow=function(t,e){this.topLineWidth=this.layout.hLineWidth(t,this.tableNode),this.rowPaddingTop=this.layout.paddingTop(t,this.tableNode),this.bottomLineWidth=this.layout.hLineWidth(t+1,this.tableNode),this.rowPaddingBottom=this.layout.paddingBottom(t,this.tableNode),this.rowCallback=this.onRowBreak(t,e),e.tracker.startTracking(\"pageChanged\",this.rowCallback),this.dontBreakRows&&e.beginUnbreakableBlock(),this.rowTopY=e.context().y,this.reservedAtBottom=this.bottomLineWidth+this.rowPaddingBottom,e.context().availableHeight-=this.reservedAtBottom,e.context().moveDown(this.rowPaddingTop)},a.prototype.drawHorizontalLine=function(t,e,n){var r=this.layout.hLineWidth(t,this.tableNode);if(r){for(var a=r/2,o=null,s=this.tableNode.table.body,l=0,u=this.rowSpanData.length;l<u;l++){var c=this.rowSpanData[l],h=!c.rowSpan;if(h&&l<u-1){var f=!1,d=!1;if(t<s.length){var p=s[t][l];f=p.border?p.border[1]:this.layout.defaultBorder}if(t>0){var g=s[t-1][l];d=g.border?g.border[3]:this.layout.defaultBorder}h=f||d}!o&&h&&(o={left:c.left,width:0}),h&&(o.width+=c.width||0);var y=(n||0)+a;h&&l!==u-1||o&&o.width&&(e.addVector({type:\"line\",x1:o.left,x2:o.left+o.width,y1:y,y2:y,lineWidth:r,lineColor:i(this.layout.hLineColor)?this.layout.hLineColor(t,this.tableNode):this.layout.hLineColor},!1,n),o=null)}e.context().moveDown(r)}},a.prototype.drawVerticalLine=function(t,e,n,r,a){var o=this.layout.vLineWidth(r,this.tableNode);0!==o&&a.addVector({type:\"line\",x1:t+o/2,x2:t+o/2,y1:e,y2:n,lineWidth:o,lineColor:i(this.layout.vLineColor)?this.layout.vLineColor(r,this.tableNode):this.layout.vLineColor},!1,!0)},a.prototype.endTable=function(t){this.cleanUpRepeatables&&(t.popFromRepeatables(),this.headerRepeatableHeight=null)},a.prototype.endRow=function(t,e,n){var r,a,o=this;e.tracker.stopTracking(\"pageChanged\",this.rowCallback),e.context().moveDown(this.layout.paddingBottom(t,this.tableNode)),e.context().availableHeight+=this.reservedAtBottom;var s=e.context().page,l=e.context().y,u=function(){for(var e=[],n=0,r=0,i=o.tableNode.table.body[t].length;r<i;r++){if(!n){e.push({x:o.rowSpanData[r].left,index:r});var a=o.tableNode.table.body[t][r];n=a._colSpan||a.colSpan||0}n>0&&n--}return e.push({x:o.rowSpanData[o.rowSpanData.length-1].left,index:o.rowSpanData.length-1}),e}(),c=[],h=n&&n.length>0,f=this.tableNode.table.body;if(c.push({y0:this.rowTopY,page:h?n[0].prevPage:s}),h)for(a=0,r=n.length;a<r;a++){var d=n[a];c[c.length-1].y1=d.prevY,c.push({y0:d.y,page:d.prevPage+1}),this.headerRepeatableHeight&&(c[c.length-1].y0+=this.headerRepeatableHeight)}c[c.length-1].y1=l;for(var p=c[0].y1-c[0].y0===this.rowPaddingTop?1:0,g=c.length;p<g;p++){var y=p<c.length-1,v=p>0&&!this.headerRows,b=v?0:this.topLineWidth,m=c[p].y0,w=c[p].y1;for(y&&(w+=this.rowPaddingBottom),e.context().page!=c[p].page&&(e.context().page=c[p].page,this.reservedAtBottom=0),a=0,r=u.length;a<r;a++){var x,S=!1,_=!1,k=u[a].index;if(k<f[t].length)S=(x=f[t][k]).border?x.border[0]:this.layout.defaultBorder;if(k>0)_=(x=f[t][k-1]).border?x.border[2]:this.layout.defaultBorder;if((S||_)&&this.drawVerticalLine(u[a].x,m-b,w+this.bottomLineWidth,u[a].index,e),a<r-1){var C=f[t][k].fillColor;if(C||(C=i(this.layout.fillColor)?this.layout.fillColor(t,this.tableNode,k):this.layout.fillColor),C){var A=S||_?this.layout.vLineWidth(k,this.tableNode):0,P=u[a].x+A,E=this.dontBreakRows?m:m-b;e.addVector({type:\"rect\",x:P,y:E,w:u[a+1].x-P,h:w+this.bottomLineWidth-E,lineWidth:0,color:C},!1,!0,e.context().hasBackground?1:0)}}}y&&!1!==this.layout.hLineWhenBroken&&this.drawHorizontalLine(t+1,e,w),v&&!1!==this.layout.hLineWhenBroken&&this.drawHorizontalLine(t,e,m)}e.context().page=s,e.context().y=l;var I=this.tableNode.table.body[t];for(a=0,r=I.length;a<r;a++){if(I[a].rowSpan&&(this.rowSpanData[a].rowSpan=I[a].rowSpan,I[a].colSpan&&I[a].colSpan>1))for(var T=1;T<I[a].rowSpan;T++)this.tableNode.table.body[t+T][a]._colSpan=I[a].colSpan;this.rowSpanData[a].rowSpan>0&&this.rowSpanData[a].rowSpan--}this.drawHorizontalLine(t+1,e),this.headerRows&&t===this.headerRows-1&&(this.headerRepeatable=e.currentBlockToRepeatable()),this.dontBreakRows&&e.tracker.auto(\"pageChanged\",function(){o.headerRows||!1===o.layout.hLineWhenBroken||o.drawHorizontalLine(t,e)},function(){e.commitUnbreakableBlock()}),!this.headerRepeatable||t!==this.rowsWithoutPageBreak-1&&t!==this.tableNode.table.body.length-1||(this.headerRepeatableHeight=this.headerRepeatable.height,e.commitUnbreakableBlock(),e.pushToRepeatables(this.headerRepeatable),this.cleanUpRepeatables=!0,this.headerRepeatable=null)},t.exports=a},function(t,e,n){(function(e){(function(){var r,i,a,o,s,l,u={}.hasOwnProperty;l=n(15),s=n(8),i=n(26),o=n(87),a=n(161),r=function(t){var r;function c(t){var e,n,r,i;if(this.options=null!=t?t:{},c.__super__.constructor.apply(this,arguments),this.version=1.3,this.compress=null==(n=this.options.compress)||n,this._pageBuffer=[],this._pageBufferStart=0,this._offsets=[],this._waiting=0,this._ended=!1,this._offset=0,this._root=this.ref({Type:\"Catalog\",Pages:this.ref({Type:\"Pages\",Count:0,Kids:[]})}),this.page=null,this.initColor(),this.initVector(),this.initFonts(),this.initText(),this.initImages(),this.info={Producer:\"PDFKit\",Creator:\"PDFKit\",CreationDate:new Date},this.options.info)for(e in r=this.options.info)i=r[e],this.info[e]=i;this._write(\"%PDF-\"+this.version),this._write(\"%ÿÿÿÿ\"),!1!==this.options.autoFirstPage&&this.addPage()}return function(t,e){for(var n in e)u.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(c,l.Readable),(r=function(t){var e,n,r;for(n in r=[],t)e=t[n],r.push(c.prototype[n]=e);return r})(n(162)),r(n(164)),r(n(166)),r(n(295)),r(n(297)),r(n(302)),c.prototype.addPage=function(t){var e;return null==t&&(t=this.options),this.options.bufferPages||this.flushPages(),this.page=new a(this,t),this._pageBuffer.push(this.page),(e=this._root.data.Pages.data).Kids.push(this.page.dictionary),e.Count++,this.x=this.page.margins.left,this.y=this.page.margins.top,this._ctm=[1,0,0,1,0,0],this.transform(1,0,0,-1,0,this.page.height),this.emit(\"pageAdded\"),this},c.prototype.bufferedPageRange=function(){return{start:this._pageBufferStart,count:this._pageBuffer.length}},c.prototype.switchToPage=function(t){var e;if(!(e=this._pageBuffer[t-this._pageBufferStart]))throw new Error(\"switchToPage(\"+t+\") out of bounds, current buffer covers pages \"+this._pageBufferStart+\" to \"+(this._pageBufferStart+this._pageBuffer.length-1));return this.page=e},c.prototype.flushPages=function(){var t,e,n;for(n=this._pageBuffer,this._pageBuffer=[],this._pageBufferStart+=n.length,t=0,e=n.length;t<e;t++)n[t].end()},c.prototype.ref=function(t){var e;return e=new o(this,this._offsets.length+1,t),this._offsets.push(null),this._waiting++,e},c.prototype._read=function(){},c.prototype._write=function(t){return e.isBuffer(t)||(t=new e(t+\"\\n\",\"binary\")),this.push(t),this._offset+=t.length},c.prototype.addContent=function(t){return this.page.write(t),this},c.prototype._refEnd=function(t){if(this._offsets[t.id-1]=t.offset,0==--this._waiting&&this._ended)return this._finalize(),this._ended=!1},c.prototype.write=function(t,e){return new Error(\"PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. Please pipe the document into a Node stream.\"),this.pipe(s.createWriteStream(t)),this.end(),this.once(\"end\",e)},c.prototype.output=function(t){throw new Error(\"PDFDocument#output is deprecated, and has been removed from PDFKit. Please pipe the document into a Node stream.\")},c.prototype.end=function(){var t,e,n,r,i;for(t in this.flushPages(),this._info=this.ref(),n=this.info)\"string\"==typeof(i=n[t])&&(i=new String(i)),this._info.data[t]=i;for(e in this._info.end(),r=this._fontFamilies)r[e].finalize();return this._root.end(),this._root.data.Pages.end(),0===this._waiting?this._finalize():this._ended=!0},c.prototype._finalize=function(t){var e,n,r,a,o;for(o=this._offset,this._write(\"xref\"),this._write(\"0 \"+(this._offsets.length+1)),this._write(\"0000000000 65535 f \"),e=0,n=(a=this._offsets).length;e<n;e++)r=(\"0000000000\"+(r=a[e])).slice(-10),this._write(r+\" 00000 n \");return this._write(\"trailer\"),this._write(i.convert({Size:this._offsets.length+1,Root:this._root,Info:this._info})),this._write(\"startxref\"),this._write(\"\"+o),this._write(\"%%EOF\"),this.push(null)},c.prototype.toString=function(){return\"[object PDFDocument]\"},c}(),t.exports=r}).call(this)}).call(e,n(1).Buffer)},function(t,e){},function(t,e,n){\"use strict\";var r=n(33).Buffer,i=n(141);t.exports=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}(this,t),this.head=null,this.tail=null,this.length=0}return t.prototype.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},t.prototype.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},t.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},t.prototype.clear=function(){this.head=this.tail=null,this.length=0},t.prototype.join=function(t){if(0===this.length)return\"\";for(var e=this.head,n=\"\"+e.data;e=e.next;)n+=t+e.data;return n},t.prototype.concat=function(t){if(0===this.length)return r.alloc(0);if(1===this.length)return this.head.data;for(var e,n,i,a=r.allocUnsafe(t>>>0),o=this.head,s=0;o;)e=o.data,n=a,i=s,e.copy(n,i),s+=o.data.length,o=o.next;return a},t}(),i&&i.inspect&&i.inspect.custom&&(t.exports.prototype[i.inspect.custom]=function(){var t=i.inspect({length:this.length});return this.constructor.name+\" \"+t})},function(t,e){},function(t,e,n){(function(t){var r=Function.prototype.apply;function i(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new i(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new i(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},i.prototype.unref=i.prototype.ref=function(){},i.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(143),e.setImmediate=\"undefined\"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate=\"undefined\"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(e,n(7))},function(t,e,n){(function(t,e){!function(t,n){\"use strict\";if(!t.setImmediate){var r,i,a,o,s,l=1,u={},c=!1,h=t.document,f=Object.getPrototypeOf&&Object.getPrototypeOf(t);f=f&&f.setTimeout?f:t,\"[object process]\"==={}.toString.call(t.process)?r=function(t){e.nextTick(function(){p(t)})}:!function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage(\"\",\"*\"),t.onmessage=n,e}}()?t.MessageChannel?((a=new MessageChannel).port1.onmessage=function(t){p(t.data)},r=function(t){a.port2.postMessage(t)}):h&&\"onreadystatechange\"in h.createElement(\"script\")?(i=h.documentElement,r=function(t){var e=h.createElement(\"script\");e.onreadystatechange=function(){p(t),e.onreadystatechange=null,i.removeChild(e),e=null},i.appendChild(e)}):r=function(t){setTimeout(p,0,t)}:(o=\"setImmediate$\"+Math.random()+\"$\",s=function(e){e.source===t&&\"string\"==typeof e.data&&0===e.data.indexOf(o)&&p(+e.data.slice(o.length))},t.addEventListener?t.addEventListener(\"message\",s,!1):t.attachEvent(\"onmessage\",s),r=function(e){t.postMessage(o+e,\"*\")}),f.setImmediate=function(t){\"function\"!=typeof t&&(t=new Function(\"\"+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var i={callback:t,args:e};return u[l]=i,r(l),l++},f.clearImmediate=d}function d(t){delete u[t]}function p(t){if(c)setTimeout(p,0,t);else{var e=u[t];if(e){c=!0;try{!function(t){var e=t.callback,r=t.args;switch(r.length){case 0:e();break;case 1:e(r[0]);break;case 2:e(r[0],r[1]);break;case 3:e(r[0],r[1],r[2]);break;default:e.apply(n,r)}}(e)}finally{d(t),c=!1}}}}}(\"undefined\"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(11))},function(t,e,n){(function(e){function n(t){try{if(!e.localStorage)return!1}catch(t){return!1}var n=e.localStorage[t];return null!=n&&\"true\"===String(n).toLowerCase()}t.exports=function(t,e){if(n(\"noDeprecation\"))return t;var r=!1;return function(){if(!r){if(n(\"throwDeprecation\"))throw new Error(e);n(\"traceDeprecation\"),r=!0}return t.apply(this,arguments)}}}).call(e,n(7))},function(t,e,n){\"use strict\";t.exports=a;var r=n(86),i=n(25);function a(t){if(!(this instanceof a))return new a(t);r.call(this,t)}i.inherits=n(21),i.inherits(a,r),a.prototype._transform=function(t,e,n){n(null,t)}},function(t,e,n){t.exports=n(46)},function(t,e,n){t.exports=n(16)},function(t,e,n){t.exports=n(45).Transform},function(t,e,n){t.exports=n(45).PassThrough},function(t,e,n){\"use strict\";(function(t,r){var i=n(88),a=n(153),o=n(154),s=n(157),l=n(160);for(var u in l)e[u]=l[u];e.NONE=0,e.DEFLATE=1,e.INFLATE=2,e.GZIP=3,e.GUNZIP=4,e.DEFLATERAW=5,e.INFLATERAW=6,e.UNZIP=7;function c(t){if(\"number\"!=typeof t||t<e.DEFLATE||t>e.UNZIP)throw new TypeError(\"Bad argument\");this.dictionary=null,this.err=0,this.flush=0,this.init_done=!1,this.level=0,this.memLevel=0,this.mode=t,this.strategy=0,this.windowBits=0,this.write_in_progress=!1,this.pending_close=!1,this.gzip_id_bytes_read=0}c.prototype.close=function(){this.write_in_progress?this.pending_close=!0:(this.pending_close=!1,i(this.init_done,\"close before init\"),i(this.mode<=e.UNZIP),this.mode===e.DEFLATE||this.mode===e.GZIP||this.mode===e.DEFLATERAW?o.deflateEnd(this.strm):this.mode!==e.INFLATE&&this.mode!==e.GUNZIP&&this.mode!==e.INFLATERAW&&this.mode!==e.UNZIP||s.inflateEnd(this.strm),this.mode=e.NONE,this.dictionary=null)},c.prototype.write=function(t,e,n,r,i,a,o){return this._write(!0,t,e,n,r,i,a,o)},c.prototype.writeSync=function(t,e,n,r,i,a,o){return this._write(!1,t,e,n,r,i,a,o)},c.prototype._write=function(n,a,o,s,l,u,c,h){if(i.equal(arguments.length,8),i(this.init_done,\"write before init\"),i(this.mode!==e.NONE,\"already finalized\"),i.equal(!1,this.write_in_progress,\"write already in progress\"),i.equal(!1,this.pending_close,\"close is pending\"),this.write_in_progress=!0,i.equal(!1,void 0===a,\"must provide flush value\"),this.write_in_progress=!0,a!==e.Z_NO_FLUSH&&a!==e.Z_PARTIAL_FLUSH&&a!==e.Z_SYNC_FLUSH&&a!==e.Z_FULL_FLUSH&&a!==e.Z_FINISH&&a!==e.Z_BLOCK)throw new Error(\"Invalid flush value\");if(null==o&&(o=t.alloc(0),l=0,s=0),this.strm.avail_in=l,this.strm.input=o,this.strm.next_in=s,this.strm.avail_out=h,this.strm.output=u,this.strm.next_out=c,this.flush=a,!n)return this._process(),this._checkError()?this._afterSync():void 0;var f=this;return r.nextTick(function(){f._process(),f._after()}),this},c.prototype._afterSync=function(){var t=this.strm.avail_out,e=this.strm.avail_in;return this.write_in_progress=!1,[e,t]},c.prototype._process=function(){var t=null;switch(this.mode){case e.DEFLATE:case e.GZIP:case e.DEFLATERAW:this.err=o.deflate(this.strm,this.flush);break;case e.UNZIP:switch(this.strm.avail_in>0&&(t=this.strm.next_in),this.gzip_id_bytes_read){case 0:if(null===t)break;if(31!==this.strm.input[t]){this.mode=e.INFLATE;break}if(this.gzip_id_bytes_read=1,t++,1===this.strm.avail_in)break;case 1:if(null===t)break;139===this.strm.input[t]?(this.gzip_id_bytes_read=2,this.mode=e.GUNZIP):this.mode=e.INFLATE;break;default:throw new Error(\"invalid number of gzip magic number bytes read\")}case e.INFLATE:case e.GUNZIP:case e.INFLATERAW:for(this.err=s.inflate(this.strm,this.flush),this.err===e.Z_NEED_DICT&&this.dictionary&&(this.err=s.inflateSetDictionary(this.strm,this.dictionary),this.err===e.Z_OK?this.err=s.inflate(this.strm,this.flush):this.err===e.Z_DATA_ERROR&&(this.err=e.Z_NEED_DICT));this.strm.avail_in>0&&this.mode===e.GUNZIP&&this.err===e.Z_STREAM_END&&0!==this.strm.next_in[0];)this.reset(),this.err=s.inflate(this.strm,this.flush);break;default:throw new Error(\"Unknown mode \"+this.mode)}},c.prototype._checkError=function(){switch(this.err){case e.Z_OK:case e.Z_BUF_ERROR:if(0!==this.strm.avail_out&&this.flush===e.Z_FINISH)return this._error(\"unexpected end of file\"),!1;break;case e.Z_STREAM_END:break;case e.Z_NEED_DICT:return null==this.dictionary?this._error(\"Missing dictionary\"):this._error(\"Bad dictionary\"),!1;default:return this._error(\"Zlib error\"),!1}return!0},c.prototype._after=function(){if(this._checkError()){var t=this.strm.avail_out,e=this.strm.avail_in;this.write_in_progress=!1,this.callback(e,t),this.pending_close&&this.close()}},c.prototype._error=function(t){this.strm.msg&&(t=this.strm.msg),this.onerror(t,this.err),this.write_in_progress=!1,this.pending_close&&this.close()},c.prototype.init=function(t,n,r,a,o){i(4===arguments.length||5===arguments.length,\"init(windowBits, level, memLevel, strategy, [dictionary])\"),i(t>=8&&t<=15,\"invalid windowBits\"),i(n>=-1&&n<=9,\"invalid compression level\"),i(r>=1&&r<=9,\"invalid memlevel\"),i(a===e.Z_FILTERED||a===e.Z_HUFFMAN_ONLY||a===e.Z_RLE||a===e.Z_FIXED||a===e.Z_DEFAULT_STRATEGY,\"invalid strategy\"),this._init(n,t,r,a,o),this._setDictionary()},c.prototype.params=function(){throw new Error(\"deflateParams Not supported\")},c.prototype.reset=function(){this._reset(),this._setDictionary()},c.prototype._init=function(t,n,r,i,l){switch(this.level=t,this.windowBits=n,this.memLevel=r,this.strategy=i,this.flush=e.Z_NO_FLUSH,this.err=e.Z_OK,this.mode!==e.GZIP&&this.mode!==e.GUNZIP||(this.windowBits+=16),this.mode===e.UNZIP&&(this.windowBits+=32),this.mode!==e.DEFLATERAW&&this.mode!==e.INFLATERAW||(this.windowBits=-1*this.windowBits),this.strm=new a,this.mode){case e.DEFLATE:case e.GZIP:case e.DEFLATERAW:this.err=o.deflateInit2(this.strm,this.level,e.Z_DEFLATED,this.windowBits,this.memLevel,this.strategy);break;case e.INFLATE:case e.GUNZIP:case e.INFLATERAW:case e.UNZIP:this.err=s.inflateInit2(this.strm,this.windowBits);break;default:throw new Error(\"Unknown mode \"+this.mode)}this.err!==e.Z_OK&&this._error(\"Init error\"),this.dictionary=l,this.write_in_progress=!1,this.init_done=!0},c.prototype._setDictionary=function(){if(null!=this.dictionary){switch(this.err=e.Z_OK,this.mode){case e.DEFLATE:case e.DEFLATERAW:this.err=o.deflateSetDictionary(this.strm,this.dictionary)}this.err!==e.Z_OK&&this._error(\"Failed to set dictionary\")}},c.prototype._reset=function(){switch(this.err=e.Z_OK,this.mode){case e.DEFLATE:case e.DEFLATERAW:case e.GZIP:this.err=o.deflateReset(this.strm);break;case e.INFLATE:case e.INFLATERAW:case e.GUNZIP:this.err=s.inflateReset(this.strm)}this.err!==e.Z_OK&&this._error(\"Failed to reset stream\")},e.Zlib=c}).call(e,n(1).Buffer,n(11))},function(t,e){t.exports=function(t){return t&&\"object\"==typeof t&&\"function\"==typeof t.copy&&\"function\"==typeof t.fill&&\"function\"==typeof t.readUInt8}},function(t,e){\"function\"==typeof Object.create?t.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:t.exports=function(t,e){t.super_=e;var n=function(){};n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t}},function(t,e,n){\"use strict\";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0}},function(t,e,n){\"use strict\";var r,i=n(34),a=n(155),o=n(89),s=n(90),l=n(156),u=0,c=1,h=3,f=4,d=5,p=0,g=1,y=-2,v=-3,b=-5,m=-1,w=1,x=2,S=3,_=4,k=0,C=2,A=8,P=9,E=15,I=8,T=286,O=30,L=19,B=2*T+1,M=15,R=3,F=258,D=F+R+1,z=32,N=42,U=69,W=73,G=91,V=103,j=113,H=666,q=1,Z=2,Y=3,X=4,K=3;function J(t,e){return t.msg=l[e],e}function Q(t){return(t<<1)-(t>4?9:0)}function $(t){for(var e=t.length;--e>=0;)t[e]=0}function tt(t){var e=t.state,n=e.pending;n>t.avail_out&&(n=t.avail_out),0!==n&&(i.arraySet(t.output,e.pending_buf,e.pending_out,n,t.next_out),t.next_out+=n,e.pending_out+=n,t.total_out+=n,t.avail_out-=n,e.pending-=n,0===e.pending&&(e.pending_out=0))}function et(t,e){a._tr_flush_block(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,tt(t.strm)}function nt(t,e){t.pending_buf[t.pending++]=e}function rt(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e}function it(t,e){var n,r,i=t.max_chain_length,a=t.strstart,o=t.prev_length,s=t.nice_match,l=t.strstart>t.w_size-D?t.strstart-(t.w_size-D):0,u=t.window,c=t.w_mask,h=t.prev,f=t.strstart+F,d=u[a+o-1],p=u[a+o];t.prev_length>=t.good_match&&(i>>=2),s>t.lookahead&&(s=t.lookahead);do{if(u[(n=e)+o]===p&&u[n+o-1]===d&&u[n]===u[a]&&u[++n]===u[a+1]){a+=2,n++;do{}while(u[++a]===u[++n]&&u[++a]===u[++n]&&u[++a]===u[++n]&&u[++a]===u[++n]&&u[++a]===u[++n]&&u[++a]===u[++n]&&u[++a]===u[++n]&&u[++a]===u[++n]&&a<f);if(r=F-(f-a),a=f-F,r>o){if(t.match_start=e,o=r,r>=s)break;d=u[a+o-1],p=u[a+o]}}}while((e=h[e&c])>l&&0!=--i);return o<=t.lookahead?o:t.lookahead}function at(t){var e,n,r,a,l,u,c,h,f,d,p=t.w_size;do{if(a=t.window_size-t.lookahead-t.strstart,t.strstart>=p+(p-D)){for(i.arraySet(t.window,t.window,p,p,0),t.match_start-=p,t.strstart-=p,t.block_start-=p,e=n=t.hash_size;r=t.head[--e],t.head[e]=r>=p?r-p:0,--n;);for(e=n=p;r=t.prev[--e],t.prev[e]=r>=p?r-p:0,--n;);a+=p}if(0===t.strm.avail_in)break;if(u=t.strm,c=t.window,h=t.strstart+t.lookahead,f=a,d=void 0,(d=u.avail_in)>f&&(d=f),n=0===d?0:(u.avail_in-=d,i.arraySet(c,u.input,u.next_in,d,h),1===u.state.wrap?u.adler=o(u.adler,c,d,h):2===u.state.wrap&&(u.adler=s(u.adler,c,d,h)),u.next_in+=d,u.total_in+=d,d),t.lookahead+=n,t.lookahead+t.insert>=R)for(l=t.strstart-t.insert,t.ins_h=t.window[l],t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+1])&t.hash_mask;t.insert&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+R-1])&t.hash_mask,t.prev[l&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=l,l++,t.insert--,!(t.lookahead+t.insert<R)););}while(t.lookahead<D&&0!==t.strm.avail_in)}function ot(t,e){for(var n,r;;){if(t.lookahead<D){if(at(t),t.lookahead<D&&e===u)return q;if(0===t.lookahead)break}if(n=0,t.lookahead>=R&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+R-1])&t.hash_mask,n=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==n&&t.strstart-n<=t.w_size-D&&(t.match_length=it(t,n)),t.match_length>=R)if(r=a._tr_tally(t,t.strstart-t.match_start,t.match_length-R),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=R){for(t.match_length--;t.strstart++,t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+R-1])&t.hash_mask,n=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart,0!=--t.match_length;);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+1])&t.hash_mask;else r=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(r&&(et(t,!1),0===t.strm.avail_out))return q}return t.insert=t.strstart<R-1?t.strstart:R-1,e===f?(et(t,!0),0===t.strm.avail_out?Y:X):t.last_lit&&(et(t,!1),0===t.strm.avail_out)?q:Z}function st(t,e){for(var n,r,i;;){if(t.lookahead<D){if(at(t),t.lookahead<D&&e===u)return q;if(0===t.lookahead)break}if(n=0,t.lookahead>=R&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+R-1])&t.hash_mask,n=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=R-1,0!==n&&t.prev_length<t.max_lazy_match&&t.strstart-n<=t.w_size-D&&(t.match_length=it(t,n),t.match_length<=5&&(t.strategy===w||t.match_length===R&&t.strstart-t.match_start>4096)&&(t.match_length=R-1)),t.prev_length>=R&&t.match_length<=t.prev_length){for(i=t.strstart+t.lookahead-R,r=a._tr_tally(t,t.strstart-1-t.prev_match,t.prev_length-R),t.lookahead-=t.prev_length-1,t.prev_length-=2;++t.strstart<=i&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+R-1])&t.hash_mask,n=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!=--t.prev_length;);if(t.match_available=0,t.match_length=R-1,t.strstart++,r&&(et(t,!1),0===t.strm.avail_out))return q}else if(t.match_available){if((r=a._tr_tally(t,0,t.window[t.strstart-1]))&&et(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return q}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(r=a._tr_tally(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<R-1?t.strstart:R-1,e===f?(et(t,!0),0===t.strm.avail_out?Y:X):t.last_lit&&(et(t,!1),0===t.strm.avail_out)?q:Z}function lt(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}function ut(t){var e;return t&&t.state?(t.total_in=t.total_out=0,t.data_type=C,(e=t.state).pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?N:j,t.adler=2===e.wrap?0:1,e.last_flush=u,a._tr_init(e),p):J(t,y)}function ct(t){var e,n=ut(t);return n===p&&((e=t.state).window_size=2*e.w_size,$(e.head),e.max_lazy_match=r[e.level].max_lazy,e.good_match=r[e.level].good_length,e.nice_match=r[e.level].nice_length,e.max_chain_length=r[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=R-1,e.match_available=0,e.ins_h=0),n}function ht(t,e,n,r,a,o){if(!t)return y;var s=1;if(e===m&&(e=6),r<0?(s=0,r=-r):r>15&&(s=2,r-=16),a<1||a>P||n!==A||r<8||r>15||e<0||e>9||o<0||o>_)return J(t,y);8===r&&(r=9);var l=new function(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=A,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new i.Buf16(2*B),this.dyn_dtree=new i.Buf16(2*(2*O+1)),this.bl_tree=new i.Buf16(2*(2*L+1)),$(this.dyn_ltree),$(this.dyn_dtree),$(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new i.Buf16(M+1),this.heap=new i.Buf16(2*T+1),$(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new i.Buf16(2*T+1),$(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0};return t.state=l,l.strm=t,l.wrap=s,l.gzhead=null,l.w_bits=r,l.w_size=1<<l.w_bits,l.w_mask=l.w_size-1,l.hash_bits=a+7,l.hash_size=1<<l.hash_bits,l.hash_mask=l.hash_size-1,l.hash_shift=~~((l.hash_bits+R-1)/R),l.window=new i.Buf8(2*l.w_size),l.head=new i.Buf16(l.hash_size),l.prev=new i.Buf16(l.w_size),l.lit_bufsize=1<<a+6,l.pending_buf_size=4*l.lit_bufsize,l.pending_buf=new i.Buf8(l.pending_buf_size),l.d_buf=1*l.lit_bufsize,l.l_buf=3*l.lit_bufsize,l.level=e,l.strategy=o,l.method=n,ct(t)}r=[new lt(0,0,0,0,function(t,e){var n=65535;for(n>t.pending_buf_size-5&&(n=t.pending_buf_size-5);;){if(t.lookahead<=1){if(at(t),0===t.lookahead&&e===u)return q;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var r=t.block_start+n;if((0===t.strstart||t.strstart>=r)&&(t.lookahead=t.strstart-r,t.strstart=r,et(t,!1),0===t.strm.avail_out))return q;if(t.strstart-t.block_start>=t.w_size-D&&(et(t,!1),0===t.strm.avail_out))return q}return t.insert=0,e===f?(et(t,!0),0===t.strm.avail_out?Y:X):(t.strstart>t.block_start&&(et(t,!1),t.strm.avail_out),q)}),new lt(4,4,8,4,ot),new lt(4,5,16,8,ot),new lt(4,6,32,32,ot),new lt(4,4,16,16,st),new lt(8,16,32,32,st),new lt(8,16,128,128,st),new lt(8,32,128,256,st),new lt(32,128,258,1024,st),new lt(32,258,258,4096,st)],e.deflateInit=function(t,e){return ht(t,e,A,E,I,k)},e.deflateInit2=ht,e.deflateReset=ct,e.deflateResetKeep=ut,e.deflateSetHeader=function(t,e){return t&&t.state?2!==t.state.wrap?y:(t.state.gzhead=e,p):y},e.deflate=function(t,e){var n,i,o,l;if(!t||!t.state||e>d||e<0)return t?J(t,y):y;if(i=t.state,!t.output||!t.input&&0!==t.avail_in||i.status===H&&e!==f)return J(t,0===t.avail_out?b:y);if(i.strm=t,n=i.last_flush,i.last_flush=e,i.status===N)if(2===i.wrap)t.adler=0,nt(i,31),nt(i,139),nt(i,8),i.gzhead?(nt(i,(i.gzhead.text?1:0)+(i.gzhead.hcrc?2:0)+(i.gzhead.extra?4:0)+(i.gzhead.name?8:0)+(i.gzhead.comment?16:0)),nt(i,255&i.gzhead.time),nt(i,i.gzhead.time>>8&255),nt(i,i.gzhead.time>>16&255),nt(i,i.gzhead.time>>24&255),nt(i,9===i.level?2:i.strategy>=x||i.level<2?4:0),nt(i,255&i.gzhead.os),i.gzhead.extra&&i.gzhead.extra.length&&(nt(i,255&i.gzhead.extra.length),nt(i,i.gzhead.extra.length>>8&255)),i.gzhead.hcrc&&(t.adler=s(t.adler,i.pending_buf,i.pending,0)),i.gzindex=0,i.status=U):(nt(i,0),nt(i,0),nt(i,0),nt(i,0),nt(i,0),nt(i,9===i.level?2:i.strategy>=x||i.level<2?4:0),nt(i,K),i.status=j);else{var v=A+(i.w_bits-8<<4)<<8;v|=(i.strategy>=x||i.level<2?0:i.level<6?1:6===i.level?2:3)<<6,0!==i.strstart&&(v|=z),v+=31-v%31,i.status=j,rt(i,v),0!==i.strstart&&(rt(i,t.adler>>>16),rt(i,65535&t.adler)),t.adler=1}if(i.status===U)if(i.gzhead.extra){for(o=i.pending;i.gzindex<(65535&i.gzhead.extra.length)&&(i.pending!==i.pending_buf_size||(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),tt(t),o=i.pending,i.pending!==i.pending_buf_size));)nt(i,255&i.gzhead.extra[i.gzindex]),i.gzindex++;i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),i.gzindex===i.gzhead.extra.length&&(i.gzindex=0,i.status=W)}else i.status=W;if(i.status===W)if(i.gzhead.name){o=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),tt(t),o=i.pending,i.pending===i.pending_buf_size)){l=1;break}l=i.gzindex<i.gzhead.name.length?255&i.gzhead.name.charCodeAt(i.gzindex++):0,nt(i,l)}while(0!==l);i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),0===l&&(i.gzindex=0,i.status=G)}else i.status=G;if(i.status===G)if(i.gzhead.comment){o=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),tt(t),o=i.pending,i.pending===i.pending_buf_size)){l=1;break}l=i.gzindex<i.gzhead.comment.length?255&i.gzhead.comment.charCodeAt(i.gzindex++):0,nt(i,l)}while(0!==l);i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),0===l&&(i.status=V)}else i.status=V;if(i.status===V&&(i.gzhead.hcrc?(i.pending+2>i.pending_buf_size&&tt(t),i.pending+2<=i.pending_buf_size&&(nt(i,255&t.adler),nt(i,t.adler>>8&255),t.adler=0,i.status=j)):i.status=j),0!==i.pending){if(tt(t),0===t.avail_out)return i.last_flush=-1,p}else if(0===t.avail_in&&Q(e)<=Q(n)&&e!==f)return J(t,b);if(i.status===H&&0!==t.avail_in)return J(t,b);if(0!==t.avail_in||0!==i.lookahead||e!==u&&i.status!==H){var m=i.strategy===x?function(t,e){for(var n;;){if(0===t.lookahead&&(at(t),0===t.lookahead)){if(e===u)return q;break}if(t.match_length=0,n=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,n&&(et(t,!1),0===t.strm.avail_out))return q}return t.insert=0,e===f?(et(t,!0),0===t.strm.avail_out?Y:X):t.last_lit&&(et(t,!1),0===t.strm.avail_out)?q:Z}(i,e):i.strategy===S?function(t,e){for(var n,r,i,o,s=t.window;;){if(t.lookahead<=F){if(at(t),t.lookahead<=F&&e===u)return q;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=R&&t.strstart>0&&(r=s[i=t.strstart-1])===s[++i]&&r===s[++i]&&r===s[++i]){o=t.strstart+F;do{}while(r===s[++i]&&r===s[++i]&&r===s[++i]&&r===s[++i]&&r===s[++i]&&r===s[++i]&&r===s[++i]&&r===s[++i]&&i<o);t.match_length=F-(o-i),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=R?(n=a._tr_tally(t,1,t.match_length-R),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(n=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),n&&(et(t,!1),0===t.strm.avail_out))return q}return t.insert=0,e===f?(et(t,!0),0===t.strm.avail_out?Y:X):t.last_lit&&(et(t,!1),0===t.strm.avail_out)?q:Z}(i,e):r[i.level].func(i,e);if(m!==Y&&m!==X||(i.status=H),m===q||m===Y)return 0===t.avail_out&&(i.last_flush=-1),p;if(m===Z&&(e===c?a._tr_align(i):e!==d&&(a._tr_stored_block(i,0,0,!1),e===h&&($(i.head),0===i.lookahead&&(i.strstart=0,i.block_start=0,i.insert=0))),tt(t),0===t.avail_out))return i.last_flush=-1,p}return e!==f?p:i.wrap<=0?g:(2===i.wrap?(nt(i,255&t.adler),nt(i,t.adler>>8&255),nt(i,t.adler>>16&255),nt(i,t.adler>>24&255),nt(i,255&t.total_in),nt(i,t.total_in>>8&255),nt(i,t.total_in>>16&255),nt(i,t.total_in>>24&255)):(rt(i,t.adler>>>16),rt(i,65535&t.adler)),tt(t),i.wrap>0&&(i.wrap=-i.wrap),0!==i.pending?p:g)},e.deflateEnd=function(t){var e;return t&&t.state?(e=t.state.status)!==N&&e!==U&&e!==W&&e!==G&&e!==V&&e!==j&&e!==H?J(t,y):(t.state=null,e===j?J(t,v):p):y},e.deflateSetDictionary=function(t,e){var n,r,a,s,l,u,c,h,f=e.length;if(!t||!t.state)return y;if(2===(s=(n=t.state).wrap)||1===s&&n.status!==N||n.lookahead)return y;for(1===s&&(t.adler=o(t.adler,e,f,0)),n.wrap=0,f>=n.w_size&&(0===s&&($(n.head),n.strstart=0,n.block_start=0,n.insert=0),h=new i.Buf8(n.w_size),i.arraySet(h,e,f-n.w_size,n.w_size,0),e=h,f=n.w_size),l=t.avail_in,u=t.next_in,c=t.input,t.avail_in=f,t.next_in=0,t.input=e,at(n);n.lookahead>=R;){for(r=n.strstart,a=n.lookahead-(R-1);n.ins_h=(n.ins_h<<n.hash_shift^n.window[r+R-1])&n.hash_mask,n.prev[r&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=r,r++,--a;);n.strstart=r,n.lookahead=R-1,at(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=R-1,n.match_available=0,t.next_in=u,t.input=c,t.avail_in=l,n.wrap=s,p},e.deflateInfo=\"pako deflate (from Nodeca project)\"},function(t,e,n){\"use strict\";var r=n(34),i=4,a=0,o=1,s=2;function l(t){for(var e=t.length;--e>=0;)t[e]=0}var u=0,c=1,h=2,f=29,d=256,p=d+1+f,g=30,y=19,v=2*p+1,b=15,m=16,w=7,x=256,S=16,_=17,k=18,C=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],A=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],P=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],E=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],I=new Array(2*(p+2));l(I);var T=new Array(2*g);l(T);var O=new Array(512);l(O);var L=new Array(256);l(L);var B=new Array(f);l(B);var M,R,F,D=new Array(g);function z(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i,this.has_stree=t&&t.length}function N(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}function U(t){return t<256?O[t]:O[256+(t>>>7)]}function W(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255}function G(t,e,n){t.bi_valid>m-n?(t.bi_buf|=e<<t.bi_valid&65535,W(t,t.bi_buf),t.bi_buf=e>>m-t.bi_valid,t.bi_valid+=n-m):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=n)}function V(t,e,n){G(t,n[2*e],n[2*e+1])}function j(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,--e>0;);return n>>>1}function H(t,e,n){var r,i,a=new Array(b+1),o=0;for(r=1;r<=b;r++)a[r]=o=o+n[r-1]<<1;for(i=0;i<=e;i++){var s=t[2*i+1];0!==s&&(t[2*i]=j(a[s]++,s))}}function q(t){var e;for(e=0;e<p;e++)t.dyn_ltree[2*e]=0;for(e=0;e<g;e++)t.dyn_dtree[2*e]=0;for(e=0;e<y;e++)t.bl_tree[2*e]=0;t.dyn_ltree[2*x]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0}function Z(t){t.bi_valid>8?W(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0}function Y(t,e,n,r){var i=2*e,a=2*n;return t[i]<t[a]||t[i]===t[a]&&r[e]<=r[n]}function X(t,e,n){for(var r=t.heap[n],i=n<<1;i<=t.heap_len&&(i<t.heap_len&&Y(e,t.heap[i+1],t.heap[i],t.depth)&&i++,!Y(e,r,t.heap[i],t.depth));)t.heap[n]=t.heap[i],n=i,i<<=1;t.heap[n]=r}function K(t,e,n){var r,i,a,o,s=0;if(0!==t.last_lit)for(;r=t.pending_buf[t.d_buf+2*s]<<8|t.pending_buf[t.d_buf+2*s+1],i=t.pending_buf[t.l_buf+s],s++,0===r?V(t,i,e):(V(t,(a=L[i])+d+1,e),0!==(o=C[a])&&G(t,i-=B[a],o),V(t,a=U(--r),n),0!==(o=A[a])&&G(t,r-=D[a],o)),s<t.last_lit;);V(t,x,e)}function J(t,e){var n,r,i,a=e.dyn_tree,o=e.stat_desc.static_tree,s=e.stat_desc.has_stree,l=e.stat_desc.elems,u=-1;for(t.heap_len=0,t.heap_max=v,n=0;n<l;n++)0!==a[2*n]?(t.heap[++t.heap_len]=u=n,t.depth[n]=0):a[2*n+1]=0;for(;t.heap_len<2;)a[2*(i=t.heap[++t.heap_len]=u<2?++u:0)]=1,t.depth[i]=0,t.opt_len--,s&&(t.static_len-=o[2*i+1]);for(e.max_code=u,n=t.heap_len>>1;n>=1;n--)X(t,a,n);for(i=l;n=t.heap[1],t.heap[1]=t.heap[t.heap_len--],X(t,a,1),r=t.heap[1],t.heap[--t.heap_max]=n,t.heap[--t.heap_max]=r,a[2*i]=a[2*n]+a[2*r],t.depth[i]=(t.depth[n]>=t.depth[r]?t.depth[n]:t.depth[r])+1,a[2*n+1]=a[2*r+1]=i,t.heap[1]=i++,X(t,a,1),t.heap_len>=2;);t.heap[--t.heap_max]=t.heap[1],function(t,e){var n,r,i,a,o,s,l=e.dyn_tree,u=e.max_code,c=e.stat_desc.static_tree,h=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,d=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(a=0;a<=b;a++)t.bl_count[a]=0;for(l[2*t.heap[t.heap_max]+1]=0,n=t.heap_max+1;n<v;n++)(a=l[2*l[2*(r=t.heap[n])+1]+1]+1)>p&&(a=p,g++),l[2*r+1]=a,r>u||(t.bl_count[a]++,o=0,r>=d&&(o=f[r-d]),s=l[2*r],t.opt_len+=s*(a+o),h&&(t.static_len+=s*(c[2*r+1]+o)));if(0!==g){do{for(a=p-1;0===t.bl_count[a];)a--;t.bl_count[a]--,t.bl_count[a+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(a=p;0!==a;a--)for(r=t.bl_count[a];0!==r;)(i=t.heap[--n])>u||(l[2*i+1]!==a&&(t.opt_len+=(a-l[2*i+1])*l[2*i],l[2*i+1]=a),r--)}}(t,e),H(a,u,t.bl_count)}function Q(t,e,n){var r,i,a=-1,o=e[1],s=0,l=7,u=4;for(0===o&&(l=138,u=3),e[2*(n+1)+1]=65535,r=0;r<=n;r++)i=o,o=e[2*(r+1)+1],++s<l&&i===o||(s<u?t.bl_tree[2*i]+=s:0!==i?(i!==a&&t.bl_tree[2*i]++,t.bl_tree[2*S]++):s<=10?t.bl_tree[2*_]++:t.bl_tree[2*k]++,s=0,a=i,0===o?(l=138,u=3):i===o?(l=6,u=3):(l=7,u=4))}function $(t,e,n){var r,i,a=-1,o=e[1],s=0,l=7,u=4;for(0===o&&(l=138,u=3),r=0;r<=n;r++)if(i=o,o=e[2*(r+1)+1],!(++s<l&&i===o)){if(s<u)for(;V(t,i,t.bl_tree),0!=--s;);else 0!==i?(i!==a&&(V(t,i,t.bl_tree),s--),V(t,S,t.bl_tree),G(t,s-3,2)):s<=10?(V(t,_,t.bl_tree),G(t,s-3,3)):(V(t,k,t.bl_tree),G(t,s-11,7));s=0,a=i,0===o?(l=138,u=3):i===o?(l=6,u=3):(l=7,u=4)}}l(D);var tt=!1;function et(t,e,n,i){var a,o,s,l;G(t,(u<<1)+(i?1:0),3),o=e,s=n,l=!0,Z(a=t),l&&(W(a,s),W(a,~s)),r.arraySet(a.pending_buf,a.window,o,s,a.pending),a.pending+=s}e._tr_init=function(t){tt||(function(){var t,e,n,r,i,a=new Array(b+1);for(n=0,r=0;r<f-1;r++)for(B[r]=n,t=0;t<1<<C[r];t++)L[n++]=r;for(L[n-1]=r,i=0,r=0;r<16;r++)for(D[r]=i,t=0;t<1<<A[r];t++)O[i++]=r;for(i>>=7;r<g;r++)for(D[r]=i<<7,t=0;t<1<<A[r]-7;t++)O[256+i++]=r;for(e=0;e<=b;e++)a[e]=0;for(t=0;t<=143;)I[2*t+1]=8,t++,a[8]++;for(;t<=255;)I[2*t+1]=9,t++,a[9]++;for(;t<=279;)I[2*t+1]=7,t++,a[7]++;for(;t<=287;)I[2*t+1]=8,t++,a[8]++;for(H(I,p+1,a),t=0;t<g;t++)T[2*t+1]=5,T[2*t]=j(t,5);M=new z(I,C,d+1,p,b),R=new z(T,A,0,g,b),F=new z(new Array(0),P,0,y,w)}(),tt=!0),t.l_desc=new N(t.dyn_ltree,M),t.d_desc=new N(t.dyn_dtree,R),t.bl_desc=new N(t.bl_tree,F),t.bi_buf=0,t.bi_valid=0,q(t)},e._tr_stored_block=et,e._tr_flush_block=function(t,e,n,r){var l,u,f=0;t.level>0?(t.strm.data_type===s&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return a;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return o;for(e=32;e<d;e++)if(0!==t.dyn_ltree[2*e])return o;return a}(t)),J(t,t.l_desc),J(t,t.d_desc),f=function(t){var e;for(Q(t,t.dyn_ltree,t.l_desc.max_code),Q(t,t.dyn_dtree,t.d_desc.max_code),J(t,t.bl_desc),e=y-1;e>=3&&0===t.bl_tree[2*E[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),l=t.opt_len+3+7>>>3,(u=t.static_len+3+7>>>3)<=l&&(l=u)):l=u=n+5,n+4<=l&&-1!==e?et(t,e,n,r):t.strategy===i||u===l?(G(t,(c<<1)+(r?1:0),3),K(t,I,T)):(G(t,(h<<1)+(r?1:0),3),function(t,e,n,r){var i;for(G(t,e-257,5),G(t,n-1,5),G(t,r-4,4),i=0;i<r;i++)G(t,t.bl_tree[2*E[i]+1],3);$(t,t.dyn_ltree,e-1),$(t,t.dyn_dtree,n-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,f+1),K(t,t.dyn_ltree,t.dyn_dtree)),q(t),r&&Z(t)},e._tr_tally=function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(L[n]+d+1)]++,t.dyn_dtree[2*U(e)]++),t.last_lit===t.lit_bufsize-1},e._tr_align=function(t){var e;G(t,c<<1,3),V(t,x,I),16===(e=t).bi_valid?(W(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):e.bi_valid>=8&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}},function(t,e,n){\"use strict\";t.exports={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"}},function(t,e,n){\"use strict\";var r=n(34),i=n(89),a=n(90),o=n(158),s=n(159),l=0,u=1,c=2,h=4,f=5,d=6,p=0,g=1,y=2,v=-2,b=-3,m=-4,w=-5,x=8,S=1,_=2,k=3,C=4,A=5,P=6,E=7,I=8,T=9,O=10,L=11,B=12,M=13,R=14,F=15,D=16,z=17,N=18,U=19,W=20,G=21,V=22,j=23,H=24,q=25,Z=26,Y=27,X=28,K=29,J=30,Q=31,$=32,tt=852,et=592,nt=15;function rt(t){return(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24)}function it(t){var e;return t&&t.state?(e=t.state,t.total_in=t.total_out=e.total=0,t.msg=\"\",e.wrap&&(t.adler=1&e.wrap),e.mode=S,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new r.Buf32(tt),e.distcode=e.distdyn=new r.Buf32(et),e.sane=1,e.back=-1,p):v}function at(t){var e;return t&&t.state?((e=t.state).wsize=0,e.whave=0,e.wnext=0,it(t)):v}function ot(t,e){var n,r;return t&&t.state?(r=t.state,e<0?(n=0,e=-e):(n=1+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?v:(null!==r.window&&r.wbits!==e&&(r.window=null),r.wrap=n,r.wbits=e,at(t))):v}function st(t,e){var n,i;return t?(i=new function(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new r.Buf16(320),this.work=new r.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0},t.state=i,i.window=null,(n=ot(t,e))!==p&&(t.state=null),n):v}var lt,ut,ct=!0;function ht(t){if(ct){var e;for(lt=new r.Buf32(512),ut=new r.Buf32(32),e=0;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(s(u,t.lens,0,288,lt,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;s(c,t.lens,0,32,ut,0,t.work,{bits:5}),ct=!1}t.lencode=lt,t.lenbits=9,t.distcode=ut,t.distbits=5}function ft(t,e,n,i){var a,o=t.state;return null===o.window&&(o.wsize=1<<o.wbits,o.wnext=0,o.whave=0,o.window=new r.Buf8(o.wsize)),i>=o.wsize?(r.arraySet(o.window,e,n-o.wsize,o.wsize,0),o.wnext=0,o.whave=o.wsize):((a=o.wsize-o.wnext)>i&&(a=i),r.arraySet(o.window,e,n-i,a,o.wnext),(i-=a)?(r.arraySet(o.window,e,n-i,i,0),o.wnext=i,o.whave=o.wsize):(o.wnext+=a,o.wnext===o.wsize&&(o.wnext=0),o.whave<o.wsize&&(o.whave+=a))),0}e.inflateReset=at,e.inflateReset2=ot,e.inflateResetKeep=it,e.inflateInit=function(t){return st(t,nt)},e.inflateInit2=st,e.inflate=function(t,e){var n,tt,et,nt,it,at,ot,st,lt,ut,ct,dt,pt,gt,yt,vt,bt,mt,wt,xt,St,_t,kt,Ct,At=0,Pt=new r.Buf8(4),Et=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!t||!t.state||!t.output||!t.input&&0!==t.avail_in)return v;(n=t.state).mode===B&&(n.mode=M),it=t.next_out,et=t.output,ot=t.avail_out,nt=t.next_in,tt=t.input,at=t.avail_in,st=n.hold,lt=n.bits,ut=at,ct=ot,_t=p;t:for(;;)switch(n.mode){case S:if(0===n.wrap){n.mode=M;break}for(;lt<16;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(2&n.wrap&&35615===st){n.check=0,Pt[0]=255&st,Pt[1]=st>>>8&255,n.check=a(n.check,Pt,2,0),st=0,lt=0,n.mode=_;break}if(n.flags=0,n.head&&(n.head.done=!1),!(1&n.wrap)||(((255&st)<<8)+(st>>8))%31){t.msg=\"incorrect header check\",n.mode=J;break}if((15&st)!==x){t.msg=\"unknown compression method\",n.mode=J;break}if(lt-=4,St=8+(15&(st>>>=4)),0===n.wbits)n.wbits=St;else if(St>n.wbits){t.msg=\"invalid window size\",n.mode=J;break}n.dmax=1<<St,t.adler=n.check=1,n.mode=512&st?O:B,st=0,lt=0;break;case _:for(;lt<16;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(n.flags=st,(255&n.flags)!==x){t.msg=\"unknown compression method\",n.mode=J;break}if(57344&n.flags){t.msg=\"unknown header flags set\",n.mode=J;break}n.head&&(n.head.text=st>>8&1),512&n.flags&&(Pt[0]=255&st,Pt[1]=st>>>8&255,n.check=a(n.check,Pt,2,0)),st=0,lt=0,n.mode=k;case k:for(;lt<32;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}n.head&&(n.head.time=st),512&n.flags&&(Pt[0]=255&st,Pt[1]=st>>>8&255,Pt[2]=st>>>16&255,Pt[3]=st>>>24&255,n.check=a(n.check,Pt,4,0)),st=0,lt=0,n.mode=C;case C:for(;lt<16;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}n.head&&(n.head.xflags=255&st,n.head.os=st>>8),512&n.flags&&(Pt[0]=255&st,Pt[1]=st>>>8&255,n.check=a(n.check,Pt,2,0)),st=0,lt=0,n.mode=A;case A:if(1024&n.flags){for(;lt<16;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}n.length=st,n.head&&(n.head.extra_len=st),512&n.flags&&(Pt[0]=255&st,Pt[1]=st>>>8&255,n.check=a(n.check,Pt,2,0)),st=0,lt=0}else n.head&&(n.head.extra=null);n.mode=P;case P:if(1024&n.flags&&((dt=n.length)>at&&(dt=at),dt&&(n.head&&(St=n.head.extra_len-n.length,n.head.extra||(n.head.extra=new Array(n.head.extra_len)),r.arraySet(n.head.extra,tt,nt,dt,St)),512&n.flags&&(n.check=a(n.check,tt,dt,nt)),at-=dt,nt+=dt,n.length-=dt),n.length))break t;n.length=0,n.mode=E;case E:if(2048&n.flags){if(0===at)break t;for(dt=0;St=tt[nt+dt++],n.head&&St&&n.length<65536&&(n.head.name+=String.fromCharCode(St)),St&&dt<at;);if(512&n.flags&&(n.check=a(n.check,tt,dt,nt)),at-=dt,nt+=dt,St)break t}else n.head&&(n.head.name=null);n.length=0,n.mode=I;case I:if(4096&n.flags){if(0===at)break t;for(dt=0;St=tt[nt+dt++],n.head&&St&&n.length<65536&&(n.head.comment+=String.fromCharCode(St)),St&&dt<at;);if(512&n.flags&&(n.check=a(n.check,tt,dt,nt)),at-=dt,nt+=dt,St)break t}else n.head&&(n.head.comment=null);n.mode=T;case T:if(512&n.flags){for(;lt<16;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(st!==(65535&n.check)){t.msg=\"header crc mismatch\",n.mode=J;break}st=0,lt=0}n.head&&(n.head.hcrc=n.flags>>9&1,n.head.done=!0),t.adler=n.check=0,n.mode=B;break;case O:for(;lt<32;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}t.adler=n.check=rt(st),st=0,lt=0,n.mode=L;case L:if(0===n.havedict)return t.next_out=it,t.avail_out=ot,t.next_in=nt,t.avail_in=at,n.hold=st,n.bits=lt,y;t.adler=n.check=1,n.mode=B;case B:if(e===f||e===d)break t;case M:if(n.last){st>>>=7&lt,lt-=7&lt,n.mode=Y;break}for(;lt<3;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}switch(n.last=1&st,lt-=1,3&(st>>>=1)){case 0:n.mode=R;break;case 1:if(ht(n),n.mode=W,e===d){st>>>=2,lt-=2;break t}break;case 2:n.mode=z;break;case 3:t.msg=\"invalid block type\",n.mode=J}st>>>=2,lt-=2;break;case R:for(st>>>=7&lt,lt-=7&lt;lt<32;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if((65535&st)!=(st>>>16^65535)){t.msg=\"invalid stored block lengths\",n.mode=J;break}if(n.length=65535&st,st=0,lt=0,n.mode=F,e===d)break t;case F:n.mode=D;case D:if(dt=n.length){if(dt>at&&(dt=at),dt>ot&&(dt=ot),0===dt)break t;r.arraySet(et,tt,nt,dt,it),at-=dt,nt+=dt,ot-=dt,it+=dt,n.length-=dt;break}n.mode=B;break;case z:for(;lt<14;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(n.nlen=257+(31&st),st>>>=5,lt-=5,n.ndist=1+(31&st),st>>>=5,lt-=5,n.ncode=4+(15&st),st>>>=4,lt-=4,n.nlen>286||n.ndist>30){t.msg=\"too many length or distance symbols\",n.mode=J;break}n.have=0,n.mode=N;case N:for(;n.have<n.ncode;){for(;lt<3;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}n.lens[Et[n.have++]]=7&st,st>>>=3,lt-=3}for(;n.have<19;)n.lens[Et[n.have++]]=0;if(n.lencode=n.lendyn,n.lenbits=7,kt={bits:n.lenbits},_t=s(l,n.lens,0,19,n.lencode,0,n.work,kt),n.lenbits=kt.bits,_t){t.msg=\"invalid code lengths set\",n.mode=J;break}n.have=0,n.mode=U;case U:for(;n.have<n.nlen+n.ndist;){for(;vt=(At=n.lencode[st&(1<<n.lenbits)-1])>>>16&255,bt=65535&At,!((yt=At>>>24)<=lt);){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(bt<16)st>>>=yt,lt-=yt,n.lens[n.have++]=bt;else{if(16===bt){for(Ct=yt+2;lt<Ct;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(st>>>=yt,lt-=yt,0===n.have){t.msg=\"invalid bit length repeat\",n.mode=J;break}St=n.lens[n.have-1],dt=3+(3&st),st>>>=2,lt-=2}else if(17===bt){for(Ct=yt+3;lt<Ct;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}lt-=yt,St=0,dt=3+(7&(st>>>=yt)),st>>>=3,lt-=3}else{for(Ct=yt+7;lt<Ct;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}lt-=yt,St=0,dt=11+(127&(st>>>=yt)),st>>>=7,lt-=7}if(n.have+dt>n.nlen+n.ndist){t.msg=\"invalid bit length repeat\",n.mode=J;break}for(;dt--;)n.lens[n.have++]=St}}if(n.mode===J)break;if(0===n.lens[256]){t.msg=\"invalid code -- missing end-of-block\",n.mode=J;break}if(n.lenbits=9,kt={bits:n.lenbits},_t=s(u,n.lens,0,n.nlen,n.lencode,0,n.work,kt),n.lenbits=kt.bits,_t){t.msg=\"invalid literal/lengths set\",n.mode=J;break}if(n.distbits=6,n.distcode=n.distdyn,kt={bits:n.distbits},_t=s(c,n.lens,n.nlen,n.ndist,n.distcode,0,n.work,kt),n.distbits=kt.bits,_t){t.msg=\"invalid distances set\",n.mode=J;break}if(n.mode=W,e===d)break t;case W:n.mode=G;case G:if(at>=6&&ot>=258){t.next_out=it,t.avail_out=ot,t.next_in=nt,t.avail_in=at,n.hold=st,n.bits=lt,o(t,ct),it=t.next_out,et=t.output,ot=t.avail_out,nt=t.next_in,tt=t.input,at=t.avail_in,st=n.hold,lt=n.bits,n.mode===B&&(n.back=-1);break}for(n.back=0;vt=(At=n.lencode[st&(1<<n.lenbits)-1])>>>16&255,bt=65535&At,!((yt=At>>>24)<=lt);){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(vt&&0==(240&vt)){for(mt=yt,wt=vt,xt=bt;vt=(At=n.lencode[xt+((st&(1<<mt+wt)-1)>>mt)])>>>16&255,bt=65535&At,!(mt+(yt=At>>>24)<=lt);){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}st>>>=mt,lt-=mt,n.back+=mt}if(st>>>=yt,lt-=yt,n.back+=yt,n.length=bt,0===vt){n.mode=Z;break}if(32&vt){n.back=-1,n.mode=B;break}if(64&vt){t.msg=\"invalid literal/length code\",n.mode=J;break}n.extra=15&vt,n.mode=V;case V:if(n.extra){for(Ct=n.extra;lt<Ct;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}n.length+=st&(1<<n.extra)-1,st>>>=n.extra,lt-=n.extra,n.back+=n.extra}n.was=n.length,n.mode=j;case j:for(;vt=(At=n.distcode[st&(1<<n.distbits)-1])>>>16&255,bt=65535&At,!((yt=At>>>24)<=lt);){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(0==(240&vt)){for(mt=yt,wt=vt,xt=bt;vt=(At=n.distcode[xt+((st&(1<<mt+wt)-1)>>mt)])>>>16&255,bt=65535&At,!(mt+(yt=At>>>24)<=lt);){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}st>>>=mt,lt-=mt,n.back+=mt}if(st>>>=yt,lt-=yt,n.back+=yt,64&vt){t.msg=\"invalid distance code\",n.mode=J;break}n.offset=bt,n.extra=15&vt,n.mode=H;case H:if(n.extra){for(Ct=n.extra;lt<Ct;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}n.offset+=st&(1<<n.extra)-1,st>>>=n.extra,lt-=n.extra,n.back+=n.extra}if(n.offset>n.dmax){t.msg=\"invalid distance too far back\",n.mode=J;break}n.mode=q;case q:if(0===ot)break t;if(dt=ct-ot,n.offset>dt){if((dt=n.offset-dt)>n.whave&&n.sane){t.msg=\"invalid distance too far back\",n.mode=J;break}dt>n.wnext?(dt-=n.wnext,pt=n.wsize-dt):pt=n.wnext-dt,dt>n.length&&(dt=n.length),gt=n.window}else gt=et,pt=it-n.offset,dt=n.length;for(dt>ot&&(dt=ot),ot-=dt,n.length-=dt;et[it++]=gt[pt++],--dt;);0===n.length&&(n.mode=G);break;case Z:if(0===ot)break t;et[it++]=n.length,ot--,n.mode=G;break;case Y:if(n.wrap){for(;lt<32;){if(0===at)break t;at--,st|=tt[nt++]<<lt,lt+=8}if(ct-=ot,t.total_out+=ct,n.total+=ct,ct&&(t.adler=n.check=n.flags?a(n.check,et,ct,it-ct):i(n.check,et,ct,it-ct)),ct=ot,(n.flags?st:rt(st))!==n.check){t.msg=\"incorrect data check\",n.mode=J;break}st=0,lt=0}n.mode=X;case X:if(n.wrap&&n.flags){for(;lt<32;){if(0===at)break t;at--,st+=tt[nt++]<<lt,lt+=8}if(st!==(4294967295&n.total)){t.msg=\"incorrect length check\",n.mode=J;break}st=0,lt=0}n.mode=K;case K:_t=g;break t;case J:_t=b;break t;case Q:return m;case $:default:return v}return t.next_out=it,t.avail_out=ot,t.next_in=nt,t.avail_in=at,n.hold=st,n.bits=lt,(n.wsize||ct!==t.avail_out&&n.mode<J&&(n.mode<Y||e!==h))&&ft(t,t.output,t.next_out,ct-t.avail_out)?(n.mode=Q,m):(ut-=t.avail_in,ct-=t.avail_out,t.total_in+=ut,t.total_out+=ct,n.total+=ct,n.wrap&&ct&&(t.adler=n.check=n.flags?a(n.check,et,ct,t.next_out-ct):i(n.check,et,ct,t.next_out-ct)),t.data_type=n.bits+(n.last?64:0)+(n.mode===B?128:0)+(n.mode===W||n.mode===F?256:0),(0===ut&&0===ct||e===h)&&_t===p&&(_t=w),_t)},e.inflateEnd=function(t){if(!t||!t.state)return v;var e=t.state;return e.window&&(e.window=null),t.state=null,p},e.inflateGetHeader=function(t,e){var n;return t&&t.state?0==(2&(n=t.state).wrap)?v:(n.head=e,e.done=!1,p):v},e.inflateSetDictionary=function(t,e){var n,r=e.length;return t&&t.state?0!==(n=t.state).wrap&&n.mode!==L?v:n.mode===L&&i(1,e,r,0)!==n.check?b:ft(t,e,r,r)?(n.mode=Q,m):(n.havedict=1,p):v},e.inflateInfo=\"pako inflate (from Nodeca project)\"},function(t,e,n){\"use strict\";t.exports=function(t,e){var n,r,i,a,o,s,l,u,c,h,f,d,p,g,y,v,b,m,w,x,S,_,k,C,A;n=t.state,r=t.next_in,C=t.input,i=r+(t.avail_in-5),a=t.next_out,A=t.output,o=a-(e-t.avail_out),s=a+(t.avail_out-257),l=n.dmax,u=n.wsize,c=n.whave,h=n.wnext,f=n.window,d=n.hold,p=n.bits,g=n.lencode,y=n.distcode,v=(1<<n.lenbits)-1,b=(1<<n.distbits)-1;t:do{p<15&&(d+=C[r++]<<p,p+=8,d+=C[r++]<<p,p+=8),m=g[d&v];e:for(;;){if(d>>>=w=m>>>24,p-=w,0===(w=m>>>16&255))A[a++]=65535&m;else{if(!(16&w)){if(0==(64&w)){m=g[(65535&m)+(d&(1<<w)-1)];continue e}if(32&w){n.mode=12;break t}t.msg=\"invalid literal/length code\",n.mode=30;break t}x=65535&m,(w&=15)&&(p<w&&(d+=C[r++]<<p,p+=8),x+=d&(1<<w)-1,d>>>=w,p-=w),p<15&&(d+=C[r++]<<p,p+=8,d+=C[r++]<<p,p+=8),m=y[d&b];n:for(;;){if(d>>>=w=m>>>24,p-=w,!(16&(w=m>>>16&255))){if(0==(64&w)){m=y[(65535&m)+(d&(1<<w)-1)];continue n}t.msg=\"invalid distance code\",n.mode=30;break t}if(S=65535&m,p<(w&=15)&&(d+=C[r++]<<p,(p+=8)<w&&(d+=C[r++]<<p,p+=8)),(S+=d&(1<<w)-1)>l){t.msg=\"invalid distance too far back\",n.mode=30;break t}if(d>>>=w,p-=w,S>(w=a-o)){if((w=S-w)>c&&n.sane){t.msg=\"invalid distance too far back\",n.mode=30;break t}if(_=0,k=f,0===h){if(_+=u-w,w<x){for(x-=w;A[a++]=f[_++],--w;);_=a-S,k=A}}else if(h<w){if(_+=u+h-w,(w-=h)<x){for(x-=w;A[a++]=f[_++],--w;);if(_=0,h<x){for(x-=w=h;A[a++]=f[_++],--w;);_=a-S,k=A}}}else if(_+=h-w,w<x){for(x-=w;A[a++]=f[_++],--w;);_=a-S,k=A}for(;x>2;)A[a++]=k[_++],A[a++]=k[_++],A[a++]=k[_++],x-=3;x&&(A[a++]=k[_++],x>1&&(A[a++]=k[_++]))}else{for(_=a-S;A[a++]=A[_++],A[a++]=A[_++],A[a++]=A[_++],(x-=3)>2;);x&&(A[a++]=A[_++],x>1&&(A[a++]=A[_++]))}break}}break}}while(r<i&&a<s);r-=x=p>>3,d&=(1<<(p-=x<<3))-1,t.next_in=r,t.next_out=a,t.avail_in=r<i?i-r+5:5-(r-i),t.avail_out=a<s?s-a+257:257-(a-s),n.hold=d,n.bits=p}},function(t,e,n){\"use strict\";var r=n(34),i=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],a=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],o=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],s=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(t,e,n,l,u,c,h,f){var d,p,g,y,v,b,m,w,x,S=f.bits,_=0,k=0,C=0,A=0,P=0,E=0,I=0,T=0,O=0,L=0,B=null,M=0,R=new r.Buf16(16),F=new r.Buf16(16),D=null,z=0;for(_=0;_<=15;_++)R[_]=0;for(k=0;k<l;k++)R[e[n+k]]++;for(P=S,A=15;A>=1&&0===R[A];A--);if(P>A&&(P=A),0===A)return u[c++]=20971520,u[c++]=20971520,f.bits=1,0;for(C=1;C<A&&0===R[C];C++);for(P<C&&(P=C),T=1,_=1;_<=15;_++)if(T<<=1,(T-=R[_])<0)return-1;if(T>0&&(0===t||1!==A))return-1;for(F[1]=0,_=1;_<15;_++)F[_+1]=F[_]+R[_];for(k=0;k<l;k++)0!==e[n+k]&&(h[F[e[n+k]]++]=k);if(0===t?(B=D=h,b=19):1===t?(B=i,M-=257,D=a,z-=257,b=256):(B=o,D=s,b=-1),L=0,k=0,_=C,v=c,E=P,I=0,g=-1,y=(O=1<<P)-1,1===t&&O>852||2===t&&O>592)return 1;for(;;){for(m=_-I,h[k]<b?(w=0,x=h[k]):h[k]>b?(w=D[z+h[k]],x=B[M+h[k]]):(w=96,x=0),d=1<<_-I,C=p=1<<E;u[v+(L>>I)+(p-=d)]=m<<24|w<<16|x|0,0!==p;);for(d=1<<_-1;L&d;)d>>=1;if(0!==d?(L&=d-1,L+=d):L=0,k++,0==--R[_]){if(_===A)break;_=e[n+h[k]]}if(_>P&&(L&y)!==g){for(0===I&&(I=P),v+=C,T=1<<(E=_-I);E+I<A&&!((T-=R[E+I])<=0);)E++,T<<=1;if(O+=1<<E,1===t&&O>852||2===t&&O>592)return 1;u[g=L&y]=P<<24|E<<16|v-c|0}}return 0!==L&&(u[v+L]=_-I<<24|64<<16|0),f.bits=P,0}},function(t,e,n){\"use strict\";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},function(t,e){(function(){var e;e=function(){var t,e;function n(n,r){var i,a,o,s,l,u;this.document=n,null==r&&(r={}),this.size=r.size||\"letter\",this.layout=r.layout||\"portrait\",\"number\"==typeof r.margin?this.margins={top:r.margin,left:r.margin,bottom:r.margin,right:r.margin}:this.margins=r.margins||t,i=Array.isArray(this.size)?this.size:e[this.size.toUpperCase()],this.width=i[\"portrait\"===this.layout?0:1],this.height=i[\"portrait\"===this.layout?1:0],this.content=this.document.ref(),this.resources=this.document.ref({ProcSet:[\"PDF\",\"Text\",\"ImageB\",\"ImageC\",\"ImageI\"]}),Object.defineProperties(this,{fonts:{get:(u=this,function(){var t;return null!=(t=u.resources.data).Font?t.Font:t.Font={}})},xobjects:{get:(l=this,function(){var t;return null!=(t=l.resources.data).XObject?t.XObject:t.XObject={}})},ext_gstates:{get:(s=this,function(){var t;return null!=(t=s.resources.data).ExtGState?t.ExtGState:t.ExtGState={}})},patterns:{get:(o=this,function(){var t;return null!=(t=o.resources.data).Pattern?t.Pattern:t.Pattern={}})},annotations:{get:(a=this,function(){var t;return null!=(t=a.dictionary.data).Annots?t.Annots:t.Annots=[]})}}),this.dictionary=this.document.ref({Type:\"Page\",Parent:this.document._root.data.Pages,MediaBox:[0,0,this.width,this.height],Contents:this.content,Resources:this.resources})}return n.prototype.maxY=function(){return this.height-this.margins.bottom},n.prototype.write=function(t){return this.content.write(t)},n.prototype.end=function(){return this.dictionary.end(),this.resources.end(),this.content.end()},t={top:72,left:72,bottom:72,right:72},e={\"4A0\":[4767.87,6740.79],\"2A0\":[3370.39,4767.87],A0:[2383.94,3370.39],A1:[1683.78,2383.94],A2:[1190.55,1683.78],A3:[841.89,1190.55],A4:[595.28,841.89],A5:[419.53,595.28],A6:[297.64,419.53],A7:[209.76,297.64],A8:[147.4,209.76],A9:[104.88,147.4],A10:[73.7,104.88],B0:[2834.65,4008.19],B1:[2004.09,2834.65],B2:[1417.32,2004.09],B3:[1000.63,1417.32],B4:[708.66,1000.63],B5:[498.9,708.66],B6:[354.33,498.9],B7:[249.45,354.33],B8:[175.75,249.45],B9:[124.72,175.75],B10:[87.87,124.72],C0:[2599.37,3676.54],C1:[1836.85,2599.37],C2:[1298.27,1836.85],C3:[918.43,1298.27],C4:[649.13,918.43],C5:[459.21,649.13],C6:[323.15,459.21],C7:[229.61,323.15],C8:[161.57,229.61],C9:[113.39,161.57],C10:[79.37,113.39],RA0:[2437.8,3458.27],RA1:[1729.13,2437.8],RA2:[1218.9,1729.13],RA3:[864.57,1218.9],RA4:[609.45,864.57],SRA0:[2551.18,3628.35],SRA1:[1814.17,2551.18],SRA2:[1275.59,1814.17],SRA3:[907.09,1275.59],SRA4:[637.8,907.09],EXECUTIVE:[521.86,756],FOLIO:[612,936],LEGAL:[612,1008],LETTER:[612,792],TABLOID:[792,1224]},n}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e,r,i,a,o;o=n(163),e=o.PDFGradient,r=o.PDFLinearGradient,i=o.PDFRadialGradient,t.exports={initColor:function(){return this._opacityRegistry={},this._opacityCount=0,this._gradCount=0},_normalizeColor:function(t){var n,r;return t instanceof e?t:(\"string\"==typeof t&&(\"#\"===t.charAt(0)?(4===t.length&&(t=t.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i,\"#$1$1$2$2$3$3\")),n=parseInt(t.slice(1),16),t=[n>>16,n>>8&255,255&n]):a[t]&&(t=a[t])),Array.isArray(t)?(3===t.length?t=function(){var e,n,i;for(i=[],e=0,n=t.length;e<n;e++)r=t[e],i.push(r/255);return i}():4===t.length&&(t=function(){var e,n,i;for(i=[],e=0,n=t.length;e<n;e++)r=t[e],i.push(r/100);return i}()),t):null)},_setColor:function(t,n){var r,i;return!!(t=this._normalizeColor(t))&&(r=n?\"SCN\":\"scn\",t instanceof e?(this._setColorSpace(\"Pattern\",n),t.apply(r)):(i=4===t.length?\"DeviceCMYK\":\"DeviceRGB\",this._setColorSpace(i,n),t=t.join(\" \"),this.addContent(t+\" \"+r)),!0)},_setColorSpace:function(t,e){var n;return n=e?\"CS\":\"cs\",this.addContent(\"/\"+t+\" \"+n)},fillColor:function(t,e){return this._setColor(t,!1)&&this.fillOpacity(e),this._fillColor=[t,e],this},strokeColor:function(t,e){return this._setColor(t,!0)&&this.strokeOpacity(e),this},opacity:function(t){return this._doOpacity(t,t),this},fillOpacity:function(t){return this._doOpacity(t,null),this},strokeOpacity:function(t){return this._doOpacity(null,t),this},_doOpacity:function(t,e){var n,r,i,a;if(null!=t||null!=e)return null!=t&&(t=Math.max(0,Math.min(1,t))),null!=e&&(e=Math.max(0,Math.min(1,e))),r=t+\"_\"+e,this._opacityRegistry[r]?(n=(a=this._opacityRegistry[r])[0],i=a[1]):(n={Type:\"ExtGState\"},null!=t&&(n.ca=t),null!=e&&(n.CA=e),(n=this.ref(n)).end(),i=\"Gs\"+ ++this._opacityCount,this._opacityRegistry[r]=[n,i]),this.page.ext_gstates[i]=n,this.addContent(\"/\"+i+\" gs\")},linearGradient:function(t,e,n,i){return new r(this,t,e,n,i)},radialGradient:function(t,e,n,r,a,o){return new i(this,t,e,n,r,a,o)}},a={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],grey:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}}).call(this)},function(t,e){(function(){var e,n,r,i=function(t,e){for(var n in e)a.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t},a={}.hasOwnProperty;e=function(){function t(t){this.doc=t,this.stops=[],this.embedded=!1,this.transform=[1,0,0,1,0,0],this._colorSpace=\"DeviceRGB\"}return t.prototype.stop=function(t,e,n){return null==n&&(n=1),n=Math.max(0,Math.min(1,n)),this.stops.push([t,this.doc._normalizeColor(e),n]),this},t.prototype.setTransform=function(t,e,n,r,i,a){return this.transform=[t,e,n,r,i,a],this},t.prototype.embed=function(t){var e,n,r,i,a,o,s,l,u,c,h,f,d,p,g,y,v,b,m,w;if(0!==this.stops.length){for(this.embedded=!0,this.matrix=t,(c=this.stops[this.stops.length-1])[0]<1&&this.stops.push([1,c[1],c[2]]),e=[],n=[],m=[],s=l=0,g=this.stops.length-1;0<=g?l<g:l>g;s=0<=g?++l:--l)n.push(0,1),s+2!==this.stops.length&&e.push(this.stops[s+1][0]),r=this.doc.ref({FunctionType:2,Domain:[0,1],C0:this.stops[s+0][1],C1:this.stops[s+1][1],N:1}),m.push(r),r.end();if(1===m.length?r=m[0]:(r=this.doc.ref({FunctionType:3,Domain:[0,1],Functions:m,Bounds:e,Encode:n})).end(),this.id=\"Sh\"+ ++this.doc._gradCount,(v=this.shader(r)).end(),(p=this.doc.ref({Type:\"Pattern\",PatternType:2,Shading:v,Matrix:function(){var t,e,n,r;for(r=[],t=0,e=(n=this.matrix).length;t<e;t++)w=n[t],r.push(+w.toFixed(5));return r}.call(this)})).end(),this.stops.some(function(t){return t[2]<1})){for((a=this.opacityGradient())._colorSpace=\"DeviceGray\",u=0,h=(y=this.stops).length;u<h;u++)b=y[u],a.stop(b[0],[b[2]]);a=a.embed(this.matrix),d=[0,0,this.doc.page.width,this.doc.page.height],(i=this.doc.ref({Type:\"XObject\",Subtype:\"Form\",FormType:1,BBox:d,Group:{Type:\"Group\",S:\"Transparency\",CS:\"DeviceGray\"},Resources:{ProcSet:[\"PDF\",\"Text\",\"ImageB\",\"ImageC\",\"ImageI\"],Pattern:{Sh1:a}}})).write(\"/Pattern cs /Sh1 scn\"),i.end(d.join(\" \")+\" re f\"),(o=this.doc.ref({Type:\"ExtGState\",SMask:{Type:\"Mask\",S:\"Luminosity\",G:i}})).end(),(f=this.doc.ref({Type:\"Pattern\",PatternType:1,PaintType:1,TilingType:2,BBox:d,XStep:d[2],YStep:d[3],Resources:{ProcSet:[\"PDF\",\"Text\",\"ImageB\",\"ImageC\",\"ImageI\"],Pattern:{Sh1:p},ExtGState:{Gs1:o}}})).write(\"/Gs1 gs /Pattern cs /Sh1 scn\"),f.end(d.join(\" \")+\" re f\"),this.doc.page.patterns[this.id]=f}else this.doc.page.patterns[this.id]=p;return p}},t.prototype.apply=function(t){var e,n,r,i,a,o,s,l,u,c,h,f,d,p,g;return i=(p=this.doc._ctm.slice())[0],a=p[1],l=p[2],h=p[3],f=p[4],d=p[5],r=[i*(o=(g=this.transform)[0])+l*(s=g[1]),a*o+h*s,i*(u=g[2])+l*(c=g[3]),a*u+h*c,i*(e=g[4])+l*(n=g[5])+f,a*e+h*n+d],this.embedded&&r.join(\" \")===this.matrix.join(\" \")||this.embed(r),this.doc.addContent(\"/\"+this.id+\" \"+t)},t}(),n=function(t){function n(t,e,r,i,a){this.doc=t,this.x1=e,this.y1=r,this.x2=i,this.y2=a,n.__super__.constructor.apply(this,arguments)}return i(n,e),n.prototype.shader=function(t){return this.doc.ref({ShadingType:2,ColorSpace:this._colorSpace,Coords:[this.x1,this.y1,this.x2,this.y2],Function:t,Extend:[!0,!0]})},n.prototype.opacityGradient=function(){return new n(this.doc,this.x1,this.y1,this.x2,this.y2)},n}(),r=function(t){function n(t,e,r,i,a,o,s){this.doc=t,this.x1=e,this.y1=r,this.r1=i,this.x2=a,this.y2=o,this.r2=s,n.__super__.constructor.apply(this,arguments)}return i(n,e),n.prototype.shader=function(t){return this.doc.ref({ShadingType:3,ColorSpace:this._colorSpace,Coords:[this.x1,this.y1,this.r1,this.x2,this.y2,this.r2],Function:t,Extend:[!0,!0]})},n.prototype.opacityGradient=function(){return new n(this.doc,this.x1,this.y1,this.r1,this.x2,this.y2,this.r2)},n}(),t.exports={PDFGradient:e,PDFLinearGradient:n,PDFRadialGradient:r}}).call(this)},function(t,e,n){(function(){var e,r,i,a=[].slice;r=n(165),i=n(26).number,e=(Math.sqrt(2)-1)/3*4,t.exports={initVector:function(){return this._ctm=[1,0,0,1,0,0],this._ctmStack=[]},save:function(){return this._ctmStack.push(this._ctm.slice()),this.addContent(\"q\")},restore:function(){return this._ctm=this._ctmStack.pop()||[1,0,0,1,0,0],this.addContent(\"Q\")},closePath:function(){return this.addContent(\"h\")},lineWidth:function(t){return this.addContent(i(t)+\" w\")},_CAP_STYLES:{BUTT:0,ROUND:1,SQUARE:2},lineCap:function(t){return\"string\"==typeof t&&(t=this._CAP_STYLES[t.toUpperCase()]),this.addContent(t+\" J\")},_JOIN_STYLES:{MITER:0,ROUND:1,BEVEL:2},lineJoin:function(t){return\"string\"==typeof t&&(t=this._JOIN_STYLES[t.toUpperCase()]),this.addContent(t+\" j\")},miterLimit:function(t){return this.addContent(i(t)+\" M\")},dash:function(t,e){var n,r,a,o;return null==e&&(e={}),null==t?this:Array.isArray(t)?(t=function(){var e,n,r;for(r=[],e=0,n=t.length;e<n;e++)o=t[e],r.push(i(o));return r}().join(\" \"),n=e.phase||0,this.addContent(\"[\"+t+\"] \"+i(n)+\" d\")):(a=null!=(r=e.space)?r:t,n=e.phase||0,this.addContent(\"[\"+i(t)+\" \"+i(a)+\"] \"+i(n)+\" d\"))},undash:function(){return this.addContent(\"[] 0 d\")},moveTo:function(t,e){return this.addContent(i(t)+\" \"+i(e)+\" m\")},lineTo:function(t,e){return this.addContent(i(t)+\" \"+i(e)+\" l\")},bezierCurveTo:function(t,e,n,r,a,o){return this.addContent(i(t)+\" \"+i(e)+\" \"+i(n)+\" \"+i(r)+\" \"+i(a)+\" \"+i(o)+\" c\")},quadraticCurveTo:function(t,e,n,r){return this.addContent(i(t)+\" \"+i(e)+\" \"+i(n)+\" \"+i(r)+\" v\")},rect:function(t,e,n,r){return this.addContent(i(t)+\" \"+i(e)+\" \"+i(n)+\" \"+i(r)+\" re\")},roundedRect:function(t,n,r,i,a){var o;return null==a&&(a=0),o=(a=Math.min(a,.5*r,.5*i))*(1-e),this.moveTo(t+a,n),this.lineTo(t+r-a,n),this.bezierCurveTo(t+r-o,n,t+r,n+o,t+r,n+a),this.lineTo(t+r,n+i-a),this.bezierCurveTo(t+r,n+i-o,t+r-o,n+i,t+r-a,n+i),this.lineTo(t+a,n+i),this.bezierCurveTo(t+o,n+i,t,n+i-o,t,n+i-a),this.lineTo(t,n+a),this.bezierCurveTo(t,n+o,t+o,n,t+a,n),this.closePath()},ellipse:function(t,n,r,i){var a,o,s,l,u,c;return null==i&&(i=r),a=r*e,o=i*e,s=(t-=r)+2*r,u=(n-=i)+2*i,l=t+r,c=n+i,this.moveTo(t,c),this.bezierCurveTo(t,c-o,l-a,n,l,n),this.bezierCurveTo(l+a,n,s,c-o,s,c),this.bezierCurveTo(s,c+o,l+a,u,l,u),this.bezierCurveTo(l-a,u,t,c+o,t,c),this.closePath()},circle:function(t,e,n){return this.ellipse(t,e,n)},arc:function(t,n,r,i,a,o){var s,l,u,c,h,f,d,p,g,y,v,b,m,w,x,S,_;for(null==o&&(o=!1),l=2*Math.PI,s=.5*Math.PI,y=a-i,Math.abs(y)>l?y=l:0!==y&&o!==y<0&&(y=(o?-1:1)*l+y),m=(_=y/(x=Math.ceil(Math.abs(y)/s)))/s*e*r,g=i,v=-Math.sin(g)*m,b=Math.cos(g)*m,u=t+Math.cos(g)*r,c=n+Math.sin(g)*r,this.moveTo(u,c),w=0,S=x;0<=S?w<S:w>S;0<=S?++w:--w)h=u+v,f=c+b,g+=_,u=t+Math.cos(g)*r,c=n+Math.sin(g)*r,d=u-(v=-Math.sin(g)*m),p=c-(b=Math.cos(g)*m),this.bezierCurveTo(h,f,d,p,u,c);return this},polygon:function(){var t,e,n,r;for(r=1<=arguments.length?a.call(arguments,0):[],this.moveTo.apply(this,r.shift()),t=0,e=r.length;t<e;t++)n=r[t],this.lineTo.apply(this,n);return this.closePath()},path:function(t){return r.apply(this,t),this},_windingRule:function(t){return/even-?odd/.test(t)?\"*\":\"\"},fill:function(t,e){return/(even-?odd)|(non-?zero)/.test(t)&&(e=t,t=null),t&&this.fillColor(t),this.addContent(\"f\"+this._windingRule(e))},stroke:function(t){return t&&this.strokeColor(t),this.addContent(\"S\")},fillAndStroke:function(t,e,n){var r;return null==e&&(e=t),(r=/(even-?odd)|(non-?zero)/).test(t)&&(n=t,t=null),r.test(e)&&(n=e,e=t),t&&(this.fillColor(t),this.strokeColor(e)),this.addContent(\"B\"+this._windingRule(n))},clip:function(t){return this.addContent(\"W\"+this._windingRule(t)+\" n\")},transform:function(t,e,n,r,a,o){var s,l,u,c,h,f,d,p,g;return l=(s=this._ctm)[0],u=s[1],c=s[2],h=s[3],f=s[4],d=s[5],s[0]=l*t+c*e,s[1]=u*t+h*e,s[2]=l*n+c*r,s[3]=u*n+h*r,s[4]=l*a+c*o+f,s[5]=u*a+h*o+d,g=function(){var s,l,u,c;for(c=[],s=0,l=(u=[t,e,n,r,a,o]).length;s<l;s++)p=u[s],c.push(i(p));return c}().join(\" \"),this.addContent(g+\" cm\")},translate:function(t,e){return this.transform(1,0,0,1,t,e)},rotate:function(t,e){var n,r,i,a,o,s,l;return null==e&&(e={}),r=t*Math.PI/180,n=Math.cos(r),a=Math.sin(r),o=s=0,null!=e.origin&&(l=(o=(i=e.origin)[0])*a+(s=i[1])*n,o-=o*n-s*a,s-=l),this.transform(n,a,-a,n,o,s)},scale:function(t,e,n){var r,i,a;return null==e&&(e=t),null==n&&(n={}),\"object\"==typeof e&&(n=e,e=t),i=a=0,null!=n.origin&&(i=(r=n.origin)[0],a=r[1],i-=t*i,a-=e*a),this.transform(t,0,0,e,i,a)}}}).call(this)},function(t,e){(function(){var e;e=function(){var t,e,n,r,i,a,o,s,l,u,c,h,f;function d(){}return d.apply=function(e,n){var r;return r=a(n),t(r,e)},i={A:7,a:7,C:6,c:6,H:1,h:1,L:2,l:2,M:2,m:2,Q:4,q:4,S:4,s:4,T:2,t:2,V:1,v:1,Z:0,z:0},a=function(t){var e,n,r,a,o,s,l,u,c;for(c=[],e=[],a=\"\",o=!1,u=0,s=0,l=t.length;s<l;s++)if(n=t[s],null!=i[n])u=i[n],r&&(a.length>0&&(e[e.length]=+a),c[c.length]={cmd:r,args:e},e=[],a=\"\",o=!1),r=n;else if(\" \"===n||\",\"===n||\"-\"===n&&a.length>0&&\"e\"!==a[a.length-1]||\".\"===n&&o){if(0===a.length)continue;e.length===u?(c[c.length]={cmd:r,args:e},e=[+a],\"M\"===r&&(r=\"L\"),\"m\"===r&&(r=\"l\")):e[e.length]=+a,o=\".\"===n,a=\"-\"===n||\".\"===n?n:\"\"}else a+=n,\".\"===n&&(o=!0);return a.length>0&&(e.length===u?(c[c.length]={cmd:r,args:e},e=[+a],\"M\"===r&&(r=\"L\"),\"m\"===r&&(r=\"l\")):e[e.length]=+a),c[c.length]={cmd:r,args:e},c},n=r=o=s=h=f=0,t=function(t,e){var i,a,u,c,d;for(n=r=o=s=h=f=0,a=u=0,c=t.length;u<c;a=++u)i=t[a],\"function\"==typeof l[d=i.cmd]&&l[d](e,i.args);return n=r=o=s=0},l={M:function(t,e){return n=e[0],r=e[1],o=s=null,h=n,f=r,t.moveTo(n,r)},m:function(t,e){return n+=e[0],r+=e[1],o=s=null,h=n,f=r,t.moveTo(n,r)},C:function(t,e){return n=e[4],r=e[5],o=e[2],s=e[3],t.bezierCurveTo.apply(t,e)},c:function(t,e){return t.bezierCurveTo(e[0]+n,e[1]+r,e[2]+n,e[3]+r,e[4]+n,e[5]+r),o=n+e[2],s=r+e[3],n+=e[4],r+=e[5]},S:function(t,e){return null===o&&(o=n,s=r),t.bezierCurveTo(n-(o-n),r-(s-r),e[0],e[1],e[2],e[3]),o=e[0],s=e[1],n=e[2],r=e[3]},s:function(t,e){return null===o&&(o=n,s=r),t.bezierCurveTo(n-(o-n),r-(s-r),n+e[0],r+e[1],n+e[2],r+e[3]),o=n+e[0],s=r+e[1],n+=e[2],r+=e[3]},Q:function(t,e){return o=e[0],s=e[1],n=e[2],r=e[3],t.quadraticCurveTo(e[0],e[1],n,r)},q:function(t,e){return t.quadraticCurveTo(e[0]+n,e[1]+r,e[2]+n,e[3]+r),o=n+e[0],s=r+e[1],n+=e[2],r+=e[3]},T:function(t,e){return null===o?(o=n,s=r):(o=n-(o-n),s=r-(s-r)),t.quadraticCurveTo(o,s,e[0],e[1]),o=n-(o-n),s=r-(s-r),n=e[0],r=e[1]},t:function(t,e){return null===o?(o=n,s=r):(o=n-(o-n),s=r-(s-r)),t.quadraticCurveTo(o,s,n+e[0],r+e[1]),n+=e[0],r+=e[1]},A:function(t,e){return c(t,n,r,e),n=e[5],r=e[6]},a:function(t,e){return e[5]+=n,e[6]+=r,c(t,n,r,e),n=e[5],r=e[6]},L:function(t,e){return n=e[0],r=e[1],o=s=null,t.lineTo(n,r)},l:function(t,e){return n+=e[0],r+=e[1],o=s=null,t.lineTo(n,r)},H:function(t,e){return n=e[0],o=s=null,t.lineTo(n,r)},h:function(t,e){return n+=e[0],o=s=null,t.lineTo(n,r)},V:function(t,e){return r=e[0],o=s=null,t.lineTo(n,r)},v:function(t,e){return r+=e[0],o=s=null,t.lineTo(n,r)},Z:function(t){return t.closePath(),n=h,r=f},z:function(t){return t.closePath(),n=h,r=f}},c=function(t,n,r,i){var a,o,s,l,c,h,f,d,p,g,y,v,b;for(p=i[0],g=i[1],d=i[2],c=i[3],b=i[4],o=i[5],s=i[6],f=[],l=0,h=(v=e(o,s,p,g,c,b,d,n,r)).length;l<h;l++)y=v[l],a=u.apply(null,y),f.push(t.bezierCurveTo.apply(t,a));return f},e=function(t,e,n,r,i,a,l,u,c){var h,f,d,p,g,y,v,b,m,w,x,S,_,k,C,A,P,E,I,T,O,L,B,M,R;for(C=l*(Math.PI/180),k=Math.sin(C),g=Math.cos(C),n=Math.abs(n),r=Math.abs(r),(b=(o=g*(u-t)*.5+k*(c-e)*.5)*o/(n*n)+(s=g*(c-e)*.5-k*(u-t)*.5)*s/(r*r))>1&&(n*=b=Math.sqrt(b),r*=b),(_=1/(((O=(h=g/n)*t+(f=k/n)*e)-(T=h*u+f*c))*(O-T)+((M=(d=-k/r)*t+(p=g/r)*e)-(B=d*u+p*c))*(M-B))-.25)<0&&(_=0),S=Math.sqrt(_),a===i&&(S=-S),L=.5*(T+O)-S*(M-B),R=.5*(B+M)+S*(O-T),A=Math.atan2(B-R,T-L),(I=Math.atan2(M-R,O-L)-A)<0&&1===a?I+=2*Math.PI:I>0&&0===a&&(I-=2*Math.PI),w=[],y=v=0,m=x=Math.ceil(Math.abs(I/(.5*Math.PI+.001)));0<=m?v<m:v>m;y=0<=m?++v:--v)P=A+y*I/x,E=A+(y+1)*I/x,w[y]=[L,R,P,E,n,r,k,g];return w},u=function(t,e,n,r,i,a,o,s){var l,u,c,h,f,d,p,g,y,v,b,m;return l=s*i,u=-o*a,c=o*i,h=s*a,d=.5*(r-n),f=8/3*Math.sin(.5*d)*Math.sin(.5*d)/Math.sin(d),p=t+Math.cos(n)-f*Math.sin(n),v=e+Math.sin(n)+f*Math.cos(n),y=t+Math.cos(r),m=e+Math.sin(r),[l*p+u*v,c*p+h*v,l*(g=y+f*Math.sin(r))+u*(b=m-f*Math.cos(r)),c*g+h*b,l*y+u*m,c*y+h*m]},d}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e;e=n(50),t.exports={initFonts:function(){this._fontFamilies={},this._fontCount=0,this._fontSize=12,this._font=null,this._registeredFonts={}},font:function(t,n,r){var i,a,o,s;return\"number\"==typeof n&&(r=n,n=null),\"string\"==typeof t&&this._registeredFonts[t]?(i=t,t=(s=this._registeredFonts[t]).src,n=s.family):\"string\"!=typeof(i=n||t)&&(i=null),null!=r&&this.fontSize(r),(a=this._fontFamilies[i])?(this._font=a,this):(o=\"F\"+ ++this._fontCount,this._font=e.open(this,t,n,o),(a=this._fontFamilies[this._font.name])?(this._font=a,this):(i&&(this._fontFamilies[i]=this._font),this._font.name&&(this._fontFamilies[this._font.name]=this._font),this))},fontSize:function(t){return this._fontSize=t,this},currentLineHeight:function(t){return null==t&&(t=!1),this._font.lineHeight(this._fontSize,t)},registerFont:function(t,e,n){return this._registeredFonts[t]={src:e,family:n},this}}}).call(this)},function(t,e,n){\"use strict\";(function(e,r){function i(t){return t&&\"object\"==typeof t&&\"default\"in t?t.default:t}var a=i(n(168)),o=i(n(197)),s=i(n(60)),l=i(n(209)),u=i(n(212)),c=i(n(69)),h=i(n(74)),f=i(n(106)),d=i(n(107)),p=i(n(225)),g=i(n(236)),y=i(n(237)),v=n(12),b=i(n(245)),m=i(n(248)),w=i(n(251)),x=i(n(255)),S=i(n(258)),_=i(n(263)),k=i(n(269)),C=i(n(43)),A=i(n(271)),P=i(n(280)),E=i(n(283)),I=i(n(79)),T=i(n(284)),O={logErrors:!1},L=[];function B(t,e,n){if(n.get){var r=n.get;n.get=function(){var t=r.call(this);return h(this,e,{value:t}),t}}else if(\"function\"==typeof n.value){var i=n.value;return{get:function(){var t=new p;function n(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];var a=n.length>0?n[0]:\"value\";if(t.has(a))return t.get(a);var o=i.apply(this,n);return t.set(a,o),o}return h(this,e,{value:n}),n}}}}O.registerFormat=function(t){L.push(t)},O.openSync=function(t,e){var r=n(8).readFileSync(t);return O.create(r,e)},O.open=function(t,e,r){\"function\"==typeof e&&(r=e,e=null),n(8).readFile(t,function(t,n){if(t)return r(t);try{var i=O.create(n,e)}catch(t){return r(t)}return r(null,i)})},O.create=function(t,e){for(var n=0;n<L.length;n++){var r=L[n];if(r.probe(t)){var i=new r(new a.DecodeStream(t));return e?i.getFont(e):i}}throw new Error(\"Unknown font format\")};var M=new a.Struct({firstCode:a.uint16,entryCount:a.uint16,idDelta:a.int16,idRangeOffset:a.uint16}),R=new a.Struct({startCharCode:a.uint32,endCharCode:a.uint32,glyphID:a.uint32}),F=new a.Struct({startUnicodeValue:a.uint24,additionalCount:a.uint8}),D=new a.Struct({unicodeValue:a.uint24,glyphID:a.uint16}),z=new a.Array(F,a.uint32),N=new a.Array(D,a.uint32),U=new a.Struct({varSelector:a.uint24,defaultUVS:new a.Pointer(a.uint32,z,{type:\"parent\"}),nonDefaultUVS:new a.Pointer(a.uint32,N,{type:\"parent\"})}),W=new a.VersionedStruct(a.uint16,{0:{length:a.uint16,language:a.uint16,codeMap:new a.LazyArray(a.uint8,256)},2:{length:a.uint16,language:a.uint16,subHeaderKeys:new a.Array(a.uint16,256),subHeaderCount:function(t){return Math.max.apply(Math,t.subHeaderKeys)},subHeaders:new a.LazyArray(M,\"subHeaderCount\"),glyphIndexArray:new a.LazyArray(a.uint16,\"subHeaderCount\")},4:{length:a.uint16,language:a.uint16,segCountX2:a.uint16,segCount:function(t){return t.segCountX2>>1},searchRange:a.uint16,entrySelector:a.uint16,rangeShift:a.uint16,endCode:new a.LazyArray(a.uint16,\"segCount\"),reservedPad:new a.Reserved(a.uint16),startCode:new a.LazyArray(a.uint16,\"segCount\"),idDelta:new a.LazyArray(a.int16,\"segCount\"),idRangeOffset:new a.LazyArray(a.uint16,\"segCount\"),glyphIndexArray:new a.LazyArray(a.uint16,function(t){return(t.length-t._currentOffset)/2})},6:{length:a.uint16,language:a.uint16,firstCode:a.uint16,entryCount:a.uint16,glyphIndices:new a.LazyArray(a.uint16,\"entryCount\")},8:{reserved:new a.Reserved(a.uint16),length:a.uint32,language:a.uint16,is32:new a.LazyArray(a.uint8,8192),nGroups:a.uint32,groups:new a.LazyArray(R,\"nGroups\")},10:{reserved:new a.Reserved(a.uint16),length:a.uint32,language:a.uint32,firstCode:a.uint32,entryCount:a.uint32,glyphIndices:new a.LazyArray(a.uint16,\"numChars\")},12:{reserved:new a.Reserved(a.uint16),length:a.uint32,language:a.uint32,nGroups:a.uint32,groups:new a.LazyArray(R,\"nGroups\")},13:{reserved:new a.Reserved(a.uint16),length:a.uint32,language:a.uint32,nGroups:a.uint32,groups:new a.LazyArray(R,\"nGroups\")},14:{length:a.uint32,numRecords:a.uint32,varSelectors:new a.LazyArray(U,\"numRecords\")}}),G=new a.Struct({platformID:a.uint16,encodingID:a.uint16,table:new a.Pointer(a.uint32,W,{type:\"parent\",lazy:!0})}),V=new a.Struct({version:a.uint16,numSubtables:a.uint16,tables:new a.Array(G,\"numSubtables\")}),j=new a.Struct({version:a.int32,revision:a.int32,checkSumAdjustment:a.uint32,magicNumber:a.uint32,flags:a.uint16,unitsPerEm:a.uint16,created:new a.Array(a.int32,2),modified:new a.Array(a.int32,2),xMin:a.int16,yMin:a.int16,xMax:a.int16,yMax:a.int16,macStyle:new a.Bitfield(a.uint16,[\"bold\",\"italic\",\"underline\",\"outline\",\"shadow\",\"condensed\",\"extended\"]),lowestRecPPEM:a.uint16,fontDirectionHint:a.int16,indexToLocFormat:a.int16,glyphDataFormat:a.int16}),H=new a.Struct({version:a.int32,ascent:a.int16,descent:a.int16,lineGap:a.int16,advanceWidthMax:a.uint16,minLeftSideBearing:a.int16,minRightSideBearing:a.int16,xMaxExtent:a.int16,caretSlopeRise:a.int16,caretSlopeRun:a.int16,caretOffset:a.int16,reserved:new a.Reserved(a.int16,4),metricDataFormat:a.int16,numberOfMetrics:a.uint16}),q=new a.Struct({advance:a.uint16,bearing:a.int16}),Z=new a.Struct({metrics:new a.LazyArray(q,function(t){return t.parent.hhea.numberOfMetrics}),bearings:new a.LazyArray(a.int16,function(t){return t.parent.maxp.numGlyphs-t.parent.hhea.numberOfMetrics})}),Y=new a.Struct({version:a.int32,numGlyphs:a.uint16,maxPoints:a.uint16,maxContours:a.uint16,maxComponentPoints:a.uint16,maxComponentContours:a.uint16,maxZones:a.uint16,maxTwilightPoints:a.uint16,maxStorage:a.uint16,maxFunctionDefs:a.uint16,maxInstructionDefs:a.uint16,maxStackElements:a.uint16,maxSizeOfInstructions:a.uint16,maxComponentElements:a.uint16,maxComponentDepth:a.uint16});function X(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;return 1===t&&J[n]?J[n]:K[t][e]}var K=[[\"utf16be\",\"utf16be\",\"utf16be\",\"utf16be\",\"utf16be\",\"utf16be\"],[\"macroman\",\"shift-jis\",\"big5\",\"euc-kr\",\"iso-8859-6\",\"iso-8859-8\",\"macgreek\",\"maccyrillic\",\"symbol\",\"Devanagari\",\"Gurmukhi\",\"Gujarati\",\"Oriya\",\"Bengali\",\"Tamil\",\"Telugu\",\"Kannada\",\"Malayalam\",\"Sinhalese\",\"Burmese\",\"Khmer\",\"macthai\",\"Laotian\",\"Georgian\",\"Armenian\",\"gb-2312-80\",\"Tibetan\",\"Mongolian\",\"Geez\",\"maccenteuro\",\"Vietnamese\",\"Sindhi\"],[\"ascii\"],[\"symbol\",\"utf16be\",\"shift-jis\",\"gb18030\",\"big5\",\"wansung\",\"johab\",null,null,null,\"utf16be\"]],J={15:\"maciceland\",17:\"macturkish\",18:\"maccroatian\",24:\"maccenteuro\",25:\"maccenteuro\",26:\"maccenteuro\",27:\"maccenteuro\",28:\"maccenteuro\",30:\"maciceland\",37:\"macromania\",38:\"maccenteuro\",39:\"maccenteuro\",40:\"maccenteuro\",143:\"macinuit\",146:\"macgaelic\"},Q=[[],{0:\"en\",30:\"fo\",60:\"ks\",90:\"rw\",1:\"fr\",31:\"fa\",61:\"ku\",91:\"rn\",2:\"de\",32:\"ru\",62:\"sd\",92:\"ny\",3:\"it\",33:\"zh\",63:\"bo\",93:\"mg\",4:\"nl\",34:\"nl-BE\",64:\"ne\",94:\"eo\",5:\"sv\",35:\"ga\",65:\"sa\",128:\"cy\",6:\"es\",36:\"sq\",66:\"mr\",129:\"eu\",7:\"da\",37:\"ro\",67:\"bn\",130:\"ca\",8:\"pt\",38:\"cz\",68:\"as\",131:\"la\",9:\"no\",39:\"sk\",69:\"gu\",132:\"qu\",10:\"he\",40:\"si\",70:\"pa\",133:\"gn\",11:\"ja\",41:\"yi\",71:\"or\",134:\"ay\",12:\"ar\",42:\"sr\",72:\"ml\",135:\"tt\",13:\"fi\",43:\"mk\",73:\"kn\",136:\"ug\",14:\"el\",44:\"bg\",74:\"ta\",137:\"dz\",15:\"is\",45:\"uk\",75:\"te\",138:\"jv\",16:\"mt\",46:\"be\",76:\"si\",139:\"su\",17:\"tr\",47:\"uz\",77:\"my\",140:\"gl\",18:\"hr\",48:\"kk\",78:\"km\",141:\"af\",19:\"zh-Hant\",49:\"az-Cyrl\",79:\"lo\",142:\"br\",20:\"ur\",50:\"az-Arab\",80:\"vi\",143:\"iu\",21:\"hi\",51:\"hy\",81:\"id\",144:\"gd\",22:\"th\",52:\"ka\",82:\"tl\",145:\"gv\",23:\"ko\",53:\"mo\",83:\"ms\",146:\"ga\",24:\"lt\",54:\"ky\",84:\"ms-Arab\",147:\"to\",25:\"pl\",55:\"tg\",85:\"am\",148:\"el-polyton\",26:\"hu\",56:\"tk\",86:\"ti\",149:\"kl\",27:\"es\",57:\"mn-CN\",87:\"om\",150:\"az\",28:\"lv\",58:\"mn\",88:\"so\",151:\"nn\",29:\"se\",59:\"ps\",89:\"sw\"},[],{1078:\"af\",16393:\"en-IN\",1159:\"rw\",1074:\"tn\",1052:\"sq\",6153:\"en-IE\",1089:\"sw\",1115:\"si\",1156:\"gsw\",8201:\"en-JM\",1111:\"kok\",1051:\"sk\",1118:\"am\",17417:\"en-MY\",1042:\"ko\",1060:\"sl\",5121:\"ar-DZ\",5129:\"en-NZ\",1088:\"ky\",11274:\"es-AR\",15361:\"ar-BH\",13321:\"en-PH\",1108:\"lo\",16394:\"es-BO\",3073:\"ar\",18441:\"en-SG\",1062:\"lv\",13322:\"es-CL\",2049:\"ar-IQ\",7177:\"en-ZA\",1063:\"lt\",9226:\"es-CO\",11265:\"ar-JO\",11273:\"en-TT\",2094:\"dsb\",5130:\"es-CR\",13313:\"ar-KW\",2057:\"en-GB\",1134:\"lb\",7178:\"es-DO\",12289:\"ar-LB\",1033:\"en\",1071:\"mk\",12298:\"es-EC\",4097:\"ar-LY\",12297:\"en-ZW\",2110:\"ms-BN\",17418:\"es-SV\",6145:\"ary\",1061:\"et\",1086:\"ms\",4106:\"es-GT\",8193:\"ar-OM\",1080:\"fo\",1100:\"ml\",18442:\"es-HN\",16385:\"ar-QA\",1124:\"fil\",1082:\"mt\",2058:\"es-MX\",1025:\"ar-SA\",1035:\"fi\",1153:\"mi\",19466:\"es-NI\",10241:\"ar-SY\",2060:\"fr-BE\",1146:\"arn\",6154:\"es-PA\",7169:\"aeb\",3084:\"fr-CA\",1102:\"mr\",15370:\"es-PY\",14337:\"ar-AE\",1036:\"fr\",1148:\"moh\",10250:\"es-PE\",9217:\"ar-YE\",5132:\"fr-LU\",1104:\"mn\",20490:\"es-PR\",1067:\"hy\",6156:\"fr-MC\",2128:\"mn-CN\",3082:\"es\",1101:\"as\",4108:\"fr-CH\",1121:\"ne\",1034:\"es\",2092:\"az-Cyrl\",1122:\"fy\",1044:\"nb\",21514:\"es-US\",1068:\"az\",1110:\"gl\",2068:\"nn\",14346:\"es-UY\",1133:\"ba\",1079:\"ka\",1154:\"oc\",8202:\"es-VE\",1069:\"eu\",3079:\"de-AT\",1096:\"or\",2077:\"sv-FI\",1059:\"be\",1031:\"de\",1123:\"ps\",1053:\"sv\",2117:\"bn\",5127:\"de-LI\",1045:\"pl\",1114:\"syr\",1093:\"bn-IN\",4103:\"de-LU\",1046:\"pt\",1064:\"tg\",8218:\"bs-Cyrl\",2055:\"de-CH\",2070:\"pt-PT\",2143:\"tzm\",5146:\"bs\",1032:\"el\",1094:\"pa\",1097:\"ta\",1150:\"br\",1135:\"kl\",1131:\"qu-BO\",1092:\"tt\",1026:\"bg\",1095:\"gu\",2155:\"qu-EC\",1098:\"te\",1027:\"ca\",1128:\"ha\",3179:\"qu\",1054:\"th\",3076:\"zh-HK\",1037:\"he\",1048:\"ro\",1105:\"bo\",5124:\"zh-MO\",1081:\"hi\",1047:\"rm\",1055:\"tr\",2052:\"zh\",1038:\"hu\",1049:\"ru\",1090:\"tk\",4100:\"zh-SG\",1039:\"is\",9275:\"smn\",1152:\"ug\",1028:\"zh-TW\",1136:\"ig\",4155:\"smj-NO\",1058:\"uk\",1155:\"co\",1057:\"id\",5179:\"smj\",1070:\"hsb\",1050:\"hr\",1117:\"iu\",3131:\"se-FI\",1056:\"ur\",4122:\"hr-BA\",2141:\"iu-Latn\",1083:\"se\",2115:\"uz-Cyrl\",1029:\"cs\",2108:\"ga\",2107:\"se-SE\",1091:\"uz\",1030:\"da\",1076:\"xh\",8251:\"sms\",1066:\"vi\",1164:\"prs\",1077:\"zu\",6203:\"sma-NO\",1106:\"cy\",1125:\"dv\",1040:\"it\",7227:\"sms\",1160:\"wo\",2067:\"nl-BE\",2064:\"it-CH\",1103:\"sa\",1157:\"sah\",1043:\"nl\",1041:\"ja\",7194:\"sr-Cyrl-BA\",1144:\"ii\",3081:\"en-AU\",1099:\"kn\",3098:\"sr\",1130:\"yo\",10249:\"en-BZ\",1087:\"kk\",6170:\"sr-Latn-BA\",4105:\"en-CA\",1107:\"km\",2074:\"sr-Latn\",9225:\"en-029\",1158:\"quc\",1132:\"nso\"}],$=new a.Struct({platformID:a.uint16,encodingID:a.uint16,languageID:a.uint16,nameID:a.uint16,length:a.uint16,string:new a.Pointer(a.uint16,new a.String(\"length\",function(t){return X(t.platformID,t.encodingID,t.languageID)}),{type:\"parent\",relativeTo:\"parent.stringOffset\",allowNull:!1})}),tt=new a.Struct({length:a.uint16,tag:new a.Pointer(a.uint16,new a.String(\"length\",\"utf16be\"),{type:\"parent\",relativeTo:\"stringOffset\"})}),NameTable=new a.VersionedStruct(a.uint16,{0:{count:a.uint16,stringOffset:a.uint16,records:new a.Array($,\"count\")},1:{count:a.uint16,stringOffset:a.uint16,records:new a.Array($,\"count\"),langTagCount:a.uint16,langTags:new a.Array(tt,\"langTagCount\")}}),et=[\"copyright\",\"fontFamily\",\"fontSubfamily\",\"uniqueSubfamily\",\"fullName\",\"version\",\"postscriptName\",\"trademark\",\"manufacturer\",\"designer\",\"description\",\"vendorURL\",\"designerURL\",\"license\",\"licenseURL\",null,\"preferredFamily\",\"preferredSubfamily\",\"compatibleFull\",\"sampleText\",\"postscriptCIDFontName\",\"wwsFamilyName\",\"wwsSubfamilyName\"];NameTable.process=function(t){var e={},n=this.records,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=Q[o.platformID][o.languageID];null==l&&null!=this.langTags&&o.languageID>=32768&&(l=this.langTags[o.languageID-32768].tag),null==l&&(l=o.platformID+\"-\"+o.languageID);var u=o.nameID>=256?\"fontFeatures\":et[o.nameID]||o.nameID;null==e[u]&&(e[u]={});var c=e[u];o.nameID>=256&&(c=c[o.nameID]||(c[o.nameID]={})),\"string\"!=typeof o.string&&\"string\"==typeof c[l]||(c[l]=o.string)}this.records=e},NameTable.preEncode=function(){if(!Array.isArray(this.records)){this.version=0;var t=[];for(var n in this.records){var r=this.records[n];\"fontFeatures\"!==n&&(t.push({platformID:3,encodingID:1,languageID:1033,nameID:et.indexOf(n),length:e.byteLength(r.en,\"utf16le\"),string:r.en}),\"postscriptName\"===n&&t.push({platformID:1,encodingID:0,languageID:0,nameID:et.indexOf(n),length:r.en.length,string:r.en}))}this.records=t,this.count=t.length,this.stringOffset=NameTable.size(this,null,!1)}};var nt=new a.VersionedStruct(a.uint16,{header:{xAvgCharWidth:a.int16,usWeightClass:a.uint16,usWidthClass:a.uint16,fsType:new a.Bitfield(a.uint16,[null,\"noEmbedding\",\"viewOnly\",\"editable\",null,null,null,null,\"noSubsetting\",\"bitmapOnly\"]),ySubscriptXSize:a.int16,ySubscriptYSize:a.int16,ySubscriptXOffset:a.int16,ySubscriptYOffset:a.int16,ySuperscriptXSize:a.int16,ySuperscriptYSize:a.int16,ySuperscriptXOffset:a.int16,ySuperscriptYOffset:a.int16,yStrikeoutSize:a.int16,yStrikeoutPosition:a.int16,sFamilyClass:a.int16,panose:new a.Array(a.uint8,10),ulCharRange:new a.Array(a.uint32,4),vendorID:new a.String(4),fsSelection:new a.Bitfield(a.uint16,[\"italic\",\"underscore\",\"negative\",\"outlined\",\"strikeout\",\"bold\",\"regular\",\"useTypoMetrics\",\"wws\",\"oblique\"]),usFirstCharIndex:a.uint16,usLastCharIndex:a.uint16},0:{},1:{typoAscender:a.int16,typoDescender:a.int16,typoLineGap:a.int16,winAscent:a.uint16,winDescent:a.uint16,codePageRange:new a.Array(a.uint32,2)},2:{typoAscender:a.int16,typoDescender:a.int16,typoLineGap:a.int16,winAscent:a.uint16,winDescent:a.uint16,codePageRange:new a.Array(a.uint32,2),xHeight:a.int16,capHeight:a.int16,defaultChar:a.uint16,breakChar:a.uint16,maxContent:a.uint16},5:{typoAscender:a.int16,typoDescender:a.int16,typoLineGap:a.int16,winAscent:a.uint16,winDescent:a.uint16,codePageRange:new a.Array(a.uint32,2),xHeight:a.int16,capHeight:a.int16,defaultChar:a.uint16,breakChar:a.uint16,maxContent:a.uint16,usLowerOpticalPointSize:a.uint16,usUpperOpticalPointSize:a.uint16}}),rt=nt.versions;rt[3]=rt[4]=rt[2];var it=new a.VersionedStruct(a.fixed32,{header:{italicAngle:a.fixed32,underlinePosition:a.int16,underlineThickness:a.int16,isFixedPitch:a.uint32,minMemType42:a.uint32,maxMemType42:a.uint32,minMemType1:a.uint32,maxMemType1:a.uint32},1:{},2:{numberOfGlyphs:a.uint16,glyphNameIndex:new a.Array(a.uint16,\"numberOfGlyphs\"),names:new a.Array(new a.String(a.uint8))},2.5:{numberOfGlyphs:a.uint16,offsets:new a.Array(a.uint8,\"numberOfGlyphs\")},3:{},4:{map:new a.Array(a.uint32,function(t){return t.parent.maxp.numGlyphs})}}),at=new a.Struct({controlValues:new a.Array(a.int16)}),ot=new a.Struct({instructions:new a.Array(a.uint8)}),st=new a.VersionedStruct(\"head.indexToLocFormat\",{0:{offsets:new a.Array(a.uint16)},1:{offsets:new a.Array(a.uint32)}});st.process=function(){if(0===this.version)for(var t=0;t<this.offsets.length;t++)this.offsets[t]<<=1},st.preEncode=function(){if(null==this.version&&(this.version=this.offsets[this.offsets.length-1]>65535?1:0,0===this.version))for(var t=0;t<this.offsets.length;t++)this.offsets[t]>>>=1};var lt=new a.Struct({controlValueProgram:new a.Array(a.uint8)}),ut=new a.Array(new a.Buffer),ct=function(){function t(e){f(this,t),this.type=e}return t.prototype.getCFFVersion=function(t){for(;t&&!t.hdrSize;)t=t.parent;return t?t.version:-1},t.prototype.decode=function(t,e){var n=this.getCFFVersion(e)>=2?t.readUInt32BE():t.readUInt16BE();if(0===n)return[];var r=t.readUInt8(),i=void 0;if(1===r)i=a.uint8;else if(2===r)i=a.uint16;else if(3===r)i=a.uint24;else{if(4!==r)throw new Error(\"Bad offset size in CFFIndex: \"+r+\" \"+t.pos);i=a.uint32}for(var o=[],s=t.pos+(n+1)*r-1,l=i.decode(t),u=0;u<n;u++){var c=i.decode(t);if(null!=this.type){var h=t.pos;t.pos=s+l,e.length=c-l,o.push(this.type.decode(t,e)),t.pos=h}else o.push({offset:s+l,length:c-l});l=c}return t.pos=s+l,o},t.prototype.size=function(t,e){var n=2;if(0===t.length)return n;for(var r=this.type||new a.Buffer,i=1,o=0;o<t.length;o++){var s=t[o];i+=r.size(s,e)}var l=void 0;if(i<=255)l=a.uint8;else if(i<=65535)l=a.uint16;else if(i<=16777215)l=a.uint24;else{if(!(i<=4294967295))throw new Error(\"Bad offset in CFFIndex\");l=a.uint32}return n+=1+l.size()*(t.length+1),n+=i-1,n},t.prototype.encode=function(t,e,n){if(t.writeUInt16BE(e.length),0!==e.length){var r=this.type||new a.Buffer,i=[],o=1,l=e,u=Array.isArray(l),c=0;for(l=u?l:s(l);;){var h;if(u){if(c>=l.length)break;h=l[c++]}else{if((c=l.next()).done)break;h=c.value}var f=h,d=r.size(f,n);i.push(d),o+=d}var p=void 0;if(o<=255)p=a.uint8;else if(o<=65535)p=a.uint16;else if(o<=16777215)p=a.uint24;else{if(!(o<=4294967295))throw new Error(\"Bad offset in CFFIndex\");p=a.uint32}t.writeUInt8(p.size()),o=1,p.encode(t,o);var g=i,y=Array.isArray(g),v=0;for(g=y?g:s(g);;){var b;if(y){if(v>=g.length)break;b=g[v++]}else{if((v=g.next()).done)break;b=v.value}o+=b,p.encode(t,o)}var m=e,w=Array.isArray(m),x=0;for(m=w?m:s(m);;){var S;if(w){if(x>=m.length)break;S=m[x++]}else{if((x=m.next()).done)break;S=x.value}var _=S;r.encode(t,_,n)}}},t}(),ht=[\"0\",\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\".\",\"E\",\"E-\",null,\"-\"],ft={\".\":10,E:11,\"E-\":12,\"-\":14},dt=function(){function t(){f(this,t)}return t.decode=function(t,e){if(32<=e&&e<=246)return e-139;if(247<=e&&e<=250)return 256*(e-247)+t.readUInt8()+108;if(251<=e&&e<=254)return 256*-(e-251)-t.readUInt8()-108;if(28===e)return t.readInt16BE();if(29===e)return t.readInt32BE();if(30===e){for(var n=\"\";;){var r=t.readUInt8(),i=r>>4;if(15===i)break;n+=ht[i];var a=15&r;if(15===a)break;n+=ht[a]}return parseFloat(n)}return null},t.size=function(t){if(t.forceLarge&&(t=32768),(0|t)!==t){var e=\"\"+t;return 1+Math.ceil((e.length+1)/2)}return-107<=t&&t<=107?1:108<=t&&t<=1131||-1131<=t&&t<=-108?2:-32768<=t&&t<=32767?3:5},t.encode=function(t,e){var n=Number(e);if(e.forceLarge)return t.writeUInt8(29),t.writeInt32BE(n);if((0|n)===n)return-107<=n&&n<=107?t.writeUInt8(n+139):108<=n&&n<=1131?(n-=108,t.writeUInt8(247+(n>>8)),t.writeUInt8(255&n)):-1131<=n&&n<=-108?(n=-n-108,t.writeUInt8(251+(n>>8)),t.writeUInt8(255&n)):-32768<=n&&n<=32767?(t.writeUInt8(28),t.writeInt16BE(n)):(t.writeUInt8(29),t.writeInt32BE(n));t.writeUInt8(30);for(var r=\"\"+n,i=0;i<r.length;i+=2){var a=r[i],o=ft[a]||+a;if(i===r.length-1)var s=15;else{var l=r[i+1];s=ft[l]||+l}t.writeUInt8(o<<4|15&s)}return 15!==s?t.writeUInt8(240):void 0},t}(),pt=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];f(this,t),this.ops=e,this.fields={};var n=e,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=Array.isArray(o[0])?o[0][0]<<8|o[0][1]:o[0];this.fields[l]=o}}return t.prototype.decodeOperands=function(t,e,n,r){var i=this;if(Array.isArray(t))return r.map(function(r,a){return i.decodeOperands(t[a],e,n,[r])});if(null!=t.decode)return t.decode(e,n,r);switch(t){case\"number\":case\"offset\":case\"sid\":return r[0];case\"boolean\":return!!r[0];default:return r}},t.prototype.encodeOperands=function(t,e,n,r){var i=this;return Array.isArray(t)?r.map(function(r,a){return i.encodeOperands(t[a],e,n,r)[0]}):null!=t.encode?t.encode(e,r,n):\"number\"==typeof r?[r]:\"boolean\"==typeof r?[+r]:Array.isArray(r)?r:[r]},t.prototype.decode=function(t,e){var n=t.pos+e.length,r={},i=[];for(var a in b(r,{parent:{value:e},_startOffset:{value:t.pos}}),this.fields){var o=this.fields[a];r[o[1]]=o[3]}for(;t.pos<n;){var s=t.readUInt8();if(s<28){12===s&&(s=s<<8|t.readUInt8());var l=this.fields[s];if(!l)throw new Error(\"Unknown operator \"+s);var u=this.decodeOperands(l[2],t,r,i);null!=u&&(u instanceof v.PropertyDescriptor?h(r,l[1],u):r[l[1]]=u),i=[]}else i.push(dt.decode(t,s))}return r},t.prototype.size=function(t,e){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r={parent:e,val:t,pointerSize:0,startOffset:e.startOffset||0},i=0;for(var a in this.fields){var o=this.fields[a],l=t[o[1]];if(null!=l&&!m(l,o[3])){var u=this.encodeOperands(o[2],null,r,l),c=Array.isArray(u),h=0;for(u=c?u:s(u);;){var f;if(c){if(h>=u.length)break;f=u[h++]}else{if((h=u.next()).done)break;f=h.value}var d=f;i+=dt.size(d)}i+=(Array.isArray(o[0])?o[0]:[o[0]]).length}}return n&&(i+=r.pointerSize),i},t.prototype.encode=function(t,e,n){var r={pointers:[],startOffset:t.pos,parent:n,val:e,pointerSize:0};r.pointerOffset=t.pos+this.size(e,r,!1);var i=this.ops,a=Array.isArray(i),o=0;for(i=a?i:s(i);;){var l;if(a){if(o>=i.length)break;l=i[o++]}else{if((o=i.next()).done)break;l=o.value}var u=l,c=e[u[1]];if(null!=c&&!m(c,u[3])){var h=this.encodeOperands(u[2],t,r,c),f=Array.isArray(h),d=0;for(h=f?h:s(h);;){var p;if(f){if(d>=h.length)break;p=h[d++]}else{if((d=h.next()).done)break;p=d.value}var g=p;dt.encode(t,g)}var y=Array.isArray(u[0])?u[0]:[u[0]],v=Array.isArray(y),b=0;for(y=v?y:s(y);;){var w;if(v){if(b>=y.length)break;w=y[b++]}else{if((b=y.next()).done)break;w=b.value}var x=w;t.writeUInt8(x)}}}for(var S=0;S<r.pointers.length;){var _=r.pointers[S++];_.type.encode(t,_.val,_.parent)}},t}(),gt=function(t){function e(n){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return f(this,e),null==r.type&&(r.type=\"global\"),g(this,t.call(this,null,n,r))}return y(e,t),e.prototype.decode=function(e,n,r){return this.offsetType={decode:function(){return r[0]}},t.prototype.decode.call(this,e,n,r)},e.prototype.encode=function(e,n,r){if(!e)return this.offsetType={size:function(){return 0}},this.size(n,r),[new yt(0)];var i=null;return this.offsetType={encode:function(t,e){return i=e}},t.prototype.encode.call(this,e,n,r),[new yt(i)]},e}(a.Pointer),yt=function(){function t(e){f(this,t),this.val=e,this.forceLarge=!0}return t.prototype.valueOf=function(){return this.val},t}(),vt=new pt([[6,\"BlueValues\",\"delta\",null],[7,\"OtherBlues\",\"delta\",null],[8,\"FamilyBlues\",\"delta\",null],[9,\"FamilyOtherBlues\",\"delta\",null],[[12,9],\"BlueScale\",\"number\",.039625],[[12,10],\"BlueShift\",\"number\",7],[[12,11],\"BlueFuzz\",\"number\",1],[10,\"StdHW\",\"number\",null],[11,\"StdVW\",\"number\",null],[[12,12],\"StemSnapH\",\"delta\",null],[[12,13],\"StemSnapV\",\"delta\",null],[[12,14],\"ForceBold\",\"boolean\",!1],[[12,17],\"LanguageGroup\",\"number\",0],[[12,18],\"ExpansionFactor\",\"number\",.06],[[12,19],\"initialRandomSeed\",\"number\",0],[20,\"defaultWidthX\",\"number\",0],[21,\"nominalWidthX\",\"number\",0],[22,\"vsindex\",\"number\",0],[23,\"blend\",function(){function t(){f(this,t)}return t.decode=function(t,e,n){for(var r=n.pop();n.length>r;)n.pop()},t}(),null],[19,\"Subrs\",new gt(new ct,{type:\"local\"}),null]]),bt=[\".notdef\",\"space\",\"exclam\",\"quotedbl\",\"numbersign\",\"dollar\",\"percent\",\"ampersand\",\"quoteright\",\"parenleft\",\"parenright\",\"asterisk\",\"plus\",\"comma\",\"hyphen\",\"period\",\"slash\",\"zero\",\"one\",\"two\",\"three\",\"four\",\"five\",\"six\",\"seven\",\"eight\",\"nine\",\"colon\",\"semicolon\",\"less\",\"equal\",\"greater\",\"question\",\"at\",\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\",\"bracketleft\",\"backslash\",\"bracketright\",\"asciicircum\",\"underscore\",\"quoteleft\",\"a\",\"b\",\"c\",\"d\",\"e\",\"f\",\"g\",\"h\",\"i\",\"j\",\"k\",\"l\",\"m\",\"n\",\"o\",\"p\",\"q\",\"r\",\"s\",\"t\",\"u\",\"v\",\"w\",\"x\",\"y\",\"z\",\"braceleft\",\"bar\",\"braceright\",\"asciitilde\",\"exclamdown\",\"cent\",\"sterling\",\"fraction\",\"yen\",\"florin\",\"section\",\"currency\",\"quotesingle\",\"quotedblleft\",\"guillemotleft\",\"guilsinglleft\",\"guilsinglright\",\"fi\",\"fl\",\"endash\",\"dagger\",\"daggerdbl\",\"periodcentered\",\"paragraph\",\"bullet\",\"quotesinglbase\",\"quotedblbase\",\"quotedblright\",\"guillemotright\",\"ellipsis\",\"perthousand\",\"questiondown\",\"grave\",\"acute\",\"circumflex\",\"tilde\",\"macron\",\"breve\",\"dotaccent\",\"dieresis\",\"ring\",\"cedilla\",\"hungarumlaut\",\"ogonek\",\"caron\",\"emdash\",\"AE\",\"ordfeminine\",\"Lslash\",\"Oslash\",\"OE\",\"ordmasculine\",\"ae\",\"dotlessi\",\"lslash\",\"oslash\",\"oe\",\"germandbls\",\"onesuperior\",\"logicalnot\",\"mu\",\"trademark\",\"Eth\",\"onehalf\",\"plusminus\",\"Thorn\",\"onequarter\",\"divide\",\"brokenbar\",\"degree\",\"thorn\",\"threequarters\",\"twosuperior\",\"registered\",\"minus\",\"eth\",\"multiply\",\"threesuperior\",\"copyright\",\"Aacute\",\"Acircumflex\",\"Adieresis\",\"Agrave\",\"Aring\",\"Atilde\",\"Ccedilla\",\"Eacute\",\"Ecircumflex\",\"Edieresis\",\"Egrave\",\"Iacute\",\"Icircumflex\",\"Idieresis\",\"Igrave\",\"Ntilde\",\"Oacute\",\"Ocircumflex\",\"Odieresis\",\"Ograve\",\"Otilde\",\"Scaron\",\"Uacute\",\"Ucircumflex\",\"Udieresis\",\"Ugrave\",\"Yacute\",\"Ydieresis\",\"Zcaron\",\"aacute\",\"acircumflex\",\"adieresis\",\"agrave\",\"aring\",\"atilde\",\"ccedilla\",\"eacute\",\"ecircumflex\",\"edieresis\",\"egrave\",\"iacute\",\"icircumflex\",\"idieresis\",\"igrave\",\"ntilde\",\"oacute\",\"ocircumflex\",\"odieresis\",\"ograve\",\"otilde\",\"scaron\",\"uacute\",\"ucircumflex\",\"udieresis\",\"ugrave\",\"yacute\",\"ydieresis\",\"zcaron\",\"exclamsmall\",\"Hungarumlautsmall\",\"dollaroldstyle\",\"dollarsuperior\",\"ampersandsmall\",\"Acutesmall\",\"parenleftsuperior\",\"parenrightsuperior\",\"twodotenleader\",\"onedotenleader\",\"zerooldstyle\",\"oneoldstyle\",\"twooldstyle\",\"threeoldstyle\",\"fouroldstyle\",\"fiveoldstyle\",\"sixoldstyle\",\"sevenoldstyle\",\"eightoldstyle\",\"nineoldstyle\",\"commasuperior\",\"threequartersemdash\",\"periodsuperior\",\"questionsmall\",\"asuperior\",\"bsuperior\",\"centsuperior\",\"dsuperior\",\"esuperior\",\"isuperior\",\"lsuperior\",\"msuperior\",\"nsuperior\",\"osuperior\",\"rsuperior\",\"ssuperior\",\"tsuperior\",\"ff\",\"ffi\",\"ffl\",\"parenleftinferior\",\"parenrightinferior\",\"Circumflexsmall\",\"hyphensuperior\",\"Gravesmall\",\"Asmall\",\"Bsmall\",\"Csmall\",\"Dsmall\",\"Esmall\",\"Fsmall\",\"Gsmall\",\"Hsmall\",\"Ismall\",\"Jsmall\",\"Ksmall\",\"Lsmall\",\"Msmall\",\"Nsmall\",\"Osmall\",\"Psmall\",\"Qsmall\",\"Rsmall\",\"Ssmall\",\"Tsmall\",\"Usmall\",\"Vsmall\",\"Wsmall\",\"Xsmall\",\"Ysmall\",\"Zsmall\",\"colonmonetary\",\"onefitted\",\"rupiah\",\"Tildesmall\",\"exclamdownsmall\",\"centoldstyle\",\"Lslashsmall\",\"Scaronsmall\",\"Zcaronsmall\",\"Dieresissmall\",\"Brevesmall\",\"Caronsmall\",\"Dotaccentsmall\",\"Macronsmall\",\"figuredash\",\"hypheninferior\",\"Ogoneksmall\",\"Ringsmall\",\"Cedillasmall\",\"questiondownsmall\",\"oneeighth\",\"threeeighths\",\"fiveeighths\",\"seveneighths\",\"onethird\",\"twothirds\",\"zerosuperior\",\"foursuperior\",\"fivesuperior\",\"sixsuperior\",\"sevensuperior\",\"eightsuperior\",\"ninesuperior\",\"zeroinferior\",\"oneinferior\",\"twoinferior\",\"threeinferior\",\"fourinferior\",\"fiveinferior\",\"sixinferior\",\"seveninferior\",\"eightinferior\",\"nineinferior\",\"centinferior\",\"dollarinferior\",\"periodinferior\",\"commainferior\",\"Agravesmall\",\"Aacutesmall\",\"Acircumflexsmall\",\"Atildesmall\",\"Adieresissmall\",\"Aringsmall\",\"AEsmall\",\"Ccedillasmall\",\"Egravesmall\",\"Eacutesmall\",\"Ecircumflexsmall\",\"Edieresissmall\",\"Igravesmall\",\"Iacutesmall\",\"Icircumflexsmall\",\"Idieresissmall\",\"Ethsmall\",\"Ntildesmall\",\"Ogravesmall\",\"Oacutesmall\",\"Ocircumflexsmall\",\"Otildesmall\",\"Odieresissmall\",\"OEsmall\",\"Oslashsmall\",\"Ugravesmall\",\"Uacutesmall\",\"Ucircumflexsmall\",\"Udieresissmall\",\"Yacutesmall\",\"Thornsmall\",\"Ydieresissmall\",\"001.000\",\"001.001\",\"001.002\",\"001.003\",\"Black\",\"Bold\",\"Book\",\"Light\",\"Medium\",\"Regular\",\"Roman\",\"Semibold\"],mt=[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"space\",\"exclam\",\"quotedbl\",\"numbersign\",\"dollar\",\"percent\",\"ampersand\",\"quoteright\",\"parenleft\",\"parenright\",\"asterisk\",\"plus\",\"comma\",\"hyphen\",\"period\",\"slash\",\"zero\",\"one\",\"two\",\"three\",\"four\",\"five\",\"six\",\"seven\",\"eight\",\"nine\",\"colon\",\"semicolon\",\"less\",\"equal\",\"greater\",\"question\",\"at\",\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\",\"bracketleft\",\"backslash\",\"bracketright\",\"asciicircum\",\"underscore\",\"quoteleft\",\"a\",\"b\",\"c\",\"d\",\"e\",\"f\",\"g\",\"h\",\"i\",\"j\",\"k\",\"l\",\"m\",\"n\",\"o\",\"p\",\"q\",\"r\",\"s\",\"t\",\"u\",\"v\",\"w\",\"x\",\"y\",\"z\",\"braceleft\",\"bar\",\"braceright\",\"asciitilde\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"exclamdown\",\"cent\",\"sterling\",\"fraction\",\"yen\",\"florin\",\"section\",\"currency\",\"quotesingle\",\"quotedblleft\",\"guillemotleft\",\"guilsinglleft\",\"guilsinglright\",\"fi\",\"fl\",\"\",\"endash\",\"dagger\",\"daggerdbl\",\"periodcentered\",\"\",\"paragraph\",\"bullet\",\"quotesinglbase\",\"quotedblbase\",\"quotedblright\",\"guillemotright\",\"ellipsis\",\"perthousand\",\"\",\"questiondown\",\"\",\"grave\",\"acute\",\"circumflex\",\"tilde\",\"macron\",\"breve\",\"dotaccent\",\"dieresis\",\"\",\"ring\",\"cedilla\",\"\",\"hungarumlaut\",\"ogonek\",\"caron\",\"emdash\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"AE\",\"\",\"ordfeminine\",\"\",\"\",\"\",\"\",\"Lslash\",\"Oslash\",\"OE\",\"ordmasculine\",\"\",\"\",\"\",\"\",\"\",\"ae\",\"\",\"\",\"\",\"dotlessi\",\"\",\"\",\"lslash\",\"oslash\",\"oe\",\"germandbls\"],wt=[\".notdef\",\"space\",\"exclam\",\"quotedbl\",\"numbersign\",\"dollar\",\"percent\",\"ampersand\",\"quoteright\",\"parenleft\",\"parenright\",\"asterisk\",\"plus\",\"comma\",\"hyphen\",\"period\",\"slash\",\"zero\",\"one\",\"two\",\"three\",\"four\",\"five\",\"six\",\"seven\",\"eight\",\"nine\",\"colon\",\"semicolon\",\"less\",\"equal\",\"greater\",\"question\",\"at\",\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\",\"bracketleft\",\"backslash\",\"bracketright\",\"asciicircum\",\"underscore\",\"quoteleft\",\"a\",\"b\",\"c\",\"d\",\"e\",\"f\",\"g\",\"h\",\"i\",\"j\",\"k\",\"l\",\"m\",\"n\",\"o\",\"p\",\"q\",\"r\",\"s\",\"t\",\"u\",\"v\",\"w\",\"x\",\"y\",\"z\",\"braceleft\",\"bar\",\"braceright\",\"asciitilde\",\"exclamdown\",\"cent\",\"sterling\",\"fraction\",\"yen\",\"florin\",\"section\",\"currency\",\"quotesingle\",\"quotedblleft\",\"guillemotleft\",\"guilsinglleft\",\"guilsinglright\",\"fi\",\"fl\",\"endash\",\"dagger\",\"daggerdbl\",\"periodcentered\",\"paragraph\",\"bullet\",\"quotesinglbase\",\"quotedblbase\",\"quotedblright\",\"guillemotright\",\"ellipsis\",\"perthousand\",\"questiondown\",\"grave\",\"acute\",\"circumflex\",\"tilde\",\"macron\",\"breve\",\"dotaccent\",\"dieresis\",\"ring\",\"cedilla\",\"hungarumlaut\",\"ogonek\",\"caron\",\"emdash\",\"AE\",\"ordfeminine\",\"Lslash\",\"Oslash\",\"OE\",\"ordmasculine\",\"ae\",\"dotlessi\",\"lslash\",\"oslash\",\"oe\",\"germandbls\",\"onesuperior\",\"logicalnot\",\"mu\",\"trademark\",\"Eth\",\"onehalf\",\"plusminus\",\"Thorn\",\"onequarter\",\"divide\",\"brokenbar\",\"degree\",\"thorn\",\"threequarters\",\"twosuperior\",\"registered\",\"minus\",\"eth\",\"multiply\",\"threesuperior\",\"copyright\",\"Aacute\",\"Acircumflex\",\"Adieresis\",\"Agrave\",\"Aring\",\"Atilde\",\"Ccedilla\",\"Eacute\",\"Ecircumflex\",\"Edieresis\",\"Egrave\",\"Iacute\",\"Icircumflex\",\"Idieresis\",\"Igrave\",\"Ntilde\",\"Oacute\",\"Ocircumflex\",\"Odieresis\",\"Ograve\",\"Otilde\",\"Scaron\",\"Uacute\",\"Ucircumflex\",\"Udieresis\",\"Ugrave\",\"Yacute\",\"Ydieresis\",\"Zcaron\",\"aacute\",\"acircumflex\",\"adieresis\",\"agrave\",\"aring\",\"atilde\",\"ccedilla\",\"eacute\",\"ecircumflex\",\"edieresis\",\"egrave\",\"iacute\",\"icircumflex\",\"idieresis\",\"igrave\",\"ntilde\",\"oacute\",\"ocircumflex\",\"odieresis\",\"ograve\",\"otilde\",\"scaron\",\"uacute\",\"ucircumflex\",\"udieresis\",\"ugrave\",\"yacute\",\"ydieresis\",\"zcaron\"],xt=new a.Struct({reserved:new a.Reserved(a.uint16),reqFeatureIndex:a.uint16,featureCount:a.uint16,featureIndexes:new a.Array(a.uint16,\"featureCount\")}),St=new a.Struct({tag:new a.String(4),langSys:new a.Pointer(a.uint16,xt,{type:\"parent\"})}),_t=new a.Struct({defaultLangSys:new a.Pointer(a.uint16,xt),count:a.uint16,langSysRecords:new a.Array(St,\"count\")}),kt=new a.Struct({tag:new a.String(4),script:new a.Pointer(a.uint16,_t,{type:\"parent\"})}),Ct=new a.Array(kt,a.uint16),At=new a.Struct({featureParams:a.uint16,lookupCount:a.uint16,lookupListIndexes:new a.Array(a.uint16,\"lookupCount\")}),Pt=new a.Struct({tag:new a.String(4),feature:new a.Pointer(a.uint16,At,{type:\"parent\"})}),Et=new a.Array(Pt,a.uint16),It=new a.Struct({markAttachmentType:a.uint8,flags:new a.Bitfield(a.uint8,[\"rightToLeft\",\"ignoreBaseGlyphs\",\"ignoreLigatures\",\"ignoreMarks\",\"useMarkFilteringSet\"])});function Tt(t){var e=new a.Struct({lookupType:a.uint16,flags:It,subTableCount:a.uint16,subTables:new a.Array(new a.Pointer(a.uint16,t),\"subTableCount\"),markFilteringSet:new a.Optional(a.uint16,function(t){return t.flags.flags.useMarkFilteringSet})});return new a.LazyArray(new a.Pointer(a.uint16,e),a.uint16)}var Ot,Lt=new a.Struct({start:a.uint16,end:a.uint16,startCoverageIndex:a.uint16}),Bt=new a.VersionedStruct(a.uint16,{1:{glyphCount:a.uint16,glyphs:new a.Array(a.uint16,\"glyphCount\")},2:{rangeCount:a.uint16,rangeRecords:new a.Array(Lt,\"rangeCount\")}}),Mt=new a.Struct({start:a.uint16,end:a.uint16,class:a.uint16}),Rt=new a.VersionedStruct(a.uint16,{1:{startGlyph:a.uint16,glyphCount:a.uint16,classValueArray:new a.Array(a.uint16,\"glyphCount\")},2:{classRangeCount:a.uint16,classRangeRecord:new a.Array(Mt,\"classRangeCount\")}}),Ft=new a.Struct({a:a.uint16,b:a.uint16,deltaFormat:a.uint16}),Dt=new a.Struct({sequenceIndex:a.uint16,lookupListIndex:a.uint16}),zt=new a.Struct({glyphCount:a.uint16,lookupCount:a.uint16,input:new a.Array(a.uint16,function(t){return t.glyphCount-1}),lookupRecords:new a.Array(Dt,\"lookupCount\")}),Nt=new a.Array(new a.Pointer(a.uint16,zt),a.uint16),Ut=new a.Struct({glyphCount:a.uint16,lookupCount:a.uint16,classes:new a.Array(a.uint16,function(t){return t.glyphCount-1}),lookupRecords:new a.Array(Dt,\"lookupCount\")}),Wt=new a.Array(new a.Pointer(a.uint16,Ut),a.uint16),Gt=new a.VersionedStruct(a.uint16,{1:{coverage:new a.Pointer(a.uint16,Bt),ruleSetCount:a.uint16,ruleSets:new a.Array(new a.Pointer(a.uint16,Nt),\"ruleSetCount\")},2:{coverage:new a.Pointer(a.uint16,Bt),classDef:new a.Pointer(a.uint16,Rt),classSetCnt:a.uint16,classSet:new a.Array(new a.Pointer(a.uint16,Wt),\"classSetCnt\")},3:{glyphCount:a.uint16,lookupCount:a.uint16,coverages:new a.Array(new a.Pointer(a.uint16,Bt),\"glyphCount\"),lookupRecords:new a.Array(Dt,\"lookupCount\")}}),Vt=new a.Struct({backtrackGlyphCount:a.uint16,backtrack:new a.Array(a.uint16,\"backtrackGlyphCount\"),inputGlyphCount:a.uint16,input:new a.Array(a.uint16,function(t){return t.inputGlyphCount-1}),lookaheadGlyphCount:a.uint16,lookahead:new a.Array(a.uint16,\"lookaheadGlyphCount\"),lookupCount:a.uint16,lookupRecords:new a.Array(Dt,\"lookupCount\")}),jt=new a.Array(new a.Pointer(a.uint16,Vt),a.uint16),Ht=new a.VersionedStruct(a.uint16,{1:{coverage:new a.Pointer(a.uint16,Bt),chainCount:a.uint16,chainRuleSets:new a.Array(new a.Pointer(a.uint16,jt),\"chainCount\")},2:{coverage:new a.Pointer(a.uint16,Bt),backtrackClassDef:new a.Pointer(a.uint16,Rt),inputClassDef:new a.Pointer(a.uint16,Rt),lookaheadClassDef:new a.Pointer(a.uint16,Rt),chainCount:a.uint16,chainClassSet:new a.Array(new a.Pointer(a.uint16,jt),\"chainCount\")},3:{backtrackGlyphCount:a.uint16,backtrackCoverage:new a.Array(new a.Pointer(a.uint16,Bt),\"backtrackGlyphCount\"),inputGlyphCount:a.uint16,inputCoverage:new a.Array(new a.Pointer(a.uint16,Bt),\"inputGlyphCount\"),lookaheadGlyphCount:a.uint16,lookaheadCoverage:new a.Array(new a.Pointer(a.uint16,Bt),\"lookaheadGlyphCount\"),lookupCount:a.uint16,lookupRecords:new a.Array(Dt,\"lookupCount\")}}),qt=new a.Fixed(16,\"BE\",14),Zt=new a.Struct({startCoord:qt,peakCoord:qt,endCoord:qt}),Yt=new a.Struct({axisCount:a.uint16,regionCount:a.uint16,variationRegions:new a.Array(new a.Array(Zt,\"axisCount\"),\"regionCount\")}),Xt=new a.Struct({shortDeltas:new a.Array(a.int16,function(t){return t.parent.shortDeltaCount}),regionDeltas:new a.Array(a.int8,function(t){return t.parent.regionIndexCount-t.parent.shortDeltaCount}),deltas:function(t){return t.shortDeltas.concat(t.regionDeltas)}}),Kt=new a.Struct({itemCount:a.uint16,shortDeltaCount:a.uint16,regionIndexCount:a.uint16,regionIndexes:new a.Array(a.uint16,\"regionIndexCount\"),deltaSets:new a.Array(Xt,\"itemCount\")}),Jt=new a.Struct({format:a.uint16,variationRegionList:new a.Pointer(a.uint32,Yt),variationDataCount:a.uint16,itemVariationData:new a.Array(new a.Pointer(a.uint32,Kt),\"variationDataCount\")}),Qt=new a.VersionedStruct(a.uint16,{1:(Ot={axisIndex:a.uint16},Ot.axisIndex=a.uint16,Ot.filterRangeMinValue=qt,Ot.filterRangeMaxValue=qt,Ot)}),$t=new a.Struct({conditionCount:a.uint16,conditionTable:new a.Array(new a.Pointer(a.uint32,Qt),\"conditionCount\")}),te=new a.Struct({featureIndex:a.uint16,alternateFeatureTable:new a.Pointer(a.uint32,At,{type:\"parent\"})}),ee=new a.Struct({version:a.fixed32,substitutionCount:a.uint16,substitutions:new a.Array(te,\"substitutionCount\")}),ne=new a.Struct({conditionSet:new a.Pointer(a.uint32,$t,{type:\"parent\"}),featureTableSubstitution:new a.Pointer(a.uint32,ee,{type:\"parent\"})}),re=new a.Struct({majorVersion:a.uint16,minorVersion:a.uint16,featureVariationRecordCount:a.uint32,featureVariationRecords:new a.Array(ne,\"featureVariationRecordCount\")}),ie=function(){function t(e,n){f(this,t),this.predefinedOps=e,this.type=n}return t.prototype.decode=function(t,e,n){return this.predefinedOps[n[0]]?this.predefinedOps[n[0]]:this.type.decode(t,e,n)},t.prototype.size=function(t,e){return this.type.size(t,e)},t.prototype.encode=function(t,e,n){var r=this.predefinedOps.indexOf(e);return-1!==r?r:this.type.encode(t,e,n)},t}(),ae=function(t){function e(){return f(this,e),g(this,t.call(this,\"UInt8\"))}return y(e,t),e.prototype.decode=function(t){return 127&a.uint8.decode(t)},e}(a.Number),oe=new a.Struct({first:a.uint16,nLeft:a.uint8}),se=new a.Struct({first:a.uint16,nLeft:a.uint16}),le=new ie([mt,[\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"space\",\"exclamsmall\",\"Hungarumlautsmall\",\"\",\"dollaroldstyle\",\"dollarsuperior\",\"ampersandsmall\",\"Acutesmall\",\"parenleftsuperior\",\"parenrightsuperior\",\"twodotenleader\",\"onedotenleader\",\"comma\",\"hyphen\",\"period\",\"fraction\",\"zerooldstyle\",\"oneoldstyle\",\"twooldstyle\",\"threeoldstyle\",\"fouroldstyle\",\"fiveoldstyle\",\"sixoldstyle\",\"sevenoldstyle\",\"eightoldstyle\",\"nineoldstyle\",\"colon\",\"semicolon\",\"commasuperior\",\"threequartersemdash\",\"periodsuperior\",\"questionsmall\",\"\",\"asuperior\",\"bsuperior\",\"centsuperior\",\"dsuperior\",\"esuperior\",\"\",\"\",\"isuperior\",\"\",\"\",\"lsuperior\",\"msuperior\",\"nsuperior\",\"osuperior\",\"\",\"\",\"rsuperior\",\"ssuperior\",\"tsuperior\",\"\",\"ff\",\"fi\",\"fl\",\"ffi\",\"ffl\",\"parenleftinferior\",\"\",\"parenrightinferior\",\"Circumflexsmall\",\"hyphensuperior\",\"Gravesmall\",\"Asmall\",\"Bsmall\",\"Csmall\",\"Dsmall\",\"Esmall\",\"Fsmall\",\"Gsmall\",\"Hsmall\",\"Ismall\",\"Jsmall\",\"Ksmall\",\"Lsmall\",\"Msmall\",\"Nsmall\",\"Osmall\",\"Psmall\",\"Qsmall\",\"Rsmall\",\"Ssmall\",\"Tsmall\",\"Usmall\",\"Vsmall\",\"Wsmall\",\"Xsmall\",\"Ysmall\",\"Zsmall\",\"colonmonetary\",\"onefitted\",\"rupiah\",\"Tildesmall\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"\",\"exclamdownsmall\",\"centoldstyle\",\"Lslashsmall\",\"\",\"\",\"Scaronsmall\",\"Zcaronsmall\",\"Dieresissmall\",\"Brevesmall\",\"Caronsmall\",\"\",\"Dotaccentsmall\",\"\",\"\",\"Macronsmall\",\"\",\"\",\"figuredash\",\"hypheninferior\",\"\",\"\",\"Ogoneksmall\",\"Ringsmall\",\"Cedillasmall\",\"\",\"\",\"\",\"onequarter\",\"onehalf\",\"threequarters\",\"questiondownsmall\",\"oneeighth\",\"threeeighths\",\"fiveeighths\",\"seveneighths\",\"onethird\",\"twothirds\",\"\",\"\",\"zerosuperior\",\"onesuperior\",\"twosuperior\",\"threesuperior\",\"foursuperior\",\"fivesuperior\",\"sixsuperior\",\"sevensuperior\",\"eightsuperior\",\"ninesuperior\",\"zeroinferior\",\"oneinferior\",\"twoinferior\",\"threeinferior\",\"fourinferior\",\"fiveinferior\",\"sixinferior\",\"seveninferior\",\"eightinferior\",\"nineinferior\",\"centinferior\",\"dollarinferior\",\"periodinferior\",\"commainferior\",\"Agravesmall\",\"Aacutesmall\",\"Acircumflexsmall\",\"Atildesmall\",\"Adieresissmall\",\"Aringsmall\",\"AEsmall\",\"Ccedillasmall\",\"Egravesmall\",\"Eacutesmall\",\"Ecircumflexsmall\",\"Edieresissmall\",\"Igravesmall\",\"Iacutesmall\",\"Icircumflexsmall\",\"Idieresissmall\",\"Ethsmall\",\"Ntildesmall\",\"Ogravesmall\",\"Oacutesmall\",\"Ocircumflexsmall\",\"Otildesmall\",\"Odieresissmall\",\"OEsmall\",\"Oslashsmall\",\"Ugravesmall\",\"Uacutesmall\",\"Ucircumflexsmall\",\"Udieresissmall\",\"Yacutesmall\",\"Thornsmall\",\"Ydieresissmall\"]],new gt(new a.VersionedStruct(new ae,{0:{nCodes:a.uint8,codes:new a.Array(a.uint8,\"nCodes\")},1:{nRanges:a.uint8,ranges:new a.Array(oe,\"nRanges\")}}),{lazy:!0})),ue=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype.decode=function(t,e){for(var n=v.resolveLength(this.length,t,e),r=0,i=[];r<n;){var a=this.type.decode(t,e);a.offset=r,r+=a.nLeft+1,i.push(a)}return i},e}(a.Array),ce=new ie([wt,[\".notdef\",\"space\",\"exclamsmall\",\"Hungarumlautsmall\",\"dollaroldstyle\",\"dollarsuperior\",\"ampersandsmall\",\"Acutesmall\",\"parenleftsuperior\",\"parenrightsuperior\",\"twodotenleader\",\"onedotenleader\",\"comma\",\"hyphen\",\"period\",\"fraction\",\"zerooldstyle\",\"oneoldstyle\",\"twooldstyle\",\"threeoldstyle\",\"fouroldstyle\",\"fiveoldstyle\",\"sixoldstyle\",\"sevenoldstyle\",\"eightoldstyle\",\"nineoldstyle\",\"colon\",\"semicolon\",\"commasuperior\",\"threequartersemdash\",\"periodsuperior\",\"questionsmall\",\"asuperior\",\"bsuperior\",\"centsuperior\",\"dsuperior\",\"esuperior\",\"isuperior\",\"lsuperior\",\"msuperior\",\"nsuperior\",\"osuperior\",\"rsuperior\",\"ssuperior\",\"tsuperior\",\"ff\",\"fi\",\"fl\",\"ffi\",\"ffl\",\"parenleftinferior\",\"parenrightinferior\",\"Circumflexsmall\",\"hyphensuperior\",\"Gravesmall\",\"Asmall\",\"Bsmall\",\"Csmall\",\"Dsmall\",\"Esmall\",\"Fsmall\",\"Gsmall\",\"Hsmall\",\"Ismall\",\"Jsmall\",\"Ksmall\",\"Lsmall\",\"Msmall\",\"Nsmall\",\"Osmall\",\"Psmall\",\"Qsmall\",\"Rsmall\",\"Ssmall\",\"Tsmall\",\"Usmall\",\"Vsmall\",\"Wsmall\",\"Xsmall\",\"Ysmall\",\"Zsmall\",\"colonmonetary\",\"onefitted\",\"rupiah\",\"Tildesmall\",\"exclamdownsmall\",\"centoldstyle\",\"Lslashsmall\",\"Scaronsmall\",\"Zcaronsmall\",\"Dieresissmall\",\"Brevesmall\",\"Caronsmall\",\"Dotaccentsmall\",\"Macronsmall\",\"figuredash\",\"hypheninferior\",\"Ogoneksmall\",\"Ringsmall\",\"Cedillasmall\",\"onequarter\",\"onehalf\",\"threequarters\",\"questiondownsmall\",\"oneeighth\",\"threeeighths\",\"fiveeighths\",\"seveneighths\",\"onethird\",\"twothirds\",\"zerosuperior\",\"onesuperior\",\"twosuperior\",\"threesuperior\",\"foursuperior\",\"fivesuperior\",\"sixsuperior\",\"sevensuperior\",\"eightsuperior\",\"ninesuperior\",\"zeroinferior\",\"oneinferior\",\"twoinferior\",\"threeinferior\",\"fourinferior\",\"fiveinferior\",\"sixinferior\",\"seveninferior\",\"eightinferior\",\"nineinferior\",\"centinferior\",\"dollarinferior\",\"periodinferior\",\"commainferior\",\"Agravesmall\",\"Aacutesmall\",\"Acircumflexsmall\",\"Atildesmall\",\"Adieresissmall\",\"Aringsmall\",\"AEsmall\",\"Ccedillasmall\",\"Egravesmall\",\"Eacutesmall\",\"Ecircumflexsmall\",\"Edieresissmall\",\"Igravesmall\",\"Iacutesmall\",\"Icircumflexsmall\",\"Idieresissmall\",\"Ethsmall\",\"Ntildesmall\",\"Ogravesmall\",\"Oacutesmall\",\"Ocircumflexsmall\",\"Otildesmall\",\"Odieresissmall\",\"OEsmall\",\"Oslashsmall\",\"Ugravesmall\",\"Uacutesmall\",\"Ucircumflexsmall\",\"Udieresissmall\",\"Yacutesmall\",\"Thornsmall\",\"Ydieresissmall\"],[\".notdef\",\"space\",\"dollaroldstyle\",\"dollarsuperior\",\"parenleftsuperior\",\"parenrightsuperior\",\"twodotenleader\",\"onedotenleader\",\"comma\",\"hyphen\",\"period\",\"fraction\",\"zerooldstyle\",\"oneoldstyle\",\"twooldstyle\",\"threeoldstyle\",\"fouroldstyle\",\"fiveoldstyle\",\"sixoldstyle\",\"sevenoldstyle\",\"eightoldstyle\",\"nineoldstyle\",\"colon\",\"semicolon\",\"commasuperior\",\"threequartersemdash\",\"periodsuperior\",\"asuperior\",\"bsuperior\",\"centsuperior\",\"dsuperior\",\"esuperior\",\"isuperior\",\"lsuperior\",\"msuperior\",\"nsuperior\",\"osuperior\",\"rsuperior\",\"ssuperior\",\"tsuperior\",\"ff\",\"fi\",\"fl\",\"ffi\",\"ffl\",\"parenleftinferior\",\"parenrightinferior\",\"hyphensuperior\",\"colonmonetary\",\"onefitted\",\"rupiah\",\"centoldstyle\",\"figuredash\",\"hypheninferior\",\"onequarter\",\"onehalf\",\"threequarters\",\"oneeighth\",\"threeeighths\",\"fiveeighths\",\"seveneighths\",\"onethird\",\"twothirds\",\"zerosuperior\",\"onesuperior\",\"twosuperior\",\"threesuperior\",\"foursuperior\",\"fivesuperior\",\"sixsuperior\",\"sevensuperior\",\"eightsuperior\",\"ninesuperior\",\"zeroinferior\",\"oneinferior\",\"twoinferior\",\"threeinferior\",\"fourinferior\",\"fiveinferior\",\"sixinferior\",\"seveninferior\",\"eightinferior\",\"nineinferior\",\"centinferior\",\"dollarinferior\",\"periodinferior\",\"commainferior\"]],new gt(new a.VersionedStruct(a.uint8,{0:{glyphs:new a.Array(a.uint16,function(t){return t.parent.CharStrings.length-1})},1:{ranges:new ue(oe,function(t){return t.parent.CharStrings.length-1})},2:{ranges:new ue(se,function(t){return t.parent.CharStrings.length-1})}}),{lazy:!0})),he=new a.Struct({first:a.uint16,fd:a.uint8}),fe=new a.Struct({first:a.uint32,fd:a.uint16}),de=new a.VersionedStruct(a.uint8,{0:{fds:new a.Array(a.uint8,function(t){return t.parent.CharStrings.length})},3:{nRanges:a.uint16,ranges:new a.Array(he,\"nRanges\"),sentinel:a.uint16},4:{nRanges:a.uint32,ranges:new a.Array(fe,\"nRanges\"),sentinel:a.uint32}}),pe=new gt(vt),ge=function(){function t(){f(this,t)}return t.prototype.decode=function(t,e,n){return e.length=n[0],pe.decode(t,e,[n[1]])},t.prototype.size=function(t,e){return[vt.size(t,e,!1),pe.size(t,e)[0]]},t.prototype.encode=function(t,e,n){return[vt.size(e,n,!1),pe.encode(t,e,n)[0]]},t}(),ye=new pt([[18,\"Private\",new ge,null],[[12,38],\"FontName\",\"sid\",null]]),ve=new pt([[[12,30],\"ROS\",[\"sid\",\"sid\",\"number\"],null],[0,\"version\",\"sid\",null],[1,\"Notice\",\"sid\",null],[[12,0],\"Copyright\",\"sid\",null],[2,\"FullName\",\"sid\",null],[3,\"FamilyName\",\"sid\",null],[4,\"Weight\",\"sid\",null],[[12,1],\"isFixedPitch\",\"boolean\",!1],[[12,2],\"ItalicAngle\",\"number\",0],[[12,3],\"UnderlinePosition\",\"number\",-100],[[12,4],\"UnderlineThickness\",\"number\",50],[[12,5],\"PaintType\",\"number\",0],[[12,6],\"CharstringType\",\"number\",2],[[12,7],\"FontMatrix\",\"array\",[.001,0,0,.001,0,0]],[13,\"UniqueID\",\"number\",null],[5,\"FontBBox\",\"array\",[0,0,0,0]],[[12,8],\"StrokeWidth\",\"number\",0],[14,\"XUID\",\"array\",null],[15,\"charset\",ce,wt],[16,\"Encoding\",le,mt],[17,\"CharStrings\",new gt(new ct),null],[18,\"Private\",new ge,null],[[12,20],\"SyntheticBase\",\"number\",null],[[12,21],\"PostScript\",\"sid\",null],[[12,22],\"BaseFontName\",\"sid\",null],[[12,23],\"BaseFontBlend\",\"delta\",null],[[12,31],\"CIDFontVersion\",\"number\",0],[[12,32],\"CIDFontRevision\",\"number\",0],[[12,33],\"CIDFontType\",\"number\",0],[[12,34],\"CIDCount\",\"number\",8720],[[12,35],\"UIDBase\",\"number\",null],[[12,37],\"FDSelect\",new gt(de),null],[[12,36],\"FDArray\",new gt(new ct(ye)),null],[[12,38],\"FontName\",\"sid\",null]]),be=new a.Struct({length:a.uint16,itemVariationStore:Jt}),me=new pt([[[12,7],\"FontMatrix\",\"array\",[.001,0,0,.001,0,0]],[17,\"CharStrings\",new gt(new ct),null],[[12,37],\"FDSelect\",new gt(de),null],[[12,36],\"FDArray\",new gt(new ct(ye)),null],[24,\"vstore\",new gt(be),null],[25,\"maxstack\",\"number\",193]]),we=new a.VersionedStruct(a.fixed16,{1:{hdrSize:a.uint8,offSize:a.uint8,nameIndex:new ct(new a.String(\"length\")),topDictIndex:new ct(ve),stringIndex:new ct(new a.String(\"length\")),globalSubrIndex:new ct},2:{hdrSize:a.uint8,length:a.uint16,topDict:me,globalSubrIndex:new ct}}),xe=function(){function t(e){f(this,t),this.stream=e,this.decode()}return t.decode=function(e){return new t(e)},t.prototype.decode=function(){this.stream.pos;var t=we.decode(this.stream);for(var e in t){var n=t[e];this[e]=n}if(this.version<2){if(1!==this.topDictIndex.length)throw new Error(\"Only a single font is allowed in CFF\");this.topDict=this.topDictIndex[0]}return this.isCIDFont=null!=this.topDict.ROS,this},t.prototype.string=function(t){return this.version>=2?null:t<bt.length?bt[t]:this.stringIndex[t-bt.length]},t.prototype.getCharString=function(t){return this.stream.pos=this.topDict.CharStrings[t].offset,this.stream.readBuffer(this.topDict.CharStrings[t].length)},t.prototype.getGlyphName=function(t){if(this.version>=2)return null;if(this.isCIDFont)return null;var e=this.topDict.charset;if(Array.isArray(e))return e[t];if(0===t)return\".notdef\";switch(t-=1,e.version){case 0:return this.string(e.glyphs[t]);case 1:case 2:for(var n=0;n<e.ranges.length;n++){var r=e.ranges[n];if(r.offset<=t&&t<=r.offset+r.nLeft)return this.string(r.first+(t-r.offset))}}return null},t.prototype.fdForGlyph=function(t){if(!this.topDict.FDSelect)return null;switch(this.topDict.FDSelect.version){case 0:return this.topDict.FDSelect.fds[t];case 3:case 4:for(var e=this.topDict.FDSelect.ranges,n=0,r=e.length-1;n<=r;){var i=n+r>>1;if(t<e[i].first)r=i-1;else{if(!(i<r&&t>e[i+1].first))return e[i].fd;n=i+1}}default:throw new Error(\"Unknown FDSelect version: \"+this.topDict.FDSelect.version)}},t.prototype.privateDictForGlyph=function(t){if(this.topDict.FDSelect){var e=this.fdForGlyph(t);return this.topDict.FDArray[e]?this.topDict.FDArray[e].Private:null}return this.version<2?this.topDict.Private:this.topDict.FDArray[0].Private},d(t,[{key:\"postscriptName\",get:function(){return this.version<2?this.nameIndex[0]:null}},{key:\"fullName\",get:function(){return this.string(this.topDict.FullName)}},{key:\"familyName\",get:function(){return this.string(this.topDict.FamilyName)}}]),t}(),Se=new a.Struct({glyphIndex:a.uint16,vertOriginY:a.int16}),_e=new a.Struct({majorVersion:a.uint16,minorVersion:a.uint16,defaultVertOriginY:a.int16,numVertOriginYMetrics:a.uint16,metrics:new a.Array(Se,\"numVertOriginYMetrics\")}),ke=new a.Struct({height:a.uint8,width:a.uint8,horiBearingX:a.int8,horiBearingY:a.int8,horiAdvance:a.uint8,vertBearingX:a.int8,vertBearingY:a.int8,vertAdvance:a.uint8}),Ce=new a.Struct({height:a.uint8,width:a.uint8,bearingX:a.int8,bearingY:a.int8,advance:a.uint8}),Ae=new a.Struct({glyph:a.uint16,xOffset:a.int8,yOffset:a.int8}),Pe=function t(){f(this,t)},Ee=function t(){f(this,t)},Ie=(new a.VersionedStruct(\"version\",{1:{metrics:Ce,data:Pe},2:{metrics:Ce,data:Ee},5:{data:Ee},6:{metrics:ke,data:Pe},7:{metrics:ke,data:Ee},8:{metrics:Ce,pad:new a.Reserved(a.uint8),numComponents:a.uint16,components:new a.Array(Ae,\"numComponents\")},9:{metrics:ke,pad:new a.Reserved(a.uint8),numComponents:a.uint16,components:new a.Array(Ae,\"numComponents\")},17:{metrics:Ce,dataLen:a.uint32,data:new a.Buffer(\"dataLen\")},18:{metrics:ke,dataLen:a.uint32,data:new a.Buffer(\"dataLen\")},19:{dataLen:a.uint32,data:new a.Buffer(\"dataLen\")}}),new a.Struct({ascender:a.int8,descender:a.int8,widthMax:a.uint8,caretSlopeNumerator:a.int8,caretSlopeDenominator:a.int8,caretOffset:a.int8,minOriginSB:a.int8,minAdvanceSB:a.int8,maxBeforeBL:a.int8,minAfterBL:a.int8,pad:new a.Reserved(a.int8,2)})),Te=new a.Struct({glyphCode:a.uint16,offset:a.uint16}),Oe=new a.VersionedStruct(a.uint16,{header:{imageFormat:a.uint16,imageDataOffset:a.uint32},1:{offsetArray:new a.Array(a.uint32,function(t){return t.parent.lastGlyphIndex-t.parent.firstGlyphIndex+1})},2:{imageSize:a.uint32,bigMetrics:ke},3:{offsetArray:new a.Array(a.uint16,function(t){return t.parent.lastGlyphIndex-t.parent.firstGlyphIndex+1})},4:{numGlyphs:a.uint32,glyphArray:new a.Array(Te,function(t){return t.numGlyphs+1})},5:{imageSize:a.uint32,bigMetrics:ke,numGlyphs:a.uint32,glyphCodeArray:new a.Array(a.uint16,\"numGlyphs\")}}),Le=new a.Struct({firstGlyphIndex:a.uint16,lastGlyphIndex:a.uint16,subtable:new a.Pointer(a.uint32,Oe)}),Be=new a.Struct({indexSubTableArray:new a.Pointer(a.uint32,new a.Array(Le,1),{type:\"parent\"}),indexTablesSize:a.uint32,numberOfIndexSubTables:a.uint32,colorRef:a.uint32,hori:Ie,vert:Ie,startGlyphIndex:a.uint16,endGlyphIndex:a.uint16,ppemX:a.uint8,ppemY:a.uint8,bitDepth:a.uint8,flags:new a.Bitfield(a.uint8,[\"horizontal\",\"vertical\"])}),Me=new a.Struct({version:a.uint32,numSizes:a.uint32,sizes:new a.Array(Be,\"numSizes\")}),Re=new a.Struct({ppem:a.uint16,resolution:a.uint16,imageOffsets:new a.Array(new a.Pointer(a.uint32,\"void\"),function(t){return t.parent.parent.maxp.numGlyphs+1})}),Fe=new a.Struct({version:a.uint16,flags:new a.Bitfield(a.uint16,[\"renderOutlines\"]),numImgTables:a.uint32,imageTables:new a.Array(new a.Pointer(a.uint32,Re),\"numImgTables\")}),De=new a.Struct({gid:a.uint16,paletteIndex:a.uint16}),ze=new a.Struct({gid:a.uint16,firstLayerIndex:a.uint16,numLayers:a.uint16}),Ne=new a.Struct({version:a.uint16,numBaseGlyphRecords:a.uint16,baseGlyphRecord:new a.Pointer(a.uint32,new a.Array(ze,\"numBaseGlyphRecords\")),layerRecords:new a.Pointer(a.uint32,new a.Array(De,\"numLayerRecords\"),{lazy:!0}),numLayerRecords:a.uint16}),Ue=new a.Struct({blue:a.uint8,green:a.uint8,red:a.uint8,alpha:a.uint8}),We=new a.VersionedStruct(a.uint16,{header:{numPaletteEntries:a.uint16,numPalettes:a.uint16,numColorRecords:a.uint16,colorRecords:new a.Pointer(a.uint32,new a.Array(Ue,\"numColorRecords\")),colorRecordIndices:new a.Array(a.uint16,\"numPalettes\")},0:{},1:{offsetPaletteTypeArray:new a.Pointer(a.uint32,new a.Array(a.uint32,\"numPalettes\")),offsetPaletteLabelArray:new a.Pointer(a.uint32,new a.Array(a.uint16,\"numPalettes\")),offsetPaletteEntryLabelArray:new a.Pointer(a.uint32,new a.Array(a.uint16,\"numPaletteEntries\"))}}),Ge=new a.VersionedStruct(a.uint16,{1:{coordinate:a.int16},2:{coordinate:a.int16,referenceGlyph:a.uint16,baseCoordPoint:a.uint16},3:{coordinate:a.int16,deviceTable:new a.Pointer(a.uint16,Ft)}}),Ve=new a.Struct({defaultIndex:a.uint16,baseCoordCount:a.uint16,baseCoords:new a.Array(new a.Pointer(a.uint16,Ge),\"baseCoordCount\")}),je=new a.Struct({tag:new a.String(4),minCoord:new a.Pointer(a.uint16,Ge,{type:\"parent\"}),maxCoord:new a.Pointer(a.uint16,Ge,{type:\"parent\"})}),He=new a.Struct({minCoord:new a.Pointer(a.uint16,Ge),maxCoord:new a.Pointer(a.uint16,Ge),featMinMaxCount:a.uint16,featMinMaxRecords:new a.Array(je,\"featMinMaxCount\")}),qe=new a.Struct({tag:new a.String(4),minMax:new a.Pointer(a.uint16,He,{type:\"parent\"})}),Ze=new a.Struct({baseValues:new a.Pointer(a.uint16,Ve),defaultMinMax:new a.Pointer(a.uint16,He),baseLangSysCount:a.uint16,baseLangSysRecords:new a.Array(qe,\"baseLangSysCount\")}),Ye=new a.Struct({tag:new a.String(4),script:new a.Pointer(a.uint16,Ze,{type:\"parent\"})}),Xe=new a.Array(Ye,a.uint16),Ke=new a.Array(new a.String(4),a.uint16),Je=new a.Struct({baseTagList:new a.Pointer(a.uint16,Ke),baseScriptList:new a.Pointer(a.uint16,Xe)}),Qe=new a.VersionedStruct(a.uint32,{header:{horizAxis:new a.Pointer(a.uint16,Je),vertAxis:new a.Pointer(a.uint16,Je)},65536:{},65537:{itemVariationStore:new a.Pointer(a.uint32,Jt)}}),$e=new a.Array(a.uint16,a.uint16),tn=new a.Struct({coverage:new a.Pointer(a.uint16,Bt),glyphCount:a.uint16,attachPoints:new a.Array(new a.Pointer(a.uint16,$e),\"glyphCount\")}),en=new a.VersionedStruct(a.uint16,{1:{coordinate:a.int16},2:{caretValuePoint:a.uint16},3:{coordinate:a.int16,deviceTable:new a.Pointer(a.uint16,Ft)}}),nn=new a.Array(new a.Pointer(a.uint16,en),a.uint16),rn=new a.Struct({coverage:new a.Pointer(a.uint16,Bt),ligGlyphCount:a.uint16,ligGlyphs:new a.Array(new a.Pointer(a.uint16,nn),\"ligGlyphCount\")}),an=new a.Struct({markSetTableFormat:a.uint16,markSetCount:a.uint16,coverage:new a.Array(new a.Pointer(a.uint32,Bt),\"markSetCount\")}),on=new a.VersionedStruct(a.uint32,{header:{glyphClassDef:new a.Pointer(a.uint16,Rt),attachList:new a.Pointer(a.uint16,tn),ligCaretList:new a.Pointer(a.uint16,rn),markAttachClassDef:new a.Pointer(a.uint16,Rt)},65536:{},65538:{markGlyphSetsDef:new a.Pointer(a.uint16,an)},65539:{markGlyphSetsDef:new a.Pointer(a.uint16,an),itemVariationStore:new a.Pointer(a.uint32,Jt)}}),sn=new a.Bitfield(a.uint16,[\"xPlacement\",\"yPlacement\",\"xAdvance\",\"yAdvance\",\"xPlaDevice\",\"yPlaDevice\",\"xAdvDevice\",\"yAdvDevice\"]),ln={xPlacement:a.int16,yPlacement:a.int16,xAdvance:a.int16,yAdvance:a.int16,xPlaDevice:new a.Pointer(a.uint16,Ft,{type:\"global\",relativeTo:\"rel\"}),yPlaDevice:new a.Pointer(a.uint16,Ft,{type:\"global\",relativeTo:\"rel\"}),xAdvDevice:new a.Pointer(a.uint16,Ft,{type:\"global\",relativeTo:\"rel\"}),yAdvDevice:new a.Pointer(a.uint16,Ft,{type:\"global\",relativeTo:\"rel\"})},un=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:\"valueFormat\";f(this,t),this.key=e}return t.prototype.buildStruct=function(t){for(var e=t;!e[this.key]&&e.parent;)e=e.parent;if(e[this.key]){var n={rel:function(){return e._startOffset}},r=e[this.key];for(var i in r)r[i]&&(n[i]=ln[i]);return new a.Struct(n)}},t.prototype.size=function(t,e){return this.buildStruct(e).size(t,e)},t.prototype.decode=function(t,e){var n=this.buildStruct(e).decode(t,e);return delete n.rel,n},t}(),cn=new a.Struct({secondGlyph:a.uint16,value1:new un(\"valueFormat1\"),value2:new un(\"valueFormat2\")}),hn=new a.Array(cn,a.uint16),fn=new a.Struct({value1:new un(\"valueFormat1\"),value2:new un(\"valueFormat2\")}),dn=new a.VersionedStruct(a.uint16,{1:{xCoordinate:a.int16,yCoordinate:a.int16},2:{xCoordinate:a.int16,yCoordinate:a.int16,anchorPoint:a.uint16},3:{xCoordinate:a.int16,yCoordinate:a.int16,xDeviceTable:new a.Pointer(a.uint16,Ft),yDeviceTable:new a.Pointer(a.uint16,Ft)}}),pn=new a.Struct({entryAnchor:new a.Pointer(a.uint16,dn,{type:\"parent\"}),exitAnchor:new a.Pointer(a.uint16,dn,{type:\"parent\"})}),gn=new a.Struct({class:a.uint16,markAnchor:new a.Pointer(a.uint16,dn,{type:\"parent\"})}),yn=new a.Array(gn,a.uint16),vn=new a.Array(new a.Pointer(a.uint16,dn),function(t){return t.parent.classCount}),bn=new a.Array(vn,a.uint16),mn=new a.Array(new a.Pointer(a.uint16,dn),function(t){return t.parent.parent.classCount}),wn=new a.Array(mn,a.uint16),xn=new a.Array(new a.Pointer(a.uint16,wn),a.uint16),Sn=new a.VersionedStruct(\"lookupType\",{1:new a.VersionedStruct(a.uint16,{1:{coverage:new a.Pointer(a.uint16,Bt),valueFormat:sn,value:new un},2:{coverage:new a.Pointer(a.uint16,Bt),valueFormat:sn,valueCount:a.uint16,values:new a.LazyArray(new un,\"valueCount\")}}),2:new a.VersionedStruct(a.uint16,{1:{coverage:new a.Pointer(a.uint16,Bt),valueFormat1:sn,valueFormat2:sn,pairSetCount:a.uint16,pairSets:new a.LazyArray(new a.Pointer(a.uint16,hn),\"pairSetCount\")},2:{coverage:new a.Pointer(a.uint16,Bt),valueFormat1:sn,valueFormat2:sn,classDef1:new a.Pointer(a.uint16,Rt),classDef2:new a.Pointer(a.uint16,Rt),class1Count:a.uint16,class2Count:a.uint16,classRecords:new a.LazyArray(new a.LazyArray(fn,\"class2Count\"),\"class1Count\")}}),3:{format:a.uint16,coverage:new a.Pointer(a.uint16,Bt),entryExitCount:a.uint16,entryExitRecords:new a.Array(pn,\"entryExitCount\")},4:{format:a.uint16,markCoverage:new a.Pointer(a.uint16,Bt),baseCoverage:new a.Pointer(a.uint16,Bt),classCount:a.uint16,markArray:new a.Pointer(a.uint16,yn),baseArray:new a.Pointer(a.uint16,bn)},5:{format:a.uint16,markCoverage:new a.Pointer(a.uint16,Bt),ligatureCoverage:new a.Pointer(a.uint16,Bt),classCount:a.uint16,markArray:new a.Pointer(a.uint16,yn),ligatureArray:new a.Pointer(a.uint16,xn)},6:{format:a.uint16,mark1Coverage:new a.Pointer(a.uint16,Bt),mark2Coverage:new a.Pointer(a.uint16,Bt),classCount:a.uint16,mark1Array:new a.Pointer(a.uint16,yn),mark2Array:new a.Pointer(a.uint16,bn)},7:Gt,8:Ht,9:{posFormat:a.uint16,lookupType:a.uint16,extension:new a.Pointer(a.uint32,Sn)}});Sn.versions[9].extension.type=Sn;var _n=new a.VersionedStruct(a.uint32,{header:{scriptList:new a.Pointer(a.uint16,Ct),featureList:new a.Pointer(a.uint16,Et),lookupList:new a.Pointer(a.uint16,new Tt(Sn))},65536:{},65537:{featureVariations:new a.Pointer(a.uint32,re)}}),kn=new a.Array(a.uint16,a.uint16),Cn=kn,An=new a.Struct({glyph:a.uint16,compCount:a.uint16,components:new a.Array(a.uint16,function(t){return t.compCount-1})}),Pn=new a.Array(new a.Pointer(a.uint16,An),a.uint16),En=new a.VersionedStruct(\"lookupType\",{1:new a.VersionedStruct(a.uint16,{1:{coverage:new a.Pointer(a.uint16,Bt),deltaGlyphID:a.int16},2:{coverage:new a.Pointer(a.uint16,Bt),glyphCount:a.uint16,substitute:new a.LazyArray(a.uint16,\"glyphCount\")}}),2:{substFormat:a.uint16,coverage:new a.Pointer(a.uint16,Bt),count:a.uint16,sequences:new a.LazyArray(new a.Pointer(a.uint16,kn),\"count\")},3:{substFormat:a.uint16,coverage:new a.Pointer(a.uint16,Bt),count:a.uint16,alternateSet:new a.LazyArray(new a.Pointer(a.uint16,Cn),\"count\")},4:{substFormat:a.uint16,coverage:new a.Pointer(a.uint16,Bt),count:a.uint16,ligatureSets:new a.LazyArray(new a.Pointer(a.uint16,Pn),\"count\")},5:Gt,6:Ht,7:{substFormat:a.uint16,lookupType:a.uint16,extension:new a.Pointer(a.uint32,En)},8:{substFormat:a.uint16,coverage:new a.Pointer(a.uint16,Bt),backtrackCoverage:new a.Array(new a.Pointer(a.uint16,Bt),\"backtrackGlyphCount\"),lookaheadGlyphCount:a.uint16,lookaheadCoverage:new a.Array(new a.Pointer(a.uint16,Bt),\"lookaheadGlyphCount\"),glyphCount:a.uint16,substitutes:new a.Array(a.uint16,\"glyphCount\")}});En.versions[7].extension.type=En;var In=new a.VersionedStruct(a.uint32,{header:{scriptList:new a.Pointer(a.uint16,Ct),featureList:new a.Pointer(a.uint16,Et),lookupList:new a.Pointer(a.uint16,new Tt(En))},65536:{},65537:{featureVariations:new a.Pointer(a.uint32,re)}}),Tn=new a.Array(a.uint16,a.uint16),On=new a.Struct({shrinkageEnableGSUB:new a.Pointer(a.uint16,Tn),shrinkageDisableGSUB:new a.Pointer(a.uint16,Tn),shrinkageEnableGPOS:new a.Pointer(a.uint16,Tn),shrinkageDisableGPOS:new a.Pointer(a.uint16,Tn),shrinkageJstfMax:new a.Pointer(a.uint16,new Tt(Sn)),extensionEnableGSUB:new a.Pointer(a.uint16,Tn),extensionDisableGSUB:new a.Pointer(a.uint16,Tn),extensionEnableGPOS:new a.Pointer(a.uint16,Tn),extensionDisableGPOS:new a.Pointer(a.uint16,Tn),extensionJstfMax:new a.Pointer(a.uint16,new Tt(Sn))}),Ln=new a.Array(new a.Pointer(a.uint16,On),a.uint16),Bn=new a.Struct({tag:new a.String(4),jstfLangSys:new a.Pointer(a.uint16,Ln)}),Mn=new a.Struct({extenderGlyphs:new a.Pointer(a.uint16,new a.Array(a.uint16,a.uint16)),defaultLangSys:new a.Pointer(a.uint16,Ln),langSysCount:a.uint16,langSysRecords:new a.Array(Bn,\"langSysCount\")}),Rn=new a.Struct({tag:new a.String(4),script:new a.Pointer(a.uint16,Mn,{type:\"parent\"})}),Fn=new a.Struct({version:a.uint32,scriptCount:a.uint16,scriptList:new a.Array(Rn,\"scriptCount\")}),Dn=function(){function t(e){f(this,t),this._size=e}return t.prototype.decode=function(t,e){switch(this.size(0,e)){case 1:return t.readUInt8();case 2:return t.readUInt16BE();case 3:return t.readUInt24BE();case 4:return t.readUInt32BE()}},t.prototype.size=function(t,e){return v.resolveLength(this._size,null,e)},t}(),zn=new a.Struct({entry:new Dn(function(t){return 1+((48&t.parent.entryFormat)>>4)}),outerIndex:function(t){return t.entry>>1+(15&t.parent.entryFormat)},innerIndex:function(t){return t.entry&(1<<1+(15&t.parent.entryFormat))-1}}),Nn=new a.Struct({entryFormat:a.uint16,mapCount:a.uint16,mapData:new a.Array(zn,\"mapCount\")}),Un=new a.Struct({majorVersion:a.uint16,minorVersion:a.uint16,itemVariationStore:new a.Pointer(a.uint32,Jt),advanceWidthMapping:new a.Pointer(a.uint32,Nn),LSBMapping:new a.Pointer(a.uint32,Nn),RSBMapping:new a.Pointer(a.uint32,Nn)}),Wn=new a.Struct({format:a.uint32,length:a.uint32,offset:a.uint32}),Gn=new a.Struct({reserved:new a.Reserved(a.uint16,2),cbSignature:a.uint32,signature:new a.Buffer(\"cbSignature\")}),Vn=new a.Struct({ulVersion:a.uint32,usNumSigs:a.uint16,usFlag:a.uint16,signatures:new a.Array(Wn,\"usNumSigs\"),signatureBlocks:new a.Array(Gn,\"usNumSigs\")}),jn=new a.Struct({rangeMaxPPEM:a.uint16,rangeGaspBehavior:new a.Bitfield(a.uint16,[\"grayscale\",\"gridfit\",\"symmetricSmoothing\",\"symmetricGridfit\"])}),Hn=new a.Struct({version:a.uint16,numRanges:a.uint16,gaspRanges:new a.Array(jn,\"numRanges\")}),qn=new a.Struct({pixelSize:a.uint8,maximumWidth:a.uint8,widths:new a.Array(a.uint8,function(t){return t.parent.parent.maxp.numGlyphs})}),Zn=new a.Struct({version:a.uint16,numRecords:a.int16,sizeDeviceRecord:a.int32,records:new a.Array(qn,\"numRecords\")}),Yn=new a.Struct({left:a.uint16,right:a.uint16,value:a.int16}),Xn=new a.Struct({firstGlyph:a.uint16,nGlyphs:a.uint16,offsets:new a.Array(a.uint16,\"nGlyphs\"),max:function(t){return t.offsets.length&&Math.max.apply(Math,t.offsets)}}),Kn=new a.Struct({off:function(t){return t._startOffset-t.parent.parent._startOffset},len:function(t){return((t.parent.leftTable.max-t.off)/t.parent.rowWidth+1)*(t.parent.rowWidth/2)},values:new a.LazyArray(a.int16,\"len\")}),Jn=new a.VersionedStruct(\"format\",{0:{nPairs:a.uint16,searchRange:a.uint16,entrySelector:a.uint16,rangeShift:a.uint16,pairs:new a.Array(Yn,\"nPairs\")},2:{rowWidth:a.uint16,leftTable:new a.Pointer(a.uint16,Xn,{type:\"parent\"}),rightTable:new a.Pointer(a.uint16,Xn,{type:\"parent\"}),array:new a.Pointer(a.uint16,Kn,{type:\"parent\"})},3:{glyphCount:a.uint16,kernValueCount:a.uint8,leftClassCount:a.uint8,rightClassCount:a.uint8,flags:a.uint8,kernValue:new a.Array(a.int16,\"kernValueCount\"),leftClass:new a.Array(a.uint8,\"glyphCount\"),rightClass:new a.Array(a.uint8,\"glyphCount\"),kernIndex:new a.Array(a.uint8,function(t){return t.leftClassCount*t.rightClassCount})}}),Qn=new a.VersionedStruct(\"version\",{0:{subVersion:a.uint16,length:a.uint16,format:a.uint8,coverage:new a.Bitfield(a.uint8,[\"horizontal\",\"minimum\",\"crossStream\",\"override\"]),subtable:Jn,padding:new a.Reserved(a.uint8,function(t){return t.length-t._currentOffset})},1:{length:a.uint32,coverage:new a.Bitfield(a.uint8,[null,null,null,null,null,\"variation\",\"crossStream\",\"vertical\"]),format:a.uint8,tupleIndex:a.uint16,subtable:Jn,padding:new a.Reserved(a.uint8,function(t){return t.length-t._currentOffset})}}),$n=new a.VersionedStruct(a.uint16,{0:{nTables:a.uint16,tables:new a.Array(Qn,\"nTables\")},1:{reserved:new a.Reserved(a.uint16),nTables:a.uint32,tables:new a.Array(Qn,\"nTables\")}}),tr=new a.Struct({version:a.uint16,numGlyphs:a.uint16,yPels:new a.Array(a.uint8,\"numGlyphs\")}),er=new a.Struct({version:a.uint16,fontNumber:a.uint32,pitch:a.uint16,xHeight:a.uint16,style:a.uint16,typeFamily:a.uint16,capHeight:a.uint16,symbolSet:a.uint16,typeface:new a.String(16),characterComplement:new a.String(8),fileName:new a.String(6),strokeWeight:new a.String(1),widthType:new a.String(1),serifStyle:a.uint8,reserved:new a.Reserved(a.uint8)}),nr=new a.Struct({bCharSet:a.uint8,xRatio:a.uint8,yStartRatio:a.uint8,yEndRatio:a.uint8}),rr=new a.Struct({yPelHeight:a.uint16,yMax:a.int16,yMin:a.int16}),ir=new a.Struct({recs:a.uint16,startsz:a.uint8,endsz:a.uint8,entries:new a.Array(rr,\"recs\")}),ar=new a.Struct({version:a.uint16,numRecs:a.uint16,numRatios:a.uint16,ratioRanges:new a.Array(nr,\"numRatios\"),offsets:new a.Array(a.uint16,\"numRatios\"),groups:new a.Array(ir,\"numRecs\")}),or=new a.Struct({version:a.uint16,ascent:a.int16,descent:a.int16,lineGap:a.int16,advanceHeightMax:a.int16,minTopSideBearing:a.int16,minBottomSideBearing:a.int16,yMaxExtent:a.int16,caretSlopeRise:a.int16,caretSlopeRun:a.int16,caretOffset:a.int16,reserved:new a.Reserved(a.int16,4),metricDataFormat:a.int16,numberOfMetrics:a.uint16}),sr=new a.Struct({advance:a.uint16,bearing:a.int16}),lr=new a.Struct({metrics:new a.LazyArray(sr,function(t){return t.parent.vhea.numberOfMetrics}),bearings:new a.LazyArray(a.int16,function(t){return t.parent.maxp.numGlyphs-t.parent.vhea.numberOfMetrics})}),ur=new a.Fixed(16,\"BE\",14),cr=new a.Struct({fromCoord:ur,toCoord:ur}),hr=new a.Struct({pairCount:a.uint16,correspondence:new a.Array(cr,\"pairCount\")}),fr=new a.Struct({version:a.fixed32,axisCount:a.uint32,segment:new a.Array(hr,\"axisCount\")}),dr=function(){function t(e,n,r){f(this,t),this.type=e,this.stream=n,this.parent=r,this.base=this.stream.pos,this._items=[]}return t.prototype.getItem=function(t){if(null==this._items[t]){var e=this.stream.pos;this.stream.pos=this.base+this.type.size(null,this.parent)*t,this._items[t]=this.type.decode(this.stream,this.parent),this.stream.pos=e}return this._items[t]},t.prototype.inspect=function(){return\"[UnboundedArray \"+this.type.constructor.name+\"]\"},t}(),pr=function(t){function e(n){return f(this,e),g(this,t.call(this,n,0))}return y(e,t),e.prototype.decode=function(t,e){return new dr(this.type,t,e)},e}(a.Array),gr=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.uint16;t=new(function(){function t(e){f(this,t),this.type=e}return t.prototype.decode=function(t,e){return e=e.parent.parent,this.type.decode(t,e)},t.prototype.size=function(t,e){return e=e.parent.parent,this.type.size(t,e)},t.prototype.encode=function(t,e,n){return n=n.parent.parent,this.type.encode(t,e,n)},t}())(t);var e=new a.Struct({unitSize:a.uint16,nUnits:a.uint16,searchRange:a.uint16,entrySelector:a.uint16,rangeShift:a.uint16}),n=new a.Struct({lastGlyph:a.uint16,firstGlyph:a.uint16,value:t}),r=new a.Struct({lastGlyph:a.uint16,firstGlyph:a.uint16,values:new a.Pointer(a.uint16,new a.Array(t,function(t){return t.lastGlyph-t.firstGlyph+1}),{type:\"parent\"})}),i=new a.Struct({glyph:a.uint16,value:t});return new a.VersionedStruct(a.uint16,{0:{values:new pr(t)},2:{binarySearchHeader:e,segments:new a.Array(n,function(t){return t.binarySearchHeader.nUnits})},4:{binarySearchHeader:e,segments:new a.Array(r,function(t){return t.binarySearchHeader.nUnits})},6:{binarySearchHeader:e,segments:new a.Array(i,function(t){return t.binarySearchHeader.nUnits})},8:{firstGlyph:a.uint16,count:a.uint16,values:new a.Array(t,\"count\")}})};function yr(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.uint16,n=w({newState:a.uint16,flags:a.uint16},t),r=new a.Struct(n),i=new pr(new a.Array(a.uint16,function(t){return t.nClasses}));return new a.Struct({nClasses:a.uint32,classTable:new a.Pointer(a.uint32,new gr(e)),stateArray:new a.Pointer(a.uint32,i),entryTable:new a.Pointer(a.uint32,new pr(r))})}var vr=new a.VersionedStruct(\"format\",{0:{deltas:new a.Array(a.int16,32)},1:{deltas:new a.Array(a.int16,32),mappingData:new gr(a.uint16)},2:{standardGlyph:a.uint16,controlPoints:new a.Array(a.uint16,32)},3:{standardGlyph:a.uint16,controlPoints:new a.Array(a.uint16,32),mappingData:new gr(a.uint16)}}),br=new a.Struct({version:a.fixed32,format:a.uint16,defaultBaseline:a.uint16,subtable:vr}),mr=new a.Struct({setting:a.uint16,nameIndex:a.int16,name:function(t){return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex]}}),wr=new a.Struct({feature:a.uint16,nSettings:a.uint16,settingTable:new a.Pointer(a.uint32,new a.Array(mr,\"nSettings\"),{type:\"parent\"}),featureFlags:new a.Bitfield(a.uint8,[null,null,null,null,null,null,\"hasDefault\",\"exclusive\"]),defaultSetting:a.uint8,nameIndex:a.int16,name:function(t){return t.parent.parent.name.records.fontFeatures[t.nameIndex]}}),xr=new a.Struct({version:a.fixed32,featureNameCount:a.uint16,reserved1:new a.Reserved(a.uint16),reserved2:new a.Reserved(a.uint32),featureNames:new a.Array(wr,\"featureNameCount\")}),Sr=new a.Struct({axisTag:new a.String(4),minValue:a.fixed32,defaultValue:a.fixed32,maxValue:a.fixed32,flags:a.uint16,nameID:a.uint16,name:function(t){return t.parent.parent.name.records.fontFeatures[t.nameID]}}),_r=new a.Struct({nameID:a.uint16,name:function(t){return t.parent.parent.name.records.fontFeatures[t.nameID]},flags:a.uint16,coord:new a.Array(a.fixed32,function(t){return t.parent.axisCount}),postscriptNameID:new a.Optional(a.uint16,function(t){return t.parent.instanceSize-t._currentOffset>0})}),kr=new a.Struct({version:a.fixed32,offsetToData:a.uint16,countSizePairs:a.uint16,axisCount:a.uint16,axisSize:a.uint16,instanceCount:a.uint16,instanceSize:a.uint16,axis:new a.Array(Sr,\"axisCount\"),instance:new a.Array(_r,\"instanceCount\")}),Cr=new a.Fixed(16,\"BE\",14),Ar=function(){function t(){f(this,t)}return t.decode=function(t,e){return e.flags?t.readUInt32BE():2*t.readUInt16BE()},t}(),Pr=new a.Struct({version:a.uint16,reserved:new a.Reserved(a.uint16),axisCount:a.uint16,globalCoordCount:a.uint16,globalCoords:new a.Pointer(a.uint32,new a.Array(new a.Array(Cr,\"axisCount\"),\"globalCoordCount\")),glyphCount:a.uint16,flags:a.uint16,offsetToData:a.uint32,offsets:new a.Array(new a.Pointer(Ar,\"void\",{relativeTo:\"offsetToData\",allowNull:!1}),function(t){return t.glyphCount+1})}),Er=new a.Struct({length:a.uint16,coverage:a.uint16,subFeatureFlags:a.uint32,stateTable:new function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.uint16,new a.Struct({version:function(){return 8},firstGlyph:a.uint16,values:new a.Array(a.uint8,a.uint16)})),n=w({newStateOffset:a.uint16,newState:function(t){return(t.newStateOffset-(t.parent.stateArray.base-t.parent._startOffset))/t.parent.nClasses},flags:a.uint16},t),r=new a.Struct(n),i=new pr(new a.Array(a.uint8,function(t){return t.nClasses}));return new a.Struct({nClasses:a.uint16,classTable:new a.Pointer(a.uint16,e),stateArray:new a.Pointer(a.uint16,i),entryTable:new a.Pointer(a.uint16,new pr(r))})}}),Ir=new a.Struct({justClass:a.uint32,beforeGrowLimit:a.fixed32,beforeShrinkLimit:a.fixed32,afterGrowLimit:a.fixed32,afterShrinkLimit:a.fixed32,growFlags:a.uint16,shrinkFlags:a.uint16}),Tr=new a.Array(Ir,a.uint32),Or=new a.VersionedStruct(\"actionType\",{0:{lowerLimit:a.fixed32,upperLimit:a.fixed32,order:a.uint16,glyphs:new a.Array(a.uint16,a.uint16)},1:{addGlyph:a.uint16},2:{substThreshold:a.fixed32,addGlyph:a.uint16,substGlyph:a.uint16},3:{},4:{variationAxis:a.uint32,minimumLimit:a.fixed32,noStretchValue:a.fixed32,maximumLimit:a.fixed32},5:{flags:a.uint16,glyph:a.uint16}}),Lr=new a.Struct({actionClass:a.uint16,actionType:a.uint16,actionLength:a.uint32,actionData:Or,padding:new a.Reserved(a.uint8,function(t){return t.actionLength-t._currentOffset})}),Br=new a.Array(Lr,a.uint32),Mr=new a.Struct({lookupTable:new gr(new a.Pointer(a.uint16,Br))}),Rr=new a.Struct({classTable:new a.Pointer(a.uint16,Er,{type:\"parent\"}),wdcOffset:a.uint16,postCompensationTable:new a.Pointer(a.uint16,Mr,{type:\"parent\"}),widthDeltaClusters:new gr(new a.Pointer(a.uint16,Tr,{type:\"parent\",relativeTo:\"wdcOffset\"}))}),Fr=new a.Struct({version:a.uint32,format:a.uint16,horizontal:new a.Pointer(a.uint16,Rr),vertical:new a.Pointer(a.uint16,Rr)}),Dr={action:a.uint16},zr={markIndex:a.uint16,currentIndex:a.uint16},Nr={currentInsertIndex:a.uint16,markedInsertIndex:a.uint16},Ur=new a.Struct({items:new pr(new a.Pointer(a.uint32,new gr))}),Wr=new a.VersionedStruct(\"type\",{0:{stateTable:new yr},1:{stateTable:new yr(zr),substitutionTable:new a.Pointer(a.uint32,Ur)},2:{stateTable:new yr(Dr),ligatureActions:new a.Pointer(a.uint32,new pr(a.uint32)),components:new a.Pointer(a.uint32,new pr(a.uint16)),ligatureList:new a.Pointer(a.uint32,new pr(a.uint16))},4:{lookupTable:new gr},5:{stateTable:new yr(Nr),insertionActions:new a.Pointer(a.uint32,new pr(a.uint16))}}),Gr=new a.Struct({length:a.uint32,coverage:a.uint24,type:a.uint8,subFeatureFlags:a.uint32,table:Wr,padding:new a.Reserved(a.uint8,function(t){return t.length-t._currentOffset})}),Vr=new a.Struct({featureType:a.uint16,featureSetting:a.uint16,enableFlags:a.uint32,disableFlags:a.uint32}),jr=new a.Struct({defaultFlags:a.uint32,chainLength:a.uint32,nFeatureEntries:a.uint32,nSubtables:a.uint32,features:new a.Array(Vr,\"nFeatureEntries\"),subtables:new a.Array(Gr,\"nSubtables\")}),Hr=new a.Struct({version:a.uint16,unused:new a.Reserved(a.uint16),nChains:a.uint32,chains:new a.Array(jr,\"nChains\")}),qr=new a.Struct({left:a.int16,top:a.int16,right:a.int16,bottom:a.int16}),Zr=new a.Struct({version:a.fixed32,format:a.uint16,lookupTable:new gr(qr)}),Yr={};Yr.cmap=V,Yr.head=j,Yr.hhea=H,Yr.hmtx=Z,Yr.maxp=Y,Yr.name=NameTable,Yr[\"OS/2\"]=nt,Yr.post=it,Yr.fpgm=ot,Yr.loca=st,Yr.prep=lt,Yr[\"cvt \"]=at,Yr.glyf=ut,Yr[\"CFF \"]=xe,Yr.CFF2=xe,Yr.VORG=_e,Yr.EBLC=Me,Yr.CBLC=Yr.EBLC,Yr.sbix=Fe,Yr.COLR=Ne,Yr.CPAL=We,Yr.BASE=Qe,Yr.GDEF=on,Yr.GPOS=_n,Yr.GSUB=In,Yr.JSTF=Fn,Yr.HVAR=Un,Yr.DSIG=Vn,Yr.gasp=Hn,Yr.hdmx=Zn,Yr.kern=$n,Yr.LTSH=tr,Yr.PCLT=er,Yr.VDMX=ar,Yr.vhea=or,Yr.vmtx=lr,Yr.avar=fr,Yr.bsln=br,Yr.feat=xr,Yr.fvar=kr,Yr.gvar=Pr,Yr.just=Fr,Yr.morx=Hr,Yr.opbd=Zr;var Xr,Kr=new a.Struct({tag:new a.String(4),checkSum:a.uint32,offset:new a.Pointer(a.uint32,\"void\",{type:\"global\"}),length:a.uint32}),Jr=new a.Struct({tag:new a.String(4),numTables:a.uint16,searchRange:a.uint16,entrySelector:a.uint16,rangeShift:a.uint16,tables:new a.Array(Kr,\"numTables\")});function Qr(t,e){for(var n=0,r=t.length-1;n<=r;){var i=n+r>>1,a=e(t[i]);if(a<0)r=i-1;else{if(!(a>0))return i;n=i+1}}return-1}function $r(t,e){for(var n=[];t<e;)n.push(t++);return n}function ti(t,e,n,r,i){var a={};return Object.keys(r).forEach(function(t){a[t]=r[t]}),a.enumerable=!!a.enumerable,a.configurable=!!a.configurable,(\"value\"in a||a.initializer)&&(a.writable=!0),a=n.slice().reverse().reduce(function(n,r){return r(t,e,n)||n},a),i&&void 0!==a.initializer&&(a.value=a.initializer?a.initializer.call(i):void 0,a.initializer=void 0),void 0===a.initializer&&(Object.defineProperty(t,e,a),a=null),a}Jr.process=function(){var t={},e=this.tables,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i;t[a.tag]=a}this.tables=t},Jr.preEncode=function(t){var e=[];for(var n in this.tables){var r=this.tables[n];r&&e.push({tag:n,checkSum:0,offset:new a.VoidPointer(Yr[n],r),length:Yr[n].size(r)})}this.tag=\"true\",this.numTables=e.length,this.tables=e,this.searchRange=16*Math.floor(Math.log(this.numTables)/Math.LN2),this.entrySelector=Math.floor(this.searchRange/Math.LN2),this.rangeShift=16*this.numTables-this.searchRange};try{var ei=n(52)}catch(t){}var ni=(ti((Xr=function(){function t(e){if(f(this,t),this.encoding=null,this.cmap=this.findSubtable(e,[[3,10],[0,6],[0,4],[3,1],[0,3],[0,2],[0,1],[0,0]]),!this.cmap&&ei){var n=e.tables,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=X(o.platformID,o.encodingID,o.table.language-1);ei.encodingExists(l)&&(this.cmap=o.table,this.encoding=l)}}if(!this.cmap)throw new Error(\"Could not find a supported cmap table\");this.uvs=this.findSubtable(e,[[0,5]]),this.uvs&&14!==this.uvs.version&&(this.uvs=null)}return t.prototype.findSubtable=function(t,e){var n=e,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=o[0],u=o[1],c=t.tables,h=Array.isArray(c),f=0;for(c=h?c:s(c);;){var d;if(h){if(f>=c.length)break;d=c[f++]}else{if((f=c.next()).done)break;d=f.value}var p=d;if(p.platformID===l&&p.encodingID===u)return p.table}}return null},t.prototype.lookup=function(t,e){if(this.encoding){var n=ei.encode(x(t),this.encoding);t=0;for(var r=0;r<n.length;r++)t=t<<8|n[r]}else if(e){var i=this.getVariationSelector(t,e);if(i)return i}var a=this.cmap;switch(a.version){case 0:return a.codeMap.get(t)||0;case 4:for(var o=0,s=a.segCount-1;o<=s;){var l=o+s>>1;if(t<a.startCode.get(l))s=l-1;else{if(!(t>a.endCode.get(l))){var u=a.idRangeOffset.get(l),c=void 0;if(0===u)c=t+a.idDelta.get(l);else{var h=u/2+(t-a.startCode.get(l))-(a.segCount-l);0!==(c=a.glyphIndexArray.get(h)||0)&&(c+=a.idDelta.get(l))}return 65535&c}o=l+1}}return 0;case 8:throw new Error(\"TODO: cmap format 8\");case 6:case 10:return a.glyphIndices.get(t-a.firstCode)||0;case 12:case 13:for(var f=0,d=a.nGroups-1;f<=d;){var p=f+d>>1,g=a.groups.get(p);if(t<g.startCharCode)d=p-1;else{if(!(t>g.endCharCode))return 12===a.version?g.glyphID+(t-g.startCharCode):g.glyphID;f=p+1}}return 0;case 14:throw new Error(\"TODO: cmap format 14\");default:throw new Error(\"Unknown cmap format \"+a.version)}},t.prototype.getVariationSelector=function(t,e){if(!this.uvs)return 0;var n=this.uvs.varSelectors.toArray(),r=Qr(n,function(t){return e-t.varSelector}),i=n[r];return-1!==r&&i.defaultUVS&&(r=Qr(i.defaultUVS,function(e){return t<e.startUnicodeValue?-1:t>e.startUnicodeValue+e.additionalCount?1:0})),-1!==r&&i.nonDefaultUVS&&-1!==(r=Qr(i.nonDefaultUVS,function(e){return t-e.unicodeValue}))?i.nonDefaultUVS[r].glyphID:0},t.prototype.getCharacterSet=function(){var t=this.cmap;switch(t.version){case 0:return $r(0,t.codeMap.length);case 4:for(var e=[],n=t.endCode.toArray(),r=0;r<n.length;r++){var i=n[r]+1,a=t.startCode.get(r);e.push.apply(e,$r(a,i))}return e;case 8:throw new Error(\"TODO: cmap format 8\");case 6:case 10:return $r(t.firstCode,t.firstCode+t.glyphIndices.length);case 12:case 13:var o=[],l=t.groups.toArray(),u=Array.isArray(l),c=0;for(l=u?l:s(l);;){var h;if(u){if(c>=l.length)break;h=l[c++]}else{if((c=l.next()).done)break;h=c.value}var f=h;o.push.apply(o,$r(f.startCharCode,f.endCharCode+1))}return o;case 14:throw new Error(\"TODO: cmap format 14\");default:throw new Error(\"Unknown cmap format \"+t.version)}},t.prototype.codePointsForGlyph=function(t){var e=this.cmap;switch(e.version){case 0:for(var n=[],r=0;r<256;r++)e.codeMap.get(r)===t&&n.push(r);return n;case 4:for(var i=[],a=0;a<e.segCount;a++)for(var o=e.endCode.get(a),l=e.startCode.get(a),u=e.idRangeOffset.get(a),c=e.idDelta.get(a),h=l;h<=o;h++){var f=0;if(0===u)f=h+c;else{var d=u/2+(h-l)-(e.segCount-a);0!==(f=e.glyphIndexArray.get(d)||0)&&(f+=c)}f===t&&i.push(h)}return i;case 12:var p=[],g=e.groups.toArray(),y=Array.isArray(g),v=0;for(g=y?g:s(g);;){var b;if(y){if(v>=g.length)break;b=g[v++]}else{if((v=g.next()).done)break;b=v.value}var m=b;t>=m.glyphID&&t<=m.glyphID+(m.endCharCode-m.startCharCode)&&p.push(m.startCharCode+(t-m.glyphID))}return p;case 13:var w=[],x=e.groups.toArray(),S=Array.isArray(x),_=0;for(x=S?x:s(x);;){var k;if(S){if(_>=x.length)break;k=x[_++]}else{if((_=x.next()).done)break;k=_.value}var C=k;t===C.glyphID&&w.push.apply(w,$r(C.startCharCode,C.endCharCode+1))}return w;default:throw new Error(\"Unknown cmap format \"+e.version)}},t}()).prototype,\"getCharacterSet\",[B],o(Xr.prototype,\"getCharacterSet\"),Xr.prototype),ti(Xr.prototype,\"codePointsForGlyph\",[B],o(Xr.prototype,\"codePointsForGlyph\"),Xr.prototype),Xr),ri=function(){function t(e){f(this,t),this.kern=e.kern}return t.prototype.process=function(t,e){for(var n=0;n<t.length-1;n++){var r=t[n].id,i=t[n+1].id;e[n].xAdvance+=this.getKerning(r,i)}},t.prototype.getKerning=function(t,e){var n=0,r=this.kern.tables,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o;if(!l.coverage.crossStream){switch(l.version){case 0:if(!l.coverage.horizontal)continue;break;case 1:if(l.coverage.vertical||l.coverage.variation)continue;break;default:throw new Error(\"Unsupported kerning table version \"+l.version)}var u=0,c=l.subtable;switch(l.format){case 0:var h=Qr(c.pairs,function(n){return t-n.left||e-n.right});h>=0&&(u=c.pairs[h].value);break;case 2:var f=0,d=0;f=t>=c.leftTable.firstGlyph&&t<c.leftTable.firstGlyph+c.leftTable.nGlyphs?c.leftTable.offsets[t-c.leftTable.firstGlyph]:c.array.off,e>=c.rightTable.firstGlyph&&e<c.rightTable.firstGlyph+c.rightTable.nGlyphs&&(d=c.rightTable.offsets[e-c.rightTable.firstGlyph]);var p=(f+d-c.array.off)/2;u=c.array.values.get(p);break;case 3:if(t>=c.glyphCount||e>=c.glyphCount)return 0;u=c.kernValue[c.kernIndex[c.leftClass[t]*c.rightClassCount+c.rightClass[e]]];break;default:throw new Error(\"Unsupported kerning sub-table format \"+l.format)}l.coverage.override?n=u:n+=u}}return n},t}(),ii=function(){function t(e){f(this,t),this.font=e}return t.prototype.positionGlyphs=function(t,e){for(var n=0,r=0,i=0;i<t.length;i++){t[i].isMark?r=i:(n!==r&&this.positionCluster(t,e,n,r),n=r=i)}return n!==r&&this.positionCluster(t,e,n,r),e},t.prototype.positionCluster=function(t,e,n,r){var i=t[n],a=i.cbox.copy();i.codePoints.length>1&&(a.minX+=(i.codePoints.length-1)*a.width/i.codePoints.length);for(var o=-e[n].xAdvance,s=0,l=this.font.unitsPerEm/16,u=n+1;u<=r;u++){var c=t[u],h=c.cbox,f=e[u],d=this.getCombiningClass(c.codePoints[0]);if(\"Not_Reordered\"!==d){switch(f.xOffset=f.yOffset=0,d){case\"Double_Above\":case\"Double_Below\":f.xOffset+=a.minX-h.width/2-h.minX;break;case\"Attached_Below_Left\":case\"Below_Left\":case\"Above_Left\":f.xOffset+=a.minX-h.minX;break;case\"Attached_Above_Right\":case\"Below_Right\":case\"Above_Right\":f.xOffset+=a.maxX-h.width-h.minX;break;default:f.xOffset+=a.minX+(a.width-h.width)/2-h.minX}switch(d){case\"Double_Below\":case\"Below_Left\":case\"Below\":case\"Below_Right\":case\"Attached_Below_Left\":case\"Attached_Below\":\"Attached_Below_Left\"!==d&&\"Attached_Below\"!==d||(a.minY+=l),f.yOffset=-a.minY-h.maxY,a.minY+=h.height;break;case\"Double_Above\":case\"Above_Left\":case\"Above\":case\"Above_Right\":case\"Attached_Above\":case\"Attached_Above_Right\":\"Attached_Above\"!==d&&\"Attached_Above_Right\"!==d||(a.maxY+=l),f.yOffset=a.maxY-h.minY,a.maxY+=h.height}f.xAdvance=f.yAdvance=0,f.xOffset+=o,f.yOffset+=s}else o-=f.xAdvance,s-=f.yAdvance}},t.prototype.getCombiningClass=function(t){var e=k.getCombiningClass(t);if(3584==(-256&t))if(\"Not_Reordered\"===e)switch(t){case 3633:case 3636:case 3637:case 3638:case 3639:case 3655:case 3660:case 3645:case 3662:return\"Above_Right\";case 3761:case 3764:case 3765:case 3766:case 3767:case 3771:case 3788:case 3789:return\"Above\";case 3772:return\"Below\"}else if(3642===t)return\"Below_Right\";switch(e){case\"CCC10\":case\"CCC11\":case\"CCC12\":case\"CCC13\":case\"CCC14\":case\"CCC15\":case\"CCC16\":case\"CCC17\":case\"CCC18\":case\"CCC20\":case\"CCC22\":return\"Below\";case\"CCC23\":return\"Attached_Above\";case\"CCC24\":return\"Above_Right\";case\"CCC25\":case\"CCC19\":return\"Above_Left\";case\"CCC26\":return\"Above\";case\"CCC21\":break;case\"CCC27\":case\"CCC28\":case\"CCC30\":case\"CCC31\":case\"CCC33\":case\"CCC34\":case\"CCC35\":case\"CCC36\":return\"Above\";case\"CCC29\":case\"CCC32\":return\"Below\";case\"CCC103\":return\"Below_Right\";case\"CCC107\":return\"Above_Right\";case\"CCC118\":return\"Below\";case\"CCC122\":return\"Above\";case\"CCC129\":case\"CCC132\":return\"Below\";case\"CCC130\":return\"Above\"}return e},t}(),ai=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1/0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1/0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:-1/0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:-1/0;f(this,t),this.minX=e,this.minY=n,this.maxX=r,this.maxY=i}return t.prototype.addPoint=function(t,e){Math.abs(t)!==1/0&&(t<this.minX&&(this.minX=t),t>this.maxX&&(this.maxX=t)),Math.abs(e)!==1/0&&(e<this.minY&&(this.minY=e),e>this.maxY&&(this.maxY=e))},t.prototype.copy=function(){return new t(this.minX,this.minY,this.maxX,this.maxY)},d(t,[{key:\"width\",get:function(){return this.maxX-this.minX}},{key:\"height\",get:function(){return this.maxY-this.minY}}]),t}(),oi={Caucasian_Albanian:\"aghb\",Arabic:\"arab\",Imperial_Aramaic:\"armi\",Armenian:\"armn\",Avestan:\"avst\",Balinese:\"bali\",Bamum:\"bamu\",Bassa_Vah:\"bass\",Batak:\"batk\",Bengali:[\"bng2\",\"beng\"],Bopomofo:\"bopo\",Brahmi:\"brah\",Braille:\"brai\",Buginese:\"bugi\",Buhid:\"buhd\",Chakma:\"cakm\",Canadian_Aboriginal:\"cans\",Carian:\"cari\",Cham:\"cham\",Cherokee:\"cher\",Coptic:\"copt\",Cypriot:\"cprt\",Cyrillic:\"cyrl\",Devanagari:[\"dev2\",\"deva\"],Deseret:\"dsrt\",Duployan:\"dupl\",Egyptian_Hieroglyphs:\"egyp\",Elbasan:\"elba\",Ethiopic:\"ethi\",Georgian:\"geor\",Glagolitic:\"glag\",Gothic:\"goth\",Grantha:\"gran\",Greek:\"grek\",Gujarati:[\"gjr2\",\"gujr\"],Gurmukhi:[\"gur2\",\"guru\"],Hangul:\"hang\",Han:\"hani\",Hanunoo:\"hano\",Hebrew:\"hebr\",Hiragana:\"hira\",Pahawh_Hmong:\"hmng\",Katakana_Or_Hiragana:\"hrkt\",Old_Italic:\"ital\",Javanese:\"java\",Kayah_Li:\"kali\",Katakana:\"kana\",Kharoshthi:\"khar\",Khmer:\"khmr\",Khojki:\"khoj\",Kannada:[\"knd2\",\"knda\"],Kaithi:\"kthi\",Tai_Tham:\"lana\",Lao:\"lao \",Latin:\"latn\",Lepcha:\"lepc\",Limbu:\"limb\",Linear_A:\"lina\",Linear_B:\"linb\",Lisu:\"lisu\",Lycian:\"lyci\",Lydian:\"lydi\",Mahajani:\"mahj\",Mandaic:\"mand\",Manichaean:\"mani\",Mende_Kikakui:\"mend\",Meroitic_Cursive:\"merc\",Meroitic_Hieroglyphs:\"mero\",Malayalam:[\"mlm2\",\"mlym\"],Modi:\"modi\",Mongolian:\"mong\",Mro:\"mroo\",Meetei_Mayek:\"mtei\",Myanmar:[\"mym2\",\"mymr\"],Old_North_Arabian:\"narb\",Nabataean:\"nbat\",Nko:\"nko \",Ogham:\"ogam\",Ol_Chiki:\"olck\",Old_Turkic:\"orkh\",Oriya:[\"ory2\",\"orya\"],Osmanya:\"osma\",Palmyrene:\"palm\",Pau_Cin_Hau:\"pauc\",Old_Permic:\"perm\",Phags_Pa:\"phag\",Inscriptional_Pahlavi:\"phli\",Psalter_Pahlavi:\"phlp\",Phoenician:\"phnx\",Miao:\"plrd\",Inscriptional_Parthian:\"prti\",Rejang:\"rjng\",Runic:\"runr\",Samaritan:\"samr\",Old_South_Arabian:\"sarb\",Saurashtra:\"saur\",Shavian:\"shaw\",Sharada:\"shrd\",Siddham:\"sidd\",Khudawadi:\"sind\",Sinhala:\"sinh\",Sora_Sompeng:\"sora\",Sundanese:\"sund\",Syloti_Nagri:\"sylo\",Syriac:\"syrc\",Tagbanwa:\"tagb\",Takri:\"takr\",Tai_Le:\"tale\",New_Tai_Lue:\"talu\",Tamil:[\"tml2\",\"taml\"],Tai_Viet:\"tavt\",Telugu:[\"tel2\",\"telu\"],Tifinagh:\"tfng\",Tagalog:\"tglg\",Thaana:\"thaa\",Thai:\"thai\",Tibetan:\"tibt\",Tirhuta:\"tirh\",Ugaritic:\"ugar\",Vai:\"vai \",Warang_Citi:\"wara\",Old_Persian:\"xpeo\",Cuneiform:\"xsux\",Yi:\"yi  \",Inherited:\"zinh\",Common:\"zyyy\",Unknown:\"zzzz\"},si={};for(var li in oi){var ui=oi[li];if(Array.isArray(ui)){var ci=ui,hi=Array.isArray(ci),fi=0;for(ci=hi?ci:s(ci);;){var di;if(hi){if(fi>=ci.length)break;di=ci[fi++]}else{if((fi=ci.next()).done)break;di=fi.value}si[di]=li}}else si[ui]=li}var pi={arab:!0,hebr:!0,syrc:!0,thaa:!0,cprt:!0,khar:!0,phnx:!0,\"nko \":!0,lydi:!0,avst:!0,armi:!0,phli:!0,prti:!0,sarb:!0,orkh:!0,samr:!0,mand:!0,merc:!0,mero:!0,mani:!0,mend:!0,nbat:!0,narb:!0,palm:!0,phlp:!0};function gi(t){return pi[t]?\"rtl\":\"ltr\"}for(var yi=function(){function t(e,n,r,i,a){if(f(this,t),this.glyphs=e,this.positions=null,this.script=r,this.language=i||null,this.direction=a||gi(r),this.features={},Array.isArray(n)){var o=n,l=Array.isArray(o),u=0;for(o=l?o:s(o);;){var h;if(l){if(u>=o.length)break;h=o[u++]}else{if((u=o.next()).done)break;h=u.value}var d=h;this.features[d]=!0}}else\"object\"===(void 0===n?\"undefined\":c(n))&&(this.features=n)}return d(t,[{key:\"advanceWidth\",get:function(){var t=0,e=this.positions,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}t+=i.xAdvance}return t}},{key:\"advanceHeight\",get:function(){var t=0,e=this.positions,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}t+=i.yAdvance}return t}},{key:\"bbox\",get:function(){for(var t=new ai,e=0,n=0,r=0;r<this.glyphs.length;r++){var i=this.glyphs[r],a=this.positions[r],o=i.bbox;t.addPoint(o.minX+e+a.xOffset,o.minY+n+a.yOffset),t.addPoint(o.maxX+e+a.xOffset,o.maxY+n+a.yOffset),e+=a.xAdvance,n+=a.yAdvance}return t}}]),t}(),vi={allTypographicFeatures:{code:0,exclusive:!1,allTypeFeatures:0},ligatures:{code:1,exclusive:!1,requiredLigatures:0,commonLigatures:2,rareLigatures:4,rebusPictures:8,diphthongLigatures:10,squaredLigatures:12,abbrevSquaredLigatures:14,symbolLigatures:16,contextualLigatures:18,historicalLigatures:20},cursiveConnection:{code:2,exclusive:!0,unconnected:0,partiallyConnected:1,cursive:2},letterCase:{code:3,exclusive:!0},verticalSubstitution:{code:4,exclusive:!1,substituteVerticalForms:0},linguisticRearrangement:{code:5,exclusive:!1,linguisticRearrangement:0},numberSpacing:{code:6,exclusive:!0,monospacedNumbers:0,proportionalNumbers:1,thirdWidthNumbers:2,quarterWidthNumbers:3},smartSwash:{code:8,exclusive:!1,wordInitialSwashes:0,wordFinalSwashes:2,nonFinalSwashes:8},diacritics:{code:9,exclusive:!0,showDiacritics:0,hideDiacritics:1,decomposeDiacritics:2},verticalPosition:{code:10,exclusive:!0,normalPosition:0,superiors:1,inferiors:2,ordinals:3,scientificInferiors:4},fractions:{code:11,exclusive:!0,noFractions:0,verticalFractions:1,diagonalFractions:2},overlappingCharacters:{code:13,exclusive:!1,preventOverlap:0},typographicExtras:{code:14,exclusive:!1,slashedZero:4},mathematicalExtras:{code:15,exclusive:!1,mathematicalGreek:10},ornamentSets:{code:16,exclusive:!0,noOrnaments:0,dingbats:1,piCharacters:2,fleurons:3,decorativeBorders:4,internationalSymbols:5,mathSymbols:6},characterAlternatives:{code:17,exclusive:!0,noAlternates:0},designComplexity:{code:18,exclusive:!0,designLevel1:0,designLevel2:1,designLevel3:2,designLevel4:3,designLevel5:4},styleOptions:{code:19,exclusive:!0,noStyleOptions:0,displayText:1,engravedText:2,illuminatedCaps:3,titlingCaps:4,tallCaps:5},characterShape:{code:20,exclusive:!0,traditionalCharacters:0,simplifiedCharacters:1,JIS1978Characters:2,JIS1983Characters:3,JIS1990Characters:4,traditionalAltOne:5,traditionalAltTwo:6,traditionalAltThree:7,traditionalAltFour:8,traditionalAltFive:9,expertCharacters:10,JIS2004Characters:11,hojoCharacters:12,NLCCharacters:13,traditionalNamesCharacters:14},numberCase:{code:21,exclusive:!0,lowerCaseNumbers:0,upperCaseNumbers:1},textSpacing:{code:22,exclusive:!0,proportionalText:0,monospacedText:1,halfWidthText:2,thirdWidthText:3,quarterWidthText:4,altProportionalText:5,altHalfWidthText:6},transliteration:{code:23,exclusive:!0,noTransliteration:0},annotation:{code:24,exclusive:!0,noAnnotation:0,boxAnnotation:1,roundedBoxAnnotation:2,circleAnnotation:3,invertedCircleAnnotation:4,parenthesisAnnotation:5,periodAnnotation:6,romanNumeralAnnotation:7,diamondAnnotation:8,invertedBoxAnnotation:9,invertedRoundedBoxAnnotation:10},kanaSpacing:{code:25,exclusive:!0,fullWidthKana:0,proportionalKana:1},ideographicSpacing:{code:26,exclusive:!0,fullWidthIdeographs:0,proportionalIdeographs:1,halfWidthIdeographs:2},unicodeDecomposition:{code:27,exclusive:!1,canonicalComposition:0,compatibilityComposition:2,transcodingComposition:4},rubyKana:{code:28,exclusive:!1,rubyKana:2},CJKSymbolAlternatives:{code:29,exclusive:!0,noCJKSymbolAlternatives:0,CJKSymbolAltOne:1,CJKSymbolAltTwo:2,CJKSymbolAltThree:3,CJKSymbolAltFour:4,CJKSymbolAltFive:5},ideographicAlternatives:{code:30,exclusive:!0,noIdeographicAlternatives:0,ideographicAltOne:1,ideographicAltTwo:2,ideographicAltThree:3,ideographicAltFour:4,ideographicAltFive:5},CJKVerticalRomanPlacement:{code:31,exclusive:!0,CJKVerticalRomanCentered:0,CJKVerticalRomanHBaseline:1},italicCJKRoman:{code:32,exclusive:!1,CJKItalicRoman:2},caseSensitiveLayout:{code:33,exclusive:!1,caseSensitiveLayout:0,caseSensitiveSpacing:2},alternateKana:{code:34,exclusive:!1,alternateHorizKana:0,alternateVertKana:2},stylisticAlternatives:{code:35,exclusive:!1,noStylisticAlternates:0,stylisticAltOne:2,stylisticAltTwo:4,stylisticAltThree:6,stylisticAltFour:8,stylisticAltFive:10,stylisticAltSix:12,stylisticAltSeven:14,stylisticAltEight:16,stylisticAltNine:18,stylisticAltTen:20,stylisticAltEleven:22,stylisticAltTwelve:24,stylisticAltThirteen:26,stylisticAltFourteen:28,stylisticAltFifteen:30,stylisticAltSixteen:32,stylisticAltSeventeen:34,stylisticAltEighteen:36,stylisticAltNineteen:38,stylisticAltTwenty:40},contextualAlternates:{code:36,exclusive:!1,contextualAlternates:0,swashAlternates:2,contextualSwashAlternates:4},lowerCase:{code:37,exclusive:!0,defaultLowerCase:0,lowerCaseSmallCaps:1,lowerCasePetiteCaps:2},upperCase:{code:38,exclusive:!0,defaultUpperCase:0,upperCaseSmallCaps:1,upperCasePetiteCaps:2},languageTag:{code:39,exclusive:!0},CJKRomanSpacing:{code:103,exclusive:!0,halfWidthCJKRoman:0,proportionalCJKRoman:1,defaultCJKRoman:2,fullWidthCJKRoman:3}},bi=function(t,e){return[vi[t].code,vi[t][e]]},mi={rlig:bi(\"ligatures\",\"requiredLigatures\"),clig:bi(\"ligatures\",\"contextualLigatures\"),dlig:bi(\"ligatures\",\"rareLigatures\"),hlig:bi(\"ligatures\",\"historicalLigatures\"),liga:bi(\"ligatures\",\"commonLigatures\"),hist:bi(\"ligatures\",\"historicalLigatures\"),smcp:bi(\"lowerCase\",\"lowerCaseSmallCaps\"),pcap:bi(\"lowerCase\",\"lowerCasePetiteCaps\"),frac:bi(\"fractions\",\"diagonalFractions\"),dnom:bi(\"fractions\",\"diagonalFractions\"),numr:bi(\"fractions\",\"diagonalFractions\"),afrc:bi(\"fractions\",\"verticalFractions\"),case:bi(\"caseSensitiveLayout\",\"caseSensitiveLayout\"),ccmp:bi(\"unicodeDecomposition\",\"canonicalComposition\"),cpct:bi(\"CJKVerticalRomanPlacement\",\"CJKVerticalRomanCentered\"),valt:bi(\"CJKVerticalRomanPlacement\",\"CJKVerticalRomanCentered\"),swsh:bi(\"contextualAlternates\",\"swashAlternates\"),cswh:bi(\"contextualAlternates\",\"contextualSwashAlternates\"),curs:bi(\"cursiveConnection\",\"cursive\"),c2pc:bi(\"upperCase\",\"upperCasePetiteCaps\"),c2sc:bi(\"upperCase\",\"upperCaseSmallCaps\"),init:bi(\"smartSwash\",\"wordInitialSwashes\"),fin2:bi(\"smartSwash\",\"wordFinalSwashes\"),medi:bi(\"smartSwash\",\"nonFinalSwashes\"),med2:bi(\"smartSwash\",\"nonFinalSwashes\"),fin3:bi(\"smartSwash\",\"wordFinalSwashes\"),fina:bi(\"smartSwash\",\"wordFinalSwashes\"),pkna:bi(\"kanaSpacing\",\"proportionalKana\"),half:bi(\"textSpacing\",\"halfWidthText\"),halt:bi(\"textSpacing\",\"altHalfWidthText\"),hkna:bi(\"alternateKana\",\"alternateHorizKana\"),vkna:bi(\"alternateKana\",\"alternateVertKana\"),ital:bi(\"italicCJKRoman\",\"CJKItalicRoman\"),lnum:bi(\"numberCase\",\"upperCaseNumbers\"),onum:bi(\"numberCase\",\"lowerCaseNumbers\"),mgrk:bi(\"mathematicalExtras\",\"mathematicalGreek\"),calt:bi(\"contextualAlternates\",\"contextualAlternates\"),vrt2:bi(\"verticalSubstitution\",\"substituteVerticalForms\"),vert:bi(\"verticalSubstitution\",\"substituteVerticalForms\"),tnum:bi(\"numberSpacing\",\"monospacedNumbers\"),pnum:bi(\"numberSpacing\",\"proportionalNumbers\"),sups:bi(\"verticalPosition\",\"superiors\"),subs:bi(\"verticalPosition\",\"inferiors\"),ordn:bi(\"verticalPosition\",\"ordinals\"),pwid:bi(\"textSpacing\",\"proportionalText\"),hwid:bi(\"textSpacing\",\"halfWidthText\"),qwid:bi(\"textSpacing\",\"quarterWidthText\"),twid:bi(\"textSpacing\",\"thirdWidthText\"),fwid:bi(\"textSpacing\",\"proportionalText\"),palt:bi(\"textSpacing\",\"altProportionalText\"),trad:bi(\"characterShape\",\"traditionalCharacters\"),smpl:bi(\"characterShape\",\"simplifiedCharacters\"),jp78:bi(\"characterShape\",\"JIS1978Characters\"),jp83:bi(\"characterShape\",\"JIS1983Characters\"),jp90:bi(\"characterShape\",\"JIS1990Characters\"),jp04:bi(\"characterShape\",\"JIS2004Characters\"),expt:bi(\"characterShape\",\"expertCharacters\"),hojo:bi(\"characterShape\",\"hojoCharacters\"),nlck:bi(\"characterShape\",\"NLCCharacters\"),tnam:bi(\"characterShape\",\"traditionalNamesCharacters\"),ruby:bi(\"rubyKana\",\"rubyKana\"),titl:bi(\"styleOptions\",\"titlingCaps\"),zero:bi(\"typographicExtras\",\"slashedZero\"),ss01:bi(\"stylisticAlternatives\",\"stylisticAltOne\"),ss02:bi(\"stylisticAlternatives\",\"stylisticAltTwo\"),ss03:bi(\"stylisticAlternatives\",\"stylisticAltThree\"),ss04:bi(\"stylisticAlternatives\",\"stylisticAltFour\"),ss05:bi(\"stylisticAlternatives\",\"stylisticAltFive\"),ss06:bi(\"stylisticAlternatives\",\"stylisticAltSix\"),ss07:bi(\"stylisticAlternatives\",\"stylisticAltSeven\"),ss08:bi(\"stylisticAlternatives\",\"stylisticAltEight\"),ss09:bi(\"stylisticAlternatives\",\"stylisticAltNine\"),ss10:bi(\"stylisticAlternatives\",\"stylisticAltTen\"),ss11:bi(\"stylisticAlternatives\",\"stylisticAltEleven\"),ss12:bi(\"stylisticAlternatives\",\"stylisticAltTwelve\"),ss13:bi(\"stylisticAlternatives\",\"stylisticAltThirteen\"),ss14:bi(\"stylisticAlternatives\",\"stylisticAltFourteen\"),ss15:bi(\"stylisticAlternatives\",\"stylisticAltFifteen\"),ss16:bi(\"stylisticAlternatives\",\"stylisticAltSixteen\"),ss17:bi(\"stylisticAlternatives\",\"stylisticAltSeventeen\"),ss18:bi(\"stylisticAlternatives\",\"stylisticAltEighteen\"),ss19:bi(\"stylisticAlternatives\",\"stylisticAltNineteen\"),ss20:bi(\"stylisticAlternatives\",\"stylisticAltTwenty\")},wi=1;wi<=99;wi++)mi[\"cv\"+(\"00\"+wi).slice(-2)]=[vi.characterAlternatives.code,wi];var xi,Si={};for(var _i in mi){var ki=mi[_i];null==Si[ki[0]]&&(Si[ki[0]]={}),Si[ki[0]][ki[1]]=_i}function Ci(t){var e=t[0],n=t[1];if(isNaN(e))var r=vi[e]&&vi[e].code;else r=e;if(isNaN(n))var i=vi[e]&&vi[e][n];else i=n;return[r,i]}var Ai,Pi,Ei,Ii,Ti,Oi,Li,Bi=(xi=function(){function t(e){f(this,t),this.table=e}return t.prototype.lookup=function(t){switch(this.table.version){case 0:return this.table.values.getItem(t);case 2:case 4:for(var e=0,n=this.table.binarySearchHeader.nUnits-1;e<=n;){var r=e+n>>1;if(65535===(o=this.table.segments[r]).firstGlyph)return null;if(t<o.firstGlyph)n=r-1;else{if(!(t>o.lastGlyph))return 2===this.table.version?o.value:o.values[t-o.firstGlyph];e=r+1}}return null;case 6:for(var i=0,a=this.table.binarySearchHeader.nUnits-1;i<=a;){var o;r=i+a>>1;if(65535===(o=this.table.segments[r]).glyph)return null;if(t<o.glyph)a=r-1;else{if(!(t>o.glyph))return o.value;i=r+1}}return null;case 8:return this.table.values[t-this.table.firstGlyph];default:throw new Error(\"Unknown lookup table format: \"+this.table.version)}},t.prototype.glyphsForValue=function(t){var e=[];switch(this.table.version){case 2:case 4:var n=this.table.segments,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a;if(2===this.table.version&&o.value===t)e.push.apply(e,$r(o.firstGlyph,o.lastGlyph+1));else for(var l=0;l<o.values.length;l++)o.values[l]===t&&e.push(o.firstGlyph+l)}break;case 6:var u=this.table.segments,c=Array.isArray(u),h=0;for(u=c?u:s(u);;){var f;if(c){if(h>=u.length)break;f=u[h++]}else{if((h=u.next()).done)break;f=h.value}var d=f;d.value===t&&e.push(d.glyph)}break;case 8:for(var p=0;p<this.table.values.length;p++)this.table.values[p]===t&&e.push(this.table.firstGlyph+p);break;default:throw new Error(\"Unknown lookup table format: \"+this.table.version)}return e},t}(),Ai=xi.prototype,Pi=\"glyphsForValue\",Ei=[B],Ii=o(xi.prototype,\"glyphsForValue\"),Ti=xi.prototype,Oi={},Object.keys(Ii).forEach(function(t){Oi[t]=Ii[t]}),Oi.enumerable=!!Oi.enumerable,Oi.configurable=!!Oi.configurable,(\"value\"in Oi||Oi.initializer)&&(Oi.writable=!0),Oi=Ei.slice().reverse().reduce(function(t,e){return e(Ai,Pi,t)||t},Oi),Ti&&void 0!==Oi.initializer&&(Oi.value=Oi.initializer?Oi.initializer.call(Ti):void 0,Oi.initializer=void 0),void 0===Oi.initializer&&(Object.defineProperty(Ai,Pi,Oi),Oi=null),xi),Mi=function(){function t(e){f(this,t),this.stateTable=e,this.lookupTable=new Bi(e.classTable)}return t.prototype.process=function(t,e,n){for(var r=0,i=e?t.length-1:0,a=e?-1:1;1===a&&i<=t.length||-1===a&&i>=-1;){var o=null,s=1,l=!0;i===t.length||-1===i?s=0:65535===(o=t[i]).id?s=2:null==(s=this.lookupTable.lookup(o.id))&&(s=1);var u=this.stateTable.stateArray.getItem(r)[s],c=this.stateTable.entryTable.getItem(u);0!==s&&2!==s&&(n(o,c,i),l=!(16384&c.flags)),r=c.newState,l&&(i+=a)}return t},t.prototype.traverse=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:new _;if(!n.has(e)){n.add(e);for(var r=this.stateTable,i=r.nClasses,a=r.stateArray,o=r.entryTable,l=a.getItem(e),u=4;u<i;u++){var c=l[u],h=o.getItem(c),f=this.lookupTable.glyphsForValue(u),d=Array.isArray(f),p=0;for(f=d?f:s(f);;){var g;if(d){if(p>=f.length)break;g=f[p++]}else{if((p=f.next()).done)break;g=p.value}var y=g;t.enter&&t.enter(y,h),0!==h.newState&&this.traverse(t,h.newState,n),t.exit&&t.exit(y,h)}}}},t}();var Ri,Fi,Di,zi,Ni,Ui,Wi=(Li=function(){function t(e){f(this,t),this.processIndicRearragement=this.processIndicRearragement.bind(this),this.processContextualSubstitution=this.processContextualSubstitution.bind(this),this.processLigature=this.processLigature.bind(this),this.processNoncontextualSubstitutions=this.processNoncontextualSubstitutions.bind(this),this.processGlyphInsertion=this.processGlyphInsertion.bind(this),this.font=e,this.morx=e.morx,this.inputCache=null}return t.prototype.process=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this.morx.chains,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=o.defaultFlags,u=o.features,c=Array.isArray(u),h=0;for(u=c?u:s(u);;){var f;if(c){if(h>=u.length)break;f=u[h++]}else{if((h=u.next()).done)break;f=h.value}var d,p=f;(d=e[p.featureType])&&d[p.featureSetting]&&(l&=p.disableFlags,l|=p.enableFlags)}var g=o.subtables,y=Array.isArray(g),v=0;for(g=y?g:s(g);;){var b;if(y){if(v>=g.length)break;b=g[v++]}else{if((v=g.next()).done)break;b=v.value}var m=b;m.subFeatureFlags&l&&this.processSubtable(m,t)}}for(var w=t.length-1;w>=0;)65535===t[w].id&&t.splice(w,1),w--;return t},t.prototype.processSubtable=function(t,e){if(this.subtable=t,this.glyphs=e,4!==this.subtable.type){this.ligatureStack=[],this.markedGlyph=null,this.firstGlyph=null,this.lastGlyph=null,this.markedIndex=null;var n=this.getStateMachine(t),r=this.getProcessor(),i=!!(4194304&this.subtable.coverage);return n.process(this.glyphs,i,r)}this.processNoncontextualSubstitutions(this.subtable,this.glyphs)},t.prototype.getStateMachine=function(t){return new Mi(t.table.stateTable)},t.prototype.getProcessor=function(){switch(this.subtable.type){case 0:return this.processIndicRearragement;case 1:return this.processContextualSubstitution;case 2:return this.processLigature;case 4:return this.processNoncontextualSubstitutions;case 5:return this.processGlyphInsertion;default:throw new Error(\"Invalid morx subtable type: \"+this.subtable.type)}},t.prototype.processIndicRearragement=function(t,e,n){32768&e.flags&&(this.firstGlyph=n),8192&e.flags&&(this.lastGlyph=n),function(t,e,n,r){switch(e){case 0:return t;case 1:return Gi(t,[n,1],[r,0]);case 2:return Gi(t,[n,0],[r,1]);case 3:return Gi(t,[n,1],[r,1]);case 4:return Gi(t,[n,2],[r,0]);case 5:return Gi(t,[n,2],[r,0],!0,!1);case 6:return Gi(t,[n,0],[r,2]);case 7:return Gi(t,[n,0],[r,2],!1,!0);case 8:return Gi(t,[n,1],[r,2]);case 9:return Gi(t,[n,1],[r,2],!1,!0);case 10:return Gi(t,[n,2],[r,1]);case 11:return Gi(t,[n,2],[r,1],!0,!1);case 12:return Gi(t,[n,2],[r,2]);case 13:return Gi(t,[n,2],[r,2],!0,!1);case 14:return Gi(t,[n,2],[r,2],!1,!0);case 15:return Gi(t,[n,2],[r,2],!0,!0);default:throw new Error(\"Unknown verb: \"+e)}}(this.glyphs,15&e.flags,this.firstGlyph,this.lastGlyph)},t.prototype.processContextualSubstitution=function(t,e,n){var r=this.subtable.table.substitutionTable.items;if(65535!==e.markIndex){var i=r.getItem(e.markIndex),a=new Bi(i);t=this.glyphs[this.markedGlyph],(o=a.lookup(t.id))&&(this.glyphs[this.markedGlyph]=this.font.getGlyph(o,t.codePoints))}if(65535!==e.currentIndex){var o,s=r.getItem(e.currentIndex),l=new Bi(s);t=this.glyphs[n],(o=l.lookup(t.id))&&(this.glyphs[n]=this.font.getGlyph(o,t.codePoints))}32768&e.flags&&(this.markedGlyph=n)},t.prototype.processLigature=function(t,e,n){if(32768&e.flags&&this.ligatureStack.push(n),8192&e.flags){for(var r,i=this.subtable.table.ligatureActions,a=this.subtable.table.components,o=this.subtable.table.ligatureList,s=e.action,l=!1,u=0,c=[],h=[];!l;){var f,d=this.ligatureStack.pop();(f=c).unshift.apply(f,this.glyphs[d].codePoints);var p=i.getItem(s++);l=!!(2147483648&p);var g=!!(1073741824&p),y=(1073741823&p)<<2>>2;if(y+=this.glyphs[d].id,u+=a.getItem(y),l||g){var v=o.getItem(u);this.glyphs[d]=this.font.getGlyph(v,c),h.push(d),u=0,c=[]}else this.glyphs[d]=this.font.getGlyph(65535)}(r=this.ligatureStack).push.apply(r,h)}},t.prototype.processNoncontextualSubstitutions=function(t,e,n){var r=new Bi(t.table.lookupTable);for(n=0;n<e.length;n++){var i=e[n];if(65535!==i.id){var a=r.lookup(i.id);a&&(e[n]=this.font.getGlyph(a,i.codePoints))}}},t.prototype._insertGlyphs=function(t,e,n,r){for(var i,a=[];n--;){var o=this.subtable.table.insertionActions.getItem(e++);a.push(this.font.getGlyph(o))}r||t++,(i=this.glyphs).splice.apply(i,[t,0].concat(a))},t.prototype.processGlyphInsertion=function(t,e,n){if(32768&e.flags&&(this.markedIndex=n),65535!==e.markedInsertIndex){var r=(31&e.flags)>>>5,i=!!(1024&e.flags);this._insertGlyphs(this.markedIndex,e.markedInsertIndex,r,i)}if(65535!==e.currentInsertIndex){var a=(992&e.flags)>>>5,o=!!(2048&e.flags);this._insertGlyphs(n,e.currentInsertIndex,a,o)}},t.prototype.getSupportedFeatures=function(){var t=[],e=this.morx.chains,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i.features,o=Array.isArray(a),l=0;for(a=o?a:s(a);;){var u;if(o){if(l>=a.length)break;u=a[l++]}else{if((l=a.next()).done)break;u=l.value}var c=u;t.push([c.featureType,c.featureSetting])}}return t},t.prototype.generateInputs=function(t){return this.inputCache||this.generateInputCache(),this.inputCache[t]||[]},t.prototype.generateInputCache=function(){this.inputCache={};var t=this.morx.chains,e=Array.isArray(t),n=0;for(t=e?t:s(t);;){var r;if(e){if(n>=t.length)break;r=t[n++]}else{if((n=t.next()).done)break;r=n.value}var i=r,a=i.defaultFlags,o=i.subtables,l=Array.isArray(o),u=0;for(o=l?o:s(o);;){var c;if(l){if(u>=o.length)break;c=o[u++]}else{if((u=o.next()).done)break;c=u.value}var h=c;h.subFeatureFlags&a&&this.generateInputsForSubtable(h)}}},t.prototype.generateInputsForSubtable=function(t){var e=this;if(2===t.type){if(!!(4194304&t.coverage))throw new Error(\"Reverse subtable, not supported.\");this.subtable=t,this.ligatureStack=[];var n=this.getStateMachine(t),r=this.getProcessor(),i=[],a=[];this.glyphs=[],n.traverse({enter:function(t,n){var o=e.glyphs;a.push({glyphs:o.slice(),ligatureStack:e.ligatureStack.slice()});var s=e.font.getGlyph(t);i.push(s),o.push(i[i.length-1]),r(o[o.length-1],n,o.length-1);for(var l=0,u=0,c=0;c<o.length&&l<=1;c++)65535!==o[c].id&&(l++,u=o[c].id);if(1===l){var h=i.map(function(t){return t.id}),f=e.inputCache[u];f?f.push(h):e.inputCache[u]=[h]}},exit:function(){var t=a.pop();e.glyphs=t.glyphs,e.ligatureStack=t.ligatureStack,i.pop()}})}},t}(),Ri=Li.prototype,Fi=\"getStateMachine\",Di=[B],zi=o(Li.prototype,\"getStateMachine\"),Ni=Li.prototype,Ui={},Object.keys(zi).forEach(function(t){Ui[t]=zi[t]}),Ui.enumerable=!!Ui.enumerable,Ui.configurable=!!Ui.configurable,(\"value\"in Ui||Ui.initializer)&&(Ui.writable=!0),Ui=Di.slice().reverse().reduce(function(t,e){return e(Ri,Fi,t)||t},Ui),Ni&&void 0!==Ui.initializer&&(Ui.value=Ui.initializer?Ui.initializer.call(Ni):void 0,Ui.initializer=void 0),void 0===Ui.initializer&&(Object.defineProperty(Ri,Fi,Ui),Ui=null),Li);function Gi(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=arguments.length>4&&void 0!==arguments[4]&&arguments[4],a=t.splice(n[0]-(n[1]-1),n[1]);i&&a.reverse();var o=t.splice.apply(t,[e[0],e[1]].concat(a));return r&&o.reverse(),t.splice.apply(t,[n[0]-(e[1]-1),0].concat(o)),t}var Vi,ji,Hi=function(){function t(e){f(this,t),this.font=e,this.morxProcessor=new Wi(e),this.fallbackPosition=!1}return t.prototype.substitute=function(t){\"rtl\"===t.direction&&t.glyphs.reverse(),this.morxProcessor.process(t.glyphs,function(t){var e={};for(var n in t){var r;(r=mi[n])&&(null==e[r[0]]&&(e[r[0]]={}),e[r[0]][r[1]]=t[n])}return e}(t.features))},t.prototype.getAvailableFeatures=function(t,e){return function(t){var e={};if(Array.isArray(t))for(var n=0;n<t.length;n++){var r,i=Ci(t[n]);(r=Si[i[0]]&&Si[i[0]][i[1]])&&(e[r]=!0)}else if(\"object\"===(void 0===t?\"undefined\":c(t)))for(var a in t){var o=t[a];for(var s in o){var l=void 0,h=Ci([a,s]);o[s]&&(l=Si[h[0]]&&Si[h[0]][h[1]])&&(e[l]=!0)}}return u(e)}(this.morxProcessor.getSupportedFeatures())},t.prototype.stringsForGlyph=function(t){var e=this.morxProcessor.generateInputs(t),n=new _,r=e,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o;this._addStrings(l,0,n,\"\")}return n},t.prototype._addStrings=function(t,e,n,r){var i=this.font._cmapProcessor.codePointsForGlyph(t[e]),a=Array.isArray(i),o=0;for(i=a?i:s(i);;){var l;if(a){if(o>=i.length)break;l=i[o++]}else{if((o=i.next()).done)break;l=o.value}var u=r+x(l);e<t.length-1?this._addStrings(t,e+1,n,u):n.add(u)}},t}(),qi=function(){function t(e,n,r){f(this,t),this.font=e,this.script=n,this.direction=r,this.stages=[],this.globalFeatures={},this.allFeatures={}}return t.prototype._addFeatures=function(t,e){var n=this.stages.length-1,r=this.stages[n],i=t,a=Array.isArray(i),o=0;for(i=a?i:s(i);;){var l;if(a){if(o>=i.length)break;l=i[o++]}else{if((o=i.next()).done)break;l=o.value}var u=l;null==this.allFeatures[u]&&(r.push(u),this.allFeatures[u]=n,e&&(this.globalFeatures[u]=!0))}},t.prototype.add=function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(0===this.stages.length&&this.stages.push([]),\"string\"==typeof t&&(t=[t]),Array.isArray(t))this._addFeatures(t,e);else{if(\"object\"!==(void 0===t?\"undefined\":c(t)))throw new Error(\"Unsupported argument to ShapingPlan#add\");this._addFeatures(t.global||[],!0),this._addFeatures(t.local||[],!1)}},t.prototype.addStage=function(t,e){\"function\"==typeof t?this.stages.push(t,[]):(this.stages.push([]),this.add(t,e))},t.prototype.setFeatureOverrides=function(t){if(Array.isArray(t))this.add(t);else if(\"object\"===(void 0===t?\"undefined\":c(t)))for(var e in t)if(t[e])this.add(e);else if(null!=this.allFeatures[e]){var n=this.stages[this.allFeatures[e]];n.splice(n.indexOf(e),1),delete this.allFeatures[e],delete this.globalFeatures[e]}},t.prototype.assignGlobalFeatures=function(t){var e=t,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i;for(var o in this.globalFeatures)a.features[o]=!0}},t.prototype.process=function(t,e,n){var r=this.stages,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o;\"function\"==typeof l?n||l(this.font,e,this):l.length>0&&t.applyFeatures(l,e,n)}},t}(),Zi=[\"rvrn\"],Yi=[\"ccmp\",\"locl\",\"rlig\",\"mark\",\"mkmk\"],Xi=[\"frac\",\"numr\",\"dnom\"],Ki=[\"calt\",\"clig\",\"liga\",\"rclt\",\"curs\",\"kern\"],Ji={ltr:[\"ltra\",\"ltrm\"],rtl:[\"rtla\",\"rtlm\"]},Qi=(ji=Vi=function(){function t(){f(this,t)}return t.plan=function(t,e,n){this.planPreprocessing(t),this.planFeatures(t),this.planPostprocessing(t,n),t.assignGlobalFeatures(e),this.assignFeatures(t,e)},t.planPreprocessing=function(t){t.add({global:[].concat(Zi,Ji[t.direction]),local:Xi})},t.planFeatures=function(t){},t.planPostprocessing=function(t,e){t.add([].concat(Yi,Ki)),t.setFeatureOverrides(e)},t.assignFeatures=function(t,e){for(var n=0;n<e.length;n++){var r=e[n];if(8260===r.codePoints[0]){for(var i=n,a=n+1;i>0&&k.isDigit(e[i-1].codePoints[0]);)e[i-1].features.numr=!0,e[i-1].features.frac=!0,i--;for(;a<e.length&&k.isDigit(e[a].codePoints[0]);)e[a].features.dnom=!0,e[a].features.frac=!0,a++;r.features.frac=!0,n=a-1}}},t}(),Vi.zeroMarkWidths=\"AFTER_GPOS\",ji),$i=new C(e(\"AAEQAAAAAAAAADGgAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0=\",\"base64\")),ta=[\"isol\",\"fina\",\"fin2\",\"fin3\",\"medi\",\"med2\",\"init\"],ea={Non_Joining:0,Left_Joining:1,Right_Joining:2,Dual_Joining:3,Join_Causing:3,ALAPH:4,\"DALATH RISH\":5,Transparent:6},na=\"isol\",ra=\"fina\",ia=\"medi\",aa=\"med2\",oa=\"init\",sa=null,la=[[[sa,sa,0],[sa,na,2],[sa,na,1],[sa,na,2],[sa,na,1],[sa,na,6]],[[sa,sa,0],[sa,na,2],[sa,na,1],[sa,na,2],[sa,\"fin2\",5],[sa,na,6]],[[sa,sa,0],[sa,na,2],[oa,ra,1],[oa,ra,3],[oa,ra,4],[oa,ra,6]],[[sa,sa,0],[sa,na,2],[ia,ra,1],[ia,ra,3],[ia,ra,4],[ia,ra,6]],[[sa,sa,0],[sa,na,2],[aa,na,1],[aa,na,2],[aa,\"fin2\",5],[aa,na,6]],[[sa,sa,0],[sa,na,2],[na,na,1],[na,na,2],[na,\"fin2\",5],[na,na,6]],[[sa,sa,0],[sa,na,2],[sa,na,1],[sa,na,2],[sa,\"fin3\",5],[sa,na,6]]],ua=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.planFeatures=function(t){t.add([\"ccmp\",\"locl\"]);for(var e=0;e<ta.length;e++){var n=ta[e];t.addStage(n,!1)}t.addStage(\"mset\")},e.assignFeatures=function(e,n){t.assignFeatures.call(this,e,n);for(var r=-1,i=0,a=[],o=0;o<n.length;o++){var s,l,u=ca((d=n[o]).codePoints[0]);if(u!==ea.Transparent){var c=la[i][u];l=c[0],s=c[1],i=c[2],l!==sa&&-1!==r&&(a[r]=l),a[o]=s,r=o}else a[o]=sa}for(var h=0;h<n.length;h++){var f,d=n[h];(f=a[h])&&(d.features[f]=!0)}},e}(Qi);function ca(t){var e=$i.get(t);if(e)return e-1;var n=k.getCategory(t);return\"Mn\"===n||\"Me\"===n||\"Cf\"===n?ea.Transparent:ea.Non_Joining}var ha,fa,da=function(){function t(e,n){f(this,t),this.glyphs=e,this.reset(n)}return t.prototype.reset=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;this.options=t,this.flags=t.flags||{},this.markAttachmentType=t.markAttachmentType||0,this.index=e},t.prototype.shouldIgnore=function(t){return this.flags.ignoreMarks&&t.isMark||this.flags.ignoreBaseGlyphs&&t.isBase||this.flags.ignoreLigatures&&t.isLigature||this.markAttachmentType&&t.isMark&&t.markAttachmentType!==this.markAttachmentType},t.prototype.move=function(t){for(this.index+=t;0<=this.index&&this.index<this.glyphs.length&&this.shouldIgnore(this.glyphs[this.index]);)this.index+=t;return 0>this.index||this.index>=this.glyphs.length?null:this.glyphs[this.index]},t.prototype.next=function(){return this.move(1)},t.prototype.prev=function(){return this.move(-1)},t.prototype.peek=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=this.index,n=this.increment(t);return this.index=e,n},t.prototype.peekIndex=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=this.index;this.increment(t);var n=this.index;return this.index=e,n},t.prototype.increment=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=t<0?-1:1;for(t=Math.abs(t);t--;)this.move(e);return this.glyphs[this.index]},d(t,[{key:\"cur\",get:function(){return this.glyphs[this.index]||null}}]),t}(),pa=[\"DFLT\",\"dflt\",\"latn\"],ga=function(){function t(e,n){f(this,t),this.font=e,this.table=n,this.script=null,this.scriptTag=null,this.language=null,this.languageTag=null,this.features={},this.lookups={},this.variationsIndex=e._variationProcessor?this.findVariationsIndex(e._variationProcessor.normalizedCoords):-1,this.selectScript(),this.glyphs=[],this.positions=[],this.ligatureID=1,this.currentFeature=null}return t.prototype.findScript=function(t){if(null==this.table.scriptList)return null;Array.isArray(t)||(t=[t]);var e=t,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i,o=this.table.scriptList,l=Array.isArray(o),u=0;for(o=l?o:s(o);;){var c;if(l){if(u>=o.length)break;c=o[u++]}else{if((u=o.next()).done)break;c=u.value}var h=c;if(h.tag===a)return h}}return null},t.prototype.selectScript=function(t,e,n){var r=!1,i=void 0;if(!this.script||t!==this.scriptTag){if((i=this.findScript(t))||(i=this.findScript(pa)),!i)return this.scriptTag;this.scriptTag=i.tag,this.script=i.script,this.language=null,this.languageTag=null,r=!0}if(n&&n===this.direction||(this.direction=n||gi(t)),e&&e.length<4&&(e+=\" \".repeat(4-e.length)),!e||e!==this.languageTag){this.language=null;var a=this.script.langSysRecords,o=Array.isArray(a),l=0;for(a=o?a:s(a);;){var u;if(o){if(l>=a.length)break;u=a[l++]}else{if((l=a.next()).done)break;u=l.value}var c=u;if(c.tag===e){this.language=c.langSys,this.languageTag=c.tag;break}}this.language||(this.language=this.script.defaultLangSys,this.languageTag=null),r=!0}if(r&&(this.features={},this.language)){var h=this.language.featureIndexes,f=Array.isArray(h),d=0;for(h=f?h:s(h);;){var p;if(f){if(d>=h.length)break;p=h[d++]}else{if((d=h.next()).done)break;p=d.value}var g=p,y=this.table.featureList[g],v=this.substituteFeatureForVariations(g);this.features[y.tag]=v||y.feature}}return this.scriptTag},t.prototype.lookupsForFeatures=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=arguments[1],n=[],r=t,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o,u=this.features[l];if(u){var c=u.lookupListIndexes,h=Array.isArray(c),f=0;for(c=h?c:s(c);;){var d;if(h){if(f>=c.length)break;d=c[f++]}else{if((f=c.next()).done)break;d=f.value}var p=d;e&&-1!==e.indexOf(p)||n.push({feature:l,index:p,lookup:this.table.lookupList.get(p)})}}}return n.sort(function(t,e){return t.index-e.index}),n},t.prototype.substituteFeatureForVariations=function(t){if(-1===this.variationsIndex)return null;var e=this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i;if(a.featureIndex===t)return a.alternateFeatureTable}return null},t.prototype.findVariationsIndex=function(t){var e=this.table.featureVariations;if(!e)return-1;for(var n=e.featureVariationRecords,r=0;r<n.length;r++){var i=n[r].conditionSet.conditionTable;if(this.variationConditionsMatch(i,t))return r}return-1},t.prototype.variationConditionsMatch=function(t,e){return t.every(function(t){var n=t.axisIndex<e.length?e[t.axisIndex]:0;return t.filterRangeMinValue<=n&&n<=t.filterRangeMaxValue})},t.prototype.applyFeatures=function(t,e,n){var r=this.lookupsForFeatures(t);this.applyLookups(r,e,n)},t.prototype.applyLookups=function(t,e,n){this.glyphs=e,this.positions=n,this.glyphIterator=new da(e);var r=t,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o,u=l.feature,c=l.lookup;for(this.currentFeature=u,this.glyphIterator.reset(c.flags);this.glyphIterator.index<e.length;)if(u in this.glyphIterator.cur.features){var h=c.subTables,f=Array.isArray(h),d=0;for(h=f?h:s(h);;){var p;if(f){if(d>=h.length)break;p=h[d++]}else{if((d=h.next()).done)break;p=d.value}var g=p;if(this.applyLookup(c.lookupType,g))break}this.glyphIterator.next()}else this.glyphIterator.next()}},t.prototype.applyLookup=function(t,e){throw new Error(\"applyLookup must be implemented by subclasses\")},t.prototype.applyLookupList=function(t){var e=this.glyphIterator.options,n=this.glyphIterator.index,r=t,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o;this.glyphIterator.reset(e,n),this.glyphIterator.increment(l.sequenceIndex);var u=this.table.lookupList.get(l.lookupListIndex);this.glyphIterator.reset(u.flags,this.glyphIterator.index);var c=u.subTables,h=Array.isArray(c),f=0;for(c=h?c:s(c);;){var d;if(h){if(f>=c.length)break;d=c[f++]}else{if((f=c.next()).done)break;d=f.value}var p=d;if(this.applyLookup(u.lookupType,p))break}}return this.glyphIterator.reset(e,n),!0},t.prototype.coverageIndex=function(t,e){switch(null==e&&(e=this.glyphIterator.cur.id),t.version){case 1:return t.glyphs.indexOf(e);case 2:var n=t.rangeRecords,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a;if(o.start<=e&&e<=o.end)return o.startCoverageIndex+e-o.start}}return-1},t.prototype.match=function(t,e,n,r){for(var i=this.glyphIterator.index,a=this.glyphIterator.increment(t),o=0;o<e.length&&a&&n(e[o],a);)r&&r.push(this.glyphIterator.index),o++,a=this.glyphIterator.next();return this.glyphIterator.index=i,!(o<e.length)&&(r||!0)},t.prototype.sequenceMatches=function(t,e){return this.match(t,e,function(t,e){return t===e.id})},t.prototype.sequenceMatchIndices=function(t,e){var n=this;return this.match(t,e,function(t,e){return n.currentFeature in e.features&&t===e.id},[])},t.prototype.coverageSequenceMatches=function(t,e){var n=this;return this.match(t,e,function(t,e){return n.coverageIndex(t,e.id)>=0})},t.prototype.getClassID=function(t,e){switch(e.version){case 1:var n=t-e.startGlyph;if(n>=0&&n<e.classValueArray.length)return e.classValueArray[n];break;case 2:var r=e.classRangeRecord,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o;if(l.start<=t&&t<=l.end)return l.class}}return 0},t.prototype.classSequenceMatches=function(t,e,n){var r=this;return this.match(t,e,function(t,e){return t===r.getClassID(e.id,n)})},t.prototype.applyContext=function(t){switch(t.version){case 1:var e=this.coverageIndex(t.coverage);if(-1===e)return!1;var n=t.ruleSets[e],r=n,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o;if(this.sequenceMatches(1,l.input))return this.applyLookupList(l.lookupRecords)}break;case 2:if(-1===this.coverageIndex(t.coverage))return!1;if(-1===(e=this.getClassID(this.glyphIterator.cur.id,t.classDef)))return!1;var u=n=t.classSet[e],c=Array.isArray(u),h=0;for(u=c?u:s(u);;){var f;if(c){if(h>=u.length)break;f=u[h++]}else{if((h=u.next()).done)break;f=h.value}var d=f;if(this.classSequenceMatches(1,d.classes,t.classDef))return this.applyLookupList(d.lookupRecords)}break;case 3:if(this.coverageSequenceMatches(0,t.coverages))return this.applyLookupList(t.lookupRecords)}return!1},t.prototype.applyChainingContext=function(t){switch(t.version){case 1:var e=this.coverageIndex(t.coverage);if(-1===e)return!1;var n=t.chainRuleSets[e],r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a;if(this.sequenceMatches(-o.backtrack.length,o.backtrack)&&this.sequenceMatches(1,o.input)&&this.sequenceMatches(1+o.input.length,o.lookahead))return this.applyLookupList(o.lookupRecords)}break;case 2:if(-1===this.coverageIndex(t.coverage))return!1;e=this.getClassID(this.glyphIterator.cur.id,t.inputClassDef);var l=t.chainClassSet[e];if(!l)return!1;var u=l,c=Array.isArray(u),h=0;for(u=c?u:s(u);;){var f;if(c){if(h>=u.length)break;f=u[h++]}else{if((h=u.next()).done)break;f=h.value}var d=f;if(this.classSequenceMatches(-d.backtrack.length,d.backtrack,t.backtrackClassDef)&&this.classSequenceMatches(1,d.input,t.inputClassDef)&&this.classSequenceMatches(1+d.input.length,d.lookahead,t.lookaheadClassDef))return this.applyLookupList(d.lookupRecords)}break;case 3:if(this.coverageSequenceMatches(-t.backtrackGlyphCount,t.backtrackCoverage)&&this.coverageSequenceMatches(0,t.inputCoverage)&&this.coverageSequenceMatches(t.inputGlyphCount,t.lookaheadCoverage))return this.applyLookupList(t.lookupRecords)}return!1},t}(),ya=function(){function t(e,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],i=arguments[3];if(f(this,t),this._font=e,this.codePoints=r,this.id=n,this.features={},Array.isArray(i))for(var a=0;a<i.length;a++){var o=i[a];this.features[o]=!0}else\"object\"===(void 0===i?\"undefined\":c(i))&&w(this.features,i);this.ligatureID=null,this.ligatureComponent=null,this.isLigated=!1,this.cursiveAttachment=null,this.markAttachment=null,this.shaperInfo=null,this.substituted=!1,this.isMultiplied=!1}return t.prototype.copy=function(){return new t(this._font,this.id,this.codePoints,this.features)},d(t,[{key:\"id\",get:function(){return this._id},set:function(t){this._id=t,this.substituted=!0;var e=this._font.GDEF;if(e&&e.glyphClassDef){var n=ga.prototype.getClassID(t,e.glyphClassDef);this.isBase=1===n,this.isLigature=2===n,this.isMark=3===n,this.markAttachmentType=e.markAttachClassDef?ga.prototype.getClassID(t,e.markAttachClassDef):0}else this.isMark=this.codePoints.every(k.isMark),this.isBase=!this.isMark,this.isLigature=this.codePoints.length>1,this.markAttachmentType=0}}]),t}(),va=(fa=ha=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.planFeatures=function(t){t.add([\"ljmo\",\"vjmo\",\"tjmo\"],!1)},e.assignFeatures=function(t,e){for(var n=0,r=0;r<e.length;){var i,a=e[r].codePoints[0],o=Ha(a),s=Ka[n][o];switch(i=s[0],n=s[1],i){case qa:t.font.hasGlyphForCodePoint(a)||(r=Qa(e,r,t.font));break;case Za:r=$a(e,r,t.font);break;case Ya:to(e,r,t.font);break;case Xa:r=eo(e,r,t.font)}r++}},e}(Qi),ha.zeroMarkWidths=\"NONE\",fa),ba=44032,ma=55204-ba+1,wa=4352,xa=4449,Sa=4519,_a=21,ka=28,Ca=wa+19-1,Aa=xa+_a-1,Pa=Sa+ka-1,Ea=9676,Ia=function(t){return 4352<=t&&t<=4447||43360<=t&&t<=43388},Ta=function(t){return 4448<=t&&t<=4519||55216<=t&&t<=55238},Oa=function(t){return 4520<=t&&t<=4607||55243<=t&&t<=55291},La=function(t){return 12334<=t&&t<=12335},Ba=function(t){return ba<=t&&t<=55204},Ma=function(t){return t-ba<ma&&(t-ba)%ka==0},Ra=function(t){return wa<=t&&t<=Ca},Fa=function(t){return xa<=t&&t<=Aa},Da=function(t){return Sa+1&&1<=t&&t<=Pa},za=0,Na=1,Ua=2,Wa=3,Ga=4,Va=5,ja=6;function Ha(t){return Ia(t)?Na:Ta(t)?Ua:Oa(t)?Wa:Ma(t)?Ga:Ba(t)?Va:La(t)?ja:za}var qa=1,Za=2,Ya=4,Xa=5,Ka=[[[0,0],[0,1],[0,0],[0,0],[qa,2],[qa,3],[Xa,0]],[[0,0],[0,1],[Za,2],[0,0],[qa,2],[qa,3],[Xa,0]],[[0,0],[0,1],[0,0],[Za,3],[qa,2],[qa,3],[Ya,0]],[[0,0],[0,1],[0,0],[0,0],[qa,2],[qa,3],[Ya,0]]];function Ja(t,e,n){return new ya(t,t.glyphForCodePoint(e).id,[e],n)}function Qa(t,e,n){var r=t[e],i=r.codePoints[0]-ba,a=Sa+i%ka,o=wa+(i=i/ka|0)/_a|0,s=xa+i%_a;if(!n.hasGlyphForCodePoint(o)||!n.hasGlyphForCodePoint(s)||a!==Sa&&!n.hasGlyphForCodePoint(a))return e;var l=Ja(n,o,r.features);l.features.ljmo=!0;var u=Ja(n,s,r.features);u.features.vjmo=!0;var c=[l,u];if(a>Sa){var h=Ja(n,a,r.features);h.features.tjmo=!0,c.push(h)}return t.splice.apply(t,[e,1].concat(c)),e+c.length-1}function $a(t,e,n){var r=t[e],i=Ha(t[e].codePoints[0]),a=t[e-1].codePoints[0],o=Ha(a),s=void 0,l=void 0,u=void 0,c=void 0;if(o===Ga&&i===Wa)s=a,c=r;else{i===Ua?(l=t[e-1],u=r):(l=t[e-2],u=t[e-1],c=r);var h=l.codePoints[0],f=u.codePoints[0];Ra(h)&&Fa(f)&&(s=ba+((h-wa)*_a+(f-xa))*ka)}var d=c&&c.codePoints[0]||Sa;if(null!=s&&(d===Sa||Da(d))){var p=s+(d-Sa);if(n.hasGlyphForCodePoint(p)){var g=o===Ua?3:2;return t.splice(e-g+1,g,Ja(n,p,r.features)),e-g+1}}return l&&(l.features.ljmo=!0),u&&(u.features.vjmo=!0),c&&(c.features.tjmo=!0),o===Ga?(Qa(t,e-1,n),e+1):e}function to(t,e,n){var r=t[e],i=t[e].codePoints[0];if(0!==n.glyphForCodePoint(i).advanceWidth){var a=function(t){switch(Ha(t)){case Ga:case Va:return 1;case Ua:return 2;case Wa:return 3}}(t[e-1].codePoints[0]);return t.splice(e,1),t.splice(e-a,0,r)}}function eo(t,e,n){var r=t[e],i=t[e].codePoints[0];if(n.hasGlyphForCodePoint(Ea)){var a=Ja(n,Ea,r.features),o=0===n.glyphForCodePoint(i).advanceWidth?e:e+1;t.splice(o,0,a),e++}return e}var no,ro,io={stateTable:[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],accepting:[!1,!0,!0,!0,!0,!0,!1,!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!0,!0,!0,!0,!0,!0,!1,!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!0,!0,!0,!1,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!1,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!1,!0,!0,!0,!1,!0,!1,!0,!0,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!1,!0,!0,!0,!0,!1,!0,!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!1,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!0,!1,!1,!0,!0,!0,!1,!0,!0,!1,!1,!0,!1,!0,!0,!1,!0,!0,!1,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!1,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!1,!0,!1,!0,!0,!0,!0,!1,!1,!1,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!0,!1,!0,!1,!0,!0,!1,!1,!0,!0,!1,!1,!0,!0,!0,!1,!0,!1,!0,!0,!0,!0,!1,!1,!1,!0,!1,!0,!0,!0,!0,!1,!1,!1,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!0,!1,!0,!0,!0,!0,!1,!1,!1,!1,!1,!1,!1,!0,!0,!1,!1,!0,!0,!1,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!0,!1,!0,!0,!1,!1,!1,!1,!1,!0,!0,!1,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!0,!1,!0,!0,!0,!0,!1,!1,!1,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!1,!0,!0,!1,!0,!0,!0],tags:[[],[\"broken_cluster\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"symbol_cluster\"],[],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"standalone_cluster\"]]},ao={categories:[\"O\",\"IND\",\"S\",\"GB\",\"B\",\"FM\",\"CGJ\",\"VMAbv\",\"VMPst\",\"VAbv\",\"VPst\",\"CMBlw\",\"VPre\",\"VBlw\",\"H\",\"VMBlw\",\"CMAbv\",\"MBlw\",\"CS\",\"R\",\"SUB\",\"MPst\",\"MPre\",\"FAbv\",\"FPst\",\"FBlw\",\"SMAbv\",\"SMBlw\",\"VMPre\",\"ZWNJ\",\"ZWJ\",\"WJ\",\"VS\",\"N\",\"HN\",\"MAbv\"],decompositions:{2507:[2503,2494],2508:[2503,2519],2888:[2887,2902],2891:[2887,2878],2892:[2887,2903],3018:[3014,3006],3019:[3015,3006],3020:[3014,3031],3144:[3142,3158],3264:[3263,3285],3271:[3270,3285],3272:[3270,3286],3274:[3270,3266],3275:[3270,3266,3285],3402:[3398,3390],3403:[3399,3390],3404:[3398,3415],3546:[3545,3530],3548:[3545,3535],3549:[3545,3535,3530],3550:[3545,3551],3635:[3661,3634],3763:[3789,3762],3955:[3953,3954],3957:[3953,3956],3958:[4018,3968],3959:[4018,3953,3968],3960:[4019,3968],3961:[4019,3953,3968],3969:[3953,3968],6971:[6970,6965],6973:[6972,6965],6976:[6974,6965],6977:[6975,6965],6979:[6978,6965],69934:[69937,69927],69935:[69938,69927],70475:[70471,70462],70476:[70471,70487],70843:[70841,70842],70844:[70841,70832],70846:[70841,70845],71098:[71096,71087],71099:[71097,71087]},stateTable:[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,23,0,0,2,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],accepting:[!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!1,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0,!0],tags:[[],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"virama_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"number_joiner_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"numeral_cluster\"]]},oo={X:1,C:2,V:4,N:8,H:16,ZWNJ:32,ZWJ:64,M:128,SM:256,VD:512,A:1024,Placeholder:2048,Dotted_Circle:4096,RS:8192,Coeng:16384,Repha:32768,Ra:65536,CM:1<<17,Symbol:1<<18},so={Start:1,Ra_To_Become_Reph:2,Pre_M:4,Pre_C:8,Base_C:16,After_Main:32,Above_C:64,Before_Sub:128,Below_C:256,After_Sub:512,Before_Post:1024,Post_C:2048,After_Post:4096,Final_C:8192,SMVD:16384,End:32768},lo=oo.C|oo.Ra|oo.CM|oo.V|oo.Placeholder|oo.Dotted_Circle,uo=oo.ZWJ|oo.ZWNJ,co=oo.H|oo.Coeng,ho={Default:{hasOldSpec:!1,virama:0,basePos:\"Last\",rephPos:so.Before_Post,rephMode:\"Implicit\",blwfMode:\"Pre_And_Post\"},Devanagari:{hasOldSpec:!0,virama:2381,basePos:\"Last\",rephPos:so.Before_Post,rephMode:\"Implicit\",blwfMode:\"Pre_And_Post\"},Bengali:{hasOldSpec:!0,virama:2509,basePos:\"Last\",rephPos:so.After_Sub,rephMode:\"Implicit\",blwfMode:\"Pre_And_Post\"},Gurmukhi:{hasOldSpec:!0,virama:2637,basePos:\"Last\",rephPos:so.Before_Sub,rephMode:\"Implicit\",blwfMode:\"Pre_And_Post\"},Gujarati:{hasOldSpec:!0,virama:2765,basePos:\"Last\",rephPos:so.Before_Post,rephMode:\"Implicit\",blwfMode:\"Pre_And_Post\"},Oriya:{hasOldSpec:!0,virama:2893,basePos:\"Last\",rephPos:so.After_Main,rephMode:\"Implicit\",blwfMode:\"Pre_And_Post\"},Tamil:{hasOldSpec:!0,virama:3021,basePos:\"Last\",rephPos:so.After_Post,rephMode:\"Implicit\",blwfMode:\"Pre_And_Post\"},Telugu:{hasOldSpec:!0,virama:3149,basePos:\"Last\",rephPos:so.After_Post,rephMode:\"Explicit\",blwfMode:\"Post_Only\"},Kannada:{hasOldSpec:!0,virama:3277,basePos:\"Last\",rephPos:so.After_Post,rephMode:\"Implicit\",blwfMode:\"Post_Only\"},Malayalam:{hasOldSpec:!0,virama:3405,basePos:\"Last\",rephPos:so.After_Main,rephMode:\"Log_Repha\",blwfMode:\"Pre_And_Post\"},Khmer:{hasOldSpec:!1,virama:6098,basePos:\"First\",rephPos:so.Ra_To_Become_Reph,rephMode:\"Vis_Repha\",blwfMode:\"Pre_And_Post\"}},fo={6078:[6081,6078],6079:[6081,6079],6080:[6081,6080],6084:[6081,6084],6085:[6081,6085]},po=ao.decompositions,go=new C(e(\"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\",\"base64\")),yo=new A(io),vo=(ro=no=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.planFeatures=function(t){var e;t.addStage(_o),t.addStage([\"locl\",\"ccmp\"]),t.addStage(Eo),t.addStage(\"nukt\"),t.addStage(\"akhn\"),t.addStage(\"rphf\",!1),t.addStage(\"rkrf\"),t.addStage(\"pref\",!1),t.addStage(\"blwf\",!1),t.addStage(\"abvf\",!1),t.addStage(\"half\",!1),t.addStage(\"pstf\",!1),t.addStage(\"vatu\"),t.addStage(\"cjct\"),t.addStage(\"cfar\",!1),t.addStage(Io),t.addStage({local:[\"init\"],global:[\"pres\",\"abvs\",\"blws\",\"psts\",\"haln\",\"dist\",\"abvm\",\"blwm\",\"calt\",\"clig\"]}),t.unicodeScript=(e=t.script,si[e]),t.indicConfig=ho[t.unicodeScript]||ho.Default,t.isOldSpec=t.indicConfig.hasOldSpec&&\"2\"!==t.script[t.script.length-1]},e.assignFeatures=function(t,e){for(var n=function(n){var r=e[n].codePoints[0],i=fo[r]||po[r];if(i){var a=i.map(function(r){var i=t.font.glyphForCodePoint(r);return new ya(t.font,i.id,[r],e[n].features)});e.splice.apply(e,[n,1].concat(a))}},r=e.length-1;r>=0;r--)n(r)},e}(Qi),no.zeroMarkWidths=\"NONE\",ro);function bo(t){return go.get(t.codePoints[0])>>8}function mo(t){return 1<<(255&go.get(t.codePoints[0]))}var wo,xo,So=function t(e,n,r,i){f(this,t),this.category=e,this.position=n,this.syllableType=r,this.syllable=i};function _o(t,e){var n=0,r=0,i=yo.match(e.map(bo)),a=Array.isArray(i),o=0;for(i=a?i:s(i);;){var l;if(a){if(o>=i.length)break;l=i[o++]}else{if((o=i.next()).done)break;l=o.value}var u=l,c=u[0],h=u[1],f=u[2];if(c>r){++n;for(var d=r;d<c;d++)e[d].shaperInfo=new So(oo.X,so.End,\"non_indic_cluster\",n)}++n;for(var p=c;p<=h;p++)e[p].shaperInfo=new So(1<<bo(e[p]),mo(e[p]),f[0],n);r=h+1}if(r<e.length){++n;for(var g=r;g<e.length;g++)e[g].shaperInfo=new So(oo.X,so.End,\"non_indic_cluster\",n)}}function ko(t){return t.shaperInfo.category&lo}function Co(t){return t.shaperInfo.category&uo}function Ao(t){return t.shaperInfo.category&co}function Po(t,e){var n=t,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a,o;if(r){if(i>=n.length)break;o=n[i++]}else{if((i=n.next()).done)break;o=i.value}o.features=((a={})[e]=!0,a)}return t[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([e],t),1===t.length}function Eo(t,e,n){var r,i,a,o=n.indicConfig,s=t._layoutEngine.engine.GSUBProcessor.features,l=t.glyphForCodePoint(9676).id,u=t.glyphForCodePoint(o.virama).id;if(u)for(var c=new ya(t,u,[o.virama]),h=0;h<e.length;h++)e[h].shaperInfo.position===so.Base_C&&(e[h].shaperInfo.position=(r=e[h].copy(),a=void 0,Po((a=[i=c,r,i]).slice(0,2),\"blwf\")||Po(a.slice(1,3),\"blwf\")?so.Below_C:Po(a.slice(0,2),\"pstf\")||Po(a.slice(1,3),\"pstf\")?so.Post_C:Po(a.slice(0,2),\"pref\")||Po(a.slice(1,3),\"pref\")?so.Post_C:so.Base_C));for(var f=0,d=To(e,0);f<e.length;d=To(e,f=d)){var p=e[f].shaperInfo,g=(p.category,p.syllableType);if(\"symbol_cluster\"!==g&&\"non_indic_cluster\"!==g){if(\"broken_cluster\"===g&&l){var y=new ya(t,l,[9676]);y.shaperInfo=new So(1<<bo(y),mo(y),e[f].shaperInfo.syllableType,e[f].shaperInfo.syllable);for(var v=f;v<d&&e[v].shaperInfo.category===oo.Repha;)v++;e.splice(v++,0,y),d++}var b=d,m=f,w=!1;if(o.rephPos!==so.Ra_To_Become_Reph&&s.rphf&&f+3<=d&&(\"Implicit\"===o.rephMode&&!Co(e[f+2])||\"Explicit\"===o.rephMode&&e[f+2].shaperInfo.category===oo.ZWJ)){var x=[e[f].copy(),e[f+1].copy(),e[f+2].copy()];if(Po(x.slice(0,2),\"rphf\")||\"Explicit\"===o.rephMode&&Po(x,\"rphf\")){for(m+=2;m<d&&Co(e[m]);)m++;b=f,w=!0}}else if(\"Log_Repha\"===o.rephMode&&e[f].shaperInfo.category===oo.Repha){for(m++;m<d&&Co(e[m]);)m++;b=f,w=!0}switch(o.basePos){case\"Last\":var S=d,_=!1;do{var k=e[--S].shaperInfo;if(ko(e[S])){if(k.position!==so.Below_C&&(k.position!==so.Post_C||_)){b=S;break}k.position===so.Below_C&&(_=!0),b=S}else if(f<S&&k.category===oo.ZWJ&&e[S-1].shaperInfo.category===oo.H)break}while(S>m);break;case\"First\":for(var C=(b=f)+1;C<d;C++)ko(e[C])&&(e[C].shaperInfo.position=so.Below_C)}w&&b===f&&m-b<=2&&(w=!1);for(var A=f;A<b;A++){var P=e[A].shaperInfo;P.position=Math.min(so.Pre_C,P.position)}b<d&&(e[b].shaperInfo.position=so.Base_C);for(var E=b+1;E<d;E++)if(e[E].shaperInfo.category===oo.M){for(var I=E+1;I<d;I++)if(ko(e[I])){e[I].shaperInfo.position=so.Final_C;break}break}if(w&&(e[f].shaperInfo.position=so.Ra_To_Become_Reph),n.isOldSpec)for(var T=\"Malayalam\"!==n.unicodeScript,O=b+1;O<d;O++)if(e[O].shaperInfo.category===oo.H){var L=void 0;for(L=d-1;L>O&&!(ko(e[L])||T&&e[L].shaperInfo.category===oo.H);L--);if(e[L].shaperInfo.category!==oo.H&&L>O){var B=e[O];e.splice.apply(e,[O,0].concat(e.splice(O+1,L-O))),e[L]=B}break}for(var M=so.Start,R=f;R<d;R++){var F=e[R].shaperInfo;if(F.category&(uo|oo.N|oo.RS|oo.CM|co&F.category)){if(F.position=M,F.category===oo.H&&F.position===so.Pre_M)for(var D=R;D>f;D--)if(e[D-1].shaperInfo.position!==so.Pre_M){F.position=e[D-1].shaperInfo.position;break}}else F.position!==so.SMVD&&(M=F.position)}for(var z=b,N=b+1;N<d;N++)if(ko(e[N])){for(var U=z+1;U<N;U++)e[U].shaperInfo.position<so.SMVD&&(e[U].shaperInfo.position=e[N].shaperInfo.position);z=N}else e[N].shaperInfo.category===oo.M&&(z=N);var W=e.slice(f,d);W.sort(function(t,e){return t.shaperInfo.position-e.shaperInfo.position}),e.splice.apply(e,[f,W.length].concat(W));for(var G=f;G<d;G++)if(e[G].shaperInfo.position===so.Base_C){b=G;break}for(var V=f;V<d&&e[V].shaperInfo.position===so.Ra_To_Become_Reph;V++)e[V].features.rphf=!0;for(var j=!n.isOldSpec&&\"Pre_And_Post\"===o.blwfMode,H=f;H<b;H++)e[H].features.half=!0,j&&(e[H].features.blwf=!0);for(var q=b+1;q<d;q++)e[q].features.abvf=!0,e[q].features.pstf=!0,e[q].features.blwf=!0;if(n.isOldSpec&&\"Devanagari\"===n.unicodeScript)for(var Z=f;Z+1<b;Z++)e[Z].shaperInfo.category!==oo.Ra||e[Z+1].shaperInfo.category!==oo.H||Z+1!==b&&e[Z+2].shaperInfo.category!==oo.ZWJ||(e[Z].features.blwf=!0,e[Z+1].features.blwf=!0);if(s.pref&&b+2<d)for(var Y=b+1;Y+2-1<d;Y++){if(Po([e[Y].copy(),e[Y+1].copy()],\"pref\")){for(var X=0;X<2;X++)e[Y++].features.pref=!0;if(s.cfar)for(;Y<d;Y++)e[Y].features.cfar=!0;break}}for(var K=f+1;K<d;K++)if(Co(e[K]))for(var J=e[K].shaperInfo.category===oo.ZWNJ,Q=K;Q--,J&&delete e[Q].features.half,Q>f&&!ko(e[Q]););}}}function Io(t,e,n){for(var r=n.indicConfig,i=t._layoutEngine.engine.GSUBProcessor.features,a=0,o=To(e,0);a<e.length;o=To(e,a=o)){for(var s=!!i.pref,l=a;l<o;l++)if(e[l].shaperInfo.position>=so.Base_C){if(s&&l+1<o)for(var u=l+1;u<o;u++)if(e[u].features.pref){if(!e[u].substituted||!e[u].isLigated||e[u].isMultiplied){for(l=u;l<o&&Ao(e[l]);)l++;e[l].shaperInfo.position=so.BASE_C,s=!1}break}if(\"Malayalam\"===n.unicodeScript)for(var c=l+1;c<o;c++){for(;c<o&&Co(e[c]);)c++;if(c===o||!Ao(e[c]))break;for(c++;c<o&&Co(e[c]);)c++;c<o&&ko(e[c])&&e[c].shaperInfo.position===so.Below_C&&(e[l=c].shaperInfo.position=so.Base_C)}a<l&&e[l].shaperInfo.position>so.Base_C&&l--;break}if(l===o&&a<l&&e[l-1].shaperInfo.category===oo.ZWJ&&l--,l<o)for(;a<l&&e[l].shaperInfo.category&(oo.N|co);)l--;if(a+1<o&&a<l){var h=l===o?l-2:l-1;if(\"Malayalam\"!==n.unicodeScript&&\"Tamil\"!==n.unicodeScript){for(;h>a&&!(e[h].shaperInfo.category&(oo.M|co));)h--;Ao(e[h])&&e[h].shaperInfo.position!==so.Pre_M?h+1<o&&Co(e[h+1])&&h++:h=a}if(a<h&&e[h].shaperInfo.position!==so.Pre_M)for(var f=h;f>a;f--)if(e[f-1].shaperInfo.position===so.Pre_M){var d=f-1;d<l&&l<=h&&l--;var p=e[d];e.splice.apply(e,[d,0].concat(e.splice(d+1,h-d))),e[h]=p,h--}}if(a+1<o&&e[a].shaperInfo.position===so.Ra_To_Become_Reph&&e[a].shaperInfo.category===oo.Repha!==(e[a].isLigated&&!e[a].isMultiplied)){var g=void 0,y=r.rephPos,v=!1;if(y!==so.After_Post){for(g=a+1;g<l&&!Ao(e[g]);)g++;if(g<l&&Ao(e[g])&&(g+1<l&&Co(e[g+1])&&g++,v=!0),!v&&y===so.After_Main){for(g=l;g+1<o&&e[g+1].shaperInfo.position<=so.After_Main;)g++;v=g<o}if(!v&&y===so.After_Sub){for(g=l;g+1<o&&!(e[g+1].shaperInfo.position&(so.Post_C|so.After_Post|so.SMVD));)g++;v=g<o}}if(!v){for(g=a+1;g<l&&!Ao(e[g]);)g++;g<l&&Ao(e[g])&&(g+1<l&&Co(e[g+1])&&g++,v=!0)}if(!v){for(g=o-1;g>a&&e[g].shaperInfo.position===so.SMVD;)g--;if(Ao(e[g]))for(var b=l+1;b<g;b++)e[b].shaperInfo.category===oo.M&&g--}var m=e[a];e.splice.apply(e,[a,0].concat(e.splice(a+1,g-a))),e[g]=m,a<l&&l<=g&&l--}if(s&&l+1<o)for(var w=l+1;w<o;w++)if(e[w].features.pref){if(e[w].isLigated&&!e[w].isMultiplied){var x=l;if(\"Malayalam\"!==n.unicodeScript&&\"Tamil\"!==n.unicodeScript){for(;x>a&&!(e[x-1].shaperInfo.category&(oo.M|co));)x--;if(x>a&&e[x-1].shaperInfo.category===oo.M)for(var S=w,_=l+1;_<S;_++)if(e[_].shaperInfo.category===oo.M){x--;break}}x>a&&Ao(e[x-1])&&x<o&&Co(e[x])&&x++;var C=w,A=e[C];e.splice.apply(e,[x+1,0].concat(e.splice(x,C-x))),e[x]=A,x<=l&&l<C&&l++}break}e[a].shaperInfo.position!==so.Pre_M||a&&/Cf|Mn/.test(k.getCategory(e[a-1].codePoints[0]))||(e[a].features.init=!0)}}function To(t,e){if(e>=t.length)return e;for(var n=t[e].shaperInfo.syllable;++e<t.length&&t[e].shaperInfo.syllable===n;);return e}var Oo=ao.categories,Lo=ao.decompositions,Bo=new C(e(\"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\",\"base64\")),Mo=new A(ao),Ro=(xo=wo=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.planFeatures=function(t){t.addStage(zo),t.addStage([\"locl\",\"ccmp\",\"nukt\",\"akhn\"]),t.addStage(No),t.addStage([\"rphf\"],!1),t.addStage(Uo),t.addStage(No),t.addStage([\"pref\"]),t.addStage(Wo),t.addStage([\"rkrf\",\"abvf\",\"blwf\",\"half\",\"pstf\",\"vatu\",\"cjct\"]),t.addStage(Go),t.addStage([\"abvs\",\"blws\",\"pres\",\"psts\",\"dist\",\"abvm\",\"blwm\"])},e.assignFeatures=function(t,e){for(var n=function(n){var r=e[n].codePoints[0];if(Lo[r]){var i=Lo[r].map(function(r){var i=t.font.glyphForCodePoint(r);return new ya(t.font,i.id,[r],e[n].features)});e.splice.apply(e,[n,1].concat(i))}},r=e.length-1;r>=0;r--)n(r)},e}(Qi),wo.zeroMarkWidths=\"BEFORE_GPOS\",xo);function Fo(t){return Bo.get(t.codePoints[0])}var Do=function t(e,n,r){f(this,t),this.category=e,this.syllableType=n,this.syllable=r};function zo(t,e){var n=0,r=Mo.match(e.map(Fo)),i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o,u=l[0],c=l[1],h=l[2];++n;for(var f=u;f<=c;f++)e[f].shaperInfo=new Do(Oo[Fo(e[f])],h[0],n);for(var d=\"R\"===e[u].shaperInfo.category?1:Math.min(3,c-u),p=u;p<u+d;p++)e[p].features.rphf=!0}}function No(t,e){var n=e,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}a.substituted=!1}}function Uo(t,e){var n=e,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a;o.substituted&&o.features.rphf&&(o.shaperInfo.category=\"R\")}}function Wo(t,e){var n=e,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a;o.substituted&&(o.shaperInfo.category=\"VPre\")}}function Go(t,e){for(var n=t.glyphForCodePoint(9676).id,r=0,i=Vo(e,0);r<e.length;i=Vo(e,r=i)){var a=void 0,o=void 0,s=e[r].shaperInfo,l=s.syllableType;if(\"virama_terminated_cluster\"===l||\"standard_cluster\"===l||\"broken_cluster\"===l){if(\"broken_cluster\"===l&&n){var u=new ya(t,n,[9676]);for(u.shaperInfo=s,a=r;a<i&&\"R\"===e[a].shaperInfo.category;a++);e.splice(++a,0,u),i++}if(\"R\"===s.category&&i-r>1)for(a=r+1;a<i;a++)if(Ho(s=e[a].shaperInfo)||jo(e[a])){jo(e[a])&&a--,e.splice.apply(e,[r,0].concat(e.splice(r+1,a-r),[e[a]]));break}for(a=r,o=i;a<i;a++)Ho(s=e[a].shaperInfo)||jo(e[a])?o=jo(e[a])?a+1:a:(\"VPre\"===s.category||\"VMPre\"===s.category)&&o<a&&e.splice.apply(e,[o,1,e[a]].concat(e.splice(o,a-o)))}}}function Vo(t,e){if(e>=t.length)return e;for(var n=t[e].shaperInfo.syllable;++e<t.length&&t[e].shaperInfo.syllable===n;);return e}function jo(t){return\"H\"===t.shaperInfo.category&&!t.isLigated}function Ho(t){return\"B\"===t.category||\"GB\"===t.category}var qo={arab:ua,mong:ua,syrc:ua,\"nko \":ua,phag:ua,mand:ua,mani:ua,phlp:ua,hang:va,bng2:vo,beng:vo,dev2:vo,deva:vo,gjr2:vo,gujr:vo,guru:vo,gur2:vo,knda:vo,knd2:vo,mlm2:vo,mlym:vo,ory2:vo,orya:vo,taml:vo,tml2:vo,telu:vo,tel2:vo,khmr:vo,bali:Ro,batk:Ro,brah:Ro,bugi:Ro,buhd:Ro,cakm:Ro,cham:Ro,dupl:Ro,egyp:Ro,gran:Ro,hano:Ro,java:Ro,kthi:Ro,kali:Ro,khar:Ro,khoj:Ro,sind:Ro,lepc:Ro,limb:Ro,mahj:Ro,mtei:Ro,modi:Ro,hmng:Ro,rjng:Ro,saur:Ro,shrd:Ro,sidd:Ro,sinh:Ro,sund:Ro,sylo:Ro,tglg:Ro,tagb:Ro,tale:Ro,lana:Ro,tavt:Ro,takr:Ro,tibt:Ro,tfng:Ro,tirh:Ro,latn:Qi,DFLT:Qi};for(var Zo=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype.applyLookup=function(t,e){var n=this;switch(t){case 1:var r=this.coverageIndex(e.coverage);if(-1===r)return!1;var i=this.glyphIterator.cur;switch(e.version){case 1:i.id=i.id+e.deltaGlyphID&65535;break;case 2:i.id=e.substitute.get(r)}return!0;case 2:var a=this.coverageIndex(e.coverage);if(-1!==a){var o,l=e.sequences.get(a);this.glyphIterator.cur.id=l[0],this.glyphIterator.cur.ligatureComponent=0;var u=this.glyphIterator.cur.features,c=this.glyphIterator.cur,h=l.slice(1).map(function(t,e){var r=new ya(n.font,t,void 0,u);return r.shaperInfo=c.shaperInfo,r.isLigated=c.isLigated,r.ligatureComponent=e+1,r.substituted=!0,r.isMultiplied=!0,r});return(o=this.glyphs).splice.apply(o,[this.glyphIterator.index+1,0].concat(h)),!0}return!1;case 3:var f=this.coverageIndex(e.coverage);if(-1!==f){return this.glyphIterator.cur.id=e.alternateSet.get(f)[0],!0}return!1;case 4:var d=this.coverageIndex(e.coverage);if(-1===d)return!1;var p=e.ligatureSets.get(d),g=Array.isArray(p),y=0;for(p=g?p:s(p);;){var v;if(g){if(y>=p.length)break;v=p[y++]}else{if((y=p.next()).done)break;v=y.value}var b=v,m=this.sequenceMatchIndices(1,b.components);if(m){var w=this.glyphIterator.cur,x=w.codePoints.slice(),S=m,_=Array.isArray(S),k=0;for(S=_?S:s(S);;){var C;if(_){if(k>=S.length)break;C=S[k++]}else{if((k=S.next()).done)break;C=k.value}var A=C;x.push.apply(x,this.glyphs[A].codePoints)}var P=new ya(this.font,b.glyph,x,w.features);P.shaperInfo=w.shaperInfo,P.isLigated=!0,P.substituted=!0;for(var E=w.isMark,I=0;I<m.length&&E;I++)E=this.glyphs[m[I]].isMark;P.ligatureID=E?null:this.ligatureID++;var T=w.ligatureID,O=w.codePoints.length,L=O,B=this.glyphIterator.index+1,M=m,R=Array.isArray(M),F=0;for(M=R?M:s(M);;){var D;if(R){if(F>=M.length)break;D=M[F++]}else{if((F=M.next()).done)break;D=F.value}var z=D;if(E)B=z;else for(;B<z;){var N=L-O+Math.min(this.glyphs[B].ligatureComponent||1,O);this.glyphs[B].ligatureID=P.ligatureID,this.glyphs[B].ligatureComponent=N,B++}T=this.glyphs[B].ligatureID,L+=O=this.glyphs[B].codePoints.length,B++}if(T&&!E)for(var U=B;U<this.glyphs.length&&this.glyphs[U].ligatureID===T;U++){N=L-O+Math.min(this.glyphs[U].ligatureComponent||1,O);this.glyphs[U].ligatureComponent=N}for(var W=m.length-1;W>=0;W--)this.glyphs.splice(m[W],1);return this.glyphs[this.glyphIterator.index]=P,!0}}return!1;case 5:return this.applyContext(e);case 6:return this.applyChainingContext(e);case 7:return this.applyLookup(e.lookupType,e.extension);default:throw new Error(\"GSUB lookupType \"+t+\" is not supported\")}},e}(ga),Yo=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype.applyPositionValue=function(t,e){var n=this.positions[this.glyphIterator.peekIndex(t)];null!=e.xAdvance&&(n.xAdvance+=e.xAdvance),null!=e.yAdvance&&(n.yAdvance+=e.yAdvance),null!=e.xPlacement&&(n.xOffset+=e.xPlacement),null!=e.yPlacement&&(n.yOffset+=e.yPlacement);var r=this.font._variationProcessor,i=this.font.GDEF&&this.font.GDEF.itemVariationStore;r&&i&&(e.xPlaDevice&&(n.xOffset+=r.getDelta(i,e.xPlaDevice.a,e.xPlaDevice.b)),e.yPlaDevice&&(n.yOffset+=r.getDelta(i,e.yPlaDevice.a,e.yPlaDevice.b)),e.xAdvDevice&&(n.xAdvance+=r.getDelta(i,e.xAdvDevice.a,e.xAdvDevice.b)),e.yAdvDevice&&(n.yAdvance+=r.getDelta(i,e.yAdvDevice.a,e.yAdvDevice.b)))},e.prototype.applyLookup=function(t,e){switch(t){case 1:var n=this.coverageIndex(e.coverage);if(-1===n)return!1;switch(e.version){case 1:this.applyPositionValue(0,e.value);break;case 2:this.applyPositionValue(0,e.values.get(n))}return!0;case 2:var r=this.glyphIterator.peek();if(!r)return!1;var i=this.coverageIndex(e.coverage);if(-1===i)return!1;switch(e.version){case 1:var a=e.pairSets.get(i),o=Array.isArray(a),l=0;for(a=o?a:s(a);;){var u;if(o){if(l>=a.length)break;u=a[l++]}else{if((l=a.next()).done)break;u=l.value}var c=u;if(c.secondGlyph===r.id)return this.applyPositionValue(0,c.value1),this.applyPositionValue(1,c.value2),!0}return!1;case 2:var h=this.getClassID(this.glyphIterator.cur.id,e.classDef1),f=this.getClassID(r.id,e.classDef2);if(-1===h||-1===f)return!1;var d=e.classRecords.get(h).get(f);return this.applyPositionValue(0,d.value1),this.applyPositionValue(1,d.value2),!0}case 3:var p=this.glyphIterator.peekIndex(),g=this.glyphs[p];if(!g)return!1;var y=e.entryExitRecords[this.coverageIndex(e.coverage)];if(!y||!y.exitAnchor)return!1;var v=e.entryExitRecords[this.coverageIndex(e.coverage,g.id)];if(!v||!v.entryAnchor)return!1;var b=this.getAnchor(v.entryAnchor),m=this.getAnchor(y.exitAnchor),w=this.positions[this.glyphIterator.index],x=this.positions[p];switch(this.direction){case\"ltr\":w.xAdvance=m.x+w.xOffset;var S=b.x+x.xOffset;x.xAdvance-=S,x.xOffset-=S;break;case\"rtl\":S=m.x+w.xOffset,w.xAdvance-=S,w.xOffset-=S,x.xAdvance=b.x+x.xOffset}return this.glyphIterator.flags.rightToLeft?(this.glyphIterator.cur.cursiveAttachment=p,w.yOffset=b.y-m.y):(g.cursiveAttachment=this.glyphIterator.index,w.yOffset=m.y-b.y),!0;case 4:var _=this.coverageIndex(e.markCoverage);if(-1===_)return!1;for(var k=this.glyphIterator.index;--k>=0&&(this.glyphs[k].isMark||this.glyphs[k].ligatureComponent>0););if(k<0)return!1;var C=this.coverageIndex(e.baseCoverage,this.glyphs[k].id);if(-1===C)return!1;var A=e.markArray[_],P=e.baseArray[C][A.class];return this.applyAnchor(A,P,k),!0;case 5:var E=this.coverageIndex(e.markCoverage);if(-1===E)return!1;for(var I=this.glyphIterator.index;--I>=0&&this.glyphs[I].isMark;);if(I<0)return!1;var T=this.coverageIndex(e.ligatureCoverage,this.glyphs[I].id);if(-1===T)return!1;var O=e.ligatureArray[T],L=this.glyphIterator.cur,B=this.glyphs[I],M=B.ligatureID&&B.ligatureID===L.ligatureID&&L.ligatureComponent>0?Math.min(L.ligatureComponent,B.codePoints.length)-1:B.codePoints.length-1,R=e.markArray[E],F=O[M][R.class];return this.applyAnchor(R,F,I),!0;case 6:var D=this.coverageIndex(e.mark1Coverage);if(-1===D)return!1;var z=this.glyphIterator.peekIndex(-1),N=this.glyphs[z];if(!N||!N.isMark)return!1;var U=this.glyphIterator.cur,W=!1;if(U.ligatureID===N.ligatureID?U.ligatureID?U.ligatureComponent===N.ligatureComponent&&(W=!0):W=!0:(U.ligatureID&&!U.ligatureComponent||N.ligatureID&&!N.ligatureComponent)&&(W=!0),!W)return!1;var G=this.coverageIndex(e.mark2Coverage,N.id);if(-1===G)return!1;var V=e.mark1Array[D],j=e.mark2Array[G][V.class];return this.applyAnchor(V,j,z),!0;case 7:return this.applyContext(e);case 8:return this.applyChainingContext(e);case 9:return this.applyLookup(e.lookupType,e.extension);default:throw new Error(\"Unsupported GPOS table: \"+t)}},e.prototype.applyAnchor=function(t,e,n){var r=this.getAnchor(e),i=this.getAnchor(t.markAnchor),a=(this.positions[n],this.positions[this.glyphIterator.index]);a.xOffset=r.x-i.x,a.yOffset=r.y-i.y,this.glyphIterator.cur.markAttachment=n},e.prototype.getAnchor=function(t){var e=t.xCoordinate,n=t.yCoordinate,r=this.font._variationProcessor,i=this.font.GDEF&&this.font.GDEF.itemVariationStore;return r&&i&&(t.xDeviceTable&&(e+=r.getDelta(i,t.xDeviceTable.a,t.xDeviceTable.b)),t.yDeviceTable&&(n+=r.getDelta(i,t.yDeviceTable.a,t.yDeviceTable.b))),{x:e,y:n}},e.prototype.applyFeatures=function(e,n,r){t.prototype.applyFeatures.call(this,e,n,r);for(var i=0;i<this.glyphs.length;i++)this.fixCursiveAttachment(i);this.fixMarkAttachment()},e.prototype.fixCursiveAttachment=function(t){var e=this.glyphs[t];if(null!=e.cursiveAttachment){var n=e.cursiveAttachment;e.cursiveAttachment=null,this.fixCursiveAttachment(n),this.positions[t].yOffset+=this.positions[n].yOffset}},e.prototype.fixMarkAttachment=function(){for(var t=0;t<this.glyphs.length;t++){var e=this.glyphs[t];if(null!=e.markAttachment){var n=e.markAttachment;if(this.positions[t].xOffset+=this.positions[n].xOffset,this.positions[t].yOffset+=this.positions[n].yOffset,\"ltr\"===this.direction)for(var r=n;r<t;r++)this.positions[t].xOffset-=this.positions[r].xAdvance,this.positions[t].yOffset-=this.positions[r].yAdvance;else for(var i=n+1;i<t+1;i++)this.positions[t].xOffset+=this.positions[i].xAdvance,this.positions[t].yOffset+=this.positions[i].yAdvance}}},e}(ga),Xo=function(){function t(e){f(this,t),this.font=e,this.glyphInfos=null,this.plan=null,this.GSUBProcessor=null,this.GPOSProcessor=null,this.fallbackPosition=!0,e.GSUB&&(this.GSUBProcessor=new Zo(e,e.GSUB)),e.GPOS&&(this.GPOSProcessor=new Yo(e,e.GPOS))}return t.prototype.setup=function(t){var e=this;this.glyphInfos=t.glyphs.map(function(t){return new ya(e.font,t.id,[].concat(t.codePoints))});var n=null;for(var r in this.GPOSProcessor&&(n=this.GPOSProcessor.selectScript(t.script,t.language,t.direction)),this.GSUBProcessor&&(n=this.GSUBProcessor.selectScript(t.script,t.language,t.direction)),this.shaper=function(t){Array.isArray(t)||(t=[t]);var e=t,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=qo[i];if(a)return a}return Qi}(n),this.plan=new qi(this.font,n,t.direction),this.shaper.plan(this.plan,this.glyphInfos,t.features),this.plan.allFeatures)t.features[r]=!0},t.prototype.substitute=function(t){var e=this;this.GSUBProcessor&&(this.plan.process(this.GSUBProcessor,this.glyphInfos),t.glyphs=this.glyphInfos.map(function(t){return e.font.getGlyph(t.id,t.codePoints)}))},t.prototype.position=function(t){return\"BEFORE_GPOS\"===this.shaper.zeroMarkWidths&&this.zeroMarkAdvances(t.positions),this.GPOSProcessor&&this.plan.process(this.GPOSProcessor,this.glyphInfos,t.positions),\"AFTER_GPOS\"===this.shaper.zeroMarkWidths&&this.zeroMarkAdvances(t.positions),\"rtl\"===t.direction&&(t.glyphs.reverse(),t.positions.reverse()),this.GPOSProcessor&&this.GPOSProcessor.features},t.prototype.zeroMarkAdvances=function(t){for(var e=0;e<this.glyphInfos.length;e++)this.glyphInfos[e].isMark&&(t[e].xAdvance=0,t[e].yAdvance=0)},t.prototype.cleanup=function(){this.glyphInfos=null,this.plan=null,this.shaper=null},t.prototype.getAvailableFeatures=function(t,e){var n=[];return this.GSUBProcessor&&(this.GSUBProcessor.selectScript(t,e),n.push.apply(n,u(this.GSUBProcessor.features))),this.GPOSProcessor&&(this.GPOSProcessor.selectScript(t,e),n.push.apply(n,u(this.GPOSProcessor.features))),n},t}(),Ko=function(){function t(e){f(this,t),this.font=e,this.unicodeLayoutEngine=null,this.kernProcessor=null,this.font.morx?this.engine=new Hi(this.font):(this.font.GSUB||this.font.GPOS)&&(this.engine=new Xo(this.font))}return t.prototype.layout=function(t,e,n,r,i){if(\"string\"==typeof e&&(i=r,r=n,n=e,e=[]),\"string\"==typeof t){null==n&&(n=function(t){for(var e=t.length,n=0;n<e;){var r=t.charCodeAt(n++);if(55296<=r&&r<=56319&&n<e){var i=t.charCodeAt(n);56320<=i&&i<=57343&&(n++,r=((1023&r)<<10)+(1023&i)+65536)}var a=k.getScript(r);if(\"Common\"!==a&&\"Inherited\"!==a&&\"Unknown\"!==a)return oi[a]}return oi.Unknown}(t));var a=this.font.glyphsForString(t)}else{if(null==n){var o=[],l=t,u=Array.isArray(l),c=0;for(l=u?l:s(l);;){var h;if(u){if(c>=l.length)break;h=l[c++]}else{if((c=l.next()).done)break;h=c.value}var f=h;o.push.apply(o,f.codePoints)}n=function(t){for(var e=0;e<t.length;e++){var n=t[e],r=k.getScript(n);if(\"Common\"!==r&&\"Inherited\"!==r&&\"Unknown\"!==r)return oi[r]}return oi.Unknown}(o)}a=t}var d=new yi(a,e,n,r,i);return 0===a.length?(d.positions=[],d):(this.engine&&this.engine.setup&&this.engine.setup(d),this.substitute(d),this.position(d),this.hideDefaultIgnorables(d.glyphs,d.positions),this.engine&&this.engine.cleanup&&this.engine.cleanup(),d)},t.prototype.substitute=function(t){this.engine&&this.engine.substitute&&this.engine.substitute(t)},t.prototype.position=function(t){t.positions=t.glyphs.map(function(t){return new function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;f(this,t),this.xAdvance=e,this.yAdvance=n,this.xOffset=r,this.yOffset=i}(t.advanceWidth)});var e=null;this.engine&&this.engine.position&&(e=this.engine.position(t)),e||this.engine&&!this.engine.fallbackPosition||(this.unicodeLayoutEngine||(this.unicodeLayoutEngine=new ii(this.font)),this.unicodeLayoutEngine.positionGlyphs(t.glyphs,t.positions)),e&&e.kern||!1===t.features.kern||!this.font.kern||(this.kernProcessor||(this.kernProcessor=new ri(this.font)),this.kernProcessor.process(t.glyphs,t.positions),t.features.kern=!0)},t.prototype.hideDefaultIgnorables=function(t,e){for(var n=this.font.glyphForCodePoint(32),r=0;r<t.length;r++)this.isDefaultIgnorable(t[r].codePoints[0])&&(t[r]=n,e[r].xAdvance=0,e[r].yAdvance=0)},t.prototype.isDefaultIgnorable=function(t){var e=t>>16;if(0===e)switch(t>>8){case 0:return 173===t;case 3:return 847===t;case 6:return 1564===t;case 23:return 6068<=t&&t<=6069;case 24:return 6155<=t&&t<=6158;case 32:return 8203<=t&&t<=8207||8234<=t&&t<=8238||8288<=t&&t<=8303;case 254:return 65024<=t&&t<=65039||65279===t;case 255:return 65520<=t&&t<=65528;default:return!1}else switch(e){case 1:return 113824<=t&&t<=113827||119155<=t&&t<=119162;case 14:return 917504<=t&&t<=921599;default:return!1}},t.prototype.getAvailableFeatures=function(t,e){var n=[];return this.engine&&n.push.apply(n,this.engine.getAvailableFeatures(t,e)),this.font.kern&&-1===n.indexOf(\"kern\")&&n.push(\"kern\"),n},t.prototype.stringsForGlyph=function(t){var e=new _,n=this.font._cmapProcessor.codePointsForGlyph(t),r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a;e.add(x(o))}if(this.engine&&this.engine.stringsForGlyph){var l=this.engine.stringsForGlyph(t),u=Array.isArray(l),c=0;for(l=u?l:s(l);;){var h;if(u){if(c>=l.length)break;h=l[c++]}else{if((c=l.next()).done)break;h=c.value}var f=h;e.add(f)}}return S(e)},t}(),Jo={moveTo:\"M\",lineTo:\"L\",quadraticCurveTo:\"Q\",bezierCurveTo:\"C\",closePath:\"Z\"},Qo=function(){function t(){f(this,t),this.commands=[],this._bbox=null,this._cbox=null}return t.prototype.toFunction=function(){var t=this.commands.map(function(t){return\"  ctx.\"+t.command+\"(\"+t.args.join(\", \")+\");\"});return new Function(\"ctx\",t.join(\"\\n\"))},t.prototype.toSVG=function(){return this.commands.map(function(t){var e=t.args.map(function(t){return Math.round(100*t)/100});return\"\"+Jo[t.command]+e.join(\" \")}).join(\"\")},t.prototype.mapPoints=function(e){var n=new t,r=this.commands,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}for(var l=o,u=[],c=0;c<l.args.length;c+=2){var h=e(l.args[c],l.args[c+1]),f=h[0],d=h[1];u.push(f,d)}n[l.command].apply(n,u)}return n},t.prototype.transform=function(t,e,n,r,i,a){return this.mapPoints(function(o,s){return[o=t*o+n*s+i,s=e*o+r*s+a]})},t.prototype.translate=function(t,e){return this.transform(1,0,0,1,t,e)},t.prototype.rotate=function(t){var e=Math.cos(t),n=Math.sin(t);return this.transform(e,n,-n,e,0,0)},t.prototype.scale=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:t;return this.transform(t,0,0,e,0,0)},d(t,[{key:\"cbox\",get:function(){if(!this._cbox){var t=new ai,e=this.commands,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}for(var a=i,o=0;o<a.args.length;o+=2)t.addPoint(a.args[o],a.args[o+1])}this._cbox=l(t)}return this._cbox}},{key:\"bbox\",get:function(){if(this._bbox)return this._bbox;var t=new ai,e=0,n=0,r=function(t){return Math.pow(1-t,3)*k[E]+3*Math.pow(1-t,2)*t*C[E]+3*(1-t)*Math.pow(t,2)*A[E]+Math.pow(t,3)*P[E]},i=this.commands,a=Array.isArray(i),o=0;for(i=a?i:s(i);;){var u;if(a){if(o>=i.length)break;u=i[o++]}else{if((o=i.next()).done)break;u=o.value}var c=u;switch(c.command){case\"moveTo\":case\"lineTo\":var h=c.args,f=h[0],d=h[1];t.addPoint(f,d),e=f,n=d;break;case\"quadraticCurveTo\":case\"bezierCurveTo\":if(\"quadraticCurveTo\"===c.command)var p=c.args,g=p[0],y=p[1],v=e+2/3*(g-e),b=n+2/3*(y-n),m=(S=p[2])+2/3*(g-S),w=(_=p[3])+2/3*(y-_);else var x=c.args,S=(v=x[0],b=x[1],m=x[2],w=x[3],x[4]),_=x[5];t.addPoint(S,_);for(var k=[e,n],C=[v,b],A=[m,w],P=[S,_],E=0;E<=1;E++){var I=6*k[E]-12*C[E]+6*A[E],T=-3*k[E]+9*C[E]-9*A[E]+3*P[E];if(c=3*C[E]-3*k[E],0!==T){var O=Math.pow(I,2)-4*c*T;if(!(O<0)){var L=(-I+Math.sqrt(O))/(2*T);0<L&&L<1&&(0===E?t.addPoint(r(L),t.maxY):1===E&&t.addPoint(t.maxX,r(L)));var B=(-I-Math.sqrt(O))/(2*T);0<B&&B<1&&(0===E?t.addPoint(r(B),t.maxY):1===E&&t.addPoint(t.maxX,r(B)))}}else{if(0===I)continue;var M=-c/I;0<M&&M<1&&(0===E?t.addPoint(r(M),t.maxY):1===E&&t.addPoint(t.maxX,r(M)))}}e=S,n=_}}return this._bbox=l(t)}}]),t}(),$o=[\"moveTo\",\"lineTo\",\"quadraticCurveTo\",\"bezierCurveTo\",\"closePath\"],ts=function(){var t=$o[es];Qo.prototype[t]=function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return this._bbox=this._cbox=null,this.commands.push({command:t,args:n}),this}},es=0;es<$o.length;es++)ts();var ns,rs=[\".notdef\",\".null\",\"nonmarkingreturn\",\"space\",\"exclam\",\"quotedbl\",\"numbersign\",\"dollar\",\"percent\",\"ampersand\",\"quotesingle\",\"parenleft\",\"parenright\",\"asterisk\",\"plus\",\"comma\",\"hyphen\",\"period\",\"slash\",\"zero\",\"one\",\"two\",\"three\",\"four\",\"five\",\"six\",\"seven\",\"eight\",\"nine\",\"colon\",\"semicolon\",\"less\",\"equal\",\"greater\",\"question\",\"at\",\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\",\"bracketleft\",\"backslash\",\"bracketright\",\"asciicircum\",\"underscore\",\"grave\",\"a\",\"b\",\"c\",\"d\",\"e\",\"f\",\"g\",\"h\",\"i\",\"j\",\"k\",\"l\",\"m\",\"n\",\"o\",\"p\",\"q\",\"r\",\"s\",\"t\",\"u\",\"v\",\"w\",\"x\",\"y\",\"z\",\"braceleft\",\"bar\",\"braceright\",\"asciitilde\",\"Adieresis\",\"Aring\",\"Ccedilla\",\"Eacute\",\"Ntilde\",\"Odieresis\",\"Udieresis\",\"aacute\",\"agrave\",\"acircumflex\",\"adieresis\",\"atilde\",\"aring\",\"ccedilla\",\"eacute\",\"egrave\",\"ecircumflex\",\"edieresis\",\"iacute\",\"igrave\",\"icircumflex\",\"idieresis\",\"ntilde\",\"oacute\",\"ograve\",\"ocircumflex\",\"odieresis\",\"otilde\",\"uacute\",\"ugrave\",\"ucircumflex\",\"udieresis\",\"dagger\",\"degree\",\"cent\",\"sterling\",\"section\",\"bullet\",\"paragraph\",\"germandbls\",\"registered\",\"copyright\",\"trademark\",\"acute\",\"dieresis\",\"notequal\",\"AE\",\"Oslash\",\"infinity\",\"plusminus\",\"lessequal\",\"greaterequal\",\"yen\",\"mu\",\"partialdiff\",\"summation\",\"product\",\"pi\",\"integral\",\"ordfeminine\",\"ordmasculine\",\"Omega\",\"ae\",\"oslash\",\"questiondown\",\"exclamdown\",\"logicalnot\",\"radical\",\"florin\",\"approxequal\",\"Delta\",\"guillemotleft\",\"guillemotright\",\"ellipsis\",\"nonbreakingspace\",\"Agrave\",\"Atilde\",\"Otilde\",\"OE\",\"oe\",\"endash\",\"emdash\",\"quotedblleft\",\"quotedblright\",\"quoteleft\",\"quoteright\",\"divide\",\"lozenge\",\"ydieresis\",\"Ydieresis\",\"fraction\",\"currency\",\"guilsinglleft\",\"guilsinglright\",\"fi\",\"fl\",\"daggerdbl\",\"periodcentered\",\"quotesinglbase\",\"quotedblbase\",\"perthousand\",\"Acircumflex\",\"Ecircumflex\",\"Aacute\",\"Edieresis\",\"Egrave\",\"Iacute\",\"Icircumflex\",\"Idieresis\",\"Igrave\",\"Oacute\",\"Ocircumflex\",\"apple\",\"Ograve\",\"Uacute\",\"Ucircumflex\",\"Ugrave\",\"dotlessi\",\"circumflex\",\"tilde\",\"macron\",\"breve\",\"dotaccent\",\"ring\",\"cedilla\",\"hungarumlaut\",\"ogonek\",\"caron\",\"Lslash\",\"lslash\",\"Scaron\",\"scaron\",\"Zcaron\",\"zcaron\",\"brokenbar\",\"Eth\",\"eth\",\"Yacute\",\"yacute\",\"Thorn\",\"thorn\",\"minus\",\"multiply\",\"onesuperior\",\"twosuperior\",\"threesuperior\",\"onehalf\",\"onequarter\",\"threequarters\",\"franc\",\"Gbreve\",\"gbreve\",\"Idotaccent\",\"Scedilla\",\"scedilla\",\"Cacute\",\"cacute\",\"Ccaron\",\"ccaron\",\"dcroat\"];function is(t,e,n,r,i){var a={};return Object.keys(r).forEach(function(t){a[t]=r[t]}),a.enumerable=!!a.enumerable,a.configurable=!!a.configurable,(\"value\"in a||a.initializer)&&(a.writable=!0),a=n.slice().reverse().reduce(function(n,r){return r(t,e,n)||n},a),i&&void 0!==a.initializer&&(a.value=a.initializer?a.initializer.call(i):void 0,a.initializer=void 0),void 0===a.initializer&&(Object.defineProperty(t,e,a),a=null),a}var as,os=(is((ns=function(){function t(e,n,r){f(this,t),this.id=e,this.codePoints=n,this._font=r,this.isMark=this.codePoints.every(k.isMark),this.isLigature=this.codePoints.length>1}return t.prototype._getPath=function(){return new Qo},t.prototype._getCBox=function(){return this.path.cbox},t.prototype._getBBox=function(){return this.path.bbox},t.prototype._getTableMetrics=function(t){if(this.id<t.metrics.length)return t.metrics.get(this.id);var e=t.metrics.get(t.metrics.length-1);return{advance:e?e.advance:0,bearing:t.bearings.get(this.id-t.metrics.length)||0}},t.prototype._getMetrics=function(t){if(this._metrics)return this._metrics;var e=this._getTableMetrics(this._font.hmtx),n=e.advance,r=e.bearing;if(this._font.vmtx)var i=this._getTableMetrics(this._font.vmtx),a=i.advance,o=i.bearing;else{var s;if(null==t&&(t=this.cbox),(s=this._font[\"OS/2\"])&&s.version>0)a=Math.abs(s.typoAscender-s.typoDescender),o=s.typoAscender-t.maxY;else{var l=this._font.hhea;a=Math.abs(l.ascent-l.descent),o=l.ascent-t.maxY}}return this._font._variationProcessor&&this._font.HVAR&&(n+=this._font._variationProcessor.getAdvanceAdjustment(this.id,this._font.HVAR)),this._metrics={advanceWidth:n,advanceHeight:a,leftBearing:r,topBearing:o}},t.prototype.getScaledPath=function(t){var e=1/this._font.unitsPerEm*t;return this.path.scale(e)},t.prototype._getName=function(){var t=this._font.post;if(!t)return null;switch(t.version){case 1:return rs[this.id];case 2:var e=t.glyphNameIndex[this.id];return e<rs.length?rs[e]:t.names[e-rs.length];case 2.5:return rs[this.id+t.offsets[this.id]];case 4:return String.fromCharCode(t.map[this.id])}},t.prototype.render=function(t,e){t.save();var n=1/this._font.head.unitsPerEm*e;t.scale(n,n),this.path.toFunction()(t),t.fill(),t.restore()},d(t,[{key:\"cbox\",get:function(){return this._getCBox()}},{key:\"bbox\",get:function(){return this._getBBox()}},{key:\"path\",get:function(){return this._getPath()}},{key:\"advanceWidth\",get:function(){return this._getMetrics().advanceWidth}},{key:\"advanceHeight\",get:function(){return this._getMetrics().advanceHeight}},{key:\"ligatureCaretPositions\",get:function(){}},{key:\"name\",get:function(){return this._getName()}}]),t}()).prototype,\"cbox\",[B],o(ns.prototype,\"cbox\"),ns.prototype),is(ns.prototype,\"bbox\",[B],o(ns.prototype,\"bbox\"),ns.prototype),is(ns.prototype,\"path\",[B],o(ns.prototype,\"path\"),ns.prototype),is(ns.prototype,\"advanceWidth\",[B],o(ns.prototype,\"advanceWidth\"),ns.prototype),is(ns.prototype,\"advanceHeight\",[B],o(ns.prototype,\"advanceHeight\"),ns.prototype),is(ns.prototype,\"name\",[B],o(ns.prototype,\"name\"),ns.prototype),ns),ss=new a.Struct({numberOfContours:a.int16,xMin:a.int16,yMin:a.int16,xMax:a.int16,yMax:a.int16}),ls=function(){function t(e,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;f(this,t),this.onCurve=e,this.endContour=n,this.x=r,this.y=i}return t.prototype.copy=function(){return new t(this.onCurve,this.endContour,this.x,this.y)},t}(),us=function t(e,n,r){f(this,t),this.glyphID=e,this.dx=n,this.dy=r,this.pos=0,this.scaleX=this.scaleY=1,this.scale01=this.scale10=0},cs=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype._getCBox=function(t){if(this._font._variationProcessor&&!t)return this.path.cbox;var e=this._font._getTableStream(\"glyf\");e.pos+=this._font.loca.offsets[this.id];var n=ss.decode(e),r=new ai(n.xMin,n.yMin,n.xMax,n.yMax);return l(r)},e.prototype._parseGlyphCoord=function(t,e,n,r){if(n){var i=t.readUInt8();r||(i=-i),i+=e}else if(r)i=e;else i=e+t.readInt16BE();return i},e.prototype._decode=function(){var t=this._font.loca.offsets[this.id];if(t===this._font.loca.offsets[this.id+1])return null;var e=this._font._getTableStream(\"glyf\");e.pos+=t;var n=e.pos,r=ss.decode(e);return r.numberOfContours>0?this._decodeSimple(r,e):r.numberOfContours<0&&this._decodeComposite(r,e,n),r},e.prototype._decodeSimple=function(t,e){t.points=[];var n=new a.Array(a.uint16,t.numberOfContours).decode(e);t.instructions=new a.Array(a.uint8,a.uint16).decode(e);for(var r=[],i=n[n.length-1]+1;r.length<i;){var o=e.readUInt8();if(r.push(o),8&o)for(var s=e.readUInt8(),l=0;l<s;l++)r.push(o)}for(var u=0;u<r.length;u++){o=r[u];var c=new ls(!!(1&o),n.indexOf(u)>=0,0,0);t.points.push(c)}var h=0;for(u=0;u<r.length;u++){o=r[u];t.points[u].x=h=this._parseGlyphCoord(e,h,2&o,16&o)}var f=0;for(u=0;u<r.length;u++){o=r[u];t.points[u].y=f=this._parseGlyphCoord(e,f,4&o,32&o)}if(this._font._variationProcessor){var d=t.points.slice();d.push.apply(d,this._getPhantomPoints(t)),this._font._variationProcessor.transformPoints(this.id,d),t.phantomPoints=d.slice(-4)}},e.prototype._decodeComposite=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;t.components=[];for(var r=!1,i=32;32&i;){i=e.readUInt16BE();var a=e.pos-n,o=e.readUInt16BE();if(r||(r=0!=(256&i)),1&i)var s=e.readInt16BE(),l=e.readInt16BE();else s=e.readInt8(),l=e.readInt8();(h=new us(o,s,l)).pos=a,8&i?h.scaleX=h.scaleY=(e.readUInt8()<<24|e.readUInt8()<<16)/1073741824:64&i?(h.scaleX=(e.readUInt8()<<24|e.readUInt8()<<16)/1073741824,h.scaleY=(e.readUInt8()<<24|e.readUInt8()<<16)/1073741824):128&i&&(h.scaleX=(e.readUInt8()<<24|e.readUInt8()<<16)/1073741824,h.scale01=(e.readUInt8()<<24|e.readUInt8()<<16)/1073741824,h.scale10=(e.readUInt8()<<24|e.readUInt8()<<16)/1073741824,h.scaleY=(e.readUInt8()<<24|e.readUInt8()<<16)/1073741824),t.components.push(h)}if(this._font._variationProcessor){for(var u=[],c=0;c<t.components.length;c++){var h=t.components[c];u.push(new ls(!0,!0,h.dx,h.dy))}u.push.apply(u,this._getPhantomPoints(t)),this._font._variationProcessor.transformPoints(this.id,u),t.phantomPoints=u.splice(-4,4);for(var f=0;f<u.length;f++){var d=u[f];t.components[f].dx=d.x,t.components[f].dy=d.y}}return r},e.prototype._getPhantomPoints=function(t){var e=this._getCBox(!0);null==this._metrics&&(this._metrics=os.prototype._getMetrics.call(this,e));var n=this._metrics,r=n.advanceWidth,i=n.advanceHeight,a=n.leftBearing,o=n.topBearing;return[new ls(!1,!0,t.xMin-a,0),new ls(!1,!0,t.xMin-a+r,0),new ls(!1,!0,0,t.yMax+o),new ls(!1,!0,0,t.yMax+o+i)]},e.prototype._getContours=function(){var t=this._decode();if(!t)return[];var e=[];if(t.numberOfContours<0){var n=t.components,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}for(var o=a,l=this._font.getGlyph(o.glyphID)._getContours(),u=0;u<l.length;u++)for(var c=l[u],h=0;h<c.length;h++){var f=c[h],d=f.x*o.scaleX+f.y*o.scale01+o.dx,p=f.y*o.scaleY+f.x*o.scale10+o.dy;e.push(new ls(f.onCurve,f.endContour,d,p))}}}else e=t.points||[];t.phantomPoints&&!this._font.directory.tables.HVAR&&(this._metrics.advanceWidth=t.phantomPoints[1].x-t.phantomPoints[0].x,this._metrics.advanceHeight=t.phantomPoints[3].y-t.phantomPoints[2].y,this._metrics.leftBearing=t.xMin-t.phantomPoints[0].x,this._metrics.topBearing=t.phantomPoints[2].y-t.yMax);for(var g=[],y=[],v=0;v<e.length;v++){var b=e[v];y.push(b),b.endContour&&(g.push(y),y=[])}return g},e.prototype._getMetrics=function(){if(this._metrics)return this._metrics;var e=this._getCBox(!0);return t.prototype._getMetrics.call(this,e),this._font._variationProcessor&&!this._font.HVAR&&this.path,this._metrics},e.prototype._getPath=function(){for(var t=this._getContours(),e=new Qo,n=0;n<t.length;n++){var r=t[n],i=r[0],a=r[r.length-1],o=0;if(i.onCurve){var s=null;o=1}else s=i=a.onCurve?a:new ls(!1,!1,(i.x+a.x)/2,(i.y+a.y)/2);e.moveTo(i.x,i.y);for(var l=o;l<r.length;l++){var u=r[l],c=0===l?i:r[l-1];if(c.onCurve&&u.onCurve)e.lineTo(u.x,u.y);else if(c.onCurve&&!u.onCurve)s=u;else if(c.onCurve||u.onCurve){if(c.onCurve||!u.onCurve)throw new Error(\"Unknown TTF path state\");e.quadraticCurveTo(s.x,s.y,u.x,u.y);s=null}else{var h=(c.x+u.x)/2,f=(c.y+u.y)/2;e.quadraticCurveTo(c.x,c.y,h,f);var s=u}}s&&e.quadraticCurveTo(s.x,s.y,i.x,i.y),e.closePath()}return e},e}(os),hs=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype._getName=function(){return this._font.CFF2?t.prototype._getName.call(this):this._font[\"CFF \"].getGlyphName(this.id)},e.prototype.bias=function(t){return t.length<1240?107:t.length<33900?1131:32768},e.prototype._getPath=function(){var t=this._font.stream,e=(t.pos,this._font.CFF2||this._font[\"CFF \"]),n=e.topDict.CharStrings[this.id],r=n.offset+n.length;t.pos=n.offset;var i=new Qo,a=[],o=[],s=null,l=0,u=0,c=0,h=void 0,f=void 0,d=!1;this._usedGsubrs=h={},this._usedSubrs=f={};var p=e.globalSubrIndex||[],g=this.bias(p),y=e.privateDictForGlyph(this.id),v=y.Subrs||[],b=this.bias(v),m=e.topDict.vstore&&e.topDict.vstore.itemVariationStore,w=y.vsindex,x=this._font._variationProcessor;function S(){null==s&&(s=a.shift()+y.nominalWidthX)}function _(){return a.length%2!=0&&S(),l+=a.length>>1,a.length=0}function k(t,e){d&&i.closePath(),i.moveTo(t,e),d=!0}return function n(){for(;t.pos<r;){var s=t.readUInt8();if(s<32)switch(s){case 1:case 3:case 18:case 23:_();break;case 4:a.length>1&&S(),c+=a.shift(),k(u,c);break;case 5:for(;a.length>=2;)u+=a.shift(),c+=a.shift(),i.lineTo(u,c);break;case 6:case 7:for(var y=6===s;a.length>=1;)y?u+=a.shift():c+=a.shift(),i.lineTo(u,c),y=!y;break;case 8:for(;a.length>0;){var C=u+a.shift(),A=c+a.shift(),P=C+a.shift(),E=A+a.shift();u=P+a.shift(),c=E+a.shift(),i.bezierCurveTo(C,A,P,E,u,c)}break;case 10:var I=a.pop()+b,T=v[I];if(T){f[I]=!0;var O=t.pos,L=r;t.pos=T.offset,r=T.offset+T.length,n(),t.pos=O,r=L}break;case 11:if(e.version>=2)break;return;case 14:if(e.version>=2)break;a.length>0&&S(),d&&(i.closePath(),d=!1);break;case 15:if(e.version<2)throw new Error(\"vsindex operator not supported in CFF v1\");w=a.pop();break;case 16:if(e.version<2)throw new Error(\"blend operator not supported in CFF v1\");if(!x)throw new Error(\"blend operator in non-variation font\");for(var B=x.getBlendVector(m,w),M=a.pop(),R=M*B.length,F=a.length-R,D=F-M,z=0;z<M;z++){for(var N=a[D+z],U=0;U<B.length;U++)N+=B[U]*a[F++];a[D+z]=N}for(;R--;)a.pop();break;case 19:case 20:_(),t.pos+=l+7>>3;break;case 21:a.length>2&&S(),u+=a.shift(),c+=a.shift(),k(u,c);break;case 22:a.length>1&&S(),k(u+=a.shift(),c);break;case 24:for(;a.length>=8;)C=u+a.shift(),A=c+a.shift(),P=C+a.shift(),E=A+a.shift(),u=P+a.shift(),c=E+a.shift(),i.bezierCurveTo(C,A,P,E,u,c);u+=a.shift(),c+=a.shift(),i.lineTo(u,c);break;case 25:for(;a.length>=8;)u+=a.shift(),c+=a.shift(),i.lineTo(u,c);C=u+a.shift(),A=c+a.shift(),P=C+a.shift(),E=A+a.shift(),u=P+a.shift(),c=E+a.shift(),i.bezierCurveTo(C,A,P,E,u,c);break;case 26:for(a.length%2&&(u+=a.shift());a.length>=4;)C=u,A=c+a.shift(),P=C+a.shift(),E=A+a.shift(),u=P,c=E+a.shift(),i.bezierCurveTo(C,A,P,E,u,c);break;case 27:for(a.length%2&&(c+=a.shift());a.length>=4;)C=u+a.shift(),A=c,P=C+a.shift(),E=A+a.shift(),u=P+a.shift(),c=E,i.bezierCurveTo(C,A,P,E,u,c);break;case 28:a.push(t.readInt16BE());break;case 29:I=a.pop()+g,(T=p[I])&&(h[I]=!0,O=t.pos,L=r,t.pos=T.offset,r=T.offset+T.length,n(),t.pos=O,r=L);break;case 30:case 31:for(y=31===s;a.length>=4;)y?(C=u+a.shift(),A=c,P=C+a.shift(),E=A+a.shift(),c=E+a.shift(),u=P+(1===a.length?a.shift():0)):(C=u,A=c+a.shift(),P=C+a.shift(),E=A+a.shift(),u=P+a.shift(),c=E+(1===a.length?a.shift():0)),i.bezierCurveTo(C,A,P,E,u,c),y=!y;break;case 12:switch(s=t.readUInt8()){case 3:var W=a.pop(),G=a.pop();a.push(W&&G?1:0);break;case 4:W=a.pop(),G=a.pop(),a.push(W||G?1:0);break;case 5:W=a.pop(),a.push(W?0:1);break;case 9:W=a.pop(),a.push(Math.abs(W));break;case 10:W=a.pop(),G=a.pop(),a.push(W+G);break;case 11:W=a.pop(),G=a.pop(),a.push(W-G);break;case 12:W=a.pop(),G=a.pop(),a.push(W/G);break;case 14:W=a.pop(),a.push(-W);break;case 15:W=a.pop(),G=a.pop(),a.push(W===G?1:0);break;case 18:a.pop();break;case 20:var V=a.pop(),j=a.pop();o[j]=V;break;case 21:j=a.pop(),a.push(o[j]||0);break;case 22:var H=a.pop(),q=a.pop(),Z=a.pop(),Y=a.pop();a.push(Z<=Y?H:q);break;case 23:a.push(Math.random());break;case 24:W=a.pop(),G=a.pop(),a.push(W*G);break;case 26:W=a.pop(),a.push(Math.sqrt(W));break;case 27:W=a.pop(),a.push(W,W);break;case 28:W=a.pop(),G=a.pop(),a.push(G,W);break;case 29:(j=a.pop())<0?j=0:j>a.length-1&&(j=a.length-1),a.push(a[j]);break;case 30:var X=a.pop(),K=a.pop();if(K>=0)for(;K>0;){for(var J=a[X-1],Q=X-2;Q>=0;Q--)a[Q+1]=a[Q];a[0]=J,K--}else for(;K<0;){J=a[0];for(var $=0;$<=X;$++)a[$]=a[$+1];a[X-1]=J,K++}break;case 34:C=u+a.shift(),A=c,P=C+a.shift(),E=A+a.shift();var tt=P+a.shift(),et=E,nt=tt+a.shift(),rt=et,it=nt+a.shift(),at=rt,ot=it+a.shift(),st=at;u=ot,c=st,i.bezierCurveTo(C,A,P,E,tt,et),i.bezierCurveTo(nt,rt,it,at,ot,st);break;case 35:for(var lt=[],ut=0;ut<=5;ut++)u+=a.shift(),c+=a.shift(),lt.push(u,c);i.bezierCurveTo.apply(i,lt.slice(0,6)),i.bezierCurveTo.apply(i,lt.slice(6)),a.shift();break;case 36:C=u+a.shift(),A=c+a.shift(),P=C+a.shift(),rt=et=E=A+a.shift(),it=(nt=(tt=P+a.shift())+a.shift())+a.shift(),at=rt+a.shift(),ot=it+a.shift(),u=ot,c=st=at,i.bezierCurveTo(C,A,P,E,tt,et),i.bezierCurveTo(nt,rt,it,at,ot,st);break;case 37:var ct=u,ht=c;lt=[];for(var ft=0;ft<=4;ft++)u+=a.shift(),c+=a.shift(),lt.push(u,c);Math.abs(u-ct)>Math.abs(c-ht)?(u+=a.shift(),c=ht):(u=ct,c+=a.shift()),lt.push(u,c),i.bezierCurveTo.apply(i,lt.slice(0,6)),i.bezierCurveTo.apply(i,lt.slice(6));break;default:throw new Error(\"Unknown op: 12 \"+s)}break;default:throw new Error(\"Unknown op: \"+s)}else if(s<247)a.push(s-139);else if(s<251){var dt=t.readUInt8();a.push(256*(s-247)+dt+108)}else s<255?(dt=t.readUInt8(),a.push(256*-(s-251)-dt-108)):a.push(t.readInt32BE()/65536)}}(),d&&i.closePath(),i},e}(os),fs=new a.Struct({originX:a.uint16,originY:a.uint16,type:new a.String(4),data:new a.Buffer(function(t){return t.parent.buflen-t._currentOffset})}),ds=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype.getImageForSize=function(t){for(var e=0;e<this._font.sbix.imageTables.length;e++){var n=this._font.sbix.imageTables[e];if(n.ppem>=t)break}var r=n.imageOffsets,i=r[this.id],a=r[this.id+1];return i===a?null:(this._font.stream.pos=i,fs.decode(this._font.stream,{buflen:a-i}))},e.prototype.render=function(e,n){var r=this.getImageForSize(n);if(null!=r){var i=n/this._font.unitsPerEm;e.image(r.data,{height:n,x:r.originX,y:(this.bbox.minY-r.originY)*i})}this._font.sbix.flags.renderOutlines&&t.prototype.render.call(this,e,n)},e}(cs),ps=function t(e,n){f(this,t),this.glyph=e,this.color=n},gs=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype._getBBox=function(){for(var t=new ai,e=0;e<this.layers.length;e++){var n=this.layers[e].glyph.bbox;t.addPoint(n.minX,n.minY),t.addPoint(n.maxX,n.maxY)}return t},e.prototype.render=function(t,e){var n=this.layers,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=o.glyph,u=o.color;t.fillColor([u.red,u.green,u.blue],u.alpha/255*100),l.render(t,e)}},d(e,[{key:\"layers\",get:function(){for(var t=this._font.CPAL,e=this._font.COLR,n=0,r=e.baseGlyphRecord.length-1;n<=r;){var i=n+r>>1,a=e.baseGlyphRecord[i];if(this.id<a.gid)r=i-1;else{if(!(this.id>a.gid)){var o=a;break}n=i+1}}if(null==o){var s=this._font._getBaseGlyph(this.id);return[new ps(s,c={red:0,green:0,blue:0,alpha:255})]}for(var l=[],u=o.firstLayerIndex;u<o.firstLayerIndex+o.numLayers;u++){a=e.layerRecords[u];var c=t.colorRecords[a.paletteIndex];s=this._font._getBaseGlyph(a.gid);l.push(new ps(s,c))}return l}}]),e}(os),ys=function(){function t(e,n){f(this,t),this.font=e,this.normalizedCoords=this.normalizeCoords(n),this.blendVectors=new p}return t.prototype.normalizeCoords=function(t){for(var e=[],n=0;n<this.font.fvar.axis.length;n++){var r=this.font.fvar.axis[n];t[n]<r.defaultValue?e.push((t[n]-r.defaultValue+P)/(r.defaultValue-r.minValue+P)):e.push((t[n]-r.defaultValue+P)/(r.maxValue-r.defaultValue+P))}if(this.font.avar)for(n=0;n<this.font.avar.segment.length;n++)for(var i=this.font.avar.segment[n],a=0;a<i.correspondence.length;a++){var o=i.correspondence[a];if(a>=1&&e[n]<o.fromCoord){var s=i.correspondence[a-1];e[n]=((e[n]-s.fromCoord)*(o.toCoord-s.toCoord)+P)/(o.fromCoord-s.fromCoord+P)+s.toCoord;break}}return e},t.prototype.transformPoints=function(t,e){if(this.font.fvar&&this.font.gvar){var n=this.font.gvar;if(!(t>=n.glyphCount)){var r=n.offsets[t];if(r!==n.offsets[t+1]){var i=this.font.stream;if(i.pos=r,!(i.pos>=i.length)){var a=i.readUInt16BE(),o=r+i.readUInt16BE();if(32768&a){var s=i.pos;i.pos=o;var l=this.decodePoints();o=i.pos,i.pos=s}var u=e.map(function(t){return t.copy()});a&=4095;for(var c=0;c<a;c++){var h=i.readUInt16BE(),f=i.readUInt16BE();if(32768&f)for(var d=[],p=0;p<n.axisCount;p++)d.push(i.readInt16BE()/16384);else{if((4095&f)>=n.globalCoordCount)throw new Error(\"Invalid gvar table\");d=n.globalCoords[4095&f]}if(16384&f){for(var g=[],y=0;y<n.axisCount;y++)g.push(i.readInt16BE()/16384);for(var v=[],b=0;b<n.axisCount;b++)v.push(i.readInt16BE()/16384)}var m=this.tupleFactor(f,d,g,v);if(0!==m){s=i.pos;if(i.pos=o,8192&f)var w=this.decodePoints();else w=l;var x=0===w.length?e.length:w.length,S=this.decodeDeltas(x),_=this.decodeDeltas(x);if(0===w.length)for(var k=0;k<e.length;k++){var C=e[k];C.x+=Math.round(S[k]*m),C.y+=Math.round(_[k]*m)}else{for(var A=u.map(function(t){return t.copy()}),P=e.map(function(){return!1}),E=0;E<w.length;E++){var I=w[E];if(I<e.length){var T=A[I];P[I]=!0,T.x+=Math.round(S[E]*m),T.y+=Math.round(_[E]*m)}}this.interpolateMissingDeltas(A,u,P);for(var O=0;O<e.length;O++){var L=A[O].x-u[O].x,B=A[O].y-u[O].y;e[O].x+=L,e[O].y+=B}}o+=h,i.pos=s}else o+=h}}}}}},t.prototype.decodePoints=function(){var t=this.font.stream,e=t.readUInt8();128&e&&(e=(127&e)<<8|t.readUInt8());for(var n=new Uint16Array(e),r=0,i=0;r<e;)for(var a=t.readUInt8(),o=1+(127&a),s=128&a?t.readUInt16:t.readUInt8,l=0;l<o&&r<e;l++)i+=s.call(t),n[r++]=i;return n},t.prototype.decodeDeltas=function(t){for(var e=this.font.stream,n=0,r=new Int16Array(t);n<t;){var i=e.readUInt8(),a=1+(63&i);if(128&i)n+=a;else for(var o=64&i?e.readInt16BE:e.readInt8,s=0;s<a&&n<t;s++)r[n++]=o.call(e)}return r},t.prototype.tupleFactor=function(t,e,n,r){for(var i=this.normalizedCoords,a=this.font.gvar,o=1,s=0;s<a.axisCount;s++)if(0!==e[s]){if(0===i[s])return 0;if(0==(16384&t)){if(i[s]<Math.min(0,e[s])||i[s]>Math.max(0,e[s]))return 0;o=(o*i[s]+P)/(e[s]+P)}else{if(i[s]<n[s]||i[s]>r[s])return 0;o=i[s]<e[s]?o*(i[s]-n[s]+P)/(e[s]-n[s]+P):o*(r[s]-i[s]+P)/(r[s]-e[s]+P)}}return o},t.prototype.interpolateMissingDeltas=function(t,e,n){if(0!==t.length)for(var r=0;r<t.length;){for(var i=r,a=r,o=t[a];!o.endContour;)o=t[++a];for(;r<=a&&!n[r];)r++;if(!(r>a)){var s=r,l=r;for(r++;r<=a;)n[r]&&(this.deltaInterpolate(l+1,r-1,l,r,e,t),l=r),r++;l===s?this.deltaShift(i,a,l,e,t):(this.deltaInterpolate(l+1,a,l,s,e,t),s>0&&this.deltaInterpolate(i,s-1,l,s,e,t)),r=a+1}}},t.prototype.deltaInterpolate=function(t,e,n,r,i,a){if(!(t>e))for(var o=[\"x\",\"y\"],s=0;s<o.length;s++){var l=o[s];if(i[n][l]>i[r][l]){var u=n;n=r,r=u}var c=i[n][l],h=i[r][l],f=a[n][l],d=a[r][l];if(c!==h||f===d)for(var p=c===h?0:(d-f)/(h-c),g=t;g<=e;g++){var y=i[g][l];y<=c?y+=f-c:y>=h?y+=d-h:y=f+(y-c)*p,a[g][l]=y}}},t.prototype.deltaShift=function(t,e,n,r,i){var a=i[n].x-r[n].x,o=i[n].y-r[n].y;if(0!==a||0!==o)for(var s=t;s<=e;s++)s!==n&&(i[s].x+=a,i[s].y+=o)},t.prototype.getAdvanceAdjustment=function(t,e){var n=void 0,r=void 0;if(e.advanceWidthMapping){var i=t;i>=e.advanceWidthMapping.mapCount&&(i=e.advanceWidthMapping.mapCount-1);e.advanceWidthMapping.entryFormat;var a=e.advanceWidthMapping.mapData[i];n=a.outerIndex,r=a.innerIndex}else n=0,r=t;return this.getDelta(e.itemVariationStore,n,r)},t.prototype.getDelta=function(t,e,n){if(e>=t.itemVariationData.length)return 0;var r=t.itemVariationData[e];if(n>=r.deltaSets.length)return 0;for(var i=r.deltaSets[n],a=this.getBlendVector(t,e),o=0,s=0;s<r.regionIndexCount;s++)o+=i.deltas[s]*a[s];return o},t.prototype.getBlendVector=function(t,e){var n=t.itemVariationData[e];if(this.blendVectors.has(n))return this.blendVectors.get(n);for(var r=this.normalizedCoords,i=[],a=0;a<n.regionIndexCount;a++){for(var o=1,s=n.regionIndexes[a],l=t.variationRegionList.variationRegions[s],u=0;u<l.length;u++){var c=l[u];o*=c.startCoord>c.peakCoord||c.peakCoord>c.endCoord?1:c.startCoord<0&&c.endCoord>0&&0!==c.peakCoord?1:0===c.peakCoord?1:r[u]<c.startCoord||r[u]>c.endCoord?0:r[u]===c.peakCoord?1:r[u]<c.peakCoord?(r[u]-c.startCoord+P)/(c.peakCoord-c.startCoord+P):(c.endCoord-r[u]+P)/(c.endCoord-c.peakCoord+P)}i[a]=o}return this.blendVectors.set(n,i),i},t}(),vs=function(){function t(e){f(this,t),this.font=e,this.glyphs=[],this.mapping={},this.includeGlyph(0)}return t.prototype.includeGlyph=function(t){return\"object\"===(void 0===t?\"undefined\":c(t))&&(t=t.id),null==this.mapping[t]&&(this.glyphs.push(t),this.mapping[t]=this.glyphs.length-1),this.mapping[t]},t.prototype.encodeStream=function(){var t=this,e=new a.EncodeStream;return r.nextTick(function(){return t.encode(e),e.end()}),e},t}(),bs=function(){function t(){f(this,t)}return t.size=function(t){return t>=0&&t<=255?1:2},t.encode=function(t,e){e>=0&&e<=255?t.writeUInt8(e):t.writeInt16BE(e)},t}(),ms=new a.Struct({numberOfContours:a.int16,xMin:a.int16,yMin:a.int16,xMax:a.int16,yMax:a.int16,endPtsOfContours:new a.Array(a.uint16,\"numberOfContours\"),instructions:new a.Array(a.uint8,a.uint16),flags:new a.Array(a.uint8,0),xPoints:new a.Array(bs,0),yPoints:new a.Array(bs,0)}),ws=function(){function t(){f(this,t)}return t.prototype.encodeSimple=function(t){for(var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=[],r=[],i=[],o=[],s=0,l=0,u=0,c=0,h=0,f=0;f<t.commands.length;f++){for(var d=t.commands[f],p=0;p<d.args.length;p+=2){var g=d.args[p],y=d.args[p+1],v=0;if(\"quadraticCurveTo\"===d.command&&2===p){var b=t.commands[f+1];if(b&&\"quadraticCurveTo\"===b.command){var m=(l+b.args[0])/2,w=(u+b.args[1])/2;if(g===m&&y===w)continue}}\"quadraticCurveTo\"===d.command&&0===p||(v|=1),v=this._encodePoint(g,l,r,v,2,16),(v=this._encodePoint(y,u,i,v,4,32))===c&&s<255?(o[o.length-1]|=8,s++):(s>0&&(o.push(s),s=0),o.push(v),c=v),l=g,u=y,h++}\"closePath\"===d.command&&n.push(h-1)}t.commands.length>1&&\"closePath\"!==t.commands[t.commands.length-1].command&&n.push(h-1);var x=t.bbox,S={numberOfContours:n.length,xMin:x.minX,yMin:x.minY,xMax:x.maxX,yMax:x.maxY,endPtsOfContours:n,instructions:e,flags:o,xPoints:r,yPoints:i},_=ms.size(S),k=4-_%4,C=new a.EncodeStream(_+k);return ms.encode(C,S),0!==k&&C.fill(0,k),C.buffer},t.prototype._encodePoint=function(t,e,n,r,i,a){var o=t-e;return t===e?r|=a:(-255<=o&&o<=255&&(r|=i,o<0?o=-o:r|=a),n.push(o)),r},t}(),xs=function(t){function n(e){f(this,n);var r=g(this,t.call(this,e));return r.glyphEncoder=new ws,r}return y(n,t),n.prototype._addGlyph=function(t){var n=this.font.getGlyph(t),r=n._decode(),i=this.font.loca.offsets[t],a=this.font.loca.offsets[t+1],o=this.font._getTableStream(\"glyf\");o.pos+=i;var l=o.readBuffer(a-i);if(r&&r.numberOfContours<0){l=new e(l);var u=r.components,c=Array.isArray(u),h=0;for(u=c?u:s(u);;){var f;if(c){if(h>=u.length)break;f=u[h++]}else{if((h=u.next()).done)break;f=h.value}var d=f;t=this.includeGlyph(d.glyphID),l.writeUInt16BE(t,d.pos)}}else r&&this.font._variationProcessor&&(l=this.glyphEncoder.encodeSimple(n.path,r.instructions));return this.glyf.push(l),this.loca.offsets.push(this.offset),this.hmtx.metrics.push({advance:n.advanceWidth,bearing:n._getMetrics().leftBearing}),this.offset+=l.length,this.glyf.length-1},n.prototype.encode=function(t){this.glyf=[],this.offset=0,this.loca={offsets:[]},this.hmtx={metrics:[],bearings:[]};for(var e=0;e<this.glyphs.length;)this._addGlyph(this.glyphs[e++]);var n=E(this.font.maxp);n.numGlyphs=this.glyf.length,this.loca.offsets.push(this.offset),Yr.loca.preEncode.call(this.loca);var r=E(this.font.head);r.indexToLocFormat=this.loca.version;var i=E(this.font.hhea);i.numberOfMetrics=this.hmtx.metrics.length,Jr.encode(t,{tables:{head:r,hhea:i,loca:this.loca,maxp:n,\"cvt \":this.font[\"cvt \"],prep:this.font.prep,glyf:this.glyf,hmtx:this.hmtx,fpgm:this.font.fpgm}})},n}(vs),Ss=function(t){function n(e){f(this,n);var r=g(this,t.call(this,e));if(r.cff=r.font[\"CFF \"],!r.cff)throw new Error(\"Not a CFF Font\");return r}return y(n,t),n.prototype.subsetCharstrings=function(){this.charstrings=[];var t={},e=this.glyphs,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i;this.charstrings.push(this.cff.getCharString(a));var o=this.font.getGlyph(a);o.path;for(var l in o._usedGsubrs)t[l]=!0}this.gsubrs=this.subsetSubrs(this.cff.globalSubrIndex,t)},n.prototype.subsetSubrs=function(t,n){for(var r=[],i=0;i<t.length;i++){var a=t[i];n[i]?(this.cff.stream.pos=a.offset,r.push(this.cff.stream.readBuffer(a.length))):r.push(new e([11]))}return r},n.prototype.subsetFontdict=function(t){t.FDArray=[],t.FDSelect={version:0,fds:[]};var e={},n=[],r=this.glyphs,i=Array.isArray(r),a=0;for(r=i?r:s(r);;){var o;if(i){if(a>=r.length)break;o=r[a++]}else{if((a=r.next()).done)break;o=a.value}var l=o,u=this.cff.fdForGlyph(l);if(null!=u){e[u]||(t.FDArray.push(w({},this.cff.topDict.FDArray[u])),n.push({})),e[u]=!0,t.FDSelect.fds.push(t.FDArray.length-1);var c=this.font.getGlyph(l);c.path;for(var h in c._usedSubrs)n[n.length-1][h]=!0}}for(var f=0;f<t.FDArray.length;f++){var d=t.FDArray[f];delete d.FontName,d.Private&&d.Private.Subrs&&(d.Private=w({},d.Private),d.Private.Subrs=this.subsetSubrs(d.Private.Subrs,n[f]))}},n.prototype.createCIDFontdict=function(t){var e={},n=this.glyphs,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=this.font.getGlyph(o);l.path;for(var u in l._usedSubrs)e[u]=!0}var c=w({},this.cff.topDict.Private);return c.Subrs=this.subsetSubrs(this.cff.topDict.Private.Subrs,e),t.FDArray=[{Private:c}],t.FDSelect={version:3,nRanges:1,ranges:[{first:0,fd:0}],sentinel:this.charstrings.length}},n.prototype.addString=function(t){return t?(this.strings||(this.strings=[]),this.strings.push(t),bt.length+this.strings.length-1):null},n.prototype.encode=function(t){this.subsetCharstrings();var e={version:this.charstrings.length>255?2:1,ranges:[{first:1,nLeft:this.charstrings.length-2}]},n=w({},this.cff.topDict);n.Private=null,n.charset=e,n.Encoding=null,n.CharStrings=this.charstrings;for(var r=[\"version\",\"Notice\",\"Copyright\",\"FullName\",\"FamilyName\",\"Weight\",\"PostScript\",\"BaseFontName\",\"FontName\"],i=0;i<r.length;i++){var a=r[i];n[a]=this.addString(this.cff.string(n[a]))}n.ROS=[this.addString(\"Adobe\"),this.addString(\"Identity\"),0],n.CIDCount=this.charstrings.length,this.cff.isCIDFont?this.subsetFontdict(n):this.createCIDFontdict(n);var o={version:1,hdrSize:this.cff.hdrSize,offSize:this.cff.length,header:this.cff.header,nameIndex:[this.cff.postscriptName],topDictIndex:[n],stringIndex:this.strings,globalSubrIndex:this.gsubrs};we.encode(t,o)},n}(vs);function _s(t,e,n,r,i){var a={};return Object.keys(r).forEach(function(t){a[t]=r[t]}),a.enumerable=!!a.enumerable,a.configurable=!!a.configurable,(\"value\"in a||a.initializer)&&(a.writable=!0),a=n.slice().reverse().reduce(function(n,r){return r(t,e,n)||n},a),i&&void 0!==a.initializer&&(a.value=a.initializer?a.initializer.call(i):void 0,a.initializer=void 0),void 0===a.initializer&&(Object.defineProperty(t,e,a),a=null),a}var ks=(_s((as=function(){function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;for(var r in f(this,t),this.stream=e,this.variationCoords=n,this._directoryPos=this.stream.pos,this._tables={},this._glyphs={},this._decodeDirectory(),this.directory.tables){var i=this.directory.tables[r];Yr[r]&&i.length>0&&h(this,r,{get:this._getTable.bind(this,i)})}}return t.probe=function(t){var e=t.toString(\"ascii\",0,4);return\"true\"===e||\"OTTO\"===e||e===String.fromCharCode(0,1,0,0)},t.prototype._getTable=function(t){if(!(t.tag in this._tables))try{this._tables[t.tag]=this._decodeTable(t)}catch(t){O.logErrors}return this._tables[t.tag]},t.prototype._getTableStream=function(t){var e=this.directory.tables[t];return e?(this.stream.pos=e.offset,this.stream):null},t.prototype._decodeDirectory=function(){return this.directory=Jr.decode(this.stream,{_startOffset:0})},t.prototype._decodeTable=function(t){var e=this.stream.pos,n=this._getTableStream(t.tag),r=Yr[t.tag].decode(n,this,t.length);return this.stream.pos=e,r},t.prototype.getName=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:\"en\",n=this.name.records[t];return n?n[e]:null},t.prototype.hasGlyphForCodePoint=function(t){return!!this._cmapProcessor.lookup(t)},t.prototype.glyphForCodePoint=function(t){return this.getGlyph(this._cmapProcessor.lookup(t),[t])},t.prototype.glyphsForString=function(t){for(var e=[],n=t.length,r=0,i=-1,a=-1;r<=n;){var o=0,s=0;if(r<n){if(55296<=(o=t.charCodeAt(r++))&&o<=56319&&r<n){var l=t.charCodeAt(r);56320<=l&&l<=57343&&(r++,o=((1023&o)<<10)+(1023&l)+65536)}s=65024<=o&&o<=65039||917760<=o&&o<=917999?1:0}else r++;0===a&&1===s?e.push(this.getGlyph(this._cmapProcessor.lookup(i,o),[i,o])):0===a&&0===s&&e.push(this.glyphForCodePoint(i)),i=o,a=s}return e},t.prototype.layout=function(t,e,n,r,i){return this._layoutEngine.layout(t,e,n,r,i)},t.prototype.stringsForGlyph=function(t){return this._layoutEngine.stringsForGlyph(t)},t.prototype.getAvailableFeatures=function(t,e){return this._layoutEngine.getAvailableFeatures(t,e)},t.prototype._getBaseGlyph=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return this._glyphs[t]||(this.directory.tables.glyf?this._glyphs[t]=new cs(t,e,this):(this.directory.tables[\"CFF \"]||this.directory.tables.CFF2)&&(this._glyphs[t]=new hs(t,e,this))),this._glyphs[t]||null},t.prototype.getGlyph=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return this._glyphs[t]||(this.directory.tables.sbix?this._glyphs[t]=new ds(t,e,this):this.directory.tables.COLR&&this.directory.tables.CPAL?this._glyphs[t]=new gs(t,e,this):this._getBaseGlyph(t,e)),this._glyphs[t]||null},t.prototype.createSubset=function(){return this.directory.tables[\"CFF \"]?new Ss(this):new xs(this)},t.prototype.getVariation=function(e){if(!this.directory.tables.fvar||!(this.directory.tables.gvar&&this.directory.tables.glyf||this.directory.tables.CFF2))throw new Error(\"Variations require a font with the fvar, gvar and glyf, or CFF2 tables.\");if(\"string\"==typeof e&&(e=this.namedVariations[e]),\"object\"!==(void 0===e?\"undefined\":c(e)))throw new Error(\"Variation settings must be either a variation name or settings object.\");var n=this.fvar.axis.map(function(t,n){var r=t.axisTag.trim();return r in e?Math.max(t.minValue,Math.min(t.maxValue,e[r])):t.defaultValue}),r=new a.DecodeStream(this.stream.buffer);r.pos=this._directoryPos;var i=new t(r,n);return i._tables=this._tables,i},t.prototype.getFont=function(t){return this.getVariation(t)},d(t,[{key:\"postscriptName\",get:function(){var t=this.name.records.postscriptName;return t?t[u(t)[0]]:null}},{key:\"fullName\",get:function(){return this.getName(\"fullName\")}},{key:\"familyName\",get:function(){return this.getName(\"fontFamily\")}},{key:\"subfamilyName\",get:function(){return this.getName(\"fontSubfamily\")}},{key:\"copyright\",get:function(){return this.getName(\"copyright\")}},{key:\"version\",get:function(){return this.getName(\"version\")}},{key:\"ascent\",get:function(){return this.hhea.ascent}},{key:\"descent\",get:function(){return this.hhea.descent}},{key:\"lineGap\",get:function(){return this.hhea.lineGap}},{key:\"underlinePosition\",get:function(){return this.post.underlinePosition}},{key:\"underlineThickness\",get:function(){return this.post.underlineThickness}},{key:\"italicAngle\",get:function(){return this.post.italicAngle}},{key:\"capHeight\",get:function(){var t=this[\"OS/2\"];return t?t.capHeight:this.ascent}},{key:\"xHeight\",get:function(){var t=this[\"OS/2\"];return t?t.xHeight:0}},{key:\"numGlyphs\",get:function(){return this.maxp.numGlyphs}},{key:\"unitsPerEm\",get:function(){return this.head.unitsPerEm}},{key:\"bbox\",get:function(){return l(new ai(this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax))}},{key:\"_cmapProcessor\",get:function(){return new ni(this.cmap)}},{key:\"characterSet\",get:function(){return this._cmapProcessor.getCharacterSet()}},{key:\"_layoutEngine\",get:function(){return new Ko(this)}},{key:\"availableFeatures\",get:function(){return this._layoutEngine.getAvailableFeatures()}},{key:\"variationAxes\",get:function(){var t={};if(!this.fvar)return t;var e=this.fvar.axis,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i;t[a.axisTag.trim()]={name:a.name.en,min:a.minValue,default:a.defaultValue,max:a.maxValue}}return t}},{key:\"namedVariations\",get:function(){var t={};if(!this.fvar)return t;var e=this.fvar.instance,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}for(var a=i,o={},l=0;l<this.fvar.axis.length;l++){o[this.fvar.axis[l].axisTag.trim()]=a.coord[l]}t[a.name.en]=o}return t}},{key:\"_variationProcessor\",get:function(){if(!this.fvar)return null;var t=this.variationCoords;return t||this.CFF2?(t||(t=this.fvar.axis.map(function(t){return t.defaultValue})),new ys(this,t)):null}}]),t}()).prototype,\"bbox\",[B],o(as.prototype,\"bbox\"),as.prototype),_s(as.prototype,\"_cmapProcessor\",[B],o(as.prototype,\"_cmapProcessor\"),as.prototype),_s(as.prototype,\"characterSet\",[B],o(as.prototype,\"characterSet\"),as.prototype),_s(as.prototype,\"_layoutEngine\",[B],o(as.prototype,\"_layoutEngine\"),as.prototype),_s(as.prototype,\"variationAxes\",[B],o(as.prototype,\"variationAxes\"),as.prototype),_s(as.prototype,\"namedVariations\",[B],o(as.prototype,\"namedVariations\"),as.prototype),_s(as.prototype,\"_variationProcessor\",[B],o(as.prototype,\"_variationProcessor\"),as.prototype),as),Cs=new a.Struct({tag:new a.String(4),offset:new a.Pointer(a.uint32,\"void\",{type:\"global\"}),compLength:a.uint32,length:a.uint32,origChecksum:a.uint32}),As=new a.Struct({tag:new a.String(4),flavor:a.uint32,length:a.uint32,numTables:a.uint16,reserved:new a.Reserved(a.uint16),totalSfntSize:a.uint32,majorVersion:a.uint16,minorVersion:a.uint16,metaOffset:a.uint32,metaLength:a.uint32,metaOrigLength:a.uint32,privOffset:a.uint32,privLength:a.uint32,tables:new a.Array(Cs,\"numTables\")});As.process=function(){var t={},e=this.tables,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var a=i;t[a.tag]=a}this.tables=t};var Ps=function(t){function n(){return f(this,n),g(this,t.apply(this,arguments))}return y(n,t),n.probe=function(t){return\"wOFF\"===t.toString(\"ascii\",0,4)},n.prototype._decodeDirectory=function(){this.directory=As.decode(this.stream,{_startOffset:0})},n.prototype._getTableStream=function(t){var n=this.directory.tables[t];if(n){if(this.stream.pos=n.offset,n.compLength<n.length){this.stream.pos+=2;var r=new e(n.length),i=I(this.stream.readBuffer(n.compLength-2),r);return new a.DecodeStream(i)}return this.stream}return null},n}(ks),Es=function(t){function e(){return f(this,e),g(this,t.apply(this,arguments))}return y(e,t),e.prototype._decode=function(){return this._font._transformedGlyphs[this.id]},e.prototype._getCBox=function(){return this.path.bbox},e}(cs),Is={decode:function(t){for(var e=0,n=[0,1,2,3,4],r=0;r<n.length;r++){var i=t.readUInt8();if(3758096384&e)throw new Error(\"Overflow\");if(e=e<<7|127&i,0==(128&i))return e}throw new Error(\"Bad base 128 number\")}},Ts=[\"cmap\",\"head\",\"hhea\",\"hmtx\",\"maxp\",\"name\",\"OS/2\",\"post\",\"cvt \",\"fpgm\",\"glyf\",\"loca\",\"prep\",\"CFF \",\"VORG\",\"EBDT\",\"EBLC\",\"gasp\",\"hdmx\",\"kern\",\"LTSH\",\"PCLT\",\"VDMX\",\"vhea\",\"vmtx\",\"BASE\",\"GDEF\",\"GPOS\",\"GSUB\",\"EBSC\",\"JSTF\",\"MATH\",\"CBDT\",\"CBLC\",\"COLR\",\"CPAL\",\"SVG \",\"sbix\",\"acnt\",\"avar\",\"bdat\",\"bloc\",\"bsln\",\"cvar\",\"fdsc\",\"feat\",\"fmtx\",\"fvar\",\"gvar\",\"hsty\",\"just\",\"lcar\",\"mort\",\"morx\",\"opbd\",\"prop\",\"trak\",\"Zapf\",\"Silf\",\"Glat\",\"Gloc\",\"Feat\",\"Sill\"],Os=new a.Struct({flags:a.uint8,customTag:new a.Optional(new a.String(4),function(t){return 63==(63&t.flags)}),tag:function(t){return t.customTag||Ts[63&t.flags]},length:Is,transformVersion:function(t){return t.flags>>>6&3},transformed:function(t){return\"glyf\"===t.tag||\"loca\"===t.tag?0===t.transformVersion:0!==t.transformVersion},transformLength:new a.Optional(Is,function(t){return t.transformed})}),Ls=new a.Struct({tag:new a.String(4),flavor:a.uint32,length:a.uint32,numTables:a.uint16,reserved:new a.Reserved(a.uint16),totalSfntSize:a.uint32,totalCompressedSize:a.uint32,majorVersion:a.uint16,minorVersion:a.uint16,metaOffset:a.uint32,metaLength:a.uint32,metaOrigLength:a.uint32,privOffset:a.uint32,privLength:a.uint32,tables:new a.Array(Os,\"numTables\")});Ls.process=function(){for(var t={},e=0;e<this.tables.length;e++){var n=this.tables[e];t[n.tag]=n}return this.tables=t};var Bs=function(t){function n(){return f(this,n),g(this,t.apply(this,arguments))}return y(n,t),n.probe=function(t){return\"wOF2\"===t.toString(\"ascii\",0,4)},n.prototype._decodeDirectory=function(){this.directory=Ls.decode(this.stream),this._dataPos=this.stream.pos},n.prototype._decompress=function(){if(!this._decompressed){this.stream.pos=this._dataPos;var t=this.stream.readBuffer(this.directory.totalCompressedSize),n=0;for(var r in this.directory.tables){var i=this.directory.tables[r];i.offset=n,n+=null!=i.transformLength?i.transformLength:i.length}var o=T(t,n);if(!o)throw new Error(\"Error decoding compressed data in WOFF2\");this.stream=new a.DecodeStream(new e(o)),this._decompressed=!0}},n.prototype._decodeTable=function(e){return this._decompress(),t.prototype._decodeTable.call(this,e)},n.prototype._getBaseGlyph=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];if(!this._glyphs[e])return this.directory.tables.glyf&&this.directory.tables.glyf.transformed?(this._transformedGlyphs||this._transformGlyfTable(),this._glyphs[e]=new Es(e,n,this)):t.prototype._getBaseGlyph.call(this,e,n)},n.prototype._transformGlyfTable=function(){this._decompress(),this.stream.pos=this.directory.tables.glyf.offset;for(var t=GlyfTable.decode(this.stream),e=[],n=0;n<t.numGlyphs;n++){var r={},i=t.nContours.readInt16BE();if(r.numberOfContours=i,i>0){for(var a=[],o=0,s=0;s<i;s++){o+=Ns(t.nPoints),a.push(o)}r.points=Ws(t.flags,t.glyphs,o);for(var l=0;l<i;l++)r.points[a[l]-1].endContour=!0;Ns(t.glyphs)}else if(i<0){if(cs.prototype._decodeComposite.call({_font:this},r,t.composites))Ns(t.glyphs)}e.push(r)}this._transformedGlyphs=e},n}(ks),Ms=function(){function t(e){f(this,t),this.length=e,this._buf=new a.Buffer(e)}return t.prototype.decode=function(t,e){return new a.DecodeStream(this._buf.decode(t,e))},t}(),GlyfTable=new a.Struct({version:a.uint32,numGlyphs:a.uint16,indexFormat:a.uint16,nContourStreamSize:a.uint32,nPointsStreamSize:a.uint32,flagStreamSize:a.uint32,glyphStreamSize:a.uint32,compositeStreamSize:a.uint32,bboxStreamSize:a.uint32,instructionStreamSize:a.uint32,nContours:new Ms(\"nContourStreamSize\"),nPoints:new Ms(\"nPointsStreamSize\"),flags:new Ms(\"flagStreamSize\"),glyphs:new Ms(\"glyphStreamSize\"),composites:new Ms(\"compositeStreamSize\"),bboxes:new Ms(\"bboxStreamSize\"),instructions:new Ms(\"instructionStreamSize\")}),Rs=253,Fs=254,Ds=255,zs=253;function Ns(t){var e=t.readUInt8();return e===Rs?t.readUInt16BE():e===Ds?t.readUInt8()+zs:e===Fs?t.readUInt8()+2*zs:e}function Us(t,e){return 1&t?e:-e}function Ws(t,e,n){for(var r=void 0,i=r=0,a=[],o=0;o<n;o++){var s=0,l=0,u=t.readUInt8(),c=!(u>>7);if((u&=127)<10)s=0,l=Us(u,((14&u)<<7)+e.readUInt8());else if(u<20)s=Us(u,((u-10&14)<<7)+e.readUInt8()),l=0;else if(u<84){s=Us(u,1+(48&(h=u-20))+((f=e.readUInt8())>>4)),l=Us(u>>1,1+((12&h)<<2)+(15&f))}else if(u<120){var h;s=Us(u,1+((h=u-84)/12<<8)+e.readUInt8()),l=Us(u>>1,1+(h%12>>2<<8)+e.readUInt8())}else if(u<124){var f=e.readUInt8(),d=e.readUInt8();s=Us(u,(f<<4)+(d>>4)),l=Us(u>>1,((15&d)<<8)+e.readUInt8())}else s=Us(u,e.readUInt16BE()),l=Us(u>>1,e.readUInt16BE());i+=s,r+=l,a.push(new ls(c,!1,i,r))}return a}var Gs=new a.VersionedStruct(a.uint32,{65536:{numFonts:a.uint32,offsets:new a.Array(a.uint32,\"numFonts\")},131072:{numFonts:a.uint32,offsets:new a.Array(a.uint32,\"numFonts\"),dsigTag:a.uint32,dsigLength:a.uint32,dsigOffset:a.uint32}}),Vs=function(){function t(e){if(f(this,t),this.stream=e,\"ttcf\"!==e.readString(4))throw new Error(\"Not a TrueType collection\");this.header=Gs.decode(e)}return t.probe=function(t){return\"ttcf\"===t.toString(\"ascii\",0,4)},t.prototype.getFont=function(t){var e=this.header.offsets,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var o=i,l=new a.DecodeStream(this.stream.buffer);l.pos=o;var u=new ks(l);if(u.postscriptName===t)return u}return null},d(t,[{key:\"fonts\",get:function(){var t=[],e=this.header.offsets,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var o=i,l=new a.DecodeStream(this.stream.buffer);l.pos=o,t.push(new ks(l))}return t}}]),t}(),js=new a.String(a.uint8),Hs=(new a.Struct({len:a.uint32,buf:new a.Buffer(\"len\")}),new a.Struct({id:a.uint16,nameOffset:a.int16,attr:a.uint8,dataOffset:a.uint24,handle:a.uint32})),qs=new a.Struct({name:new a.String(4),maxTypeIndex:a.uint16,refList:new a.Pointer(a.uint16,new a.Array(Hs,function(t){return t.maxTypeIndex+1}),{type:\"parent\"})}),Zs=new a.Struct({length:a.uint16,types:new a.Array(qs,function(t){return t.length+1})}),Ys=new a.Struct({reserved:new a.Reserved(a.uint8,24),typeList:new a.Pointer(a.uint16,Zs),nameListOffset:new a.Pointer(a.uint16,\"void\")}),Xs=new a.Struct({dataOffset:a.uint32,map:new a.Pointer(a.uint32,Ys),dataLength:a.uint32,mapLength:a.uint32}),Ks=function(){function t(e){f(this,t),this.stream=e,this.header=Xs.decode(this.stream);var n=this.header.map.typeList.types,r=Array.isArray(n),i=0;for(n=r?n:s(n);;){var a;if(r){if(i>=n.length)break;a=n[i++]}else{if((i=n.next()).done)break;a=i.value}var o=a,l=o.refList,u=Array.isArray(l),c=0;for(l=u?l:s(l);;){var h;if(u){if(c>=l.length)break;h=l[c++]}else{if((c=l.next()).done)break;h=c.value}var d=h;d.nameOffset>=0?(this.stream.pos=d.nameOffset+this.header.map.nameListOffset,d.name=js.decode(this.stream)):d.name=null}\"sfnt\"===o.name&&(this.sfnt=o)}}return t.probe=function(t){var e=new a.DecodeStream(t);try{var n=Xs.decode(e)}catch(t){return!1}var r=n.map.typeList.types,i=Array.isArray(r),o=0;for(r=i?r:s(r);;){var l;if(i){if(o>=r.length)break;l=r[o++]}else{if((o=r.next()).done)break;l=o.value}if(\"sfnt\"===l.name)return!0}return!1},t.prototype.getFont=function(t){if(!this.sfnt)return null;var e=this.sfnt.refList,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var o=i,l=this.header.dataOffset+o.dataOffset+4,u=new a.DecodeStream(this.stream.buffer.slice(l)),c=new ks(u);if(c.postscriptName===t)return c}return null},d(t,[{key:\"fonts\",get:function(){var t=[],e=this.sfnt.refList,n=Array.isArray(e),r=0;for(e=n?e:s(e);;){var i;if(n){if(r>=e.length)break;i=e[r++]}else{if((r=e.next()).done)break;i=r.value}var o=i,l=this.header.dataOffset+o.dataOffset+4,u=new a.DecodeStream(this.stream.buffer.slice(l));t.push(new ks(u))}return t}}]),t}();O.registerFormat(ks),O.registerFormat(Ps),O.registerFormat(Bs),O.registerFormat(Vs),O.registerFormat(Ks),t.exports=O}).call(e,n(1).Buffer,n(11))},function(t,e,n){(function(){var t,r,i,a;for(t in e.EncodeStream=n(169),e.DecodeStream=n(51),e.Array=n(93),e.LazyArray=n(187),e.Bitfield=n(188),e.Boolean=n(189),e.Buffer=n(190),e.Enum=n(191),e.Optional=n(192),e.Reserved=n(193),e.String=n(194),e.Struct=n(94),e.VersionedStruct=n(195),i=n(22))r=i[t],e[t]=r;for(t in a=n(196))r=a[t],e[t]=r}).call(this)},function(t,e,n){(function(e){(function(){var r,i,a,o,s={}.hasOwnProperty;o=n(15),r=n(51);try{a=n(52)}catch(t){}i=function(t){var n;function i(t){null==t&&(t=65536),i.__super__.constructor.apply(this,arguments),this.buffer=new e(t),this.bufferOffset=0,this.pos=0}for(n in function(t,e){for(var n in e)s.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(i,t),e.prototype)\"write\"===n.slice(0,5)&&function(t){var e;e=+r.TYPES[t.replace(/write|[BL]E/g,\"\")],i.prototype[t]=function(n){return this.ensure(e),this.buffer[t](n,this.bufferOffset),this.bufferOffset+=e,this.pos+=e}}(n);return i.prototype._read=function(){},i.prototype.ensure=function(t){if(this.bufferOffset+t>this.buffer.length)return this.flush()},i.prototype.flush=function(){if(this.bufferOffset>0)return this.push(new e(this.buffer.slice(0,this.bufferOffset))),this.bufferOffset=0},i.prototype.writeBuffer=function(t){return this.flush(),this.push(t),this.pos+=t.length},i.prototype.writeString=function(t,n){var r,i,o,s,l;switch(null==n&&(n=\"ascii\"),n){case\"utf16le\":case\"ucs2\":case\"utf8\":case\"ascii\":return this.writeBuffer(new e(t,n));case\"utf16be\":for(o=s=0,l=(r=new e(t,\"utf16le\")).length-1;s<l;o=s+=2)i=r[o],r[o]=r[o+1],r[o+1]=i;return this.writeBuffer(r);default:if(a)return this.writeBuffer(a.encode(t,n));throw new Error(\"Install iconv-lite to enable additional string encodings.\")}},i.prototype.writeUInt24BE=function(t){return this.ensure(3),this.buffer[this.bufferOffset++]=t>>>16&255,this.buffer[this.bufferOffset++]=t>>>8&255,this.buffer[this.bufferOffset++]=255&t,this.pos+=3},i.prototype.writeUInt24LE=function(t){return this.ensure(3),this.buffer[this.bufferOffset++]=255&t,this.buffer[this.bufferOffset++]=t>>>8&255,this.buffer[this.bufferOffset++]=t>>>16&255,this.pos+=3},i.prototype.writeInt24BE=function(t){return t>=0?this.writeUInt24BE(t):this.writeUInt24BE(t+16777215+1)},i.prototype.writeInt24LE=function(t){return t>=0?this.writeUInt24LE(t):this.writeUInt24LE(t+16777215+1)},i.prototype.fill=function(t,n){var r;return n<this.buffer.length?(this.ensure(n),this.buffer.fill(t,this.bufferOffset,this.bufferOffset+n),this.bufferOffset+=n,this.pos+=n):((r=new e(n)).fill(t),this.writeBuffer(r))},i.prototype.end=function(){return this.flush(),this.push(null)},i}(o.Readable),t.exports=i}).call(this)}).call(e,n(1).Buffer)},function(t,e,n){\"use strict\";function r(t,e){this.encoder=t,this.addBOM=!0}function i(t,e){this.decoder=t,this.pass=!1,this.options=e||{}}e.PrependBOM=r,r.prototype.write=function(t){return this.addBOM&&(t=\"\\ufeff\"+t,this.addBOM=!1),this.encoder.write(t)},r.prototype.end=function(){return this.encoder.end()},e.StripBOM=i,i.prototype.write=function(t){var e=this.decoder.write(t);return this.pass||!e?e:(\"\\ufeff\"===e[0]&&(e=e.slice(1),\"function\"==typeof this.options.stripBOM&&this.options.stripBOM()),this.pass=!0,e)},i.prototype.end=function(){return this.decoder.end()}},function(t,e,n){\"use strict\";for(var r=[n(172),n(173),n(174),n(175),n(176),n(177),n(178),n(179)],i=0;i<r.length;i++){t=r[i];for(var a in t)Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a])}},function(t,e,n){\"use strict\";var r=n(1).Buffer;function i(t,e){this.enc=t.encodingName,this.bomAware=t.bomAware,\"base64\"===this.enc?this.encoder=l:\"cesu8\"===this.enc&&(this.enc=\"utf8\",this.encoder=u,\"💩\"!==new r(\"eda0bdedb2a9\",\"hex\").toString()&&(this.decoder=c,this.defaultCharUnicode=e.defaultCharUnicode))}t.exports={utf8:{type:\"_internal\",bomAware:!0},cesu8:{type:\"_internal\",bomAware:!0},unicode11utf8:\"utf8\",ucs2:{type:\"_internal\",bomAware:!0},utf16le:\"ucs2\",binary:{type:\"_internal\"},base64:{type:\"_internal\"},hex:{type:\"_internal\"},_internal:i},i.prototype.encoder=s,i.prototype.decoder=o;var a=n(47).StringDecoder;function o(t,e){a.call(this,e.enc)}function s(t,e){this.enc=e.enc}function l(t,e){this.prevStr=\"\"}function u(t,e){}function c(t,e){this.acc=0,this.contBytes=0,this.accBytes=0,this.defaultCharUnicode=e.defaultCharUnicode}a.prototype.end||(a.prototype.end=function(){}),o.prototype=a.prototype,s.prototype.write=function(t){return new r(t,this.enc)},s.prototype.end=function(){},l.prototype.write=function(t){var e=(t=this.prevStr+t).length-t.length%4;return this.prevStr=t.slice(e),t=t.slice(0,e),new r(t,\"base64\")},l.prototype.end=function(){return new r(this.prevStr,\"base64\")},u.prototype.write=function(t){for(var e=new r(3*t.length),n=0,i=0;i<t.length;i++){var a=t.charCodeAt(i);a<128?e[n++]=a:a<2048?(e[n++]=192+(a>>>6),e[n++]=128+(63&a)):(e[n++]=224+(a>>>12),e[n++]=128+(a>>>6&63),e[n++]=128+(63&a))}return e.slice(0,n)},u.prototype.end=function(){},c.prototype.write=function(t){for(var e=this.acc,n=this.contBytes,r=this.accBytes,i=\"\",a=0;a<t.length;a++){var o=t[a];128!=(192&o)?(n>0&&(i+=this.defaultCharUnicode,n=0),o<128?i+=String.fromCharCode(o):o<224?(e=31&o,n=1,r=1):o<240?(e=15&o,n=2,r=1):i+=this.defaultCharUnicode):n>0?(e=e<<6|63&o,r++,0===--n&&(i+=2===r&&e<128&&e>0?this.defaultCharUnicode:3===r&&e<2048?this.defaultCharUnicode:String.fromCharCode(e))):i+=this.defaultCharUnicode}return this.acc=e,this.contBytes=n,this.accBytes=r,i},c.prototype.end=function(){var t=0;return this.contBytes>0&&(t+=this.defaultCharUnicode),t}},function(t,e,n){\"use strict\";var r=n(1).Buffer;function i(){}function a(){}function o(){this.overflowByte=-1}function s(t,e){this.iconv=e}function l(t,e){void 0===(t=t||{}).addBOM&&(t.addBOM=!0),this.encoder=e.iconv.getEncoder(\"utf-16le\",t)}function u(t,e){this.decoder=null,this.initialBytes=[],this.initialBytesLen=0,this.options=t||{},this.iconv=e.iconv}function c(t,e){var n=e||\"utf-16le\";if(t.length>=2)if(254==t[0]&&255==t[1])n=\"utf-16be\";else if(255==t[0]&&254==t[1])n=\"utf-16le\";else{for(var r=0,i=0,a=Math.min(t.length-t.length%2,64),o=0;o<a;o+=2)0===t[o]&&0!==t[o+1]&&i++,0!==t[o]&&0===t[o+1]&&r++;i>r?n=\"utf-16be\":i<r&&(n=\"utf-16le\")}return n}e.utf16be=i,i.prototype.encoder=a,i.prototype.decoder=o,i.prototype.bomAware=!0,a.prototype.write=function(t){for(var e=new r(t,\"ucs2\"),n=0;n<e.length;n+=2){var i=e[n];e[n]=e[n+1],e[n+1]=i}return e},a.prototype.end=function(){},o.prototype.write=function(t){if(0==t.length)return\"\";var e=new r(t.length+1),n=0,i=0;for(-1!==this.overflowByte&&(e[0]=t[0],e[1]=this.overflowByte,n=1,i=2);n<t.length-1;n+=2,i+=2)e[i]=t[n+1],e[i+1]=t[n];return this.overflowByte=n==t.length-1?t[t.length-1]:-1,e.slice(0,i).toString(\"ucs2\")},o.prototype.end=function(){},e.utf16=s,s.prototype.encoder=l,s.prototype.decoder=u,l.prototype.write=function(t){return this.encoder.write(t)},l.prototype.end=function(){return this.encoder.end()},u.prototype.write=function(t){if(!this.decoder){if(this.initialBytes.push(t),this.initialBytesLen+=t.length,this.initialBytesLen<16)return\"\";var e=c(t=r.concat(this.initialBytes),this.options.defaultEncoding);this.decoder=this.iconv.getDecoder(e,this.options),this.initialBytes.length=this.initialBytesLen=0}return this.decoder.write(t)},u.prototype.end=function(){if(!this.decoder){var t=r.concat(this.initialBytes),e=c(t,this.options.defaultEncoding);this.decoder=this.iconv.getDecoder(e,this.options);var n=this.decoder.write(t),i=this.decoder.end();return i?n+i:n}return this.decoder.end()}},function(t,e,n){\"use strict\";var r=n(1).Buffer;function i(t,e){this.iconv=e}e.utf7=i,e.unicode11utf7=\"utf7\",i.prototype.encoder=o,i.prototype.decoder=s,i.prototype.bomAware=!0;var a=/[^A-Za-z0-9'\\(\\),-\\.\\/:\\? \\n\\r\\t]+/g;function o(t,e){this.iconv=e.iconv}function s(t,e){this.iconv=e.iconv,this.inBase64=!1,this.base64Accum=\"\"}o.prototype.write=function(t){return new r(t.replace(a,function(t){return\"+\"+(\"+\"===t?\"\":this.iconv.encode(t,\"utf16-be\").toString(\"base64\").replace(/=+$/,\"\"))+\"-\"}.bind(this)))},o.prototype.end=function(){};for(var l=/[A-Za-z0-9\\/+]/,u=[],c=0;c<256;c++)u[c]=l.test(String.fromCharCode(c));var h=\"+\".charCodeAt(0),f=\"-\".charCodeAt(0),d=\"&\".charCodeAt(0);function p(t,e){this.iconv=e}function g(t,e){this.iconv=e.iconv,this.inBase64=!1,this.base64Accum=new r(6),this.base64AccumIdx=0}function y(t,e){this.iconv=e.iconv,this.inBase64=!1,this.base64Accum=\"\"}s.prototype.write=function(t){for(var e=\"\",n=0,i=this.inBase64,a=this.base64Accum,o=0;o<t.length;o++)if(i){if(!u[t[o]]){if(o==n&&t[o]==f)e+=\"+\";else{var s=a+t.slice(n,o).toString();e+=this.iconv.decode(new r(s,\"base64\"),\"utf16-be\")}t[o]!=f&&o--,n=o+1,i=!1,a=\"\"}}else t[o]==h&&(e+=this.iconv.decode(t.slice(n,o),\"ascii\"),n=o+1,i=!0);if(i){var l=(s=a+t.slice(n).toString()).length-s.length%8;a=s.slice(l),s=s.slice(0,l),e+=this.iconv.decode(new r(s,\"base64\"),\"utf16-be\")}else e+=this.iconv.decode(t.slice(n),\"ascii\");return this.inBase64=i,this.base64Accum=a,e},s.prototype.end=function(){var t=\"\";return this.inBase64&&this.base64Accum.length>0&&(t=this.iconv.decode(new r(this.base64Accum,\"base64\"),\"utf16-be\")),this.inBase64=!1,this.base64Accum=\"\",t},e.utf7imap=p,p.prototype.encoder=g,p.prototype.decoder=y,p.prototype.bomAware=!0,g.prototype.write=function(t){for(var e=this.inBase64,n=this.base64Accum,i=this.base64AccumIdx,a=new r(5*t.length+10),o=0,s=0;s<t.length;s++){var l=t.charCodeAt(s);32<=l&&l<=126?(e&&(i>0&&(o+=a.write(n.slice(0,i).toString(\"base64\").replace(/\\//g,\",\").replace(/=+$/,\"\"),o),i=0),a[o++]=f,e=!1),e||(a[o++]=l,l===d&&(a[o++]=f))):(e||(a[o++]=d,e=!0),e&&(n[i++]=l>>8,n[i++]=255&l,i==n.length&&(o+=a.write(n.toString(\"base64\").replace(/\\//g,\",\"),o),i=0)))}return this.inBase64=e,this.base64AccumIdx=i,a.slice(0,o)},g.prototype.end=function(){var t=new r(10),e=0;return this.inBase64&&(this.base64AccumIdx>0&&(e+=t.write(this.base64Accum.slice(0,this.base64AccumIdx).toString(\"base64\").replace(/\\//g,\",\").replace(/=+$/,\"\"),e),this.base64AccumIdx=0),t[e++]=f,this.inBase64=!1),t.slice(0,e)};var v=u.slice();v[\",\".charCodeAt(0)]=!0,y.prototype.write=function(t){for(var e=\"\",n=0,i=this.inBase64,a=this.base64Accum,o=0;o<t.length;o++)if(i){if(!v[t[o]]){if(o==n&&t[o]==f)e+=\"&\";else{var s=a+t.slice(n,o).toString().replace(/,/g,\"/\");e+=this.iconv.decode(new r(s,\"base64\"),\"utf16-be\")}t[o]!=f&&o--,n=o+1,i=!1,a=\"\"}}else t[o]==d&&(e+=this.iconv.decode(t.slice(n,o),\"ascii\"),n=o+1,i=!0);if(i){var l=(s=a+t.slice(n).toString().replace(/,/g,\"/\")).length-s.length%8;a=s.slice(l),s=s.slice(0,l),e+=this.iconv.decode(new r(s,\"base64\"),\"utf16-be\")}else e+=this.iconv.decode(t.slice(n),\"ascii\");return this.inBase64=i,this.base64Accum=a,e},y.prototype.end=function(){var t=\"\";return this.inBase64&&this.base64Accum.length>0&&(t=this.iconv.decode(new r(this.base64Accum,\"base64\"),\"utf16-be\")),this.inBase64=!1,this.base64Accum=\"\",t}},function(t,e,n){\"use strict\";var r=n(1).Buffer;function i(t,e){if(!t)throw new Error(\"SBCS codec is called without the data.\");if(!t.chars||128!==t.chars.length&&256!==t.chars.length)throw new Error(\"Encoding '\"+t.type+\"' has incorrect 'chars' (must be of len 128 or 256)\");if(128===t.chars.length){for(var n=\"\",i=0;i<128;i++)n+=String.fromCharCode(i);t.chars=n+t.chars}this.decodeBuf=new r(t.chars,\"ucs2\");var a=new r(65536);a.fill(e.defaultCharSingleByte.charCodeAt(0));for(i=0;i<t.chars.length;i++)a[t.chars.charCodeAt(i)]=i;this.encodeBuf=a}function a(t,e){this.encodeBuf=e.encodeBuf}function o(t,e){this.decodeBuf=e.decodeBuf}e._sbcs=i,i.prototype.encoder=a,i.prototype.decoder=o,a.prototype.write=function(t){for(var e=new r(t.length),n=0;n<t.length;n++)e[n]=this.encodeBuf[t.charCodeAt(n)];return e},a.prototype.end=function(){},o.prototype.write=function(t){for(var e=this.decodeBuf,n=new r(2*t.length),i=0,a=0,o=0;o<t.length;o++)i=2*t[o],n[a=2*o]=e[i],n[a+1]=e[i+1];return n.toString(\"ucs2\")},o.prototype.end=function(){}},function(t,e,n){\"use strict\";t.exports={10029:\"maccenteuro\",maccenteuro:{type:\"_sbcs\",chars:\"ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ\"},808:\"cp808\",ibm808:\"cp808\",cp808:{type:\"_sbcs\",chars:\"АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ \"},ascii8bit:\"ascii\",usascii:\"ascii\",ansix34:\"ascii\",ansix341968:\"ascii\",ansix341986:\"ascii\",csascii:\"ascii\",cp367:\"ascii\",ibm367:\"ascii\",isoir6:\"ascii\",iso646us:\"ascii\",iso646irv:\"ascii\",us:\"ascii\",latin1:\"iso88591\",latin2:\"iso88592\",latin3:\"iso88593\",latin4:\"iso88594\",latin5:\"iso88599\",latin6:\"iso885910\",latin7:\"iso885913\",latin8:\"iso885914\",latin9:\"iso885915\",latin10:\"iso885916\",csisolatin1:\"iso88591\",csisolatin2:\"iso88592\",csisolatin3:\"iso88593\",csisolatin4:\"iso88594\",csisolatincyrillic:\"iso88595\",csisolatinarabic:\"iso88596\",csisolatingreek:\"iso88597\",csisolatinhebrew:\"iso88598\",csisolatin5:\"iso88599\",csisolatin6:\"iso885910\",l1:\"iso88591\",l2:\"iso88592\",l3:\"iso88593\",l4:\"iso88594\",l5:\"iso88599\",l6:\"iso885910\",l7:\"iso885913\",l8:\"iso885914\",l9:\"iso885915\",l10:\"iso885916\",isoir14:\"iso646jp\",isoir57:\"iso646cn\",isoir100:\"iso88591\",isoir101:\"iso88592\",isoir109:\"iso88593\",isoir110:\"iso88594\",isoir144:\"iso88595\",isoir127:\"iso88596\",isoir126:\"iso88597\",isoir138:\"iso88598\",isoir148:\"iso88599\",isoir157:\"iso885910\",isoir166:\"tis620\",isoir179:\"iso885913\",isoir199:\"iso885914\",isoir203:\"iso885915\",isoir226:\"iso885916\",cp819:\"iso88591\",ibm819:\"iso88591\",cyrillic:\"iso88595\",arabic:\"iso88596\",arabic8:\"iso88596\",ecma114:\"iso88596\",asmo708:\"iso88596\",greek:\"iso88597\",greek8:\"iso88597\",ecma118:\"iso88597\",elot928:\"iso88597\",hebrew:\"iso88598\",hebrew8:\"iso88598\",turkish:\"iso88599\",turkish8:\"iso88599\",thai:\"iso885911\",thai8:\"iso885911\",celtic:\"iso885914\",celtic8:\"iso885914\",isoceltic:\"iso885914\",tis6200:\"tis620\",tis62025291:\"tis620\",tis62025330:\"tis620\",10000:\"macroman\",10006:\"macgreek\",10007:\"maccyrillic\",10079:\"maciceland\",10081:\"macturkish\",cspc8codepage437:\"cp437\",cspc775baltic:\"cp775\",cspc850multilingual:\"cp850\",cspcp852:\"cp852\",cspc862latinhebrew:\"cp862\",cpgr:\"cp869\",msee:\"cp1250\",mscyrl:\"cp1251\",msansi:\"cp1252\",msgreek:\"cp1253\",msturk:\"cp1254\",mshebr:\"cp1255\",msarab:\"cp1256\",winbaltrim:\"cp1257\",cp20866:\"koi8r\",20866:\"koi8r\",ibm878:\"koi8r\",cskoi8r:\"koi8r\",cp21866:\"koi8u\",21866:\"koi8u\",ibm1168:\"koi8u\",strk10482002:\"rk1048\",tcvn5712:\"tcvn\",tcvn57121:\"tcvn\",gb198880:\"iso646cn\",cn:\"iso646cn\",csiso14jisc6220ro:\"iso646jp\",jisc62201969ro:\"iso646jp\",jp:\"iso646jp\",cshproman8:\"hproman8\",r8:\"hproman8\",roman8:\"hproman8\",xroman8:\"hproman8\",ibm1051:\"hproman8\",mac:\"macintosh\",csmacintosh:\"macintosh\"}},function(t,e,n){\"use strict\";t.exports={437:\"cp437\",737:\"cp737\",775:\"cp775\",850:\"cp850\",852:\"cp852\",855:\"cp855\",856:\"cp856\",857:\"cp857\",858:\"cp858\",860:\"cp860\",861:\"cp861\",862:\"cp862\",863:\"cp863\",864:\"cp864\",865:\"cp865\",866:\"cp866\",869:\"cp869\",874:\"windows874\",922:\"cp922\",1046:\"cp1046\",1124:\"cp1124\",1125:\"cp1125\",1129:\"cp1129\",1133:\"cp1133\",1161:\"cp1161\",1162:\"cp1162\",1163:\"cp1163\",1250:\"windows1250\",1251:\"windows1251\",1252:\"windows1252\",1253:\"windows1253\",1254:\"windows1254\",1255:\"windows1255\",1256:\"windows1256\",1257:\"windows1257\",1258:\"windows1258\",28591:\"iso88591\",28592:\"iso88592\",28593:\"iso88593\",28594:\"iso88594\",28595:\"iso88595\",28596:\"iso88596\",28597:\"iso88597\",28598:\"iso88598\",28599:\"iso88599\",28600:\"iso885910\",28601:\"iso885911\",28603:\"iso885913\",28604:\"iso885914\",28605:\"iso885915\",28606:\"iso885916\",windows874:{type:\"_sbcs\",chars:\"€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����\"},win874:\"windows874\",cp874:\"windows874\",windows1250:{type:\"_sbcs\",chars:\"€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙\"},win1250:\"windows1250\",cp1250:\"windows1250\",windows1251:{type:\"_sbcs\",chars:\"ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя\"},win1251:\"windows1251\",cp1251:\"windows1251\",windows1252:{type:\"_sbcs\",chars:\"€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ\"},win1252:\"windows1252\",cp1252:\"windows1252\",windows1253:{type:\"_sbcs\",chars:\"€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�\"},win1253:\"windows1253\",cp1253:\"windows1253\",windows1254:{type:\"_sbcs\",chars:\"€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ\"},win1254:\"windows1254\",cp1254:\"windows1254\",windows1255:{type:\"_sbcs\",chars:\"€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�\"},win1255:\"windows1255\",cp1255:\"windows1255\",windows1256:{type:\"_sbcs\",chars:\"€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے\"},win1256:\"windows1256\",cp1256:\"windows1256\",windows1257:{type:\"_sbcs\",chars:\"€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙\"},win1257:\"windows1257\",cp1257:\"windows1257\",windows1258:{type:\"_sbcs\",chars:\"€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ\"},win1258:\"windows1258\",cp1258:\"windows1258\",iso88591:{type:\"_sbcs\",chars:\" ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ\"},cp28591:\"iso88591\",iso88592:{type:\"_sbcs\",chars:\" Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙\"},cp28592:\"iso88592\",iso88593:{type:\"_sbcs\",chars:\" Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙\"},cp28593:\"iso88593\",iso88594:{type:\"_sbcs\",chars:\" ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙\"},cp28594:\"iso88594\",iso88595:{type:\"_sbcs\",chars:\" ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ\"},cp28595:\"iso88595\",iso88596:{type:\"_sbcs\",chars:\" ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������\"},cp28596:\"iso88596\",iso88597:{type:\"_sbcs\",chars:\" ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�\"},cp28597:\"iso88597\",iso88598:{type:\"_sbcs\",chars:\" �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�\"},cp28598:\"iso88598\",iso88599:{type:\"_sbcs\",chars:\" ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ\"},cp28599:\"iso88599\",iso885910:{type:\"_sbcs\",chars:\" ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ\"},cp28600:\"iso885910\",iso885911:{type:\"_sbcs\",chars:\" กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����\"},cp28601:\"iso885911\",iso885913:{type:\"_sbcs\",chars:\" ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’\"},cp28603:\"iso885913\",iso885914:{type:\"_sbcs\",chars:\" Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ\"},cp28604:\"iso885914\",iso885915:{type:\"_sbcs\",chars:\" ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ\"},cp28605:\"iso885915\",iso885916:{type:\"_sbcs\",chars:\" ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ\"},cp28606:\"iso885916\",cp437:{type:\"_sbcs\",chars:\"ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ \"},ibm437:\"cp437\",csibm437:\"cp437\",cp737:{type:\"_sbcs\",chars:\"ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ \"},ibm737:\"cp737\",csibm737:\"cp737\",cp775:{type:\"_sbcs\",chars:\"ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ \"},ibm775:\"cp775\",csibm775:\"cp775\",cp850:{type:\"_sbcs\",chars:\"ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ \"},ibm850:\"cp850\",csibm850:\"cp850\",cp852:{type:\"_sbcs\",chars:\"ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ \"},ibm852:\"cp852\",csibm852:\"cp852\",cp855:{type:\"_sbcs\",chars:\"ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ \"},ibm855:\"cp855\",csibm855:\"cp855\",cp856:{type:\"_sbcs\",chars:\"אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ \"},ibm856:\"cp856\",csibm856:\"cp856\",cp857:{type:\"_sbcs\",chars:\"ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ \"},ibm857:\"cp857\",csibm857:\"cp857\",cp858:{type:\"_sbcs\",chars:\"ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ \"},ibm858:\"cp858\",csibm858:\"cp858\",cp860:{type:\"_sbcs\",chars:\"ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ \"},ibm860:\"cp860\",csibm860:\"cp860\",cp861:{type:\"_sbcs\",chars:\"ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ \"},ibm861:\"cp861\",csibm861:\"cp861\",cp862:{type:\"_sbcs\",chars:\"אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ \"},ibm862:\"cp862\",csibm862:\"cp862\",cp863:{type:\"_sbcs\",chars:\"ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ \"},ibm863:\"cp863\",csibm863:\"cp863\",cp864:{type:\"_sbcs\",chars:\"\\0\u0001\u0002\u0003\u0004\u0005\u0006\u0007\\b\\t\\n\\v\\f\\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\\\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�\"},ibm864:\"cp864\",csibm864:\"cp864\",cp865:{type:\"_sbcs\",chars:\"ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ \"},ibm865:\"cp865\",csibm865:\"cp865\",cp866:{type:\"_sbcs\",chars:\"АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ \"},ibm866:\"cp866\",csibm866:\"cp866\",cp869:{type:\"_sbcs\",chars:\"������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ \"},ibm869:\"cp869\",csibm869:\"cp869\",cp922:{type:\"_sbcs\",chars:\" ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ\"},ibm922:\"cp922\",csibm922:\"cp922\",cp1046:{type:\"_sbcs\",chars:\"ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�\"},ibm1046:\"cp1046\",csibm1046:\"cp1046\",cp1124:{type:\"_sbcs\",chars:\" ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ\"},ibm1124:\"cp1124\",csibm1124:\"cp1124\",cp1125:{type:\"_sbcs\",chars:\"АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ \"},ibm1125:\"cp1125\",csibm1125:\"cp1125\",cp1129:{type:\"_sbcs\",chars:\" ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ\"},ibm1129:\"cp1129\",csibm1129:\"cp1129\",cp1133:{type:\"_sbcs\",chars:\" ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�\"},ibm1133:\"cp1133\",csibm1133:\"cp1133\",cp1161:{type:\"_sbcs\",chars:\"��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ \"},ibm1161:\"cp1161\",csibm1161:\"cp1161\",cp1162:{type:\"_sbcs\",chars:\"€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����\"},ibm1162:\"cp1162\",csibm1162:\"cp1162\",cp1163:{type:\"_sbcs\",chars:\" ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ\"},ibm1163:\"cp1163\",csibm1163:\"cp1163\",maccroatian:{type:\"_sbcs\",chars:\"ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ\"},maccyrillic:{type:\"_sbcs\",chars:\"АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤\"},macgreek:{type:\"_sbcs\",chars:\"Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�\"},maciceland:{type:\"_sbcs\",chars:\"ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ\"},macroman:{type:\"_sbcs\",chars:\"ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ\"},macromania:{type:\"_sbcs\",chars:\"ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ\"},macthai:{type:\"_sbcs\",chars:\"«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู\\ufeff​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����\"},macturkish:{type:\"_sbcs\",chars:\"ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ\"},macukraine:{type:\"_sbcs\",chars:\"АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤\"},koi8r:{type:\"_sbcs\",chars:\"─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ\"},koi8u:{type:\"_sbcs\",chars:\"─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ\"},koi8ru:{type:\"_sbcs\",chars:\"─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ\"},koi8t:{type:\"_sbcs\",chars:\"қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ\"},armscii8:{type:\"_sbcs\",chars:\" �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�\"},rk1048:{type:\"_sbcs\",chars:\"ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя\"},tcvn:{type:\"_sbcs\",chars:\"\\0ÚỤ\u0003ỪỬỮ\u0007\\b\\t\\n\\v\\f\\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\\\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ\"},georgianacademy:{type:\"_sbcs\",chars:\"‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ\"},georgianps:{type:\"_sbcs\",chars:\"‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ\"},pt154:{type:\"_sbcs\",chars:\"ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя\"},viscii:{type:\"_sbcs\",chars:\"\\0\u0001Ẳ\u0003\u0004ẴẪ\u0007\\b\\t\\n\\v\\f\\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\\\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ\"},iso646cn:{type:\"_sbcs\",chars:\"\\0\u0001\u0002\u0003\u0004\u0005\u0006\u0007\\b\\t\\n\\v\\f\\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\\\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������\"},iso646jp:{type:\"_sbcs\",chars:\"\\0\u0001\u0002\u0003\u0004\u0005\u0006\u0007\\b\\t\\n\\v\\f\\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\\\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������\"},hproman8:{type:\"_sbcs\",chars:\" ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�\"},macintosh:{type:\"_sbcs\",chars:\"ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ\"},ascii:{type:\"_sbcs\",chars:\"��������������������������������������������������������������������������������������������������������������������������������\"},tis620:{type:\"_sbcs\",chars:\"���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����\"}}},function(t,e,n){\"use strict\";var r=n(1).Buffer;e._dbcs=u;for(var i=-1,a=-2,o=-1e3,s=new Array(256),l=0;l<256;l++)s[l]=i;function u(t,e){if(this.encodingName=t.encodingName,!t)throw new Error(\"DBCS codec is called without the data.\");if(!t.table)throw new Error(\"Encoding '\"+this.encodingName+\"' has no data.\");var n=t.table();this.decodeTables=[],this.decodeTables[0]=s.slice(0),this.decodeTableSeq=[];for(var r=0;r<n.length;r++)this._addDecodeChunk(n[r]);this.defaultCharUnicode=e.defaultCharUnicode,this.encodeTable=[],this.encodeTableSeq=[];var l={};if(t.encodeSkipVals)for(r=0;r<t.encodeSkipVals.length;r++){var u=t.encodeSkipVals[r];if(\"number\"==typeof u)l[u]=!0;else for(var c=u.from;c<=u.to;c++)l[c]=!0}if(this._fillEncodeTable(0,0,l),t.encodeAdd)for(var h in t.encodeAdd)Object.prototype.hasOwnProperty.call(t.encodeAdd,h)&&this._setEncodeChar(h.charCodeAt(0),t.encodeAdd[h]);if(this.defCharSB=this.encodeTable[0][e.defaultCharSingleByte.charCodeAt(0)],this.defCharSB===i&&(this.defCharSB=this.encodeTable[0][\"?\"]),this.defCharSB===i&&(this.defCharSB=\"?\".charCodeAt(0)),\"function\"==typeof t.gb18030){this.gb18030=t.gb18030();var f=this.decodeTables.length,d=this.decodeTables[f]=s.slice(0),p=this.decodeTables.length,g=this.decodeTables[p]=s.slice(0);for(r=129;r<=254;r++){var y=o-this.decodeTables[0][r],v=this.decodeTables[y];for(c=48;c<=57;c++)v[c]=o-f}for(r=129;r<=254;r++)d[r]=o-p;for(r=48;r<=57;r++)g[r]=a}}function c(t,e){this.leadSurrogate=-1,this.seqObj=void 0,this.encodeTable=e.encodeTable,this.encodeTableSeq=e.encodeTableSeq,this.defaultCharSingleByte=e.defCharSB,this.gb18030=e.gb18030}function h(t,e){this.nodeIdx=0,this.prevBuf=new r(0),this.decodeTables=e.decodeTables,this.decodeTableSeq=e.decodeTableSeq,this.defaultCharUnicode=e.defaultCharUnicode,this.gb18030=e.gb18030}function f(t,e){if(t[0]>e)return-1;for(var n=0,r=t.length;n<r-1;){var i=n+Math.floor((r-n+1)/2);t[i]<=e?n=i:r=i}return n}u.prototype.encoder=c,u.prototype.decoder=h,u.prototype._getDecodeTrieNode=function(t){for(var e=[];t>0;t>>=8)e.push(255&t);0==e.length&&e.push(0);for(var n=this.decodeTables[0],r=e.length-1;r>0;r--){var a=n[e[r]];if(a==i)n[e[r]]=o-this.decodeTables.length,this.decodeTables.push(n=s.slice(0));else{if(!(a<=o))throw new Error(\"Overwrite byte in \"+this.encodingName+\", addr: \"+t.toString(16));n=this.decodeTables[o-a]}}return n},u.prototype._addDecodeChunk=function(t){var e=parseInt(t[0],16),n=this._getDecodeTrieNode(e);e&=255;for(var r=1;r<t.length;r++){var i=t[r];if(\"string\"==typeof i)for(var a=0;a<i.length;){var o=i.charCodeAt(a++);if(55296<=o&&o<56320){var s=i.charCodeAt(a++);if(!(56320<=s&&s<57344))throw new Error(\"Incorrect surrogate pair in \"+this.encodingName+\" at chunk \"+t[0]);n[e++]=65536+1024*(o-55296)+(s-56320)}else if(4080<o&&o<=4095){for(var l=4095-o+2,u=[],c=0;c<l;c++)u.push(i.charCodeAt(a++));n[e++]=-10-this.decodeTableSeq.length,this.decodeTableSeq.push(u)}else n[e++]=o}else{if(\"number\"!=typeof i)throw new Error(\"Incorrect type '\"+typeof i+\"' given in \"+this.encodingName+\" at chunk \"+t[0]);var h=n[e-1]+1;for(a=0;a<i;a++)n[e++]=h++}}if(e>255)throw new Error(\"Incorrect chunk in \"+this.encodingName+\" at addr \"+t[0]+\": too long\"+e)},u.prototype._getEncodeBucket=function(t){var e=t>>8;return void 0===this.encodeTable[e]&&(this.encodeTable[e]=s.slice(0)),this.encodeTable[e]},u.prototype._setEncodeChar=function(t,e){var n=this._getEncodeBucket(t),r=255&t;n[r]<=-10?this.encodeTableSeq[-10-n[r]][-1]=e:n[r]==i&&(n[r]=e)},u.prototype._setEncodeSequence=function(t,e){var n,r=t[0],a=this._getEncodeBucket(r),o=255&r;a[o]<=-10?n=this.encodeTableSeq[-10-a[o]]:(n={},a[o]!==i&&(n[-1]=a[o]),a[o]=-10-this.encodeTableSeq.length,this.encodeTableSeq.push(n));for(var s=1;s<t.length-1;s++){var l=n[r];\"object\"==typeof l?n=l:(n=n[r]={},void 0!==l&&(n[-1]=l))}n[r=t[t.length-1]]=e},u.prototype._fillEncodeTable=function(t,e,n){for(var r=this.decodeTables[t],i=0;i<256;i++){var a=r[i],s=e+i;n[s]||(a>=0?this._setEncodeChar(a,s):a<=o?this._fillEncodeTable(o-a,s<<8,n):a<=-10&&this._setEncodeSequence(this.decodeTableSeq[-10-a],s))}},c.prototype.write=function(t){for(var e=new r(t.length*(this.gb18030?4:3)),n=this.leadSurrogate,a=this.seqObj,o=-1,s=0,l=0;;){if(-1===o){if(s==t.length)break;var u=t.charCodeAt(s++)}else{u=o;o=-1}if(55296<=u&&u<57344)if(u<56320){if(-1===n){n=u;continue}n=u,u=i}else-1!==n?(u=65536+1024*(n-55296)+(u-56320),n=-1):u=i;else-1!==n&&(o=u,u=i,n=-1);var c=i;if(void 0!==a&&u!=i){var h=a[u];if(\"object\"==typeof h){a=h;continue}\"number\"==typeof h?c=h:null==h&&void 0!==(h=a[-1])&&(c=h,o=u),a=void 0}else if(u>=0){var d=this.encodeTable[u>>8];if(void 0!==d&&(c=d[255&u]),c<=-10){a=this.encodeTableSeq[-10-c];continue}if(c==i&&this.gb18030){var p=f(this.gb18030.uChars,u);if(-1!=p){c=this.gb18030.gbChars[p]+(u-this.gb18030.uChars[p]);e[l++]=129+Math.floor(c/12600),c%=12600,e[l++]=48+Math.floor(c/1260),c%=1260,e[l++]=129+Math.floor(c/10),c%=10,e[l++]=48+c;continue}}}c===i&&(c=this.defaultCharSingleByte),c<256?e[l++]=c:c<65536?(e[l++]=c>>8,e[l++]=255&c):(e[l++]=c>>16,e[l++]=c>>8&255,e[l++]=255&c)}return this.seqObj=a,this.leadSurrogate=n,e.slice(0,l)},c.prototype.end=function(){if(-1!==this.leadSurrogate||void 0!==this.seqObj){var t=new r(10),e=0;if(this.seqObj){var n=this.seqObj[-1];void 0!==n&&(n<256?t[e++]=n:(t[e++]=n>>8,t[e++]=255&n)),this.seqObj=void 0}return-1!==this.leadSurrogate&&(t[e++]=this.defaultCharSingleByte,this.leadSurrogate=-1),t.slice(0,e)}},c.prototype.findIdx=f,h.prototype.write=function(t){var e=new r(2*t.length),n=this.nodeIdx,s=this.prevBuf,l=this.prevBuf.length,u=-this.prevBuf.length;l>0&&(s=r.concat([s,t.slice(0,10)]));for(var c=0,h=0;c<t.length;c++){var d,p=c>=0?t[c]:s[c+l];if((d=this.decodeTables[n][p])>=0);else if(d===i)c=u,d=this.defaultCharUnicode.charCodeAt(0);else if(d===a){var g=u>=0?t.slice(u,c+1):s.slice(u+l,c+1+l),y=12600*(g[0]-129)+1260*(g[1]-48)+10*(g[2]-129)+(g[3]-48),v=f(this.gb18030.gbChars,y);d=this.gb18030.uChars[v]+y-this.gb18030.gbChars[v]}else{if(d<=o){n=o-d;continue}if(!(d<=-10))throw new Error(\"iconv-lite internal error: invalid decoding table value \"+d+\" at \"+n+\"/\"+p);for(var b=this.decodeTableSeq[-10-d],m=0;m<b.length-1;m++)d=b[m],e[h++]=255&d,e[h++]=d>>8;d=b[b.length-1]}if(d>65535){d-=65536;var w=55296+Math.floor(d/1024);e[h++]=255&w,e[h++]=w>>8,d=56320+d%1024}e[h++]=255&d,e[h++]=d>>8,n=0,u=c+1}return this.nodeIdx=n,this.prevBuf=u>=0?t.slice(u):s.slice(u+l),e.slice(0,h).toString(\"ucs2\")},h.prototype.end=function(){for(var t=\"\";this.prevBuf.length>0;){t+=this.defaultCharUnicode;var e=this.prevBuf.slice(1);this.prevBuf=new r(0),this.nodeIdx=0,e.length>0&&(t+=this.write(e))}return this.nodeIdx=0,t}},function(t,e,n){\"use strict\";t.exports={shiftjis:{type:\"_dbcs\",table:function(){return n(180)},encodeAdd:{\"¥\":92,\"‾\":126},encodeSkipVals:[{from:60736,to:63808}]},csshiftjis:\"shiftjis\",mskanji:\"shiftjis\",sjis:\"shiftjis\",windows31j:\"shiftjis\",ms31j:\"shiftjis\",xsjis:\"shiftjis\",windows932:\"shiftjis\",ms932:\"shiftjis\",932:\"shiftjis\",cp932:\"shiftjis\",eucjp:{type:\"_dbcs\",table:function(){return n(181)},encodeAdd:{\"¥\":92,\"‾\":126}},gb2312:\"cp936\",gb231280:\"cp936\",gb23121980:\"cp936\",csgb2312:\"cp936\",csiso58gb231280:\"cp936\",euccn:\"cp936\",windows936:\"cp936\",ms936:\"cp936\",936:\"cp936\",cp936:{type:\"_dbcs\",table:function(){return n(53)}},gbk:{type:\"_dbcs\",table:function(){return n(53).concat(n(91))}},xgbk:\"gbk\",isoir58:\"gbk\",gb18030:{type:\"_dbcs\",table:function(){return n(53).concat(n(91))},gb18030:function(){return n(182)},encodeSkipVals:[128],encodeAdd:{\"€\":41699}},chinese:\"gb18030\",windows949:\"cp949\",ms949:\"cp949\",949:\"cp949\",cp949:{type:\"_dbcs\",table:function(){return n(183)}},cseuckr:\"cp949\",csksc56011987:\"cp949\",euckr:\"cp949\",isoir149:\"cp949\",korean:\"cp949\",ksc56011987:\"cp949\",ksc56011989:\"cp949\",ksc5601:\"cp949\",windows950:\"cp950\",ms950:\"cp950\",950:\"cp950\",cp950:{type:\"_dbcs\",table:function(){return n(92)}},big5:\"big5hkscs\",big5hkscs:{type:\"_dbcs\",table:function(){return n(92).concat(n(184))},encodeSkipVals:[41676]},cnbig5:\"big5hkscs\",csbig5:\"big5hkscs\",xxbig5:\"big5hkscs\"}},function(t,e){t.exports=[[\"0\",\"\\0\",128],[\"a1\",\"｡\",62],[\"8140\",\"　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈\",9,\"＋－±×\"],[\"8180\",\"÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓\"],[\"81b8\",\"∈∋⊆⊇⊂⊃∪∩\"],[\"81c8\",\"∧∨￢⇒⇔∀∃\"],[\"81da\",\"∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬\"],[\"81f0\",\"Å‰♯♭♪†‡¶\"],[\"81fc\",\"◯\"],[\"824f\",\"０\",9],[\"8260\",\"Ａ\",25],[\"8281\",\"ａ\",25],[\"829f\",\"ぁ\",82],[\"8340\",\"ァ\",62],[\"8380\",\"ム\",22],[\"839f\",\"Α\",16,\"Σ\",6],[\"83bf\",\"α\",16,\"σ\",6],[\"8440\",\"А\",5,\"ЁЖ\",25],[\"8470\",\"а\",5,\"ёж\",7],[\"8480\",\"о\",17],[\"849f\",\"─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂\"],[\"8740\",\"①\",19,\"Ⅰ\",9],[\"875f\",\"㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡\"],[\"877e\",\"㍻\"],[\"8780\",\"〝〟№㏍℡㊤\",4,\"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪\"],[\"889f\",\"亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭\"],[\"8940\",\"院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円\"],[\"8980\",\"園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改\"],[\"8a40\",\"魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫\"],[\"8a80\",\"橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄\"],[\"8b40\",\"機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救\"],[\"8b80\",\"朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈\"],[\"8c40\",\"掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨\"],[\"8c80\",\"劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向\"],[\"8d40\",\"后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降\"],[\"8d80\",\"項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷\"],[\"8e40\",\"察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止\"],[\"8e80\",\"死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周\"],[\"8f40\",\"宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳\"],[\"8f80\",\"準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾\"],[\"9040\",\"拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨\"],[\"9080\",\"逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線\"],[\"9140\",\"繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻\"],[\"9180\",\"操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只\"],[\"9240\",\"叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄\"],[\"9280\",\"逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓\"],[\"9340\",\"邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬\"],[\"9380\",\"凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入\"],[\"9440\",\"如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅\"],[\"9480\",\"楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美\"],[\"9540\",\"鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷\"],[\"9580\",\"斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋\"],[\"9640\",\"法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆\"],[\"9680\",\"摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒\"],[\"9740\",\"諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲\"],[\"9780\",\"沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯\"],[\"9840\",\"蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕\"],[\"989f\",\"弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲\"],[\"9940\",\"僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭\"],[\"9980\",\"凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨\"],[\"9a40\",\"咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸\"],[\"9a80\",\"噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩\"],[\"9b40\",\"奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀\"],[\"9b80\",\"它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏\"],[\"9c40\",\"廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠\"],[\"9c80\",\"怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛\"],[\"9d40\",\"戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫\"],[\"9d80\",\"捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼\"],[\"9e40\",\"曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎\"],[\"9e80\",\"梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣\"],[\"9f40\",\"檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯\"],[\"9f80\",\"麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌\"],[\"e040\",\"漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝\"],[\"e080\",\"烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱\"],[\"e140\",\"瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿\"],[\"e180\",\"痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬\"],[\"e240\",\"磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰\"],[\"e280\",\"窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆\"],[\"e340\",\"紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷\"],[\"e380\",\"縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋\"],[\"e440\",\"隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤\"],[\"e480\",\"艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈\"],[\"e540\",\"蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬\"],[\"e580\",\"蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞\"],[\"e640\",\"襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧\"],[\"e680\",\"諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊\"],[\"e740\",\"蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜\"],[\"e780\",\"轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮\"],[\"e840\",\"錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙\"],[\"e880\",\"閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰\"],[\"e940\",\"顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃\"],[\"e980\",\"騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈\"],[\"ea40\",\"鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯\"],[\"ea80\",\"黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙\"],[\"ed40\",\"纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏\"],[\"ed80\",\"塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱\"],[\"ee40\",\"犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙\"],[\"ee80\",\"蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑\"],[\"eeef\",\"ⅰ\",9,\"￢￤＇＂\"],[\"f040\",\"\",62],[\"f080\",\"\",124],[\"f140\",\"\",62],[\"f180\",\"\",124],[\"f240\",\"\",62],[\"f280\",\"\",124],[\"f340\",\"\",62],[\"f380\",\"\",124],[\"f440\",\"\",62],[\"f480\",\"\",124],[\"f540\",\"\",62],[\"f580\",\"\",124],[\"f640\",\"\",62],[\"f680\",\"\",124],[\"f740\",\"\",62],[\"f780\",\"\",124],[\"f840\",\"\",62],[\"f880\",\"\",124],[\"f940\",\"\"],[\"fa40\",\"ⅰ\",9,\"Ⅰ\",9,\"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊\"],[\"fa80\",\"兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯\"],[\"fb40\",\"涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神\"],[\"fb80\",\"祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙\"],[\"fc40\",\"髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑\"]]},function(t,e){t.exports=[[\"0\",\"\\0\",127],[\"8ea1\",\"｡\",62],[\"a1a1\",\"　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈\",9,\"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇\"],[\"a2a1\",\"◆□■△▲▽▼※〒→←↑↓〓\"],[\"a2ba\",\"∈∋⊆⊇⊂⊃∪∩\"],[\"a2ca\",\"∧∨￢⇒⇔∀∃\"],[\"a2dc\",\"∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬\"],[\"a2f2\",\"Å‰♯♭♪†‡¶\"],[\"a2fe\",\"◯\"],[\"a3b0\",\"０\",9],[\"a3c1\",\"Ａ\",25],[\"a3e1\",\"ａ\",25],[\"a4a1\",\"ぁ\",82],[\"a5a1\",\"ァ\",85],[\"a6a1\",\"Α\",16,\"Σ\",6],[\"a6c1\",\"α\",16,\"σ\",6],[\"a7a1\",\"А\",5,\"ЁЖ\",25],[\"a7d1\",\"а\",5,\"ёж\",25],[\"a8a1\",\"─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂\"],[\"ada1\",\"①\",19,\"Ⅰ\",9],[\"adc0\",\"㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡\"],[\"addf\",\"㍻〝〟№㏍℡㊤\",4,\"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪\"],[\"b0a1\",\"亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭\"],[\"b1a1\",\"院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応\"],[\"b2a1\",\"押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改\"],[\"b3a1\",\"魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱\"],[\"b4a1\",\"粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄\"],[\"b5a1\",\"機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京\"],[\"b6a1\",\"供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈\"],[\"b7a1\",\"掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲\"],[\"b8a1\",\"検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向\"],[\"b9a1\",\"后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込\"],[\"baa1\",\"此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷\"],[\"bba1\",\"察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時\"],[\"bca1\",\"次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周\"],[\"bda1\",\"宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償\"],[\"bea1\",\"勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾\"],[\"bfa1\",\"拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾\"],[\"c0a1\",\"澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線\"],[\"c1a1\",\"繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎\"],[\"c2a1\",\"臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只\"],[\"c3a1\",\"叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵\"],[\"c4a1\",\"帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓\"],[\"c5a1\",\"邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到\"],[\"c6a1\",\"董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入\"],[\"c7a1\",\"如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦\"],[\"c8a1\",\"函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美\"],[\"c9a1\",\"鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服\"],[\"caa1\",\"福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋\"],[\"cba1\",\"法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満\"],[\"cca1\",\"漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒\"],[\"cda1\",\"諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃\"],[\"cea1\",\"痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯\"],[\"cfa1\",\"蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕\"],[\"d0a1\",\"弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲\"],[\"d1a1\",\"僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨\"],[\"d2a1\",\"辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨\"],[\"d3a1\",\"咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉\"],[\"d4a1\",\"圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩\"],[\"d5a1\",\"奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓\"],[\"d6a1\",\"屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏\"],[\"d7a1\",\"廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚\"],[\"d8a1\",\"悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛\"],[\"d9a1\",\"戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼\"],[\"daa1\",\"據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼\"],[\"dba1\",\"曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍\"],[\"dca1\",\"棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣\"],[\"dda1\",\"檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾\"],[\"dea1\",\"沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌\"],[\"dfa1\",\"漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼\"],[\"e0a1\",\"燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱\"],[\"e1a1\",\"瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰\"],[\"e2a1\",\"癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬\"],[\"e3a1\",\"磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐\"],[\"e4a1\",\"筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆\"],[\"e5a1\",\"紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺\"],[\"e6a1\",\"罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋\"],[\"e7a1\",\"隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙\"],[\"e8a1\",\"茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈\"],[\"e9a1\",\"蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙\"],[\"eaa1\",\"蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞\"],[\"eba1\",\"襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫\"],[\"eca1\",\"譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊\"],[\"eda1\",\"蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸\"],[\"eea1\",\"遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮\"],[\"efa1\",\"錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞\"],[\"f0a1\",\"陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰\"],[\"f1a1\",\"顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷\"],[\"f2a1\",\"髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈\"],[\"f3a1\",\"鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠\"],[\"f4a1\",\"堯槇遙瑤凜熙\"],[\"f9a1\",\"纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德\"],[\"faa1\",\"忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱\"],[\"fba1\",\"犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚\"],[\"fca1\",\"釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑\"],[\"fcf1\",\"ⅰ\",9,\"￢￤＇＂\"],[\"8fa2af\",\"˘ˇ¸˙˝¯˛˚～΄΅\"],[\"8fa2c2\",\"¡¦¿\"],[\"8fa2eb\",\"ºª©®™¤№\"],[\"8fa6e1\",\"ΆΈΉΊΪ\"],[\"8fa6e7\",\"Ό\"],[\"8fa6e9\",\"ΎΫ\"],[\"8fa6ec\",\"Ώ\"],[\"8fa6f1\",\"άέήίϊΐόςύϋΰώ\"],[\"8fa7c2\",\"Ђ\",10,\"ЎЏ\"],[\"8fa7f2\",\"ђ\",10,\"ўџ\"],[\"8fa9a1\",\"ÆĐ\"],[\"8fa9a4\",\"Ħ\"],[\"8fa9a6\",\"Ĳ\"],[\"8fa9a8\",\"ŁĿ\"],[\"8fa9ab\",\"ŊØŒ\"],[\"8fa9af\",\"ŦÞ\"],[\"8fa9c1\",\"æđðħıĳĸłŀŉŋøœßŧþ\"],[\"8faaa1\",\"ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ\"],[\"8faaba\",\"ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ\"],[\"8faba1\",\"áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ\"],[\"8fabbd\",\"ġĥíìïîǐ\"],[\"8fabc5\",\"īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż\"],[\"8fb0a1\",\"丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄\"],[\"8fb1a1\",\"侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐\"],[\"8fb2a1\",\"傒傓傔傖傛傜傞\",4,\"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂\"],[\"8fb3a1\",\"凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋\"],[\"8fb4a1\",\"匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿\"],[\"8fb5a1\",\"咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒\"],[\"8fb6a1\",\"嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍\",5,\"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤\",4,\"囱囫园\"],[\"8fb7a1\",\"囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭\",4,\"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡\"],[\"8fb8a1\",\"堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭\"],[\"8fb9a1\",\"奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿\"],[\"8fbaa1\",\"嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖\",4,\"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩\"],[\"8fbba1\",\"屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤\"],[\"8fbca1\",\"巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪\",4,\"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧\"],[\"8fbda1\",\"彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐\",4,\"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷\"],[\"8fbea1\",\"悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐\",4,\"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥\"],[\"8fbfa1\",\"懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵\"],[\"8fc0a1\",\"捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿\"],[\"8fc1a1\",\"擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝\"],[\"8fc2a1\",\"昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝\"],[\"8fc3a1\",\"杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮\",4,\"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏\"],[\"8fc4a1\",\"棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲\"],[\"8fc5a1\",\"樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽\"],[\"8fc6a1\",\"歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖\"],[\"8fc7a1\",\"泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞\"],[\"8fc8a1\",\"湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊\"],[\"8fc9a1\",\"濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔\",4,\"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃\",4,\"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠\"],[\"8fcaa1\",\"煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻\"],[\"8fcba1\",\"狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽\"],[\"8fcca1\",\"珿琀琁琄琇琊琑琚琛琤琦琨\",9,\"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆\"],[\"8fcda1\",\"甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹\",5,\"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹\"],[\"8fcea1\",\"瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢\",6,\"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢\"],[\"8fcfa1\",\"睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳\"],[\"8fd0a1\",\"碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞\"],[\"8fd1a1\",\"秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰\"],[\"8fd2a1\",\"笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙\",5],[\"8fd3a1\",\"籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝\"],[\"8fd4a1\",\"綞綦綧綪綳綶綷綹緂\",4,\"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭\"],[\"8fd5a1\",\"罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮\"],[\"8fd6a1\",\"胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆\"],[\"8fd7a1\",\"艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸\"],[\"8fd8a1\",\"荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓\"],[\"8fd9a1\",\"蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏\",4,\"蕖蕙蕜\",6,\"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼\"],[\"8fdaa1\",\"藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠\",4,\"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣\"],[\"8fdba1\",\"蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃\",6,\"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵\"],[\"8fdca1\",\"蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊\",4,\"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺\"],[\"8fdda1\",\"襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔\",4,\"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳\"],[\"8fdea1\",\"誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂\",4,\"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆\"],[\"8fdfa1\",\"貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢\"],[\"8fe0a1\",\"踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁\"],[\"8fe1a1\",\"轃轇轏轑\",4,\"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃\"],[\"8fe2a1\",\"郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿\"],[\"8fe3a1\",\"釂釃釅釓釔釗釙釚釞釤釥釩釪釬\",5,\"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵\",4,\"鉻鉼鉽鉿銈銉銊銍銎銒銗\"],[\"8fe4a1\",\"銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿\",4,\"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶\"],[\"8fe5a1\",\"鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉\",4,\"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹\"],[\"8fe6a1\",\"镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂\"],[\"8fe7a1\",\"霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦\"],[\"8fe8a1\",\"頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱\",4,\"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵\"],[\"8fe9a1\",\"馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿\",4],[\"8feaa1\",\"鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪\",4,\"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸\"],[\"8feba1\",\"鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦\",4,\"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻\"],[\"8feca1\",\"鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵\"],[\"8feda1\",\"黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃\",4,\"齓齕齖齗齘齚齝齞齨齩齭\",4,\"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥\"]]},function(t,e){t.exports={uChars:[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],gbChars:[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189e3]}},function(t,e){t.exports=[[\"0\",\"\\0\",127],[\"8141\",\"갂갃갅갆갋\",4,\"갘갞갟갡갢갣갥\",6,\"갮갲갳갴\"],[\"8161\",\"갵갶갷갺갻갽갾갿걁\",9,\"걌걎\",5,\"걕\"],[\"8181\",\"걖걗걙걚걛걝\",18,\"걲걳걵걶걹걻\",4,\"겂겇겈겍겎겏겑겒겓겕\",6,\"겞겢\",5,\"겫겭겮겱\",6,\"겺겾겿곀곂곃곅곆곇곉곊곋곍\",7,\"곖곘\",7,\"곢곣곥곦곩곫곭곮곲곴곷\",4,\"곾곿괁괂괃괅괇\",4,\"괎괐괒괓\"],[\"8241\",\"괔괕괖괗괙괚괛괝괞괟괡\",7,\"괪괫괮\",5],[\"8261\",\"괶괷괹괺괻괽\",6,\"굆굈굊\",5,\"굑굒굓굕굖굗\"],[\"8281\",\"굙\",7,\"굢굤\",7,\"굮굯굱굲굷굸굹굺굾궀궃\",4,\"궊궋궍궎궏궑\",10,\"궞\",5,\"궥\",17,\"궸\",7,\"귂귃귅귆귇귉\",6,\"귒귔\",7,\"귝귞귟귡귢귣귥\",18],[\"8341\",\"귺귻귽귾긂\",5,\"긊긌긎\",5,\"긕\",7],[\"8361\",\"긝\",18,\"긲긳긵긶긹긻긼\"],[\"8381\",\"긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗\",4,\"깞깢깣깤깦깧깪깫깭깮깯깱\",6,\"깺깾\",5,\"꺆\",5,\"꺍\",46,\"꺿껁껂껃껅\",6,\"껎껒\",5,\"껚껛껝\",8],[\"8441\",\"껦껧껩껪껬껮\",5,\"껵껶껷껹껺껻껽\",8],[\"8461\",\"꼆꼉꼊꼋꼌꼎꼏꼑\",18],[\"8481\",\"꼤\",7,\"꼮꼯꼱꼳꼵\",6,\"꼾꽀꽄꽅꽆꽇꽊\",5,\"꽑\",10,\"꽞\",5,\"꽦\",18,\"꽺\",5,\"꾁꾂꾃꾅꾆꾇꾉\",6,\"꾒꾓꾔꾖\",5,\"꾝\",26,\"꾺꾻꾽꾾\"],[\"8541\",\"꾿꿁\",5,\"꿊꿌꿏\",4,\"꿕\",6,\"꿝\",4],[\"8561\",\"꿢\",5,\"꿪\",5,\"꿲꿳꿵꿶꿷꿹\",6,\"뀂뀃\"],[\"8581\",\"뀅\",6,\"뀍뀎뀏뀑뀒뀓뀕\",6,\"뀞\",9,\"뀩\",26,\"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞\",29,\"끾끿낁낂낃낅\",6,\"낎낐낒\",5,\"낛낝낞낣낤\"],[\"8641\",\"낥낦낧낪낰낲낶낷낹낺낻낽\",6,\"냆냊\",5,\"냒\"],[\"8661\",\"냓냕냖냗냙\",6,\"냡냢냣냤냦\",10],[\"8681\",\"냱\",22,\"넊넍넎넏넑넔넕넖넗넚넞\",4,\"넦넧넩넪넫넭\",6,\"넶넺\",5,\"녂녃녅녆녇녉\",6,\"녒녓녖녗녙녚녛녝녞녟녡\",22,\"녺녻녽녾녿놁놃\",4,\"놊놌놎놏놐놑놕놖놗놙놚놛놝\"],[\"8741\",\"놞\",9,\"놩\",15],[\"8761\",\"놹\",18,\"뇍뇎뇏뇑뇒뇓뇕\"],[\"8781\",\"뇖\",5,\"뇞뇠\",7,\"뇪뇫뇭뇮뇯뇱\",7,\"뇺뇼뇾\",5,\"눆눇눉눊눍\",6,\"눖눘눚\",5,\"눡\",18,\"눵\",6,\"눽\",26,\"뉙뉚뉛뉝뉞뉟뉡\",6,\"뉪\",4],[\"8841\",\"뉯\",4,\"뉶\",5,\"뉽\",6,\"늆늇늈늊\",4],[\"8861\",\"늏늒늓늕늖늗늛\",4,\"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷\"],[\"8881\",\"늸\",15,\"닊닋닍닎닏닑닓\",4,\"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉\",6,\"댒댖\",5,\"댝\",54,\"덗덙덚덝덠덡덢덣\"],[\"8941\",\"덦덨덪덬덭덯덲덳덵덶덷덹\",6,\"뎂뎆\",5,\"뎍\"],[\"8961\",\"뎎뎏뎑뎒뎓뎕\",10,\"뎢\",5,\"뎩뎪뎫뎭\"],[\"8981\",\"뎮\",21,\"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩\",18,\"돽\",18,\"됑\",6,\"됙됚됛됝됞됟됡\",6,\"됪됬\",7,\"됵\",15],[\"8a41\",\"둅\",10,\"둒둓둕둖둗둙\",6,\"둢둤둦\"],[\"8a61\",\"둧\",4,\"둭\",18,\"뒁뒂\"],[\"8a81\",\"뒃\",4,\"뒉\",19,\"뒞\",5,\"뒥뒦뒧뒩뒪뒫뒭\",7,\"뒶뒸뒺\",5,\"듁듂듃듅듆듇듉\",6,\"듑듒듓듔듖\",5,\"듞듟듡듢듥듧\",4,\"듮듰듲\",5,\"듹\",26,\"딖딗딙딚딝\"],[\"8b41\",\"딞\",5,\"딦딫\",4,\"딲딳딵딶딷딹\",6,\"땂땆\"],[\"8b61\",\"땇땈땉땊땎땏땑땒땓땕\",6,\"땞땢\",8],[\"8b81\",\"땫\",52,\"떢떣떥떦떧떩떬떭떮떯떲떶\",4,\"떾떿뗁뗂뗃뗅\",6,\"뗎뗒\",5,\"뗙\",18,\"뗭\",18],[\"8c41\",\"똀\",15,\"똒똓똕똖똗똙\",4],[\"8c61\",\"똞\",6,\"똦\",5,\"똭\",6,\"똵\",5],[\"8c81\",\"똻\",12,\"뙉\",26,\"뙥뙦뙧뙩\",50,\"뚞뚟뚡뚢뚣뚥\",5,\"뚭뚮뚯뚰뚲\",16],[\"8d41\",\"뛃\",16,\"뛕\",8],[\"8d61\",\"뛞\",17,\"뛱뛲뛳뛵뛶뛷뛹뛺\"],[\"8d81\",\"뛻\",4,\"뜂뜃뜄뜆\",33,\"뜪뜫뜭뜮뜱\",6,\"뜺뜼\",7,\"띅띆띇띉띊띋띍\",6,\"띖\",9,\"띡띢띣띥띦띧띩\",6,\"띲띴띶\",5,\"띾띿랁랂랃랅\",6,\"랎랓랔랕랚랛랝랞\"],[\"8e41\",\"랟랡\",6,\"랪랮\",5,\"랶랷랹\",8],[\"8e61\",\"럂\",4,\"럈럊\",19],[\"8e81\",\"럞\",13,\"럮럯럱럲럳럵\",6,\"럾렂\",4,\"렊렋렍렎렏렑\",6,\"렚렜렞\",5,\"렦렧렩렪렫렭\",6,\"렶렺\",5,\"롁롂롃롅\",11,\"롒롔\",7,\"롞롟롡롢롣롥\",6,\"롮롰롲\",5,\"롹롺롻롽\",7],[\"8f41\",\"뢅\",7,\"뢎\",17],[\"8f61\",\"뢠\",7,\"뢩\",6,\"뢱뢲뢳뢵뢶뢷뢹\",4],[\"8f81\",\"뢾뢿룂룄룆\",5,\"룍룎룏룑룒룓룕\",7,\"룞룠룢\",5,\"룪룫룭룮룯룱\",6,\"룺룼룾\",5,\"뤅\",18,\"뤙\",6,\"뤡\",26,\"뤾뤿륁륂륃륅\",6,\"륍륎륐륒\",5],[\"9041\",\"륚륛륝륞륟륡\",6,\"륪륬륮\",5,\"륶륷륹륺륻륽\"],[\"9061\",\"륾\",5,\"릆릈릋릌릏\",15],[\"9081\",\"릟\",12,\"릮릯릱릲릳릵\",6,\"릾맀맂\",5,\"맊맋맍맓\",4,\"맚맜맟맠맢맦맧맩맪맫맭\",6,\"맶맻\",4,\"먂\",5,\"먉\",11,\"먖\",33,\"먺먻먽먾먿멁멃멄멅멆\"],[\"9141\",\"멇멊멌멏멐멑멒멖멗멙멚멛멝\",6,\"멦멪\",5],[\"9161\",\"멲멳멵멶멷멹\",9,\"몆몈몉몊몋몍\",5],[\"9181\",\"몓\",20,\"몪몭몮몯몱몳\",4,\"몺몼몾\",5,\"뫅뫆뫇뫉\",14,\"뫚\",33,\"뫽뫾뫿묁묂묃묅\",7,\"묎묐묒\",5,\"묙묚묛묝묞묟묡\",6],[\"9241\",\"묨묪묬\",7,\"묷묹묺묿\",4,\"뭆뭈뭊뭋뭌뭎뭑뭒\"],[\"9261\",\"뭓뭕뭖뭗뭙\",7,\"뭢뭤\",7,\"뭭\",4],[\"9281\",\"뭲\",21,\"뮉뮊뮋뮍뮎뮏뮑\",18,\"뮥뮦뮧뮩뮪뮫뮭\",6,\"뮵뮶뮸\",7,\"믁믂믃믅믆믇믉\",6,\"믑믒믔\",35,\"믺믻믽믾밁\"],[\"9341\",\"밃\",4,\"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵\"],[\"9361\",\"밶밷밹\",6,\"뱂뱆뱇뱈뱊뱋뱎뱏뱑\",8],[\"9381\",\"뱚뱛뱜뱞\",37,\"벆벇벉벊벍벏\",4,\"벖벘벛\",4,\"벢벣벥벦벩\",6,\"벲벶\",5,\"벾벿볁볂볃볅\",7,\"볎볒볓볔볖볗볙볚볛볝\",22,\"볷볹볺볻볽\"],[\"9441\",\"볾\",5,\"봆봈봊\",5,\"봑봒봓봕\",8],[\"9461\",\"봞\",5,\"봥\",6,\"봭\",12],[\"9481\",\"봺\",5,\"뵁\",6,\"뵊뵋뵍뵎뵏뵑\",6,\"뵚\",9,\"뵥뵦뵧뵩\",22,\"붂붃붅붆붋\",4,\"붒붔붖붗붘붛붝\",6,\"붥\",10,\"붱\",6,\"붹\",24],[\"9541\",\"뷒뷓뷖뷗뷙뷚뷛뷝\",11,\"뷪\",5,\"뷱\"],[\"9561\",\"뷲뷳뷵뷶뷷뷹\",6,\"븁븂븄븆\",5,\"븎븏븑븒븓\"],[\"9581\",\"븕\",6,\"븞븠\",35,\"빆빇빉빊빋빍빏\",4,\"빖빘빜빝빞빟빢빣빥빦빧빩빫\",4,\"빲빶\",4,\"빾빿뺁뺂뺃뺅\",6,\"뺎뺒\",5,\"뺚\",13,\"뺩\",14],[\"9641\",\"뺸\",23,\"뻒뻓\"],[\"9661\",\"뻕뻖뻙\",6,\"뻡뻢뻦\",5,\"뻭\",8],[\"9681\",\"뻶\",10,\"뼂\",5,\"뼊\",13,\"뼚뼞\",33,\"뽂뽃뽅뽆뽇뽉\",6,\"뽒뽓뽔뽖\",44],[\"9741\",\"뾃\",16,\"뾕\",8],[\"9761\",\"뾞\",17,\"뾱\",7],[\"9781\",\"뾹\",11,\"뿆\",5,\"뿎뿏뿑뿒뿓뿕\",6,\"뿝뿞뿠뿢\",89,\"쀽쀾쀿\"],[\"9841\",\"쁀\",16,\"쁒\",5,\"쁙쁚쁛\"],[\"9861\",\"쁝쁞쁟쁡\",6,\"쁪\",15],[\"9881\",\"쁺\",21,\"삒삓삕삖삗삙\",6,\"삢삤삦\",5,\"삮삱삲삷\",4,\"삾샂샃샄샆샇샊샋샍샎샏샑\",6,\"샚샞\",5,\"샦샧샩샪샫샭\",6,\"샶샸샺\",5,\"섁섂섃섅섆섇섉\",6,\"섑섒섓섔섖\",5,\"섡섢섥섨섩섪섫섮\"],[\"9941\",\"섲섳섴섵섷섺섻섽섾섿셁\",6,\"셊셎\",5,\"셖셗\"],[\"9961\",\"셙셚셛셝\",6,\"셦셪\",5,\"셱셲셳셵셶셷셹셺셻\"],[\"9981\",\"셼\",8,\"솆\",5,\"솏솑솒솓솕솗\",4,\"솞솠솢솣솤솦솧솪솫솭솮솯솱\",11,\"솾\",5,\"쇅쇆쇇쇉쇊쇋쇍\",6,\"쇕쇖쇙\",6,\"쇡쇢쇣쇥쇦쇧쇩\",6,\"쇲쇴\",7,\"쇾쇿숁숂숃숅\",6,\"숎숐숒\",5,\"숚숛숝숞숡숢숣\"],[\"9a41\",\"숤숥숦숧숪숬숮숰숳숵\",16],[\"9a61\",\"쉆쉇쉉\",6,\"쉒쉓쉕쉖쉗쉙\",6,\"쉡쉢쉣쉤쉦\"],[\"9a81\",\"쉧\",4,\"쉮쉯쉱쉲쉳쉵\",6,\"쉾슀슂\",5,\"슊\",5,\"슑\",6,\"슙슚슜슞\",5,\"슦슧슩슪슫슮\",5,\"슶슸슺\",33,\"싞싟싡싢싥\",5,\"싮싰싲싳싴싵싷싺싽싾싿쌁\",6,\"쌊쌋쌎쌏\"],[\"9b41\",\"쌐쌑쌒쌖쌗쌙쌚쌛쌝\",6,\"쌦쌧쌪\",8],[\"9b61\",\"쌳\",17,\"썆\",7],[\"9b81\",\"썎\",25,\"썪썫썭썮썯썱썳\",4,\"썺썻썾\",5,\"쎅쎆쎇쎉쎊쎋쎍\",50,\"쏁\",22,\"쏚\"],[\"9c41\",\"쏛쏝쏞쏡쏣\",4,\"쏪쏫쏬쏮\",5,\"쏶쏷쏹\",5],[\"9c61\",\"쏿\",8,\"쐉\",6,\"쐑\",9],[\"9c81\",\"쐛\",8,\"쐥\",6,\"쐭쐮쐯쐱쐲쐳쐵\",6,\"쐾\",9,\"쑉\",26,\"쑦쑧쑩쑪쑫쑭\",6,\"쑶쑷쑸쑺\",5,\"쒁\",18,\"쒕\",6,\"쒝\",12],[\"9d41\",\"쒪\",13,\"쒹쒺쒻쒽\",8],[\"9d61\",\"쓆\",25],[\"9d81\",\"쓠\",8,\"쓪\",5,\"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂\",9,\"씍씎씏씑씒씓씕\",6,\"씝\",10,\"씪씫씭씮씯씱\",6,\"씺씼씾\",5,\"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩\",6,\"앲앶\",5,\"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔\"],[\"9e41\",\"얖얙얚얛얝얞얟얡\",7,\"얪\",9,\"얶\"],[\"9e61\",\"얷얺얿\",4,\"엋엍엏엒엓엕엖엗엙\",6,\"엢엤엦엧\"],[\"9e81\",\"엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑\",6,\"옚옝\",6,\"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉\",6,\"왒왖\",5,\"왞왟왡\",10,\"왭왮왰왲\",5,\"왺왻왽왾왿욁\",6,\"욊욌욎\",5,\"욖욗욙욚욛욝\",6,\"욦\"],[\"9f41\",\"욨욪\",5,\"욲욳욵욶욷욻\",4,\"웂웄웆\",5,\"웎\"],[\"9f61\",\"웏웑웒웓웕\",6,\"웞웟웢\",5,\"웪웫웭웮웯웱웲\"],[\"9f81\",\"웳\",4,\"웺웻웼웾\",5,\"윆윇윉윊윋윍\",6,\"윖윘윚\",5,\"윢윣윥윦윧윩\",6,\"윲윴윶윸윹윺윻윾윿읁읂읃읅\",4,\"읋읎읐읙읚읛읝읞읟읡\",6,\"읩읪읬\",7,\"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛\",4,\"잢잧\",4,\"잮잯잱잲잳잵잶잷\"],[\"a041\",\"잸잹잺잻잾쟂\",5,\"쟊쟋쟍쟏쟑\",6,\"쟙쟚쟛쟜\"],[\"a061\",\"쟞\",5,\"쟥쟦쟧쟩쟪쟫쟭\",13],[\"a081\",\"쟻\",4,\"젂젃젅젆젇젉젋\",4,\"젒젔젗\",4,\"젞젟젡젢젣젥\",6,\"젮젰젲\",5,\"젹젺젻젽젾젿졁\",6,\"졊졋졎\",5,\"졕\",26,\"졲졳졵졶졷졹졻\",4,\"좂좄좈좉좊좎\",5,\"좕\",7,\"좞좠좢좣좤\"],[\"a141\",\"좥좦좧좩\",18,\"좾좿죀죁\"],[\"a161\",\"죂죃죅죆죇죉죊죋죍\",6,\"죖죘죚\",5,\"죢죣죥\"],[\"a181\",\"죦\",14,\"죶\",5,\"죾죿줁줂줃줇\",4,\"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈\",9,\"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢\"],[\"a241\",\"줐줒\",5,\"줙\",18],[\"a261\",\"줭\",6,\"줵\",18],[\"a281\",\"쥈\",7,\"쥒쥓쥕쥖쥗쥙\",6,\"쥢쥤\",7,\"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®\"],[\"a341\",\"쥱쥲쥳쥵\",6,\"쥽\",10,\"즊즋즍즎즏\"],[\"a361\",\"즑\",6,\"즚즜즞\",16],[\"a381\",\"즯\",16,\"짂짃짅짆짉짋\",4,\"짒짔짗짘짛！\",58,\"￦］\",32,\"￣\"],[\"a441\",\"짞짟짡짣짥짦짨짩짪짫짮짲\",5,\"짺짻짽짾짿쨁쨂쨃쨄\"],[\"a461\",\"쨅쨆쨇쨊쨎\",5,\"쨕쨖쨗쨙\",12],[\"a481\",\"쨦쨧쨨쨪\",28,\"ㄱ\",93],[\"a541\",\"쩇\",4,\"쩎쩏쩑쩒쩓쩕\",6,\"쩞쩢\",5,\"쩩쩪\"],[\"a561\",\"쩫\",17,\"쩾\",5,\"쪅쪆\"],[\"a581\",\"쪇\",16,\"쪙\",14,\"ⅰ\",9],[\"a5b0\",\"Ⅰ\",9],[\"a5c1\",\"Α\",16,\"Σ\",6],[\"a5e1\",\"α\",16,\"σ\",6],[\"a641\",\"쪨\",19,\"쪾쪿쫁쫂쫃쫅\"],[\"a661\",\"쫆\",5,\"쫎쫐쫒쫔쫕쫖쫗쫚\",5,\"쫡\",6],[\"a681\",\"쫨쫩쫪쫫쫭\",6,\"쫵\",18,\"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃\",7],[\"a741\",\"쬋\",4,\"쬑쬒쬓쬕쬖쬗쬙\",6,\"쬢\",7],[\"a761\",\"쬪\",22,\"쭂쭃쭄\"],[\"a781\",\"쭅쭆쭇쭊쭋쭍쭎쭏쭑\",6,\"쭚쭛쭜쭞\",5,\"쭥\",7,\"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙\",9,\"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰\",9,\"㎀\",4,\"㎺\",5,\"㎐\",4,\"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆\"],[\"a841\",\"쭭\",10,\"쭺\",14],[\"a861\",\"쮉\",18,\"쮝\",6],[\"a881\",\"쮤\",19,\"쮹\",11,\"ÆÐªĦ\"],[\"a8a6\",\"Ĳ\"],[\"a8a8\",\"ĿŁØŒºÞŦŊ\"],[\"a8b1\",\"㉠\",27,\"ⓐ\",25,\"①\",14,\"½⅓⅔¼¾⅛⅜⅝⅞\"],[\"a941\",\"쯅\",14,\"쯕\",10],[\"a961\",\"쯠쯡쯢쯣쯥쯦쯨쯪\",18],[\"a981\",\"쯽\",14,\"찎찏찑찒찓찕\",6,\"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀\",27,\"⒜\",25,\"⑴\",14,\"¹²³⁴ⁿ₁₂₃₄\"],[\"aa41\",\"찥찦찪찫찭찯찱\",6,\"찺찿\",4,\"챆챇챉챊챋챍챎\"],[\"aa61\",\"챏\",4,\"챖챚\",5,\"챡챢챣챥챧챩\",6,\"챱챲\"],[\"aa81\",\"챳챴챶\",29,\"ぁ\",82],[\"ab41\",\"첔첕첖첗첚첛첝첞첟첡\",6,\"첪첮\",5,\"첶첷첹\"],[\"ab61\",\"첺첻첽\",6,\"쳆쳈쳊\",5,\"쳑쳒쳓쳕\",5],[\"ab81\",\"쳛\",8,\"쳥\",6,\"쳭쳮쳯쳱\",12,\"ァ\",85],[\"ac41\",\"쳾쳿촀촂\",5,\"촊촋촍촎촏촑\",6,\"촚촜촞촟촠\"],[\"ac61\",\"촡촢촣촥촦촧촩촪촫촭\",11,\"촺\",4],[\"ac81\",\"촿\",28,\"쵝쵞쵟А\",5,\"ЁЖ\",25],[\"acd1\",\"а\",5,\"ёж\",25],[\"ad41\",\"쵡쵢쵣쵥\",6,\"쵮쵰쵲\",5,\"쵹\",7],[\"ad61\",\"춁\",6,\"춉\",10,\"춖춗춙춚춛춝춞춟\"],[\"ad81\",\"춠춡춢춣춦춨춪\",5,\"춱\",18,\"췅\"],[\"ae41\",\"췆\",5,\"췍췎췏췑\",16],[\"ae61\",\"췢\",5,\"췩췪췫췭췮췯췱\",6,\"췺췼췾\",4],[\"ae81\",\"츃츅츆츇츉츊츋츍\",6,\"츕츖츗츘츚\",5,\"츢츣츥츦츧츩츪츫\"],[\"af41\",\"츬츭츮츯츲츴츶\",19],[\"af61\",\"칊\",13,\"칚칛칝칞칢\",5,\"칪칬\"],[\"af81\",\"칮\",5,\"칶칷칹칺칻칽\",6,\"캆캈캊\",5,\"캒캓캕캖캗캙\"],[\"b041\",\"캚\",5,\"캢캦\",5,\"캮\",12],[\"b061\",\"캻\",5,\"컂\",19],[\"b081\",\"컖\",13,\"컦컧컩컪컭\",6,\"컶컺\",5,\"가각간갇갈갉갊감\",7,\"같\",4,\"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆\"],[\"b141\",\"켂켃켅켆켇켉\",6,\"켒켔켖\",5,\"켝켞켟켡켢켣\"],[\"b161\",\"켥\",6,\"켮켲\",5,\"켹\",11],[\"b181\",\"콅\",14,\"콖콗콙콚콛콝\",6,\"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸\"],[\"b241\",\"콭콮콯콲콳콵콶콷콹\",6,\"쾁쾂쾃쾄쾆\",5,\"쾍\"],[\"b261\",\"쾎\",18,\"쾢\",5,\"쾩\"],[\"b281\",\"쾪\",5,\"쾱\",18,\"쿅\",6,\"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙\"],[\"b341\",\"쿌\",19,\"쿢쿣쿥쿦쿧쿩\"],[\"b361\",\"쿪\",5,\"쿲쿴쿶\",5,\"쿽쿾쿿퀁퀂퀃퀅\",5],[\"b381\",\"퀋\",5,\"퀒\",5,\"퀙\",19,\"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫\",4,\"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝\"],[\"b441\",\"퀮\",5,\"퀶퀷퀹퀺퀻퀽\",6,\"큆큈큊\",5],[\"b461\",\"큑큒큓큕큖큗큙\",6,\"큡\",10,\"큮큯\"],[\"b481\",\"큱큲큳큵\",6,\"큾큿킀킂\",18,\"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫\",4,\"닳담답닷\",4,\"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥\"],[\"b541\",\"킕\",14,\"킦킧킩킪킫킭\",5],[\"b561\",\"킳킶킸킺\",5,\"탂탃탅탆탇탊\",5,\"탒탖\",4],[\"b581\",\"탛탞탟탡탢탣탥\",6,\"탮탲\",5,\"탹\",11,\"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸\"],[\"b641\",\"턅\",7,\"턎\",17],[\"b661\",\"턠\",15,\"턲턳턵턶턷턹턻턼턽턾\"],[\"b681\",\"턿텂텆\",5,\"텎텏텑텒텓텕\",6,\"텞텠텢\",5,\"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗\"],[\"b741\",\"텮\",13,\"텽\",6,\"톅톆톇톉톊\"],[\"b761\",\"톋\",20,\"톢톣톥톦톧\"],[\"b781\",\"톩\",6,\"톲톴톶톷톸톹톻톽톾톿퇁\",14,\"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩\"],[\"b841\",\"퇐\",7,\"퇙\",17],[\"b861\",\"퇫\",8,\"퇵퇶퇷퇹\",13],[\"b881\",\"툈툊\",5,\"툑\",24,\"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많\",4,\"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼\"],[\"b941\",\"툪툫툮툯툱툲툳툵\",6,\"툾퉀퉂\",5,\"퉉퉊퉋퉌\"],[\"b961\",\"퉍\",14,\"퉝\",6,\"퉥퉦퉧퉨\"],[\"b981\",\"퉩\",22,\"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바\",4,\"받\",4,\"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗\"],[\"ba41\",\"튍튎튏튒튓튔튖\",5,\"튝튞튟튡튢튣튥\",6,\"튭\"],[\"ba61\",\"튮튯튰튲\",5,\"튺튻튽튾틁틃\",4,\"틊틌\",5],[\"ba81\",\"틒틓틕틖틗틙틚틛틝\",6,\"틦\",9,\"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤\"],[\"bb41\",\"틻\",4,\"팂팄팆\",5,\"팏팑팒팓팕팗\",4,\"팞팢팣\"],[\"bb61\",\"팤팦팧팪팫팭팮팯팱\",6,\"팺팾\",5,\"퍆퍇퍈퍉\"],[\"bb81\",\"퍊\",31,\"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤\"],[\"bc41\",\"퍪\",17,\"퍾퍿펁펂펃펅펆펇\"],[\"bc61\",\"펈펉펊펋펎펒\",5,\"펚펛펝펞펟펡\",6,\"펪펬펮\"],[\"bc81\",\"펯\",4,\"펵펶펷펹펺펻펽\",6,\"폆폇폊\",5,\"폑\",5,\"샥샨샬샴샵샷샹섀섄섈섐섕서\",4,\"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭\"],[\"bd41\",\"폗폙\",7,\"폢폤\",7,\"폮폯폱폲폳폵폶폷\"],[\"bd61\",\"폸폹폺폻폾퐀퐂\",5,\"퐉\",13],[\"bd81\",\"퐗\",5,\"퐞\",25,\"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰\"],[\"be41\",\"퐸\",7,\"푁푂푃푅\",14],[\"be61\",\"푔\",7,\"푝푞푟푡푢푣푥\",7,\"푮푰푱푲\"],[\"be81\",\"푳\",4,\"푺푻푽푾풁풃\",4,\"풊풌풎\",5,\"풕\",8,\"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄\",6,\"엌엎\"],[\"bf41\",\"풞\",10,\"풪\",14],[\"bf61\",\"풹\",18,\"퓍퓎퓏퓑퓒퓓퓕\"],[\"bf81\",\"퓖\",5,\"퓝퓞퓠\",7,\"퓩퓪퓫퓭퓮퓯퓱\",6,\"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염\",5,\"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨\"],[\"c041\",\"퓾\",5,\"픅픆픇픉픊픋픍\",6,\"픖픘\",5],[\"c061\",\"픞\",25],[\"c081\",\"픸픹픺픻픾픿핁핂핃핅\",6,\"핎핐핒\",5,\"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응\",7,\"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊\"],[\"c141\",\"핤핦핧핪핬핮\",5,\"핶핷핹핺핻핽\",6,\"햆햊햋\"],[\"c161\",\"햌햍햎햏햑\",19,\"햦햧\"],[\"c181\",\"햨\",31,\"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓\"],[\"c241\",\"헊헋헍헎헏헑헓\",4,\"헚헜헞\",5,\"헦헧헩헪헫헭헮\"],[\"c261\",\"헯\",4,\"헶헸헺\",5,\"혂혃혅혆혇혉\",6,\"혒\"],[\"c281\",\"혖\",5,\"혝혞혟혡혢혣혥\",7,\"혮\",9,\"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻\"],[\"c341\",\"혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝\",4],[\"c361\",\"홢\",4,\"홨홪\",5,\"홲홳홵\",11],[\"c381\",\"횁횂횄횆\",5,\"횎횏횑횒횓횕\",7,\"횞횠횢\",5,\"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층\"],[\"c441\",\"횫횭횮횯횱\",7,\"횺횼\",7,\"훆훇훉훊훋\"],[\"c461\",\"훍훎훏훐훒훓훕훖훘훚\",5,\"훡훢훣훥훦훧훩\",4],[\"c481\",\"훮훯훱훲훳훴훶\",5,\"훾훿휁휂휃휅\",11,\"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼\"],[\"c541\",\"휕휖휗휚휛휝휞휟휡\",6,\"휪휬휮\",5,\"휶휷휹\"],[\"c561\",\"휺휻휽\",6,\"흅흆흈흊\",5,\"흒흓흕흚\",4],[\"c581\",\"흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵\",6,\"흾흿힀힂\",5,\"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜\"],[\"c641\",\"힍힎힏힑\",6,\"힚힜힞\",5],[\"c6a1\",\"퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁\"],[\"c7a1\",\"퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠\"],[\"c8a1\",\"혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝\"],[\"caa1\",\"伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕\"],[\"cba1\",\"匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢\"],[\"cca1\",\"瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械\"],[\"cda1\",\"棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜\"],[\"cea1\",\"科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾\"],[\"cfa1\",\"區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴\"],[\"d0a1\",\"鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣\"],[\"d1a1\",\"朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩\",5,\"那樂\",4,\"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉\"],[\"d2a1\",\"納臘蠟衲囊娘廊\",4,\"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧\",5,\"駑魯\",10,\"濃籠聾膿農惱牢磊腦賂雷尿壘\",7,\"嫩訥杻紐勒\",5,\"能菱陵尼泥匿溺多茶\"],[\"d3a1\",\"丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃\"],[\"d4a1\",\"棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅\"],[\"d5a1\",\"蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣\"],[\"d6a1\",\"煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼\"],[\"d7a1\",\"遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬\"],[\"d8a1\",\"立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅\"],[\"d9a1\",\"蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文\"],[\"daa1\",\"汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑\"],[\"dba1\",\"發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖\"],[\"dca1\",\"碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦\"],[\"dda1\",\"孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥\"],[\"dea1\",\"脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索\"],[\"dfa1\",\"傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署\"],[\"e0a1\",\"胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬\"],[\"e1a1\",\"聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁\"],[\"e2a1\",\"戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧\"],[\"e3a1\",\"嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁\"],[\"e4a1\",\"沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額\"],[\"e5a1\",\"櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬\"],[\"e6a1\",\"旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒\"],[\"e7a1\",\"簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳\"],[\"e8a1\",\"烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療\"],[\"e9a1\",\"窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓\"],[\"eaa1\",\"運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜\"],[\"eba1\",\"濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼\"],[\"eca1\",\"議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄\"],[\"eda1\",\"立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長\"],[\"eea1\",\"障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱\"],[\"efa1\",\"煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖\"],[\"f0a1\",\"靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫\"],[\"f1a1\",\"踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只\"],[\"f2a1\",\"咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯\"],[\"f3a1\",\"鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策\"],[\"f4a1\",\"責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢\"],[\"f5a1\",\"椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃\"],[\"f6a1\",\"贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託\"],[\"f7a1\",\"鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑\"],[\"f8a1\",\"阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃\"],[\"f9a1\",\"品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航\"],[\"faa1\",\"行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型\"],[\"fba1\",\"形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵\"],[\"fca1\",\"禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆\"],[\"fda1\",\"爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰\"]]},function(t,e){t.exports=[[\"8740\",\"䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻\"],[\"8767\",\"綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬\"],[\"87a1\",\"𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋\"],[\"8840\",\"㇀\",4,\"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ\"],[\"88a1\",\"ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛\"],[\"8940\",\"𪎩𡅅\"],[\"8943\",\"攊\"],[\"8946\",\"丽滝鵎釟\"],[\"894c\",\"𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮\"],[\"89a1\",\"琑糼緍楆竉刧\"],[\"89ab\",\"醌碸酞肼\"],[\"89b0\",\"贋胶𠧧\"],[\"89b5\",\"肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁\"],[\"89c1\",\"溚舾甙\"],[\"89c5\",\"䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅\"],[\"8a40\",\"𧶄唥\"],[\"8a43\",\"𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓\"],[\"8a64\",\"𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕\"],[\"8a76\",\"䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯\"],[\"8aa1\",\"𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱\"],[\"8aac\",\"䠋𠆩㿺塳𢶍\"],[\"8ab2\",\"𤗈𠓼𦂗𠽌𠶖啹䂻䎺\"],[\"8abb\",\"䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃\"],[\"8ac9\",\"𪘁𠸉𢫏𢳉\"],[\"8ace\",\"𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻\"],[\"8adf\",\"𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌\"],[\"8af6\",\"𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭\"],[\"8b40\",\"𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹\"],[\"8b55\",\"𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑\"],[\"8ba1\",\"𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁\"],[\"8bde\",\"𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢\"],[\"8c40\",\"倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋\"],[\"8ca1\",\"𣏹椙橃𣱣泿\"],[\"8ca7\",\"爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚\"],[\"8cc9\",\"顨杫䉶圽\"],[\"8cce\",\"藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶\"],[\"8ce6\",\"峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻\"],[\"8d40\",\"𠮟\"],[\"8d42\",\"𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱\"],[\"8da1\",\"㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘\"],[\"8e40\",\"𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎\"],[\"8ea1\",\"繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛\"],[\"8f40\",\"蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖\"],[\"8fa1\",\"𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起\"],[\"9040\",\"趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛\"],[\"90a1\",\"𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜\"],[\"9140\",\"𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈\"],[\"91a1\",\"鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨\"],[\"9240\",\"𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘\"],[\"92a1\",\"働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃\"],[\"9340\",\"媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍\"],[\"93a1\",\"摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋\"],[\"9440\",\"銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻\"],[\"94a1\",\"㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡\"],[\"9540\",\"𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂\"],[\"95a1\",\"衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰\"],[\"9640\",\"桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸\"],[\"96a1\",\"𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉\"],[\"9740\",\"愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫\"],[\"97a1\",\"𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎\"],[\"9840\",\"𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦\"],[\"98a1\",\"咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃\"],[\"9940\",\"䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚\"],[\"99a1\",\"䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿\"],[\"9a40\",\"鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺\"],[\"9aa1\",\"黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪\"],[\"9b40\",\"𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌\"],[\"9b62\",\"𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎\"],[\"9ba1\",\"椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊\"],[\"9c40\",\"嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶\"],[\"9ca1\",\"㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏\"],[\"9d40\",\"𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁\"],[\"9da1\",\"辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢\"],[\"9e40\",\"𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺\"],[\"9ea1\",\"鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭\"],[\"9ead\",\"𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹\"],[\"9ec5\",\"㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲\"],[\"9ef5\",\"噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼\"],[\"9f40\",\"籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱\"],[\"9f4f\",\"凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰\"],[\"9fa1\",\"椬叚鰊鴂䰻陁榀傦畆𡝭駚剳\"],[\"9fae\",\"酙隁酜\"],[\"9fb2\",\"酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽\"],[\"9fc1\",\"𤤙盖鮝个𠳔莾衂\"],[\"9fc9\",\"届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳\"],[\"9fdb\",\"歒酼龥鮗頮颴骺麨麄煺笔\"],[\"9fe7\",\"毺蠘罸\"],[\"9feb\",\"嘠𪙊蹷齓\"],[\"9ff0\",\"跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇\"],[\"a040\",\"𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷\"],[\"a055\",\"𡠻𦸅\"],[\"a058\",\"詾𢔛\"],[\"a05b\",\"惽癧髗鵄鍮鮏蟵\"],[\"a063\",\"蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽\"],[\"a073\",\"坟慯抦戹拎㩜懢厪𣏵捤栂㗒\"],[\"a0a1\",\"嵗𨯂迚𨸹\"],[\"a0a6\",\"僙𡵆礆匲阸𠼻䁥\"],[\"a0ae\",\"矾\"],[\"a0b0\",\"糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦\"],[\"a0d4\",\"覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷\"],[\"a0e2\",\"罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫\"],[\"a3c0\",\"␀\",31,\"␡\"],[\"c6a1\",\"①\",9,\"⑴\",9,\"ⅰ\",9,\"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ\",23],[\"c740\",\"す\",58,\"ァアィイ\"],[\"c7a1\",\"ゥ\",81,\"А\",5,\"ЁЖ\",4],[\"c840\",\"Л\",26,\"ёж\",25,\"⇧↸↹㇏𠃌乚𠂊刂䒑\"],[\"c8a1\",\"龰冈龱𧘇\"],[\"c8cd\",\"￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣\"],[\"c8f5\",\"ʃɐɛɔɵœøŋʊɪ\"],[\"f9fe\",\"￭\"],[\"fa40\",\"𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸\"],[\"faa1\",\"鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍\"],[\"fb40\",\"𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙\"],[\"fba1\",\"𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂\"],[\"fc40\",\"廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷\"],[\"fca1\",\"𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝\"],[\"fd40\",\"𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀\"],[\"fda1\",\"𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎\"],[\"fe40\",\"鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌\"],[\"fea1\",\"𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔\"]]},function(t,e,n){\"use strict\";var r=n(1).Buffer,i=n(15).Transform;function a(t,e){this.conv=t,(e=e||{}).decodeStrings=!1,i.call(this,e)}function o(t,e){this.conv=t,(e=e||{}).encoding=this.encoding=\"utf8\",i.call(this,e)}t.exports=function(t){t.encodeStream=function(e,n){return new a(t.getEncoder(e,n),n)},t.decodeStream=function(e,n){return new o(t.getDecoder(e,n),n)},t.supportsStreams=!0,t.IconvLiteEncoderStream=a,t.IconvLiteDecoderStream=o,t._collect=o.prototype.collect},(a.prototype=Object.create(i.prototype,{constructor:{value:a}}))._transform=function(t,e,n){if(\"string\"!=typeof t)return n(new Error(\"Iconv encoding stream needs strings as its input.\"));try{var r=this.conv.write(t);r&&r.length&&this.push(r),n()}catch(t){n(t)}},a.prototype._flush=function(t){try{var e=this.conv.end();e&&e.length&&this.push(e),t()}catch(e){t(e)}},a.prototype.collect=function(t){var e=[];return this.on(\"error\",t),this.on(\"data\",function(t){e.push(t)}),this.on(\"end\",function(){t(null,r.concat(e))}),this},(o.prototype=Object.create(i.prototype,{constructor:{value:o}}))._transform=function(t,e,n){if(!r.isBuffer(t))return n(new Error(\"Iconv decoding stream needs buffers as its input.\"));try{var i=this.conv.write(t);i&&i.length&&this.push(i,this.encoding),n()}catch(t){n(t)}},o.prototype._flush=function(t){try{var e=this.conv.end();e&&e.length&&this.push(e,this.encoding),t()}catch(e){t(e)}},o.prototype.collect=function(t){var e=\"\";return this.on(\"error\",t),this.on(\"data\",function(t){e+=t}),this.on(\"end\",function(){t(null,e)}),this}},function(t,e,n){\"use strict\";var r=n(1).Buffer;t.exports=function(t){var e=void 0;t.supportsNodeEncodingsExtension=!(new r(0)instanceof Uint8Array),t.extendNodeEncodings=function(){if(!e&&(e={},t.supportsNodeEncodingsExtension)){var i={hex:!0,utf8:!0,\"utf-8\":!0,ascii:!0,binary:!0,base64:!0,ucs2:!0,\"ucs-2\":!0,utf16le:!0,\"utf-16le\":!0};r.isNativeEncoding=function(t){return t&&i[t.toLowerCase()]};var a=n(1).SlowBuffer;if(e.SlowBufferToString=a.prototype.toString,a.prototype.toString=function(n,i,a){return n=String(n||\"utf8\").toLowerCase(),r.isNativeEncoding(n)?e.SlowBufferToString.call(this,n,i,a):(void 0===i&&(i=0),void 0===a&&(a=this.length),t.decode(this.slice(i,a),n))},e.SlowBufferWrite=a.prototype.write,a.prototype.write=function(n,i,a,o){if(isFinite(i))isFinite(a)||(o=a,a=void 0);else{var s=o;o=i,i=a,a=s}i=+i||0;var l=this.length-i;if(a?(a=+a)>l&&(a=l):a=l,o=String(o||\"utf8\").toLowerCase(),r.isNativeEncoding(o))return e.SlowBufferWrite.call(this,n,i,a,o);if(n.length>0&&(a<0||i<0))throw new RangeError(\"attempt to write beyond buffer bounds\");var u=t.encode(n,o);return u.length<a&&(a=u.length),u.copy(this,i,0,a),a},e.BufferIsEncoding=r.isEncoding,r.isEncoding=function(e){return r.isNativeEncoding(e)||t.encodingExists(e)},e.BufferByteLength=r.byteLength,r.byteLength=a.byteLength=function(n,i){return i=String(i||\"utf8\").toLowerCase(),r.isNativeEncoding(i)?e.BufferByteLength.call(this,n,i):t.encode(n,i).length},e.BufferToString=r.prototype.toString,r.prototype.toString=function(n,i,a){return n=String(n||\"utf8\").toLowerCase(),r.isNativeEncoding(n)?e.BufferToString.call(this,n,i,a):(void 0===i&&(i=0),void 0===a&&(a=this.length),t.decode(this.slice(i,a),n))},e.BufferWrite=r.prototype.write,r.prototype.write=function(n,i,a,o){var s=i,l=a,u=o;if(isFinite(i))isFinite(a)||(o=a,a=void 0);else{var c=o;o=i,i=a,a=c}if(o=String(o||\"utf8\").toLowerCase(),r.isNativeEncoding(o))return e.BufferWrite.call(this,n,s,l,u);i=+i||0;var h=this.length-i;if(a?(a=+a)>h&&(a=h):a=h,n.length>0&&(a<0||i<0))throw new RangeError(\"attempt to write beyond buffer bounds\");var f=t.encode(n,o);return f.length<a&&(a=f.length),f.copy(this,i,0,a),a},t.supportsStreams){var o=n(15).Readable;e.ReadableSetEncoding=o.prototype.setEncoding,o.prototype.setEncoding=function(e,n){this._readableState.decoder=t.getDecoder(e,n),this._readableState.encoding=e},o.prototype.collect=t._collect}}},t.undoExtendNodeEncodings=function(){if(t.supportsNodeEncodingsExtension){if(!e)throw new Error(\"require('iconv-lite').undoExtendNodeEncodings(): Nothing to undo; extendNodeEncodings() is not called.\");delete r.isNativeEncoding;var i=n(1).SlowBuffer;if(i.prototype.toString=e.SlowBufferToString,i.prototype.write=e.SlowBufferWrite,r.isEncoding=e.BufferIsEncoding,r.byteLength=e.BufferByteLength,r.prototype.toString=e.BufferToString,r.prototype.write=e.BufferWrite,t.supportsStreams){var a=n(15).Readable;a.prototype.setEncoding=e.ReadableSetEncoding,delete a.prototype.collect}e=void 0}}}},function(t,e,n){(function(){var e,r,i,a,o,s,l={}.hasOwnProperty;e=n(93),a=n(22).Number,s=n(12),o=n(49).inspect,i=function(t){function n(){return n.__super__.constructor.apply(this,arguments)}return function(t,e){for(var n in e)l.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(n,e),n.prototype.decode=function(t,e){var n,i,o;return i=t.pos,n=s.resolveLength(this.length,t,e),this.length instanceof a&&(e={parent:e,_startOffset:i,_currentOffset:0,_length:n}),o=new r(this.type,n,t,e),t.pos+=n*this.type.size(null,e),o},n.prototype.size=function(t,e){return t instanceof r&&(t=t.toArray()),n.__super__.size.call(this,t,e)},n.prototype.encode=function(t,e,i){return e instanceof r&&(e=e.toArray()),n.__super__.encode.call(this,t,e,i)},n}(),r=function(){function t(t,e,n,r){this.type=t,this.length=e,this.stream=n,this.ctx=r,this.base=this.stream.pos,this.items=[]}return t.prototype.get=function(t){var e;if(!(t<0||t>=this.length))return null==this.items[t]&&(e=this.stream.pos,this.stream.pos=this.base+this.type.size(null,this.ctx)*t,this.items[t]=this.type.decode(this.stream,this.ctx),this.stream.pos=e),this.items[t]},t.prototype.toArray=function(){var t,e,n,r;for(r=[],t=e=0,n=this.length;e<n;t=e+=1)r.push(this.get(t));return r},t.prototype.inspect=function(){return o(this.toArray())},t}(),t.exports=i}).call(this)},function(t,e){(function(){var e;e=function(){function t(t,e){this.type=t,this.flags=null!=e?e:[]}return t.prototype.decode=function(t){var e,n,r,i,a,o,s;for(i=this.type.decode(t),r={},n=a=0,o=(s=this.flags).length;a<o;n=++a)null!=(e=s[n])&&(r[e]=!!(i&1<<n));return r},t.prototype.size=function(){return this.type.size()},t.prototype.encode=function(t,e){var n,r,i,a,o,s;for(i=0,r=a=0,o=(s=this.flags).length;a<o;r=++a)null!=(n=s[r])&&e[n]&&(i|=1<<r);return this.type.encode(t,i)},t}(),t.exports=e}).call(this)},function(t,e){(function(){var e;e=function(){function t(t){this.type=t}return t.prototype.decode=function(t,e){return!!this.type.decode(t,e)},t.prototype.size=function(t,e){return this.type.size(t,e)},t.prototype.encode=function(t,e,n){return this.type.encode(t,+e,n)},t}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e,r,i;i=n(12),r=n(22).Number,e=function(){function t(t){this.length=t}return t.prototype.decode=function(t,e){var n;return n=i.resolveLength(this.length,t,e),t.readBuffer(n)},t.prototype.size=function(t,e){return t?t.length:i.resolveLength(this.length,null,e)},t.prototype.encode=function(t,e,n){return this.length instanceof r&&this.length.encode(t,e.length),t.writeBuffer(e)},t}(),t.exports=e}).call(this)},function(t,e){(function(){var e;e=function(){function t(t,e){this.type=t,this.options=null!=e?e:[]}return t.prototype.decode=function(t){var e;return e=this.type.decode(t),this.options[e]||e},t.prototype.size=function(){return this.type.size()},t.prototype.encode=function(t,e){var n;if(-1===(n=this.options.indexOf(e)))throw new Error(\"Unknown option in enum: \"+e);return this.type.encode(t,n)},t}(),t.exports=e}).call(this)},function(t,e){(function(){var e;e=function(){function t(t,e){this.type=t,this.condition=null==e||e}return t.prototype.decode=function(t,e){var n;if(\"function\"==typeof(n=this.condition)&&(n=n.call(e,e)),n)return this.type.decode(t,e)},t.prototype.size=function(t,e){var n;return\"function\"==typeof(n=this.condition)&&(n=n.call(e,e)),n?this.type.size(t,e):0},t.prototype.encode=function(t,e,n){var r;if(\"function\"==typeof(r=this.condition)&&(r=r.call(n,n)),r)return this.type.encode(t,e,n)},t}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e,r;r=n(12),e=function(){function t(t,e){this.type=t,this.count=null!=e?e:1}return t.prototype.decode=function(t,e){t.pos+=this.size(null,e)},t.prototype.size=function(t,e){var n;return n=r.resolveLength(this.count,null,e),this.type.size()*n},t.prototype.encode=function(t,e,n){return t.fill(0,this.size(e,n))},t}(),t.exports=e}).call(this)},function(t,e,n){(function(e){(function(){var r,i,a;r=n(22).Number,a=n(12),i=function(){function t(t,e){this.length=t,this.encoding=null!=e?e:\"ascii\"}return t.prototype.decode=function(t,e){var n,r,i,o,s;return i=function(){if(null!=this.length)return a.resolveLength(this.length,t,e);for(n=t.buffer,i=t.length,o=t.pos;o<i&&0!==n[o];)++o;return o-t.pos}.call(this),\"function\"==typeof(r=this.encoding)&&(r=r.call(e,e)||\"ascii\"),s=t.readString(i,r),null==this.length&&t.pos<t.length&&t.pos++,s},t.prototype.size=function(t,n){var i,o;return t?(\"function\"==typeof(i=this.encoding)&&(i=i.call(null!=n?n.val:void 0,null!=n?n.val:void 0)||\"ascii\"),\"utf16be\"===i&&(i=\"utf16le\"),o=e.byteLength(t,i),this.length instanceof r&&(o+=this.length.size()),null==this.length&&o++,o):a.resolveLength(this.length,null,n)},t.prototype.encode=function(t,n,i){var a;if(\"function\"==typeof(a=this.encoding)&&(a=a.call(null!=i?i.val:void 0,null!=i?i.val:void 0)||\"ascii\"),this.length instanceof r&&this.length.encode(t,e.byteLength(n,a)),t.writeString(n,a),null==this.length)return t.writeUInt8(0)},t}(),t.exports=i}).call(this)}).call(e,n(1).Buffer)},function(t,e,n){(function(){var e,r,i={}.hasOwnProperty;e=n(94),r=function(t){function n(t,e){this.type=t,this.versions=null!=e?e:{},\"string\"==typeof this.type&&(this.versionGetter=new Function(\"parent\",\"return parent.\"+this.type),this.versionSetter=new Function(\"parent\",\"version\",\"return parent.\"+this.type+\" = version\"))}return function(t,e){for(var n in e)i.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(n,e),n.prototype.decode=function(t,e,r){var i,a,o;if(null==r&&(r=0),a=this._setup(t,e,r),\"string\"==typeof this.type?a.version=this.versionGetter(e):a.version=this.type.decode(t),this.versions.header&&this._parseFields(t,a,this.versions.header),null==(i=this.versions[a.version]))throw new Error(\"Unknown version \"+a.version);return i instanceof n?i.decode(t,e):(this._parseFields(t,a,i),null!=(o=this.process)&&o.call(a,t),a)},n.prototype.size=function(t,e,n){var r,i,a,o,s,l;if(null==n&&(n=!0),!t)throw new Error(\"Not a fixed size\");if(r={parent:e,val:t,pointerSize:0},o=0,\"string\"!=typeof this.type&&(o+=this.type.size(t.version,r)),this.versions.header)for(a in l=this.versions.header)null!=(s=l[a]).size&&(o+=s.size(t[a],r));if(null==(i=this.versions[t.version]))throw new Error(\"Unknown version \"+t.version);for(a in i)null!=(s=i[a]).size&&(o+=s.size(t[a],r));return n&&(o+=r.pointerSize),o},n.prototype.encode=function(t,e,n){var r,i,a,o,s,l,u,c;if(null!=(u=this.preEncode)&&u.call(e,t),(r={pointers:[],startOffset:t.pos,parent:n,val:e,pointerSize:0}).pointerOffset=t.pos+this.size(e,r,!1),\"string\"!=typeof this.type&&this.type.encode(t,e.version),this.versions.header)for(o in c=this.versions.header)null!=(l=c[o]).encode&&l.encode(t,e[o],r);for(o in i=this.versions[e.version])null!=(l=i[o]).encode&&l.encode(t,e[o],r);for(a=0;a<r.pointers.length;)(s=r.pointers[a++]).type.encode(t,s.val,s.parent)},n}(),t.exports=r}).call(this)},function(t,e,n){(function(){var t,r,i;i=n(12),t=function(){function t(t,e,n){var r,i,a,o;this.offsetType=t,this.type=e,this.options=null!=n?n:{},\"void\"===this.type&&(this.type=null),null==(r=this.options).type&&(r.type=\"local\"),null==(i=this.options).allowNull&&(i.allowNull=!0),null==(a=this.options).nullValue&&(a.nullValue=0),null==(o=this.options).lazy&&(o.lazy=!1),this.options.relativeTo&&(this.relativeToGetter=new Function(\"ctx\",\"return ctx.\"+this.options.relativeTo))}return t.prototype.decode=function(t,e){var n,r,a,o,s,l,u;return(a=this.offsetType.decode(t,e))===this.options.nullValue&&this.options.allowNull?null:(s=function(){switch(this.options.type){case\"local\":return e._startOffset;case\"immediate\":return t.pos-this.offsetType.size();case\"parent\":return e.parent._startOffset;default:for(n=e;n.parent;)n=n.parent;return n._startOffset||0}}.call(this),this.options.relativeTo&&(s+=this.relativeToGetter(e)),o=a+s,null!=this.type?(l=null,u=this,r=function(){var n;return null!=l?l:(n=t.pos,t.pos=o,l=u.type.decode(t,e),t.pos=n,l)},this.options.lazy?new i.PropertyDescriptor({get:r}):r()):o)},t.prototype.size=function(t,e){var n,i;switch(n=e,this.options.type){case\"local\":case\"immediate\":break;case\"parent\":e=e.parent;break;default:for(;e.parent;)e=e.parent}if(null==(i=this.type)){if(!(t instanceof r))throw new Error(\"Must be a VoidPointer\");i=t.type,t=t.value}return t&&e&&(e.pointerSize+=i.size(t,n)),this.offsetType.size()},t.prototype.encode=function(t,e,n){var i,a,o;if(i=n,null!=e){switch(this.options.type){case\"local\":a=n.startOffset;break;case\"immediate\":a=t.pos+this.offsetType.size(e,i);break;case\"parent\":a=(n=n.parent).startOffset;break;default:for(a=0;n.parent;)n=n.parent}if(this.options.relativeTo&&(a+=this.relativeToGetter(i.val)),this.offsetType.encode(t,n.pointerOffset-a),null==(o=this.type)){if(!(e instanceof r))throw new Error(\"Must be a VoidPointer\");o=e.type,e=e.value}return n.pointers.push({type:o,val:e,parent:i}),n.pointerOffset+=o.size(e,i)}this.offsetType.encode(t,this.options.nullValue)},t}(),r=function(t,e){this.type=t,this.value=e},e.Pointer=t,e.VoidPointer=r}).call(this)},function(t,e,n){t.exports={default:n(198),__esModule:!0}},function(t,e,n){n(199);var r=n(2).Object;t.exports=function(t,e){return r.getOwnPropertyDescriptor(t,e)}},function(t,e,n){var r=n(17),i=n(57).f;n(59)(\"getOwnPropertyDescriptor\",function(){return function(t,e){return i(r(t),e)}})},function(t,e,n){n(28),n(24),t.exports=n(208)},function(t,e,n){\"use strict\";var r=n(202),i=n(98),a=n(23),o=n(17);t.exports=n(61)(Array,\"Array\",function(t,e){this._t=o(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,i(1)):i(0,\"keys\"==e?n:\"values\"==e?t[n]:[n,t[n]])},\"values\"),a.Arguments=a.Array,r(\"keys\"),r(\"values\"),r(\"entries\")},function(t,e){t.exports=function(){}},function(t,e,n){\"use strict\";var r=n(36),i=n(27),a=n(39),o={};n(13)(o,n(4)(\"iterator\"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(o,{next:i(1,n)}),a(t,e+\" Iterator\")}},function(t,e,n){var r=n(17),i=n(37),a=n(102);t.exports=function(t){return function(e,n,o){var s,l=r(e),u=i(l.length),c=a(o,u);if(t&&n!=n){for(;u>c;)if((s=l[c++])!=s)return!0}else for(;u>c;c++)if((t||c in l)&&l[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var r=n(10).document;t.exports=r&&r.documentElement},function(t,e,n){var r=n(18),i=n(30),a=n(64)(\"IE_PROTO\"),o=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),r(t,a)?t[a]:\"function\"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?o:null}},function(t,e,n){var r=n(63),i=n(56);t.exports=function(t){return function(e,n){var a,o,s=String(i(e)),l=r(n),u=s.length;return l<0||l>=u?t?\"\":void 0:(a=s.charCodeAt(l))<55296||a>56319||l+1===u||(o=s.charCodeAt(l+1))<56320||o>57343?t?s.charAt(l):a:t?s.slice(l,l+2):o-56320+(a-55296<<10)+65536}}},function(t,e,n){var r=n(14),i=n(67);t.exports=n(2).getIterator=function(t){var e=i(t);if(\"function\"!=typeof e)throw TypeError(t+\" is not iterable!\");return r(e.call(t))}},function(t,e,n){t.exports={default:n(210),__esModule:!0}},function(t,e,n){n(211),t.exports=n(2).Object.freeze},function(t,e,n){var r=n(9),i=n(40).onFreeze;n(59)(\"freeze\",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){t.exports={default:n(213),__esModule:!0}},function(t,e,n){n(214),t.exports=n(2).Object.keys},function(t,e,n){var r=n(30),i=n(29);n(59)(\"keys\",function(){return function(t){return i(r(t))}})},function(t,e,n){n(24),n(28),t.exports=n(70).f(\"iterator\")},function(t,e,n){t.exports={default:n(217),__esModule:!0}},function(t,e,n){n(218),n(73),n(221),n(222),t.exports=n(2).Symbol},function(t,e,n){\"use strict\";var r=n(10),i=n(18),a=n(5),o=n(3),s=n(99),l=n(40).KEY,u=n(19),c=n(65),h=n(39),f=n(38),d=n(4),p=n(70),g=n(71),y=n(219),v=n(104),b=n(14),m=n(9),w=n(17),x=n(58),S=n(27),_=n(36),k=n(220),C=n(57),A=n(6),P=n(29),E=C.f,I=A.f,T=k.f,O=r.Symbol,L=r.JSON,B=L&&L.stringify,M=\"prototype\",R=d(\"_hidden\"),F=d(\"toPrimitive\"),D={}.propertyIsEnumerable,z=c(\"symbol-registry\"),N=c(\"symbols\"),U=c(\"op-symbols\"),W=Object[M],G=\"function\"==typeof O,V=r.QObject,j=!V||!V[M]||!V[M].findChild,H=a&&u(function(){return 7!=_(I({},\"a\",{get:function(){return I(this,\"a\",{value:7}).a}})).a})?function(t,e,n){var r=E(W,e);r&&delete W[e],I(t,e,n),r&&t!==W&&I(W,e,r)}:I,q=function(t){var e=N[t]=_(O[M]);return e._k=t,e},Z=G&&\"symbol\"==typeof O.iterator?function(t){return\"symbol\"==typeof t}:function(t){return t instanceof O},Y=function(t,e,n){return t===W&&Y(U,e,n),b(t),e=x(e,!0),b(n),i(N,e)?(n.enumerable?(i(t,R)&&t[R][e]&&(t[R][e]=!1),n=_(n,{enumerable:S(0,!1)})):(i(t,R)||I(t,R,S(1,{})),t[R][e]=!0),H(t,e,n)):I(t,e,n)},X=function(t,e){b(t);for(var n,r=y(e=w(e)),i=0,a=r.length;a>i;)Y(t,n=r[i++],e[n]);return t},K=function(t){var e=D.call(this,t=x(t,!0));return!(this===W&&i(N,t)&&!i(U,t))&&(!(e||!i(this,t)||!i(N,t)||i(this,R)&&this[R][t])||e)},J=function(t,e){if(t=w(t),e=x(e,!0),t!==W||!i(N,e)||i(U,e)){var n=E(t,e);return!n||!i(N,e)||i(t,R)&&t[R][e]||(n.enumerable=!0),n}},Q=function(t){for(var e,n=T(w(t)),r=[],a=0;n.length>a;)i(N,e=n[a++])||e==R||e==l||r.push(e);return r},$=function(t){for(var e,n=t===W,r=T(n?U:w(t)),a=[],o=0;r.length>o;)!i(N,e=r[o++])||n&&!i(W,e)||a.push(N[e]);return a};G||(s((O=function(){if(this instanceof O)throw TypeError(\"Symbol is not a constructor!\");var t=f(arguments.length>0?arguments[0]:void 0),e=function(n){this===W&&e.call(U,n),i(this,R)&&i(this[R],t)&&(this[R][t]=!1),H(this,t,S(1,n))};return a&&j&&H(W,t,{configurable:!0,set:e}),q(t)})[M],\"toString\",function(){return this._k}),C.f=J,A.f=Y,n(105).f=k.f=Q,n(35).f=K,n(72).f=$,a&&!n(62)&&s(W,\"propertyIsEnumerable\",K,!0),p.f=function(t){return q(d(t))}),o(o.G+o.W+o.F*!G,{Symbol:O});for(var tt=\"hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables\".split(\",\"),et=0;tt.length>et;)d(tt[et++]);for(var nt=P(d.store),rt=0;nt.length>rt;)g(nt[rt++]);o(o.S+o.F*!G,\"Symbol\",{for:function(t){return i(z,t+=\"\")?z[t]:z[t]=O(t)},keyFor:function(t){if(!Z(t))throw TypeError(t+\" is not a symbol!\");for(var e in z)if(z[e]===t)return e},useSetter:function(){j=!0},useSimple:function(){j=!1}}),o(o.S+o.F*!G,\"Object\",{create:function(t,e){return void 0===e?_(t):X(_(t),e)},defineProperty:Y,defineProperties:X,getOwnPropertyDescriptor:J,getOwnPropertyNames:Q,getOwnPropertySymbols:$}),L&&o(o.S+o.F*(!G||u(function(){var t=O();return\"[null]\"!=B([t])||\"{}\"!=B({a:t})||\"{}\"!=B(Object(t))})),\"JSON\",{stringify:function(t){for(var e,n,r=[t],i=1;arguments.length>i;)r.push(arguments[i++]);if(n=e=r[1],(m(e)||void 0!==t)&&!Z(t))return v(e)||(e=function(t,e){if(\"function\"==typeof n&&(e=n.call(this,t,e)),!Z(e))return e}),r[1]=e,B.apply(L,r)}}),O[M][F]||n(13)(O[M],F,O[M].valueOf),h(O,\"Symbol\"),h(Math,\"Math\",!0),h(r.JSON,\"JSON\",!0)},function(t,e,n){var r=n(29),i=n(72),a=n(35);t.exports=function(t){var e=r(t),n=i.f;if(n)for(var o,s=n(t),l=a.f,u=0;s.length>u;)l.call(t,o=s[u++])&&e.push(o);return e}},function(t,e,n){var r=n(17),i=n(105).f,a={}.toString,o=\"object\"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return o&&\"[object Window]\"==a.call(t)?function(t){try{return i(t)}catch(t){return o.slice()}}(t):i(r(t))}},function(t,e,n){n(71)(\"asyncIterator\")},function(t,e,n){n(71)(\"observable\")},function(t,e,n){n(224);var r=n(2).Object;t.exports=function(t,e,n){return r.defineProperty(t,e,n)}},function(t,e,n){var r=n(3);r(r.S+r.F*!n(5),\"Object\",{defineProperty:n(6).f})},function(t,e,n){t.exports={default:n(226),__esModule:!0}},function(t,e,n){n(73),n(24),n(28),n(227),n(232),n(234),n(235),t.exports=n(2).Map},function(t,e,n){\"use strict\";var r=n(108),i=n(75);t.exports=n(113)(\"Map\",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{get:function(t){var e=r.getEntry(i(this,\"Map\"),t);return e&&e.v},set:function(t,e){return r.def(i(this,\"Map\"),0===t?0:t,e)}},r,!0)},function(t,e,n){\"use strict\";var r=n(10),i=n(2),a=n(6),o=n(5),s=n(4)(\"species\");t.exports=function(t){var e=\"function\"==typeof i[t]?i[t]:r[t];o&&e&&!e[s]&&a.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(20),i=n(54),a=n(30),o=n(37),s=n(230);t.exports=function(t,e){var n=1==t,l=2==t,u=3==t,c=4==t,h=6==t,f=5==t||h,d=e||s;return function(e,s,p){for(var g,y,v=a(e),b=i(v),m=r(s,p,3),w=o(b.length),x=0,S=n?d(e,w):l?d(e,0):void 0;w>x;x++)if((f||x in b)&&(y=m(g=b[x],x,v),t))if(n)S[x]=y;else if(y)switch(t){case 3:return!0;case 5:return g;case 6:return x;case 2:S.push(g)}else if(c)return!1;return h?-1:u||c?c:S}}},function(t,e,n){var r=n(231);t.exports=function(t,e){return new(r(t))(e)}},function(t,e,n){var r=n(9),i=n(104),a=n(4)(\"species\");t.exports=function(t){var e;return i(t)&&(\"function\"!=typeof(e=t.constructor)||e!==Array&&!i(e.prototype)||(e=void 0),r(e)&&null===(e=e[a])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var r=n(3);r(r.P+r.R,\"Map\",{toJSON:n(114)(\"Map\")})},function(t,e,n){var r=n(41);t.exports=function(t,e){var n=[];return r(t,!1,n.push,n,e),n}},function(t,e,n){n(115)(\"Map\")},function(t,e,n){n(116)(\"Map\")},function(t,e,n){\"use strict\";e.__esModule=!0;var r,i=n(69),a=(r=i)&&r.__esModule?r:{default:r};e.default=function(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!==(void 0===e?\"undefined\":(0,a.default)(e))&&\"function\"!=typeof e?t:e}},function(t,e,n){\"use strict\";e.__esModule=!0;var r=o(n(238)),i=o(n(242)),a=o(n(69));function o(t){return t&&t.__esModule?t:{default:t}}e.default=function(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+(void 0===e?\"undefined\":(0,a.default)(e)));t.prototype=(0,i.default)(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(r.default?(0,r.default)(t,e):t.__proto__=e)}},function(t,e,n){t.exports={default:n(239),__esModule:!0}},function(t,e,n){n(240),t.exports=n(2).Object.setPrototypeOf},function(t,e,n){var r=n(3);r(r.S,\"Object\",{setPrototypeOf:n(241).set})},function(t,e,n){var r=n(9),i=n(14),a=function(t,e){if(i(t),!r(e)&&null!==e)throw TypeError(e+\": can't set as prototype!\")};t.exports={set:Object.setPrototypeOf||(\"__proto__\"in{}?function(t,e,r){try{(r=n(20)(Function.call,n(57).f(Object.prototype,\"__proto__\").set,2))(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return a(t,n),e?t.__proto__=n:r(t,n),t}}({},!1):void 0),check:a}},function(t,e,n){t.exports={default:n(243),__esModule:!0}},function(t,e,n){n(244);var r=n(2).Object;t.exports=function(t,e){return r.create(t,e)}},function(t,e,n){var r=n(3);r(r.S,\"Object\",{create:n(36)})},function(t,e,n){t.exports={default:n(246),__esModule:!0}},function(t,e,n){n(247);var r=n(2).Object;t.exports=function(t,e){return r.defineProperties(t,e)}},function(t,e,n){var r=n(3);r(r.S+r.F*!n(5),\"Object\",{defineProperties:n(100)})},function(t,e,n){var r=Array.prototype.slice,i=n(249),a=n(250),o=t.exports=function(t,e,n){return n||(n={}),t===e||(t instanceof Date&&e instanceof Date?t.getTime()===e.getTime():!t||!e||\"object\"!=typeof t&&\"object\"!=typeof e?n.strict?t===e:t==e:function(t,e,n){var u,c;if(s(t)||s(e))return!1;if(t.prototype!==e.prototype)return!1;if(a(t))return!!a(e)&&(t=r.call(t),e=r.call(e),o(t,e,n));if(l(t)){if(!l(e))return!1;if(t.length!==e.length)return!1;for(u=0;u<t.length;u++)if(t[u]!==e[u])return!1;return!0}try{var h=i(t),f=i(e)}catch(t){return!1}if(h.length!=f.length)return!1;for(h.sort(),f.sort(),u=h.length-1;u>=0;u--)if(h[u]!=f[u])return!1;for(u=h.length-1;u>=0;u--)if(c=h[u],!o(t[c],e[c],n))return!1;return typeof t==typeof e}(t,e,n))};function s(t){return null==t}function l(t){return!(!t||\"object\"!=typeof t||\"number\"!=typeof t.length)&&(\"function\"==typeof t.copy&&\"function\"==typeof t.slice&&!(t.length>0&&\"number\"!=typeof t[0]))}},function(t,e){function n(t){var e=[];for(var n in t)e.push(n);return e}(t.exports=\"function\"==typeof Object.keys?Object.keys:n).shim=n},function(t,e){var n=\"[object Arguments]\"==function(){return Object.prototype.toString.call(arguments)}();function r(t){return\"[object Arguments]\"==Object.prototype.toString.call(t)}function i(t){return t&&\"object\"==typeof t&&\"number\"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,\"callee\")&&!Object.prototype.propertyIsEnumerable.call(t,\"callee\")||!1}(e=t.exports=n?r:i).supported=r,e.unsupported=i},function(t,e,n){t.exports={default:n(252),__esModule:!0}},function(t,e,n){n(253),t.exports=n(2).Object.assign},function(t,e,n){var r=n(3);r(r.S+r.F,\"Object\",{assign:n(254)})},function(t,e,n){\"use strict\";var r=n(29),i=n(72),a=n(35),o=n(30),s=n(54),l=Object.assign;t.exports=!l||n(19)(function(){var t={},e={},n=Symbol(),r=\"abcdefghijklmnopqrst\";return t[n]=7,r.split(\"\").forEach(function(t){e[t]=t}),7!=l({},t)[n]||Object.keys(l({},e)).join(\"\")!=r})?function(t,e){for(var n=o(t),l=arguments.length,u=1,c=i.f,h=a.f;l>u;)for(var f,d=s(arguments[u++]),p=c?r(d).concat(c(d)):r(d),g=p.length,y=0;g>y;)h.call(d,f=p[y++])&&(n[f]=d[f]);return n}:l},function(t,e,n){t.exports={default:n(256),__esModule:!0}},function(t,e,n){n(257),t.exports=n(2).String.fromCodePoint},function(t,e,n){var r=n(3),i=n(102),a=String.fromCharCode,o=String.fromCodePoint;r(r.S+r.F*(!!o&&1!=o.length),\"String\",{fromCodePoint:function(t){for(var e,n=[],r=arguments.length,o=0;r>o;){if(e=+arguments[o++],i(e,1114111)!==e)throw RangeError(e+\" is not a valid code point\");n.push(e<65536?a(e):a(55296+((e-=65536)>>10),e%1024+56320))}return n.join(\"\")}})},function(t,e,n){t.exports={default:n(259),__esModule:!0}},function(t,e,n){n(24),n(260),t.exports=n(2).Array.from},function(t,e,n){\"use strict\";var r=n(20),i=n(3),a=n(30),o=n(111),s=n(112),l=n(37),u=n(261),c=n(67);i(i.S+i.F*!n(262)(function(t){Array.from(t)}),\"Array\",{from:function(t){var e,n,i,h,f=a(t),d=\"function\"==typeof this?this:Array,p=arguments.length,g=p>1?arguments[1]:void 0,y=void 0!==g,v=0,b=c(f);if(y&&(g=r(g,p>2?arguments[2]:void 0,2)),null==b||d==Array&&s(b))for(n=new d(e=l(f.length));e>v;v++)u(n,v,y?g(f[v],v):f[v]);else for(h=b.call(f),n=new d;!(i=h.next()).done;v++)u(n,v,y?o(h,g,[i.value,v],!0):i.value);return n.length=v,n}})},function(t,e,n){\"use strict\";var r=n(6),i=n(27);t.exports=function(t,e,n){e in t?r.f(t,e,i(0,n)):t[e]=n}},function(t,e,n){var r=n(4)(\"iterator\"),i=!1;try{var a=[7][r]();a.return=function(){i=!0},Array.from(a,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!i)return!1;var n=!1;try{var a=[7],o=a[r]();o.next=function(){return{done:n=!0}},a[r]=function(){return o},t(a)}catch(t){}return n}},function(t,e,n){t.exports={default:n(264),__esModule:!0}},function(t,e,n){n(73),n(24),n(28),n(265),n(266),n(267),n(268),t.exports=n(2).Set},function(t,e,n){\"use strict\";var r=n(108),i=n(75);t.exports=n(113)(\"Set\",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(i(this,\"Set\"),t=0===t?0:t,t)}},r)},function(t,e,n){var r=n(3);r(r.P+r.R,\"Set\",{toJSON:n(114)(\"Set\")})},function(t,e,n){n(115)(\"Set\")},function(t,e,n){n(116)(\"Set\")},function(t,e,n){(function(t){var r,i,a,o,s,l,u,c,h,f,d,p,g,y,v,b;p=n(43),y=n(270),b=new p(t(\"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\",\"base64\")),v=Math.log2||function(t){return Math.log(t)/Math.LN2},r=(g=function(t){return v(t)+1|0})(y.categories.length-1),o=g(y.combiningClasses.length-1),h=g(y.scripts.length-1),u=g(y.eaw.length-1),a=o+h+u+10,l=h+u+10,d=u+10,i=(1<<r)-1,s=(1<<o)-1,f=(1<<h)-1,c=(1<<u)-1,e.getCategory=function(t){var e;return e=b.get(t),y.categories[e>>a&i]},e.getCombiningClass=function(t){var e;return e=b.get(t),y.combiningClasses[e>>l&s]},e.getScript=function(t){var e;return e=b.get(t),y.scripts[e>>d&f]},e.getEastAsianWidth=function(t){var e;return e=b.get(t),y.eaw[e>>10&c]},e.getNumericValue=function(t){var e,n,r;if(0===(n=1023&(r=b.get(t))))return null;if(n<=50)return n-1;if(n<480)return((n>>4)-12)/(1+(15&n));if(n<768){for(r=(n>>5)-14,e=2+(31&n);e>0;)r*=10,e--;return r}for(r=(n>>2)-191,e=1+(3&n);e>0;)r*=60,e--;return r},e.isAlphabetic=function(t){var n;return\"Lu\"===(n=e.getCategory(t))||\"Ll\"===n||\"Lt\"===n||\"Lm\"===n||\"Lo\"===n||\"Nl\"===n},e.isDigit=function(t){return\"Nd\"===e.getCategory(t)},e.isPunctuation=function(t){var n;return\"Pc\"===(n=e.getCategory(t))||\"Pd\"===n||\"Pe\"===n||\"Pf\"===n||\"Pi\"===n||\"Po\"===n||\"Ps\"===n},e.isLowerCase=function(t){return\"Ll\"===e.getCategory(t)},e.isUpperCase=function(t){return\"Lu\"===e.getCategory(t)},e.isTitleCase=function(t){return\"Lt\"===e.getCategory(t)},e.isWhiteSpace=function(t){var n;return\"Zs\"===(n=e.getCategory(t))||\"Zl\"===n||\"Zp\"===n},e.isBaseForm=function(t){var n;return\"Nd\"===(n=e.getCategory(t))||\"No\"===n||\"Nl\"===n||\"Lu\"===n||\"Ll\"===n||\"Lt\"===n||\"Lm\"===n||\"Lo\"===n||\"Me\"===n||\"Mc\"===n},e.isMark=function(t){var n;return\"Mn\"===(n=e.getCategory(t))||\"Me\"===n||\"Mc\"===n}}).call(e,n(1).Buffer)},function(t,e){t.exports={categories:[\"Cc\",\"Zs\",\"Po\",\"Sc\",\"Ps\",\"Pe\",\"Sm\",\"Pd\",\"Nd\",\"Lu\",\"Sk\",\"Pc\",\"Ll\",\"So\",\"Lo\",\"Pi\",\"Cf\",\"No\",\"Pf\",\"Lt\",\"Lm\",\"Mn\",\"Me\",\"Mc\",\"Nl\",\"Zl\",\"Zp\",\"Cs\",\"Co\"],combiningClasses:[\"Not_Reordered\",\"Above\",\"Above_Right\",\"Below\",\"Attached_Above_Right\",\"Attached_Below\",\"Overlay\",\"Iota_Subscript\",\"Double_Below\",\"Double_Above\",\"Below_Right\",\"Above_Left\",\"CCC10\",\"CCC11\",\"CCC12\",\"CCC13\",\"CCC14\",\"CCC15\",\"CCC16\",\"CCC17\",\"CCC18\",\"CCC19\",\"CCC20\",\"CCC21\",\"CCC22\",\"CCC23\",\"CCC24\",\"CCC25\",\"CCC30\",\"CCC31\",\"CCC32\",\"CCC27\",\"CCC28\",\"CCC29\",\"CCC33\",\"CCC34\",\"CCC35\",\"CCC36\",\"Nukta\",\"Virama\",\"CCC84\",\"CCC91\",\"CCC103\",\"CCC107\",\"CCC118\",\"CCC122\",\"CCC129\",\"CCC130\",\"CCC132\",\"Attached_Above\",\"Below_Left\",\"Left\",\"Kana_Voicing\",\"CCC26\",\"Right\"],scripts:[\"Common\",\"Latin\",\"Bopomofo\",\"Inherited\",\"Greek\",\"Coptic\",\"Cyrillic\",\"Armenian\",\"Hebrew\",\"Arabic\",\"Syriac\",\"Thaana\",\"Nko\",\"Samaritan\",\"Mandaic\",\"Devanagari\",\"Bengali\",\"Gurmukhi\",\"Gujarati\",\"Oriya\",\"Tamil\",\"Telugu\",\"Kannada\",\"Malayalam\",\"Sinhala\",\"Thai\",\"Lao\",\"Tibetan\",\"Myanmar\",\"Georgian\",\"Hangul\",\"Ethiopic\",\"Cherokee\",\"Canadian_Aboriginal\",\"Ogham\",\"Runic\",\"Tagalog\",\"Hanunoo\",\"Buhid\",\"Tagbanwa\",\"Khmer\",\"Mongolian\",\"Limbu\",\"Tai_Le\",\"New_Tai_Lue\",\"Buginese\",\"Tai_Tham\",\"Balinese\",\"Sundanese\",\"Batak\",\"Lepcha\",\"Ol_Chiki\",\"Braille\",\"Glagolitic\",\"Tifinagh\",\"Han\",\"Hiragana\",\"Katakana\",\"Yi\",\"Lisu\",\"Vai\",\"Bamum\",\"Syloti_Nagri\",\"Phags_Pa\",\"Saurashtra\",\"Kayah_Li\",\"Rejang\",\"Javanese\",\"Cham\",\"Tai_Viet\",\"Meetei_Mayek\",\"null\",\"Linear_B\",\"Lycian\",\"Carian\",\"Old_Italic\",\"Gothic\",\"Old_Permic\",\"Ugaritic\",\"Old_Persian\",\"Deseret\",\"Shavian\",\"Osmanya\",\"Elbasan\",\"Caucasian_Albanian\",\"Linear_A\",\"Cypriot\",\"Imperial_Aramaic\",\"Palmyrene\",\"Nabataean\",\"Hatran\",\"Phoenician\",\"Lydian\",\"Meroitic_Hieroglyphs\",\"Meroitic_Cursive\",\"Kharoshthi\",\"Old_South_Arabian\",\"Old_North_Arabian\",\"Manichaean\",\"Avestan\",\"Inscriptional_Parthian\",\"Inscriptional_Pahlavi\",\"Psalter_Pahlavi\",\"Old_Turkic\",\"Old_Hungarian\",\"Brahmi\",\"Kaithi\",\"Sora_Sompeng\",\"Chakma\",\"Mahajani\",\"Sharada\",\"Khojki\",\"Multani\",\"Khudawadi\",\"Grantha\",\"Tirhuta\",\"Siddham\",\"Modi\",\"Takri\",\"Ahom\",\"Warang_Citi\",\"Pau_Cin_Hau\",\"Cuneiform\",\"Egyptian_Hieroglyphs\",\"Anatolian_Hieroglyphs\",\"Mro\",\"Bassa_Vah\",\"Pahawh_Hmong\",\"Miao\",\"Duployan\",\"SignWriting\",\"Mende_Kikakui\"],eaw:[\"N\",\"Na\",\"A\",\"W\",\"H\",\"F\"]}},function(t,e,n){\"use strict\";function r(t){return t&&\"object\"==typeof t&&\"default\"in t?t.default:t}var i=r(n(272)),a=r(n(60)),o=r(n(276)),s=r(n(277)),l=r(n(103)),u=r(n(106)),c=r(n(107)),h=function(){function t(e){u(this,t),this.stateTable=e.stateTable,this.accepting=e.accepting,this.tags=e.tags}return c(t,[{key:\"match\",value:function(t){var e=this;return o({},l,s.mark(function n(){var r,i,a,o,l,u;return s.wrap(function(n){for(;;)switch(n.prev=n.next){case 0:r=1,i=null,a=null,o=null,l=0;case 5:if(!(l<t.length)){n.next=21;break}if(u=t[l],o=r,0!==(r=e.stateTable[r][u])){n.next=15;break}if(!(null!=i&&null!=a&&a>=i)){n.next=13;break}return n.next=13,[i,a,e.tags[o]];case 13:r=e.stateTable[1][u],i=null;case 15:0!==r&&null==i&&(i=l),e.accepting[r]&&(a=l),0===r&&(r=1);case 18:l++,n.next=5;break;case 21:if(!(null!=i&&null!=a&&a>=i)){n.next=24;break}return n.next=24,[i,a,e.tags[r]];case 24:case\"end\":return n.stop()}},n,this)}))}},{key:\"apply\",value:function(t,e){var n=!0,r=!1,o=void 0;try{for(var s,l=a(this.match(t));!(n=(s=l.next()).done);n=!0){var u=i(s.value,3),c=u[0],h=u[1],f=u[2],d=!0,p=!1,g=void 0;try{for(var y,v=a(f);!(d=(y=v.next()).done);d=!0){var b=y.value;\"function\"==typeof e[b]&&e[b](c,h,t.slice(c,h+1))}}catch(t){p=!0,g=t}finally{try{!d&&v.return&&v.return()}finally{if(p)throw g}}}}catch(t){r=!0,o=t}finally{try{!n&&l.return&&l.return()}finally{if(r)throw o}}}}]),t}();t.exports=h},function(t,e,n){\"use strict\";e.__esModule=!0;var r=a(n(273)),i=a(n(60));function a(t){return t&&t.__esModule?t:{default:t}}e.default=function(t,e){if(Array.isArray(t))return t;if((0,r.default)(Object(t)))return function(t,e){var n=[],r=!0,a=!1,o=void 0;try{for(var s,l=(0,i.default)(t);!(r=(s=l.next()).done)&&(n.push(s.value),!e||n.length!==e);r=!0);}catch(t){a=!0,o=t}finally{try{!r&&l.return&&l.return()}finally{if(a)throw o}}return n}(t,e);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}},function(t,e,n){t.exports={default:n(274),__esModule:!0}},function(t,e,n){n(28),n(24),t.exports=n(275)},function(t,e,n){var r=n(68),i=n(4)(\"iterator\"),a=n(23);t.exports=n(2).isIterable=function(t){var e=Object(t);return void 0!==e[i]||\"@@iterator\"in e||a.hasOwnProperty(r(e))}},function(t,e,n){\"use strict\";e.__esModule=!0;var r,i=n(74),a=(r=i)&&r.__esModule?r:{default:r};e.default=function(t,e,n){return e in t?(0,a.default)(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e,n){t.exports=n(278)},function(t,e,n){var r=function(){return this}()||Function(\"return this\")(),i=r.regeneratorRuntime&&Object.getOwnPropertyNames(r).indexOf(\"regeneratorRuntime\")>=0,a=i&&r.regeneratorRuntime;if(r.regeneratorRuntime=void 0,t.exports=n(279),i)r.regeneratorRuntime=a;else try{delete r.regeneratorRuntime}catch(t){r.regeneratorRuntime=void 0}},function(t,e){!function(e){\"use strict\";var n,r=Object.prototype,i=r.hasOwnProperty,a=\"function\"==typeof Symbol?Symbol:{},o=a.iterator||\"@@iterator\",s=a.asyncIterator||\"@@asyncIterator\",l=a.toStringTag||\"@@toStringTag\",u=\"object\"==typeof t,c=e.regeneratorRuntime;if(c)u&&(t.exports=c);else{(c=e.regeneratorRuntime=u?t.exports:{}).wrap=w;var h=\"suspendedStart\",f=\"suspendedYield\",d=\"executing\",p=\"completed\",g={},y={};y[o]=function(){return this};var v=Object.getPrototypeOf,b=v&&v(v(O([])));b&&b!==r&&i.call(b,o)&&(y=b);var m=k.prototype=S.prototype=Object.create(y);_.prototype=m.constructor=k,k.constructor=_,k[l]=_.displayName=\"GeneratorFunction\",c.isGeneratorFunction=function(t){var e=\"function\"==typeof t&&t.constructor;return!!e&&(e===_||\"GeneratorFunction\"===(e.displayName||e.name))},c.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,k):(t.__proto__=k,l in t||(t[l]=\"GeneratorFunction\")),t.prototype=Object.create(m),t},c.awrap=function(t){return{__await:t}},C(A.prototype),A.prototype[s]=function(){return this},c.AsyncIterator=A,c.async=function(t,e,n,r){var i=new A(w(t,e,n,r));return c.isGeneratorFunction(e)?i:i.next().then(function(t){return t.done?t.value:i.next()})},C(m),m[l]=\"Generator\",m[o]=function(){return this},m.toString=function(){return\"[object Generator]\"},c.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},c.values=O,T.prototype={constructor:T,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=n,this.done=!1,this.delegate=null,this.method=\"next\",this.arg=n,this.tryEntries.forEach(I),!t)for(var e in this)\"t\"===e.charAt(0)&&i.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=n)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if(\"throw\"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,i){return s.type=\"throw\",s.arg=t,e.next=r,i&&(e.method=\"next\",e.arg=n),!!i}for(var a=this.tryEntries.length-1;a>=0;--a){var o=this.tryEntries[a],s=o.completion;if(\"root\"===o.tryLoc)return r(\"end\");if(o.tryLoc<=this.prev){var l=i.call(o,\"catchLoc\"),u=i.call(o,\"finallyLoc\");if(l&&u){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(l){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!u)throw new Error(\"try statement without catch or finally\");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&i.call(r,\"finallyLoc\")&&this.prev<r.finallyLoc){var a=r;break}}a&&(\"break\"===t||\"continue\"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method=\"next\",this.next=a.finallyLoc,g):this.complete(o)},complete:function(t,e){if(\"throw\"===t.type)throw t.arg;return\"break\"===t.type||\"continue\"===t.type?this.next=t.arg:\"return\"===t.type?(this.rval=this.arg=t.arg,this.method=\"return\",this.next=\"end\"):\"normal\"===t.type&&e&&(this.next=e),g},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),I(n),g}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if(\"throw\"===r.type){var i=r.arg;I(n)}return i}}throw new Error(\"illegal catch attempt\")},delegateYield:function(t,e,r){return this.delegate={iterator:O(t),resultName:e,nextLoc:r},\"next\"===this.method&&(this.arg=n),g}}}function w(t,e,n,r){var i,a,o,s,l=e&&e.prototype instanceof S?e:S,u=Object.create(l.prototype),c=new T(r||[]);return u._invoke=(i=t,a=n,o=c,s=h,function(t,e){if(s===d)throw new Error(\"Generator is already running\");if(s===p){if(\"throw\"===t)throw e;return L()}for(o.method=t,o.arg=e;;){var n=o.delegate;if(n){var r=P(n,o);if(r){if(r===g)continue;return r}}if(\"next\"===o.method)o.sent=o._sent=o.arg;else if(\"throw\"===o.method){if(s===h)throw s=p,o.arg;o.dispatchException(o.arg)}else\"return\"===o.method&&o.abrupt(\"return\",o.arg);s=d;var l=x(i,a,o);if(\"normal\"===l.type){if(s=o.done?p:f,l.arg===g)continue;return{value:l.arg,done:o.done}}\"throw\"===l.type&&(s=p,o.method=\"throw\",o.arg=l.arg)}}),u}function x(t,e,n){try{return{type:\"normal\",arg:t.call(e,n)}}catch(t){return{type:\"throw\",arg:t}}}function S(){}function _(){}function k(){}function C(t){[\"next\",\"throw\",\"return\"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function A(t){var e;this._invoke=function(n,r){function a(){return new Promise(function(e,a){!function e(n,r,a,o){var s=x(t[n],t,r);if(\"throw\"!==s.type){var l=s.arg,u=l.value;return u&&\"object\"==typeof u&&i.call(u,\"__await\")?Promise.resolve(u.__await).then(function(t){e(\"next\",t,a,o)},function(t){e(\"throw\",t,a,o)}):Promise.resolve(u).then(function(t){l.value=t,a(l)},o)}o(s.arg)}(n,r,e,a)})}return e=e?e.then(a,a):a()}}function P(t,e){var r=t.iterator[e.method];if(r===n){if(e.delegate=null,\"throw\"===e.method){if(t.iterator.return&&(e.method=\"return\",e.arg=n,P(t,e),\"throw\"===e.method))return g;e.method=\"throw\",e.arg=new TypeError(\"The iterator does not provide a 'throw' method\")}return g}var i=x(r,t.iterator,e.arg);if(\"throw\"===i.type)return e.method=\"throw\",e.arg=i.arg,e.delegate=null,g;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,\"return\"!==e.method&&(e.method=\"next\",e.arg=n),e.delegate=null,g):a:(e.method=\"throw\",e.arg=new TypeError(\"iterator result is not an object\"),e.delegate=null,g)}function E(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function I(t){var e=t.completion||{};e.type=\"normal\",delete e.arg,t.completion=e}function T(t){this.tryEntries=[{tryLoc:\"root\"}],t.forEach(E,this),this.reset(!0)}function O(t){if(t){var e=t[o];if(e)return e.call(t);if(\"function\"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,a=function e(){for(;++r<t.length;)if(i.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=n,e.done=!0,e};return a.next=a}}return{next:L}}function L(){return{value:n,done:!0}}}(function(){return this}()||Function(\"return this\")())},function(t,e,n){t.exports={default:n(281),__esModule:!0}},function(t,e,n){n(282),t.exports=Math.pow(2,-52)},function(t,e,n){var r=n(3);r(r.S,\"Number\",{EPSILON:Math.pow(2,-52)})},function(t,e,n){(function(e){var n=function(){\"use strict\";function t(n,i,a,o){\"object\"==typeof i&&(a=i.depth,o=i.prototype,i.filter,i=i.circular);var s=[],l=[],u=void 0!==e;return void 0===i&&(i=!0),void 0===a&&(a=1/0),function n(a,c){if(null===a)return null;if(0==c)return a;var h,f;if(\"object\"!=typeof a)return a;if(t.__isArray(a))h=[];else if(t.__isRegExp(a))h=new RegExp(a.source,r(a)),a.lastIndex&&(h.lastIndex=a.lastIndex);else if(t.__isDate(a))h=new Date(a.getTime());else{if(u&&e.isBuffer(a))return h=new e(a.length),a.copy(h),h;void 0===o?(f=Object.getPrototypeOf(a),h=Object.create(f)):(h=Object.create(o),f=o)}if(i){var d=s.indexOf(a);if(-1!=d)return l[d];s.push(a),l.push(h)}for(var p in a){var g;f&&(g=Object.getOwnPropertyDescriptor(f,p)),g&&null==g.set||(h[p]=n(a[p],c-1))}return h}(n,a)}function n(t){return Object.prototype.toString.call(t)}function r(t){var e=\"\";return t.global&&(e+=\"g\"),t.ignoreCase&&(e+=\"i\"),t.multiline&&(e+=\"m\"),e}return t.clonePrototype=function(t){if(null===t)return null;var e=function(){};return e.prototype=t,new e},t.__objToStr=n,t.__isDate=function(t){return\"object\"==typeof t&&\"[object Date]\"===n(t)},t.__isArray=function(t){return\"object\"==typeof t&&\"[object Array]\"===n(t)},t.__isRegExp=function(t){return\"object\"==typeof t&&\"[object RegExp]\"===n(t)},t.__getRegExpFlags=r,t}();\"object\"==typeof t&&t.exports&&(t.exports=n)}).call(e,n(1).Buffer)},function(t,e,n){t.exports=n(117).BrotliDecompressBuffer},function(t,e){var n=8224,r=new Uint32Array([0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215]);function i(t){this.buf_=new Uint8Array(n),this.input_=t,this.reset()}i.READ_SIZE=4096,i.IBUF_MASK=8191,i.prototype.reset=function(){this.buf_ptr_=0,this.val_=0,this.pos_=0,this.bit_pos_=0,this.bit_end_pos_=0,this.eos_=0,this.readMoreInput();for(var t=0;t<4;t++)this.val_|=this.buf_[this.pos_]<<8*t,++this.pos_;return this.bit_end_pos_>0},i.prototype.readMoreInput=function(){if(!(this.bit_end_pos_>256))if(this.eos_){if(this.bit_pos_>this.bit_end_pos_)throw new Error(\"Unexpected end of input \"+this.bit_pos_+\" \"+this.bit_end_pos_)}else{var t=this.buf_ptr_,e=this.input_.read(this.buf_,t,4096);if(e<0)throw new Error(\"Unexpected end of input\");if(e<4096){this.eos_=1;for(var n=0;n<32;n++)this.buf_[t+e+n]=0}if(0===t){for(n=0;n<32;n++)this.buf_[8192+n]=this.buf_[n];this.buf_ptr_=4096}else this.buf_ptr_=0;this.bit_end_pos_+=e<<3}},i.prototype.fillBitWindow=function(){for(;this.bit_pos_>=8;)this.val_>>>=8,this.val_|=this.buf_[8191&this.pos_]<<24,++this.pos_,this.bit_pos_=this.bit_pos_-8>>>0,this.bit_end_pos_=this.bit_end_pos_-8>>>0},i.prototype.readBits=function(t){32-this.bit_pos_<t&&this.fillBitWindow();var e=this.val_>>>this.bit_pos_&r[t];return this.bit_pos_+=t,e},t.exports=i},function(t,e,n){var r=n(287);n(8);e.init=function(){return(0,n(117).BrotliDecompressBuffer)(r.toByteArray(n(288)))}},function(t,e,n){\"use strict\";e.byteLength=function(t){return 3*t.length/4-u(t)},e.toByteArray=function(t){var e,n,r,o,s,l=t.length;o=u(t),s=new a(3*l/4-o),n=o>0?l-4:l;var c=0;for(e=0;e<n;e+=4)r=i[t.charCodeAt(e)]<<18|i[t.charCodeAt(e+1)]<<12|i[t.charCodeAt(e+2)]<<6|i[t.charCodeAt(e+3)],s[c++]=r>>16&255,s[c++]=r>>8&255,s[c++]=255&r;2===o?(r=i[t.charCodeAt(e)]<<2|i[t.charCodeAt(e+1)]>>4,s[c++]=255&r):1===o&&(r=i[t.charCodeAt(e)]<<10|i[t.charCodeAt(e+1)]<<4|i[t.charCodeAt(e+2)]>>2,s[c++]=r>>8&255,s[c++]=255&r);return s},e.fromByteArray=function(t){for(var e,n=t.length,i=n%3,a=\"\",o=[],s=0,l=n-i;s<l;s+=16383)o.push(c(t,s,s+16383>l?l:s+16383));1===i?(e=t[n-1],a+=r[e>>2],a+=r[e<<4&63],a+=\"==\"):2===i&&(e=(t[n-2]<<8)+t[n-1],a+=r[e>>10],a+=r[e>>4&63],a+=r[e<<2&63],a+=\"=\");return o.push(a),o.join(\"\")};for(var r=[],i=[],a=\"undefined\"!=typeof Uint8Array?Uint8Array:Array,o=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",s=0,l=o.length;s<l;++s)r[s]=o[s],i[o.charCodeAt(s)]=s;function u(t){var e=t.length;if(e%4>0)throw new Error(\"Invalid string. Length must be a multiple of 4\");return\"=\"===t[e-2]?2:\"=\"===t[e-1]?1:0}function c(t,e,n){for(var i,a,o=[],s=e;s<n;s+=3)i=(t[s]<<16&16711680)+(t[s+1]<<8&65280)+(255&t[s+2]),o.push(r[(a=i)>>18&63]+r[a>>12&63]+r[a>>6&63]+r[63&a]);return o.join(\"\")}i[\"-\".charCodeAt(0)]=62,i[\"_\".charCodeAt(0)]=63},function(t,e){t.exports=\"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\"},function(t,e){e.lookup=new Uint8Array([0,0,0,0,0,0,0,0,0,4,4,0,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,12,16,12,12,20,12,16,24,28,12,12,32,12,36,12,44,44,44,44,44,44,44,44,44,44,32,32,24,40,28,12,12,48,52,52,52,48,52,52,52,48,52,52,52,52,52,48,52,52,52,52,52,48,52,52,52,52,52,24,12,28,12,12,12,56,60,60,60,56,60,60,60,56,60,60,60,60,60,56,60,60,60,60,60,56,60,60,60,60,60,24,12,28,12,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,2,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,2,2,2,2,2,2,2,2,2,1,1,1,1,1,1,1,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,1,1,1,1,1,1,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,0,8,8,8,8,8,8,8,8,8,8,8,8,8,8,8,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,40,48,48,48,48,48,48,48,48,48,48,48,48,48,48,48,56,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,6,6,6,6,7,7,7,7,8,8,8,8,9,9,9,9,10,10,10,10,11,11,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,22,22,22,22,23,23,23,23,24,24,24,24,25,25,25,25,26,26,26,26,27,27,27,27,28,28,28,28,29,29,29,29,30,30,30,30,31,31,31,31,32,32,32,32,33,33,33,33,34,34,34,34,35,35,35,35,36,36,36,36,37,37,37,37,38,38,38,38,39,39,39,39,40,40,40,40,41,41,41,41,42,42,42,42,43,43,43,43,44,44,44,44,45,45,45,45,46,46,46,46,47,47,47,47,48,48,48,48,49,49,49,49,50,50,50,50,51,51,51,51,52,52,52,52,53,53,53,53,54,54,54,54,55,55,55,55,56,56,56,56,57,57,57,57,58,58,58,58,59,59,59,59,60,60,60,60,61,61,61,61,62,62,62,62,63,63,63,63,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]),e.lookupOffsets=new Uint16Array([1024,1536,1280,1536,0,256,768,512])},function(t,e){function n(t,e){this.offset=t,this.nbits=e}e.kBlockLengthPrefixCode=[new n(1,2),new n(5,2),new n(9,2),new n(13,2),new n(17,3),new n(25,3),new n(33,3),new n(41,3),new n(49,4),new n(65,4),new n(81,4),new n(97,4),new n(113,5),new n(145,5),new n(177,5),new n(209,5),new n(241,6),new n(305,6),new n(369,7),new n(497,8),new n(753,9),new n(1265,10),new n(2289,11),new n(4337,12),new n(8433,13),new n(16625,24)],e.kInsertLengthPrefixCode=[new n(0,0),new n(1,0),new n(2,0),new n(3,0),new n(4,0),new n(5,0),new n(6,1),new n(8,1),new n(10,2),new n(14,2),new n(18,3),new n(26,3),new n(34,4),new n(50,4),new n(66,5),new n(98,5),new n(130,6),new n(194,7),new n(322,8),new n(578,9),new n(1090,10),new n(2114,12),new n(6210,14),new n(22594,24)],e.kCopyLengthPrefixCode=[new n(2,0),new n(3,0),new n(4,0),new n(5,0),new n(6,0),new n(7,0),new n(8,0),new n(9,0),new n(10,1),new n(12,1),new n(14,2),new n(18,2),new n(22,3),new n(30,3),new n(38,4),new n(54,4),new n(70,5),new n(102,5),new n(134,6),new n(198,7),new n(326,8),new n(582,9),new n(1094,10),new n(2118,24)],e.kInsertRangeLut=[0,0,8,8,0,16,8,16,16],e.kCopyRangeLut=[0,8,0,8,16,0,16,8,16]},function(t,e,n){var r=n(119);function i(t,e,n){this.prefix=new Uint8Array(t.length),this.transform=e,this.suffix=new Uint8Array(n.length);for(var r=0;r<t.length;r++)this.prefix[r]=t.charCodeAt(r);for(r=0;r<n.length;r++)this.suffix[r]=n.charCodeAt(r)}var a=[new i(\"\",0,\"\"),new i(\"\",0,\" \"),new i(\" \",0,\" \"),new i(\"\",12,\"\"),new i(\"\",10,\" \"),new i(\"\",0,\" the \"),new i(\" \",0,\"\"),new i(\"s \",0,\" \"),new i(\"\",0,\" of \"),new i(\"\",10,\"\"),new i(\"\",0,\" and \"),new i(\"\",13,\"\"),new i(\"\",1,\"\"),new i(\", \",0,\" \"),new i(\"\",0,\", \"),new i(\" \",10,\" \"),new i(\"\",0,\" in \"),new i(\"\",0,\" to \"),new i(\"e \",0,\" \"),new i(\"\",0,'\"'),new i(\"\",0,\".\"),new i(\"\",0,'\">'),new i(\"\",0,\"\\n\"),new i(\"\",3,\"\"),new i(\"\",0,\"]\"),new i(\"\",0,\" for \"),new i(\"\",14,\"\"),new i(\"\",2,\"\"),new i(\"\",0,\" a \"),new i(\"\",0,\" that \"),new i(\" \",10,\"\"),new i(\"\",0,\". \"),new i(\".\",0,\"\"),new i(\" \",0,\", \"),new i(\"\",15,\"\"),new i(\"\",0,\" with \"),new i(\"\",0,\"'\"),new i(\"\",0,\" from \"),new i(\"\",0,\" by \"),new i(\"\",16,\"\"),new i(\"\",17,\"\"),new i(\" the \",0,\"\"),new i(\"\",4,\"\"),new i(\"\",0,\". The \"),new i(\"\",11,\"\"),new i(\"\",0,\" on \"),new i(\"\",0,\" as \"),new i(\"\",0,\" is \"),new i(\"\",7,\"\"),new i(\"\",1,\"ing \"),new i(\"\",0,\"\\n\\t\"),new i(\"\",0,\":\"),new i(\" \",0,\". \"),new i(\"\",0,\"ed \"),new i(\"\",20,\"\"),new i(\"\",18,\"\"),new i(\"\",6,\"\"),new i(\"\",0,\"(\"),new i(\"\",10,\", \"),new i(\"\",8,\"\"),new i(\"\",0,\" at \"),new i(\"\",0,\"ly \"),new i(\" the \",0,\" of \"),new i(\"\",5,\"\"),new i(\"\",9,\"\"),new i(\" \",10,\", \"),new i(\"\",10,'\"'),new i(\".\",0,\"(\"),new i(\"\",11,\" \"),new i(\"\",10,'\">'),new i(\"\",0,'=\"'),new i(\" \",0,\".\"),new i(\".com/\",0,\"\"),new i(\" the \",0,\" of the \"),new i(\"\",10,\"'\"),new i(\"\",0,\". This \"),new i(\"\",0,\",\"),new i(\".\",0,\" \"),new i(\"\",10,\"(\"),new i(\"\",10,\".\"),new i(\"\",0,\" not \"),new i(\" \",0,'=\"'),new i(\"\",0,\"er \"),new i(\" \",11,\" \"),new i(\"\",0,\"al \"),new i(\" \",11,\"\"),new i(\"\",0,\"='\"),new i(\"\",11,'\"'),new i(\"\",10,\". \"),new i(\" \",0,\"(\"),new i(\"\",0,\"ful \"),new i(\" \",10,\". \"),new i(\"\",0,\"ive \"),new i(\"\",0,\"less \"),new i(\"\",11,\"'\"),new i(\"\",0,\"est \"),new i(\" \",10,\".\"),new i(\"\",11,'\">'),new i(\" \",0,\"='\"),new i(\"\",10,\",\"),new i(\"\",0,\"ize \"),new i(\"\",11,\".\"),new i(\"Â \",0,\"\"),new i(\" \",0,\",\"),new i(\"\",10,'=\"'),new i(\"\",11,'=\"'),new i(\"\",0,\"ous \"),new i(\"\",11,\", \"),new i(\"\",10,\"='\"),new i(\" \",10,\",\"),new i(\" \",11,'=\"'),new i(\" \",11,\", \"),new i(\"\",11,\",\"),new i(\"\",11,\"(\"),new i(\"\",11,\". \"),new i(\" \",11,\".\"),new i(\"\",11,\"='\"),new i(\" \",11,\". \"),new i(\" \",10,'=\"'),new i(\" \",11,\"='\"),new i(\" \",10,\"='\")];function o(t,e){return t[e]<192?(t[e]>=97&&t[e]<=122&&(t[e]^=32),1):t[e]<224?(t[e+1]^=32,2):(t[e+2]^=5,3)}e.kTransforms=a,e.kNumTransforms=a.length,e.transformDictionaryWord=function(t,e,n,i,s){var l,u=a[s].prefix,c=a[s].suffix,h=a[s].transform,f=h<12?0:h-11,d=0,p=e;f>i&&(f=i);for(var g=0;g<u.length;)t[e++]=u[g++];for(n+=f,i-=f,h<=9&&(i-=h),d=0;d<i;d++)t[e++]=r.dictionary[n+d];if(l=e-i,10===h)o(t,l);else if(11===h)for(;i>0;){var y=o(t,l);l+=y,i-=y}for(var v=0;v<c.length;)t[e++]=c[v++];return e-p}},function(t,e,n){(function(e){(function(){var r,i,a,o,s={}.hasOwnProperty;r=n(293),i=n(50),o=n(8),a=function(t){var n;function a(t,e,i){var a;this.document=t,this.name=e,this.id=i,this.font=new r(n[this.name]()),a=this.font,this.ascender=a.ascender,this.descender=a.descender,this.bbox=a.bbox,this.lineGap=a.lineGap}return function(t,e){for(var n in e)s.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(a,i),a.prototype.embed=function(){return this.dictionary.data={Type:\"Font\",BaseFont:this.name,Subtype:\"Type1\",Encoding:\"WinAnsiEncoding\"},this.dictionary.end()},a.prototype.encode=function(t){var e,n,r,i,a,o,s,l;for(n=this.font.encodeText(t),i=this.font.glyphsForString(\"\"+t),e=this.font.advancesForGlyphs(i),l=[],a=o=0,s=i.length;o<s;a=++o)r=i[a],l.push({xAdvance:e[a],yAdvance:0,xOffset:0,yOffset:0,advanceWidth:this.font.widthOfGlyph(r)});return[n,l]},a.prototype.widthOfString=function(t,e){var n,r,i,a,o;for(r=this.font.glyphsForString(\"\"+t),o=0,i=0,a=(n=this.font.advancesForGlyphs(r)).length;i<a;i++)o+=n[i];return o*(e/1e3)},a.isStandardFont=function(t){return t in n},n={Courier:function(){return o.readFileSync(e+\"/../font/data/Courier.afm\",\"utf8\")},\"Courier-Bold\":function(){return o.readFileSync(e+\"/../font/data/Courier-Bold.afm\",\"utf8\")},\"Courier-Oblique\":function(){return o.readFileSync(e+\"/../font/data/Courier-Oblique.afm\",\"utf8\")},\"Courier-BoldOblique\":function(){return o.readFileSync(e+\"/../font/data/Courier-BoldOblique.afm\",\"utf8\")},Helvetica:function(){return o.readFileSync(e+\"/../font/data/Helvetica.afm\",\"utf8\")},\"Helvetica-Bold\":function(){return o.readFileSync(e+\"/../font/data/Helvetica-Bold.afm\",\"utf8\")},\"Helvetica-Oblique\":function(){return o.readFileSync(e+\"/../font/data/Helvetica-Oblique.afm\",\"utf8\")},\"Helvetica-BoldOblique\":function(){return o.readFileSync(e+\"/../font/data/Helvetica-BoldOblique.afm\",\"utf8\")},\"Times-Roman\":function(){return o.readFileSync(e+\"/../font/data/Times-Roman.afm\",\"utf8\")},\"Times-Bold\":function(){return o.readFileSync(e+\"/../font/data/Times-Bold.afm\",\"utf8\")},\"Times-Italic\":function(){return o.readFileSync(e+\"/../font/data/Times-Italic.afm\",\"utf8\")},\"Times-BoldItalic\":function(){return o.readFileSync(e+\"/../font/data/Times-BoldItalic.afm\",\"utf8\")},Symbol:function(){return o.readFileSync(e+\"/../font/data/Symbol.afm\",\"utf8\")},ZapfDingbats:function(){return o.readFileSync(e+\"/../font/data/ZapfDingbats.afm\",\"utf8\")}},a}(),t.exports=a}).call(this)}).call(e,\"/\")},function(t,e,n){(function(){var e,r;r=n(8),e=function(){var t,e;function n(t){var n,r;this.contents=t,this.attributes={},this.glyphWidths={},this.boundingBoxes={},this.kernPairs={},this.parse(),this.charWidths=function(){var t,n;for(n=[],r=t=0;t<=255;r=++t)n.push(this.glyphWidths[e[r]]);return n}.call(this),this.bbox=function(){var t,e,r,i;for(i=[],t=0,e=(r=this.attributes.FontBBox.split(/\\s+/)).length;t<e;t++)n=r[t],i.push(+n);return i}.call(this),this.ascender=+(this.attributes.Ascender||0),this.descender=+(this.attributes.Descender||0),this.lineGap=this.bbox[3]-this.bbox[1]-(this.ascender-this.descender)}return n.open=function(t){return new n(r.readFileSync(t,\"utf8\"))},n.prototype.parse=function(){var t,e,n,r,i,a,o,s,l,u;for(l=\"\",e=0,r=(s=this.contents.split(\"\\n\")).length;e<r;e++)if(a=(i=s[e]).match(/^Start(\\w+)/))l=a[1];else if(a=i.match(/^End(\\w+)/))l=\"\";else switch(l){case\"FontMetrics\":n=(a=i.match(/(^\\w+)\\s+(.*)/))[1],u=a[2],(t=this.attributes[n])?(Array.isArray(t)||(t=this.attributes[n]=[t]),t.push(u)):this.attributes[n]=u;break;case\"CharMetrics\":if(!/^CH?\\s/.test(i))continue;o=i.match(/\\bN\\s+(\\.?\\w+)\\s*;/)[1],this.glyphWidths[o]=+i.match(/\\bWX\\s+(\\d+)\\s*;/)[1];break;case\"KernPairs\":(a=i.match(/^KPX\\s+(\\.?\\w+)\\s+(\\.?\\w+)\\s+(-?\\d+)/))&&(this.kernPairs[a[1]+\"\\0\"+a[2]]=parseInt(a[3]))}},t={402:131,8211:150,8212:151,8216:145,8217:146,8218:130,8220:147,8221:148,8222:132,8224:134,8225:135,8226:149,8230:133,8364:128,8240:137,8249:139,8250:155,710:136,8482:153,338:140,339:156,732:152,352:138,353:154,376:159,381:142,382:158},n.prototype.encodeText=function(e){var n,r,i,a,o;for(o=[],r=i=0,a=e.length;0<=a?i<a:i>a;r=0<=a?++i:--i)n=e.charCodeAt(r),n=t[n]||n,o.push(n.toString(16));return o},n.prototype.glyphsForString=function(t){var e,n,r,i,a;for(n=[],r=i=0,a=t.length;0<=a?i<a:i>a;r=0<=a?++i:--i)e=t.charCodeAt(r),n.push(this.characterToGlyph(e));return n},n.prototype.characterToGlyph=function(n){return e[t[n]||n]||\".notdef\"},n.prototype.widthOfGlyph=function(t){return this.glyphWidths[t]||0},n.prototype.getKernPair=function(t,e){return this.kernPairs[t+\"\\0\"+e]||0},n.prototype.advancesForGlyphs=function(t){var e,n,r,i,a,o;for(e=[],n=r=0,a=t.length;r<a;n=++r)i=t[n],o=t[n+1],e.push(this.widthOfGlyph(i)+this.getKernPair(i,o));return e},e=\".notdef       .notdef        .notdef        .notdef\\n.notdef       .notdef        .notdef        .notdef\\n.notdef       .notdef        .notdef        .notdef\\n.notdef       .notdef        .notdef        .notdef\\n.notdef       .notdef        .notdef        .notdef\\n.notdef       .notdef        .notdef        .notdef\\n.notdef       .notdef        .notdef        .notdef\\n.notdef       .notdef        .notdef        .notdef\\n\\nspace         exclam         quotedbl       numbersign\\ndollar        percent        ampersand      quotesingle\\nparenleft     parenright     asterisk       plus\\ncomma         hyphen         period         slash\\nzero          one            two            three\\nfour          five           six            seven\\neight         nine           colon          semicolon\\nless          equal          greater        question\\n\\nat            A              B              C\\nD             E              F              G\\nH             I              J              K\\nL             M              N              O\\nP             Q              R              S\\nT             U              V              W\\nX             Y              Z              bracketleft\\nbackslash     bracketright   asciicircum    underscore\\n\\ngrave         a              b              c\\nd             e              f              g\\nh             i              j              k\\nl             m              n              o\\np             q              r              s\\nt             u              v              w\\nx             y              z              braceleft\\nbar           braceright     asciitilde     .notdef\\n\\nEuro          .notdef        quotesinglbase florin\\nquotedblbase  ellipsis       dagger         daggerdbl\\ncircumflex    perthousand    Scaron         guilsinglleft\\nOE            .notdef        Zcaron         .notdef\\n.notdef       quoteleft      quoteright     quotedblleft\\nquotedblright bullet         endash         emdash\\ntilde         trademark      scaron         guilsinglright\\noe            .notdef        zcaron         ydieresis\\n\\nspace         exclamdown     cent           sterling\\ncurrency      yen            brokenbar      section\\ndieresis      copyright      ordfeminine    guillemotleft\\nlogicalnot    hyphen         registered     macron\\ndegree        plusminus      twosuperior    threesuperior\\nacute         mu             paragraph      periodcentered\\ncedilla       onesuperior    ordmasculine   guillemotright\\nonequarter    onehalf        threequarters  questiondown\\n\\nAgrave        Aacute         Acircumflex    Atilde\\nAdieresis     Aring          AE             Ccedilla\\nEgrave        Eacute         Ecircumflex    Edieresis\\nIgrave        Iacute         Icircumflex    Idieresis\\nEth           Ntilde         Ograve         Oacute\\nOcircumflex   Otilde         Odieresis      multiply\\nOslash        Ugrave         Uacute         Ucircumflex\\nUdieresis     Yacute         Thorn          germandbls\\n\\nagrave        aacute         acircumflex    atilde\\nadieresis     aring          ae             ccedilla\\negrave        eacute         ecircumflex    edieresis\\nigrave        iacute         icircumflex    idieresis\\neth           ntilde         ograve         oacute\\nocircumflex   otilde         odieresis      divide\\noslash        ugrave         uacute         ucircumflex\\nudieresis     yacute         thorn          ydieresis\".split(/\\s+/),n}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e,r,i={}.hasOwnProperty,a=[].slice;r=n(50),n(26),e=function(t){var e;function n(t,e,n){this.document=t,this.font=e,this.id=n,this.subset=this.font.createSubset(),this.unicode=[[0]],this.widths=[this.font.getGlyph(0).advanceWidth],this.name=this.font.postscriptName,this.scale=1e3/this.font.unitsPerEm,this.ascender=this.font.ascent*this.scale,this.descender=this.font.descent*this.scale,this.lineGap=this.font.lineGap*this.scale,this.bbox=this.font.bbox,this.layoutCache=Object.create(null)}return function(t,e){for(var n in e)i.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(n,r),n.prototype.layoutRun=function(t,e){var n,r,i,a,o,s,l;for(n=r=0,a=(s=(l=this.font.layout(t,e)).positions).length;r<a;n=++r){for(i in o=s[n])o[i]*=this.scale;o.advanceWidth=l.glyphs[n].advanceWidth*this.scale}return l},n.prototype.layoutCached=function(t){var e,n;return(e=this.layoutCache[t])?e:(n=this.layoutRun(t),this.layoutCache[t]=n,n)},n.prototype.layout=function(t,e,n){var r,i,a,o,s,l,u;if(null==n&&(n=!1),e)return this.layoutRun(t,e);for(i=n?null:[],s=n?null:[],r=0,o=0,a=0;a<=t.length;)a===t.length&&o<a||\" \"===(l=t.charAt(a))||\"\\t\"===l?(u=this.layoutCached(t.slice(o,++a)),n||(i.push.apply(i,u.glyphs),s.push.apply(s,u.positions)),r+=u.advanceWidth,o=a):a++;return{glyphs:i,positions:s,advanceWidth:r}},n.prototype.encode=function(t,e){var n,r,i,a,o,s,l,u,c,h,f;for(o=(h=this.layout(t,e)).glyphs,c=h.positions,f=[],s=l=0,u=o.length;l<u;s=++l)a=o[s],i=this.subset.includeGlyph(a.id),f.push((\"0000\"+i.toString(16)).slice(-4)),null==(n=this.widths)[i]&&(n[i]=a.advanceWidth*this.scale),null==(r=this.unicode)[i]&&(r[i]=a.codePoints);return[f,c]},n.prototype.widthOfString=function(t,e,n){return this.layout(t,n,!0).advanceWidth*(e/1e3)},n.prototype.embed=function(){var t,e,n,r,i,a,o,s,l;return o=null!=this.subset.cff,a=this.document.ref(),o&&(a.data.Subtype=\"CIDFontType0C\"),this.subset.encodeStream().pipe(a),r=((null!=(l=this.font[\"OS/2\"])?l.sFamilyClass:void 0)||0)>>8,i=0,this.font.post.isFixedPitch&&(i|=1),1<=r&&r<=7&&(i|=2),i|=4,10===r&&(i|=8),this.font.head.macStyle.italic&&(i|=64),s=function(){var t,e;for(e=[],t=0;t<6;++t)e.push(String.fromCharCode(26*Math.random()+65));return e}().join(\"\")+\"+\"+this.font.postscriptName,t=this.font.bbox,n=this.document.ref({Type:\"FontDescriptor\",FontName:s,Flags:i,FontBBox:[t.minX*this.scale,t.minY*this.scale,t.maxX*this.scale,t.maxY*this.scale],ItalicAngle:this.font.italicAngle,Ascent:this.ascender,Descent:this.descender,CapHeight:(this.font.capHeight||this.font.ascent)*this.scale,XHeight:(this.font.xHeight||0)*this.scale,StemV:0}),o?n.data.FontFile3=a:n.data.FontFile2=a,n.end(),(e=this.document.ref({Type:\"Font\",Subtype:o?\"CIDFontType0\":\"CIDFontType2\",BaseFont:s,CIDSystemInfo:{Registry:new String(\"Adobe\"),Ordering:new String(\"Identity\"),Supplement:0},FontDescriptor:n,W:[0,this.widths]})).end(),this.dictionary.data={Type:\"Font\",Subtype:\"Type0\",BaseFont:s,Encoding:\"Identity-H\",DescendantFonts:[e],ToUnicode:this.toUnicodeCmap()},this.dictionary.end()},e=function(){var t,e;return e=1<=arguments.length?a.call(arguments,0):[],function(){var n,r,i;for(i=[],n=0,r=e.length;n<r;n++)t=e[n],i.push((\"0000\"+t.toString(16)).slice(-4));return i}().join(\"\")},n.prototype.toUnicodeCmap=function(){var t,n,r,i,a,o,s,l,u,c;for(t=this.document.ref(),i=[],a=0,s=(u=this.unicode).length;a<s;a++){for(r=[],o=0,l=(n=u[a]).length;o<l;o++)(c=n[o])>65535&&(c-=65536,r.push(e(c>>>10&1023|55296)),c=56320|1023&c),r.push(e(c));i.push(\"<\"+r.join(\" \")+\">\")}return t.end(\"/CIDInit /ProcSet findresource begin\\n12 dict begin\\nbegincmap\\n/CIDSystemInfo <<\\n  /Registry (Adobe)\\n  /Ordering (UCS)\\n  /Supplement 0\\n>> def\\n/CMapName /Adobe-Identity-UCS def\\n/CMapType 2 def\\n1 begincodespacerange\\n<0000><ffff>\\nendcodespacerange\\n1 beginbfrange\\n<0000> <\"+e(i.length-1)+\"> [\"+i.join(\" \")+\"]\\nendbfrange\\nendcmap\\nCMapName currentdict /CMap defineresource pop\\nend\\nend\"),t},n}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e,r;e=n(296),r=n(26).number,t.exports={initText:function(){return this.x=0,this.y=0,this._lineGap=0},lineGap:function(t){return this._lineGap=t,this},moveDown:function(t){return null==t&&(t=1),this.y+=this.currentLineHeight(!0)*t+this._lineGap,this},moveUp:function(t){return null==t&&(t=1),this.y-=this.currentLineHeight(!0)*t+this._lineGap,this},_text:function(t,n,r,i,a){var o,s,l,u;if(t=null==t?\"\":\"\"+t,(i=this._initOptions(n,r,i)).wordSpacing&&(t=t.replace(/\\s{2,}/g,\" \")),i.width)(u=this._wrapper)||(u=new e(this,i)).on(\"line\",a),this._wrapper=i.continued?u:null,this._textOptions=i.continued?i:null,u.wrap(t,i);else for(o=0,s=(l=t.split(\"\\n\")).length;o<s;o++)a(l[o],i);return this},text:function(t,e,n,r){return this._text(t,e,n,r,this._line.bind(this))},widthOfString:function(t,e){return null==e&&(e={}),this._font.widthOfString(t,this._fontSize,e.features)+(e.characterSpacing||0)*(t.length-1)},heightOfString:function(t,e){var n,r,i,a,o;return null==e&&(e={}),this,i=this.x,a=this.y,(e=this._initOptions(e)).height=Infinity,r=e.lineGap||this._lineGap||0,this._text(t,this.x,this.y,e,(o=this,function(t,e){return o.y+=o.currentLineHeight(!0)+r})),n=this.y-a,this.x=i,this.y=a,n},list:function(t,n,r,i,a){var o,s,l,u,c,h,f,d,p,g,y,v;return i=this._initOptions(n,r,i),d=Math.round(this._font.ascender/1e3*this._fontSize/2),p=i.bulletRadius||Math.round(this._font.ascender/1e3*this._fontSize/3),l=i.textIndent||5*p,u=i.bulletIndent||8*p,h=1,c=[],f=[],(o=function(t){var e,n,r,i,a;for(a=[],e=r=0,i=t.length;r<i;e=++r)n=t[e],Array.isArray(n)?(h++,o(n),a.push(h--)):(c.push(n),a.push(f.push(h)));return a})(t),(a=new e(this,i)).on(\"line\",this._line.bind(this)),h=1,s=0,a.on(\"firstLine\",(g=this,function(){var t,e;return(e=f[s++])!==h&&(t=u*(e-h),g.x+=t,a.lineWidth-=t,h=e),g.circle(g.x-l+p,g.y+d,p),g.fill()})),a.on(\"sectionStart\",(y=this,function(){var t;return t=l+u*(h-1),y.x+=t,a.lineWidth-=t})),a.on(\"sectionEnd\",(v=this,function(){var t;return t=l+u*(h-1),v.x-=t,a.lineWidth+=t})),a.wrap(c.join(\"\\n\"),i),this},_initOptions:function(t,e,n){var r,i,a;if(null==t&&(t={}),null==n&&(n={}),\"object\"==typeof t&&(n=t,t=null),n=function(){var t,e,r;for(t in e={},n)r=n[t],e[t]=r;return e}(),this._textOptions)for(r in i=this._textOptions)a=i[r],\"continued\"!==r&&null==n[r]&&(n[r]=a);return null!=t&&(this.x=t),null!=e&&(this.y=e),!1!==n.lineBreak&&null==n.width&&(n.width=this.page.width-this.x-this.page.margins.right),n.columns||(n.columns=0),null==n.columnGap&&(n.columnGap=18),n},_line:function(t,e,n){var r;return null==e&&(e={}),this._fragment(t,this.x,this.y,e),r=e.lineGap||this._lineGap||0,n?this.y+=this.currentLineHeight(!0)+r:this.x+=this.widthOfString(t)},_fragment:function(t,e,n,i){var a,o,s,l,u,c,h,f,d,p,g,y,v,b,m,w,x,S,_,k,C,A,P,E,I,T,O,L,B,M,R,F,D,z,N,U;if(0!==(t=(\"\"+t).replace(/\\n/g,\"\")).length){if(o=i.align||\"left\",N=i.wordSpacing||0,l=i.characterSpacing||0,i.width)switch(o){case\"right\":F=this.widthOfString(t.replace(/\\s+$/,\"\"),i),e+=i.lineWidth-F;break;case\"center\":e+=i.lineWidth/2-i.textWidth/2;break;case\"justify\":U=t.trim().split(/\\s+/),F=this.widthOfString(t.replace(/\\s+/g,\"\"),i),R=this.widthOfString(\" \")+l,N=Math.max(0,(i.lineWidth-F)/Math.max(1,U.length-1)-R)}if(L=i.textWidth+N*(i.wordCount-1)+l*(t.length-1),i.link&&this.link(e,n,L,this.currentLineHeight(),i.link),(i.underline||i.strike)&&(this.save(),i.stroke||this.strokeColor.apply(this,this._fillColor),x=this._fontSize<10?.5:Math.floor(this._fontSize/10),this.lineWidth(x),c=i.underline?1:2,S=n+this.currentLineHeight()/c,i.underline&&(S-=x),this.moveTo(e,S),this.lineTo(e+L,S),this.stroke(),this.restore()),this.save(),this.transform(1,0,0,-1,0,this.page.height),n=this.page.height-n-this._font.ascender/1e3*this._fontSize,null==(s=this.page.fonts)[C=this._font.id]&&(s[C]=this._font.ref()),this.addContent(\"BT\"),this.addContent(\"1 0 0 1 \"+r(e)+\" \"+r(n)+\" Tm\"),this.addContent(\"/\"+this._font.id+\" \"+r(this._fontSize)+\" Tf\"),(k=i.fill&&i.stroke?2:i.stroke?1:0)&&this.addContent(k+\" Tr\"),l&&this.addContent(r(l)+\" Tc\"),N)for(U=t.trim().split(/\\s+/),N+=this.widthOfString(\" \")+l,N*=1e3/this._fontSize,h=[],P=[],y=0,m=U.length;y<m;y++){for(v in z=U[y],f=(I=this._font.encode(z,i.features))[0],E=I[1],h.push.apply(h,f),P.push.apply(P,E),M={},T=P[P.length-1])D=T[v],M[v]=D;M.xAdvance+=N,P[P.length-1]=M}else O=this._font.encode(t,i.features),h=O[0],P=O[1];var W;for(B=this._fontSize/1e3,u=[],b=0,p=!1,a=function(t){var e,n;return b<t&&(n=h.slice(b,t).join(\"\"),e=P[t-1].xAdvance-P[t-1].advanceWidth,u.push(\"<\"+n+\"> \"+r(-e))),b=t},W=this,d=function(t){if(a(t),u.length>0)return W.addContent(\"[\"+u.join(\" \")+\"] TJ\"),u.length=0},g=_=0,w=P.length;_<w;g=++_)(A=P[g]).xOffset||A.yOffset?(d(g),this.addContent(\"1 0 0 1 \"+r(e+A.xOffset*B)+\" \"+r(n+A.yOffset*B)+\" Tm\"),d(g+1),p=!0):(p&&(this.addContent(\"1 0 0 1 \"+r(e)+\" \"+r(n)+\" Tm\"),p=!1),A.xAdvance-A.advanceWidth!=0&&a(g+1)),e+=A.xAdvance*B;return d(g),this.addContent(\"ET\"),this.restore()}}}}).call(this)},function(t,e,n){(function(){var e,r,i,a={}.hasOwnProperty;e=n(31).EventEmitter,r=n(78),i=function(t){function n(t,e){var n,r,i;this.document=t,this.indent=e.indent||0,this.characterSpacing=e.characterSpacing||0,this.wordSpacing=0===e.wordSpacing,this.columns=e.columns||1,this.columnGap=null!=(n=e.columnGap)?n:18,this.lineWidth=(e.width-this.columnGap*(this.columns-1))/this.columns,this.spaceLeft=this.lineWidth,this.startX=this.document.x,this.startY=this.document.y,this.column=1,this.ellipsis=e.ellipsis,this.continuedX=0,this.features=e.features,null!=e.height?(this.height=e.height,this.maxY=this.startY+e.height):this.maxY=this.document.page.maxY(),this.on(\"firstLine\",(r=this,function(t){var e;return e=r.continuedX||r.indent,r.document.x+=e,r.lineWidth-=e,r.once(\"line\",function(){if(r.document.x-=e,r.lineWidth+=e,t.continued&&!r.continuedX&&(r.continuedX=r.indent),!t.continued)return r.continuedX=0})})),this.on(\"lastLine\",(i=this,function(t){var e;return\"justify\"===(e=t.align)&&(t.align=\"left\"),i.lastLine=!0,i.once(\"line\",function(){return i.document.y+=t.paragraphGap||0,t.align=e,i.lastLine=!1})}))}return function(t,e){for(var n in e)a.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype}(n,e),n.prototype.wordWidth=function(t){return this.document.widthOfString(t,this)+this.characterSpacing+this.wordSpacing},n.prototype.eachWord=function(t,e){var n,i,a,o,s,l,u,c,h,f;for(i=new r(t),s=null,f=Object.create(null);n=i.nextBreak();){if((c=null!=f[h=t.slice((null!=s?s.position:void 0)||0,n.position)]?f[h]:f[h]=this.wordWidth(h))>this.lineWidth+this.continuedX)for(l=s,a={};h.length;){for(o=h.length;c>this.spaceLeft;)c=this.wordWidth(h.slice(0,--o));if(a.required=o<h.length,u=e(h.slice(0,o),c,a,l),l={required:!1},h=h.slice(o),c=this.wordWidth(h),!1===u)break}else u=e(h,c,n,s);if(!1===u)break;s=n}},n.prototype.wrap=function(t,e){var n,r,i,a,o,s,l,u,c;return null!=e.indent&&(this.indent=e.indent),null!=e.characterSpacing&&(this.characterSpacing=e.characterSpacing),null!=e.wordSpacing&&(this.wordSpacing=e.wordSpacing),null!=e.ellipsis&&(this.ellipsis=e.ellipsis),a=this.document.y+this.document.currentLineHeight(!0),(this.document.y>this.maxY||a>this.maxY)&&this.nextSection(),n=\"\",o=0,s=0,i=0,l=this.document.y,u=this,r=function(){return e.textWidth=o+u.wordSpacing*(s-1),e.wordCount=s,e.lineWidth=u.lineWidth,l=u.document.y,u.emit(\"line\",n,e,u),i++},this.emit(\"sectionStart\",e,this),this.eachWord(t,(c=this,function(t,i,a,l){var u;if((null==l||l.required)&&(c.emit(\"firstLine\",e,c),c.spaceLeft=c.lineWidth),i<=c.spaceLeft&&(n+=t,o+=i,s++),a.required||i>c.spaceLeft){if(a.required&&c.emit(\"lastLine\",e,c),u=c.document.currentLineHeight(!0),null!=c.height&&c.ellipsis&&c.document.y+2*u>c.maxY&&c.column>=c.columns){for(!0===c.ellipsis&&(c.ellipsis=\"…\"),n=n.replace(/\\s+$/,\"\"),o=c.wordWidth(n+c.ellipsis);o>c.lineWidth;)n=n.slice(0,-1).replace(/\\s+$/,\"\"),o=c.wordWidth(n+c.ellipsis);n+=c.ellipsis}return a.required&&i>c.spaceLeft&&(n=t,o=i,s=1),r(),c.document.y+u>c.maxY&&!c.nextSection()?(s=0,n=\"\",!1):a.required?(c.spaceLeft=c.lineWidth,n=\"\",o=0,s=0):(c.spaceLeft=c.lineWidth-i,n=t,o=i,s=1)}return c.spaceLeft-=i})),s>0&&(this.emit(\"lastLine\",e,this),r()),this.emit(\"sectionEnd\",e,this),!0===e.continued?(i>1&&(this.continuedX=0),this.continuedX+=e.textWidth,this.document.y=l):this.document.x=this.startX},n.prototype.nextSection=function(t){var e;if(this.emit(\"sectionEnd\",t,this),++this.column>this.columns){if(null!=this.height)return!1;this.document.addPage(),this.column=1,this.startY=this.document.page.margins.top,this.maxY=this.document.page.maxY(),this.document.x=this.startX,this.document._fillColor&&(e=this.document).fillColor.apply(e,this.document._fillColor),this.emit(\"pageBreak\",t,this)}else this.document.x+=this.lineWidth+this.columnGap,this.document.y=this.startY,this.emit(\"columnBreak\",t,this);return this.emit(\"sectionStart\",t,this),!0},n}(),t.exports=i}).call(this)},function(t,e,n){(function(){var e;e=n(121),t.exports={initImages:function(){return this._imageRegistry={},this._imageCount=0},image:function(t,e,n,r){var i,a,o,s,l,u,c,h,f,d,p,g,y,v,b;return null==r&&(r={}),\"object\"==typeof e&&(r=e,e=null),e=null!=(d=null!=e?e:r.x)?d:this.x,n=null!=(p=null!=n?n:r.y)?p:this.y,\"string\"==typeof t&&(c=this._imageRegistry[t]),c||(c=t.width&&t.height?t:this.openImage(t)),c.obj||c.embed(this),null==(i=this.page.xobjects)[f=c.label]&&(i[f]=c.obj),v=r.width||c.width,l=r.height||c.height,r.width&&!r.height?(b=v/c.width,v=c.width*b,l=c.height*b):r.height&&!r.width?(u=l/c.height,v=c.width*u,l=c.height*u):r.scale?(v=c.width*r.scale,l=c.height*r.scale):r.fit?(o=(s=(g=r.fit)[0])/(a=g[1]),(h=c.width/c.height)>o?(v=s,l=s/h):(l=a,v=a*h)):r.cover&&(o=(s=(y=r.cover)[0])/(a=y[1]),(h=c.width/c.height)>o?(l=a,v=a*h):(v=s,l=s/h)),(r.fit||r.cover)&&(\"center\"===r.align?e=e+s/2-v/2:\"right\"===r.align&&(e=e+s-v),\"center\"===r.valign?n=n+a/2-l/2:\"bottom\"===r.valign&&(n=n+a-l)),this.y===n&&(this.y+=l),this.save(),this.transform(v,0,0,-l,e,n+l),this.addContent(\"/\"+c.label+\" Do\"),this.restore(),this},openImage:function(t){var n;return\"string\"==typeof t&&(n=this._imageRegistry[t]),n||(n=e.open(t,\"I\"+ ++this._imageCount),\"string\"==typeof t&&(this._imageRegistry[t]=n)),n}}}).call(this)},function(t,e){(function(){var e;e=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.byteAt=function(t){return this.data[t]},t.prototype.readBool=function(){return!!this.readByte()},t.prototype.writeBool=function(t){return this.writeByte(t?1:0)},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return(t=this.readUInt32())>=2147483648?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return(t=this.readUInt16())>=32768?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t;0<=r?n<r:n>r;e=0<=r?++n:--n)i[e]=String.fromCharCode(this.readByte());return i.join(\"\")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:n>r;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.stringAt=function(t,e){return this.pos=t,this.readString(e)},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,a,o,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*a+256*o+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.slice=function(t,e){return this.data.slice(t,e)},t.prototype.read=function(t){var e,n,r;for(e=[],n=0,r=t;0<=r?n<r:n>r;0<=r?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),t.exports=e}).call(this)},function(t,e,n){(function(){var e,r=[].indexOf||function(t){for(var e=0,n=this.length;e<n;e++)if(e in this&&this[e]===t)return e;return-1};n(8),e=function(){var t;function e(e,n){var i,a,o;if(this.data=e,this.label=n,65496!==this.data.readUInt16BE(0))throw\"SOI not found in JPEG\";for(o=2;o<this.data.length&&(a=this.data.readUInt16BE(o),o+=2,!(r.call(t,a)>=0));)o+=this.data.readUInt16BE(o);if(r.call(t,a)<0)throw\"Invalid JPEG.\";o+=2,this.bits=this.data[o++],this.height=this.data.readUInt16BE(o),o+=2,this.width=this.data.readUInt16BE(o),o+=2,i=this.data[o++],this.colorSpace=function(){switch(i){case 1:return\"DeviceGray\";case 3:return\"DeviceRGB\";case 4:return\"DeviceCMYK\"}}(),this.obj=null}return t=[65472,65473,65474,65475,65477,65478,65479,65480,65481,65482,65483,65484,65485,65486,65487],e.prototype.embed=function(t){if(!this.obj)return this.obj=t.ref({Type:\"XObject\",Subtype:\"Image\",BitsPerComponent:this.bits,Width:this.width,Height:this.height,ColorSpace:this.colorSpace,Filter:\"DCTDecode\"}),\"DeviceCMYK\"===this.colorSpace&&(this.obj.data.Decode=[1,0,1,0,1,0,1,0]),this.obj.end(this.data),this.data=null},e}(),t.exports=e}).call(this)},function(t,e,n){(function(e){(function(){var r,i,a;a=n(48),r=n(301),i=function(){function t(t,e){this.label=e,this.image=new r(t),this.width=this.image.width,this.height=this.image.height,this.imgData=this.image.imgData,this.obj=null}return t.prototype.embed=function(t){var n,r,i,a,o,s,l,u;if(this.document=t,!this.obj){if(this.obj=this.document.ref({Type:\"XObject\",Subtype:\"Image\",BitsPerComponent:this.image.bits,Width:this.width,Height:this.height,Filter:\"FlateDecode\"}),this.image.hasAlphaChannel||(o=this.document.ref({Predictor:15,Colors:this.image.colors,BitsPerComponent:this.image.bits,Columns:this.width}),this.obj.data.DecodeParms=o,o.end()),0===this.image.palette.length?this.obj.data.ColorSpace=this.image.colorSpace:((a=this.document.ref()).end(new e(this.image.palette)),this.obj.data.ColorSpace=[\"Indexed\",\"DeviceRGB\",this.image.palette.length/3-1,a]),this.image.transparency.grayscale)return l=this.image.transparency.greyscale,this.obj.data.Mask=[l,l];if(this.image.transparency.rgb){for(i=[],n=0,r=(s=this.image.transparency.rgb).length;n<r;n++)u=s[n],i.push(u,u);return this.obj.data.Mask=i}return this.image.transparency.indexed?this.loadIndexedAlphaChannel():this.image.hasAlphaChannel?this.splitAlphaChannel():this.finalize()}},t.prototype.finalize=function(){var t;return this.alphaChannel&&((t=this.document.ref({Type:\"XObject\",Subtype:\"Image\",Height:this.height,Width:this.width,BitsPerComponent:8,Filter:\"FlateDecode\",ColorSpace:\"DeviceGray\",Decode:[0,1]})).end(this.alphaChannel),this.obj.data.SMask=t),this.obj.end(this.imgData),this.image=null,this.imgData=null},t.prototype.splitAlphaChannel=function(){return this.image.decodePixels((t=this,function(n){var r,i,o,s,l,u,c,h,f;for(o=t.image.colors*t.image.bits/8,f=t.width*t.height,u=new e(f*o),i=new e(f),l=h=r=0,c=n.length;l<c;)u[h++]=n[l++],u[h++]=n[l++],u[h++]=n[l++],i[r++]=n[l++];return s=0,a.deflate(u,function(e,n){if(t.imgData=n,e)throw e;if(2==++s)return t.finalize()}),a.deflate(i,function(e,n){if(t.alphaChannel=n,e)throw e;if(2==++s)return t.finalize()})}));var t},t.prototype.loadIndexedAlphaChannel=function(t){var n,r;return n=this.image.transparency.indexed,this.image.decodePixels((r=this,function(t){var i,o,s,l,u;for(i=new e(r.width*r.height),o=0,s=l=0,u=t.length;l<u;s=l+=1)i[o++]=n[t[s]];return a.deflate(i,function(t,e){if(r.alphaChannel=e,t)throw t;return r.finalize()})}))},t}(),t.exports=i}).call(this)}).call(e,n(1).Buffer)},function(t,e,n){(function(e){(function(){var r,i;r=n(8),i=n(48),t.exports=function(){function t(t){var n,r,i,a,o,s,l,u,c;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.text={};;){switch(n=this.readUInt32(),function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join(\"\")){case\"IHDR\":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case\"PLTE\":this.palette=this.read(n);break;case\"IDAT\":for(l=0;l<n;l+=1)this.imgData.push(this.data[this.pos++]);break;case\"tRNS\":switch(this.transparency={},this.colorType){case 3:if(this.transparency.indexed=this.read(n),(o=255-this.transparency.indexed.length)>0)for(u=0;0<=o?u<o:u>o;0<=o?++u:--u)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(n)[0];break;case 2:this.transparency.rgb=this.read(n)}break;case\"tEXt\":i=(s=this.read(n)).indexOf(0),a=String.fromCharCode.apply(String,s.slice(0,i)),this.text[a]=String.fromCharCode.apply(String,s.slice(i+1));break;case\"IEND\":return this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(c=this.colorType)||6===c,r=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*r,this.colorSpace=function(){switch(this.colors){case 1:return\"DeviceGray\";case 3:return\"DeviceRGB\"}}.call(this),void(this.imgData=new e(this.imgData));default:this.pos+=n}if(this.pos+=4,this.pos>this.data.length)throw new Error(\"Incomplete or corrupt PNG file\")}}return t.decode=function(e,n){return r.readFile(e,function(e,r){return new t(r).decode(function(t){return n(t)})})},t.load=function(e){return new t(r.readFileSync(e))},t.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},t.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},t.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},t.prototype.decodePixels=function(t){var n=this;return i.inflate(this.imgData,function(r,i){var a,o,s,l,u,c,h,f,d,p,g,y,v,b,m,w,x,S,_,k,C,A,P;if(r)throw r;for(w=(y=n.pixelBitlength/8)*n.width,v=new e(w*n.height),c=i.length,m=0,b=0,o=0;b<c;){switch(i[b++]){case 0:for(l=_=0;_<w;l=_+=1)v[o++]=i[b++];break;case 1:for(l=k=0;k<w;l=k+=1)a=i[b++],u=l<y?0:v[o-y],v[o++]=(a+u)%256;break;case 2:for(l=C=0;C<w;l=C+=1)a=i[b++],s=(l-l%y)/y,x=m&&v[(m-1)*w+s*y+l%y],v[o++]=(x+a)%256;break;case 3:for(l=A=0;A<w;l=A+=1)a=i[b++],s=(l-l%y)/y,u=l<y?0:v[o-y],x=m&&v[(m-1)*w+s*y+l%y],v[o++]=(a+Math.floor((u+x)/2))%256;break;case 4:for(l=P=0;P<w;l=P+=1)a=i[b++],s=(l-l%y)/y,u=l<y?0:v[o-y],0===m?x=S=0:(x=v[(m-1)*w+s*y+l%y],S=s&&v[(m-1)*w+(s-1)*y+l%y]),h=u+x-S,f=Math.abs(h-u),p=Math.abs(h-x),g=Math.abs(h-S),d=f<=p&&f<=g?u:p<=g?x:S,v[o++]=(a+d)%256;break;default:throw new Error(\"Invalid filter algorithm: \"+i[b-1])}m++}return t(v)})},t.prototype.decodePalette=function(){var t,n,r,i,a,o,s,l,u;for(r=this.palette,o=this.transparency.indexed||[],a=new e(o.length+r.length),i=0,r.length,t=0,n=s=0,l=r.length;s<l;n=s+=3)a[i++]=r[n],a[i++]=r[n+1],a[i++]=r[n+2],a[i++]=null!=(u=o[t++])?u:255;return a},t.prototype.copyToImageData=function(t,e){var n,r,i,a,o,s,l,u,c,h,f;if(r=this.colors,c=null,n=this.hasAlphaChannel,this.palette.length&&(c=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),u=(i=(null!=t?t.data:void 0)||t).length,o=c||e,a=s=0,1===r)for(;a<u;)l=c?4*e[a/4]:s,h=o[l++],i[a++]=h,i[a++]=h,i[a++]=h,i[a++]=n?o[l++]:255,s=l;else for(;a<u;)l=c?4*e[a/4]:s,i[a++]=o[l++],i[a++]=o[l++],i[a++]=o[l++],i[a++]=n?o[l++]:255,s=l},t.prototype.decode=function(t){var n,r=this;return n=new e(this.width*this.height*4),this.decodePixels(function(e){return r.copyToImageData(n,e),t(n)})},t}()}).call(this)}).call(e,n(1).Buffer)},function(t,e){(function(){t.exports={annotate:function(t,e,n,r,i){var a,o,s;for(a in i.Type=\"Annot\",i.Rect=this._convertRect(t,e,n,r),i.Border=[0,0,0],\"Link\"!==i.Subtype&&null==i.C&&(i.C=this._normalizeColor(i.color||[0,0,0])),delete i.color,\"string\"==typeof i.Dest&&(i.Dest=new String(i.Dest)),i)s=i[a],i[a[0].toUpperCase()+a.slice(1)]=s;return o=this.ref(i),this.page.annotations.push(o),o.end(),this},note:function(t,e,n,r,i,a){return null==a&&(a={}),a.Subtype=\"Text\",a.Contents=new String(i),a.Name=\"Comment\",null==a.color&&(a.color=[243,223,92]),this.annotate(t,e,n,r,a)},link:function(t,e,n,r,i,a){return null==a&&(a={}),a.Subtype=\"Link\",a.A=this.ref({S:\"URI\",URI:new String(i)}),a.A.end(),this.annotate(t,e,n,r,a)},_markup:function(t,e,n,r,i){var a,o,s,l,u;return null==i&&(i={}),o=(a=this._convertRect(t,e,n,r))[0],l=a[1],s=a[2],u=a[3],i.QuadPoints=[o,u,s,u,o,l,s,l],i.Contents=new String,this.annotate(t,e,n,r,i)},highlight:function(t,e,n,r,i){return null==i&&(i={}),i.Subtype=\"Highlight\",null==i.color&&(i.color=[241,238,148]),this._markup(t,e,n,r,i)},underline:function(t,e,n,r,i){return null==i&&(i={}),i.Subtype=\"Underline\",this._markup(t,e,n,r,i)},strike:function(t,e,n,r,i){return null==i&&(i={}),i.Subtype=\"StrikeOut\",this._markup(t,e,n,r,i)},lineAnnotation:function(t,e,n,r,i){return null==i&&(i={}),i.Subtype=\"Line\",i.Contents=new String,i.L=[t,this.page.height-e,n,this.page.height-r],this.annotate(t,e,n,r,i)},rectAnnotation:function(t,e,n,r,i){return null==i&&(i={}),i.Subtype=\"Square\",i.Contents=new String,this.annotate(t,e,n,r,i)},ellipseAnnotation:function(t,e,n,r,i){return null==i&&(i={}),i.Subtype=\"Circle\",i.Contents=new String,this.annotate(t,e,n,r,i)},textAnnotation:function(t,e,n,r,i,a){return null==a&&(a={}),a.Subtype=\"FreeText\",a.Contents=new String(i),a.DA=new String,this.annotate(t,e,n,r,a)},_convertRect:function(t,e,n,r){var i,a,o,s,l,u,c,h,f;return f=e,e+=r,h=t+n,i=(c=this._ctm)[0],a=c[1],o=c[2],s=c[3],[t=i*t+o*e+(l=c[4]),e=a*t+s*e+(u=c[5]),h=i*h+o*f+l,f=a*h+s*f+u]}}}).call(this)},function(t,e,n){\"use strict\";t.exports={\"4A0\":[4767.87,6740.79],\"2A0\":[3370.39,4767.87],A0:[2383.94,3370.39],A1:[1683.78,2383.94],A2:[1190.55,1683.78],A3:[841.89,1190.55],A4:[595.28,841.89],A5:[419.53,595.28],A6:[297.64,419.53],A7:[209.76,297.64],A8:[147.4,209.76],A9:[104.88,147.4],A10:[73.7,104.88],B0:[2834.65,4008.19],B1:[2004.09,2834.65],B2:[1417.32,2004.09],B3:[1000.63,1417.32],B4:[708.66,1000.63],B5:[498.9,708.66],B6:[354.33,498.9],B7:[249.45,354.33],B8:[175.75,249.45],B9:[124.72,175.75],B10:[87.87,124.72],C0:[2599.37,3676.54],C1:[1836.85,2599.37],C2:[1298.27,1836.85],C3:[918.43,1298.27],C4:[649.13,918.43],C5:[459.21,649.13],C6:[323.15,459.21],C7:[229.61,323.15],C8:[161.57,229.61],C9:[113.39,161.57],C10:[79.37,113.39],RA0:[2437.8,3458.27],RA1:[1729.13,2437.8],RA2:[1218.9,1729.13],RA3:[864.57,1218.9],RA4:[609.45,864.57],SRA0:[2551.18,3628.35],SRA1:[1814.17,2551.18],SRA2:[1275.59,1814.17],SRA3:[907.09,1275.59],SRA4:[637.8,907.09],EXECUTIVE:[521.86,756],FOLIO:[612,936],LEGAL:[612,1008],LETTER:[612,792],TABLOID:[792,1224]}},function(t,e,n){\"use strict\";(function(e){var r=n(121);function i(t,e){this.pdfKitDoc=t,this.imageDictionary=e||{}}i.prototype.measureImage=function(t){var n,i,a=this;if(this.pdfKitDoc._imageRegistry[t])n=this.pdfKitDoc._imageRegistry[t];else{i=\"I\"+ ++this.pdfKitDoc._imageCount;try{n=r.open(function(t){var n=a.imageDictionary[t];if(!n)return t;var r=n.indexOf(\"base64,\");if(r<0)return a.imageDictionary[t];return e.from(n.substring(r+7),\"base64\")}(t),i)}catch(t){n=null}if(null==n)throw\"invalid image, images dictionary should contain dataURL entries (or local file paths in node.js)\";n.embed(this.pdfKitDoc),this.pdfKitDoc._imageRegistry[t]=n}return{width:n.width,height:n.height}},t.exports=i}).call(e,n(1).Buffer)},function(t,e,n){\"use strict\";var r=n(0).isArray;function i(t,e,n,r){var i=t.inlines[0],a=function(){for(var e=0,n=0,r=t.inlines.length;n<r;n++)e=t.inlines[n].fontSize>e?n:e;return t.inlines[e]}(),o=function(){for(var e=0,n=0,r=t.inlines.length;n<r;n++)e+=t.inlines[n].width;return e}(),s=t.line.getAscenderHeight(),l=a.font.ascender/1e3*a.fontSize,u=a.height-l,c=.5+.12*Math.floor(Math.max(a.fontSize-8,0)/2);switch(t.decoration){case\"underline\":n+=s+.45*u;break;case\"overline\":n+=s-.85*l;break;case\"lineThrough\":n+=s-.25*l;break;default:throw\"Unkown decoration : \"+t.decoration}if(r.save(),\"double\"===t.decorationStyle){var h=Math.max(.5,2*c);r.fillColor(t.decorationColor).rect(e+i.x,n-c/2,o,c/2).fill().rect(e+i.x,n+h-c/2,o,c/2).fill()}else if(\"dashed\"===t.decorationStyle){var f=Math.ceil(o/6.8),d=e+i.x;r.rect(d,n,o,c).clip(),r.fillColor(t.decorationColor);for(var p=0;p<f;p++)r.rect(d,n-c/2,3.96,c).fill(),d+=6.8}else if(\"dotted\"===t.decorationStyle){var g=Math.ceil(o/(3*c)),y=e+i.x;r.rect(y,n,o,c).clip(),r.fillColor(t.decorationColor);for(var v=0;v<g;v++)r.rect(y,n-c/2,c,c).fill(),y+=3*c}else if(\"wavy\"===t.decorationStyle){var b=Math.ceil(o/1.4)+1,m=e+i.x-1;r.rect(e+i.x,n-1,o,n+1).clip(),r.lineWidth(.24),r.moveTo(m,n);for(var w=0;w<b;w++)r.bezierCurveTo(m+.7,n-1,m+1.4,n-1,m+.7*3,n).bezierCurveTo(m+2.8,n+1,m+3.5,n+1,m+.7*6,n),m+=.7*6;r.stroke(t.decorationColor)}else r.fillColor(t.decorationColor).rect(e+i.x,n-c/2,o,c).fill();r.restore()}t.exports={drawBackground:function(t,e,n,r){for(var i=t.getHeight(),a=0,o=t.inlines.length;a<o;a++){var s=t.inlines[a];if(s.background){var l=s.justifyShift||0;r.fillColor(s.background).rect(e+s.x-l,n,s.width+l,i).fill()}}},drawDecorations:function(t,e,n,a){for(var o=function(t){for(var e=[],n=null,i=0,a=t.inlines.length;i<a;i++){var o=t.inlines[i],s=o.decoration;if(s){r(s)||(s=[s]);for(var l=o.decorationColor||o.color||\"black\",u=o.decorationStyle||\"solid\",c=0,h=s.length;c<h;c++){var f=s[c];n&&f===n.decoration&&u===n.decorationStyle&&l===n.decorationColor&&\"lineThrough\"!==f?n.inlines.push(o):(n={line:t,decoration:f,decorationColor:l,decorationStyle:u,inlines:[o]},e.push(n))}}else n=null}return e}(t),s=0,l=o.length;s<l;s++)i(o[s],e,n,a)}}},function(t,e,n){var r,i=i||function(t){\"use strict\";if(!(void 0===t||\"undefined\"!=typeof navigator&&/MSIE [1-9]\\./.test(navigator.userAgent))){var e=t.document,n=function(){return t.URL||t.webkitURL||t},r=e?e.createElementNS(\"http://www.w3.org/1999/xhtml\",\"a\"):[],i=\"download\"in r,a=/constructor/i.test(t.HTMLElement)||t.safari,o=/CriOS\\/[\\d]+/.test(navigator.userAgent),s=function(e){(t.setImmediate||t.setTimeout)(function(){throw e},0)},l=function(t){setTimeout(function(){\"string\"==typeof t?n().revokeObjectURL(t):t.remove()},4e4)},u=function(t){return/^\\s*(?:text\\/\\S*|application\\/xml|\\S*\\/\\S*\\+xml)\\s*;.*charset\\s*=\\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},c=function(e,c,h){h||(e=u(e));var f,d=this,p=\"application/octet-stream\"===e.type,g=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t[\"on\"+e[r]];if(\"function\"==typeof i)try{i.call(t,n||t)}catch(t){s(t)}}}(d,\"writestart progress write writeend\".split(\" \"))};if(d.readyState=d.INIT,i)return f=n().createObjectURL(e),void setTimeout(function(){var t,e;r.href=f,r.download=c,t=r,e=new MouseEvent(\"click\"),t.dispatchEvent(e),g(),l(f),d.readyState=d.DONE});!function(){if((o||p&&a)&&t.FileReader){var r=new FileReader;return r.onloadend=function(){var e=o?r.result:r.result.replace(/^data:[^;]*;/,\"data:attachment/file;\");t.open(e,\"_blank\")||(t.location.href=e),e=void 0,d.readyState=d.DONE,g()},r.readAsDataURL(e),void(d.readyState=d.INIT)}f||(f=n().createObjectURL(e)),p?t.location.href=f:t.open(f,\"_blank\")||(t.location.href=f);d.readyState=d.DONE,g(),l(f)}()},h=c.prototype;return\"undefined\"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||\"download\",n||(t=u(t)),navigator.msSaveOrOpenBlob(t,e)}:(h.abort=function(){},h.readyState=h.INIT=0,h.WRITING=1,h.DONE=2,h.error=h.onwritestart=h.onprogress=h.onwrite=h.onabort=h.onerror=h.onwriteend=null,function(t,e,n){return new c(t,e||t.name||\"download\",n)})}}(\"undefined\"!=typeof self&&self||\"undefined\"!=typeof window&&window||this.content);void 0!==t&&t.exports?t.exports.saveAs=i:null!==n(307)&&null!==n(308)&&(void 0===(r=function(){return i}.call(e,n,e,t))||(t.exports=r))},function(t,e){t.exports=function(){throw new Error(\"define cannot be used indirect\")}},function(t,e){(function(e){t.exports=e}).call(e,{})}])});\n//# sourceMappingURL=pdfmake.min.js.map\n"

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1528))

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	module.exports = "this.pdfMake = this.pdfMake || {}; this.pdfMake.vfs = {\n  \"Roboto-Italic.ttf\": \"AAEAAAASAQAABAAgR0RFRtRX1FkAAgp8AAACREdQT1NKcuCzAAIMwAAAUiRHU1VCw4aZEQACXuQAABfoT1MvMqCnsO0AAAGoAAAAYGNtYXBAbb9DAAAafAAABoBjdnQgJEEG5QAAI5QAAABMZnBnbWf0XKsAACD8AAABvGdhc3AACAATAAIKcAAAAAxnbHlmoLsktAAALagAAdn2aGRteCEe/AUAABWQAAAE7GhlYWT4gasAAAABLAAAADZoaGVhDKYSegAAAWQAAAAkaG10eHJO1ygAAAIIAAATiGxvY2EXM5zBAAAj4AAACcZtYXhwBxICWwAAAYgAAAAgbmFtZTlLZFAAAgegAAACrnBvc3T/YQBkAAIKUAAAACBwcmVwdKCP7AAAIrgAAADbAAEAAAACAAAcadIiXw889QAbCAAAAAAAxPARLgAAAADQ206M+jj91QlMCHMAAgAJAAIAAAAAAAAAAQAAB2z+DAAACRb6OP52CUwIAAGzAAAAAAAAAAAAAAAABOIAAQAABOIAkAAWAFYABQABAAAAAAAOAAACAAFzAAYAAQADBAsBkAAFAAAFmgUzAAABHwWaBTMAAAPRAGYCAAAAAgAAAAAAAAAAAOAACv9QACF/AAAAIQAAAABHT09HAAEAAP/9BgD+AABmB5oCACAAAZ8AAAAABDoFsAAgACAAAgOWAGQACgAAAAoAAAH2AAAB9gAAAgkAQwKFAMgE0QBSBGYASgW5ALsE3QA6AWQAqgKxAG0Cvf+PA2IAawRwAEwBkP+PAi4AGQIVADUDPf+PBGYAaARmAPkEZgAXBGYANARmAAUEZgByBGYAcARmAJ0EZgBBBGYAlAHrACsBrv+bA/wAQQRMAHAEGAA6A7QApQcCAEQFGv+vBN8AOwUXAHQFIQA7BHMAOwRUADsFUwB5BZIAOwImAEkEUgAKBOcAOwQ3ADsG0AA7BZIAOwVgAHcE7wA7BWAAbwTRADoEpQAnBKsAqAUSAGcE+gCkBuwAwwTn/9QEswCoBK//6wIZ//8DOQC/Ahn/egNIAE8Div+BAnAAzwRDADMEZQAfBBoARgRqAEsEJgBFArwAdARlAAQEUAAfAewALwHk/xQD+QAgAewALwbXAB4EUgAfBHcARQRl/9cEcwBJAqoAHwQKAC4CkwBDBFEAWwPMAG4F3wCAA+P/xAO2/6UD4//tAqoAOAHuACECqv+MBVEAaQHu//EESABSBIz/8wWSABIEvQBTAeb/9wTM/90DSADbBiMAYgOCAMMDrgBZBFYAgQYkAGEDmADjAvAA6AQvACUC4gBcAuIAbgJ5ANUEb//lA9UAewIQAKUB9v/IAuIA3wORAMADrQAPBbkAuQYPALQGEwCeA7b/0wdL/4QELQAoBWAAIASgADgEpwAeBpcAEwSWAFwEeABEBG8AOQSD/+AFeQA1AfUALgRbAC0EOAAiAiIAIwVqADUEbwAkB3AAVAcWAEcB9wAzBWcAUQKu/0kFXgBnBHkAQgVvAGcE1wBaAf7/CQQhAD4DsQEXA3wBJgOZAOMDWgEHAewBDgKiAQECI/+vA7MA3QLvAMICUv/pAAr9agAK/esACv0LAAr99QAK/NsB6vy7AgcBIQP2APMCEQClBFsAQwWD/7EFUQBpBSD/xAR4AAwFkwBEBHj/2gWZAFQFaACGBTMACgRsAEgEo//wA+0AhARvAEMEOQApBA8AggRvACQEdQBzAo0AhQRW/7cD2AA/BKkAYARv/9wENgBOBG8ASgQWAIcERQBnBYIAQQV5AE8GbgBmBIcAUQQrAGcGIgBmBdsAoQVFAHgIWf/MCGwAQwZaALQFkgBCBO4ANAXg/4sHFf+sBKUAJQWSAEMFiP/KBOoAkwYHAFsFtgBBBVoAzgdXAEIHjgBCBe0AiQbAAEUE6AA2BUUAdAb6AEkE+//oBFQARgR5ADADSwAtBLn/jQX7/6UD+wAhBIUALwQ7AC8Ehv/IBcsAMASEAC8EhQAvA8QAYAWqAEwEowAvBEIAewZQAC8GdQAkBNsAVgYQADAEQQAwBDYANAZfADAETP+/BFAAHwQ2AE4Gn//DBrkALwRwAB8EhQAvBtwAbwYGAE8EPwAuBv4ASQXUACwEt/+6BC//ogbfAFoF5wBOBqcAJgW+ACkIyQBIB58ALgQN/84Dx//KBVEAaQRyAEIE7QCtA+4AhAVRAGoEbwBEBtUAdAX/AFIG3ABvBgYATwUUAGYEMABNBOEAQAAK/OgACv0LAAr+FwAK/jsACvo4AAr6TwQ/AC4E/gA6BHD/1wRLADUDfwAkBMAAQwPwACQE7AA2BGYALQZkALsFYwB0B50AOgWSACQH/ABCBskAJAXKAHEEuABfBv8ArAU9AFcFTwDEBFIAmAVQAOwGCgCKBKMABwTsADUEQwAtBZAAQwRvACQFZwBRBI4APASO//wEnf/4Azr/6QTaADEGawAyBrkATAYvAK0FDQBoBDIArwPyAKAHj//fBk3/2gfIADsGeAAjBNoAagQHAEwFiwCaBQMAfQVFAGoDEgDyA/8AAAf0AAAD/wAAB/QAAAKuAAACBAAAAVwAAARmAAACKQAAAZ8AAADVAAAACgAAAi0AGQItABkFIgCnBhkAmQOU/18BlwCuAZcAiQGV/5gBlwDUAsgAtgLPAJUCtv+UBFEAdwR2//YCpwCgA7EAOQU7ADkA+QAaB3kAlwJeAF8CXgACA5H/7wLiAGEDUAB+BIz/8wYuAAoGaAA5CD8AOgc0ACIGBgAfBGYAUQW3AEMEDABJBFwACgUp//IFMP/lBcQAzAO7AEsIBQA1BOUA6gT6AIIGAQC1BqwAkgalAI8GQwC+BHYATQVtACQElf+sBHkAqwSqAEEIBQBNAgb/GgRpADEETABwA/z/1AQZABkD8wBBAkQAeAKFAHAB/v/jBNcAdARWAFgEcgB0BqoAdAaqAHQE0gB0BnIAKQAKAAAH/v+rCDUAXAQKAGIEhQBBAff/DwGP/70DkgETA4wBEgONARED4ADNA/kAzgPfACID2wDSA5IBEQH4APwEbP+lBDkAHQRkAEcEZwAdA9IAHQO4AB0EkgBMBMcAHQHjACoDvP/2BD0AHQOiAB0F3gAdBMcAHQShAEoERQAdBKEARQQzAB0ECgARBBAAbQRkAEUETwB6BfAAlQQ9/7YEFQB0BA3/3ALiAB0C4gBrAuL/6QLi//sC4v/wAuIAFgLiAB4C4gAvAuIACwLiADYDhACTAqoBCwQk/5oEqABLBS0AQwUHAEQD/gAlBR8ARAP6ACUECgASBB0ABgQlADQDnQAdBE//sAShAEoET/+wA3j/0wSzAB0D2//VBUgAUQT6AH4E1gAMBVIAbARkAEcHE//EByEAHQVUAG0EsgAdBEIAHwUH/4kF5/+vBCgAEQTQAB8ENwAeBKb/xAQJAFgFCgAdBFIAWgYqAB0GgwAdBQAAUAXNAB8ENwAfBGMAIAZOAB0Ebv/fA/z/+gYh/68EYQAeBOwAHgUZAGkFoABQBEcAdASO/7YGOgBsBFIAWgRSAB0FoQAvBK8AQQQoABEEoQBKBB3//wPPAB4H7gAdBJH/3QRlAB8EHABDBHoARwRzACQDaACpBHT/1wSDAEYEJgBFBGUANQVhAIEFjACEBXIARAW9AIUFwACFA8IAuwRpADkDnQAdBEH/gQS0/9MC4gCQAuIAYQLiAIkC4gCRAuIAogLiAH4C4gCpBFP/1QQYACsGewBJBJ8APwTkAGQCAP8JAf//CQH2AC4B9v96AfYALgH2//EEOQAdAfYAAAIuABkFPwAvBT8ALwRuAD0EqwCoApP/9AUa/68FGv+vBRr/rwUa/68FGv+vBRr/rwUa/68FFwB0BHMAOwRzADsEcwA7BHMAOwImAEkCJgBJAiYASQImAEkFkgA7BWAAdwVgAHcFYAB3BWAAdwVgAHcFEgBnBRIAZwUSAGcFEgBnBLMAqARDADMEQwAzBEMAMwRDADMEQwAzBEMAMwRDADMEGgBGBCYARQQmAEUEJgBFBCYARQH1AC4B9QAuAfUALgH1AC4EUgAfBHcARQR3AEUEdwBFBHcARQR3AEUEUQBbBFEAWwRRAFsEUQBbA7b/pQO2/6UFGv+vBEMAMwUa/68EQwAzBRr/rwRDADMFFwB0BBoARgUXAHQEGgBGBRcAdAQaAEYFFwB0BBoARgUhADsFAABLBHMAOwQmAEUEcwA7BCYARQRzADsEJgBFBHMAOwQmAEUEcwA7BCYARQVTAHkEZQAEBVMAeQRlAAQFUwB5BGUABAVTAHkEZQAEBZIAOwRQAB8CJgBJAfUAEQImAEkB9QAaAiYASQH1AC4CJv+OAez/cAImAEkGeABJA9AALwRSAAoB/v8JBOcAOwP5ACAENwA7AewALwQ3ADsB7P+jBDcAOwKCAC8ENwA7AsgALwWSADsEUgAfBZIAOwRSAB8FkgA7BFIAHwRSAB8FYAB3BHcARQVgAHcEdwBFBWAAdwR3AEUE0QA6AqoAHwTRADoCqv+fBNEAOgKqAB8EpQAnBAoALgSlACcECgAuBKUAJwQKAC4EpQAnBAoALgSlACcECgAuBKsAqAKTAEMEqwCoApMAQwSrAKgCuwBDBRIAZwRRAFsFEgBnBFEAWwUSAGcEUQBbBRIAZwRRAFsFEgBnBFEAWwUSAGcEUQBbBuwAwwXfAIAEswCoA7b/pQSzAKgEr//rA+P/7QSv/+sD4//tBK//6wPj/+0HS/+EBpcAEwVgACAEbwA5BGf/sARn/7AEEABtBGz/pQRs/6UEbP+lBGz/pQRs/6UEbP+lBGz/pQRkAEcD0gAdA9IAHQPSAB0D0gAdAeMAKgHjACoB4wAqAeMAKgTHAB0EoQBKBKEASgShAEoEoQBKBKEASgRkAEUEZABFBGQARQRkAEUEFQB0BGz/pQRs/6UEbP+lBGQARwRkAEcEZABHBGQARwRnAB0D0gAdA9IAHQPSAB0D0gAdA9IAHQSSAEwEkgBMBJIATASSAEwExwAdAeMADwHjABgB4wAqAeP/egHjACoDvP/2BD0AHQOiAB0DogAdA6IAHQOiAB0ExwAdBMcAHQTHAB0EoQBKBKEASgShAEoEMwAdBDMAHQQzAB0ECgARBAoAEQQKABEECgARBBAAbQQQAG0EEABtBGQARQRkAEUEZABFBGQARQRkAEUEZABFBfAAlQQVAHQEFQB0BA3/3AQN/9wEDf/cBRr/rwTXAGMF9gBxAooAdwV0AGoFF//uBUcAHgKNACAFGv+vBN8AOwRzADsEr//rBZIAOwImAEkE5wA7BtAAOwWSADsFYAB3BO8AOwSrAKgEswCoBOf/1AImAEkEswCoBGwASAQ5ACkEbwAkAo0AhQRFAGcEWwAtBHcARQRv/+UDzABuA+P/xAKNAGcERQBnBHcARQRFAGcGbgBmBHMAOwRbAEMEpQAnAiYASQImAEkEUgAKBQcARATnADsE6gCTBRr/rwTfADsEWwBDBHMAOwWSAEMG0AA7BZIAOwVgAHcFkwBEBO8AOwUXAHQEqwCoBOf/1ARDADMEJgBFBIUALwR3AEUEZf/XBBoARgO2/6UD4//EBCYARQNLAC0ECgAuAewALwH1AC4B5P8UBDsALwO2/6UG7ADDBd8AgAbsAMMF3wCABuwAwwXfAIAEswCoA7b/pQFkAKoChQDIBBIAQwH+/wkBlwCJBtAAOwbXAB4FGv+vBEMAMwRzADsFkgBDBCYARQSFAC8FaACGBXkATwTtAK0D7gCECC0ARQkWAHcEpQAlA/sAIQUXAHQEGgBGBLMAqAPtAIQCJgBJBxX/rAX7/6UCJgBJBRr/rwRDADMFGv+vBEMAMwdL/4QGlwATBHMAOwQmAEUFZwBRBCEAPgQhAD4HFf+sBfv/pQSlACUD+wAhBZIAQwSFAC8FkgBDBIUALwVgAHcEdwBFBVEAaQRyAEIFUQBpBHIAQgVFAHQENgA0BOoAkwO2/6UE6gCTA7b/pQTqAJMDtv+lBVoAzgRCAHsGwABFBhAAMATn/9QD4//EBGoASwWI/8oEhv/IBRr/rwRDADMFGv+vBEMAMwUa/68EQwAzBRr/rwRDADMFGv+vBEMAMwUa/68EQwAzBRr/rwRDADMFGv+vBEMAMwUa/68EQwAzBRr/rwRDADMFGv+vBEMAMwUa/68EQwAzBHMAOwQmAEUEcwA7BCYARQRzADsEJgBFBHMAOwQmAEUEcwA7BCYARQRzADsEJgBFBHMAOwQmAEUEcwA7BCYARQImAEkB9QAuAiYADgHs//EFYAB3BHcARQVgAHcEdwBFBWAAdwR3AEUFYAB3BHcARQVgAHcEdwBFBWAAdwR3AEUFYAB3BHcARQVeAGcEeQBCBV4AZwR5AEIFXgBnBHkAQgVeAGcEeQBCBV4AZwR5AEIFEgBnBFEAWwUSAGcEUQBbBW8AZwTXAFoFbwBnBNcAWgVvAGcE1wBaBW8AZwTXAFoFbwBnBNcAWgSzAKgDtv+lBLMAqAO2/6UEswCoA7b/pQSIAEsEiAAABQcARAQ7AC8FkgA7BIQALwSrAKgDxABgBOf/1APj/8QFWgDOBEIAewVaAM4EQgB7BFsAQwNLAC0HFf+sBfv/pQYKAIoEowAHBFAAHwToACsE6AArBFsAEANL/+YFGwBYBBIAOQWSAEMEhQAvBZIAOwSEAC8G0AA7BcsAMAWI/8oEhv/IBLMAqAPtAF0E5//UA+P/xAQ5ACkEVP/XBhkAmQRmABcEZgA0BGYABQRmAHIEegCUBI4AfAVTAHkEZQAEBZIAOwRSAB8FGv+vBEMAMwRzADsEJgBFAib/3wH1/40FYAB3BHcARQTRADoCqgAfBRIAZwRRAFsEj/+yBN8AOwRlAB8FIQA7BGoASwUhADsEagBLBZIAOwRQAB8E5wA7A/kAIATnADsD+QAgBDcAOwHs//IG0AA7BtcAHgWSADsEUgAfBO8AOwRl/9cE0QA6Aqr/7gSlACcECgAuBKsAqAKTAEME+gCkA8wAbgT6AKQDzABuBuwAwwXfAIAEr//rA+P/7QWm/wwEbP+lBA7/4QUD//0CHwABBKsAHQRR/5sE4AAWBGz/pQQ5AB0D0gAdBA3/3ATHAB0B4wAqBD0AHQXeAB0EoQBKBEUAHQQQAG0EFQB0BD3/tgHjACoEFQB0A9IAHQOdAB0ECgARAeMAKgHjACoDvP/2BD0AHQQJAFgEbP+lBDkAHQOdAB0D0gAdBNAAHwXeAB0ExwAdBKEASgSzAB0ERQAdBGQARwQQAG0EPf+2BCgAEQTHAB0EZABIBBUAdAWhAC8E0AAfBAkAWAVIAFEFGv+vBEMAMwRzADsEJgBFAAAAAQAABOQJCgQAAAICAgMFBQYFAgMDBAUCAgIEBQUFBQUFBQUFBQICBAUFBAgGBQYGBQUGBgIFBgUIBgYGBgUFBQYGCAYFBQIEAgQEAwUFBQUFAwUFAgIEAggFBQUFAwUDBQQHBAQEAwIDBgIFBQYFAgUEBwQEBQcEAwUDAwMFBAICAwQEBgcHBAgFBgUFBwUFBQUGAgUFAgYFCAgCBgMGBQYFAgUEBAQEAgMCBAMDAAAAAAACAgQCBQYGBgUGBQYGBgUFBAUFBQUFAwUEBQUFBQUFBgYHBQUHBwYJCQcGBgcIBQYGBgcGBggJBwgGBggGBQUEBQcEBQUFBwUFBAYFBQcHBQcFBQcFBQUHCAUFCAcFCAcFBQgHBwYKCQUEBgUGBAYFCAcIBwYFBQAAAAAAAAUGBQUEBQQGBQcGCQYJCAcFCAYGBQYHBQYFBgUGBQUFBAUHCAcGBQQJBwkHBQUGBgYDBQkFCQMCAgUCAgEAAgIGBwQCAgICAwMDBQUDBAYBCAMDBAMEBQcHCQgHBQYFBQYGBgQJBgYHCAcHBQYFBQUJAgUFBAUEAwMCBQUFCAgFBwAJCQUFAgIEBAQEBAQEBAIFBQUFBAQFBQIEBQQHBQUFBQUFBQUFBwUFBQMDAwMDAwMDAwMEAwUFBgYEBgQFBQUEBQUFBAUEBgYFBgUICAYFBQYHBQUFBQUGBQcHBgcFBQcFBAcFBgYGBQUHBQUGBQUFBQQJBQUFBQUEBQUFBQYGBgYGBAUEBQUDAwMDAwMDBQUHBQYCAgICAgIFAgIGBgUFAwYGBgYGBgYGBQUFBQICAgIGBgYGBgYGBgYGBQUFBQUFBQUFBQUFBQICAgIFBQUFBQUFBQUFBAQGBQYFBgUGBQYFBgUGBQYGBQUFBQUFBQUFBQYFBgUGBQYFBgUCAgICAgICAgIHBAUCBgQFAgUCBQMFAwYFBgUGBQUGBQYFBgUFAwUDBQMFBQUFBQUFBQUFBQMFAwUDBgUGBQYFBgUGBQYFCAcFBAUFBAUEBQQIBwYFBQUFBQUFBQUFBQUEBAQEAgICAgUFBQUFBQUFBQUFBQUFBQUFBQUEBAQEBAUFBQUFAgICAgIEBQQEBAQFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBwUFBQUFBgUHAwYGBgMGBQUFBgIGCAYGBgUFBgIFBQUFAwUFBQUEBAMFBQUHBQUFAgIFBgYGBgUFBQYIBgYGBgYFBgUFBQUFBQQEBQQFAgICBQQIBwgHCAcFBAIDBQICCAgGBQUGBQUGBgYECQoFBAYFBQQCCAcCBgUGBQgHBQUGBQUIBwUEBgUGBQYFBgUGBQYFBgQGBAYEBgUIBwYEBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBQUFBQUFBQUFBQUFBQUFBQICAgIGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQUEBQQFBAUFBgUGBQUEBgQGBQYFBQQIBwcFBQYGBQQGBQYFBgUIBwYFBQQGBAUFBwUFBQUFBQYFBgUGBQUFAgIGBQUDBgUFBQUGBQYFBgUGBAYEBQIICAYFBgUFAwUFBQMGBAYECAcFBAYFBQYCBQUFBQUEBQUCBQcFBQUFBQIFBAQFAgIEBQUFBQQEBQcFBQUFBQUFBQUFBQYFBQYGBQUFAAAAAgAAAAMAAAAUAAMAAQAAABQABAZsAAAA6gCAAAYAagAAAAIADQB+AKAArACtAL8AxgDPAOYA7wD+AQ8BEQElAScBMAFTAV8BZwF+AX8BjwGSAaEBsAHwAf8CGwI3AlkCvALHAskC3QLzAwEDAwMJAw8DIwOKA4wDkgOhA7ADuQPJA84D0gPWBCUELwRFBE8EYgRvBHkEhgTOBNcE4QT1BQEFEAUTHgEePx6FHvEe8x75H00gCyARIBUgHiAiICcgMCAzIDogPCBEIHQgfyCkIKogrCCxILogvSEFIRMhFiEiISYhLiFeIgIiBiIPIhIiGiIeIisiSCJgImUlyu4C9sP7BP7///3//wAAAAAAAgANACAAoAChAK0ArgDAAMcA0ADnAPAA/wEQARIBJgEoATEBVAFgAWgBfwGPAZIBoAGvAfAB+gIYAjcCWQK8AsYCyQLYAvMDAAMDAwkDDwMjA4QDjAOOA5MDowOxA7oDygPRA9YEAAQmBDAERgRQBGMEcAR6BIgEzwTYBOIE9gUCBREeAB4+HoAeoB7yHvQfTSAAIBAgEyAXICAgJSAwIDIgOSA8IEQgdCB/IKMgpiCrILEguSC8IQUhEyEWISIhJiEuIVsiAiIGIg8iESIaIh4iKyJIImAiZCXK7gH2w/sB/v///P//AAEAAP/2/+QBpf/CAZn/wQAAAYwAAAGHAAABgwAAAYEAAAF/AAABdwAAAXn/Ff8G/wT+9/7qAbsAAAAA/mT+QwDw/df91v3I/bP9p/2m/aH9nP2JAAD/y//KAAAAAP0JAAD/q/z9/PoAAPy5AAD8sQAA/KYAAPygAAD+9QAA/vIAAPxJAADlr+Vv5SDlT+S05U3lXeFb4VcAAOFU4VPhUeFJ43bhQeNu4TjhCeD/AADg2gAA4NXgzuDN4IbgeeB34Gzfk+Bh4DXfkt6r34bfhd9+33vfb99T3zzfOdvVE58K3wajAqsBrwABAAAAAAAAAAAAAAAAAAAAAADaAAAA5AAAAQ4AAAEoAAABKAAAASgAAAFqAAAAAAAAAAAAAAAAAAABagF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWIAAAAAAWoBhgAAAZ4AAAAAAAABtgAAAf4AAAImAAACSAAAAlgAAALiAAAC8gAAAwYAAAAAAAAAAAAAAAAAAAAAAAAC+AAAAAAAAAAAAAAAAAAAAAAAAAAAAugAAALoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkwCTQJOAk8CUAJRAIECSAJcAl0CXgJfAmACYQCCAIMCYgJjAmQCZQJmAIQAhQJnAmgCaQJqAmsCbACGAIcCdwJ4AnkCegJ7AnwAiACJAn0CfgJ/AoACgQCKAkcERwCLAkkAjAKwArECsgKzArQCtQCNArYCtwK4ArkCugK7ArwCvQCOAI8CvgK/AsACwQLCAsMCxACQAJECxQLGAscCyALJAsoAkgCTAtkC2gLdAt4C3wLgAkoCSwJSAm0C+AL5AvoC+wLXAtgC2wLcAK0ArgNTAK8DVANVA1YAsACxA10DXgNfALIDYANhALMDYgNjALQDZAC1A2UAtgNmA2cAtwNoALgAuQNpA2oDawNsA20DbgNvA3AAwwNyA3MAxANxAMUAxgDHAMgAyQDKAMsDdADMAM0DsQN6ANEDewDSA3wDfQN+A38A0wDUANUDgQOyA4IA1gODANcDhAOFANgDhgDZANoA2wOHA4AA3AOIA4kDigOLA4wDjQOOAN0A3gOPA5AA6QDqAOsA7AORAO0A7gDvA5IA8ADxAPIA8wOTAPQDlAOVAPUDlgD2A5cDswOYAQEDmQECA5oDmwOcA50BAwEEAQUDngO0A58BBgEHAQgEXQO1A7YBFgEXARgBGQO3A7gDugO5AScBKARiBGMEXAEpASoBKwEsAS0EXgRfAS4BLwRXBFgDuwO8BEkESgEwATEEYARhATIBMwRLBEwBNAE1ATYBNwE4ATkDvQO+BE0ETgO/A8AEagRrBE8EUAE6ATsEUQRSATwBPQE+BFsBPwFABFkEWgPBA8IDwwFBAUIEaARpAUMBRARkBGUEUwRUBGYEZwFFA84DzQPPA9AD0QPSA9MBRgFHBFUEVgPoA+kBSAFJA+oD6wRsBG0BSgPsBG4D7QPuAWkBagRwBG8BfwRIAYWwACxLsAlQWLEBAY5ZuAH/hbCEHbEJA19eLbABLCAgRWlEsAFgLbACLLABKiEtsAMsIEawAyVGUlgjWSCKIIpJZIogRiBoYWSwBCVGIGhhZFJYI2WKWS8gsABTWGkgsABUWCGwQFkbaSCwAFRYIbBAZVlZOi2wBCwgRrAEJUZSWCOKWSBGIGphZLAEJUYgamFkUlgjilkv/S2wBSxLILADJlBYUViwgEQbsEBEWRshISBFsMBQWLDARBshWVktsAYsICBFaUSwAWAgIEV9aRhEsAFgLbAHLLAGKi2wCCxLILADJlNYsEAbsABZioogsAMmU1gjIbCAioobiiNZILADJlNYIyGwwIqKG4ojWSCwAyZTWCMhuAEAioobiiNZILADJlNYIyG4AUCKihuKI1kgsAMmU1iwAyVFuAGAUFgjIbgBgCMhG7ADJUUjISMhWRshWUQtsAksS1NYRUQbISFZLbAKLLAkRS2wCyywJUUtsAwssScBiCCKU1i5QAAEAGO4CACIVFi5ACQD6HBZG7AjU1iwIIi4EABUWLkAJAPocFlZWS2wDSywQIi4IABaWLElAEQbuQAlA+hEWS2wDCuwACsAsgEOAisBsg8BAisBtw86MCUbEAAIKwC3AUg7LiEUAAgrtwJYSDgoFAAIK7cDUkM0JRYACCu3BF5NPCsZAAgrtwU2LCIZDwAIK7cGcV1GMhsACCu3B5F3XDojAAgrtwh+Z1A5GgAIK7cJVEU2JhcACCu3CnZgSzYdAAgrtwuDZE46IwAIK7cM2bKKYzwACCu3DRQRDQkGAAgrtw48MiccEQAIKwCyEAoHK7AAIEV9aRhEsjASAXOysBQBc7JQFAF0soAUAXSycBQBdbIPHAFzsm8cAXUAACoAnQCAAIoAeADUAGQATgBaAIcAYABWADQCPAC8AMQAAAAU/mAAFAKbACADIQALBDoAFASNABAFsAAUBhgAFQGmABEGwAAOAAAAAAAAAGEAYQBhAGEAYQCgAMYBRQHEAnIDEwMrA1sDjAO/A+cEBgQdBEIEWQS8BOsFRQXLBhEGfAbzByAHrAglCDoITwhvCJcIuAknCeMKIgqRCvMLQguFC70MKAxsDIcMvg0VDToNig3IDi0OfA7nD0cPvA/oEC0QXRCxEQYRNxFwEZYRrRHUEfsSFhI1ErsTJhODE+wUWxS0FT4ViBW8FgkWYhZ9FvQXQxeiGA4YeRi3GSoZgxnPGf4aTRqVGtcbEBtdG3QbvxwFHDYcmh0IHXcd2h37HqAe2x+HH/sgByAlINsg8iE0IXkhzSJBImEitSLhIwIjOiNtI7ojxiPgI/okFCR3JNwlGiWjJf0mcidDJ7QoAiiHKO0pUClrKbwqCSpJKp4q/SuJLEIscyzfLUktvC4mLnsu1y8HL28vnS/DL8sv+DAaMFUwiDDNMQAxQzFgMX4xhzG2MecyCTIlMnIyejKhMs4zRzN0M7gz6DQmNKM1AzV0NfY2cjamNyk3qjf+OE04xjj5OVA5xToeOoA64jtHO4472TxMPKg9ID2qPgE+gz7kP1s/00BKQKNA4kE9QZZCBkKAQsdDEUNSQ9VEDURXRJdE40U/RaZF9UZkRulHSUe7SCBIR0icSRBJiEnDShxKZ0qxSxBLQEttTBFMSUyRTNFNGU10TdFOIE6PTxNPc0/wUFlQ1VFIUbVR9FJhUsRTMlPBVGJUrlT9VWlV2VZVVr1XVlfiWIBZJFmdWf9aP1qDWvRbYFwtXO1dc13sXkJekl7FXuJfHV80X0tgImCWYQRhYWHdYg5iOmKVYu5jSGOuZARkZWSyZR5lgWXbZn5nFWdoZ65oB2hZaJ1pHGmUae9qTGqoaw9rg2vobEpsWWxtbL5tKG3DbkBusW8fb4hv/XBwcOhxZnHEchpybnLHc0Zzd3N3c3dzd3N3c3dzd3N3c3dzd3N3c3dzd3N/c4dzkXObc7Jz0XPvdA50LnQ6dEZ0d3S4dR11QnVOdV51cnZGdmJ2f3aSdqZ273d6eBx4qXi1eXh503pZewR7ZnvpfEd8uH1dfcl+W368fyR/Pn9Yf3J/jH//gCeAYYB9gLKBO4GBgfiCOYJHglWCjoKbgsKC24Lng0qDo4Q3hMKFQ4YXhheHlIfxiCKIgIiviMWJKIl6ibqKLIqFisWLCItIi2KLqIwejHqMx40TjU+Nto4EjiKOWI6cjsSPFo9Uj7OQA5BhkLWRI5FPkYuRvpISkleSi5LIkxuTRpOVlAaUSJSolQiVNZW+liCWN5aBlz6XuZgtmHyYwpkEmUyZzJo4mq+a2psQm4ibuZwHnDqcepzunVCdu54enoyfA597n9KgDaBpoMGhN6G8ofqiS6KUotijE6Nbo5uj5aRApEyknaURpZyl+aZIptCnM6eYp/iooqiuqQGpTamiqeuqZarSqzerq6xHrM6tb63irk+uqK8Tr5yvpLAQsH6w6bFysdWyQLKSsvSzWrOFs9q0BLRdtKG0tbTJtNu077UBtRi1LLWOtba2RLa0tw23FbcdtyW3MLc4t0S3sLewt7i4KLiYuPq5QLmoub+51rntugS6HLovuju6R7peunC6h7qaurG6w7rauu27BLsbuy27RLtbu267hbuXu667wbvTu+q7/LwSvCO8NrxJvFW8Ybx4vIq8oLyzvMm82rzxvQm9Gr0xvUO9Wb1qvX29lL2mvby9z73hvfO+Cr4gvje+Sb62v2S/dr+Iv5q/q7+9v8+/4b/ywATAEMAiwDPARcBXwGnAe8DvwX3Bj8GgwbLBw8HVwefB+cILwhfCKcI7wk/CYcJzwoXCl8KpwrvCxsLRwuPC78L7ww3DH8MrwzfDScNbw2fDc8OIw5TDoMOsw77D0MPcw+jD+sQLxBfEKcQ6xEzEXsRxxITElsSoxLTEwMTSxOPE9cUHxRnFKsU2xULFTsVaxWzFfcWJxZXFocWtxb/Fy8Xdxe7GAMYRxiPGNcZIxlvGbsaBxuLHUcdjx3XHh8eYx6vHvcfPx+HH88gFyBbILchEyFvIcsiVyLjIyMjfyPHJB8kYySvJPslKyVbJbcl/yZDJosm4ycnJ28nuygDKF8opyjvKTcpgynfKicqayq3Kv8rQyuLLSctby2zLfsuQy6HLssvDy9XMT8xgzHHMg8yVzKHMs8zFzNfM6cz0zQXNF80jzTTNQM1VzWHNc81/zZHNo821zcjN2s3mzffOCc4azibON85DzlTOYM5xzoLOlM6nzrrPJc83z0jPWs9sz37Pj8+az6bPss++z8rP1s/iz/3QBdAN0BXQHdAl0C3QNdA90EXQTdBV0F3QZdBt0IDQk9Cl0LfQydDa0O/Q99D/0QfRD9EX0SnRO9FN0V/RcdGJ0aDSFdId0jDSONJA0lfSbtJ20n7ShtKO0qDSqNKw0rjSwNLI0tDS2NLg0ujS8NMC0wrTEtNv03fTf9OS06nTsdO508zT1NPr1AHUGNQv1EbUXdR11I3UpNS71MPUy9TX1O7U9tUN1STVMNU81VPVatWB1ZjVoNWo1cDV2NXk1fDV/NYI1hTWINYo1jDWONZP1mbWbtaF1pzWtNbH1s/W19bp1vvXDtcW1ynXPNdP12LXdNeG15fXqte919DX49fr1/PYBtgZ2CzYP9hR2GLYddiH2J/Yt9jP2OHY/dkZ2SXZMdk52UXZUdld2WnZe9mN2aXZvNnU2evaA9oa2jLaSdpk2n7akdqk2rfaytrd2vDbA9sW2zHbTNtY22TbdtuI25rbq9vD29rb8twJ3CHcONxQ3Gfcgtyc3K7cwNzM3Njc5Nzw3QLdFN0s3UPdW91y3Yrdod253dDd694F3hzeM95K3mHeeN6P3qbevN7I3tTe4N7s3v7fEN8n3z7fVd9s34Pfmt+x38ff09/f3+vf9+AJ4BvgLeA+4L7gzuDa4Obg8uD+4QrhFuEi4S7hOuFG4VLhXuFq4XbhguGO4ZrhpuGu4hjihOLK4xDjb+PK4+XkAOQM5BjkJOQw5DzkSOST5OPlO+WV5Z3lqeWz5bvlw+XL5dPl2+Xj5frmEeYo5j/mV+Zv5ofmn+a35s/m5+b/5xfnL+dH51/na+d354Pnj+eb56fns+e/58vn4uf06ADoDOgY6CToMOg86EjoVOhr6ILojuia6Kbosui+6Mro4ej36QPpD+kb6SfpM+k/6UvpV+lj6W/pe+mH6ZPpn+mn6a/pt+m/6cfpz+nX6d/p5+nv6ffp/+oH6h/qNupN6mTqbOp06ozqlOqr6sHqyerR6tnq4er46wDrCOsQ6xjrIOso6zDrOOvD7B3sguyK7JbsrezD7Mvs1+zj7O/s+wAAAAUAZAAAAygFsAADAAYACQAMAA8AcbIMEBEREjmwDBCwANCwDBCwBtCwDBCwCdCwDBCwDdAAsABFWLACLxuxAhw+WbAARViwAC8bsQAQPlmyBAIAERI5sgUCABESObIHAgAREjmyCAIAERI5sQoM9LIMAgAREjmyDQIAERI5sAIQsQ4M9DAxISERIQMRAQERAQMhATUBIQMo/TwCxDb+7v66AQzkAgP+/gEC/f0FsPqkBQf9fQJ3+xECeP1eAl6IAl4AAgBD//IB9AWwAAMADgA/sgkPEBESObAJELAA0ACwAEVYsAIvG7ECHD5ZsABFWLANLxuxDRA+WbIHBQorWCHYG/RZsgEHAhESObABLzAxASMTMwE2Njc2FhUUBgYmATGkqb7+TwE6MC48PF47AZsEFfqqLz0CAjwuLzsEOgAAAgDIBBECpgYIAAQACQAZALADL7ICCgMREjmwAi+wB9CwAxCwCNAwMQEDBxMXFwMjExcBiVNuUIjvU25QiAVu/qQBAfcJkf6kAfYJAAIAUgAABPsFsAAbAB8AjwCwAEVYsAwvG7EMHD5ZsABFWLAQLxuxEBw+WbAARViwAi8bsQIQPlmwAEVYsBovG7EaED5Zsh0MAhESOXywHS8YsgADCitYIdgb9FmwBNCwHRCwBtCwHRCwC9CwCy+yCAMKK1gh2Bv0WbALELAO0LALELAS0LAIELAU0LAdELAW0LAAELAY0LAIELAe0DAxASMDIxMjNzMTIzchEzMDMxMzAzMHIwMzByMDIwMzEyMCw/qWkJXmGP+A+BgBEpiRmfuYkpnEGN6A2BjxlZI0+oH6AZr+ZgGaiQFiiwGg/mABoP5gi/6eif5mAiMBYgAAAQBK/zAEPAacACsAbbIfLC0REjkAsABFWLAJLxuxCRw+WbAARViwIi8bsSIQPlmyAiIJERI5sAkQsAzQsAkQsBDQsAkQshMBCitYIdgb9FmwAhCyGQEKK1gh2Bv0WbAiELAf0LAiELAm0LAiELIpAQorWCHYG/RZMDEBNiYmJyY3NjY3NzMHFhYHIzYmJyYGBwYWBBYWBwYGBwcjNyYmNzMGFhcWNgMhCmr9S5QOC9exJ5IolJEPswhnZHGTDAldARKOQQcN5b0ikSOkqAu1C3V2f6sBflaAYT15xKTXF9veHfHAk50DAoNvVnxtd5pjq9IUv8EY6rqDnAIChQAFALv/5gU4BcgADQAbACkANwA7AImyJTw9ERI5sCUQsAXQsCUQsBbQsCUQsCvQsCUQsDjQALA4L7A6L7AARViwAC8bsQAcPlmwAEVYsCMvG7EjED5ZsAAQsAfQsAcvshEECitYIdgb9FmwABCyGAQKK1gh2Bv0WbAjELAc0LAcL7AjELItBAorWCHYG/RZsBwQsjQECitYIdgb9FkwMQEWFgcHBgYnJiY3NzY2AwYWFxY2Nzc2JicmBgcBFhYHBwYGJyYmNzc2NgMGFhcWNjc3NiYnJgYHBScBFwINeY8IBg+1fXmSCAYNt0MFRUBEZQsJB0JDRWYLAtt8jggGDbWAeJMIBg2yPgVDQkZjCwkHQkNHZAv982MDcWMFxgSpgU2GqgQCrH5AkK3+gVFfAgJlUU5MZgICZlH9+gSrfkONrwQCqoFEi67+gVBhAgJmUU9LZgICZlD1SARoRwADADr/6QSHBcgAHAAlADEAmLIeMjMREjmwHhCwD9CwHhCwMNAAsABFWLAJLxuxCRw+WbAARViwGi8bsRoQPlmwAEVYsBcvG7EXED5ZsiAaCRESObIpCRoREjmyAyApERI5sg8pIBESObIQGgkREjmyEhoJERI5shgaCRESObIVEBgREjmwGhCyHQEKK1gh2Bv0WbIfHRAREjmwCRCyLwEKK1gh2Bv0WTAxEzY3NycmNzY2FxYWBwYHBxM2NzMGBxcjJwYnJiYFFjcBBwYHBhYTBhcXNzY3NiYjIgZHD89yK0gIDNikh7AICcyT+VsXoRuancpJrtG95gGphpb+8SuzEw9+cAg5G5lrCwZSRFNwAYC6kkxNhHGlyQQCq3+sj2L+g4eb/6z1cYgEAuFNA3QBqB58g2yOA9xUZS9nUGlAVHkAAQCqBCEBiQYAAAQAEACwAy+yAgUDERI5sAIvMDEBAyMTMwF2TIBNkgWK/pcB3wAAAQBt/ioDGAZsABIAELICExQREjkAsAQvsA0vMDETNhIANxcGAgIXFBIXByYCEzY3hSGzAQSgG53hegJrZS2nsQgCDAJL5wG2ATVPfHX+h/35/M/+xVtwdAHGASVgVwAAAf+P/ikCOAZrABIAELIHExQREjkAsAQvsAwvMDEBBgIABycAEzYnAic3FhISBwYHAiMjuP7/nBwBV3MuAgXLL3CbSQQDDAJJ9P5N/tVOcwECAjvm1QGtunBO/v3+qbhhVgABAGsCXwOKBbAADgAgALAARViwBC8bsQQcPlmwANAZsAAvGLAJ0BmwCS8YMDEBJTcFEzMDJRcFEwcDAycBgP7rRAEWM5ZGAS8T/sWTgIPecgPbWpBxAVz+qGyfW/7tWAEi/uhiAAABAEwAkgQ0BLYACwAaALAJL7AA0LAJELIGAQorWCHYG/RZsAPQMDEBIQchAyMTITchEzMCqgGKH/53ULZQ/nYfAYlKtgMNr/40AcyvAakAAAH/j/7dAOoA2wAHABcAsAgvsgQFCitYIdgb9FmwANCwAC8wMQMnNjc3MwcGCWh0HBqxFST+3UuPjZeH5AAAAQAZAh8CDwK2AAMAEQCwAi+yAQEKK1gh2Bv0WTAxASE3IQH0/iUbAdsCH5cAAAEANf/yARUA0wAIACKyAwkKERI5ALAARViwBS8bsQUQPlmyAAUKK1gh2Bv0WTAxNzYWDgImNDakMUACQGA+PtIBPmI9BDtiQQAAAf+P/4MDkgWwAAMAEwCwAC+wAEVYsAIvG7ECHD5ZMDEXIwEzM6QDYKN9Bi0AAAIAaP/nBCsFyQARACEARrIXIiMREjmwFxCwCNAAsABFWLAJLxuxCRw+WbAARViwAC8bsQAQPlmwCRCyFgEKK1gh2Bv0WbAAELIeAQorWCHYG/RZMDEFJiY3Njc3EgAXFhYHBgcHAgATNicmJyYGBwMGFxIXFjY3Adi4uAgCCSQwAQ7durcHAwkjNf70tQ4BBcCMrSIrDgEFv4WtJRQE/e5KSPMBNwEyBQT360tI6/63/tADhXlD/gcF2ej+3nRJ/vcHBtDiAAEA+QAAA1QFtwAGADkAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvsgMBCitYIdgb9FmyAgMFERI5MDEhIxMFNyUzAly21v59HwIcIATMiLDDAAABABcAAAQrBccAGQBUsgMaGxESOQCwAEVYsBEvG7ERHD5ZsABFWLAALxuxABA+WbIZAQorWCHYG/RZsALQsgMRGRESObARELIJAQorWCHYG/RZsBEQsAzQshcZERESOTAxISE3ATc2NzYmJyYGBwc+AhcWFgcGBwcBIQO2/GEWAhliqRINcGaDsBOzDYvjhbXVDxHMXP4sAr+NAgphqY9uiwQEoYwBhs9vAwTTqMDUXf5DAAABADT/6AQhBccAKAB/sggpKhESOQCwAEVYsA4vG7EOHD5ZsABFWLAaLxuxGhA+WbIAGg4REjmwAC+yzwABXbKfAAFxsi8AAV2yXwABcrAOELIHAQorWCHYG/RZsA4QsArQsAAQsigBCitYIdgb9FmyFCgAERI5sBoQsB3QsBoQsiEBCitYIdgb9FkwMQEXMjY3NiYnJgYHBzYkFxYWBwYGBxYWBwYEJyYmNxcGFhcWNjc2JicnAaB4hLUNDXBrcp8SsxEBEb230Q4JjHxjYggQ/ufJu94ItQZ4coCqDAuCgYsDMgGLd3SFAgKJdAG04QIE3bVnqjgorXTF8AQE4LEBcIkEBJqBd4UEAQAAAgAFAAAEHQWwAAoADgBJALAARViwCS8bsQkcPlmwAEVYsAQvG7EEED5ZsgEJBBESObABL7ICAQorWCHYG/RZsAbQsAEQsAvQsggGCxESObINCQQREjkwMQEzByMDIxMhNwEzASETBwNZxBvDO7Y7/XwVAyDG/PMBsIIdAemX/q4BUncD5/w5AswqAAABAHL/5wRqBbAAHQBoshseHxESOQCwAEVYsAEvG7EBHD5ZsABFWLANLxuxDRA+WbABELIDAQorWCHYG/RZsgcBDRESObAHL7IaAQorWCHYG/RZsgUHGhESObANELAR0LANELIUAQorWCHYG/RZsBoQsB3QMDETEyEHIQM2FxYSBwYAJyYmJzMWFhcWNjc2JicmBgfbuQLWG/3GcG6AtcISE/7o0a7WBqkHemiArxAOenZJcTgC3QLTq/5yQQIC/vPQ4P7wBALct3iEAgS+moevBAIwLQAAAgBw/+YD+AWyABYAJgBishgnKBESObAYELAO0ACwAEVYsAAvG7EAHD5ZsABFWLAOLxuxDhA+WbAAELIBAQorWCHYG/RZsgcADhESObAHL7IFBw4REjmyFwEKK1gh2Bv0WbAOELIgAQorWCHYG/RZMDEBByMGBAc2Fx4CBwYAJyYmJyY3EgAhASYGDwIUFhYXFjY3NiYmA7sQI8j+5E6ItnOkTQwU/uvKotAPCCFFAZcBOv7GYaouBwIyYkJ5rREKKmEFsp0E8OqIBAJ72YPd/uEGBObBabMBdQGK/XACdFpDUVKaUAEFvptallcAAAEAnQAABIwFsAAGADIAsABFWLAFLxuxBRw+WbAARViwAS8bsQEQPlmwBRCyAwEKK1gh2Bv0WbIAAwUREjkwMQEBIwEhNyEEevzpxgMT/QgYA7wFPvrCBRiYAAMAQf/oBDYFyAAXACMALwBvshswMRESObAbELAU0LAbELAo0ACwAEVYsBUvG7EVHD5ZsABFWLAJLxuxCRA+WbItFQkREjmwLS+yGwEKK1gh2Bv0WbIDLRsREjmyDxstERI5sAkQsiEBCitYIdgb9FmwFRCyJwEKK1gh2Bv0WTAxAQYGBxYWBwYEJyYmNzY2NyYmNzYkFxYWATYmJyYGBwYWFxY2EzYmJyYGBwYWFxY2BCgJiXZeWwgP/uLKvdwPC5qFTksIDgEGv67M/ugMeHJ8sA4MeW9+sGILaWFwmg0La2FtmwQ9ba85NrVrwekEBOKvfbs6NqReueQEBNr8sHGXBAKhf3SMAgSbAyFligQCk3RohgICkQACAJT//gQTBcgAGAAoAGWyEikqERI5sBIQsBnQALAARViwCy8bsQscPlmwAEVYsBMvG7ETED5ZsgMTCxESObADL7IAAwsREjmwExCyFQEKK1gh2Bv0WbADELIZAQorWCHYG/RZsAsQsiEBCitYIdgb9FkwMQEGBicuAjc+AhcWFhcWBwIABSM3MzYkJxY2PwImJicmBgcGFhcWAzdKplJzo0sMDYjbhK7GCAMcQv57/s8tECXXARPWW6g2CAMEa2R8rw4HEhs2AoBOTQICftyCkPCDBAT0zWuf/or+hQacBOn5BG9eSVGbqAQFyZc9fjBh//8AK//yAaQERgAmABL2AAEHABIAjwNzABAAsABFWLAJLxuxCRg+WTAx////m/7dAY0ERgAnABIAeANzAQYAEAwAABAAsABFWLAALxuxABg+WTAxAAEAQQDIA7gETwAGABYAsABFWLAFLxuxBRg+WbAC0LACLzAxAQUHATcBBwEHAjUh/SYaA10kAoD9uwF7kgF6zQACAHABjwP/A88AAwAHACUAsAcvsAPQsAMvsgABCitYIdgb9FmwBxCyBAEKK1gh2Bv0WTAxASE3IQMhNyED4vzWHAMrZfzWHAMrAy6h/cCgAAEAOgC/A9QERwAGABYAsABFWLACLxuxAhg+WbAF0LAFLzAxAQE3AQcBNwMN/aohAvwa/IAkAo4BA7b+hZH+hMkAAAIApf/yA78FxwAYACQAXbIeJSYREjmwHhCwCtAAsABFWLAQLxuxEBw+WbAARViwIi8bsSIQPlmyHAUKK1gh2Bv0WbAA0LAAL7IEEAAREjmwEBCyCQEKK1gh2Bv0WbAQELAM0LIVABAREjkwMQE2Njc3Njc2JicmBgcHNjYXFhYHBgcHBgcDNjY3NhYHFAYHBiYBQQ1gbFF9EAxWW2aDEbQT9bGouQ4Ru3piF/gBOjAuPQE8Ly87AZlzsGBHb3pedgQCcVkBpccCBMyltqhoWZf+wC89AgE7Ly48AQI6AAIARP47BpsFmgA3AEQAh7JCRUYREjmwQhCwC9AAsCcvsDAvsABFWLAFLxuxBRA+WbAARViwAC8bsQAQPlmyAzAAERI5sgwwABESObAML7AAELITAgorWCHYG/RZsDAQshoCCitYIdgb9FmwJxCyIgIKK1gh2Bv0WbAFELI6AgorWCHYG/RZsAwQskECCitYIdgb9FkwMQUmJicGJyYmNzYSNhcWFwMGFQYXFhITNgImJyYEAgMGEhYXFjcXBiMmJAI1JhIAJBcWBBIVFAIGAQYXFj8CEyYnJgIHBK9ZbQ2Ij3RwDAqY3IKLhYUKBWGTtgsHauep3f6G9QwIbuCiqaobi+W//uaaAp8BGwFpyMIBF5OD3f1OBXVrXSABhTQ3i8EiFAJZTawDAracoQFPsQIDZv3SQhuHAwYBVgEOtAESjAME/v4a/um1/uSRAQRSdVcBpwFB0tkBwwFXsQMDqP6+zOH+oLUBPqsDBZU1CwH6HAEF/ujtAAAC/68AAASLBbAABwAKAEYAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsgkEAhESObAJL7IAAQorWCHYG/RZsgoEAhESOTAxASEDIwEzASMBIQMDjf2yx8kDF6UBILn9wAHfeQF8/oQFsPpQAhoCpwADADsAAASgBbAADQAWAB8AaLIYICEREjmwGBCwDdCwGBCwENAAsABFWLACLxuxAhw+WbAARViwAC8bsQAQPlmyGAIAERI5sBgvshYBCitYIdgb9FmyBxYYERI5sAAQshABCitYIdgb9FmwAhCyHgEKK1gh2Bv0WTAxMxMFMhYHBgcWFgcGBCMDAwUyNjc2JiclBTI2NzYmJyU7/QGr394OEvViYQkP/uLjyFsBKYi4Dw5udv7UAQ9/rw8NbX7+4gWwAciz0WomuG/F5wKp/fQBknx2hASbAYJyamwFAQABAHT/5gT5BckAHwBOshUgIRESOQCwAEVYsA0vG7ENHD5ZsABFWLADLxuxAxA+WbIADQMREjmyEAMNERI5sA0QshQBCitYIdgb9FmwAxCyHAEKK1gh2Bv0WTAxAQYAJy4CJyY3NxIABRYSFyMCJycmAg8CBhYXFjY3BJEq/rvjh8pwBgQLES8BbwEHzfAHuw3jIb39JRYGBo+NmMc0AdDi/vgGA3/vkVJOeAFIAXsFBP7/5AEyGAIF/t38l1i42QQFnK0AAgA7AAAE1QWwAAoAFQBDsg4WFxESObAOELAC0ACwAEVYsAIvG7ECHD5ZsABFWLAALxuxABA+WbINAQorWCHYG/RZsAIQshUBCitYIdgb9FkwMTMTBTIEEgcHAgAhEwMXMgA3NicmJic7/QF6sgEBcBcKLP5q/s0ZxrnUAScsIwsPsJQFsAGy/sfCSf7C/oUFEvuLAQEI5riBm68EAAABADsAAASxBbAACwBOALAARViwBi8bsQYcPlmwAEVYsAQvG7EEED5ZsgsEBhESObALL7IAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASEDIQchEyEHIQMhA9D9nFoCyBz8ff0DeRz9Q1ECZAKh/fydBbCe/iwAAAEAOwAABKQFsAAJAEAAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmyCQIEERI5sAkvsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASEDIxMhByEDIQO3/bBwvP0DbBz9UFYCUQKD/X0FsJ7+DgABAHn/6gUGBccAIQBcsh8iIxESOQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIQDAMREjmwDBCyEwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsiEMAxESObAhL7IeAQorWCHYG/RZMDElBgQnLgInJhISJBcWFhcjJiYnJgIDBwcUFhcWNxMhNyEEe0n+6bOP1noJB0m2ARGwy/ERuguQf7z9KBMDopLTfDz+uBwCAMBnbwIDgO+YdwGWASicAwTp04qUBAf+5P7vjEzF1wIFbQFHnAAAAQA7AAAFdwWwAAsAVQCwAEVYsAYvG7EGHD5ZsABFWLAKLxuxChw+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAAQsAnQsAkvsp8JAXKyLwkBXbICAQorWCHYG/RZMDEhIxMhAyMTMwMhEzMEerx1/Tl1vP28bQLGbb0Cof1fBbD9jgJyAAEASQAAAgEFsAADAB0AsABFWLACLxuxAhw+WbAARViwAC8bsQAQPlkwMSEjEzMBBLv9uwWwAAEACv/mBEoFsAAPAC4AsABFWLAALxuxABw+WbAARViwBS8bsQUQPlmwCdCwBRCyDAEKK1gh2Bv0WTAxATMDBgQnJiY3MwYWFxY2NwOOvK8d/uzOwNIMuwtwcHuqEwWw+/nO9QQE4MR4jwIEooEAAQA7AAAFUAWwAAsAdACwAEVYsAUvG7EFHD5ZsABFWLAHLxuxBxw+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgACBRESOUARSgBaAGoAegCKAJoAqgC6AAhdsjkAAV2yBgUCERI5QBM2BkYGVgZmBnYGhgaWBqYGtgYJXTAxAQcDIxMzAwEzAQEjAiDVVLz9vHwC5vL9WwHF0QKjv/4cBbD9OwLF/XT83AAAAQA7AAADsQWwAAUAKACwAEVYsAQvG7EEHD5ZsABFWLACLxuxAhA+WbIAAQorWCHYG/RZMDElIQchEzMBEwKeHPym/b2dnQWwAAABADsAAAa3BbAADgBZALAARViwAC8bsQAcPlmwAEVYsAIvG7ECHD5ZsABFWLAELxuxBBA+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsgEABBESObIHAAQREjmyCgAEERI5MDEBEwEzAyMTEwEjAQMDIxMCJf8CnPf9u2R3/WyQ/vxaYbz9BbD7XgSi+lACQAJK+3YEof2M/dMFsAAAAQA7AAAFdwWwAAkATLIBCgsREjkAsABFWLAFLxuxBRw+WbAARViwCC8bsQgcPlmwAEVYsAAvG7EAED5ZsABFWLADLxuxAxA+WbICBQAREjmyBwUAERI5MDEhIwEDIxMzARMzBHq2/fjEvf22AgnFuwRq+5YFsPuRBG8AAAIAd//nBQ0FyAASACIARrIXIyQREjmwFxCwCdAAsABFWLAKLxuxChw+WbAARViwAC8bsQAQPlmwChCyFgEKK1gh2Bv0WbAAELIeAQorWCHYG/RZMDEFLgInJhISNzYXFhIXFgICBwYBNiYnJgYCBwcGFhcWEhM2AlGLzXYGBkKidJ3J1fYJBDODZbABDgaWlIbThxIDBpiRvfkpFBQDgPmbeQFkAR5WdAQE/uH1af68/upepAOXxdkEBJj+0ehBxN4EBQEbAQB+AAACADsAAATzBbAACgATAE2yChQVERI5sAoQsAzQALAARViwAy8bsQMcPlmwAEVYsAEvG7EBED5ZsgsDARESObALL7IAAQorWCHYG/RZsAMQshIBCitYIdgb9FkwMQEDIxMFMhYHBgQjJQUyNjc2JiclAVpjvP0B5uH0ERL+1/P+wQFEmcQREIaA/qcCOv3GBbAB78bR8J4Bmol7mQQBAAIAb/8KBQQFyAAXACgARrIcKSoREjmwHBCwBNAAsABFWLAPLxuxDxw+WbAARViwBS8bsQUQPlmwDxCyGwEKK1gh2Bv0WbAFELIkAQorWCHYG/RZMDElFwcnBiMuAicmEhI3NhceAhcWBwcCAzYmJyYGAgcHBhYWFxYSNzYDi9mL/kpKidBzBgZBnnCgzo3QcgYDCgw+aQeYkobThxIDBD6HYrj7KhVM0XHzEAGD95x+AV0BGVZ6BAOC95xUU1X+UQJ9yNYEBJj+0ehBc8hoAwcBGP9/AAACADoAAATCBbAADgAXAGGyBRgZERI5sAUQsBbQALAARViwBC8bsQQcPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIQBAIREjmwEC+yAAEKK1gh2Bv0WbILAAQREjmwBBCyFgEKK1gh2Bv0WTAxASEDIxMFFhYHBgYHEwcjAQUyNjc2JiclAq3+sGa9/QG25fATC7GT4gHI/f8BFJDGEQ+Chf7dAk39swWwAQHmxonQNf2ZDQLqAZmAfY4EAQABACf/6QSjBccAKABhshMpKhESOQCwAEVYsAovG7EKHD5ZsABFWLAfLxuxHxA+WbICHwoREjmwChCwD9CwChCyEgEKK1gh2Bv0WbACELIYAQorWCHYG/RZsB8QsCTQsB8QsiYBCitYIdgb9FkwMQE2LwIkNz4CFx4CByc2JicmBgcGHwIEAw4CJy4CNxcGFgQ2A20WvK06/twTCpLxiITPbAa9CoyCibgOFMuVSwEaFQuQ946J43YHvAmfASK8AXegSj8ZhfF5umUDA3DJfgGGkwIChHKVTTUggv8Ae7NiAwFzyH8BgpkEggABAKgAAAUJBbAABwAuALAARViwBi8bsQYcPlmwAEVYsAIvG7ECED5ZsAYQsgABCitYIdgb9FmwBNAwMQEhAyMTITchBO3+O+G74f47HARFBRL67gUSngAAAQBn/+cFIAWwABIAPLIPExQREjkAsABFWLAKLxuxChw+WbAARViwEi8bsRIcPlmwAEVYsAQvG7EEED5Zsg4BCitYIdgb9FkwMQEDBgAnLgI3EzMDBhYXFjY3EwUgqCL+vOWP02QRqLmnEYqMmNEbqAWw/Cfj/vMEA3vfjgPa/CWZrwQGsaAD3AAAAQCkAAAFYQWwAAYAOLIABwgREjkAsABFWLABLxuxARw+WbAARViwBS8bsQUcPlmwAEVYsAMvG7EDED5ZsgABAxESOTAxAQEzASMBMwI+Ak/U/RCm/tnFAQEEr/pQBbAAAQDDAAAHQQWwABIAWQCwAEVYsAMvG7EDHD5ZsABFWLAILxuxCBw+WbAARViwES8bsREcPlmwAEVYsAovG7EKED5ZsABFWLAPLxuxDxA+WbIBAwoREjmyBgMKERI5sg0DChESOTAxAQc3ATMTFzcBMwEjAycHASMDMwG+BEQBs59zCj8BdMH9xqt+BCr+MKtytwHBsKwD8/wApskD3fpQBC1kdPvjBbAAAf/UAAAFKwWwAAsAawCwAEVYsAEvG7EBHD5ZsABFWLAKLxuxChw+WbAARViwBC8bsQQQPlmwAEVYsAcvG7EHED5ZsgABBBESOUAJhgCWAKYAtgAEXbIGAQQREjlACYkGmQapBrkGBF2yAwAGERI5sgkGABESOTAxAQEzAQEjAQEjAQEzApoBqej9yQFT0/7+/kroAkP+ttADgwIt/SX9KwI3/ckC5wLJAAABAKgAAAUyBbAACAAxALAARViwAS8bsQEcPlmwAEVYsAcvG7EHHD5ZsABFWLAELxuxBBA+WbIAAQQREjkwMQEBMwEDIxMBMwJjAe/g/XNdu2D+u8wC1gLa/GX96wIqA4YAAAH/6wAABM4FsAAJAEQAsABFWLAHLxuxBxw+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WbIEAAIREjmwBxCyBQEKK1gh2Bv0WbIJBQcREjkwMTchByE3ASE3IQfqAyIc+/sbA8b9DBwD2hqdnZoEeJ6XAAH///7IAqMGgAAHACIAsAQvsAcvsgABCitYIdgb9FmwBBCyAwEKK1gh2Bv0WTAxASMBMwchASECirn++7oY/pEBNAFwBej5eJgHuAABAL//gwKeBbAAAwATALACL7AARViwAC8bsQAcPlkwMRMzASO/pAE7owWw+dMAAf96/sgCHwaAAAcAJQCwAi+wAS+wAhCyBQEKK1gh2Bv0WbABELIGAQorWCHYG/RZMDETIQEhNzMBI68BcP7L/pAYuwEFvAaA+EiYBogAAQBPAtkDDwWwAAYAJ7IABwgREjkAsABFWLADLxuxAxw+WbAA0LIBBwMREjmwAS+wBdAwMQEBIwEzEyMCDP70sQGhfKOeBLn+IALX/SkAAf+B/2kDFgAAAAMAGwCwAEVYsAMvG7EDED5ZsgABCitYIdgb9FkwMQUhNyEC+/yGGwN6l5cAAQDPBNgCKwX+AAMAIwCwAS+yDwEBXbAA0BmwAC8YsAEQsALQsAIvtA8CHwICXTAxASMDMwIrj83NBNgBJgACADP/6APPBFEAIAArAHmyBCwtERI5sAQQsCLQALAARViwGC8bsRgYPlmwAEVYsAUvG7EFED5ZsABFWLAALxuxABA+WbIDGAUREjmyCxgFERI5sAsvsBgQshABCitYIdgb9FmyEwsYERI5sAUQsiEBCitYIdgb9FmwCxCyJgEKK1gh2Bv0WTAxISY1NwYnJiY3NiQzFzc2JicmBgcHPgIXFhYHAwcGFwclFjY3NyciBgcGFgK1BwOVp4+zCAoBGeW9DApfX12PELYJgsxtqbwPWAUCDgL+LFebOCeJq7YMCVkdHDmKBAKxhazBAVZhcQICX04BX5NRAgTFo/3oTTc2EYwCV03fAWxjTGUAAgAf/+gD/gYAABIAHgBkshwfIBESObAcELAE0ACwCS+wAEVYsA0vG7ENGD5ZsABFWLAELxuxBBA+WbAARViwBy8bsQcQPlmyBg0EERI5sgsNBBESObANELIWAQorWCHYG/RZsAQQshsBCitYIdgb9FkwMQEGAgYnJicHIwEzAzYXFhYXFgcnNiYnJgcDFhcWNjYD9RSOynvEXyWnAQu1bYK6nK4FAQeuA2hrqXVRPKVqn1ICGKb+9oADBI9+BgD9wpAEBN7DQDxUkpsEBK7+KaUEBIbxAAEARv/pA+YEUgAgAEuyACEiERI5ALAARViwES8bsREYPlmwAEVYsAgvG7EIED5ZsgABCitYIdgb9FmyBBEIERI5shQRCBESObARELIYAQorWCHYG/RZMDElFjY3Nw4CJy4CNzc+AhcWFhUnJiYnJgYHBwYXFhYB6GGcGKsPhcpqh7tYDgUTkOiMqsypAnJhjbsXAwYEB3aCAnVfAWaoXgMCifWZMpz2iQQE3KkBaoMEA9jCGkBEdYgAAAIAS//oBHUGAAARAB0AZLIEHh8REjmwBBCwGtAAsAcvsABFWLAELxuxBBg+WbAARViwDS8bsQ0QPlmwAEVYsAovG7EKED5ZsgYEDRESObILBA0REjmwDRCyFQEKK1gh2Bv0WbAEELIaAQorWCHYG/RZMDETNhI2FxYXEzMBIzcGJyYmJyYXBhYXFjcTJicmBgZTFI7QfbVhaLX+9qUTgLyWsgcDtgNsaJ16Vjyea6NVAh+lAQqEAwSAAjX6AHSMBATjvzsWj54CB6UB9JQEA4fzAAIARf/qA+AEUQAXAB8AabISICEREjmwEhCwGdAAsABFWLAILxuxCBg+WbAARViwAC8bsQAQPlmyHAgAERI5sBwvtL8czxwCXbIOAQorWCHYG/RZsAAQshIBCitYIdgb9FmyFAgAERI5sAgQshgBCitYIdgb9FkwMQUmAjc3NhI2FxYWFxYHByEGFhcWNxcGBgMmBgcFNzYmAfPK5BIFEZ3ig6e+CQMHC/09EoWEoIhoRNcRcKcxAg4EEHEUBAEi4iuhAQqHAwTWt0FBU5POBASUWGJvA80DnpwBEH6nAAEAdAAAA1AGGQAWAGOyBhcYERI5ALAARViwCS8bsQkePlmwAEVYsAMvG7EDGD5ZsABFWLASLxuxEhg+WbAARViwAC8bsQAQPlmwAxCyAQEKK1gh2Bv0WbAJELIOAQorWCHYG/RZsAEQsBTQsBXQMDEzEyM3Mzc2NzYXMhcHJiciBgcHMwcjA3ekpxmmEhpkaaMzThYwMV51DhDgGeCjA6uPgKNcYAIRlwoCdWFrj/xVAAACAAT+TwQoBFIAHQApAIOyCyorERI5sAsQsCbQALAARViwBC8bsQQYPlmwAEVYsAcvG7EHGD5ZsABFWLAMLxuxDBI+WbAARViwGC8bsRgQPlmyBgQYERI5shAYDBESObAMELISAQorWCHYG/RZshYEGBESObAYELIhAQorWCHYG/RZsAQQsiYBCitYIdgb9FkwMRM2EjYXFhc3MwMGBCcmJic3FhcWNjc3BicuAicmFwYWFxY3EyYnJgYHVBiPzXq8YCSmtB3+6sxuyTpnYqGBsx0UhLFllVIEArcDaWqidVU8nZO9EQIfsQEFfQMEinn73c/5BgJkV2+RBASYjGCEBANnw3g7FI+dBASjAfGUBgT40wABAB8AAAPjBgAAEgBJsgETFBESOQCwEi+wAEVYsAIvG7ECGD5ZsABFWLAPLxuxDxA+WbAARViwBy8bsQcQPlmyAAIPERI5sAIQsgwBCitYIdgb9FkwMQE2FxYWBwMjEzYnJicmBwMjATMBcY65mJMTdrV3BgURlKZ4hrUBC7UDtpsEAs25/TsCyDEqjAMEsvz8BgAAAgAvAAAB4wXHAAMADQAxALAARViwAi8bsQIYPlmwAEVYsAEvG7EBED5ZsAIQsArQsAovsgQFCitYIdgb9FkwMTMjEzMDNhYVDgImNjbjtLy0Jy49ATtePAI6BDoBiwI7MC88BDpePgAC/xT+RgHVBccADAAYADwAsABFWLAMLxuxDBg+WbAARViwBC8bsQQSPlmyCQEKK1gh2Bv0WbAMELAX0LAXL7IQBQorWCHYG/RZMDEBAwYGJyYnNxYXMjcTEzY2NzYWFQYGBwYmAZbNFKWFNUIQJS6BGs8fATkwLj0BPC8tPAQ6+0WZoAICEpQJApoEuwEcLz4CAj0uLzwCAjwAAQAgAAAEGgYAAAwAdQCwAEVYsAQvG7EEHj5ZsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgAIAhESOUAVOgBKAFoAagB6AIoAmgCqALoAygAKXbIGCAIREjlAFTYGRgZWBmYGdgaGBpYGpga2BsYGCl0wMQEHAyMBMwM3ATMBASMBo45AtQELtaBvAYDr/g8BVsYB83/+jAYA/GpwAWD+M/2TAAEALwAAAe4GAAADAB0AsABFWLACLxuxAh4+WbAARViwAC8bsQAQPlkwMTMjATPjtAEKtQYAAAEAHgAABmoEUgAgAHeyFiEiERI5ALAARViwAy8bsQMYPlmwAEVYsAgvG7EIGD5ZsABFWLAALxuxABg+WbAARViwFy8bsRcQPlmwAEVYsA0vG7ENED5ZsABFWLAeLxuxHhA+WbIBHgMREjmyBgMXERI5sAMQshsBCitYIdgb9FmwEtAwMQEHNhcWFhc2FxYWBwMjEzYnJicmBgcDIxM2JicmBwMjEwGEF4jBZ48bmM+imhR3tHYGBhOfY6EXe7Z4DV1iqWSJtbwEO3mQBAJaUrIEBNKx/TkCyTQriAMCf2f9MQLIb3gCBJ786QQ6AAABAB8AAAPjBFIAEgBTsgITFBESOQCwAEVYsAMvG7EDGD5ZsABFWLAALxuxABg+WbAARViwEC8bsRAQPlmwAEVYsAgvG7EIED5ZsgEDEBESObADELINAQorWCHYG/RZMDEBBzYXFhYHAyMTNicmJyYHAyMTAYYakrqZkhN2tXcGBRGUo3uGtbwEO4mgBATMuf07AsgxKowDA7H8/AQ6AAIARf/oBB8EUgAQACIAQ7IXIyQREjmwFxCwCNAAsABFWLAALxuxABg+WbAARViwCS8bsQkQPlmyFgEKK1gh2Bv0WbAAELIfAQorWCHYG/RZMDEBHgIHBw4CJy4CNzYSNgMGFxYWFxY2Njc2JyYmJyYGBwJ4iMJdDwITlu6Oh8NaDQ+Y7+AHBwp5ZVqYaA8IBQx6ZYzEFwROApD9lhae/44EApD4lagBDJP9uD9EdowDA1/AdVw/eYwEA+K3AAAC/9f+YAP8BFIAEgAeAGeyBB8gERI5sAQQsB3QALAARViwDS8bsQ0YPlmwAEVYsAovG7EKGD5ZsABFWLAHLxuxBxI+WbAARViwBC8bsQQQPlmyCw0HERI5sA0QshcBCitYIdgb9FmwBBCyHAEKK1gh2Bv0WTAxAQYCBicmJwMjATcHNhcWFhcWByM3NCYnJgcDFhcWNgPzFIrMfLxkYbUBBKQUhrucrgUBBrUFb2mdcls9noe9Ahil/viDAwR7/fYF2gF5kAQE3sNAPFSSmwQEmf35kAQD2QACAEn+YAQoBFIAEAAcAGiyAB0eERI5sBrQALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAFLxuxBRI+WbAARViwCS8bsQkQPlmyAgAJERI5sgcACRESObIVAQorWCHYG/RZsAAQshoBCitYIdgb9FkwMQEWFzczASMTBicmJicmEjY2AwcGFhcWNxMmJyYGAkm3YCGn/vy0YoKsmLYHBkaLvs8FA29omXZeQpaJvARPBH9u+iYCBHwEAuLAfAETzWb9uFSRoQIElgIUiwQD2AAAAQAfAAAC1ARUAAwARrIDDQ4REjkAsABFWLAKLxuxChg+WbAARViwBy8bsQcYPlmwAEVYsAQvG7EEED5ZsAoQsgEOCitYIdgb9FmyCAoBERI5MDEBJyIHAyMTNwc2FzIXAsBVrmSFtbyvG3OcITUDlQmd/P8EOgF+lwQPAAEALv/pA7YEUAAmAGOyFicoERI5ALAARViwCC8bsQgYPlmwAEVYsB0vG7EdED5ZsgMdCBESObILCB0REjmwCBCyDwEKK1gh2Bv0WbADELIVAQorWCHYG/RZsiAIHRESObAdELIkAQorWCHYG/RZMDEBNicnJjc2NhcWFgcnNiYnJgcGBwYXFxYWBw4CJyYmNxcUFjMWNgK9D4q87ggH96ekzQS0AmpYXkQ/Cg2AW7qcBgZ4yHGs4AS1dGVjkAElcC43Ur6PtwICu5YBUWYCAjAtSV4rGTCacmWWTwMCxZsBW24CVwAAAQBD/+0ClAVAABYAX7IWFxgREjkAsABFWLABLxuxARg+WbAARViwFC8bsRQYPlmwAEVYsA4vG7EOED5ZsAEQsADQsAAvsAEQsgMBCitYIdgb9FmwDhCyCQEKK1gh2Bv0WbADELAS0LAT0DAxAQMzByMDBhcWMzI3BwYjJiY3EyM3MxMB/S7FGcRxAwIHTiE3DkFDbGwMbr8Zvy4FQP76j/1fGhZOCpcSApuDAp6PAQYAAAEAW//oBB4EOgATAEyyARQVERI5ALAARViwBi8bsQYYPlmwAEVYsBAvG7EQGD5ZsABFWLACLxuxAhA+WbAARViwEy8bsRMQPlmwAhCyDQEKK1gh2Bv0WTAxJQYnJiY3EzMDBhcWFhcWNxMzAyMCzn/Em5UTdLV1BQMFTETCaoi1vKtrgwQE1rkCu/1CLCpIUgMGowMU+8YAAQBuAAAD7QQ6AAYAOLIABwgREjkAsABFWLABLxuxARg+WbAARViwBS8bsQUYPlmwAEVYsAMvG7EDED5ZsgAFAxESOTAxJQEzASMDMwGoAYa//d+K1LL9Az37xgQ6AAEAgAAABf4EOgAMAGCyBQ0OERI5ALAARViwAS8bsQEYPlmwAEVYsAgvG7EIGD5ZsABFWLALLxuxCxg+WbAARViwAy8bsQMQPlmwAEVYsAYvG7EGED5ZsgALAxESObIFCwMREjmyCgsDERI5MDEBATMBIwMBIwMzEwEzA+oBWbv+E5Nw/nqTda1CAYCSAQADOvvGAzL8zgQ6/NoDJgAAAf/EAAAD9AQ6AAsAUwCwAEVYsAEvG7EBGD5ZsABFWLAKLxuxChg+WbAARViwBC8bsQQQPlmwAEVYsAcvG7EHED5ZsgAKBBESObIGCgQREjmyAwAGERI5sgkGABESOTAxAQEzAQEjAwEjAQEzAfABJt7+TgEIxbP+z90Bv/8AxgKwAYr94P3mAZT+bAIsAg4AAf+l/kUD7AQ6AA8AP7IAEBEREjkAsABFWLAPLxuxDxg+WbAARViwBS8bsQUSPlmyAAUPERI5sA8QsAHQsAUQsgkBCitYIdgb9FkwMQEBMwECJyYnNxcWNjc3AzMBowGByP1+htIlSBAvVn0wQbu9AREDKfsS/vkDARGWBQRVX3wEIwAAAf/tAAADzgQ6AAkARACwAEVYsAcvG7EHGD5ZsABFWLACLxuxAhA+WbIAAQorWCHYG/RZsgQAAhESObAHELIFAQorWCHYG/RZsgkFBxESOTAxNyEHITcBITchB+oCYBv8vhkCxf3LHAMcGJeXkQMQmYwAAQA4/pMDFQY/AB0ALrIMHh8REjkAsAAvsA4vsgkADhESOXywCS8YsggDCitYIdgb9FmyFAgJERI5MDEBJiY3NzYnJic3Njc3EiUXBgMHBgcWFxYPAhcWFwHenpQTHAYFEZMQ2SAfOwFfG9QtIiGyZwoDBB8CAhGG/pM176zPMSqICJEK6+QBU2V1Rv718MheTY4sK/NHH581AAEAIf7yAcEFsAADABMAsAAvsABFWLACLxuxAhw+WTAxEyMBM7OSAQ6S/vIGvgAB/4z+kAJqBjsAHAAushkdHhESOQCwDi+wHC+yFhwOERI5fLAWLxiyFwMKK1gh2Bv0WbIFFxYREjkwMQc2Ezc2NyYnJj8CJic3FhYHBwYXFhcHBgcHAgV02SsfH8NxDQQFHwIDlS2ckBMbBgUQkw/aIBwz/pb7RwER4tBdRZMqLfZHuDpxNe+r0DIphwiRCu7P/p5oAAABAGkBjgTdAycAFwA4shEYGRESOQCwDy+wANCwDxCwFNCwFC+yAwEKK1gh2Bv0WbAPELIIAQorWCHYG/RZsAMQsAzQMDEBBgYnJicnJiMmDwI2NhcWFxcWMzI2NwTdDsOMfns8SEKILAicEMONd2xZRD9LaRIDCqPZAgNwOkMDpyUDotEEA11TPW5mAAL/8f6YAaEETwADAA4AJACwAy+wAEVYsAwvG7EMGD5ZsgcFCitYIdgb9FmwAdCwAS8wMRMzAyMBFAYGJjU2Njc2FrOlqb4BrzpgOwE7Ly49Aqz77AVPLz4EPi0wOwIBOgAAAQBS/wsD8wUmACIAUrIHIyQREjkAsABFWLASLxuxEhg+WbAARViwBy8bsQcQPlmyAAMKK1gh2Bv0WbAHELAD0LAHELAK0LASELAV0LAZ0LAVELIcAworWCHYG/RZMDElFjY3NwYGBwcjNyYmJyYSNjY3NzMHFhYVIzQmJyYCBwcGFgHpYZ0brBXRoC61L3eRDgwsebp3LbUtg5OqcGGYxg4BA3SCAnNhAYa9HunsHryNbwEL0oUV4uEgy5VqhAQG/wDkKo6dAAAB//MAAASJBcoAHwBrshEgIRESOQCwAEVYsBIvG7ESHD5ZsABFWLAFLxuxBRA+WbIdEgUREjmwHS+yAAEKK1gh2Bv0WbAFELIDAQorWCHYG/RZsAjQsAAQsAvQsB0QsA3QshUSBRESObASELIZAQorWCHYG/RZMDEBBwYHJQchNxc2NzcjNzM3NiQXFhYHJzYmJyYGBwchBwG4HBRYAssd/BUdQ3EdG6AbnB8ZARbAqMAIuwdiZW6aECABNhsCbtSZZwOdnAIp3c6d/cz2BgTRsQFqegQEpIH7nQAAAgAS/+UFjQTxAB0ALQA/sisuLxESObArELAQ0ACwAEVYsAIvG7ECED5ZsBHQsBEvsAIQsiIBCitYIdgb9FmwERCyKgEKK1gh2Bv0WTAxJQYnJicHJzcmJyYSNyc3FzYXFhc3FwcWFxYCBxcHAQYWFhcWNjY3NiYmJyYGBgPku77HiJ1tnx4KE1lodY1ys7a8ia9vrSAMElFjc4/84g9Kn2x115EQDkmebHbYkG6GBAR+iJCGVVeWASF1nX+UegQCd5iSk1dZkP7meJZ/AnJy0HsEBH7ee3POeQQEftwAAQBTAAAFJAWwABYAawCwAEVYsBYvG7EWHD5ZsABFWLABLxuxARw+WbAARViwDC8bsQwQPlmyDxMDK7IADBYREjm0DxMfEwJdsBMQsAPQsBMQshICCitYIdgb9FmwBtCwDxCwB9CwDxCyDgIKK1gh2Bv0WbAK0DAxAQEzASEHIQchByEDIxMhNyE3ITchATMCbgHV4f3uASkW/owdAXUW/ow5vDj+kRYBbh3+kRYBNv7nywMPAqH9MH2lfP6+AUJ8pX0C0AAAAv/3/vIB2QWwAAMABwAYALAAL7AARViwBi8bsQYcPlmyBQEDKzAxAxMzAxMjEzMJiraKqLaEtv7yAxf86QPIAvYAAv/d/g4EoQXGADEAPwBzALAHL7AARViwIi8bsSIcPlmyFQciERI5sBUQsjoBCitYIdgb9FmyAhU6ERI5sAcQsAvQsAcQsg8BCitYIdgb9FmyLiIHERI5sC4QsjMBCitYIdgb9FmyGzMuERI5sCIQsCbQsCIQsikBCitYIdgb9FkwMQEGBxYHBgQnJiY3NwYWFhcWNjY3NiYkJyY3NjcmNzY2NzYXFhYHIzYmJyYGBwYWBBcEJScGBwYXFgQXNjc2JicEPxLTZw0O/uDe2fILtQY/glhTlFwJDGv+61DyFA7SYw0Ihnd7jc/hDLQIhHyHtw8LYAEPRwEN/hSapxYOSzIBAkGuFgtfdwG3v2Bnqa7MAgTmxwFVfkUBAjZjRU1vWSZz7LhnaqZsrS8wAgTlxn6WBAJ1aVFtVB90BzQvl2Q9KVEZNJNJcCoAAgDbBO4DUgXHAAsAFwAdALAJL7IDBQorWCHYG/RZsA/QsAkQsBXQsBUvMDETNjY3NhYHFAYHBiYlNjY3NhYHFAYHBibbATovLz0BPC8vOwGhATovMDwBPC8uPQVZLj0CATsvLjwCATotLj4CATswLzsCAToAAAMAYv/qBe0FyAAbACkAOgCCALAARViwLi8bsS4cPlmwAEVYsDcvG7E3ED5ZsgM3LhESObADL7QPAx8DAl2yCi43ERI5sAovtAAKEAoCXbIOCgMREjmyEQIKK1gh2Bv0WbADELIZAgorWCHYG/RZshsDChESObA3ELIfBAorWCHYG/RZsC4QsiYECitYIdgb9FkwMQEGBicmJjc3NjYXFhYHJzYmJyYGBhcXFhYXFjcFFgAXFiQSJyYAJyYEAgc2EiQXFgQSBwYCBCcjJiQCBEUOupWRoA4KFM+djpsGjwZFWl9/HQECB09EqiP9LRYBBL67AU23FBb/AMG9/rO2WxbkAV7CsgEcjhUX5P6ovAq3/uiOAlWXpwQE2KdivdsCBKOUAVViAgKR/x4jTVoDB78az/75AgTfAX2+zQECBQTg/ogmxwFkywQCxP6lxMv+nsgBBMQBWwAAAgDDArMDTgXHAB0AJwBgALAARViwFi8bsRYcPlmyAygWERI5sAMvsADQsAAvsgkDFhESObAJL7AWELIPAworWCHYG/RZshIJFhESOXywEi8YsAMQsh4DCitYIdgb9FmwCRCyIQQKK1gh2Bv0WTAxAScGIyImNzY2Mxc3NicmJyYGByc2NhcWFgcDBwYXJTI3NyMGBgcGFgJ2BFxyaXgEBbqnbwkDAgdVOFcPnAuwg3uFCjYEAQj+u0tbHF1YaAgFNgK/SlZ7YXN8ATYbGE8DATE4C21/AgSVfP6lOi0uekSPA0A3Ky4A//8AWQCXA44DswAmAXr6/gAHAXoBOv/+AAEAgQF3A8UDIAAFABoAsAQvsAHQsAEvsAQQsgIBCitYIdgb9FkwMQEjEyE3IQN7ti/9jR0DJwF3AQihAAQAYf/mBe0FyAAPAB8AOQBCAIQAsABFWLAELxuxBBw+WbAARViwDC8bsQwQPlmyFAQKK1gh2Bv0WbAEELIcBAorWCHYG/RZsiEMBBESObAhL7IjBAwREjmwIy+0ACMQIwJdsjohIxESObA6L7IgAgorWCHYG/RZsiogOhESObAhELAy0LAyL7AjELJCAgorWCHYG/RZMDETNhIkFxYEEgcGAgQnJiQCNx4CFxYkEicuAicmBAIFAyMTBRYWBwYGBxYXBwYXFwcjJj8CNiYnJxc2Njc2JicjdhbkAV7CrwEbkxYX5v6lwLP+6JOEDIHNfrsBSroTDoHLfrn+tr0BvTWKhQEBi5UHA0RRTQkBCwIDAooGAgcGBzBElI9IZQkKQVmMAtLHAWTLBAK//qXJzP6dygQEvwFeLoPcdgME3AF8w4XYdAME1v6Db/6uA1EBBYFyOmAuLGE9Vx9AESUkSDZCRQSBAQJFOj8+AwABAOMFIQOwBbAAAwARALABL7ICAworWCHYG/RZMDEBITchA5n9ShcCtgUhjwAAAgDoA70C2AXHAAsAFwAvALAARViwAy8bsQMcPlmwD9CwDy+yCQIKK1gh2Bv0WbADELIVAgorWCHYG/RZMDETNjYXFhYHBgYnJiY3BhYzMjY3NiYjIgbsBKFnYX8CBJ9mYoN9Bj0xNlUGBjg0NlcEt2+hAgKVZXCcAgKRZzFJUDgwT1UAAgAlAAAD/wTzAAsADwBGALAJL7AARViwDS8bsQ0QPlmwCRCwANCwCRCyBgEKK1gh2Bv0WbAD0LANELIOAQorWCHYG/RZsgUOBhESObQLBRsFAl0wMQEhByEDIxMhNyETMxMhNyECngFhGP6gQaRB/ooZAXVBo3H81RgDKwNWl/5iAZ6XAZ37DZgAAQBcApsC5gW/ABcATgCwAEVYsA8vG7EPHD5ZsABFWLAALxuxABQ+WbIXAgorWCHYG/RZsALQsgMXDxESObAPELIIAgorWCHYG/RZsgsPABESObIUFw8REjkwMQEhNwE2NzYmJyYGBwc2NhcWFgcGDwIhAqL9uhQBY2MMBzUwQlAOmguugHiLBQiXQMQBewKbdAEqVEowNgEBSz4BdZUCAn5me30zkQAAAQBuAo0C6wW8ACQAcQCwAEVYsA0vG7ENHD5ZsABFWLAXLxuxFxQ+WbIAFw0REjl8sAAvGLbQAOAA8AADXbANELIHAgorWCHYG/RZsgkADRESObAAELIjBAorWCHYG/RZshIjABESObIbFw0REjmwFxCyHgIKK1gh2Bv0WTAxARc2Njc2JiMiByM2NjMWFgcGBxYHBgYnJiY1MxQWMzI2NzYnJwFXTkJdBwY+MnAdnAuffX6OBQeYdgQFtYV3lZdCOkBbBw2NVwRlAQI9NjExXWV5A3Zhd0IrgW+BAgJ8bDI3QDVmBQEAAAEA1QTYAqUF/gADACMAsAIvsg8CAV2wANCwAC+0DwAfAAJdsAIQsAPQGbADLxgwMQEzASMBv+b+zp4F/v7aAAAB/+X+YAQlBDoAEwBZsg0UFRESOQCwAEVYsAAvG7EAGD5ZsABFWLAILxuxCBg+WbAARViwES8bsRESPlmwAEVYsA4vG7EOED5ZsABFWLALLxuxCxA+WbAOELIFAQorWCHYG/RZMDEBAwYXFhcWNxMzAyM3BiciJwMjAQGeZwoDCpK3YYu2vKITb6KHUFm0AQQEOv2QVDq3AwadAyH7xnOKAkv+KgXaAAABAHsAAAPGBbEACwAksgAMDRESOQCwAEVYsAovG7EKHD5ZsABFWLAALxuxABA+WTAxIRMnJiY3PgIzBQMCFFtA0+EUDpTwkAEV/AIIAQP/yY7adQH6UAAAAQClAmgBhQNMAAsADwCwAy+xCQorWNgb3FkwMRM2Njc2FhUGBgcGJqUBPTIwQAFAMS1BAtYxQQICPjIxPwICOwAAAf/I/ksBEwAAAA0AOQCwAEVYsAYvG7EGEj5ZsABFWLANLxuxDRA+WbIBDQYREjmwBhCyBwYKK1gh2Bv0WbIMBgEREjkwMTMHFgcGBgc3Njc2Jyc3pxWBBAOulgSmEAxoLi43HYZmcgNsBmVHDAaFAAEA3wKiAnAFtwAGAECyAQcIERI5ALAARViwBS8bsQUcPlmwAEVYsAAvG7EAFD5ZsgQABRESObAEL7IDAgorWCHYG/RZsgIDBRESOTAxASMTBzclMwHtmmjcGAFkFQKiAlU4h3EAAAIAwAKtA3sFyQANABsAMwCwAEVYsAAvG7EAHD5ZsgccABESObAHL7IRAworWCHYG/RZsAAQshgDCitYIdgb9FkwMQEWFgcHBgYnJiY3NzY2AwYWFxY2Nzc2JicmBgcCTY2hDQcR0ZaOoQ0HEdNLCkhNT3APCQhKSFJwDgXFBMWZR6bJBATIlkaoyP5IYHMCA3JoUWZtAgJ0ZP//AA8AmANWA7UAJgF7DQAABwF7AV8AAP//ALkAAAUzBa0AJwHVAE4CmAAnAXwBEQAIAQcB2ALAAAAAEACwAEVYsAUvG7EFHD5ZMDH//wC0AAAFeQWtACcBfADmAAgAJwHVAEkCmAEHAdYDBgAAABAAsABFWLAJLxuxCRw+WTAx//8AngAABYwFvQAnAXwBjAAIACcB2AMZAAABBwHXAKMCmwAQALAARViwIC8bsSAcPlkwMQAC/9P+egL2BE8AGAAkAEYAsBAvsABFWLAiLxuxIhg+WbIcBQorWCHYG/RZsADQsAAvsgMQABESObAQELIJAQorWCHYG/RZsBAQsAzQshYAEBESOTAxAQYGBwcGBwYWFxY2NzcGBicmJjc2Nzc2NxMUBgcGJjU2Njc2FgJIDFNpYXcNDV5dYoUStBP0sa2+Dw+/dFsZ9jsvMDsBPC4uPQKpbaFkW3NzYnQCAnFeAafLBATKprevZlWVAUAvPgICPi0vOwIBOQAC/4QAAAd4BbAADwASAHcAsABFWLAGLxuxBhw+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZshEGABESObARL7ICAQorWCHYG/RZsAYQsggBCitYIdgb9FmyCwAGERI5sAsvsgwBCitYIdgb9FmwABCyDgEKK1gh2Bv0WbISBgAREjkwMSEhEyEBIwEhByEDIQchAyEBIRMGt/ynL/3k/vvoBFIDohv9Yj8CPhv9yUcCrfseAbRgAWH+nwWwmP4pl/3tAXgC0gAAAQAoAM4EAgRjAAsAOACwAy+yCQwDERI5sAkvsgoJAxESObIEAwkREjmyAQoEERI5sAMQsAXQsgcEChESObAJELAL0DAxEwEBNwEBFwEBBwEBKAF7/vuAAQYBeWX+iAEGgP75/oUBUgFPAVBy/rIBToP+sP6wcgFQ/rAAAAMAIP+kBZwF6wAZACMALQBmsgwuLxESObAMELAg0LAMELAp0ACwAEVYsA0vG7ENHD5ZsABFWLAALxuxABA+WbIcDQAREjmyJg0AERI5sCYQsB3QsA0Qsh8BCitYIdgb9FmwHBCwJ9CwABCyKQEKK1gh2Bv0WTAxBSYnByM3Jjc2EhI2NhcWFzczAxYXFgICBwYBFhcBJicmAgcGATYnARYXFhITNgJOpnV8l71qBQExd7Lif86Bg5bQMQoOVuKfcP5gAh8Cxk2ctvwsIgMpBAv9TUpyv/0oFhUEUJvoq+ZhASwBA7lhAwR6pf8AdHqp/kT+wUIvAf9sUwOMaAUF/uz0wAFHTk78ijoEBQEmAQ6TAAACADgAAARiBbAADQAWAFqyEBcYERI5sBAQsAnQALAARViwAC8bsQAcPlmwAEVYsAsvG7ELED5ZsgEACxESObABL7IKCwAREjmwCi+wARCyDgEKK1gh2Bv0WbAKELIPAQorWCHYG/RZMDEBAxcWFgcOAiMlAyMTEwMFMjY3NiYnAesz7tDsDwuN7pH+6Te2/WlfAQGLwhEOgXYFsP7bAQHjvILFawH+xwWw/kP93gGZf3iOBAABAB7/5wQZBhUALABbsiAtLhESOQCwAEVYsAYvG7EGHj5ZsABFWLAULxuxFBA+WbAARViwAC8bsQAQPlmyCwYUERI5sBQQshkBCitYIdgb9FmyHxQGERI5sAYQsikBCitYIdgb9FkwMTMjEz4CFxYWBwYGBwYeAgcGBicmJzcWFzI2NzYuAjc+Azc2JicmBgfTtb4Sdrp5n64NCaIMCTaSOgMK6K2ycjtqcWWLCwc3kz0GBThBOQgKTFFpiBUEV4bOagIEspRf9Ew3bJRxPKS7BAJJmUsCY1Y5a5Z3PzthW186UmwEA5eRAAADABP/6AZhBFIALAA3AEEAx7ICQkMREjmwAhCwMdCwAhCwO9AAsABFWLAcLxuxHBg+WbAARViwAC8bsQAQPlmwAEVYsAUvG7EFED5ZsgMcABESObILHAAREjmwCy+0vwvPCwJdsBwQsjgBCitYIdgb9FmwENCyEwscERI5sBwQsBfQshocABESObI8HAAREjmwPC+0vzzPPAJdsiEBCitYIdgb9FmwABCyJwEKK1gh2Bv0WbIqHAAREjmwBRCyLQEKK1gh2Bv0WbALELIyAQorWCHYG/RZMDEFJiYnBiUmJjc2NjMXNzYmJyYGByc2NhcWFhc2Fx4CBwchBhcWFhcWNjcXBiUWNjc3JyIGBwYWASYGByE3NicmJgRwebkzqf7skqkKCv7Z4gwMVlpokA+zEPy6baMiosJ/rkoREv1CCQkNgWhanUo1ivwVRp9CK8t4pgwJWgO7bqo1AgoGCQcLZhQCXVW4BAKtjaC0AVZoeQQCa1YTl7ACAldNqQQCft2KdkRAa30BAjwviXiVAkk57gFxW0pXAzUDnZ4gNzJQXAAAAgBc/+gEVAYrABwAKABQshYpKhESObAWELAm0ACwDi+wAEVYsBgvG7EYHj5ZsABFWLAHLxuxBxA+WbIQDgcREjmwDhCyHwEKK1gh2Bv0WbAHELIlAQorWCHYG/RZMDEBEgMHBgIGJyYCNz4CFxYXJicHJzcmJzcWFzcXAyYnJgYHBhYXFjY3A56xMg0YneGCvOATDorehJpvBGrvO89mskbcltE65ziqkMQTD4Bwf7YfBRP+2f6NW6f+9oUDBAETyZDziAQEb7aZlGx+VjSdOIiCbf03fgUEy6mLuwMF28AAAAMARACpBC4EvQADAA4AGQA7ALACL7IBDgorWCHYG/RZsAIQsQ0KK1jYG9xZsQcKK1jYG9xZsAEQsRIKK1jYG9xZsRgKK1jYG9xZMDEBITchATQ2NzYWFQ4CJgM2Njc2FhUOAiYEDvw2IQPJ/eg9MjBAAT9iPo0BPTIwQAFAYj0CWLgBNzFBAgI+MjE+BDz9ADFBAgI+MjE+BD0AAAMAOf96BCoEuAAZACEAKwBmsgwsLRESObAMELAf0LAMELAo0ACwAEVYsAAvG7EAGD5ZsABFWLANLxuxDRA+WbIcAA0REjmyJAANERI5sCQQsB3QsAAQsh8BCitYIdgb9FmwHBCwJdCwDRCyJwEKK1gh2Bv0WTAxARYXNxcHFhcWBwYCBicmJwcnNyYnJjc3EgADBhcBJicmAiUmJwEWFxY2NzYCfmdbZoSQbgcCCBOf8I5ZXWaEjXYHAgYCJAE2sAozAcs3QJ3RAlcDH/44MjmMyR8NBFACK5UBz4LGN1ac/vmIAgIjlQHNfM09PBABBwEz/WuEWwK6HQIE/u0TSkX9TBcCA9y7XwAAAv/g/mAEBAYAABEAHQBdsgQeHxESObAEELAc0ACwCS+wAEVYsA0vG7ENGD5ZsABFWLAHLxuxBxI+WbAARViwBC8bsQQQPlmyCw0HERI5sA0QshYBCitYIdgb9FmwBBCyGwEKK1gh2Bv0WTAxAQYCBicmJwMjATMDNhcWFhcWBzc0JicmBwMWFxY2A/wUjMt8umVhtQFTtGqDtZ6tAwG6BXBooHBaPZ2JvQIYpv72gQMEfP32B6D9yYkEBOS9PT5UkZwCBJj9+Y8FA9sAAgA1AAAFwQWwABMAFwBrALAARViwDy8bsQ8cPlmwAEVYsAgvG7EIED5ZshQIDxESObAUL7IQFA8REjmwEC+wANCwEBCyFwEKK1gh2Bv0WbAD0LAIELAF0LAUELIHAQorWCHYG/RZsBcQsArQsBAQsA3QsA8QsBLQMDEBMwcjAyMTIQMjEyM3MxMzAyETMwEhNyEFPoMZgrK8df06db2yghmCMr0zAsYzvPwRAsUj/ToEjo78AAKh/V8EAI4BIv7eASL9jsIAAQAuAAABnwQ6AAMAHQCwAEVYsAIvG7ECGD5ZsABFWLABLxuxARA+WTAxMyMTM+O1vLUEOgAAAQAtAAAEVwQ6AAwAaACwAEVYsAQvG7EEGD5ZsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsAIQsAbQsAYvsp8GAV20vwbPBgJdsi8GAV2y/wYBXbIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBMwEBIwGhblC2vLZRUAHR6P3lAXTUAc3+MwQ6/jYByv3q/dwAAQAiAAADsAWwAA0AWwCwAEVYsAwvG7EMHD5ZsABFWLAGLxuxBhA+WbIBDAYREjmwAS+wANCwARCyAgEKK1gh2Bv0WbAD0LAGELIEAQorWCHYG/RZsAMQsAjQsAnQsAAQsAvQsArQMDEBJQcFAyEHIRMHNzcTMwGKAQ4Y/vNhAp4c/KZyihiJdL0DT1OEU/3SnQKNKYQpAp8AAAEAIwAAAjYGAAALAEoAsABFWLAKLxuxCh4+WbAARViwBC8bsQQQPlmyAQQKERI5sAEvsADQsAEQsgIBCitYIdgb9FmwA9CwBtCwB9CwABCwCdCwCNAwMQE3BwcDIxMHNzcTMwGRpRijgbZ1lheVgLUDajyDPf0aAp42gzcC3gAAAQA1/kUFYQWwABMAWrIGFBUREjkAsABFWLAALxuxABw+WbAARViwEC8bsRAcPlmwAEVYsAQvG7EEEj5ZsABFWLAOLxuxDhA+WbAEELIJAQorWCHYG/RZsg0OEBESObISDgAREjkwMQEBBgYnIic3FjMyNzcBAyMTMwETBWH++RnBlzVDHjgphCUR/gzGu/y1AfjFBbD5/ay8BBSZEb1eBHL7jgWw+5AEcAABACT+RwPyBFIAGwBaALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAKLxuxChI+WbAARViwGS8bsRkQPlmyARkDERI5sAoQsg8BCitYIdgb9FmwAxCyFgEKK1gh2Bv0WTAxAQc2FxYWBwMGBiciJzcWMzI3EzYnJicmBwMjEwGBFoy/o5kVfRa/ljVDHzUujCB8BgMOpJ9xjra8BDubsgQE4738/aa6AhScEMUC+TYwoAUEifzTBDoAAgBU/+0HZQXHABYAJACRshUlJhESObAVELAa0ACwAEVYsAsvG7ELHD5ZsABFWLANLxuxDRw+WbAARViwAC8bsQAQPlmwAEVYsAMvG7EDED5ZsA0Qsg8BCitYIdgb9FmyEg0AERI5sBIvshMBCitYIdgb9FmwABCyFQEKK1gh2Bv0WbADELIXAQorWCHYG/RZsAsQshwBCitYIdgb9FkwMSEhBwcmJgI3ExIAHwIhByEDIQchAyEFFjcTJiMmBgcDBhcWFgZy/NTZRZjbYRUvKwFZ80rTAzkc/UNRAmQc/Z1aAsj7oEyK0Wxfr+whLwoHCo4SAQSeARKfASsBEgFKAgITnv4snf38GAMNBJARAvPU/tROToOXAAMAR//mBuIEUwAiADMAPQChshk+PxESObAZELAt0LAZELA30ACwAEVYsAUvG7EFGD5ZsABFWLAALxuxABg+WbAARViwGy8bsRsQPlmwAEVYsBYvG7EWED5ZsgMFFhESObI4BRYREjmwOC+yCgEKK1gh2Bv0WbAWELIQAQorWCHYG/RZshIFFhESObIZBRYREjmwGxCyKAEKK1gh2Bv0WbAFELIwAQorWCHYG/RZsDTQMDEBFhYXNhceAgcHIQYXFhYXFjcXBgYnJiYnBicuAjc3EgADBhcWFhcWNj8CNCYnJgYHASYGBwU3NicmJgJ+eb4rstl9sEoRE/1MCAYKdWCskD1EyHN8vSyr9IW8VRACJAEtnQcEBXNliMMaAgVzbYzBFwRSZaU3Af4FCAcNZwROAnRj3QMCftyIej1AbIEDBm9/QUICAnFf2QYCjvmVEAEFATT9tz5EdY8DBdy7FlePpAQF57UBlwOalwEcNTFPWwABADMAAAMKBhoADQArALAARViwBC8bsQQePlmwAEVYsA0vG7ENED5ZsAQQsgkBCitYIdgb9FkwMTMTNjYXMhcHJiciBgcDM8sWxp4vYyEsLFd1Ec0Eq6vEAhaPDAJvZvtUAAIAUf/pBSoFxgAaACQAUQCwAEVYsBIvG7ESHD5ZsABFWLAALxuxABA+WbIFABIREjmwBS+wEhCyDAEKK1gh2Bv0WbAAELIbAQorWCHYG/RZsAUQsh8BCitYIdgb9FkwMQUmJgI3NwU3NicmJicmByc2NhcWBBIHBwYCBCcWNjcFBwYXFhYCT67tYxoUA9ADFQkPvZimyiNE1IG4AQFxGg4fzv7fnaX7R/zoBw8KEKQUAqgBL758AwxjYJy5AwNWkS82AwKz/r7GY8j+uKqgBfXyASNZUIGRAAH/Sf5GAy8GGgAdAHGyEh4fERI5ALAARViwFC8bsRQePlmwAEVYsA8vG7EPGD5ZsABFWLAcLxuxHBg+WbAARViwBS8bsQUSPlmwHBCyAAEKK1gh2Bv0WbAFELIKAQorWCHYG/RZsAAQsA3QsA7QsBQQshkBCitYIdgb9FkwMQEjAwYGJyYnNxYzMjcTIzczNzY2FzIXByYjIgcHMwKDxJ0Uu5c1Phw1KoggnaYWpg4VxpgzXB03KLQdDcUDq/v8p7oCAhOSEM4D/o9xr8ACFZUM3WMAAgBn/+kGGwY3ABgAKABOALAARViwCi8bsQocPlmwAEVYsAAvG7EAED5ZsgwAChESObAML7ISAgorWCHYG/RZsAoQshwBCitYIdgb9FmwABCyJAEKK1gh2Bv0WTAxBS4CJyY3NhIkFxYXNjY3NwIFFhcWAgIEATYmJyYCAwYHBhYXFhI3NgJAi9BzBgUbIsUBFaflhmRzE6Ej/uQaBQZNuf7wAVQGlZW+/iYTAQaWlMT8IhIUA4P1nG2nzwFBoAMEmQqFgAH+tkJpaZj+cf7XoAOWxNgEBf7Z/v5/SL/jBAUBL/6DAAACAEL/5wT/BLAAFgAlAE4AsABFWLAALxuxABg+WbAARViwDy8bsQ8QPlmyAg8AERI5sAIvsgkCCitYIdgb9FmwDxCyGgEKK1gh2Bv0WbAAELIiAQorWCHYG/RZMDEBFhc2NjczBgYHFhcWAgQnLgI3NzYAAxQWFxY2NzYnJiYnJgYGAoLEeUtSE5AQeXYSBAqO/vSliL9YEAMiATSoeG6NyRsHBAl2Zm6uWwRPBIkOY32UpCBLS8f+qb0EBI74lRX+ATb9YIyhBAXjyT9FeY0EBI/4AAEAZ//oBpoGAgAaAEYAsABFWLASLxuxEhw+WbAARViwDS8bsQ0QPlmwEhCwGtCyAQ0aERI5sAEvsggCCitYIdgb9FmwDRCyFgEKK1gh2Bv0WTAxAQc2Njc3BgYHAw4CJyYCNxMzAwYWFxY2NxMFJh5vdxOZF9LAcBaf/5ja9BqouacRi4yV0ByrBbDZDoyQAc7WC/2DlOF5AwQBD9gD2vwlm64EBKqdA+UAAQBa/+gFTgSRABsAUwCwAEVYsA0vG7ENGD5ZsABFWLAFLxuxBRA+WbAARViwCC8bsQgQPlmwDRCwFtCyGBYIERI5sBgvsgMCCitYIdgb9FmwCBCyEwEKK1gh2Bv0WTAxAQYGBwMjNwYnJiY3EzMDBhcWFhcWNxMzBzY2NwVODqKllqsXfcWclxV0tXUFAwVMRMFriLQYW1cUBJGongb8u2uDBATYtwK7/UIsKkhSAwilAxSGB1SBAAH/Cf5GAa8EOgAMACgAsABFWLAMLxuxDBg+WbAARViwBC8bsQQSPlmyCQEKK1gh2Bv0WTAxAQMGBicmJzcWMzI3EwGvxha+mDY+HjUqiiTGBDr7bqa8AgITkhDTBIgAAAIAPv/pA98ETgAYACIAUQCwAEVYsAAvG7EAGD5ZsABFWLAJLxuxCRA+WbIOAAkREjmwDi+wABCyEwEKK1gh2Bv0WbAJELIZAQorWCHYG/RZsA4QshwBCitYIdgb9FkwMQEeAgcHBgIGJyYCNzchNicmJicmByc2NwMWNjclBwYXFhYCR4a8Vg8EEZXlgsHAGhICswgGCnRgqZM9e9NOZKU3/gMGCAgLaQROAoz2lSSW/v+RBAYBCNR5PUBtgQMGb353C/w2A5qXARw1MU5eAAABARcE4gNkBgAACAAxALAFL7AB0LABL7EACitY2BvcWbAFELAH0LAHL7QPBx8HAl2wA9CwABCwBtCwBi8wMQEVJycHBzUBMwNkk3GwmQEWagTwDgKpqAMQAQ4AAAEBJgTjA4AGAQAIACAAsAQvsALQsAIvtA8CHwICXbIABAIREjmwB9CwBy8wMQE3NxcBIwM1FwIvsZ8B/uJuzpYFVqgDDf7vARAOAv//AOMFIQOwBbAABgBwAAAAAQEHBMcDTAXYAAwAIgCwAy+yDwMBXbIJBAorWCHYG/RZsAfQsAcvsADQsAAvMDEBBgYnJiY3FwYXFjY3A0wMq4B7kwKTB4FHUgwF132TBAKSeQGSBAFVQQAAAQEOBOsB4wXFAAsAEQCwCS+yAwUKK1gh2Bv0WTAxATQ2NzYWFQYGBwYmAQ46MC49ATsvLD4FVC8+AgI7MC88AgI5AAACAQEEswKkBlEACwAXACUAsAkvsBXQsBUvsgMICitYIdgb9FmwCRCyDwgKK1gh2Bv0WTAxATY2MzIWFQYGIyImNwYWMzI2NzYmIyIGAQMCgVlScwKBWVRzYgQ2Ky5PBgY4Ki5QBXhbfnRVWXxyVS4/RzIuQkkAAf+v/k8BFgA5AA8AJwCwEC+wAEVYsAovG7EKEj5ZsgUDCitYIdgb9FmwEBCwD9CwDy8wMQUHBgcGFxY3FwYjIiY3NiUBFkF6CQdBIEMERFNOXwIDARYDL1pZPwIBGnkrZVKxggAAAQDdBNoDrgXnABUAPgCwAy+wCNCwCC+0DwgfCAJdsAMQsArQsAovsAgQsg4DCitYIdgb9FmwAxCyEwMKK1gh2Bv0WbAOELAV0DAxAQYGIyIuAgcGByc2NhcyHgI3MjcDrgx6XSU9PD4kVR96DH1dGy9qMRtWIAXdb4YfJh4BA20HbowCEUESAXEAAgDCBNADvgX/AAMABwA7ALACL7AA0LAAL7QPAB8AAl2wAhCwA9AZsAMvGLAAELAF0LAFL7ACELAG0LAGL7ADELAH0BmwBy8YMDEBMwEjAzMBIwLm2P7GszTN/vefBf/+0QEv/tEAAv/p/moBNf+2AAsAFwA5ALAYL7AD0LADL0ALAAMQAyADMANAAwVdsA/QsA8vsgkHCitYIdgb9FmwAxCyFQcKK1gh2Bv0WTAxBzQ2MzIWFRQGIyImNwYWMzI2NzYmIyIGF2hGRFpjRkVeVAQoIB87BwQmHiU6+UlmX0NHY1lGHy8xJyEwOQAB/WoE2P6/Bf4AAwAeALABL7AA0BmwAC8YsAEQsALQsAIvtA8CHwICXTAxASMDM/6/jsfMBNgBJgAAAf3rBNj/wgX+AAMAHgCwAi+wAdCwAS+0DwEfAQJdsAIQsAPQGbADLxgwMQEXASP+2en+yJ8F/gH+2wD///0LBNr/3AXnAAcApPwuAAAAAf31BNj/NgZzAA0AJQCwDS+wB9CwBy+yDA0HERI5sgEHDBESObIGBgorWCHYG/RZMDEBNzc2NzYjNxYWBwYHB/31FilrCgubD4KMAweiDATZmQQKQkdqA2BRgh1IAAL82wTk/4YF7gADAAcANwCwAS+wANAZsAAvGLABELAF0LAFL7AG0LAGL7YPBh8GLwYDXbAD0LADL7AAELAE0BmwBC8YMDEBIwMzASMDM/6KtPvqAcGfwdYE5AEK/vYBCgAAAfy7/p/9kP95AAsAEQCwAy+yCQUKK1gh2Bv0WTAxBTY2NzYWFQYGBwYm/LsBOi8uPQE7Lyw++C8+AgI7MC88AgI5AAABASEE7gJBBj8AAwAdALACL7AA0LAAL7IPAAFdsgMCABESORmwAy8YMDEBMwMjAZGwrHQGP/6vAAMA8wTtA+4GiAADAA4AGQA6ALAML7AC0LACL7AA0LAAL7ACELAD0BmwAy8YsAwQsgYFCitYIdgb9FmwDBCwFdCwFS+wBhCwGdAwMQEzAyMFPgIWFRQGBwYmJTYWFQYGBwYmNjYCir6Riv7GATpePDwvLD4CkCw/ATwuLzwCOgaI/vgoLz0EPC4vPAICOZ0CPC8vPAICOl4+AP//AKUCaAGFA0wABgB4AAAAAQBDAAAEpQWwAAUAKwCwAEVYsAQvG7EEHD5ZsABFWLACLxuxAhA+WbAEELIAAQorWCHYG/RZMDEBIQMjEyEEif1Y4b39A2UFEvruBbAAAv+xAAAE3gWwAAMABgAvALAARViwAC8bsQAcPlmwAEVYsAIvG7ECED5ZsgQBCitYIdgb9FmyBgIAERI5MDEBMwEhJSEDAwKnATX60wEjAzLUBbD6UJ0EJgAAAwBp/+kE/AXIAAMAFgAnAFcAsABFWLANLxuxDRw+WbAARViwBC8bsQQQPlmyAgQNERI5fLACLxi0YAJwAgJdsgEBCitYIdgb9FmwDRCyGwEKK1gh2Bv0WbAEELIjAQorWCHYG/RZMDEBITchASYCJyYSNzYkFxYSFxYHBwYCBAE2JiYnJgADBgcGFhcWEhM2A6/+CRsB9/540/cKBTBCXQEwvtT2CQMKDB/C/ucBVAQ8iGPB/wAkEAEGlpS6+ykUApOY/MEEAR/0YgFCjMTRBAT+4/dUU1TZ/ralA5V7v2UDBf7O/vh0Q8DhBAcBGwEBfgAB/8QAAARxBbAABgAxALAARViwAy8bsQMcPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbIAAwEREjkwMQEBIwEzASMC7P2p0QL/qAEGwgSH+3kFsPpQAAADAAwAAASGBbAAAwAHAAsATwCwAEVYsAgvG7EIHD5ZsABFWLACLxuxAhA+WbIAAQorWCHYG/RZsAIQsAXQsAUvsi8FAV2yBgEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDE3IQchEyEHIRMhByEoA44c/HLlAtwb/SM4A3kc/IadnQM/nQMOngAAAQBEAAAFcAWwAAcAOACwAEVYsAYvG7EGHD5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmwBhCyAgEKK1gh2Bv0WTAxISMTIQMjEyEEc7zh/UnhvP0ELwUS+u4FsAAAAf/aAAAEiQWwAAwAPACwAEVYsAgvG7EIHD5ZsABFWLADLxuxAxA+WbIBAQorWCHYG/RZsAXQsAgQsgoBCitYIdgb9FmwB9AwMQEBIQchNwEBNyEHIQEC8v31AvEc/B4bAjj+khgDshz9MwFUAtD9zZ2YAkoCR4ee/dYAAAMAVAAABXAFsAAJABMALABZALAARViwHi8bsR4cPlmwAEVYsCsvG7ErED5ZshQrHhESObAUL7IAAQorWCHYG/RZsh0eKxESObAdL7Ag0LIKAQorWCHYG/RZsAHQsAAQsAvQsBQQsCnQMDEBEyMmBgYHBhYXAQMXFjY2NzYmJwEGJiY3NhIkFzM3FwcyFhYHBgIEJyMHIzcCO5MCZLiFDhWQnAFWlANit4QRFZKa/pqF4m8PD6sBFZ4NJ7opiuJvDxCt/uOZBiS+JAFOAwwRX89zpM0LAwr89QENW8d7qMkL/FgBjvmUmwEBkwK5AbiO+ZSc/vyTBq+wAAABAIYAAAWdBbAAGQBcsgoaGxESOQCwAEVYsAQvG7EEHD5ZsABFWLAQLxuxEBw+WbAARViwGC8bsRgcPlmwAEVYsAsvG7ELED5ZshcECxESObAXL7AA0LAXELIMAQorWCHYG/RZsAnQMDEBNjY3EzMDBgAHAyMTJgI3EzMDBhcWFhcTMwL/nM0dXLxdK/7D70S9RdDXG1i8WQkHCndkpr0CCBnTowIZ/dvr/uEX/pYBbB4BNuICDv3xRUFqjRgDpAABAAoAAATaBccAJgBZsgAnKBESOQCwAEVYsBovG7EaHD5ZsABFWLAQLxuxEBA+WbAARViwJS8bsSUQPlmyIwEKK1gh2Bv0WbAA0LAaELIIAQorWCHYG/RZsAAQsA/QsCMQsBLQMDElNhI/AjYmJyYGAhcWFhcHITc3AhM3NhIkFx4CFxYCBwYHNwchAnuYxiYRCAOKiKjmSQQDaV8Z/iIc1qEpFB61AQief8Z0CQc9WVB32Bz+KaEhARj3eWuqxAQF+f5JfpWvGKKdAgEDATSEtAEhmAMDdt+LaP6clodeA50AAgBI/+cEMgRUABgAJQB5shUmJxESObAVELAi0ACwAEVYsBUvG7EVGD5ZsABFWLAYLxuxGBg+WbAARViwDi8bsQ4QPlmwAEVYsAovG7EKED5ZsgUBCitYIdgb9FmyDBUKERI5shcVChESObAOELIdAQorWCHYG/RZsBUQsiIBCitYIdgb9FkwMQEDBhcWFzM3FwYnJicGJyYCNzc2ABcWFzcBBwYWFxY3EyYnJgYHBDKECAQFKhEQCjU9jBCKwK+1FwssAQG5wFgv/X4FA21mpHVMOJqMthoEOvzrOh04AgOLIAEEn6kEAwEc50v5AR8FBp2O/bNRhJYCA74BwbMHBe3MAAAC//D+gARMBccAEwApAGWyGyorERI5sBsQsBPQALAOL7AARViwAC8bsQAcPlmwAEVYsAsvG7ELED5ZshQACxESObAUL7InAQorWCHYG/RZsgUnFBESObAAELIaAQorWCHYG/RZsAsQsiEBCitYIdgb9FkwMQEWFgcGBxYWBwYEJyYnAyMTPgITNjY3NiYnJgYHAxYWMxY2NzYmJyc3AtKszg4R1l5gCRD+5susb1a2+RGL2A16mgsKaWJsqROOKYhJg7oQDmhhlxsFxATXprxyLrp9y/4EBF3+NAWxcrpq/ZECgW1hgQQCj2/8wzs4AqeFcZ8FAZcAAAEAhP5gBBoEOgAIADiyAAkKERI5ALAARViwAS8bsQEYPlmwAEVYsAcvG7EHGD5ZsABFWLAELxuxBBI+WbIABwQREjkwMQEBMwEDIxMDMwG+AZzA/dhQtVW+sQEWAyT79P4yAesD7wAAAgBD/+cEEwYgACAALwBisgIwMRESObACELAo0ACwAEVYsAMvG7EDHj5ZsABFWLAVLxuxFRA+WbADELIIAQorWCHYG/RZsi0VAxESObAtL7IOAQorWCHYG/RZsh0tDhESObAVELInAQorWCHYG/RZMDEBNjYXFhcHJgciBgcGFxcWEgcHBgAnLgI3NzY2NzcmJgMGFxYXFhcWNjc2JicmBgFPB+KqepAUgn5VdQoPjzW1pRQDIf7U0oe9Vg4DF9mjA0xUQQcFC1cwTYXAHg97bYfEBO2OpQICN6E/Ak5AXUEYS/7lwhX2/t0FBIjwkhaz/R8NJYb9Xz5BjEMlAgXOyoniDxLnAAEAKf/nA+UETQAoAHiyJikqERI5ALAARViwGS8bsRkYPlmwAEVYsA0vG7ENED5ZsicZDRESOXywJy8YsoAnAV20QCdQJwJdsgABCitYIdgb9FmwDRCyBgEKK1gh2Bv0WbIKGQ0REjmyEwAnERI5sh0ZDRESObAZELIhAQorWCHYG/RZMDEBIgYHBhYXFjY3NwYEJyYnJjc2NyYmNzY2NzcWFgcnNiYnIgYHBhcXBwIFfJUKCXxqa6gRtRD+9MSLaKQKCudCTQQG2rwtrtUDsgJzY2yYDBPQ1BsB315ZSlwDAmtXAZ67BQI2Vq24UiJ0Q4utCgEFsI0BS10DW1GSBgGUAAEAgv6ABDwFsAAcADmyEx0eERI5ALANL7AUL7AARViwAC8bsQAcPlmyGgEKK1gh2Bv0WbAB0LAUELIIAQorWCHYG/RZMDEBBwEHBgcGFhcXFgcGByc3Njc2JycmJjcSAQEhNwQ8F/4vKsYZCilKzYsKCsZcIk4KCF9vin4QHAFCAVb9nRsFsIH+IC3X0EtpG0UyhJiZWSRURDogISurkAEMAUoBTJgAAAEAJP5hA/MEUgASAFOyCBMUERI5ALAARViwAy8bsQMYPlmwAEVYsAAvG7EAGD5ZsABFWLAHLxuxBxI+WbAARViwEC8bsRAQPlmyAQMHERI5sAMQsg0BCitYIdgb9FkwMQEHNhcWFgcDIxM2JyYnJgcDIxMBghWOu6aXFbu1uwYEDaWpboi2vAQ7iaAEBNPB+6sEUjYvnAMEqfzuBDoAAwBz/+UEKwXKABEAGwAkAGayGSUmERI5sBkQsADQsBkQsCLQALAARViwCS8bsQkcPlmwAEVYsAAvG7EAED5ZshIACRESOXywEi8YsAkQshgBCitYIdgb9FmwEhCyHQEKK1gh2Bv0WbAAELIiAQorWCHYG/RZMDEFLgI3NhI3NgUWEgcGBwcCAAEhNzYnAicmBgcFIQYXFhYXFhMB3HmlSwQDTmKQAQO2uAYCCRwz/un+lQIYCQ8CC7iIrykB+/3pFgMDZFr0WxQDfu2XcwHen+kGBP727UtFt/61/q4DOzlySgERBwTo8NCAZYyTAwwBkQABAIX/9AHuBDoADgAoALAARViwAC8bsQAYPlmwAEVYsAovG7EKED5ZsgUBCitYIdgb9FkwMQEDBhcWFzI3BwYnJiY3EwHMiAMCBk8iNAxHPmxsDIcEOvzXGhZKAwqYEgICmIQDJgAB/7f/8APABewAGQBNsg4aGxESOQCwAC+wAEVYsAovG7EKED5ZsABFWLAPLxuxDxA+WbAKELIFAQorWCHYG/RZsg4AChESObAAELIVAQorWCHYG/RZsBfQMDEBMhcTFhczNwcGByImJwMBIwEnJiYnJwc3NgGOtijiFDkTEgYeKFBiIH3+Y9ECNzQRKyMYGQwwBeyu+6tTAwKaCQJWdQJO/PcEEOA6JwIBAY4LAAABAD/+dwQPBcgALgBSshkvMBESOQCwGC+wHi+wAEVYsCwvG7EsHD5ZsgIBCitYIdgb9FmyCSwYERI5sAkvsgsBCitYIdgb9FmwHhCyEQEKK1gh2Bv0WbIlCwkREjkwMQEmIyIGBwYWFxcHJyIGBwYeBAcGBgcnNzY3NicmJyYTNjY3JiY3Njc2FxYXA+V+WYyzDQ+PlIsbf8HoEQxx9Fk/IwMFaWBkOz4IClinRPUXDLuvXWYFC6SPxYN7BQgmaVtkbwEBmAGvm2ycQyAtRTNInElXPUQ/OhgtIXQBFo/POSqVVrVeUQMCJwABAGD/9ASkBDoAFgBcsg0XGBESOQCwAEVYsBUvG7EVGD5ZsABFWLALLxuxCxA+WbAARViwES8bsREQPlmwFRCyAAEKK1gh2Bv0WbALELIGAQorWCHYG/RZsAAQsA/QsBDQsBPQsBTQMDEBIwMGFxYzFjcHBicmJjcTIQMjEyM3IQSJl28DAgdPJS8JQkJtbQxs/nyhtaGkGwQpA6H9cBoWTAIMmRIBApiFAo38XwOhmQAAAv/c/mAD+QRTABMAIABQsg8hIhESObAPELAX0ACwAEVYsAUvG7EFGD5ZsABFWLASLxuxEhI+WbAARViwDy8bsQ8QPlmyFgEKK1gh2Bv0WbAFELIdAQorWCHYG/RZMDETNjY3NhceAhcWBw4CJyYnAyMBFhcWNjc3NiYnJgYHhhFXR4rGc6VYAwEJE4HJgbxjYbYBL0GZibcWCQdkbXqoHgJBcMlJkAUDbM1/PGKY84ECBHr99wKzjQQDzapro7AEAtS3AAEATv6JA+sEUwAhAEqyGSIjERI5ALATL7AARViwAC8bsQAYPlmwAEVYsBkvG7EZED5ZsgMAExESObAAELIHAQorWCHYG/RZsBkQsg0BCitYIdgb9FkwMQEWFgcnNiYnJgYHBwIFFxYHBgYHJzc2NzYnJyYCNzc2EjYCe6vFCqoHaGWDvRsEHgE0VpUKBWtdXClHCQdOLs/HEwQRlucETwTYrwFtgQQF274d/vFjHTiIR6BHWitLRz0XDDkBB8UrlgEAjQACAEr/5gStBDsAEgAhAEyyHiIjERI5sB4QsBHQALAARViwEi8bsRIYPlmwAEVYsAcvG7EHED5ZsBIQsgEBCitYIdgb9FmwBxCyFgEKK1gh2Bv0WbABELAe0DAxAQUWBwcGACcuAicmNzc2ADMFARQWFxY2NzYnJiYnJgYGBJL+7ZAXAR7+zM1urGYJBQcCIAEq2wI1/FVzbIvBGgkFCXVjaqZYA6EDqfAK7v7ZBgFmwHZCQxDzASoB/XqPoAQF37laPHCFAwOC6QAAAQCH/+wEEAQ6ABEASbIDEhMREjkAsABFWLAQLxuxEBg+WbAARViwCi8bsQoQPlmwEBCyAAEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAAQsA7QsA/QMDEBIQMHFDMyNxcGJyYmNxMhNyED9v6YcAFIITseT11sZw1r/q8bA24DpP1oLVQXhDIBApaSAo2WAAEAZ//lA/oEPAAVADyyBhYXERI5ALAARViwAC8bsQAYPlmwAEVYsAsvG7ELGD5ZsABFWLARLxuxERA+WbIFAQorWCHYG/RZMDEBAwcUFhcWEgMnJicXFhcSACUmJjcTAaFtBUpHpNsHAgoitiYFD/7G/v6vqBdtBDr9bV1dagIGAXUBFjaDfQJ9gv57/i8GBPDNAo4AAAIAQf4iBTgEPgAaACMAX7IYJCUREjmwGBCwG9AAsBkvsABFWLARLxuxERg+WbAARViwBi8bsQYYPlmwAEVYsAAvG7EAED5Zsg0BCitYIdgb9FmwABCwGNCwDRCwG9CwERCyIQEKK1gh2Bv0WTAxBSYCNzYSNxcGAhcWFhcTNjYXHgIHBgAFAyMBNhInJiYHBgcCAuDhHRSljlaBexMOhm17DZJufsJdDhv+rP78VbUBI8HtBgd4YzwSDx0BOeaoAQxaiGr+2IRskRgCz2eAAgKU+If1/tIV/jMCYx8BFL6OpggEQQAAAQBP/igFTwQ8AB0ARLIdHh8REjkAsA8vsABFWLAWLxuxFhg+WbAARViwES8bsREQPlmyHAEKK1gh2Bv0WbAB0LAWELAd0LAH0LARELAO0DAxAQM2EgMnJicXFhcSBQYHAyMTJgI3EzMDBhcWFhcTA2ul1u8JAwwltScIHf74pPJUtVXe0CFStVIKBAV5cKkEOvxLJQFCARU+gnsCe4H+JdqHE/45AcsfAUb8Aeb+F0xJe58ZA7EAAAEAZv/kBfwEPAAqAFqyISssERI5ALAARViwAC8bsQAYPlmwAEVYsBgvG7EYGD5ZsABFWLAfLxuxHxA+WbAARViwJC8bsSQQPlmyCAEKK1gh2Bv0WbIMHwAREjmwEtCyIggfERI5MDEBBwYCBxUUFhcWExMzAwYHBhYXFhM2JyYnFxYXFgIGJyYmJwYnLgI3EhMCCUhLWwJPStM8M7YvBgECUlC1TDQUDS23LwoRb+CbbJgUfd9nkEEDBdcEOX+D/vqfCn+FAw0BTwE//tQvOmt/AgcBKMzOg30CfILa/l7ZBAKBbPYHA3DSgAFeASwAAAIAUf/nBG0FywAkAC8Aa7ImMDEREjmwJhCwFNAAsABFWLAeLxuxHhw+WbAARViwBy8bsQcQPlmyKB4HERI5sCgvshcBCitYIdgb9FmwAtCyDR4HERI5sAcQshMBCitYIdgb9FmwKBCwItCwHhCyLAEKK1gh2Bv0WTAxAQYHBwYHBicuAjcTNwMGFxYWFxY2NzcmAjc3NjYXFhYHAzY3AQYWFxM3JicmBgcEZzRgHyeCgLh6tFQPNrY2BwcLaVV3lxYewNIOAg7MlZGXEjtONv3kCm5+OwQEb0hbCgJyEg230nNwBQN10H8BTgL+rzg1VmQDA52QqSYBFMUQmscEBM6k/p4LDgFQgLklAVhIjQICaVkAAAEAZwAABNgFwQAaAEmyABscERI5ALAARViwBC8bsQQcPlmwAEVYsBcvG7EXHD5ZsABFWLANLxuxDRA+WbIABA0REjmwBBCyCQEKK1gh2Bv0WbAS0DAxAQE2NhcyFwcmIyYHAQMjEwMmJyYHJzYzFhYXAi0BLTZ5T0BALx0VQjb+amG6Za0aOw8mFTY+S2QgAwgB+2ZYAhyXCQJT/Wv90QJIAntJAwEImRkCV2AAAAIAZv/kBkQEOgAWACwAarIJLS4REjmwCRCwJ9AAsABFWLAVLxuxFRg+WbAARViwBy8bsQcQPlmwAEVYsAwvG7EMED5ZsBUQsgABCitYIdgb9FmyChUHERI5sBTQsBnQsAcQsikBCitYIdgb9FmwINCyJBkHERI5MDEBIxYVFAIGJyYmJwYnLgI3NjY3BzchASYnJQYGBwYWFxYTNzMHBwYWFxYTNgYngAdyw4VvlxJ+3WGCOAYHREB1HAWm/rMDC/zTUEkHBT1C2TgmtycGB1JWqTwdA6FcWtD+hroEAoNr9wcDctt9ledvApn+slpbAYvqmn+OBQ4BaPf8RYSLAgQBTqEAAQCh//IFegWwABkAYQCwAEVYsBgvG7EYHD5ZsABFWLAULxuxFBA+WbAARViwCi8bsQoQPlmwGBCyFwEKK1gh2Bv0WbAB0LIEFBgREjmwBC+wChCyCwEKK1gh2Bv0WbAEELIRAQorWCHYG/RZMDEBIQM2FxYWBwYEBzc2Njc2JicmBwMjEyE3IQTq/gdWo3bW8BES/t7zC5e5Dw6JhXynerzh/m0cBEkFEv44MgMC8c7U7gSYAp6PhpECAy79WQUSngABAHj/5gT/BccAJABqALAARViwDS8bsQ0cPlmwAEVYsAMvG7EDED5ZsA0QsREKK1jYG9xZsA0QshQBCitYIdgb9FmwAxCwGNCwGC+yLxgBXbIZAQorWCHYG/RZsAMQsiEBCitYIdgb9FmwAxCxJAorWNgb3FkwMQEGACcuAicmEhI3NhcWEhcjJiYnJgYDIQclBwYHBhYWFxY2NwSXKv6744fJcQYGTeaobXvN8Ae6B4qBrvY7AjAc/d0CDAMGQYJcmsczAdDi/vgGA3/uknABuAFFQSsDBP7/5KihAwX8/v2dBQo0Om6/ZAMFnawAAv/MAAAH8gWwABgAIQBushoiIxESObAaELAK0ACwAEVYsAAvG7EAHD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyAgAIERI5sAIvsAAQsgoBCitYIdgb9FmwEBCyEgEKK1gh2Bv0WbAb0LACELIhAQorWCHYG/RZMDEBAwUWFgcGBCMhEyEDBwICByM3NzY2EzcTAQMFMjY3NiYnBV5jAUjM4xET/tbk/eXi/hF4Hz7wu0wSJoSoKxWPAuFkAUqMwhIPf3cFsP3LAQbwwM33BRL91Jn+zv7pBJwBBugBBHcCqv0t/cABpYd8lAQAAgBDAAAH/gWwABIAGwCCsgEcHRESObABELAT0ACwAEVYsBIvG7ESHD5ZsABFWLACLxuxAhw+WbAARViwDy8bsQ8QPlmwAEVYsAwvG7EMED5ZsgACDxESObAAL7IEDAIREjmwBC+wABCyDgEKK1gh2Bv0WbAEELITAQorWCHYG/RZsAwQshQBCitYIdgb9FkwMQEhEzMDBRYWBwYEIyETIQMjEzMBAwUyNjc2JicBjwK3brtqATfR8Q8R/tjn/eh0/Ul0vf28Au5bAUmLwBEPfX0DOQJ3/Z4BAd27x+0CnP1kBbD9Af31AZN/bocEAAEAtAAABaIFsAAXAFeyAxgZERI5ALAARViwFi8bsRYcPlmwAEVYsAgvG7EIED5ZsABFWLASLxuxEhA+WbAWELIVAQorWCHYG/RZsAHQsgQIFhESObAEL7IPAQorWCHYG/RZMDEBIQM2FxYWBwMjEzYnJiYnJgcDIxMhNyEE/P4AUZyp39MXS71MCAgMb2uMw3+84v5zHARIBRL+TykCBOvS/jkByEU2UVMDAyr9PQUSngABAEL+mQVuBbAACwBIALAJL7AARViwAC8bsQAcPlmwAEVYsAQvG7EEHD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAD0DAxATMDIRMzAyEDIxMhAT+84QK34rv9/k4+vT/+PwWw+u0FE/pQ/pkBZwACADQAAASWBbAADAAVAFuyDxYXERI5sA8QsAPQALAARViwCy8bsQscPlmwAEVYsAkvG7EJED5ZsAsQsgABCitYIdgb9FmyAgsJERI5sAIvsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxASEDBRYWBwYEIyETIQEDBTI2NzYmJwR6/VhLATbY7BEQ/tjp/eX9A2X81mABSo3AEQ58fAUS/kwBAeK/x/QFsP0Q/d0BnoN2iAQAAAL/i/6aBXoFsAAOABUAVbISFhcREjmwEhCwC9AAsAQvsABFWLALLxuxCxw+WbAARViwAi8bsQIQPlmwBBCwAdCwAhCyBwEKK1gh2Bv0WbAP0LAN0LALELIRAQorWCHYG/RZMDEBIxMhAyMTFzYTNxMhAzMFJRMhAwcCBPa7PvwMP7tZa89lFJQDT+K5+9gCs8b+JG4dXf6bAWX+mgIDAqkBfk4CoPrtAwMEdf4Lcv6pAAAB/6wAAAd1BbAAFQCGALAARViwCS8bsQkcPlmwAEVYsA0vG7ENHD5ZsABFWLARLxuxERw+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsABFWLAULxuxFBA+WbACELAQ0LAQL7IvEAFdss8QAV2yAAEKK1gh2Bv0WbAE0LIIEAAREjmwEBCwC9CyEwAQERI5MDEBIwMjEyMBIwEBMwEzEzMDMwEzAQEjBJWcc7x0mf399gJo/sXRAQqlbrtukgHm6f3JAVLcApj9aAKY/WgDCgKm/YgCeP2IAnj9R/0JAAEAJf/qBJgFxwAqAGAAsABFWLANLxuxDRw+WbAARViwGS8bsRkQPlmwDRCyBgEKK1gh2Bv0WbANELAK0LAZELAq0LAqL7IpAQorWCHYG/RZshIpKhESObAZELAd0LAZELIgAQorWCHYG/RZMDEBMjY3NiYnJgYHBzYkFxYWBwYFFhYHBgYEJyYmNxcGFhcWNjc2NzYmJyc3Am2UvQ4NlYB+uxS6EgEs0tvwEBH+9WdfCAuX/vmZ0PMJugiUfEWGNm4QDoKUrRwDNIV4c4ICAolvAbbgAgXdtdR0LaxvhMVrAgTovQF1kwQCJCVMf3WCBQGeAAABAEMAAAVuBbAACQBdALAARViwAC8bsQAcPlmwAEVYsAcvG7EHHD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAACERI5QAmKBJoEqgS6BARdsgkAAhESOUAJhQmVCaUJtQkEXTAxATMDIxMBIxMzAwSswv27wfyPw/28wQWw+lAEVvuqBbD7qgAAAf/KAAAFZQWwABAATbIEERIREjkAsABFWLAALxuxABw+WbAARViwAS8bsQEQPlmwAEVYsAgvG7EIED5ZsAAQsgMBCitYIdgb9FmwCBCyCgEKK1gh2Bv0WTAxAQMjEyEDAgYHIzc3NjY3NxMFZfy84f4Ip0Hiq1cSJIemKxaPBbD6UAUS/Pb+8/UGnQEI5P99AqoAAAEAk//mBUAFsAAQADyyAxESERI5ALAARViwAS8bsQEcPlmwAEVYsBAvG7EQHD5ZsABFWLAGLxuxBhA+WbIKAQorWCHYG/RZMDEBATMBBgYnJic3FzI/AgEzAoYB2OL9PVG0ejwvFlljRSQ6/tvJAmQDTPtCk3kCAgmYBmM4ZgQqAAADAFv/xAXfBewAGAAhACoAarIeKywREjmwHhCwC9CwHhCwI9AAsBcvshYXKxESObAWL7AA0LAAL7INKxcREjmwDS+wCtCwCi+wDRCwDNCwDC+wDRCyHQEKK1gh2Bv0WbAWELIfAQorWCHYG/RZsB0QsCPQsB8QsCrQMDEBFxYWEgcGAgQnIwcjNyImAjc2EiQ3MzczAQYWFxcTIwYEJQMzNiQ3NiYnA9gUmOpxEBK6/tunICe2KKjscxAQswEcojYqsP0iF5uiLp8evP7/ApKeHboBARkWpKcFHQEDl/73nKj+65kBxMWWAQygowEQnATO/N+45QwCA2kD9vf8lwP0yL/kBwAAAQBB/qEFbQWwAAsAOwCwCS+wAEVYsAAvG7EAHD5ZsABFWLAELxuxBBw+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAG0DAxATMDIRMzAzMDIxMhAT684QK34rvhlWqqPvv2BbD67QUT+vH+AAFfAAEAzgAABUQFsAASAEiyDxMUERI5ALAARViwEi8bsRIcPlmwAEVYsAovG7EKHD5ZsABFWLABLxuxARA+WbIPAQoREjl8sA8vGLIFAQorWCHYG/RZMDEBAyMTBicmJjcTMwMGFxYXFjcTBUT9vG+xydzWF0y8SwgIGM+h4H0FsPpQAlw3AgLr1QHH/jhFNaUDAzYCtwABAEIAAAc4BbAACwBIALAARViwAC8bsQAcPlmwAEVYsAMvG7EDHD5ZsABFWLAHLxuxBxw+WbAARViwCS8bsQkQPlmyAQEKK1gh2Bv0WbAF0LAG0DAxAQMhEzMDIRMzAyETAfvhAeXhu+IB4uG8/foH/QWw+u0FE/rtBRP6UAWwAAEAQv6hBzgFsAAPAFQAsAsvsABFWLAALxuxABw+WbAARViwAy8bsQMcPlmwAEVYsAcvG7EHHD5ZsABFWLANLxuxDRA+WbIBAQorWCHYG/RZsAXQsAbQsAnQsArQsALQMDEBAyETMwMhEzMDMwMjEyETAfvhAeXhu+IB4uG84o9poj36K/0FsPrtBRP67QUT+uf+CgFfBbAAAgCJAAAFgAWwAAwAFQBesgEWFxESObABELAN0ACwAEVYsAAvG7EAHD5ZsABFWLAJLxuxCRA+WbICAAkREjmwAi+wABCyCwEKK1gh2Bv0WbACELINAQorWCHYG/RZsAkQsg4BCitYIdgb9FkwMRMhAwUWFgcGBCMhEyEBAwUyNjc2JiekAkpnATba6RER/tno/ebi/nIB42ABSo2/EQ58ewWw/a4BAeW9yfEFGP2o/d0BnoN2iAQAAAMARQAABpYFsAAKABMAFwBtshIYGRESObASELAG0LASELAV0ACwAEVYsAkvG7EJHD5ZsABFWLAWLxuxFhw+WbAARViwBy8bsQcQPlmwAEVYsBQvG7EUED5ZsgAJBxESObAAL7ILAQorWCHYG/RZsAcQsgwBCitYIdgb9FkwMQEFFhYHBgQjIRMzAwMFMjY3NiYnASMTMwGWATbY7BEQ/tjp/ef8vIJgAUqNwBEOfHwCwLv9uwNeAQHiv8f0BbD9EP3dAZ6DdogE/UEFsAAAAgA2AAAEgQWwAAoAEwBNsg0UFRESObANELAB0ACwAEVYsAkvG7EJHD5ZsABFWLAHLxuxBxA+WbIACQcREjmwAC+yCwEKK1gh2Bv0WbAHELIMAQorWCHYG/RZMDEBBRYWBwYEIyETMwMDBTI2NzYmJwGHATbY7BEQ/tjp/ef8vIJgAUqNwBEOfHwDXgEB4r/H9AWw/RD93QGeg3aIBAABAHT/6QT8BcoAIgBgALAARViwFS8bsRUcPlmwAEVYsB8vG7EfED5ZsADQsB8QsgMBCitYIdgb9FmwHxCwCNCwCC+yLwgBXbLPCAFdsgcBCitYIdgb9FmwFRCyDgEKK1gh2Bv0WbAVELAR0DAxARYWFxYSNwU3ITY3NiYnJgYHBzYAFx4CFxYCAgcGJyYmJwEwB42OrOw3/c0cAikJAgOZkY/FMbsuAT3cjM53BwZL26BvfdX5CAHPp5wEBQEI/QGeODu50gQFpKsB5gEIBgN97JRy/k/+vEQwAwT+4QACAEn/5wbOBccAFwAnAHeyASgpERI5sAEQsCLQALAARViwDy8bsQ8cPlmwAEVYsAkvG7EJHD5ZsABFWLAALxuxABA+WbAARViwBi8bsQYQPlmyCgYJERI5fLAKLxiyBQEKK1gh2Bv0WbAPELIbAQorWCHYG/RZsAAQsiMBCitYIdgb9FkwMQUmJgI3IwMjEzMDMzYSJBcWEhcWAgIHBgE2JicmBgIHBwYWFxYSEzYEEpveaRDObrv9u3THIcIBGabV9gkEM4NlsAEOBpaUhtOHEgMGmJG9+SkUFAOiATa2/YMFsP1kzgFCowME/uH1af68/upepAOXxdkEBJj+0ehBxN4EBQEbAQB+AAL/6AAABNgFsQANABYAYbIRFxgREjmwERCwAtAAsABFWLALLxuxCxw+WbAARViwAC8bsQAQPlmwAEVYsAMvG7EDED5ZshIACxESObASL7IBAQorWCHYG/RZsgUBCxESObALELIUAQorWCHYG/RZMDEhEyEBIwEmJjc2JDMFAwEGFhcFEyciBgMeY/7B/nnTAbxyaAsSATTsAdH9/bYQhX0BGWT+msYCN/3JAnA6yH/Q8AH6UAPyfJ0EAQI+AZoAAAIARv/nBFUGEQAcACsATbIZLC0REjmwGRCwHdAAsBQvsABFWLAILxuxCBA+WbIACBQREjmwAC+yGwAIERI5sAgQsiUBCitYIdgb9FmwABCyKwEKK1gh2Bv0WTAxAR4CBwcGACcuAj8CEgA3NzY3Mw4CBAYHNhcmBg8CFhYXFjY3NiYnAo16sVYMAx7+19GGwlkQBAUnASfycZcZlQpLiv660kCpmn+2GwcDA3lsibsaDn55A/wCfuCHF/T+3QUCjfGPHi0BTwGmMRUhb2B3SUC4p66bA6uVL1WEnQIDzsiYtQQAAAMAMAAABA0EOgANABYAHgBXALAARViwAS8bsQEYPlmwAEVYsAAvG7EAED5ZshcAARESOXywFy8Ysg4BCitYIdgb9FmyBw4XERI5sAAQsg8BCitYIdgb9FmwARCyHgEKK1gh2Bv0WTAxMxMFFhYHBgcWFgcGBgcDAwUyNjc2JiclFzI2NzYnJzC8AX7K2QoKylBaBAbmwfE5AR5wiwsKYWH+5t6DkgsV7PEEOgEBk4ybVhiBVJKnAgHb/roBW1FITwOVAVJOjgcBAAABAC0AAAODBDoABQArALAARViwBC8bsQQYPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhAyMTIQNn/h2htrwCmgOh/F8EOgAC/43+wgQ+BDoADgAUAFKyEhUWERI5sBIQsAnQALAML7AARViwBC8bsQQYPlmwAEVYsAovG7EKED5ZsgABCitYIdgb9FmwD9CwBtCwDBCwCdCwBBCyEQEKK1gh2Bv0WTAxNzY2NxMhAzMDIxMhAyMTBSUTIQMCLW+IIFQCpqKHUrQ3/SU3tVMBJAHjhP6/RESUZvyuAZb8Xf4rAT7+wgHVAwMC+P67/uUAAAH/pQAABg4EOgAVAJAAsABFWLAJLxuxCRg+WbAARViwDS8bsQ0YPlmwAEVYsBEvG7ERGD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsBQvG7EUED5ZsAIQsBDQsBAvsr8QAV2y/xABXbIvEAFdss8QAXGyAAEKK1gh2Bv0WbAE0LIIEAAREjmwEBCwC9CyEwAQERI5MDEBIwMjEyMBIwEDMxMzEzMDMwEzAQEjA7yDUbVSd/6I8QHi9c7BgE61T3MBX+f+SAES1wHW/ioB1v4qAjoCAP5AAcD+QAHA/ev92wABACH/6gOqBFAAJwBqALAARViwDS8bsQ0YPlmwAEVYsBkvG7EZED5ZsA0QsgYBCitYIdgb9FmwDRCwCtCwGRCwJ9CwJy+yLycBXbK/JwFdsiYBCitYIdgb9FmyEiYnERI5sBkQsBzQsBkQsiABCitYIdgb9FkwMQEyNjc2JiMmBgcHNjYXFhYHBgcWFgcOAicmJjcXBhYXFjY3NicnNwIBZnsICWNYWo4RtBD5rKnBCgrCS0UFBnfMd6nVBrEEdF9nkwsVzbkcAnVWT0dYAmBOAZWvAgKli5xZIX1RaJZQAwK6mAFSawICZFShAQGcAAABAC8AAAQ3BDoACQBFALAARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAcCERI5sgkHAhESOTAxATMDIxMBIxMzAwN8u7y1iP2cu7y0hwQ6+8YDCfz3BDr89gAAAQAvAAAEVwQ6AAwAdwCwAEVYsAQvG7EEGD5ZsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsAIQsAbQsAYvsp8GAV2y/wYBXbLPBgFxsp8GAXG0vwbPBgJdsi8GAV2ybwYBcrIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBMwEBIwG+iVG1vLVQbgGw6f3+AVvWAc3+MwQ6/jYByv3v/dcAAAH/yAAABDkEOgARAE2yBBITERI5ALAARViwAC8bsQAYPlmwAEVYsAEvG7EBED5ZsABFWLAJLxuxCRA+WbAAELIDAQorWCHYG/RZsAkQsgwBCitYIdgb9FkwMQEDIxMhAwcGBgcjNzc2Njc3EwQ5vLai/pxRFjW+lU4SJ2F8IBJiBDr7xgOh/o5s8s4DogIGoa5nAdoAAAEAMAAABX4EOgAMAFkAsABFWLABLxuxARg+WbAARViwCy8bsQsYPlmwAEVYsAMvG7EDED5ZsABFWLAGLxuxBhA+WbAARViwCS8bsQkQPlmyAAsDERI5sgULAxESObIICwMREjkwMSUBMwMjEwEjAwMjEzMCogH25ry1h/4sftCOtLzl9wND+8YDBfz7Ayz81AQ6AAABAC8AAAQ2BDoACwCKALAARViwBi8bsQYYPlmwAEVYsAovG7EKGD5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmwABCwCdCwCS+ybwkBXbS/Cc8JAl2yPwkBcbTPCd8JAnGyDwkBcrSfCa8JAnGy/wkBXbIPCQFxsp8JAV2yLwkBXbRvCX8JAnKyAgEKK1gh2Bv0WTAxISMTIQMjEzMDIRMzA3q1Uf4fUbW8tVEB4FK1Ac7+MgQ6/isB1QAAAQAvAAAENwQ6AAcAOACwAEVYsAYvG7EGGD5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmwBhCyAgEKK1gh2Bv0WTAxISMTIQMjEyEDe7Wi/h6itbwDTAOh/F8EOgAAAQBgAAAD6AQ6AAcAMQCwAEVYsAYvG7EGGD5ZsABFWLACLxuxAhA+WbAGELIAAQorWCHYG/RZsATQsAXQMDEBIQMjEyE3IQPO/qCitKH+pxoDbgOk/FwDpJYAAwBM/mAFPQYAAB8ALAA6AH2yJzs8ERI5sCcQsBLQsCcQsDXQALADL7AARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLATLxuxExI+WbAARViwFy8bsRcQPlmwENCwBxCyJAEKK1gh2Bv0WbAXELIyAQorWCHYG/RZsCnQsAAQsjcBCitYIdgb9FkwMQEWFxMzAzYXFhcWDwIGAicmJwMjEwYnIiYnJjc3EhIBNicmJyYHAxYXFjY3BQYVFxYXFjcTJiMmBgcCJ1JBV7VZTVHVQRwCCAIi8bhXTFC1UUlHkJ8DAQYMLesDCAsDEKYzPY4sO3+pGvyMBgITnS86jjQqfaEgBFACHgHQ/iojAQPrZ3R4EPn+5AMCIf5UAakdAdW5OzdSAQABE/29ZEfzBwIU/O8QAgLHtg01PjC/BwISAxMSAs3PAAEAL/6/BDcEOgALADsAsAgvsABFWLAALxuxABg+WbAARViwBC8bsQQYPlmwAEVYsAovG7EKED5ZsgIBCitYIdgb9FmwBtAwMRMzAyETMwMzAyMTIeu1oQHhorWifmSiOPzqBDr8XQOj/F3+KAFBAAABAHsAAAQABDsAEgBIsg4TFBESOQCwAEVYsBEvG7ERGD5ZsABFWLAJLxuxCRg+WbAARViwAS8bsQEQPlmyDgEJERI5fLAOLxiyBAEKK1gh2Bv0WTAxISMTBicmJjcTMwMGFxYXFjcTMwNEtkt7drK7FTK1MwYFEJ5uiWK2AYkhAgLauQE8/sM0LZQGAx8CGwABAC8AAAYIBDoACwBIALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAHLxuxBxg+WbAARViwCS8bsQkQPlmyAQEKK1gh2Bv0WbAF0LAG0DAxAQMhEzMDIRMzAyETAaChAX+htaIBfqK2vPrjvAQ6/F0Do/xdA6P7xgQ6AAEAJP6/Bf0EOgAPAEsAsAwvsABFWLAALxuxABg+WbAARViwAy8bsQMYPlmwAEVYsAcvG7EHGD5ZsABFWLANLxuxDRA+WbIBAQorWCHYG/RZsAXQsAnQMDEBAyETMwMhEzMDMwMjEyETAZaiAX+itKEBfaK2opRjozj7A7wEOvxdA6P8XQOj/F3+KAFBBDoAAAIAVgAABHsEOgAMABUAXrIBFhcREjmwARCwDdAAsABFWLAALxuxABg+WbAARViwCS8bsQkQPlmyAgAJERI5sAIvsAAQsgsBCitYIdgb9FmwAhCyDQEKK1gh2Bv0WbAJELIOAQorWCHYG/RZMDETIQMXFhYHBgYjIRMhAQMFNjY3NiYncQHsQf6jvgsL87v+NaH+yQGsRwEAa4cNC1ZYBDr+iwEEupilyQOi/oz+aQECcV5XawQAAwAwAAAFqQQ6AAoAEwAXAFoAsABFWLAKLxuxChg+WbAARViwFi8bsRYYPlmwAEVYsAgvG7EIED5ZsABFWLAVLxuxFRA+WbIACAoREjmwAC+yCwEKK1gh2Bv0WbAIELIMAQorWCHYG/RZMDEBFxYWBwYGIyETMwMDBTY2NzYmJwEjEzMBX+2xwgsL873+N7y1W0cBAGuHDQtXVwKStby1AsUCAbuZpckEOv30/mkBAnFeV2sE/dMEOgAAAgAwAAADvwQ6AAoAEwBNsgcUFRESObAHELAN0ACwAEVYsAkvG7EJGD5ZsABFWLAHLxuxBxA+WbIACQcREjmwAC+yCwEKK1gh2Bv0WbAHELIMAQorWCHYG/RZMDEBFxYWBwYGIyETMwMDBTY2NzYmJwFf7bHCCwvzvf43vLVbRwEAa4cNC1dXAsUCAbuZpckEOv30/mkBAnFeV2sEAAABADT/5wPEBFAAIQBoALAARViwCC8bsQgYPlmwAEVYsBIvG7ESED5ZsAgQsgABCitYIdgb9FmwCBCwBNCwEhCwFdCwEhCyGQEKK1gh2Bv0WbASELAe0LAeL7IvHgFdsr8eAV2yIB4BcbIdAQorWCHYG/RZMDEBJgYHBz4CFx4CFxYHBwYAJyYmNxcGFhcWNjchNyE2JgI7Y5gUqwqDyWxspGMJBQYDHf7V0KXKCKsGa2B0sDH+cBsBhAhzA7cCeF4BZKtfAQNju3dBQRn7/sYFBNyoAWWJBAWxrpiRsAACADD/5wYHBFQAFQAmAH0AsABFWLAVLxuxFRg+WbAARViwBC8bsQQYPlmwAEVYsBIvG7ESED5ZsABFWLAMLxuxDBA+WbIAEhUREjl8sAAvGLKAAAFdtEAAUAACXbRQAGAAAnGyEQEKK1gh2Bv0WbAMELIbAQorWCHYG/RZsAQQsiMBCitYIdgb9FkwMQEzNgAXHgIHBwIAJy4CNwUDIxMzAQYXFBYXFjY3NicmJicmBgcBUPRCASPAiL9XDwEi/szYfsFdC/7/U7S8tAFPBQF4bovLGwcFCXZmjMgaAm/lAQAFBI/6mAn+/P7KBQKE4IYB/ikEOv3QKi2NoQQF5Mk/RXiNBAXjuAAC/78AAAP/BDsADQAWAGGyFBcYERI5sBQQsA3QALAARViwAC8bsQAYPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbISAAEREjmwEi+yAwEKK1gh2Bv0WbIHAwAREjmwABCyEwEKK1gh2Bv0WTAxAQMjEyEBIwEmJjc2NjMBBhYXBRMnBgYD/7y2Sf75/r/PAV9VUAYL+rj++ApWTgEiP/dpjgQ6+8YBpf5bAcUqnF2buP6sTVgEAQFnAQJmAAABAB/+RQPjBgAAIwCAALAhL7AARViwBC8bsQQYPlmwAEVYsAsvG7ELEj5ZsABFWLAaLxuxGhA+WbK/IQFdsi8hAV2yDyEBXbIiGiEREjmwIi+yAQEKK1gh2Bv0WbICGgQREjmwCxCyEAEKK1gh2Bv0WbAEELIXAQorWCHYG/RZsAEQsBzQsCIQsB/QMDEBIQM2FxYWBwMGBiciJzcWMzI3EzYnJicmBwMjEyM3MzczByECu/7rNo66mpETgRbAlS1LHzExiyOBBgQRlaZ4hrXSnxqfH7UfARYEuf79mwQEz7X84qi6BBSSD9MDFTEqjAMEsvz8BLmYr68AAQBO/+gD/QRTAB4AZQCwAEVYsA8vG7EPGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsAgQsATQsA8QsBLQsA8QshYBCitYIdgb9FmwCBCwGtCwGi+yvxoBXbL/GgFdsi8aAV2yGwEKK1gh2Bv0WTAxJRY2NzcOAicmAjc3EgAXFhYHIzQmJyYGByEHIQYWAfFhnRusD4XOa8rRFwMeAS3XqcoCqnFferIxAY4b/n0PdoICc2EBZahgAwUBKO0bAQIBMQUE3ahrgwQFp62YlrUAAv/DAAAGLwQ6ABgAIQB5sgoiIxESObAKELAa0ACwAEVYsAAvG7EAGD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyAgAIERI5sAIvsAAQsgoBCitYIdgb9FmwEBCyEwEKK1gh2Bv0WbAIELIbAQorWCHYG/RZsAIQsiEBCitYIdgb9FkwMQEDFxYWBwYGIyETIQMHBgYHIzc3NjY3NxMBAwU2Njc2JicEFkj+pb4JCfG+/jai/rtRGDPAmkgTJmF8IBJiAkdAAQBmjAsLWFsEOv5kAQWtkZu/A6H+jnbn0QGiAgahrmcB2v3M/o8BAm1ZSloFAAACAC8AAAZPBDoAEgAbAHuyARwdERI5sAEQsBPQALAARViwAi8bsQIYPlmwAEVYsBEvG7ERGD5ZsABFWLALLxuxCxA+WbAARViwDy8bsQ8QPlmyARELERI5sAEvsATQsAEQsg0BCitYIdgb9FmwBBCyEwEKK1gh2Bv0WbALELIUAQorWCHYG/RZMDEBIRMzAxcWFgcGBiMhEyEDIxMzAQMFNjY3NiYnAVkB4Ue1SP6jwAkJ8b7+N1v+H1u1vLUCNEABAGaKDQtXXAKhAZn+YwEErpCbvwIK/fYEOv3M/o8BAmxaSloFAAEAHwAAA+MGAAAaAHmyAxscERI5ALAXL7AARViwBC8bsQQYPlmwAEVYsAgvG7EIED5ZsABFWLARLxuxERA+WbK/FwFdsi8XAV2yDxcBXbIaERcREjmwGi+yAAEKK1gh2Bv0WbICBBEREjmwBBCyDgEKK1gh2Bv0WbAAELAT0LAaELAV0DAxASEDNhcWFgcDIxM2JyYnJgcDIxMjNzM3MwchAtH+0TGOuZiTE3a1dwYFEZSmeIa104sbih61IAEtBL7++JsEAs25/TsCyDEqjAMEsvz8BL6Xq6sAAQAv/pwENwQ6AAsARQCwCC+wAEVYsAAvG7EAGD5ZsABFWLADLxuxAxg+WbAARViwBS8bsQUQPlmwAEVYsAkvG7EJED5ZsgEBCitYIdgb9FkwMQEDIRMzAyEDIxMhEwGgoQHhorW8/rg/tD7+sbwEOvxdA6P7xv6cAWQEOgAAAQBv/+QG4wWwACEAYLIGIiMREjkAsABFWLAALxuxABw+WbAARViwGS8bsRkcPlmwAEVYsA4vG7EOHD5ZsABFWLAELxuxBBA+WbAARViwCS8bsQkQPlmyFAEKK1gh2Bv0WbIHFAQREjmwHdAwMQEDBgYnJiYnBicmJjcTMwMGFxYWFxY2NxMzAwYWFxY2NxMG47Qb/7lqnCCL3au0E7S8swUEB1JFbZwRtcKzDF5eZI4VtgWw+93E4wQCX1C3BgbntgQj+9wtLU5aAwWQegQk+9x4igMDhncELwABAE//5gXfBDoAIQBLALAARViwDi8bsQ4YPlmwAEVYsBgvG7EYGD5ZsABFWLAhLxuxIRg+WbAARViwCS8bsQkQPlmwBNCwCRCyFAEKK1gh2Bv0WbAd0DAxAQMGBicmJicGJyYmNxMzAwYXFhYXFjY3EzMDBhYXFjY3EwXfehndrFqIH3u+mKIRerR6BAMDRDxbgxJ7tnoKT09VeBJ6BDr9KLDMBAJNRZgEBM6lAtn9JiYmQFADBHhrAtr9JmZ3AgN1bQLaAAACAC7//APDBhYAEgAbAHGyFRwdERI5sBUQsAnQALAARViwDy8bsQ8ePlmwAEVYsAkvG7EJED5ZshIPCRESObASL7IAAQorWCHYG/RZsgMPCRESObADL7AAELAL0LASELAN0LAJELIVAQorWCHYG/RZsAMQshsBCitYIdgb9FkwMQEhAxcWFgcGBichEyM3MxMzAyEBAxc2Njc2JicC1v7JOv2lvAwO+7X+Nby6G7g5tjkBOP5aTf9ojgwNV1YEOv6wAQbEnrDVBAQ6lwFF/rv9gf5FAgJ7aVt3BAAAAQBJ/+cGswXKACsAh7IYLC0REjkAsABFWLArLxuxKxw+WbAARViwBi8bsQYcPlmwAEVYsCgvG7EoED5ZsABFWLAgLxuxIBA+WbIAKygREjmwAC+wBhCwCtCwBhCyDQEKK1gh2Bv0WbAAELAQ0LAAELInAQorWCHYG/RZsBLQsCAQshkBCitYIdgb9FmwIBCwHNAwMQEzNjY3NhcWEhcjJiYnJgYHIQclBgcGFhYXFjY3NwYAJyYCJyY3NwcDIxMzAZa5IXxasPnP7wa6B4qBq/M9AhQb/fcOAgY+gV2ZyDS6L/6648r3BwMOBsZ3vP28A0CQ+VeqBQT+/eKooQMF9PmXAU49bsBkAwWdrAHj/vsGBAEY5VBQHAH9VwWwAAEALP/oBY0EUwAkAMSyAyUmERI5ALAARViwBC8bsQQYPlmwAEVYsCQvG7EkGD5ZsABFWLAhLxuxIRA+WbAARViwHC8bsRwQPlmyDxwEERI5sA8vtL8Pzw8CXbQ/D08PAnG0zw/fDwJxtA8PHw8CcrSfD68PAnGy/w8BXbIPDwFxtC8PPw8CXbRvD38PAnKwANCyCA8EERI5sAQQsgsBCitYIdgb9FmwDxCyEAEKK1gh2Bv0WbAcELIUAQorWCHYG/RZshccBBESObAQELAf0DAxATM2JBcWFgcjNCYnJgYHIQchBhYXFjY3Nw4CJyYCNwcDIxMzAUyxQQEZw6fMAqpwX32xMAGuG/5dD3Z2ZpkarA+HzGu/2xPAULa8tgJn8PwFBN2oaoQEA6mql5a1AwJ1XwFlqV8DBAETzwH+MAQ6AAAC/7oAAARTBbAACwAOAFYAsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsABFWLAKLxuxChA+WbINCAIREjmwDS+yAAEKK1gh2Bv0WbAE0LIOCAIREjkwMQEjAyMTIwMjATMTIwEhAwNVp0y4TZbeyQL6p/i4/hoBhlsBtv5KAbb+SgWw+lACWgJHAAL/ogAAA5oEOgALABAAVgCwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsAovG7EKED5Zsg0CCBESObANL7IBAQorWCHYG/RZsATQsg8IAhESOTAxASMDIxMjAyMBMxMjASEDJwcCpnQ0tTRyqMECaJz0sf52ASVIBSgBKf7XASn+1wQ6+8YBwQFGTFsAAgBaAAAGVQWwABMAFgB8ALAARViwAi8bsQIcPlmwAEVYsBIvG7ESHD5ZsABFWLAELxuxBBA+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsABFWLAQLxuxEBA+WbIVAgQREjmwFS+wANCwFRCyBgEKK1gh2Bv0WbAK0LAGELAO0LIWAgQREjkwMQEhATMTIwMjAyMTIwMjEyEDIxMzASEDAX8BdgHBp/i5RqdMuE2V4Mjn/sJNvf29AaMBhVoCWQNX+lABtv5KAbb+SgG4/kgFsPyqAkcAAgBOAAAFSwQ6ABMAGAB/ALAARViwAi8bsQIYPlmwAEVYsBIvG7ESGD5ZsABFWLAELxuxBBA+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsABFWLAQLxuxEBA+WbIAEBIREjmwAC+wAdCyDgEKK1gh2Bv0WbAL0LAH0LABELAU0LAV0LIXEgQREjkwMQEhATMTIwMjAyMTIwMjEyMDIxMzASEDJwcBUQECAWmb9LBDdTS1NXOowarGNLW8tgFRASVIBicBwQJ5+8YBKf7XASn+1wEo/tgEOv2HAUZMWwACACYAAAYvBbAAHgAiAHayDiMkERI5sA4QsB/QALAARViwHS8bsR0cPlmwAEVYsBYvG7EWED5ZsABFWLAGLxuxBhA+WbAARViwDi8bsQ4QPlmyGw4dERI5sBsvsADQsBsQshIBCitYIdgb9FmwDNCwGxCwH9CwHRCyIgEKK1gh2Bv0WTAxATMyFgcDIxM2JyYnJwcDIxMnJyYGBwMjEzYkMzMBBQEzAQUEQg3Y1Rg8vT0IBxXJdx5tvXIGgJmoGD28PR4BEPgk/vwEhv08DwFo/dUDJ+bQ/o8BckM0oAMCJf2XAngTAwKIkf6JAXHb3wKFAv18AegBAAIAKQAABQsEOgAcACAAWACwAEVYsAUvG7EFGD5ZsABFWLAcLxuxHBA+WbIEHAUREjmwBC+wB9CwHBCwFdCwDNCwBBCyGAEKK1gh2Bv0WbAR0LAEELAd0LAFELIgAQorWCHYG/RZMDEzNzY2NwMhARYWBwcjNzYnJicnBwMjEycnJgYHBwEXEyEpGh7t1rwDo/6Nq6cWGbYZBwIKtTURT7VUAzqDmxgcAfUJ6/6fqtLXCQHe/h4L5MWkpT0zqAcCFv5QAbwJAQKCj7cCXAEBRwACAEgAAAhaBbAAJAAoAJmyICkqERI5sCAQsCjQALAARViwBy8bsQccPlmwAEVYsAsvG7ELHD5ZsABFWLAALxuxABA+WbAARViwBS8bsQUQPlmwAEVYsBMvG7ETED5ZsABFWLAcLxuxHBA+WbIJBQcREjmwCS+yBAEKK1gh2Bv0WbAJELAN0LAEELAZ0LAEELAf0LAJELAl0LALELIoAQorWCHYG/RZMDEhEzY3BQMjEzMDIQEhATMWFxYHAyMTNicmJycHAyMTJycmBgcDATMBBQJHQyFf/m1zvP28cANF/vQEkP4KE9ZoaBc8vT0IBxSwkR9tvHIHgJWqGD4CiQ8BaP3VAYyoYwP9bAWw/XwChP13AXJz0P6PAXJDNJQNBCf9mQJ3FAICg5X+iQMqAegBAAACAC4AAAbtBDoAIgAmAIwAsABFWLALLxuxCxg+WbAARViwCC8bsQgYPlmwAEVYsAUvG7EFED5ZsABFWLAALxuxABA+WbAARViwGy8bsRsQPlmwAEVYsBIvG7ESED5ZsgkFCBESObAJL7IEAQorWCHYG/RZsAkQsA3QsAQQsBfQsAQQsB7QsAkQsCPQsAsQsiYBCitYIdgb9FkwMSE3NjcFAyMTMwMhAyEBFhYHByM3NicmJycHAyMTJyciBgcHARcTIQIKHB1f/pBPtby2VALBxAOk/oyupBYZthkHAgq1NRFPtVQDR4GUFxkB9Qnr/p+qs2oD/jwEOv4iAd7+HQ3kwqSlPTOoBwIW/lABvAgCiZmkAlwBAUcAAv/O/kgEIQeIAC0ANgCGALAzL7AARViwCS8bsQkcPlmwAEVYsB4vG7EeEj5ZsABFWLAYLxuxGBA+WbAJELIIAQorWCHYG/RZsBgQsC3QsC0vsiwBCitYIdgb9FmyECwtERI5sBgQsiQBCitYIdgb9FmyDzMBXbAzELA20LA2L7QPNh82Al2yLjM2ERI5sDDQsDAvMDEBMjY3NiYnJyU3BR4CBwYFFhYHDgIjJwYGBwYXByYmNzY2MzMyNjc2JicnNwE3NxcBIwM1FwGzk78QDHBzD/7LGwEeesNhCBH+7mpkCQqL7I00UVkGEI5RbWsDBb2pIIzADw6GkZUbAZuxoAH+4m/NlgM2g3pheQkBAZgBA2OqcdVwLK5xgsVrAQM/Nm9EejmhW36Jmn15hQUBmAOmqAMN/u8BEA4CAAL/yv5IA5gGMgAoADEAnwCwLi+wAEVYsAgvG7EIGD5ZsABFWLAbLxuxGxI+WbAARViwFS8bsRUQPlmwCBCyBwEKK1gh2Bv0WbAVELAo0LAoL7IvKAFdsv8oAV2yjygBcbK/KAFdss8oAXGyXygBcrInAQorWCHYG/RZsg8nKBESObAVELIhAQorWCHYG/RZsC4QsDDQsDAvtA8wHzACXbIpLjAREjmwK9CwKy8wMQEyNjc2JiclNwUWFgcGBgcWFgcGBCMjBgcGFwcmJjc2NjMyNjc2Jyc3ATc3FwEjAzUXAYiHmQsJZ23+zxwBGLTPCAVndlZTBAj++9QinxEQjlJncQQFuriMmQsV+KQbAT6xnwH+4m/NlwJoVlM/TQMBmQEFpIJJdjMjdkuYswVza0l5NqFefYpfUZYGAZgDHqgDDf7vARAOAgADAGn/6QT8BcgAEgAbACQAZrIIJSYREjmwCBCwFNCwCBCwHdAAsABFWLAJLxuxCRw+WbAARViwAC8bsQAQPlmwCRCyEwEKK1gh2Bv0WbIWAAkREjl8sBYvGLAAELIcAQorWCHYG/RZsBYQsiABCitYIdgb9FkwMQUmAicmEjc2JBcWEhcWBwcGAgQTJgIDITY3NiYBFjY3IQYXFBYCQtP3CgU3R2ABKLfU9gkDCgwfwv7nMbH3OwL+CAIDmP6ervU6/QIHAZgUBAEf9G4BUIq7wgQE/uP3VFNU2f62pQU3Bf75/vw4PL7Q+3MG/P42ObHQAAMAQv/nBCAEUwARABgAHwBNALAARViwBC8bsQQYPlmwAEVYsA0vG7ENED5ZshIBCitYIdgb9FmyHA0EERI5fLAcLxiyFgEKK1gh2Bv0WbAEELIZAQorWCHYG/RZMDETNhI2Fx4CBwcGAgYnLgI3ARY2NyEGFgEmBgchNiZUFJvvj4i/WBACFJzvjoi/WBABl3i4OP2wDHwBB3m3NQJNB34CIJ4BBo8EBI/8lhed/v6NBASO+JX+eAWpsJDBAzIDqqKQtgABAK0AAAVLBcYADwA/ALAARViwDy8bsQ8cPlmwAEVYsAYvG7EGHD5ZsABFWLANLxuxDRA+WbIBDQ8REjmwBhCyCA4KK1gh2Bv0WTAxARc3ATY2MxcHIyYHASMDMwIJCDwBfUmbajMVCmhF/cKn7cQBbneGAyKqfQKrA5T7eAWwAAEAhAAABDwEUAAQAEayAhESERI5ALAARViwBS8bsQUYPlmwAEVYsBAvG7EQGD5ZsABFWLANLxuxDRA+WbIBDRAREjmwBRCyCgEKK1gh2Bv0WTAxARc3EzYzMhcHJiMiBwEjAzMBmgQs8GasPDQkFhNKOv5YibaxATJXaQIe7huSCXH8xQQ6AAACAGr/cwT6BjUAFQApAEgAsABFWLALLxuxCxw+WbAARViwAy8bsQMQPlmwANCwCxCwDtCwCxCyGwEKK1gh2Bv0WbAY0LAAELIlAQorWCHYG/RZsCLQMDEFByM3JgInJjcSADc3FwcWEhcUBwIAEwInByc3BgIPAgIXNxcHNhI3NgKZG7UbsMYDARoyATvqGbUar7oCHjT+0cgPthS1FprMJBEJFOYWtReXxCIfDIGBIAEg4W6aASEBYR93AXon/uDceqL+6v6vA78BAz1iAWYi/vnVcmX+m0ZnAWYnAQfeyQAAAgBE/4gELQS2ABMAJwBLALAARViwAC8bsQAYPlmwAEVYsA0vG7ENED5ZsAAQsAPQsA0QsArQshQBCitYIdgb9FmwABCyHQEKK1gh2Bv0WbAa0LAUELAl0DAxATcXBxYSBwcGAgcHJzcmAjc3NhITNhI1NCYnByc3BgYHBwYVFBc3FwI2F7UYoaIWAhz/xRe1F56eFQMe/M+JmkpFFbUWcY0XAgeKFrUERXEBcSb+2s4X2/7cIGwBbiYBI8oW4wEh/GkvARbEZJAeYwFkK8qRFTM50EFnAQAAAwB0/+YGmgdWADEARABMAJkAsABFWLAWLxuxFhw+WbAARViwDS8bsQ0QPlmwFhCwANCwDRCwCNCyCw0WERI5sBYQshcBCitYIdgb9FmwDRCyHwEKK1gh2Bv0WbIjFg0REjmwKNCwFxCwMdCwFhCwPNCwPC+wNNCwNC+yMgIKK1gh2Bv0WbA0ELA30LA3L7JAAgorWCHYG/RZsDwQsEjQsEgvsEzQsEwvMDEBFhYHAw4CJyYmJwYnJiY3NxM2NzY3BwYDAwYXFhYXFjY3EzMDBhYXFjY3EzYnJiYnEwcnJiQjIgYHByc3NjYXHgMBNjc3FwcGBwU/q7AXXBN8wXpsoyOI26OxCgNfI3l5vhLaMVkFAgJQSmyZFUe8Rg5mZ2GGGF0GAQJNSawKPkb+8Ew2RQkCfQMJhW0wV7Zb/gBMDxKaDxObBa8J98X9xYnSbgQCXU6xBAXhuSYCVMlxcASeB/7N/dUtMllrBAWMfgGt/lN1jQQDlZACQy8yVWgGAcWBAgZ6OzUSASRscgIBGE8Y/pJRQWABZW9ZAAADAFL/5QWmBfYAKwA/AEcAkgCwAEVYsBMvG7ETGD5ZsABFWLAMLxuxDBA+WbATELAA0LAMELAH0LATELIUAQorWCHYG/RZsAwQshsBCitYIdgb9FmyHwwTERI5sCTQsBQQsCvQsBMQsDbQsDYvsC3QsC0vsiwCCitYIdgb9FmwLRCwMtCwMi+yOwIKK1gh2Bv0WbAtELBE0LBEL7BH0LBHLzAxARYWBwMGBicmJicGJyYmNxM2NjcHBgMDBwYWFxY2NzczBwYWFxY2NxM3NCcTBy4DIyYGBwcnNzY2Fx4DATY3NxcHBgcEdJqYEiob2aRijiF9vJieEywd164RuScpAwNCQVuDESa0JAtZV1JwEy0EfO0KWFKxWC01RgkCfQILhW0vV75V/fxJDhWbDhSYBEQJ4bL+38TdBAJPRJoGA+O1AS+/zgSYB/7z/uQtY2sCBXlr7OxkegIDiIABM0ShDQHKgQIXTRoBOjUSASRtcQIBGFIV/ohQNW0BZXJXAAACAG//4gbjBwMAIgAqAHUAsABFWLAZLxuxGRw+WbAARViwDy8bsQ8cPlmwAEVYsCIvG7EiHD5ZsABFWLAKLxuxChA+WbAE0LIICg8REjmwChCyFQEKK1gh2Bv0WbAe0LAZELAp0LApL7Aq0LAqL7IkBgorWCHYG/RZsCoQsCfQsCcvMDEBAwYGByMmJicGJyYmNxMzAwYXFhYXFjY3EzMDBhYXFjY3EyU3IQchByM3BuO0G/azDm2aII3bq7QTtLyzBQQHUkVrmha0wrMMXl5kjhW2/IcTAxUS/r8WpBYFsPvdwOIBAmBPuQgG57YEI/vcLS1OWgMFioAEJPvceIoDA4Z3BC/oa2t9fQAAAgBP/+YF3wWwACAAKABgALAARViwFy8bsRcYPlmwAEVYsAgvG7EIED5ZsATQsBcQsA3QsAgQshMBCitYIdgb9FmwHNCwFxCwINCwFxCwJ9CwJy+wKNCwKC+yIgYKK1gh2Bv0WbAoELAl0LAlLzAxAQMGBicmJwYnJiY3EzMDBhcWFhcWNjcTMwMGFhcWNjcTATchByEHIzcF33sX3qu+RHu+m58RerR6BAMDRDxbgxJ7tnoKT09VeBJ6/NsUAxQQ/r4XpRcEOv0or80EBY+YBATUnwLZ/SYmJkBQAwR4awLa/SZmdwIDdW0C2gELa2uAgAABAGb+hATyBcgAHABCALABL7AARViwCy8bsQscPlmwAEVYsAIvG7ECED5ZsAsQsA/QsAsQshIBCitYIdgb9FmwAhCyGwEKK1gh2Bv0WTAxASMTJiYCNzc2EiQXFhIHIzYmJyYGBgcDBxQWFxcCWbtFgrJJFCYevQEJmt33DrwLkI5otoQWKgSNfHv+hAFuGLABDZT0vwEnkwME/vXZnKsEA27iif7yTqXEBAEAAQBN/oID5ARSABkAQgCwAS+wAEVYsAsvG7ELGD5ZsABFWLACLxuxAhA+WbALELAP0LALELISAQorWCHYG/RZsAIQshgDCitYIdgb9FkwMQEjEy4CNzc+AhcWFgcnNiYnJgIHBhYXFwHptUZpijoOBBOX5YilyQiqBmtfmcsCA2pmbv6CAXIZlOKCK5r+igQE3qgBZYkEBv7b5IijBgEAAAEAQAAABLgFPgATABMAsA4vsABFWLAELxuxBBA+WTAxARcHJwMjASc3FwEnNxcTMwEXBycCLPxS/OqwASX7Uv4BDf1U/PKs/tT/VfoBt6xyqf6+AZWrcqoBdat0qgFM/mGrcakAAAH86ASm/9AF/AAHABEAsAAvsgMGCitYIdgb9FkwMQEHJzchNxcH/aEXoioCCxKhJgUjfQHpbAHYAAAB/QsFFv/qBhQAEwArALASL7AN0LANL7IFAgorWCHYG/RZsBIQsArQsBIQshMCCitYIdgb9FkwMQE+AxcWFgcHJzc2JyYGBgcHN/08QHhudz1lbwUDegIIYCxU+kNKDAWVASktKAEBb2YnARRkBAESZQUBfwAAAf4XBRX+5AZXAAUADACwAS+wBdCwBS8wMQE3MwcXB/4XFK8bJU0F5XKXcjkAAAH+OwUX/1EGVwAFAAwAsAMvsADQsAAvMDEBJzc3Mwf+gkdQFbEYBRdIeX+EAAAI+jj+wgGUBbEACwAXACMALwA7AEcAUwBfAHoAsD8vsEsvsFcvsDMvsABFWLADLxuxAxw+WbIJCworWCHYG/RZsD8QsA/QsD8QskULCitYIdgb9FmwFdCwSxCwG9CwSxCyUQsKK1gh2Bv0WbAh0LBXELAn0LBXELJdCworWCHYG/RZsC3QsDMQsjkLCitYIdgb9FkwMQE2NhcWFhUnNiMmBwE2NhcyFhUnNiMmBwM2NjMWFhUnNiMiBwE2NhcWFhUnNiMiBwE2NhcWFhUnNiMmBwE2NhcWFhUnNiMmBwE2NhcWFhUnNiMiBwM2NhcWFhUnNiMiB/2TCnFbWGlsBVFTHQGfCXFaWGpsBVJSGxEIcVtYaGsFUVMd/nsIc1hYaGsFUVUa/TEKcVtYaGsFUVIe/kIKc1pYaWwFUVQb/pAJcFtYaGsFUlQbJghzWVhpbAVSUxsE81llAQFmWAFmAmb+6lhmAWlWAWYCZv4IVWcBZVgBZmT9+FdnAgFlWAFmZP7jWWUBAmVYAWYCZgUZWWUBAmVYAWYCZv4IWGUBAWVYAWZk/fhXZwIBZVgBZmQACPpP/mMBUwXGAAQACQAOABMAGAAdACIAJwA5ALAhL7ASL7ALL7AbL7AmL7AARViwBy8bsQccPlmwAEVYsBYvG7EWGj5ZsABFWLACLxuxAhI+WTAxBRcDIxMTJxMzAwE3BQclBQclNwUBNyUXBQEHBSclEycDNxMBFxMHA/3FDaxlf6ENq2R+AawLATcR/sD7jgr+yREBQAPNAwFMPf7N/GgD/rU+ATRpEV1DlAKzEF5FkjoS/q8BYASiEAFR/qH+EQp/XEU8Cn9bRAGuEZlNv/yNEplOvwLlAgFPPv7Q/OYC/rI/AS8AAAIALv/8A8MGcQASABsAdLIQHB0REjmwEBCwFdAAsABFWLANLxuxDRw+WbAARViwES8bsREcPlmwAEVYsAkvG7EJED5ZsBEQsgABCitYIdgb9FmyAg0JERI5sAIvsAAQsAvQsAzQsAIQshMBCitYIdgb9FmwCRCyFAEKK1gh2Bv0WTAxASEDFxYWBwYGJyETIzczNzMHIQEDFzY2NzYmJwL9/slh/aW8DA77tf414robuSK2IgE4/jNN/2iODA1XVgUY/dIBBsSesNUEBRiYwcH8ov5FAgJ7aVt3BAACADoAAATuBbAADwAcAE2yDx0eERI5sA8QsBjQALAARViwBC8bsQQcPlmwAEVYsAEvG7EBED5ZshcEARESObAXL7IAAQorWCHYG/RZsAQQshUBCitYIdgb9FkwMQEDIxMFHgIHBgcXBycGIwE2NzYmJyUDITI3JzcBWmO9/QH9ic1kDhKDYnNqgKgBODUNEoZ+/qhjATxeWlV0Ajr9xgWwAQRtxH+6e5BemDYBG01XfpYEAf3FH4BdAAAC/9f+YAP9BFIAFQAmAG6yIicoERI5sCIQsAfQALAARViwEC8bsRAYPlmwAEVYsAwvG7EMGD5ZsABFWLAKLxuxChI+WbAARViwBy8bsQcQPlmyCRAHERI5sg4QBxESObAQELIaAQorWCHYG/RZsAcQsh8BCitYIdgb9FkwMQEGBxcHJwYnJicDIwE3BzYXFhYXFgcnNzYmJyYHAxYXMjcnNxc2NwP0II1XdFNpZbhkYbUBBKQUhrubsAUBB7cGA29rnXJbO5pEVE50RUgXAhfxnYNeezgCAnv99gXaAXmQBATgwkA8AVSLogQEmf35jQQpeF5ob40AAAEANQAABM0HAAAJADWyAwoLERI5ALAIL7AARViwBi8bsQYcPlmwAEVYsAQvG7EEED5ZsAYQsgIBCitYIdgb9FkwMQEjFSEDIxMhEzMEhAP9UOG7/AKyPK4FGAb67gWwAVAAAQAkAAADtAV2AAcALgCwBi+wAEVYsAQvG7EEGD5ZsABFWLACLxuxAhA+WbAEELIAAQorWCHYG/RZMDEBIQMjEyETMwNj/hihtrwB6Di0A6H8XwQ6ATwAAAEAQ/7eBKUFsAAWAFuyAxcYERI5ALAKL7AARViwFS8bsRUcPlmwAEVYsBMvG7ETED5ZsBUQsgABCitYIdgb9FmyAxUTERI5sAMvsAoQsgsDCitYIdgb9FmwAxCyEQEKK1gh2Bv0WTAxASEDFxYWEgcCAAc3NjY3NiYnJwMjEyEEif1YUaSm6moRHP7k6w6TtRcWp6+zdL39A2UFEv4vAQSO/wCn/v3+3gSSA87Hw9IBAf1hBbAAAQAk/uEDegQ6ABYAW7IMFxgREjkAsAovsABFWLAVLxuxFRg+WbAARViwEy8bsRMQPlmwFRCyAAEKK1gh2Bv0WbICFRMREjmwAi+wChCyCwEKK1gh2Bv0WbACELISAQorWCHYG/RZMDEBIQMXHgIHBgIHJzY2NzYmJycDIxMhA1/+HDFjh81kDRH2siR5nhAPin96VLa8ApoDof7kAQR404Sp/v8mliCdf4miBAH+HQQ6AAEANgAABUgFsAAUAGIAsABFWLAALxuxABw+WbAARViwDC8bsQwcPlmwAEVYsAIvG7ECED5ZsABFWLAKLxuxChA+WbAP0LAPL7IvDwFdss8PAV2yCAEKK1gh2Bv0WbIBCA8REjmwBdCwDxCwEtAwMQkCIwMjByM3IwMjEzMDMxMzAzMBBUj9/AEo4OJSK5EsZHK8/L1wZC2RLkUBqQWw/UT9DAKO9PT9cgWw/X8BAP8AAoEAAAEALQAABJMEOgAUAHsAsABFWLANLxuxDRg+WbAARViwFC8bsRQYPlmwAEVYsAovG7EKED5ZsABFWLADLxuxAxA+WbAKELAO0LAOL7KfDgFdsv8OAV2ynw4BcbS/Ds8OAl2yLw4BXbJvDgFysgkBCitYIdgb9FmyAQkOERI5sAXQsA4QsBLQMDEJAiMDJwcjNyMDIxMzAzM3Mwc3AQST/lcBBdm7MieRI2FQtry2UWEmkSsnAUsEOv30/dIBzQHDwv4zBDr+NtXXAQHLAAEAuwAABswFsAAOAGsAsABFWLAGLxuxBhw+WbAARViwCi8bsQocPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIBgIREjmwCC+yLwgBXbLPCAFdsgEBCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbIMAQgREjkwMQEjAyMTITchAzMBMwEBIwOFsXG94v4zGwKJb4kCXPf9YgG92AKO/XIFGJj9fgKC/Tb9GgABAHQAAAWMBDoADgCAALAARViwBi8bsQYYPlmwAEVYsAovG7EKGD5ZsABFWLACLxuxAhA+WbAARViwDS8bsQ0QPlmwAhCwCdCwCS+ynwkBXbL/CQFdsp8JAXG0vwnPCQJdsi8JAV2ybwkBcrIAAQorWCHYG/RZsAYQsgQBCitYIdgb9FmyDAAJERI5MDEBIwMjEyE3IQMzATMBASMC8opQtqL+cBwCRFBuAbDq/fwBXNYBzf4zA6GZ/jYByv3v/dcAAAEAOgAAB+AFsAANAF4AsABFWLACLxuxAhw+WbAARViwDC8bsQwcPlmwAEVYsAYvG7EGED5ZsABFWLAKLxuxChA+WbAB0LABL7IvAQFdsAIQsgQBCitYIdgb9FmwARCyCAEKK1gh2Bv0WTAxASETIQchAyMTIQMjEzMBhwLGbQMmG/2W4rt1/Tl1vf29Az4Ccpj66AKh/V8FsAABACQAAAWUBDoADQCbALAARViwAi8bsQIYPlmwAEVYsAwvG7EMGD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmwBhCwAdCwAS+ybwEBXbS/Ac8BAl2yPwEBcbTPAd8BAnGyDwEBcrSfAa8BAnGy/wEBXbIPAQFxsp8BAV2yLwEBXbRvAX8BAnKwAhCyBAEKK1gh2Bv0WbABELIIAQorWCHYG/RZMDEBIRMhByEDIxMhAyMTMwFEAeFRAh4b/piitFD+H1C2vLYCZQHVmfxfAc7+MgQ6AAABAEL+3gdvBbAAFwBoshEYGRESOQCwBy+wAEVYsBYvG7EWHD5ZsABFWLAULxuxFBA+WbAARViwES8bsREQPlmyARYHERI5sAEvsAcQsggBCitYIdgb9FmwARCyDgEKK1gh2Bv0WbAWELISAQorWCHYG/RZMDEBMxYABwIABzc2Njc2JicjAyMTIQMjEyEFAWr9AQcaHP7k6w6TtRcWoq2BdLzh/UnhvP0ELwNABv7M//79/t4EkgPOx8DSBP1iBRL67gWwAAABACT+4QZBBDoAGABXALAIL7AARViwGC8bsRgYPlmwAEVYsBUvG7EVED5ZsBLQsgASGBESObAAL7AIELIJAQorWCHYG/RZsAAQshABCitYIdgb9FmwGBCyEwEKK1gh2Bv0WTAxARceAgcGBgcnNjY3NiYnJwMjEyEDIxMhA+CWi9dpDhH1siSAlg8QkYmuVLSh/h6htrwDTAKFAQN31ISs/yaWIqJ4hKcEAf4dA6H8XwQ6AAACAHH/4wWpBccAKgA5AIEAsABFWLAfLxuxHxw+WbAARViwBC8bsQQQPlmwANCyAgQfERI5sAIvsB8QsA7Qsg8BCitYIdgb9FmwBBCyFwEKK1gh2Bv0WbACELItDgorWCHYG/RZshkCLRESObIoLQIREjmwABCyKgEKK1gh2Bv0WbAfELI0AQorWCHYG/RZMDEFJicGJy4CJyY3NxIANwcGBg8CFBYXFjcmEzc2EhceAhcWBwcCBxYXARYXNhM3NicmJyYGBwcGBRXNo5ufjdmCCwcPGTEBIdQSh7IhHAOolTpMvykiJ/66ZJJOAgEHJDX4XnT98gqZ2zEgDgQLj2iQHiIKHQRFQgIDgvCaXGCkARoBTQWlBfzdwla54QICEOcBNt36ATUFA23Jdz856P6uxRQCAbHWd5oBPM5ZUOMHBMnB3EIAAAIAX//qBFoEVQAnADIAgQCwAEVYsB4vG7EeGD5ZsABFWLAELxuxBBA+WbAA0LICBB4REjmwAi+wHhCwDdCyDgEKK1gh2Bv0WbAEELIWAQorWCHYG/RZsAIQsioBCitYIdgb9FmyGAIqERI5siUqAhESObAAELInAQorWCHYG/RZsB4QsjABCitYIdgb9FkwMQUmJwYnLgInJhI2NjcHBgYHBwYWFhcWNyY3NzY2FxYWFxYHBgcWFwEGFzY2NzUmJyYDBBulg4SCbq5kBwczcKdsEmB4EAMCLmZJIz6OHQsawZF1hgMCFiOcQ2H+bhaDTEoLBVeEIQ0ENUICAXDSgHQBB7hrA54FzsY4YJ9WAQEMtvBZzfMFBL6gT4XbnQ8CAajSeE7hvymqBAT+7QAAAQCs/qEGYwWwABMAWwCwES+wAEVYsAcvG7EHHD5ZsABFWLAMLxuxDBw+WbAARViwEy8bsRMQPlmwBxCyCAEKK1gh2Bv0WbAA0LAHELAF0LAD0LAC0LATELIKAQorWCHYG/RZsA7QMDEBITchNTMVIQchAyETMwMzAyMTIQIY/pQaAWS8AX4b/ovHArjhveGUa6g9+/YFGJcBAZf7hQUT+vH+AAFfAAEAV/6/BMgEOgAPAEsAsA0vsABFWLADLxuxAxg+WbAARViwDy8bsQ8QPlmwAxCyBAEKK1gh2Bv0WbAA0LAPELIGAQorWCHYG/RZsAMQsAjQsAYQsArQMDEBITchByMDIRMzAzMDIxMhAWH+9hoCsRvxiAHioraifWSiOPzqA6OXl/z0A6P8Xf4oAUEAAQDEAAAFOQWwABkAUbIHGhsREjkAsABFWLAALxuxABw+WbAARViwDC8bsQwcPlmwAEVYsA8vG7EPED5ZsgYADxESOXywBi8YsAnQsAYQshUBCitYIdgb9FmwEtAwMQEDBhcWFhcTMwM2NxMzAyMTBgcHIzcmJjcTAeJLCQgMbms7kjhijny9/bxudX0uki7U0hdLBbD+N0Y1UFIGATb+0Q0hArf6UAJcIwzv6gfi2AHHAAEAmAAABBoEOwAYAEoAsABFWLAXLxuxFxg+WbAARViwDC8bsQwYPlmwAEVYsAEvG7EBED5ZshEBDBESOXywES8YsgcBCitYIdgb9FmwBNCwERCwFNAwMSEjEwYHByM3JiY3EzMDBhcWFxMzAzY3EzMDXrZKNGUckhyWmRIytTQFAQN7NpM0PVphtgGJDw2IhxLUrQE8/sMrKIsdARj+6QgTAhsAAQDsAAAFYgWwABIAPwCwAEVYsAIvG7ECHD5ZsABFWLASLxuxEhA+WbAARViwCi8bsQoQPlmyBRICERI5sAUvsg8BCitYIdgb9FkwMTMTMwM2FxYWBwMjEzYnJicmBwPs/bxvscne1BdMvEsICBjPoeB9BbD9pDcCBOrU/jkByEU2oQYDNv1JAAIAiv/rBcUFyAAjAC4AVwCwAEVYsBEvG7ERHD5ZsABFWLAALxuxABA+WbIlABEREjmwJS+yFwEKK1gh2Bv0WbAF0LAlELAN0LAAELIeAQorWCHYG/RZsBEQsioBCitYIdgb9FkwMQUmJgI3NyYmNxcGFxYXNxIAFxYSFxYHByEHBhcWFhcWNjcXBgElNjc2JicmBgcHA3Or+m0bE4WAC5MEAwprFE4BPNjJ5AUBDRD8ng8MCxCoi16qVSKA/eACqw4CA4qEjdM8DxUBpQEfq2caxpgCKCR2K0wBCgEnBQT+9u1aUmReWlOGmgMCLiWQYANXAk48obEEBMrQOgAAAgAH/+oERwRTAB8AKQBeALAARViwDy8bsQ8YPlmwAEVYsAAvG7EAED5ZsiQADxESObAkL7S/JM8kAl2yFQEKK1gh2Bv0WbAF0LAkELAM0LAAELIZAQorWCHYG/RZsA8QsiABCitYIdgb9FkwMQUuAjc3JiY3FwcGFzYkFxYWFxYHByEGFhcWNjcXBgYTJgYHBTc2JyYmAlCFy1cXBGBdB48EAz9GARippr0GAggM/T0ThH9ckT1oSNwFba00Ag4ECAcLaRQCkPCJEx6rhgE3Xi3Q7QUE2LZAQVOYygMCUUFYaGkDzQWdnwISNTRUZwAAAQA1/tMFRAWwABYAXbIVFxgREjkAsA4vsABFWLACLxuxAhw+WbAARViwBi8bsQYcPlmwAEVYsAAvG7EAED5ZsgQAAhESObAEL7AI0LAOELIPAQorWCHYG/RZsAQQshYBCitYIdgb9FkwMTMjEzMDMwEzARYSBwIABzc2Njc2Jicl8r39vW14Al/r/ZDT2Bga/t7qC5K1Fxajrf71BbD9jwJx/YQY/s/q/v3+2waaAs3EwNMBAQABAC3++gRWBDoAFgBjALAGL7AARViwEi8bsRIYPlmwAEVYsBUvG7EVGD5ZsABFWLAPLxuxDxA+WbAT0LATL7S/E88TAl2yLxMBXbL/EwFdsADQsAYQsgcBCitYIdgb9FmwExCyDgEKK1gh2Bv0WTAxARYWBwYGByc2Njc2JicnAyMTMwMzATMCbKOqEBHzsSR/lw0PjJOwULa8tlFQAc7qAmAg6KKl8iWWH5pvf5AFAf4zBDr+NgHKAAABAEP+RwVtBbAAFABmALAIL7AARViwAC8bsQAcPlmwAEVYsAMvG7EDHD5ZsABFWLASLxuxEhA+WbIBEgAREjl8sAEvGLIfAQFxtGABcAECXbKQAQFdsAgQsg0BCitYIdgb9FmwARCyEQEKK1gh2Bv0WTAxAQMhEzMBBgYnIic3FjMyNxMhAyMTAfxyArVzu/75GcKVLkkeOCiMI3j9S2+9/QWw/W4Ckvn8rbgCFJkR0gLK/X8FsAAAAQAk/kcEKwQ6ABQAfgCwAEVYsAAvG7EAGD5ZsABFWLADLxuxAxg+WbAARViwCC8bsQgSPlmwAEVYsBIvG7ESED5ZsAHQsAEvsm8BAV20vwHPAQJdsv8BAV2yDwEBcbKfAQFdsi8BAV2yPwEBcbAIELINAQorWCHYG/RZsAEQshEBCitYIdgb9FkwMQEDIRMzAwYGJyInNxYzMjcTIQMjEwGWUgHhUrTHFr6WLEsfNSuMI1r+H1C2vAQ6/isB1fttp7kCFJIQ0wIc/jIEOgACAFH/6QUqBcYAGgAkAF6yGiUmERI5sBoQsBzQALAARViwAC8bsQAcPlmwAEVYsAkvG7EJED5Zsg8ACRESObAPL7AAELIVAQorWCHYG/RZsAkQshsBCitYIdgb9FmwDxCyHwMKK1gh2Bv0WTAxARYEEgcHBgIEJyYmAjc3BTc2JyYmJyYHJzY2AxY2NwUHBhcWFgMAuAEBcRoMHdD+3aWv7GMaFAPQAxUJD72YpsojRNQopftH/OgHDwoQpAXDArP+vsZVzv6wqgMEpwEtv3wDDGNgnLkDA1aRLzb6wwX18gEjWVCBkQAAAQA8/+cEewWwABsAZbIZHB0REjkAsABFWLACLxuxAhw+WbAARViwDC8bsQwQPlmwAhCyAAEKK1gh2Bv0WbIEAAIREjmyBQIMERI5sAUvsAwQsBDQsAwQshMBCitYIdgb9FmwBRCyGQMKK1gh2Bv0WTAxASE3IQcBFhYHDgInJiY3MwYWFxY2NzYmJyc3A3z9kRwDUhf+I7TEDguQ8o2+3Qy6CHtug78QEYKLlBwFEp6G/iQQ5rqDyGwDBOy6dJMEBJZ/jJIEAaAAAAH//P5xBDUEOgAaAGGyBRscERI5ALALL7AARViwAi8bsQIYPlmyAAEKK1gh2Bv0WbIEAAIREjmyGgsCERI5sBovsAXQsAsQsQ8KK1jYG9xZsAsQshIBCitYIdgb9FmwGhCyGQEKK1gh2Bv0WTAxASE3IQcBFhYHBgQnJiY3MwYWFxY2NzYmJyc3Ayz9ohsDTBX+J7S/DhH+1dq93Qy0CHxwhsMPEIiKlBsDoZl//hYS4rXE8wQE7LhzmAQEm36NkAQBoP////j+RQTnBbAAJgCwQgAAJgHeuUAABwGvAOkAAP///+n+RQPQBDoAJgDrTQAAJgHem44BBwGvANoAAAAIALIACQFdMDEAAgAxAAAE4QWwAAoAEwBQsgQUFRESObAEELAN0ACwAEVYsAEvG7EBHD5ZsABFWLADLxuxAxA+WbIAAQMREjmwAC+wAxCyCwEKK1gh2Bv0WbAAELIMAQorWCHYG/RZMDEBEzMDJSYmNzYkMxMTJSIGBwYWFwPAY779/fvJ5RERAS7f4mP+to2/ERB6ewNzAj36UAEG68PN8v0pAjgBmoR3nQYAAgAy//4GMwWwABcAIABashghIhESObAYELAH0ACwAEVYsAgvG7EIHD5ZsABFWLAXLxuxFxA+WbIGFwgREjmwBi+wFxCyGAEKK1gh2Bv0WbAK0LIQBhcREjmwBhCyGgEKK1gh2Bv0WTAxJSYmNzYkMwUTMwMXNjYnJicXFhcWAgYnJRMlIgYHBhYXAeLN4xETASviAWBkveJLjZ4FAhOvDwgPc+WT/v5i/raMwBEQfXgBCO2/zfIBAj366wEC59FSUAFRUKv+65YCnQI4AZqEeZ0EAAACAEz/5gZBBhgAIwAzAICyBjQ1ERI5sAYQsCTQALAARViwBy8bsQcePlmwAEVYsAQvG7EEGD5ZsABFWLAeLxuxHhA+WbAARViwGi8bsRoQPlmyBgQeERI5sg4BCitYIdgb9FmyFAQeERI5shwEHhESObAEELImAQorWCHYG/RZsB4Qsi8BCitYIdgb9FkwMRM2EjYXFhcTMwMGFxYWFxYSEzYnNxYXFgIEJyYnBicmJicmNwEmJyYGBwcGFxYWFxY2NzdVFYzLgK5dbbXPBAQFQjmjxggCEKgNAweI/v2m7i2LzJexBwMGAuI/kIi2HgMHAwVrYVeDMwYCArIBFocDBIACTvtAJCU/SgMJAUEBImNkAWRj1/6gvwMFsbsEAtS1PTsBQoAEBd/TFDw/bX8DA1NCPwAAAQCt/+gFqgWwAC0AXACwAEVYsA4vG7EOHD5ZsABFWLAqLxuxKhA+WbIFLg4REjmwBS+yBAEKK1gh2Bv0WbAOELINAQorWCHYG/RZshUEBRESObAqELIdAQorWCHYG/RZsiMqDhESOTAxATYmJyc3FzI2NzYmJyU3BRYXFgcGBRYWFxYHBhYXFjYSNzYnMxYXFgIGJyYmNwKBCWNjyRyCobgQDXuA/pkcATn7cl8PFf71RlIGBAwHOz9dkFcGAxCvDAQGgvCfj5cIAXV2hwUCngGFhHJ8BAGeAQF/aqjncB96UTR5R1wEBYQBF8BjZGRj1v6fvwICqJsAAAEAaP/jBLgEOgAnAFkAsABFWLAeLxuxHhg+WbAARViwDi8bsQ4QPlmyAgEKK1gh2Bv0WbIHDh4REjmyFigeERI5sBYvshUBCitYIdgb9FmwHhCyHQEKK1gh2Bv0WbIlFRYREjkwMSUGFxY2NzYnFxYXFgIGJyYmNzc2Jyc3FzI2NzYnJTcXFhYHBgcHFgcCkQhSapYYGiipDwkSceWQfX0GCAux2BmrdYwKFdT+9xT4t8cKCJk+mA/TUwQFopCenQFOTpz+2aEDAnxyTYwKAZYBWVGfCwGWAQWljolPHTiyAAABAK/+1gOVBa8AJwBWALAbL7AARViwCi8bsQocPlmwAEVYsB4vG7EeED5ZsgEoChESObABL7IAAQorWCHYG/RZsAoQsgkBCitYIdgb9FmyEQABERI5sB4QsRcKK1jYG9xZMDETNxcyNjc2JiclNxcWFgcGBgcWFxYPAjcHBgcnNjcjJicmNzc2JievG5OnvA8Ne4D+6Bvu3eURC4mEkBAEBxcGqhckuWhXL2AhBQQIFg1nagJ5lwGLgXiABAGXAQHYvHGnO0CrMzWIGAGN3ZRMZ3crRyU/nHOOBAAAAQCg/sYDdgQ6ACMAVgCwGi+wAEVYsAovG7EKGD5ZsABFWLAdLxuxHRA+WbIBJAoREjmwAS+yAAEKK1gh2Bv0WbAKELIJAQorWCHYG/RZshEAARESObAdELEWCitY2BvcWTAxEzcXMjY3NiYnJTcFFhYHBgYHFhcWBwc3BwYHJzY3IyY3NzYnoBnEdo4LCmFn/uAbAQi1xwoFa3J3EAUGDJsWIrxnXixcKQYRD7EBuJcBWFNRVgMBlgEFpY5Qei0tfikoSwGO25VMc3srVI+fCQAAAf/f/+UHOwWwACQAYrIjJSYREjkAsABFWLAOLxuxDhw+WbAARViwIS8bsSEQPlmwAEVYsAYvG7EGED5ZsA4QsgABCitYIdgb9FmwBhCyCAEKK1gh2Bv0WbAhELIVAQorWCHYG/RZshsOBhESOTAxASEDBwICByM3NzY2NzcTIQMGFxYWFxYSEzYnNxYXFgIEJyYmNwSA/it3Jz/tt0sRM36dKxmQA0e8BAQFQTefwwgCEa8NAweJ/v2koJ0RBRL93bz+2/72BJwDDN3wjgKq+6kjJD5JAwkBPQEhY2QBZGPZ/qDABAbCqQAAAf/a/+UGBQQ6ACQAYrIAJSYREjkAsABFWLAOLxuxDhg+WbAARViwIS8bsSEQPlmwAEVYsAYvG7EGED5ZsA4QsgABCitYIdgb9FmwBhCyCQEKK1gh2Bv0WbAhELIVAQorWCHYG/RZshohDhESOTAxASEDBwYGByM3NzY2NzcTIQMGFxYWFxYSEzYnMxYXFgIGJyYmNwNR/sdSFjW+lU4TJmR+IA1iApx7AwMFQzeJoQUBEagNBQh55JCbnREDof6ObPLOA6ICBqnDSgHa/R4jJUBNAQYBJgEEXl5eXsT+s7AEBMCsAAABADv/5gc8BbAAHgB7ALAARViwGy8bsRscPlmwAEVYsB4vG7EeHD5ZsABFWLAYLxuxGBA+WbAARViwEi8bsRIQPlmyBgEKK1gh2Bv0WbILEh4REjmwGBCwHNCwHC+y/xwBXbJfHAFdss8cAV2yLxwBXbIfHAFxsk8cAXGyFwEKK1gh2Bv0WTAxAQMGFxYWFxYSEzYnNxYXFgIEJyYmNxMhAyMTMwMhEwVYugMDBUI1n8QGAhGwDQQHif7+ppycDS/9WG+9/b1zAqhyBbD7pyMkPkkBCAE/AR5jZAFkY9v+o8ADBMSpASf9fwWw/W4CkgABACP/5wYXBDoAHgCLALAARViwBS8bsQUYPlmwAEVYsAgvG7EIGD5ZsABFWLAbLxuxGxA+WbAARViwAi8bsQIQPlmwBtCwBi+ybwYBXbL/BgFdsg8GAXG0nwavBgJxsj8GAXG0vwbPBgJdsi8GAV20zwbfBgJxsgEBCitYIdgb9FmwGxCyDwEKK1gh2Bv0WbIUGwgREjkwMQEhAyMTMwMhEzMDBhcWFhcWEhM2JzMWFxYCBicmJjcDEv4WULW8tVIB6VK1ewQEBUE4iaQDARGnDgUIeeKTmZ0PAc3+MwQ6/ioB1v0eIyVBSgMGASkBAV5eXl3I/revAgLGqAABAGr/6ASCBcgAIgBAALAARViwCS8bsQkcPlmwAEVYsAAvG7EAED5ZsAkQsg4BCitYIdgb9FmwABCyFwEKK1gh2Bv0WbIdAAkREjkwMQUmJicmNzcSABcWFwcmJyYCBwcGFxYWFxY2Njc0JzMXFgIEAkjG/hMHCictAWr8yYtFfpew/yMnBwIDnoZop1cBC7MKB4b+/hUF/M5MT/kBHgFcAgJWi0UCAv763PY0Np3EAgNowrJaWbPV/vGUAAEATP/nA4oEUgAfAD0AsABFWLATLxuxExg+WbAARViwCy8bsQsQPlmyAAEKK1gh2Bv0WbIFCxMREjmwExCyGAEKK1gh2Bv0WTAxJRY2NjcnMxcWBgYnLgI3NzYAFxYXByYjJgYHBhcWFgH2SmouAgKpBgNlwnmHv1gQAx0BKtKoajlhfoXAGgwGCnuCAj9ydHV0n7xkAwSN+JIa+wE4AgJEjj0C2rFnRnSMAAABAJr/5QUgBbAAGgBDALAARViwAy8bsQMcPlmwAEVYsBcvG7EXED5ZsAMQsgQBCitYIdgb9FmwANCwFxCyCQEKK1gh2Bv0WbIPFwMREjkwMQEhNyEHIQMGFhcWNhI3Nic3FhcWAgcGJyYmNwJn/jMcBF8c/iuhCENDa6NZAwEQrg4DBV9elN2YoA0FEp6e/EdibQIEkAEZsGNkAWRjtf7JaKUEAsOsAAABAH3/6ASIBDoAGgBNsgUbHBESOQCwAEVYsAIvG7ECGD5ZsABFWLAXLxuxFxA+WbACELIAAQorWCHYG/RZsATQsAXQsBcQsgsBCitYIdgb9FmyEAIXERI5MDEBITchByEDBhcWFhcWEicmJxcWFxYCBicmJjcB2P6lGgNxGv6gYQQEBUI5haMGAxKnDgkQceOTmp0NA6SWlv20JCU/SwMGAQLTUU8BT0+i/tigAQLEqgAAAQBq/+kFIwXHACwAZrIaLS4REjkAsABFWLAbLxuxGxw+WbAARViwDi8bsQ4QPlmyBgEKK1gh2Bv0WbIKGw4REjmwDhCwK9CwKy+yLAEKK1gh2Bv0WbIULCsREjmyHxsOERI5sBsQsiMBCitYIdgb9FkwMQEiBgcGFhcWNjc3BgYEJy4CNzYlJiY3NjYkFx4CByc2JicmBwYHBhYXFwcCzb3QDg+wnZXhFbwOn/75m5nxdAoVATJfZAUIlAEPp4bYdgW7BZyFnGt3EA6Zm7QcApiPf3WLAwKTewGEwWYDAmy6ev9jMKBdgMFpAgNltncBbYQFAkBIf3F6AQGeAAACAPIEcgNMBdYABQAQABsAsA0vsAbQsAYvsAHQsAEvsA0QsAXQsAUvMDEBEzMHAQcDMwcGFxYXByYmNwHqo78B/vZY4qQNCggIJkhISAkElQFBFv7FAgFTTz42NzM3LoxW//8AGQIfAg8CtgAGABEAAP//ABkCHwIPArYABgARAAD//wCnAosElQMiAEYBl9oATM1AAP//AJkCiwXXAyIARgGXiABmZkAA////X/5sAx8AAAAnAEP/3v8DAQYAQwkAABQAQAkAAhACIAIwAgRdsrACAV0wMQABAK4EMQIFBhMABwAWALAARViwAC8bsQAePlmwBdCwBS8wMQEXBgcHIzc2AaFkcBsYtBIkBhNKjIaGcN4AAAEAiQQWAeAGAAAHABYAsABFWLAELxuxBB4+WbAA0LAALzAxEyc2NzczBwbtZHYYF7ITJAQWSpOKg3nhAAH/mP7lAOoAtQAHABcAsAgvsgQFCitYIdgb9FmwANCwAC8wMQMnNjc3MwcGBWNzGBK1DyP+5UuQi2pg3AAAAQDUBBcBugYAAAsADACwCy+wBtCwBi8wMQEHBhcWFwcmJyY3NwGhFgsKCiZqZxAFBhUGAIVNRkdFRWqdMTGA//8AtgQxAz4GEwAmAWwIAAAHAWwBOQAA//8AlQQWAxUGAAAmAW0MAAAHAW0BNQAAAAL/lP7SAhUA9gAHAA8AIwCwEC+yBAUKK1gh2Bv0WbAM0LAML7AI0LAIL7AA0LAALzAxAyc2NzczBwYXJzY3NzMHBgRodBsetBknZmd0Gh61GSf+0kuXl6uc8ZdLmpSrnPAAAQB3AAAEUQWwAAsASwCwAEVYsAgvG7EIHD5ZsABFWLAGLxuxBhg+WbAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZsAoQsgABCitYIdgb9FmwBNCwBdAwMQEhAyMTITchEzMDIQQ4/nmStZH+fBgBgzu2OwGJA6H8XwOhmQF2/ooAAAH/9v5gBGAFsAATAHwAsABFWLAMLxuxDBw+WbAARViwCi8bsQoYPlmwAEVYsA4vG7EOGD5ZsABFWLACLxuxAhI+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgYBCitYIdgb9FmwDhCyCAEKK1gh2Bv0WbAJ0LAQ0LAR0LAGELAS0LAT0DAxISEDIxMhNyETITchEzMDIQchAyEDt/52QbZC/n4YAYF6/n4YAYE7tjsBihj+dnkBiv5gAaCXAwqZAXb+ipn89gABAKACFQIsA8wADQAWsgoODxESOQCwAy+xCgorWNgb3FkwMRM2NjMyFhUHBgYjIiY1oQZ1VlFpAgZxWlJnAv1ecW1YKlpualUA//8AOf/yAsEA0wAmABIEAAAHABIBrAAA//8AOf/yBFMA0wAmABIEAAAnABIBrAAAAAcAEgM+AAAAAQAaAh4A2wK3AAMADwCwAi+xAQorWNgb3FkwMRMjNzO/pRumAh6ZAAYAl//nBv4FxwAXACYAKgA4AEYAVACFALApL7AnL7AARViwGC8bsRgcPlmwAEVYsBEvG7ERED5ZsADQsAAvsAXQsAUvsBEQsA3QsA0vsBgQsB/QsB8vsBEQsi4ECitYIdgb9FmwABCyNQQKK1gh2Bv0WbAuELA80LA1ELBD0LAfELJKBAorWCHYG/RZsBgQslEECitYIdgb9FkwMQEWFhc2FxYXFgcHBgYnJicGJyYmNzc2NgEWFgcHBgYnJiY3Nz4CAycBFwEGFhcWNjc3NiYnJgYHBQYWFxY2Nzc2JicmBgcBBhYXFjY3NzYmJyYGBwQ7QnAeZod4SEYIBg23gpU+ZIV4kQgGDbf+MXyOCAYPtn15kggHCFmNPWIDcWL+rQdEQkZjCwkHQkNGYwwBtAdDQkdjCwkHQkNGYwz77AdEQkNlDAkHQkNIYwsCkwI8PHoCAldVfkOOrQIFdHsEAqt/Qo2vAzEEq39NhqoEAqx+TFWPTPqpSARoR/w8TmQCAmdRT05jAgJjU1BMZgICaU9PS2YCAmNTAuRNZAICY1ROTGYCAmhPAAABAF8AmQJUA7UABgAQALAFL7ICBwUREjmwAi8wMQETIwM3ATMBC7J94QIBW5gCHP59AYMUAYUAAAEAAgCYAfcDtQAGABAAsAAvsgMHABESObADLzAxARMHASMBAwEW4QL+pZgBSLEDtf59Ff57AZgBhQAB/+8AcAPCBSAAAwAJALAAL7ACLzAxNycBF1FiA3FicEgEaEgA//8AYQKQAuQFpQMHAdgAcQKQABMAsABFWLAJLxuxCRw+WbAN0DAxAAABAH4CiwNKBboAEQBMALAARViwAC8bsQAcPlmwAEVYsAMvG7EDHD5ZsABFWLAPLxuxDxQ+WbAARViwCC8bsQgUPlmyAQMPERI5sAMQsgwDCitYIdgb9FkwMQEXNjMyFgcDIxM3JicmBwMjEwGEAVyGcXIMU6ZNAwRmY0Ngp4sFrHyKopH+BAHdQn4DAm/9zQMgAAH/8wAABIkFygAnAI8AsABFWLAXLxuxFxw+WbAARViwBi8bsQYQPlmyJwYXERI5sCcvsgACCitYIdgb9FmwBhCyBQEKK1gh2Bv0WbAJ0LAAELAN0LAnELAP0LAnELAj0LAjL7YPIx8jLyMDXbIkAgorWCHYG/RZsBHQsCMQsBPQsBcQsRsKK1jYG9xZsBcQsh4BCitYIdgb9FkwMQEhBwYHJQchNxc2NzcHNzM3IzczNzYkFxYWByc2JicmBgcHIQchByEC5/6+CRhUAssd/BUdQ2klC6sWoRSeFpkVGQEWwKjACLsHZGNvmg8VAVIW/rMUAUoB1kSUYwKdnAIm0EcBfYh9r832BgTRsQFreQQEp32vfYgABQAKAAAGQgWwABsAHwAjACYAKQCxALAARViwFy8bsRccPlmwAEVYsBovG7EaHD5ZsABFWLAMLxuxDBA+WbAARViwCS8bsQkQPlmyEAwXERI5sBAvsBTQsBQvtA8UHxQCXbAk0LAkL7AY0LAYL7AA0LAAL7AUELITAQorWCHYG/RZsB/QsCPQsAPQsBAQsBzQsBwvsCDQsCAvsATQsAQvsBAQsg8BCitYIdgb9FmwC9CwKdCwB9CyJhcMERI5sicJGhESOTAxATMHIwczByMDIwMhAyMTIzczNyM3MxMzEyETMwEhJyMFMzchJTMnATcjBWrYGtga2BrYVbfh/mpVvFXTG9Ia0xvSWrXtAYhau/vuATdE2AHjyxr+2P55eVcCPB1qA6yYlJj+GAHo/hgB6JiUmAIE/fwCBPzQlJSUmL7816cAAgA5/+0GJQWwACAAKQCIALAARViwHC8bsRwYPlmwAEVYsBYvG7EWHD5ZsABFWLAULxuxFBA+WbAARViwCy8bsQsQPlmwHBCwH9CyAQEKK1gh2Bv0WbALELIGAQorWCHYG/RZsAEQsA/QsiEWFBESObAhL7ITAQorWCHYG/RZsBwQsB3QsB0vsBYQsikBCitYIdgb9FkwMQEjAwYXFjMyNwcGJyYmNxMjAiEnAyMTBR4CBzcTMwMzARc+AicmJycGC8NyAwIHTyA1C0JEa2wMboFv/nTFY7X9AWJ4tFsFkC+1LsX7RbB4m0MME7zFA6v9YBoXTQqYEgEClYgCnv6JAf3LBbABA1yncAEBBv76/pIBAmrEa6kIAQD//wA6/+kH6gWwACYANgAAAAcAVwQ0AAAABwAiAAAHaQWwAB8AIwAnACsAMAA1ADoAtwCwAEVYsB4vG7EeHD5ZsABFWLAbLxuxGxw+WbAARViwAi8bsQIcPlmwAEVYsA0vG7ENED5ZsABFWLAQLxuxEBA+WbIUEBsREjmwFC+wGNCwGC+wHNCwNtCwANCwBNCwGBCyFwEKK1gh2Bv0WbAn0LAj0LAr0LAH0LAUELAk0LAg0LAo0LAI0LAUELITAQorWCHYG/RZsDLQsA/QsC3QsAvQsjQQHhESObA0ELAv0LI5HhAREjkwMQEhEzMDMwcjBzMHIQMjAyEDIwMhNzMnIzczAzMTIRMzASEnIwUzNyMFMzcjEwcXFzclBxcHNwE3JycHBKQBSbnDwo4bsVDgG/79w6sx/pHdqx7++xvhDLQbjx22GAFK153+nAEaFK3+Xp5Y/wMEn03+fFYDBUP9BlMBCUUBlWIKAisD1AHc/iSYwpj+HgHi/h4B4pjCmAHc/iQB3PzKwsLCwsL+qAIpssMaARi6pQIcAltiawAAAgAf//wFyAQ6AA4AGwBKALAARViwFi8bsRYYPlmwAEVYsAwvG7EMED5ZsA/QshIBCitYIdgb9FmwFhCwDtCyBRIOERI5sgsBCitYIdgb9FmyEAsPERI5MDEBFhYHAyMTNicmJyUDIxsCMwMFMjcTMwMGBicC65mPEzW1NgYCCpL+waG1vMGAtWUBKuEodLVyGcurBDgFzcD+twFMMCyVBQL8XwQ6+8YC3f27AvUCr/1Zyc4EAAABAFH/7ASIBccAJQCKsh8mJxESOQCwAEVYsBgvG7EYHD5ZsABFWLALLxuxCxA+WbIlGAsREjmwJS+yAAIKK1gh2Bv0WbALELIGAQorWCHYG/RZsAAQsA/QsCUQsBDQsCUQsBXQsBUvtg8VHxUvFQNdshICCitYIdgb9FmwGBCyHQEKK1gh2Bv0WbAVELAg0LASELAi0DAxASEGFxYWFxY3FwYnJgI3BzczNyM3MxIAFzIXByYnJgYHIQchByEDLv6OCQcMhnJffAVyd+LuILQWrBmtFqU+ATvoWZQiamOh0y4Behb+jBgBdQIdSkd4hgMDIqEdAgQBNvYBfIl9AQ0BGwIepCQCAsrCfYkABABDAAAF+wWwABkAHgAjACgAwACwAEVYsAsvG7ELHD5ZsABFWLABLxuxARA+WbALELIoAQorWCHYG/RZsCTQsCQvQAkAJBAkICQwJARdsAbQsAYvtA8GHwYCXbQgBjAGAl2ysAYBXbAj0LAjL7SwI8AjAl1ACQAjECMgIzAjBF2yAAEKK1gh2Bv0WbAGELIDAQorWCHYG/RZsCQQshwBCitYIdgb9FmwB9CwJBCwCtCwCi+wJBCwD9CwHBCwEtCwBhCwHdCwFNCwAxCwItCwF9AwMQEDIxMjNzM3IzczNwUyFhczBycHBzcHBwYhATcFBwUFNjcFBxMlJichAZRju43AGsARwRvAKgHtpeIn7hu4Cg7BG9SY/qQBdgn9fBACff6coXL9uhBUAjY4lf6nAjr9xgMwl16X9AF+dZcBMy4ClwH2Abk0AV4B8AJaAlkB5QJPBQAAAQBJAAAEcgWwABoAXwCwAEVYsBkvG7EZHD5ZsABFWLAMLxuxDBA+WbAZELIYAQorWCHYG/RZsAHQsBgQsBPQsBMvsAPQsBMQshIBCitYIdgb9FmwBtCwEhCwDtCwDi+yCQEKK1gh2Bv0WTAxAQcWBzMHIwYEBwEHIwE3FzI3BTchJiYnJTchBCnmJwTPSY80/wDlAXwB2f5jFOL1Zv3GSQIBBnxo/uBJA4kFEgFeZ56yrwf9yA4CcnQCywGeXWQEAZ4AAAEACv/pBBQFsAAeAI0AsABFWLARLxuxERw+WbAARViwBS8bsQUQPlmyExEFERI5sBMvsBfQsBcvsgAXAV2yGAEKK1gh2Bv0WbAZ0LAI0LAJ0LAXELAW0LAL0LAK0LATELIUAQorWCHYG/RZsBXQsAzQsA3QsBMQsBLQsA/QsA7QsAUQshoBCitYIdgb9FmyHgURERI5sB4vMDEBBwYCBCcmJxMFPwIFNyUTMwclBwUHJQcFAzYSNzcEFAobwf7lrkpyYv7/Iv8a/v8hAQA7vC0BCCH++RkBCCH++WG/8yUOAwNO1f6zqgICEwJUbrxvjm68bwFU+3K8co9yvHP94QUBFfBrAAAB//IAAASGBDoAHABVALAARViwHC8bsRwYPlmwAEVYsAgvG7EIED5ZsABFWLAPLxuxDxA+WbAARViwFS8bsRUQPlmyAA8cERI5sAAvsg4BCitYIdgb9FmwEdCwABCwGtAwMQEeAhUUBwcjNzYnJiYnAyMTBgIHByM3EgA3NzMDFHanVQoetRwUBgtpXYG1gZfGJyK1Hy8BNuootQNvF5Pti0tIuqp8Z4yYHP0zAswl/wDZzrkBKwFqI8kAAAL/5QAABTUFsAAWAB8AbQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIGAwwREjmwBi+yBQEKK1gh2Bv0WbAB0LAGELAK0LAKL7QPCh8KAl2yCQEKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAMELIfAQorWCHYG/RZMDEBIQMjEyM3MzcjNzMTBRYWBwYEIyUHIQEFMjY3NiYnJQKt/rwwuzDJHMgZyhzIfwH90+oREv7V8P6lGAFF/u4BRZnDERCHfv6mARP+7QETnomdAtkBB+y+0vMBiQEmAZyLepYEAQAEAMz/5gU5BcgAGwApADcAOwB7ALA4L7A6L7AARViwCi8bsQocPlmwAEVYsCMvG7EjED5ZsAoQsAPQsAMvsgADChESObIOCgMREjmwChCyEQQKK1gh2Bv0WbADELIYBAorWCHYG/RZsCMQsBzQsBwvsCMQsi0ECitYIdgb9FmwHBCyNAQKK1gh2Bv0WTAxAQYGJyYmNzc2NhcWFgcnNiYnIgYHBwYWFzI2NwEWFgcHBgYnJiY3NzY2AwYWFxY2Nzc2JicmBgcFJwEXAuUMn3NziAkGDat8b4kChwM2QEFcCggIODw8Tg0B0HuPCAYNtYF5kQgGDLQ/BUNCSGELCQdDQkVmC/3zZANxYwQec48EAqt+Q4uvAgKPcQE6TQJoVkZKZwJLO/50BKl/Q42vBAKrgESLrf6CUGECAmlOT0xmAgJmUfVIBGhHAAACAEv/6wPDBhcAHAAkAFMAsAkvsABFWLAPLxuxDx4+WbAARViwAC8bsQAQPlmwCRCyCAEKK1gh2Bv0WbAW0LAAELIcAQorWCHYG/RZsAkQsB3QsA8QsiIBCitYIdgb9FkwMQUmJicmNzcGBzc2NxM2NhcWFgcHBgAHBwYVBhYXAzYSNzYnJgcCVYOoFA0PBGRtFGVsXhiuhHF6CgMT/wDHEQgCUlBtfo0GBENuGRUGlIFPWBQbArACIQIhtskDBK+HH8f+jXFjNTJVYgUCX28BCqRtBQblAAAEADUAAAfvBcUAAwARACAAKgCIALAARViwJy8bsSccPlmwAEVYsCkvG7EpHD5ZsABFWLAELxuxBBw+WbAARViwIS8bsSEQPlmwAEVYsCQvG7EkED5ZsAQQsAvQsAsvsALQsAIvsgEDCitYIdgb9FmwCxCyFQMKK1gh2Bv0WbAEELIdAworWCHYG/RZsiMpJBESObIoISkREjkwMQEhNyEDFhYHBwYGJyYmNzc2NgMGFhcWNj8DJicmBgcBIwEDIxMzARMzB0n9qhoCVqKQngwJEdCWj6EMCA/USghLSk5rEQILAQaIUm0O/gTB/oPHtPzBAX/HswGcjgOXBMOTV6XCBATCklaiyP4+Y2cCA2VgDGMpoAMCbWL7mQR2+4oFsPuHBHkAAgDqA5YErQWwAAwAFABtALAARViwBi8bsQYcPlmwAEVYsAkvG7EJHD5ZsABFWLATLxuxExw+WbIBFQYREjmwAS+yAAkBERI5sgMBBhESObAE0LIIAQkREjmwARCwC9CwBhCxDQorWNgb3FmwARCwD9CwDRCwEdCwEtAwMQEDBwMDIxMzExMzAyMBIwMjEyM3IQQ6wzRGR1leakXScV5Y/mqOUFlPjw4BeAUS/oYCAZH+cAIZ/nMBjf3nAcj+OAHIUQACAIL/6QR8BFIAFQAcAGKyAh0eERI5sAIQsBbQALAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZshoKAhESObAaL7IPCgorWCHYG/RZsAIQshMKCitYIdgb9FmyFQoCERI5sAoQshYKCitYIdgb9FkwMSUGJyYmAjc2EiQXHgIHByEDFhcWNwMmBwMhEyYDsLi+hNBkDg6yAQSKgL5gCwX9FDtfj6rWzoiaMwILM11ddAQCmgECiZIBEZsEBIr7kjH+tmcEB38DKwN8/uoBH2z//wC1//QFdAWbACcB1QBKAoYAJwF8AN8AAAEHAdwC/AAAABAAsABFWLAFLxuxBRw+WTAx//8Akv/0BhAFtgAnAdcAlwKUACcBfAGYAAABBwHcA5gAAAAQALAARViwDS8bsQ0cPlkwMf//AI//9AYGBaQAJwHZAHkCjwAnAXwBdwAAAQcB3AOOAAAAEACwAEVYsAEvG7EBHD5ZMDH//wC+//QFvAWkACcB2wCPAo8AJwF8ARcAAAEHAdwDRAAAABAAsABFWLAFLxuxBRw+WTAxAAIATf/nBDcF7AAeACwARwCwDy+wAEVYsBcvG7EXED5ZsgAPFxESObAAL7APELIJAQorWCHYG/RZsAAQsh8BCitYIdgb9FmwFxCyJgEKK1gh2Bv0WTAxARYWFzYnLgInJgYHJzYXFhYSBwICBCcmAj8CNgAXJgYGFxYWFxY2Nzc2JgJkVpc0BAIEQXlSS49GApOlk8NUCA2e/v6ku9YGAwIdASLVbKxWCwlyY4/CJAoDkwP+AktFLjVlsmADAiMYmEQBA57+08D+2/56ywQFAQTTMRLlARWdA33kj3KDBAXz5UFUeQAAAQAk/ysFRgWwAAcAJwCwBC+wAEVYsAYvG7EGHD5ZsAQQsAHQsAYQsgIBCitYIdgb9FkwMQUjEyEDIwEhBEG17v1M7bUBBQQd1QXt+hMGhQAB/6z+8wTSBbAADAA1ALADL7AARViwCC8bsQgcPlmwAxCyAgEKK1gh2Bv0WbAF0LAIELIKAQorWCHYG/RZsAfQMDEBASEHITcBATchByEBA0/9WgNjG/u7GgLM/i0YA/sb/NkBwQJC/UmYmALMAtKHmP1EAAEAqwKLA/EDIgADABsAsABFWLACLxuxAhY+WbIBAQorWCHYG/RZMDEBITchA9b81RsDKwKLlwAAAQBBAAAFDgWwAAgAPLIDCQoREjkAsAcvsABFWLABLxuxARw+WbAARViwAy8bsQMQPlmyAAEDERI5sAcQsgYBCitYIdgb9FkwMQEBMwEjAyM3IQHlAmnA/PaKgbgcAS4BHgSS+lACdJoAAAMATf/mB6EEUgAZACoAOwBEALAARViwBi8bsQYQPlmwANCwBhCwDdCwDS+wE9CwBhCyHQEKK1gh2Bv0WbANELInAQorWCHYG/RZsC/QsB0QsDjQMDEFJiYnBgYnJiYnJhIkFxYWFzY2Fx4CBwIAARQWFxY2Njc3NiYnJicmBgYFNyYmJyYGBgcHBhYWFxY2NwVpjtQoffSFo9QSE5IBC56N1Sh69oqBu1kPHv7I+tV3alSriRwHBT84Tl5ppWIFzwQDc2lUqI4dBwZNh0+NxBcVBMefyaUDBOW3rAFawgQExqHEqwMEk/uN/v3+uQHMiacCAm7CXSpKqDpRBASD9w9Tj6EEAmnDYClPvXMEBeezAAAB/xr+RQMHBhoAFQA9sgIWFxESOQCwAEVYsA4vG7EOHj5ZsABFWLADLxuxAxI+WbIIAQorWCHYG/RZsA4QshMBCitYIdgb9FkwMRcGBicmJzcWFxY3EzY2FxYXByYjIgfxE7mVNUEcNBmcHsMTxZ02XCIwKLcja6OtAgIUkg4BB8kFDKjEAgEVjw3lAAIAMQEVBC0D8wAWACkAawCwGS+wAtCwAi+wCNCwCC+wAhCwC9CwCBCyDgEKK1gh2Bv0WbACELIUAQorWCHYG/RZsA4QsBbQsBkQsB3QsB0vsBkQsB/QsB0QsiIBCitYIdgb9FmwGRCyJgEKK1gh2Bv0WbAiELAp0DAxEzYzMhcXFhYzMjY3BwYnIiYnJyYjIgcHNjM2FhYzMjcHBiciJiYjIgcHjG2QU1A4MV46PHdNFW+CO2AxMlRSf4k4bo0yU9RNeoQUb4IsStlUbHAtA4ZtKx8dKThHvW8CKR0cL3/mbgEaeH+8bwIWelkmAAABAHAAnQP/BNMAEwA3ALATL7IAAQorWCHYG/RZsATQsBMQsAfQsBMQsA/QsA8vshABCitYIdgb9FmwCNCwDxCwC9AwMQEhByc3IzczNyE3IRMXBzMHIQchA5r+A7NbhaQc/b3+chwB6cFbkrgd/u68AaMBj/JBsaD/oQEEQcOh/wD////UAAIDyQRCAGYAIBFhQAA5mgAHAZf/Kf13//8AGQABA+gETQBmACIUc0AAOZoABwGX/279dgACAEEAAAPUBbAABQAJADiyCAoLERI5sAgQsAHQALAARViwAC8bsQAcPlmwAEVYsAMvG7EDED5ZsgYAAxESObIIAAMREjkwMQEzAQEjCQITAQI9iQEO/gWK/vICKP6PtAFyBbD9Hf0zAuECBP3n/f4CF///AHgApAHwBPcAJwASAEMAsgAHABIA2wQkAAIAcAJ5AncEOgADAAcAJQCwAEVYsAMvG7EDGD5ZsADQsAAvsAXQsAUvsAMQsAbQsAYvMDETIxMzEyMTM/qKTorgik+KAnkBwf4/AcEAAAH/4/9fAQ8A7wAHAAwAsAQvsADQsAAvMDEXJzY3NzMHBkZjWxYPrAkeoUp7eVI/0wD//wB0AAAFawYZACYASgAAAAcASgIbAAAAAgBYAAAEBQYZABYAGgBpALAARViwCS8bsQkePlmwAEVYsBMvG7ETGD5ZsABFWLAZLxuxGRg+WbAARViwFi8bsRYQPlmwAEVYsBgvG7EYED5ZsBMQshQBCitYIdgb9FmwAdCwExCwBNCwCRCyDwEKK1gh2Bv0WTAxMxMjPwI2NzYXFhYXByYnJgcHMwcjAyEjEzNbo6YZpg4beHOvR4VGLHFv5SIN1xnWowI4try2A6uPAWS3ZF8CAiMYnjMCBORXj/xVBDoAAQB0AAAEYgYaABgAXACwAEVYsBMvG7ETHj5ZsABFWLAHLxuxBxg+WbAARViwCi8bsQoQPlmwAEVYsBgvG7EYED5ZsBMQsgIBCitYIdgb9FmwBxCyCAEKK1gh2Bv0WbAM0LAHELAP0DAxASYjIgYHBzMHIwMjEyM3Mzc2NhcWFxcDIwOfgTtjeA8S4Rngo7WkpxmmEhrYpm24YP61BWUWb19zj/xVA6uPf6e6AgIqFPooAAIAdAAABlcGGwAnACsAlwCwAEVYsAgvG7EIHj5ZsABFWLAWLxuxFh4+WbAARViwIC8bsSAYPlmwAEVYsCovG7EqGD5ZsABFWLAnLxuxJxA+WbAARViwJC8bsSQQPlmwAEVYsCkvG7EpED5ZsCAQsiEBCitYIdgb9FmwJdCwAdCwIBCwEtCwBNCwCBCyDQEKK1gh2Bv0WbAWELIcAQorWCHYG/RZMDEzEyM3Mzc2NhcWFwcmJyIGBwchNzY2FxYWFwcmJyYHBzMHIwMjEyEDISMTM3ekpxmmERfUoDZLFjAxWXUREwGDDhrntUiJRC9zb+QiDdgZ16O1o/59owRvtby1A6uPeajAAgIQmAoCal55ZbHJAgImGJszAgLiV4/8VQOr/FUEOgAAAQB0AAAGmQYbACoAigCwAEVYsAkvG7EJHj5ZsABFWLAXLxuxFx4+WbAARViwIy8bsSMYPlmwAEVYsCovG7EqED5ZsABFWLAnLxuxJxA+WbAARViwHC8bsRwQPlmwIxCyJAEKK1gh2Bv0WbAo0LAB0LAjELAT0LAE0LAJELIOAQorWCHYG/RZsBcQsh8BCitYIdgb9FkwMTMTIzczNzY3NhcWFwcmIyIGBwchNzY2FxYXFwMjEyYjJgcHMwcjAyMTIQN3o6YZphIdemaONUsWOihbdRARAYQPGdaqVnG//rXzgTzNIg7hGt+jtaP+faMDq49/tl5OAgIQmAxuZ2xrtMECAhYo+igFZBYC41+P/FUDq/xVAAABAHT/7QTIBhoAJgCBALAARViwIi8bsSIePlmwAEVYsB4vG7EeGD5ZsABFWLARLxuxERg+WbAARViwJS8bsSUYPlmwAEVYsAsvG7ELED5ZsABFWLAZLxuxGRA+WbAeELIbAQorWCHYG/RZsBDQsAHQsAsQsgYBCitYIdgb9FmwIhCyFQEKK1gh2Bv0WTAxASMDBhcWMzI3BwYnJiY3EyM3MxMmJyIGBwMjEyM3Mzc2NhcWFwMzBK7DcgMCB08iMgpCQW5sDG7AGr8zRWpVchLNtaSnGaYRF8WerNU8xQOr/WAaF00KmBIBApuCAp6PASEkAmtp+1MDq494pcMCA2b+iwABACn/6QZ2BhMATQC2ALAARViwSC8bsUgePlmwAEVYsEEvG7FBGD5ZsABFWLASLxuxEhg+WbAARViwLi8bsS4QPlmwAEVYsAovG7EKED5ZsBIQsEzQsgEBCitYIdgb9FmwChCyBQEKK1gh2Bv0WbABELAP0LBIELIXAQorWCHYG/RZsh9BLhESObBBELIiAQorWCHYG/RZsjouQRESObA6ELInAQorWCHYG/RZsjIuQRESObAuELI1AQorWCHYG/RZMDEBIwMHFBcWNwcGJyYmNzcTIzczNzYnJicmBh8CFgcjNiYnJgYHBgQXFgcOAicmJjczFBYXFjY3NicnJjc+AjMWFyY3NjYXFhYHBzMGXcRsAVIbOAxLOmFqAwJqtxm1DAUEDotlegwFFgcGtQJoWF2EDA4BJzzKCwZ5ynKr3Qa0cWVkkAwSkqD/CwV1xW1bWRMHD92UqbEUDcQDq/19NGQDAQuYEwIBkIckAoGPVisqjgMDiZI7q0A8UmUCAltLaU0bWbRkllADAsWbXWsCAldNcy0uVcBglFMBH3s/hqMCBNKqVwAAFv+r/nIIRgWuAA0AHAApADgAPgBEAEoAUABXAFsAXwBjAGcAawBvAHcAewB/AIMAhwCLAI8BDACwPi+wAEVYsEcvG7FHHD5Zsn9KAyuyfHsDK7J4gwMrsoA7AyuyCj5HERI5sAovsAPQsAMvsA7QsA4vsAoQsA/QsA8vslEODxESObBRL7JwBworWCHYG/RZshZRcBESObAKELIgBworWCHYG/RZsAMQsiYHCitYIdgb9FmwDxCwKtCwKi+wDhCwL9CwLy+yNQcKK1gh2Bv0WbA+ELI9CgorWCHYG/RZsD4QsGzQsGjQsGTQsD/QsD0QsG3QsGnQsGXQsEDQsEcQskgKCitYIdgb9FmwYNCwXNCwWNCwS9CwRxCwYdCwXdCwWdCwTNCwDhCyUgcKK1gh2Bv0WbAPELJ3BworWCHYG/RZMDEBBgYnJiY3NzY2FxYWBxMTFxYWBwYGBxYVBgcGBwE2JicmBgcHBhYWNjcBMwMGBiMiJicXBjc2NjcBEzMHMwchNzM3MwMBEyEHIwclNyEDIzcBBzM2NzYnATchByE3IQchNyEHEzchByE3IQchNyEHATc2NzYvAgEjNzM3IzczAyM3MyUjNzM3IzczAyM3MwMQCotfXnQECQiLYF10Agtgql5fAwI3J08BFjSF/rgFODo7VgwNBzl4VQsD0GE7CmtNUmYBWQRYLDkJ+WM3byS/FAT/FMAkbTf5tTIBLRS+HgXbFAEuMm0e++geb28ODVIBShUBDxX9bhUBDhX9bxUBDRXNFAEPFP1uFAEOFP1vFAENFAFYV3sNCkUhXvzOby1vFW8sb69vLW8HAG0sbRVtLW2vbSxtAdRlegICemFuZXsCAnpg/rgCJQEDSkIwORUdWDAhTgQBS0NOAgJOSHI/UgRRRQFP/oVPW1JVAl8CATgp/MoBO8pxccr+xQYfAR10qal0/uOp/LapBVRIBwNLdHR0dHR0+ThxcXFxcXEDwgEGUTcHAwH+0vx++vwV+X78fvr8FfkABQBc/dUH1whzAAMAHAAgACQAKAA0ALAlL7AhL7IcHgMrsCUQsADQsAAvsCEQsALQsAIvsg0AHBESObANL7IfAh4REjmwHy8wMQkDBTQ2NzY2NTQmIyIGBzM2NjMyFhUUBwYGFRcjFTMDMxUjAzMVIwQYA7/8QfxEBA8eJEpcp5WQoALLAjorOThdWy/KyspLBAQCBAQGUvwx/DEDz/E6Ohgnh0qAl4t/MzRANF88QVxMW6r9TAQKngQAAQBiAAAESgWwAAYAObIBBwgREjkAsABFWLAFLxuxBRw+WbAARViwAi8bsQIQPlmwBRCyAwEKK1gh2Bv0WbIAAwUREjkwMQEBIwEhNyEENvzrvwMS/T4bA30FPfrDBRiYAAACAEH/6AQoBFIAEgAhAEOyCCIjERI5sAgQsBfQALAARViwAC8bsQAYPlmwAEVYsAkvG7EJED5ZshYBCitYIdgb9FmwABCyHgEKK1gh2Bv0WTAxAR4CBwcOAicmJicmNzc2EjYDFhYXFjY3NicmJicmBgYCgIrDWw8DFZ31j6LXGgwJAxWg8PcDe3CM0h0FAQN8cW2yYQROBI/6lxag/40EBMuuUFEWowEFiv1fh6QEBeLKKy6IqQQEjPsAAAH/D/5FAQ8AmAAMACcAsA0vsABFWLAELxuxBBI+WbIJAQorWCHYG/RZsA0QsAzQsAwvMDElAwYGJyYnNxYXMjc3AQ8nG7yPND8bLjGFJCmY/vugrgICEZ8OArP8AAAB/73+mQDMAJkAAwASALAEL7AC0LACL7AA0LAALzAxEyMTM3O2Wbb+mQIAAAIBEwTXA3MGzwALAB4AXACwAy+yCQQKK1gh2Bv0WbAH0LAHL7AL0LALL7AHELAP0LAPL7AS0LASL7I/EgFdsA8QsBTQsBQvsBIQshgECitYIdgb9FmwDxCyHAQKK1gh2Bv0WbAYELAe0DAxAQYGJyYmNRcGFzI3EwYGIyImBwYHJzY2MzIWFjc2NwNMCaR/e5KQBH2DHLgJXkYpgidFHlIMYUMkeCQTQyIFr2ZyAgJ1YAJ1AnYBDVBnTwEDVRRTZUYKAQNWAAIBEgTeA0UHAwALABoAQwCwAy+yCQQKK1gh2Bv0WbAL0LALL7AH0LAHL7ALELAa0LAaL7AU0LAUL7IZGhQREjmyDRQZERI5sRMKK1jYG9xZMDEBBgYnJiY1FwYXMjcnNzc2NzYmIzcXFgcGBwcDRQuhfHqRjAaAhBu/Ei9hBwRAUgwX9AQDmwoFsWZtAgJwYAJyAnMSfAMIMxobUwEMfWIYPwAAAgERBN8DXAaKAA4AEgA3ALAEL7ILBAorWCHYG/RZsA7QsA4vsAnQsAkvsA4QsBHQsBEvsA/QsA8vsBEQsBLQGbASLxgwMQEGBgcjJiYnNRcGFxY2NycXBwcDXAqdfw+BkwKSBIM9WQ45osJxBbBibQIDb2ABAnMCATk82wHEAQACAM0E5AOWBtMABgAYAI0AsAEvsAbQsAYvQAkPBh8GLwY/BgRdsgABBhESORmwAC8YsAYQsALQsAEQsAPQsAMvsAAQsATQGbAELxiwBhCwCtCwCi9ACx8KLwo/Ck8KXwoFXbAN0LANL7Q/DU8NAl2wChCwD9CwDy+wDRCyEwYKK1gh2Bv0WbAKELIWBgorWCHYG/RZsBMQsBjQMDEBIycHIyUzNwYGIyImBwYHJzY2MzIWNzY3A5aTpdq3AU+A6wtdPSlxJz4iTwtdQCZ2JkAiBOSdnfTmRllKAQRGE0VdSQECRgACAM4E5AR5Bs8ABgAVAF0AsAEvsADQGbAALxiwARCwBtCwBi+2DwYfBi8GA12wAtCwARCwA9CwAy+wABCwBNAZsAQvGLABELAH0LAHL7AO0LAOL7IIBw4REjmxDQorWNgb3FmyFA4HERI5MDEBIycHBwEzFzc3NjYnJzcWFgcGBgcHA5aUoN62ATa3qBMrVg5hHwt3cgMDREoKBOS5uAEBBnyDBQtqBQJdB1BDNkUQPQAAAgAiBM8DkwaCAAYACgBOALABL7AA0BmwAC8YsAEQsAPQsAMvsAXQsAUvtg8FHwUvBQNdsALQsAAQsATQGbAELxiwARCwCNCwCC+wB9AZsAcvGLAIELAK0LAKLzAxASMnByMBMwUjAzMDk6+KwNABR5T+j3yWtgTPnZ0BBlUBAgACANIE4QT7BpUABgAKAFQAsAMvsAHQsAEvtg8BHwEvAQNdsAMQsALQGbACLxiwARCwBNCwAxCwBdCwBS+wAhCwBtAZsAYvGLADELAJ0LAJL7AH0LAHL7AJELAK0BmwCi8YMDEBMxMjJwcjATMDIwIbleuviMDSA1nQ8ZYF6P75np4BtP79AAIBEQTfA1wGigAOABIANwCwBC+yCwQKK1gh2Bv0WbAO0LAOL7AJ0LAJL7AOELAS0LASL7AQ0LAQL7ASELAR0BmwES8YMDEBBgYHIyYmJzUXBhcWNjclMxcjA1wKnX8PgZMCkgSDPVkO/uGJS1YFsGJtAgNvYAECcwIBOTzbxgAAAQD8BI4CJwY9AAcADACwBS+wANCwAC8wMQEXBgcHIzc2AcBnSxQYtBEdBj1XbmaEcsEAAAL/pQAAA+MEjQAHAAoAU7IECwwREjmwBBCwCtAAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmwAEVYsAcvG7EHED5ZsggCBBESObAIL7IAAQorWCHYG/RZsgoCBBESOTAxASEDIwEzASMBIQMC+f4JnMECm6IBAbD+IwGEaAEX/ukEjftzAa4B+wAAAwAdAAAD5wSNAA0AFgAeAHuyGB8gERI5sBgQsA3QsBgQsBbQALAARViwAS8bsQEaPlmwAEVYsAAvG7EAED5ZshcAARESObAXL7K/FwFdtB8XLxcCXbTfF+8XAl2yDgEKK1gh2Bv0WbIHDhcREjmwABCyDwEKK1gh2Bv0WbABELIeAQorWCHYG/RZMDEzEwUWFgcGBxYWBwYGBwMDFzI2NzYmJycXMjY3NicnHcsBfr/CCgrST1YECO3Av0L0bpUMC1dk+dlvjgoU1+EEjQEFpIyqUxqOXZ21AwIS/oUBZlpUYgWOAV1ToAUBAAABAEf/7AQ3BKMAHABOshMdHhESOQCwAEVYsAsvG7ELGj5ZsABFWLADLxuxAxA+WbIACwMREjmyDgMLERI5sAsQshIBCitYIdgb9FmwAxCyGgEKK1gh2Bv0WTAxAQYEJy4CNzcSABcWFhcjJiYnJgYHBhcWFhcWNwPmI/7tyIrBVhEMJQE54LjVCLMFbXiTyh8bBgV2bPtMAXq70wQEjPuYWAEIATAGBNW2coIEBcq2nmN1iwQK/AAAAgAdAAAEDwSNAAoAFQBDshUWFxESObAVELAC0ACwAEVYsAIvG7ECGj5ZsABFWLAALxuxABA+WbINAQorWCHYG/RZsAIQshUBCitYIdgb9FkwMTMTBR4CBwcCACETAxcyNjc3NicmJx3LAVKW2mUQBRz+ov76CJaUvPMZBhI4RawEjQEEjfiaMP78/ssD9PyjAdvHMaJmfAYAAAEAHQAAA+8EjQALAGGyCQwNERI5ALAARViwBi8bsQYaPlmwAEVYsAQvG7EEED5ZsgsGBBESObALL7QfCy8LAl2yvwsBXbIAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASEDIQchEyEHIQMhAzH9/UICWRv888sDBxv9rjoCBAIO/omXBI2Z/rIAAQAdAAAD4gSNAAkAR7IHCgsREjkAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmyCAIEERI5sAgvsgEBCitYIdgb9FmwBBCyBwEKK1gh2Bv0WTAxASEDIxMhByEDIQMh/ghXtcsC+hv9uz8B+QHz/g0EjZn+mAAAAQBM/+4EQQSjAB8AXLIeICEREjkAsABFWLALLxuxCxo+WbAARViwAy8bsQMQPlmyDgsDERI5sAsQshEBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WbIfCwMREjmwHy+yHAEKK1gh2Bv0WTAxJQYGJy4CNzcSABcWFhcnJicmBgcGFxYWFxY3NyE3IQPWP/Cekc9dEQchATvos9YQsRTalMwgHAsMhW+lai3+7hoBw5ZRVwMCkPydOwEWATYGBMCvAdMIBci4n196iAMFTu6QAAABAB0AAASaBI0ACwBosgEMDRESOQCwAEVYsAovG7EKGj5ZsABFWLAHLxuxBxo+WbAARViwBC8bsQQQPlmwAEVYsAEvG7EBED5ZsggEBxESOXywCC8YtGAIcAgCcbKgCAFdtGAIcAgCXbIDAQorWCHYG/RZMDEhIxMhAyMTMwMhEzMDz7RW/bhXtcu0WQJIWrUB8v4OBI39/QIDAAABACoAAAGqBI0AAwAksgIEBRESOQCwAEVYsAIvG7ECGj5ZsABFWLAALxuxABA+WTAxMyMTM+C2yrYEjQAB//b/6wObBI0ADgAvsgwPEBESOQCwAEVYsAAvG7EAGj5ZsABFWLAFLxuxBRA+WbILAQorWCHYG/RZMDEBMwMGBicmJjcXBhcWNjcC5LeMFuyorcIItQzIW34RBI38xaPEBAS5oAHBBAJvZAABAB0AAAR/BI0ADABMsgoNDhESOQCwAEVYsAQvG7EEGj5ZsABFWLAILxuxCBo+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgAEAhESObIGBAIREjkwMQEHAyMTMwM3ATMBASMBwrBAtcu0X5IBw+39zAF8zAIGlf6PBI394IkBl/3w/YMAAQAdAAADIwSNAAUAL7IFBgcREjkAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmyAQEKK1gh2Bv0WTAxNyEHIRMz7AI3G/0Vy7SXlwSNAAABAB0AAAWwBI0ADgBgsggPEBESOQCwAEVYsAAvG7EAGj5ZsABFWLACLxuxAho+WbAARViwBC8bsQQQPlmwAEVYsAgvG7EIED5ZsABFWLAMLxuxDBA+WbIBAAQREjmyBwAEERI5sgoABBESOTAxARMBMwMjExMBIwsCIxMBzd0CF+/KtEdq/eWF4kxEtMsEjfxzA437cwGbAfv8agOs/dv+eQSNAAEAHQAABJoEjQAJAEyyAQoLERI5ALAARViwBS8bsQUaPlmwAEVYsAgvG7EIGj5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmyAgUAERI5sgcFABESOTAxISMBAyMTMwETMwPPrf5KmrXLrQG3mrQDdPyMBI38iwN1AAACAEr/6gROBKMADwAfAEayHCAhERI5sBwQsAjQALAARViwCC8bsQgaPlmwAEVYsAAvG7EAED5ZsAgQshMBCitYIdgb9FmwABCyGwEKK1gh2Bv0WTAxBSYmAjc3EgAXHgIHBwIAEyYmJyYGBwYXFhYXFjY3NgH2j8VYEQUgAT/lj8RXEAQc/sKuCX1tldEdFQgKfmyUzh8VEASRAQOcKwENAUcGBI7+nyn+8P61AxN4iQQF17aFX3yNBAXRvIMAAgAdAAAEKQSNAAoAEwBNsgoUFRESObAKELAM0ACwAEVYsAMvG7EDGj5ZsABFWLABLxuxARA+WbIMAwEREjmwDC+yCgEKK1gh2Bv0WbADELITAQorWCHYG/RZMDEBAyMTBRYWBwYEIyUFMjY3NiYnJQEeTLXLAbmz1QsM/vrR/v0BB32fDgtvZ/7kAbb+SgSNAQTCoKzFmQFyZV9sBAEAAAIARf83BEsEowATACMAOQCwAEVYsA0vG7ENGj5ZsABFWLAFLxuxBRA+WbANELIXAQorWCHYG/RZsAUQsh8BCitYIdgb9FkwMSUXBycGIyYCPwISABcWFhIHBwIDJiYnJgYHBhcWFhcWNjc2Awy2gttCN8fgDAMGHwFA5JDGWBIGKoAJfm6Vzx0VCAl8bZXOHxZBpGbFCwMBHegnNQEIAUYGBJH+/Z4y/qcCHXqLBAXYtoRfeo8EBdC9hQAAAgAdAAAEAQSNAA0AFgBNALAARViwBC8bsQQaPlmwAEVYsAIvG7ECED5Zsg4CBBESObAOL7IBAQorWCHYG/RZsgoBBBESObACELAN0LAEELIWAQorWCHYG/RZMDEBIQMjEwUWFgcGBRMVIwEXMjY3NiYnJwIz/u1OtcsBkb3LDBL++cbA/ljkd6AMC2hu9AHB/j8EjQEFuJ3oYf4jDAJYAXRgW2gFAQAAAQAR/+sD7QSdACcAVACwAEVYsAovG7EKGj5ZsABFWLAeLxuxHhA+WbIDHgoREjmwChCyEgEKK1gh2Bv0WbAO0LADELIXAQorWCHYG/RZsB4QsiUBCitYIdgb9FmwItAwMQE2LwIkNzY2NzcWFgcnNicmJyIGBwYXFxYWBwYEJyYmNxcGFhcyNgLZEqR9Pv7/DQjnsymz1wW0BSk3f3GSDBG6QrulCAr+98G67wW1B4B8eJYBMXs2JxdmzoyyCgEExJ0BUTRFA15ScTkUN7J7mLEFAselAWVxAlwAAAEAbQAABEIEjQAHAC4AsABFWLAGLxuxBho+WbAARViwAy8bsQMQPlmwBhCyBQEKK1gh2Bv0WbAB0DAxASEDIxMhNyEEJv5+sLWw/n4cA7kD9PwMA/SZAAABAEX/6gRXBI0AEQAuALAARViwCS8bsQkaPlmwAEVYsAQvG7EEED5Zsg0BCitYIdgb9FmwCRCwEdAwMQEDBgQnJiY3EzMDBhYXFjY3EwRXgxn+6si/2RODs4QNdXR6qRWEBI389breBATcswMM/PN1gQMEgnsDDQABAHoAAASZBI4ACAA4sgUJChESOQCwAEVYsAgvG7EIGj5ZsABFWLADLxuxAxo+WbAARViwBS8bsQUQPlmyAQgFERI5MDEBFzcBMwEjAzcB0gcsAcvJ/Xqp8LUBJFthA2P7cwSNAQABAJUAAAYpBI4AEgBZALAARViwAy8bsQMaPlmwAEVYsBIvG7ESGj5ZsABFWLAILxuxCBo+WbAARViwDy8bsQ8QPlmwAEVYsAsvG7ELED5ZsgEPEhESObIGCwgREjmyDRILERI5MDEBBzcBMxMXNwEzASMDNQcBIwM3AWsGGwGLoVEBHwFTuf4VqloE/l6qVacBJlJCA3f8hj1cA1v7cwOVCgv8bASNAQAB/7YAAARtBI0ACwBMsgAMDRESOQCwAEVYsAEvG7EBGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQQPlmwAEVYsAcvG7EHED5ZsgABBBESObIGAQQREjkwMQEBMwEBIwMBIwEBMwIoAWHk/hQBIsnV/pTjAfj+6MgC2wGy/bT9vwG6/kYCVQI4AAABAHQAAARlBI0ACAA4sgAJChESOQCwAEVYsAEvG7EBGj5ZsABFWLAHLxuxBxo+WbAARViwBC8bsQQQPlmyAAEEERI5MDEBATMBAyMTATMB/AGT1v3URbVL/urAAksCQv0A/nMBrQLgAAH/3AAABA4EjQAJAEuyBQoLERI5ALAARViwBy8bsQcaPlmwAEVYsAIvG7ECED5ZsgEBCitYIdgb9FmyBAIBERI5sAcQsgYBCitYIdgb9FmyCQYHERI5MDE3IQchNwEhNyEH4AKWG/yBGAMV/YsbA18Xl5eFA2+ZggAAAgAd//ACgQMlAA0AGQBGshAaGxESObAQELAH0ACwAEVYsAcvG7EHFj5ZsABFWLAALxuxABA+WbAHELIQAgorWCHYG/RZsAAQshYCCitYIdgb9FkwMQUmJjc3NjYXFhYHBwYGEyYnJg8CFhcWNzcBIIKBDA0TrYmBgQwOE6s0BGOFHRQBBGWEHRMMBLSZeq64BAS1mYGqtAIxfAMDxLM3fwMGybYAAAEAawAAAfwDFQAGADIAsABFWLAFLxuxBRY+WbAARViwAS8bsQEQPlmyBAEFERI5sAQvsgMCCitYIdgb9FkwMSEjEwc3JTMBeZpo3BgBZBUCVTiHcQAAAf/pAAACcwMkABcARwCwAEVYsA8vG7EPFj5ZsABFWLABLxuxARA+WbIWAgorWCHYG/RZsALQsgMPFhESObAPELIIAgorWCHYG/RZshUWDxESOTAxISE3ATY3NiYnJgYHBzY2FxYWBwYPAiECL/26FAFjYwwHNTBCUA6aC66AeIsFCJdAxAF7dAEqVEowNgEBSz4BdZUCAn5me30zkQAB//v/8wJ4AyIAJABsALAARViwDS8bsQ0WPlmwAEVYsBcvG7EXED5ZsgAXDRESOXywAC8YtoAAkACgAANdtqAAsADAAANxsA0QsgcCCitYIdgb9FmwABCyJAIKK1gh2Bv0WbISJAAREjmwFxCyHgIKK1gh2Bv0WTAxExc2Njc2JiMiByM2NjMWFgcGBxYHBgYnJiY1MxQWMzI2NzYnJ+ROQl0HBj4ycB2cC599fo4FB5h2BAW1hXeVl0I6QFsHDY1XAcsBAj02MTFdZXkDdmF3QiuBb4ECAnxsMjdANWYFAQAAAv/wAAACcwMVAAoADgBFALAARViwCS8bsQkWPlmwAEVYsAUvG7EFED5ZsgwFCRESObAML7AA0LIDAgorWCHYG/RZsAbQsAwQsAjQsg0JBRESOTAxATMHIwcjNyE3ATMBMxMHAgtoF2cemh7+lQ0Bv6T+QdA6FgErgqmpcAH8/hYBIx4AAQAW//MCjwMVABsAYACwAEVYsAEvG7EBFj5ZsABFWLANLxuxDRA+WbABELIEAgorWCHYG/RZsgcNARESObAHL7AF0LANELAR0LANELITAgorWCHYG/RZsAcQshkCCitYIdgb9FmwBxCwG9AwMRMTIQchBzYzMhYHBgYnJiYnFxY3MjY3NiYnIgdGdgHTGP6wO0BCbYEEBq6DdZEFlAlvQVYIBkE8Qz8BhgGPhKschXN8mwICgGMBZQJSRDxGASoAAgAe//ICaAMgABIAHQBVALAARViwAC8bsQAWPlmwAEVYsAwvG7EMED5ZsAAQsgECCitYIdgb9FmyBgwAERI5sAYvsgQGDBESObITAgorWCHYG/RZsAwQshgCCitYIdgb9FkwMQEHIyYHNhcyFgcGBiYmNzc2JDMDJgcHBhYyNjc2JgI8DQv+VlJmanYGBrD8kgsFFgEJ1MddPQQHOn5XBgc8Ax+DA+FOApNsep8ErIw4zO7+bgJRIkdgVz05SgAAAQAvAAACswMVAAYAMgCwAEVYsAUvG7EFFj5ZsABFWLACLxuxAhA+WbAFELIEAgorWCHYG/RZsgAEBRESOTAxAQEjASE3IQKh/jutAcX+ThcCWgKx/U8Ck4IAAwAL//QCeAMjABQAIAAsAH4AsABFWLASLxuxEhY+WbAARViwCC8bsQgQPlmyKggSERI5fLAqLxi0UCpgKgJxtqAqsCrAKgNxtoAqkCqgKgNdtCAqMCoCcrIYAgorWCHYG/RZsgIqGBESObINGCoREjmwCBCyHgIKK1gh2Bv0WbASELIkAgorWCHYG/RZMDEBBgcWBwYGByMmJjc2NyY3NjYXFhYDNiYjIgYHBhYzMjYTNiYjIgYHBhYzMjYCcweIbAQDo30QfpAFB5xbBASjeHSJxAVCNj5VBwZCNj5WLwU2MDZJBgY4LjJOAktxSTt2aYADA3digkk3aWt9AgJ3/kIxN0A0MjdBAYoqNTwvKzU9AAIANv/3AncDIgATACEAUQCwAEVYsAgvG7EIFj5ZsABFWLAPLxuxDxA+WbICDwgREjmwAi+wDxCyEQIKK1gh2Bv0WbACELIUAgorWCHYG/RZsAgQshwCCitYIdgb9FkwMQEGIyImNzY2FxYWBwcGBCMnNzI2JxY3NzYnJiYjIgYHBhYBwk1aa3oGBq+Cf4ULBBb+/9QUDYebWFE9CAMDBTctPVUHBjsBQECOcXuoAgKxkDPS4QF/XqIESz4dHS84XEI8TAABAJMCiwMYAyIAAwARALACL7IBAQorWCHYG/RZMDEBITchAv39lhsCagKLlwAAAwELBD8DGwZxAAMADwAZAD4AsABFWLANLxuxDRg+WbAH0LAHL7AC0LACL7AA0LAAL7ANELISBworWCHYG/RZsAcQshgHCitYIdgb9FkwMQEzByMHNDYzMhYVFAYjIiY3FjMyNjc2JiMiAlPI9n+bZUdDWWFGRVxSBT4hOgcEIiJEBnG23kZoXURFZltEUDMnHzQAAAP/mv5HBEkEUgAqADgARgCPALAARViwJy8bsScYPlmwAEVYsBYvG7EWEj5ZsCcQsCrQsCovsgADCitYIdgb9FmyCBYnERI5sAgvsg8IFhESObAPL7SQD6APAl2yOAEKK1gh2Bv0WbIcOA8REjmyIAgnERI5sBYQsjEBCitYIdgb9FmwCBCyPAEKK1gh2Bv0WbAnELJDAQorWCHYG/RZMDEBBxYHBwYHBiciJwYHBhcXFhYHBgYEJyYmNzY2NyY3NjcmNzc2NzYfAgUBJwYHBhYzMjY2NzYmJwMGFhcWNjc3NiYnJgYHBC+QIQkFHJ58l0lNQggJYLC6tQgGk/7qhsLiBwVxXyYGCouCCwERnoCjJmsBcfz1T4IRCYFyXK9lCQpTbt8GdVljnA8CB3BdYpwQA6cBXGEkrmNNAhc4OUYEAgaUg2OcYAMFjnlZizAvP3xebLAMvmdTAgITAfvyBz95SVIzWjk/RAMCnVZvAgJ4WxZWdQICdV4AAAIAS//kBIcEUgATACUAbrIiJicREjmwIhCwC9AAsABFWLALLxuxCxg+WbAARViwDy8bsQ8YPlmwAEVYsAIvG7ECED5ZsABFWLATLxuxExA+WbIAAgsREjmyDgsCERI5sAIQshkBCitYIdgb9FmwCxCyIgEKK1gh2Bv0WTAxJQInJiYnJjc2EjYXFhYXNzMDEyMBBhcWFhcWNzY3NzYnJicmBgcDMpf8mbEHAwgUjc9+fKogULDKEKj94gcDBWxgoG8xFwUGHTODjLQa8v7yBwTUtTlWpwEbiQMEinXu/db98AHtPD9vgAMD0F1iI25krwYF7cwAAAIAQwAABOUFrwAcACUAYbIeJicREjmwHhCwHNAAsABFWLADLxuxAxw+WbAARViwAS8bsQEQPlmwAEVYsBMvG7ETED5Zsh0BAxESObAdL7IAAQorWCHYG/RZsgkAHRESObADELIlAQorWCHYG/RZMDEBAyMTBTIWBwYFFhcWBwcGFxYXByMmJyY3NzYmJyUFMjY3NiYnJQFtbb39Ad3e6hEV/vWQEAQGFgcDBCEDuSAFAwkUDWlo/rYBJaK5EA16f/61AnT9jAWvAde/5HBAqzM1lTcoOioZLUYuRYp0iQaeAYiCdH4EAQABAEQAAAVqBbAADABksgoNDhESOQCwAEVYsAQvG7EEHD5ZsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgYCBBESObAGL7LPBgFdsi8GAV2yAQEKK1gh2Bv0WbIKAQYREjkwMQEjAyMTMwMzATMBASMCI7JxvP27b4kCXff9YQG81gKO/XIFsP1+AoL9Nf0bAAEAJQAABB4GAAAMAFCyBQ0OERI5ALAEL7AARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIGAggREjmwBi+yAQEKK1gh2Bv0WbIKAQYREjkwMQEjAyMBMwMzATMBASMBtIJXtgELtZlyAXzk/jIBN8gB9f4LBgD8jgGs/gr9vAAAAQBEAAAFSgWwAAsATLIJDA0REjkAsABFWLADLxuxAxw+WbAARViwBy8bsQccPlmwAEVYsAEvG7EBED5ZsABFWLAKLxuxChA+WbIAAwEREjmyBQMBERI5MDEBAyMTMwMzATMBASMBeXm8/bt2CQLB+vz6AiHXArz9RAWw/XgCiP0y/R4AAQAlAAAEBgYYAAwAU7IFDQ4REjkAsABFWLAELxuxBB4+WbAARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIABAIREjmyBgQCERI5sgoHABESOTAxASMDIwEzAxcBMwEBIwE8Blu2AQ+2pwIByPn92QGFzAHz/g0GGPxzAQGw/gT9wgAAAQAS/xMD7wVzACwAbbIgLS4REjkAsABFWLAJLxuxCRo+WbAARViwIy8bsSMQPlmyBCMJERI5sAkQsAzQsAkQsBDQsAwQshQBCitYIdgb9FmwBBCyGQEKK1gh2Bv0WbAjELAg0LAjELAn0LAgELIqAQorWCHYG/RZMDEBNi8CJDc2Njc3MwcWFgcnNicmJyIGBwYWFhcWBwYGBwcjNyYmNxcGFhcyNgLaEqR9Pv7/DQneryyRK5GdBrQFKTd/cZIMB1rvSMUMCNO3LJItorgGtAV+fHiWATF7NicXZs6JrBHZ3Ry/gwFRNEUDXlI8VUYmaL2EqhLh4xjBjwFmcAJcAAEABgAAA9gEogAeAGqyGh8gERI5ALAARViwEy8bsRMaPlmwAEVYsAYvG7EGED5Zsh4GExESObAeL7IABAorWCHYG/RZsAYQsgUBCitYIdgb9FmwCNCwABCwDNCwHhCwD9CwExCwF9CwExCyGQEKK1gh2Bv0WTAxASUGBwclByE3FzY3Nwc3Mzc2NhcWFgcnNicmBgcHIQL0/oIjMiEChBv8nRYJZiMUphacCxfqraeqCrYQrWB9EA0BiQH0Ac5cNQKYlgEpxXIBeWrb8AUE0q4B4gcDmY5yAAEANAAABG4EjQAXAJSyABgZERI5ALAARViwAS8bsQEaPlmwAEVYsBcvG7EXGj5ZsABFWLANLxuxDRA+WbIADRcREjmyEBcNERI5sBAvsg8QAV2wFNCwFC+0DxQfFAJxQA8PFB8ULxQ/FE8UXxRvFAddsATQsAQvsBQQshMECitYIdgb9FmwBdCwEBCwCdCwEBCyDwQKK1gh2Bv0WbAK0DAxAQEzATMHJQcHJQchByM3ITchNyE3MwMzAgUBk9b+OO8W/tELEQE/Fv7HJ7Un/sUVAToO/sUV/uy/AkwCQf2MeQIMQwJ43d14S3kCdAABAB0AAAPNBI0ABQAysgEGBxESOQCwAEVYsAQvG7EEGj5ZsABFWLACLxuxAhA+WbAEELIBAQorWCHYG/RZMDEBIQMjEyEDsv3QsLXLAuUD9PwMBI0AAAL/sAAAA84EjQADAAgAPLICCQoREjmwAhCwBtAAsABFWLACLxuxAho+WbAARViwAC8bsQAQPlmyBQIAERI5sggBCitYIdgb9FkwMSEhATMDJwcBIQPO++IChqZyCib+fQI0BI3+z2xX/ScAAAMASv/qBFgEpAADABIAIgBnshcjJBESObAXELAC0LAXELAE0ACwAEVYsAsvG7ELGj5ZsABFWLAELxuxBBA+WbAC0LACL7LfAgFdsh8CAV2yAQEKK1gh2Bv0WbALELIWAQorWCHYG/RZsAQQsh4BCitYIdgb9FkwMQEhNyEBJgI3NxIAFxYWEgcHAgATJiYnJgYHBhcWFhcWNjc2Azv+LBsB1P6q1uAbBSABQOSPxFcQBiH+xLMJfG6W0B0VCAh/bZTOHxUB+Zn9XgUBO/QsAQwBSAYEjv8AnzT+7/7CAxR4iAQF2bSEYHmQBAXRvIQAAAH/sAAAA84EjQAIADiyAgkKERI5ALAARViwAi8bsQIaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbIHAgAREjkwMTMjATMTIwMnB2S0Aoam8sedCioEjftzA1xsYAAAA//TAAADlQSNAAMABwALAGSyAAwNERI5sATQsAAQsArQALAARViwCi8bsQoaPlmwAEVYsAAvG7EAED5ZsgMBCitYIdgb9FmwABCwB9CwBy+yHwcBXbLfBwFdsgQBCitYIdgb9FmwChCyCQEKK1gh2Bv0WTAxISE3IREhNyETITchAsr9CRsC9/2KGwJ2ev0JGwL3mAF7mAFJmQAAAQAdAAAEhgSNAAcAP7IBCAkREjkAsABFWLAGLxuxBho+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAYQsgMBCitYIdgb9FkwMSEjEyEDIxMhA7y2sP3MsLXLA54D9PwMBI0AAf/VAAAD3gSNAAwAQ7IGDQ4REjkAsABFWLAILxuxCBo+WbAARViwAy8bsQMQPlmyAgEKK1gh2Bv0WbAF0LAIELILAQorWCHYG/RZsAfQMDEBASEHITcBAzchByETAln+fgKIG/yRGgGU/BgDPxz9m/4COv5fmZkBuAG1h5n+YAADAFEAAATzBI0AEgAYAB4Ab7IHHyAREjmwBxCwFtCwBxCwHNAAsABFWLARLxuxERo+WbAARViwCC8bsQgQPlmyEBEIERI5sBAvsADQsgkIERESObAJL7AG0LAJELIVAQorWCHYG/RZsAAQshsBCitYIdgb9FmwFtCwFRCwHNAwMQEWFgcGAAcHIzcmJjc+Ajc3MwECBRMGBgUSJQM2NgNJyeEPEv7L6xi1GMvhEQyT+JwZtf2yHwEYdKK6Awof/up1oLsEFBP1wND+/w1ucBH9vIrReQl2/a3+7h8CdQ2nfQEPH/2MDagAAQB+AAAE9QSNABoAXLIZGxwREjkAsABFWLADLxuxAxo+WbAARViwES8bsREaPlmwAEVYsBkvG7EZGj5ZsABFWLAJLxuxCRA+WbIYAwkREjmwGC+wANCwGBCyCwEKK1gh2Bv0WbAI0DAxASQTEzMDBgAHAyMTJiYnJjcTMwMGFxYWFxMzArIBHzs0tTUk/ubgOLY4l7YUDQ00tjQJAgJkXYK2Abk6AWIBOP7I9/7bGP7fASEWwJpfZQE4/sdAQXKRFwLUAAEADAAABGoEoQAiAFmyACMkERI5ALAARViwGC8bsRgaPlmwAEVYsA8vG7EPED5ZsABFWLAhLxuxIRA+WbIgAQorWCHYG/RZsADQsBgQsgYBCitYIdgb9FmwABCwDtCwIBCwEdAwMSUkEzc2JicmBgcGBxcWFwchNzcmJyYSJBcWEg8CAgc3ByECVQEfNAUThIyZ0xYMAQEOqhj+ShypYAEElAESp8jpBwMGKdSyG/5JnEMBjSSpxgMEza10OSniN52XAo7F1AE2qwQE/vjTLyz+zp0DlwABAGz/6wToBI0AGABosgcZGhESOQCwAEVYsAIvG7ECGj5ZsABFWLAOLxuxDhA+WbAARViwFy8bsRcQPlmwAhCyAQEKK1gh2Bv0WbAF0LIIAhcREjmwCC+wDhCyDwEKK1gh2Bv0WbAIELIUAQorWCHYG/RZMDEBITchByEDNhcWFgcGBgc3JDc2JicmBwMjAcX+pxsDbxv+nzqVlbnFDA7/6A8BFxkNXXJ+tma0A/SZmf7WNAQEzri8xwKXBeluggIDMv3NAAABAEf/7AQ3BKMAHwBqshMgIRESOQCwAEVYsAsvG7ELGj5ZsABFWLADLxuxAxA+WbALELAP0LALELISAQorWCHYG/RZsAMQsBbQsBYvst8WAV2yHxYBXbIXAQorWCHYG/RZsAMQsh0BCitYIdgb9FmwAxCwH9AwMQEGBCcuAjc3EgAXFhYXIyYmJyYGByEHIQYXFhYXFjcD5iP+7ciKwVYRDCUBOeC41QizBW14kMIuAbkb/lIIBgh5Z/tMAXq70wQEjPuYWAEIATAGBNW2coIEA7m9mEJBboAECPoAAv/EAAAGqASNABcAIAB2sgghIhESObAIELAZ0ACwAEVYsBUvG7EVGj5ZsABFWLAGLxuxBhA+WbAARViwDS8bsQ0QPlmwFRCyCQEKK1gh2Bv0WbANELIQAQorWCHYG/RZshcGFRESObAXL7IYAQorWCHYG/RZsAYQshoBCitYIdgb9FkwMQEWFgcGBCMhEyEDBgYHIzczMjY3NxMhAwcDBTI2NzYmJwUtrs0LDf7+yv42r/5tczbKnEMWImOBIRJtAvlNGkkBAnKeDQtkZgLWBL+dqswD9P3K6dQBpKS+awIc/kqY/lkBfGZXaQUAAAIAHQAABrUEjQASABsAhLIBHB0REjmwARCwFNAAsABFWLACLxuxAho+WbAARViwES8bsREaPlmwAEVYsAsvG7ELED5ZsABFWLAPLxuxDxA+WbIADxEREjl8sAAvGLIECwIREjmwBC+wABCyDgEKK1gh2Bv0WbAEELITAQorWCHYG/RZsAsQshUBCitYIdgb9FkwMQEhEzMDBRYWBwYEIyETIQMjEzMBAwUyNjc2JicBQwI1WrRMAQCuzQsL/v7L/jVX/ctXtcu0AoRKAQJynw0LYmgCigID/koBBL+dqM4B8v4OBI39sv5ZAXpoVmoFAAEAbQAABO0EjQAWAFeyBxcYERI5ALAARViwAi8bsQIaPlmwAEVYsAwvG7EMED5ZsABFWLAVLxuxFRA+WbACELIBAQorWCHYG/RZsAXQsggMAhESObAIL7ISAQorWCHYG/RZMDEBITchByEDNhcWFgcDIxM2JyYnJgcDIwHG/qccA28b/p86kZq8xBQ6tTkHBhaogbNmtQP0mZn+1jIDAti7/pwBZTgukQYDMv3NAAEAHf6bBIUEjQALAEKyAQwNERI5ALACL7AARViwBi8bsQYaPlmwAEVYsAovG7EKGj5ZsABFWLAALxuxABA+WbAE0LIIAQorWCHYG/RZMDEhIQMjEyETMwMhEzMDu/6NPrU+/orLtLACNbC0/psBZQSN/AsD9QACAB//+wPbBI0ADAAVAFuyExYXERI5sBMQsAPQALAARViwCy8bsQsaPlmwAEVYsAovG7EKED5ZsAsQsgEBCitYIdgb9FmyAgoLERI5sAIvshQBCitYIdgb9FmwChCyFQEKK1gh2Bv0WTAxASEDBRYWBwYEJyUTIQE2Njc2JiclAwPB/cAyARmtvhQW/uvB/kzKAvL+KXGUBAJyZ/7/SgP3/uABBL6erc4EAQSN/AoCeGdbZgUB/lkAAv+J/qwEmgSNAA4AFQBVshIWFxESObASELAE0ACwDC+wAEVYsAQvG7EEGj5ZsABFWLAKLxuxChA+WbIGAQorWCHYG/RZsAwQsAnQsAYQsA7QsBDQsAQQshEBCitYIdgb9FkwMTc2NjcTIQMzAyMTIQMjEwUlEyEDBwItbIYnYgLysItWtTz81Du2VwEjAjKV/nNMEEWWYvi3Aeb8C/4UAVT+rQHrAwMDXP6QQ/7tAAAB/68AAAYEBI0AFQCSsg0WFxESOQCwAEVYsAkvG7EJGj5ZsABFWLANLxuxDRo+WbAARViwES8bsREaPlmwAEVYsAIvG7ECED5ZsABFWLAGLxuxBhA+WbAARViwFC8bsRQQPlmyDAINERI5fLAMLxiyoAwBXbRgDHAMAl2yBAEKK1gh2Bv0WbAB0LIIBAwREjmwDBCwD9CyEwwEERI5MDEBJwMjEyMBIwEDMxMzEzMDMwEzAQEjA6BoV7ZYWv538QHq8M7LW1i2WU8BfOf+PAEQ1AH1Af4KAfb+CgJbAjL+AwH9/gMB/f3D/bAAAAEAEf/uA94EoAAoAIKyGikqERI5ALAARViwDy8bsQ8aPlmwAEVYsBsvG7EbED5ZsA8QsgcBCitYIdgb9FmyDA8bERI5sigPGxESObAoL7K/KAFdsi8oAV203yjvKAJdtK8ovygCcbInAQorWCHYG/RZshQnKBESObIfGw8REjmwGxCyIQEKK1gh2Bv0WTAxATI2NzYnJicmBwYHBzY2FxYWBwYHFhYHDgInJiY3MxQXFjY3NiUnNwIBf5IKBxkzlmtFQxG2EPu3vtcKCvJVYAUHfeKJtdMFstmBqQsY/vuEGwKfYVc2JU0EAi0sUQGWsAIDpo24YiGGXWudVAICtZqxBQNmW7wCAZgAAQAfAAAEoQSNAAkATLIDCgsREjkAsABFWLAALxuxABo+WbAARViwBy8bsQcaPlmwAEVYsAIvG7ECED5ZsABFWLAFLxuxBRA+WbIEAAIREjmyCQACERI5MDEBMwMjEwEjEzMDA/WsyrKc/QmryrKcBI37cwN//IEEjfyBAAEAHgAABFcEjQAMAGiyCg0OERI5ALAARViwBC8bsQQaPlmwAEVYsAgvG7EIGj5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyBgQCERI5fLAGLxiyoAYBXbRgBnAGAl2yAQEKK1gh2Bv0WbIKAQYREjkwMQEjAyMTMwMzATMBASMBl21Xtcu0WFgB0uj91wFw2gH2/goEjf4DAf39vP23AAH/xAAABHkEjQAQAE2yBBESERI5ALAARViwAC8bsQAaPlmwAEVYsAEvG7EBED5ZsABFWLAILxuxCBA+WbAAELIDAQorWCHYG/RZsAgQsgoBCitYIdgb9FkwMQEDIxMhAwYGByM3NzY2NzcTBHnLtK/+bXU2x5VLFilgfCASbwSN+3MD9P3P6NcEpAIHnrhuAhwAAQBY/+gEVASNABEAQ7IBEhMREjkAsABFWLACLxuxAho+WbAARViwEC8bsRAaPlmwAEVYsAgvG7EIED5ZsgECCBESObINAQorWCHYG/RZMDEBFwEzAQ4CIyInNxY3MjcDMwHeFAGJ2f3aPmN8UDU0EzodXlLryAInbQLT/GRwZTQJlQgBbwOfAAEAHf6sBIYEjQALAEKyCQwNERI5ALACL7AARViwBi8bsQYaPlmwAEVYsAovG7EKGj5ZsABFWLAELxuxBBA+WbIAAQorWCHYG/RZsAnQMDElMwMjEyETMwMhEzMD16hnojv8bMu0sAI1sLWY/hQBVASN/AsD9QABAFoAAAQuBI0AEgBIsg8TFBESOQCwAEVYsAgvG7EIGj5ZsABFWLARLxuxERo+WbAARViwAC8bsQAQPlmyDgAIERI5fLAOLxiyBAEKK1gh2Bv0WTAxISMTBicmJjcTMwMGFxYXFjcTMwNktVWPnbrEFDm1OgcHFqqCsGa0AcMxAgLWvgFj/pw4LpMDAzECMgABAB0AAAX9BI0ACwBMsgYMDRESOQCwAEVYsAIvG7ECGj5ZsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAAvG7EAED5ZsgkBCitYIdgb9FmwBdAwMSEhEzMDIRMzAyETMwUy+uvLtLABe7C2sAF7sLUEjfwLA/X8CwP1AAEAHf6sBf4EjQAPAFKyDBARERI5ALACL7AARViwBi8bsQYaPlmwAEVYsAovG7EKGj5ZsABFWLAOLxuxDho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAN0LAJ0DAxJTMDIxMhEzMDIRMzAyETMwVOqWejPPr0y7SwAXuwtrABe7C2mP4UAVQEjfwLA/X8CwP1AAACAFD/+wSbBI0ADAAVAFuyBhYXERI5sAYQsA3QALAARViwCi8bsQoaPlmwAEVYsAcvG7EHED5ZsAoQsgkBCitYIdgb9FmyDAcKERI5sAwvshQBCitYIdgb9FmwBxCyFQEKK1gh2Bv0WTAxARYWBwYEJyUTITchAxM2Njc2JiclAwMwrb4UFv7swf5KsP66GwH5TLVzkQQCcWj/AEoC1gS+nqvQBAED9Jn+Sv3AAnlmWmcFAf5Z//8AH//7BaEEjQAmAggAAAAHAcID9wAAAAIAH//7A9MEjQAKABMATbILFBUREjmwCxCwBtAAsABFWLAILxuxCBo+WbAARViwBy8bsQcQPlmyCgcIERI5sAovshIBCitYIdgb9FmwBxCyEwEKK1gh2Bv0WTAxARYWBwYEJyUTMwMTNjY3NiYnJQMCaK2+FBb+7ML+TMqyTLVxlAQEcmn+/0oC1gS+nqvQBAEEjf5K/cACeGdWawUB/lkAAAEAIP/qBBoEoQAfAHOyBCAhERI5ALAARViwFS8bsRUaPlmwAEVYsBwvG7EcED5ZsADQsBwQsgMBCitYIdgb9FmyCBwVERI5fLAILxi0YAhwCAJdsqAIAV20YAhwCAJxsgcBCitYIdgb9FmwFRCyDgEKK1gh2Bv0WbAVELAS0DAxExYWFxY2NyE3ITYnJiYnJgYHBzYkFxYSBwcCACcmJifTB3R7jLwt/kgbAawIBgx8aYCbIrUmAQ/F0+EbCiL+zN693AgBend6AwO6vphDQmx+BASEdgG81gQE/s7vT/74/skGBNOzAAACAB3/6gX3BKIAFQAmAIqyAScoERI5sAEQsCLQALAARViwCS8bsQkaPlmwAEVYsA4vG7EOGj5ZsABFWLAGLxuxBhA+WbAARViwAC8bsQAQPlmyCgYJERI5fLAKLxi0YApwCgJxsqAKAV20YApwCgJdsgUBCitYIdgb9FmwDhCyGwEKK1gh2Bv0WbAAELIjAQorWCHYG/RZMDEFLgI3BwMjEzMDMzYAFxYWEgcHAgATNicmJicmBgcGFxYWFxY2NwOfhshgEddZtcu0V8lAASzTj8RXEAYh/sWwBwQJfm6S0B8WCAl+bZbOHhACifWPAf4CBI3+CfkBEwQEjv8AnzP+7/7BAoFGR3qMBAXRtYRneo8EBdTAAAL/3wAABEAEjgANABUAYbIQFhcREjmwEBCwB9AAsABFWLAHLxuxBxo+WbAARViwAC8bsQAQPlmwAEVYsAkvG7EJED5ZshEHABESObARL7ILAQorWCHYG/RZsgELERESObAHELISAQorWCHYG/RZMDEjASYmNzY2MwUDIxMhARMGFwUTJyIGIQF9XFsGC/nJAcjKtVT+4P61thbjAQJC/naRAhEmlWSmuAH7cwHf/iEDKa8BAQF8AWsAAAH/+gAABCwEjQANAGWyCw4PERI5ALAARViwCC8bsQgaPlmwAEVYsAIvG7ECED5ZsgcCCBESOXywBy8YsqAHAV20YAdwBwJdtGAHcAcCcbIEAQorWCHYG/RZsAHQsAgQsgsBCitYIdgb9FmwBxCwDNAwMQEjAyMTIzczEyEHIQMzAmXbWbVZ2xvaWALlG/3QPdsB/f4DAf2XAfmZ/qAAAf+v/qwGBASNABkArbIUGhsREjkAsAMvsABFWLAQLxuxEBo+WbAARViwFC8bsRQaPlmwAEVYsBgvG7EYGj5ZsABFWLAFLxuxBRA+WbAARViwCS8bsQkQPlmwAEVYsA0vG7ENED5ZshYQBRESOXywFi8YsqAWAV20YBZwFgJdtGAWcBYCcbIIAQorWCHYG/RZsgAIFhESObAFELIBAQorWCHYG/RZsAgQsAvQsg8WCBESObAWELAS0DAxARMzAyMTIwMjAyMTIwEjAQMzEzMTMwMzATMEQMubVaQ8cNxlV7ZYWv538QHq8M7LW1i2WU8BfOcCUP5G/hYBVAH2/goB9v4KAlsCMv4DAf3+AwH9AAABAB7+rARXBI0AEACAsgAREhESOQCwAy+wAEVYsAsvG7ELGj5ZsABFWLAPLxuxDxo+WbAARViwBi8bsQYQPlmwAEVYsAkvG7EJED5Zsg0JCxESOXywDS8YtGANcA0CcbKgDQFdtGANcA0CXbIIAQorWCHYG/RZsgAIDRESObAGELIBAQorWCHYG/RZMDEBATMDIxMjASMDIxMzAzMBMwIuARGhVaU8Xv7TbVe1y7RYWAHS6AJJ/k3+FgFUAfb+CgSN/gMB/QABAB4AAAUNBI0AFAB4sgUVFhESOQCwAEVYsAYvG7EGGj5ZsABFWLATLxuxExo+WbAARViwCS8bsQkQPlmwAEVYsBEvG7ERED5ZsgAGCRESOXywAC8YsqAAAV20YABwAAJdtGAAcAACcbAE0LAAELIQAQorWCHYG/RZsggQABESObAM0DAxATc3MwczATMBASMBJwcjNyMDIxMzAT9TJ5EtNgHS6P3WAXDa/tRBKZElTFi1y68CjwHk5QH+/bz9twH2Ac/O/goEjQAAAQBpAAAFOgSNAA4AfbIHDxAREjkAsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIBgIREjl8sAgvGLKgCAFdtGAIcAgCXbRgCHAIAnGyAQEKK1gh2Bv0WbAGELIFAQorWCHYG/RZsgwBCBESOTAxASMDIxMhNyEDNwEzAQEjAnlsV7aw/rkbAfxZWQHR6f3WAXDaAfb+CgP1mP4DAQH8/bz9twAAAgBQ/+oFOASiACQAMQCishYyMxESObAWELAl0ACwAEVYsAsvG7ELGj5ZsABFWLAbLxuxGxo+WbAARViwBC8bsQQQPlmwAEVYsAAvG7EAED5ZsgIEGxESObACL7ALELIMAQorWCHYG/RZsAQQshQBCitYIdgb9FmwAhCyJwEKK1gh2Bv0WbIWFCcREjmwABCyJAEKK1gh2Bv0WbIiJCcREjmwGxCyLgEKK1gh2Bv0WTAxBSYnBicmAhM3EgA3BwYGAhcWFxYXMjcmExISFxYWFxYHAgcWFwEWFzYTNjc1JicmBgcE4MyblZf//h4DIAEa2xF1o0sOEXdCaTA/pB8a77iWoAMBDSnbSH/9/QeWxyYMAwqKe4QGFQQ3PAIEAVABEiABAwEnBJ4Bmf7RkKtKKQEJxAEuAQIBGwUEzKtBbv7atgwCAYDPY4cBFWk8LrUGBfLR//8AdAAABGUEjQAmAdIAAAAHAd4AEP7eAAH/tv6sBG0EjQAQAFqyABESERI5ALAHL7AARViwAS8bsQEaPlmwAEVYsA8vG7EPGj5ZsABFWLAMLxuxDBA+WbAARViwCi8bsQoQPlmyAAEHERI5sgQBCitYIdgb9FmyCwEHERI5MDEBATMBEzUXAyMTIwMBIwEBMwIoAWHk/hTVq1SlPGrV/pTjAfj+6MgC2wGy/bT+VQME/hcBVAG6/kYCVQI4AAABAGz+rAV/BI0ADwBWsgsQERESOQCwAi+wAEVYsAgvG7EIGj5ZsABFWLAOLxuxDho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAIELIHAQorWCHYG/RZsAvQsAAQsA3QMDElMwMjEyETITchByEDIRMzBM+pZ6I8/Gyv/qYbA28b/qCVAjOwtpj+FAFUA/SZmfykA/UAAAEAWgAABC0EjQAYAFGyBBkaERI5ALAARViwCy8bsQsaPlmwAEVYsBcvG7EXGj5ZsABFWLAALxuxABA+WbIRCwAREjl8sBEvGLIHAQorWCHYG/RZsATQsBEQsBTQMDEhIxMGBwcjNyYmNxMzAwYXFhc3Mwc2NxMzA2O1VWdnJ5InqKESOrU7BgMKjS+RLVlzZrQBwyIKx8US1a4BY/6cMCqHHPDuDSACMgAAAQAdAAAD7ASNABMARrIQFBUREjkAsABFWLAALxuxABo+WbAARViwCS8bsQkQPlmwAEVYsBIvG7ESED5ZsgQSABESObAEL7IPAQorWCHYG/RZMDETMwM2Fx4CBwMjEzYnJicmBwMj6LVVlpR9rVANOrU6BwYWqny3ZrUEjf49MgIDYLp5/pwBZTgukQYDM/3OAAACAC//8QVhBKEAHgAnAGmyDigpERI5sA4QsCDQALAARViwDy8bsQ8aPlmwAEVYsAAvG7EAED5ZsiMADxESObAjL7K/IwFdshQBCitYIdgb9FmwBdCwIxCwDNCwABCyGgEKK1gh2Bv0WbAPELIfAQorWCHYG/RZMDEFLgI3NyYmNxcGFhc2ABceAgcHIQYXFhYXFjcXBgMmBgcFNicmJgMfk+pqHAGQlguVCUhSOAE31ZPRWRMU/MsNDBOXd4idLX5djs8qAoURCxOGDwGM9Y8IC8mhAWNtEO0BFgQCiPCahlBCaXQBAkiTVQQRA8GpAWM9XmcAAgBB/+wEZAScABcAIQBeshMiIxESObATELAY0ACwAEVYsAAvG7EAGj5ZsABFWLAILxuxCBA+WbINCAAREjmwDS+wABCyEwEKK1gh2Bv0WbAIELIYAQorWCHYG/RZsA0Qsh0BCitYIdgb9FkwMQEeAgcHBgAnLgI3NwU2JyYmJyYHJzYTFjc2NyUGFxYWApKU2mQRECL+u96Vz1kTFAMyFAwUnHWEoyqKULJzQiD9exEMEYgEnAOJ85R19/7PBAOF8JqGBVlCZnUBAkmUVfvtBJdYfQFhP11pAAABABH/6APwBI0AGwBmsgscHRESOQCwAEVYsAIvG7ECGj5ZsABFWLAMLxuxDBA+WbACELIBAQorWCHYG/RZsATQshsMAhESObAbL7IZAQorWCHYG/RZsgUbGRESObIQDAIREjmwDBCyEwEKK1gh2Bv0WTAxASE3IQcBFhYHDgInJiY3MxQWFxY2NzYmJyc3AuD91BwDIBT+dJOwCAeG4Ia10gWycmaGpgwKcHOIHgP0mX7+nxS5h3OnWAMFtZxYYwICdGdYYwUBrgAAAwBK/+oEWASkAA4AFQAcAHOyFx0eERI5sBcQsADQsBcQsBDQALAARViwBy8bsQcaPlmwAEVYsAAvG7EAED5Zsg8BCitYIdgb9FmyGQAHERI5fLAZLxiyoBkBXbRgGXAZAl20YBlwGQJxshMBCitYIdgb9FmwBxCyFgEKK1gh2Bv0WTAxBSYCNzcSABcWFhIHBwIAJxY2NyEGFgEmBgchNiYCANbgGwUgAUDkj8RXEAUc/sLgjMgu/YgPgwEeisouAncRgBAFATv0LAEMAUgGBI7/AJ4v/vP+uJ8FvbmlxwN0Bb63pMcAAAH//wAAA9gEogAnAK+yJSgpERI5ALAARViwHi8bsR4aPlmwAEVYsAwvG7EMED5ZsgYMHhESObAGL7IPBgFdsAHQsAEvQAkfAS8BPwFPAQRdsgABAV2yAgQKK1gh2Bv0WbAGELIHBAorWCHYG/RZsAwQsgsBCitYIdgb9FmwDtCwBxCwE9CwBhCwFNCwAhCwGNCwARCwGdCwHhCwItCyDyIBXbI9IgFdskwiAV2wHhCyJAEKK1gh2Bv0WTAxASEHIQcHJQclBgclByE3FzY3Nwc3Fzc3IzczNzY2FxYWByc2JyYGBwGDAZEV/nkQBQGJFf5/Jy8ChBv8nRYJRCYRoRabBBCdFpMIH+aqp6oKthCtWXoYAqh5XBIBeQFvRQKYlgEdZzEBeQESXHk62uYFBNKuAeIHA4WEAAEAHv/wA98EoQAiAJWyAyMkERI5ALAARViwFi8bsRYaPlmwAEVYsAkvG7EJED5ZsiIJFhESObAiL7IMIgFdtBAiICICXbAO0LINBAorWCHYG/RZsAHQsAkQsgQBCitYIdgb9FmwIhCwHtCwHi9ACR8eLx4/Hk8eBF2yAB4BXbAT0LIQBAorWCHYG/RZsBYQshsBCitYIdgb9FmwEBCwINAwMQEFBhYXFjcXBicmJjcHNzM3IzczNiQXFhcHJiMmAyEHIQchAvb+dAR2cVB5DXBsutsKnhWSFJMVjj0BD8RciiRZb/laAZMW/nETAZABlgF+iwIDHZcdAgLiwQF5bXnT2QICH5UfBP7peW0AAAQAHQAAB6YEogADABEAHwApAKiyKCorERI5sCgQsAHQsCgQsA3QsCgQsBPQALAARViwJi8bsSYaPlmwAEVYsCgvG7EoGj5ZsABFWLAELxuxBBo+WbAARViwIC8bsSAQPlmwAEVYsCMvG7EjED5ZsAQQsAvQsAsvsALQsAIvtAACEAICXbIBAworWCHYG/RZsAsQshUDCitYIdgb9FmwBBCyHAMKK1gh2Bv0WbIiJiAREjmyJyAmERI5MDElITchAxYWBwcGBicmJjc3NjYDBhYXFjY3NzYmJyYGBwEjAQMjEzMBEzMG7v3jGQIekpCgDAcP0JeOoQoHD9NJB0tLUWwOCQdMSVFwC/4urf5KmrXLrQG3mrS9jgNTBL6OSZ7ABAS7kEmfwP5WWmYCAmldVVxkAgJtX/y5A3T8jASN/IsDdQAC/90AAARwBI0AFgAfAHYAsABFWLAMLxuxDBo+WbAARViwAy8bsQMQPlmyBgMMERI5sAYvsBXQsgEBCitYIdgb9FmwBNCwBhCwCtCwCi+0vgrOCgJdQAkOCh4KLgo+CgRdsggBCitYIdgb9FmwFNCwChCwF9CwDBCyHwEKK1gh2Bv0WTAxJSMHIzcjNzM3IzczEwUWFgcGBCMlBzMnBTY2NzYmJyUCSPogtiC7G7oQuxu6ZwG1rsoLC/77xv7pEPvRAQJznA0MaF/+6bS0tJhZmAJQAQTIn6rTAVnxAgJ9ZWFwBAEAAAIAH//mBBEGAAATACAAZLIFISIREjmwBRCwHdAAsAovsABFWLAOLxuxDhg+WbAARViwCC8bsQgQPlmwAEVYsAUvG7EFED5ZsgcOCBESObIMDggREjmwDhCyFwEKK1gh2Bv0WbAFELIcAQorWCHYG/RZMDEBBgYHBicmJwcjATMDNhceAhcWJyYmJyYHAxYXFjY3NgQJEFlDi8XHXiueAQu1bYK6Z55XBQK4CXNkqXVROqaKxhoJAhh50kybBQSTggYA/cKQBAFoxHU9QnWJAwSu/immBAXeuloAAQBD/+gD9gRUABwAS7IAHR4REjkAsABFWLAPLxuxDxg+WbAARViwCC8bsQgQPlmyAAEKK1gh2Bv0WbIEDwgREjmyEggPERI5sA8QshYBCitYIdgb9FkwMSUWNjc3DgInJgI3NxIAFxYWByM0JicmAgcHFBYB6mGdG6wQhsxrytUZAx4BLtimzQKqcV+byQsBdoICcmIBZalfAwQBLOobAQABNAYE2axrgwQG/vjiJJSXAAIAR//nBIUGAAASACAAYbIEISIREjmwBBCwHdAAsAcvsABFWLAELxuxBBg+WbAARViwCi8bsQoQPlmwAEVYsA0vG7ENED5ZsgYEChESObILBAoREjmyGAEKK1gh2Bv0WbAEELIdAQorWCHYG/RZMDETNhI2FxYXEzMBIzcGJyYmJyY3MwYXFBYXFjcTJicmBgdQE5bZgLRhabX+9ZsOhLybuwwEBrUFAXhronVWPJ2OxhsCH6ABDYYDBIACNfoAeJEEBOW7PzwpLImjAgSjAfSTBAXctgACACT+UAQ2BFQAGwAqAHyyCyssERI5sAsQsCbQALAARViwBC8bsQQYPlmwAEVYsAcvG7EHGD5ZsABFWLAMLxuxDBI+WbAARViwFi8bsRYQPlmyBgQWERI5sAwQshEBCitYIdgb9FmyFAQWERI5sBYQsiEBCitYIdgb9FmwBBCyJgEKK1gh2Bv0WTAxEzY3NhcWFzczAwYAJyYnNxYXBBM3BicmJicmNzMGFxYWFxY3EyYnJgcGB1AXYpXywV8rm6wj/ufWuJxBeJ4BBFETiLCbuwoEBrUHBQl0Y6J3VTqgvmo4DwIfwZTgBgSRgfwU8P7yBARmi1oEBgEyVYQEBOW6Pzw+Q3WJBASlAe6WBgO7ZHf//wCpAAADBAW3AAYAFbAAAAL/1/5gBBAEUgARAB4AZLIAHyAREjmwG9AAsABFWLAJLxuxCRg+WbAARViwBi8bsQYYPlmwAEVYsAMvG7EDEj5ZsABFWLAALxuxABA+WbIHCQMREjmwCRCyFQEKK1gh2Bv0WbAAELIaAQorWCHYG/RZMDEFJicDIwE3BzYXFhYXFgcHBgATJiYnJgcDFhcWNjc2Agy7ZGG1AQSaD4i+oLgJAwcJKv7zjQt4ZJ5yWz2djs0ZCBUEe/32BdoBfpUEBN7BQD477f7hAst2iAMEmf35jwUD5LVcAAIARv5gBDUEVAARAB4Aa7IDHyAREjmwAxCwHNAAsABFWLAGLxuxBhg+WbAARViwAy8bsQMYPlmwAEVYsAgvG7EIEj5ZsABFWLAMLxuxDBA+WbIFBgwREjmyCgYMERI5shcBCitYIdgb9FmwAxCyHAEKK1gh2Bv0WTAxEzYAFxYXNzMBIxMGJy4CJyY3BhcWFhcWNxMmJyYGTyABGc65YSee/vy1YoKsZp5bBwS8BwYJd2OZd11BlZDMAh75AT0FBIRz+iYCBHwEAWfCdzhEPkR3iwMElwITiQYF5QACAEX/6wP7BFMAFQAfAF+yACAhERI5sBfQALAARViwCC8bsQgYPlmwAEVYsAAvG7EAED5ZshoIABESObAaL7S/Gs8aAl2yDAEKK1gh2Bv0WbAAELIQAQorWCHYG/RZsAgQshYBCitYIdgb9FkwMQUmAjc3Ejc2FxYSBwchBhYXFjcXBgYDJgYHBTc2JyYmAgzY7xUDHaCWxsPCGxP9Pg+Ti42SLEC2Am6uNAIRBQkHDWgTAgEv5xwBAZ6TBQb+8th6l8kEBF2BOTgDzAWboQEbNzNTXQAAAgA1/lAEKARSABwAKgB8sgsrLBESObALELAn0ACwAEVYsAcvG7EHGD5ZsABFWLAELxuxBBg+WbAARViwDC8bsQwSPlmwAEVYsBYvG7EWED5ZsgYHFhESObAMELIRAQorWCHYG/RZshQHFhESObAWELIiAQorWCHYG/RZsAQQsicBCitYIdgb9FkwMRM2EjYXFhc3MwMGACcmJzcWFxYTNwYnJiYnJyY3MwYXFhYXFjcTJicmBgdVFIvPf8FfK5uuI/7p1qiNQW+I/U8ahLGMrBQEAga2BwMEaWKeeVU8nYq3GwIepAELhQMEkYD8Aun+/QQEU4tJAgYBFXKEBATBqTY+OztDd4kEB6cB8ZQGA9bBAAEAgf/nBUEFyAAfAE6yCyAhERI5ALAARViwDC8bsQwcPlmwAEVYsAMvG7EDED5ZsgAMAxESObIQAwwREjmwDBCyFAEKK1gh2Bv0WbADELIdAQorWCHYG/RZMDEBBgAnLgInJhISJBcWABcjJicmJyYGAgcHFBYWFwQTBNws/rbjj9uDCgtd0AEUntUBBAi7Bj1Pm4fflxMDTZJlATJnAc/g/vgEA4T+naIBbQEejgME/vnfilNrBASY/tTUVHzNbAMLAVEAAAEAhP/oBUMFxwAhAFyyFCIjERI5ALAARViwDS8bsQ0cPlmwAEVYsAMvG7EDED5ZshEDDRESObANELITAQorWCHYG/RZsAMQshsBCitYIdgb9FmyIA0DERI5sCAvsh8BCitYIdgb9FkwMSUGBCcuAicmNzYSJBcWFhcjAiUmBgIXFBYWFxY3EyE3IQS2Sf7es5jkiAsFDR7PAS2x1/4SuRz+55bskgJRnWzegDz+uRwCAL5lcQMDh/+gUX7YAVywAwTp0wEaCAS6/qDIe9NwAQVuAUabAAACAEQAAAUWBbAADAAXAEayCxgZERI5sAsQsBfQALAARViwAS8bsQEcPlmwAEVYsAAvG7EAED5ZsAEQsg0BCitYIdgb9FmwABCyDgEKK1gh2Bv0WTAxMxMFMgQXFgcHBgIEBwMDFzI2NhInJiYnRP0Bj70BEz05FAMY2f6ozAnGzZT4qDsQFsCdBbABvaaevxvS/re4AQUS+4sBf+wBMX+htQQAAAIAhf/oBV4FyAATACAARrIIISIREjmwCBCwGNAAsABFWLAJLxuxCRw+WbAARViwAC8bsQAQPlmwCRCyFwEKK1gh2Bv0WbAAELIdAQorWCHYG/RZMDEFJiYCJyYSEiQXHgIXFgcHBgIEATQmJyYGAhIWFxY2EgKCjdmACwxj1QERmYzZggsFCQYd0f7RAW+pmZPzlQarlpHzkhUDiQEBnq0BXwEYjgMDh/+eVlQr0/6otgOHwO4EBLz+p/5w7gQGuAFdAAACAIX/BAVkBcgAFQAjAEayAyQlERI5sAMQsBrQALAARViwDi8bsQ4cPlmwAEVYsAUvG7EFED5ZsA4QshkBCitYIdgb9FmwBRCyIAEKK1gh2Bv0WTAxJRcHJwYjJiYCJyYSEiQXFhYSFxYCAhMmJicmBgIXFhYXFjYSA6zQi/84OorWhAsMZdMBEJqN3H8LCmHJZwOplpL1lAMDq5aS9ZA9yHHyCgGGAQOhrQFhARWOAwOJ/wCerf6h/vwC4szkBAS+/qbFyO4EBrsBYQABALsAAAMRBI0ABgAyALAARViwBS8bsQUaPlmwAEVYsAEvG7EBED5ZsgQFARESObAEL7IDAQorWCHYG/RZMDEhIxMFNyUzAky0of6CIAIUIgOhirDGAAEAOQAAA/kEowAYAE0AsABFWLAQLxuxEBo+WbAARViwAC8bsQAQPlmyGAEKK1gh2Bv0WbAC0LIEEBgREjmwEBCyCQEKK1gh2Bv0WbAQELAM0LIWGBAREjkwMSEhNwE3Njc2JicmBgcHNiQXHgIHBgcBIQOZ/KAZAjIpgAwLZVt1phWyEQEcv2uqVggQ6P5eAl2LAcEjb3NRZgIEkHgBs+sCA1OTYLu5/rMAAQAdAAAEAwXEAAcAKwCwAEVYsAYvG7EGGj5ZsABFWLAELxuxBBA+WbAGELIDAQorWCHYG/RZMDEBMwMhAyMTIQNOtVH90LC1ywIwBcT+MPwMBI0AAf+B/qEEEASNABoATgCwDS+wAEVYsAIvG7ECGj5ZsgEBCitYIdgb9FmwBNCyBQ0CERI5sAUvsA0QshIBCitYIdgb9FmwBRCyGQEKK1gh2Bv0WbIaBRkREjkwMQEhNyEHAR4CBwYGBCcmJzcWFxYkNzYmJyc3Aw39jxsDWRb+RGeVRwkPpf7rqLXRPpKrrgEAFhOVpEEPA/SZfv5wE3u7a6D9jQICZIxXBATSrJunBQFvAAL/0/62BDAEjQAKAA4ARgCwAEVYsAkvG7EJGj5ZsABFWLAGLxuxBhA+WbIMAQorWCHYG/RZsADQsAYQsAPQsAYQsAXQsAUvsAwQsAjQsAkQsA3QMDElMwcjAyMTITcBMwEhEwcDcMAbvzm2Ov0yFQNwyfynAfKMJZaX/rcBSXcEF/wJAv43AP//AJACiAL0Bb0DBwHUAHMCmAATALAARViwBy8bsQccPlmwENAwMQD//wBhApgC5AWtAwcB2ABxApgAEwCwAEVYsAkvG7EJHD5ZsA3QMDEA//8AiQKLAwIFrQMHAdkAcwKYABAAsABFWLABLxuxARw+WTAx//8AkQKKAtsFuAMHAdoAcwKYABMAsABFWLASLxuxEhw+WbAT0DAxAP//AKICmAMmBa0DBwHbAHMCmAAQALAARViwBS8bsQUcPlkwMf//AH4CjALrBbsDBwHcAHMCmAAZALAARViwEi8bsRIcPlmwGNCwEhCwJNAwMQD//wCpAo8C6gW6AwcB3QBzApgAEwCwAEVYsAgvG7EIHD5ZsBzQMDEAAAH/1f6aBEQEjAAcAFuyBx0eERI5ALAOL7AARViwAS8bsQEaPlmyAwEKK1gh2Bv0WbIHAQ4REjmwBy+wBdCyEQEOERI5sA4QshMBCitYIdgb9FmwBxCyGQEKK1gh2Bv0WbAHELAc0DAxExMhByEDNhceAgcGACcmJzcWFxY2NzYmJyYGB1jtAv8e/ZSCb5B6rE0NGP6z6cezRHPInuITD3t6W4YqAXYDFqv+c0MCAX7chu7+1AQEb4xjBQLdpIWzBAM+UQABACv+tgQ3BI0ABgAosgEHCBESOQCwAS+wAEVYsAUvG7EFGj5ZsgMBCitYIdgb9FmwANAwMQEBIwEhNyEEI/zHvwMu/TYbA40EGfqdBT+YAAIASf/yBqcEoAAWACIAnbILIyQREjmwCxCwGdAAsABFWLANLxuxDRo+WbAARViwCi8bsQoaPlmwAEVYsAIvG7ECED5ZsABFWLAALxuxABA+WbANELIPAQorWCHYG/RZshINABESObASL7QfEi8SAl2yvxIBXbITAQorWCHYG/RZsAAQshYBCitYIdgb9FmwAhCyFwEKK1gh2Bv0WbAKELIaAQorWCHYG/RZMDEhIQUjJgI3NxIAFzIWMyEHIQMhByEDIQU3EycmBgcGFxQWFwXj/ZX+2VXU3xsGIAE/5lzIYAJ0G/2uOwIFG/39QgJa/HlzoeKa1BsNAXx0DgUBOvMyAQoBQAIRmf6ymP6JCgMDaQwC3sJwMZClBAAAAgA//qUEPgSmABkAJwBRshsoKRESObAbELAN0ACwFS+wAEVYsA0vG7ENGj5ZsBUQsgABCitYIdgb9FmyBBUNERI5sAQvshoBCitYIdgb9FmwDRCyIgEKK1gh2Bv0WTAxBQQTBicuAjc2Njc2FxYSBwcGAgQnJic3FgEWNj8CNiYnJgYHBhYBQAFYnoipfrVUDQpWRo/R2NUeJyPD/uOpknwzbQE3Zac1FwYDdnSGtREPc8EHAdZsBAGB4Itsx0mXBAX+zP352v6zpwMCPYwyAfwEXFWWWoygBAPWpY/DAAACAGT/5wR4BKYAEQAgADkAsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmwChCyFQEKK1gh2Bv0WbAAELIcAQorWCHYG/RZMDEFJiYCNzc2Njc2FxYSBwcGAgYBJyYnJgIHFRQWFxY2NzYCGZXIWBICEGNRouvP4AoEE6D+AQIEH9ex5AeDeZ3XHAoVBJYBDKgUfuRSpQUF/uLxN7b+4JkC3j/+CAb+2Pkhm64EBezPXAD///8J/kYBrwQ6AAYAmwAA////Cf5GAa8EOgAGAJsAAP//AC4AAAGfBDoABgCMAAD///96/lkBnwQ6ACYAjAAAAAYAo8sK//8ALgAAAZ8EOgAGAIwAAP////H+qQGfBDoAJgCMAAAABwCsAzYACgABAB3/5wPUBKIAIQBfALAARViwFS8bsRUaPlmwAEVYsBAvG7EQED5ZsABFWLAfLxuxHxA+WbICAQorWCHYG/RZsgkfFRESObAJL7IIAworWCHYG/RZsBUQsgwBCitYIdgb9FmyGQkIERI5MDElFhcyNjc2Jyc3ASYnJgYHAyMTNjYXFhYXARYWBwYGJyYnAWVKVWGJDBPtXRkBGDxjaoYUgLSAHei8Z7Nc/ryOlwcM8LJrcbUzAoNlqwMBkgEhPAICk4b9DwLx1dwEBFhc/rISnXyv1wICMf//ABkCHwIPArYCBgARAAAAAgAvAAAE8wWwAA4AHQBtALAARViwBS8bsQUcPlmwAEVYsAAvG7EAED5ZsgMABRESObADL7LPAwFdsp8DAXGyLwMBXbRvA38DAnKyAgEKK1gh2Bv0WbAQ0LAAELIRAQorWCHYG/RZsAUQshsBCitYIdgb9FmwAxCwHdAwMTMTIzczEwUyBBIHBwIAIRMhAxcyADc2JyYmJycDIVlznRudbwF6sgEBcBcKLP5q/s28/u9YudQBJywjCw+wlN9UARICmpcCfwGy/sfCSf7C/oUCmv4DAQEI5riBm68EAf4fAAACAC8AAATzBbAADgAdAG2yDx4fERI5sA8QsAbQALAARViwBi8bsQYcPlmwAEVYsAAvG7EAED5ZsAPQsAMvsi8DAV2yzwMBXbICAQorWCHYG/RZsBDQsAAQshIBCitYIdgb9FmwBhCyGgEKK1gh2Bv0WbADELAc0LAd0DAxMxMjNzMTBTIEEgcHAgAhEyEDFzIANzYnJiYnJwMhWXOdG51vAXqyAQFwFwos/mr+zbz+71i51AEnLCMLD7CU31QBEgKalwJ/AbL+x8JJ/sL+hQKa/gMBAQjmuIGbrwQB/h8AAAEAPQAABAEGAAAaAGMAsBgvsABFWLAELxuxBBg+WbAARViwES8bsREQPlmwAEVYsAkvG7EJED5Zsi8YAV2yDxgBXbIWERgREjmwFi+yEwEKK1gh2Bv0WbAB0LAEELIOAQorWCHYG/RZsBYQsBnQMDEBIQM2FxYWBwMjEzYnJicmBwMjEyM3MzczByEC1/7tNY65mJMTdrV3BgURlKZ4hrXWphulG7UdARIE0v7kmwQCzbn9OwLIMSqMAwSy/PwE0peXlwABAKgAAAUJBbAADwBMALAARViwCi8bsQocPlmwAEVYsAIvG7ECED5ZsgYCChESObAGL7IFAQorWCHYG/RZsAHQsAoQsgkBCitYIdgb9FmwDdCwBhCwDtAwMQEjAyMTIzczEyE3IQchAzMDtN+Ou47QG885/jscBEUc/js54AM3/MkDN5cBRJ6e/rwAAAH/9P/tApQFQAAeAGoAsABFWLAZLxuxGRg+WbAARViwCy8bsQsQPlmwGRCwHdCwHS+yAB0BXbAS0LIPAQorWCHYG/RZsAHQsAsQsgYBCitYIdgb9FmwGRCyHAEKK1gh2Bv0WbAT0LAZELAW0LAZELAY0LAYLzAxASMDBhcWMzI3BwYjJiY3EyM3MzcjNzMTMwMzByMHMwJe4DgDAgdOITcOQUNsbAw21hvUH78Zvy60LsUZxB/hAlr+sBoWTgqXEgKbgwFNl7qPAQb++o+6AP///68AAASLBzQCJgAlAAABBwBEAWkBNgATALAARViwBC8bsQQcPlmwDNwwMQD///+vAAAEmAc0AiYAJQAAAQcAdQHzATYAEwCwAEVYsAUvG7EFHD5ZsA3cMDEA////rwAABIsHNgImACUAAAEHAJ0A+QE2ABMAsABFWLAELxuxBBw+WbAQ3DAxAP///68AAASvByECJgAlAAABBwCkAQEBOgATALAARViwBS8bsQUcPlmwDtwwMQD///+vAAAEiwb9AiYAJQAAAQcAagEzATYAFgCwAEVYsAQvG7EEHD5ZsBTcsCDQMDH///+vAAAEiweSAiYAJQAAAQcAogF+AUEADACwBC+wFNywF9AwMf///68AAASdB5MCJgAlAAAABwHfAYIBIv//AHT+QgT5BckCJgAnAAAABwB5AcL/9///ADsAAASxB0ACJgApAAABBwBEATcBQgATALAARViwBi8bsQYcPlmwDdwwMQD//wA7AAAEsQdAAiYAKQAAAQcAdQHBAUIACQCwBi+wDtwwMQD//wA7AAAEsQdCAiYAKQAAAQcAnQDHAUIAEwCwAEVYsAYvG7EGHD5ZsBHcMDEA//8AOwAABLEHCQImACkAAAEHAGoBAQFCAAwAsAYvsCHcsAzQMDH//wBJAAACGQdAAiYALQAAAQcARP/uAUIAEwCwAEVYsAIvG7ECHD5ZsAXcMDEA//8ASQAAAxwHQAImAC0AAAEHAHUAdwFCAAkAsAIvsAbcMDEA//8ASQAAAuIHQgImAC0AAAEHAJ3/fgFCABMAsABFWLACLxuxAhw+WbAJ3DAxAP//AEkAAAMKBwkCJgAtAAABBwBq/7gBQgAMALACL7AZ3LAE0DAx//8AOwAABXcHIQImADIAAAEHAKQBNQE6ABMAsABFWLAILxuxCBw+WbAN3DAxAP//AHf/5wUNBzYCJgAzAAABBwBEAYoBOAATALAARViwCi8bsQocPlmwJNwwMQD//wB3/+cFDQc2AiYAMwAAAQcAdQIUATgACQCwCi+wJdwwMQD//wB3/+cFDQc4AiYAMwAAAQcAnQEaATgAEwCwAEVYsAovG7EKHD5ZsCjcMDEA//8Ad//nBQ0HIwImADMAAAEHAKQBIgE8ABMAsABFWLAKLxuxChw+WbAm3DAxAP//AHf/5wUNBv8CJgAzAAABBwBqAVQBOAAMALAKL7A43LAj0DAx//8AZ//nBSAHNAImADkAAAEHAEQBZAE2ABMAsABFWLAKLxuxChw+WbAU3DAxAP//AGf/5wUgBzQCJgA5AAABBwB1Ae4BNgAJALAAL7AV3DAxAP//AGf/5wUgBzYCJgA5AAABBwCdAPQBNgATALAARViwCi8bsQocPlmwGNwwMQD//wBn/+cFIAb9AiYAOQAAAQcAagEuATYADACwAC+wKNywE9AwMf//AKgAAAUyBzQCJgA9AAABBwB1Ab0BNgAJALABL7AL3DAxAP//ADP/6APPBf4CJgBFAAABBwBEANsAAAATALAARViwGC8bsRgYPlmwLdwwMQD//wAz/+gECgX+AiYARQAAAQcAdQFlAAAACQCwGC+wLtwwMQD//wAz/+gDzwYAAiYARQAAAQYAnWsAABMAsABFWLAYLxuxGBg+WbAx3DAxAP//ADP/6AQhBesCJgBFAAABBgCkcwQACQCwGC+wNtwwMQD//wAz/+gD9wXHAiYARQAAAQcAagClAAAADACwGC+wQdywLNAwMf//ADP/6APPBlwCJgBFAAABBwCiAPAACwAMALAYL7A13LA40DAx//8AM//oBA8GXgImAEUAAAAHAd8A9P/t//8ARv5CA+YEUgImAEcAAAAHAHkBPv/3//8ARf/qA+AF/gImAEkAAAEHAEQAwAAAABMAsABFWLAILxuxCBg+WbAh3DAxAP//AEX/6gPvBf4CJgBJAAABBwB1AUoAAAAJALAIL7Ai3DAxAP//AEX/6gPgBgACJgBJAAABBgCdUAAAEwCwAEVYsAgvG7EIGD5ZsCXcMDEA//8ARf/qA+AFxwImAEkAAAEHAGoAigAAAAwAsAgvsDXcsCDQMDH//wAuAAABxwX9AiYAjAAAAQYARJz/ABMAsABFWLACLxuxAhg+WbAF3DAxAP//AC4AAALKBf0CJgCMAAABBgB1Jf8ACQCwAi+wBtwwMQD//wAuAAACkAX/AiYAjAAAAQcAnf8s//8AEwCwAEVYsAIvG7ECGD5ZsAncMDEA//8ALgAAArgFxgImAIwAAAEHAGr/Zv//ABYAsABFWLACLxuxAhg+WbAN3LAZ0DAx//8AHwAABBgF6wImAFIAAAEGAKRqBAAJALADL7Ad3DAxAP//AEX/6AQfBf4CJgBTAAABBwBEAMkAAAATALAARViwAC8bsQAYPlmwJNwwMQD//wBF/+gEHwX+AiYAUwAAAQcAdQFTAAAACQCwAC+wJdwwMQD//wBF/+gEHwYAAiYAUwAAAQYAnVkAABMAsABFWLAALxuxABg+WbAo3DAxAP//AEX/6AQfBesCJgBTAAABBgCkYQQACQCwAC+wLdwwMQD//wBF/+gEHwXHAiYAUwAAAQcAagCTAAAADACwAC+wONywI9AwMf//AFv/6AQeBf4CJgBZAAABBwBEAM0AAAATALAARViwBy8bsQcYPlmwFdwwMQD//wBb/+gEHgX+AiYAWQAAAQcAdQFXAAAACQCwBi+wFtwwMQD//wBb/+gEHgYAAiYAWQAAAQYAnV0AABMAsABFWLAGLxuxBhg+WbAZ3DAxAP//AFv/6AQeBccCJgBZAAABBwBqAJcAAAAMALAGL7Ap3LAU0DAx////pf5FA+wF/gImAF0AAAEHAHUBHgAAAAkAsAEvsBLcMDEA////pf5FA+wFxwImAF0AAAEGAGpeAAAMALABL7Al3LAQ0DAx////rwAABLQG7gImACUAAAEHAHABBAE+ABMAsABFWLAELxuxBBw+WbAM3DAxAP//ADP/6AQmBbgCJgBFAAABBgBwdggAEwCwAEVYsBgvG7EYGD5ZsC3cMDEA////rwAABIsHDwImACUAAAEHAKABLgE3ABMAsABFWLAELxuxBBw+WbAO3DAxAP//ADP/6APsBdkCJgBFAAABBwCgAKAAAQAJALAYL7Av3DAxAAAC/6/+TwSLBbAAFwAaAHSyFRscERI5sBUQsBrQALAARViwFS8bsRUcPlmwAEVYsBMvG7ETED5ZsABFWLAXLxuxFxA+WbAARViwCy8bsQsSPlmyBgMKK1gh2Bv0WbAXELAQ0LAQL7IYExUREjmwGC+yEgEKK1gh2Bv0WbIaFRMREjkwMSEXBwYHBhcWNxcGIyImNzY3AyEDIwEzAQEhAwRlBEF6CQdBIEMERFNOXwIDyEL9ssfJAxelASD9BwHfeQMvWlk/AgEaeStlUppxAWv+hAWw+lACGgKnAAIAM/5PA88EUQAvADoAnbITOzwREjmwExCwMdAAsABFWLAnLxuxJxg+WbAARViwCy8bsQsSPlmwAEVYsBQvG7EUED5ZsABFWLAvLxuxLxA+WbALELIGAworWCHYG/RZsC8QsBDQsBAvshInFBESObIaJxQREjmwGi+wJxCyHwEKK1gh2Bv0WbIiGicREjmwFBCyMAEKK1gh2Bv0WbAaELI1AQorWCHYG/RZMDEhFwcGBwYXFjcXBiMiJjc2Nyc3BicmJjc2JDMXNzYmJyYGBwc+AhcWFgcDBwYXByUWNjc3JyIGBwYWA0QEQXoJB0EgQwREU05fAgPLAwOVp4+zCAoBGeW9DApfX12PELYJgsxtqbwPWAUCDgL+LFebOCeJq7YMCVkDL1pZPwIBGnkrZVKacjAwigQCsYWswQFWYXECAl9OAV+TUQIExaP96E03NhGMAldN3wFsY0xl//8AdP/mBPkHVQImACcAAAEHAHUB/wFXAAkAsA0vsCLcMDEA//8ARv/pA+YF/gImAEcAAAEHAHUBKgAAAAkAsBEvsCPcMDEA//8AdP/mBPkHVwImACcAAAEHAJ0BBQFXAAkAsA0vsCHcMDEA//8ARv/pA+YGAAImAEcAAAEGAJ0wAAAJALARL7Ai3DAxAP//AHT/5gT5BxwCJgAnAAABBwChAdwBVwAJALANL7Ap3DAxAP//AEb/6QPmBcUCJgBHAAABBwChAQcAAAAJALARL7Aq3DAxAP//AHT/5gT5B1kCJgAnAAABBwCeARoBWAAJALANL7Ak3DAxAP//AEb/6QPmBgICJgBHAAABBgCeRQEACQCwES+wJdwwMQD//wA7AAAE1QdEAiYAKAAAAQcAngDSAUMACQCwAS+wGtwwMQD//wBL/+gFpgYCACYASAAAAAcBogSXBRP//wA7AAAEsQb6AiYAKQAAAQcAcADSAUoACQCwBi+wDNwwMQD//wBF/+oECwW4AiYASQAAAQYAcFsIAAkAsAgvsCDcMDEA//8AOwAABLEHGwImACkAAAEHAKAA/AFDAAkAsAYvsA/cMDEA//8ARf/qA+AF2QImAEkAAAEHAKAAhQABAAkAsAgvsCPcMDEA//8AOwAABLEHBwImACkAAAEHAKEBngFCAAkAsAYvsBXcMDEA//8ARf/qA+AFxQImAEkAAAEHAKEBJwAAAAkAsAgvsCncMDEAAAEAO/5PBLEFsAAcAICyFB0eERI5ALAARViwFy8bsRccPlmwAEVYsBAvG7EQEj5ZsABFWLAELxuxBBA+WbAARViwFS8bsRUQPlmyHBcEERI5sBwvsgABCitYIdgb9FmwFRCyAgEKK1gh2Bv0WbAD0LAQELILAworWCHYG/RZsBcQshkBCitYIdgb9FkwMQEhAyEHIxcHBgcGFxY3FwYjIiY3NjchEyEHIQMhA9D9nFoCyBxLBEF6CQdBIEMERFNOXwIDq/17/QN5HP1DUQJkAqH9/J0DL1pZPwIBGnkrZVKRaQWwnv4sAAACAEX+aAPZBFEAJgAuAH6yBC8wERI5sAQQsCjQALAML7AARViwGi8bsRoYPlmwAEVYsBEvG7ERED5ZsiQBCitYIdgb9FmyAhEkERI5sAwQsgcDCitYIdgb9FmyKxoRERI5sCsvtL8rzysCXbIgAQorWCHYG/RZsiYaERESObAaELInAQorWCHYG/RZMDElBgcHBgcGFxY3FwYjIiY3NjcuAjc3NhI2FxYWFxYHByEGFhcWNwMmBgcFNzYmA4tThTt1CgdBIEMERFNOXwIDcHy0VgsFEZ3ig6e+CQMHC/09EoWEoIjEcKcxAg4EEHG7dzUrV1k/AgEaeStlUnJdConoiyuhAQqHAwTWt0FBU5POBASUAqQDnpwBEH6n//8AOwAABLEHRAImACkAAAEHAJ4A3AFDAAkAsAYvsBDcMDEA//8ARf/qA+UGAgImAEkAAAEGAJ5lAQAJALAIL7Ak3DAxAP//AHn/6gUGB1cCJgArAAABBwCdAP0BVwAJALAML7Aj3DAxAP//AAT+TwQoBgACJgBLAAABBgCdUwAACQCwBC+wK9wwMQD//wB5/+oFBgcwAiYAKwAAAQcAoAEyAVgACQCwDC+wJdwwMQD//wAE/k8EKAXZAiYASwAAAQcAoACIAAEACQCwBC+wLdwwMQD//wB5/+oFBgccAiYAKwAAAQcAoQHUAVcACQCwDC+wK9wwMQD//wAE/k8EKAXFAiYASwAAAQcAoQEqAAAACQCwBC+wM9wwMQD//wB5/fYFBgXHAiYAKwAAAAcBogFY/pf//wAE/k8EKAaVAiYASwAAAQcBuQEyAFgACQCwBC+wLtwwMQD//wA7AAAFdwdCAiYALAAAAQcAnQEhAUIACQCwBi+wDdwwMQD//wAfAAAD4wdBAiYATAAAAQcAnQBUAUEADgCwES+wFNyy3xQBXTAx//8ASQAAAzQHLQImAC0AAAEHAKT/hgFGAAkAsAIvsA7cMDEA//8AEQAAAuIF6QImAIwAAAEHAKT/NAACAAkAsAIvsA7cMDEA//8ASQAAAzkG+gImAC0AAAEHAHD/iQFKAAkAsAIvsATcMDEA//8AGgAAAucFtgImAIwAAAEHAHD/NwAGAAkAsAIvsATcMDEA//8ASQAAAv8HGwImAC0AAAEHAKD/swFDAAkAsAIvsAfcMDEA//8ALgAAAq0F2AImAIwAAAEHAKD/YQAAAAkAsAIvsAfcMDEA////jv5YAgEFsAImAC0AAAAGAKPfCf///3D+TwHjBccCJgBNAAAABgCjwQD//wBJAAACNwcHAiYALQAAAQcAoQBUAUIACQCwAi+wDdwwMQD//wBJ/+YGcAWwACYALQAAAAcALgImAAD//wAv/kYDwQXHACYATQAAAAcATgHsAAD//wAK/+YFCgc1AiYALgAAAQcAnQGmATUACQCwAC+wEdwwMQD///8J/kYClgXYAiYAmwAAAQcAnf8y/9gACQCwAC+wDtwwMQD//wA7/lgFUAWwAiYALwAAAAcBogFa/vn//wAg/kUEGgYAAiYATwAAAAcBogDY/ub//wA7AAADsQcvAiYAMAAAAQcAdQBlATEACQCwBC+wCNwwMQD//wAvAAADDgeUAiYAUAAAAQcAdQBpAZYACQCwAi+wBtwwMQD//wA7/gkDsQWwAiYAMAAAAAcBogEl/qr///+j/gkB7gYAAiYAUAAAAAcBov/A/qr//wA7AAADsQWxAiYAMAAAAQcBogKaBMIAEACwAEVYsAovG7EKHD5ZMDH//wAvAAADOwYCACYAUAAAAAcBogIsBRP//wA7AAADsQWwAiYAMAAAAAcAoQFM/cX//wAvAAACrAYAACYAUAAAAAcAoQDJ/bb//wA7AAAFdwc0AiYAMgAAAQcAdQInATYACQCwBS+wDNwwMQD//wAfAAAEAQX+AiYAUgAAAQcAdQFcAAAACQCwAy+wFdwwMQD//wA7/gkFdwWwAiYAMgAAAAcBogGG/qr//wAf/gkD4wRSAiYAUgAAAAcBogDu/qr//wA7AAAFdwc4AiYAMgAAAQcAngFCATcACQCwBS+wDtwwMQD//wAfAAAD9wYCAiYAUgAAAQYAnncBAAkAsAMvsBfcMDEA//8AHwAAA+MGBAImAFIAAAAHAaIARQUV//8Ad//nBQ0G8AImADMAAAEHAHABJQFAAAkAsAovsCPcMDEA//8ARf/oBB8FuAImAFMAAAEGAHBkCAAJALAAL7Aj3DAxAP//AHf/5wUNBxECJgAzAAABBwCgAU8BOQAJALAKL7Am3DAxAP//AEX/6AQfBdkCJgBTAAABBwCgAI4AAQAJALAAL7Am3DAxAP//AHf/5wVUBzcCJgAzAAABBwClAZYBOAAMALAKL7Al3LAn0DAx//8ARf/oBJMF/wImAFMAAAEHAKUA1QAAAAwAsAAvsCXcsCfQMDH//wA6AAAEwgc0AiYANgAAAQcAdQG2ATYACQCwBC+wGtwwMQD//wAfAAADYQX+AiYAVgAAAQcAdQC8AAAACQCwCi+wD9wwMQD//wA6/gkEwgWwAiYANgAAAAcBogEd/qr///+f/gkC1ARUAiYAVgAAAAcBov+8/qr//wA6AAAEwgc4AiYANgAAAQcAngDRATcACQCwBC+wHNwwMQD//wAfAAADWAYCAiYAVgAAAQYAntgBAAkAsAovsBHcMDEA//8AJ//pBKMHNgImADcAAAEHAHUBwgE4AAkAsAovsCvcMDEA//8ALv/pA+wF/gImAFcAAAEHAHUBRwAAAAkAsAgvsCncMDEA//8AJ//pBKMHOAImADcAAAEHAJ0AyAE4AAkAsAovsCrcMDEA//8ALv/pA7YGAAImAFcAAAEGAJ1NAAAJALAIL7Ao3DAxAP//ACf+SwSjBccCJgA3AAAABwB5AZIAAP//AC7+QwO2BFACJgBXAAAABwB5AVv/+P//ACf9/wSjBccCJgA3AAAABwGiASz+oP//AC799gO2BFACJgBXAAAABwGiAPX+l///ACf/6QSjBzoCJgA3AAABBwCeAN0BOQAJALAKL7At3DAxAP//AC7/6QPiBgICJgBXAAABBgCeYgEACQCwCC+wK9wwMQD//wCo/f8FCQWwAiYAOAAAAAcBogEe/qD//wBD/f8ClAVAAiYAWAAAAAcBogCC/qD//wCo/ksFCQWwAiYAOAAAAAcAeQGEAAD//wBD/ksClAVAAiYAWAAAAAcAeQDoAAD//wCoAAAFCQc4AiYAOAAAAQcAngDSATcACQCwBi+wDNwwMQD//wBD/+0DjQZ5ACYAWAAAAAcBogJ+BYr//wBn/+cFIAchAiYAOQAAAQcApAD8AToACQCwAC+wHdwwMQD//wBb/+gEHgXrAiYAWQAAAQYApGUEAAkAsAYvsB7cMDEA//8AZ//nBSAG7gImADkAAAEHAHAA/wE+AAkAsAAvsBPcMDEA//8AW//oBB4FuAImAFkAAAEGAHBoCAAJALAGL7AU3DAxAP//AGf/5wUgBw8CJgA5AAABBwCgASkBNwAJALAAL7AW3DAxAP//AFv/6AQeBdkCJgBZAAABBwCgAJIAAQAJALAGL7AX3DAxAP//AGf/5wUgB5ICJgA5AAABBwCiAXkBQQAMALAAL7Ac3LAf0DAx//8AW//oBB4GXAImAFkAAAEHAKIA4gALAAwAsAYvsB3csCDQMDH//wBn/+cFLgc1AiYAOQAAAQcApQFwATYADACwAC+wFdywF9AwMf//AFv/6ASXBf8CJgBZAAABBwClANkAAAAMALAGL7AW3LAY0DAxAAEAZ/57BSgFsAAfAFAAsABFWLAXLxuxFxw+WbAARViwDS8bsQ0SPlmwAEVYsBIvG7ESED5ZshsBCitYIdgb9FmyBBIbERI5sA0QsggDCitYIdgb9FmwFxCwH9AwMQEDBgYHBgcGFxY3FwYjIiY3NjcmAjcTMwMGFhcWNjcTBSioF72WlQkHQSBDBERTTl8CBFbZ8RmouacRioyY0RuoBbD8J5/0NmdgPwIBGnkrZVJnUgYBD9YD2vwlma8EBrGgA9wAAQBb/k8EHgQ6ACMAYwCwAEVYsBgvG7EYGD5ZsABFWLATLxuxExA+WbAARViwIy8bsSMQPlmwAEVYsAsvG7ELEj5ZsgYDCitYIdgb9FmwIxCwENCyERMYERI5sBMQsh4BCitYIdgb9FmwGBCwIdAwMSEXBwYHBhcWNxcGIyImNzY3NwYnJiY3EzMDBhcWFhcWNxMzAwNUBEF6CQdBIEMERFNOXwIDxBR/xJuVE3S1dQUDBUxEwmqItbwDL1pZPwIBGnkrZVKXcV2DBATWuQK7/UIsKkhSAwajAxT7xgD//wDDAAAHQQc2AiYAOwAAAQcAnQHcATYACQCwAy+wFNwwMQD//wCAAAAF/gYAAiYAWwAAAQcAnQEbAAAACQCwAS+wDtwwMQD//wCoAAAFMgc2AiYAPQAAAQcAnQDDATYACQCwAS+wCtwwMQD///+l/kUD7AYAAiYAXQAAAQYAnSQAAAkAsAEvsBHcMDEA//8AqAAABTIG/QImAD0AAAEHAGoA/QE2AAwAsAEvsB7csAnQMDH////rAAAEzgc0AiYAPgAAAQcAdQG8ATYACQCwBy+wDNwwMQD////tAAADzgX+AiYAXgAAAQcAdQEkAAAACQCwBy+wDNwwMQD////rAAAEzgb7AiYAPgAAAQcAoQGZATYACQCwBy+wE9wwMQD////tAAADzgXFAiYAXgAAAQcAoQEBAAAACQCwBy+wE9wwMQD////rAAAEzgc4AiYAPgAAAQcAngDXATcACQCwBy+wDtwwMQD////tAAADzgYCAiYAXgAAAQYAnj8BAAkAsAcvsA7cMDEA////hAAAB3gHQAImAIEAAAEHAHUC9wFCABMAsABFWLAGLxuxBhw+WbAV3DAxAP//ABP/6AZhBf8CJgCGAAABBwB1AnMAAQATALAARViwFy8bsRcYPlmwRNwwMQD//wAg/6QFnAd+AiYAgwAAAQcAdQIoAYAAEwCwAEVYsA0vG7ENHD5ZsDDcMDEA//8AOf96BCoF/gImAIkAAAEHAHUBOQAAABMAsABFWLAALxuxABg+WbAu3DAxAP///7AAAAQPBI0CJgG9AAABBwHe/x3/eAAsALIfGQFxtN8Z7xkCcbQfGS8ZAl2ybxkBcrJPGQFxtO8Z/xkCXbJfGQFdMDH///+wAAAEDwSNAiYBvQAAAQcB3v8d/3gALACyHxkBcbTfGe8ZAnG0HxkvGQJdsm8ZAXKyTxkBcbTvGf8ZAl2yXxkBXTAx//8AbQAABEIEjQImAc0AAAEGAd494AAIALIACwFdMDH///+lAAAD4wYcAiYBugAAAQcARADgAB4AEwCwAEVYsAQvG7EEGj5ZsAzcMDEA////pQAABA8GHAImAboAAAEHAHUBagAeAAkAsAQvsA3cMDEA////pQAAA+MGHgImAboAAAEGAJ1wHgATALAARViwBC8bsQQaPlmwENwwMQD///+lAAAEJgYJAiYBugAAAQYApHgiAAkAsAQvsBXcMDEA////pQAAA/wF5QImAboAAAEHAGoAqgAeAAwAsAQvsCDcsAvQMDH///+lAAAD4wZ6AiYBugAAAQcAogD1ACkADACwBC+wFNywF9AwMf///6UAAAQUBnsCJgG6AAAABwHfAPkACv//AEf+SAQ3BKMCJgG8AAAABwB5AWj//f//AB0AAAPvBhwCJgG+AAABBwBEALQAHgATALAARViwBi8bsQYaPlmwDdwwMQD//wAdAAAD7wYcAiYBvgAAAQcAdQE+AB4ACQCwBi+wDtwwMQD//wAdAAAD7wYeAiYBvgAAAQYAnUQeAAkAsAYvsA3cMDEA//8AHQAAA+8F5QImAb4AAAEGAGp+HgAMALAGL7Ah3LAM0DAx//8AKgAAAcUGHAImAcIAAAEGAESaHgATALAARViwAi8bsQIaPlmwBdwwMQD//wAqAAACyAYcAiYBwgAAAQYAdSMeAAkAsAIvsAbcMDEA//8AKgAAAo4GHgImAcIAAAEHAJ3/KgAeAAkAsAIvsAXcMDEA//8AKgAAArYF5QImAcIAAAEHAGr/ZAAeAAwAsAIvsBncsATQMDH//wAdAAAEmgYJAiYBxwAAAQcApACiACIACQCwBS+wFNwwMQD//wBK/+oETgYcAiYByAAAAQcARAD4AB4AEwCwAEVYsAgvG7EIGj5ZsCHcMDEA//8ASv/qBE4GHAImAcgAAAEHAHUBggAeAAkAsAgvsCLcMDEA//8ASv/qBE4GHgImAcgAAAEHAJ0AiAAeAAkAsAgvsCHcMDEA//8ASv/qBE4GCQImAcgAAAEHAKQAkAAiAAkAsAgvsCrcMDEA//8ASv/qBE4F5QImAcgAAAEHAGoAwgAeAAwAsAgvsDXcsCDQMDH//wBF/+oEVwYcAiYBzgAAAQcARADaAB4AEwCwAEVYsAkvG7EJGj5ZsBPcMDEA//8ARf/qBFcGHAImAc4AAAEHAHUBZAAeAAkAsAAvsBTcMDEA//8ARf/qBFcGHgImAc4AAAEGAJ1qHgAJALAAL7AT3DAxAP//AEX/6gRXBeUCJgHOAAABBwBqAKQAHgAMALAAL7An3LAS0DAx//8AdAAABGUGHAImAdIAAAEHAHUBOgAeAAkAsAEvsAvcMDEA////pQAABCsF1gImAboAAAEGAHB7JgAJALAEL7AL3DAxAP///6UAAAPxBfcCJgG6AAABBwCgAKUAHwAJALAEL7AO3DAxAAAC/6X+TwPjBI0AFgAZAGuyFBobERI5sBQQsBnQALAARViwFC8bsRQaPlmwAEVYsBIvG7ESED5ZsABFWLAWLxuxFhA+WbAARViwCi8bsQoSPlmyBQMKK1gh2Bv0WbIXEhQREjmwFy+yEQEKK1gh2Bv0WbIZFBIREjkwMSEHBgcGFxY3FwYjIiY3NjcDIQMjATMBASEDA8FBegkHQSBDBERTTl8CA881/gmcwQKbogEB/XMBhGgyWlk/AgEaeStlUpp1AQL+6QSN+3MBrgH7//8AR//sBDcGHAImAbwAAAEHAHUBbwAeAAkAsAsvsB/cMDEA//8AR//sBDcGHgImAbwAAAEGAJ11HgAJALALL7Ae3DAxAP//AEf/7AQ3BeMCJgG8AAABBwChAUwAHgAJALALL7Am3DAxAP//AEf/7AQ3BiACJgG8AAABBwCeAIoAHwAJALALL7Ah3DAxAP//AB0AAAQPBiACJgG9AAABBgCeNR8ACQCwAS+wGtwwMQD//wAdAAAD/wXWAiYBvgAAAQYAcE8mAAkAsAYvsAzcMDEA//8AHQAAA+8F9wImAb4AAAEGAKB5HwAJALAGL7AP3DAxAP//AB0AAAPvBeMCJgG+AAABBwChARsAHgAJALAGL7AV3DAxAAABAB3+TwPvBI0AHACMshEdHhESOQCwAEVYsBcvG7EXGj5ZsABFWLAQLxuxEBI+WbAARViwBC8bsQQQPlmwAEVYsBUvG7EVED5ZshwXBBESObAcL7QfHC8cAl2yvxwBXbIAAQorWCHYG/RZsBUQsgIBCitYIdgb9FmwA9CwEBCyCwMKK1gh2Bv0WbAXELIZAQorWCHYG/RZMDEBIQMhByMXBwYHBhcWNxcGIyImNzY3IRMhByEDIQMx/f1CAlkbPwRBegkHQSBDBERTTl8CA6v95csDBxv9rjoCBAIO/omXAy9aWT8CARp5K2VSkWkEjZn+sgD//wAdAAAD7wYgAiYBvgAAAQYAnlkfAAkAsAYvsBDcMDEA//8ATP/uBEEGHgImAcAAAAEGAJ1zHgAJALALL7Ah3DAxAP//AEz/7gRBBfcCJgHAAAABBwCgAKgAHwAJALALL7Aj3DAxAP//AEz/7gRBBeMCJgHAAAABBwChAUoAHgAJALALL7Ap3DAxAP//AEz9/ARBBKMCJgHAAAAABwGiAQf+nf//AB0AAASaBh4CJgHBAAABBwCdAJEAHgAJALAGL7AN3DAxAP//AA8AAALgBgkCJgHCAAABBwCk/zIAIgAJALACL7AO3DAxAP//ABgAAALlBdYCJgHCAAABBwBw/zUAJgAJALACL7AE3DAxAP//ACoAAAKrBfcCJgHCAAABBwCg/18AHwAJALACL7AH3DAxAP///3r+TwGqBI0CJgHCAAAABgCjywD//wAqAAAB4wXjAiYBwgAAAQYAoQAeAAkAsAIvsA3cMDEA////9v/rBGgGHgImAcMAAAEHAJ0BBAAeAAkAsAAvsBDcMDEA//8AHf4FBH8EjQImAcQAAAAHAaIAz/6m//8AHQAAAyMGHAImAcUAAAEGAHUXHgAJALAEL7AI3DAxAP//AB3+BwMjBI0CJgHFAAAABwGiAMz+qP//AB0AAAMjBI4CJgHFAAABBwGiAhMDnwAQALAARViwCi8bsQoaPlkwMf//AB0AAAMjBI0CJgHFAAAABwChAOD9N///AB0AAASaBhwCJgHHAAABBwB1AZQAHgAJALAFL7AM3DAxAP//AB3+AwSaBI0CJgHHAAAABwGiAST+pP//AB0AAASaBiACJgHHAAABBwCeAK8AHwAJALAFL7AO3DAxAP//AEr/6gROBdYCJgHIAAABBwBwAJMAJgAJALAIL7Ag3DAxAP//AEr/6gROBfcCJgHIAAABBwCgAL0AHwAJALAIL7Aj3DAxAP//AEr/6gTCBh0CJgHIAAABBwClAQQAHgAMALAIL7Ai3LAk0DAx//8AHQAABAEGHAImAcsAAAEHAHUBLwAeAAkAsAQvsBncMDEA//8AHf4HBAEEjQImAcsAAAAHAaIAyf6o//8AHQAABAEGIAImAcsAAAEGAJ5KHwAJALAEL7Ab3DAxAP//ABH/6wPtBhwCJgHMAAABBwB1AUUAHgAJALAKL7Aq3DAxAP//ABH/6wPtBh4CJgHMAAABBgCdSx4ACQCwCi+wKdwwMQD//wAR/ksD7QSdAiYBzAAAAAcAeQFJAAD//wAR/+sD7QYgAiYBzAAAAQYAnmAfAAkAsAovsCzcMDEA//8Abf4BBEIEjQImAc0AAAAHAaIAz/6i//8AbQAABEIGIAImAc0AAAEGAJ5UHwAJALAGL7AM3DAxAP//AG3+TQRCBI0CJgHNAAAABwB5ATUAAv//AEX/6gRXBgkCJgHOAAABBgCkciIACQCwAC+wHNwwMQD//wBF/+oEVwXWAiYBzgAAAQYAcHUmAAkAsAAvsBLcMDEA//8ARf/qBFcF9wImAc4AAAEHAKAAnwAfAAkAsAAvsBXcMDEA//8ARf/qBFcGegImAc4AAAEHAKIA7wApAAwAsAAvsBvcsB7QMDH//wBF/+oEpAYdAiYBzgAAAQcApQDmAB4ADACwAC+wFNywFtAwMQABAEX+dARXBI0AIABhsgkhIhESOQCwAEVYsCAvG7EgGj5ZsABFWLAYLxuxGBo+WbAARViwDi8bsQ4SPlmwAEVYsBMvG7ETED5ZsgQTIBESObAOELIJAworWCHYG/RZsBMQshwBCitYIdgb9FkwMQEDBgYHBgYHBhcWNxcGIyImNzY3JiY3EzMDBhYXFjY3EwRXgxOkgFRKBAdBIEMERFNOXwIEYrTHE4OzhA11dHqpFYQEjfz1h8cqO2AvPwIBGnkrZVJwVQ3aqgMM/PN1gQMEgnsDDQD//wCVAAAGKQYeAiYB0AAAAQcAnQE3AB4ACQCwEi+wFNwwMQD//wB0AAAEZQYeAiYB0gAAAQYAnUAeAAkAsAEvsArcMDEA//8AdAAABGUF5QImAdIAAAEGAGp6HgAMALABL7Ae3LAJ0DAx////3AAABA4GHAImAdMAAAEHAHUBOgAeAAkAsAcvsAzcMDEA////3AAABA4F4wImAdMAAAEHAKEBFwAeAAkAsAcvsBPcMDEA////3AAABA4GIAImAdMAAAEGAJ5VHwAJALAHL7AO3DAxAP///68AAASLBj8CJgAlAAAABgCtBAD//wBjAAAFFQY/ACYAKWQAAAcArf9CAAD//wBxAAAF2wZBACYALGQAAAcArf9QAAL//wB3AAACZQZAACYALWQAAAcArf9WAAH//wBq/+cFIQY/ACYAMxQAAAcArf9JAAD////uAAAFlgY/ACYAPWQAAAcArf7NAAD//wAeAAAE7gY/ACYAuRQAAAcArf9MAAD//wAg//QDGwZ0AiYAwgAAAQcArv8t/+wAHACwAEVYsA4vG7EOGD5ZsBvcsBHQsBsQsCTQMDH///+vAAAEiwWwAgYAJQAA//8AOwAABKAFsAIGACYAAP//ADsAAASxBbACBgApAAD////rAAAEzgWwAgYAPgAA//8AOwAABXcFsAIGACwAAP//AEkAAAIBBbACBgAtAAD//wA7AAAFUAWwAgYALwAA//8AOwAABrcFsAIGADEAAP//ADsAAAV3BbACBgAyAAD//wB3/+cFDQXIAgYAMwAA//8AOwAABPMFsAIGADQAAP//AKgAAAUJBbACBgA4AAD//wCoAAAFMgWwAgYAPQAA////1AAABSsFsAIGADwAAP//AEkAAAMKBwkCJgAtAAABBwBq/7gBQgAMALACL7AZ3LAE0DAx//8AqAAABTIG/QImAD0AAAEHAGoA/QE2AAwAsAEvsB7csAnQMDH//wBI/+cEMgY6AiYAugAAAQcArQFo//sACQCwFS+wKNwwMQD//wAp/+cD5QY5AiYAvgAAAQcArQEh//oACQCwGi+wK9wwMQD//wAk/mED8wY6AiYAwAAAAQcArQE7//sACQCwAy+wFdwwMQD//wCF//QCZQYlAiYAwgAAAQYArSTmAAkAsAAvsBHcMDEA//8AZ//lBAoGdAImAMoAAAEGAK4c7AASALALL7Ar3LAW0LArELAa0DAx//8ALQAABFcEOgIGAI0AAP//AEX/6AQfBFICBgBTAAD////l/mAEJQQ6AgYAdgAA//8AbgAAA+0EOgIGAFoAAP///8QAAAP0BDoCBgBcAAD//wBn//QC3gWzAiYAwgAAAQYAaozsAAwAsAAvsCTcsA/QMDH//wBn/+UD+gWzAiYAygAAAQYAanvsAAwAsAsvsCvcsBbQMDH//wBF/+gEHwY6AiYAUwAAAQcArQEs//sACQCwAC+wJdwwMQD//wBn/+UD+gYlAiYAygAAAQcArQEU/+YACQCwCy+wGNwwMQD//wBm/+QF/AYiAiYAzQAAAQcArQI8/+MACQCwGC+wLdwwMQD//wA7AAAEsQcJAiYAKQAAAQcAagEBAUIAFgCwAEVYsAYvG7EGHD5ZsBXcsCHQMDH//wBDAAAEpQdAAiYAsAAAAQcAdQHHAUIAEwCwAEVYsAQvG7EEHD5ZsAjcMDEAAAEAJ//pBKMFxwAoAGGyEykqERI5ALAARViwCi8bsQocPlmwAEVYsB8vG7EfED5ZsgIfChESObAKELAP0LAKELISAQorWCHYG/RZsAIQshgBCitYIdgb9FmwHxCwJNCwHxCyJwEKK1gh2Bv0WTAxATYvAiQ3PgIXHgIHJzYmJyYGBwYfAgQDDgInLgI3FwYWBDYDbRa8rTr+3BMKkvGIhM9sBr0KjIKJuA4Uy5VLARoVC5D3jonjdge8CZ8BIrwBd6BKPxmF8Xm6ZQMDcMl+AYaTAgKEcpVNNSCC/wB7s2IDAXPIfwGCmQSC//8ASQAAAgEFsAIGAC0AAP//AEkAAAMKBwkCJgAtAAABBwBq/7gBQgAMALACL7AZ3LAE0DAx//8ACv/mBEoFsAIGAC4AAP//AEQAAAVqBbACBgHjAAD//wA7AAAFUAcuAiYALwAAAQcAdQGwATAAEwCwAEVYsAUvG7EFHD5ZsA7cMDEA//8Ak//mBUAHGwImAN0AAAEHAKABFgFDABMAsABFWLAQLxuxEBw+WbAU3DAxAP///68AAASLBbACBgAlAAD//wA7AAAEoAWwAgYAJgAA//8AQwAABKUFsAIGALAAAP//ADsAAASxBbACBgApAAD//wBDAAAFbgcbAiYA2wAAAQcAoAFrAUMACQCwAC+wDdwwMQD//wA7AAAGtwWwAgYAMQAA//8AOwAABXcFsAIGACwAAP//AHf/5wUNBcgCBgAzAAD//wBEAAAFcAWwAgYAtQAA//8AOwAABPMFsAIGADQAAP//AHT/5gT5BckCBgAnAAD//wCoAAAFCQWwAgYAOAAA////1AAABSsFsAIGADwAAP//ADP/6APPBFECBgBFAAD//wBF/+oD4ARRAgYASQAA//8ALwAABDcFxQImAO8AAAEHAKAApf/tAAkAsAAvsA3cMDEA//8ARf/oBB8EUgIGAFMAAP///9f+YAP8BFICBgBUAAAAAQBG/+kD5gRSACAAS7IAISIREjkAsABFWLARLxuxERg+WbAARViwCC8bsQgQPlmyAAEKK1gh2Bv0WbIEEQgREjmyFBEIERI5sBEQshgBCitYIdgb9FkwMSUWNjc3DgInLgI3Nz4CFxYWFScmJicmBgcHBhcWFgHoYZwYqw+FymqHu1gOBROQ6IyqzKkCcmGNuxcDBgQHdoICdV8BZqheAwKJ9ZkynPaJBATcqQFqgwQD2MIaQER1iAD///+l/kUD7AQ6AgYAXQAA////xAAAA/QEOgIGAFwAAP//AEX/6gPgBccCJgBJAAABBwBqAIoAAAAMALAIL7A13LAg0DAx//8ALQAAA4MF6gImAOsAAAEHAHUAz//sABMAsABFWLAFLxuxBRg+WbAI3DAxAP//AC7/6QO2BFACBgBXAAD//wAvAAAB4wXHAgYATQAA//8ALgAAArgFxgImAIwAAAEHAGr/Zv//AAwAsAIvsBncsATQMDH///8U/kYB1QXHAgYATgAA//8ALwAABFcF6QImAPAAAAEHAHUBOf/rABMAsABFWLAILxuxCBg+WbAP3DAxAP///6X+RQPsBdkCJgBdAAABBgCgWQEAEwCwAEVYsA8vG7EPGD5ZsBPcMDEA//8AwwAAB0EHNAImADsAAAEHAEQCTAE2ABMAsABFWLAELxuxBBw+WbAU3DAxAP//AIAAAAX+Bf4CJgBbAAABBwBEAYsAAAATALAARViwCy8bsQsYPlmwDtwwMQD//wDDAAAHQQc0AiYAOwAAAQcAdQLWATYAEwCwAEVYsAQvG7EEHD5ZsBXcMDEA//8AgAAABf4F/gImAFsAAAEHAHUCFQAAABMAsABFWLAMLxuxDBg+WbAP3DAxAP//AMMAAAdBBv0CJgA7AAABBwBqAhYBNgAWALAARViwAy8bsQMcPlmwHNywKNAwMf//AIAAAAX+BccCJgBbAAABBwBqAVUAAAAWALAARViwCy8bsQsYPlmwFtywItAwMf//AKgAAAUyBzQCJgA9AAABBwBEATMBNgATALAARViwCC8bsQgcPlmwCtwwMQD///+l/kUD7AX+AiYAXQAAAQcARACUAAAAEwCwAEVYsA8vG7EPGD5ZsBHcMDEA//8AqgQhAYkGAAIGAAsAAP//AMgEEQKmBggCBgAGAAD//wBD//ID/QWwACYABQAAAAcABQIJAAD///8J/kYCxwXaAiYAmwAAAQcAnv9H/9kAEwCwAEVYsAwvG7EMGD5ZsBLcMDEA//8AiQQWAeAGAAIGAW0AAP//ADsAAAa3BzQCJgAxAAABBwB1AsYBNgATALAARViwAi8bsQIcPlmwEdwwMQD//wAeAAAGagX+AiYAUQAAAQcAdQKkAAAAEwCwAEVYsAMvG7EDGD5ZsCPcMDEA////r/5qBIsFsAImACUAAAAHAKYBdAAA//8AM/5qA88EUQImAEUAAAAHAKYAwQAA//8AOwAABLEHQAImACkAAAEHAEQBNwFCABMAsABFWLAGLxuxBhw+WbAN3DAxAP//AEMAAAVuB0ACJgDbAAABBwBEAaYBQgATALAARViwCC8bsQgcPlmwC9wwMQD//wBF/+oD4AX+AiYASQAAAQcARADAAAAAEwCwAEVYsAgvG7EIGD5ZsCHcMDEA//8ALwAABDcF6gImAO8AAAEHAEQA4P/sABMAsABFWLAILxuxCBg+WbAL3DAxAP//AIYAAAWdBbACBgC4AAD//wBP/igFTwQ8AgYAzAAA//8ArQAABUsG6AImARgAAAEHAKsERAD6ABYAsABFWLAPLxuxDxw+WbAR3LAV0DAx//8AhAAABDwFwQImARkAAAEHAKsDrv/TABYAsABFWLAQLxuxEBg+WbAS3LAW0DAx//8ARf5FCGMEUgAmAFMAAAAHAF0EdwAA//8Ad/5FCUwFyAAmADMAAAAHAF0FYAAA//8AJf5RBJgFxwImANoAAAAHAbABg/+4//8AIf5SA6oEUAImAO4AAAAHAbABLf+5//8AdP5RBPkFyQImACcAAAAHAbAByv+4//8ARv5RA+YEUgImAEcAAAAHAbABRv+4//8AqAAABTIFsAIGAD0AAP//AIT+YAQaBDoCBgC8AAD//wBJAAACAQWwAgYALQAA////rAAAB3UHGwImANkAAAEHAKACLAFDABMAsABFWLANLxuxDRw+WbAZ3DAxAP///6UAAAYOBcUCJgDtAAABBwCgAVz/7QATALAARViwDS8bsQ0YPlmwGdwwMQD//wBJAAACAQWwAgYALQAA////rwAABIsHDwImACUAAAEHAKABLgE3ABMAsABFWLAELxuxBBw+WbAO3DAxAP//ADP/6APsBdkCJgBFAAABBwCgAKAAAQATALAARViwGC8bsRgYPlmwL9wwMQD///+vAAAEiwb9AiYAJQAAAQcAagEzATYAFgCwAEVYsAQvG7EEHD5ZsBTcsCDQMDH//wAz/+gD9wXHAiYARQAAAQcAagClAAAADACwGC+wQdywLNAwMf///4QAAAd4BbACBgCBAAD//wAT/+gGYQRSAgYAhgAA//8AOwAABLEHGwImACkAAAEHAKAA/AFDAAkAsAYvsA/cMDEA//8ARf/qA+AF2QImAEkAAAEHAKAAhQABAAkAsAgvsCPcMDEA//8AUf/pBSoG2wImAUUAAAEHAGoBCAEUAAwAsAAvsDrcsCXQMDH//wA+/+kD3wROAgYAnAAA//8APv/pA+EFyAImAJwAAAEHAGoAjwABAAwAsAAvsDjcsCPQMDH///+sAAAHdQcJAiYA2QAAAQcAagIxAUIADACwCS+wK9ywFtAwMf///6UAAAYOBbMCJgDtAAABBwBqAWH/7AAMALAJL7Ar3LAW0DAx//8AJf/qBJgHHgImANoAAAEHAGoA+AFXAAwAsA0vsEDcsCvQMDH//wAh/+oDuQXHAiYA7gAAAQYAamcAAAwAsA0vsD3csCjQMDH//wBDAAAFbgb6AiYA2wAAAQcAcAFBAUoACQCwAC+wCtwwMQD//wAvAAAENwWkAiYA7wAAAQYAcHv0AAkAsAAvsArcMDEA//8AQwAABW4HCQImANsAAAEHAGoBcAFCAAwAsAAvsB/csArQMDH//wAvAAAENwWzAiYA7wAAAQcAagCq/+wADACwAC+wH9ywCtAwMf//AHf/5wUNBv8CJgAzAAABBwBqAVQBOAAMALAKL7A43LAj0DAx//8ARf/oBB8FxwImAFMAAAEHAGoAkwAAAAwAsAAvsDjcsCPQMDH//wBp/+kE/AXIAgYBFgAA//8AQv/nBCAEUwIGARcAAP//AGn/6QT8BwQCJgEWAAABBwBqAWABPQAMALAJL7A63LAl0DAx//8AQv/nBCAFyQImARcAAAEHAGoAkAACAAwAsAQvsDXcsCDQMDH//wB0/+kE/AcfAiYA5gAAAQcAagFMAVgADACwFS+wONywI9AwMf//ADT/5wPWBccCJgD+AAABBwBqAIQAAAAMALAIL7A33LAi0DAx//8Ak//mBUAG+gImAN0AAAEHAHAA7AFKAAkAsAEvsBHcMDEA////pf5FA+wFuAImAF0AAAEGAHAvCAAJALABL7AQ3DAxAP//AJP/5gVABwkCJgDdAAABBwBqARsBQgAMALABL7Am3LAR0DAx////pf5FA+wFxwImAF0AAAEGAGpeAAAMALABL7Al3LAQ0DAx//8Ak//mBUAHQQImAN0AAAEHAKUBXQFCABYAsABFWLABLxuxARw+WbAT3LAX0DAx////pf5FBF4F/wImAF0AAAEHAKUAoAAAABYAsABFWLABLxuxARg+WbAS3LAW0DAx//8AzgAABUQHCQImAOAAAAEHAGoBRAFCABYAsABFWLASLxuxEhw+WbAo3LAc0DAx//8AewAABAAFswImAPgAAAEGAGpp7AAMALAIL7Ao3LAT0DAx//8ARQAABpYHCQAmAOUPAAAnAC0ElQAAAQcAagIIAUIAFgCwAEVYsAovG7EKHD5ZsCHcsC3QMDH//wAwAAAFqQWzACYA/QAAACcAjAQKAAABBwBqAWr/7AAWALAARViwCi8bsQoYPlmwIdywLdAwMf///9T+RQUrBbACJgA8AAAABwGvA5UAAP///8T+RQP0BDoCJgBcAAAABwGvAqoAAP//AEv/6AR1BgACBgBIAAD////K/kUFZQWwAiYA3AAAAAcBrwQkAAD////I/kUESgQ6AiYA8QAAAAcBrwM7AAD///+v/p8EiwWwAiYAJQAAAAcArATcAAD//wAz/p8DzwRRAiYARQAAAAcArAQpAAD///+vAAAEiwe5AiYAJQAAAQcAqgUBAUYACQCwBC+wGNwwMQD//wAz/+gDzwaDAiYARQAAAQcAqgRzABAACQCwGC+wOdwwMQD///+vAAAF7QfDAiYAJQAAAQcBtwDyAS4AFgCwAEVYsAUvG7EFHD5ZsA7csBTQMDH//wAz/+gFXwaOAiYARQAAAQYBt2T5ABYAsABFWLAYLxuxGBg+WbAv3LA10DAx////rwAABIsHvwImACUAAAEHAbYA+AE9ABYAsABFWLAFLxuxBRw+WbAM3LAT0DAx//8AM//oA/0GiQImAEUAAAEGAbZqBwAWALAARViwGC8bsRgYPlmwL9ywNNAwMf///68AAAVsB+oCJgAlAAABBwG1APMBGwAWALAARViwBS8bsQUcPlmwDNywINAwMf//ADP/6ATeBrUCJgBFAAABBgG1ZeYAFgCwAEVYsBgvG7EYGD5ZsC/csDPQMDH///+vAAAEiwfZAiYAJQAAAQcBtADvAQYAFgCwAEVYsAQvG7EEHD5ZsA7csBXQMDH//wAz/+gD9wakAiYARQAAAQYBtGHRABYAsABFWLAYLxuxGBg+WbAt3LA20DAx////r/6fBIsHNgImACUAAAAnAJ0A+QE2AQcArATcAAAAEwCwAEVYsAQvG7EEHD5ZsBDcMDEA//8AM/6fA88GAAImAEUAAAAmAJ1rAAEHAKwEKQAAABMAsABFWLAYLxuxGBg+WbAx3DAxAP///68AAASLB7cCJgAlAAABBwGzARcBLQAMALAEL7AO3LAa0DAx//8AM//oA+UGggImAEUAAAEHAbMAif/4AAwAsBgvsC/csDvQMDH///+vAAAEiwe3AiYAJQAAAQcBuAEXAS0ADACwBC+wDtywGtAwMf//ADP/6APlBoICJgBFAAABBwG4AIn/+AAMALAYL7Av3LA70DAx////rwAABIsIQAImACUAAAEHAbIBHgE9AAwAsAQvsA7csBfQMDH//wAz/+gD1QcKAiYARQAAAQcBsgCQAAcADACwGC+wL9ywONAwMf///68AAASSCBQCJgAlAAABBwGxAR8BRQAMALAEL7AO3LAX0DAx//8AM//oBAQG3gImAEUAAAEHAbEAkQAPAAwAsBgvsC/csDjQMDH///+v/p8EiwcPAiYAJQAAACcAoAEuATcBBwCsBNwAAAATALAARViwBC8bsQQcPlmwDtwwMQD//wAz/p8D7AXZAiYARQAAACcAoACgAAEBBwCsBCkAAAATALAARViwGC8bsRgYPlmwL9wwMQD//wA7/qkEsQWwAiYAKQAAAAcArASdAAr//wBF/p8D4ARRAiYASQAAAAcArAR0AAD//wA7AAAEsQfFAiYAKQAAAQcAqgTPAVIACQCwBi+wGdwwMQD//wBF/+oD4AaDAiYASQAAAQcAqgRYABAACQCwCC+wLdwwMQD//wA7AAAEsQctAiYAKQAAAQcApADPAUYACQCwBi+wFtwwMQD//wBF/+oEBgXrAiYASQAAAQYApFgEAAkAsAgvsCrcMDEA//8AOwAABbsHzwImACkAAAEHAbcAwAE6ABYAsABFWLAGLxuxBhw+WbAR3LAV0DAx//8ARf/qBUQGjgImAEkAAAEGAbdJ+QAWALAARViwCC8bsQgYPlmwI9ywKdAwMf//ADsAAASxB8sCJgApAAABBwG2AMYBSQAWALAARViwBi8bsQYcPlmwD9ywFNAwMf//AEX/6gPiBokCJgBJAAABBgG2TwcAFgCwAEVYsAgvG7EIGD5ZsCPcsCjQMDH//wA7AAAFOgf2AiYAKQAAAQcBtQDBAScAFgCwAEVYsAYvG7EGHD5ZsA/csCHQMDH//wBF/+oEwwa1AiYASQAAAQYBtUrmABYAsABFWLAILxuxCBg+WbAh3LA10DAx//8AOwAABLEH5QImACkAAAEHAbQAvQESABYAsABFWLAGLxuxBhw+WbAP3LAW0DAx//8ARf/qA+AGpAImAEkAAAEGAbRG0QAWALAARViwCC8bsQgYPlmwI9ywKtAwMf//ADv+qQSxB0ICJgApAAAAJwCdAMcBQgEHAKwEnQAKABMAsABFWLAGLxuxBhw+WbAR3DAxAP//AEX+nwPgBgACJgBJAAAAJgCdUAABBwCsBHQAAAATALAARViwCC8bsQgYPlmwJdwwMQD//wBJAAACuwfFAiYALQAAAQcAqgOFAVIACQCwAi+wEdwwMQD//wAuAAACaQaBAiYAjAAAAQcAqgMzAA4ACQCwAi+wEdwwMQD//wAO/qgCAQWwAiYALQAAAAcArANTAAn////x/qkB4wXHAiYATQAAAAcArAM2AAr//wB3/p8FDQXIAiYAMwAAAAcArATxAAD//wBF/p8EHwRSAiYAUwAAAAcArASEAAD//wB3/+cFDQe7AiYAMwAAAQcAqgUiAUgACQCwCi+wMNwwMQD//wBF/+gEHwaDAiYAUwAAAQcAqgRhABAACQCwAC+wMNwwMQD//wB3/+cGDgfFAiYAMwAAAQcBtwETATAAFgCwAEVYsAovG7EKHD5ZsCbcsCzQMDH//wBF/+gFTQaOAiYAUwAAAQYBt1L5ABYAsABFWLAALxuxABg+WbAm3LAs0DAx//8Ad//nBQ0HwQImADMAAAEHAbYBGQE/ABYAsABFWLAKLxuxChw+WbAm3LAr0DAx//8ARf/oBB8GiQImAFMAAAEGAbZYBwAWALAARViwAC8bsQAYPlmwJtywK9AwMf//AHf/5wWNB+wCJgAzAAABBwG1ARQBHQAWALAARViwCi8bsQocPlmwJtywKtAwMf//AEX/6ATMBrUCJgBTAAABBgG1U+YAFgCwAEVYsAAvG7EAGD5ZsCTcsDjQMDH//wB3/+cFDQfbAiYAMwAAAQcBtAEQAQgAFgCwAEVYsAovG7EKHD5ZsCTcsC3QMDH//wBF/+gEHwakAiYAUwAAAQYBtE/RABYAsABFWLAALxuxABg+WbAk3LAt0DAx//8Ad/6fBQ0HOAImADMAAAAnAJ0BGgE4AQcArATxAAAAEwCwAEVYsAovG7EKHD5ZsCjcMDEA//8ARf6fBB8GAAImAFMAAAAmAJ1ZAAEHAKwEhAAAABMAsABFWLAALxuxABg+WbAo3DAxAP//AGf/6QYbBy8CJgCXAAABBwB1Ag8BMQATALAARViwCi8bsQocPlmwK9wwMQD//wBC/+cE/wX+AiYAmAAAAQcAdQFmAAAAEwCwAEVYsAAvG7EAGD5ZsCjcMDEA//8AZ//pBhsHLwImAJcAAAEHAEQBhQExABMAsABFWLAKLxuxChw+WbAq3DAxAP//AEL/5wT/Bf4CJgCYAAABBwBEANwAAAATALAARViwAC8bsQAYPlmwJ9wwMQD//wBn/+kGGwe0AiYAlwAAAQcAqgUdAUEAEwCwAEVYsAovG7EKHD5ZsCncMDEA//8AQv/nBP8GgwImAJgAAAEHAKoEdAAQABMAsABFWLAALxuxABg+WbAm3DAxAP//AGf/6QYbBxwCJgCXAAABBwCkAR0BNQATALAARViwCi8bsQocPlmwLNwwMQD//wBC/+cE/wXrAiYAmAAAAQYApHQEABMAsABFWLAALxuxABg+WbAp3DAxAP//AGf+nwYbBjcCJgCXAAAABwCsBOMAAP//AEL+lgT/BLACJgCYAAAABwCsBHb/9///AGf+nwUgBbACJgA5AAAABwCsBMgAAP//AFv+nwQeBDoCJgBZAAAABwCsBDAAAP//AGf/5wUgB7kCJgA5AAABBwCqBPwBRgAJALAAL7Ag3DAxAP//AFv/6AQeBoMCJgBZAAABBwCqBGUAEAAJALAGL7Ah3DAxAP//AGf/6AaaB0ACJgCZAAABBwB1AgkBQgATALAARViwGi8bsRocPlmwHdwwMQD//wBa/+gFTgXqAiYAmgAAAQcAdQFg/+wAEwCwAEVYsBYvG7EWGD5ZsB7cMDEA//8AZ//oBpoHQAImAJkAAAEHAEQBfwFCABMAsABFWLASLxuxEhw+WbAc3DAxAP//AFr/6AVOBeoCJgCaAAABBwBEANb/7AATALAARViwDS8bsQ0YPlmwHdwwMQD//wBn/+gGmgfFAiYAmQAAAQcAqgUXAVIAEwCwAEVYsBovG7EaHD5ZsCjcMDEA//8AWv/oBU4GbwImAJoAAAEHAKoEbv/8ABMAsABFWLANLxuxDRg+WbAc3DAxAP//AGf/6AaaBy0CJgCZAAABBwCkARcBRgATALAARViwGi8bsRocPlmwHtwwMQD//wBa/+gFTgXXAiYAmgAAAQYApG7wABMAsABFWLAWLxuxFhg+WbAf3DAxAP//AGf+lwaaBgICJgCZAAAABwCsBOH/+P//AFr+nwVOBJECJgCaAAAABwCsBDYAAP//AKj+nwUyBbACJgA9AAAABwCsBJcAAP///6X+AgPsBDoCJgBdAAAABwCsBNr/Y///AKgAAAUyB7kCJgA9AAABBwCqBMsBRgAJALABL7AW3DAxAP///6X+RQPsBoMCJgBdAAABBwCqBCwAEAAJALABL7Ad3DAxAP//AKgAAAUyByECJgA9AAABBwCkAMsBOgAJALABL7AT3DAxAP///6X+RQPsBesCJgBdAAABBgCkLAQACQCwAS+wGtwwMQAAAgBL/+gFEQYAABkAJQB8ALAWL7AARViwDy8bsQ8YPlmwAEVYsAMvG7EDED5ZsABFWLAGLxuxBhA+WbIPFgFdsi8WAV2yFAMWERI5sBQvsBjQsgEBCitYIdgb9FmyBAYPERI5shEPBhESObAS0LAGELIdAQorWCHYG/RZsA8QsiIBCitYIdgb9FkwMQEjAyM3BicmJicmNzYSNhcWFxMjNzM3MwczAQYWFxY3EyYnJgYGBPa11qUTgLyWsgcDCBSO0H21YTD8G/0ctRq2+/ADbGidelY8nmujVQTS+y50jAQE4787UqUBCoQDBIABB5eXl/xOj54CB6UB9JQEA4fz//8AAP7NBREGAAAmAEgAAAAnAd4B+QJHAAcAQwB//2T//wBE/pgFagWwAiYB4wAAAAcBsAQC/////wAv/pkEVwQ6AiYA8AAAAAcBsANGAAD//wA7/pkFdwWwAiYALAAAAAcBsARlAAD//wAv/pkENgQ6AiYA8wAAAAcBsANmAAD//wCo/pkFCQWwAiYAOAAAAAcBsAItAAD//wBg/pkD6AQ6AiYA9QAAAAcBsAG4AAD////U/pkFKwWwAiYAPAAAAAcBsAPDAAD////E/pkD9AQ6AiYAXAAAAAcBsALYAAD//wDO/pkFRAWwAiYA4AAAAAcBsAQkAAD//wB7/pkEAAQ7AiYA+AAAAAcBsAMkAAD//wDO/pkFRAWwAiYA4AAAAAcBsALnAAD//wB7/pkEAAQ7AiYA+AAAAAcBsAHmAAD//wBD/pkEpQWwAiYAsAAAAAcBsADnAAD//wAt/pkDgwQ6AiYA6wAAAAcBsADOAAD///+s/pkHdQWwAiYA2QAAAAcBsAYwAAD///+l/pkGDgQ6AiYA7QAAAAcBsAT0AAD//wCK/lUFxQXIAiYBPwAAAAcBsALj/7z//wAH/lkERwRTAiYBQAAAAAcBsAHn/8D//wAfAAAD4wYAAgYATAAAAAIAKwAABIEFsAASABsAbrIVHB0REjmwFRCwANAAsABFWLAPLxuxDxw+WbAARViwCS8bsQkQPlmyDg8JERI5sA4vsgsBCitYIdgb9FmwANCyAg8JERI5sAIvsA4QsBHQsAIQshMBCitYIdgb9FmwCRCyFAEKK1gh2Bv0WTAxASMHBRYWBwYEIyETIzczNzMHMwEDBTI2NzYmJwKV5CoBNtjsERD+2On957/KG8kjvCPl/rxgAUqNwBEOfHwEUPIBAeK/x/QEUJfJyf3Z/d0BnoN2iAQAAgArAAAEgQWwABIAGwBxshUcHRESObAVELAA0ACwAEVYsBAvG7EQHD5ZsABFWLAJLxuxCRA+WbISEAkREjmwEi+yAAEKK1gh2Bv0WbIDEAkREjmwAy+wABCwC9CwEhCwDdCwCRCyFQEKK1gh2Bv0WbADELIbAQorWCHYG/RZMDEBIwcFFhYHBgQjIRMjNzM3MwczAQMFMjY3NiYnApXkKgE22OwREP7Y6f3nv8obySO8I+X+vGABSo3AEQ58fARQ8gEB4r/H9ARQl8nJ/dn93QGeg3aIBAAAAQAQAAAEpQWwAA0AULILDg8REjkAsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASEDIxMjNzMTIQchAyECev78dr13qhupbANlHP1YUQEFAqz9VAKslwJtnv4xAAAB/+YAAAODBDoADQBQsgsODxESOQCwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbINCAIREjmwDS+yAAEKK1gh2Bv0WbAE0LANELAG0LAIELIKAQorWCHYG/RZMDEBIQMjEyM3MxMhByEDIQJQ/uZTtlOaG5lPApoc/h00ARsB3/4hAd+XAcSZ/tUAAAEAWAAABX4FsAAUAG0AsABFWLASLxuxEhw+WbAARViwBC8bsQQcPlmwAEVYsAsvG7ELED5ZsABFWLAILxuxCBA+WbITEgsREjmwEy+wENCyDQEKK1gh2Bv0WbAB0LALELAC0LACL7IKAQorWCHYG/RZsgYKAhESOTAxASMDMwEzAQEjASMDIxMjNzM3MwczAsf4LokCXff9YQG81v5ysnG8u7YbtSi7J/kEN/73AoL9Nf0bAo79cgQ3l+LiAAABADkAAAQyBgAAFABmALARL7AARViwBC8bsQQYPlmwAEVYsAsvG7ELED5ZsABFWLAILxuxCBA+WbIQEQsREjmwEC+wE9CyAQEKK1gh2Bv0WbALELAC0LACL7IKAQorWCHYG/RZsgYKAhESObABELAN0DAxASMDMwEzAQEjASMDIxMjNzM3MwczAqnoYXIBfOT+MgE3yP71gle2080bzR21HegEwf3NAaz+Cv28AfX+CwTBl6io//8AQ/6aBW4HGwImANsAAAAnAKABawFDAQcAEARQ/70AEwCwAEVYsAgvG7EIHD5ZsA3cMDEA//8AL/6aBEUFxQImAO8AAAAnAKAApf/tAQcAEANb/70AEwCwAEVYsAgvG7EIGD5ZsA3cMDEA//8AO/6aBXcFsAImACwAAAAHABAEWf+9//8AL/6aBEQEOgImAPMAAAAHABADWv+9//8AO/6aBrcFsAImADEAAAAHABAFjP+9//8AMP6aBYsEOgImAPIAAAAHABAEof+9////yv6aBWUFsAImANwAAAAHABAERv+9////yP6aBEcEOgImAPEAAAAHABADXf+9AAEAqAAABTIFsAAOAFayCg8QERI5ALAARViwCC8bsQgcPlmwAEVYsAsvG7ELHD5ZsABFWLACLxuxAhA+WbIGAggREjmwBi+yBQEKK1gh2Bv0WbAA0LIKCAIREjmwBhCwDtAwMQEjAyMTIzczATMTATMBMwN82Vu7WtUblf7mzO8B7+D91ZACCf33AgmXAxD9JgLa/PAAAAEAXf5gBBoEOgAOAGOyAQ8QERI5ALAARViwCS8bsQkYPlmwAEVYsAsvG7ELGD5ZsABFWLADLxuxAxI+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgYBCitYIdgb9FmyCgsAERI5sA3QsA7QMDEFIwMjEyM3MwMzEwEzATMCx99GtUbWG72xsYkBnMD+Cr4L/msBlZcDrvzcAyT8UgAB/9QAAAUrBbAAEQBiALAARViwDC8bsQwcPlmwAEVYsA4vG7EOHD5ZsABFWLAFLxuxBRA+WbAARViwAy8bsQMQPlmyCQwFERI5fLAJLxiwENCyAAEKK1gh2Bv0WbIEBQwREjmwCNCyDQwFERI5MDEBIwEjAQEjASM3MwEzEwEzATMDsaQBOtP+/v5K6AIKlxuR/trQ/QGp6P4TjgKe/WICN/3JAp6XAnv90wIt/YUAAAH/xAAAA/QEOgARAGoAsABFWLAMLxuxDBg+WbAARViwDi8bsQ4YPlmwAEVYsAUvG7EFED5ZsABFWLADLxuxAxA+WbIJBQwREjl8sAkvGLIIAQorWCHYG/RZsAHQsgQFDBESObINDAUREjmwCRCwEdB8sBEvGDAxASMTIwMBIwEjNzMDMxMBMwEzAw+x7MWz/s/dAYKhG57bxqcBJt7+mZ0B4f4fAZT+bAHhlwHC/nYBiv4+//8AKf/nA+UETQIGAL4AAP///9cAAASkBbACJgAqAAAABwHe/0T+f///AJkCiwXXAyIARgGXiABmZkAA//8AFwAABCsFxwIGABYAAP//ADT/6AQhBccCBgAXAAD//wAFAAAEHQWwAgYAGAAA//8Acv/nBGoFsAIGABkAAP//AJT//gQTBcgABgAdAAD//wB8/+cEPwXJAAYAFBQA//8Aef/qBQYHVQImACsAAAEHAHUB9wFXABMAsABFWLAMLxuxDBw+WbAk3DAxAP//AAT+TwQoBf4CJgBLAAABBwB1AU0AAAATALAARViwBC8bsQQYPlmwLNwwMQD//wA7AAAFdwc0AiYAMgAAAQcARAGdATYAEwCwAEVYsAYvG7EGHD5ZsAvcMDEA//8AHwAAA+MF/gImAFIAAAEHAEQA0gAAABMAsABFWLADLxuxAxg+WbAU3DAxAP///68AAASLByACJgAlAAABBwCrBIABMgAWALAARViwBC8bsQQcPlmwDNywENAwMf//ADP/6APPBesCJgBFAAABBwCrA/L//QAWALAARViwGC8bsRgYPlmwLdywMdAwMf//ADsAAASxBywCJgApAAABBwCrBE4BPgAWALAARViwBi8bsQYcPlmwDdywEdAwMf//AEX/6gPgBesCJgBJAAABBwCrA9f//QAWALAARViwCC8bsQgYPlmwIdywJdAwMf///98AAAKKBywCJgAtAAABBwCrAwQBPgAWALAARViwAi8bsQIcPlmwBdywCdAwMf///40AAAI4BekCJgCMAAABBwCrArL/+wAWALAARViwAi8bsQIYPlmwBdywCdAwMf//AHf/5wUNByICJgAzAAABBwCrBKEBNAAWALAARViwCi8bsQocPlmwJNywKNAwMf//AEX/6AQfBesCJgBTAAABBwCrA+D//QAWALAARViwAC8bsQAYPlmwJNywKNAwMf//ADoAAATCByACJgA2AAABBwCrBEMBMgAWALAARViwBC8bsQQcPlmwGdywHdAwMf//AB8AAALUBesCJgBWAAABBwCrA0n//QAWALAARViwCi8bsQoYPlmwEtywDdAwMf//AGf/5wUgByACJgA5AAABBwCrBHsBMgAWALAARViwCi8bsQocPlmwFNywGNAwMf//AFv/6AQeBesCJgBZAAABBwCrA+T//QAWALAARViwBy8bsQcYPlmwFdywGdAwMf///7IAAAU8Bj8AJgDPZAAABwCt/pEAAP//ADv+qQSgBbACJgAmAAAABwCsBJgACv//AB/+lgP+BgACJgBGAAAABwCsBIb/9///ADv+qQTVBbACJgAoAAAABwCsBJcACv//AEv+nwR1BgACJgBIAAAABwCsBJkAAP//ADv+CQTVBbACJgAoAAAABwGiAR/+qv//AEv9/wR1BgACJgBIAAAABwGiASH+oP//ADv+qQV3BbACJgAsAAAABwCsBPoACv//AB/+qQPjBgACJgBMAAAABwCsBH8ACv//ADsAAAVQBy4CJgAvAAABBwB1AbABMAATALAARViwBS8bsQUcPlmwDtwwMQD//wAgAAAEIgc/AiYATwAAAQcAdQF9AUEACQCwBS+wD9wwMQD//wA7/vgFUAWwAiYALwAAAAcArATSAFn//wAg/uUEGgYAAiYATwAAAAcArARQAEb//wA7/qkDsQWwAiYAMAAAAAcArASdAAr////y/qkB7gYAAiYAUAAAAAcArAM3AAr//wA7/qkGtwWwAiYAMQAAAAcArAWnAAr//wAe/qkGagRSAiYAUQAAAAcArAWrAAr//wA7/qkFdwWwAiYAMgAAAAcArAT+AAr//wAf/qkD4wRSAiYAUgAAAAcArARmAAr//wA7AAAE8wdAAiYANAAAAQcAdQG0AUIAEwCwAEVYsAMvG7EDHD5ZsBbcMDEA////1/5gBDYF9QImAFQAAAEHAHUBkf/3ABMAsABFWLANLxuxDRg+WbAh3DAxAP//ADr+qQTCBbACJgA2AAAABwCsBJUACv///+7+qQLUBFQCJgBWAAAABwCsAzMACv//ACf+nwSjBccCJgA3AAAABwCsBKQAAP//AC7+lwO2BFACJgBXAAAABwCsBG3/+P//AKj+nwUJBbACJgA4AAAABwCsBJYAAP//AEP+nwKUBUACJgBYAAAABwCsA/oAAP//AKQAAAVhBy0CJgA6AAABBwCkAOEBRgATALAARViwAS8bsQEcPlmwCtwwMQD//wBuAAAD7QXiAiYAWgAAAQYApBv7ABMAsABFWLABLxuxARg+WbAK3DAxAP//AKT+qQVhBbACJgA6AAAABwCsBMoACv//AG7+qQPtBDoCJgBaAAAABwCsBDgACv//AMP+qQdBBbACJgA7AAAABwCsBc0ACv//AID+qQX+BDoCJgBbAAAABwCsBSwACv///+v+qQTOBbACJgA+AAAABwCsBJgACv///+3+qQPOBDoCJgBeAAAABwCsBEIACv///wz/5wVTBdYAJgAzRgAABwFa/hoAAP///6UAAAPjBRwCJgG6AAAABwCt/6v+3f///+EAAAQrBR8AJgG+PAAABwCt/sD+4P////0AAATWBRwAJgHBPAAABwCt/tz+3f//AAEAAAHmBR4AJgHCPAAABwCt/uD+3///AB3/6gRYBRwAJgHICgAABwCt/vz+3f///5sAAAShBRwAJgHSPAAABwCt/nr+3f//ABYAAAR0BRsAJgHzCgAABwCt/xT+3P///6UAAAPjBI0CBgG6AAD//wAdAAAD5wSNAgYBuwAA//8AHQAAA+8EjQIGAb4AAP///9wAAAQOBI0CBgHTAAD//wAdAAAEmgSNAgYBwQAA//8AKgAAAaoEjQIGAcIAAP//AB0AAAR/BI0CBgHEAAD//wAdAAAFsASNAgYBxgAA//8ASv/qBE4EowIGAcgAAP//AB0AAAQpBI0CBgHJAAD//wBtAAAEQgSNAgYBzQAA//8AdAAABGUEjQIGAdIAAP///7YAAARtBI0CBgHRAAD//wAqAAACtgXlAiYBwgAAAQcAav9kAB4AFgCwAEVYsAIvG7ECGj5ZsA3csBnQMDH//wB0AAAEZQXlAiYB0gAAAQYAanoeABYAsABFWLAILxuxCBo+WbAS3LAe0DAx//8AHQAAA+8F5QImAb4AAAEGAGp+HgAWALAARViwBi8bsQYaPlmwFdywIdAwMf//AB0AAAPgBhwCJgHqAAABBwB1ATsAHgATALAARViwBS8bsQUaPlmwCNwwMQD//wAR/+sD7QSdAgYBzAAA//8AKgAAAaoEjQIGAcIAAP//ACoAAAK2BeUCJgHCAAABBwBq/2QAHgAWALAARViwAi8bsQIaPlmwDdywGdAwMf////b/6wObBI0CBgHDAAD//wAdAAAEfwYcAiYBxAAAAQcAdQEtAB4AEwCwAEVYsAgvG7EIGj5ZsA/cMDEA//8AWP/oBFQF9wImAgEAAAEGAKB0HwATALAARViwAi8bsQIaPlmwFdwwMQD///+lAAAD4wSNAgYBugAA//8AHQAAA+cEjQIGAbsAAP//AB0AAAPNBI0CBgHqAAD//wAdAAAD7wSNAgYBvgAA//8AHwAABKEF9wImAf4AAAEHAKAA1AAfABMAsABFWLAILxuxCBo+WbAN3DAxAP//AB0AAAWwBI0CBgHGAAD//wAdAAAEmgSNAgYBwQAA//8ASv/qBE4EowIGAcgAAP//AB0AAASGBI0CBgHvAAD//wAdAAAEKQSNAgYByQAA//8AR//sBDcEowIGAbwAAP//AG0AAARCBI0CBgHNAAD///+2AAAEbQSNAgYB0QAAAAEAEf5QA94EoAAqAIYAsABFWLAPLxuxDxo+WbAARViwHS8bsR0QPlmwAEVYsBsvG7EbEj5ZsA8QsgcBCitYIdgb9FmwDxCwDNCyKh0PERI5fLAqLxi0YCpwKgJdsqAqAV20YCpwKgJxsikBCitYIdgb9FmyFCkqERI5sB0QsBrQsCHQsBoQsiMBCitYIdgb9FkwMQEyNjc2JyYnJgcGBwc2NhcWFgcGBxYWBwYGBwMjEyYmNzMUFxY2NzYlJzcCAX+SCgcZM5ZrRUMRthD7t77XCgryVWAFCOS8SLZKi5AFstmBqQsY/vuEGwKfYVc2JU0EAi0sUQGWsAIDpo24YiGGXZG4D/5eAawcqn+xBQNmW7wCAZgAAQAd/pkEmgSNAA8AcgCwAS+wAEVYsAkvG7EJGj5ZsABFWLAMLxuxDBo+WbAARViwBi8bsQYQPlmwAEVYsAIvG7ECED5ZsgoGCRESOXywCi8YtGAKcAoCcbKgCgFdtGAKcAoCXbIFAQorWCHYG/RZsAIQsg4BCitYIdgb9FkwMQEjEyMTIQMjEzMDIRMzAzMELrY+m1b9uFe1y7RZAkhatbGe/pkBZwHy/g4Ejf39AgP8DAAAAQBI/lYEPwSjAB4AWACwAEVYsA0vG7ENGj5ZsABFWLADLxuxAxA+WbAARViwBC8bsQQSPlmwAxCwBtCwDRCwEdCwDRCyFAEKK1gh2Bv0WbADELIcAQorWCHYG/RZsAMQsB7QMDEBBgYHAyMTJgI3NxIAFxYWFyMmJicmBgcGFxYWFxY3A+4f7KxHtkqdnxgMJQE54LjVCLMFbXiTyh8bBgV2bPtMAXqp0Q7+ZAGpKAEmxlgBCAEwBgTVtnKCBAXKtp5jdYsECvwA//8AdAAABGUEjQIGAdIAAP//AC/+UQVhBKECJgIXAAAABwGwApv/uP//AB8AAAShBdYCJgH+AAABBwBwAKoAJgATALAARViwCC8bsQgaPlmwC9wwMQD//wBY/+gEVAXWAiYCAQAAAQYAcEomABMAsABFWLARLxuxERo+WbAT3DAxAP//AFEAAATzBI0CBgHxAAD///+v/k8EiwWwAiYAJQAAAAcAowFnAAD//wAz/k8DzwRRAiYARQAAAAcAowC0AAD//wA7/lkEsQWwAiYAKQAAAAcAowEoAAr//wBF/k8D4ARRAiYASQAAAAcAowD/AAAAAAAAAA0AogADAAEECQAAAF4AAAADAAEECQABAAwAXgADAAEECQACAAwAagADAAEECQADABoAdgADAAEECQAEABoAdgADAAEECQAFACwAkAADAAEECQAGABoAvAADAAEECQAHAEAA1gADAAEECQAJAAwBFgADAAEECQALABQBIgADAAEECQAMACYBNgADAAEECQANAFwBXAADAAEECQAOAFQBuABDAG8AcAB5AHIAaQBnAGgAdAAgADIAMAAxADEAIABHAG8AbwBnAGwAZQAgAEkAbgBjAC4AIABBAGwAbAAgAFIAaQBnAGgAdABzACAAUgBlAHMAZQByAHYAZQBkAC4AUgBvAGIAbwB0AG8ASQB0AGEAbABpAGMAUgBvAGIAbwB0AG8AIABJAHQAYQBsAGkAYwBWAGUAcgBzAGkAbwBuACAAMgAuADAAMAAxADEAMAAxADsAIAAyADAAMQA0AFIAbwBiAG8AdABvAC0ASQB0AGEAbABpAGMAUgBvAGIAbwB0AG8AIABpAHMAIABhACAAdAByAGEAZABlAG0AYQByAGsAIABvAGYAIABHAG8AbwBnAGwAZQAuAEcAbwBvAGcAbABlAEcAbwBvAGcAbABlAC4AYwBvAG0AQwBoAHIAaQBzAHQAaQBhAG4AIABSAG8AYgBlAHIAdABzAG8AbgBMAGkAYwBlAG4AcwBlAGQAIAB1AG4AZABlAHIAIAB0AGgAZQAgAEEAcABhAGMAaABlACAATABpAGMAZQBuAHMAZQAsACAAVgBlAHIAcwBpAG8AbgAgADIALgAwAGgAdAB0AHAAOgAvAC8AdwB3AHcALgBhAHAAYQBjAGgAZQAuAG8AcgBnAC8AbABpAGMAZQBuAHMAZQBzAC8ATABJAEMARQBOAFMARQAtADIALgAwAAAAAwAA//QAAP9qAGQAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAIACAAC//8ADwABAAAADAAAAAAAAAACAF4AJQA+AAEARQBeAAEAeQB5AAMAgQCBAAEAgwCDAAEAhgCGAAEAiQCJAAEAiwCVAAEAlwCcAAEAowCjAAMApwCsAAMAsACwAAEAuQC6AAEAvgC+AAEAwADAAAEAwgDCAAEAxgDGAAEAygDKAAEAzADNAAEAzwDQAAEA0gDSAAEA2QDdAAEA4ADgAAEA5ADkAAEA5gDoAAEA6gD6AAEA/AD8AAEA/gEAAAEBAgECAAEBBwEIAAEBFQEZAAEBGwEbAAEBHwEhAAEBIwEkAAMBOAE5AAEBPgFAAAEBRQFFAAEBTQFNAAEBTwFPAAEBUwFTAAEBVQFXAAEBWQFZAAEBogGiAAMBowGpAAIBugHTAAEB4gHiAAEB5AHkAAEB6gHqAAEB8wHzAAEB9QH1AAEB/AH+AAECAAIBAAECAwIDAAECBwIHAAECCQILAAECEQIRAAECFgIYAAECGgIaAAECPgJDAAECRwKvAAECsgNYAAEDWwNqAAEDcQNxAAEDcwN3AAEDegN/AAEDgQOEAAEDhgOKAAEDjAOnAAEDqwOrAAEDrQO0AAEDtgO4AAEDvQO/AAEDwQPNAAEDzwPZAAED3APsAAED7wRIAAEESwRLAAEETQRNAAEETwRQAAEEWwRbAAEEYgRkAAEEZgRmAAEEagRqAAEEbARtAAEEbwRvAAEEdwSGAAEEhwSHAAIEiASwAAEEsgTKAAEEzATQAAEE0gTVAAEE1wTZAAEE2wTcAAEE3gThAAEAAQAAAAoAXACaAARERkxUABpjeXJsAChncmVrADZsYXRuAEQABAAAAAD//wACAAAABAAEAAAAAP//AAIAAQAFAAQAAAAA//8AAgACAAYABAAAAAD//wACAAMABwAIY3BzcAAyY3BzcAAyY3BzcAAyY3BzcAAya2VybgA4a2VybgA4a2VybgA4a2VybgA4AAAAAQAAAAAAAQABAAIABgHYAAEAAAABAAgAAQAKAAUAJABIAAEA3gAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAkgCwALEAsgCzALQAtQC2ALcAuAC5ANEA0gDTANQA1QDWANcA2ADZANoA2wDcAN0A3gDfAOAA4QDiAOMA5ADlAOYA5wDoASwBMAEyATgBOgE8AT4BPwFFAUYBfwGFAYoBjQJHAkgCSgJMAk0CTgJPAlACUQJSAlMCVAJVAlYCVwJYAlkCWgJbAlwCXQJeAl8CYAJhAmICYwJkAmUCZgKDAoUChwKJAosCjQKPApECkwKVApcCmQKbAp0CnwKhAqMCpQKnAqkCqwKtAq8CsgK0ArYCuAK6ArwCvgLAAsICxQLHAskCywLNAs8C0QLTAtUC2QLbAt0C3wLhAuMC5QLnAukC6wLtAu8C8QLyAvQC9gNTA1QDVQNWA1cDWANZA1sDXANdA14DXwNgA2EDYgNkA2UDZgNnA2gDaQNqA3oDewN8A30DfgN/A4ADgQOCA4MDhAOFA4YDhwOIA4kDigOLA4wDjQOOA48DuwO9A78D1APaA+AESQRLBE8EVwRZBF4EagACAAAABAAOD84V8jViAAEDVAAEAAABpQrSCtIGggtwCoAK/g+aDAAGiA7uDu4MRg6gCiIO7g7uD5oKigaSDGYMRgrYCqwNUg8QCl4L4gsQDBYGmA22DbYNtgwgCxAKUAxMDbAMTAsQBqYN5gtwD5oLcAasBrIGvAbCBsgMTAbOBtgNtgb+BxQHKgcwB0YHTAdSB4QHigeQDcANwAe+Du4H4AgCDVIIMA7uDu4LJg7uDu4IRg3ADcAIeAiCCIwIpg1ICLgNsAjSCOgLEAkyCUwJaAloCxAJYgloCWgJaAtwDCAK2AxMCxAN5g1IDqAOoA1ICtIK0grSCtIK0gmKCbAJugnECeIJ9AoGChgK/g+aD5oPmg+aDGYLcAtwC3ALcAtwC3ALcAr+DAAMAAwADAAO7g7uDu4O7g7uD5oPmg+aD5oPmgxGDEYMRgxGDxAL4gviC+IL4gviC+IL4gwWDBYMFgwWDbYMIAwgDCAMIAwgDEwMTAtwC+ILcAviC3AL4gr+Cv4K/gr+D5oMAAwWDAAMFgwADBYMAAwWDAAMFg7uDbYO7g7uDu4O7g7uDEYOoAoiCiIKIgoiDu4Ntg7uDbYO7g22DbYPmgwgD5oMIA+aDCAKUApQClAMZgxmDGYMRgxGDEYMRgxGDEYKrA8QDEwPEApeCl4KXgtwDAAO7g7uD5oPEAtwCoAMAApeDu4O7g6gDu4O7g+aCooMZg8QDVIO7g8QDbYMIAxMDCAMAA3mDu4O7gxGDqAOoAsmC3AKgA3mDAAO7g7uD5oKigr+DGYNUgviDBYMIAsQDEwNsAwWDUgMTAqsCqwKrA8QDEwK0grSCtIO7g22C3AL4gwADBYK2AxMCv4PEAxMDu4NUg2wDu4LcAviC3AL4gwADBYMFgwWDVINsA+aDCAMIAsQCyYMTAsmDEwLJgxMDVINsAtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gwADBYMAAwWDAAMFgwADBYMAAwWDAAMFgwADBYMAAwWDu4O7g+aDCAPmgwgD5oMIA+aDCAPmgwgD5oMIA+aDCAMIAxGDEYPEAxMDxAMTA8QDEwOoA7uDGYNUg2wDeYNSA1SDbANtg3ADeYOoA7uDu4PEA+aAAIAhwAGAAYAAAALAAsAAQATABMAAgAlACoAAwAsADUACQA4AD4AEwBFAEYAGgBJAEoAHABMAEwAHgBRAFQAHwBWAFYAIwBaAFoAJABcAF0AJQCKAIoAJwCcAJwAKACwALQAKQC2ALgALgC6ALoAMQC8AL0AMgC/AMAANADCAMQANgDGAMsAOQDRANEAPwDTAN0AQADfAN8ASwDhAOMATADlAOcATwDpAO0AUgDwAPAAVwD1APcAWAD6APsAWwD9AP8AXQEDAQQAYAEJAQkAYgEMAQwAYwEXARkAZAErAS0AZwEwATAAagEyATIAawFJAUkAbAFsAW0AbQFvAXEAbwG6AboAcgG9Ab0AcwHEAcUAdAHIAcgAdgHKAcsAdwHNAc0AeQIoAigAegIqAisAewJHAkgAfQJKAkoAfwJMAm0AgAJvAnIAogJ3AnwApgKBAokArAKLAosAtQKNAo0AtgKPAo8AtwKRApEAuAKTApwAuQKlAqcAwwKpAqkAxgKrAqsAxwKtAq0AyAKvAq8AyQKyArIAygK0ArQAywK2ArYAzAK4ArgAzQK6AroAzgK8ArwAzwK+AsoA0ALMAswA3QLOAs4A3gLQAtAA3wLbAtsA4ALdAt0A4QLfAt8A4gLhAuEA4wLjAuMA5ALlAuUA5QLnAucA5gLpAukA5wLrAusA6ALtAu0A6QLvAvIA6gL0AvQA7gL2AvYA7wNTA1gA8ANbA2oA9gNtA20BBgNxA3EBBwNzA3MBCAN3A3cBCQN6A3sBCgN9A4YBDAOIA4oBFgOMA5EBGQOTA5QBHwOWA5kBIQOfA6ABJQOiA6IBJwOkA6QBKAOmA6kBKQOsA7EBLQOzA7MBMwO3A7gBNAO9A70BNgO/A8gBNwPLA8wBQQPOA9EBQwPYA9kBRwPdA90BSQPfA+UBSgPqA+sBUQPvBBcBUwQZBBkBfAQbBCgBfQQwBDABiwQzBDMBjAQ1BDUBjQRBBEYBjgRJBEkBlARLBEsBlQRNBE0BlgRPBFABlwRVBFgBmQRbBFsBnQRdBF4BngRgBGABoARkBGQBoQRmBGYBogRqBGoBowSqBKoBpAABABP/IAACAFb/5gG6/8AAAQG6AA4AAwANABQAQQASAGEAEwABAPX/9QABAMMADQACALf/wgDDABAAAQDD/+IAAQDG//IAAQDDAA4AAgDJ/+0A9f/AAAkAvv/mAMH/6wDC/+kAxP/wAMX/5wDJ/+MAy//OAMz/1ADN/9sABQDB/+wAwwAPAMX/6gDJ/8QAy//nAAUASv/pAMH/7gDDABAAxf/sAMn/IAABAMMADwAFAMn/6gDs/+4A9f+rATP/7AFY/+wAAQD1/9UAAQDJAAsADABKAAwAxQALAMkADAG6/78BvP/uAcD/7AHI/+0Byv/sAcz/9QHNAA4BzwANAdIADQABAPX/2AABAPX/qgALAOX/1AD1/8kBCP/lAR//4wEz/8QBPP/hAU3/1AFO//UBT//nAVf/0gFY/8kACADl/8kA9f/fAQj/7QEf/+sBM//fAT//6QFO//UBWP/gAAgA5f/mAPX/0AEz/84BPP/oAU3/5wFP/+0BV//mAVj/0AALANgAFADl/+AA7AATATz/4QE9/+ABQP/hAUX/6QFN/98BT//eAVf/3wFZ//IABQAb//IA5f/xAU3/8gFP//IBV//yAAwA2AATAOX/5gDm//QA7AASAPX/5wEz/+cBPP/lAT3/6AFN/+YBT//mAVf/5gFY/+cAAgDY/+IBV//kAAIA2P/hAOz/5AAGAOz/7gD1/+4BCP/0AR//8QEz/+8BWP/vAAQA9f/0AQj/9QEz//UBWP/1AAYA7AAUAPX/7QD7/+IBM//tAT3/7QFY/+0ABQEb/+sBvP/rAcD/6QHI/+sByv/rABIASgANAMb/qwDH/8AAy//VAOz/qgEb/+IBHwAMAU4ACwFQAAsBuv+/Abz/7gHA/+wByP/tAcr/7AHM//UBzQAOAc8ADQHSAA0ABgDsABQA9f/wAQAADAEz//ABPf/mAVj/8AAFAOwAOgD1/+MBM//iAT3/4wFY/+MAAQDs/+8ACAD1/7oBCP/PAR//2wEz/1ABPf+dAU7/8AFQ//IBWP9MAAkBvP/yAcD/8gHI//IByv/yAc3/wAHO/+wBz//HAdD/2AHS/78AAgHP/+4B0P/1AAIByP/rAcr/6wAHAcj/7wHK//ABzf+7Ac7/7AHP/7cB0P/VAdL/tAAEAc3/7gHP//EB0f/sAdL/6gAEAc3/6QHP/+sB0P/xAdL/5QAEAc3/8gHP//EB0P/1AdL/7gACAc8ADQHSAA0ACwBb/6QBugATAbz/8wHA//EByP/yAcr/8QHN/zsBzv/aAc//VAHQ/5EB0v8/AAMASgAPAFgAMgBbABEACABb/+UAt//LAMz/5AG6AA0BvP/tAcD/6wHI/+wByv/sAAIBEAALAVf/5gAIAFgADgCB/58Aw//eAMb/5QDY/6gA7P/KAUr/4wG6/8YACQANAA8AQQAMAFb/6wBhAA4Buv/LAbz/6QHA/+cByP/nAcr/5wABAFsACwAJAA0AFABBABEAVv/iAGEAEwG6/7QBvP/ZAcD/2QHI/9kByv/ZAAQADf/mAEH/9ABh/+8BQP/tAAUAyf/qAOz/7gD1/7ABM//sAVj/7AASANj/rgDlABIA6v/gAOz/rQDu/9YA/P/fAQD/0gEG/+ABG//OASv/3QEt/+IBMf/gATf/4AE9/+kBQP/aAUr/vQFU/98BVwARABwAI//DAFj/7wBb/98Amf/uALf/5QC4/9EAwwARAMn/yADYABMA5f/FAPX/ygEz/58BPP9RAT3/ewE//8oBQP/dAUX/8gFN/3UBT//KAVf/TwFY/4wBwP/1Acj/9QHN/8cBzv/xAc//zQHQ/90B0v/EAAcA9f/wAQj/8QEf//MBM//xAU7/8wFQ/+kBWP/TAAUASv/uAFv/6gHP//AB0P/tAdL/8AACAPX/9QFt/7AACQDJ/+oA7P+4APX/6gEI//ABH//xATP/6wFO//UBWP/sAW3/sAABAbr/6wAGAEoADQDFAAsAxv/qAMkADADs/8gBG//xADgABP/YAFb/tQBb/8cAbf64AHz/KACB/00Ahv+OAIn/oQC3/64Avv9+AML/ZwDF/4cAxv9lAMn/ngDL/2oAzP9zAM3/XgDY/6UA5QAPAOn/5ADq/6AA7P90AO7/gAD1/7IA/P99AP7/gAEA/3kBBv99AQj/fwEb/5gBH//aASv/gQEt/5gBMf99ATP/swE3/6ABPf98AT//mgFA/2wBRf/mAUr/awFO/5IBUP+tAVT/ewFXAA8BWP+RAVn/8gG6/68BvP+5AcD/uQHI/7kByv+5Acz/vAHN//EB0P/xAdH/7QACAOz/yQEb/+4AFwC3/9QAwf/tAMMAEQDJ/+AAy//nAMz/5QDN/+4A2AASAOn/6QD1/9cBM//XAT3/0wE//9YBQP/FAUX/5wFNAA0BTwAMAVj/1gFZ//IBvP/pAcD/5wHI/+cByv/pAAEBG//xAAIA9f/AAW3/sAAJAOX/wwD1/88BM//OATz/5wE//98BTf/RAU//7AFX/6ABWP/RAC4AVv9tAFv/jABt/b8AfP59AIH+vACG/ysAif9LALf/YQC+/w8Awv7oAMX/HwDG/uUAyf9GAMv+7QDM/v0Azf7ZANj/UgDlAAUA6f+9AOr/SQDs/v4A7v8TAPX/aAD8/w4A/v8TAQD/BwEG/w4BCP8RARv/PAEf/6wBK/8VAS3/PAEx/w4BM/9qATf/SQE9/wwBP/8/AUD+8QFF/8ABSv7vAU7/MQFQ/18BVP8KAVcABQFY/zABWf/VABMAW//BALf/xQDJ/7QA6f/XAPX/uQEI/7IBG//SAR//yAEz/6ABPf/FAUX/5AFO/8wBUP/MAVj/ywFZ/+8BvP/oAcD/5gHI/+cByv/nAAgA2AAVAOwAFQE8/+QBPf/lAT//5AFN/+MBT//iAVf/5AAiAAr/4gANABQADv/PAEEAEgBK/+oAVv/YAFj/6gBhABMAbf+uAHz/zQCB/6AAhv/BAIn/wAC3/9AAu//qAL7/xgC/AA0Awf/pAML/1gDF/+gAxv+6AMn/6QDL/8sAzP/aAM3/xwF1/9MBuv+rAbz/zQHA/8sByP/LAcr/ywHN//MB0P/zAdH/7wAJAIH/3wC0//MAtv/wAMP/6gDY/98A5f/gAVf/4AG6/+0B0f/1AAEAGAAEAAAABwAqAFQAqgPcBFoExAUGAAEABwAEAAwAKgA1ADYAPwBKAAoAOP/YANH/2ADV/9gBMv/YATr/2ALb/9gC3f/YAt//2AOO/9gETf/YABUAOgAUADsAEgA9ABYBGAAUAmYAFgLtABIC7wAWAvEAFgNYABYDZwAWA2oAFgOgABIDogASA6QAEgOmABYDtwAUA78AFgRBABYEQwAWBEUAFgRqABYAzAAQ/xYAEv8WACX/VgAu/vgAOAAUAEX/3gBH/+sASP/rAEn/6wBL/+sAU//rAFX/6wBZ/+oAWv/oAF3/6ACT/+sAmP/rAJr/6gCx/1YAs/9WALr/6wC8/+gAx//rAMj/6wDK/+oA0QAUANUAFAD2/+sBAv/rAQz/VgEX/+sBGf/oAR3/6wEh/+sBMgAUATn/6wE6ABQBS//rAUz/6wFW/+sBbv8WAXL/FgF2/xYBd/8WAkz/VgJN/1YCTv9WAk//VgJQ/1YCUf9WAlL/VgJn/94CaP/eAmn/3gJq/94Ca//eAmz/3gJt/94Cbv/rAm//6wJw/+sCcf/rAnL/6wJ4/+sCef/rAnr/6wJ7/+sCfP/rAn3/6gJ+/+oCf//qAoD/6gKB/+gCgv/oAoP/VgKE/94Chf9WAob/3gKH/1YCiP/eAor/6wKM/+sCjv/rApD/6wKS/+sClP/rApb/6wKY/+sCmv/rApz/6wKe/+sCoP/rAqL/6wKk/+sCsv74Asb/6wLI/+sCyv/rAtsAFALdABQC3wAUAuL/6gLk/+oC5v/qAuj/6gLq/+oC7P/qAvD/6ANT/1YDW/9WA2v/6wNv/+oDcf/rA3P/6AN2/+oDd//rA3j/6gN//vgDg/9WA44AFAOQ/94Dkf/rA5P/6wOV/+sDlv/oA5j/6wOf/+gDp//oA6//VgOw/94Ds//rA7j/6AO5/+sDvv/rA8D/6APF/1YDxv/eA8f/VgPI/94DzP/rA87/6wPP/+sD2f/rA9v/6wPd/+sD4f/oA+P/6APl/+gD7P/rA+//VgPw/94D8f9WA/L/3gPz/1YD9P/eA/X/VgP2/94D9/9WA/j/3gP5/1YD+v/eA/v/VgP8/94D/f9WA/7/3gP//1YEAP/eBAH/VgQC/94EA/9WBAT/3gQF/1YEBv/eBAj/6wQK/+sEDP/rBA7/6wQQ/+sEEv/rBBT/6wQW/+sEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/6wQs/+sELv/rBDD/6wQy/+sENP/qBDb/6gQ4/+oEOv/qBDz/6gQ+/+oEQP/qBEL/6ARE/+gERv/oBE0AFAAfADj/1QA6/+QAO//sAD3/3QDR/9UA1f/VARj/5AEy/9UBOv/VAmb/3QLb/9UC3f/VAt//1QLt/+wC7//dAvH/3QNY/90DZ//dA2r/3QOO/9UDoP/sA6L/7AOk/+wDpv/dA7f/5AO//90EQf/dBEP/3QRF/90ETf/VBGr/3QAaADj/sAA6/+0APf/QANH/sADV/7ABGP/tATL/sAE6/7ACZv/QAtv/sALd/7AC3/+wAu//0ALx/9ADWP/QA2f/0ANq/9ADjv+wA6b/0AO3/+0Dv//QBEH/0ARD/9AERf/QBE3/sARq/9AAEAAu/+4AOf/uAmL/7gJj/+4CZP/uAmX/7gKy/+4C4f/uAuP/7gLl/+4C5//uAun/7gLr/+4Df//uBDP/7gQ1/+4ARwAGABAACwAQAEf/6ABI/+gASf/oAEv/6ABV/+gAk//oAJj/6AC6/+gAx//oAMj/6AD2/+gBAv/oAR3/6AEh/+gBOf/oAUv/6AFM/+gBVv/oAWwAEAFtABABbwAQAXAAEAFxABACbv/oAm//6AJw/+gCcf/oAnL/6AKK/+gCjP/oAo7/6AKQ/+gCkv/oApT/6AKW/+gCmP/oApr/6AKc/+gCnv/oAqD/6AKi/+gCpP/oA2v/6AOR/+gDlf/oA5j/6AOoABADqQAQA6wAEAOz/+gDuf/oA77/6APM/+gDzv/oA8//6APb/+gD7P/oBAj/6AQK/+gEDP/oBA7/6AQQ/+gEEv/oBBT/6AQW/+gEKv/oBCz/6AQu/+gEMv/oAAEAVgAEAAAAJgCmAZwB+gIUAlYCzAPCBLgFkgYsCMYKjAteDFQOGg5MDn4O/BDiEVgSKhRMFQIWaBciF6gYBhjIGT4ewBlQGqIc4B0CHhgelh7AHuoAAQAmAE8AWABbAF8AnAC0ALYAtwC4AL8AwgDDAMQAyQDLAMwAzQDRANUA1wDYANoA4gDmAOcA6ADpAOoA7ADuAPAA9QD3APoA/wECASEBbQA9AEf/7ABI/+wASf/sAEv/7ABV/+wAk//sAJj/7AC6/+wAx//sAMj/7AD2/+wBAv/sAR3/7AEh/+wBOf/sAUv/7AFM/+wBVv/sAm7/7AJv/+wCcP/sAnH/7AJy/+wCiv/sAoz/7AKO/+wCkP/sApL/7AKU/+wClv/sApj/7AKa/+wCnP/sAp7/7AKg/+wCov/sAqT/7ANr/+wDkf/sA5X/7AOY/+wDs//sA7n/7AO+/+wDzP/sA87/7APP/+wD2//sA+z/7AQI/+wECv/sBAz/7AQO/+wEEP/sBBL/7AQU/+wEFv/sBCr/7AQs/+wELv/sBDL/7AAXAFP/7AEX/+wCeP/sAnn/7AJ6/+wCe//sAnz/7ALG/+wCyP/sAsr/7ANx/+wDd//sA5P/7APZ/+wD3f/sBBz/7AQe/+wEIP/sBCL/7AQk/+wEJv/sBCj/7AQw/+wABgAQ/4QAEv+EAW7/hAFy/4QBdv+EAXf/hAAQAC7/7AA5/+wCYv/sAmP/7AJk/+wCZf/sArL/7ALh/+wC4//sAuX/7ALn/+wC6f/sAuv/7AN//+wEM//sBDX/7AAdAAb/8gAL//IAWv/zAF3/8wC8//MBGf/zAWz/8gFt//IBb//yAXD/8gFx//ICgf/zAoL/8wLw//MDc//zA5b/8wOf//MDp//zA6j/8gOp//IDrP/yA7j/8wPA//MD4f/zA+P/8wPl//MEQv/zBET/8wRG//MAPQAn//MAK//zADP/8wA1//MAg//zAJL/8wCX//MAsv/zANL/8wEH//MBFv/zARr/8wEc//MBHv/zASD/8wE4//MBVf/zAij/8wIp//MCK//zAiz/8wJT//MCXf/zAl7/8wJf//MCYP/zAmH/8wKJ//MCi//zAo3/8wKP//MCnf/zAp//8wKh//MCo//zAsX/8wLH//MCyf/zAvr/8wNX//MDZP/zA4r/8wON//MDuv/zA73/8wPY//MD2v/zA9z/8wQb//MEHf/zBB//8wQh//MEI//zBCX/8wQn//MEKf/zBCv/8wQt//MEL//zBDH/8wSq//MAPQAn/+YAK//mADP/5gA1/+YAg//mAJL/5gCX/+YAsv/mANL/5gEH/+YBFv/mARr/5gEc/+YBHv/mASD/5gE4/+YBVf/mAij/5gIp/+YCK//mAiz/5gJT/+YCXf/mAl7/5gJf/+YCYP/mAmH/5gKJ/+YCi//mAo3/5gKP/+YCnf/mAp//5gKh/+YCo//mAsX/5gLH/+YCyf/mAvr/5gNX/+YDZP/mA4r/5gON/+YDuv/mA73/5gPY/+YD2v/mA9z/5gQb/+YEHf/mBB//5gQh/+YEI//mBCX/5gQn/+YEKf/mBCv/5gQt/+YEL//mBDH/5gSq/+YANgAl/+QAPP/SAD3/0wCx/+QAs//kANn/0gEM/+QCTP/kAk3/5AJO/+QCT//kAlD/5AJR/+QCUv/kAmb/0wKD/+QChf/kAof/5ALv/9MC8f/TA1P/5ANY/9MDW//kA2f/0wNo/9IDav/TA4P/5AOP/9IDpv/TA6//5AO//9MDwv/SA8X/5APH/+QD0P/SA+r/0gPv/+QD8f/kA/P/5AP1/+QD9//kA/n/5AP7/+QD/f/kA///5AQB/+QEA//kBAX/5ARB/9MEQ//TBEX/0wRP/9IEV//SBGr/0wAmABD/HgAS/x4AJf/NALH/zQCz/80BDP/NAW7/HgFy/x4Bdv8eAXf/HgJM/80CTf/NAk7/zQJP/80CUP/NAlH/zQJS/80Cg//NAoX/zQKH/80DU//NA1v/zQOD/80Dr//NA8X/zQPH/80D7//NA/H/zQPz/80D9f/NA/f/zQP5/80D+//NA/3/zQP//80EAf/NBAP/zQQF/80ApgBH/9wASP/cAEn/3ABL/9wAUf/zAFL/8wBT/9YAVP/zAFX/3ABZ/90AWv/hAF3/4QCT/9wAmP/cAJr/3QC6/9wAvP/hAMD/8wDH/9wAyP/cAMr/3QDr//MA7//zAPD/8wDy//MA8//zAPT/8wD2/9wA9//zAPn/8wD6//MA/f/zAP//8wEC/9wBBP/zARf/1gEZ/+EBHf/cASH/3AE1//MBOf/cAUT/8wFJ//MBS//cAUz/3AFW/9wCbv/cAm//3AJw/9wCcf/cAnL/3AJ3//MCeP/WAnn/1gJ6/9YCe//WAnz/1gJ9/90Cfv/dAn//3QKA/90Cgf/hAoL/4QKK/9wCjP/cAo7/3AKQ/9wCkv/cApT/3AKW/9wCmP/cApr/3AKc/9wCnv/cAqD/3AKi/9wCpP/cAr//8wLB//MCw//zAsT/8wLG/9YCyP/WAsr/1gLi/90C5P/dAub/3QLo/90C6v/dAuz/3QLw/+EDa//cA23/8wNv/90Dcf/WA3P/4QN2/90Dd//WA3j/3QOR/9wDkv/zA5P/1gOU//MDlf/cA5b/4QOY/9wDmf/zA57/8wOf/+EDp//hA67/8wOz/9wDtP/zA7j/4QO5/9wDvv/cA8D/4QPM/9wDzv/cA8//3APV//MD1//zA9n/1gPb/9wD3f/WA+H/4QPj/+ED5f/hA+n/8wPs/9wECP/cBAr/3AQM/9wEDv/cBBD/3AQS/9wEFP/cBBb/3AQc/9YEHv/WBCD/1gQi/9YEJP/WBCb/1gQo/9YEKv/cBCz/3AQu/9wEMP/WBDL/3AQ0/90ENv/dBDj/3QQ6/90EPP/dBD7/3QRA/90EQv/hBET/4QRG/+EESv/zBEz/8wRW//MEY//zBGX/8wRn//MAcQAG/9oAC//aAEf/8ABI//AASf/wAEv/8ABV//AAWf/vAFr/3ABd/9wAk//wAJj/8ACa/+8Auv/wALz/3ADH//AAyP/wAMr/7wD2//ABAv/wARn/3AEd//ABIf/wATn/8AFL//ABTP/wAVb/8AFs/9oBbf/aAW//2gFw/9oBcf/aAm7/8AJv//ACcP/wAnH/8AJy//ACff/vAn7/7wJ//+8CgP/vAoH/3AKC/9wCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALi/+8C5P/vAub/7wLo/+8C6v/vAuz/7wLw/9wDa//wA2//7wNz/9wDdv/vA3j/7wOR//ADlf/wA5b/3AOY//ADn//cA6f/3AOo/9oDqf/aA6z/2gOz//ADuP/cA7n/8AO+//ADwP/cA8z/8APO//ADz//wA9v/8APh/9wD4//cA+X/3APs//AECP/wBAr/8AQM//AEDv/wBBD/8AQS//AEFP/wBBb/8AQq//AELP/wBC7/8AQy//AENP/vBDb/7wQ4/+8EOv/vBDz/7wQ+/+8EQP/vBEL/3ARE/9wERv/cADQABv+gAAv/oABZ//EAWv/FAF3/xQCa//EAvP/FAMr/8QEZ/8UBbP+gAW3/oAFv/6ABcP+gAXH/oAJ9//ECfv/xAn//8QKA//ECgf/FAoL/xQLi//EC5P/xAub/8QLo//EC6v/xAuz/8QLw/8UDb//xA3P/xQN2//EDeP/xA5b/xQOf/8UDp//FA6j/oAOp/6ADrP+gA7j/xQPA/8UD4f/FA+P/xQPl/8UENP/xBDb/8QQ4//EEOv/xBDz/8QQ+//EEQP/xBEL/xQRE/8UERv/FAD0AR//nAEj/5wBJ/+cAS//nAFX/5wCT/+cAmP/nALr/5wDH/+cAyP/nAPb/5wEC/+cBHf/nASH/5wE5/+cBS//nAUz/5wFW/+cCbv/nAm//5wJw/+cCcf/nAnL/5wKK/+cCjP/nAo7/5wKQ/+cCkv/nApT/5wKW/+cCmP/nApr/5wKc/+cCnv/nAqD/5wKi/+cCpP/nA2v/5wOR/+cDlf/nA5j/5wOz/+cDuf/nA77/5wPM/+cDzv/nA8//5wPb/+cD7P/nBAj/5wQK/+cEDP/nBA7/5wQQ/+cEEv/nBBT/5wQW/+cEKv/nBCz/5wQu/+cEMv/nAHEABgAMAAsADABH/+gASP/oAEn/6ABL/+gAU//qAFX/6ABaAAsAXQALAJP/6ACY/+gAuv/oALwACwDH/+gAyP/oAPb/6AEC/+gBF//qARkACwEd/+gBIf/oATn/6AFL/+gBTP/oAVb/6AFsAAwBbQAMAW8ADAFwAAwBcQAMAm7/6AJv/+gCcP/oAnH/6AJy/+gCeP/qAnn/6gJ6/+oCe//qAnz/6gKBAAsCggALAor/6AKM/+gCjv/oApD/6AKS/+gClP/oApb/6AKY/+gCmv/oApz/6AKe/+gCoP/oAqL/6AKk/+gCxv/qAsj/6gLK/+oC8AALA2v/6ANx/+oDcwALA3f/6gOR/+gDk//qA5X/6AOWAAsDmP/oA58ACwOnAAsDqAAMA6kADAOsAAwDs//oA7gACwO5/+gDvv/oA8AACwPM/+gDzv/oA8//6APZ/+oD2//oA93/6gPhAAsD4wALA+UACwPs/+gECP/oBAr/6AQM/+gEDv/oBBD/6AQS/+gEFP/oBBb/6AQc/+oEHv/qBCD/6gQi/+oEJP/qBCb/6gQo/+oEKv/oBCz/6AQu/+gEMP/qBDL/6ARCAAsERAALBEYACwAMAFz/7QBe/+0A7f/tAvP/7QL1/+0C9//tA5f/7QPD/+0D0f/tA+v/7QRQ/+0EWP/tAAwAXP/yAF7/8gDt//IC8//yAvX/8gL3//IDl//yA8P/8gPR//ID6//yBFD/8gRY//IAHwBa//QAXP/yAF3/9ABe//MAvP/0AO3/8gEZ//QCgf/0AoL/9ALw//QC8//zAvX/8wL3//MDc//0A5b/9AOX//IDn//0A6f/9AO4//QDwP/0A8P/8gPR//ID4f/0A+P/9APl//QD6//yBEL/9ARE//QERv/0BFD/8gRY//IAeQAG/8oAC//KADj/0gA6/9QAPP/0AD3/0wBR/9EAUv/RAFT/0QBa/+YAXP/vAF3/5gC8/+YAwP/RANH/0gDV/9IA2f/0AN3/7QDg/+EA6//RAO3/7wDv/9EA8P/RAPL/0QDz/9EA9P/RAPf/0QD5/9EA+v/RAP3/0QD//9EBBP/RARj/1AEZ/+YBMv/SATX/0QE6/9IBRP/RAUn/0QFs/8oBbf/KAW//ygFw/8oBcf/KAmb/0wJ3/9ECgf/mAoL/5gK//9ECwf/RAsP/0QLE/9EC2//SAt3/0gLf/9IC7//TAvD/5gLx/9MDWP/TA2f/0wNo//QDav/TA23/0QNz/+YDgv/tA47/0gOP//QDkv/RA5T/0QOW/+YDl//vA5n/0QOe/9EDn//mA6b/0wOn/+YDqP/KA6n/ygOs/8oDrv/RA7T/0QO3/9QDuP/mA7//0wPA/+YDwv/0A8P/7wPQ//QD0f/vA9X/0QPX/9ED4P/tA+H/5gPi/+0D4//mA+T/7QPl/+YD5v/hA+n/0QPq//QD6//vBEH/0wRC/+YEQ//TBET/5gRF/9MERv/mBEr/0QRM/9EETf/SBE//9ARQ/+8EUf/hBFP/4QRW/9EEV//0BFj/7wRj/9EEZf/RBGf/0QRq/9MAHQA4/74AWv/vAF3/7wC8/+8A0f++ANX/vgEZ/+8BMv++ATr/vgKB/+8Cgv/vAtv/vgLd/74C3/++AvD/7wNz/+8Djv++A5b/7wOf/+8Dp//vA7j/7wPA/+8D4f/vA+P/7wPl/+8EQv/vBET/7wRG/+8ETf++ADQAOP/mADr/5wA8//IAPf/nAFz/8QDR/+YA1f/mANn/8gDd/+4A4P/oAO3/8QEY/+cBMv/mATr/5gJm/+cC2//mAt3/5gLf/+YC7//nAvH/5wNY/+cDZ//nA2j/8gNq/+cDgv/uA47/5gOP//IDl//xA6b/5wO3/+cDv//nA8L/8gPD//ED0P/yA9H/8QPg/+4D4v/uA+T/7gPm/+gD6v/yA+v/8QRB/+cEQ//nBEX/5wRN/+YET//yBFD/8QRR/+gEU//oBFf/8gRY//EEav/nAIgAJQAQACf/6AAr/+gAM//oADX/6AA4/+AAOv/gAD3/3wCD/+gAkv/oAJf/6ACxABAAsv/oALMAEADR/+AA0v/oANMAEADV/+AA3AAQAOD/4QDxABAA+P/gAQMAEAEH/+gBDAAQARb/6AEY/+ABGv/oARz/6AEe/+gBIP/oATL/4AE4/+gBOv/gAVEAEAFV/+gCKP/oAin/6AIr/+gCLP/oAkwAEAJNABACTgAQAk8AEAJQABACUQAQAlIAEAJT/+gCXf/oAl7/6AJf/+gCYP/oAmH/6AJm/98CgwAQAoUAEAKHABACif/oAov/6AKN/+gCj//oAp3/6AKf/+gCof/oAqP/6ALF/+gCx//oAsn/6ALb/+AC3f/gAt//4ALv/98C8f/fAvr/6ANTABADV//oA1j/3wNbABADZP/oA2f/3wNq/98DgwAQA4r/6AON/+gDjv/gA6b/3wOvABADt//gA7r/6AO9/+gDv//fA8UAEAPHABAD2P/oA9r/6APc/+gD5v/hA+f/4APtABAD7gAQA+8AEAPxABAD8wAQA/UAEAP3ABAD+QAQA/sAEAP9ABAD/wAQBAEAEAQDABAEBQAQBBv/6AQd/+gEH//oBCH/6AQj/+gEJf/oBCf/6AQp/+gEK//oBC3/6AQv/+gEMf/oBEH/3wRD/98ERf/fBE3/4ARR/+EEUv/gBFP/4QRU/+AEaAAQBGkAEARq/98Eqv/oAC0AOP/xADr/9AA8//QAPf/wANH/8QDT//UA1f/xANn/9ADc//UA3f/zARj/9AEy//EBOv/xAVH/9QJm//AC2//xAt3/8QLf//EC7//wAvH/8ANY//ADZ//wA2j/9ANq//ADgv/zA47/8QOP//QDpv/wA7f/9AO///ADwv/0A9D/9APg//MD4v/zA+T/8wPq//QD7f/1BEH/8ARD//AERf/wBE3/8QRP//QEV//0BGj/9QRq//AAWQAlAA8AOP/mADr/5gA8AA4APf/mALEADwCzAA8A0f/mANMADgDV/+YA2QAOANwADgDdAAsA4P/lAPEADwD4/+gBAwAPAQwADwEY/+YBMv/mATr/5gFRAA4CTAAPAk0ADwJOAA8CTwAPAlAADwJRAA8CUgAPAmb/5gKDAA8ChQAPAocADwLb/+YC3f/mAt//5gLv/+YC8f/mA1MADwNY/+YDWwAPA2f/5gNoAA4Dav/mA4IACwODAA8Djv/mA48ADgOm/+YDrwAPA7f/5gO//+YDwgAOA8UADwPHAA8D0AAOA+AACwPiAAsD5AALA+b/5QPn/+gD6gAOA+0ADgPuAA8D7wAPA/EADwPzAA8D9QAPA/cADwP5AA8D+wAPA/0ADwP/AA8EAQAPBAMADwQFAA8EQf/mBEP/5gRF/+YETf/mBE8ADgRR/+UEUv/oBFP/5QRU/+gEVwAOBGgADgRpAA8Eav/mAC4AOP/jADz/5QA9/+QA0f/jANP/5QDV/+MA2f/lANz/5QDd/+kA8f/qAQP/6gEy/+MBOv/jAVH/5QJm/+QC2//jAt3/4wLf/+MC7//kAvH/5ANY/+QDZ//kA2j/5QNq/+QDgv/pA47/4wOP/+UDpv/kA7//5APC/+UD0P/lA+D/6QPi/+kD5P/pA+r/5QPt/+UD7v/qBEH/5ARD/+QERf/kBE3/4wRP/+UEV//lBGj/5QRp/+oEav/kACEAOP/iADz/5ADR/+IA0//kANX/4gDZ/+QA3P/kAN3/6QDx/+sBA//rATL/4gE6/+IBUf/kAtv/4gLd/+IC3//iA2j/5AOC/+kDjv/iA4//5APC/+QD0P/kA+D/6QPi/+kD5P/pA+r/5APt/+QD7v/rBE3/4gRP/+QEV//kBGj/5ARp/+sAFwA4/+sAPf/zANH/6wDV/+sBMv/rATr/6wJm//MC2//rAt3/6wLf/+sC7//zAvH/8wNY//MDZ//zA2r/8wOO/+sDpv/zA7//8wRB//MEQ//zBEX/8wRN/+sEav/zADAAUf/vAFL/7wBU/+8AXP/wAMD/7wDr/+8A7f/wAO//7wDw/+8A8v/vAPP/7wD0/+8A9//vAPn/7wD6/+8A/f/vAP//7wEE/+8BNf/vAUT/7wFJ/+8Cd//vAr//7wLB/+8Cw//vAsT/7wNt/+8Dkv/vA5T/7wOX//ADmf/vA57/7wOu/+8DtP/vA8P/8APR//AD1f/vA9f/7wPp/+8D6//wBEr/7wRM/+8EUP/wBFb/7wRY//AEY//vBGX/7wRn/+8AHQAG//IAC//yAFr/9QBd//UAvP/1ARn/9QFs//IBbf/yAW//8gFw//IBcf/yAoH/9QKC//UC8P/1A3P/9QOW//UDn//1A6f/9QOo//IDqf/yA6z/8gO4//UDwP/1A+H/9QPj//UD5f/1BEL/9QRE//UERv/1AAQA+P/tA+f/7QRS/+0EVP/tAFQAR//wAEj/8ABJ//AAS//wAFP/6wBV//AAk//wAJj/8AC6//AAx//wAMj/8AD2//ABAv/wARf/6wEd//ABIf/wATn/8AFL//ABTP/wAVb/8AJu//ACb//wAnD/8AJx//ACcv/wAnj/6wJ5/+sCev/rAnv/6wJ8/+sCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALG/+sCyP/rAsr/6wNr//ADcf/rA3f/6wOR//ADk//rA5X/8AOY//ADs//wA7n/8AO+//ADzP/wA87/8APP//AD2f/rA9v/8APd/+sD7P/wBAj/8AQK//AEDP/wBA7/8AQQ//AEEv/wBBT/8AQW//AEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/8AQs//AELv/wBDD/6wQy//AAjwAGAA0ACwANAEX/8ABH/7AASP+wAEn/sABL/7AAU//WAFX/sABaAAsAXQALAJP/sACY/7AAuv+wALwACwDI/7AA8f+vAPb/sAEC/7ABA/+vARf/1gEZAAsBHf+wASH/sAE5/7ABS/+wAUz/sAFW/7ABbAANAW0ADQFvAA0BcAANAXEADQJn//ACaP/wAmn/8AJq//ACa//wAmz/8AJt//ACbv+wAm//sAJw/7ACcf+wAnL/sAJ4/9YCef/WAnr/1gJ7/9YCfP/WAoEACwKCAAsChP/wAob/8AKI//ACiv+wAoz/sAKO/7ACkP+wApL/sAKU/7AClv+wApj/sAKa/7ACnP+wAp7/sAKg/7ACov+wAqT/sALG/9YCyP/WAsr/1gLwAAsDa/+wA3H/1gNzAAsDd//WA5D/8AOR/7ADk//WA5X/sAOWAAsDmP+wA58ACwOnAAsDqAANA6kADQOsAA0DsP/wA7P/sAO4AAsDuf+wA77/sAPAAAsDxv/wA8j/8APM/7ADzv+wA8//sAPZ/9YD2/+wA93/1gPhAAsD4wALA+UACwPs/7AD7v+vA/D/8APy//AD9P/wA/b/8AP4//AD+v/wA/z/8AP+//AEAP/wBAL/8AQE//AEBv/wBAj/sAQK/7AEDP+wBA7/sAQQ/7AEEv+wBBT/sAQW/7AEHP/WBB7/1gQg/9YEIv/WBCT/1gQm/9YEKP/WBCr/sAQs/7AELv+wBDD/1gQy/7AEQgALBEQACwRGAAsEaf+vAAgA8QAQAPj/8AEDABAD5//wA+4AEARS//AEVP/wBGkAEABFAEcADABIAAwASQAMAEsADABVAAwAkwAMAJgADAC6AAwAxwAMAMgADADxABgA9gAMAPj/9wECAAwBAwAYAR0ADAEhAAwBOQAMAUsADAFMAAwBVgAMAm4ADAJvAAwCcAAMAnEADAJyAAwCigAMAowADAKOAAwCkAAMApIADAKUAAwClgAMApgADAKaAAwCnAAMAp4ADAKgAAwCogAMAqQADANrAAwDkQAMA5UADAOYAAwDswAMA7kADAO+AAwDzAAMA84ADAPPAAwD2wAMA+f/9wPsAAwD7gAYBAgADAQKAAwEDAAMBA4ADAQQAAwEEgAMBBQADAQWAAwEKgAMBCwADAQuAAwEMgAMBFL/9wRU//cEaQAYAB8AWv/0AFz/8ABd//QAvP/0AO3/8ADx//MBA//zARn/9AKB//QCgv/0AvD/9ANz//QDlv/0A5f/8AOf//QDp//0A7j/9APA//QDw//wA9H/8APh//QD4//0A+X/9APr//AD7v/zBEL/9ARE//QERv/0BFD/8ARY//AEaf/zAAoABv/WAAv/1gFs/9YBbf/WAW//1gFw/9YBcf/WA6j/1gOp/9YDrP/WAAoABv/1AAv/9QFs//UBbf/1AW//9QFw//UBcf/1A6j/9QOp//UDrP/1ACEATAAgAE8AIABQACAAU/+AAFf/kAEX/4ACeP+AAnn/gAJ6/4ACe/+AAnz/gALG/4ACyP+AAsr/gALS/5AC1P+QAtb/kALY/5AC2v+QA3H/gAN3/4ADk/+AA5r/kAPZ/4AD3f+ABBz/gAQe/4AEIP+ABCL/gAQk/4AEJv+ABCj/gAQw/4AAAgeKAAQAAApeEb4AIQAdAAAAEf/O/48AEv/1/+//iP/0/7v/f//1AAz/qf+i/8kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+UAAAAA/+j/yQAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAD/5QARAAAAAAAAAAAAAP/jAAAAAAAA/+T/5AAAABIAEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/4QAAAAAAAAAAAAAAAAAAAAD/5QAAAAD/6v/VAAAAAP/r/+r/mv/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+YAAAAAAAAAAAAA/+0AAAAU/+8AAAAAAAAAAAAAAAAAAAAAAAD/7QAAAAAAAAAAAAAAAAAAAAD/y/+4/3z/fv/kAAAAAP+dAA8AEP+h/8QAEAAQAAAAAP+xAAD/JgAA/53/s/8Y/5P/8P+P/4z/EAAA/5L/cv8M/w//vQAAAAD/RAAFAAf/S/+GAAcABwAAAAD/PgAA/noAAP9E/2r+Yv8z/9H/LP8nAAAAAAAAAAAAAP/YAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAAAAAAAP/Y/6MAAP/hAAAAAP/lAAAAAP/pAAAAAAAAAAAAAAAAAAAAAAAA/+YAAP/A/+kAAAAAAAAAAAAAAAD/ewAAAAD/v//K/rAAAP9x/u3/1AAA/1H/EQAAAAAAEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAA8AAP/ZAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAA/3b/4f68/+b/8wAAAAAAAAAA//UAAP84AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9QAAAAD/8wAAAAD/0gAAAAD/5AAAAAAAAAAAAAD/tQAA/x8AAP/UAAD/2wAAAAD/0gAAAAAAAAAR/+H/0QAR/+cAAAAA/+sAAAAA/+sAAAAOAAAAAAAAAAAAAAAAAAD/5gAA/9IAAAAAAAAAAAAAAAAAAP/sAAAAAP/j/6AAAP+/ABEAEf/Z/+IAEgASAAAAAP+iAA3/LQAA/7//6f/M/9j/8P+3/8b/oAAAAAAAAAAAAAAAAAAAAAD/4QAAAA7/7QAAAAAAAAAAAAD/1QAA/4UAAP/hAAD/xAAAAAD/3wAAAAAAAAAA/+UAAAAA/+YAAAAA/+sAAAAA/+0AAAAAAAAAAAAAAA0AAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAD/ygAA/+n/u//pAAAAAP+9AAAAEgAAAAAAAAASAAAAAP+lAAD+bQAA/70AAP+J/5oAAP+R/9IAAAAAAAD/8QAAAAAAAAAA/70AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAD/8gAAAAD/4wAAAAAAAAAA//EAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAAAAD/8wAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/xAAD/8AAAAAD/eAAAAAAAAAAA//AAAAAAAAAAAAAAAAAAAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAAAA//8QAAAAAAAAAAAAAAAAAAAAAAAAAA/5UAAP/zAAAAAAAAAAD/8QAAAAAAAAAAABIAAAAAAAAAAAAQ/+wAAAAAAAAAAAAAAAAAAAAAAAAAAP+FAAD/7QAAAAAAAAAA/9gAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+V/8MAAAAAAAAAAAAAAAAAAAAA/4gAAAAAAAD/xQAAAAD/7AAA/87/sAAAAAAAAAAAAAAAAAAAAAD/VgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//UAAAAAAAAAAAAA/8AAAAAA/vUAAAAA/8j/rf/n/+sAAP/wAAAAAAAA/8kAAAAAAAAAAAAAAAAAAAAA/93/2QAAAAAAAP95AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAIAeAAGAAYAAAALAAsAAQAQABAAAgASABIAAwAlACkABAAsADQACQA4AD4AEgBFAEcAGQBJAEkAHABMAEwAHQBRAFQAHgBWAFYAIgBaAFoAIwBcAF4AJACKAIoAJwCwALMAKAC8ALwALADAAMAALQDGAMYALgDTANQALwDWANYAMQDZANkAMgDbAN0AMwDfAN8ANgDhAOEANwDjAOMAOADlAOUAOQDrAOsAOgDtAO0AOwD2APYAPAD7APsAPQD9AP4APgEDAQQAQAEJAQkAQgEMAQwAQwEXARkARAErAS0ARwEwATAASgEyATIASwFJAUkATAFsAXIATQF2AXcAVAIoAigAVgIqAisAVwJHAkgAWQJKAkoAWwJMAnIAXAJ3AnwAgwKBApEAiQKTApwAmgKlAqcApAKpAqkApwKrAqsAqAKtAq0AqQKvAq8AqgKyArIAqwK0ArQArAK2ArYArQK4ArgArgK6AroArwK8ArwAsAK+AsoAsQLMAswAvgLOAs4AvwLQAtAAwALbAtsAwQLdAt0AwgLfAt8AwwLhAuEAxALjAuMAxQLlAuUAxgLnAucAxwLpAukAyALrAusAyQLtAu0AygLvAvcAywNTA1gA1ANbA2oA2gNtA20A6gNxA3EA6wNzA3MA7AN3A3cA7QN6A3sA7gN9A4YA8AOIA4oA+gOMA5EA/QOTA5kBAwOfA6ABCgOiA6IBDAOkA6QBDQOmA6kBDgOsA7EBEgOzA7MBGAO3A7gBGQO9A8gBGwPLA8wBJwPOA9EBKQPYA9kBLQPdA90BLwPfA+UBMAPqA+sBNwPvBBcBOQQZBBkBYgQbBCgBYwQwBDABcQQzBDMBcgQ1BDUBcwRBBEYBdARJBEkBegRLBEsBewRNBE0BfARPBFABfQRVBFgBfwRbBFsBgwRdBF4BhARgBGABhgRkBGQBhwRmBGYBiARqBGoBiQSqBKoBigACAToABgAGAB0ACwALAB0AEAAQAB4AEgASAB4AJgAmAAEAJwAnAAQAKAAoAAMAKQApAAUALAAtAAIALgAuAAwALwAvAAkAMAAwAAoAMQAyAAIAMwAzAAMANAA0AAsAOAA4AAYAOQA5AAwAOgA6AA0AOwA7ABAAPAA8AA4APQA9AA8APgA+ABEARQBFABMARgBGABUARwBHABQASQBJABYATABMABcAUQBSABcAUwBTABgAVABUABUAVgBWABoAWgBaABkAXABcABsAXQBdABkAXgBeABwAigCKABUAsACwAAcAsgCyAAMAvAC8ABkAwADAABcAxgDGABUA0wDUAB8A1gDWAAIA2QDZAA4A2wDcAAIA3QDdABIA3wDfAAIA4QDhAAIA4wDjAB8A5QDlAB8A6wDrAAgA7QDtABsA9gD2ABUA+wD7ACAA/QD9ACAA/gD+ABUBAwEEACABCQEJACABFwEXABgBGAEYAA0BGQEZABkBKwErABUBLAEsAAcBLQEtAAgBMAEwAAkBMgEyAAkBSQFJAAgBbAFtAB0BbgFuAB4BbwFxAB0BcgFyAB4BdgF3AB4CKAIoAAQCKgIrAAMCRwJIAAMCSgJKAAYCUwJTAAQCVAJXAAUCWAJcAAICXQJhAAMCYgJlAAwCZgJmAA8CZwJtABMCbgJuABQCbwJyABYCdwJ3ABcCeAJ8ABgCgQKCABkChAKEABMChgKGABMCiAKIABMCiQKJAAQCigKKABQCiwKLAAQCjAKMABQCjQKNAAQCjgKOABQCjwKPAAQCkAKQABQCkQKRAAMCkwKTAAUClAKUABYClQKVAAUClgKWABYClwKXAAUCmAKYABYCmQKZAAUCmgKaABYCmwKbAAUCnAKcABYCpQKlAAICpgKmABcCpwKnAAICqQKpAAICqwKrAAICrQKtAAICrwKvAAICsgKyAAwCtAK0AAkCtgK2AAoCuAK4AAoCugK6AAoCvAK8AAoCvgK+AAICvwK/ABcCwALAAAICwQLBABcCwgLCAAICwwLEABcCxQLFAAMCxgLGABgCxwLHAAMCyALIABgCyQLJAAMCygLKABgCzALMABoCzgLOABoC0ALQABoC2wLbAAYC3QLdAAYC3wLfAAYC4QLhAAwC4wLjAAwC5QLlAAwC5wLnAAwC6QLpAAwC6wLrAAwC7QLtABAC7wLvAA8C8ALwABkC8QLxAA8C8gLyABEC8wLzABwC9AL0ABEC9QL1ABwC9gL2ABEC9wL3ABwDVANUAAUDVQNWAAIDVwNXAAMDWANYAA8DXANcAAEDXQNdAAUDXgNeABEDXwNgAAIDYQNhAAkDYgNjAAIDZANkAAMDZQNlAAsDZgNmAAYDZwNnAA8DaANoAA4DaQNpAAIDagNqAA8DbQNtABcDcQNxABgDcwNzABkDdwN3ABgDegN6AAUDewN7AAcDfQN+AAIDfwN/AAwDgAOBAAkDggOCABIDhAOEAAEDhQOFAAcDhgOGAAUDiAOJAAIDigOKAAMDjAOMAAsDjQONAAQDjgOOAAYDjwOPAA4DkAOQABMDkQORABYDkwOTABgDlAOUABUDlQOVABQDlgOWABkDlwOXABsDmAOYABYDmQOZAAgDnwOfABkDoAOgABADogOiABADpAOkABADpgOmAA8DpwOnABkDqAOpAB0DrAOsAB0DrQOtAAIDrgOuABcDsAOwABMDsQOxAAUDswOzABYDtwO3AA0DuAO4ABkDvQO9AAQDvgO+ABQDvwO/AA8DwAPAABkDwQPBAAIDwgPCAA4DwwPDABsDxAPEAAIDxgPGABMDyAPIABMDywPLAAUDzAPMABYDzgPPABYD0APQAA4D0QPRABsD2APYAAMD2QPZABgD3QPdABgD3wPfABUD4APgABID4QPhABkD4gPiABID4wPjABkD5APkABID5QPlABkD6gPqAA4D6wPrABsD8APwABMD8gPyABMD9AP0ABMD9gP2ABMD+AP4ABMD+gP6ABMD/AP8ABMD/gP+ABMEAAQAABMEAgQCABMEBAQEABMEBgQGABMEBwQHAAUECAQIABYECQQJAAUECgQKABYECwQLAAUEDAQMABYEDQQNAAUEDgQOABYEDwQPAAUEEAQQABYEEQQRAAUEEgQSABYEEwQTAAUEFAQUABYEFQQVAAUEFgQWABYEFwQXAAIEGQQZAAIEGwQbAAMEHAQcABgEHQQdAAMEHgQeABgEHwQfAAMEIAQgABgEIQQhAAMEIgQiABgEIwQjAAMEJAQkABgEJQQlAAMEJgQmABgEJwQnAAMEKAQoABgEMAQwABgEMwQzAAwENQQ1AAwEQQRBAA8EQgRCABkEQwRDAA8ERAREABkERQRFAA8ERgRGABkESQRJAAkESwRLAAIETQRNAAYETwRPAA4EUARQABsEVQRVAAcEVgRWAAgEVwRXAA4EWARYABsEWwRbABcEXQRdAB8EXgReAAcEYARgAAkEZARkAAIEZgRmAAIEagRqAA8EqgSqAAMAAgFtAAYABgAHAAsACwAHABAAEAATABEAEQAXABIAEgATACUAJQARACcAJwAFACsAKwAFAC4ALgAcADMAMwAFADUANQAFADcANwAZADgAOAAKADkAOQAGADoAOgANADsAOwAJADwAPAASAD0APQAOAD4APgAUAEUARQAaAEcASQAVAEsASwAVAFEAUgAYAFMAUwAIAFQAVAAYAFUAVQAVAFcAVwAbAFkAWQALAFoAWgACAFwAXAAWAF0AXQACAF4AXgAMAIMAgwAFAJIAkgAFAJMAkwAVAJcAlwAFAJgAmAAVAJoAmgALALEAsQARALIAsgAFALMAswARALoAugAVALwAvAACAMAAwAAYAMcAyAAVAMoAygALANEA0QAKANIA0gAFANMA0wABANUA1QAKANkA2QASANwA3AABAN0A3QAQAOAA4AAPAOsA6wAYAO0A7QAWAO8A8AAYAPEA8QAEAPIA9AAYAPYA9gAVAPcA9wAYAPgA+AADAPkA+gAYAP0A/QAYAP8A/wAYAQIBAgAVAQMBAwAEAQQBBAAYAQcBBwAFAQwBDAARARYBFgAFARcBFwAIARgBGAANARkBGQACARoBGgAFARwBHAAFAR0BHQAVAR4BHgAFASABIAAFASEBIQAVATIBMgAKATUBNQAYATgBOAAFATkBOQAVAToBOgAKAUQBRAAYAUkBSQAYAUsBTAAVAVEBUQABAVUBVQAFAVYBVgAVAWkBagAXAWwBbQAHAW4BbgATAW8BcQAHAXIBcgATAXYBdwATAigCKQAFAisCLAAFAkYCRgAXAkwCUgARAlMCUwAFAl0CYQAFAmICZQAGAmYCZgAOAmcCbQAaAm4CcgAVAncCdwAYAngCfAAIAn0CgAALAoECggACAoMCgwARAoQChAAaAoUChQARAoYChgAaAocChwARAogCiAAaAokCiQAFAooCigAVAosCiwAFAowCjAAVAo0CjQAFAo4CjgAVAo8CjwAFApACkAAVApICkgAVApQClAAVApYClgAVApgCmAAVApoCmgAVApwCnAAVAp0CnQAFAp4CngAVAp8CnwAFAqACoAAVAqECoQAFAqICogAVAqMCowAFAqQCpAAVArICsgAcAr8CvwAYAsECwQAYAsMCxAAYAsUCxQAFAsYCxgAIAscCxwAFAsgCyAAIAskCyQAFAsoCygAIAtEC0QAZAtIC0gAbAtMC0wAZAtQC1AAbAtUC1QAZAtYC1gAbAtcC1wAZAtgC2AAbAtkC2QAZAtoC2gAbAtsC2wAKAt0C3QAKAt8C3wAKAuEC4QAGAuIC4gALAuMC4wAGAuQC5AALAuUC5QAGAuYC5gALAucC5wAGAugC6AALAukC6QAGAuoC6gALAusC6wAGAuwC7AALAu0C7QAJAu8C7wAOAvAC8AACAvEC8QAOAvIC8gAUAvMC8wAMAvQC9AAUAvUC9QAMAvYC9gAUAvcC9wAMAvoC+gAFA1MDUwARA1cDVwAFA1gDWAAOA1sDWwARA14DXgAUA2QDZAAFA2cDZwAOA2gDaAASA2oDagAOA2sDawAVA20DbQAYA28DbwALA3EDcQAIA3MDcwACA3YDdgALA3cDdwAIA3gDeAALA38DfwAcA4IDggAQA4MDgwARA4oDigAFA40DjQAFA44DjgAKA48DjwASA5ADkAAaA5EDkQAVA5IDkgAYA5MDkwAIA5QDlAAYA5UDlQAVA5YDlgACA5cDlwAWA5gDmAAVA5kDmQAYA5oDmgAbA54DngAYA58DnwACA6ADoAAJA6IDogAJA6QDpAAJA6YDpgAOA6cDpwACA6gDqQAHA6wDrAAHA64DrgAYA68DrwARA7ADsAAaA7MDswAVA7QDtAAYA7cDtwANA7gDuAACA7kDuQAVA7oDugAFA70DvQAFA74DvgAVA78DvwAOA8ADwAACA8IDwgASA8MDwwAWA8UDxQARA8YDxgAaA8cDxwARA8gDyAAaA8wDzAAVA84DzwAVA9AD0AASA9ED0QAWA9UD1QAYA9cD1wAYA9gD2AAFA9kD2QAIA9oD2gAFA9sD2wAVA9wD3AAFA90D3QAIA+AD4AAQA+ED4QACA+ID4gAQA+MD4wACA+QD5AAQA+UD5QACA+YD5gAPA+cD5wADA+kD6QAYA+oD6gASA+sD6wAWA+wD7AAVA+0D7QABA+4D7gAEA+8D7wARA/AD8AAaA/ED8QARA/ID8gAaA/MD8wARA/QD9AAaA/UD9QARA/YD9gAaA/cD9wARA/gD+AAaA/kD+QARA/oD+gAaA/sD+wARA/wD/AAaA/0D/QARA/4D/gAaA/8D/wARBAAEAAAaBAEEAQARBAIEAgAaBAMEAwARBAQEBAAaBAUEBQARBAYEBgAaBAgECAAVBAoECgAVBAwEDAAVBA4EDgAVBBAEEAAVBBIEEgAVBBQEFAAVBBYEFgAVBBsEGwAFBBwEHAAIBB0EHQAFBB4EHgAIBB8EHwAFBCAEIAAIBCEEIQAFBCIEIgAIBCMEIwAFBCQEJAAIBCUEJQAFBCYEJgAIBCcEJwAFBCgEKAAIBCkEKQAFBCoEKgAVBCsEKwAFBCwELAAVBC0ELQAFBC4ELgAVBC8ELwAFBDAEMAAIBDEEMQAFBDIEMgAVBDMEMwAGBDQENAALBDUENQAGBDYENgALBDgEOAALBDoEOgALBDwEPAALBD4EPgALBEAEQAALBEEEQQAOBEIEQgACBEMEQwAOBEQERAACBEUERQAOBEYERgACBEoESgAYBEwETAAYBE0ETQAKBE8ETwASBFAEUAAWBFEEUQAPBFIEUgADBFMEUwAPBFQEVAADBFYEVgAYBFcEVwASBFgEWAAWBGMEYwAYBGUEZQAYBGcEZwAYBGgEaAABBGkEaQAEBGoEagAOBHAEcAAXBKoEqgAFAAEAAAAKAgYG8AAEREZMVAAaY3lybABIZ3JlawB2bGF0bgCkAAQAAAAA//8AEgAAAAoAFAAeACgANABBAEsAVQBfAGkAcwB9AIcAkQCbAKUArwAEAAAAAP//ABIAAQALABUAHwApADUAQgBMAFYAYABqAHQAfgCIAJIAnACmALAABAAAAAD//wASAAIADAAWACAAKgA2AEMATQBXAGEAawB1AH8AiQCTAJ0ApwCxACgABkFaRSAAVENSVCAAfk1PTCAAqE5BViAA1FJPTSABAFRVUiABLAAA//8AEwADAA0AFwAhACsAMgA3AEQATgBYAGIAbAB2AIAAigCUAJ4AqACyAAD//wASAAQADgAYACIALAA4AEUATwBZAGMAbQB3AIEAiwCVAJ8AqQCzAAD//wASAAUADwAZACMALQA5AEYAUABaAGQAbgB4AIIAjACWAKAAqgC0AAD//wATAAYAEAAaACQALgA6AD4ARwBRAFsAZQBvAHkAgwCNAJcAoQCrALUAAP//ABMABwARABsAJQAvADsAPwBIAFIAXABmAHAAegCEAI4AmACiAKwAtgAA//8AEwAIABIAHAAmADAAPABAAEkAUwBdAGcAcQB7AIUAjwCZAKMArQC3AAD//wATAAkAEwAdACcAMQAzAD0ASgBUAF4AaAByAHwAhgCQAJoApACuALgAuWMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmxpZ2EEfGxpZ2EEhGxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxvY2wEkGxvY2wElmxvY2wEnG51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqHBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5AAAAAEAAAAAAAIAAgADAAAAAQAHAAAAAQAYAAAAAwAVABYAFwAAAAIACAAJAAAAAQAJAAAAAQAUAAAAAQAEAAAAAQAGAAAAAQAFAAAAAQAZAAAAAQARAAAAAQATAAAAAQABAAAAAQAKAAAAAQALAAAAAQAMAAAAAQANAAAAAQAOAAAAAQAPAAAAAQAQAAAAAQASABsAOAPGBrQHYA3wDfAOBg4oDl4OhA6yDsYO2g7uDwAPGg9cD3oPmA/KD/wQLhBCEHoQbBB6EKYAAQAAAAEACAACAcQA3wHnAboBuwG8Ab0BvgG/AcABwQHCAcMBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0AHRAdIB0wHoAekCRAI7AeoB6wHsAe0B7gHvAfAB8QHyAfMB9AH1AfYB9wH4AfkB+gH7AfwB/QH+AgACAQTdAgICAwIEAgUCBgIHAggCCQIKAgsCLwIPAhACEQIUAhUCFgIXAhgCGQIbAhwCHgIdAvwC/QL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZAxoDGwMcAx0DHgMfAyADIQMiAyMDJAMlAyYDJwMoAykDKgMrAywDLQMuAy8DMAMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNPA1ADUQNSBKsErAStBK4ErwSwBLEEsgSzBLQEtQS2BLcEuAS5BLoEuwS8BL0EvgS/BMAEwQTCBMMExATFBMYB/wTHBMgEyQTKBMsEzATNBM4EzwTQBNEE0gTTBNQE1QTWBNgE2QTbAhoE3AIOBNcCEwINBNoCDAISAAEA3wAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAhQCSALAAsQCyALMAtAC1ALYAtwC4ALkA0QDSANMA1ADVANYA1wDYANkA2gDbANwA3QDeAN8A4ADhAOIA4wDkAOUA5gDnAOgBLAEwATIBOAE6ATwBPgE/AUUBRgF/AYUBigGNAkcCSAJKAkwCTQJOAk8CUAJRAlICUwJUAlUCVgJXAlgCWQJaAlsCXAJdAl4CXwJgAmECYgJjAmQCZQJmAoMChQKHAokCiwKNAo8CkQKTApUClwKZApsCnQKfAqECowKlAqcCqQKrAq0CrwKyArQCtgK4AroCvAK+AsACwgLFAscCyQLLAs0CzwLRAtMC1QLZAtsC3QLfAuEC4wLlAucC6QLrAu0C7wLxAvIC9AL2A1MDVANVA1YDVwNYA1kDWwNcA10DXgNfA2ADYQNiA2QDZQNmA2cDaANpA2oDegN7A3wDfQN+A38DgAOBA4IDgwOEA4UDhgOHA4gDiQOKA4sDjAONA44DjwO7A70DvwPUA9oD4ARJBEsETwRXBFkEXgRqAAEAAAABAAgAAgF0ALcBugG7AbwBvQG+Ab8BwAHBAcIBwwHEAcUBxgHHAcgByQHKAcsBzAHNAc4BzwHQAdEB0gHTAv0DMAI7AfoEygTLAfsB/AH9Af4B/wIABM4EzwTRBNQE3QICAgMCBAIFAgYCBwIIAgkCCgILAfQB9QH2AfcB+AH5Ai8CDwIQAhECFAIVAhcCGQL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZA08DGgMbAxwDHQMeAx8DIAMhAyIDIwMkAyUDJgMnAygDKQMqAysDLAMtAy4DLwMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNQA1EDUgTJBMwEzQTQBNIE0wIBBNUEwQTCBMMExATFBMYExwTIBNYE2ATZAhgE2wIaBNwC/AIOBNcCEwINBNoCFgIMAhIAAQC3AEUARgBHAEgASQBKAEsATABNAE4ATwBQAFEAUgBTAFQAVQBWAFcAWABZAFoAWwBcAF0AXgCHAIwAkwDpAOoA6wDsAO0A7gDvAPAA8QDyAPMA9AD1APYA9wD4APkA+gD7APwA/QD+AP8BAAEBAQIBAwEEAQUBBgEtATEBMwE5ATsBPQFAAUcCSwJnAmgCaQJqAmsCbAJtAm4CbwJwAnECcgJzAnQCdQJ2AncCeAJ5AnoCewJ8An0CfgJ/AoACgQKCAoQChgKIAooCjAKOApACkgKUApYCmAKaApwCngKgAqICpAKmAqgCqgKsAq4CswK1ArcCuQK7Ar0CvwLBAsMCxgLIAsoCzALOAtAC0gLUAtYC2gLcAt4C4ALiAuQC5gLoAuoC7ALuAvAC8wL1AvcDkAORA5IDkwOUA5UDlgOXA5gDmQOaA5sDnAOdA54DnwO8A74DwAPOA9UD2wPhBEcESgRMBFAEWARaBFsEXwRrAAYAAAAGABIAKgBCAFoAcgCKAAMAAAABABIAAQCQAAEAAAAaAAEAAQBNAAMAAAABABIAAQB4AAEAAAAaAAEAAQBOAAMAAAABABIAAQBgAAEAAAAaAAEAAQKuAAMAAAABABIAAQBIAAEAAAAaAAEAAQObAAMAAAABABIAAQAwAAEAAAAaAAEAAQOdAAMAAAABABIAAQAYAAEAAAAaAAEAAQQaAAIAAQCnAKsAAAAEAAAAAQAIAAEGHgA2AHIApACuALgAygD8AQ4BGAFKAWQBfgGQAboB7AH2AhgCMgJEAnYCiAKiAswC3gMQAxoDJAM2A2gDcgN8A4YDoAO6A8wD9gQoBDIEVARuBIAEsgTEBN4FCAUaBSQFLgU4BUIFbAWWBcAF6gYUAAYADgAUABoAIAAmACwCTAACAKcCTQACAKgCTwACAKkD8QACAKoEewACAKsD7wACAKwAAQAEBIgAAgCsAAEABAKJAAIAqAACAAYADASKAAIArASMAAIBogAGAA4AFAAaACAAJgAsAlQAAgCnAlUAAgCoBAsAAgCpBAkAAgCqBH0AAgCrBAcAAgCsAAIABgAMBHcAAgCoAqMAAgGiAAEABASOAAIArAAGAA4AFAAaACAAJgAsAlgAAgCnAlkAAgCoAqcAAgCpBBcAAgCqBH8AAgCrBBkAAgCsAAMACAAOABQEkAACAKgEkgACAKwCtAACAaIAAwAIAA4AFAK2AAIAqASUAAIArAK4AAIBogACAAYADAOtAAIAqASWAAIArAAFAAwAEgAYAB4AJAR5AAIApwK+AAIAqAJcAAIAqQSYAAIArALAAAIBogAGAA4AFAAaACAAJgAsAl0AAgCnAl4AAgCoAmAAAgCpBB0AAgCqBIEAAgCrBBsAAgCsAAEABASaAAIAqAAEAAoAEAAWABwCywACAKgEgwACAKsEnAACAKwCzQACAaIAAwAIAA4AFALRAAIAqASeAAIArALXAAIBogACAAYADASgAAIArALbAAIBogAGAA4AFAAaACAAJgAsAmIAAgCnAmMAAgCoAuEAAgCpBDUAAgCqBIUAAgCrBDMAAgCsAAIABgAMBKIAAgCpBKQAAgCsAAMACAAOABQDoAACAKcDogACAKgEpgACAKwABQAMABIAGAAeACQDpgACAKcCZgACAKgERQACAKkEQwACAKoEQQACAKwAAgAGAAwC8gACAKgEqAACAKwABgAOABQAGgAgACYALAJnAAIApwJoAAIAqAJqAAIAqQPyAAIAqgR8AAIAqwPwAAIArAABAAQEiQACAKwAAQAEAooAAgCoAAIABgAMBIsAAgCsBI0AAgGiAAYADgAUABoAIAAmACwCbwACAKcCcAACAKgEDAACAKkECgACAKoEfgACAKsECAACAKwAAQAEBHgAAgCoAAEABASPAAIArAABAAQEGgACAKwAAwAIAA4AFASRAAIAqASTAAIArAK1AAIBogADAAgADgAUArcAAgCoBJUAAgCsArkAAgGiAAIABgAMA64AAgCoBJcAAgCsAAUADAASABgAHgAkBHoAAgCnAr8AAgCoAncAAgCpBJkAAgCsAsEAAgGiAAYADgAUABoAIAAmACwCeAACAKcCeQACAKgCewACAKkEHgACAKoEggACAKsEHAACAKwAAQAEBJsAAgCoAAQACgAQABYAHALMAAIAqASEAAIAqwSdAAIArALOAAIBogADAAgADgAUAtIAAgCoBJ8AAgCsAtgAAgGiAAIABgAMBKEAAgCsAtwAAgGiAAYADgAUABoAIAAmACwCfQACAKcCfgACAKgC4gACAKkENgACAKoEhgACAKsENAACAKwAAgAGAAwEowACAKkEpQACAKwAAwAIAA4AFAOhAAIApwOjAAIAqASnAAIArAAFAAwAEgAYAB4AJAOnAAIApwKBAAIAqARGAAIAqQREAAIAqgRCAAIArAACAAYADALzAAIAqASpAAIArAABAAQC+AACAKgAAQAEAvoAAgCoAAEABAL5AAIAqAABAAQC+wACAKgABQAMABIAGAAeACQCcwACAKcCdAACAKgCqAACAKkEGAACAKoEgAACAKsABQAMABIAGAAeACQEKwACAKcEKQACAKgELwACAKkELQACAKoEMQACAKwABQAMABIAGAAeACQELAACAKcEKgACAKgEMAACAKkELgACAKoEMgACAKwABQAMABIAGAAeACQEOQACAKcENwACAKgEPQACAKkEOwACAKoEPwACAKwABQAMABIAGAAeACQEOgACAKcEOAACAKgEPgACAKkEPAACAKoEQAACAKwAAQAEBIcAAgCoAAIAEQAlACkAAAArAC0ABQAvADQACAA2ADsADgA9AD4AFABFAEkAFgBLAE0AGwBPAFQAHgBWAFsAJABdAF4AKgCBAIEALACDAIMALQCGAIYALgCJAIkALwCMAIwAMACXAJoAMQDPAM8ANQABAAAAAQAIAAEABgACAAEAAgLVAtYAAQAAAAEACAACAA4ABATeBN8E4AThAAEABAKHAogCmQKaAAQAAAABAAgAAQAmAAIACgAcAAIABgAMAaMAAgBKAagAAgBYAAEABAGpAAIAWAABAAIASgBXAAQAAAABAAgAAQBEAAIACgAUAAEABAGkAAIATQABAAQBpgACAE0ABAAAAAEACAABAB4AAgAKABQAAQAEAaUAAgBQAAEABAGnAAIAUAABAAIASgGjAAEAAAABAAgAAQAGAZUAAQABAEsAAQAAAAEACAABAAYBJwABAAEAugABAAAAAQAIAAEABgGsAAEAAQA2AAEAAAABAAgAAgAcAAIB4wHkAAEAAAABAAgAAgAKAAIB5QHmAAEAAgAvAE8AAQAAAAEACAACAB4ADAIoAioCKQIrAiwCHwIgAiECIgGuAiQCJQABAAwAJwAoACsAMwA1AEYARwBIAEsAUwBUAFUAAQAAAAEACAACAAwAAwImAicCJwABAAMASQBLAiIAAQAAAAEACAACAGYACAI9Ai0CLgIwAjECOQI6AjwAAQAAAAEACAACABYACAAbABUAFgAXABgAGQAdABQAAQAIAa0CIwRxBHIEcwR0BHUEdgABAAAAAQAIAAIAFgAIBHYCIwRxBHIEcwR0Aa0EdQABAAgAFAAVABYAFwAYABkAGwAdAAEAAAABAAgAAgAWAAgAFQAWABcAGAAZABsAHQAUAAEACAItAi4CMAIxAjkCOgI8Aj0AAQAAAAEACAABAAYBaQABAAEAEwAGAAAAAQAIAAMAAQASAAEAUgAAAAEAAAAaAAIAAgF8AXwAAAHUAd0AAQABAAAAAQAIAAEAKAHAAAEAAAABAAgAAgAaAAoCMgB6AHMAdAIzAjQCNQI2AjcCOAACAAEAFAAdAAAAAQAAAAEACAACACYAEAHUAdUB1gHXAdgB2QHaAdsB3AHdAkACPgJBAkICPwJDAAEAEAAUABUAFgAXABgAGQAaABsAHAAdAE0ATgKuA5sDnQQa\",\n  \"Roboto-Medium.ttf\": \"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\",\n  \"Roboto-MediumItalic.ttf\": \"AAEAAAARAQAABAAQR1BPUyEcbY8AAhQcAABZakdTVULEnLdcAAJtiAAAGXxPUy8yoQuw+wAAAZgAAABgY21hcNhuDxIAABpsAAAGXGN2dCAElytKAAAjUAAAAFZmcGdte/lhqwAAIMgAAAG8Z2FzcAAIABMAAhQQAAAADGdseWZgubUGAAAtcAAB42poZG14LxpP7wAAFYAAAATsaGVhZPi2qwsAAAEcAAAANmhoZWEM2xKRAAABVAAAACRobXR4rRqYNAAAAfgAABOIbG9jYSKZqcwAACOoAAAJxm1heHAHEgLZAAABeAAAACBuYW1lRuRz4wACENwAAAMUcG9zdP9hAGQAAhPwAAAAIHByZXAbsfg2AAAihAAAAMwAAQAAAAIAALDh6v1fDzz1ABsIAAAAAADE8BEuAAAAANDbTpf6Qf3VCXgIcwACAAkAAgAAAAAAAAABAAAHbP4MAAAJN/pB/mwJeAgAAbMAAAAAAAAAAAAAAAAE4gABAAAE4gCPABYAVgAFAAEAAAAAAA4AAAIAAfIABgABAAMEGQH0AAUAAAWaBTMAAAEfBZoFMwAAA9EAZgIAAAACAAAAAAAAAAAA4AAK/1AAIX8AAAAhAAAAAEdPT0cAAQAA//0GAP4AAGYHmgIAIAABnwAAAAAEOgWwACAAIAACA5YAZAAKAAAACgAAAfkAAAH5AAACHwA3Ao4AoQTHADsEcwBCBb0AtQUAAC0BWgCQAr8AaALG/5QDeABnBF0APQG//4kClgA2AjUAMAMc/38EcwBgBHMA7wRzAAsEcwAmBHMACQRzAFoEcwBjBHMAhgRzADsEcwCOAhkAKwHi/5oD/AAyBGIAYgQUAC8D0ACVBvsAMgU0/6QE7wAnBRsAZQUcACcEbQAnBE0AJwVSAGsFjQAnAjsANQRZAAME7gAnBD0AJwbVACcFjAAnBWYAawUAACcFZgBkBOIAJwS5ACQEwACcBRkAWwUPAJsG3gC3BPP/wwTFAKEEtv/lAir/7wNIAKwCKv96A1sARAOK/3kCigDKBD0AIgRoABAEGgA4BGsAOwQ0ADsCygBfBHD/9wRZAA0CBQAfAfz/DAQXABECBQAfBssAEARbAA0EdQA5BGj/xwRyADsCxAAQBAsAHAKfADsEWgBKA+EAZAXOAHcD8f+5A9H/tQPx/+cCpAAwAf0AIAKk/5kFMgBbAfkAAAIY/+YEZQBMBJv/9gV8AAgExQBQAff/7ATc/9wDdADRBh4AXgOAAL4DzgBJBFUAgAKWADYGHgBeA8cA7wL9AOQEMwAbAukAVgLpAGcCkQDIBKH/3QPZAH0COwCeAgr/0wLpAOEDlQC+A84AAgWtALkGBgCxBjAAlgPQ/9IFNP+kBTT/pAU0/6QFNP+kBTT/pAU0/6QHVf+HBRsAZQRtACcEbQAnBG0AJwRtACcCOwA1AjsANQI7ADUCOwA1BTr//wWMACcFZgBrBWYAawVmAGsFZgBrBWYAawQtACMFZAAVBRkAWwUZAFsFGQBbBRkAWwTFAKEErwAnBMsAGwQ9ACIEPQAiBD0AIgQ9ACIEPQAiBD0AIgaXAA8EGgA4BDQAOwQ0ADsENAA7BDQAOwIUACICFAAiAhQAIgIUACIEjQBGBFsADQR1ADkEdQA5BHUAOQR1ADkEdQA5BHgAPQRvACoEWgBKBFoASgRaAEoEWgBKA9H/tQR+/80D0f+1BTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBRsAZQQaADgFGwBlBBoAOAUbAGUEGgA4BRsAZQQaADgFHAAnBQEAOwU6//8EiQA7BG0AJwQ0ADsEbQAnBDQAOwRtACcENAA7BG0AJwQ0ADwEbQAnBDQAOwVSAGsEcP/3BVIAawRw//cFUgBrBHD/9wVSAGsEcP/3BY0AJwRZAA0FjgAuBHcAKwI7ADUCFAAUAjsANQIUAB8COwA1AhQAIgI7/44CBf92AjsANQIUACIGlAA1BAEAHwRZAAMCIP8PBO4AJwQXABEEfwAhBD0AJwIFAB8EPQAnAgX/ogQ9ACcCmwAfBD0AJwLhAB8ETAAhAkcAHwWMACcEWwANBYwAJwRbAA0FjAAnBFsADQRbAA0FcgAjBG8AEQVmAGsEdQA5BWYAawR1ADkFZgBrBHUAOQeDAFAHDQBCBOIAJwLEABAE4gAnAsT/nATiACcCxAAQBLkAJAQLABwEuQAkBAsAHAS5ACQECwAcBLkAJAQLABwEwACcAp8AOwTAAJwCxwA7BMAAnAKf/+IFGQBbBFoASgUZAFsEWgBKBRkAWwRaAEoFGQBbBFoASgUZAFsEWgBKBRkAWwRaAEoG3gC3Bc4AdwTFAKED0f+1BMUAoQS2/+UD8f/nBLb/5QPx/+cEtv/lA/H/5wIGAB4FaABOAsT/SgVpAFsEhQA2BYMAWwTWAEoCIP8PBVIAawRw//cFjAAnBFsADQU0/6QEPQAiB1X/hwaXAA8FZAAVBG8AKgU0/6QEPQAiBG0AJwQ0ADsCO//JAhT/fgVmAGsEdQA5BOIAJwLEAAcFGQBbBFoASgS5ACQECwAcBMAAnAKfADsCIP8PBCUANgG5AIoD0gECA54BDQPIAO8DawD+AgUBAgKnAPoCRf+oA8QA3gMRAKwCY//uAAr9VAAK/dcACvz2AAr91gAK/L8ACvygAlUBLgQlAOgFNP+kAjsAngTR/74F8f/GAp//ygV6ABgFKf9YBVAAHQKgAAsFNP+kBO8AJwRdAC4Fnf+qBG0AJwS2/+UFjQAnBVoAXgI7ADUE7gAnBRr/sgbVACcFjAAnBHcAAAVmAGsFjwAuBQAAJwR3/9wEwACcBMUAoQXLAFIE8//DBYkAdQU8AAkCOwA1BMUAoQRrAD4ESAAoBG8AEQKgAG4ESABXBGsAPgSr/+UD+QB3BG8AOARIACgEBQBmBG8AEQSHAGwCoABuBH8AIQRS/6gEof/dA+EAZAP+AD4EdQA5BNcAXQRv/8sEIQA7BHcAOAQXAG4ESABXBa0AMgPx/7kFpwA/BmsAVAKgAEwESABXBHUAOQRIAFcGawBUBJkAUARjAG0Ex/8kBkoAVwRtACcEbQAnBdoAkQRdAC4FOgBnBLkAJAI7ADUCOwA1BFkAAwhQ/8oIVwAuBjQAoATuACcFhwAnBO0AmwWJACUFNP+kBOsAIwTvACcEXQAuBeL/hARtACcHcf+lBLsAHgWHACcFhwAnBQoALgWI/8oG1QAnBY0AJwVmAGsFjwAuBQAAJwUbAGUEwACcBO0AmwY4AFYE8//DBdUAJQVoAMUHawArB8YAKwX1AIkGzQAuBOoAIwUxAE8HJgAyBNv/sAQ9ACIEZQBDBHYAIgNKABgE2v+FBDQAOwZO/60EAQAWBH8AGQR/ABkEVgAiBIH/vwXfACIEfgAZBHUAOQR/ABkEaP/HBBoAOAPhAFMD0f+1BbAAPQPx/7kEuAAZBE4AcAZmABkGwQASBPoATwZIACIEUAAiBCUAIwZcACQEWP+2BDQAOwQ0ADsEWQANA0oAGAQlADsECwAcAgUAHwIUACIB/P8MBqf/vQa5ABkEcAANBFYAIgR/ABkD0f+1BH8AGQcbAGAGKQBEBOoAIwRPACEG+wArBd0AGQTv/64ESP+cBxQAPgYQADAGwgAUBcMAFgj1ADUHxgAiBAr/qgPc/7UFiQB1BacAPwVaAGIEbwA2BP0AqAP5AHcE/QCoA/kAdwk3AGsIRgA5BVoAZgRvADgHFwBiBh4ASwcbAGAGKQBEBP0AVgQzAEUE4wA4AAr85gAK/Q4ACv4rAAr+PAAK+kEACvpvBYcAJwR/ABkE6gAjBE8AIQT2ACcEbf/HBFIAIgOPABEEXf/8A0r/ywSdAC4ECgARB3H/pQZO/60EuwAeBAEAFgUKAC4EVgAiBQ4AIwSRACEFHgA3BC4AGQZsAKQFgwBsBY0AJwR+ABkHngAnBYkAEQgRAC4GygARBgUAZQTjAEsFGwBlBBoAOATAAJwD4QBTBMUAoQP5AHcExQChA/kAVATz/8MD8f+5BwQAnQVQAFYFaADFBE4AcAVUALkEWwCFBWcA5wRZAA0F/wBiBKj/9AX/AGIEqP/0AjsANQdx/6UGTv+tBQQAIwRgACEFiP/KBIH/vwWNAC4EbwARBY0AJwR+ABkFaADFBE4AcAbVACcF3wAiAjsANQU0/6QEPQAiBTT/pAQ9ACIHVf+HBpcADwRtACcENAA7BWgASAQlADYFaABIBCUANgdx/6UGTv+tBLsAHgQBABYEjAAvBIz/8AWHACcEfwAZBYcAJwR/ABkFZgBrBHUAOQVaAGIEbwA2BVoAYgRvADYFMQBPBCUAIwTtAJsD0f+1BO0AmwPR/7UE7QCbA9H/tQVoAMUETgBwBF0ALgNKABgGzQAuBkgAIgSsADMDQwAJBPP/wwPx/7kE8//DA/H/uQTqADAEawA7BsYARQayAEcGLACqBQoAYQRjAJIEJwCMB43/3gZ0/94HygAnBnUACwTnAEwEFgA9BYkAkAUAAHMFNgBWBEgAKAWI/8oEgf+/BTT/pAQ9ACIE7wAnBGgAEAUcACcEawA7BRwAJwRrADsFjQAnBFkADQTuACcEFwARBO4AJwQXABEEPQAnAgX/5AbVACcGywAQBtUAJwbLABAFjAAnBFsADQUAACcEaP/HBOIAJwLE/94EuQAkBAsAHATAAJwCnwA7BQ8AmwPhAGQFDwCbA+EAZAbeALcFzgB3Bt4AtwXOAHcG3gC3Bc4AdwbeALcFzgB3BLb/5QPx/+cFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIEbQAnBDQAOwRtACcENAA7BG0AJwQ0ADsEbQAnBDQAOwRtACcENAA7BG0AJwQ0ADsEbQAnBDQAOwRtACcENAA7AjsANQIUACICO///AgX/5AVmAGsEdQA5BWYAawR1ADkFZgBrBHUAOQVmAGsEdQA5BWYAawR1ADkFZgBrBHUAOQVmAGsEdQA5BWkAWwSFADYFaQBbBIUANgVpAFsEhQA2BWkAWwSFADYFaQBbBIUANgUZAFsEWgBKBRkAWwRaAEoFgwBbBNYASgWDAFsE1gBKBYMAWwTWAEoFgwBbBNYASgWDAFsE1gBKBMUAoQPR/7UExQChA9H/tQTFAKED0f+1BMUAoQPR/7UFrP6zAx4A7AP/AAAH9AAAA/8AAAf0AAACrgAAAgQAAAFcAAAEZgAAAikAAAGfAAAA1QAAAAoAAAKXADYClwA2BQsAnAYKAIIGCgCCA4v/TgG9AK4BuQCKAcr/pAGlAM0DBgC3Aw0AlwL7/6EERQBpBID/+wLAAJ4D5QAzBYUAMwFrADYHdgCdAVoAkAKOAKECaQBdAmD/+QQ+ADcDiv/hAukAYwNMAG4ETf/DBJv/9gZJAA0GjgArCFsAJwdYACoGZAAQBIn/9ARzAE4F0QBCBB4AOwSIABAFP//kBV3/5gXBAMIDzgAxB/kAIwTsAO0E9wB9Bg8AtgayAIIGpwCIBnkAtQR4AEUFdQAfBL7/pwRqAJwEmAA0CA8ASQIm/xcEdQAwBGIAYgP8/9UEFAAXA/cAOgJTAGkCjgBmAez/zwT+AF8EjgBLBKIAXwb2AF8G9gBfBPQAXwaNABcACgAAB/v/qQg1AFwDhv/XBGP/pwSmADoEY/+nA6YACgQ2AC0ETgARBB4ADgQXABQFGwAuBBoAFAUKAC4FJgAuBKEAOwQl/4cCpwEGBL0ACgLpADMC6QAIAukAIwLpABYC6QAKAun/8QLp//QC6f/jAukAbQLpABcEBP/ZBXwAQwU1AHAEyAAAA6YAkwXjAIwEYwBwBGsAOQQlAGIEHgAOBEUACgSmADcEVQAKBKYAOgTCAAoF4gAKA6YACgREAAoDwv/yAfcAGATDAAoEjAA/A7IACgPMAAoEYgAKBGcAOQRIAAoEhf+bAf8A6wOPAQQD9gDcA/YAEwP2ANgD9gDXA48BBAOPAQUDjwEEBEb/pAQlAG0EZwA5BXAAYgQdAFUEegAqAgr/BwGw/7IEFP/WByb/wQcpAAoFdgBiBLwACgRZAAsFOv+DBhT/qQQvAAwEyAALBEUACgSw/8EELwByBT4ACgRzAF0GXAAKBt4ACgU7AEoF+wALBE8ACwRnABMGagAKBG//0gQM//UGav+pBIQACgT9AAoFTgBiBcwAQARDAG0Eqf+kBmwAYgRzAF0EcwAKBdoANwS3ADQELwAMBKYAOgROAAQD4wAeCAEACgTP/9kEbwAQBCYANwR/ADsDkgCkBIcANAR7/8cEhgA7BDQAOwRwADAFWgBvBYEAcQVmAC4FvQByBb8AcgQFAKsEaQAfA6YACgRA/38EpP/RAukAigLpAGQC6QB9AukAiQLpAJYC6QB7AukApgRT/9QEGAAnBm8AOgSaAEcEzwBOAiD/DwIg/w8CFQAiAhX/fQIVACIESAAKBGL/lwRi/5cEJQBiBIX/mwSF/5sEhf+bBIX/mwSF/5sEhf+bBIX/mwRnADkDzAAKA8wACgPMAAoDzAAKAfcAGAH3ABgB9wAYAfcAGATCAAoEpgA6BKYAOgSmADoEpgA6BKYAOgRrADkEmwB0BIcAjgRzAFoEcwAJBHMAJgRzAAsEawA5BGsAOQRrADkEJQBtBIX/mwSF/5sEhf+bBGcAOQRnADkEZwA5BGcAOQRiAAoDzAAKA8wACgPMAAoDzAAKA8wACgSMAD8EjAA/BIwAPwSMAD8EwwAKAfcADQH3ABgB9wAYAff/igH3ABgDwv/yBEQACgOmAAoDpgAKA6YACgOmAAoEwgAKBMIACgTCAAoEpgA6BKYAOgSmADoERQAKBEUACgRFAAoEHgAOBB4ADgQeAA4EHgAOBCUAYgQlAGIEJQBiBGsAOQRrADkEawA5BGsAOQRrADkEawA6BeMAjAQlAG0EJQBtBBT/1gQU/9YEFP/WBIX/mwQI/20E//94AjP/ewSw/9IEYf8sBNL/4gSF/5sESAAKA8wACgQU/9YEwwAKAfcAGAREAAoF4gAKBKYAOgRVAAoEJQBiBCUAbQRG/6QB9wAYBCUAbQPMAAoDpgAKBB4ADgH3ABgB9wAYA8L/8gREAAoELwByBIX/mwRIAAoDpgAKA8wACgTIAAsF4gAKBMMACgSmADoEvQAKBFUACgRnADkEJQBiBEb/pAQvAA0EwwAKBGcAOgQlAG0F2gA3BMgACwQvAHIFfABDBTT/pAQ9ACIEbQAnBDQAOwIU/+QAAAABAAAE5AkKBAAAAgICAwUFBgYCAwMEBQIDAgQFBQUFBQUFBQUFAgIEBQUECAYGBgYFBQYGAwUGBQgGBgYGBgUFBgYIBgUFAgQCBAQDBQUFBQUDBQUCAgUCCAUFBQUDBQMFBAcEBAQDAgMGAgIFBQYFAgUEBwQEBQMHBAMFAwMDBQQDAgMEBAYHBwQGBgYGBgYIBgUFBQUDAwMDBgYGBgYGBgUGBgYGBgUFBQUFBQUFBQcFBQUFBQICAgIFBQUFBQUFBQUFBQUFBAUEBgUGBQYFBgUGBQYFBgUGBgYFBQUFBQUFBQUFBQYFBgUGBQYFBgUGBQMCAwIDAgMCAwIHBQUCBgUFBQIFAgUDBQMFAwYFBgUGBQUGBQYFBgUGBQgIBgMGAwYDBQUFBQUFBQUFAwUDBQMGBQYFBgUGBQYFBgUIBwUEBQUEBQQFBAIGAwYFBgUCBgUGBQYFCAcGBQYFBQUDAgYFBgMGBQUFBQMCBQIEBAQEAgMDBAMDAAAAAAAAAwUGAwUHAwYGBgMGBgUGBQUGBgMGBggGBQYGBgUFBQcGBgYDBQUFBQMFBQUEBQUFBQUDBQUFBAQFBQUFBQUFBgQGBwMFBQUHBQUFBwUFBwUGBQMDBQkJBwYGBgYGBgYFBwUIBQYGBgYIBgYGBgYFBgcGBwYICQcIBgYIBQUFBQQFBQcFBQUFBQcFBQUFBQQEBgQFBQcIBgcFBQcFBQUFBAUFAgICBwgFBQUEBQgHBgUIBwYFCAcIBgoJBQQGBgYFBgQGBAoJBgUIBwgHBgUGAAAAAAAABgUGBQYFBQQFBAUFCAcFBQYFBgUGBQcGBgUJBgkIBwYGBQUEBQQFBAYECAYGBQYFBgUHBQcFAwgHBgUGBQYFBgUGBQgHAwYFBgUIBwUFBgUGBQgHBQUFBQYFBgUGBQYFBgUGBQYEBgQGBAYFBQQIBwUEBgQGBAYFCAgHBgUFCQcJBwYFBgYGBQYFBgUGBQYFBgUGBQYFBgUFAggICAgGBQYFBgMFBQUDBgQGBAgHCAcIBwgHBQQGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUFBQUFBQUFBQUFBQUFBQUFAwIDAgYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBQQFBAUEBQQGBAUJBQkDAgIFAgIBAAMDBgcHBAICAgIDAwMFBQMEBgIIAgMDAwUEAwQFBQcHCQgHBQUHBQUGBgYECQYGBwgHBwUGBQUFCQIFBQQFBAMDAgYFBQgIBgcACQkEBQUFBAUFBQUGBQYGBQUDBQMDAwMDAwMDAwMFBgYFBAcFBQUFBQUFBQUHBAUEAgUFBAQFBQUFAgQEBAQEBAQEBQUFBgUFAgIFCAgGBQUGBwUFBQUFBgUHCAYHBQUHBQUHBQYGBwUFBwUFBwUFBQUECQUFBQUEBQUFBQUGBgYGBgUFBAUFAwMDAwMDAwUFBwUFAgICAgIFBQUFBQUFBQUFBQUEBAQEAgICAgUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUEBAQEBAUFBQUFAgICAgIEBQQEBAQFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBwUFBQUFBQUGAgUFBQUFBAUFAgUHBQUFBQUCBQQEBQICBAUFBQUEBAUHBQUFBQUFBQUFBQUHBQUGBgUFBQIAAAADAAAAAwAAABwAAwABAAAAHAADAAoAAAKkAAQCiAAAAJ4AgAAGAB4AAAACAA0AfgF/AY8BkgGhAbAB8AH/AhsCNwJZArwCxwLJAt0C8wMBAwMDCQMPAyMDigOMA6EDzgPSA9YEhgUTHgEePx6FHvkfTSALIBEgFSAeICIgJyAwIDMgOiA8IEQgdCB/IKQgrCCxILogvSEFIRMhFiEiISYhLiFeIgIiBiIPIhIiGiIeIisiSCJgImUlyu4C9sP7BP7///3//wAAAAAAAgANACAAoAGPAZIBoAGvAfAB+gIYAjcCWQK8AsYCyQLYAvMDAAMDAwkDDwMjA4QDjAOOA6MD0QPWBAAEiB4AHj4egB6gH00gACAQIBMgFyAgICUgMCAyIDkgPCBEIHQgfyCjIKYgsSC5ILwhBSETIRYhIiEmIS4hWyICIgYiDyIRIhoiHiIrIkgiYCJkJcruAfbD+wH+///8//8AAQAA//b/5P/D/7T/sv+l/5j/Wf9U/0j/Lf8M/qr+of6g/pL+ff5x/nD+a/5m/lP98/3y/fH98P3u/ez9w/3C5NbkqOR45GLkD+Ne41rjWeNY41fjVeNN40zjR+NG4z/jEOMG4uPi4uLe4tfi1uKP4oLigOJ14HPiauI+4Zvff+GP4Y7hh+GE4XjhXOFF4ULd3hWoDOgIrAS0A7gAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAAAA7gAAAAAAAAATgAAAAAAAAAAAAAAAQAAAAIAAAACAAAAAgAAAA0AAAANAAAAAwAAACAAAAB+AAAABAAAAKAAAAF/AAAAYwAAAY8AAAGPAAABQwAAAZIAAAGSAAABRAAAAaAAAAGhAAABRQAAAa8AAAGwAAABRwAAAfAAAAHwAAABSQAAAfoAAAH/AAABTgAAAhgAAAIbAAABYAAAAjcAAAI3AAABZAAAAlkAAAJZAAABZQAAArwAAAK8AAABZgAAAsYAAALHAAABZwAAAskAAALJAAABaQAAAtgAAALdAAABagAAAvMAAALzAAABcAAAAwAAAAMBAAABcQAAAwMAAAMDAAABcwAAAwkAAAMJAAABdAAAAw8AAAMPAAABdQAAAyMAAAMjAAABdgAAA4QAAAOKAAABdwAAA4wAAAOMAAABfgAAA44AAAOhAAABfwAAA6MAAAPOAAABkwAAA9EAAAPSAAABvwAAA9YAAAPWAAABwgAABAAAAASGAAABwwAABIgAAAUTAAACSgAAHgAAAB4BAAAC1gAAHj4AAB4/AAAC5gAAHoAAAB6FAAAC+AAAHqAAAB75AAADAgAAH00AAB9NAAADXAAAIAAAACALAAADXgAAIBAAACARAAADagAAIBMAACAVAAADbAAAIBcAACAeAAADbwAAICAAACAiAAADdwAAICUAACAnAAADegAAIDAAACAwAAADfQAAIDIAACAzAAADfgAAIDkAACA6AAADgAAAIDwAACA8AAADggAAIEQAACBEAAADgwAAIHQAACB0AAADhAAAIH8AACB/AAADhQAAIKMAACCkAAADhgAAIKYAACCsAAADiAAAILEAACCxAAADjwAAILkAACC6AAADkAAAILwAACC9AAADkgAAIQUAACEFAAADlAAAIRMAACETAAADlQAAIRYAACEWAAADlgAAISIAACEiAAADlwAAISYAACEmAAABmQAAIS4AACEuAAADmAAAIVsAACFeAAADmQAAIgIAACICAAADnQAAIgYAACIGAAABhQAAIg8AACIPAAADngAAIhEAACISAAADnwAAIhoAACIaAAADoQAAIh4AACIeAAADogAAIisAACIrAAADowAAIkgAACJIAAADpAAAImAAACJgAAADpQAAImQAACJlAAADpgAAJcoAACXKAAADqAAA7gEAAO4CAAADqQAA9sMAAPbDAAADqwAA+wEAAPsEAAADrQAA/v8AAP7/AAADswAA//wAAP/9AAADtLAALEuwCVBYsQEBjlm4Af+FsIQdsQkDX14tsAEsICBFaUSwAWAtsAIssAEqIS2wAywgRrADJUZSWCNZIIogiklkiiBGIGhhZLAEJUYgaGFkUlgjZYpZLyCwAFNYaSCwAFRYIbBAWRtpILAAVFghsEBlWVk6LbAELCBGsAQlRlJYI4pZIEYgamFksAQlRiBqYWRSWCOKWS/9LbAFLEsgsAMmUFhRWLCARBuwQERZGyEhIEWwwFBYsMBEGyFZWS2wBiwgIEVpRLABYCAgRX1pGESwAWAtsAcssAYqLbAILEsgsAMmU1iwQBuwAFmKiiCwAyZTWCMhsICKihuKI1kgsAMmU1gjIbDAioobiiNZILADJlNYIyG4AQCKihuKI1kgsAMmU1gjIbgBQIqKG4ojWSCwAyZTWLADJUW4AYBQWCMhuAGAIyEbsAMlRSMhIyFZGyFZRC2wCSxLU1hFRBshIVktsAossClFLbALLLAqRS2wDCyxJwGIIIpTWLlAAAQAY7gIAIhUWLkAKQPocFkbsCNTWLAgiLgQAFRYuQApA+hwWVlZLbANLLBAiLggAFpYsSoARBu5ACoD6ERZLbAMK7AAKwCyAQ0CKwGyDgECKwG3DjowJRsQAAgrALcBOC4kGhEACCu3Ak5AMiMVAAgrtwNIOy4hFAAIK7cETkAyIxUACCu3BTAoHxYOAAgrtwZjUT8tGwAIK7cHQDQkGhEACCu3CFtKOikZAAgrtwmDZE46IwAIK7cKd2JMNiEACCu3C5F3XDojAAgrtwx2YEs2HQAIK7cNLCQcFAwACCsAsg8NByuwACBFfWkYRLKwEwFzslATAXSygBMBdLJwEwF1sg8fAXOybx8BdQAqAMwAkQCeAJEA7AByALIAfQBWAF8ATgBgAQQAxAAAABT+YAAUApsAEP85AA3+lwASAyEACwQ6ABQEjQAQBbAAFAYYABUGwAAQAlsAEgcEAAUAAAAAAAAAAABgAGAAYABgAGAAnQDIAUYB1QKDAxYDMQNgA4sDvgPmBAUEHARFBFwEvQTsBUUFwAYGBnEG4gcQB5kICAgUCCAIQQhpCIoI+Qm1CfUKYwrDCxMLVguOC/gMOwxWDJAM2Qz+DVgNlg36DkoOtQ8RD4cPsw/5ECoQeRDDEPURLxFVEWwRkxG6EdUR9RKCEu0TQxOrFCcUfxUMFVYVlBXmFi8WSxbDFxIXbRfaGEsYixkEGVwZqhnaGikacRq1Gu8bPRtUG6Ib5xvnHCQciBz2HWMdyh3rHosewh93H/Af/CAaICIg5iD9IT8hhCHdIlIiciLEIvMjFyNJI3gjzSPZI/MkDSQnJJgkryTGJN0k7yUCJRUleiWGJZ0ltCXLJd4l9SYMJiMmNiajJrUmzCbeJvAnAicVJ1EnzyfmJ/0oFCgsKEMomykQKScpPilUKWopgimaKn8qiyqiKrkqzyrmKvwrEispK0EruyvRK+gr/ywVLCssPSyZLRctLi1ALVEtZC12Ldkt6y4CLhMuJS43LqcvVi9oL3ovjC+dL68vwS/TL+Qv+zAHMHQw/DETMSQxNjFHMVkxazHfMn4ylTKmMrgyyTLbMuwy/jMQMxwzLjNFM1czujQkNDY0SDRfNHY0iDSaNKU0sDTCNN006TT1NQc1HjUqNTY1hDWbNbI1vjXKNd817zX7Ngc2UzaTNqo2vDbINtQ26zb8Nww3aDfLN9037jgAOBI4JTg4OMY5gzmVOac5szm/OdE54jn0OgY6GDopOjU6QTpTOmQ6cDp8OpM6nzrlO1g7ajt7O407njuwO8I71TvoO/s8Djx5PPI9CT0gPTc9TT1gPXc9jj2gPbI9xD3VPgo+fD7nP2I/1kAzQJlAq0C9QM9A5kD9QQlBFUEsQT5BVUFsQYRBnEG0QcxB5EH8QhRCLEJEQlxCdEKMQphCpEKwQrxC60NVQ2FDnEPEQ8xD/EQiRGFEjkTVRQtFUUVwRZBFmUXLRf1GHkY3RolGlEacRqhGtEbARsxG2EbkRvpHAkcKRzFHXkdmR25HdkgASAhIEEg9SEVITUiPSJdIx0jPSQ1JFUkdSZtJo0oDSnJKhUqYSqpKvErOSt9K9Et+S/lMLUytTT5Nm03qTnFOok6qTwVPDU8VT4xPlE/sUE9Qt1EnUW9RulIqUjJSlFMPUyJTNFNGU1hTalPqVERUUFTPVOZU+VVhVXhV91ZtVnVWiFaQVw5XhVfgV/dYDlggWF9YZ1jDWMtY01ksWTRZoVopWmRadlp+Wspa0lraWuJa6lryWvpbAltHW8JbylwCXElciVzVXTBdmF3pXmle9V9VX11f22BcYINg3GDkYVNh6WIkYjZiiGLRYxxjdWN9Y61jtWQLZDhkQGTgZOhlIGVoZahl8GZLZrFnAGdzZ/5oXWh0aIZpBWkcaYVpjWmVaahpsGopaqBrCmshazhrSWuIa/lsZWzSbUBty25YbqVu9G9hb9BwSHC6cUxx3HJ5cyhzMHM4c7V0JXRpdK50xnTedOp09nVqddh2s3eIeBh4qHkFeV95k3mweel6AHoXevJ7YXt8e5d8BHxzfM99S317faV95n4ofoR+037ffut+938Dfw9/G391f8yALICKgNyBM4E/gUuBmIHpgk+CqYNUg++D+4QHhBOEH4QnhC+Ee4TLhNeE44UshXKFfoWKheGGMYZ2hn6HAIeNh5mHpYeth7+H0YgziI6ImoimiQmJZ4lziX+Ji4mXiaOJr4m3icmJ24nuigGKCYoRiiOKNIqniq+KworUiueK+osNix+Lhovni/6MFIwnjDqMTYxfjGeMb4yCjJSMp4y5jMuM3IzvjQGNFI0sjT+NUY1djWmNhY2hjbCNwI3MjdiOMo6JjtyO5I9Oj+eQY5DakU2Ru5Iukp2TEJOCk+OUOpSTlOqVb5V3lYOVj5WblaeVs5W/lcuV15Xjle+V+5YHlhmWK5Y3lkOWT5ZblnKWhJaQlpyWqJa0lsaW2JbklvCW/JcIlxSXIJcyl0OXT5dbl3KXiZegl7eXypfdl+mX9ZgBmA2YGZglmDeYSZhhmHiYkJinmL+Y1pjumQWZIJk6mVKZaZl8mY6ZoZmzmcaZ2Jnzmg6aGpommjiaSppcmm2ahZqcmrSay5rjmvqbEpspm0SbXptwm4Kbjpuam6abspvEm9ab7pwFnB2cNJxMnGOce5ySnK2cx5zenPWdDJ0jnTqdUZ1onX6dip2WnaKdrp3Fndyd854KniGeOJ5PnmaefZ6Tnp+eq57Cntie5J7wnwKfFJ8mnzefQ59vn2+fb59vn2+fb59vn2+fb59vn2+fb59vn3eff5+Jn5OfnZ+4n9qf/KAboD2gSaBVoIigyaEuoVOhX6FvoYiicqKBopiitKLRot2i8KMEo0+jW6PqpJOlLqU6pgymd6aRpxin1Kg3qLipF6mMqj2qqqtIq6msE6wtrEesYax7rPStHK1WrW2toq5Broiu/69Ar0+vXq+Xr6qv1K/tr/mwaLDKsXKyDrKas3CzcLU2tZ+16rYbtpi2zrb5t3O33rhduKC45LksuXa57bpkuyi7fLuvvBy8rLzZvUG9qr3vvmS+vL7mvzi/fL/twE3AuMDPwRrBSsGNwbnCMcKMwu/DPcOew9jEK8RQxJXEy8TmxUPFr8Xqxi/GfcbZx2jHpsfFyBPIWsigyP7JdMnDyiTKmcrjyxTLj8vxzB7MqMzZzO/NBc16zfDOSM6KzubPPc+60BvQWdCz0PfRQNF70cLR/dI+0prSptL302/T/NRa1J/VJ9WO1ffWXNbz1v/XUteh1/XYPdix2RrZgNoA2pjbIdvD3ETcsd0J3XPde93c3kXes98t37TgFOCD4NPhPuGt4djiM+Jh4r7jCOMc4zDjQuNW42jjf+OT4/bkHeSn5RjlduV+5YbljuWZ5aHmD+Y65mXmdeaM5qPmuebK5t3m8Ob85wjnH+c250znXud054rnoee058bn3efv6ADoEugl6DzoROhM6FToXOhk6GzofuiP6KLouejP6OHpVeln6Xjpiumb6bHpx+nY6erqXup06oXql+qp6rXqy+rd6vTrBusR6yLrOetF61vrZ+t864jrn+ur68Lr0+vl6/jsCuwW7CfsOexK7FbsZ+xz7Insleym7Lfsyezc7O/tWe1w7YbtmO2v7cHt++4H7hPuH+4r7jfuQ+5P7lfuX+5n7m/ud+5/7ofuj+6X7p/up+6v7rfuyu7c7u7vAO8I7xDvI+8r7z3vT+9X71/vZ+9v74Hvie+R75nvoe+p77Hvue/B8F3w0vE68ULxTvFg8XHxefGF8ZHxnfGp8bUAAAAFAGQAAAMoBbAAAwAGAAkADAAPAG+yDBARERI5sAwQsADQsAwQsAbQsAwQsAnQsAwQsA3QALAARViwAi8bsQIfPlmwAEVYsAAvG7EADz5ZsgQCABESObIFAgAREjmyBwIAERI5sggCABESObAK3LIMAgAREjmyDQIAERI5sAIQsA7cMDEhIREhAxEBAREBAyEBNQEhAyj9PALENv7u/roBDOQCA/7+AQL9/QWw+qQFB/19Anf7EQJ4/V4CXogCXgACADf/7wIgBbAAAwAOADuyAg8QERI5sAIQsAvQALAARViwAi8bsQIfPlmwAEVYsAwvG7EMDz5ZsgcNCitYIdgb9FmwAdCwAS8wMQEjEzMBNDY3NhYUBgcGJgFWzJz6/hdLOjlOSzo3UAGtBAP6vztMAgJKcksCAkcAAAIAoQP0AsIGAAAEAAkAJQCwAEVYsAMvG7EDIT5ZsALQsAIvsAfQsAcvsAMQsAjQsAgvMDEBAyMTMwUDIxMzAYdcilOqAQ1cilOqBWz+iAIMlP6IAgwAAgA7AAAE5QWwABsAHwCNALAARViwDC8bsQwfPlmwAEVYsBAvG7EQHz5ZsABFWLACLxuxAg8+WbAARViwGi8bsRoPPlmyHQwCERI5sB0vsgADCitYIdgb9FmwBNCwHRCwBtCwHRCwC9CwCy+yCAMKK1gh2Bv0WbALELAO0LALELAS0LAIELAU0LAdELAW0LAAELAY0LAIELAe0DAxASMDIxMjNzMTIzchEzMDMxMzAzMHIwMzByMDIwMzEyMCltORqpHeHPpv6RwBBZWpldSUqZTHHORu1BzxkakJ02/TAZr+ZgGangE5nwGg/mABoP5gn/7Hnv5mAjgBOQAAAQBC/y0EUQabADUAb7InNjcREjkAsABFWLAQLxuxEB8+WbAARViwJy8bsScPPlmyBCcQERI5sBAQsA3QshUnEBESObAQELIYAQorWCHYG/RZsAQQsh8BCitYIdgb9FmwJxCwKtCyLhAnERI5sCcQsjIBCitYIdgb9FkwMQE2JyYnJiYnJjc2NzY3NzMHFhcWByM2JicmBgcGFxYXFhcWBwYHBgcHIzcmJyY3FwYWFxY3NgL+CSkodjteJKoOC3JxtSidKZVKTArsCVRYXXwNCSgodHU+uA8Ld3W9JJwlp1lYCe0HZWNqR0kBg0w4OTEZMxyBz6psbRXa3iB4er6AjAMCb2NNNTYzNCyC2q1raRTDxBl6eb8BgIYCAjk6AAUAtf/nBT4FyAANABsAKQA3ADsAibInPD0REjmwJxCwBdCwJxCwFtCwJxCwK9CwJxCwONAAsDgvsDovsABFWLAALxuxAB8+WbAARViwIy8bsSMPPlmwABCwB9CwBy+yEQIKK1gh2Bv0WbAAELIYAgorWCHYG/RZsCMQsBzQsBwvsCMQsi0CCitYIdgb9FmwHBCyNAIKK1gh2Bv0WTAxARYWBwcGBicmJjc3NjYDBhYXFjY3NzYmJyYGBwEWFgcHBgYnJiY3NzY2AwYWFxY2Nzc2JicmBgcFJwEXAg+DkggGD7mCfpkIBw23JAc4OjxYCwkHODs9WggCvYKTCAYOuoJ8mgYFC7kiBTo3PVUMCgU6N0BYCP3xeANveAXGBKqATYmmBAKqf0qJqv6BQFcCAldGTkFYAgJdSv4CBKp+ToepBAKmhEGOrf6CRVMCAlNLT0hQAgJdSO5PBGdPAAMALf/pBKEFyAAeACgANABysi01NhESObAtELAR0LAtELAh0ACwAEVYsAkvG7EJHz5ZsABFWLAYLxuxGA8+WbAARViwHC8bsRwPPlmyEgkYERI5shUJGBESObIfAQorWCHYG/RZsiMJGBESObIsCRgREjmwCRCyMgEKK1gh2Bv0WTAxEzY3NyYmNzY2Fx4CBwYGBwcTNjc3AgcXIScGJyYmBRY2NwMHBgcGFhMGFxc3Njc2JiMiBjgMxnI9KAQM5KxdllAFBWl2edZTFcsYoKH+/j2wx7vsAbdEeDjzIokRDGhwCjAXY4EMBkg3SGQBgbaMS3CNP6rUBANSkVdanVJQ/rx8kAH+8K36X3YEAt4eATQjAXEWYHdgeAOgRVwqPlJqOUlpAAEAkAP8AZYGAAAEABYAsABFWLADLxuxAyE+WbAC0LACLzAxAQMjEzMBgVSdUbUFd/6FAgQAAAEAaP4xAyAGYAARABCyBhITERI5ALADL7AMLzAxExIANxcAAwYHBhIXByYCEzY3gDUBT/gk/qpmJQECZGI4q7cIAgwCTAFtAjlukP74/czOv8v+0VeFagHAASpgVgAB/5T+LwJQBl8ADwAQsgkQERESOQCwCC+wAC8wMQMnNhITNxAnNxYWEgcCAgBHJdTwGgTEOXOjTwQJs/7e/i+KpQIvAX98AaWshkb9/qS1/un99f6XAAEAZwJLA6UFsAAOACAAsABFWLAELxuxBB8+WbAA0BmwAC8YsAnQGbAJLxgwMQElNwUTMwMlFwUTBwMDJwF//uhPARctsEsBLhj+wZeVfNyGA9FYoXcBXf6ocLRY/vFiASH+7G4AAAEAPQCSBC4EtgALABoAsAkvsADQsAkQsgYBCitYIdgb9FmwA9AwMQEhByEDIxMhNyETMwK9AXEn/pBL50z+jCgBckbnAyHe/k8Bsd4BlQAAAf+J/rgBFADrAAcAGLIHCAkREjkAsAgvsgQNCitYIdgb9FkwMRMnNjc3MwcGCH92GyXVGij+uFCed86h9wABADYCCQJYAs0AAwARALACL7IBAQorWCHYG/RZMDEBITchAjX+ASMB/wIJxAAAAQAw//IBQwEDAAsAIrIIDA0REjkAsABFWLAJLxuxCQ8+WbIDDQorWCHYG/RZMDE3NDY3NhYVFAYHBiYwTTw7T0w9O091PU0CAks7Ok0CAkoAAAH/f/+DA4IFsAADABMAsAAvsABFWLACLxuxAh8+WTAxFyMBM0PEAz7FfQYtAAACAGD/5wQ6BckAEQAgAEayFyEiERI5sBcQsADQALAARViwCS8bsQkfPlmwAEVYsAAvG7EADz5ZsAkQshYBCitYIdgb9FmwABCyHgEKK1gh2Bv0WTAxBSYmNzY3ExIAFxYWBwYHBwIAEzY1JicmBgcDBhcUFxYTAd+9wgMBCScxARjevMMDAQknM/7riA0FoHqUHi4MAaTiQRQE/eRKSgEEATIBLgUE+ORLSf3+x/7NA5ByMOIHBbzN/sNnPOoHDQFuAAEA7wAAA3gFtQAGADkAsABFWLAFLxuxBR8+WbAARViwAC8bsQAPPlmyBAAFERI5sAQvsgMBCitYIdgb9FmyAgMFERI5MDEhIxMFNyUzAoHsyv6QJQJAJASMetfMAAABAAsAAAQ/BccAGABVsgkZGhESOQCwAEVYsBAvG7EQHz5ZsABFWLAALxuxAA8+WbIDEAAREjmwEBCyCAEKK1gh2Bv0WbIMEAAREjmyFRAAERI5sAAQshcBCitYIdgb9FkwMSEhNwE2NzYmJyYGBwc+AhcWFgcGBwcBIQPC/EkcAl2pEQ1aWm+YEOwKj+2Kvt0NEeQ+/lsCh7ECRaWGX38EBJN/AYbWdwME1LLM4z3+dAAAAQAm/+gEOQXFACoAZ7IIKywREjkAsABFWLAPLxuxDx8+WbAARViwGy8bsRsPPlmwAdCwAS+wDxCyBwEKK1gh2Bv0WbAPELAL0LABELIpAQorWCHYG/RZshUpARESObAbELAg0LAbELIjAQorWCHYG/RZMDEBFzI2NzYmJyYGBwc+AhcWFgcGBgcWFxUGBCcuAjcXBhYXFjY3NiYnJwGggXWcCwteXV6KDu0JiNt/w+ENB4Z/rQsN/tnWe8RpBOwEZ2NtmQwMc2yZA0cBfmljcQICcl0BdbhjAQTbuGSnPFDGMMT0BAFnu3gBYHUDBIhub3QDAQAAAgAJAAAEKgWwAAoADgBJALAARViwCS8bsQkfPlmwAEVYsAQvG7EEDz5ZsgEJBBESObABL7ICAQorWCHYG/RZsAbQsAEQsAvQsggGCxESObINCQQREjkwMQEzByMDIxMhNwEzASETBwN6sCKvOe04/Z4VAwL9/QcBaXEYAgfD/rwBRKADzPxXAmMiAAABAFr/5wRzBbAAHQBqshoeHxESOQCwAEVYsAEvG7EBHz5ZsABFWLANLxuxDQ8+WbABELIDAQorWCHYG/RZsgcBDRESObAHL7IaAQorWCHYG/RZsgUHGhESObANELIUAQorWCHYG/RZshEUGhESObIdGhQREjkwMRMTIQchAzYzFhIHBgAnJiYnMxYWFxY2NzYmJyYGB7q/Avoh/c9nZni5xxIS/tzXtuMG4wdlW2+XDwxqaUBlMALVAtvS/qM6Av701dv+6gQE4rlmcwIDqIx8mQICLSgAAgBj/+gEEwW4ABcAJQBbshkmJxESObAZELAG0ACwAEVYsAAvG7EAHz5ZsABFWLAPLxuxDw8+WbAAELICAQorWCHYG/RZsgcADxESObAHL7IYAQorWCHYG/RZsA8QsiABCitYIdgb9FkwMQEHJyYEBzYXHgIHDgInJiYnJjcSACEBJgYHBhcUFhcWNjc2JgPMFA3A/uZQhKl1pEwMDI7liK3YDwkgQQGpAUj+tFCMMAsBXlhslw8NYAW4ygEC09aABAJ/3YKO7YEDBO7Ca7MBZQGW/UkCWVJlK4CWAgOoiH+iAAEAhgAABJwFsAAGADIAsABFWLAFLxuxBR8+WbAARViwAS8bsQEPPlmwBRCyAwEKK1gh2Bv0WbIAAwUREjkwMQEBIQEhNyEEhf0E/v0C+f0qHwPUBR364wTtwwAAAwA7/+gERQXIABYAIgAuAGuyGi8wERI5sBoQsBLQsBoQsCfQALAARViwEy8bsRMfPlmwAEVYsAgvG7EIDz5ZsCzQsCwvshoBCitYIdgb9FmyAiwaERI5sg0aLBESObAIELIgAQorWCHYG/RZsBMQsiYBCitYIdgb9FkwMQEGBxYWBwYEJyYmNzYlJiY3NiQXHgIBNiYnJgYHBhYXFjYTNiYnJgYHBhYXFjYEPBLuWVcIDf7g1cLlDRIBEUtIBg4BDMd3tVr+tQtkXmqWDAtmXWyTYAlVU1uBCwlWUVyBBDjZdzmwasDtBATftfN9NqFcvOUEA2S0/PhlgwICj21newICigL7WnYCAoBmXnICAoIAAAIAjv/5BC8FyAAYACYAWLIZJygREjmwGRCwFdAAsABFWLANLxuxDR8+WbAARViwFi8bsRYPPlmyAAEKK1gh2Bv0WbIFFg0REjmwBS+yGQEKK1gh2Bv0WbANELIhAQorWCHYG/RZMDE3FiQ3BicuAjc+AhceAhcWBwIAISM3ARY2PwI2JicmBhcWFvfUAQpCiJhxplIMDY/kh3WtYAcFHED+XP68FhMBSkqEMA0EA1hYfaAPB1rCAtHRhAICd+CIkfKEBANx0YFroP6O/njKAdoCVUthRoKZBAT4qFls//8AK//yAdAEVAAmABL7AAAHABIAjQNR////mv64AbwEVAAnABIAeQNRAAYAEBEAAAEAMgCqA8MEVAAGABeyAAcIERI5ALAARViwBS8bsQUbPlkwMQEFBwE3AQcBMgIWKf0TIgNvLQJy4OgBdcEBdP4AAAIAYgFkBBQD1gADAAcAJQCwBy+wA9CwAy+yAAEKK1gh2Bv0WbAHELIEAQorWCHYG/RZMDEBITchAyE3IQPx/LokA0Vt/LsjA0YDDMr9jskAAQAvAJ8D2QRJAAYAF7IABwgREjkAsABFWLACLxuxAhs+WTAxASU3AQcBNwLb/c8oAwci/HgsAoHj5f6Lwf6M+gAAAgCV//ED3wXJABgAJABesh4lJhESObAeELAK0ACwAEVYsBAvG7EQHz5ZsABFWLAiLxuxIg8+WbIcDQorWCHYG/RZsADQsAAvsgQQABESObAQELIJAQorWCHYG/RZsg0QIhESObIVABAREjkwMQE+Ajc2JyYmJyYGBwc2JBcWFgcGBwcGBwE0Njc2FhUUBiMGJgE/DF3LH14SCEg5UnER7BEBAL6xyg4PvXpeFP7WSzo4Tk82OE4Bq32wrCRsdjQ9AQJjVQGy0gQEzqqxo2ZWjf7FO0wCAko5PUkCRwAAAgAy/jsGpAWTADsARwB8sh5ISRESObAeELBF0ACwKy+wNC+wAEVYsAAvG7EADz5ZsABFWLAFLxuxBQ8+WbIDNAAREjmyDDQAERI5sAwvsAAQsj4ECitYIdgb9FmwFNCwNBCyHQIKK1gh2Bv0WbArELImBAorWCHYG/RZsAwQskQECitYIdgb9FkwMQUmJicGJyYmNzYSNhcWFhcDBwYWFxY2Ejc2JicmJyYEAgIHBhIWFxY3FwYjJiQCJyYSACQXFgQSFxYCBgEGFxY2NxMmJyYGBwSmTXYUg4tyegkHn+KEVYVDhggHKC9ZiVYHBDs8ffKn/trrhQcIadufpq0biuXD/t2cBASeASABb8nAARqaBASB5/1jBWo4dx2BLSmCsSQVAkpOnAMCtaChAU+uAgI5MP3JPD9JAgSQAROshtZHkgQDkf7f/ou+rf70iwECS4xWAaQBONPdAcABWrEDA6L+ycjT/pLEAUyiAwNrTAHxEQIF++UAAAL/pAAABK4FsAAHAAoARgCwAEVYsAQvG7EEHz5ZsABFWLACLxuxAg8+WbAARViwBi8bsQYPPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMhATMBIwEhAwN9/d+u/vYDEt4BGvj+DgGYYwFT/q0FsPpQAh8CWgAAAwAnAAAEvAWwAA0AFgAeAGmyGB8gERI5sBgQsA3QsBgQsBDQALAARViwAi8bsQIfPlmwAEVYsAAvG7EADz5ZsBfQsBcvsp8XAV2yDgEKK1gh2Bv0WbIHDhcREjmwABCyEAEKK1gh2Bv0WbACELIdAQorWCHYG/RZMDEzEwUWFgcGBxYWBwYEIwMDBTI2NzYmJyUXMjY3NiclJ/0Bv+ztDhLxWmIHDv7b8K1PAQN1pA8OWmj++ON6mg4Z1v7/BbABAcu01GsgqnbI6AKR/jkBfGxndAS7AXRjuwcBAAEAZf/oBQ0FxwAeAE6yCx8gERI5ALAARViwDC8bsQwfPlmwAEVYsAMvG7EDDz5ZsgAMAxESObIQDAMREjmwDBCyEwEKK1gh2Bv0WbADELIcAQorWCHYG/RZMDEBBgAnLgInJhISJBcWEhcjJiYnJgYPAgYWFhcEEwSqJf6w8YvRdgcGRMEBGazZ/Qj1BXl3o9wmFAkILXJYARdPAdvk/vEEA37xmHIBiQE4ngME/vfpnIsDBfTphWZntV8DCwEtAAIAJwAABOAFsAALABYARrIKFxgREjmwChCwD9AAsABFWLABLxuxAR8+WbAARViwAC8bsQAPPlmwARCyDAEKK1gh2Bv0WbAAELIOAQorWCHYG/RZMDEzEwUyBBIHBwYCBCMTAxcyJDc2JyYmJyf8AYq2AQd2Fwsezf68wiq2ksYBBSUaBwmXhgWwAbX+wcBPyf7JrATk++YB+92YcZGkBAABACcAAAS6BbAACwBOALAARViwBi8bsQYfPlmwAEVYsAQvG7EEDz5ZsgsGBBESObALL7IAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASEDIQchEyEHIQMhA9P9vE4CpiP8Y/wDlyT9YUYCRQKK/kDKBbDM/m4AAAEAJwAABKcFsAAJAEAAsABFWLAELxuxBB8+WbAARViwAi8bsQIPPlmyCQQCERI5sAkvsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASEDIxMhByEDIQPB/chr9/wDhCT9dEsCOQJp/ZcFsMz+TwABAGv/6gUWBcgAIQBbsh8iIxESOQCwAEVYsA0vG7ENHz5ZsABFWLADLxuxAw8+WbANELAQ0LANELITAQorWCHYG/RZsAMQshsBCitYIdgb9FmyIA0DERI5sCAvsh8BCitYIdgb9FkwMSUGBCcuAicmEhI3NhcWFhcnAicmBgcGBwYWFxY3EyE3IQSQUP7ctJDcgQkHQKV2oM7b9xDvFuOq2ygXAgaPia9xNv7cIgIXvWhrAgF/85t4AXQBIVJvBAT03AEBAQcF+euJV7POAgRbAR3AAAEAJwAABYcFsAALAFOyBwwNERI5ALAARViwBi8bsQYfPlmwAEVYsAovG7EKHz5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmyCQYAERI5sAkvsgIBCitYIdgb9FkwMSEjEyEDIxMzAyETMwSK9nD9inD3/fdqAnZp9wKH/XkFsP2iAl4AAQA1AAACKAWwAAMAHQCwAEVYsAIvG7ECHz5ZsABFWLAALxuxAA8+WTAxISMTMwEr9v32BbAAAQAD/+cEYQWwAA4ANrIMDxAREjkAsABFWLAALxuxAB8+WbAARViwBS8bsQUPPlmyCAAFERI5sgsBCitYIdgb9FkwMQEzAwYEJyYmNxcGFxY2NwNr9q4f/uPRzNcK9g7AZI8VBbD8A9T4BATqxwHlBASGegABACcAAAVxBbAADABTALAARViwBC8bsQQfPlmwAEVYsAgvG7EIHz5ZsABFWLACLxuxAg8+WbAARViwCy8bsQsPPlmyAAQCERI5tGoAegACXbIGBAIREjm0ZQZ1BgJdMDEBBwMjEzMDNwEhAQEhAjPITff993WZAfYBPP14AZn+7AJzt/5EBbD9Y58B/v1v/OEAAAEAJwAAA8MFsAAFACgAsABFWLAELxuxBB8+WbAARViwAi8bsQIPPlmyAAEKK1gh2Bv0WTAxJSEHIRMzAUECgiT8iP33ysoFsAAAAQAnAAAGzgWwAA4AbgCwAEVYsAAvG7EAHz5ZsABFWLACLxuxAh8+WbAARViwBC8bsQQPPlmwAEVYsAgvG7EIDz5ZsABFWLAMLxuxDA8+WbIBAAQREjm0ZQF1AQJdsgcABBESObRqB3oHAl2yCgAEERI5tGoKegoCXTAxARMBIQMjExMBIwsCIxMCXtUCVwFE/PZVgf2ost9bUfb9BbD7pgRa+lAB7QJf+7QEbf1m/i0FsAAAAQAnAAAFhgWwAAkATLIBCgsREjkAsABFWLAFLxuxBR8+WbAARViwCC8bsQgfPlmwAEVYsAAvG7EADz5ZsABFWLADLxuxAw8+WbICBQAREjmyBwUAERI5MDEhIwEDIxMzARMzBInv/jm19/3vAce29gQT++0FsPvpBBcAAAIAa//nBSEFyAASACIARrIZIyQREjmwGRCwANAAsABFWLAKLxuxCh8+WbAARViwAC8bsQAPPlmwChCyGAEKK1gh2Bv0WbAAELIfAQorWCHYG/RZMDEFLgInJhISNzYXFgAXFgICBwYTNzYmJicmBgIHBhYXFhI3AleO13gIBzuXaa3j2AEBDAY5i2ey2gkGMndbfsN5CgqEhK3hIxQDgvedfQFOARNXjgQE/t73fP6//vNanAMYam25YQMElv7O57fSBAUBDvUAAgAnAAAFBAWwAAoAEwBNsgoUFRESObAKELAM0ACwAEVYsAMvG7EDHz5ZsABFWLABLxuxAQ8+WbILAQMREjmwCy+yAAEKK1gh2Bv0WbADELITAQorWCHYG/RZMDEBAyMTBTIEBwYEIyUFMjY3NiYnJQF8Xvf9AfjkAQQREv7K+/7vARuGqxEOb3D+zAId/eMFsAH5zdT5zAKIem+HBQEAAAIAZP8EBRoFyAAWACYARrIDJygREjmwAxCwJNAAsABFWLAOLxuxDh8+WbAARViwBS8bsQUPPlmwDhCyHAEKK1gh2Bv0WbAFELIjAQorWCHYG/RZMDElFwclBicmACcmEhI3NhceAhcWBwcCAzc2JiYnJgIDBhYWFxYSNwOr0K7/AFAv1f79DAY7nXOo2JDWegcECgw+rQkGM3hbxPEOBjR3WaXiKFbIivQMAQIBJPZ9AUkBHlmCBAOC+5xWVlf+bgHtam64YAMG/pf+uG+6YQMHAQDzAAACACcAAATYBbAADgAXAFqyBRgZERI5sAUQsBDQALAARViwBC8bsQQfPlmwAEVYsAIvG7ECDz5Zsg8CBBESObAPL7IBAQorWCHYG/RZsgsBDxESObACELAO0LAEELIXAQorWCHYG/RZMDEBIQMjEwUyFgcGBgcTByEBFzI2NzYmJyUClv7qYvf9Acvt/BELppbXAf76/lLvga0PD25w/vgCMf3PBbAB5MuNzzv9pg8C/AKHdHF5BAEAAQAk/+oEuwXHACkAYbIDKisREjkAsABFWLAKLxuxCh8+WbAARViwHy8bsR8PPlmyAx8KERI5sAoQsA7QsAoQshIBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WbAfELAk0LAfELInAQorWCHYG/RZMDEBNicnJiY3PgIXHgIHJzYmJyYGBwYXFxYWBw4CJy4CNxcGFhcWNgNMFrNR4r4JCJn6jYjUcAT2B3N0daEOFL5L5bYLCo77l4/pfAX3CIqBeKEBfpBGHk/Yj3y9ZgMDccmBAXJ+AwJyYX9JG1Ldl3u3ZAIBdtGFAXyGAgJqAAABAJwAAAUiBbAABwAuALAARViwBi8bsQYfPlmwAEVYsAIvG7ECDz5ZsAYQsgABCitYIdgb9FmwBNAwMQEhAyMTITchBP7+SNn22v5LJARiBOT7HATkzAAAAQBb/+YFLwWwABIAPLIPExQREjkAsABFWLAALxuxAB8+WbAARViwCS8bsQkfPlmwAEVYsAQvG7EEDz5Zsg4BCitYIdgb9FkwMQEDBgAnJgI3NxMzAwYWFxY2NxMFL6Ui/rXr2v0LA6X2pRJ2e4e0GacFsPwz6f7sBAQBAM4mA878MYucBASakAPUAAABAJsAAAWBBbAABgA4sgAHCBESOQCwAEVYsAEvG7EBHz5ZsABFWLAFLxuxBR8+WbAARViwAy8bsQMPPlmyAAEDERI5MDEBASEBIwEhAlECGAEY/SDv/ukBBgE/BHH6UAWwAAEAtwAABzoFsAAMAGCyBQ0OERI5ALAARViwAS8bsQEfPlmwAEVYsAgvG7EIHz5ZsABFWLALLxuxCx8+WbAARViwAy8bsQMPPlmwAEVYsAYvG7EGDz5ZsgABAxESObIFAQMREjmyCgEDERI5MDEBATMBIwMBIwMzEwEzBLsBhPv91uxl/kjuYu8wAbfPAWoERvpQBCT73AWw+78EQQAAAf/DAAAFRwWwAAsAUwCwAEVYsAEvG7EBHz5ZsABFWLAKLxuxCh8+WbAARViwBC8bsQQPPlmwAEVYsAcvG7EHDz5ZsgABBBESObIGAQQREjmyAwAGERI5sgkGABESOTAxAQEhAQEhAwEhAQEhAqMBegEq/dsBPv7u3P58/tUCMf7JARADowIN/SP9LQIV/esC6QLHAAEAoQAABU0FsAAIADEAsABFWLABLxuxAR8+WbAARViwBy8bsQcfPlmwAEVYsAQvG7EEDz5ZsgABBBESOTAxAQEhAQMjEwEhAnMBvAEe/X5b+GD+yQEFAwACsPxb/fUCJQOLAAAB/+UAAATnBbAACQBEALAARViwBy8bsQcfPlmwAEVYsAIvG7ECDz5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIQchNwEhNyEHAToC7CT74x8Djf0yJAQAHsrKsAQ0zKwAAAH/7/68ArUGjgAHACIAsAQvsAcvsgABCitYIdgb9FmwBBCyAwEKK1gh2Bv0WTAxASMDMwchASECl5/+oB7+cwE5AY0F0PmpvQfSAAABAKz/gwLIBbAAAwATALACL7AARViwAC8bsQAfPlkwMRMzASOs4AE84AWw+dMAAf96/rwCQwaOAAcAJQCwAi+wAS+wAhCyBQEKK1gh2Bv0WbABELIGAQorWCHYG/RZMDETIQEhNzMTI7QBj/7H/nAeov6jBo74Lr0GVwAAAQBEAtkDLgWwAAYAJ7IABwgREjkAsABFWLADLxuxAx8+WbAA0LIBBwMREjmwAS+wBdAwMQEDIwEzEyMCFP3TAaCno70EpP41Atf9KQAAAf95/0EDFgAAAAMAGwCwAEVYsAMvG7EDDz5ZsgABCitYIdgb9FkwMQUhNyEC9PyFIgN7v78AAQDKBNECVgYAAAMAJACwAS+yDwEBXbAD0LADL7QPAx8DAl2yAAEDERI5GbAALxgwMQEjAzMCVrXX/gTRAS8AAAIAIv/oA9wEUAAgACsAhbIKLC0REjmwChCwJtAAsABFWLAYLxuxGBs+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgIEGBESObIKGAAREjmwCi+wGBCyEAcKK1gh2Bv0WbITChAREjlACQwTHBMsEzwTBF2wBBCyIQEKK1gh2Bv0WbAKELImBworWCHYG/RZMDEhJjcGJyYmNzYkMxc3NicmJyYGBwc+AhcWFgcDBwYXByUWNjc3JyIGBwYWApMMAoabjbkGCAEY7JoOBgYUe0xzDe0HgNR2scYRUwgDEgH+IUuALSVxhqALCEsoPX0EArGIq8QCSicibAMCUUQCZJdUAgTNo/4FWjs4Eq4CSTrNAWVYQ00AAAIAEP/oBA8GAAARAB4AZLIEHyAREjmwBBCwG9AAsAkvsABFWLANLxuxDRs+WbAARViwBy8bsQcPPlmwAEVYsAQvG7EEDz5ZsgYNBxESObILDQcREjmwDRCyFQEKK1gh2Bv0WbAEELIaAQorWCHYG/RZMDEBBgIGJyYnByMBMwM2FxYWFxYnNCYnJgcDFhcWNjc2BAcUict/tVwm2QEK7mx5pp2xBQHsWlWPY04skXibFggCGKX+9YADBId2BgD90YEEBN7BPC9tewIEjv5AiAUDvq1VAAABADj/6QPuBFIAHABLsgAdHhESOQCwAEVYsBEvG7ERGz5ZsABFWLAILxuxCA8+WbIAAQorWCHYG/RZsgQRCBESObIVCBEREjmwERCyGAEKK1gh2Bv0WTAxJRY2NzcOAicuAjc3PgIXFhYVIzQmJyYGBwIB6FWDEuALhdBxi8RaDwMRleyQsNLeW1aLoAYHrQJnUwFrsGIDAoz3mCOd/4oEBOG0XXYEBPTe/vMAAgA7/+cEiAYAABIAHQBhsgQeHxESObAEELAb0ACwBy+wAEVYsAQvG7EEGz5ZsABFWLAJLxuxCQ8+WbAARViwDS8bsQ0PPlmyBgQJERI5sgsECRESObIWAQorWCHYG/RZsAQQshsBCitYIdgb9FkwMRM2EjYXFhcTMwEjNwYnJiYnJjcXBhYXFjcTJicmBkQUjM5+pV1o7v711BB+qpe1BwMG6QdbWolkUS+HiKYCHqcBCoMDBHcCLPoAcIkEAuW+PjtIfJICBIkB0X0EBPgAAAIAO//qBAIEUQAWAB8Ag7IRICEREjmwERCwF9AAsABFWLAJLxuxCRs+WbAARViwAC8bsQAPPlmyGgAJERI5sBovtL8azxoCXbRfGm8aAnG0HxovGgJxso8aAV207xr/GgJxsg0HCitYIdgb9FmwABCyEQEKK1gh2Bv0WbITCQAREjmwCRCyFwEKK1gh2Bv0WTAxBS4CNzc2EjYXFhIHByEGFhcWNxcGBgMmAwU3NicmJgH6jc9jDAMSneqJy8sZDv1XCXprmYF4RN4fvF4BwQQHBgtaFAOI7JEppQEHiAME/trsaIGeAgWKfmFrA6IG/vABFS4sR1IAAQBfAAADXgYaABUAY7IVFhcREjkAsABFWLAILxuxCCE+WbAARViwAy8bsQMbPlmwAEVYsBEvG7ERGz5ZsABFWLAALxuxAA8+WbADELIBAQorWCHYG/RZsAgQsg0BCitYIdgb9FmwARCwE9CwFNAwMTMTIzczNzY2FxYXByYjJgYHBzMHIwNjnaEgoBAa2609UBosLVVsDw/WINWdA4a0dKjEAgISvgoBXlNmtPx6AAAC//f+TwRCBFEAHAAqAIOyBCssERI5sAQQsCPQALAARViwCC8bsQgbPlmwAEVYsAQvG7EEGz5ZsABFWLAMLxuxDBE+WbAARViwGC8bsRgPPlmyBggYERI5sAwQshIBCitYIdgb9FmyEBIYERI5shYIGBESObAYELIiAQorWCHYG/RZsAQQsicBCitYIdgb9FkwMRM2EjYXFhc3FwMGBCcmJic3FhcWNjc3BicmJicmNwYXFhYXFjcTJicmBgdGE4nQhrJbJdizHv7X1XLMPn5fmXSnHBF9n5i3CQPzBgICXFWHZVU0hXikGQIeogEGiwIEf28B++TU+wYCZFKPgwQEh31MeQQC4r88PjM7anwDBYIB3ncEA8CtAAABAA0AAAP5BgAAEgBJsgETFBESOQCwES+wAEVYsAIvG7ECGz5ZsABFWLAGLxuxBg8+WbAARViwDy8bsQ8PPlmyAAIGERI5sAIQsgwBCitYIdgb9FkwMQE2FxYWBwMjEzYnJicmBwMjATMBl4esmpUTdO12BQMNg4Roh+0BCu4Dw44EAta9/UgCuyslegMChPz6BgAAAgAfAAACCQXYAAMADwA+sgQQERESObAEELAA0ACwAEVYsAIvG7ECGz5ZsABFWLAALxuxAA8+WbACELAN0LANL7IHDQorWCHYG/RZMDEhIxMzAzQ2NzYWFRQGBwYmAQztvO3LSD06TUs6OU4EOgEVN04CAks2OUoCAkkAAAL/DP5GAf4F2AAMABgASbIBGRoREjmwARCwDdAAsABFWLAALxuxABs+WbAARViwBC8bsQQRPlmyCQEKK1gh2Bv0WbAAELAW0LAWL7IQDQorWCHYG/RZMDEBAwYGJyYnNxYzMjcTEzQ2NzYWFRQGByImAcPHFryXQEcULiZ/GskdSDw6TUs6PEoEOvtnqLMCAhHAC5UElQEVOksCAkk4OUoCRwAAAQARAAAESgYAAAwAUwCwAEVYsAQvG7EEIT5ZsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmwAEVYsAsvG7ELDz5ZsgAIAhESObRqAHoAAl2yBggCERI5tGUGdQYCXTAxAQcDIwEzAzcBIQEBIQG/hjvtAQrtmFMBWAEv/iABPP7/Ac53/qkGAPyYVgFM/jL9lAABAB8AAAIXBgAAAwAdALAARViwAi8bsQIhPlmwAEVYsAAvG7EADz5ZMDEhIwEzAQztAQvtBgAAAAEAEAAABmgEUgAhAHeyFiIjERI5ALAARViwAy8bsQMbPlmwAEVYsAgvG7EIGz5ZsABFWLAALxuxABs+WbAARViwDC8bsQwPPlmwAEVYsBYvG7EWDz5ZsABFWLAfLxuxHw8+WbIBCAwREjmyBggMERI5sAgQshIBCitYIdgb9FmwHNAwMQEHNhcWFhc2FxYWBwMjEzYnJicmBwcDIxM2JyYnJgcDIxMBqRWGumaHGJbCnpkTde12BQQQhJNVA3zudgUEEISFWYntuwQ7c4oEAlpKqgQE0bz9QwK/LCV1AwSlFv0vArwrJXkDAnn87wQ6AAEADQAAA/oEUgASAFOyAhMUERI5ALAARViwAy8bsQMbPlmwAEVYsAAvG7EAGz5ZsABFWLAHLxuxBw8+WbAARViwEC8bsRAPPlmyAQMHERI5sAMQsg0BCitYIdgb9FkwMQEHNhcWFgcDIxM2JyYnJgcDIxMBpxiLtpiSE3XtdgUEDYGHZoftuwQ7f5YEA9O9/UUCvisldwMCh/z9BDoAAgA5/+gEJwRSABAAIABDshshIhESObAbELAE0ACwAEVYsAQvG7EEGz5ZsABFWLAMLxuxDA8+WbIUAQorWCHYG/RZsAQQshsBCitYIdgb9FkwMRM2EjYXHgIHBgIGJy4CNxcWFhcWNjc3NCYnJgcGBwZJEZnwkovKXQ4Qm/GTisleDewFZVp6pRUGZmGYWDUOCAIhnwEEjgQCkPqZrP74jQQCj/mWdGl/AwPCqGKAkgQEmV15VAAC/8f+YAQNBFIAEgAeAGeyBB8gERI5sAQQsB3QALAARViwDS8bsQ0bPlmwAEVYsAovG7EKGz5ZsABFWLAHLxuxBxE+WbAARViwBC8bsQQPPlmyCw0HERI5sA0QshcBCitYIdgb9FmwBBCyHAEKK1gh2Bv0WTAxAQYCBicmJwMjATcHNhceAhcWBzc2JicmBwMWFxY2BAUUhc1/qWFh7gEE2RJ8q2eYUQMB8gUDW1uGYlQtinahAhmi/viHAwR0/f0F2gFwhwQBZ8R4PT9JgY4CBH/+HXkEA74AAAIAO/5gBDgEUgASACAAa7IEISIREjmwBBCwGNAAsABFWLAILxuxCBs+WbAARViwBC8bsQQbPlmwAEVYsAkvG7EJET5ZsABFWLANLxuxDQ8+WbIGCA0REjmyCwgNERI5shcBCitYIdgb9FmwBBCyHQEKK1gh2Bv0WTAxEzYSNhcWFzcXASMTBicmJicmNzMHBhYXFjY3EyYnJgYHRBSOzn+sXCfW/vztYnmcm7QHAwbuBQNbWEtvLVg0gnKfHAIfqwEJfwMEfW0B+iYB/XUEAuO+PzxIh4sCA0U4Ae5yBAOypAABABAAAALvBFMADQBGsgkODxESOQCwAEVYsAgvG7EIGz5ZsABFWLALLxuxCxs+WbAARViwBS8bsQUPPlmwCxCyAgEKK1gh2Bv0WbIJCwUREjkwMQEmIyYHAyMTNwc2FzIXAtQuL5xcgu274RhvkSE6A1wKBIX9GwQ6AXuTAw8AAAEAHP/pA8QEUAAkAHSyIyUmERI5ALAARViwCC8bsQgbPlmwAEVYsBsvG7EbDz5ZsgMbCBESObILCBsREjmyHAsBXbILCwFdsAgQsg8BCitYIdgb9FmwAxCyEwEKK1gh2Bv0WbIeCBsREjm0BB4UHgJdsBsQsiIBCitYIdgb9FkwMQE2JCcmNzY2FxYWByc2JiciBgcGBBcWBw4CJyYmNxcWFhcyNgKXEf7dNc4HBf+yrNkC6wJWS09xCQ4BHETGBwV90nax6QLlAmRXWHUBLGNNF1i0kr8CAr6aAUtVAk4/W0ceV7lnmVEDAsqeAVdaAUkAAQA7/+0CrgVBABYAXLIWFxgREjkAsABFWLABLxuxARs+WbAARViwFC8bsRQbPlmwAEVYsA4vG7EODz5ZsAEQsADQsAAvsAEQsgMBCitYIdgb9FmwDhCyCQEKK1gh2Bv0WbADELAS0DAxAQMzByMDBhcWFzI3BwYjJiY3EyM3MxMCIy65H7pmAwIGSiUvEEpLfHsNZa0grC4FQf75tP2iGRRBAwm+FQKliAJqtAEHAAABAEr/6AQxBDoAEwBQsgEUFRESOQCwAEVYsAcvG7EHGz5ZsABFWLAQLxuxEBs+WbAARViwEi8bsRIPPlmwAEVYsAIvG7ECDz5ZsgAQEhESObINAQorWCHYG/RZMDElBicuAjcTMwMGFxYXFjcTMwMjAq17uWmLOwx17XYEAwpznWGI7bvea4MEAmSzeQK8/UElI3wFBoQDCvvGAAABAGQAAAQNBDoABgA4sgAHCBESOQCwAEVYsAEvG7EBGz5ZsABFWLAFLxuxBRs+WbAARViwAy8bsQMPPlmyAAUDERI5MDEBATMBIwMzAboBVv39687G7gE3AwP7xgQ6AAABAHcAAAX4BDoADABgsgUNDhESOQCwAEVYsAEvG7EBGz5ZsABFWLAILxuxCBs+WbAARViwCy8bsQsbPlmwAEVYsAMvG7EDDz5ZsABFWLAGLxuxBg8+WbIACwMREjmyBQsDERI5sgoLAxESOTAxAQEzASMDASMDMxMBMwPhASnu/ibDX/6ixGPgKQFWswFRAun7xgLk/RwEOv0iAt4AAAH/uQAABBMEOgALAFMAsABFWLABLxuxARs+WbAARViwCi8bsQobPlmwAEVYsAQvG7EEDz5ZsABFWLAHLxuxBw8+WbIACgQREjmyBgoEERI5sgMABhESObIJBgAREjkwMQETIQETIwMBIQEDMwH//wEV/mLx+Jf+9v7sAavp+ALYAWL94P3mAXH+jwIwAgoAAAH/tf5FBBIEOgAPAEOyABARERI5ALAARViwDy8bsQ8bPlmwAEVYsAEvG7EBGz5ZsABFWLAFLxuxBRE+WbIABQ8REjmyCQEKK1gh2Bv0WTAxAQEhAQInJic3FxY2NzcDMwG4AVQBBv1/hts2RRQrVnAmObX2AV4C3PsL/wADAhK8BANHS3AEJwAB/+cAAAPkBDoACQBEALAARViwBy8bsQcbPlmwAEVYsAIvG7ECDz5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIQchNwEhNyEHATgCJiL8qx4CiP39IwM3HcLCqwLLxKUAAAEAMP6ZAwUGQAAbADayDBwdERI5ALAOL7AARViwAC8bsQAXPlmyCQ4AERI5sAkvsggHCitYIdgb9FmyFAgJERI5MDEBJiY3NzYnJic3Njc3EiUXBgMHBgcWFg8CBhcBzZ6cExwFBA2GEccfHzkBYyPBIx0huUk2CR4DA4P+mTPwrswtJ3oLsgrd4AFQaI9G/vraxWA3oljmR6o6AAEAIP7yAdIFsAADABMAsAAvsABFWLACLxuxAh8+WTAxEyMBM8SkAQ6k/vIGvgAB/5n+lQJvBjsAHAA2shodHhESOQCwDi+wAEVYsBwvG7EcFz5ZshYOHBESObAWL7IXBworWCHYG/RZsgUXFhESOTAxBzY3NzY3JicmPwI0JzcWFgcHBhcWFwcGBwcCBWe4KSIjvnAOBQUeBIE3o5ASHAUEDYcSyB4fOf6d20D49MNbSpArLeZIqjmJNvGozC4mfAuyCtvf/qxmAAABAFsBfgTKAzQAFgA8sgUXGBESOQCwDi+wANCyAxcOERI5sAMvsA4QsggBCitYIdgb9FmwAxCwCtCwAxCyEwEKK1gh2Bv0WTAxAQYGJy4DIyYHIzY2Fx4DMzI2NwTKDMSUUX50QyGHIrsOx5FSgnBEH0RdEAMUrugEAkp0JAPAr9wEAkxyJGlcAAAC/+b+lAHOBFAAAwAOAD6yCw8QERI5sAsQsALQALAARViwDC8bsQwbPlmwAEVYsAIvG7ECFz5ZsAwQsgcNCitYIdgb9FmwAdCwAS8wMRMzAyMBFAYGJjU0Njc2Fq/MmvsB6Ep2TEo7Ok0Clvv+BTs5TQRKODlMAgJLAAEATP8LBAYFJgAhAFeyEiIjERI5ALAARViwFS8bsRUbPlmwAEVYsAcvG7EHDz5ZsgABCitYIdgb9FmyBAcVERI5sAcQsArQsBUQsBLQshkVBxESObAVELIcAQorWCHYG/RZMDElFjY3NwYGBwcjNy4CNzc2Ejc3MwcWFgcjNCYnJgIVFBYB9liAFN8O1qAvxDBriToOAhn2wS7DLoSTAt1cU4+pXK0CaFIBjccd6uwbk9+EFOUBIiLh4yHSm2FxBAb+9vBqfQAAAf/2AAAEpQXHACAAarIcISIREjkAsABFWLATLxuxEx8+WbAARViwBS8bsQUPPlmyHhMFERI5sB4vsgABCitYIdgb9FmwBRCyAwEKK1gh2Bv0WbAI0LAAELAL0LAeELAN0LATELAW0LATELIaAQorWCHYG/RZMDEBBwYHJQchNxc2NzcjNzM3PgIXFhYHJzYmJyYGBwchBwHuFhFZAqgk/AQkRWQcGJ0jlx8Qi9l/tMsI7wVSU1p/Dh0BLiMCVq6CXwPKyQIksrnH+3/HaQQE2bYBX2cEAoZw6scAAAIACP/lBX8E8QAcACwAP7IiLS4REjmwIhCwENAAsABFWLACLxuxAg8+WbAR0LARL7ACELIhBworWCHYG/RZsBEQsikHCitYIdgb9FkwMSUGJyYnByc3JicmEjcnNxc2FxYXNxcHFgcGBxcHAQYWFhcWNjY3NiYmJyYGBgPUtrzDh5h4mhsKE1hmc5dur7K5iKp5qT4UGoNvmPz4D0SaaXHRjxAPRJppctOMaYEEBHqEm4BVVpMBHHWbhY90BAJylJyOuafJnpWGAnJuyXkEBHnZd27HeAQEetQAAQBQAAAFOAWwABYAcgCwAEVYsBYvG7EWHz5ZsABFWLAMLxuxDA8+WbIADBYREjmwFhCwAdCyDwwWERI5sA8vsBPQsBMvtA8THxMCXbAE0LAEL7ATELISBAorWCHYG/RZsAbQsA8QsAfQsAcvsA8Qsg4ECitYIdgb9FmwCtAwMQEBIQEzByEHIQchAyMTITchNyE3IQEhAnoBoAEe/gf+G/6uGAFTG/6uNPc1/qgbAVcY/qgbARj+/gEFAzYCev02mIqX/tMBLZeKmALKAAAC/+z+8gH4BbAAAwAHABgAsAAvsABFWLAGLxuxBh8+WbIFAQMrMDEDEzMDEyMTMxSL34qo4ITg/vIDG/zlA8gC9gAC/9z+IwSxBcYALgA5AICyJzo7ERI5sCcQsDTQALAIL7AARViwHy8bsR8fPlmyAggfERI5sAgQsAzQsAgQsg8BCitYIdgb9FmyFQgfERI5shofCBESObAfELAj0LAfELImAQorWCHYG/RZsiwIHxESObAVELIzAQorWCHYG/RZsCwQsjkBCitYIdgb9FkwMQEGBxYHDgInJiY3MwYWFzI2NzYvAiQ3NjcmNzYkFxYWByc2JicmBwYHBgQXFiUGBwYfAjY3NicEUg7IYQ0Jj/CR4PsF8AZ+eHidDRW5kln+6xUOxmANDgEq49brCewGdGlyTlMOFgF8VOX9bnkUFrbDKIEUFsIBz7VpaKh5rFkDAuLFa3kCYlN4QTAjd/W4Z22ksNACBOTGAWx7AgIuMVqGcSt0IDd2iD1ADztygUQAAAIA0QTeA4MFzQAKABUAIgCwES+yDxEBXbILBQorWCHYG/RZsADQsBEQsAbQsAYvMDEBMhYVFAYHIiY0NiUyFhUUBgciJjQ2AUw2RkY1OEREAfI4REY1N0VFBc1DMTNFAkRgSAFEMDNFAkJkRgAAAwBe/+gF6QXHABsAKQA6AJWyLjs8ERI5sC4QsBLQsC4QsCfQALAARViwLy8bsS8fPlmwAEVYsDcvG7E3Dz5ZsgM3LxESObADL7QPAx8DAl2yCi83ERI5sAovtAAKEAoCXbIAAwoREjmyDgoDERI5shECCitYIdgb9FmwAxCyGQIKK1gh2Bv0WbA3ELIfCAorWCHYG/RZsC8QsiYICitYIdgb9FkwMQEGBicmJjc3NjYXFhYHJzYmJyYGBhUXFhYXFjcFFgAXFiQSJyYCJyYEAgc2EjYkFxYEEgcGAgQnJiQCBEMMuZmSpA4KE9CelZoEmAVIUV17HQIFS0KnH/09EwEBvLgBSbcSE/zAuf63uWIRieABDZCyAR6PFRbm/qW/tv7mkAJUlqgEBNinZbzcAgSpjwFaWQICjvgbLEtYAwe5GMz++wIE2wF3wcoBAQUE2v6JKJYBF9lvAwLF/qbEyf6ayAQExAFcAAACAL4CswNQBccAHQAnAGuyEigpERI5sBIQsB7QALAARViwFi8bsRYfPlmyBCgWERI5sAQvsADQsAAvsgoEFhESObAKL7AWELIQAgorWCHYG/RZsAoQsRIKK1jYG9xZsAQQsh4CCitYIdgb9FmwChCxIgorWNgb3FkwMQEmNwYjIiY3NjYzFzc2JyYnJgcnNjYXFhYHAwcGFyUyNzcjBgYHBhYCbgUCXW1qeQQCu6hoCwQBB0x3G6wLsYJ6jAo2BAEJ/rVFWhtTUmYIBzECvygeUnthc30BNRkWSwMEZw5vfQICln3+pTotL4I+igM+NSYs//8ASQCKA60DqQAmA4DsAAAHA4ABSAAAAAEAgAF2A8oDJQAFABoAsAQvsAHQsAEvsAQQsgIBCitYIdgb9FkwMQEjEyE3IQN/xC79lx8DKwF2AQSr//8ANgIJAlgCzQIGABEAAAAEAF7/6AXpBcgADwAfADgAQQCfsjpCQxESObA6ELAD0LA6ELAd0LA6ELA40ACwAEVYsAQvG7EEHz5ZsABFWLAMLxuxDA8+WbIUCAorWCHYG/RZsAQQshwICitYIdgb9FmyIQwEERI5sCEvsiQEDBESObAkL7QAJBAkAl2yICEkERI5sCAvsiAgAV2yOQgKK1gh2Bv0WbIpIDkREjmwIRCwMdCwJBCyQAgKK1gh2Bv0WTAxEzYSJBcWBBIHBgIEJyYkAjceAhcWJBI3NgImJyYEAgUDIxMFFhYHBgcWFxYGFxcHIyY3Njc2JicnFzY2NzYmJydzFt4BXsWyAR6PFRbm/qW/tv7mkIoMfsl+nAEnyRcVaeCYuf63uAG4NZSFAQSPlAUHiUkHAg0BBAGVBQIBDAYsQpCBSmUKCztZigLSxgFhzwQCxf6mxMn+msgEBMQBXCuD13YDBKQBLaufAR6mBATa/oxw/q8DUgEFhnF0TC5kH3kcPhIlJCFfP0QEiAECQzY7PQMBAAEA7wUSA8sFsAADABEAsAEvsgIDCitYIdgb9FkwMQEhNyEDsv09GQLDBRKeAAACAOQDrALkBccACwAXAC8AsABFWLADLxuxAx8+WbAP0LAPL7IJAgorWCHYG/RZsAMQshUCCitYIdgb9FkwMRM2NhcWFgcGBicmJjcGFjMyNjc2JiMiBuYCpG9jhgIEoGxmiIoGNjE3UAYGNS82VASvb6kCAplpcqMCApZrLElPNDFJVAACABsAAQQFBPwACwAPAEYAsAkvsABFWLANLxuxDQ8+WbAJELAA0LAJELIGAQorWCHYG/RZsAPQsA0Qsg4BCitYIdgb9FmyBQ4GERI5tAsFGwUCXTAxASEHIQMjEyE3IRMzEyE3IQK4AU0g/rQ90z3+pSABWTzTYfzHHwM5A4PH/nwBhMcBefsFxAABAFYCmwLxBb8AFwBZsggYGRESOQCwAEVYsA8vG7EPHz5ZsABFWLAALxuxABM+WbIWAgorWCHYG/RZsgIAFhESObIDDwAREjmwDxCyCAIKK1gh2Bv0WbIMDwAREjmyEw8AERI5MDEBITcBNjc2JiciBgcHNjYXFhYHBg8CBQKp/a0YAVZhDAcrKTpDDLYKr4J/kgUFlk+dAV8Cm4cBGVNDKS8BRzQBeZgCAoNofnc8bgIAAQBnAo0C+AW+ACQAb7IJJSYREjkAsABFWLANLxuxDR8+WbAARViwGC8bsRgTPlmyARgNERI5fLABLxiwDRCyBwIKK1gh2Bv0WbIKAQcREjmwARCyIwIKK1gh2Bv0WbITIwEREjmwGBCyHgIKK1gh2Bv0WbIcIx4REjkwMQEzNjY3NicnJgcHNjYXFhYHBgYHFgcGBicmJjUXFhcyNjc2JyMBWVM9TQcJShddHLoJpn2BmQUDSVJ2BAO8i32ZsQRqNlMHDXhcBGwCOC5DDQICTAFpegIDd2I7VyYpgW+CAgKDbQFZAjgvWQUAAQDIBNEC0gYAAAMAIwCwAi+yDwIBXbAA0LAAL7QPAB8AAl2wAhCwA9AZsAMvGDAxASEBIwG1AR3+xM4GAP7RAAH/3f5gBFQEOgATAFayDRQVERI5ALAARViwAC8bsQAbPlmwAEVYsAgvG7EIGz5ZsABFWLARLxuxERE+WbAARViwCi8bsQoPPlmwAEVYsA4vG7EODz5ZsgUBCitYIdgb9FkwMQEDBhcWFxY3EzMDIzcGJyInAyMBAc1mCAIFhZhaiu271w9ojGxSVuwBBAQ6/ZJVKJ0DBHwDE/vGVm4COf49BdoAAQB9AAAD3AWxAAoAK7ICCwwREjkAsABFWLAILxuxCB8+WbAARViwAC8bsQAPPlmyAQAIERI5MDEhEycmJjc2ADMFAwISWjjT5BQTASvhASz9AggBA//J0wEKAfpQAAEAngJCAbEDVQALABiyAwwNERI5ALADL7IJDQorWCHYG/RZMDETNDY3NhYVFAYHBiaeTTs9Tk48O04Cxj1OAgJPODtNAgJKAAH/0/49AS8ABAAOACmyAg8QERI5ALAAL7AHL7IIAgorWCHYG/RZsg0IABESObIBAA0REjkwMTcHFhYHBgYHNzY3NicnN8UTPj8BArKnAokQCVI4LQQ7DlU/bXcGjQZaPA0GiQABAOECoAKBBbMABgA5sgEHCBESOQCwAEVYsAUvG7EFHz5ZsABFWLAALxuxABM+WbIEBQAREjmwBBCyAwIKK1gh2Bv0WTAxASMTBzclMwH/tWPMGwFuFwKgAjYvmXMAAgC+Aq0DfQXIAA4AHABAshEdHhESObARELAO0ACwAEVYsAAvG7EAHz5ZsgcdABESObAHL7ISAgorWCHYG/RZsAAQshkCCitYIdgb9FkwMQEWFgcHBgYnJiY3Nz4CAwYWFxY2Nzc2JicmBgcCSpCjCwYP0pmNpwsGCmemcQhFRk9sDAgIRUZQbAsFxQTHmUKkzgQExJtCbqlb/klhbAICdWdGZGkCAnZkAP//AAIAigN1A6kAJgOBCQAABwOBAXMAAP//ALkAAAUqBasAJwPPAEwCmAAnA4MBFAAIAQcDzAKwAAAAEACwAEVYsAUvG7EFHz5ZMDH//wCxAAAFgAWuACcDgwDqAAgAJwPPAEQCmwEHA84DAgAAABAAsABFWLAJLxuxCR8+WTAx//8AlgAABZ8FvwAnA4MBnQAIACcDzAMlAAABBwPNAKICmwAQALAARViwIC8bsSAfPlkwMQAC/9L+egMjBFEAGAAkAGGyISUmERI5sCEQsALQALAARViwIi8bsSIbPlmwAEVYsBAvG7EQFz5ZsCIQshwNCitYIdgb9FmwANCwAC+yBBAAERI5sBAQsgkBCitYIdgb9FmyDBAAERI5shUAEBESOTAxAQYGBwcGBwYWFxY2NzMGBCcmJjc2Nzc2NwEUBgcGJjU0Njc2FgJrC1dfUngOC0pOU3MR7RH+/Ly3yQ0Pw21fFAEsSjo7TEo7OkwClnSrV0ptb1JgAgJlV7PTBATMqbOrXlaMATs7SwICSjg5TAICSgD///+kAAAErgc2AiYAJQAAAQcARAFbATYAEwCwAEVYsAQvG7EEHz5ZsAzcMDEA////pAAABMgHNgImACUAAAEHAHcB9gE2ABMAsABFWLAFLxuxBR8+WbAN3DAxAP///6QAAASuBzcCJgAlAAABBwFnAPIBNgATALAARViwBC8bsQQfPlmwD9wwMQD///+kAAAEyQcrAiYAJQAAAQcBbgEAATcACQCwBC+wFdwwMQD///+kAAAErgcDAiYAJQAAAQcAawEoATYADACwBC+wHNywC9AwMf///6QAAASuB5UCJgAlAAABBwFsAYwBagAMALAEL7AU3LAX0DAxAAL/hwAAB3gFsAAPABIAdwCwAEVYsAYvG7EGHz5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmyEQYAERI5sBEvsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WbILBgAREjmwCy+yDAEKK1gh2Bv0WbAAELIOAQorWCHYG/RZshIGABESOTAxISETIQMhASEHIQMhByEDIQEhEwa3/Jks/iHu/tgEJgPLI/2ONwIVI/30PAKE+1gBZlUBVP6sBbDF/mjF/jYBZwJ6AP//AGX+OAUNBccCJgAnAAAABwB7Abr/+///ACcAAAS6Bz0CJgApAAABBwBEASMBPQATALAARViwBi8bsQYfPlmwDdwwMQD//wAnAAAEugc9AiYAKQAAAQcAdwG+AT0AEwCwAEVYsAYvG7EGHz5ZsA7cMDEA//8AJwAABLoHPgImACkAAAEHAWcAugE9ABMAsABFWLAGLxuxBh8+WbAR3DAxAP//ACcAAAS6BwoCJgApAAABBwBrAPABPQAMALAGL7Ad3LAM0DAx//8ANQAAAjIHPQImAC0AAAEHAET/3AE9ABMAsABFWLACLxuxAh8+WbAF3DAxAP//ADUAAANIBz0CJgAtAAABBwB3AHYBPQATALAARViwAy8bsQMfPlmwBtwwMQD//wA1AAADEgc+AiYALQAAAQcBZ/9zAT0AEwCwAEVYsAIvG7ECHz5ZsAjcMDEA//8ANQAAAywHCgImAC0AAAEHAGv/qQE9AAwAsAIvsBXcsATQMDEAAv//AAAE/gWwAA8AHgBpsh4fIBESObAeELAO0ACwAEVYsAUvG7EFHz5ZsABFWLAALxuxAA8+WbIDAAUREjl8sAMvGLICBworWCHYG/RZsBHQsAAQshMBCitYIdgb9FmwBRCyHAEKK1gh2Bv0WbADELAd0LAe0DAxMxMjNzMTBTIEEgcHBgIEIxMjAxcyJDc2JyYmJycDM0Vxtx62bgGKtgEHdhcLHs3+vMKf3U6SxgEFJRoHCZeGuUveAoyqAnoBtf7BwE/J/smsAoz+PgH73ZhxkaQEAf5SAP//ACcAAAWGBysCJgAyAAABBwFuASgBNwAJALAFL7AU3DAxAP//AGv/5wUhBzYCJgAzAAABBwBEAXIBNgATALAARViwCi8bsQofPlmwJNwwMQD//wBr/+cFIQc2AiYAMwAAAQcAdwINATYACQCwCi+wJdwwMQD//wBr/+cFIQc3AiYAMwAAAQcBZwEJATYACQCwCi+wJNwwMQD//wBr/+cFIQcrAiYAMwAAAQcBbgEXATcACQCwCi+wLdwwMQD//wBr/+cFIQcDAiYAMwAAAQcAawE/ATYADACwCi+wNNywI9AwMQABACMA1gQUBIYACwA4ALADL7IJDAMREjmwCS+yCgkDERI5sgQDCRESObIBCgQREjmwAxCwBdCyBwQKERI5sAkQsAvQMDETAQM3EwEXARMHAwEjAWv7nvoBan/+lfue+/6XAXcBQQFDi/6/AUGh/r/+vYsBQP7AAAADABX/oQWYBe0AFwAhACsAVbIeLC0REjmwHhCwC9CwHhCwJ9AAsABFWLAMLxuxDB8+WbAARViwAC8bsQAPPlmyJwEKK1gh2Bv0WbAl0LAa0LAMELIdAQorWCHYG/RZsBvQsCTQMDEFJicHJzcmNzcSEiQXFhc3MwcWFxYCAgQBBhcBJicmAgcGATYnARYXFhI3NwJXnHt2tcJsAgMTwQE1vr6AcLPEOA4RSsn+5P5hAxQCfT6BpuIpGgLQBQb9kz9gsOMkERUESZcB8LDiTwEMAX7KAgRjj/R5gKr+Zf7ImwIiVVMDP04FBf8A6ZUBEEZH/NYyAgUBF/p5AP//AFv/5gUvBzYCJgA5AAABBwBEAUoBNgATALAARViwCi8bsQofPlmwFNwwMQD//wBb/+YFLwc2AiYAOQAAAQcAdwHlATYAEwCwAEVYsBIvG7ESHz5ZsBXcMDEA//8AW//mBS8HNwImADkAAAEHAWcA4QE2ABMAsABFWLAKLxuxCh8+WbAX3DAxAP//AFv/5gUvBwMCJgA5AAABBwBrARcBNgAWALAARViwCi8bsQofPlmwJNywGdAwMf//AKEAAAVNBzYCJgA9AAABBwB3Ab0BNgATALAARViwAS8bsQEfPlmwC9wwMQAAAgAnAAAEggWwAAwAFQBXsg8WFxESObAPELAI0ACwAEVYsAAvG7EAHz5ZsABFWLAKLxuxCg8+WbICAAoREjmwAi+yDwAKERI5sA8vsggBCitYIdgb9FmwAhCyFQEKK1gh2Bv0WTAxAQMXFhYHBgQjJwMjExMDFzY2NzYmJwIRMcve+Q8Q/s3r/DXt/ZtV4YCsDw5wagWw/ugBAerCy/QB/tQFsP4l/hoCAolxa3wEAAABABv/5wRMBhoALQBYsiEuLxESOQCwAEVYsAUvG7EFIT5ZsABFWLAALxuxAA8+WbAARViwFS8bsRUPPlmyDgUVERI5shoBCitYIdgb9FmyIBUFERI5sAUQsioBCitYIdgb9FkwMSEjEzYkFxYWBw4DBwYeAgcGBicmJzcWMzI2NzYmJyY3PgM3NiYnJgYHAQjtvRwBAMinvg0EJGAcBwguiDUCCfi9q3FEZ2xYdgsIMkZ+CQQyPDQHCUVGWnUUBFHS9wQEvZwxV5pCJjFmmW44rcUEAkHBQllJNGZLhm85XVlcN0xcBAODh///ACL/6APcBgACJgBFAAABBwBEALMAAAATALAARViwGC8bsRgbPlmwLdwwMQD//wAi/+gEIAYAAiYARQAAAQcAdwFOAAAAEwCwAEVYsBgvG7EYGz5ZsC7cMDEA//8AIv/oA+kGAQImAEUAAAEGAWdKAAATALAARViwGC8bsRgbPlmwMNwwMQD//wAi/+gEIQX1AiYARQAAAQYBblgBABMAsABFWLAYLxuxGBs+WbAv3DAxAP//ACL/6AQDBc0CJgBFAAABBwBrAIAAAAAWALAARViwGC8bsRgbPlmwMtywPdAwMf//ACL/6APcBl8CJgBFAAABBwFsAOQANAAWALAARViwGC8bsRgbPlmwNdywO9AwMQADAA//6AZwBFIAKwA1AD4A+LICP0AREjmwAhCwL9CwAhCwOdAAsABFWLAdLxuxHRs+WbAARViwGS8bsRkbPlmwAEVYsAAvG7EADz5ZsABFWLAFLxuxBQ8+WbIDHQAREjmyCwUZERI5sAsvsBkQshEBCitYIdgb9FmyFAsRERI5QAkMFBwULBQ8FARdshsdABESObI6HQAREjmwOi+0HzovOgJxso86AV20XzpvOgJxtL86zzoCXbTvOv86AnGyIQcKK1gh2Bv0WbAAELIlAQorWCHYG/RZsigdABESObAFELIsBworWCHYG/RZsAsQsjAHCitYIdgb9FmwHRCyNgEKK1gh2Bv0WTAxBSImJwYnJiY3NiQzFzc2JyYnJgYHJz4CFxYXNhcWEgcHIQYWFxY2NxcGBiUyNzcnBgYHBhYBJgYHITc2JyYEanO8Naz9mrQICgEF5r8NBgQRd1d3De0He9t711qbucLHGhX9Yw53c1WXSjpB0/y2coooqWuRDAlOA41gki4BtgYHBA4TU0ykBAKvk6GyAkomInUDAlRJE2KZUwIFgIgEBv7y1o2InQICNSeoOT64ZtIBA15PP0gC5wOHhyEtKo0A//8AOP44A+4EUgImAEcAAAAHAHsBPP/7//8AO//qBAIGAAImAEkAAAEHAEQAnAAAABMAsABFWLAJLxuxCRs+WbAh3DAxAP//ADv/6gQJBgACJgBJAAABBwB3ATcAAAATALAARViwCS8bsQkbPlmwItwwMQD//wA7/+oEAgYBAiYASQAAAQYBZzMAABMAsABFWLAJLxuxCRs+WbAk3DAxAP//ADv/6gQCBc0CJgBJAAABBgBraQAAFgCwAEVYsAkvG7EJGz5ZsCbcsDHQMDH//wAiAAAB5wX5AiYA9AAAAQYARJH5ABMAsABFWLACLxuxAhs+WbAF3DAxAP//ACIAAAL9BfkCJgD0AAABBgB3K/kAEwCwAEVYsAMvG7EDGz5ZsAbcMDEA//8AIgAAAscF+gImAPQAAAEHAWf/KP/5ABMAsABFWLACLxuxAhs+WbAI3DAxAP//ACIAAALhBcYCJgD0AAABBwBr/17/+QAWALAARViwAi8bsQIbPlmwCtywFdAwMQACAEb/6ARKBiwAHgAqAF6yECssERI5sBAQsCjQALAARViwGi8bsRohPlmwAEVYsAgvG7EIDz5ZshAaCBESObAQL7AaELIZAQorWCHYG/RZsBAQsiEHCitYIdgb9FmwCBCyJwEKK1gh2Bv0WTAxARYSBwcGAgYnLgI3PgIXFhcmJwcnNyYnNxYXNxcBJicmBgcGFhcWNjcDpVtBFwwXqOyJf8VgDA2I4IWKawRg4D+4W6Vb3pTJPv74NpN/qxAOaWJ2oxkFFJv+vLNWp/7siQMEgNyBkPCGBARZmYqIeWxJMMI2g3p5/TlhBQK2k3ilAwXQrQD//wANAAAEJwX1AiYAUgAAAQYBbl4BABMAsABFWLADLxuxAxs+WbAW3DAxAP//ADn/6AQnBgACJgBTAAABBwBEALAAAAATALAARViwBC8bsQQbPlmwItwwMQD//wA5/+gEJwYAAiYAUwAAAQcAdwFLAAAAEwCwAEVYsAQvG7EEGz5ZsCPcMDEA//8AOf/oBCcGAQImAFMAAAEGAWdHAAATALAARViwBC8bsQQbPlmwJdwwMQD//wA5/+gEJwX1AiYAUwAAAQYBblUBABMAsABFWLAELxuxBBs+WbAk3DAxAP//ADn/6AQnBc0CJgBTAAABBgBrfQAADACwBC+wMtywIdAwMQADAD0AkAQ6BM8AAwAPABsAUrIYHB0REjmwGBCwANCwGBCwBtAAsAMvsgABCitYIdgb9FmwAxCxDQorWNgb3FmyBw0KK1gh2Bv0WbAAELETCitY2BvcWbIZDQorWCHYG/RZMDEBITchATQ2NzYWFRQGBwYmAzQ2NzYWFRQGBwYmBBT8KSUD2P3CTjo9Tks+O0+OTD05UUw9OVECRtQBKT1LAgJMODlOAgJI/Qo5UAICSTw7SwICSAAAAwAq/3cEMwS7ABsAJAAuAFWyKy8wERI5sCsQsBHQsCsQsCLQALAARViwBS8bsQUbPlmwAEVYsBIvG7ESDz5ZsioBCitYIdgb9FmwKNCwHtCwBRCyIQEKK1gh2Bv0WbAf0LAn0DAxEzY2NzYXFhc3FwcWFxYHBgIGJyYnByc3JicmNxcGFwEmJyYGBiU2JwEWFxY2NzZED15OnN9eX2GbknAHAggUm/SUVltlm5J2CAMH4QEUAZQmNWSXUAIQARL+cCgqeaseDAIgdtNOnQQCI5AB0oTDOlOf/v6LAgIflAHRgsc9PHw/PQJnEwIBgfGDPDz9oQ4CA76vVAD//wBK/+gEMQYAAiYAWQAAAQcARAC1AAAAEwCwAEVYsAgvG7EIGz5ZsBXcMDEA//8ASv/oBDEGAAImAFkAAAEHAHcBUAAAAAkAsAcvsBbcMDEA//8ASv/oBDEGAQImAFkAAAEGAWdMAAAJALAHL7AV3DAxAP//AEr/6AQxBc0CJgBZAAABBwBrAIIAAAAMALAHL7Al3LAU0DAx////tf5FBBIGAAImAF0AAAEHAHcBGgAAAAkAsAEvsBLcMDEAAAL/zf5gBBQGAAARAB0AVrIEHh8REjmwBBCwHNAAsAkvsABFWLANLxuxDRs+WbAARViwBy8bsQcRPlmwAEVYsAQvG7EEDz5ZsA0QshYBCitYIdgb9FmwBBCyGwEKK1gh2Bv0WTAxAQYCBicmJwMjATMDNhcWFhcWBzc2JicmBwMWFxY2BAwUiM19qGJh7gFT7Wp6o52xBQHzBQNaXYViVS+JdqECGKT+94QDBHX9/Qeg/dZ8BATewTxBSn+NBAR//h15BAO+////tf5FBBIFzQImAF0AAAEGAGtMAAAMALABL7Ah3LAQ0DAx////pAAABMUG6gImACUAAAEHAHIA+gE6ABMAsABFWLAELxuxBB8+WbAM3DAxAP//ACL/6AQdBbQCJgBFAAABBgByUgQACQCwGC+wLNwwMQD///+kAAAErgcdAiYAJQAAAQcBagEwATYACQCwBC+wDtwwMQD//wAi/+gD9AXnAiYARQAAAQcBagCIAAAACQCwGC+wL9wwMQAAAv+k/lEErgWwABcAGgB3shUbHBESObAVELAa0ACwAEVYsBUvG7EVHz5ZsABFWLALLxuxCxE+WbAARViwEy8bsRMPPlmwAEVYsBcvG7EXDz5ZsAsQsgYDCitYIdgb9FmwFxCwENCwEC+yGRMVERI5sBkvshEBCitYIdgb9FmyGhUTERI5MDEhFwcGBwYXFjcXBiciJjc2NwMhAyEBMwEBIQMEcQUvgwcFOBs9DEVVV2kCA7Q2/d+u/vYDEt4BGv0WAZhjAx9WVjkDAReQKwJtVJVpAUH+rQWw+lACHwJaAAACACL+UQPcBFAAMAA7AJuyGjw9ERI5sBoQsDbQALAARViwKC8bsSgbPlmwAEVYsAsvG7ELET5ZsABFWLAALxuxAA8+WbAARViwFC8bsRQPPlmwABCwENCwEC+yEigAERI5shoUKBESObAaL7AoELIgBworWCHYG/RZsiQaIBESOUAJDCQcJCwkPCQEXbAUELIxAQorWCHYG/RZsBoQsjYHCitYIdgb9FkwMSEXBwYHBhcWNxcGJyImNzY3JzUGJyYmNzYkMxc3NicmJyYGBwc+AhcWFgcDBwYXByUWNjc3JyIGBwYWA0oFL4MHBTgbPQxFVVdpAgO1BIabjbkGCAEY7JoOBgYUe0xzDe0HgNR2scYRUwgDEgH+IUuALSVxhqALCEsDH1ZWOQMBF5ArAm1UlmkpKX0EArGIq8QCSicibAMCUUQCZJdUAgTNo/4FWjs4Eq4CSTrNAWVYQ00A//8AZf/oBQ0HSwImACcAAAEHAHcB+AFLAAkAsAwvsCHcMDEA//8AOP/pA/MGAAImAEcAAAEHAHcBIQAAAAkAsBEvsB/cMDEA//8AZf/oBQ0HTAImACcAAAEHAWcA9AFLAAkAsAwvsCDcMDEA//8AOP/pA+4GAQImAEcAAAEGAWcdAAAJALARL7Ae3DAxAP//AGX/6AUNBywCJgAnAAABBwFrAdUBVAAJALAML7An3DAxAP//ADj/6QPuBeECJgBHAAABBwFrAP4ACQAJALARL7Al3DAxAP//AGX/6AUNB1ACJgAnAAABBwFoAQsBSwAJALAML7Aj3DAxAP//ADj/6QPwBgUCJgBHAAABBgFoNAAACQCwES+wIdwwMQD//wAnAAAE4AdCAiYAKAAAAQcBaACbAT0AEwCwAEVYsAEvG7EBHz5ZsBzcMDEA//8AO//nBdUGAgAmAEgAAAAHA6sEvwT8AAL//wAABP4FsAAPAB4AabIeHyAREjmwHhCwDtAAsABFWLAFLxuxBR8+WbAARViwAC8bsQAPPlmyAwAFERI5fLADLxiyAgcKK1gh2Bv0WbAR0LAAELITAQorWCHYG/RZsAUQshwBCitYIdgb9FmwAxCwHdCwHtAwMTMTIzczEwUyBBIHBwYCBCMTIwMXMiQ3NicmJicnAzNFcbcetm4BirYBB3YXCx7N/rzCn91OksYBBSUaBwmXhrlL3gKMqgJ6AbX+wcBPyf7JrAKM/j4B+92YcZGkBAH+UgAAAgA7/+cFGQYAABoAJQCMsgUmJxESObAFELAj0ACwFy+wAEVYsBAvG7EQGz5ZsABFWLADLxuxAw8+WbAARViwBi8bsQYPPlmyLxcBXbIPFwFdshYXAxESObAWL7ITBworWCHYG/RZsAHQsgQGEBESObISEAYREjmwFhCwGdCwBhCyHgEKK1gh2Bv0WbAQELIjAQorWCHYG/RZMDEBIwMjNwYnJiYnJjc3NhI2FxYXNyM3MzczBzMBBhYXFjcTJicmBgT7qdXUEH6ql7UHAwYDFIzOfqVdLvAe8RvuGar8EQdbWolkUS+HiKYEyfs3cIkEAuW+PjsVpwEKgwMEd/WqjY38TnySAgSJAdF9BAT4AP//ACcAAAS6BvECJgApAAABBwByAMIBQQATALAARViwBi8bsQYfPlmwDdwwMQD//wA7/+oEBgW0AiYASQAAAQYAcjsEAAkAsAkvsCDcMDEA//8AJwAABLoHJAImACkAAAEHAWoA+AE9AAkAsAYvsA/cMDEA//8AO//qBAIF5wImAEkAAAEGAWpxAAAJALAJL7Aj3DAxAP//ACcAAAS6Bx4CJgApAAABBwFrAZsBRgAJALAGL7AU3DAxAP//ADv/6gQCBeECJgBJAAABBwFrARQACQAJALAJL7Ao3DAxAAABACf+UQS6BbAAHACAshEdHhESOQCwAEVYsBcvG7EXHz5ZsABFWLAQLxuxEBE+WbAARViwBC8bsQQPPlmwAEVYsBUvG7EVDz5ZshsVFxESObAbL7IBAQorWCHYG/RZsBUQsgIBCitYIdgb9FmwA9CwEBCyCwMKK1gh2Bv0WbAXELIZAQorWCHYG/RZMDEBIQMhByMXBwYHBhcWNxcGJyImNzY3IRMhByEDIQPT/bxOAqYjcQUvgwcFOBs9DEVVV2kCA5b9sPwDlyT9YUYCRQKK/kDKAx9WVjkDAReQKwJtVIxgBbDM/m4AAgA8/mwECARRACMALAChsgYtLhESObAGELAk0ACwAEVYsBkvG7EZGz5ZsABFWLAMLxuxDBE+WbAARViwES8bsREPPlmwA9CyJi0ZERI5sCYvso8mAV20HyYvJgJxtJ8mryYCcbRfJm8mAnG0vybPJgJdtO8m/yYCcbQvJj8mAnKyHQcKK1gh2Bv0WbARELIhAQorWCHYG/RZsiMRGRESObAZELIkAQorWCHYG/RZMDElBgcHBgcGFxY3FwYnIiY3NjcmAjc3NhI2FxYSBwchBhYXFjcDJgMFNzYnJiYDplWNMW0IBTgbPQxFVVdpAgJgt8wRAxKd6onLyxkO/VcJemuZgcm8XgHBBAcGC1q2eDIhTFI5AwEXkCsCbVRtVRkBHM4ppQEHiAME/trsaIGeAgWKAlgG/vABFS4sR1L//wAnAAAEugdCAiYAKQAAAQcBaADRAT0AEwCwAEVYsAYvG7EGHz5ZsBHcMDEA//8AO//qBAYGBQImAEkAAAEGAWhKAAAJALAJL7Ak3DAxAP//AGv/6gUWB0wCJgArAAABBwFnAPEBSwAJALANL7Aj3DAxAP////f+TwRCBgECJgBLAAABBgFnPgAACQCwBC+wLNwwMQD//wBr/+oFFgcyAiYAKwAAAQcBagEvAUsACQCwDS+wJdwwMQD////3/k8EQgXnAiYASwAAAQYBanwAAAkAsAQvsC7cMDEA//8Aa//qBRYHLAImACsAAAEHAWsB0gFUAAkAsA0vsCrcMDEA////9/5PBEIF4QImAEsAAAEHAWsBHwAJAAkAsAQvsDPcMDEA//8Aa/35BRYFyAImACsAAAAHA6sBbv6S////9/5PBEIGqwImAEsAAAEHA+0BNAB+AAkAsAQvsC/cMDEA//8AJwAABYcHPgImACwAAAEHAWcBEgE9ABMAsABFWLAHLxuxBx8+WbAQ3DAxAP//AA0AAAP5B14CJgBMAAABBwFnAFIBXQAJALARL7AU3DAxAAACAC4AAAXbBbAAEwAXAGsAsABFWLAPLxuxDx8+WbAARViwCC8bsQgPPlmyFAgPERI5sBQvshAUDxESObAQL7AA0LAQELIXBworWCHYG/RZsAPQsAgQsAXQsBQQsgcBCitYIdgb9FmwFxCwCtCwEBCwDdCwDxCwEtAwMQEzByMDIxMhAyMTIzczEzMDIRMzASE3IQVffB17s/Zw/Ypw9rN4HHgt9y4Cdi32/CsCdiH9igSuovv0Aof9eQQMogEC/v4BAv2iugABACsAAAQXBgAAGgB0sgMbHBESOQCwGC+wAEVYsAQvG7EEGz5ZsABFWLARLxuxEQ8+WbAARViwCS8bsQkPPlmyLxgBXbIPGAFdshoRGBESObAaL7IBBworWCHYG/RZsgIRBBESObAEELIOAQorWCHYG/RZsAEQsBPQsBoQsBbQMDEBIwM2FxYWBwMjEzYnJicmBwMjEyM3MzczBzMCy+Qyh6yalRN07XYFAw2DhGiH7dS/Hr4Z7hziBMf+/I4EAta9/UgCuyslegMChPz6BMeqj48A//8ANQAAA0oHMgImAC0AAAEHAW7/gQE+AAkAsAIvsA7cMDEA//8AFAAAAv8F7gImAPQAAAEHAW7/Nv/6AAkAsAIvsA7cMDEA//8ANQAAA0YG8QImAC0AAAEHAHL/ewFBABMAsABFWLACLxuxAh8+WbAF3DAxAP//AB8AAAL7Ba0CJgD0AAABBwBy/zD//QATALAARViwAi8bsQIbPlmwBdwwMQD//wA1AAADHQckAiYALQAAAQcBav+xAT0ACQCwAi+wB9wwMQD//wAiAAAC0gXgAiYA9AAAAQcBav9m//kACQCwAi+wB9wwMQD///+O/lcCKAWwAiYALQAAAAYBbeYG////dv5RAgkF2AImAE0AAAAGAW3OAP//ADUAAAJUBx4CJgAtAAABBwFrAFMBRgAJALACL7AM3DAxAAABACIAAAHLBDoAAwAdALAARViwAi8bsQIbPlmwAEVYsAAvG7EADz5ZMDEhIxMzAQ/tvO0EOv//ADX/5wacBbAAJgAtAAAABwAuAjsAAP//AB/+RgQDBdgAJgBNAAAABwBOAgUAAP//AAP/5wUxBzcCJgAuAAABBwFnAZIBNgAJALAAL7AQ3DAxAP///w/+SALHBd8CJgFkAAABBwFn/yj/3gATALAARViwDC8bsQwbPlmwEdwwMQD//wAn/fkFcQWwAiYALwAAAAcDqwFf/pL//wAR/fkESgYAAiYATwAAAAcDqwDu/pIAAQAhAAAEjQQ6AAwAXwCwAEVYsAQvG7EEGz5ZsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmwAEVYsAsvG7ELDz5ZsgYCBBESObAGL7QfBi8GAnGyjwYBXbIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBIQEBIQHLc0vsvOxLSAGRATb+BwFF/uUBrP5UBDr+UAGw/ef93wD//wAnAAADwwc2AiYAMAAAAQcAdwBqATYAEwCwAEVYsAUvG7EFHz5ZsAjcMDEA//8AHwAAAz0HkQImAFAAAAEHAHcAawGRABMAsABFWLADLxuxAyE+WbAG3DAxAP//ACf9+QPDBbACJgAwAAAABwOrASX+kv///6L9+QIXBgACJgBQAAAABwOr/9P+kv//ACcAAAPfBbECJgAwAAABBwOrAskEqwAQALAARViwCi8bsQofPlkwMf//AB8AAAN0BgIAJgBQAAABBwOrAl4E/AAGALAILzAx//8AJwAAA8MFsAImADAAAAAHAWsBXP3U//8AHwAAAvMGAAAmAFAAAAAHAWsA8v2vAAEAIQAAA9IFsAANAFsAsABFWLAMLxuxDB8+WbAARViwBi8bsQYPPlmyAQwGERI5sAEvsADQsAEQsgIHCitYIdgb9FmwA9CwBhCyBAEKK1gh2Bv0WbADELAI0LAJ0LAAELAL0LAK0DAxATcHBwMhByETBzc3EzMBxfAc71oCgiP8h3CFG4Vy9wNsRptH/frKAoImmycCkgAAAQAfAAACWwYAAAsASgCwAEVYsAovG7EKIT5ZsABFWLAELxuxBA8+WbIBBAoREjmwAS+wANCwARCyAgcKK1gh2Bv0WbAD0LAG0LAH0LAAELAJ0LAI0DAxATcHBwMjEwc3NxMzAcKZHJiA7nKMHIp/7QN/NJw1/R4Ciy+cLwLZAP//ACcAAAWGBzYCJgAyAAABBwB3Ah4BNgATALAARViwCC8bsQgfPlmwDNwwMQD//wANAAAEJgYAAiYAUgAAAQcAdwFUAAAACQCwAy+wFdwwMQD//wAn/fkFhgWwAiYAMgAAAAcDqwGQ/pL//wAN/fkD+gRSAiYAUgAAAAcDqwD6/pL//wAnAAAFhgc7AiYAMgAAAQcBaAExATYAEwCwAEVYsAYvG7EGHz5ZsA/cMDEA//8ADQAABCMGBQImAFIAAAEGAWhnAAAJALADL7AX3DAxAP//AA0AAAP6BgMCJgBSAAABBwOrAEAE/QAGALAXLzAxAAEAI/5GBXgFsAATAGeyBhQVERI5ALAARViwAC8bsQAfPlmwAEVYsBAvG7EQHz5ZsABFWLAELxuxBBE+WbAARViwDC8bsQwPPlmwAEVYsA4vG7EODz5ZsAQQsgkBCitYIdgb9FmyDQAMERI5shIOABESOTAxAQEGBiciJzcWMzI3NwEDIxMzARMFeP7/GNelO0wjNimBIgf+SLf2/e4Bu7cFsPoYtswCFMYOxCgEH/vhBbD74gQeAAABABH+RgQGBFIAGwBhsgIcHRESOQCwAEVYsAMvG7EDGz5ZsABFWLAALxuxABs+WbAARViwCi8bsQoRPlmwAEVYsBkvG7EZDz5ZsgEDGRESObAKELIPAQorWCHYG/RZsAMQshYBCitYIdgb9FkwMQEHNhcWFgcDBgYnJic3FjMyNxM2JyYnJgcDIxMBpReGu6GWFnYY0KNBRCM5J4EfdgUCB4uDZY3uvAQ7mK8EA+bE/SC1xgIBE8UPuwLTLSmMBQRq/N8EOv//AGv/5wUhBuoCJgAzAAABBwByAREBOgAJALAKL7Aj3DAxAP//ADn/6AQnBbQCJgBTAAABBgByTwQACQCwBC+wIdwwMQD//wBr/+cFIQcdAiYAMwAAAQcBagFHATYACQCwCi+wJtwwMQD//wA5/+gEJwXnAiYAUwAAAQcBagCFAAAACQCwBC+wJNwwMQD//wBr/+cFdwc1AiYAMwAAAQcBbwGOATYADACwCi+wJdywJ9AwMf//ADn/6AS1Bf8CJgBTAAABBwFvAMwAAAAMALAEL7Aj3LAl0DAxAAIAUP/uB4oFxQAXACUAkbIbJicREjmwGxCwFtAAsABFWLAMLxuxDB8+WbAARViwDi8bsQ4fPlmwAEVYsAMvG7EDDz5ZsABFWLAALxuxAA8+WbAOELIQAQorWCHYG/RZshMADhESObATL7IUAQorWCHYG/RZsAAQshcBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WbAMELIdAQorWCHYG/RZMDEhIQcHJiYCNxM2EiQzFxchByEDIQchAyEFFjcTJicmBgcDBhcWFgaU/MXEV57naRQyHLUBE6VKzwNSJP1hRgJFJP29TgKm+5BPe8ZzTKDaHi8JBgiBEQEEnQEQoQE9qQENkgITzP5uyP5AGQMMBDsOAgLZwv7TSEZ0iAAAAwBC/+gG3ARSACAALwA5ALiyGjo7ERI5sBoQsCnQsBoQsDPQALAARViwCS8bsQkbPlmwAEVYsAQvG7EEGz5ZsABFWLAcLxuxHA8+WbAARViwFy8bsRcPPlmyBwkcERI5sjQJHBESObA0L7KPNAFdtB80LzQCcbINBworWCHYG/RZsBcQshEBCitYIdgb9FmyExcJERI5shoJHBESObAcELIlAQorWCHYG/RZsAQQsiwBCitYIdgb9FmwCRCyMAEKK1gh2Bv0WTAxEzYSNhcWFhc2FxYSBwchBhYXFjcXBgYnJiYnBicuAjczBxcWFxY2Nzc1JicmBgcBJgYHITc2JyYmVBSY7pRytzGmzsPJGhb9cA1raJqaQUPMe3a1MablisJYEOwFAQ6se6QVBwi0cqAcA/tShTYBpwUHBQhTAiChAQSMAgJeUbQEBP7z14+FnwMFX6A+QQICXE6xBAKO+ZZLLt8HA8alYR3yCAOxpAFTAXqMHC0pQ03//wAnAAAE2Ac2AiYANgAAAQcAdwGoATYACQCwBC+wGtwwMQD//wAQAAADhgYAAiYAVgAAAQcAdwC0AAAACQCwCy+wENwwMQD//wAn/fkE2AWwAiYANgAAAAcDqwEm/pL///+c/fkC7wRTAiYAVgAAAAcDq//N/pL//wAnAAAE2Ac7AiYANgAAAQcBaAC7ATYACQCwBC+wHNwwMQD//wAQAAADhAYFAiYAVgAAAQYBaMgAAAkAsAsvsBLcMDEA//8AJP/qBLsHNgImADcAAAEHAHcBxAE2AAkAsAovsCzcMDEA//8AHP/pBAMGAAImAFcAAAEHAHcBMQAAAAkAsAgvsCfcMDEA//8AJP/qBLsHNwImADcAAAEHAWcAwAE2AAkAsAovsCvcMDEA//8AHP/pA8wGAQImAFcAAAEGAWctAAAJALAIL7Am3DAxAP//ACT+PQS7BccCJgA3AAAABwB7AZAAAP//ABz+NAPEBFACJgBXAAAABwB7AUL/9///ACT/6gS7BzsCJgA3AAABBwFoANcBNgAJALAKL7Au3DAxAP//ABz/6QQABgUCJgBXAAABBgFoRAAACQCwCC+wKdwwMQD//wCc/kAFIgWwAiYAOAAAAAcAewF/AAP//wA7/j0CrgVBAiYAWAAAAAcAewDVAAD//wCcAAAFIgc7AiYAOAAAAQcBaADJATYAEwCwAEVYsAYvG7EGHz5ZsA3cMDEA//8AO//tA8gGgwAmAFgAAAAHA6sCsgV9AAEAnAAABSIFsAAPAEwAsABFWLAKLxuxCh8+WbAARViwAi8bsQIPPlmyDwoCERI5sA8vsgAHCitYIdgb9FmwBNCwDxCwBtCwChCyCAEKK1gh2Bv0WbAM0DAxASMDIxMjNzMTITchByEDMwO+yYj2ic0ezDT+SyQEYiT+SDTKAxL87gMSqgEozMz+2AAAAf/i/+0CrgVBAB4AgLIXHyAREjkAsABFWLAVLxuxFRs+WbAARViwGS8bsRkbPlmwAEVYsAsvG7ELDz5Zsh4ZCxESObAeL7IABworWCHYG/RZsAsQsgYBCitYIdgb9FmwABCwD9CwHhCwEdCwFRCyEwEKK1gh2Bv0WbAVELAX0LAXL7ATELAb0LAc0DAxASMDBhcWFzI3BwYjJiY3EyM3MzcjNzMTMwMzByMHMwJt0S0DAgZKJS8QSkt8ew0uzx7NG60grC7uLrkfuhzSAjf+8RkUQQMJvhUCpYgBG6qltAEH/vm0pf//AFv/5gUvBysCJgA5AAABBwFuAO8BNwAJALAAL7Ad3DAxAP//AEr/6AQxBfUCJgBZAAABBgFuWgEACQCwBy+wHtwwMQD//wBb/+YFLwbqAiYAOQAAAQcAcgDpAToACQCwAC+wE9wwMQD//wBK/+gEMQW0AiYAWQAAAQYAclQEAAkAsAcvsBTcMDEA//8AW//mBS8HHQImADkAAAEHAWoBHwE2AAkAsAAvsBbcMDEA//8ASv/oBDEF5wImAFkAAAEHAWoAigAAAAkAsAcvsBfcMDEA//8AW//mBS8HlQImADkAAAEHAWwBewFqAAwAsAAvsBzcsB/QMDH//wBK/+gEMQZfAiYAWQAAAQcBbADmADQADACwBy+wHdywINAwMf//AFv/5gVPBzUCJgA5AAABBwFvAWYBNgAMALAAL7AV3LAX0DAx//8ASv/oBLoF/wImAFkAAAEHAW8A0QAAAAwAsAcvsBbcsBjQMDEAAQBb/ogFMgWwACAAYbIHISIREjkAsABFWLAALxuxAB8+WbAARViwFy8bsRcfPlmwAEVYsA0vG7ENFz5ZsABFWLASLxuxEg8+WbIEEgAREjmwDRCyCAMKK1gh2Bv0WbASELIcAQorWCHYG/RZMDEBAwYGBwYHBhcWNxcGJyImNzY3LgI3EzMDBhYXFjY3EwUypRe+lXoKBTgbPQxFVVdpAgI9kNJgEaX2pRJ2e4e0GacFsPwzpPY4UFg5AwEXkCsCbVRYSAiE34wDzvwxi5wEBJqQA9QAAAEASv5RBDEEOgAjAHeyEiQlERI5ALAARViwGC8bsRgbPlmwAEVYsCEvG7EhGz5ZsABFWLALLxuxCxE+WbAARViwAC8bsQAPPlmwAEVYsBMvG7ETDz5ZsAsQsgYDCitYIdgb9FmwABCwENCwEC+yESEAERI5sBMQsh4BCitYIdgb9FkwMSEXBwYHBhcWNxcGJyImNzY3NwYnLgI3EzMDBhcWFxY3EzMDA1wFL4MHBTgbPQxFVVdpAgOxEnu5aYs7DHXtdgQDCnOdYYjtuwMfVlY5AwEXkCsCbVSWZ1qDBAJks3kCvP1BJSN8BQaEAwr7xgD//wC3AAAHOgc3AiYAOwAAAQcBZwG/ATYAEwCwAEVYsAwvG7EMHz5ZsA/cMDEA//8AdwAABfgGAQImAFsAAAEHAWcBAgAAABMAsABFWLALLxuxCxs+WbAR3DAxAP//AKEAAAVNBzcCJgA9AAABBwFnALkBNgATALAARViwAS8bsQEfPlmwC9wwMQD///+1/kUEEgYBAiYAXQAAAQYBZxYAABMAsABFWLAPLxuxDxs+WbAU3DAxAP//AKEAAAVNBwMCJgA9AAABBwBrAO8BNgAMALABL7Aa3LAJ0DAx////5QAABOcHNgImAD4AAAEHAHcBuQE2ABMAsABFWLAHLxuxBx8+WbAM3DAxAP///+cAAAPxBgACJgBeAAABBwB3AR8AAAATALAARViwBy8bsQcbPlmwDNwwMQD////lAAAE5wcXAiYAPgAAAQcBawGWAT8ACQCwBy+wEtwwMQD////nAAAD5AXhAiYAXgAAAQcBawD8AAkACQCwBy+wEtwwMQD////lAAAE5wc7AiYAPgAAAQcBaADMATYACQCwBy+wDtwwMQD////nAAAD7gYFAiYAXgAAAQYBaDIAAAkAsAcvsA7cMDEAAAEAHgAAAyAGGgANADKyAg4PERI5ALAARViwBC8bsQQhPlmwAEVYsAAvG7EADz5ZsAQQsgkBCitYIdgb9FkwMTMTNjYXFhcHJiciBgcDHskX2qo8YiwsLVBoD8oEn7HKAgEXuAwCY1n7ZgACAE7/6AUvBcMAGgAkAF6yDSUmERI5sA0QsBzQALAARViwEi8bsRIfPlmwAEVYsAAvG7EADz5ZsggSABESObAIL7ASELINAQorWCHYG/RZsAAQshsBCitYIdgb9FmwCBCyHgEKK1gh2Bv0WTAxBSYkJycmNzcFNicmJicmByc2IRYEEgcHBgIEJxY2NyEHBhcWFgJJ0/77GgQFDBYDrw8KEqqLpNEehgEfvgELdxkPHsv+1p2R2kP9RQcOChCRFATr1DJUWo8BW1OHlwMDSclUA7D+w8Rozf68rtcDy9EiTkNsdwAB/0r+RgNMBhkAHQBxsgIeHxESOQCwAEVYsBQvG7EUIT5ZsABFWLAPLxuxDxs+WbAARViwHC8bsRwbPlmwAEVYsAUvG7EFET5ZsBwQsgABCitYIdgb9FmwBRCyCgEKK1gh2Bv0WbAAELAN0LAO0LAUELIZAQorWCHYG/RZMDEBIwMGBicmJzcWFzI3EyM3Mzc2NhcWFwcmIyIHBzMCocOUE8iiQ0AgNyR4HZehHaAMFdiqNWcqNyekGwvDA4b8NK7GAgISvg4CqQPTtGWyyAIBFrsMxVIAAgBb/+gGJgYuABoAKwBbsiAsLRESObAgELAa0ACwAEVYsAovG7EKHz5ZsABFWLAALxuxAA8+WbINCgAREjmwDS+yEwgKK1gh2Bv0WbAKELIfAQorWCHYG/RZsAAQsigBCitYIdgb9FkwMQUuAicmEhI3NhcWFhc2NjczAgUWFxYCAgcGEzc2JicmAg8CBhYWFxYSNwJIj9R7CAc/mWyr3nfFQ1JlE7Ug/vIVBQU9o3Wl9AkKg4as5SMJCAY1d1ml4igUA4H3oX4BUAESV4kEAlhQD4CF/q5HZ2WG/p3+21h7AxhqtdAEBf7u9UBpbbxhAwcBAPMAAgA2/+YFBQSoABgAJwBbsh0oKRESObAdELAE0ACwAEVYsAQvG7EEGz5ZsABFWLAVLxuxFQ8+WbIHBBUREjmwBy+yDggKK1gh2Bv0WbAVELIcAQorWCHYG/RZsAQQsiMBCitYIdgb9FkwMRM2EjYXFhYXNjc3MwYGBxYXFgcCACcmAjcXFhYXFjY3NzYmJyYGBwZREp3xlGKvPmcbDqEOc24PAwIIJf7K3dTgGOoDY1l6qBgHA2NieqYZCAIgoAEGiwICSU0pfEyQqSdIR0dJ/vH+zAUGATXlc2l/BAPCqWJ9lQQDw6xRAAEAW//oBq0GAgAaAFSyFxscERI5ALAARViwAC8bsQAfPlmwAEVYsBEvG7ERHz5ZsABFWLAMLxuxDA8+WbIBAAwREjmwAS+yCAgKK1gh2Bv0WbAMELIWAQorWCHYG/RZMDEBBzY2NzcGBgcDBgAnLgI3EzMDBhYXFjY3EwUyKGp3Fa0T1c1sIv658JXcZxGl9qUSdX2HsxmnBbDfC4mcAdbiDP2k6P7uBAN+5JEDzvwxip4EBJqRA9QAAAEASv/oBWEElAAbAGiyFBwdERI5ALAARViwDS8bsQ0bPlmwAEVYsBYvG7EWGz5ZsABFWLAELxuxBA8+WbAARViwCC8bsQgPPlmyGBYEERI5sBgvsgMICitYIdgb9FmyBhYEERI5sAgQshMBCitYIdgb9FkwMQEGBgcDIzcGJy4CNxMzAwYXFhcWNxMzBzY2NwVhD6Slk94Ve7lpizsMde11BAMHdp5fiO0fUlISBJSuqQz8z2uDBAJks3kCvP1BJSN8BQaEAwqLDVx7////D/5IAvsF4wImAWQAAAEHAWj/P//eAAkAsAAvsBHcMDEA//8Aa//qBRYHSwImACsAAAEHAHcB9QFLAAkAsA0vsCTcMDEA////9/5PBEIGAAImAEsAAAEHAHcBQgAAAAkAsAQvsC3cMDEA//8AJwAABYYHNgImADIAAAEHAEQBgwE2ABMAsABFWLAGLxuxBh8+WbAL3DAxAP//AA0AAAP6BgACJgBSAAABBwBEALkAAAATALAARViwAy8bsQMbPlmwFNwwMQD///+kAAAE2gexAiYAJQAAAAcDxQGEARz//wAi/+gEMgZ8AiYARQAAAAcDxQDc/+f///+HAAAHeAdCAiYAiQAAAQcAdwLqAUIAEwCwAEVYsAYvG7EGHz5ZsBXcMDEA//8AD//oBnAGAQImAKkAAAEHAHcCawABAAkAsBkvsEHcMDEA//8AFf+hBZgHgAImAJsAAAEHAHcCIAGAABMAsABFWLAMLxuxDB8+WbAu3DAxAP//ACr/dwQzBf4CJgC7AAABBwB3ATP//gATALAARViwBS8bsQUbPlmwMdwwMQD///+kAAAErgchAiYAJQAAAQcBdQSKATMAFgCwAEVYsAQvG7EEHz5ZsAzcsBDQMDH//wAi/+gD3AXsAiYARQAAAQcBdQPi//4AFgCwAEVYsBgvG7EYGz5ZsC3csDHQMDH//wAnAAAEugcoAiYAKQAAAQcBdQRSAToAFgCwAEVYsAYvG7EGHz5ZsA3csBHQMDH//wA7/+oEAgXsAiYASQAAAQcBdQPL//4AFgCwAEVYsAkvG7EJGz5ZsCHcsCXQMDH////JAAACvQcoAiYALQAAAQcBdQMKAToAFgCwAEVYsAIvG7ECHz5ZsAXcsAnQMDH///9+AAACcgXkAiYA9AAAAQcBdQK///YAFgCwAEVYsAIvG7ECGz5ZsAXcsAnQMDH//wBr/+cFIQchAiYAMwAAAQcBdQShATMAFgCwAEVYsAovG7EKHz5ZsCTcsCjQMDH//wA5/+gEJwXsAiYAUwAAAQcBdQPf//4AFgCwAEVYsAQvG7EEGz5ZsCLcsCbQMDH//wAnAAAE2AchAiYANgAAAQcBdQQ8ATMAFgCwAEVYsAQvG7EEHz5ZsBncsB3QMDH//wAHAAAC+wXsAiYAVgAAAQcBdQNI//4AFgCwAEVYsAcvG7EHGz5ZsA/csBPQMDH//wBb/+YFLwchAiYAOQAAAQcBdQR5ATMAFgCwAEVYsAovG7EKHz5ZsBTcsBjQMDH//wBK/+gEMQXsAiYAWQAAAQcBdQPk//4AFgCwAEVYsAgvG7EIGz5ZsBXcsBnQMDH//wAk/fkEuwXHAiYANwAAAAcDqwE+/pL//wAc/fkDxARQAiYAVwAAAAcDqwDw/pL//wCc/fkFIgWwAiYAOAAAAAcDqwEt/pL//wA7/fkCrgVBAiYAWAAAAAcDqwCD/pIAAf8P/kgB3AQ6AAwAKACwAEVYsAwvG7EMGz5ZsABFWLAELxuxBBE+WbIJAQorWCHYG/RZMDEBAwYGIyInNxYzMjcTAdzDGMyjPUYfNSp/IcIEOvuItcURwRDCBG4AAAIANv/qA/YEUAAVAB0AZbIQHh8REjmwEBCwFtAAsABFWLAALxuxABs+WbAARViwCC8bsQgPPlmyDAAIERI5sAwvsAAQshABCitYIdgb9FmyEgwQERI5sAgQshYBCitYIdgb9FmwDBCyGAcKK1gh2Bv0WTAxARYSBwcOAicmAjc3ITYmJyYHJzY2ExYTIQYXFhYCRc7jFgcVmuSDxcgaFgKQDGppl5xBQ8wHqGf+WA0GCFUETgT+1eY5l/yDAwYBDNWPg6EDBV+gPkL8XQYBC0kpQ0///wCKBAAB/gYAAwYDcQAAAAYAsAQvMDEAAQECBN0DnwYBAAgASgCwBS+yDwUBXbAG0BmwBi8YsADQGbAALxiwBRCwAdCwAS+wBRCwBNCwBC+wAtCwAi+wBRCwB9CwBy+0DwcfBwJdsgMFBxESOTAxARUnJwcHJwEzA5+5da3BAQEtiATuEQObmgQSARIAAAEBDQTgA7wGBQAIACUAsAQvsg8EAV2wAtCwAi+0DwIfAgJdsgAEAhESObAH0LAHLzAxATc3FQEjAzUXAkKp0f7MkunEBWeZBBD+7AEVEAT//wDvBRIDywWwAAYAcgAAAAEA/gTIA2wF5wAMACwAsAMvsg8DAV2wANCwAC+0DwAfAAJdsAbQsAYvsAMQsgkCCitYIdgb9FkwMQEGBicmJjUXBjMyNjcDbAq6h4SfsAV4Q0wMBeeFmgQCmYABjE49AAEBAgTcAgEF2AAKAB2yAAsMERI5ALAIL7IPCAFdsgIFCitYIdgb9FkwMQE0NjYWFRQGBwYmAQJHbkpHNzZLBVU4RwRFNjlEAgJFAAACAPoEjAKoBisACwAXAC8AsAkvsg8JAV2wFdCwFS+yDxUBXbIDDAorWCHYG/RZsAkQsg8KCitYIdgb9FkwMRM0NjMyFhUUBiMiJjcGFjMyNjc2JiMiBvqFXVJ6hF1XdmsGMisySQYGMSsySgVSWn91VFl9dFQoQkguK0BJAAAB/6j+UQEkAD0ADwAbALAARViwCi8bsQoRPlmyBQMKK1gh2Bv0WTAxBQcGBwYXFjcXBiciJjc2JQEkL4MHBTgbPQxFVVdpAgMBCAMfVlY5AwEXkCsCbVSzdgABAN4E2wPJBfQAFABBALADL7AI0LAIL7QPCB8IAl2yDgMKK1gh2Bv0WbAU0LAA0LADELAK0LAKL7AL0LALL7ADELISAworWCHYG/RZMDEBBgYjIi4CBwYHJzY2FxYWFxc2NwPJDIFeGC1rNB1PG5UKgmAwliIZURwF6XeMDj0TAQNlCHKXAgFZBAEDZgAAAgCsBNED6QX/AAMABwBAALACL7IPAgFdsADQsAAvtA8AHwACXbACELAD0BmwAy8YsAAQsAXQsAUvsAIQsAbQsAYvsAMQsAfQGbAHLxgwMQEzASMDMwEjAu/6/snSVvP+9MUF//7SAS7+0gAAAv/u/mkBTf+/AAsAFwA9ALAYL7AD0LADL0APAAMQAyADMANAA1ADYAMHXbAP0LAPL7IJCQorWCHYG/RZsAMQshUJCitYIdgb9FkwMQc0NjMyFhUUBiMiJjcGFjMyNjc2JiciBhJqS0lhaUhKZGEEJR0hNgYFHiAjOfVNZ2JESmZeRh8rMyEdMQE2AAAB/VQE0f7ZBgAAAwAjALABL7IPAQFdsADQGbAALxiwARCwAtCwAi+0DwIfAgJdMDEBIwMz/tm00fwE0QEvAAH91wTR/+kGAAADACMAsAIvsg8CAV2wAdCwAS+0DwEfAQJdsAIQsAPQGbADLxgwMQEhASP+yQEg/r7QBgD+0f///PYE2//hBfQABwFu/BgAAAAB/dYE5f89Bn8ADgAlALAOL7AH0LAHL7IBDgcREjmyCAgKK1gh2Bv0WbINAQ4REjkwMQE3NzY3NicnNxcEBwYHB/3WDi9fCQprIhEoAQwDA6AKBOaSBQs6PAQBfAIWoX0eRgAAAvy/BOT/swXuAAMABwA3ALABL7AA0BmwAC8YsAEQsAXQsAUvsAbQsAYvtg8GHwYvBgNdsAPQsAMvsAAQsATQGbAELxgwMQEjAyEBIwMh/pHd9QESAeLOwAEEBOQBCv72AQoAAAH8oP6R/az/jgALABEAsAMvsgkNCitYIdgb9FkwMQU0Njc2FhUUBgcGJvygSzo3UEo7Ok31NkkCAkQ3OUUCAkYAAAEBLgTpAogGQQADABcAsAIvsADQsAAvsAIQsAPQGbADLxgwMQEzAyMBpuLElgZB/qgAAwDoBNwEIwavAAMADwAbAD4AsA0vsALQsAIvsADQsAAvtA8AHwACXbACELAD0BmwAy8YsA0QsgcFCitYIdgb9FmwE9CwDRCwGdCwGS8wMQEzAyMFNDY3NhYVBgYHBiYlNjY3NhYVFAYHBiYCneizl/6tRDcySgFGMzJLAkQBRjMyS0U2NEgGr/7WMjBIAgJCNDREAgJCMzREAgJCNDBIAgJEAP///6QAAASuBkECJgAlAAAABgF3wQD//wCeAkIBsQNVAgYAegAA////vgAABR4GQQAmAClkAAAHAXf+kAAA////xgAABesGQQAmACxkAAAHAXf+mAAA////ygAAAowGQwAmAC1kAAAHAXf+nAAC//8AGP/nBTUGQQAmADMUAAAHAXf+6gAA////WAAABbEGQQAmAD1kAAAHAXf+KgAA//8AHQAABQsGQQAmAZkUAAAHAXf+9AAA//8AC//0A0YGmgImAakAAAEHAXj/I//rABIAsAAvsCfcsA7QsCcQsBLQMDH///+kAAAErgWwAgYAJQAA//8AJwAABLwFsAIGACYAAAABAC4AAASsBbAABQArALAARViwBC8bsQQfPlmwAEVYsAIvG7ECDz5ZsAQQsgABCitYIdgb9FkwMQEhAyMTIQSI/XXZ9vwDggTk+xwFsAAC/6oAAAUJBbAAAwAGAC8AsABFWLAALxuxAB8+WbAARViwAi8bsQIPPlmyBAEKK1gh2Bv0WbIGAgAREjkwMQEzASElIQMC6+0BMfqhAXoCybcFsPpQygO5AP//ACcAAAS6BbACBgApAAD////lAAAE5wWwAgYAPgAA//8AJwAABYcFsAIGACwAAAADAF7/5wUWBcgAAwAVACUAg7IbJicREjmwGxCwAtCwGxCwDdAAsABFWLANLxuxDR8+WbAARViwBC8bsQQPPlmyAgQNERI5fLACLxiyYAIBXbJCAgFdsnICAV200ALgAgJdsjACAV2yAAIBcbIBAQorWCHYG/RZsA0QshoBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxASE3IQEuAicmEhI3NgQAFxYCAgcGEzc2JicmAg8CBhYXFhI3A5D+SyMBtP6aj9Z6CAc6n3SoAbABAQwGOYtnstwJB4ODr+IiCggKhIWl4igCecL8sQOD+J1zAVEBIVqCCP7e93z+v/7zWpwDGWq8yQQF/u3tR2m30gQHAQDzAP//ADUAAAIoBbACBgAtAAD//wAnAAAFcQWwAgYALwAAAAH/sgAABH8FsAAGADEAsABFWLADLxuxAx8+WbAARViwAS8bsQEPPlmwAEVYsAUvG7EFDz5ZsgADARESOTAxAQEhATMTIQLe/eX+7wLr7/P/AARB+78FsPpQ//8AJwAABs4FsAIGADEAAP//ACcAAAWGBbACBgAyAAAAAwAAAAAEiAWwAAMABwALAEsAsABFWLAILxuxCB8+WbAARViwAi8bsQIPPlmyAAEKK1gh2Bv0WbIFCAIREjmwBS+yBgEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDE3IQchEyEHIRMhByEkA6Yj/Fn0AuEj/R84A38j/IDKygNNxgMpzAD//wBr/+cFIQXIAgYAMwAAAAEALgAABYMFsAAHADgAsABFWLAGLxuxBh8+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsAYQsgIBCitYIdgb9FkwMSEjEyEDIxMhBIb22f2U2fb8BFkE5PscBbAA//8AJwAABQQFsAIGADQAAAAB/9wAAASfBbAADAA8ALAARViwCC8bsQgfPlmwAEVYsAMvG7EDDz5ZsgEBCitYIdgb9FmwBdCwCBCyCgEKK1gh2Bv0WbAH0DAxAQEhByE3AQE3IQchAQMb/i8CniP8FxwCIP6oGQPGJP12ASsC0f35yqICQwI+jcz+AQD//wCcAAAFIgWwAgYAOAAA//8AoQAABU0FsAIGAD0AAAADAFIAAAWxBbAAFQAcACMAdbITJCUREjmwExCwGtCwExCwIdAAsABFWLAVLxuxFR8+WbAARViwCC8bsQgPPlmyExUIERI5sBMvsADQsAAvsgoIFRESObAKL7AH0LAHL7AKELIZAQorWCHYG/RZsBMQshoBCitYIdgb9FmwINCwGRCwIdAwMQEWAAcGAgQHByM3LgI3NhI3Njc3MwEGFhcTBgYFNiYnAzY2A9XbAQEVD63+6ack9ySR3GwPD6qKj6sm9/1YEXyFgpjHA0QSeoWBlccE/Qr+zOaf/wCNA6qrBY72k6ABAElLA7L9F5KuCwKyCMCMlbAN/U4Ivf///8MAAAVHBbACBgA8AAAAAQB1AAAF1wWwABkAXLIKGhsREjkAsABFWLAELxuxBB8+WbAARViwEC8bsRAfPlmwAEVYsBgvG7EYHz5ZsABFWLAKLxuxCg8+WbIXBAoREjmwFy+wANCwFxCyDAEKK1gh2Bv0WbAJ0DAxATY2NxMzAwYABwMjEyYCNxMzAwYXFhYXEzMDQYarGVX3Vir+wfZI9kjc2x1T9lQIAwVjWZ70Aj8bxZoB9/4C+f7VF/6JAXcfAUHoAfH+Dj48YocYA20AAQAJAAAE9wXHACMAWbIAJCUREjkAsABFWLAZLxuxGR8+WbAARViwDy8bsQ8PPlmwAEVYsCIvG7EiDz5ZsiEBCitYIdgb9FmwANCwGRCyBwEKK1gh2Bv0WbAAELAO0LAhELAR0DAxJTYSEzc1AicmBgIHBhYXByE3NwITNzYSJBcWFhIHBwIFNwchAoCPqyEGC8+Qvj4DBVFRIP4UJdGhJQ0atAESpJ3gZhUNNf720ST+Hc4nATMBN08zAQ8IBdv+fHaQrxnQywIBDgESXbgBJp8EBKT+3qhX/p7RBMv//wA1AAADLAcKAiYALQAAAQcAa/+pAT0ADACwAi+wFdywBNAwMf//AKEAAAVNBwMCJgA9AAABBwBrAO8BNgAMALABL7Aa3LAJ0DAx//8APv/qBDMGQQImAaEAAAEHAXcBRgAAAAkAsBovsC7cMDEA//8AKP/qBAIGQQImAaUAAAEHAXcBEAAAAAkAsAgvsCrcMDEA//8AEf5hBAYGQQImAacAAAEHAXcBGgAAAAkAsAMvsBXcMDEA//8Abv/0ApIGLAImAakAAAEGAXcK6wAJALAAL7AQ3DAxAP//AFf/5QQ9BqICJgG1AAABBgF4GvMAEgCwCi+wMNywF9CwMBCwG9AwMQACAD7/6gQzBFEAHQArAHmyGiwtERI5sBoQsCTQALAARViwGi8bsRobPlmwAEVYsAAvG7EAGz5ZsABFWLAQLxuxEA8+WbAARViwCi8bsQoPPlmyBQEKK1gh2Bv0WbINGhAREjmyHBoQERI5sBAQsiMBCitYIdgb9FmwGhCyKAEKK1gh2Bv0WTAxAQMGFxYXMzcXBicmJicGBicmJicmNzc2EjYXFhc3AQYXFhYXFjcTJicmBgcEM4AHAgInDg0GNUBOXg08lGSatAcDBgMVi8yArVUx/cwGAQJZUoRiUC9/eZ4WBDr9BjQaNAIDtx0CAlRLS1kCAtu1PTwVrAEThgMElYX9uDM4ZHQCA4sByYkEBdO2AAAC/+X+dwRrBccAFAApAGWyFCorERI5sBQQsBzQALAPL7AARViwAC8bsQAfPlmwAEVYsAwvG7EMDz5ZshUADBESObAVL7InAQorWCHYG/RZsgUnFRESObAAELIbAQorWCHYG/RZsAwQsiEBCitYIdgb9FkwMQEWFgcGBxYWBw4CJyYnAyMTPgITNjY3NiYnJgYHAxYXMjY3NiYnJzcC27jYDQ7cXl4ICobbhJ10V+z3EJLiF2mCCwlYUWCREotKkXGjEA5ZWIQaBcQE1anDdS66dYXRbwMEUv42Bah3xG39lAJ0aVhuBAKAZvzeUAKPcmWMBQG4AAABAHf+XwQwBDoACAA4sgAJChESOQCwAEVYsAEvG7EBGz5ZsABFWLAHLxuxBxs+WbAARViwBC8bsQQRPlmyAAcEERI5MDEBATMBAyMTAzMByQFp/v3fTu1TsOwBPgL8++L+QwHeA/0AAAIAOP/nBDgGJAAfAC4AYrICLzAREjmwAhCwJtAAsABFWLADLxuxAyE+WbAARViwFS8bsRUPPlmwAxCyCAEKK1gh2Bv0WbIOFQMREjmwDi+yKwEKK1gh2Bv0WbIcKw4REjmwFRCyJQEKK1gh2Bv0WTAxATY2FxYXByYHIgYHBhcXBAMHDgInLgI3NjY3NSYmAwYXFhYXFjY3NiYnBgYHAUEH67FsmRWEakxrCg9wLAGGJwMUme+QisRcDhLbnkhNBwYDA2NXd6QcDmZgeqUYBOKVrQICMcQ4AkE3TTcUrP51FJ36iAQEh/GUvv8cDyeG/XM1O2h9AwO9vH+7HgO6qgABACj/6gQCBFEAJwCgshQoKRESOQCwAEVYsAgvG7EIGz5ZsABFWLAlLxuxJQ8+WbIVCCUREjmwFS+yjxUBXbQfFS8VAnG0XxVvFQJxtL8VzxUCXbTvFf8VAnGyWhUBXbIXBworWCHYG/RZsgIXFRESObAIELIPAQorWCHYG/RZsgwVDxESObYMDBwMLAwDXbAlELIdAQorWCHYG/RZsiAXHRESObQDIBMgAl0wMRM2NyYmNzYkFxYWFSc0JiMmBgcGFxcHJyIGBwYWFxY2NzMOAicmJi8K5j1PAgUBDc6y2+llTlmGChOx0R+0boQJCGdcWo4O7gmC3X7D7AEpt1MhbUiargQFspABQkgCUER5BgGtAVVKP04DAlVKa5xQAgSqAAEAZv59BFAFsAAbAE+yEhwdERI5ALAML7AARViwAC8bsQAfPlmyGQEKK1gh2Bv0WbIBGQAREjmyAgwAERI5shMMABESObATELIGAQorWCHYG/RZshgADBESOTAxAQcBBhcWFxcWFgcGByc3Njc2JyckEzYSNwEhNwRQHP4W4gcDXbBZSQQK3norPwsKTnX+7xwOqrEBFP3eIgWwnP4J9NleJD0hYUmlpGsvSDo3HCRbAQ2KASqyAQ/DAAEAEf5hBAYEUgASAFOyCBMUERI5ALAARViwAy8bsQMbPlmwAEVYsAAvG7EAGz5ZsABFWLAHLxuxBxE+WbAARViwEC8bsRAPPlmyAQMQERI5sAMQsg0BCitYIdgb9FkwMQEHNhcWFgcDIxM2JyYnJgcDIxMBpRSKtaGVE7vtvAUDDoaIZYnuvAQ7hZwEBNTA+6sEVCwngAMEffzuBDoAAwBs/+cEPwXJABEAGQAiAIayICMkERI5sCAQsADQsCAQsBjQALAARViwCS8bsQkfPlmwAEVYsAAvG7EADz5ZshMJABESOXywEy8YsmATAV2yQhMBXbJyEwFdtNAT4BMCXbIwEwFdsgATAXGwCRCyFwEKK1gh2Bv0WbATELIaAQorWCHYG/RZsAAQsiABCitYIdgb9FkwMQUmAjc0NzcSABcWEgcGBwcCAAEhNjUmJyYDASEGFxQWFxYTAei4xAIJHzEBHt+5wgEBCSI0/uf+tgHJFQWf2UsBn/43FQFUTtZOFAQBBetLR8wBQgFJBQT+/OdLR93+xf68A1GDUe8HCP6i/s2DS3mCAwwBZAAAAQBu//QCCgQ6AA0AKACwAEVYsAAvG7EAGz5ZsABFWLAJLxuxCQ8+WbIEAQorWCHYG/RZMDEBAxUWFzI3BwYnJiY3EwHrgwNLJy0QSkt8ew2DBDr89S1AAwm+FgICo4kDFv//ACEAAASNBDoCBgD7AAAAAf+o//AD1gX7ABoAUbIPGxwREjkAsAAvsABFWLALLxuxCw8+WbAARViwEC8bsRAPPlmwCxCyBgEKK1gh2Bv0WbIPABAREjmyEhAAERI5sAAQshYBCitYIdgb9FkwMQEWFxMWFhczNwcGIyYmJwMBIQEnJiYnJwc3NgGZuDDoCB4kEhENKipfch1p/pb+9AIxLgsqKxsbDj4F+QSl+8QfNgUBwwgCZmsCBP05BB3AKC0CAQG4D////93+YARUBDoCBgB4AAD//wBkAAAEDQQ6AgYAWgAAAAEAPv51BCYFxQAtAFayBS4vERI5ALAXL7AARViwKy8bsSsfPlmyAgEKK1gh2Bv0WbIHLisREjmwBy+yCgEKK1gh2Bv0WbIeFysREjmwHhCyEAEKK1gh2Bv0WbIlCgcREjkwMQEmIyIGBwYFFwcnIgYHBhYfAhYHBgYHJzc2NzYnJyYnJhM2NjcmJjc2JDMyFwPue1h8mAwbAQ+FI36s0xILYWCELqkIBXhsgC9CCQc/KqBC2hUKuKtUYAQIAR/bjIgE2iZbTq8CAcYBmY5dgxwlDzyQUqlNajFIPTIZDzMjcgEBjcs4KIlYrsYuAP//ADn/6AQnBFICBgBTAAAAAQBd//UE2gQ6ABYAXLINFxgREjkAsABFWLAVLxuxFRs+WbAARViwCy8bsQsPPlmwAEVYsBEvG7ERDz5ZsBUQsgABCitYIdgb9FmwCxCyBgEKK1gh2Bv0WbAAELAP0LAQ0LAT0LAU0DAxASMDBhcWFzI3BwYjJiY3EyEDIxMjNyEEuZtjAwIGSiYvEUVQfHsNYv7Am+2bpyIEWwN8/bQZFEEDCb4VAqOKAlj8hAN8vgAC/8v+YAQMBFMAEgAgAFCyDiEiERI5sA4QsBbQALAARViwBS8bsQUbPlmwAEVYsBEvG7ERET5ZsABFWLAOLxuxDg8+WbIVAQorWCHYG/RZsAUQsh0BCitYIdgb9FkwMRM2Njc2FxYWFxYHBwYGJyYnAyMBFhcWNjc2JyYmJyYGB3UQW0iQ0LDICQMHDSz3salhYe4BazSDdZ4VCwMIVU5rjhkCPm/JSZQFBOnHRUVT3/gFBHb9+wK/bwQDs591PXFsAwK/ogABADv+iQPwBFMAIABZsg0hIhESOQCwAEVYsAAvG7EAGz5ZsABFWLAaLxuxGg8+WbAARViwEy8bsRMXPlmwABCxAworWNgb3FmwABCyBwEKK1gh2Bv0WbAaELINAQorWCHYG/RZMDEBFhYHJzYmJyYGBwcGFxcWBwYGByc3Njc2JicmAjc3EgACc7TJCN4FVVRzoRYEHO5toAcDe2x5KUMJBCU6zb8TAh0BMQROBOG0AWRuBAPAoyPtVyc9j1GrTWssSj8hKBA+AQTEFAECATUAAgA4/+gEtgQ7ABEAIgBhshgjJBESObAYELAH0ACwAEVYsBAvG7EQGz5ZsABFWLARLxuxERs+WbAARViwCC8bsQgPPlmwERCyAAEKK1gh2Bv0WbAIELIXAQorWCHYG/RZsBAQsiABCitYIdgb9FkwMQEFFgcHDgInLgI3NzYAMwUBBhcWFhcWNjc3NicmJicmBgSS/v6DEQMQlu+Ki8RZEAIiATHeAjv8gAYCBGBXb50cBwYCBV5VeKADdgOrxxaR7YUEApD8lRD7ASEB/dE2PW58AgOspS80OmZ3AwO2AAABAG7/6wQjBDoAEQBJsgMSExESOQCwAEVYsBAvG7EQGz5ZsABFWLAKLxuxCg8+WbAQELIAAQorWCHYG/RZsAoQsgUBCitYIdgb9FmwABCwDtCwD9AwMQEhAwcUMxY3FwYnJiY3EyE3IQQB/qNlAj8hPRVSX3x6DmH+tyIDkwN5/a8oSgEVtCsCAquWAknBAAABAFf/5QP+BDwAFgA8shAXGBESOQCwAEVYsAovG7EKGz5ZsABFWLAALxuxABs+WbAARViwES8bsREPPlmyBQEKK1gh2Bv0WTAxAQMHBhYXFhIDJicXFgcGAgYnJiY3NxMBv20FAjs5lcMOBiHiOgsPm/iZqbgKA24EOv1rTExfAgYBdAEkgX0Bqdf7/sahBAPXwCYCkQACADL+IgVtBEQAGwAkAFmyGSUmERI5sBkQsBzQALAaL7AARViwEi8bsRIbPlmwAEVYsAcvG7EHGz5ZsABFWLAALxuxAA8+WbAZ0LIcAQorWCHYG/RZsA7QsBIQsiIBCitYIdgb9FkwMQUmJyY3NhI3FwYCFxYWFxM2NhceAgcGAAUDIwE2NicmJgcGBwH67nJoGRObhohxbgwKcWBxDqZ7h9FmDhr+r/7zV+0BXq3KAgNnVjYMDCOqnOCgAQlblmj+9H1jhhoChXWTAgKQ9Y30/tEa/jECkSTxq4GQBgQ2////uQAABBMEOgIGAFwAAAABAD/+IgWKBDwAHQBSsg4eHxESOQCwDy+wAEVYsAAvG7EAGz5ZsABFWLAILxuxCBs+WbAARViwFS8bsRUbPlmwAEVYsBEvG7ERDz5ZsA7QsgEBCitYIdgb9FmwHNAwMQEDNjYSJyYnFxYXEgcGBQMjEyYCNxMzAwYXFhYXEwOeo5K/RAwJI94rCh/vqf70V+1X4dkgUu1SCQMDZ1+iBDr8eiK3AQ6rfngCdn/+ROGfGf4yAdIiAUT3Aen+FEJAa44cA4MAAQBU/+QGEAQ9ACsAXrIjLC0REjkAsABFWLAALxuxABs+WbAARViwGy8bsRsbPlmwAEVYsCEvG7EhDz5ZsABFWLAmLxuxJg8+WbIHAQorWCHYG/RZsgwhABESObAhELISAQorWCHYG/RZMDEBBwYGBwYWFxY2NxMzAwYXFxYXFjY3NzYnJicXFhcWAgYnJiYnBicmJjcQEwIoUk9GAwNDPVt9EzX1NAkDAhByVnkcChEMDC3iNAwTcuakapgYhdOirALeBDmYleiDd3sDBqCZAUb+uksxG5gDBKmqQIKCgXwDeILd/lnVBAJ4ZeYHBOnXAV8BKwD//wBM//QC/gW4AiYBqQAAAQcAa/97/+sADACwAC+wH9ywDtAwMf//AFf/5QP+BcACJgG1AAABBgBrcvMADACwCi+wKNywF9AwMf//ADn/6AQnBkECJgBTAAABBwF3AQ0AAAAJALAEL7Aj3DAxAP//AFf/5QP+BjQCJgG1AAABBwF3AQL/8wAJALAKL7AZ3DAxAP//AFT/5AYQBjICJgG5AAABBwF3Ahj/8QAJALAaL7Au3DAxAAACAFD/5gSNBckAHgAoAGuyFCkqERI5sBQQsCDQALAARViwGS8bsRkfPlmwAEVYsAYvG7EGDz5ZsiEZBhESObAhL7ITAQorWCHYG/RZsALQsgwZBhESObAGELIQAQorWCHYG/RZsCEQsB3QsBkQsiUBCitYIdgb9FkwMQEGBwcGBCcuAjcTNwMGFhcWEzcmAjc2NhcWFgcDNwEGFxM3NCcmBgcEgjlLEyX+58h+vFsPL+cwDmRhyjQUt8sOE9yfmKESNHL98RK6OARUOUoLAlYTC3Xh/AYDedeAASMC/tp4jgMHASBvLAEVu7/RBATZrf7LGAEh4UwBODdwAgJUTQAAAQBtAAAFBgXJABgAVLIMGRoREjkAsABFWLAELxuxBB8+WbAARViwFi8bsRYfPlmwAEVYsAwvG7EMDz5ZsgAWDBESObAEELIIAQorWCHYG/RZsBYQshEBCitYIdgb9FkwMQEBNjYXFhcHJwYHAQMjEwMmJyYHJzYzFhcCRwETP4pXO1E1M0Es/mhZ9l6nFTgRJRE8QK8/AwkB53lgAgIZwwYDRf1d/fwCHwKJPgMBBcQYBMv///8kAAAFagZBACYBwGQAAAcBd/32AAAAAgBX/+MGfQQ6ABQAKgBmsgkrLBESObAJELAh0ACwAEVYsBMvG7ETGz5ZsABFWLAMLxuxDA8+WbATELIBAQorWCHYG/RZsAwQsAfQsgoTDBESObABELAX0LAS0LAMELIdAQorWCHYG/RZsiEMEhESObAn0DAxAScXBgIGBicmJicGJyYmNxI3BzchASYnJQYGBwYXFjY3NzMHBhcWFxYTNgZaeAMCPHixb2ucGIbamKEGBHhyIgX0/n4BB/zdSDwGC3Bbfhgk9CIIAwqBkzYbA4MBpIr+29xtAwJ4aesHBOvdAQDQArb+plFSAonXfPYGB5ad6eNJNbIDBAEpl///ACcAAAS6Bz0CJgApAAABBwBEASMBPQATALAARViwBi8bsQYfPlmwDdwwMQD//wAnAAAEugcKAiYAKQAAAQcAawDwAT0ADACwBi+wHdywDNAwMQABAJH/8QWFBbAAGQBusgEaGxESOQCwAEVYsBgvG7EYHz5ZsABFWLAKLxuxCg8+WbAARViwFC8bsRQPPlmwGBCyAAEKK1gh2Bv0WbIEGBQREjmwBC+wChCyCwEKK1gh2Bv0WbAEELIRAQorWCHYG/RZsAAQsBbQsBfQMDEBIQM2FxYWBwYEBzc2Njc2JicmBwMjEyE3IQTf/iJNjW/f9hES/sj+E4ujDw1yeW6SdvfZ/ockBE4E5P5zJwIC88rZ8QK/BIl6boEEAyD9cwTkzAD//wAuAAAErAc9AiYBhAAAAQcAdwG5AT0AEwCwAEVYsAQvG7EEHz5ZsAjcMDEAAAEAZ//oBREFxwAgAIWyFCEiERI5ALAARViwDC8bsQwfPlmwAEVYsAMvG7EDDz5ZsgAMAxESObIQAwwREjmwDBCyEwEKK1gh2Bv0WbIWDAMREjl8sBYvGLJgFgFdsnIWAV2yQhYBXbIwFgFdtNAW4BYCXbIAFgFxshkBCitYIdgb9FmwAxCyHQEKK1gh2Bv0WTAxAQYAJy4CJyYSEiQXFhIXIyYmJyYGByUHIQcGFhcWNjcEqSH+r/CL0XcHBkTCARyp2PwL9QV7dpbUPQH0JP4ZCQZ+fIu2JAHb4/7wBAN+75pxAYkBOZ4DBP74656LAwXT6wHKYqS5BAaXkwAAAQAk/+oEuwXHACkAYbIDKisREjkAsABFWLAKLxuxCh8+WbAARViwHy8bsR8PPlmyAx8KERI5sAoQsA7QsAoQshIBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WbAfELAk0LAfELInAQorWCHYG/RZMDEBNicnJiY3PgIXHgIHJzYmJyYGBwYXFxYWBw4CJy4CNxcGFhcWNgNMFrNR4r4JCJn6jYjUcAT2B3N0daEOFL5L5bYLCo77l4/pfAX3CIqBeKEBfpBGHk/Yj3y9ZgMDccmBAXJ+AwJyYX9JG1Ldl3u3ZAIBdtGFAXyGAgJqAP//ADUAAAIoBbACBgAtAAD//wA1AAADLAcKAiYALQAAAQcAa/+pAT0ADACwAi+wFdywBNAwMf//AAP/5wRhBbACBgAuAAAAAv/KAAAH9QWwABkAIgB5sgojJBESObAKELAb0ACwAEVYsBgvG7EYHz5ZsABFWLAILxuxCA8+WbAARViwEC8bsRAPPlmyARgIERI5sAEvsBgQsgoBCitYIdgb9FmwEBCyEgEKK1gh2Bv0WbAIELIcAQorWCHYG/RZsAEQsiIBCitYIdgb9FkwMQEFHgIHBgAjIRMhAwcCAgcjNzc2Njc3EyEDAwU2Njc2JicFIAERitRmCxH+xfT939n+UnEeQ/vCWxYkf6IpE4oDkX9bARJ/sBIPcWkDoQEEdsyC0/77BOT99ZL+z/7vBcoBCd/3bwKX/Sb99AIClH1uiAQAAgAuAAAH/QWwABIAGwCCsgEcHRESObABELAU0ACwAEVYsAIvG7ECHz5ZsABFWLARLxuxER8+WbAARViwCy8bsQsPPlmwAEVYsA8vG7EPDz5ZsgECCxESObABL7IFAgsREjmwBS+wARCyDQEKK1gh2Bv0WbALELIVAQorWCHYG/RZsAUQshsBCitYIdgb9FkwMQEhEzMDFxYWBwYEIyETIQMjEzMBAwU2Njc2JicBtQJrbPZh/OL+DxD+xvT93279lW72/PYC3lUBEoGuDw5xawNFAmv90gEB8cPO/gJ6/YYFsP0I/hgCAoxzaHwEAAEAoAAABZgFsAAWAF2yARcYERI5ALAARViwFS8bsRUfPlmwAEVYsAgvG7EIDz5ZsABFWLARLxuxEQ8+WbAVELIAAQorWCHYG/RZsgQVCBESObAEL7IOAQorWCHYG/RZsAAQsBPQsBTQMDEBIQM2FxYWBwMjEzYnJicmBwMjEyE3IQTh/iBGgobq6xhL90wIBxW+ZK999tn+lSQEQQTk/pocAgT11/44AclAMI4GAxz9TATkzAD//wAnAAAFcQc2AiYALwAAAQcAdwGlATYAEwCwAEVYsAUvG7EFHz5ZsA/cMDEA//8AJwAABXwHPQImAdsAAAEHAEQBggE9ABMAsABFWLAILxuxCB8+WbAL3DAxAP//AJv/5wVTByQCJgHmAAABBwFqARUBPQAJALABL7AU3DAxAAABACX+mAV8BbAACwBIALAJL7AARViwAC8bsQAfPlmwAEVYsAQvG7EEHz5ZsABFWLAGLxuxBg8+WbAARViwCi8bsQoPPlmyAgEKK1gh2Bv0WbAD0DAxATMDIRMzAyEDIxMhASL32gJs2vf9/lk/9z/+RAWw+xoE5vpQ/pgBaP///6QAAASuBbACBgAlAAAAAgAjAAAEoQWwAAwAFQBesg8WFxESObAPELAJ0ACwAEVYsAsvG7ELHz5ZsABFWLAJLxuxCQ8+WbALELIAAQorWCHYG/RZsgMLCRESObADL7AJELIPAQorWCHYG/RZsAMQshUBCitYIdgb9FkwMQEhAxcWFgcGBCMhEyEBAwU2Njc2JicEff12Pf7j/REQ/sf0/d38A4L88lYBEoGuDw5wawTk/p8BAe/E0P4FsP0I/hICApB3aXkE//8AJwAABLwFsAIGACYAAP//AC4AAASsBbACBgGEAAAAAv+E/poFkQWwAA4AFQBVshIWFxESObASELAL0ACwAS+wAEVYsAsvG7ELHz5ZsABFWLACLxuxAg8+WbABELAE0LACELINAQorWCHYG/RZsBDQsAbQsAsQshEBCitYIdgb9FkwMQEjEyEDIxMXNhITEyEDMwUlEyEDBwIE/us+/GA/7ltlc543iAN92bT79gJft/5mbhFV/poBZv6aAjADUwEzAQ4CVfsaBAQEGv4aQv68//8AJwAABLoFsAIGACkAAAAB/6UAAAfgBbAAFQB9ALAARViwCS8bsQkfPlmwAEVYsA0vG7ENHz5ZsABFWLARLxuxER8+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsABFWLAULxuxFA8+WbIQCQIREjmwEC+yAAEKK1gh2Bv0WbAE0LIIEAAREjmwEBCwC9CyEwAQERI5MDEBIwMjEyMBIQEBIRMzEzMDMwEhAQEhBOSjbvZunf45/r4CWP7SARvpnWr2aooBtwE5/dsBN/7dAnT9jAJ0/YwDEwKd/aACYP2gAmD9Tf0DAAEAHv/tBKgFxQApAIGyByorERI5ALAARViwDi8bsQ4fPlmwAEVYsBovG7EaDz5ZsgAOGhESObAAL7IfAAFxsp8AAV2yegABXbJKAAFdsA4QsgYBCitYIdgb9FmyCg4aERI5sAAQsicBCitYIdgb9FmyEycAERI5sh0OGhESObAaELIhAQorWCHYG/RZMDEBMjY3NiYnJgYHBz4CFxYWBwYFFhYHBgQHByYkNxcGFhcWNjc2LwI3And+oQwMfW1nohH1CY74jOD4DhH+/WNcBwz+2eU10v7/B/MEgmZ+wQ4b0SS1IwNJeGpecAICcGEBd7ppAgXYuc94Lqxsu+sMAQLnvwFkeQIEgW7FGQMByAAAAQAnAAAFfAWwAAkARQCwAEVYsAAvG7EAHz5ZsABFWLAHLxuxBx8+WbAARViwAi8bsQIPPlmwAEVYsAUvG7EFDz5ZsgQAAhESObIJAAIREjkwMQEzAyMTASMTMwMEff/997L86/7997IFsPpQA/78AgWw/AEA//8AJwAABXwHJAImAdsAAAEHAWoBVwE9AAkAsAAvsA3cMDEA//8ALgAABXsFsAIGA8EAAAAB/8oAAAV8BbAAEQBNsgQSExESOQCwAEVYsAAvG7EAHz5ZsABFWLABLxuxAQ8+WbAARViwCS8bsQkPPlmwABCyAwEKK1gh2Bv0WbAJELIMAQorWCHYG/RZMDEBAyMTIQMHAgIHIzc3NjY3NxMFfP322f5ScR5E/MNYFiJ+oSoWigWw+lAE5P31kv7L/vACygIH1PCCApcA//8AJwAABs4FsAIGADEAAP//ACcAAAWHBbACBgAsAAD//wBr/+cFIQXIAgYAMwAA//8ALgAABYMFsAIGAZEAAP//ACcAAAUEBbACBgA0AAD//wBl/+gFDQXHAgYAJwAA//8AnAAABSIFsAIGADgAAAABAJv/5wVTBbAAEABDsgAREhESOQCwAEVYsAEvG7EBHz5ZsABFWLAPLxuxDx8+WbAARViwBi8bsQYPPlmyAAEGERI5sgsBCitYIdgb9FkwMQEBIQEGBiciJzcWNzI3NwEhApcBnwEd/U1Uwn8vQRc0H25DRP7XAQICuAL4+1WbgwIHyAcBbHwEFgADAFb/xAYSBewAFwAfACkAXrIVKisREjmwFRCwHdCwFRCwIdAAsAovsBcvsgAXChESObAAL7IMChcREjmwDC+wCdCwABCwFNCwDBCyGwEKK1gh2Bv0WbAUELIdAQorWCHYG/RZsCDQsBsQsCHQMDEBMhYSBwYCBCcnByM3IiYCNzYSJBcXNzMBBhYXFxMiBiUDMjY3NicmJicEDKLwdBARvf7XqxQo7Sik73YQErsBKqwWKub9IBSQlRWTuugCkJG06BgKChCFawUkmv7xoaz+6ZgDAb/AlgENoa0BGJsCAcf83KzIBwEDEd7d/O/ZtkxFan0IAP///8MAAAVHBbACBgA8AAAAAQAl/qEFfAWwAAsAOwCwCS+wAEVYsAAvG7EAHz5ZsABFWLAELxuxBB8+WbAARViwCi8bsQoPPlmyAgEKK1gh2Bv0WbAG0DAxATMDIRMzAzMDIxMhASL32gJs2vfZq3TjPfvxBbD7GgTm+xz91QFfAAEAxQAABWoFsAAQAEayBRESERI5ALAARViwAC8bsQAfPlmwAEVYsAkvG7EJHz5ZsABFWLABLxuxAQ8+WbINAQkREjmwDS+yBQEKK1gh2Bv0WTAxAQMjEwYnJiY3EzMDBhYENxMFav32a5qt5vAZTPZMEGABBs58BbD6UAI+LAQC89wByf42gIIGKgKoAAABACsAAAdjBbAACwBIALAARViwAC8bsQAfPlmwAEVYsAMvG7EDHz5ZsABFWLAHLxuxBx8+WbAARViwCS8bsQkPPlmyAQEKK1gh2Bv0WbAF0LAG0DAxAQMhEzMDIRMzAyETAh/ZAa3Z99oBqtr2/fnF/AWw+xoE5vsaBOb6UAWwAAEAK/6iB2MFsAAPAFQAsAsvsABFWLAALxuxAB8+WbAARViwAy8bsQMfPlmwAEVYsAcvG7EHHz5ZsABFWLANLxuxDQ8+WbIBAQorWCHYG/RZsAXQsAbQsAnQsArQsALQMDEBAyETMwMhEzMDMwMjEyETAh/ZAa3Z99oBqtr226Vy2T36DPwFsPsaBOb7GgTm+xL94AFeBbAAAgCJAAAFnQWwAAwAFQBesgEWFxESObABELAN0ACwAEVYsAAvG7EAHz5ZsABFWLAJLxuxCQ8+WbIDAAkREjmwAy+wABCyCwEKK1gh2Bv0WbAJELIPAQorWCHYG/RZsAMQshUBCitYIdgb9FkwMRMhAxcWFgcGBCMhEyEBAwUyNjc2JierAnVg/eH/DxD+x/b939v+gAIUVgESgK8PDW1tBbD90wEB7MbR/gTt/cv+EgGRd2d7BAADAC4AAAa9BbAACgATABcAcLIGGBkREjmwBhCwD9CwBhCwFdAAsABFWLAJLxuxCR8+WbAARViwFi8bsRYfPlmwAEVYsAcvG7EHDz5ZsABFWLAULxuxFA8+WbIBCQcREjmwAS+wBxCyDQEKK1gh2Bv0WbABELITAQorWCHYG/RZMDEBFxYWBwYEIyETMwMDBTY2NzYmJwEjEzMBwf7j/REQ/sf0/d3994RWARKBrg8OcGsC9fb99gODAQHvxND+BbD9CP4SAgKQd2l5BP1JBbAAAgAjAAAElAWwAAoAEwBQsg0UFRESObANELAH0ACwAEVYsAkvG7EJHz5ZsABFWLAHLxuxBw8+WbIBCQcREjmwAS+wBxCyDQEKK1gh2Bv0WbABELITAQorWCHYG/RZMDEBFxYWBwYEIyETMwMDBTY2NzYmJwG2/uP9ERD+x/T93f33hFYBEoGuDw5wawODAQHvxND+BbD9CP4SAgKQd2l5BAAAAQBP/+kE9wXIACAAhbIOISIREjkAsABFWLAULxuxFB8+WbAARViwHS8bsR0PPlmyAwEKK1gh2Bv0WbIIFB0REjl8sAgvGLIwCAFdsnIIAV2y4ggBXbJCCAFdsmAIAV2y0AgBXbIACAFxsgcBCitYIdgb9FmwFBCyDQEKK1gh2Bv0WbIRFB0REjmyIB0UERI5MDEBFhYXFjY3BTchNzYmJyYGBwc2ABceAhcWAgIEJyYAJwFDB358lM46/gUkAe4IA4N+irAj9SgBS+uO1HkJBke9/uyn3v79CAHam4gDBdbsAcxkn7YEBJqUAeYBFAQDfvGYeP5z/tGdAwQBBeUAAAIAMv/nBvkFxwAYACgAg7INKSoREjmwDRCwJNAAsABFWLAILxuxCB8+WbAARViwEC8bsRAfPlmwAEVYsAYvG7EGDz5ZsABFWLAALxuxAA8+WbIKCAYREjl8sAovGLIfCgFxtGAKcAoCXbIEAQorWCHYG/RZsBAQsh4BCitYIdgb9FmwABCyJQEKK1gh2Bv0WTAxBSYAETcjAyMTMwMzNhI3NhcWABcWAgIHBhM3NiYmJyYGAgcGFhcWEjcEL+P+/AG4afb99nKsJ++ub3zYAQEMBjmLZ7LaCQYyd1t+w3kKCoSEreEjFAUBPAEJJ/2jBbD9ceIBVEQsAwT+3vd8/r/+81qcAxhqbblhAwSW/s7nt9IEBQEO9QAC/7AAAATTBbEADgAXAGGyEhgZERI5sBIQsAvQALAARViwDS8bsQ0fPlmwAEVYsAAvG7EADz5ZsABFWLADLxuxAw8+WbITDQAREjmwEy+yAQEKK1gh2Bv0WbIFEwEREjmwDRCyFAEKK1gh2Bv0WTAxIRMhASEBJiY3PgIzBQMBBhYXFxMnIgYC31/+9/6Q/usBsWdYCguX/p4B6f39yg9rc/FZ14atAiD94AJvQcV3jc1rAfpQA+FxhwQBAgACi///ACL/6APcBFACBgBFAAAAAgBD/+YEYQYTABsAKwBishgsLRESObAYELAd0ACwAEVYsBMvG7ETIT5ZsABFWLAGLxuxBg8+WbIAEwYREjmwAC+yFwATERI5shETFxESObIaAAYREjmyHAEKK1gh2Bv0WbAGELIlAQorWCHYG/RZMDEBFhIHBgAnLgI3NzU3EgA3NzY3Mw4CBAYHNhcmBgYHBhcWFhcWNjc3NiYCnrrPEhb+0eCLx1sQAgoxASPnXpMVwQhSmv7Xv0GegE99TQsHBAdiWHWgFQINZwP+BP7s1/f+zgQEjvmWFQNLAVABjjISHWZkgFM5pJeYxAJNjFtKOmRzAwOwoBWLoAAAAwAiAAAEFgQ6AA4AFwAfAI6yGSAhERI5sBkQsA7QsBkQsBHQALAARViwAS8bsQEbPlmwAEVYsAAvG7EADz5ZshgAARESObAYL7KMGAFdtF8YbxgCcbTvGP8YAnG0vxjPGAJdtBwYLBgCcbJaGAFdsg8HCitYIdgb9FmyCA8YERI5sAAQshABCitYIdgb9FmwARCyHwEKK1gh2Bv0WTAxMxMFFhcWBwYHFhYHBgYHAwMXNjY3NiYnJxcyNzYmJycivAGelGKkCQrQVGECBenMzC/0YW8JCkdS8rbUFglNZMsEOgEEK0mqoFEZelaUpgMBzf7zAQNKQTlDA68Bgjo/AwEAAQAYAAADiQQ6AAUAKwCwAEVYsAQvG7EEGz5ZsABFWLACLxuxAg8+WbAEELIAAQorWCHYG/RZMDEBIQMjEyEDZv45mu28ArUDdvyKBDoAAv+F/r4EZAQ6AA4AFABbshIVFhESObASELAE0ACwDC+wAEVYsAQvG7EEGz5ZsABFWLAKLxuxCg8+WbIAAQorWCHYG/RZsAbQsAfQsAwQsAnQsAcQsA/QsBDQsAQQshEBCitYIdgb9FkwMTc2NjcTIQMzAyMTIQMjEwUlEyEDAjFqgR9OAtuakVrsOP1hOPFbAWgBlXb++TY/v2HvqgGB/Ij9/AFC/r4CAwMEAqf+9f70//8AO//qBAIEUQIGAEkAAAAB/60AAAZyBDoAFQCCALAARViwCS8bsQkbPlmwAEVYsA0vG7ENGz5ZsABFWLARLxuxERs+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsABFWLAULxuxFA8+WbIQEQIREjmwEC+yjxABXbIAAQorWCHYG/RZsATQsggQABESObAQELAL0LITABAREjkwMQEjAyMTIwEhAQMhEzMTMwMzASEBEyED/4NM7Uxz/sL+zwHI6wETpHRK7UpnATkBMP5T+P7oAbP+TQGz/k0CPwH7/lcBqf5XAan98P3WAAABABb/6QO8BFAAKQCjshkqKxESOQCwAEVYsCYvG7EmGz5ZsABFWLAKLxuxCg8+WbIZJgoREjmwGS+07xn/GQJxtB8ZLxkCcbK/GQFxtF8ZbxkCcbS/Gc8ZAl2yjBkBXbJaGQFdshYHCitYIdgb9FmyAxYZERI5sAoQshEBCitYIdgb9FmyDhYRERI5tAMOEw4CXbAmELIfAQorWCHYG/RZsiIZHxESObQMIhwiAl0wMQEGBgcWFgcOAicmJjczBhYzMjY3NicnNxc2Njc2JiMmBgcHNjYXHgIDtgVeZkhFBAV8132w2wTpAmJQV3kLFaW4H5xVZwkHT0RLcw/tDPm4c7BcAxpKdjMhfU9pl1EDAr2XRVZVSIcFAa8BAklEP0cCTUEBlLUCAkqJAAABABkAAARIBDoACQBFALAARViwAC8bsQAbPlmwAEVYsAcvG7EHGz5ZsABFWLACLxuxAg8+WbAARViwBS8bsQUPPlmyBAcCERI5sgkHAhESOTAxATMDIxMBIxMzAwNU9LztfP3y9LztfAQ6+8YCwv0+BDr9PgD//wAZAAAESAXaAiYB+wAAAQcBagCc//MACQCwAC+wDdwwMQAAAQAiAAAEgQQ6AAwAaACwAEVYsAQvG7EEGz5ZsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmwAEVYsAsvG7ELDz5ZsgYCBBESOXywBi8YtNMG4wYCXbRDBlMGAl2yEwYBcbIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBIQEBIQHYfkvtvO1LXgFtATb+HwE0/t0BrP5UBDr+UAGw/e792AAB/7///wRJBDoAEABNsgQREhESOQCwAEVYsAAvG7EAGz5ZsABFWLABLxuxAQ8+WbAARViwCC8bsQgPPlmwABCyAwEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDEBAyMTIQMGBicjNzc2Njc3EwRJu+6a/tpjNcyfUhYkW3MfD2AEOvvGA3b+PObNAckDCJevUgHOAAEAIgAABZoEOgAMAFkAsABFWLABLxuxARs+WbAARViwCy8bsQsbPlmwAEVYsAMvG7EDDz5ZsABFWLAGLxuxBg8+WbAARViwCS8bsQkPPlmyAAsDERI5sgULAxESObIICwMREjkwMQEBIQMjEwEjAwMjEyECrwG9AS687Xr+bKKmgO28ASUBLQMN+8YCuv1GAtr9JgQ6AAEAGQAABEcEOgALAH4AsABFWLAGLxuxBhs+WbAARViwCi8bsQobPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIJCgAREjmwCS+0vwnPCQJdsr8JAXG0Lwk/CQJysl8JAXK07wn/CQJxtB8JLwkCcbKPCQFdtI8JnwkCcrICAQorWCHYG/RZMDEhIxMhAyMTMwMhEzMDi+5M/mpM7rzuTwGXTu4Btf5LBDr+PQHDAP//ADn/6AQnBFICBgBTAAAAAQAZAAAESAQ6AAcAOACwAEVYsAYvG7EGGz5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmwBhCyAgEKK1gh2Bv0WTAxISMTIQMjEyEDjO6a/mma7rwDcwN2/IoEOgD////H/mAEDQRSAgYAVAAAAAEAOP/pA+4EUgAcAEuyAB0eERI5ALAARViwES8bsREbPlmwAEVYsAgvG7EIDz5ZsgABCitYIdgb9FmyBBEIERI5shUIERESObARELIYAQorWCHYG/RZMDElFjY3Nw4CJy4CNzc+AhcWFhUjNCYnJgYHAgHoVYMS4AuF0HGLxFoPAxGV7JCw0t5bVougBgetAmdTAWuwYgMCjPeYI53/igQE4bRddgQE9N7+8wABAFMAAAQIBDoABwAxALAARViwBi8bsQYbPlmwAEVYsAIvG7ECDz5ZsAYQsgABCitYIdgb9FmwBNCwBdAwMQEhAyMTITchA+b+rJvtmv6vIgOTA3n8hwN5wf///7X+RQQSBDoCBgBdAAAAAwA9/mAFUQYAACEALAA4AHyyEzk6ERI5sBMQsCnQsBMQsDTQALADL7AARViwAC8bsQAbPlmwAEVYsAcvG7EHGz5ZsABFWLAULxuxFBE+WbAARViwGC8bsRgPPlmwAEVYsBEvG7ERDz5ZsAAQsjYBCitYIdgb9FmwJtCwGBCyMQEKK1gh2Bv0WbAr0DAxARYXEzMDNhcWFgcGBwcOAicmJwMjEwYjIiYnJjc3NhI2ATYnJicmBwMWMzIBBhcWFxY3EyYjJgMCGERFWO1aRkiYnwEBBgUXhLxxT0hS7VI+RpKhAwEGBhqBvwK5CQEFkCMxgycm5v0ECQMKiBg3hCQh1zsEUAIdAc/+LSECAvHRQDgko/ByAwEg/lUBpxnZuDw3K7QBBH79wls52QcCDP03CwFHVzC0BwEIAswLBP6ZAP///7kAAAQTBDoCBgBcAAAAAQAZ/r8ESAQ6AAsAOwCwCC+wAEVYsAAvG7EAGz5ZsABFWLAELxuxBBs+WbAARViwCi8bsQoPPlmyAgEKK1gh2Bv0WbAG0DAxEzMDIRMzAzMDIxMh1e6bAZia7puQbdk4/OoEOvyIA3j8iP39AUEAAAEAcAAABCAEOwASAEiyDhMUERI5ALAARViwCC8bsQgbPlmwAEVYsBEvG7ERGz5ZsABFWLAALxuxAA8+WbIOEQAREjl8sA4vGLIEAQorWCHYG/RZMDEhIxMGIyYmNxMzAwYXFhcWNxMzA2TtRlthws8TNe42BgUMklNyYe0BaxYC3LwBTP6zMCZ5BgMXAg0AAAEAGQAABioEOgALAEgAsABFWLAALxuxABs+WbAARViwAy8bsQMbPlmwAEVYsAcvG7EHGz5ZsABFWLAJLxuxCQ8+WbIBAQorWCHYG/RZsAXQsAbQMDEBAyETMwMhEzMDIRMBw5sBRpvtmgFHmu28+qu8BDr8iAN4/IgDePvGBDoAAQAS/r8GPAQ6AA8ASwCwDC+wAEVYsAAvG7EAGz5ZsABFWLADLxuxAxs+WbAARViwBy8bsQcbPlmwAEVYsA0vG7ENDz5ZsgEBCitYIdgb9FmwBdCwCdAwMQEDIRMzAyETMwMzAyMTIRMBu5sBR5rtmgFHm+yatG3ZOfrjuwQ6/IgDePyIA3j8iP39AUEEOgAAAgBPAAAEpgQ6AAwAFQBesgwWFxESObAMELAN0ACwAEVYsAsvG7ELGz5ZsABFWLAHLxuxBw8+WbIBCwcREjmwAS+wCxCyCQEKK1gh2Bv0WbAHELIPAQorWCHYG/RZsAEQshUBCitYIdgb9FkwMQEXFhYHBgQjIRMhNyEDAxc2Njc2JicCUdawzwkL/vzL/iGa/tEiAhxdPdhcfA0LTEwC4gEEwqGp0QN2xP3l/qMBAl5TTVkEAAADACIAAAXxBDoACgATABcAbbICGBkREjmwAhCwEdCwAhCwFdAAsABFWLAJLxuxCRs+WbAARViwFi8bsRYbPlmwAEVYsAcvG7EHDz5ZsABFWLAULxuxFA8+WbIBBwkREjmwAS+yCwEKK1gh2Bv0WbAHELINAQorWCHYG/RZMDEBFxYWBwYEIyETMwMDFzY2NzYmJwEjEzMBj9awzwkL/vzL/iG87V092Fx8DQtNSwLU7bztAuIBBMKhqdEEOv3l/qMBAl5TTVkE/eIEOgACACIAAAPkBDoACgATAE2yDRQVERI5sA0QsAfQALAARViwCS8bsQkbPlmwAEVYsAcvG7EHDz5ZsgEHCRESObABL7ILAQorWCHYG/RZsAcQsg0BCitYIdgb9FkwMQEXFhYHBgQjIRMzAwMXNjY3NiYnAY/WsM8JC/78y/4hvO1dPdhcfA0LTUsC4gEEwqGp0QQ6/eX+owECXlNNWQQAAAEAI//oA9QEUAAfAHSyACAhERI5ALAARViwCC8bsQgbPlmwAEVYsBEvG7ERDz5ZsAgQsgABCitYIdgb9FmyHAgRERI5fLAcLxiyUxwBXbJAHAFdsgMcABESObIbBworWCHYG/RZsBEQshgBCitYIdgb9FmyFRsYERI5slMVAV0wMQEmBgcHPgIXHgIHBwYCBicmJjcXBhYXFhMFNyE2JgIsVH0Q3wmDznKIvVcPAxKW7o6r0AbfBVdRx1z+rh4BQwhdA4wCaVEBbLBhAQSM+JYbn/7+jQQE4LMBW3YEBgEqAah+kwAAAgAk/+kGEARTABcAJwCLsiYoKRESObAmELAP0ACwAEVYsBYvG7EWGz5ZsABFWLAELxuxBBs+WbAARViwFC8bsRQPPlmwAEVYsA4vG7EODz5ZsgAWFBESObAAL7QfAC8AAnGyvwABcbKPAAFdsl8AAXKyEwEKK1gh2Bv0WbAOELIdAQorWCHYG/RZsAQQsiQBCitYIdgb9FkwMQEzNiQXHgIHBwYCBwYnLgI3BwMjEzMBBhcWFhcWNjc3NCYnJgYHAYG7RwEhwIvEXRACFrSNZHp+xWMIy0/tvO0BTQYDA2Jad6oZB2FgeacZAofb8QQEjP2YFq7+7z8tAwN914IB/jwEOv3RNzxpgAMFwaxhhI8EA8GvAAAC/7YAAAQWBDsADQAWAGGyFBcYERI5sBQQsATQALAARViwAC8bsQAbPlmwAEVYsAEvG7EBDz5ZsABFWLAFLxuxBQ8+WbISAAEREjmwEi+yAwEKK1gh2Bv0WbIHAxIREjmwABCyEwEKK1gh2Bv0WTAxAQMjEyMBIQEmJjc2JDMDBhYXFxMnBgYEFrzsRdP+2v78AU5QTQUKAQjF6wtORPM2y1x/BDr7xgGN/nMBui2WW6HC/pdATgIBATgBAl///wA7/+oEAgYAAiYASQAAAQcARACcAAAAEwCwAEVYsAkvG7EJGz5ZsCHcMDEA//8AO//qBAIFzQImAEkAAAEGAGtpAAAMALAJL7Ax3LAg0DAxAAEADf5HA/kGAAAjAIWyAyQlERI5ALAhL7AARViwBC8bsQQbPlmwAEVYsAsvG7ELET5ZsABFWLAaLxuxGg8+WbafIa8hvyEDXbIvIQFdsg8hAV2yIxohERI5sCMvsB/QshwHCitYIdgb9FmwAdCyAhoEERI5sAsQshABCitYIdgb9FmwBBCyFwEKK1gh2Bv0WTAxASEHNhcWFgcDBgYjJic3FjMyNxM2JyYnJgcDIxMjNzM3MwchAsz+/jOHq5mXE3oYyaVDQh81K38gfAUEDYOFZoftz5kemR3uHgEEBK3qjgQC08D9CbXFAhDBEMIC7yslegMChPz6BK2rqKj//wAYAAADmAXzAiYB9gAAAQcAdwDG//MAEwCwAEVYsAQvG7EEGz5ZsAjcMDEAAAEAO//oA/YEVAAfAGKyGCAhERI5ALAARViwEC8bsRAbPlmwAEVYsAgvG7EIDz5ZsgABCitYIdgb9FmyGhAIERI5fLAaLxiyHAcKK1gh2Bv0WbIDABwREjmwEBCyFwEKK1gh2Bv0WbIUGhcREjkwMSUWNjc3DgInLgI3NxIAFxYWByM0JicmBgclByEGFgHlVoMU3wuE1XGMv1YQAh0BMN6wzgLdXFNoky0BWB7+tw1frQJnUwFrr2QDBIr3mBQBAgE2BgThtGFyBAOMmgGogJMA//8AHP/pA8QEUAIGAFcAAP//AB8AAAIJBdgCBgBNAAD//wAiAAAC4QXGAiYA9AAAAQcAa/9e//kADACwAi+wFdywBNAwMf///wz+RgH+BdgCBgBOAAAAAv+9AAAGRgQ6ABcAHwB5sgogIRESObAKELAZ0ACwAEVYsAAvG7EAGz5ZsABFWLAILxuxCA8+WbAARViwDy8bsQ8PPlmyAgAIERI5sAIvsAAQsgoBCitYIdgb9FmwDxCyEQEKK1gh2Bv0WbAIELIaAQorWCHYG/RZsAIQsh8BCitYIdgb9FkwMQEDFxYWBwYEIyETIQMCBgcjNzc2Njc3EwEDFzY2NzYnBDBB1rLPCQv/AMz+IZr+8Us3yaZkFSVcbx4SYAJ7N9hZfQ0SowQ6/ocBBbeZpcYDdv6r/tXxBckDCJadZQHO/cX+wQECXE+ICgACABkAAAZcBDoAEgAbAIKyARwdERI5sAEQsBPQALAARViwAi8bsQIbPlmwAEVYsBEvG7ERGz5ZsABFWLALLxuxCw8+WbAARViwDy8bsQ8PPlmyARELERI5sAEvsgQRCxESObAEL7ABELINAQorWCHYG/RZsAQQshMBCitYIdgb9FmwCxCyFAEKK1gh2Bv0WTAxASETMwMXFhYHBgQjIRMhAyMTMwEDFzY2NzYmJwF7AZdH7kLWss8JCf7/zf4hU/5qU+687gIhONhdewsKSlECnwGb/ocBBbeZpMcB3f4jBDr9xf7BAQJfTEBNBQAAAQANAAAD+QYAABoAc7IDGxwREjkAsBgvsABFWLAELxuxBBs+WbAARViwES8bsREPPlmwAEVYsAkvG7EJDz5Zsr8YAV2yLxgBXbIPGAFdshoRGBESObAaL7AW0LITBworWCHYG/RZsAHQsgIEERESObAEELIOAQorWCHYG/RZMDEBIQc2FxYWBwMjEzYnJicmBwMjEyM3MzczByEC4f7kLoesmpUTdO12BQMNg4Roh+3Qhx6HHO4fARkEtfKOBALWvf1IArsrJXoDAoT8+gS1qqGhAP//ACIAAASBBfICJgH9AAABBwB3AUT/8gATALAARViwBC8bsQQbPlmwD9wwMQD//wAZAAAESAXzAiYB+wAAAQcARADH//MAEwCwAEVYsAgvG7EIGz5ZsAvcMDEA////tf5FBBIF5wImAF0AAAEGAWpUAAAJALABL7AT3DAxAAABABn+mgRIBDoACwBFALAIL7AARViwAC8bsQAbPlmwAEVYsAMvG7EDGz5ZsABFWLAFLxuxBQ8+WbAARViwCS8bsQkPPlmyAQEKK1gh2Bv0WTAxAQMhEzMDIQMjEyETAcObAZia7rz+vz7uP/67vAQ6/IgDePvG/poBZgQ6AAABAGD/5gcuBbAAIwBgsgYkJRESOQCwAEVYsAAvG7EAHz5ZsABFWLANLxuxDR8+WbAARViwGC8bsRgfPlmwAEVYsAQvG7EEDz5ZsABFWLAJLxuxCQ8+WbIHAAQREjmyFAEKK1gh2Bv0WbAf0DAxAQMGBCcmJicGJyYmNxMzAwYXFhYXFjY3EzMDBhcWFhcWNjcTBy6vHf7vzmygJY7au88VrvevBQMFS0NkiRSv+68FBQdQRV+BFa8FsPv90PcEAldMqQQE+sQEBPv7KitIVwMEg3gEBfv7LStLUQMDf3sEBQAAAQBE/+YGHgQ6ACIAXLIXIyQREjkAsABFWLAALxuxABs+WbAARViwDS8bsQ0bPlmwAEVYsBcvG7EXGz5ZsABFWLAJLxuxCQ8+WbAE0LAEL7IHFwkREjmwCRCyEwEKK1gh2Bv0WbAe0DAxAQMGBicmJicGJyYmNxMzAwcUFhcWNjcTMwMGFxYWFxY2NxMGHnMc8rdbjiKCuqmyE3PtcgQ4OFN0E3PucgQCAkI7T2gQcwQ6/VLE4gQCSkKRBATmtgKv/VBHQ1EDBXNwArD9UCYmQ04BA3ZrArAAAgAjAAAElAWwABIAGwB0shUcHRESObAVELAJ0ACwAEVYsA8vG7EPHz5ZsABFWLAJLxuxCQ8+WbISCQ8REjmwEi+yAAcKK1gh2Bv0WbIDDwkREjmwAy+wABCwC9CwDNCwEhCwDdCwCRCyFQEKK1gh2Bv0WbADELIbAQorWCHYG/RZMDEBIwcXFhYHBgQjIRMjNzM3MwczAQMFNjY3NiYnArHZIv7j/REQ/sf0/d2+ux67Ifci2v7EVgESga4PDnBrBEfEAQHvxND+BEeqv7/9x/4SAgKQd2l5BAACACH//APpBhgAEgAbAHGyFRwdERI5sBUQsAPQALAARViwDy8bsQ8hPlmwAEVYsAkvG7EJDz5ZshIPCRESObASL7IABworWCHYG/RZsgIPCRESObACL7AAELAL0LASELAN0LACELITAQorWCHYG/RZsAkQshQBCitYIdgb9FkwMQEhAxcWFgcGBCchEyM3MxMzAyEBAxc2Njc2JicC4/7nNse51QwN/vTC/h+8qR6oNu02ARr+ckPZYHwLCkZPBDr+yQEBzKm22gQEOqsBM/7N/Vv+ggICcFZMZgUAAQAr/+kG3wXKACYAibIcJygREjkAsABFWLAlLxuxJR8+WbAARViwBC8bsQQfPlmwAEVYsCMvG7EjDz5ZsABFWLAbLxuxGw8+WbIAJSMREjmwAC+yBwQbERI5sAQQsgsBCitYIdgb9FmwABCwDtCwABCyIgEKK1gh2Bv0WbAR0LAbELIVAQorWCHYG/RZshgbBBESOTAxARcSABcWEhcjJiYnJgYHJQchBwYWFwQTNwYAJy4CJyY3BwMjEzMBtKZQAV362PsL9QV5d5XSPAHiIv4rCg19fwEXT/Yn/q7widF4BgQOtXH2/PcDTwEBMgFKBQT++uyciwMFz+EBw2SqwgQLAS0B5P7yBAN+6pJRUgH9dAWwAAABABn/6AWkBFMAJgCVsg0nKBESOQCwAEVYsCYvG7EmGz5ZsABFWLAELxuxBBs+WbAARViwIy8bsSMPPlmwAEVYsB4vG7EeDz5Zsg4eBBESOXywDi8YslIOAV2yQA4BXbAB0LAEELILAQorWCHYG/RZsggOCxESObAOELIPBworWCHYG/RZsB4QshYBCitYIdgb9FmyGRYPERI5sA8QsCHQMDEBMzYkFxYWByM0JicmAyUHIQYXFhcWFxY2NzcOAicmAjcHAyMTMwFzjkUBHMOv0ALdWVbRVgF5Hv6WBQULSiU6WIET4AuI03DF4RKhTu687gJx7fUFBOC1X3QEBv7eAasyMmwwGAECaVEBbLBiAwQBEccB/joEOgAC/64AAASEBbAACwAOAFYAsABFWLAILxuxCB8+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsABFWLAKLxuxCg8+WbINCAIREjmwDS+yAAEKK1gh2Bv0WbAE0LIOCAIREjkwMQEjAyMTIwMhATMTIwEhAwNOfUrcSmnV/vcC8+/09v5cAUhLAar+VgGq/lYFsPpQAmgB9QAAAv+cAAADuAQ6AAsAEABWALAARViwCC8bsQgbPlmwAEVYsAIvG7ECDz5ZsABFWLAGLxuxBg8+WbAARViwCi8bsQoPPlmyDQIIERI5sA0vsgEBCitYIdgb9FmwBNCyDwgCERI5MDEBIwMjEyMDIwEzEyMBMwMnBwKfYzC+MVKW+wJY4ePi/rPwNgUuARf+6QEX/ukEOvvGAcQBE1RtAAACAD4AAAaNBbAAEwAWAHwAsABFWLACLxuxAh8+WbAARViwEi8bsRIfPlmwAEVYsAQvG7EEDz5ZsABFWLAILxuxCA8+WbAARViwDC8bsQwPPlmwAEVYsBAvG7EQDz5ZshUCBBESObAVL7AA0LAVELIGAQorWCHYG/RZsArQsAYQsA7QshYCBBESOTAxASEBMxMjAyMDIxMjAyETIQMjEzMBIQMBnwFYAbLw9PZAfUrdSmjV/vbe/utL9v32AcIBSEwCZwNJ+lABqv5WAar+VgGr/lUFsPy4AfYAAAIAMAAABX0EOgATABgAfwCwAEVYsAIvG7ECGz5ZsABFWLASLxuxEhs+WbAARViwBC8bsQQPPlmwAEVYsAgvG7EIDz5ZsABFWLAMLxuxDA8+WbAARViwEC8bsRAPPlmyABASERI5sAAvsAHQsg4BCitYIdgb9FmwC9CwB9CwARCwFNCwFdCyFxIEERI5MDEBMwEzEyMDIwMjEyMDIxMjAyMTMwEzAycHAWvwAV7h4+c2XTK+MVKW+5uuMe277gF18DYFLgHEAnb7xgEX/ukBF/7pARf+6QQ6/YoBE1RtAAIAFAAABmQFsAAbAB4Ad7IMHyAREjmwDBCwHNAAsABFWLAaLxuxGh8+WbAARViwBC8bsQQPPlmwAEVYsAwvG7EMDz5ZsABFWLATLxuxEw8+WbIYGgQREjmwGC+wANCwGBCyDwEKK1gh2Bv0WbAJ0LIcGgQREjmwGhCyHQEKK1gh2Bv0WTAxARYWBwMjEzYmJycHAyMTJyYGBwMjEzYkJRcDIQEBIQR52dQXOfY5EFZ8aAxs9mlshZ8WOvY5IAEbAQER9gTA/SQBLP4+AyQE79H+oAFheX0FAw/9sAJcAgFzhv6aAWDk4wIBAoj9jAGnAAIAFgAABSoEOgAbAB4Ac7IcHyAREjmwHBCwFNAAsABFWLAFLxuxBRs+WbAARViwAC8bsQAPPlmwAEVYsAsvG7ELDz5ZsABFWLAULxuxFA8+WbAE0LAEL7AH0LAEELISAQorWCHYG/RZsBfQshwFABESObAFELIdAQorWCHYG/RZMDEzNzY2NwMhARYWBwcjNzYnJicnBwMjEyciBgcHARMhFhod59CxA9f+lKSfFBnuGgYBBpokBk3sTiZyhBUcAd3C/uCvzNcOAdr+IBDjvqmqNC2NDQII/mEBpgFzfrYCawEgAAIANQAACJkFsAAhACQAl7IdJSYREjmwHRCwJNAAsABFWLAHLxuxBx8+WbAARViwCy8bsQsfPlmwAEVYsAAvG7EADz5ZsABFWLAFLxuxBQ8+WbAARViwES8bsREPPlmwAEVYsBovG7EaDz5ZsgkHABESObAJL7IdAQorWCHYG/RZsAPQsAkQsA3QsB0QsBfQsiIHABESObALELIjAQorWCHYG/RZMDEhEzY3BQMjEzMDIQMhARYWBwMjEzYnJicnBwMjEycmBgcDAQEhAkc7F1b+p2v2/fZwAx3+BML+E9nUFzn2OgcGErJnC2z2aW6EnxY7AoABK/49AV+fawP9mgWw/XsChf10BO/R/qABYT0uigYDDf2uAlwCAXOG/poDOgGpAAACACIAAActBDoAIQAkAJmyGyUmERI5sBsQsCTQALAARViwBy8bsQcbPlmwAEVYsAsvG7ELGz5ZsABFWLAALxuxAA8+WbAARViwBS8bsQUPPlmwAEVYsBEvG7ERDz5ZsABFWLAaLxuxGg8+WbAFELAJ0LAJL7AK0LIcAQorWCHYG/RZsATQsAoQsA3QsBwQsBfQsiILABESObALELIjAQorWCHYG/RZMDEhNzY3BQMjEzMDIQMhARYWBwcjNzYnJicnBwMjEyMGBgcHARMhAhgcGk3+vkrtvO1SApa5A9f+laGgFBntGgcCB5ojBk3sTitzgRQaAd3C/uCpnmQD/lgEOv4nAdn+IBDiv6mqNSyRCQII/mEBpgF2haoCawEgAAAC/6r+QgQxB4wAKgAzAIuyCTQ1ERI5sAkQsDPQALAbL7AwL7AARViwCS8bsQkfPlmwAEVYsBUvG7EVDz5ZsgAJFRESObAAL7AJELIGAQorWCHYG/RZsAAQsigBCitYIdgb9FmyDygAERI5sBUQsiIBCitYIdgb9FmyDzABXbAwELAy0LAyL7IPMgFdsiswMhESObAt0LAtLzAxATI2NzYmJyU3Fx4CBwYFFhYHBgQnJwYHBhcHJiY3NjYzFzI2NzYmJyc3ATc3FQEjAzUXAaR9pA4LZWv+3iP4h9JqCBH+9mZoBw/+1ds1jBEQh1t0hQYFxqo0cqkPDniAmSMBlKrQ/s2T6cQDTXNqVmMFAccBAVypdOFtLKtwye8CAQVpaD6VKrlxhJcBgWxreQUBxwOgmQQQ/uwBFRAEAAL/tf5KA8UGIAAlAC4Av7IrLzAREjmwKxCwBNAAsCsvsABFWLAHLxuxBxs+WbAARViwFy8bsRcRPlmwAEVYsBEvG7ERDz5ZsgARBxESObAAL7S/AM8AAl20XwBvAAJxtC8APwACcrTvAP8AAnG0HwAvAAJxso8AAV2yvwABcrAHELIEAQorWCHYG/RZsAAQsiMHCitYIdgb9FmyDCMAERI5sBEQsh0BCitYIdgb9FmwKxCwLdCwLS+0Dy0fLQJdsiYrLRESObAo0LAoLzAxATY3NichNxcWFgcGBxYHBgQjIwYHBhcHJiY3NjYzFzI2NzYnIzcBNzcXASMDNRcBhOQXEsL+3iHvzukHCtGsBAX+89YlkxEQf1loggQFv6EwaI0NFOahHgFPqtAB/syT6cMCbgaRdQe5AQGajZ1cRpqerwVqYUKPLrFtf48BUEaGB6kDE5kEEf7tARQRBAD//wB1AAAF1wWwAgYBmAAA//8AP/4iBYoEPAIGAbgAAAADAGL/5wUaBcgAEgAbACQAcLIUJSYREjmwFBCwCdCwFBCwHdAAsABFWLAKLxuxCh8+WbAARViwAC8bsQAPPlmwChCyEwEKK1gh2Bv0WbIWCgAREjl8sBYvGLJzFgFdsmAWAV2wABCyHAEKK1gh2Bv0WbAWELIgBworWCHYG/RZMDEFLgInJhI3NiQXFgAXFgICBwYDJgYHJTY3NiYBFjY3BQYVFBYCUI/WeggHOEVgATO92AEBDAY5i2eyGpnaPgKoBwEDhP68mtU+/VgGhhQDg/idcwFDh7vJBAT+3vd8/r/+81qcBQwF3vIBMDWnuvvMBdvvATAzp7YAAwA2/+cEJgRSABEAFwAdAGqyGB4fERI5sBgQsAzQsBgQsBLQALAARViwBC8bsQQbPlmwAEVYsA0vG7ENDz5ZshIBCitYIdgb9FmyGgQNERI5fLAaLxiyUhoBXbJAGgFdshUHCitYIdgb9FmwBBCyGAEKK1gh2Bv0WTAxEzYSNhceAgcHBgIGJyYCNzcBFhMFBhYTJgMlNiZGEpvzk4vHWxACFJzzksjhCgMBp9Jh/g4IZeXNZAHxCGgCIJ4BBY8EBI78lhaf/v6MBAUBGdoo/qIHASQBg5YC3Af+4AF9mAABAKgAAAVeBcYADwBGsgIQERESOQCwAEVYsAYvG7EGHz5ZsABFWLAPLxuxDx8+WbAARViwDC8bsQwPPlmyAQwPERI5sAYQsggBCitYIdgb9FkwMQEXNwE2NhcXByciBwEjAzMCKgQyAVdLtHYyGRFbPv3i7uf+AYBjdgLtspQCAdcBgfuUBbAAAQB3AAAERARSABAARrINERIREjkAsABFWLAFLxuxBRs+WbAARViwEC8bsRAbPlmwAEVYsA0vG7ENDz5ZsgENEBESObAFELIKAQorWCHYG/RZMDEBFzcTEjMyFwcmByIHASMDMwGpAiS/d884OCcYEks3/nvOp+cBbmBgAcIBIhjBCgJv/O4EOwD//wCoAAAFXgb8AiYCNwAAAQcBdQRXAQ4AFgCwAEVYsA8vG7EPHz5ZsBHcsBXQMDH//wB3AAAERAXQAiYCOAAAAQcBdQPC/+IAFgCwAEVYsA8vG7EPGz5ZsBLcsBbQMDH//wBr/kUJeAXIACYAMwAAAAcAXQVmAAD//wA5/kUIhwRSACYAUwAAAAcAXQR1AAAAAgBm/3UFFAYvABQAJgBVshknKBESObAZELAA0ACwAEVYsA0vG7ENHz5ZsABFWLADLxuxAw8+WbAA0LANELAK0LANELIXAQorWCHYG/RZsBrQsAMQsiABCitYIdgb9FmwI9AwMQUHJzcmAic3EgAlNxcHFhIXFgcCABMmJwcnNwYCAxUWFzcXByQTNgKkHMEcscgEARIBTQEQGcEZr8cFAhw0/saVBZwVwhalsg8MmBXCFgEPPhgMfwGAJAEe4kwBbgHDJnIBdCT+4eZ4lv7n/qoDofBAYgFkNf6y/sVC4z1iAWJXAZS2AAIAOP+HBDUEtQATACMAWLIAJCUREjmwFNAAsABFWLAALxuxABs+WbAARViwCi8bsQoPPlmwABCwA9CwChCwDdCwChCyFAEKK1gh2Bv0WbAAELIcAQorWCHYG/RZsBnQsBQQsCHQMDEBNxcHFhIHBwYABwcnNyYCNzc2EhM2Njc2JwcnNwYGBwYXNxcCNRm0GaamFQIc/vrIGLQYpaMVByP/1G99BgRuFbQWbXkHB2wXtARGbwFvJ/7bzxbg/tscbAFuJwEjyzHaARL8ki3ss7g8YQFjMOextj9pAQADAGL/5QbcB0QAMQBGAE8Ar7I9UFEREjmwPRCwCdCwPRCwR9AAsABFWLAULxuxFB8+WbAARViwBy8bsQcPPlmwFBCwANCwAC+yCgcUERI5sAcQsAzQsBQQshUBCitYIdgb9FmwBxCyKQEKK1gh2Bv0WbAe0LIiFAcREjmwFRCwMdCwFBCwPtCwPi+wM9CwMy+yMggKK1gh2Bv0WbAzELA50LA5L7JCCAorWCHYG/RZsD4QsEvQsEsvsE/QsE8vMDEBFhIHAwYAJyYmJwYnLgI3EzYkNwcGBgcDBhcWFhcWNjcTMwMGFxYWFxY2NxM2NSYnEwcjLgMjIgYHByc3NjYXHgMBNjY3NxcHBgcFWL3HF1Ue/u/JZ6MpktB8s1IPVR8BEdUXYYAVVQUBAklEZokUP+8/BQUIVUdefBZWBgSKsQkeO3FxbTczQAkCgwIIgmwwWrVi/e0rJwgSpQ0RngWxCf77zf3t3P7/BAJTSaMGAnnagwIT3voEzAKMgv3sKi5TXwQFhnsBf/58LyxJUQMDiogCFS0upgoB5ogCJy8kODETASZscQIBF0kZ/ooxPiVeAWZvWwADAEv/5QXDBegAMABFAE0Ar7I6Tk8REjmwOhCwCtCwOhCwRtAAsABFWLAVLxuxFRs+WbAARViwDS8bsQ0PPlmwFRCwANCwAC+wDRCwCNCyCw0VERI5sBUQshYBCitYIdgb9FmwDRCyHQEKK1gh2Bv0WbIhFQ0REjmwKNCwFhCwMNCwFRCwPdCwPS+wMtCwMi+yMQgKK1gh2Bv0WbAyELA40LA4L7JBCAorWCHYG/RZsD0QsEnQsEkvsE3QsE0vMDEBHgIHBwYGJyYmJwYnJiY3EzY3NjcHBg8CBhYXFjY3NzMHBhcWFhcWNjcTNzYmJwEHIy4DIyIGBwcnNzY2Fx4DATY3NxcHBgcEa3GeSQ0hHeyyWY0jgLCorhQkIYx3rxWpJyQEBDc2UG8RH+YdBAMDRTtHYhEmBAI7OgEDCSE6bXhrNzJACQKEAgiCbDBav1n98EsPEaYNEKAESAZvxHzu0+0FAktElAQE8b4BA9hvXgPDB+X9SEhfAgV3bMfHJiZCUAEDenUBDD9FVQYB6ogCJTIjODETASZscQIBF00V/ohVP14BZW9cAAACAGD/5ActBxEAIwArAIWyBiwtERI5sAYQsCrQALAARViwAC8bsQAfPlmwAEVYsA0vG7ENHz5ZsABFWLAYLxuxGB8+WbAARViwCS8bsQkPPlmwBNCwBC+yBwAJERI5sAkQshQBCitYIdgb9FmwH9CwABCwKtCwKi+wKNCwKC+yJggKK1gh2Bv0WbAoELAr0LArLzAxAQMGBCcmJicGJyYmNxMzAwYXFhYXFjY3EzMDBhcWFhcWNjcTJTchByEHIzcHLa8d/u7NaaImj9m/yhSu968FAwVLQ2SJFK/7rwUFB1BFXYMVr/x9FgM9Ff6xF7EXBbD7/dD5BAJXTqoEBvvCBAT7+yorSlUDBIN4BAX7+y0rS1EDA358BAXnenp/fwACAET/5gYeBbEAIgAqAImyFyssERI5sBcQsCnQALAARViwAC8bsQAbPlmwAEVYsA0vG7ENGz5ZsABFWLAXLxuxFxs+WbAARViwBC8bsQQPPlmwAEVYsAkvG7EJDz5ZsgcXBBESObITAQorWCHYG/RZsB7QsBcQsCnQsCkvsCrQsCovsiQICitYIdgb9FmwKhCwJ9CwJy8wMQEDBgYnJiYnBicmJjcTMwMHFBYXFjY3EzMDBhcWFhcWNjcTJTchByEHIzcGHnMc87ZbjiKDuamyE3PtcgQ4OFNzE3TucgQCAkI7T2gQc/ziFgMhE/6+F7EWBDr9UsbgBAJKQpIEBOm0Aq/9UEdDUQMDcGsCtv1QJiZDTgEDdmsCsPx7e39/AAABAFb+jATqBcoAGQBTsgAaGxESOQCwAEVYsAovG7EKHz5ZsABFWLAALxuxABc+WbAARViwAi8bsQIPPlmwChCwDtCwChCyEAEKK1gh2Bv0WbACELIYAQorWCHYG/RZMDEBIxMmJgI3ExIAFxYSBycSJyYGBwMHBhYXFwJ69UV9rUoTKi0BXfLk9wz2EviPyyAtAwN0aqf+jAFoGqkBApIBDAEfAVQFBP735gEBIAcD4sj+4UCRqQQBAAABAEX+iQP8BFMAGQBTsgAaGxESOQCwAEVYsAovG7EKGz5ZsABFWLAALxuxABc+WbAARViwAi8bsQIPPlmwChCwDtCwChCyEQEKK1gh2Bv0WbACELIYAQorWCHYG/RZMDEBIxMmAjc3Ejc2FxYWByc2JicmBgcHBhYXFwIk7UWbnBYBHZmZ1qzPBt8FVlJxoxYKB1ZYnf6JAWwnASDMCwEGnpwFBOOyAVt3BAXCo2p8kwQCAAABADgAAAS6BT4AEwATALAOL7AARViwBC8bsQQPPlkwMQEXBycDIwEnNxcBJzcXEzcBBQcnAjD7VP3puQEm+1T+AQv9Vv3tt/7VAQBZ+QG4rHWq/r8Bl6t1qwFzq3erAUcB/mKrdKkAAAH85gSi/+IF/QAHABEAsAAvsgMGCitYIdgb9FkwMQEHJzchNxcH/aoWrisCEROtJwUgfgHubAHcAAAB/Q4FFv/zBhQAEgArALAEL7AI0LAIL7IAAgorWCHYG/RZsAQQsA3QsA0vsg4CCitYIdgb9FkwMQMWFgcHJzc2JyYGBAcHNzI+AuRkcwQDggIGVipT/vNBQwtKV9FhBhMCbGcoARRdBAIQYgUBhxNNFwAB/isFFf8CBmAABQAMALABL7AF0LAFLzAxATczBxcH/isWuR4mUAXneaRsOwAAAf48BRf/WwZgAAUADACwAy+wANCwAC8wMQEnNzczB/6KTk8XuRkFF05yiY8AAAj6Qf7CAZ4FsQALABcAIwAvADsARwBTAF8AegCwPy+wSy+wVy+wMy+wAEVYsAMvG7EDHz5ZsgkJCitYIdgb9FmwPxCwD9CwPxCyRQkKK1gh2Bv0WbAV0LBLELAb0LBLELJRCQorWCHYG/RZsCHQsFcQsCfQsFcQsl0JCitYIdgb9FmwLdCwMxCyOQkKK1gh2Bv0WTAxATY2FzIWFSc2IyYHATY2MxYWFyc2IyIHAzY2FxYWFyc2IyYHATY2FxYWFyc2IyYHATY2FxYWFyc2IyYHATY2FzIWFSc2IyIHATY2FxYWFyc2IyYHAzY2FxYWFyc2IyYH/Z0Ib1tXbWsFUFUbAZ0Ib1pZawJsBVBSHRIIbltYagJrBVBTHv56CHFXWGoCawVQUh79MAhwW1hqAmsFUFMe/kIIcFtXbWsFT1Qd/o8IbltYagJrBVBTHicIb1pYawJsBVBSHgTzWGYBaVYBZgJm/upXZgFmWAFmZP4HWGYBAWZXAWYCZv33WWYCAWZXAWYCZv7jWWUBAWdXAWYCZgUZWWUBaVYBZmT+B1hmAQFmVwFmAmb991hmAQFmVwFmAmYAAAj6b/5jAXMFxgAEAAkADgATABgAHQAiACcALwCwIS+wFi+wEi+wCy+wGy+wJi+wAEVYsAcvG7EHHz5ZsABFWLACLxuxAhE+WTAxBRcDIxMTJxMzAwE3BQclBQclNwUBNyUXBQEHBSclEycDNxMBFxMHA/3kDqtmfaQOqmZ9AakKATkQ/sD7jwr+xxEBPwPOAwFKP/7Q/GYD/rZAATJtEV9BlgKxEV9DlDoT/rABYAShEQFR/qH+EQqAWkQ8CoBaRAGuEphOvvyNE5hPvwLkAQFTO/7Q/OYB/q49ATAA//8AJ/5+BXwHJAImAdsAAAAnAWoBVwE9AQcAEARU/8YAEwCwAEVYsAgvG7EIHz5ZsA3cMDEA//8AGf5+BHYF2gImAfsAAAAnAWoAnP/zAQcAEANi/8YAEwCwAEVYsAgvG7EIGz5ZsA3cMDEAAAIAIwAABJQFsAASABsAdLIVHB0REjmwFRCwCdAAsABFWLAPLxuxDx8+WbAARViwCS8bsQkPPlmyEgkPERI5sBIvsgAHCitYIdgb9FmyAw8JERI5sAMvsAAQsAvQsAzQsBIQsA3QsAkQshUBCitYIdgb9FmwAxCyGwEKK1gh2Bv0WTAxASMHFxYWBwYEIyETIzczNzMHMwEDBTY2NzYmJwKx2SL+4/0REP7H9P3dvrseuyH3Itr+xFYBEoGuDw5wawRHxAEB78TQ/gRHqr+//cf+EgICkHdpeQQAAgAh//wD6QZiABIAGwB0shUcHRESObAVELAD0ACwAEVYsA0vG7ENHz5ZsABFWLARLxuxER8+WbAARViwCS8bsQkPPlmwERCyAAcKK1gh2Bv0WbICDQkREjmwAi+wABCwC9CwDNCwAhCyEwEKK1gh2Bv0WbAJELIUAQorWCHYG/RZMDEBIQMXFhYHBgQnIRMjNzM3MwchAQMXNjY3NiYnAwb+51nHudUMDf70wv4f36keqCDtHwEZ/k9D2WB8CwpGTwUF/f4BAcypttoEBQWrsrL8kP6CAgJwVkxmBQAAAgAnAAAFBQWwAA4AGwBNsgQcHRESObAEELAX0ACwAEVYsAMvG7EDHz5ZsABFWLABLxuxAQ8+WbIWAwEREjmwFi+yAAEKK1gh2Bv0WbADELIUAQorWCHYG/RZMDEBAyMTBTIEBwYHFwcnBiMBNjc2JiclAyE2Nyc3AXxe9/0B9+YBBBMTlF9xZ4KrARssCxJxbf7MWAEZR05YcgId/eMFsAH7zMOBjVqWNgFDRENuigQB/gQCF4hZAAL/x/5gBA8EUgAVACYAbrIFJygREjmwBRCwH9AAsABFWLAOLxuxDhs+WbAARViwCy8bsQsbPlmwAEVYsAgvG7EIET5ZsABFWLAFLxuxBQ8+WbIHDgUREjmyDA4FERI5sA4QshkBCitYIdgb9FmwBRCyHgEKK1gh2Bv0WTAxJRcHJwYnJicDIwE3BzYXFhYXFgcHBgMmJicmBwMWFzI3JzcXNjc2A1RRcU5jZqViYe4BBNkSfKycsQYCBwUjwQJcVYViVS6EO0lRc0Q4EgqCgFl4NgICc/3+BdoBcIcEBNzEQD0k7wGDa34CBH/+HXgCIoNZaGFxSQAAAQAiAAAE3wcQAAkAMrIDCgsREjkAsABFWLAGLxuxBh8+WbAARViwBC8bsQQPPlmwBhCyAgEKK1gh2Bv0WTAxASMHIQMjEyETMwSOBwH9bNn3/QKdPeYE7Qn7HAWwAWAAAQARAAADzAVzAAcAKwCwAEVYsAQvG7EEGz5ZsABFWLACLxuxAg8+WbAEELIAAQorWCHYG/RZMDEBIQMjEyETMwN0/iWa7rwB3DfsA3b8igQ6ATkAAf/8AAAErAWwAA0ASQCwAEVYsAgvG7EIHz5ZsABFWLACLxuxAg8+WbINCAIREjmwDS+yAAcKK1gh2Bv0WbAE0LANELAG0LAIELIKAQorWCHYG/RZMDEBIwMjEyM3MxMhByEDMwKH73T2dKYepWsDgiT9dUfvAp/9YQKfqgJnzP5lAAH/ywAAA4kEOgANAEkAsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmyDQgCERI5sA0vsgAHCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASEDIxMjNzMTIQchByECVv8AUe1Rnh6dTgK1I/45LAEBAdH+LwHRqgG/xPsAAAEALv7EBKwFsAAXAFuyAxgZERI5ALAKL7AARViwFi8bsRYfPlmwAEVYsBQvG7EUDz5ZsBYQsgABCitYIdgb9FmyAxYUERI5sAMvsAoQsgsHCitYIdgb9FmwAxCyEgEKK1gh2Bv0WTAxASEDMxYWEgcCAAc3NhM2JyYmJyMDIxMhBIj9dUmYqe5rERv+zvwS70cgDQ2Gd7Rt9vwDggTk/l4Ej/79qf77/swGuwYBF4BxbnkE/YgFsAABABH+3wOCBDoAFQBKsg8WFxESOQCwCi+wAEVYsBQvG7EUGz5ZsABFWLASLxuxEg8+WbAUELIAAQorWCHYG/RZsgMUEhESObADL7IQAQorWCHYG/RZMDEBIQcXHgIHBgIHJzY3NiYnJwMjEyEDX/46KECP2WkND/O0QuseDnV1XE/uvAK1A3blAQN51oij/vwws1HUeZEEAf46BDoA////pf6aB+AFsAImAdkAAAAHA/0GgwAA////rf6aBnIEOgImAfkAAAAHA/0FPAAA//8AHv46BKgFxQImAdoAAAAHA/0Bdf+g//8AFv47A7wEUAImAfoAAAAHA/0BH/+h//8ALv6aBXsFsAImA8EAAAAHA/0EDwAA//8AIv6aBIEEOgImAf0AAAAHA/0DWQAAAAEAIwAABYMFsAAUAGEAsABFWLAALxuxAB8+WbAARViwDC8bsQwfPlmwAEVYsAIvG7ECDz5ZsABFWLAKLxuxCg8+WbIPCgwREjmwDy+ynw8BXbIIAQorWCHYG/RZsgEIDxESObAF0LAPELAS0DAxCQIhAycHIzcjAyMTMwMzNzMDMwEFg/4IARX+1rZBLp8pVWz3/fdrVC2gMzIBfwWw/U79AgJtAerp/ZMFsP2a/v8AAmgAAAEAIQAABM0EOgAUAFwAsABFWLANLxuxDRs+WbAARViwFC8bsRQbPlmwAEVYsAovG7EKDz5ZsABFWLADLxuxAw8+WbIOCg0REjmwDi+yCQEKK1gh2Bv0WbIBCQ4REjmwBdCwDhCwEtAwMQEBEyEDJwcjNyMDIxMzAzM3MwczAQTN/mrl/uCGLySYIFNL7LzsS1IkmCkiARYEOv3x/dUBrAGzsv5UBDr+UMfJAbIAAAEANwAABY8FsAAUAG4AsABFWLAELxuxBB8+WbAARViwEi8bsRIfPlmwAEVYsAsvG7ELDz5ZsABFWLAILxuxCA8+WbITEgsREjmwEy+wENCyDQcKK1gh2Bv0WbAB0LICCxIREjmwAi+yCgEKK1gh2Bv0WbIGCgIREjkwMQEjBzMBIQEBIQEjAyMTIzczNzMHMwLCzip9AgoBPv2YAYb+6P69rmz2vMcexiP2I88EP/MCZP07/RUCcP2QBD+qx8cAAAEAGQAABFkGAAAUAGoAsBIvsABFWLAELxuxBBs+WbAARViwCy8bsQsPPlmwAEVYsAgvG7EIDz5ZshMSCxESObATL7IBBworWCHYG/RZsgILBBESObACL7IKAQorWCHYG/RZsgYKAhESObABELAN0LATELAQ0DAxASMDMwEhAQEhAyMDIxMjNzM3MwczAqS+Xl0BTwEl/kkBGP793nJS7dLhHuEb7Bu+BLv94QGe/gX9wQHZ/icEu6qbmwAAAQCkAAAG4wWwAA4AYQCwAEVYsAYvG7EGHz5ZsABFWLAKLxuxCh8+WbAARViwAi8bsQIPPlmwAEVYsA0vG7ENDz5ZsggGAhESObAIL7IBAQorWCHYG/RZsAYQsgQBCitYIdgb9FmyDAEIERI5MDEBIwMjEyE3IQMzASEBASEDpq9s9tr+NSMCwGp9AgsBPv2XAYb+6AJw/ZAE7MT9nAJk/Tv9FQABAGwAAAW7BDoADgBrALAARViwBi8bsQYbPlmwAEVYsAovG7EKGz5ZsABFWLACLxuxAg8+WbAARViwDS8bsQ0PPlmyCQoCERI5sAkvsi8JAXGyjAkBXbIAAQorWCHYG/RZsAYQsgQBCitYIdgb9FmyDAAJERI5MDEBIwMjEyE3IQMzASEBASEDEX5K7Zr+diICd0xfAW0BNv4eATT+3gGs/lQDdsT+UAGw/e392f//ACf+mgWHBbACJgAsAAAABwP9BGkAAP//ABn+mgRpBDoCJgIAAAAABwP9A2sAAAABACcAAAffBbAADQBdALAARViwAi8bsQIfPlmwAEVYsAwvG7EMHz5ZsABFWLAGLxuxBg8+WbAARViwCi8bsQoPPlmyAQIGERI5sAEvsAIQsgQBCitYIdgb9FmwARCyCAEKK1gh2Bv0WTAxASETIQchAyMTIQMjEzMBsQJ2aQNPIv2o2/Zw/Ypw9/33A1ICXsP7EwKH/XkFsAAAAQARAAAFkgQ6AA0AZgCwAEVYsAIvG7ECGz5ZsABFWLAMLxuxDBs+WbAARViwBi8bsQYPPlmwAEVYsAovG7EKDz5ZsgEMBhESOXywAS8YtEABUAECXbACELIEAQorWCHYG/RZsAEQsggBCitYIdgb9FkwMQEhEyEHIQMjEyEDIxMzAWwBl04CQSP+rprtTP5pTO687gJ3AcPE/IoBtf5LBDoAAQAu/sIHhgWwABkAaLIUGhsREjkAsAgvsABFWLAYLxuxGB8+WbAARViwEi8bsRIPPlmwAEVYsBYvG7EWDz5ZsgEYEhESObABL7AIELIJBworWCHYG/RZsAEQshABCitYIdgb9FmwGBCyFAEKK1gh2Bv0WTAxATMWFhIHAgAHNzYTNicmJicjAyMTIQMjEyEFFm6p7msRG/7O/BLvRyANDYZ3im322f2U2fb8BFkDQASP/v2p/vv+zAa7BgEXgHFueQT9igTk+xwFsAAAAQAR/uMGUgQ6ABcAV7IQGBkREjkAsAcvsABFWLAWLxuxFhs+WbAARViwEC8bsRAPPlmwAEVYsBQvG7EUDz5ZsgEWEBESObABL7IOAQorWCHYG/RZsBYQshIBCitYIdgb9FkwMQEXFgAHBgIHJzY2NzYmJycDIxMhAyMTIQP2Ye4BDRMP9LNCeYQMD39/jVDtmf5pmu68A3MClAEC/vzUpv8AMLIqmGN4kwQB/jYDdvyKBDoAAgBl/+gF2QXHACsAOgCMshk7PBESObAZELA60ACwAEVYsCAvG7EgHz5ZsABFWLAOLxuxDh8+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgIEIBESObACL7AOELIPAQorWCHYG/RZsAQQshcBCitYIdgb9FmwABCyKwEKK1gh2Bv0WbACELAv0LAgELI2AQorWCHYG/RZMDEFJicGJy4CJyY3NxIANwcGBgIGFxYWFzI3JhM3NhI2FxYWFxcWBwcCBxYXARYWFzYTNzY1NCcmAwcGBUrSpKuikOmQEAkMGi4BOOAYb5o/CQYMmX8xMqUlIBiSxnaRtRMEAQciMdtPaf4AA0U+rSwiCn+rNiQJFwdBSQQCf+qWV1arASsBUgXUAs7+iHg8jqcDCPABFtGkAQh9AwTRtTdCPdr+2sIOAgGkWpo5jQEA4lMyzgcI/sbvPQAAAgBL/+oEkgRSACcAMgCMshszNBESObAbELAp0ACwAEVYsB0vG7EdGz5ZsABFWLAMLxuxDBs+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgIEHRESObACL7AMELINAQorWCHYG/RZsAQQshQBCitYIdgb9FmwABCyJwMKK1gh2Bv0WbACELAq0LAdELIwAQorWCHYG/RZMDEFJicGJyYmAjc3NhI3BwYHBxUWFhczNyY3Nz4CFxYWFxYHBwYHFhcBBhc2PwI0JyYHBE2zh4mBjtBgEQca870WlyYOBWdbFxZfFhMSbZpae5IGAgURIZ45Yf5pEV9rFw8GS28dFAQ0OgICmgEImDvcAQsGyhP+eE1vhQMCqcaOesRcAwTBnjQvftWWCwIBjqdwZaSBV5kDBvYA//8AZf4+BQ0FxwImACcAAAAHA/0BuP+k//8AOP4+A+4EUgImAEcAAAAHA/0BOv+k//8AnP6aBSIFsAImADgAAAAHA/0COwAA//8AU/6aBAgEOgImAgUAAAAHA/0B2AAA//8AoQAABU0FsAIGAD0AAP//AHf+XwQwBDoCBgGjAAAAAQChAAAFTQWwAA4AVrIKDxAREjkAsABFWLAILxuxCB8+WbAARViwCy8bsQsfPlmwAEVYsAIvG7ECDz5ZsgYCCBESObAGL7IFBworWCHYG/RZsAHQsgoIAhESObAGELAO0DAxASMDIxMjNzMBIRMBIQEzA5nPWvhaxB59/vgBBc0BvAEe/e58AgT9/AIEqgMC/VACsPz+AAABAFT+XwQwBDoADgBjsgoPEBESOQCwAEVYsAgvG7EIGz5ZsABFWLALLxuxCxs+WbAARViwAi8bsQIRPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIGBworWCHYG/RZsgoLABESObAN0LAO0DAxBSMDIxMjNzMDMxMBMwEzAt/VSe1IyB6inexmAWn+/iilAf5gAaCqA5H9BAL8/G/////D/poFRwWwAiYAPAAAAAcD/QPAAAD///+5/poEEwQ6AiYAXAAAAAcD/QLNAAAAAQCd/qEGbgWwAA8ATwCwDS+wAEVYsAgvG7EIHz5ZsABFWLACLxuxAh8+WbAARViwDi8bsQ4PPlmwAhCyAAEKK1gh2Bv0WbAF0LAOELIGAQorWCHYG/RZsArQMDEBITchByEDIRMzAzMDIxMhAfP+qiMDoyP+qrgCbdn22atz4z778ATsxMT73gTm+xz91QFfAAABAFb+vwTYBDoADwBLALANL7AARViwAy8bsQMbPlmwAEVYsA8vG7EPDz5ZsAMQsgQBCitYIdgb9FmwANCwDxCyBgEKK1gh2Bv0WbADELAI0LAGELAK0DAxASM3IQcjAyETMwMzAyMTIQFE7iICsCPUeAGXm+2aj23YOPzqA3fDw/1LA3j8iP39AUEA//8Axf6aBWoFsAImAeoAAAAHA/0EPQAA//8AcP6aBDoEOwImAgoAAAAHA/0DPAAAAAEAuQAABVwFsAAYAE+yBRkaERI5ALAARViwAC8bsQAfPlmwAEVYsAsvG7ELHz5ZsABFWLAOLxuxDg8+WbIFDgAREjmwBS+wCNCwBRCyFAEKK1gh2Bv0WbAR0DAxAQMGFxYXEzMDNjcTMwMjEwYHByM3JiY3EwISSwcFDKk7nzhecHv3/fdrUX8uoC/Y0xdLBbD+NToujREBK/7bCxgCqPpQAj0WDOznDPbPAckAAAEAhQAABDQEOwAVAE+yBBYXERI5ALAARViwCi8bsQobPlmwAEVYsBQvG7EUGz5ZsABFWLAALxuxAA8+WbIPFAAREjmwDy+yBgEKK1gh2Bv0WbAD0LAPELAS0DAxISMTBwcjNyYmNxMzAwcGFxMzAzcTMwN57kV1HaAfnZsSNuw4BANZNaA1dGDtAWoTi40X26QBTP6yQGsiAQv+7hQCDQABAOcAAAWMBbAAEABGsgIREhESOQCwAEVYsAEvG7EBHz5ZsABFWLAALxuxAA8+WbAARViwCS8bsQkPPlmyBQkBERI5sAUvsg4BCitYIdgb9FkwMTMTMwM2FxYWBwMjEzYmJAcD5/32a5qt5vAZTPZMEGD++s58BbD9wiwEAvPc/jcByn+DBir9WP//AA0AAAP5BgACBgBMAAAAAgBi/+oFwQXIACEALABkshwtLhESObAcELAr0ACwAEVYsBAvG7EQHz5ZsABFWLAALxuxAA8+WbIjABAREjmwIy+yFgEKK1gh2Bv0WbAF0LAjELAM0LAAELIdAQorWCHYG/RZsBAQsikBCitYIdgb9FkwMQUmJAI3NyYmNxcHFBc2EiQXFhIXFgcHJQcGFxYWFxY3FwYBJTc2JyYmJyYGBwNosP73dB4Ng4EJsAJeJbwBC5/Q6QUBCxb8ugwPCg6bgJ3DHXT98QJbBwsDBXZoh8Q3FgGkASGvSBzTpQFEdCi0ASGZBAT+6upSUYkBOFNKdYgDA0jIUwNlBSFCQnCBAwXGzwAC//T/6gSDBFMAHAAmAJGyDScoERI5sA0QsB7QALAARViwDi8bsQ4bPlmwAEVYsAAvG7EADz5ZsiEOABESObAhL7S/Ic8hAl20XyFvIQJxsr8hAXG0HyEvIQJxso8hAV207yH/IQJxshIHCitYIdgb9FmwBNCwIRCwC9CwABCyFwEKK1gh2Bv0WbIZDgAREjmwDhCyHQEKK1gh2Bv0WTAxBS4CNyYmNxcHBhc2JBcWEgcHIQYWFhcWNxcGBgMmBgcFNzYnJiYCbYvQYRRpaAekBANCSQEas8rJHg/9VwctaEmagHhD4g9ejTUBwQUHBQpYFAOI7Ykgu5QBOF8t0+kFBf7Z6mhRgU0CBYl9YWsDogN9kAIWLixHUv//AGL+QwXBBcgCJgJ+AAAABwP9Asf/qf////T+RgSDBFMCJgJ/AAAABwP9Adf/rP//ADUAAAIoBbACBgAtAAD///+lAAAH4AckAiYB2QAAAQcBagJQAT0ACQCwCS+wGdwwMQD///+tAAAGcgXaAiYB+QAAAQcBagGF//MACQCwCS+wGdwwMQAAAQAj/r0FWwWwABkAXrIYGhsREjkAsBAvsABFWLAELxuxBB8+WbAARViwCC8bsQgfPlmwAEVYsAIvG7ECDz5ZsgcEAhESObAHL7IYAQorWCHYG/RZsgoHGBESObAQELIRAQorWCHYG/RZMDEBIwMjEzMDMwEhARYSBwIABzc2NhInJiYnJwGVCHP3/fdqZAIOATz9t8jIGBv+x/wTcZxIDQ2Ecv0Ccv2OBbD9pAJc/YYf/szj/vf+ygTDBIkBAXdteQQCAAEAIf7nBIAEOgAWAF6yBhcYERI5ALAGL7AARViwES8bsREbPlmwAEVYsBUvG7EVGz5ZsABFWLAPLxuxDw8+WbITDxEREjmwEy+yDgEKK1gh2Bv0WbIADhMREjmwBhCyBwcKK1gh2Bv0WTAxARYWBwYGByc2Njc2JicnAyMTMwMzASECt4+WDg/yskJ1hgwOcm62S+y87EtIAYMBNwJcKuado/cusiWRYm2HBgH+VAQ6/lABsAD////K/n4FfAWwAiYB3gAAAAcAEART/8b///+//n4EeAQ6AiYB/gAAAAcAEANk/8YAAQAu/kYFggWwABQAdLIKFRYREjkAsABFWLAALxuxAB8+WbAARViwAy8bsQMfPlmwAEVYsBIvG7ESDz5ZsABFWLAILxuxCBE+WbICABIREjl8sAIvGLRgAnACAl20MAJAAgJdsAgQsg0BCitYIdgb9FmwAhCyEAEKK1gh2Bv0WTAxAQMhEzMBBgYnIic3FjMyNxMhAyMTAiBuAmpv9/7+GNamN04jNimAIW/9lmv2/AWw/YMCffoXuMkCE8cOxAKR/ZcFsAAAAQAR/kcEPwQ6ABQAbbILFRYREjkAsABFWLAALxuxABs+WbAARViwAy8bsQMbPlmwAEVYsBIvG7ESDz5ZsABFWLAILxuxCBE+WbICAxIREjl8sAIvGLRAAlACAl2wCBCyDQEKK1gh2Bv0WbACELIQAQorWCHYG/RZMDEBAyETMwMGBiMiJzcWMzI3EyEDIxMBu08Bl0/twxjNoztIHj0jgCFS/mlM7rwEOv49AcP7h7TGEsEQwgHp/ksEOv//ACf+fgWHBbACJgAsAAAABwAQBF//xv//ABn+fgR1BDoCJgIAAAAABwAQA2H/xv//AMX+mgVqBbACJgHqAAAABwP9AroAAP//AHD+mgQgBDsCJgIKAAAABwP9AbkAAP//ACf+fgbOBbACJgAxAAAABwAQBZ7/xv//ACL+fgXJBDoCJgH/AAAABwAQBLX/xv//ADUAAAIoBbACBgAtAAD///+kAAAErgcdAiYAJQAAAQcBagEwATYACQCwBC+wDtwwMQD//wAi/+gD9AXnAiYARQAAAQcBagCIAAAACQCwGC+wL9wwMQD///+kAAAErgcDAiYAJQAAAQcAawEoATYADACwBC+wHNywC9AwMf//ACL/6AQDBc0CJgBFAAABBwBrAIAAAAAMALAYL7A93LAs0DAx////hwAAB3gFsAIGAIkAAP//AA//6AZwBFICBgCpAAD//wAnAAAEugckAiYAKQAAAQcBagD4AT0ACQCwBi+wD9wwMQD//wA7/+oEAgXnAiYASQAAAQYBanEAAAkAsAkvsCPcMDEAAAIASP/oBTcFwwAaACQAXrIVJSYREjmwFRCwHNAAsABFWLAALxuxAB8+WbAARViwCi8bsQoPPlmyEAAKERI5sBAvsAAQshUBCitYIdgb9FmwChCyGwEKK1gh2Bv0WbAQELIeAQorWCHYG/RZMDEBFgQXFgcHBgIEJyYmAjc3BTYnJiYnJgcnNjYTFjY3IQcGFxYWAu+9AQ89PxkQHcr+1qyz8mQaFgOvDwoSqouk0R5AwQyR2kP9RQcOChCRBcMCrpqgym7G/ryvBASqATDFjwFbU4eXAwNJySkr+vwDy9EiTkNsdwD//wA2/+oD9gRQAgYBZQAA//8ASP/oBTcG3AImApoAAAEHAGsA9wEPAAwAsAAvsDbcsCXQMDH//wA2/+oD9gXOAiYBZQAAAQYAa3IBAAwAsAAvsC/csB7QMDH///+lAAAH4AcKAiYB2QAAAQcAawJIAT0ADACwCS+wJ9ywFtAwMf///60AAAZyBcACJgH5AAABBwBrAX3/8wAMALAJL7An3LAW0DAx//8AHv/tBKgHGAImAdoAAAEHAGsA4wFLAAwAsA4vsDvcsCrQMDH//wAW/+kD2gXNAiYB+gAAAQYAa1cAAAwAsCYvsDvcsCrQMDEAAQAv/+YEnAWwABsAarIZHB0REjkAsABFWLACLxuxAh8+WbAARViwDC8bsQwPPlmwAhCyAAEKK1gh2Bv0WbIEAAIREjmyGwwCERI5sBsvshkHCitYIdgb9FmyBRsZERI5shAMGRESObAMELITAQorWCHYG/RZMDEBITchBwEWFgcOAicmJjczBhYXFjY3NiYnJzcDU/2uJAN3Hf5FqLAOC5b7k8joCPQEbVpvrRARdIGXIATkzK7+VRnvr4bJawQE7LtkeQIEf2+BiwQBtwAB//D+cgRUBDoAGwBdsgscHRESOQCwDC+wAEVYsAIvG7ECGz5ZsgABCitYIdgb9FmyBAACERI5shsMAhESObAbL7IZBworWCHYG/RZsgUZGxESObIPAgwREjmwDBCyEwEKK1gh2Bv0WTAxASE3IQcBFhYHDgInJiY3FwYWFxY2NzYmJyc3Awn9tiMDchz+RaW1DwuW+JLG5wjsBGtfcrEQEXaCmiADdsSm/koZ67CFyGsDBOu6AWR+AgSDcIOKBAG2//8AJwAABXwG8QImAdsAAAEHAHIBIQFBABMAsABFWLAILxuxCB8+WbAL3DAxAP//ABkAAARIBacCJgH7AAABBgByZvcAEwCwAEVYsAcvG7EHGz5ZsAvcMDEA//8AJwAABXwHCgImAdsAAAEHAGsBTwE9AAwAsAAvsBvcsArQMDH//wAZAAAESAXAAiYB+wAAAQcAawCU//MADACwAC+wG9ywCtAwMf//AGv/5wUhBwMCJgAzAAABBwBrAT8BNgAMALAKL7A03LAj0DAx//8AOf/oBCcFzQImAFMAAAEGAGt9AAAMALAEL7Ay3LAh0DAx//8AYv/nBRoFyAIGAjUAAP//ADb/5wQmBFICBgI2AAD//wBi/+cFGgcHAiYCNQAAAQcAawFNAToADACwCi+wNtywJdAwMf//ADb/5wQmBc0CJgI2AAABBgBrewAADACwBC+wL9ywHtAwMf//AE//6QT3BxkCJgHwAAABBwBrASEBTAAMALAUL7Ay3LAh0DAx//8AI//oA+UFzQImAhAAAAEGAGtiAAAMALAIL7Ax3LAg0DAx//8Am//nBVMG8QImAeYAAAEHAHIA3wFBAAkAsAEvsBHcMDEA////tf5FBBIFtAImAF0AAAEGAHIeBAAJALABL7AQ3DAxAP//AJv/5wVTBwoCJgHmAAABBwBrAQ0BPQAMALABL7Ai3LAR0DAx////tf5FBBIFzQImAF0AAAEGAGtMAAAMALABL7Ah3LAQ0DAx//8Am//nBVMHPAImAeYAAAEHAW8BXAE9AAwAsAEvsBPcsBXQMDH///+1/kUEhAX/AiYAXQAAAQcBbwCbAAAAFgCwAEVYsA8vG7EPGz5ZsBbcsBLQMDH//wDFAAAFagcKAiYB6gAAAQcAawFJAT0ADACwAC+wItywEdAwMf//AHAAAAQgBcACJgIKAAABBgBrbfMADACwCC+wJNywE9AwMf//AC7+mgSsBbACJgGEAAAABwP9AP8AAP//ABj+mgOJBDoCJgH2AAAABwP9AOUAAP//AC4AAAa9BwsAJgHvCwAAJwAtBJUAAAEHAGsB9wE+ABYAsABFWLAKLxuxCh8+WbAe3LAp0DAx//8AIgAABfEFwAAmAg8AAAAnAPQEJgAAAQcAawFy//MAFgCwAEVYsAovG7EKGz5ZsB7csCnQMDH//wAz/kYE/AWwACYBhFAAACYD1a4pAAcD/AEsAAD//wAJ/kQD2wQ6ACYB9lIAACcD1f+J/3oABwP8AQL//v///8P+RgVHBbACJgA8AAAABwP8A7AAAP///7n+RgQTBDoCJgBcAAAABwP8Ar0AAAAB/8MAAAVHBbAAEQBjALAARViwCy8bsQsfPlmwAEVYsA4vG7EOHz5ZsABFWLACLxuxAg8+WbAARViwBS8bsQUPPlmyEQsCERI5sBEvsgAHCitYIdgb9FmyBAsCERI5sAfQsBEQsAnQsg0LAhESOTAxASMBIQMBIQEjNzMBIRMBIQEzA8eKASP+7tz+fP7VAfF4HnT+7wEQ1gF6ASr+LHIClf1rAhX96wKVqgJx/fMCDf2PAAAB/7kAAAQTBDoAEQBjALAARViwCy8bsQsbPlmwAEVYsA4vG7EOGz5ZsABFWLACLxuxAg8+WbAARViwBS8bsQUPPlmyEQ4CERI5sBEvsgAHCitYIdgb9FmyBA4CERI5sAfQsBEQsAnQsg0OAhESOTAxASMTIwMBIQEjNzMDMxMTIQEzAymW0/iX/vb+7AFngh6ExfiM/wEV/rCEAdf+KQFx/o8B16oBuf6eAWL+RwACADAAAAT4BbAADAAVAFCyDBYXERI5sAwQsA/QALAARViwAS8bsQEfPlmwAEVYsAMvG7EDDz5ZsgABAxESObAAL7ADELINAQorWCHYG/RZsAAQsg4BCitYIdgb9FkwMQETMwMlLgI3PgIzExMlBgYHBhYXA6Rd9/39+YvSZwsLmf+ZsFr+7oCtDxFvaQObAhX6UAEEc8yEjNVz/S4CBgICj3dvjAT//wA7/+cEiAYAAgYASAAAAAIARQAABoAFsAAYACEAWrIZIiMREjmwGRCwCdAAsABFWLAKLxuxCh8+WbAARViwGC8bsRgPPlmyCAoYERI5sAgvsBgQsgwBCitYIdgb9FmyEgoYERI5sBnQsAgQshoBCitYIdgb9FkwMSUuAjc+AjMFEzMDFzY2NTQnFxYXEgAjJRMlBgYHBhYXAgiL0mYLC5r9mQEuXfbZO3+aFeYSBhD+3/n+11r+7H2uEQ9uaQEEdMuEjNZyAQIV+xoCAubfXVgBWVv+1v6bygIGAgKNeHCMBAAAAgBH/+YGUQYYACMAMgCAsgYzNBESObAGELAk0ACwAEVYsAcvG7EHIT5ZsABFWLAaLxuxGg8+WbAARViwHy8bsR8PPlmyBAcfERI5sAQvsgYHHxESObAaELIOAQorWCHYG/RZshMHHxESObIdBx8REjmwBBCyJgEKK1gh2Bv0WbAfELIvAQorWCHYG/RZMDETNhI2FxYXEzMDBhcWFhcWEhM2JxcWFxYCBCciJicGJyYmJyYBJicmBgcHBhcWFhcWNzdPFYrLgZxZbe3NAwMDNy+OrwcCEt8OBAeL/vWpdp8chr+ZsgcDAtE3d3ydFQMGAQJaUn5lBgIHsAEVhgMEdwJE+04eHzdAAwkBKwENZGQBZGPb/qK9A1pZuAQE07g7AW5jBALPsRQzOGZzAgR1RQAAAQCq/+gFugWwACoAY7IVKywREjkAsABFWLANLxuxDR8+WbAARViwJy8bsScPPlmyBisNERI5sAYvsgMBCitYIdgb9FmwDRCyDAEKK1gh2Bv0WbIUAwYREjmwJxCyGwEKK1gh2Bv0WbIgDScREjkwMQE2JicnNxcyNjc2JyU3BRYWBwYGBxYWBwcGFhcWEhM2JxcWFxYCBicmJjcCZAlVV+Ekj5WkDhnm/p0kAS/v9Q8IkZliXwkHBS0tgpoHAhHoDQQHif+nl54IAXtlewUCzQF4dL8JAc0BAdbAb6s+IqR+RjZIAgkBMAEBZGQBZGPd/qS9AgKwmwABAGH/4wTNBDoAKQBgsiUqKxESOQCwAEVYsB8vG7EfGz5ZsABFWLAQLxuxEA8+WbIDAQorWCHYG/RZsgkQHxESObIYKh8REjmwGC+yFwEKK1gh2Bv0WbAfELIeAQorWCHYG/RZsiYXGBESOTAxJRUWFxY2NicmJxcWFxYCBicmJjc3NicnNxc2NzYnJTcXFhYHBgYHFhYHAq4DN0lyPQUEFN4RCRJw5ZWXkQUJC4PwH6XOFBWr/vQc9r3MCAVja09GBukhMwMFbNV5T04BTk6a/tagAQN8dExxBwK9AQaJhAoBwwEFpo9PdS8aeFIAAQCS/rkD2QWwACcAX7IkKCkREjkAsBsvsABFWLAKLxuxCh8+WbAARViwHy8bsR8PPlmyASgKERI5sAEvsgABCitYIdgb9FmwChCyCQEKK1gh2Bv0WbIQAAEREjmwHxCyGAUKK1gh2Bv0WTAxEzcXMjY3NiYnJTcXFhYHBgUWFhcWDwI3BwYHJzY3ByYnJjc3NiYnkiK1jqcODm5r/tof+OXyDxH++kdUCAQHFgPPGijHg2QslSUEAwoSDl1eAlzDAXlzbXEEAcMBAd7A3nUeeFQzNXcMBKD3nFGHbwEuRyxMfW2ABAABAIz+qAO5BDoAIwBfsh8kJRESOQCwGS+wAEVYsAkvG7EJGz5ZsABFWLAdLxuxHQ8+WbIBJAkREjmwAS+yAAEKK1gh2Bv0WbAJELIIAQorWCHYG/RZshAAARESObAdELIVAQorWCHYG/RZMDETNxc2NzYmJyU3BRYWBwYGBxYXFgcHNwcGByc2NwcmNzc2JieMH9LWFwpUVP7aHgENvdUKBWVnbg0EBga+GSbIg2somSMGDwlNTAGbswEGkENQAgHBAQWwkFB7MTR7JighAaHxoVGWcQEtToBOTgMAAf/e/+UHSgWwACMAYrIjJCUREjkAsABFWLANLxuxDR8+WbAARViwIC8bsSAPPlmwAEVYsAUvG7EFDz5ZsA0QsgABCitYIdgb9FmwBRCyCAEKK1gh2Bv0WbAgELIUAQorWCHYG/RZshkNBRESOTAxASEDAgIHIzc3NjY3NxMhAwYXFhYXFhITNicXFhcWAgQnJiY3BFn+b5BD+cBeFzN0mykUiwN1ugMDAzUuiaoFAhLpDgQHjv74p62vEgTj/Vv+1P7zBcoDDNbpcgKm+7kdHzRAAwkBJQEMZGQBZGPf/qO9BATPrgAB/97/5wYmBDoAIgBisgAjJBESOQCwAEVYsA0vG7ENGz5ZsABFWLAFLxuxBQ8+WbAARViwHy8bsR8PPlmwDRCyAAEKK1gh2Bv0WbAFELIHAQorWCHYG/RZsB8QshIBCitYIdgb9FmyGA0FERI5MDEBIwMGBicjNzc2Njc3EyEDBhYXFjY3NzYnFxYXFgIGJyYmNwMw/mI3zqBNFSVbcx8OYALMeQg8Pm6GDQIBEt8OBQp57ZmssxIDdP4/6s0EyQMImrBOAc79LFFlAgTp3DxeXgFeXsP+trYDAsyvAAABACf/5gdQBbAAHgBxshYfIBESOQCwAEVYsAAvG7EAHz5ZsABFWLAaLxuxGh8+WbAARViwEi8bsRIPPlmwAEVYsBgvG7EYDz5ZsBIQsgYBCitYIdgb9FmyCwAYERI5sh0AGBESOXywHS8YtDAdQB0CXbIWAQorWCHYG/RZMDEBAwYXFhYXFhITNicXFhcWAgQnJiY3NyEDIxMzAyETBXi3AwMEMy2JqwUCEukOBAeO/vmpp68OJ/2Xa/b99m8CaW8FsPu3HR42PwEIASIBDmRkAWRj4P6juwMCzrH//ZcFsP2DAn0AAAEAC//mBikEOgAeAHSyCB8gERI5ALAARViwBC8bsQQbPlmwAEVYsAgvG7EIGz5ZsABFWLAbLxuxGw8+WbAARViwAi8bsQIPPlmyBwgCERI5fLAHLxiyUwcBXbJABwFdsgABCitYIdgb9FmwGxCyDwEKK1gh2Bv0WbIUCAIREjkwMQEhAyMTMwMhEzMDBhcWFhcWEjc0JxcWFxYCBicmJjcC5/5eTe287U4Bok3teQMDBTswd40CEd4OBQp47pmpsQwBuv5GBDr+QwG9/SwfIDZBAQYBE+9eXgFeXr7+srgDAsqyAAEATP/oBJQFxwAhAEeyFyIjERI5ALAARViwCS8bsQkfPlmwAEVYsAAvG7EADz5ZsAkQsg4BCitYIdgb9FmwABCyFwEKK1gh2Bv0WbIcCQAREjkwMQUmJgI3EzYSJBcWFwcmJyYGBwcGFxYWFxY2JyYnFxcWAgQCUqPycRYpHL8BIqzMj1B6m6LqHigKCQ2Nb5OuAQEN6w0Ki/7yFQSkARymAQazAR6bAQRYtkUCAu6+/UZKeZMDAtDiWFcBrtb+75YAAQA9/+cDqgRRAB8AQ7IAICEREjkAsABFWLATLxuxExs+WbAARViwCi8bsQoPPlmyAAEKK1gh2Bv0WbAKELAE0LATELIYAQorWCHYG/RZMDElFjY3JzMXFgYGJy4CNzc+AhcWFwcmIyIGBwYXFhYCBVliAgXfCAZszH6Ny18OBRKZ8pGobUFdgXiqFwsGCWyvAmmWbm2ew2UDBI71lCqZ/YwBAkS7Pb+dXz9oegAAAQCQ/+YFNAWwABoATbIJGxwREjkAsABFWLACLxuxAh8+WbAARViwFy8bsRcPPlmwAhCyAAEKK1gh2Bv0WbAE0LAF0LAXELIKAQorWCHYG/RZshACFxESOTAxASE3IQchAwcWFhcWEjc3NicXFhcWAgQnJiY3AkX+SyQEXyT+TJYBAzUuh6cLAQIS6A4DB4n++Kuorw4E483N/IU7NEADBgER/x5kZAFkY9n+ocADAs6xAAEAc//oBJcEOgAZAE2yChobERI5ALAARViwAi8bsQIbPlmwAEVYsBYvG7EWDz5ZsAIQsgABCitYIdgb9FmwBNCwBdCwFhCyCwEKK1gh2Bv0WbIQAhYREjkwMQEhNyEHIQMGFxYWFxY2JyYnFxYHBgQnJiY3Aa/+xCIDciP+uFgDAwU7MXeICgUU3SkOGf73wqmyDgN3w8P97x8gN0ABBOywS0oBtHfN+wICzK8AAAEAVv/oBSIFyAArAHSyGywtERI5ALAARViwHC8bsRwfPlmwAEVYsA4vG7EODz5ZsikcDhESObApL7IfKQFxskopAV2yAAEKK1gh2Bv0WbAOELIGAQorWCHYG/RZsgocDhESObIUACkREjmyHxwOERI5sBwQsiMBCitYIdgb9FkwMQEiBgcGFhcWNjc3BgYEJy4CNzYlJicmNzY2JBcWBAcnNiYnJgYHBhYXFwcCw6C7Dw2bh4K/EfULof71m5z6dwoRATBQMT4GCJ8BEKbVAQgE9ASGbo3BDw6DhL0kAoN8d2N3AwJ+ZQGFwmYDAm67evtnLENVZojAZAMF4bUBXW8CA3lnZWsBAcj//wAo/+oEAgRRAgYBpQAA////yv5GBYwFsAImAd4AAAAHA/wETQAA////v/5GBJ0EOgImAf4AAAAHA/wDXgAA////pP5sBK4FsAImACUAAAAHAXABbwAD//8AIv5wA9wEUAImAEUAAAAHAXAAqQAH//8AJ/6bBLwFsAImACYAAAAHAXYElwAK//8AEP6IBA8GAAImAEYAAAAHAXYEpf/3//8AJ/6bBOAFsAImACgAAAAHAXYEcwAK//8AO/6RBIgGAAImAEgAAAAHAXYEkAAA//8AJ/35BOAFsAImACgAAAAHA6sBAf6S//8AO/35BIgGAAImAEgAAAAHA6sBHv6S//8AJ/6bBYcFsAImACwAAAAHAXYFAAAK//8ADf6bA/kGAAImAEwAAAAHAXYEfwAK//8AJwAABXEHNgImAC8AAAEHAHcBpQE2AAkAsAQvsA/cMDEA//8AEQAABHUHPQImAE8AAAEHAHcBowE9AAkAsAQvsA/cMDEA//8AJ/7cBXEFsAImAC8AAAAHAXYE0QBL//8AEf7HBEoGAAImAE8AAAAHAXYEYAA2//8AJ/6bA8MFsAImADAAAAAHAXYElwAK////5P6bAhcGAAImAFAAAAAHAXYDRAAK//8AJwAABs4HNgImADEAAAEHAHcCvgE2ABMAsABFWLACLxuxAh8+WbAR3DAxAP//ABAAAAZoBgACJgBRAAABBwB3ApgAAAAJALADL7Ak3DAxAP//ACf+mwbOBbACJgAxAAAABwF2BasACv//ABD+mwZoBFICJgBRAAAABwF2Ba4ACv//ACf+lwWGBbACJgAyAAAABwF2BQIABv//AA3+mwP6BFICJgBSAAAABwF2BGwACv//ACcAAAUEB0ICJgA0AAABBwB3AasBQgAJALADL7AW3DAxAP///8f+YARtBfcCJgBUAAABBwB3AZv/9wAJALANL7Ah3DAxAP//ACf+mwTYBbACJgA2AAAABwF2BJgACv///97+mwLvBFMCJgBWAAAABwF2Az4ACv//ACT+kQS7BccCJgA3AAAABwF2BLAAAP//ABz+iAPEBFACJgBXAAAABwF2BGL/9///AJz+lAUiBbACJgA4AAAABwF2BJ8AA///ADv+kQKuBUECJgBYAAAABwF2A/UAAP//AJsAAAWBBzcCJgA6AAABBwFuAN0BQwAJALABL7AR3DAxAP//AGQAAAQNBewCJgBaAAABBgFuFvgACQCwAS+wEdwwMQD//wCb/psFgQWwAiYAOgAAAAcBdgTVAAr//wBk/psEDQQ6AiYAWgAAAAcBdgRCAAr//wC3AAAHOgc2AiYAOwAAAQcARAIoATYAEwCwAEVYsAsvG7ELHz5ZsA7cMDEA//8AdwAABfgGAAImAFsAAAEHAEQBawAAABMAsABFWLALLxuxCxs+WbAO3DAxAP//ALcAAAc6BzYCJgA7AAABBwB3AsMBNgATALAARViwDC8bsQwfPlmwD9wwMQD//wB3AAAF+AYAAiYAWwAAAQcAdwIGAAAAEwCwAEVYsAwvG7EMGz5ZsA/cMDEA//8AtwAABzoHAwImADsAAAEHAGsB9QE2AAwAsAEvsB7csA3QMDH//wB3AAAF+AXNAiYAWwAAAQcAawE4AAAADACwAS+wHtywDdAwMf//ALf+mwc6BbACJgA7AAAABwF2BcUACv//AHf+mwX4BDoCJgBbAAAABwF2BScACv///+X+mwTnBbACJgA+AAAABwF2BJ8ACv///+f+mwPkBDoCJgBeAAAABwF2BEMACv///6T+lASuBbACJgAlAAAABwF2BOcAA///ACL+mAPcBFACJgBFAAAABwF2BCEAB////6QAAASuB7sCJgAlAAABBwF0BRUBPAAJALAEL7AZ3DAxAP//ACL/6APcBoUCJgBFAAABBwF0BG0ABgAJALAYL7A63DAxAP///6QAAAYYB7ECJgAlAAABBwPvAOsBIQAWALAARViwBS8bsQUfPlmwDtywFNAwMf//ACL/6AVwBnwCJgBFAAABBgPvQ+wAFgCwAEVYsBgvG7EYGz5ZsC/csDXQMDH///+kAAAErgeuAiYAJQAAAQcD8ADyASsAFgCwAEVYsAQvG7EEHz5ZsA7csBPQMDH//wAi/+gD8gZ5AiYARQAAAQYD8Er2ABYAsABFWLAYLxuxGBs+WbAt3LA00DAx////pAAABYAH3gImACUAAAEHA/EA7AETABYAsABFWLAFLxuxBR8+WbAM3LAS0DAx//8AIv/oBNgGqQImAEUAAAEGA/FE3gAWALAARViwGC8bsRgbPlmwLdywM9AwMf///6QAAASuB9UCJgAlAAABBwPyAOsBBQAWALAARViwBC8bsQQfPlmwDtywFdAwMf//ACL/6APsBqACJgBFAAABBgPyQ9AAFgCwAEVYsBgvG7EYGz5ZsC3csDbQMDH///+k/pQErgc3AiYAJQAAACcBZwDyATYBBwF2BOcAAwATALAARViwBC8bsQQfPlmwD9wwMQD//wAi/pgD6QYBAiYARQAAACYBZ0oAAQcBdgQhAAcAEwCwAEVYsBgvG7EYGz5ZsDDcMDEA////pAAABK4HrgImACUAAAEHA/MBHAEwABYAsABFWLAELxuxBB8+WbAO3LAa0DAx//8AIv/oA+4GeQImAEUAAAEGA/N0+wAWALAARViwGC8bsRgbPlmwL9ywO9AwMf///6QAAASuB64CJgAlAAABBwPuARwBMAAMALAEL7AO3LAa0DAx//8AIv/oA+4GeQImAEUAAAEGA+50+wAMALAYL7Av3LA40DAx////pAAABK4IPgImACUAAAEHA/QBHAE2AAwAsAQvsA7csBjQMDH//wAi/+gD4gcIAiYARQAAAQYD9HQAAAwAsBgvsC/csDnQMDH///+kAAAErggXAiYAJQAAAQcD9QEgATwADACwBC+wDtywF9AwMf//ACL/6AP6BuECJgBFAAABBgP1eAYADACwGC+wL9ywONAwMf///6T+lASuBx0CJgAlAAAAJwFqATABNgEHAXYE5wADABMAsABFWLAELxuxBB8+WbAO3DAxAP//ACL+mAP0BecCJgBFAAAAJwFqAIgAAAEHAXYEIQAHABMAsABFWLAYLxuxGBs+WbAv3DAxAP//ACf+mwS6BbACJgApAAAABwF2BKgACv//ADv+kQQCBFECJgBJAAAABwF2BHYAAP//ACcAAAS6B8ICJgApAAABBwF0BN0BQwAJALAGL7Aa3DAxAP//ADv/6gQCBoUCJgBJAAABBwF0BFYABgAJALAJL7Au3DAxAP//ACcAAAS6BzICJgApAAABBwFuAMgBPgAJALAGL7AW3DAxAP//ADv/6gQKBfUCJgBJAAABBgFuQQEACQCwCS+wKtwwMQD//wAnAAAF4Ae4AiYAKQAAAQcD7wCzASgAFgCwAEVYsAcvG7EHHz5ZsA/csBXQMDH//wA7/+oFWQZ8AiYASQAAAQYD7yzsABYAsABFWLAJLxuxCRs+WbAj3LAp0DAx//8AJwAABLoHtQImACkAAAEHA/AAugEyABYAsABFWLAGLxuxBh8+WbAP3LAU0DAx//8AO//qBAIGeQImAEkAAAEGA/Az9gAWALAARViwCS8bsQkbPlmwI9ywKNAwMf//ACcAAAVIB+UCJgApAAABBwPxALQBGgAWALAARViwBi8bsQYfPlmwD9ywE9AwMf//ADv/6gTBBqkCJgBJAAABBgPxLd4AFgCwAEVYsAkvG7EJGz5ZsCHcsCfQMDH//wAnAAAEugfcAiYAKQAAAQcD8gCzAQwAFgCwAEVYsAYvG7EGHz5ZsA/csBbQMDH//wA7/+oEAgagAiYASQAAAQYD8izQABYAsABFWLAJLxuxCRs+WbAh3LAq0DAx//8AJ/6bBLoHPgImACkAAAAnAWcAugE9AQcBdgSoAAoAEwCwAEVYsAYvG7EGHz5ZsBDcMDEA//8AO/6RBAIGAQImAEkAAAAmAWczAAEHAXYEdgAAABMAsABFWLAJLxuxCRs+WbAk3DAxAP//ADUAAALSB8ICJgAtAAABBwF0A5UBQwAJALACL7AS3DAxAP//ACIAAAKHBn4CJgD0AAABBwF0A0r//wAJALACL7AS3DAxAP/////+lwIoBbACJgAtAAAABwF2A18ABv///+T+mwIJBdgCJgBNAAAABwF2A0QACv//AGv+kQUhBcgCJgAzAAAABwF2BPYAAP//ADn+jwQnBFICJgBTAAAABwF2BIT//v//AGv/5wUhB7sCJgAzAAABBwF0BSwBPAAJALAKL7Ax3DAxAP//ADn/6AQnBoUCJgBTAAABBwF0BGoABgAJALAEL7Av3DAxAP//AGv/5wYvB7ECJgAzAAABBwPvAQIBIQAWALAARViwCi8bsQofPlmwJtywLNAwMf//ADn/6AVtBnwCJgBTAAABBgPvQOwAFgCwAEVYsAQvG7EEGz5ZsCTcsCrQMDH//wBr/+cFIQeuAiYAMwAAAQcD8AEJASsAFgCwAEVYsAovG7EKHz5ZsCTcsCvQMDH//wA5/+gEJwZ5AiYAUwAAAQYD8Ef2ABYAsABFWLAELxuxBBs+WbAk3LAp0DAx//8Aa//nBZcH3gImADMAAAEHA/EBAwETABYAsABFWLAKLxuxCh8+WbAk3LAq0DAx//8AOf/oBNUGqQImAFMAAAEGA/FB3gAWALAARViwBC8bsQQbPlmwItywKNAwMf//AGv/5wUhB9UCJgAzAAABBwPyAQIBBQAWALAARViwCi8bsQofPlmwJNywLdAwMf//ADn/6AQnBqACJgBTAAABBgPyQNAAFgCwAEVYsAQvG7EEGz5ZsCLcsCvQMDH//wBr/pEFIQc3AiYAMwAAACcBZwEJATYBBwF2BPYAAAATALAARViwCi8bsQofPlmwJdwwMQD//wA5/o8EJwYBAiYAUwAAACYBZ0cAAQcBdgSE//4AEwCwAEVYsAQvG7EEGz5ZsCPcMDEA//8AW//oBiYHMwImAUUAAAEHAHcCBgEzABMAsABFWLAKLxuxCh8+WbAu3DAxAP//ADb/5gUFBgACJgFGAAABBwB3AVoAAAATALAARViwBC8bsQQbPlmwKtwwMQD//wBb/+gGJgczAiYBRQAAAQcARAFrATMAEwCwAEVYsAovG7EKHz5ZsC3cMDEA//8ANv/mBQUGAAImAUYAAAEHAEQAvwAAABMAsABFWLAELxuxBBs+WbAp3DAxAP//AFv/6AYmB7gCJgFFAAABBwF0BSUBOQATALAARViwCi8bsQofPlmwOtwwMQD//wA2/+YFBQaFAiYBRgAAAQcBdAR5AAYAEwCwAEVYsAQvG7EEGz5ZsCjcMDEA//8AW//oBiYHKAImAUUAAAEHAW4BEAE0ABMAsABFWLAKLxuxCh8+WbAv3DAxAP//ADb/5gUFBfUCJgFGAAABBgFuZAEAEwCwAEVYsAQvG7EEGz5ZsCvcMDEA//8AW/6RBiYGLgImAUUAAAAHAXYE4AAA//8ANv6IBQUEqAImAUYAAAAHAXYEdf/3//8AW/6RBS8FsAImADkAAAAHAXYEzAAA//8ASv6RBDEEOgImAFkAAAAHAXYEIQAA//8AW//mBS8HuwImADkAAAEHAXQFBAE8ABMAsABFWLAKLxuxCh8+WbAT3DAxAP//AEr/6AQxBoUCJgBZAAABBwF0BG8ABgATALAARViwCC8bsQgbPlmwFNwwMQD//wBb/+gGrQdCAiYBRwAAAQcAdwINAUIAEwCwAEVYsBovG7EaHz5ZsB3cMDEA//8ASv/oBWEF7AImAUgAAAEHAHcBVf/sABMAsABFWLAWLxuxFhs+WbAe3DAxAP//AFv/6AatB0ICJgFHAAABBwBEAXIBQgATALAARViwEi8bsRIfPlmwHNwwMQD//wBK/+gFYQXsAiYBSAAAAQcARAC6/+wAEwCwAEVYsA4vG7EOGz5ZsB3cMDEA//8AW//oBq0HxwImAUcAAAEHAXQFLAFIABMAsABFWLASLxuxEh8+WbAb3DAxAP//AEr/6AVhBnECJgFIAAABBwF0BHT/8gATALAARViwDi8bsQ4bPlmwHNwwMQD//wBb/+gGrQc3AiYBRwAAAQcBbgEXAUMAEwCwAEVYsBovG7EaHz5ZsB7cMDEA//8ASv/oBWEF4QImAUgAAAEGAW5f7QATALAARViwFi8bsRYbPlmwH9wwMQD//wBb/ogGrQYCAiYBRwAAAAcBdgTw//f//wBK/pEFYQSUAiYBSAAAAAcBdgQlAAD//wChAAAFTQc2AiYAPQAAAQcARAEiATYAEwCwAEVYsAgvG7EIHz5ZsArcMDEA////tf5FBBIGAAImAF0AAAEGAER/AAATALAARViwDy8bsQ8bPlmwEdwwMQD//wCh/qEFTQWwAiYAPQAAAAcBdgSkABD///+1/gwEEgQ6AiYAXQAAAAcBdgUH/3v//wChAAAFTQe7AiYAPQAAAQcBdATcATwACQCwAS+wF9wwMQD///+1/kUEEgaFAiYAXQAAAQcBdAQ5AAYACQCwAS+wHtwwMQD//wChAAAFTQcrAiYAPQAAAQcBbgDHATcACQCwAS+wE9wwMQD///+1/kUEEgX1AiYAXQAAAQYBbiQBAAkAsAEvsBrcMDEA///+s//nBWcF2AAmADNGAAAHA139xwAAAAIA7ARxA2AF2AAFAA4AFQCwDC+wB9CwAdCwDBCwBNCwBdAwMQETNwcBBwMzBwYWFwcmNwH1nc4B/vFd660PCQ4mTZgQBJkBPgEY/sMBAVVTPGQwQ12xAP//ADYCCQJYAs0ABgARAAD//wA2AgkCWALNAAYAEQAA//8AnAJtBKUDMQBGA6DhAEzNQAD//wCCAm0F4wMxAEYDoIkAZmZAAP//AIICbQXjAzEARgOgiQBmZkAA////Tv4/AxcAAAAnAEP/1f7+AQYAQwEAABwAtgACEAIgAgNdtBACIAICcbaAApACoAIDXTAxAAEArgQgAiIGGgAHAB2yBwgJERI5ALAARViwAC8bsQAhPlmwBNCwBC8wMQEXBgcHIzc2Aat3axwd0BQmBhpPjX+ffOcAAQCKBAAB/gYAAAcAHbICCAkREjkAsABFWLAELxuxBCE+WbAA0LAALzAxASc2NzczBwYBAXdqHB7QFiUEAE+LgaWI4gAB/6T+1gEVAMoABwAYsgcICRESOQCwCC+yBA0KK1gh2Bv0WTAxEyc2NzczBwYadmYbHNQTI/7WUImBmnvgAAEAzQQBAdIGAAAKABOyCAsMERI5ALAAL7AG0LAGLzAxAQcGFxYXByYmNzcBwBkMCgkke0VFDBYGAJFOSElGSUfIYo7//wC3BCADcQYaACYDcAkAAAcDcAFPAAD//wCXBAADTwYAACYDcQ0AAAcDcQFRAAAAAv+h/sICWwD/AAgAEQAhsg0SExESObANELAF0ACwEi+yBA0KK1gh2Bv0WbAN0DAxEyc2NzczBwYGFyc2NzczBwYGG3pvGiDUHRJ733p0GSDVHhJ+/sJQoJS5tnHPR1Cjkbm3dMkAAQBpAAAESwWwAAsASwCwAEVYsAgvG7EIHz5ZsABFWLAGLxuxBhs+WbAARViwCi8bsQobPlmwAEVYsAIvG7ECDz5ZsAoQsgABCitYIdgb9FmwBNCwBdAwMQEhAyMTITchEzMDIQQr/pSK7ov+lyABZzvuOwFtA3L8jgNyyAF2/ooAAAH/+/5gBGUFsAATAHwAsABFWLAMLxuxDB8+WbAARViwCi8bsQobPlmwAEVYsA4vG7EOGz5ZsABFWLACLxuxAhE+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgYBCitYIdgb9FmwDhCyCAEKK1gh2Bv0WbAJ0LAQ0LAR0LAGELAS0LAT0DAxISEDIxMhNyETITchEzMDIQchAyEDvP6TQe1B/pkfAWZs/pkfAWc67jsBbR/+lG0Bbv5gAaDCArTEAXb+isT9TAABAJ4CBAJNA9wADQAWsgMODxESOQCwAy+xCgorWNgb3FkwMRM2NjMWFhUHBgYjIiY1nwZ9YFtwAgd9X1pwAvxkfAJ2Xitkc3Rb//8AM//yAwIBAwAmABIDAAAHABIBvwAA//8AM//yBK4BAwAmABIDAAAnABIBvwAAAAcAEgNrAAAAAQA2AgkBLgLNAAMAGLIABAUREjkAsAMvsgABCitYIdgb9FkwMQEjNzMBC9Uj1QIJxAAGAJ3/6AcGBccAFgAkACgANgBEAFIAuLICU1QREjmwAhCwGdCwAhCwJ9CwAhCwK9CwAhCwONCwAhCwTdAAsCUvsCcvsABFWLAXLxuxFx8+WbAARViwEy8bsRMPPlmwA9CwAy+yBQMTERI5sAfQsAcvsBMQsA7QsA4vshETAxESObAXELAe0LAeL7ATELIsAgorWCHYG/RZsAMQsjMCCitYIdgb9FmwLBCwOtCwMxCwQdCwHhCySAIKK1gh2Bv0WbAXELJPAgorWCHYG/RZMDEBNjYXFhc2FxYWBwcGBicmJicGJyYmNwMWFgcHBgYnJiY3NzY2EycBFwEGFhcWNjc3NiYnJgYHBQYWFxY2Nzc2JicmBgcBBhYXFjY3NzYmJyYGBwLrDr6ElDxngn2VCAYNuodAcSBmgn2VBvaAlggHDbyBepUIBQu1AngDb3n+rwU6N0FUCwkHOjk+VwsBsAU6OD9VCwoHOjk+Wgn79wU6Nz1WDAoFODo9VgwBZIarAgVrcAICqoBEjK0CATY4bwICqn8ErgSqgEqIqgQCq39AjLD6qE8EZ0/8P0VTAgJYRk9CVgICWEVQRVMCAldHT0JWAgJaSgLrSFACAlZITUVVAgJWSf//AJAD/AGWBgADBgALAAAADACwBC+wAdCwAS8wMf//AKED9ALCBgADBgAGAAAAGwCwCS+wBtCwBi+wAdCwAS+wCRCwBNCwBC8wMQAAAQBdAIoCZQOpAAYAEACwBS+yAgcFERI5sAIvMDEBEyMDNwEzASamlNsBAVSzAgz+fgGFFAGGAAAB//kAigICA6kABgAQALAAL7IDBwAREjmwAy8wMQETBwEjAQMBJtwC/q20AT+lA6n+fBX+egGbAYT//wA3/+8EPwWwACYABQAAAAcABQIfAAAAAf/hAG8DyQUlAAMACQCwAC+wAi8wMTcnARdaeQNweG9PBGdPAP//AGMCkwLsBakDBwPMAHICkwATALAARViwCS8bsQkfPlmwDdAwMQAAAQBuAowDUwW6ABIATLIPExQREjkAsABFWLAELxuxBB8+WbAARViwAC8bsQAfPlmwAEVYsBAvG7EQEz5ZsABFWLAILxuxCBM+WbAEELINAworWCHYG/RZMDEBFzY2MzIWBwMjEzc2JyYHAyMTAYoCNGxBcnQPUsFLBARfVj9hwYsFrXpIP6eM/gUByj1/AgJb/dEDIAD////DAAAEpwWwAiYAKgAAAAcD1f8w/mkAAf/2AAAEpQXJACYAmrIWJygREjkAsABFWLAXLxuxFx8+WbAARViwBi8bsQYPPlmyJRcGERI5sCUvsgACCitYIdgb9FmwBhCyCQEKK1gh2Bv0WbAE0LAEL7AAELAN0LAlELAP0LAPL7AlELAT0LATL7YPEx8TLxMDXbIQAgorWCHYG/RZsBcQsh0BCitYIdgb9FmyGxMdERI5sBMQsCHQsBAQsCPQMDEBIQcGByUHITcXNjc3BzczNyM3Mzc2JBcWFgcnNicmBgcHIQchByEDA/7hBxRbAqgk/AQkRWQfCqgamxKYGZMTGAEVx7TLCO8Jqlp+DhIBNhr+0BEBLQHULYFfA8rJASSxOAGReZCgxvUGBNm2AcUEAoVpoJB5AAUADQAABl8FsAAbAB8AIwAmACkAvbIKKisREjmwChCwH9CwChCwIdCwChCwJtCwChCwKNAAsABFWLAaLxuxGh8+WbAARViwFy8bsRcfPlmwAEVYsAwvG7EMDz5ZsABFWLAJLxuxCQ8+WbIFCRoREjmwBS+wAdCwAS+yDwEBXbIDAworWCHYG/RZsAUQsgcDCitYIdgb9FmwJdCwCtCwDtCwBRCwHdCwIdCwEdCwAxCwHtCwItCwEtCwARCwGdCwJ9CwFdCwCRCwJNCwFxCwKdAwMQEzByMHMwcjAyMDIQMjEyM3MzcjNzMTMxMhEzMBMzcjBTMnIwE3BwE3JwWN0hzRG9Ic0Vbv2P6xVvZWzRzMG80czFbu1gFTVvX96pUb8v5g7kKRAjATL/4HKhsDxaCXoP4SAe7+EgHuoJegAev+FQHr/N6Xl5f+fU4DAdUDRgAAAgAr/+0GWAWwACAAKQCisiYqKxESObAmELAY0ACwAEVYsBcvG7EXHz5ZsABFWLAcLxuxHBs+WbAARViwHy8bsR8bPlmwAEVYsBQvG7EUDz5ZsABFWLALLxuxCw8+WbAfELIAAQorWCHYG/RZsAsQsgYBCitYIdgb9FmwABCwD9CwENCyIhQXERI5sCIvshIBCitYIdgb9FmwHxCwHtCwHi+wFxCyKAEKK1gh2Bv0WTAxASMDBhcWFzI3BwYnJiY3EyMCIScDIxMFHgIHNxMzAzMBFzY3NicmJycGOblnAwIGSiYvEUtKe3sNZWmC/nCbXvT8AXN8v2gEeS7tLrn7SILKQiMLE6CbA4b9ohkUQQMJvhUBAqOJAmr+lAH95QWwAQNcqG8BAQf++f6tAgOsXF2OCAEA//8AJ//pCBQFsAAmADYAAAAHAFcEUAAAAAcAKgAAB30FsAAfACMAJwArAC4AMQA0AOuyMjU2ERI5sDIQsB7QsDIQsCLQsDIQsCfQsDIQsCrQsDIQsC7QsDIQsDDQALAARViwAi8bsQIfPlmwAEVYsB8vG7EfHz5ZsABFWLAbLxuxGx8+WbAARViwEC8bsRAPPlmwAEVYsA0vG7ENDz5ZsgkQAhESObAJL7AF0LAFL7IPBQFdsAHQsAUQsgcDCitYIdgb9FmwCRCyCgMKK1gh2Bv0WbAt0LAO0LAw0LAS0LAJELAl0LAp0LAh0LAV0LAHELAm0LAq0LAi0LAW0LABELAd0LAZ0LAQELAv0LAs0LAfELAy0LABELA00DAxASETMwMzByMHMwcjAyMDIQMjAyM3MycjNzMDMxMhEzMBMzcjBTM3IwUzJyMBNyMFNyMBBzcEvQEnnvupkxy2Qdsc/tntLf787e0b/xzaB7cckhXvCwEps8/9XZhG4QLZmT7i/puzDGABQUdT/SdNUAH2EA4EBwGp/legoqD92wIl/dsCJaCioAGp/lcBqf0VoqKioqL+Ary0tAIHKQIAAAIAEP/8BjYEOgAOABsAaLIAHB0REjmwEdAAsABFWLAOLxuxDhs+WbAARViwFi8bsRYbPlmwAEVYsAwvG7EMDz5ZsABFWLAPLxuxDw8+WbISAQorWCHYG/RZsA4QsgsBCitYIdgb9FmyBRILERI5shALEhESOTAxARYWBwMjEzYnJiclAyMbAjMDBRY3EzMDBgQnAzmklxUz7jUFAgqD/q6a7bvRf+1dATnIJ3XucRv+9c4EOQXMxP7AAUIsJXgFAvyKBDr7xgLW/e0CAsQCt/1bxNUEAP////T+rgUZBgAAJgBIAAAAJwPVAd0CQgEHAEMAe/9tABIAsi8hAV2yHyEBcbKfIQFdMDEAAQBO/+0EngXGACYAirIMJygREjkAsABFWLAZLxuxGR8+WbAARViwCy8bsQsPPlmyJhkLERI5sCYvsgACCitYIdgb9FmwCxCyBgEKK1gh2Bv0WbAAELAQ0LAmELAR0LAmELAW0LAWL7YPFh8WLxYDXbITAgorWCHYG/RZsBkQsh4BCitYIdgb9FmwFhCwIdCwExCwI9AwMQEhBhcWFhcWNxcGJy4CNwc3MzcjNzMSABcWFwcmJyYGByEHIQchA0T+qwkIC3ppW3MHenOZ3WUUrxmmF6gZoEIBSPBjjDFfX5TCLgFhGf6nFwFaAg9EPWNxAwIizxsCA4r5mwGNgI0BBwEWAgIezSMCAq6njYAABABCAAAGDwWwABoAHwAkACkA27IaKisREjmwGhCwHdCwGhCwI9CwGhCwKNAAsABFWLALLxuxCx8+WbAARViwAS8bsQEPPlmwCxCyJAEKK1gh2Bv0WbAK0LAKL0ARAAoQCiAKMApAClAKYApwCghdsgcDCitYIdgb9FmwBtCwBi9ACwAGEAYgBjAGQAYFXbIDAworWCHYG/RZsCfQsCcvQA8wJ0AnUCdgJ3AngCeQJwddsgABCitYIdgb9FmwChCwINCwIC+wD9CwDy+wBxCwHdCwEtCwBhCwHtCwHi+wFNCwFC+wAxCwJtCwF9AwMQEDIxMjNxc3BzczEwUyFhczBycGBzcHBwYEIwE3IQchJSUmJyUBBQclNgG/XveLsx2tFbgdsi8B/LTqJekdsQgPvh7OUf7+tgFNCf3OFAIw/fgB4y92/tUBlP4dEQEbdwId/eMDH6ACTAKgAQkBjHygAikkA6ABg38BxClM6AQ5AQP+PAE7AgEAAAEAOwAABIcFsAAZAGayEBobERI5ALAARViwGC8bsRgfPlmwAEVYsAwvG7EMDz5ZsBgQshcBCitYIdgb9FmwANCwFxCwE9CwEy+wA9CwExCyEgcKK1gh2Bv0WbAG0LASELAO0LAOL7IJBworWCHYG/RZMDEBIxYHNwcjBgYHARUhATcXMjcFNyEmJyU3IQQ01RsE0VCNN+3QAWb+7v5xGOnLZf3tUQHUDsL+5VkDmwT5VlsBtqirFP3jDwJcjgKtAraVBQHMAAEAEP/nBEcFsAAeAJGyGx8gERI5ALAARViwES8bsREfPlmwAEVYsAUvG7EFDz5ZshMRBRESObATL7AX0LAXL7IAFwFdshgBCitYIdgb9FmwGdCwCNCwCdCwFxCwFtCwC9CwCtCwExCyFAEKK1gh2Bv0WbAV0LAM0LAN0LATELAS0LAP0LAO0LAFELIaAQorWCHYG/RZsh4FERESOTAxAQcGAgQnJicTBz8CBzc3EzMHNw8CNwcHAzYSNzcERwgbxf7bsHSDYuUl5BblJeQ29yXqJekX6yXqXa7eHwgC/0zT/rWuAgIVAldW0Vd+VtJXATbRWdJaflnSWf3+BQEH7E0AAAH/5AAABKwEOgAaAFyyDRscERI5ALAARViwGS8bsRkbPlmwAEVYsAYvG7EGDz5ZsABFWLANLxuxDQ8+WbAARViwEi8bsRIPPlmyAA0ZERI5sAAvsgwBCitYIdgb9FmwD9CwABCwGNAwMQEWFhcWBwcjNzc2JicDIxMGAwcjNxIAPwIzAzqduxEJDh3tIQgFTVN57nr4RibtIzQBLNoMK+0DaCj6vG9sr85pgbco/WkCmGH+pt3LARkBWikC0QAC/+YAAAVgBbAAFgAfAHiyGCAhERI5sBgQsA3QALAARViwDC8bsQwfPlmwAEVYsAIvG7ECDz5ZsgYCDBESObAGL7IFAQorWCHYG/RZsAHQsAYQsArQsAovsg8KAV2yCQEKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAMELIfAQorWCHYG/RZMDElIQcjNyM3MzcjNzMTBTIEBwYEIyUHIQEFMjY3NiYnJQLb/skp9ijHJMYTxyPHfAH35gEBERL+xvX+yxMBOf79AReFsBEOc2v+y+fn58trywLIAfjK2fgBawE2Aod/boUEAQAEAML/5wU+BckAHAAqADgAPACUsgE9PhESObABELAo0LABELAs0LABELA50ACwOS+wOy+wAEVYsAovG7EKHz5ZsABFWLAkLxuxJA8+WbAKELAD0LADL7IOAwoREjmwChCyEQIKK1gh2Bv0WbADELIZAgorWCHYG/RZshwDChESObAkELAd0LAdL7AkELIuAgorWCHYG/RZsB0QsjUCCitYIdgb9FkwMQEGBicmJjc3NjYXFhYVJzYmIyIGBwcVFhYXMjY3ARYWBwcGBicmJjc3NjYDBhYXFjY3NzYmJyYGBwUnARcC7Aqhe3eNCAYNrH95jKUCMjI3TAoJAi0nMEMOAeJ+lwgGDbeHfpkIBQu6JAU8Nj5UDAoFOjc/WAn96nkDb3oEJXiQAgKrf0SNrQIElHMBOEBYRU4yLjgBPDf+bAKogUSMrgQCqoBCjaz+g0dSAgJVSk9IUAICW0nvTwRnTgACADH/6gPiBf8AGgAkAFqyFiUmERI5sBYQsBvQALAOL7AARViwAC8bsQAPPlmyCAAOERI5sAgvsgcHCitYIdgb9FmwFdCwABCyGgEKK1gh2Bv0WbAIELAb0LAOELIhAQorWCHYG/RZMDEFLgI3NwYHNzY3EzY2FxYWBwcGAAcHBhUUFwM2PwI0JyYHBwJmg7tQFgRLdhRbZlQay5WAjgsEFP76xQ8InWvHHQUCNlMaBxYHc8p/EBEFvAIVAd/I3gUEuYwst/6wZk4zLpgLAj+00yUlVQUFmSwAAAQAIwAAB+kFxQADABEAHwApAKGyICorERI5sCAQsAHQsCAQsBDQsCAQsBPQALAARViwJS8bsSUfPlmwAEVYsCgvG7EoHz5ZsABFWLAHLxuxBx8+WbAARViwIC8bsSAPPlmwAEVYsCMvG7EjDz5ZsAcQsA7QsA4vsAPQsAMvsgACCitYIdgb9FmwDhCyFQIKK1gh2Bv0WbAHELIcAgorWCHYG/RZsiIlIBESObInJSAREjkwMQEhNyEBNjYXFhYHBwYGJyYmNxcGFhcWNjc3NiYnJgYHASMBAyMTMwETMwc9/a8bAlD95BHTl46lCwcQ1JWQpAqsCEVHTWoPCghESFBpDv4Q//7Ntu79/gE1t+wBnJUCLp/HBATDmkqoxQQExJcCYGkCA21jVV9rAgJxXvugBBT77AWw++kEFwACAO0DkwTLBbAADAAUAG0AsABFWLAGLxuxBh8+WbAARViwCS8bsQkfPlmwAEVYsBMvG7ETHz5ZsgEVBhESObABL7IACQEREjmyAwEGERI5sATQsggBCRESObABELAL0LAGELENCitY2BvcWbABELAP0LANELAR0LAS0DAxAQMHAwMjEzMTEzMDIwEjAyMTIzchBD6uPDxDbl+COcOHXm3+b4ZNc02JEQGCBPb+nwIBfv6DAhz+hgF6/eQBvf5FAbtfAAIAff/pBHcEUgAWAB0AYrIUHh8REjmwFBCwGNAAsABFWLAKLxuxChs+WbAARViwAi8bsQIPPlmyGgoCERI5sBovsg8MCitYIdgb9FmwAhCyEwwKK1gh2Bv0WbIWCgIREjmwChCyFwwKK1gh2Bv0WTAxJQYnJiYCNzYSJBceAgcHIQMWFxY2NwMmBwMhEyYDrLLChM9oDg6xAQOJgsBfCgX9Ezxdj1O6dcqKmjQCCjVcXHMEApcBAoyRARSZBASO+JEx/rZnBAM3RAMrA3z+6gEgawD//wC2//IFiQWZACcDzwBJAoYAJwODAPMAAAEHA8gDCQAAABAAsABFWLAFLxuxBR8+WTAx//8Agv/yBiEFuAAnA80AjgKUACcDgwGbAAABBwPIA6EAAAAQALAARViwDS8bsQ0fPlkwMf//AIj/8gYWBagAJwPLAH4CkwAnA4MBgAAAAQcDyAOWAAAAEACwAEVYsAEvG7EBHz5ZMDH//wC1//IF1gWjACcDyQCSAo4AJwODASoAAAEHA8gDVgAAABAAsABFWLAFLxuxBR8+WTAxAAIARf/nBEgF9QAdAC0AVLIILi8REjmwCBCwHtAAsA0vsABFWLAVLxuxFQ8+WbIADRUREjmwAC+wDRCyBwEKK1gh2Bv0WbAAELIeAQorWCHYG/RZsBUQsicBCitYIdgb9FkwMQEWFzYnJiYnJgYHJzYXFhITFQICBCcuAjc3PgIXJgYHBwYXFhYXFjY3NyYmAmSkawMCCoRuRYNCDJGi0N0GDZ7++amKw1sQAhGR4pl2phUDBgQFYVd6pSANDnQEBQR7KjCVsgQDIBW5QwEE/tf+6kb+1/530gQCivGTFpHqfcYDqJQVNjlkcwMFzs5VTlsAAQAf/xsFVQWwAAcAJwCwBC+wAEVYsAYvG7EGHz5ZsAQQsAHQsAYQsgIBCitYIdgb9FkwMQUjEyEDIwEhBE3u6f2t6e0BBwQv5QXU+iwGlQAB/6f+8wT6BbAADAA1ALADL7AARViwCC8bsQgfPlmwAxCyAgEKK1gh2Bv0WbAF0LAIELIKAQorWCHYG/RZsAfQMDEBASEHITcBATchByEBA3P9lAMiIvugHAK5/j0ZBCgi/QQBmQJF/XHDogLIAsaNw/11AAEAnAJtA/gDMQADABEAsAIvsgEBCitYIdgb9FkwMQEhNyED1fzHIwM5Am3EAAABADQAAAUJBbAACAA8sgAJChESOQCwBy+wAEVYsAEvG7EBHz5ZsABFWLADLxuxAw8+WbIAAQMREjmwBxCyBgEKK1gh2Bv0WTAxAQEzASMDIzchAfcCNd39KcBu0CMBWQEtBIP6UAJBxQAAAwBJ/+gHrgRSAB4ALwBBAGKyBkJDERI5sAYQsCnQsAYQsDvQALAARViwCi8bsQoPPlmwBNCwChCwE9CwEy+wGdCyBxkKERI5shYZChESObATELI/AQorWCHYG/RZsCTQsAoQsjUBCitYIdgb9FmwLNAwMQEGAgYnJiYnBgYnLgI3NzYSNhcWFhc2NhcWFhcWByc2JycmJyYGBwcGFhYXFjY3BQYXFhYXFjY2Nzc2JicmJyYGB58Sn/SPiNUuevCFhMRgDwISn/OOi9YtePGHicksJg3pBgQFIp513SoHBkZ6RXyyF/qLBgUHZlhLl38bBgQmJVFqe7ACGJv+/JEEBLKVtJsDBI79lBeXAQWRBASykrKZAwKeiHaCATU9Jb4FAtaGJEulaAIFyqMQNjxpfAMCXq5YJDd4M2wEBcsAAf8X/kUDIgYZABYAPbIBFxgREjkAsABFWLAOLxuxDiE+WbAARViwAy8bsQMRPlmyCAEKK1gh2Bv0WbAOELITAQorWCHYG/RZMDEFBgYnIic3FjMWNxM2NhcWFwcmIyIGBwEfFcqjOU0jORWPG74V16o1ZykwKVBlDU+vvQQVvA8EsATrscYCARa4DWBTAAIAMAD+BDUD+QASACUAeLIOJicREjmwDhCwINAAsAIvsAbQsAYvsAIQsAjQsAYQsgsBCitYIdgb9FmwAhCyEAEKK1gh2Bv0WbALELAS0LACELAV0LAVL7AZ0LAZL7AVELAb0LAZELIeAQorWCHYG/RZsBUQsiMBCitYIdgb9FmwHhCwJdAwMRM2MzIWFjMyNwcGJyIuAiMGBwc2MzIWFjMyNwcGJyIuAiMGB45tjV3ZTS17ghZtfDxka2Y/hogzbYld20wteocYa4AxVqZVLoeDA5BpeRd92WsCKT0qAnzKaXkXfdlrAhxcGAJ8AAABAGIAggQUBMEAEwA3ALATL7IAAQorWCHYG/RZsATQsBMQsAfQsBMQsA/QsA8vshABCitYIdgb9FmwCNCwDxCwC9AwMQEhByc3IzchNyE3ITcXBzMHIQchA6f9+qNqcqQjARGh/nQkAfiranmxI/7hoAGZAWTiRZ3J38rrRabK3wD////VABMD2wRxAGcAIAAYAItAADmaAAcDoP85/ab//wAXABMD8wRnAGcAIgAaAItAADmaAAcDoP97/aYAAgA6AAAD4gWwAAUACQA4sgYKCxESObAGELAE0ACwAEVYsAAvG7EAHz5ZsABFWLADLxuxAw8+WbIGAAMREjmyCAADERI5MDEBMxMBIwMBARMBAiW//v4WwP4CKv7AlAE/BbD9Gv02AuQBx/4f/jcB4wD//wBpAKgCDgUKACcAEgA5ALYBBwASAMsEBwAJALADL7AV3DAxAAACAGYCfwKCBDkAAwAHACqyAAgJERI5sAXQALACL7AARViwBi8bsQYbPlmyAAgCERI5sAAvsATQMDEBIxMzEyMTMwEAmk2a55pOmgJ/Abr+RgG6AAAB/8//ZwEWAQYABwAMALAEL7AA0LAALzAxFyc2NzczBwZKe18VD8QNJJlPhXhTVsUA//8AXwAABZEGGgAmAEoAAAAHAEoCMwAAAAIASwAABEwGGgAVABkAg7IHGhsREjmwBxCwF9AAsABFWLAILxuxCCE+WbAARViwAy8bsQMbPlmwAEVYsBIvG7ESGz5ZsABFWLAYLxuxGBs+WbAARViwAC8bsQAPPlmwAEVYsBYvG7EWDz5ZsAMQsgEBCitYIdgb9FmwCBCyDgEKK1gh2Bv0WbABELAT0LAU0DAxMxMjNxc3NjYXFhYXByYjJgcHNwcjAyEjEzNPnKAgmA4j/MNOlUo5fnDUKA3XIM6dAlXuvO0DhrQBUb7SBAEmF8gzAspCAbT8egQ6AAEAXwAABKQGGQAYAG2yEhkaERI5ALAARViwEy8bsRMhPlmwAEVYsAYvG7EGGz5ZsABFWLAOLxuxDhs+WbAARViwCi8bsQoPPlmwAEVYsBcvG7EXDz5ZsBMQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WbAM0LAN0DAxASYHIgYHBzMHIwMjEyM/AjY2FxYXFwMjA59tNV14Dw7XINWd7Z2hIJ8OGu+7bW3a/+wFQhABX15atPx6A4a0AWW2wwICECD6GwACAF8AAAa1BhoAJwArAL6yEywtERI5sBMQsCnQALAARViwFi8bsRYhPlmwAEVYsAMvG7EDGz5ZsABFWLARLxuxERs+WbAARViwIC8bsSAbPlmwAEVYsCovG7EqGz5ZsABFWLAILxuxCCE+WbAARViwAC8bsQAPPlmwAEVYsCMvG7EjDz5ZsABFWLAoLxuxKA8+WbADELIBAQorWCHYG/RZsAgQsg0BCitYIdgb9FmwFhCyHAEKK1gh2Bv0WbABELAh0LAi0LAl0LAm0DAxMxMjNzM3NjYXFhcHJiMmBgcHBTc2NhcWFhcHJicmBwc3ByMDIxMhAyEjEzNjnaEgoA0Z3648UBosLVVsDw8BYBEm+MBOlko6enTTKA3XIM6d7Zz+mZ0Eqe287QOGtGC3yQICEr4KAV5TZgFhtskCAiYXyDECAspCAbT8egOG/HoEOgABAF8AAAb5BhsAKgCrshMrLBESOQCwAEVYsAgvG7EIIT5ZsABFWLAWLxuxFiE+WbAARViwAy8bsQMbPlmwAEVYsBEvG7ERGz5ZsABFWLAiLxuxIhs+WbAARViwAC8bsQAPPlmwAEVYsBovG7EaDz5ZsABFWLAmLxuxJg8+WbADELIBAQorWCHYG/RZsAgQsg0BCitYIdgb9FmwFhCyHgEKK1gh2Bv0WbABELAk0LAl0LAo0LAp0DAxMxMjNzM3NjYXFhcHJiMmBgcHJTc2NhcWFxcBIxMmIyIGBwczByMDIxMhA2OdoSCgDRnirTJYGjchVWwPEAFnDRrvu2Zk6/8A7e2GIVt5EA7WH9Wd7Zz+mZ0DhrRfuMoEARK+CgFfUmYBZbbDAgEOI/obBUEQXFtgtPx6A4b8egABAF//7QT7BhkAJwCUshAoKRESOQCwAEVYsCIvG7EiIT5ZsABFWLARLxuxERs+WbAARViwHS8bsR0bPlmwAEVYsCYvG7EmGz5ZsABFWLAZLxuxGQ8+WbAARViwCy8bsQsPPlmwJhCyAAEKK1gh2Bv0WbALELIGAQorWCHYG/RZsAAQsA/QsBDQsCIQshUBCitYIdgb9FmwEBCwG9CwHNAwMQEjAwYXFhcWNwcGJyYmNxMjNzM3JiMiBgcDIxMjNzM3NjYXFhYXAzME27lmAwIGSSMyEUpKe3wNZa0grC9CY01nD8vtnaEgoA0Z16py22k6uQOG/aIZFEADAgq+FQECo4kCarT6Il1Y+18DhrRfuMgCAT8r/o4AAQAX/+kGnQYaAEoAwLIpS0wREjkAsABFWLA+LxuxPhs+WbAARViwRS8bsUUhPlmwAEVYsBAvG7EQGz5ZsABFWLBJLxuxSRs+WbAARViwLC8bsSwPPlmwAEVYsAovG7EKDz5ZsEkQsgEBCitYIdgb9FmwChCyBQEKK1gh2Bv0WbABELAO0LBFELIVBworWCHYG/RZsh1JLBESObA+ELIgAQorWCHYG/RZsjcsPhESObA3ELImAQorWCHYG/RZsCwQsjMBCitYIdgb9FkwMQEjAwcWFxY3BwYnJiY3EyM3Mzc2JicmBh8CFgcHNiYnIgYHBgQXFgcOAicmJjczFBYXMjY3NiQnJjc2JBcyFyY3NjYXFhYHBzMGfrlkAgNLIzIRS0p7eA9gpx+mDQpKTV1zCQQTBgTuAlJMTnMLDwEQRM0KBX7VdrHkAuZjVlp1DBH+7hb4CAcBBbFLXxMGDuuoucUVDLkDhv22L1IDAgq+FQECtJkCSbRZX2kCA4WNPKo6OQFLVgJNQVpFHVe7aJlRAwLJn1hZAklBYE4IWMOWvgIZfDmJpQIE1qxYAAAW/6n+cghFBa4ADQAaACgANwA9AEMASQBPAFYAWgBeAGIAZgBqAG4AdgB6AH4AggCGAIoAjgGhsluPkBESObBbELAM0LBbELAa0LBbELAc0LBbELAx0LBbELA80LBbELA+0LBbELBG0LBbELBK0LBbELBS0LBbELBX0LBbELBh0LBbELBj0LBbELBp0LBbELBt0LBbELBw0LBbELB60LBbELB+0LBbELCC0LBbELCE0LBbELCI0LBbELCM0ACwPS+wAEVYsEYvG7FGHz5Zsn86Ayuyd4IDK7J7egMrskl+AyuyiU4DK7KFiAMrso2EAyuyQYwDK7IKPUYREjmwCi+wA9CwAy+wDtCwDi+wChCwD9CwDy+ybw4PERI5fLBvLxiyUAsKK1gh2Bv0WbIVUG8REjmwChCyHgsKK1gh2Bv0WbADELIlCworWCHYG/RZsA8QsCnQsCkvsA4QsC7QsC4vsjQLCitYIdgb9FmwPRCwa9CwZ9CwY9CwPtCyPwwKK1gh2Bv0WbBl0LBp0LBt0LA80LBGELJHDAorWCHYG/RZsF/QsFvQsFfQsErQsEYQsGDQsFzQsFjQsEvQsA4QslELCitYIdgb9FmwDxCydgsKK1gh2Bv0WTAxAQYGJyYmNzc2NhcWFgcTExcWBwYGBxYVFAYHATYmJyYGBwcGFhcWNjcBMwMGBiMGJicXBjcyNjcBEzMHMwchNzM3MwMBEyEHIwclNyEDIzcBBzM2NzYnATchByE3IQchNyEHEzchByE3IQchNyEHATc2NzYvAgEjNzM3IzczAyM3MyUjNzM3IzczAyM3MwMPCohgYXQECAiFZV11AgxgqL8DAiY4T21g/rUHNzo/VQsPBzg7P1QLA9BjOwhpT1NnAlgEVi06CflkN28kvxQE/xTAJG03+bUyAS0Uvh4F2xQBLzNtHvvoHm1uEg1RAUgVARAV/W0VAQ8V/W4VAQ4VzBQBDxT9bhQBDhT9bxQBDRQBV1Z6EApAI2D8znAtbxVvLHCvcC1vBwBtLG4UbSxur24tbQHUZnkCAn1ecGB+AgJ4Yv64AiUBBoknOCAdWElWAwFMQFACAlRDcUBRAgJRRQFP/oVNXQFTVQJfAjkq/MkBO8pxccr+xQYfAR10qal0/uOp/LapBVVHBwNLdHR0dHR0+ThxcXFxcXEDwgEGUTYIAwL+0fx++vwV+X78fvr8FfkAAAUAXP3VB9cIcwADABwAIAAkACgATACwIS+wJS+wANCwAC+wIRCwAtCwAi+yIAIAERI5sCAvsB3QsB0vsATQsAQvsg0AAhESObANL7AU0LAUL7IHBBQREjmyGRQEERI5MDEJAwU0Njc2NjU0JiMiBgczNjYzMhYVFAcGBhUXIxUzAzMVIwMzFSMEGAO//EH8RAQPHiRKXKeVkKACywI6Kzk4XVsvysrKSwQEAgQEBlL8MfwxA8/xOjoYJ4dKgJeLfzM0QDRfPEFcTFuq/UwECp4EAAP/1wAAA58EjQADAAcACwBesgQMDRESObAEELAA0LAEELAI0ACwAEVYsAovG7EKHT5ZsABFWLAALxuxAA8+WbICAQorWCHYG/RZsgcKABESObAHL7IEAQorWCHYG/RZsAoQsggBCitYIdgb9FkwMSEhNyEDITchEyE3IQLU/QMjAv0S/ZAjAnB0/QMjAv3DATjEAQrEAAH/pwAAA+wEjQAIADiyBwkKERI5ALAARViwAi8bsQIdPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIHAgAREjkwMTMjATMTIQMnB5HqAnbt4v7/gwUiBI37cwNHXlEAAwA6/+oEYwSiAAMAFAAiAHGyGCMkERI5sBgQsALQsBgQsA3QALAARViwDS8bsQ0dPlmwAEVYsAQvG7EEDz5ZsgMNBBESOXywAy8YtGADcAMCXbQwA0ADAl2yAAEKK1gh2Bv0WbANELIYAQorWCHYG/RZsAQQsh8BCitYIdgb9FkwMQEhNyEBJiYCNzcSNzYXFhYSBwcCABMmJicmAgcXFhYXFhI3AxD+ZSMBm/7Jk9FeEQMhsaHkk85dEQQg/rmDBWximsAJAQVsYpfACwHfw/1OApUBBJ4cAR2omAUEkv78niH+7f65AvttgwQG/vzoR3GFBAYBAPAAAAL/pwAAA+wEjQADAAgAPLIFCQoREjmwBRCwAtAAsABFWLACLxuxAh0+WbAARViwAC8bsQAPPlmyBQACERI5sgcBCitYIdgb9FkwMSEhATMDJwcBIQPs+7sCdu2iBRz+rwHXBI3+ul5E/WIAAAEACgAAA98EjQAFADKyAQYHERI5ALAARViwBC8bsQQdPlmwAEVYsAIvG7ECDz5ZsAQQsgABCitYIdgb9FkwMQEhAyMTIQO8/eOo7coDCwPJ/DcEjQAAAQAtAAAEiASNABgAlbIAGRoREjkAsABFWLABLxuxAR0+WbAARViwGC8bsRgdPlmwAEVYsAwvG7EMDz5ZsgAMGBESObIJDAEREjmwCS+wBNCwBC9ADQ8EHwQvBD8ETwRfBAZdts8E3wTvBANdsgYCCitYIdgb9FmwCRCyCgIKK1gh2Bv0WbAO0LAJELAQ0LAQL7AGELAT0LAEELAW0LAWLzAxAQEhATMHJQcHJQchByM3ITcFNychNzMDMwIUAWMBEf5iyRv+6RoMATIa/tQm7Sf+0hoBKBID/tQb3NP2AnwCEf23kwMgLAKR2dmRATkPkwJJAAEAEQAABAkEogAfAGWyGyAhERI5ALAARViwFC8bsRQdPlmwAEVYsAYvG7EGDz5Zsh8GFBESObAfL7AP0LIOAgorWCHYG/RZsADQsAYQsgUBCitYIdgb9FmwCNCwFBCyGgEKK1gh2Bv0WbIXHxoREjkwMQElBgYHJQchNxc2PwIHNzM3NjYXFhYHJzYnJgYHByEDG/6YETs6Aokk/H8dCF0iDQOlHJYMGPG4rb0I7guPUmcNCgF2AeUBVJJAA8PCASWvRw4Fk2jT7wQE1rgBxgcChH5iAAABAA7/EwP/BXMAKwBvsh8sLRESOQCwAEVYsAkvG7EJHT5ZsABFWLAiLxuxIg8+WbIDIgkREjmwCRCwDNCwAxCyGQEKK1gh2Bv0WbAJELITAQorWCHYG/RZshAZExESObAiELAf0LAiELIpAQorWCHYG/RZsiUDKRESOTAxATYnJyYmNzY2NzczBxYWByc2JiciBgcGFxcWFgcGBgcHIzcmJjcXBhYzMjYCuxGPPMysBwnjsyydLZGjAusDZlVdewwRnT7IoQgJ2rQunC6kvATsBW5uYHsBOWovEjitfo60EdnfG7uKAVZXAVBDYDASPbOAjqsR4eMYx5QBXWJNAAEAFAAABDUGGAAKAEwAsABFWLADLxuxAyE+WbAARViwBi8bsQYbPlmwAEVYsAEvG7EBDz5ZsABFWLAJLxuxCQ8+WbIABgEREjmyBQYBERI5sggABRESOTAxAQMjATMDASEBASEBWFftAQ/tmgGKATX9+wFi/vUB9f4LBhj8kQGR/gH9xQAAAQAuAAAFZwWwAAsATACwAEVYsAMvG7EDHz5ZsABFWLAHLxuxBx8+WbAARViwAS8bsQEPPlmwAEVYsAovG7EKDz5ZsgADARESObIFAwEREjmyCQAFERI5MDEBAyMTMwM3ASEBASEBmXX2/PZ2AgJ4AUP9LwHl/uMCo/1dBbD9fQECgv0q/SYAAAEAFAAABEUGAAAMAFMAsABFWLAELxuxBCE+WbAARViwCC8bsQgbPlmwAEVYsAIvG7ECDz5ZsABFWLALLxuxCw8+WbIHCAIREjmwBy+yAAEKK1gh2Bv0WbIKAAcREjkwMQEjAyMBMwMzASEBASEBxXJS7QEL7JddAU8BJf5JARj+/QHZ/icGAPycAZ7+Bf3BAAEALgAABXsFsAAMAFgAsABFWLAELxuxBB8+WbAARViwCC8bsQgfPlmwAEVYsAIvG7ECDz5ZsABFWLALLxuxCw8+WbIGAgQREjmwBi+yHwYBcbIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBIQEBIQI+rmz2/PZqfQIKAT79mAGG/ugCcP2QBbD9nAJk/Tv9FQACAC7//wTwBbAAHgAnAGGyICgpERI5sCAQsB7QALAARViwAy8bsQMfPlmwAEVYsBUvG7EVDz5ZsABFWLABLxuxAQ8+WbIgAwEREjmwIC+yHgEKK1gh2Bv0WbIKHiAREjmwAxCyJwEKK1gh2Bv0WTAxAQMjEwUyFgcGBgcWFxYHBwYXFhcHByYnJjc3NicmJyUXMjY3NiYnJQGMaPb8Afbh7w8Ij5OUEQUGFAcEBCQC9SMFAwoSBgYUlP7w/4uiDg1paP7ZAlb9qgWwAdvCcKk9QKs0Nos3JD0pGwEsSixMeTAqjAnLAXdwam8EAQAAAgA7/+MEkQRUABIAIwBushkkJRESObAZELAK0ACwAEVYsAovG7EKGz5ZsABFWLAOLxuxDhs+WbAARViwAi8bsQIPPlmwAEVYsBIvG7ESDz5ZsgACChESObINCgIREjmwAhCyGAEKK1gh2Bv0WbAKELIgAQorWCHYG/RZMDElBicmJj8CNgAXFhYXNzMDEyMBBhcWFhcWNj8CJyYnJgYHAxCO46u5CQMIJwEGwW2gJ0TczBHT/jIGAgJcUmaiIAYBBBuPdZobxeIHBf/cLTn6ASoFA3Fmxf3T/fMB8jM5ZXUCA76cLkQ13AcFx8IAAAP/h/5HBFAEUAArADkARwCbsidISRESObAnELA50LAnELBE0ACwAEVYsCgvG7EoGz5ZsABFWLAWLxuxFhE+WbAoELAr0LArL7IAAworWCHYG/RZsgcWKBESObAHL7IOFgcREjmwDi+yLAEKK1gh2Bv0WbIbLA4REjmyIAcoERI5sBYQsjMBCitYIdgb9FmwBxCyPQEKK1gh2Bv0WbAoELJEAQorWCHYG/RZMDEBBxYHBwYEJyInBgcGFhcXFhYHBgYEJyYmNzY3Jjc2NjcmJjc3NjY3NxcXIQEmJwYHBhYzMjY3NiYnAwYWFzI2Nzc2JicmBgcENoMgCQQX/u26Q1IyBwYpOq2ztAcFl/7kh8/pBAfQIQYHVjtHQwUDEPW3KCpwAXX88DgeYw4JcWeFuA0JP1e/BmBQWIUNAwZgUFSIDgOgAVxeH6PHAhQyJyAiAwIGmINmomIDBY54pWYyPUllJjaYWCGWxQoBAxP73gMFO1k/SVtKMzgDAq1JYAJoThVNXwICZlQAAwEGBEcDVgaVAAMADgAZAE4AsA0vsBfQsBcvsgcJCitYIdgb9FmwAtCwAi+wANCwAC9ADw8AHwAvAD8ATwBfAG8AB12wAhCwA9AZsAMvGLANELIRCQorWCHYG/RZMDEBFwUnBzQ2MzIWFRQGIiY3FjMyNjc2JiMiBgJh9f7wpppuTUxibJhlYQNAJDoGBCQeJjcGlQHBAeZPa2hETWhiR1E3JCQxNAAAAQAKAAAEpASNAAcAP7IBCAkREjkAsABFWLAGLxuxBh0+WbAARViwBC8bsQQPPlmwAEVYsAEvG7EBDz5ZsAYQsgIBCitYIdgb9FkwMSEjEyEDIxMhA9nuqP4MqO3KA9ADyfw3BI0AAgAz//UCggMjABQAIQBnsggiIxESObAIELAc0ACwAEVYsAgvG7EIGT5ZsABFWLAPLxuxDw8+WbICDwgREjmwAi+2DwIfAi8CA12wDxCyEgIKK1gh2Bv0WbACELIVAgorWCHYG/RZsAgQshwCCitYIdgb9FkwMQEGIyImNzY2FxYWBwcGBCMnNzMWNicWNzc2JyYjIgYHBhYBsktMbXsEBrmAgYsJBRb+/NkVDQx3jkQ9OgwDAgtNNEwHBiwBNzmLc4GmAgSwkTTV3gGTAlSsAjZHGBlWVDoxQwADAAj/8gKAAyMAFAAgACwAirIXLS4REjmwFxCwEtCwFxCwJNAAsABFWLASLxuxEhk+WbAARViwCC8bsQgPPlmyKggSERI5sCovtt8q7yr/KgNdtg8qHyovKgNdtq8qvyrPKgNxshgCCitYIdgb9FmyAxgqERI5sg0qGBESObAIELIeAgorWCHYG/RZsBIQsiQCCitYIdgb9FkwMQEGBgcWBwYGJyYmNzY3Jjc2NhcWFgM2JiMiBgcGFjMyNhM2JiMiBgcGFjMyNgJ9A0BGZgQEr4Z/lgMDmlYEBKd6do/eBTMwMkwHBzYuL08vBSsmKkEHBi0mKkACSTlYKD5xcH8CAndkfE86ZGt+AgJ0/kUoLzgrKDI0AXwnKjEqJysyAAABACMAAAK7AxUABgAyALAARViwBS8bsQUZPlmwAEVYsAIvG7ECDz5ZsAUQsgQCCitYIdgb9FmyAAQFERI5MDEBASMBITchAqf+Sc0BuP5fGwJmAp/9YQJ/lgACABb/8gJzAyQAFAAhAFuyHSIjERI5sB0QsAfQALAARViwAC8bsQAZPlmwAEVYsA0vG7ENDz5ZsAAQsgICCitYIdgb9FmyBw0AERI5sAcvshUCCitYIdgb9FmwDRCyHAIKK1gh2Bv0WTAxAQcnJgYHNjMyFgcGBicmJjc3NjY3AyIHBwYXFjMyNjc2JgJEDgd0pTBQXWZ6BAS2g4iUCgcZ/smsTToFAwMKVjNSBgczAySbAQNba0WMc3ugAgKxjUXB4An+WD4kGxpaTjUyOwAAAQAK//ICkQMVABwAarIHHR4REjkAsABFWLACLxuxAhk+WbAARViwDS8bsQ0PPlmwAhCyAwIKK1gh2Bv0WbIHAg0REjmwBy+yGggKK1gh2Bv0WbIFBxoREjmwDRCyFAIKK1gh2Bv0WbIRFBoREjmyHBoUERI5MDETEyEHJQc2NzYWBwYGJyYmJxcWFjc2Njc2JiciBzh4AeEb/rk3OENtgwQEuIJ4mwSwBDMvPEgIBzY1QTUBgwGSlgGXGQIChHR+ngICgmYBLyQBAUk5NT8BJwAAAv/xAAACegMWAAoADgBJALAARViwCS8bsQkZPlmwAEVYsAQvG7EEDz5ZsgEJBBESObABL7ICAgorWCHYG/RZsAbQsAEQsAvQsggLBhESObINCQQREjkwMQE3ByMHIzchNwE3ATM3BwIWZBxcHLge/qUNAbC6/lOqMxIBOQGXo6OFAewC/iT1GAAAAf/0//MChQMkACQAb7ICJSYREjkAsABFWLANLxuxDRk+WbAARViwGC8bsRgPPlmyARgNERI5fLABLxiwDRCyBwIKK1gh2Bv0WbIJAQcREjmwARCyIwIKK1gh2Bv0WbITIwEREjmwGBCyHgIKK1gh2Bv0WbIbHiMREjkwMRMzNjY3NicnJgcHNjYXFhYHBgYHFgcGBicmJjUXFhcyNjc2JyPmUz1NBwlKF10cugmmfYGZBQNJUnYEA7yLfZmxBGo2UwcNeFwB0gI4LkMNAgJMAWl6AgN3YjtXJimBb4ICAoNtAVkCOC9ZBQAAAf/jAAACfgMkABcAWbIIGBkREjkAsABFWLAPLxuxDxk+WbAARViwAC8bsQAPPlmyFgIKK1gh2Bv0WbICFgAREjmyAw8AERI5sA8QsggCCitYIdgb9FmyDAAPERI5shUADxESOTAxISE3ATY3NiYnIgYHBzY2FxYWBwYPAgUCNv2tGAFWYQwHKyk6Qwy2Cq+Cf5IFBZZPnQFfhwEZU0MpLwFHNAF5mAICg2h+dzxuAgABAG0AAAINAxMABgAxALAARViwBS8bsQUZPlmwAEVYsAEvG7EBDz5ZsAUQsATQsAQvsgMCCitYIdgb9FkwMSEjEwc3JTMBi7VjzBsBbhcCNi+ZcwACABf/8AKMAyUADQAZAEayERobERI5sBEQsAfQALAARViwBy8bsQcZPlmwAEVYsAAvG7EADz5ZsAcQshECCitYIdgb9FmwABCyFwIKK1gh2Bv0WTAxBSYmNzc2NhcWFgcHBgYTNzQnJg8CFBcWNwElhIoLEBOyiISJCw8SsR0CVnYXFgJZdhcMBLCWj6iwBASylo+msAHzN28DA7WwMG8DB8MAAAH/2QAABAcEjQAMAEuyAA0OERI5ALAARViwCC8bsQgdPlmwAEVYsAMvG7EDDz5ZsgEBCitYIdgb9FmyBQEDERI5sAgQsgoBCitYIdgb9FmyBwoIERI5MDEBASEHITcBAzchByETAnv+swJWI/x4HQGC7RkDYyP9w9UCRP6AxKQBtwGmjMT+kAADAEMAAAU3BI4AEQAXAB0AbLIQHh8REjmwEBCwFdCwEBCwG9AAsABFWLAQLxuxEB0+WbAARViwBy8bsQcPPlmyDxAHERI5sA8vsADQsgYHEBESObAGL7AJ0LIUAQorWCHYG/RZsA8QshUBCitYIdgb9FmwGtCwFBCwG9AwMQEWFgcGAAcHIzcmJjc2JDc3FwEGFxMGBgU2JwM2NgN+0OkPEP7K+RjuGdHoDxABOPcb7f2kH/Jqj54C7xvta4ujBBMU9bzR/wAQbW4T+sHP/A55Af2v7yICLhCTZ+ch/dIPlwAAAQBwAAAFUQSNABkAXLIYGhsREjkAsABFWLAELxuxBB0+WbAARViwEC8bsRAdPlmwAEVYsBgvG7EYHT5ZsABFWLAKLxuxCg8+WbIXBAoREjmwFy+wANCwFxCyDAEKK1gh2Bv0WbAJ0DAxATY2NxMzAwYABwMjEyYCNxMzAwYHBhYXEzMDAXqZHDPuNSn+3eQ37jjLxB4y7TIIAQNRVH7tAdoauaoBNv7F/P7bGP7nARkdATnvAS/+0Dk8aYoYArAAAQAAAAAEeAShACQAWbIAJSYREjkAsABFWLAaLxuxGh0+WbAARViwEC8bsRAPPlmwAEVYsCMvG7EjDz5ZsiEBCitYIdgb9FmwANCwGhCyCAEKK1gh2Bv0WbAAELAP0LAhELAS0DAxJTY2NzYnJiYnJgYGBxcWFwchNzcmNzc+AhceAgcHAgc3ByECTnyVGQwGDG9gaaBUAwEMkh7+PCSpgRcFEqX+k43UZw0FI+C0I/48xyXIsWg8YmsDA23QtyTDOMnEArf6K5LufwQDg+iPK/7nnATEAAEAkwKHAzwDMQADABEAsAIvsgEBCitYIdgb9FkwMQEhNyEDHv11HgKLAoeqAAABAIwAAAYeBI0ADABZALAARViwAS8bsQEdPlmwAEVYsAgvG7EIHT5ZsABFWLALLxuxCx0+WbAARViwAy8bsQMPPlmwAEVYsAYvG7EGDz5ZsgABAxESObIFAQMREjmyCgEDERI5MDEBATMBIwMBIwMzEwEzA/IBQOz+JOVA/pzmR+AUAWfRAS4DX/tzAz78wgSN/KEDXwABAHAAAAS4BI4ACAAxALAARViwAy8bsQMdPlmwAEVYsAcvG7EHHT5ZsABFWLAFLxuxBQ8+WbIBAwUREjkwMQEXNwEhASMDNwHkBSMBqAEE/Ynw4eoBOEpTA0z7cwSNAQABADn/6wRqBI0AEQA8sg4SExESOQCwAEVYsAAvG7EAHT5ZsABFWLAILxuxCB0+WbAARViwBC8bsQQPPlmyDQEKK1gh2Bv0WTAxAQMGBCcmJjcTMwMGFhcWNjcTBGqAG/7l0sngFIHsggtbZ2uOEoMEjf0BwuEEBOW1AwD8/2VyAwRvaQMHAAEAYgAABFoEjQAHAC4AsABFWLAGLxuxBh0+WbAARViwAi8bsQIPPlmwBhCyAAEKK1gh2Bv0WbAE0DAxASEDIxMhNyEEN/6KqO2o/o4jA9UDyfw3A8nEAAABAA7/7QP/BJ8AJgBtshEnKBESOQCwAEVYsAkvG7EJHT5ZsABFWLAcLxuxHA8+WbICHAkREjmyDAkcERI5sgwMAV2wCRCyEAEKK1gh2Bv0WbACELIVAQorWCHYG/RZsiAJHBESObIDIAFdsBwQsiQBCitYIdgb9FkwMQE2LwImNzYkFxYWByc2JiciBgcGBBcWBw4CJyYnJjcXBhYzMjYCuxGPdkf9DQkBC7+84ALrA2dUXXsMEQE9RsQKB3/YgJ5ypgTsBW1uYXsBOWovJBpk1Ju8AgXCogFWVgFQQ2FdJWfGbJdPAwJHaMgBXWJNAAACAAoAAAQWBI0ADQAVAF6yABYXERI5sA/QALAARViwBC8bsQQdPlmwAEVYsAIvG7ECDz5ZsABFWLAMLxuxDA8+WbIPBAIREjmwDy+yAAEKK1gh2Bv0WbIKAA8REjmwBBCyFQEKK1gh2Bv0WTAxASMDIxMFFhYHBgUTFSMBFzY2NzYnJwIf3krtygGsxdEKD/8Aufz+qMNohgwWutwBqf5XBI0BBbeb8GH+KQ0CawICYFWfCQEAAAIAN/8wBGAEowATACIARrIDIyQREjmwAxCwH9AAsABFWLANLxuxDR0+WbAARViwBS8bsQUPPlmwDRCyFwEKK1gh2Bv0WbAFELIeAQorWCHYG/RZMDElFwcnBiMmJgI3NxIAFxYWEgcHAgMmJicmAgcVFhYXFjY3NgMqr6XdOiiRz14RAyABSe2Tz10RBy6yB2ximb8KBWxigLQfFkyefsgHApUBBp4bAREBSwYEkv75oTr+vwICb4AEBv785khxhgQFt6p3AAIACgAABDYEjQAKABMATbIEFBUREjmwBBCwDNAAsABFWLADLxuxAx0+WbAARViwAS8bsQEPPlmyCwEDERI5sAsvsgABCitYIdgb9FmwAxCyEgEKK1gh2Bv0WTAxAQMjEwUWFgcGBCMnFzI2NzYmJycBPkftygHIvN4LCv7t19fda4wMC1xY+AGZ/mcEjQEE0KWvzMUBYFVSYQQBAAIAOv/qBGMEoQAQACAARrIeISIREjmwHhCwCNAAsABFWLAJLxuxCR0+WbAARViwAC8bsQAPPlmwCRCyFgEKK1gh2Bv0WbAAELIdAQorWCHYG/RZMDEFJiYCNzc2EjYXFhYSBwcCABM2JyYmJyYCBxcWFhcWNjcB+5PRXREJGKX8mJPOXREDIP65fgYDBWtimsAJAQVtYYe4GRAElQEDnUOlAQWLBASS/vucHP7p/rcCfj1AboIEBv765UhxhQQFzr8AAQAKAAAEqASNAAkARQCwAEVYsAUvG7EFHT5ZsABFWLAILxuxCB0+WbAARViwAC8bsQAPPlmwAEVYsAMvG7EDDz5ZsgIFABESObIHBQAREjkwMSEjAQMjEzMBEzMD3uT+iYztyuUBd4zsAyX82wSN/NoDJgABAAoAAAXIBI0ADgBgsgEPEBESOQCwAEVYsAAvG7EAHT5ZsABFWLACLxuxAh0+WbAARViwBC8bsQQPPlmwAEVYsAgvG7EIDz5ZsABFWLAMLxuxDA8+WbIBAAQREjmyBwAEERI5sgoABBESOTAxARMBIQMjExMBIwsCIxMCA7QB1QE8y+w5dP4dpb5NNezKBI38twNJ+3MBSAIX/KEDfP2y/tIEjQAAAQAKAAADNASNAAUAKACwAEVYsAQvG7EEHT5ZsABFWLACLxuxAg8+WbIAAQorWCHYG/RZMDElIQchEzMBGQIbI/z5yu3CwgSNAAABAAoAAASdBI0ADABLALAARViwBC8bsQQdPlmwAEVYsAgvG7EIHT5ZsABFWLACLxuxAg8+WbAARViwCy8bsQsPPlmyBgIEERI5sAYQsAHQsgoBBhESOTAxAQcDIxMzAzcBIQEBIQHVpDrtyu1XfAGAATf96gFQ/vYB2Yv+sgSN/gt+AXf97P2HAAAB//L/6wOwBI0ADgAvsgUPEBESOQCwAEVYsAAvG7EAHT5ZsABFWLAFLxuxBQ8+WbILAQorWCHYG/RZMDEBMwMGBicmJjcXBhcWNjcCw+2GGfettcYG7QmfSmgPBI384LPPBATDqgGrBAJjWwABABgAAAHPBI0AAwAdALAARViwAi8bsQIdPlmwAEVYsAAvG7EADz5ZMDEhIxMzAQXty+wEjQABAAoAAASpBI0ACwCGALAARViwBi8bsQYdPlmwAEVYsAovG7EKHT5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmyCQYAERI5sAkvtK8JvwkCXbI/CQFxss8JAXGyPwkBcrL/CQFxsg8JAXK0bwl/CQJxtN8J7wkCXbJfCQFytBwJLAkCXbICAQorWCHYG/RZMDEhIxMhAyMTMwMhEzMD3+1S/gZT7crtVgH7Vu0B2/4lBI3+EQHvAAABAD//8ARRBKMAIABksgIhIhESOQCwAEVYsAsvG7ELHT5ZsABFWLADLxuxAw8+WbIfCwMREjmwHy+wCxCyEQEKK1gh2Bv0WbIPHxEREjmyDA8BXbADELIaAQorWCHYG/RZsB8Qsh0BCitYIdgb9FkwMSUGBQcuAjc3EgAXFhYXJyYnJgYHBwYXFhYXFjc3IzchA+d//to6ldRgEQYfAUHtwd0Q5BK9hrUbDAcFCHRmh1oo8yAB3ZKUDQECkP+eNwERATwGBMm4AbwGBbuqWkFBbnsDAjrIsQABAAoAAAPmBI0ACQBFALAARViwBC8bsQQdPlmwAEVYsAIvG7ECDz5ZsgkEAhESObAJL7JKCQFdsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASEDIxMhByEDIQMs/h5T7coDEiP93DQB5AHb/iUEjcT+1QAAAQAKAAAD+QSNAAsAUwCwAEVYsAYvG7EGHT5ZsABFWLAELxuxBA8+WbILBgQREjmwCy+ySQsBXbIAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASEDIQchEyEHIQMhAzX+GjYCOyP82coDJSP9yS8B6AH4/srCBI3E/vIAAgAKAAAEGgSNAAoAFgBDsg4XGBESObAOELAC0ACwAEVYsAIvG7ECHT5ZsABFWLAALxuxAA8+WbINAQorWCHYG/RZsAIQshYBCitYIdgb9FkwMTMTBR4CBwcGACETAxcyNjc3NicmJicKygFil+FsEAUd/qH+9x+GcKnPGAYIBgp5bgSNAQSP/Zks/f7GA8n8+QHBtSxHQGhyBAAAAQA5/+wESQSjABwATrITHR4REjkAsABFWLALLxuxCx0+WbAARViwAy8bsQMPPlmyAAsDERI5sg4LAxESObALELISAQorWCHYG/RZsAMQshoBCitYIdgb9FkwMQEGBCcuAjc3EgAXFhYXJyYmJyYGBwYXFBYXFjcD/Bz+39SQyVkSBiABQenC4grrA2BrhbAaEAFkYeM4AYW93AQCkP+fNAEOAUEGBN29AWdwBAXAtIk/cH8ECNoAAAMACgAABAAEjQAOABYAHgCsshgfIBESObAYELAC0LAYELAW0ACwAEVYsAEvG7EBHT5ZsABFWLAALxuxAA8+WbIYAAEREjmwGC+yvxgBcrSvGL8YAl20bxh/GAJxsv8YAXGyDxgBcrSPGJ8YAnKyXxgBcrLPGAFxsj8YAXG0HxgvGAJdsnkYAV2ySRgBXbIWAQorWCHYG/RZsggWGBESObAAELIRAQorWCHYG/RZsAEQsh4BCitYIdgb9FkwMTMTBQQXFgcGBxYWBwYGIwMDFzY2NzYnJxc2Njc2JycKygGUASZUHgYKz0tUBAj33pA2z2V6DBam18FfcgwUss0EjQEIpDlTrFcaiFmksgH7/scBA1JJkgmrAQNPRYgFAQAC/5sAAAQFBI0ABwAKAEYAsABFWLAELxuxBB0+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsgkEAhESObAJL7IAAQorWCHYG/RZsgoEAhESOTAxJSEHIwEzEyMBIQMC7v4uiPkCk9r95v5iAUhX+fkEjftzAbIBuAAAAQDrBGkCNgYtAAcAFgCwAEVYsAAvG7EAIT5ZsATQsAQvMDEBFwYHByM3NgG1gVEWFs4RHwYtV312enfXAAACAQQE0QN6Bn4ACwAPAFoAsAMvsAbQsAYvQAsPBh8GLwY/Bk8GBV2wANCwAC+wAxCyCQYKK1gh2Bv0WbAGELAP0LAPL7AM0LAML0APDwwfDC8MPwxPDF8MbwwHXbAPELAO0BmwDi8YMDEBBgYnJiYnFwYXFjclMxcjA3oItYyLoAKqBICGG/7Rok5tBbFoeAMDeGQCbwICc83AAAACANwE5wUtBpAABgAKAFsAsAMvsAXQsAUvsADQsAAvQAkPAB8ALwA/AARdsAMQsALQGbACLxiyBAMAERI5sAbQGbAGLxiwAxCwCdCwCS+wB9CwBy+2DwcfBy8HA12wCRCwCtAZsAovGDAxATMXIycHIwEXASMCIp3wuYKy5gNp6P8AqgXh+o2NAakB/vYAAgATBNoDqAaDAAYACgBbALADL7AE0BmwBC8YsADQGbAALxiwAxCwAdCwAS+wBtCwBi9ACQ8GHwYvBj8GBF2yAgMGERI5sAMQsAjQsAgvsAfQGbAHLxiwCBCwCtCwCi+2DwofCi8KA10wMQEjJwcjJTMFIwMzA6i7gbLlAUad/oeKoscE2o2N+lwBCwACANgE5wSUBssABgAVAGgAsAMvsATQGbAELxiwANAZsAAvGLADELAB0LABL7ADELAF0LAFL0AJDwUfBS8FPwUEXbICAwUREjmwAxCwB9CwBy+wDtCwDi+yPw4BXbIIBw4REjmyDwYKK1gh2Bv0WbIUCAcREjkwMQEjJwcnJTMXNzc2NzYnJzcWFgcGBwcDqqeRydEBObaoCyJaBwdNKg93gQEDiAkE56GhAfl0fQMKMy8GAmoDU0hrGT0AAAIA1wTnA6kG0AAGABoAjgCwAy+wBNAZsAQvGLAA0BmwAC8YsAMQsAHQsAEvsAMQsAXQsAUvQAkPBR8FLwU/BQRdsgIDBRESObAK0LAKL0AJPwpPCl8KbwoEXbAO0LAOL0ANDw4fDi8OPw5PDl8OBl2wChCwENCwEC+wDhCyFAYKK1gh2Bv0WbAKELIYBgorWCHYG/RZsBQQsBrQMDEBIycHIyUzNwYGIyImJgcGByc2NjMyFhY3NjcDqaWVxdMBS4/mCVU7I24kEjMgWgpTPCFzIRI5HATnjY3t30RbPQkCA0MYSFo+CAEERQAAAgEEBNADegZ+AAwAEABaALADL7AG0LAGL0ALDwYfBi8GPwZPBgVdsADQsAAvsAMQsgkGCitYIdgb9FmwBhCwD9CwDy+wDdCwDS9ADw8NHw0vDT8NTw1fDW8NB12wDxCwENAZsBAvGDAxAQYGJyYmJxcGFxY2NycXByMDegi1jIugAqoEgDpZDkDDxo8FsGh4AwN4ZAJvAgE3O84BvgACAQUE0gNuBwgADAAbAF0AsAMvsAbQsAYvQAsPBh8GLwY/Bk8GBV2wANCwAC+wAxCyCQYKK1gh2Bv0WbAGELAb0LAbL7AU0LAUL7Q/FE8UAl2yDhsUERI5shUMCitYIdgb9FmyGg4bERI5MDEBBgYnJiYnFwYXFjY3Jzc3Njc2Jyc3FxYVBgcHA24JsYiDogKmBH46WA7QCjBXCQlfKg1I2AOXCQWxa3QCAnZmAmwCATU6GXYCBjArBAFhBBN4XRg8AAIBBATNA4IG2wALACAAdgCwAy+wBtCwBi9ACw8GHwYvBj8GTwYFXbAA0LAAL7ADELIJBgorWCHYG/RZsAAQsBDQsBAvsBPQsBMvQAsPEx8TLxM/E08TBV2wEBCwFdCwFS+wExCyGQgKK1gh2Bv0WbAQELIeCAorWCHYG/RZsBkQsCDQMDEBBgYnJiYnFwYXFjcTBgcGByImBwYHJzY2MzIWFxY3NjcDcQiyi4WhAqgEfYUbvQosLkYoiSg7H2YJXkYWJy9GKDwfBbBreAICe2YCbgICcgERVDIzAk4DA1QbUGsNGicDA1MAAAH/pAAABIAEjQALAFMAsABFWLABLxuxAR0+WbAARViwCi8bsQodPlmwAEVYsAQvG7EEDz5ZsABFWLAHLxuxBw8+WbIAAQQREjmyBgEEERI5sgMABhESObIJBgAREjkwMQEBIQEBIQMBIQEBIQIrATEBJP4lARX+97D+x/7cAeb+/AEEAvsBkv2y/cEBmP5oAlcCNgABAG0AAASABI0ACAAxALAARViwAS8bsQEdPlmwAEVYsAcvG7EHHT5ZsABFWLAELxuxBA8+WbIAAQQREjkwMQEBIQEDIxMBMwIMAWIBEv3cROxL/vb3AnwCEfz6/nkBrgLfAAEAOf/sBEkEowAeAISyHB8gERI5ALAARViwCy8bsQsdPlmwAEVYsAMvG7EDDz5ZsgALAxESObIOCwMREjmwCxCyEgEKK1gh2Bv0WbIVCwMREjl8sBUvGLLwFQFdsgAVAXG0MBVAFQJdtIAVkBUCcbRgFXAVAl2yFgEKK1gh2Bv0WbADELIcAQorWCHYG/RZMDEBBgQnLgI3NxIAFxYWFycmJicmAyEHIQYXFhYXFjcD/Bz+39SQyVkSBiABQerB4grrA2Br7VwBfSL+kgYFB2VX4zkBhb3cBAKQ/580AQ4BQQYE3b0BZ3AEB/7HxDg2W2gDCNoAAAEAYv/rBQ0EjQAXAGuyBRgZERI5ALAARViwAi8bsQIdPlmwAEVYsBYvG7EWDz5ZsABFWLAOLxuxDg8+WbACELIAAQorWCHYG/RZsATQsAXQsggCFhESObAIL7AOELIPBworWCHYG/RZsAgQshMBCitYIdgb9FkwMQEhNyEHIQc2FxYWBwYEBzc2NzYnJgcDIwGy/rAjA5Ij/qwyhIjA0wwO/vbyFPAZGs5nn2PtA8nExO8pAwLVubzHAr0FwcoGAyf95gABAFUAAARiBbAABgAyALAARViwBS8bsQUfPlmwAEVYsAEvG7EBDz5ZsAUQsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITchBEj9B/oC9/1eIgOWBRz65ATtwwACACr+UARMBFEAHAAqAHyyBCssERI5sAQQsCfQALAARViwBy8bsQcbPlmwAEVYsAQvG7EEGz5ZsABFWLAMLxuxDBE+WbAARViwFi8bsRYPPlmyBgcWERI5sAwQshEBCitYIdgb9FmyFAcWERI5sBYQsiIBCitYIdgb9FmwBBCyJwEKK1gh2Bv0WTAxEzYSNhcWFzczAwYAJyYnNxYXBBM3BicuAicmNxcGFxYWFxY3EyYnJgYHRBOU14G2WirPqiL+1+Sum0JzjAEFSgd+oGWdXAYEBu4GBAViVYpkVTSGfqwXAh+jAQyDAwSDc/wZ8f7uBARZsk0CBwE8G3wEAWjDdj89ATU7Z30DBYUB23cEA8amAAAB/wf+RgE/AM0ADAAsALANL7AARViwBC8bsQQRPlmyCQEKK1gh2Bv0WbANELIMBQorWCHYG/RZMDElAwYGJyYnNxYzMjcTAT8qGNCiREAiOSZ+ICvN/vS0xwICEsUPrwEMAAH/sv6aAP4AtQADABIAsAQvsALQsAIvsAHQsAEvMDETIxMzoO5e7v6aAhv////WAAAEJwYjAiYEqQAAAQYBaEseABMAsABFWLAHLxuxBx0+WbAP3DAxAAAC/8H//wbEBI0AGAAhAGuyBSIjERI5sAUQsBrQALAARViwEy8bsRMdPlmwAEVYsAMvG7EDDz5ZsABFWLALLxuxCw8+WbATELIFAQorWCHYG/RZshYTAxESObAWL7ADELIbAQorWCHYG/RZsBYQsiEBCitYIdgb9FkwMQEGBCMhEyEDBwIGJyM3NzY2NzcTIQMXFhYlAxc2Njc2JicGuQv+7dr+Hqn+sEQZO+e6PhgiZnwfD2gDJEbHxub9a0HcZo8NC1hZAYev2APJ/rZ//uztAcwBBqTAXAH6/mwBAcoI/o4BAmtaTFoFAAACAAoAAAbHBI0AEgAbAIGyAhwdERI5sAIQsBTQALAARViwAi8bsQIdPlmwAEVYsBEvG7ERHT5ZsABFWLALLxuxCw8+WbAARViwDy8bsQ8PPlmyAQILERI5sAEvsAIQsRsKK1jYG9xZsgUBCitYIdgb9FmwARCyDQEKK1gh2Bv0WbALELIVAQorWCHYG/RZMDEBIRMzAxcWFgcGBCMhEyEDIxMzAQMXNjY3NiYnAWsB7FbuR8nF5QsL/u3Y/h1T/hRT7crtAnJB3GiNDQtYWQKeAe/+bAEByqav2AHb/iUEjf2o/o4BAmtaTFoFAAEAYgAABQ4EjQAWAFqyBRcYERI5ALAARViwAi8bsQIdPlmwAEVYsAwvG7EMDz5ZsABFWLAVLxuxFQ8+WbACELIAAQorWCHYG/RZsATQsAXQsggCDBESObAIL7ISAQorWCHYG/RZMDEBITchByEHNhcWFgcDIxM2JyYnJgcDIwGy/rAjA5Ij/qwygYrJzBQ47TkGBRObbJtj7QPJxMTuJwIE4ML+pgFbNCl/BgMm/eYAAQAK/p8EowSNAAsAT7IDDA0REjkAsAIvsABFWLAGLxuxBh0+WbAARViwCi8bsQodPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIIAQorWCHYG/RZsAnQMDEhIQMjEyETMwMhEzMD2P6WPu0+/onK7agB9Kju/p8BYQSN/DYDygAAAgAL//wD9wSNAA0AFgBeshQXGBESObAUELAJ0ACwAEVYsAwvG7EMHT5ZsABFWLALLxuxCw8+WbAMELIAAQorWCHYG/RZsgMMCxESObADL7ALELIOAQorWCHYG/RZsAMQshQBCitYIdgb9FkwMQEhBxcWFgcOAiclEyEBNjY3NCYnJwMD1f3JJ/nAxRUQkueF/jnLAyH+GWh8Amlc3D4Dy+ABBcOid7FcAwEEjfw1AmZXTFcCAf6cAAL/g/6vBMAEjQAOABQAVrISFRYREjmwEhCwCdAAsABFWLAELxuxBB0+WbAARViwCi8bsQoPPlmyAAEKK1gh2Bv0WbEMCitY2BvcWbAI0LIPBAoREjmwBBCyEQEKK1gh2Bv0WTAxNzY2NxMhAzMDIxMhAyMTBSUTIQMCMW+DJFIDJ6mSXO07/RA77V0BZwHjhv6uQEHAZf3FAab8Nv3sAVH+rwITAwQDBv64/twAAAH/qQAABjsEjQAVAJ6yARYXERI5ALAARViwES8bsREdPlmwAEVYsA4vG7EOHT5ZsABFWLAKLxuxCh0+WbAARViwBi8bsQYPPlmwAEVYsAMvG7EDDz5ZsABFWLAVLxuxFQ8+WbIMAw4REjmwDC+yPwwBcbJfDAFyss8MAXG0rwy/DAJdtI8MnwwCcrAP0LIBAQorWCHYG/RZsATQsggPBBESObITAQ8REjkwMQEjAyMTIwEhAQMhEzMTMwMzASEBEyEDymZR7VJV/rr+zAHDywEJnFdT7lRJAUQBJP5h5v7uAdX+KwHV/isCYQIs/iAB4P4gAeD9w/2wAAABAAz/7gPvBKAAJgBBsiAnKBESOQCwAC+wAEVYsBgvG7EYDz5ZsgkAGBESObIMABgREjmyHwEKK1gh2Bv0WbAAELIkBworWCHYG/RZMDEBMjY3NiYiBgcHNjYXFhYHBgcWFgcOAicmJjczFhYzFjY3NicnNwIFZoAKCmWwag/uDP3Cw94ICulRWgQFfOyLud4E6gJcVmqQDBXchyACqlNNRExFPgGYsgIDpo21ZSOGWWqdVwICuZxHTANZT6ABAbAAAAEACwAABK4EjQAJAEyyAAoLERI5ALAARViwAC8bsQAdPlmwAEVYsAgvG7EIHT5ZsABFWLAFLxuxBQ8+WbAARViwAy8bsQMPPlmyBAMAERI5sgkFCBESOTAxATMDIxMBIxMzAwPL48vqj/1m48vqjwSN+3MDMfzPBI380gABAAoAAARtBI0ADAB3sgANDhESOQCwAEVYsAgvG7EIHT5ZsABFWLAFLxuxBR0+WbAARViwAi8bsQIPPlmwAEVYsAwvG7EMDz5ZsgYCBRESObAGL7I/BgFxsl8GAXKyzwYBcbSvBr8GAl20jwafBgJysgEBCitYIdgb9FmyCgEGERI5MDEBIwMjEzMDMwEhAQEhAbZtUu3K7VRXAYMBJv4QATP+6QHV/isEjf4gAeD9uf26AAAB/8EAAASXBI0AEQA/sgQSExESOQCwAEVYsAAvG7EAHT5ZsABFWLABLxuxAQ8+WbAARViwCS8bsQkPPlmwABCyAwEKK1gh2Bv0WTAxAQMjEyEDBwIGByM3NzY2NzcTBJfK7qn+sUYZPOK0RxgkZ3scD2kEjftzA8n+tn3+7e0CzAMKqbhZAfoAAQBy/+gEggSOAA8ATrIBEBEREjkAsAcvsABFWLAPLxuxDx0+WbAARViwCC8bsQgPPlmyAQ8IERI5sgIPCBESObACL7AIELEKCitY2BvcWbIODwgREjmwDi8wMQEXASEBBgYjJzcXNjY3AzcCEAcBXAEP/d1csnRrEVI6TiP69QJKOAJ7/HSjdgXEBgE6KwN8AQABAAr+rwS4BI0ACwBCsgkMDRESOQCwAy+wAEVYsAcvG7EHHT5ZsABFWLAKLxuxCh0+WbAARViwBS8bsQUPPlmyCAEKK1gh2Bv0WbAA0DAxJTMDIxMhEzMDIRMzA/u9cNg7/F/K7agB9Kjvw/3sAVEEjfw2A8oAAQBdAAAEZASNABIARrIOExQREjkAsABFWLAILxuxCB0+WbAARViwES8bsREdPlmwAEVYsAAvG7EADz5Zsg4IABESObAOL7IEAQorWCHYG/RZMDEhIxMGJyYmNxMzAwYXFhcWNxMzA5ruUn9/0NMVOO46BgYTm2+YZO0BqycCAuDEAWH+njQpgAMDJQIgAAEACgAABkMEjQALAEGyBwwNERI5ALAARViwAy8bsQMdPlmwAEVYsAEvG7EBDz5ZsgQBCitYIdgb9FmwAxCwBtCwBBCwCNCwBhCwCtAwMSEhEzMDIRMzAyETMwV4+pLK7agBU6juqQFUqO4Ejfw2A8r8NgPKAAABAAr+rwZYBI0ADwBBsgsQERESOQCwAy+wAEVYsAcvG7EHHT5ZsABFWLAELxuxBA8+WbIAAQorWCHYG/RZsA3QsAnQsAcQsArQsA7QMDElMwMjEyETMwMhEzMDIRMzBZu9cNg7+r/K7agBU6juqQFUqO/D/ewBUQSN/DYDyvw2A8oAAgBK//sE4wSNAAwAFQBesgsWFxESObALELAU0ACwAEVYsAovG7EKHT5ZsABFWLAHLxuxBw8+WbIACgcREjmwAC+wChCyCAEKK1gh2Bv0WbAHELINAQorWCHYG/RZsAAQshMBCitYIdgb9FkwMQEWFgcGBCclEyE3IQMTNjY3NiYnJwMDXrvKFhj+1cz+OKj+rCMCPkaXZX8CAm1Y20EC+AXKorPZBAEDycT+bP3JAmtZTlwCAf6O//8AC//7BeEEjQAmBBEAAAAHA+QEEgAAAAIAC//7A/cEjQAKABMAT7IRFBUREjmwERCwANAAsABFWLAILxuxCB0+WbAARViwBy8bsQcPPlmwCBCxEQorWNgb3FmyAAEKK1gh2Bv0WbAHELILAQorWCHYG/RZMDEBFhYHBgQnJRMzAxM2Njc2JicnAwJyu8oWGP7Vy/44y+pHl2OCAgJsWttBAvgFyaOz2QQBBI3+bP3JAmtZTV0CAf6OAAEAE//qBB4EoQAdAIGyCx4fERI5ALAARViwEi8bsRIdPlmwAEVYsBovG7EaDz5ZsgAaEhESObIDAQorWCHYG/RZsggSGhESOXywCC8YtGAIcAgCXbQwCEAIAl2y8AgBXbIACAFxtIAIkAgCcbIFAQorWCHYG/RZsBIQsgsBCitYIdgb9FmyDxIaERI5MDETFhYXFhMhNyE2JicmBgcHNiQXFhIPAgIAJyYmJ/0FZWzuVv6CIwFuDWltcYwa7iABINDK6AgEBiH+w+fD6QgBhWpnAwcBO8SPoAMEc2oBvuIEA/7r4zcz/vD+wgYE2LkAAAIACv/rBiIEogAWACMAlrIBJCUREjmwARCwH9AAsABFWLAOLxuxDh0+WbAARViwCS8bsQkdPlmwAEVYsAYvG7EGDz5ZsABFWLAALxuxAA8+WbIKBgkREjl8sAovGLRgCnAKAl2y8AoBXbIACgFxtDAKQAoCXbSACpAKAnGyBQEKK1gh2Bv0WbAOELIaAQorWCHYG/RZsAAQsiABCitYIdgb9FkwMQUuAjcHAyMTMwMzNgAXFhYSBwcGAgQTNCYnJgIHBhYXFhI3A7qHz2cLvlTsyuxVrEUBNdKUzl0RBBWg/v/Ta2mdxAIDa2ybvwgRBIPkiQH+HgSN/hj0AQkFBJP+/Z4ksv7wlALSiJAEBv7v94abBAYBDO4AAAL/0gAABFYEjgANABYAYbIRFxgREjmwERCwDNAAsABFWLAHLxuxBx0+WbAARViwAC8bsQAPPlmwAEVYsAkvG7EJDz5ZshIHABESObASL7ILAQorWCHYG/RZsgELEhESObAHELITAQorWCHYG/RZMDEjASYmNzYkMwUDIxMjARMGFhcXEyciBi4BclJSBgkBB88B0cruTuL+1LELVVHjOslfgwIPK5Fep74B+3MBvP5EAxtKTwIBAUoBWwAAAf/1AAAERASNAA0AULIBDg8REjkAsABFWLAILxuxCB0+WbAARViwAi8bsQIPPlmyBwIIERI5sAcvsgQHCitYIdgb9FmwAdCwCBCyCwEKK1gh2Bv0WbAHELAM0DAxASMDIxMjNzMTIQchAzMCgM9V7VTOHs1ZAwsj/eM20AHm/hoB5qoB/cT+xwAAAf+p/q8GOwSNABkAqrIIGhsREjkAsAMvsABFWLARLxuxER0+WbAARViwBS8bsQUPPlmwAEVYsAkvG7EJDz5ZsABFWLANLxuxDQ8+WbIXCREREjmwFy+yPxcBcbJfFwFyss8XAXG0rxe/FwJdtI8XnxcCcrIHAQorWCHYG/RZsgAHFxESObAFELIBAQorWCHYG/RZsAcQsAvQsg8XBxESObAXELAS0LARELAU0LAUL7AY0LAYLzAxARMzAyMTIwMjAyMTIwEhAQMhEzMTMwMzASEEnJvAXcs7n6VhUu1SVf66/swBw8sBCZxXU+5USQFEASQCUP5y/e0BUQHV/isB1f4rAmECLP4gAeD+IAHgAAABAAr+rwRtBI0AEACIsgAREhESOQCwBC+wAEVYsAwvG7EMHT5ZsABFWLAPLxuxDx0+WbAARViwCS8bsQkPPlmwAEVYsAYvG7EGDz5Zsg0JDBESObANL7I/DQFxsl8NAXKyzw0BcbSvDb8NAl20jw2fDQJysggBCitYIdgb9FmyAAgNERI5sAYQsgEBCitYIdgb9FkwMQETMwMjEyMDIwMjEzMDMwEhAn3Ny13LO4/jbVLtyu1UVwGDASYCRv58/e0BUQHV/isEjf4gAeAAAAEACgAABSQEjQAUAICyBRUWERI5ALAARViwFC8bsRQdPlmwAEVYsAYvG7EGHT5ZsABFWLARLxuxEQ8+WbAARViwCi8bsQoPPlmyABEUERI5sAAvsj8AAXGyXwABcrLPAAFxtK8AvwACXbSPAJ8AAnKwBNCwABCyEAEKK1gh2Bv0WbAM0LIIDAAREjkwMQEzNzMHNwEhAQEhAycHIzcjAyMTMwFpRCugLjIBgwEl/hABNP7q4j8poClEVu3K5gKr4OABAeH9uP27AdUBzM3+KQSNAAEAYgAABXIEjQAOAIWyCQ8QERI5ALAARViwBy8bsQcdPlmwAEVYsAovG7EKHT5ZsABFWLACLxuxAg8+WbAARViwDi8bsQ4PPlmyCAIHERI5sAgvsj8IAXGyXwgBcrLPCAFxtK8IvwgCXbSPCJ8IAnKyAQEKK1gh2Bv0WbAHELIEAQorWCHYG/RZsgwBCBESOTAxASMDIxMhNyEDMwEFAQEhArxtUu2o/qojAkJUVwGCASb+EQEz/ukB1f4rA8rD/iAB4AH9uf27AAACAED/6gV5BKkAJAAvAIKyAzAxERI5sAMQsC/QALAARViwCy8bsQsdPlmwAEVYsBsvG7EbHT5ZsABFWLAELxuxBA8+WbAA0LICBBsREjmwAi+wCxCyDAEKK1gh2Bv0WbAEELITAQorWCHYG/RZsAAQsiQBCitYIdgb9FmwAhCwJ9CwGxCyLAEKK1gh2Bv0WTAxBSYnBickABM3EgA3BwYGBwcGFhc3JiY3NzYSFxYWFxYHBgcWMwEWFzY3NzYnJgMGBRzbnaKY/vX+4RsDHAEu5xZ4mxoGFZ6kP0gvDAUe+7mdsQkEESPHZ0j9+gN/tCANDIe6JwkSBzM+AgIBRwETHgEIATUEzQKzrivC0AIDaeF+JvEBDwUEya1PePmxBwFls1x+8o7QBQb+zGEA//8AbQAABIAEjQAmA/cAAAAHA9UABf7VAAH/pP6vBIAEjQAPAFqyChARERI5ALAHL7AARViwAS8bsQEdPlmwAEVYsA8vG7EPHT5ZsABFWLALLxuxCw8+WbAARViwCS8bsQkPPlmyAA8LERI5sgQBCitYIdgb9FmyCgsPERI5MDEBASEBEzMDIxMjAwEhAQEhAisBMQEk/iW4xlzLO4aw/sf+3AHm/vwBBAL7AZL9sv6D/e0BUQGY/mgCVwI2AAABAGL+rwW6BI0ADwBcsgkQERESOQCwAi+wAEVYsAgvG7EIHT5ZsABFWLAOLxuxDh0+WbAARViwBC8bsQQPPlmyAAEKK1gh2Bv0WbAIELIGAQorWCHYG/RZsArQsAvQsAAQsAzQsA3QMDElMwMjEyETITchByEDIRMzBPu/cNk7/GCo/q4jA4ci/raGAfWo7cP97AFRA8nExPz6A8oAAAEAXQAABGQEjQAYAE+yBRkaERI5ALAARViwCy8bsQsdPlmwAEVYsBcvG7EXHT5ZsABFWLAALxuxAA8+WbIRCwAREjmwES+yBwEKK1gh2Bv0WbAE0LARELAU0DAxISMTBgcHIzcmJjcTMwMGFxYXNzMHNjcTMwOa7lFGXCqfKq+wFDnuOgcCA3Uxny9EXWTtAasVC83KEty2AWH+pCsoeBv08woXAiAAAAEACgAABBEEjQASAEayDhMUERI5ALAARViwAC8bsQAdPlmwAEVYsAgvG7EIDz5ZsABFWLARLxuxEQ8+WbIEAAgREjmwBC+yDgEKK1gh2Bv0WTAxEzMDNhcWFgcDIxM2JyYnJgcDI9TtUYR40NUVOe06BgYTm2ybZO0Ejf5VJwIC4cP+nwFiNCl/BgMm/d8AAAIAN//xBaUEpwAbACQAZLIOJSYREjmwDhCwHdAAsABFWLAPLxuxDx0+WbAARViwAC8bsQAPPlmyIA8AERI5sCAvshMBCitYIdgb9FmwBNCwIBCwDNCwABCyFwEKK1gh2Bv0WbAPELIcAQorWCHYG/RZMDEFLgI3JiY3FwYXFhc2ABcWEgcHIQYWFxY3FwYDJgYHITYnJiYDWJrydRCXmQu8AwMHcz0BQtnm7x0X/N4SkpGBqS93fX23LQI6EQsPdA8Bg+eREtu1ASckeBvoAQ8EBP7Y9JmOngIDP71KA+4Dn5dTN05YAAACADT/7AR6BKIAFQAfAF6yESAhERI5sBEQsBfQALAARViwAC8bsQAdPlmwAEVYsAgvG7EIDz5Zsg4ACBESObAOL7AAELIRAQorWCHYG/RZsAgQshYBCitYIdgb9FmwDhCyGQEKK1gh2Bv0WTAxAR4CBwcGACcuAjc3ITYmJyYHJzYTFjY3IQcGFxYWAoOf620RDSD+q+eZ11wTGAMgEpKPgKswenx8ty39xwYLChB1BKIDivicZfv+ywQDifWfmZGbAgM/vEv8EgOflxk9M1BXAAABAAz/5wQFBI0AGgBqshMbHBESOQCwAEVYsAIvG7ECHT5ZsABFWLAMLxuxDA8+WbACELIAAQorWCHYG/RZsgQAAhESObIaDAIREjmwGi+yGAEKK1gh2Bv0WbIFGBoREjmwDBCyEgEKK1gh2Bv0WbIQEhgREjkwMQEhNyEHARYWBw4CJyYmNzMWFxY2NzYmJyc3ArH9+CIDOhv+lomeCAeG6Ii82gTqBLVsjAoKX2CRIgPJxKX+xRe5gXWnWQMFvJyUBQJiVE1XAwHFAAADADr/7ARjBKMAEAAXAB4AiLIZHyAREjmwGRCwENCwGRCwEtAAsABFWLAILxuxCB0+WbAARViwAC8bsQAPPlmwCBCyEQEKK1gh2Bv0WbIVCAAREjl8sBUvGLIwFQFdskMVAV20YBVwFQJdsvAVAV2yABUBcbSAFZAVAnGwABCyGAEKK1gh2Bv0WbAVELIbAQorWCHYG/RZMDEFJiYCNzcSABcWFhIHBwYCBBEmBgchNiYDFjY3IQYWAfuS0V4RAx8BSe+Rz14RBBWg/v9yrTMCJQpv/3OrMv3cCnAQApUBBJ4cAREBTQYCkv76niSy/vGUA+0FmKCMovzeBZmdhqYAAQAEAAAECgSiACYAprIlJygREjkAsABFWLAeLxuxHh0+WbAARViwDC8bsQwPPlmyBh4MERI5sAYvsg8GAV2wAdCwAS+yzwEBXUAJHwEvAT8BTwEEXbIAAQFdsgICCitYIdgb9FmwBhCyBwIKK1gh2Bv0WbAMELIPAQorWCHYG/RZsArQsAcQsBPQsAYQsBTQsAIQsBjQsAEQsBnQsB4QsiQBCitYIdgb9FmyIQEkERI5MDEBIQclBwclByUGByUHITcXNjc3BzcXNzcHNzM3NjYXFhYHJzYnJgMBvgGCGv6TDwgBdhv+iSM2Aokk/H8dCDQfE5gclgYQoBuNAxvwva69CO0KkKQoArqSAkMZApMBRDoDw8IBFkApA5MCEUsCkhjX+QQE0bMBwAMD/v8AAAEAHv/wA+sEogAiAJuyHSMkERI5ALAVL7AARViwCC8bsQgPPlmyIhUIERI5sCIvsg8iAV2yzyIBXbQQIiAiAl2yAAIKK1gh2Bv0WbAIELIDAQorWCHYG/RZsAAQsAzQsCIQsA3QsCIQsB3QsB0vss8dAV22Hx0vHT8dA12yAB0BXbIgAgorWCHYG/RZsA/QsB0QsBLQsBIvsBUQshoBCitYIdgb9FkwMQEhBhcWNxcGJyYmNwc3MzcjNzM2JBcWFwcmJyIGByUHIQchAxH+lQTCRYMMc2i+6QScGo0RjhqJQQEVx16FJVprZ48wAXka/okQAXgBhMsEAx3BHgIC3LUBklyTydQCAh7BHgJocwGTXAAEAAoAAAe+BKMAAwARAB8AKQCqsiAqKxESObAgELAB0LAgELAN0LAgELAT0ACwAEVYsCUvG7ElHT5ZsABFWLAoLxuxKB0+WbAARViwBC8bsQQdPlmwAEVYsCAvG7EgDz5ZsABFWLAjLxuxIw8+WbAEELAL0LALL7AD0LADL7YAAxADIAMDXbIAAgorWCHYG/RZsAsQshUCCitYIdgb9FmwBBCyHAIKK1gh2Bv0WbIiJSAREjmyJyUgERI5MDElITchAxYWBwcGBicmJjc3NjYDBhYXFjY3NzYmJyYGBwEjAQMjEzMBEzMHCv3UGwIrm4+mCgYO0JmQpgoFDNU7B0ZHS2sOCgdGRkxsDv4f5P6JjO3K5QF3jOzIlQNCBLuRQpzCBAS+jUCdxP5dWWACBGhZTllgAgJkWvyxAyX82wSN/NoDJgAC/9kAAASyBI0AFgAfAJOyACAhERI5sB/QALAARViwDC8bsQwdPlmwAEVYsAIvG7ECDz5ZsgYCDBESObAGL7QfBi8GAnGyBQcKK1gh2Bv0WbAB0LAGELAK0LAKL7QfCi8KAnG2DwofCi8KA122jwqfCq8KA12yCQcKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAXL7AMELIfAQorWCHYG/RZMDElIQcjNyM3MzcjNzMTBRYWBwYEIycHIQMXNjY3NiYnJwKT/v0b7RvKIMkOyyHJYwHOudkLCv7w0v4OAQTX5GKLDQxXVP2ZmZm2TbcCOgEFzJ+r1gFNAQQBAmpZT18EAQACABD/6AQjBgAAEgAfAGSyBCAhERI5sAQQsBzQALAJL7AARViwDS8bsQ0bPlmwAEVYsAcvG7EHDz5ZsABFWLAELxuxBA8+WbIGDQcREjmyCw0HERI5sA0QshYBCitYIdgb9FmwBBCyGwEKK1gh2Bv0WTAxAQYCBicmJwcjATMDNhcWFhcWBycnJicmBwMWFxY2NzYEGhOS1n+3XS3PAQrubHmmobsJAwbqBByejWVRM4t8qRgIAhig/vODAwSMewYA/dGBBATfv0E+cye8BQSJ/jWDBAPCqFQAAAEAN//oBAMEVAAbAEuyABwdERI5ALAARViwDy8bsQ8bPlmwAEVYsAgvG7EIDz5ZsgABCitYIdgb9FmyBA8IERI5shMIDxESObAPELIWAQorWCHYG/RZMDElFjY3Nw4CJyYCNzcSABcWFhUjJiYnJgYHBhYB8VeDFt8OhtRw094YAh0BNt+w0N0CXlKKrAgGYq0CZ1MBbK9jAwUBMOgUAQEBNwYE4rNicQQG8uKCjQAAAgA7/+cEmwYAABIAHwBhsgQgIRESObAEELAZ0ACwBy+wAEVYsAQvG7EEGz5ZsABFWLAJLxuxCQ8+WbAARViwDS8bsQ0PPlmyBgQJERI5sgsECRESObIYAQorWCHYG/RZsAQQsh0BCitYIdgb9FkwMRM2EjYXFhcTMwEjNwYnJiYnJjczBhcWFhcWNxMmJyYGRBOW1oGjX2jt/vbMDH+um74MBAbuBgQFYleFZ1Q1g32sAh+jAQyEAwR2Aiv6AHWOBATluz88NTtnfgQEhQHaeAQDwv//AKQAAAMtBbUABgAVtQAAAgA0/+gEPwRRABMAIwBDshgkJRESObAYELAE0ACwAEVYsAUvG7EFGz5ZsABFWLAOLxuxDg8+WbIXAQorWCHYG/RZsAUQsh8BCitYIdgb9FkwMRM2Ejc2Fx4CBwcGAgYnJiYnJjcXFhYXFjY3NicmJicmBgcGRRa7kmV5jMxhEAIUoPuTjc4vLQ/rB2lae7McBgQJall+shcIAiCwARNBLQMCkPyWFp7+/40EApJ/e5F2aXwDBcS9OD5rfwMDy6VRAAAC/8f+YAQhBFIAEgAeAGCyBB8gERI5sAQQsB3QALAARViwDS8bsQ0bPlmwAEVYsAovG7EKGz5ZsABFWLAHLxuxBxE+WbAARViwBC8bsQQPPlmwDRCyFwEKK1gh2Bv0WbAEELIcAQorWCHYG/RZMDEBBgIGJyYnAyMBNwc2FxYWFxYHJzc0JicmBwMWFxY2BBgTkdZ/qGFh7gEE0g58r569CQMG7QRmX4RjVzKHerECGJ7+84UDBHP9/gXaAXKJBALkvUA+AUt+jQQEfP4VdAQDxgACADv+YARLBFEAEgAeAGuyDB8gERI5sAwQsBjQALAARViwBy8bsQcbPlmwAEVYsAQvG7EEGz5ZsABFWLAJLxuxCRE+WbAARViwDS8bsQ0PPlmyBgcNERI5sgsHDRESObIXAQorWCHYG/RZsAQQshwBCitYIdgb9FkwMRM2EjYXFhc3MwEjEwYnJiYnJjcXBxQWFxY3EyYnJgZEEpLZha9cKtD+/O1jeZ2cwAwEBu4EZF6DZFk3f32xAh+eAQ6GAwR/b/omAf11BALhvz89AUp7lAIEeQH3bwMDxwAAAgA7/+sECARUABUAHgCAsgAfIBESObAW0ACwAEVYsAgvG7EIGz5ZsABFWLAALxuxAA8+WbIZCAAREjmwGS+0vxnPGQJdtF8ZbxkCcbQfGS8ZAnGyjxkBXbTvGf8ZAnGyDAcKK1gh2Bv0WbAAELIQAQorWCHYG/RZshIACBESObAIELIWAQorWCHYG/RZMDEFLgI3NzYAFxYSBwchBhYXFjcXBgYDJgMFNzYnJiYCDZDYag4CGQE518fNGxP9WAqGfYmSLT69EcBiAcIGCAUIWBMBiPSXFP4BQQYE/urign+fAgRRqDM3A6EG/vABHS8rQk8AAAIAMP5QBDoEUQAbACkAfLIEKisREjmwBBCwJtAAsABFWLAHLxuxBxs+WbAARViwBC8bsQQbPlmwAEVYsAwvG7EMET5ZsABFWLAWLxuxFg8+WbIGBxYREjmwDBCyEQEKK1gh2Bv0WbIUBxYREjmwFhCyIQEKK1gh2Bv0WbAEELImAQorWCHYG/RZMDETNhI2FxYXNzMDBgAnJic3FhcWEzcGJyYmJyY3MwYXFBYXFjcTJicmBgdGFIbOgrVcK86tIv7Y4aCSQmx7+EwRfp+asAcDBu0GAVhWi2JSMIh5nxYCH6UBBocCBIRz/Azt/vcEBEyxPwIHARBFegQE4ME+OzM7aH8EBIkB1HoEA8GrAAEAb//nBUYFyAAdAE6yDB4fERI5ALAARViwDS8bsQ0fPlmwAEVYsAMvG7EDDz5ZsgANAxESObIRAw0REjmwDRCyEwEKK1gh2Bv0WbADELIaAQorWCHYG/RZMDEBBgAnLgInJjc2EiQXFgAXIwInJgADBwYWFxY2NwTeI/6x9ZLehQsIGSPTASit3wEKCvUN/cj/ABICA5OIi7kmAdzj/u4EA4T7nnOSzQFHpAME/vTnASQHBv6X/uYvvdgEBpyPAAEAcf/oBUoFyAAkAFyyFSUmERI5ALAARViwDi8bsQ4fPlmwAEVYsAMvG7EDDz5ZshEOAxESObAOELIUAQorWCHYG/RZsAMQsh4BCitYIdgb9FmyIw4DERI5sCMvsiIBCitYIdgb9FkwMSUGBCcuAicmNzc2EiQXFgQXJwInJgYGBwYXFBYWFxY3EyE3IQTAS/7atpjsjg4ICwQbzwE1tt4BBRLwF/V0w4kXDAFIjmC6cDX+5SICELxjcQMDhPqeVl4n0wFbtQME9N0BAQAIA3/7m149dbtlAQVYARvAAAIALgAABR0FsAALABYAQ7IPFxgREjmwDxCwCtAAsABFWLACLxuxAh8+WbAARViwAC8bsQAPPlmyDgEKK1gh2Bv0WbACELIWAQorWCHYG/RZMDEzEwUyBBIHBwYCBAcTAxcyADc2JyYmJy78AZi9ARuDFQUZ1/6mxgq2mtMBKSocDxSxkQWwAbf+vcYsxv69uAIE5PvmAQEB2JB3k6MEAAACAHL/6AVyBcgAEwAnAEayCigpERI5sAoQsBvQALAARViwCy8bsQsfPlmwAEVYsAAvG7EADz5ZsAsQshoBCitYIdgb9FmwABCyJAEKK1gh2Bv0WTAxBS4CJyY3NzYSJBceAhcWAgIEATY3NCYmJyYABwcGFRQWFhcWADcCf4/hiA0ICgwi1QEzrZDgiA0OZNb+5gFOBgFBg1y1/vUiAgZCg1ywAQInFQOH/qBWV1LCAUetAwOG/J6u/pn+6o8DDjQ6br1kAwX+y/YPNDpwwGcDBwEh5QAAAgBy/wMFbAXIABkAKwBGsiEsLRESObAhELAD0ACwAEVYsBAvG7EQHz5ZsABFWLAFLxuxBQ8+WbAQELIgAQorWCHYG/RZsAUQsicBCitYIdgb9FkwMSUXBycGIy4CJyY3NzYSJBcWFhIXFgcHBgIDNjc0JiYnJgYCFRQWFxY2EjcD2Mau9UY4kt2IDQcKCSDVATSxk+GHDAYKCB/ICAcBP4NeiduGl4pzxo4WU8aK9AsDhv+hV1c+xgFQsQMDiP8AnVhXN8r+xQI/NTpyvGUDBK7+wri83QQFfQECmgAAAQCrAAADNQSMAAYAMgCwAEVYsAUvG7EFHT5ZsABFWLAALxuxAA8+WbIEAAUREjmwBC+yAwEKK1gh2Bv0WTAxISMTBTclMwJx7Zf+kCYCQCQDZHrXywABAB8AAAQKBKAAGQBVsgoaGxESOQCwAEVYsBEvG7ERHT5ZsABFWLAALxuxAA8+WbIDEQAREjmwERCyCQEKK1gh2Bv0WbINEQAREjmyFwARERI5sAAQshkBCitYIdgb9FkwMSEhNwE3Njc2JicmBgcHPgIXFhYHBgcHAQUDpfx6HgIbPW0OCVNOZIoQ6wmI4oK20AoMt03+pwIwqQGkM19lRlQCAnpiAne9aAEFspWnnUD+9QIAAAEACgAABBUFxAAHADKyAwgJERI5ALAARViwBi8bsQYdPlmwAEVYsAUvG7EFDz5ZsAYQsgIBCitYIdgb9FkwMQEzAyEDIxMhAyfuWf3jqO3KAh0FxP4F/DcEjQAAAf9//qAEFQSNABgAWbIFGRoREjkAsAwvsABFWLACLxuxAh0+WbIAAQorWCHYG/RZsgQAAhESObIFDAIREjmwBS+wDBCyEQEKK1gh2Bv0WbAFELIWAworWCHYG/RZshgWBRESOTAxASE3IQcBFhYHBgYEJyYnNxYXFjY3EiUnNwLA/dQjA14b/mSTpw0OrP7cqrLSSo+joekTI/7hZRIDycSa/oYe9KGi+YsDA2a0WQICwJcBChQChgAAAv/R/sQEIwSMAAoADgBSALAARViwCS8bsQkdPlmwAEVYsAIvG7ECDz5ZsABFWLAGLxuxBg8+WbIAAQorWCHYG/RZsAYQsAXQsAUvsggGABESObAAELAM0LINCQIREjkwMSUzByMDIxMhNwEzASETBwNysSKwN+03/W0VAzn8/NcBlHcewsP+xQE7oAPt/DYCgywA//8AigKIAv8FvQMHA9AAcwKYABMAsABFWLAHLxuxBx8+WbAR0DAxAP//AGQCmALtBa4DBwPMAHMCmAATALAARViwCS8bsQkfPlmwDdAwMQD//wB9AooDBAWtAwcDywBzApgAEACwAEVYsAEvG7EBHz5ZMDH//wCJAooC5gW8AwcDygBzApgAEwCwAEVYsBQvG7EUHz5ZsBXQMDEA//8AlgKYAy4FrQMHA8kAcwKYABAAsABFWLAFLxuxBR8+WTAx//8AewKKAvMFuwMHA8gAcwKYABkAsABFWLASLxuxEh8+WbAY0LASELAk0DAxAP//AKYCjQL1BbsDBwPHAHMCmAATALAARViwCC8bsQgfPlmwHNAwMQAAAf/U/p0ETgSMABwAXbIHHR4REjkAsA8vsABFWLABLxuxAR0+WbIDAQorWCHYG/RZsgcBDxESObAHL7IaAQorWCHYG/RZsgUaBxESObAPELIUAQorWCHYG/RZshIUGhESObIcGhQREjkwMRMTIQchAzYXMhYWBwYGBCcmJzcWFxY2NzYmJyYHWeEDFCX9r3FjgHqvUA0Pnv73pM+5WneykcwTDmhplEgBdgMW0v6oNgJ634mX840CBHWvZAICvpZ/nwMEcgAAAQAn/sQEVASMAAYAJQCwAS+wAEVYsAUvG7EFHT5ZsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITchBDr85vkDDP1NIwOxA/n6ywUFwwAAAgA6//IGoQSfABgAJACRsgElJhESObABELAb0ACwAEVYsAwvG7EMHT5ZsABFWLAPLxuxDx0+WbAARViwAi8bsQIPPlmwAEVYsAAvG7EADz5ZsA8QshEBCitYIdgb9FmyFAAPERI5sBQvshUBCitYIdgb9FmwABCyGAEKK1gh2Bv0WbACELIZAQorWCHYG/RZsAwQshwBCitYIdgb9FkwMSEhBSMmJgI3NzYSNhcyFjMhByEDIQchAyEFNxMnJgYHBhcWFhcF2f17/vJOkdBdEQYXov+dWcRdAoEj/cowAegj/ho2Ajv8a2WWxIK2IRYFBWpdDgKUAQOdNqkBCJABEcT+8sP+ygwEAxYMArSpcGNwhAQAAgBH/rAERgSjABkAKABRsiMpKhESObAjELAE0ACwFS+wAEVYsAwvG7EMHT5ZsBUQsgABCitYIdgb9FmyBRUMERI5sAUvshoBCitYIdgb9FmwDBCyIgEKK1gh2Bv0WTAxBRY2NwYnJgI3PgIXFhYSBwcGAgQnJic3FgEWNzc2JyYmJyYGBhcWFgFQkdpQgpm8zRQOlOiLk8tYEx0kxf7krYyRQXIBIqFxHAcCA2RaW45HCgleiwO50l0EAgEV15P4hgIEkf7+osLx/qarAwI9tC8B6QR7rjg8aHoDA3jWZ1xtAAIATv/mBIoEpQAMAB0ARrISHh8REjmwEhCwANAAsABFWLAGLxuxBh0+WbAARViwAC8bsQAPPlmwBhCyEQEKK1gh2Bv0WbAAELIaAQorWCHYG/RZMDEFJgITEgAXFhIDBwIAEzc0JicmBgcHBhcWFhcWNjcCGOLoGyQBR+/g5xsLMP7EjQVraIq8GQQGAwVsYYq7GRUFAUoBAQEhAUkFBf66/v5H/v7+3AKAU4yVBAXUwiA8QnSLBAXWxwD///8P/kgB3AQ6AgYBZAAA////D/5IAdwEOgIGAWQAAP//ACIAAAHLBDoABgD0AAD///99/lsBywQ6ACYA9AAAAAYBbdUK//8AIgAAAcsEOgAGAPQAAAABAAr/5gPoBKEAIABpsgchIhESOQCwAEVYsBQvG7EUHT5ZsABFWLAeLxuxHg8+WbAARViwDy8bsQ8PPlmwHhCyAgEKK1gh2Bv0WbIJHhQREjmwCS+yBwcKK1gh2Bv0WbAUELIMBworWCHYG/RZshgJBxESOTAxJRYzMjY3NicnNzcmJyYHAyMTNjYXFhYXARYWBwYGJyYnAZBFRU9vCxPSYB/uNU+xKn/pfh7ywXK/Xv7Ygo4GCvCubnfbM25TlAIBrvo2AgP3/RQC7NbfBARnav7TFqF3r9gCAjb///+XAAAEGgSNAiYD6QAAAQcD1f8E/24AOwCyHxoBcbJvGgFxsv8aAXGyDxoBcrKfGgFysl8aAXK2vxrPGt8aA3GyPxoBcbLfGgFdtB8aLxoCXTAxAP///5cAAAQaBI0CJgPpAAABBwPV/wT/bgA7ALIfGgFxsm8aAXGy/xoBcbIPGgFysp8aAXKyXxoBcra/Gs8a3xoDcbI/GgFxst8aAV20HxovGgJdMDEA//8AYgAABFoEjQImA9kAAAEGA9UlvgAIALIACwFdMDH///+bAAAEBQYeAiYD7AAAAQcARADSAB4AEwCwAEVYsAQvG7EEHT5ZsAzcMDEA////mwAABD8GHgImA+wAAAEHAHcBbQAeABMAsABFWLAFLxuxBR0+WbAN3DAxAP///5sAAAQIBh8CJgPsAAABBgFnaR4AEwCwAEVYsAQvG7EEHT5ZsA/cMDEA////mwAABEAGEwImA+wAAAEGAW53HwAJALAEL7AV3DAxAP///5sAAAQiBesCJgPsAAABBwBrAJ8AHgAMALAEL7Ac3LAL0DAx////mwAABAUGfQImA+wAAAEHAWwBAwBSAAwAsAQvsBTcsBfQMDH///+bAAAEUQaZAiYD7AAAAAcDxQD7AAT//wA5/j0ESQSjAiYD6gAAAAcAewFgAAD//wAKAAAD+QYeAiYD6AAAAQcARACiAB4AEwCwAEVYsAYvG7EGHT5ZsA3cMDEA//8ACgAABA8GHgImA+gAAAEHAHcBPQAeABMAsABFWLAHLxuxBx0+WbAO3DAxAP//AAoAAAP5Bh8CJgPoAAABBgFnOR4AEwCwAEVYsAYvG7EGHT5ZsBDcMDEA//8ACgAAA/kF6wImA+gAAAEGAGtvHgAMALAGL7Ad3LAM0DAx//8AGAAAAeAGHgImA+QAAAEGAESKHgATALAARViwAi8bsQIdPlmwBdwwMQD//wAYAAAC9gYeAiYD5AAAAQYAdyQeABMAsABFWLADLxuxAx0+WbAG3DAxAP//ABgAAALABh8CJgPkAAABBwFn/yEAHgATALAARViwAi8bsQIdPlmwCNwwMQD//wAYAAAC2gXrAiYD5AAAAQcAa/9XAB4ADACwAi+wFdywBNAwMf//AAoAAASoBhMCJgPfAAABBwFuAJUAHwAJALAFL7AU3DAxAP//ADr/6gRjBh4CJgPeAAABBwBEAN8AHgATALAARViwCS8bsQkdPlmwItwwMQD//wA6/+oEYwYeAiYD3gAAAQcAdwF6AB4ACQCwCS+wI9wwMQD//wA6/+oEYwYfAiYD3gAAAQYBZ3YeAAkAsAkvsCLcMDEA//8AOv/qBGMGEwImA94AAAEHAW4AhAAfAAkAsAkvsCvcMDEA//8AOv/qBGMF6wImA94AAAEHAGsArAAeAAwAsAkvsDLcsCHQMDH//wA5/+sEagYeAiYD2AAAAQcARADAAB4AEwCwAEVYsAkvG7EJHT5ZsBPcMDEA//8AdP/nBE4FyQAGABQUAP//AI7/+QQvBcgABgAdAAD//wBa/+cEcwWwAgYAGQAA//8ACQAABCoFsAIGABgAAP//ACb/6AQ5BcUCBgAXAAD//wALAAAEPwXHAgYAFgAA//8AOf/rBGoGHgImA9gAAAEHAHcBWwAeAAkAsAAvsBTcMDEA//8AOf/rBGoGHwImA9gAAAEGAWdXHgAJALAAL7AT3DAxAP//ADn/6wRqBesCJgPYAAABBwBrAI0AHgAMALAAL7Aj3LAS0DAx//8AbQAABIAGHgImA/cAAAEHAHcBNQAeABMAsABFWLABLxuxAR0+WbAL3DAxAP///5sAAAQ8BdICJgPsAAABBgBycSIAEwCwAEVYsAQvG7EEHT5ZsAzcMDEA////mwAABBMGBQImA+wAAAEHAWoApwAeAAkAsAQvsA7cMDEAAAL/m/5RBAUEjQAXABoAhLIVGxwREjmwFRCwGtAAsABFWLAVLxuxFR0+WbAARViwCy8bsQsRPlmwAEVYsAAvG7EADz5ZsABFWLATLxuxEw8+WbAARViwAS8bsQEPPlmwCxCyBgMKK1gh2Bv0WbABELAQ0LAQL7IZFQAREjmwGS+yEQcKK1gh2Bv0WbIaFQAREjkwMSEXBwYHBhcWNxcGJyImNzY3JyEHIwEzEwEhAwPQBS+DBwU4Gz0MRVVXaQIDvCz+Loj5ApPa/f18AUhXAx9WVjkDAReQKwJtVJhr4vkEjftzAbIBuP//ADn/7ARJBh4CJgPqAAABBwB3AWoAHgAJALALL7Af3DAxAP//ADn/7ARJBh8CJgPqAAABBgFnZh4ACQCwCy+wHtwwMQD//wA5/+wESQX/AiYD6gAAAQcBawFHACcACQCwCy+wJdwwMQD//wA5/+wESQYjAiYD6gAAAQYBaH0eAAkAsAsvsCHcMDEA//8ACgAABBoGIwImA+kAAAEGAWj+HgATALAARViwAi8bsQIdPlmwG9wwMQD//wAKAAAEDAXSAiYD6AAAAQYAckEiABMAsABFWLAGLxuxBh0+WbAN3DAxAP//AAoAAAP5BgUCJgPoAAABBgFqdx4ACQCwBi+wD9wwMQD//wAKAAAD+QX/AiYD6AAAAQcBawEaACcACQCwBi+wFNwwMQAAAQAK/lED+QSNABwAgLIVHR4REjkAsABFWLAXLxuxFx0+WbAARViwEC8bsRARPlmwAEVYsAQvG7EEDz5ZsABFWLAVLxuxFQ8+WbIcFwQREjmwHC+yAAEKK1gh2Bv0WbAVELICAQorWCHYG/RZsAPQsBAQsgsDCitYIdgb9FmwFxCyGQEKK1gh2Bv0WTAxASEDIQcjFwcGBwYXFjcXBiciJjc2NyETIQchAyEDNf4aNgI7I2AFL4MHBTgbPQxFVVdpAgOW/hXKAyUj/ckvAegB+P7KwgMfVlY5AwEXkCsCbVSMYASNxP7y//8ACgAABAwGIwImA+gAAAEGAWhQHgATALAARViwBi8bsQYdPlmwEdwwMQD//wA///AEUQYfAiYD5gAAAQYBZ2oeAAkAsAsvsCLcMDEA//8AP//wBFEGBQImA+YAAAEHAWoAqAAeAAkAsAsvsCTcMDEA//8AP//wBFEF/wImA+YAAAEHAWsBSwAnAAkAsAsvsCncMDEA//8AP/35BFEEowImA+YAAAAHA6sBIP6S//8ACgAABKkGHwImA+UAAAEGAWd8HgATALAARViwBy8bsQcdPlmwENwwMQD//wANAAAC+AYTAiYD5AAAAQcBbv8vAB8ACQCwAi+wDtwwMQD//wAYAAAC9AXSAiYD5AAAAQcAcv8pACIAEwCwAEVYsAIvG7ECHT5ZsAXcMDEA//8AGAAAAssGBQImA+QAAAEHAWr/XwAeAAkAsAIvsAfcMDEA////iv5RAc8EjQImA+QAAAAGAW3iAP//ABgAAAICBf8CJgPkAAABBgFrAScACQCwAi+wDNwwMQD////y/+sEkAYfAiYD4wAAAQcBZwDxAB4AEwCwAEVYsAAvG7EAHT5ZsBPcMDEA//8ACv35BJ0EjQImA+IAAAAHA6sAzP6S//8ACgAAAzQGHgImA+EAAAEGAHcbHgATALAARViwBS8bsQUdPlmwCNwwMQD//wAK/fkDNASNAiYD4QAAAAcDqwDK/pL//wAKAAADOwSQAiYD4QAAAQcDqwIlA4oAEACwAEVYsAovG7EKHT5ZMDH//wAKAAADNASNAiYD4QAAAAcBawDu/Ub//wAKAAAEqAYeAiYD3wAAAQcAdwGLAB4AEwCwAEVYsAgvG7EIHT5ZsAzcMDEA//8ACv35BKgEjQImA98AAAAHA6sBLv6S//8ACgAABKgGIwImA98AAAEHAWgAngAeABMAsABFWLAGLxuxBh0+WbAP3DAxAP//ADr/6gRjBdICJgPeAAABBgByfiIACQCwCS+wIdwwMQD//wA6/+oEYwYFAiYD3gAAAQcBagC0AB4ACQCwCS+wJNwwMQD//wA6/+oE5AYdAiYD3gAAAQcBbwD7AB4ADACwCS+wI9ywJdAwMf//AAoAAAQWBh4CJgPbAAABBwB3ASAAHgAJALAEL7AY3DAxAP//AAr9+QQWBI0CJgPbAAAABwOrANL+kv//AAoAAAQWBiMCJgPbAAABBgFoMx4ACQCwBC+wGtwwMQD//wAO/+0EGwYeAiYD2gAAAQcAdwFJAB4ACQCwCS+wKdwwMQD//wAO/+0D/wYfAiYD2gAAAQYBZ0UeAAkAsAkvsCjcMDEA//8ADv49A/8EnwImA9oAAAAHAHsBRQAA//8ADv/tBBgGIwImA9oAAAEGAWhcHgAJALAJL7Ar3DAxAP//AGL9+QRaBI0CJgPZAAAABwOrAN7+kv//AGIAAARaBiMCJgPZAAABBgFoSh4AEwCwAEVYsAYvG7EGHT5ZsA3cMDEA//8AYv5DBFoEjQImA9kAAAAHAHsBMAAG//8AOf/rBGoGEwImA9gAAAEGAW5lHwAJALAAL7Ac3DAxAP//ADn/6wRqBdICJgPYAAABBgByXyIACQCwAC+wEtwwMQD//wA5/+sEagYFAiYD2AAAAQcBagCVAB4ACQCwAC+wFdwwMQD//wA5/+sEagZ9AiYD2AAAAQcBbADxAFIADACwAC+wG9ywHtAwMf//ADn/6wTFBh0CJgPYAAABBwFvANwAHgAMALAAL7AU3LAW0DAxAAEAOv6BBGoEjQAfAGGyBSAhERI5ALAARViwAC8bsQAdPlmwAEVYsBYvG7EWHT5ZsABFWLANLxuxDRc+WbAARViwEi8bsRIPPlmyBBIAERI5sA0QsggDCitYIdgb9FmwEhCyGwEKK1gh2Bv0WTAxAQMGBgcGBwYXFjcXBiciJjc2NyYmNxMzAwYWFxY2NxMEaoIYp4R5CgU4Gz0MRVVXaQICS7LCE4HsggtbZ2uOEoMEjfz1jcMpT1g5AwEXkCsCbVRiTRPdqgMA/P9lcgMEb2kDBwD//wCMAAAGHgYfAiYD1gAAAQcBZwEVAB4AEwCwAEVYsAEvG7EBHT5ZsA/cMDEA//8AbQAABIAGHwImA/cAAAEGAWcxHgATALAARViwCC8bsQgdPlmwDdwwMQD//wBtAAAEgAXrAiYD9wAAAQYAa2ceAAwAsAEvsBrcsAnQMDH////WAAAEJwYeAiYEqQAAAQcAdwE4AB4AEwCwAEVYsAgvG7EIHT5ZsAzcMDEA////1gAABCcF/wImBKkAAAEHAWsBFQAnAAkAsAcvsBLcMDEAAAH/1gAABCcEjQAJAEQAsABFWLAHLxuxBx0+WbAARViwAi8bsQIPPlmyAAEKK1gh2Bv0WbIEAAIREjmwBxCyBQEKK1gh2Bv0WbIJBQcREjkwMSUhByE3ASE3IQcBMAJgI/xpGwLf/a8jA4UawsKYAzHElgD///+bAAAEBQUeAiYD7AAAAAcBd/9I/t3///9tAAAENQUhACYD6DwAAAcBd/4//uD///94AAAE5QUcACYD5TwAAAcBd/5K/tv///97AAACCwUhACYD5DwAAAcBd/5N/uD////S/+oEbQUeACYD3goAAAcBd/6k/t3///8sAAAEvAUeACYD9zwAAAcBd/3+/t3////iAAAEggUeACYD1AoAAAcBd/60/t3///+bAAAEBQSNAgYD7AAA//8ACgAABAAEjQIGA+sAAP//AAoAAAP5BI0CBgPoAAD////WAAAEJwSNAgYEqQAA//8ACgAABKkEjQIGA+UAAP//ABgAAAHPBI0CBgPkAAD//wAKAAAEnQSNAgYD4gAA//8ACgAABcgEjQIGA+AAAP//ADr/6gRjBKECBgPeAAD//wAKAAAENgSNAgYD3QAA//8AYgAABFoEjQIGA9kAAP//AG0AAASABI0CBgP3AAD///+kAAAEgASNAgYD9gAA//8AGAAAAtoF6wImA+QAAAEHAGv/VwAeAAwAsAIvsBXcsATQMDH//wBtAAAEgAXrAiYD9wAAAQYAa2ceAAwAsAEvsBrcsAnQMDH//wAKAAAD+QXrAiYD6AAAAQYAa28eAAwAsAYvsB3csAzQMDH//wAKAAAD/gYeAiYDugAAAQcAdwEsAB4ACQCwBC+wCNwwMQD//wAO/+0D/wSfAgYD2gAA//8AGAAAAc8EjQIGA+QAAP//ABgAAALaBesCJgPkAAABBwBr/1cAHgAMALACL7AV3LAE0DAx////8v/rA7AEjQIGA+MAAP//AAoAAASdBh4CJgPiAAABBwB3ASAAHgAJALAEL7AP3DAxAP//AHL/6ASCBgUCJgQKAAABBwFqAIgAHgAJALAPL7AT3DAxAP///5sAAAQFBI0CBgPsAAD//wAKAAAEAASNAgYD6wAA//8ACgAAA98EjQIGA7oAAP//AAoAAAP5BI0CBgPoAAD//wALAAAErgYFAiYEBwAAAQcBagDGAB4ACQCwAC+wDdwwMQD//wAKAAAFyASNAgYD4AAA//8ACgAABKkEjQIGA+UAAP//ADr/6gRjBKECBgPeAAD//wAKAAAEpASNAgYDxgAA//8ACgAABDYEjQIGA90AAP//ADn/7ARJBKMCBgPqAAD//wBiAAAEWgSNAgYD2QAA////pAAABIAEjQIGA/YAAAABAA3+OQPuBKAAKACwsiIpKhESOQCwGC+wAEVYsAwvG7EMHT5ZsABFWLAXLxuxFw8+WbAMELIGAQorWCHYG/RZsigXDBESObAoL7K/KAFytK8ovygCXbRvKH8oAnGy/ygBcbIPKAFysl8oAXKyzygBcbI/KAFxtB8oLygCXbKPKAFyskooAV2yCSgGERI5siYBCitYIdgb9FmyESYoERI5sBcQsBrQsBcQsiEBCitYIdgb9FmyHiYhERI5MDEBMjY3NiYiBgcHNjYXFhYHBgcWFgcGBgcDIxMmJjczFhYzFjY3NicnNwIEZoAKCmWwag/uDP3Cw94ICulRWgQH2LZN7k+GhgLqAlxWapAMFdyHIAKqU01ETEU+AZiyAgOmjbVlI4ZZjrUU/kQByCOqeUdMA1lPoAEBsAABAAr+mgS9BI0ADwCosgMQERESOQCwAEVYsAwvG7EMHT5ZsABFWLAJLxuxCR0+WbAARViwAS8bsQEXPlmwAEVYsAYvG7EGDz5ZsABFWLADLxuxAw8+WbIKBgkREjmwCi+0rwq/CgJdsj8KAXGyzwoBcbI/CgFysv8KAXGyDwoBcrRvCn8KAnG03wrvCgJdtB8KLwoCXbJfCgFysgUBCitYIdgb9FmwAxCyDgcKK1gh2Bv0WTAxASMTIxMhAyMTMwMhEzMDMwRf7j69Uv4GU+3K7VYB+1btq7/+mgFmAdv+JQSN/hEB7/woAAABADr+QwRPBKMAHgBesgMfIBESOQCwAEVYsA0vG7ENHT5ZsABFWLAELxuxBBE+WbAARViwAy8bsQMPPlmyAAMNERI5sAbQshENAxESObANELIUAQorWCHYG/RZsAMQshwBCitYIdgb9FkwMQEGBgcDIxMmAjc3EgAXFhYXJyYmJyYGBwYXFBYXFjcEAhnorEvuTpuVFwYgAUHpwuIK6wNga4WwGhABZGHjOAGFp9QV/k4BwS8BKMU0AQ4BQQYE3b0BZ3AEBcC0iT9wfwQI2gD//wBtAAAEgASNAgYD9wAA//8AN/46BaUEpwImBCAAAAAHA/0Cv/+g//8ACwAABK4F0gImBAcAAAEHAHIAkAAiAAkAsAAvsArcMDEA//8Acv/oBIIF0gImBAoAAAEGAHJSIgAJALAPL7AQ3DAxAP//AEMAAAU3BI4CBgPSAAD///+k/lQErgWwAiYAJQAAAAcBbQFtAAP//wAi/lgD3ARQAiYARQAAAAcBbQCnAAf//wAn/lsEugWwAiYAKQAAAAcBbQEuAAr//wA7/lEEAgRRAiYASQAAAAcBbQD8AAD////k/psBywQ6AiYA9AAAAAcBdgNEAAoAAAAAAA8AugADAAEECQAAAF4AAAADAAEECQABABoAXgADAAEECQACAAwAeAADAAEECQADACgAhAADAAEECQAEACgAhAADAAEECQAFACwArAADAAEECQAGACYA2AADAAEECQAHAEAA/gADAAEECQAJAAwBPgADAAEECQALABQBSgADAAEECQAMACYBXgADAAEECQANAFwBhAADAAEECQAOAFQB4AADAAEECQAQAAwCNAADAAEECQARABoCQABDAG8AcAB5AHIAaQBnAGgAdAAgADIAMAAxADEAIABHAG8AbwBnAGwAZQAgAEkAbgBjAC4AIABBAGwAbAAgAFIAaQBnAGgAdABzACAAUgBlAHMAZQByAHYAZQBkAC4AUgBvAGIAbwB0AG8AIABNAGUAZABpAHUAbQBJAHQAYQBsAGkAYwBSAG8AYgBvAHQAbwAgAE0AZQBkAGkAdQBtACAASQB0AGEAbABpAGMAVgBlAHIAcwBpAG8AbgAgADIALgAwADAAMQAxADUAMgA7ACAAMgAwADEANABSAG8AYgBvAHQAbwAtAE0AZQBkAGkAdQBtAEkAdABhAGwAaQBjAFIAbwBiAG8AdABvACAAaQBzACAAYQAgAHQAcgBhAGQAZQBtAGEAcgBrACAAbwBmACAARwBvAG8AZwBsAGUALgBHAG8AbwBnAGwAZQBHAG8AbwBnAGwAZQAuAGMAbwBtAEMAaAByAGkAcwB0AGkAYQBuACAAUgBvAGIAZQByAHQAcwBvAG4ATABpAGMAZQBuAHMAZQBkACAAdQBuAGQAZQByACAAdABoAGUAIABBAHAAYQBjAGgAZQAgAEwAaQBjAGUAbgBzAGUALAAgAFYAZQByAHMAaQBvAG4AIAAyAC4AMABoAHQAdABwADoALwAvAHcAdwB3AC4AYQBwAGEAYwBoAGUALgBvAHIAZwAvAGwAaQBjAGUAbgBzAGUAcwAvAEwASQBDAEUATgBTAEUALQAyAC4AMABSAG8AYgBvAHQAbwBNAGUAZABpAHUAbQAgAEkAdABhAGwAaQBjAAMAAP/0AAD/agBkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQACAAgAAv//AA8AAQAAAAoAXACsAARERkxUABpjeXJsAChncmVrADZsYXRuAEQABAAAAAD//wACAAAABAAEAAAAAP//AAIAAQAFAAQAAAAA//8AAgACAAYABAAAAAD//wACAAMABwAIY3BzcAAyY3BzcAA4Y3BzcAA+Y3BzcABEa2VybgBKa2VybgBKa2VybgBKa2VybgBKAAAAAQABAAAAAQADAAAAAQACAAAAAQAAAAAAAQAEAAUADAAMAAwADAHeAAEAAAABAAgAAQAKAAUAJABIAAEA3gAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBmAGgAgwCEAIUAhgCHAIgAigCLAIwAjQCOAI8AkACRAJIAkwCUAJUAlgCXAJgAmQCcAJ0AngCfAKAAwwDFAMcAyQDLAM0AzwDRANMA1QDXANkA2wDdAN8A4QDjAOUA5wDrAO0A7wDxAPMA9wD5APwA/gEAAQIBBgEIAQoBDwERARMBFQEXARkBGwEdAR8BIQEjASUBJwEpASsBLQEvATEBMwE1ATcBOQE7ATwBPgFAAU4BYgF5AXsBfAF9AX4BfwGAAYIBgwGEAYUBhgGHAYgBiQGKAYsBjAGNAY8BkAGRAZIBkwGUAZUBlgGXAZgBmQGaAZsBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0QHSAdMB1AHVAdYB1wHYAdkB2gHbAdwB3QHeAd8B4AHhAeIB4wHkAeUB5gHnAegB6QHqAesB7AHtAe4B7wHwAfEB8gJSAlQCWAJaAlwCXgJiAmQCagJsAnACcgJ0AnYCegJ8An4CgAKaAqICpAKqArADhwOOA5MDlgACAAAAAgAKO9oAAQNsAAQAAAGxBtI6+jr6BvwHUjfeI2I7mDuqOHYHWDiWOJY43jTeDqg4ljiWO6omhAqSCxQ1MDjeNI43uDdKOOQPYgt+OFQ2GjiMC8AM6gz0N643rji4NhoO1g3qOW4OTDeoOW4OZjfeN9433jfeN9433juYOHY4djh2OHY4ljiWOJY4ljuqOJY7qjuqO6o7qjuqON443jjeON445DhUOFQ4VDhUOFQ4VDiMOIw4jDiMN644uDi4OLg4uDi4OW42GjluN944VDfeOFQ33jhUO5g7mDuYO5g7qjuqOHY4jDh2OIw4djiMOHY4jDh2OIw4ljeuOJY4ljiWOJY4ljjeNN4OqA6oDqgOqDiWN644ljeuOJY3rjeuO6o4uDuqOLg7qji4DtYO1g7WNTA1MDUwON443jjeON443jjeN7g45DluOOQPYg9iD2I33jhUNTAO6Dr6N944djiWOJY7qjjkN94jYjZ+N944dg9iOJY7qjiWNN433jiWOJYPhDuqJoQQfjUwOOQRfDdKElo4ljjkN64S+DluEv43rhW8OW4Xlji4GKgYwhjIGM4ayBrOGwQbNji4OHY4dhu0Nn44ljiWON4dKh7cIJo03jY0OJY33iHQI2I2fiNsOHY3SiW6OJY03jiWOJY4ljuqJoQ7mDUwNjQ3SjiWOJYmpihAND4pHingKm44VCrMK6Y3QCwwOIw3qCz6LSQ4uDYaLoo5bjYaN6gxEDFOMoA0aDYaMwI4jDiMN0AziDOyNAg5bjQ+NGg33ji4NI45bjSOOW40tDYaNn43QDZ+N0o3qDTeNN403jTeOJY7mDUwOOQ5bjjkN0o3qDeuOJY3SjeoOJY4ljiWN944VDfeOFQ4djiMOIw4jDdKN6g7qji4OLg2GjY0OW42NDluNjQ5bjZ+N0A3QDdKN6g33jhUOJY3rje4N7g3uDfeOFQ33jhUN944VDfeOFQ33jhUN944VDfeOFQ33jhUN944VDfeOFQ33jhUN944VDh2OIw4djiMOHY4jDh2OIw4djiMOHY4jDh2OIw4djiMOJY4ljuqOLg7qji4O6o4uDuqOLg7qji4O6o4uDuqOLg4uDjeON445DluOOQ5bjjkOW445DluO6o6+jmIOvo6+jr6Ovo6+jsAOwo7HDsuO0A7XjtoO3I7mDuqO6oAAQGxAAQABgALAAwAEwAlACYAJwAoACkAKgAsAC0ALgAvADAAMQAyADMANAA1ADYAOAA5ADoAOwA8AD0APgA/AEUARgBJAEoATABPAFEAUgBTAFQAVgBYAFoAWwBcAF0AXwCDAIQAhQCGAIcAiACKAIsAjACNAI4AjwCQAJEAkgCTAJQAlQCWAJcAmACZAJwAnQCeAJ8AoACjAKQApQCmAKcAqACrAKwArQCuALQAtQC2ALcAuAC5AMAAwQDCAMMAxADFAMYAxwDIAMkAywDNAM8A0QDTANUA1gDXANgA2QDaANsA3ADdAN4A5wDoAOsA7QDvAPEA8wD3APkA/AD+AQABAgEGAQcBCAEJAQoBCwEMAQ8BEAERARIBEwEUARgBGgEcASUBJwEpASsBLQEvATEBMwE1ATcBOQE6ATsBPAE+AUABTgFPAWIBZQFmAXkBewF8AX0BfgF/AYIBgwGEAYUBhgGHAYgBiQGKAYsBjAGNAY4BjwGQAZIBkwGUAZUBlgGXAZgBmgGbAZ4BoQGjAaYBpwGpAa0BrgGvAbEBsgGzAbQBtQG2AbgBuQG8AcMBxAHFAcYByQHKAcsBzAHNAc4BzwHRAdIB0wHUAdUB1gHXAdgB2QHaAdsB3QHeAd8B4AHhAeMB5AHlAeYB6AHpAesB7AHtAe8B8AHxAfIB8wH0AfUB9gH3AfgB+QH6Af0CAQIDAgUCBgIHAggCCQIMAg0CDwIQAhECEwIUAhYCFwIcAh0CIQIlAiYCKQI2AjcCOAI5AjoCRAJRAlICUwJUAlgCWQJcAl4CYAJiAmQCbAJuAnACcQJyAnQCdQJ9AoICgwKEAosCjwKRApICkwKUApUCmAKZApsCnQKeAp8CqAKpAq0CrwKwArECsgKzArQCtQK4ArkCvQK+Ar8C1gLXAuYC5wL4AvoC/AMCAwMDBAMFAwYDBwMIAwkDCgMLAwwDDQMOAw8DEAMRAxIDEwMUAxUDFgMXAxgDGQMaAxsDHAMdAx4DHwMgAyEDIgMjAyQDJQMmAycDKAMpAyoDLAMuAy8DMAMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDQwNGA0gDVANVA1YDVwNYA1kDWgNbA1wDcANxA3MDdAN1A34DfwPZA9sD3APeA+ED4gPpA+wEMQQzBDQACgA4/8QBJf/EASf/xAFi/8QBxf/EAc7/xAHl/8QCYv/EAm7/xAJ2/8QAFQA6ABQAOwAmAD0AFgCgABYBNwAmATkAFgE7ABYBfwAWAZUAFgGbABYCNwAUAjkAFAJwABYCcgAWAvgAJgL6ACYC/AAmA1QAFgNWABYDWAAWA1oAFgABABP/CADOABD+7gAS/u4AJf9AAC7/MAA4ABQARf/eAEf/6wBI/+sASf/rAEv/6wBT/+sAVf/rAFb/5gBZ/+oAWv/oAF3/6ACD/0AAhP9AAIX/QACG/0AAh/9AAIj/QACj/94ApP/eAKX/3gCm/94Ap//eAKj/3gCq/+sAq//rAKz/6wCt/+sArv/rALX/6wC2/+sAt//rALj/6wC5/+sAvP/qAL3/6gC+/+oAv//qAMD/6ADC/+gAw/9AAMT/3gDF/0AAxv/eAMf/QADI/94Ayv/rAMz/6wDO/+sA0P/rANL/6wDW/+sA2P/rANr/6wDc/+sA3v/rAOD/6wDi/+sA5P/rAOb/6wD3/zABEP/rARL/6wEU/+sBFv/rASUAFAEnABQBLP/qAS7/6gEw/+oBMv/qATT/6gE2/+oBOv/oAUb/6wFI/+oBTv9AAU//3gFiABQBef9AAYL/QAGF/0ABjP9AAZz/6wGg/+oBof/rAaP/6AGt/+gBr//rAbL/6wGz/+sBtf/qAbv/6gG8/+sBvf/qAcUAFAHL/zABzgAUAdP/QAHlABQB8//eAfj/6wIB/+sCBP/rAgb/6AIH/+sCE//rAhT/6wIX/+sCIf/oAin/QAI2/+sCOP/oAjr/6AI8/+sCQP/rAkT/6wJiABQCa//rAm3/6wJuABQCcf/oAnYAFAKS/0ACk//eApT/QAKV/94Cmf/rApv/6wKd/+sCqf/rAqv/6wKt/+sCsf/oArP/6AK1/+gCw//rAsT/6wLF/+sCz//rAtb/QALX/94DAv9AAwP/3gME/0ADBf/eAwb/QAMH/94DCP9AAwn/3gMK/0ADC//eAwz/QAMN/94DDv9AAw//3gMQ/0ADEf/eAxL/QAMT/94DFP9AAxX/3gMW/0ADF//eAxj/QAMZ/94DG//rAx3/6wMf/+sDIf/rAyP/6wMl/+sDJ//rAyn/6wMv/+sDMf/rAzP/6wM1/+sDN//rAzn/6wM7/+sDPf/rAz//6wNB/+sDQ//rA0X/6wNH/+oDSf/qA0v/6gNN/+oDT//qA1H/6gNT/+oDVf/oA1f/6ANZ/+gDW//oA3L+7gN2/u4Dev7uA3v+7gPs/8AAIAA4/98AOv/kADv/7AA9/90AoP/dASX/3wEn/98BN//sATn/3QE7/90BYv/fAX//3QGV/90Bm//dAcX/3wHO/98B5f/fAjf/5AI5/+QCYv/fAm7/3wJw/90Ccv/dAnb/3wL4/+wC+v/sAvz/7ANU/90DVv/dA1j/3QNa/90D7AAOABoAOP/OADr/7QA9/9AAoP/QASX/zgEn/84BOf/QATv/0AFi/84Bf//QAZX/0AGb/9ABxf/OAc7/zgHl/84CN//tAjn/7QJi/84Cbv/OAnD/0AJy/9ACdv/OA1T/0ANW/9ADWP/QA1r/0AAQAC7/7gA5/+4AnP/uAJ3/7gCe/+4An//uAPf/7gEr/+4BLf/uAS//7gEx/+4BM//uATX/7gHL/+4DRv/uA0j/7gBKAAYAEAALABAADQAUAEEAEgBH/+gASP/oAEn/6ABL/+gAVf/oAGEAEwCq/+gAq//oAKz/6ACt/+gArv/oAMr/6ADM/+gAzv/oAND/6ADS/+gA1v/oANj/6ADa/+gA3P/oAN7/6ADg/+gA4v/oAOT/6ADm/+gBFv/oAUb/6AFmABABnP/oAaH/6AGy/+gBs//oAfj/6AIE/+gCB//oAhP/6AIU/+gCF//oAjz/6AJA/+gCRP/oAmv/6AJt/+gCmf/oApv/6AKd/+gCq//oAsP/6ALE/+gCxf/oAs//6AMb/+gDHf/oAx//6AMh/+gDI//oAyX/6AMn/+gDKf/oAz3/6AM//+gDQf/oA0X/6ANwABADcQAQA3MAEAN0ABADdQAQA34AEAN/ABAAAgIF/9YDcf+YAD0AR//sAEj/7ABJ/+wAS//sAFX/7ACq/+wAq//sAKz/7ACt/+wArv/sAMr/7ADM/+wAzv/sAND/7ADS/+wA1v/sANj/7ADa/+wA3P/sAN7/7ADg/+wA4v/sAOT/7ADm/+wBFv/sAUb/7AGc/+wBof/sAbL/7AGz/+wB+P/sAgT/7AIH/+wCE//sAhT/7AIX/+wCPP/sAkD/7AJE/+wCa//sAm3/7AKZ/+wCm//sAp3/7AKr/+wCw//sAsT/7ALF/+wCz//sAxv/7AMd/+wDH//sAyH/7AMj/+wDJf/sAyf/7AMp/+wDPf/sAz//7ANB/+wDRf/sABgAU//iALX/4gC2/+IAt//iALj/4gC5/+IBEP/iARL/4gEU/+IBr//iAbz/4gIB/+ICNv/iAqn/4gKt/+IDL//iAzH/4gMz/+IDNf/iAzf/4gM5/+IDO//iA0P/4gNxABgABgAQ/4QAEv+EA3L/hAN2/4QDev+EA3v/hAAQAC7/7AA5/+wAnP/sAJ3/7ACe/+wAn//sAPf/7AEr/+wBLf/sAS//7AEx/+wBM//sATX/7AHL/+wDRv/sA0j/7AALAFv/zAPW/9cD1/+4A9j/7gPZ/70D3P/yA97/8gPm//ED6v/zA+wAEwP3/7cABABKABQAWAAyAFsAEQNxABAAHgAG//IAC//yAFr/8wBd//MAwP/zAML/8wE6//MBZv/yAaP/8wGt//MCBf/1Agb/8wIh//MCOP/zAjr/8wJx//MCsf/zArP/8wK1//MDVf/zA1f/8wNZ//MDW//zA3D/8gNx//IDc//yA3T/8gN1//IDfv/yA3//8gAIAFv/5QGW/8sBuP/kA9z/7APe/+wD5v/rA+r/7QPsAA0APgAn//MAK//zADP/8wA1//MAiv/zAJX/8wCW//MAl//zAJj/8wCZ//MAm//zAMn/8wDL//MAzf/zAM//8wDf//MA4f/zAOP/8wDl//MBD//zARH/8wET//MBFf/zAUX/8wFS//MBfv/zAYn/8wGQ//MBqwANAcf/8wHh//MB5P/zAiP/8wI1//MCO//zAj3/8wI///MCQf/zAkP/8wJq//MCbP/zAqj/8wKq//MCrP/zAs7/8wMu//MDMP/zAzL/8wM0//MDNv/zAzj/8wM6//MDPP/zAz7/8wNA//MDQv/zA0T/8wNc//MEMf/zBDL/8wQ0//MENf/zAD8AJ//mACv/5gAz/+YANf/mAIr/5gCV/+YAlv/mAJf/5gCY/+YAmf/mAJv/5gDJ/+YAy//mAM3/5gDP/+YA3//mAOH/5gDj/+YA5f/mAQ//5gER/+YBE//mARX/5gFF/+YBUv/mAX7/5gGJ/+YBkP/mAZb/wgGrABABx//mAeH/5gHk/+YCI//mAjX/5gI7/+YCPf/mAj//5gJB/+YCQ//mAmr/5gJs/+YCqP/mAqr/5gKs/+YCzv/mAy7/5gMw/+YDMv/mAzT/5gM2/+YDOP/mAzr/5gM8/+YDPv/mA0D/5gNC/+YDRP/mA1z/5gQx/+YEMv/mBDT/5gQ1/+YANwAl/+QAPP/SAD3/0wCD/+QAhP/kAIX/5ACG/+QAh//kAIj/5ACg/9MAw//kAMX/5ADH/+QBOf/TATv/0wFO/+QBef/kAX//0wGC/+QBhf/kAYz/5AGV/9MBl//SAZv/0wGr/+IB0//kAdn/0gHo/9ICKf/kAlj/0gJw/9MCcv/TAnT/0gKD/9ICkv/kApT/5AKe/9ICvv/SAtb/5AMC/+QDBP/kAwb/5AMI/+QDCv/kAwz/5AMO/+QDEP/kAxL/5AMU/+QDFv/kAxj/5ANU/9MDVv/TA1j/0wNa/9MAJwAQ/0YAEv9GACX/zQCD/80AhP/NAIX/zQCG/80Ah//NAIj/zQDD/80Axf/NAMf/zQFO/80Bef/NAYL/zQGF/80BjP/NAbH/8gHT/80CKf/NApL/zQKU/80C1v/NAwL/zQME/80DBv/NAwj/zQMK/80DDP/NAw7/zQMQ/80DEv/NAxT/zQMW/80DGP/NA3L/RgN2/0YDev9GA3v/RgABAasADgCvAEf/3ABI/9wASf/cAEv/3ABR/8EAUv/BAFP/1gBU/8EAVf/cAFn/3QBa/+EAXf/hAKr/3ACr/9wArP/cAK3/3ACu/9wAtP/BALX/1gC2/9YAt//WALj/1gC5/9YAvP/dAL3/3QC+/90Av//dAMD/4QDC/+EAyv/cAMz/3ADO/9wA0P/cANL/3ADW/9wA2P/cANr/3ADc/9wA3v/cAOD/3ADi/9wA5P/cAOb/3AEH/8EBCf/BAQv/wQEM/8EBEP/WARL/1gEU/9YBFv/cASz/3QEu/90BMP/dATL/3QE0/90BNv/dATr/4QFG/9wBSP/dAZz/3AGe/8EBoP/dAaH/3AGj/+EBpf/mAaf/wQGo/+sBqf/pAa3/4QGu//ABr//WAbD/5wGy/9wBs//cAbT/4wG1/90Btv/OAbj/1AG5/9sBu//dAbz/1gG9/90B9v/BAfj/3AH7/8EB/P/BAf3/wQH//8ECAP/BAgH/1gIC/8ECA//BAgT/3AIG/+ECB//cAgn/wQIL/8ECDP/BAg//wQIR/8ECE//cAhT/3AIW/8ECF//cAh3/wQIf/8ECIP/BAiH/4QI2/9YCOP/hAjr/4QI8/9wCQP/cAkT/3AJN/8ECXf/BAmX/wQJn/8ECa//cAm3/3AJx/+ECiv/BAoz/wQKQ/8ECmf/cApv/3AKd/9wCpf/BAqf/wQKp/9YCq//cAq3/1gKx/+ECs//hArX/4QK5/8ECu//BAr3/wQLD/9wCxP/cAsX/3ALP/9wC5//BAxv/3AMd/9wDH//cAyH/3AMj/9wDJf/cAyf/3AMp/9wDL//WAzH/1gMz/9YDNf/WAzf/1gM5/9YDO//WAz3/3AM//9wDQf/cA0P/1gNF/9wDR//dA0n/3QNL/90DTf/dA0//3QNR/90DU//dA1X/4QNX/+EDWf/hA1v/4QB2AAb/2gAL/9oAR//wAEj/8ABJ//AAS//wAFX/8ABZ/+8AWv/cAF3/3ACq//AAq//wAKz/8ACt//AArv/wALz/7wC9/+8Avv/vAL//7wDA/9wAwv/cAMr/8ADM//AAzv/wAND/8ADS//AA1v/wANj/8ADa//AA3P/wAN7/8ADg//AA4v/wAOT/8ADm//ABFv/wASz/7wEu/+8BMP/vATL/7wE0/+8BNv/vATr/3AFG//ABSP/vAWb/2gGc//ABoP/vAaH/8AGj/9wBqP/sAasADwGt/9wBsP/qAbL/8AGz//ABtP/OAbX/7wG2/+cBu//vAb3/7wH4//ACBP/wAgb/3AIH//ACE//wAhT/8AIX//ACIf/cAjj/3AI6/9wCPP/wAkD/8AJE//ACa//wAm3/8AJx/9wCmf/wApv/8AKd//ACq//wArH/3AKz/9wCtf/cAsP/8ALE//ACxf/wAs//8AMb//ADHf/wAx//8AMh//ADI//wAyX/8AMn//ADKf/wAz3/8AM///ADQf/wA0X/8ANH/+8DSf/vA0v/7wNN/+8DT//vA1H/7wNT/+8DVf/cA1f/3ANZ/9wDW//cA3D/2gNx/9oDc//aA3T/2gN1/9oDfv/aA3//2gBEABAADAASAAwAR//nAEj/5wBJ/+cAS//nAFX/5wCq/+cAq//nAKz/5wCt/+cArv/nAMr/5wDM/+cAzv/nAND/5wDS/+cA1v/nANj/5wDa/+cA3P/nAN7/5wDg/+cA4v/nAOT/5wDm/+cBFv/nAUb/5wGc/+cBof/nAasADwGy/+cBs//nAfj/5wIE/+cCB//nAhP/5wIU/+cCF//nAjz/5wJA/+cCRP/nAmv/5wJt/+cCmf/nApv/5wKd/+cCq//nAsP/5wLE/+cCxf/nAs//5wMb/+cDHf/nAx//5wMh/+cDI//nAyX/5wMn/+cDKf/nAz3/5wM//+cDQf/nA0X/5wNyAAwDdgAMA3oADAN7AAwABgG0/+oB9//uAgX/1QIP/+0CY//sAtH/7AABAgX/wAABAbQAIAB+AAYADAALAAwAR//oAEj/6ABJ/+gASgAMAEv/6ABT/+oAVf/oAFoACwBdAAsAqv/oAKv/6ACs/+gArf/oAK7/6AC1/+oAtv/qALf/6gC4/+oAuf/qAMAACwDCAAsAyv/oAMz/6ADO/+gA0P/oANL/6ADW/+gA2P/oANr/6ADc/+gA3v/oAOD/6ADi/+gA5P/oAOb/6AEQ/+oBEv/qART/6gEW/+gBOgALAUb/6AFmAAwBnP/oAaH/6AGjAAsBq/+QAa0ACwGv/+oBsAALAbL/6AGz/+gBtAAMAbz/6gH4/+gCAf/qAgT/6AIGAAsCB//oAhP/6AIU/+gCF//oAiEACwI2/+oCOAALAjoACwI8/+gCQP/oAkT/6AJr/+gCbf/oAnEACwKZ/+gCm//oAp3/6AKp/+oCq//oAq3/6gKxAAsCswALArUACwLD/+gCxP/oAsX/6ALP/+gDG//oAx3/6AMf/+gDIf/oAyP/6AMl/+gDJ//oAyn/6AMv/+oDMf/qAzP/6gM1/+oDN//qAzn/6gM7/+oDPf/oAz//6ANB/+gDQ//qA0X/6ANVAAsDVwALA1kACwNbAAsDcAAMA3EADANzAAwDdAAMA3UADAN+AAwDfwAMA9cADQPZAA4D2v/1A9z/7APe/+0D5v/sA+r/7gPs/78D9wANAAECBf/iAA0AXP/tAF7/7QE9/+0BP//tAUH/7QH5/+0CBf/AAgj/7QJZ/+0Cdf/tAoT/7QKf/+0Cv//tAAwAXP/yAF7/8gE9//IBP//yAUH/8gH5//ICCP/yAln/8gJ1//IChP/yAp//8gK///IAHwBa//QAXP/yAF3/9ABe//MAwP/0AML/9AE6//QBPf/zAT//8wFB//MBo//0Aa3/9AH5//ICBv/0Agj/8gIh//QCOP/0Ajr/9AJZ//ICcf/0AnX/8gKE//ICn//yArH/9AKz//QCtf/0Ar//8gNV//QDV//0A1n/9ANb//QAXQAG/8oAC//KADj/0gA6/9QAPP/0AD3/0wBa/+YAXP/vAF3/5gCg/9MAwP/mAML/5gEl/9IBJ//SATn/0wE6/+YBO//TAWL/0gFm/8oBf//TAZX/0wGX//QBm//TAaP/5gGt/+YBxf/SAc7/0gHR/+0B2f/0AeX/0gHm/+0B6P/0Aer/4QHv/9QB+f/vAgX/yQIG/+YCCP/vAg//0QIh/+YCJP/lAjf/1AI4/+YCOf/UAjr/5gJC/+MCWP/0Aln/7wJi/9ICY//EAm7/0gJw/9MCcf/mAnL/0wJ0//QCdf/vAnb/0gJ4/+ECev/hAoP/9AKE/+8Cjf/hAp7/9AKf/+8CsP/tArH/5gKy/+0Cs//mArT/7QK1/+YCtv/hAr7/9AK//+8Cxv/UAsf/9QLI/+cC0P9kAtH/yQNU/9MDVf/mA1b/0wNX/+YDWP/TA1n/5gNa/9MDW//mA3D/ygNx/8oDc//KA3T/ygN1/8oDfv/KA3//ygBsAAb/wAAL/8AAOP+dADr/xwA8//AAPf+rAFH/0gBS/9IAVP/SAKD/qwC0/9IBB//SAQn/0gEL/9IBDP/SASX/nQEn/50BOf+rATv/qwFi/50BZv/AAX//qwGV/6sBl//wAZv/qwGe/9IBp//SAcX/nQHM//UBzv+dAdH/6gHZ//AB3v/1AeX/nQHm/+oB6P/wAer/5QHv/8EB9v/SAfv/0gH8/9IB/f/SAf//0gIA/9ICAv/SAgP/0gIF/80CCf/SAgv/0gIM/9ICD//SAhH/0gIW/9ICHf/SAh//0gIg/9ICN//HAjn/xwJN/9ICWP/wAl3/0gJi/50CY//MAmX/0gJn/9ICbv+dAnD/qwJy/6sCdP/wAnb/nQJ4/+UCev/lAn7/3wKD//ACh//1Aor/0gKM/9ICjf/lApD/0gKe//ACpf/SAqf/0gKw/+oCsv/qArT/6gK2/+UCuf/SArv/0gK9/9ICvv/wAsb/zgLI/+oCyv/1AtD/ngLR/84C1P/1Auf/0gNU/6sDVv+rA1j/qwNa/6sDcP/AA3H/wANz/8ADdP/AA3X/wAN+/8ADf//AAG8ABv+xAAv/sQA4/54AOv/FADz/8gA9/6gAUf/PAFL/zwBU/88AXP/vAKD/qAC0/88BB//PAQn/zwEL/88BDP/PASX/ngEn/54BOf+oATv/qAFi/54BZv+xAX//qAGV/6gBl//yAZv/qAGe/88Bp//PAcX/ngHO/54B0f/sAdn/8gHl/54B5v/sAej/8gHq/+EB7//CAfb/zwH5/+8B+//PAfz/zwH9/88B///PAgD/zwIC/88CA//PAgX/xgII/+8CCf/PAgv/zwIM/88CD//PAhH/zwIW/88CHf/PAh//zwIg/88CN//FAjn/xQJN/88CWP/yAln/7wJd/88CYv+eAmP/wAJl/88CZ//PAm7/ngJw/6gCcv+oAnT/8gJ1/+8Cdv+eAnj/4QJ6/+ECfv/fAoP/8gKE/+8Civ/PAoz/zwKN/+ECkP/PAp7/8gKf/+8Cpf/PAqf/zwKw/+wCsv/sArT/7AK2/+ECuf/PArv/zwK9/88Cvv/yAr//7wLG/80CyP/oAtD/nwLR/8YC5//PA1T/qANW/6gDWP+oA1r/qANw/7EDcf+xA3P/sQN0/7EDdf+xA37/sQN//7EATQA4/74AUf/hAFL/4QBU/+EAWv/vAF3/7wC0/+EAwP/vAML/7wEH/+EBCf/hAQv/4QEM/+EBJf++ASf/vgE6/+8BYv++AZ7/4QGj/+8Bp//hAa3/7wHF/74Bzv++AeX/vgHv/8kB9v/hAfv/4QH8/+EB/f/hAf//4QIA/+ECAv/hAgP/4QIF/98CBv/vAgn/4QIL/+ECDP/hAg//4QIR/+ECFv/hAh3/4QIf/+ECIP/hAiH/7wIk/+0COP/vAjr/7wJC/+sCTf/hAl3/4QJi/74CY//fAmX/4QJn/+ECbv++AnH/7wJ2/74Cfv/pAor/4QKM/+ECkP/hAqX/4QKn/+ECsf/vArP/7wK1/+8Cuf/hArv/4QK9/+ECx//1AtH/4ALn/+EDVf/vA1f/7wNZ/+8DW//vAGQAOP/mADr/5wA8//IAPf/nAFH/1gBS/9YAVP/WAFz/8QCg/+cAtP/WAQf/1gEJ/9YBC//WAQz/1gEl/+YBJ//mATn/5wE7/+cBYv/mAX//5wGV/+cBl//yAZv/5wGe/9YBp//WAcX/5gHO/+YB0f/uAdn/8gHl/+YB5v/uAej/8gHq/+gB7//mAfb/1gH5//EB+//WAfz/1gH9/9YB///WAgD/1gIC/9YCA//WAgX/0AII//ECCf/WAgv/1gIM/9YCD//WAhH/1gIW/9YCHf/WAh//1gIg/9YCN//nAjn/5wJN/9YCWP/yAln/8QJd/9YCYv/mAmP/zgJl/9YCZ//WAm7/5gJw/+cCcv/nAnT/8gJ1//ECdv/mAnj/6AJ6/+gCg//yAoT/8QKK/9YCjP/WAo3/6AKQ/9YCnv/yAp//8QKl/9YCp//WArD/7gKy/+4CtP/uArb/6AK5/9YCu//WAr3/1gK+//ICv//xAsb/5wLI/+0C0P/mAtH/0ALn/9YDVP/nA1b/5wNY/+cDWv/nAAICLQALAtD/5gCTACUAEAAn/+gAK//oADP/6AA1/+gAOP/gADr/4AA9/98AgwAQAIQAEACFABAAhgAQAIcAEACIABAAiv/oAJX/6ACW/+gAl//oAJj/6ACZ/+gAm//oAKD/3wDDABAAxQAQAMcAEADJ/+gAy//oAM3/6ADP/+gA3//oAOH/6ADj/+gA5f/oAQ//6AER/+gBE//oARX/6AEl/+ABJ//gATn/3wE7/98BRf/oAU4AEAFS/+gBYv/gAXkAEAF+/+gBf//fAYIAEAGFABABif/oAYwAEAGQ/+gBlf/fAZv/3wHF/+ABx//oAcwAEAHO/+AB0wAQAdcAFAHeABAB4f/oAeT/6AHl/+AB6v/hAe//4AH3ABMB/gAQAgr/4AIcABACI//oAikAEAI1/+gCN//gAjn/4AI7/+gCPf/oAj//6AJB/+gCQ//oAmL/4AJq/+gCbP/oAm7/4AJw/98Ccv/fAnb/4AJ4/+ECef/gAnr/4QJ7/+ACf//hAocAEAKIABACjf/hAo7/4AKSABAClAAQApr/6QKo/+gCqv/oAqz/6AK2/+ECt//gAsb/3wLI/94CygAQAs7/6ALQ/98C0v/yAtQAEALVABAC1gAQAwIAEAMEABADBgAQAwgAEAMKABADDAAQAw4AEAMQABADEgAQAxQAEAMWABADGAAQAy7/6AMw/+gDMv/oAzT/6AM2/+gDOP/oAzr/6AM8/+gDPv/oA0D/6ANC/+gDRP/oA1T/3wNW/98DWP/fA1r/3wNc/+gEMf/oBDL/6AQ0/+gENf/oADIAG//yADj/8QA6//QAPP/0AD3/8ACg//ABJf/xASf/8QE5//ABO//wAWL/8QF///ABlf/wAZf/9AGb//ABxf/xAcz/9QHO//EB0f/zAdn/9AHe//UB5f/xAeb/8wHo//QB7//xAjf/9AI5//QCWP/0AmL/8QJu//ECcP/wAnL/8AJ0//QCdv/xAoP/9AKH//UCnv/0ArD/8wKy//MCtP/zAr7/9ALG//ICyP/yAsr/9QLQ//IC1P/1A1T/8ANW//ADWP/wA1r/8AAIAFgADgCJ/tcBq/+YAbH/xwHX/xIB9/9SAsL/zwPs/4AAZgAlAA8AOP/mADr/5gA8AA4APf/mAIMADwCEAA8AhQAPAIYADwCHAA8AiAAPAKD/5gDDAA8AxQAPAMcADwEl/+YBJ//mATn/5gE7/+YBTgAPAWL/5gF5AA8Bf//mAYIADwGFAA8BjAAPAZX/5gGXAA4Bm//mAcX/5gHMAA4Bzv/mAdEACwHTAA8B1wATAdkADgHeAA4B5f/mAeYACwHoAA4B6v/lAe//5gHw//QB9wASAf4ADwIF/+cCCv/oAg//5wIcAA8CKQAPAjf/5gI5/+YCWAAOAmL/5gJj/+cCbv/mAnD/5gJy/+YCdAAOAnb/5gJ4/+UCef/oAnr/5QJ7/+gCgwAOAocADgKIAA8Cjf/lAo7/6AKSAA8ClAAPAp4ADgKwAAsCsgALArQACwK2/+UCt//oAr4ADgLG/+YCyP/mAsoADgLQ/+YC0f/nAtQADgLVAA8C1gAPAwIADwMEAA8DBgAPAwgADwMKAA8DDAAPAw4ADwMQAA8DEgAPAxQADwMWAA8DGAAPA1T/5gNW/+YDWP/mA1r/5gA3AAb/vwAL/78AOP+fADr/yQA9/60AoP+tASX/nwEn/58BOf+tATv/rQFi/58BZv+/AX//rQGV/60Bm/+tAcX/nwHO/58B0f/sAeX/nwHm/+wB6v/mAe//xAIF/80CD//VAjf/yQI5/8kCYv+fAmP/zAJu/58CcP+tAnL/rQJ2/58CeP/mAnr/5gJ+/98Cjf/mArD/7AKy/+wCtP/sArb/5gLG/9ECyP/sAtD/oQLR/88DVP+tA1b/rQNY/60DWv+tA3D/vwNx/78Dc/+/A3T/vwN1/78Dfv+/A3//vwAwADj/4wA8/+UAPf/kAKD/5AEl/+MBJ//jATn/5AE7/+QBYv/jAX//5AGV/+QBl//lAZv/5AHF/+MBzP/lAc7/4wHR/+kB1//iAdn/5QHe/+UB5f/jAeb/6QHo/+UB/v/qAhz/6gJY/+UCYv/jAm7/4wJw/+QCcv/kAnT/5QJ2/+MCg//lAof/5QKI/+oCnv/lArD/6QKy/+kCtP/pAr7/5QLK/+UC0P/kAtT/5QLV/+oDVP/kA1b/5ANY/+QDWv/kACMAOP/iADz/5AEl/+IBJ//iAWL/4gGX/+QBxf/iAcz/5AHO/+IB0f/pAdf/4QHZ/+QB3v/kAeX/4gHm/+kB6P/kAff/5AH+/+sCHP/rAlj/5AJi/+ICbv/iAnT/5AJ2/+ICg//kAof/5AKI/+sCnv/kArD/6QKy/+kCtP/pAr7/5ALK/+QC1P/kAtX/6wAXADj/6wA9//MAoP/zASX/6wEn/+sBOf/zATv/8wFi/+sBf//zAZX/8wGb//MBxf/rAc7/6wHl/+sCYv/rAm7/6wJw//MCcv/zAnb/6wNU//MDVv/zA1j/8wNa//MANgBR/+8AUv/vAFT/7wBc//AAtP/vAQf/7wEJ/+8BC//vAQz/7wGe/+8Bp//vAfb/7wH3/+4B+f/wAfv/7wH8/+8B/f/vAf//7wIA/+8CAv/vAgP/7wIF/+4CCP/wAgn/7wIL/+8CDP/vAg//7wIR/+8CFv/vAh3/7wIf/+8CIP/vAiT/9AJC//ECTf/vAln/8AJd/+8CY//vAmX/7wJn/+8Cdf/wAoT/8AKK/+8CjP/vApD/7wKf//ACpf/vAqf/7wK5/+8Cu//vAr3/7wK///AC0f/vAuf/7wAiAAb/8gAL//IAWv/1AF3/9QDA//UAwv/1ATr/9QFm//IBo//1Aa3/9QIF//QCBv/1Ag//9AIh//UCJP/1Ajj/9QI6//UCY//1AnH/9QKx//UCs//1ArX/9QLR//UDVf/1A1f/9QNZ//UDW//1A3D/8gNx//IDc//yA3T/8gN1//IDfv/yA3//8gAyAFH/7gBS/+4AVP/uALT/7gEH/+4BCf/uAQv/7gEM/+4Bnv/uAaf/7gH2/+4B9wAUAfv/7gH8/+4B/f/uAf//7gIA/+4CAv/uAgP/7gIF/+0CCf/uAgr/7QIL/+4CDP/uAg3/0AIP/+4CEf/uAhb/7gId/+4CH//uAiD/7gJN/+4CXf/uAmP/7QJl/+4CZ//uAnn/7QJ7/+0Civ/uAoz/7gKO/+0CkP/uAqX/7gKn/+4Ct//tArn/7gK7/+4Cvf/uAtH/7QLn/+4ACgAG//UAC//1AWb/9QNw//UDcf/1A3P/9QN0//UDdf/1A37/9QN///UAWQBH//AASP/wAEn/8ABL//AAU//HAFX/8ACq//AAq//wAKz/8ACt//AArv/wALX/xwC2/8cAt//HALj/xwC5/8cAyv/wAMz/8ADO//AA0P/wANL/8ADW//AA2P/wANr/8ADc//AA3v/wAOD/8ADi//AA5P/wAOb/8AEQ/8cBEv/HART/xwEW//ABRv/wAZz/8AGh//ABr//HAbL/8AGz//ABvP/HAfj/8AIB/8cCBP/wAgf/8AIT//ACFP/wAhf/8AI2/8cCPP/wAj7/6wJA//ACRP/wAmv/8AJt//ACmf/wApv/8AKd//ACqf/HAqv/8AKt/8cCw//wAsT/8ALF//ACz//wAxv/8AMd//ADH//wAyH/8AMj//ADJf/wAyf/8AMp//ADL//HAzH/xwMz/8cDNf/HAzf/xwM5/8cDO//HAz3/8AM///ADQf/wA0P/xwNF//AD3P/rA97/6wPm/+kD6v/rAKEABgANAAsADQBF//AAR//AAEj/wABJ/8AASgANAEv/wABT/+IAVf/AAFoACwBdAAsAo//wAKT/8ACl//AApv/wAKf/8ACo//AAqv/AAKv/wACs/8AArf/AAK7/wAC1/+IAtv/iALf/4gC4/+IAuf/iAMAACwDCAAsAxP/wAMb/8ADI//AAyv/AAMz/wADO/8AA0P/AANL/wADW/8AA2P/AANr/wADc/8AA3v/AAOD/wADi/8AA5P/AAOb/wAEQ/+IBEv/iART/4gEW/8ABOgALAUb/wAFP//ABZgANAZz/wAGh/8ABowALAa0ACwGv/+IBsf/WAbL/wAGz/8ABtv/VAbz/4gHz//AB9//IAfj/wAH+/9cCAf/iAgT/wAIGAAsCB//AAhP/wAIU/8ACF//AAhz/1wIhAAsCNv/iAjgACwI6AAsCPP/AAj7/7AJA/8ACQgAMAkT/wAJr/8ACbf/AAnEACwKI/9cCk//wApX/8AKZ/8ACm//AAp3/wAKp/+ICq//AAq3/4gKxAAsCswALArUACwLD/8ACxP/AAsX/wALHAAsCyQALAs//wALV/9cC1//wAwP/8AMF//ADB//wAwn/8AML//ADDf/wAw//8AMR//ADE//wAxX/8AMX//ADGf/wAxv/wAMd/8ADH//AAyH/wAMj/8ADJf/AAyf/wAMp/8ADL//iAzH/4gMz/+IDNf/iAzf/4gM5/+IDO//iAz3/wAM//8ADQf/AA0P/4gNF/8ADVQALA1cACwNZAAsDWwALA3AADQNxAA0DcwANA3QADQN1AA0DfgANA38ADQPXAA0D2QAOA9r/9QPc/+wD3v/tA+b/7APq/+4D7P+/A/cADQAPAfcAFAH+ABACBf/wAgr/8AIP//ACEgAWAhwAEAJj/+YCef/wAnv/3AKIABACjv/wArf/8ALR//AC1QAQAEwAR//uAEj/7gBJ/+4AS//uAFX/7gCq/+4Aq//uAKz/7gCt/+4Arv/uAMr/7gDM/+4Azv/uAND/7gDS/+4A1v/uANj/7gDa/+4A3P/uAN7/7gDg/+4A4v/uAOT/7gDm/+4BFv/uAUb/7gGc/+4Bof/uAbL/7gGz/+4B9wASAfj/7gH+AA4CBP/uAgX/4wIH/+4CCv/jAg3/uAIP/+MCE//uAhT/7gIX/+4CHAAOAjz/7gJA/+4CRP/uAmP/ugJr/+4Cbf/uAnn/4wJ7/9kCiAAOAo7/4wKZ/+4Cm//uAp3/7gKr/+4Ct//jAsP/7gLE/+4Cxf/uAs//7gLR/+MC1QAOAxv/7gMd/+4DH//uAyH/7gMj/+4DJf/uAyf/7gMp/+4DPf/uAz//7gNB/+4DRf/uACAAWv/AAF3/wADA/8AAwv/AATr/wAGj/8ABrf/AAgX/gAIG/8ACCv/uAg//8AIh/8ACJP/bAjj/wAI6/8ACQv/cAmP/RwJx/8ACef/uAnv/7gKO/+4Csf/AArP/wAK1/8ACt//uAscABwLJ//QC0f9/A1X/wANX/8ADWf/AA1v/wAAhAFr/9ABc//AAXf/0AMD/9ADC//QBOv/0AaP/9AGt//QB9//vAfn/8AH+//MCBv/0Agj/8AIP/+4CHP/zAiH/9AI4//QCOv/0Aln/8AJx//QCdf/wAoT/8AKI//MCn//wArH/9AKz//QCtf/0Ar//8ALV//MDVf/0A1f/9ANZ//QDW//0AAoABv/WAAv/1gFm/9YDcP/WA3H/1gNz/9YDdP/WA3X/1gN+/9YDf//WABUAXP/gAfn/4AIF/3YCCP/gAgr/wgIP/9MCJP/ZAkL/2wJZ/+ACY/8eAnX/4AJ5/8ICe//tAoT/4AKO/8ICn//gArf/wgK//+ACx//wAsn/8gLR/1YADQIF/2QCCv/SAg//2QIk/9kCQv/bAmP/HgJ5/9ICe//tAo7/0gK3/9ICx//wAsn/8gLR/1YACgHv/8MCBf/PAg//1AJj/84Cev/nAn7/3wLG/9ECyP/sAtD/oALR/9EACQIF/2oCD//GAiT/2QJC/9sCY/8eAnv/7QLH//ACyf/yAtH/VgAJAA0AFABBABEAVv/iAGEAEwPc/9kD3v/ZA+b/2QPq/9kD7P+0AAoABv/XAAv/1wFm/9cDcP/XA3H/1wNz/9cDdP/XA3X/1wN+/9cDf//XABQAW//BAZb/xQG0/7QB9P/XAgX/uQIP/+kCJP+yAj7/0gJC/8gCY/+gAnv/xQKa/+QCx//MAsn/zALR/8sC0v/vA9z/5wPe/+cD5v/mA+r/6AA6AAT/xABW/78AW//RAG7/bAB+/24Aif9DAKn/rAC7/6EBlv+4AaX/fgGp/3sBsP+bAbH/eQG0/7IBtv9+Abj/fQG5/3wB1/+vAe8ADwH0/+QB9f+gAff/dAH6/4ACBf+yAg7/fQIP/7ICEP+AAhL/eQIVACgCIv99AiT/fwI+/2YCQv/aAlH/gQJT/5gCX/99AmP/swJp/6ACe/98An7/mgJ//2wCmv/mAsL/awLH/5ICyf+tAs3/ewLQAA8C0f+RAtL/8gPW//ED2f/xA9r/vAPc/7kD3v+5A+b/uQPq/7kD7P+vA/b/7QAGAbT/6gH3/+4CBf/WAg//7QJj/+wC0f/sABIB1/+uAe8AEgH1/+AB9/+tAfr/1gIO/98CEv/SAiL/4AI+/84CUf/dAlP/4gJf/+ACaf/gAnv/6QJ//9oCwv+9As3/3wLQABEAMABW/34AW/+dAG7+8QB+/vQAif6rAKn/XgC7/0sBlv9yAaX/DwGp/woBsP9BAbH/BwG0/2gBtv8PAbj/DgG5/wwB1/9jAe8ABQH0/70B9f9JAff+/gH6/xMCBf9oAg7/DgIP/2gCEP8TAhL/BwIVADACIv8OAiT/EQI+/ucCQv+sAlH/FQJT/zwCX/8OAmP/agJp/0kCe/8MAn7/PwJ//vECmv/AAsL+7wLH/zECyf9fAs3/CgLQAAUC0f8wAtL/1QACAff/aAI+/+4AFwGW/9QBqP/tAasAEQG0/+ABtv/nAbj/5QG5/+4B1wASAfT/6QIF/9cCY//XAnv/0wJ+/9YCf//FApr/5wLGAA0CyAAMAtH/1gLS//ID3P/pA97/5wPm/+cD6v/pAAECPv/xAAICBf/WA3H/iAAJAA0ADwBBAAwAVv/rAGEADgPc/+cD3v/nA+b/5wPq/+kD7P/LAB0AI/+vAFj/7wBb/98BR//uAZb/5QGY/9EBqwARAbT/yAHXABMB7//FAgX/ygIP/9ACY/+BAnr/ZQJ7/4UCfv9mAn//3QKa//ICxv+xAsj/ygLQ/6kC0f/IA9b/3QPX/80D2P/xA9n/xwPe//UD5v/1A/f/xAAIAgX/8AIP//ACJP/xAkL/8wJj//ECx//zAsn/8wLR//EABQBK/+4AW//qA9b/7QPX//AD9//wAAICBf/1A3H/wAAIAdcAFQH3ABUCev/kAnv/5QJ+/+QCxv/jAsj/4gLQ/+QACQG0/+oB9/+4AgX/4gIk//ACQv/xAmP/6wLH//UC0f/sA3H/kAABA+z/6wAiAAr/4gANABQADv/PAEEAEgBK/+oAVv/YAFj/6gBhABMAbv+uAH7/zQCJ/6AAqf/BALv/wAGW/9ABov/qAaX/xgGmAA0BqP/pAan/1gGw/+gBsf+6AbT/6QG2/8sBuP/aAbn/xwN5/9MD1v/zA9n/8wPc/8sD3v/LA+b/ywPq/80D7P+rA/b/7wAGAEoADQGwAAsBsf/qAbQADAH3/8gCPv/xAFwAR/+YAEj/mABJ/5gAS/+YAFP/cABV/5gAV/8YAFsACwCq/5gAq/+YAKz/mACt/5gArv+YALX/cAC2/3AAt/9wALj/cAC5/3AAyv+YAMz/mADO/5gA0P+YANL/mADW/5gA2P+YANr/mADc/5gA3v+YAOD/mADi/5gA5P+YAOb/mAEQ/3ABEv9wART/cAEW/5gBHv8YASD/GAEi/xgBJP8YAUb/mAFh/xgBnP+YAaH/mAGv/3ABsv+YAbP/mAG8/3AB+P+YAgH/cAIE/5gCB/+YAhP/mAIU/5gCF/+YAhj/GAI2/3ACPP+YAkD/mAJE/5gCa/+YAm3/mAKZ/5gCm/+YAp3/mAKp/3ACq/+YAq3/cALD/5gCxP+YAsX/mALP/5gDG/+YAx3/mAMf/5gDIf+YAyP/mAMl/5gDJ/+YAyn/mAMv/3ADMf9wAzP/cAM1/3ADN/9wAzn/cAM7/3ADPf+YAz//mANB/5gDQ/9wA0X/mAABAFsACwACA9cADQP3AA0ABAPW//UD1//xA9n/8gP3/+4ABAPW//ED1//rA9n/6QP3/+UABAPX//ED2f/uA/b/7AP3/+oABwPW/9UD1/+3A9j/7APZ/7sD3P/wA97/7wP3/7QAAgPc/+sD3v/rAAID1v/1A9f/7gAJA9b/2APX/8cD2P/sA9n/wAPc//ID3v/yA+b/8gPq//ID9/+/AAQADf/mAEH/9ABh/+8Cf//tAAkAif/fAY//8wGT//ABq//qAdf/3wHv/+AC0P/gA+z/7QP2//UAAgeKAAQAAAqkEqAAIQAdAAD/2/+I/87/xf/s/6X/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/uMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+IAAAAAAAA/9D/9AAA/+v/iP/v/7P/2f9q//X/zgAMABH/yQAS/98AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+UAAP/oAAD/yQAAAAAAAAAAAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/jAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+sAAAAAAAAAAAAAAAD/qwAA/+oAAP/VAAAAAAAA/+EAAAAAAAAAAP+G/+r/6QAAAAAAAAAAAAAAAAAAAAD/7QAA/+0AAAAAABQAAAAAAAAAAP/v/+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgAAAAAAAAAAAAAAAP/jAAAAAAAA/+QAAAAAAAAAEf/kABH/5QAAAAAAEQAAAAAAAAAAAAAAAAAA/+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/5gAA/+UAAP/hAAAAAAAAAAAAAP/p/9gAAAAAAAAAAP+jAAAAAAAAAAD/XAAAAAAAAAAA/uAAEwAAAAAAAAAAAAD/wP8z/+j/Mv+j/un/8v+FAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/07/9f/zAAD/8wAAAAAAAAAAAAAAAAAAAAAADwAA/28AAP+nAAAAAP5s/83/3AAA/0gAAAAAAAAAAP+I/1j/p/+n/zD/tP/kABAAAAAQAA8AEP+//67/xP/LAAD/fv98AAD+/gAAAAD+8P8o//D/swAAAAD/tf/S/9QAAP/SAAD/8wAAAAAAAAAAAAD/5P/1AAAAAAAAAAAAAAAA/ykAAAAA/2MAAAAAAAAAAAAA/9X/3//hAAD/4QAAAAAADgAAAAAAAAAA/+0AAAAAAAAAAAAAAAAAAP9xAAAAAP/EAAAAAAAAAAAAAAAAAAD/5gAA/+sAAP/nAAAAAAAOAAAAAP/r/+EAAAARAAAAEf/RAAAAAAAAAAD/ZAAAAAAAAAAAAAD/av/B/7//2P+//8b/4wAR/6AAEgARABL/2f/s/+IAAAAAAAAAAAAA/xkADQAA/2j/oP/w/+kAAAAAAA0AAP/rAAD/6wAA/+YAAAAAAAAAAAAA/+3/5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1//EAAAAA//IAAAAAAAAAAAAAAAAAAAAA//EAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8f/wAAAAAP/wAAAAAAAAAAAAAAAAAAAAAP/rAAAAEAAA/+L/7QAA/9wAAAAAAAAAAAAAAAAAAAAAABIAAAAAAAAAAAAAAAD/UwAAAAAAAAAAAAAAAAAAAA8AAP/x//MAAP/xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAA/1kAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAD/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAA//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/M/9f/1X/Vf9m/2v/vQAHAAAABwAFAAf/fv9h/4b/kgAA/w//DAAA/jYAAAAA/h4AAP/R/2oAAP/AAAAAAAAAAAAAAAAAAAD/nwAA/8gAAP+tAAAAAAAAAAD/5wAAAAD/6wAAAAAAAAAAAAAAAP/JAAAAAP+l/6//vf+u/73/0v/pABIAAAAAAAAAEgAAAAAAAP/KAAD/u//pAAD+dwAAAAD/OQAAAAAAAAAAAAAAAAAA/+wAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9gAAAAAAAAAAAAAAAAAAAAAAAAAAP95AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/tQAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAP/rAAEBiwAGAAsAEAASACUAJgAnACgAKQAsAC0ALgAvADAAMQAyADMANAA4ADkAOgA7ADwAPQA+AEUARgBHAEkATABRAFIAUwBUAFYAWgBcAF0AXgCDAIQAhQCGAIcAiACKAIsAjACNAI4AjwCQAJEAkgCTAJQAlQCWAJcAmACZAJwAnQCeAJ8AoACjAKQApQCmAKcAqACqAKsArACtAK4AtAC1ALYAtwC4ALkAwADBAMIAwwDEAMUAxgDHAMgAyQDKAMsAzADNAM4AzwDQANEA0wDVANYA1wDYANkA2gDbANwA3QDeAOcA6ADrAO0A7wDxAPMA9wD5APwA/gEAAQIBBgEHAQgBCQEKAQsBDAEPARABEQESARMBFAEYARoBHAElAScBKQErAS0BLwExATMBNQE3ATkBOgE7ATwBPQE+AT8BQAFBAU4BTwFiAWYBeQF7AXwBfQF+AX8BggGDAYQBhQGGAYcBiAGJAYoBiwGMAY0BjgGQAZIBlAGVAZcBmgGbAZ4BowGnAa0BrwGxAbwBwwHEAcYByQHKAcsBzAHNAc8B0QHSAdMB1QHWAdgB2QHbAd0B3gHfAeAB4QHjAeQB5QHmAegB6QHrAe0B7wHzAfYB+AH5AgECAwIEAgYCBwIIAg0CDwIQAhMCFAIWAhwCHQIhAiUCJgIpAjYCNwI4AjkCOgJRAlICUwJUAlgCWQJcAl4CYAJiAmQCbAJtAm4CcAJxAnICdAJ1An0CggKDAoQCiwKPApECkgKTApQClQKYApkCmwKdAp4CnwKoAqkCrQKvArACsQKyArMCtAK1ArgCuQK9Ar4CvwLWAtcC5gLnAvgC+gL8AwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZAxoDGwMcAx0DHgMfAyADIQMiAyMDJAMlAyYDJwMoAykDKgMsAy4DLwMwAzEDMgMzAzQDNQM2AzcDOAM5AzoDOwNDA0YDSANUA1UDVgNXA1gDWQNaA1sDXANwA3EDcgNzA3QDdQN2A3oDewN+A38EMQQzBDQAAgFUABAAEAABABIAEgABACUAJQACACYAJgADACcAJwAEACgAKAAFACkAKQAGACwALQAHAC4ALgAIAC8ALwAJADAAMAAKADEAMgAHADMAMwAFADQANAALADgAOAAMADkAOQAIADoAOgANADsAOwAOADwAPAAPAD0APQAQAD4APgARAEUARQASAEYARgATAEcARwAUAEkASQAVAEwATAAWAFEAUgAWAFMAUwAXAFQAVAATAFYAVgAYAFoAWgAZAFwAXAAaAF0AXQAZAF4AXgAbAIMAiAACAIoAigAEAIsAjgAGAI8AkgAHAJMAkwAFAJQAlAAHAJUAmQAFAJwAnwAIAKAAoAAQAKMAqAASAKoAqgAUAKsArgAVALQAtAAWALUAuQAXAMAAwAAZAMEAwQATAMIAwgAZAMMAwwACAMQAxAASAMUAxQACAMYAxgASAMcAxwACAMgAyAASAMkAyQAEAMoAygAUAMsAywAEAMwAzAAUAM0AzQAEAM4AzgAUAM8AzwAEANAA0AAUANEA0QAFANMA0wAFANUA1QAGANYA1gAVANcA1wAGANgA2AAVANkA2QAGANoA2gAVANsA2wAGANwA3AAVAN0A3QAGAN4A3gAVAOcA5wAHAOgA6AAWAOsA6wAHAO0A7QAHAO8A7wAHAPEA8QAHAPMA8wAHAPcA9wAIAPkA+QAJAPwA/AAKAP4A/gAKAQABAAAKAQIBAgAKAQYBBgAHAQcBBwAWAQgBCAAHAQkBCQAWAQoBCgAHAQsBDAAWAQ8BDwAFARABEAAXAREBEQAFARIBEgAXARMBEwAFARQBFAAXARgBGAAYARoBGgAYARwBHAAYASUBJQAMAScBJwAMASkBKQAMASsBKwAIAS0BLQAIAS8BLwAIATEBMQAIATMBMwAIATUBNQAIATcBNwAOATkBOQAQAToBOgAZATsBOwAQATwBPAARAT0BPQAbAT4BPgARAT8BPwAbAUABQAARAUEBQQAbAU4BTgACAU8BTwASAWIBYgAMAXkBeQACAXsBewAGAXwBfQAHAX4BfgAFAX8BfwAQAYIBggACAYMBgwADAYQBhAAcAYUBhQACAYYBhgAGAYcBhwARAYgBiAAHAYkBiQAFAYoBigAHAYsBiwAJAYwBjAACAY0BjgAHAZABkAAFAZIBkgALAZQBlAAMAZUBlQAQAZcBlwAPAZoBmgAHAZsBmwAQAZ4BngAWAaMBowAZAacBpwAWAa0BrQAZAa8BrwAXAbEBsQATAbwBvAAXAcMBxAAGAcYBxgAcAckBygAHAcsBywAIAcwBzQAdAc8BzwAJAdEB0QAeAdIB0gAHAdMB0wACAdUB1QADAdYB1gAcAdgB2AAGAdkB2QAPAdsB2wAHAd0B3QAJAd4B4AAHAeEB4QAFAeMB4wALAeQB5AAEAeUB5QAMAeYB5gAeAegB6AAPAekB6QAHAesB6wAHAe0B7QAdAe8B7wAdAfMB8wASAfYB9gAfAfgB+AAVAfkB+QAaAgECAQAXAgMCAwATAgQCBAAUAgYCBgAZAgcCBwATAggCCAAaAg0CDQAgAg8CDwAgAhACEAATAhMCFAAVAhYCFgAfAhwCHQAgAiECIQAZAiUCJQAdAiYCJgAgAikCKQACAjYCNgAXAjcCNwANAjgCOAAZAjkCOQANAjoCOgAZAlECUQATAlICUgAcAlMCUwAfAlQCVAAcAlgCWAAPAlkCWQAaAlwCXAAJAl4CXgAJAmACYAAJAmICYgAJAmQCZAAHAmwCbAAEAm0CbQAUAm4CbgAMAnACcAAQAnECcQAZAnICcgAQAnQCdAAPAnUCdQAaAn0CfQAWAoICggAHAoMCgwAPAoQChAAaAosCiwAHAo8CjwAHApECkQAHApICkgACApMCkwASApQClAACApUClQASApgCmAAGApkCmQAVApsCmwAVAp0CnQAVAp4CngAPAp8CnwAaAqgCqAAFAqkCqQAXAq0CrQAXAq8CrwATArACsAAeArECsQAZArICsgAeArMCswAZArQCtAAeArUCtQAZArgCuAAcArkCuQAfAr0CvQAfAr4CvgAPAr8CvwAaAtYC1gACAtcC1wASAuYC5gAHAucC5wAWAvgC+AAOAvoC+gAOAvwC/AAOAwIDAgACAwMDAwASAwQDBAACAwUDBQASAwYDBgACAwcDBwASAwgDCAACAwkDCQASAwoDCgACAwsDCwASAwwDDAACAw0DDQASAw4DDgACAw8DDwASAxADEAACAxEDEQASAxIDEgACAxMDEwASAxQDFAACAxUDFQASAxYDFgACAxcDFwASAxgDGAACAxkDGQASAxoDGgAGAxsDGwAVAxwDHAAGAx0DHQAVAx4DHgAGAx8DHwAVAyADIAAGAyEDIQAVAyIDIgAGAyMDIwAVAyQDJAAGAyUDJQAVAyYDJgAGAycDJwAVAygDKAAGAykDKQAVAyoDKgAHAywDLAAHAy4DLgAFAy8DLwAXAzADMAAFAzEDMQAXAzIDMgAFAzMDMwAXAzQDNAAFAzUDNQAXAzYDNgAFAzcDNwAXAzgDOAAFAzkDOQAXAzoDOgAFAzsDOwAXA0MDQwAXA0YDRgAIA0gDSAAIA1QDVAAQA1UDVQAZA1YDVgAQA1cDVwAZA1gDWAAQA1kDWQAZA1oDWgAQA1sDWwAZA1wDXAAFA3IDcgABA3YDdgABA3oDewABBDEEMQAEBDMENAAFAAEABgQwAAEAAAAAAAAAAAABAAAAAAAAAAAAFgAZABYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAgAAAAAAAAACAAAAAAAGgAAAAAAAAAAAAgAAAAIAAAAGwAJAAoACwAMABcADQAYAAAAAAAAAAAAAAAAAAMAAAAEAAQABAAAAAQAAAAAAAAAAAAAAAUABQAGAAUABAAAAAcAAAAOAA8AAAAcAA8AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAIAAgACAAIAAgAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAgACAAIAAgAAAAIAAoACgAKAAoADQAAAAAAAwADAAMAAwADAAMAAAAEAAQABAAEAAQAAAAAAAAAAAAAAAUABgAGAAYABgAGAAAAAAAOAA4ADgAOAA8AAAAPAAIAAwACAAMAAgADAAgABAAIAAQACAAEAAgABAAAAAQAAAAAAAAABAAAAAQAAAAEAAAABAAAAAQACAAEAAgABAAIAAQACAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABQAAAAUABQAAAAAACAAGAAgABgAIAAYACAAEAAAAAAAAAAAAAAAAABsABwAbAAcAGwAHABsABwAJAAAACQAAAAAAAAAKAA4ACgAOAAoADgAKAA4ACgAOAAoADgAMAAAADQAPAA0AGAAQABgAEAAYABAAAAAAAAAACAAEAAAADgAAAAAAAAAAAAAAAgADAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGwAHAAkAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAACAANAAAAAAACAAAAAAACAAAAGAAAAAgAAAAAAAIAAAAAAAAACAAAAAAAAAAAAA0AAAAXAAAAAAAAAA0ABAAAAAUAAAAOAAQAAAAPAAAAAAAAAAUAAAAAAAAAAAAAAA8AAAAGAAAAAAAEAAQAAAAOAAAAAAAAAAAAAAAOAAYADgAAAAAAAAAAAAAAAAAAAAkAAAAIAAAAAAAAABoAEQAAAAkAAAAAABUAAAACAAAAAAAAAAAAAAAXAAAAAAAAAAAAEQAAAAAACAAAAAAACAAJABUAAAAXAAAAEgAAAAAAAAAAAAAAAAAAAAAAAwAAAAAABQAAAAQAHAAAAAUABQAFABMABQAFAAYABQAFAAQAAAAPAAQAHAAFABQABQAFAAAAAAAFAAAABQAAAAQABAAAAAUABAAHAAAAAAAAABMABQAAAAUABQAPAAAACAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAGAAsADwALAA8ACAAEAAgAAAAIAAQACAAAAAgABAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAABcAHAAAAAAAAAAFAAAAAAAAAAAACQAAAAAABQAAAAUAAAAAAAgABAAIAAQACQAAAA0ADwANAAAAFwAcAAkAAAASABQAAAAAAAAAAAAAAAAAAAAAAAAAFwAcAAAAAAARABMAAAAFAAAABQASABQAAAAFAAAAAgADAAIAAwAAAAAAAAAEAAAABAAAAAQAFwAcAAAAAAAAAAAAAAAFAAAABQAIAAYACAAEAAgABgAAAAAAFQAPABUADwAVAA8AEgAUAAAABQAAAAUAAAAFABcAHAAAAAAAAAAEAAQABAAAAAAAAAAAABEAAAAAAAAACAAEAAAAAAAAAAAAEQATAAIAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAAAwAAAAMAAAAAAAAAAAAAAACAAMAAgADAAIAAwACAAMAAgADAAIAAwACAAMAAgADAAIAAwACAAMAAgADAAIAAwAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAAAAAAAAAACAAGAAgABgAIAAYACAAGAAgABgAIAAYACAAGAAgABAAIAAQACAAEAAgABgAIAAQACgAOAAoADgAAAA4AAAAOAAAADgAAAA4AAAAOAA0ADwANAA8ADQAPAA0ADwAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABkAGQAZAAAAAQABABYAAQABAAEAFgAAAAAAAAAWABYAAAAAAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAgAAAAIAAgAAAABAAAACgIGCBAABERGTFQAGmN5cmwASGdyZWsAdmxhdG4ApAAEAAAAAP//ABIAAAAKABQAHgAoADQAQQBLAFUAXwBpAHMAfQCHAJEAmwClAK8ABAAAAAD//wASAAEACwAVAB8AKQA1AEIATABWAGAAagB0AH4AiACSAJwApgCwAAQAAAAA//8AEgACAAwAFgAgACoANgBDAE0AVwBhAGsAdQB/AIkAkwCdAKcAsQAoAAZBWkUgAFRDUlQgAH5NT0wgAKhOQVYgANRST00gAQBUVVIgASwAAP//ABMAAwANABcAIQArADIANwBEAE4AWABiAGwAdgCAAIoAlACeAKgAsgAA//8AEgAEAA4AGAAiACwAOABFAE8AWQBjAG0AdwCBAIsAlQCfAKkAswAA//8AEgAFAA8AGQAjAC0AOQBGAFAAWgBkAG4AeACCAIwAlgCgAKoAtAAA//8AEwAGABAAGgAkAC4AOgA+AEcAUQBbAGUAbwB5AIMAjQCXAKEAqwC1AAD//wATAAcAEQAbACUALwA7AD8ASABSAFwAZgBwAHoAhACOAJgAogCsALYAAP//ABMACAASABwAJgAwADwAQABJAFMAXQBnAHEAewCFAI8AmQCjAK0AtwAA//8AEwAJABMAHQAnADEAMwA9AEoAVABeAGgAcgB8AIYAkACaAKQArgC4ALljMnNjBFhjMnNjBF5jMnNjBGRjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBkbGlnBHhkbGlnBH5kbGlnBIRkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbm9tBJBkbm9tBJZkbm9tBJxkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhsaWdhBLJsaWdhBLpsbnVtBMBsbnVtBMZsbnVtBMxsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsb2NsBNhsb2NsBN5sb2NsBORudW1yBOpudW1yBPBudW1yBPZudW1yBPxudW1yBPxudW1yBPxudW1yBPxudW1yBPxudW1yBPxudW1yBPxvbnVtBQJvbnVtBQhvbnVtBQ5vbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRwbnVtBRpwbnVtBSBwbnVtBSZwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxzbWNwBTJzbWNwBThzbWNwBT5zbWNwBURzbWNwBURzbWNwBURzbWNwBURzbWNwBURzbWNwBURzbWNwBURzczAxBUpzczAxBVBzczAxBVZzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAyBWJzczAyBWhzczAyBW5zczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAzBXpzczAzBYBzczAzBYZzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczA0BZJzczA0BZhzczA0BZ5zczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA1BapzczA1BbBzczA1BbZzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA2BcJzczA2BchzczA2Bc5zczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA3BdpzczA3BeBzczA3BeZzczA3BexzczA3BexzczA3BexzczA3BexzczA3BexzczA3BexzczA3Bex0bnVtBfJ0bnVtBfh0bnVtBf50bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgQAAAABAAEAAAABAAMAAAABAAIAAAABAAAAAAACAAgACQAAAAEADgAAAAEAEAAAAAEADwAAAAEADQAAAAEAQwAAAAEARQAAAAEARAAAAAEAQgAAAAMAPwBAAEEAAAACABEAEgAAAAEAEgAAAAEAPAAAAAEAPgAAAAEAPQAAAAEAOwAAAAEACgAAAAEADAAAAAEACwAAAAEARwAAAAEASQAAAAEASAAAAAEARgAAAAEAMAAAAAEAMgAAAAEAMQAAAAEALwAAAAEAOAAAAAEAOgAAAAEAOQAAAAEANwAAAAEABQAAAAEABwAAAAEABgAAAAEABAAAAAEAFAAAAAEAFgAAAAEAFQAAAAEAEwAAAAEAGAAAAAEAGgAAAAEAGQAAAAEAFwAAAAEAHAAAAAEAHgAAAAEAHQAAAAEAGwAAAAEAIAAAAAEAIgAAAAEAIQAAAAEAHwAAAAEAJAAAAAEAJgAAAAEAJQAAAAEAIwAAAAEAKAAAAAEAKgAAAAEAKQAAAAEAJwAAAAEALAAAAAEALgAAAAEALQAAAAEAKwAAAAEANAAAAAEANgAAAAEANQAAAAEAMwBLAJgAmACYAJgEJgQmBCYEJgcUB8AOUA5QDmYOiA6IDogOiA6+DuQPEg8SDxIPEg8mDyYPJg8mDzoPOg86DzoPTg9OD04PTg9gD2APYA9gD3oPeg96D3oPvA+8D7wPvA/aD9oP2g/aD/gP+A/4D/gQKhAqECoQKhBcEFwQXBBcEI4QohDuEMwQzBDMEMwQ7hDuEO4Q7hEaAAEAAAABAAgAAgHEAN8DvQPsA+sD6gPpA+gD5wPmA+UD5APjA+ID4QPgA98D3gPdA9wD2wPaA9kD2APXA9YD9gP3BKkDvAO7BFAEUQRSBFMEVARVBFcEWARZBFoEWwRcBF0EXgRfBE4EYARhBGIEYwRkBGUEZgRtBG4EbwRwBEwEcQRyBHMEdAR1BHYEdwR4BE0EeQR6BHsEfAR9BH4EfwSABIEEggSDBIQEhQSGBIcEiASJBIoEiwSMBI0EjgSPBJAEkQSSBJMERASUBJUElgSXBJgEmQSaBJ0EnARPBJ4EnwSgBKEEogSjBKQEpQSmBKcEqAP+BFYEmwSqBKsErAStBK4ErwSwBLEEsgO6A7kEswS0BLUDuAS2BLcDtwS4A7YEuQPGBLoD0QS7BLwD0gS9A9MD1AS+BL8EwAP5BMED+ATCBMMExATFA/8EAAQBBMYExwQCBMgEAwTJBMoEBATLBAUEBgQHBMwECAQJBM0EzgTPBNAE0QTSBNMECgTcBNQECwQMBA0EDgQPBBAEEQQSBBMEFAQ4BBUEFgTVBBcEGAQZBNYEGgTXBNgEGwQcBB0EHgQfBCAE2QQhBCIE2gQjBNsEJAQlBCcEJgABAN8ACAAlACYAJwAoACkAKgArACwALQAuAC8AMAAxADIAMwA0ADUANgA3ADgAOQA6ADsAPAA9AD4AZgBoAIMAhACFAIYAhwCIAIoAiwCMAI0AjgCPAJAAkQCSAJMAlACVAJYAlwCYAJkAnACdAJ4AnwCgAKIAwwDFAMcAyQDLAM0AzwDRANMA1QDXANkA2wDdAN8A4QDjAOUA5wDrAO0A7wDxAPMA9wD5APwA/gEAAQIBBgEIAQoBDwERARMBFQEXARkBGwEdAR8BIQEjASUBJwEpASsBLQEvATEBMwE1ATcBOQE7ATwBPgFAAU4BYgF5AXsBfAF9AX4BfwGAAYIBgwGEAYUBhgGHAYgBiQGKAYsBjAGNAY8BkAGRAZIBkwGUAZUBlgGXAZgBmQGaAZsBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0QHSAdMB1AHVAdYB1wHYAdkB2gHbAdwB3QHeAd8B4AHhAeIB4wHkAeUB5gHnAegB6QHqAesB7AHtAe4B7wHwAfEB8gJSAlQCWAJaAlwCXgJiAmQCagJsAnACcgJ0AnYCegJ8An4CgAKaAqICpAKqArADhwOOA5MDlgABAAAAAQAIAAIBdAC3A+wD6wPqA+kD6APnA+YD5QPkA+MD4gPhA+AD3wPeA90D3APbA9oD2QPYA9cD1gP2A/cEqQRQBFEEUgRTBFQEVQRXBFgEWQRaBFsEXARdBF4EXwROBGAEYQRiBGMEZARlBGYEbQRuBG8EcASmBHEEcgRzBHQEdQR2BHcEeARNBHkEegR7BHwEfQR+BH8EgASBBIIEgwSEBIUEhgSHBIgEiQSKBIsEjASNBI4EjwSQBJEEkgSTBEQElASVBJYElwSYBJkEmgSdBJwETwSeBJ8EoAShBKIEowSkBKUEpwSoA/4EVgSbBMgEAwTJBMoEBATLBAUEBgQHBMwECAQJBM0EzgTPBNAE0QTSBNMECgTcBNQECwQMBA0EDgQPBBAEEQQSBBMEFATAA/kEwQP4BMIEwwTEBMUD/wQABAEExgTHBAIEOAQVBBYE1QQXBBgEGQTWBBoE1wTYBBsEHAQdBB4EHwQgBNkEIQQiBNoEIwTbAAEAtwBFAEYARwBIAEkASgBLAEwATQBOAE8AUABRAFIAUwBUAFUAVgBXAFgAWQBaAFsAXABdAF4AowCkAKUApgCnAKgAqgCrAKwArQCuAK8AsACxALIAswC0ALUAtgC3ALgAuQC8AL0AvgC/AMAAwgDEAMYAyADKAMwAzgDQANIA1ADWANgA2gDcAN4A4ADiAOQA5gDoAOwA7gDwAPIA9AD4APoA/QD/AQEBAwEHAQkBCwEQARIBFAEWARgBGgEcAR4BIAEiASQBJgEoASoBLAEuATABMgE0ATYBOAE6AT0BPwFBAU8BYwHzAfQB9QH2AfcB+AH5AfoB+wH8Af0B/gH/AgACAQICAgMCBAIFAgYCBwIIAgkCCgILAgwCDQIOAg8CEAIRAhICFAIVAhYCFwIYAhkCGgIbAhwCHQIeAh8CIQIiAlMCVQJZAlsCXQJfAmMCZQJrAm0CcQJzAnUCdwJ7An0CfwKBApsCowKlAqsCsQAGAAAABgASACoAQgBaAHIAigADAAAAAQASAAEAkAABAAAASgABAAEATQADAAAAAQASAAEAeAABAAAASgABAAEATgADAAAAAQASAAEAYAABAAAASgABAAEA8gADAAAAAQASAAEASAABAAAASgABAAECGQADAAAAAQASAAEAMAABAAAASgABAAECGwADAAAAAQASAAEAGAABAAAASgABAAEDLQACAAEBcQF1AAAABAAAAAEACAABBh4ANgByAKQArgC4AMoA/AEOARgBSgFkAX4BkAG6AewB9gIYAjICRAJ2AogCogLMAt4DEAMaAyQDNgNoA3IDfAOGA6ADugPMA/YEKAQyBFQEbgSABLIExATeBQgFGgUkBS4FOAVCBWwFlgXABeoGFAAGAA4AFAAaACAAJgAsAIMAAgFxAIQAAgFyAIYAAgFzAwQAAgF0AVQAAgF1AwIAAgF2AAEABALYAAIBdgABAAQAyQACAXIAAgAGAAwC2gACAXYC3AACA6sABgAOABQAGgAgACYALACLAAIBcQCMAAIBcgMeAAIBcwMcAAIBdAFWAAIBdQMaAAIBdgACAAYADAFKAAIBcgDlAAIDqwABAAQC3gACAXYABgAOABQAGgAgACYALACPAAIBcQCQAAIBcgDrAAIBcwMqAAIBdAFYAAIBdQMsAAIBdgADAAgADgAUAuAAAgFyAuIAAgF2APkAAgOrAAMACAAOABQA/AACAXIC5AACAXYA/gACA6sAAgAGAAwC5gACAXIC6AACAXYABQAMABIAGAAeACQBTAACAXEBBgACAXIAlAACAXMC6gACAXYBCAACA6sABgAOABQAGgAgACYALACVAAIBcQCWAAIBcgCYAAIBcwMwAAIBdAFaAAIBdQMuAAIBdgABAAQC7AACAXIABAAKABAAFgAcARcAAgFyAVwAAgF1Au4AAgF2ARkAAgOrAAMACAAOABQBHQACAXIC8AACAXYBYAACA6sAAgAGAAwC8gACAXYBYgACA6sABgAOABQAGgAgACYALACcAAIBcQCdAAIBcgErAAIBcwNIAAIBdAFeAAIBdQNGAAIBdgACAAYADAL0AAIBcwL2AAIBdgADAAgADgAUAvgAAgFxAvoAAgFyAv4AAgF2AAUADAASABgAHgAkA1QAAgFxAKAAAgFyA1oAAgFzA1gAAgF0A1YAAgF2AAIABgAMATwAAgFyAwAAAgF2AAYADgAUABoAIAAmACwAowACAXEApAACAXIApgACAXMDBQACAXQBVQACAXUDAwACAXYAAQAEAtkAAgF2AAEABADKAAIBcgACAAYADALbAAIBdgLdAAIDqwAGAA4AFAAaACAAJgAsAKsAAgFxAKwAAgFyAx8AAgFzAx0AAgF0AVcAAgF1AxsAAgF2AAEABAFLAAIBcgABAAQC3wACAXYAAQAEAy0AAgF2AAMACAAOABQC4QACAXIC4wACAXYA+gACA6sAAwAIAA4AFAD9AAIBcgLlAAIBdgD/AAIDqwACAAYADALnAAIBcgLpAAIBdgAFAAwAEgAYAB4AJAFNAAIBcQEHAAIBcgC0AAIBcwLrAAIBdgEJAAIDqwAGAA4AFAAaACAAJgAsALUAAgFxALYAAgFyALgAAgFzAzEAAgF0AVsAAgF1Ay8AAgF2AAEABALtAAIBcgAEAAoAEAAWABwBGAACAXIBXQACAXUC7wACAXYBGgACA6sAAwAIAA4AFAEeAAIBcgLxAAIBdgFhAAIDqwACAAYADALzAAIBdgFjAAIDqwAGAA4AFAAaACAAJgAsALwAAgFxAL0AAgFyASwAAgFzA0kAAgF0AV8AAgF1A0cAAgF2AAIABgAMAvUAAgFzAvcAAgF2AAMACAAOABQC+QACAXEC+wACAXIC/wACAXYABQAMABIAGAAeACQDVQACAXEAwAACAXIDWwACAXMDWQACAXQDVwACAXYAAgAGAAwBPQACAXIDAQACAXYAAQAEAVAAAgFyAAEABAFSAAIBcgABAAQBUQACAXIAAQAEAVMAAgFyAAUADAASABgAHgAkAK8AAgFxALAAAgFyAOwAAgFzAysAAgF0AVkAAgF1AAUADAASABgAHgAkAz4AAgFxAzwAAgFyA0IAAgFzA0AAAgF0A0QAAgF2AAUADAASABgAHgAkAz8AAgFxAz0AAgFyA0MAAgFzA0EAAgF0A0UAAgF2AAUADAASABgAHgAkA0wAAgFxA0oAAgFyA1AAAgFzA04AAgF0A1IAAgF2AAUADAASABgAHgAkA00AAgFxA0sAAgFyA1EAAgFzA08AAgF0A1MAAgF2AAEABAHBAAIBcgACABEAJQApAAAAKwAtAAUALwA0AAgANgA7AA4APQA+ABQARQBJABYASwBNABsATwBUAB4AVgBbACQAXQBeACoAiQCJACwAmwCbAC0AqQCpAC4AuwC7AC8A9AD0ADABRQFIADEBwAHAADUAAQAAAAEACAABAAYAPwABAAIBIQEiAAEAAAABAAgAAgAOAAQE3QTeBN8E4AABAAQAxwDIANsA3AAEAAAAAQAIAAEAJgACAAoAHAACAAYADAOsAAIASgOxAAIAWAABAAQDsgACAFgAAQACAEoAVwAEAAAAAQAIAAEARAACAAoAFAABAAQDrQACAE0AAQAEA68AAgBNAAQAAAABAAgAAQAeAAIACgAUAAEABAOuAAIAUAABAAQDsAACAFAAAQACAEoDrAABAAAAAQAIAAEABgN5AAEAAQBLAAEAAAABAAgAAQAGAiIAAQABAaEAAQAAAAEACAABAAYDjAABAAEANgABAAAAAQAIAAIAHAACA8EDwAABAAAAAQAIAAIACgACA78DvgABAAIALwBPAAEAAAABAAgAAgAeAAwEMQQzBDIENAQ1BCgEKQQqA/sELAQtBC4AAQAMACcAKAArADMANQBGAEcASABLAFMAVABVAAEAAAABAAgAAgAMAAMELwQwBDAAAQADAEkASwP7AAEAAAABAAgAAgBmAAgERgQ2BDcEOQQ6BEIEQwRFAAEAAAABAAgAAgAWAAgAGwAVABQAHQAZABgAFwAWAAEACAP6BCsEZwRoBGkEagRrBGwAAQAAAAEACAACABYACARnBCsEbARrBGoEaQP6BGgAAQAIABQAFQAWABcAGAAZABsAHQABAAAAAQAIAAIAFgAIABUAFgAXABgAGQAbAB0AFAABAAgENgQ3BDkEOgRCBEMERQRGAAEAAAABAAgAAQAGA3AAAQABABMABgAAAAEACAADAAEAEgABAGYAAAABAAAASgACAAIDgwODAAADxwPQAAEAAQAAAAEACAACADwACgPQA88DzgPNA8wDywPKA8kDyAPHAAEAAAABAAgAAgAaAAoEOwB8AHUAdgQ8BD0EPgQ/BEAEQQACAAEAFAAdAAAAAQAAAAEACAACACYAEAPQA88DzgPNA8wDywPKA8kDyAPHBEkERwRKBEsESAThAAEAEAAUABUAFgAXABgAGQAaABsAHAAdAE0ATgDyAhkCGwMt\",\n  \"Roboto-Regular.ttf\": \"AAEAAAASAQAABAAgR0RFRtRX1FkAAg/sAAACREdQT1NKcuCzAAISMAAAUiRHU1VCw4aZEQACZFQAABfoT1MvMqCnsaYAAAGoAAAAYGNtYXBAmkl2AAAafAAAEshjdnQgJEEG5QAAL9wAAABMZnBnbWf0XKsAAC1EAAABvGdhc3AACAATAAIP4AAAAAxnbHlmHN2bBQAAOfAAAdM2aGRteDc4ERcAABWQAAAE7GhlYWT4RqsOAAABLAAAADZoaGVhCroKggAAAWQAAAAkaG10eOiEiIgAAAIIAAATiGxvY2HgyGepAAAwKAAACcZtYXhwBxIC+QAAAYgAAAAgbmFtZTVTY1kAAg0oAAACmHBvc3T/bQBkAAIPwAAAACBwcmVwdKCP7AAALwAAAADbAAEAAAACAACEKlnoXw889QAbCAAAAAAAxPARLgAAAADQ206a+hv91QkwCHMAAAAJAAIAAAAAAAAAAQAAB2z+DAAACUn6G/5KCTAAAQAAAAAAAAAAAAAAAAAABOIAAQAABOIAjwAWAFQABQABAAAAAAAOAAACAAIUAAYAAQADBIUBkAAFAAAFmgUzAAABHwWaBTMAAAPRAGYCAAAAAgAAAAAAAAAAAOAACv9QACF/AAAAIQAAAABHT09HAEAAAP/9BgD+AABmB5oCACAAAZ8AAAAABDoFsAAgACAAAgOMAGQAAAAAAAAAAAH7AAAB+wAAAg8AoAKPAIgE7QB3BH4AbgXcAGkE+QBlAWUAZwK8AIUCyAAmA3IAHASJAE4BkgAdAjUAJQIbAJADTAASBH4AcwR+AKoEfgBdBH4AXgR+ADUEfgCaBH4AhAR+AE0EfgBwBH4AZAHwAIYBsQApBBEASARkAJgELgCGA8cASwcvAGoFOAAcBPsAqQU1AHcFPwCpBIwAqQRsAKkFcwB6BbQAqQItALcEagA1BQQAqQROAKkG/ACpBbQAqQWAAHYFDACpBYAAbQTtAKgEvwBQBMYAMQUwAIwFFwAcBxkAPQUEADkEzgAPBMoAVgIfAJIDSAAoAh8ACQNYAEADnAAEAnkAOQRaAG0EfQCMBDAAXASDAF8EPQBdAscAPAR9AGAEaACMAfEAjQHp/78EDgCNAfEAnAcDAIsEagCMBJAAWwR9AIwEjABfArUAjAQgAF8CnQAJBGkAiAPgACEGAwArA/cAKQPJABYD9wBYArUAQAHzAK8CtQATBXEAgwHzAIsEYABpBKYAWwW0AGkE2AAfAesAkwToAFoDWABmBkkAWwOTAJMDwQBmBG4AfwZKAFoDqgB4Av0AggRGAGEC7wBCAu8APgKCAHsEiACaA+kAQwIWAJMB+wB0Au8AegOjAHoDwABmBdwAVQY1AFAGOQBvA8kARAd6//IERABZBYAAdgS6AKYEwgCLBsEATgSwAH4EkQBHBIgAWwScAJUFmgAdAfoAmwRzAJoETwAiAikAIgWLAKIEiACRB6EAaAdEAGEB/ACgBYcAXQK5/+QFfgBlBJIAWwWQAIwE8wCIAgP/tAQ3AGIDxACpA40AjAOrAHgDagCBAfEAjQKtAHkCKgAyA8YAewL8AF4CWgB+AAD8pwAA/W8AAPyLAAD9XgAA/CcB7/04Ag0AtwQLAHECFwCTBHMAsQWkAB8FcQBnBT4AMgSRAHgFtQCyBJEARQW7AE0FiQBaBVIAcQSFAGQEvQCgBAIALgSIAGAEUABjBCUAbQSIAJEEjgB6ApcAwwRuACUD7ABlBMQAKQSIAJEETQBlBIgAYAQsAFEEXQCPBaMAVwWaAF8GlwB6BKEAeQRC/9oGSABKBf8AKgVkAHsIkQAxCKQAsQaCAD4FtACwBQsAogYEADIHQwAbBL8AUAW0ALEFqQAvBQcATQYsAFMF2QCvBXoAlgeHALAHwACwBhIAEAbrALIFBQCjBWQAkwcnALcFGABZBGwAYQSSAJ0DWwCaBNQALgYgABUEEABYBJ4AnARSAJwEoAAsBe8AnQSdAJwEngCcA9gAKAXNAGQEvQCcBFkAZwZ4AJwGngCRBPcAHgY2AJ0EWACdBE0AZAaHAJ0EZAAvBGj/6ARNAGcGyQAnBuQAnASJ//0EngCcBwgAnAYrAIEEVv/cBysAtwX4AJkE0gAoBEYADwcLAMkGCwC8BtEAkwXhAJYJBAC2B9EAmwQjAFAD2wBMBXEAZwSLAFsFCgAWBAMALgVxAGcEiABbBwEAnAYkAH4HCACcBisAgQUyAHUERwBkBP0AdAAA/GcAAPxxAAD9ZgAA/aQAAPobAAD6LARW/9wFGwCoBIkAjARjAKIDkACRBNsAsQQFAJEFCQCjBH4AmgaMAEQFgwA+B88AqAW0AJEIMQCwBvQAkQXuAHEE0wBtBywANAVcAB8FbwCWBGoAgwVwAIoGLwA/BL3/3gUJAKMEWgCaBbIAsQSIAJEFhwBdBKgAaASoAGkEtwA6A0kAOwT2AFcGlABZBuQAZAZWADYFKwAxBEkAUgQHAHkHwQBEBnUAPwf7AKkGoQCQBPYAdgQdAGUFrQAjBSAARgVkAJYDIABvBBQAAAgpAAAEFAAACCkAAAK5AAACCgAAAVwAAAR/AAACMAAAAaIAAADRAAAAAAAAAjQAJQI0ACUFQACiBj8AkAOmAA0BmQBgAZkAMAGXACQBmQBPAtQAaALbADwCwQAkBGkARgSPAFcCsgCKA8QAlAVaAJQA9gAmB6oARAJmAGwCZgBZA6MAOwLvADYDYAB6BKYAWwZVAB8GkACnCHYAqAdjADkGKwCMBH4AXwXaAB8EIgAqBHQAIAVIAF0FTwAfBecAegPOAGgIOgCiBQEAZwUXAJgGJgBUBtcAZAbPAGMGagBZBI8AagWOAKkErwBFBJIAqATFAD8IOgBiAgz/sASCAGUEZACYBBEAPgQvAIUECAArAkwAtQKPAG4CAwBcBPMAPARuAB8EiwA8BtQAPAbUADwE7gA8BpsAXwAAAAAIMwBbCDUAXAQgADsEngBaAfz/tgGRAGcDpACDA54AgQOfAIED9ABpBA4AaQPz/14D7wBuA6QAgQH9AJ8EhQATBFAAigR8AGAEgACKA+YAigPLAIoErABjBOMAigHoAJcDzwArBFQAigO0AIoGAgCKBOMAigS7AGAEXACKBLsAWQRKAIoEIABDBCYAKAR8AHQEZwAUBhUAMQRUACYEKwANBCMARwLvAFAC7wB6Au8AQgLvAD4C7wA2Au8AWwLvAFYC7wA6Au8ATwLvAEkDlgCPArUAngQ6AB4EwwBkBUwAsQUkALIEEwCSBT0AsgQPAJIEIABDBDMAMAQ8ABYDrwCKBGcAFAS7AGAEZwAUA4kAPgTOAIoD7wA/BWcAYAUXAGAE8gB1BXIAJgR8AGAHQQAnB08AigV0ACgEzQCKBFkAigUkAC4GCwAfBD8ARwTsAIoETgCLBMEAJwQfACIFKACKBGoAPQZRAIoGrACKBR0ACAXxAIoETgCKBHsASwZ2AIoEhwBQBBEACwZHAB8EeQCLBQkAiwU3ACMFwgBgBF8ADQSoACYGYQAmBGoAPQRqAIoFwwACBMoAXgQ/AEcEuwBgBDMAMAPjAEIIIgCKBKsAKAR9AIwEMgBcBJMAWwSMAFsDeQBXBI0AjAScAFsEPQBdBH0AYAWBAH4FrgB+BZMAsgXgAH4F4wB+A9UAoASCAIMDrwCKBFgADwTPAD4C7wBQAu8ANgLvAFsC7wBWAu8AOgLvAE8C7wBJBGsAZQQuAEoGpABgBLkAggUAAHgCBv+0AgT/tAH7AJsB+//6AfsAmwH7AIYEUACKAfsAAAI1ACUFXQAlBV0AJQSGAAAExgAxAp3/9AU4ABwFOAAcBTgAHAU4ABwFOAAcBTgAHAU4ABwFNQB3BIwAqQSMAKkEjACpBIwAqQIt/+ACLQCwAi3/6QIt/9YFtACpBYAAdgWAAHYFgAB2BYAAdgWAAHYFMACMBTAAjAUwAIwFMACMBM4ADwRaAG0EWgBtBFoAbQRaAG0EWgBtBFoAbQRaAG0EMABcBD0AXQQ9AF0EPQBdBD0AXQH6/8YB+gCWAfr/zwH6/7wEagCMBJAAWwSQAFsEkABbBJAAWwSQAFsEaQCIBGkAiARpAIgEaQCIA8kAFgPJABYFOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FNQB3BDAAXAU1AHcEMABcBTUAdwQwAFwFNQB3BDAAXAU/AKkFGQBfBIwAqQQ9AF0EjACpBD0AXQSMAKkEPQBdBIwAqQQ9AF0EjACpBD0AXQVzAHoEfQBgBXMAegR9AGAFcwB6BH0AYAVzAHoEfQBgBbQAqQRoAIwCLf+3Afr/nQIt/7YB+v+cAi3/7AH6/9ICLQAYAfH/+wItAKoGlwC3A9oAjQRqADUCA/+0BQQAqQQOAI0ETgChAfEAkwROAKkB8QBXBE4AqQKHAJwETgCpAs0AnAW0AKkEagCMBbQAqQRqAIwFtACpBGoAjARq/7wFgAB2BJAAWwWAAHYEkABbBYAAdgSQAFsE7QCoArUAjATtAKgCtQBTBO0AqAK1AGMEvwBQBCAAXwS/AFAEIABfBL8AUAQgAF8EvwBQBCAAXwS/AFAEIABfBMYAMQKdAAkExgAxAp0ACQTGADECxQAJBTAAjARpAIgFMACMBGkAiAUwAIwEaQCIBTAAjARpAIgFMACMBGkAiAUwAIwEaQCIBxkAPQYDACsEzgAPA8kAFgTOAA8EygBWA/cAWATKAFYD9wBYBMoAVgP3AFgHev/yBsEATgWAAHYEiABbBID/vgSA/74EJgAoBIUAEwSFABMEhQATBIUAEwSFABMEhQATBIUAEwR8AGAD5gCKA+YAigPmAIoD5gCKAej/vgHoAI4B6P/HAej/tATjAIoEuwBgBLsAYAS7AGAEuwBgBLsAYAR8AHQEfAB0BHwAdAR8AHQEKwANBIUAEwSFABMEhQATBHwAYAR8AGAEfABgBHwAYASAAIoD5gCKA+YAigPmAIoD5gCKA+YAigSsAGMErABjBKwAYwSsAGME4wCKAej/lQHo/5QB6P/KAegABgHoAIkDzwArBFQAigO0AIIDtACKA7QAigO0AIoE4wCKBOMAigTjAIoEuwBgBLsAYAS7AGAESgCKBEoAigRKAIoEIABDBCAAQwQgAEMEIABDBCYAKAQmACgEJgAoBHwAdAR8AHQEfAB0BHwAdAR8AHQEfAB0BhUAMQQrAA0EKwANBCMARwQjAEcEIwBHBTgAHATw//AGGP/+ApEABAWU//oFMv94BWb//QKX/5sFOAAcBPsAqQSMAKkEygBWBbQAqQItALcFBACpBvwAqQW0AKkFgAB2BQwAqQTGADEEzgAPBQQAOQIt/9YEzgAPBIUAZARQAGMEiACRApcAwwRdAI8EcwCaBJAAWwSIAJoD4AAhA/cAKQKX/+YEXQCPBJAAWwRdAI8GlwB6BIwAqQRzALEEvwBQAi0AtwIt/9YEagA1BSQAsgUEAKkFBwBNBTgAHAT7AKkEcwCxBIwAqQW0ALEG/ACpBbQAqQWAAHYFtQCyBQwAqQU1AHcExgAxBQQAOQRaAG0EPQBdBJ4AnASQAFsEfQCMBDAAXAPJABYD9wApBD0AXQNbAJoEIABfAfEAjQH6/7wB6f+/BFIAnAPJABYHGQA9BgMAKwcZAD0GAwArBxkAPQYDACsEzgAPA8kAFgFlAGcCjwCIBB4AoAID/7QBmQAwBvwAqQcDAIsFOAAcBFoAbQSMAKkFtACxBD0AXQSeAJwFiQBaBZoAXwUKABYEA//7CFkAWwlJAHYEvwBQBBAAWAU1AHcEMABcBM4ADwQCAC4CLQC3B0MAGwYgABUCLQC3BTgAHARaAG0FOAAcBFoAbQd6//IGwQBOBIwAqQQ9AF0FhwBdBDcAYgQ3AGIHQwAbBiAAFQS/AFAEEABYBbQAsQSeAJwFtACxBJ4AnAWAAHYEkABbBXEAZwSLAFsFcQBnBIsAWwVkAJMETQBkBQcATQPJABYFBwBNA8kAFgUHAE0DyQAWBXoAlgRZAGcG6wCyBjYAnQUEADkD9wApBIMAXwWpAC8EoAAsBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBTgAHARa/8oFOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBIwAqQQ9AF0EjACpBD0AXQSMAKkEPQBdBIwAqQQ9AF0EjP/wBD3/ugSMAKkEPQBdBIwAqQQ9AF0EjACpBD0AXQItALcB+gCbAi0AowHxAIUFgAB2BJAAWwWAAHYEkABbBYAAdgSQAFsFgABHBJD/xAWAAHYEkABbBYAAdgSQAFsFgAB2BJAAWwV+AGUEkgBbBX4AZQSSAFsFfgBlBJIAWwV+AGUEkgBbBX4AZQSSAFsFMACMBGkAiAUwAIwEaQCIBZAAjATzAIgFkACMBPMAiAWQAIwE8wCIBZAAjATzAIgFkACMBPMAiATOAA8DyQAWBM4ADwPJABYEzgAPA8kAFgShAF8EoQBfBSQAsgRSAJwFtACpBJ0AnATGADED2AAoBQQAOQP3ACkFegCWBFkAZwV6AJYEWQBnBHMAsQNbAJoHQwAbBiAAFQYvAD8Evf/eBGgAjAUF/9QFBf/UBHMAAwNb//wFOAALBCf/0wW0ALEEngCcBbQAqQSdAJwG/ACpBe8AnQWpAC8EoAAsBM4ADwQCAC4FBAA5A/cAKQRQAGMEbAASBj8AkAR+AF0EfgBeBH4ANQR+AJoEkgBkBKYAhwVzAHoEfQBgBbQAqQRqAIwFOAAcBFoAOQSMAF8EPQApAi3/CgH6/vAFgAB2BJAAMwTtAFUCtf+LBTAAjARpACsEpv86BPsAqQR9AIwFPwCpBIMAXwU/AKkEgwBfBbQAqQRoAIwFBACpBA4AjQUEAKkEDgCNBE4AqQHxAIYG/ACpBwMAiwW0AKkEagCMBQwAqQR9AIwE7QCoArUAggS/AFAEIABfBMYAMQKdAAkFFwAcA+AAIQUXABwD4AAhBxkAPQYDACsEygBWA/cAWAXG/ngEhQATBCL/nwUf/7wCJP/ABMX/3wRn/1cE/P/4BIUAEwRQAIoD5gCKBCMARwTjAIoB6ACXBFQAigYCAIoEuwBgBFwAigQmACgEKwANBFQAJgHo/7QEKwANA+YAigOvAIoEIABDAegAlwHo/7QDzwArBFQAigQfACIEhQATBFAAigOvAIoD5gCKBOwAigYCAIoE4wCKBLsAYATOAIoEXACKBHwAYAQmACgEVAAmBD8ARwTjAIoEfABgBCsADQXDAAIE7ACKBB8AIgVnAGAFOAAcBFoAbQSMAKkEPQBdAAAAAQAABOQJCgQAAAICAgMGBQcGAgMDBAUCAgIEBQUFBQUFBQUFBQICBQUFBAgGBgYGBQUGBgIFBgUIBgYGBgYFBQYGCAYFBQIEAgQEAwUFBQUFAwUFAgIFAggFBQUFAwUDBQQHBAQEAwIDBgIFBQYFAgYEBwQEBQcEAwUDAwMFBAICAwQEBwcHBAgFBgUFCAUFBQUGAgUFAgYFCQgCBgMGBQYGAgUEBAQEAgMCBAMDAAAAAAACAgUCBQYGBgUGBQYGBgUFBQUFBQUFAwUEBQUFBQUFBgYHBQUHBwYKCgcGBgcIBQYGBgcHBggJBwgGBggGBQUEBQcFBQUFBwUFBAcFBQcHBgcFBQcFBQUICAUFCAcFCAcFBQgHCAcKCQUEBgUGBQYFCAcIBwYFBgAAAAAAAAUGBQUEBQUGBQcGCQYJCAcFCAYGBQYHBQYFBgUGBQUFBAYHCAcGBQUJBwkHBgUGBgYEBQkFCQMCAgUCAgEAAgIGBwQCAgICAwMDBQUDBAYBCQMDBAMEBQcHCggHBQcFBQYGBwQJBgYHCAgHBQYFBQUJAgUFBQUFAwMCBgUFCAgGBwAJCQUFAgIEBAQEBQQEBAIFBQUFBAQFBgIEBQQHBgUFBQUFBQUFBwUFBQMDAwMDAwMDAwMEAwUFBgYFBgUFBQUEBQUFBAUEBgYGBgUICAYFBQYHBQYFBQUGBQcIBgcFBQcFBQcFBgYGBQUHBQUGBQUFBQQJBQUFBQUEBQUFBQYGBgcHBAUEBQUDAwMDAwMDBQUHBQYCAgICAgIFAgIGBgUFAwYGBgYGBgYGBQUFBQICAgIGBgYGBgYGBgYGBQUFBQUFBQUFBQUFBQICAgIFBQUFBQUFBQUFBAQGBQYFBgUGBQYFBgUGBQYGBQUFBQUFBQUFBQYFBgUGBQYFBgUCAgICAgICAgIHBAUCBgUFAgUCBQMFAwYFBgUGBQUGBQYFBgUGAwYDBgMFBQUFBQUFBQUFBQMFAwUDBgUGBQYFBgUGBQYFCAcFBAUFBAUEBQQICAYFBQUFBQUFBQUFBQUEBAQEAgICAgYFBQUFBQUFBQUFBQUFBQUFBQUEBAQEBAUFBQUGAgICAgIEBQQEBAQGBgYFBQUFBQUFBQUFBQUFBQUFBQUFBwUFBQUFBgYHAwYGBgMGBgUFBgIGCAYGBgUFBgIFBQUFAwUFBQUEBAMFBQUHBQUFAgIFBgYGBgYFBQYIBgYGBgYFBgUFBQUFBQQEBQQFAgICBQQIBwgHCAcFBAIDBQICCAgGBQUGBQUGBgYFCQoFBQYFBQUCCAcCBgUGBQgIBQUGBQUIBwUFBgUGBQYFBgUGBQYFBgQGBAYEBgUIBwYEBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBQUFBQUFBQUFBQUFBQUFBQICAgIGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgYGBgYGBgYGBgUEBQQFBAUFBgUGBQUEBgQGBQYFBQQIBwcFBQYGBQQGBQYFBgUIBwYFBQUGBAUFBwUFBQUFBQYFBgUGBQUFAgIGBQYDBgUFBgUGBQYFBgUGBQYFBQIICAYFBgUGAwUFBQMGBAYECAcFBAcFBQYCBQUGBQUEBQYCBQcFBQUFBQIFBAQFAgIEBQUFBQQEBgcGBQUFBQUFBQYFBQYGBQYGBQUFAAAAAwAAAAMAAAAcAAMAAQAAABwAAwAKAAAGiAAEBmwAAADqAIAABgBqAAAAAgANAH4AoACsAK0AvwDGAM8A5gDvAP4BDwERASUBJwEwAVMBXwFnAX4BfwGPAZIBoQGwAfAB/wIbAjcCWQK8AscCyQLdAvMDAQMDAwkDDwMjA4oDjAOSA6EDsAO5A8kDzgPSA9YEJQQvBEUETwRiBG8EeQSGBM4E1wThBPUFAQUQBRMeAR4/HoUe8R7zHvkfTSALIBEgFSAeICIgJyAwIDMgOiA8IEQgdCB/IKQgqiCsILEguiC9IQUhEyEWISIhJiEuIV4iAiIGIg8iEiIaIh4iKyJIImAiZSXK7gL2w/sE/v///f//AAAAAAACAA0AIACgAKEArQCuAMAAxwDQAOcA8AD/ARABEgEmASgBMQFUAWABaAF/AY8BkgGgAa8B8AH6AhgCNwJZArwCxgLJAtgC8wMAAwMDCQMPAyMDhAOMA44DkwOjA7EDugPKA9ED1gQABCYEMARGBFAEYwRwBHoEiATPBNgE4gT2BQIFER4AHj4egB6gHvIe9B9NIAAgECATIBcgICAlIDAgMiA5IDwgRCB0IH8goyCmIKsgsSC5ILwhBSETIRYhIiEmIS4hWyICIgYiDyIRIhoiHiIrIkgiYCJkJcruAfbD+wH+///8//8AAQAA//b/5AGl/8IBmf/BAAABjAAAAYcAAAGDAAABgQAAAX8AAAF3AAABef8V/wb/BP73/uoBuwAAAAD+ZP5DAPD91/3W/cj9s/2n/ab9of2c/YkAAP/L/8oAAAAA/QkAAP+r/P38+gAA/LkAAPyxAAD8pgAA/KAAAP71AAD+8gAA/EkAAOWv5W/lIOVP5LTlTeVd4VvhVwAA4VThU+FR4UnjduFB427hOOEJ4P8AAODaAADg1eDO4M3ghuB54HfgbN+T4GHgNd+S3qvfht+F337fe99v31PfPN8529UTnwrfBqMCqwGvAAEAAAAAAAAAAAAAAAAAAAAAANoAAADkAAABDgAAASgAAAEoAAABKAAAAWoAAAAAAAAAAAAAAAAAAAFqAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYgAAAAABagGGAAABngAAAAAAAAG2AAAB/gAAAiYAAAJIAAACWAAAAuIAAALyAAADBgAAAAAAAAAAAAAAAAAAAAAAAAL4AAAAAAAAAAAAAAAAAAAAAAAAAAAC6AAAAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACTAJNAk4CTwJQAlEAgQJIAlwCXQJeAl8CYAJhAIIAgwJiAmMCZAJlAmYAhACFAmcCaAJpAmoCawJsAIYAhwJ3AngCeQJ6AnsCfACIAIkCfQJ+An8CgAKBAIoCRwRHAIsCSQCMArACsQKyArMCtAK1AI0CtgK3ArgCuQK6ArsCvAK9AI4AjwK+Ar8CwALBAsICwwLEAJAAkQLFAsYCxwLIAskCygCSAJMC2QLaAt0C3gLfAuACSgJLAlICbQL4AvkC+gL7AtcC2ALbAtwArQCuA1MArwNUA1UDVgCwALEDXQNeA18AsgNgA2EAswNiA2MAtANkALUDZQC2A2YDZwC3A2gAuAC5A2kDagNrA2wDbQNuA28DcADDA3IDcwDEA3EAxQDGAMcAyADJAMoAywN0AMwAzQOxA3oA0QN7ANIDfAN9A34DfwDTANQA1QOBA7IDggDWA4MA1wOEA4UA2AOGANkA2gDbA4cDgADcA4gDiQOKA4sDjAONA44A3QDeA48DkADpAOoA6wDsA5EA7QDuAO8DkgDwAPEA8gDzA5MA9AOUA5UA9QOWAPYDlwOzA5gBAQOZAQIDmgObA5wDnQEDAQQBBQOeA7QDnwEGAQcBCARdA7UDtgEWARcBGAEZA7cDuAO6A7kBJwEoBGIEYwRcASkBKgErASwBLQReBF8BLgEvBFcEWAO7A7wESQRKATABMQRgBGEBMgEzBEsETAE0ATUBNgE3ATgBOQO9A74ETQROA78DwARqBGsETwRQAToBOwRRBFIBPAE9AT4EWwE/AUAEWQRaA8EDwgPDAUEBQgRoBGkBQwFEBGQEZQRTBFQEZgRnAUUDzgPNA88D0APRA9ID0wFGAUcEVQRWA+gD6QFIAUkD6gPrBGwEbQFKA+wEbgPtA+4BaQFqBHAEbwF/BEgBhQAMAAAAAAxAAAAAAAAAAQQAAAAAAAAAAAAAAAEAAAACAAAAAgAAAAIAAAANAAAADQAAAAMAAAAgAAAAfgAAAAQAAACgAAAAoAAAAkUAAAChAAAArAAAAGMAAACtAAAArQAAAkYAAACuAAAAvwAAAG8AAADAAAAAxQAAAkwAAADGAAAAxgAAAIEAAADHAAAAzwAAAlMAAADQAAAA0AAAAkgAAADRAAAA1gAAAlwAAADXAAAA2AAAAIIAAADZAAAA3QAAAmIAAADeAAAA3wAAAIQAAADgAAAA5QAAAmcAAADmAAAA5gAAAIYAAADnAAAA7wAAAm4AAADwAAAA8AAAAIcAAADxAAAA9gAAAncAAAD3AAAA+AAAAIgAAAD5AAAA/QAAAn0AAAD+AAAA/gAAAIoAAAD/AAABDwAAAoIAAAEQAAABEAAAAkcAAAERAAABEQAABEcAAAESAAABJQAAApMAAAEmAAABJgAAAIsAAAEnAAABJwAAAkkAAAEoAAABMAAAAqcAAAExAAABMQAAAIwAAAEyAAABNwAAArAAAAE4AAABOAAAAI0AAAE5AAABQAAAArYAAAFBAAABQgAAAI4AAAFDAAABSQAAAr4AAAFKAAABSwAAAJAAAAFMAAABUQAAAsUAAAFSAAABUwAAAJIAAAFUAAABXwAAAssAAAFgAAABYQAAAtkAAAFiAAABZQAAAt0AAAFmAAABZwAAAkoAAAFoAAABfgAAAuEAAAF/AAABfwAAAJQAAAGPAAABjwAAAJUAAAGSAAABkgAAAJYAAAGgAAABoQAAAJcAAAGvAAABsAAAAJkAAAHwAAAB8AAAA6sAAAH6AAAB+gAAAlIAAAH7AAAB+wAAAm0AAAH8AAAB/wAAAvgAAAIYAAACGQAAAtcAAAIaAAACGwAAAtsAAAI3AAACNwAAAJsAAAJZAAACWQAAAJwAAAK8AAACvAAAA6wAAALGAAACxwAAAJ0AAALJAAACyQAAAJ8AAALYAAAC3QAAAKAAAALzAAAC8wAAAKYAAAMAAAADAQAAAKcAAAMDAAADAwAAAKkAAAMJAAADCQAAAKoAAAMPAAADDwAAAKsAAAMjAAADIwAAAKwAAAOEAAADhQAAAK0AAAOGAAADhgAAA1MAAAOHAAADhwAAAK8AAAOIAAADigAAA1QAAAOMAAADjAAAA1cAAAOOAAADkgAAA1gAAAOTAAADlAAAALAAAAOVAAADlwAAA10AAAOYAAADmAAAALIAAAOZAAADmgAAA2AAAAObAAADmwAAALMAAAOcAAADnQAAA2IAAAOeAAADngAAALQAAAOfAAADnwAAA2QAAAOgAAADoAAAALUAAAOhAAADoQAAA2UAAAOjAAADowAAALYAAAOkAAADpQAAA2YAAAOmAAADpgAAALcAAAOnAAADpwAAA2gAAAOoAAADqQAAALgAAAOqAAADsAAAA2kAAAOxAAADuQAAALoAAAO6AAADugAAA3AAAAO7AAADuwAAAMMAAAO8AAADvQAAA3IAAAO+AAADvgAAAMQAAAO/AAADvwAAA3EAAAPAAAADxgAAAMUAAAPHAAADxwAAA3QAAAPIAAADyQAAAMwAAAPKAAADzgAAA3UAAAPRAAAD0gAAAM4AAAPWAAAD1gAAANAAAAQAAAAEAAAAA7EAAAQBAAAEAQAAA3oAAAQCAAAEAgAAANEAAAQDAAAEAwAAA3sAAAQEAAAEBAAAANIAAAQFAAAECAAAA3wAAAQJAAAECwAAANMAAAQMAAAEDAAAA4EAAAQNAAAEDQAAA7IAAAQOAAAEDgAAA4IAAAQPAAAEDwAAANYAAAQQAAAEEAAAA4MAAAQRAAAEEQAAANcAAAQSAAAEEwAAA4QAAAQUAAAEFAAAANgAAAQVAAAEFQAAA4YAAAQWAAAEGAAAANkAAAQZAAAEGQAAA4cAAAQaAAAEGgAAA4AAAAQbAAAEGwAAANwAAAQcAAAEIgAAA4gAAAQjAAAEJAAAAN0AAAQlAAAEJQAAA48AAAQmAAAELwAAAN8AAAQwAAAEMAAAA5AAAAQxAAAENAAAAOkAAAQ1AAAENQAAA5EAAAQ2AAAEOAAAAO0AAAQ5AAAEOQAAA5IAAAQ6AAAEPQAAAPAAAAQ+AAAEPgAAA5MAAAQ/AAAEPwAAAPQAAARAAAAEQQAAA5QAAARCAAAEQgAAAPUAAARDAAAEQwAAA5YAAAREAAAERAAAAPYAAARFAAAERQAAA5cAAARGAAAETwAAAPcAAARQAAAEUAAAA7MAAARRAAAEUQAAA5gAAARSAAAEUgAAAQEAAARTAAAEUwAAA5kAAARUAAAEVAAAAQIAAARVAAAEWAAAA5oAAARZAAAEWwAAAQMAAARcAAAEXAAAA54AAARdAAAEXQAAA7QAAAReAAAEXgAAA58AAARfAAAEYQAAAQYAAARiAAAEYgAABF0AAARjAAAEbwAAAQkAAARwAAAEcQAAA7UAAARyAAAEdQAAARYAAAR2AAAEdwAAA7cAAAR4AAAEeAAAA7oAAAR5AAAEeQAAA7kAAAR6AAAEhgAAARoAAASIAAAEiQAAAScAAASKAAAEiwAABGIAAASMAAAEjAAABFwAAASNAAAEkQAAASkAAASSAAAEkwAABF4AAASUAAAElQAAAS4AAASWAAAElwAABFcAAASYAAAEmQAAA7sAAASaAAAEmwAABEkAAAScAAAEnQAAATAAAASeAAAEnwAABGAAAASgAAAEoQAAATIAAASiAAAEowAABEsAAASkAAAEqQAAATQAAASqAAAEqwAAA70AAASsAAAErQAABE0AAASuAAAErwAAA78AAASwAAAEsQAABGoAAASyAAAEswAABE8AAAS0AAAEtQAAAToAAAS2AAAEtwAABFEAAAS4AAAEugAAATwAAAS7AAAEuwAABFsAAAS8AAAEvQAAAT8AAAS+AAAEvwAABFkAAATAAAAEwgAAA8EAAATDAAAExAAAAUEAAATFAAAExgAABGgAAATHAAAEyAAAAUMAAATJAAAEygAABGQAAATLAAAEzAAABFMAAATNAAAEzgAABGYAAATPAAAE1wAAA8QAAATYAAAE2AAAAUUAAATZAAAE2QAAA84AAATaAAAE2gAAA80AAATbAAAE3wAAA88AAATgAAAE4QAAAUYAAATiAAAE9QAAA9QAAAT2AAAE9wAABFUAAAT4AAAE+QAAA+gAAAT6AAAE+wAAAUgAAAT8AAAE/QAAA+oAAAT+AAAE/wAABGwAAAUAAAAFAAAAAUoAAAUBAAAFAQAAA+wAAAUCAAAFEAAAAUsAAAURAAAFEQAABG4AAAUSAAAFEwAAA+0AAB4AAAAeAQAAA68AAB4+AAAePwAAA60AAB6AAAAehQAAA6AAAB6gAAAe8QAAA+8AAB7yAAAe8wAAA6YAAB70AAAe+QAABEEAAB9NAAAfTQAABKoAACAAAAAgCwAAAVsAACAQAAAgEQAAAWcAACATAAAgFAAAAWkAACAVAAAgFQAABHAAACAXAAAgHgAAAWsAACAgAAAgIgAAAXMAACAlAAAgJwAAAXYAACAwAAAgMAAAAXkAACAyAAAgMwAAA6gAACA5AAAgOgAAAXoAACA8AAAgPAAAA6oAACBEAAAgRAAAAXwAACB0AAAgdAAAAX0AACB/AAAgfwAAAX4AACCjAAAgowAABG8AACCkAAAgpAAAAX8AACCmAAAgqgAAAYAAACCrAAAgqwAABEgAACCsAAAgrAAAAYUAACCxAAAgsQAAAYYAACC5AAAgugAAAYcAACC8AAAgvQAAAYkAACEFAAAhBQAAAYsAACETAAAhEwAAAYwAACEWAAAhFgAAAY0AACEiAAAhIgAAAY4AACEmAAAhJgAAALkAACEuAAAhLgAAAY8AACFbAAAhXgAAAZAAACICAAAiAgAAAZQAACIGAAAiBgAAALEAACIPAAAiDwAAAZUAACIRAAAiEgAAAZYAACIaAAAiGgAAAZgAACIeAAAiHgAAAZkAACIrAAAiKwAAAZoAACJIAAAiSAAAAZsAACJgAAAiYAAAAZwAACJkAAAiZQAAAZ0AACXKAAAlygAAAZ8AAO4BAADuAgAAAaAAAPbDAAD2wwAAAaIAAPsBAAD7BAAAAaQAAP7/AAD+/wAAAaoAAP/8AAD//QAAAauwACxLsAlQWLEBAY5ZuAH/hbCEHbEJA19eLbABLCAgRWlEsAFgLbACLLABKiEtsAMsIEawAyVGUlgjWSCKIIpJZIogRiBoYWSwBCVGIGhhZFJYI2WKWS8gsABTWGkgsABUWCGwQFkbaSCwAFRYIbBAZVlZOi2wBCwgRrAEJUZSWCOKWSBGIGphZLAEJUYgamFkUlgjilkv/S2wBSxLILADJlBYUViwgEQbsEBEWRshISBFsMBQWLDARBshWVktsAYsICBFaUSwAWAgIEV9aRhEsAFgLbAHLLAGKi2wCCxLILADJlNYsEAbsABZioogsAMmU1gjIbCAioobiiNZILADJlNYIyGwwIqKG4ojWSCwAyZTWCMhuAEAioobiiNZILADJlNYIyG4AUCKihuKI1kgsAMmU1iwAyVFuAGAUFgjIbgBgCMhG7ADJUUjISMhWRshWUQtsAksS1NYRUQbISFZLbAKLLAkRS2wCyywJUUtsAwssScBiCCKU1i5QAAEAGO4CACIVFi5ACQD6HBZG7AjU1iwIIi4EABUWLkAJAPocFlZWS2wDSywQIi4IABaWLElAEQbuQAlA+hEWS2wDCuwACsAsgEOAisBsg8BAisBtw86MCUbEAAIKwC3AUg7LiEUAAgrtwJYSDgoFAAIK7cDUkM0JRYACCu3BF5NPCsZAAgrtwU2LCIZDwAIK7cGcV1GMhsACCu3B5F3XDojAAgrtwh+Z1A5GgAIK7cJVEU2JhcACCu3CnZgSzYdAAgrtwuDZE46IwAIK7cM2bKKYzwACCu3DRQRDQkGAAgrtw48MiccEQAIKwCyEAoHK7AAIEV9aRhEsjASAXOysBQBc7JQFAF0soAUAXSycBQBdbIPHAFzsm8cAXUAACoAnQCAAIoAeADUAGQATgBaAIcAYABWADQCPAC8AMQAAAAU/mAAFAKbACADIQALBDoAFASNABAFsAAUBhgAFQGmABEGwAAOAAAAAAAAAGEAYQBhAGEAYQCTALgBOAGqAjoCzQLkAw4DOANrA5ADrwPFA+YD/QRKBHgExwU8BX8F3wY+BmsG3wdGB1sHcAePB7YH1QgzCNYJFQl0CcgKDQpNCoMK6wstC0gLewvQC/QMQgx+DNMNHg2DDd8OSg50DrYO5g87D5APwA/4EBwQMxBYEH8QmhC6ETIRkBHjEkESqBL6E3QTuRPxFD0UlBSvFRoVZRWzFhcWeBa1Fx8XcRe4F+gYNhh9GMIY+hk7GVIZkhnZGgwaaBraGz0bnBu7HGAcjx01HaMdrx3MHoQemh7WHxkfaR/kIAQgTSB5IJgg0yEFIU8hWyF1IY8hqSIKIm0iqyMmI3oj6iSoJRclaCXZJjgmliaxJwEnSyeIJ9koNCi3KVEpginnKk4quCsYK2srxCvyLFUsgyynLLUs4Cz/LTgtbC2wLeMuIS4+LlsuZC6XLsgu5C8AL0MvTy91L6IwHTBKMIwwujD2MWcxwTIpMp4zEzNGM7c0IzR/NMo1SjV3NdA2PjaPNuk3RDebN944HziIOOQ5SznCOhU6izrmO1871TxHPJs81z0uPYY99D5pPq4++D9AP7E/50AsQGlAskEKQW1BuUI2QsdDIkOSRAlEL0SFRPhFcUWqRgFGSEaQRuxHGkdGR9FIB0hHSIRIyEkfSYFJy0o9SsNLHkuVTBVMikz3TV5Nmk38TlxOxE9GT+FQLVB8UOdRVlHLUjpSxVNPU99UelT8VXRVuFX+VmpW0VeKWERYw1lCWZNZ4FoVWjFaaFp+WpRbZVvYXEBcm10OXT5daF29XhJeaV7LXx9ffl/IYDFgj2DtYYxiI2JzYrZjBmNUY5ZkBmR3ZM9lM2WsZiNmi2brZ0RnU2dnZ7RoF2ieaQ5pe2neaj5qrGsVa55sIGx8bM5tIG1xbeZuFW4VbhVuFW4VbhVuFW4VbhVuFW4VbhVuFW4dbiVuL245blBudG6Ybrpu1W7hbu1vJW9jb8Rv52/zcANwF3DocQRxIXE0cUhxj3IXcrRzQ3NPdA90cnTudYt17XZmdr93KXfZeD9403kxeZN5pHm1ecZ513pIem56pnrBevV7h3vIfFN8k3yxfM99CH0VfT99Yn1ufdZ+KH60fyJ/lIBXgFeCBoJygp+C6IMTgymDmYP5hEeEtIULhVOFm4XqhgSGQ4aphv2HRIeHh76IHYheiHmIr4jyiRaJZ4mgifOKPYqbivOLWIuCi7+L74xHjJCMwIz4jUGNbI27jiqObI7IjyGPTo/KkCeQPZCikUuRrpIRkmGSppLnkymTnJQAlG6UmJTOlTSVZpWyleSWI5aJluCXQZefmA+Yg5j4mUqZiZngmjeaq5skm2CbsJv4nD6ceZy6nPmdQ52bnaed9J5jnuCfN595n/6gX6DAoR2hsKHBohyiaKK2ovijaKPLpC+kn6UxpbWmS6a9px2nb6fPqEmoUai2qRepeanwqkuqu6sHq2arzqv4rEusd6zHrQutH60zrUWtWa1rrYKtlq3srhKuk671r0OvS69Tr1uvZq9ur3qv3a/dr+WwS7CxsRCxUrG2sc2x5LH7shKyK7JEslCyXLJzsoqyobK6stGy6LL/sxizL7NGs12zdLOLs6Szu7PSs+m0ArQZtDC0R7RdtHO0jLSltLG0vbTUtOu1AbUatTC1RrVdtXa1jLWjtbq10LXmtf+2FrYttkO2XLZztou2ora4ts+25rdJt9+39rgNuCS4OrhRuGi4f7iVuKy43bj0uQq5Ibk4uU+5ZrnOulK6abp/upa6rLrDutq68bsIuxS7K7tCu1S7a7uCu5m7sLvHu9676bv0vAu8F7wjvDq8UbxdvGm8gLyXvKO8r7zEvPm9Bb0RvSi9P71LvVe9br2EvZS9q73Bvdi9774IviG+OL5Pvlu+Z75+vpS+q77Cvtm+7777vwe/E78fvza/TL9Yv2S/cL98v5O/n7+2v8y/47/5wBDAJ8BAwFnAcsCLwOjBTsFlwXzBk8GpwcLB2cHwwgfCHsI1wkvCYsJ5wpDCp8LKwvLDBcMcwzPDScNfw3jDkcOdw6nDwMPXw+3EBcQbxDHESMRhxHjEj8SmxL3E1MTtxQTFG8UxxUrFYcV3xY7F8cYIxh7GNcZMxmLGeMaOxqXHDsckxzrHUcdox3THi8eix7nH0Mfbx/HICMgUyCrINshLyFfIbsh6yJHIqMi/yNjI78j7yRHJKMk+yUrJYMlsyYLJjsmkybrJ0cnqygPKX8p2yozKpMq7ytLK6Mrzyv/LC8sXyyPLL8s7y1fLX8tny2/Ld8t/y4fLj8uXy5/Lp8uvy7fLv8vHy+DL+cwQzCfMPsxUzG/Md8x/zIfMj8yXzK/Mx8zezPXNDM0lzTzNp82vzcjN0M3Yze/OBs4OzhbOHs4mzj3ORc5NzlXOXc5lzm3Odc59zoXOjc6kzqzOtM8Hzw/PF88wz0fPT89Xz3DPeM+Pz6XPvM/Tz+rQAdAa0DPQStBh0GnQcdB90JTQnNCz0MrQ1tDi0PnRENEn0T7RRtFO0WfRgNGM0ZjRpNGw0bzRyNHQ0djR4NH30g7SFtIt0kTSW9J00nzShNKb0rLSy9LT0uzTBdMe0zfTT9Nm03zTldOu08fT4NPo0/DUCdQi1DvUU9Rq1IDUmdSx1MrU49T81RTVMdVO1VrVZtVu1XrVhtWS1Z7VtdXM1eXV/dYW1i7WR9Zf1njWkNar1sXW3tb31xDXKddC11vXdNeN16jXw9fP19vX8tgJ2CDYNthP2GfYgNiY2LHYydji2PrZFdkv2UbZXdlp2XXZgdmN2aTZu9nU2ezaBdod2jbaTtpn2n/amtq02sva4tr52xDbJ9s+21Xba9t324Pbj9ub27Lbydvg2/fcDtwl3DzcU9xq3IDcjNyY3KTcsNzH3N7c9d0L3YHdlt2i3a7dut3G3dLd3t3q3fbeAt4O3hreJt4y3j7eSt5W3mLebt523tTfMt9037PgF+B14JDgq+C34MPgz+Db4Ofg8+E94Y3h5eI74kPiT+JZ4mHiaeJx4nnigeKJ4qDit+LO4uXi/uMX4zDjSeNi43vjlOOt48bj3+P45BHkHeQp5DXkQeRN5FnkZeRx5H3klOSm5LLkvuTK5Nbk4uTu5PrlBuUd5TTlQOVM5VjlZOVw5Xzlk+Wp5bXlweXN5dnl5eXx5f3mCeYV5iHmLeY55kXmUeZZ5mHmaeZx5nnmgeaJ5pHmmeah5qnmsea55tLm6ucC5xnnIecp50LnSudh53fnf+eH54/nl+eu57bnvufG587n1ufe5+bn7uh46MTpIukq6TbpTelj6Wvpd+mD6Y/pmwAAAAUAZAAAAygFsAADAAYACQAMAA8AcbIMEBEREjmwDBCwANCwDBCwBtCwDBCwCdCwDBCwDdAAsABFWLACLxuxAhw+WbAARViwAC8bsQAQPlmyBAIAERI5sgUCABESObIHAgAREjmyCAIAERI5sQoM9LIMAgAREjmyDQIAERI5sAIQsQ4M9DAxISERIQMRAQERAQMhATUBIQMo/TwCxDb+7v66AQzkAgP+/gEC/f0FsPqkBQf9fQJ3+xECeP1eAl6IAl4AAgCg//UBewWwAAMADAAvALAARViwAi8bsQIcPlmwAEVYsAsvG7ELED5ZsgYFCitYIdgb9FmyAQYCERI5MDEBIwMzAzQ2MhYUBiImAVunDcLJN2w4OGw3AZsEFfqtLT09Wjs7AAIAiAQSAiMGAAAEAAkAGQCwAy+yAgoDERI5sAIvsAfQsAMQsAjQMDEBAyMTMwUDIxMzARUebwGMAQ4ebwGMBXj+mgHuiP6aAe4AAgB3AAAE0wWwABsAHwCPALAARViwDC8bsQwcPlmwAEVYsBAvG7EQHD5ZsABFWLACLxuxAhA+WbAARViwGi8bsRoQPlmyHQwCERI5fLAdLxiyAAMKK1gh2Bv0WbAE0LAdELAG0LAdELAL0LALL7IIAworWCHYG/RZsAsQsA7QsAsQsBLQsAgQsBTQsB0QsBbQsAAQsBjQsAgQsB7QMDEBIQMjEyM1IRMhNSETMwMhEzMDMxUjAzMVIwMjAyETIQL9/vhQj1DvAQlF/v4BHVKPUgEIUpBSzOdF4ftQkJ4BCEX++AGa/mYBmokBYosBoP5gAaD+YIv+non+ZgIjAWIAAAEAbv8wBBEGnAArAGYAsABFWLAJLxuxCRw+WbAARViwIi8bsSIQPlmyAiIJERI5sAkQsAzQsAkQsBDQsAkQshMBCitYIdgb9FmwAhCyGQEKK1gh2Bv0WbAiELAf0LAiELAm0LAiELIpAQorWCHYG/RZMDEBNCYnJiY1NDY3NTMVFhYVIzQmIyIGFRQWBBYWFRQGBxUjNSYmNTMUFjMyNgNYgZnVw7+nlai7uIZyd36FATGrUcu3lLrTuZKGg5YBd1x+M0HRoaTSFNvcF+zNjaZ7bmZ5Y3eeaqnOE7+/EefGi5Z+AAUAaf/rBYMFxQANABoAJgA0ADgAeACwAEVYsAMvG7EDHD5ZsABFWLAjLxuxIxA+WbADELAK0LAKL7IRBAorWCHYG/RZsAMQshgECitYIdgb9FmwIxCwHdCwHS+wIxCyKgQKK1gh2Bv0WbAdELIxBAorWCHYG/RZsjUjAxESObA1L7I3AyMREjmwNy8wMRM0NjMyFhUVFAYjIiY1FxQWMzI2NTU0JiIGFQE0NiAWFRUUBiAmNRcUFjMyNjU1NCYjIgYVBScBF2mng4Wlp4GCqopYSkdXVpRWAjunAQaop/78qopYSkhWV0lHWf4HaQLHaQSYg6qriEeEp6eLB05lYlVJTmZmUvzRg6moi0eDqaeLBk9lY1VKT2RjVPNCBHJCAAMAZf/sBPMFxAAeACcAMwCFALAARViwCS8bsQkcPlmwAEVYsBwvG7EcED5ZsABFWLAYLxuxGBA+WbIiHAkREjmyKgkcERI5sgMiKhESObIQKiIREjmyEQkcERI5shMcCRESObIZHAkREjmyFhEZERI5sBwQsh8BCitYIdgb9FmyIR8RERI5sAkQsjEBCitYIdgb9FkwMRM0NjcmJjU0NjMyFhUUBgcHATY1MxQHFyMnBgYjIiQFMjcBBwYVFBYDFBc3NjY1NCYjIgZldaVhQsSolsRZb2sBRESne9DeYUrHZ9X+/gHXk3r+nSGnmSJ2dkQyZExSYAGHabB1dpBHpryvhViVUk/+fYKf/6j5c0JF4ktwAakYe4J2jgPlYJBTMFc+Q1lvAAEAZwQhAP0GAAAEABAAsAMvsgIFAxESObACLzAxEwMjEzP9FYEBlQWR/pAB3wABAIX+KgKVBmsAEQAJALAOL7AELzAxEzQSEjcXBgIDBxATFhcHJicChXnwgSaSuwkBjVV1JoV57AJP4gGgAVRGenD+NP7jVf5+/uSqYHFKrgFUAAABACb+KgI3BmsAEQAJALAOL7AELzAxARQCAgcnNhITNTQCAic3FhISAjd18YQnmrsCWJ1iJ4TvdwJF3/5n/qZJcXYB8QEvINIBaQEeUHFJ/qr+ZAABABwCYQNVBbAADgAgALAARViwBC8bsQQcPlmwANAZsAAvGLAJ0BmwCS8YMDEBJTcFAzMDJRcFEwcDAycBSv7SLgEuCZkKASku/s3GfLq0fQPXWpdwAVj+o26YW/7xXgEg/udbAAABAE4AkgQ0BLYACwAaALAJL7AA0LAJELIGAQorWCHYG/RZsAPQMDEBIRUhESMRITUhETMCngGW/mq6/moBlroDDa/+NAHMrwGpAAEAHf7eATQA2wAIABcAsAkvsgQFCitYIdgb9FmwANCwAC8wMRMnNjc1MxUUBoZpXgS1Y/7eSIOLp5FlygAAAQAlAh8CDQK2AAMAEQCwAi+yAQEKK1gh2Bv0WTAxASE1IQIN/hgB6AIflwABAJD/9QF2ANEACQAbALAARViwBy8bsQcQPlmyAgUKK1gh2Bv0WTAxNzQ2MhYVFAYiJpA5cjs7cjlhMEBAMC4+PgABABL/gwMQBbAAAwATALAAL7AARViwAi8bsQIcPlkwMRcjATOxnwJgnn0GLQAAAgBz/+wECgXEAA0AGwA5ALAARViwCi8bsQocPlmwAEVYsAMvG7EDED5ZsAoQshEBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxARACIyICAzUQEjMyEhMnNCYjIgYHERQWMzI2NwQK3uzp4ATe7eveA7mEj46CAomLiYUDAm3+u/7EATUBM/cBQQE4/tP+xg3r19be/tjs4dTkAAEAqgAAAtkFtwAGADkAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvsgMBCitYIdgb9FmyAgMFERI5MDEhIxEFNSUzAtm6/osCEh0E0YmoxwAAAQBdAAAEMwXEABcATQCwAEVYsBAvG7EQHD5ZsABFWLAALxuxABA+WbIXAQorWCHYG/RZsALQsgMQFxESObAQELIJAQorWCHYG/RZsBAQsAzQshUXEBESOTAxISE1ATY2NTQmIyIGFSM0JDMyFhUUAQEhBDP8RgH4cFWKc4qZuQED2cvs/u7+egLbhQIwf59VcpKdjMn41bHX/tf+WQABAF7/7AP5BcQAJgB4ALAARViwDS8bsQ0cPlmwAEVYsBkvG7EZED5ZsgANGRESObAAL7LPAAFdsp8AAXGyLwABXbJfAAFysA0QsgYBCitYIdgb9FmwDRCwCdCwABCyJgEKK1gh2Bv0WbITJgAREjmwGRCwHNCwGRCyHwEKK1gh2Bv0WTAxATM2NjUQIyIGFSM0NjMyFhUUBgcWFhUUBCAkNTMUFjMyNjU0JicjAYaLg5b/eI+5/cPO6ntqeIP/AP5m/v+6ln6GjpyTiwMyAoZyAQCJca3l2sJfsiwmsH/E5t62c4qMg3+IAgACADUAAARQBbAACgAOAEkAsABFWLAJLxuxCRw+WbAARViwBC8bsQQQPlmyAQkEERI5sAEvsgIBCitYIdgb9FmwBtCwARCwC9CyCAYLERI5sg0JBBESOTAxATMVIxEjESE1ATMBIREHA4bKyrr9aQKMxf2BAcUWAemX/q4BUm0D8fw5AsooAAEAmv/sBC0FsAAdAGEAsABFWLABLxuxARw+WbAARViwDS8bsQ0QPlmwARCyBAEKK1gh2Bv0WbIHDQEREjmwBy+yGgEKK1gh2Bv0WbIFBxoREjmwDRCwEdCwDRCyFAEKK1gh2Bv0WbAHELAd0DAxExMhFSEDNjMyEhUUAiMiJiczFhYzMjY1NCYjIgcHzkoC6v2zLGuIx+rz2sH0Ea8RkHaBk5+EeUUxAtoC1qv+cz/++eDh/v3WvX1/sJuSsTUoAAIAhP/sBBwFsQAUACEATgCwAEVYsAAvG7EAHD5ZsABFWLANLxuxDRA+WbAAELIBAQorWCHYG/RZsgcNABESObAHL7IVAQorWCHYG/RZsA0QshwBCitYIdgb9FkwMQEVIwYEBzYzMhIVFAIjIgA1NRAAJQMiBgcVFBYzMjY1NCYDTyLY/wAUc8e+4/XO0f78AVcBU9JfoB+ieX2PkQWxnQT44YT+9NTh/vIBQf1HAZIBqQX9cHJWRLTcuJWWuQABAE0AAAQlBbAABgAyALAARViwBS8bsQUcPlmwAEVYsAEvG7EBED5ZsAUQsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITUhBCX9pcICWfzsA9gFSPq4BRiYAAADAHD/7AQOBcQAFwAhACsAYQCwAEVYsBUvG7EVHD5ZsABFWLAJLxuxCRA+WbInCRUREjmwJy+yzycBXbIaAQorWCHYG/RZsgMaJxESObIPJxoREjmwCRCyHwEKK1gh2Bv0WbAVELIiAQorWCHYG/RZMDEBFAYHFhYVFAYjIiY1NDY3JiY1NDYzMhYDNCYiBhQWMzI2ASIGFRQWMjY0JgPsc2Jyhf/Q0v2BcmFw7MHA7Zeb+peTg4KU/upth4XehYoENG2qMDG8d73g4bx2vjEwqmy42Nj8oXqamPiOjwQah3RviYnejAAAAgBk//8D+AXEABcAJABYALAARViwCy8bsQscPlmwAEVYsBMvG7ETED5ZsgMTCxESObADL7IAAwsREjmwExCyFAEKK1gh2Bv0WbADELIYAQorWCHYG/RZsAsQsh8BCitYIdgb9FkwMQEGBiMiJiY1NDY2MzISERUQAAUjNTM2NiUyNjc1NCYjIgYVFBYDPjqhYH67Zm/MiNj5/rD+rSQn5fb+7l2dJJ55epSPAoBFVHzhiJLqfP69/uk2/lf+eQWcBOf6clRKtuS7mZXBAP//AIb/9QFtBEQAJgAS9gABBwAS//cDcwAQALAARViwDS8bsQ0YPlkwMf//ACn+3gFVBEQAJwAS/98DcwEGABAMAAAQALAARViwAy8bsQMYPlkwMQABAEgAwwN6BEoABgAWALAARViwBS8bsQUYPlmwAtCwAi8wMQEFFQE1ARUBCAJy/M4DMgKE/cQBe5IBesQAAAIAmAGPA9oDzwADAAcAJQCwBy+wA9CwAy+yAAEKK1gh2Bv0WbAHELIEAQorWCHYG/RZMDEBITUhESE1IQPa/L4DQvy+A0IDLqH9wKAAAAEAhgDEA9wESwAGABYAsABFWLACLxuxAhg+WbAF0LAFLzAxAQE1ARUBNQMb/WsDVvyqAooBA77+hpL+hcAAAgBL//UDdgXEABgAIQBRALAARViwEC8bsRAcPlmwAEVYsCAvG7EgED5ZshsFCitYIdgb9FmyABsQERI5sgQQABESObAQELIJAQorWCHYG/RZsBAQsAzQshUAEBESOTAxATY2Nzc2NTQmIyIGFSM2NjMyFhUUBwcGFQM0NjIWFAYiJgFlAjJNg1RuaWZ8uQLjtr3Tom1JwTdsODhsNwGad4pUh19taXdsW6LHy7GvqmxRmP7DLT09Wjs7AAACAGr+OwbWBZcANQBCAGgAsDIvsABFWLAILxuxCBA+WbAD0LIPMggREjmwDy+yBQgPERI5sAgQsjkCCitYIdgb9FmwFdCwMhCyGwIKK1gh2Bv0WbAIELAq0LAqL7IjAgorWCHYG/RZsA8QskACCitYIdgb9FkwMQEGAiMiJwYGIyImNzYSNjMyFhcDBjMyNjcSACEiBAIHBhIEMzI2NxcGBiMiJAITEhIkMzIEEgEGFjMyNjc3EyYjIgYGygzYtbs1NotKjpITD3m/aVGAUDQTk3GMBhP+uf6yyf7ItAsMkAEn0Vq1PCU+zWn6/pizDAzeAXzv+QFkrvvyDlFYPG8kAS44QHWZAfby/uioVVPozaUBA5QrP/3W5+C0AYUBmMf+iPb4/pPBLCNzJzLhAacBGwETAbfv4P5a/pCOmGZfCQH3He4AAAIAHAAABR0FsAAHAAoARgCwAEVYsAQvG7EEHD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMjATMBIwEhAwPN/Z6JxgIsqAItxf1NAe/4AXz+hAWw+lACGgKpAAMAqQAABIgFsAAOABYAHwBVALAARViwAS8bsQEcPlmwAEVYsAAvG7EAED5ZshcAARESObAXL7IPAQorWCHYG/RZsggPFxESObAAELIQAQorWCHYG/RZsAEQsh8BCitYIdgb9FkwMTMRITIWFRQGBxYWFRQGIwERITI2NRAhJSEyNjU0JiMhqQHc7e90ZHaJ/uj+xwE9hpv+4v7AASJ+l4yP/uQFsMTAZp0rIbmAxOACqf30i3oBB5p+bHhtAAABAHf/7ATYBcQAHABFALAARViwCy8bsQscPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WbADELAc0DAxAQYEIyAAETU0EiQzMgAXIyYmIyICFRUUEjMyNjcE2Bv+4e7+/v7JkQEKr+gBGBfBGaeWuNHGsqCrHAHO5/sBcgE2jMsBNKX+/eWunP7w+43t/uiRtAACAKkAAATGBbAACwAVADkAsABFWLABLxuxARw+WbAARViwAC8bsQAQPlmwARCyDAEKK1gh2Bv0WbAAELINAQorWCHYG/RZMDEzESEyBBIXFRQCBAcDETMyEjU1NAInqQGbvgEknwGf/tnE08re9+nWBbCo/srJXc7+yqYCBRL7iwEU/1X4ARMCAAABAKkAAARGBbAACwBOALAARViwBi8bsQYcPlmwAEVYsAQvG7EEED5ZsgsEBhESObALL7IAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASERIRUhESEVIREhA+D9iQLd/GMDk/0tAncCof38nQWwnv4sAAEAqQAABC8FsAAJAEAAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmyCQIEERI5sAkvsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASERIxEhFSERIQPM/Z3AA4b9OgJjAoP9fQWwnv4OAAEAev/sBNwFxAAfAGIAsABFWLALLxuxCxw+WbAARViwAy8bsQMQPlmwCxCwD9CwCxCyEQEKK1gh2Bv0WbADELIYAQorWCHYG/RZsh4DCxESObAeL7QPHh8eAl20Px5PHgJdsh0BCitYIdgb9FkwMSUGBCMiJAInNRAAITIEFyMCISICAxUUEjMyNjcRITUhBNxK/vewsv7slwIBMwEW5AEWH8A2/t7BxwHgv2yiNf6vAhC/ammnATTLfwFJAWrp1gEh/vH+/3f1/t8wOQFHnAABAKkAAAUIBbAACwBVALAARViwBi8bsQYcPlmwAEVYsAovG7EKHD5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmwABCwCdCwCS+ynwkBcrIvCQFdsgIBCitYIdgb9FkwMSEjESERIxEzESERMwUIwf0iwMAC3sECof1fBbD9jgJyAAABALcAAAF3BbAAAwAdALAARViwAi8bsQIcPlmwAEVYsAAvG7EAED5ZMDEhIxEzAXfAwAWwAAABADX/7APMBbAADwAuALAARViwAC8bsQAcPlmwAEVYsAUvG7EFED5ZsAnQsAUQsgwBCitYIdgb9FkwMQEzERQGIyImNTMUFjMyNjcDC8H70dnywImCd5MBBbD7+dHs3sh9jJaHAAABAKkAAAUFBbAACwB0ALAARViwBS8bsQUcPlmwAEVYsAcvG7EHHD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAIFERI5QBFKAFoAagB6AIoAmgCqALoACF2yOQABXbIGBQIREjlAEzYGRgZWBmYGdgaGBpYGpga2BgldMDEBBxEjETMRATMBASMCG7LAwAKH6P3DAmrmAqW5/hQFsP0wAtD9ffzTAAEAqQAABBwFsAAFACgAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WTAxJSEVIREzAWoCsvyNwZ2dBbAAAAEAqQAABlIFsAAOAFkAsABFWLAALxuxABw+WbAARViwAi8bsQIcPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbAARViwDC8bsQwQPlmyAQAEERI5sgcABBESObIKAAQREjkwMQkCMxEjERMBIwETESMRAaEB3AHc+cAS/iKT/iMTwAWw+1wEpPpQAjcCZPtlBJj9n/3JBbAAAAEAqQAABQgFsAAJAEyyAQoLERI5ALAARViwBS8bsQUcPlmwAEVYsAgvG7EIHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmyAgUAERI5sgcFABESOTAxISMBESMRMwERMwUIwf0jwcEC378EYvueBbD7mQRnAAIAdv/sBQkFxAARAB8AOQCwAEVYsA0vG7ENHD5ZsABFWLAELxuxBBA+WbANELIVAQorWCHYG/RZsAQQshwBCitYIdgb9FkwMQEUAgQjIiQCJzU0EiQzMgQSFScQAiMiAgcVFBIzMhI3BQmQ/viwrP72kwKSAQusrwELkL/Qu7bRA9O5uswDAqnW/sGoqQE5zmnSAUKrqf6/1QIBAwEV/uv2a/v+4QEP/QAAAgCpAAAEwAWwAAoAEwBNsgoUFRESObAKELAM0ACwAEVYsAMvG7EDHD5ZsABFWLABLxuxARA+WbILAwEREjmwCy+yAAEKK1gh2Bv0WbADELISAQorWCHYG/RZMDEBESMRITIEFRQEIyUhMjY1NCYnIQFpwAIZ7wEP/vf3/qkBWZqkpI/+nAI6/cYFsPTJ1OWdkYmCnAMAAgBt/woFBgXEABUAIgBNsggjJBESObAIELAZ0ACwAEVYsBEvG7ERHD5ZsABFWLAILxuxCBA+WbIDCBEREjmwERCyGQEKK1gh2Bv0WbAIELIgAQorWCHYG/RZMDEBFAIHBQclBiMiJAInNTQSJDMyBBIVJxACIyICBxUUEiASNwUBhnkBBIP+zUhQrP72kwKSAQussAELkMDNvrXRA9EBdMwDAqnT/s9WzHn0EqkBOc5p0gFCq6r+wdUBAQEBF/7r9mv6/uABD/0AAAIAqAAABMkFsAAOABcAYbIFGBkREjmwBRCwFtAAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmwAEVYsA0vG7ENED5ZshAEAhESObAQL7IAAQorWCHYG/RZsgsABBESObAEELIWAQorWCHYG/RZMDEBIREjESEyBBUUBgcBFSMBITI2NTQmJyECv/6qwQHi9gEJk4MBVs79bgEnj6mhmP7aAk39swWw4NaIyjL9lgwC6pR8h5ABAAABAFD/7ARyBcQAJgBhsgAnKBESOQCwAEVYsAYvG7EGHD5ZsABFWLAaLxuxGhA+WbAGELAL0LAGELIOAQorWCHYG/RZsiYaBhESObAmELIUAQorWCHYG/RZsBoQsB/QsBoQsiIBCitYIdgb9FkwMQEmJjU0JDMyFhYVIzQmIyIGFRQWBBYWFRQEIyIkJjUzFBYzMjY0JgJW9+EBE9yW64HBqJmOn5cBa81j/uznlv78jcHDo5iilgKJR8+YrOF0zHmEl31vWXtme6RvsdVzyH+EmXzWdQAAAQAxAAAElwWwAAcALgCwAEVYsAYvG7EGHD5ZsABFWLACLxuxAhA+WbAGELIAAQorWCHYG/RZsATQMDEBIREjESE1IQSX/iy//i0EZgUS+u4FEp4AAQCM/+wEqgWwABIAPLIFExQREjkAsABFWLAALxuxABw+WbAARViwCS8bsQkcPlmwAEVYsAUvG7EFED5Zsg4BCitYIdgb9FkwMQERBgAHByIAJxEzERQWMzI2NREEqgH+/9wz7/7kAr6uoaOtBbD8Is7++hACAQLiA+D8Jp6vrp4D2wAAAQAcAAAE/QWwAAYAOLIABwgREjkAsABFWLABLxuxARw+WbAARViwBS8bsQUcPlmwAEVYsAMvG7EDED5ZsgABAxESOTAxJQEzASMBMwKLAaDS/eSq/eXR/wSx+lAFsAAAAQA9AAAG7QWwABIAWQCwAEVYsAMvG7EDHD5ZsABFWLAILxuxCBw+WbAARViwES8bsREcPlmwAEVYsAovG7EKED5ZsABFWLAPLxuxDxA+WbIBAwoREjmyBgMKERI5sg0DChESOTAxARc3ATMBFzcTMwEjAScHASMBMwHjHCkBIKIBGSgf4sH+n6/+1BcX/smv/qDAAcvArQP4/AiwxAPk+lAEJW9v+9sFsAABADkAAATOBbAACwBrALAARViwAS8bsQEcPlmwAEVYsAovG7EKHD5ZsABFWLAELxuxBBA+WbAARViwBy8bsQcQPlmyAAEEERI5QAmGAJYApgC2AARdsgYBBBESOUAJiQaZBqkGuQYEXbIDAAYREjmyCQYAERI5MDEBATMBASMBASMBATMChAFd4v40Adfk/pr+mOMB2P4z4QOCAi79Lv0iAjj9yALeAtIAAAEADwAABLsFsAAIADEAsABFWLABLxuxARw+WbAARViwBy8bsQccPlmwAEVYsAQvG7EEED5ZsgABBBESOTAxAQEzAREjEQEzAmUBfNr+CsD+CtwC1QLb/G/94QIfA5EAAAEAVgAABHoFsAAJAEQAsABFWLAHLxuxBxw+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WbIEAAIREjmwBxCyBQEKK1gh2Bv0WbIJBQcREjkwMSUhFSE1ASE1IRUBOQNB+9wDHvzvA/ednZAEgp6NAAABAJL+yAILBoAABwAiALAEL7AHL7IAAQorWCHYG/RZsAQQsgMBCitYIdgb9FkwMQEjETMVIREhAgu/v/6HAXkF6Pl4mAe4AAABACj/gwM4BbAAAwATALACL7AARViwAC8bsQAcPlkwMRMzASMosAJgsAWw+dMAAQAJ/sgBgwaAAAcAJQCwAi+wAS+wAhCyBQEKK1gh2Bv0WbABELIGAQorWCHYG/RZMDETIREhNTMRIwkBev6GwcEGgPhImAaIAAABAEAC2QMUBbAABgAnsgAHCBESOQCwAEVYsAMvG7EDHD5ZsADQsgEHAxESObABL7AF0DAxAQMjATMBIwGqvqwBK38BKqsEu/4eAtf9KQABAAT/aQOYAAAAAwAbALAARViwAy8bsQMQPlmyAAEKK1gh2Bv0WTAxBSE1IQOY/GwDlJeXAAABADkE2AHaBf4AAwAjALABL7IPAQFdsADQGbAALxiwARCwAtCwAi+0DwIfAgJdMDEBIwEzAdqf/v7fBNgBJgAAAgBt/+wD6gROAB4AKAB5shcpKhESObAXELAg0ACwAEVYsBcvG7EXGD5ZsABFWLAELxuxBBA+WbAARViwAC8bsQAQPlmyAhcEERI5sgsXBBESObALL7AXELIPAQorWCHYG/RZshILFxESObAEELIfAQorWCHYG/RZsAsQsiMBCitYIdgb9FkwMSEmJwYjIiY1NCQzMzU0JiMiBhUjNDY2MzIWFxEUFxUlMjY3NSMgFRQWAygQCoGzoM0BAem0dHFjhrpzxXa71AQm/gtXnCOR/qx0IFKGtYupu1Vhc2RHUZdYu6T+DpVYEI1aSN7HV2IAAgCM/+wEIAYAAA4AGQBkshIaGxESObASELAD0ACwCC+wAEVYsAwvG7EMGD5ZsABFWLADLxuxAxA+WbAARViwBi8bsQYQPlmyBQgDERI5sgoMAxESObAMELISAQorWCHYG/RZsAMQshcBCitYIdgb9FkwMQEUAiMiJwcjETMRNiASESc0JiMiBxEWMzI2BCDkwM1wCaq5cAGK4bmSibdQVbSFlAIR+P7TkX0GAP3Di/7W/v0Fvc6q/iyqzgABAFz/7APsBE4AHQBJshAeHxESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsAgQsAPQsBAQsBTQsBAQshcBCitYIdgb9FkwMSUyNjczDgIjIgARNTQ2NjMyFhcjJiYjIgYVFRQWAj5jlAivBXbFbt3++3TZlLbxCK8Ij2mNm5qDeFpdqGQBJwEAH572iNquaYfLwCO7ygAAAgBf/+wD8AYAAA8AGgBkshgbHBESObAYELAD0ACwBi+wAEVYsAMvG7EDGD5ZsABFWLAMLxuxDBA+WbAARViwCC8bsQgQPlmyBQMMERI5sgoDDBESObAMELITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMRM0EjMyFxEzESMnBiMiAjUXFBYzMjcRJiMiBl/sv75vuaoJb8a87bmYhrBRU6yImAIm+QEvggI0+gB0iAE0+Ae40J4B8ZnSAAACAF3/7APzBE4AFQAdAGmyCB4fERI5sAgQsBbQALAARViwCC8bsQgYPlmwAEVYsAAvG7EAED5ZshoIABESObAaL7S/Gs8aAl2yDAEKK1gh2Bv0WbAAELIQAQorWCHYG/RZshMIABESObAIELIWAQorWCHYG/RZMDEFIgA1NTQ2NjMyEhEVIRYWMzI2NxcGASIGByE1JiYCTdz+7HvdgdPq/SMEs4piiDNxiP7ZcJgSAh4IiBQBIfIiof2P/ur+/U2gxVBCWNEDyqOTDo2bAAEAPAAAAsoGFQAVAGOyDxYXERI5ALAARViwCC8bsQgePlmwAEVYsAMvG7EDGD5ZsABFWLARLxuxERg+WbAARViwAC8bsQAQPlmwAxCyAQEKK1gh2Bv0WbAIELINAQorWCHYG/RZsAEQsBPQsBTQMDEzESM1MzU0NjMyFwcmIyIGFRUzFSMR56uruqpAPwovNVpi5+cDq49vrr4RlglpYnKP/FUAAgBg/lYD8gROABkAJACDsiIlJhESObAiELAL0ACwAEVYsAMvG7EDGD5ZsABFWLAGLxuxBhg+WbAARViwCy8bsQsSPlmwAEVYsBcvG7EXED5ZsgUDFxESObIPFwsREjmwCxCyEQEKK1gh2Bv0WbIVAxcREjmwFxCyHQEKK1gh2Bv0WbADELIiAQorWCHYG/RZMDETNBIzMhc3MxEUBiMiJic3FjMyNjU1BiMiAjcUFjMyNxEmIyIGYOrBxm8JqfnSdeA7YHesh5dvwL7rupaHr1JVqoeYAib9ASuMePvg0vJkV2+TmIpdgAEy87fRnwHum9IAAAEAjAAAA98GAAARAEmyChITERI5ALAQL7AARViwAi8bsQIYPlmwAEVYsAUvG7EFED5ZsABFWLAOLxuxDhA+WbIAAgUREjmwAhCyCgEKK1gh2Bv0WTAxATYzIBMRIxEmJiMiBgcRIxEzAUV7xQFXA7kBaW9aiCa5uQO3l/59/TUCzHVwYE78/QYAAAIAjQAAAWgFxAADAAwAPrIGDQ4REjmwBhCwAdAAsABFWLACLxuxAhg+WbAARViwAC8bsQAQPlmwAhCwCtCwCi+yBgUKK1gh2Bv0WTAxISMRMwM0NjIWFAYiJgFVubnIN2w4OGw3BDoBHy0+Plo8PAAC/7/+SwFZBcQADAAWAEmyEBcYERI5sBAQsADQALAARViwDC8bsQwYPlmwAEVYsAMvG7EDEj5ZsggBCitYIdgb9FmwDBCwFdCwFS+yEAUKK1gh2Bv0WTAxAREQISInNRYzMjY1EQM0NjMyFhQGIiYBS/7lPTQgND5BEzc1Njg4bDYEOvtJ/sgSlAhDUwS7AR8sPz5aPDwAAAEAjQAABAwGAAAMAHUAsABFWLAELxuxBB4+WbAARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIACAIREjlAFToASgBaAGoAegCKAJoAqgC6AMoACl2yBggCERI5QBU2BkYGVgZmBnYGhgaWBqYGtgbGBgpdMDEBBxEjETMRNwEzAQEjAbp0ubljAVHh/lsB1tkB9Xn+hAYA/F93AWT+PP2KAAEAnAAAAVUGAAADAB0AsABFWLACLxuxAh4+WbAARViwAC8bsQAQPlkwMSEjETMBVbm5BgAAAAEAiwAABngETgAdAHeyBB4fERI5ALAARViwAy8bsQMYPlmwAEVYsAgvG7EIGD5ZsABFWLAALxuxABg+WbAARViwCy8bsQsQPlmwAEVYsBQvG7EUED5ZsABFWLAbLxuxGxA+WbIBCAsREjmyBQgLERI5sAgQshABCitYIdgb9FmwGNAwMQEXNjMyFzY2MyATESMRNCYjIgYHESMRNCMiBxEjEQE6BXfK41I2rXYBZAa5an1niAu657ZDuQQ6eIyuTmD+h/0rAsp0c3to/TICxeyb/OoEOgABAIwAAAPfBE4AEQBTsgsSExESOQCwAEVYsAMvG7EDGD5ZsABFWLAALxuxABg+WbAARViwBi8bsQYQPlmwAEVYsA8vG7EPED5ZsgEDBhESObADELILAQorWCHYG/RZMDEBFzYzIBMRIxEmJiMiBgcRIxEBOwZ8yAFXA7kBaW9aiCa5BDqInP59/TUCzHVwYE78/QQ6AAACAFv/7AQ0BE4ADwAbAEOyDBwdERI5sAwQsBPQALAARViwBC8bsQQYPlmwAEVYsAwvG7EMED5ZshMBCitYIdgb9FmwBBCyGQEKK1gh2Bv0WTAxEzQ2NjMyABUVFAYGIyIANRcUFjMyNjU0JiMiBlt934/dARF54ZLc/u+6p4yNpqmMiagCJ5/+iv7O/g2e+4wBMvwJtNrdx7Ld2gACAIz+YAQeBE4ADwAaAG6yExscERI5sBMQsAzQALAARViwDC8bsQwYPlmwAEVYsAkvG7EJGD5ZsABFWLAGLxuxBhI+WbAARViwAy8bsQMQPlmyBQwDERI5sgoMAxESObAMELITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMQEUAiMiJxEjETMXNjMyEhEnNCYjIgcRFjMyNgQe4sHFcbmpCXHJw+O5nIioVFOrhZ0CEff+0n399wXaeIz+2v76BLfUlf37lNMAAAIAX/5gA+8ETgAPABoAa7IYGxwREjmwGBCwA9AAsABFWLADLxuxAxg+WbAARViwBi8bsQYYPlmwAEVYsAgvG7EIEj5ZsABFWLAMLxuxDBA+WbIFAwwREjmyCgMMERI5shMBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxEzQSMzIXNzMRIxEGIyICNRcUFjMyNxEmIyIGX+rFwG8IqrlwusTpuZ2FpVdYooaeAib/ASmBbfomAgR4ATH8CLrUkgISj9UAAQCMAAAClwROAA0ARrIEDg8REjkAsABFWLALLxuxCxg+WbAARViwCC8bsQgYPlmwAEVYsAUvG7EFED5ZsAsQsgIBCitYIdgb9FmyCQsFERI5MDEBJiMiBxEjETMXNjMyFwKXKjG2Qbm0A1unNhwDlAeb/QAEOn2RDgABAF//7AO7BE4AJgBhsgknKBESOQCwAEVYsAkvG7EJGD5ZsABFWLAcLxuxHBA+WbIDHAkREjmwCRCwDdCwCRCyEAEKK1gh2Bv0WbADELIVAQorWCHYG/RZsBwQsCHQsBwQsiQBCitYIdgb9FkwMQE0JiQmJjU0NjMyFhUjNCYjIgYVFBYEFhYVFAYjIiYmNTMWFjMyNgMCcf7npU/hr7jluoFiZXJqARWsU+i5gshxuQWLcml/AR9LUzxUdFCFuL6UTG5YR0NEPlZ5V5GvXKVgXW1VAAEACf/sAlYFQAAVAF+yDhYXERI5ALAARViwAS8bsQEYPlmwAEVYsBMvG7ETGD5ZsABFWLANLxuxDRA+WbABELAA0LAAL7ABELIDAQorWCHYG/RZsA0QsggBCitYIdgb9FmwAxCwEdCwEtAwMQERMxUjERQWMzI3FQYjIiY1ESM1MxEBh8rKNkEgOElFfH7FxQVA/vqP/WFBQQyWFJaKAp+PAQYAAQCI/+wD3AQ6ABAAU7IKERIREjkAsABFWLAGLxuxBhg+WbAARViwDS8bsQ0YPlmwAEVYsAIvG7ECED5ZsABFWLAQLxuxEBA+WbIADQIREjmwAhCyCgEKK1gh2Bv0WTAxJQYjIiYnETMRFDMyNxEzESMDKGzRrbUBucjURrmwa3/JxQLA/UX2ngMT+8YAAAEAIQAAA7oEOgAGADiyAAcIERI5ALAARViwAS8bsQEYPlmwAEVYsAUvG7EFGD5ZsABFWLADLxuxAxA+WbIABQMREjkwMSUBMwEjATMB8QEMvf58jf54vfsDP/vGBDoAAAEAKwAABdMEOgAMAGCyBQ0OERI5ALAARViwAS8bsQEYPlmwAEVYsAgvG7EIGD5ZsABFWLALLxuxCxg+WbAARViwAy8bsQMQPlmwAEVYsAYvG7EGED5ZsgALAxESObIFCwMREjmyCgsDERI5MDElEzMBIwEBIwEzExMzBErQuf7Flv75/wCW/sa41fyV/wM7+8YDNPzMBDr81gMqAAEAKQAAA8oEOgALAFMAsABFWLABLxuxARg+WbAARViwCi8bsQoYPlmwAEVYsAQvG7EEED5ZsABFWLAHLxuxBxA+WbIACgQREjmyBgoEERI5sgMABhESObIJBgAREjkwMQETMwEBIwMDIwEBMwH38Nj+ngFt1vr61wFt/p7WAq8Bi/3p/d0Blf5rAiMCFwABABb+SwOwBDoADwBJsgAQERESOQCwAEVYsAEvG7EBGD5ZsABFWLAOLxuxDhg+WbAARViwBS8bsQUSPlmyAA4FERI5sgkBCitYIdgb9FmwABCwDdAwMQETMwECIycnNRcyNjc3ATMB7vzG/k1l3CNFMl5pIin+fsoBDwMr+x/+8gMNlgRMZW4ELgABAFgAAAOzBDoACQBEALAARViwBy8bsQcYPlmwAEVYsAIvG7ECED5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIRUhNQEhNSEVAToCefylAlX9tAM0l5eIAxmZgwAAAQBA/pICngY9ABgAMbITGRoREjkAsA0vsAAvsgcNABESObAHL7IfBwFdsgYDCitYIdgb9FmyEwYHERI5MDEBJiY1NTQjNTI1NTY2NxcGERUUBxYVFRIXAnixs9TUAq+zJtGnpwPO/pIy5bzH85Hy0LfhM3ND/ubK41la5c7+7UIAAAEAr/7yAUQFsAADABMAsAAvsABFWLACLxuxAhw+WTAxASMRMwFElZX+8ga+AAABABP+kgJyBj0AGAAxsgUZGhESOQCwCy+wGC+yEQsYERI5sBEvsh8RAV2yEgMKK1gh2Bv0WbIFEhEREjkwMRc2EzU0NyY1NRAnNxYWFxUUMxUiFRUUBgcTywe1tdEmsbIB1NS1r/tBAQrc51RS6csBGkNzMuG50u+R88q84jIAAAEAgwGSBO8DIgAXAEKyERgZERI5ALAARViwDy8bsQ8WPlmwANCwDxCwFNCwFC+yAwEKK1gh2Bv0WbAPELIIAQorWCHYG/RZsAMQsAvQMDEBFAYjIi4CIyIGFQc0NjMyFhYXFzI2NQTvu4lIgKlKKk5UobiLTIywQB1MXwMJntk1lCRrXgKgzkChCgJ0XwACAIv+mAFmBE0AAwAMADKyBg0OERI5sAYQsADQALACL7AARViwCy8bsQsYPlmyBgUKK1gh2Bv0WbIBAgYREjkwMRMzEyMTFAYiJjQ2MhaqqA3CyTdsODhsNwKs++wFTC0+Plo8PAABAGn/CwP5BSYAIQBSsgAiIxESOQCwAEVYsBQvG7EUGD5ZsABFWLAKLxuxChA+WbAH0LIAAQorWCHYG/RZsAoQsAPQsBQQsBHQsBQQsBjQsBQQshsBCitYIdgb9FkwMSUyNjczBgYHFSM1JgI1NTQSNzUzFRYWFyMmJiMiBhUVFBYCSmSUCK8GxpC5s8jKsbmWwAavCI9pjZubg3lZfska6eoiARzcI9QBHSHi3xfUlmmHy8Aju8oAAQBbAAAEaAXEACEAfLIcIiMREjkAsABFWLAULxuxFBw+WbAARViwBS8bsQUQPlmyHxQFERI5sB8vsl8fAXKyjx8BcbK/HwFdsgABCitYIdgb9FmwBRCyAwEKK1gh2Bv0WbAH0LAI0LAAELAN0LAfELAP0LAUELAY0LAUELIbAQorWCHYG/RZMDEBFxQHIQchNTM2Njc1JyM1MwM0NjMyFhUjNCYjIgYVEyEVAcEIPgLdAfv4TSgyAgiloAn1yL7ev39vaYIJAT8CbtyaW52dCYNgCN2dAQTH7tSxa3yaff78nQAAAgBp/+UFWwTxABsAKgA/sgIrLBESObACELAn0ACwAEVYsAIvG7ECED5ZsBDQsBAvsAIQsh8BCitYIdgb9FmwEBCyJwEKK1gh2Bv0WTAxJQYjIicHJzcmNTQ3JzcXNjMyFzcXBxYVFAcXBwEUFhYyNjY1NCYmIyIGBgRPn9HPn4aCi2hwk4KTnsPEn5WEl25mj4T8YHPE4sRxccVwccRzcISCiIeNnMrOo5eIlnh5mImao8vEn5CIAnt71Hp703t603l41AAAAQAfAAAErQWwABYAawCwAEVYsBYvG7EWHD5ZsABFWLABLxuxARw+WbAARViwDC8bsQwQPlmyDxMDK7IADBYREjm0DxMfEwJdsBMQsAPQsBMQshICCitYIdgb9FmwBtCwDxCwB9CwDxCyDgIKK1gh2Bv0WbAK0DAxAQEzASEVIRUhFSERIxEhNSE1ITUhATMCZgFs2/5eATj+gAGA/oDB/oYBev6GATn+XtwDDgKi/TB9pXz+vgFCfKV9AtAAAAIAk/7yAU0FsAADAAcAGACwAC+wAEVYsAYvG7EGHD5ZsgUBAyswMRMRMxERIxEzk7q6uv7yAxf86QPIAvYAAgBa/hEEeQXEADQARACAsiNFRhESObAjELA10ACwCC+wAEVYsCMvG7EjHD5ZshYIIxESObAWELI/AQorWCHYG/RZsgIWPxESObAIELAO0LAIELIRAQorWCHYG/RZsjAjCBESObAwELI3AQorWCHYG/RZsh03MBESObAjELAn0LAjELIqAQorWCHYG/RZMDEBFAcWFhUUBCMiJicmNTcUFjMyNjU0JicuAjU0NyYmNTQkMzIEFSM0JiMiBhUUFhYEHgIlJicGBhUUFhYEFzY2NTQmBHm6RUj+/ORwyUaLurSciKaO0bbAXbZCRwEL3ugBBLmoi46hOIcBH6lxOv3hWktQSzaFARwsTlSLAa+9VTGIZKjHODlxzQKCl3VgWWk+MG+bb7pYMYhkpsjizX2bc2JFUEFQSGGBqxgbE2VFRlBCUhEUZUVYbQAAAgBmBPAC7wXFAAgAEQAdALAHL7ICBQorWCHYG/RZsAvQsAcQsBDQsBAvMDETNDYyFhQGIiYlNDYyFhQGIiZmN2w4OGw3Aa43bDg4bDcFWy09PVo8PCstPj5aPDwAAAMAW//rBeYFxAAbACoAOQCVsic6OxESObAnELAD0LAnELA20ACwAEVYsC4vG7EuHD5ZsABFWLA2LxuxNhA+WbIDNi4REjmwAy+0DwMfAwJdsgouNhESObAKL7QAChAKAl2yDgoDERI5shECCitYIdgb9FmwAxCyGAIKK1gh2Bv0WbIbAwoREjmwNhCyIAQKK1gh2Bv0WbAuELInBAorWCHYG/RZMDEBFAYjIiY1NTQ2MzIWFSM0JiMiBhUVFBYzMjY1JRQSBCAkEjU0AiQjIgQCBzQSJCAEEhUUAgQjIiQCBF+tnp29v5ugrJJfW15sbF5cXf0BoAETAUABEqCe/u2hoP7sn3O7AUsBgAFKu7T+tcbF/rW2AlWZodO2brDTpJVjVYp7cXiKVGWErP7bpqYBJayqASKnpf7cqsoBWsfH/qbKxf6o0c8BWAAAAgCTArMDDwXEABsAJQBssg4mJxESObAOELAd0ACwAEVYsBUvG7EVHD5ZsgQmFRESObAEL7AA0LICBBUREjmyCwQVERI5sAsvsBUQsg4DCitYIdgb9FmyEQsVERI5sAQQshwDCitYIdgb9FmwCxCyIAQKK1gh2Bv0WTAxASYnBiMiJjU0NjMzNTQjIgYVJzQ2MzIWFREUFyUyNjc1IwYGFRQCagwGTIB3gqesbHxFT6GsiYWaGv6kK1gccFNZAsEiJlZ8Z294NIc2Mwxngo+G/sRhUXsoG44BPzNe//8AZgCXA2QDswAmAXr6/gAHAXoBRP/+AAEAfwF3A74DIAAFABoAsAQvsAHQsAEvsAQQsgIBCitYIdgb9FkwMQEjESE1IQO+uv17Az8BdwEIoQAEAFr/6wXlBcQADgAeADQAPQCpsjY+PxESObA2ELAL0LA2ELAT0LA2ELAj0ACwAEVYsAMvG7EDHD5ZsABFWLALLxuxCxA+WbITBAorWCHYG/RZsAMQshsECitYIdgb9FmyIAsDERI5sCAvsiIDCxESObAiL7QAIhAiAl2yNSAiERI5sDUvsr81AV20ADUQNQJdsh8CCitYIdgb9FmyKB81ERI5sCAQsC/QsC8vsCIQsj0CCitYIdgb9FkwMRM0EiQgBBIVFAIEIyIkAjcUEgQzMiQSNTQCJCMiBAIFESMRITIWFRQHFhcVFBcVIyY0JyYnJzM2NjU0JiMjWrsBSwGAAUq7tP61xsX+tbZzoAEToKEBFJ2d/uyhoP7snwHAjQEUmamAegERkQ4DEHOwnEhYTmSKAtnKAVrHx/6mysX+qNHPAVjHrP7bpqkBIqyrASGnpf7c9f6uA1GDfXtBMpo9ViYQJLkRYASAAkI2ST0AAAEAeAUhA0IFsAADABEAsAEvsgIDCitYIdgb9FkwMQEhNSEDQv02AsoFIY8AAgCCA8ACfAXEAAsAFgAvALAARViwAy8bsQMcPlmwDNCwDC+yCQIKK1gh2Bv0WbADELISAgorWCHYG/RZMDETNDYzMhYVFAYjIiYXMjY1NCYjIgYUFoKVamiTk2hplv82Sko2N0tLBMBonJtpapaWFkc5OktPbEoAAgBhAAAD9QTzAAsADwBGALAJL7AARViwDS8bsQ0QPlmwCRCwANCwCRCyBgEKK1gh2Bv0WbAD0LANELIOAQorWCHYG/RZsgUOBhESObQLBRsFAl0wMQEhFSERIxEhNSERMwEhNSECiQFs/pSn/n8BgacBQfy9A0MDVpf+YgGelwGd+w2YAAABAEICmwKrBbsAFgBUsggXGBESOQCwAEVYsA4vG7EOHD5ZsABFWLAALxuxABQ+WbIWAgorWCHYG/RZsALQsgMOFhESObAOELIIAgorWCHYG/RZsA4QsAvQshQWDhESOTAxASE1ATY1NCYjIgYVIzQ2IBYVFA8CIQKr/akBLG1APEtHnacBCJprVLABjwKbbAEaZkUxPUw5cpR/bmhrT5EAAQA+Ao8CmgW6ACYAibIgJygREjkAsABFWLAOLxuxDhw+WbAARViwGS8bsRkUPlmyABkOERI5sAAvtm8AfwCPAANdsj8AAXG2DwAfAC8AA12yXwABcrAOELIHAgorWCHYG/RZsgoOGRESObAAELImBAorWCHYG/RZshQmABESObIdGQ4REjmwGRCyIAIKK1gh2Bv0WTAxATMyNjU0JiMiBhUjNDYzMhYVFAYHFhUUBiMiJjUzFBYzMjY1NCcjAQlUSkg/RjlLnaN8iZxGQpWqiISmnk9DRkmcWARlPTAtOjMpYnt5aDdbGSmPan1+ay08PDNxAgAAAQB7BNgCHAX+AAMAIwCwAi+yDwIBXbAA0LAAL7QPAB8AAl2wAhCwA9AZsAMvGDAxATMBIwE84P70lQX+/toAAAEAmv5gA+4EOgASAFCyDRMUERI5ALAARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLAQLxuxEBI+WbAARViwDS8bsQ0QPlmyBAEKK1gh2Bv0WbILBw0REjkwMQERFhYzMjcRMxEjJwYjIicRIxEBUwFndMc+uqcJXaqTUbkEOv2Ho5yYAyD7xnOHSf4rBdoAAQBDAAADQAWwAAoAK7ICCwwREjkAsABFWLAILxuxCBw+WbAARViwAC8bsQAQPlmyAQAIERI5MDEhESMiJDU0JDMhEQKGVOb+9wEK5gENAgj+1tX/+lAAAAEAkwJrAXkDSQAJABayAwoLERI5ALACL7EICitY2BvcWTAxEzQ2MhYVFAYiJpM5cjs7cjkC2TBAQDAvPz8AAQB0/k0BqgAAAA4AQbIFDxAREjkAsABFWLAALxuxABA+WbAARViwBi8bsQYSPlm0EwYjBgJdsgEGABESObEHCitY2BvcWbABELAN0DAxIQcWFRQGIycyNjU0Jic3AR0MmaCPB09XQGIgNBuSYXFrNC8sKgmGAAEAegKiAe8FtwAGAECyAQcIERI5ALAARViwBS8bsQUcPlmwAEVYsAAvG7EAFD5ZsgQABRESObAEL7IDAgorWCHYG/RZsgIDBRESOTAxASMRBzUlMwHvndgBYxICogJZOYB1AAACAHoCsgMnBcQADAAaAECyAxscERI5sAMQsBDQALAARViwAy8bsQMcPlmyChsDERI5sAovshADCitYIdgb9FmwAxCyFwMKK1gh2Bv0WTAxEzQ2MzIWFRUUBiAmNRcUFjMyNjU1NCYjIgYHeryam7y7/sy+o2FUU19hU1FgAgRjnsPBpkqfwsKlBmRyc2VOY3JuYQD//wBmAJgDeAO1ACYBew0AAAcBewFqAAD//wBVAAAFkQWtACcB1f/bApgAJwF8ARgACAEHAdgC1gAAABAAsABFWLAFLxuxBRw+WTAx//8AUAAABckFrQAnAXwA7AAIACcB1f/WApgBBwHWAx4AAAAQALAARViwCS8bsQkcPlkwMf//AG8AAAXtBbsAJwF8AZcACAAnAdgDMgAAAQcB1wAxApsAEACwAEVYsCEvG7EhHD5ZMDEAAgBE/n8DeARNABgAIgBXsgkjJBESObAJELAc0ACwEC+wAEVYsCEvG7EhGD5ZsgAQIRESObIDEAAREjmwEBCyCQEKK1gh2Bv0WbAQELAM0LIVABAREjmwIRCyGwUKK1gh2Bv0WTAxAQ4DBwcUFjMyNjUzBgYjIiY1NDc3NjUTFAYiJjU0NjIWAkwBKWC4CwJ0bWR9uQLht8TWoG1CwTdsODhsNwKoan92wWMlbXNxW6HMybOtr3FOkgE9LT4+LSw8PAAC//IAAAdXBbAADwASAHcAsABFWLAGLxuxBhw+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZshEGABESObARL7ICAQorWCHYG/RZsAYQsggBCitYIdgb9FmyCwAGERI5sAsvsgwBCitYIdgb9FmwABCyDgEKK1gh2Bv0WbISBgAREjkwMSEhAyEDIwEhFSETIRUhEyEBIQMHV/yND/3MzeIDcAO3/U0UAk79uBYCwfqvAcgfAWH+nwWwmP4pl/3tAXgC3QABAFkAzgPdBGMACwA4ALADL7IJDAMREjmwCS+yCgkDERI5sgQDCRESObIBCgQREjmwAxCwBdCyBwQKERI5sAkQsAvQMDETAQE3AQEXAQEHAQFZAUr+uHcBSQFJd/64AUp3/rX+tQFJAVABT3v+sQFPe/6x/rB7AVH+rwAAAwB2/6MFHQXsABcAIAApAGayBCorERI5sAQQsB3QsAQQsCbQALAARViwEC8bsRAcPlmwAEVYsAQvG7EEED5ZshoQBBESObIjEAQREjmwIxCwG9CwEBCyHQEKK1gh2Bv0WbAaELAk0LAEELImAQorWCHYG/RZMDEBFAIEIyInByM3JhE1NBIkMzIXNzMHFhMFFBcBJiMiAgcFNCcBFjMyEjcFCZD++LCrg2GOkL6SAQus1pRnjZ+JAvwsYgI0Zqa20QMDFTj921t5uswDAqnW/sGoUpvnwAFoU9IBQqt9pf+7/tpj9I0DiG/+6/YNtoP8j0ABD/0AAgCmAAAEXQWwAA0AFgBXsgkXGBESObAJELAQ0ACwAEVYsAAvG7EAHD5ZsABFWLALLxuxCxA+WbIBAAsREjmwAS+yEAALERI5sBAvsgkBCitYIdgb9FmwARCyDgEKK1gh2Bv0WTAxAREhMhYWFRQEIyERIxETESEyNjU0JicBYAEXk9x3/vjj/u66ugEVjqCgiAWw/ttpwn7C5/7HBbD+Q/3el3h7lwEAAQCL/+wEagYSACoAabIhKywREjkAsABFWLAFLxuxBR4+WbAARViwEy8bsRMQPlmwAEVYsAAvG7EAED5ZsgoTBRESObIOBRMREjmwExCyGgEKK1gh2Bv0WbIgEwUREjmyIwUTERI5sAUQsigBCitYIdgb9FkwMSEjETQ2MzIWFRQGFRQeAhUUBiMiJic3FhYzMjY1NC4CNTQ2NTQmIyIRAUS5z7q0xYBLvFbLtlG1JisxhzVrcUq9V4toWNoEV9Drs599y0UzX5CITJ+yLBybICxeUjRgk4pRWc9UXmv+2wADAE7/7AZ8BE4AKgA1AD0AxrICPj8REjmwAhCwLtCwAhCwOdAAsABFWLAXLxuxFxg+WbAARViwHS8bsR0YPlmwAEVYsAAvG7EAED5ZsABFWLAFLxuxBRA+WbICHQAREjmyDAUXERI5sAwvtL8MzwwCXbAXELIQAQorWCHYG/RZshMMFxESObIaHQAREjmyOh0AERI5sDovtL86zzoCXbIhAQorWCHYG/RZsAAQsiUBCitYIdgb9FmyKB0AERI5sCvQsAwQsi8BCitYIdgb9FmwEBCwNtAwMQUgJwYGIyImNTQ2MzM1NCYjIgYVJzQ2MzIWFzY2MzISFRUhFhYzMjc3FwYlMjY3NSMGBhUUFgEiBgchNTQmBO7++4hB4o2nvOPd325oaYy48rtzsDI/rmnS6P0oB66VlHkvQJ78CUieMuR1jGoDUHOVEQIahhS0Vl6tl52uVWt7blETj7VTU09X/v/pc7C/TB+IeZZKNu0CblNNXQM0q4sfhJMAAAIAfv/sBC0GLAAdACsAVLIHLC0REjmwBxCwKNAAsABFWLAZLxuxGR4+WbAARViwBy8bsQcQPlmyDxkHERI5sA8vshEZBxESObIiAQorWCHYG/RZsAcQsigBCitYIdgb9FkwMQESERUUBgYjIiYmNTQ2NjMyFyYnByc3Jic3Fhc3FwMnJiYjIgYVFBYzMjY1AzT5ddiGh9x5cM+Bo3kwjdpJwIS3Oe+vvUloAiGLXJGip4B9mQUV/vj+Z12e/ZCB4IaT6YJyw42UY4NbMZ82i4Fk/PM4PUm/p4zE4rgAAAMARwCsBC0EugADAA0AFwBOsgcYGRESObAHELAA0LAHELAR0ACwAi+yAQEKK1gh2Bv0WbACELEMCitY2BvcWbEGCitY2BvcWbABELEQCitY2BvcWbEWCitY2BvcWTAxASE1IQE0NjIWFRQGIiYRNDYyFhUUBiImBC38GgPm/aA5cjs7cjk5cjs7cjkCWLgBOjBAQDAvPj78/jBAQDAuPz8AAAMAW/96BDQEuAAVAB0AJgBjsgQnKBESObAEELAb0LAEELAj0ACwAEVYsAQvG7EEGD5ZsABFWLAPLxuxDxA+WbIjAQorWCHYG/RZsiEjBBESObAhELAY0LAEELIbAQorWCHYG/RZshkbDxESObAZELAg0DAxEzQ2NjMyFzczBxYRFAYGIyInByM3JhMUFwEmIyIGBTQnARYzMjY1W3vhj25eSXxmw3zgkGhWSnxkzblhAVc+SIqoAmZX/qw3QounAief/YsqlM2a/sCe/okjlcuVATfCbwK2INq1tm/9UBnbuQACAJX+YAQnBgAADwAaAGSyGBscERI5sBgQsAzQALAIL7AARViwDC8bsQwYPlmwAEVYsAYvG7EGEj5ZsABFWLADLxuxAxA+WbIFDAMREjmyCgwDERI5sAwQshMBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxARQCIyInESMRMxE2MzISESc0JiMiBxEWMzI2BCfiwcVxublxwsPjuZyIqFRTq4WdAhH3/tJ9/fcHoP3KhP7a/voEt9SV/fuU0wAAAgAdAAAFiAWwABMAFwBrALAARViwDy8bsQ8cPlmwAEVYsAgvG7EIED5ZshQIDxESObAUL7IQFA8REjmwEC+wANCwEBCyFwEKK1gh2Bv0WbAD0LAIELAF0LAUELIHAQorWCHYG/RZsBcQsArQsBAQsA3QsA8QsBLQMDEBMxUjESMRIREjESM1MxEzESERMwEhNSEFAoaGwf0jwYaGwQLdwfxiAt39IwSOjvwAAqH9XwQAjgEi/t4BIv2OwgABAJsAAAFVBDoAAwAdALAARViwAi8bsQIYPlmwAEVYsAAvG7EAED5ZMDEhIxEzAVW6ugQ6AAABAJoAAAQ/BDoADABoALAARViwBC8bsQQYPlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmwAhCwBtCwBi+ynwYBXbS/Bs8GAl2yLwYBXbL/BgFdsgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAb9rurpbAY3f/jwB6OkBzf4zBDr+NgHK/fP90wAAAQAiAAAEGwWwAA0AWwCwAEVYsAwvG7EMHD5ZsABFWLAGLxuxBhA+WbIBDAYREjmwAS+wANCwARCyAgEKK1gh2Bv0WbAD0LAGELIEAQorWCHYG/RZsAMQsAjQsAnQsAAQsAvQsArQMDEBJRUFESEVIREHNTcRMwFpAQf++QKy/I2GhsEDS1R9VP3PnQKRKn0qAqIAAAEAIgAAAgoGAAALAEoAsABFWLAKLxuxCh4+WbAARViwBC8bsQQQPlmyAQQKERI5sAEvsADQsAEQsgIBCitYIdgb9FmwA9CwBtCwB9CwABCwCdCwCNAwMQE3FQcRIxEHNTcRMwFsnp66kJC6A2U9ez39FgKjN3s3AuIAAQCi/ksE8QWwABMAWrIGFBUREjkAsABFWLAALxuxABw+WbAARViwEC8bsRAcPlmwAEVYsAQvG7EEEj5ZsABFWLAOLxuxDhA+WbAEELIJAQorWCHYG/RZsg0OEBESObISDgAREjkwMQERFAYjIic3FjMyNTUBESMRMwERBPGrnD02DiU9iP0zwMACzQWw+f2ouhKaDtBHBGr7lgWw+5gEaAAAAQCR/ksD8AROABoAYbINGxwREjkAsABFWLADLxuxAxg+WbAARViwAC8bsQAYPlmwAEVYsAovG7EKEj5ZsABFWLAYLxuxGBA+WbIBGAMREjmwChCyDwEKK1gh2Bv0WbADELIVAQorWCHYG/RZMDEBFzYzMhYXERQGIyInNxYzMjURNCYjIgcRIxEBNw10y7O4AqebPTYOI0KJb32vUboEOpqu0Mv89KS4Ep0NwgL3i4CF/NQEOgACAGj/6wcJBcQAFwAjAJGyASQlERI5sAEQsBrQALAARViwDC8bsQwcPlmwAEVYsA4vG7EOHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmwDhCyEAEKK1gh2Bv0WbITAA4REjmwEy+yFAEKK1gh2Bv0WbAAELIWAQorWCHYG/RZsAMQshgBCitYIdgb9FmwDBCyHQEKK1gh2Bv0WTAxISEGIyImAicRNBI2MzIXIRUhESEVIREhBTI3ESYjIgYHERQWBwn8sLJyov6MAYv+onyqA0b9LQJ3/YkC3fuMcWZtbK3CAsMVlgEPqwE1rAERlxSe/iyd/fwbDgSOD+XP/sfT6wAAAwBh/+wHAAROACAALAA0AJayBjU2ERI5sAYQsCbQsAYQsDDQALAARViwBC8bsQQYPlmwAEVYsAovG7EKGD5ZsABFWLAXLxuxFxA+WbAARViwHS8bsR0QPlmyBwoXERI5sjEKFxESObAxL7IOAQorWCHYG/RZsBcQshIBCitYIdgb9FmyFAoXERI5shoKFxESObAk0LAEELIqAQorWCHYG/RZsC3QMDETNDY2MzIWFzY2MzIWFRUhFhYzMjcXBiMiJicGBiMiADUXFBYzMjY1NCYjIgYlIgYHITU0JmF5246JyT1BxHDP6v0yB6SGvHhKifWHzT8+x4bc/vi5oIuJoKGKh6IELWOWFgIOiQInoP6JdWRmc/7rdKrFbH6EcGRjcQEw/gm32NfOttnW1qOKGn2WAAABAKAAAAKCBhUADAAysgMNDhESOQCwAEVYsAQvG7EEHj5ZsABFWLAALxuxABA+WbAEELIJAQorWCHYG/RZMDEzETY2MzIXByYjIhURoAGwojtUFygztwSuqb4Vjgvd+2AAAAIAXf/sBRIFxAAXAB8AW7IAICEREjmwGNAAsABFWLAQLxuxEBw+WbAARViwAC8bsQAQPlmyBRAAERI5sAUvsBAQsgkBCitYIdgb9FmwABCyGAEKK1gh2Bv0WbAFELIbAQorWCHYG/RZMDEFIAARNSE1EAIjIgcHJzc2MyAAERUUAgQnMhI3IRUUFgK5/uP+wQP09N2liz0vFp7oAS4BZJz+6qep3g/8z9MUAVkBRXUHAQIBHDoajw1Y/of+sVTF/r+2ngEF2yLa5AAB/+T+SwK8BhUAHgBxshQfIBESOQCwAEVYsBUvG7EVHj5ZsABFWLAQLxuxEBg+WbAARViwHS8bsR0YPlmwAEVYsAUvG7EFEj5ZsB0QsgABCitYIdgb9FmwBRCyCgEKK1gh2Bv0WbAAELAO0LAP0LAVELIaAQorWCHYG/RZMDEBIxEUBiMiJzcWMzI2NREjNTM1NjYzMhcHJiMiBxUzAmDLqJo9Mg4eQ0FHq6sCr6E7VBYmPKsEywOr+/6ntxKTDWhcBASPeKe8FZMKw3oAAAIAZf/sBZ0GNwAXACUAU7IEJicREjmwBBCwItAAsABFWLANLxuxDRw+WbAARViwBC8bsQQQPlmyDw0EERI5sA8QsBXQsA0QshsBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxARQCBCMiJAInNTQSJDMyFzY2NTMQBRYXBxACIyICBxUUEjMyEhEE+JD++LCr/vaVAZIBC6zwm2Bdp/75YQG+z7220QPTub/LAqnW/sGoqAE+z2TSAUGsmweDhP6zPaz2BAECARb+6/Zr+/7hARoBAQAAAgBb/+wEugSwABYAIwBTshMkJRESObATELAa0ACwAEVYsAQvG7EEGD5ZsABFWLATLxuxExA+WbIGBBMREjmwBhCwDNCwExCyGgEKK1gh2Bv0WbAEELIhAQorWCHYG/RZMDETNDY2MzIXNjY1MxAHFhUVFAYGIyIANRcUFjMyNjU1NCYjIgZbe+GPz4hHQJbPSXzgkN7+8bmnjYunqYuKqAInn/2LighkgP7dM4qpFp7+iQEz+wm02tu5ELXa2gAAAQCM/+wGHQYCABoATLIMGxwREjkAsABFWLASLxuxEhw+WbAARViwGi8bsRocPlmwAEVYsA0vG7ENED5ZsgENGhESObABELAI0LANELIWAQorWCHYG/RZMDEBFTY2NTMUBgcRBgIHByIAJxEzERQWMzI2NREEqnNhn7HCAfTTSe/+5AK+rqGjrQWw1QuJk9LRDP1+x/78FgQBAuID4Pwmnq+ungPbAAEAiP/sBQ8EkAAZAGCyBxobERI5ALAARViwEy8bsRMYPlmwAEVYsA0vG7ENGD5ZsABFWLAILxuxCBA+WbAARViwBS8bsQUQPlmyFQgTERI5sBUQsAPQsgYIExESObAIELIQAQorWCHYG/RZMDEBFAYHESMnBiMiJicRMxEUMzI3ETMVPgI1BQ+ToLAEbNGttQG5yNRGuUREHQSQtJME/Ltrf8nFAsD9RfaeAxODAiNIbAAB/7T+SwFlBDoADQAoALAARViwAC8bsQAYPlmwAEVYsAQvG7EEEj5ZsgkBCitYIdgb9FkwMQERFAYjIic3FjMyNjURAWWqmDs0Dh5DQUgEOvttqrISkw1oXASTAAIAYv/sA+kETwAUABwAZbIIHR4REjmwCBCwFdAAsABFWLAALxuxABg+WbAARViwCC8bsQgQPlmyDQAIERI5sA0vsAAQshABCitYIdgb9FmyEgAIERI5sAgQshUBCitYIdgb9FmwDRCyGAEKK1gh2Bv0WTAxATIAFRUUBgYnIiY1NSEmJiMiByc2ATI2NyEVFBYB/9wBDnzYetDpAs0HoYi6e0mMAQ5ilxX984kET/7U+SSV+I0B/ul0qMhsfYb8NaSJGn2WAAEAqQTkAwYGAAAIADQAsAQvsAfQsAcvtA8HHwcCXbIFBAcREjkZsAUvGLAB0BmwAS8YsAQQsALQsgMEBxESOTAxARUjJwcjNRMzAwaZlpWZ9nAE7gqqqgwBEAAAAQCMBOMC9gX/AAgAIACwBC+wAdCwAS+0DwEfAQJdsgAEARESObAI0LAILzAxATczFQMjAzUzAcCWoP5x+50FVaoK/u4BEgr//wB4BSEDQgWwAQYAcAAAAAoAsAEvsQID9DAxAAEAgQTLAtgF1wAMACayCQ0OERI5ALADL7IPAwFdsgkECitYIdgb9FmwBtCwBi+wDNAwMQEUBiAmNTMUFjMyNjUC2KX+9KaXTElGTwXXeZOUeEZPTkcAAQCNBO4BaAXCAAgAGLICCQoREjkAsAcvsgIFCitYIdgb9FkwMRM0NjIWFAYiJo03bDg4bDcFVy0+Plo8PAACAHkEtAInBlAACQAUACqyAxUWERI5sAMQsA3QALADL7AH0LAHL7I/BwFdsAMQsA3QsAcQsBLQMDEBFAYjIiY0NjIWBRQWMzI2NCYjIgYCJ3xbXHt7uHv+tUMxMERDMTJCBYBXdXasenpWL0RCYkVGAAABADL+TwGSADgAEAAusgUREhESOQCwEC+wAEVYsAovG7EKEj5ZsgUDCitYIdgb9Fm2DxAfEC8QA10wMSEHBhUUMzI3FwYjIiY1NDY3AX46cU4wNA1GWllnhnstW1ZIGnksaFZZmjgAAAEAewTZAz4F6AAXAD4AsAMvsAjQsAgvtA8IHwgCXbADELAL0LALL7AIELIPAworWCHYG/RZsAMQshQDCitYIdgb9FmwDxCwF9AwMQEUBiMiLgIjIgYVJzQ2MzIeAjMyNjUDPntcKTxhKxwpOnx5XSM4YDMfKzkF3GyGFD4NPzEHa4wUOhJELQACAF4E0AMsBf8AAwAHADsAsAIvsADQsAAvtA8AHwACXbACELAD0BmwAy8YsAAQsAXQsAUvsAIQsAbQsAYvsAMQsAfQGbAHLxgwMQEzASMDMwMjAl3P/vOpbcXalgX//tEBL/7RAAACAH7+awHV/7UACwAWADQAsAMvQAsAAxADIAMwA0ADBV2wCdCwCS9ACTAJQAlQCWAJBF2yAAkBXbAO0LADELAU0DAxFzQ2MzIWFRQGIyImNxQWMjY1NCYjIgZ+ZEpHYmBJTGJXNEYwMCMlMvJGYWBHRl1eRSMwMCMkMjQAAfynBNj+SAX+AAMAHgCwAS+wANAZsAAvGLABELAC0LACL7QPAh8CAl0wMQEjATP+SJ/+/uAE2AEmAAH9bwTY/xAF/gADAB4AsAIvsAHQsAEvtA8BHwECXbACELAD0BmwAy8YMDEBMwEj/jDg/vSVBf7+2v///IsE2f9OBegABwCk/BAAAAAB/V4E2f6UBnQADgAuALAAL7IPAAFdsAfQsAcvQAkPBx8HLwc/BwRdsAbQsgEABhESObINAAcREjkwMQEnNjY0JiM3MhYVFAYHB/10AUtGW0sHlZpOTQEE2ZkFHk4namdVPVALRwAC/CcE5P8HBe4AAwAHADcAsAEvsADQGbAALxiwARCwBdCwBS+wBtCwBi+2DwYfBi8GA12wA9CwAy+wABCwBNAZsAQvGDAxASMBMwEjAzP+Aqn+zuEB/5b2zgTkAQr+9gEKAAH9OP6i/hP/dgAIABEAsAIvsgcFCitYIdgb9FkwMQU0NjIWFAYiJv04N2w4OGw39S0+Plo8PAAAAQC3BO4BmwY/AAMAHQCwAi+wANCwAC+yDwABXbIDAgAREjkZsAMvGDAxEzMDI+2udHAGP/6vAAADAHEE8AODBogAAwAMABUANwCwCy+wAtCwAi+wAdCwAS+wAhCwA9AZsAMvGLALELIGBQorWCHYG/RZsA/QsAsQsBTQsBQvMDEBMwMjBTQ2MhYUBiImJTQ2MhYUBiImAeG8ZYf+wDdsODhsNwI3N2w4OGw3Boj++CUtPT1aPDwrLT4+Wjw8//8AkwJrAXkDSQEGAHgAAAAGALACLzAxAAEAsQAABDAFsAAFACsAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmwBBCyAAEKK1gh2Bv0WTAxASERIxEhBDD9QsEDfwUS+u4FsAACAB8AAAVzBbAAAwAGAC8AsABFWLAALxuxABw+WbAARViwAi8bsQIQPlmyBAEKK1gh2Bv0WbIGAgAREjkwMQEzASElIQEChqoCQ/qsAQYDTP5nBbD6UJ0EKAADAGf/7AT6BcQAAwAVACMAd7IIJCUREjmwCBCwAdCwCBCwINAAsABFWLARLxuxERw+WbAARViwCC8bsQgQPlmyAggRERI5sAIvss8CAV2y/wIBXbIvAgFdtL8CzwICcbIBAQorWCHYG/RZsBEQshkBCitYIdgb9FmwCBCyIAEKK1gh2Bv0WTAxASE1IQUUAgQjIiQCJzU0EiQzMgQSFwcQAiMiAgcVFBIzMhI3A8D9+wIFATqP/vixrP72kwKSAQusrwEIkQK/0Lu20QPRu7rMAwKTmILV/sKqqQE5zmnSAUKrqP7FzwsBAwEV/uv2a/r+4AEP/QABADIAAAUDBbAABgAxALAARViwAy8bsQMcPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbIAAwEREjkwMQEBIwEzASMCmv5mzgISrAITzwSJ+3cFsPpQAAADAHgAAAQhBbAAAwAHAAsATwCwAEVYsAgvG7EIHD5ZsABFWLACLxuxAhA+WbIAAQorWCHYG/RZsAIQsAXQsAUvsi8FAV2yBgEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDE3IRUhEyEVIQMhFSF4A6n8V1cC8v0OUwOU/GydnQM/nQMOngABALIAAAUBBbAABwA4ALAARViwBi8bsQYcPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEhIxEhESMRIQUBwf0ywARPBRL67gWwAAEARQAABEQFsAAMADwAsABFWLAILxuxCBw+WbAARViwAy8bsQMQPlmyAQEKK1gh2Bv0WbAF0LAIELIKAQorWCHYG/RZsAfQMDEBASEVITUBATUhFSEBAvL+QwMP/AEB4f4fA879JAG7As79z52PAkoCR5Ce/dQAAAMATQAABXQFsAAUABsAIwBssgokJRESObAKELAV0LAKELAc0ACwAEVYsBMvG7ETHD5ZsABFWLAJLxuxCRA+WbISEwkREjmwEi+wANCyCAkTERI5sAgvsAvQsAgQsh0BCitYIdgb9FmwFdCwEhCyFgEKK1gh2Bv0WbAc0DAxATIEFhUUBgQjFSM1IiQmEDY2MzUzAxEjIgYQFgERMzI2NTQmA0KgAQOPkv8AoMKi/v6Pkf+jwsIFrMPCAXQErMPDBPeM/Jud/Yuvr436ATj9jLn7ngMK0v6Y0AMK/PbRtbPRAAABAFoAAAUhBbAAGABcsgAZGhESOQCwAEVYsAQvG7EEHD5ZsABFWLARLxuxERw+WbAARViwFy8bsRccPlmwAEVYsAsvG7ELED5ZshYECxESObAWL7AA0LAWELINAQorWCHYG/RZsArQMDEBNjY1ETMRFAYGBxEjESYAJxEzERYWFxEzAxacrsF/7Z/B5/7vA8ABpZXBAgsX16oCDf3wn/WTD/6WAWoXASrtAhj976PXGQOkAAABAHEAAATLBcQAJABcshklJhESOQCwAEVYsBkvG7EZHD5ZsABFWLAOLxuxDhA+WbAARViwIy8bsSMQPlmwDhCyEAEKK1gh2Bv0WbAN0LAA0LAZELIGAQorWCHYG/RZsBAQsCHQsCLQMDElNhI3NTQmIAYVFRQSFxUhNTMmAjU1NBI2MzIWEhcVFAIHMxUhAuGKmgPC/q7AnZH+FN1qeI3+oaD9jgN4atz+HKIbARzqhuf2+uVx8P7YHKKdZgEzom+6ASSfnP7ktIKg/s1mnQAAAgBk/+sEdwROABYAIQB8sh8iIxESObAfELAT0ACwAEVYsBMvG7ETGD5ZsABFWLAWLxuxFhg+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsAgQsgMBCitYIdgb9FmyChMIERI5shUTCBESObAMELIaAQorWCHYG/RZsBMQsh8BCitYIdgb9FkwMQERFjMyNxcGIyInBiMiAjU1EBIzMhc3ARQWMzI3ESYjIgYD7gJOEw8XMEqTJmvRwOTixMtrEf3MkoetUlWohpUEOvzjjAWJIqWlARv0DwEIAT2hjf26r8O6Ab684wAAAgCg/oAETQXEABQAKgBpsgArLBESObAY0ACwDy+wAEVYsAAvG7EAHD5ZsABFWLAMLxuxDBA+WbIoAAwREjmwKC+yJQEKK1gh2Bv0WbIGJSgREjmyDgwAERI5sAAQshgBCitYIdgb9FmwDBCyHwEKK1gh2Bv0WTAxATIWFRQGBxYWFRQGIyInESMRNDY2ATQmIyIGBxEWFjMyNjU0JicjNTMyNgJdwetiWHuD+c21eLp6zwFniGtslgEskF6GmoxtllV4fgXE265bmC4tw4LN71/+NQWxbLxr/ntmh45r/MM0P6CBdqUDmHcAAQAu/mAD3wQ6AAgAOLIACQoREjkAsABFWLABLxuxARg+WbAARViwBy8bsQcYPlmwAEVYsAQvG7EEEj5ZsgAHBBESOTAxAQEzAREjEQEzAgoBGL3+hbr+hL0BFAMm+//+JwHgA/oAAgBg/+wEJwYcAB4AKgBeshQrLBESObAUELAi0ACwAEVYsAMvG7EDHj5ZsABFWLAULxuxFBA+WbADELIIAQorWCHYG/RZshsUAxESObAbL7IoCworWCHYG/RZsAzQsBQQsiIBCitYIdgb9FkwMRM0NjMyFwcmIyIGFRQEEhcVFAYGIyIANTU0EjcnJiYTFBYzMjY1NCYnIgbdy6+LhgKXfFZlAbvPBXbbkd7++byQAWNrPqGJiKCpfYikBPWInzegO0g+bJn+88QnmfOFASfyDaUBCCMFJ4z9Y7DLysaI2xnNAAEAY//sA+wETQAlAG+yAyYnERI5ALAARViwFS8bsRUYPlmwAEVYsAovG7EKED5ZsgMBCitYIdgb9FmwChCwBtCwChCwItCwIi+yLyIBXbK/IgFdsiMBCitYIdgb9FmyDyMiERI5shkVIhESObAVELIcAQorWCHYG/RZMDEBFBYzMjY1MxQGIyImNTQ3JiY1NDYzMhYVIzQmIyIGFRQzMxUjBgEek3Zxm7n/xsz4zVhi58q6+bmPa3CH9MTg6gEwTWJuUZu5sZO6QiR6SZSms45GZVtKoJQGAAEAbf6BA8MFsAAfAEuyCCAhERI5ALAPL7AARViwAC8bsQAcPlmyHQEKK1gh2Bv0WbAB0LIVIAAREjmyAhUAERI5sBUQsgcBCitYIdgb9FmyHAAVERI5MDEBFQEGBhUUFhcXFhYVBgYHJzY2NTQkJyYmNTQSNwEhNQPD/qKKZkNS91FHAmxDYi8z/sw2Z1uSfwEd/YMFsHj+VaHlhVphGUgYWE5FrDZUNVUtRE4YLZmBggFAlgFDmAABAJH+YQPwBE4AEgBTsgwTFBESOQCwAEVYsAMvG7EDGD5ZsABFWLAALxuxABg+WbAARViwBy8bsQcSPlmwAEVYsBAvG7EQED5ZsgEQAxESObADELIMAQorWCHYG/RZMDEBFzYzMhYXESMRNCYjIgYHESMRATgLeMi+rgG5bIBcgiK6BDqInMXM+6QEUYh8V0787wQ6AAADAHr/7AQSBcQADQAWAB4AkrIDHyAREjmwAxCwE9CwAxCwG9AAsABFWLAKLxuxChw+WbAARViwAy8bsQMQPlmyDgMKERI5sA4vsl8OAV2y/w4BXbSPDp8OAnG0vw7PDgJxsi8OAXGyzw4BXbIvDgFdtO8O/w4CcbAKELITAQorWCHYG/RZsA4QshgBCitYIdgb9FmwAxCyGwEKK1gh2Bv0WTAxARACIyICAzUQEjMyEhMFITU0JiMiBhUFIRUUFiA2NwQS7N/b7gTs397rBP0hAiWLiIaMAiX925IBBI0CAoD+v/6tAUwBNM0BPQFO/rz+zSw34/Hx488n5frw4wAAAQDD//QCSwQ6AAwAKACwAEVYsAAvG7EAGD5ZsABFWLAJLxuxCRA+WbIEAQorWCHYG/RZMDEBERQWMzI3FwYjIhERAXw3QDAnAUZJ+QQ6/Nc/QAyXEwEmAyAAAQAl/+8EOwXuABoAULIQGxwREjkAsAAvsABFWLALLxuxCxA+WbAARViwES8bsREQPlmwCxCyBwEKK1gh2Bv0WbIQAAsREjmwEBCwE9CwABCyFwEKK1gh2Bv0WTAxATIWFwEWFjM3FwYjIiYmJwMBIwEnJiYjByc2AQVieCEBqxQtIyYGJCpNTj4d5v7izgGKYBc1LS8BKgXuUF/7qzMnA5gMJVZQAlH89QQF6zguAo4MAAEAZf53A6kFxAAtAFayAy4vERI5ALAXL7AARViwKy8bsSscPlmyAgEKK1gh2Bv0WbIILisREjmwCC+yCQEKK1gh2Bv0WbIeLisREjmwHhCyDwEKK1gh2Bv0WbIlCQgREjkwMQEmIyIGFRQhMxUjBgYVFBYEFhcWFRQGByc3NjU0LgQ1NDY3JiY1NCQzMhcDcoRhjaABTYWWtseQAQ98IE9oSGs5MUzmqXdBpJZ2gwEC5JFwBQgkZ1XbmAKco3CdQSUUMWlApz1UQDw+Jy4zQmmZb5HLLiqYYJ+5JwABACn/9ASkBDoAFABcsgsVFhESOQCwAEVYsBMvG7ETGD5ZsABFWLAKLxuxChA+WbAARViwDy8bsQ8QPlmwExCyAAEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAAQsA3QsA7QsBHQsBLQMDEBIxEUFjMyNxcGIyIRESERIxEjNSEEcZw2QTAnAUZJ+f5vuakESAOh/XJAQQyXEwEmAof8XwOhmQACAJH+YAQfBE4ADwAbAFeyEhwdERI5sBIQsADQALAARViwAC8bsQAYPlmwAEVYsAovG7EKEj5ZsABFWLAHLxuxBxA+WbIJAAcREjmyEgEKK1gh2Bv0WbAAELIYAQorWCHYG/RZMDEBMhIXFxQCIyInESMRNDY2AxYzMjY1NCYjIgYVAlDP9AsB4L/DcrpxzYRTq4eWkYV1kARO/ub+QvD+6Hz9+APknuyA/MiTw8PN4NipAAABAGX+igPhBE4AIgBJsgAjJBESOQCwFC+wAEVYsAAvG7EAGD5ZsABFWLAbLxuxGxA+WbAAELAE0LAAELIHAQorWCHYG/RZsBsQsg0BCitYIdgb9FkwMQEyFhUjNCYjIgYVFRAFFxYWFQYGByc3NjU0JicmAjU1NDY2Aj2956+Gb4SbAUCGYlACY0piLzFGVuz4d9cETtW0boPbsyD+/GMmHWBQP6c+VTY8RisrEzQBAdMqmPuJAAIAYP/sBHsEOgARAB0ATLIIHh8REjmwCBCwFdAAsABFWLAQLxuxEBg+WbAARViwCC8bsQgQPlmwEBCyAAEKK1gh2Bv0WbAIELIVAQorWCHYG/RZsAAQsBvQMDEBIRYRFRQGBiMiADU1NDY2NyEBFBYzMjY1NCYjIgYEe/7kyHrdjNr+9nbZjAJA/J+gioufoYuJnwOhlP7vEYzriAEv/w2Y8ogB/de319nLrM7MAAEAUf/sA9kEOgAQAEmyChESERI5ALAARViwDy8bsQ8YPlmwAEVYsAkvG7EJED5ZsA8QsgABCitYIdgb9FmwCRCyBAEKK1gh2Bv0WbAAELAN0LAO0DAxASERFDMyNxcGIyImJxEhNSED2f6NaSsxKkxqfXUB/qUDiAOk/WmFGoI0k5ICk5YAAQCP/+wD9gQ6ABIAPLIOExQREjkAsABFWLAALxuxABg+WbAARViwCC8bsQgYPlmwAEVYsA4vG7EOED5ZsgMBCitYIdgb9FkwMQEREDMyNjUmAzMWERAAIyImJxEBScmBqgV2w3H+/9rCyAIEOv15/s/6tucBIfH+6f75/sHg1wKXAAIAV/4iBUwEOgAZACIAXLIPIyQREjmwDxCwGtAAsBgvsABFWLAGLxuxBhg+WbAARViwEC8bsRAYPlmwAEVYsBcvG7EXED5ZsADQsBcQshoBCitYIdgb9FmwDNCwEBCyIAEKK1gh2Bv0WTAxBSQANTQSNxcGBxQWFxE0NjMyFhYVFAAFESMTNjY1JiYjIhUCbP8A/uuBf2WhCrWminGC4YL+3v77ubmqxAWlgkIRFwEz+6gBB1eFjPWt5RoCzGl9jfiV8/7XFf4zAmYW3qSp2FIAAAEAX/4oBUMEOgAZAFiyABobERI5ALANL7AARViwAC8bsQAYPlmwAEVYsAYvG7EGGD5ZsABFWLATLxuxExg+WbAARViwDC8bsQwQPlmyAQEKK1gh2Bv0WbAMELAP0LABELAY0DAxARE2NjUmAzMWERAABREjESYAEREzERYWFxEDHKvDBXrCdv7j/va5//77ugKmogQ6/E4Y5bLoARvs/un+/f7QFf45AckaATYBEwHm/g7C5BkDsQABAHr/7AYZBDoAIwBashskJRESOQCwAEVYsAAvG7EAGD5ZsABFWLATLxuxExg+WbAARViwGS8bsRkQPlmwAEVYsB4vG7EeED5ZsgUBCitYIdgb9FmyCQAeERI5sA7QshsTGRESOTAxAQIHFBYzMjY1ETMRFhYzMjY1JgMzFhEQAiMiJwYGIyICERA3AcSKB3JqbHG7AXFranIHisOHz7zwVSmkd7zPhwQ6/uXvy+OtpgEt/s6kquLM7wEb9P7q/u3+z+51eQExARMBH+sAAAIAef/sBHkFxgAfACgAbrIUKSoREjmwFBCwJtAAsABFWLAZLxuxGRw+WbAARViwBi8bsQYQPlmyHRkGERI5sB0vsgIBCitYIdgb9FmyCxkGERI5sAYQsg8BCitYIdgb9FmwAhCwE9CwHRCwI9CwGRCyJgEKK1gh2Bv0WTAxAQYHFQYGIyImNRE3ERQWMzI2NTUmADU0NjMyFhURNjcBFBYXESYjIhUEeTxTAuXIy/e6jHx0gtn+87iWn7I/SP2UoooFk5QCcxcJptPu99cBRwL+sI+bkpimHwEa2aC7xbL+oQUTAVKFvR4BaMbEAAAB/9oAAARuBbwAGgBJsgAbHBESOQCwAEVYsAQvG7EEHD5ZsABFWLAXLxuxFxw+WbAARViwDS8bsQ0QPlmyAAQNERI5sAQQsgkBCitYIdgb9FmwEtAwMQETNjYzMhcHJiMiBwERIxEBJiMiByc2MzIWFwIk4StrV0g0JA0nRiT+17/+2CdDJw0kNEdYayoDBgH7Y1gblwhP/Xf9xgI8AodPCJYcVF0AAgBK/+wGGwQ6ABIAJgBwsggnKBESObAIELAe0ACwAEVYsBEvG7ERGD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmwERCyAAEKK1gh2Bv0WbIIEQYREjmwD9CwENCwFdCwFtCwChCyGwEKK1gh2Bv0WbIfChEREjmwJNAwMQEjFhUQAiMiJwYjIgIRNDcjNSEBJichBgcUFjMyNjcRMxEWFjMyNgYbiEC8q/FTU/CqvUB0BdH+/gRK/LtLBGBYaXECuwJxalZgA6Gsxf7v/s3v7wEwARS/spn99qrHyKnL46eiAQf++aKn4gABACr/9QWxBbAAGABhshEZGhESOQCwAEVYsBcvG7EXHD5ZsABFWLAJLxuxCRA+WbAXELIAAQorWCHYG/RZsgQXCRESObAEL7AJELIKAQorWCHYG/RZsAQQshABCitYIdgb9FmwABCwFdCwFtAwMQEhETYzMgQQBCMnMjY1JiYjIgcRIxEhNSEElP32nYT0ARL+/O0Cm5gCo6KWisH+YQRqBRL+OTDx/k7jlpGUjpYu/VoFEp4AAAEAe//sBNwFxAAfAIayAyAhERI5ALAARViwCy8bsQscPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmyFgMLERI5sBYvtL8WzxYCcbLPFgFdsp8WAXGy/xYBXbIvFgFdsl8WAXKyjxYBcrIXAQorWCHYG/RZsAMQshwBCitYIdgb9FmwAxCwH9AwMQEGBCMgABE1NBIkMzIAFyMmJiMiAgchFSEVFBIzMjY3BNwb/uHu/v7+yY8BC7DoARgXwBmnl7nOAgI6/cbGsqCrHAHO5/sBcgE2i8kBNaf+/eWsnv7x6p0C7f7okbQAAgAxAAAIOwWwABgAIQB0sgkiIxESObAJELAZ0ACwAEVYsAAvG7EAHD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyAQAIERI5sAEvsAAQsgoBCitYIdgb9FmwEBCyEgEKK1gh2Bv0WbABELIZAQorWCHYG/RZsBIQsBrQsBvQMDEBESEWBBUUBAchESEDAgIGByM1Nz4CNxMBESEyNjU0JicE7gFp3gEG/v7e/dP+ABoPWayQPyhdZDQLHgN3AV+Mop2KBbD9ywPwy8bzBAUS/b/+3v7ciQKdAgdr6vMCwv0t/cCehICcAgACALEAAAhNBbAAEgAbAIKyARwdERI5sAEQsBPQALAARViwEi8bsRIcPlmwAEVYsAIvG7ECHD5ZsABFWLAPLxuxDxA+WbAARViwDC8bsQwQPlmyAAIPERI5sAAvsgQMAhESObAEL7AAELIOAQorWCHYG/RZsAQQshMBCitYIdgb9FmwDBCyFAEKK1gh2Bv0WTAxASERMxEhFgQVFAQHIREhESMRMwERITI2NTQmJwFyAs7AAWriAQH+/9/90/0ywcEDjgFfjqCYigM5Anf9ngPivb/pBAKc/WQFsP0B/fWOenSMAwABAD4AAAXUBbAAFQBdsg4WFxESOQCwAEVYsBQvG7EUHD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmwFBCyAAEKK1gh2Bv0WbIEFAgREjmwBC+yDQEKK1gh2Bv0WbAAELAS0LAT0DAxASERNjMyFhcRIxEmJiMiBxEjESE1IQSm/fCgr/ryA8EBiaSppsD+aARoBRL+UCja3f4tAc6Yhir9PgUSngABALD+mQT/BbAACwBIALAJL7AARViwAC8bsQAcPlmwAEVYsAQvG7EEHD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAD0DAxEzMRIREzESERIxEhsMECzsD+QMH+MgWw+u0FE/pQ/pkBZwACAKIAAASxBbAADAAVAFuyDxYXERI5sA8QsAPQALAARViwCy8bsQscPlmwAEVYsAkvG7EJED5ZsAsQsgABCitYIdgb9FmyAgsJERI5sAIvsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxASERIRYEFRQEByERIQERITI2NTQmJwQh/UIBauQBAP7+3/3SA3/9QgFfj5+ZjQUS/kwD5MTF6gQFsP0Q/d2YgHuOAgACADL+mgXJBbAADgAVAFuyEhYXERI5sBIQsAvQALAEL7AARViwCy8bsQscPlmwAEVYsAIvG7ECED5ZsAQQsAHQsAIQsgYBCitYIdgb9FmwDdCwDtCwD9CwENCwCxCyEQEKK1gh2Bv0WTAxASMRIREjAzM2EjcTIREzISERIQMGAgXHv/vrwAF3Xm8OIANnvvu7Asb+ExUNa/6bAWX+mgIDagFl1QJv+u0Edf5U+/6eAAEAGwAABzUFsAAVAIYAsABFWLAJLxuxCRw+WbAARViwDS8bsQ0cPlmwAEVYsBEvG7ERHD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsBQvG7EUED5ZsAIQsBDQsBAvsi8QAV2yzxABXbIAAQorWCHYG/RZsATQsggQABESObAQELAL0LITABAREjkwMQEjESMRIwEjAQEzATMRMxEzATMBASMEqJzApf5k8AHq/jzjAYOlwJ4Bg+L+PAHq7wKY/WgCmP1oAwACsP2IAnj9iAJ4/VH8/wABAFD/7ARqBcQAKABysgMpKhESOQCwAEVYsAsvG7ELHD5ZsABFWLAWLxuxFhA+WbALELIDAQorWCHYG/RZsAsQsAbQsiUWCxESObAlL7LPJQFdsp8lAXGyJAEKK1gh2Bv0WbIRJCUREjmwFhCwG9CwFhCyHgEKK1gh2Bv0WTAxATQmIyIGFSM0NjYzMgQVFAYHBBUUBCMiJiY1MxQWMzI2NRAlIzUzNjYDlKmZgK3Af+SK9AEOfG8BAf7c9JHthMC2jJ27/sO0s5KWBCl0iY1odLhn28NlpjBW/8TmZ76Dc5mSeAEABZ4DfgABALEAAAT/BbAACQBdALAARViwAC8bsQAcPlmwAEVYsAcvG7EHHD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAACERI5QAmKBJoEqgS6BARdsgkAAhESOUAJhQmVCaUJtQkEXTAxATMRIxEBIxEzEQQ/wMD9M8HBBbD6UARi+54FsPueAAABAC8AAAT2BbAAEQBNsgQSExESOQCwAEVYsAAvG7EAHD5ZsABFWLABLxuxARA+WbAARViwCS8bsQkQPlmwABCyAwEKK1gh2Bv0WbAJELILAQorWCHYG/RZMDEBESMRIQMCAgYHIzU3PgI3EwT2wP32Gg9ZrJA/KF1kNAseBbD6UAUS/b/+3v7ciQKdAgdr6vMCwgAAAQBN/+sEywWwABEASrIEEhMREjkAsABFWLABLxuxARw+WbAARViwEC8bsRAcPlmwAEVYsAcvG7EHED5ZsgABBxESObILAQorWCHYG/RZsg8HEBESOTAxAQEzAQ4CIyInNxcyPwIBMwKdAU/f/f00WnlbTxYGW2kzGSb+ENcCYwNN+0N0YTMJmARlNFkENgAAAwBT/8QF4wXsABgAIQAqAFuyDCssERI5sAwQsCDQsAwQsCLQALALL7AXL7IVFwsREjmwFS+wANCyCQsXERI5sAkvsA3QsBUQshkBCitYIdgb9FmwCRCyJAEKK1gh2Bv0WbAf0LAZELAi0DAxATMWBBIVFAIEByMVIzUjIiQCEBIkMzM1MwMiBhUUFjMzETMRMzI2NTQmIwN4H6UBEJeY/vSkI7ocp/7vl5cBEaccuta829q/Grocv9fXwwUeAZj+9aWm/vKXAsTEmAEMAU4BDJjO/pvnzc7lA2f8mevKyOoAAAEAr/6hBZcFsAALADsAsAkvsABFWLAALxuxABw+WbAARViwBC8bsQQcPlmwAEVYsAovG7EKED5ZsgIBCitYIdgb9FmwBtAwMRMzESERMxEzAyMRIa/BAs7AmRKt+9cFsPrtBRP68f4AAV8AAAEAlgAABMgFsAASAEayBRMUERI5ALAARViwAC8bsQAcPlmwAEVYsAovG7EKHD5ZsABFWLABLxuxARA+WbIPAAEREjmwDy+yBgEKK1gh2Bv0WTAxAREjEQYGIyImJxEzERYWMzI3EQTIwWmsbvnyA8EBiaO+xQWw+lACWx4X2N8B0/4ymIY2ArYAAAEAsAAABtcFsAALAEgAsABFWLAALxuxABw+WbAARViwAy8bsQMcPlmwAEVYsAcvG7EHHD5ZsABFWLAJLxuxCRA+WbIBAQorWCHYG/RZsAXQsAbQMDEBESERMxEhETMRIREBcQH1vwHywPnZBbD67QUT+u0FE/pQBbAAAQCw/qEHagWwAA8AVACwCy+wAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwBy8bsQccPlmwAEVYsA0vG7ENED5ZsgEBCitYIdgb9FmwBdCwBtCwCdCwCtCwAtAwMQERIREzESERMxEzAyMRIREBcQH1vwHywJMSpfn9BbD67QUT+u0FE/rn/goBXwWwAAACABAAAAW4BbAADAAVAF6yARYXERI5sAEQsA3QALAARViwAC8bsQAcPlmwAEVYsAkvG7EJED5ZsgIACRESObACL7AAELILAQorWCHYG/RZsAIQsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxEyERITIEFRQEByERIQERITI2NTQmJxACWwFa7wEE/v7i/db+ZgJbAV+On5mMBbD9ruXGxesDBRj9qP3dmIB7jgIAAAMAsgAABjAFsAAKABMAFwBtshIYGRESObASELAG0LASELAV0ACwAEVYsAkvG7EJHD5ZsABFWLAWLxuxFhw+WbAARViwBy8bsQcQPlmwAEVYsBQvG7EUED5ZsgAJBxESObAAL7ILAQorWCHYG/RZsAcQsgwBCitYIdgb9FkwMQEhFgQVFAQHIREzEREhMjY1NCYnASMRMwFyAWrkAQD+/t/908ABX4+fmY0DV8DAA14D5MTF6gQFsP0Q/d2YgHuOAv1ABbAAAAIAowAABLEFsAAKABMATbINFBUREjmwDRCwAdAAsABFWLAJLxuxCRw+WbAARViwBy8bsQcQPlmyAAkHERI5sAAvsgsBCitYIdgb9FmwBxCyDAEKK1gh2Bv0WTAxASEWBBUUBAchETMRESEyNjU0JicBYwFq5AEA/v7f/dPAAV+Pn5mNA14D5MTF6gQFsP0Q/d2YgHuOAgAAAQCT/+wE9AXEAB8Aj7IMICEREjkAsABFWLATLxuxExw+WbAARViwHC8bsRwQPlmwANCwHBCyAwEKK1gh2Bv0WbIIHBMREjmwCC+07wj/CAJxss8IAV2yLwgBcbS/CM8IAnGynwgBcbL/CAFdsi8IAV2yXwgBcrKPCAFysgYBCitYIdgb9FmwExCyDAEKK1gh2Bv0WbATELAP0DAxARYWMzISNyE1ITQCIyIGByM2ADMyBBIVFRQCBCMiJCcBVByroK3JAv3DAj3PupanGcEXARjosAELj47+/aju/uEbAc60kQEO8J7tARScruUBA6f+y8mRyf7MpfvnAAIAt//sBtoFxAAXACUAobIhJicREjmwIRCwEtAAsABFWLATLxuxExw+WbAARViwDS8bsQ0cPlmwAEVYsAQvG7EEED5ZsABFWLAKLxuxChA+WbIPCg0REjmwDy+yXw8BXbL/DwFdtE8PXw8CcbSPD58PAnGyLw8BcbLPDwFdsi8PAV2yzw8BcbIIAQorWCHYG/RZsBMQshsBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxARQCBCMiJAInIxEjETMRMzYSJDMyBBIVJxACIyICBxUUEjMyEjcG2pD++LCm/vmVCNHAwNADkAEKrK8BC5C/0Lu20QPTubrMAwKp1v7BqKABKsf9gwWw/WTOATerqf6/1QIBAwEV/uv2a/v+4QEP/QAAAgBZAAAEZAWwAAwAFQBhshAWFxESObAQELAK0ACwAEVYsAovG7EKHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmyEQoAERI5sBEvsgEBCitYIdgb9FmyBQEKERI5sAoQshIBCitYIdgb9FkwMSERIQEjASQRNCQzIREBFBYXIREhIgYDo/6w/tPNAVL+5gER8wHP/O2lkwEa/u+cpQI3/ckCbG8BHtDn+lAD+YSgAQI+lAACAGH/7AQoBhEAGwAoAGKyHCkqERI5sBwQsAjQALAARViwEi8bsRIePlmwAEVYsAgvG7EIED5ZsgASCBESObAAL7IXABIREjmyDxIXERI5shoACBESObIcAQorWCHYG/RZsAgQsiMBCitYIdgb9FkwMQEyEhUVFAYGIyIANTUQEjc2NjUzFAYHBwYGBzYXIgYVFRQWMzI2NTQmAmfM9XbdkNr+9v33jGKYcXyKpaUZk6+IoKGJiqChA/z+798RmfGFASP1WgFVAZIsGUg/fYwdHye5mqqYt6IQrsvMxJm5AAMAnQAABCkEOgAOABYAHACOshgdHhESObAYELAC0LAYELAW0ACwAEVYsAEvG7EBGD5ZsABFWLAALxuxABA+WbIXAQAREjmwFy+0vxfPFwJdtJ8XrxcCcbL/FwFdsg8XAXG0Lxc/FwJdtG8XfxcCcrIPAQorWCHYG/RZsggPFxESObAAELIQAQorWCHYG/RZsAEQshsBCitYIdgb9FkwMTMRITIWFRQGBxYWFRQGIwERITI2NTQjJTMgECcjnQGm2OdaWGJ328j+0AEydHPu/tXvAQT2/QQ6l5JLeSAXhl2VngHb/rpWTqKUATAFAAABAJoAAANHBDoABQArALAARViwBC8bsQQYPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIQNH/g26Aq0DofxfBDoAAgAu/sIEkwQ6AA4AFABbshIVFhESObASELAE0ACwDC+wAEVYsAQvG7EEGD5ZsABFWLAKLxuxChA+WbIAAQorWCHYG/RZsAbQsAfQsAwQsAnQsAcQsA/QsBDQsAQQshEBCitYIdgb9FkwMTc3NhMTIREzESMRIREjEyEhESEDAoNAbA8RArmLuf0NuQEBLwHx/rMLEZdPjAEYAbD8Xf4rAT7+wgHVAvj+/v69AAEAFQAABgQEOgAVAJAAsABFWLAJLxuxCRg+WbAARViwDS8bsQ0YPlmwAEVYsBEvG7ERGD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsBQvG7EUED5ZsAIQsBDQsBAvsr8QAV2y/xABXbIvEAFdss8QAXGyAAEKK1gh2Bv0WbAE0LIIEAAREjmwEBCwC9CyEwAQERI5MDEBIxEjESMBIwEBMwEzETMRMwEzAQEjA+uCuYL+0eoBg/6i4AEXf7l+ARng/qEBg+oB1v4qAdb+KgIwAgr+QAHA/kABwP31/dEAAQBY/+0DrARNACYAhrIDJygREjkAsABFWLAKLxuxChg+WbAARViwFS8bsRUQPlmwChCyAwEKK1gh2Bv0WbIlChUREjmwJS+0LyU/JQJdtL8lzyUCXbSfJa8lAnG0byV/JQJysgYlChESObIiAQorWCHYG/RZshAiJRESObIZFQoREjmwFRCyHAEKK1gh2Bv0WTAxATQmIyIGFSM0NjMyFhUUBgcWFRQGIyImNTMUFjMyNjU0JiMjNTM2At90ZWKDuOyxvtRYUb3mwLvzuI1paoJtc7nJvQMSTFlmRY20o5dJeiRAvJWut5xPcWJOW0+cBQABAJwAAAQBBDoACQBFALAARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAcCERI5sgkHAhESOTAxATMRIxEBIxEzEQNIubn+Dbm5BDr7xgMV/OsEOvzqAAABAJwAAAQ/BDoADAB3ALAARViwBC8bsQQYPlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmwAhCwBtCwBi+ynwYBXbL/BgFdss8GAXGynwYBcbS/Bs8GAl2yLwYBXbJvBgFysgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAd2Hurp5AWzg/lQB0OsBzf4zBDr+NgHK/fj9zgABACwAAAQDBDoADwBNsgQQERESOQCwAEVYsAAvG7EAGD5ZsABFWLABLxuxARA+WbAARViwCC8bsQgQPlmwABCyAwEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDEBESMRIQMCBgcjNTc2NjcTBAO6/pAWEpekSjVaTgsUBDr7xgOh/mv+6fAFowQKvP4BzwAAAQCdAAAFUgQ6AAwAWQCwAEVYsAEvG7EBGD5ZsABFWLALLxuxCxg+WbAARViwAy8bsQMQPlmwAEVYsAYvG7EGED5ZsABFWLAJLxuxCRA+WbIACwMREjmyBQsDERI5sggLAxESOTAxJQEzESMRASMBESMRMwL7AXDnuf6igP6bufD1A0X7xgMT/O0DJPzcBDoAAQCcAAAEAAQ6AAsAigCwAEVYsAYvG7EGGD5ZsABFWLAKLxuxChg+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAAQsAnQsAkvsm8JAV20vwnPCQJdsj8JAXG0zwnfCQJxsg8JAXK0nwmvCQJxsv8JAV2yDwkBcbKfCQFdsi8JAV20bwl/CQJysgIBCitYIdgb9FkwMSEjESERIxEzESERMwQAuf4PuroB8bkBzv4yBDr+KwHVAAEAnAAABAEEOgAHADgAsABFWLAGLxuxBhg+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAYQsgIBCitYIdgb9FkwMSEjESERIxEhBAG5/g66A2UDofxfBDoAAQAoAAADsAQ6AAcAMQCwAEVYsAYvG7EGGD5ZsABFWLACLxuxAhA+WbAGELIAAQorWCHYG/RZsATQsAXQMDEBIREjESE1IQOw/pW5/pwDiAOk/FwDpJYAAAMAZP5gBWkGAAAaACUAMAB/sgcxMhESObAHELAg0LAHELAr0ACwBi+wAEVYsAMvG7EDGD5ZsABFWLAKLxuxChg+WbAARViwEy8bsRMSPlmwAEVYsBAvG7EQED5ZsABFWLAXLxuxFxA+WbAKELIeAQorWCHYG/RZsBAQsiMBCitYIdgb9FmwKdCwHhCwLtAwMRMQEjMyFxEzETYzMhIRFAIjIicRIxEGIyICNSU0JiMiBxEWMzI2JRQWMzI3ESYjIgZk0rdVQLlGXrjS0bdhRblCVbbRBEyMez8vLUN8ifxtgno6Lyo9eoQCCQEPATYdAc/+KyP+yv7c7/7mIP5VAagdARr1D8zhFPzxEcCytrwSAxER2gAAAQCc/r8EggQ6AAsAOwCwCC+wAEVYsAAvG7EAGD5ZsABFWLAELxuxBBg+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAG0DAxEzMRIREzETMDIxEhnLoB8rmBEqb80gQ6/F0Do/xd/igBQQAAAQBnAAADvQQ7ABAARrIEERIREjkAsABFWLAILxuxCBg+WbAARViwDy8bsQ8YPlmwAEVYsAAvG7EAED5ZsgwPABESObAML7IEAQorWCHYG/RZMDEhIxEGIyImJxEzERYzMjcRMwO9unqAy9UCuQXkgHq6AYgg0MABQ/638iACGgABAJwAAAXgBDoACwBIALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAHLxuxBxg+WbAARViwCS8bsQkQPlmyAQEKK1gh2Bv0WbAF0LAG0DAxAREhETMRIREzESERAVYBjLkBi7r6vAQ6/F0Do/xdA6P7xgQ6AAEAkf6/Bm0EOgAPAEsAsAwvsABFWLAALxuxABg+WbAARViwAy8bsQMYPlmwAEVYsAcvG7EHGD5ZsABFWLANLxuxDRA+WbIBAQorWCHYG/RZsAXQsAnQMDEBESERMxEhETMRMwMjESERAUsBjLkBi7qYEqb63AQ6/F0Do/xdA6P8Xf4oAUEEOgACAB4AAAS/BDoADAAVAF6yARYXERI5sAEQsA3QALAARViwAC8bsQAYPlmwAEVYsAkvG7EJED5ZsgIACRESObACL7AAELILAQorWCHYG/RZsAIQsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxEyERIRYWFRQGIyERIQERITI2NTQmJx4B+gEZuNbcuv42/r8B+gETaHJvZAQ6/osCvKGixAOi/oz+aWtdWnMCAAADAJ0AAAV/BDoACgAOABcAbbIGGBkREjmwBhCwDNCwBhCwE9AAsABFWLAJLxuxCRg+WbAARViwDS8bsQ0YPlmwAEVYsAcvG7EHED5ZsABFWLALLxuxCxA+WbIADQcREjmwAC+yDwEKK1gh2Bv0WbAHELIQAQorWCHYG/RZMDEBIRYWFRQGIyERMwEjETMBESEyNjU0JicBVgEZuNbcuv42uQQpurr71wETaHJvZALFAryhosQEOvvGBDr99P5pa11acwIAAgCdAAAD/QQ6AAoAEwBNsgcUFRESObAHELAN0ACwAEVYsAkvG7EJGD5ZsABFWLAHLxuxBxA+WbIACQcREjmwAC+yCwEKK1gh2Bv0WbAHELIMAQorWCHYG/RZMDEBIRYWFRQGIyERMxERITI2NTQmJwFWARm41ty6/ja5ARNocm9kAsUCvKGixAQ6/fT+aWtdWnMCAAEAZP/sA+AETgAfAIKyACAhERI5ALAARViwCC8bsQgYPlmwAEVYsBAvG7EQED5ZsAgQsgABCitYIdgb9FmyHQgQERI5sB0vtC8dPx0CXbS/Hc8dAl20nx2vHQJxtG8dfx0CcrIDCB0REjmyFBAIERI5sBAQshcBCitYIdgb9FmwHRCyGgEKK1gh2Bv0WTAxASIGFSM0NjYzMgAVFRQGBiMiJjUzFBYzMjY3ITUhJiYCCGORsHbEatMBBXfXirTwsI5md5oM/moBlA6WA7Z+Vl2qZf7P9h+Y+4ngp2aLuKGYkrEAAAIAnf/sBjAETgAUAB8AnbINICEREjmwDRCwFdAAsABFWLAULxuxFBg+WbAARViwBC8bsQQYPlmwAEVYsBEvG7ERED5ZsABFWLAMLxuxDBA+WbIAERQREjmwAC+0vwDPAAJdtJ8ArwACcbL/AAFdsg8AAXG0LwA/AAJdtl8AbwB/AANyshABCitYIdgb9FmwDBCyGAEKK1gh2Bv0WbAEELIdAQorWCHYG/RZMDEBITYAMzIAFxcUBgYjIgAnIREjETMBFBYgNjU0JiMiBgFWAQQVAQnK1AEOCwF84JDR/vYQ/v25uQG6pwEapaiMiqgCb9gBB/7i5Tqe/okBEdr+KQQ6/de02t7Gsd7aAAACAC8AAAPHBDoADQAWAGGyFBcYERI5sBQQsA3QALAARViwAC8bsQAYPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbISAAEREjmwEi+yAwEKK1gh2Bv0WbIHAwAREjmwABCyEwEKK1gh2Bv0WTAxAREjESEDIwEmJjU0NjcDFBYXIREhIgYDx7r+6f/IARBob9663mxZASb+9md6BDr7xgGl/lsBwSafapS1Af60T2EBAWdlAAH/6P5LA98GAAAiAISyDSMkERI5ALAfL7AARViwBC8bsQQYPlmwAEVYsBkvG7EZED5ZsABFWLAKLxuxChI+WbK/HwFdsi8fAV2yDx8BXbIeGR8REjmwHi+wIdCyAQEKK1gh2Bv0WbICGQQREjmwChCyDwEKK1gh2Bv0WbAEELIVAQorWCHYG/RZsAEQsBvQMDEBIRE2MyATERQGIyInNxYyNjURNCYjIgYHESMRIzUzNTMVIQJj/uJ7xQFXA6qYPTYPI4JIaXBaiCa5pKS5AR4Euf7+l/59/NyqshKTDWhcAyB4cmBO/P0EuZivrwABAGf/7AP3BE4AHwCcsgAgIRESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsgMIEBESObIbEAgREjmwGy+0DxsfGwJytL8bzxsCXbSfG68bAnG0zxvfGwJxsv8bAV2yDxsBcbQvGz8bAl20bxt/GwJysr8bAXKyFBAbERI5sBAQshcBCitYIdgb9FmwGxCyHAEKK1gh2Bv0WTAxJTI2NzMOAiMiABE1NDY2MzIWFyMmJiMiBgchFSEWFgJIY5QIsAV4xG7e/v112JS28QiwCI9ogpoKAZT+bAqZg3haXqhjASgBAB6f94barmmHsZ2YoK0AAgAnAAAGhgQ6ABYAHwB5sgkgIRESObAJELAX0ACwAEVYsAAvG7EAGD5ZsABFWLAILxuxCBA+WbAARViwDy8bsQ8QPlmyAQAIERI5sAEvsAAQsgoBCitYIdgb9FmwDxCyEQEKK1gh2Bv0WbABELIXAQorWCHYG/RZsAgQshgBCitYIdgb9FkwMQERIRYWFRQGByERIQMCBgcjNTc2NjcTAREhMjY1NCYnA98BHrbT07f+Kf6vFxScpUE2VU0NFwK8ARNldXJjBDr+ZAO1lJO8AwOh/lr+6+QCowQKp9MCD/3M/o9pVlFgAQAAAgCcAAAGpwQ6ABIAGwB7sgEcHRESObABELAT0ACwAEVYsAIvG7ECGD5ZsABFWLARLxuxERg+WbAARViwCy8bsQsQPlmwAEVYsA8vG7EPED5ZsgERCxESObABL7AE0LABELINAQorWCHYG/RZsAQQshMBCitYIdgb9FmwCxCyFAEKK1gh2Bv0WTAxASERMxEhFhYVFAYjIREhESMRMwERITI2NTQmJwFWAfG5ASK00dm9/jb+D7q6AqoBE2V1cmMCoQGZ/mMEsZaXuwIK/fYEOv3M/o9pVlFgAQAB//0AAAPfBgAAGQB5sgwaGxESOQCwFi+wAEVYsAQvG7EEGD5ZsABFWLAHLxuxBxA+WbAARViwEC8bsRAQPlmyvxYBXbIvFgFdsg8WAV2yGRAWERI5sBkvsgABCitYIdgb9FmyAgQHERI5sAQQsgwBCitYIdgb9FmwABCwEtCwGRCwFNAwMQEhETYzIBMRIxEmJiMiBgcRIxEjNTM1MxUhAnn+zHvFAVcDuQFpb1qIJrmPj7kBNAS+/vmX/n39NQLMdXBgTvz9BL6Xq6sAAAEAnP6cBAEEOgALAEUAsAgvsABFWLAALxuxABg+WbAARViwAy8bsQMYPlmwAEVYsAUvG7EFED5ZsABFWLAJLxuxCRA+WbIBAQorWCHYG/RZMDEBESERMxEhESMRIREBVgHyuf6tuf6nBDr8XQOj+8b+nAFkBDoAAAEAnP/sBnUFsAAgAGCyByEiERI5ALAARViwAC8bsQAcPlmwAEVYsA4vG7EOHD5ZsABFWLAXLxuxFxw+WbAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsgcABBESObITAQorWCHYG/RZsBzQMDEBERQGIyImJwYGIyImJxEzERQWMzI2NREzERQWMzI2NREGdeHDbasxNLJxvdcBwXJicoLHfGlqegWw+97G3FdZWVfbwwQm+917iol8BCP73X2IiX0EIgABAIH/6wWtBDoAHgBgsgYfIBESOQCwAEVYsAAvG7EAGD5ZsABFWLAMLxuxDBg+WbAARViwFS8bsRUYPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbIGFQQREjmyEQEKK1gh2Bv0WbAa0DAxAREUBiMiJwYjIiYnETMRFhYzMjY1ETMRFBYzMjY3EQWtyq7GWV/Op8ABuQFbU2JvumVcWWUBBDr9J7DGlJTDsALc/SNmdXhnAtn9J2d4dWYC3QAC/9wAAAP8BhYAEQAaAHGyFBscERI5sBQQsAPQALAARViwDi8bsQ4ePlmwAEVYsAgvG7EIED5ZshEOCBESObARL7IAAQorWCHYG/RZsgIOCBESObACL7AAELAK0LARELAM0LACELISAQorWCHYG/RZsAgQshMBCitYIdgb9FkwMQEhESEWFhAGByERIzUzETMRIQERITI2NTQmJwKW/r8BGLvU1Lf+Kr+/ugFB/r8BEmlxb2QEOv6wAsr+ttEDBDqXAUX+u/2B/kV3ZGF9AgAAAQC3/+0GoAXFACYAh7IeJygREjkAsABFWLAFLxuxBRw+WbAARViwJi8bsSYcPlmwAEVYsB0vG7EdED5ZsABFWLAjLxuxIxA+WbIQBR0REjmwEC+wANCwBRCwCdCwBRCyDAEKK1gh2Bv0WbAQELIRAQorWCHYG/RZsB0QshYBCitYIdgb9FmwHRCwGdCwERCwIdAwMQEzNhIkMzIAFyMmJiMiAgchFSEVFBIzMjY3MwYEIyAAETUjESMRMwF4xwWTAQas5gEZGMAZp5e0zwYCHv3ixrKjqRzAG/7h7v7+/snHwcEDQMEBJp7/AOisnv774pca7f7ok7Ln+wFyATYU/VcFsAABAJn/7AWhBE4AJADEsgMlJhESOQCwAEVYsAQvG7EEGD5ZsABFWLAkLxuxJBg+WbAARViwIS8bsSEQPlmwAEVYsBwvG7EcED5Zsg8cBBESObAPL7S/D88PAl20Pw9PDwJxtM8P3w8CcbQPDx8PAnK0nw+vDwJxsv8PAV2yDw8BcbQvDz8PAl20bw9/DwJysADQsggPBBESObAEELILAQorWCHYG/RZsA8QshABCitYIdgb9FmwHBCyFAEKK1gh2Bv0WbIXHAQREjmwEBCwH9AwMQEzNhIzMhYXIyYmIyIGByEVIRYWMzI2NzMOAiMiAicjESMRMwFTvxD/0bbxCLAIj2iEmAoBtf5LCpmDY5QIsAV4xG7R/hDAuroCZ98BCNquaYexnpegrXhaXqhjAQbe/jAEOgAAAgAoAAAE5AWwAAsADgBWALAARViwCC8bsQgcPlmwAEVYsAIvG7ECED5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCyDggCERI5MDEBIxEjESMDIwEzASMBIQMDiaq8npjFAg2rAgTF/Z8Bk8cBtv5KAbb+SgWw+lACWgJJAAACAA8AAAQlBDoACwAQAFYAsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsABFWLAKLxuxChA+WbINAggREjmwDS+yAQEKK1gh2Bv0WbAE0LIPCAIREjkwMQEjESMRIwMjATMBIwEhAycHAu11uXx3vQG6nwG9vv4ZAS+AGBgBKf7XASn+1wQ6+8YBwQE7WVkAAAIAyQAABvUFsAATABYAfACwAEVYsAIvG7ECHD5ZsABFWLASLxuxEhw+WbAARViwBC8bsQQQPlmwAEVYsAgvG7EIED5ZsABFWLAMLxuxDBA+WbAARViwEC8bsRAQPlmyFQIEERI5sBUvsADQsBUQsgYBCitYIdgb9FmwCtCwBhCwDtCyFgIEERI5MDEBIQEzASMDIxEjESMDIxMhESMRMwEhAwGKAYcBNasCBMWWqryemMWe/rPBwQJFAZPHAlkDV/pQAbb+SgG2/koBuP5IBbD8qgJJAAACALwAAAXkBDoAEwAYAH8AsABFWLACLxuxAhg+WbAARViwEi8bsRIYPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbAARViwDC8bsQwQPlmwAEVYsBAvG7EQED5ZsgAQEhESObAAL7AB0LIOAQorWCHYG/RZsAvQsAfQsAEQsBTQsBXQshcSBBESOTAxASEBMwEjAyMRIxEjAyMTIxEjETMBIQMnBwF2AQ8BA58Bvb56dbl8d7150bq6AckBL4AYGAHBAnn7xgEp/tcBKf7XASj+2AQ6/YcBO1lZAAACAJMAAAY/BbAAHQAhAHayHiIjERI5sB4QsA7QALAARViwHC8bsRwcPlmwAEVYsAUvG7EFED5ZsABFWLANLxuxDRA+WbAARViwFS8bsRUQPlmyAQ0cERI5sAEvsgoBCitYIdgb9FmwENCwARCwGtCwARCwHtCwHBCyIAEKK1gh2Bv0WTAxATMyFhcRIxEmJicjBxEjEScjIgYHESMRNjYzMwEhATMBIQRBG/TsA8EBfJqFFcENiJ6CBMAD7PMq/ngEsv2fEAEa/bsDKtTY/oIBeJCCAiP9lwJ2FnuN/nwBftjUAob9egHoAAACAJYAAAVLBDoAGwAfAHOyHCAhERI5sBwQsBTQALAARViwBi8bsQYYPlmwAEVYsBsvG7EbED5ZsABFWLAULxuxFBA+WbAARViwDC8bsQwQPlmyHBQGERI5sBwvsATQsBwQsAfQshABCitYIdgb9FmwF9CwBhCyHgEKK1gh2Bv0WTAxMzU2NjcBIQEWFhcVIzUmJiMjBxEjEScjIgYHFQEzEyGWBMrS/uEDv/7gzsUCugJzjDULuQY+jHUCAaIIt/6Lts3SBgHf/iEL09CtsZKBE/5PAbsJfpWxAlwBRgACALYAAAhyBbAAIgAmAJOyJicoERI5sCYQsB7QALAARViwCC8bsQgcPlmwAEVYsAsvG7ELHD5ZsABFWLAFLxuxBRA+WbAARViwIi8bsSIQPlmwAEVYsBsvG7EbED5ZsABFWLATLxuxExA+WbIJBQgREjmwCS+yBAEKK1gh2Bv0WbAJELAj0LAN0LAEELAe0LAY0LALELImAQorWCHYG/RZMDEhETY3IREjETMRIQEhATMyFhcRIxEmJicjBxEjEScjIgYHEQEzASECxQFP/mLBwQNZ/nkEs/54G/TsA8EBfJqFFsAOh56CBAIVEAEa/bsBeLNp/WwFsP18AoT9etTY/oIBeJCCAiX9mQJ1F3uN/nwDKgHoAAIAmwAABzsEOgAhACUAlrIeJicREjmwHhCwJdAAsABFWLAHLxuxBxg+WbAARViwCy8bsQsYPlmwAEVYsAAvG7EAED5ZsABFWLAFLxuxBRA+WbAARViwES8bsREQPlmwAEVYsBkvG7EZED5ZsgoLABESObAKL7IdAQorWCHYG/RZsAPQsAoQsA3QsB0QsBbQsAoQsCLQsAsQsiQBCitYIdgb9FkwMSE1NjchESMRMxEhASEBFhYXFSM1JiYjIwcRIxEnIwYGBxUBMxMhAoYCRv6HuroC0f7hA7/+4M7FAroCc4w1C7kGS4VvAgGiCLf+i6+taP48BDr+IgHe/iEL09CtsZKBE/5PAbsJAoCTrwJcAUYAAAIAUP5GA6oHhgApADIAh7IqMzQREjmwKhCwAtAAsBkvsC4vsABFWLAFLxuxBRw+WbAARViwEi8bsRIQPlmwBRCyAwEKK1gh2Bv0WbIoBRIREjmwKC+yJQEKK1gh2Bv0WbIMJSgREjmwEhCyHwEKK1gh2Bv0WbIPLgFdsC4QsCvQsCsvtA8rHysCXbIqLisREjmwMtAwMQE0JiMhNSEyBBUUBgcWFhUUBCMjBhUUFxcHJiY1NDY3MzY2NRAlIzUzIAM3MxUDIwM1MwLanYf+zgEr3gEGgXOCif734DSNgh9Keo2lojSGn/6+mYYBP7yXoP5y+p0EKm6AmNiyZ6QtKa2CxOUDbWlCD301qGN6gwEBlHkBCAWYA6WqCv7uARIKAAIATP5GA3YGMAApADIAnrIuMzQREjmwLhCwH9AAsBgvsC4vsABFWLAFLxuxBRg+WbAARViwES8bsREQPlmwBRCyAwEKK1gh2Bv0WbIoBREREjmwKC+0Lyg/KAJdtL8ozygCXbSfKK8oAnG0byh/KAJysiUBCitYIdgb9FmyDCUoERI5sBEQsh4BCitYIdgb9FmwLhCwK9CwKy+0DysfKwJdsiouKxESObAy0DAxATQmJyE1ITIWFRQGBxYVFAYjIwYVFBcXByYmNTQ2NzM2NzY1NCUjNTMgAzczFQMjAzUzAqd/cP7JASfK7mZb1/PIMo2CH0t8iqWiNnJDP/7omYgBE9qXoP5y+p0DCUNTApmqi0l3JEKvlK8DbWlCD303qGF6gwECMC5IogOYAx2qCv7uARIKAAADAGf/7AT6BcQAEQAYAB8AibIEICEREjmwBBCwEtCwBBCwGdAAsABFWLANLxuxDRw+WbAARViwBC8bsQQQPlmwDRCyEgEKK1gh2Bv0WbIWDQQREjmwFi+yLxYBXbLPFgFdsi8WAXGy/xYBXbJfFgFdtE8WXxYCcbKfFgFxsAQQshkBCitYIdgb9FmwFhCyHAEKK1gh2Bv0WTAxARQCBCMiJAInNTQSJDMyBBIXASICByEmAgMyEjchFhIE+o/++LGs/vaTApIBC6yvAQiRAv22ttAEAxQEzra2ygj87AjTAqnV/sKqqQE5zmnSAUKrqP7FzwIN/u3y+AEN+3ABAPTs/vgAAAMAW//sBDQETgAPABUAHACHsgQdHhESObAEELAT0LAEELAW0ACwAEVYsAQvG7EEGD5ZsABFWLAMLxuxDBA+WbIaDAQREjmwGi+0vxrPGgJdtJ8arxoCcbL/GgFdsg8aAXG0Lxo/GgJdtM8a3xoCcbIQAQorWCHYG/RZsAwQshQBCitYIdgb9FmwBBCyFgEKK1gh2Bv0WTAxEzQ2NjMyABcXFAYGIyIANQUhFhYgNgEiBgchJiZbe+GP1AEOCwF84JDe/vEDHP2fDaQBAqH+3H2iDwJeEqMCJ5/9i/7i5Tqe/okBM/tEm7i6Anm1k5exAAEAFgAABN0FwwAPAEayAhARERI5ALAARViwBi8bsQYcPlmwAEVYsA8vG7EPHD5ZsABFWLAMLxuxDBA+WbIBBgwREjmwBhCyCAEKK1gh2Bv0WTAxARc3ATY2MxcHIgYHASMBMwJDISMBCDOGZy4BQEAf/nyq/gfQAXaCgQM/l3gBqzxU+3kFsAABAC4AAAQLBE0AEQBGsgISExESOQCwAEVYsAUvG7EFGD5ZsABFWLARLxuxERg+WbAARViwDi8bsQ4QPlmyAQUOERI5sAUQsgoBCitYIdgb9FkwMQEXNxM2MzIXByYjIgYHASMBMwHbFxmdTaxHIxUNHR88EP7Xjf6DvQE8ZGQCH/IYlAgwLfy0BDoAAAIAZ/9zBPoGNAATACcAUrIFKCkREjmwBRCwGdAAsABFWLANLxuxDRw+WbAARViwAy8bsQMQPlmwBtCwDRCwENCyFwEKK1gh2Bv0WbAa0LADELIkAQorWCHYG/RZsCHQMDEBEAAHFSM1JgADNRAANzUzFRYAESc0AicVIzUGAhUVFBIXNTMVNhI1BPr+/uO55f7xAQEO57niAQO/mY25k6OkkrmPlwKp/t3+kSOBfx8BcQEjYAEkAXYfdngl/pD+2QfgAQkjYWQf/u7fXd7+7B9mZCIBC+IAAAIAW/+JBDQEtQATACUAWLIDJicREjmwAxCwHNAAsABFWLADLxuxAxg+WbAARViwEC8bsRAQPlmwAxCwBtCwEBCwDdCwEBCyIwEKK1gh2Bv0WbAU0LADELIdAQorWCHYG/RZsBrQMDETNBI3NTMVFhIVFRQCBxUjNSYCNQE2NjU0JicVIzUGBhUUFhc1M1vUubm62d22ubTZAkZjdnRluWJycWO5AifSASoicG8g/tjdENj+2B1rbB8BJ9z+eR/Nq5HQIGJhIdClkssiZgAAAwCc/+sGbwdRACwAQABJAKayCkpLERI5sAoQsDLQsAoQsEnQALAARViwFC8bsRQcPlmwAEVYsA0vG7ENED5ZsBQQsADQsA0QsAfQsgoNFBESObAUELIVAQorWCHYG/RZsA0QshwBCitYIdgb9FmyIBQNERI5sCXQsBUQsCzQsBQQsDjQsDgvsC/Qsi0CCitYIdgb9FmwLxCwNNCwNC+yPAIKK1gh2Bv0WbA4ELBE0LBJ0LBJLzAxATIWFREUBiMiJicGBiMiJicRNDYzFSIGFREUFjMyNjURMxEUFjMyNjURNCYjExUjIi4CIyIVFSM1NDYzMh4CATY3NTMVFAYHBNu72dm7cLI0NLBwudgE2L1jcXJicoLBgnNjcG9kaCtQgrg0GHGAf24oSL9q/kBCA51bOwWv8Nb9xtTwVVhYVejNAkrU8Z6dif3EjJuJfAGs/lR6i5yMAjqInwHCfyJQDHAPJG5sEVIb/pBQPGlmMnUgAAMAfv/rBaoF8QArAD8ASACssglJShESObAJELA80LAJELBI0ACwAEVYsBMvG7ETGD5ZsABFWLAMLxuxDBA+WbATELAA0LAMELAH0LIJDBMREjmwExCyFAEKK1gh2Bv0WbAMELIbAQorWCHYG/RZsh8TDBESObAk0LAUELAr0LATELA30LA3L7At0LAtL7IsAgorWCHYG/RZsC0QsDPQsDMvsjsCCitYIdgb9FmwNxCwQ9CwQy+wSNCwSC8wMQEyFhURFAYjIicGBiMiJicRNDYzFSIGFREUFjMyNjU1MxUWFjMyNjURNCYjExUjIi4CIyIVFSM1NDYzMh4CATY3NTMVFAYHBEKowMCo0F8vnGKjwQTAqFJdXFNib7kBcGFRXV1RqixPfsAwGHKAf28pSrdt/kFBA55bOwRE28L+38HalUtK0LsBMsHbmIh8/t57iXhn6+5ndYh9ASF8iAHHfyBSC28PJG5sElAc/oZOP2hmMnUgAAIAnP/sBnUHAwAgACgAgrIHKSoREjmwBxCwJ9AAsABFWLAPLxuxDxw+WbAARViwFy8bsRccPlmwAEVYsCAvG7EgHD5ZsABFWLAKLxuxChA+WbAE0LIHCg8REjmwChCyEwEKK1gh2Bv0WbAc0LAPELAn0LAnL7Ao0LAoL7IiBgorWCHYG/RZsCgQsCXQsCUvMDEBERQGIyImJwYGIyImJxEzERQWMzI2NREzERQWMzI2NRElNSEXIRUjNQZ14cNtqzE0snG91wHBcmJygsd8aWp6/EIDLAH+tagFsPvextxXWVlX28MEJvvde4qJfAQj+919iIl9BCLoa2t9fQAAAgCB/+sFrQWwAB4AJgCFsgYnKBESObAGELAj0ACwAEVYsA0vG7ENGD5ZsABFWLAVLxuxFRg+WbAARViwHi8bsR4YPlmwAEVYsAgvG7EIED5ZsATQsAQvsgYIDRESObAIELIRAQorWCHYG/RZsBrQsA0QsCXQsCUvsCbQsCYvsiAGCitYIdgb9FmwJhCwI9CwIy8wMQERFAYjIicGIyImJxEzERYWMzI2NREzERQWMzI2NxEBNSEXIRUjNQWtyq7GWV/Op8ABuQFbU2JvumVcWWUB/JMDLAP+s6kEOv0nsMaUlMOwAtz9I2Z1eGcC2f0nZ3h1ZgLdAQtra4CAAAABAHX+hAS8BcUAGQBJshgaGxESOQCwAC+wAEVYsAovG7EKHD5ZsABFWLACLxuxAhA+WbAKELAO0LAKELIRAQorWCHYG/RZsAIQshkBCitYIdgb9FkwMQEjESYANTU0EiQzMgAXIyYmIyICFRUUEhczAxS/2P74jgEAoPcBIALBArWhoM3FnXz+hAFsHAFW//SxASCf/vjgnqz+/NT0yv77BAABAGT+ggPgBE4AGQBJshgaGxESOQCwAC+wAEVYsAovG7EKGD5ZsABFWLACLxuxAhA+WbAKELAO0LAKELIRAQorWCHYG/RZsAIQshgBCitYIdgb9FkwMQEjESYCNTU0NjYzMhYVIzQmIyIGFRUUFhczAqK5sdR314uz8K+PZYScloJt/oIBcB4BJtkjmfmK4ahljNq1H6jbAwAAAQB0AAAEkAU+ABMAEwCwDi+wAEVYsAQvG7EEED5ZMDEBBQclAyMTJTcFEyU3BRMzAwUHJQJYASFE/t22qOH+30QBJc3+3kYBI7yl5wElSP7gAb6se6r+vwGOq3urAW2rfasBS/5oq3qqAAH8ZwSm/ycF/AAHABEAsAAvsgMGCitYIdgb9FkwMQEVJzchJxcV/Q2mAQIbAaUFI30B6WwB2AAAAfxxBRf/ZAYVABMALgCwDi+wCNCwCC+yAAIKK1gh2Bv0WbAOELAF0LAFL7AOELIPAgorWCHYG/RZMDEBMhYVFSM1NCMiBwcGByM1Mj4C/nZvf4ByKi1viXY8bGrBRwYVbG4kDnASLzoCfhtTEQAB/WYFFv5UBlcABQAMALABL7AF0LAFLzAxATUzFRcH/WazO00F3HuMdEEAAAH9pAUW/pMGVwAFAAwAsAMvsADQsAAvMDEBJzcnMxX98U07AbUFFkF0jHsACPob/sQBtgWvAAwAGgAnADUAQgBPAFwAagB6ALBFL7BTL7BgL7A4L7AARViwAi8bsQIcPlmyCQsKK1gh2Bv0WbBFELAQ0LBFELJMCworWCHYG/RZsBfQsFMQsB7QsFMQsloLCitYIdgb9FmwJdCwYBCwK9CwYBCyZwsKK1gh2Bv0WbAy0LA4ELI/CworWCHYG/RZMDEBNDYyFhUjNCYjIgYVATQ2MzIWFSM0JiMiBhUTNDYzMhYVIzQmIgYVATQ2MzIWFSM0JiMiBhUBNDYyFhUjNCYjIgYVATQ2MhYVIzQmIyIGFQE0NjMyFhUjNCYiBhUTNDYzMhYVIzQmIyIGFf0Ic750cDMwLjMB3nRdX3VxNS4sM0h1XV90cDVcM/7LdF1fdHA1Li0z/U9zvnRwMzAuM/1NdL50cDMwLjP+3nVdX3RwNVwzNXVdX3VxNS4tMwTzVGhoVC43NTD+61RoZ1UxNDUw/glVZ2hUMTQ3Lv35VGhoVDE0Ny7+5FRoaFQuNzcuBRpUaGhULjc1MP4JVWdoVDE0Ny79+VVnZ1UxNDUwAAj6LP5jAWsFxgAEAAkADgATABgAHQAiACcAOQCwIS+wEi+wCy+wGy+wJi+wAEVYsAcvG7EHHD5ZsABFWLAWLxuxFho+WbAARViwAi8bsQISPlkwMQUXAyMTAycTMwMBNwUVJQUHJTUFATclFwUBBwUnJQMnAzcTARcTBwP+Lwt6YEY6DHpgRgIdDQFN/qb7dQ3+swFaA5wCAUBE/tv88wL+wEUBJisRlEHGA2ARlELEPA7+rQFhBKIOAVL+oP4RDHxiRzsMfGJHAa4QmUTI/I4RmUXIAuQCAUZF/tX84wL+u0cBKwAAAv/cAAAD/AZxABEAGgB0shQbHBESObAUELAD0ACwAEVYsAwvG7EMHD5ZsABFWLAQLxuxEBw+WbAARViwCC8bsQgQPlmwEBCyAAEKK1gh2Bv0WbICDAgREjmwAi+wABCwCtCwC9CwAhCyEgEKK1gh2Bv0WbAIELITAQorWCHYG/RZMDEBIREhFhYQBgchESM1MzUzFSEBESEyNjU0JicClv6/ARi71NS3/iq/v7oBQf6/ARJpcW9kBRj90gLK/rbRAwUYmMHB/KL+RXdkYX0CAAIAqAAABNcFsAAOABsAVLIEHB0REjmwBBCwF9AAsABFWLADLxuxAxw+WbAARViwAS8bsQEQPlmyFgMBERI5sBYvsgABCitYIdgb9FmyCQADERI5sAMQshQBCitYIdgb9FkwMQERIxEhMgQVFAcXBycGIwE2NTQmJyERITI3JzcBacECGewBE2d+bYt2qAEZJaWR/qABWGJFbm4COv3GBbDyy7pwimeZNwEbQVuCnQL9xR15ZgAAAgCM/mAEIwROABMAIgB1shwjJBESObAcELAQ0ACwAEVYsBAvG7EQGD5ZsABFWLANLxuxDRg+WbAARViwCi8bsQoSPlmwAEVYsAcvG7EHED5ZsgIHEBESObIJEAcREjmyDhAHERI5sBAQshcBCitYIdgb9FmwBxCyHAEKK1gh2Bv0WTAxARQHFwcnBiMiJxEjETMXNjMyEhEnNCYjIgcRFjMyNyc3FzYEHmpvbm5Zc8VxuakJccnD47mciKhUU6tSPGZuWjICEe6XfWZ7OH399wXaeIz+2v76BLfUlf37lCdzZ2diAAABAKIAAAQjBwAACQA1sgMKCxESOQCwCC+wAEVYsAYvG7EGHD5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEBIxUhESMRIREzBCMD/ULAAsi5BRgG+u4FsAFQAAABAJEAAANCBXYABwAuALAGL7AARViwBC8bsQQYPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIREzA0L+CboB+LkDofxfBDoBPAABALH+3wR8BbAAFQBbsgoWFxESOQCwCS+wAEVYsBQvG7EUHD5ZsABFWLASLxuxEhA+WbAUELIAAQorWCHYG/RZsgMUCRESObADL7AJELIKAQorWCHYG/RZsAMQshABCitYIdgb9FkwMQEhETMgABEQAiMnMjY1JiYjIxEjESEEMP1CsgEcATz15AKRkAHMzrXBA38FEv4v/s/+8P74/ueTw8vL1P1hBbAAAAEAkf7lA74EOgAWAFuyCxcYERI5ALAKL7AARViwFS8bsRUYPlmwAEVYsBMvG7ETED5ZsBUQsgABCitYIdgb9FmyAxUKERI5sAMvsAoQsgsBCitYIdgb9FmwAxCyEQEKK1gh2Bv0WTAxASERMzIAFRQGBgcnNjY1NCYjIxEjESEDPv4NbO8BGGKqdTCAeLKYcLoCrQOh/uT+/NdiyIYVkiGZeZGo/h0EOgAAAQCjAAAE/wWwABQAYgCwAEVYsAAvG7EAHD5ZsABFWLAMLxuxDBw+WbAARViwAi8bsQIQPlmwAEVYsAovG7EKED5ZsA/QsA8vsi8PAV2yzw8BXbIIAQorWCHYG/RZsgEIDxESObAF0LAPELAS0DAxCQIjASMVIzUjESMRMxEzETMRMwEE0v5wAb3x/qJQlGjBwWiUTQFDBbD9Tv0CAo709P1yBbD9fwEA/wACgQAAAQCaAAAEfwQ6ABQAewCwAEVYsA0vG7ENGD5ZsABFWLAULxuxFBg+WbAARViwCi8bsQoQPlmwAEVYsAMvG7EDED5ZsAoQsA7QsA4vsp8OAV2y/w4BXbKfDgFxtL8Ozw4CXbIvDgFdsm8OAXKyCQEKK1gh2Bv0WbIBCQ4REjmwBdCwDhCwEtAwMQkCIwEjFSM1IxEjETMRMzUzFTMBBFr+rgF36/7rMpRlurpllCoBAwQ6/f79yAHNwsL+MwQ6/jbV1QHKAAEARAAABosFsAAOAGsAsABFWLAGLxuxBhw+WbAARViwCi8bsQocPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIBgIREjmwCC+yLwgBXbLPCAFdsgEBCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbIMAQgREjkwMQEjESMRITUhETMBMwEBIwOQsMH+JQKclgH87/3UAlbsAo79cgUYmP1+AoL9P/0RAAEAPgAABX0EOgAOAIAAsABFWLAGLxuxBhg+WbAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbACELAJ0LAJL7KfCQFdsv8JAV2ynwkBcbS/Cc8JAl2yLwkBXbJvCQFysgABCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbIMAAkREjkwMQEjESMRITUhETMBMwEBIwMbiLr+ZQJVegFr4f5TAdHrAc3+MwOhmf42Acr9+P3OAAABAKgAAAeEBbAADQBeALAARViwAi8bsQIcPlmwAEVYsAwvG7EMHD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmwAdCwAS+yLwEBXbACELIEAQorWCHYG/RZsAEQsggBCitYIdgb9FkwMQEhESEVIREjESERIxEzAWkC3gM9/YPA/SLBwQM+AnKY+ugCof1fBbAAAQCRAAAFaQQ6AA0AmwCwAEVYsAIvG7ECGD5ZsABFWLAMLxuxDBg+WbAARViwBi8bsQYQPlmwAEVYsAovG7EKED5ZsAYQsAHQsAEvsm8BAV20vwHPAQJdsj8BAXG0zwHfAQJxsg8BAXK0nwGvAQJxsv8BAV2yDwEBcbKfAQFdsi8BAV20bwF/AQJysAIQsgQBCitYIdgb9FmwARCyCAEKK1gh2Bv0WTAxASERIRUhESMRIREjETMBSwHxAi3+jLn+D7q6AmUB1Zn8XwHO/jIEOgAAAQCw/t8HzQWwABcAaLIRGBkREjkAsAcvsABFWLAWLxuxFhw+WbAARViwFC8bsRQQPlmwAEVYsBEvG7ERED5ZsgEWBxESObABL7AHELIIAQorWCHYG/RZsAEQsg4BCitYIdgb9FmwFhCyEgEKK1gh2Bv0WTAxATMgABEQAiMnMjY1JiYjIxEjESERIxEhBP92ARwBPPXkApGQAczOecH9MsAETwNB/s/+8P74/ueTw8vL1P1hBRL67gWwAAABAJH+5QawBDoAGABoshIZGhESOQCwCC+wAEVYsBcvG7EXGD5ZsABFWLAVLxuxFRA+WbAARViwEi8bsRIQPlmyARcIERI5sAEvsAgQsgkBCitYIdgb9FmwARCyDwEKK1gh2Bv0WbAXELITAQorWCHYG/RZMDEBMzIAFQcGBgcnNjY1NCYjIxEjESERIxEhA/ag+AEiAxTRmTB8e7ygpLn+DroDZQKF/vzXJqPhG5Igln2Sp/4dA6H8XwQ6AAIAcf/kBaIFxQAoADYAm7IYNzgREjmwGBCwKdAAsABFWLANLxuxDRw+WbAARViwHy8bsR8cPlmwAEVYsAQvG7EEED5ZsADQsAAvsgIEHxESObACL7ANELIOAQorWCHYG/RZsAQQshUBCitYIdgb9FmwAhCyLAEKK1gh2Bv0WbIXAiwREjmyJiwCERI5sAAQsigBCitYIdgb9FmwHxCyMwEKK1gh2Bv0WTAxBSInBiMiJAI1NTQSNjMXIgYVFRQSMzI3JgI1NTQ2NjMyEhUVFAIHFjMBFBYXNjY1NTQmIyIGFQWi17OOrLL+5J910oQBdpTsv0Y4eYRovXa25m9maHn9fXh1Ymh5Y2F6HElCsgFCxKyxASKjpf7Zpuz+1w1hARWq45r9jf7M/eue/vZfGgI0mO1KSOeN+bHO0rIAAAIAbf/rBJwETwAkAC8AorIEMDEREjmwBBCwJdAAsABFWLAMLxuxDBg+WbAARViwHC8bsRwYPlmwAEVYsAQvG7EEED5ZsABFWLAALxuxABA+WbICBBwREjmwAi+wDBCyDQEKK1gh2Bv0WbAEELIUAQorWCHYG/RZsAIQsicBCitYIdgb9FmyFhQnERI5sAAQsiQBCitYIdgb9FmyIickERI5sBwQsiwBCitYIdgb9FkwMQUiJwYjIiYCNTU0EjMVIgYVFRQWMzI3JhE1NDYzMhYVFRQHFjMBFBc2NzU0JiIGBwScsox2j4zhf8WbSV2piS4swa2PjLKAT2H+D59mA0l4RgEMOUKVARKnOs0BDp6tkjjB8AuiARFewOv5zmLjnRUBqdZ0c7p1gp6NegAAAQA0/qEGkwWwABMAWwCwES+wAEVYsAcvG7EHHD5ZsABFWLAMLxuxDBw+WbAARViwEy8bsRMQPlmwBxCyCAEKK1gh2Bv0WbAA0LAHELAF0LAD0LAC0LATELIKAQorWCHYG/RZsA7QMDEBITUhNTMVIRUhESERMxEzAyMRIQGr/okBd8EBgf5/As7BmBKs+9YFGJcBAZf7hQUT+vH+AAFfAAEAH/6/BRYEOgAPAEsAsA0vsABFWLADLxuxAxg+WbAARViwDy8bsQ8QPlmwAxCyBAEKK1gh2Bv0WbAA0LAPELIGAQorWCHYG/RZsAMQsAjQsAYQsArQMDEBITUhFSMRIREzETMDIxEhATH+7gLE+QHyuoASpfzSA6OXl/z0A6P8Xf4oAUEAAQCWAAAEyAWwABcAT7IEGBkREjkAsABFWLAALxuxABw+WbAARViwCi8bsQocPlmwAEVYsAwvG7EMED5ZsgcADBESObAHL7AE0LAHELIQAQorWCHYG/RZsBPQMDEBERYWMxEzETY3ETMRIxEGBxUjNSImJxEBVwGJoJV5eMHBcn+V+O8EBbD+MpqEATb+0g0hArb6UAJbIg3u6NnaAdcAAAEAgwAAA9kEOwAWAE+yBhcYERI5ALAARViwCy8bsQsYPlmwAEVYsBUvG7EVGD5ZsABFWLAALxuxABA+WbIPFQAREjmwDy+yBwEKK1gh2Bv0WbAE0LAPELAS0DAxISMRBgcVIzUmJicRMxEWFxEzETY3ETMD2bpGU5awuwK5Ba+WVEW6AYgTCYeFDcy1AUP+tdMaARj+6goRAhoAAAEAigAABLwFsAARAEayBRITERI5ALAARViwAS8bsQEcPlmwAEVYsAAvG7EAED5ZsABFWLAJLxuxCRA+WbIFAQAREjmwBS+yDgEKK1gh2Bv0WTAxMxEzETYzMhYXESMRJiYjIgcRisG5yvnyA8EBiaO7yAWw/aU12N/+LQHOmIY3/UsAAAIAP//qBb0FwwAdACUAZLIXJicREjmwFxCwJNAAsABFWLAPLxuxDxw+WbAARViwAC8bsQAQPlmyHw8AERI5sB8vshMBCitYIdgb9FmwBNCwHxCwC9CwABCyGAEKK1gh2Bv0WbAPELIjAQorWCHYG/RZMDEFIAARNSYmNTMUFhc0EjYzIAARFSEVFBYzMjcXBgYBITU0JiMiAgPp/uL+s5mmmFBXjv2WAQIBHPyC3syzpi9A0v3gAr6zq57CFgFRASlbE8WiWn0UtAEfov6j/r5sXdz3U48tNQNaIdnl/v0AAv/e/+wEYwROABkAIQByshQiIxESObAUELAb0ACwAEVYsA0vG7ENGD5ZsABFWLAALxuxABA+WbIeDQAREjmwHi+0vx7PHgJdshEBCitYIdgb9FmwA9CwHhCwCdCwABCyFQEKK1gh2Bv0WbIXDQAREjmwDRCyGgEKK1gh2Bv0WTAxBSIANSYmNTMUFz4CMzISERUhFhYzMjcXBgEiBgchNSYmAr3c/ux4d5NlFITIcNPq/SMEs4qub3GI/tlwmBICHgiIFAEh+h2uhpMwgslu/ur+/U2gxZJY0QPKo5MOjZsAAAEAo/7WBMwFsAAWAF2yFRcYERI5ALAOL7AARViwAi8bsQIcPlmwAEVYsAYvG7EGHD5ZsABFWLAALxuxABA+WbIEAAIREjmwBC+wCNCwDhCyDwEKK1gh2Bv0WbAEELIWAQorWCHYG/RZMDEhIxEzETMBMwEWABUQAiMnMjY1JiYnIQFkwcGFAgHi/fj4AQ355gKQkALHx/7sBbD9jwJx/YgW/tL6/vj+5JjBycrSAQAAAQCa/v4EGQQ6ABYAebINFxgREjkAsAcvsABFWLARLxuxERg+WbAARViwFS8bsRUYPlmwAEVYsA8vG7EPED5ZsBPQsBMvsp8TAV2y/xMBXbKfEwFxtL8TzxMCXbIvEwFdss8TAXGwANCwBxCyCAEKK1gh2Bv0WbATELIOAQorWCHYG/RZMDEBFhYVFAYGByc2NTQmJyMRIxEzETMBMwJ/w85krHAw+K2lsrq6WwGK4AJkH+K0XcV8E5I55oqSAv4zBDr+NgHKAAABALH+SwT+BbAAFQCnsgoWFxESOQCwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwCC8bsQgSPlmwAEVYsBMvG7ETED5ZsALQsAIvsl8CAV2yzwIBXbIfAgFxtG8CfwICcbS/As8CAnG0DwIfAgJysu8CAXGynwIBcbJPAgFxsv8CAV2yrwIBXbIvAgFdsj8CAXKwCBCyDQEKK1gh2Bv0WbACELIRAQorWCHYG/RZMDEBESERMxEUBiMiJzcWMzI2NREhESMRAXICzMCrnDw2DiU9QUj9NMEFsP1uApL5/ai6EpoOZ1wC1f1/BbAAAAEAkf5LA/UEOgAWAJ+yChcYERI5ALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAILxuxCBI+WbAARViwFC8bsRQQPlmwAtCwAi+ybwIBXbS/As8CAl2yPwIBcbTPAt8CAnGyDwIBcrSfAq8CAnGy/wIBXbIPAgFxsp8CAV2yLwIBXbRvAn8CAnKwCBCyDgEKK1gh2Bv0WbACELISAQorWCHYG/RZMDEBESERMxEUBiMiJzcWFxcyNjURIREjEQFLAfG5q5g8NA8RPBRCSP4PugQ6/isB1fttqrISkwcFAWhcAif+MgQ6AAACAF3/7AUSBcQAFwAfAF6yCCAhERI5sAgQsBjQALAARViwAC8bsQAcPlmwAEVYsAgvG7EIED5Zsg0ACBESObANL7AAELIRAQorWCHYG/RZsAgQshgBCitYIdgb9FmwDRCyGwEKK1gh2Bv0WTAxASAAERUUAgQjIAARNSE1EAIjIgcHJzc2ATISNyEVFBYCgAEuAWSc/uqn/uP+wQP09N2liz0vFp4BIaneD/zP0wXE/of+sVTF/r+2AVkBRXUHAQIBHDoajw1Y+sYBBdsi2uQAAQBo/+sELAWwABsAZ7ILHB0REjkAsABFWLACLxuxAhw+WbAARViwCy8bsQsQPlmwAhCyAAEKK1gh2Bv0WbAE0LIFAgsREjmwBS+wCxCwENCwCxCyEwEKK1gh2Bv0WbAFELIZAQorWCHYG/RZsAUQsBvQMDEBITUhFwEWFhUUBCMiJiY1MxQWMzI2NTQmIyM1Ax39dgNrAf5r2en+8+CG23bAnHuJo6aejQUSnn3+Hg7nxsPoab6CcpqSeJ2OlwAAAQBp/nUEKAQ6ABoAWrILGxwREjkAsAsvsABFWLACLxuxAhg+WbIAAQorWCHYG/RZsATQsgUCCxESObAFL7ALELAQ0LALELITAQorWCHYG/RZsAUQshgDCitYIdgb9FmwBRCwGtAwMQEhNSEXARYWFRQEIyImJjUzFBYzMjY1ECUjNQMM/YgDZQH+ctTo/vTehNd6up59jaT+yaADoZl2/hEQ4cXD52a/g3GflXkBIgiX//8AOv5LBHQFsAAmALBEAAAmAd6rQAAHAa8A8AAA//8AO/5LA5YEOgAmAOtPAAAmAd6sjgEHAa8A4QAAAAgAsgAGAV0wMQACAFcAAARlBbAACgATAFCyBBQVERI5sAQQsA3QALAARViwAS8bsQEcPlmwAEVYsAMvG7EDED5ZsgABAxESObAAL7ADELILAQorWCHYG/RZsAAQsgwBCitYIdgb9FkwMQERMxEhIiQ1NDY3AREhIgYVFBYXA6PC/d/k/vf/4AFt/qGMoZ+KA3MCPfpQ8svH6wT9KgI4loCCnwEAAgBZAAAGZwWwABcAHwBasgcgIRESObAHELAY0ACwAEVYsAgvG7EIHD5ZsABFWLAALxuxABA+WbIHCAAREjmwBy+wABCyGAEKK1gh2Bv0WbAK0LIQAAgREjmwBxCyGQEKK1gh2Bv0WTAxISIkNTQkNyERMxE3NjY3NiczFxYHBgYjJREhIgYUFhcCR+X+9wEB4wFqwVhvcgMEQLoWLwME5cP+7/6gjp6YhfTJxu0DAj366wECknuip0SXbsPonQI4l/6fBAAAAgBk/+cGbgYYAB8AKwCDshosLRESObAaELAq0ACwAEVYsAYvG7EGHj5ZsABFWLADLxuxAxg+WbAARViwGC8bsRgQPlmwAEVYsBwvG7EcED5ZsgUDGBESObAYELILAQorWCHYG/RZshEDGBESObIaAxgREjmwAxCyIgEKK1gh2Bv0WbAcELIoAQorWCHYG/RZMDETEBIzMhcRMxEGFjM2Njc2JzcWFgcOAiMGJwYjIgI1ASYjIgYVFBYzMjcnZOLEt2q5Al9OiZcEBEGzHCkCAnnZifJObNvA5ALHUqGHlJGIp1MFAgkBCAE9gwJN+0FfeALQvbrYAWbHZqn5hAS6tgEb9AExht/erb+TPgAAAQA2/+MF1QWwACcAY7IQKCkREjkAsABFWLAJLxuxCRw+WbAARViwIS8bsSEQPlmyASgJERI5sAEvsgABCitYIdgb9FmwCRCyBwEKK1gh2Bv0WbIPAAEREjmwIRCyFQEKK1gh2Bv0WbIaIQkREjkwMRM1MzY2NTQhITUhFhYVFAcWExUUFjM2Njc2JzMXFgcGAiMEAzU0Jif+m5+T/sv+oAFr7/zt2wVTQXSGBARBuhcwAwT2x/69D4d1AnmeAnuD+54B0cnoYkX+/FBPWwLOubvYWLuA/f7XCAFNQHiQAQABADH/4wToBDoAJwBgsg8oKRESOQCwAEVYsB8vG7EfGD5ZsABFWLAOLxuxDhA+WbICAQorWCHYG/RZsgcOHxESObIXKB8REjmwFy+yFAEKK1gh2Bv0WbAfELIdAQorWCHYG/RZsiUUFxESOTAxJQYzNjY3NiczFhYHBgYjBiYnNTQjIyczNjY1NCYjISchFhYVFAcWFwLnAl9wdgMEQrQtGAEE57iHiQfYzQLAem59df77BgEYxNy8tgTVWAKbiZmmhoA5zfADcINHnZYBV0pVXZYDp5idSjSyAAEAUv7XA/UFrwAhAF2yICIjERI5ALAXL7AARViwCS8bsQkcPlmwAEVYsBovG7EaED5ZsgEiCRESObABL7IAAQorWCHYG/RZsAkQsgcBCitYIdgb9FmyDwABERI5sBoQsRIKK1jYG9xZMDETNTM2NjUQISE1IRYWFRQHFhMVMxUUBgcnNjcjJic1NCYjr6mkm/7K/vEBIej05d4EqWFNalEOazwDkncCeZcBfYUBBZcD0sniZEb++KmUYchASHNuNKuPfo0AAAEAef7HA9kEOgAgAF2yICEiERI5ALAXL7AARViwCC8bsQgYPlmwAEVYsBovG7EaED5ZsgEhCBESObABL7IAAQorWCHYG/RZsAgQsgYBCitYIdgb9FmyDwABERI5sBoQsRIKK1jYG9xZMDETJzM2NTQjITUhFhcWFRQHFhcVMxUUBgcnNjcjJic1NCPCAdvp9f7pASfdbFa+vQGaYk1pVA1nMwLaAbiXAqGylgNnU4ShSTXKTJRhyj5IdH0hhV60AAEARP/rB3AFsAAjAGKyACQlERI5ALAARViwDi8bsQ4cPlmwAEVYsCAvG7EgED5ZsABFWLAHLxuxBxA+WbAOELIAAQorWCHYG/RZsAcQsggBCitYIdgb9FmwIBCyEwEKK1gh2Bv0WbIZDiAREjkwMQEhAwICBgcjNTc+AjcTIREUFjMyNjc2JzcWFgcGAgcHIiY1BCf+GhoPWayQPyhdZDQLHgNfWU+ClwQCP7ocKQID6cMus7cFEv2//t7+3IkCnQIHa+rzAsL7rGB0zbzA0gFmx2bs/toSArq0AAABAD//6wY6BDoAIQBisiAiIxESOQCwAEVYsAwvG7EMGD5ZsABFWLAeLxuxHhA+WbAARViwBi8bsQYQPlmwDBCyAAEKK1gh2Bv0WbAGELIHAQorWCHYG/RZsB4QshEBCitYIdgb9FmyFh4MERI5MDEBIQMCBgcjNTc2NjcTIREUFjMyNjc2JzMXFgcOAiMiJicDMf67FxScpUE2VU0NFwKvWk9sewQEQbMWMAMCbL54rrMBA6H+Wv7r5AKjBAqn0wIP/SFgebersstQsXya5nm4sQABAKn/5wdxBbAAHQCushQeHxESOQCwAEVYsAAvG7EAHD5ZsABFWLAZLxuxGRw+WbAARViwES8bsREQPlmwAEVYsBcvG7EXED5ZsBEQsgQBCitYIdgb9FmyCgARERI5sBcQsBzQsBwvsu8cAXGyXxwBXbLPHAFdsh8cAXG0bxx/HAJxtL8czxwCcbKfHAFxsk8cAXGy/xwBXbKvHAFdsi8cAV20DxwfHAJysj8cAXKyFQEKK1gh2Bv0WTAxAREUFjM2Njc2JzcWFgcOAiMGJicRIREjETMRIREE6V1KhpQEBEK7GysCAnvYiqu1CP1CwcECvgWw+6xlbwLNurfbAWLKZ6j7gwS4uwEn/X8FsP1uApIAAQCQ/+cGTQQ6ABwAo7IbHR4REjkAsABFWLAELxuxBBg+WbAARViwCC8bsQgYPlmwAEVYsBkvG7EZED5ZsABFWLACLxuxAhA+WbAH0LAHL7JvBwFdtL8HzwcCXbI/BwFxtM8H3wcCcbIPBwFytJ8HrwcCcbL/BwFdsg8HAXGynwcBXbIvBwFdtG8HfwcCcrIAAQorWCHYG/RZsBkQsg0BCitYIdgb9FmyEhkIERI5MDEBIREjETMRIREzERQWMzY2NzYnMxcWBwYCIwYmJwND/ga5uQH6uVxNbHwEBEGyFzADBOa7p7MIAc3+MwQ6/ioB1v0hZHUCtaus0VOxeer+8QS3uwABAHb/6wSgBcUAIgBHshUjJBESOQCwAEVYsAkvG7EJHD5ZsABFWLAALxuxABA+WbAJELIOAQorWCHYG/RZsAAQshYBCitYIdgb9FmyGwAJERI5MDEFIiQCJxE0EiQzMhcHJiMiAhUVFBYWMzY2NzYnMxcWBw4CArmk/viVApQBCqXchzuGoqzXYrBxjZYDAzW6JhMBAnveFZsBGK0BEK8BHp1YikT+/tL+g9V1ApmGms+zW1uIyW0AAQBl/+sDxwROAB4ARLITHyAREjkAsABFWLATLxuxExg+WbAARViwCy8bsQsQPlmyAAEKK1gh2Bv0WbIFCxMREjmwExCyGAEKK1gh2Bv0WTAxJTY2NzQnMxYHBgYjIgA1NTQ2NjMyFwcmIyIGFRUUFgJRYFoCFLIcAQTErdz+8HbWi7lgLGOKg5umggJQWXpyllaZqQEy9x6X+YxCkDrcsx+r2wABACP/5wVHBbAAGABNsgUZGhESOQCwAEVYsAIvG7ECHD5ZsABFWLAVLxuxFRA+WbACELIAAQorWCHYG/RZsATQsAXQsBUQsgkBCitYIdgb9FmyDgIVERI5MDEBITUhFSERFBYzNjYSJzcWFgcOAiMGJicB/v4lBID+HFxMhpQIQrobKwMCedmJqrcIBRKenvxIYHIC0AFu2wFiymep+YQEt7wAAAEARv/nBLcEOgAYAE2yFhkaERI5ALAARViwAi8bsQIYPlmwAEVYsBUvG7EVED5ZsAIQsgABCitYIdgb9FmwBNCwBdCwFRCyCQEKK1gh2Bv0WbIOFQIREjkwMQEhNSEVIREUFjM2Njc2JzMWFgcGBiMGJicBrP6aA4v+lV5NcXcDBECyKhsBBOi5qrMIA6SWlv21Y3QCnYmXrn2MPNDvBLm5AAEAlv/sBP8FxQApAG+yJCorERI5ALAARViwFi8bsRYcPlmwAEVYsAsvG7ELED5ZsgMBCitYIdgb9FmwCxCwBtCyJQsWERI5sCUvss8lAV2ynyUBcbImAQorWCHYG/RZshAmJRESObAWELAb0LAWELIeAQorWCHYG/RZMDEBFBYzMjY1MxQGBiMgJDU0JSYmNTQkITIWFhUjNCYjIgYVFBYXMxUjBgYBWM+wm8zBjf6d/vv+xAEUeIYBJQEGk/WMwcGSp8Kto8TEsbUBkniSmHSDvmflxf9WMKZlxNtlunVnj4h2dX0CngJ+AAIAbwRwAskF1gAFAA0AIwCwCy+wB9CwBy+wAdCwAS+wCxCwBNCwBC+wBdAZsAUvGDAxARMzFQMjATMVFhcHJjUBkXTE31n+3qgDUEmyBJQBQhX+wwFSW3tVO1+7AP//ACUCHwINArYABgARAAD//wAlAh8CDQK2AAYAEQAA//8AogKLBI0DIgBGAZfZAEzNQAD//wCQAosFyQMiAEYBl4QAZmZAAP//AA3+bAOhAAAAJwBDAAn/AwEGAEMJAAAUAEAJAwITAiMCMwIEXbKwAgFdMDEAAQBgBDEBeAYTAAgAIbIICQoREjkAsABFWLAALxuxAB4+WbIFCQAREjmwBS8wMQEXBgcVIzU0NgEOal0DuGEGE0h/k4h0ZsgAAQAwBBYBRwYAAAgAIbIICQoREjkAsABFWLAELxuxBB4+WbIACQQREjmwAC8wMRMnNjc1MxUGBplpXQO3AWEEFkiCkJCCZMcAAQAk/uUBOwC1AAgAHrIICQoREjkAsAkvsgQFCitYIdgb9FmwANCwAC8wMRMnNjc1MxUUBo1pWwO5Y/7lSX+SdmRlygABAE8EFgFnBgAACAAMALAIL7AE0LAELzAxARUWFwcmJic1AQYEXWpNXwIGAJOQf0hAwmGHAP//AGgEMQK7BhMAJgFsCAAABwFsAUMAAP//ADwEFgKGBgAAJgFtDAAABwFtAT8AAAACACT+0wJkAPYACAARADCyChITERI5sAoQsAXQALASL7IEBQorWCHYG/RZsADQsAAvsAnQsAkvsAQQsA3QMDETJzY3NTMVFAYXJzY3NTMVFAaNaVsDuWPdaVsDumH+00iJmbmkbNNASImZuaRr0QAAAQBGAAAEJAWwAAsASwCwAEVYsAgvG7EIHD5ZsABFWLAGLxuxBhg+WbAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZsAoQsgABCitYIdgb9FmwBNCwBdAwMQEhESMRITUhETMRIQQk/my6/nABkLoBlAOh/F8DoZkBdv6KAAEAV/5gBDQFsAATAHwAsABFWLAMLxuxDBw+WbAARViwCi8bsQoYPlmwAEVYsA4vG7EOGD5ZsABFWLACLxuxAhI+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgYBCitYIdgb9FmwDhCyCAEKK1gh2Bv0WbAJ0LAQ0LAR0LAGELAS0LAT0DAxISERIxEhNSERITUhETMRIRUhESEENP5quv5zAY3+cwGNugGW/moBlv5gAaCXAwqZAXb+ipn89gAAAQCKAhcCIgPLAA0AFrIKDg8REjkAsAMvsQoKK1jYG9xZMDETNDYzMhYVFRQGIyImNYpvXFtybl5dbwMEV3BtXSVXbm9Y//8AlP/1Ay8A0QAmABIEAAAHABIBuQAA//8AlP/1BM4A0QAmABIEAAAnABIBuQAAAAcAEgNYAAAAAQAmAh4AzwK3AAMADwCwAi+xAQorWNgb3FkwMRMjNTPPqakCHpkAAAYARP/rB1cFxQAVACMAJwA1AEMAUQC4sgJSUxESObACELAb0LACELAm0LACELAo0LACELA20LACELBJ0ACwAEVYsBkvG7EZHD5ZsABFWLASLxuxEhA+WbAD0LADL7AH0LAHL7ASELAO0LAOL7AZELAg0LAgL7IkEhkREjmwJC+yJhkSERI5sCYvsBIQsisECitYIdgb9FmwAxCyMgQKK1gh2Bv0WbArELA50LAyELBA0LAgELJHBAorWCHYG/RZsBkQsk4ECitYIdgb9FkwMQE0NjMyFzYzMhYVFRQGIyInBiMiJjUBNDYzMhYVFRQGIyImNQEnARcDFBYzMjY1NTQmIyIGFQUUFjMyNjU1NCYjIgYVARQWMzI2NTU0JiMiBhUDN6eDmE1Pl4Oop4KZT0yXgqr9DaeDhKelhIKqAWloAsdos1hKSFZXSUdZActYSUhWV0lIV/tCWEpHV1ZKSFgBZYOpeXmoi0eDqXh4p4sDe4OqqohIgaqni/wcQgRyQvw3T2VjVUpPZGNUSk9lZlJKT2RkUwLqTmViVUlOZmVTAAABAGwAmQIgA7UABgAQALAFL7ICBwUREjmwAi8wMQEBIwE1ATMBHgECjf7ZASeNAib+cwGEEwGFAAEAWQCYAg4DtQAGABAAsAAvsgMHABESObADLzAxEwEVASMBAecBJ/7ZjgEC/v4Dtf57E/57AY4BjwABADsAbgNqBSIAAwAJALAAL7ACLzAxNycBF6NoAsdobkIEckIA//8ANgKQArsFpQMHAdgAAAKQABMAsABFWLAJLxuxCRw+WbAN0DAxAAABAHoCiwL4BboADwBTsgoQERESOQCwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwDS8bsQ0UPlmwAEVYsAYvG7EGFD5ZsgENAxESObADELIKAworWCHYG/RZMDETFzYzIBERIxEmIyIHESMR+h5KkgEEqgONbiyqBat7iv7G/gsB5rlt/c4DIAAAAQBbAAAEaAXEACkAlrIhKisREjkAsABFWLAZLxuxGRw+WbAARViwBi8bsQYQPlmyKRkGERI5sCkvsgACCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbAI0LAJ0LAAELAO0LApELAQ0LApELAV0LAVL7YPFR8VLxUDXbISAgorWCHYG/RZsBkQsB3QsBkQsiABCitYIdgb9FmwFRCwJNCwEhCwJtAwMQEhFxQHIQchNTM2Njc1JyM1MycjNTMnNDYzMhYVIzQmIyIGFRchFSEXIQMV/rEDPgLdAfv4TSgyAgOqpgSinQb1yL7ev39vaYIGAVz+qQQBUwHWRJpbnZ0Jg2AIRX2IfbfH7tSxa3yafbd9iAAFAB8AAAY2BbAAGwAfACMAJgApALEAsABFWLAXLxuxFxw+WbAARViwGi8bsRocPlmwAEVYsAwvG7EMED5ZsABFWLAJLxuxCRA+WbIQDBcREjmwEC+wFNCwFC+0DxQfFAJdsCTQsCQvsBjQsBgvsADQsAAvsBQQshMBCitYIdgb9FmwH9CwI9CwA9CwEBCwHNCwHC+wINCwIC+wBNCwBC+wEBCyDwEKK1gh2Bv0WbAL0LAp0LAH0LImFwwREjmyJwkaERI5MDEBMxUjFTMVIxEjASERIxEjNTM1IzUzETMBIREzASEnIwUzNSElMycBNSMFV9/f39/C/sH+YsDZ2dnZwAFRAY+//GEBO2HaAhTM/tT+THd3AuBoA6yYlJj+GAHo/hgB6JiUmAIE/fwCBPzQlJSUmLb8558AAAIAp//sBgMFsAAfACgAorIjKSoREjmwIxCwEdAAsABFWLAWLxuxFhw+WbAARViwGi8bsRoYPlmwAEVYsB4vG7EeGD5ZsABFWLAKLxuxChA+WbAARViwFC8bsRQQPlmwHhCyAAEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAAQsA7QsA/QsiEUFhESObAhL7ISAQorWCHYG/RZsB4QsB3QsB0vsBYQsicBCitYIdgb9FkwMQEjERQWMzI3FwYjIiY1ESMGBgcjESMRITIWFzMRMxEzATMyNjU0JicjBf7KNkEjNAFJRnx+jxTnx8m5AXnK7RSPusr7YsCLi4eEywOr/WFBQQyWFJaKAp+3vQL9ywWwwLYBBv76/pKNl5iOAv//AKj/7AgQBbAAJgA2AAAABwBXBFUAAAAHADkAAAcpBbAAHwAjACcAKwAwADUAOgC3ALAARViwHi8bsR4cPlmwAEVYsBsvG7EbHD5ZsABFWLACLxuxAhw+WbAARViwDS8bsQ0QPlmwAEVYsBAvG7EQED5ZshQQGxESObAUL7AY0LAYL7Ac0LA20LAA0LAE0LAYELIXAQorWCHYG/RZsCfQsCPQsCvQsAfQsBQQsCTQsCDQsCjQsAjQsBQQshMBCitYIdgb9FmwMtCwD9CwLdCwC9CyNBAeERI5sDQQsC/QsjkeEBESOTAxASETMwMzFSMHMxUhAyMDIQMjAyE1MycjNTMDMxMhEzMDIScjBTM3IQUzNyETIxcXNyUjFxc3ATMnJwcEhwFTbMFzlbov6f7ydK+I/oSNr3X+9uUvtpFzwG4BVoih4wEkN7T+eqU3/vgDP6Us/vm5WQwpH/zpVwYdKAFEXRcXFwPUAdz+JJjCmP4eAeL+HgHimMKYAdz+JAHc/MrCwsLCwv6mKrLGFhfArQIcUW9vAAACAIwAAAWeBDoADQAbAGQAsABFWLAWLxuxFhg+WbAARViwAC8bsQAYPlmwAEVYsAsvG7ELED5ZsABFWLAOLxuxDhA+WbIRAQorWCHYG/RZsgURABESObAFL7AAELIKAQorWCHYG/RZsg8KCxESObAPLzAxATIWFxEjETQmJyERIxEBETMRITI2NxEzEQYGBwK6r6gEuWVv/r25AYm5AT5xZwG5AqWtBDrBv/6jAUx/eAH8XwQ6+8YC3f27dX4Cr/1OwsQCAAABAF//7AQcBcQAIwCHshUkJRESOQCwAEVYsBYvG7EWHD5ZsABFWLAJLxuxCRA+WbIjCRYREjmwIy+yAAIKK1gh2Bv0WbAJELIEAQorWCHYG/RZsAAQsAzQsCMQsA/QsCMQsB/QsB8vtg8fHx8vHwNdsiACCitYIdgb9FmwENCwHxCwE9CwFhCyGwEKK1gh2Bv0WTAxASEWFjMyNxcGIyIAAyM1MzUjNTMSADMyFwcmIyIGByEVIRUhA1H+gAS0pXRmFHh4+P7jBrKysrIKAR3zaocUbW6ksQYBf/6AAYACHcPSIqAeASUBDHyJfQEGAR8foiPLvH2JAAQAHwAABbwFsAAZAB4AIwAoALgAsABFWLALLxuxCxw+WbAARViwAS8bsQEQPlmwCxCyKAEKK1gh2Bv0WbIkKAEREjmwJC+ycCQBcbYAJBAkICQDXbIcAQorWCHYG/RZsB3QsB0vsnAdAXG2AB0QHSAdA12yIAEKK1gh2Bv0WbAh0LAhL7JwIQFxsiAhAV2yAAEKK1gh2Bv0WbAgELAD0LAdELAG0LAGL7AcELAH0LAkELAK0LAkELAP0LAcELAS0LAdELAU0LAULzAxAREjESM1MzUjNTM1ITIWFzMVIxcHMxUjBiEBJyEVIQchFSEyASEmIyEBpcDGxsbGAhmx6zbswwMCwuVr/owBRAT9bQKVP/2qAVms/fsCSlSe/qgCOv3GAzCXXpf0hHCXMiyX9gG3NF6XWQHlVgAAAQAqAAAD+AWwABoAZgCwAEVYsBkvG7EZHD5ZsABFWLAMLxuxDBA+WbAZELIYAQorWCHYG/RZsAHQsBgQsBTQsBQvsAPQsBQQshMBCitYIdgb9FmwBtCwExCwDtCwDi+yCQEKK1gh2Bv0WbINCQ4REjkwMQEjFhczByMGBiMBFSMBJzM2NjchNyEmJyE3IQPK7EARyS6YEvbbAe3j/e4B+X2cFf29LgITMPb+5y8DnQUSUXWesrT9xAwCaX0Ba1yevgieAAEAIP/uBBoFsAAeAI0AsABFWLARLxuxERw+WbAARViwBS8bsQUQPlmyExEFERI5sBMvsBfQsBcvsgAXAV2yGAEKK1gh2Bv0WbAZ0LAI0LAJ0LAXELAW0LAL0LAK0LATELIUAQorWCHYG/RZsBXQsAzQsA3QsBMQsBLQsA/QsA7QsAUQshoBCitYIdgb9FmyHgURERI5sB4vMDEBFQYCBCMiJxEHNTc1BzU3ETMRNxUHFTcVBxE2EhE1BBoCkP73r1Bs9PT09MD7+/v7vskDA2TS/semEgJab7JvmW+ybwFZ/v9zsnOZc7Jz/d4CARABCVgAAQBdAAAE6wQ6ABcAXLIAGBkREjkAsABFWLAWLxuxFhg+WbAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsABFWLAQLxuxEBA+WbIAChYREjmwAC+yCQEKK1gh2Bv0WbAM0LAAELAV0DAxARYAERUjNSYCJxEjEQYCBxUjNRIANzUzAv/nAQW5Ap6TuY+fArkDAQffuQNxIf6N/tq3yN8BBSD9NALKIf712MbFAR0BbSLJAAIAHwAABQMFsAAWAB8AbQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIGAwwREjmwBi+yBQEKK1gh2Bv0WbAB0LAGELAK0LAKL7QPCh8KAl2yCQEKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAMELIfAQorWCHYG/RZMDEBIREjESM1MzUjNTMRITIEFRQEByEVIQEhMjY1NCYnIQL8/rG/z8/PzwIZ6gES/vny/qMBT/6xAVqboqiP/qABE/7tAROeiZ0C2e7L1ecBiQEmkox/nQEABAB6/+sFgwXFABsAJwA1ADkAt7IcOjsREjmwHBCwANCwHBCwKNCwHBCwONAAsABFWLAKLxuxChw+WbAARViwJS8bsSUQPlmwChCwA9CwAy+yDgoDERI5tioOOg5KDgNdsAoQshEECitYIdgb9FmwAxCyGAQKK1gh2Bv0WbIbAwoREjm0NhtGGwJdsiUbAV2wJRCwH9CwHy+wJRCyKwQKK1gh2Bv0WbAfELIyBAorWCHYG/RZsjYlChESObA2L7I4CiUREjmwOC8wMQEUBiMiJjU1NDYzMhYVIzQmIyIGFRUUFjMyNjUBNDYgFhUVFAYgJjUXFBYzMjY1NTQmIyIGFQUnARcCqJh7eqGee3mciklCQU1PQT1MARCnAQaop/78qopYSkhWV0lHWf4GaQLHaQQebpCoiUeCq5FvOk1mUklOZUw6/UeDqaiLR4Opp4sGT2VjVUpPZGNU80IEckIAAAIAaP/rA2oGEwAXACEAZLITIiMREjmwExCwGNAAsABFWLAMLxuxDB4+WbAARViwAC8bsQAQPlmyBgwAERI5sAYvsgUBCitYIdgb9FmwE9CwABCyFwEKK1gh2Bv0WbAGELAY0LAMELIfAQorWCHYG/RZMDEFIiY1BiM1MjcRNjYzMhYVFRQCBxUUFjMDNjY1NTQmIyIHAszC0mJucV8BnYV4l86ra3DbWWcwJmcDFerrHLAjAiSyxq2TJcH+j2timo0CY1X1eydSTNEAAAQAogAAB8YFwAADABAAHgAoAKOyHykqERI5sB8QsAHQsB8QsATQsB8QsBHQALAARViwJy8bsSccPlmwAEVYsCUvG7ElHD5ZsABFWLAHLxuxBxw+WbAARViwIi8bsSIQPlmwAEVYsCAvG7EgED5ZsAcQsA3QsALQsAIvshACAV2yAQMKK1gh2Bv0WbANELIUAworWCHYG/RZsAcQshsDCitYIdgb9FmyISUgERI5siYgJRESOTAxASE1IQE0NiAWFRUUBiMiJjUXFBYzMjY3NTQmIyIGFQEjAREjETMBETMHpP2ZAmf9dboBOLu5nJ66o19WVF0BX1VUX/68zP2vucsCVLcBnI4CPZu+u6Ndnbq7oQVia2pgZWFra2P7mwRu+5IFsPuPBHEAAgBnA5cEOAWwAAwAFABtALAARViwBi8bsQYcPlmwAEVYsAkvG7EJHD5ZsABFWLATLxuxExw+WbIBFQYREjmwAS+yAAkBERI5sgMBBhESObAE0LIIAQkREjmwARCwC9CwBhCxDQorWNgb3FmwARCwD9CwDRCwEdCwEtAwMQEDIwMRIxEzExMzESMBIxEjESM1IQPejDSMWnCQkHBa/guTW5QBggUh/nYBif53Ahn+cQGP/ecByP44AchRAAACAJj/7ASTBE4AFQAcAGKyAh0eERI5sAIQsBbQALAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZshoKAhESObAaL7IPCgorWCHYG/RZsAIQshMKCitYIdgb9FmyFQoCERI5sAoQshYKCitYIdgb9FkwMSUGIyImAjU0EjYzMhYWFxUhERYzMjcBIgcRIREmBBa3u5H0h5D4hIXjhAP9AHeaxKz+kJd6AhxzXnKdAQGTjwEDn4vzkD7+uG56Ayp6/usBHnH//wBU//UFswWbACcB1f/aAoYAJwF8AOYAAAAHAdwDFAAA//8AZP/1BlMFtAAnAdcAJgKUACcBfAGlAAAABwHcA7QAAP//AGP/9QZJBaQAJwHZAAgCjwAnAXwBgwAAAAcB3AOqAAD//wBZ//UF/QWkACcB2wAfAo8AJwF8ASAAAAAHAdwDXgAAAAIAav/rBDIF7AAbACoAW7IVKywREjmwFRCwI9AAsA0vsABFWLAVLxuxFRA+WbIADRUREjmwAC+yAwAVERI5sA0QsgcBCitYIdgb9FmwABCyHAEKK1gh2Bv0WbAVELIjAQorWCHYG/RZMDEBMhYXLgIjIgcnNzYzIAARFRQCBiMiADU1NAAXIgYVFRQWMzI2NTUnJiYCPF2mOg5ppmCBmxAxdJcBBwEfeN6Q2v74AQDkjJ+fio6fBBygA/5NRIzZeTuXFTD+Tv5uMrz+1qUBI/YO3AEQmLugEKrP+ds9D1pqAAABAKn/KwTlBbAABwAnALAEL7AARViwBi8bsQYcPlmwBBCwAdCwBhCyAgEKK1gh2Bv0WTAxBSMRIREjESEE5bn9NrkEPNUF7foTBoUAAQBF/vMEqwWwAAwANQCwAy+wAEVYsAgvG7EIHD5ZsAMQsgIBCitYIdgb9FmwBdCwCBCyCgEKK1gh2Bv0WbAH0DAxAQEhFSE1AQE1IRUhAQNr/bsDhfuaAmH9nwQZ/McCRgJB/UqYjwLMAtKQmP1CAAEAqAKLA+sDIgADABsAsABFWLACLxuxAhY+WbIBAQorWCHYG/RZMDEBITUhA+v8vQNDAouXAAEAPwAABJgFsAAIADyyAwkKERI5ALAHL7AARViwAS8bsQEcPlmwAEVYsAMvG7EDED5ZsgABAxESObAHELIGAQorWCHYG/RZMDEBATMBIwMjNSECMAGrvf3ijfW5ATsBHASU+lACdJoAAwBi/+sHywROABwALAA8AG+yBz0+ERI5sAcQsCTQsAcQsDTQALAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsBPQsBMvsBnQsBkvsgcZBBESObIWGQQREjmwChCyIAEKK1gh2Bv0WbATELIpAQorWCHYG/RZsDDQsCAQsDnQMDEBFAIGIyImJwYGIyImAjU1NBI2MzIWFzY2MzIAFQUUFjMyNjc3NS4CIyIGFSU0JiMiBgcHFR4CMzI2NQfLft+Jke5QUeyQid6Aft+Ike1RUO+SzgEW+VCmiHK5NAsYcpJQhqYF96aFc7w1CRZ1kFCIpQIPk/8Akbixs7aPAQCXGJMBAJK3s7G5/sHzDbHcvKMnKmPAYdy5CK7fvagfKmHFYN64AAH/sP5LAo4GFQAVAD2yAhYXERI5ALAARViwDi8bsQ4ePlmwAEVYsAMvG7EDEj5ZsggBCitYIdgb9FmwDhCyEwEKK1gh2Bv0WTAxBRQGIyInNxYzMjURNDYzMhcHJiMiFQFlpJ45OhIuIZuxoTxUGCU2tmuiqBSRDbEFGaq+FY4L2wACAGUBGAQLA/QAFQArAI2yHCwtERI5sBwQsAXQALADL7IPAwFdsA3QsA0vsgANAV2yCAEKK1gh2Bv0WbADELAK0LAKL7ADELISAQorWCHYG/RZsA0QsBXQsBUvsA0QsBnQsBkvsCPQsCMvsgAjAV2yHgEKK1gh2Bv0WbAZELAg0LAgL7AZELIoAQorWCHYG/RZsCMQsCvQsCsvMDETNjYzNhcXFjMyNxUGIyInJyYHIgYHBzY2MzYXFxYzMjcXBiMiJycmByIGB2Ywg0JSSphCToZmZ4VOQqFET0KDMAEwgkJSSpVEUIVmAWeFTkKYSlJCgzADhTM6AiNOH4C+bR9THwJEPOUzOwIjTSGAvW0fTiMCRDwAAAEAmACbA9oE1QATADcAsBMvsgABCitYIdgb9FmwBNCwExCwB9CwExCwD9CwDy+yEAEKK1gh2Bv0WbAI0LAPELAL0DAxASEHJzcjNSE3ITUhExcHMxUhByED2v3tjl9srgELlf5gAf6ZX3fD/t+UAbUBj/Q7uaD/oQEGO8uh/wD//wA+AAIDgQQ+AGYAIABhQAA5mgEHAZf/lv13AB0AsABFWLAFLxuxBRg+WbAARViwCC8bsQgQPlkwMQD//wCFAAED3ARRAGYAIgBzQAA5mgEHAZf/3f12AB0AsABFWLACLxuxAhg+WbAARViwCC8bsQgQPlkwMQAAAgArAAAD3AWwAAUACQA4sggKCxESObAIELAB0ACwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxA+WbIGAAMREjmyCAADERI5MDEBMwEBIwkEAbyMAZT+cI3+bAHW/ukBHAEYBbD9J/0pAtcCD/3x/fICDgD//wC1AKcBmwT1ACcAEgAlALIABwASACUEJAACAG4CeQIzBDoAAwAHACwAsABFWLACLxuxAhg+WbAARViwBi8bsQYYPlmwAhCwANCwAC+wBNCwBdAwMRMjETMBIxEz+42NATiNjQJ5AcH+PwHBAAABAFz/XwFXAO8ACAAgsggJChESOQCwCS+wBNCwBC+0QARQBAJdsADQsAAvMDEXJzY3NTMVFAbFaUgCsU+hSG1/XExbswD//wA8AAAE9gYVACYASgAAAAcASgIsAAAAAgAfAAADzQYVABUAGQCDsggaGxESObAIELAX0ACwAEVYsAgvG7EIHj5ZsABFWLADLxuxAxg+WbAARViwES8bsREYPlmwAEVYsBgvG7EYGD5ZsABFWLAALxuxABA+WbAARViwFi8bsRYQPlmwAxCyAQEKK1gh2Bv0WbAIELINAQorWCHYG/RZsAEQsBPQsBTQMDEzESM1MzU0NjMyFwcmIyIGFRUzFSMRISMRM8qrq8+9cKsffXF3ad3dAkm6ugOrj1y1yj2cMmtrXo/8VQQ6AAEAPAAAA+kGFQAWAFwAsABFWLASLxuxEh4+WbAARViwBi8bsQYYPlmwAEVYsAkvG7EJED5ZsABFWLAWLxuxFhA+WbASELICAQorWCHYG/RZsAYQsgcBCitYIdgb9FmwC9CwBhCwDtAwMQEmIyIVFTMVIxEjESM1MzU2NjMyBREjAzB8TMjn57mrqwHAsWUBK7kFYxTSa4/8VQOrj3atuD36KAAAAgA8AAAGMgYVACcAKwCdALAARViwFi8bsRYePlmwAEVYsAgvG7EIHj5ZsABFWLAgLxuxIBg+WbAARViwEi8bsRIYPlmwAEVYsAQvG7EEGD5ZsABFWLAqLxuxKhg+WbAARViwKS8bsSkQPlmwAEVYsCMvG7EjED5ZsABFWLAnLxuxJxA+WbAgELIhAQorWCHYG/RZsCXQsAHQsAgQsg0BCitYIdgb9FmwG9AwMTMRIzUzNTQ2MzIXByYjIgYVFSE1NDYzMhcHJiMiBhUVMxUjESMRIREhIxEz56uruqpAPwovNVpiAZDPvXCrH31yd2ne3rn+cASSubkDq49vrr4RlglpYnJctco9nDJqbF6P/FUDq/xVBDoAAAEAPAAABjIGFQAoAGoAsABFWLAILxuxCB4+WbAARViwIS8bsSEYPlmwAEVYsCgvG7EoED5ZsCEQsiIBCitYIdgb9FmwJtCwAdCwIRCwEtCwBNCwCBCyDQEKK1gh2Bv0WbAIELAW0LAoELAl0LAa0LANELAd0DAxMxEjNTM1NDYzMhcHJiMiBhUVITU2NjMyBREjESYjIhUVMxUjESMRIRHnq6u6qkA/Ci81WmIBkAHAsWUBK7l8TMjn57n+cAOrj2+uvhGWCWlicnatuD36KAVjFNJrj/xVA6v8VQABADz/7ASbBhUAJgBzALAARViwIS8bsSEePlmwAEVYsB0vG7EdGD5ZsABFWLAYLxuxGBA+WbAARViwCi8bsQoQPlmwHRCwENCwJdCyAQEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAEQsA7QsCEQshUBCitYIdgb9FmwDhCwGtAwMQEjERQWMzI3FwYjIiY1ESM1MxEmJyciFREjESM1MzU0NjMyFhcRMwSWyjZBIzQBSUZ8fsXFPWYYt7mrq7OgXdtaygOr/WFBQQyWFJaKAp+PAR8cBwHd+2ADq49wrb45LP6KAAABAF//7AZUBhEATAC5shZNThESOQCwAEVYsEcvG7FHHj5ZsABFWLAPLxuxDxg+WbAARViwSy8bsUsYPlmwAEVYsEAvG7FAGD5ZsABFWLAJLxuxCRA+WbAARViwLC8bsSwQPlmwSxCyAQEKK1gh2Bv0WbAJELIEAQorWCHYG/RZsAEQsA3QsEcQshQBCitYIdgb9FmwQBCyIAEKK1gh2Bv0WbI6LEAREjmwOhCyJQEKK1gh2Bv0WbAsELI0AQorWCHYG/RZMDEBIxEUMzI3FwYjIiY1ESM1MzU0JiMiBhUUHgIVIzQmIyIGFRQWBBYWFRQGIyImJjUzFhYzMjY1NCYkJiY1NDYzMhcmNTQ2MzIWFRUzBk/KdyM0AU1CdoS8vGZiWFwfJR66gWJlcmoBFaxT6LmCyHG5BYtyaX9x/uelT+GvYFYsypu5ycoDq/1+nwyWFKaXAoKPVXJ1WEY7aXB8TExuWEdDRD5WeVeRr1ylYF1tVUdLUzxUdFCFuB5uUnylx8NNAAAWAFv+cgfuBa4ADQAaACgANwA9AEMASQBPAFYAWgBeAGIAZgBqAG4AdgB6AH4AggCGAIoAjgG+shCPkBESObAQELAA0LAQELAb0LAQELAw0LAQELA80LAQELA+0LAQELBG0LAQELBK0LAQELBQ0LAQELBX0LAQELBb0LAQELBh0LAQELBj0LAQELBn0LAQELBt0LAQELBw0LAQELB30LAQELB70LAQELB/0LAQELCE0LAQELCI0LAQELCM0ACwPS+wAEVYsEYvG7FGHD5Zsn5JAyuyensDK7KCdwMrsn86AyuyCj1GERI5sAovsAPQsAMvsA7QsA4vsAoQsA/QsA8vslAODxESObBQL7JvBworWCHYG/RZshVQbxESObAKELIeBworWCHYG/RZsAMQsiUHCitYIdgb9FmwDxCwKdCwKS+wDhCwLtCwLi+yNAcKK1gh2Bv0WbA9ELI8CgorWCHYG/RZsD0QsGvQsGfQsGPQsD7QsDwQsGzQsGjQsGTQsD/QsDoQsEHQsEYQsGDQsFzQsFjQsEvQskoKCitYIdgb9FmwWtCwXtCwYtCwR9CwSRCwTtCwDhCyUQcKK1gh2Bv0WbAPELJ2BworWCHYG/RZsHcQsITQsHoQsIXQsHsQsIjQsH4QsInQsH8QsIzQsIIQsI3QMDEBFAYjIiYnNTQ2MzIWFxMRMzIWFRQHFhYVFCMBNCYjIgYVFRQWMzI2NQEzERQGIyImNTMUMzI2NQERMxUzFSE1MzUzEQERIRUjFSU1IREjNQEVMzI1NCcTNSEVITUhFSE1IRUBNSEVITUhFSE1IRUTMzI1NCYjIwEjNTM1IzUzESM1MyUjNTM1IzUzESM1MwM5gWRmgAJ+aGWAAkO8YnJUMjTQ/o9KQUBKSkJASQO6XGlSWG1daCk2+cRxxAUox2/4bQE1xAXsATZv/Fx+Z2LLARb9WwEV/VwBFAIKARb9WwEV/VwBFLxddjo8XfzxcXFxcXFxByJvb29vb28B1GJ5eF51X3x4Xv6zAiVJTVQgDUYtmwFIRU5ORXBFTk5FAU/+hk5dUVNbNiz8yQE7ynFxyv7FBh8BHXSpqXT+46n8tqlTUgQDSnR0dHR0dPk4cXFxcXFxA8RQKR7+0/x++vwV+X78fvr8FfkABQBc/dUH1whzAAMAHAAgACQAKABSsxEPEAQrswQPHAQrswoPFwQrsAQQsB3QsBwQsB7QALAhL7AlL7IcHgMrsCUQsADQsAAvsCEQsALQsAIvsg0AAhESObANL7IfHgIREjmwHy8wMQkDBTQ2NzY2NTQmIyIGBzM2NjMyFhUUBwYGFRcjFTMDMxUjAzMVIwQYA7/8QfxEBA8eJEpcp5WQoALLAjorOThdWy/KyspLBAQCBAQGUvwx/DEDz/E6Ohgnh0qAl4t/MzRANF88QVxMW6r9TAQKngQAAQA7AAAD0gWwAAYAMgCwAEVYsAUvG7EFHD5ZsABFWLABLxuxARA+WbAFELIDAQorWCHYG/RZsgADBRESOTAxAQEjASE1IQPS/b66AkD9JQOXBUj6uAUYmAAAAgBa/+wERAROABAAHAA2ALAARViwBC8bsQQYPlmwAEVYsAwvG7EMED5ZshQBCitYIdgb9FmwBBCyGgEKK1gh2Bv0WTAxEzQ2NjMyABUVFAYGIyImJic3FBYzMjY1NCYjIgZagOOQ3QEafuWSj+OBArmvjY6usY2LrwInnP+M/sz7Dp38jIj5mgqw3uDEr+DeAAAB/7b+SwFnAJgADAAnALANL7AARViwBC8bsQQSPlmyCQEKK1gh2Bv0WbANELAM0LAMLzAxJRUGBiMiJzcWMzI1NQFnAaqXOzQOHkOJmPWosBKdDcLpAAEAZ/6ZASEAmQADABIAsAQvsALQsAIvsAHQsAEvMDEBIxEzASG6uv6ZAgAAAgCDBNkC0gbQAA0AIQB7ALADL7AH0LAHL0ANDwcfBy8HPwdPB18HBl2wAxCyCgQKK1gh2Bv0WbAHELAN0LANL7AHELAR0LARL7AU0LAUL0ALDxQfFC8UPxRPFAVdsBEQsBfQsBcvsBQQshsECitYIdgb9FmwERCyHgQKK1gh2Bv0WbAbELAh0DAxARQGIyImNTMUFjMyNjUTFAYjIiYjIgYVJzQ2MzIWMzI2NQLSoYaHoZZKSEdKjWBGOncsIjBTYEUwgSwjMAWuX3Z2XzZAQDYBCkppSzMmFUtrSzMmAAACAIEE4ALKBwMADQAcAGUAsAMvsAfQsAcvQA0PBx8HLwc/B08HXwcGXbADELIKBAorWCHYG/RZsAcQsA3QsA0vsAcQsA7QsA4vsBXQsBUvQA8PFR8VLxU/FU8VXxVvFQddsBTQsg8UDhESObIbDhUREjkwMQEUBiMiJjUzFBYzMjY1Jyc2NjU0IzcyFhUUBgcHAsqhg4ShkkpJRUzJAUpCoAeQlFFEAQWwXnJzXTU+PTYRfAQYHTtSTkIyOwc+AAACAIEE3wLgBooADQARAF8AsAMvsAfQsAcvQA0PBx8HLwc/B08HXwcGXbADELIKBAorWCHYG/RZsAcQsA3QsA0vsAcQsBDQsBAvsA/QsA8vQA8PDx8PLw8/D08PXw9vDwddsBAQsBHQGbARLxgwMQEUBiMiJjUzFBYzMjY1JzMHIwLgqIeIqJhPSUdPYJmkZgWwX3JyXzc9PzXaxgACAGkE5ANGBtQABgAaAIUAsAMvsAHQsAEvsAbQsAYvQAkPBh8GLwY/BgRdsgQDBhESORmwBC8YsADQsgIGARESObAGELAK0LAKL7Q/Ck8KAl2wDdCwDS9ADQ8NHw0vDT8NTw1fDQZdsAoQsBDQsBAvsA0QshQECitYIdgb9FmwChCyFwQKK1gh2Bv0WbAUELAa0DAxASMnByMlMzcUBiMiJiMiBhUnNDYzMhYzMjY1A0aqxcWpAS2Dw2BBNm4oHTZNYEAqfCYfNATknp705T5eRy4dEz9iRi0cAAIAaQTkA+wGzwAGABUAYQCwAy+wBdCwBS+2DwUfBS8FA12yBAMFERI5GbAELxiwANCwAxCwAdCwAS+yAgUDERI5sAfQsAcvsA7QsA4vQA0PDh8OLw4/Dk8OXw4GXbAN0LIIBw0REjmyFA4HERI5MDEBIycHIwEzFyc2NjU0IzcyFhUUBgcHA0aqxcWpARC8vgFBO40FgIZKPAEE5Lq6AQZ8gwQaIUNcWEk7Qgc8AAL/XgTPA0YGggAGAAoAXQCwAy+yDwMBXbAE0BmwBC8YsADQGbAALxiwAxCwAdCwAS+wBtCwBi+2DwYfBi8GA12yAgMGERI5sAMQsAjQsAgvsAfQGbAHLxiwCBCwCtCwCi+2DwofCi8KA10wMQEjJwcjATMFIwMzA0bFqqrEASKY/o+MyMcEz56eAQZVAQIAAAIAbgThBFgGlQAGAAoAXQCwAy+yDwMBXbAF0LAFL7AA0LAAL7YPAB8ALwADXbADELAC0BmwAi8YsgQDABESObAG0BmwBi8YsAMQsAnQsAkvsAfQsAcvtg8HHwcvBwNdsAkQsArQGbAKLxgwMQEzASMnByMBMwMjAZKYASLFqarGAyLIyY0F6P75n58BtP79AAIAgQTfAuAGigANABEAXwCwAy+wB9CwBy9ADQ8HHwcvBz8HTwdfBwZdsAMQsgoECitYIdgb9FmwBxCwDdCwDS+wBxCwEdCwES+wD9CwDy9ADw8PHw8vDz8PTw9fD28PB12wERCwENAZsBAvGDAxARQGIyImNTMUFjMyNjUlMxcjAuCoh4iomE9JR0/+pppwZQWwX3JyXzc9PzXaxgAAAQCfBI4BlgY7AAgADACwAC+wBNCwBC8wMQEXBgcVIzU0NgErazsDuVQGO1Njb4iCTa0AAAIAEwAABHAEjQAHAAoARgCwAEVYsAQvG7EEGj5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMjATMBIwEhAwNG/fhuvQHfpgHYvP3GAZHHARf+6QSN+3MBrgH9AAMAigAAA+8EjQAOABYAHgBoALAARViwAS8bsQEaPlmwAEVYsAAvG7EAED5ZshcAARESObAXL7K/FwFdtB8XLxcCXbTfF+8XAl2yDwEKK1gh2Bv0WbIIDxcREjmwABCyEAEKK1gh2Bv0WbABELIeAQorWCHYG/RZMDEzESEyFhUUBgcWFhUUBgcBESEyNjU0IyUzMjY1NCcjigGW0d5fWGN02sn+9wEGc3rr/vjqbHzl7QSNo5tRfiEYlWWergECEv6FYlXEjVVTqAUAAAEAYP/wBDAEnQAcAEyyAx0eERI5ALAARViwCy8bsQsaPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WbADELAc0DAxAQYGIyIAETU0NjYzMhYXIyYmIyIGBxUUFjMyNjcEMBT80eD+8XvnmMz3E7kSjX6ZpwGfl4eNFAF5u84BJwEDXqT5iNO7gnTLvWq9z2+DAAIAigAABB8EjQAKABQARrICFRYREjmwAhCwFNAAsABFWLABLxuxARo+WbAARViwAC8bsQAQPlmwARCyCwEKK1gh2Bv0WbAAELIMAQorWCHYG/RZMDEzESEyFhYXFRQAIQMRMzI2NTU0JiOKAWmi+4wD/sn++Z6kusa9twSNhfafTfz+1gP0/KPQwEDAzQABAIoAAAOuBI0ACwBUALAARViwBi8bsQYaPlmwAEVYsAQvG7EEED5ZsAvQsAsvst8LAV2yHwsBXbIAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASERIRUhESEVIREhA1f97AJr/NwDHv2bAhQCDv6JlwSNmf6yAAEAigAAA5sEjQAJAEEAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmwCdCwCS+yHwkBXbIAAQorWCHYG/RZsAQQsgYBCitYIdgb9FkwMQEhESMRIRUhESEDS/34uQMR/agCCAHz/g0EjZn+mAAAAQBj//AENQSdAB0AX7IKHh8REjkAsABFWLAKLxuxCho+WbAARViwAy8bsQMQPlmyHQoDERI5sB0vsg0dChESObAKELIQAQorWCHYG/RZsAMQshcBCitYIdgb9FmwHRCyGgMKK1gh2Bv0WTAxJQYGIyIAJzUQADMyFhcjJiMiBhUVFBYzMjc1ITUhBDVC6Zfu/uACAQvyyPIbuCb1n6a5oLZR/ucB0ZZTUwEq/FoBBgEnvLXZzsdUvtdK7pAAAAEAigAABFgEjQALAFMAsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbIJAAoREjl8sAkvGLKjCQFdsgIBCitYIdgb9FkwMSEjESERIxEzESERMwRYuf2kubkCXLkB8v4OBI39/QIDAAABAJcAAAFRBI0AAwAdALAARViwAi8bsQIaPlmwAEVYsAAvG7EAED5ZMDEhIxEzAVG6ugSNAAABACv/8ANNBI0ADwA1sgUQERESOQCwAEVYsAAvG7EAGj5ZsABFWLAFLxuxBRA+WbAJ0LAFELIMAQorWCHYG/RZMDEBMxEUBiMiJjUzFBYzMjY1ApK71LHC27pxclxuBI38xZ3Ft6ReZm1fAAABAIoAAARXBI0ADABMALAARViwBC8bsQQaPlmwAEVYsAgvG7EIGj5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAIIERI5sgYCBBESObIKAggREjkwMQEHESMRMxE3ATMBASMB1pO5uYIBjeP+IQIB4QIHjv6HBI391ZABm/35/XoAAAEAigAAA4sEjQAFACgAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WTAxJSEVIREzAUMCSPz/uZeXBI0AAAEAigAABXcEjQAOAGCyAQ8QERI5ALAARViwAC8bsQAaPlmwAEVYsAIvG7ECGj5ZsABFWLAELxuxBBA+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsgEABBESObIHAAQREjmyCgAEERI5MDEJAjMRIxETASMBExEjEQF6AYcBhfG4E/5yiP5zE7gEjfxxA4/7cwGRAhX8WgOi/e/+bwSNAAEAigAABFgEjQAJAEUAsABFWLAFLxuxBRo+WbAARViwCC8bsQgaPlmwAEVYsAAvG7EAED5ZsABFWLADLxuxAxA+WbICBQAREjmyBwUAERI5MDEhIwERIxEzAREzBFi4/aO5uQJduANs/JQEjfyTA20AAAIAYP/wBFoEnQANABsARrIDHB0REjmwAxCwEdAAsABFWLAKLxuxCho+WbAARViwAy8bsQMQPlmwChCyEQEKK1gh2Bv0WbADELIYAQorWCHYG/RZMDEBEAAjIgARNRAAMzIAFwc0JiMiBhUVFBYzMjY1BFr+7Ojl/ucBF+XpARMCt6yblq+wl5ypAiT++/7RATIBBz4BAgE0/tD/BcbS1sVCw9fTxwACAIoAAAQbBI0ACgATAE2yChQVERI5sAoQsAzQALAARViwAy8bsQMaPlmwAEVYsAEvG7EBED5ZsgsDARESObALL7IAAQorWCHYG/RZsAMQshIBCitYIdgb9FkwMQERIxEhMhYVFAYjJSEyNjU0JichAUO5AdPM8urW/ugBGnyIiHf+4QG2/koEjceoqr6YamRgdwEAAgBZ/zYEVwSdABMAIQBNsggiIxESObAIELAe0ACwAEVYsBAvG7EQGj5ZsABFWLAILxuxCBA+WbIDCBAREjmwEBCyFwEKK1gh2Bv0WbAIELIeAQorWCHYG/RZMDEBFAYHFwclBiMiABE1NBI2MzIAESc0JiMiBgcVFBYzMjY1BFVwZth8/vk2RuT+5X/oluoBFbesnJSsBK6YnKoCJKbzRqBvxw0BMQEIPqkBA4r+zf75BsbSz7lVwtjTxwACAIoAAAQlBI0ADQAWAGGyFRcYERI5sBUQsAXQALAARViwBC8bsQQaPlmwAEVYsAIvG7ECED5ZsABFWLAMLxuxDBA+WbIPBAIREjmwDy+yAAEKK1gh2Bv0WbIKAAQREjmwBBCyFQEKK1gh2Bv0WTAxASERIxEhMhYVFAcBFSMBMzI2NTQmIyMCWv7puQGq1efrASDG/eT2dYmGfvABwf4/BI26quRZ/h4KAlhtXWRuAAEAQ//wA90EnQAlAFoAsABFWLAJLxuxCRo+WbAARViwHC8bsRwQPlmyAhwJERI5sAkQsA3QsAkQshABCitYIdgb9FmwAhCyFgEKK1gh2Bv0WbAcELAg0LAcELIjAQorWCHYG/RZMDEBNCYkJyY1NDYzMhYVIzQmIyIGFRQWBBYWFRQGIyIkNTMUFjMyNgMjef7aVsPzv8T5uY15cYZ7ATiwVvPHz/7vupqMfoIBKlBYSitis4+yyJxia1lQQVhQZYhbk6nLomZyWwABACgAAAP9BI0ABwAuALAARViwBi8bsQYaPlmwAEVYsAIvG7ECED5ZsAYQsgABCitYIdgb9FmwBNAwMQEhESMRITUhA/3+cbn+cwPVA/T8DAP0mQABAHT/8AQKBI0AEQA8sgQSExESOQCwAEVYsAAvG7EAGj5ZsABFWLAILxuxCBo+WbAARViwBC8bsQQQPlmyDQEKK1gh2Bv0WTAxAREUBiMiJicRMxEUFjMyNjURBAr60dL2A7ePhYOPBI389Lbb07YDFPz0eYF/ewMMAAEAFAAABFMEjQAIADEAsABFWLADLxuxAxo+WbAARViwBy8bsQcaPlmwAEVYsAUvG7EFED5ZsgEDBRESOTAxARc3ATMBIwEzAhoZGgFAxv43rf43xwEkXlwDa/tzBI0AAAEAMQAABfEEjQASAGCyDhMUERI5ALAARViwAy8bsQMaPlmwAEVYsAgvG7EIGj5ZsABFWLARLxuxERo+WbAARViwCi8bsQoQPlmwAEVYsA8vG7EPED5ZsgEDChESObIGAwoREjmyDQMKERI5MDEBFzcTMxMXNxMzASMBJwcBIwEzAa8LD/il9A0Mxrj+1q7+/AEB/vSt/te3ASZQQAN3/IY7UANl+3MDlQUF/GsEjQAAAQAmAAAEMQSNAAsAUwCwAEVYsAEvG7EBGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQQPlmwAEVYsAcvG7EHED5ZsgABBBESObIGAQQREjmyAwAGERI5sgkGABESOTAxAQEzAQEjAQEjAQEzAigBH9z+dQGZ3P7V/tjcAZb+c9sC2gGz/b79tQG7/kUCSwJCAAABAA0AAAQcBI0ACAAxALAARViwAS8bsQEaPlmwAEVYsAcvG7EHGj5ZsABFWLAELxuxBBA+WbIAAQQREjkwMQEBMwERIxEBMwIUATjQ/lK5/ljQAkoCQ/0K/mkBogLrAAABAEcAAAPgBI0ACQBEALAARViwBy8bsQcaPlmwAEVYsAIvG7ECED5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIRUhNQEhNSEVAS8CsfxnApj9cQN4l5d8A3iZeQAAAgBQ//UCnQMgAA0AFwBGsgMYGRESObADELAQ0ACwAEVYsAovG7EKFj5ZsABFWLADLxuxAxA+WbAKELIQAgorWCHYG/RZsAMQshUCCitYIdgb9FkwMQEUBiMiJic1NDYzMhYXJzQjIgcVFDMyNwKdmI2LnAGbi42YAp2KhQSLhAQBRaKurKCOo66snQfAtLPCtQABAHoAAAHvAxUABgA1ALAARViwBS8bsQUWPlmwAEVYsAEvG7EBED5ZsgQFARESObAEL7IDAgorWCHYG/RZsALQMDEhIxEHNSUzAe+d2AFjEgJZOYB1AAEAQgAAAqsDIAAWAFSyCBcYERI5ALAARViwDi8bsQ4WPlmwAEVYsAAvG7EAED5ZshUCCitYIdgb9FmwAtCyFBUOERI5sgMOFBESObAOELIIAgorWCHYG/RZsA4QsAvQMDEhITUBNjU0JiMiBhUjNDYgFhUUDwIhAqv9qQEsbUA8S0edpwEImmtUsAGPbAEaZkUxPUw5cpR/bmhrT5EAAQA+//UCmgMgACYAcQCwAEVYsA4vG7EOFj5ZsABFWLAZLxuxGRA+WbIAGQ4REjl8sAAvGLaAAJAAoAADXbAOELIHAgorWCHYG/RZsgoABxESObAAELImAgorWCHYG/RZshQmABESObAZELIgAgorWCHYG/RZsh0mIBESOTAxATMyNjU0JiMiBhUjNDYzMhYVFAYHFhUUBiMiJjUzFBYzMjY1NCcjAQlUSkg/RjlLnaN8iZxGQpWqiISmnk9DRkmcWAHLPTAtOjMpYnt5aDdbGSmPan1+ay08PDNxAgAAAgA2AAACuwMVAAoADgBJALAARViwCS8bsQkWPlmwAEVYsAQvG7EEED5ZsgEJBBESObABL7ICAgorWCHYG/RZsAbQsAEQsAvQsggLBhESObINCQQREjkwMQEzFSMVIzUhJwEzATMRBwJQa2ud/okGAXmh/oTfEQErgqmpZgIG/hYBIRwAAQBb//UCpwMVABsAYQCwAEVYsAEvG7EBFj5ZsABFWLANLxuxDRA+WbABELIECQorWCHYG/RZsgcNARESObAHL7IZAgorWCHYG/RZsgUHGRESObANELAR0LANELITAgorWCHYG/RZsAcQsBvQMDETEyEVIQc2MzIWFRQGIyImJzMWMzI2NTQmIyIHcDIB3v6jFkFKgI+ghnmnBpsKgUFITkpJOwGDAZKEqh2JeXyRfmVjS0Q+TSsAAAIAVv/1AqsDHgATAB8ATgCwAEVYsAAvG7EAFj5ZsABFWLAMLxuxDBA+WbAAELIBAgorWCHYG/RZsgYMABESObAGL7IUAgorWCHYG/RZsAwQshsCCitYIdgb9FkwMQEVIwQHNjMyFhUUBiMiJjU1NDY3AyIGBxUUFjMyNjQmAigR/vQXSHJ2h5+Ei6fezX4zTRFTPz1ORwMegwLbTZF3dJqmlzPQ5AX+biwgIlRVT3xMAAABADoAAAKlAxUABgAyALAARViwBS8bsQUWPlmwAEVYsAIvG7ECED5ZsAUQsgQCCitYIdgb9FmyAAUEERI5MDEBASMBITUhAqX+o6YBXf47AmsCu/1FApOCAAADAE//9QKfAyAAEwAeACgAegCwAEVYsBEvG7ERFj5ZsABFWLAGLxuxBhA+WbIkBhEREjmwJC+23yTvJP8kA122DyQfJC8kA12y/yQBcbQPJB8kAnKyFwIKK1gh2Bv0WbICJBcREjmyDBckERI5sAYQsh0CCitYIdgb9FmwERCyHwIKK1gh2Bv0WTAxARQHFhUUBiAmNTQ2NyY1NDYzMhYDNCYjIgYVFBYyNgMiBhUUFjI2NCYCi3eLoP7woEpAd5d9fpeJTj4/S0x+TIw3Pz9wP0ACQ3Y3O4NqeXlqQmEbN3Zndnb+OjQ6OjQ1OjoB8DUwLjg4XDcAAAIASf/5ApUDIAASAB4AWgCwAEVYsAgvG7EIFj5ZsABFWLAPLxuxDxA+WbICDwgREjmwAi+2DwIfAi8CA12wDxCyEAIKK1gh2Bv0WbACELITAgorWCHYG/RZsAgQshkCCitYIdgb9FkwMQEGIyImNTQ2MzIWFxUQBQc1MjYnMjc1NCYjIgYVFBYB9kVldo2jgYmcA/5zN5aEe14qTzw7TEoBQEGKfnmgpZQ9/mQUAX9inkc8U1BUQ0FOAAEAjwKLAwsDIgADABEAsAIvsgEBCitYIdgb9FkwMQEhNSEDC/2EAnwCi5cAAwCeBEACbgZyAAMADwAbAHIAsABFWLANLxuxDRg+WbAH0LAHL0AJPwdPB18HbwcEXbAC0LACL7Y/Ak8CXwIDXbAA0LAAL0ARDwAfAC8APwBPAF8AbwB/AAhdsAIQsAPQGbADLxiwDRCyEwcKK1gh2Bv0WbAHELIZBworWCHYG/RZMDEBMwcjBzQ2MzIWFRQGIyImNxQWMzI2NTQmIyIGAbG93HKCZEhEY2FGSGRVMyQjMDAjJTIGcrjXRmFeSUdcXkUjMjEkJjI0AAMAHv5KBBEETgApADcARACPALAARViwJi8bsSYYPlmwAEVYsBYvG7EWEj5ZsCYQsCnQsCkvsgADCitYIdgb9FmyCBYmERI5sAgvsg4IFhESObAOL7SQDqAOAl2yNwEKK1gh2Bv0WbIcNw4REjmyIAgmERI5sBYQsjABCitYIdgb9FmwCBCyOwEKK1gh2Bv0WbAmELJCAQorWCHYG/RZMDEBIxYXFRQGBiMiJwYVFBczFhYVFAYGIyImNTQ2NyY1NDcmNTU0NjMyFyEBBgYVFBYzMjY1NCYnIwMUFjMyNjU1NCYiBhUEEZc6AW/DeE9JNHq3yM6N9JfR/15UOHOu8btQRwFv/Tw4PJSDks1obO90jGlniorSigOnVGkZYqZeFSpAUAIBlY9UoWCbelOKKi9KfFJqxQudyhT7+BpdN0pZckxKQQICpVN7elgSV3h4WgAAAgBk/+sEWAROABAAHABhALAARViwCS8bsQkYPlmwAEVYsAwvG7EMGD5ZsABFWLACLxuxAhA+WbAARViwEC8bsRAQPlmyAAIJERI5sgsJAhESObACELIUAQorWCHYG/RZsAkQshoBCitYIdgb9FkwMSUCISICNTUQEjMgEzczAxMjARQWMzITNSYmIyIGA4Js/vLA5OLEAQlsIrBqcbD9dZKH00gckmuGlfH++gEb9A8BCAE9/v/t/eL95AH0r8MBhyS+y+MAAgCxAAAE4wWvABYAHgBhshgfIBESObAYELAE0ACwAEVYsAMvG7EDHD5ZsABFWLABLxuxARA+WbAARViwDy8bsQ8QPlmyFwMBERI5sBcvsgABCitYIdgb9FmyCRcAERI5sAMQsh0BCitYIdgb9FkwMQERIxEhMhYVFAcWExUWFxUjJic1NCYjJSEyNjUQISEBcsECDvD77d4FAkHGOwOMf/6eATminf7P/rkCdP2MBa/SzOVjRf76nI09GDasi3iPnXyEAQAAAQCyAAAFHQWwAAwAaACwAEVYsAQvG7EEHD5ZsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgYCBBESOXywBi8YtGMGcwYCXbQzBkMGAl2ykwYBXbIBAQorWCHYG/RZsgoBBhESOTAxASMRIxEzETMBMwEBIwIjscDAlgH97/3UAlXrAo79cgWw/X4Cgv0+/RIAAAEAkgAABBQGAAAMAFMAsABFWLAELxuxBB4+WbAARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIHCAIREjmwBy+yAAEKK1gh2Bv0WbIKAAcREjkwMQEjESMRMxEzATMBASMBzIC6un4BO9v+hgGu2wH1/gsGAPyOAaz+E/2zAAEAsgAABPoFsAALAEwAsABFWLADLxuxAxw+WbAARViwBy8bsQccPlmwAEVYsAEvG7EBED5ZsABFWLAKLxuxChA+WbIAAwEREjmyBQMBERI5sgkABRESOTAxAREjETMRMwEzAQEjAXLAwAwCY/H9awK97QK1/UsFsP15Aof9O/0VAAABAJIAAAPxBhgADABMALAARViwBC8bsQQePlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAgCERI5sgYIAhESObIKBgAREjkwMQEjESMRMxEzATMBASMBUAS6ugEBivD+KwH/5AHz/g0GGPx1Aa3+Df25AAABAEP/EwPdBXMAKwBmALAARViwCS8bsQkaPlmwAEVYsCIvG7EiED5ZsgIiCRESObAJELAM0LAJELAQ0LAJELITAQorWCHYG/RZsAIQshkBCitYIdgb9FmwIhCwH9CwIhCwJtCwIhCyKQEKK1gh2Bv0WTAxATQmJCcmNTQ2NzUzFRYWFSM0JiMiBhUUFgQWFhUUBgcVIzUmJjUzFBYzMjYDI3n+2lbDy6aVo8a5jXlxhnsBOLBWw6mVut+6mox+ggEqUFhKK2KzgqwQ2dsVwohia1lQQVhQZYhbgqYQ4eETwpRmclsAAAEAMAAAA+8EnQAgAGAAsABFWLAULxuxFBo+WbAARViwBy8bsQcQPlmyDwcUERI5sA8vsg4ECitYIdgb9FmwAdCwBxCyBAEKK1gh2Bv0WbAI0LAUELAY0LAUELIbAQorWCHYG/RZsA8QsB/QMDEBIRcWByEHITUzNjc3JyM1MycmNjMyFhUjNCYjIgYXFyEDHf5wAQU4ApQB/IQKTwkBAaSgBAbLtbfKuWhgXWgEBAGUAfQiy2+YmBfdRiJ5e8nszLdwd4+KewAAAQAWAAAEJQSNABcAigCwAEVYsBcvG7EXGj5ZsABFWLABLxuxARo+WbAARViwDS8bsQ0QPlmyAA0XERI5shANFxESObAQL7IPEAFdsBTQsBQvtA8UHxQCcUAPDxQfFC8UPxRPFF8UbxQHXbAD0LAUELITBAorWCHYG/RZsAbQsBAQsAjQsBAQsg8ECitYIdgb9FmwC9AwMQEBMwEzFSEHFSEVIRUjNSE1ITUhNSEBMwIdATjQ/pv7/sEFAUT+vLn+vAFE/rwBAP6c0AJLAkL9jHkJQnjd3XhLeQJ0AAEAigAAA4UEjQAFADKyAQYHERI5ALAARViwBC8bsQQaPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIQOF/b65AvsD9PwMBI0AAAIAFAAABFMEjQADAAgAPLIFCQoREjmwBRCwAtAAsABFWLACLxuxAho+WbAARViwAC8bsQAQPlmyBQIAERI5sgcBCitYIdgb9FkwMSEhATMDJwcBIQRT+8EBya09Ghn++AJDBI3+3Vxe/TAAAAMAYP/wBFoEnQADABEAHwBeALAARViwDi8bsQ4aPlmwAEVYsAcvG7EHED5ZsgIHDhESOXywAi8YtGACcAICcbRgAnACAl2yAQEKK1gh2Bv0WbAOELIVAQorWCHYG/RZsAcQshwBCitYIdgb9FkwMQEhNSEFEAAjIgARNRAAMzIAFwc0JiMiBhUVFBYzMjY1A1X+HwHhAQX+7Ojl/ucBF+XpARMCt6yblq+wl5ypAfmZbv77/tEBMgEHPgECATT+0P8FxtLWxULD19PHAAEAFAAABFMEjQAIADiyBwkKERI5ALAARViwAi8bsQIaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbIHAgAREjkwMTMjATMBIwEnB9vHAcmtAcnG/sAaGQSN+3MDalxeAAADAD4AAANLBI0AAwAHAAsAY7IEDA0REjmwBBCwAdCwBBCwCdAAsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmyAgEKK1gh2Bv0WbIHCgAREjmwBy+yvwcBXbIEAQorWCHYG/RZsAoQsggBCitYIdgb9FkwMSEhNSEDITUhEyE1IQNL/PMDDUP9dwKJQ/zzAw2YAXuYAUmZAAEAigAABEQEjQAHAD+yAQgJERI5ALAARViwBi8bsQYaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEhIxEhESMRIQREuv25uQO6A/T8DASNAAABAD8AAAPIBI0ADABDsgYNDhESOQCwAEVYsAgvG7EIGj5ZsABFWLADLxuxAxA+WbIBAQorWCHYG/RZsAXQsAgQsgoBCitYIdgb9FmwB9AwMQEBIRUhNQEBNSEVIQECb/62AqP8dwFR/q8DV/2PAUoCOv5fmZABtwG2kJn+XwADAGAAAAUGBI0AEQAXAB4AXACwAEVYsBAvG7EQGj5ZsABFWLAILxuxCBA+WbIPEAgREjmwDy+wANCyCQgQERI5sAkvsAbQsAkQshQBCitYIdgb9FmwDxCyFQEKK1gh2Bv0WbAb0LAUELAc0DAxARYEFRQEBxUjNSYkNTQkNzUzARAFEQYGBTQmJxE2NgMQ5gEQ/u3juen+8gEQ57n+CAE/mqUDNqaYmKYEFg36y838DW5uDfvMzfsNdv21/tgRAnMJl5iZlQn9jgqWAAABAGAAAAS2BI0AFQBcsgAWFxESOQCwAEVYsAMvG7EDGj5ZsABFWLAPLxuxDxo+WbAARViwFC8bsRQaPlmwAEVYsAkvG7EJED5ZshMDCRESObATL7AA0LATELILAQorWCHYG/RZsAjQMDEBJBERMxEGAgcRIxEmAicRMxEQBREzAugBFbkD8tm62fAFugEUugG7MwFrATT+vfP+4hj+3wEfFAEd8gFL/sv+ji0C1AABAHUAAAR+BJ0AIQBcsgciIxESOQCwAEVYsBgvG7EYGj5ZsABFWLAPLxuxDxA+WbAARViwIC8bsSAQPlmwDxCyEQEKK1gh2Bv0WbAO0LAA0LAYELIHAQorWCHYG/RZsBEQsB7QsB/QMDElNjY1NTQmIyIGFRUUFhcVITUzJhE1NAAzMgAVFRAHMxUhAruIf66dnKyNf/4+r7MBG+foARyytf49nR/fzSazwMG3IczfIJ2XnQE6Hu4BI/7c9Rz+y5yXAAEAJv/sBSwEjQAZAGuyFhobERI5ALAARViwAi8bsQIaPlmwAEVYsA4vG7EOED5ZsABFWLAYLxuxGBA+WbACELIAAQorWCHYG/RZsATQsAXQsggCDhESObAIL7AOELIPAQorWCHYG/RZsAgQshUBCitYIdgb9FkwMQEhNSEVIRE2MzIWFRQGIzUyNjU0JiMiBxEjAYr+nAOJ/pSXnNTi5eCNf32AnZa5A/SZmf7XMdDEvr6XbXiDeTL9zgAAAQBg//AEMASdAB4AfbIDHyAREjkAsABFWLALLxuxCxo+WbAARViwAy8bsQMQPlmyDwsDERI5sAsQshIBCitYIdgb9FmyFgsDERI5fLAWLxiyoBYBXbRgFnAWAl2yMBYBcbRgFnAWAnGyFwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsh4DCxESOTAxAQYGIyIAETU0NjYzMhYXIyYmIyIGByEVIRYWMzI2NwQwFPzR4P7xe+eYzPcTuRKNfpmiBgG//kEEoZGHjRQBebvOAScBA16k+YjTu4J0w6+YssJvgwACACcAAAb7BI0AFwAgAHayBCEiERI5sAQQsBjQALAARViwEi8bsRIaPlmwAEVYsAMvG7EDED5ZsABFWLALLxuxCxA+WbASELIFAQorWCHYG/RZsAsQsg4BCitYIdgb9FmyFBIDERI5sBQvshgBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WTAxARQGByERIQMOAgcjNzc2NhMTIREhFhYlESEyNjU0JiMG++bD/iv+Xg8LTZd7OwQuYFEKFAMOASTB4P07ARVyhINzAW6lxwID9P5l7fZ1AaUBBL4BCQIc/koEwS3+WXVjX3AAAgCKAAAHCQSNABIAGwCJsgEcHRESObABELAT0ACwAEVYsAIvG7ECGj5ZsABFWLARLxuxERo+WbAARViwCy8bsQsQPlmwAEVYsA8vG7EPED5ZsgECCxESOXywAS8YsqABAV2yBAILERI5sAQvsAEQsg0BCitYIdgb9FmwBBCyEwEKK1gh2Bv0WbALELIUAQorWCHYG/RZMDEBIREzESEWFhUUBgchESERIxEzAREhMjY1NCYnAUMCSLkBJMHg5sP+K/24ubkDAQEVc4R9bgKKAgP+SgTBpKXHAgHy/g4Ejf2y/ll3YVtxAwAAAQAoAAAFLgSNABUAWrIHFhcREjkAsABFWLACLxuxAho+WbAARViwDC8bsQwQPlmwAEVYsBQvG7EUED5ZsAIQsgABCitYIdgb9FmwBNCwBdCyCAIMERI5sAgvshEBCitYIdgb9FkwMQEhNSEVIRE2MzIWFxEjETQmIyIHESMBi/6dA4n+lJOg1N4Eun1/nZa6A/SZmf7XMcrB/o8BZId5Mv3OAAABAIr+mwRDBI0ACwBPsgMMDRESOQCwAi+wAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsggBCitYIdgb9FmwCdAwMSEhESMRIREzESERMwRD/oG5/n+5Ake5/psBZQSN/AsD9QACAIoAAAQIBI0ADAAVAF6yAxYXERI5sAMQsA3QALAARViwCy8bsQsaPlmwAEVYsAkvG7EJED5ZsAsQsgABCitYIdgb9FmyAwsJERI5sAMvsAkQsg0BCitYIdgb9FmwAxCyEwEKK1gh2Bv0WTAxASERITIWFRQGByERIQEyNjU0JichEQOV/a4BEc7m5MX+KwML/sNzhH1u/t8D9/7gxKWkyAIEjfwLd2FbcQP+WQACAC7+rATnBI0ADwAVAFuyExYXERI5sBMQsAXQALAJL7AARViwBS8bsQUaPlmwAEVYsAsvG7ELED5ZsgABCitYIdgb9FmwB9CwCNCwCRCwDdCwCBCwENCwEdCwBRCyEgEKK1gh2Bv0WTAxNzc2NjcTIREzESMRIREjEyEhESEDAoUpR0cHDgMHj7n8uroBAS4CQv5kDBGYMVb92AGZ/Av+FAFU/q0B6wNc/sj+mQABAB8AAAXrBI0AFQCRsgEWFxESOQCwAEVYsAkvG7EJGj5ZsABFWLANLxuxDRo+WbAARViwES8bsREaPlmwAEVYsAIvG7ECED5ZsABFWLAGLxuxBhA+WbAARViwFC8bsRQQPlmyEAkCERI5fLAQLxiyoBABXbRgEHAQAl2yAAEKK1gh2Bv0WbAE0LITEAAREjmwExCwCNCwEBCwC9AwMQEjESMRIwEjAQEzATMRMxEzATMBASMDxWO6ZP7F6gGG/p7gASxZulkBLOD+nAGI6gH2/goB9v4KAlECPP4DAf3+AwH9/c39pgAAAQBH//AD1ASdACgAfbIkKSoREjkAsABFWLAKLxuxCho+WbAARViwFi8bsRYQPlmwChCyAwEKK1gh2Bv0WbIGChYREjmyJwoWERI5sCcvtB8nLycCXbK/JwFdtN8n7ycCXbIkAQorWCHYG/RZshAkJxESObIcFgoREjmwFhCyHwEKK1gh2Bv0WTAxATQmIyIGFSM0NjMyFhUUBgcWFhUUBiMiJicmNTMWFjMyNjU0JSM1MzYDCIp9boG67bzT7m5ndnH+1VupPXm5BYN5iJL+/52c7wNQVF1YT461qJZWjSkkkluetCwuWZ1WYGBYwQWYBQABAIoAAARhBI0ACQBMsgAKCxESOQCwAEVYsAAvG7EAGj5ZsABFWLAHLxuxBxo+WbAARViwAi8bsQIQPlmwAEVYsAUvG7EFED5ZsgQAAhESObIJAAIREjkwMQEzESMRASMRMxEDqLm5/Zu5uQSN+3MDdPyMBI38jAABAIsAAAQsBI0ADABosgoNDhESOQCwAEVYsAQvG7EEGj5ZsABFWLAILxuxCBo+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgYCBBESOXywBi8YsqAGAV20YAZwBgJdsgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAa5qublkAYXf/jUB6+8B9v4KBI3+AwH9/cX9rgAAAQAnAAAENgSNAA8ATbIEEBEREjkAsABFWLAALxuxABo+WbAARViwAS8bsQEQPlmwAEVYsAgvG7EIED5ZsAAQsgMBCitYIdgb9FmwCBCyCgEKK1gh2Bv0WTAxAREjESEDAgIHIzc3NjY3EwQ2uf5eDw2ksEQEKV5QDRkEjftzA/T+gv6q/uUFpQMHnuICXgAAAQAi/+wECwSNABEAQ7IBEhMREjkAsABFWLACLxuxAho+WbAARViwEC8bsRAaPlmwAEVYsAgvG7EIED5ZsgEIAhESObIMAQorWCHYG/RZMDEBFwEzAQcGBwciJzcXMjY3ATMB9S0BFNX+XiVQqiZQFAZcMUkg/mbWAjB4AtX8RUmRCwEIkwUxOwOfAAABAIr+rATxBI0ACwBFsgkMDRESOQCwAi+wAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAI0LAJ0DAxJTMDIxEhETMRIREzBEStEqX8ULkCR7qY/hQBVASN/AsD9QAAAQA9AAAD3wSNABEARrIEEhMREjkAsABFWLAILxuxCBo+WbAARViwEC8bsRAaPlmwAEVYsAAvG7EAED5Zsg0IABESObANL7IEAQorWCHYG/RZMDEhIxEGIyImJxEzERQWMzI3ETMD37mQo9TeBLl+f52WuQHCMMrBAXD+nYd5MgIxAAEAigAABcYEjQALAE+yBQwNERI5ALAARViwAi8bsQIaPlmwAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmyBAEKK1gh2Bv0WbAI0LAJ0DAxISERMxEhETMRIREzBcb6xLkBiLoBiLkEjfwLA/X8CwP1AAEAiv6sBnUEjQAPAFiyCxARERI5ALACL7AARViwBi8bsQYaPlmwAEVYsAovG7EKGj5ZsABFWLAOLxuxDho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAI0LAJ0LAM0LAN0DAxJTMDIxEhETMRIREzESERMwXHrhKm+s25AYi6AYi6mP4UAVQEjfwLA/X8CwP1AAACAAgAAATWBI0ADQAWAF6yCBcYERI5sAgQsBXQALAARViwBy8bsQcaPlmwAEVYsAMvG7EDED5ZsAcQsgUBCitYIdgb9FmyCgcDERI5sAovsAMQsg4BCitYIdgb9FmwChCyFAEKK1gh2Bv0WTAxARQGByERITUhESEyFhYBMjY1NCYjIREE1uTE/ir+sAIKARaEwmj+UXKEg3P+6wFupMgCA/SZ/kpYo/68dWNfcP5Z//8AigAABWcEjQAmAggAAAAHAcIEFgAAAAIAigAABAgEjQAKABMAULIIFBUREjmwCBCwC9AAsABFWLAFLxuxBRo+WbAARViwAy8bsQMQPlmyCAUDERI5sAgvsAMQsgsBCitYIdgb9FmwCBCyEQEKK1gh2Bv0WTAxARQGByERMxEhMhYBMjY1NCYnIREECOTF/iu5ARHO5v5Qc4R9bv7fAW6kyAIEjf5KxP6Fd2FbcQP+WQABAEv/8AQbBJ0AHgB6sgMfIBESOQCwAEVYsBMvG7ETGj5ZsABFWLAbLxuxGxA+WbIAGxMREjmyAwEKK1gh2Bv0WbIJExsREjl8sAkvGLKgCQFdtGAJcAkCXbIwCQFxtGAJcAkCcbIGAQorWCHYG/RZsBMQsgwBCitYIdgb9FmyDxMbERI5MDEBFhYzMjY3ITUhJiYjIgYHIzY2MzIAFxUUBgYjIiYnAQQUjYeNogf+QQG+BaOYfo0SuRP3zOQBEQV44pXP/hQBeYNvu7mYr8N0grvT/t/0daP5h867AAACAIr/8AYVBJ0AEwAhAIqyBCIjERI5sAQQsBjQALAARViwEC8bsRAaPlmwAEVYsAsvG7ELGj5ZsABFWLADLxuxAxA+WbAARViwCC8bsQgQPlmyDQgLERI5fLANLxi0YA1wDQJxsqANAV20YA1wDQJdsgYBCitYIdgb9FmwEBCyFwEKK1gh2Bv0WbADELIeAQorWCHYG/RZMDEBEAAjIgAnIxEjETMRMzYAMzIAFwc0JiMiBhUVFBYzMjY1BhX+7Ojd/usM2Lm52A4BFNrpARMCt6yblq+wl5ypAiT++/7RARzy/gIEjf4J8QEW/tD/BcbS1sVCw9fTxwAAAgBQAAAD/ASNAA0AFABhshMVFhESObATELAH0ACwAEVYsAcvG7EHGj5ZsABFWLAALxuxABA+WbAARViwCS8bsQkQPlmyEQcAERI5sBEvsgsBCitYIdgb9FmyAQsHERI5sAcQshIBCitYIdgb9FkwMTMBJiY1NDY3IREjESEDExQXIREhIlABInpx3MgB0bn+0P8u5gEb/u/wAg0mnWihsgL7cwHf/iEDMLQEAXwAAQALAAAD5wSNAA0AULIBDg8REjkAsABFWLAILxuxCBo+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASMRIxEjNTMRIRUhETMCh+K54eEC+/2+4gH9/gMB/ZcB+Zn+oAAAAQAf/qwGIgSNABkAqrIIGhsREjkAsABFWLAQLxuxEBo+WbAARViwFC8bsRQaPlmwAEVYsBgvG7EYGj5ZsABFWLANLxuxDRA+WbAARViwCi8bsQoQPlmwAEVYsAUvG7EFED5ZshcKGBESOXywFy8YsqAXAV20YBdwFwJdtGAXcBcCcbIHAQorWCHYG/RZsgAHFxESObAFELIBAQorWCHYG/RZsAcQsAvQsg8XBxESObAXELAS0DAxAQEzESMRIwEjESMRIwEjAQEzATMRMxEzATMEYwEmmad6/sRjumT+xeoBhv6e4AEsWbpZASzgAlr+PP4WAVQB9v4KAfb+CgJRAjz+AwH9/gMB/QABAIv+rAROBI0AEACAsgAREhESOQCwAy+wAEVYsAsvG7ELGj5ZsABFWLAPLxuxDxo+WbAARViwCS8bsQkQPlmwAEVYsAUvG7EFED5Zsg0JCxESOXywDS8YtGANcA0CcbKgDQFdtGANcA0CXbIIAQorWCHYG/RZsgAIDRESObAFELIBAQorWCHYG/RZMDEBATMRIxEjASMRIxEzETMBMwJBAW+eqGn+cWq5uWQBhd8CUv5E/hYBVAH2/goEjf4DAf0AAAEAiwAABOcEjQAUAHiyCxUWERI5ALAARViwBi8bsQYaPlmwAEVYsBMvG7ETGj5ZsABFWLAJLxuxCRA+WbAARViwES8bsREQPlmyABETERI5fLAALxiyoAABXbRgAHAAAl20YABwAAJxsATQsAAQshABCitYIdgb9FmyCBAAERI5sAzQMDEBMzUzFTMBMwEBIwEjFSM1IxEjETMBRFCUPAGE4P40Aevv/nFBlFC5uQKQ5OQB/f3F/a4B9s7O/goEjQAAAQAjAAAFFQSNAA4AfbIADxAREjkAsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIAgYREjl8sAgvGLKgCAFdtGAIcAgCXbRgCHAIAnGyAQEKK1gh2Bv0WbAGELIEAQorWCHYG/RZsgwBCBESOTAxASMRIxEhNSERMwEzAQEjApdpuv6vAgtjAYXg/jQB6+8B9v4KA/WY/gMB/f3F/a4AAgBg/+sFWwSfACMALgCUshQvMBESObAUELAk0ACwAEVYsAsvG7ELGj5ZsABFWLAbLxuxGxo+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgIEGxESObACL7ALELIMAQorWCHYG/RZsAQQshMBCitYIdgb9FmwAhCyJgEKK1gh2Bv0WbIVEyYREjmyIQImERI5sBsQsiwBCitYIdgb9FkwMQUiJwYjIAARNRASMxciBhUVFBYzMjcmAzU0EjMyEhUVEAcWMwEQFzYRNTQmIyIDBVvZpomj/ur+xvTSAX6Q0Mc2MuMBz7W4zbZedv2S4bZiasYFFDs8AUUBKhoBAwEonsPIIejlCLIBRSfrAQT+//E4/tqyEgH9/sx5gQEeOKyj/sP//wANAAAEHASNACYB0gAAAQcB3gBE/t4ACACyAAoBXTAxAAEAJv6sBHEEjQAQAGuyCxESERI5ALAHL7AARViwAS8bsQEaPlmwAEVYsA8vG7EPGj5ZsABFWLAJLxuxCRA+WbAARViwDC8bsQwQPlmyAAEMERI5sgsMARESObIDCwAREjmwCRCyBAEKK1gh2Bv0WbIOAAsREjkwMQEBMwEBNTMRIxEjAQEjAQEzAigBH9z+dQExqKh0/tX+2NwBlv5z2wLaAbP9vv5KAf4WAVQBu/5FAksCQgAAAQAm/qwF8gSNAA8AXLIJEBEREjkAsAIvsABFWLAILxuxCBo+WbAARViwDi8bsQ4aPlmwAEVYsAQvG7EEED5ZsgABCitYIdgb9FmwCBCyBgEKK1gh2Bv0WbAK0LAL0LAAELAM0LAN0DAxJTMDIxEhESE1IRUhESERMwVErhKl/FD+mwOJ/pUCRrqY/hQBVAP0mZn8pAP1AAABAD0AAAPfBI0AFwBPsgQYGRESOQCwAEVYsAsvG7ELGj5ZsABFWLAWLxuxFho+WbAARViwAC8bsQAQPlmyEAsAERI5sBAvsgcBCitYIdgb9FmwBNCwEBCwE9AwMSEjEQYHFSM1JiYnETMRFBYXNTMVNjcRMwPfuWNplbzJA7lnaJVnZbkBwiELxsMKyboBbf6de3gL8O0LIgIxAAABAIoAAAQsBI0AEQBGsgQSExESOQCwAEVYsAAvG7EAGj5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyBAAIERI5sAQvsg0BCitYIdgb9FkwMRMzETYzMhYXESMRNCYjIgcRI4q5mpnU3gS5fn+Ym7kEjf4+McrB/o8BZId5M/3PAAACAAL/8AVrBJ0AHAAkAGmyFSUmERI5sBUQsB7QALAARViwDi8bsQ4aPlmwAEVYsAAvG7EAED5ZsiEOABESObAhL7K/IQFdshIBCitYIdgb9FmwA9CwIRCwCtCwABCyFgEKK1gh2Bv0WbAOELIdAQorWCHYG/RZMDEFIgA1JiY1MxQWFz4CMzIAERUhFBYzMjY3FwYGAyIGByE1NCYDkf/+zqa4mV9mBYfpjvgBEPyuwbdMh1A5PLiWj7UGApmuEAEi8wvGqF53DJPsgf7r/v2CscAfKJIoLwQRwqQboaoAAAIAXv/wBGkEnQAWAB4AXrIIHyAREjmwCBCwF9AAsABFWLAALxuxABo+WbAARViwCC8bsQgQPlmyDQAIERI5sA0vsAAQshEBCitYIdgb9FmwCBCyFwEKK1gh2Bv0WbANELIaAQorWCHYG/RZMDEBMgAXFRQGBiMiABE1ITU0JiMiByc2NhMyNjchFRQWAkf3ASkChOyT+P7wA1LBt5OQOUHAiZGzBv1nrQSd/uDviJn0iQEVAQGCAbHBSJIpL/vtxqEboKwAAAEAR//tA9QEjQAcAG2yGh0eERI5ALAARViwAi8bsQIaPlmwAEVYsAsvG7ELED5ZsAIQsgABCitYIdgb9FmyBAACERI5sgULAhESObAFL7IRCwIREjmwCxCyFAEKK1gh2Bv0WbAFELIaAQorWCHYG/RZshwFGhESOTAxASE1IRcBFhYVFAYjIiYnJjUzFhYzMjY1NCYjIzUCs/28AzgC/qmx0fzXWas8erkFiXOIkoqGgAP0mXb+mxDFi6e+LS5anllkaGpfaqUAAwBg//AEWgSdAA0AFAAbAHOyAxwdERI5sAMQsA7QsAMQsBXQALAARViwCi8bsQoaPlmwAEVYsAMvG7EDED5Zsg4BCitYIdgb9FmyGQoDERI5fLAZLxiyoBkBXbRgGXAZAl20YBlwGQJxshEBCitYIdgb9FmwChCyFQEKK1gh2Bv0WTAxARAAIyIAETUQADMyABcBMjY3IRYWEyIGByEmJgRa/uzo5f7nARfl6QETAv4Ek6gJ/XYKrY2RqwgCigmqAiT++/7RATIBBz4BAgE0/tD//hy8tLDAA3fDrLO8AAABADAAAAPvBJ0AJwCush0oKRESOQCwAEVYsB0vG7EdGj5ZsABFWLAMLxuxDBA+WbIGHQwREjmwBi+yDwYBcbIPBgFdsk8GAXGwAdCwAS9ACR8BLwE/AU8BBF2yAAEBXbICBAorWCHYG/RZsAYQsgcECitYIdgb9FmwDBCyCgEKK1gh2Bv0WbAO0LAP0LAHELAR0LAGELAT0LACELAW0LABELAY0LIhAR0REjmwHRCyJAEKK1gh2Bv0WTAxASEVIRcVIRUhBgchByE1MzY3IzUzNScjNTMnJjYzMhYVIzQmIyIGFwGHAZb+bgMBj/5sCiQClAH8hAo/FJ+lA6KeAgbLtbfKuWhgXWgEAqh5XRB5akeYmBKfeRBdeUDJ7My3cHePigAAAQBC//ADngSdACEAnrIUIiMREjkAsABFWLAVLxuxFRo+WbAARViwCC8bsQgQPlmyIRUIERI5sCEvsg8hAV20ECEgIQJdsgAECitYIdgb9FmwCBCyAwEKK1gh2Bv0WbAAELAL0LAhELAN0LAhELAS0LASL0AJHxIvEj8STxIEXbIAEgFdsg8ECitYIdgb9FmwFRCyGgEKK1gh2Bv0WbASELAc0LAPELAe0DAxASESITI3FwYjIiYnIzUzNSM1MzY2MzIXByYjIAMhFSEVIQMv/mggAQJiaBt2b9P1FJuXl5sW9c9ghxVZef8AIAGY/mQBnAGW/vEclR7azHlteczcH5Uc/vB5bQAABACKAAAHrQSdAAMAEAAeACgAqLIfKSoREjmwHxCwAdCwHxCwBNCwHxCwEdAAsABFWLAnLxuxJxo+WbAARViwJS8bsSUaPlmwAEVYsAcvG7EHGj5ZsABFWLAiLxuxIhA+WbAARViwIC8bsSAQPlmwBxCwDdCwDS+wAtCwAi+0AAIQAgJdsgEDCitYIdgb9FmwDRCyFAMKK1gh2Bv0WbAHELIbAworWCHYG/RZsiEnIBESObImICcREjkwMSUhNSEBNDYgFhUVFAYjIiY1FxQWMzI2NTU0JiMiBhUBIwERIxEzAREzB2790wIt/ZK8ATS9vpeZv6NeV1ReYVNSYf61uP2jubkCXbi9jgIDlbq4m1CYtrecBVlqaVxSWmhnXvy1A2z8lASN/JMDbQAAAgAoAAAEZgSNABYAHwCDsgAgIRESObAY0ACwAEVYsAwvG7EMGj5ZsABFWLACLxuxAhA+WbIWDAIREjmwFi+yAAEKK1gh2Bv0WbAE0LAWELAG0LAWELAL0LALL0AJDwsfCy8LPwsEXbS/C88LAl2yCAEKK1gh2Bv0WbAT0LALELAX0LAMELIeAQorWCHYG/RZMDElIRUjNSM1MzUjNTMRITIWFRQGByEVISUhMjY1NCYjIQKk/v66wMDAwAHPxerjvv7dAQL+/gEVcoOEcP7qtLS0mFmYAlDMqKXLBFnxeGJkegAAAgCM/+wENAYAABAAGwBkshQcHRESObAUELAN0ACwCS+wAEVYsA0vG7ENGD5ZsABFWLAELxuxBBA+WbAARViwBy8bsQcQPlmyBg0EERI5sgsNBBESObANELIUAQorWCHYG/RZsAQQshkBCitYIdgb9FkwMQEUBgYjIicHIxEzETYzMhIRJzQmIyIHERYzMjYENG/JgNFwD6C5cMXJ8bmjjLdQVbSKowISn/yLlYEGAP3Di/7T/v8HtNaq/iyr2AAAAQBc/+wD7wROAB0ASbIAHh8REjkAsABFWLAQLxuxEBg+WbAARViwCC8bsQgQPlmyAAEKK1gh2Bv0WbAIELAD0LAQELAU0LAQELIXAQorWCHYG/RZMDElMjY3Mw4CIyIANTU0NjYzMhYXIyYmIyIGFRUUFgJAY5QIsAV4xG7f/vt225O28QiwCI9oj5udg3haXqhjASr8IJ35htquaYfOvyG8yQACAFv/7AQABgAAEQAcAGSyGh0eERI5sBoQsATQALAHL7AARViwBC8bsQQYPlmwAEVYsA0vG7ENED5ZsABFWLAJLxuxCRA+WbIGBA0REjmyCwQNERI5sA0QshUBCitYIdgb9FmwBBCyGgEKK1gh2Bv0WTAxEzQ2NjMyFxEzESMnBiMiJiYnNxQWMzI3ESYjIgZbcc6Avm+5oQ5vynzLdQG5qIqvUlOsjacCJp/8jYICNPoAeIyM+5gGsdifAfGZ1gACAFv+VgQABE4AGwAmAHyyHycoERI5sB8QsAvQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLALLxuxCxI+WbAARViwGC8bsRgQPlmyBQMYERI5sAsQshIBCitYIdgb9FmyFgMYERI5sBgQsh8BCitYIdgb9FmwAxCyJAEKK1gh2Bv0WTAxEzQSMzIXNzMRBgIjIiYnNxYWMzI2NTUGIyICNRcUFjMyNxEmIyIGW/jGzG8PnQL04FbISDc/n0+Vim/Bwvq5pouvU1OtjqUCJvYBMpSA/A7v/v03MooqMrCoKIEBOPQHsNmhAeud1wD//wBXAAAChgW3AAYAFa0AAAIAjP5gBDIETgAQABsAbrIZHB0REjmwGRCwDdAAsABFWLANLxuxDRg+WbAARViwCi8bsQoYPlmwAEVYsAcvG7EHEj5ZsABFWLAELxuxBBA+WbIGDQQREjmyCw0EERI5sA0QshQBCitYIdgb9FmwBBCyGQEKK1gh2Bv0WTAxARQGBiMiJxEjETMXNjMyEhcHNCYjIgcRFjMyNgQybsiBxXG5nw90ysHuCripj6hUU6uMqgIRnvyLff33Bdp9kf7p6iew25X9+5TfAAACAFv+YAP/BE4ADwAaAGuyGBscERI5sBgQsAPQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLAILxuxCBI+WbAARViwDC8bsQwQPlmyBQMMERI5sgoDDBESObITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMRM0EjMyFzczESMRBiMiAjUXFBYzMjcRJiMiBlv3zMRvDqC5cLrH+rmqjKZWWKKOqgIl9QE0hnL6JgIEeAE19geu35MCEY/fAAIAXf/sA/METgAUABwAYrIIHR4REjmwCBCwFdAAsABFWLAILxuxCBg+WbAARViwAC8bsQAQPlmyGQgAERI5sBkvtL8ZzxkCXbIMAQorWCHYG/RZsAAQshABCitYIdgb9FmwCBCyFQEKK1gh2Bv0WTAxBSIAJyc0NjYzMhIVFSEWFjMyNxcGASIGByE1NCYCceX+3QsBfN2A1ej9JAjCmaB4OYP+7nOYEQIgiRQBF+NOm/WK/v7wdJ3IWn9yA8qglhmDmgACAGD+VgPyBE4AGgAlAHyyIyYnERI5sCMQsAvQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLALLxuxCxI+WbAARViwFy8bsRcQPlmyBQMXERI5sAsQshEBCitYIdgb9FmyFQMXERI5sBcQsh4BCitYIdgb9FmwAxCyIwEKK1gh2Bv0WTAxEzQSMzIXNzMRFAYjIiYnNxYzMjY1NQYjIgI1FxQWMzI3ESYjIgZg6MPKcBCd9eFSr0E3eo+ViW/Avuu6lYivUlWqiZYCJfoBL5N//AXq/y0pikmnnjqAATL6CLXToAHum9AAAQB+/+sFHQXFAB4ATLIMHyAREjkAsABFWLAMLxuxDBw+WbAARViwAy8bsQMQPlmwDBCwENCwDBCyEwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsAMQsB7QMDEBBgAjIiQCJzU0EiQzMgAXIyYmIyICERUUEhYzMjY3BRwY/tvusf7hogGdARuy7QEvGcEYv53A6m7IfaGwGgHO3/78tAFHy0TTAUqz/vrjo6j+y/7+N6H/AJCdqQABAH7/6wUeBcQAIgBtsgwjJBESOQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIQAwwREjmwEC+wDBCyEwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsiIMAxESObAiL7Q/Ik8iAl20DyIfIgJdsh8BCitYIdgb9FkwMSUGBCMiJAInNTQSJDMyBBcjJiYjIgIHBxQSFjMyNjcRITUhBR5D/uOwu/7WqAObARy18QEhIsAeupy17AoBeNOFcrUq/rACD75hcrQBR9It2wFOtuXalYz+3PJGrP72jDowAUabAAIAsgAABREFsAALABUARrIDFhcREjmwAxCwFdAAsABFWLABLxuxARw+WbAARViwAC8bsQAQPlmwARCyDAEKK1gh2Bv0WbAAELINAQorWCHYG/RZMDEzESEyBBIXFRQCBAcDETMyABE1NAAjsgGxwQE4sQSt/sLL6d/qARP+9+gFsKz+xMg+0P7BsQIFEvuLASoBAyT8ASgAAgB+/+sFXwXFABEAIgBGsgQjJBESObAEELAf0ACwAEVYsA0vG7ENHD5ZsABFWLAELxuxBBA+WbANELIWAQorWCHYG/RZsAQQsh8BCitYIdgb9FkwMQEUAgQjIiQCJzU0EiQzMgQSFwc0AiYjIgYGBxUUEhYzMhI1BV+i/uKvq/7hpgKkASGrrQEgowG/bsd9eMZyAXHJecHvAsLO/rC5uQFKyDfNAU+8uf60zAWiAQCPj/6cNaD+/pIBO/8AAAIAfv8EBV8FxQAVACYATbIIJygREjmwCBCwI9AAsABFWLARLxuxERw+WbAARViwCC8bsQgQPlmyAwgRERI5sBEQshoBCitYIdgb9FmwCBCyIwEKK1gh2Bv0WTAxARQCBxcHJQYjIiQCJzU0EiQzMgQSFSc0AiYjIgYGBxUUEhYzMhI1BV+plPqD/sw5PKv+4KQDogEirK4BIaK/bsd9eMdxAXHJecHvAsLU/qxaw3nzDLoBRsY6zAFQvrv+sM4BowEBj5D/nDOg/v6SATv/AAABAKAAAALJBI0ABgAyALAARViwBS8bsQUaPlmwAEVYsAAvG7EAED5ZsgQABRESObAEL7IDAQorWCHYG/RZMDEhIxEFNSUzAsm5/pACCh8DpouoygABAIMAAAQgBKAAGABUsgkZGhESOQCwAEVYsBEvG7ERGj5ZsABFWLAALxuxABA+WbIXAQorWCHYG/RZsALQshYXERESObIDERYREjmwERCyCQEKK1gh2Bv0WbARELAM0DAxISE1ATY3NzQmIyIGFSM0NjYzMhYVFAcBIQQg/IcB/X0KA31mepW5eNJ+u+HF/oYCeIMByXNUNVRsjnVwv2y4mLG0/qwAAQCKAAADhQXEAAcAMrIDCAkREjkAsABFWLAGLxuxBho+WbAARViwBC8bsQQQPlmwBhCyAgEKK1gh2Bv0WTAxATMRIREjESECzLn9vrkCQgXE/jD8DASNAAEAD/6jA94EjQAYAE4AsAsvsABFWLACLxuxAho+WbIBAQorWCHYG/RZsATQsgULAhESObAFL7ALELIQAQorWCHYG/RZsAUQshcBCitYIdgb9FmyGBcFERI5MDEBITUhFQEWFhUUACMiJzcWMzI2NTQmIyM1AuT9dANy/oCy4v7M/8rSNKWxtNe5wDwD9Jl2/mwY9rP5/tpni1jKpaulZwACAD7+tgSgBI0ACgAOAEsAsABFWLAJLxuxCRo+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsgABCitYIdgb9FmwBhCwBdCwBS+wABCwDNCyDQkCERI5MDElMxUjESMRITUBMwEhEQcD28XFuv0dAtbH/TwCChyWl/63AUltBCH8CQL8NQD//wBQAo0CnQW4AwcB1AAAApgAEwCwAEVYsAovG7EKHD5ZsBDQMDEA//8ANgKYArsFrQMHAdgAAAKYABMAsABFWLAJLxuxCRw+WbAN0DAxAP//AFsCjQKnBa0DBwHZAAACmAAQALAARViwAS8bsQEcPlkwMf//AFYCjQKrBbYDBwHaAAACmAATALAARViwAC8bsQAcPlmwFNAwMQD//wA6ApgCpQWtAwcB2wAAApgAEACwAEVYsAUvG7EFHD5ZMDH//wBPAo0CnwW4AwcB3AAAApgAGQCwAEVYsBEvG7ERHD5ZsBfQsBEQsB/QMDEA//8ASQKRApUFuAMHAd0AAAKYABMAsABFWLAILxuxCBw+WbAZ0DAxAAABAGX+oAQFBIwAGwBOALANL7AARViwAS8bsQEaPlmyBAEKK1gh2Bv0WbIHDQEREjmwBy+yGAEKK1gh2Bv0WbIFBxgREjmwDRCyEgEKK1gh2Bv0WbAHELAb0DAxExMhFSEDNjc2EhUUACMiJzcWMzI2NTQmIyIGB4ZmAxT9fjZvlcjx/uDx4K86gtOZv6WHanUiAXQDGKv+dEACAv714e/+4nKLZc+kj7Y6UwAAAQBK/rYD8gSNAAYAJQCwAS+wAEVYsAUvG7EFGj5ZsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITUhA/L9oLoCV/0bA6gEI/qTBT+YAAIAYP/wBm0EnQATAB0AmrIVHh8REjmwFRCwCtAAsABFWLAJLxuxCRo+WbAARViwCy8bsQsaPlmwAEVYsAIvG7ECED5ZsABFWLAALxuxABA+WbALELIMAQorWCHYG/RZsAAQsA/QsA8vsh8PAV2y3w8BXbIQAQorWCHYG/RZsAAQshMBCitYIdgb9FmwAhCyFAEKK1gh2Bv0WbAJELIXAQorWCHYG/RZMDEhIQUiABE1EAAzBSEVIREhFSERIQU3ESciBhUVFBYGbf1j/o7l/ucBF+UBWwKv/ZsCFP3sAmz78erslq+wEAEyAQc+AQIBNBCZ/rKY/okNBwNnCdbFQsPXAAIAgv6pBD8EoQAYACUASwCwFC+wAEVYsAwvG7EMGj5ZsBQQsgABCitYIdgb9FmyBRQMERI5sAUvsgMFDBESObIaAQorWCHYG/RZsAwQsiABCitYIdgb9FkwMQUyNjcGIyICNTQ2NjMyABMVFAIEIyInNxYTMjY3NTQmIyIGFRQWAd+x3BV3t9L/ddKE6wEFApL+86+fdiZ64GmfIqGSf5ijv/TZaQEU4pzsfv7c/vb63P66rjyOMgH8XFKUxcXDq5XJAAACAHj/6wSJBKEACwAZADkAsABFWLAILxuxCBo+WbAARViwAy8bsQMQPlmwCBCyDwEKK1gh2Bv0WbADELIWAQorWCHYG/RZMDEBEAAgAAM1EAAgABMnNCYjIgYHFRQWMzI2NwSJ/uj+Iv7mAQEZAd4BGQG6sp2bsgK2m5qxAgI8/ur+xQE8ARQUARQBPv7E/usNyuLgxTTJ5d3KAP///7T+SwFlBDoABgCbAAD///+0/ksBZQQ6AAYAmwAA//8AmwAAAVUEOgAGAIwAAP////r+WQFaBDoAJgCMAAAABgCjyAr//wCbAAABVQQ6AAYAjAAA//8Ahv6sAWEEOgAmAIwAAAAHAKwDTgAKAAEAiv/sA/kEnQAhAFwAsABFWLAVLxuxFRo+WbAARViwEC8bsRAQPlmwAEVYsB8vG7EfED5ZsgIBCitYIdgb9FmyGR8VERI5sBkvsQgKK1jYG9xZsBkQsArQsBUQsg0BCitYIdgb9FkwMSUWMzI2NTQmIyM1EyYjIgMRIxE2NjMyFhcBFhYVFAYjIicBw1JYYXKIh1TtTmPTBLgBxclrw2X+7qm217V3aLUze2NiVYkBJz7+9f0GAvXS1lVi/rYPo4aszDEA//8AJQIfAg0CtgIGABEAAAACACUAAATkBbAADwAdAGYAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvss8EAV2yLwQBXbKfBAFxsgEBCitYIdgb9FmwEdCwABCyEgEKK1gh2Bv0WbAFELIbAQorWCHYG/RZsAQQsBzQMDEzESM1MxEhMgQSFxUUAgQHEyERMzISNzU0AicjESHHoqIBm74BJJ8Bn/7ZxEf+5sne9wHp1uABGgKalwJ/qP7KyV3O/sqmAgKa/gMBEvld+AETAv4fAAACACUAAATkBbAADwAdAGYAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvss8EAV2yLwQBXbKfBAFxsgEBCitYIdgb9FmwEdCwABCyEgEKK1gh2Bv0WbAFELIbAQorWCHYG/RZsAQQsBzQMDEzESM1MxEhMgQSFxUUAgQHEyERMzISNzU0AicjESHHoqIBm74BJJ8Bn/7ZxEf+5sne9wHp1uABGgKalwJ/qP7KyV3O/sqmAgKa/gMBEvld+AETAv4fAAABAAAAAAP9BgAAGQBqALAXL7AARViwBC8bsQQYPlmwAEVYsBAvG7EQED5ZsABFWLAILxuxCBA+WbIvFwFdsg8XAV2yFRAXERI5sBUvshIBCitYIdgb9FmwAdCyAhAEERI5sAQQsgwBCitYIdgb9FmwFRCwGNAwMQEhETYzIBMRIxEmJiMiBgcRIxEjNTM1MxUhAnz+53vFAVcDuQFpb1qIJrmqqrkBGQTS/uWX/n39NQLMdXBgTvz9BNKXl5cAAQAxAAAElwWwAA8ATACwAEVYsAovG7EKHD5ZsABFWLACLxuxAhA+WbIPCgIREjmwDy+yAAEKK1gh2Bv0WbAE0LAPELAG0LAKELIIAQorWCHYG/RZsAzQMDEBIxEjESM1MxEhNSEVIREzA6rnv9bW/i0EZv4s5wM3/MkDN5cBRJ6e/rwAAf/0/+wCcAVAAB0AcwCwAEVYsAEvG7EBGD5ZsABFWLARLxuxERA+WbABELAA0LAAL7ABELIEAQorWCHYG/RZsAEQsAXQsAUvsgAFAV2yCAEKK1gh2Bv0WbARELIMAQorWCHYG/RZsAgQsBXQsAUQsBjQsAQQsBnQsAEQsBzQMDEBETMVIxUzFSMRFBYzMjcVBiMiJjURIzUzNSM1MxEBh8rK6ek2QSA4SUV8ftraxcUFQP76j7qX/rJBQQyWFJaKAU6Xuo8BBv//ABwAAAUdBzQCJgAlAAABBwBEATABNgAUALAARViwBC8bsQQcPlmxDAj0MDH//wAcAAAFHQc0AiYAJQAAAQcAdQG/ATYAFACwAEVYsAUvG7EFHD5ZsQ0I9DAx//8AHAAABR0HNgImACUAAAEHAJ0AyQE2ABQAsABFWLAELxuxBBw+WbEPBvQwMf//ABwAAAUdByICJgAlAAABBwCkAMUBOgAUALAARViwBS8bsQUcPlmxDgT0MDH//wAcAAAFHQb7AiYAJQAAAQcAagD5ATYAFwCwAEVYsAQvG7EEHD5ZsREE9LAb0DAxAP//ABwAAAUdB5ECJgAlAAABBwCiAVABQQAXALAARViwBC8bsQQcPlmxDgb0sBjQMDEA//8AHAAABR0HlAImACUAAAAHAd8BWgEi//8Ad/5EBNgFxAImACcAAAAHAHkB0v/3//8AqQAABEYHQAImACkAAAEHAEQA+wFCABQAsABFWLAGLxuxBhw+WbENCPQwMf//AKkAAARGB0ACJgApAAABBwB1AYoBQgAUALAARViwBi8bsQYcPlmxDgj0MDH//wCpAAAERgdCAiYAKQAAAQcAnQCUAUIAFACwAEVYsAYvG7EGHD5ZsRAG9DAx//8AqQAABEYHBwImACkAAAEHAGoAxAFCABcAsABFWLAGLxuxBhw+WbESBPSwG9AwMQD////gAAABgQdAAiYALQAAAQcARP+nAUIAFACwAEVYsAIvG7ECHD5ZsQUI9DAx//8AsAAAAlEHQAImAC0AAAEHAHUANQFCABQAsABFWLADLxuxAxw+WbEGCPQwMf///+kAAAJGB0ICJgAtAAABBwCd/0ABQgAUALAARViwAi8bsQIcPlmxCAb0MDH////WAAACXwcHAiYALQAAAQcAav9wAUIAFwCwAEVYsAIvG7ECHD5ZsQoE9LAU0DAxAP//AKkAAAUIByICJgAyAAABBwCkAPsBOgAUALAARViwBi8bsQYcPlmxDQT0MDH//wB2/+wFCQc2AiYAMwAAAQcARAFSATgAFACwAEVYsA0vG7ENHD5ZsSEI9DAx//8Adv/sBQkHNgImADMAAAEHAHUB4QE4ABQAsABFWLANLxuxDRw+WbEiCPQwMf//AHb/7AUJBzgCJgAzAAABBwCdAOsBOAAUALAARViwDS8bsQ0cPlmxIgb0MDH//wB2/+wFCQckAiYAMwAAAQcApADnATwAFACwAEVYsA0vG7ENHD5ZsSME9DAx//8Adv/sBQkG/QImADMAAAEHAGoBGwE4ABcAsABFWLANLxuxDRw+WbEnBPSwMNAwMQD//wCM/+wEqgc0AiYAOQAAAQcARAErATYAFACwAEVYsAovG7EKHD5ZsRQI9DAx//8AjP/sBKoHNAImADkAAAEHAHUBugE2ABQAsABFWLASLxuxEhw+WbEVCPQwMf//AIz/7ASqBzYCJgA5AAABBwCdAMQBNgAUALAARViwCi8bsQocPlmxFwb0MDH//wCM/+wEqgb7AiYAOQAAAQcAagD0ATYAFwCwAEVYsAovG7EKHD5ZsRkE9LAj0DAxAP//AA8AAAS7BzQCJgA9AAABBwB1AYgBNgAUALAARViwAS8bsQEcPlmxCwj0MDH//wBt/+wD6gX+AiYARQAAAQcARADVAAAAFACwAEVYsBcvG7EXGD5ZsSoJ9DAx//8Abf/sA+oF/gImAEUAAAEHAHUBZAAAABQAsABFWLAXLxuxFxg+WbErCfQwMf//AG3/7APqBgACJgBFAAABBgCdbgAAFACwAEVYsBcvG7EXGD5ZsSsB9DAx//8Abf/sA+oF7AImAEUAAAEGAKRqBAAUALAARViwFy8bsRcYPlmxLAH0MDH//wBt/+wD6gXFAiYARQAAAQcAagCeAAAAFwCwAEVYsBcvG7EXGD5ZsTAB9LA50DAxAP//AG3/7APqBlsCJgBFAAABBwCiAPUACwAXALAARViwFy8bsRcYPlmxLAT0sDbQMDEA//8Abf/sA+oGXwImAEUAAAAHAd8A///t//8AXP5EA+wETgImAEcAAAAHAHkBP//3//8AXf/sA/MF/gImAEkAAAEHAEQAxQAAABQAsABFWLAILxuxCBg+WbEfCfQwMf//AF3/7APzBf4CJgBJAAABBwB1AVQAAAAUALAARViwCC8bsQgYPlmxIAn0MDH//wBd/+wD8wYAAiYASQAAAQYAnV4AABQAsABFWLAILxuxCBg+WbEgAfQwMf//AF3/7APzBcUCJgBJAAABBwBqAI4AAAAXALAARViwCC8bsQgYPlmxJQH0sC7QMDEA////xgAAAWcF/QImAIwAAAEGAESN/wAUALAARViwAi8bsQIYPlmxBQn0MDH//wCWAAACNwX9AiYAjAAAAQYAdRv/ABQAsABFWLADLxuxAxg+WbEGCfQwMf///88AAAIsBf8CJgCMAAABBwCd/yb//wAUALAARViwAi8bsQIYPlmxCAH0MDH///+8AAACRQXEAiYAjAAAAQcAav9W//8AFwCwAEVYsAIvG7ECGD5ZsQsB9LAU0DAxAP//AIwAAAPfBewCJgBSAAABBgCkYQQAFACwAEVYsAMvG7EDGD5ZsRUB9DAx//8AW//sBDQF/gImAFMAAAEHAEQAzwAAABQAsABFWLAELxuxBBg+WbEdCfQwMf//AFv/7AQ0Bf4CJgBTAAABBwB1AV4AAAAUALAARViwBC8bsQQYPlmxHgn0MDH//wBb/+wENAYAAiYAUwAAAQYAnWgAABQAsABFWLAELxuxBBg+WbEeAfQwMf//AFv/7AQ0BewCJgBTAAABBgCkZAQAFACwAEVYsAQvG7EEGD5ZsR8B9DAx//8AW//sBDQFxQImAFMAAAEHAGoAmAAAABcAsABFWLAELxuxBBg+WbEjAfSwLNAwMQD//wCI/+wD3AX+AiYAWQAAAQcARADHAAAAFACwAEVYsAcvG7EHGD5ZsRIJ9DAx//8AiP/sA9wF/gImAFkAAAEHAHUBVgAAABQAsABFWLANLxuxDRg+WbETCfQwMf//AIj/7APcBgACJgBZAAABBgCdYAAAFACwAEVYsAcvG7EHGD5ZsRUB9DAx//8AiP/sA9wFxQImAFkAAAEHAGoAkAAAABcAsABFWLAHLxuxBxg+WbEYAfSwIdAwMQD//wAW/ksDsAX+AiYAXQAAAQcAdQEbAAAAFACwAEVYsAEvG7EBGD5ZsRIJ9DAx//8AFv5LA7AFxQImAF0AAAEGAGpVAAAXALAARViwDy8bsQ8YPlmxFwH0sCDQMDEA//8AHAAABR0G7gImACUAAAEHAHAAxwE+ABMAsABFWLAELxuxBBw+WbAM3DAxAP//AG3/7APqBbgCJgBFAAABBgBwbAgAEwCwAEVYsBcvG7EXGD5ZsCrcMDEA//8AHAAABR0HDgImACUAAAEHAKAA9AE3ABMAsABFWLAELxuxBBw+WbAN3DAxAP//AG3/7APqBdgCJgBFAAABBwCgAJkAAQATALAARViwFy8bsRcYPlmwK9wwMQAAAgAc/k8FHQWwABYAGQBnALAARViwFi8bsRYcPlmwAEVYsBQvG7EUED5ZsABFWLABLxuxARA+WbAARViwDC8bsQwSPlmyBwMKK1gh2Bv0WbABELAR0LARL7IXFBYREjmwFy+yEwEKK1gh2Bv0WbIZFhQREjkwMQEBIwcGFRQzMjcXBiMiJjU0NwMhAyMBAyEDAvACLSY6cU4wNA1GWllnqYf9nonGAiyjAe/4BbD6UC1bVkgaeSxoVpBsAXP+hAWw/GoCqQAAAgBt/k8D6gROAC0ANwCQALAARViwFy8bsRcYPlmwAEVYsAQvG7EEED5ZsABFWLAeLxuxHhA+WbAARViwKS8bsSkSPlmwHhCwANCwAC+yAgQXERI5sgsXBBESObALL7AXELIPAQorWCHYG/RZshILFxESObApELIkAworWCHYG/RZsAQQsi4BCitYIdgb9FmwCxCyMwEKK1gh2Bv0WTAxJSYnBiMiJjU0JDMzNTQmIyIGFSM0NjYzMhYXERQXFSMHBhUUMzI3FwYjIiY1NCcyNjc1IyAVFBYDJA8HgbOgzQEB6bR0cWOGunPFdrvUBCYhOnFOMDQNRlpZZ4hXnCOR/qx0ByZFhrWLqbtVYXNkR1GXWLuk/g6VWBAtW1ZIGnksaFaQ8FpI3sdXYgD//wB3/+wE2AdVAiYAJwAAAQcAdQHGAVcAFACwAEVYsAsvG7ELHD5ZsR8I9DAx//8AXP/sA+wF/gImAEcAAAEHAHUBMwAAABQAsABFWLAQLxuxEBg+WbEgCfQwMf//AHf/7ATYB1cCJgAnAAABBwCdANABVwAUALAARViwCy8bsQscPlmxHwb0MDH//wBc/+wD7AYAAiYARwAAAQYAnT0AABQAsABFWLAQLxuxEBg+WbEgAfQwMf//AHf/7ATYBxkCJgAnAAABBwChAa4BVwAUALAARViwCy8bsQscPlmxIwT0MDH//wBc/+wD7AXCAiYARwAAAQcAoQEbAAAAFACwAEVYsBAvG7EQGD5ZsSQB9DAx//8Ad//sBNgHVwImACcAAAEHAJ4A5gFYABQAsABFWLALLxuxCxw+WbEhBvQwMf//AFz/7APsBgACJgBHAAABBgCeUwEAFACwAEVYsBAvG7EQGD5ZsSIB9DAx//8AqQAABMYHQgImACgAAAEHAJ4AnwFDABQAsABFWLABLxuxARw+WbEbBvQwMf//AF//7AUrBgIAJgBIAAABBwGiA9QFEwBIALLwHwFysh8fAV2ynx8BXbIfHwFxtM8f3x8CcbLfHwFysl8fAXKyTx8BcbLPHwFdtE8fXx8CXbJgHwFdsuAfAXGy4B8BXTAx//8AqQAABEYG+gImACkAAAEHAHAAkgFKABMAsABFWLAGLxuxBhw+WbAN3DAxAP//AF3/7APzBbgCJgBJAAABBgBwXAgAEwCwAEVYsAgvG7EIGD5ZsB/cMDEA//8AqQAABEYHGgImACkAAAEHAKAAvwFDABMAsABFWLAGLxuxBhw+WbAP3DAxAP//AF3/7APzBdgCJgBJAAABBwCgAIkAAQATALAARViwCC8bsQgYPlmwIdwwMQD//wCpAAAERgcEAiYAKQAAAQcAoQFyAUIAFACwAEVYsAYvG7EGHD5ZsRME9DAx//8AXf/sA/MFwgImAEkAAAEHAKEBPAAAABQAsABFWLAILxuxCBg+WbElAfQwMQABAKn+TwRGBbAAGwB2ALAARViwFi8bsRYcPlmwAEVYsBUvG7EVED5ZsABFWLAPLxuxDxI+WbAARViwBC8bsQQQPlmyGhUWERI5sBovsgEBCitYIdgb9FmwFRCyAgEKK1gh2Bv0WbAPELIKAworWCHYG/RZsBYQshkBCitYIdgb9FkwMQEhESEVIwcGFRQzMjcXBiMiJjU0NyERIRUhESED4P2JAt1JOnFOMDQNRlpZZ5v9XQOT/S0CdwKh/fydLVtWSBp5LGhWimkFsJ7+LAAAAgBd/mgD8wROACUALQB6ALAARViwGi8bsRoYPlmwAEVYsA0vG7ENEj5ZsABFWLASLxuxEhA+WbAE0LANELIIAworWCHYG/RZsioSGhESObAqL7S/Ks8qAl2yHgEKK1gh2Bv0WbASELIiAQorWCHYG/RZsiUSGhESObAaELImAQorWCHYG/RZMDElBgczBwYVFDMyNxcGIyImNTQ3JgA1NTQ2NjMyEhEVIRYWMzI2NwEiBgchNSYmA+VHcwE6cU4wNA1GWllnYtr+9XvdgdPq/SMEs4piiDP+wnCYEgIeCIi9bjYtW1ZIGnksaFZsWgQBIe8hof2P/ur+/U2gxVBCAqGjkw6NmwD//wCpAAAERgdCAiYAKQAAAQcAngCqAUMAFACwAEVYsAYvG7EGHD5ZsREG9DAx//8AXf/sA/MGAAImAEkAAAEGAJ50AQAUALAARViwCC8bsQgYPlmxIgH0MDH//wB6/+wE3AdXAiYAKwAAAQcAnQDIAVcAFACwAEVYsAsvG7ELHD5ZsSIG9DAx//8AYP5WA/IGAAImAEsAAAEGAJ1VAAAUALAARViwAy8bsQMYPlmxJwH0MDH//wB6/+wE3AcvAiYAKwAAAQcAoADzAVgAEwCwAEVYsAsvG7ELHD5ZsCLcMDEA//8AYP5WA/IF2AImAEsAAAEHAKAAgAABABMAsABFWLADLxuxAxg+WbAn3DAxAP//AHr/7ATcBxkCJgArAAABBwChAaYBVwAUALAARViwCy8bsQscPlmxJwT0MDH//wBg/lYD8gXCAiYASwAAAQcAoQEzAAAAFACwAEVYsAMvG7EDGD5ZsSwB9DAx//8Aev3/BNwFxAImACsAAAAHAaIBo/6g//8AYP5WA/IGkwImAEsAAAEHAbkBKwBYABMAsABFWLADLxuxAxg+WbAq3DAxAP//AKkAAAUIB0ICJgAsAAABBwCdAPEBQgAUALAARViwBy8bsQccPlmxEAb0MDH//wCMAAAD3wdBAiYATAAAAQcAnQAdAUEACQCwES+wFNwwMQD///+3AAACegcuAiYALQAAAQcApP88AUYAFACwAEVYsAMvG7EDHD5ZsQcE9DAx////nQAAAmAF6gImAIwAAAEHAKT/IgACABQAsABFWLADLxuxAxg+WbEHAfQwMf///7YAAAKABvoCJgAtAAABBwBw/z4BSgATALAARViwAi8bsQIcPlmwBdwwMQD///+cAAACZgW2AiYAjAAAAQcAcP8kAAYAEwCwAEVYsAIvG7ECGD5ZsAXcMDEA////7AAAAkMHGgImAC0AAAEHAKD/awFDABMAsABFWLACLxuxAhw+WbAH3DAxAP///9IAAAIpBdcCJgCMAAABBwCg/1EAAAATALAARViwAi8bsQIYPlmwB9wwMQD//wAY/lgBeAWwAiYALQAAAAYAo+YJ////+/5PAWgFxAImAE0AAAAGAKPJAP//AKoAAAGFBwQCJgAtAAABBwChAB0BQgAUALAARViwAi8bsQIcPlmxCwT0MDH//wC3/+wF+QWwACYALQAAAAcALgItAAD//wCN/ksDSgXEACYATQAAAAcATgHxAAD//wA1/+wEggc1AiYALgAAAQcAnQF8ATUAFACwAEVYsAAvG7EAHD5ZsRQG9DAx////tP5LAjkF2AImAJsAAAEHAJ3/M//YABQAsABFWLANLxuxDRg+WbESBPQwMf//AKn9/wUFBbACJgAvAAAABwGiAZT+oP//AI39/wQMBgACJgBPAAAABwGiARH+oP//AKEAAAQcBy8CJgAwAAABBwB1ACYBMQAUALAARViwBS8bsQUcPlmxCAj0MDH//wCTAAACNAeUAiYAUAAAAQcAdQAYAZYAFACwAEVYsAMvG7EDHj5ZsQYJ9DAx//8Aqf3/BBwFsAImADAAAAAHAaIBbP6g//8AV/3/AVUGAAImAFAAAAAHAaL/+/6g//8AqQAABBwFsQImADAAAAEHAaIB1QTCABAAsABFWLAKLxuxChw+WTAx//8AnAAAAq0GAgAmAFAAAAEHAaIBVgUTAFAAsh8IAV2ynwgBXbQfCC8IAnGyrwgBcbQvCD8IAnKy3wgBcrZfCG8IfwgDcrTPCN8IAnGyTwgBcbLPCAFdtE8IXwgCXbJgCAFdsvAIAXIwMf//AKkAAAQcBbACJgAwAAAABwChAbz9xf//AJwAAAKgBgAAJgBQAAAABwChATj9tv//AKkAAAUIBzQCJgAyAAABBwB1AfUBNgAUALAARViwCC8bsQgcPlmxDAj0MDH//wCMAAAD3wX+AiYAUgAAAQcAdQFbAAAAFACwAEVYsAMvG7EDGD5ZsRQJ9DAx//8Aqf3/BQgFsAImADIAAAAHAaIB0P6g//8AjP3/A98ETgImAFIAAAAHAaIBM/6g//8AqQAABQgHNgImADIAAAEHAJ4BFQE3ABQAsABFWLAGLxuxBhw+WbEPBvQwMf//AIwAAAPfBgACJgBSAAABBgCeewEAFACwAEVYsAMvG7EDGD5ZsRYB9DAx////vAAAA98GBAImAFIAAAEHAaL/YAUVAAYAsBcvMDH//wB2/+wFCQbwAiYAMwAAAQcAcADpAUAAEwCwAEVYsA0vG7ENHD5ZsCHcMDEA//8AW//sBDQFuAImAFMAAAEGAHBmCAATALAARViwBC8bsQQYPlmwHdwwMQD//wB2/+wFCQcQAiYAMwAAAQcAoAEWATkAEwCwAEVYsA0vG7ENHD5ZsCLcMDEA//8AW//sBDQF2AImAFMAAAEHAKAAkwABABMAsABFWLAELxuxBBg+WbAf3DAxAP//AHb/7AUJBzcCJgAzAAABBwClAWsBOAAXALAARViwDS8bsQ0cPlmxJgj0sCLQMDEA//8AW//sBDQF/wImAFMAAAEHAKUA6AAAABcAsABFWLAELxuxBBg+WbEiCfSwHtAwMQD//wCoAAAEyQc0AiYANgAAAQcAdQGAATYAFACwAEVYsAQvG7EEHD5ZsRoI9DAx//8AjAAAAtIF/gImAFYAAAEHAHUAtgAAABQAsABFWLALLxuxCxg+WbEQCfQwMf//AKj9/wTJBbACJgA2AAAABwGiAWP+oP//AFP9/wKXBE4CJgBWAAAABwGi//f+oP//AKgAAATJBzYCJgA2AAABBwCeAKABNwAUALAARViwBC8bsQQcPlmxHQb0MDH//wBjAAACzQYAAiYAVgAAAQYAntcBABQAsABFWLALLxuxCxg+WbESAfQwMf//AFD/7ARyBzYCJgA3AAABBwB1AY0BOAAUALAARViwBi8bsQYcPlmxKQj0MDH//wBf/+wDuwX+AiYAVwAAAQcAdQFRAAAAFACwAEVYsAkvG7EJGD5ZsSkJ9DAx//8AUP/sBHIHOAImADcAAAEHAJ0AlwE4ABQAsABFWLAGLxuxBhw+WbEpBvQwMf//AF//7AO7BgACJgBXAAABBgCdWwAAFACwAEVYsAkvG7EJGD5ZsSkB9DAx//8AUP5NBHIFxAImADcAAAAHAHkBnwAA//8AX/5FA7sETgImAFcAAAAHAHkBXf/4//8AUP3/BHIFxAImADcAAAAHAaIBdf6g//8AX/3/A7sETgImAFcAAAAHAaIBM/6g//8AUP/sBHIHOAImADcAAAEHAJ4ArQE5ABQAsABFWLAGLxuxBhw+WbErBvQwMf//AF//7AO7BgACJgBXAAABBgCecQEAFACwAEVYsAkvG7EJGD5ZsSsB9DAx//8AMf3/BJcFsAImADgAAAAHAaIBZv6g//8ACf3/AlYFQAImAFgAAAAHAaIAxf6g//8AMf5NBJcFsAImADgAAAAHAHkBkAAA//8ACf5NApkFQAImAFgAAAAHAHkA7wAA//8AMQAABJcHNgImADgAAAEHAJ4AogE3ABQAsABFWLAGLxuxBhw+WbENBvQwMf//AAn/7ALsBnkAJgBYAAAABwGiAZUFiv//AIz/7ASqByICJgA5AAABBwCkAMABOgAUALAARViwEi8bsRIcPlmxFgT0MDH//wCI/+wD3AXsAiYAWQAAAQYApFwEABQAsABFWLANLxuxDRg+WbEUAfQwMf//AIz/7ASqBu4CJgA5AAABBwBwAMIBPgATALAARViwEi8bsRIcPlmwE9wwMQD//wCI/+wD3AW4AiYAWQAAAQYAcF4IABMAsABFWLAHLxuxBxg+WbAS3DAxAP//AIz/7ASqBw4CJgA5AAABBwCgAO8BNwATALAARViwCi8bsQocPlmwFtwwMQD//wCI/+wD3AXYAiYAWQAAAQcAoACLAAEAEwCwAEVYsAcvG7EHGD5ZsBTcMDEA//8AjP/sBKoHkQImADkAAAEHAKIBSwFBABcAsABFWLAKLxuxChw+WbEWBvSwINAwMQD//wCI/+wD3AZbAiYAWQAAAQcAogDnAAsAFwCwAEVYsAcvG7EHGD5ZsRQE9LAe0DAxAP//AIz/7ASqBzUCJgA5AAABBwClAUQBNgAXALAARViwEi8bsRIcPlmxFQj0sBnQMDEA//8AiP/sBAwF/wImAFkAAAEHAKUA4AAAABcAsABFWLANLxuxDRg+WbETCfSwF9AwMQAAAQCM/nsEqgWwACAAUwCwAEVYsBgvG7EYHD5ZsABFWLANLxuxDRI+WbAARViwEy8bsRMQPlmwGBCwINCyBBMgERI5sA0QsggDCitYIdgb9FmwExCyHAEKK1gh2Bv0WTAxAREGBgcGFRQzMjcXBiMiJjU0NwciACcRMxEUFjMyNjURBKoBioObTjA0DUZaWWdPFu/+5AK+rqGjrQWw/CGU4jtyYEgaeSxoVmFTAQEC4gPg/Caer66eA9sAAQCI/k8D5gQ6AB8AbQCwAEVYsBcvG7EXGD5ZsABFWLAdLxuxHRg+WbAARViwHy8bsR8QPlmwAEVYsBIvG7ESED5ZsABFWLAKLxuxChI+WbIFAworWCHYG/RZsB8QsA/QsA8vshASHRESObASELIaAQorWCHYG/RZMDEhBwYVFDMyNxcGIyImNTQ3JwYjIiYnETMRFDMyNxEzEQPSOnFOMDQNRlpZZ6YEbNGttQG5yNRGuS1bVkgaeSxoVo9qZX/JxQLA/UX2ngMT+8b//wA9AAAG7Qc2AiYAOwAAAQcAnQHFATYAFACwAEVYsAMvG7EDHD5ZsRcG9DAx//8AKwAABdMGAAImAFsAAAEHAJ0BJAAAABQAsABFWLAMLxuxDBg+WbEPAfQwMf//AA8AAAS7BzYCJgA9AAABBwCdAJIBNgAUALAARViwAS8bsQEcPlmxCwb0MDH//wAW/ksDsAYAAiYAXQAAAQYAnSUAABQAsABFWLAPLxuxDxg+WbEUAfQwMf//AA8AAAS7BvsCJgA9AAABBwBqAMIBNgAXALAARViwCC8bsQgcPlmxEAT0sBnQMDEA//8AVgAABHoHNAImAD4AAAEHAHUBhwE2ABQAsABFWLAHLxuxBxw+WbEMCPQwMf//AFgAAAOzBf4CJgBeAAABBwB1ASEAAAAUALAARViwBy8bsQcYPlmxDAn0MDH//wBWAAAEegb4AiYAPgAAAQcAoQFvATYAFACwAEVYsAcvG7EHHD5ZsREE9DAx//8AWAAAA7MFwgImAF4AAAEHAKEBCQAAABQAsABFWLAHLxuxBxg+WbERAfQwMf//AFYAAAR6BzYCJgA+AAABBwCeAKcBNwAUALAARViwBy8bsQccPlmxDwb0MDH//wBYAAADswYAAiYAXgAAAQYAnkEBABQAsABFWLAHLxuxBxg+WbEPAfQwMf////IAAAdXB0ACJgCBAAABBwB1AskBQgAUALAARViwBi8bsQYcPlmxFQj0MDH//wBO/+wGfAX/AiYAhgAAAQcAdQJ6AAEAFACwAEVYsB0vG7EdGD5ZsUAJ9DAx//8Adv+jBR0HfgImAIMAAAEHAHUB6QGAABQAsABFWLAQLxuxEBw+WbEsCPQwMf//AFv/egQ0Bf4CJgCJAAABBwB1ATcAAAAUALAARViwBC8bsQQYPlmxKQn0MDH///++AAAEHwSNAiYBvQAAAQcB3v8v/3gALACyHxgBcbTfGO8YAnG0HxgvGAJdsh8YAXKyTxgBcbTvGP8YAl2yXxgBXTAx////vgAABB8EjQImAb0AAAEHAd7/L/94ADYAtO8X/xcCXbJPFwFxsh8XAXKy3xcBcrJvFwFytN8X7xcCcbIfFwFxsl8XAV20HxcvFwJdMDH//wAoAAAD/QSNAiYBzQAAAQYB3kXgAA0AsgMKAV2ysAoBXTAxAP//ABMAAARwBhwCJgG6AAABBwBEANUAHgAUALAARViwBC8bsQQaPlmxDAb0MDH//wATAAAEcAYcAiYBugAAAQcAdQFkAB4AFACwAEVYsAUvG7EFGj5ZsQ0G9DAx//8AEwAABHAGHgImAboAAAEGAJ1uHgAUALAARViwBC8bsQQaPlmxDwT0MDH//wATAAAEcAYKAiYBugAAAQYApGoiABQAsABFWLAFLxuxBRo+WbEOAvQwMf//ABMAAARwBeMCJgG6AAABBwBqAJ4AHgAXALAARViwBC8bsQQaPlmxEgL0sBvQMDEA//8AEwAABHAGeQImAboAAAEHAKIA9QApABcAsABFWLAELxuxBBo+WbEOBvSwGNAwMQD//wATAAAEcAZ8AiYBugAAAAcB3wD/AAr//wBg/koEMASdAiYBvAAAAAcAeQF0//3//wCKAAADrgYcAiYBvgAAAQcARACoAB4AFACwAEVYsAYvG7EGGj5ZsQ0G9DAx//8AigAAA64GHAImAb4AAAEHAHUBNwAeABQAsABFWLAHLxuxBxo+WbEOBvQwMf//AIoAAAOuBh4CJgG+AAABBgCdQR4AFACwAEVYsAYvG7EGGj5ZsRAE9DAx//8AigAAA64F4wImAb4AAAEGAGpxHgAXALAARViwBi8bsQYaPlmxEwL0sBzQMDEA////vgAAAV8GHAImAcIAAAEGAESFHgAUALAARViwAi8bsQIaPlmxBQb0MDH//wCOAAACLwYcAiYBwgAAAQYAdRMeABQAsABFWLADLxuxAxo+WbEGBvQwMf///8cAAAIkBh4CJgHCAAABBwCd/x4AHgAUALAARViwAi8bsQIaPlmxCAT0MDH///+0AAACPQXjAiYBwgAAAQcAav9OAB4AFwCwAEVYsAIvG7ECGj5ZsQsC9LAU0DAxAP//AIoAAARYBgoCJgHHAAABBwCkAJUAIgAUALAARViwBi8bsQYaPlmxDQL0MDH//wBg//AEWgYcAiYByAAAAQcARADuAB4AFACwAEVYsAovG7EKGj5ZsR0G9DAx//8AYP/wBFoGHAImAcgAAAEHAHUBfQAeABQAsABFWLAKLxuxCho+WbEeBvQwMf//AGD/8ARaBh4CJgHIAAABBwCdAIcAHgAUALAARViwCi8bsQoaPlmxIAT0MDH//wBg//AEWgYKAiYByAAAAQcApACDACIAFACwAEVYsAovG7EKGj5ZsR8C9DAx//8AYP/wBFoF4wImAcgAAAEHAGoAtwAeABcAsABFWLAKLxuxCho+WbEjAvSwLNAwMQD//wB0//AECgYcAiYBzgAAAQcARADPAB4AFACwAEVYsAkvG7EJGj5ZsRMG9DAx//8AdP/wBAoGHAImAc4AAAEHAHUBXgAeABQAsABFWLARLxuxERo+WbEUBvQwMf//AHT/8AQKBh4CJgHOAAABBgCdaB4AFACwAEVYsAkvG7EJGj5ZsRYE9DAx//8AdP/wBAoF4wImAc4AAAEHAGoAmAAeABcAsABFWLAJLxuxCRo+WbEZAvSwItAwMQD//wANAAAEHAYcAiYB0gAAAQcAdQEzAB4AFACwAEVYsAEvG7EBGj5ZsQsG9DAx//8AEwAABHAF1gImAboAAAEGAHBsJgATALAARViwBC8bsQQaPlmwDNwwMQD//wATAAAEcAX2AiYBugAAAQcAoACZAB8AFACwAEVYsAQvG7EEGj5ZsQ4I9DAxAAIAE/5PBHAEjQAWABkAZwCwAEVYsAAvG7EAGj5ZsABFWLAULxuxFBA+WbAARViwAS8bsQEQPlmwAEVYsAwvG7EMEj5ZsgcDCitYIdgb9FmwARCwEdCwES+yFxQAERI5sBcvshMBCitYIdgb9FmyGQAUERI5MDEBASMHBhUUMzI3FwYjIiY1NDcDIQMjAQMhAwKYAdgmOnFOMDQNRlpZZ7Bo/fhuvQHfeAGRxwSN+3MtW1ZIGnksaFaUbAEK/ukEjf0hAf0A//8AYP/wBDAGHAImAbwAAAEHAHUBaQAeABQAsABFWLALLxuxCxo+WbEfBvQwMf//AGD/8AQwBh4CJgG8AAABBgCdcx4AFACwAEVYsAsvG7ELGj5ZsSEE9DAx//8AYP/wBDAF4AImAbwAAAEHAKEBUQAeABQAsABFWLALLxuxCxo+WbEjAvQwMf//AGD/8AQwBh4CJgG8AAABBwCeAIkAHwAUALAARViwCy8bsQsaPlmxIQb0MDH//wCKAAAEHwYeAiYBvQAAAQYAnjIfABQAsABFWLABLxuxARo+WbEaBvQwMf//AIoAAAOuBdYCJgG+AAABBgBwPyYAEwCwAEVYsAYvG7EGGj5ZsA3cMDEA//8AigAAA64F9gImAb4AAAEGAKBsHwAUALAARViwBi8bsQYaPlmxDwj0MDH//wCKAAADrgXgAiYBvgAAAQcAoQEfAB4AFACwAEVYsAYvG7EGGj5ZsRMC9DAxAAEAiv5PA64EjQAbAHgAsABFWLAWLxuxFho+WbAARViwFC8bsRQQPlmwAEVYsA8vG7EPEj5ZsBQQsBvQsBsvsh8bAV2y3xsBXbIAAQorWCHYG/RZsBQQsgIBCitYIdgb9FmwFBCwBdCwDxCyCgMKK1gh2Bv0WbAWELIZAQorWCHYG/RZMDEBIREhFSMHBhUUMzI3FwYjIiY1NDchESEVIREhA1f97AJrPTpxTjA0DUZaWWeb/coDHv2bAhQCDv6Jly1bVkgaeSxoVoppBI2Z/rIA//8AigAAA64GHgImAb4AAAEGAJ5XHwAUALAARViwBi8bsQYaPlmxEQb0MDH//wBj//AENQYeAiYBwAAAAQYAnXEeABQAsABFWLAKLxuxCho+WbEgBPQwMf//AGP/8AQ1BfYCJgHAAAABBwCgAJwAHwAUALAARViwCi8bsQoaPlmxIAj0MDH//wBj//AENQXgAiYBwAAAAQcAoQFPAB4AFACwAEVYsAovG7EKGj5ZsSUC9DAx//8AY/38BDUEnQImAcAAAAAHAaIBT/6d//8AigAABFgGHgImAcEAAAEHAJ0AkAAeABQAsABFWLAHLxuxBxo+WbEQBPQwMf///5UAAAJYBgoCJgHCAAABBwCk/xoAIgAUALAARViwAy8bsQMaPlmxBwL0MDH///+UAAACXgXWAiYBwgAAAQcAcP8cACYAEwCwAEVYsAIvG7ECGj5ZsAXcMDEA////ygAAAiEF9gImAcIAAAEHAKD/SQAfABQAsABFWLACLxuxAho+WbEHCPQwMf//AAb+TwFmBI0CJgHCAAAABgCj1AD//wCJAAABZAXgAiYBwgAAAQYAofweABQAsABFWLACLxuxAho+WbELAvQwMf//ACv/8AQNBh4CJgHDAAABBwCdAQcAHgAUALAARViwAC8bsQAaPlmxFAT0MDH//wCK/fwEVwSNAiYBxAAAAAcBogEU/p3//wCCAAADiwYcAiYBxQAAAQYAdQceABQAsABFWLAFLxuxBRo+WbEIBvQwMf//AIr9/AOLBI0CJgHFAAAABwGiARD+nf//AIoAAAOLBI4CJgHFAAABBwGiAX4DnwAQALAARViwCi8bsQoaPlkwMf//AIoAAAOLBI0CJgHFAAAABwChAWb9N///AIoAAARYBhwCJgHHAAABBwB1AY8AHgAUALAARViwCC8bsQgaPlmxDAb0MDH//wCK/fwEWASNAiYBxwAAAAcBogFs/p3//wCKAAAEWAYeAiYBxwAAAQcAngCvAB8AFACwAEVYsAYvG7EGGj5ZsQ8G9DAx//8AYP/wBFoF1gImAcgAAAEHAHAAhQAmABMAsABFWLAKLxuxCho+WbAd3DAxAP//AGD/8ARaBfYCJgHIAAABBwCgALIAHwAUALAARViwCi8bsQoaPlmxHwj0MDH//wBg//AEWgYdAiYByAAAAQcApQEHAB4AFwCwAEVYsAovG7EKGj5ZsR4G9LAi0DAxAP//AIoAAAQlBhwCJgHLAAABBwB1AScAHgAUALAARViwBS8bsQUaPlmxGQb0MDH//wCK/fwEJQSNAiYBywAAAAcBogEN/p3//wCKAAAEJQYeAiYBywAAAQYAnkcfABQAsABFWLAELxuxBBo+WbEcBvQwMf//AEP/8APdBhwCJgHMAAABBwB1AT4AHgAUALAARViwCS8bsQkaPlmxKAb0MDH//wBD//AD3QYeAiYBzAAAAQYAnUgeABQAsABFWLAJLxuxCRo+WbEqBPQwMf//AEP+TQPdBJ0CJgHMAAAABwB5AVMAAP//AEP/8APdBh4CJgHMAAABBgCeXh8AFACwAEVYsAkvG7EJGj5ZsSoG9DAx//8AKP38A/0EjQImAc0AAAAHAaIBFP6d//8AKAAAA/0GHgImAc0AAAEGAJ5RHwAUALAARViwBi8bsQYaPlmxDQb0MDH//wAo/k8D/QSNAiYBzQAAAAcAeQE+AAL//wB0//AECgYKAiYBzgAAAQYApGQiABQAsABFWLARLxuxERo+WbEVAvQwMf//AHT/8AQKBdYCJgHOAAABBgBwZiYAEwCwAEVYsAkvG7EJGj5ZsBPcMDEA//8AdP/wBAoF9gImAc4AAAEHAKAAkwAfABQAsABFWLAJLxuxCRo+WbEVCPQwMf//AHT/8AQKBnkCJgHOAAABBwCiAO8AKQAXALAARViwCS8bsQkaPlmxFQb0sB/QMDEA//8AdP/wBBQGHQImAc4AAAEHAKUA6AAeABcAsABFWLARLxuxERo+WbEUBvSwGNAwMQAAAQB0/nQECgSNACAAUwCwAEVYsBgvG7EYGj5ZsABFWLAOLxuxDhI+WbAARViwEy8bsRMQPlmwGBCwINCyBRMgERI5sA4QsgkDCitYIdgb9FmwExCyHAEKK1gh2Bv0WTAxAREUBgcHBhUUMzI3FwYjIiY1NDciJicRMxEUFjMyNjURBAp4bzJsTjA0DUZaWWdazfkEt4+Fg48EjfzzerowKFtSSBp5LGhWaFbOuAMX/PR5gX97AwwA//8AMQAABfEGHgImAdAAAAEHAJ0BOwAeABQAsABFWLADLxuxAxo+WbEXBPQwMf//AA0AAAQcBh4CJgHSAAABBgCdPR4AFACwAEVYsAgvG7EIGj5ZsQ0E9DAx//8ADQAABBwF4wImAdIAAAEGAGptHgAXALAARViwCC8bsQgaPlmxEAL0sBnQMDEA//8ARwAAA+AGHAImAdMAAAEHAHUBMwAeABQAsABFWLAILxuxCBo+WbEMBvQwMf//AEcAAAPgBeACJgHTAAABBwChARsAHgAUALAARViwBy8bsQcaPlmxEQL0MDH//wBHAAAD4AYeAiYB0wAAAQYAnlMfABQAsABFWLAHLxuxBxo+WbEPBvQwMf//ABwAAAUdBj8CJgAlAAAABgCtBAD////wAAAEqgY/ACYAKWQAAAcArf85AAD////+AAAFbAZBACYALGQAAAcArf9HAAL//wAEAAAB2wZAACYALWQAAAcArf9NAAH////6/+wFHQY/ACYAMxQAAAcArf9DAAD///94AAAFHwY/ACYAPWQAAAcArf7BAAD////9AAAE3wY/ACYAuRQAAAcArf9GAAD///+b//QCrQZ0AiYAwgAAAQcArv8q/+wAHQCwAEVYsAwvG7EMGD5ZsRgB9LAP0LAYELAh0DAxAP//ABwAAAUdBbACBgAlAAD//wCpAAAEiAWwAgYAJgAA//8AqQAABEYFsAIGACkAAP//AFYAAAR6BbACBgA+AAD//wCpAAAFCAWwAgYALAAA//8AtwAAAXcFsAIGAC0AAP//AKkAAAUFBbACBgAvAAD//wCpAAAGUgWwAgYAMQAA//8AqQAABQgFsAIGADIAAP//AHb/7AUJBcQCBgAzAAD//wCpAAAEwAWwAgYANAAA//8AMQAABJcFsAIGADgAAP//AA8AAAS7BbACBgA9AAD//wA5AAAEzgWwAgYAPAAA////1gAAAl8HBwImAC0AAAEHAGr/cAFCABcAsABFWLACLxuxAhw+WbELBPSwFNAwMQD//wAPAAAEuwb7AiYAPQAAAQcAagDCATYAFwCwAEVYsAgvG7EIHD5ZsRAE9LAZ0DAxAP//AGT/6wR3BjoCJgC6AAABBwCtAXX/+wAUALAARViwEy8bsRMYPlmxJAH0MDH//wBj/+wD7AY5AiYAvgAAAQcArQEr//oAFACwAEVYsBUvG7EVGD5ZsSgB9DAx//8Akf5hA/AGOgImAMAAAAEHAK0BRv/7ABQAsABFWLADLxuxAxg+WbEVAfQwMf//AMP/9AJLBiUCJgDCAAABBgCtKuYAFACwAEVYsAwvG7EMGD5ZsQ8B9DAx//8Aj//sA/YGdAImAMoAAAEGAK4h7AAdALAARViwAC8bsQAYPlmxHQH0sBXQsB0QsCfQMDEA//8AmgAABD8EOgIGAI0AAP//AFv/7AQ0BE4CBgBTAAD//wCa/mAD7gQ6AgYAdgAA//8AIQAAA7oEOgIGAFoAAP//ACkAAAPKBDoCBgBcAAD////m//QCbwWxAiYAwgAAAQYAaoDsABcAsABFWLAMLxuxDBg+WbEUAfSwHdAwMQD//wCP/+wD9gWxAiYAygAAAQYAanfsABcAsABFWLAALxuxABg+WbEaAfSwI9AwMQD//wBb/+wENAY6AiYAUwAAAQcArQFD//sAFACwAEVYsAQvG7EEGD5ZsR4B9DAx//8Aj//sA/YGJQImAMoAAAEHAK0BIv/mABQAsABFWLAALxuxABg+WbEVAfQwMf//AHr/7AYZBiICJgDNAAABBwCtAlP/4wAUALAARViwAC8bsQAYPlmxJgH0MDH//wCpAAAERgcHAiYAKQAAAQcAagDEAUIAFwCwAEVYsAYvG7EGHD5ZsRME9LAc0DAxAP//ALEAAAQwB0ACJgCwAAABBwB1AZABQgAUALAARViwBC8bsQQcPlmxCAj0MDEAAQBQ/+wEcgXEACYAYbIAJygREjkAsABFWLAGLxuxBhw+WbAARViwGi8bsRoQPlmwBhCwC9CwBhCyDgEKK1gh2Bv0WbImGgYREjmwJhCyFAEKK1gh2Bv0WbAaELAf0LAaELIiAQorWCHYG/RZMDEBJiY1NCQzMhYWFSM0JiMiBhUUFgQWFhUUBCMiJCY1MxQWMzI2NCYCVvfhARPcluuBwaiZjp+XAWvNY/7s55b+/I3Bw6OYopYCiUfPmKzhdMx5hJd9b1l7Znukb7HVc8h/hJl81nUA//8AtwAAAXcFsAIGAC0AAP///9YAAAJfBwcCJgAtAAABBwBq/3ABQgAXALAARViwAi8bsQIcPlmxCwT0sBTQMDEA//8ANf/sA8wFsAIGAC4AAP//ALIAAAUdBbACBgHjAAD//wCpAAAFBQcuAiYALwAAAQcAdQF7ATAAFACwAEVYsAUvG7EFHD5ZsQ4I9DAx//8ATf/rBMsHGgImAN0AAAEHAKAA2gFDABMAsABFWLARLxuxERw+WbAV3DAxAP//ABwAAAUdBbACBgAlAAD//wCpAAAEiAWwAgYAJgAA//8AsQAABDAFsAIGALAAAP//AKkAAARGBbACBgApAAD//wCxAAAE/wcaAiYA2wAAAQcAoAExAUMAEwCwAEVYsAgvG7EIHD5ZsA3cMDEA//8AqQAABlIFsAIGADEAAP//AKkAAAUIBbACBgAsAAD//wB2/+wFCQXEAgYAMwAA//8AsgAABQEFsAIGALUAAP//AKkAAATABbACBgA0AAD//wB3/+wE2AXEAgYAJwAA//8AMQAABJcFsAIGADgAAP//ADkAAATOBbACBgA8AAD//wBt/+wD6gROAgYARQAA//8AXf/sA/METgIGAEkAAP//AJwAAAQBBcQCJgDvAAABBwCgAKL/7QATALAARViwCC8bsQgYPlmwDdwwMQD//wBb/+wENAROAgYAUwAA//8AjP5gBB4ETgIGAFQAAAABAFz/7APsBE4AHQBJshAeHxESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsAgQsAPQsBAQsBTQsBAQshcBCitYIdgb9FkwMSUyNjczDgIjIgARNTQ2NjMyFhcjJiYjIgYVFRQWAj5jlAivBXbFbt3++3TZlLbxCK8Ij2mNm5qDeFpdqGQBJwEAH572iNquaYfLwCO7ygD//wAW/ksDsAQ6AgYAXQAA//8AKQAAA8oEOgIGAFwAAP//AF3/7APzBcUCJgBJAAABBwBqAI4AAAAXALAARViwCC8bsQgYPlmxJQH0sC7QMDEA//8AmgAAA0cF6gImAOsAAAEHAHUAzf/sABQAsABFWLAELxuxBBg+WbEICfQwMf//AF//7AO7BE4CBgBXAAD//wCNAAABaAXEAgYATQAA////vAAAAkUFxAImAIwAAAEHAGr/Vv//ABcAsABFWLACLxuxAhg+WbELAfSwFNAwMQD///+//ksBWQXEAgYATgAA//8AnAAABD8F6QImAPAAAAEHAHUBO//rABQAsABFWLAELxuxBBg+WbEPCfQwMf//ABb+SwOwBdgCJgBdAAABBgCgUAEAEwCwAEVYsA8vG7EPGD5ZsBPcMDEA//8APQAABu0HNAImADsAAAEHAEQCLAE2ABQAsABFWLADLxuxAxw+WbEUCPQwMf//ACsAAAXTBf4CJgBbAAABBwBEAYsAAAAUALAARViwCy8bsQsYPlmxDgn0MDH//wA9AAAG7Qc0AiYAOwAAAQcAdQK7ATYAFACwAEVYsAQvG7EEHD5ZsRUI9DAx//8AKwAABdMF/gImAFsAAAEHAHUCGgAAABQAsABFWLAMLxuxDBg+WbEPCfQwMf//AD0AAAbtBvsCJgA7AAABBwBqAfUBNgAXALAARViwAy8bsQMcPlmxGgT0sCPQMDEA//8AKwAABdMFxQImAFsAAAEHAGoBVAAAABcAsABFWLALLxuxCxg+WbEUAfSwHdAwMQD//wAPAAAEuwc0AiYAPQAAAQcARAD5ATYAFACwAEVYsAgvG7EIHD5ZsQoI9DAx//8AFv5LA7AF/gImAF0AAAEHAEQAjAAAABQAsABFWLAPLxuxDxg+WbERCfQwMf//AGcEIQD9BgACBgALAAD//wCIBBICIwYAAgYABgAA//8AoP/1A4oFsAAmAAUAAAAHAAUCDwAA////tP5LAj8F2AImAJsAAAEHAJ7/Sf/ZABQAsABFWLANLxuxDRg+WbETAfQwMf//ADAEFgFHBgACBgFtAAD//wCpAAAGUgc0AiYAMQAAAQcAdQKZATYAFACwAEVYsAIvG7ECHD5ZsREI9DAx//8AiwAABngF/gImAFEAAAEHAHUCrQAAABQAsABFWLADLxuxAxg+WbEgCfQwMf//ABz+awUdBbACJgAlAAAABwCmAX8AAP//AG3+awPqBE4CJgBFAAAABwCmAMcAAP//AKkAAARGB0ACJgApAAABBwBEAPsBQgAUALAARViwBi8bsQYcPlmxDQj0MDH//wCxAAAE/wdAAiYA2wAAAQcARAFtAUIAFACwAEVYsAgvG7EIHD5ZsQsI9DAx//8AXf/sA/MF/gImAEkAAAEHAEQAxQAAABQAsABFWLAILxuxCBg+WbEfCfQwMf//AJwAAAQBBeoCJgDvAAABBwBEAN7/7AAUALAARViwCC8bsQgYPlmxCwn0MDH//wBaAAAFIQWwAgYAuAAA//8AX/4oBUMEOgIGAMwAAP//ABYAAATdBugCJgEYAAABBwCrBDkA+gAXALAARViwDy8bsQ8cPlmxEQj0sBXQMDEA////+wAABAsFwQImARkAAAEHAKsD1P/TABcAsABFWLARLxuxERg+WbETCfSwF9AwMQD//wBb/ksIQAROACYAUwAAAAcAXQSQAAD//wB2/ksJMAXEACYAMwAAAAcAXQWAAAD//wBQ/lEEagXEAiYA2gAAAAcBsAGc/7j//wBY/lIDrARNAiYA7gAAAAcBsAFD/7n//wB3/lEE2AXEAiYAJwAAAAcBsAHl/7j//wBc/lED7AROAiYARwAAAAcBsAFS/7j//wAPAAAEuwWwAgYAPQAA//8ALv5gA98EOgIGALwAAP//ALcAAAF3BbACBgAtAAD//wAbAAAHNQcaAiYA2QAAAQcAoAH4AUMAEwCwAEVYsA0vG7ENHD5ZsBncMDEA//8AFQAABgQFxAImAO0AAAEHAKABX//tABMAsABFWLANLxuxDRg+WbAZ3DAxAP//ALcAAAF3BbACBgAtAAD//wAcAAAFHQcOAiYAJQAAAQcAoAD0ATcAEwCwAEVYsAQvG7EEHD5ZsA7cMDEA//8Abf/sA+oF2AImAEUAAAEHAKAAmQABABMAsABFWLAXLxuxFxg+WbAs3DAxAP//ABwAAAUdBvsCJgAlAAABBwBqAPkBNgAUALAARViwBC8bsQQcPlmxEgT0MDH//wBt/+wD6gXFAiYARQAAAQcAagCeAAAAFwCwAEVYsBcvG7EXGD5ZsTAB9LA50DAxAP////IAAAdXBbACBgCBAAD//wBO/+wGfAROAgYAhgAA//8AqQAABEYHGgImACkAAAEHAKAAvwFDABMAsABFWLAGLxuxBhw+WbAP3DAxAP//AF3/7APzBdgCJgBJAAABBwCgAIkAAQATALAARViwCC8bsQgYPlmwIdwwMQD//wBd/+wFEgbZAiYBRQAAAQcAagDTARQAFwCwAEVYsAAvG7EAHD5ZsScE9LAw0DAxAP//AGL/7APpBE8CBgCcAAD//wBi/+wD6QXGAiYAnAAAAQcAagCHAAEAFwCwAEVYsAAvG7EAGD5ZsSQB9LAt0DAxAP//ABsAAAc1BwcCJgDZAAABBwBqAf0BQgAXALAARViwDS8bsQ0cPlmxHQT0sCbQMDEA//8AFQAABgQFsQImAO0AAAEHAGoBZP/sABcAsABFWLANLxuxDRg+WbEdAfSwJtAwMQD//wBQ/+wEagccAiYA2gAAAQcAagC3AVcAFwCwAEVYsAsvG7ELHD5ZsTAE9LA50DAxAP//AFj/7QOsBcUCJgDuAAABBgBqXgAAFwCwAEVYsAovG7EKGD5ZsS4B9LA30DAxAP//ALEAAAT/BvoCJgDbAAABBwBwAQQBSgATALAARViwCC8bsQgcPlmwC9wwMQD//wCcAAAEAQWkAiYA7wAAAQYAcHX0ABMAsABFWLAHLxuxBxg+WbAL3DAxAP//ALEAAAT/BwcCJgDbAAABBwBqATYBQgAXALAARViwCC8bsQgcPlmxEQT0sBrQMDEA//8AnAAABAEFsQImAO8AAAEHAGoAp//sABcAsABFWLAILxuxCBg+WbERAfSwGtAwMQD//wB2/+wFCQb9AiYAMwAAAQcAagEbATgAFwCwAEVYsA0vG7ENHD5ZsScE9LAw0DAxAP//AFv/7AQ0BcUCJgBTAAABBwBqAJgAAAAXALAARViwBC8bsQQYPlmxIwH0sCzQMDEA//8AZ//sBPoFxAIGARYAAP//AFv/7AQ0BE4CBgEXAAD//wBn/+wE+gcCAiYBFgAAAQcAagEOAT0AFwCwAEVYsA0vG7ENHD5ZsScE9LAw0DAxAP//AFv/7AQ0BccCJgEXAAABBwBqAIgAAgAXALAARViwBC8bsQQYPlmxJAH0sC3QMDEA//8Ak//sBPQHHQImAOYAAAEHAGoBDQFYABcAsABFWLATLxuxExw+WbEnBPSwMNAwMQD//wBk/+wD4AXFAiYA/gAAAQYAanwAABcAsABFWLAILxuxCBg+WbEnAfSwMNAwMQD//wBN/+sEywb6AiYA3QAAAQcAcACtAUoAEwCwAEVYsBEvG7ERHD5ZsBPcMDEA//8AFv5LA7AFuAImAF0AAAEGAHAjCAATALAARViwDi8bsQ4YPlmwEdwwMQD//wBN/+sEywcHAiYA3QAAAQcAagDfAUIAFwCwAEVYsBEvG7ERHD5ZsRkE9LAi0DAxAP//ABb+SwOwBcUCJgBdAAABBgBqVQAAFwCwAEVYsA8vG7EPGD5ZsRcB9LAg0DAxAP//AE3/6wTLB0ECJgDdAAABBwClAS8BQgAXALAARViwAS8bsQEcPlmxFAj0sBjQMDEA//8AFv5LA9EF/wImAF0AAAEHAKUApQAAABcAsABFWLAPLxuxDxg+WbEWCfSwEtAwMQD//wCWAAAEyAcHAiYA4AAAAQcAagEJAUIAFwCwAEVYsAsvG7ELHD5ZsRoE9LAj0DAxAP//AGcAAAO9BbECJgD4AAABBgBqZOwAFwCwAEVYsAkvG7EJGD5ZsRgB9LAh0DAxAP//ALIAAAYwBwcAJgDlDwAAJwAtBLkAAAEHAGoB0wFCABcAsABFWLAKLxuxChw+WbEfBPSwKNAwMQD//wCdAAAFfwWxACYA/QAAACcAjAQqAAABBwBqAW3/7AAXALAARViwCi8bsQoYPlmxHwH0sCjQMDEA//8AOf5LBQ4FsAImADwAAAAHAa8DpwAA//8AKf5LBBwEOgImAFwAAAAHAa8CtQAA//8AX//sA/AGAAIGAEgAAP//AC/+SwWsBbACJgDcAAAABwGvBEUAAP//ACz+SwS7BDoCJgDxAAAABwGvA1QAAP//ABz+ogUdBbACJgAlAAAABwCsBQIAAP//AG3+ogPqBE4CJgBFAAAABwCsBEoAAP//ABwAAAUdB7oCJgAlAAABBwCqBO4BRgAUALAARViwBC8bsQQcPlmxCwj0MDH//wBt/+wD6gaEAiYARQAAAQcAqgSTABAAFACwAEVYsBcvG7EXGD5ZsSkB9DAx//8AHAAABR0HwwImACUAAAEHAbcAwwEuABcAsABFWLAFLxuxBRw+WbEODPSwFNAwMQD//wBt/+wEwAaOAiYARQAAAQYBt2j5ABcAsABFWLAXLxuxFxg+WbEsCPSwMtAwMQD//wAcAAAFHQe/AiYAJQAAAQcBtgDHAT0AFwCwAEVYsAQvG7EEHD5ZsQ4M9LAT0DAxAP///8r/7APqBokCJgBFAAABBgG2bAcAFwCwAEVYsBcvG7EXGD5ZsSwI9LAx0DAxAP//ABwAAAUdB+oCJgAlAAABBwG1AMgBGwAXALAARViwBS8bsQUcPlmxDAz0sCDQMDEA//8Abf/sBFkGtQImAEUAAAEGAbVt5gAXALAARViwFy8bsRcYPlmxKgj0sDDQMDEA//8AHAAABR0H2gImACUAAAEHAbQAxwEGABcAsABFWLAFLxuxBRw+WbEMDPSwFdAwMQD//wBt/+wD6galAiYARQAAAQYBtGzRABcAsABFWLAXLxuxFxg+WbEqCPSwM9AwMQD//wAc/qIFHQc2AiYAJQAAACcAnQDJATYBBwCsBQIAAAAUALAARViwBC8bsQQcPlmxDwb0MDH//wBt/qID6gYAAiYARQAAACYAnW4AAQcArARKAAAAFACwAEVYsBcvG7EXGD5ZsS0B9DAx//8AHAAABR0HtwImACUAAAEHAbMA6gEtABcAsABFWLAELxuxBBw+WbEOB/SwG9AwMQD//wBt/+wD6gaCAiYARQAAAQcBswCP//gAFwCwAEVYsBcvG7EXGD5ZsSwE9LA50DAxAP//ABwAAAUdB7cCJgAlAAABBwG4AOoBLQAXALAARViwBC8bsQQcPlmxDgf0sBzQMDEA//8Abf/sA+oGggImAEUAAAEHAbgAj//4ABcAsABFWLAXLxuxFxg+WbEsBPSwOtAwMQD//wAcAAAFHQhAAiYAJQAAAQcBsgDuAT0AFwCwAEVYsAQvG7EEHD5ZsQ4H9LAn0DAxAP//AG3/7APqBwoCJgBFAAABBwGyAJMABwAXALAARViwFy8bsRcYPlmxLAT0sEXQMDEA//8AHAAABR0IFQImACUAAAEHAbEA7gFFABcAsABFWLAELxuxBBw+WbEOB/SwHNAwMQD//wBt/+wD6gbfAiYARQAAAQcBsQCTAA8AFwCwAEVYsBcvG7EXGD5ZsSwE9LA60DAxAP//ABz+ogUdBw4CJgAlAAAAJwCgAPQBNwEHAKwFAgAAABMAsABFWLAELxuxBBw+WbAO3DAxAP//AG3+ogPqBdgCJgBFAAAAJwCgAJkAAQEHAKwESgAAABMAsABFWLAXLxuxFxg+WbAs3DAxAP//AKn+ogRGBbACJgApAAAABwCsBMAAAP//AF3+ogPzBE4CJgBJAAAABwCsBIwAAP//AKkAAARGB8YCJgApAAABBwCqBLkBUgAUALAARViwBi8bsQYcPlmxDAj0MDH//wBd/+wD8waEAiYASQAAAQcAqgSDABAAFACwAEVYsAgvG7EIGD5ZsR4B9DAx//8AqQAABEYHLgImACkAAAEHAKQAkAFGABQAsABFWLAGLxuxBhw+WbEPBPQwMf//AF3/7APzBewCJgBJAAABBgCkWgQAFACwAEVYsAgvG7EIGD5ZsSEB9DAx//8AqQAABOYHzwImACkAAAEHAbcAjgE6ABcAsABFWLAHLxuxBxw+WbEPDPSwFdAwMQD//wBd/+wEsAaOAiYASQAAAQYBt1j5ABcAsABFWLAILxuxCBg+WbEhCPSwJ9AwMQD////wAAAERgfLAiYAKQAAAQcBtgCSAUkAFwCwAEVYsAYvG7EGHD5ZsQ8M9LAU0DAxAP///7r/7APzBokCJgBJAAABBgG2XAcAFwCwAEVYsAgvG7EIGD5ZsSEI9LAm0DAxAP//AKkAAAR/B/YCJgApAAABBwG1AJMBJwAXALAARViwBi8bsQYcPlmxDwz0sBPQMDEA//8AXf/sBEkGtQImAEkAAAEGAbVd5gAXALAARViwCC8bsQgYPlmxHwj0sCXQMDEA//8AqQAABEYH5gImACkAAAEHAbQAkgESABcAsABFWLAGLxuxBhw+WbEPDPSwFtAwMQD//wBd/+wD8walAiYASQAAAQYBtFzRABcAsABFWLAILxuxCBg+WbEhCPSwKNAwMQD//wCp/qIERgdCAiYAKQAAACcAnQCUAUIBBwCsBMAAAAAUALAARViwBi8bsQYcPlmxEAb0MDH//wBd/qID8wYAAiYASQAAACYAnV4AAQcArASMAAAAFACwAEVYsAgvG7EIGD5ZsSAB9DAx//8AtwAAAfgHxgImAC0AAAEHAKoDZAFSABQAsABFWLACLxuxAhw+WbEECPQwMf//AJsAAAHeBoICJgCMAAABBwCqA0oADgAUALAARViwAi8bsQIYPlmxBAH0MDH//wCj/qIBfgWwAiYALQAAAAcArANrAAD//wCF/qIBaAXEAiYATQAAAAcArANNAAD//wB2/qIFCQXEAiYAMwAAAAcArAUYAAD//wBb/qIENAROAiYAUwAAAAcArASdAAD//wB2/+wFCQe8AiYAMwAAAQcAqgUQAUgAFACwAEVYsA0vG7ENHD5ZsS4I9DAx//8AW//sBDQGhAImAFMAAAEHAKoEjQAQABQAsABFWLAELxuxBBg+WbEqAfQwMf//AHb/7AU9B8UCJgAzAAABBwG3AOUBMAAXALAARViwDS8bsQ0cPlmxIwz0sCnQMDEA//8AW//sBLoGjgImAFMAAAEGAbdi+QAXALAARViwBC8bsQQYPlmxHwj0sCXQMDEA//8AR//sBQkHwQImADMAAAEHAbYA6QE/ABcAsABFWLANLxuxDRw+WbEhDPSwKNAwMQD////E/+wENAaJAiYAUwAAAQYBtmYHABcAsABFWLAELxuxBBg+WbEdCPSwJNAwMQD//wB2/+wFCQfsAiYAMwAAAQcBtQDqAR0AFwCwAEVYsA0vG7ENHD5ZsSEM9LAn0DAxAP//AFv/7ARTBrUCJgBTAAABBgG1Z+YAFwCwAEVYsAQvG7EEGD5ZsR0I9LAj0DAxAP//AHb/7AUJB9wCJgAzAAABBwG0AOkBCAAXALAARViwDS8bsQ0cPlmxIQz0sCrQMDEA//8AW//sBDQGpQImAFMAAAEGAbRm0QAXALAARViwBC8bsQQYPlmxHQj0sCbQMDEA//8Adv6iBQkHOAImADMAAAAnAJ0A6wE4AQcArAUYAAAAFACwAEVYsA0vG7ENHD5ZsSIG9DAx//8AW/6iBDQGAAImAFMAAAAmAJ1oAAEHAKwEnQAAABQAsABFWLAELxuxBBg+WbEeAfQwMf//AGX/7AWdBy8CJgCXAAABBwB1Ad0BMQAUALAARViwDS8bsQ0cPlmxKAj0MDH//wBb/+wEugX+AiYAmAAAAQcAdQFlAAAAFACwAEVYsAQvG7EEGD5ZsSYJ9DAx//8AZf/sBZ0HLwImAJcAAAEHAEQBTgExABQAsABFWLANLxuxDRw+WbEnCPQwMf//AFv/7AS6Bf4CJgCYAAABBwBEANYAAAAUALAARViwBC8bsQQYPlmxJQn0MDH//wBl/+wFnQe1AiYAlwAAAQcAqgUMAUEAFACwAEVYsA0vG7ENHD5ZsTQI9DAx//8AW//sBLoGhAImAJgAAAEHAKoElAAQABQAsABFWLAELxuxBBg+WbEyAfQwMf//AGX/7AWdBx0CJgCXAAABBwCkAOMBNQAUALAARViwDS8bsQ0cPlmxKQT0MDH//wBb/+wEugXsAiYAmAAAAQYApGsEABQAsABFWLAELxuxBBg+WbEnAfQwMf//AGX+ogWdBjcCJgCXAAAABwCsBQkAAP//AFv+ogS6BLACJgCYAAAABwCsBJsAAP//AIz+ogSqBbACJgA5AAAABwCsBO4AAP//AIj+ogPcBDoCJgBZAAAABwCsBFEAAP//AIz/7ASqB7oCJgA5AAABBwCqBOkBRgAUALAARViwCi8bsQocPlmxEwj0MDH//wCI/+wD3AaEAiYAWQAAAQcAqgSFABAAFACwAEVYsAcvG7EHGD5ZsREB9DAx//8AjP/sBh0HQAImAJkAAAEHAHUB1AFCABQAsABFWLAaLxuxGhw+WbEdCPQwMf//AIj/7AUPBeoCJgCaAAABBwB1AWP/7AAUALAARViwEy8bsRMYPlmxHAn0MDH//wCM/+wGHQdAAiYAmQAAAQcARAFFAUIAFACwAEVYsBIvG7ESHD5ZsRwI9DAx//8AiP/sBQ8F6gImAJoAAAEHAEQA1P/sABQAsABFWLANLxuxDRg+WbEbCfQwMf//AIz/7AYdB8YCJgCZAAABBwCqBQMBUgAUALAARViwGi8bsRocPlmxKQj0MDH//wCI/+wFDwZwAiYAmgAAAQcAqgSS//wAFACwAEVYsBMvG7ETGD5ZsSgB9DAx//8AjP/sBh0HLgImAJkAAAEHAKQA2gFGABQAsABFWLASLxuxEhw+WbEeBPQwMf//AIj/7AUPBdgCJgCaAAABBgCkafAAFACwAEVYsBMvG7ETGD5ZsR0B9DAx//8AjP6iBh0GAgImAJkAAAAHAKwFCQAA//8AiP6iBQ8EkAImAJoAAAAHAKwEVwAA//8AD/6iBLsFsAImAD0AAAAHAKwEuwAA//8AFv4FA7AEOgImAF0AAAAHAKwFHP9j//8ADwAABLsHugImAD0AAAEHAKoEtwFGABQAsABFWLAILxuxCBw+WbEJCPQwMf//ABb+SwOwBoQCJgBdAAABBwCqBEoAEAAUALAARViwDy8bsQ8YPlmxEAH0MDH//wAPAAAEuwciAiYAPQAAAQcApACOAToAFACwAEVYsAEvG7EBHD5ZsQwE9DAx//8AFv5LA7AF7AImAF0AAAEGAKQhBAAUALAARViwAS8bsQEYPlmxEwH0MDEAAgBf/+wErAYAABcAIgB/ALAUL7AARViwDS8bsQ0YPlmwAEVYsAMvG7EDED5ZsABFWLAGLxuxBhA+WbIPFAFdsi8UAV2yEwMUERI5sBMvshABCitYIdgb9FmwAdCyBAYNERI5sg8NBhESObATELAW0LAGELIbAQorWCHYG/RZsA0QsiABCitYIdgb9FkwMQEjESMnBiMiAjU1NBIzMhcRITUhNTMVMwEUFjMyNxEmIyIGBKy8qglvxrzt7L++b/75AQe5vPxsmIawUVOsiJgE0vsudIgBNPgO+QEvggEGl5eX/Ki40J4B8ZnSAP//AF/+zQSsBgAAJgBIAAAAJwHeAaECRwEHAEMAn/9kAAgAsi8eAV0wMf//ALL+mAVEBbACJgHjAAAABwGwBCP/////AJz+mQSBBDoCJgDwAAAABwGwA2AAAP//AKn+mQWpBbACJgAsAAAABwGwBIgAAP//AJz+mQSiBDoCJgDzAAAABwGwA4EAAP//ADH+mQSXBbACJgA4AAAABwGwAj8AAP//ACj+mQOwBDoCJgD1AAAABwGwAcYAAP//ADn+mQT4BbACJgA8AAAABwGwA9cAAP//ACn+mQQGBDoCJgBcAAAABwGwAuUAAP//AJb+mQVmBbACJgDgAAAABwGwBEUAAP//AGf+mQReBDsCJgD4AAAABwGwAz0AAP//AJb+mQTIBbACJgDgAAAABwGwAv4AAP//AGf+mQO9BDsCJgD4AAAABwGwAfUAAP//ALH+mQQwBbACJgCwAAAABwGwAO8AAP//AJr+mQNHBDoCJgDrAAAABwGwANUAAP//ABv+mQeCBbACJgDZAAAABwGwBmEAAP//ABX+mQY9BDoCJgDtAAAABwGwBRwAAP//AD/+VQW9BcMCJgE/AAAABwGwAwb/vP///97+WQRjBE4CJgFAAAAABwGwAgH/wP//AIwAAAPfBgACBgBMAAAAAv/UAAAEsQWwABIAGwBhALAARViwDy8bsQ8cPlmwAEVYsAovG7EKED5ZsgIKDxESObACL7IODwIREjmwDi+yCwEKK1gh2Bv0WbAB0LAOELAR0LACELITAQorWCHYG/RZsAoQshQBCitYIdgb9FkwMQEjFSEWBBUUBAchESM1MzUzFTMDESEyNjU0JicCUO0BauQBAP7+3/3Tz8/A7e0BX4+fmY0EUPID5MTF6gQEUJfJyf3Z/d2YgHuOAgAC/9QAAASxBbAAEgAbAGEAsABFWLAQLxuxEBw+WbAARViwCi8bsQoQPlmyAgoQERI5sAIvshECEBESObARL7IBAQorWCHYG/RZsAvQsBEQsA7QsAIQshMBCitYIdgb9FmwChCyFAEKK1gh2Bv0WTAxASMVIRYEFRQEByERIzUzNTMVMwMRITI2NTQmJwJQ7QFq5AEA/v7f/dPPz8Dt7QFfj5+ZjQRQ8gPkxMXqBARQl8nJ/dn93ZiAe44CAAEAAwAABDAFsAANAE4AsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsnoNAV2yAAEKK1gh2Bv0WbAE0LANELAG0LAIELIKAQorWCHYG/RZMDEBIREjESM1MxEhFSERIQJ//vPBrq4Df/1CAQ0CrP1UAqyXAm2e/jEAAAH//AAAA0cEOgANAEkAsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASERIxEjNTMRIRUhESECeP7cup6eAq3+DQEkAd/+IQHflwHEmf7VAAEACwAABTEFsAAUAH4AsABFWLAILxuxCBw+WbAARViwEC8bsRAcPlmwAEVYsAIvG7ECED5ZsABFWLATLxuxExA+WbIOCAIREjmwDi+yLw4BXbLPDgFdsgEBCitYIdgb9FmyBwgCERI5sAcvsgQBCitYIdgb9FmwBxCwCtCwBBCwDNCyEgEOERI5MDEBIxEjESM1MzUzFSEVIREzATMBASMCN7HAu7vAAQH+/5YB/e/91AJV6wKO/XIEN5fi4pf+9wKC/T79EgAAAf/TAAAEKAYAABQAdACwAEVYsAgvG7EIHj5ZsABFWLAQLxuxEBg+WbAARViwAi8bsQIQPlmwAEVYsBMvG7ETED5Zsg4QAhESObAOL7IBAQorWCHYG/RZsgcIEBESObAHL7IEAQorWCHYG/RZsAcQsArQsAQQsAzQshIBDhESOTAxASMRIxEjNTM1MxUzFSMRMwEzAQEjAeCAutPTuu/vfgE72/6GAa7bAfX+CwTBl6iol/3NAaz+E/2zAP//ALH+mwWyBxoCJgDbAAAAJwCgATEBQwEHABAEfv+9ABMAsABFWLAILxuxCBw+WbAN3DAxAP//AJz+mwS1BcQCJgDvAAAAJwCgAKL/7QEHABADgf+9ABMAsABFWLAILxuxCBg+WbAN3DAxAP//AKn+mwW7BbACJgAsAAAABwAQBIf/vf//AJz+mwS0BDoCJgDzAAAABwAQA4D/vf//AKn+mwb4BbACJgAxAAAABwAQBcT/vf//AJ3+mwYGBDoCJgDyAAAABwAQBNL/vf//AC/+mwWoBbACJgDcAAAABwAQBHT/vf//ACz+mwS3BDoCJgDxAAAABwAQA4P/vQABAA8AAAS7BbAADgBWsgoPEBESOQCwAEVYsAgvG7EIHD5ZsABFWLALLxuxCxw+WbAARViwAi8bsQIQPlmyBggCERI5sAYvsgUBCitYIdgb9FmwANCyCggCERI5sAYQsA7QMDEBIxEjESM1MwEzAQEzATMDpuHA25T+UdwBegF82v5RmgIJ/fcCCZcDEP0lAtv88AAAAQAu/mAD3wQ6AA4AY7IKDxAREjkAsABFWLAILxuxCBg+WbAARViwCy8bsQsYPlmwAEVYsAIvG7ECEj5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmyBgEKK1gh2Bv0WbIKCwAREjmwDdCwDtAwMQUjESMRIzUzATMBATMBMwNK5rrcv/6hvQEfARi9/qPIC/5rAZWXA6782gMm/FIAAAEAOQAABM4FsAARAGMAsABFWLALLxuxCxw+WbAARViwDi8bsQ4cPlmwAEVYsAIvG7ECED5ZsABFWLAFLxuxBRA+WbIRCwIREjmwES+yAAEKK1gh2Bv0WbIECwIREjmwB9CwERCwCdCyDQsCERI5MDEBIwEjAQEjASM1MwEzAQEzATMDxKQBruT+mv6Y4wGvoJH+a+EBXwFd4v5rlgKe/WICOP3IAp6XAnv90gIu/YUAAQApAAADygQ6ABEAYwCwAEVYsAsvG7ELGD5ZsABFWLAOLxuxDhg+WbAARViwAi8bsQIQPlmwAEVYsAUvG7EFED5ZshEOAhESObARL7IAAQorWCHYG/RZsgQOAhESObAH0LARELAJ0LINDgIREjkwMQEjASMDAyMBIzUzATMTEzMBMwM8swFB1vr61wFBqp7+1tbt8Nj+1qcB4f4fAZX+awHhlwHC/nUBi/4+//8AY//sA+wETQIGAL4AAP//ABIAAAQvBbACJgAqAAAABwHe/4P+f///AJACiwXJAyIARgGXhABmZkAA//8AXQAABDMFxAIGABYAAP//AF7/7AP5BcQCBgAXAAD//wA1AAAEUAWwAgYAGAAA//8Amv/sBC0FsAIGABkAAP//AGT//wP4BcQABgAdAAD//wCH/+wEHgXEAAYAFBQA//8Aev/sBNwHVQImACsAAAEHAHUBvgFXABQAsABFWLALLxuxCxw+WbEiCPQwMf//AGD+VgPyBf4CJgBLAAABBwB1AUsAAAAUALAARViwAy8bsQMYPlmxJwn0MDH//wCpAAAFCAc0AiYAMgAAAQcARAFmATYAFACwAEVYsAYvG7EGHD5ZsQsI9DAx//8AjAAAA98F/gImAFIAAAEHAEQAzAAAABQAsABFWLADLxuxAxg+WbETCfQwMf//ABwAAAUdByACJgAlAAABBwCrBG0BMgAXALAARViwBC8bsQQcPlmxDAj0sBDQMDEA//8AOf/sA+oF6wImAEUAAAEHAKsEEv/9ABcAsABFWLAXLxuxFxg+WbEqCfSwLtAwMQD//wBfAAAERgcsAiYAKQAAAQcAqwQ4AT4AFwCwAEVYsAYvG7EGHD5ZsQ0I9LAR0DAxAP//ACn/7APzBesCJgBJAAABBwCrBAL//QAXALAARViwCC8bsQgYPlmxHwn0sCPQMDEA////CgAAAeoHLAImAC0AAAEHAKsC4wE+ABcAsABFWLACLxuxAhw+WbEFCPSwCdAwMQD///7wAAAB0AXpAiYAjAAAAQcAqwLJ//sAFwCwAEVYsAIvG7ECGD5ZsQUJ9LAJ0DAxAP//AHb/7AUJByICJgAzAAABBwCrBI8BNAAXALAARViwDS8bsQ0cPlmxIQj0sCXQMDEA//8AM//sBDQF6wImAFMAAAEHAKsEDP/9ABcAsABFWLAELxuxBBg+WbEdCfSwIdAwMQD//wBVAAAEyQcgAiYANgAAAQcAqwQuATIAFwCwAEVYsAQvG7EEHD5ZsRkI9LAd0DAxAP///4sAAAKXBesCJgBWAAABBwCrA2T//QAXALAARViwCy8bsQsYPlmxDwn0sBPQMDEA//8AjP/sBKoHIAImADkAAAEHAKsEaAEyABcAsABFWLAJLxuxCRw+WbEUCPSwGNAwMQD//wAr/+wD3AXrAiYAWQAAAQcAqwQE//0AFwCwAEVYsAcvG7EHGD5ZsRIJ9LAW0DAxAP///zoAAATSBj8AJgDPZAAABwCt/oMAAP//AKn+ogSIBbACJgAmAAAABwCsBLoAAP//AIz+ogQgBgACJgBGAAAABwCsBKsAAP//AKn+ogTGBbACJgAoAAAABwCsBLkAAP//AF/+ogPwBgACJgBIAAAABwCsBL0AAP//AKn9/wTGBbACJgAoAAAABwGiAWX+oP//AF/9/wPwBgACJgBIAAAABwGiAWn+oP//AKn+ogUIBbACJgAsAAAABwCsBR8AAP//AIz+ogPfBgACJgBMAAAABwCsBKEAAP//AKkAAAUFBy4CJgAvAAABBwB1AXsBMAAUALAARViwBS8bsQUcPlmxDgj0MDH//wCNAAAEDAc/AiYATwAAAQcAdQFEAUEACQCwBS+wD9wwMQD//wCp/qIFBQWwAiYALwAAAAcArAToAAD//wCN/qIEDAYAAiYATwAAAAcArARlAAD//wCp/qIEHAWwAiYAMAAAAAcArATAAAD//wCG/qIBYQYAAiYAUAAAAAcArANOAAD//wCp/qIGUgWwAiYAMQAAAAcArAXSAAD//wCL/qIGeAROAiYAUQAAAAcArAXWAAD//wCp/qIFCAWwAiYAMgAAAAcArAUkAAD//wCM/qID3wROAiYAUgAAAAcArASHAAD//wCpAAAEwAdAAiYANAAAAQcAdQF8AUIAFACwAEVYsAMvG7EDHD5ZsRYI9DAx//8AjP5gBB4F9QImAFQAAAEHAHUBk//3ABQAsABFWLAMLxuxDBg+WbEdCfQwMf//AKj+ogTJBbACJgA2AAAABwCsBLcAAP//AIL+ogKXBE4CJgBWAAAABwCsA0oAAP//AFD+ogRyBcQCJgA3AAAABwCsBMkAAP//AF/+ogO7BE4CJgBXAAAABwCsBIcAAP//ADH+ogSXBbACJgA4AAAABwCsBLoAAP//AAn+ogJWBUACJgBYAAAABwCsBBkAAP//ABwAAAT9By4CJgA6AAABBwCkALQBRgAUALAARViwBi8bsQYcPlmxCgT0MDH//wAhAAADugXjAiYAWgAAAQYApB37ABQAsABFWLABLxuxARg+WbEKAfQwMf//ABz+ogT9BbACJgA6AAAABwCsBOQAAP//ACH+ogO6BDoCJgBaAAAABwCsBE0AAP//AD3+ogbtBbACJgA7AAAABwCsBe8AAP//ACv+ogXTBDoCJgBbAAAABwCsBVMAAP//AFb+ogR6BbACJgA+AAAABwCsBLoAAP//AFj+ogOzBDoCJgBeAAAABwCsBGIAAP///nj/7AVPBdYAJgAzRgAABwFa/gkAAP//ABMAAARwBRwCJgG6AAAABwCt/9z+3f///58AAAPqBR8AJgG+PAAABwCt/uj+4P///7wAAASUBRwAJgHBPAAABwCt/wX+3f///8AAAAGNBR4AJgHCPAAABwCt/wn+3////9//8ARkBRwAJgHICgAABwCt/yj+3f///1cAAARYBRwAJgHSPAAABwCt/qD+3f////gAAASIBRsAJgHzCgAABwCt/0H+3P//ABMAAARwBI0CBgG6AAD//wCKAAAD7wSNAgYBuwAA//8AigAAA64EjQIGAb4AAP//AEcAAAPgBI0CBgHTAAD//wCKAAAEWASNAgYBwQAA//8AlwAAAVEEjQIGAcIAAP//AIoAAARXBI0CBgHEAAD//wCKAAAFdwSNAgYBxgAA//8AYP/wBFoEnQIGAcgAAP//AIoAAAQbBI0CBgHJAAD//wAoAAAD/QSNAgYBzQAA//8ADQAABBwEjQIGAdIAAP//ACYAAAQxBI0CBgHRAAD///+0AAACPQXjAiYBwgAAAQcAav9OAB4AFwCwAEVYsAIvG7ECGj5ZsQsC9LAU0DAxAP//AA0AAAQcBeMCJgHSAAABBgBqbR4AFwCwAEVYsAgvG7EIGj5ZsRAC9LAZ0DAxAP//AIoAAAOuBeMCJgG+AAABBgBqcR4AFwCwAEVYsAYvG7EGGj5ZsRMC9LAc0DAxAP//AIoAAAOFBhwCJgHqAAABBwB1ATQAHgAUALAARViwBC8bsQQaPlmxCAb0MDH//wBD//AD3QSdAgYBzAAA//8AlwAAAVEEjQIGAcIAAP///7QAAAI9BeMCJgHCAAABBwBq/04AHgAXALAARViwAi8bsQIaPlmxCwL0sBTQMDEA//8AK//wA00EjQIGAcMAAP//AIoAAARXBhwCJgHEAAABBwB1ASUAHgAUALAARViwBS8bsQUaPlmxDwb0MDH//wAi/+wECwX2AiYCAQAAAQYAoGcfABQAsABFWLACLxuxAho+WbEUCPQwMf//ABMAAARwBI0CBgG6AAD//wCKAAAD7wSNAgYBuwAA//8AigAAA4UEjQIGAeoAAP//AIoAAAOuBI0CBgG+AAD//wCKAAAEYQX2AiYB/gAAAQcAoADJAB8AFACwAEVYsAgvG7EIGj5ZsQ0I9DAx//8AigAABXcEjQIGAcYAAP//AIoAAARYBI0CBgHBAAD//wBg//AEWgSdAgYByAAA//8AigAABEQEjQIGAe8AAP//AIoAAAQbBI0CBgHJAAD//wBg//AEMASdAgYBvAAA//8AKAAAA/0EjQIGAc0AAP//ACYAAAQxBI0CBgHRAAAAAQBH/lAD1ASdACkAmgCwAEVYsAovG7EKGj5ZsABFWLAZLxuxGRA+WbAARViwGC8bsRgSPlmwChCyAwEKK1gh2Bv0WbIGChkREjmyJxkKERI5fLAnLxiy8CcBXbIAJwFxsqAnAV20YCdwJwJdsjAnAXG0YCdwJwJxsiYBCitYIdgb9FmyECYnERI5sBkQsBbQsh0ZChESObAZELIgAQorWCHYG/RZMDEBNCYjIgYVIzQ2MzIWFRQGBxYWFRQGBxEjESYmNTMWFjMyNjU0JSM1MzYDCIp9boG67bzT7m5ndnHLr7qjtrkFg3mIkv7/nZzvA1BUXVhPjrWollaNKSSSW4yvEv5bAacUrYhWYGBYwQWYBQAAAQCK/pkE+gSNAA8AXQCwAS+wAEVYsAkvG7EJGj5ZsABFWLADLxuxAxA+WbAARViwBi8bsQYQPlmyCwMJERI5fLALLxiyoAsBXbIEAQorWCHYG/RZsAkQsAzQsAMQsg4BCitYIdgb9FkwMQEjESMRIREjETMRIREzETME+rqh/aS5uQJcuaL+mQFnAfL+DgSN/f0CA/wMAAABAGD+VgQwBJ0AHwBYALAARViwDi8bsQ4aPlmwAEVYsAMvG7EDED5ZsABFWLAFLxuxBRI+WbADELAG0LAOELAS0LAOELIVAQorWCHYG/RZsAMQshwBCitYIdgb9FmwAxCwH9AwMQEGBgcRIxEmAjU1NDY2MzIWFyMmJiMiBgcVFBYzMjY3BDAUy6m6t9d755jM9xO5Eo1+macBn5eHjRQBeajHFP5gAaIeAR7jYaT5iNO7gnTLvWq9z2+D//8ADQAABBwEjQIGAdIAAP//AAL+UQVrBJ0CJgIXAAAABwGwArz/uP//AIoAAARhBdYCJgH+AAABBwBwAJwAJgATALAARViwCC8bsQgaPlmwC9wwMQD//wAi/+wECwXWAiYCAQAAAQYAcDomABMAsABFWLARLxuxERo+WbAT3DAxAP//AGAAAAUGBI0CBgHxAAD//wAc/k8FHQWwAiYAJQAAAAcAowF8AAD//wBt/k8D6gROAiYARQAAAAcAowDEAAD//wCp/lkERgWwAiYAKQAAAAcAowE6AAr//wBd/k8D8wROAiYASQAAAAcAowEGAAAAAAAAAA0AogADAAEECQAAAF4AAAADAAEECQABAAwAXgADAAEECQACAA4AagADAAEECQADAAwAXgADAAEECQAEAAwAXgADAAEECQAFACwAeAADAAEECQAGABwApAADAAEECQAHAEAAwAADAAEECQAJAAwBAAADAAEECQALABQBDAADAAEECQAMACYBIAADAAEECQANAFwBRgADAAEECQAOAFQBogBDAG8AcAB5AHIAaQBnAGgAdAAgADIAMAAxADEAIABHAG8AbwBnAGwAZQAgAEkAbgBjAC4AIABBAGwAbAAgAFIAaQBnAGgAdABzACAAUgBlAHMAZQByAHYAZQBkAC4AUgBvAGIAbwB0AG8AUgBlAGcAdQBsAGEAcgBWAGUAcgBzAGkAbwBuACAAMgAuADAAMAAxADEAMAAxADsAIAAyADAAMQA0AFIAbwBiAG8AdABvAC0AUgBlAGcAdQBsAGEAcgBSAG8AYgBvAHQAbwAgAGkAcwAgAGEAIAB0AHIAYQBkAGUAbQBhAHIAawAgAG8AZgAgAEcAbwBvAGcAbABlAC4ARwBvAG8AZwBsAGUARwBvAG8AZwBsAGUALgBjAG8AbQBDAGgAcgBpAHMAdABpAGEAbgAgAFIAbwBiAGUAcgB0AHMAbwBuAEwAaQBjAGUAbgBzAGUAZAAgAHUAbgBkAGUAcgAgAHQAaABlACAAQQBwAGEAYwBoAGUAIABMAGkAYwBlAG4AcwBlACwAIABWAGUAcgBzAGkAbwBuACAAMgAuADAAaAB0AHQAcAA6AC8ALwB3AHcAdwAuAGEAcABhAGMAaABlAC4AbwByAGcALwBsAGkAYwBlAG4AcwBlAHMALwBMAEkAQwBFAE4AUwBFAC0AMgAuADAAAwAAAAAAAP9qAGQAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAIACAAC//8ADwABAAAADAAAAAAAAAACAF4AJQA+AAEARQBeAAEAeQB5AAMAgQCBAAEAgwCDAAEAhgCGAAEAiQCJAAEAiwCVAAEAlwCcAAEAowCjAAMApwCsAAMAsACwAAEAuQC6AAEAvgC+AAEAwADAAAEAwgDCAAEAxgDGAAEAygDKAAEAzADNAAEAzwDQAAEA0gDSAAEA2QDdAAEA4ADgAAEA5ADkAAEA5gDoAAEA6gD6AAEA/AD8AAEA/gEAAAEBAgECAAEBBwEIAAEBFQEZAAEBGwEbAAEBHwEhAAEBIwEkAAMBOAE5AAEBPgFAAAEBRQFFAAEBTQFNAAEBTwFPAAEBUwFTAAEBVQFXAAEBWQFZAAEBogGiAAMBowGpAAIBugHTAAEB4gHiAAEB5AHkAAEB6gHqAAEB8wHzAAEB9QH1AAEB/AH+AAECAAIBAAECAwIDAAECBwIHAAECCQILAAECEQIRAAECFgIYAAECGgIaAAECPgJDAAECRwKvAAECsgNYAAEDWwNqAAEDcQNxAAEDcwN3AAEDegN/AAEDgQOEAAEDhgOKAAEDjAOnAAEDqwOrAAEDrQO0AAEDtgO4AAEDvQO/AAEDwQPNAAEDzwPZAAED3APsAAED7wRIAAEESwRLAAEETQRNAAEETwRQAAEEWwRbAAEEYgRkAAEEZgRmAAEEagRqAAEEbARtAAEEbwRvAAEEdwSGAAEEhwSHAAIEiASwAAEEsgTKAAEEzATQAAEE0gTVAAEE1wTZAAEE2wTcAAEE3gThAAEAAQAAAAoAXACaAARERkxUABpjeXJsAChncmVrADZsYXRuAEQABAAAAAD//wACAAAABAAEAAAAAP//AAIAAQAFAAQAAAAA//8AAgACAAYABAAAAAD//wACAAMABwAIY3BzcAAyY3BzcAAyY3BzcAAyY3BzcAAya2VybgA4a2VybgA4a2VybgA4a2VybgA4AAAAAQAAAAAAAQABAAIABgHYAAEAAAABAAgAAQAKAAUAJABIAAEA3gAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAkgCwALEAsgCzALQAtQC2ALcAuAC5ANEA0gDTANQA1QDWANcA2ADZANoA2wDcAN0A3gDfAOAA4QDiAOMA5ADlAOYA5wDoASwBMAEyATgBOgE8AT4BPwFFAUYBfwGFAYoBjQJHAkgCSgJMAk0CTgJPAlACUQJSAlMCVAJVAlYCVwJYAlkCWgJbAlwCXQJeAl8CYAJhAmICYwJkAmUCZgKDAoUChwKJAosCjQKPApECkwKVApcCmQKbAp0CnwKhAqMCpQKnAqkCqwKtAq8CsgK0ArYCuAK6ArwCvgLAAsICxQLHAskCywLNAs8C0QLTAtUC2QLbAt0C3wLhAuMC5QLnAukC6wLtAu8C8QLyAvQC9gNTA1QDVQNWA1cDWANZA1sDXANdA14DXwNgA2EDYgNkA2UDZgNnA2gDaQNqA3oDewN8A30DfgN/A4ADgQOCA4MDhAOFA4YDhwOIA4kDigOLA4wDjQOOA48DuwO9A78D1APaA+AESQRLBE8EVwRZBF4EagACAAAABAAOD84V8jViAAEDVAAEAAABpQrSCtIGggtwCoAK/g+aDAAGiA7uDu4MRg6gCiIO7g7uD5oKigaSDGYMRgrYCqwNUg8QCl4L4gsQDBYGmA22DbYNtgwgCxAKUAxMDbAMTAsQBqYN5gtwD5oLcAasBrIGvAbCBsgMTAbOBtgNtgb+BxQHKgcwB0YHTAdSB4QHigeQDcANwAe+Du4H4AgCDVIIMA7uDu4LJg7uDu4IRg3ADcAIeAiCCIwIpg1ICLgNsAjSCOgLEAkyCUwJaAloCxAJYgloCWgJaAtwDCAK2AxMCxAN5g1IDqAOoA1ICtIK0grSCtIK0gmKCbAJugnECeIJ9AoGChgK/g+aD5oPmg+aDGYLcAtwC3ALcAtwC3ALcAr+DAAMAAwADAAO7g7uDu4O7g7uD5oPmg+aD5oPmgxGDEYMRgxGDxAL4gviC+IL4gviC+IL4gwWDBYMFgwWDbYMIAwgDCAMIAwgDEwMTAtwC+ILcAviC3AL4gr+Cv4K/gr+D5oMAAwWDAAMFgwADBYMAAwWDAAMFg7uDbYO7g7uDu4O7g7uDEYOoAoiCiIKIgoiDu4Ntg7uDbYO7g22DbYPmgwgD5oMIA+aDCAKUApQClAMZgxmDGYMRgxGDEYMRgxGDEYKrA8QDEwPEApeCl4KXgtwDAAO7g7uD5oPEAtwCoAMAApeDu4O7g6gDu4O7g+aCooMZg8QDVIO7g8QDbYMIAxMDCAMAA3mDu4O7gxGDqAOoAsmC3AKgA3mDAAO7g7uD5oKigr+DGYNUgviDBYMIAsQDEwNsAwWDUgMTAqsCqwKrA8QDEwK0grSCtIO7g22C3AL4gwADBYK2AxMCv4PEAxMDu4NUg2wDu4LcAviC3AL4gwADBYMFgwWDVINsA+aDCAMIAsQCyYMTAsmDEwLJgxMDVINsAtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gwADBYMAAwWDAAMFgwADBYMAAwWDAAMFgwADBYMAAwWDu4O7g+aDCAPmgwgD5oMIA+aDCAPmgwgD5oMIA+aDCAMIAxGDEYPEAxMDxAMTA8QDEwOoA7uDGYNUg2wDeYNSA1SDbANtg3ADeYOoA7uDu4PEA+aAAIAhwAGAAYAAAALAAsAAQATABMAAgAlACoAAwAsADUACQA4AD4AEwBFAEYAGgBJAEoAHABMAEwAHgBRAFQAHwBWAFYAIwBaAFoAJABcAF0AJQCKAIoAJwCcAJwAKACwALQAKQC2ALgALgC6ALoAMQC8AL0AMgC/AMAANADCAMQANgDGAMsAOQDRANEAPwDTAN0AQADfAN8ASwDhAOMATADlAOcATwDpAO0AUgDwAPAAVwD1APcAWAD6APsAWwD9AP8AXQEDAQQAYAEJAQkAYgEMAQwAYwEXARkAZAErAS0AZwEwATAAagEyATIAawFJAUkAbAFsAW0AbQFvAXEAbwG6AboAcgG9Ab0AcwHEAcUAdAHIAcgAdgHKAcsAdwHNAc0AeQIoAigAegIqAisAewJHAkgAfQJKAkoAfwJMAm0AgAJvAnIAogJ3AnwApgKBAokArAKLAosAtQKNAo0AtgKPAo8AtwKRApEAuAKTApwAuQKlAqcAwwKpAqkAxgKrAqsAxwKtAq0AyAKvAq8AyQKyArIAygK0ArQAywK2ArYAzAK4ArgAzQK6AroAzgK8ArwAzwK+AsoA0ALMAswA3QLOAs4A3gLQAtAA3wLbAtsA4ALdAt0A4QLfAt8A4gLhAuEA4wLjAuMA5ALlAuUA5QLnAucA5gLpAukA5wLrAusA6ALtAu0A6QLvAvIA6gL0AvQA7gL2AvYA7wNTA1gA8ANbA2oA9gNtA20BBgNxA3EBBwNzA3MBCAN3A3cBCQN6A3sBCgN9A4YBDAOIA4oBFgOMA5EBGQOTA5QBHwOWA5kBIQOfA6ABJQOiA6IBJwOkA6QBKAOmA6kBKQOsA7EBLQOzA7MBMwO3A7gBNAO9A70BNgO/A8gBNwPLA8wBQQPOA9EBQwPYA9kBRwPdA90BSQPfA+UBSgPqA+sBUQPvBBcBUwQZBBkBfAQbBCgBfQQwBDABiwQzBDMBjAQ1BDUBjQRBBEYBjgRJBEkBlARLBEsBlQRNBE0BlgRPBFABlwRVBFgBmQRbBFsBnQRdBF4BngRgBGABoARkBGQBoQRmBGYBogRqBGoBowSqBKoBpAABABP/IAACAFb/5gG6/8AAAQG6AA4AAwANABQAQQASAGEAEwABAPX/9QABAMMADQACALf/wgDDABAAAQDD/+IAAQDG//IAAQDDAA4AAgDJ/+0A9f/AAAkAvv/mAMH/6wDC/+kAxP/wAMX/5wDJ/+MAy//OAMz/1ADN/9sABQDB/+wAwwAPAMX/6gDJ/8QAy//nAAUASv/pAMH/7gDDABAAxf/sAMn/IAABAMMADwAFAMn/6gDs/+4A9f+rATP/7AFY/+wAAQD1/9UAAQDJAAsADABKAAwAxQALAMkADAG6/78BvP/uAcD/7AHI/+0Byv/sAcz/9QHNAA4BzwANAdIADQABAPX/2AABAPX/qgALAOX/1AD1/8kBCP/lAR//4wEz/8QBPP/hAU3/1AFO//UBT//nAVf/0gFY/8kACADl/8kA9f/fAQj/7QEf/+sBM//fAT//6QFO//UBWP/gAAgA5f/mAPX/0AEz/84BPP/oAU3/5wFP/+0BV//mAVj/0AALANgAFADl/+AA7AATATz/4QE9/+ABQP/hAUX/6QFN/98BT//eAVf/3wFZ//IABQAb//IA5f/xAU3/8gFP//IBV//yAAwA2AATAOX/5gDm//QA7AASAPX/5wEz/+cBPP/lAT3/6AFN/+YBT//mAVf/5gFY/+cAAgDY/+IBV//kAAIA2P/hAOz/5AAGAOz/7gD1/+4BCP/0AR//8QEz/+8BWP/vAAQA9f/0AQj/9QEz//UBWP/1AAYA7AAUAPX/7QD7/+IBM//tAT3/7QFY/+0ABQEb/+sBvP/rAcD/6QHI/+sByv/rABIASgANAMb/qwDH/8AAy//VAOz/qgEb/+IBHwAMAU4ACwFQAAsBuv+/Abz/7gHA/+wByP/tAcr/7AHM//UBzQAOAc8ADQHSAA0ABgDsABQA9f/wAQAADAEz//ABPf/mAVj/8AAFAOwAOgD1/+MBM//iAT3/4wFY/+MAAQDs/+8ACAD1/7oBCP/PAR//2wEz/1ABPf+dAU7/8AFQ//IBWP9MAAkBvP/yAcD/8gHI//IByv/yAc3/wAHO/+wBz//HAdD/2AHS/78AAgHP/+4B0P/1AAIByP/rAcr/6wAHAcj/7wHK//ABzf+7Ac7/7AHP/7cB0P/VAdL/tAAEAc3/7gHP//EB0f/sAdL/6gAEAc3/6QHP/+sB0P/xAdL/5QAEAc3/8gHP//EB0P/1AdL/7gACAc8ADQHSAA0ACwBb/6QBugATAbz/8wHA//EByP/yAcr/8QHN/zsBzv/aAc//VAHQ/5EB0v8/AAMASgAPAFgAMgBbABEACABb/+UAt//LAMz/5AG6AA0BvP/tAcD/6wHI/+wByv/sAAIBEAALAVf/5gAIAFgADgCB/58Aw//eAMb/5QDY/6gA7P/KAUr/4wG6/8YACQANAA8AQQAMAFb/6wBhAA4Buv/LAbz/6QHA/+cByP/nAcr/5wABAFsACwAJAA0AFABBABEAVv/iAGEAEwG6/7QBvP/ZAcD/2QHI/9kByv/ZAAQADf/mAEH/9ABh/+8BQP/tAAUAyf/qAOz/7gD1/7ABM//sAVj/7AASANj/rgDlABIA6v/gAOz/rQDu/9YA/P/fAQD/0gEG/+ABG//OASv/3QEt/+IBMf/gATf/4AE9/+kBQP/aAUr/vQFU/98BVwARABwAI//DAFj/7wBb/98Amf/uALf/5QC4/9EAwwARAMn/yADYABMA5f/FAPX/ygEz/58BPP9RAT3/ewE//8oBQP/dAUX/8gFN/3UBT//KAVf/TwFY/4wBwP/1Acj/9QHN/8cBzv/xAc//zQHQ/90B0v/EAAcA9f/wAQj/8QEf//MBM//xAU7/8wFQ/+kBWP/TAAUASv/uAFv/6gHP//AB0P/tAdL/8AACAPX/9QFt/7AACQDJ/+oA7P+4APX/6gEI//ABH//xATP/6wFO//UBWP/sAW3/sAABAbr/6wAGAEoADQDFAAsAxv/qAMkADADs/8gBG//xADgABP/YAFb/tQBb/8cAbf64AHz/KACB/00Ahv+OAIn/oQC3/64Avv9+AML/ZwDF/4cAxv9lAMn/ngDL/2oAzP9zAM3/XgDY/6UA5QAPAOn/5ADq/6AA7P90AO7/gAD1/7IA/P99AP7/gAEA/3kBBv99AQj/fwEb/5gBH//aASv/gQEt/5gBMf99ATP/swE3/6ABPf98AT//mgFA/2wBRf/mAUr/awFO/5IBUP+tAVT/ewFXAA8BWP+RAVn/8gG6/68BvP+5AcD/uQHI/7kByv+5Acz/vAHN//EB0P/xAdH/7QACAOz/yQEb/+4AFwC3/9QAwf/tAMMAEQDJ/+AAy//nAMz/5QDN/+4A2AASAOn/6QD1/9cBM//XAT3/0wE//9YBQP/FAUX/5wFNAA0BTwAMAVj/1gFZ//IBvP/pAcD/5wHI/+cByv/pAAEBG//xAAIA9f/AAW3/sAAJAOX/wwD1/88BM//OATz/5wE//98BTf/RAU//7AFX/6ABWP/RAC4AVv9tAFv/jABt/b8AfP59AIH+vACG/ysAif9LALf/YQC+/w8Awv7oAMX/HwDG/uUAyf9GAMv+7QDM/v0Azf7ZANj/UgDlAAUA6f+9AOr/SQDs/v4A7v8TAPX/aAD8/w4A/v8TAQD/BwEG/w4BCP8RARv/PAEf/6wBK/8VAS3/PAEx/w4BM/9qATf/SQE9/wwBP/8/AUD+8QFF/8ABSv7vAU7/MQFQ/18BVP8KAVcABQFY/zABWf/VABMAW//BALf/xQDJ/7QA6f/XAPX/uQEI/7IBG//SAR//yAEz/6ABPf/FAUX/5AFO/8wBUP/MAVj/ywFZ/+8BvP/oAcD/5gHI/+cByv/nAAgA2AAVAOwAFQE8/+QBPf/lAT//5AFN/+MBT//iAVf/5AAiAAr/4gANABQADv/PAEEAEgBK/+oAVv/YAFj/6gBhABMAbf+uAHz/zQCB/6AAhv/BAIn/wAC3/9AAu//qAL7/xgC/AA0Awf/pAML/1gDF/+gAxv+6AMn/6QDL/8sAzP/aAM3/xwF1/9MBuv+rAbz/zQHA/8sByP/LAcr/ywHN//MB0P/zAdH/7wAJAIH/3wC0//MAtv/wAMP/6gDY/98A5f/gAVf/4AG6/+0B0f/1AAEAGAAEAAAABwAqAFQAqgPcBFoExAUGAAEABwAEAAwAKgA1ADYAPwBKAAoAOP/YANH/2ADV/9gBMv/YATr/2ALb/9gC3f/YAt//2AOO/9gETf/YABUAOgAUADsAEgA9ABYBGAAUAmYAFgLtABIC7wAWAvEAFgNYABYDZwAWA2oAFgOgABIDogASA6QAEgOmABYDtwAUA78AFgRBABYEQwAWBEUAFgRqABYAzAAQ/xYAEv8WACX/VgAu/vgAOAAUAEX/3gBH/+sASP/rAEn/6wBL/+sAU//rAFX/6wBZ/+oAWv/oAF3/6ACT/+sAmP/rAJr/6gCx/1YAs/9WALr/6wC8/+gAx//rAMj/6wDK/+oA0QAUANUAFAD2/+sBAv/rAQz/VgEX/+sBGf/oAR3/6wEh/+sBMgAUATn/6wE6ABQBS//rAUz/6wFW/+sBbv8WAXL/FgF2/xYBd/8WAkz/VgJN/1YCTv9WAk//VgJQ/1YCUf9WAlL/VgJn/94CaP/eAmn/3gJq/94Ca//eAmz/3gJt/94Cbv/rAm//6wJw/+sCcf/rAnL/6wJ4/+sCef/rAnr/6wJ7/+sCfP/rAn3/6gJ+/+oCf//qAoD/6gKB/+gCgv/oAoP/VgKE/94Chf9WAob/3gKH/1YCiP/eAor/6wKM/+sCjv/rApD/6wKS/+sClP/rApb/6wKY/+sCmv/rApz/6wKe/+sCoP/rAqL/6wKk/+sCsv74Asb/6wLI/+sCyv/rAtsAFALdABQC3wAUAuL/6gLk/+oC5v/qAuj/6gLq/+oC7P/qAvD/6ANT/1YDW/9WA2v/6wNv/+oDcf/rA3P/6AN2/+oDd//rA3j/6gN//vgDg/9WA44AFAOQ/94Dkf/rA5P/6wOV/+sDlv/oA5j/6wOf/+gDp//oA6//VgOw/94Ds//rA7j/6AO5/+sDvv/rA8D/6APF/1YDxv/eA8f/VgPI/94DzP/rA87/6wPP/+sD2f/rA9v/6wPd/+sD4f/oA+P/6APl/+gD7P/rA+//VgPw/94D8f9WA/L/3gPz/1YD9P/eA/X/VgP2/94D9/9WA/j/3gP5/1YD+v/eA/v/VgP8/94D/f9WA/7/3gP//1YEAP/eBAH/VgQC/94EA/9WBAT/3gQF/1YEBv/eBAj/6wQK/+sEDP/rBA7/6wQQ/+sEEv/rBBT/6wQW/+sEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/6wQs/+sELv/rBDD/6wQy/+sENP/qBDb/6gQ4/+oEOv/qBDz/6gQ+/+oEQP/qBEL/6ARE/+gERv/oBE0AFAAfADj/1QA6/+QAO//sAD3/3QDR/9UA1f/VARj/5AEy/9UBOv/VAmb/3QLb/9UC3f/VAt//1QLt/+wC7//dAvH/3QNY/90DZ//dA2r/3QOO/9UDoP/sA6L/7AOk/+wDpv/dA7f/5AO//90EQf/dBEP/3QRF/90ETf/VBGr/3QAaADj/sAA6/+0APf/QANH/sADV/7ABGP/tATL/sAE6/7ACZv/QAtv/sALd/7AC3/+wAu//0ALx/9ADWP/QA2f/0ANq/9ADjv+wA6b/0AO3/+0Dv//QBEH/0ARD/9AERf/QBE3/sARq/9AAEAAu/+4AOf/uAmL/7gJj/+4CZP/uAmX/7gKy/+4C4f/uAuP/7gLl/+4C5//uAun/7gLr/+4Df//uBDP/7gQ1/+4ARwAGABAACwAQAEf/6ABI/+gASf/oAEv/6ABV/+gAk//oAJj/6AC6/+gAx//oAMj/6AD2/+gBAv/oAR3/6AEh/+gBOf/oAUv/6AFM/+gBVv/oAWwAEAFtABABbwAQAXAAEAFxABACbv/oAm//6AJw/+gCcf/oAnL/6AKK/+gCjP/oAo7/6AKQ/+gCkv/oApT/6AKW/+gCmP/oApr/6AKc/+gCnv/oAqD/6AKi/+gCpP/oA2v/6AOR/+gDlf/oA5j/6AOoABADqQAQA6wAEAOz/+gDuf/oA77/6APM/+gDzv/oA8//6APb/+gD7P/oBAj/6AQK/+gEDP/oBA7/6AQQ/+gEEv/oBBT/6AQW/+gEKv/oBCz/6AQu/+gEMv/oAAEAVgAEAAAAJgCmAZwB+gIUAlYCzAPCBLgFkgYsCMYKjAteDFQOGg5MDn4O/BDiEVgSKhRMFQIWaBciF6gYBhjIGT4ewBlQGqIc4B0CHhgelh7AHuoAAQAmAE8AWABbAF8AnAC0ALYAtwC4AL8AwgDDAMQAyQDLAMwAzQDRANUA1wDYANoA4gDmAOcA6ADpAOoA7ADuAPAA9QD3APoA/wECASEBbQA9AEf/7ABI/+wASf/sAEv/7ABV/+wAk//sAJj/7AC6/+wAx//sAMj/7AD2/+wBAv/sAR3/7AEh/+wBOf/sAUv/7AFM/+wBVv/sAm7/7AJv/+wCcP/sAnH/7AJy/+wCiv/sAoz/7AKO/+wCkP/sApL/7AKU/+wClv/sApj/7AKa/+wCnP/sAp7/7AKg/+wCov/sAqT/7ANr/+wDkf/sA5X/7AOY/+wDs//sA7n/7AO+/+wDzP/sA87/7APP/+wD2//sA+z/7AQI/+wECv/sBAz/7AQO/+wEEP/sBBL/7AQU/+wEFv/sBCr/7AQs/+wELv/sBDL/7AAXAFP/7AEX/+wCeP/sAnn/7AJ6/+wCe//sAnz/7ALG/+wCyP/sAsr/7ANx/+wDd//sA5P/7APZ/+wD3f/sBBz/7AQe/+wEIP/sBCL/7AQk/+wEJv/sBCj/7AQw/+wABgAQ/4QAEv+EAW7/hAFy/4QBdv+EAXf/hAAQAC7/7AA5/+wCYv/sAmP/7AJk/+wCZf/sArL/7ALh/+wC4//sAuX/7ALn/+wC6f/sAuv/7AN//+wEM//sBDX/7AAdAAb/8gAL//IAWv/zAF3/8wC8//MBGf/zAWz/8gFt//IBb//yAXD/8gFx//ICgf/zAoL/8wLw//MDc//zA5b/8wOf//MDp//zA6j/8gOp//IDrP/yA7j/8wPA//MD4f/zA+P/8wPl//MEQv/zBET/8wRG//MAPQAn//MAK//zADP/8wA1//MAg//zAJL/8wCX//MAsv/zANL/8wEH//MBFv/zARr/8wEc//MBHv/zASD/8wE4//MBVf/zAij/8wIp//MCK//zAiz/8wJT//MCXf/zAl7/8wJf//MCYP/zAmH/8wKJ//MCi//zAo3/8wKP//MCnf/zAp//8wKh//MCo//zAsX/8wLH//MCyf/zAvr/8wNX//MDZP/zA4r/8wON//MDuv/zA73/8wPY//MD2v/zA9z/8wQb//MEHf/zBB//8wQh//MEI//zBCX/8wQn//MEKf/zBCv/8wQt//MEL//zBDH/8wSq//MAPQAn/+YAK//mADP/5gA1/+YAg//mAJL/5gCX/+YAsv/mANL/5gEH/+YBFv/mARr/5gEc/+YBHv/mASD/5gE4/+YBVf/mAij/5gIp/+YCK//mAiz/5gJT/+YCXf/mAl7/5gJf/+YCYP/mAmH/5gKJ/+YCi//mAo3/5gKP/+YCnf/mAp//5gKh/+YCo//mAsX/5gLH/+YCyf/mAvr/5gNX/+YDZP/mA4r/5gON/+YDuv/mA73/5gPY/+YD2v/mA9z/5gQb/+YEHf/mBB//5gQh/+YEI//mBCX/5gQn/+YEKf/mBCv/5gQt/+YEL//mBDH/5gSq/+YANgAl/+QAPP/SAD3/0wCx/+QAs//kANn/0gEM/+QCTP/kAk3/5AJO/+QCT//kAlD/5AJR/+QCUv/kAmb/0wKD/+QChf/kAof/5ALv/9MC8f/TA1P/5ANY/9MDW//kA2f/0wNo/9IDav/TA4P/5AOP/9IDpv/TA6//5AO//9MDwv/SA8X/5APH/+QD0P/SA+r/0gPv/+QD8f/kA/P/5AP1/+QD9//kA/n/5AP7/+QD/f/kA///5AQB/+QEA//kBAX/5ARB/9MEQ//TBEX/0wRP/9IEV//SBGr/0wAmABD/HgAS/x4AJf/NALH/zQCz/80BDP/NAW7/HgFy/x4Bdv8eAXf/HgJM/80CTf/NAk7/zQJP/80CUP/NAlH/zQJS/80Cg//NAoX/zQKH/80DU//NA1v/zQOD/80Dr//NA8X/zQPH/80D7//NA/H/zQPz/80D9f/NA/f/zQP5/80D+//NA/3/zQP//80EAf/NBAP/zQQF/80ApgBH/9wASP/cAEn/3ABL/9wAUf/zAFL/8wBT/9YAVP/zAFX/3ABZ/90AWv/hAF3/4QCT/9wAmP/cAJr/3QC6/9wAvP/hAMD/8wDH/9wAyP/cAMr/3QDr//MA7//zAPD/8wDy//MA8//zAPT/8wD2/9wA9//zAPn/8wD6//MA/f/zAP//8wEC/9wBBP/zARf/1gEZ/+EBHf/cASH/3AE1//MBOf/cAUT/8wFJ//MBS//cAUz/3AFW/9wCbv/cAm//3AJw/9wCcf/cAnL/3AJ3//MCeP/WAnn/1gJ6/9YCe//WAnz/1gJ9/90Cfv/dAn//3QKA/90Cgf/hAoL/4QKK/9wCjP/cAo7/3AKQ/9wCkv/cApT/3AKW/9wCmP/cApr/3AKc/9wCnv/cAqD/3AKi/9wCpP/cAr//8wLB//MCw//zAsT/8wLG/9YCyP/WAsr/1gLi/90C5P/dAub/3QLo/90C6v/dAuz/3QLw/+EDa//cA23/8wNv/90Dcf/WA3P/4QN2/90Dd//WA3j/3QOR/9wDkv/zA5P/1gOU//MDlf/cA5b/4QOY/9wDmf/zA57/8wOf/+EDp//hA67/8wOz/9wDtP/zA7j/4QO5/9wDvv/cA8D/4QPM/9wDzv/cA8//3APV//MD1//zA9n/1gPb/9wD3f/WA+H/4QPj/+ED5f/hA+n/8wPs/9wECP/cBAr/3AQM/9wEDv/cBBD/3AQS/9wEFP/cBBb/3AQc/9YEHv/WBCD/1gQi/9YEJP/WBCb/1gQo/9YEKv/cBCz/3AQu/9wEMP/WBDL/3AQ0/90ENv/dBDj/3QQ6/90EPP/dBD7/3QRA/90EQv/hBET/4QRG/+EESv/zBEz/8wRW//MEY//zBGX/8wRn//MAcQAG/9oAC//aAEf/8ABI//AASf/wAEv/8ABV//AAWf/vAFr/3ABd/9wAk//wAJj/8ACa/+8Auv/wALz/3ADH//AAyP/wAMr/7wD2//ABAv/wARn/3AEd//ABIf/wATn/8AFL//ABTP/wAVb/8AFs/9oBbf/aAW//2gFw/9oBcf/aAm7/8AJv//ACcP/wAnH/8AJy//ACff/vAn7/7wJ//+8CgP/vAoH/3AKC/9wCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALi/+8C5P/vAub/7wLo/+8C6v/vAuz/7wLw/9wDa//wA2//7wNz/9wDdv/vA3j/7wOR//ADlf/wA5b/3AOY//ADn//cA6f/3AOo/9oDqf/aA6z/2gOz//ADuP/cA7n/8AO+//ADwP/cA8z/8APO//ADz//wA9v/8APh/9wD4//cA+X/3APs//AECP/wBAr/8AQM//AEDv/wBBD/8AQS//AEFP/wBBb/8AQq//AELP/wBC7/8AQy//AENP/vBDb/7wQ4/+8EOv/vBDz/7wQ+/+8EQP/vBEL/3ARE/9wERv/cADQABv+gAAv/oABZ//EAWv/FAF3/xQCa//EAvP/FAMr/8QEZ/8UBbP+gAW3/oAFv/6ABcP+gAXH/oAJ9//ECfv/xAn//8QKA//ECgf/FAoL/xQLi//EC5P/xAub/8QLo//EC6v/xAuz/8QLw/8UDb//xA3P/xQN2//EDeP/xA5b/xQOf/8UDp//FA6j/oAOp/6ADrP+gA7j/xQPA/8UD4f/FA+P/xQPl/8UENP/xBDb/8QQ4//EEOv/xBDz/8QQ+//EEQP/xBEL/xQRE/8UERv/FAD0AR//nAEj/5wBJ/+cAS//nAFX/5wCT/+cAmP/nALr/5wDH/+cAyP/nAPb/5wEC/+cBHf/nASH/5wE5/+cBS//nAUz/5wFW/+cCbv/nAm//5wJw/+cCcf/nAnL/5wKK/+cCjP/nAo7/5wKQ/+cCkv/nApT/5wKW/+cCmP/nApr/5wKc/+cCnv/nAqD/5wKi/+cCpP/nA2v/5wOR/+cDlf/nA5j/5wOz/+cDuf/nA77/5wPM/+cDzv/nA8//5wPb/+cD7P/nBAj/5wQK/+cEDP/nBA7/5wQQ/+cEEv/nBBT/5wQW/+cEKv/nBCz/5wQu/+cEMv/nAHEABgAMAAsADABH/+gASP/oAEn/6ABL/+gAU//qAFX/6ABaAAsAXQALAJP/6ACY/+gAuv/oALwACwDH/+gAyP/oAPb/6AEC/+gBF//qARkACwEd/+gBIf/oATn/6AFL/+gBTP/oAVb/6AFsAAwBbQAMAW8ADAFwAAwBcQAMAm7/6AJv/+gCcP/oAnH/6AJy/+gCeP/qAnn/6gJ6/+oCe//qAnz/6gKBAAsCggALAor/6AKM/+gCjv/oApD/6AKS/+gClP/oApb/6AKY/+gCmv/oApz/6AKe/+gCoP/oAqL/6AKk/+gCxv/qAsj/6gLK/+oC8AALA2v/6ANx/+oDcwALA3f/6gOR/+gDk//qA5X/6AOWAAsDmP/oA58ACwOnAAsDqAAMA6kADAOsAAwDs//oA7gACwO5/+gDvv/oA8AACwPM/+gDzv/oA8//6APZ/+oD2//oA93/6gPhAAsD4wALA+UACwPs/+gECP/oBAr/6AQM/+gEDv/oBBD/6AQS/+gEFP/oBBb/6AQc/+oEHv/qBCD/6gQi/+oEJP/qBCb/6gQo/+oEKv/oBCz/6AQu/+gEMP/qBDL/6ARCAAsERAALBEYACwAMAFz/7QBe/+0A7f/tAvP/7QL1/+0C9//tA5f/7QPD/+0D0f/tA+v/7QRQ/+0EWP/tAAwAXP/yAF7/8gDt//IC8//yAvX/8gL3//IDl//yA8P/8gPR//ID6//yBFD/8gRY//IAHwBa//QAXP/yAF3/9ABe//MAvP/0AO3/8gEZ//QCgf/0AoL/9ALw//QC8//zAvX/8wL3//MDc//0A5b/9AOX//IDn//0A6f/9AO4//QDwP/0A8P/8gPR//ID4f/0A+P/9APl//QD6//yBEL/9ARE//QERv/0BFD/8gRY//IAeQAG/8oAC//KADj/0gA6/9QAPP/0AD3/0wBR/9EAUv/RAFT/0QBa/+YAXP/vAF3/5gC8/+YAwP/RANH/0gDV/9IA2f/0AN3/7QDg/+EA6//RAO3/7wDv/9EA8P/RAPL/0QDz/9EA9P/RAPf/0QD5/9EA+v/RAP3/0QD//9EBBP/RARj/1AEZ/+YBMv/SATX/0QE6/9IBRP/RAUn/0QFs/8oBbf/KAW//ygFw/8oBcf/KAmb/0wJ3/9ECgf/mAoL/5gK//9ECwf/RAsP/0QLE/9EC2//SAt3/0gLf/9IC7//TAvD/5gLx/9MDWP/TA2f/0wNo//QDav/TA23/0QNz/+YDgv/tA47/0gOP//QDkv/RA5T/0QOW/+YDl//vA5n/0QOe/9EDn//mA6b/0wOn/+YDqP/KA6n/ygOs/8oDrv/RA7T/0QO3/9QDuP/mA7//0wPA/+YDwv/0A8P/7wPQ//QD0f/vA9X/0QPX/9ED4P/tA+H/5gPi/+0D4//mA+T/7QPl/+YD5v/hA+n/0QPq//QD6//vBEH/0wRC/+YEQ//TBET/5gRF/9MERv/mBEr/0QRM/9EETf/SBE//9ARQ/+8EUf/hBFP/4QRW/9EEV//0BFj/7wRj/9EEZf/RBGf/0QRq/9MAHQA4/74AWv/vAF3/7wC8/+8A0f++ANX/vgEZ/+8BMv++ATr/vgKB/+8Cgv/vAtv/vgLd/74C3/++AvD/7wNz/+8Djv++A5b/7wOf/+8Dp//vA7j/7wPA/+8D4f/vA+P/7wPl/+8EQv/vBET/7wRG/+8ETf++ADQAOP/mADr/5wA8//IAPf/nAFz/8QDR/+YA1f/mANn/8gDd/+4A4P/oAO3/8QEY/+cBMv/mATr/5gJm/+cC2//mAt3/5gLf/+YC7//nAvH/5wNY/+cDZ//nA2j/8gNq/+cDgv/uA47/5gOP//IDl//xA6b/5wO3/+cDv//nA8L/8gPD//ED0P/yA9H/8QPg/+4D4v/uA+T/7gPm/+gD6v/yA+v/8QRB/+cEQ//nBEX/5wRN/+YET//yBFD/8QRR/+gEU//oBFf/8gRY//EEav/nAIgAJQAQACf/6AAr/+gAM//oADX/6AA4/+AAOv/gAD3/3wCD/+gAkv/oAJf/6ACxABAAsv/oALMAEADR/+AA0v/oANMAEADV/+AA3AAQAOD/4QDxABAA+P/gAQMAEAEH/+gBDAAQARb/6AEY/+ABGv/oARz/6AEe/+gBIP/oATL/4AE4/+gBOv/gAVEAEAFV/+gCKP/oAin/6AIr/+gCLP/oAkwAEAJNABACTgAQAk8AEAJQABACUQAQAlIAEAJT/+gCXf/oAl7/6AJf/+gCYP/oAmH/6AJm/98CgwAQAoUAEAKHABACif/oAov/6AKN/+gCj//oAp3/6AKf/+gCof/oAqP/6ALF/+gCx//oAsn/6ALb/+AC3f/gAt//4ALv/98C8f/fAvr/6ANTABADV//oA1j/3wNbABADZP/oA2f/3wNq/98DgwAQA4r/6AON/+gDjv/gA6b/3wOvABADt//gA7r/6AO9/+gDv//fA8UAEAPHABAD2P/oA9r/6APc/+gD5v/hA+f/4APtABAD7gAQA+8AEAPxABAD8wAQA/UAEAP3ABAD+QAQA/sAEAP9ABAD/wAQBAEAEAQDABAEBQAQBBv/6AQd/+gEH//oBCH/6AQj/+gEJf/oBCf/6AQp/+gEK//oBC3/6AQv/+gEMf/oBEH/3wRD/98ERf/fBE3/4ARR/+EEUv/gBFP/4QRU/+AEaAAQBGkAEARq/98Eqv/oAC0AOP/xADr/9AA8//QAPf/wANH/8QDT//UA1f/xANn/9ADc//UA3f/zARj/9AEy//EBOv/xAVH/9QJm//AC2//xAt3/8QLf//EC7//wAvH/8ANY//ADZ//wA2j/9ANq//ADgv/zA47/8QOP//QDpv/wA7f/9AO///ADwv/0A9D/9APg//MD4v/zA+T/8wPq//QD7f/1BEH/8ARD//AERf/wBE3/8QRP//QEV//0BGj/9QRq//AAWQAlAA8AOP/mADr/5gA8AA4APf/mALEADwCzAA8A0f/mANMADgDV/+YA2QAOANwADgDdAAsA4P/lAPEADwD4/+gBAwAPAQwADwEY/+YBMv/mATr/5gFRAA4CTAAPAk0ADwJOAA8CTwAPAlAADwJRAA8CUgAPAmb/5gKDAA8ChQAPAocADwLb/+YC3f/mAt//5gLv/+YC8f/mA1MADwNY/+YDWwAPA2f/5gNoAA4Dav/mA4IACwODAA8Djv/mA48ADgOm/+YDrwAPA7f/5gO//+YDwgAOA8UADwPHAA8D0AAOA+AACwPiAAsD5AALA+b/5QPn/+gD6gAOA+0ADgPuAA8D7wAPA/EADwPzAA8D9QAPA/cADwP5AA8D+wAPA/0ADwP/AA8EAQAPBAMADwQFAA8EQf/mBEP/5gRF/+YETf/mBE8ADgRR/+UEUv/oBFP/5QRU/+gEVwAOBGgADgRpAA8Eav/mAC4AOP/jADz/5QA9/+QA0f/jANP/5QDV/+MA2f/lANz/5QDd/+kA8f/qAQP/6gEy/+MBOv/jAVH/5QJm/+QC2//jAt3/4wLf/+MC7//kAvH/5ANY/+QDZ//kA2j/5QNq/+QDgv/pA47/4wOP/+UDpv/kA7//5APC/+UD0P/lA+D/6QPi/+kD5P/pA+r/5QPt/+UD7v/qBEH/5ARD/+QERf/kBE3/4wRP/+UEV//lBGj/5QRp/+oEav/kACEAOP/iADz/5ADR/+IA0//kANX/4gDZ/+QA3P/kAN3/6QDx/+sBA//rATL/4gE6/+IBUf/kAtv/4gLd/+IC3//iA2j/5AOC/+kDjv/iA4//5APC/+QD0P/kA+D/6QPi/+kD5P/pA+r/5APt/+QD7v/rBE3/4gRP/+QEV//kBGj/5ARp/+sAFwA4/+sAPf/zANH/6wDV/+sBMv/rATr/6wJm//MC2//rAt3/6wLf/+sC7//zAvH/8wNY//MDZ//zA2r/8wOO/+sDpv/zA7//8wRB//MEQ//zBEX/8wRN/+sEav/zADAAUf/vAFL/7wBU/+8AXP/wAMD/7wDr/+8A7f/wAO//7wDw/+8A8v/vAPP/7wD0/+8A9//vAPn/7wD6/+8A/f/vAP//7wEE/+8BNf/vAUT/7wFJ/+8Cd//vAr//7wLB/+8Cw//vAsT/7wNt/+8Dkv/vA5T/7wOX//ADmf/vA57/7wOu/+8DtP/vA8P/8APR//AD1f/vA9f/7wPp/+8D6//wBEr/7wRM/+8EUP/wBFb/7wRY//AEY//vBGX/7wRn/+8AHQAG//IAC//yAFr/9QBd//UAvP/1ARn/9QFs//IBbf/yAW//8gFw//IBcf/yAoH/9QKC//UC8P/1A3P/9QOW//UDn//1A6f/9QOo//IDqf/yA6z/8gO4//UDwP/1A+H/9QPj//UD5f/1BEL/9QRE//UERv/1AAQA+P/tA+f/7QRS/+0EVP/tAFQAR//wAEj/8ABJ//AAS//wAFP/6wBV//AAk//wAJj/8AC6//AAx//wAMj/8AD2//ABAv/wARf/6wEd//ABIf/wATn/8AFL//ABTP/wAVb/8AJu//ACb//wAnD/8AJx//ACcv/wAnj/6wJ5/+sCev/rAnv/6wJ8/+sCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALG/+sCyP/rAsr/6wNr//ADcf/rA3f/6wOR//ADk//rA5X/8AOY//ADs//wA7n/8AO+//ADzP/wA87/8APP//AD2f/rA9v/8APd/+sD7P/wBAj/8AQK//AEDP/wBA7/8AQQ//AEEv/wBBT/8AQW//AEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/8AQs//AELv/wBDD/6wQy//AAjwAGAA0ACwANAEX/8ABH/7AASP+wAEn/sABL/7AAU//WAFX/sABaAAsAXQALAJP/sACY/7AAuv+wALwACwDI/7AA8f+vAPb/sAEC/7ABA/+vARf/1gEZAAsBHf+wASH/sAE5/7ABS/+wAUz/sAFW/7ABbAANAW0ADQFvAA0BcAANAXEADQJn//ACaP/wAmn/8AJq//ACa//wAmz/8AJt//ACbv+wAm//sAJw/7ACcf+wAnL/sAJ4/9YCef/WAnr/1gJ7/9YCfP/WAoEACwKCAAsChP/wAob/8AKI//ACiv+wAoz/sAKO/7ACkP+wApL/sAKU/7AClv+wApj/sAKa/7ACnP+wAp7/sAKg/7ACov+wAqT/sALG/9YCyP/WAsr/1gLwAAsDa/+wA3H/1gNzAAsDd//WA5D/8AOR/7ADk//WA5X/sAOWAAsDmP+wA58ACwOnAAsDqAANA6kADQOsAA0DsP/wA7P/sAO4AAsDuf+wA77/sAPAAAsDxv/wA8j/8APM/7ADzv+wA8//sAPZ/9YD2/+wA93/1gPhAAsD4wALA+UACwPs/7AD7v+vA/D/8APy//AD9P/wA/b/8AP4//AD+v/wA/z/8AP+//AEAP/wBAL/8AQE//AEBv/wBAj/sAQK/7AEDP+wBA7/sAQQ/7AEEv+wBBT/sAQW/7AEHP/WBB7/1gQg/9YEIv/WBCT/1gQm/9YEKP/WBCr/sAQs/7AELv+wBDD/1gQy/7AEQgALBEQACwRGAAsEaf+vAAgA8QAQAPj/8AEDABAD5//wA+4AEARS//AEVP/wBGkAEABFAEcADABIAAwASQAMAEsADABVAAwAkwAMAJgADAC6AAwAxwAMAMgADADxABgA9gAMAPj/9wECAAwBAwAYAR0ADAEhAAwBOQAMAUsADAFMAAwBVgAMAm4ADAJvAAwCcAAMAnEADAJyAAwCigAMAowADAKOAAwCkAAMApIADAKUAAwClgAMApgADAKaAAwCnAAMAp4ADAKgAAwCogAMAqQADANrAAwDkQAMA5UADAOYAAwDswAMA7kADAO+AAwDzAAMA84ADAPPAAwD2wAMA+f/9wPsAAwD7gAYBAgADAQKAAwEDAAMBA4ADAQQAAwEEgAMBBQADAQWAAwEKgAMBCwADAQuAAwEMgAMBFL/9wRU//cEaQAYAB8AWv/0AFz/8ABd//QAvP/0AO3/8ADx//MBA//zARn/9AKB//QCgv/0AvD/9ANz//QDlv/0A5f/8AOf//QDp//0A7j/9APA//QDw//wA9H/8APh//QD4//0A+X/9APr//AD7v/zBEL/9ARE//QERv/0BFD/8ARY//AEaf/zAAoABv/WAAv/1gFs/9YBbf/WAW//1gFw/9YBcf/WA6j/1gOp/9YDrP/WAAoABv/1AAv/9QFs//UBbf/1AW//9QFw//UBcf/1A6j/9QOp//UDrP/1ACEATAAgAE8AIABQACAAU/+AAFf/kAEX/4ACeP+AAnn/gAJ6/4ACe/+AAnz/gALG/4ACyP+AAsr/gALS/5AC1P+QAtb/kALY/5AC2v+QA3H/gAN3/4ADk/+AA5r/kAPZ/4AD3f+ABBz/gAQe/4AEIP+ABCL/gAQk/4AEJv+ABCj/gAQw/4AAAgeKAAQAAApeEb4AIQAdAAAAEf/O/48AEv/1/+//iP/0/7v/f//1AAz/qf+i/8kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+UAAAAA/+j/yQAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAD/5QARAAAAAAAAAAAAAP/jAAAAAAAA/+T/5AAAABIAEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/4QAAAAAAAAAAAAAAAAAAAAD/5QAAAAD/6v/VAAAAAP/r/+r/mv/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+YAAAAAAAAAAAAA/+0AAAAU/+8AAAAAAAAAAAAAAAAAAAAAAAD/7QAAAAAAAAAAAAAAAAAAAAD/y/+4/3z/fv/kAAAAAP+dAA8AEP+h/8QAEAAQAAAAAP+xAAD/JgAA/53/s/8Y/5P/8P+P/4z/EAAA/5L/cv8M/w//vQAAAAD/RAAFAAf/S/+GAAcABwAAAAD/PgAA/noAAP9E/2r+Yv8z/9H/LP8nAAAAAAAAAAAAAP/YAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAAAAAAAP/Y/6MAAP/hAAAAAP/lAAAAAP/pAAAAAAAAAAAAAAAAAAAAAAAA/+YAAP/A/+kAAAAAAAAAAAAAAAD/ewAAAAD/v//K/rAAAP9x/u3/1AAA/1H/EQAAAAAAEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAA8AAP/ZAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAA/3b/4f68/+b/8wAAAAAAAAAA//UAAP84AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9QAAAAD/8wAAAAD/0gAAAAD/5AAAAAAAAAAAAAD/tQAA/x8AAP/UAAD/2wAAAAD/0gAAAAAAAAAR/+H/0QAR/+cAAAAA/+sAAAAA/+sAAAAOAAAAAAAAAAAAAAAAAAD/5gAA/9IAAAAAAAAAAAAAAAAAAP/sAAAAAP/j/6AAAP+/ABEAEf/Z/+IAEgASAAAAAP+iAA3/LQAA/7//6f/M/9j/8P+3/8b/oAAAAAAAAAAAAAAAAAAAAAD/4QAAAA7/7QAAAAAAAAAAAAD/1QAA/4UAAP/hAAD/xAAAAAD/3wAAAAAAAAAA/+UAAAAA/+YAAAAA/+sAAAAA/+0AAAAAAAAAAAAAAA0AAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAD/ygAA/+n/u//pAAAAAP+9AAAAEgAAAAAAAAASAAAAAP+lAAD+bQAA/70AAP+J/5oAAP+R/9IAAAAAAAD/8QAAAAAAAAAA/70AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAD/8gAAAAD/4wAAAAAAAAAA//EAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAAAAD/8wAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/xAAD/8AAAAAD/eAAAAAAAAAAA//AAAAAAAAAAAAAAAAAAAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAAAA//8QAAAAAAAAAAAAAAAAAAAAAAAAAA/5UAAP/zAAAAAAAAAAD/8QAAAAAAAAAAABIAAAAAAAAAAAAQ/+wAAAAAAAAAAAAAAAAAAAAAAAAAAP+FAAD/7QAAAAAAAAAA/9gAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+V/8MAAAAAAAAAAAAAAAAAAAAA/4gAAAAAAAD/xQAAAAD/7AAA/87/sAAAAAAAAAAAAAAAAAAAAAD/VgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//UAAAAAAAAAAAAA/8AAAAAA/vUAAAAA/8j/rf/n/+sAAP/wAAAAAAAA/8kAAAAAAAAAAAAAAAAAAAAA/93/2QAAAAAAAP95AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAIAeAAGAAYAAAALAAsAAQAQABAAAgASABIAAwAlACkABAAsADQACQA4AD4AEgBFAEcAGQBJAEkAHABMAEwAHQBRAFQAHgBWAFYAIgBaAFoAIwBcAF4AJACKAIoAJwCwALMAKAC8ALwALADAAMAALQDGAMYALgDTANQALwDWANYAMQDZANkAMgDbAN0AMwDfAN8ANgDhAOEANwDjAOMAOADlAOUAOQDrAOsAOgDtAO0AOwD2APYAPAD7APsAPQD9AP4APgEDAQQAQAEJAQkAQgEMAQwAQwEXARkARAErAS0ARwEwATAASgEyATIASwFJAUkATAFsAXIATQF2AXcAVAIoAigAVgIqAisAVwJHAkgAWQJKAkoAWwJMAnIAXAJ3AnwAgwKBApEAiQKTApwAmgKlAqcApAKpAqkApwKrAqsAqAKtAq0AqQKvAq8AqgKyArIAqwK0ArQArAK2ArYArQK4ArgArgK6AroArwK8ArwAsAK+AsoAsQLMAswAvgLOAs4AvwLQAtAAwALbAtsAwQLdAt0AwgLfAt8AwwLhAuEAxALjAuMAxQLlAuUAxgLnAucAxwLpAukAyALrAusAyQLtAu0AygLvAvcAywNTA1gA1ANbA2oA2gNtA20A6gNxA3EA6wNzA3MA7AN3A3cA7QN6A3sA7gN9A4YA8AOIA4oA+gOMA5EA/QOTA5kBAwOfA6ABCgOiA6IBDAOkA6QBDQOmA6kBDgOsA7EBEgOzA7MBGAO3A7gBGQO9A8gBGwPLA8wBJwPOA9EBKQPYA9kBLQPdA90BLwPfA+UBMAPqA+sBNwPvBBcBOQQZBBkBYgQbBCgBYwQwBDABcQQzBDMBcgQ1BDUBcwRBBEYBdARJBEkBegRLBEsBewRNBE0BfARPBFABfQRVBFgBfwRbBFsBgwRdBF4BhARgBGABhgRkBGQBhwRmBGYBiARqBGoBiQSqBKoBigACAToABgAGAB0ACwALAB0AEAAQAB4AEgASAB4AJgAmAAEAJwAnAAQAKAAoAAMAKQApAAUALAAtAAIALgAuAAwALwAvAAkAMAAwAAoAMQAyAAIAMwAzAAMANAA0AAsAOAA4AAYAOQA5AAwAOgA6AA0AOwA7ABAAPAA8AA4APQA9AA8APgA+ABEARQBFABMARgBGABUARwBHABQASQBJABYATABMABcAUQBSABcAUwBTABgAVABUABUAVgBWABoAWgBaABkAXABcABsAXQBdABkAXgBeABwAigCKABUAsACwAAcAsgCyAAMAvAC8ABkAwADAABcAxgDGABUA0wDUAB8A1gDWAAIA2QDZAA4A2wDcAAIA3QDdABIA3wDfAAIA4QDhAAIA4wDjAB8A5QDlAB8A6wDrAAgA7QDtABsA9gD2ABUA+wD7ACAA/QD9ACAA/gD+ABUBAwEEACABCQEJACABFwEXABgBGAEYAA0BGQEZABkBKwErABUBLAEsAAcBLQEtAAgBMAEwAAkBMgEyAAkBSQFJAAgBbAFtAB0BbgFuAB4BbwFxAB0BcgFyAB4BdgF3AB4CKAIoAAQCKgIrAAMCRwJIAAMCSgJKAAYCUwJTAAQCVAJXAAUCWAJcAAICXQJhAAMCYgJlAAwCZgJmAA8CZwJtABMCbgJuABQCbwJyABYCdwJ3ABcCeAJ8ABgCgQKCABkChAKEABMChgKGABMCiAKIABMCiQKJAAQCigKKABQCiwKLAAQCjAKMABQCjQKNAAQCjgKOABQCjwKPAAQCkAKQABQCkQKRAAMCkwKTAAUClAKUABYClQKVAAUClgKWABYClwKXAAUCmAKYABYCmQKZAAUCmgKaABYCmwKbAAUCnAKcABYCpQKlAAICpgKmABcCpwKnAAICqQKpAAICqwKrAAICrQKtAAICrwKvAAICsgKyAAwCtAK0AAkCtgK2AAoCuAK4AAoCugK6AAoCvAK8AAoCvgK+AAICvwK/ABcCwALAAAICwQLBABcCwgLCAAICwwLEABcCxQLFAAMCxgLGABgCxwLHAAMCyALIABgCyQLJAAMCygLKABgCzALMABoCzgLOABoC0ALQABoC2wLbAAYC3QLdAAYC3wLfAAYC4QLhAAwC4wLjAAwC5QLlAAwC5wLnAAwC6QLpAAwC6wLrAAwC7QLtABAC7wLvAA8C8ALwABkC8QLxAA8C8gLyABEC8wLzABwC9AL0ABEC9QL1ABwC9gL2ABEC9wL3ABwDVANUAAUDVQNWAAIDVwNXAAMDWANYAA8DXANcAAEDXQNdAAUDXgNeABEDXwNgAAIDYQNhAAkDYgNjAAIDZANkAAMDZQNlAAsDZgNmAAYDZwNnAA8DaANoAA4DaQNpAAIDagNqAA8DbQNtABcDcQNxABgDcwNzABkDdwN3ABgDegN6AAUDewN7AAcDfQN+AAIDfwN/AAwDgAOBAAkDggOCABIDhAOEAAEDhQOFAAcDhgOGAAUDiAOJAAIDigOKAAMDjAOMAAsDjQONAAQDjgOOAAYDjwOPAA4DkAOQABMDkQORABYDkwOTABgDlAOUABUDlQOVABQDlgOWABkDlwOXABsDmAOYABYDmQOZAAgDnwOfABkDoAOgABADogOiABADpAOkABADpgOmAA8DpwOnABkDqAOpAB0DrAOsAB0DrQOtAAIDrgOuABcDsAOwABMDsQOxAAUDswOzABYDtwO3AA0DuAO4ABkDvQO9AAQDvgO+ABQDvwO/AA8DwAPAABkDwQPBAAIDwgPCAA4DwwPDABsDxAPEAAIDxgPGABMDyAPIABMDywPLAAUDzAPMABYDzgPPABYD0APQAA4D0QPRABsD2APYAAMD2QPZABgD3QPdABgD3wPfABUD4APgABID4QPhABkD4gPiABID4wPjABkD5APkABID5QPlABkD6gPqAA4D6wPrABsD8APwABMD8gPyABMD9AP0ABMD9gP2ABMD+AP4ABMD+gP6ABMD/AP8ABMD/gP+ABMEAAQAABMEAgQCABMEBAQEABMEBgQGABMEBwQHAAUECAQIABYECQQJAAUECgQKABYECwQLAAUEDAQMABYEDQQNAAUEDgQOABYEDwQPAAUEEAQQABYEEQQRAAUEEgQSABYEEwQTAAUEFAQUABYEFQQVAAUEFgQWABYEFwQXAAIEGQQZAAIEGwQbAAMEHAQcABgEHQQdAAMEHgQeABgEHwQfAAMEIAQgABgEIQQhAAMEIgQiABgEIwQjAAMEJAQkABgEJQQlAAMEJgQmABgEJwQnAAMEKAQoABgEMAQwABgEMwQzAAwENQQ1AAwEQQRBAA8EQgRCABkEQwRDAA8ERAREABkERQRFAA8ERgRGABkESQRJAAkESwRLAAIETQRNAAYETwRPAA4EUARQABsEVQRVAAcEVgRWAAgEVwRXAA4EWARYABsEWwRbABcEXQRdAB8EXgReAAcEYARgAAkEZARkAAIEZgRmAAIEagRqAA8EqgSqAAMAAgFtAAYABgAHAAsACwAHABAAEAATABEAEQAXABIAEgATACUAJQARACcAJwAFACsAKwAFAC4ALgAcADMAMwAFADUANQAFADcANwAZADgAOAAKADkAOQAGADoAOgANADsAOwAJADwAPAASAD0APQAOAD4APgAUAEUARQAaAEcASQAVAEsASwAVAFEAUgAYAFMAUwAIAFQAVAAYAFUAVQAVAFcAVwAbAFkAWQALAFoAWgACAFwAXAAWAF0AXQACAF4AXgAMAIMAgwAFAJIAkgAFAJMAkwAVAJcAlwAFAJgAmAAVAJoAmgALALEAsQARALIAsgAFALMAswARALoAugAVALwAvAACAMAAwAAYAMcAyAAVAMoAygALANEA0QAKANIA0gAFANMA0wABANUA1QAKANkA2QASANwA3AABAN0A3QAQAOAA4AAPAOsA6wAYAO0A7QAWAO8A8AAYAPEA8QAEAPIA9AAYAPYA9gAVAPcA9wAYAPgA+AADAPkA+gAYAP0A/QAYAP8A/wAYAQIBAgAVAQMBAwAEAQQBBAAYAQcBBwAFAQwBDAARARYBFgAFARcBFwAIARgBGAANARkBGQACARoBGgAFARwBHAAFAR0BHQAVAR4BHgAFASABIAAFASEBIQAVATIBMgAKATUBNQAYATgBOAAFATkBOQAVAToBOgAKAUQBRAAYAUkBSQAYAUsBTAAVAVEBUQABAVUBVQAFAVYBVgAVAWkBagAXAWwBbQAHAW4BbgATAW8BcQAHAXIBcgATAXYBdwATAigCKQAFAisCLAAFAkYCRgAXAkwCUgARAlMCUwAFAl0CYQAFAmICZQAGAmYCZgAOAmcCbQAaAm4CcgAVAncCdwAYAngCfAAIAn0CgAALAoECggACAoMCgwARAoQChAAaAoUChQARAoYChgAaAocChwARAogCiAAaAokCiQAFAooCigAVAosCiwAFAowCjAAVAo0CjQAFAo4CjgAVAo8CjwAFApACkAAVApICkgAVApQClAAVApYClgAVApgCmAAVApoCmgAVApwCnAAVAp0CnQAFAp4CngAVAp8CnwAFAqACoAAVAqECoQAFAqICogAVAqMCowAFAqQCpAAVArICsgAcAr8CvwAYAsECwQAYAsMCxAAYAsUCxQAFAsYCxgAIAscCxwAFAsgCyAAIAskCyQAFAsoCygAIAtEC0QAZAtIC0gAbAtMC0wAZAtQC1AAbAtUC1QAZAtYC1gAbAtcC1wAZAtgC2AAbAtkC2QAZAtoC2gAbAtsC2wAKAt0C3QAKAt8C3wAKAuEC4QAGAuIC4gALAuMC4wAGAuQC5AALAuUC5QAGAuYC5gALAucC5wAGAugC6AALAukC6QAGAuoC6gALAusC6wAGAuwC7AALAu0C7QAJAu8C7wAOAvAC8AACAvEC8QAOAvIC8gAUAvMC8wAMAvQC9AAUAvUC9QAMAvYC9gAUAvcC9wAMAvoC+gAFA1MDUwARA1cDVwAFA1gDWAAOA1sDWwARA14DXgAUA2QDZAAFA2cDZwAOA2gDaAASA2oDagAOA2sDawAVA20DbQAYA28DbwALA3EDcQAIA3MDcwACA3YDdgALA3cDdwAIA3gDeAALA38DfwAcA4IDggAQA4MDgwARA4oDigAFA40DjQAFA44DjgAKA48DjwASA5ADkAAaA5EDkQAVA5IDkgAYA5MDkwAIA5QDlAAYA5UDlQAVA5YDlgACA5cDlwAWA5gDmAAVA5kDmQAYA5oDmgAbA54DngAYA58DnwACA6ADoAAJA6IDogAJA6QDpAAJA6YDpgAOA6cDpwACA6gDqQAHA6wDrAAHA64DrgAYA68DrwARA7ADsAAaA7MDswAVA7QDtAAYA7cDtwANA7gDuAACA7kDuQAVA7oDugAFA70DvQAFA74DvgAVA78DvwAOA8ADwAACA8IDwgASA8MDwwAWA8UDxQARA8YDxgAaA8cDxwARA8gDyAAaA8wDzAAVA84DzwAVA9AD0AASA9ED0QAWA9UD1QAYA9cD1wAYA9gD2AAFA9kD2QAIA9oD2gAFA9sD2wAVA9wD3AAFA90D3QAIA+AD4AAQA+ED4QACA+ID4gAQA+MD4wACA+QD5AAQA+UD5QACA+YD5gAPA+cD5wADA+kD6QAYA+oD6gASA+sD6wAWA+wD7AAVA+0D7QABA+4D7gAEA+8D7wARA/AD8AAaA/ED8QARA/ID8gAaA/MD8wARA/QD9AAaA/UD9QARA/YD9gAaA/cD9wARA/gD+AAaA/kD+QARA/oD+gAaA/sD+wARA/wD/AAaA/0D/QARA/4D/gAaA/8D/wARBAAEAAAaBAEEAQARBAIEAgAaBAMEAwARBAQEBAAaBAUEBQARBAYEBgAaBAgECAAVBAoECgAVBAwEDAAVBA4EDgAVBBAEEAAVBBIEEgAVBBQEFAAVBBYEFgAVBBsEGwAFBBwEHAAIBB0EHQAFBB4EHgAIBB8EHwAFBCAEIAAIBCEEIQAFBCIEIgAIBCMEIwAFBCQEJAAIBCUEJQAFBCYEJgAIBCcEJwAFBCgEKAAIBCkEKQAFBCoEKgAVBCsEKwAFBCwELAAVBC0ELQAFBC4ELgAVBC8ELwAFBDAEMAAIBDEEMQAFBDIEMgAVBDMEMwAGBDQENAALBDUENQAGBDYENgALBDgEOAALBDoEOgALBDwEPAALBD4EPgALBEAEQAALBEEEQQAOBEIEQgACBEMEQwAOBEQERAACBEUERQAOBEYERgACBEoESgAYBEwETAAYBE0ETQAKBE8ETwASBFAEUAAWBFEEUQAPBFIEUgADBFMEUwAPBFQEVAADBFYEVgAYBFcEVwASBFgEWAAWBGMEYwAYBGUEZQAYBGcEZwAYBGgEaAABBGkEaQAEBGoEagAOBHAEcAAXBKoEqgAFAAEAAAAKAgYG8AAEREZMVAAaY3lybABIZ3JlawB2bGF0bgCkAAQAAAAA//8AEgAAAAoAFAAeACgANABBAEsAVQBfAGkAcwB9AIcAkQCbAKUArwAEAAAAAP//ABIAAQALABUAHwApADUAQgBMAFYAYABqAHQAfgCIAJIAnACmALAABAAAAAD//wASAAIADAAWACAAKgA2AEMATQBXAGEAawB1AH8AiQCTAJ0ApwCxACgABkFaRSAAVENSVCAAfk1PTCAAqE5BViAA1FJPTSABAFRVUiABLAAA//8AEwADAA0AFwAhACsAMgA3AEQATgBYAGIAbAB2AIAAigCUAJ4AqACyAAD//wASAAQADgAYACIALAA4AEUATwBZAGMAbQB3AIEAiwCVAJ8AqQCzAAD//wASAAUADwAZACMALQA5AEYAUABaAGQAbgB4AIIAjACWAKAAqgC0AAD//wATAAYAEAAaACQALgA6AD4ARwBRAFsAZQBvAHkAgwCNAJcAoQCrALUAAP//ABMABwARABsAJQAvADsAPwBIAFIAXABmAHAAegCEAI4AmACiAKwAtgAA//8AEwAIABIAHAAmADAAPABAAEkAUwBdAGcAcQB7AIUAjwCZAKMArQC3AAD//wATAAkAEwAdACcAMQAzAD0ASgBUAF4AaAByAHwAhgCQAJoApACuALgAuWMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmxpZ2EEfGxpZ2EEhGxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxvY2wEkGxvY2wElmxvY2wEnG51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqHBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5AAAAAEAAAAAAAIAAgADAAAAAQAHAAAAAQAYAAAAAwAVABYAFwAAAAIACAAJAAAAAQAJAAAAAQAUAAAAAQAEAAAAAQAGAAAAAQAFAAAAAQAZAAAAAQARAAAAAQATAAAAAQABAAAAAQAKAAAAAQALAAAAAQAMAAAAAQANAAAAAQAOAAAAAQAPAAAAAQAQAAAAAQASABsAOAPGBrQHYA3wDfAOBg4oDl4OhA6yDsYO2g7uDwAPGg9cD3oPmA/KD/wQLhBCEHoQbBB6EKYAAQAAAAEACAACAcQA3wHnAboBuwG8Ab0BvgG/AcABwQHCAcMBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0AHRAdIB0wHoAekCRAI7AeoB6wHsAe0B7gHvAfAB8QHyAfMB9AH1AfYB9wH4AfkB+gH7AfwB/QH+AgACAQTdAgICAwIEAgUCBgIHAggCCQIKAgsCLwIPAhACEQIUAhUCFgIXAhgCGQIbAhwCHgIdAvwC/QL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZAxoDGwMcAx0DHgMfAyADIQMiAyMDJAMlAyYDJwMoAykDKgMrAywDLQMuAy8DMAMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNPA1ADUQNSBKsErAStBK4ErwSwBLEEsgSzBLQEtQS2BLcEuAS5BLoEuwS8BL0EvgS/BMAEwQTCBMMExATFBMYB/wTHBMgEyQTKBMsEzATNBM4EzwTQBNEE0gTTBNQE1QTWBNgE2QTbAhoE3AIOBNcCEwINBNoCDAISAAEA3wAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAhQCSALAAsQCyALMAtAC1ALYAtwC4ALkA0QDSANMA1ADVANYA1wDYANkA2gDbANwA3QDeAN8A4ADhAOIA4wDkAOUA5gDnAOgBLAEwATIBOAE6ATwBPgE/AUUBRgF/AYUBigGNAkcCSAJKAkwCTQJOAk8CUAJRAlICUwJUAlUCVgJXAlgCWQJaAlsCXAJdAl4CXwJgAmECYgJjAmQCZQJmAoMChQKHAokCiwKNAo8CkQKTApUClwKZApsCnQKfAqECowKlAqcCqQKrAq0CrwKyArQCtgK4AroCvAK+AsACwgLFAscCyQLLAs0CzwLRAtMC1QLZAtsC3QLfAuEC4wLlAucC6QLrAu0C7wLxAvIC9AL2A1MDVANVA1YDVwNYA1kDWwNcA10DXgNfA2ADYQNiA2QDZQNmA2cDaANpA2oDegN7A3wDfQN+A38DgAOBA4IDgwOEA4UDhgOHA4gDiQOKA4sDjAONA44DjwO7A70DvwPUA9oD4ARJBEsETwRXBFkEXgRqAAEAAAABAAgAAgF0ALcBugG7AbwBvQG+Ab8BwAHBAcIBwwHEAcUBxgHHAcgByQHKAcsBzAHNAc4BzwHQAdEB0gHTAv0DMAI7AfoEygTLAfsB/AH9Af4B/wIABM4EzwTRBNQE3QICAgMCBAIFAgYCBwIIAgkCCgILAfQB9QH2AfcB+AH5Ai8CDwIQAhECFAIVAhcCGQL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZA08DGgMbAxwDHQMeAx8DIAMhAyIDIwMkAyUDJgMnAygDKQMqAysDLAMtAy4DLwMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNQA1EDUgTJBMwEzQTQBNIE0wIBBNUEwQTCBMMExATFBMYExwTIBNYE2ATZAhgE2wIaBNwC/AIOBNcCEwINBNoCFgIMAhIAAQC3AEUARgBHAEgASQBKAEsATABNAE4ATwBQAFEAUgBTAFQAVQBWAFcAWABZAFoAWwBcAF0AXgCHAIwAkwDpAOoA6wDsAO0A7gDvAPAA8QDyAPMA9AD1APYA9wD4APkA+gD7APwA/QD+AP8BAAEBAQIBAwEEAQUBBgEtATEBMwE5ATsBPQFAAUcCSwJnAmgCaQJqAmsCbAJtAm4CbwJwAnECcgJzAnQCdQJ2AncCeAJ5AnoCewJ8An0CfgJ/AoACgQKCAoQChgKIAooCjAKOApACkgKUApYCmAKaApwCngKgAqICpAKmAqgCqgKsAq4CswK1ArcCuQK7Ar0CvwLBAsMCxgLIAsoCzALOAtAC0gLUAtYC2gLcAt4C4ALiAuQC5gLoAuoC7ALuAvAC8wL1AvcDkAORA5IDkwOUA5UDlgOXA5gDmQOaA5sDnAOdA54DnwO8A74DwAPOA9UD2wPhBEcESgRMBFAEWARaBFsEXwRrAAYAAAAGABIAKgBCAFoAcgCKAAMAAAABABIAAQCQAAEAAAAaAAEAAQBNAAMAAAABABIAAQB4AAEAAAAaAAEAAQBOAAMAAAABABIAAQBgAAEAAAAaAAEAAQKuAAMAAAABABIAAQBIAAEAAAAaAAEAAQObAAMAAAABABIAAQAwAAEAAAAaAAEAAQOdAAMAAAABABIAAQAYAAEAAAAaAAEAAQQaAAIAAQCnAKsAAAAEAAAAAQAIAAEGHgA2AHIApACuALgAygD8AQ4BGAFKAWQBfgGQAboB7AH2AhgCMgJEAnYCiAKiAswC3gMQAxoDJAM2A2gDcgN8A4YDoAO6A8wD9gQoBDIEVARuBIAEsgTEBN4FCAUaBSQFLgU4BUIFbAWWBcAF6gYUAAYADgAUABoAIAAmACwCTAACAKcCTQACAKgCTwACAKkD8QACAKoEewACAKsD7wACAKwAAQAEBIgAAgCsAAEABAKJAAIAqAACAAYADASKAAIArASMAAIBogAGAA4AFAAaACAAJgAsAlQAAgCnAlUAAgCoBAsAAgCpBAkAAgCqBH0AAgCrBAcAAgCsAAIABgAMBHcAAgCoAqMAAgGiAAEABASOAAIArAAGAA4AFAAaACAAJgAsAlgAAgCnAlkAAgCoAqcAAgCpBBcAAgCqBH8AAgCrBBkAAgCsAAMACAAOABQEkAACAKgEkgACAKwCtAACAaIAAwAIAA4AFAK2AAIAqASUAAIArAK4AAIBogACAAYADAOtAAIAqASWAAIArAAFAAwAEgAYAB4AJAR5AAIApwK+AAIAqAJcAAIAqQSYAAIArALAAAIBogAGAA4AFAAaACAAJgAsAl0AAgCnAl4AAgCoAmAAAgCpBB0AAgCqBIEAAgCrBBsAAgCsAAEABASaAAIAqAAEAAoAEAAWABwCywACAKgEgwACAKsEnAACAKwCzQACAaIAAwAIAA4AFALRAAIAqASeAAIArALXAAIBogACAAYADASgAAIArALbAAIBogAGAA4AFAAaACAAJgAsAmIAAgCnAmMAAgCoAuEAAgCpBDUAAgCqBIUAAgCrBDMAAgCsAAIABgAMBKIAAgCpBKQAAgCsAAMACAAOABQDoAACAKcDogACAKgEpgACAKwABQAMABIAGAAeACQDpgACAKcCZgACAKgERQACAKkEQwACAKoEQQACAKwAAgAGAAwC8gACAKgEqAACAKwABgAOABQAGgAgACYALAJnAAIApwJoAAIAqAJqAAIAqQPyAAIAqgR8AAIAqwPwAAIArAABAAQEiQACAKwAAQAEAooAAgCoAAIABgAMBIsAAgCsBI0AAgGiAAYADgAUABoAIAAmACwCbwACAKcCcAACAKgEDAACAKkECgACAKoEfgACAKsECAACAKwAAQAEBHgAAgCoAAEABASPAAIArAABAAQEGgACAKwAAwAIAA4AFASRAAIAqASTAAIArAK1AAIBogADAAgADgAUArcAAgCoBJUAAgCsArkAAgGiAAIABgAMA64AAgCoBJcAAgCsAAUADAASABgAHgAkBHoAAgCnAr8AAgCoAncAAgCpBJkAAgCsAsEAAgGiAAYADgAUABoAIAAmACwCeAACAKcCeQACAKgCewACAKkEHgACAKoEggACAKsEHAACAKwAAQAEBJsAAgCoAAQACgAQABYAHALMAAIAqASEAAIAqwSdAAIArALOAAIBogADAAgADgAUAtIAAgCoBJ8AAgCsAtgAAgGiAAIABgAMBKEAAgCsAtwAAgGiAAYADgAUABoAIAAmACwCfQACAKcCfgACAKgC4gACAKkENgACAKoEhgACAKsENAACAKwAAgAGAAwEowACAKkEpQACAKwAAwAIAA4AFAOhAAIApwOjAAIAqASnAAIArAAFAAwAEgAYAB4AJAOnAAIApwKBAAIAqARGAAIAqQREAAIAqgRCAAIArAACAAYADALzAAIAqASpAAIArAABAAQC+AACAKgAAQAEAvoAAgCoAAEABAL5AAIAqAABAAQC+wACAKgABQAMABIAGAAeACQCcwACAKcCdAACAKgCqAACAKkEGAACAKoEgAACAKsABQAMABIAGAAeACQEKwACAKcEKQACAKgELwACAKkELQACAKoEMQACAKwABQAMABIAGAAeACQELAACAKcEKgACAKgEMAACAKkELgACAKoEMgACAKwABQAMABIAGAAeACQEOQACAKcENwACAKgEPQACAKkEOwACAKoEPwACAKwABQAMABIAGAAeACQEOgACAKcEOAACAKgEPgACAKkEPAACAKoEQAACAKwAAQAEBIcAAgCoAAIAEQAlACkAAAArAC0ABQAvADQACAA2ADsADgA9AD4AFABFAEkAFgBLAE0AGwBPAFQAHgBWAFsAJABdAF4AKgCBAIEALACDAIMALQCGAIYALgCJAIkALwCMAIwAMACXAJoAMQDPAM8ANQABAAAAAQAIAAEABgACAAEAAgLVAtYAAQAAAAEACAACAA4ABATeBN8E4AThAAEABAKHAogCmQKaAAQAAAABAAgAAQAmAAIACgAcAAIABgAMAaMAAgBKAagAAgBYAAEABAGpAAIAWAABAAIASgBXAAQAAAABAAgAAQBEAAIACgAUAAEABAGkAAIATQABAAQBpgACAE0ABAAAAAEACAABAB4AAgAKABQAAQAEAaUAAgBQAAEABAGnAAIAUAABAAIASgGjAAEAAAABAAgAAQAGAZUAAQABAEsAAQAAAAEACAABAAYBJwABAAEAugABAAAAAQAIAAEABgGsAAEAAQA2AAEAAAABAAgAAgAcAAIB4wHkAAEAAAABAAgAAgAKAAIB5QHmAAEAAgAvAE8AAQAAAAEACAACAB4ADAIoAioCKQIrAiwCHwIgAiECIgGuAiQCJQABAAwAJwAoACsAMwA1AEYARwBIAEsAUwBUAFUAAQAAAAEACAACAAwAAwImAicCJwABAAMASQBLAiIAAQAAAAEACAACAGYACAI9Ai0CLgIwAjECOQI6AjwAAQAAAAEACAACABYACAAbABUAFgAXABgAGQAdABQAAQAIAa0CIwRxBHIEcwR0BHUEdgABAAAAAQAIAAIAFgAIBHYCIwRxBHIEcwR0Aa0EdQABAAgAFAAVABYAFwAYABkAGwAdAAEAAAABAAgAAgAWAAgAFQAWABcAGAAZABsAHQAUAAEACAItAi4CMAIxAjkCOgI8Aj0AAQAAAAEACAABAAYBaQABAAEAEwAGAAAAAQAIAAMAAQASAAEAUgAAAAEAAAAaAAIAAgF8AXwAAAHUAd0AAQABAAAAAQAIAAEAKAHAAAEAAAABAAgAAgAaAAoCMgB6AHMAdAIzAjQCNQI2AjcCOAACAAEAFAAdAAAAAQAAAAEACAACACYAEAHUAdUB1gHXAdgB2QHaAdsB3AHdAkACPgJBAkICPwJDAAEAEAAUABUAFgAXABgAGQAaABsAHAAdAE0ATgKuA5sDnQQa\"\n};"

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1530))

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	module.exports = "/**\n * Rangy, a cross-browser JavaScript range and selection library\n * https://github.com/timdown/rangy\n *\n * Copyright 2015, Tim Down\n * Licensed under the MIT license.\n * Version: 1.3.0\n * Build date: 10 May 2015\n */\n!function(a,b){\"function\"==typeof define&&define.amd?\n// AMD. Register as an anonymous module.\ndefine(a):\"undefined\"!=typeof module&&\"object\"==typeof exports?\n// Node/CommonJS style\nmodule.exports=a():\n// No AMD or CommonJS support so we place Rangy in (probably) the global variable\nb.rangy=a()}(function(){/*----------------------------------------------------------------------------------------------------------------*/\n// Trio of functions taken from Peter Michaux's article:\n// http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting\nfunction a(a,b){var c=typeof a[b];return c==u||!(c!=t||!a[b])||\"unknown\"==c}function b(a,b){return!(typeof a[b]!=t||!a[b])}function c(a,b){return typeof a[b]!=v}\n// Creates a convenience function to save verbose repeated calls to tests functions\nfunction d(a){return function(b,c){for(var d=c.length;d--;)if(!a(b,c[d]))return!1;return!0}}function e(a){return a&&A(a,z)&&C(a,y)}function f(a){return b(a,\"body\")?a.body:a.getElementsByTagName(\"body\")[0]}function g(b){typeof console!=v&&a(console,\"log\")&&console.log(b)}function h(a,b){F&&b?alert(a):g(a)}function i(a){H.initialized=!0,H.supported=!1,h(\"Rangy is not supported in this environment. Reason: \"+a,H.config.alertOnFail)}function j(a){h(\"Rangy warning: \"+a,H.config.alertOnWarn)}function k(a){return a.message||a.description||String(a)}\n// Initialization\nfunction l(){if(F&&!H.initialized){var b,c=!1,d=!1;\n// First, perform basic feature tests\na(document,\"createRange\")&&(b=document.createRange(),A(b,x)&&C(b,w)&&(c=!0));var h=f(document);if(!h||\"body\"!=h.nodeName.toLowerCase())return void i(\"No body element found\");if(h&&a(h,\"createTextRange\")&&(b=h.createTextRange(),e(b)&&(d=!0)),!c&&!d)return void i(\"Neither Range nor TextRange are available\");H.initialized=!0,H.features={implementsDomRange:c,implementsTextRange:d};\n// Initialize modules\nvar j,l;for(var m in E)(j=E[m])instanceof p&&j.init(j,H);\n// Call init listeners\nfor(var n=0,o=K.length;n<o;++n)try{K[n](H)}catch(a){l=\"Rangy init listener threw an exception. Continuing. Detail: \"+k(a),g(l)}}}function m(a,b,c){c&&(a+=\" in module \"+c.name),H.warn(\"DEPRECATED: \"+a+\" is deprecated. Please use \"+b+\" instead.\")}function n(a,b,c,d){a[b]=function(){return m(b,c,d),a[c].apply(a,G.toArray(arguments))}}function o(a){a=a||window,l();\n// Notify listeners\nfor(var b=0,c=L.length;b<c;++b)L[b](a)}function p(a,b,c){this.name=a,this.dependencies=b,this.initialized=!1,this.supported=!1,this.initializer=c}function q(a,b,c){var d=new p(a,b,function(b){if(!b.initialized){b.initialized=!0;try{c(H,b),b.supported=!0}catch(b){var d=\"Module '\"+a+\"' failed to load: \"+k(b);g(d),b.stack&&g(b.stack)}}});return E[a]=d,d}/*----------------------------------------------------------------------------------------------------------------*/\n// Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately\nfunction r(){}function s(){}var t=\"object\",u=\"function\",v=\"undefined\",w=[\"startContainer\",\"startOffset\",\"endContainer\",\"endOffset\",\"collapsed\",\"commonAncestorContainer\"],x=[\"setStart\",\"setStartBefore\",\"setStartAfter\",\"setEnd\",\"setEndBefore\",\"setEndAfter\",\"collapse\",\"selectNode\",\"selectNodeContents\",\"compareBoundaryPoints\",\"deleteContents\",\"extractContents\",\"cloneContents\",\"insertNode\",\"surroundContents\",\"cloneRange\",\"toString\",\"detach\"],y=[\"boundingHeight\",\"boundingLeft\",\"boundingTop\",\"boundingWidth\",\"htmlText\",\"text\"],z=[\"collapse\",\"compareEndPoints\",\"duplicate\",\"moveToElementText\",\"parentElement\",\"select\",\"setEndPoint\",\"getBoundingClientRect\"],A=d(a),B=d(b),C=d(c),D=[].forEach?function(a,b){a.forEach(b)}:function(a,b){for(var c=0,d=a.length;c<d;++c)b(a[c],c)},E={},F=typeof window!=v&&typeof document!=v,G={isHostMethod:a,isHostObject:b,isHostProperty:c,areHostMethods:A,areHostObjects:B,areHostProperties:C,isTextRange:e,getBody:f,forEach:D},H={version:\"1.3.0\",initialized:!1,isBrowser:F,supported:!0,util:G,features:{},modules:E,config:{alertOnFail:!1,alertOnWarn:!1,preferTextRange:!1,autoInitialize:typeof rangyAutoInitialize==v||rangyAutoInitialize}};H.fail=i,H.warn=j;\n// Add utility extend() method\nvar I;({}).hasOwnProperty?(G.extend=I=function(a,b,c){var d,e;for(var f in b)b.hasOwnProperty(f)&&(d=a[f],e=b[f],c&&null!==d&&\"object\"==typeof d&&null!==e&&\"object\"==typeof e&&I(d,e,!0),a[f]=e);\n// Special case for toString, which does not show up in for...in loops in IE <= 8\nreturn b.hasOwnProperty(\"toString\")&&(a.toString=b.toString),a},G.createOptions=function(a,b){var c={};return I(c,b),a&&I(c,a),c}):i(\"hasOwnProperty not supported\"),\n// Test whether we're in a browser and bail out if not\nF||i(\"Rangy can only run in a browser\"),\n// Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not\nfunction(){var a;if(F){var b=document.createElement(\"div\");b.appendChild(document.createElement(\"span\"));var c=[].slice;try{1==c.call(b.childNodes,0)[0].nodeType&&(a=function(a){return c.call(a,0)})}catch(a){}}a||(a=function(a){for(var b=[],c=0,d=a.length;c<d;++c)b[c]=a[c];return b}),G.toArray=a}();\n// Very simple event handler wrapper function that doesn't attempt to solve issues such as \"this\" handling or\n// normalization of event properties\nvar J;F&&(a(document,\"addEventListener\")?J=function(a,b,c){a.addEventListener(b,c,!1)}:a(document,\"attachEvent\")?J=function(a,b,c){a.attachEvent(\"on\"+b,c)}:i(\"Document does not have required addEventListener or attachEvent method\"),G.addListener=J);var K=[];G.deprecationNotice=m,G.createAliasForDeprecatedMethod=n,\n// Allow external scripts to initialize this library in case it's loaded after the document has loaded\nH.init=l,\n// Execute listener immediately if already initialized\nH.addInitListener=function(a){H.initialized?a(H):K.push(a)};var L=[];H.addShimListener=function(a){L.push(a)},F&&(H.shim=H.createMissingNativeApi=o,n(H,\"createMissingNativeApi\",\"shim\")),p.prototype={init:function(){for(var a,b,c=this.dependencies||[],d=0,e=c.length;d<e;++d){if(b=c[d],a=E[b],!(a&&a instanceof p))throw new Error(\"required module '\"+b+\"' not found\");if(a.init(),!a.supported)throw new Error(\"required module '\"+b+\"' not supported\")}\n// Now run initializer\nthis.initializer(this)},fail:function(a){throw this.initialized=!0,this.supported=!1,new Error(a)},warn:function(a){H.warn(\"Module \"+this.name+\": \"+a)},deprecationNotice:function(a,b){H.warn(\"DEPRECATED: \"+a+\" in module \"+this.name+\" is deprecated. Please use \"+b+\" instead\")},createError:function(a){return new Error(\"Error in Rangy \"+this.name+\" module: \"+a)}},H.createModule=function(a){\n// Allow 2 or 3 arguments (second argument is an optional array of dependencies)\nvar b,c;2==arguments.length?(b=arguments[1],c=[]):(b=arguments[2],c=arguments[1]);var d=q(a,c,b);\n// Initialize the module immediately if the core is already initialized\nH.initialized&&H.supported&&d.init()},H.createCoreModule=function(a,b,c){q(a,b,c)},H.RangePrototype=r,H.rangePrototype=new r,H.selectionPrototype=new s,/*----------------------------------------------------------------------------------------------------------------*/\n// DOM utility methods used by Rangy\nH.createCoreModule(\"DomUtil\",[],function(a,b){\n// Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI\nfunction c(a){var b;return typeof a.namespaceURI==F||null===(b=a.namespaceURI)||\"http://www.w3.org/1999/xhtml\"==b}function d(a){var b=a.parentNode;return 1==b.nodeType?b:null}function e(a){for(var b=0;a=a.previousSibling;)++b;return b}function f(a){switch(a.nodeType){case 7:case 10:return 0;case 3:case 8:return a.length;default:return a.childNodes.length}}function g(a,b){var c,d=[];for(c=a;c;c=c.parentNode)d.push(c);for(c=b;c;c=c.parentNode)if(K(d,c))return c;return null}function h(a,b,c){for(var d=c?b:b.parentNode;d;){if(d===a)return!0;d=d.parentNode}return!1}function i(a,b){return h(a,b,!0)}function j(a,b,c){for(var d,e=c?a:a.parentNode;e;){if(d=e.parentNode,d===b)return e;e=d}return null}function k(a){var b=a.nodeType;return 3==b||4==b||8==b}function l(a){if(!a)return!1;var b=a.nodeType;return 3==b||8==b}function m(a,b){var c=b.nextSibling,d=b.parentNode;return c?d.insertBefore(a,c):d.appendChild(a),a}\n// Note that we cannot use splitText() because it is bugridden in IE 9.\nfunction n(a,b,c){var d=a.cloneNode(!1);\n// Preserve positions\nif(d.deleteData(0,b),a.deleteData(b,a.length-b),m(d,a),c)for(var f,g=0;f=c[g++];)\n// Handle case where position was inside the portion of node after the split point\nf.node==a&&f.offset>b?(f.node=d,f.offset-=b):f.node==a.parentNode&&f.offset>e(a)&&++f.offset;return d}function o(a){if(9==a.nodeType)return a;if(typeof a.ownerDocument!=F)return a.ownerDocument;if(typeof a.document!=F)return a.document;if(a.parentNode)return o(a.parentNode);throw b.createError(\"getDocument: no document found for node\")}function p(a){var c=o(a);if(typeof c.defaultView!=F)return c.defaultView;if(typeof c.parentWindow!=F)return c.parentWindow;throw b.createError(\"Cannot get a window object for node\")}function q(a){if(typeof a.contentDocument!=F)return a.contentDocument;if(typeof a.contentWindow!=F)return a.contentWindow.document;throw b.createError(\"getIframeDocument: No Document object found for iframe element\")}function r(a){if(typeof a.contentWindow!=F)return a.contentWindow;if(typeof a.contentDocument!=F)return a.contentDocument.defaultView;throw b.createError(\"getIframeWindow: No Window object found for iframe element\")}\n// This looks bad. Is it worth it?\nfunction s(a){return a&&G.isHostMethod(a,\"setTimeout\")&&G.isHostObject(a,\"document\")}function t(a,b,c){var d;if(a?G.isHostProperty(a,\"nodeType\")?d=1==a.nodeType&&\"iframe\"==a.tagName.toLowerCase()?q(a):o(a):s(a)&&(d=a.document):d=document,!d)throw b.createError(c+\"(): Parameter must be a Window object or DOM node\");return d}function u(a){for(var b;b=a.parentNode;)a=b;return a}function v(a,c,d,f){\n// See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing\nvar h,i,k,l,m;if(a==d)\n// Case 1: nodes are the same\nreturn c===f?0:c<f?-1:1;if(h=j(d,a,!0))\n// Case 2: node C (container B or an ancestor) is a child node of A\nreturn c<=e(h)?-1:1;if(h=j(a,d,!0))\n// Case 3: node C (container A or an ancestor) is a child node of B\nreturn e(h)<f?-1:1;if(i=g(a,d),!i)throw new Error(\"comparePoints error: nodes have no common ancestor\");if(\n// Case 4: containers are siblings or descendants of siblings\nk=a===i?i:j(a,i,!0),l=d===i?i:j(d,i,!0),k===l)\n// This shouldn't be possible\nthrow b.createError(\"comparePoints got to case 4 and childA and childB are the same!\");for(m=i.firstChild;m;){if(m===k)return-1;if(m===l)return 1;m=m.nextSibling}}function w(a){var b;try{return b=a.parentNode,!1}catch(a){return!0}}/*----------------------------------------------------------------------------------------------------------------*/\nfunction x(a){if(!a)return\"[No node]\";if(L&&w(a))return\"[Broken node]\";if(k(a))return'\"'+a.data+'\"';if(1==a.nodeType){var b=a.id?' id=\"'+a.id+'\"':\"\";return\"<\"+a.nodeName+b+\">[index:\"+e(a)+\",length:\"+a.childNodes.length+\"][\"+(a.innerHTML||\"[innerHTML not supported]\").slice(0,25)+\"]\"}return a.nodeName}function y(a){for(var b,c=o(a).createDocumentFragment();b=a.firstChild;)c.appendChild(b);return c}function z(a,b,c){var d=H(a),e=a.createElement(\"div\");e.contentEditable=\"\"+!!c,b&&(e.innerHTML=b);\n// Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)\nvar f=d.firstChild;return f?d.insertBefore(e,f):d.appendChild(e),e}function A(a){return a.parentNode.removeChild(a)}function B(a){this.root=a,this._next=a}function C(a){return new B(a)}function D(a,b){this.node=a,this.offset=b}function E(a){this.code=this[a],this.codeName=a,this.message=\"DOMException: \"+this.codeName}var F=\"undefined\",G=a.util,H=G.getBody;\n// Perform feature tests\nG.areHostMethods(document,[\"createDocumentFragment\",\"createElement\",\"createTextNode\"])||b.fail(\"document missing a Node creation method\"),G.isHostMethod(document,\"getElementsByTagName\")||b.fail(\"document missing getElementsByTagName method\");var I=document.createElement(\"div\");G.areHostMethods(I,[\"insertBefore\",\"appendChild\",\"cloneNode\"]||!G.areHostObjects(I,[\"previousSibling\",\"nextSibling\",\"childNodes\",\"parentNode\"]))||b.fail(\"Incomplete Element implementation\"),\n// innerHTML is required for Range's createContextualFragment method\nG.isHostProperty(I,\"innerHTML\")||b.fail(\"Element is missing innerHTML property\");var J=document.createTextNode(\"test\");G.areHostMethods(J,[\"splitText\",\"deleteData\",\"insertData\",\"appendData\",\"cloneNode\"]||!G.areHostObjects(I,[\"previousSibling\",\"nextSibling\",\"childNodes\",\"parentNode\"])||!G.areHostProperties(J,[\"data\"]))||b.fail(\"Incomplete Text Node implementation\");/*----------------------------------------------------------------------------------------------------------------*/\n// Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been\n// able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that\n// contains just the document as a single element and the value searched for is the document.\nvar K=/*Array.prototype.indexOf ?\n            function(arr, val) {\n                return arr.indexOf(val) > -1;\n            }:*/\nfunction(a,b){for(var c=a.length;c--;)if(a[c]===b)return!0;return!1},L=!1;!function(){var b=document.createElement(\"b\");b.innerHTML=\"1\";var c=b.firstChild;b.innerHTML=\"<br />\",L=w(c),a.features.crashyTextNodes=L}();var M;typeof window.getComputedStyle!=F?M=function(a,b){return p(a).getComputedStyle(a,null)[b]}:typeof document.documentElement.currentStyle!=F?M=function(a,b){return a.currentStyle?a.currentStyle[b]:\"\"}:b.fail(\"No means of obtaining computed style properties found\"),B.prototype={_current:null,hasNext:function(){return!!this._next},next:function(){var a,b,c=this._current=this._next;if(this._current)if(a=c.firstChild)this._next=a;else{for(b=null;c!==this.root&&!(b=c.nextSibling);)c=c.parentNode;this._next=b}return this._current},detach:function(){this._current=this._next=this.root=null}},D.prototype={equals:function(a){return!!a&&this.node===a.node&&this.offset==a.offset},inspect:function(){return\"[DomPosition(\"+x(this.node)+\":\"+this.offset+\")]\"},toString:function(){return this.inspect()}},E.prototype={INDEX_SIZE_ERR:1,HIERARCHY_REQUEST_ERR:3,WRONG_DOCUMENT_ERR:4,NO_MODIFICATION_ALLOWED_ERR:7,NOT_FOUND_ERR:8,NOT_SUPPORTED_ERR:9,INVALID_STATE_ERR:11,INVALID_NODE_TYPE_ERR:24},E.prototype.toString=function(){return this.message},a.dom={arrayContains:K,isHtmlNamespace:c,parentElement:d,getNodeIndex:e,getNodeLength:f,getCommonAncestor:g,isAncestorOf:h,isOrIsAncestorOf:i,getClosestAncestorIn:j,isCharacterDataNode:k,isTextOrCommentNode:l,insertAfter:m,splitDataNode:n,getDocument:o,getWindow:p,getIframeWindow:r,getIframeDocument:q,getBody:H,isWindow:s,getContentDocument:t,getRootContainer:u,comparePoints:v,isBrokenNode:w,inspectNode:x,getComputedStyleProperty:M,createTestElement:z,removeNode:A,fragmentFromNodeChildren:y,createIterator:C,DomPosition:D},a.DOMException=E}),/*----------------------------------------------------------------------------------------------------------------*/\n// Pure JavaScript implementation of DOM Range\nH.createCoreModule(\"DomRange\",[\"DomUtil\"],function(a,b){/*----------------------------------------------------------------------------------------------------------------*/\n// Utility functions\nfunction c(a,b){return 3!=a.nodeType&&(P(a,b.startContainer)||P(a,b.endContainer))}function d(a){return a.document||Q(a.startContainer)}function e(a){return W(a.startContainer)}function f(a){return new L(a.parentNode,O(a))}function g(a){return new L(a.parentNode,O(a)+1)}function h(a,b,c){var d=11==a.nodeType?a.firstChild:a;return N(b)?c==b.length?J.insertAfter(a,b):b.parentNode.insertBefore(a,0==c?b:S(b,c)):c>=b.childNodes.length?b.appendChild(a):b.insertBefore(a,b.childNodes[c]),d}function i(a,b,c){if(z(a),z(b),d(b)!=d(a))throw new M(\"WRONG_DOCUMENT_ERR\");var e=R(a.startContainer,a.startOffset,b.endContainer,b.endOffset),f=R(a.endContainer,a.endOffset,b.startContainer,b.startOffset);return c?e<=0&&f>=0:e<0&&f>0}function j(a){for(var b,c,e,f=d(a.range).createDocumentFragment();c=a.next();){if(b=a.isPartiallySelectedSubtree(),c=c.cloneNode(!b),b&&(e=a.getSubtreeIterator(),c.appendChild(j(e)),e.detach()),10==c.nodeType)// DocumentType\nthrow new M(\"HIERARCHY_REQUEST_ERR\");f.appendChild(c)}return f}function k(a,b,c){var d,e;c=c||{stop:!1};for(var f,g;f=a.next();)if(a.isPartiallySelectedSubtree()){if(b(f)===!1)return void(c.stop=!0);if(\n// The node is partially selected by the Range, so we can use a new RangeIterator on the portion of\n// the node selected by the Range.\ng=a.getSubtreeIterator(),k(g,b,c),g.detach(),c.stop)return}else for(\n// The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its\n// descendants\nd=J.createIterator(f);e=d.next();)if(b(e)===!1)return void(c.stop=!0)}function l(a){for(var b;a.next();)a.isPartiallySelectedSubtree()?(b=a.getSubtreeIterator(),l(b),b.detach()):a.remove()}function m(a){for(var b,c,e=d(a.range).createDocumentFragment();b=a.next();){if(a.isPartiallySelectedSubtree()?(b=b.cloneNode(!1),c=a.getSubtreeIterator(),b.appendChild(m(c)),c.detach()):a.remove(),10==b.nodeType)// DocumentType\nthrow new M(\"HIERARCHY_REQUEST_ERR\");e.appendChild(b)}return e}function n(a,b,c){var d,e=!(!b||!b.length),f=!!c;e&&(d=new RegExp(\"^(\"+b.join(\"|\")+\")$\"));var g=[];return k(new p(a,!1),function(b){if((!e||d.test(b.nodeType))&&(!f||c(b))){\n// Don't include a boundary container if it is a character data node and the range does not contain any\n// of its character data. See issue 190.\nvar h=a.startContainer;if(b!=h||!N(h)||a.startOffset!=h.length){var i=a.endContainer;b==i&&N(i)&&0==a.endOffset||g.push(b)}}}),g}function o(a){var b=\"undefined\"==typeof a.getName?\"Range\":a.getName();return\"[\"+b+\"(\"+J.inspectNode(a.startContainer)+\":\"+a.startOffset+\", \"+J.inspectNode(a.endContainer)+\":\"+a.endOffset+\")]\"}/*----------------------------------------------------------------------------------------------------------------*/\n// RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)\nfunction p(a,b){if(this.range=a,this.clonePartiallySelectedTextNodes=b,!a.collapsed){this.sc=a.startContainer,this.so=a.startOffset,this.ec=a.endContainer,this.eo=a.endOffset;var c=a.commonAncestorContainer;this.sc===this.ec&&N(this.sc)?(this.isSingleCharacterDataNode=!0,this._first=this._last=this._next=this.sc):(this._first=this._next=this.sc!==c||N(this.sc)?T(this.sc,c,!0):this.sc.childNodes[this.so],this._last=this.ec!==c||N(this.ec)?T(this.ec,c,!0):this.ec.childNodes[this.eo-1])}}function q(a){return function(b,c){for(var d,e=c?b:b.parentNode;e;){if(d=e.nodeType,V(a,d))return e;e=e.parentNode}return null}}function r(a,b){if(ea(a,b))throw new M(\"INVALID_NODE_TYPE_ERR\")}function s(a,b){if(!V(b,a.nodeType))throw new M(\"INVALID_NODE_TYPE_ERR\")}function t(a,b){if(b<0||b>(N(a)?a.length:a.childNodes.length))throw new M(\"INDEX_SIZE_ERR\")}function u(a,b){if(ca(a,!0)!==ca(b,!0))throw new M(\"WRONG_DOCUMENT_ERR\")}function v(a){if(da(a,!0))throw new M(\"NO_MODIFICATION_ALLOWED_ERR\")}function w(a,b){if(!a)throw new M(b)}function x(a,b){return b<=(N(a)?a.length:a.childNodes.length)}function y(a){return!!a.startContainer&&!!a.endContainer&&!(X&&(J.isBrokenNode(a.startContainer)||J.isBrokenNode(a.endContainer)))&&W(a.startContainer)==W(a.endContainer)&&x(a.startContainer,a.startOffset)&&x(a.endContainer,a.endOffset)}function z(a){if(!y(a))throw new Error(\"Range error: Range is not valid. This usually happens after DOM mutation. Range: (\"+a.inspect()+\")\")}function A(a,b){z(a);var c=a.startContainer,d=a.startOffset,e=a.endContainer,f=a.endOffset,g=c===e;N(e)&&f>0&&f<e.length&&S(e,f,b),N(c)&&d>0&&d<c.length&&(c=S(c,d,b),g?(f-=d,e=c):e==c.parentNode&&f>=O(c)&&f++,d=0),a.setStartAndEnd(c,d,e,f)}function B(a){z(a);var b=a.commonAncestorContainer.parentNode.cloneNode(!1);return b.appendChild(a.cloneContents()),b.innerHTML}function C(a){a.START_TO_START=ja,a.START_TO_END=ka,a.END_TO_END=la,a.END_TO_START=ma,a.NODE_BEFORE=na,a.NODE_AFTER=oa,a.NODE_BEFORE_AND_AFTER=pa,a.NODE_INSIDE=qa}function D(a){C(a),C(a.prototype)}function E(a,b){return function(){z(this);var c,d,e=this.startContainer,f=this.startOffset,h=this.commonAncestorContainer,i=new p(this,!0);e!==h&&(c=T(e,h,!0),d=g(c),e=d.node,f=d.offset),\n// Check none of the range is read-only\nk(i,v),i.reset();\n// Remove the content\nvar j=a(i);\n// Move to the new position\nreturn i.detach(),b(this,e,f,e,f),j}}function F(b,d){function e(a,b){return function(c){s(c,Z),s(W(c),$);var d=(a?f:g)(c);(b?h:i)(this,d.node,d.offset)}}function h(a,b,c){var e=a.endContainer,f=a.endOffset;b===a.startContainer&&c===a.startOffset||(\n// Check the root containers of the range and the new boundary, and also check whether the new boundary\n// is after the current end. In either case, collapse the range to the new position\nW(b)==W(e)&&1!=R(b,c,e,f)||(e=b,f=c),d(a,b,c,e,f))}function i(a,b,c){var e=a.startContainer,f=a.startOffset;b===a.endContainer&&c===a.endOffset||(\n// Check the root containers of the range and the new boundary, and also check whether the new boundary\n// is after the current end. In either case, collapse the range to the new position\nW(b)==W(e)&&R(b,c,e,f)!=-1||(e=b,f=c),d(a,e,f,b,c))}\n// Set up inheritance\nvar j=function(){};j.prototype=a.rangePrototype,b.prototype=new j,K.extend(b.prototype,{setStart:function(a,b){r(a,!0),t(a,b),h(this,a,b)},setEnd:function(a,b){r(a,!0),t(a,b),i(this,a,b)},/**\n                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:\n                 * - Two parameters (node, offset) creates a collapsed range at that position\n                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at\n                 *   startOffset and ending at endOffset\n                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in\n                 *   startNode and ending at endOffset in endNode\n                 */\nsetStartAndEnd:function(){var a=arguments,b=a[0],c=a[1],e=b,f=c;switch(a.length){case 3:f=a[2];break;case 4:e=a[2],f=a[3]}d(this,b,c,e,f)},setBoundary:function(a,b,c){this[\"set\"+(c?\"Start\":\"End\")](a,b)},setStartBefore:e(!0,!0),setStartAfter:e(!1,!0),setEndBefore:e(!0,!1),setEndAfter:e(!1,!1),collapse:function(a){z(this),a?d(this,this.startContainer,this.startOffset,this.startContainer,this.startOffset):d(this,this.endContainer,this.endOffset,this.endContainer,this.endOffset)},selectNodeContents:function(a){r(a,!0),d(this,a,0,a,U(a))},selectNode:function(a){r(a,!1),s(a,Z);var b=f(a),c=g(a);d(this,b.node,b.offset,c.node,c.offset)},extractContents:E(m,d),deleteContents:E(l,d),canSurroundContents:function(){z(this),v(this.startContainer),v(this.endContainer);\n// Check if the contents can be surrounded. Specifically, this means whether the range partially selects\n// no non-text nodes.\nvar a=new p(this,!0),b=a._first&&c(a._first,this)||a._last&&c(a._last,this);return a.detach(),!b},splitBoundaries:function(){A(this)},splitBoundariesPreservingPositions:function(a){A(this,a)},normalizeBoundaries:function(){z(this);var a,b=this.startContainer,c=this.startOffset,e=this.endContainer,f=this.endOffset,g=function(a){var b=a.nextSibling;b&&b.nodeType==a.nodeType&&(e=a,f=a.length,a.appendData(b.data),Y(b))},h=function(a){var d=a.previousSibling;if(d&&d.nodeType==a.nodeType){b=a;var g=a.length;if(c=d.length,a.insertData(0,d.data),Y(d),b==e)f+=c,e=b;else if(e==a.parentNode){var h=O(a);f==h?(e=a,f=g):f>h&&f--}}},i=!0;if(N(e))f==e.length?g(e):0==f&&(a=e.previousSibling,a&&a.nodeType==e.nodeType&&(f=a.length,b==e&&(i=!1),a.appendData(e.data),Y(e),e=a));else{if(f>0){var j=e.childNodes[f-1];j&&N(j)&&g(j)}i=!this.collapsed}if(i){if(N(b))0==c?h(b):c==b.length&&(a=b.nextSibling,a&&a.nodeType==b.nodeType&&(e==a&&(e=b,f+=b.length),b.appendData(a.data),Y(a)));else if(c<b.childNodes.length){var k=b.childNodes[c];k&&N(k)&&h(k)}}else b=e,c=f;d(this,b,c,e,f)},collapseToPoint:function(a,b){r(a,!0),t(a,b),this.setStartAndEnd(a,b)}}),D(b)}/*----------------------------------------------------------------------------------------------------------------*/\n// Updates commonAncestorContainer and collapsed after boundary change\nfunction G(a){a.collapsed=a.startContainer===a.endContainer&&a.startOffset===a.endOffset,a.commonAncestorContainer=a.collapsed?a.startContainer:J.getCommonAncestor(a.startContainer,a.endContainer)}function H(a,b,c,d,e){a.startContainer=b,a.startOffset=c,a.endContainer=d,a.endOffset=e,a.document=J.getDocument(b),G(a)}function I(a){this.startContainer=a,this.startOffset=0,this.endContainer=a,this.endOffset=0,this.document=a,G(this)}var J=a.dom,K=a.util,L=J.DomPosition,M=a.DOMException,N=J.isCharacterDataNode,O=J.getNodeIndex,P=J.isOrIsAncestorOf,Q=J.getDocument,R=J.comparePoints,S=J.splitDataNode,T=J.getClosestAncestorIn,U=J.getNodeLength,V=J.arrayContains,W=J.getRootContainer,X=a.features.crashyTextNodes,Y=J.removeNode;p.prototype={_current:null,_next:null,_first:null,_last:null,isSingleCharacterDataNode:!1,reset:function(){this._current=null,this._next=this._first},hasNext:function(){return!!this._next},next:function(){\n// Move to next node\nvar a=this._current=this._next;\n// Check for partially selected text nodes\nreturn a&&(this._next=a!==this._last?a.nextSibling:null,N(a)&&this.clonePartiallySelectedTextNodes&&(a===this.ec&&(a=a.cloneNode(!0)).deleteData(this.eo,a.length-this.eo),this._current===this.sc&&(a=a.cloneNode(!0)).deleteData(0,this.so))),a},remove:function(){var a,b,c=this._current;!N(c)||c!==this.sc&&c!==this.ec?c.parentNode&&Y(c):(a=c===this.sc?this.so:0,b=c===this.ec?this.eo:c.length,a!=b&&c.deleteData(a,b-a))},\n// Checks if the current node is partially selected\nisPartiallySelectedSubtree:function(){var a=this._current;return c(a,this.range)},getSubtreeIterator:function(){var a;if(this.isSingleCharacterDataNode)a=this.range.cloneRange(),a.collapse(!1);else{a=new I(d(this.range));var b=this._current,c=b,e=0,f=b,g=U(b);P(b,this.sc)&&(c=this.sc,e=this.so),P(b,this.ec)&&(f=this.ec,g=this.eo),H(a,c,e,f,g)}return new p(a,this.clonePartiallySelectedTextNodes)},detach:function(){this.range=this._current=this._next=this._first=this._last=this.sc=this.so=this.ec=this.eo=null}};/*----------------------------------------------------------------------------------------------------------------*/\nvar Z=[1,3,4,5,7,8,10],$=[2,9,11],_=[5,6,10,12],aa=[1,3,4,5,7,8,10,11],ba=[1,3,4,5,7,8],ca=q([9,11]),da=q(_),ea=q([6,10,12]),fa=document.createElement(\"style\"),ga=!1;try{fa.innerHTML=\"<b>x</b>\",ga=3==fa.firstChild.nodeType}catch(a){}a.features.htmlParsingConforms=ga;var ha=ga?\n// Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See\n// discussion and base code for this implementation at issue 67.\n// Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface\n// Thanks to Aleks Williams.\nfunction(a){\n// \"Let node the context object's start's node.\"\nvar b=this.startContainer,c=Q(b);\n// \"If the context object's start's node is null, raise an INVALID_STATE_ERR\n// exception and abort these steps.\"\nif(!b)throw new M(\"INVALID_STATE_ERR\");\n// \"Let element be as follows, depending on node's interface:\"\n// Document, Document Fragment: null\nvar d=null;\n// \"If this raises an exception, then abort these steps. Otherwise, let new\n// children be the nodes returned.\"\n// \"Let fragment be a new DocumentFragment.\"\n// \"Append all new children to fragment.\"\n// \"Return fragment.\"\n// \"Element: node\"\n// \"If either element is null or element's ownerDocument is an HTML document\n// and element's local name is \"html\" and element's namespace is the HTML\n// namespace\"\n// \"let element be a new Element with \"body\" as its local name and the HTML\n// namespace as its namespace.\"\"\n// \"If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm.\"\n// \"If the node's document is an XML document: Invoke the XML fragment parsing algorithm.\"\n// \"In either case, the algorithm must be invoked with fragment as the input\n// and element as the context element.\"\nreturn 1==b.nodeType?d=b:N(b)&&(d=J.parentElement(b)),d=null===d||\"HTML\"==d.nodeName&&J.isHtmlNamespace(Q(d).documentElement)&&J.isHtmlNamespace(d)?c.createElement(\"body\"):d.cloneNode(!1),d.innerHTML=a,J.fragmentFromNodeChildren(d)}:\n// In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that\n// previous versions of Rangy used (with the exception of using a body element rather than a div)\nfunction(a){var b=d(this),c=b.createElement(\"body\");return c.innerHTML=a,J.fragmentFromNodeChildren(c)},ia=[\"startContainer\",\"startOffset\",\"endContainer\",\"endOffset\",\"collapsed\",\"commonAncestorContainer\"],ja=0,ka=1,la=2,ma=3,na=0,oa=1,pa=2,qa=3;K.extend(a.rangePrototype,{compareBoundaryPoints:function(a,b){z(this),u(this.startContainer,b.startContainer);var c,d,e,f,g=a==ma||a==ja?\"start\":\"end\",h=a==ka||a==ja?\"start\":\"end\";return c=this[g+\"Container\"],d=this[g+\"Offset\"],e=b[h+\"Container\"],f=b[h+\"Offset\"],R(c,d,e,f)},insertNode:function(a){if(z(this),s(a,aa),v(this.startContainer),P(a,this.startContainer))throw new M(\"HIERARCHY_REQUEST_ERR\");\n// No check for whether the container of the start of the Range is of a type that does not allow\n// children of the type of node: the browser's DOM implementation should do this for us when we attempt\n// to add the node\nvar b=h(a,this.startContainer,this.startOffset);this.setStartBefore(b)},cloneContents:function(){z(this);var a,b;if(this.collapsed)return d(this).createDocumentFragment();if(this.startContainer===this.endContainer&&N(this.startContainer))return a=this.startContainer.cloneNode(!0),a.data=a.data.slice(this.startOffset,this.endOffset),b=d(this).createDocumentFragment(),b.appendChild(a),b;var c=new p(this,!0);return a=j(c),c.detach(),a},canSurroundContents:function(){z(this),v(this.startContainer),v(this.endContainer);\n// Check if the contents can be surrounded. Specifically, this means whether the range partially selects\n// no non-text nodes.\nvar a=new p(this,!0),b=a._first&&c(a._first,this)||a._last&&c(a._last,this);return a.detach(),!b},surroundContents:function(a){if(s(a,ba),!this.canSurroundContents())throw new M(\"INVALID_STATE_ERR\");\n// Extract the contents\nvar b=this.extractContents();\n// Clear the children of the node\nif(a.hasChildNodes())for(;a.lastChild;)a.removeChild(a.lastChild);\n// Insert the new node and add the extracted contents\nh(a,this.startContainer,this.startOffset),a.appendChild(b),this.selectNode(a)},cloneRange:function(){z(this);for(var a,b=new I(d(this)),c=ia.length;c--;)a=ia[c],b[a]=this[a];return b},toString:function(){z(this);var a=this.startContainer;if(a===this.endContainer&&N(a))return 3==a.nodeType||4==a.nodeType?a.data.slice(this.startOffset,this.endOffset):\"\";var b=[],c=new p(this,!0);return k(c,function(a){\n// Accept only text or CDATA nodes, not comments\n3!=a.nodeType&&4!=a.nodeType||b.push(a.data)}),c.detach(),b.join(\"\")},\n// The methods below are all non-standard. The following batch were introduced by Mozilla but have since\n// been removed from Mozilla.\ncompareNode:function(a){z(this);var b=a.parentNode,c=O(a);if(!b)throw new M(\"NOT_FOUND_ERR\");var d=this.comparePoint(b,c),e=this.comparePoint(b,c+1);return d<0?e>0?pa:na:e>0?oa:qa},comparePoint:function(a,b){return z(this),w(a,\"HIERARCHY_REQUEST_ERR\"),u(a,this.startContainer),R(a,b,this.startContainer,this.startOffset)<0?-1:R(a,b,this.endContainer,this.endOffset)>0?1:0},createContextualFragment:ha,toHtml:function(){return B(this)},\n// touchingIsIntersecting determines whether this method considers a node that borders a range intersects\n// with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)\nintersectsNode:function(a,b){if(z(this),W(a)!=e(this))return!1;var c=a.parentNode,d=O(a);if(!c)return!0;var f=R(c,d,this.endContainer,this.endOffset),g=R(c,d+1,this.startContainer,this.startOffset);return b?f<=0&&g>=0:f<0&&g>0},isPointInRange:function(a,b){return z(this),w(a,\"HIERARCHY_REQUEST_ERR\"),u(a,this.startContainer),R(a,b,this.startContainer,this.startOffset)>=0&&R(a,b,this.endContainer,this.endOffset)<=0},\n// The methods below are non-standard and invented by me.\n// Sharing a boundary start-to-end or end-to-start does not count as intersection.\nintersectsRange:function(a){return i(this,a,!1)},\n// Sharing a boundary start-to-end or end-to-start does count as intersection.\nintersectsOrTouchesRange:function(a){return i(this,a,!0)},intersection:function(a){if(this.intersectsRange(a)){var b=R(this.startContainer,this.startOffset,a.startContainer,a.startOffset),c=R(this.endContainer,this.endOffset,a.endContainer,a.endOffset),d=this.cloneRange();return b==-1&&d.setStart(a.startContainer,a.startOffset),1==c&&d.setEnd(a.endContainer,a.endOffset),d}return null},union:function(a){if(this.intersectsOrTouchesRange(a)){var b=this.cloneRange();return R(a.startContainer,a.startOffset,this.startContainer,this.startOffset)==-1&&b.setStart(a.startContainer,a.startOffset),1==R(a.endContainer,a.endOffset,this.endContainer,this.endOffset)&&b.setEnd(a.endContainer,a.endOffset),b}throw new M(\"Ranges do not intersect\")},containsNode:function(a,b){return b?this.intersectsNode(a,!1):this.compareNode(a)==qa},containsNodeContents:function(a){return this.comparePoint(a,0)>=0&&this.comparePoint(a,U(a))<=0},containsRange:function(a){var b=this.intersection(a);return null!==b&&a.equals(b)},containsNodeText:function(a){var b=this.cloneRange();b.selectNode(a);var c=b.getNodes([3]);if(c.length>0){b.setStart(c[0],0);var d=c.pop();return b.setEnd(d,d.length),this.containsRange(b)}return this.containsNodeContents(a)},getNodes:function(a,b){return z(this),n(this,a,b)},getDocument:function(){return d(this)},collapseBefore:function(a){this.setEndBefore(a),this.collapse(!1)},collapseAfter:function(a){this.setStartAfter(a),this.collapse(!0)},getBookmark:function(b){var c=d(this),e=a.createRange(c);b=b||J.getBody(c),e.selectNodeContents(b);var f=this.intersection(e),g=0,h=0;return f&&(e.setEnd(f.startContainer,f.startOffset),g=e.toString().length,h=g+f.toString().length),{start:g,end:h,containerNode:b}},moveToBookmark:function(a){var b=a.containerNode,c=0;this.setStart(b,0),this.collapse(!0);for(var d,e,f,g,h=[b],i=!1,j=!1;!j&&(d=h.pop());)if(3==d.nodeType)e=c+d.length,!i&&a.start>=c&&a.start<=e&&(this.setStart(d,a.start-c),i=!0),i&&a.end>=c&&a.end<=e&&(this.setEnd(d,a.end-c),j=!0),c=e;else for(g=d.childNodes,f=g.length;f--;)h.push(g[f])},getName:function(){return\"DomRange\"},equals:function(a){return I.rangesEqual(this,a)},isValid:function(){return y(this)},inspect:function(){return o(this)},detach:function(){}}),F(I,H),K.extend(I,{rangeProperties:ia,RangeIterator:p,copyComparisonConstants:D,createPrototypeRange:F,inspect:o,toHtml:B,getRangeDocument:d,rangesEqual:function(a,b){return a.startContainer===b.startContainer&&a.startOffset===b.startOffset&&a.endContainer===b.endContainer&&a.endOffset===b.endOffset}}),a.DomRange=I}),/*----------------------------------------------------------------------------------------------------------------*/\n// Wrappers for the browser's native DOM Range and/or TextRange implementation\nH.createCoreModule(\"WrappedRange\",[\"DomRange\"],function(a,b){var c,d,e=a.dom,f=a.util,g=e.DomPosition,h=a.DomRange,i=e.getBody,j=e.getContentDocument,k=e.isCharacterDataNode;if(/*----------------------------------------------------------------------------------------------------------------*/\na.features.implementsDomRange&&\n// This is a wrapper around the browser's native DOM Range. It has two aims:\n// - Provide workarounds for specific browser bugs\n// - provide convenient extensions, which are inherited from Rangy's DomRange\n!function(){function d(a){for(var b,c=m.length;c--;)b=m[c],a[b]=a.nativeRange[b];\n// Fix for broken collapsed property in IE 9.\na.collapsed=a.startContainer===a.endContainer&&a.startOffset===a.endOffset}function g(a,b,c,d,e){var f=a.startContainer!==b||a.startOffset!=c,g=a.endContainer!==d||a.endOffset!=e,h=!a.equals(a.nativeRange);\n// Always set both boundaries for the benefit of IE9 (see issue 35)\n(f||g||h)&&(a.setEnd(d,e),a.setStart(b,c))}var k,l,m=h.rangeProperties;c=function(a){if(!a)throw b.createError(\"WrappedRange: Range must be specified\");this.nativeRange=a,d(this)},h.createPrototypeRange(c,g),k=c.prototype,k.selectNode=function(a){this.nativeRange.selectNode(a),d(this)},k.cloneContents=function(){return this.nativeRange.cloneContents()},\n// Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,\n// insertNode() is never delegated to the native range.\nk.surroundContents=function(a){this.nativeRange.surroundContents(a),d(this)},k.collapse=function(a){this.nativeRange.collapse(a),d(this)},k.cloneRange=function(){return new c(this.nativeRange.cloneRange())},k.refresh=function(){d(this)},k.toString=function(){return this.nativeRange.toString()};\n// Create test range and node for feature detection\nvar n=document.createTextNode(\"test\");i(document).appendChild(n);var o=document.createRange();/*--------------------------------------------------------------------------------------------------------*/\n// Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and\n// correct for it\no.setStart(n,0),o.setEnd(n,0);try{o.setStart(n,1),k.setStart=function(a,b){this.nativeRange.setStart(a,b),d(this)},k.setEnd=function(a,b){this.nativeRange.setEnd(a,b),d(this)},l=function(a){return function(b){this.nativeRange[a](b),d(this)}}}catch(a){k.setStart=function(a,b){try{this.nativeRange.setStart(a,b)}catch(c){this.nativeRange.setEnd(a,b),this.nativeRange.setStart(a,b)}d(this)},k.setEnd=function(a,b){try{this.nativeRange.setEnd(a,b)}catch(c){this.nativeRange.setStart(a,b),this.nativeRange.setEnd(a,b)}d(this)},l=function(a,b){return function(c){try{this.nativeRange[a](c)}catch(d){this.nativeRange[b](c),this.nativeRange[a](c)}d(this)}}}k.setStartBefore=l(\"setStartBefore\",\"setEndBefore\"),k.setStartAfter=l(\"setStartAfter\",\"setEndAfter\"),k.setEndBefore=l(\"setEndBefore\",\"setStartBefore\"),k.setEndAfter=l(\"setEndAfter\",\"setStartAfter\"),/*--------------------------------------------------------------------------------------------------------*/\n// Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing\n// whether the native implementation can be trusted\nk.selectNodeContents=function(a){this.setStartAndEnd(a,0,e.getNodeLength(a))},/*--------------------------------------------------------------------------------------------------------*/\n// Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for\n// constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738\no.selectNodeContents(n),o.setEnd(n,3);var p=document.createRange();p.selectNodeContents(n),p.setEnd(n,4),p.setStart(n,2),o.compareBoundaryPoints(o.START_TO_END,p)==-1&&1==o.compareBoundaryPoints(o.END_TO_START,p)?\n// This is the wrong way round, so correct for it\nk.compareBoundaryPoints=function(a,b){return b=b.nativeRange||b,a==b.START_TO_END?a=b.END_TO_START:a==b.END_TO_START&&(a=b.START_TO_END),this.nativeRange.compareBoundaryPoints(a,b)}:k.compareBoundaryPoints=function(a,b){return this.nativeRange.compareBoundaryPoints(a,b.nativeRange||b)};/*--------------------------------------------------------------------------------------------------------*/\n// Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.\nvar q=document.createElement(\"div\");q.innerHTML=\"123\";var r=q.firstChild,s=i(document);s.appendChild(q),o.setStart(r,1),o.setEnd(r,2),o.deleteContents(),\"13\"==r.data&&(\n// Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and\n// extractContents()\nk.deleteContents=function(){this.nativeRange.deleteContents(),d(this)},k.extractContents=function(){var a=this.nativeRange.extractContents();return d(this),a}),s.removeChild(q),s=null,/*--------------------------------------------------------------------------------------------------------*/\n// Test for existence of createContextualFragment and delegate to it if it exists\nf.isHostMethod(o,\"createContextualFragment\")&&(k.createContextualFragment=function(a){return this.nativeRange.createContextualFragment(a)}),/*--------------------------------------------------------------------------------------------------------*/\n// Clean up\ni(document).removeChild(n),k.getName=function(){return\"WrappedRange\"},a.WrappedRange=c,a.createNativeRange=function(a){return a=j(a,b,\"createNativeRange\"),a.createRange()}}(),a.features.implementsTextRange){/*\n            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()\n            method. For example, in the following (where pipes denote the selection boundaries):\n\n            <ul id=\"ul\"><li id=\"a\">| a </li><li id=\"b\"> b |</li></ul>\n\n            var range = document.selection.createRange();\n            alert(range.parentElement().id); // Should alert \"ul\" but alerts \"b\"\n\n            This method returns the common ancestor node of the following:\n            - the parentElement() of the textRange\n            - the parentElement() of the textRange after calling collapse(true)\n            - the parentElement() of the textRange after calling collapse(false)\n            */\nvar l=function(a){var b=a.parentElement(),c=a.duplicate();c.collapse(!0);var d=c.parentElement();c=a.duplicate(),c.collapse(!1);var f=c.parentElement(),g=d==f?d:e.getCommonAncestor(d,f);return g==b?g:e.getCommonAncestor(b,g)},m=function(a){return 0==a.compareEndPoints(\"StartToEnd\",a)},n=function(a,b,c,d,f){var h=a.duplicate();h.collapse(c);var i=h.parentElement();\n// Deal with nodes that cannot \"contain rich HTML markup\". In practice, this means form inputs, images and\n// similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx\nif(\n// Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so\n// check for that\ne.isOrIsAncestorOf(b,i)||(i=b),!i.canHaveHTML){var j=new g(i.parentNode,e.getNodeIndex(i));return{boundaryPosition:j,nodeInfo:{nodeIndex:j.offset,containerElement:j.node}}}var l=e.getDocument(i).createElement(\"span\");\n// Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5\n// Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64\nl.parentNode&&e.removeNode(l);for(var m,n,o,p,q,r=c?\"StartToStart\":\"StartToEnd\",s=f&&f.containerElement==i?f.nodeIndex:0,t=i.childNodes.length,u=t,v=u;;){if(v==t?i.appendChild(l):i.insertBefore(l,i.childNodes[v]),h.moveToElementText(l),m=h.compareEndPoints(r,a),0==m||s==u)break;if(m==-1){if(u==s+1)\n// We know the endth child node is after the range boundary, so we must be done.\nbreak;s=v}else u=u==s+1?s:v;v=Math.floor((s+u)/2),i.removeChild(l)}if(\n// We've now reached or gone past the boundary of the text range we're interested in\n// so have identified the node we want\nq=l.nextSibling,m==-1&&q&&k(q)){\n// This is a character data node (text, comment, cdata). The working range is collapsed at the start of\n// the node containing the text range's boundary, so we move the end of the working range to the\n// boundary point and measure the length of its text to get the boundary's offset within the node.\nh.setEndPoint(c?\"EndToStart\":\"EndToEnd\",a);var w;if(/[\\r\\n]/.test(q.data)){/*\n                        For the particular case of a boundary within a text node containing rendered line breaks (within a\n                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in\n                        IE. The facts:\n\n                        - Each line break is represented as \\r in the text node's data/nodeValue properties\n                        - Each line break is represented as \\r\\n in the TextRange's 'text' property\n                        - The 'text' property of the TextRange does not contain trailing line breaks\n\n                        To get round the problem presented by the final fact above, we can use the fact that TextRange's\n                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not\n                        necessarily the same as the number of characters it was instructed to move. The simplest approach is\n                        to use this to store the characters moved when moving both the start and end of the range to the\n                        start of the document body and subtracting the start offset from the end offset (the\n                        \"move-negative-gazillion\" method). However, this is extremely slow when the document is large and\n                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to\n                        the end of the document) has the same problem.\n\n                        Another approach that works is to use moveStart() to move the start boundary of the range up to the\n                        end boundary one character at a time and incrementing a counter with the value returned by the\n                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is\n                        expensive, so this method is slow (although unlike \"move-negative-gazillion\" is largely unaffected\n                        by the location of the range within the document).\n\n                        The approach used below is a hybrid of the two methods above. It uses the fact that a string\n                        containing the TextRange's 'text' property with each \\r\\n converted to a single \\r character cannot\n                        be longer than the text of the TextRange, so the start of the range is moved that length initially\n                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'\n                        property. This has good performance in most situations compared to the previous two methods.\n                        */\nvar x=h.duplicate(),y=x.text.replace(/\\r\\n/g,\"\\r\").length;for(w=x.moveStart(\"character\",y);(m=x.compareEndPoints(\"StartToEnd\",x))==-1;)w++,x.moveStart(\"character\",1)}else w=h.text.length;p=new g(q,w)}else\n// If the boundary immediately follows a character data node and this is the end boundary, we should favour\n// a position within that, and likewise for a start boundary preceding a character data node\nn=(d||!c)&&l.previousSibling,o=(d||c)&&l.nextSibling,p=o&&k(o)?new g(o,0):n&&k(n)?new g(n,n.data.length):new g(i,e.getNodeIndex(l));\n// Clean up\nreturn e.removeNode(l),{boundaryPosition:p,nodeInfo:{nodeIndex:v,containerElement:i}}},o=function(a,b){var c,d,f,g,h=a.offset,j=e.getDocument(a.node),l=i(j).createTextRange(),m=k(a.node);\n// Position the range immediately before the node containing the boundary\n// Making the working element non-empty element persuades IE to consider the TextRange boundary to be within\n// the element rather than immediately before or after it\n// insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report\n// for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12\n// Clean up\n// Move the working range to the text offset, if required\nreturn m?(c=a.node,d=c.parentNode):(g=a.node.childNodes,c=h<g.length?g[h]:null,d=a.node),f=j.createElement(\"span\"),f.innerHTML=\"&#feff;\",c?d.insertBefore(f,c):d.appendChild(f),l.moveToElementText(f),l.collapse(!b),d.removeChild(f),m&&l[b?\"moveStart\":\"moveEnd\"](\"character\",h),l};/*------------------------------------------------------------------------------------------------------------*/\n// This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a\n// prototype\nd=function(a){this.textRange=a,this.refresh()},d.prototype=new h(document),d.prototype.refresh=function(){var a,b,c,d=l(this.textRange);m(this.textRange)?b=a=n(this.textRange,d,!0,!0).boundaryPosition:(c=n(this.textRange,d,!0,!1),a=c.boundaryPosition,\n// An optimization used here is that if the start and end boundaries have the same parent element, the\n// search scope for the end boundary can be limited to exclude the portion of the element that precedes\n// the start boundary\nb=n(this.textRange,d,!1,!1,c.nodeInfo).boundaryPosition),this.setStart(a.node,a.offset),this.setEnd(b.node,b.offset)},d.prototype.getName=function(){return\"WrappedTextRange\"},h.copyComparisonConstants(d);var p=function(a){if(a.collapsed)return o(new g(a.startContainer,a.startOffset),!0);var b=o(new g(a.startContainer,a.startOffset),!0),c=o(new g(a.endContainer,a.endOffset),!1),d=i(h.getRangeDocument(a)).createTextRange();return d.setEndPoint(\"StartToStart\",b),d.setEndPoint(\"EndToEnd\",c),d};\n// IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which\n// implementation to use by default.\nif(d.rangeToTextRange=p,d.prototype.toTextRange=function(){return p(this)},a.WrappedTextRange=d,!a.features.implementsDomRange||a.config.preferTextRange){\n// Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work\nvar q=function(a){return a(\"return this;\")()}(Function);\"undefined\"==typeof q.Range&&(q.Range=d),a.createNativeRange=function(a){return a=j(a,b,\"createNativeRange\"),i(a).createTextRange()},a.WrappedRange=d}}a.createRange=function(c){return c=j(c,b,\"createRange\"),new a.WrappedRange(a.createNativeRange(c))},a.createRangyRange=function(a){return a=j(a,b,\"createRangyRange\"),new h(a)},f.createAliasForDeprecatedMethod(a,\"createIframeRange\",\"createRange\"),f.createAliasForDeprecatedMethod(a,\"createIframeRangyRange\",\"createRangyRange\"),a.addShimListener(function(b){var c=b.document;\"undefined\"==typeof c.createRange&&(c.createRange=function(){return a.createRange(c)}),c=b=null})}),/*----------------------------------------------------------------------------------------------------------------*/\n// This module creates a selection object wrapper that conforms as closely as possible to the Selection specification\n// in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)\nH.createCoreModule(\"WrappedSelection\",[\"DomRange\",\"WrappedRange\"],function(a,b){\n// Utility function to support direction parameters in the API that may be a string (\"backward\", \"backwards\",\n// \"forward\" or \"forwards\") or a Boolean (true for backwards).\nfunction c(a){return\"string\"==typeof a?/^backward(s)?$/i.test(a):!!a}function d(a,c){if(a){if(C.isWindow(a))return a;if(a instanceof r)return a.win;var d=C.getContentDocument(a,b,c);return C.getWindow(d)}return window}function e(a){return d(a,\"getWinSelection\").getSelection()}function f(a){return d(a,\"getDocSelection\").document.selection}function g(a){var b=!1;return a.anchorNode&&(b=1==C.comparePoints(a.anchorNode,a.anchorOffset,a.focusNode,a.focusOffset)),b}function h(a,b,c){var d=c?\"end\":\"start\",e=c?\"start\":\"end\";a.anchorNode=b[d+\"Container\"],a.anchorOffset=b[d+\"Offset\"],a.focusNode=b[e+\"Container\"],a.focusOffset=b[e+\"Offset\"]}function i(a){var b=a.nativeSelection;a.anchorNode=b.anchorNode,a.anchorOffset=b.anchorOffset,a.focusNode=b.focusNode,a.focusOffset=b.focusOffset}function j(a){a.anchorNode=a.focusNode=null,a.anchorOffset=a.focusOffset=0,a.rangeCount=0,a.isCollapsed=!0,a._ranges.length=0}function k(b){var c;return b instanceof F?(c=a.createNativeRange(b.getDocument()),c.setEnd(b.endContainer,b.endOffset),c.setStart(b.startContainer,b.startOffset)):b instanceof G?c=b.nativeRange:J.implementsDomRange&&b instanceof C.getWindow(b.startContainer).Range&&(c=b),c}function l(a){if(!a.length||1!=a[0].nodeType)return!1;for(var b=1,c=a.length;b<c;++b)if(!C.isAncestorOf(a[0],a[b]))return!1;return!0}function m(a){var c=a.getNodes();if(!l(c))throw b.createError(\"getSingleElementFromRange: range \"+a.inspect()+\" did not consist of a single element\");return c[0]}\n// Simple, quick test which only needs to distinguish between a TextRange and a ControlRange\nfunction n(a){return!!a&&\"undefined\"!=typeof a.text}function o(a,b){\n// Create a Range from the selected TextRange\nvar c=new G(b);a._ranges=[c],h(a,c,!1),a.rangeCount=1,a.isCollapsed=c.collapsed}function p(b){if(\n// Update the wrapped selection based on what's now in the native selection\nb._ranges.length=0,\"None\"==b.docSelection.type)j(b);else{var c=b.docSelection.createRange();if(n(c))\n// This case (where the selection type is \"Control\" and calling createRange() on the selection returns\n// a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected\n// ControlRange have been removed from the ControlRange and removed from the document.\no(b,c);else{b.rangeCount=c.length;for(var d,e=L(c.item(0)),f=0;f<b.rangeCount;++f)d=a.createRange(e),d.selectNode(c.item(f)),b._ranges.push(d);b.isCollapsed=1==b.rangeCount&&b._ranges[0].collapsed,h(b,b._ranges[b.rangeCount-1],!1)}}}function q(a,c){for(var d=a.docSelection.createRange(),e=m(c),f=L(d.item(0)),g=M(f).createControlRange(),h=0,i=d.length;h<i;++h)g.add(d.item(h));try{g.add(e)}catch(a){throw b.createError(\"addRange(): Element within the specified Range could not be added to control selection (does it have layout?)\")}g.select(),\n// Update the wrapped selection based on what's now in the native selection\np(a)}function r(a,b,c){this.nativeSelection=a,this.docSelection=b,this._ranges=[],this.win=c,this.refresh()}function s(a){a.win=a.anchorNode=a.focusNode=a._ranges=null,a.rangeCount=a.anchorOffset=a.focusOffset=0,a.detached=!0}function t(a,b){for(var c,d,e=ba.length;e--;)if(c=ba[e],d=c.selection,\"deleteAll\"==b)s(d);else if(c.win==a)return\"delete\"==b?(ba.splice(e,1),!0):d;return\"deleteAll\"==b&&(ba.length=0),null}function u(a,c){for(var d,e=L(c[0].startContainer),f=M(e).createControlRange(),g=0,h=c.length;g<h;++g){d=m(c[g]);try{f.add(d)}catch(a){throw b.createError(\"setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)\")}}f.select(),\n// Update the wrapped selection based on what's now in the native selection\np(a)}function v(a,b){if(a.win.document!=L(b))throw new H(\"WRONG_DOCUMENT_ERR\")}function w(b){return function(c,d){var e;this.rangeCount?(e=this.getRangeAt(0),e[\"set\"+(b?\"Start\":\"End\")](c,d)):(e=a.createRange(this.win.document),e.setStartAndEnd(c,d)),this.setSingleRange(e,this.isBackward())}}function x(a){var b=[],c=new I(a.anchorNode,a.anchorOffset),d=new I(a.focusNode,a.focusOffset),e=\"function\"==typeof a.getName?a.getName():\"Selection\";if(\"undefined\"!=typeof a.rangeCount)for(var f=0,g=a.rangeCount;f<g;++f)b[f]=F.inspect(a.getRangeAt(f));return\"[\"+e+\"(Ranges: \"+b.join(\", \")+\")(anchor: \"+c.inspect()+\", focus: \"+d.inspect()+\"]\"}a.config.checkSelectionRanges=!0;var y,z,A=\"boolean\",B=\"number\",C=a.dom,D=a.util,E=D.isHostMethod,F=a.DomRange,G=a.WrappedRange,H=a.DOMException,I=C.DomPosition,J=a.features,K=\"Control\",L=C.getDocument,M=C.getBody,N=F.rangesEqual,O=E(window,\"getSelection\"),P=D.isHostObject(document,\"selection\");J.implementsWinGetSelection=O,J.implementsDocSelection=P;var Q=P&&(!O||a.config.preferTextRange);if(Q)y=f,a.isSelectionValid=function(a){var b=d(a,\"isSelectionValid\").document,c=b.selection;\n// Check whether the selection TextRange is actually contained within the correct document\nreturn\"None\"!=c.type||L(c.createRange().parentElement())==b};else{if(!O)return b.fail(\"Neither document.selection or window.getSelection() detected.\"),!1;y=e,a.isSelectionValid=function(){return!0}}a.getNativeSelection=y;var R=y();\n// In Firefox, the selection is null in an iframe with display: none. See issue #138.\nif(!R)return b.fail(\"Native selection was null (possibly issue 138?)\"),!1;var S=a.createNativeRange(document),T=M(document),U=D.areHostProperties(R,[\"anchorNode\",\"focusNode\",\"anchorOffset\",\"focusOffset\"]);J.selectionHasAnchorAndFocus=U;\n// Test for existence of native selection extend() method\nvar V=E(R,\"extend\");J.selectionHasExtend=V;\n// Test if rangeCount exists\nvar W=typeof R.rangeCount==B;J.selectionHasRangeCount=W;var X=!1,Y=!0,Z=V?function(b,c){var d=F.getRangeDocument(c),e=a.createRange(d);e.collapseToPoint(c.endContainer,c.endOffset),b.addRange(k(e)),b.extend(c.startContainer,c.startOffset)}:null;D.areHostMethods(R,[\"addRange\",\"getRangeAt\",\"removeAllRanges\"])&&typeof R.rangeCount==B&&J.implementsDomRange&&!function(){\n// Previously an iframe was used but this caused problems in some circumstances in IE, so tests are\n// performed on the current document's selection. See issue 109.\n// Note also that if a selection previously existed, it is wiped and later restored by these tests. This\n// will result in the selection direction begin reversed if the original selection was backwards and the\n// browser does not support setting backwards selections (Internet Explorer, I'm looking at you).\nvar b=window.getSelection();if(b){for(var c=b.rangeCount,d=c>1,e=[],f=g(b),h=0;h<c;++h)e[h]=b.getRangeAt(h);\n// Create some test elements\nvar i=C.createTestElement(document,\"\",!1),j=i.appendChild(document.createTextNode(\"   \")),k=document.createRange();\n// Test whether the native selection is capable of supporting multiple ranges.\nif(k.setStart(j,1),k.collapse(!0),b.removeAllRanges(),b.addRange(k),Y=1==b.rangeCount,b.removeAllRanges(),!d){\n// Doing the original feature test here in Chrome 36 (and presumably later versions) prints a\n// console error of \"Discontiguous selection is not supported.\" that cannot be suppressed. There's\n// nothing we can do about this while retaining the feature test so we have to resort to a browser\n// sniff. I'm not happy about it. See\n// https://code.google.com/p/chromium/issues/detail?id=399791\nvar l=window.navigator.appVersion.match(/Chrome\\/(.*?) /);if(l&&parseInt(l[1])>=36)X=!1;else{var m=k.cloneRange();k.setStart(j,0),m.setEnd(j,3),m.setStart(j,2),b.addRange(k),b.addRange(m),X=2==b.rangeCount}}for(\n// Clean up\nC.removeNode(i),b.removeAllRanges(),h=0;h<c;++h)0==h&&f?Z?Z(b,e[h]):(a.warn(\"Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend\"),b.addRange(e[h])):b.addRange(e[h])}}(),J.selectionSupportsMultipleRanges=X,J.collapsedNonEditableSelectionsSupported=Y;\n// ControlRanges\nvar $,_=!1;T&&E(T,\"createControlRange\")&&($=T.createControlRange(),D.areHostProperties($,[\"item\",\"add\"])&&(_=!0)),J.implementsControlRange=_,\n// Selection collapsedness\nz=U?function(a){return a.anchorNode===a.focusNode&&a.anchorOffset===a.focusOffset}:function(a){return!!a.rangeCount&&a.getRangeAt(a.rangeCount-1).collapsed};var aa;E(R,\"getRangeAt\")?\n// try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.\n// Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a\n// lesson to us all, especially me.\naa=function(a,b){try{return a.getRangeAt(b)}catch(a){return null}}:U&&(aa=function(b){var c=L(b.anchorNode),d=a.createRange(c);\n// Handle the case when the selection was selected backwards (from the end to the start in the\n// document)\nreturn d.setStartAndEnd(b.anchorNode,b.anchorOffset,b.focusNode,b.focusOffset),d.collapsed!==this.isCollapsed&&d.setStartAndEnd(b.focusNode,b.focusOffset,b.anchorNode,b.anchorOffset),d}),r.prototype=a.selectionPrototype;var ba=[],ca=function(a){\n// Check if the parameter is a Rangy Selection object\nif(a&&a instanceof r)return a.refresh(),a;a=d(a,\"getNativeSelection\");var b=t(a),c=y(a),e=P?f(a):null;return b?(b.nativeSelection=c,b.docSelection=e,b.refresh()):(b=new r(c,e,a),ba.push({win:a,selection:b})),b};a.getSelection=ca,D.createAliasForDeprecatedMethod(a,\"getIframeSelection\",\"getSelection\");var da=r.prototype;\n// Selecting a range\nif(!Q&&U&&D.areHostMethods(R,[\"removeAllRanges\",\"addRange\"])){da.removeAllRanges=function(){this.nativeSelection.removeAllRanges(),j(this)};var ea=function(a,b){Z(a.nativeSelection,b),a.refresh()};W?da.addRange=function(b,d){if(_&&P&&this.docSelection.type==K)q(this,b);else if(c(d)&&V)ea(this,b);else{var e;X?e=this.rangeCount:(this.removeAllRanges(),e=0);\n// Clone the native range so that changing the selected range does not affect the selection.\n// This is contrary to the spec but is the only way to achieve consistency between browsers. See\n// issue 80.\nvar f=k(b).cloneRange();try{this.nativeSelection.addRange(f)}catch(a){}if(\n// Check whether adding the range was successful\nthis.rangeCount=this.nativeSelection.rangeCount,this.rangeCount==e+1){\n// The range was added successfully\n// Check whether the range that we added to the selection is reflected in the last range extracted from\n// the selection\nif(a.config.checkSelectionRanges){var g=aa(this.nativeSelection,this.rangeCount-1);g&&!N(g,b)&&(\n// Happens in WebKit with, for example, a selection placed at the start of a text node\nb=new G(g))}this._ranges[this.rangeCount-1]=b,h(this,b,ha(this.nativeSelection)),this.isCollapsed=z(this)}else\n// The range was not added successfully. The simplest thing is to refresh\nthis.refresh()}}:da.addRange=function(a,b){c(b)&&V?ea(this,a):(this.nativeSelection.addRange(k(a)),this.refresh())},da.setRanges=function(a){if(_&&P&&a.length>1)u(this,a);else{this.removeAllRanges();for(var b=0,c=a.length;b<c;++b)this.addRange(a[b])}}}else{if(!(E(R,\"empty\")&&E(S,\"select\")&&_&&Q))return b.fail(\"No means of selecting a Range or TextRange was found\"),!1;da.removeAllRanges=function(){\n// Added try/catch as fix for issue #21\ntry{\n// Check for empty() not working (issue #24)\nif(this.docSelection.empty(),\"None\"!=this.docSelection.type){\n// Work around failure to empty a control selection by instead selecting a TextRange and then\n// calling empty()\nvar a;if(this.anchorNode)a=L(this.anchorNode);else if(this.docSelection.type==K){var b=this.docSelection.createRange();b.length&&(a=L(b.item(0)))}if(a){var c=M(a).createTextRange();c.select(),this.docSelection.empty()}}}catch(a){}j(this)},da.addRange=function(b){this.docSelection.type==K?q(this,b):(a.WrappedTextRange.rangeToTextRange(b).select(),this._ranges[0]=b,this.rangeCount=1,this.isCollapsed=this._ranges[0].collapsed,h(this,b,!1))},da.setRanges=function(a){this.removeAllRanges();var b=a.length;b>1?u(this,a):b&&this.addRange(a[0])}}da.getRangeAt=function(a){if(a<0||a>=this.rangeCount)throw new H(\"INDEX_SIZE_ERR\");\n// Clone the range to preserve selection-range independence. See issue 80.\nreturn this._ranges[a].cloneRange()};var fa;if(Q)fa=function(b){var c;a.isSelectionValid(b.win)?c=b.docSelection.createRange():(c=M(b.win.document).createTextRange(),c.collapse(!0)),b.docSelection.type==K?p(b):n(c)?o(b,c):j(b)};else if(E(R,\"getRangeAt\")&&typeof R.rangeCount==B)fa=function(b){if(_&&P&&b.docSelection.type==K)p(b);else if(b._ranges.length=b.rangeCount=b.nativeSelection.rangeCount,b.rangeCount){for(var c=0,d=b.rangeCount;c<d;++c)b._ranges[c]=new a.WrappedRange(b.nativeSelection.getRangeAt(c));h(b,b._ranges[b.rangeCount-1],ha(b.nativeSelection)),b.isCollapsed=z(b)}else j(b)};else{if(!U||typeof R.isCollapsed!=A||typeof S.collapsed!=A||!J.implementsDomRange)return b.fail(\"No means of obtaining a Range or TextRange from the user's selection was found\"),!1;fa=function(a){var b,c=a.nativeSelection;c.anchorNode?(b=aa(c,0),a._ranges=[b],a.rangeCount=1,i(a),a.isCollapsed=z(a)):j(a)}}da.refresh=function(a){var b=a?this._ranges.slice(0):null,c=this.anchorNode,d=this.anchorOffset;if(fa(this),a){\n// Check the range count first\nvar e=b.length;if(e!=this._ranges.length)return!0;\n// Now check the direction. Checking the anchor position is the same is enough since we're checking all the\n// ranges after this\nif(this.anchorNode!=c||this.anchorOffset!=d)return!0;\n// Finally, compare each range in turn\nfor(;e--;)if(!N(b[e],this._ranges[e]))return!0;return!1}};\n// Removal of a single range\nvar ga=function(a,b){var c=a.getAllRanges();a.removeAllRanges();for(var d=0,e=c.length;d<e;++d)N(b,c[d])||a.addRange(c[d]);a.rangeCount||j(a)};_&&P?da.removeRange=function(a){if(this.docSelection.type==K){for(var b,c=this.docSelection.createRange(),d=m(a),e=L(c.item(0)),f=M(e).createControlRange(),g=!1,h=0,i=c.length;h<i;++h)b=c.item(h),b!==d||g?f.add(c.item(h)):g=!0;f.select(),\n// Update the wrapped selection based on what's now in the native selection\np(this)}else ga(this,a)}:da.removeRange=function(a){ga(this,a)};\n// Detecting if a selection is backward\nvar ha;!Q&&U&&J.implementsDomRange?(ha=g,da.isBackward=function(){return ha(this)}):ha=da.isBackward=function(){return!1},\n// Create an alias for backwards compatibility. From 1.3, everything is \"backward\" rather than \"backwards\"\nda.isBackwards=da.isBackward,\n// Selection stringifier\n// This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.\n// The current spec does not yet define this method.\nda.toString=function(){for(var a=[],b=0,c=this.rangeCount;b<c;++b)a[b]=\"\"+this._ranges[b];return a.join(\"\")},\n// No current browser conforms fully to the spec for this method, so Rangy's own method is always used\nda.collapse=function(b,c){v(this,b);var d=a.createRange(b);d.collapseToPoint(b,c),this.setSingleRange(d),this.isCollapsed=!0},da.collapseToStart=function(){if(!this.rangeCount)throw new H(\"INVALID_STATE_ERR\");var a=this._ranges[0];this.collapse(a.startContainer,a.startOffset)},da.collapseToEnd=function(){if(!this.rangeCount)throw new H(\"INVALID_STATE_ERR\");var a=this._ranges[this.rangeCount-1];this.collapse(a.endContainer,a.endOffset)},\n// The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as\n// specified so the native implementation is never used by Rangy.\nda.selectAllChildren=function(b){v(this,b);var c=a.createRange(b);c.selectNodeContents(b),this.setSingleRange(c)},da.deleteFromDocument=function(){\n// Sepcial behaviour required for IE's control selections\nif(_&&P&&this.docSelection.type==K){for(var a,b=this.docSelection.createRange();b.length;)a=b.item(0),b.remove(a),C.removeNode(a);this.refresh()}else if(this.rangeCount){var c=this.getAllRanges();if(c.length){this.removeAllRanges();for(var d=0,e=c.length;d<e;++d)c[d].deleteContents();\n// The spec says nothing about what the selection should contain after calling deleteContents on each\n// range. Firefox moves the selection to where the final selected range was, so we emulate that\nthis.addRange(c[e-1])}}},\n// The following are non-standard extensions\nda.eachRange=function(a,b){for(var c=0,d=this._ranges.length;c<d;++c)if(a(this.getRangeAt(c)))return b},da.getAllRanges=function(){var a=[];return this.eachRange(function(b){a.push(b)}),a},da.setSingleRange=function(a,b){this.removeAllRanges(),this.addRange(a,b)},da.callMethodOnEachRange=function(a,b){var c=[];return this.eachRange(function(d){c.push(d[a].apply(d,b||[]))}),c},da.setStart=w(!0),da.setEnd=w(!1),\n// Add select() method to Range prototype. Any existing selection will be removed.\na.rangePrototype.select=function(a){ca(this.getDocument()).setSingleRange(this,a)},da.changeEachRange=function(a){var b=[],c=this.isBackward();this.eachRange(function(c){a(c),b.push(c)}),this.removeAllRanges(),c&&1==b.length?this.addRange(b[0],\"backward\"):this.setRanges(b)},da.containsNode=function(a,b){return this.eachRange(function(c){return c.containsNode(a,b)},!0)||!1},da.getBookmark=function(a){return{backward:this.isBackward(),rangeBookmarks:this.callMethodOnEachRange(\"getBookmark\",[a])}},da.moveToBookmark=function(b){for(var c,d,e=[],f=0;c=b.rangeBookmarks[f++];)d=a.createRange(this.win),d.moveToBookmark(c),e.push(d);b.backward?this.setSingleRange(e[0],\"backward\"):this.setRanges(e)},da.saveRanges=function(){return{backward:this.isBackward(),ranges:this.callMethodOnEachRange(\"cloneRange\")}},da.restoreRanges=function(a){this.removeAllRanges();for(var b,c=0;b=a.ranges[c];++c)this.addRange(b,a.backward&&0==c)},da.toHtml=function(){var a=[];return this.eachRange(function(b){a.push(F.toHtml(b))}),a.join(\"\")},J.implementsTextRange&&(da.getNativeTextRange=function(){var c;if(c=this.docSelection){var d=c.createRange();if(n(d))return d;throw b.createError(\"getNativeTextRange: selection is a control selection\")}if(this.rangeCount>0)return a.WrappedTextRange.rangeToTextRange(this.getRangeAt(0));throw b.createError(\"getNativeTextRange: selection contains no range\")}),da.getName=function(){return\"WrappedSelection\"},da.inspect=function(){return x(this)},da.detach=function(){t(this.win,\"delete\"),s(this)},r.detachAll=function(){t(null,\"deleteAll\")},r.inspect=x,r.isDirectionBackward=c,a.Selection=r,a.selectionPrototype=da,a.addShimListener(function(a){\"undefined\"==typeof a.getSelection&&(a.getSelection=function(){return ca(a)}),a=null})});/*----------------------------------------------------------------------------------------------------------------*/\n// Wait for document to load before initializing\nvar M=!1,N=function(a){M||(M=!0,!H.initialized&&H.config.autoInitialize&&l())};\n// Test whether the document has already been loaded and initialize immediately if so\n// Add a fallback in case the DOMContentLoaded event isn't supported\nreturn F&&(\"complete\"==document.readyState?N():(a(document,\"addEventListener\")&&document.addEventListener(\"DOMContentLoaded\",N,!1),J(window,\"load\",N))),H},this),/**\n * Selection save and restore module for Rangy.\n * Saves and restores user selections using marker invisible elements in the DOM.\n *\n * Part of Rangy, a cross-browser JavaScript range and selection library\n * https://github.com/timdown/rangy\n *\n * Depends on Rangy core.\n *\n * Copyright 2015, Tim Down\n * Licensed under the MIT license.\n * Version: 1.3.0\n * Build date: 10 May 2015\n */\nfunction(a,b){\"function\"==typeof define&&define.amd?\n// AMD. Register as an anonymous module with a dependency on Rangy.\ndefine([\"./rangy-core\"],a):\"undefined\"!=typeof module&&\"object\"==typeof exports?\n// Node/CommonJS style\nmodule.exports=a(require(\"rangy\")):\n// No AMD or CommonJS support so we use the rangy property of root (probably the global variable)\na(b.rangy)}(function(a){return a.createModule(\"SaveRestore\",[\"WrappedRange\"],function(a,b){function c(a,b){return(b||document).getElementById(a)}function d(a,b){var c,d=\"selectionBoundary_\"+ +new Date+\"_\"+(\"\"+Math.random()).slice(2),e=o.getDocument(a.startContainer),f=a.cloneRange();\n// Create the marker element containing a single invisible character using DOM methods and insert it\nreturn f.collapse(b),c=e.createElement(\"span\"),c.id=d,c.style.lineHeight=\"0\",c.style.display=\"none\",c.className=\"rangySelectionBoundary\",c.appendChild(e.createTextNode(r)),f.insertNode(c),c}function e(a,d,e,f){var g=c(e,a);g?(d[f?\"setStartBefore\":\"setEndBefore\"](g),p(g)):b.warn(\"Marker element has been removed. Cannot restore selection.\")}function f(a,b){return b.compareBoundaryPoints(a.START_TO_START,a)}function g(b,c){var e,f,g=a.DomRange.getRangeDocument(b),h=b.toString(),i=q(c);return b.collapsed?(f=d(b,!1),{document:g,markerId:f.id,collapsed:!0}):(f=d(b,!1),e=d(b,!0),{document:g,startMarkerId:e.id,endMarkerId:f.id,collapsed:!1,backward:i,toString:function(){return\"original text: '\"+h+\"', new text: '\"+b.toString()+\"'\"}})}function h(d,f){var g=d.document;\"undefined\"==typeof f&&(f=!0);var h=a.createRange(g);if(d.collapsed){var i=c(d.markerId,g);if(i){i.style.display=\"inline\";var j=i.previousSibling;\n// Workaround for issue 17\nj&&3==j.nodeType?(p(i),h.collapseToPoint(j,j.length)):(h.collapseBefore(i),p(i))}else b.warn(\"Marker element has been removed. Cannot restore selection.\")}else e(g,h,d.startMarkerId,!0),e(g,h,d.endMarkerId,!1);return f&&h.normalizeBoundaries(),h}function i(b,d){var e,h,i=[],j=q(d);\n// Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched\nb=b.slice(0),b.sort(f);for(var k=0,l=b.length;k<l;++k)i[k]=g(b[k],j);\n// Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie\n// between its markers\nfor(k=l-1;k>=0;--k)e=b[k],h=a.DomRange.getRangeDocument(e),e.collapsed?e.collapseAfter(c(i[k].markerId,h)):(e.setEndBefore(c(i[k].endMarkerId,h)),e.setStartAfter(c(i[k].startMarkerId,h)));return i}function j(c){if(!a.isSelectionValid(c))return b.warn(\"Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.\"),null;var d=a.getSelection(c),e=d.getAllRanges(),f=1==e.length&&d.isBackward(),g=i(e,f);\n// Ensure current selection is unaffected\nreturn f?d.setSingleRange(e[0],f):d.setRanges(e),{win:c,rangeInfos:g,restored:!1}}function k(a){for(var b=[],c=a.length,d=c-1;d>=0;d--)b[d]=h(a[d],!0);return b}function l(b,c){if(!b.restored){var d=b.rangeInfos,e=a.getSelection(b.win),f=k(d),g=d.length;1==g&&c&&a.features.selectionHasExtend&&d[0].backward?(e.removeAllRanges(),e.addRange(f[0],!0)):e.setRanges(f),b.restored=!0}}function m(a,b){var d=c(b,a);d&&p(d)}function n(a){for(var b,c=a.rangeInfos,d=0,e=c.length;d<e;++d)b=c[d],b.collapsed?m(a.doc,b.markerId):(m(a.doc,b.startMarkerId),m(a.doc,b.endMarkerId))}var o=a.dom,p=o.removeNode,q=a.Selection.isDirectionBackward,r=\"\\ufeff\";a.util.extend(a,{saveRange:g,restoreRange:h,saveRanges:i,restoreRanges:k,saveSelection:j,restoreSelection:l,removeMarkerElement:m,removeMarkers:n})}),a},this);"

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1532))

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	module.exports = "(function(f){if(typeof exports===\"object\"&&typeof module!==\"undefined\"){module.exports=f()}else if(typeof define===\"function\"&&define.amd){define([],f)}else{var g;if(typeof window!==\"undefined\"){g=window}else if(typeof global!==\"undefined\"){g=global}else if(typeof self!==\"undefined\"){g=self}else{g=this}g.rltm = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require==\"function\"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error(\"Cannot find module '\"+o+\"'\");throw f.code=\"MODULE_NOT_FOUND\",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require==\"function\"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){\nmodule.exports = after\n\nfunction after(count, callback, err_cb) {\n    var bail = false\n    err_cb = err_cb || noop\n    proxy.count = count\n\n    return (count === 0) ? callback() : proxy\n\n    function proxy(err, result) {\n        if (proxy.count <= 0) {\n            throw new Error('after called too many times')\n        }\n        --proxy.count\n\n        // after first error, rest are passed to err_cb\n        if (err) {\n            bail = true\n            callback(err)\n            // future error callbacks will go to error handler\n            callback = err_cb\n        } else if (proxy.count === 0 && !bail) {\n            callback(null, result)\n        }\n    }\n}\n\nfunction noop() {}\n\n},{}],2:[function(require,module,exports){\n/**\n * An abstraction for slicing an arraybuffer even when\n * ArrayBuffer.prototype.slice is not supported\n *\n * @api public\n */\n\nmodule.exports = function(arraybuffer, start, end) {\n  var bytes = arraybuffer.byteLength;\n  start = start || 0;\n  end = end || bytes;\n\n  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }\n\n  if (start < 0) { start += bytes; }\n  if (end < 0) { end += bytes; }\n  if (end > bytes) { end = bytes; }\n\n  if (start >= bytes || start >= end || bytes === 0) {\n    return new ArrayBuffer(0);\n  }\n\n  var abv = new Uint8Array(arraybuffer);\n  var result = new Uint8Array(end - start);\n  for (var i = start, ii = 0; i < end; i++, ii++) {\n    result[ii] = abv[i];\n  }\n  return result.buffer;\n};\n\n},{}],3:[function(require,module,exports){\n\n/**\n * Expose `Backoff`.\n */\n\nmodule.exports = Backoff;\n\n/**\n * Initialize backoff timer with `opts`.\n *\n * - `min` initial timeout in milliseconds [100]\n * - `max` max timeout [10000]\n * - `jitter` [0]\n * - `factor` [2]\n *\n * @param {Object} opts\n * @api public\n */\n\nfunction Backoff(opts) {\n  opts = opts || {};\n  this.ms = opts.min || 100;\n  this.max = opts.max || 10000;\n  this.factor = opts.factor || 2;\n  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;\n  this.attempts = 0;\n}\n\n/**\n * Return the backoff duration.\n *\n * @return {Number}\n * @api public\n */\n\nBackoff.prototype.duration = function(){\n  var ms = this.ms * Math.pow(this.factor, this.attempts++);\n  if (this.jitter) {\n    var rand =  Math.random();\n    var deviation = Math.floor(rand * this.jitter * ms);\n    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;\n  }\n  return Math.min(ms, this.max) | 0;\n};\n\n/**\n * Reset the number of attempts.\n *\n * @api public\n */\n\nBackoff.prototype.reset = function(){\n  this.attempts = 0;\n};\n\n/**\n * Set the minimum duration\n *\n * @api public\n */\n\nBackoff.prototype.setMin = function(min){\n  this.ms = min;\n};\n\n/**\n * Set the maximum duration\n *\n * @api public\n */\n\nBackoff.prototype.setMax = function(max){\n  this.max = max;\n};\n\n/**\n * Set the jitter\n *\n * @api public\n */\n\nBackoff.prototype.setJitter = function(jitter){\n  this.jitter = jitter;\n};\n\n\n},{}],4:[function(require,module,exports){\n/*\n * base64-arraybuffer\n * https://github.com/niklasvh/base64-arraybuffer\n *\n * Copyright (c) 2012 Niklas von Hertzen\n * Licensed under the MIT license.\n */\n(function(){\n  \"use strict\";\n\n  var chars = \"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\";\n\n  // Use a lookup table to find the index.\n  var lookup = new Uint8Array(256);\n  for (var i = 0; i < chars.length; i++) {\n    lookup[chars.charCodeAt(i)] = i;\n  }\n\n  exports.encode = function(arraybuffer) {\n    var bytes = new Uint8Array(arraybuffer),\n    i, len = bytes.length, base64 = \"\";\n\n    for (i = 0; i < len; i+=3) {\n      base64 += chars[bytes[i] >> 2];\n      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];\n      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];\n      base64 += chars[bytes[i + 2] & 63];\n    }\n\n    if ((len % 3) === 2) {\n      base64 = base64.substring(0, base64.length - 1) + \"=\";\n    } else if (len % 3 === 1) {\n      base64 = base64.substring(0, base64.length - 2) + \"==\";\n    }\n\n    return base64;\n  };\n\n  exports.decode =  function(base64) {\n    var bufferLength = base64.length * 0.75,\n    len = base64.length, i, p = 0,\n    encoded1, encoded2, encoded3, encoded4;\n\n    if (base64[base64.length - 1] === \"=\") {\n      bufferLength--;\n      if (base64[base64.length - 2] === \"=\") {\n        bufferLength--;\n      }\n    }\n\n    var arraybuffer = new ArrayBuffer(bufferLength),\n    bytes = new Uint8Array(arraybuffer);\n\n    for (i = 0; i < len; i+=4) {\n      encoded1 = lookup[base64.charCodeAt(i)];\n      encoded2 = lookup[base64.charCodeAt(i+1)];\n      encoded3 = lookup[base64.charCodeAt(i+2)];\n      encoded4 = lookup[base64.charCodeAt(i+3)];\n\n      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);\n      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);\n      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);\n    }\n\n    return arraybuffer;\n  };\n})();\n\n},{}],5:[function(require,module,exports){\n(function (global){\n/**\n * Create a blob builder even when vendor prefixes exist\n */\n\nvar BlobBuilder = global.BlobBuilder\n  || global.WebKitBlobBuilder\n  || global.MSBlobBuilder\n  || global.MozBlobBuilder;\n\n/**\n * Check if Blob constructor is supported\n */\n\nvar blobSupported = (function() {\n  try {\n    var a = new Blob(['hi']);\n    return a.size === 2;\n  } catch(e) {\n    return false;\n  }\n})();\n\n/**\n * Check if Blob constructor supports ArrayBufferViews\n * Fails in Safari 6, so we need to map to ArrayBuffers there.\n */\n\nvar blobSupportsArrayBufferView = blobSupported && (function() {\n  try {\n    var b = new Blob([new Uint8Array([1,2])]);\n    return b.size === 2;\n  } catch(e) {\n    return false;\n  }\n})();\n\n/**\n * Check if BlobBuilder is supported\n */\n\nvar blobBuilderSupported = BlobBuilder\n  && BlobBuilder.prototype.append\n  && BlobBuilder.prototype.getBlob;\n\n/**\n * Helper function that maps ArrayBufferViews to ArrayBuffers\n * Used by BlobBuilder constructor and old browsers that didn't\n * support it in the Blob constructor.\n */\n\nfunction mapArrayBufferViews(ary) {\n  for (var i = 0; i < ary.length; i++) {\n    var chunk = ary[i];\n    if (chunk.buffer instanceof ArrayBuffer) {\n      var buf = chunk.buffer;\n\n      // if this is a subarray, make a copy so we only\n      // include the subarray region from the underlying buffer\n      if (chunk.byteLength !== buf.byteLength) {\n        var copy = new Uint8Array(chunk.byteLength);\n        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));\n        buf = copy.buffer;\n      }\n\n      ary[i] = buf;\n    }\n  }\n}\n\nfunction BlobBuilderConstructor(ary, options) {\n  options = options || {};\n\n  var bb = new BlobBuilder();\n  mapArrayBufferViews(ary);\n\n  for (var i = 0; i < ary.length; i++) {\n    bb.append(ary[i]);\n  }\n\n  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();\n};\n\nfunction BlobConstructor(ary, options) {\n  mapArrayBufferViews(ary);\n  return new Blob(ary, options || {});\n};\n\nmodule.exports = (function() {\n  if (blobSupported) {\n    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;\n  } else if (blobBuilderSupported) {\n    return BlobBuilderConstructor;\n  } else {\n    return undefined;\n  }\n})();\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{}],6:[function(require,module,exports){\n\n},{}],7:[function(require,module,exports){\n/**\n * Slice reference.\n */\n\nvar slice = [].slice;\n\n/**\n * Bind `obj` to `fn`.\n *\n * @param {Object} obj\n * @param {Function|String} fn or string\n * @return {Function}\n * @api public\n */\n\nmodule.exports = function(obj, fn){\n  if ('string' == typeof fn) fn = obj[fn];\n  if ('function' != typeof fn) throw new Error('bind() requires a function');\n  var args = slice.call(arguments, 2);\n  return function(){\n    return fn.apply(obj, args.concat(slice.call(arguments)));\n  }\n};\n\n},{}],8:[function(require,module,exports){\n\r\n/**\r\n * Expose `Emitter`.\r\n */\r\n\r\nif (typeof module !== 'undefined') {\r\n  module.exports = Emitter;\r\n}\r\n\r\n/**\r\n * Initialize a new `Emitter`.\r\n *\r\n * @api public\r\n */\r\n\r\nfunction Emitter(obj) {\r\n  if (obj) return mixin(obj);\r\n};\r\n\r\n/**\r\n * Mixin the emitter properties.\r\n *\r\n * @param {Object} obj\r\n * @return {Object}\r\n * @api private\r\n */\r\n\r\nfunction mixin(obj) {\r\n  for (var key in Emitter.prototype) {\r\n    obj[key] = Emitter.prototype[key];\r\n  }\r\n  return obj;\r\n}\r\n\r\n/**\r\n * Listen on the given `event` with `fn`.\r\n *\r\n * @param {String} event\r\n * @param {Function} fn\r\n * @return {Emitter}\r\n * @api public\r\n */\r\n\r\nEmitter.prototype.on =\r\nEmitter.prototype.addEventListener = function(event, fn){\r\n  this._callbacks = this._callbacks || {};\r\n  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])\r\n    .push(fn);\r\n  return this;\r\n};\r\n\r\n/**\r\n * Adds an `event` listener that will be invoked a single\r\n * time then automatically removed.\r\n *\r\n * @param {String} event\r\n * @param {Function} fn\r\n * @return {Emitter}\r\n * @api public\r\n */\r\n\r\nEmitter.prototype.once = function(event, fn){\r\n  function on() {\r\n    this.off(event, on);\r\n    fn.apply(this, arguments);\r\n  }\r\n\r\n  on.fn = fn;\r\n  this.on(event, on);\r\n  return this;\r\n};\r\n\r\n/**\r\n * Remove the given callback for `event` or all\r\n * registered callbacks.\r\n *\r\n * @param {String} event\r\n * @param {Function} fn\r\n * @return {Emitter}\r\n * @api public\r\n */\r\n\r\nEmitter.prototype.off =\r\nEmitter.prototype.removeListener =\r\nEmitter.prototype.removeAllListeners =\r\nEmitter.prototype.removeEventListener = function(event, fn){\r\n  this._callbacks = this._callbacks || {};\r\n\r\n  // all\r\n  if (0 == arguments.length) {\r\n    this._callbacks = {};\r\n    return this;\r\n  }\r\n\r\n  // specific event\r\n  var callbacks = this._callbacks['$' + event];\r\n  if (!callbacks) return this;\r\n\r\n  // remove all handlers\r\n  if (1 == arguments.length) {\r\n    delete this._callbacks['$' + event];\r\n    return this;\r\n  }\r\n\r\n  // remove specific handler\r\n  var cb;\r\n  for (var i = 0; i < callbacks.length; i++) {\r\n    cb = callbacks[i];\r\n    if (cb === fn || cb.fn === fn) {\r\n      callbacks.splice(i, 1);\r\n      break;\r\n    }\r\n  }\r\n  return this;\r\n};\r\n\r\n/**\r\n * Emit `event` with the given args.\r\n *\r\n * @param {String} event\r\n * @param {Mixed} ...\r\n * @return {Emitter}\r\n */\r\n\r\nEmitter.prototype.emit = function(event){\r\n  this._callbacks = this._callbacks || {};\r\n  var args = [].slice.call(arguments, 1)\r\n    , callbacks = this._callbacks['$' + event];\r\n\r\n  if (callbacks) {\r\n    callbacks = callbacks.slice(0);\r\n    for (var i = 0, len = callbacks.length; i < len; ++i) {\r\n      callbacks[i].apply(this, args);\r\n    }\r\n  }\r\n\r\n  return this;\r\n};\r\n\r\n/**\r\n * Return array of callbacks for `event`.\r\n *\r\n * @param {String} event\r\n * @return {Array}\r\n * @api public\r\n */\r\n\r\nEmitter.prototype.listeners = function(event){\r\n  this._callbacks = this._callbacks || {};\r\n  return this._callbacks['$' + event] || [];\r\n};\r\n\r\n/**\r\n * Check if this emitter has `event` handlers.\r\n *\r\n * @param {String} event\r\n * @return {Boolean}\r\n * @api public\r\n */\r\n\r\nEmitter.prototype.hasListeners = function(event){\r\n  return !! this.listeners(event).length;\r\n};\r\n\n},{}],9:[function(require,module,exports){\n\nmodule.exports = function(a, b){\n  var fn = function(){};\n  fn.prototype = b.prototype;\n  a.prototype = new fn;\n  a.prototype.constructor = a;\n};\n},{}],10:[function(require,module,exports){\n\nmodule.exports = require('./lib/index');\n\n},{\"./lib/index\":11}],11:[function(require,module,exports){\n\nmodule.exports = require('./socket');\n\n/**\n * Exports parser\n *\n * @api public\n *\n */\nmodule.exports.parser = require('engine.io-parser');\n\n},{\"./socket\":12,\"engine.io-parser\":23}],12:[function(require,module,exports){\n(function (global){\n/**\n * Module dependencies.\n */\n\nvar transports = require('./transports/index');\nvar Emitter = require('component-emitter');\nvar debug = require('debug')('engine.io-client:socket');\nvar index = require('indexof');\nvar parser = require('engine.io-parser');\nvar parseuri = require('parseuri');\nvar parsejson = require('parsejson');\nvar parseqs = require('parseqs');\n\n/**\n * Module exports.\n */\n\nmodule.exports = Socket;\n\n/**\n * Socket constructor.\n *\n * @param {String|Object} uri or options\n * @param {Object} options\n * @api public\n */\n\nfunction Socket (uri, opts) {\n  if (!(this instanceof Socket)) return new Socket(uri, opts);\n\n  opts = opts || {};\n\n  if (uri && 'object' === typeof uri) {\n    opts = uri;\n    uri = null;\n  }\n\n  if (uri) {\n    uri = parseuri(uri);\n    opts.hostname = uri.host;\n    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';\n    opts.port = uri.port;\n    if (uri.query) opts.query = uri.query;\n  } else if (opts.host) {\n    opts.hostname = parseuri(opts.host).host;\n  }\n\n  this.secure = null != opts.secure ? opts.secure\n    : (global.location && 'https:' === location.protocol);\n\n  if (opts.hostname && !opts.port) {\n    // if no port is specified manually, use the protocol default\n    opts.port = this.secure ? '443' : '80';\n  }\n\n  this.agent = opts.agent || false;\n  this.hostname = opts.hostname ||\n    (global.location ? location.hostname : 'localhost');\n  this.port = opts.port || (global.location && location.port\n      ? location.port\n      : (this.secure ? 443 : 80));\n  this.query = opts.query || {};\n  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);\n  this.upgrade = false !== opts.upgrade;\n  this.path = (opts.path || '/engine.io').replace(/\\/$/, '') + '/';\n  this.forceJSONP = !!opts.forceJSONP;\n  this.jsonp = false !== opts.jsonp;\n  this.forceBase64 = !!opts.forceBase64;\n  this.enablesXDR = !!opts.enablesXDR;\n  this.timestampParam = opts.timestampParam || 't';\n  this.timestampRequests = opts.timestampRequests;\n  this.transports = opts.transports || ['polling', 'websocket'];\n  this.readyState = '';\n  this.writeBuffer = [];\n  this.prevBufferLen = 0;\n  this.policyPort = opts.policyPort || 843;\n  this.rememberUpgrade = opts.rememberUpgrade || false;\n  this.binaryType = null;\n  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;\n  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;\n\n  if (true === this.perMessageDeflate) this.perMessageDeflate = {};\n  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {\n    this.perMessageDeflate.threshold = 1024;\n  }\n\n  // SSL options for Node.js client\n  this.pfx = opts.pfx || null;\n  this.key = opts.key || null;\n  this.passphrase = opts.passphrase || null;\n  this.cert = opts.cert || null;\n  this.ca = opts.ca || null;\n  this.ciphers = opts.ciphers || null;\n  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;\n  this.forceNode = !!opts.forceNode;\n\n  // other options for Node.js client\n  var freeGlobal = typeof global === 'object' && global;\n  if (freeGlobal.global === freeGlobal) {\n    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {\n      this.extraHeaders = opts.extraHeaders;\n    }\n\n    if (opts.localAddress) {\n      this.localAddress = opts.localAddress;\n    }\n  }\n\n  // set on handshake\n  this.id = null;\n  this.upgrades = null;\n  this.pingInterval = null;\n  this.pingTimeout = null;\n\n  // set on heartbeat\n  this.pingIntervalTimer = null;\n  this.pingTimeoutTimer = null;\n\n  this.open();\n}\n\nSocket.priorWebsocketSuccess = false;\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Socket.prototype);\n\n/**\n * Protocol version.\n *\n * @api public\n */\n\nSocket.protocol = parser.protocol; // this is an int\n\n/**\n * Expose deps for legacy compatibility\n * and standalone browser access.\n */\n\nSocket.Socket = Socket;\nSocket.Transport = require('./transport');\nSocket.transports = require('./transports/index');\nSocket.parser = require('engine.io-parser');\n\n/**\n * Creates transport of the given type.\n *\n * @param {String} transport name\n * @return {Transport}\n * @api private\n */\n\nSocket.prototype.createTransport = function (name) {\n  debug('creating transport \"%s\"', name);\n  var query = clone(this.query);\n\n  // append engine.io protocol identifier\n  query.EIO = parser.protocol;\n\n  // transport name\n  query.transport = name;\n\n  // session id if we already have one\n  if (this.id) query.sid = this.id;\n\n  var transport = new transports[name]({\n    agent: this.agent,\n    hostname: this.hostname,\n    port: this.port,\n    secure: this.secure,\n    path: this.path,\n    query: query,\n    forceJSONP: this.forceJSONP,\n    jsonp: this.jsonp,\n    forceBase64: this.forceBase64,\n    enablesXDR: this.enablesXDR,\n    timestampRequests: this.timestampRequests,\n    timestampParam: this.timestampParam,\n    policyPort: this.policyPort,\n    socket: this,\n    pfx: this.pfx,\n    key: this.key,\n    passphrase: this.passphrase,\n    cert: this.cert,\n    ca: this.ca,\n    ciphers: this.ciphers,\n    rejectUnauthorized: this.rejectUnauthorized,\n    perMessageDeflate: this.perMessageDeflate,\n    extraHeaders: this.extraHeaders,\n    forceNode: this.forceNode,\n    localAddress: this.localAddress\n  });\n\n  return transport;\n};\n\nfunction clone (obj) {\n  var o = {};\n  for (var i in obj) {\n    if (obj.hasOwnProperty(i)) {\n      o[i] = obj[i];\n    }\n  }\n  return o;\n}\n\n/**\n * Initializes transport to use and starts probe.\n *\n * @api private\n */\nSocket.prototype.open = function () {\n  var transport;\n  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {\n    transport = 'websocket';\n  } else if (0 === this.transports.length) {\n    // Emit error on next tick so it can be listened to\n    var self = this;\n    setTimeout(function () {\n      self.emit('error', 'No transports available');\n    }, 0);\n    return;\n  } else {\n    transport = this.transports[0];\n  }\n  this.readyState = 'opening';\n\n  // Retry with the next transport if the transport is disabled (jsonp: false)\n  try {\n    transport = this.createTransport(transport);\n  } catch (e) {\n    this.transports.shift();\n    this.open();\n    return;\n  }\n\n  transport.open();\n  this.setTransport(transport);\n};\n\n/**\n * Sets the current transport. Disables the existing one (if any).\n *\n * @api private\n */\n\nSocket.prototype.setTransport = function (transport) {\n  debug('setting transport %s', transport.name);\n  var self = this;\n\n  if (this.transport) {\n    debug('clearing existing transport %s', this.transport.name);\n    this.transport.removeAllListeners();\n  }\n\n  // set up transport\n  this.transport = transport;\n\n  // set up transport listeners\n  transport\n  .on('drain', function () {\n    self.onDrain();\n  })\n  .on('packet', function (packet) {\n    self.onPacket(packet);\n  })\n  .on('error', function (e) {\n    self.onError(e);\n  })\n  .on('close', function () {\n    self.onClose('transport close');\n  });\n};\n\n/**\n * Probes a transport.\n *\n * @param {String} transport name\n * @api private\n */\n\nSocket.prototype.probe = function (name) {\n  debug('probing transport \"%s\"', name);\n  var transport = this.createTransport(name, { probe: 1 });\n  var failed = false;\n  var self = this;\n\n  Socket.priorWebsocketSuccess = false;\n\n  function onTransportOpen () {\n    if (self.onlyBinaryUpgrades) {\n      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;\n      failed = failed || upgradeLosesBinary;\n    }\n    if (failed) return;\n\n    debug('probe transport \"%s\" opened', name);\n    transport.send([{ type: 'ping', data: 'probe' }]);\n    transport.once('packet', function (msg) {\n      if (failed) return;\n      if ('pong' === msg.type && 'probe' === msg.data) {\n        debug('probe transport \"%s\" pong', name);\n        self.upgrading = true;\n        self.emit('upgrading', transport);\n        if (!transport) return;\n        Socket.priorWebsocketSuccess = 'websocket' === transport.name;\n\n        debug('pausing current transport \"%s\"', self.transport.name);\n        self.transport.pause(function () {\n          if (failed) return;\n          if ('closed' === self.readyState) return;\n          debug('changing transport and sending upgrade packet');\n\n          cleanup();\n\n          self.setTransport(transport);\n          transport.send([{ type: 'upgrade' }]);\n          self.emit('upgrade', transport);\n          transport = null;\n          self.upgrading = false;\n          self.flush();\n        });\n      } else {\n        debug('probe transport \"%s\" failed', name);\n        var err = new Error('probe error');\n        err.transport = transport.name;\n        self.emit('upgradeError', err);\n      }\n    });\n  }\n\n  function freezeTransport () {\n    if (failed) return;\n\n    // Any callback called by transport should be ignored since now\n    failed = true;\n\n    cleanup();\n\n    transport.close();\n    transport = null;\n  }\n\n  // Handle any error that happens while probing\n  function onerror (err) {\n    var error = new Error('probe error: ' + err);\n    error.transport = transport.name;\n\n    freezeTransport();\n\n    debug('probe transport \"%s\" failed because of error: %s', name, err);\n\n    self.emit('upgradeError', error);\n  }\n\n  function onTransportClose () {\n    onerror('transport closed');\n  }\n\n  // When the socket is closed while we're probing\n  function onclose () {\n    onerror('socket closed');\n  }\n\n  // When the socket is upgraded while we're probing\n  function onupgrade (to) {\n    if (transport && to.name !== transport.name) {\n      debug('\"%s\" works - aborting \"%s\"', to.name, transport.name);\n      freezeTransport();\n    }\n  }\n\n  // Remove all listeners on the transport and on self\n  function cleanup () {\n    transport.removeListener('open', onTransportOpen);\n    transport.removeListener('error', onerror);\n    transport.removeListener('close', onTransportClose);\n    self.removeListener('close', onclose);\n    self.removeListener('upgrading', onupgrade);\n  }\n\n  transport.once('open', onTransportOpen);\n  transport.once('error', onerror);\n  transport.once('close', onTransportClose);\n\n  this.once('close', onclose);\n  this.once('upgrading', onupgrade);\n\n  transport.open();\n};\n\n/**\n * Called when connection is deemed open.\n *\n * @api public\n */\n\nSocket.prototype.onOpen = function () {\n  debug('socket open');\n  this.readyState = 'open';\n  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;\n  this.emit('open');\n  this.flush();\n\n  // we check for `readyState` in case an `open`\n  // listener already closed the socket\n  if ('open' === this.readyState && this.upgrade && this.transport.pause) {\n    debug('starting upgrade probes');\n    for (var i = 0, l = this.upgrades.length; i < l; i++) {\n      this.probe(this.upgrades[i]);\n    }\n  }\n};\n\n/**\n * Handles a packet.\n *\n * @api private\n */\n\nSocket.prototype.onPacket = function (packet) {\n  if ('opening' === this.readyState || 'open' === this.readyState ||\n      'closing' === this.readyState) {\n    debug('socket receive: type \"%s\", data \"%s\"', packet.type, packet.data);\n\n    this.emit('packet', packet);\n\n    // Socket is live - any packet counts\n    this.emit('heartbeat');\n\n    switch (packet.type) {\n      case 'open':\n        this.onHandshake(parsejson(packet.data));\n        break;\n\n      case 'pong':\n        this.setPing();\n        this.emit('pong');\n        break;\n\n      case 'error':\n        var err = new Error('server error');\n        err.code = packet.data;\n        this.onError(err);\n        break;\n\n      case 'message':\n        this.emit('data', packet.data);\n        this.emit('message', packet.data);\n        break;\n    }\n  } else {\n    debug('packet received with socket readyState \"%s\"', this.readyState);\n  }\n};\n\n/**\n * Called upon handshake completion.\n *\n * @param {Object} handshake obj\n * @api private\n */\n\nSocket.prototype.onHandshake = function (data) {\n  this.emit('handshake', data);\n  this.id = data.sid;\n  this.transport.query.sid = data.sid;\n  this.upgrades = this.filterUpgrades(data.upgrades);\n  this.pingInterval = data.pingInterval;\n  this.pingTimeout = data.pingTimeout;\n  this.onOpen();\n  // In case open handler closes socket\n  if ('closed' === this.readyState) return;\n  this.setPing();\n\n  // Prolong liveness of socket on heartbeat\n  this.removeListener('heartbeat', this.onHeartbeat);\n  this.on('heartbeat', this.onHeartbeat);\n};\n\n/**\n * Resets ping timeout.\n *\n * @api private\n */\n\nSocket.prototype.onHeartbeat = function (timeout) {\n  clearTimeout(this.pingTimeoutTimer);\n  var self = this;\n  self.pingTimeoutTimer = setTimeout(function () {\n    if ('closed' === self.readyState) return;\n    self.onClose('ping timeout');\n  }, timeout || (self.pingInterval + self.pingTimeout));\n};\n\n/**\n * Pings server every `this.pingInterval` and expects response\n * within `this.pingTimeout` or closes connection.\n *\n * @api private\n */\n\nSocket.prototype.setPing = function () {\n  var self = this;\n  clearTimeout(self.pingIntervalTimer);\n  self.pingIntervalTimer = setTimeout(function () {\n    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);\n    self.ping();\n    self.onHeartbeat(self.pingTimeout);\n  }, self.pingInterval);\n};\n\n/**\n* Sends a ping packet.\n*\n* @api private\n*/\n\nSocket.prototype.ping = function () {\n  var self = this;\n  this.sendPacket('ping', function () {\n    self.emit('ping');\n  });\n};\n\n/**\n * Called on `drain` event\n *\n * @api private\n */\n\nSocket.prototype.onDrain = function () {\n  this.writeBuffer.splice(0, this.prevBufferLen);\n\n  // setting prevBufferLen = 0 is very important\n  // for example, when upgrading, upgrade packet is sent over,\n  // and a nonzero prevBufferLen could cause problems on `drain`\n  this.prevBufferLen = 0;\n\n  if (0 === this.writeBuffer.length) {\n    this.emit('drain');\n  } else {\n    this.flush();\n  }\n};\n\n/**\n * Flush write buffers.\n *\n * @api private\n */\n\nSocket.prototype.flush = function () {\n  if ('closed' !== this.readyState && this.transport.writable &&\n    !this.upgrading && this.writeBuffer.length) {\n    debug('flushing %d packets in socket', this.writeBuffer.length);\n    this.transport.send(this.writeBuffer);\n    // keep track of current length of writeBuffer\n    // splice writeBuffer and callbackBuffer on `drain`\n    this.prevBufferLen = this.writeBuffer.length;\n    this.emit('flush');\n  }\n};\n\n/**\n * Sends a message.\n *\n * @param {String} message.\n * @param {Function} callback function.\n * @param {Object} options.\n * @return {Socket} for chaining.\n * @api public\n */\n\nSocket.prototype.write =\nSocket.prototype.send = function (msg, options, fn) {\n  this.sendPacket('message', msg, options, fn);\n  return this;\n};\n\n/**\n * Sends a packet.\n *\n * @param {String} packet type.\n * @param {String} data.\n * @param {Object} options.\n * @param {Function} callback function.\n * @api private\n */\n\nSocket.prototype.sendPacket = function (type, data, options, fn) {\n  if ('function' === typeof data) {\n    fn = data;\n    data = undefined;\n  }\n\n  if ('function' === typeof options) {\n    fn = options;\n    options = null;\n  }\n\n  if ('closing' === this.readyState || 'closed' === this.readyState) {\n    return;\n  }\n\n  options = options || {};\n  options.compress = false !== options.compress;\n\n  var packet = {\n    type: type,\n    data: data,\n    options: options\n  };\n  this.emit('packetCreate', packet);\n  this.writeBuffer.push(packet);\n  if (fn) this.once('flush', fn);\n  this.flush();\n};\n\n/**\n * Closes the connection.\n *\n * @api private\n */\n\nSocket.prototype.close = function () {\n  if ('opening' === this.readyState || 'open' === this.readyState) {\n    this.readyState = 'closing';\n\n    var self = this;\n\n    if (this.writeBuffer.length) {\n      this.once('drain', function () {\n        if (this.upgrading) {\n          waitForUpgrade();\n        } else {\n          close();\n        }\n      });\n    } else if (this.upgrading) {\n      waitForUpgrade();\n    } else {\n      close();\n    }\n  }\n\n  function close () {\n    self.onClose('forced close');\n    debug('socket closing - telling transport to close');\n    self.transport.close();\n  }\n\n  function cleanupAndClose () {\n    self.removeListener('upgrade', cleanupAndClose);\n    self.removeListener('upgradeError', cleanupAndClose);\n    close();\n  }\n\n  function waitForUpgrade () {\n    // wait for upgrade to finish since we can't send packets while pausing a transport\n    self.once('upgrade', cleanupAndClose);\n    self.once('upgradeError', cleanupAndClose);\n  }\n\n  return this;\n};\n\n/**\n * Called upon transport error\n *\n * @api private\n */\n\nSocket.prototype.onError = function (err) {\n  debug('socket error %j', err);\n  Socket.priorWebsocketSuccess = false;\n  this.emit('error', err);\n  this.onClose('transport error', err);\n};\n\n/**\n * Called upon transport close.\n *\n * @api private\n */\n\nSocket.prototype.onClose = function (reason, desc) {\n  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {\n    debug('socket close with reason: \"%s\"', reason);\n    var self = this;\n\n    // clear timers\n    clearTimeout(this.pingIntervalTimer);\n    clearTimeout(this.pingTimeoutTimer);\n\n    // stop event from firing again for transport\n    this.transport.removeAllListeners('close');\n\n    // ensure transport won't stay open\n    this.transport.close();\n\n    // ignore further transport communication\n    this.transport.removeAllListeners();\n\n    // set ready state\n    this.readyState = 'closed';\n\n    // clear session id\n    this.id = null;\n\n    // emit close event\n    this.emit('close', reason, desc);\n\n    // clean buffers after, so users can still\n    // grab the buffers on `close` event\n    self.writeBuffer = [];\n    self.prevBufferLen = 0;\n  }\n};\n\n/**\n * Filters upgrades, returning only those matching client transports.\n *\n * @param {Array} server upgrades\n * @api private\n *\n */\n\nSocket.prototype.filterUpgrades = function (upgrades) {\n  var filteredUpgrades = [];\n  for (var i = 0, j = upgrades.length; i < j; i++) {\n    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);\n  }\n  return filteredUpgrades;\n};\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"./transport\":13,\"./transports/index\":14,\"component-emitter\":8,\"debug\":20,\"engine.io-parser\":23,\"indexof\":29,\"parsejson\":31,\"parseqs\":32,\"parseuri\":33}],13:[function(require,module,exports){\n/**\n * Module dependencies.\n */\n\nvar parser = require('engine.io-parser');\nvar Emitter = require('component-emitter');\n\n/**\n * Module exports.\n */\n\nmodule.exports = Transport;\n\n/**\n * Transport abstract constructor.\n *\n * @param {Object} options.\n * @api private\n */\n\nfunction Transport (opts) {\n  this.path = opts.path;\n  this.hostname = opts.hostname;\n  this.port = opts.port;\n  this.secure = opts.secure;\n  this.query = opts.query;\n  this.timestampParam = opts.timestampParam;\n  this.timestampRequests = opts.timestampRequests;\n  this.readyState = '';\n  this.agent = opts.agent || false;\n  this.socket = opts.socket;\n  this.enablesXDR = opts.enablesXDR;\n\n  // SSL options for Node.js client\n  this.pfx = opts.pfx;\n  this.key = opts.key;\n  this.passphrase = opts.passphrase;\n  this.cert = opts.cert;\n  this.ca = opts.ca;\n  this.ciphers = opts.ciphers;\n  this.rejectUnauthorized = opts.rejectUnauthorized;\n  this.forceNode = opts.forceNode;\n\n  // other options for Node.js client\n  this.extraHeaders = opts.extraHeaders;\n  this.localAddress = opts.localAddress;\n}\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Transport.prototype);\n\n/**\n * Emits an error.\n *\n * @param {String} str\n * @return {Transport} for chaining\n * @api public\n */\n\nTransport.prototype.onError = function (msg, desc) {\n  var err = new Error(msg);\n  err.type = 'TransportError';\n  err.description = desc;\n  this.emit('error', err);\n  return this;\n};\n\n/**\n * Opens the transport.\n *\n * @api public\n */\n\nTransport.prototype.open = function () {\n  if ('closed' === this.readyState || '' === this.readyState) {\n    this.readyState = 'opening';\n    this.doOpen();\n  }\n\n  return this;\n};\n\n/**\n * Closes the transport.\n *\n * @api private\n */\n\nTransport.prototype.close = function () {\n  if ('opening' === this.readyState || 'open' === this.readyState) {\n    this.doClose();\n    this.onClose();\n  }\n\n  return this;\n};\n\n/**\n * Sends multiple packets.\n *\n * @param {Array} packets\n * @api private\n */\n\nTransport.prototype.send = function (packets) {\n  if ('open' === this.readyState) {\n    this.write(packets);\n  } else {\n    throw new Error('Transport not open');\n  }\n};\n\n/**\n * Called upon open\n *\n * @api private\n */\n\nTransport.prototype.onOpen = function () {\n  this.readyState = 'open';\n  this.writable = true;\n  this.emit('open');\n};\n\n/**\n * Called with data.\n *\n * @param {String} data\n * @api private\n */\n\nTransport.prototype.onData = function (data) {\n  var packet = parser.decodePacket(data, this.socket.binaryType);\n  this.onPacket(packet);\n};\n\n/**\n * Called with a decoded packet.\n */\n\nTransport.prototype.onPacket = function (packet) {\n  this.emit('packet', packet);\n};\n\n/**\n * Called upon close.\n *\n * @api private\n */\n\nTransport.prototype.onClose = function () {\n  this.readyState = 'closed';\n  this.emit('close');\n};\n\n},{\"component-emitter\":8,\"engine.io-parser\":23}],14:[function(require,module,exports){\n(function (global){\n/**\n * Module dependencies\n */\n\nvar XMLHttpRequest = require('xmlhttprequest-ssl');\nvar XHR = require('./polling-xhr');\nvar JSONP = require('./polling-jsonp');\nvar websocket = require('./websocket');\n\n/**\n * Export transports.\n */\n\nexports.polling = polling;\nexports.websocket = websocket;\n\n/**\n * Polling transport polymorphic constructor.\n * Decides on xhr vs jsonp based on feature detection.\n *\n * @api private\n */\n\nfunction polling (opts) {\n  var xhr;\n  var xd = false;\n  var xs = false;\n  var jsonp = false !== opts.jsonp;\n\n  if (global.location) {\n    var isSSL = 'https:' === location.protocol;\n    var port = location.port;\n\n    // some user agents have empty `location.port`\n    if (!port) {\n      port = isSSL ? 443 : 80;\n    }\n\n    xd = opts.hostname !== location.hostname || port !== opts.port;\n    xs = opts.secure !== isSSL;\n  }\n\n  opts.xdomain = xd;\n  opts.xscheme = xs;\n  xhr = new XMLHttpRequest(opts);\n\n  if ('open' in xhr && !opts.forceJSONP) {\n    return new XHR(opts);\n  } else {\n    if (!jsonp) throw new Error('JSONP disabled');\n    return new JSONP(opts);\n  }\n}\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"./polling-jsonp\":15,\"./polling-xhr\":16,\"./websocket\":18,\"xmlhttprequest-ssl\":19}],15:[function(require,module,exports){\n(function (global){\n\n/**\n * Module requirements.\n */\n\nvar Polling = require('./polling');\nvar inherit = require('component-inherit');\n\n/**\n * Module exports.\n */\n\nmodule.exports = JSONPPolling;\n\n/**\n * Cached regular expressions.\n */\n\nvar rNewline = /\\n/g;\nvar rEscapedNewline = /\\\\n/g;\n\n/**\n * Global JSONP callbacks.\n */\n\nvar callbacks;\n\n/**\n * Noop.\n */\n\nfunction empty () { }\n\n/**\n * JSONP Polling constructor.\n *\n * @param {Object} opts.\n * @api public\n */\n\nfunction JSONPPolling (opts) {\n  Polling.call(this, opts);\n\n  this.query = this.query || {};\n\n  // define global callbacks array if not present\n  // we do this here (lazily) to avoid unneeded global pollution\n  if (!callbacks) {\n    // we need to consider multiple engines in the same page\n    if (!global.___eio) global.___eio = [];\n    callbacks = global.___eio;\n  }\n\n  // callback identifier\n  this.index = callbacks.length;\n\n  // add callback to jsonp global\n  var self = this;\n  callbacks.push(function (msg) {\n    self.onData(msg);\n  });\n\n  // append to query string\n  this.query.j = this.index;\n\n  // prevent spurious errors from being emitted when the window is unloaded\n  if (global.document && global.addEventListener) {\n    global.addEventListener('beforeunload', function () {\n      if (self.script) self.script.onerror = empty;\n    }, false);\n  }\n}\n\n/**\n * Inherits from Polling.\n */\n\ninherit(JSONPPolling, Polling);\n\n/*\n * JSONP only supports binary as base64 encoded strings\n */\n\nJSONPPolling.prototype.supportsBinary = false;\n\n/**\n * Closes the socket.\n *\n * @api private\n */\n\nJSONPPolling.prototype.doClose = function () {\n  if (this.script) {\n    this.script.parentNode.removeChild(this.script);\n    this.script = null;\n  }\n\n  if (this.form) {\n    this.form.parentNode.removeChild(this.form);\n    this.form = null;\n    this.iframe = null;\n  }\n\n  Polling.prototype.doClose.call(this);\n};\n\n/**\n * Starts a poll cycle.\n *\n * @api private\n */\n\nJSONPPolling.prototype.doPoll = function () {\n  var self = this;\n  var script = document.createElement('script');\n\n  if (this.script) {\n    this.script.parentNode.removeChild(this.script);\n    this.script = null;\n  }\n\n  script.async = true;\n  script.src = this.uri();\n  script.onerror = function (e) {\n    self.onError('jsonp poll error', e);\n  };\n\n  var insertAt = document.getElementsByTagName('script')[0];\n  if (insertAt) {\n    insertAt.parentNode.insertBefore(script, insertAt);\n  } else {\n    (document.head || document.body).appendChild(script);\n  }\n  this.script = script;\n\n  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);\n\n  if (isUAgecko) {\n    setTimeout(function () {\n      var iframe = document.createElement('iframe');\n      document.body.appendChild(iframe);\n      document.body.removeChild(iframe);\n    }, 100);\n  }\n};\n\n/**\n * Writes with a hidden iframe.\n *\n * @param {String} data to send\n * @param {Function} called upon flush.\n * @api private\n */\n\nJSONPPolling.prototype.doWrite = function (data, fn) {\n  var self = this;\n\n  if (!this.form) {\n    var form = document.createElement('form');\n    var area = document.createElement('textarea');\n    var id = this.iframeId = 'eio_iframe_' + this.index;\n    var iframe;\n\n    form.className = 'socketio';\n    form.style.position = 'absolute';\n    form.style.top = '-1000px';\n    form.style.left = '-1000px';\n    form.target = id;\n    form.method = 'POST';\n    form.setAttribute('accept-charset', 'utf-8');\n    area.name = 'd';\n    form.appendChild(area);\n    document.body.appendChild(form);\n\n    this.form = form;\n    this.area = area;\n  }\n\n  this.form.action = this.uri();\n\n  function complete () {\n    initIframe();\n    fn();\n  }\n\n  function initIframe () {\n    if (self.iframe) {\n      try {\n        self.form.removeChild(self.iframe);\n      } catch (e) {\n        self.onError('jsonp polling iframe removal error', e);\n      }\n    }\n\n    try {\n      // ie6 dynamic iframes with target=\"\" support (thanks Chris Lambacher)\n      var html = '<iframe src=\"javascript:0\" name=\"' + self.iframeId + '\">';\n      iframe = document.createElement(html);\n    } catch (e) {\n      iframe = document.createElement('iframe');\n      iframe.name = self.iframeId;\n      iframe.src = 'javascript:0';\n    }\n\n    iframe.id = self.iframeId;\n\n    self.form.appendChild(iframe);\n    self.iframe = iframe;\n  }\n\n  initIframe();\n\n  // escape \\n to prevent it from being converted into \\r\\n by some UAs\n  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side\n  data = data.replace(rEscapedNewline, '\\\\\\n');\n  this.area.value = data.replace(rNewline, '\\\\n');\n\n  try {\n    this.form.submit();\n  } catch (e) {}\n\n  if (this.iframe.attachEvent) {\n    this.iframe.onreadystatechange = function () {\n      if (self.iframe.readyState === 'complete') {\n        complete();\n      }\n    };\n  } else {\n    this.iframe.onload = complete;\n  }\n};\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"./polling\":17,\"component-inherit\":9}],16:[function(require,module,exports){\n(function (global){\n/**\n * Module requirements.\n */\n\nvar XMLHttpRequest = require('xmlhttprequest-ssl');\nvar Polling = require('./polling');\nvar Emitter = require('component-emitter');\nvar inherit = require('component-inherit');\nvar debug = require('debug')('engine.io-client:polling-xhr');\n\n/**\n * Module exports.\n */\n\nmodule.exports = XHR;\nmodule.exports.Request = Request;\n\n/**\n * Empty function\n */\n\nfunction empty () {}\n\n/**\n * XHR Polling constructor.\n *\n * @param {Object} opts\n * @api public\n */\n\nfunction XHR (opts) {\n  Polling.call(this, opts);\n  this.requestTimeout = opts.requestTimeout;\n\n  if (global.location) {\n    var isSSL = 'https:' === location.protocol;\n    var port = location.port;\n\n    // some user agents have empty `location.port`\n    if (!port) {\n      port = isSSL ? 443 : 80;\n    }\n\n    this.xd = opts.hostname !== global.location.hostname ||\n      port !== opts.port;\n    this.xs = opts.secure !== isSSL;\n  } else {\n    this.extraHeaders = opts.extraHeaders;\n  }\n}\n\n/**\n * Inherits from Polling.\n */\n\ninherit(XHR, Polling);\n\n/**\n * XHR supports binary\n */\n\nXHR.prototype.supportsBinary = true;\n\n/**\n * Creates a request.\n *\n * @param {String} method\n * @api private\n */\n\nXHR.prototype.request = function (opts) {\n  opts = opts || {};\n  opts.uri = this.uri();\n  opts.xd = this.xd;\n  opts.xs = this.xs;\n  opts.agent = this.agent || false;\n  opts.supportsBinary = this.supportsBinary;\n  opts.enablesXDR = this.enablesXDR;\n\n  // SSL options for Node.js client\n  opts.pfx = this.pfx;\n  opts.key = this.key;\n  opts.passphrase = this.passphrase;\n  opts.cert = this.cert;\n  opts.ca = this.ca;\n  opts.ciphers = this.ciphers;\n  opts.rejectUnauthorized = this.rejectUnauthorized;\n  opts.requestTimeout = this.requestTimeout;\n\n  // other options for Node.js client\n  opts.extraHeaders = this.extraHeaders;\n\n  return new Request(opts);\n};\n\n/**\n * Sends data.\n *\n * @param {String} data to send.\n * @param {Function} called upon flush.\n * @api private\n */\n\nXHR.prototype.doWrite = function (data, fn) {\n  var isBinary = typeof data !== 'string' && data !== undefined;\n  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });\n  var self = this;\n  req.on('success', fn);\n  req.on('error', function (err) {\n    self.onError('xhr post error', err);\n  });\n  this.sendXhr = req;\n};\n\n/**\n * Starts a poll cycle.\n *\n * @api private\n */\n\nXHR.prototype.doPoll = function () {\n  debug('xhr poll');\n  var req = this.request();\n  var self = this;\n  req.on('data', function (data) {\n    self.onData(data);\n  });\n  req.on('error', function (err) {\n    self.onError('xhr poll error', err);\n  });\n  this.pollXhr = req;\n};\n\n/**\n * Request constructor\n *\n * @param {Object} options\n * @api public\n */\n\nfunction Request (opts) {\n  this.method = opts.method || 'GET';\n  this.uri = opts.uri;\n  this.xd = !!opts.xd;\n  this.xs = !!opts.xs;\n  this.async = false !== opts.async;\n  this.data = undefined !== opts.data ? opts.data : null;\n  this.agent = opts.agent;\n  this.isBinary = opts.isBinary;\n  this.supportsBinary = opts.supportsBinary;\n  this.enablesXDR = opts.enablesXDR;\n  this.requestTimeout = opts.requestTimeout;\n\n  // SSL options for Node.js client\n  this.pfx = opts.pfx;\n  this.key = opts.key;\n  this.passphrase = opts.passphrase;\n  this.cert = opts.cert;\n  this.ca = opts.ca;\n  this.ciphers = opts.ciphers;\n  this.rejectUnauthorized = opts.rejectUnauthorized;\n\n  // other options for Node.js client\n  this.extraHeaders = opts.extraHeaders;\n\n  this.create();\n}\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Request.prototype);\n\n/**\n * Creates the XHR object and sends the request.\n *\n * @api private\n */\n\nRequest.prototype.create = function () {\n  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };\n\n  // SSL options for Node.js client\n  opts.pfx = this.pfx;\n  opts.key = this.key;\n  opts.passphrase = this.passphrase;\n  opts.cert = this.cert;\n  opts.ca = this.ca;\n  opts.ciphers = this.ciphers;\n  opts.rejectUnauthorized = this.rejectUnauthorized;\n\n  var xhr = this.xhr = new XMLHttpRequest(opts);\n  var self = this;\n\n  try {\n    debug('xhr open %s: %s', this.method, this.uri);\n    xhr.open(this.method, this.uri, this.async);\n    try {\n      if (this.extraHeaders) {\n        xhr.setDisableHeaderCheck(true);\n        for (var i in this.extraHeaders) {\n          if (this.extraHeaders.hasOwnProperty(i)) {\n            xhr.setRequestHeader(i, this.extraHeaders[i]);\n          }\n        }\n      }\n    } catch (e) {}\n    if (this.supportsBinary) {\n      // This has to be done after open because Firefox is stupid\n      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension\n      xhr.responseType = 'arraybuffer';\n    }\n\n    if ('POST' === this.method) {\n      try {\n        if (this.isBinary) {\n          xhr.setRequestHeader('Content-type', 'application/octet-stream');\n        } else {\n          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');\n        }\n      } catch (e) {}\n    }\n\n    try {\n      xhr.setRequestHeader('Accept', '*/*');\n    } catch (e) {}\n\n    // ie6 check\n    if ('withCredentials' in xhr) {\n      xhr.withCredentials = true;\n    }\n\n    if (this.requestTimeout) {\n      xhr.timeout = this.requestTimeout;\n    }\n\n    if (this.hasXDR()) {\n      xhr.onload = function () {\n        self.onLoad();\n      };\n      xhr.onerror = function () {\n        self.onError(xhr.responseText);\n      };\n    } else {\n      xhr.onreadystatechange = function () {\n        if (4 !== xhr.readyState) return;\n        if (200 === xhr.status || 1223 === xhr.status) {\n          self.onLoad();\n        } else {\n          // make sure the `error` event handler that's user-set\n          // does not throw in the same tick and gets caught here\n          setTimeout(function () {\n            self.onError(xhr.status);\n          }, 0);\n        }\n      };\n    }\n\n    debug('xhr data %s', this.data);\n    xhr.send(this.data);\n  } catch (e) {\n    // Need to defer since .create() is called directly fhrom the constructor\n    // and thus the 'error' event can only be only bound *after* this exception\n    // occurs.  Therefore, also, we cannot throw here at all.\n    setTimeout(function () {\n      self.onError(e);\n    }, 0);\n    return;\n  }\n\n  if (global.document) {\n    this.index = Request.requestsCount++;\n    Request.requests[this.index] = this;\n  }\n};\n\n/**\n * Called upon successful response.\n *\n * @api private\n */\n\nRequest.prototype.onSuccess = function () {\n  this.emit('success');\n  this.cleanup();\n};\n\n/**\n * Called if we have data.\n *\n * @api private\n */\n\nRequest.prototype.onData = function (data) {\n  this.emit('data', data);\n  this.onSuccess();\n};\n\n/**\n * Called upon error.\n *\n * @api private\n */\n\nRequest.prototype.onError = function (err) {\n  this.emit('error', err);\n  this.cleanup(true);\n};\n\n/**\n * Cleans up house.\n *\n * @api private\n */\n\nRequest.prototype.cleanup = function (fromError) {\n  if ('undefined' === typeof this.xhr || null === this.xhr) {\n    return;\n  }\n  // xmlhttprequest\n  if (this.hasXDR()) {\n    this.xhr.onload = this.xhr.onerror = empty;\n  } else {\n    this.xhr.onreadystatechange = empty;\n  }\n\n  if (fromError) {\n    try {\n      this.xhr.abort();\n    } catch (e) {}\n  }\n\n  if (global.document) {\n    delete Request.requests[this.index];\n  }\n\n  this.xhr = null;\n};\n\n/**\n * Called upon load.\n *\n * @api private\n */\n\nRequest.prototype.onLoad = function () {\n  var data;\n  try {\n    var contentType;\n    try {\n      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];\n    } catch (e) {}\n    if (contentType === 'application/octet-stream') {\n      data = this.xhr.response || this.xhr.responseText;\n    } else {\n      if (!this.supportsBinary) {\n        data = this.xhr.responseText;\n      } else {\n        try {\n          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));\n        } catch (e) {\n          var ui8Arr = new Uint8Array(this.xhr.response);\n          var dataArray = [];\n          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {\n            dataArray.push(ui8Arr[idx]);\n          }\n\n          data = String.fromCharCode.apply(null, dataArray);\n        }\n      }\n    }\n  } catch (e) {\n    this.onError(e);\n  }\n  if (null != data) {\n    this.onData(data);\n  }\n};\n\n/**\n * Check if it has XDomainRequest.\n *\n * @api private\n */\n\nRequest.prototype.hasXDR = function () {\n  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;\n};\n\n/**\n * Aborts the request.\n *\n * @api public\n */\n\nRequest.prototype.abort = function () {\n  this.cleanup();\n};\n\n/**\n * Aborts pending requests when unloading the window. This is needed to prevent\n * memory leaks (e.g. when using IE) and to ensure that no spurious error is\n * emitted.\n */\n\nRequest.requestsCount = 0;\nRequest.requests = {};\n\nif (global.document) {\n  if (global.attachEvent) {\n    global.attachEvent('onunload', unloadHandler);\n  } else if (global.addEventListener) {\n    global.addEventListener('beforeunload', unloadHandler, false);\n  }\n}\n\nfunction unloadHandler () {\n  for (var i in Request.requests) {\n    if (Request.requests.hasOwnProperty(i)) {\n      Request.requests[i].abort();\n    }\n  }\n}\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"./polling\":17,\"component-emitter\":8,\"component-inherit\":9,\"debug\":20,\"xmlhttprequest-ssl\":19}],17:[function(require,module,exports){\n/**\n * Module dependencies.\n */\n\nvar Transport = require('../transport');\nvar parseqs = require('parseqs');\nvar parser = require('engine.io-parser');\nvar inherit = require('component-inherit');\nvar yeast = require('yeast');\nvar debug = require('debug')('engine.io-client:polling');\n\n/**\n * Module exports.\n */\n\nmodule.exports = Polling;\n\n/**\n * Is XHR2 supported?\n */\n\nvar hasXHR2 = (function () {\n  var XMLHttpRequest = require('xmlhttprequest-ssl');\n  var xhr = new XMLHttpRequest({ xdomain: false });\n  return null != xhr.responseType;\n})();\n\n/**\n * Polling interface.\n *\n * @param {Object} opts\n * @api private\n */\n\nfunction Polling (opts) {\n  var forceBase64 = (opts && opts.forceBase64);\n  if (!hasXHR2 || forceBase64) {\n    this.supportsBinary = false;\n  }\n  Transport.call(this, opts);\n}\n\n/**\n * Inherits from Transport.\n */\n\ninherit(Polling, Transport);\n\n/**\n * Transport name.\n */\n\nPolling.prototype.name = 'polling';\n\n/**\n * Opens the socket (triggers polling). We write a PING message to determine\n * when the transport is open.\n *\n * @api private\n */\n\nPolling.prototype.doOpen = function () {\n  this.poll();\n};\n\n/**\n * Pauses polling.\n *\n * @param {Function} callback upon buffers are flushed and transport is paused\n * @api private\n */\n\nPolling.prototype.pause = function (onPause) {\n  var self = this;\n\n  this.readyState = 'pausing';\n\n  function pause () {\n    debug('paused');\n    self.readyState = 'paused';\n    onPause();\n  }\n\n  if (this.polling || !this.writable) {\n    var total = 0;\n\n    if (this.polling) {\n      debug('we are currently polling - waiting to pause');\n      total++;\n      this.once('pollComplete', function () {\n        debug('pre-pause polling complete');\n        --total || pause();\n      });\n    }\n\n    if (!this.writable) {\n      debug('we are currently writing - waiting to pause');\n      total++;\n      this.once('drain', function () {\n        debug('pre-pause writing complete');\n        --total || pause();\n      });\n    }\n  } else {\n    pause();\n  }\n};\n\n/**\n * Starts polling cycle.\n *\n * @api public\n */\n\nPolling.prototype.poll = function () {\n  debug('polling');\n  this.polling = true;\n  this.doPoll();\n  this.emit('poll');\n};\n\n/**\n * Overloads onData to detect payloads.\n *\n * @api private\n */\n\nPolling.prototype.onData = function (data) {\n  var self = this;\n  debug('polling got data %s', data);\n  var callback = function (packet, index, total) {\n    // if its the first message we consider the transport open\n    if ('opening' === self.readyState) {\n      self.onOpen();\n    }\n\n    // if its a close packet, we close the ongoing requests\n    if ('close' === packet.type) {\n      self.onClose();\n      return false;\n    }\n\n    // otherwise bypass onData and handle the message\n    self.onPacket(packet);\n  };\n\n  // decode payload\n  parser.decodePayload(data, this.socket.binaryType, callback);\n\n  // if an event did not trigger closing\n  if ('closed' !== this.readyState) {\n    // if we got data we're not polling\n    this.polling = false;\n    this.emit('pollComplete');\n\n    if ('open' === this.readyState) {\n      this.poll();\n    } else {\n      debug('ignoring poll - transport state \"%s\"', this.readyState);\n    }\n  }\n};\n\n/**\n * For polling, send a close packet.\n *\n * @api private\n */\n\nPolling.prototype.doClose = function () {\n  var self = this;\n\n  function close () {\n    debug('writing close packet');\n    self.write([{ type: 'close' }]);\n  }\n\n  if ('open' === this.readyState) {\n    debug('transport open - closing');\n    close();\n  } else {\n    // in case we're trying to close while\n    // handshaking is in progress (GH-164)\n    debug('transport not open - deferring close');\n    this.once('open', close);\n  }\n};\n\n/**\n * Writes a packets payload.\n *\n * @param {Array} data packets\n * @param {Function} drain callback\n * @api private\n */\n\nPolling.prototype.write = function (packets) {\n  var self = this;\n  this.writable = false;\n  var callbackfn = function () {\n    self.writable = true;\n    self.emit('drain');\n  };\n\n  parser.encodePayload(packets, this.supportsBinary, function (data) {\n    self.doWrite(data, callbackfn);\n  });\n};\n\n/**\n * Generates uri for connection.\n *\n * @api private\n */\n\nPolling.prototype.uri = function () {\n  var query = this.query || {};\n  var schema = this.secure ? 'https' : 'http';\n  var port = '';\n\n  // cache busting is forced\n  if (false !== this.timestampRequests) {\n    query[this.timestampParam] = yeast();\n  }\n\n  if (!this.supportsBinary && !query.sid) {\n    query.b64 = 1;\n  }\n\n  query = parseqs.encode(query);\n\n  // avoid port if default for schema\n  if (this.port && (('https' === schema && Number(this.port) !== 443) ||\n     ('http' === schema && Number(this.port) !== 80))) {\n    port = ':' + this.port;\n  }\n\n  // prepend ? to query\n  if (query.length) {\n    query = '?' + query;\n  }\n\n  var ipv6 = this.hostname.indexOf(':') !== -1;\n  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;\n};\n\n},{\"../transport\":13,\"component-inherit\":9,\"debug\":20,\"engine.io-parser\":23,\"parseqs\":32,\"xmlhttprequest-ssl\":19,\"yeast\":54}],18:[function(require,module,exports){\n(function (global){\n/**\n * Module dependencies.\n */\n\nvar Transport = require('../transport');\nvar parser = require('engine.io-parser');\nvar parseqs = require('parseqs');\nvar inherit = require('component-inherit');\nvar yeast = require('yeast');\nvar debug = require('debug')('engine.io-client:websocket');\nvar BrowserWebSocket = global.WebSocket || global.MozWebSocket;\nvar NodeWebSocket;\nif (typeof window === 'undefined') {\n  try {\n    NodeWebSocket = require('ws');\n  } catch (e) { }\n}\n\n/**\n * Get either the `WebSocket` or `MozWebSocket` globals\n * in the browser or try to resolve WebSocket-compatible\n * interface exposed by `ws` for Node-like environment.\n */\n\nvar WebSocket = BrowserWebSocket;\nif (!WebSocket && typeof window === 'undefined') {\n  WebSocket = NodeWebSocket;\n}\n\n/**\n * Module exports.\n */\n\nmodule.exports = WS;\n\n/**\n * WebSocket transport constructor.\n *\n * @api {Object} connection options\n * @api public\n */\n\nfunction WS (opts) {\n  var forceBase64 = (opts && opts.forceBase64);\n  if (forceBase64) {\n    this.supportsBinary = false;\n  }\n  this.perMessageDeflate = opts.perMessageDeflate;\n  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;\n  if (!this.usingBrowserWebSocket) {\n    WebSocket = NodeWebSocket;\n  }\n  Transport.call(this, opts);\n}\n\n/**\n * Inherits from Transport.\n */\n\ninherit(WS, Transport);\n\n/**\n * Transport name.\n *\n * @api public\n */\n\nWS.prototype.name = 'websocket';\n\n/*\n * WebSockets support binary\n */\n\nWS.prototype.supportsBinary = true;\n\n/**\n * Opens socket.\n *\n * @api private\n */\n\nWS.prototype.doOpen = function () {\n  if (!this.check()) {\n    // let probe timeout\n    return;\n  }\n\n  var uri = this.uri();\n  var protocols = void (0);\n  var opts = {\n    agent: this.agent,\n    perMessageDeflate: this.perMessageDeflate\n  };\n\n  // SSL options for Node.js client\n  opts.pfx = this.pfx;\n  opts.key = this.key;\n  opts.passphrase = this.passphrase;\n  opts.cert = this.cert;\n  opts.ca = this.ca;\n  opts.ciphers = this.ciphers;\n  opts.rejectUnauthorized = this.rejectUnauthorized;\n  if (this.extraHeaders) {\n    opts.headers = this.extraHeaders;\n  }\n  if (this.localAddress) {\n    opts.localAddress = this.localAddress;\n  }\n\n  try {\n    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);\n  } catch (err) {\n    return this.emit('error', err);\n  }\n\n  if (this.ws.binaryType === undefined) {\n    this.supportsBinary = false;\n  }\n\n  if (this.ws.supports && this.ws.supports.binary) {\n    this.supportsBinary = true;\n    this.ws.binaryType = 'nodebuffer';\n  } else {\n    this.ws.binaryType = 'arraybuffer';\n  }\n\n  this.addEventListeners();\n};\n\n/**\n * Adds event listeners to the socket\n *\n * @api private\n */\n\nWS.prototype.addEventListeners = function () {\n  var self = this;\n\n  this.ws.onopen = function () {\n    self.onOpen();\n  };\n  this.ws.onclose = function () {\n    self.onClose();\n  };\n  this.ws.onmessage = function (ev) {\n    self.onData(ev.data);\n  };\n  this.ws.onerror = function (e) {\n    self.onError('websocket error', e);\n  };\n};\n\n/**\n * Writes data to socket.\n *\n * @param {Array} array of packets.\n * @api private\n */\n\nWS.prototype.write = function (packets) {\n  var self = this;\n  this.writable = false;\n\n  // encodePacket efficient as it uses WS framing\n  // no need for encodePayload\n  var total = packets.length;\n  for (var i = 0, l = total; i < l; i++) {\n    (function (packet) {\n      parser.encodePacket(packet, self.supportsBinary, function (data) {\n        if (!self.usingBrowserWebSocket) {\n          // always create a new object (GH-437)\n          var opts = {};\n          if (packet.options) {\n            opts.compress = packet.options.compress;\n          }\n\n          if (self.perMessageDeflate) {\n            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;\n            if (len < self.perMessageDeflate.threshold) {\n              opts.compress = false;\n            }\n          }\n        }\n\n        // Sometimes the websocket has already been closed but the browser didn't\n        // have a chance of informing us about it yet, in that case send will\n        // throw an error\n        try {\n          if (self.usingBrowserWebSocket) {\n            // TypeError is thrown when passing the second argument on Safari\n            self.ws.send(data);\n          } else {\n            self.ws.send(data, opts);\n          }\n        } catch (e) {\n          debug('websocket closed before onclose event');\n        }\n\n        --total || done();\n      });\n    })(packets[i]);\n  }\n\n  function done () {\n    self.emit('flush');\n\n    // fake drain\n    // defer to next tick to allow Socket to clear writeBuffer\n    setTimeout(function () {\n      self.writable = true;\n      self.emit('drain');\n    }, 0);\n  }\n};\n\n/**\n * Called upon close\n *\n * @api private\n */\n\nWS.prototype.onClose = function () {\n  Transport.prototype.onClose.call(this);\n};\n\n/**\n * Closes socket.\n *\n * @api private\n */\n\nWS.prototype.doClose = function () {\n  if (typeof this.ws !== 'undefined') {\n    this.ws.close();\n  }\n};\n\n/**\n * Generates uri for connection.\n *\n * @api private\n */\n\nWS.prototype.uri = function () {\n  var query = this.query || {};\n  var schema = this.secure ? 'wss' : 'ws';\n  var port = '';\n\n  // avoid port if default for schema\n  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||\n    ('ws' === schema && Number(this.port) !== 80))) {\n    port = ':' + this.port;\n  }\n\n  // append timestamp to URI\n  if (this.timestampRequests) {\n    query[this.timestampParam] = yeast();\n  }\n\n  // communicate binary support capabilities\n  if (!this.supportsBinary) {\n    query.b64 = 1;\n  }\n\n  query = parseqs.encode(query);\n\n  // prepend ? to query\n  if (query.length) {\n    query = '?' + query;\n  }\n\n  var ipv6 = this.hostname.indexOf(':') !== -1;\n  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;\n};\n\n/**\n * Feature detection for WebSocket.\n *\n * @return {Boolean} whether this transport is available.\n * @api public\n */\n\nWS.prototype.check = function () {\n  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);\n};\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"../transport\":13,\"component-inherit\":9,\"debug\":20,\"engine.io-parser\":23,\"parseqs\":32,\"ws\":6,\"yeast\":54}],19:[function(require,module,exports){\n(function (global){\n// browser shim for xmlhttprequest module\n\nvar hasCORS = require('has-cors');\n\nmodule.exports = function (opts) {\n  var xdomain = opts.xdomain;\n\n  // scheme must be same when usign XDomainRequest\n  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx\n  var xscheme = opts.xscheme;\n\n  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.\n  // https://github.com/Automattic/engine.io-client/pull/217\n  var enablesXDR = opts.enablesXDR;\n\n  // XMLHttpRequest can be disabled on IE\n  try {\n    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {\n      return new XMLHttpRequest();\n    }\n  } catch (e) { }\n\n  // Use XDomainRequest for IE8 if enablesXDR is true\n  // because loading bar keeps flashing when using jsonp-polling\n  // https://github.com/yujiosaka/socke.io-ie8-loading-example\n  try {\n    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {\n      return new XDomainRequest();\n    }\n  } catch (e) { }\n\n  if (!xdomain) {\n    try {\n      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');\n    } catch (e) { }\n  }\n};\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"has-cors\":28}],20:[function(require,module,exports){\n(function (process){\n\n/**\n * This is the web browser implementation of `debug()`.\n *\n * Expose `debug()` as the module.\n */\n\nexports = module.exports = require('./debug');\nexports.log = log;\nexports.formatArgs = formatArgs;\nexports.save = save;\nexports.load = load;\nexports.useColors = useColors;\nexports.storage = 'undefined' != typeof chrome\n               && 'undefined' != typeof chrome.storage\n                  ? chrome.storage.local\n                  : localstorage();\n\n/**\n * Colors.\n */\n\nexports.colors = [\n  'lightseagreen',\n  'forestgreen',\n  'goldenrod',\n  'dodgerblue',\n  'darkorchid',\n  'crimson'\n];\n\n/**\n * Currently only WebKit-based Web Inspectors, Firefox >= v31,\n * and the Firebug extension (any Firefox version) are known\n * to support \"%c\" CSS customizations.\n *\n * TODO: add a `localStorage` variable to explicitly enable/disable colors\n */\n\nfunction useColors() {\n  // is webkit? http://stackoverflow.com/a/16459606/376773\n  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632\n  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||\n    // is firebug? http://stackoverflow.com/a/398120/376773\n    (window.console && (console.firebug || (console.exception && console.table))) ||\n    // is firefox >= v31?\n    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages\n    (navigator.userAgent.toLowerCase().match(/firefox\\/(\\d+)/) && parseInt(RegExp.$1, 10) >= 31);\n}\n\n/**\n * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.\n */\n\nexports.formatters.j = function(v) {\n  try {\n    return JSON.stringify(v);\n  } catch (err) {\n    return '[UnexpectedJSONParseError]: ' + err.message;\n  }\n};\n\n\n/**\n * Colorize log arguments if enabled.\n *\n * @api public\n */\n\nfunction formatArgs() {\n  var args = arguments;\n  var useColors = this.useColors;\n\n  args[0] = (useColors ? '%c' : '')\n    + this.namespace\n    + (useColors ? ' %c' : ' ')\n    + args[0]\n    + (useColors ? '%c ' : ' ')\n    + '+' + exports.humanize(this.diff);\n\n  if (!useColors) return args;\n\n  var c = 'color: ' + this.color;\n  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));\n\n  // the final \"%c\" is somewhat tricky, because there could be other\n  // arguments passed either before or after the %c, so we need to\n  // figure out the correct index to insert the CSS into\n  var index = 0;\n  var lastC = 0;\n  args[0].replace(/%[a-z%]/g, function(match) {\n    if ('%%' === match) return;\n    index++;\n    if ('%c' === match) {\n      // we only are interested in the *last* %c\n      // (the user may have provided their own)\n      lastC = index;\n    }\n  });\n\n  args.splice(lastC, 0, c);\n  return args;\n}\n\n/**\n * Invokes `console.log()` when available.\n * No-op when `console.log` is not a \"function\".\n *\n * @api public\n */\n\nfunction log() {\n  // this hackery is required for IE8/9, where\n  // the `console.log` function doesn't have 'apply'\n  return 'object' === typeof console\n    && console.log\n    && Function.prototype.apply.call(console.log, console, arguments);\n}\n\n/**\n * Save `namespaces`.\n *\n * @param {String} namespaces\n * @api private\n */\n\nfunction save(namespaces) {\n  try {\n    if (null == namespaces) {\n      exports.storage.removeItem('debug');\n    } else {\n      exports.storage.debug = namespaces;\n    }\n  } catch(e) {}\n}\n\n/**\n * Load `namespaces`.\n *\n * @return {String} returns the previously persisted debug modes\n * @api private\n */\n\nfunction load() {\n  var r;\n  try {\n    return exports.storage.debug;\n  } catch(e) {}\n\n  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG\n  if (typeof process !== 'undefined' && 'env' in process) {\n    return process.env.DEBUG;\n  }\n}\n\n/**\n * Enable namespaces listed in `localStorage.debug` initially.\n */\n\nexports.enable(load());\n\n/**\n * Localstorage attempts to return the localstorage.\n *\n * This is necessary because safari throws\n * when a user disables cookies/localstorage\n * and you attempt to access it.\n *\n * @return {LocalStorage}\n * @api private\n */\n\nfunction localstorage(){\n  try {\n    return window.localStorage;\n  } catch (e) {}\n}\n\n}).call(this,require('_process'))\n\n},{\"./debug\":21,\"_process\":34}],21:[function(require,module,exports){\n\n/**\n * This is the common logic for both the Node.js and web browser\n * implementations of `debug()`.\n *\n * Expose `debug()` as the module.\n */\n\nexports = module.exports = debug.debug = debug;\nexports.coerce = coerce;\nexports.disable = disable;\nexports.enable = enable;\nexports.enabled = enabled;\nexports.humanize = require('ms');\n\n/**\n * The currently active debug mode names, and names to skip.\n */\n\nexports.names = [];\nexports.skips = [];\n\n/**\n * Map of special \"%n\" handling functions, for the debug \"format\" argument.\n *\n * Valid key names are a single, lowercased letter, i.e. \"n\".\n */\n\nexports.formatters = {};\n\n/**\n * Previously assigned color.\n */\n\nvar prevColor = 0;\n\n/**\n * Previous log timestamp.\n */\n\nvar prevTime;\n\n/**\n * Select a color.\n *\n * @return {Number}\n * @api private\n */\n\nfunction selectColor() {\n  return exports.colors[prevColor++ % exports.colors.length];\n}\n\n/**\n * Create a debugger with the given `namespace`.\n *\n * @param {String} namespace\n * @return {Function}\n * @api public\n */\n\nfunction debug(namespace) {\n\n  // define the `disabled` version\n  function disabled() {\n  }\n  disabled.enabled = false;\n\n  // define the `enabled` version\n  function enabled() {\n\n    var self = enabled;\n\n    // set `diff` timestamp\n    var curr = +new Date();\n    var ms = curr - (prevTime || curr);\n    self.diff = ms;\n    self.prev = prevTime;\n    self.curr = curr;\n    prevTime = curr;\n\n    // add the `color` if not set\n    if (null == self.useColors) self.useColors = exports.useColors();\n    if (null == self.color && self.useColors) self.color = selectColor();\n\n    var args = new Array(arguments.length);\n    for (var i = 0; i < args.length; i++) {\n      args[i] = arguments[i];\n    }\n\n    args[0] = exports.coerce(args[0]);\n\n    if ('string' !== typeof args[0]) {\n      // anything else let's inspect with %o\n      args = ['%o'].concat(args);\n    }\n\n    // apply any `formatters` transformations\n    var index = 0;\n    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {\n      // if we encounter an escaped % then don't increase the array index\n      if (match === '%%') return match;\n      index++;\n      var formatter = exports.formatters[format];\n      if ('function' === typeof formatter) {\n        var val = args[index];\n        match = formatter.call(self, val);\n\n        // now we need to remove `args[index]` since it's inlined in the `format`\n        args.splice(index, 1);\n        index--;\n      }\n      return match;\n    });\n\n    // apply env-specific formatting\n    args = exports.formatArgs.apply(self, args);\n\n    var logFn = enabled.log || exports.log || console.log.bind(console);\n    logFn.apply(self, args);\n  }\n  enabled.enabled = true;\n\n  var fn = exports.enabled(namespace) ? enabled : disabled;\n\n  fn.namespace = namespace;\n\n  return fn;\n}\n\n/**\n * Enables a debug mode by namespaces. This can include modes\n * separated by a colon and wildcards.\n *\n * @param {String} namespaces\n * @api public\n */\n\nfunction enable(namespaces) {\n  exports.save(namespaces);\n\n  var split = (namespaces || '').split(/[\\s,]+/);\n  var len = split.length;\n\n  for (var i = 0; i < len; i++) {\n    if (!split[i]) continue; // ignore empty strings\n    namespaces = split[i].replace(/[\\\\^$+?.()|[\\]{}]/g, '\\\\$&').replace(/\\*/g, '.*?');\n    if (namespaces[0] === '-') {\n      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));\n    } else {\n      exports.names.push(new RegExp('^' + namespaces + '$'));\n    }\n  }\n}\n\n/**\n * Disable debug output.\n *\n * @api public\n */\n\nfunction disable() {\n  exports.enable('');\n}\n\n/**\n * Returns true if the given mode name is enabled, false otherwise.\n *\n * @param {String} name\n * @return {Boolean}\n * @api public\n */\n\nfunction enabled(name) {\n  var i, len;\n  for (i = 0, len = exports.skips.length; i < len; i++) {\n    if (exports.skips[i].test(name)) {\n      return false;\n    }\n  }\n  for (i = 0, len = exports.names.length; i < len; i++) {\n    if (exports.names[i].test(name)) {\n      return true;\n    }\n  }\n  return false;\n}\n\n/**\n * Coerce `val`.\n *\n * @param {Mixed} val\n * @return {Mixed}\n * @api private\n */\n\nfunction coerce(val) {\n  if (val instanceof Error) return val.stack || val.message;\n  return val;\n}\n\n},{\"ms\":22}],22:[function(require,module,exports){\n/**\n * Helpers.\n */\n\nvar s = 1000\nvar m = s * 60\nvar h = m * 60\nvar d = h * 24\nvar y = d * 365.25\n\n/**\n * Parse or format the given `val`.\n *\n * Options:\n *\n *  - `long` verbose formatting [false]\n *\n * @param {String|Number} val\n * @param {Object} options\n * @throws {Error} throw an error if val is not a non-empty string or a number\n * @return {String|Number}\n * @api public\n */\n\nmodule.exports = function (val, options) {\n  options = options || {}\n  var type = typeof val\n  if (type === 'string' && val.length > 0) {\n    return parse(val)\n  } else if (type === 'number' && isNaN(val) === false) {\n    return options.long ?\n\t\t\tfmtLong(val) :\n\t\t\tfmtShort(val)\n  }\n  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))\n}\n\n/**\n * Parse the given `str` and return milliseconds.\n *\n * @param {String} str\n * @return {Number}\n * @api private\n */\n\nfunction parse(str) {\n  str = String(str)\n  if (str.length > 10000) {\n    return\n  }\n  var match = /^((?:\\d+)?\\.?\\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)\n  if (!match) {\n    return\n  }\n  var n = parseFloat(match[1])\n  var type = (match[2] || 'ms').toLowerCase()\n  switch (type) {\n    case 'years':\n    case 'year':\n    case 'yrs':\n    case 'yr':\n    case 'y':\n      return n * y\n    case 'days':\n    case 'day':\n    case 'd':\n      return n * d\n    case 'hours':\n    case 'hour':\n    case 'hrs':\n    case 'hr':\n    case 'h':\n      return n * h\n    case 'minutes':\n    case 'minute':\n    case 'mins':\n    case 'min':\n    case 'm':\n      return n * m\n    case 'seconds':\n    case 'second':\n    case 'secs':\n    case 'sec':\n    case 's':\n      return n * s\n    case 'milliseconds':\n    case 'millisecond':\n    case 'msecs':\n    case 'msec':\n    case 'ms':\n      return n\n    default:\n      return undefined\n  }\n}\n\n/**\n * Short format for `ms`.\n *\n * @param {Number} ms\n * @return {String}\n * @api private\n */\n\nfunction fmtShort(ms) {\n  if (ms >= d) {\n    return Math.round(ms / d) + 'd'\n  }\n  if (ms >= h) {\n    return Math.round(ms / h) + 'h'\n  }\n  if (ms >= m) {\n    return Math.round(ms / m) + 'm'\n  }\n  if (ms >= s) {\n    return Math.round(ms / s) + 's'\n  }\n  return ms + 'ms'\n}\n\n/**\n * Long format for `ms`.\n *\n * @param {Number} ms\n * @return {String}\n * @api private\n */\n\nfunction fmtLong(ms) {\n  return plural(ms, d, 'day') ||\n    plural(ms, h, 'hour') ||\n    plural(ms, m, 'minute') ||\n    plural(ms, s, 'second') ||\n    ms + ' ms'\n}\n\n/**\n * Pluralization helper.\n */\n\nfunction plural(ms, n, name) {\n  if (ms < n) {\n    return\n  }\n  if (ms < n * 1.5) {\n    return Math.floor(ms / n) + ' ' + name\n  }\n  return Math.ceil(ms / n) + ' ' + name + 's'\n}\n\n},{}],23:[function(require,module,exports){\n(function (global){\n/**\n * Module dependencies.\n */\n\nvar keys = require('./keys');\nvar hasBinary = require('has-binary');\nvar sliceBuffer = require('arraybuffer.slice');\nvar after = require('after');\nvar utf8 = require('wtf-8');\n\nvar base64encoder;\nif (global && global.ArrayBuffer) {\n  base64encoder = require('base64-arraybuffer');\n}\n\n/**\n * Check if we are running an android browser. That requires us to use\n * ArrayBuffer with polling transports...\n *\n * http://ghinda.net/jpeg-blob-ajax-android/\n */\n\nvar isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);\n\n/**\n * Check if we are running in PhantomJS.\n * Uploading a Blob with PhantomJS does not work correctly, as reported here:\n * https://github.com/ariya/phantomjs/issues/11395\n * @type boolean\n */\nvar isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);\n\n/**\n * When true, avoids using Blobs to encode payloads.\n * @type boolean\n */\nvar dontSendBlobs = isAndroid || isPhantomJS;\n\n/**\n * Current protocol version.\n */\n\nexports.protocol = 3;\n\n/**\n * Packet types.\n */\n\nvar packets = exports.packets = {\n    open:     0    // non-ws\n  , close:    1    // non-ws\n  , ping:     2\n  , pong:     3\n  , message:  4\n  , upgrade:  5\n  , noop:     6\n};\n\nvar packetslist = keys(packets);\n\n/**\n * Premade error packet.\n */\n\nvar err = { type: 'error', data: 'parser error' };\n\n/**\n * Create a blob api even for blob builder when vendor prefixes exist\n */\n\nvar Blob = require('blob');\n\n/**\n * Encodes a packet.\n *\n *     <packet type id> [ <data> ]\n *\n * Example:\n *\n *     5hello world\n *     3\n *     4\n *\n * Binary is encoded in an identical principle\n *\n * @api private\n */\n\nexports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {\n  if ('function' == typeof supportsBinary) {\n    callback = supportsBinary;\n    supportsBinary = false;\n  }\n\n  if ('function' == typeof utf8encode) {\n    callback = utf8encode;\n    utf8encode = null;\n  }\n\n  var data = (packet.data === undefined)\n    ? undefined\n    : packet.data.buffer || packet.data;\n\n  if (global.ArrayBuffer && data instanceof ArrayBuffer) {\n    return encodeArrayBuffer(packet, supportsBinary, callback);\n  } else if (Blob && data instanceof global.Blob) {\n    return encodeBlob(packet, supportsBinary, callback);\n  }\n\n  // might be an object with { base64: true, data: dataAsBase64String }\n  if (data && data.base64) {\n    return encodeBase64Object(packet, callback);\n  }\n\n  // Sending data as a utf-8 string\n  var encoded = packets[packet.type];\n\n  // data fragment is optional\n  if (undefined !== packet.data) {\n    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);\n  }\n\n  return callback('' + encoded);\n\n};\n\nfunction encodeBase64Object(packet, callback) {\n  // packet data is an object { base64: true, data: dataAsBase64String }\n  var message = 'b' + exports.packets[packet.type] + packet.data.data;\n  return callback(message);\n}\n\n/**\n * Encode packet helpers for binary types\n */\n\nfunction encodeArrayBuffer(packet, supportsBinary, callback) {\n  if (!supportsBinary) {\n    return exports.encodeBase64Packet(packet, callback);\n  }\n\n  var data = packet.data;\n  var contentArray = new Uint8Array(data);\n  var resultBuffer = new Uint8Array(1 + data.byteLength);\n\n  resultBuffer[0] = packets[packet.type];\n  for (var i = 0; i < contentArray.length; i++) {\n    resultBuffer[i+1] = contentArray[i];\n  }\n\n  return callback(resultBuffer.buffer);\n}\n\nfunction encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {\n  if (!supportsBinary) {\n    return exports.encodeBase64Packet(packet, callback);\n  }\n\n  var fr = new FileReader();\n  fr.onload = function() {\n    packet.data = fr.result;\n    exports.encodePacket(packet, supportsBinary, true, callback);\n  };\n  return fr.readAsArrayBuffer(packet.data);\n}\n\nfunction encodeBlob(packet, supportsBinary, callback) {\n  if (!supportsBinary) {\n    return exports.encodeBase64Packet(packet, callback);\n  }\n\n  if (dontSendBlobs) {\n    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);\n  }\n\n  var length = new Uint8Array(1);\n  length[0] = packets[packet.type];\n  var blob = new Blob([length.buffer, packet.data]);\n\n  return callback(blob);\n}\n\n/**\n * Encodes a packet with binary data in a base64 string\n *\n * @param {Object} packet, has `type` and `data`\n * @return {String} base64 encoded message\n */\n\nexports.encodeBase64Packet = function(packet, callback) {\n  var message = 'b' + exports.packets[packet.type];\n  if (Blob && packet.data instanceof global.Blob) {\n    var fr = new FileReader();\n    fr.onload = function() {\n      var b64 = fr.result.split(',')[1];\n      callback(message + b64);\n    };\n    return fr.readAsDataURL(packet.data);\n  }\n\n  var b64data;\n  try {\n    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));\n  } catch (e) {\n    // iPhone Safari doesn't let you apply with typed arrays\n    var typed = new Uint8Array(packet.data);\n    var basic = new Array(typed.length);\n    for (var i = 0; i < typed.length; i++) {\n      basic[i] = typed[i];\n    }\n    b64data = String.fromCharCode.apply(null, basic);\n  }\n  message += global.btoa(b64data);\n  return callback(message);\n};\n\n/**\n * Decodes a packet. Changes format to Blob if requested.\n *\n * @return {Object} with `type` and `data` (if any)\n * @api private\n */\n\nexports.decodePacket = function (data, binaryType, utf8decode) {\n  if (data === undefined) {\n    return err;\n  }\n  // String data\n  if (typeof data == 'string') {\n    if (data.charAt(0) == 'b') {\n      return exports.decodeBase64Packet(data.substr(1), binaryType);\n    }\n\n    if (utf8decode) {\n      data = tryDecode(data);\n      if (data === false) {\n        return err;\n      }\n    }\n    var type = data.charAt(0);\n\n    if (Number(type) != type || !packetslist[type]) {\n      return err;\n    }\n\n    if (data.length > 1) {\n      return { type: packetslist[type], data: data.substring(1) };\n    } else {\n      return { type: packetslist[type] };\n    }\n  }\n\n  var asArray = new Uint8Array(data);\n  var type = asArray[0];\n  var rest = sliceBuffer(data, 1);\n  if (Blob && binaryType === 'blob') {\n    rest = new Blob([rest]);\n  }\n  return { type: packetslist[type], data: rest };\n};\n\nfunction tryDecode(data) {\n  try {\n    data = utf8.decode(data);\n  } catch (e) {\n    return false;\n  }\n  return data;\n}\n\n/**\n * Decodes a packet encoded in a base64 string\n *\n * @param {String} base64 encoded message\n * @return {Object} with `type` and `data` (if any)\n */\n\nexports.decodeBase64Packet = function(msg, binaryType) {\n  var type = packetslist[msg.charAt(0)];\n  if (!base64encoder) {\n    return { type: type, data: { base64: true, data: msg.substr(1) } };\n  }\n\n  var data = base64encoder.decode(msg.substr(1));\n\n  if (binaryType === 'blob' && Blob) {\n    data = new Blob([data]);\n  }\n\n  return { type: type, data: data };\n};\n\n/**\n * Encodes multiple messages (payload).\n *\n *     <length>:data\n *\n * Example:\n *\n *     11:hello world2:hi\n *\n * If any contents are binary, they will be encoded as base64 strings. Base64\n * encoded strings are marked with a b before the length specifier\n *\n * @param {Array} packets\n * @api private\n */\n\nexports.encodePayload = function (packets, supportsBinary, callback) {\n  if (typeof supportsBinary == 'function') {\n    callback = supportsBinary;\n    supportsBinary = null;\n  }\n\n  var isBinary = hasBinary(packets);\n\n  if (supportsBinary && isBinary) {\n    if (Blob && !dontSendBlobs) {\n      return exports.encodePayloadAsBlob(packets, callback);\n    }\n\n    return exports.encodePayloadAsArrayBuffer(packets, callback);\n  }\n\n  if (!packets.length) {\n    return callback('0:');\n  }\n\n  function setLengthHeader(message) {\n    return message.length + ':' + message;\n  }\n\n  function encodeOne(packet, doneCallback) {\n    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {\n      doneCallback(null, setLengthHeader(message));\n    });\n  }\n\n  map(packets, encodeOne, function(err, results) {\n    return callback(results.join(''));\n  });\n};\n\n/**\n * Async array map using after\n */\n\nfunction map(ary, each, done) {\n  var result = new Array(ary.length);\n  var next = after(ary.length, done);\n\n  var eachWithIndex = function(i, el, cb) {\n    each(el, function(error, msg) {\n      result[i] = msg;\n      cb(error, result);\n    });\n  };\n\n  for (var i = 0; i < ary.length; i++) {\n    eachWithIndex(i, ary[i], next);\n  }\n}\n\n/*\n * Decodes data when a payload is maybe expected. Possible binary contents are\n * decoded from their base64 representation\n *\n * @param {String} data, callback method\n * @api public\n */\n\nexports.decodePayload = function (data, binaryType, callback) {\n  if (typeof data != 'string') {\n    return exports.decodePayloadAsBinary(data, binaryType, callback);\n  }\n\n  if (typeof binaryType === 'function') {\n    callback = binaryType;\n    binaryType = null;\n  }\n\n  var packet;\n  if (data == '') {\n    // parser error - ignoring payload\n    return callback(err, 0, 1);\n  }\n\n  var length = ''\n    , n, msg;\n\n  for (var i = 0, l = data.length; i < l; i++) {\n    var chr = data.charAt(i);\n\n    if (':' != chr) {\n      length += chr;\n    } else {\n      if ('' == length || (length != (n = Number(length)))) {\n        // parser error - ignoring payload\n        return callback(err, 0, 1);\n      }\n\n      msg = data.substr(i + 1, n);\n\n      if (length != msg.length) {\n        // parser error - ignoring payload\n        return callback(err, 0, 1);\n      }\n\n      if (msg.length) {\n        packet = exports.decodePacket(msg, binaryType, true);\n\n        if (err.type == packet.type && err.data == packet.data) {\n          // parser error in individual packet - ignoring payload\n          return callback(err, 0, 1);\n        }\n\n        var ret = callback(packet, i + n, l);\n        if (false === ret) return;\n      }\n\n      // advance cursor\n      i += n;\n      length = '';\n    }\n  }\n\n  if (length != '') {\n    // parser error - ignoring payload\n    return callback(err, 0, 1);\n  }\n\n};\n\n/**\n * Encodes multiple messages (payload) as binary.\n *\n * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number\n * 255><data>\n *\n * Example:\n * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers\n *\n * @param {Array} packets\n * @return {ArrayBuffer} encoded payload\n * @api private\n */\n\nexports.encodePayloadAsArrayBuffer = function(packets, callback) {\n  if (!packets.length) {\n    return callback(new ArrayBuffer(0));\n  }\n\n  function encodeOne(packet, doneCallback) {\n    exports.encodePacket(packet, true, true, function(data) {\n      return doneCallback(null, data);\n    });\n  }\n\n  map(packets, encodeOne, function(err, encodedPackets) {\n    var totalLength = encodedPackets.reduce(function(acc, p) {\n      var len;\n      if (typeof p === 'string'){\n        len = p.length;\n      } else {\n        len = p.byteLength;\n      }\n      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2\n    }, 0);\n\n    var resultArray = new Uint8Array(totalLength);\n\n    var bufferIndex = 0;\n    encodedPackets.forEach(function(p) {\n      var isString = typeof p === 'string';\n      var ab = p;\n      if (isString) {\n        var view = new Uint8Array(p.length);\n        for (var i = 0; i < p.length; i++) {\n          view[i] = p.charCodeAt(i);\n        }\n        ab = view.buffer;\n      }\n\n      if (isString) { // not true binary\n        resultArray[bufferIndex++] = 0;\n      } else { // true binary\n        resultArray[bufferIndex++] = 1;\n      }\n\n      var lenStr = ab.byteLength.toString();\n      for (var i = 0; i < lenStr.length; i++) {\n        resultArray[bufferIndex++] = parseInt(lenStr[i]);\n      }\n      resultArray[bufferIndex++] = 255;\n\n      var view = new Uint8Array(ab);\n      for (var i = 0; i < view.length; i++) {\n        resultArray[bufferIndex++] = view[i];\n      }\n    });\n\n    return callback(resultArray.buffer);\n  });\n};\n\n/**\n * Encode as Blob\n */\n\nexports.encodePayloadAsBlob = function(packets, callback) {\n  function encodeOne(packet, doneCallback) {\n    exports.encodePacket(packet, true, true, function(encoded) {\n      var binaryIdentifier = new Uint8Array(1);\n      binaryIdentifier[0] = 1;\n      if (typeof encoded === 'string') {\n        var view = new Uint8Array(encoded.length);\n        for (var i = 0; i < encoded.length; i++) {\n          view[i] = encoded.charCodeAt(i);\n        }\n        encoded = view.buffer;\n        binaryIdentifier[0] = 0;\n      }\n\n      var len = (encoded instanceof ArrayBuffer)\n        ? encoded.byteLength\n        : encoded.size;\n\n      var lenStr = len.toString();\n      var lengthAry = new Uint8Array(lenStr.length + 1);\n      for (var i = 0; i < lenStr.length; i++) {\n        lengthAry[i] = parseInt(lenStr[i]);\n      }\n      lengthAry[lenStr.length] = 255;\n\n      if (Blob) {\n        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);\n        doneCallback(null, blob);\n      }\n    });\n  }\n\n  map(packets, encodeOne, function(err, results) {\n    return callback(new Blob(results));\n  });\n};\n\n/*\n * Decodes data when a payload is maybe expected. Strings are decoded by\n * interpreting each byte as a key code for entries marked to start with 0. See\n * description of encodePayloadAsBinary\n *\n * @param {ArrayBuffer} data, callback method\n * @api public\n */\n\nexports.decodePayloadAsBinary = function (data, binaryType, callback) {\n  if (typeof binaryType === 'function') {\n    callback = binaryType;\n    binaryType = null;\n  }\n\n  var bufferTail = data;\n  var buffers = [];\n\n  var numberTooLong = false;\n  while (bufferTail.byteLength > 0) {\n    var tailArray = new Uint8Array(bufferTail);\n    var isString = tailArray[0] === 0;\n    var msgLength = '';\n\n    for (var i = 1; ; i++) {\n      if (tailArray[i] == 255) break;\n\n      if (msgLength.length > 310) {\n        numberTooLong = true;\n        break;\n      }\n\n      msgLength += tailArray[i];\n    }\n\n    if(numberTooLong) return callback(err, 0, 1);\n\n    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);\n    msgLength = parseInt(msgLength);\n\n    var msg = sliceBuffer(bufferTail, 0, msgLength);\n    if (isString) {\n      try {\n        msg = String.fromCharCode.apply(null, new Uint8Array(msg));\n      } catch (e) {\n        // iPhone Safari doesn't let you apply to typed arrays\n        var typed = new Uint8Array(msg);\n        msg = '';\n        for (var i = 0; i < typed.length; i++) {\n          msg += String.fromCharCode(typed[i]);\n        }\n      }\n    }\n\n    buffers.push(msg);\n    bufferTail = sliceBuffer(bufferTail, msgLength);\n  }\n\n  var total = buffers.length;\n  buffers.forEach(function(buffer, i) {\n    callback(exports.decodePacket(buffer, binaryType, true), i, total);\n  });\n};\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"./keys\":24,\"after\":1,\"arraybuffer.slice\":2,\"base64-arraybuffer\":4,\"blob\":5,\"has-binary\":26,\"wtf-8\":53}],24:[function(require,module,exports){\n\n/**\n * Gets the keys for an object.\n *\n * @return {Array} keys\n * @api private\n */\n\nmodule.exports = Object.keys || function keys (obj){\n  var arr = [];\n  var has = Object.prototype.hasOwnProperty;\n\n  for (var i in obj) {\n    if (has.call(obj, i)) {\n      arr.push(i);\n    }\n  }\n  return arr;\n};\n\n},{}],25:[function(require,module,exports){\n// Copyright Joyent, Inc. and other Node contributors.\n//\n// Permission is hereby granted, free of charge, to any person obtaining a\n// copy of this software and associated documentation files (the\n// \"Software\"), to deal in the Software without restriction, including\n// without limitation the rights to use, copy, modify, merge, publish,\n// distribute, sublicense, and/or sell copies of the Software, and to permit\n// persons to whom the Software is furnished to do so, subject to the\n// following conditions:\n//\n// The above copyright notice and this permission notice shall be included\n// in all copies or substantial portions of the Software.\n//\n// THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS\n// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN\n// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,\n// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR\n// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE\n// USE OR OTHER DEALINGS IN THE SOFTWARE.\n\nfunction EventEmitter() {\n  this._events = this._events || {};\n  this._maxListeners = this._maxListeners || undefined;\n}\nmodule.exports = EventEmitter;\n\n// Backwards-compat with node 0.10.x\nEventEmitter.EventEmitter = EventEmitter;\n\nEventEmitter.prototype._events = undefined;\nEventEmitter.prototype._maxListeners = undefined;\n\n// By default EventEmitters will print a warning if more than 10 listeners are\n// added to it. This is a useful default which helps finding memory leaks.\nEventEmitter.defaultMaxListeners = 10;\n\n// Obviously not all Emitters should be limited to 10. This function allows\n// that to be increased. Set to zero for unlimited.\nEventEmitter.prototype.setMaxListeners = function(n) {\n  if (!isNumber(n) || n < 0 || isNaN(n))\n    throw TypeError('n must be a positive number');\n  this._maxListeners = n;\n  return this;\n};\n\nEventEmitter.prototype.emit = function(type) {\n  var er, handler, len, args, i, listeners;\n\n  if (!this._events)\n    this._events = {};\n\n  // If there is no 'error' event listener then throw.\n  if (type === 'error') {\n    if (!this._events.error ||\n        (isObject(this._events.error) && !this._events.error.length)) {\n      er = arguments[1];\n      if (er instanceof Error) {\n        throw er; // Unhandled 'error' event\n      } else {\n        // At least give some kind of context to the user\n        var err = new Error('Uncaught, unspecified \"error\" event. (' + er + ')');\n        err.context = er;\n        throw err;\n      }\n    }\n  }\n\n  handler = this._events[type];\n\n  if (isUndefined(handler))\n    return false;\n\n  if (isFunction(handler)) {\n    switch (arguments.length) {\n      // fast cases\n      case 1:\n        handler.call(this);\n        break;\n      case 2:\n        handler.call(this, arguments[1]);\n        break;\n      case 3:\n        handler.call(this, arguments[1], arguments[2]);\n        break;\n      // slower\n      default:\n        args = Array.prototype.slice.call(arguments, 1);\n        handler.apply(this, args);\n    }\n  } else if (isObject(handler)) {\n    args = Array.prototype.slice.call(arguments, 1);\n    listeners = handler.slice();\n    len = listeners.length;\n    for (i = 0; i < len; i++)\n      listeners[i].apply(this, args);\n  }\n\n  return true;\n};\n\nEventEmitter.prototype.addListener = function(type, listener) {\n  var m;\n\n  if (!isFunction(listener))\n    throw TypeError('listener must be a function');\n\n  if (!this._events)\n    this._events = {};\n\n  // To avoid recursion in the case that type === \"newListener\"! Before\n  // adding it to the listeners, first emit \"newListener\".\n  if (this._events.newListener)\n    this.emit('newListener', type,\n              isFunction(listener.listener) ?\n              listener.listener : listener);\n\n  if (!this._events[type])\n    // Optimize the case of one listener. Don't need the extra array object.\n    this._events[type] = listener;\n  else if (isObject(this._events[type]))\n    // If we've already got an array, just append.\n    this._events[type].push(listener);\n  else\n    // Adding the second element, need to change to array.\n    this._events[type] = [this._events[type], listener];\n\n  // Check for listener leak\n  if (isObject(this._events[type]) && !this._events[type].warned) {\n    if (!isUndefined(this._maxListeners)) {\n      m = this._maxListeners;\n    } else {\n      m = EventEmitter.defaultMaxListeners;\n    }\n\n    if (m && m > 0 && this._events[type].length > m) {\n      this._events[type].warned = true;\n      console.error('(node) warning: possible EventEmitter memory ' +\n                    'leak detected. %d listeners added. ' +\n                    'Use emitter.setMaxListeners() to increase limit.',\n                    this._events[type].length);\n      if (typeof console.trace === 'function') {\n        // not supported in IE 10\n        console.trace();\n      }\n    }\n  }\n\n  return this;\n};\n\nEventEmitter.prototype.on = EventEmitter.prototype.addListener;\n\nEventEmitter.prototype.once = function(type, listener) {\n  if (!isFunction(listener))\n    throw TypeError('listener must be a function');\n\n  var fired = false;\n\n  function g() {\n    this.removeListener(type, g);\n\n    if (!fired) {\n      fired = true;\n      listener.apply(this, arguments);\n    }\n  }\n\n  g.listener = listener;\n  this.on(type, g);\n\n  return this;\n};\n\n// emits a 'removeListener' event iff the listener was removed\nEventEmitter.prototype.removeListener = function(type, listener) {\n  var list, position, length, i;\n\n  if (!isFunction(listener))\n    throw TypeError('listener must be a function');\n\n  if (!this._events || !this._events[type])\n    return this;\n\n  list = this._events[type];\n  length = list.length;\n  position = -1;\n\n  if (list === listener ||\n      (isFunction(list.listener) && list.listener === listener)) {\n    delete this._events[type];\n    if (this._events.removeListener)\n      this.emit('removeListener', type, listener);\n\n  } else if (isObject(list)) {\n    for (i = length; i-- > 0;) {\n      if (list[i] === listener ||\n          (list[i].listener && list[i].listener === listener)) {\n        position = i;\n        break;\n      }\n    }\n\n    if (position < 0)\n      return this;\n\n    if (list.length === 1) {\n      list.length = 0;\n      delete this._events[type];\n    } else {\n      list.splice(position, 1);\n    }\n\n    if (this._events.removeListener)\n      this.emit('removeListener', type, listener);\n  }\n\n  return this;\n};\n\nEventEmitter.prototype.removeAllListeners = function(type) {\n  var key, listeners;\n\n  if (!this._events)\n    return this;\n\n  // not listening for removeListener, no need to emit\n  if (!this._events.removeListener) {\n    if (arguments.length === 0)\n      this._events = {};\n    else if (this._events[type])\n      delete this._events[type];\n    return this;\n  }\n\n  // emit removeListener for all listeners on all events\n  if (arguments.length === 0) {\n    for (key in this._events) {\n      if (key === 'removeListener') continue;\n      this.removeAllListeners(key);\n    }\n    this.removeAllListeners('removeListener');\n    this._events = {};\n    return this;\n  }\n\n  listeners = this._events[type];\n\n  if (isFunction(listeners)) {\n    this.removeListener(type, listeners);\n  } else if (listeners) {\n    // LIFO order\n    while (listeners.length)\n      this.removeListener(type, listeners[listeners.length - 1]);\n  }\n  delete this._events[type];\n\n  return this;\n};\n\nEventEmitter.prototype.listeners = function(type) {\n  var ret;\n  if (!this._events || !this._events[type])\n    ret = [];\n  else if (isFunction(this._events[type]))\n    ret = [this._events[type]];\n  else\n    ret = this._events[type].slice();\n  return ret;\n};\n\nEventEmitter.prototype.listenerCount = function(type) {\n  if (this._events) {\n    var evlistener = this._events[type];\n\n    if (isFunction(evlistener))\n      return 1;\n    else if (evlistener)\n      return evlistener.length;\n  }\n  return 0;\n};\n\nEventEmitter.listenerCount = function(emitter, type) {\n  return emitter.listenerCount(type);\n};\n\nfunction isFunction(arg) {\n  return typeof arg === 'function';\n}\n\nfunction isNumber(arg) {\n  return typeof arg === 'number';\n}\n\nfunction isObject(arg) {\n  return typeof arg === 'object' && arg !== null;\n}\n\nfunction isUndefined(arg) {\n  return arg === void 0;\n}\n\n},{}],26:[function(require,module,exports){\n(function (global){\n\n/*\n * Module requirements.\n */\n\nvar isArray = require('isarray');\n\n/**\n * Module exports.\n */\n\nmodule.exports = hasBinary;\n\n/**\n * Checks for binary data.\n *\n * Right now only Buffer and ArrayBuffer are supported..\n *\n * @param {Object} anything\n * @api public\n */\n\nfunction hasBinary(data) {\n\n  function _hasBinary(obj) {\n    if (!obj) return false;\n\n    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||\n         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||\n         (global.Blob && obj instanceof Blob) ||\n         (global.File && obj instanceof File)\n        ) {\n      return true;\n    }\n\n    if (isArray(obj)) {\n      for (var i = 0; i < obj.length; i++) {\n          if (_hasBinary(obj[i])) {\n              return true;\n          }\n      }\n    } else if (obj && 'object' == typeof obj) {\n      // see: https://github.com/Automattic/has-binary/pull/4\n      if (obj.toJSON && 'function' == typeof obj.toJSON) {\n        obj = obj.toJSON();\n      }\n\n      for (var key in obj) {\n        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {\n          return true;\n        }\n      }\n    }\n\n    return false;\n  }\n\n  return _hasBinary(data);\n}\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"isarray\":27}],27:[function(require,module,exports){\nmodule.exports = Array.isArray || function (arr) {\n  return Object.prototype.toString.call(arr) == '[object Array]';\n};\n\n},{}],28:[function(require,module,exports){\n\n/**\n * Module exports.\n *\n * Logic borrowed from Modernizr:\n *\n *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js\n */\n\ntry {\n  module.exports = typeof XMLHttpRequest !== 'undefined' &&\n    'withCredentials' in new XMLHttpRequest();\n} catch (err) {\n  // if XMLHttp support is disabled in IE then it will throw\n  // when trying to create\n  module.exports = false;\n}\n\n},{}],29:[function(require,module,exports){\n\nvar indexOf = [].indexOf;\n\nmodule.exports = function(arr, obj){\n  if (indexOf) return arr.indexOf(obj);\n  for (var i = 0; i < arr.length; ++i) {\n    if (arr[i] === obj) return i;\n  }\n  return -1;\n};\n},{}],30:[function(require,module,exports){\n(function (global){\n/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */\n;(function () {\n  // Detect the `define` function exposed by asynchronous module loaders. The\n  // strict `define` check is necessary for compatibility with `r.js`.\n  var isLoader = typeof define === \"function\" && define.amd;\n\n  // A set of types used to distinguish objects from primitives.\n  var objectTypes = {\n    \"function\": true,\n    \"object\": true\n  };\n\n  // Detect the `exports` object exposed by CommonJS implementations.\n  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;\n\n  // Use the `global` object exposed by Node (including Browserify via\n  // `insert-module-globals`), Narwhal, and Ringo as the default context,\n  // and the `window` object in browsers. Rhino exports a `global` function\n  // instead.\n  var root = objectTypes[typeof window] && window || this,\n      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == \"object\" && global;\n\n  if (freeGlobal && (freeGlobal[\"global\"] === freeGlobal || freeGlobal[\"window\"] === freeGlobal || freeGlobal[\"self\"] === freeGlobal)) {\n    root = freeGlobal;\n  }\n\n  // Public: Initializes JSON 3 using the given `context` object, attaching the\n  // `stringify` and `parse` functions to the specified `exports` object.\n  function runInContext(context, exports) {\n    context || (context = root[\"Object\"]());\n    exports || (exports = root[\"Object\"]());\n\n    // Native constructor aliases.\n    var Number = context[\"Number\"] || root[\"Number\"],\n        String = context[\"String\"] || root[\"String\"],\n        Object = context[\"Object\"] || root[\"Object\"],\n        Date = context[\"Date\"] || root[\"Date\"],\n        SyntaxError = context[\"SyntaxError\"] || root[\"SyntaxError\"],\n        TypeError = context[\"TypeError\"] || root[\"TypeError\"],\n        Math = context[\"Math\"] || root[\"Math\"],\n        nativeJSON = context[\"JSON\"] || root[\"JSON\"];\n\n    // Delegate to the native `stringify` and `parse` implementations.\n    if (typeof nativeJSON == \"object\" && nativeJSON) {\n      exports.stringify = nativeJSON.stringify;\n      exports.parse = nativeJSON.parse;\n    }\n\n    // Convenience aliases.\n    var objectProto = Object.prototype,\n        getClass = objectProto.toString,\n        isProperty, forEach, undef;\n\n    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.\n    var isExtended = new Date(-3509827334573292);\n    try {\n      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical\n      // results for certain dates in Opera >= 10.53.\n      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&\n        // Safari < 2.0.2 stores the internal millisecond time value correctly,\n        // but clips the values returned by the date methods to the range of\n        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).\n        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;\n    } catch (exception) {}\n\n    // Internal: Determines whether the native `JSON.stringify` and `parse`\n    // implementations are spec-compliant. Based on work by Ken Snyder.\n    function has(name) {\n      if (has[name] !== undef) {\n        // Return cached feature test result.\n        return has[name];\n      }\n      var isSupported;\n      if (name == \"bug-string-char-index\") {\n        // IE <= 7 doesn't support accessing string characters using square\n        // bracket notation. IE 8 only supports this for primitives.\n        isSupported = \"a\"[0] != \"a\";\n      } else if (name == \"json\") {\n        // Indicates whether both `JSON.stringify` and `JSON.parse` are\n        // supported.\n        isSupported = has(\"json-stringify\") && has(\"json-parse\");\n      } else {\n        var value, serialized = '{\"a\":[1,true,false,null,\"\\\\u0000\\\\b\\\\n\\\\f\\\\r\\\\t\"]}';\n        // Test `JSON.stringify`.\n        if (name == \"json-stringify\") {\n          var stringify = exports.stringify, stringifySupported = typeof stringify == \"function\" && isExtended;\n          if (stringifySupported) {\n            // A test function object with a custom `toJSON` method.\n            (value = function () {\n              return 1;\n            }).toJSON = value;\n            try {\n              stringifySupported =\n                // Firefox 3.1b1 and b2 serialize string, number, and boolean\n                // primitives as object literals.\n                stringify(0) === \"0\" &&\n                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object\n                // literals.\n                stringify(new Number()) === \"0\" &&\n                stringify(new String()) == '\"\"' &&\n                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or\n                // does not define a canonical JSON representation (this applies to\n                // objects with `toJSON` properties as well, *unless* they are nested\n                // within an object or array).\n                stringify(getClass) === undef &&\n                // IE 8 serializes `undefined` as `\"undefined\"`. Safari <= 5.1.7 and\n                // FF 3.1b3 pass this test.\n                stringify(undef) === undef &&\n                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,\n                // respectively, if the value is omitted entirely.\n                stringify() === undef &&\n                // FF 3.1b1, 2 throw an error if the given value is not a number,\n                // string, array, object, Boolean, or `null` literal. This applies to\n                // objects with custom `toJSON` methods as well, unless they are nested\n                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`\n                // methods entirely.\n                stringify(value) === \"1\" &&\n                stringify([value]) == \"[1]\" &&\n                // Prototype <= 1.6.1 serializes `[undefined]` as `\"[]\"` instead of\n                // `\"[null]\"`.\n                stringify([undef]) == \"[null]\" &&\n                // YUI 3.0.0b1 fails to serialize `null` literals.\n                stringify(null) == \"null\" &&\n                // FF 3.1b1, 2 halts serialization if an array contains a function:\n                // `[1, true, getClass, 1]` serializes as \"[1,true,],\". FF 3.1b3\n                // elides non-JSON values from objects and arrays, unless they\n                // define custom `toJSON` methods.\n                stringify([undef, getClass, null]) == \"[null,null,null]\" &&\n                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences\n                // where character escape codes are expected (e.g., `\\b` => `\\u0008`).\n                stringify({ \"a\": [value, true, false, null, \"\\x00\\b\\n\\f\\r\\t\"] }) == serialized &&\n                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.\n                stringify(null, value) === \"1\" &&\n                stringify([1, 2], null, 1) == \"[\\n 1,\\n 2\\n]\" &&\n                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly\n                // serialize extended years.\n                stringify(new Date(-8.64e15)) == '\"-271821-04-20T00:00:00.000Z\"' &&\n                // The milliseconds are optional in ES 5, but required in 5.1.\n                stringify(new Date(8.64e15)) == '\"+275760-09-13T00:00:00.000Z\"' &&\n                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative\n                // four-digit years instead of six-digit years. Credits: @Yaffle.\n                stringify(new Date(-621987552e5)) == '\"-000001-01-01T00:00:00.000Z\"' &&\n                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond\n                // values less than 1000. Credits: @Yaffle.\n                stringify(new Date(-1)) == '\"1969-12-31T23:59:59.999Z\"';\n            } catch (exception) {\n              stringifySupported = false;\n            }\n          }\n          isSupported = stringifySupported;\n        }\n        // Test `JSON.parse`.\n        if (name == \"json-parse\") {\n          var parse = exports.parse;\n          if (typeof parse == \"function\") {\n            try {\n              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.\n              // Conforming implementations should also coerce the initial argument to\n              // a string prior to parsing.\n              if (parse(\"0\") === 0 && !parse(false)) {\n                // Simple parsing test.\n                value = parse(serialized);\n                var parseSupported = value[\"a\"].length == 5 && value[\"a\"][0] === 1;\n                if (parseSupported) {\n                  try {\n                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.\n                    parseSupported = !parse('\"\\t\"');\n                  } catch (exception) {}\n                  if (parseSupported) {\n                    try {\n                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading\n                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow\n                      // certain octal literals.\n                      parseSupported = parse(\"01\") !== 1;\n                    } catch (exception) {}\n                  }\n                  if (parseSupported) {\n                    try {\n                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal\n                      // points. These environments, along with FF 3.1b1 and 2,\n                      // also allow trailing commas in JSON objects and arrays.\n                      parseSupported = parse(\"1.\") !== 1;\n                    } catch (exception) {}\n                  }\n                }\n              }\n            } catch (exception) {\n              parseSupported = false;\n            }\n          }\n          isSupported = parseSupported;\n        }\n      }\n      return has[name] = !!isSupported;\n    }\n\n    if (!has(\"json\")) {\n      // Common `[[Class]]` name aliases.\n      var functionClass = \"[object Function]\",\n          dateClass = \"[object Date]\",\n          numberClass = \"[object Number]\",\n          stringClass = \"[object String]\",\n          arrayClass = \"[object Array]\",\n          booleanClass = \"[object Boolean]\";\n\n      // Detect incomplete support for accessing string characters by index.\n      var charIndexBuggy = has(\"bug-string-char-index\");\n\n      // Define additional utility methods if the `Date` methods are buggy.\n      if (!isExtended) {\n        var floor = Math.floor;\n        // A mapping between the months of the year and the number of days between\n        // January 1st and the first of the respective month.\n        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];\n        // Internal: Calculates the number of days between the Unix epoch and the\n        // first day of the given month.\n        var getDay = function (year, month) {\n          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);\n        };\n      }\n\n      // Internal: Determines if a property is a direct property of the given\n      // object. Delegates to the native `Object#hasOwnProperty` method.\n      if (!(isProperty = objectProto.hasOwnProperty)) {\n        isProperty = function (property) {\n          var members = {}, constructor;\n          if ((members.__proto__ = null, members.__proto__ = {\n            // The *proto* property cannot be set multiple times in recent\n            // versions of Firefox and SeaMonkey.\n            \"toString\": 1\n          }, members).toString != getClass) {\n            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but\n            // supports the mutable *proto* property.\n            isProperty = function (property) {\n              // Capture and break the object's prototype chain (see section 8.6.2\n              // of the ES 5.1 spec). The parenthesized expression prevents an\n              // unsafe transformation by the Closure Compiler.\n              var original = this.__proto__, result = property in (this.__proto__ = null, this);\n              // Restore the original prototype chain.\n              this.__proto__ = original;\n              return result;\n            };\n          } else {\n            // Capture a reference to the top-level `Object` constructor.\n            constructor = members.constructor;\n            // Use the `constructor` property to simulate `Object#hasOwnProperty` in\n            // other environments.\n            isProperty = function (property) {\n              var parent = (this.constructor || constructor).prototype;\n              return property in this && !(property in parent && this[property] === parent[property]);\n            };\n          }\n          members = null;\n          return isProperty.call(this, property);\n        };\n      }\n\n      // Internal: Normalizes the `for...in` iteration algorithm across\n      // environments. Each enumerated key is yielded to a `callback` function.\n      forEach = function (object, callback) {\n        var size = 0, Properties, members, property;\n\n        // Tests for bugs in the current environment's `for...in` algorithm. The\n        // `valueOf` property inherits the non-enumerable flag from\n        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.\n        (Properties = function () {\n          this.valueOf = 0;\n        }).prototype.valueOf = 0;\n\n        // Iterate over a new instance of the `Properties` class.\n        members = new Properties();\n        for (property in members) {\n          // Ignore all properties inherited from `Object.prototype`.\n          if (isProperty.call(members, property)) {\n            size++;\n          }\n        }\n        Properties = members = null;\n\n        // Normalize the iteration algorithm.\n        if (!size) {\n          // A list of non-enumerable properties inherited from `Object.prototype`.\n          members = [\"valueOf\", \"toString\", \"toLocaleString\", \"propertyIsEnumerable\", \"isPrototypeOf\", \"hasOwnProperty\", \"constructor\"];\n          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable\n          // properties.\n          forEach = function (object, callback) {\n            var isFunction = getClass.call(object) == functionClass, property, length;\n            var hasProperty = !isFunction && typeof object.constructor != \"function\" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;\n            for (property in object) {\n              // Gecko <= 1.0 enumerates the `prototype` property of functions under\n              // certain conditions; IE does not.\n              if (!(isFunction && property == \"prototype\") && hasProperty.call(object, property)) {\n                callback(property);\n              }\n            }\n            // Manually invoke the callback for each non-enumerable property.\n            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));\n          };\n        } else if (size == 2) {\n          // Safari <= 2.0.4 enumerates shadowed properties twice.\n          forEach = function (object, callback) {\n            // Create a set of iterated properties.\n            var members = {}, isFunction = getClass.call(object) == functionClass, property;\n            for (property in object) {\n              // Store each property name to prevent double enumeration. The\n              // `prototype` property of functions is not enumerated due to cross-\n              // environment inconsistencies.\n              if (!(isFunction && property == \"prototype\") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {\n                callback(property);\n              }\n            }\n          };\n        } else {\n          // No bugs detected; use the standard `for...in` algorithm.\n          forEach = function (object, callback) {\n            var isFunction = getClass.call(object) == functionClass, property, isConstructor;\n            for (property in object) {\n              if (!(isFunction && property == \"prototype\") && isProperty.call(object, property) && !(isConstructor = property === \"constructor\")) {\n                callback(property);\n              }\n            }\n            // Manually invoke the callback for the `constructor` property due to\n            // cross-environment inconsistencies.\n            if (isConstructor || isProperty.call(object, (property = \"constructor\"))) {\n              callback(property);\n            }\n          };\n        }\n        return forEach(object, callback);\n      };\n\n      // Public: Serializes a JavaScript `value` as a JSON string. The optional\n      // `filter` argument may specify either a function that alters how object and\n      // array members are serialized, or an array of strings and numbers that\n      // indicates which properties should be serialized. The optional `width`\n      // argument may be either a string or number that specifies the indentation\n      // level of the output.\n      if (!has(\"json-stringify\")) {\n        // Internal: A map of control characters and their escaped equivalents.\n        var Escapes = {\n          92: \"\\\\\\\\\",\n          34: '\\\\\"',\n          8: \"\\\\b\",\n          12: \"\\\\f\",\n          10: \"\\\\n\",\n          13: \"\\\\r\",\n          9: \"\\\\t\"\n        };\n\n        // Internal: Converts `value` into a zero-padded string such that its\n        // length is at least equal to `width`. The `width` must be <= 6.\n        var leadingZeroes = \"000000\";\n        var toPaddedString = function (width, value) {\n          // The `|| 0` expression is necessary to work around a bug in\n          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== \"0\"`.\n          return (leadingZeroes + (value || 0)).slice(-width);\n        };\n\n        // Internal: Double-quotes a string `value`, replacing all ASCII control\n        // characters (characters with code unit values between 0 and 31) with\n        // their escaped equivalents. This is an implementation of the\n        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.\n        var unicodePrefix = \"\\\\u00\";\n        var quote = function (value) {\n          var result = '\"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;\n          var symbols = useCharIndex && (charIndexBuggy ? value.split(\"\") : value);\n          for (; index < length; index++) {\n            var charCode = value.charCodeAt(index);\n            // If the character is a control character, append its Unicode or\n            // shorthand escape sequence; otherwise, append the character as-is.\n            switch (charCode) {\n              case 8: case 9: case 10: case 12: case 13: case 34: case 92:\n                result += Escapes[charCode];\n                break;\n              default:\n                if (charCode < 32) {\n                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));\n                  break;\n                }\n                result += useCharIndex ? symbols[index] : value.charAt(index);\n            }\n          }\n          return result + '\"';\n        };\n\n        // Internal: Recursively serializes an object. Implements the\n        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.\n        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {\n          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;\n          try {\n            // Necessary for host object support.\n            value = object[property];\n          } catch (exception) {}\n          if (typeof value == \"object\" && value) {\n            className = getClass.call(value);\n            if (className == dateClass && !isProperty.call(value, \"toJSON\")) {\n              if (value > -1 / 0 && value < 1 / 0) {\n                // Dates are serialized according to the `Date#toJSON` method\n                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15\n                // for the ISO 8601 date time string format.\n                if (getDay) {\n                  // Manually compute the year, month, date, hours, minutes,\n                  // seconds, and milliseconds if the `getUTC*` methods are\n                  // buggy. Adapted from @Yaffle's `date-shim` project.\n                  date = floor(value / 864e5);\n                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);\n                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);\n                  date = 1 + date - getDay(year, month);\n                  // The `time` value specifies the time within the day (see ES\n                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used\n                  // to compute `A modulo B`, as the `%` operator does not\n                  // correspond to the `modulo` operation for negative numbers.\n                  time = (value % 864e5 + 864e5) % 864e5;\n                  // The hours, minutes, seconds, and milliseconds are obtained by\n                  // decomposing the time within the day. See section 15.9.1.10.\n                  hours = floor(time / 36e5) % 24;\n                  minutes = floor(time / 6e4) % 60;\n                  seconds = floor(time / 1e3) % 60;\n                  milliseconds = time % 1e3;\n                } else {\n                  year = value.getUTCFullYear();\n                  month = value.getUTCMonth();\n                  date = value.getUTCDate();\n                  hours = value.getUTCHours();\n                  minutes = value.getUTCMinutes();\n                  seconds = value.getUTCSeconds();\n                  milliseconds = value.getUTCMilliseconds();\n                }\n                // Serialize extended years correctly.\n                value = (year <= 0 || year >= 1e4 ? (year < 0 ? \"-\" : \"+\") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +\n                  \"-\" + toPaddedString(2, month + 1) + \"-\" + toPaddedString(2, date) +\n                  // Months, dates, hours, minutes, and seconds should have two\n                  // digits; milliseconds should have three.\n                  \"T\" + toPaddedString(2, hours) + \":\" + toPaddedString(2, minutes) + \":\" + toPaddedString(2, seconds) +\n                  // Milliseconds are optional in ES 5.0, but required in 5.1.\n                  \".\" + toPaddedString(3, milliseconds) + \"Z\";\n              } else {\n                value = null;\n              }\n            } else if (typeof value.toJSON == \"function\" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, \"toJSON\"))) {\n              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the\n              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3\n              // ignores all `toJSON` methods on these objects unless they are\n              // defined directly on an instance.\n              value = value.toJSON(property);\n            }\n          }\n          if (callback) {\n            // If a replacement function was provided, call it to obtain the value\n            // for serialization.\n            value = callback.call(object, property, value);\n          }\n          if (value === null) {\n            return \"null\";\n          }\n          className = getClass.call(value);\n          if (className == booleanClass) {\n            // Booleans are represented literally.\n            return \"\" + value;\n          } else if (className == numberClass) {\n            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as\n            // `\"null\"`.\n            return value > -1 / 0 && value < 1 / 0 ? \"\" + value : \"null\";\n          } else if (className == stringClass) {\n            // Strings are double-quoted and escaped.\n            return quote(\"\" + value);\n          }\n          // Recursively serialize objects and arrays.\n          if (typeof value == \"object\") {\n            // Check for cyclic structures. This is a linear search; performance\n            // is inversely proportional to the number of unique nested objects.\n            for (length = stack.length; length--;) {\n              if (stack[length] === value) {\n                // Cyclic structures cannot be serialized by `JSON.stringify`.\n                throw TypeError();\n              }\n            }\n            // Add the object to the stack of traversed objects.\n            stack.push(value);\n            results = [];\n            // Save the current indentation level and indent one additional level.\n            prefix = indentation;\n            indentation += whitespace;\n            if (className == arrayClass) {\n              // Recursively serialize array elements.\n              for (index = 0, length = value.length; index < length; index++) {\n                element = serialize(index, value, callback, properties, whitespace, indentation, stack);\n                results.push(element === undef ? \"null\" : element);\n              }\n              result = results.length ? (whitespace ? \"[\\n\" + indentation + results.join(\",\\n\" + indentation) + \"\\n\" + prefix + \"]\" : (\"[\" + results.join(\",\") + \"]\")) : \"[]\";\n            } else {\n              // Recursively serialize object members. Members are selected from\n              // either a user-specified list of property names, or the object\n              // itself.\n              forEach(properties || value, function (property) {\n                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);\n                if (element !== undef) {\n                  // According to ES 5.1 section 15.12.3: \"If `gap` {whitespace}\n                  // is not the empty string, let `member` {quote(property) + \":\"}\n                  // be the concatenation of `member` and the `space` character.\"\n                  // The \"`space` character\" refers to the literal space\n                  // character, not the `space` {width} argument provided to\n                  // `JSON.stringify`.\n                  results.push(quote(property) + \":\" + (whitespace ? \" \" : \"\") + element);\n                }\n              });\n              result = results.length ? (whitespace ? \"{\\n\" + indentation + results.join(\",\\n\" + indentation) + \"\\n\" + prefix + \"}\" : (\"{\" + results.join(\",\") + \"}\")) : \"{}\";\n            }\n            // Remove the object from the traversed object stack.\n            stack.pop();\n            return result;\n          }\n        };\n\n        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.\n        exports.stringify = function (source, filter, width) {\n          var whitespace, callback, properties, className;\n          if (objectTypes[typeof filter] && filter) {\n            if ((className = getClass.call(filter)) == functionClass) {\n              callback = filter;\n            } else if (className == arrayClass) {\n              // Convert the property names array into a makeshift set.\n              properties = {};\n              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));\n            }\n          }\n          if (width) {\n            if ((className = getClass.call(width)) == numberClass) {\n              // Convert the `width` to an integer and create a string containing\n              // `width` number of space characters.\n              if ((width -= width % 1) > 0) {\n                for (whitespace = \"\", width > 10 && (width = 10); whitespace.length < width; whitespace += \" \");\n              }\n            } else if (className == stringClass) {\n              whitespace = width.length <= 10 ? width : width.slice(0, 10);\n            }\n          }\n          // Opera <= 7.54u2 discards the values associated with empty string keys\n          // (`\"\"`) only if they are used directly within an object member list\n          // (e.g., `!(\"\" in { \"\": 1})`).\n          return serialize(\"\", (value = {}, value[\"\"] = source, value), callback, properties, whitespace, \"\", []);\n        };\n      }\n\n      // Public: Parses a JSON source string.\n      if (!has(\"json-parse\")) {\n        var fromCharCode = String.fromCharCode;\n\n        // Internal: A map of escaped control characters and their unescaped\n        // equivalents.\n        var Unescapes = {\n          92: \"\\\\\",\n          34: '\"',\n          47: \"/\",\n          98: \"\\b\",\n          116: \"\\t\",\n          110: \"\\n\",\n          102: \"\\f\",\n          114: \"\\r\"\n        };\n\n        // Internal: Stores the parser state.\n        var Index, Source;\n\n        // Internal: Resets the parser state and throws a `SyntaxError`.\n        var abort = function () {\n          Index = Source = null;\n          throw SyntaxError();\n        };\n\n        // Internal: Returns the next token, or `\"$\"` if the parser has reached\n        // the end of the source string. A token may be a string, number, `null`\n        // literal, or Boolean literal.\n        var lex = function () {\n          var source = Source, length = source.length, value, begin, position, isSigned, charCode;\n          while (Index < length) {\n            charCode = source.charCodeAt(Index);\n            switch (charCode) {\n              case 9: case 10: case 13: case 32:\n                // Skip whitespace tokens, including tabs, carriage returns, line\n                // feeds, and space characters.\n                Index++;\n                break;\n              case 123: case 125: case 91: case 93: case 58: case 44:\n                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at\n                // the current position.\n                value = charIndexBuggy ? source.charAt(Index) : source[Index];\n                Index++;\n                return value;\n              case 34:\n                // `\"` delimits a JSON string; advance to the next character and\n                // begin parsing the string. String tokens are prefixed with the\n                // sentinel `@` character to distinguish them from punctuators and\n                // end-of-string tokens.\n                for (value = \"@\", Index++; Index < length;) {\n                  charCode = source.charCodeAt(Index);\n                  if (charCode < 32) {\n                    // Unescaped ASCII control characters (those with a code unit\n                    // less than the space character) are not permitted.\n                    abort();\n                  } else if (charCode == 92) {\n                    // A reverse solidus (`\\`) marks the beginning of an escaped\n                    // control character (including `\"`, `\\`, and `/`) or Unicode\n                    // escape sequence.\n                    charCode = source.charCodeAt(++Index);\n                    switch (charCode) {\n                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:\n                        // Revive escaped control characters.\n                        value += Unescapes[charCode];\n                        Index++;\n                        break;\n                      case 117:\n                        // `\\u` marks the beginning of a Unicode escape sequence.\n                        // Advance to the first character and validate the\n                        // four-digit code point.\n                        begin = ++Index;\n                        for (position = Index + 4; Index < position; Index++) {\n                          charCode = source.charCodeAt(Index);\n                          // A valid sequence comprises four hexdigits (case-\n                          // insensitive) that form a single hexadecimal value.\n                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {\n                            // Invalid Unicode escape sequence.\n                            abort();\n                          }\n                        }\n                        // Revive the escaped character.\n                        value += fromCharCode(\"0x\" + source.slice(begin, Index));\n                        break;\n                      default:\n                        // Invalid escape sequence.\n                        abort();\n                    }\n                  } else {\n                    if (charCode == 34) {\n                      // An unescaped double-quote character marks the end of the\n                      // string.\n                      break;\n                    }\n                    charCode = source.charCodeAt(Index);\n                    begin = Index;\n                    // Optimize for the common case where a string is valid.\n                    while (charCode >= 32 && charCode != 92 && charCode != 34) {\n                      charCode = source.charCodeAt(++Index);\n                    }\n                    // Append the string as-is.\n                    value += source.slice(begin, Index);\n                  }\n                }\n                if (source.charCodeAt(Index) == 34) {\n                  // Advance to the next character and return the revived string.\n                  Index++;\n                  return value;\n                }\n                // Unterminated string.\n                abort();\n              default:\n                // Parse numbers and literals.\n                begin = Index;\n                // Advance past the negative sign, if one is specified.\n                if (charCode == 45) {\n                  isSigned = true;\n                  charCode = source.charCodeAt(++Index);\n                }\n                // Parse an integer or floating-point value.\n                if (charCode >= 48 && charCode <= 57) {\n                  // Leading zeroes are interpreted as octal literals.\n                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {\n                    // Illegal octal literal.\n                    abort();\n                  }\n                  isSigned = false;\n                  // Parse the integer component.\n                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);\n                  // Floats cannot contain a leading decimal point; however, this\n                  // case is already accounted for by the parser.\n                  if (source.charCodeAt(Index) == 46) {\n                    position = ++Index;\n                    // Parse the decimal component.\n                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);\n                    if (position == Index) {\n                      // Illegal trailing decimal.\n                      abort();\n                    }\n                    Index = position;\n                  }\n                  // Parse exponents. The `e` denoting the exponent is\n                  // case-insensitive.\n                  charCode = source.charCodeAt(Index);\n                  if (charCode == 101 || charCode == 69) {\n                    charCode = source.charCodeAt(++Index);\n                    // Skip past the sign following the exponent, if one is\n                    // specified.\n                    if (charCode == 43 || charCode == 45) {\n                      Index++;\n                    }\n                    // Parse the exponential component.\n                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);\n                    if (position == Index) {\n                      // Illegal empty exponent.\n                      abort();\n                    }\n                    Index = position;\n                  }\n                  // Coerce the parsed value to a JavaScript number.\n                  return +source.slice(begin, Index);\n                }\n                // A negative sign may only precede numbers.\n                if (isSigned) {\n                  abort();\n                }\n                // `true`, `false`, and `null` literals.\n                if (source.slice(Index, Index + 4) == \"true\") {\n                  Index += 4;\n                  return true;\n                } else if (source.slice(Index, Index + 5) == \"false\") {\n                  Index += 5;\n                  return false;\n                } else if (source.slice(Index, Index + 4) == \"null\") {\n                  Index += 4;\n                  return null;\n                }\n                // Unrecognized token.\n                abort();\n            }\n          }\n          // Return the sentinel `$` character if the parser has reached the end\n          // of the source string.\n          return \"$\";\n        };\n\n        // Internal: Parses a JSON `value` token.\n        var get = function (value) {\n          var results, hasMembers;\n          if (value == \"$\") {\n            // Unexpected end of input.\n            abort();\n          }\n          if (typeof value == \"string\") {\n            if ((charIndexBuggy ? value.charAt(0) : value[0]) == \"@\") {\n              // Remove the sentinel `@` character.\n              return value.slice(1);\n            }\n            // Parse object and array literals.\n            if (value == \"[\") {\n              // Parses a JSON array, returning a new JavaScript array.\n              results = [];\n              for (;; hasMembers || (hasMembers = true)) {\n                value = lex();\n                // A closing square bracket marks the end of the array literal.\n                if (value == \"]\") {\n                  break;\n                }\n                // If the array literal contains elements, the current token\n                // should be a comma separating the previous element from the\n                // next.\n                if (hasMembers) {\n                  if (value == \",\") {\n                    value = lex();\n                    if (value == \"]\") {\n                      // Unexpected trailing `,` in array literal.\n                      abort();\n                    }\n                  } else {\n                    // A `,` must separate each array element.\n                    abort();\n                  }\n                }\n                // Elisions and leading commas are not permitted.\n                if (value == \",\") {\n                  abort();\n                }\n                results.push(get(value));\n              }\n              return results;\n            } else if (value == \"{\") {\n              // Parses a JSON object, returning a new JavaScript object.\n              results = {};\n              for (;; hasMembers || (hasMembers = true)) {\n                value = lex();\n                // A closing curly brace marks the end of the object literal.\n                if (value == \"}\") {\n                  break;\n                }\n                // If the object literal contains members, the current token\n                // should be a comma separator.\n                if (hasMembers) {\n                  if (value == \",\") {\n                    value = lex();\n                    if (value == \"}\") {\n                      // Unexpected trailing `,` in object literal.\n                      abort();\n                    }\n                  } else {\n                    // A `,` must separate each object member.\n                    abort();\n                  }\n                }\n                // Leading commas are not permitted, object property names must be\n                // double-quoted strings, and a `:` must separate each property\n                // name and value.\n                if (value == \",\" || typeof value != \"string\" || (charIndexBuggy ? value.charAt(0) : value[0]) != \"@\" || lex() != \":\") {\n                  abort();\n                }\n                results[value.slice(1)] = get(lex());\n              }\n              return results;\n            }\n            // Unexpected token encountered.\n            abort();\n          }\n          return value;\n        };\n\n        // Internal: Updates a traversed object member.\n        var update = function (source, property, callback) {\n          var element = walk(source, property, callback);\n          if (element === undef) {\n            delete source[property];\n          } else {\n            source[property] = element;\n          }\n        };\n\n        // Internal: Recursively traverses a parsed JSON object, invoking the\n        // `callback` function for each value. This is an implementation of the\n        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.\n        var walk = function (source, property, callback) {\n          var value = source[property], length;\n          if (typeof value == \"object\" && value) {\n            // `forEach` can't be used to traverse an array in Opera <= 8.54\n            // because its `Object#hasOwnProperty` implementation returns `false`\n            // for array indices (e.g., `![1, 2, 3].hasOwnProperty(\"0\")`).\n            if (getClass.call(value) == arrayClass) {\n              for (length = value.length; length--;) {\n                update(value, length, callback);\n              }\n            } else {\n              forEach(value, function (property) {\n                update(value, property, callback);\n              });\n            }\n          }\n          return callback.call(source, property, value);\n        };\n\n        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.\n        exports.parse = function (source, callback) {\n          var result, value;\n          Index = 0;\n          Source = \"\" + source;\n          result = get(lex());\n          // If a JSON string contains multiple tokens, it is invalid.\n          if (lex() != \"$\") {\n            abort();\n          }\n          // Reset the parser state.\n          Index = Source = null;\n          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[\"\"] = result, value), \"\", callback) : result;\n        };\n      }\n    }\n\n    exports[\"runInContext\"] = runInContext;\n    return exports;\n  }\n\n  if (freeExports && !isLoader) {\n    // Export for CommonJS environments.\n    runInContext(root, freeExports);\n  } else {\n    // Export for web browsers and JavaScript engines.\n    var nativeJSON = root.JSON,\n        previousJSON = root[\"JSON3\"],\n        isRestored = false;\n\n    var JSON3 = runInContext(root, (root[\"JSON3\"] = {\n      // Public: Restores the original value of the global `JSON` object and\n      // returns a reference to the `JSON3` object.\n      \"noConflict\": function () {\n        if (!isRestored) {\n          isRestored = true;\n          root.JSON = nativeJSON;\n          root[\"JSON3\"] = previousJSON;\n          nativeJSON = previousJSON = null;\n        }\n        return JSON3;\n      }\n    }));\n\n    root.JSON = {\n      \"parse\": JSON3.parse,\n      \"stringify\": JSON3.stringify\n    };\n  }\n\n  // Export for asynchronous module loaders.\n  if (isLoader) {\n    define(function () {\n      return JSON3;\n    });\n  }\n}).call(this);\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{}],31:[function(require,module,exports){\n(function (global){\n/**\r\n * JSON parse.\r\n *\r\n * @see Based on jQuery#parseJSON (MIT) and JSON2\r\n * @api private\r\n */\r\n\r\nvar rvalidchars = /^[\\],:{}\\s]*$/;\r\nvar rvalidescape = /\\\\(?:[\"\\\\\\/bfnrt]|u[0-9a-fA-F]{4})/g;\r\nvar rvalidtokens = /\"[^\"\\\\\\n\\r]*\"|true|false|null|-?\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?/g;\r\nvar rvalidbraces = /(?:^|:|,)(?:\\s*\\[)+/g;\r\nvar rtrimLeft = /^\\s+/;\r\nvar rtrimRight = /\\s+$/;\r\n\r\nmodule.exports = function parsejson(data) {\r\n  if ('string' != typeof data || !data) {\r\n    return null;\r\n  }\r\n\r\n  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');\r\n\r\n  // Attempt to parse using the native JSON parser first\r\n  if (global.JSON && JSON.parse) {\r\n    return JSON.parse(data);\r\n  }\r\n\r\n  if (rvalidchars.test(data.replace(rvalidescape, '@')\r\n      .replace(rvalidtokens, ']')\r\n      .replace(rvalidbraces, ''))) {\r\n    return (new Function('return ' + data))();\r\n  }\r\n};\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{}],32:[function(require,module,exports){\n/**\r\n * Compiles a querystring\r\n * Returns string representation of the object\r\n *\r\n * @param {Object}\r\n * @api private\r\n */\r\n\r\nexports.encode = function (obj) {\r\n  var str = '';\r\n\r\n  for (var i in obj) {\r\n    if (obj.hasOwnProperty(i)) {\r\n      if (str.length) str += '&';\r\n      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);\r\n    }\r\n  }\r\n\r\n  return str;\r\n};\r\n\r\n/**\r\n * Parses a simple querystring into an object\r\n *\r\n * @param {String} qs\r\n * @api private\r\n */\r\n\r\nexports.decode = function(qs){\r\n  var qry = {};\r\n  var pairs = qs.split('&');\r\n  for (var i = 0, l = pairs.length; i < l; i++) {\r\n    var pair = pairs[i].split('=');\r\n    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);\r\n  }\r\n  return qry;\r\n};\r\n\n},{}],33:[function(require,module,exports){\n/**\r\n * Parses an URI\r\n *\r\n * @author Steven Levithan <stevenlevithan.com> (MIT license)\r\n * @api private\r\n */\r\n\r\nvar re = /^(?:(?![^:@]+:[^:@\\/]*@)(http|https|ws|wss):\\/\\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\\/?#]*)(?::(\\d*))?)(((\\/(?:[^?#](?![^?#\\/]*\\.[^?#\\/.]+(?:[?#]|$)))*\\/?)?([^?#\\/]*))(?:\\?([^#]*))?(?:#(.*))?)/;\r\n\r\nvar parts = [\r\n    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'\r\n];\r\n\r\nmodule.exports = function parseuri(str) {\r\n    var src = str,\r\n        b = str.indexOf('['),\r\n        e = str.indexOf(']');\r\n\r\n    if (b != -1 && e != -1) {\r\n        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);\r\n    }\r\n\r\n    var m = re.exec(str || ''),\r\n        uri = {},\r\n        i = 14;\r\n\r\n    while (i--) {\r\n        uri[parts[i]] = m[i] || '';\r\n    }\r\n\r\n    if (b != -1 && e != -1) {\r\n        uri.source = src;\r\n        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');\r\n        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');\r\n        uri.ipv6uri = true;\r\n    }\r\n\r\n    return uri;\r\n};\r\n\n},{}],34:[function(require,module,exports){\n// shim for using process in browser\nvar process = module.exports = {};\n\n// cached from whatever global is present so that test runners that stub it\n// don't break things.  But we need to wrap it in a try catch in case it is\n// wrapped in strict mode code which doesn't define any globals.  It's inside a\n// function because try/catches deoptimize in certain engines.\n\nvar cachedSetTimeout;\nvar cachedClearTimeout;\n\nfunction defaultSetTimout() {\n    throw new Error('setTimeout has not been defined');\n}\nfunction defaultClearTimeout () {\n    throw new Error('clearTimeout has not been defined');\n}\n(function () {\n    try {\n        if (typeof setTimeout === 'function') {\n            cachedSetTimeout = setTimeout;\n        } else {\n            cachedSetTimeout = defaultSetTimout;\n        }\n    } catch (e) {\n        cachedSetTimeout = defaultSetTimout;\n    }\n    try {\n        if (typeof clearTimeout === 'function') {\n            cachedClearTimeout = clearTimeout;\n        } else {\n            cachedClearTimeout = defaultClearTimeout;\n        }\n    } catch (e) {\n        cachedClearTimeout = defaultClearTimeout;\n    }\n} ())\nfunction runTimeout(fun) {\n    if (cachedSetTimeout === setTimeout) {\n        //normal enviroments in sane situations\n        return setTimeout(fun, 0);\n    }\n    // if setTimeout wasn't available but was latter defined\n    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {\n        cachedSetTimeout = setTimeout;\n        return setTimeout(fun, 0);\n    }\n    try {\n        // when when somebody has screwed with setTimeout but no I.E. maddness\n        return cachedSetTimeout(fun, 0);\n    } catch(e){\n        try {\n            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally\n            return cachedSetTimeout.call(null, fun, 0);\n        } catch(e){\n            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error\n            return cachedSetTimeout.call(this, fun, 0);\n        }\n    }\n\n\n}\nfunction runClearTimeout(marker) {\n    if (cachedClearTimeout === clearTimeout) {\n        //normal enviroments in sane situations\n        return clearTimeout(marker);\n    }\n    // if clearTimeout wasn't available but was latter defined\n    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {\n        cachedClearTimeout = clearTimeout;\n        return clearTimeout(marker);\n    }\n    try {\n        // when when somebody has screwed with setTimeout but no I.E. maddness\n        return cachedClearTimeout(marker);\n    } catch (e){\n        try {\n            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally\n            return cachedClearTimeout.call(null, marker);\n        } catch (e){\n            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.\n            // Some versions of I.E. have different rules for clearTimeout vs setTimeout\n            return cachedClearTimeout.call(this, marker);\n        }\n    }\n\n\n\n}\nvar queue = [];\nvar draining = false;\nvar currentQueue;\nvar queueIndex = -1;\n\nfunction cleanUpNextTick() {\n    if (!draining || !currentQueue) {\n        return;\n    }\n    draining = false;\n    if (currentQueue.length) {\n        queue = currentQueue.concat(queue);\n    } else {\n        queueIndex = -1;\n    }\n    if (queue.length) {\n        drainQueue();\n    }\n}\n\nfunction drainQueue() {\n    if (draining) {\n        return;\n    }\n    var timeout = runTimeout(cleanUpNextTick);\n    draining = true;\n\n    var len = queue.length;\n    while(len) {\n        currentQueue = queue;\n        queue = [];\n        while (++queueIndex < len) {\n            if (currentQueue) {\n                currentQueue[queueIndex].run();\n            }\n        }\n        queueIndex = -1;\n        len = queue.length;\n    }\n    currentQueue = null;\n    draining = false;\n    runClearTimeout(timeout);\n}\n\nprocess.nextTick = function (fun) {\n    var args = new Array(arguments.length - 1);\n    if (arguments.length > 1) {\n        for (var i = 1; i < arguments.length; i++) {\n            args[i - 1] = arguments[i];\n        }\n    }\n    queue.push(new Item(fun, args));\n    if (queue.length === 1 && !draining) {\n        runTimeout(drainQueue);\n    }\n};\n\n// v8 likes predictible objects\nfunction Item(fun, array) {\n    this.fun = fun;\n    this.array = array;\n}\nItem.prototype.run = function () {\n    this.fun.apply(null, this.array);\n};\nprocess.title = 'browser';\nprocess.browser = true;\nprocess.env = {};\nprocess.argv = [];\nprocess.version = ''; // empty string to avoid regexp issues\nprocess.versions = {};\n\nfunction noop() {}\n\nprocess.on = noop;\nprocess.addListener = noop;\nprocess.once = noop;\nprocess.off = noop;\nprocess.removeListener = noop;\nprocess.removeAllListeners = noop;\nprocess.emit = noop;\n\nprocess.binding = function (name) {\n    throw new Error('process.binding is not supported');\n};\n\nprocess.cwd = function () { return '/' };\nprocess.chdir = function (dir) {\n    throw new Error('process.chdir is not supported');\n};\nprocess.umask = function() { return 0; };\n\n},{}],35:[function(require,module,exports){\n!function(e,t){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=t():\"function\"==typeof define&&define.amd?define([],t):\"object\"==typeof exports?exports.PubNub=t():e.PubNub=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return e[r].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p=\"\",t(0)}([function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}function o(e,t){if(!e)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!t||\"object\"!=typeof t&&\"function\"!=typeof t?e:t}function s(e,t){if(\"function\"!=typeof t&&null!==t)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){if(!navigator||!navigator.sendBeacon)return!1;navigator.sendBeacon(e)}Object.defineProperty(t,\"__esModule\",{value:!0});var u=n(1),c=r(u),l=n(40),h=r(l),f=n(41),d=r(f),p=n(42),g=(n(8),function(e){function t(e){i(this,t);var n=e.listenToBrowserNetworkEvents,r=void 0===n||n;e.db=d.default,e.sdkFamily=\"Web\",e.networking=new h.default({get:p.get,post:p.post,sendBeacon:a});var s=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r&&(window.addEventListener(\"offline\",function(){s.networkDownDetected()}),window.addEventListener(\"online\",function(){s.networkUpDetected()})),s}return s(t,e),t}(c.default));t.default=g,e.exports=t.default},function(e,t,n){\"use strict\";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function i(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(2),u=i(a),c=n(7),l=i(c),h=n(9),f=i(h),d=n(11),p=i(d),g=n(12),y=i(g),v=n(18),b=i(v),_=n(19),m=r(_),k=n(20),P=r(k),S=n(21),O=r(S),w=n(22),T=r(w),C=n(23),M=r(C),x=n(24),E=r(x),N=n(25),R=r(N),K=n(26),A=r(K),j=n(27),D=r(j),G=n(28),U=r(G),B=n(29),I=r(B),H=n(30),L=r(H),q=n(31),F=r(q),z=n(32),X=r(z),W=n(33),V=r(W),J=n(34),$=r(J),Q=n(35),Y=r(Q),Z=n(36),ee=r(Z),te=n(37),ne=r(te),re=n(38),ie=r(re),oe=n(15),se=r(oe),ae=n(39),ue=r(ae),ce=n(16),le=i(ce),he=n(13),fe=i(he),de=(n(8),function(){function e(t){var n=this;o(this,e);var r=t.db,i=t.networking,s=this._config=new l.default({setup:t,db:r}),a=new f.default({config:s});i.init(s);var u={config:s,networking:i,crypto:a},c=b.default.bind(this,u,se),h=b.default.bind(this,u,U),d=b.default.bind(this,u,L),g=b.default.bind(this,u,X),v=b.default.bind(this,u,ue),_=this._listenerManager=new y.default,k=new p.default({timeEndpoint:c,leaveEndpoint:h,heartbeatEndpoint:d,setStateEndpoint:g,subscribeEndpoint:v,crypto:u.crypto,config:u.config,listenerManager:_});this.addListener=_.addListener.bind(_),this.removeListener=_.removeListener.bind(_),this.removeAllListeners=_.removeAllListeners.bind(_),this.channelGroups={listGroups:b.default.bind(this,u,T),listChannels:b.default.bind(this,u,M),addChannels:b.default.bind(this,u,m),removeChannels:b.default.bind(this,u,P),deleteGroup:b.default.bind(this,u,O)},this.push={addChannels:b.default.bind(this,u,E),removeChannels:b.default.bind(this,u,R),deleteDevice:b.default.bind(this,u,D),listChannels:b.default.bind(this,u,A)},this.hereNow=b.default.bind(this,u,V),this.whereNow=b.default.bind(this,u,I),this.getState=b.default.bind(this,u,F),this.setState=k.adaptStateChange.bind(k),this.grant=b.default.bind(this,u,Y),this.audit=b.default.bind(this,u,$),this.publish=b.default.bind(this,u,ee),this.fire=function(e,t){e.replicate=!1,e.storeInHistory=!1,n.publish(e,t)},this.history=b.default.bind(this,u,ne),this.fetchMessages=b.default.bind(this,u,ie),this.time=c,this.subscribe=k.adaptSubscribeChange.bind(k),this.unsubscribe=k.adaptUnsubscribeChange.bind(k),this.disconnect=k.disconnect.bind(k),this.reconnect=k.reconnect.bind(k),this.destroy=function(e){k.unsubscribeAll(e),k.disconnect()},this.stop=this.destroy,this.unsubscribeAll=k.unsubscribeAll.bind(k),this.getSubscribedChannels=k.getSubscribedChannels.bind(k),this.getSubscribedChannelGroups=k.getSubscribedChannelGroups.bind(k),this.encrypt=a.encrypt.bind(a),this.decrypt=a.decrypt.bind(a),this.getAuthKey=u.config.getAuthKey.bind(u.config),this.setAuthKey=u.config.setAuthKey.bind(u.config),this.setCipherKey=u.config.setCipherKey.bind(u.config),this.getUUID=u.config.getUUID.bind(u.config),this.setUUID=u.config.setUUID.bind(u.config),this.getFilterExpression=u.config.getFilterExpression.bind(u.config),this.setFilterExpression=u.config.setFilterExpression.bind(u.config)}return s(e,[{key:\"getVersion\",value:function(){return this._config.getVersion()}},{key:\"networkDownDetected\",value:function(){this._listenerManager.announceNetworkDown(),this._config.restore?this.disconnect():this.destroy(!0)}},{key:\"networkUpDetected\",value:function(){this._listenerManager.announceNetworkUp(),this.reconnect()}}],[{key:\"generateUUID\",value:function(){return u.default.v4()}}]),e}());de.OPERATIONS=le.default,de.CATEGORIES=fe.default,t.default=de,e.exports=t.default},function(e,t,n){var r=n(3),i=n(6),o=i;o.v1=r,o.v4=i,e.exports=o},function(e,t,n){function r(e,t,n){var r=t&&n||0,i=t||[];e=e||{};var s=void 0!==e.clockseq?e.clockseq:u,h=void 0!==e.msecs?e.msecs:(new Date).getTime(),f=void 0!==e.nsecs?e.nsecs:l+1,d=h-c+(f-l)/1e4;if(d<0&&void 0===e.clockseq&&(s=s+1&16383),(d<0||h>c)&&void 0===e.nsecs&&(f=0),f>=1e4)throw new Error(\"uuid.v1(): Can't create more than 10M uuids/sec\");c=h,l=f,u=s,h+=122192928e5;var p=(1e4*(268435455&h)+f)%4294967296;i[r++]=p>>>24&255,i[r++]=p>>>16&255,i[r++]=p>>>8&255,i[r++]=255&p;var g=h/4294967296*1e4&268435455;i[r++]=g>>>8&255,i[r++]=255&g,i[r++]=g>>>24&15|16,i[r++]=g>>>16&255,i[r++]=s>>>8|128,i[r++]=255&s;for(var y=e.node||a,v=0;v<6;++v)i[r+v]=y[v];return t?t:o(i)}var i=n(4),o=n(5),s=i(),a=[1|s[0],s[1],s[2],s[3],s[4],s[5]],u=16383&(s[6]<<8|s[7]),c=0,l=0;e.exports=r},function(e,t){(function(t){var n,r=t.crypto||t.msCrypto;if(r&&r.getRandomValues){var i=new Uint8Array(16);n=function(){return r.getRandomValues(i),i}}if(!n){var o=new Array(16);n=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),o[t]=e>>>((3&t)<<3)&255;return o}}e.exports=n}).call(t,function(){return this}())},function(e,t){function n(e,t){var n=t||0,i=r;return i[e[n++]]+i[e[n++]]+i[e[n++]]+i[e[n++]]+\"-\"+i[e[n++]]+i[e[n++]]+\"-\"+i[e[n++]]+i[e[n++]]+\"-\"+i[e[n++]]+i[e[n++]]+\"-\"+i[e[n++]]+i[e[n++]]+i[e[n++]]+i[e[n++]]+i[e[n++]]+i[e[n++]]}for(var r=[],i=0;i<256;++i)r[i]=(i+256).toString(16).substr(1);e.exports=n},function(e,t,n){function r(e,t,n){var r=t&&n||0;\"string\"==typeof e&&(t=\"binary\"==e?new Array(16):null,e=null),e=e||{};var s=e.random||(e.rng||i)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,t)for(var a=0;a<16;++a)t[r+a]=s[a];return t||o(s)}var i=n(4),o=n(5);e.exports=r},function(e,t,n){\"use strict\";function r(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(2),s=function(e){return e&&e.__esModule?e:{default:e}}(o),a=(n(8),function(){function e(t){var n=t.setup,i=t.db;r(this,e),this._db=i,this.instanceId=\"pn-\"+s.default.v4(),this.secretKey=n.secretKey||n.secret_key,this.subscribeKey=n.subscribeKey||n.subscribe_key,this.publishKey=n.publishKey||n.publish_key,this.sdkFamily=n.sdkFamily,this.partnerId=n.partnerId,this.setAuthKey(n.authKey),this.setCipherKey(n.cipherKey),this.setFilterExpression(n.filterExpression),this.origin=n.origin||\"pubsub.pubnub.com\",this.secure=n.ssl||!1,this.restore=n.restore||!1,this.proxy=n.proxy,this.keepAlive=n.keepAlive,this.keepAliveSettings=n.keepAliveSettings,\"undefined\"!=typeof location&&\"https:\"===location.protocol&&(this.secure=!0),this.logVerbosity=n.logVerbosity||!1,this.suppressLeaveEvents=n.suppressLeaveEvents||!1,this.announceFailedHeartbeats=n.announceFailedHeartbeats||!0,this.announceSuccessfulHeartbeats=n.announceSuccessfulHeartbeats||!1,this.useInstanceId=n.useInstanceId||!1,this.useRequestId=n.useRequestId||!1,this.requestMessageCountThreshold=n.requestMessageCountThreshold,this.setTransactionTimeout(n.transactionalRequestTimeout||15e3),this.setSubscribeTimeout(n.subscribeRequestTimeout||31e4),this.setSendBeaconConfig(n.useSendBeacon||!0),this.setPresenceTimeout(n.presenceTimeout||300),n.heartbeatInterval&&this.setHeartbeatInterval(n.heartbeatInterval),this.setUUID(this._decideUUID(n.uuid))}return i(e,[{key:\"getAuthKey\",value:function(){return this.authKey}},{key:\"setAuthKey\",value:function(e){return this.authKey=e,this}},{key:\"setCipherKey\",value:function(e){return this.cipherKey=e,this}},{key:\"getUUID\",value:function(){return this.UUID}},{key:\"setUUID\",value:function(e){return this._db&&this._db.set&&this._db.set(this.subscribeKey+\"uuid\",e),this.UUID=e,this}},{key:\"getFilterExpression\",value:function(){return this.filterExpression}},{key:\"setFilterExpression\",value:function(e){return this.filterExpression=e,this}},{key:\"getPresenceTimeout\",value:function(){return this._presenceTimeout}},{key:\"setPresenceTimeout\",value:function(e){return this._presenceTimeout=e,this.setHeartbeatInterval(this._presenceTimeout/2-1),this}},{key:\"getHeartbeatInterval\",value:function(){return this._heartbeatInterval}},{key:\"setHeartbeatInterval\",value:function(e){return this._heartbeatInterval=e,this}},{key:\"getSubscribeTimeout\",value:function(){return this._subscribeRequestTimeout}},{key:\"setSubscribeTimeout\",value:function(e){return this._subscribeRequestTimeout=e,this}},{key:\"getTransactionTimeout\",value:function(){return this._transactionalRequestTimeout}},{key:\"setTransactionTimeout\",value:function(e){return this._transactionalRequestTimeout=e,this}},{key:\"isSendBeaconEnabled\",value:function(){return this._useSendBeacon}},{key:\"setSendBeaconConfig\",value:function(e){return this._useSendBeacon=e,this}},{key:\"getVersion\",value:function(){return\"4.8.0\"}},{key:\"_decideUUID\",value:function(e){return e?e:this._db&&this._db.get&&this._db.get(this.subscribeKey+\"uuid\")?this._db.get(this.subscribeKey+\"uuid\"):\"pn-\"+s.default.v4()}}]),e}());t.default=a,e.exports=t.default},function(e,t){\"use strict\";e.exports={}},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(7),a=(r(s),n(10)),u=r(a),c=function(){function e(t){var n=t.config;i(this,e),this._config=n,this._iv=\"0123456789012345\",this._allowedKeyEncodings=[\"hex\",\"utf8\",\"base64\",\"binary\"],this._allowedKeyLengths=[128,256],this._allowedModes=[\"ecb\",\"cbc\"],this._defaultOptions={encryptKey:!0,keyEncoding:\"utf8\",keyLength:256,mode:\"cbc\"}}return o(e,[{key:\"HMACSHA256\",value:function(e){return u.default.HmacSHA256(e,this._config.secretKey).toString(u.default.enc.Base64)}},{key:\"SHA256\",value:function(e){return u.default.SHA256(e).toString(u.default.enc.Hex)}},{key:\"_parseOptions\",value:function(e){var t=e||{};return t.hasOwnProperty(\"encryptKey\")||(t.encryptKey=this._defaultOptions.encryptKey),t.hasOwnProperty(\"keyEncoding\")||(t.keyEncoding=this._defaultOptions.keyEncoding),t.hasOwnProperty(\"keyLength\")||(t.keyLength=this._defaultOptions.keyLength),t.hasOwnProperty(\"mode\")||(t.mode=this._defaultOptions.mode),this._allowedKeyEncodings.indexOf(t.keyEncoding.toLowerCase())===-1&&(t.keyEncoding=this._defaultOptions.keyEncoding),this._allowedKeyLengths.indexOf(parseInt(t.keyLength,10))===-1&&(t.keyLength=this._defaultOptions.keyLength),this._allowedModes.indexOf(t.mode.toLowerCase())===-1&&(t.mode=this._defaultOptions.mode),t}},{key:\"_decodeKey\",value:function(e,t){return\"base64\"===t.keyEncoding?u.default.enc.Base64.parse(e):\"hex\"===t.keyEncoding?u.default.enc.Hex.parse(e):e}},{key:\"_getPaddedKey\",value:function(e,t){return e=this._decodeKey(e,t),t.encryptKey?u.default.enc.Utf8.parse(this.SHA256(e).slice(0,32)):e}},{key:\"_getMode\",value:function(e){return\"ecb\"===e.mode?u.default.mode.ECB:u.default.mode.CBC}},{key:\"_getIV\",value:function(e){return\"cbc\"===e.mode?u.default.enc.Utf8.parse(this._iv):null}},{key:\"encrypt\",value:function(e,t,n){if(!t&&!this._config.cipherKey)return e;n=this._parseOptions(n);var r=this._getIV(n),i=this._getMode(n),o=this._getPaddedKey(t||this._config.cipherKey,n);return u.default.AES.encrypt(e,o,{iv:r,mode:i}).ciphertext.toString(u.default.enc.Base64)||e}},{key:\"decrypt\",value:function(e,t,n){if(!t&&!this._config.cipherKey)return e;n=this._parseOptions(n);var r=this._getIV(n),i=this._getMode(n),o=this._getPaddedKey(t||this._config.cipherKey,n);try{var s=u.default.enc.Base64.parse(e),a=u.default.AES.decrypt({ciphertext:s},o,{iv:r,mode:i}).toString(u.default.enc.Utf8);return JSON.parse(a)}catch(e){return null}}}]),e}();t.default=c,e.exports=t.default},function(e,t){\"use strict\";var n=n||function(e,t){var n={},r=n.lib={},i=function(){},o=r.Base={extend:function(e){i.prototype=this;var t=new i;return e&&t.mixIn(e),t.hasOwnProperty(\"init\")||(t.init=function(){t.$super.init.apply(this,arguments)}),t.init.prototype=t,t.$super=this,t},create:function(){var e=this.extend();return e.init.apply(e,arguments),e},init:function(){},mixIn:function(e){for(var t in e)e.hasOwnProperty(t)&&(this[t]=e[t]);e.hasOwnProperty(\"toString\")&&(this.toString=e.toString)},clone:function(){return this.init.prototype.extend(this)}},s=r.WordArray=o.extend({init:function(e,t){e=this.words=e||[],this.sigBytes=void 0!=t?t:4*e.length},toString:function(e){return(e||u).stringify(this)},concat:function(e){var t=this.words,n=e.words,r=this.sigBytes;if(e=e.sigBytes,this.clamp(),r%4)for(var i=0;i<e;i++)t[r+i>>>2]|=(n[i>>>2]>>>24-i%4*8&255)<<24-(r+i)%4*8;else if(65535<n.length)for(i=0;i<e;i+=4)t[r+i>>>2]=n[i>>>2];else t.push.apply(t,n);return this.sigBytes+=e,this},clamp:function(){var t=this.words,n=this.sigBytes;t[n>>>2]&=4294967295<<32-n%4*8,t.length=e.ceil(n/4)},clone:function(){var e=o.clone.call(this);return e.words=this.words.slice(0),e},random:function(t){for(var n=[],r=0;r<t;r+=4)n.push(4294967296*e.random()|0);return new s.init(n,t)}}),a=n.enc={},u=a.Hex={stringify:function(e){var t=e.words;e=e.sigBytes;for(var n=[],r=0;r<e;r++){var i=t[r>>>2]>>>24-r%4*8&255;n.push((i>>>4).toString(16)),n.push((15&i).toString(16))}return n.join(\"\")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r+=2)n[r>>>3]|=parseInt(e.substr(r,2),16)<<24-r%8*4;return new s.init(n,t/2)}},c=a.Latin1={stringify:function(e){var t=e.words;e=e.sigBytes;for(var n=[],r=0;r<e;r++)n.push(String.fromCharCode(t[r>>>2]>>>24-r%4*8&255));return n.join(\"\")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r++)n[r>>>2]|=(255&e.charCodeAt(r))<<24-r%4*8;return new s.init(n,t)}},l=a.Utf8={stringify:function(e){try{return decodeURIComponent(escape(c.stringify(e)))}catch(e){throw Error(\"Malformed UTF-8 data\")}},parse:function(e){return c.parse(unescape(encodeURIComponent(e)))}},h=r.BufferedBlockAlgorithm=o.extend({reset:function(){this._data=new s.init,this._nDataBytes=0},_append:function(e){\"string\"==typeof e&&(e=l.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function(t){var n=this._data,r=n.words,i=n.sigBytes,o=this.blockSize,a=i/(4*o),a=t?e.ceil(a):e.max((0|a)-this._minBufferSize,0);if(t=a*o,i=e.min(4*t,i),t){for(var u=0;u<t;u+=o)this._doProcessBlock(r,u);u=r.splice(0,t),n.sigBytes-=i}return new s.init(u,i)},clone:function(){var e=o.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0});r.Hasher=h.extend({cfg:o.extend(),init:function(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function(){h.reset.call(this),this._doReset()},update:function(e){return this._append(e),this._process(),this},finalize:function(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function(e){return function(t,n){return new e.init(n).finalize(t)}},_createHmacHelper:function(e){return function(t,n){return new f.HMAC.init(e,n).finalize(t)}}});var f=n.algo={};return n}(Math);!function(e){for(var t=n,r=t.lib,i=r.WordArray,o=r.Hasher,r=t.algo,s=[],a=[],u=function(e){return 4294967296*(e-(0|e))|0},c=2,l=0;64>l;){var h;e:{h=c;for(var f=e.sqrt(h),d=2;d<=f;d++)if(!(h%d)){h=!1;break e}h=!0}h&&(8>l&&(s[l]=u(e.pow(c,.5))),a[l]=u(e.pow(c,1/3)),l++),c++}var p=[],r=r.SHA256=o.extend({_doReset:function(){this._hash=new i.init(s.slice(0))},_doProcessBlock:function(e,t){for(var n=this._hash.words,r=n[0],i=n[1],o=n[2],s=n[3],u=n[4],c=n[5],l=n[6],h=n[7],f=0;64>f;f++){if(16>f)p[f]=0|e[t+f];else{var d=p[f-15],g=p[f-2];p[f]=((d<<25|d>>>7)^(d<<14|d>>>18)^d>>>3)+p[f-7]+((g<<15|g>>>17)^(g<<13|g>>>19)^g>>>10)+p[f-16]}d=h+((u<<26|u>>>6)^(u<<21|u>>>11)^(u<<7|u>>>25))+(u&c^~u&l)+a[f]+p[f],g=((r<<30|r>>>2)^(r<<19|r>>>13)^(r<<10|r>>>22))+(r&i^r&o^i&o),h=l,l=c,c=u,u=s+d|0,s=o,o=i,i=r,r=d+g|0}n[0]=n[0]+r|0,n[1]=n[1]+i|0,n[2]=n[2]+o|0,n[3]=n[3]+s|0,n[4]=n[4]+u|0,n[5]=n[5]+c|0,n[6]=n[6]+l|0,n[7]=n[7]+h|0},_doFinalize:function(){var t=this._data,n=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;return n[i>>>5]|=128<<24-i%32,n[14+(i+64>>>9<<4)]=e.floor(r/4294967296),n[15+(i+64>>>9<<4)]=r,t.sigBytes=4*n.length,this._process(),this._hash},clone:function(){var e=o.clone.call(this);return e._hash=this._hash.clone(),e}});t.SHA256=o._createHelper(r),t.HmacSHA256=o._createHmacHelper(r)}(Math),function(){var e=n,t=e.enc.Utf8;e.algo.HMAC=e.lib.Base.extend({init:function(e,n){e=this._hasher=new e.init,\"string\"==typeof n&&(n=t.parse(n));var r=e.blockSize,i=4*r;n.sigBytes>i&&(n=e.finalize(n)),n.clamp();for(var o=this._oKey=n.clone(),s=this._iKey=n.clone(),a=o.words,u=s.words,c=0;c<r;c++)a[c]^=1549556828,u[c]^=909522486;o.sigBytes=s.sigBytes=i,this.reset()},reset:function(){var e=this._hasher;e.reset(),e.update(this._iKey)},update:function(e){return this._hasher.update(e),this},finalize:function(e){var t=this._hasher;return e=t.finalize(e),t.reset(),t.finalize(this._oKey.clone().concat(e))}})}(),function(){var e=n,t=e.lib.WordArray;e.enc.Base64={stringify:function(e){var t=e.words,n=e.sigBytes,r=this._map;e.clamp(),e=[];for(var i=0;i<n;i+=3)for(var o=(t[i>>>2]>>>24-i%4*8&255)<<16|(t[i+1>>>2]>>>24-(i+1)%4*8&255)<<8|t[i+2>>>2]>>>24-(i+2)%4*8&255,s=0;4>s&&i+.75*s<n;s++)e.push(r.charAt(o>>>6*(3-s)&63));if(t=r.charAt(64))for(;e.length%4;)e.push(t);return e.join(\"\")},parse:function(e){var n=e.length,r=this._map,i=r.charAt(64);i&&-1!=(i=e.indexOf(i))&&(n=i);for(var i=[],o=0,s=0;s<n;s++)if(s%4){var a=r.indexOf(e.charAt(s-1))<<s%4*2,u=r.indexOf(e.charAt(s))>>>6-s%4*2;i[o>>>2]|=(a|u)<<24-o%4*8,o++}return t.create(i,o)},_map:\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\"}}(),function(e){function t(e,t,n,r,i,o,s){return((e=e+(t&n|~t&r)+i+s)<<o|e>>>32-o)+t}function r(e,t,n,r,i,o,s){return((e=e+(t&r|n&~r)+i+s)<<o|e>>>32-o)+t}function i(e,t,n,r,i,o,s){return((e=e+(t^n^r)+i+s)<<o|e>>>32-o)+t}function o(e,t,n,r,i,o,s){return((e=e+(n^(t|~r))+i+s)<<o|e>>>32-o)+t}for(var s=n,a=s.lib,u=a.WordArray,c=a.Hasher,a=s.algo,l=[],h=0;64>h;h++)l[h]=4294967296*e.abs(e.sin(h+1))|0;a=a.MD5=c.extend({_doReset:function(){this._hash=new u.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(e,n){for(var s=0;16>s;s++){var a=n+s,u=e[a];e[a]=16711935&(u<<8|u>>>24)|4278255360&(u<<24|u>>>8)}var s=this._hash.words,a=e[n+0],u=e[n+1],c=e[n+2],h=e[n+3],f=e[n+4],d=e[n+5],p=e[n+6],g=e[n+7],y=e[n+8],v=e[n+9],b=e[n+10],_=e[n+11],m=e[n+12],k=e[n+13],P=e[n+14],S=e[n+15],O=s[0],w=s[1],T=s[2],C=s[3],O=t(O,w,T,C,a,7,l[0]),C=t(C,O,w,T,u,12,l[1]),T=t(T,C,O,w,c,17,l[2]),w=t(w,T,C,O,h,22,l[3]),O=t(O,w,T,C,f,7,l[4]),C=t(C,O,w,T,d,12,l[5]),T=t(T,C,O,w,p,17,l[6]),w=t(w,T,C,O,g,22,l[7]),O=t(O,w,T,C,y,7,l[8]),C=t(C,O,w,T,v,12,l[9]),T=t(T,C,O,w,b,17,l[10]),w=t(w,T,C,O,_,22,l[11]),O=t(O,w,T,C,m,7,l[12]),C=t(C,O,w,T,k,12,l[13]),T=t(T,C,O,w,P,17,l[14]),w=t(w,T,C,O,S,22,l[15]),O=r(O,w,T,C,u,5,l[16]),C=r(C,O,w,T,p,9,l[17]),T=r(T,C,O,w,_,14,l[18]),w=r(w,T,C,O,a,20,l[19]),O=r(O,w,T,C,d,5,l[20]),C=r(C,O,w,T,b,9,l[21]),T=r(T,C,O,w,S,14,l[22]),w=r(w,T,C,O,f,20,l[23]),O=r(O,w,T,C,v,5,l[24]),C=r(C,O,w,T,P,9,l[25]),T=r(T,C,O,w,h,14,l[26]),w=r(w,T,C,O,y,20,l[27]),O=r(O,w,T,C,k,5,l[28]),C=r(C,O,w,T,c,9,l[29]),T=r(T,C,O,w,g,14,l[30]),w=r(w,T,C,O,m,20,l[31]),O=i(O,w,T,C,d,4,l[32]),C=i(C,O,w,T,y,11,l[33]),T=i(T,C,O,w,_,16,l[34]),w=i(w,T,C,O,P,23,l[35]),O=i(O,w,T,C,u,4,l[36]),C=i(C,O,w,T,f,11,l[37]),T=i(T,C,O,w,g,16,l[38]),w=i(w,T,C,O,b,23,l[39]),O=i(O,w,T,C,k,4,l[40]),C=i(C,O,w,T,a,11,l[41]),T=i(T,C,O,w,h,16,l[42]),w=i(w,T,C,O,p,23,l[43]),O=i(O,w,T,C,v,4,l[44]),C=i(C,O,w,T,m,11,l[45]),T=i(T,C,O,w,S,16,l[46]),w=i(w,T,C,O,c,23,l[47]),O=o(O,w,T,C,a,6,l[48]),C=o(C,O,w,T,g,10,l[49]),T=o(T,C,O,w,P,15,l[50]),w=o(w,T,C,O,d,21,l[51]),O=o(O,w,T,C,m,6,l[52]),C=o(C,O,w,T,h,10,l[53]),T=o(T,C,O,w,b,15,l[54]),w=o(w,T,C,O,u,21,l[55]),O=o(O,w,T,C,y,6,l[56]),C=o(C,O,w,T,S,10,l[57]),T=o(T,C,O,w,p,15,l[58]),w=o(w,T,C,O,k,21,l[59]),O=o(O,w,T,C,f,6,l[60]),C=o(C,O,w,T,_,10,l[61]),T=o(T,C,O,w,c,15,l[62]),w=o(w,T,C,O,v,21,l[63]);s[0]=s[0]+O|0,s[1]=s[1]+w|0,s[2]=s[2]+T|0,s[3]=s[3]+C|0},_doFinalize:function(){var t=this._data,n=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;n[i>>>5]|=128<<24-i%32;var o=e.floor(r/4294967296);for(n[15+(i+64>>>9<<4)]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),n[14+(i+64>>>9<<4)]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8),t.sigBytes=4*(n.length+1),this._process(),t=this._hash,n=t.words,r=0;4>r;r++)i=n[r],n[r]=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8);return t},clone:function(){var e=c.clone.call(this);return e._hash=this._hash.clone(),e}}),s.MD5=c._createHelper(a),s.HmacMD5=c._createHmacHelper(a)}(Math),function(){var e=n,t=e.lib,r=t.Base,i=t.WordArray,t=e.algo,o=t.EvpKDF=r.extend({cfg:r.extend({keySize:4,hasher:t.MD5,iterations:1}),init:function(e){this.cfg=this.cfg.extend(e)},compute:function(e,t){for(var n=this.cfg,r=n.hasher.create(),o=i.create(),s=o.words,a=n.keySize,n=n.iterations;s.length<a;){u&&r.update(u);var u=r.update(e).finalize(t);r.reset();for(var c=1;c<n;c++)u=r.finalize(u),r.reset();o.concat(u)}return o.sigBytes=4*a,o}});e.EvpKDF=function(e,t,n){return o.create(n).compute(e,t)}}(),n.lib.Cipher||function(e){var t=n,r=t.lib,i=r.Base,o=r.WordArray,s=r.BufferedBlockAlgorithm,a=t.enc.Base64,u=t.algo.EvpKDF,c=r.Cipher=s.extend({cfg:i.extend(),createEncryptor:function(e,t){return this.create(this._ENC_XFORM_MODE,e,t)},createDecryptor:function(e,t){return this.create(this._DEC_XFORM_MODE,e,t)},init:function(e,t,n){this.cfg=this.cfg.extend(n),this._xformMode=e,this._key=t,this.reset()},reset:function(){s.reset.call(this),this._doReset()},process:function(e){return this._append(e),this._process()},finalize:function(e){return e&&this._append(e),this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(e){return{encrypt:function(t,n,r){return(\"string\"==typeof n?g:p).encrypt(e,t,n,r)},decrypt:function(t,n,r){return(\"string\"==typeof n?g:p).decrypt(e,t,n,r)}}}});r.StreamCipher=c.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var l=t.mode={},h=function(e,t,n){var r=this._iv;r?this._iv=void 0:r=this._prevBlock;for(var i=0;i<n;i++)e[t+i]^=r[i]},f=(r.BlockCipherMode=i.extend({createEncryptor:function(e,t){return this.Encryptor.create(e,t)},createDecryptor:function(e,t){return this.Decryptor.create(e,t)},init:function(e,t){this._cipher=e,this._iv=t}})).extend();f.Encryptor=f.extend({processBlock:function(e,t){var n=this._cipher,r=n.blockSize;h.call(this,e,t,r),n.encryptBlock(e,t),this._prevBlock=e.slice(t,t+r)}}),f.Decryptor=f.extend({processBlock:function(e,t){var n=this._cipher,r=n.blockSize,i=e.slice(t,t+r);n.decryptBlock(e,t),h.call(this,e,t,r),this._prevBlock=i}}),l=l.CBC=f,f=(t.pad={}).Pkcs7={pad:function(e,t){for(var n=4*t,n=n-e.sigBytes%n,r=n<<24|n<<16|n<<8|n,i=[],s=0;s<n;s+=4)i.push(r);n=o.create(i,n),e.concat(n)},unpad:function(e){e.sigBytes-=255&e.words[e.sigBytes-1>>>2]}},r.BlockCipher=c.extend({cfg:c.cfg.extend({mode:l,padding:f}),reset:function(){c.reset.call(this);var e=this.cfg,t=e.iv,e=e.mode;if(this._xformMode==this._ENC_XFORM_MODE)var n=e.createEncryptor;else n=e.createDecryptor,this._minBufferSize=1;this._mode=n.call(e,this,t&&t.words)},_doProcessBlock:function(e,t){this._mode.processBlock(e,t)},_doFinalize:function(){var e=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){e.pad(this._data,this.blockSize);var t=this._process(!0)}else t=this._process(!0),e.unpad(t);return t},blockSize:4});var d=r.CipherParams=i.extend({init:function(e){this.mixIn(e)},toString:function(e){return(e||this.formatter).stringify(this)}}),l=(t.format={}).OpenSSL={stringify:function(e){var t=e.ciphertext;return e=e.salt,(e?o.create([1398893684,1701076831]).concat(e).concat(t):t).toString(a)},parse:function(e){e=a.parse(e);var t=e.words;if(1398893684==t[0]&&1701076831==t[1]){var n=o.create(t.slice(2,4));t.splice(0,4),e.sigBytes-=16}return d.create({ciphertext:e,salt:n})}},p=r.SerializableCipher=i.extend({cfg:i.extend({format:l}),encrypt:function(e,t,n,r){r=this.cfg.extend(r);var i=e.createEncryptor(n,r);return t=i.finalize(t),i=i.cfg,d.create({ciphertext:t,key:n,iv:i.iv,algorithm:e,mode:i.mode,padding:i.padding,blockSize:e.blockSize,formatter:r.format})},decrypt:function(e,t,n,r){return r=this.cfg.extend(r),t=this._parse(t,r.format),e.createDecryptor(n,r).finalize(t.ciphertext)},_parse:function(e,t){return\"string\"==typeof e?t.parse(e,this):e}}),t=(t.kdf={}).OpenSSL={execute:function(e,t,n,r){return r||(r=o.random(8)),e=u.create({keySize:t+n}).compute(e,r),n=o.create(e.words.slice(t),4*n),e.sigBytes=4*t,d.create({key:e,iv:n,salt:r})}},g=r.PasswordBasedCipher=p.extend({cfg:p.cfg.extend({kdf:t}),encrypt:function(e,t,n,r){return r=this.cfg.extend(r),n=r.kdf.execute(n,e.keySize,e.ivSize),r.iv=n.iv,e=p.encrypt.call(this,e,t,n.key,r),e.mixIn(n),e},decrypt:function(e,t,n,r){return r=this.cfg.extend(r),t=this._parse(t,r.format),n=r.kdf.execute(n,e.keySize,e.ivSize,t.salt),r.iv=n.iv,p.decrypt.call(this,e,t,n.key,r)}})}(),function(){for(var e=n,t=e.lib.BlockCipher,r=e.algo,i=[],o=[],s=[],a=[],u=[],c=[],l=[],h=[],f=[],d=[],p=[],g=0;256>g;g++)p[g]=128>g?g<<1:g<<1^283;for(var y=0,v=0,g=0;256>g;g++){var b=v^v<<1^v<<2^v<<3^v<<4,b=b>>>8^255&b^99;i[y]=b,o[b]=y;var _=p[y],m=p[_],k=p[m],P=257*p[b]^16843008*b;s[y]=P<<24|P>>>8,a[y]=P<<16|P>>>16,u[y]=P<<8|P>>>24,c[y]=P,P=16843009*k^65537*m^257*_^16843008*y,l[b]=P<<24|P>>>8,h[b]=P<<16|P>>>16,f[b]=P<<8|P>>>24,d[b]=P,y?(y=_^p[p[p[k^_]]],v^=p[p[v]]):y=v=1}var S=[0,1,2,4,8,16,32,64,128,27,54],r=r.AES=t.extend({_doReset:function(){for(var e=this._key,t=e.words,n=e.sigBytes/4,e=4*((this._nRounds=n+6)+1),r=this._keySchedule=[],o=0;o<e;o++)if(o<n)r[o]=t[o];else{var s=r[o-1];o%n?6<n&&4==o%n&&(s=i[s>>>24]<<24|i[s>>>16&255]<<16|i[s>>>8&255]<<8|i[255&s]):(s=s<<8|s>>>24,s=i[s>>>24]<<24|i[s>>>16&255]<<16|i[s>>>8&255]<<8|i[255&s],s^=S[o/n|0]<<24),r[o]=r[o-n]^s}for(t=this._invKeySchedule=[],n=0;n<e;n++)o=e-n,s=n%4?r[o]:r[o-4],t[n]=4>n||4>=o?s:l[i[s>>>24]]^h[i[s>>>16&255]]^f[i[s>>>8&255]]^d[i[255&s]]},encryptBlock:function(e,t){this._doCryptBlock(e,t,this._keySchedule,s,a,u,c,i)},decryptBlock:function(e,t){var n=e[t+1];e[t+1]=e[t+3],e[t+3]=n,this._doCryptBlock(e,t,this._invKeySchedule,l,h,f,d,o),n=e[t+1],e[t+1]=e[t+3],e[t+3]=n},_doCryptBlock:function(e,t,n,r,i,o,s,a){for(var u=this._nRounds,c=e[t]^n[0],l=e[t+1]^n[1],h=e[t+2]^n[2],f=e[t+3]^n[3],d=4,p=1;p<u;p++)var g=r[c>>>24]^i[l>>>16&255]^o[h>>>8&255]^s[255&f]^n[d++],y=r[l>>>24]^i[h>>>16&255]^o[f>>>8&255]^s[255&c]^n[d++],v=r[h>>>24]^i[f>>>16&255]^o[c>>>8&255]^s[255&l]^n[d++],f=r[f>>>24]^i[c>>>16&255]^o[l>>>8&255]^s[255&h]^n[d++],c=g,l=y,h=v;g=(a[c>>>24]<<24|a[l>>>16&255]<<16|a[h>>>8&255]<<8|a[255&f])^n[d++],y=(a[l>>>24]<<24|a[h>>>16&255]<<16|a[f>>>8&255]<<8|a[255&c])^n[d++],v=(a[h>>>24]<<24|a[f>>>16&255]<<16|a[c>>>8&255]<<8|a[255&l])^n[d++],f=(a[f>>>24]<<24|a[c>>>16&255]<<16|a[l>>>8&255]<<8|a[255&h])^n[d++],e[t]=g,e[t+1]=y,e[t+2]=v,e[t+3]=f},keySize:8});e.AES=t._createHelper(r)}(),n.mode.ECB=function(){var e=n.lib.BlockCipherMode.extend();return e.Encryptor=e.extend({processBlock:function(e,t){this._cipher.encryptBlock(e,t)}}),e.Decryptor=e.extend({processBlock:function(e,t){this._cipher.decryptBlock(e,t)}}),e}(),e.exports=n},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(9),a=(r(s),n(7)),u=(r(a),n(12)),c=(r(u),n(14)),l=r(c),h=n(17),f=r(h),d=(n(8),n(13)),p=r(d),g=function(){function e(t){var n=t.subscribeEndpoint,r=t.leaveEndpoint,o=t.heartbeatEndpoint,s=t.setStateEndpoint,a=t.timeEndpoint,u=t.config,c=t.crypto,h=t.listenerManager;i(this,e),this._listenerManager=h,this._config=u,this._leaveEndpoint=r,this._heartbeatEndpoint=o,this._setStateEndpoint=s,this._subscribeEndpoint=n,this._crypto=c,this._channels={},this._presenceChannels={},this._channelGroups={},this._presenceChannelGroups={},this._pendingChannelSubscriptions=[],this._pendingChannelGroupSubscriptions=[],this._currentTimetoken=0,this._lastTimetoken=0,this._subscriptionStatusAnnounced=!1,this._reconnectionManager=new l.default({timeEndpoint:a})}return o(e,[{key:\"adaptStateChange\",value:function(e,t){var n=this,r=e.state,i=e.channels,o=void 0===i?[]:i,s=e.channelGroups,a=void 0===s?[]:s;return o.forEach(function(e){e in n._channels&&(n._channels[e].state=r)}),a.forEach(function(e){e in n._channelGroups&&(n._channelGroups[e].state=r)}),this._setStateEndpoint({state:r,channels:o,channelGroups:a},t)}},{key:\"adaptSubscribeChange\",value:function(e){var t=this,n=e.timetoken,r=e.channels,i=void 0===r?[]:r,o=e.channelGroups,s=void 0===o?[]:o,a=e.withPresence,u=void 0!==a&&a;if(!this._config.subscribeKey||\"\"===this._config.subscribeKey)return void(console&&console.log&&console.log(\"subscribe key missing; aborting subscribe\"));n&&(this._lastTimetoken=this._currentTimetoken,this._currentTimetoken=n),i.forEach(function(e){t._channels[e]={state:{}},u&&(t._presenceChannels[e]={}),t._pendingChannelSubscriptions.push(e)}),s.forEach(function(e){t._channelGroups[e]={state:{}},u&&(t._presenceChannelGroups[e]={}),t._pendingChannelGroupSubscriptions.push(e)}),this._subscriptionStatusAnnounced=!1,this.reconnect()}},{key:\"adaptUnsubscribeChange\",value:function(e,t){var n=this,r=e.channels,i=void 0===r?[]:r,o=e.channelGroups,s=void 0===o?[]:o;i.forEach(function(e){e in n._channels&&delete n._channels[e],e in n._presenceChannels&&delete n._presenceChannels[e]}),s.forEach(function(e){e in n._channelGroups&&delete n._channelGroups[e],e in n._presenceChannelGroups&&delete n._channelGroups[e]}),this._config.suppressLeaveEvents!==!1||t||this._leaveEndpoint({channels:i,channelGroups:s},function(e){e.affectedChannels=i,e.affectedChannelGroups=s,e.currentTimetoken=n._currentTimetoken,\ne.lastTimetoken=n._lastTimetoken,n._listenerManager.announceStatus(e)}),0===Object.keys(this._channels).length&&0===Object.keys(this._presenceChannels).length&&0===Object.keys(this._channelGroups).length&&0===Object.keys(this._presenceChannelGroups).length&&(this._lastTimetoken=0,this._currentTimetoken=0,this._region=null,this._reconnectionManager.stopPolling()),this.reconnect()}},{key:\"unsubscribeAll\",value:function(e){this.adaptUnsubscribeChange({channels:this.getSubscribedChannels(),channelGroups:this.getSubscribedChannelGroups()},e)}},{key:\"getSubscribedChannels\",value:function(){return Object.keys(this._channels)}},{key:\"getSubscribedChannelGroups\",value:function(){return Object.keys(this._channelGroups)}},{key:\"reconnect\",value:function(){this._startSubscribeLoop(),this._registerHeartbeatTimer()}},{key:\"disconnect\",value:function(){this._stopSubscribeLoop(),this._stopHeartbeatTimer(),this._reconnectionManager.stopPolling()}},{key:\"_registerHeartbeatTimer\",value:function(){this._stopHeartbeatTimer(),this._performHeartbeatLoop(),this._heartbeatTimer=setInterval(this._performHeartbeatLoop.bind(this),1e3*this._config.getHeartbeatInterval())}},{key:\"_stopHeartbeatTimer\",value:function(){this._heartbeatTimer&&(clearInterval(this._heartbeatTimer),this._heartbeatTimer=null)}},{key:\"_performHeartbeatLoop\",value:function(){var e=this,t=Object.keys(this._channels),n=Object.keys(this._channelGroups),r={};if(0!==t.length||0!==n.length){t.forEach(function(t){var n=e._channels[t].state;Object.keys(n).length&&(r[t]=n)}),n.forEach(function(t){var n=e._channelGroups[t].state;Object.keys(n).length&&(r[t]=n)});var i=function(t){t.error&&e._config.announceFailedHeartbeats&&e._listenerManager.announceStatus(t),!t.error&&e._config.announceSuccessfulHeartbeats&&e._listenerManager.announceStatus(t)};this._heartbeatEndpoint({channels:t,channelGroups:n,state:r},i.bind(this))}}},{key:\"_startSubscribeLoop\",value:function(){this._stopSubscribeLoop();var e=[],t=[];if(Object.keys(this._channels).forEach(function(t){return e.push(t)}),Object.keys(this._presenceChannels).forEach(function(t){return e.push(t+\"-pnpres\")}),Object.keys(this._channelGroups).forEach(function(e){return t.push(e)}),Object.keys(this._presenceChannelGroups).forEach(function(e){return t.push(e+\"-pnpres\")}),0!==e.length||0!==t.length){var n={channels:e,channelGroups:t,timetoken:this._currentTimetoken,filterExpression:this._config.filterExpression,region:this._region};this._subscribeCall=this._subscribeEndpoint(n,this._processSubscribeResponse.bind(this))}}},{key:\"_processSubscribeResponse\",value:function(e,t){var n=this;if(e.error)return void(e.category===p.default.PNTimeoutCategory?this._startSubscribeLoop():e.category===p.default.PNNetworkIssuesCategory?(this.disconnect(),this._reconnectionManager.onReconnection(function(){n.reconnect(),n._subscriptionStatusAnnounced=!0;var t={category:p.default.PNReconnectedCategory,operation:e.operation,lastTimetoken:n._lastTimetoken,currentTimetoken:n._currentTimetoken};n._listenerManager.announceStatus(t)}),this._reconnectionManager.startPolling(),this._listenerManager.announceStatus(e)):this._listenerManager.announceStatus(e));if(this._lastTimetoken=this._currentTimetoken,this._currentTimetoken=t.metadata.timetoken,!this._subscriptionStatusAnnounced){var r={};r.category=p.default.PNConnectedCategory,r.operation=e.operation,r.affectedChannels=this._pendingChannelSubscriptions,r.affectedChannelGroups=this._pendingChannelGroupSubscriptions,r.lastTimetoken=this._lastTimetoken,r.currentTimetoken=this._currentTimetoken,this._subscriptionStatusAnnounced=!0,this._listenerManager.announceStatus(r),this._pendingChannelSubscriptions=[],this._pendingChannelGroupSubscriptions=[]}var i=t.messages||[],o=this._config.requestMessageCountThreshold;if(o&&i.length>=o){var s={};s.category=p.default.PNRequestMessageCountExceededCategory,s.operation=e.operation,this._listenerManager.announceStatus(s)}i.forEach(function(e){var t=e.channel,r=e.subscriptionMatch,i=e.publishMetaData;if(t===r&&(r=null),f.default.endsWith(e.channel,\"-pnpres\")){var o={};o.channel=null,o.subscription=null,o.actualChannel=null!=r?t:null,o.subscribedChannel=null!=r?r:t,t&&(o.channel=t.substring(0,t.lastIndexOf(\"-pnpres\"))),r&&(o.subscription=r.substring(0,r.lastIndexOf(\"-pnpres\"))),o.action=e.payload.action,o.state=e.payload.data,o.timetoken=i.publishTimetoken,o.occupancy=e.payload.occupancy,o.uuid=e.payload.uuid,o.timestamp=e.payload.timestamp,e.payload.join&&(o.join=e.payload.join),e.payload.leave&&(o.leave=e.payload.leave),e.payload.timeout&&(o.timeout=e.payload.timeout),n._listenerManager.announcePresence(o)}else{var s={};s.channel=null,s.subscription=null,s.actualChannel=null!=r?t:null,s.subscribedChannel=null!=r?r:t,s.channel=t,s.subscription=r,s.timetoken=i.publishTimetoken,s.publisher=e.issuingClientId,n._config.cipherKey?s.message=n._crypto.decrypt(e.payload):s.message=e.payload,n._listenerManager.announceMessage(s)}}),this._region=t.metadata.region,this._startSubscribeLoop()}},{key:\"_stopSubscribeLoop\",value:function(){this._subscribeCall&&(this._subscribeCall.abort(),this._subscribeCall=null)}}]),e}();t.default=g,e.exports=t.default},function(e,t,n){\"use strict\";function r(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=(n(8),n(13)),s=function(e){return e&&e.__esModule?e:{default:e}}(o),a=function(){function e(){r(this,e),this._listeners=[]}return i(e,[{key:\"addListener\",value:function(e){this._listeners.push(e)}},{key:\"removeListener\",value:function(e){var t=[];this._listeners.forEach(function(n){n!==e&&t.push(n)}),this._listeners=t}},{key:\"removeAllListeners\",value:function(){this._listeners=[]}},{key:\"announcePresence\",value:function(e){this._listeners.forEach(function(t){t.presence&&t.presence(e)})}},{key:\"announceStatus\",value:function(e){this._listeners.forEach(function(t){t.status&&t.status(e)})}},{key:\"announceMessage\",value:function(e){this._listeners.forEach(function(t){t.message&&t.message(e)})}},{key:\"announceNetworkUp\",value:function(){var e={};e.category=s.default.PNNetworkUpCategory,this.announceStatus(e)}},{key:\"announceNetworkDown\",value:function(){var e={};e.category=s.default.PNNetworkDownCategory,this.announceStatus(e)}}]),e}();t.default=a,e.exports=t.default},function(e,t){\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.default={PNNetworkUpCategory:\"PNNetworkUpCategory\",PNNetworkDownCategory:\"PNNetworkDownCategory\",PNNetworkIssuesCategory:\"PNNetworkIssuesCategory\",PNTimeoutCategory:\"PNTimeoutCategory\",PNBadRequestCategory:\"PNBadRequestCategory\",PNAccessDeniedCategory:\"PNAccessDeniedCategory\",PNUnknownCategory:\"PNUnknownCategory\",PNReconnectedCategory:\"PNReconnectedCategory\",PNConnectedCategory:\"PNConnectedCategory\",PNRequestMessageCountExceededCategory:\"PNRequestMessageCountExceededCategory\"},e.exports=t.default},function(e,t,n){\"use strict\";function r(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(15),s=(function(e){e&&e.__esModule?e:{default:e}}(o),n(8),function(){function e(t){var n=t.timeEndpoint;r(this,e),this._timeEndpoint=n}return i(e,[{key:\"onReconnection\",value:function(e){this._reconnectionCallback=e}},{key:\"startPolling\",value:function(){this._timeTimer=setInterval(this._performTimeLoop.bind(this),3e3)}},{key:\"stopPolling\",value:function(){clearInterval(this._timeTimer)}},{key:\"_performTimeLoop\",value:function(){var e=this;this._timeEndpoint(function(t){t.error||(clearInterval(e._timeTimer),e._reconnectionCallback())})}}]),e}());t.default=s,e.exports=t.default},function(e,t,n){\"use strict\";function r(){return h.default.PNTimeOperation}function i(){return\"/time/0\"}function o(e){return e.config.getTransactionTimeout()}function s(){return{}}function a(){return!1}function u(e,t){return{timetoken:t[0]}}function c(){}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.getURL=i,t.getRequestTimeout=o,t.prepareParams=s,t.isAuthSupported=a,t.handleResponse=u,t.validateParams=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t){\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.default={PNTimeOperation:\"PNTimeOperation\",PNHistoryOperation:\"PNHistoryOperation\",PNFetchMessagesOperation:\"PNFetchMessagesOperation\",PNSubscribeOperation:\"PNSubscribeOperation\",PNUnsubscribeOperation:\"PNUnsubscribeOperation\",PNPublishOperation:\"PNPublishOperation\",PNPushNotificationEnabledChannelsOperation:\"PNPushNotificationEnabledChannelsOperation\",PNRemoveAllPushNotificationsOperation:\"PNRemoveAllPushNotificationsOperation\",PNWhereNowOperation:\"PNWhereNowOperation\",PNSetStateOperation:\"PNSetStateOperation\",PNHereNowOperation:\"PNHereNowOperation\",PNGetStateOperation:\"PNGetStateOperation\",PNHeartbeatOperation:\"PNHeartbeatOperation\",PNChannelGroupsOperation:\"PNChannelGroupsOperation\",PNRemoveGroupOperation:\"PNRemoveGroupOperation\",PNChannelsForGroupOperation:\"PNChannelsForGroupOperation\",PNAddChannelsToGroupOperation:\"PNAddChannelsToGroupOperation\",PNRemoveChannelsFromGroupOperation:\"PNRemoveChannelsFromGroupOperation\",PNAccessManagerGrant:\"PNAccessManagerGrant\",PNAccessManagerAudit:\"PNAccessManagerAudit\"},e.exports=t.default},function(e,t){\"use strict\";function n(e){var t=[];return Object.keys(e).forEach(function(e){return t.push(e)}),t}function r(e){return encodeURIComponent(e).replace(/[!~*'()]/g,function(e){return\"%\"+e.charCodeAt(0).toString(16).toUpperCase()})}function i(e){return n(e).sort()}function o(e){return i(e).map(function(t){return t+\"=\"+r(e[t])}).join(\"&\")}function s(e,t){return e.indexOf(t,this.length-t.length)!==-1}function a(){var e=void 0,t=void 0;return{promise:new Promise(function(n,r){e=n,t=r}),reject:t,fulfill:e}}e.exports={signPamFromParams:o,endsWith:s,createPromise:a,encodeString:r}},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}function o(e,t){if(!e)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!t||\"object\"!=typeof t&&\"function\"!=typeof t?e:t}function s(e,t){if(\"function\"!=typeof t&&null!==t)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){return e.type=t,e.error=!0,e}function u(e){return a({message:e},\"validationError\")}function c(e,t,n){return e.usePost&&e.usePost(t,n)?e.postURL(t,n):e.getURL(t,n)}function l(e){var t=\"PubNub-JS-\"+e.sdkFamily;return e.partnerId&&(t+=\"-\"+e.partnerId),t+=\"/\"+e.getVersion()}function h(e,t,n){var r=e.config,i=e.crypto;n.timestamp=Math.floor((new Date).getTime()/1e3);var o=r.subscribeKey+\"\\n\"+r.publishKey+\"\\n\"+t+\"\\n\";o+=g.default.signPamFromParams(n);var s=i.HMACSHA256(o);s=s.replace(/\\+/g,\"-\"),s=s.replace(/\\//g,\"_\"),n.signature=s}Object.defineProperty(t,\"__esModule\",{value:!0}),t.default=function(e,t){var n=e.networking,r=e.config,i=null,o=null,s={};t.getOperation()===b.default.PNTimeOperation||t.getOperation()===b.default.PNChannelGroupsOperation?i=arguments.length<=2?void 0:arguments[2]:(s=arguments.length<=2?void 0:arguments[2],i=arguments.length<=3?void 0:arguments[3]),\"undefined\"==typeof Promise||i||(o=g.default.createPromise());var a=t.validateParams(e,s);if(!a){var f=t.prepareParams(e,s),p=c(t,e,s),y=void 0,v={url:p,operation:t.getOperation(),timeout:t.getRequestTimeout(e)};f.uuid=r.UUID,f.pnsdk=l(r),r.useInstanceId&&(f.instanceid=r.instanceId),r.useRequestId&&(f.requestid=d.default.v4()),t.isAuthSupported()&&r.getAuthKey()&&(f.auth=r.getAuthKey()),r.secretKey&&h(e,p,f);var m=function(n,r){if(n.error)return void(i?i(n):o&&o.reject(new _(\"PubNub call failed, check status for details\",n)));var a=t.handleResponse(e,r,s);i?i(n,a):o&&o.fulfill(a)};if(t.usePost&&t.usePost(e,s)){var k=t.postPayload(e,s);y=n.POST(f,k,v,m)}else y=n.GET(f,v,m);return t.getOperation()===b.default.PNSubscribeOperation?y:o?o.promise:void 0}return i?i(u(a)):o?(o.reject(new _(\"Validation failed, check status for details\",u(a))),o.promise):void 0};var f=n(2),d=r(f),p=(n(8),n(17)),g=r(p),y=n(7),v=(r(y),n(16)),b=r(v),_=function(e){function t(e,n){i(this,t);var r=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.name=r.constructor.name,r.status=n,r.message=e,r}return s(t,e),t}(Error);e.exports=t.default},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNAddChannelsToGroupOperation}function o(e,t){var n=t.channels,r=t.channelGroup,i=e.config;return r?n&&0!==n.length?i.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing Channels\":\"Missing Channel Group\"}function s(e,t){var n=t.channelGroup;return\"/v1/channel-registration/sub-key/\"+e.config.subscribeKey+\"/channel-group/\"+p.default.encodeString(n)}function a(e){return e.config.getTransactionTimeout()}function u(){return!0}function c(e,t){var n=t.channels;return{add:(void 0===n?[]:n).join(\",\")}}function l(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNRemoveChannelsFromGroupOperation}function o(e,t){var n=t.channels,r=t.channelGroup,i=e.config;return r?n&&0!==n.length?i.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing Channels\":\"Missing Channel Group\"}function s(e,t){var n=t.channelGroup;return\"/v1/channel-registration/sub-key/\"+e.config.subscribeKey+\"/channel-group/\"+p.default.encodeString(n)}function a(e){return e.config.getTransactionTimeout()}function u(){return!0}function c(e,t){var n=t.channels;return{remove:(void 0===n?[]:n).join(\",\")}}function l(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNRemoveGroupOperation}function o(e,t){var n=t.channelGroup,r=e.config;return n?r.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing Channel Group\"}function s(e,t){var n=t.channelGroup;return\"/v1/channel-registration/sub-key/\"+e.config.subscribeKey+\"/channel-group/\"+p.default.encodeString(n)+\"/remove\"}function a(){return!0}function u(e){return e.config.getTransactionTimeout()}function c(){return{}}function l(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.isAuthSupported=a,t.getRequestTimeout=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(){return h.default.PNChannelGroupsOperation}function i(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function o(e){return\"/v1/channel-registration/sub-key/\"+e.config.subscribeKey+\"/channel-group\"}function s(e){return e.config.getTransactionTimeout()}function a(){return!0}function u(){return{}}function c(e,t){return{groups:t.payload.groups}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNChannelsForGroupOperation}function o(e,t){var n=t.channelGroup,r=e.config;return n?r.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing Channel Group\"}function s(e,t){var n=t.channelGroup;return\"/v1/channel-registration/sub-key/\"+e.config.subscribeKey+\"/channel-group/\"+p.default.encodeString(n)}function a(e){return e.config.getTransactionTimeout()}function u(){return!0}function c(){return{}}function l(e,t){return{channels:t.payload.channels}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(){return h.default.PNPushNotificationEnabledChannelsOperation}function i(e,t){var n=t.device,r=t.pushGateway,i=t.channels,o=e.config;return n?r?i&&0!==i.length?o.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing Channels\":\"Missing GW Type (pushGateway: gcm or apns)\":\"Missing Device ID (device)\"}function o(e,t){var n=t.device;return\"/v1/push/sub-key/\"+e.config.subscribeKey+\"/devices/\"+n}function s(e){return e.config.getTransactionTimeout()}function a(){return!0}function u(e,t){var n=t.pushGateway,r=t.channels;return{type:n,add:(void 0===r?[]:r).join(\",\")}}function c(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(){return h.default.PNPushNotificationEnabledChannelsOperation}function i(e,t){var n=t.device,r=t.pushGateway,i=t.channels,o=e.config;return n?r?i&&0!==i.length?o.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing Channels\":\"Missing GW Type (pushGateway: gcm or apns)\":\"Missing Device ID (device)\"}function o(e,t){var n=t.device;return\"/v1/push/sub-key/\"+e.config.subscribeKey+\"/devices/\"+n}function s(e){return e.config.getTransactionTimeout()}function a(){return!0}function u(e,t){var n=t.pushGateway,r=t.channels;return{type:n,remove:(void 0===r?[]:r).join(\",\")}}function c(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(){return h.default.PNPushNotificationEnabledChannelsOperation}function i(e,t){var n=t.device,r=t.pushGateway,i=e.config;return n?r?i.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing GW Type (pushGateway: gcm or apns)\":\"Missing Device ID (device)\"}function o(e,t){var n=t.device;return\"/v1/push/sub-key/\"+e.config.subscribeKey+\"/devices/\"+n}function s(e){return e.config.getTransactionTimeout()}function a(){return!0}function u(e,t){return{type:t.pushGateway}}function c(e,t){return{channels:t}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(){return h.default.PNRemoveAllPushNotificationsOperation}function i(e,t){var n=t.device,r=t.pushGateway,i=e.config;return n?r?i.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing GW Type (pushGateway: gcm or apns)\":\"Missing Device ID (device)\"}function o(e,t){var n=t.device;return\"/v1/push/sub-key/\"+e.config.subscribeKey+\"/devices/\"+n+\"/remove\"}function s(e){return e.config.getTransactionTimeout()}function a(){return!0}function u(e,t){return{type:t.pushGateway}}function c(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNUnsubscribeOperation}function o(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function s(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,o=i.length>0?i.join(\",\"):\",\";return\"/v2/presence/sub-key/\"+n.subscribeKey+\"/channel/\"+p.default.encodeString(o)+\"/leave\"}function a(e){return e.config.getTransactionTimeout()}function u(){return!0}function c(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i={};return r.length>0&&(i[\"channel-group\"]=r.join(\",\")),i}function l(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(){return h.default.PNWhereNowOperation}function i(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function o(e,t){var n=e.config,r=t.uuid,i=void 0===r?n.UUID:r;return\"/v2/presence/sub-key/\"+n.subscribeKey+\"/uuid/\"+i}function s(e){return e.config.getTransactionTimeout()}function a(){return!0}function u(){return{}}function c(e,t){return{channels:t.payload.channels}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNHeartbeatOperation}function o(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function s(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,o=i.length>0?i.join(\",\"):\",\";return\"/v2/presence/sub-key/\"+n.subscribeKey+\"/channel/\"+p.default.encodeString(o)+\"/heartbeat\"}function a(){return!0}function u(e){return e.config.getTransactionTimeout()}function c(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i=t.state,o=void 0===i?{}:i,s=e.config,a={};return r.length>0&&(a[\"channel-group\"]=r.join(\",\")),a.state=JSON.stringify(o),a.heartbeat=s.getPresenceTimeout(),a}function l(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.isAuthSupported=a,t.getRequestTimeout=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNGetStateOperation}function o(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function s(e,t){var n=e.config,r=t.uuid,i=void 0===r?n.UUID:r,o=t.channels,s=void 0===o?[]:o,a=s.length>0?s.join(\",\"):\",\";return\"/v2/presence/sub-key/\"+n.subscribeKey+\"/channel/\"+p.default.encodeString(a)+\"/uuid/\"+i}function a(e){return e.config.getTransactionTimeout()}function u(){return!0}function c(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i={};return r.length>0&&(i[\"channel-group\"]=r.join(\",\")),i}function l(e,t,n){var r=n.channels,i=void 0===r?[]:r,o=n.channelGroups,s=void 0===o?[]:o,a={};return 1===i.length&&0===s.length?a[i[0]]=t.payload:a=t.payload,{channels:a}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNSetStateOperation}function o(e,t){var n=e.config,r=t.state,i=t.channels,o=void 0===i?[]:i,s=t.channelGroups,a=void 0===s?[]:s;return r?n.subscribeKey?0===o.length&&0===a.length?\"Please provide a list of channels and/or channel-groups\":void 0:\"Missing Subscribe Key\":\"Missing State\"}function s(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,o=i.length>0?i.join(\",\"):\",\";return\"/v2/presence/sub-key/\"+n.subscribeKey+\"/channel/\"+p.default.encodeString(o)+\"/uuid/\"+n.UUID+\"/data\"}function a(e){return e.config.getTransactionTimeout()}function u(){return!0}function c(e,t){var n=t.state,r=t.channelGroups,i=void 0===r?[]:r,o={};return o.state=JSON.stringify(n),i.length>0&&(o[\"channel-group\"]=i.join(\",\")),o}function l(e,t){return{state:t.payload}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNHereNowOperation}function o(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function s(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,o=t.channelGroups,s=void 0===o?[]:o,a=\"/v2/presence/sub-key/\"+n.subscribeKey;if(i.length>0||s.length>0){var u=i.length>0?i.join(\",\"):\",\";a+=\"/channel/\"+p.default.encodeString(u)}return a}function a(e){return e.config.getTransactionTimeout()}function u(){return!0}function c(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i=t.includeUUIDs,o=void 0===i||i,s=t.includeState,a=void 0!==s&&s,u={};return o||(u.disable_uuids=1),a&&(u.state=1),r.length>0&&(u[\"channel-group\"]=r.join(\",\")),u}function l(e,t,n){var r=n.channels,i=void 0===r?[]:r,o=n.channelGroups,s=void 0===o?[]:o,a=n.includeUUIDs,u=void 0===a||a,c=n.includeState,l=void 0!==c&&c;return i.length>1||s.length>0||0===s.length&&0===i.length?function(){var e={};return e.totalChannels=t.payload.total_channels,e.totalOccupancy=t.payload.total_occupancy,e.channels={},Object.keys(t.payload.channels).forEach(function(n){var r=t.payload.channels[n],i=[];return e.channels[n]={occupants:i,name:n,occupancy:r.occupancy},u&&r.uuids.forEach(function(e){l?i.push({state:e.state,uuid:e.uuid}):i.push({state:null,uuid:e})}),e}),e}():function(){var e={},n=[];return e.totalChannels=1,e.totalOccupancy=t.occupancy,e.channels={},e.channels[i[0]]={occupants:n,name:i[0],occupancy:t.occupancy},u&&t.uuids.forEach(function(e){l?n.push({state:e.state,uuid:e.uuid}):n.push({state:null,uuid:e})}),e}()}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(){return h.default.PNAccessManagerAudit}function i(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function o(e){return\"/v2/auth/audit/sub-key/\"+e.config.subscribeKey}function s(e){return e.config.getTransactionTimeout()}function a(){return!1}function u(e,t){var n=t.channel,r=t.channelGroup,i=t.authKeys,o=void 0===i?[]:i,s={};return n&&(s.channel=n),r&&(s[\"channel-group\"]=r),o.length>0&&(s.auth=o.join(\",\")),s}function c(e,t){return t.payload}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(){return h.default.PNAccessManagerGrant}function i(e){var t=e.config;return t.subscribeKey?t.publishKey?t.secretKey?void 0:\"Missing Secret Key\":\"Missing Publish Key\":\"Missing Subscribe Key\"}function o(e){return\"/v2/auth/grant/sub-key/\"+e.config.subscribeKey}function s(e){return e.config.getTransactionTimeout()}function a(){return!1}function u(e,t){var n=t.channels,r=void 0===n?[]:n,i=t.channelGroups,o=void 0===i?[]:i,s=t.ttl,a=t.read,u=void 0!==a&&a,c=t.write,l=void 0!==c&&c,h=t.manage,f=void 0!==h&&h,d=t.authKeys,p=void 0===d?[]:d,g={};return g.r=u?\"1\":\"0\",g.w=l?\"1\":\"0\",g.m=f?\"1\":\"0\",r.length>0&&(g.channel=r.join(\",\")),o.length>0&&(g[\"channel-group\"]=o.join(\",\")),p.length>0&&(g.auth=p.join(\",\")),(s||0===s)&&(g.ttl=s),g}function c(){return{}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=r,t.validateParams=i,t.getURL=o,t.getRequestTimeout=s,t.isAuthSupported=a,t.prepareParams=u,t.handleResponse=c;var l=(n(8),n(16)),h=function(e){return e&&e.__esModule?e:{default:e}}(l)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){var n=e.crypto,r=e.config,i=JSON.stringify(t);return r.cipherKey&&(i=n.encrypt(i),i=JSON.stringify(i)),i}function o(){return v.default.PNPublishOperation}function s(e,t){var n=e.config,r=t.message;return t.channel?r?n.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing Message\":\"Missing Channel\"}function a(e,t){var n=t.sendByPost;return void 0!==n&&n}function u(e,t){var n=e.config,r=t.channel,o=t.message,s=i(e,o);return\"/publish/\"+n.publishKey+\"/\"+n.subscribeKey+\"/0/\"+_.default.encodeString(r)+\"/0/\"+_.default.encodeString(s)}function c(e,t){var n=e.config,r=t.channel;return\"/publish/\"+n.publishKey+\"/\"+n.subscribeKey+\"/0/\"+_.default.encodeString(r)+\"/0\"}function l(e){return e.config.getTransactionTimeout()}function h(){return!0}function f(e,t){return i(e,t.message)}function d(e,t){var n=t.meta,r=t.replicate,i=void 0===r||r,o=t.storeInHistory,s=t.ttl,a={};return null!=o&&(a.store=o?\"1\":\"0\"),s&&(a.ttl=s),i===!1&&(a.norep=\"true\"),n&&\"object\"===(void 0===n?\"undefined\":g(n))&&(a.meta=JSON.stringify(n)),a}function p(e,t){return{timetoken:t[2]}}Object.defineProperty(t,\"__esModule\",{value:!0});var g=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&\"function\"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?\"symbol\":typeof e};t.getOperation=o,t.validateParams=s,t.usePost=a,t.getURL=u,t.postURL=c,t.getRequestTimeout=l,t.isAuthSupported=h,t.postPayload=f,t.prepareParams=d,t.handleResponse=p;var y=(n(8),n(16)),v=r(y),b=n(17),_=r(b)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){var n=e.config,r=e.crypto;if(!n.cipherKey)return t;try{return r.decrypt(t)}catch(e){return t}}function o(){return d.default.PNHistoryOperation}function s(e,t){var n=t.channel,r=e.config;return n?r.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing channel\"}function a(e,t){var n=t.channel;return\"/v2/history/sub-key/\"+e.config.subscribeKey+\"/channel/\"+g.default.encodeString(n)}function u(e){return e.config.getTransactionTimeout()}function c(){return!0}function l(e,t){var n=t.start,r=t.end,i=t.reverse,o=t.count,s=void 0===o?100:o,a=t.stringifiedTimeToken,u=void 0!==a&&a,c={include_token:\"true\"};return c.count=s,n&&(c.start=n),r&&(c.end=r),u&&(c.string_message_token=\"true\"),null!=i&&(c.reverse=i.toString()),c}function h(e,t){var n={messages:[],startTimeToken:t[1],endTimeToken:t[2]};return t[0].forEach(function(t){var r={timetoken:t.timetoken,entry:i(e,t.message)};n.messages.push(r)}),n}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=o,t.validateParams=s,t.getURL=a,t.getRequestTimeout=u,t.isAuthSupported=c,t.prepareParams=l,t.handleResponse=h;var f=(n(8),n(16)),d=r(f),p=n(17),g=r(p)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){var n=e.config,r=e.crypto;if(!n.cipherKey)return t;try{return r.decrypt(t)}catch(e){return t}}function o(){return d.default.PNFetchMessagesOperation}function s(e,t){var n=t.channels,r=e.config;return n&&0!==n.length?r.subscribeKey?void 0:\"Missing Subscribe Key\":\"Missing channels\"}function a(e,t){var n=t.channels,r=void 0===n?[]:n,i=e.config,o=r.length>0?r.join(\",\"):\",\";return\"/v3/history/sub-key/\"+i.subscribeKey+\"/channel/\"+g.default.encodeString(o)}function u(e){return e.config.getTransactionTimeout()}function c(){return!0}function l(e,t){var n=t.start,r=t.end,i=t.count,o={};return i&&(o.max=i),n&&(o.start=n),r&&(o.end=r),o}function h(e,t){var n={channels:{}}\n;return Object.keys(t.channels||{}).forEach(function(r){n.channels[r]=[],(t.channels[r]||[]).forEach(function(t){var o={};o.channel=r,o.subscription=null,o.timetoken=t.timetoken,o.message=i(e,t.message),n.channels[r].push(o)})}),n}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=o,t.validateParams=s,t.getURL=a,t.getRequestTimeout=u,t.isAuthSupported=c,t.prepareParams=l,t.handleResponse=h;var f=(n(8),n(16)),d=r(f),p=n(17),g=r(p)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(){return f.default.PNSubscribeOperation}function o(e){if(!e.config.subscribeKey)return\"Missing Subscribe Key\"}function s(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,o=i.length>0?i.join(\",\"):\",\";return\"/v2/subscribe/\"+n.subscribeKey+\"/\"+p.default.encodeString(o)+\"/0\"}function a(e){return e.config.getSubscribeTimeout()}function u(){return!0}function c(e,t){var n=e.config,r=t.channelGroups,i=void 0===r?[]:r,o=t.timetoken,s=t.filterExpression,a=t.region,u={heartbeat:n.getPresenceTimeout()};return i.length>0&&(u[\"channel-group\"]=i.join(\",\")),s&&s.length>0&&(u[\"filter-expr\"]=s),o&&(u.tt=o),a&&(u.tr=a),u}function l(e,t){var n=[];t.m.forEach(function(e){var t={publishTimetoken:e.p.t,region:e.p.r},r={shard:parseInt(e.a,10),subscriptionMatch:e.b,channel:e.c,payload:e.d,flags:e.f,issuingClientId:e.i,subscribeKey:e.k,originationTimetoken:e.o,publishMetaData:t};n.push(r)});var r={timetoken:t.t.t,region:t.t.r};return{messages:n,metadata:r}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getOperation=i,t.validateParams=o,t.getURL=s,t.getRequestTimeout=a,t.isAuthSupported=u,t.prepareParams=c,t.handleResponse=l;var h=(n(8),n(16)),f=r(h),d=n(17),p=r(d)},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(7),a=(r(s),n(13)),u=r(a),c=(n(8),function(){function e(t){var n=this;i(this,e),this._modules={},Object.keys(t).forEach(function(e){n._modules[e]=t[e].bind(n)})}return o(e,[{key:\"init\",value:function(e){this._config=e,this._maxSubDomain=20,this._currentSubDomain=Math.floor(Math.random()*this._maxSubDomain),this._providedFQDN=(this._config.secure?\"https://\":\"http://\")+this._config.origin,this._coreParams={},this.shiftStandardOrigin()}},{key:\"nextOrigin\",value:function(){if(this._providedFQDN.indexOf(\"pubsub.\")===-1)return this._providedFQDN;var e=void 0;return this._currentSubDomain=this._currentSubDomain+1,this._currentSubDomain>=this._maxSubDomain&&(this._currentSubDomain=1),e=this._currentSubDomain.toString(),this._providedFQDN.replace(\"pubsub\",\"ps\"+e)}},{key:\"shiftStandardOrigin\",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return this._standardOrigin=this.nextOrigin(e),this._standardOrigin}},{key:\"getStandardOrigin\",value:function(){return this._standardOrigin}},{key:\"POST\",value:function(e,t,n,r){return this._modules.post(e,t,n,r)}},{key:\"GET\",value:function(e,t,n){return this._modules.get(e,t,n)}},{key:\"_detectErrorCategory\",value:function(e){if(\"ENOTFOUND\"===e.code)return u.default.PNNetworkIssuesCategory;if(\"ECONNREFUSED\"===e.code)return u.default.PNNetworkIssuesCategory;if(\"ECONNRESET\"===e.code)return u.default.PNNetworkIssuesCategory;if(\"EAI_AGAIN\"===e.code)return u.default.PNNetworkIssuesCategory;if(0===e.status||e.hasOwnProperty(\"status\")&&void 0===e.status)return u.default.PNNetworkIssuesCategory;if(e.timeout)return u.default.PNTimeoutCategory;if(e.response){if(e.response.badRequest)return u.default.PNBadRequestCategory;if(e.response.forbidden)return u.default.PNAccessDeniedCategory}return u.default.PNUnknownCategory}}]),e}());t.default=c,e.exports=t.default},function(e,t){\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.default={get:function(e){try{return localStorage.getItem(e)}catch(e){return null}},set:function(e,t){try{return localStorage.setItem(e,t)}catch(e){return null}}},e.exports=t.default},function(e,t,n){\"use strict\";function r(e){var t=(new Date).getTime(),n=(new Date).toISOString(),r=function(){return console&&console.log?console:window&&window.console&&window.console.log?window.console:console}();r.log(\"<<<<<\"),r.log(\"[\"+n+\"]\",\"\\n\",e.url,\"\\n\",e.qs),r.log(\"-----\"),e.on(\"response\",function(n){var i=(new Date).getTime(),o=i-t,s=(new Date).toISOString();r.log(\">>>>>>\"),r.log(\"[\"+s+\" / \"+o+\"]\",\"\\n\",e.url,\"\\n\",e.qs,\"\\n\",n.text),r.log(\"-----\")})}function i(e,t,n){var i=this;return this._config.logVerbosity&&(e=e.use(r)),this._config.proxy&&this._modules.proxy&&(e=this._modules.proxy.call(this,e)),this._config.keepAlive&&this._modules.keepAlive&&(e=this._module.keepAlive(e)),e.timeout(t.timeout).end(function(e,r){var o={};if(o.error=null!==e,o.operation=t.operation,r&&r.status&&(o.statusCode=r.status),e)return o.errorData=e,o.category=i._detectErrorCategory(e),n(o,null);var s=JSON.parse(r.text);return n(o,s)})}function o(e,t,n){var r=u.default.get(this.getStandardOrigin()+t.url).query(e);return i.call(this,r,t,n)}function s(e,t,n,r){var o=u.default.post(this.getStandardOrigin()+n.url).query(e).send(t);return i.call(this,o,n,r)}Object.defineProperty(t,\"__esModule\",{value:!0}),t.get=o,t.post=s;var a=n(43),u=function(e){return e&&e.__esModule?e:{default:e}}(a);n(8)},function(e,t,n){function r(){}function i(e){if(!v(e))return e;var t=[];for(var n in e)o(t,n,e[n]);return t.join(\"&\")}function o(e,t,n){if(null!=n)if(Array.isArray(n))n.forEach(function(n){o(e,t,n)});else if(v(n))for(var r in n)o(e,t+\"[\"+r+\"]\",n[r]);else e.push(encodeURIComponent(t)+\"=\"+encodeURIComponent(n));else null===n&&e.push(encodeURIComponent(t))}function s(e){for(var t,n,r={},i=e.split(\"&\"),o=0,s=i.length;o<s;++o)t=i[o],n=t.indexOf(\"=\"),n==-1?r[decodeURIComponent(t)]=\"\":r[decodeURIComponent(t.slice(0,n))]=decodeURIComponent(t.slice(n+1));return r}function a(e){var t,n,r,i,o=e.split(/\\r?\\n/),s={};o.pop();for(var a=0,u=o.length;a<u;++a)n=o[a],t=n.indexOf(\":\"),r=n.slice(0,t).toLowerCase(),i=_(n.slice(t+1)),s[r]=i;return s}function u(e){return/[\\/+]json\\b/.test(e)}function c(e){return e.split(/ *; */).shift()}function l(e){return e.split(/ *; */).reduce(function(e,t){var n=t.split(/ *= */),r=n.shift(),i=n.shift();return r&&i&&(e[r]=i),e},{})}function h(e,t){t=t||{},this.req=e,this.xhr=this.req.xhr,this.text=\"HEAD\"!=this.req.method&&(\"\"===this.xhr.responseType||\"text\"===this.xhr.responseType)||void 0===this.xhr.responseType?this.xhr.responseText:null,this.statusText=this.req.xhr.statusText,this._setStatusProperties(this.xhr.status),this.header=this.headers=a(this.xhr.getAllResponseHeaders()),this.header[\"content-type\"]=this.xhr.getResponseHeader(\"content-type\"),this._setHeaderProperties(this.header),this.body=\"HEAD\"!=this.req.method?this._parseBody(this.text?this.text:this.xhr.response):null}function f(e,t){var n=this;this._query=this._query||[],this.method=e,this.url=t,this.header={},this._header={},this.on(\"end\",function(){var e=null,t=null;try{t=new h(n)}catch(t){return e=new Error(\"Parser is unable to parse the response\"),e.parse=!0,e.original=t,e.rawResponse=n.xhr&&n.xhr.responseText?n.xhr.responseText:null,e.statusCode=n.xhr&&n.xhr.status?n.xhr.status:null,n.callback(e)}n.emit(\"response\",t);var r;try{(t.status<200||t.status>=300)&&(r=new Error(t.statusText||\"Unsuccessful HTTP response\"),r.original=e,r.response=t,r.status=t.status)}catch(e){r=e}r?n.callback(r,t):n.callback(null,t)})}function d(e,t){var n=b(\"DELETE\",e);return t&&n.end(t),n}var p;\"undefined\"!=typeof window?p=window:\"undefined\"!=typeof self?p=self:(console.warn(\"Using browser-only version of superagent in non-browser environment\"),p=this);var g=n(44),y=n(45),v=n(46),b=e.exports=n(47).bind(null,f);b.getXHR=function(){if(!(!p.XMLHttpRequest||p.location&&\"file:\"==p.location.protocol&&p.ActiveXObject))return new XMLHttpRequest;try{return new ActiveXObject(\"Microsoft.XMLHTTP\")}catch(e){}try{return new ActiveXObject(\"Msxml2.XMLHTTP.6.0\")}catch(e){}try{return new ActiveXObject(\"Msxml2.XMLHTTP.3.0\")}catch(e){}try{return new ActiveXObject(\"Msxml2.XMLHTTP\")}catch(e){}throw Error(\"Browser-only verison of superagent could not find XHR\")};var _=\"\".trim?function(e){return e.trim()}:function(e){return e.replace(/(^\\s*|\\s*$)/g,\"\")};b.serializeObject=i,b.parseString=s,b.types={html:\"text/html\",json:\"application/json\",xml:\"application/xml\",urlencoded:\"application/x-www-form-urlencoded\",form:\"application/x-www-form-urlencoded\",\"form-data\":\"application/x-www-form-urlencoded\"},b.serialize={\"application/x-www-form-urlencoded\":i,\"application/json\":JSON.stringify},b.parse={\"application/x-www-form-urlencoded\":s,\"application/json\":JSON.parse},h.prototype.get=function(e){return this.header[e.toLowerCase()]},h.prototype._setHeaderProperties=function(e){var t=this.header[\"content-type\"]||\"\";this.type=c(t);var n=l(t);for(var r in n)this[r]=n[r]},h.prototype._parseBody=function(e){var t=b.parse[this.type];return!t&&u(this.type)&&(t=b.parse[\"application/json\"]),t&&e&&(e.length||e instanceof Object)?t(e):null},h.prototype._setStatusProperties=function(e){1223===e&&(e=204);var t=e/100|0;this.status=this.statusCode=e,this.statusType=t,this.info=1==t,this.ok=2==t,this.clientError=4==t,this.serverError=5==t,this.error=(4==t||5==t)&&this.toError(),this.accepted=202==e,this.noContent=204==e,this.badRequest=400==e,this.unauthorized=401==e,this.notAcceptable=406==e,this.notFound=404==e,this.forbidden=403==e},h.prototype.toError=function(){var e=this.req,t=e.method,n=e.url,r=\"cannot \"+t+\" \"+n+\" (\"+this.status+\")\",i=new Error(r);return i.status=this.status,i.method=t,i.url=n,i},b.Response=h,g(f.prototype);for(var m in y)f.prototype[m]=y[m];f.prototype.type=function(e){return this.set(\"Content-Type\",b.types[e]||e),this},f.prototype.responseType=function(e){return this._responseType=e,this},f.prototype.accept=function(e){return this.set(\"Accept\",b.types[e]||e),this},f.prototype.auth=function(e,t,n){switch(n||(n={type:\"basic\"}),n.type){case\"basic\":var r=btoa(e+\":\"+t);this.set(\"Authorization\",\"Basic \"+r);break;case\"auto\":this.username=e,this.password=t}return this},f.prototype.query=function(e){return\"string\"!=typeof e&&(e=i(e)),e&&this._query.push(e),this},f.prototype.attach=function(e,t,n){return this._getFormData().append(e,t,n||t.name),this},f.prototype._getFormData=function(){return this._formData||(this._formData=new p.FormData),this._formData},f.prototype.callback=function(e,t){var n=this._callback;this.clearTimeout(),n(e,t)},f.prototype.crossDomainError=function(){var e=new Error(\"Request has been terminated\\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.\");e.crossDomain=!0,e.status=this.status,e.method=this.method,e.url=this.url,this.callback(e)},f.prototype._timeoutError=function(){var e=this._timeout,t=new Error(\"timeout of \"+e+\"ms exceeded\");t.timeout=e,this.callback(t)},f.prototype._appendQueryString=function(){var e=this._query.join(\"&\");e&&(this.url+=~this.url.indexOf(\"?\")?\"&\"+e:\"?\"+e)},f.prototype.end=function(e){var t=this,n=this.xhr=b.getXHR(),i=this._timeout,o=this._formData||this._data;this._callback=e||r,n.onreadystatechange=function(){if(4==n.readyState){var e;try{e=n.status}catch(t){e=0}if(0==e){if(t.timedout)return t._timeoutError();if(t._aborted)return;return t.crossDomainError()}t.emit(\"end\")}};var s=function(e,n){n.total>0&&(n.percent=n.loaded/n.total*100),n.direction=e,t.emit(\"progress\",n)};if(this.hasListeners(\"progress\"))try{n.onprogress=s.bind(null,\"download\"),n.upload&&(n.upload.onprogress=s.bind(null,\"upload\"))}catch(e){}if(i&&!this._timer&&(this._timer=setTimeout(function(){t.timedout=!0,t.abort()},i)),this._appendQueryString(),this.username&&this.password?n.open(this.method,this.url,!0,this.username,this.password):n.open(this.method,this.url,!0),this._withCredentials&&(n.withCredentials=!0),\"GET\"!=this.method&&\"HEAD\"!=this.method&&\"string\"!=typeof o&&!this._isHost(o)){var a=this._header[\"content-type\"],c=this._serializer||b.serialize[a?a.split(\";\")[0]:\"\"];!c&&u(a)&&(c=b.serialize[\"application/json\"]),c&&(o=c(o))}for(var l in this.header)null!=this.header[l]&&n.setRequestHeader(l,this.header[l]);return this._responseType&&(n.responseType=this._responseType),this.emit(\"request\",this),n.send(void 0!==o?o:null),this},b.Request=f,b.get=function(e,t,n){var r=b(\"GET\",e);return\"function\"==typeof t&&(n=t,t=null),t&&r.query(t),n&&r.end(n),r},b.head=function(e,t,n){var r=b(\"HEAD\",e);return\"function\"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r},b.options=function(e,t,n){var r=b(\"OPTIONS\",e);return\"function\"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r},b.del=d,b.delete=d,b.patch=function(e,t,n){var r=b(\"PATCH\",e);return\"function\"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r},b.post=function(e,t,n){var r=b(\"POST\",e);return\"function\"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r},b.put=function(e,t,n){var r=b(\"PUT\",e);return\"function\"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r}},function(e,t,n){function r(e){if(e)return i(e)}function i(e){for(var t in r.prototype)e[t]=r.prototype[t];return e}e.exports=r,r.prototype.on=r.prototype.addEventListener=function(e,t){return this._callbacks=this._callbacks||{},(this._callbacks[\"$\"+e]=this._callbacks[\"$\"+e]||[]).push(t),this},r.prototype.once=function(e,t){function n(){this.off(e,n),t.apply(this,arguments)}return n.fn=t,this.on(e,n),this},r.prototype.off=r.prototype.removeListener=r.prototype.removeAllListeners=r.prototype.removeEventListener=function(e,t){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var n=this._callbacks[\"$\"+e];if(!n)return this;if(1==arguments.length)return delete this._callbacks[\"$\"+e],this;for(var r,i=0;i<n.length;i++)if((r=n[i])===t||r.fn===t){n.splice(i,1);break}return this},r.prototype.emit=function(e){this._callbacks=this._callbacks||{};var t=[].slice.call(arguments,1),n=this._callbacks[\"$\"+e];if(n){n=n.slice(0);for(var r=0,i=n.length;r<i;++r)n[r].apply(this,t)}return this},r.prototype.listeners=function(e){return this._callbacks=this._callbacks||{},this._callbacks[\"$\"+e]||[]},r.prototype.hasListeners=function(e){return!!this.listeners(e).length}},function(e,t,n){var r=n(46);t.clearTimeout=function(){return this._timeout=0,clearTimeout(this._timer),this},t.parse=function(e){return this._parser=e,this},t.serialize=function(e){return this._serializer=e,this},t.timeout=function(e){return this._timeout=e,this},t.then=function(e,t){if(!this._fullfilledPromise){var n=this;this._fullfilledPromise=new Promise(function(e,t){n.end(function(n,r){n?t(n):e(r)})})}return this._fullfilledPromise.then(e,t)},t.catch=function(e){return this.then(void 0,e)},t.use=function(e){return e(this),this},t.get=function(e){return this._header[e.toLowerCase()]},t.getHeader=t.get,t.set=function(e,t){if(r(e)){for(var n in e)this.set(n,e[n]);return this}return this._header[e.toLowerCase()]=t,this.header[e]=t,this},t.unset=function(e){return delete this._header[e.toLowerCase()],delete this.header[e],this},t.field=function(e,t){if(null===e||void 0===e)throw new Error(\".field(name, val) name can not be empty\");if(r(e)){for(var n in e)this.field(n,e[n]);return this}if(null===t||void 0===t)throw new Error(\".field(name, val) val can not be empty\");return this._getFormData().append(e,t),this},t.abort=function(){return this._aborted?this:(this._aborted=!0,this.xhr&&this.xhr.abort(),this.req&&this.req.abort(),this.clearTimeout(),this.emit(\"abort\"),this)},t.withCredentials=function(){return this._withCredentials=!0,this},t.redirects=function(e){return this._maxRedirects=e,this},t.toJSON=function(){return{method:this.method,url:this.url,data:this._data,headers:this._header}},t._isHost=function(e){switch({}.toString.call(e)){case\"[object File]\":case\"[object Blob]\":case\"[object FormData]\":return!0;default:return!1}},t.send=function(e){var t=r(e),n=this._header[\"content-type\"];if(t&&r(this._data))for(var i in e)this._data[i]=e[i];else\"string\"==typeof e?(n||this.type(\"form\"),n=this._header[\"content-type\"],this._data=\"application/x-www-form-urlencoded\"==n?this._data?this._data+\"&\"+e:e:(this._data||\"\")+e):this._data=e;return!t||this._isHost(e)?this:(n||this.type(\"json\"),this)}},function(e,t){function n(e){return null!==e&&\"object\"==typeof e}e.exports=n},function(e,t){function n(e,t,n){return\"function\"==typeof n?new e(\"GET\",t).end(n):2==arguments.length?new e(\"GET\",t):new e(t,n)}e.exports=n}])});\n},{}],36:[function(require,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar url = require('./url');\nvar parser = require('socket.io-parser');\nvar Manager = require('./manager');\nvar debug = require('debug')('socket.io-client');\n\n/**\n * Module exports.\n */\n\nmodule.exports = exports = lookup;\n\n/**\n * Managers cache.\n */\n\nvar cache = exports.managers = {};\n\n/**\n * Looks up an existing `Manager` for multiplexing.\n * If the user summons:\n *\n *   `io('http://localhost/a');`\n *   `io('http://localhost/b');`\n *\n * We reuse the existing instance based on same scheme/port/host,\n * and we initialize sockets for each namespace.\n *\n * @api public\n */\n\nfunction lookup (uri, opts) {\n  if (typeof uri === 'object') {\n    opts = uri;\n    uri = undefined;\n  }\n\n  opts = opts || {};\n\n  var parsed = url(uri);\n  var source = parsed.source;\n  var id = parsed.id;\n  var path = parsed.path;\n  var sameNamespace = cache[id] && path in cache[id].nsps;\n  var newConnection = opts.forceNew || opts['force new connection'] ||\n                      false === opts.multiplex || sameNamespace;\n\n  var io;\n\n  if (newConnection) {\n    debug('ignoring socket cache for %s', source);\n    io = Manager(source, opts);\n  } else {\n    if (!cache[id]) {\n      debug('new io instance for %s', source);\n      cache[id] = Manager(source, opts);\n    }\n    io = cache[id];\n  }\n  if (parsed.query && !opts.query) {\n    opts.query = parsed.query;\n  } else if (opts && 'object' === typeof opts.query) {\n    opts.query = encodeQueryString(opts.query);\n  }\n  return io.socket(parsed.path, opts);\n}\n/**\n *  Helper method to parse query objects to string.\n * @param {object} query\n * @returns {string}\n */\nfunction encodeQueryString (obj) {\n  var str = [];\n  for (var p in obj) {\n    if (obj.hasOwnProperty(p)) {\n      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));\n    }\n  }\n  return str.join('&');\n}\n/**\n * Protocol version.\n *\n * @api public\n */\n\nexports.protocol = parser.protocol;\n\n/**\n * `connect`.\n *\n * @param {String} uri\n * @api public\n */\n\nexports.connect = lookup;\n\n/**\n * Expose constructors for standalone build.\n *\n * @api public\n */\n\nexports.Manager = require('./manager');\nexports.Socket = require('./socket');\n\n},{\"./manager\":37,\"./socket\":39,\"./url\":40,\"debug\":41,\"socket.io-parser\":45}],37:[function(require,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar eio = require('engine.io-client');\nvar Socket = require('./socket');\nvar Emitter = require('component-emitter');\nvar parser = require('socket.io-parser');\nvar on = require('./on');\nvar bind = require('component-bind');\nvar debug = require('debug')('socket.io-client:manager');\nvar indexOf = require('indexof');\nvar Backoff = require('backo2');\n\n/**\n * IE6+ hasOwnProperty\n */\n\nvar has = Object.prototype.hasOwnProperty;\n\n/**\n * Module exports\n */\n\nmodule.exports = Manager;\n\n/**\n * `Manager` constructor.\n *\n * @param {String} engine instance or engine uri/opts\n * @param {Object} options\n * @api public\n */\n\nfunction Manager (uri, opts) {\n  if (!(this instanceof Manager)) return new Manager(uri, opts);\n  if (uri && ('object' === typeof uri)) {\n    opts = uri;\n    uri = undefined;\n  }\n  opts = opts || {};\n\n  opts.path = opts.path || '/socket.io';\n  this.nsps = {};\n  this.subs = [];\n  this.opts = opts;\n  this.reconnection(opts.reconnection !== false);\n  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);\n  this.reconnectionDelay(opts.reconnectionDelay || 1000);\n  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);\n  this.randomizationFactor(opts.randomizationFactor || 0.5);\n  this.backoff = new Backoff({\n    min: this.reconnectionDelay(),\n    max: this.reconnectionDelayMax(),\n    jitter: this.randomizationFactor()\n  });\n  this.timeout(null == opts.timeout ? 20000 : opts.timeout);\n  this.readyState = 'closed';\n  this.uri = uri;\n  this.connecting = [];\n  this.lastPing = null;\n  this.encoding = false;\n  this.packetBuffer = [];\n  this.encoder = new parser.Encoder();\n  this.decoder = new parser.Decoder();\n  this.autoConnect = opts.autoConnect !== false;\n  if (this.autoConnect) this.open();\n}\n\n/**\n * Propagate given event to sockets and emit on `this`\n *\n * @api private\n */\n\nManager.prototype.emitAll = function () {\n  this.emit.apply(this, arguments);\n  for (var nsp in this.nsps) {\n    if (has.call(this.nsps, nsp)) {\n      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);\n    }\n  }\n};\n\n/**\n * Update `socket.id` of all sockets\n *\n * @api private\n */\n\nManager.prototype.updateSocketIds = function () {\n  for (var nsp in this.nsps) {\n    if (has.call(this.nsps, nsp)) {\n      this.nsps[nsp].id = this.engine.id;\n    }\n  }\n};\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Manager.prototype);\n\n/**\n * Sets the `reconnection` config.\n *\n * @param {Boolean} true/false if it should automatically reconnect\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnection = function (v) {\n  if (!arguments.length) return this._reconnection;\n  this._reconnection = !!v;\n  return this;\n};\n\n/**\n * Sets the reconnection attempts config.\n *\n * @param {Number} max reconnection attempts before giving up\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnectionAttempts = function (v) {\n  if (!arguments.length) return this._reconnectionAttempts;\n  this._reconnectionAttempts = v;\n  return this;\n};\n\n/**\n * Sets the delay between reconnections.\n *\n * @param {Number} delay\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnectionDelay = function (v) {\n  if (!arguments.length) return this._reconnectionDelay;\n  this._reconnectionDelay = v;\n  this.backoff && this.backoff.setMin(v);\n  return this;\n};\n\nManager.prototype.randomizationFactor = function (v) {\n  if (!arguments.length) return this._randomizationFactor;\n  this._randomizationFactor = v;\n  this.backoff && this.backoff.setJitter(v);\n  return this;\n};\n\n/**\n * Sets the maximum delay between reconnections.\n *\n * @param {Number} delay\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.reconnectionDelayMax = function (v) {\n  if (!arguments.length) return this._reconnectionDelayMax;\n  this._reconnectionDelayMax = v;\n  this.backoff && this.backoff.setMax(v);\n  return this;\n};\n\n/**\n * Sets the connection timeout. `false` to disable\n *\n * @return {Manager} self or value\n * @api public\n */\n\nManager.prototype.timeout = function (v) {\n  if (!arguments.length) return this._timeout;\n  this._timeout = v;\n  return this;\n};\n\n/**\n * Starts trying to reconnect if reconnection is enabled and we have not\n * started reconnecting yet\n *\n * @api private\n */\n\nManager.prototype.maybeReconnectOnOpen = function () {\n  // Only try to reconnect if it's the first time we're connecting\n  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {\n    // keeps reconnection from firing twice for the same reconnection loop\n    this.reconnect();\n  }\n};\n\n/**\n * Sets the current transport `socket`.\n *\n * @param {Function} optional, callback\n * @return {Manager} self\n * @api public\n */\n\nManager.prototype.open =\nManager.prototype.connect = function (fn, opts) {\n  debug('readyState %s', this.readyState);\n  if (~this.readyState.indexOf('open')) return this;\n\n  debug('opening %s', this.uri);\n  this.engine = eio(this.uri, this.opts);\n  var socket = this.engine;\n  var self = this;\n  this.readyState = 'opening';\n  this.skipReconnect = false;\n\n  // emit `open`\n  var openSub = on(socket, 'open', function () {\n    self.onopen();\n    fn && fn();\n  });\n\n  // emit `connect_error`\n  var errorSub = on(socket, 'error', function (data) {\n    debug('connect_error');\n    self.cleanup();\n    self.readyState = 'closed';\n    self.emitAll('connect_error', data);\n    if (fn) {\n      var err = new Error('Connection error');\n      err.data = data;\n      fn(err);\n    } else {\n      // Only do this if there is no fn to handle the error\n      self.maybeReconnectOnOpen();\n    }\n  });\n\n  // emit `connect_timeout`\n  if (false !== this._timeout) {\n    var timeout = this._timeout;\n    debug('connect attempt will timeout after %d', timeout);\n\n    // set timer\n    var timer = setTimeout(function () {\n      debug('connect attempt timed out after %d', timeout);\n      openSub.destroy();\n      socket.close();\n      socket.emit('error', 'timeout');\n      self.emitAll('connect_timeout', timeout);\n    }, timeout);\n\n    this.subs.push({\n      destroy: function () {\n        clearTimeout(timer);\n      }\n    });\n  }\n\n  this.subs.push(openSub);\n  this.subs.push(errorSub);\n\n  return this;\n};\n\n/**\n * Called upon transport open.\n *\n * @api private\n */\n\nManager.prototype.onopen = function () {\n  debug('open');\n\n  // clear old subs\n  this.cleanup();\n\n  // mark as open\n  this.readyState = 'open';\n  this.emit('open');\n\n  // add new subs\n  var socket = this.engine;\n  this.subs.push(on(socket, 'data', bind(this, 'ondata')));\n  this.subs.push(on(socket, 'ping', bind(this, 'onping')));\n  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));\n  this.subs.push(on(socket, 'error', bind(this, 'onerror')));\n  this.subs.push(on(socket, 'close', bind(this, 'onclose')));\n  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));\n};\n\n/**\n * Called upon a ping.\n *\n * @api private\n */\n\nManager.prototype.onping = function () {\n  this.lastPing = new Date();\n  this.emitAll('ping');\n};\n\n/**\n * Called upon a packet.\n *\n * @api private\n */\n\nManager.prototype.onpong = function () {\n  this.emitAll('pong', new Date() - this.lastPing);\n};\n\n/**\n * Called with data.\n *\n * @api private\n */\n\nManager.prototype.ondata = function (data) {\n  this.decoder.add(data);\n};\n\n/**\n * Called when parser fully decodes a packet.\n *\n * @api private\n */\n\nManager.prototype.ondecoded = function (packet) {\n  this.emit('packet', packet);\n};\n\n/**\n * Called upon socket error.\n *\n * @api private\n */\n\nManager.prototype.onerror = function (err) {\n  debug('error', err);\n  this.emitAll('error', err);\n};\n\n/**\n * Creates a new socket for the given `nsp`.\n *\n * @return {Socket}\n * @api public\n */\n\nManager.prototype.socket = function (nsp, opts) {\n  var socket = this.nsps[nsp];\n  if (!socket) {\n    socket = new Socket(this, nsp, opts);\n    this.nsps[nsp] = socket;\n    var self = this;\n    socket.on('connecting', onConnecting);\n    socket.on('connect', function () {\n      socket.id = self.engine.id;\n    });\n\n    if (this.autoConnect) {\n      // manually call here since connecting evnet is fired before listening\n      onConnecting();\n    }\n  }\n\n  function onConnecting () {\n    if (!~indexOf(self.connecting, socket)) {\n      self.connecting.push(socket);\n    }\n  }\n\n  return socket;\n};\n\n/**\n * Called upon a socket close.\n *\n * @param {Socket} socket\n */\n\nManager.prototype.destroy = function (socket) {\n  var index = indexOf(this.connecting, socket);\n  if (~index) this.connecting.splice(index, 1);\n  if (this.connecting.length) return;\n\n  this.close();\n};\n\n/**\n * Writes a packet.\n *\n * @param {Object} packet\n * @api private\n */\n\nManager.prototype.packet = function (packet) {\n  debug('writing packet %j', packet);\n  var self = this;\n  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;\n\n  if (!self.encoding) {\n    // encode, then write to engine with result\n    self.encoding = true;\n    this.encoder.encode(packet, function (encodedPackets) {\n      for (var i = 0; i < encodedPackets.length; i++) {\n        self.engine.write(encodedPackets[i], packet.options);\n      }\n      self.encoding = false;\n      self.processPacketQueue();\n    });\n  } else { // add packet to the queue\n    self.packetBuffer.push(packet);\n  }\n};\n\n/**\n * If packet buffer is non-empty, begins encoding the\n * next packet in line.\n *\n * @api private\n */\n\nManager.prototype.processPacketQueue = function () {\n  if (this.packetBuffer.length > 0 && !this.encoding) {\n    var pack = this.packetBuffer.shift();\n    this.packet(pack);\n  }\n};\n\n/**\n * Clean up transport subscriptions and packet buffer.\n *\n * @api private\n */\n\nManager.prototype.cleanup = function () {\n  debug('cleanup');\n\n  var subsLength = this.subs.length;\n  for (var i = 0; i < subsLength; i++) {\n    var sub = this.subs.shift();\n    sub.destroy();\n  }\n\n  this.packetBuffer = [];\n  this.encoding = false;\n  this.lastPing = null;\n\n  this.decoder.destroy();\n};\n\n/**\n * Close the current socket.\n *\n * @api private\n */\n\nManager.prototype.close =\nManager.prototype.disconnect = function () {\n  debug('disconnect');\n  this.skipReconnect = true;\n  this.reconnecting = false;\n  if ('opening' === this.readyState) {\n    // `onclose` will not fire because\n    // an open event never happened\n    this.cleanup();\n  }\n  this.backoff.reset();\n  this.readyState = 'closed';\n  if (this.engine) this.engine.close();\n};\n\n/**\n * Called upon engine close.\n *\n * @api private\n */\n\nManager.prototype.onclose = function (reason) {\n  debug('onclose');\n\n  this.cleanup();\n  this.backoff.reset();\n  this.readyState = 'closed';\n  this.emit('close', reason);\n\n  if (this._reconnection && !this.skipReconnect) {\n    this.reconnect();\n  }\n};\n\n/**\n * Attempt a reconnection.\n *\n * @api private\n */\n\nManager.prototype.reconnect = function () {\n  if (this.reconnecting || this.skipReconnect) return this;\n\n  var self = this;\n\n  if (this.backoff.attempts >= this._reconnectionAttempts) {\n    debug('reconnect failed');\n    this.backoff.reset();\n    this.emitAll('reconnect_failed');\n    this.reconnecting = false;\n  } else {\n    var delay = this.backoff.duration();\n    debug('will wait %dms before reconnect attempt', delay);\n\n    this.reconnecting = true;\n    var timer = setTimeout(function () {\n      if (self.skipReconnect) return;\n\n      debug('attempting reconnect');\n      self.emitAll('reconnect_attempt', self.backoff.attempts);\n      self.emitAll('reconnecting', self.backoff.attempts);\n\n      // check again for the case socket closed in above events\n      if (self.skipReconnect) return;\n\n      self.open(function (err) {\n        if (err) {\n          debug('reconnect attempt error');\n          self.reconnecting = false;\n          self.reconnect();\n          self.emitAll('reconnect_error', err.data);\n        } else {\n          debug('reconnect success');\n          self.onreconnect();\n        }\n      });\n    }, delay);\n\n    this.subs.push({\n      destroy: function () {\n        clearTimeout(timer);\n      }\n    });\n  }\n};\n\n/**\n * Called upon successful reconnect.\n *\n * @api private\n */\n\nManager.prototype.onreconnect = function () {\n  var attempt = this.backoff.attempts;\n  this.reconnecting = false;\n  this.backoff.reset();\n  this.updateSocketIds();\n  this.emitAll('reconnect', attempt);\n};\n\n},{\"./on\":38,\"./socket\":39,\"backo2\":3,\"component-bind\":7,\"component-emitter\":8,\"debug\":41,\"engine.io-client\":10,\"indexof\":29,\"socket.io-parser\":45}],38:[function(require,module,exports){\n\n/**\n * Module exports.\n */\n\nmodule.exports = on;\n\n/**\n * Helper for subscriptions.\n *\n * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`\n * @param {String} event name\n * @param {Function} callback\n * @api public\n */\n\nfunction on (obj, ev, fn) {\n  obj.on(ev, fn);\n  return {\n    destroy: function () {\n      obj.removeListener(ev, fn);\n    }\n  };\n}\n\n},{}],39:[function(require,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar parser = require('socket.io-parser');\nvar Emitter = require('component-emitter');\nvar toArray = require('to-array');\nvar on = require('./on');\nvar bind = require('component-bind');\nvar debug = require('debug')('socket.io-client:socket');\nvar hasBin = require('has-binary');\n\n/**\n * Module exports.\n */\n\nmodule.exports = exports = Socket;\n\n/**\n * Internal events (blacklisted).\n * These events can't be emitted by the user.\n *\n * @api private\n */\n\nvar events = {\n  connect: 1,\n  connect_error: 1,\n  connect_timeout: 1,\n  connecting: 1,\n  disconnect: 1,\n  error: 1,\n  reconnect: 1,\n  reconnect_attempt: 1,\n  reconnect_failed: 1,\n  reconnect_error: 1,\n  reconnecting: 1,\n  ping: 1,\n  pong: 1\n};\n\n/**\n * Shortcut to `Emitter#emit`.\n */\n\nvar emit = Emitter.prototype.emit;\n\n/**\n * `Socket` constructor.\n *\n * @api public\n */\n\nfunction Socket (io, nsp, opts) {\n  this.io = io;\n  this.nsp = nsp;\n  this.json = this; // compat\n  this.ids = 0;\n  this.acks = {};\n  this.receiveBuffer = [];\n  this.sendBuffer = [];\n  this.connected = false;\n  this.disconnected = true;\n  if (opts && opts.query) {\n    this.query = opts.query;\n  }\n  if (this.io.autoConnect) this.open();\n}\n\n/**\n * Mix in `Emitter`.\n */\n\nEmitter(Socket.prototype);\n\n/**\n * Subscribe to open, close and packet events\n *\n * @api private\n */\n\nSocket.prototype.subEvents = function () {\n  if (this.subs) return;\n\n  var io = this.io;\n  this.subs = [\n    on(io, 'open', bind(this, 'onopen')),\n    on(io, 'packet', bind(this, 'onpacket')),\n    on(io, 'close', bind(this, 'onclose'))\n  ];\n};\n\n/**\n * \"Opens\" the socket.\n *\n * @api public\n */\n\nSocket.prototype.open =\nSocket.prototype.connect = function () {\n  if (this.connected) return this;\n\n  this.subEvents();\n  this.io.open(); // ensure open\n  if ('open' === this.io.readyState) this.onopen();\n  this.emit('connecting');\n  return this;\n};\n\n/**\n * Sends a `message` event.\n *\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.send = function () {\n  var args = toArray(arguments);\n  args.unshift('message');\n  this.emit.apply(this, args);\n  return this;\n};\n\n/**\n * Override `emit`.\n * If the event is in `events`, it's emitted normally.\n *\n * @param {String} event name\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.emit = function (ev) {\n  if (events.hasOwnProperty(ev)) {\n    emit.apply(this, arguments);\n    return this;\n  }\n\n  var args = toArray(arguments);\n  var parserType = parser.EVENT; // default\n  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary\n  var packet = { type: parserType, data: args };\n\n  packet.options = {};\n  packet.options.compress = !this.flags || false !== this.flags.compress;\n\n  // event ack callback\n  if ('function' === typeof args[args.length - 1]) {\n    debug('emitting packet with ack id %d', this.ids);\n    this.acks[this.ids] = args.pop();\n    packet.id = this.ids++;\n  }\n\n  if (this.connected) {\n    this.packet(packet);\n  } else {\n    this.sendBuffer.push(packet);\n  }\n\n  delete this.flags;\n\n  return this;\n};\n\n/**\n * Sends a packet.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.packet = function (packet) {\n  packet.nsp = this.nsp;\n  this.io.packet(packet);\n};\n\n/**\n * Called upon engine `open`.\n *\n * @api private\n */\n\nSocket.prototype.onopen = function () {\n  debug('transport is open - connecting');\n\n  // write connect packet if necessary\n  if ('/' !== this.nsp) {\n    if (this.query) {\n      this.packet({type: parser.CONNECT, query: this.query});\n    } else {\n      this.packet({type: parser.CONNECT});\n    }\n  }\n};\n\n/**\n * Called upon engine `close`.\n *\n * @param {String} reason\n * @api private\n */\n\nSocket.prototype.onclose = function (reason) {\n  debug('close (%s)', reason);\n  this.connected = false;\n  this.disconnected = true;\n  delete this.id;\n  this.emit('disconnect', reason);\n};\n\n/**\n * Called with socket packet.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.onpacket = function (packet) {\n  if (packet.nsp !== this.nsp) return;\n\n  switch (packet.type) {\n    case parser.CONNECT:\n      this.onconnect();\n      break;\n\n    case parser.EVENT:\n      this.onevent(packet);\n      break;\n\n    case parser.BINARY_EVENT:\n      this.onevent(packet);\n      break;\n\n    case parser.ACK:\n      this.onack(packet);\n      break;\n\n    case parser.BINARY_ACK:\n      this.onack(packet);\n      break;\n\n    case parser.DISCONNECT:\n      this.ondisconnect();\n      break;\n\n    case parser.ERROR:\n      this.emit('error', packet.data);\n      break;\n  }\n};\n\n/**\n * Called upon a server event.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.onevent = function (packet) {\n  var args = packet.data || [];\n  debug('emitting event %j', args);\n\n  if (null != packet.id) {\n    debug('attaching ack callback to event');\n    args.push(this.ack(packet.id));\n  }\n\n  if (this.connected) {\n    emit.apply(this, args);\n  } else {\n    this.receiveBuffer.push(args);\n  }\n};\n\n/**\n * Produces an ack callback to emit with an event.\n *\n * @api private\n */\n\nSocket.prototype.ack = function (id) {\n  var self = this;\n  var sent = false;\n  return function () {\n    // prevent double callbacks\n    if (sent) return;\n    sent = true;\n    var args = toArray(arguments);\n    debug('sending ack %j', args);\n\n    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;\n    self.packet({\n      type: type,\n      id: id,\n      data: args\n    });\n  };\n};\n\n/**\n * Called upon a server acknowlegement.\n *\n * @param {Object} packet\n * @api private\n */\n\nSocket.prototype.onack = function (packet) {\n  var ack = this.acks[packet.id];\n  if ('function' === typeof ack) {\n    debug('calling ack %s with %j', packet.id, packet.data);\n    ack.apply(this, packet.data);\n    delete this.acks[packet.id];\n  } else {\n    debug('bad ack %s', packet.id);\n  }\n};\n\n/**\n * Called upon server connect.\n *\n * @api private\n */\n\nSocket.prototype.onconnect = function () {\n  this.connected = true;\n  this.disconnected = false;\n  this.emit('connect');\n  this.emitBuffered();\n};\n\n/**\n * Emit buffered events (received and emitted).\n *\n * @api private\n */\n\nSocket.prototype.emitBuffered = function () {\n  var i;\n  for (i = 0; i < this.receiveBuffer.length; i++) {\n    emit.apply(this, this.receiveBuffer[i]);\n  }\n  this.receiveBuffer = [];\n\n  for (i = 0; i < this.sendBuffer.length; i++) {\n    this.packet(this.sendBuffer[i]);\n  }\n  this.sendBuffer = [];\n};\n\n/**\n * Called upon server disconnect.\n *\n * @api private\n */\n\nSocket.prototype.ondisconnect = function () {\n  debug('server disconnect (%s)', this.nsp);\n  this.destroy();\n  this.onclose('io server disconnect');\n};\n\n/**\n * Called upon forced client/server side disconnections,\n * this method ensures the manager stops tracking us and\n * that reconnections don't get triggered for this.\n *\n * @api private.\n */\n\nSocket.prototype.destroy = function () {\n  if (this.subs) {\n    // clean subscriptions to avoid reconnections\n    for (var i = 0; i < this.subs.length; i++) {\n      this.subs[i].destroy();\n    }\n    this.subs = null;\n  }\n\n  this.io.destroy(this);\n};\n\n/**\n * Disconnects the socket manually.\n *\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.close =\nSocket.prototype.disconnect = function () {\n  if (this.connected) {\n    debug('performing disconnect (%s)', this.nsp);\n    this.packet({ type: parser.DISCONNECT });\n  }\n\n  // remove socket from pool\n  this.destroy();\n\n  if (this.connected) {\n    // fire events\n    this.onclose('io client disconnect');\n  }\n  return this;\n};\n\n/**\n * Sets the compress flag.\n *\n * @param {Boolean} if `true`, compresses the sending data\n * @return {Socket} self\n * @api public\n */\n\nSocket.prototype.compress = function (compress) {\n  this.flags = this.flags || {};\n  this.flags.compress = compress;\n  return this;\n};\n\n},{\"./on\":38,\"component-bind\":7,\"component-emitter\":8,\"debug\":41,\"has-binary\":26,\"socket.io-parser\":45,\"to-array\":52}],40:[function(require,module,exports){\n(function (global){\n\n/**\n * Module dependencies.\n */\n\nvar parseuri = require('parseuri');\nvar debug = require('debug')('socket.io-client:url');\n\n/**\n * Module exports.\n */\n\nmodule.exports = url;\n\n/**\n * URL parser.\n *\n * @param {String} url\n * @param {Object} An object meant to mimic window.location.\n *                 Defaults to window.location.\n * @api public\n */\n\nfunction url (uri, loc) {\n  var obj = uri;\n\n  // default to window.location\n  loc = loc || global.location;\n  if (null == uri) uri = loc.protocol + '//' + loc.host;\n\n  // relative path support\n  if ('string' === typeof uri) {\n    if ('/' === uri.charAt(0)) {\n      if ('/' === uri.charAt(1)) {\n        uri = loc.protocol + uri;\n      } else {\n        uri = loc.host + uri;\n      }\n    }\n\n    if (!/^(https?|wss?):\\/\\//.test(uri)) {\n      debug('protocol-less url %s', uri);\n      if ('undefined' !== typeof loc) {\n        uri = loc.protocol + '//' + uri;\n      } else {\n        uri = 'https://' + uri;\n      }\n    }\n\n    // parse\n    debug('parse %s', uri);\n    obj = parseuri(uri);\n  }\n\n  // make sure we treat `localhost:80` and `localhost` equally\n  if (!obj.port) {\n    if (/^(http|ws)$/.test(obj.protocol)) {\n      obj.port = '80';\n    } else if (/^(http|ws)s$/.test(obj.protocol)) {\n      obj.port = '443';\n    }\n  }\n\n  obj.path = obj.path || '/';\n\n  var ipv6 = obj.host.indexOf(':') !== -1;\n  var host = ipv6 ? '[' + obj.host + ']' : obj.host;\n\n  // define unique id\n  obj.id = obj.protocol + '://' + host + ':' + obj.port;\n  // define href\n  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));\n\n  return obj;\n}\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"debug\":41,\"parseuri\":33}],41:[function(require,module,exports){\n(function (process){\n\n/**\n * This is the web browser implementation of `debug()`.\n *\n * Expose `debug()` as the module.\n */\n\nexports = module.exports = require('./debug');\nexports.log = log;\nexports.formatArgs = formatArgs;\nexports.save = save;\nexports.load = load;\nexports.useColors = useColors;\nexports.storage = 'undefined' != typeof chrome\n               && 'undefined' != typeof chrome.storage\n                  ? chrome.storage.local\n                  : localstorage();\n\n/**\n * Colors.\n */\n\nexports.colors = [\n  'lightseagreen',\n  'forestgreen',\n  'goldenrod',\n  'dodgerblue',\n  'darkorchid',\n  'crimson'\n];\n\n/**\n * Currently only WebKit-based Web Inspectors, Firefox >= v31,\n * and the Firebug extension (any Firefox version) are known\n * to support \"%c\" CSS customizations.\n *\n * TODO: add a `localStorage` variable to explicitly enable/disable colors\n */\n\nfunction useColors() {\n  // is webkit? http://stackoverflow.com/a/16459606/376773\n  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632\n  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||\n    // is firebug? http://stackoverflow.com/a/398120/376773\n    (window.console && (console.firebug || (console.exception && console.table))) ||\n    // is firefox >= v31?\n    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages\n    (navigator.userAgent.toLowerCase().match(/firefox\\/(\\d+)/) && parseInt(RegExp.$1, 10) >= 31);\n}\n\n/**\n * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.\n */\n\nexports.formatters.j = function(v) {\n  try {\n    return JSON.stringify(v);\n  } catch (err) {\n    return '[UnexpectedJSONParseError]: ' + err.message;\n  }\n};\n\n\n/**\n * Colorize log arguments if enabled.\n *\n * @api public\n */\n\nfunction formatArgs() {\n  var args = arguments;\n  var useColors = this.useColors;\n\n  args[0] = (useColors ? '%c' : '')\n    + this.namespace\n    + (useColors ? ' %c' : ' ')\n    + args[0]\n    + (useColors ? '%c ' : ' ')\n    + '+' + exports.humanize(this.diff);\n\n  if (!useColors) return args;\n\n  var c = 'color: ' + this.color;\n  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));\n\n  // the final \"%c\" is somewhat tricky, because there could be other\n  // arguments passed either before or after the %c, so we need to\n  // figure out the correct index to insert the CSS into\n  var index = 0;\n  var lastC = 0;\n  args[0].replace(/%[a-z%]/g, function(match) {\n    if ('%%' === match) return;\n    index++;\n    if ('%c' === match) {\n      // we only are interested in the *last* %c\n      // (the user may have provided their own)\n      lastC = index;\n    }\n  });\n\n  args.splice(lastC, 0, c);\n  return args;\n}\n\n/**\n * Invokes `console.log()` when available.\n * No-op when `console.log` is not a \"function\".\n *\n * @api public\n */\n\nfunction log() {\n  // this hackery is required for IE8/9, where\n  // the `console.log` function doesn't have 'apply'\n  return 'object' === typeof console\n    && console.log\n    && Function.prototype.apply.call(console.log, console, arguments);\n}\n\n/**\n * Save `namespaces`.\n *\n * @param {String} namespaces\n * @api private\n */\n\nfunction save(namespaces) {\n  try {\n    if (null == namespaces) {\n      exports.storage.removeItem('debug');\n    } else {\n      exports.storage.debug = namespaces;\n    }\n  } catch(e) {}\n}\n\n/**\n * Load `namespaces`.\n *\n * @return {String} returns the previously persisted debug modes\n * @api private\n */\n\nfunction load() {\n  var r;\n  try {\n    return exports.storage.debug;\n  } catch(e) {}\n\n  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG\n  if (typeof process !== 'undefined' && 'env' in process) {\n    return process.env.DEBUG;\n  }\n}\n\n/**\n * Enable namespaces listed in `localStorage.debug` initially.\n */\n\nexports.enable(load());\n\n/**\n * Localstorage attempts to return the localstorage.\n *\n * This is necessary because safari throws\n * when a user disables cookies/localstorage\n * and you attempt to access it.\n *\n * @return {LocalStorage}\n * @api private\n */\n\nfunction localstorage(){\n  try {\n    return window.localStorage;\n  } catch (e) {}\n}\n\n}).call(this,require('_process'))\n\n},{\"./debug\":42,\"_process\":34}],42:[function(require,module,exports){\narguments[4][21][0].apply(exports,arguments)\n},{\"dup\":21,\"ms\":43}],43:[function(require,module,exports){\narguments[4][22][0].apply(exports,arguments)\n},{\"dup\":22}],44:[function(require,module,exports){\n(function (global){\n/*global Blob,File*/\n\n/**\n * Module requirements\n */\n\nvar isArray = require('isarray');\nvar isBuf = require('./is-buffer');\n\n/**\n * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.\n * Anything with blobs or files should be fed through removeBlobs before coming\n * here.\n *\n * @param {Object} packet - socket.io event packet\n * @return {Object} with deconstructed packet and list of buffers\n * @api public\n */\n\nexports.deconstructPacket = function(packet){\n  var buffers = [];\n  var packetData = packet.data;\n\n  function _deconstructPacket(data) {\n    if (!data) return data;\n\n    if (isBuf(data)) {\n      var placeholder = { _placeholder: true, num: buffers.length };\n      buffers.push(data);\n      return placeholder;\n    } else if (isArray(data)) {\n      var newData = new Array(data.length);\n      for (var i = 0; i < data.length; i++) {\n        newData[i] = _deconstructPacket(data[i]);\n      }\n      return newData;\n    } else if ('object' == typeof data && !(data instanceof Date)) {\n      var newData = {};\n      for (var key in data) {\n        newData[key] = _deconstructPacket(data[key]);\n      }\n      return newData;\n    }\n    return data;\n  }\n\n  var pack = packet;\n  pack.data = _deconstructPacket(packetData);\n  pack.attachments = buffers.length; // number of binary 'attachments'\n  return {packet: pack, buffers: buffers};\n};\n\n/**\n * Reconstructs a binary packet from its placeholder packet and buffers\n *\n * @param {Object} packet - event packet with placeholders\n * @param {Array} buffers - binary buffers to put in placeholder positions\n * @return {Object} reconstructed packet\n * @api public\n */\n\nexports.reconstructPacket = function(packet, buffers) {\n  var curPlaceHolder = 0;\n\n  function _reconstructPacket(data) {\n    if (data && data._placeholder) {\n      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)\n      return buf;\n    } else if (isArray(data)) {\n      for (var i = 0; i < data.length; i++) {\n        data[i] = _reconstructPacket(data[i]);\n      }\n      return data;\n    } else if (data && 'object' == typeof data) {\n      for (var key in data) {\n        data[key] = _reconstructPacket(data[key]);\n      }\n      return data;\n    }\n    return data;\n  }\n\n  packet.data = _reconstructPacket(packet.data);\n  packet.attachments = undefined; // no longer useful\n  return packet;\n};\n\n/**\n * Asynchronously removes Blobs or Files from data via\n * FileReader's readAsArrayBuffer method. Used before encoding\n * data as msgpack. Calls callback with the blobless data.\n *\n * @param {Object} data\n * @param {Function} callback\n * @api private\n */\n\nexports.removeBlobs = function(data, callback) {\n  function _removeBlobs(obj, curKey, containingObject) {\n    if (!obj) return obj;\n\n    // convert any blob\n    if ((global.Blob && obj instanceof Blob) ||\n        (global.File && obj instanceof File)) {\n      pendingBlobs++;\n\n      // async filereader\n      var fileReader = new FileReader();\n      fileReader.onload = function() { // this.result == arraybuffer\n        if (containingObject) {\n          containingObject[curKey] = this.result;\n        }\n        else {\n          bloblessData = this.result;\n        }\n\n        // if nothing pending its callback time\n        if(! --pendingBlobs) {\n          callback(bloblessData);\n        }\n      };\n\n      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer\n    } else if (isArray(obj)) { // handle array\n      for (var i = 0; i < obj.length; i++) {\n        _removeBlobs(obj[i], i, obj);\n      }\n    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object\n      for (var key in obj) {\n        _removeBlobs(obj[key], key, obj);\n      }\n    }\n  }\n\n  var pendingBlobs = 0;\n  var bloblessData = data;\n  _removeBlobs(bloblessData);\n  if (!pendingBlobs) {\n    callback(bloblessData);\n  }\n};\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{\"./is-buffer\":46,\"isarray\":50}],45:[function(require,module,exports){\n\n/**\n * Module dependencies.\n */\n\nvar debug = require('debug')('socket.io-parser');\nvar json = require('json3');\nvar Emitter = require('component-emitter');\nvar binary = require('./binary');\nvar isBuf = require('./is-buffer');\n\n/**\n * Protocol version.\n *\n * @api public\n */\n\nexports.protocol = 4;\n\n/**\n * Packet types.\n *\n * @api public\n */\n\nexports.types = [\n  'CONNECT',\n  'DISCONNECT',\n  'EVENT',\n  'ACK',\n  'ERROR',\n  'BINARY_EVENT',\n  'BINARY_ACK'\n];\n\n/**\n * Packet type `connect`.\n *\n * @api public\n */\n\nexports.CONNECT = 0;\n\n/**\n * Packet type `disconnect`.\n *\n * @api public\n */\n\nexports.DISCONNECT = 1;\n\n/**\n * Packet type `event`.\n *\n * @api public\n */\n\nexports.EVENT = 2;\n\n/**\n * Packet type `ack`.\n *\n * @api public\n */\n\nexports.ACK = 3;\n\n/**\n * Packet type `error`.\n *\n * @api public\n */\n\nexports.ERROR = 4;\n\n/**\n * Packet type 'binary event'\n *\n * @api public\n */\n\nexports.BINARY_EVENT = 5;\n\n/**\n * Packet type `binary ack`. For acks with binary arguments.\n *\n * @api public\n */\n\nexports.BINARY_ACK = 6;\n\n/**\n * Encoder constructor.\n *\n * @api public\n */\n\nexports.Encoder = Encoder;\n\n/**\n * Decoder constructor.\n *\n * @api public\n */\n\nexports.Decoder = Decoder;\n\n/**\n * A socket.io Encoder instance\n *\n * @api public\n */\n\nfunction Encoder() {}\n\n/**\n * Encode a packet as a single string if non-binary, or as a\n * buffer sequence, depending on packet type.\n *\n * @param {Object} obj - packet object\n * @param {Function} callback - function to handle encodings (likely engine.write)\n * @return Calls callback with Array of encodings\n * @api public\n */\n\nEncoder.prototype.encode = function(obj, callback){\n  debug('encoding packet %j', obj);\n\n  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {\n    encodeAsBinary(obj, callback);\n  }\n  else {\n    var encoding = encodeAsString(obj);\n    callback([encoding]);\n  }\n};\n\n/**\n * Encode packet as string.\n *\n * @param {Object} packet\n * @return {String} encoded\n * @api private\n */\n\nfunction encodeAsString(obj) {\n  var str = '';\n  var nsp = false;\n\n  // first is type\n  str += obj.type;\n\n  // attachments if we have them\n  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {\n    str += obj.attachments;\n    str += '-';\n  }\n\n  // if we have a namespace other than `/`\n  // we append it followed by a comma `,`\n  if (obj.nsp && '/' != obj.nsp) {\n    nsp = true;\n    str += obj.nsp;\n  }\n\n  // immediately followed by the id\n  if (null != obj.id) {\n    if (nsp) {\n      str += ',';\n      nsp = false;\n    }\n    str += obj.id;\n  }\n\n  // json data\n  if (null != obj.data) {\n    if (nsp) str += ',';\n    str += json.stringify(obj.data);\n  }\n\n  debug('encoded %j as %s', obj, str);\n  return str;\n}\n\n/**\n * Encode packet as 'buffer sequence' by removing blobs, and\n * deconstructing packet into object with placeholders and\n * a list of buffers.\n *\n * @param {Object} packet\n * @return {Buffer} encoded\n * @api private\n */\n\nfunction encodeAsBinary(obj, callback) {\n\n  function writeEncoding(bloblessData) {\n    var deconstruction = binary.deconstructPacket(bloblessData);\n    var pack = encodeAsString(deconstruction.packet);\n    var buffers = deconstruction.buffers;\n\n    buffers.unshift(pack); // add packet info to beginning of data list\n    callback(buffers); // write all the buffers\n  }\n\n  binary.removeBlobs(obj, writeEncoding);\n}\n\n/**\n * A socket.io Decoder instance\n *\n * @return {Object} decoder\n * @api public\n */\n\nfunction Decoder() {\n  this.reconstructor = null;\n}\n\n/**\n * Mix in `Emitter` with Decoder.\n */\n\nEmitter(Decoder.prototype);\n\n/**\n * Decodes an ecoded packet string into packet JSON.\n *\n * @param {String} obj - encoded packet\n * @return {Object} packet\n * @api public\n */\n\nDecoder.prototype.add = function(obj) {\n  var packet;\n  if ('string' == typeof obj) {\n    packet = decodeString(obj);\n    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json\n      this.reconstructor = new BinaryReconstructor(packet);\n\n      // no attachments, labeled binary but no binary data to follow\n      if (this.reconstructor.reconPack.attachments === 0) {\n        this.emit('decoded', packet);\n      }\n    } else { // non-binary full packet\n      this.emit('decoded', packet);\n    }\n  }\n  else if (isBuf(obj) || obj.base64) { // raw binary data\n    if (!this.reconstructor) {\n      throw new Error('got binary data when not reconstructing a packet');\n    } else {\n      packet = this.reconstructor.takeBinaryData(obj);\n      if (packet) { // received final buffer\n        this.reconstructor = null;\n        this.emit('decoded', packet);\n      }\n    }\n  }\n  else {\n    throw new Error('Unknown type: ' + obj);\n  }\n};\n\n/**\n * Decode a packet String (JSON data)\n *\n * @param {String} str\n * @return {Object} packet\n * @api private\n */\n\nfunction decodeString(str) {\n  var p = {};\n  var i = 0;\n\n  // look up type\n  p.type = Number(str.charAt(0));\n  if (null == exports.types[p.type]) return error();\n\n  // look up attachments if type binary\n  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {\n    var buf = '';\n    while (str.charAt(++i) != '-') {\n      buf += str.charAt(i);\n      if (i == str.length) break;\n    }\n    if (buf != Number(buf) || str.charAt(i) != '-') {\n      throw new Error('Illegal attachments');\n    }\n    p.attachments = Number(buf);\n  }\n\n  // look up namespace (if any)\n  if ('/' == str.charAt(i + 1)) {\n    p.nsp = '';\n    while (++i) {\n      var c = str.charAt(i);\n      if (',' == c) break;\n      p.nsp += c;\n      if (i == str.length) break;\n    }\n  } else {\n    p.nsp = '/';\n  }\n\n  // look up id\n  var next = str.charAt(i + 1);\n  if ('' !== next && Number(next) == next) {\n    p.id = '';\n    while (++i) {\n      var c = str.charAt(i);\n      if (null == c || Number(c) != c) {\n        --i;\n        break;\n      }\n      p.id += str.charAt(i);\n      if (i == str.length) break;\n    }\n    p.id = Number(p.id);\n  }\n\n  // look up json data\n  if (str.charAt(++i)) {\n    p = tryParse(p, str.substr(i));\n  }\n\n  debug('decoded %s as %j', str, p);\n  return p;\n}\n\nfunction tryParse(p, str) {\n  try {\n    p.data = json.parse(str);\n  } catch(e){\n    return error();\n  }\n  return p; \n};\n\n/**\n * Deallocates a parser's resources\n *\n * @api public\n */\n\nDecoder.prototype.destroy = function() {\n  if (this.reconstructor) {\n    this.reconstructor.finishedReconstruction();\n  }\n};\n\n/**\n * A manager of a binary event's 'buffer sequence'. Should\n * be constructed whenever a packet of type BINARY_EVENT is\n * decoded.\n *\n * @param {Object} packet\n * @return {BinaryReconstructor} initialized reconstructor\n * @api private\n */\n\nfunction BinaryReconstructor(packet) {\n  this.reconPack = packet;\n  this.buffers = [];\n}\n\n/**\n * Method to be called when binary data received from connection\n * after a BINARY_EVENT packet.\n *\n * @param {Buffer | ArrayBuffer} binData - the raw binary data received\n * @return {null | Object} returns null if more binary data is expected or\n *   a reconstructed packet object if all buffers have been received.\n * @api private\n */\n\nBinaryReconstructor.prototype.takeBinaryData = function(binData) {\n  this.buffers.push(binData);\n  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list\n    var packet = binary.reconstructPacket(this.reconPack, this.buffers);\n    this.finishedReconstruction();\n    return packet;\n  }\n  return null;\n};\n\n/**\n * Cleans up binary packet reconstruction variables.\n *\n * @api private\n */\n\nBinaryReconstructor.prototype.finishedReconstruction = function() {\n  this.reconPack = null;\n  this.buffers = [];\n};\n\nfunction error(data){\n  return {\n    type: exports.ERROR,\n    data: 'parser error'\n  };\n}\n\n},{\"./binary\":44,\"./is-buffer\":46,\"component-emitter\":47,\"debug\":48,\"json3\":30}],46:[function(require,module,exports){\n(function (global){\n\nmodule.exports = isBuf;\n\n/**\n * Returns true if obj is a buffer or an arraybuffer.\n *\n * @api private\n */\n\nfunction isBuf(obj) {\n  return (global.Buffer && global.Buffer.isBuffer(obj)) ||\n         (global.ArrayBuffer && obj instanceof ArrayBuffer);\n}\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{}],47:[function(require,module,exports){\n\n/**\n * Expose `Emitter`.\n */\n\nmodule.exports = Emitter;\n\n/**\n * Initialize a new `Emitter`.\n *\n * @api public\n */\n\nfunction Emitter(obj) {\n  if (obj) return mixin(obj);\n};\n\n/**\n * Mixin the emitter properties.\n *\n * @param {Object} obj\n * @return {Object}\n * @api private\n */\n\nfunction mixin(obj) {\n  for (var key in Emitter.prototype) {\n    obj[key] = Emitter.prototype[key];\n  }\n  return obj;\n}\n\n/**\n * Listen on the given `event` with `fn`.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.on =\nEmitter.prototype.addEventListener = function(event, fn){\n  this._callbacks = this._callbacks || {};\n  (this._callbacks[event] = this._callbacks[event] || [])\n    .push(fn);\n  return this;\n};\n\n/**\n * Adds an `event` listener that will be invoked a single\n * time then automatically removed.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.once = function(event, fn){\n  var self = this;\n  this._callbacks = this._callbacks || {};\n\n  function on() {\n    self.off(event, on);\n    fn.apply(this, arguments);\n  }\n\n  on.fn = fn;\n  this.on(event, on);\n  return this;\n};\n\n/**\n * Remove the given callback for `event` or all\n * registered callbacks.\n *\n * @param {String} event\n * @param {Function} fn\n * @return {Emitter}\n * @api public\n */\n\nEmitter.prototype.off =\nEmitter.prototype.removeListener =\nEmitter.prototype.removeAllListeners =\nEmitter.prototype.removeEventListener = function(event, fn){\n  this._callbacks = this._callbacks || {};\n\n  // all\n  if (0 == arguments.length) {\n    this._callbacks = {};\n    return this;\n  }\n\n  // specific event\n  var callbacks = this._callbacks[event];\n  if (!callbacks) return this;\n\n  // remove all handlers\n  if (1 == arguments.length) {\n    delete this._callbacks[event];\n    return this;\n  }\n\n  // remove specific handler\n  var cb;\n  for (var i = 0; i < callbacks.length; i++) {\n    cb = callbacks[i];\n    if (cb === fn || cb.fn === fn) {\n      callbacks.splice(i, 1);\n      break;\n    }\n  }\n  return this;\n};\n\n/**\n * Emit `event` with the given args.\n *\n * @param {String} event\n * @param {Mixed} ...\n * @return {Emitter}\n */\n\nEmitter.prototype.emit = function(event){\n  this._callbacks = this._callbacks || {};\n  var args = [].slice.call(arguments, 1)\n    , callbacks = this._callbacks[event];\n\n  if (callbacks) {\n    callbacks = callbacks.slice(0);\n    for (var i = 0, len = callbacks.length; i < len; ++i) {\n      callbacks[i].apply(this, args);\n    }\n  }\n\n  return this;\n};\n\n/**\n * Return array of callbacks for `event`.\n *\n * @param {String} event\n * @return {Array}\n * @api public\n */\n\nEmitter.prototype.listeners = function(event){\n  this._callbacks = this._callbacks || {};\n  return this._callbacks[event] || [];\n};\n\n/**\n * Check if this emitter has `event` handlers.\n *\n * @param {String} event\n * @return {Boolean}\n * @api public\n */\n\nEmitter.prototype.hasListeners = function(event){\n  return !! this.listeners(event).length;\n};\n\n},{}],48:[function(require,module,exports){\n\n/**\n * This is the web browser implementation of `debug()`.\n *\n * Expose `debug()` as the module.\n */\n\nexports = module.exports = require('./debug');\nexports.log = log;\nexports.formatArgs = formatArgs;\nexports.save = save;\nexports.load = load;\nexports.useColors = useColors;\nexports.storage = 'undefined' != typeof chrome\n               && 'undefined' != typeof chrome.storage\n                  ? chrome.storage.local\n                  : localstorage();\n\n/**\n * Colors.\n */\n\nexports.colors = [\n  'lightseagreen',\n  'forestgreen',\n  'goldenrod',\n  'dodgerblue',\n  'darkorchid',\n  'crimson'\n];\n\n/**\n * Currently only WebKit-based Web Inspectors, Firefox >= v31,\n * and the Firebug extension (any Firefox version) are known\n * to support \"%c\" CSS customizations.\n *\n * TODO: add a `localStorage` variable to explicitly enable/disable colors\n */\n\nfunction useColors() {\n  // is webkit? http://stackoverflow.com/a/16459606/376773\n  return ('WebkitAppearance' in document.documentElement.style) ||\n    // is firebug? http://stackoverflow.com/a/398120/376773\n    (window.console && (console.firebug || (console.exception && console.table))) ||\n    // is firefox >= v31?\n    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages\n    (navigator.userAgent.toLowerCase().match(/firefox\\/(\\d+)/) && parseInt(RegExp.$1, 10) >= 31);\n}\n\n/**\n * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.\n */\n\nexports.formatters.j = function(v) {\n  return JSON.stringify(v);\n};\n\n\n/**\n * Colorize log arguments if enabled.\n *\n * @api public\n */\n\nfunction formatArgs() {\n  var args = arguments;\n  var useColors = this.useColors;\n\n  args[0] = (useColors ? '%c' : '')\n    + this.namespace\n    + (useColors ? ' %c' : ' ')\n    + args[0]\n    + (useColors ? '%c ' : ' ')\n    + '+' + exports.humanize(this.diff);\n\n  if (!useColors) return args;\n\n  var c = 'color: ' + this.color;\n  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));\n\n  // the final \"%c\" is somewhat tricky, because there could be other\n  // arguments passed either before or after the %c, so we need to\n  // figure out the correct index to insert the CSS into\n  var index = 0;\n  var lastC = 0;\n  args[0].replace(/%[a-z%]/g, function(match) {\n    if ('%%' === match) return;\n    index++;\n    if ('%c' === match) {\n      // we only are interested in the *last* %c\n      // (the user may have provided their own)\n      lastC = index;\n    }\n  });\n\n  args.splice(lastC, 0, c);\n  return args;\n}\n\n/**\n * Invokes `console.log()` when available.\n * No-op when `console.log` is not a \"function\".\n *\n * @api public\n */\n\nfunction log() {\n  // this hackery is required for IE8/9, where\n  // the `console.log` function doesn't have 'apply'\n  return 'object' === typeof console\n    && console.log\n    && Function.prototype.apply.call(console.log, console, arguments);\n}\n\n/**\n * Save `namespaces`.\n *\n * @param {String} namespaces\n * @api private\n */\n\nfunction save(namespaces) {\n  try {\n    if (null == namespaces) {\n      exports.storage.removeItem('debug');\n    } else {\n      exports.storage.debug = namespaces;\n    }\n  } catch(e) {}\n}\n\n/**\n * Load `namespaces`.\n *\n * @return {String} returns the previously persisted debug modes\n * @api private\n */\n\nfunction load() {\n  var r;\n  try {\n    r = exports.storage.debug;\n  } catch(e) {}\n  return r;\n}\n\n/**\n * Enable namespaces listed in `localStorage.debug` initially.\n */\n\nexports.enable(load());\n\n/**\n * Localstorage attempts to return the localstorage.\n *\n * This is necessary because safari throws\n * when a user disables cookies/localstorage\n * and you attempt to access it.\n *\n * @return {LocalStorage}\n * @api private\n */\n\nfunction localstorage(){\n  try {\n    return window.localStorage;\n  } catch (e) {}\n}\n\n},{\"./debug\":49}],49:[function(require,module,exports){\n\n/**\n * This is the common logic for both the Node.js and web browser\n * implementations of `debug()`.\n *\n * Expose `debug()` as the module.\n */\n\nexports = module.exports = debug;\nexports.coerce = coerce;\nexports.disable = disable;\nexports.enable = enable;\nexports.enabled = enabled;\nexports.humanize = require('ms');\n\n/**\n * The currently active debug mode names, and names to skip.\n */\n\nexports.names = [];\nexports.skips = [];\n\n/**\n * Map of special \"%n\" handling functions, for the debug \"format\" argument.\n *\n * Valid key names are a single, lowercased letter, i.e. \"n\".\n */\n\nexports.formatters = {};\n\n/**\n * Previously assigned color.\n */\n\nvar prevColor = 0;\n\n/**\n * Previous log timestamp.\n */\n\nvar prevTime;\n\n/**\n * Select a color.\n *\n * @return {Number}\n * @api private\n */\n\nfunction selectColor() {\n  return exports.colors[prevColor++ % exports.colors.length];\n}\n\n/**\n * Create a debugger with the given `namespace`.\n *\n * @param {String} namespace\n * @return {Function}\n * @api public\n */\n\nfunction debug(namespace) {\n\n  // define the `disabled` version\n  function disabled() {\n  }\n  disabled.enabled = false;\n\n  // define the `enabled` version\n  function enabled() {\n\n    var self = enabled;\n\n    // set `diff` timestamp\n    var curr = +new Date();\n    var ms = curr - (prevTime || curr);\n    self.diff = ms;\n    self.prev = prevTime;\n    self.curr = curr;\n    prevTime = curr;\n\n    // add the `color` if not set\n    if (null == self.useColors) self.useColors = exports.useColors();\n    if (null == self.color && self.useColors) self.color = selectColor();\n\n    var args = Array.prototype.slice.call(arguments);\n\n    args[0] = exports.coerce(args[0]);\n\n    if ('string' !== typeof args[0]) {\n      // anything else let's inspect with %o\n      args = ['%o'].concat(args);\n    }\n\n    // apply any `formatters` transformations\n    var index = 0;\n    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {\n      // if we encounter an escaped % then don't increase the array index\n      if (match === '%%') return match;\n      index++;\n      var formatter = exports.formatters[format];\n      if ('function' === typeof formatter) {\n        var val = args[index];\n        match = formatter.call(self, val);\n\n        // now we need to remove `args[index]` since it's inlined in the `format`\n        args.splice(index, 1);\n        index--;\n      }\n      return match;\n    });\n\n    if ('function' === typeof exports.formatArgs) {\n      args = exports.formatArgs.apply(self, args);\n    }\n    var logFn = enabled.log || exports.log || console.log.bind(console);\n    logFn.apply(self, args);\n  }\n  enabled.enabled = true;\n\n  var fn = exports.enabled(namespace) ? enabled : disabled;\n\n  fn.namespace = namespace;\n\n  return fn;\n}\n\n/**\n * Enables a debug mode by namespaces. This can include modes\n * separated by a colon and wildcards.\n *\n * @param {String} namespaces\n * @api public\n */\n\nfunction enable(namespaces) {\n  exports.save(namespaces);\n\n  var split = (namespaces || '').split(/[\\s,]+/);\n  var len = split.length;\n\n  for (var i = 0; i < len; i++) {\n    if (!split[i]) continue; // ignore empty strings\n    namespaces = split[i].replace(/\\*/g, '.*?');\n    if (namespaces[0] === '-') {\n      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));\n    } else {\n      exports.names.push(new RegExp('^' + namespaces + '$'));\n    }\n  }\n}\n\n/**\n * Disable debug output.\n *\n * @api public\n */\n\nfunction disable() {\n  exports.enable('');\n}\n\n/**\n * Returns true if the given mode name is enabled, false otherwise.\n *\n * @param {String} name\n * @return {Boolean}\n * @api public\n */\n\nfunction enabled(name) {\n  var i, len;\n  for (i = 0, len = exports.skips.length; i < len; i++) {\n    if (exports.skips[i].test(name)) {\n      return false;\n    }\n  }\n  for (i = 0, len = exports.names.length; i < len; i++) {\n    if (exports.names[i].test(name)) {\n      return true;\n    }\n  }\n  return false;\n}\n\n/**\n * Coerce `val`.\n *\n * @param {Mixed} val\n * @return {Mixed}\n * @api private\n */\n\nfunction coerce(val) {\n  if (val instanceof Error) return val.stack || val.message;\n  return val;\n}\n\n},{\"ms\":51}],50:[function(require,module,exports){\narguments[4][27][0].apply(exports,arguments)\n},{\"dup\":27}],51:[function(require,module,exports){\n/**\n * Helpers.\n */\n\nvar s = 1000;\nvar m = s * 60;\nvar h = m * 60;\nvar d = h * 24;\nvar y = d * 365.25;\n\n/**\n * Parse or format the given `val`.\n *\n * Options:\n *\n *  - `long` verbose formatting [false]\n *\n * @param {String|Number} val\n * @param {Object} options\n * @return {String|Number}\n * @api public\n */\n\nmodule.exports = function(val, options){\n  options = options || {};\n  if ('string' == typeof val) return parse(val);\n  return options.long\n    ? long(val)\n    : short(val);\n};\n\n/**\n * Parse the given `str` and return milliseconds.\n *\n * @param {String} str\n * @return {Number}\n * @api private\n */\n\nfunction parse(str) {\n  str = '' + str;\n  if (str.length > 10000) return;\n  var match = /^((?:\\d+)?\\.?\\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);\n  if (!match) return;\n  var n = parseFloat(match[1]);\n  var type = (match[2] || 'ms').toLowerCase();\n  switch (type) {\n    case 'years':\n    case 'year':\n    case 'yrs':\n    case 'yr':\n    case 'y':\n      return n * y;\n    case 'days':\n    case 'day':\n    case 'd':\n      return n * d;\n    case 'hours':\n    case 'hour':\n    case 'hrs':\n    case 'hr':\n    case 'h':\n      return n * h;\n    case 'minutes':\n    case 'minute':\n    case 'mins':\n    case 'min':\n    case 'm':\n      return n * m;\n    case 'seconds':\n    case 'second':\n    case 'secs':\n    case 'sec':\n    case 's':\n      return n * s;\n    case 'milliseconds':\n    case 'millisecond':\n    case 'msecs':\n    case 'msec':\n    case 'ms':\n      return n;\n  }\n}\n\n/**\n * Short format for `ms`.\n *\n * @param {Number} ms\n * @return {String}\n * @api private\n */\n\nfunction short(ms) {\n  if (ms >= d) return Math.round(ms / d) + 'd';\n  if (ms >= h) return Math.round(ms / h) + 'h';\n  if (ms >= m) return Math.round(ms / m) + 'm';\n  if (ms >= s) return Math.round(ms / s) + 's';\n  return ms + 'ms';\n}\n\n/**\n * Long format for `ms`.\n *\n * @param {Number} ms\n * @return {String}\n * @api private\n */\n\nfunction long(ms) {\n  return plural(ms, d, 'day')\n    || plural(ms, h, 'hour')\n    || plural(ms, m, 'minute')\n    || plural(ms, s, 'second')\n    || ms + ' ms';\n}\n\n/**\n * Pluralization helper.\n */\n\nfunction plural(ms, n, name) {\n  if (ms < n) return;\n  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;\n  return Math.ceil(ms / n) + ' ' + name + 's';\n}\n\n},{}],52:[function(require,module,exports){\nmodule.exports = toArray\n\nfunction toArray(list, index) {\n    var array = []\n\n    index = index || 0\n\n    for (var i = index || 0; i < list.length; i++) {\n        array[i - index] = list[i]\n    }\n\n    return array\n}\n\n},{}],53:[function(require,module,exports){\n(function (global){\n/*! https://mths.be/wtf8 v1.0.0 by @mathias */\n;(function(root) {\n\n\t// Detect free variables `exports`\n\tvar freeExports = typeof exports == 'object' && exports;\n\n\t// Detect free variable `module`\n\tvar freeModule = typeof module == 'object' && module &&\n\t\tmodule.exports == freeExports && module;\n\n\t// Detect free variable `global`, from Node.js or Browserified code,\n\t// and use it as `root`\n\tvar freeGlobal = typeof global == 'object' && global;\n\tif (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {\n\t\troot = freeGlobal;\n\t}\n\n\t/*--------------------------------------------------------------------------*/\n\n\tvar stringFromCharCode = String.fromCharCode;\n\n\t// Taken from https://mths.be/punycode\n\tfunction ucs2decode(string) {\n\t\tvar output = [];\n\t\tvar counter = 0;\n\t\tvar length = string.length;\n\t\tvar value;\n\t\tvar extra;\n\t\twhile (counter < length) {\n\t\t\tvalue = string.charCodeAt(counter++);\n\t\t\tif (value >= 0xD800 && value <= 0xDBFF && counter < length) {\n\t\t\t\t// high surrogate, and there is a next character\n\t\t\t\textra = string.charCodeAt(counter++);\n\t\t\t\tif ((extra & 0xFC00) == 0xDC00) { // low surrogate\n\t\t\t\t\toutput.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);\n\t\t\t\t} else {\n\t\t\t\t\t// unmatched surrogate; only append this code unit, in case the next\n\t\t\t\t\t// code unit is the high surrogate of a surrogate pair\n\t\t\t\t\toutput.push(value);\n\t\t\t\t\tcounter--;\n\t\t\t\t}\n\t\t\t} else {\n\t\t\t\toutput.push(value);\n\t\t\t}\n\t\t}\n\t\treturn output;\n\t}\n\n\t// Taken from https://mths.be/punycode\n\tfunction ucs2encode(array) {\n\t\tvar length = array.length;\n\t\tvar index = -1;\n\t\tvar value;\n\t\tvar output = '';\n\t\twhile (++index < length) {\n\t\t\tvalue = array[index];\n\t\t\tif (value > 0xFFFF) {\n\t\t\t\tvalue -= 0x10000;\n\t\t\t\toutput += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);\n\t\t\t\tvalue = 0xDC00 | value & 0x3FF;\n\t\t\t}\n\t\t\toutput += stringFromCharCode(value);\n\t\t}\n\t\treturn output;\n\t}\n\n\t/*--------------------------------------------------------------------------*/\n\n\tfunction createByte(codePoint, shift) {\n\t\treturn stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);\n\t}\n\n\tfunction encodeCodePoint(codePoint) {\n\t\tif ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence\n\t\t\treturn stringFromCharCode(codePoint);\n\t\t}\n\t\tvar symbol = '';\n\t\tif ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence\n\t\t\tsymbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);\n\t\t}\n\t\telse if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence\n\t\t\tsymbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);\n\t\t\tsymbol += createByte(codePoint, 6);\n\t\t}\n\t\telse if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence\n\t\t\tsymbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);\n\t\t\tsymbol += createByte(codePoint, 12);\n\t\t\tsymbol += createByte(codePoint, 6);\n\t\t}\n\t\tsymbol += stringFromCharCode((codePoint & 0x3F) | 0x80);\n\t\treturn symbol;\n\t}\n\n\tfunction wtf8encode(string) {\n\t\tvar codePoints = ucs2decode(string);\n\t\tvar length = codePoints.length;\n\t\tvar index = -1;\n\t\tvar codePoint;\n\t\tvar byteString = '';\n\t\twhile (++index < length) {\n\t\t\tcodePoint = codePoints[index];\n\t\t\tbyteString += encodeCodePoint(codePoint);\n\t\t}\n\t\treturn byteString;\n\t}\n\n\t/*--------------------------------------------------------------------------*/\n\n\tfunction readContinuationByte() {\n\t\tif (byteIndex >= byteCount) {\n\t\t\tthrow Error('Invalid byte index');\n\t\t}\n\n\t\tvar continuationByte = byteArray[byteIndex] & 0xFF;\n\t\tbyteIndex++;\n\n\t\tif ((continuationByte & 0xC0) == 0x80) {\n\t\t\treturn continuationByte & 0x3F;\n\t\t}\n\n\t\t// If we end up here, it’s not a continuation byte.\n\t\tthrow Error('Invalid continuation byte');\n\t}\n\n\tfunction decodeSymbol() {\n\t\tvar byte1;\n\t\tvar byte2;\n\t\tvar byte3;\n\t\tvar byte4;\n\t\tvar codePoint;\n\n\t\tif (byteIndex > byteCount) {\n\t\t\tthrow Error('Invalid byte index');\n\t\t}\n\n\t\tif (byteIndex == byteCount) {\n\t\t\treturn false;\n\t\t}\n\n\t\t// Read the first byte.\n\t\tbyte1 = byteArray[byteIndex] & 0xFF;\n\t\tbyteIndex++;\n\n\t\t// 1-byte sequence (no continuation bytes)\n\t\tif ((byte1 & 0x80) == 0) {\n\t\t\treturn byte1;\n\t\t}\n\n\t\t// 2-byte sequence\n\t\tif ((byte1 & 0xE0) == 0xC0) {\n\t\t\tvar byte2 = readContinuationByte();\n\t\t\tcodePoint = ((byte1 & 0x1F) << 6) | byte2;\n\t\t\tif (codePoint >= 0x80) {\n\t\t\t\treturn codePoint;\n\t\t\t} else {\n\t\t\t\tthrow Error('Invalid continuation byte');\n\t\t\t}\n\t\t}\n\n\t\t// 3-byte sequence (may include unpaired surrogates)\n\t\tif ((byte1 & 0xF0) == 0xE0) {\n\t\t\tbyte2 = readContinuationByte();\n\t\t\tbyte3 = readContinuationByte();\n\t\t\tcodePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;\n\t\t\tif (codePoint >= 0x0800) {\n\t\t\t\treturn codePoint;\n\t\t\t} else {\n\t\t\t\tthrow Error('Invalid continuation byte');\n\t\t\t}\n\t\t}\n\n\t\t// 4-byte sequence\n\t\tif ((byte1 & 0xF8) == 0xF0) {\n\t\t\tbyte2 = readContinuationByte();\n\t\t\tbyte3 = readContinuationByte();\n\t\t\tbyte4 = readContinuationByte();\n\t\t\tcodePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |\n\t\t\t\t(byte3 << 0x06) | byte4;\n\t\t\tif (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {\n\t\t\t\treturn codePoint;\n\t\t\t}\n\t\t}\n\n\t\tthrow Error('Invalid WTF-8 detected');\n\t}\n\n\tvar byteArray;\n\tvar byteCount;\n\tvar byteIndex;\n\tfunction wtf8decode(byteString) {\n\t\tbyteArray = ucs2decode(byteString);\n\t\tbyteCount = byteArray.length;\n\t\tbyteIndex = 0;\n\t\tvar codePoints = [];\n\t\tvar tmp;\n\t\twhile ((tmp = decodeSymbol()) !== false) {\n\t\t\tcodePoints.push(tmp);\n\t\t}\n\t\treturn ucs2encode(codePoints);\n\t}\n\n\t/*--------------------------------------------------------------------------*/\n\n\tvar wtf8 = {\n\t\t'version': '1.0.0',\n\t\t'encode': wtf8encode,\n\t\t'decode': wtf8decode\n\t};\n\n\t// Some AMD build optimizers, like r.js, check for specific condition patterns\n\t// like the following:\n\tif (\n\t\ttypeof define == 'function' &&\n\t\ttypeof define.amd == 'object' &&\n\t\tdefine.amd\n\t) {\n\t\tdefine(function() {\n\t\t\treturn wtf8;\n\t\t});\n\t}\telse if (freeExports && !freeExports.nodeType) {\n\t\tif (freeModule) { // in Node.js or RingoJS v0.8.0+\n\t\t\tfreeModule.exports = wtf8;\n\t\t} else { // in Narwhal or RingoJS v0.7.0-\n\t\t\tvar object = {};\n\t\t\tvar hasOwnProperty = object.hasOwnProperty;\n\t\t\tfor (var key in wtf8) {\n\t\t\t\thasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);\n\t\t\t}\n\t\t}\n\t} else { // in Rhino or a web browser\n\t\troot.wtf8 = wtf8;\n\t}\n\n}(this));\n\n}).call(this,typeof global !== \"undefined\" ? global : typeof self !== \"undefined\" ? self : typeof window !== \"undefined\" ? window : {})\n\n},{}],54:[function(require,module,exports){\n'use strict';\n\nvar alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')\n  , length = 64\n  , map = {}\n  , seed = 0\n  , i = 0\n  , prev;\n\n/**\n * Return a string representing the specified number.\n *\n * @param {Number} num The number to convert.\n * @returns {String} The string representation of the number.\n * @api public\n */\nfunction encode(num) {\n  var encoded = '';\n\n  do {\n    encoded = alphabet[num % length] + encoded;\n    num = Math.floor(num / length);\n  } while (num > 0);\n\n  return encoded;\n}\n\n/**\n * Return the integer value specified by the given string.\n *\n * @param {String} str The string to convert.\n * @returns {Number} The integer value represented by the string.\n * @api public\n */\nfunction decode(str) {\n  var decoded = 0;\n\n  for (i = 0; i < str.length; i++) {\n    decoded = decoded * length + map[str.charAt(i)];\n  }\n\n  return decoded;\n}\n\n/**\n * Yeast: A tiny growing id generator.\n *\n * @returns {String} A unique id.\n * @api public\n */\nfunction yeast() {\n  var now = encode(+new Date());\n\n  if (now !== prev) return seed = 0, prev = now;\n  return now +'.'+ encode(seed++);\n}\n\n//\n// Map each character to its index.\n//\nfor (; i < length; i++) map[alphabet[i]] = i;\n\n//\n// Expose the `yeast`, `encode` and `decode` functions.\n//\nyeast.encode = encode;\nyeast.decode = decode;\nmodule.exports = yeast;\n\n},{}],55:[function(require,module,exports){\n\"use strict\";\n\n// this is what is returned by new Rltm()\nmodule.exports = function(setup) {\n\n    // these are available realtime providers and their definitions\n    const services = {\n        pubnub: require('./services/pubnub'),\n        socketio: require('./services/socketio') \n    };\n    \n    // return error if service is not set\n    let service = services[setup.service];\n\n    if(!setup.service) {\n        throw new Error('You must supply a service property.');\n    }\n    \n    if(!service) {\n        throw new Error('The service you supplied is invalid.');\n    } \n    \n    // add config if doesn't exist\n    setup.config = setup.config || {};\n\n    // set a default uuid if it has not been set for this user\n    setup.config.uuid = setup.config.uuid || new Date();\n\n    // set this uuid if it is not set\n    setup.config.state = setup.config.state || {};\n\n    // immediately invoke and return the main function\n    return new service(setup);\n\n}; \n\n},{\"./services/pubnub\":56,\"./services/socketio\":57}],56:[function(require,module,exports){\n\"use strict\";\n\n// include the NodeJS event emitter\nconst EventEmitter = require('events');\n\n// include the PubNub javascript sdk v4\nconst PubNub = require('pubnub');\nlet globalReady = false;\n\n// represents a connection to a single channel\nclass Room extends EventEmitter {\n\n    constructor(pubnub, channel, uuid, state) {\n\n        // call the EventEmitter constructor\n        super();\n\n        // determine the user's state \n        state = state || {};\n\n        // store this users uuid\n        this.uuid = uuid;\n\n        // assign the channel parameter as a property\n        this.channel = channel;\n\n        // save pubnub in the instance of room\n        this.pubnub = pubnub;\n\n        this.isReady = false;\n        \n        // use the PubNub library to listen for messages\n        this.pubnub.addListener({\n\n            status: (statusEvent) => {\n\n                // detect if this is a connection event on this channel\n                if (statusEvent.category === \"PNConnectedCategory\" \n                    && !this.isReady\n                    && statusEvent.affectedChannels.indexOf(channel) > -1) {\n\n                    globalReady = true;\n\n                    // tell the user that first connection made\n                    this.onReady();\n\n                }\n            }\n        });\n\n        this.pubnub.addListener({\n            message: (m) => {\n\n                // if message is sent to this specific channel\n                if(channel == m.channel) {\n\n                    // emit the message as an event\n                    this.emit('message', m.message.uuid, m.message.data);   \n\n                }\n            },\n            presence: (presenceEvent) => {\n\n                // make sure channel matches this channel\n                if(channel == presenceEvent.channel) {\n\n                    // someone joins channel\n                    if(presenceEvent.action == \"join\") {\n\n                        this.emit('join', \n                            presenceEvent.uuid, presenceEvent.state);\n                    }\n\n                    // someone leaves channel\n                    if(presenceEvent.action == \"leave\") {\n                        this.emit('leave', presenceEvent.uuid);\n                    }\n\n                    // someone timesout\n                    if(presenceEvent.action == \"timeout\") {\n                        this.emit('disconnect', presenceEvent.uuid);\n                    }\n                    \n                    // someone's state is updated\n                    if(presenceEvent.action == \"state-change\") {\n                        this.emit('state', \n                            presenceEvent.uuid, presenceEvent.state);\n                    }\n                       \n                }\n\n            }\n        });\n\n        // tell PubNub to subscribe to the supplied channel\n        this.pubnub.subscribe({ \n            channels: [channel],\n            withPresence: true,\n            state: state\n        });\n\n    }\n\n    // ready is a callback and not an event because pubnub may be ready\n    // immediately, which doesn't allow time to register an event handler\n    // this can be solved with setTimeout(() => {}, 10) to let the \n    onReady() {\n\n        // waiting to be assigned by user\n        return;\n\n    }\n\n    ready (fn) {\n        \n        this.onReady = fn;\n\n        if(globalReady) {\n            this.onReady()\n            this.isReady = true;\n        }\n\n    }\n\n    message (data) {\n\n        return new Promise((resolve, reject) => {\n          \n          // publish the given data over PubNub channel\n          this.pubnub.publish({\n              channel: this.channel,\n              message: {\n                  uuid: this.uuid,\n                  data: data\n              }\n          }, (status, response) => {\n\n            if(status.error) {\n                // if there's a problem publishing, reject\n                reject(status);\n            } else {\n                resolve();\n            }\n\n          });\n\n        });\n\n    };\n\n    here() {\n\n        return new Promise((resolve, reject) => {\n        \n            // ask PubNub for information about connected users in this channel\n            this.pubnub.hereNow({\n                channels: [this.channel],\n                includeUUIDs: true,\n                includeState: true\n            }, (status, response) => {\n\n                if(status.error) {\n                    // if there's a problem with the request, reject\n                    reject(status)\n                } else {\n\n                    // build a userlist in rltm.js format\n                    let userList = {};\n\n                    // get the list of occupants in this channel\n                    let occupants = response.channels[this.channel].occupants;\n\n                    // format the userList for rltm.js standard\n                    for(let i in occupants) {\n                        userList[occupants[i].uuid] = occupants[i].state;\n                    }\n\n                    // respond with formatted list\n                    resolve(userList);\n\n                }\n\n            });\n\n        });\n\n    }\n\n    state(state) {\n\n        return new Promise((resolve, reject) => {\n            \n            // use PubNub state function to update state for channel\n            this.pubnub.setState({\n                state: state,\n                uuid: this.uuid,\n                channels: [this.channel]\n            }, (status, response) => {\n                \n                if(status.error) {\n                    // if there's a problem with the request log it\n                    reject(status);            \n                } else {\n                    resolve();\n                }\n\n            });\n\n        });\n\n    }\n\n    history() {\n        \n        return new Promise((resolve, reject) => {\n\n            // retrieved the message history with PubNub\n            this.pubnub.history({\n                channel: this.channel,\n                count: 100 // how many items to fetch\n            }, (status, response) => {\n\n                if(status.error) {\n                    // if there's a problem with the request log it\n                    reject(status);            \n                } else {\n                    \n                    // create our return array\n                    let data = [];\n\n                    // loop through response and push data to array\n                    for(let i in response.messages) {\n                        data.push(response.messages[i].entry)\n                    }   \n\n                    // reverse the array so newest are first\n                    data = data.reverse();\n\n                    // respond with the history data\n                    resolve(data);\n\n                }\n\n            });\n\n        });\n\n    }\n\n    leave() {\n\n        return new Promise((resolve, reject) => {\n            \n            // tell PubNub to manually unsubscribe from this channel        \n            this.pubnub.unsubscribe({\n                channels: [this.channel],\n            });\n\n            resolve();\n\n        });\n\n    }\n}\n\n// export a generic function expected by rltm.js\nmodule.exports = function(setup) {\n\n    // convenience method to assign the service string name to itself\n    this.service = setup.service;\n\n    // initialize PubNub with supplied config information\n    this.pubnub = new PubNub(setup.config);\n\n    // expose the join method to create new room connections\n    this.join = (channel, state) => {\n        return new Room(this.pubnub, channel, setup.config.uuid, state);\n    }\n\n    // return the instance of this service\n    return this;\n\n};\n\n},{\"events\":25,\"pubnub\":35}],57:[function(require,module,exports){\n\"use strict\";\n\n// include NodeJS event emitter\nconst EventEmitter = require('events');\n\n// include the Socket.io user library\nconst io = require('socket.io-client');\n\n// represents a connection to a single channel\nclass Room extends EventEmitter {\n\n    constructor(endpoint, channel, uuid, state) {\n\n        // call the EventEmitter constructor\n        super();\n\n        // store this users uuid\n        this.uuid = uuid;\n\n        // assign the channel parameter as a property\n        this.channel = channel;\n\n        this.isReady = false;\n\n        // create a connection to the socketio endpoint\n        this.socket = io.connect(endpoint, {multiplex: true});\n\n        // subscribe to the socket.io connection event\n        this.socket.on('connect', () => {\n\n            // tell the server that we want to join a channel\n            this.socket.emit('channel', channel, this.uuid, state);\n\n            // tell the user the server is ready\n            this.onReady();\n            this.isReady = true;\n\n        });\n\n        // server says someone has joined\n        this.socket.on('join', (channel, uuid, state) => {\n\n            // make sure the channel is this channel\n            if(this.channel == channel) {\n\n                // emit the 'join' event to the user\n                this.emit('join', uuid, state);\n\n            }\n\n        });\n\n        // server says someone has left\n        this.socket.on('leave', (channel, uuid) => {\n\n            // make sure it's on this channel\n            if(this.channel == channel) {\n\n                // emit the 'leave' event to the user\n                this.emit('leave', uuid);\n            }\n\n        });\n\n\n        // server says someone has disconnected\n        this.socket.on('disconnect', (channel, uuid) => {\n\n            // make sure it's on this channel\n            if(this.channel == channel) {\n\n                // emit the 'leave' event to the user\n                this.emit('disconnect', uuid);\n            }\n\n        });\n\n        // a message is sent from the srever\n        this.socket.on('message', (channel, uuid, data) => {\n\n            // make sure it is on this channel\n            if(this.channel == channel) {\n\n                // tell the user of the new message\n                this.emit('message', uuid, data);\n            }\n\n        });\n\n        // a user sets their state\n        this.socket.on('state', (channel, uuid, state) => {\n\n            // make sure it is on this channel\n            if(this.channel == channel) {\n\n                // tell the user of the set state\n                this.emit('state', uuid, state);\n            }\n\n        });\n\n    }\n    ready(fn) {\n        \n        this.onReady = fn;\n        \n        if(this.isReady) {\n            this.onReady();\n        }\n\n    }\n    onReady() {\n        // waiting to be assigned by user\n        return;\n    }\n    message(data) {\n\n        return new Promise((resolve, reject) => {\n\n            // publish the data to the socket.io server\n            this.socket.emit('publish', this.channel, this.uuid, data, () =>{\n                resolve();\n            });\n\n        });\n\n    }\n    here() {\n        \n        // ask socket.io-server for a list of online users\n        return new Promise((resolve, reject) => {\n            \n            this.socket.emit('whosonline', this.channel, null, function(users) {\n\n                // callback with an object of users\n                resolve(users);\n\n            });\n\n        });\n\n    }\n    state(state) {\n        \n        return new Promise((resolve, reject) => {\n\n            // tell socket.io-server to update this user's state\n            this.socket.emit('setState', this.channel, this.uuid, state, () => {\n                resolve();\n            });\n\n        });\n\n    }\n    history() {\n        \n        return new Promise((resolve, reject) => {\n                        \n            // ask socket.io-server for the history of messages published\n            this.socket.emit('history', this.channel, (data) => {\n\n                // callback with an array of messages\n                resolve(data);\n\n            });\n\n        });\n\n    }\n    leave(channel) {\n        \n        return new Promise((resolve, reject) => {\n\n            // manually disconnect from socket.io-server\n            this.socket.emit('leave', this.uuid, channel, () => {\n\n                resolve();\n\n            });\n\n        });\n\n    }\n    \n}\n\nmodule.exports = function (setup) {\n\n    // convenience method to assign the service string name to itself\n    this.service = setup.service;\n\n    this.join = (channel, state) => {\n        return new Room(setup.config.endpoint, channel, setup.config.uuid, setup.config.state);\n    };\n\n    return this;\n\n};\n\n},{\"events\":25,\"socket.io-client\":36}]},{},[55])(55)\n});\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vZGVfbW9kdWxlcy9icm93c2VyLXBhY2svX3ByZWx1ZGUuanMiLCJub2RlX21vZHVsZXMvYWZ0ZXIvaW5kZXguanMiLCJub2RlX21vZHVsZXMvYXJyYXlidWZmZXIuc2xpY2UvaW5kZXguanMiLCJub2RlX21vZHVsZXMvYmFja28yL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL2Jhc2U2NC1hcnJheWJ1ZmZlci9saWIvYmFzZTY0LWFycmF5YnVmZmVyLmpzIiwibm9kZV9tb2R1bGVzL2Jsb2IvaW5kZXguanMiLCJub2RlX21vZHVsZXMvYnJvd3Nlci1yZXNvbHZlL2VtcHR5LmpzIiwibm9kZV9tb2R1bGVzL2NvbXBvbmVudC1iaW5kL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL2NvbXBvbmVudC1lbWl0dGVyL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL2NvbXBvbmVudC1pbmhlcml0L2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL2VuZ2luZS5pby1jbGllbnQvaW5kZXguanMiLCJub2RlX21vZHVsZXMvZW5naW5lLmlvLWNsaWVudC9saWIvaW5kZXguanMiLCJub2RlX21vZHVsZXMvZW5naW5lLmlvLWNsaWVudC9saWIvc29ja2V0LmpzIiwibm9kZV9tb2R1bGVzL2VuZ2luZS5pby1jbGllbnQvbGliL3RyYW5zcG9ydC5qcyIsIm5vZGVfbW9kdWxlcy9lbmdpbmUuaW8tY2xpZW50L2xpYi90cmFuc3BvcnRzL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL2VuZ2luZS5pby1jbGllbnQvbGliL3RyYW5zcG9ydHMvcG9sbGluZy1qc29ucC5qcyIsIm5vZGVfbW9kdWxlcy9lbmdpbmUuaW8tY2xpZW50L2xpYi90cmFuc3BvcnRzL3BvbGxpbmcteGhyLmpzIiwibm9kZV9tb2R1bGVzL2VuZ2luZS5pby1jbGllbnQvbGliL3RyYW5zcG9ydHMvcG9sbGluZy5qcyIsIm5vZGVfbW9kdWxlcy9lbmdpbmUuaW8tY2xpZW50L2xpYi90cmFuc3BvcnRzL3dlYnNvY2tldC5qcyIsIm5vZGVfbW9kdWxlcy9lbmdpbmUuaW8tY2xpZW50L2xpYi94bWxodHRwcmVxdWVzdC5qcyIsIm5vZGVfbW9kdWxlcy9lbmdpbmUuaW8tY2xpZW50L25vZGVfbW9kdWxlcy9kZWJ1Zy9icm93c2VyLmpzIiwibm9kZV9tb2R1bGVzL2VuZ2luZS5pby1jbGllbnQvbm9kZV9tb2R1bGVzL2RlYnVnL2RlYnVnLmpzIiwibm9kZV9tb2R1bGVzL2VuZ2luZS5pby1jbGllbnQvbm9kZV9tb2R1bGVzL21zL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL2VuZ2luZS5pby1wYXJzZXIvbGliL2Jyb3dzZXIuanMiLCJub2RlX21vZHVsZXMvZW5naW5lLmlvLXBhcnNlci9saWIva2V5cy5qcyIsIm5vZGVfbW9kdWxlcy9ldmVudHMvZXZlbnRzLmpzIiwibm9kZV9tb2R1bGVzL2hhcy1iaW5hcnkvaW5kZXguanMiLCJub2RlX21vZHVsZXMvaGFzLWJpbmFyeS9ub2RlX21vZHVsZXMvaXNhcnJheS9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9oYXMtY29ycy9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9pbmRleG9mL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL2pzb24zL2xpYi9qc29uMy5qcyIsIm5vZGVfbW9kdWxlcy9wYXJzZWpzb24vaW5kZXguanMiLCJub2RlX21vZHVsZXMvcGFyc2Vxcy9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9wYXJzZXVyaS9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9wcm9jZXNzL2Jyb3dzZXIuanMiLCJub2RlX21vZHVsZXMvcHVibnViL2Rpc3Qvd2ViL3B1Ym51Yi5taW4uanMiLCJub2RlX21vZHVsZXMvc29ja2V0LmlvLWNsaWVudC9saWIvaW5kZXguanMiLCJub2RlX21vZHVsZXMvc29ja2V0LmlvLWNsaWVudC9saWIvbWFuYWdlci5qcyIsIm5vZGVfbW9kdWxlcy9zb2NrZXQuaW8tY2xpZW50L2xpYi9vbi5qcyIsIm5vZGVfbW9kdWxlcy9zb2NrZXQuaW8tY2xpZW50L2xpYi9zb2NrZXQuanMiLCJub2RlX21vZHVsZXMvc29ja2V0LmlvLWNsaWVudC9saWIvdXJsLmpzIiwibm9kZV9tb2R1bGVzL3NvY2tldC5pby1jbGllbnQvbm9kZV9tb2R1bGVzL2RlYnVnL2Jyb3dzZXIuanMiLCJub2RlX21vZHVsZXMvc29ja2V0LmlvLXBhcnNlci9iaW5hcnkuanMiLCJub2RlX21vZHVsZXMvc29ja2V0LmlvLXBhcnNlci9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9zb2NrZXQuaW8tcGFyc2VyL2lzLWJ1ZmZlci5qcyIsIm5vZGVfbW9kdWxlcy9zb2NrZXQuaW8tcGFyc2VyL25vZGVfbW9kdWxlcy9jb21wb25lbnQtZW1pdHRlci9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9zb2NrZXQuaW8tcGFyc2VyL25vZGVfbW9kdWxlcy9kZWJ1Zy9icm93c2VyLmpzIiwibm9kZV9tb2R1bGVzL3NvY2tldC5pby1wYXJzZXIvbm9kZV9tb2R1bGVzL2RlYnVnL2RlYnVnLmpzIiwibm9kZV9tb2R1bGVzL3NvY2tldC5pby1wYXJzZXIvbm9kZV9tb2R1bGVzL21zL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL3RvLWFycmF5L2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL3d0Zi04L3d0Zi04LmpzIiwibm9kZV9tb2R1bGVzL3llYXN0L2luZGV4LmpzIiwic3JjL2luZGV4LmpzIiwic3JjL3NlcnZpY2VzL3B1Ym51Yi5qcyIsInNyYy9zZXJ2aWNlcy9zb2NrZXRpby5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQ0FBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDNUJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUM3QkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNyRkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7O0FDbkVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7O0FDaEdBOztBQ0FBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUN2QkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNuS0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQ1ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7O0FDbHVCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7QUM3SkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7OztBQ3JEQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7QUN2T0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7OztBQ3hhQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQ3JQQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7QUM3UkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7QUNyQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7QUNqTEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3hNQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQ3JKQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7OztBQ2ptQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNuQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7QUM5U0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7O0FDM0RBO0FBQ0E7QUFDQTtBQUNBOztBQ0hBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNqQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQ1RBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7QUN0NEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7QUMvQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNyQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDdkNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3BMQTtBQUNBO0FBQ0E7O0FDRkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUM3R0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ2hqQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDeEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7O0FDbmFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7OztBQzNFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7Ozs7O0FDakxBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7O0FDN0lBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7O0FDcFpBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7QUNiQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDcEtBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3hLQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7QUNyTUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzdIQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7QUNiQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7OztBQzFPQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDcEVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNuQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUMzUkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIihmdW5jdGlvbiBlKHQsbixyKXtmdW5jdGlvbiBzKG8sdSl7aWYoIW5bb10pe2lmKCF0W29dKXt2YXIgYT10eXBlb2YgcmVxdWlyZT09XCJmdW5jdGlvblwiJiZyZXF1aXJlO2lmKCF1JiZhKXJldHVybiBhKG8sITApO2lmKGkpcmV0dXJuIGkobywhMCk7dmFyIGY9bmV3IEVycm9yKFwiQ2Fubm90IGZpbmQgbW9kdWxlICdcIitvK1wiJ1wiKTt0aHJvdyBmLmNvZGU9XCJNT0RVTEVfTk9UX0ZPVU5EXCIsZn12YXIgbD1uW29dPXtleHBvcnRzOnt9fTt0W29dWzBdLmNhbGwobC5leHBvcnRzLGZ1bmN0aW9uKGUpe3ZhciBuPXRbb11bMV1bZV07cmV0dXJuIHMobj9uOmUpfSxsLGwuZXhwb3J0cyxlLHQsbixyKX1yZXR1cm4gbltvXS5leHBvcnRzfXZhciBpPXR5cGVvZiByZXF1aXJlPT1cImZ1bmN0aW9uXCImJnJlcXVpcmU7Zm9yKHZhciBvPTA7bzxyLmxlbmd0aDtvKyspcyhyW29dKTtyZXR1cm4gc30pIiwibW9kdWxlLmV4cG9ydHMgPSBhZnRlclxuXG5mdW5jdGlvbiBhZnRlcihjb3VudCwgY2FsbGJhY2ssIGVycl9jYikge1xuICAgIHZhciBiYWlsID0gZmFsc2VcbiAgICBlcnJfY2IgPSBlcnJfY2IgfHwgbm9vcFxuICAgIHByb3h5LmNvdW50ID0gY291bnRcblxuICAgIHJldHVybiAoY291bnQgPT09IDApID8gY2FsbGJhY2soKSA6IHByb3h5XG5cbiAgICBmdW5jdGlvbiBwcm94eShlcnIsIHJlc3VsdCkge1xuICAgICAgICBpZiAocHJveHkuY291bnQgPD0gMCkge1xuICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKCdhZnRlciBjYWxsZWQgdG9vIG1hbnkgdGltZXMnKVxuICAgICAgICB9XG4gICAgICAgIC0tcHJveHkuY291bnRcblxuICAgICAgICAvLyBhZnRlciBmaXJzdCBlcnJvciwgcmVzdCBhcmUgcGFzc2VkIHRvIGVycl9jYlxuICAgICAgICBpZiAoZXJyKSB7XG4gICAgICAgICAgICBiYWlsID0gdHJ1ZVxuICAgICAgICAgICAgY2FsbGJhY2soZXJyKVxuICAgICAgICAgICAgLy8gZnV0dXJlIGVycm9yIGNhbGxiYWNrcyB3aWxsIGdvIHRvIGVycm9yIGhhbmRsZXJcbiAgICAgICAgICAgIGNhbGxiYWNrID0gZXJyX2NiXG4gICAgICAgIH0gZWxzZSBpZiAocHJveHkuY291bnQgPT09IDAgJiYgIWJhaWwpIHtcbiAgICAgICAgICAgIGNhbGxiYWNrKG51bGwsIHJlc3VsdClcbiAgICAgICAgfVxuICAgIH1cbn1cblxuZnVuY3Rpb24gbm9vcCgpIHt9XG4iLCIvKipcbiAqIEFuIGFic3RyYWN0aW9uIGZvciBzbGljaW5nIGFuIGFycmF5YnVmZmVyIGV2ZW4gd2hlblxuICogQXJyYXlCdWZmZXIucHJvdG90eXBlLnNsaWNlIGlzIG5vdCBzdXBwb3J0ZWRcbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oYXJyYXlidWZmZXIsIHN0YXJ0LCBlbmQpIHtcbiAgdmFyIGJ5dGVzID0gYXJyYXlidWZmZXIuYnl0ZUxlbmd0aDtcbiAgc3RhcnQgPSBzdGFydCB8fCAwO1xuICBlbmQgPSBlbmQgfHwgYnl0ZXM7XG5cbiAgaWYgKGFycmF5YnVmZmVyLnNsaWNlKSB7IHJldHVybiBhcnJheWJ1ZmZlci5zbGljZShzdGFydCwgZW5kKTsgfVxuXG4gIGlmIChzdGFydCA8IDApIHsgc3RhcnQgKz0gYnl0ZXM7IH1cbiAgaWYgKGVuZCA8IDApIHsgZW5kICs9IGJ5dGVzOyB9XG4gIGlmIChlbmQgPiBieXRlcykgeyBlbmQgPSBieXRlczsgfVxuXG4gIGlmIChzdGFydCA+PSBieXRlcyB8fCBzdGFydCA+PSBlbmQgfHwgYnl0ZXMgPT09IDApIHtcbiAgICByZXR1cm4gbmV3IEFycmF5QnVmZmVyKDApO1xuICB9XG5cbiAgdmFyIGFidiA9IG5ldyBVaW50OEFycmF5KGFycmF5YnVmZmVyKTtcbiAgdmFyIHJlc3VsdCA9IG5ldyBVaW50OEFycmF5KGVuZCAtIHN0YXJ0KTtcbiAgZm9yICh2YXIgaSA9IHN0YXJ0LCBpaSA9IDA7IGkgPCBlbmQ7IGkrKywgaWkrKykge1xuICAgIHJlc3VsdFtpaV0gPSBhYnZbaV07XG4gIH1cbiAgcmV0dXJuIHJlc3VsdC5idWZmZXI7XG59O1xuIiwiXG4vKipcbiAqIEV4cG9zZSBgQmFja29mZmAuXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSBCYWNrb2ZmO1xuXG4vKipcbiAqIEluaXRpYWxpemUgYmFja29mZiB0aW1lciB3aXRoIGBvcHRzYC5cbiAqXG4gKiAtIGBtaW5gIGluaXRpYWwgdGltZW91dCBpbiBtaWxsaXNlY29uZHMgWzEwMF1cbiAqIC0gYG1heGAgbWF4IHRpbWVvdXQgWzEwMDAwXVxuICogLSBgaml0dGVyYCBbMF1cbiAqIC0gYGZhY3RvcmAgWzJdXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IG9wdHNcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gQmFja29mZihvcHRzKSB7XG4gIG9wdHMgPSBvcHRzIHx8IHt9O1xuICB0aGlzLm1zID0gb3B0cy5taW4gfHwgMTAwO1xuICB0aGlzLm1heCA9IG9wdHMubWF4IHx8IDEwMDAwO1xuICB0aGlzLmZhY3RvciA9IG9wdHMuZmFjdG9yIHx8IDI7XG4gIHRoaXMuaml0dGVyID0gb3B0cy5qaXR0ZXIgPiAwICYmIG9wdHMuaml0dGVyIDw9IDEgPyBvcHRzLmppdHRlciA6IDA7XG4gIHRoaXMuYXR0ZW1wdHMgPSAwO1xufVxuXG4vKipcbiAqIFJldHVybiB0aGUgYmFja29mZiBkdXJhdGlvbi5cbiAqXG4gKiBAcmV0dXJuIHtOdW1iZXJ9XG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbkJhY2tvZmYucHJvdG90eXBlLmR1cmF0aW9uID0gZnVuY3Rpb24oKXtcbiAgdmFyIG1zID0gdGhpcy5tcyAqIE1hdGgucG93KHRoaXMuZmFjdG9yLCB0aGlzLmF0dGVtcHRzKyspO1xuICBpZiAodGhpcy5qaXR0ZXIpIHtcbiAgICB2YXIgcmFuZCA9ICBNYXRoLnJhbmRvbSgpO1xuICAgIHZhciBkZXZpYXRpb24gPSBNYXRoLmZsb29yKHJhbmQgKiB0aGlzLmppdHRlciAqIG1zKTtcbiAgICBtcyA9IChNYXRoLmZsb29yKHJhbmQgKiAxMCkgJiAxKSA9PSAwICA/IG1zIC0gZGV2aWF0aW9uIDogbXMgKyBkZXZpYXRpb247XG4gIH1cbiAgcmV0dXJuIE1hdGgubWluKG1zLCB0aGlzLm1heCkgfCAwO1xufTtcblxuLyoqXG4gKiBSZXNldCB0aGUgbnVtYmVyIG9mIGF0dGVtcHRzLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuQmFja29mZi5wcm90b3R5cGUucmVzZXQgPSBmdW5jdGlvbigpe1xuICB0aGlzLmF0dGVtcHRzID0gMDtcbn07XG5cbi8qKlxuICogU2V0IHRoZSBtaW5pbXVtIGR1cmF0aW9uXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5CYWNrb2ZmLnByb3RvdHlwZS5zZXRNaW4gPSBmdW5jdGlvbihtaW4pe1xuICB0aGlzLm1zID0gbWluO1xufTtcblxuLyoqXG4gKiBTZXQgdGhlIG1heGltdW0gZHVyYXRpb25cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbkJhY2tvZmYucHJvdG90eXBlLnNldE1heCA9IGZ1bmN0aW9uKG1heCl7XG4gIHRoaXMubWF4ID0gbWF4O1xufTtcblxuLyoqXG4gKiBTZXQgdGhlIGppdHRlclxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuQmFja29mZi5wcm90b3R5cGUuc2V0Sml0dGVyID0gZnVuY3Rpb24oaml0dGVyKXtcbiAgdGhpcy5qaXR0ZXIgPSBqaXR0ZXI7XG59O1xuXG4iLCIvKlxuICogYmFzZTY0LWFycmF5YnVmZmVyXG4gKiBodHRwczovL2dpdGh1Yi5jb20vbmlrbGFzdmgvYmFzZTY0LWFycmF5YnVmZmVyXG4gKlxuICogQ29weXJpZ2h0IChjKSAyMDEyIE5pa2xhcyB2b24gSGVydHplblxuICogTGljZW5zZWQgdW5kZXIgdGhlIE1JVCBsaWNlbnNlLlxuICovXG4oZnVuY3Rpb24oKXtcbiAgXCJ1c2Ugc3RyaWN0XCI7XG5cbiAgdmFyIGNoYXJzID0gXCJBQkNERUZHSElKS0xNTk9QUVJTVFVWV1hZWmFiY2RlZmdoaWprbG1ub3BxcnN0dXZ3eHl6MDEyMzQ1Njc4OSsvXCI7XG5cbiAgLy8gVXNlIGEgbG9va3VwIHRhYmxlIHRvIGZpbmQgdGhlIGluZGV4LlxuICB2YXIgbG9va3VwID0gbmV3IFVpbnQ4QXJyYXkoMjU2KTtcbiAgZm9yICh2YXIgaSA9IDA7IGkgPCBjaGFycy5sZW5ndGg7IGkrKykge1xuICAgIGxvb2t1cFtjaGFycy5jaGFyQ29kZUF0KGkpXSA9IGk7XG4gIH1cblxuICBleHBvcnRzLmVuY29kZSA9IGZ1bmN0aW9uKGFycmF5YnVmZmVyKSB7XG4gICAgdmFyIGJ5dGVzID0gbmV3IFVpbnQ4QXJyYXkoYXJyYXlidWZmZXIpLFxuICAgIGksIGxlbiA9IGJ5dGVzLmxlbmd0aCwgYmFzZTY0ID0gXCJcIjtcblxuICAgIGZvciAoaSA9IDA7IGkgPCBsZW47IGkrPTMpIHtcbiAgICAgIGJhc2U2NCArPSBjaGFyc1tieXRlc1tpXSA+PiAyXTtcbiAgICAgIGJhc2U2NCArPSBjaGFyc1soKGJ5dGVzW2ldICYgMykgPDwgNCkgfCAoYnl0ZXNbaSArIDFdID4+IDQpXTtcbiAgICAgIGJhc2U2NCArPSBjaGFyc1soKGJ5dGVzW2kgKyAxXSAmIDE1KSA8PCAyKSB8IChieXRlc1tpICsgMl0gPj4gNildO1xuICAgICAgYmFzZTY0ICs9IGNoYXJzW2J5dGVzW2kgKyAyXSAmIDYzXTtcbiAgICB9XG5cbiAgICBpZiAoKGxlbiAlIDMpID09PSAyKSB7XG4gICAgICBiYXNlNjQgPSBiYXNlNjQuc3Vic3RyaW5nKDAsIGJhc2U2NC5sZW5ndGggLSAxKSArIFwiPVwiO1xuICAgIH0gZWxzZSBpZiAobGVuICUgMyA9PT0gMSkge1xuICAgICAgYmFzZTY0ID0gYmFzZTY0LnN1YnN0cmluZygwLCBiYXNlNjQubGVuZ3RoIC0gMikgKyBcIj09XCI7XG4gICAgfVxuXG4gICAgcmV0dXJuIGJhc2U2NDtcbiAgfTtcblxuICBleHBvcnRzLmRlY29kZSA9ICBmdW5jdGlvbihiYXNlNjQpIHtcbiAgICB2YXIgYnVmZmVyTGVuZ3RoID0gYmFzZTY0Lmxlbmd0aCAqIDAuNzUsXG4gICAgbGVuID0gYmFzZTY0Lmxlbmd0aCwgaSwgcCA9IDAsXG4gICAgZW5jb2RlZDEsIGVuY29kZWQyLCBlbmNvZGVkMywgZW5jb2RlZDQ7XG5cbiAgICBpZiAoYmFzZTY0W2Jhc2U2NC5sZW5ndGggLSAxXSA9PT0gXCI9XCIpIHtcbiAgICAgIGJ1ZmZlckxlbmd0aC0tO1xuICAgICAgaWYgKGJhc2U2NFtiYXNlNjQubGVuZ3RoIC0gMl0gPT09IFwiPVwiKSB7XG4gICAgICAgIGJ1ZmZlckxlbmd0aC0tO1xuICAgICAgfVxuICAgIH1cblxuICAgIHZhciBhcnJheWJ1ZmZlciA9IG5ldyBBcnJheUJ1ZmZlcihidWZmZXJMZW5ndGgpLFxuICAgIGJ5dGVzID0gbmV3IFVpbnQ4QXJyYXkoYXJyYXlidWZmZXIpO1xuXG4gICAgZm9yIChpID0gMDsgaSA8IGxlbjsgaSs9NCkge1xuICAgICAgZW5jb2RlZDEgPSBsb29rdXBbYmFzZTY0LmNoYXJDb2RlQXQoaSldO1xuICAgICAgZW5jb2RlZDIgPSBsb29rdXBbYmFzZTY0LmNoYXJDb2RlQXQoaSsxKV07XG4gICAgICBlbmNvZGVkMyA9IGxvb2t1cFtiYXNlNjQuY2hhckNvZGVBdChpKzIpXTtcbiAgICAgIGVuY29kZWQ0ID0gbG9va3VwW2Jhc2U2NC5jaGFyQ29kZUF0KGkrMyldO1xuXG4gICAgICBieXRlc1twKytdID0gKGVuY29kZWQxIDw8IDIpIHwgKGVuY29kZWQyID4+IDQpO1xuICAgICAgYnl0ZXNbcCsrXSA9ICgoZW5jb2RlZDIgJiAxNSkgPDwgNCkgfCAoZW5jb2RlZDMgPj4gMik7XG4gICAgICBieXRlc1twKytdID0gKChlbmNvZGVkMyAmIDMpIDw8IDYpIHwgKGVuY29kZWQ0ICYgNjMpO1xuICAgIH1cblxuICAgIHJldHVybiBhcnJheWJ1ZmZlcjtcbiAgfTtcbn0pKCk7XG4iLCIvKipcbiAqIENyZWF0ZSBhIGJsb2IgYnVpbGRlciBldmVuIHdoZW4gdmVuZG9yIHByZWZpeGVzIGV4aXN0XG4gKi9cblxudmFyIEJsb2JCdWlsZGVyID0gZ2xvYmFsLkJsb2JCdWlsZGVyXG4gIHx8IGdsb2JhbC5XZWJLaXRCbG9iQnVpbGRlclxuICB8fCBnbG9iYWwuTVNCbG9iQnVpbGRlclxuICB8fCBnbG9iYWwuTW96QmxvYkJ1aWxkZXI7XG5cbi8qKlxuICogQ2hlY2sgaWYgQmxvYiBjb25zdHJ1Y3RvciBpcyBzdXBwb3J0ZWRcbiAqL1xuXG52YXIgYmxvYlN1cHBvcnRlZCA9IChmdW5jdGlvbigpIHtcbiAgdHJ5IHtcbiAgICB2YXIgYSA9IG5ldyBCbG9iKFsnaGknXSk7XG4gICAgcmV0dXJuIGEuc2l6ZSA9PT0gMjtcbiAgfSBjYXRjaChlKSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG59KSgpO1xuXG4vKipcbiAqIENoZWNrIGlmIEJsb2IgY29uc3RydWN0b3Igc3VwcG9ydHMgQXJyYXlCdWZmZXJWaWV3c1xuICogRmFpbHMgaW4gU2FmYXJpIDYsIHNvIHdlIG5lZWQgdG8gbWFwIHRvIEFycmF5QnVmZmVycyB0aGVyZS5cbiAqL1xuXG52YXIgYmxvYlN1cHBvcnRzQXJyYXlCdWZmZXJWaWV3ID0gYmxvYlN1cHBvcnRlZCAmJiAoZnVuY3Rpb24oKSB7XG4gIHRyeSB7XG4gICAgdmFyIGIgPSBuZXcgQmxvYihbbmV3IFVpbnQ4QXJyYXkoWzEsMl0pXSk7XG4gICAgcmV0dXJuIGIuc2l6ZSA9PT0gMjtcbiAgfSBjYXRjaChlKSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG59KSgpO1xuXG4vKipcbiAqIENoZWNrIGlmIEJsb2JCdWlsZGVyIGlzIHN1cHBvcnRlZFxuICovXG5cbnZhciBibG9iQnVpbGRlclN1cHBvcnRlZCA9IEJsb2JCdWlsZGVyXG4gICYmIEJsb2JCdWlsZGVyLnByb3RvdHlwZS5hcHBlbmRcbiAgJiYgQmxvYkJ1aWxkZXIucHJvdG90eXBlLmdldEJsb2I7XG5cbi8qKlxuICogSGVscGVyIGZ1bmN0aW9uIHRoYXQgbWFwcyBBcnJheUJ1ZmZlclZpZXdzIHRvIEFycmF5QnVmZmVyc1xuICogVXNlZCBieSBCbG9iQnVpbGRlciBjb25zdHJ1Y3RvciBhbmQgb2xkIGJyb3dzZXJzIHRoYXQgZGlkbid0XG4gKiBzdXBwb3J0IGl0IGluIHRoZSBCbG9iIGNvbnN0cnVjdG9yLlxuICovXG5cbmZ1bmN0aW9uIG1hcEFycmF5QnVmZmVyVmlld3MoYXJ5KSB7XG4gIGZvciAodmFyIGkgPSAwOyBpIDwgYXJ5Lmxlbmd0aDsgaSsrKSB7XG4gICAgdmFyIGNodW5rID0gYXJ5W2ldO1xuICAgIGlmIChjaHVuay5idWZmZXIgaW5zdGFuY2VvZiBBcnJheUJ1ZmZlcikge1xuICAgICAgdmFyIGJ1ZiA9IGNodW5rLmJ1ZmZlcjtcblxuICAgICAgLy8gaWYgdGhpcyBpcyBhIHN1YmFycmF5LCBtYWtlIGEgY29weSBzbyB3ZSBvbmx5XG4gICAgICAvLyBpbmNsdWRlIHRoZSBzdWJhcnJheSByZWdpb24gZnJvbSB0aGUgdW5kZXJseWluZyBidWZmZXJcbiAgICAgIGlmIChjaHVuay5ieXRlTGVuZ3RoICE9PSBidWYuYnl0ZUxlbmd0aCkge1xuICAgICAgICB2YXIgY29weSA9IG5ldyBVaW50OEFycmF5KGNodW5rLmJ5dGVMZW5ndGgpO1xuICAgICAgICBjb3B5LnNldChuZXcgVWludDhBcnJheShidWYsIGNodW5rLmJ5dGVPZmZzZXQsIGNodW5rLmJ5dGVMZW5ndGgpKTtcbiAgICAgICAgYnVmID0gY29weS5idWZmZXI7XG4gICAgICB9XG5cbiAgICAgIGFyeVtpXSA9IGJ1ZjtcbiAgICB9XG4gIH1cbn1cblxuZnVuY3Rpb24gQmxvYkJ1aWxkZXJDb25zdHJ1Y3RvcihhcnksIG9wdGlvbnMpIHtcbiAgb3B0aW9ucyA9IG9wdGlvbnMgfHwge307XG5cbiAgdmFyIGJiID0gbmV3IEJsb2JCdWlsZGVyKCk7XG4gIG1hcEFycmF5QnVmZmVyVmlld3MoYXJ5KTtcblxuICBmb3IgKHZhciBpID0gMDsgaSA8IGFyeS5sZW5ndGg7IGkrKykge1xuICAgIGJiLmFwcGVuZChhcnlbaV0pO1xuICB9XG5cbiAgcmV0dXJuIChvcHRpb25zLnR5cGUpID8gYmIuZ2V0QmxvYihvcHRpb25zLnR5cGUpIDogYmIuZ2V0QmxvYigpO1xufTtcblxuZnVuY3Rpb24gQmxvYkNvbnN0cnVjdG9yKGFyeSwgb3B0aW9ucykge1xuICBtYXBBcnJheUJ1ZmZlclZpZXdzKGFyeSk7XG4gIHJldHVybiBuZXcgQmxvYihhcnksIG9wdGlvbnMgfHwge30pO1xufTtcblxubW9kdWxlLmV4cG9ydHMgPSAoZnVuY3Rpb24oKSB7XG4gIGlmIChibG9iU3VwcG9ydGVkKSB7XG4gICAgcmV0dXJuIGJsb2JTdXBwb3J0c0FycmF5QnVmZmVyVmlldyA/IGdsb2JhbC5CbG9iIDogQmxvYkNvbnN0cnVjdG9yO1xuICB9IGVsc2UgaWYgKGJsb2JCdWlsZGVyU3VwcG9ydGVkKSB7XG4gICAgcmV0dXJuIEJsb2JCdWlsZGVyQ29uc3RydWN0b3I7XG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIHVuZGVmaW5lZDtcbiAgfVxufSkoKTtcbiIsIiIsIi8qKlxuICogU2xpY2UgcmVmZXJlbmNlLlxuICovXG5cbnZhciBzbGljZSA9IFtdLnNsaWNlO1xuXG4vKipcbiAqIEJpbmQgYG9iamAgdG8gYGZuYC5cbiAqXG4gKiBAcGFyYW0ge09iamVjdH0gb2JqXG4gKiBAcGFyYW0ge0Z1bmN0aW9ufFN0cmluZ30gZm4gb3Igc3RyaW5nXG4gKiBAcmV0dXJuIHtGdW5jdGlvbn1cbiAqIEBhcGkgcHVibGljXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihvYmosIGZuKXtcbiAgaWYgKCdzdHJpbmcnID09IHR5cGVvZiBmbikgZm4gPSBvYmpbZm5dO1xuICBpZiAoJ2Z1bmN0aW9uJyAhPSB0eXBlb2YgZm4pIHRocm93IG5ldyBFcnJvcignYmluZCgpIHJlcXVpcmVzIGEgZnVuY3Rpb24nKTtcbiAgdmFyIGFyZ3MgPSBzbGljZS5jYWxsKGFyZ3VtZW50cywgMik7XG4gIHJldHVybiBmdW5jdGlvbigpe1xuICAgIHJldHVybiBmbi5hcHBseShvYmosIGFyZ3MuY29uY2F0KHNsaWNlLmNhbGwoYXJndW1lbnRzKSkpO1xuICB9XG59O1xuIiwiXHJcbi8qKlxyXG4gKiBFeHBvc2UgYEVtaXR0ZXJgLlxyXG4gKi9cclxuXHJcbmlmICh0eXBlb2YgbW9kdWxlICE9PSAndW5kZWZpbmVkJykge1xyXG4gIG1vZHVsZS5leHBvcnRzID0gRW1pdHRlcjtcclxufVxyXG5cclxuLyoqXHJcbiAqIEluaXRpYWxpemUgYSBuZXcgYEVtaXR0ZXJgLlxyXG4gKlxyXG4gKiBAYXBpIHB1YmxpY1xyXG4gKi9cclxuXHJcbmZ1bmN0aW9uIEVtaXR0ZXIob2JqKSB7XHJcbiAgaWYgKG9iaikgcmV0dXJuIG1peGluKG9iaik7XHJcbn07XHJcblxyXG4vKipcclxuICogTWl4aW4gdGhlIGVtaXR0ZXIgcHJvcGVydGllcy5cclxuICpcclxuICogQHBhcmFtIHtPYmplY3R9IG9ialxyXG4gKiBAcmV0dXJuIHtPYmplY3R9XHJcbiAqIEBhcGkgcHJpdmF0ZVxyXG4gKi9cclxuXHJcbmZ1bmN0aW9uIG1peGluKG9iaikge1xyXG4gIGZvciAodmFyIGtleSBpbiBFbWl0dGVyLnByb3RvdHlwZSkge1xyXG4gICAgb2JqW2tleV0gPSBFbWl0dGVyLnByb3RvdHlwZVtrZXldO1xyXG4gIH1cclxuICByZXR1cm4gb2JqO1xyXG59XHJcblxyXG4vKipcclxuICogTGlzdGVuIG9uIHRoZSBnaXZlbiBgZXZlbnRgIHdpdGggYGZuYC5cclxuICpcclxuICogQHBhcmFtIHtTdHJpbmd9IGV2ZW50XHJcbiAqIEBwYXJhbSB7RnVuY3Rpb259IGZuXHJcbiAqIEByZXR1cm4ge0VtaXR0ZXJ9XHJcbiAqIEBhcGkgcHVibGljXHJcbiAqL1xyXG5cclxuRW1pdHRlci5wcm90b3R5cGUub24gPVxyXG5FbWl0dGVyLnByb3RvdHlwZS5hZGRFdmVudExpc3RlbmVyID0gZnVuY3Rpb24oZXZlbnQsIGZuKXtcclxuICB0aGlzLl9jYWxsYmFja3MgPSB0aGlzLl9jYWxsYmFja3MgfHwge307XHJcbiAgKHRoaXMuX2NhbGxiYWNrc1snJCcgKyBldmVudF0gPSB0aGlzLl9jYWxsYmFja3NbJyQnICsgZXZlbnRdIHx8IFtdKVxyXG4gICAgLnB1c2goZm4pO1xyXG4gIHJldHVybiB0aGlzO1xyXG59O1xyXG5cclxuLyoqXHJcbiAqIEFkZHMgYW4gYGV2ZW50YCBsaXN0ZW5lciB0aGF0IHdpbGwgYmUgaW52b2tlZCBhIHNpbmdsZVxyXG4gKiB0aW1lIHRoZW4gYXV0b21hdGljYWxseSByZW1vdmVkLlxyXG4gKlxyXG4gKiBAcGFyYW0ge1N0cmluZ30gZXZlbnRcclxuICogQHBhcmFtIHtGdW5jdGlvbn0gZm5cclxuICogQHJldHVybiB7RW1pdHRlcn1cclxuICogQGFwaSBwdWJsaWNcclxuICovXHJcblxyXG5FbWl0dGVyLnByb3RvdHlwZS5vbmNlID0gZnVuY3Rpb24oZXZlbnQsIGZuKXtcclxuICBmdW5jdGlvbiBvbigpIHtcclxuICAgIHRoaXMub2ZmKGV2ZW50LCBvbik7XHJcbiAgICBmbi5hcHBseSh0aGlzLCBhcmd1bWVudHMpO1xyXG4gIH1cclxuXHJcbiAgb24uZm4gPSBmbjtcclxuICB0aGlzLm9uKGV2ZW50LCBvbik7XHJcbiAgcmV0dXJuIHRoaXM7XHJcbn07XHJcblxyXG4vKipcclxuICogUmVtb3ZlIHRoZSBnaXZlbiBjYWxsYmFjayBmb3IgYGV2ZW50YCBvciBhbGxcclxuICogcmVnaXN0ZXJlZCBjYWxsYmFja3MuXHJcbiAqXHJcbiAqIEBwYXJhbSB7U3RyaW5nfSBldmVudFxyXG4gKiBAcGFyYW0ge0Z1bmN0aW9ufSBmblxyXG4gKiBAcmV0dXJuIHtFbWl0dGVyfVxyXG4gKiBAYXBpIHB1YmxpY1xyXG4gKi9cclxuXHJcbkVtaXR0ZXIucHJvdG90eXBlLm9mZiA9XHJcbkVtaXR0ZXIucHJvdG90eXBlLnJlbW92ZUxpc3RlbmVyID1cclxuRW1pdHRlci5wcm90b3R5cGUucmVtb3ZlQWxsTGlzdGVuZXJzID1cclxuRW1pdHRlci5wcm90b3R5cGUucmVtb3ZlRXZlbnRMaXN0ZW5lciA9IGZ1bmN0aW9uKGV2ZW50LCBmbil7XHJcbiAgdGhpcy5fY2FsbGJhY2tzID0gdGhpcy5fY2FsbGJhY2tzIHx8IHt9O1xyXG5cclxuICAvLyBhbGxcclxuICBpZiAoMCA9PSBhcmd1bWVudHMubGVuZ3RoKSB7XHJcbiAgICB0aGlzLl9jYWxsYmFja3MgPSB7fTtcclxuICAgIHJldHVybiB0aGlzO1xyXG4gIH1cclxuXHJcbiAgLy8gc3BlY2lmaWMgZXZlbnRcclxuICB2YXIgY2FsbGJhY2tzID0gdGhpcy5fY2FsbGJhY2tzWyckJyArIGV2ZW50XTtcclxuICBpZiAoIWNhbGxiYWNrcykgcmV0dXJuIHRoaXM7XHJcblxyXG4gIC8vIHJlbW92ZSBhbGwgaGFuZGxlcnNcclxuICBpZiAoMSA9PSBhcmd1bWVudHMubGVuZ3RoKSB7XHJcbiAgICBkZWxldGUgdGhpcy5fY2FsbGJhY2tzWyckJyArIGV2ZW50XTtcclxuICAgIHJldHVybiB0aGlzO1xyXG4gIH1cclxuXHJcbiAgLy8gcmVtb3ZlIHNwZWNpZmljIGhhbmRsZXJcclxuICB2YXIgY2I7XHJcbiAgZm9yICh2YXIgaSA9IDA7IGkgPCBjYWxsYmFja3MubGVuZ3RoOyBpKyspIHtcclxuICAgIGNiID0gY2FsbGJhY2tzW2ldO1xyXG4gICAgaWYgKGNiID09PSBmbiB8fCBjYi5mbiA9PT0gZm4pIHtcclxuICAgICAgY2FsbGJhY2tzLnNwbGljZShpLCAxKTtcclxuICAgICAgYnJlYWs7XHJcbiAgICB9XHJcbiAgfVxyXG4gIHJldHVybiB0aGlzO1xyXG59O1xyXG5cclxuLyoqXHJcbiAqIEVtaXQgYGV2ZW50YCB3aXRoIHRoZSBnaXZlbiBhcmdzLlxyXG4gKlxyXG4gKiBAcGFyYW0ge1N0cmluZ30gZXZlbnRcclxuICogQHBhcmFtIHtNaXhlZH0gLi4uXHJcbiAqIEByZXR1cm4ge0VtaXR0ZXJ9XHJcbiAqL1xyXG5cclxuRW1pdHRlci5wcm90b3R5cGUuZW1pdCA9IGZ1bmN0aW9uKGV2ZW50KXtcclxuICB0aGlzLl9jYWxsYmFja3MgPSB0aGlzLl9jYWxsYmFja3MgfHwge307XHJcbiAgdmFyIGFyZ3MgPSBbXS5zbGljZS5jYWxsKGFyZ3VtZW50cywgMSlcclxuICAgICwgY2FsbGJhY2tzID0gdGhpcy5fY2FsbGJhY2tzWyckJyArIGV2ZW50XTtcclxuXHJcbiAgaWYgKGNhbGxiYWNrcykge1xyXG4gICAgY2FsbGJhY2tzID0gY2FsbGJhY2tzLnNsaWNlKDApO1xyXG4gICAgZm9yICh2YXIgaSA9IDAsIGxlbiA9IGNhbGxiYWNrcy5sZW5ndGg7IGkgPCBsZW47ICsraSkge1xyXG4gICAgICBjYWxsYmFja3NbaV0uYXBwbHkodGhpcywgYXJncyk7XHJcbiAgICB9XHJcbiAgfVxyXG5cclxuICByZXR1cm4gdGhpcztcclxufTtcclxuXHJcbi8qKlxyXG4gKiBSZXR1cm4gYXJyYXkgb2YgY2FsbGJhY2tzIGZvciBgZXZlbnRgLlxyXG4gKlxyXG4gKiBAcGFyYW0ge1N0cmluZ30gZXZlbnRcclxuICogQHJldHVybiB7QXJyYXl9XHJcbiAqIEBhcGkgcHVibGljXHJcbiAqL1xyXG5cclxuRW1pdHRlci5wcm90b3R5cGUubGlzdGVuZXJzID0gZnVuY3Rpb24oZXZlbnQpe1xyXG4gIHRoaXMuX2NhbGxiYWNrcyA9IHRoaXMuX2NhbGxiYWNrcyB8fCB7fTtcclxuICByZXR1cm4gdGhpcy5fY2FsbGJhY2tzWyckJyArIGV2ZW50XSB8fCBbXTtcclxufTtcclxuXHJcbi8qKlxyXG4gKiBDaGVjayBpZiB0aGlzIGVtaXR0ZXIgaGFzIGBldmVudGAgaGFuZGxlcnMuXHJcbiAqXHJcbiAqIEBwYXJhbSB7U3RyaW5nfSBldmVudFxyXG4gKiBAcmV0dXJuIHtCb29sZWFufVxyXG4gKiBAYXBpIHB1YmxpY1xyXG4gKi9cclxuXHJcbkVtaXR0ZXIucHJvdG90eXBlLmhhc0xpc3RlbmVycyA9IGZ1bmN0aW9uKGV2ZW50KXtcclxuICByZXR1cm4gISEgdGhpcy5saXN0ZW5lcnMoZXZlbnQpLmxlbmd0aDtcclxufTtcclxuIiwiXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGEsIGIpe1xuICB2YXIgZm4gPSBmdW5jdGlvbigpe307XG4gIGZuLnByb3RvdHlwZSA9IGIucHJvdG90eXBlO1xuICBhLnByb3RvdHlwZSA9IG5ldyBmbjtcbiAgYS5wcm90b3R5cGUuY29uc3RydWN0b3IgPSBhO1xufTsiLCJcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSgnLi9saWIvaW5kZXgnKTtcbiIsIlxubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKCcuL3NvY2tldCcpO1xuXG4vKipcbiAqIEV4cG9ydHMgcGFyc2VyXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzLnBhcnNlciA9IHJlcXVpcmUoJ2VuZ2luZS5pby1wYXJzZXInKTtcbiIsIi8qKlxuICogTW9kdWxlIGRlcGVuZGVuY2llcy5cbiAqL1xuXG52YXIgdHJhbnNwb3J0cyA9IHJlcXVpcmUoJy4vdHJhbnNwb3J0cy9pbmRleCcpO1xudmFyIEVtaXR0ZXIgPSByZXF1aXJlKCdjb21wb25lbnQtZW1pdHRlcicpO1xudmFyIGRlYnVnID0gcmVxdWlyZSgnZGVidWcnKSgnZW5naW5lLmlvLWNsaWVudDpzb2NrZXQnKTtcbnZhciBpbmRleCA9IHJlcXVpcmUoJ2luZGV4b2YnKTtcbnZhciBwYXJzZXIgPSByZXF1aXJlKCdlbmdpbmUuaW8tcGFyc2VyJyk7XG52YXIgcGFyc2V1cmkgPSByZXF1aXJlKCdwYXJzZXVyaScpO1xudmFyIHBhcnNlanNvbiA9IHJlcXVpcmUoJ3BhcnNlanNvbicpO1xudmFyIHBhcnNlcXMgPSByZXF1aXJlKCdwYXJzZXFzJyk7XG5cbi8qKlxuICogTW9kdWxlIGV4cG9ydHMuXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSBTb2NrZXQ7XG5cbi8qKlxuICogU29ja2V0IGNvbnN0cnVjdG9yLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfE9iamVjdH0gdXJpIG9yIG9wdGlvbnNcbiAqIEBwYXJhbSB7T2JqZWN0fSBvcHRpb25zXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIFNvY2tldCAodXJpLCBvcHRzKSB7XG4gIGlmICghKHRoaXMgaW5zdGFuY2VvZiBTb2NrZXQpKSByZXR1cm4gbmV3IFNvY2tldCh1cmksIG9wdHMpO1xuXG4gIG9wdHMgPSBvcHRzIHx8IHt9O1xuXG4gIGlmICh1cmkgJiYgJ29iamVjdCcgPT09IHR5cGVvZiB1cmkpIHtcbiAgICBvcHRzID0gdXJpO1xuICAgIHVyaSA9IG51bGw7XG4gIH1cblxuICBpZiAodXJpKSB7XG4gICAgdXJpID0gcGFyc2V1cmkodXJpKTtcbiAgICBvcHRzLmhvc3RuYW1lID0gdXJpLmhvc3Q7XG4gICAgb3B0cy5zZWN1cmUgPSB1cmkucHJvdG9jb2wgPT09ICdodHRwcycgfHwgdXJpLnByb3RvY29sID09PSAnd3NzJztcbiAgICBvcHRzLnBvcnQgPSB1cmkucG9ydDtcbiAgICBpZiAodXJpLnF1ZXJ5KSBvcHRzLnF1ZXJ5ID0gdXJpLnF1ZXJ5O1xuICB9IGVsc2UgaWYgKG9wdHMuaG9zdCkge1xuICAgIG9wdHMuaG9zdG5hbWUgPSBwYXJzZXVyaShvcHRzLmhvc3QpLmhvc3Q7XG4gIH1cblxuICB0aGlzLnNlY3VyZSA9IG51bGwgIT0gb3B0cy5zZWN1cmUgPyBvcHRzLnNlY3VyZVxuICAgIDogKGdsb2JhbC5sb2NhdGlvbiAmJiAnaHR0cHM6JyA9PT0gbG9jYXRpb24ucHJvdG9jb2wpO1xuXG4gIGlmIChvcHRzLmhvc3RuYW1lICYmICFvcHRzLnBvcnQpIHtcbiAgICAvLyBpZiBubyBwb3J0IGlzIHNwZWNpZmllZCBtYW51YWxseSwgdXNlIHRoZSBwcm90b2NvbCBkZWZhdWx0XG4gICAgb3B0cy5wb3J0ID0gdGhpcy5zZWN1cmUgPyAnNDQzJyA6ICc4MCc7XG4gIH1cblxuICB0aGlzLmFnZW50ID0gb3B0cy5hZ2VudCB8fCBmYWxzZTtcbiAgdGhpcy5ob3N0bmFtZSA9IG9wdHMuaG9zdG5hbWUgfHxcbiAgICAoZ2xvYmFsLmxvY2F0aW9uID8gbG9jYXRpb24uaG9zdG5hbWUgOiAnbG9jYWxob3N0Jyk7XG4gIHRoaXMucG9ydCA9IG9wdHMucG9ydCB8fCAoZ2xvYmFsLmxvY2F0aW9uICYmIGxvY2F0aW9uLnBvcnRcbiAgICAgID8gbG9jYXRpb24ucG9ydFxuICAgICAgOiAodGhpcy5zZWN1cmUgPyA0NDMgOiA4MCkpO1xuICB0aGlzLnF1ZXJ5ID0gb3B0cy5xdWVyeSB8fCB7fTtcbiAgaWYgKCdzdHJpbmcnID09PSB0eXBlb2YgdGhpcy5xdWVyeSkgdGhpcy5xdWVyeSA9IHBhcnNlcXMuZGVjb2RlKHRoaXMucXVlcnkpO1xuICB0aGlzLnVwZ3JhZGUgPSBmYWxzZSAhPT0gb3B0cy51cGdyYWRlO1xuICB0aGlzLnBhdGggPSAob3B0cy5wYXRoIHx8ICcvZW5naW5lLmlvJykucmVwbGFjZSgvXFwvJC8sICcnKSArICcvJztcbiAgdGhpcy5mb3JjZUpTT05QID0gISFvcHRzLmZvcmNlSlNPTlA7XG4gIHRoaXMuanNvbnAgPSBmYWxzZSAhPT0gb3B0cy5qc29ucDtcbiAgdGhpcy5mb3JjZUJhc2U2NCA9ICEhb3B0cy5mb3JjZUJhc2U2NDtcbiAgdGhpcy5lbmFibGVzWERSID0gISFvcHRzLmVuYWJsZXNYRFI7XG4gIHRoaXMudGltZXN0YW1wUGFyYW0gPSBvcHRzLnRpbWVzdGFtcFBhcmFtIHx8ICd0JztcbiAgdGhpcy50aW1lc3RhbXBSZXF1ZXN0cyA9IG9wdHMudGltZXN0YW1wUmVxdWVzdHM7XG4gIHRoaXMudHJhbnNwb3J0cyA9IG9wdHMudHJhbnNwb3J0cyB8fCBbJ3BvbGxpbmcnLCAnd2Vic29ja2V0J107XG4gIHRoaXMucmVhZHlTdGF0ZSA9ICcnO1xuICB0aGlzLndyaXRlQnVmZmVyID0gW107XG4gIHRoaXMucHJldkJ1ZmZlckxlbiA9IDA7XG4gIHRoaXMucG9saWN5UG9ydCA9IG9wdHMucG9saWN5UG9ydCB8fCA4NDM7XG4gIHRoaXMucmVtZW1iZXJVcGdyYWRlID0gb3B0cy5yZW1lbWJlclVwZ3JhZGUgfHwgZmFsc2U7XG4gIHRoaXMuYmluYXJ5VHlwZSA9IG51bGw7XG4gIHRoaXMub25seUJpbmFyeVVwZ3JhZGVzID0gb3B0cy5vbmx5QmluYXJ5VXBncmFkZXM7XG4gIHRoaXMucGVyTWVzc2FnZURlZmxhdGUgPSBmYWxzZSAhPT0gb3B0cy5wZXJNZXNzYWdlRGVmbGF0ZSA/IChvcHRzLnBlck1lc3NhZ2VEZWZsYXRlIHx8IHt9KSA6IGZhbHNlO1xuXG4gIGlmICh0cnVlID09PSB0aGlzLnBlck1lc3NhZ2VEZWZsYXRlKSB0aGlzLnBlck1lc3NhZ2VEZWZsYXRlID0ge307XG4gIGlmICh0aGlzLnBlck1lc3NhZ2VEZWZsYXRlICYmIG51bGwgPT0gdGhpcy5wZXJNZXNzYWdlRGVmbGF0ZS50aHJlc2hvbGQpIHtcbiAgICB0aGlzLnBlck1lc3NhZ2VEZWZsYXRlLnRocmVzaG9sZCA9IDEwMjQ7XG4gIH1cblxuICAvLyBTU0wgb3B0aW9ucyBmb3IgTm9kZS5qcyBjbGllbnRcbiAgdGhpcy5wZnggPSBvcHRzLnBmeCB8fCBudWxsO1xuICB0aGlzLmtleSA9IG9wdHMua2V5IHx8IG51bGw7XG4gIHRoaXMucGFzc3BocmFzZSA9IG9wdHMucGFzc3BocmFzZSB8fCBudWxsO1xuICB0aGlzLmNlcnQgPSBvcHRzLmNlcnQgfHwgbnVsbDtcbiAgdGhpcy5jYSA9IG9wdHMuY2EgfHwgbnVsbDtcbiAgdGhpcy5jaXBoZXJzID0gb3B0cy5jaXBoZXJzIHx8IG51bGw7XG4gIHRoaXMucmVqZWN0VW5hdXRob3JpemVkID0gb3B0cy5yZWplY3RVbmF1dGhvcml6ZWQgPT09IHVuZGVmaW5lZCA/IG51bGwgOiBvcHRzLnJlamVjdFVuYXV0aG9yaXplZDtcbiAgdGhpcy5mb3JjZU5vZGUgPSAhIW9wdHMuZm9yY2VOb2RlO1xuXG4gIC8vIG90aGVyIG9wdGlvbnMgZm9yIE5vZGUuanMgY2xpZW50XG4gIHZhciBmcmVlR2xvYmFsID0gdHlwZW9mIGdsb2JhbCA9PT0gJ29iamVjdCcgJiYgZ2xvYmFsO1xuICBpZiAoZnJlZUdsb2JhbC5nbG9iYWwgPT09IGZyZWVHbG9iYWwpIHtcbiAgICBpZiAob3B0cy5leHRyYUhlYWRlcnMgJiYgT2JqZWN0LmtleXMob3B0cy5leHRyYUhlYWRlcnMpLmxlbmd0aCA+IDApIHtcbiAgICAgIHRoaXMuZXh0cmFIZWFkZXJzID0gb3B0cy5leHRyYUhlYWRlcnM7XG4gICAgfVxuXG4gICAgaWYgKG9wdHMubG9jYWxBZGRyZXNzKSB7XG4gICAgICB0aGlzLmxvY2FsQWRkcmVzcyA9IG9wdHMubG9jYWxBZGRyZXNzO1xuICAgIH1cbiAgfVxuXG4gIC8vIHNldCBvbiBoYW5kc2hha2VcbiAgdGhpcy5pZCA9IG51bGw7XG4gIHRoaXMudXBncmFkZXMgPSBudWxsO1xuICB0aGlzLnBpbmdJbnRlcnZhbCA9IG51bGw7XG4gIHRoaXMucGluZ1RpbWVvdXQgPSBudWxsO1xuXG4gIC8vIHNldCBvbiBoZWFydGJlYXRcbiAgdGhpcy5waW5nSW50ZXJ2YWxUaW1lciA9IG51bGw7XG4gIHRoaXMucGluZ1RpbWVvdXRUaW1lciA9IG51bGw7XG5cbiAgdGhpcy5vcGVuKCk7XG59XG5cblNvY2tldC5wcmlvcldlYnNvY2tldFN1Y2Nlc3MgPSBmYWxzZTtcblxuLyoqXG4gKiBNaXggaW4gYEVtaXR0ZXJgLlxuICovXG5cbkVtaXR0ZXIoU29ja2V0LnByb3RvdHlwZSk7XG5cbi8qKlxuICogUHJvdG9jb2wgdmVyc2lvbi5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cblNvY2tldC5wcm90b2NvbCA9IHBhcnNlci5wcm90b2NvbDsgLy8gdGhpcyBpcyBhbiBpbnRcblxuLyoqXG4gKiBFeHBvc2UgZGVwcyBmb3IgbGVnYWN5IGNvbXBhdGliaWxpdHlcbiAqIGFuZCBzdGFuZGFsb25lIGJyb3dzZXIgYWNjZXNzLlxuICovXG5cblNvY2tldC5Tb2NrZXQgPSBTb2NrZXQ7XG5Tb2NrZXQuVHJhbnNwb3J0ID0gcmVxdWlyZSgnLi90cmFuc3BvcnQnKTtcblNvY2tldC50cmFuc3BvcnRzID0gcmVxdWlyZSgnLi90cmFuc3BvcnRzL2luZGV4Jyk7XG5Tb2NrZXQucGFyc2VyID0gcmVxdWlyZSgnZW5naW5lLmlvLXBhcnNlcicpO1xuXG4vKipcbiAqIENyZWF0ZXMgdHJhbnNwb3J0IG9mIHRoZSBnaXZlbiB0eXBlLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSB0cmFuc3BvcnQgbmFtZVxuICogQHJldHVybiB7VHJhbnNwb3J0fVxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5jcmVhdGVUcmFuc3BvcnQgPSBmdW5jdGlvbiAobmFtZSkge1xuICBkZWJ1ZygnY3JlYXRpbmcgdHJhbnNwb3J0IFwiJXNcIicsIG5hbWUpO1xuICB2YXIgcXVlcnkgPSBjbG9uZSh0aGlzLnF1ZXJ5KTtcblxuICAvLyBhcHBlbmQgZW5naW5lLmlvIHByb3RvY29sIGlkZW50aWZpZXJcbiAgcXVlcnkuRUlPID0gcGFyc2VyLnByb3RvY29sO1xuXG4gIC8vIHRyYW5zcG9ydCBuYW1lXG4gIHF1ZXJ5LnRyYW5zcG9ydCA9IG5hbWU7XG5cbiAgLy8gc2Vzc2lvbiBpZCBpZiB3ZSBhbHJlYWR5IGhhdmUgb25lXG4gIGlmICh0aGlzLmlkKSBxdWVyeS5zaWQgPSB0aGlzLmlkO1xuXG4gIHZhciB0cmFuc3BvcnQgPSBuZXcgdHJhbnNwb3J0c1tuYW1lXSh7XG4gICAgYWdlbnQ6IHRoaXMuYWdlbnQsXG4gICAgaG9zdG5hbWU6IHRoaXMuaG9zdG5hbWUsXG4gICAgcG9ydDogdGhpcy5wb3J0LFxuICAgIHNlY3VyZTogdGhpcy5zZWN1cmUsXG4gICAgcGF0aDogdGhpcy5wYXRoLFxuICAgIHF1ZXJ5OiBxdWVyeSxcbiAgICBmb3JjZUpTT05QOiB0aGlzLmZvcmNlSlNPTlAsXG4gICAganNvbnA6IHRoaXMuanNvbnAsXG4gICAgZm9yY2VCYXNlNjQ6IHRoaXMuZm9yY2VCYXNlNjQsXG4gICAgZW5hYmxlc1hEUjogdGhpcy5lbmFibGVzWERSLFxuICAgIHRpbWVzdGFtcFJlcXVlc3RzOiB0aGlzLnRpbWVzdGFtcFJlcXVlc3RzLFxuICAgIHRpbWVzdGFtcFBhcmFtOiB0aGlzLnRpbWVzdGFtcFBhcmFtLFxuICAgIHBvbGljeVBvcnQ6IHRoaXMucG9saWN5UG9ydCxcbiAgICBzb2NrZXQ6IHRoaXMsXG4gICAgcGZ4OiB0aGlzLnBmeCxcbiAgICBrZXk6IHRoaXMua2V5LFxuICAgIHBhc3NwaHJhc2U6IHRoaXMucGFzc3BocmFzZSxcbiAgICBjZXJ0OiB0aGlzLmNlcnQsXG4gICAgY2E6IHRoaXMuY2EsXG4gICAgY2lwaGVyczogdGhpcy5jaXBoZXJzLFxuICAgIHJlamVjdFVuYXV0aG9yaXplZDogdGhpcy5yZWplY3RVbmF1dGhvcml6ZWQsXG4gICAgcGVyTWVzc2FnZURlZmxhdGU6IHRoaXMucGVyTWVzc2FnZURlZmxhdGUsXG4gICAgZXh0cmFIZWFkZXJzOiB0aGlzLmV4dHJhSGVhZGVycyxcbiAgICBmb3JjZU5vZGU6IHRoaXMuZm9yY2VOb2RlLFxuICAgIGxvY2FsQWRkcmVzczogdGhpcy5sb2NhbEFkZHJlc3NcbiAgfSk7XG5cbiAgcmV0dXJuIHRyYW5zcG9ydDtcbn07XG5cbmZ1bmN0aW9uIGNsb25lIChvYmopIHtcbiAgdmFyIG8gPSB7fTtcbiAgZm9yICh2YXIgaSBpbiBvYmopIHtcbiAgICBpZiAob2JqLmhhc093blByb3BlcnR5KGkpKSB7XG4gICAgICBvW2ldID0gb2JqW2ldO1xuICAgIH1cbiAgfVxuICByZXR1cm4gbztcbn1cblxuLyoqXG4gKiBJbml0aWFsaXplcyB0cmFuc3BvcnQgdG8gdXNlIGFuZCBzdGFydHMgcHJvYmUuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblNvY2tldC5wcm90b3R5cGUub3BlbiA9IGZ1bmN0aW9uICgpIHtcbiAgdmFyIHRyYW5zcG9ydDtcbiAgaWYgKHRoaXMucmVtZW1iZXJVcGdyYWRlICYmIFNvY2tldC5wcmlvcldlYnNvY2tldFN1Y2Nlc3MgJiYgdGhpcy50cmFuc3BvcnRzLmluZGV4T2YoJ3dlYnNvY2tldCcpICE9PSAtMSkge1xuICAgIHRyYW5zcG9ydCA9ICd3ZWJzb2NrZXQnO1xuICB9IGVsc2UgaWYgKDAgPT09IHRoaXMudHJhbnNwb3J0cy5sZW5ndGgpIHtcbiAgICAvLyBFbWl0IGVycm9yIG9uIG5leHQgdGljayBzbyBpdCBjYW4gYmUgbGlzdGVuZWQgdG9cbiAgICB2YXIgc2VsZiA9IHRoaXM7XG4gICAgc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICBzZWxmLmVtaXQoJ2Vycm9yJywgJ05vIHRyYW5zcG9ydHMgYXZhaWxhYmxlJyk7XG4gICAgfSwgMCk7XG4gICAgcmV0dXJuO1xuICB9IGVsc2Uge1xuICAgIHRyYW5zcG9ydCA9IHRoaXMudHJhbnNwb3J0c1swXTtcbiAgfVxuICB0aGlzLnJlYWR5U3RhdGUgPSAnb3BlbmluZyc7XG5cbiAgLy8gUmV0cnkgd2l0aCB0aGUgbmV4dCB0cmFuc3BvcnQgaWYgdGhlIHRyYW5zcG9ydCBpcyBkaXNhYmxlZCAoanNvbnA6IGZhbHNlKVxuICB0cnkge1xuICAgIHRyYW5zcG9ydCA9IHRoaXMuY3JlYXRlVHJhbnNwb3J0KHRyYW5zcG9ydCk7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICB0aGlzLnRyYW5zcG9ydHMuc2hpZnQoKTtcbiAgICB0aGlzLm9wZW4oKTtcbiAgICByZXR1cm47XG4gIH1cblxuICB0cmFuc3BvcnQub3BlbigpO1xuICB0aGlzLnNldFRyYW5zcG9ydCh0cmFuc3BvcnQpO1xufTtcblxuLyoqXG4gKiBTZXRzIHRoZSBjdXJyZW50IHRyYW5zcG9ydC4gRGlzYWJsZXMgdGhlIGV4aXN0aW5nIG9uZSAoaWYgYW55KS5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLnNldFRyYW5zcG9ydCA9IGZ1bmN0aW9uICh0cmFuc3BvcnQpIHtcbiAgZGVidWcoJ3NldHRpbmcgdHJhbnNwb3J0ICVzJywgdHJhbnNwb3J0Lm5hbWUpO1xuICB2YXIgc2VsZiA9IHRoaXM7XG5cbiAgaWYgKHRoaXMudHJhbnNwb3J0KSB7XG4gICAgZGVidWcoJ2NsZWFyaW5nIGV4aXN0aW5nIHRyYW5zcG9ydCAlcycsIHRoaXMudHJhbnNwb3J0Lm5hbWUpO1xuICAgIHRoaXMudHJhbnNwb3J0LnJlbW92ZUFsbExpc3RlbmVycygpO1xuICB9XG5cbiAgLy8gc2V0IHVwIHRyYW5zcG9ydFxuICB0aGlzLnRyYW5zcG9ydCA9IHRyYW5zcG9ydDtcblxuICAvLyBzZXQgdXAgdHJhbnNwb3J0IGxpc3RlbmVyc1xuICB0cmFuc3BvcnRcbiAgLm9uKCdkcmFpbicsIGZ1bmN0aW9uICgpIHtcbiAgICBzZWxmLm9uRHJhaW4oKTtcbiAgfSlcbiAgLm9uKCdwYWNrZXQnLCBmdW5jdGlvbiAocGFja2V0KSB7XG4gICAgc2VsZi5vblBhY2tldChwYWNrZXQpO1xuICB9KVxuICAub24oJ2Vycm9yJywgZnVuY3Rpb24gKGUpIHtcbiAgICBzZWxmLm9uRXJyb3IoZSk7XG4gIH0pXG4gIC5vbignY2xvc2UnLCBmdW5jdGlvbiAoKSB7XG4gICAgc2VsZi5vbkNsb3NlKCd0cmFuc3BvcnQgY2xvc2UnKTtcbiAgfSk7XG59O1xuXG4vKipcbiAqIFByb2JlcyBhIHRyYW5zcG9ydC5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gdHJhbnNwb3J0IG5hbWVcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUucHJvYmUgPSBmdW5jdGlvbiAobmFtZSkge1xuICBkZWJ1ZygncHJvYmluZyB0cmFuc3BvcnQgXCIlc1wiJywgbmFtZSk7XG4gIHZhciB0cmFuc3BvcnQgPSB0aGlzLmNyZWF0ZVRyYW5zcG9ydChuYW1lLCB7IHByb2JlOiAxIH0pO1xuICB2YXIgZmFpbGVkID0gZmFsc2U7XG4gIHZhciBzZWxmID0gdGhpcztcblxuICBTb2NrZXQucHJpb3JXZWJzb2NrZXRTdWNjZXNzID0gZmFsc2U7XG5cbiAgZnVuY3Rpb24gb25UcmFuc3BvcnRPcGVuICgpIHtcbiAgICBpZiAoc2VsZi5vbmx5QmluYXJ5VXBncmFkZXMpIHtcbiAgICAgIHZhciB1cGdyYWRlTG9zZXNCaW5hcnkgPSAhdGhpcy5zdXBwb3J0c0JpbmFyeSAmJiBzZWxmLnRyYW5zcG9ydC5zdXBwb3J0c0JpbmFyeTtcbiAgICAgIGZhaWxlZCA9IGZhaWxlZCB8fCB1cGdyYWRlTG9zZXNCaW5hcnk7XG4gICAgfVxuICAgIGlmIChmYWlsZWQpIHJldHVybjtcblxuICAgIGRlYnVnKCdwcm9iZSB0cmFuc3BvcnQgXCIlc1wiIG9wZW5lZCcsIG5hbWUpO1xuICAgIHRyYW5zcG9ydC5zZW5kKFt7IHR5cGU6ICdwaW5nJywgZGF0YTogJ3Byb2JlJyB9XSk7XG4gICAgdHJhbnNwb3J0Lm9uY2UoJ3BhY2tldCcsIGZ1bmN0aW9uIChtc2cpIHtcbiAgICAgIGlmIChmYWlsZWQpIHJldHVybjtcbiAgICAgIGlmICgncG9uZycgPT09IG1zZy50eXBlICYmICdwcm9iZScgPT09IG1zZy5kYXRhKSB7XG4gICAgICAgIGRlYnVnKCdwcm9iZSB0cmFuc3BvcnQgXCIlc1wiIHBvbmcnLCBuYW1lKTtcbiAgICAgICAgc2VsZi51cGdyYWRpbmcgPSB0cnVlO1xuICAgICAgICBzZWxmLmVtaXQoJ3VwZ3JhZGluZycsIHRyYW5zcG9ydCk7XG4gICAgICAgIGlmICghdHJhbnNwb3J0KSByZXR1cm47XG4gICAgICAgIFNvY2tldC5wcmlvcldlYnNvY2tldFN1Y2Nlc3MgPSAnd2Vic29ja2V0JyA9PT0gdHJhbnNwb3J0Lm5hbWU7XG5cbiAgICAgICAgZGVidWcoJ3BhdXNpbmcgY3VycmVudCB0cmFuc3BvcnQgXCIlc1wiJywgc2VsZi50cmFuc3BvcnQubmFtZSk7XG4gICAgICAgIHNlbGYudHJhbnNwb3J0LnBhdXNlKGZ1bmN0aW9uICgpIHtcbiAgICAgICAgICBpZiAoZmFpbGVkKSByZXR1cm47XG4gICAgICAgICAgaWYgKCdjbG9zZWQnID09PSBzZWxmLnJlYWR5U3RhdGUpIHJldHVybjtcbiAgICAgICAgICBkZWJ1ZygnY2hhbmdpbmcgdHJhbnNwb3J0IGFuZCBzZW5kaW5nIHVwZ3JhZGUgcGFja2V0Jyk7XG5cbiAgICAgICAgICBjbGVhbnVwKCk7XG5cbiAgICAgICAgICBzZWxmLnNldFRyYW5zcG9ydCh0cmFuc3BvcnQpO1xuICAgICAgICAgIHRyYW5zcG9ydC5zZW5kKFt7IHR5cGU6ICd1cGdyYWRlJyB9XSk7XG4gICAgICAgICAgc2VsZi5lbWl0KCd1cGdyYWRlJywgdHJhbnNwb3J0KTtcbiAgICAgICAgICB0cmFuc3BvcnQgPSBudWxsO1xuICAgICAgICAgIHNlbGYudXBncmFkaW5nID0gZmFsc2U7XG4gICAgICAgICAgc2VsZi5mbHVzaCgpO1xuICAgICAgICB9KTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIGRlYnVnKCdwcm9iZSB0cmFuc3BvcnQgXCIlc1wiIGZhaWxlZCcsIG5hbWUpO1xuICAgICAgICB2YXIgZXJyID0gbmV3IEVycm9yKCdwcm9iZSBlcnJvcicpO1xuICAgICAgICBlcnIudHJhbnNwb3J0ID0gdHJhbnNwb3J0Lm5hbWU7XG4gICAgICAgIHNlbGYuZW1pdCgndXBncmFkZUVycm9yJywgZXJyKTtcbiAgICAgIH1cbiAgICB9KTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGZyZWV6ZVRyYW5zcG9ydCAoKSB7XG4gICAgaWYgKGZhaWxlZCkgcmV0dXJuO1xuXG4gICAgLy8gQW55IGNhbGxiYWNrIGNhbGxlZCBieSB0cmFuc3BvcnQgc2hvdWxkIGJlIGlnbm9yZWQgc2luY2Ugbm93XG4gICAgZmFpbGVkID0gdHJ1ZTtcblxuICAgIGNsZWFudXAoKTtcblxuICAgIHRyYW5zcG9ydC5jbG9zZSgpO1xuICAgIHRyYW5zcG9ydCA9IG51bGw7XG4gIH1cblxuICAvLyBIYW5kbGUgYW55IGVycm9yIHRoYXQgaGFwcGVucyB3aGlsZSBwcm9iaW5nXG4gIGZ1bmN0aW9uIG9uZXJyb3IgKGVycikge1xuICAgIHZhciBlcnJvciA9IG5ldyBFcnJvcigncHJvYmUgZXJyb3I6ICcgKyBlcnIpO1xuICAgIGVycm9yLnRyYW5zcG9ydCA9IHRyYW5zcG9ydC5uYW1lO1xuXG4gICAgZnJlZXplVHJhbnNwb3J0KCk7XG5cbiAgICBkZWJ1ZygncHJvYmUgdHJhbnNwb3J0IFwiJXNcIiBmYWlsZWQgYmVjYXVzZSBvZiBlcnJvcjogJXMnLCBuYW1lLCBlcnIpO1xuXG4gICAgc2VsZi5lbWl0KCd1cGdyYWRlRXJyb3InLCBlcnJvcik7XG4gIH1cblxuICBmdW5jdGlvbiBvblRyYW5zcG9ydENsb3NlICgpIHtcbiAgICBvbmVycm9yKCd0cmFuc3BvcnQgY2xvc2VkJyk7XG4gIH1cblxuICAvLyBXaGVuIHRoZSBzb2NrZXQgaXMgY2xvc2VkIHdoaWxlIHdlJ3JlIHByb2JpbmdcbiAgZnVuY3Rpb24gb25jbG9zZSAoKSB7XG4gICAgb25lcnJvcignc29ja2V0IGNsb3NlZCcpO1xuICB9XG5cbiAgLy8gV2hlbiB0aGUgc29ja2V0IGlzIHVwZ3JhZGVkIHdoaWxlIHdlJ3JlIHByb2JpbmdcbiAgZnVuY3Rpb24gb251cGdyYWRlICh0bykge1xuICAgIGlmICh0cmFuc3BvcnQgJiYgdG8ubmFtZSAhPT0gdHJhbnNwb3J0Lm5hbWUpIHtcbiAgICAgIGRlYnVnKCdcIiVzXCIgd29ya3MgLSBhYm9ydGluZyBcIiVzXCInLCB0by5uYW1lLCB0cmFuc3BvcnQubmFtZSk7XG4gICAgICBmcmVlemVUcmFuc3BvcnQoKTtcbiAgICB9XG4gIH1cblxuICAvLyBSZW1vdmUgYWxsIGxpc3RlbmVycyBvbiB0aGUgdHJhbnNwb3J0IGFuZCBvbiBzZWxmXG4gIGZ1bmN0aW9uIGNsZWFudXAgKCkge1xuICAgIHRyYW5zcG9ydC5yZW1vdmVMaXN0ZW5lcignb3BlbicsIG9uVHJhbnNwb3J0T3Blbik7XG4gICAgdHJhbnNwb3J0LnJlbW92ZUxpc3RlbmVyKCdlcnJvcicsIG9uZXJyb3IpO1xuICAgIHRyYW5zcG9ydC5yZW1vdmVMaXN0ZW5lcignY2xvc2UnLCBvblRyYW5zcG9ydENsb3NlKTtcbiAgICBzZWxmLnJlbW92ZUxpc3RlbmVyKCdjbG9zZScsIG9uY2xvc2UpO1xuICAgIHNlbGYucmVtb3ZlTGlzdGVuZXIoJ3VwZ3JhZGluZycsIG9udXBncmFkZSk7XG4gIH1cblxuICB0cmFuc3BvcnQub25jZSgnb3BlbicsIG9uVHJhbnNwb3J0T3Blbik7XG4gIHRyYW5zcG9ydC5vbmNlKCdlcnJvcicsIG9uZXJyb3IpO1xuICB0cmFuc3BvcnQub25jZSgnY2xvc2UnLCBvblRyYW5zcG9ydENsb3NlKTtcblxuICB0aGlzLm9uY2UoJ2Nsb3NlJywgb25jbG9zZSk7XG4gIHRoaXMub25jZSgndXBncmFkaW5nJywgb251cGdyYWRlKTtcblxuICB0cmFuc3BvcnQub3BlbigpO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgd2hlbiBjb25uZWN0aW9uIGlzIGRlZW1lZCBvcGVuLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5vbk9wZW4gPSBmdW5jdGlvbiAoKSB7XG4gIGRlYnVnKCdzb2NrZXQgb3BlbicpO1xuICB0aGlzLnJlYWR5U3RhdGUgPSAnb3Blbic7XG4gIFNvY2tldC5wcmlvcldlYnNvY2tldFN1Y2Nlc3MgPSAnd2Vic29ja2V0JyA9PT0gdGhpcy50cmFuc3BvcnQubmFtZTtcbiAgdGhpcy5lbWl0KCdvcGVuJyk7XG4gIHRoaXMuZmx1c2goKTtcblxuICAvLyB3ZSBjaGVjayBmb3IgYHJlYWR5U3RhdGVgIGluIGNhc2UgYW4gYG9wZW5gXG4gIC8vIGxpc3RlbmVyIGFscmVhZHkgY2xvc2VkIHRoZSBzb2NrZXRcbiAgaWYgKCdvcGVuJyA9PT0gdGhpcy5yZWFkeVN0YXRlICYmIHRoaXMudXBncmFkZSAmJiB0aGlzLnRyYW5zcG9ydC5wYXVzZSkge1xuICAgIGRlYnVnKCdzdGFydGluZyB1cGdyYWRlIHByb2JlcycpO1xuICAgIGZvciAodmFyIGkgPSAwLCBsID0gdGhpcy51cGdyYWRlcy5sZW5ndGg7IGkgPCBsOyBpKyspIHtcbiAgICAgIHRoaXMucHJvYmUodGhpcy51cGdyYWRlc1tpXSk7XG4gICAgfVxuICB9XG59O1xuXG4vKipcbiAqIEhhbmRsZXMgYSBwYWNrZXQuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5vblBhY2tldCA9IGZ1bmN0aW9uIChwYWNrZXQpIHtcbiAgaWYgKCdvcGVuaW5nJyA9PT0gdGhpcy5yZWFkeVN0YXRlIHx8ICdvcGVuJyA9PT0gdGhpcy5yZWFkeVN0YXRlIHx8XG4gICAgICAnY2xvc2luZycgPT09IHRoaXMucmVhZHlTdGF0ZSkge1xuICAgIGRlYnVnKCdzb2NrZXQgcmVjZWl2ZTogdHlwZSBcIiVzXCIsIGRhdGEgXCIlc1wiJywgcGFja2V0LnR5cGUsIHBhY2tldC5kYXRhKTtcblxuICAgIHRoaXMuZW1pdCgncGFja2V0JywgcGFja2V0KTtcblxuICAgIC8vIFNvY2tldCBpcyBsaXZlIC0gYW55IHBhY2tldCBjb3VudHNcbiAgICB0aGlzLmVtaXQoJ2hlYXJ0YmVhdCcpO1xuXG4gICAgc3dpdGNoIChwYWNrZXQudHlwZSkge1xuICAgICAgY2FzZSAnb3Blbic6XG4gICAgICAgIHRoaXMub25IYW5kc2hha2UocGFyc2Vqc29uKHBhY2tldC5kYXRhKSk7XG4gICAgICAgIGJyZWFrO1xuXG4gICAgICBjYXNlICdwb25nJzpcbiAgICAgICAgdGhpcy5zZXRQaW5nKCk7XG4gICAgICAgIHRoaXMuZW1pdCgncG9uZycpO1xuICAgICAgICBicmVhaztcblxuICAgICAgY2FzZSAnZXJyb3InOlxuICAgICAgICB2YXIgZXJyID0gbmV3IEVycm9yKCdzZXJ2ZXIgZXJyb3InKTtcbiAgICAgICAgZXJyLmNvZGUgPSBwYWNrZXQuZGF0YTtcbiAgICAgICAgdGhpcy5vbkVycm9yKGVycik7XG4gICAgICAgIGJyZWFrO1xuXG4gICAgICBjYXNlICdtZXNzYWdlJzpcbiAgICAgICAgdGhpcy5lbWl0KCdkYXRhJywgcGFja2V0LmRhdGEpO1xuICAgICAgICB0aGlzLmVtaXQoJ21lc3NhZ2UnLCBwYWNrZXQuZGF0YSk7XG4gICAgICAgIGJyZWFrO1xuICAgIH1cbiAgfSBlbHNlIHtcbiAgICBkZWJ1ZygncGFja2V0IHJlY2VpdmVkIHdpdGggc29ja2V0IHJlYWR5U3RhdGUgXCIlc1wiJywgdGhpcy5yZWFkeVN0YXRlKTtcbiAgfVxufTtcblxuLyoqXG4gKiBDYWxsZWQgdXBvbiBoYW5kc2hha2UgY29tcGxldGlvbi5cbiAqXG4gKiBAcGFyYW0ge09iamVjdH0gaGFuZHNoYWtlIG9ialxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5vbkhhbmRzaGFrZSA9IGZ1bmN0aW9uIChkYXRhKSB7XG4gIHRoaXMuZW1pdCgnaGFuZHNoYWtlJywgZGF0YSk7XG4gIHRoaXMuaWQgPSBkYXRhLnNpZDtcbiAgdGhpcy50cmFuc3BvcnQucXVlcnkuc2lkID0gZGF0YS5zaWQ7XG4gIHRoaXMudXBncmFkZXMgPSB0aGlzLmZpbHRlclVwZ3JhZGVzKGRhdGEudXBncmFkZXMpO1xuICB0aGlzLnBpbmdJbnRlcnZhbCA9IGRhdGEucGluZ0ludGVydmFsO1xuICB0aGlzLnBpbmdUaW1lb3V0ID0gZGF0YS5waW5nVGltZW91dDtcbiAgdGhpcy5vbk9wZW4oKTtcbiAgLy8gSW4gY2FzZSBvcGVuIGhhbmRsZXIgY2xvc2VzIHNvY2tldFxuICBpZiAoJ2Nsb3NlZCcgPT09IHRoaXMucmVhZHlTdGF0ZSkgcmV0dXJuO1xuICB0aGlzLnNldFBpbmcoKTtcblxuICAvLyBQcm9sb25nIGxpdmVuZXNzIG9mIHNvY2tldCBvbiBoZWFydGJlYXRcbiAgdGhpcy5yZW1vdmVMaXN0ZW5lcignaGVhcnRiZWF0JywgdGhpcy5vbkhlYXJ0YmVhdCk7XG4gIHRoaXMub24oJ2hlYXJ0YmVhdCcsIHRoaXMub25IZWFydGJlYXQpO1xufTtcblxuLyoqXG4gKiBSZXNldHMgcGluZyB0aW1lb3V0LlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25IZWFydGJlYXQgPSBmdW5jdGlvbiAodGltZW91dCkge1xuICBjbGVhclRpbWVvdXQodGhpcy5waW5nVGltZW91dFRpbWVyKTtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICBzZWxmLnBpbmdUaW1lb3V0VGltZXIgPSBzZXRUaW1lb3V0KGZ1bmN0aW9uICgpIHtcbiAgICBpZiAoJ2Nsb3NlZCcgPT09IHNlbGYucmVhZHlTdGF0ZSkgcmV0dXJuO1xuICAgIHNlbGYub25DbG9zZSgncGluZyB0aW1lb3V0Jyk7XG4gIH0sIHRpbWVvdXQgfHwgKHNlbGYucGluZ0ludGVydmFsICsgc2VsZi5waW5nVGltZW91dCkpO1xufTtcblxuLyoqXG4gKiBQaW5ncyBzZXJ2ZXIgZXZlcnkgYHRoaXMucGluZ0ludGVydmFsYCBhbmQgZXhwZWN0cyByZXNwb25zZVxuICogd2l0aGluIGB0aGlzLnBpbmdUaW1lb3V0YCBvciBjbG9zZXMgY29ubmVjdGlvbi5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLnNldFBpbmcgPSBmdW5jdGlvbiAoKSB7XG4gIHZhciBzZWxmID0gdGhpcztcbiAgY2xlYXJUaW1lb3V0KHNlbGYucGluZ0ludGVydmFsVGltZXIpO1xuICBzZWxmLnBpbmdJbnRlcnZhbFRpbWVyID0gc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgZGVidWcoJ3dyaXRpbmcgcGluZyBwYWNrZXQgLSBleHBlY3RpbmcgcG9uZyB3aXRoaW4gJXNtcycsIHNlbGYucGluZ1RpbWVvdXQpO1xuICAgIHNlbGYucGluZygpO1xuICAgIHNlbGYub25IZWFydGJlYXQoc2VsZi5waW5nVGltZW91dCk7XG4gIH0sIHNlbGYucGluZ0ludGVydmFsKTtcbn07XG5cbi8qKlxuKiBTZW5kcyBhIHBpbmcgcGFja2V0LlxuKlxuKiBAYXBpIHByaXZhdGVcbiovXG5cblNvY2tldC5wcm90b3R5cGUucGluZyA9IGZ1bmN0aW9uICgpIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICB0aGlzLnNlbmRQYWNrZXQoJ3BpbmcnLCBmdW5jdGlvbiAoKSB7XG4gICAgc2VsZi5lbWl0KCdwaW5nJyk7XG4gIH0pO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgb24gYGRyYWluYCBldmVudFxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25EcmFpbiA9IGZ1bmN0aW9uICgpIHtcbiAgdGhpcy53cml0ZUJ1ZmZlci5zcGxpY2UoMCwgdGhpcy5wcmV2QnVmZmVyTGVuKTtcblxuICAvLyBzZXR0aW5nIHByZXZCdWZmZXJMZW4gPSAwIGlzIHZlcnkgaW1wb3J0YW50XG4gIC8vIGZvciBleGFtcGxlLCB3aGVuIHVwZ3JhZGluZywgdXBncmFkZSBwYWNrZXQgaXMgc2VudCBvdmVyLFxuICAvLyBhbmQgYSBub256ZXJvIHByZXZCdWZmZXJMZW4gY291bGQgY2F1c2UgcHJvYmxlbXMgb24gYGRyYWluYFxuICB0aGlzLnByZXZCdWZmZXJMZW4gPSAwO1xuXG4gIGlmICgwID09PSB0aGlzLndyaXRlQnVmZmVyLmxlbmd0aCkge1xuICAgIHRoaXMuZW1pdCgnZHJhaW4nKTtcbiAgfSBlbHNlIHtcbiAgICB0aGlzLmZsdXNoKCk7XG4gIH1cbn07XG5cbi8qKlxuICogRmx1c2ggd3JpdGUgYnVmZmVycy5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLmZsdXNoID0gZnVuY3Rpb24gKCkge1xuICBpZiAoJ2Nsb3NlZCcgIT09IHRoaXMucmVhZHlTdGF0ZSAmJiB0aGlzLnRyYW5zcG9ydC53cml0YWJsZSAmJlxuICAgICF0aGlzLnVwZ3JhZGluZyAmJiB0aGlzLndyaXRlQnVmZmVyLmxlbmd0aCkge1xuICAgIGRlYnVnKCdmbHVzaGluZyAlZCBwYWNrZXRzIGluIHNvY2tldCcsIHRoaXMud3JpdGVCdWZmZXIubGVuZ3RoKTtcbiAgICB0aGlzLnRyYW5zcG9ydC5zZW5kKHRoaXMud3JpdGVCdWZmZXIpO1xuICAgIC8vIGtlZXAgdHJhY2sgb2YgY3VycmVudCBsZW5ndGggb2Ygd3JpdGVCdWZmZXJcbiAgICAvLyBzcGxpY2Ugd3JpdGVCdWZmZXIgYW5kIGNhbGxiYWNrQnVmZmVyIG9uIGBkcmFpbmBcbiAgICB0aGlzLnByZXZCdWZmZXJMZW4gPSB0aGlzLndyaXRlQnVmZmVyLmxlbmd0aDtcbiAgICB0aGlzLmVtaXQoJ2ZsdXNoJyk7XG4gIH1cbn07XG5cbi8qKlxuICogU2VuZHMgYSBtZXNzYWdlLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBtZXNzYWdlLlxuICogQHBhcmFtIHtGdW5jdGlvbn0gY2FsbGJhY2sgZnVuY3Rpb24uXG4gKiBAcGFyYW0ge09iamVjdH0gb3B0aW9ucy5cbiAqIEByZXR1cm4ge1NvY2tldH0gZm9yIGNoYWluaW5nLlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLndyaXRlID1cblNvY2tldC5wcm90b3R5cGUuc2VuZCA9IGZ1bmN0aW9uIChtc2csIG9wdGlvbnMsIGZuKSB7XG4gIHRoaXMuc2VuZFBhY2tldCgnbWVzc2FnZScsIG1zZywgb3B0aW9ucywgZm4pO1xuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogU2VuZHMgYSBwYWNrZXQuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IHBhY2tldCB0eXBlLlxuICogQHBhcmFtIHtTdHJpbmd9IGRhdGEuXG4gKiBAcGFyYW0ge09iamVjdH0gb3B0aW9ucy5cbiAqIEBwYXJhbSB7RnVuY3Rpb259IGNhbGxiYWNrIGZ1bmN0aW9uLlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5zZW5kUGFja2V0ID0gZnVuY3Rpb24gKHR5cGUsIGRhdGEsIG9wdGlvbnMsIGZuKSB7XG4gIGlmICgnZnVuY3Rpb24nID09PSB0eXBlb2YgZGF0YSkge1xuICAgIGZuID0gZGF0YTtcbiAgICBkYXRhID0gdW5kZWZpbmVkO1xuICB9XG5cbiAgaWYgKCdmdW5jdGlvbicgPT09IHR5cGVvZiBvcHRpb25zKSB7XG4gICAgZm4gPSBvcHRpb25zO1xuICAgIG9wdGlvbnMgPSBudWxsO1xuICB9XG5cbiAgaWYgKCdjbG9zaW5nJyA9PT0gdGhpcy5yZWFkeVN0YXRlIHx8ICdjbG9zZWQnID09PSB0aGlzLnJlYWR5U3RhdGUpIHtcbiAgICByZXR1cm47XG4gIH1cblxuICBvcHRpb25zID0gb3B0aW9ucyB8fCB7fTtcbiAgb3B0aW9ucy5jb21wcmVzcyA9IGZhbHNlICE9PSBvcHRpb25zLmNvbXByZXNzO1xuXG4gIHZhciBwYWNrZXQgPSB7XG4gICAgdHlwZTogdHlwZSxcbiAgICBkYXRhOiBkYXRhLFxuICAgIG9wdGlvbnM6IG9wdGlvbnNcbiAgfTtcbiAgdGhpcy5lbWl0KCdwYWNrZXRDcmVhdGUnLCBwYWNrZXQpO1xuICB0aGlzLndyaXRlQnVmZmVyLnB1c2gocGFja2V0KTtcbiAgaWYgKGZuKSB0aGlzLm9uY2UoJ2ZsdXNoJywgZm4pO1xuICB0aGlzLmZsdXNoKCk7XG59O1xuXG4vKipcbiAqIENsb3NlcyB0aGUgY29ubmVjdGlvbi5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLmNsb3NlID0gZnVuY3Rpb24gKCkge1xuICBpZiAoJ29wZW5pbmcnID09PSB0aGlzLnJlYWR5U3RhdGUgfHwgJ29wZW4nID09PSB0aGlzLnJlYWR5U3RhdGUpIHtcbiAgICB0aGlzLnJlYWR5U3RhdGUgPSAnY2xvc2luZyc7XG5cbiAgICB2YXIgc2VsZiA9IHRoaXM7XG5cbiAgICBpZiAodGhpcy53cml0ZUJ1ZmZlci5sZW5ndGgpIHtcbiAgICAgIHRoaXMub25jZSgnZHJhaW4nLCBmdW5jdGlvbiAoKSB7XG4gICAgICAgIGlmICh0aGlzLnVwZ3JhZGluZykge1xuICAgICAgICAgIHdhaXRGb3JVcGdyYWRlKCk7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgY2xvc2UoKTtcbiAgICAgICAgfVxuICAgICAgfSk7XG4gICAgfSBlbHNlIGlmICh0aGlzLnVwZ3JhZGluZykge1xuICAgICAgd2FpdEZvclVwZ3JhZGUoKTtcbiAgICB9IGVsc2Uge1xuICAgICAgY2xvc2UoKTtcbiAgICB9XG4gIH1cblxuICBmdW5jdGlvbiBjbG9zZSAoKSB7XG4gICAgc2VsZi5vbkNsb3NlKCdmb3JjZWQgY2xvc2UnKTtcbiAgICBkZWJ1Zygnc29ja2V0IGNsb3NpbmcgLSB0ZWxsaW5nIHRyYW5zcG9ydCB0byBjbG9zZScpO1xuICAgIHNlbGYudHJhbnNwb3J0LmNsb3NlKCk7XG4gIH1cblxuICBmdW5jdGlvbiBjbGVhbnVwQW5kQ2xvc2UgKCkge1xuICAgIHNlbGYucmVtb3ZlTGlzdGVuZXIoJ3VwZ3JhZGUnLCBjbGVhbnVwQW5kQ2xvc2UpO1xuICAgIHNlbGYucmVtb3ZlTGlzdGVuZXIoJ3VwZ3JhZGVFcnJvcicsIGNsZWFudXBBbmRDbG9zZSk7XG4gICAgY2xvc2UoKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIHdhaXRGb3JVcGdyYWRlICgpIHtcbiAgICAvLyB3YWl0IGZvciB1cGdyYWRlIHRvIGZpbmlzaCBzaW5jZSB3ZSBjYW4ndCBzZW5kIHBhY2tldHMgd2hpbGUgcGF1c2luZyBhIHRyYW5zcG9ydFxuICAgIHNlbGYub25jZSgndXBncmFkZScsIGNsZWFudXBBbmRDbG9zZSk7XG4gICAgc2VsZi5vbmNlKCd1cGdyYWRlRXJyb3InLCBjbGVhbnVwQW5kQ2xvc2UpO1xuICB9XG5cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIHRyYW5zcG9ydCBlcnJvclxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25FcnJvciA9IGZ1bmN0aW9uIChlcnIpIHtcbiAgZGVidWcoJ3NvY2tldCBlcnJvciAlaicsIGVycik7XG4gIFNvY2tldC5wcmlvcldlYnNvY2tldFN1Y2Nlc3MgPSBmYWxzZTtcbiAgdGhpcy5lbWl0KCdlcnJvcicsIGVycik7XG4gIHRoaXMub25DbG9zZSgndHJhbnNwb3J0IGVycm9yJywgZXJyKTtcbn07XG5cbi8qKlxuICogQ2FsbGVkIHVwb24gdHJhbnNwb3J0IGNsb3NlLlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25DbG9zZSA9IGZ1bmN0aW9uIChyZWFzb24sIGRlc2MpIHtcbiAgaWYgKCdvcGVuaW5nJyA9PT0gdGhpcy5yZWFkeVN0YXRlIHx8ICdvcGVuJyA9PT0gdGhpcy5yZWFkeVN0YXRlIHx8ICdjbG9zaW5nJyA9PT0gdGhpcy5yZWFkeVN0YXRlKSB7XG4gICAgZGVidWcoJ3NvY2tldCBjbG9zZSB3aXRoIHJlYXNvbjogXCIlc1wiJywgcmVhc29uKTtcbiAgICB2YXIgc2VsZiA9IHRoaXM7XG5cbiAgICAvLyBjbGVhciB0aW1lcnNcbiAgICBjbGVhclRpbWVvdXQodGhpcy5waW5nSW50ZXJ2YWxUaW1lcik7XG4gICAgY2xlYXJUaW1lb3V0KHRoaXMucGluZ1RpbWVvdXRUaW1lcik7XG5cbiAgICAvLyBzdG9wIGV2ZW50IGZyb20gZmlyaW5nIGFnYWluIGZvciB0cmFuc3BvcnRcbiAgICB0aGlzLnRyYW5zcG9ydC5yZW1vdmVBbGxMaXN0ZW5lcnMoJ2Nsb3NlJyk7XG5cbiAgICAvLyBlbnN1cmUgdHJhbnNwb3J0IHdvbid0IHN0YXkgb3BlblxuICAgIHRoaXMudHJhbnNwb3J0LmNsb3NlKCk7XG5cbiAgICAvLyBpZ25vcmUgZnVydGhlciB0cmFuc3BvcnQgY29tbXVuaWNhdGlvblxuICAgIHRoaXMudHJhbnNwb3J0LnJlbW92ZUFsbExpc3RlbmVycygpO1xuXG4gICAgLy8gc2V0IHJlYWR5IHN0YXRlXG4gICAgdGhpcy5yZWFkeVN0YXRlID0gJ2Nsb3NlZCc7XG5cbiAgICAvLyBjbGVhciBzZXNzaW9uIGlkXG4gICAgdGhpcy5pZCA9IG51bGw7XG5cbiAgICAvLyBlbWl0IGNsb3NlIGV2ZW50XG4gICAgdGhpcy5lbWl0KCdjbG9zZScsIHJlYXNvbiwgZGVzYyk7XG5cbiAgICAvLyBjbGVhbiBidWZmZXJzIGFmdGVyLCBzbyB1c2VycyBjYW4gc3RpbGxcbiAgICAvLyBncmFiIHRoZSBidWZmZXJzIG9uIGBjbG9zZWAgZXZlbnRcbiAgICBzZWxmLndyaXRlQnVmZmVyID0gW107XG4gICAgc2VsZi5wcmV2QnVmZmVyTGVuID0gMDtcbiAgfVxufTtcblxuLyoqXG4gKiBGaWx0ZXJzIHVwZ3JhZGVzLCByZXR1cm5pbmcgb25seSB0aG9zZSBtYXRjaGluZyBjbGllbnQgdHJhbnNwb3J0cy5cbiAqXG4gKiBAcGFyYW0ge0FycmF5fSBzZXJ2ZXIgdXBncmFkZXNcbiAqIEBhcGkgcHJpdmF0ZVxuICpcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLmZpbHRlclVwZ3JhZGVzID0gZnVuY3Rpb24gKHVwZ3JhZGVzKSB7XG4gIHZhciBmaWx0ZXJlZFVwZ3JhZGVzID0gW107XG4gIGZvciAodmFyIGkgPSAwLCBqID0gdXBncmFkZXMubGVuZ3RoOyBpIDwgajsgaSsrKSB7XG4gICAgaWYgKH5pbmRleCh0aGlzLnRyYW5zcG9ydHMsIHVwZ3JhZGVzW2ldKSkgZmlsdGVyZWRVcGdyYWRlcy5wdXNoKHVwZ3JhZGVzW2ldKTtcbiAgfVxuICByZXR1cm4gZmlsdGVyZWRVcGdyYWRlcztcbn07XG4iLCIvKipcbiAqIE1vZHVsZSBkZXBlbmRlbmNpZXMuXG4gKi9cblxudmFyIHBhcnNlciA9IHJlcXVpcmUoJ2VuZ2luZS5pby1wYXJzZXInKTtcbnZhciBFbWl0dGVyID0gcmVxdWlyZSgnY29tcG9uZW50LWVtaXR0ZXInKTtcblxuLyoqXG4gKiBNb2R1bGUgZXhwb3J0cy5cbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IFRyYW5zcG9ydDtcblxuLyoqXG4gKiBUcmFuc3BvcnQgYWJzdHJhY3QgY29uc3RydWN0b3IuXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IG9wdGlvbnMuXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBUcmFuc3BvcnQgKG9wdHMpIHtcbiAgdGhpcy5wYXRoID0gb3B0cy5wYXRoO1xuICB0aGlzLmhvc3RuYW1lID0gb3B0cy5ob3N0bmFtZTtcbiAgdGhpcy5wb3J0ID0gb3B0cy5wb3J0O1xuICB0aGlzLnNlY3VyZSA9IG9wdHMuc2VjdXJlO1xuICB0aGlzLnF1ZXJ5ID0gb3B0cy5xdWVyeTtcbiAgdGhpcy50aW1lc3RhbXBQYXJhbSA9IG9wdHMudGltZXN0YW1wUGFyYW07XG4gIHRoaXMudGltZXN0YW1wUmVxdWVzdHMgPSBvcHRzLnRpbWVzdGFtcFJlcXVlc3RzO1xuICB0aGlzLnJlYWR5U3RhdGUgPSAnJztcbiAgdGhpcy5hZ2VudCA9IG9wdHMuYWdlbnQgfHwgZmFsc2U7XG4gIHRoaXMuc29ja2V0ID0gb3B0cy5zb2NrZXQ7XG4gIHRoaXMuZW5hYmxlc1hEUiA9IG9wdHMuZW5hYmxlc1hEUjtcblxuICAvLyBTU0wgb3B0aW9ucyBmb3IgTm9kZS5qcyBjbGllbnRcbiAgdGhpcy5wZnggPSBvcHRzLnBmeDtcbiAgdGhpcy5rZXkgPSBvcHRzLmtleTtcbiAgdGhpcy5wYXNzcGhyYXNlID0gb3B0cy5wYXNzcGhyYXNlO1xuICB0aGlzLmNlcnQgPSBvcHRzLmNlcnQ7XG4gIHRoaXMuY2EgPSBvcHRzLmNhO1xuICB0aGlzLmNpcGhlcnMgPSBvcHRzLmNpcGhlcnM7XG4gIHRoaXMucmVqZWN0VW5hdXRob3JpemVkID0gb3B0cy5yZWplY3RVbmF1dGhvcml6ZWQ7XG4gIHRoaXMuZm9yY2VOb2RlID0gb3B0cy5mb3JjZU5vZGU7XG5cbiAgLy8gb3RoZXIgb3B0aW9ucyBmb3IgTm9kZS5qcyBjbGllbnRcbiAgdGhpcy5leHRyYUhlYWRlcnMgPSBvcHRzLmV4dHJhSGVhZGVycztcbiAgdGhpcy5sb2NhbEFkZHJlc3MgPSBvcHRzLmxvY2FsQWRkcmVzcztcbn1cblxuLyoqXG4gKiBNaXggaW4gYEVtaXR0ZXJgLlxuICovXG5cbkVtaXR0ZXIoVHJhbnNwb3J0LnByb3RvdHlwZSk7XG5cbi8qKlxuICogRW1pdHMgYW4gZXJyb3IuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IHN0clxuICogQHJldHVybiB7VHJhbnNwb3J0fSBmb3IgY2hhaW5pbmdcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuVHJhbnNwb3J0LnByb3RvdHlwZS5vbkVycm9yID0gZnVuY3Rpb24gKG1zZywgZGVzYykge1xuICB2YXIgZXJyID0gbmV3IEVycm9yKG1zZyk7XG4gIGVyci50eXBlID0gJ1RyYW5zcG9ydEVycm9yJztcbiAgZXJyLmRlc2NyaXB0aW9uID0gZGVzYztcbiAgdGhpcy5lbWl0KCdlcnJvcicsIGVycik7XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBPcGVucyB0aGUgdHJhbnNwb3J0LlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuVHJhbnNwb3J0LnByb3RvdHlwZS5vcGVuID0gZnVuY3Rpb24gKCkge1xuICBpZiAoJ2Nsb3NlZCcgPT09IHRoaXMucmVhZHlTdGF0ZSB8fCAnJyA9PT0gdGhpcy5yZWFkeVN0YXRlKSB7XG4gICAgdGhpcy5yZWFkeVN0YXRlID0gJ29wZW5pbmcnO1xuICAgIHRoaXMuZG9PcGVuKCk7XG4gIH1cblxuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogQ2xvc2VzIHRoZSB0cmFuc3BvcnQuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuVHJhbnNwb3J0LnByb3RvdHlwZS5jbG9zZSA9IGZ1bmN0aW9uICgpIHtcbiAgaWYgKCdvcGVuaW5nJyA9PT0gdGhpcy5yZWFkeVN0YXRlIHx8ICdvcGVuJyA9PT0gdGhpcy5yZWFkeVN0YXRlKSB7XG4gICAgdGhpcy5kb0Nsb3NlKCk7XG4gICAgdGhpcy5vbkNsb3NlKCk7XG4gIH1cblxuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogU2VuZHMgbXVsdGlwbGUgcGFja2V0cy5cbiAqXG4gKiBAcGFyYW0ge0FycmF5fSBwYWNrZXRzXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5UcmFuc3BvcnQucHJvdG90eXBlLnNlbmQgPSBmdW5jdGlvbiAocGFja2V0cykge1xuICBpZiAoJ29wZW4nID09PSB0aGlzLnJlYWR5U3RhdGUpIHtcbiAgICB0aGlzLndyaXRlKHBhY2tldHMpO1xuICB9IGVsc2Uge1xuICAgIHRocm93IG5ldyBFcnJvcignVHJhbnNwb3J0IG5vdCBvcGVuJyk7XG4gIH1cbn07XG5cbi8qKlxuICogQ2FsbGVkIHVwb24gb3BlblxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblRyYW5zcG9ydC5wcm90b3R5cGUub25PcGVuID0gZnVuY3Rpb24gKCkge1xuICB0aGlzLnJlYWR5U3RhdGUgPSAnb3Blbic7XG4gIHRoaXMud3JpdGFibGUgPSB0cnVlO1xuICB0aGlzLmVtaXQoJ29wZW4nKTtcbn07XG5cbi8qKlxuICogQ2FsbGVkIHdpdGggZGF0YS5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gZGF0YVxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuVHJhbnNwb3J0LnByb3RvdHlwZS5vbkRhdGEgPSBmdW5jdGlvbiAoZGF0YSkge1xuICB2YXIgcGFja2V0ID0gcGFyc2VyLmRlY29kZVBhY2tldChkYXRhLCB0aGlzLnNvY2tldC5iaW5hcnlUeXBlKTtcbiAgdGhpcy5vblBhY2tldChwYWNrZXQpO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgd2l0aCBhIGRlY29kZWQgcGFja2V0LlxuICovXG5cblRyYW5zcG9ydC5wcm90b3R5cGUub25QYWNrZXQgPSBmdW5jdGlvbiAocGFja2V0KSB7XG4gIHRoaXMuZW1pdCgncGFja2V0JywgcGFja2V0KTtcbn07XG5cbi8qKlxuICogQ2FsbGVkIHVwb24gY2xvc2UuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuVHJhbnNwb3J0LnByb3RvdHlwZS5vbkNsb3NlID0gZnVuY3Rpb24gKCkge1xuICB0aGlzLnJlYWR5U3RhdGUgPSAnY2xvc2VkJztcbiAgdGhpcy5lbWl0KCdjbG9zZScpO1xufTtcbiIsIi8qKlxuICogTW9kdWxlIGRlcGVuZGVuY2llc1xuICovXG5cbnZhciBYTUxIdHRwUmVxdWVzdCA9IHJlcXVpcmUoJ3htbGh0dHByZXF1ZXN0LXNzbCcpO1xudmFyIFhIUiA9IHJlcXVpcmUoJy4vcG9sbGluZy14aHInKTtcbnZhciBKU09OUCA9IHJlcXVpcmUoJy4vcG9sbGluZy1qc29ucCcpO1xudmFyIHdlYnNvY2tldCA9IHJlcXVpcmUoJy4vd2Vic29ja2V0Jyk7XG5cbi8qKlxuICogRXhwb3J0IHRyYW5zcG9ydHMuXG4gKi9cblxuZXhwb3J0cy5wb2xsaW5nID0gcG9sbGluZztcbmV4cG9ydHMud2Vic29ja2V0ID0gd2Vic29ja2V0O1xuXG4vKipcbiAqIFBvbGxpbmcgdHJhbnNwb3J0IHBvbHltb3JwaGljIGNvbnN0cnVjdG9yLlxuICogRGVjaWRlcyBvbiB4aHIgdnMganNvbnAgYmFzZWQgb24gZmVhdHVyZSBkZXRlY3Rpb24uXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZnVuY3Rpb24gcG9sbGluZyAob3B0cykge1xuICB2YXIgeGhyO1xuICB2YXIgeGQgPSBmYWxzZTtcbiAgdmFyIHhzID0gZmFsc2U7XG4gIHZhciBqc29ucCA9IGZhbHNlICE9PSBvcHRzLmpzb25wO1xuXG4gIGlmIChnbG9iYWwubG9jYXRpb24pIHtcbiAgICB2YXIgaXNTU0wgPSAnaHR0cHM6JyA9PT0gbG9jYXRpb24ucHJvdG9jb2w7XG4gICAgdmFyIHBvcnQgPSBsb2NhdGlvbi5wb3J0O1xuXG4gICAgLy8gc29tZSB1c2VyIGFnZW50cyBoYXZlIGVtcHR5IGBsb2NhdGlvbi5wb3J0YFxuICAgIGlmICghcG9ydCkge1xuICAgICAgcG9ydCA9IGlzU1NMID8gNDQzIDogODA7XG4gICAgfVxuXG4gICAgeGQgPSBvcHRzLmhvc3RuYW1lICE9PSBsb2NhdGlvbi5ob3N0bmFtZSB8fCBwb3J0ICE9PSBvcHRzLnBvcnQ7XG4gICAgeHMgPSBvcHRzLnNlY3VyZSAhPT0gaXNTU0w7XG4gIH1cblxuICBvcHRzLnhkb21haW4gPSB4ZDtcbiAgb3B0cy54c2NoZW1lID0geHM7XG4gIHhociA9IG5ldyBYTUxIdHRwUmVxdWVzdChvcHRzKTtcblxuICBpZiAoJ29wZW4nIGluIHhociAmJiAhb3B0cy5mb3JjZUpTT05QKSB7XG4gICAgcmV0dXJuIG5ldyBYSFIob3B0cyk7XG4gIH0gZWxzZSB7XG4gICAgaWYgKCFqc29ucCkgdGhyb3cgbmV3IEVycm9yKCdKU09OUCBkaXNhYmxlZCcpO1xuICAgIHJldHVybiBuZXcgSlNPTlAob3B0cyk7XG4gIH1cbn1cbiIsIlxuLyoqXG4gKiBNb2R1bGUgcmVxdWlyZW1lbnRzLlxuICovXG5cbnZhciBQb2xsaW5nID0gcmVxdWlyZSgnLi9wb2xsaW5nJyk7XG52YXIgaW5oZXJpdCA9IHJlcXVpcmUoJ2NvbXBvbmVudC1pbmhlcml0Jyk7XG5cbi8qKlxuICogTW9kdWxlIGV4cG9ydHMuXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSBKU09OUFBvbGxpbmc7XG5cbi8qKlxuICogQ2FjaGVkIHJlZ3VsYXIgZXhwcmVzc2lvbnMuXG4gKi9cblxudmFyIHJOZXdsaW5lID0gL1xcbi9nO1xudmFyIHJFc2NhcGVkTmV3bGluZSA9IC9cXFxcbi9nO1xuXG4vKipcbiAqIEdsb2JhbCBKU09OUCBjYWxsYmFja3MuXG4gKi9cblxudmFyIGNhbGxiYWNrcztcblxuLyoqXG4gKiBOb29wLlxuICovXG5cbmZ1bmN0aW9uIGVtcHR5ICgpIHsgfVxuXG4vKipcbiAqIEpTT05QIFBvbGxpbmcgY29uc3RydWN0b3IuXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IG9wdHMuXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIEpTT05QUG9sbGluZyAob3B0cykge1xuICBQb2xsaW5nLmNhbGwodGhpcywgb3B0cyk7XG5cbiAgdGhpcy5xdWVyeSA9IHRoaXMucXVlcnkgfHwge307XG5cbiAgLy8gZGVmaW5lIGdsb2JhbCBjYWxsYmFja3MgYXJyYXkgaWYgbm90IHByZXNlbnRcbiAgLy8gd2UgZG8gdGhpcyBoZXJlIChsYXppbHkpIHRvIGF2b2lkIHVubmVlZGVkIGdsb2JhbCBwb2xsdXRpb25cbiAgaWYgKCFjYWxsYmFja3MpIHtcbiAgICAvLyB3ZSBuZWVkIHRvIGNvbnNpZGVyIG11bHRpcGxlIGVuZ2luZXMgaW4gdGhlIHNhbWUgcGFnZVxuICAgIGlmICghZ2xvYmFsLl9fX2VpbykgZ2xvYmFsLl9fX2VpbyA9IFtdO1xuICAgIGNhbGxiYWNrcyA9IGdsb2JhbC5fX19laW87XG4gIH1cblxuICAvLyBjYWxsYmFjayBpZGVudGlmaWVyXG4gIHRoaXMuaW5kZXggPSBjYWxsYmFja3MubGVuZ3RoO1xuXG4gIC8vIGFkZCBjYWxsYmFjayB0byBqc29ucCBnbG9iYWxcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICBjYWxsYmFja3MucHVzaChmdW5jdGlvbiAobXNnKSB7XG4gICAgc2VsZi5vbkRhdGEobXNnKTtcbiAgfSk7XG5cbiAgLy8gYXBwZW5kIHRvIHF1ZXJ5IHN0cmluZ1xuICB0aGlzLnF1ZXJ5LmogPSB0aGlzLmluZGV4O1xuXG4gIC8vIHByZXZlbnQgc3B1cmlvdXMgZXJyb3JzIGZyb20gYmVpbmcgZW1pdHRlZCB3aGVuIHRoZSB3aW5kb3cgaXMgdW5sb2FkZWRcbiAgaWYgKGdsb2JhbC5kb2N1bWVudCAmJiBnbG9iYWwuYWRkRXZlbnRMaXN0ZW5lcikge1xuICAgIGdsb2JhbC5hZGRFdmVudExpc3RlbmVyKCdiZWZvcmV1bmxvYWQnLCBmdW5jdGlvbiAoKSB7XG4gICAgICBpZiAoc2VsZi5zY3JpcHQpIHNlbGYuc2NyaXB0Lm9uZXJyb3IgPSBlbXB0eTtcbiAgICB9LCBmYWxzZSk7XG4gIH1cbn1cblxuLyoqXG4gKiBJbmhlcml0cyBmcm9tIFBvbGxpbmcuXG4gKi9cblxuaW5oZXJpdChKU09OUFBvbGxpbmcsIFBvbGxpbmcpO1xuXG4vKlxuICogSlNPTlAgb25seSBzdXBwb3J0cyBiaW5hcnkgYXMgYmFzZTY0IGVuY29kZWQgc3RyaW5nc1xuICovXG5cbkpTT05QUG9sbGluZy5wcm90b3R5cGUuc3VwcG9ydHNCaW5hcnkgPSBmYWxzZTtcblxuLyoqXG4gKiBDbG9zZXMgdGhlIHNvY2tldC5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5KU09OUFBvbGxpbmcucHJvdG90eXBlLmRvQ2xvc2UgPSBmdW5jdGlvbiAoKSB7XG4gIGlmICh0aGlzLnNjcmlwdCkge1xuICAgIHRoaXMuc2NyaXB0LnBhcmVudE5vZGUucmVtb3ZlQ2hpbGQodGhpcy5zY3JpcHQpO1xuICAgIHRoaXMuc2NyaXB0ID0gbnVsbDtcbiAgfVxuXG4gIGlmICh0aGlzLmZvcm0pIHtcbiAgICB0aGlzLmZvcm0ucGFyZW50Tm9kZS5yZW1vdmVDaGlsZCh0aGlzLmZvcm0pO1xuICAgIHRoaXMuZm9ybSA9IG51bGw7XG4gICAgdGhpcy5pZnJhbWUgPSBudWxsO1xuICB9XG5cbiAgUG9sbGluZy5wcm90b3R5cGUuZG9DbG9zZS5jYWxsKHRoaXMpO1xufTtcblxuLyoqXG4gKiBTdGFydHMgYSBwb2xsIGN5Y2xlLlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbkpTT05QUG9sbGluZy5wcm90b3R5cGUuZG9Qb2xsID0gZnVuY3Rpb24gKCkge1xuICB2YXIgc2VsZiA9IHRoaXM7XG4gIHZhciBzY3JpcHQgPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KCdzY3JpcHQnKTtcblxuICBpZiAodGhpcy5zY3JpcHQpIHtcbiAgICB0aGlzLnNjcmlwdC5wYXJlbnROb2RlLnJlbW92ZUNoaWxkKHRoaXMuc2NyaXB0KTtcbiAgICB0aGlzLnNjcmlwdCA9IG51bGw7XG4gIH1cblxuICBzY3JpcHQuYXN5bmMgPSB0cnVlO1xuICBzY3JpcHQuc3JjID0gdGhpcy51cmkoKTtcbiAgc2NyaXB0Lm9uZXJyb3IgPSBmdW5jdGlvbiAoZSkge1xuICAgIHNlbGYub25FcnJvcignanNvbnAgcG9sbCBlcnJvcicsIGUpO1xuICB9O1xuXG4gIHZhciBpbnNlcnRBdCA9IGRvY3VtZW50LmdldEVsZW1lbnRzQnlUYWdOYW1lKCdzY3JpcHQnKVswXTtcbiAgaWYgKGluc2VydEF0KSB7XG4gICAgaW5zZXJ0QXQucGFyZW50Tm9kZS5pbnNlcnRCZWZvcmUoc2NyaXB0LCBpbnNlcnRBdCk7XG4gIH0gZWxzZSB7XG4gICAgKGRvY3VtZW50LmhlYWQgfHwgZG9jdW1lbnQuYm9keSkuYXBwZW5kQ2hpbGQoc2NyaXB0KTtcbiAgfVxuICB0aGlzLnNjcmlwdCA9IHNjcmlwdDtcblxuICB2YXIgaXNVQWdlY2tvID0gJ3VuZGVmaW5lZCcgIT09IHR5cGVvZiBuYXZpZ2F0b3IgJiYgL2dlY2tvL2kudGVzdChuYXZpZ2F0b3IudXNlckFnZW50KTtcblxuICBpZiAoaXNVQWdlY2tvKSB7XG4gICAgc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICB2YXIgaWZyYW1lID0gZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgnaWZyYW1lJyk7XG4gICAgICBkb2N1bWVudC5ib2R5LmFwcGVuZENoaWxkKGlmcmFtZSk7XG4gICAgICBkb2N1bWVudC5ib2R5LnJlbW92ZUNoaWxkKGlmcmFtZSk7XG4gICAgfSwgMTAwKTtcbiAgfVxufTtcblxuLyoqXG4gKiBXcml0ZXMgd2l0aCBhIGhpZGRlbiBpZnJhbWUuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IGRhdGEgdG8gc2VuZFxuICogQHBhcmFtIHtGdW5jdGlvbn0gY2FsbGVkIHVwb24gZmx1c2guXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5KU09OUFBvbGxpbmcucHJvdG90eXBlLmRvV3JpdGUgPSBmdW5jdGlvbiAoZGF0YSwgZm4pIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuXG4gIGlmICghdGhpcy5mb3JtKSB7XG4gICAgdmFyIGZvcm0gPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KCdmb3JtJyk7XG4gICAgdmFyIGFyZWEgPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KCd0ZXh0YXJlYScpO1xuICAgIHZhciBpZCA9IHRoaXMuaWZyYW1lSWQgPSAnZWlvX2lmcmFtZV8nICsgdGhpcy5pbmRleDtcbiAgICB2YXIgaWZyYW1lO1xuXG4gICAgZm9ybS5jbGFzc05hbWUgPSAnc29ja2V0aW8nO1xuICAgIGZvcm0uc3R5bGUucG9zaXRpb24gPSAnYWJzb2x1dGUnO1xuICAgIGZvcm0uc3R5bGUudG9wID0gJy0xMDAwcHgnO1xuICAgIGZvcm0uc3R5bGUubGVmdCA9ICctMTAwMHB4JztcbiAgICBmb3JtLnRhcmdldCA9IGlkO1xuICAgIGZvcm0ubWV0aG9kID0gJ1BPU1QnO1xuICAgIGZvcm0uc2V0QXR0cmlidXRlKCdhY2NlcHQtY2hhcnNldCcsICd1dGYtOCcpO1xuICAgIGFyZWEubmFtZSA9ICdkJztcbiAgICBmb3JtLmFwcGVuZENoaWxkKGFyZWEpO1xuICAgIGRvY3VtZW50LmJvZHkuYXBwZW5kQ2hpbGQoZm9ybSk7XG5cbiAgICB0aGlzLmZvcm0gPSBmb3JtO1xuICAgIHRoaXMuYXJlYSA9IGFyZWE7XG4gIH1cblxuICB0aGlzLmZvcm0uYWN0aW9uID0gdGhpcy51cmkoKTtcblxuICBmdW5jdGlvbiBjb21wbGV0ZSAoKSB7XG4gICAgaW5pdElmcmFtZSgpO1xuICAgIGZuKCk7XG4gIH1cblxuICBmdW5jdGlvbiBpbml0SWZyYW1lICgpIHtcbiAgICBpZiAoc2VsZi5pZnJhbWUpIHtcbiAgICAgIHRyeSB7XG4gICAgICAgIHNlbGYuZm9ybS5yZW1vdmVDaGlsZChzZWxmLmlmcmFtZSk7XG4gICAgICB9IGNhdGNoIChlKSB7XG4gICAgICAgIHNlbGYub25FcnJvcignanNvbnAgcG9sbGluZyBpZnJhbWUgcmVtb3ZhbCBlcnJvcicsIGUpO1xuICAgICAgfVxuICAgIH1cblxuICAgIHRyeSB7XG4gICAgICAvLyBpZTYgZHluYW1pYyBpZnJhbWVzIHdpdGggdGFyZ2V0PVwiXCIgc3VwcG9ydCAodGhhbmtzIENocmlzIExhbWJhY2hlcilcbiAgICAgIHZhciBodG1sID0gJzxpZnJhbWUgc3JjPVwiamF2YXNjcmlwdDowXCIgbmFtZT1cIicgKyBzZWxmLmlmcmFtZUlkICsgJ1wiPic7XG4gICAgICBpZnJhbWUgPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KGh0bWwpO1xuICAgIH0gY2F0Y2ggKGUpIHtcbiAgICAgIGlmcmFtZSA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ2lmcmFtZScpO1xuICAgICAgaWZyYW1lLm5hbWUgPSBzZWxmLmlmcmFtZUlkO1xuICAgICAgaWZyYW1lLnNyYyA9ICdqYXZhc2NyaXB0OjAnO1xuICAgIH1cblxuICAgIGlmcmFtZS5pZCA9IHNlbGYuaWZyYW1lSWQ7XG5cbiAgICBzZWxmLmZvcm0uYXBwZW5kQ2hpbGQoaWZyYW1lKTtcbiAgICBzZWxmLmlmcmFtZSA9IGlmcmFtZTtcbiAgfVxuXG4gIGluaXRJZnJhbWUoKTtcblxuICAvLyBlc2NhcGUgXFxuIHRvIHByZXZlbnQgaXQgZnJvbSBiZWluZyBjb252ZXJ0ZWQgaW50byBcXHJcXG4gYnkgc29tZSBVQXNcbiAgLy8gZG91YmxlIGVzY2FwaW5nIGlzIHJlcXVpcmVkIGZvciBlc2NhcGVkIG5ldyBsaW5lcyBiZWNhdXNlIHVuZXNjYXBpbmcgb2YgbmV3IGxpbmVzIGNhbiBiZSBkb25lIHNhZmVseSBvbiBzZXJ2ZXItc2lkZVxuICBkYXRhID0gZGF0YS5yZXBsYWNlKHJFc2NhcGVkTmV3bGluZSwgJ1xcXFxcXG4nKTtcbiAgdGhpcy5hcmVhLnZhbHVlID0gZGF0YS5yZXBsYWNlKHJOZXdsaW5lLCAnXFxcXG4nKTtcblxuICB0cnkge1xuICAgIHRoaXMuZm9ybS5zdWJtaXQoKTtcbiAgfSBjYXRjaCAoZSkge31cblxuICBpZiAodGhpcy5pZnJhbWUuYXR0YWNoRXZlbnQpIHtcbiAgICB0aGlzLmlmcmFtZS5vbnJlYWR5c3RhdGVjaGFuZ2UgPSBmdW5jdGlvbiAoKSB7XG4gICAgICBpZiAoc2VsZi5pZnJhbWUucmVhZHlTdGF0ZSA9PT0gJ2NvbXBsZXRlJykge1xuICAgICAgICBjb21wbGV0ZSgpO1xuICAgICAgfVxuICAgIH07XG4gIH0gZWxzZSB7XG4gICAgdGhpcy5pZnJhbWUub25sb2FkID0gY29tcGxldGU7XG4gIH1cbn07XG4iLCIvKipcbiAqIE1vZHVsZSByZXF1aXJlbWVudHMuXG4gKi9cblxudmFyIFhNTEh0dHBSZXF1ZXN0ID0gcmVxdWlyZSgneG1saHR0cHJlcXVlc3Qtc3NsJyk7XG52YXIgUG9sbGluZyA9IHJlcXVpcmUoJy4vcG9sbGluZycpO1xudmFyIEVtaXR0ZXIgPSByZXF1aXJlKCdjb21wb25lbnQtZW1pdHRlcicpO1xudmFyIGluaGVyaXQgPSByZXF1aXJlKCdjb21wb25lbnQtaW5oZXJpdCcpO1xudmFyIGRlYnVnID0gcmVxdWlyZSgnZGVidWcnKSgnZW5naW5lLmlvLWNsaWVudDpwb2xsaW5nLXhocicpO1xuXG4vKipcbiAqIE1vZHVsZSBleHBvcnRzLlxuICovXG5cbm1vZHVsZS5leHBvcnRzID0gWEhSO1xubW9kdWxlLmV4cG9ydHMuUmVxdWVzdCA9IFJlcXVlc3Q7XG5cbi8qKlxuICogRW1wdHkgZnVuY3Rpb25cbiAqL1xuXG5mdW5jdGlvbiBlbXB0eSAoKSB7fVxuXG4vKipcbiAqIFhIUiBQb2xsaW5nIGNvbnN0cnVjdG9yLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBvcHRzXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIFhIUiAob3B0cykge1xuICBQb2xsaW5nLmNhbGwodGhpcywgb3B0cyk7XG4gIHRoaXMucmVxdWVzdFRpbWVvdXQgPSBvcHRzLnJlcXVlc3RUaW1lb3V0O1xuXG4gIGlmIChnbG9iYWwubG9jYXRpb24pIHtcbiAgICB2YXIgaXNTU0wgPSAnaHR0cHM6JyA9PT0gbG9jYXRpb24ucHJvdG9jb2w7XG4gICAgdmFyIHBvcnQgPSBsb2NhdGlvbi5wb3J0O1xuXG4gICAgLy8gc29tZSB1c2VyIGFnZW50cyBoYXZlIGVtcHR5IGBsb2NhdGlvbi5wb3J0YFxuICAgIGlmICghcG9ydCkge1xuICAgICAgcG9ydCA9IGlzU1NMID8gNDQzIDogODA7XG4gICAgfVxuXG4gICAgdGhpcy54ZCA9IG9wdHMuaG9zdG5hbWUgIT09IGdsb2JhbC5sb2NhdGlvbi5ob3N0bmFtZSB8fFxuICAgICAgcG9ydCAhPT0gb3B0cy5wb3J0O1xuICAgIHRoaXMueHMgPSBvcHRzLnNlY3VyZSAhPT0gaXNTU0w7XG4gIH0gZWxzZSB7XG4gICAgdGhpcy5leHRyYUhlYWRlcnMgPSBvcHRzLmV4dHJhSGVhZGVycztcbiAgfVxufVxuXG4vKipcbiAqIEluaGVyaXRzIGZyb20gUG9sbGluZy5cbiAqL1xuXG5pbmhlcml0KFhIUiwgUG9sbGluZyk7XG5cbi8qKlxuICogWEhSIHN1cHBvcnRzIGJpbmFyeVxuICovXG5cblhIUi5wcm90b3R5cGUuc3VwcG9ydHNCaW5hcnkgPSB0cnVlO1xuXG4vKipcbiAqIENyZWF0ZXMgYSByZXF1ZXN0LlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBtZXRob2RcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblhIUi5wcm90b3R5cGUucmVxdWVzdCA9IGZ1bmN0aW9uIChvcHRzKSB7XG4gIG9wdHMgPSBvcHRzIHx8IHt9O1xuICBvcHRzLnVyaSA9IHRoaXMudXJpKCk7XG4gIG9wdHMueGQgPSB0aGlzLnhkO1xuICBvcHRzLnhzID0gdGhpcy54cztcbiAgb3B0cy5hZ2VudCA9IHRoaXMuYWdlbnQgfHwgZmFsc2U7XG4gIG9wdHMuc3VwcG9ydHNCaW5hcnkgPSB0aGlzLnN1cHBvcnRzQmluYXJ5O1xuICBvcHRzLmVuYWJsZXNYRFIgPSB0aGlzLmVuYWJsZXNYRFI7XG5cbiAgLy8gU1NMIG9wdGlvbnMgZm9yIE5vZGUuanMgY2xpZW50XG4gIG9wdHMucGZ4ID0gdGhpcy5wZng7XG4gIG9wdHMua2V5ID0gdGhpcy5rZXk7XG4gIG9wdHMucGFzc3BocmFzZSA9IHRoaXMucGFzc3BocmFzZTtcbiAgb3B0cy5jZXJ0ID0gdGhpcy5jZXJ0O1xuICBvcHRzLmNhID0gdGhpcy5jYTtcbiAgb3B0cy5jaXBoZXJzID0gdGhpcy5jaXBoZXJzO1xuICBvcHRzLnJlamVjdFVuYXV0aG9yaXplZCA9IHRoaXMucmVqZWN0VW5hdXRob3JpemVkO1xuICBvcHRzLnJlcXVlc3RUaW1lb3V0ID0gdGhpcy5yZXF1ZXN0VGltZW91dDtcblxuICAvLyBvdGhlciBvcHRpb25zIGZvciBOb2RlLmpzIGNsaWVudFxuICBvcHRzLmV4dHJhSGVhZGVycyA9IHRoaXMuZXh0cmFIZWFkZXJzO1xuXG4gIHJldHVybiBuZXcgUmVxdWVzdChvcHRzKTtcbn07XG5cbi8qKlxuICogU2VuZHMgZGF0YS5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gZGF0YSB0byBzZW5kLlxuICogQHBhcmFtIHtGdW5jdGlvbn0gY2FsbGVkIHVwb24gZmx1c2guXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5YSFIucHJvdG90eXBlLmRvV3JpdGUgPSBmdW5jdGlvbiAoZGF0YSwgZm4pIHtcbiAgdmFyIGlzQmluYXJ5ID0gdHlwZW9mIGRhdGEgIT09ICdzdHJpbmcnICYmIGRhdGEgIT09IHVuZGVmaW5lZDtcbiAgdmFyIHJlcSA9IHRoaXMucmVxdWVzdCh7IG1ldGhvZDogJ1BPU1QnLCBkYXRhOiBkYXRhLCBpc0JpbmFyeTogaXNCaW5hcnkgfSk7XG4gIHZhciBzZWxmID0gdGhpcztcbiAgcmVxLm9uKCdzdWNjZXNzJywgZm4pO1xuICByZXEub24oJ2Vycm9yJywgZnVuY3Rpb24gKGVycikge1xuICAgIHNlbGYub25FcnJvcigneGhyIHBvc3QgZXJyb3InLCBlcnIpO1xuICB9KTtcbiAgdGhpcy5zZW5kWGhyID0gcmVxO1xufTtcblxuLyoqXG4gKiBTdGFydHMgYSBwb2xsIGN5Y2xlLlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblhIUi5wcm90b3R5cGUuZG9Qb2xsID0gZnVuY3Rpb24gKCkge1xuICBkZWJ1ZygneGhyIHBvbGwnKTtcbiAgdmFyIHJlcSA9IHRoaXMucmVxdWVzdCgpO1xuICB2YXIgc2VsZiA9IHRoaXM7XG4gIHJlcS5vbignZGF0YScsIGZ1bmN0aW9uIChkYXRhKSB7XG4gICAgc2VsZi5vbkRhdGEoZGF0YSk7XG4gIH0pO1xuICByZXEub24oJ2Vycm9yJywgZnVuY3Rpb24gKGVycikge1xuICAgIHNlbGYub25FcnJvcigneGhyIHBvbGwgZXJyb3InLCBlcnIpO1xuICB9KTtcbiAgdGhpcy5wb2xsWGhyID0gcmVxO1xufTtcblxuLyoqXG4gKiBSZXF1ZXN0IGNvbnN0cnVjdG9yXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IG9wdGlvbnNcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gUmVxdWVzdCAob3B0cykge1xuICB0aGlzLm1ldGhvZCA9IG9wdHMubWV0aG9kIHx8ICdHRVQnO1xuICB0aGlzLnVyaSA9IG9wdHMudXJpO1xuICB0aGlzLnhkID0gISFvcHRzLnhkO1xuICB0aGlzLnhzID0gISFvcHRzLnhzO1xuICB0aGlzLmFzeW5jID0gZmFsc2UgIT09IG9wdHMuYXN5bmM7XG4gIHRoaXMuZGF0YSA9IHVuZGVmaW5lZCAhPT0gb3B0cy5kYXRhID8gb3B0cy5kYXRhIDogbnVsbDtcbiAgdGhpcy5hZ2VudCA9IG9wdHMuYWdlbnQ7XG4gIHRoaXMuaXNCaW5hcnkgPSBvcHRzLmlzQmluYXJ5O1xuICB0aGlzLnN1cHBvcnRzQmluYXJ5ID0gb3B0cy5zdXBwb3J0c0JpbmFyeTtcbiAgdGhpcy5lbmFibGVzWERSID0gb3B0cy5lbmFibGVzWERSO1xuICB0aGlzLnJlcXVlc3RUaW1lb3V0ID0gb3B0cy5yZXF1ZXN0VGltZW91dDtcblxuICAvLyBTU0wgb3B0aW9ucyBmb3IgTm9kZS5qcyBjbGllbnRcbiAgdGhpcy5wZnggPSBvcHRzLnBmeDtcbiAgdGhpcy5rZXkgPSBvcHRzLmtleTtcbiAgdGhpcy5wYXNzcGhyYXNlID0gb3B0cy5wYXNzcGhyYXNlO1xuICB0aGlzLmNlcnQgPSBvcHRzLmNlcnQ7XG4gIHRoaXMuY2EgPSBvcHRzLmNhO1xuICB0aGlzLmNpcGhlcnMgPSBvcHRzLmNpcGhlcnM7XG4gIHRoaXMucmVqZWN0VW5hdXRob3JpemVkID0gb3B0cy5yZWplY3RVbmF1dGhvcml6ZWQ7XG5cbiAgLy8gb3RoZXIgb3B0aW9ucyBmb3IgTm9kZS5qcyBjbGllbnRcbiAgdGhpcy5leHRyYUhlYWRlcnMgPSBvcHRzLmV4dHJhSGVhZGVycztcblxuICB0aGlzLmNyZWF0ZSgpO1xufVxuXG4vKipcbiAqIE1peCBpbiBgRW1pdHRlcmAuXG4gKi9cblxuRW1pdHRlcihSZXF1ZXN0LnByb3RvdHlwZSk7XG5cbi8qKlxuICogQ3JlYXRlcyB0aGUgWEhSIG9iamVjdCBhbmQgc2VuZHMgdGhlIHJlcXVlc3QuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUmVxdWVzdC5wcm90b3R5cGUuY3JlYXRlID0gZnVuY3Rpb24gKCkge1xuICB2YXIgb3B0cyA9IHsgYWdlbnQ6IHRoaXMuYWdlbnQsIHhkb21haW46IHRoaXMueGQsIHhzY2hlbWU6IHRoaXMueHMsIGVuYWJsZXNYRFI6IHRoaXMuZW5hYmxlc1hEUiB9O1xuXG4gIC8vIFNTTCBvcHRpb25zIGZvciBOb2RlLmpzIGNsaWVudFxuICBvcHRzLnBmeCA9IHRoaXMucGZ4O1xuICBvcHRzLmtleSA9IHRoaXMua2V5O1xuICBvcHRzLnBhc3NwaHJhc2UgPSB0aGlzLnBhc3NwaHJhc2U7XG4gIG9wdHMuY2VydCA9IHRoaXMuY2VydDtcbiAgb3B0cy5jYSA9IHRoaXMuY2E7XG4gIG9wdHMuY2lwaGVycyA9IHRoaXMuY2lwaGVycztcbiAgb3B0cy5yZWplY3RVbmF1dGhvcml6ZWQgPSB0aGlzLnJlamVjdFVuYXV0aG9yaXplZDtcblxuICB2YXIgeGhyID0gdGhpcy54aHIgPSBuZXcgWE1MSHR0cFJlcXVlc3Qob3B0cyk7XG4gIHZhciBzZWxmID0gdGhpcztcblxuICB0cnkge1xuICAgIGRlYnVnKCd4aHIgb3BlbiAlczogJXMnLCB0aGlzLm1ldGhvZCwgdGhpcy51cmkpO1xuICAgIHhoci5vcGVuKHRoaXMubWV0aG9kLCB0aGlzLnVyaSwgdGhpcy5hc3luYyk7XG4gICAgdHJ5IHtcbiAgICAgIGlmICh0aGlzLmV4dHJhSGVhZGVycykge1xuICAgICAgICB4aHIuc2V0RGlzYWJsZUhlYWRlckNoZWNrKHRydWUpO1xuICAgICAgICBmb3IgKHZhciBpIGluIHRoaXMuZXh0cmFIZWFkZXJzKSB7XG4gICAgICAgICAgaWYgKHRoaXMuZXh0cmFIZWFkZXJzLmhhc093blByb3BlcnR5KGkpKSB7XG4gICAgICAgICAgICB4aHIuc2V0UmVxdWVzdEhlYWRlcihpLCB0aGlzLmV4dHJhSGVhZGVyc1tpXSk7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfSBjYXRjaCAoZSkge31cbiAgICBpZiAodGhpcy5zdXBwb3J0c0JpbmFyeSkge1xuICAgICAgLy8gVGhpcyBoYXMgdG8gYmUgZG9uZSBhZnRlciBvcGVuIGJlY2F1c2UgRmlyZWZveCBpcyBzdHVwaWRcbiAgICAgIC8vIGh0dHA6Ly9zdGFja292ZXJmbG93LmNvbS9xdWVzdGlvbnMvMTMyMTY5MDMvZ2V0LWJpbmFyeS1kYXRhLXdpdGgteG1saHR0cHJlcXVlc3QtaW4tYS1maXJlZm94LWV4dGVuc2lvblxuICAgICAgeGhyLnJlc3BvbnNlVHlwZSA9ICdhcnJheWJ1ZmZlcic7XG4gICAgfVxuXG4gICAgaWYgKCdQT1NUJyA9PT0gdGhpcy5tZXRob2QpIHtcbiAgICAgIHRyeSB7XG4gICAgICAgIGlmICh0aGlzLmlzQmluYXJ5KSB7XG4gICAgICAgICAgeGhyLnNldFJlcXVlc3RIZWFkZXIoJ0NvbnRlbnQtdHlwZScsICdhcHBsaWNhdGlvbi9vY3RldC1zdHJlYW0nKTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICB4aHIuc2V0UmVxdWVzdEhlYWRlcignQ29udGVudC10eXBlJywgJ3RleHQvcGxhaW47Y2hhcnNldD1VVEYtOCcpO1xuICAgICAgICB9XG4gICAgICB9IGNhdGNoIChlKSB7fVxuICAgIH1cblxuICAgIHRyeSB7XG4gICAgICB4aHIuc2V0UmVxdWVzdEhlYWRlcignQWNjZXB0JywgJyovKicpO1xuICAgIH0gY2F0Y2ggKGUpIHt9XG5cbiAgICAvLyBpZTYgY2hlY2tcbiAgICBpZiAoJ3dpdGhDcmVkZW50aWFscycgaW4geGhyKSB7XG4gICAgICB4aHIud2l0aENyZWRlbnRpYWxzID0gdHJ1ZTtcbiAgICB9XG5cbiAgICBpZiAodGhpcy5yZXF1ZXN0VGltZW91dCkge1xuICAgICAgeGhyLnRpbWVvdXQgPSB0aGlzLnJlcXVlc3RUaW1lb3V0O1xuICAgIH1cblxuICAgIGlmICh0aGlzLmhhc1hEUigpKSB7XG4gICAgICB4aHIub25sb2FkID0gZnVuY3Rpb24gKCkge1xuICAgICAgICBzZWxmLm9uTG9hZCgpO1xuICAgICAgfTtcbiAgICAgIHhoci5vbmVycm9yID0gZnVuY3Rpb24gKCkge1xuICAgICAgICBzZWxmLm9uRXJyb3IoeGhyLnJlc3BvbnNlVGV4dCk7XG4gICAgICB9O1xuICAgIH0gZWxzZSB7XG4gICAgICB4aHIub25yZWFkeXN0YXRlY2hhbmdlID0gZnVuY3Rpb24gKCkge1xuICAgICAgICBpZiAoNCAhPT0geGhyLnJlYWR5U3RhdGUpIHJldHVybjtcbiAgICAgICAgaWYgKDIwMCA9PT0geGhyLnN0YXR1cyB8fCAxMjIzID09PSB4aHIuc3RhdHVzKSB7XG4gICAgICAgICAgc2VsZi5vbkxvYWQoKTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAvLyBtYWtlIHN1cmUgdGhlIGBlcnJvcmAgZXZlbnQgaGFuZGxlciB0aGF0J3MgdXNlci1zZXRcbiAgICAgICAgICAvLyBkb2VzIG5vdCB0aHJvdyBpbiB0aGUgc2FtZSB0aWNrIGFuZCBnZXRzIGNhdWdodCBoZXJlXG4gICAgICAgICAgc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICAgICAgICBzZWxmLm9uRXJyb3IoeGhyLnN0YXR1cyk7XG4gICAgICAgICAgfSwgMCk7XG4gICAgICAgIH1cbiAgICAgIH07XG4gICAgfVxuXG4gICAgZGVidWcoJ3hociBkYXRhICVzJywgdGhpcy5kYXRhKTtcbiAgICB4aHIuc2VuZCh0aGlzLmRhdGEpO1xuICB9IGNhdGNoIChlKSB7XG4gICAgLy8gTmVlZCB0byBkZWZlciBzaW5jZSAuY3JlYXRlKCkgaXMgY2FsbGVkIGRpcmVjdGx5IGZocm9tIHRoZSBjb25zdHJ1Y3RvclxuICAgIC8vIGFuZCB0aHVzIHRoZSAnZXJyb3InIGV2ZW50IGNhbiBvbmx5IGJlIG9ubHkgYm91bmQgKmFmdGVyKiB0aGlzIGV4Y2VwdGlvblxuICAgIC8vIG9jY3Vycy4gIFRoZXJlZm9yZSwgYWxzbywgd2UgY2Fubm90IHRocm93IGhlcmUgYXQgYWxsLlxuICAgIHNldFRpbWVvdXQoZnVuY3Rpb24gKCkge1xuICAgICAgc2VsZi5vbkVycm9yKGUpO1xuICAgIH0sIDApO1xuICAgIHJldHVybjtcbiAgfVxuXG4gIGlmIChnbG9iYWwuZG9jdW1lbnQpIHtcbiAgICB0aGlzLmluZGV4ID0gUmVxdWVzdC5yZXF1ZXN0c0NvdW50Kys7XG4gICAgUmVxdWVzdC5yZXF1ZXN0c1t0aGlzLmluZGV4XSA9IHRoaXM7XG4gIH1cbn07XG5cbi8qKlxuICogQ2FsbGVkIHVwb24gc3VjY2Vzc2Z1bCByZXNwb25zZS5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5SZXF1ZXN0LnByb3RvdHlwZS5vblN1Y2Nlc3MgPSBmdW5jdGlvbiAoKSB7XG4gIHRoaXMuZW1pdCgnc3VjY2VzcycpO1xuICB0aGlzLmNsZWFudXAoKTtcbn07XG5cbi8qKlxuICogQ2FsbGVkIGlmIHdlIGhhdmUgZGF0YS5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5SZXF1ZXN0LnByb3RvdHlwZS5vbkRhdGEgPSBmdW5jdGlvbiAoZGF0YSkge1xuICB0aGlzLmVtaXQoJ2RhdGEnLCBkYXRhKTtcbiAgdGhpcy5vblN1Y2Nlc3MoKTtcbn07XG5cbi8qKlxuICogQ2FsbGVkIHVwb24gZXJyb3IuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUmVxdWVzdC5wcm90b3R5cGUub25FcnJvciA9IGZ1bmN0aW9uIChlcnIpIHtcbiAgdGhpcy5lbWl0KCdlcnJvcicsIGVycik7XG4gIHRoaXMuY2xlYW51cCh0cnVlKTtcbn07XG5cbi8qKlxuICogQ2xlYW5zIHVwIGhvdXNlLlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblJlcXVlc3QucHJvdG90eXBlLmNsZWFudXAgPSBmdW5jdGlvbiAoZnJvbUVycm9yKSB7XG4gIGlmICgndW5kZWZpbmVkJyA9PT0gdHlwZW9mIHRoaXMueGhyIHx8IG51bGwgPT09IHRoaXMueGhyKSB7XG4gICAgcmV0dXJuO1xuICB9XG4gIC8vIHhtbGh0dHByZXF1ZXN0XG4gIGlmICh0aGlzLmhhc1hEUigpKSB7XG4gICAgdGhpcy54aHIub25sb2FkID0gdGhpcy54aHIub25lcnJvciA9IGVtcHR5O1xuICB9IGVsc2Uge1xuICAgIHRoaXMueGhyLm9ucmVhZHlzdGF0ZWNoYW5nZSA9IGVtcHR5O1xuICB9XG5cbiAgaWYgKGZyb21FcnJvcikge1xuICAgIHRyeSB7XG4gICAgICB0aGlzLnhoci5hYm9ydCgpO1xuICAgIH0gY2F0Y2ggKGUpIHt9XG4gIH1cblxuICBpZiAoZ2xvYmFsLmRvY3VtZW50KSB7XG4gICAgZGVsZXRlIFJlcXVlc3QucmVxdWVzdHNbdGhpcy5pbmRleF07XG4gIH1cblxuICB0aGlzLnhociA9IG51bGw7XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIGxvYWQuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUmVxdWVzdC5wcm90b3R5cGUub25Mb2FkID0gZnVuY3Rpb24gKCkge1xuICB2YXIgZGF0YTtcbiAgdHJ5IHtcbiAgICB2YXIgY29udGVudFR5cGU7XG4gICAgdHJ5IHtcbiAgICAgIGNvbnRlbnRUeXBlID0gdGhpcy54aHIuZ2V0UmVzcG9uc2VIZWFkZXIoJ0NvbnRlbnQtVHlwZScpLnNwbGl0KCc7JylbMF07XG4gICAgfSBjYXRjaCAoZSkge31cbiAgICBpZiAoY29udGVudFR5cGUgPT09ICdhcHBsaWNhdGlvbi9vY3RldC1zdHJlYW0nKSB7XG4gICAgICBkYXRhID0gdGhpcy54aHIucmVzcG9uc2UgfHwgdGhpcy54aHIucmVzcG9uc2VUZXh0O1xuICAgIH0gZWxzZSB7XG4gICAgICBpZiAoIXRoaXMuc3VwcG9ydHNCaW5hcnkpIHtcbiAgICAgICAgZGF0YSA9IHRoaXMueGhyLnJlc3BvbnNlVGV4dDtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHRyeSB7XG4gICAgICAgICAgZGF0YSA9IFN0cmluZy5mcm9tQ2hhckNvZGUuYXBwbHkobnVsbCwgbmV3IFVpbnQ4QXJyYXkodGhpcy54aHIucmVzcG9uc2UpKTtcbiAgICAgICAgfSBjYXRjaCAoZSkge1xuICAgICAgICAgIHZhciB1aThBcnIgPSBuZXcgVWludDhBcnJheSh0aGlzLnhoci5yZXNwb25zZSk7XG4gICAgICAgICAgdmFyIGRhdGFBcnJheSA9IFtdO1xuICAgICAgICAgIGZvciAodmFyIGlkeCA9IDAsIGxlbmd0aCA9IHVpOEFyci5sZW5ndGg7IGlkeCA8IGxlbmd0aDsgaWR4KyspIHtcbiAgICAgICAgICAgIGRhdGFBcnJheS5wdXNoKHVpOEFycltpZHhdKTtcbiAgICAgICAgICB9XG5cbiAgICAgICAgICBkYXRhID0gU3RyaW5nLmZyb21DaGFyQ29kZS5hcHBseShudWxsLCBkYXRhQXJyYXkpO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9IGNhdGNoIChlKSB7XG4gICAgdGhpcy5vbkVycm9yKGUpO1xuICB9XG4gIGlmIChudWxsICE9IGRhdGEpIHtcbiAgICB0aGlzLm9uRGF0YShkYXRhKTtcbiAgfVxufTtcblxuLyoqXG4gKiBDaGVjayBpZiBpdCBoYXMgWERvbWFpblJlcXVlc3QuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUmVxdWVzdC5wcm90b3R5cGUuaGFzWERSID0gZnVuY3Rpb24gKCkge1xuICByZXR1cm4gJ3VuZGVmaW5lZCcgIT09IHR5cGVvZiBnbG9iYWwuWERvbWFpblJlcXVlc3QgJiYgIXRoaXMueHMgJiYgdGhpcy5lbmFibGVzWERSO1xufTtcblxuLyoqXG4gKiBBYm9ydHMgdGhlIHJlcXVlc3QuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5SZXF1ZXN0LnByb3RvdHlwZS5hYm9ydCA9IGZ1bmN0aW9uICgpIHtcbiAgdGhpcy5jbGVhbnVwKCk7XG59O1xuXG4vKipcbiAqIEFib3J0cyBwZW5kaW5nIHJlcXVlc3RzIHdoZW4gdW5sb2FkaW5nIHRoZSB3aW5kb3cuIFRoaXMgaXMgbmVlZGVkIHRvIHByZXZlbnRcbiAqIG1lbW9yeSBsZWFrcyAoZS5nLiB3aGVuIHVzaW5nIElFKSBhbmQgdG8gZW5zdXJlIHRoYXQgbm8gc3B1cmlvdXMgZXJyb3IgaXNcbiAqIGVtaXR0ZWQuXG4gKi9cblxuUmVxdWVzdC5yZXF1ZXN0c0NvdW50ID0gMDtcblJlcXVlc3QucmVxdWVzdHMgPSB7fTtcblxuaWYgKGdsb2JhbC5kb2N1bWVudCkge1xuICBpZiAoZ2xvYmFsLmF0dGFjaEV2ZW50KSB7XG4gICAgZ2xvYmFsLmF0dGFjaEV2ZW50KCdvbnVubG9hZCcsIHVubG9hZEhhbmRsZXIpO1xuICB9IGVsc2UgaWYgKGdsb2JhbC5hZGRFdmVudExpc3RlbmVyKSB7XG4gICAgZ2xvYmFsLmFkZEV2ZW50TGlzdGVuZXIoJ2JlZm9yZXVubG9hZCcsIHVubG9hZEhhbmRsZXIsIGZhbHNlKTtcbiAgfVxufVxuXG5mdW5jdGlvbiB1bmxvYWRIYW5kbGVyICgpIHtcbiAgZm9yICh2YXIgaSBpbiBSZXF1ZXN0LnJlcXVlc3RzKSB7XG4gICAgaWYgKFJlcXVlc3QucmVxdWVzdHMuaGFzT3duUHJvcGVydHkoaSkpIHtcbiAgICAgIFJlcXVlc3QucmVxdWVzdHNbaV0uYWJvcnQoKTtcbiAgICB9XG4gIH1cbn1cbiIsIi8qKlxuICogTW9kdWxlIGRlcGVuZGVuY2llcy5cbiAqL1xuXG52YXIgVHJhbnNwb3J0ID0gcmVxdWlyZSgnLi4vdHJhbnNwb3J0Jyk7XG52YXIgcGFyc2VxcyA9IHJlcXVpcmUoJ3BhcnNlcXMnKTtcbnZhciBwYXJzZXIgPSByZXF1aXJlKCdlbmdpbmUuaW8tcGFyc2VyJyk7XG52YXIgaW5oZXJpdCA9IHJlcXVpcmUoJ2NvbXBvbmVudC1pbmhlcml0Jyk7XG52YXIgeWVhc3QgPSByZXF1aXJlKCd5ZWFzdCcpO1xudmFyIGRlYnVnID0gcmVxdWlyZSgnZGVidWcnKSgnZW5naW5lLmlvLWNsaWVudDpwb2xsaW5nJyk7XG5cbi8qKlxuICogTW9kdWxlIGV4cG9ydHMuXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSBQb2xsaW5nO1xuXG4vKipcbiAqIElzIFhIUjIgc3VwcG9ydGVkP1xuICovXG5cbnZhciBoYXNYSFIyID0gKGZ1bmN0aW9uICgpIHtcbiAgdmFyIFhNTEh0dHBSZXF1ZXN0ID0gcmVxdWlyZSgneG1saHR0cHJlcXVlc3Qtc3NsJyk7XG4gIHZhciB4aHIgPSBuZXcgWE1MSHR0cFJlcXVlc3QoeyB4ZG9tYWluOiBmYWxzZSB9KTtcbiAgcmV0dXJuIG51bGwgIT0geGhyLnJlc3BvbnNlVHlwZTtcbn0pKCk7XG5cbi8qKlxuICogUG9sbGluZyBpbnRlcmZhY2UuXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IG9wdHNcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIFBvbGxpbmcgKG9wdHMpIHtcbiAgdmFyIGZvcmNlQmFzZTY0ID0gKG9wdHMgJiYgb3B0cy5mb3JjZUJhc2U2NCk7XG4gIGlmICghaGFzWEhSMiB8fCBmb3JjZUJhc2U2NCkge1xuICAgIHRoaXMuc3VwcG9ydHNCaW5hcnkgPSBmYWxzZTtcbiAgfVxuICBUcmFuc3BvcnQuY2FsbCh0aGlzLCBvcHRzKTtcbn1cblxuLyoqXG4gKiBJbmhlcml0cyBmcm9tIFRyYW5zcG9ydC5cbiAqL1xuXG5pbmhlcml0KFBvbGxpbmcsIFRyYW5zcG9ydCk7XG5cbi8qKlxuICogVHJhbnNwb3J0IG5hbWUuXG4gKi9cblxuUG9sbGluZy5wcm90b3R5cGUubmFtZSA9ICdwb2xsaW5nJztcblxuLyoqXG4gKiBPcGVucyB0aGUgc29ja2V0ICh0cmlnZ2VycyBwb2xsaW5nKS4gV2Ugd3JpdGUgYSBQSU5HIG1lc3NhZ2UgdG8gZGV0ZXJtaW5lXG4gKiB3aGVuIHRoZSB0cmFuc3BvcnQgaXMgb3Blbi5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Qb2xsaW5nLnByb3RvdHlwZS5kb09wZW4gPSBmdW5jdGlvbiAoKSB7XG4gIHRoaXMucG9sbCgpO1xufTtcblxuLyoqXG4gKiBQYXVzZXMgcG9sbGluZy5cbiAqXG4gKiBAcGFyYW0ge0Z1bmN0aW9ufSBjYWxsYmFjayB1cG9uIGJ1ZmZlcnMgYXJlIGZsdXNoZWQgYW5kIHRyYW5zcG9ydCBpcyBwYXVzZWRcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblBvbGxpbmcucHJvdG90eXBlLnBhdXNlID0gZnVuY3Rpb24gKG9uUGF1c2UpIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuXG4gIHRoaXMucmVhZHlTdGF0ZSA9ICdwYXVzaW5nJztcblxuICBmdW5jdGlvbiBwYXVzZSAoKSB7XG4gICAgZGVidWcoJ3BhdXNlZCcpO1xuICAgIHNlbGYucmVhZHlTdGF0ZSA9ICdwYXVzZWQnO1xuICAgIG9uUGF1c2UoKTtcbiAgfVxuXG4gIGlmICh0aGlzLnBvbGxpbmcgfHwgIXRoaXMud3JpdGFibGUpIHtcbiAgICB2YXIgdG90YWwgPSAwO1xuXG4gICAgaWYgKHRoaXMucG9sbGluZykge1xuICAgICAgZGVidWcoJ3dlIGFyZSBjdXJyZW50bHkgcG9sbGluZyAtIHdhaXRpbmcgdG8gcGF1c2UnKTtcbiAgICAgIHRvdGFsKys7XG4gICAgICB0aGlzLm9uY2UoJ3BvbGxDb21wbGV0ZScsIGZ1bmN0aW9uICgpIHtcbiAgICAgICAgZGVidWcoJ3ByZS1wYXVzZSBwb2xsaW5nIGNvbXBsZXRlJyk7XG4gICAgICAgIC0tdG90YWwgfHwgcGF1c2UoKTtcbiAgICAgIH0pO1xuICAgIH1cblxuICAgIGlmICghdGhpcy53cml0YWJsZSkge1xuICAgICAgZGVidWcoJ3dlIGFyZSBjdXJyZW50bHkgd3JpdGluZyAtIHdhaXRpbmcgdG8gcGF1c2UnKTtcbiAgICAgIHRvdGFsKys7XG4gICAgICB0aGlzLm9uY2UoJ2RyYWluJywgZnVuY3Rpb24gKCkge1xuICAgICAgICBkZWJ1ZygncHJlLXBhdXNlIHdyaXRpbmcgY29tcGxldGUnKTtcbiAgICAgICAgLS10b3RhbCB8fCBwYXVzZSgpO1xuICAgICAgfSk7XG4gICAgfVxuICB9IGVsc2Uge1xuICAgIHBhdXNlKCk7XG4gIH1cbn07XG5cbi8qKlxuICogU3RhcnRzIHBvbGxpbmcgY3ljbGUuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5Qb2xsaW5nLnByb3RvdHlwZS5wb2xsID0gZnVuY3Rpb24gKCkge1xuICBkZWJ1ZygncG9sbGluZycpO1xuICB0aGlzLnBvbGxpbmcgPSB0cnVlO1xuICB0aGlzLmRvUG9sbCgpO1xuICB0aGlzLmVtaXQoJ3BvbGwnKTtcbn07XG5cbi8qKlxuICogT3ZlcmxvYWRzIG9uRGF0YSB0byBkZXRlY3QgcGF5bG9hZHMuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUG9sbGluZy5wcm90b3R5cGUub25EYXRhID0gZnVuY3Rpb24gKGRhdGEpIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICBkZWJ1ZygncG9sbGluZyBnb3QgZGF0YSAlcycsIGRhdGEpO1xuICB2YXIgY2FsbGJhY2sgPSBmdW5jdGlvbiAocGFja2V0LCBpbmRleCwgdG90YWwpIHtcbiAgICAvLyBpZiBpdHMgdGhlIGZpcnN0IG1lc3NhZ2Ugd2UgY29uc2lkZXIgdGhlIHRyYW5zcG9ydCBvcGVuXG4gICAgaWYgKCdvcGVuaW5nJyA9PT0gc2VsZi5yZWFkeVN0YXRlKSB7XG4gICAgICBzZWxmLm9uT3BlbigpO1xuICAgIH1cblxuICAgIC8vIGlmIGl0cyBhIGNsb3NlIHBhY2tldCwgd2UgY2xvc2UgdGhlIG9uZ29pbmcgcmVxdWVzdHNcbiAgICBpZiAoJ2Nsb3NlJyA9PT0gcGFja2V0LnR5cGUpIHtcbiAgICAgIHNlbGYub25DbG9zZSgpO1xuICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cblxuICAgIC8vIG90aGVyd2lzZSBieXBhc3Mgb25EYXRhIGFuZCBoYW5kbGUgdGhlIG1lc3NhZ2VcbiAgICBzZWxmLm9uUGFja2V0KHBhY2tldCk7XG4gIH07XG5cbiAgLy8gZGVjb2RlIHBheWxvYWRcbiAgcGFyc2VyLmRlY29kZVBheWxvYWQoZGF0YSwgdGhpcy5zb2NrZXQuYmluYXJ5VHlwZSwgY2FsbGJhY2spO1xuXG4gIC8vIGlmIGFuIGV2ZW50IGRpZCBub3QgdHJpZ2dlciBjbG9zaW5nXG4gIGlmICgnY2xvc2VkJyAhPT0gdGhpcy5yZWFkeVN0YXRlKSB7XG4gICAgLy8gaWYgd2UgZ290IGRhdGEgd2UncmUgbm90IHBvbGxpbmdcbiAgICB0aGlzLnBvbGxpbmcgPSBmYWxzZTtcbiAgICB0aGlzLmVtaXQoJ3BvbGxDb21wbGV0ZScpO1xuXG4gICAgaWYgKCdvcGVuJyA9PT0gdGhpcy5yZWFkeVN0YXRlKSB7XG4gICAgICB0aGlzLnBvbGwoKTtcbiAgICB9IGVsc2Uge1xuICAgICAgZGVidWcoJ2lnbm9yaW5nIHBvbGwgLSB0cmFuc3BvcnQgc3RhdGUgXCIlc1wiJywgdGhpcy5yZWFkeVN0YXRlKTtcbiAgICB9XG4gIH1cbn07XG5cbi8qKlxuICogRm9yIHBvbGxpbmcsIHNlbmQgYSBjbG9zZSBwYWNrZXQuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUG9sbGluZy5wcm90b3R5cGUuZG9DbG9zZSA9IGZ1bmN0aW9uICgpIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuXG4gIGZ1bmN0aW9uIGNsb3NlICgpIHtcbiAgICBkZWJ1Zygnd3JpdGluZyBjbG9zZSBwYWNrZXQnKTtcbiAgICBzZWxmLndyaXRlKFt7IHR5cGU6ICdjbG9zZScgfV0pO1xuICB9XG5cbiAgaWYgKCdvcGVuJyA9PT0gdGhpcy5yZWFkeVN0YXRlKSB7XG4gICAgZGVidWcoJ3RyYW5zcG9ydCBvcGVuIC0gY2xvc2luZycpO1xuICAgIGNsb3NlKCk7XG4gIH0gZWxzZSB7XG4gICAgLy8gaW4gY2FzZSB3ZSdyZSB0cnlpbmcgdG8gY2xvc2Ugd2hpbGVcbiAgICAvLyBoYW5kc2hha2luZyBpcyBpbiBwcm9ncmVzcyAoR0gtMTY0KVxuICAgIGRlYnVnKCd0cmFuc3BvcnQgbm90IG9wZW4gLSBkZWZlcnJpbmcgY2xvc2UnKTtcbiAgICB0aGlzLm9uY2UoJ29wZW4nLCBjbG9zZSk7XG4gIH1cbn07XG5cbi8qKlxuICogV3JpdGVzIGEgcGFja2V0cyBwYXlsb2FkLlxuICpcbiAqIEBwYXJhbSB7QXJyYXl9IGRhdGEgcGFja2V0c1xuICogQHBhcmFtIHtGdW5jdGlvbn0gZHJhaW4gY2FsbGJhY2tcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblBvbGxpbmcucHJvdG90eXBlLndyaXRlID0gZnVuY3Rpb24gKHBhY2tldHMpIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICB0aGlzLndyaXRhYmxlID0gZmFsc2U7XG4gIHZhciBjYWxsYmFja2ZuID0gZnVuY3Rpb24gKCkge1xuICAgIHNlbGYud3JpdGFibGUgPSB0cnVlO1xuICAgIHNlbGYuZW1pdCgnZHJhaW4nKTtcbiAgfTtcblxuICBwYXJzZXIuZW5jb2RlUGF5bG9hZChwYWNrZXRzLCB0aGlzLnN1cHBvcnRzQmluYXJ5LCBmdW5jdGlvbiAoZGF0YSkge1xuICAgIHNlbGYuZG9Xcml0ZShkYXRhLCBjYWxsYmFja2ZuKTtcbiAgfSk7XG59O1xuXG4vKipcbiAqIEdlbmVyYXRlcyB1cmkgZm9yIGNvbm5lY3Rpb24uXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUG9sbGluZy5wcm90b3R5cGUudXJpID0gZnVuY3Rpb24gKCkge1xuICB2YXIgcXVlcnkgPSB0aGlzLnF1ZXJ5IHx8IHt9O1xuICB2YXIgc2NoZW1hID0gdGhpcy5zZWN1cmUgPyAnaHR0cHMnIDogJ2h0dHAnO1xuICB2YXIgcG9ydCA9ICcnO1xuXG4gIC8vIGNhY2hlIGJ1c3RpbmcgaXMgZm9yY2VkXG4gIGlmIChmYWxzZSAhPT0gdGhpcy50aW1lc3RhbXBSZXF1ZXN0cykge1xuICAgIHF1ZXJ5W3RoaXMudGltZXN0YW1wUGFyYW1dID0geWVhc3QoKTtcbiAgfVxuXG4gIGlmICghdGhpcy5zdXBwb3J0c0JpbmFyeSAmJiAhcXVlcnkuc2lkKSB7XG4gICAgcXVlcnkuYjY0ID0gMTtcbiAgfVxuXG4gIHF1ZXJ5ID0gcGFyc2Vxcy5lbmNvZGUocXVlcnkpO1xuXG4gIC8vIGF2b2lkIHBvcnQgaWYgZGVmYXVsdCBmb3Igc2NoZW1hXG4gIGlmICh0aGlzLnBvcnQgJiYgKCgnaHR0cHMnID09PSBzY2hlbWEgJiYgTnVtYmVyKHRoaXMucG9ydCkgIT09IDQ0MykgfHxcbiAgICAgKCdodHRwJyA9PT0gc2NoZW1hICYmIE51bWJlcih0aGlzLnBvcnQpICE9PSA4MCkpKSB7XG4gICAgcG9ydCA9ICc6JyArIHRoaXMucG9ydDtcbiAgfVxuXG4gIC8vIHByZXBlbmQgPyB0byBxdWVyeVxuICBpZiAocXVlcnkubGVuZ3RoKSB7XG4gICAgcXVlcnkgPSAnPycgKyBxdWVyeTtcbiAgfVxuXG4gIHZhciBpcHY2ID0gdGhpcy5ob3N0bmFtZS5pbmRleE9mKCc6JykgIT09IC0xO1xuICByZXR1cm4gc2NoZW1hICsgJzovLycgKyAoaXB2NiA/ICdbJyArIHRoaXMuaG9zdG5hbWUgKyAnXScgOiB0aGlzLmhvc3RuYW1lKSArIHBvcnQgKyB0aGlzLnBhdGggKyBxdWVyeTtcbn07XG4iLCIvKipcbiAqIE1vZHVsZSBkZXBlbmRlbmNpZXMuXG4gKi9cblxudmFyIFRyYW5zcG9ydCA9IHJlcXVpcmUoJy4uL3RyYW5zcG9ydCcpO1xudmFyIHBhcnNlciA9IHJlcXVpcmUoJ2VuZ2luZS5pby1wYXJzZXInKTtcbnZhciBwYXJzZXFzID0gcmVxdWlyZSgncGFyc2VxcycpO1xudmFyIGluaGVyaXQgPSByZXF1aXJlKCdjb21wb25lbnQtaW5oZXJpdCcpO1xudmFyIHllYXN0ID0gcmVxdWlyZSgneWVhc3QnKTtcbnZhciBkZWJ1ZyA9IHJlcXVpcmUoJ2RlYnVnJykoJ2VuZ2luZS5pby1jbGllbnQ6d2Vic29ja2V0Jyk7XG52YXIgQnJvd3NlcldlYlNvY2tldCA9IGdsb2JhbC5XZWJTb2NrZXQgfHwgZ2xvYmFsLk1veldlYlNvY2tldDtcbnZhciBOb2RlV2ViU29ja2V0O1xuaWYgKHR5cGVvZiB3aW5kb3cgPT09ICd1bmRlZmluZWQnKSB7XG4gIHRyeSB7XG4gICAgTm9kZVdlYlNvY2tldCA9IHJlcXVpcmUoJ3dzJyk7XG4gIH0gY2F0Y2ggKGUpIHsgfVxufVxuXG4vKipcbiAqIEdldCBlaXRoZXIgdGhlIGBXZWJTb2NrZXRgIG9yIGBNb3pXZWJTb2NrZXRgIGdsb2JhbHNcbiAqIGluIHRoZSBicm93c2VyIG9yIHRyeSB0byByZXNvbHZlIFdlYlNvY2tldC1jb21wYXRpYmxlXG4gKiBpbnRlcmZhY2UgZXhwb3NlZCBieSBgd3NgIGZvciBOb2RlLWxpa2UgZW52aXJvbm1lbnQuXG4gKi9cblxudmFyIFdlYlNvY2tldCA9IEJyb3dzZXJXZWJTb2NrZXQ7XG5pZiAoIVdlYlNvY2tldCAmJiB0eXBlb2Ygd2luZG93ID09PSAndW5kZWZpbmVkJykge1xuICBXZWJTb2NrZXQgPSBOb2RlV2ViU29ja2V0O1xufVxuXG4vKipcbiAqIE1vZHVsZSBleHBvcnRzLlxuICovXG5cbm1vZHVsZS5leHBvcnRzID0gV1M7XG5cbi8qKlxuICogV2ViU29ja2V0IHRyYW5zcG9ydCBjb25zdHJ1Y3Rvci5cbiAqXG4gKiBAYXBpIHtPYmplY3R9IGNvbm5lY3Rpb24gb3B0aW9uc1xuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBXUyAob3B0cykge1xuICB2YXIgZm9yY2VCYXNlNjQgPSAob3B0cyAmJiBvcHRzLmZvcmNlQmFzZTY0KTtcbiAgaWYgKGZvcmNlQmFzZTY0KSB7XG4gICAgdGhpcy5zdXBwb3J0c0JpbmFyeSA9IGZhbHNlO1xuICB9XG4gIHRoaXMucGVyTWVzc2FnZURlZmxhdGUgPSBvcHRzLnBlck1lc3NhZ2VEZWZsYXRlO1xuICB0aGlzLnVzaW5nQnJvd3NlcldlYlNvY2tldCA9IEJyb3dzZXJXZWJTb2NrZXQgJiYgIW9wdHMuZm9yY2VOb2RlO1xuICBpZiAoIXRoaXMudXNpbmdCcm93c2VyV2ViU29ja2V0KSB7XG4gICAgV2ViU29ja2V0ID0gTm9kZVdlYlNvY2tldDtcbiAgfVxuICBUcmFuc3BvcnQuY2FsbCh0aGlzLCBvcHRzKTtcbn1cblxuLyoqXG4gKiBJbmhlcml0cyBmcm9tIFRyYW5zcG9ydC5cbiAqL1xuXG5pbmhlcml0KFdTLCBUcmFuc3BvcnQpO1xuXG4vKipcbiAqIFRyYW5zcG9ydCBuYW1lLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuV1MucHJvdG90eXBlLm5hbWUgPSAnd2Vic29ja2V0JztcblxuLypcbiAqIFdlYlNvY2tldHMgc3VwcG9ydCBiaW5hcnlcbiAqL1xuXG5XUy5wcm90b3R5cGUuc3VwcG9ydHNCaW5hcnkgPSB0cnVlO1xuXG4vKipcbiAqIE9wZW5zIHNvY2tldC5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5XUy5wcm90b3R5cGUuZG9PcGVuID0gZnVuY3Rpb24gKCkge1xuICBpZiAoIXRoaXMuY2hlY2soKSkge1xuICAgIC8vIGxldCBwcm9iZSB0aW1lb3V0XG4gICAgcmV0dXJuO1xuICB9XG5cbiAgdmFyIHVyaSA9IHRoaXMudXJpKCk7XG4gIHZhciBwcm90b2NvbHMgPSB2b2lkICgwKTtcbiAgdmFyIG9wdHMgPSB7XG4gICAgYWdlbnQ6IHRoaXMuYWdlbnQsXG4gICAgcGVyTWVzc2FnZURlZmxhdGU6IHRoaXMucGVyTWVzc2FnZURlZmxhdGVcbiAgfTtcblxuICAvLyBTU0wgb3B0aW9ucyBmb3IgTm9kZS5qcyBjbGllbnRcbiAgb3B0cy5wZnggPSB0aGlzLnBmeDtcbiAgb3B0cy5rZXkgPSB0aGlzLmtleTtcbiAgb3B0cy5wYXNzcGhyYXNlID0gdGhpcy5wYXNzcGhyYXNlO1xuICBvcHRzLmNlcnQgPSB0aGlzLmNlcnQ7XG4gIG9wdHMuY2EgPSB0aGlzLmNhO1xuICBvcHRzLmNpcGhlcnMgPSB0aGlzLmNpcGhlcnM7XG4gIG9wdHMucmVqZWN0VW5hdXRob3JpemVkID0gdGhpcy5yZWplY3RVbmF1dGhvcml6ZWQ7XG4gIGlmICh0aGlzLmV4dHJhSGVhZGVycykge1xuICAgIG9wdHMuaGVhZGVycyA9IHRoaXMuZXh0cmFIZWFkZXJzO1xuICB9XG4gIGlmICh0aGlzLmxvY2FsQWRkcmVzcykge1xuICAgIG9wdHMubG9jYWxBZGRyZXNzID0gdGhpcy5sb2NhbEFkZHJlc3M7XG4gIH1cblxuICB0cnkge1xuICAgIHRoaXMud3MgPSB0aGlzLnVzaW5nQnJvd3NlcldlYlNvY2tldCA/IG5ldyBXZWJTb2NrZXQodXJpKSA6IG5ldyBXZWJTb2NrZXQodXJpLCBwcm90b2NvbHMsIG9wdHMpO1xuICB9IGNhdGNoIChlcnIpIHtcbiAgICByZXR1cm4gdGhpcy5lbWl0KCdlcnJvcicsIGVycik7XG4gIH1cblxuICBpZiAodGhpcy53cy5iaW5hcnlUeXBlID09PSB1bmRlZmluZWQpIHtcbiAgICB0aGlzLnN1cHBvcnRzQmluYXJ5ID0gZmFsc2U7XG4gIH1cblxuICBpZiAodGhpcy53cy5zdXBwb3J0cyAmJiB0aGlzLndzLnN1cHBvcnRzLmJpbmFyeSkge1xuICAgIHRoaXMuc3VwcG9ydHNCaW5hcnkgPSB0cnVlO1xuICAgIHRoaXMud3MuYmluYXJ5VHlwZSA9ICdub2RlYnVmZmVyJztcbiAgfSBlbHNlIHtcbiAgICB0aGlzLndzLmJpbmFyeVR5cGUgPSAnYXJyYXlidWZmZXInO1xuICB9XG5cbiAgdGhpcy5hZGRFdmVudExpc3RlbmVycygpO1xufTtcblxuLyoqXG4gKiBBZGRzIGV2ZW50IGxpc3RlbmVycyB0byB0aGUgc29ja2V0XG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuV1MucHJvdG90eXBlLmFkZEV2ZW50TGlzdGVuZXJzID0gZnVuY3Rpb24gKCkge1xuICB2YXIgc2VsZiA9IHRoaXM7XG5cbiAgdGhpcy53cy5vbm9wZW4gPSBmdW5jdGlvbiAoKSB7XG4gICAgc2VsZi5vbk9wZW4oKTtcbiAgfTtcbiAgdGhpcy53cy5vbmNsb3NlID0gZnVuY3Rpb24gKCkge1xuICAgIHNlbGYub25DbG9zZSgpO1xuICB9O1xuICB0aGlzLndzLm9ubWVzc2FnZSA9IGZ1bmN0aW9uIChldikge1xuICAgIHNlbGYub25EYXRhKGV2LmRhdGEpO1xuICB9O1xuICB0aGlzLndzLm9uZXJyb3IgPSBmdW5jdGlvbiAoZSkge1xuICAgIHNlbGYub25FcnJvcignd2Vic29ja2V0IGVycm9yJywgZSk7XG4gIH07XG59O1xuXG4vKipcbiAqIFdyaXRlcyBkYXRhIHRvIHNvY2tldC5cbiAqXG4gKiBAcGFyYW0ge0FycmF5fSBhcnJheSBvZiBwYWNrZXRzLlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuV1MucHJvdG90eXBlLndyaXRlID0gZnVuY3Rpb24gKHBhY2tldHMpIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICB0aGlzLndyaXRhYmxlID0gZmFsc2U7XG5cbiAgLy8gZW5jb2RlUGFja2V0IGVmZmljaWVudCBhcyBpdCB1c2VzIFdTIGZyYW1pbmdcbiAgLy8gbm8gbmVlZCBmb3IgZW5jb2RlUGF5bG9hZFxuICB2YXIgdG90YWwgPSBwYWNrZXRzLmxlbmd0aDtcbiAgZm9yICh2YXIgaSA9IDAsIGwgPSB0b3RhbDsgaSA8IGw7IGkrKykge1xuICAgIChmdW5jdGlvbiAocGFja2V0KSB7XG4gICAgICBwYXJzZXIuZW5jb2RlUGFja2V0KHBhY2tldCwgc2VsZi5zdXBwb3J0c0JpbmFyeSwgZnVuY3Rpb24gKGRhdGEpIHtcbiAgICAgICAgaWYgKCFzZWxmLnVzaW5nQnJvd3NlcldlYlNvY2tldCkge1xuICAgICAgICAgIC8vIGFsd2F5cyBjcmVhdGUgYSBuZXcgb2JqZWN0IChHSC00MzcpXG4gICAgICAgICAgdmFyIG9wdHMgPSB7fTtcbiAgICAgICAgICBpZiAocGFja2V0Lm9wdGlvbnMpIHtcbiAgICAgICAgICAgIG9wdHMuY29tcHJlc3MgPSBwYWNrZXQub3B0aW9ucy5jb21wcmVzcztcbiAgICAgICAgICB9XG5cbiAgICAgICAgICBpZiAoc2VsZi5wZXJNZXNzYWdlRGVmbGF0ZSkge1xuICAgICAgICAgICAgdmFyIGxlbiA9ICdzdHJpbmcnID09PSB0eXBlb2YgZGF0YSA/IGdsb2JhbC5CdWZmZXIuYnl0ZUxlbmd0aChkYXRhKSA6IGRhdGEubGVuZ3RoO1xuICAgICAgICAgICAgaWYgKGxlbiA8IHNlbGYucGVyTWVzc2FnZURlZmxhdGUudGhyZXNob2xkKSB7XG4gICAgICAgICAgICAgIG9wdHMuY29tcHJlc3MgPSBmYWxzZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICAvLyBTb21ldGltZXMgdGhlIHdlYnNvY2tldCBoYXMgYWxyZWFkeSBiZWVuIGNsb3NlZCBidXQgdGhlIGJyb3dzZXIgZGlkbid0XG4gICAgICAgIC8vIGhhdmUgYSBjaGFuY2Ugb2YgaW5mb3JtaW5nIHVzIGFib3V0IGl0IHlldCwgaW4gdGhhdCBjYXNlIHNlbmQgd2lsbFxuICAgICAgICAvLyB0aHJvdyBhbiBlcnJvclxuICAgICAgICB0cnkge1xuICAgICAgICAgIGlmIChzZWxmLnVzaW5nQnJvd3NlcldlYlNvY2tldCkge1xuICAgICAgICAgICAgLy8gVHlwZUVycm9yIGlzIHRocm93biB3aGVuIHBhc3NpbmcgdGhlIHNlY29uZCBhcmd1bWVudCBvbiBTYWZhcmlcbiAgICAgICAgICAgIHNlbGYud3Muc2VuZChkYXRhKTtcbiAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgc2VsZi53cy5zZW5kKGRhdGEsIG9wdHMpO1xuICAgICAgICAgIH1cbiAgICAgICAgfSBjYXRjaCAoZSkge1xuICAgICAgICAgIGRlYnVnKCd3ZWJzb2NrZXQgY2xvc2VkIGJlZm9yZSBvbmNsb3NlIGV2ZW50Jyk7XG4gICAgICAgIH1cblxuICAgICAgICAtLXRvdGFsIHx8IGRvbmUoKTtcbiAgICAgIH0pO1xuICAgIH0pKHBhY2tldHNbaV0pO1xuICB9XG5cbiAgZnVuY3Rpb24gZG9uZSAoKSB7XG4gICAgc2VsZi5lbWl0KCdmbHVzaCcpO1xuXG4gICAgLy8gZmFrZSBkcmFpblxuICAgIC8vIGRlZmVyIHRvIG5leHQgdGljayB0byBhbGxvdyBTb2NrZXQgdG8gY2xlYXIgd3JpdGVCdWZmZXJcbiAgICBzZXRUaW1lb3V0KGZ1bmN0aW9uICgpIHtcbiAgICAgIHNlbGYud3JpdGFibGUgPSB0cnVlO1xuICAgICAgc2VsZi5lbWl0KCdkcmFpbicpO1xuICAgIH0sIDApO1xuICB9XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIGNsb3NlXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuV1MucHJvdG90eXBlLm9uQ2xvc2UgPSBmdW5jdGlvbiAoKSB7XG4gIFRyYW5zcG9ydC5wcm90b3R5cGUub25DbG9zZS5jYWxsKHRoaXMpO1xufTtcblxuLyoqXG4gKiBDbG9zZXMgc29ja2V0LlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbldTLnByb3RvdHlwZS5kb0Nsb3NlID0gZnVuY3Rpb24gKCkge1xuICBpZiAodHlwZW9mIHRoaXMud3MgIT09ICd1bmRlZmluZWQnKSB7XG4gICAgdGhpcy53cy5jbG9zZSgpO1xuICB9XG59O1xuXG4vKipcbiAqIEdlbmVyYXRlcyB1cmkgZm9yIGNvbm5lY3Rpb24uXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuV1MucHJvdG90eXBlLnVyaSA9IGZ1bmN0aW9uICgpIHtcbiAgdmFyIHF1ZXJ5ID0gdGhpcy5xdWVyeSB8fCB7fTtcbiAgdmFyIHNjaGVtYSA9IHRoaXMuc2VjdXJlID8gJ3dzcycgOiAnd3MnO1xuICB2YXIgcG9ydCA9ICcnO1xuXG4gIC8vIGF2b2lkIHBvcnQgaWYgZGVmYXVsdCBmb3Igc2NoZW1hXG4gIGlmICh0aGlzLnBvcnQgJiYgKCgnd3NzJyA9PT0gc2NoZW1hICYmIE51bWJlcih0aGlzLnBvcnQpICE9PSA0NDMpIHx8XG4gICAgKCd3cycgPT09IHNjaGVtYSAmJiBOdW1iZXIodGhpcy5wb3J0KSAhPT0gODApKSkge1xuICAgIHBvcnQgPSAnOicgKyB0aGlzLnBvcnQ7XG4gIH1cblxuICAvLyBhcHBlbmQgdGltZXN0YW1wIHRvIFVSSVxuICBpZiAodGhpcy50aW1lc3RhbXBSZXF1ZXN0cykge1xuICAgIHF1ZXJ5W3RoaXMudGltZXN0YW1wUGFyYW1dID0geWVhc3QoKTtcbiAgfVxuXG4gIC8vIGNvbW11bmljYXRlIGJpbmFyeSBzdXBwb3J0IGNhcGFiaWxpdGllc1xuICBpZiAoIXRoaXMuc3VwcG9ydHNCaW5hcnkpIHtcbiAgICBxdWVyeS5iNjQgPSAxO1xuICB9XG5cbiAgcXVlcnkgPSBwYXJzZXFzLmVuY29kZShxdWVyeSk7XG5cbiAgLy8gcHJlcGVuZCA/IHRvIHF1ZXJ5XG4gIGlmIChxdWVyeS5sZW5ndGgpIHtcbiAgICBxdWVyeSA9ICc/JyArIHF1ZXJ5O1xuICB9XG5cbiAgdmFyIGlwdjYgPSB0aGlzLmhvc3RuYW1lLmluZGV4T2YoJzonKSAhPT0gLTE7XG4gIHJldHVybiBzY2hlbWEgKyAnOi8vJyArIChpcHY2ID8gJ1snICsgdGhpcy5ob3N0bmFtZSArICddJyA6IHRoaXMuaG9zdG5hbWUpICsgcG9ydCArIHRoaXMucGF0aCArIHF1ZXJ5O1xufTtcblxuLyoqXG4gKiBGZWF0dXJlIGRldGVjdGlvbiBmb3IgV2ViU29ja2V0LlxuICpcbiAqIEByZXR1cm4ge0Jvb2xlYW59IHdoZXRoZXIgdGhpcyB0cmFuc3BvcnQgaXMgYXZhaWxhYmxlLlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5XUy5wcm90b3R5cGUuY2hlY2sgPSBmdW5jdGlvbiAoKSB7XG4gIHJldHVybiAhIVdlYlNvY2tldCAmJiAhKCdfX2luaXRpYWxpemUnIGluIFdlYlNvY2tldCAmJiB0aGlzLm5hbWUgPT09IFdTLnByb3RvdHlwZS5uYW1lKTtcbn07XG4iLCIvLyBicm93c2VyIHNoaW0gZm9yIHhtbGh0dHByZXF1ZXN0IG1vZHVsZVxuXG52YXIgaGFzQ09SUyA9IHJlcXVpcmUoJ2hhcy1jb3JzJyk7XG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gKG9wdHMpIHtcbiAgdmFyIHhkb21haW4gPSBvcHRzLnhkb21haW47XG5cbiAgLy8gc2NoZW1lIG11c3QgYmUgc2FtZSB3aGVuIHVzaWduIFhEb21haW5SZXF1ZXN0XG4gIC8vIGh0dHA6Ly9ibG9ncy5tc2RuLmNvbS9iL2llaW50ZXJuYWxzL2FyY2hpdmUvMjAxMC8wNS8xMy94ZG9tYWlucmVxdWVzdC1yZXN0cmljdGlvbnMtbGltaXRhdGlvbnMtYW5kLXdvcmthcm91bmRzLmFzcHhcbiAgdmFyIHhzY2hlbWUgPSBvcHRzLnhzY2hlbWU7XG5cbiAgLy8gWERvbWFpblJlcXVlc3QgaGFzIGEgZmxvdyBvZiBub3Qgc2VuZGluZyBjb29raWUsIHRoZXJlZm9yZSBpdCBzaG91bGQgYmUgZGlzYWJsZWQgYXMgYSBkZWZhdWx0LlxuICAvLyBodHRwczovL2dpdGh1Yi5jb20vQXV0b21hdHRpYy9lbmdpbmUuaW8tY2xpZW50L3B1bGwvMjE3XG4gIHZhciBlbmFibGVzWERSID0gb3B0cy5lbmFibGVzWERSO1xuXG4gIC8vIFhNTEh0dHBSZXF1ZXN0IGNhbiBiZSBkaXNhYmxlZCBvbiBJRVxuICB0cnkge1xuICAgIGlmICgndW5kZWZpbmVkJyAhPT0gdHlwZW9mIFhNTEh0dHBSZXF1ZXN0ICYmICgheGRvbWFpbiB8fCBoYXNDT1JTKSkge1xuICAgICAgcmV0dXJuIG5ldyBYTUxIdHRwUmVxdWVzdCgpO1xuICAgIH1cbiAgfSBjYXRjaCAoZSkgeyB9XG5cbiAgLy8gVXNlIFhEb21haW5SZXF1ZXN0IGZvciBJRTggaWYgZW5hYmxlc1hEUiBpcyB0cnVlXG4gIC8vIGJlY2F1c2UgbG9hZGluZyBiYXIga2VlcHMgZmxhc2hpbmcgd2hlbiB1c2luZyBqc29ucC1wb2xsaW5nXG4gIC8vIGh0dHBzOi8vZ2l0aHViLmNvbS95dWppb3Nha2Evc29ja2UuaW8taWU4LWxvYWRpbmctZXhhbXBsZVxuICB0cnkge1xuICAgIGlmICgndW5kZWZpbmVkJyAhPT0gdHlwZW9mIFhEb21haW5SZXF1ZXN0ICYmICF4c2NoZW1lICYmIGVuYWJsZXNYRFIpIHtcbiAgICAgIHJldHVybiBuZXcgWERvbWFpblJlcXVlc3QoKTtcbiAgICB9XG4gIH0gY2F0Y2ggKGUpIHsgfVxuXG4gIGlmICgheGRvbWFpbikge1xuICAgIHRyeSB7XG4gICAgICByZXR1cm4gbmV3IGdsb2JhbFtbJ0FjdGl2ZSddLmNvbmNhdCgnT2JqZWN0Jykuam9pbignWCcpXSgnTWljcm9zb2Z0LlhNTEhUVFAnKTtcbiAgICB9IGNhdGNoIChlKSB7IH1cbiAgfVxufTtcbiIsIlxuLyoqXG4gKiBUaGlzIGlzIHRoZSB3ZWIgYnJvd3NlciBpbXBsZW1lbnRhdGlvbiBvZiBgZGVidWcoKWAuXG4gKlxuICogRXhwb3NlIGBkZWJ1ZygpYCBhcyB0aGUgbW9kdWxlLlxuICovXG5cbmV4cG9ydHMgPSBtb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoJy4vZGVidWcnKTtcbmV4cG9ydHMubG9nID0gbG9nO1xuZXhwb3J0cy5mb3JtYXRBcmdzID0gZm9ybWF0QXJncztcbmV4cG9ydHMuc2F2ZSA9IHNhdmU7XG5leHBvcnRzLmxvYWQgPSBsb2FkO1xuZXhwb3J0cy51c2VDb2xvcnMgPSB1c2VDb2xvcnM7XG5leHBvcnRzLnN0b3JhZ2UgPSAndW5kZWZpbmVkJyAhPSB0eXBlb2YgY2hyb21lXG4gICAgICAgICAgICAgICAmJiAndW5kZWZpbmVkJyAhPSB0eXBlb2YgY2hyb21lLnN0b3JhZ2VcbiAgICAgICAgICAgICAgICAgID8gY2hyb21lLnN0b3JhZ2UubG9jYWxcbiAgICAgICAgICAgICAgICAgIDogbG9jYWxzdG9yYWdlKCk7XG5cbi8qKlxuICogQ29sb3JzLlxuICovXG5cbmV4cG9ydHMuY29sb3JzID0gW1xuICAnbGlnaHRzZWFncmVlbicsXG4gICdmb3Jlc3RncmVlbicsXG4gICdnb2xkZW5yb2QnLFxuICAnZG9kZ2VyYmx1ZScsXG4gICdkYXJrb3JjaGlkJyxcbiAgJ2NyaW1zb24nXG5dO1xuXG4vKipcbiAqIEN1cnJlbnRseSBvbmx5IFdlYktpdC1iYXNlZCBXZWIgSW5zcGVjdG9ycywgRmlyZWZveCA+PSB2MzEsXG4gKiBhbmQgdGhlIEZpcmVidWcgZXh0ZW5zaW9uIChhbnkgRmlyZWZveCB2ZXJzaW9uKSBhcmUga25vd25cbiAqIHRvIHN1cHBvcnQgXCIlY1wiIENTUyBjdXN0b21pemF0aW9ucy5cbiAqXG4gKiBUT0RPOiBhZGQgYSBgbG9jYWxTdG9yYWdlYCB2YXJpYWJsZSB0byBleHBsaWNpdGx5IGVuYWJsZS9kaXNhYmxlIGNvbG9yc1xuICovXG5cbmZ1bmN0aW9uIHVzZUNvbG9ycygpIHtcbiAgLy8gaXMgd2Via2l0PyBodHRwOi8vc3RhY2tvdmVyZmxvdy5jb20vYS8xNjQ1OTYwNi8zNzY3NzNcbiAgLy8gZG9jdW1lbnQgaXMgdW5kZWZpbmVkIGluIHJlYWN0LW5hdGl2ZTogaHR0cHM6Ly9naXRodWIuY29tL2ZhY2Vib29rL3JlYWN0LW5hdGl2ZS9wdWxsLzE2MzJcbiAgcmV0dXJuICh0eXBlb2YgZG9jdW1lbnQgIT09ICd1bmRlZmluZWQnICYmICdXZWJraXRBcHBlYXJhbmNlJyBpbiBkb2N1bWVudC5kb2N1bWVudEVsZW1lbnQuc3R5bGUpIHx8XG4gICAgLy8gaXMgZmlyZWJ1Zz8gaHR0cDovL3N0YWNrb3ZlcmZsb3cuY29tL2EvMzk4MTIwLzM3Njc3M1xuICAgICh3aW5kb3cuY29uc29sZSAmJiAoY29uc29sZS5maXJlYnVnIHx8IChjb25zb2xlLmV4Y2VwdGlvbiAmJiBjb25zb2xlLnRhYmxlKSkpIHx8XG4gICAgLy8gaXMgZmlyZWZveCA+PSB2MzE/XG4gICAgLy8gaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9Ub29scy9XZWJfQ29uc29sZSNTdHlsaW5nX21lc3NhZ2VzXG4gICAgKG5hdmlnYXRvci51c2VyQWdlbnQudG9Mb3dlckNhc2UoKS5tYXRjaCgvZmlyZWZveFxcLyhcXGQrKS8pICYmIHBhcnNlSW50KFJlZ0V4cC4kMSwgMTApID49IDMxKTtcbn1cblxuLyoqXG4gKiBNYXAgJWogdG8gYEpTT04uc3RyaW5naWZ5KClgLCBzaW5jZSBubyBXZWIgSW5zcGVjdG9ycyBkbyB0aGF0IGJ5IGRlZmF1bHQuXG4gKi9cblxuZXhwb3J0cy5mb3JtYXR0ZXJzLmogPSBmdW5jdGlvbih2KSB7XG4gIHRyeSB7XG4gICAgcmV0dXJuIEpTT04uc3RyaW5naWZ5KHYpO1xuICB9IGNhdGNoIChlcnIpIHtcbiAgICByZXR1cm4gJ1tVbmV4cGVjdGVkSlNPTlBhcnNlRXJyb3JdOiAnICsgZXJyLm1lc3NhZ2U7XG4gIH1cbn07XG5cblxuLyoqXG4gKiBDb2xvcml6ZSBsb2cgYXJndW1lbnRzIGlmIGVuYWJsZWQuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBmb3JtYXRBcmdzKCkge1xuICB2YXIgYXJncyA9IGFyZ3VtZW50cztcbiAgdmFyIHVzZUNvbG9ycyA9IHRoaXMudXNlQ29sb3JzO1xuXG4gIGFyZ3NbMF0gPSAodXNlQ29sb3JzID8gJyVjJyA6ICcnKVxuICAgICsgdGhpcy5uYW1lc3BhY2VcbiAgICArICh1c2VDb2xvcnMgPyAnICVjJyA6ICcgJylcbiAgICArIGFyZ3NbMF1cbiAgICArICh1c2VDb2xvcnMgPyAnJWMgJyA6ICcgJylcbiAgICArICcrJyArIGV4cG9ydHMuaHVtYW5pemUodGhpcy5kaWZmKTtcblxuICBpZiAoIXVzZUNvbG9ycykgcmV0dXJuIGFyZ3M7XG5cbiAgdmFyIGMgPSAnY29sb3I6ICcgKyB0aGlzLmNvbG9yO1xuICBhcmdzID0gW2FyZ3NbMF0sIGMsICdjb2xvcjogaW5oZXJpdCddLmNvbmNhdChBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmdzLCAxKSk7XG5cbiAgLy8gdGhlIGZpbmFsIFwiJWNcIiBpcyBzb21ld2hhdCB0cmlja3ksIGJlY2F1c2UgdGhlcmUgY291bGQgYmUgb3RoZXJcbiAgLy8gYXJndW1lbnRzIHBhc3NlZCBlaXRoZXIgYmVmb3JlIG9yIGFmdGVyIHRoZSAlYywgc28gd2UgbmVlZCB0b1xuICAvLyBmaWd1cmUgb3V0IHRoZSBjb3JyZWN0IGluZGV4IHRvIGluc2VydCB0aGUgQ1NTIGludG9cbiAgdmFyIGluZGV4ID0gMDtcbiAgdmFyIGxhc3RDID0gMDtcbiAgYXJnc1swXS5yZXBsYWNlKC8lW2EteiVdL2csIGZ1bmN0aW9uKG1hdGNoKSB7XG4gICAgaWYgKCclJScgPT09IG1hdGNoKSByZXR1cm47XG4gICAgaW5kZXgrKztcbiAgICBpZiAoJyVjJyA9PT0gbWF0Y2gpIHtcbiAgICAgIC8vIHdlIG9ubHkgYXJlIGludGVyZXN0ZWQgaW4gdGhlICpsYXN0KiAlY1xuICAgICAgLy8gKHRoZSB1c2VyIG1heSBoYXZlIHByb3ZpZGVkIHRoZWlyIG93bilcbiAgICAgIGxhc3RDID0gaW5kZXg7XG4gICAgfVxuICB9KTtcblxuICBhcmdzLnNwbGljZShsYXN0QywgMCwgYyk7XG4gIHJldHVybiBhcmdzO1xufVxuXG4vKipcbiAqIEludm9rZXMgYGNvbnNvbGUubG9nKClgIHdoZW4gYXZhaWxhYmxlLlxuICogTm8tb3Agd2hlbiBgY29uc29sZS5sb2dgIGlzIG5vdCBhIFwiZnVuY3Rpb25cIi5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGxvZygpIHtcbiAgLy8gdGhpcyBoYWNrZXJ5IGlzIHJlcXVpcmVkIGZvciBJRTgvOSwgd2hlcmVcbiAgLy8gdGhlIGBjb25zb2xlLmxvZ2AgZnVuY3Rpb24gZG9lc24ndCBoYXZlICdhcHBseSdcbiAgcmV0dXJuICdvYmplY3QnID09PSB0eXBlb2YgY29uc29sZVxuICAgICYmIGNvbnNvbGUubG9nXG4gICAgJiYgRnVuY3Rpb24ucHJvdG90eXBlLmFwcGx5LmNhbGwoY29uc29sZS5sb2csIGNvbnNvbGUsIGFyZ3VtZW50cyk7XG59XG5cbi8qKlxuICogU2F2ZSBgbmFtZXNwYWNlc2AuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IG5hbWVzcGFjZXNcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIHNhdmUobmFtZXNwYWNlcykge1xuICB0cnkge1xuICAgIGlmIChudWxsID09IG5hbWVzcGFjZXMpIHtcbiAgICAgIGV4cG9ydHMuc3RvcmFnZS5yZW1vdmVJdGVtKCdkZWJ1ZycpO1xuICAgIH0gZWxzZSB7XG4gICAgICBleHBvcnRzLnN0b3JhZ2UuZGVidWcgPSBuYW1lc3BhY2VzO1xuICAgIH1cbiAgfSBjYXRjaChlKSB7fVxufVxuXG4vKipcbiAqIExvYWQgYG5hbWVzcGFjZXNgLlxuICpcbiAqIEByZXR1cm4ge1N0cmluZ30gcmV0dXJucyB0aGUgcHJldmlvdXNseSBwZXJzaXN0ZWQgZGVidWcgbW9kZXNcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIGxvYWQoKSB7XG4gIHZhciByO1xuICB0cnkge1xuICAgIHJldHVybiBleHBvcnRzLnN0b3JhZ2UuZGVidWc7XG4gIH0gY2F0Y2goZSkge31cblxuICAvLyBJZiBkZWJ1ZyBpc24ndCBzZXQgaW4gTFMsIGFuZCB3ZSdyZSBpbiBFbGVjdHJvbiwgdHJ5IHRvIGxvYWQgJERFQlVHXG4gIGlmICh0eXBlb2YgcHJvY2VzcyAhPT0gJ3VuZGVmaW5lZCcgJiYgJ2VudicgaW4gcHJvY2Vzcykge1xuICAgIHJldHVybiBwcm9jZXNzLmVudi5ERUJVRztcbiAgfVxufVxuXG4vKipcbiAqIEVuYWJsZSBuYW1lc3BhY2VzIGxpc3RlZCBpbiBgbG9jYWxTdG9yYWdlLmRlYnVnYCBpbml0aWFsbHkuXG4gKi9cblxuZXhwb3J0cy5lbmFibGUobG9hZCgpKTtcblxuLyoqXG4gKiBMb2NhbHN0b3JhZ2UgYXR0ZW1wdHMgdG8gcmV0dXJuIHRoZSBsb2NhbHN0b3JhZ2UuXG4gKlxuICogVGhpcyBpcyBuZWNlc3NhcnkgYmVjYXVzZSBzYWZhcmkgdGhyb3dzXG4gKiB3aGVuIGEgdXNlciBkaXNhYmxlcyBjb29raWVzL2xvY2Fsc3RvcmFnZVxuICogYW5kIHlvdSBhdHRlbXB0IHRvIGFjY2VzcyBpdC5cbiAqXG4gKiBAcmV0dXJuIHtMb2NhbFN0b3JhZ2V9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBsb2NhbHN0b3JhZ2UoKXtcbiAgdHJ5IHtcbiAgICByZXR1cm4gd2luZG93LmxvY2FsU3RvcmFnZTtcbiAgfSBjYXRjaCAoZSkge31cbn1cbiIsIlxuLyoqXG4gKiBUaGlzIGlzIHRoZSBjb21tb24gbG9naWMgZm9yIGJvdGggdGhlIE5vZGUuanMgYW5kIHdlYiBicm93c2VyXG4gKiBpbXBsZW1lbnRhdGlvbnMgb2YgYGRlYnVnKClgLlxuICpcbiAqIEV4cG9zZSBgZGVidWcoKWAgYXMgdGhlIG1vZHVsZS5cbiAqL1xuXG5leHBvcnRzID0gbW9kdWxlLmV4cG9ydHMgPSBkZWJ1Zy5kZWJ1ZyA9IGRlYnVnO1xuZXhwb3J0cy5jb2VyY2UgPSBjb2VyY2U7XG5leHBvcnRzLmRpc2FibGUgPSBkaXNhYmxlO1xuZXhwb3J0cy5lbmFibGUgPSBlbmFibGU7XG5leHBvcnRzLmVuYWJsZWQgPSBlbmFibGVkO1xuZXhwb3J0cy5odW1hbml6ZSA9IHJlcXVpcmUoJ21zJyk7XG5cbi8qKlxuICogVGhlIGN1cnJlbnRseSBhY3RpdmUgZGVidWcgbW9kZSBuYW1lcywgYW5kIG5hbWVzIHRvIHNraXAuXG4gKi9cblxuZXhwb3J0cy5uYW1lcyA9IFtdO1xuZXhwb3J0cy5za2lwcyA9IFtdO1xuXG4vKipcbiAqIE1hcCBvZiBzcGVjaWFsIFwiJW5cIiBoYW5kbGluZyBmdW5jdGlvbnMsIGZvciB0aGUgZGVidWcgXCJmb3JtYXRcIiBhcmd1bWVudC5cbiAqXG4gKiBWYWxpZCBrZXkgbmFtZXMgYXJlIGEgc2luZ2xlLCBsb3dlcmNhc2VkIGxldHRlciwgaS5lLiBcIm5cIi5cbiAqL1xuXG5leHBvcnRzLmZvcm1hdHRlcnMgPSB7fTtcblxuLyoqXG4gKiBQcmV2aW91c2x5IGFzc2lnbmVkIGNvbG9yLlxuICovXG5cbnZhciBwcmV2Q29sb3IgPSAwO1xuXG4vKipcbiAqIFByZXZpb3VzIGxvZyB0aW1lc3RhbXAuXG4gKi9cblxudmFyIHByZXZUaW1lO1xuXG4vKipcbiAqIFNlbGVjdCBhIGNvbG9yLlxuICpcbiAqIEByZXR1cm4ge051bWJlcn1cbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIHNlbGVjdENvbG9yKCkge1xuICByZXR1cm4gZXhwb3J0cy5jb2xvcnNbcHJldkNvbG9yKysgJSBleHBvcnRzLmNvbG9ycy5sZW5ndGhdO1xufVxuXG4vKipcbiAqIENyZWF0ZSBhIGRlYnVnZ2VyIHdpdGggdGhlIGdpdmVuIGBuYW1lc3BhY2VgLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBuYW1lc3BhY2VcbiAqIEByZXR1cm4ge0Z1bmN0aW9ufVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBkZWJ1ZyhuYW1lc3BhY2UpIHtcblxuICAvLyBkZWZpbmUgdGhlIGBkaXNhYmxlZGAgdmVyc2lvblxuICBmdW5jdGlvbiBkaXNhYmxlZCgpIHtcbiAgfVxuICBkaXNhYmxlZC5lbmFibGVkID0gZmFsc2U7XG5cbiAgLy8gZGVmaW5lIHRoZSBgZW5hYmxlZGAgdmVyc2lvblxuICBmdW5jdGlvbiBlbmFibGVkKCkge1xuXG4gICAgdmFyIHNlbGYgPSBlbmFibGVkO1xuXG4gICAgLy8gc2V0IGBkaWZmYCB0aW1lc3RhbXBcbiAgICB2YXIgY3VyciA9ICtuZXcgRGF0ZSgpO1xuICAgIHZhciBtcyA9IGN1cnIgLSAocHJldlRpbWUgfHwgY3Vycik7XG4gICAgc2VsZi5kaWZmID0gbXM7XG4gICAgc2VsZi5wcmV2ID0gcHJldlRpbWU7XG4gICAgc2VsZi5jdXJyID0gY3VycjtcbiAgICBwcmV2VGltZSA9IGN1cnI7XG5cbiAgICAvLyBhZGQgdGhlIGBjb2xvcmAgaWYgbm90IHNldFxuICAgIGlmIChudWxsID09IHNlbGYudXNlQ29sb3JzKSBzZWxmLnVzZUNvbG9ycyA9IGV4cG9ydHMudXNlQ29sb3JzKCk7XG4gICAgaWYgKG51bGwgPT0gc2VsZi5jb2xvciAmJiBzZWxmLnVzZUNvbG9ycykgc2VsZi5jb2xvciA9IHNlbGVjdENvbG9yKCk7XG5cbiAgICB2YXIgYXJncyA9IG5ldyBBcnJheShhcmd1bWVudHMubGVuZ3RoKTtcbiAgICBmb3IgKHZhciBpID0gMDsgaSA8IGFyZ3MubGVuZ3RoOyBpKyspIHtcbiAgICAgIGFyZ3NbaV0gPSBhcmd1bWVudHNbaV07XG4gICAgfVxuXG4gICAgYXJnc1swXSA9IGV4cG9ydHMuY29lcmNlKGFyZ3NbMF0pO1xuXG4gICAgaWYgKCdzdHJpbmcnICE9PSB0eXBlb2YgYXJnc1swXSkge1xuICAgICAgLy8gYW55dGhpbmcgZWxzZSBsZXQncyBpbnNwZWN0IHdpdGggJW9cbiAgICAgIGFyZ3MgPSBbJyVvJ10uY29uY2F0KGFyZ3MpO1xuICAgIH1cblxuICAgIC8vIGFwcGx5IGFueSBgZm9ybWF0dGVyc2AgdHJhbnNmb3JtYXRpb25zXG4gICAgdmFyIGluZGV4ID0gMDtcbiAgICBhcmdzWzBdID0gYXJnc1swXS5yZXBsYWNlKC8lKFthLXolXSkvZywgZnVuY3Rpb24obWF0Y2gsIGZvcm1hdCkge1xuICAgICAgLy8gaWYgd2UgZW5jb3VudGVyIGFuIGVzY2FwZWQgJSB0aGVuIGRvbid0IGluY3JlYXNlIHRoZSBhcnJheSBpbmRleFxuICAgICAgaWYgKG1hdGNoID09PSAnJSUnKSByZXR1cm4gbWF0Y2g7XG4gICAgICBpbmRleCsrO1xuICAgICAgdmFyIGZvcm1hdHRlciA9IGV4cG9ydHMuZm9ybWF0dGVyc1tmb3JtYXRdO1xuICAgICAgaWYgKCdmdW5jdGlvbicgPT09IHR5cGVvZiBmb3JtYXR0ZXIpIHtcbiAgICAgICAgdmFyIHZhbCA9IGFyZ3NbaW5kZXhdO1xuICAgICAgICBtYXRjaCA9IGZvcm1hdHRlci5jYWxsKHNlbGYsIHZhbCk7XG5cbiAgICAgICAgLy8gbm93IHdlIG5lZWQgdG8gcmVtb3ZlIGBhcmdzW2luZGV4XWAgc2luY2UgaXQncyBpbmxpbmVkIGluIHRoZSBgZm9ybWF0YFxuICAgICAgICBhcmdzLnNwbGljZShpbmRleCwgMSk7XG4gICAgICAgIGluZGV4LS07XG4gICAgICB9XG4gICAgICByZXR1cm4gbWF0Y2g7XG4gICAgfSk7XG5cbiAgICAvLyBhcHBseSBlbnYtc3BlY2lmaWMgZm9ybWF0dGluZ1xuICAgIGFyZ3MgPSBleHBvcnRzLmZvcm1hdEFyZ3MuYXBwbHkoc2VsZiwgYXJncyk7XG5cbiAgICB2YXIgbG9nRm4gPSBlbmFibGVkLmxvZyB8fCBleHBvcnRzLmxvZyB8fCBjb25zb2xlLmxvZy5iaW5kKGNvbnNvbGUpO1xuICAgIGxvZ0ZuLmFwcGx5KHNlbGYsIGFyZ3MpO1xuICB9XG4gIGVuYWJsZWQuZW5hYmxlZCA9IHRydWU7XG5cbiAgdmFyIGZuID0gZXhwb3J0cy5lbmFibGVkKG5hbWVzcGFjZSkgPyBlbmFibGVkIDogZGlzYWJsZWQ7XG5cbiAgZm4ubmFtZXNwYWNlID0gbmFtZXNwYWNlO1xuXG4gIHJldHVybiBmbjtcbn1cblxuLyoqXG4gKiBFbmFibGVzIGEgZGVidWcgbW9kZSBieSBuYW1lc3BhY2VzLiBUaGlzIGNhbiBpbmNsdWRlIG1vZGVzXG4gKiBzZXBhcmF0ZWQgYnkgYSBjb2xvbiBhbmQgd2lsZGNhcmRzLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBuYW1lc3BhY2VzXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGVuYWJsZShuYW1lc3BhY2VzKSB7XG4gIGV4cG9ydHMuc2F2ZShuYW1lc3BhY2VzKTtcblxuICB2YXIgc3BsaXQgPSAobmFtZXNwYWNlcyB8fCAnJykuc3BsaXQoL1tcXHMsXSsvKTtcbiAgdmFyIGxlbiA9IHNwbGl0Lmxlbmd0aDtcblxuICBmb3IgKHZhciBpID0gMDsgaSA8IGxlbjsgaSsrKSB7XG4gICAgaWYgKCFzcGxpdFtpXSkgY29udGludWU7IC8vIGlnbm9yZSBlbXB0eSBzdHJpbmdzXG4gICAgbmFtZXNwYWNlcyA9IHNwbGl0W2ldLnJlcGxhY2UoL1tcXFxcXiQrPy4oKXxbXFxde31dL2csICdcXFxcJCYnKS5yZXBsYWNlKC9cXCovZywgJy4qPycpO1xuICAgIGlmIChuYW1lc3BhY2VzWzBdID09PSAnLScpIHtcbiAgICAgIGV4cG9ydHMuc2tpcHMucHVzaChuZXcgUmVnRXhwKCdeJyArIG5hbWVzcGFjZXMuc3Vic3RyKDEpICsgJyQnKSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIGV4cG9ydHMubmFtZXMucHVzaChuZXcgUmVnRXhwKCdeJyArIG5hbWVzcGFjZXMgKyAnJCcpKTtcbiAgICB9XG4gIH1cbn1cblxuLyoqXG4gKiBEaXNhYmxlIGRlYnVnIG91dHB1dC5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGRpc2FibGUoKSB7XG4gIGV4cG9ydHMuZW5hYmxlKCcnKTtcbn1cblxuLyoqXG4gKiBSZXR1cm5zIHRydWUgaWYgdGhlIGdpdmVuIG1vZGUgbmFtZSBpcyBlbmFibGVkLCBmYWxzZSBvdGhlcndpc2UuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IG5hbWVcbiAqIEByZXR1cm4ge0Jvb2xlYW59XG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGVuYWJsZWQobmFtZSkge1xuICB2YXIgaSwgbGVuO1xuICBmb3IgKGkgPSAwLCBsZW4gPSBleHBvcnRzLnNraXBzLmxlbmd0aDsgaSA8IGxlbjsgaSsrKSB7XG4gICAgaWYgKGV4cG9ydHMuc2tpcHNbaV0udGVzdChuYW1lKSkge1xuICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cbiAgfVxuICBmb3IgKGkgPSAwLCBsZW4gPSBleHBvcnRzLm5hbWVzLmxlbmd0aDsgaSA8IGxlbjsgaSsrKSB7XG4gICAgaWYgKGV4cG9ydHMubmFtZXNbaV0udGVzdChuYW1lKSkge1xuICAgICAgcmV0dXJuIHRydWU7XG4gICAgfVxuICB9XG4gIHJldHVybiBmYWxzZTtcbn1cblxuLyoqXG4gKiBDb2VyY2UgYHZhbGAuXG4gKlxuICogQHBhcmFtIHtNaXhlZH0gdmFsXG4gKiBAcmV0dXJuIHtNaXhlZH1cbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIGNvZXJjZSh2YWwpIHtcbiAgaWYgKHZhbCBpbnN0YW5jZW9mIEVycm9yKSByZXR1cm4gdmFsLnN0YWNrIHx8IHZhbC5tZXNzYWdlO1xuICByZXR1cm4gdmFsO1xufVxuIiwiLyoqXG4gKiBIZWxwZXJzLlxuICovXG5cbnZhciBzID0gMTAwMFxudmFyIG0gPSBzICogNjBcbnZhciBoID0gbSAqIDYwXG52YXIgZCA9IGggKiAyNFxudmFyIHkgPSBkICogMzY1LjI1XG5cbi8qKlxuICogUGFyc2Ugb3IgZm9ybWF0IHRoZSBnaXZlbiBgdmFsYC5cbiAqXG4gKiBPcHRpb25zOlxuICpcbiAqICAtIGBsb25nYCB2ZXJib3NlIGZvcm1hdHRpbmcgW2ZhbHNlXVxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfE51bWJlcn0gdmFsXG4gKiBAcGFyYW0ge09iamVjdH0gb3B0aW9uc1xuICogQHRocm93cyB7RXJyb3J9IHRocm93IGFuIGVycm9yIGlmIHZhbCBpcyBub3QgYSBub24tZW1wdHkgc3RyaW5nIG9yIGEgbnVtYmVyXG4gKiBAcmV0dXJuIHtTdHJpbmd8TnVtYmVyfVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uICh2YWwsIG9wdGlvbnMpIHtcbiAgb3B0aW9ucyA9IG9wdGlvbnMgfHwge31cbiAgdmFyIHR5cGUgPSB0eXBlb2YgdmFsXG4gIGlmICh0eXBlID09PSAnc3RyaW5nJyAmJiB2YWwubGVuZ3RoID4gMCkge1xuICAgIHJldHVybiBwYXJzZSh2YWwpXG4gIH0gZWxzZSBpZiAodHlwZSA9PT0gJ251bWJlcicgJiYgaXNOYU4odmFsKSA9PT0gZmFsc2UpIHtcbiAgICByZXR1cm4gb3B0aW9ucy5sb25nID9cblx0XHRcdGZtdExvbmcodmFsKSA6XG5cdFx0XHRmbXRTaG9ydCh2YWwpXG4gIH1cbiAgdGhyb3cgbmV3IEVycm9yKCd2YWwgaXMgbm90IGEgbm9uLWVtcHR5IHN0cmluZyBvciBhIHZhbGlkIG51bWJlci4gdmFsPScgKyBKU09OLnN0cmluZ2lmeSh2YWwpKVxufVxuXG4vKipcbiAqIFBhcnNlIHRoZSBnaXZlbiBgc3RyYCBhbmQgcmV0dXJuIG1pbGxpc2Vjb25kcy5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gc3RyXG4gKiBAcmV0dXJuIHtOdW1iZXJ9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBwYXJzZShzdHIpIHtcbiAgc3RyID0gU3RyaW5nKHN0cilcbiAgaWYgKHN0ci5sZW5ndGggPiAxMDAwMCkge1xuICAgIHJldHVyblxuICB9XG4gIHZhciBtYXRjaCA9IC9eKCg/OlxcZCspP1xcLj9cXGQrKSAqKG1pbGxpc2Vjb25kcz98bXNlY3M/fG1zfHNlY29uZHM/fHNlY3M/fHN8bWludXRlcz98bWlucz98bXxob3Vycz98aHJzP3xofGRheXM/fGR8eWVhcnM/fHlycz98eSk/JC9pLmV4ZWMoc3RyKVxuICBpZiAoIW1hdGNoKSB7XG4gICAgcmV0dXJuXG4gIH1cbiAgdmFyIG4gPSBwYXJzZUZsb2F0KG1hdGNoWzFdKVxuICB2YXIgdHlwZSA9IChtYXRjaFsyXSB8fCAnbXMnKS50b0xvd2VyQ2FzZSgpXG4gIHN3aXRjaCAodHlwZSkge1xuICAgIGNhc2UgJ3llYXJzJzpcbiAgICBjYXNlICd5ZWFyJzpcbiAgICBjYXNlICd5cnMnOlxuICAgIGNhc2UgJ3lyJzpcbiAgICBjYXNlICd5JzpcbiAgICAgIHJldHVybiBuICogeVxuICAgIGNhc2UgJ2RheXMnOlxuICAgIGNhc2UgJ2RheSc6XG4gICAgY2FzZSAnZCc6XG4gICAgICByZXR1cm4gbiAqIGRcbiAgICBjYXNlICdob3Vycyc6XG4gICAgY2FzZSAnaG91cic6XG4gICAgY2FzZSAnaHJzJzpcbiAgICBjYXNlICdocic6XG4gICAgY2FzZSAnaCc6XG4gICAgICByZXR1cm4gbiAqIGhcbiAgICBjYXNlICdtaW51dGVzJzpcbiAgICBjYXNlICdtaW51dGUnOlxuICAgIGNhc2UgJ21pbnMnOlxuICAgIGNhc2UgJ21pbic6XG4gICAgY2FzZSAnbSc6XG4gICAgICByZXR1cm4gbiAqIG1cbiAgICBjYXNlICdzZWNvbmRzJzpcbiAgICBjYXNlICdzZWNvbmQnOlxuICAgIGNhc2UgJ3NlY3MnOlxuICAgIGNhc2UgJ3NlYyc6XG4gICAgY2FzZSAncyc6XG4gICAgICByZXR1cm4gbiAqIHNcbiAgICBjYXNlICdtaWxsaXNlY29uZHMnOlxuICAgIGNhc2UgJ21pbGxpc2Vjb25kJzpcbiAgICBjYXNlICdtc2Vjcyc6XG4gICAgY2FzZSAnbXNlYyc6XG4gICAgY2FzZSAnbXMnOlxuICAgICAgcmV0dXJuIG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIHVuZGVmaW5lZFxuICB9XG59XG5cbi8qKlxuICogU2hvcnQgZm9ybWF0IGZvciBgbXNgLlxuICpcbiAqIEBwYXJhbSB7TnVtYmVyfSBtc1xuICogQHJldHVybiB7U3RyaW5nfVxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZnVuY3Rpb24gZm10U2hvcnQobXMpIHtcbiAgaWYgKG1zID49IGQpIHtcbiAgICByZXR1cm4gTWF0aC5yb3VuZChtcyAvIGQpICsgJ2QnXG4gIH1cbiAgaWYgKG1zID49IGgpIHtcbiAgICByZXR1cm4gTWF0aC5yb3VuZChtcyAvIGgpICsgJ2gnXG4gIH1cbiAgaWYgKG1zID49IG0pIHtcbiAgICByZXR1cm4gTWF0aC5yb3VuZChtcyAvIG0pICsgJ20nXG4gIH1cbiAgaWYgKG1zID49IHMpIHtcbiAgICByZXR1cm4gTWF0aC5yb3VuZChtcyAvIHMpICsgJ3MnXG4gIH1cbiAgcmV0dXJuIG1zICsgJ21zJ1xufVxuXG4vKipcbiAqIExvbmcgZm9ybWF0IGZvciBgbXNgLlxuICpcbiAqIEBwYXJhbSB7TnVtYmVyfSBtc1xuICogQHJldHVybiB7U3RyaW5nfVxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZnVuY3Rpb24gZm10TG9uZyhtcykge1xuICByZXR1cm4gcGx1cmFsKG1zLCBkLCAnZGF5JykgfHxcbiAgICBwbHVyYWwobXMsIGgsICdob3VyJykgfHxcbiAgICBwbHVyYWwobXMsIG0sICdtaW51dGUnKSB8fFxuICAgIHBsdXJhbChtcywgcywgJ3NlY29uZCcpIHx8XG4gICAgbXMgKyAnIG1zJ1xufVxuXG4vKipcbiAqIFBsdXJhbGl6YXRpb24gaGVscGVyLlxuICovXG5cbmZ1bmN0aW9uIHBsdXJhbChtcywgbiwgbmFtZSkge1xuICBpZiAobXMgPCBuKSB7XG4gICAgcmV0dXJuXG4gIH1cbiAgaWYgKG1zIDwgbiAqIDEuNSkge1xuICAgIHJldHVybiBNYXRoLmZsb29yKG1zIC8gbikgKyAnICcgKyBuYW1lXG4gIH1cbiAgcmV0dXJuIE1hdGguY2VpbChtcyAvIG4pICsgJyAnICsgbmFtZSArICdzJ1xufVxuIiwiLyoqXG4gKiBNb2R1bGUgZGVwZW5kZW5jaWVzLlxuICovXG5cbnZhciBrZXlzID0gcmVxdWlyZSgnLi9rZXlzJyk7XG52YXIgaGFzQmluYXJ5ID0gcmVxdWlyZSgnaGFzLWJpbmFyeScpO1xudmFyIHNsaWNlQnVmZmVyID0gcmVxdWlyZSgnYXJyYXlidWZmZXIuc2xpY2UnKTtcbnZhciBhZnRlciA9IHJlcXVpcmUoJ2FmdGVyJyk7XG52YXIgdXRmOCA9IHJlcXVpcmUoJ3d0Zi04Jyk7XG5cbnZhciBiYXNlNjRlbmNvZGVyO1xuaWYgKGdsb2JhbCAmJiBnbG9iYWwuQXJyYXlCdWZmZXIpIHtcbiAgYmFzZTY0ZW5jb2RlciA9IHJlcXVpcmUoJ2Jhc2U2NC1hcnJheWJ1ZmZlcicpO1xufVxuXG4vKipcbiAqIENoZWNrIGlmIHdlIGFyZSBydW5uaW5nIGFuIGFuZHJvaWQgYnJvd3Nlci4gVGhhdCByZXF1aXJlcyB1cyB0byB1c2VcbiAqIEFycmF5QnVmZmVyIHdpdGggcG9sbGluZyB0cmFuc3BvcnRzLi4uXG4gKlxuICogaHR0cDovL2doaW5kYS5uZXQvanBlZy1ibG9iLWFqYXgtYW5kcm9pZC9cbiAqL1xuXG52YXIgaXNBbmRyb2lkID0gdHlwZW9mIG5hdmlnYXRvciAhPT0gJ3VuZGVmaW5lZCcgJiYgL0FuZHJvaWQvaS50ZXN0KG5hdmlnYXRvci51c2VyQWdlbnQpO1xuXG4vKipcbiAqIENoZWNrIGlmIHdlIGFyZSBydW5uaW5nIGluIFBoYW50b21KUy5cbiAqIFVwbG9hZGluZyBhIEJsb2Igd2l0aCBQaGFudG9tSlMgZG9lcyBub3Qgd29yayBjb3JyZWN0bHksIGFzIHJlcG9ydGVkIGhlcmU6XG4gKiBodHRwczovL2dpdGh1Yi5jb20vYXJpeWEvcGhhbnRvbWpzL2lzc3Vlcy8xMTM5NVxuICogQHR5cGUgYm9vbGVhblxuICovXG52YXIgaXNQaGFudG9tSlMgPSB0eXBlb2YgbmF2aWdhdG9yICE9PSAndW5kZWZpbmVkJyAmJiAvUGhhbnRvbUpTL2kudGVzdChuYXZpZ2F0b3IudXNlckFnZW50KTtcblxuLyoqXG4gKiBXaGVuIHRydWUsIGF2b2lkcyB1c2luZyBCbG9icyB0byBlbmNvZGUgcGF5bG9hZHMuXG4gKiBAdHlwZSBib29sZWFuXG4gKi9cbnZhciBkb250U2VuZEJsb2JzID0gaXNBbmRyb2lkIHx8IGlzUGhhbnRvbUpTO1xuXG4vKipcbiAqIEN1cnJlbnQgcHJvdG9jb2wgdmVyc2lvbi5cbiAqL1xuXG5leHBvcnRzLnByb3RvY29sID0gMztcblxuLyoqXG4gKiBQYWNrZXQgdHlwZXMuXG4gKi9cblxudmFyIHBhY2tldHMgPSBleHBvcnRzLnBhY2tldHMgPSB7XG4gICAgb3BlbjogICAgIDAgICAgLy8gbm9uLXdzXG4gICwgY2xvc2U6ICAgIDEgICAgLy8gbm9uLXdzXG4gICwgcGluZzogICAgIDJcbiAgLCBwb25nOiAgICAgM1xuICAsIG1lc3NhZ2U6ICA0XG4gICwgdXBncmFkZTogIDVcbiAgLCBub29wOiAgICAgNlxufTtcblxudmFyIHBhY2tldHNsaXN0ID0ga2V5cyhwYWNrZXRzKTtcblxuLyoqXG4gKiBQcmVtYWRlIGVycm9yIHBhY2tldC5cbiAqL1xuXG52YXIgZXJyID0geyB0eXBlOiAnZXJyb3InLCBkYXRhOiAncGFyc2VyIGVycm9yJyB9O1xuXG4vKipcbiAqIENyZWF0ZSBhIGJsb2IgYXBpIGV2ZW4gZm9yIGJsb2IgYnVpbGRlciB3aGVuIHZlbmRvciBwcmVmaXhlcyBleGlzdFxuICovXG5cbnZhciBCbG9iID0gcmVxdWlyZSgnYmxvYicpO1xuXG4vKipcbiAqIEVuY29kZXMgYSBwYWNrZXQuXG4gKlxuICogICAgIDxwYWNrZXQgdHlwZSBpZD4gWyA8ZGF0YT4gXVxuICpcbiAqIEV4YW1wbGU6XG4gKlxuICogICAgIDVoZWxsbyB3b3JsZFxuICogICAgIDNcbiAqICAgICA0XG4gKlxuICogQmluYXJ5IGlzIGVuY29kZWQgaW4gYW4gaWRlbnRpY2FsIHByaW5jaXBsZVxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmV4cG9ydHMuZW5jb2RlUGFja2V0ID0gZnVuY3Rpb24gKHBhY2tldCwgc3VwcG9ydHNCaW5hcnksIHV0ZjhlbmNvZGUsIGNhbGxiYWNrKSB7XG4gIGlmICgnZnVuY3Rpb24nID09IHR5cGVvZiBzdXBwb3J0c0JpbmFyeSkge1xuICAgIGNhbGxiYWNrID0gc3VwcG9ydHNCaW5hcnk7XG4gICAgc3VwcG9ydHNCaW5hcnkgPSBmYWxzZTtcbiAgfVxuXG4gIGlmICgnZnVuY3Rpb24nID09IHR5cGVvZiB1dGY4ZW5jb2RlKSB7XG4gICAgY2FsbGJhY2sgPSB1dGY4ZW5jb2RlO1xuICAgIHV0ZjhlbmNvZGUgPSBudWxsO1xuICB9XG5cbiAgdmFyIGRhdGEgPSAocGFja2V0LmRhdGEgPT09IHVuZGVmaW5lZClcbiAgICA/IHVuZGVmaW5lZFxuICAgIDogcGFja2V0LmRhdGEuYnVmZmVyIHx8IHBhY2tldC5kYXRhO1xuXG4gIGlmIChnbG9iYWwuQXJyYXlCdWZmZXIgJiYgZGF0YSBpbnN0YW5jZW9mIEFycmF5QnVmZmVyKSB7XG4gICAgcmV0dXJuIGVuY29kZUFycmF5QnVmZmVyKHBhY2tldCwgc3VwcG9ydHNCaW5hcnksIGNhbGxiYWNrKTtcbiAgfSBlbHNlIGlmIChCbG9iICYmIGRhdGEgaW5zdGFuY2VvZiBnbG9iYWwuQmxvYikge1xuICAgIHJldHVybiBlbmNvZGVCbG9iKHBhY2tldCwgc3VwcG9ydHNCaW5hcnksIGNhbGxiYWNrKTtcbiAgfVxuXG4gIC8vIG1pZ2h0IGJlIGFuIG9iamVjdCB3aXRoIHsgYmFzZTY0OiB0cnVlLCBkYXRhOiBkYXRhQXNCYXNlNjRTdHJpbmcgfVxuICBpZiAoZGF0YSAmJiBkYXRhLmJhc2U2NCkge1xuICAgIHJldHVybiBlbmNvZGVCYXNlNjRPYmplY3QocGFja2V0LCBjYWxsYmFjayk7XG4gIH1cblxuICAvLyBTZW5kaW5nIGRhdGEgYXMgYSB1dGYtOCBzdHJpbmdcbiAgdmFyIGVuY29kZWQgPSBwYWNrZXRzW3BhY2tldC50eXBlXTtcblxuICAvLyBkYXRhIGZyYWdtZW50IGlzIG9wdGlvbmFsXG4gIGlmICh1bmRlZmluZWQgIT09IHBhY2tldC5kYXRhKSB7XG4gICAgZW5jb2RlZCArPSB1dGY4ZW5jb2RlID8gdXRmOC5lbmNvZGUoU3RyaW5nKHBhY2tldC5kYXRhKSkgOiBTdHJpbmcocGFja2V0LmRhdGEpO1xuICB9XG5cbiAgcmV0dXJuIGNhbGxiYWNrKCcnICsgZW5jb2RlZCk7XG5cbn07XG5cbmZ1bmN0aW9uIGVuY29kZUJhc2U2NE9iamVjdChwYWNrZXQsIGNhbGxiYWNrKSB7XG4gIC8vIHBhY2tldCBkYXRhIGlzIGFuIG9iamVjdCB7IGJhc2U2NDogdHJ1ZSwgZGF0YTogZGF0YUFzQmFzZTY0U3RyaW5nIH1cbiAgdmFyIG1lc3NhZ2UgPSAnYicgKyBleHBvcnRzLnBhY2tldHNbcGFja2V0LnR5cGVdICsgcGFja2V0LmRhdGEuZGF0YTtcbiAgcmV0dXJuIGNhbGxiYWNrKG1lc3NhZ2UpO1xufVxuXG4vKipcbiAqIEVuY29kZSBwYWNrZXQgaGVscGVycyBmb3IgYmluYXJ5IHR5cGVzXG4gKi9cblxuZnVuY3Rpb24gZW5jb2RlQXJyYXlCdWZmZXIocGFja2V0LCBzdXBwb3J0c0JpbmFyeSwgY2FsbGJhY2spIHtcbiAgaWYgKCFzdXBwb3J0c0JpbmFyeSkge1xuICAgIHJldHVybiBleHBvcnRzLmVuY29kZUJhc2U2NFBhY2tldChwYWNrZXQsIGNhbGxiYWNrKTtcbiAgfVxuXG4gIHZhciBkYXRhID0gcGFja2V0LmRhdGE7XG4gIHZhciBjb250ZW50QXJyYXkgPSBuZXcgVWludDhBcnJheShkYXRhKTtcbiAgdmFyIHJlc3VsdEJ1ZmZlciA9IG5ldyBVaW50OEFycmF5KDEgKyBkYXRhLmJ5dGVMZW5ndGgpO1xuXG4gIHJlc3VsdEJ1ZmZlclswXSA9IHBhY2tldHNbcGFja2V0LnR5cGVdO1xuICBmb3IgKHZhciBpID0gMDsgaSA8IGNvbnRlbnRBcnJheS5sZW5ndGg7IGkrKykge1xuICAgIHJlc3VsdEJ1ZmZlcltpKzFdID0gY29udGVudEFycmF5W2ldO1xuICB9XG5cbiAgcmV0dXJuIGNhbGxiYWNrKHJlc3VsdEJ1ZmZlci5idWZmZXIpO1xufVxuXG5mdW5jdGlvbiBlbmNvZGVCbG9iQXNBcnJheUJ1ZmZlcihwYWNrZXQsIHN1cHBvcnRzQmluYXJ5LCBjYWxsYmFjaykge1xuICBpZiAoIXN1cHBvcnRzQmluYXJ5KSB7XG4gICAgcmV0dXJuIGV4cG9ydHMuZW5jb2RlQmFzZTY0UGFja2V0KHBhY2tldCwgY2FsbGJhY2spO1xuICB9XG5cbiAgdmFyIGZyID0gbmV3IEZpbGVSZWFkZXIoKTtcbiAgZnIub25sb2FkID0gZnVuY3Rpb24oKSB7XG4gICAgcGFja2V0LmRhdGEgPSBmci5yZXN1bHQ7XG4gICAgZXhwb3J0cy5lbmNvZGVQYWNrZXQocGFja2V0LCBzdXBwb3J0c0JpbmFyeSwgdHJ1ZSwgY2FsbGJhY2spO1xuICB9O1xuICByZXR1cm4gZnIucmVhZEFzQXJyYXlCdWZmZXIocGFja2V0LmRhdGEpO1xufVxuXG5mdW5jdGlvbiBlbmNvZGVCbG9iKHBhY2tldCwgc3VwcG9ydHNCaW5hcnksIGNhbGxiYWNrKSB7XG4gIGlmICghc3VwcG9ydHNCaW5hcnkpIHtcbiAgICByZXR1cm4gZXhwb3J0cy5lbmNvZGVCYXNlNjRQYWNrZXQocGFja2V0LCBjYWxsYmFjayk7XG4gIH1cblxuICBpZiAoZG9udFNlbmRCbG9icykge1xuICAgIHJldHVybiBlbmNvZGVCbG9iQXNBcnJheUJ1ZmZlcihwYWNrZXQsIHN1cHBvcnRzQmluYXJ5LCBjYWxsYmFjayk7XG4gIH1cblxuICB2YXIgbGVuZ3RoID0gbmV3IFVpbnQ4QXJyYXkoMSk7XG4gIGxlbmd0aFswXSA9IHBhY2tldHNbcGFja2V0LnR5cGVdO1xuICB2YXIgYmxvYiA9IG5ldyBCbG9iKFtsZW5ndGguYnVmZmVyLCBwYWNrZXQuZGF0YV0pO1xuXG4gIHJldHVybiBjYWxsYmFjayhibG9iKTtcbn1cblxuLyoqXG4gKiBFbmNvZGVzIGEgcGFja2V0IHdpdGggYmluYXJ5IGRhdGEgaW4gYSBiYXNlNjQgc3RyaW5nXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IHBhY2tldCwgaGFzIGB0eXBlYCBhbmQgYGRhdGFgXG4gKiBAcmV0dXJuIHtTdHJpbmd9IGJhc2U2NCBlbmNvZGVkIG1lc3NhZ2VcbiAqL1xuXG5leHBvcnRzLmVuY29kZUJhc2U2NFBhY2tldCA9IGZ1bmN0aW9uKHBhY2tldCwgY2FsbGJhY2spIHtcbiAgdmFyIG1lc3NhZ2UgPSAnYicgKyBleHBvcnRzLnBhY2tldHNbcGFja2V0LnR5cGVdO1xuICBpZiAoQmxvYiAmJiBwYWNrZXQuZGF0YSBpbnN0YW5jZW9mIGdsb2JhbC5CbG9iKSB7XG4gICAgdmFyIGZyID0gbmV3IEZpbGVSZWFkZXIoKTtcbiAgICBmci5vbmxvYWQgPSBmdW5jdGlvbigpIHtcbiAgICAgIHZhciBiNjQgPSBmci5yZXN1bHQuc3BsaXQoJywnKVsxXTtcbiAgICAgIGNhbGxiYWNrKG1lc3NhZ2UgKyBiNjQpO1xuICAgIH07XG4gICAgcmV0dXJuIGZyLnJlYWRBc0RhdGFVUkwocGFja2V0LmRhdGEpO1xuICB9XG5cbiAgdmFyIGI2NGRhdGE7XG4gIHRyeSB7XG4gICAgYjY0ZGF0YSA9IFN0cmluZy5mcm9tQ2hhckNvZGUuYXBwbHkobnVsbCwgbmV3IFVpbnQ4QXJyYXkocGFja2V0LmRhdGEpKTtcbiAgfSBjYXRjaCAoZSkge1xuICAgIC8vIGlQaG9uZSBTYWZhcmkgZG9lc24ndCBsZXQgeW91IGFwcGx5IHdpdGggdHlwZWQgYXJyYXlzXG4gICAgdmFyIHR5cGVkID0gbmV3IFVpbnQ4QXJyYXkocGFja2V0LmRhdGEpO1xuICAgIHZhciBiYXNpYyA9IG5ldyBBcnJheSh0eXBlZC5sZW5ndGgpO1xuICAgIGZvciAodmFyIGkgPSAwOyBpIDwgdHlwZWQubGVuZ3RoOyBpKyspIHtcbiAgICAgIGJhc2ljW2ldID0gdHlwZWRbaV07XG4gICAgfVxuICAgIGI2NGRhdGEgPSBTdHJpbmcuZnJvbUNoYXJDb2RlLmFwcGx5KG51bGwsIGJhc2ljKTtcbiAgfVxuICBtZXNzYWdlICs9IGdsb2JhbC5idG9hKGI2NGRhdGEpO1xuICByZXR1cm4gY2FsbGJhY2sobWVzc2FnZSk7XG59O1xuXG4vKipcbiAqIERlY29kZXMgYSBwYWNrZXQuIENoYW5nZXMgZm9ybWF0IHRvIEJsb2IgaWYgcmVxdWVzdGVkLlxuICpcbiAqIEByZXR1cm4ge09iamVjdH0gd2l0aCBgdHlwZWAgYW5kIGBkYXRhYCAoaWYgYW55KVxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZXhwb3J0cy5kZWNvZGVQYWNrZXQgPSBmdW5jdGlvbiAoZGF0YSwgYmluYXJ5VHlwZSwgdXRmOGRlY29kZSkge1xuICBpZiAoZGF0YSA9PT0gdW5kZWZpbmVkKSB7XG4gICAgcmV0dXJuIGVycjtcbiAgfVxuICAvLyBTdHJpbmcgZGF0YVxuICBpZiAodHlwZW9mIGRhdGEgPT0gJ3N0cmluZycpIHtcbiAgICBpZiAoZGF0YS5jaGFyQXQoMCkgPT0gJ2InKSB7XG4gICAgICByZXR1cm4gZXhwb3J0cy5kZWNvZGVCYXNlNjRQYWNrZXQoZGF0YS5zdWJzdHIoMSksIGJpbmFyeVR5cGUpO1xuICAgIH1cblxuICAgIGlmICh1dGY4ZGVjb2RlKSB7XG4gICAgICBkYXRhID0gdHJ5RGVjb2RlKGRhdGEpO1xuICAgICAgaWYgKGRhdGEgPT09IGZhbHNlKSB7XG4gICAgICAgIHJldHVybiBlcnI7XG4gICAgICB9XG4gICAgfVxuICAgIHZhciB0eXBlID0gZGF0YS5jaGFyQXQoMCk7XG5cbiAgICBpZiAoTnVtYmVyKHR5cGUpICE9IHR5cGUgfHwgIXBhY2tldHNsaXN0W3R5cGVdKSB7XG4gICAgICByZXR1cm4gZXJyO1xuICAgIH1cblxuICAgIGlmIChkYXRhLmxlbmd0aCA+IDEpIHtcbiAgICAgIHJldHVybiB7IHR5cGU6IHBhY2tldHNsaXN0W3R5cGVdLCBkYXRhOiBkYXRhLnN1YnN0cmluZygxKSB9O1xuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4geyB0eXBlOiBwYWNrZXRzbGlzdFt0eXBlXSB9O1xuICAgIH1cbiAgfVxuXG4gIHZhciBhc0FycmF5ID0gbmV3IFVpbnQ4QXJyYXkoZGF0YSk7XG4gIHZhciB0eXBlID0gYXNBcnJheVswXTtcbiAgdmFyIHJlc3QgPSBzbGljZUJ1ZmZlcihkYXRhLCAxKTtcbiAgaWYgKEJsb2IgJiYgYmluYXJ5VHlwZSA9PT0gJ2Jsb2InKSB7XG4gICAgcmVzdCA9IG5ldyBCbG9iKFtyZXN0XSk7XG4gIH1cbiAgcmV0dXJuIHsgdHlwZTogcGFja2V0c2xpc3RbdHlwZV0sIGRhdGE6IHJlc3QgfTtcbn07XG5cbmZ1bmN0aW9uIHRyeURlY29kZShkYXRhKSB7XG4gIHRyeSB7XG4gICAgZGF0YSA9IHV0ZjguZGVjb2RlKGRhdGEpO1xuICB9IGNhdGNoIChlKSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG4gIHJldHVybiBkYXRhO1xufVxuXG4vKipcbiAqIERlY29kZXMgYSBwYWNrZXQgZW5jb2RlZCBpbiBhIGJhc2U2NCBzdHJpbmdcbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gYmFzZTY0IGVuY29kZWQgbWVzc2FnZVxuICogQHJldHVybiB7T2JqZWN0fSB3aXRoIGB0eXBlYCBhbmQgYGRhdGFgIChpZiBhbnkpXG4gKi9cblxuZXhwb3J0cy5kZWNvZGVCYXNlNjRQYWNrZXQgPSBmdW5jdGlvbihtc2csIGJpbmFyeVR5cGUpIHtcbiAgdmFyIHR5cGUgPSBwYWNrZXRzbGlzdFttc2cuY2hhckF0KDApXTtcbiAgaWYgKCFiYXNlNjRlbmNvZGVyKSB7XG4gICAgcmV0dXJuIHsgdHlwZTogdHlwZSwgZGF0YTogeyBiYXNlNjQ6IHRydWUsIGRhdGE6IG1zZy5zdWJzdHIoMSkgfSB9O1xuICB9XG5cbiAgdmFyIGRhdGEgPSBiYXNlNjRlbmNvZGVyLmRlY29kZShtc2cuc3Vic3RyKDEpKTtcblxuICBpZiAoYmluYXJ5VHlwZSA9PT0gJ2Jsb2InICYmIEJsb2IpIHtcbiAgICBkYXRhID0gbmV3IEJsb2IoW2RhdGFdKTtcbiAgfVxuXG4gIHJldHVybiB7IHR5cGU6IHR5cGUsIGRhdGE6IGRhdGEgfTtcbn07XG5cbi8qKlxuICogRW5jb2RlcyBtdWx0aXBsZSBtZXNzYWdlcyAocGF5bG9hZCkuXG4gKlxuICogICAgIDxsZW5ndGg+OmRhdGFcbiAqXG4gKiBFeGFtcGxlOlxuICpcbiAqICAgICAxMTpoZWxsbyB3b3JsZDI6aGlcbiAqXG4gKiBJZiBhbnkgY29udGVudHMgYXJlIGJpbmFyeSwgdGhleSB3aWxsIGJlIGVuY29kZWQgYXMgYmFzZTY0IHN0cmluZ3MuIEJhc2U2NFxuICogZW5jb2RlZCBzdHJpbmdzIGFyZSBtYXJrZWQgd2l0aCBhIGIgYmVmb3JlIHRoZSBsZW5ndGggc3BlY2lmaWVyXG4gKlxuICogQHBhcmFtIHtBcnJheX0gcGFja2V0c1xuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZXhwb3J0cy5lbmNvZGVQYXlsb2FkID0gZnVuY3Rpb24gKHBhY2tldHMsIHN1cHBvcnRzQmluYXJ5LCBjYWxsYmFjaykge1xuICBpZiAodHlwZW9mIHN1cHBvcnRzQmluYXJ5ID09ICdmdW5jdGlvbicpIHtcbiAgICBjYWxsYmFjayA9IHN1cHBvcnRzQmluYXJ5O1xuICAgIHN1cHBvcnRzQmluYXJ5ID0gbnVsbDtcbiAgfVxuXG4gIHZhciBpc0JpbmFyeSA9IGhhc0JpbmFyeShwYWNrZXRzKTtcblxuICBpZiAoc3VwcG9ydHNCaW5hcnkgJiYgaXNCaW5hcnkpIHtcbiAgICBpZiAoQmxvYiAmJiAhZG9udFNlbmRCbG9icykge1xuICAgICAgcmV0dXJuIGV4cG9ydHMuZW5jb2RlUGF5bG9hZEFzQmxvYihwYWNrZXRzLCBjYWxsYmFjayk7XG4gICAgfVxuXG4gICAgcmV0dXJuIGV4cG9ydHMuZW5jb2RlUGF5bG9hZEFzQXJyYXlCdWZmZXIocGFja2V0cywgY2FsbGJhY2spO1xuICB9XG5cbiAgaWYgKCFwYWNrZXRzLmxlbmd0aCkge1xuICAgIHJldHVybiBjYWxsYmFjaygnMDonKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIHNldExlbmd0aEhlYWRlcihtZXNzYWdlKSB7XG4gICAgcmV0dXJuIG1lc3NhZ2UubGVuZ3RoICsgJzonICsgbWVzc2FnZTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGVuY29kZU9uZShwYWNrZXQsIGRvbmVDYWxsYmFjaykge1xuICAgIGV4cG9ydHMuZW5jb2RlUGFja2V0KHBhY2tldCwgIWlzQmluYXJ5ID8gZmFsc2UgOiBzdXBwb3J0c0JpbmFyeSwgdHJ1ZSwgZnVuY3Rpb24obWVzc2FnZSkge1xuICAgICAgZG9uZUNhbGxiYWNrKG51bGwsIHNldExlbmd0aEhlYWRlcihtZXNzYWdlKSk7XG4gICAgfSk7XG4gIH1cblxuICBtYXAocGFja2V0cywgZW5jb2RlT25lLCBmdW5jdGlvbihlcnIsIHJlc3VsdHMpIHtcbiAgICByZXR1cm4gY2FsbGJhY2socmVzdWx0cy5qb2luKCcnKSk7XG4gIH0pO1xufTtcblxuLyoqXG4gKiBBc3luYyBhcnJheSBtYXAgdXNpbmcgYWZ0ZXJcbiAqL1xuXG5mdW5jdGlvbiBtYXAoYXJ5LCBlYWNoLCBkb25lKSB7XG4gIHZhciByZXN1bHQgPSBuZXcgQXJyYXkoYXJ5Lmxlbmd0aCk7XG4gIHZhciBuZXh0ID0gYWZ0ZXIoYXJ5Lmxlbmd0aCwgZG9uZSk7XG5cbiAgdmFyIGVhY2hXaXRoSW5kZXggPSBmdW5jdGlvbihpLCBlbCwgY2IpIHtcbiAgICBlYWNoKGVsLCBmdW5jdGlvbihlcnJvciwgbXNnKSB7XG4gICAgICByZXN1bHRbaV0gPSBtc2c7XG4gICAgICBjYihlcnJvciwgcmVzdWx0KTtcbiAgICB9KTtcbiAgfTtcblxuICBmb3IgKHZhciBpID0gMDsgaSA8IGFyeS5sZW5ndGg7IGkrKykge1xuICAgIGVhY2hXaXRoSW5kZXgoaSwgYXJ5W2ldLCBuZXh0KTtcbiAgfVxufVxuXG4vKlxuICogRGVjb2RlcyBkYXRhIHdoZW4gYSBwYXlsb2FkIGlzIG1heWJlIGV4cGVjdGVkLiBQb3NzaWJsZSBiaW5hcnkgY29udGVudHMgYXJlXG4gKiBkZWNvZGVkIGZyb20gdGhlaXIgYmFzZTY0IHJlcHJlc2VudGF0aW9uXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IGRhdGEsIGNhbGxiYWNrIG1ldGhvZFxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5leHBvcnRzLmRlY29kZVBheWxvYWQgPSBmdW5jdGlvbiAoZGF0YSwgYmluYXJ5VHlwZSwgY2FsbGJhY2spIHtcbiAgaWYgKHR5cGVvZiBkYXRhICE9ICdzdHJpbmcnKSB7XG4gICAgcmV0dXJuIGV4cG9ydHMuZGVjb2RlUGF5bG9hZEFzQmluYXJ5KGRhdGEsIGJpbmFyeVR5cGUsIGNhbGxiYWNrKTtcbiAgfVxuXG4gIGlmICh0eXBlb2YgYmluYXJ5VHlwZSA9PT0gJ2Z1bmN0aW9uJykge1xuICAgIGNhbGxiYWNrID0gYmluYXJ5VHlwZTtcbiAgICBiaW5hcnlUeXBlID0gbnVsbDtcbiAgfVxuXG4gIHZhciBwYWNrZXQ7XG4gIGlmIChkYXRhID09ICcnKSB7XG4gICAgLy8gcGFyc2VyIGVycm9yIC0gaWdub3JpbmcgcGF5bG9hZFxuICAgIHJldHVybiBjYWxsYmFjayhlcnIsIDAsIDEpO1xuICB9XG5cbiAgdmFyIGxlbmd0aCA9ICcnXG4gICAgLCBuLCBtc2c7XG5cbiAgZm9yICh2YXIgaSA9IDAsIGwgPSBkYXRhLmxlbmd0aDsgaSA8IGw7IGkrKykge1xuICAgIHZhciBjaHIgPSBkYXRhLmNoYXJBdChpKTtcblxuICAgIGlmICgnOicgIT0gY2hyKSB7XG4gICAgICBsZW5ndGggKz0gY2hyO1xuICAgIH0gZWxzZSB7XG4gICAgICBpZiAoJycgPT0gbGVuZ3RoIHx8IChsZW5ndGggIT0gKG4gPSBOdW1iZXIobGVuZ3RoKSkpKSB7XG4gICAgICAgIC8vIHBhcnNlciBlcnJvciAtIGlnbm9yaW5nIHBheWxvYWRcbiAgICAgICAgcmV0dXJuIGNhbGxiYWNrKGVyciwgMCwgMSk7XG4gICAgICB9XG5cbiAgICAgIG1zZyA9IGRhdGEuc3Vic3RyKGkgKyAxLCBuKTtcblxuICAgICAgaWYgKGxlbmd0aCAhPSBtc2cubGVuZ3RoKSB7XG4gICAgICAgIC8vIHBhcnNlciBlcnJvciAtIGlnbm9yaW5nIHBheWxvYWRcbiAgICAgICAgcmV0dXJuIGNhbGxiYWNrKGVyciwgMCwgMSk7XG4gICAgICB9XG5cbiAgICAgIGlmIChtc2cubGVuZ3RoKSB7XG4gICAgICAgIHBhY2tldCA9IGV4cG9ydHMuZGVjb2RlUGFja2V0KG1zZywgYmluYXJ5VHlwZSwgdHJ1ZSk7XG5cbiAgICAgICAgaWYgKGVyci50eXBlID09IHBhY2tldC50eXBlICYmIGVyci5kYXRhID09IHBhY2tldC5kYXRhKSB7XG4gICAgICAgICAgLy8gcGFyc2VyIGVycm9yIGluIGluZGl2aWR1YWwgcGFja2V0IC0gaWdub3JpbmcgcGF5bG9hZFxuICAgICAgICAgIHJldHVybiBjYWxsYmFjayhlcnIsIDAsIDEpO1xuICAgICAgICB9XG5cbiAgICAgICAgdmFyIHJldCA9IGNhbGxiYWNrKHBhY2tldCwgaSArIG4sIGwpO1xuICAgICAgICBpZiAoZmFsc2UgPT09IHJldCkgcmV0dXJuO1xuICAgICAgfVxuXG4gICAgICAvLyBhZHZhbmNlIGN1cnNvclxuICAgICAgaSArPSBuO1xuICAgICAgbGVuZ3RoID0gJyc7XG4gICAgfVxuICB9XG5cbiAgaWYgKGxlbmd0aCAhPSAnJykge1xuICAgIC8vIHBhcnNlciBlcnJvciAtIGlnbm9yaW5nIHBheWxvYWRcbiAgICByZXR1cm4gY2FsbGJhY2soZXJyLCAwLCAxKTtcbiAgfVxuXG59O1xuXG4vKipcbiAqIEVuY29kZXMgbXVsdGlwbGUgbWVzc2FnZXMgKHBheWxvYWQpIGFzIGJpbmFyeS5cbiAqXG4gKiA8MSA9IGJpbmFyeSwgMCA9IHN0cmluZz48bnVtYmVyIGZyb20gMC05PjxudW1iZXIgZnJvbSAwLTk+Wy4uLl08bnVtYmVyXG4gKiAyNTU+PGRhdGE+XG4gKlxuICogRXhhbXBsZTpcbiAqIDEgMyAyNTUgMSAyIDMsIGlmIHRoZSBiaW5hcnkgY29udGVudHMgYXJlIGludGVycHJldGVkIGFzIDggYml0IGludGVnZXJzXG4gKlxuICogQHBhcmFtIHtBcnJheX0gcGFja2V0c1xuICogQHJldHVybiB7QXJyYXlCdWZmZXJ9IGVuY29kZWQgcGF5bG9hZFxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZXhwb3J0cy5lbmNvZGVQYXlsb2FkQXNBcnJheUJ1ZmZlciA9IGZ1bmN0aW9uKHBhY2tldHMsIGNhbGxiYWNrKSB7XG4gIGlmICghcGFja2V0cy5sZW5ndGgpIHtcbiAgICByZXR1cm4gY2FsbGJhY2sobmV3IEFycmF5QnVmZmVyKDApKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGVuY29kZU9uZShwYWNrZXQsIGRvbmVDYWxsYmFjaykge1xuICAgIGV4cG9ydHMuZW5jb2RlUGFja2V0KHBhY2tldCwgdHJ1ZSwgdHJ1ZSwgZnVuY3Rpb24oZGF0YSkge1xuICAgICAgcmV0dXJuIGRvbmVDYWxsYmFjayhudWxsLCBkYXRhKTtcbiAgICB9KTtcbiAgfVxuXG4gIG1hcChwYWNrZXRzLCBlbmNvZGVPbmUsIGZ1bmN0aW9uKGVyciwgZW5jb2RlZFBhY2tldHMpIHtcbiAgICB2YXIgdG90YWxMZW5ndGggPSBlbmNvZGVkUGFja2V0cy5yZWR1Y2UoZnVuY3Rpb24oYWNjLCBwKSB7XG4gICAgICB2YXIgbGVuO1xuICAgICAgaWYgKHR5cGVvZiBwID09PSAnc3RyaW5nJyl7XG4gICAgICAgIGxlbiA9IHAubGVuZ3RoO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgbGVuID0gcC5ieXRlTGVuZ3RoO1xuICAgICAgfVxuICAgICAgcmV0dXJuIGFjYyArIGxlbi50b1N0cmluZygpLmxlbmd0aCArIGxlbiArIDI7IC8vIHN0cmluZy9iaW5hcnkgaWRlbnRpZmllciArIHNlcGFyYXRvciA9IDJcbiAgICB9LCAwKTtcblxuICAgIHZhciByZXN1bHRBcnJheSA9IG5ldyBVaW50OEFycmF5KHRvdGFsTGVuZ3RoKTtcblxuICAgIHZhciBidWZmZXJJbmRleCA9IDA7XG4gICAgZW5jb2RlZFBhY2tldHMuZm9yRWFjaChmdW5jdGlvbihwKSB7XG4gICAgICB2YXIgaXNTdHJpbmcgPSB0eXBlb2YgcCA9PT0gJ3N0cmluZyc7XG4gICAgICB2YXIgYWIgPSBwO1xuICAgICAgaWYgKGlzU3RyaW5nKSB7XG4gICAgICAgIHZhciB2aWV3ID0gbmV3IFVpbnQ4QXJyYXkocC5sZW5ndGgpO1xuICAgICAgICBmb3IgKHZhciBpID0gMDsgaSA8IHAubGVuZ3RoOyBpKyspIHtcbiAgICAgICAgICB2aWV3W2ldID0gcC5jaGFyQ29kZUF0KGkpO1xuICAgICAgICB9XG4gICAgICAgIGFiID0gdmlldy5idWZmZXI7XG4gICAgICB9XG5cbiAgICAgIGlmIChpc1N0cmluZykgeyAvLyBub3QgdHJ1ZSBiaW5hcnlcbiAgICAgICAgcmVzdWx0QXJyYXlbYnVmZmVySW5kZXgrK10gPSAwO1xuICAgICAgfSBlbHNlIHsgLy8gdHJ1ZSBiaW5hcnlcbiAgICAgICAgcmVzdWx0QXJyYXlbYnVmZmVySW5kZXgrK10gPSAxO1xuICAgICAgfVxuXG4gICAgICB2YXIgbGVuU3RyID0gYWIuYnl0ZUxlbmd0aC50b1N0cmluZygpO1xuICAgICAgZm9yICh2YXIgaSA9IDA7IGkgPCBsZW5TdHIubGVuZ3RoOyBpKyspIHtcbiAgICAgICAgcmVzdWx0QXJyYXlbYnVmZmVySW5kZXgrK10gPSBwYXJzZUludChsZW5TdHJbaV0pO1xuICAgICAgfVxuICAgICAgcmVzdWx0QXJyYXlbYnVmZmVySW5kZXgrK10gPSAyNTU7XG5cbiAgICAgIHZhciB2aWV3ID0gbmV3IFVpbnQ4QXJyYXkoYWIpO1xuICAgICAgZm9yICh2YXIgaSA9IDA7IGkgPCB2aWV3Lmxlbmd0aDsgaSsrKSB7XG4gICAgICAgIHJlc3VsdEFycmF5W2J1ZmZlckluZGV4KytdID0gdmlld1tpXTtcbiAgICAgIH1cbiAgICB9KTtcblxuICAgIHJldHVybiBjYWxsYmFjayhyZXN1bHRBcnJheS5idWZmZXIpO1xuICB9KTtcbn07XG5cbi8qKlxuICogRW5jb2RlIGFzIEJsb2JcbiAqL1xuXG5leHBvcnRzLmVuY29kZVBheWxvYWRBc0Jsb2IgPSBmdW5jdGlvbihwYWNrZXRzLCBjYWxsYmFjaykge1xuICBmdW5jdGlvbiBlbmNvZGVPbmUocGFja2V0LCBkb25lQ2FsbGJhY2spIHtcbiAgICBleHBvcnRzLmVuY29kZVBhY2tldChwYWNrZXQsIHRydWUsIHRydWUsIGZ1bmN0aW9uKGVuY29kZWQpIHtcbiAgICAgIHZhciBiaW5hcnlJZGVudGlmaWVyID0gbmV3IFVpbnQ4QXJyYXkoMSk7XG4gICAgICBiaW5hcnlJZGVudGlmaWVyWzBdID0gMTtcbiAgICAgIGlmICh0eXBlb2YgZW5jb2RlZCA9PT0gJ3N0cmluZycpIHtcbiAgICAgICAgdmFyIHZpZXcgPSBuZXcgVWludDhBcnJheShlbmNvZGVkLmxlbmd0aCk7XG4gICAgICAgIGZvciAodmFyIGkgPSAwOyBpIDwgZW5jb2RlZC5sZW5ndGg7IGkrKykge1xuICAgICAgICAgIHZpZXdbaV0gPSBlbmNvZGVkLmNoYXJDb2RlQXQoaSk7XG4gICAgICAgIH1cbiAgICAgICAgZW5jb2RlZCA9IHZpZXcuYnVmZmVyO1xuICAgICAgICBiaW5hcnlJZGVudGlmaWVyWzBdID0gMDtcbiAgICAgIH1cblxuICAgICAgdmFyIGxlbiA9IChlbmNvZGVkIGluc3RhbmNlb2YgQXJyYXlCdWZmZXIpXG4gICAgICAgID8gZW5jb2RlZC5ieXRlTGVuZ3RoXG4gICAgICAgIDogZW5jb2RlZC5zaXplO1xuXG4gICAgICB2YXIgbGVuU3RyID0gbGVuLnRvU3RyaW5nKCk7XG4gICAgICB2YXIgbGVuZ3RoQXJ5ID0gbmV3IFVpbnQ4QXJyYXkobGVuU3RyLmxlbmd0aCArIDEpO1xuICAgICAgZm9yICh2YXIgaSA9IDA7IGkgPCBsZW5TdHIubGVuZ3RoOyBpKyspIHtcbiAgICAgICAgbGVuZ3RoQXJ5W2ldID0gcGFyc2VJbnQobGVuU3RyW2ldKTtcbiAgICAgIH1cbiAgICAgIGxlbmd0aEFyeVtsZW5TdHIubGVuZ3RoXSA9IDI1NTtcblxuICAgICAgaWYgKEJsb2IpIHtcbiAgICAgICAgdmFyIGJsb2IgPSBuZXcgQmxvYihbYmluYXJ5SWRlbnRpZmllci5idWZmZXIsIGxlbmd0aEFyeS5idWZmZXIsIGVuY29kZWRdKTtcbiAgICAgICAgZG9uZUNhbGxiYWNrKG51bGwsIGJsb2IpO1xuICAgICAgfVxuICAgIH0pO1xuICB9XG5cbiAgbWFwKHBhY2tldHMsIGVuY29kZU9uZSwgZnVuY3Rpb24oZXJyLCByZXN1bHRzKSB7XG4gICAgcmV0dXJuIGNhbGxiYWNrKG5ldyBCbG9iKHJlc3VsdHMpKTtcbiAgfSk7XG59O1xuXG4vKlxuICogRGVjb2RlcyBkYXRhIHdoZW4gYSBwYXlsb2FkIGlzIG1heWJlIGV4cGVjdGVkLiBTdHJpbmdzIGFyZSBkZWNvZGVkIGJ5XG4gKiBpbnRlcnByZXRpbmcgZWFjaCBieXRlIGFzIGEga2V5IGNvZGUgZm9yIGVudHJpZXMgbWFya2VkIHRvIHN0YXJ0IHdpdGggMC4gU2VlXG4gKiBkZXNjcmlwdGlvbiBvZiBlbmNvZGVQYXlsb2FkQXNCaW5hcnlcbiAqXG4gKiBAcGFyYW0ge0FycmF5QnVmZmVyfSBkYXRhLCBjYWxsYmFjayBtZXRob2RcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5kZWNvZGVQYXlsb2FkQXNCaW5hcnkgPSBmdW5jdGlvbiAoZGF0YSwgYmluYXJ5VHlwZSwgY2FsbGJhY2spIHtcbiAgaWYgKHR5cGVvZiBiaW5hcnlUeXBlID09PSAnZnVuY3Rpb24nKSB7XG4gICAgY2FsbGJhY2sgPSBiaW5hcnlUeXBlO1xuICAgIGJpbmFyeVR5cGUgPSBudWxsO1xuICB9XG5cbiAgdmFyIGJ1ZmZlclRhaWwgPSBkYXRhO1xuICB2YXIgYnVmZmVycyA9IFtdO1xuXG4gIHZhciBudW1iZXJUb29Mb25nID0gZmFsc2U7XG4gIHdoaWxlIChidWZmZXJUYWlsLmJ5dGVMZW5ndGggPiAwKSB7XG4gICAgdmFyIHRhaWxBcnJheSA9IG5ldyBVaW50OEFycmF5KGJ1ZmZlclRhaWwpO1xuICAgIHZhciBpc1N0cmluZyA9IHRhaWxBcnJheVswXSA9PT0gMDtcbiAgICB2YXIgbXNnTGVuZ3RoID0gJyc7XG5cbiAgICBmb3IgKHZhciBpID0gMTsgOyBpKyspIHtcbiAgICAgIGlmICh0YWlsQXJyYXlbaV0gPT0gMjU1KSBicmVhaztcblxuICAgICAgaWYgKG1zZ0xlbmd0aC5sZW5ndGggPiAzMTApIHtcbiAgICAgICAgbnVtYmVyVG9vTG9uZyA9IHRydWU7XG4gICAgICAgIGJyZWFrO1xuICAgICAgfVxuXG4gICAgICBtc2dMZW5ndGggKz0gdGFpbEFycmF5W2ldO1xuICAgIH1cblxuICAgIGlmKG51bWJlclRvb0xvbmcpIHJldHVybiBjYWxsYmFjayhlcnIsIDAsIDEpO1xuXG4gICAgYnVmZmVyVGFpbCA9IHNsaWNlQnVmZmVyKGJ1ZmZlclRhaWwsIDIgKyBtc2dMZW5ndGgubGVuZ3RoKTtcbiAgICBtc2dMZW5ndGggPSBwYXJzZUludChtc2dMZW5ndGgpO1xuXG4gICAgdmFyIG1zZyA9IHNsaWNlQnVmZmVyKGJ1ZmZlclRhaWwsIDAsIG1zZ0xlbmd0aCk7XG4gICAgaWYgKGlzU3RyaW5nKSB7XG4gICAgICB0cnkge1xuICAgICAgICBtc2cgPSBTdHJpbmcuZnJvbUNoYXJDb2RlLmFwcGx5KG51bGwsIG5ldyBVaW50OEFycmF5KG1zZykpO1xuICAgICAgfSBjYXRjaCAoZSkge1xuICAgICAgICAvLyBpUGhvbmUgU2FmYXJpIGRvZXNuJ3QgbGV0IHlvdSBhcHBseSB0byB0eXBlZCBhcnJheXNcbiAgICAgICAgdmFyIHR5cGVkID0gbmV3IFVpbnQ4QXJyYXkobXNnKTtcbiAgICAgICAgbXNnID0gJyc7XG4gICAgICAgIGZvciAodmFyIGkgPSAwOyBpIDwgdHlwZWQubGVuZ3RoOyBpKyspIHtcbiAgICAgICAgICBtc2cgKz0gU3RyaW5nLmZyb21DaGFyQ29kZSh0eXBlZFtpXSk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICBidWZmZXJzLnB1c2gobXNnKTtcbiAgICBidWZmZXJUYWlsID0gc2xpY2VCdWZmZXIoYnVmZmVyVGFpbCwgbXNnTGVuZ3RoKTtcbiAgfVxuXG4gIHZhciB0b3RhbCA9IGJ1ZmZlcnMubGVuZ3RoO1xuICBidWZmZXJzLmZvckVhY2goZnVuY3Rpb24oYnVmZmVyLCBpKSB7XG4gICAgY2FsbGJhY2soZXhwb3J0cy5kZWNvZGVQYWNrZXQoYnVmZmVyLCBiaW5hcnlUeXBlLCB0cnVlKSwgaSwgdG90YWwpO1xuICB9KTtcbn07XG4iLCJcbi8qKlxuICogR2V0cyB0aGUga2V5cyBmb3IgYW4gb2JqZWN0LlxuICpcbiAqIEByZXR1cm4ge0FycmF5fSBrZXlzXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IE9iamVjdC5rZXlzIHx8IGZ1bmN0aW9uIGtleXMgKG9iail7XG4gIHZhciBhcnIgPSBbXTtcbiAgdmFyIGhhcyA9IE9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHk7XG5cbiAgZm9yICh2YXIgaSBpbiBvYmopIHtcbiAgICBpZiAoaGFzLmNhbGwob2JqLCBpKSkge1xuICAgICAgYXJyLnB1c2goaSk7XG4gICAgfVxuICB9XG4gIHJldHVybiBhcnI7XG59O1xuIiwiLy8gQ29weXJpZ2h0IEpveWVudCwgSW5jLiBhbmQgb3RoZXIgTm9kZSBjb250cmlidXRvcnMuXG4vL1xuLy8gUGVybWlzc2lvbiBpcyBoZXJlYnkgZ3JhbnRlZCwgZnJlZSBvZiBjaGFyZ2UsIHRvIGFueSBwZXJzb24gb2J0YWluaW5nIGFcbi8vIGNvcHkgb2YgdGhpcyBzb2Z0d2FyZSBhbmQgYXNzb2NpYXRlZCBkb2N1bWVudGF0aW9uIGZpbGVzICh0aGVcbi8vIFwiU29mdHdhcmVcIiksIHRvIGRlYWwgaW4gdGhlIFNvZnR3YXJlIHdpdGhvdXQgcmVzdHJpY3Rpb24sIGluY2x1ZGluZ1xuLy8gd2l0aG91dCBsaW1pdGF0aW9uIHRoZSByaWdodHMgdG8gdXNlLCBjb3B5LCBtb2RpZnksIG1lcmdlLCBwdWJsaXNoLFxuLy8gZGlzdHJpYnV0ZSwgc3VibGljZW5zZSwgYW5kL29yIHNlbGwgY29waWVzIG9mIHRoZSBTb2Z0d2FyZSwgYW5kIHRvIHBlcm1pdFxuLy8gcGVyc29ucyB0byB3aG9tIHRoZSBTb2Z0d2FyZSBpcyBmdXJuaXNoZWQgdG8gZG8gc28sIHN1YmplY3QgdG8gdGhlXG4vLyBmb2xsb3dpbmcgY29uZGl0aW9uczpcbi8vXG4vLyBUaGUgYWJvdmUgY29weXJpZ2h0IG5vdGljZSBhbmQgdGhpcyBwZXJtaXNzaW9uIG5vdGljZSBzaGFsbCBiZSBpbmNsdWRlZFxuLy8gaW4gYWxsIGNvcGllcyBvciBzdWJzdGFudGlhbCBwb3J0aW9ucyBvZiB0aGUgU29mdHdhcmUuXG4vL1xuLy8gVEhFIFNPRlRXQVJFIElTIFBST1ZJREVEIFwiQVMgSVNcIiwgV0lUSE9VVCBXQVJSQU5UWSBPRiBBTlkgS0lORCwgRVhQUkVTU1xuLy8gT1IgSU1QTElFRCwgSU5DTFVESU5HIEJVVCBOT1QgTElNSVRFRCBUTyBUSEUgV0FSUkFOVElFUyBPRlxuLy8gTUVSQ0hBTlRBQklMSVRZLCBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBBTkQgTk9OSU5GUklOR0VNRU5ULiBJTlxuLy8gTk8gRVZFTlQgU0hBTEwgVEhFIEFVVEhPUlMgT1IgQ09QWVJJR0hUIEhPTERFUlMgQkUgTElBQkxFIEZPUiBBTlkgQ0xBSU0sXG4vLyBEQU1BR0VTIE9SIE9USEVSIExJQUJJTElUWSwgV0hFVEhFUiBJTiBBTiBBQ1RJT04gT0YgQ09OVFJBQ1QsIFRPUlQgT1Jcbi8vIE9USEVSV0lTRSwgQVJJU0lORyBGUk9NLCBPVVQgT0YgT1IgSU4gQ09OTkVDVElPTiBXSVRIIFRIRSBTT0ZUV0FSRSBPUiBUSEVcbi8vIFVTRSBPUiBPVEhFUiBERUFMSU5HUyBJTiBUSEUgU09GVFdBUkUuXG5cbmZ1bmN0aW9uIEV2ZW50RW1pdHRlcigpIHtcbiAgdGhpcy5fZXZlbnRzID0gdGhpcy5fZXZlbnRzIHx8IHt9O1xuICB0aGlzLl9tYXhMaXN0ZW5lcnMgPSB0aGlzLl9tYXhMaXN0ZW5lcnMgfHwgdW5kZWZpbmVkO1xufVxubW9kdWxlLmV4cG9ydHMgPSBFdmVudEVtaXR0ZXI7XG5cbi8vIEJhY2t3YXJkcy1jb21wYXQgd2l0aCBub2RlIDAuMTAueFxuRXZlbnRFbWl0dGVyLkV2ZW50RW1pdHRlciA9IEV2ZW50RW1pdHRlcjtcblxuRXZlbnRFbWl0dGVyLnByb3RvdHlwZS5fZXZlbnRzID0gdW5kZWZpbmVkO1xuRXZlbnRFbWl0dGVyLnByb3RvdHlwZS5fbWF4TGlzdGVuZXJzID0gdW5kZWZpbmVkO1xuXG4vLyBCeSBkZWZhdWx0IEV2ZW50RW1pdHRlcnMgd2lsbCBwcmludCBhIHdhcm5pbmcgaWYgbW9yZSB0aGFuIDEwIGxpc3RlbmVycyBhcmVcbi8vIGFkZGVkIHRvIGl0LiBUaGlzIGlzIGEgdXNlZnVsIGRlZmF1bHQgd2hpY2ggaGVscHMgZmluZGluZyBtZW1vcnkgbGVha3MuXG5FdmVudEVtaXR0ZXIuZGVmYXVsdE1heExpc3RlbmVycyA9IDEwO1xuXG4vLyBPYnZpb3VzbHkgbm90IGFsbCBFbWl0dGVycyBzaG91bGQgYmUgbGltaXRlZCB0byAxMC4gVGhpcyBmdW5jdGlvbiBhbGxvd3Ncbi8vIHRoYXQgdG8gYmUgaW5jcmVhc2VkLiBTZXQgdG8gemVybyBmb3IgdW5saW1pdGVkLlxuRXZlbnRFbWl0dGVyLnByb3RvdHlwZS5zZXRNYXhMaXN0ZW5lcnMgPSBmdW5jdGlvbihuKSB7XG4gIGlmICghaXNOdW1iZXIobikgfHwgbiA8IDAgfHwgaXNOYU4obikpXG4gICAgdGhyb3cgVHlwZUVycm9yKCduIG11c3QgYmUgYSBwb3NpdGl2ZSBudW1iZXInKTtcbiAgdGhpcy5fbWF4TGlzdGVuZXJzID0gbjtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG5FdmVudEVtaXR0ZXIucHJvdG90eXBlLmVtaXQgPSBmdW5jdGlvbih0eXBlKSB7XG4gIHZhciBlciwgaGFuZGxlciwgbGVuLCBhcmdzLCBpLCBsaXN0ZW5lcnM7XG5cbiAgaWYgKCF0aGlzLl9ldmVudHMpXG4gICAgdGhpcy5fZXZlbnRzID0ge307XG5cbiAgLy8gSWYgdGhlcmUgaXMgbm8gJ2Vycm9yJyBldmVudCBsaXN0ZW5lciB0aGVuIHRocm93LlxuICBpZiAodHlwZSA9PT0gJ2Vycm9yJykge1xuICAgIGlmICghdGhpcy5fZXZlbnRzLmVycm9yIHx8XG4gICAgICAgIChpc09iamVjdCh0aGlzLl9ldmVudHMuZXJyb3IpICYmICF0aGlzLl9ldmVudHMuZXJyb3IubGVuZ3RoKSkge1xuICAgICAgZXIgPSBhcmd1bWVudHNbMV07XG4gICAgICBpZiAoZXIgaW5zdGFuY2VvZiBFcnJvcikge1xuICAgICAgICB0aHJvdyBlcjsgLy8gVW5oYW5kbGVkICdlcnJvcicgZXZlbnRcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIC8vIEF0IGxlYXN0IGdpdmUgc29tZSBraW5kIG9mIGNvbnRleHQgdG8gdGhlIHVzZXJcbiAgICAgICAgdmFyIGVyciA9IG5ldyBFcnJvcignVW5jYXVnaHQsIHVuc3BlY2lmaWVkIFwiZXJyb3JcIiBldmVudC4gKCcgKyBlciArICcpJyk7XG4gICAgICAgIGVyci5jb250ZXh0ID0gZXI7XG4gICAgICAgIHRocm93IGVycjtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICBoYW5kbGVyID0gdGhpcy5fZXZlbnRzW3R5cGVdO1xuXG4gIGlmIChpc1VuZGVmaW5lZChoYW5kbGVyKSlcbiAgICByZXR1cm4gZmFsc2U7XG5cbiAgaWYgKGlzRnVuY3Rpb24oaGFuZGxlcikpIHtcbiAgICBzd2l0Y2ggKGFyZ3VtZW50cy5sZW5ndGgpIHtcbiAgICAgIC8vIGZhc3QgY2FzZXNcbiAgICAgIGNhc2UgMTpcbiAgICAgICAgaGFuZGxlci5jYWxsKHRoaXMpO1xuICAgICAgICBicmVhaztcbiAgICAgIGNhc2UgMjpcbiAgICAgICAgaGFuZGxlci5jYWxsKHRoaXMsIGFyZ3VtZW50c1sxXSk7XG4gICAgICAgIGJyZWFrO1xuICAgICAgY2FzZSAzOlxuICAgICAgICBoYW5kbGVyLmNhbGwodGhpcywgYXJndW1lbnRzWzFdLCBhcmd1bWVudHNbMl0pO1xuICAgICAgICBicmVhaztcbiAgICAgIC8vIHNsb3dlclxuICAgICAgZGVmYXVsdDpcbiAgICAgICAgYXJncyA9IEFycmF5LnByb3RvdHlwZS5zbGljZS5jYWxsKGFyZ3VtZW50cywgMSk7XG4gICAgICAgIGhhbmRsZXIuYXBwbHkodGhpcywgYXJncyk7XG4gICAgfVxuICB9IGVsc2UgaWYgKGlzT2JqZWN0KGhhbmRsZXIpKSB7XG4gICAgYXJncyA9IEFycmF5LnByb3RvdHlwZS5zbGljZS5jYWxsKGFyZ3VtZW50cywgMSk7XG4gICAgbGlzdGVuZXJzID0gaGFuZGxlci5zbGljZSgpO1xuICAgIGxlbiA9IGxpc3RlbmVycy5sZW5ndGg7XG4gICAgZm9yIChpID0gMDsgaSA8IGxlbjsgaSsrKVxuICAgICAgbGlzdGVuZXJzW2ldLmFwcGx5KHRoaXMsIGFyZ3MpO1xuICB9XG5cbiAgcmV0dXJuIHRydWU7XG59O1xuXG5FdmVudEVtaXR0ZXIucHJvdG90eXBlLmFkZExpc3RlbmVyID0gZnVuY3Rpb24odHlwZSwgbGlzdGVuZXIpIHtcbiAgdmFyIG07XG5cbiAgaWYgKCFpc0Z1bmN0aW9uKGxpc3RlbmVyKSlcbiAgICB0aHJvdyBUeXBlRXJyb3IoJ2xpc3RlbmVyIG11c3QgYmUgYSBmdW5jdGlvbicpO1xuXG4gIGlmICghdGhpcy5fZXZlbnRzKVxuICAgIHRoaXMuX2V2ZW50cyA9IHt9O1xuXG4gIC8vIFRvIGF2b2lkIHJlY3Vyc2lvbiBpbiB0aGUgY2FzZSB0aGF0IHR5cGUgPT09IFwibmV3TGlzdGVuZXJcIiEgQmVmb3JlXG4gIC8vIGFkZGluZyBpdCB0byB0aGUgbGlzdGVuZXJzLCBmaXJzdCBlbWl0IFwibmV3TGlzdGVuZXJcIi5cbiAgaWYgKHRoaXMuX2V2ZW50cy5uZXdMaXN0ZW5lcilcbiAgICB0aGlzLmVtaXQoJ25ld0xpc3RlbmVyJywgdHlwZSxcbiAgICAgICAgICAgICAgaXNGdW5jdGlvbihsaXN0ZW5lci5saXN0ZW5lcikgP1xuICAgICAgICAgICAgICBsaXN0ZW5lci5saXN0ZW5lciA6IGxpc3RlbmVyKTtcblxuICBpZiAoIXRoaXMuX2V2ZW50c1t0eXBlXSlcbiAgICAvLyBPcHRpbWl6ZSB0aGUgY2FzZSBvZiBvbmUgbGlzdGVuZXIuIERvbid0IG5lZWQgdGhlIGV4dHJhIGFycmF5IG9iamVjdC5cbiAgICB0aGlzLl9ldmVudHNbdHlwZV0gPSBsaXN0ZW5lcjtcbiAgZWxzZSBpZiAoaXNPYmplY3QodGhpcy5fZXZlbnRzW3R5cGVdKSlcbiAgICAvLyBJZiB3ZSd2ZSBhbHJlYWR5IGdvdCBhbiBhcnJheSwganVzdCBhcHBlbmQuXG4gICAgdGhpcy5fZXZlbnRzW3R5cGVdLnB1c2gobGlzdGVuZXIpO1xuICBlbHNlXG4gICAgLy8gQWRkaW5nIHRoZSBzZWNvbmQgZWxlbWVudCwgbmVlZCB0byBjaGFuZ2UgdG8gYXJyYXkuXG4gICAgdGhpcy5fZXZlbnRzW3R5cGVdID0gW3RoaXMuX2V2ZW50c1t0eXBlXSwgbGlzdGVuZXJdO1xuXG4gIC8vIENoZWNrIGZvciBsaXN0ZW5lciBsZWFrXG4gIGlmIChpc09iamVjdCh0aGlzLl9ldmVudHNbdHlwZV0pICYmICF0aGlzLl9ldmVudHNbdHlwZV0ud2FybmVkKSB7XG4gICAgaWYgKCFpc1VuZGVmaW5lZCh0aGlzLl9tYXhMaXN0ZW5lcnMpKSB7XG4gICAgICBtID0gdGhpcy5fbWF4TGlzdGVuZXJzO1xuICAgIH0gZWxzZSB7XG4gICAgICBtID0gRXZlbnRFbWl0dGVyLmRlZmF1bHRNYXhMaXN0ZW5lcnM7XG4gICAgfVxuXG4gICAgaWYgKG0gJiYgbSA+IDAgJiYgdGhpcy5fZXZlbnRzW3R5cGVdLmxlbmd0aCA+IG0pIHtcbiAgICAgIHRoaXMuX2V2ZW50c1t0eXBlXS53YXJuZWQgPSB0cnVlO1xuICAgICAgY29uc29sZS5lcnJvcignKG5vZGUpIHdhcm5pbmc6IHBvc3NpYmxlIEV2ZW50RW1pdHRlciBtZW1vcnkgJyArXG4gICAgICAgICAgICAgICAgICAgICdsZWFrIGRldGVjdGVkLiAlZCBsaXN0ZW5lcnMgYWRkZWQuICcgK1xuICAgICAgICAgICAgICAgICAgICAnVXNlIGVtaXR0ZXIuc2V0TWF4TGlzdGVuZXJzKCkgdG8gaW5jcmVhc2UgbGltaXQuJyxcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5fZXZlbnRzW3R5cGVdLmxlbmd0aCk7XG4gICAgICBpZiAodHlwZW9mIGNvbnNvbGUudHJhY2UgPT09ICdmdW5jdGlvbicpIHtcbiAgICAgICAgLy8gbm90IHN1cHBvcnRlZCBpbiBJRSAxMFxuICAgICAgICBjb25zb2xlLnRyYWNlKCk7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG5FdmVudEVtaXR0ZXIucHJvdG90eXBlLm9uID0gRXZlbnRFbWl0dGVyLnByb3RvdHlwZS5hZGRMaXN0ZW5lcjtcblxuRXZlbnRFbWl0dGVyLnByb3RvdHlwZS5vbmNlID0gZnVuY3Rpb24odHlwZSwgbGlzdGVuZXIpIHtcbiAgaWYgKCFpc0Z1bmN0aW9uKGxpc3RlbmVyKSlcbiAgICB0aHJvdyBUeXBlRXJyb3IoJ2xpc3RlbmVyIG11c3QgYmUgYSBmdW5jdGlvbicpO1xuXG4gIHZhciBmaXJlZCA9IGZhbHNlO1xuXG4gIGZ1bmN0aW9uIGcoKSB7XG4gICAgdGhpcy5yZW1vdmVMaXN0ZW5lcih0eXBlLCBnKTtcblxuICAgIGlmICghZmlyZWQpIHtcbiAgICAgIGZpcmVkID0gdHJ1ZTtcbiAgICAgIGxpc3RlbmVyLmFwcGx5KHRoaXMsIGFyZ3VtZW50cyk7XG4gICAgfVxuICB9XG5cbiAgZy5saXN0ZW5lciA9IGxpc3RlbmVyO1xuICB0aGlzLm9uKHR5cGUsIGcpO1xuXG4gIHJldHVybiB0aGlzO1xufTtcblxuLy8gZW1pdHMgYSAncmVtb3ZlTGlzdGVuZXInIGV2ZW50IGlmZiB0aGUgbGlzdGVuZXIgd2FzIHJlbW92ZWRcbkV2ZW50RW1pdHRlci5wcm90b3R5cGUucmVtb3ZlTGlzdGVuZXIgPSBmdW5jdGlvbih0eXBlLCBsaXN0ZW5lcikge1xuICB2YXIgbGlzdCwgcG9zaXRpb24sIGxlbmd0aCwgaTtcblxuICBpZiAoIWlzRnVuY3Rpb24obGlzdGVuZXIpKVxuICAgIHRocm93IFR5cGVFcnJvcignbGlzdGVuZXIgbXVzdCBiZSBhIGZ1bmN0aW9uJyk7XG5cbiAgaWYgKCF0aGlzLl9ldmVudHMgfHwgIXRoaXMuX2V2ZW50c1t0eXBlXSlcbiAgICByZXR1cm4gdGhpcztcblxuICBsaXN0ID0gdGhpcy5fZXZlbnRzW3R5cGVdO1xuICBsZW5ndGggPSBsaXN0Lmxlbmd0aDtcbiAgcG9zaXRpb24gPSAtMTtcblxuICBpZiAobGlzdCA9PT0gbGlzdGVuZXIgfHxcbiAgICAgIChpc0Z1bmN0aW9uKGxpc3QubGlzdGVuZXIpICYmIGxpc3QubGlzdGVuZXIgPT09IGxpc3RlbmVyKSkge1xuICAgIGRlbGV0ZSB0aGlzLl9ldmVudHNbdHlwZV07XG4gICAgaWYgKHRoaXMuX2V2ZW50cy5yZW1vdmVMaXN0ZW5lcilcbiAgICAgIHRoaXMuZW1pdCgncmVtb3ZlTGlzdGVuZXInLCB0eXBlLCBsaXN0ZW5lcik7XG5cbiAgfSBlbHNlIGlmIChpc09iamVjdChsaXN0KSkge1xuICAgIGZvciAoaSA9IGxlbmd0aDsgaS0tID4gMDspIHtcbiAgICAgIGlmIChsaXN0W2ldID09PSBsaXN0ZW5lciB8fFxuICAgICAgICAgIChsaXN0W2ldLmxpc3RlbmVyICYmIGxpc3RbaV0ubGlzdGVuZXIgPT09IGxpc3RlbmVyKSkge1xuICAgICAgICBwb3NpdGlvbiA9IGk7XG4gICAgICAgIGJyZWFrO1xuICAgICAgfVxuICAgIH1cblxuICAgIGlmIChwb3NpdGlvbiA8IDApXG4gICAgICByZXR1cm4gdGhpcztcblxuICAgIGlmIChsaXN0Lmxlbmd0aCA9PT0gMSkge1xuICAgICAgbGlzdC5sZW5ndGggPSAwO1xuICAgICAgZGVsZXRlIHRoaXMuX2V2ZW50c1t0eXBlXTtcbiAgICB9IGVsc2Uge1xuICAgICAgbGlzdC5zcGxpY2UocG9zaXRpb24sIDEpO1xuICAgIH1cblxuICAgIGlmICh0aGlzLl9ldmVudHMucmVtb3ZlTGlzdGVuZXIpXG4gICAgICB0aGlzLmVtaXQoJ3JlbW92ZUxpc3RlbmVyJywgdHlwZSwgbGlzdGVuZXIpO1xuICB9XG5cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG5FdmVudEVtaXR0ZXIucHJvdG90eXBlLnJlbW92ZUFsbExpc3RlbmVycyA9IGZ1bmN0aW9uKHR5cGUpIHtcbiAgdmFyIGtleSwgbGlzdGVuZXJzO1xuXG4gIGlmICghdGhpcy5fZXZlbnRzKVxuICAgIHJldHVybiB0aGlzO1xuXG4gIC8vIG5vdCBsaXN0ZW5pbmcgZm9yIHJlbW92ZUxpc3RlbmVyLCBubyBuZWVkIHRvIGVtaXRcbiAgaWYgKCF0aGlzLl9ldmVudHMucmVtb3ZlTGlzdGVuZXIpIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMClcbiAgICAgIHRoaXMuX2V2ZW50cyA9IHt9O1xuICAgIGVsc2UgaWYgKHRoaXMuX2V2ZW50c1t0eXBlXSlcbiAgICAgIGRlbGV0ZSB0aGlzLl9ldmVudHNbdHlwZV07XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICAvLyBlbWl0IHJlbW92ZUxpc3RlbmVyIGZvciBhbGwgbGlzdGVuZXJzIG9uIGFsbCBldmVudHNcbiAgaWYgKGFyZ3VtZW50cy5sZW5ndGggPT09IDApIHtcbiAgICBmb3IgKGtleSBpbiB0aGlzLl9ldmVudHMpIHtcbiAgICAgIGlmIChrZXkgPT09ICdyZW1vdmVMaXN0ZW5lcicpIGNvbnRpbnVlO1xuICAgICAgdGhpcy5yZW1vdmVBbGxMaXN0ZW5lcnMoa2V5KTtcbiAgICB9XG4gICAgdGhpcy5yZW1vdmVBbGxMaXN0ZW5lcnMoJ3JlbW92ZUxpc3RlbmVyJyk7XG4gICAgdGhpcy5fZXZlbnRzID0ge307XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICBsaXN0ZW5lcnMgPSB0aGlzLl9ldmVudHNbdHlwZV07XG5cbiAgaWYgKGlzRnVuY3Rpb24obGlzdGVuZXJzKSkge1xuICAgIHRoaXMucmVtb3ZlTGlzdGVuZXIodHlwZSwgbGlzdGVuZXJzKTtcbiAgfSBlbHNlIGlmIChsaXN0ZW5lcnMpIHtcbiAgICAvLyBMSUZPIG9yZGVyXG4gICAgd2hpbGUgKGxpc3RlbmVycy5sZW5ndGgpXG4gICAgICB0aGlzLnJlbW92ZUxpc3RlbmVyKHR5cGUsIGxpc3RlbmVyc1tsaXN0ZW5lcnMubGVuZ3RoIC0gMV0pO1xuICB9XG4gIGRlbGV0ZSB0aGlzLl9ldmVudHNbdHlwZV07XG5cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG5FdmVudEVtaXR0ZXIucHJvdG90eXBlLmxpc3RlbmVycyA9IGZ1bmN0aW9uKHR5cGUpIHtcbiAgdmFyIHJldDtcbiAgaWYgKCF0aGlzLl9ldmVudHMgfHwgIXRoaXMuX2V2ZW50c1t0eXBlXSlcbiAgICByZXQgPSBbXTtcbiAgZWxzZSBpZiAoaXNGdW5jdGlvbih0aGlzLl9ldmVudHNbdHlwZV0pKVxuICAgIHJldCA9IFt0aGlzLl9ldmVudHNbdHlwZV1dO1xuICBlbHNlXG4gICAgcmV0ID0gdGhpcy5fZXZlbnRzW3R5cGVdLnNsaWNlKCk7XG4gIHJldHVybiByZXQ7XG59O1xuXG5FdmVudEVtaXR0ZXIucHJvdG90eXBlLmxpc3RlbmVyQ291bnQgPSBmdW5jdGlvbih0eXBlKSB7XG4gIGlmICh0aGlzLl9ldmVudHMpIHtcbiAgICB2YXIgZXZsaXN0ZW5lciA9IHRoaXMuX2V2ZW50c1t0eXBlXTtcblxuICAgIGlmIChpc0Z1bmN0aW9uKGV2bGlzdGVuZXIpKVxuICAgICAgcmV0dXJuIDE7XG4gICAgZWxzZSBpZiAoZXZsaXN0ZW5lcilcbiAgICAgIHJldHVybiBldmxpc3RlbmVyLmxlbmd0aDtcbiAgfVxuICByZXR1cm4gMDtcbn07XG5cbkV2ZW50RW1pdHRlci5saXN0ZW5lckNvdW50ID0gZnVuY3Rpb24oZW1pdHRlciwgdHlwZSkge1xuICByZXR1cm4gZW1pdHRlci5saXN0ZW5lckNvdW50KHR5cGUpO1xufTtcblxuZnVuY3Rpb24gaXNGdW5jdGlvbihhcmcpIHtcbiAgcmV0dXJuIHR5cGVvZiBhcmcgPT09ICdmdW5jdGlvbic7XG59XG5cbmZ1bmN0aW9uIGlzTnVtYmVyKGFyZykge1xuICByZXR1cm4gdHlwZW9mIGFyZyA9PT0gJ251bWJlcic7XG59XG5cbmZ1bmN0aW9uIGlzT2JqZWN0KGFyZykge1xuICByZXR1cm4gdHlwZW9mIGFyZyA9PT0gJ29iamVjdCcgJiYgYXJnICE9PSBudWxsO1xufVxuXG5mdW5jdGlvbiBpc1VuZGVmaW5lZChhcmcpIHtcbiAgcmV0dXJuIGFyZyA9PT0gdm9pZCAwO1xufVxuIiwiXG4vKlxuICogTW9kdWxlIHJlcXVpcmVtZW50cy5cbiAqL1xuXG52YXIgaXNBcnJheSA9IHJlcXVpcmUoJ2lzYXJyYXknKTtcblxuLyoqXG4gKiBNb2R1bGUgZXhwb3J0cy5cbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IGhhc0JpbmFyeTtcblxuLyoqXG4gKiBDaGVja3MgZm9yIGJpbmFyeSBkYXRhLlxuICpcbiAqIFJpZ2h0IG5vdyBvbmx5IEJ1ZmZlciBhbmQgQXJyYXlCdWZmZXIgYXJlIHN1cHBvcnRlZC4uXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IGFueXRoaW5nXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGhhc0JpbmFyeShkYXRhKSB7XG5cbiAgZnVuY3Rpb24gX2hhc0JpbmFyeShvYmopIHtcbiAgICBpZiAoIW9iaikgcmV0dXJuIGZhbHNlO1xuXG4gICAgaWYgKCAoZ2xvYmFsLkJ1ZmZlciAmJiBnbG9iYWwuQnVmZmVyLmlzQnVmZmVyICYmIGdsb2JhbC5CdWZmZXIuaXNCdWZmZXIob2JqKSkgfHxcbiAgICAgICAgIChnbG9iYWwuQXJyYXlCdWZmZXIgJiYgb2JqIGluc3RhbmNlb2YgQXJyYXlCdWZmZXIpIHx8XG4gICAgICAgICAoZ2xvYmFsLkJsb2IgJiYgb2JqIGluc3RhbmNlb2YgQmxvYikgfHxcbiAgICAgICAgIChnbG9iYWwuRmlsZSAmJiBvYmogaW5zdGFuY2VvZiBGaWxlKVxuICAgICAgICApIHtcbiAgICAgIHJldHVybiB0cnVlO1xuICAgIH1cblxuICAgIGlmIChpc0FycmF5KG9iaikpIHtcbiAgICAgIGZvciAodmFyIGkgPSAwOyBpIDwgb2JqLmxlbmd0aDsgaSsrKSB7XG4gICAgICAgICAgaWYgKF9oYXNCaW5hcnkob2JqW2ldKSkge1xuICAgICAgICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICAgICAgICB9XG4gICAgICB9XG4gICAgfSBlbHNlIGlmIChvYmogJiYgJ29iamVjdCcgPT0gdHlwZW9mIG9iaikge1xuICAgICAgLy8gc2VlOiBodHRwczovL2dpdGh1Yi5jb20vQXV0b21hdHRpYy9oYXMtYmluYXJ5L3B1bGwvNFxuICAgICAgaWYgKG9iai50b0pTT04gJiYgJ2Z1bmN0aW9uJyA9PSB0eXBlb2Ygb2JqLnRvSlNPTikge1xuICAgICAgICBvYmogPSBvYmoudG9KU09OKCk7XG4gICAgICB9XG5cbiAgICAgIGZvciAodmFyIGtleSBpbiBvYmopIHtcbiAgICAgICAgaWYgKE9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHkuY2FsbChvYmosIGtleSkgJiYgX2hhc0JpbmFyeShvYmpba2V5XSkpIHtcbiAgICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cblxuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuXG4gIHJldHVybiBfaGFzQmluYXJ5KGRhdGEpO1xufVxuIiwibW9kdWxlLmV4cG9ydHMgPSBBcnJheS5pc0FycmF5IHx8IGZ1bmN0aW9uIChhcnIpIHtcbiAgcmV0dXJuIE9iamVjdC5wcm90b3R5cGUudG9TdHJpbmcuY2FsbChhcnIpID09ICdbb2JqZWN0IEFycmF5XSc7XG59O1xuIiwiXG4vKipcbiAqIE1vZHVsZSBleHBvcnRzLlxuICpcbiAqIExvZ2ljIGJvcnJvd2VkIGZyb20gTW9kZXJuaXpyOlxuICpcbiAqICAgLSBodHRwczovL2dpdGh1Yi5jb20vTW9kZXJuaXpyL01vZGVybml6ci9ibG9iL21hc3Rlci9mZWF0dXJlLWRldGVjdHMvY29ycy5qc1xuICovXG5cbnRyeSB7XG4gIG1vZHVsZS5leHBvcnRzID0gdHlwZW9mIFhNTEh0dHBSZXF1ZXN0ICE9PSAndW5kZWZpbmVkJyAmJlxuICAgICd3aXRoQ3JlZGVudGlhbHMnIGluIG5ldyBYTUxIdHRwUmVxdWVzdCgpO1xufSBjYXRjaCAoZXJyKSB7XG4gIC8vIGlmIFhNTEh0dHAgc3VwcG9ydCBpcyBkaXNhYmxlZCBpbiBJRSB0aGVuIGl0IHdpbGwgdGhyb3dcbiAgLy8gd2hlbiB0cnlpbmcgdG8gY3JlYXRlXG4gIG1vZHVsZS5leHBvcnRzID0gZmFsc2U7XG59XG4iLCJcbnZhciBpbmRleE9mID0gW10uaW5kZXhPZjtcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihhcnIsIG9iail7XG4gIGlmIChpbmRleE9mKSByZXR1cm4gYXJyLmluZGV4T2Yob2JqKTtcbiAgZm9yICh2YXIgaSA9IDA7IGkgPCBhcnIubGVuZ3RoOyArK2kpIHtcbiAgICBpZiAoYXJyW2ldID09PSBvYmopIHJldHVybiBpO1xuICB9XG4gIHJldHVybiAtMTtcbn07IiwiLyohIEpTT04gdjMuMy4yIHwgaHR0cDovL2Jlc3RpZWpzLmdpdGh1Yi5pby9qc29uMyB8IENvcHlyaWdodCAyMDEyLTIwMTQsIEtpdCBDYW1icmlkZ2UgfCBodHRwOi8va2l0Lm1pdC1saWNlbnNlLm9yZyAqL1xuOyhmdW5jdGlvbiAoKSB7XG4gIC8vIERldGVjdCB0aGUgYGRlZmluZWAgZnVuY3Rpb24gZXhwb3NlZCBieSBhc3luY2hyb25vdXMgbW9kdWxlIGxvYWRlcnMuIFRoZVxuICAvLyBzdHJpY3QgYGRlZmluZWAgY2hlY2sgaXMgbmVjZXNzYXJ5IGZvciBjb21wYXRpYmlsaXR5IHdpdGggYHIuanNgLlxuICB2YXIgaXNMb2FkZXIgPSB0eXBlb2YgZGVmaW5lID09PSBcImZ1bmN0aW9uXCIgJiYgZGVmaW5lLmFtZDtcblxuICAvLyBBIHNldCBvZiB0eXBlcyB1c2VkIHRvIGRpc3Rpbmd1aXNoIG9iamVjdHMgZnJvbSBwcmltaXRpdmVzLlxuICB2YXIgb2JqZWN0VHlwZXMgPSB7XG4gICAgXCJmdW5jdGlvblwiOiB0cnVlLFxuICAgIFwib2JqZWN0XCI6IHRydWVcbiAgfTtcblxuICAvLyBEZXRlY3QgdGhlIGBleHBvcnRzYCBvYmplY3QgZXhwb3NlZCBieSBDb21tb25KUyBpbXBsZW1lbnRhdGlvbnMuXG4gIHZhciBmcmVlRXhwb3J0cyA9IG9iamVjdFR5cGVzW3R5cGVvZiBleHBvcnRzXSAmJiBleHBvcnRzICYmICFleHBvcnRzLm5vZGVUeXBlICYmIGV4cG9ydHM7XG5cbiAgLy8gVXNlIHRoZSBgZ2xvYmFsYCBvYmplY3QgZXhwb3NlZCBieSBOb2RlIChpbmNsdWRpbmcgQnJvd3NlcmlmeSB2aWFcbiAgLy8gYGluc2VydC1tb2R1bGUtZ2xvYmFsc2ApLCBOYXJ3aGFsLCBhbmQgUmluZ28gYXMgdGhlIGRlZmF1bHQgY29udGV4dCxcbiAgLy8gYW5kIHRoZSBgd2luZG93YCBvYmplY3QgaW4gYnJvd3NlcnMuIFJoaW5vIGV4cG9ydHMgYSBgZ2xvYmFsYCBmdW5jdGlvblxuICAvLyBpbnN0ZWFkLlxuICB2YXIgcm9vdCA9IG9iamVjdFR5cGVzW3R5cGVvZiB3aW5kb3ddICYmIHdpbmRvdyB8fCB0aGlzLFxuICAgICAgZnJlZUdsb2JhbCA9IGZyZWVFeHBvcnRzICYmIG9iamVjdFR5cGVzW3R5cGVvZiBtb2R1bGVdICYmIG1vZHVsZSAmJiAhbW9kdWxlLm5vZGVUeXBlICYmIHR5cGVvZiBnbG9iYWwgPT0gXCJvYmplY3RcIiAmJiBnbG9iYWw7XG5cbiAgaWYgKGZyZWVHbG9iYWwgJiYgKGZyZWVHbG9iYWxbXCJnbG9iYWxcIl0gPT09IGZyZWVHbG9iYWwgfHwgZnJlZUdsb2JhbFtcIndpbmRvd1wiXSA9PT0gZnJlZUdsb2JhbCB8fCBmcmVlR2xvYmFsW1wic2VsZlwiXSA9PT0gZnJlZUdsb2JhbCkpIHtcbiAgICByb290ID0gZnJlZUdsb2JhbDtcbiAgfVxuXG4gIC8vIFB1YmxpYzogSW5pdGlhbGl6ZXMgSlNPTiAzIHVzaW5nIHRoZSBnaXZlbiBgY29udGV4dGAgb2JqZWN0LCBhdHRhY2hpbmcgdGhlXG4gIC8vIGBzdHJpbmdpZnlgIGFuZCBgcGFyc2VgIGZ1bmN0aW9ucyB0byB0aGUgc3BlY2lmaWVkIGBleHBvcnRzYCBvYmplY3QuXG4gIGZ1bmN0aW9uIHJ1bkluQ29udGV4dChjb250ZXh0LCBleHBvcnRzKSB7XG4gICAgY29udGV4dCB8fCAoY29udGV4dCA9IHJvb3RbXCJPYmplY3RcIl0oKSk7XG4gICAgZXhwb3J0cyB8fCAoZXhwb3J0cyA9IHJvb3RbXCJPYmplY3RcIl0oKSk7XG5cbiAgICAvLyBOYXRpdmUgY29uc3RydWN0b3IgYWxpYXNlcy5cbiAgICB2YXIgTnVtYmVyID0gY29udGV4dFtcIk51bWJlclwiXSB8fCByb290W1wiTnVtYmVyXCJdLFxuICAgICAgICBTdHJpbmcgPSBjb250ZXh0W1wiU3RyaW5nXCJdIHx8IHJvb3RbXCJTdHJpbmdcIl0sXG4gICAgICAgIE9iamVjdCA9IGNvbnRleHRbXCJPYmplY3RcIl0gfHwgcm9vdFtcIk9iamVjdFwiXSxcbiAgICAgICAgRGF0ZSA9IGNvbnRleHRbXCJEYXRlXCJdIHx8IHJvb3RbXCJEYXRlXCJdLFxuICAgICAgICBTeW50YXhFcnJvciA9IGNvbnRleHRbXCJTeW50YXhFcnJvclwiXSB8fCByb290W1wiU3ludGF4RXJyb3JcIl0sXG4gICAgICAgIFR5cGVFcnJvciA9IGNvbnRleHRbXCJUeXBlRXJyb3JcIl0gfHwgcm9vdFtcIlR5cGVFcnJvclwiXSxcbiAgICAgICAgTWF0aCA9IGNvbnRleHRbXCJNYXRoXCJdIHx8IHJvb3RbXCJNYXRoXCJdLFxuICAgICAgICBuYXRpdmVKU09OID0gY29udGV4dFtcIkpTT05cIl0gfHwgcm9vdFtcIkpTT05cIl07XG5cbiAgICAvLyBEZWxlZ2F0ZSB0byB0aGUgbmF0aXZlIGBzdHJpbmdpZnlgIGFuZCBgcGFyc2VgIGltcGxlbWVudGF0aW9ucy5cbiAgICBpZiAodHlwZW9mIG5hdGl2ZUpTT04gPT0gXCJvYmplY3RcIiAmJiBuYXRpdmVKU09OKSB7XG4gICAgICBleHBvcnRzLnN0cmluZ2lmeSA9IG5hdGl2ZUpTT04uc3RyaW5naWZ5O1xuICAgICAgZXhwb3J0cy5wYXJzZSA9IG5hdGl2ZUpTT04ucGFyc2U7XG4gICAgfVxuXG4gICAgLy8gQ29udmVuaWVuY2UgYWxpYXNlcy5cbiAgICB2YXIgb2JqZWN0UHJvdG8gPSBPYmplY3QucHJvdG90eXBlLFxuICAgICAgICBnZXRDbGFzcyA9IG9iamVjdFByb3RvLnRvU3RyaW5nLFxuICAgICAgICBpc1Byb3BlcnR5LCBmb3JFYWNoLCB1bmRlZjtcblxuICAgIC8vIFRlc3QgdGhlIGBEYXRlI2dldFVUQypgIG1ldGhvZHMuIEJhc2VkIG9uIHdvcmsgYnkgQFlhZmZsZS5cbiAgICB2YXIgaXNFeHRlbmRlZCA9IG5ldyBEYXRlKC0zNTA5ODI3MzM0NTczMjkyKTtcbiAgICB0cnkge1xuICAgICAgLy8gVGhlIGBnZXRVVENGdWxsWWVhcmAsIGBNb250aGAsIGFuZCBgRGF0ZWAgbWV0aG9kcyByZXR1cm4gbm9uc2Vuc2ljYWxcbiAgICAgIC8vIHJlc3VsdHMgZm9yIGNlcnRhaW4gZGF0ZXMgaW4gT3BlcmEgPj0gMTAuNTMuXG4gICAgICBpc0V4dGVuZGVkID0gaXNFeHRlbmRlZC5nZXRVVENGdWxsWWVhcigpID09IC0xMDkyNTIgJiYgaXNFeHRlbmRlZC5nZXRVVENNb250aCgpID09PSAwICYmIGlzRXh0ZW5kZWQuZ2V0VVRDRGF0ZSgpID09PSAxICYmXG4gICAgICAgIC8vIFNhZmFyaSA8IDIuMC4yIHN0b3JlcyB0aGUgaW50ZXJuYWwgbWlsbGlzZWNvbmQgdGltZSB2YWx1ZSBjb3JyZWN0bHksXG4gICAgICAgIC8vIGJ1dCBjbGlwcyB0aGUgdmFsdWVzIHJldHVybmVkIGJ5IHRoZSBkYXRlIG1ldGhvZHMgdG8gdGhlIHJhbmdlIG9mXG4gICAgICAgIC8vIHNpZ25lZCAzMi1iaXQgaW50ZWdlcnMgKFstMiAqKiAzMSwgMiAqKiAzMSAtIDFdKS5cbiAgICAgICAgaXNFeHRlbmRlZC5nZXRVVENIb3VycygpID09IDEwICYmIGlzRXh0ZW5kZWQuZ2V0VVRDTWludXRlcygpID09IDM3ICYmIGlzRXh0ZW5kZWQuZ2V0VVRDU2Vjb25kcygpID09IDYgJiYgaXNFeHRlbmRlZC5nZXRVVENNaWxsaXNlY29uZHMoKSA9PSA3MDg7XG4gICAgfSBjYXRjaCAoZXhjZXB0aW9uKSB7fVxuXG4gICAgLy8gSW50ZXJuYWw6IERldGVybWluZXMgd2hldGhlciB0aGUgbmF0aXZlIGBKU09OLnN0cmluZ2lmeWAgYW5kIGBwYXJzZWBcbiAgICAvLyBpbXBsZW1lbnRhdGlvbnMgYXJlIHNwZWMtY29tcGxpYW50LiBCYXNlZCBvbiB3b3JrIGJ5IEtlbiBTbnlkZXIuXG4gICAgZnVuY3Rpb24gaGFzKG5hbWUpIHtcbiAgICAgIGlmIChoYXNbbmFtZV0gIT09IHVuZGVmKSB7XG4gICAgICAgIC8vIFJldHVybiBjYWNoZWQgZmVhdHVyZSB0ZXN0IHJlc3VsdC5cbiAgICAgICAgcmV0dXJuIGhhc1tuYW1lXTtcbiAgICAgIH1cbiAgICAgIHZhciBpc1N1cHBvcnRlZDtcbiAgICAgIGlmIChuYW1lID09IFwiYnVnLXN0cmluZy1jaGFyLWluZGV4XCIpIHtcbiAgICAgICAgLy8gSUUgPD0gNyBkb2Vzbid0IHN1cHBvcnQgYWNjZXNzaW5nIHN0cmluZyBjaGFyYWN0ZXJzIHVzaW5nIHNxdWFyZVxuICAgICAgICAvLyBicmFja2V0IG5vdGF0aW9uLiBJRSA4IG9ubHkgc3VwcG9ydHMgdGhpcyBmb3IgcHJpbWl0aXZlcy5cbiAgICAgICAgaXNTdXBwb3J0ZWQgPSBcImFcIlswXSAhPSBcImFcIjtcbiAgICAgIH0gZWxzZSBpZiAobmFtZSA9PSBcImpzb25cIikge1xuICAgICAgICAvLyBJbmRpY2F0ZXMgd2hldGhlciBib3RoIGBKU09OLnN0cmluZ2lmeWAgYW5kIGBKU09OLnBhcnNlYCBhcmVcbiAgICAgICAgLy8gc3VwcG9ydGVkLlxuICAgICAgICBpc1N1cHBvcnRlZCA9IGhhcyhcImpzb24tc3RyaW5naWZ5XCIpICYmIGhhcyhcImpzb24tcGFyc2VcIik7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICB2YXIgdmFsdWUsIHNlcmlhbGl6ZWQgPSAne1wiYVwiOlsxLHRydWUsZmFsc2UsbnVsbCxcIlxcXFx1MDAwMFxcXFxiXFxcXG5cXFxcZlxcXFxyXFxcXHRcIl19JztcbiAgICAgICAgLy8gVGVzdCBgSlNPTi5zdHJpbmdpZnlgLlxuICAgICAgICBpZiAobmFtZSA9PSBcImpzb24tc3RyaW5naWZ5XCIpIHtcbiAgICAgICAgICB2YXIgc3RyaW5naWZ5ID0gZXhwb3J0cy5zdHJpbmdpZnksIHN0cmluZ2lmeVN1cHBvcnRlZCA9IHR5cGVvZiBzdHJpbmdpZnkgPT0gXCJmdW5jdGlvblwiICYmIGlzRXh0ZW5kZWQ7XG4gICAgICAgICAgaWYgKHN0cmluZ2lmeVN1cHBvcnRlZCkge1xuICAgICAgICAgICAgLy8gQSB0ZXN0IGZ1bmN0aW9uIG9iamVjdCB3aXRoIGEgY3VzdG9tIGB0b0pTT05gIG1ldGhvZC5cbiAgICAgICAgICAgICh2YWx1ZSA9IGZ1bmN0aW9uICgpIHtcbiAgICAgICAgICAgICAgcmV0dXJuIDE7XG4gICAgICAgICAgICB9KS50b0pTT04gPSB2YWx1ZTtcbiAgICAgICAgICAgIHRyeSB7XG4gICAgICAgICAgICAgIHN0cmluZ2lmeVN1cHBvcnRlZCA9XG4gICAgICAgICAgICAgICAgLy8gRmlyZWZveCAzLjFiMSBhbmQgYjIgc2VyaWFsaXplIHN0cmluZywgbnVtYmVyLCBhbmQgYm9vbGVhblxuICAgICAgICAgICAgICAgIC8vIHByaW1pdGl2ZXMgYXMgb2JqZWN0IGxpdGVyYWxzLlxuICAgICAgICAgICAgICAgIHN0cmluZ2lmeSgwKSA9PT0gXCIwXCIgJiZcbiAgICAgICAgICAgICAgICAvLyBGRiAzLjFiMSwgYjIsIGFuZCBKU09OIDIgc2VyaWFsaXplIHdyYXBwZWQgcHJpbWl0aXZlcyBhcyBvYmplY3RcbiAgICAgICAgICAgICAgICAvLyBsaXRlcmFscy5cbiAgICAgICAgICAgICAgICBzdHJpbmdpZnkobmV3IE51bWJlcigpKSA9PT0gXCIwXCIgJiZcbiAgICAgICAgICAgICAgICBzdHJpbmdpZnkobmV3IFN0cmluZygpKSA9PSAnXCJcIicgJiZcbiAgICAgICAgICAgICAgICAvLyBGRiAzLjFiMSwgMiB0aHJvdyBhbiBlcnJvciBpZiB0aGUgdmFsdWUgaXMgYG51bGxgLCBgdW5kZWZpbmVkYCwgb3JcbiAgICAgICAgICAgICAgICAvLyBkb2VzIG5vdCBkZWZpbmUgYSBjYW5vbmljYWwgSlNPTiByZXByZXNlbnRhdGlvbiAodGhpcyBhcHBsaWVzIHRvXG4gICAgICAgICAgICAgICAgLy8gb2JqZWN0cyB3aXRoIGB0b0pTT05gIHByb3BlcnRpZXMgYXMgd2VsbCwgKnVubGVzcyogdGhleSBhcmUgbmVzdGVkXG4gICAgICAgICAgICAgICAgLy8gd2l0aGluIGFuIG9iamVjdCBvciBhcnJheSkuXG4gICAgICAgICAgICAgICAgc3RyaW5naWZ5KGdldENsYXNzKSA9PT0gdW5kZWYgJiZcbiAgICAgICAgICAgICAgICAvLyBJRSA4IHNlcmlhbGl6ZXMgYHVuZGVmaW5lZGAgYXMgYFwidW5kZWZpbmVkXCJgLiBTYWZhcmkgPD0gNS4xLjcgYW5kXG4gICAgICAgICAgICAgICAgLy8gRkYgMy4xYjMgcGFzcyB0aGlzIHRlc3QuXG4gICAgICAgICAgICAgICAgc3RyaW5naWZ5KHVuZGVmKSA9PT0gdW5kZWYgJiZcbiAgICAgICAgICAgICAgICAvLyBTYWZhcmkgPD0gNS4xLjcgYW5kIEZGIDMuMWIzIHRocm93IGBFcnJvcmBzIGFuZCBgVHlwZUVycm9yYHMsXG4gICAgICAgICAgICAgICAgLy8gcmVzcGVjdGl2ZWx5LCBpZiB0aGUgdmFsdWUgaXMgb21pdHRlZCBlbnRpcmVseS5cbiAgICAgICAgICAgICAgICBzdHJpbmdpZnkoKSA9PT0gdW5kZWYgJiZcbiAgICAgICAgICAgICAgICAvLyBGRiAzLjFiMSwgMiB0aHJvdyBhbiBlcnJvciBpZiB0aGUgZ2l2ZW4gdmFsdWUgaXMgbm90IGEgbnVtYmVyLFxuICAgICAgICAgICAgICAgIC8vIHN0cmluZywgYXJyYXksIG9iamVjdCwgQm9vbGVhbiwgb3IgYG51bGxgIGxpdGVyYWwuIFRoaXMgYXBwbGllcyB0b1xuICAgICAgICAgICAgICAgIC8vIG9iamVjdHMgd2l0aCBjdXN0b20gYHRvSlNPTmAgbWV0aG9kcyBhcyB3ZWxsLCB1bmxlc3MgdGhleSBhcmUgbmVzdGVkXG4gICAgICAgICAgICAgICAgLy8gaW5zaWRlIG9iamVjdCBvciBhcnJheSBsaXRlcmFscy4gWVVJIDMuMC4wYjEgaWdub3JlcyBjdXN0b20gYHRvSlNPTmBcbiAgICAgICAgICAgICAgICAvLyBtZXRob2RzIGVudGlyZWx5LlxuICAgICAgICAgICAgICAgIHN0cmluZ2lmeSh2YWx1ZSkgPT09IFwiMVwiICYmXG4gICAgICAgICAgICAgICAgc3RyaW5naWZ5KFt2YWx1ZV0pID09IFwiWzFdXCIgJiZcbiAgICAgICAgICAgICAgICAvLyBQcm90b3R5cGUgPD0gMS42LjEgc2VyaWFsaXplcyBgW3VuZGVmaW5lZF1gIGFzIGBcIltdXCJgIGluc3RlYWQgb2ZcbiAgICAgICAgICAgICAgICAvLyBgXCJbbnVsbF1cImAuXG4gICAgICAgICAgICAgICAgc3RyaW5naWZ5KFt1bmRlZl0pID09IFwiW251bGxdXCIgJiZcbiAgICAgICAgICAgICAgICAvLyBZVUkgMy4wLjBiMSBmYWlscyB0byBzZXJpYWxpemUgYG51bGxgIGxpdGVyYWxzLlxuICAgICAgICAgICAgICAgIHN0cmluZ2lmeShudWxsKSA9PSBcIm51bGxcIiAmJlxuICAgICAgICAgICAgICAgIC8vIEZGIDMuMWIxLCAyIGhhbHRzIHNlcmlhbGl6YXRpb24gaWYgYW4gYXJyYXkgY29udGFpbnMgYSBmdW5jdGlvbjpcbiAgICAgICAgICAgICAgICAvLyBgWzEsIHRydWUsIGdldENsYXNzLCAxXWAgc2VyaWFsaXplcyBhcyBcIlsxLHRydWUsXSxcIi4gRkYgMy4xYjNcbiAgICAgICAgICAgICAgICAvLyBlbGlkZXMgbm9uLUpTT04gdmFsdWVzIGZyb20gb2JqZWN0cyBhbmQgYXJyYXlzLCB1bmxlc3MgdGhleVxuICAgICAgICAgICAgICAgIC8vIGRlZmluZSBjdXN0b20gYHRvSlNPTmAgbWV0aG9kcy5cbiAgICAgICAgICAgICAgICBzdHJpbmdpZnkoW3VuZGVmLCBnZXRDbGFzcywgbnVsbF0pID09IFwiW251bGwsbnVsbCxudWxsXVwiICYmXG4gICAgICAgICAgICAgICAgLy8gU2ltcGxlIHNlcmlhbGl6YXRpb24gdGVzdC4gRkYgMy4xYjEgdXNlcyBVbmljb2RlIGVzY2FwZSBzZXF1ZW5jZXNcbiAgICAgICAgICAgICAgICAvLyB3aGVyZSBjaGFyYWN0ZXIgZXNjYXBlIGNvZGVzIGFyZSBleHBlY3RlZCAoZS5nLiwgYFxcYmAgPT4gYFxcdTAwMDhgKS5cbiAgICAgICAgICAgICAgICBzdHJpbmdpZnkoeyBcImFcIjogW3ZhbHVlLCB0cnVlLCBmYWxzZSwgbnVsbCwgXCJcXHgwMFxcYlxcblxcZlxcclxcdFwiXSB9KSA9PSBzZXJpYWxpemVkICYmXG4gICAgICAgICAgICAgICAgLy8gRkYgMy4xYjEgYW5kIGIyIGlnbm9yZSB0aGUgYGZpbHRlcmAgYW5kIGB3aWR0aGAgYXJndW1lbnRzLlxuICAgICAgICAgICAgICAgIHN0cmluZ2lmeShudWxsLCB2YWx1ZSkgPT09IFwiMVwiICYmXG4gICAgICAgICAgICAgICAgc3RyaW5naWZ5KFsxLCAyXSwgbnVsbCwgMSkgPT0gXCJbXFxuIDEsXFxuIDJcXG5dXCIgJiZcbiAgICAgICAgICAgICAgICAvLyBKU09OIDIsIFByb3RvdHlwZSA8PSAxLjcsIGFuZCBvbGRlciBXZWJLaXQgYnVpbGRzIGluY29ycmVjdGx5XG4gICAgICAgICAgICAgICAgLy8gc2VyaWFsaXplIGV4dGVuZGVkIHllYXJzLlxuICAgICAgICAgICAgICAgIHN0cmluZ2lmeShuZXcgRGF0ZSgtOC42NGUxNSkpID09ICdcIi0yNzE4MjEtMDQtMjBUMDA6MDA6MDAuMDAwWlwiJyAmJlxuICAgICAgICAgICAgICAgIC8vIFRoZSBtaWxsaXNlY29uZHMgYXJlIG9wdGlvbmFsIGluIEVTIDUsIGJ1dCByZXF1aXJlZCBpbiA1LjEuXG4gICAgICAgICAgICAgICAgc3RyaW5naWZ5KG5ldyBEYXRlKDguNjRlMTUpKSA9PSAnXCIrMjc1NzYwLTA5LTEzVDAwOjAwOjAwLjAwMFpcIicgJiZcbiAgICAgICAgICAgICAgICAvLyBGaXJlZm94IDw9IDExLjAgaW5jb3JyZWN0bHkgc2VyaWFsaXplcyB5ZWFycyBwcmlvciB0byAwIGFzIG5lZ2F0aXZlXG4gICAgICAgICAgICAgICAgLy8gZm91ci1kaWdpdCB5ZWFycyBpbnN0ZWFkIG9mIHNpeC1kaWdpdCB5ZWFycy4gQ3JlZGl0czogQFlhZmZsZS5cbiAgICAgICAgICAgICAgICBzdHJpbmdpZnkobmV3IERhdGUoLTYyMTk4NzU1MmU1KSkgPT0gJ1wiLTAwMDAwMS0wMS0wMVQwMDowMDowMC4wMDBaXCInICYmXG4gICAgICAgICAgICAgICAgLy8gU2FmYXJpIDw9IDUuMS41IGFuZCBPcGVyYSA+PSAxMC41MyBpbmNvcnJlY3RseSBzZXJpYWxpemUgbWlsbGlzZWNvbmRcbiAgICAgICAgICAgICAgICAvLyB2YWx1ZXMgbGVzcyB0aGFuIDEwMDAuIENyZWRpdHM6IEBZYWZmbGUuXG4gICAgICAgICAgICAgICAgc3RyaW5naWZ5KG5ldyBEYXRlKC0xKSkgPT0gJ1wiMTk2OS0xMi0zMVQyMzo1OTo1OS45OTlaXCInO1xuICAgICAgICAgICAgfSBjYXRjaCAoZXhjZXB0aW9uKSB7XG4gICAgICAgICAgICAgIHN0cmluZ2lmeVN1cHBvcnRlZCA9IGZhbHNlO1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgICBpc1N1cHBvcnRlZCA9IHN0cmluZ2lmeVN1cHBvcnRlZDtcbiAgICAgICAgfVxuICAgICAgICAvLyBUZXN0IGBKU09OLnBhcnNlYC5cbiAgICAgICAgaWYgKG5hbWUgPT0gXCJqc29uLXBhcnNlXCIpIHtcbiAgICAgICAgICB2YXIgcGFyc2UgPSBleHBvcnRzLnBhcnNlO1xuICAgICAgICAgIGlmICh0eXBlb2YgcGFyc2UgPT0gXCJmdW5jdGlvblwiKSB7XG4gICAgICAgICAgICB0cnkge1xuICAgICAgICAgICAgICAvLyBGRiAzLjFiMSwgYjIgd2lsbCB0aHJvdyBhbiBleGNlcHRpb24gaWYgYSBiYXJlIGxpdGVyYWwgaXMgcHJvdmlkZWQuXG4gICAgICAgICAgICAgIC8vIENvbmZvcm1pbmcgaW1wbGVtZW50YXRpb25zIHNob3VsZCBhbHNvIGNvZXJjZSB0aGUgaW5pdGlhbCBhcmd1bWVudCB0b1xuICAgICAgICAgICAgICAvLyBhIHN0cmluZyBwcmlvciB0byBwYXJzaW5nLlxuICAgICAgICAgICAgICBpZiAocGFyc2UoXCIwXCIpID09PSAwICYmICFwYXJzZShmYWxzZSkpIHtcbiAgICAgICAgICAgICAgICAvLyBTaW1wbGUgcGFyc2luZyB0ZXN0LlxuICAgICAgICAgICAgICAgIHZhbHVlID0gcGFyc2Uoc2VyaWFsaXplZCk7XG4gICAgICAgICAgICAgICAgdmFyIHBhcnNlU3VwcG9ydGVkID0gdmFsdWVbXCJhXCJdLmxlbmd0aCA9PSA1ICYmIHZhbHVlW1wiYVwiXVswXSA9PT0gMTtcbiAgICAgICAgICAgICAgICBpZiAocGFyc2VTdXBwb3J0ZWQpIHtcbiAgICAgICAgICAgICAgICAgIHRyeSB7XG4gICAgICAgICAgICAgICAgICAgIC8vIFNhZmFyaSA8PSA1LjEuMiBhbmQgRkYgMy4xYjEgYWxsb3cgdW5lc2NhcGVkIHRhYnMgaW4gc3RyaW5ncy5cbiAgICAgICAgICAgICAgICAgICAgcGFyc2VTdXBwb3J0ZWQgPSAhcGFyc2UoJ1wiXFx0XCInKTtcbiAgICAgICAgICAgICAgICAgIH0gY2F0Y2ggKGV4Y2VwdGlvbikge31cbiAgICAgICAgICAgICAgICAgIGlmIChwYXJzZVN1cHBvcnRlZCkge1xuICAgICAgICAgICAgICAgICAgICB0cnkge1xuICAgICAgICAgICAgICAgICAgICAgIC8vIEZGIDQuMCBhbmQgNC4wLjEgYWxsb3cgbGVhZGluZyBgK2Agc2lnbnMgYW5kIGxlYWRpbmdcbiAgICAgICAgICAgICAgICAgICAgICAvLyBkZWNpbWFsIHBvaW50cy4gRkYgNC4wLCA0LjAuMSwgYW5kIElFIDktMTAgYWxzbyBhbGxvd1xuICAgICAgICAgICAgICAgICAgICAgIC8vIGNlcnRhaW4gb2N0YWwgbGl0ZXJhbHMuXG4gICAgICAgICAgICAgICAgICAgICAgcGFyc2VTdXBwb3J0ZWQgPSBwYXJzZShcIjAxXCIpICE9PSAxO1xuICAgICAgICAgICAgICAgICAgICB9IGNhdGNoIChleGNlcHRpb24pIHt9XG4gICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICBpZiAocGFyc2VTdXBwb3J0ZWQpIHtcbiAgICAgICAgICAgICAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgICAgICAgICAgICAvLyBGRiA0LjAsIDQuMC4xLCBhbmQgUmhpbm8gMS43UjMtUjQgYWxsb3cgdHJhaWxpbmcgZGVjaW1hbFxuICAgICAgICAgICAgICAgICAgICAgIC8vIHBvaW50cy4gVGhlc2UgZW52aXJvbm1lbnRzLCBhbG9uZyB3aXRoIEZGIDMuMWIxIGFuZCAyLFxuICAgICAgICAgICAgICAgICAgICAgIC8vIGFsc28gYWxsb3cgdHJhaWxpbmcgY29tbWFzIGluIEpTT04gb2JqZWN0cyBhbmQgYXJyYXlzLlxuICAgICAgICAgICAgICAgICAgICAgIHBhcnNlU3VwcG9ydGVkID0gcGFyc2UoXCIxLlwiKSAhPT0gMTtcbiAgICAgICAgICAgICAgICAgICAgfSBjYXRjaCAoZXhjZXB0aW9uKSB7fVxuICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSBjYXRjaCAoZXhjZXB0aW9uKSB7XG4gICAgICAgICAgICAgIHBhcnNlU3VwcG9ydGVkID0gZmFsc2U7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICAgIGlzU3VwcG9ydGVkID0gcGFyc2VTdXBwb3J0ZWQ7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAgIHJldHVybiBoYXNbbmFtZV0gPSAhIWlzU3VwcG9ydGVkO1xuICAgIH1cblxuICAgIGlmICghaGFzKFwianNvblwiKSkge1xuICAgICAgLy8gQ29tbW9uIGBbW0NsYXNzXV1gIG5hbWUgYWxpYXNlcy5cbiAgICAgIHZhciBmdW5jdGlvbkNsYXNzID0gXCJbb2JqZWN0IEZ1bmN0aW9uXVwiLFxuICAgICAgICAgIGRhdGVDbGFzcyA9IFwiW29iamVjdCBEYXRlXVwiLFxuICAgICAgICAgIG51bWJlckNsYXNzID0gXCJbb2JqZWN0IE51bWJlcl1cIixcbiAgICAgICAgICBzdHJpbmdDbGFzcyA9IFwiW29iamVjdCBTdHJpbmddXCIsXG4gICAgICAgICAgYXJyYXlDbGFzcyA9IFwiW29iamVjdCBBcnJheV1cIixcbiAgICAgICAgICBib29sZWFuQ2xhc3MgPSBcIltvYmplY3QgQm9vbGVhbl1cIjtcblxuICAgICAgLy8gRGV0ZWN0IGluY29tcGxldGUgc3VwcG9ydCBmb3IgYWNjZXNzaW5nIHN0cmluZyBjaGFyYWN0ZXJzIGJ5IGluZGV4LlxuICAgICAgdmFyIGNoYXJJbmRleEJ1Z2d5ID0gaGFzKFwiYnVnLXN0cmluZy1jaGFyLWluZGV4XCIpO1xuXG4gICAgICAvLyBEZWZpbmUgYWRkaXRpb25hbCB1dGlsaXR5IG1ldGhvZHMgaWYgdGhlIGBEYXRlYCBtZXRob2RzIGFyZSBidWdneS5cbiAgICAgIGlmICghaXNFeHRlbmRlZCkge1xuICAgICAgICB2YXIgZmxvb3IgPSBNYXRoLmZsb29yO1xuICAgICAgICAvLyBBIG1hcHBpbmcgYmV0d2VlbiB0aGUgbW9udGhzIG9mIHRoZSB5ZWFyIGFuZCB0aGUgbnVtYmVyIG9mIGRheXMgYmV0d2VlblxuICAgICAgICAvLyBKYW51YXJ5IDFzdCBhbmQgdGhlIGZpcnN0IG9mIHRoZSByZXNwZWN0aXZlIG1vbnRoLlxuICAgICAgICB2YXIgTW9udGhzID0gWzAsIDMxLCA1OSwgOTAsIDEyMCwgMTUxLCAxODEsIDIxMiwgMjQzLCAyNzMsIDMwNCwgMzM0XTtcbiAgICAgICAgLy8gSW50ZXJuYWw6IENhbGN1bGF0ZXMgdGhlIG51bWJlciBvZiBkYXlzIGJldHdlZW4gdGhlIFVuaXggZXBvY2ggYW5kIHRoZVxuICAgICAgICAvLyBmaXJzdCBkYXkgb2YgdGhlIGdpdmVuIG1vbnRoLlxuICAgICAgICB2YXIgZ2V0RGF5ID0gZnVuY3Rpb24gKHllYXIsIG1vbnRoKSB7XG4gICAgICAgICAgcmV0dXJuIE1vbnRoc1ttb250aF0gKyAzNjUgKiAoeWVhciAtIDE5NzApICsgZmxvb3IoKHllYXIgLSAxOTY5ICsgKG1vbnRoID0gKyhtb250aCA+IDEpKSkgLyA0KSAtIGZsb29yKCh5ZWFyIC0gMTkwMSArIG1vbnRoKSAvIDEwMCkgKyBmbG9vcigoeWVhciAtIDE2MDEgKyBtb250aCkgLyA0MDApO1xuICAgICAgICB9O1xuICAgICAgfVxuXG4gICAgICAvLyBJbnRlcm5hbDogRGV0ZXJtaW5lcyBpZiBhIHByb3BlcnR5IGlzIGEgZGlyZWN0IHByb3BlcnR5IG9mIHRoZSBnaXZlblxuICAgICAgLy8gb2JqZWN0LiBEZWxlZ2F0ZXMgdG8gdGhlIG5hdGl2ZSBgT2JqZWN0I2hhc093blByb3BlcnR5YCBtZXRob2QuXG4gICAgICBpZiAoIShpc1Byb3BlcnR5ID0gb2JqZWN0UHJvdG8uaGFzT3duUHJvcGVydHkpKSB7XG4gICAgICAgIGlzUHJvcGVydHkgPSBmdW5jdGlvbiAocHJvcGVydHkpIHtcbiAgICAgICAgICB2YXIgbWVtYmVycyA9IHt9LCBjb25zdHJ1Y3RvcjtcbiAgICAgICAgICBpZiAoKG1lbWJlcnMuX19wcm90b19fID0gbnVsbCwgbWVtYmVycy5fX3Byb3RvX18gPSB7XG4gICAgICAgICAgICAvLyBUaGUgKnByb3RvKiBwcm9wZXJ0eSBjYW5ub3QgYmUgc2V0IG11bHRpcGxlIHRpbWVzIGluIHJlY2VudFxuICAgICAgICAgICAgLy8gdmVyc2lvbnMgb2YgRmlyZWZveCBhbmQgU2VhTW9ua2V5LlxuICAgICAgICAgICAgXCJ0b1N0cmluZ1wiOiAxXG4gICAgICAgICAgfSwgbWVtYmVycykudG9TdHJpbmcgIT0gZ2V0Q2xhc3MpIHtcbiAgICAgICAgICAgIC8vIFNhZmFyaSA8PSAyLjAuMyBkb2Vzbid0IGltcGxlbWVudCBgT2JqZWN0I2hhc093blByb3BlcnR5YCwgYnV0XG4gICAgICAgICAgICAvLyBzdXBwb3J0cyB0aGUgbXV0YWJsZSAqcHJvdG8qIHByb3BlcnR5LlxuICAgICAgICAgICAgaXNQcm9wZXJ0eSA9IGZ1bmN0aW9uIChwcm9wZXJ0eSkge1xuICAgICAgICAgICAgICAvLyBDYXB0dXJlIGFuZCBicmVhayB0aGUgb2JqZWN0J3MgcHJvdG90eXBlIGNoYWluIChzZWUgc2VjdGlvbiA4LjYuMlxuICAgICAgICAgICAgICAvLyBvZiB0aGUgRVMgNS4xIHNwZWMpLiBUaGUgcGFyZW50aGVzaXplZCBleHByZXNzaW9uIHByZXZlbnRzIGFuXG4gICAgICAgICAgICAgIC8vIHVuc2FmZSB0cmFuc2Zvcm1hdGlvbiBieSB0aGUgQ2xvc3VyZSBDb21waWxlci5cbiAgICAgICAgICAgICAgdmFyIG9yaWdpbmFsID0gdGhpcy5fX3Byb3RvX18sIHJlc3VsdCA9IHByb3BlcnR5IGluICh0aGlzLl9fcHJvdG9fXyA9IG51bGwsIHRoaXMpO1xuICAgICAgICAgICAgICAvLyBSZXN0b3JlIHRoZSBvcmlnaW5hbCBwcm90b3R5cGUgY2hhaW4uXG4gICAgICAgICAgICAgIHRoaXMuX19wcm90b19fID0gb3JpZ2luYWw7XG4gICAgICAgICAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgICAgICAgICB9O1xuICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAvLyBDYXB0dXJlIGEgcmVmZXJlbmNlIHRvIHRoZSB0b3AtbGV2ZWwgYE9iamVjdGAgY29uc3RydWN0b3IuXG4gICAgICAgICAgICBjb25zdHJ1Y3RvciA9IG1lbWJlcnMuY29uc3RydWN0b3I7XG4gICAgICAgICAgICAvLyBVc2UgdGhlIGBjb25zdHJ1Y3RvcmAgcHJvcGVydHkgdG8gc2ltdWxhdGUgYE9iamVjdCNoYXNPd25Qcm9wZXJ0eWAgaW5cbiAgICAgICAgICAgIC8vIG90aGVyIGVudmlyb25tZW50cy5cbiAgICAgICAgICAgIGlzUHJvcGVydHkgPSBmdW5jdGlvbiAocHJvcGVydHkpIHtcbiAgICAgICAgICAgICAgdmFyIHBhcmVudCA9ICh0aGlzLmNvbnN0cnVjdG9yIHx8IGNvbnN0cnVjdG9yKS5wcm90b3R5cGU7XG4gICAgICAgICAgICAgIHJldHVybiBwcm9wZXJ0eSBpbiB0aGlzICYmICEocHJvcGVydHkgaW4gcGFyZW50ICYmIHRoaXNbcHJvcGVydHldID09PSBwYXJlbnRbcHJvcGVydHldKTtcbiAgICAgICAgICAgIH07XG4gICAgICAgICAgfVxuICAgICAgICAgIG1lbWJlcnMgPSBudWxsO1xuICAgICAgICAgIHJldHVybiBpc1Byb3BlcnR5LmNhbGwodGhpcywgcHJvcGVydHkpO1xuICAgICAgICB9O1xuICAgICAgfVxuXG4gICAgICAvLyBJbnRlcm5hbDogTm9ybWFsaXplcyB0aGUgYGZvci4uLmluYCBpdGVyYXRpb24gYWxnb3JpdGhtIGFjcm9zc1xuICAgICAgLy8gZW52aXJvbm1lbnRzLiBFYWNoIGVudW1lcmF0ZWQga2V5IGlzIHlpZWxkZWQgdG8gYSBgY2FsbGJhY2tgIGZ1bmN0aW9uLlxuICAgICAgZm9yRWFjaCA9IGZ1bmN0aW9uIChvYmplY3QsIGNhbGxiYWNrKSB7XG4gICAgICAgIHZhciBzaXplID0gMCwgUHJvcGVydGllcywgbWVtYmVycywgcHJvcGVydHk7XG5cbiAgICAgICAgLy8gVGVzdHMgZm9yIGJ1Z3MgaW4gdGhlIGN1cnJlbnQgZW52aXJvbm1lbnQncyBgZm9yLi4uaW5gIGFsZ29yaXRobS4gVGhlXG4gICAgICAgIC8vIGB2YWx1ZU9mYCBwcm9wZXJ0eSBpbmhlcml0cyB0aGUgbm9uLWVudW1lcmFibGUgZmxhZyBmcm9tXG4gICAgICAgIC8vIGBPYmplY3QucHJvdG90eXBlYCBpbiBvbGRlciB2ZXJzaW9ucyBvZiBJRSwgTmV0c2NhcGUsIGFuZCBNb3ppbGxhLlxuICAgICAgICAoUHJvcGVydGllcyA9IGZ1bmN0aW9uICgpIHtcbiAgICAgICAgICB0aGlzLnZhbHVlT2YgPSAwO1xuICAgICAgICB9KS5wcm90b3R5cGUudmFsdWVPZiA9IDA7XG5cbiAgICAgICAgLy8gSXRlcmF0ZSBvdmVyIGEgbmV3IGluc3RhbmNlIG9mIHRoZSBgUHJvcGVydGllc2AgY2xhc3MuXG4gICAgICAgIG1lbWJlcnMgPSBuZXcgUHJvcGVydGllcygpO1xuICAgICAgICBmb3IgKHByb3BlcnR5IGluIG1lbWJlcnMpIHtcbiAgICAgICAgICAvLyBJZ25vcmUgYWxsIHByb3BlcnRpZXMgaW5oZXJpdGVkIGZyb20gYE9iamVjdC5wcm90b3R5cGVgLlxuICAgICAgICAgIGlmIChpc1Byb3BlcnR5LmNhbGwobWVtYmVycywgcHJvcGVydHkpKSB7XG4gICAgICAgICAgICBzaXplKys7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIFByb3BlcnRpZXMgPSBtZW1iZXJzID0gbnVsbDtcblxuICAgICAgICAvLyBOb3JtYWxpemUgdGhlIGl0ZXJhdGlvbiBhbGdvcml0aG0uXG4gICAgICAgIGlmICghc2l6ZSkge1xuICAgICAgICAgIC8vIEEgbGlzdCBvZiBub24tZW51bWVyYWJsZSBwcm9wZXJ0aWVzIGluaGVyaXRlZCBmcm9tIGBPYmplY3QucHJvdG90eXBlYC5cbiAgICAgICAgICBtZW1iZXJzID0gW1widmFsdWVPZlwiLCBcInRvU3RyaW5nXCIsIFwidG9Mb2NhbGVTdHJpbmdcIiwgXCJwcm9wZXJ0eUlzRW51bWVyYWJsZVwiLCBcImlzUHJvdG90eXBlT2ZcIiwgXCJoYXNPd25Qcm9wZXJ0eVwiLCBcImNvbnN0cnVjdG9yXCJdO1xuICAgICAgICAgIC8vIElFIDw9IDgsIE1vemlsbGEgMS4wLCBhbmQgTmV0c2NhcGUgNi4yIGlnbm9yZSBzaGFkb3dlZCBub24tZW51bWVyYWJsZVxuICAgICAgICAgIC8vIHByb3BlcnRpZXMuXG4gICAgICAgICAgZm9yRWFjaCA9IGZ1bmN0aW9uIChvYmplY3QsIGNhbGxiYWNrKSB7XG4gICAgICAgICAgICB2YXIgaXNGdW5jdGlvbiA9IGdldENsYXNzLmNhbGwob2JqZWN0KSA9PSBmdW5jdGlvbkNsYXNzLCBwcm9wZXJ0eSwgbGVuZ3RoO1xuICAgICAgICAgICAgdmFyIGhhc1Byb3BlcnR5ID0gIWlzRnVuY3Rpb24gJiYgdHlwZW9mIG9iamVjdC5jb25zdHJ1Y3RvciAhPSBcImZ1bmN0aW9uXCIgJiYgb2JqZWN0VHlwZXNbdHlwZW9mIG9iamVjdC5oYXNPd25Qcm9wZXJ0eV0gJiYgb2JqZWN0Lmhhc093blByb3BlcnR5IHx8IGlzUHJvcGVydHk7XG4gICAgICAgICAgICBmb3IgKHByb3BlcnR5IGluIG9iamVjdCkge1xuICAgICAgICAgICAgICAvLyBHZWNrbyA8PSAxLjAgZW51bWVyYXRlcyB0aGUgYHByb3RvdHlwZWAgcHJvcGVydHkgb2YgZnVuY3Rpb25zIHVuZGVyXG4gICAgICAgICAgICAgIC8vIGNlcnRhaW4gY29uZGl0aW9uczsgSUUgZG9lcyBub3QuXG4gICAgICAgICAgICAgIGlmICghKGlzRnVuY3Rpb24gJiYgcHJvcGVydHkgPT0gXCJwcm90b3R5cGVcIikgJiYgaGFzUHJvcGVydHkuY2FsbChvYmplY3QsIHByb3BlcnR5KSkge1xuICAgICAgICAgICAgICAgIGNhbGxiYWNrKHByb3BlcnR5KTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICAgICAgLy8gTWFudWFsbHkgaW52b2tlIHRoZSBjYWxsYmFjayBmb3IgZWFjaCBub24tZW51bWVyYWJsZSBwcm9wZXJ0eS5cbiAgICAgICAgICAgIGZvciAobGVuZ3RoID0gbWVtYmVycy5sZW5ndGg7IHByb3BlcnR5ID0gbWVtYmVyc1stLWxlbmd0aF07IGhhc1Byb3BlcnR5LmNhbGwob2JqZWN0LCBwcm9wZXJ0eSkgJiYgY2FsbGJhY2socHJvcGVydHkpKTtcbiAgICAgICAgICB9O1xuICAgICAgICB9IGVsc2UgaWYgKHNpemUgPT0gMikge1xuICAgICAgICAgIC8vIFNhZmFyaSA8PSAyLjAuNCBlbnVtZXJhdGVzIHNoYWRvd2VkIHByb3BlcnRpZXMgdHdpY2UuXG4gICAgICAgICAgZm9yRWFjaCA9IGZ1bmN0aW9uIChvYmplY3QsIGNhbGxiYWNrKSB7XG4gICAgICAgICAgICAvLyBDcmVhdGUgYSBzZXQgb2YgaXRlcmF0ZWQgcHJvcGVydGllcy5cbiAgICAgICAgICAgIHZhciBtZW1iZXJzID0ge30sIGlzRnVuY3Rpb24gPSBnZXRDbGFzcy5jYWxsKG9iamVjdCkgPT0gZnVuY3Rpb25DbGFzcywgcHJvcGVydHk7XG4gICAgICAgICAgICBmb3IgKHByb3BlcnR5IGluIG9iamVjdCkge1xuICAgICAgICAgICAgICAvLyBTdG9yZSBlYWNoIHByb3BlcnR5IG5hbWUgdG8gcHJldmVudCBkb3VibGUgZW51bWVyYXRpb24uIFRoZVxuICAgICAgICAgICAgICAvLyBgcHJvdG90eXBlYCBwcm9wZXJ0eSBvZiBmdW5jdGlvbnMgaXMgbm90IGVudW1lcmF0ZWQgZHVlIHRvIGNyb3NzLVxuICAgICAgICAgICAgICAvLyBlbnZpcm9ubWVudCBpbmNvbnNpc3RlbmNpZXMuXG4gICAgICAgICAgICAgIGlmICghKGlzRnVuY3Rpb24gJiYgcHJvcGVydHkgPT0gXCJwcm90b3R5cGVcIikgJiYgIWlzUHJvcGVydHkuY2FsbChtZW1iZXJzLCBwcm9wZXJ0eSkgJiYgKG1lbWJlcnNbcHJvcGVydHldID0gMSkgJiYgaXNQcm9wZXJ0eS5jYWxsKG9iamVjdCwgcHJvcGVydHkpKSB7XG4gICAgICAgICAgICAgICAgY2FsbGJhY2socHJvcGVydHkpO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAvLyBObyBidWdzIGRldGVjdGVkOyB1c2UgdGhlIHN0YW5kYXJkIGBmb3IuLi5pbmAgYWxnb3JpdGhtLlxuICAgICAgICAgIGZvckVhY2ggPSBmdW5jdGlvbiAob2JqZWN0LCBjYWxsYmFjaykge1xuICAgICAgICAgICAgdmFyIGlzRnVuY3Rpb24gPSBnZXRDbGFzcy5jYWxsKG9iamVjdCkgPT0gZnVuY3Rpb25DbGFzcywgcHJvcGVydHksIGlzQ29uc3RydWN0b3I7XG4gICAgICAgICAgICBmb3IgKHByb3BlcnR5IGluIG9iamVjdCkge1xuICAgICAgICAgICAgICBpZiAoIShpc0Z1bmN0aW9uICYmIHByb3BlcnR5ID09IFwicHJvdG90eXBlXCIpICYmIGlzUHJvcGVydHkuY2FsbChvYmplY3QsIHByb3BlcnR5KSAmJiAhKGlzQ29uc3RydWN0b3IgPSBwcm9wZXJ0eSA9PT0gXCJjb25zdHJ1Y3RvclwiKSkge1xuICAgICAgICAgICAgICAgIGNhbGxiYWNrKHByb3BlcnR5KTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICAgICAgLy8gTWFudWFsbHkgaW52b2tlIHRoZSBjYWxsYmFjayBmb3IgdGhlIGBjb25zdHJ1Y3RvcmAgcHJvcGVydHkgZHVlIHRvXG4gICAgICAgICAgICAvLyBjcm9zcy1lbnZpcm9ubWVudCBpbmNvbnNpc3RlbmNpZXMuXG4gICAgICAgICAgICBpZiAoaXNDb25zdHJ1Y3RvciB8fCBpc1Byb3BlcnR5LmNhbGwob2JqZWN0LCAocHJvcGVydHkgPSBcImNvbnN0cnVjdG9yXCIpKSkge1xuICAgICAgICAgICAgICBjYWxsYmFjayhwcm9wZXJ0eSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gZm9yRWFjaChvYmplY3QsIGNhbGxiYWNrKTtcbiAgICAgIH07XG5cbiAgICAgIC8vIFB1YmxpYzogU2VyaWFsaXplcyBhIEphdmFTY3JpcHQgYHZhbHVlYCBhcyBhIEpTT04gc3RyaW5nLiBUaGUgb3B0aW9uYWxcbiAgICAgIC8vIGBmaWx0ZXJgIGFyZ3VtZW50IG1heSBzcGVjaWZ5IGVpdGhlciBhIGZ1bmN0aW9uIHRoYXQgYWx0ZXJzIGhvdyBvYmplY3QgYW5kXG4gICAgICAvLyBhcnJheSBtZW1iZXJzIGFyZSBzZXJpYWxpemVkLCBvciBhbiBhcnJheSBvZiBzdHJpbmdzIGFuZCBudW1iZXJzIHRoYXRcbiAgICAgIC8vIGluZGljYXRlcyB3aGljaCBwcm9wZXJ0aWVzIHNob3VsZCBiZSBzZXJpYWxpemVkLiBUaGUgb3B0aW9uYWwgYHdpZHRoYFxuICAgICAgLy8gYXJndW1lbnQgbWF5IGJlIGVpdGhlciBhIHN0cmluZyBvciBudW1iZXIgdGhhdCBzcGVjaWZpZXMgdGhlIGluZGVudGF0aW9uXG4gICAgICAvLyBsZXZlbCBvZiB0aGUgb3V0cHV0LlxuICAgICAgaWYgKCFoYXMoXCJqc29uLXN0cmluZ2lmeVwiKSkge1xuICAgICAgICAvLyBJbnRlcm5hbDogQSBtYXAgb2YgY29udHJvbCBjaGFyYWN0ZXJzIGFuZCB0aGVpciBlc2NhcGVkIGVxdWl2YWxlbnRzLlxuICAgICAgICB2YXIgRXNjYXBlcyA9IHtcbiAgICAgICAgICA5MjogXCJcXFxcXFxcXFwiLFxuICAgICAgICAgIDM0OiAnXFxcXFwiJyxcbiAgICAgICAgICA4OiBcIlxcXFxiXCIsXG4gICAgICAgICAgMTI6IFwiXFxcXGZcIixcbiAgICAgICAgICAxMDogXCJcXFxcblwiLFxuICAgICAgICAgIDEzOiBcIlxcXFxyXCIsXG4gICAgICAgICAgOTogXCJcXFxcdFwiXG4gICAgICAgIH07XG5cbiAgICAgICAgLy8gSW50ZXJuYWw6IENvbnZlcnRzIGB2YWx1ZWAgaW50byBhIHplcm8tcGFkZGVkIHN0cmluZyBzdWNoIHRoYXQgaXRzXG4gICAgICAgIC8vIGxlbmd0aCBpcyBhdCBsZWFzdCBlcXVhbCB0byBgd2lkdGhgLiBUaGUgYHdpZHRoYCBtdXN0IGJlIDw9IDYuXG4gICAgICAgIHZhciBsZWFkaW5nWmVyb2VzID0gXCIwMDAwMDBcIjtcbiAgICAgICAgdmFyIHRvUGFkZGVkU3RyaW5nID0gZnVuY3Rpb24gKHdpZHRoLCB2YWx1ZSkge1xuICAgICAgICAgIC8vIFRoZSBgfHwgMGAgZXhwcmVzc2lvbiBpcyBuZWNlc3NhcnkgdG8gd29yayBhcm91bmQgYSBidWcgaW5cbiAgICAgICAgICAvLyBPcGVyYSA8PSA3LjU0dTIgd2hlcmUgYDAgPT0gLTBgLCBidXQgYFN0cmluZygtMCkgIT09IFwiMFwiYC5cbiAgICAgICAgICByZXR1cm4gKGxlYWRpbmdaZXJvZXMgKyAodmFsdWUgfHwgMCkpLnNsaWNlKC13aWR0aCk7XG4gICAgICAgIH07XG5cbiAgICAgICAgLy8gSW50ZXJuYWw6IERvdWJsZS1xdW90ZXMgYSBzdHJpbmcgYHZhbHVlYCwgcmVwbGFjaW5nIGFsbCBBU0NJSSBjb250cm9sXG4gICAgICAgIC8vIGNoYXJhY3RlcnMgKGNoYXJhY3RlcnMgd2l0aCBjb2RlIHVuaXQgdmFsdWVzIGJldHdlZW4gMCBhbmQgMzEpIHdpdGhcbiAgICAgICAgLy8gdGhlaXIgZXNjYXBlZCBlcXVpdmFsZW50cy4gVGhpcyBpcyBhbiBpbXBsZW1lbnRhdGlvbiBvZiB0aGVcbiAgICAgICAgLy8gYFF1b3RlKHZhbHVlKWAgb3BlcmF0aW9uIGRlZmluZWQgaW4gRVMgNS4xIHNlY3Rpb24gMTUuMTIuMy5cbiAgICAgICAgdmFyIHVuaWNvZGVQcmVmaXggPSBcIlxcXFx1MDBcIjtcbiAgICAgICAgdmFyIHF1b3RlID0gZnVuY3Rpb24gKHZhbHVlKSB7XG4gICAgICAgICAgdmFyIHJlc3VsdCA9ICdcIicsIGluZGV4ID0gMCwgbGVuZ3RoID0gdmFsdWUubGVuZ3RoLCB1c2VDaGFySW5kZXggPSAhY2hhckluZGV4QnVnZ3kgfHwgbGVuZ3RoID4gMTA7XG4gICAgICAgICAgdmFyIHN5bWJvbHMgPSB1c2VDaGFySW5kZXggJiYgKGNoYXJJbmRleEJ1Z2d5ID8gdmFsdWUuc3BsaXQoXCJcIikgOiB2YWx1ZSk7XG4gICAgICAgICAgZm9yICg7IGluZGV4IDwgbGVuZ3RoOyBpbmRleCsrKSB7XG4gICAgICAgICAgICB2YXIgY2hhckNvZGUgPSB2YWx1ZS5jaGFyQ29kZUF0KGluZGV4KTtcbiAgICAgICAgICAgIC8vIElmIHRoZSBjaGFyYWN0ZXIgaXMgYSBjb250cm9sIGNoYXJhY3RlciwgYXBwZW5kIGl0cyBVbmljb2RlIG9yXG4gICAgICAgICAgICAvLyBzaG9ydGhhbmQgZXNjYXBlIHNlcXVlbmNlOyBvdGhlcndpc2UsIGFwcGVuZCB0aGUgY2hhcmFjdGVyIGFzLWlzLlxuICAgICAgICAgICAgc3dpdGNoIChjaGFyQ29kZSkge1xuICAgICAgICAgICAgICBjYXNlIDg6IGNhc2UgOTogY2FzZSAxMDogY2FzZSAxMjogY2FzZSAxMzogY2FzZSAzNDogY2FzZSA5MjpcbiAgICAgICAgICAgICAgICByZXN1bHQgKz0gRXNjYXBlc1tjaGFyQ29kZV07XG4gICAgICAgICAgICAgICAgYnJlYWs7XG4gICAgICAgICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICAgICAgaWYgKGNoYXJDb2RlIDwgMzIpIHtcbiAgICAgICAgICAgICAgICAgIHJlc3VsdCArPSB1bmljb2RlUHJlZml4ICsgdG9QYWRkZWRTdHJpbmcoMiwgY2hhckNvZGUudG9TdHJpbmcoMTYpKTtcbiAgICAgICAgICAgICAgICAgIGJyZWFrO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICByZXN1bHQgKz0gdXNlQ2hhckluZGV4ID8gc3ltYm9sc1tpbmRleF0gOiB2YWx1ZS5jaGFyQXQoaW5kZXgpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgICByZXR1cm4gcmVzdWx0ICsgJ1wiJztcbiAgICAgICAgfTtcblxuICAgICAgICAvLyBJbnRlcm5hbDogUmVjdXJzaXZlbHkgc2VyaWFsaXplcyBhbiBvYmplY3QuIEltcGxlbWVudHMgdGhlXG4gICAgICAgIC8vIGBTdHIoa2V5LCBob2xkZXIpYCwgYEpPKHZhbHVlKWAsIGFuZCBgSkEodmFsdWUpYCBvcGVyYXRpb25zLlxuICAgICAgICB2YXIgc2VyaWFsaXplID0gZnVuY3Rpb24gKHByb3BlcnR5LCBvYmplY3QsIGNhbGxiYWNrLCBwcm9wZXJ0aWVzLCB3aGl0ZXNwYWNlLCBpbmRlbnRhdGlvbiwgc3RhY2spIHtcbiAgICAgICAgICB2YXIgdmFsdWUsIGNsYXNzTmFtZSwgeWVhciwgbW9udGgsIGRhdGUsIHRpbWUsIGhvdXJzLCBtaW51dGVzLCBzZWNvbmRzLCBtaWxsaXNlY29uZHMsIHJlc3VsdHMsIGVsZW1lbnQsIGluZGV4LCBsZW5ndGgsIHByZWZpeCwgcmVzdWx0O1xuICAgICAgICAgIHRyeSB7XG4gICAgICAgICAgICAvLyBOZWNlc3NhcnkgZm9yIGhvc3Qgb2JqZWN0IHN1cHBvcnQuXG4gICAgICAgICAgICB2YWx1ZSA9IG9iamVjdFtwcm9wZXJ0eV07XG4gICAgICAgICAgfSBjYXRjaCAoZXhjZXB0aW9uKSB7fVxuICAgICAgICAgIGlmICh0eXBlb2YgdmFsdWUgPT0gXCJvYmplY3RcIiAmJiB2YWx1ZSkge1xuICAgICAgICAgICAgY2xhc3NOYW1lID0gZ2V0Q2xhc3MuY2FsbCh2YWx1ZSk7XG4gICAgICAgICAgICBpZiAoY2xhc3NOYW1lID09IGRhdGVDbGFzcyAmJiAhaXNQcm9wZXJ0eS5jYWxsKHZhbHVlLCBcInRvSlNPTlwiKSkge1xuICAgICAgICAgICAgICBpZiAodmFsdWUgPiAtMSAvIDAgJiYgdmFsdWUgPCAxIC8gMCkge1xuICAgICAgICAgICAgICAgIC8vIERhdGVzIGFyZSBzZXJpYWxpemVkIGFjY29yZGluZyB0byB0aGUgYERhdGUjdG9KU09OYCBtZXRob2RcbiAgICAgICAgICAgICAgICAvLyBzcGVjaWZpZWQgaW4gRVMgNS4xIHNlY3Rpb24gMTUuOS41LjQ0LiBTZWUgc2VjdGlvbiAxNS45LjEuMTVcbiAgICAgICAgICAgICAgICAvLyBmb3IgdGhlIElTTyA4NjAxIGRhdGUgdGltZSBzdHJpbmcgZm9ybWF0LlxuICAgICAgICAgICAgICAgIGlmIChnZXREYXkpIHtcbiAgICAgICAgICAgICAgICAgIC8vIE1hbnVhbGx5IGNvbXB1dGUgdGhlIHllYXIsIG1vbnRoLCBkYXRlLCBob3VycywgbWludXRlcyxcbiAgICAgICAgICAgICAgICAgIC8vIHNlY29uZHMsIGFuZCBtaWxsaXNlY29uZHMgaWYgdGhlIGBnZXRVVEMqYCBtZXRob2RzIGFyZVxuICAgICAgICAgICAgICAgICAgLy8gYnVnZ3kuIEFkYXB0ZWQgZnJvbSBAWWFmZmxlJ3MgYGRhdGUtc2hpbWAgcHJvamVjdC5cbiAgICAgICAgICAgICAgICAgIGRhdGUgPSBmbG9vcih2YWx1ZSAvIDg2NGU1KTtcbiAgICAgICAgICAgICAgICAgIGZvciAoeWVhciA9IGZsb29yKGRhdGUgLyAzNjUuMjQyNSkgKyAxOTcwIC0gMTsgZ2V0RGF5KHllYXIgKyAxLCAwKSA8PSBkYXRlOyB5ZWFyKyspO1xuICAgICAgICAgICAgICAgICAgZm9yIChtb250aCA9IGZsb29yKChkYXRlIC0gZ2V0RGF5KHllYXIsIDApKSAvIDMwLjQyKTsgZ2V0RGF5KHllYXIsIG1vbnRoICsgMSkgPD0gZGF0ZTsgbW9udGgrKyk7XG4gICAgICAgICAgICAgICAgICBkYXRlID0gMSArIGRhdGUgLSBnZXREYXkoeWVhciwgbW9udGgpO1xuICAgICAgICAgICAgICAgICAgLy8gVGhlIGB0aW1lYCB2YWx1ZSBzcGVjaWZpZXMgdGhlIHRpbWUgd2l0aGluIHRoZSBkYXkgKHNlZSBFU1xuICAgICAgICAgICAgICAgICAgLy8gNS4xIHNlY3Rpb24gMTUuOS4xLjIpLiBUaGUgZm9ybXVsYSBgKEEgJSBCICsgQikgJSBCYCBpcyB1c2VkXG4gICAgICAgICAgICAgICAgICAvLyB0byBjb21wdXRlIGBBIG1vZHVsbyBCYCwgYXMgdGhlIGAlYCBvcGVyYXRvciBkb2VzIG5vdFxuICAgICAgICAgICAgICAgICAgLy8gY29ycmVzcG9uZCB0byB0aGUgYG1vZHVsb2Agb3BlcmF0aW9uIGZvciBuZWdhdGl2ZSBudW1iZXJzLlxuICAgICAgICAgICAgICAgICAgdGltZSA9ICh2YWx1ZSAlIDg2NGU1ICsgODY0ZTUpICUgODY0ZTU7XG4gICAgICAgICAgICAgICAgICAvLyBUaGUgaG91cnMsIG1pbnV0ZXMsIHNlY29uZHMsIGFuZCBtaWxsaXNlY29uZHMgYXJlIG9idGFpbmVkIGJ5XG4gICAgICAgICAgICAgICAgICAvLyBkZWNvbXBvc2luZyB0aGUgdGltZSB3aXRoaW4gdGhlIGRheS4gU2VlIHNlY3Rpb24gMTUuOS4xLjEwLlxuICAgICAgICAgICAgICAgICAgaG91cnMgPSBmbG9vcih0aW1lIC8gMzZlNSkgJSAyNDtcbiAgICAgICAgICAgICAgICAgIG1pbnV0ZXMgPSBmbG9vcih0aW1lIC8gNmU0KSAlIDYwO1xuICAgICAgICAgICAgICAgICAgc2Vjb25kcyA9IGZsb29yKHRpbWUgLyAxZTMpICUgNjA7XG4gICAgICAgICAgICAgICAgICBtaWxsaXNlY29uZHMgPSB0aW1lICUgMWUzO1xuICAgICAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgICAgICB5ZWFyID0gdmFsdWUuZ2V0VVRDRnVsbFllYXIoKTtcbiAgICAgICAgICAgICAgICAgIG1vbnRoID0gdmFsdWUuZ2V0VVRDTW9udGgoKTtcbiAgICAgICAgICAgICAgICAgIGRhdGUgPSB2YWx1ZS5nZXRVVENEYXRlKCk7XG4gICAgICAgICAgICAgICAgICBob3VycyA9IHZhbHVlLmdldFVUQ0hvdXJzKCk7XG4gICAgICAgICAgICAgICAgICBtaW51dGVzID0gdmFsdWUuZ2V0VVRDTWludXRlcygpO1xuICAgICAgICAgICAgICAgICAgc2Vjb25kcyA9IHZhbHVlLmdldFVUQ1NlY29uZHMoKTtcbiAgICAgICAgICAgICAgICAgIG1pbGxpc2Vjb25kcyA9IHZhbHVlLmdldFVUQ01pbGxpc2Vjb25kcygpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAvLyBTZXJpYWxpemUgZXh0ZW5kZWQgeWVhcnMgY29ycmVjdGx5LlxuICAgICAgICAgICAgICAgIHZhbHVlID0gKHllYXIgPD0gMCB8fCB5ZWFyID49IDFlNCA/ICh5ZWFyIDwgMCA/IFwiLVwiIDogXCIrXCIpICsgdG9QYWRkZWRTdHJpbmcoNiwgeWVhciA8IDAgPyAteWVhciA6IHllYXIpIDogdG9QYWRkZWRTdHJpbmcoNCwgeWVhcikpICtcbiAgICAgICAgICAgICAgICAgIFwiLVwiICsgdG9QYWRkZWRTdHJpbmcoMiwgbW9udGggKyAxKSArIFwiLVwiICsgdG9QYWRkZWRTdHJpbmcoMiwgZGF0ZSkgK1xuICAgICAgICAgICAgICAgICAgLy8gTW9udGhzLCBkYXRlcywgaG91cnMsIG1pbnV0ZXMsIGFuZCBzZWNvbmRzIHNob3VsZCBoYXZlIHR3b1xuICAgICAgICAgICAgICAgICAgLy8gZGlnaXRzOyBtaWxsaXNlY29uZHMgc2hvdWxkIGhhdmUgdGhyZWUuXG4gICAgICAgICAgICAgICAgICBcIlRcIiArIHRvUGFkZGVkU3RyaW5nKDIsIGhvdXJzKSArIFwiOlwiICsgdG9QYWRkZWRTdHJpbmcoMiwgbWludXRlcykgKyBcIjpcIiArIHRvUGFkZGVkU3RyaW5nKDIsIHNlY29uZHMpICtcbiAgICAgICAgICAgICAgICAgIC8vIE1pbGxpc2Vjb25kcyBhcmUgb3B0aW9uYWwgaW4gRVMgNS4wLCBidXQgcmVxdWlyZWQgaW4gNS4xLlxuICAgICAgICAgICAgICAgICAgXCIuXCIgKyB0b1BhZGRlZFN0cmluZygzLCBtaWxsaXNlY29uZHMpICsgXCJaXCI7XG4gICAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgICAgdmFsdWUgPSBudWxsO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9IGVsc2UgaWYgKHR5cGVvZiB2YWx1ZS50b0pTT04gPT0gXCJmdW5jdGlvblwiICYmICgoY2xhc3NOYW1lICE9IG51bWJlckNsYXNzICYmIGNsYXNzTmFtZSAhPSBzdHJpbmdDbGFzcyAmJiBjbGFzc05hbWUgIT0gYXJyYXlDbGFzcykgfHwgaXNQcm9wZXJ0eS5jYWxsKHZhbHVlLCBcInRvSlNPTlwiKSkpIHtcbiAgICAgICAgICAgICAgLy8gUHJvdG90eXBlIDw9IDEuNi4xIGFkZHMgbm9uLXN0YW5kYXJkIGB0b0pTT05gIG1ldGhvZHMgdG8gdGhlXG4gICAgICAgICAgICAgIC8vIGBOdW1iZXJgLCBgU3RyaW5nYCwgYERhdGVgLCBhbmQgYEFycmF5YCBwcm90b3R5cGVzLiBKU09OIDNcbiAgICAgICAgICAgICAgLy8gaWdub3JlcyBhbGwgYHRvSlNPTmAgbWV0aG9kcyBvbiB0aGVzZSBvYmplY3RzIHVubGVzcyB0aGV5IGFyZVxuICAgICAgICAgICAgICAvLyBkZWZpbmVkIGRpcmVjdGx5IG9uIGFuIGluc3RhbmNlLlxuICAgICAgICAgICAgICB2YWx1ZSA9IHZhbHVlLnRvSlNPTihwcm9wZXJ0eSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICAgIGlmIChjYWxsYmFjaykge1xuICAgICAgICAgICAgLy8gSWYgYSByZXBsYWNlbWVudCBmdW5jdGlvbiB3YXMgcHJvdmlkZWQsIGNhbGwgaXQgdG8gb2J0YWluIHRoZSB2YWx1ZVxuICAgICAgICAgICAgLy8gZm9yIHNlcmlhbGl6YXRpb24uXG4gICAgICAgICAgICB2YWx1ZSA9IGNhbGxiYWNrLmNhbGwob2JqZWN0LCBwcm9wZXJ0eSwgdmFsdWUpO1xuICAgICAgICAgIH1cbiAgICAgICAgICBpZiAodmFsdWUgPT09IG51bGwpIHtcbiAgICAgICAgICAgIHJldHVybiBcIm51bGxcIjtcbiAgICAgICAgICB9XG4gICAgICAgICAgY2xhc3NOYW1lID0gZ2V0Q2xhc3MuY2FsbCh2YWx1ZSk7XG4gICAgICAgICAgaWYgKGNsYXNzTmFtZSA9PSBib29sZWFuQ2xhc3MpIHtcbiAgICAgICAgICAgIC8vIEJvb2xlYW5zIGFyZSByZXByZXNlbnRlZCBsaXRlcmFsbHkuXG4gICAgICAgICAgICByZXR1cm4gXCJcIiArIHZhbHVlO1xuICAgICAgICAgIH0gZWxzZSBpZiAoY2xhc3NOYW1lID09IG51bWJlckNsYXNzKSB7XG4gICAgICAgICAgICAvLyBKU09OIG51bWJlcnMgbXVzdCBiZSBmaW5pdGUuIGBJbmZpbml0eWAgYW5kIGBOYU5gIGFyZSBzZXJpYWxpemVkIGFzXG4gICAgICAgICAgICAvLyBgXCJudWxsXCJgLlxuICAgICAgICAgICAgcmV0dXJuIHZhbHVlID4gLTEgLyAwICYmIHZhbHVlIDwgMSAvIDAgPyBcIlwiICsgdmFsdWUgOiBcIm51bGxcIjtcbiAgICAgICAgICB9IGVsc2UgaWYgKGNsYXNzTmFtZSA9PSBzdHJpbmdDbGFzcykge1xuICAgICAgICAgICAgLy8gU3RyaW5ncyBhcmUgZG91YmxlLXF1b3RlZCBhbmQgZXNjYXBlZC5cbiAgICAgICAgICAgIHJldHVybiBxdW90ZShcIlwiICsgdmFsdWUpO1xuICAgICAgICAgIH1cbiAgICAgICAgICAvLyBSZWN1cnNpdmVseSBzZXJpYWxpemUgb2JqZWN0cyBhbmQgYXJyYXlzLlxuICAgICAgICAgIGlmICh0eXBlb2YgdmFsdWUgPT0gXCJvYmplY3RcIikge1xuICAgICAgICAgICAgLy8gQ2hlY2sgZm9yIGN5Y2xpYyBzdHJ1Y3R1cmVzLiBUaGlzIGlzIGEgbGluZWFyIHNlYXJjaDsgcGVyZm9ybWFuY2VcbiAgICAgICAgICAgIC8vIGlzIGludmVyc2VseSBwcm9wb3J0aW9uYWwgdG8gdGhlIG51bWJlciBvZiB1bmlxdWUgbmVzdGVkIG9iamVjdHMuXG4gICAgICAgICAgICBmb3IgKGxlbmd0aCA9IHN0YWNrLmxlbmd0aDsgbGVuZ3RoLS07KSB7XG4gICAgICAgICAgICAgIGlmIChzdGFja1tsZW5ndGhdID09PSB2YWx1ZSkge1xuICAgICAgICAgICAgICAgIC8vIEN5Y2xpYyBzdHJ1Y3R1cmVzIGNhbm5vdCBiZSBzZXJpYWxpemVkIGJ5IGBKU09OLnN0cmluZ2lmeWAuXG4gICAgICAgICAgICAgICAgdGhyb3cgVHlwZUVycm9yKCk7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIC8vIEFkZCB0aGUgb2JqZWN0IHRvIHRoZSBzdGFjayBvZiB0cmF2ZXJzZWQgb2JqZWN0cy5cbiAgICAgICAgICAgIHN0YWNrLnB1c2godmFsdWUpO1xuICAgICAgICAgICAgcmVzdWx0cyA9IFtdO1xuICAgICAgICAgICAgLy8gU2F2ZSB0aGUgY3VycmVudCBpbmRlbnRhdGlvbiBsZXZlbCBhbmQgaW5kZW50IG9uZSBhZGRpdGlvbmFsIGxldmVsLlxuICAgICAgICAgICAgcHJlZml4ID0gaW5kZW50YXRpb247XG4gICAgICAgICAgICBpbmRlbnRhdGlvbiArPSB3aGl0ZXNwYWNlO1xuICAgICAgICAgICAgaWYgKGNsYXNzTmFtZSA9PSBhcnJheUNsYXNzKSB7XG4gICAgICAgICAgICAgIC8vIFJlY3Vyc2l2ZWx5IHNlcmlhbGl6ZSBhcnJheSBlbGVtZW50cy5cbiAgICAgICAgICAgICAgZm9yIChpbmRleCA9IDAsIGxlbmd0aCA9IHZhbHVlLmxlbmd0aDsgaW5kZXggPCBsZW5ndGg7IGluZGV4KyspIHtcbiAgICAgICAgICAgICAgICBlbGVtZW50ID0gc2VyaWFsaXplKGluZGV4LCB2YWx1ZSwgY2FsbGJhY2ssIHByb3BlcnRpZXMsIHdoaXRlc3BhY2UsIGluZGVudGF0aW9uLCBzdGFjayk7XG4gICAgICAgICAgICAgICAgcmVzdWx0cy5wdXNoKGVsZW1lbnQgPT09IHVuZGVmID8gXCJudWxsXCIgOiBlbGVtZW50KTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICByZXN1bHQgPSByZXN1bHRzLmxlbmd0aCA/ICh3aGl0ZXNwYWNlID8gXCJbXFxuXCIgKyBpbmRlbnRhdGlvbiArIHJlc3VsdHMuam9pbihcIixcXG5cIiArIGluZGVudGF0aW9uKSArIFwiXFxuXCIgKyBwcmVmaXggKyBcIl1cIiA6IChcIltcIiArIHJlc3VsdHMuam9pbihcIixcIikgKyBcIl1cIikpIDogXCJbXVwiO1xuICAgICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgICAgLy8gUmVjdXJzaXZlbHkgc2VyaWFsaXplIG9iamVjdCBtZW1iZXJzLiBNZW1iZXJzIGFyZSBzZWxlY3RlZCBmcm9tXG4gICAgICAgICAgICAgIC8vIGVpdGhlciBhIHVzZXItc3BlY2lmaWVkIGxpc3Qgb2YgcHJvcGVydHkgbmFtZXMsIG9yIHRoZSBvYmplY3RcbiAgICAgICAgICAgICAgLy8gaXRzZWxmLlxuICAgICAgICAgICAgICBmb3JFYWNoKHByb3BlcnRpZXMgfHwgdmFsdWUsIGZ1bmN0aW9uIChwcm9wZXJ0eSkge1xuICAgICAgICAgICAgICAgIHZhciBlbGVtZW50ID0gc2VyaWFsaXplKHByb3BlcnR5LCB2YWx1ZSwgY2FsbGJhY2ssIHByb3BlcnRpZXMsIHdoaXRlc3BhY2UsIGluZGVudGF0aW9uLCBzdGFjayk7XG4gICAgICAgICAgICAgICAgaWYgKGVsZW1lbnQgIT09IHVuZGVmKSB7XG4gICAgICAgICAgICAgICAgICAvLyBBY2NvcmRpbmcgdG8gRVMgNS4xIHNlY3Rpb24gMTUuMTIuMzogXCJJZiBgZ2FwYCB7d2hpdGVzcGFjZX1cbiAgICAgICAgICAgICAgICAgIC8vIGlzIG5vdCB0aGUgZW1wdHkgc3RyaW5nLCBsZXQgYG1lbWJlcmAge3F1b3RlKHByb3BlcnR5KSArIFwiOlwifVxuICAgICAgICAgICAgICAgICAgLy8gYmUgdGhlIGNvbmNhdGVuYXRpb24gb2YgYG1lbWJlcmAgYW5kIHRoZSBgc3BhY2VgIGNoYXJhY3Rlci5cIlxuICAgICAgICAgICAgICAgICAgLy8gVGhlIFwiYHNwYWNlYCBjaGFyYWN0ZXJcIiByZWZlcnMgdG8gdGhlIGxpdGVyYWwgc3BhY2VcbiAgICAgICAgICAgICAgICAgIC8vIGNoYXJhY3Rlciwgbm90IHRoZSBgc3BhY2VgIHt3aWR0aH0gYXJndW1lbnQgcHJvdmlkZWQgdG9cbiAgICAgICAgICAgICAgICAgIC8vIGBKU09OLnN0cmluZ2lmeWAuXG4gICAgICAgICAgICAgICAgICByZXN1bHRzLnB1c2gocXVvdGUocHJvcGVydHkpICsgXCI6XCIgKyAod2hpdGVzcGFjZSA/IFwiIFwiIDogXCJcIikgKyBlbGVtZW50KTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgICByZXN1bHQgPSByZXN1bHRzLmxlbmd0aCA/ICh3aGl0ZXNwYWNlID8gXCJ7XFxuXCIgKyBpbmRlbnRhdGlvbiArIHJlc3VsdHMuam9pbihcIixcXG5cIiArIGluZGVudGF0aW9uKSArIFwiXFxuXCIgKyBwcmVmaXggKyBcIn1cIiA6IChcIntcIiArIHJlc3VsdHMuam9pbihcIixcIikgKyBcIn1cIikpIDogXCJ7fVwiO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgLy8gUmVtb3ZlIHRoZSBvYmplY3QgZnJvbSB0aGUgdHJhdmVyc2VkIG9iamVjdCBzdGFjay5cbiAgICAgICAgICAgIHN0YWNrLnBvcCgpO1xuICAgICAgICAgICAgcmV0dXJuIHJlc3VsdDtcbiAgICAgICAgICB9XG4gICAgICAgIH07XG5cbiAgICAgICAgLy8gUHVibGljOiBgSlNPTi5zdHJpbmdpZnlgLiBTZWUgRVMgNS4xIHNlY3Rpb24gMTUuMTIuMy5cbiAgICAgICAgZXhwb3J0cy5zdHJpbmdpZnkgPSBmdW5jdGlvbiAoc291cmNlLCBmaWx0ZXIsIHdpZHRoKSB7XG4gICAgICAgICAgdmFyIHdoaXRlc3BhY2UsIGNhbGxiYWNrLCBwcm9wZXJ0aWVzLCBjbGFzc05hbWU7XG4gICAgICAgICAgaWYgKG9iamVjdFR5cGVzW3R5cGVvZiBmaWx0ZXJdICYmIGZpbHRlcikge1xuICAgICAgICAgICAgaWYgKChjbGFzc05hbWUgPSBnZXRDbGFzcy5jYWxsKGZpbHRlcikpID09IGZ1bmN0aW9uQ2xhc3MpIHtcbiAgICAgICAgICAgICAgY2FsbGJhY2sgPSBmaWx0ZXI7XG4gICAgICAgICAgICB9IGVsc2UgaWYgKGNsYXNzTmFtZSA9PSBhcnJheUNsYXNzKSB7XG4gICAgICAgICAgICAgIC8vIENvbnZlcnQgdGhlIHByb3BlcnR5IG5hbWVzIGFycmF5IGludG8gYSBtYWtlc2hpZnQgc2V0LlxuICAgICAgICAgICAgICBwcm9wZXJ0aWVzID0ge307XG4gICAgICAgICAgICAgIGZvciAodmFyIGluZGV4ID0gMCwgbGVuZ3RoID0gZmlsdGVyLmxlbmd0aCwgdmFsdWU7IGluZGV4IDwgbGVuZ3RoOyB2YWx1ZSA9IGZpbHRlcltpbmRleCsrXSwgKChjbGFzc05hbWUgPSBnZXRDbGFzcy5jYWxsKHZhbHVlKSksIGNsYXNzTmFtZSA9PSBzdHJpbmdDbGFzcyB8fCBjbGFzc05hbWUgPT0gbnVtYmVyQ2xhc3MpICYmIChwcm9wZXJ0aWVzW3ZhbHVlXSA9IDEpKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgICAgaWYgKHdpZHRoKSB7XG4gICAgICAgICAgICBpZiAoKGNsYXNzTmFtZSA9IGdldENsYXNzLmNhbGwod2lkdGgpKSA9PSBudW1iZXJDbGFzcykge1xuICAgICAgICAgICAgICAvLyBDb252ZXJ0IHRoZSBgd2lkdGhgIHRvIGFuIGludGVnZXIgYW5kIGNyZWF0ZSBhIHN0cmluZyBjb250YWluaW5nXG4gICAgICAgICAgICAgIC8vIGB3aWR0aGAgbnVtYmVyIG9mIHNwYWNlIGNoYXJhY3RlcnMuXG4gICAgICAgICAgICAgIGlmICgod2lkdGggLT0gd2lkdGggJSAxKSA+IDApIHtcbiAgICAgICAgICAgICAgICBmb3IgKHdoaXRlc3BhY2UgPSBcIlwiLCB3aWR0aCA+IDEwICYmICh3aWR0aCA9IDEwKTsgd2hpdGVzcGFjZS5sZW5ndGggPCB3aWR0aDsgd2hpdGVzcGFjZSArPSBcIiBcIik7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH0gZWxzZSBpZiAoY2xhc3NOYW1lID09IHN0cmluZ0NsYXNzKSB7XG4gICAgICAgICAgICAgIHdoaXRlc3BhY2UgPSB3aWR0aC5sZW5ndGggPD0gMTAgPyB3aWR0aCA6IHdpZHRoLnNsaWNlKDAsIDEwKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgICAgLy8gT3BlcmEgPD0gNy41NHUyIGRpc2NhcmRzIHRoZSB2YWx1ZXMgYXNzb2NpYXRlZCB3aXRoIGVtcHR5IHN0cmluZyBrZXlzXG4gICAgICAgICAgLy8gKGBcIlwiYCkgb25seSBpZiB0aGV5IGFyZSB1c2VkIGRpcmVjdGx5IHdpdGhpbiBhbiBvYmplY3QgbWVtYmVyIGxpc3RcbiAgICAgICAgICAvLyAoZS5nLiwgYCEoXCJcIiBpbiB7IFwiXCI6IDF9KWApLlxuICAgICAgICAgIHJldHVybiBzZXJpYWxpemUoXCJcIiwgKHZhbHVlID0ge30sIHZhbHVlW1wiXCJdID0gc291cmNlLCB2YWx1ZSksIGNhbGxiYWNrLCBwcm9wZXJ0aWVzLCB3aGl0ZXNwYWNlLCBcIlwiLCBbXSk7XG4gICAgICAgIH07XG4gICAgICB9XG5cbiAgICAgIC8vIFB1YmxpYzogUGFyc2VzIGEgSlNPTiBzb3VyY2Ugc3RyaW5nLlxuICAgICAgaWYgKCFoYXMoXCJqc29uLXBhcnNlXCIpKSB7XG4gICAgICAgIHZhciBmcm9tQ2hhckNvZGUgPSBTdHJpbmcuZnJvbUNoYXJDb2RlO1xuXG4gICAgICAgIC8vIEludGVybmFsOiBBIG1hcCBvZiBlc2NhcGVkIGNvbnRyb2wgY2hhcmFjdGVycyBhbmQgdGhlaXIgdW5lc2NhcGVkXG4gICAgICAgIC8vIGVxdWl2YWxlbnRzLlxuICAgICAgICB2YXIgVW5lc2NhcGVzID0ge1xuICAgICAgICAgIDkyOiBcIlxcXFxcIixcbiAgICAgICAgICAzNDogJ1wiJyxcbiAgICAgICAgICA0NzogXCIvXCIsXG4gICAgICAgICAgOTg6IFwiXFxiXCIsXG4gICAgICAgICAgMTE2OiBcIlxcdFwiLFxuICAgICAgICAgIDExMDogXCJcXG5cIixcbiAgICAgICAgICAxMDI6IFwiXFxmXCIsXG4gICAgICAgICAgMTE0OiBcIlxcclwiXG4gICAgICAgIH07XG5cbiAgICAgICAgLy8gSW50ZXJuYWw6IFN0b3JlcyB0aGUgcGFyc2VyIHN0YXRlLlxuICAgICAgICB2YXIgSW5kZXgsIFNvdXJjZTtcblxuICAgICAgICAvLyBJbnRlcm5hbDogUmVzZXRzIHRoZSBwYXJzZXIgc3RhdGUgYW5kIHRocm93cyBhIGBTeW50YXhFcnJvcmAuXG4gICAgICAgIHZhciBhYm9ydCA9IGZ1bmN0aW9uICgpIHtcbiAgICAgICAgICBJbmRleCA9IFNvdXJjZSA9IG51bGw7XG4gICAgICAgICAgdGhyb3cgU3ludGF4RXJyb3IoKTtcbiAgICAgICAgfTtcblxuICAgICAgICAvLyBJbnRlcm5hbDogUmV0dXJucyB0aGUgbmV4dCB0b2tlbiwgb3IgYFwiJFwiYCBpZiB0aGUgcGFyc2VyIGhhcyByZWFjaGVkXG4gICAgICAgIC8vIHRoZSBlbmQgb2YgdGhlIHNvdXJjZSBzdHJpbmcuIEEgdG9rZW4gbWF5IGJlIGEgc3RyaW5nLCBudW1iZXIsIGBudWxsYFxuICAgICAgICAvLyBsaXRlcmFsLCBvciBCb29sZWFuIGxpdGVyYWwuXG4gICAgICAgIHZhciBsZXggPSBmdW5jdGlvbiAoKSB7XG4gICAgICAgICAgdmFyIHNvdXJjZSA9IFNvdXJjZSwgbGVuZ3RoID0gc291cmNlLmxlbmd0aCwgdmFsdWUsIGJlZ2luLCBwb3NpdGlvbiwgaXNTaWduZWQsIGNoYXJDb2RlO1xuICAgICAgICAgIHdoaWxlIChJbmRleCA8IGxlbmd0aCkge1xuICAgICAgICAgICAgY2hhckNvZGUgPSBzb3VyY2UuY2hhckNvZGVBdChJbmRleCk7XG4gICAgICAgICAgICBzd2l0Y2ggKGNoYXJDb2RlKSB7XG4gICAgICAgICAgICAgIGNhc2UgOTogY2FzZSAxMDogY2FzZSAxMzogY2FzZSAzMjpcbiAgICAgICAgICAgICAgICAvLyBTa2lwIHdoaXRlc3BhY2UgdG9rZW5zLCBpbmNsdWRpbmcgdGFicywgY2FycmlhZ2UgcmV0dXJucywgbGluZVxuICAgICAgICAgICAgICAgIC8vIGZlZWRzLCBhbmQgc3BhY2UgY2hhcmFjdGVycy5cbiAgICAgICAgICAgICAgICBJbmRleCsrO1xuICAgICAgICAgICAgICAgIGJyZWFrO1xuICAgICAgICAgICAgICBjYXNlIDEyMzogY2FzZSAxMjU6IGNhc2UgOTE6IGNhc2UgOTM6IGNhc2UgNTg6IGNhc2UgNDQ6XG4gICAgICAgICAgICAgICAgLy8gUGFyc2UgYSBwdW5jdHVhdG9yIHRva2VuIChge2AsIGB9YCwgYFtgLCBgXWAsIGA6YCwgb3IgYCxgKSBhdFxuICAgICAgICAgICAgICAgIC8vIHRoZSBjdXJyZW50IHBvc2l0aW9uLlxuICAgICAgICAgICAgICAgIHZhbHVlID0gY2hhckluZGV4QnVnZ3kgPyBzb3VyY2UuY2hhckF0KEluZGV4KSA6IHNvdXJjZVtJbmRleF07XG4gICAgICAgICAgICAgICAgSW5kZXgrKztcbiAgICAgICAgICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgICAgICAgICAgIGNhc2UgMzQ6XG4gICAgICAgICAgICAgICAgLy8gYFwiYCBkZWxpbWl0cyBhIEpTT04gc3RyaW5nOyBhZHZhbmNlIHRvIHRoZSBuZXh0IGNoYXJhY3RlciBhbmRcbiAgICAgICAgICAgICAgICAvLyBiZWdpbiBwYXJzaW5nIHRoZSBzdHJpbmcuIFN0cmluZyB0b2tlbnMgYXJlIHByZWZpeGVkIHdpdGggdGhlXG4gICAgICAgICAgICAgICAgLy8gc2VudGluZWwgYEBgIGNoYXJhY3RlciB0byBkaXN0aW5ndWlzaCB0aGVtIGZyb20gcHVuY3R1YXRvcnMgYW5kXG4gICAgICAgICAgICAgICAgLy8gZW5kLW9mLXN0cmluZyB0b2tlbnMuXG4gICAgICAgICAgICAgICAgZm9yICh2YWx1ZSA9IFwiQFwiLCBJbmRleCsrOyBJbmRleCA8IGxlbmd0aDspIHtcbiAgICAgICAgICAgICAgICAgIGNoYXJDb2RlID0gc291cmNlLmNoYXJDb2RlQXQoSW5kZXgpO1xuICAgICAgICAgICAgICAgICAgaWYgKGNoYXJDb2RlIDwgMzIpIHtcbiAgICAgICAgICAgICAgICAgICAgLy8gVW5lc2NhcGVkIEFTQ0lJIGNvbnRyb2wgY2hhcmFjdGVycyAodGhvc2Ugd2l0aCBhIGNvZGUgdW5pdFxuICAgICAgICAgICAgICAgICAgICAvLyBsZXNzIHRoYW4gdGhlIHNwYWNlIGNoYXJhY3RlcikgYXJlIG5vdCBwZXJtaXR0ZWQuXG4gICAgICAgICAgICAgICAgICAgIGFib3J0KCk7XG4gICAgICAgICAgICAgICAgICB9IGVsc2UgaWYgKGNoYXJDb2RlID09IDkyKSB7XG4gICAgICAgICAgICAgICAgICAgIC8vIEEgcmV2ZXJzZSBzb2xpZHVzIChgXFxgKSBtYXJrcyB0aGUgYmVnaW5uaW5nIG9mIGFuIGVzY2FwZWRcbiAgICAgICAgICAgICAgICAgICAgLy8gY29udHJvbCBjaGFyYWN0ZXIgKGluY2x1ZGluZyBgXCJgLCBgXFxgLCBhbmQgYC9gKSBvciBVbmljb2RlXG4gICAgICAgICAgICAgICAgICAgIC8vIGVzY2FwZSBzZXF1ZW5jZS5cbiAgICAgICAgICAgICAgICAgICAgY2hhckNvZGUgPSBzb3VyY2UuY2hhckNvZGVBdCgrK0luZGV4KTtcbiAgICAgICAgICAgICAgICAgICAgc3dpdGNoIChjaGFyQ29kZSkge1xuICAgICAgICAgICAgICAgICAgICAgIGNhc2UgOTI6IGNhc2UgMzQ6IGNhc2UgNDc6IGNhc2UgOTg6IGNhc2UgMTE2OiBjYXNlIDExMDogY2FzZSAxMDI6IGNhc2UgMTE0OlxuICAgICAgICAgICAgICAgICAgICAgICAgLy8gUmV2aXZlIGVzY2FwZWQgY29udHJvbCBjaGFyYWN0ZXJzLlxuICAgICAgICAgICAgICAgICAgICAgICAgdmFsdWUgKz0gVW5lc2NhcGVzW2NoYXJDb2RlXTtcbiAgICAgICAgICAgICAgICAgICAgICAgIEluZGV4Kys7XG4gICAgICAgICAgICAgICAgICAgICAgICBicmVhaztcbiAgICAgICAgICAgICAgICAgICAgICBjYXNlIDExNzpcbiAgICAgICAgICAgICAgICAgICAgICAgIC8vIGBcXHVgIG1hcmtzIHRoZSBiZWdpbm5pbmcgb2YgYSBVbmljb2RlIGVzY2FwZSBzZXF1ZW5jZS5cbiAgICAgICAgICAgICAgICAgICAgICAgIC8vIEFkdmFuY2UgdG8gdGhlIGZpcnN0IGNoYXJhY3RlciBhbmQgdmFsaWRhdGUgdGhlXG4gICAgICAgICAgICAgICAgICAgICAgICAvLyBmb3VyLWRpZ2l0IGNvZGUgcG9pbnQuXG4gICAgICAgICAgICAgICAgICAgICAgICBiZWdpbiA9ICsrSW5kZXg7XG4gICAgICAgICAgICAgICAgICAgICAgICBmb3IgKHBvc2l0aW9uID0gSW5kZXggKyA0OyBJbmRleCA8IHBvc2l0aW9uOyBJbmRleCsrKSB7XG4gICAgICAgICAgICAgICAgICAgICAgICAgIGNoYXJDb2RlID0gc291cmNlLmNoYXJDb2RlQXQoSW5kZXgpO1xuICAgICAgICAgICAgICAgICAgICAgICAgICAvLyBBIHZhbGlkIHNlcXVlbmNlIGNvbXByaXNlcyBmb3VyIGhleGRpZ2l0cyAoY2FzZS1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgLy8gaW5zZW5zaXRpdmUpIHRoYXQgZm9ybSBhIHNpbmdsZSBoZXhhZGVjaW1hbCB2YWx1ZS5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgaWYgKCEoY2hhckNvZGUgPj0gNDggJiYgY2hhckNvZGUgPD0gNTcgfHwgY2hhckNvZGUgPj0gOTcgJiYgY2hhckNvZGUgPD0gMTAyIHx8IGNoYXJDb2RlID49IDY1ICYmIGNoYXJDb2RlIDw9IDcwKSkge1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgIC8vIEludmFsaWQgVW5pY29kZSBlc2NhcGUgc2VxdWVuY2UuXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgYWJvcnQoKTtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICAgICAgLy8gUmV2aXZlIHRoZSBlc2NhcGVkIGNoYXJhY3Rlci5cbiAgICAgICAgICAgICAgICAgICAgICAgIHZhbHVlICs9IGZyb21DaGFyQ29kZShcIjB4XCIgKyBzb3VyY2Uuc2xpY2UoYmVnaW4sIEluZGV4KSk7XG4gICAgICAgICAgICAgICAgICAgICAgICBicmVhaztcbiAgICAgICAgICAgICAgICAgICAgICBkZWZhdWx0OlxuICAgICAgICAgICAgICAgICAgICAgICAgLy8gSW52YWxpZCBlc2NhcGUgc2VxdWVuY2UuXG4gICAgICAgICAgICAgICAgICAgICAgICBhYm9ydCgpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICAgICAgICBpZiAoY2hhckNvZGUgPT0gMzQpIHtcbiAgICAgICAgICAgICAgICAgICAgICAvLyBBbiB1bmVzY2FwZWQgZG91YmxlLXF1b3RlIGNoYXJhY3RlciBtYXJrcyB0aGUgZW5kIG9mIHRoZVxuICAgICAgICAgICAgICAgICAgICAgIC8vIHN0cmluZy5cbiAgICAgICAgICAgICAgICAgICAgICBicmVhaztcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICBjaGFyQ29kZSA9IHNvdXJjZS5jaGFyQ29kZUF0KEluZGV4KTtcbiAgICAgICAgICAgICAgICAgICAgYmVnaW4gPSBJbmRleDtcbiAgICAgICAgICAgICAgICAgICAgLy8gT3B0aW1pemUgZm9yIHRoZSBjb21tb24gY2FzZSB3aGVyZSBhIHN0cmluZyBpcyB2YWxpZC5cbiAgICAgICAgICAgICAgICAgICAgd2hpbGUgKGNoYXJDb2RlID49IDMyICYmIGNoYXJDb2RlICE9IDkyICYmIGNoYXJDb2RlICE9IDM0KSB7XG4gICAgICAgICAgICAgICAgICAgICAgY2hhckNvZGUgPSBzb3VyY2UuY2hhckNvZGVBdCgrK0luZGV4KTtcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICAvLyBBcHBlbmQgdGhlIHN0cmluZyBhcy1pcy5cbiAgICAgICAgICAgICAgICAgICAgdmFsdWUgKz0gc291cmNlLnNsaWNlKGJlZ2luLCBJbmRleCk7XG4gICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGlmIChzb3VyY2UuY2hhckNvZGVBdChJbmRleCkgPT0gMzQpIHtcbiAgICAgICAgICAgICAgICAgIC8vIEFkdmFuY2UgdG8gdGhlIG5leHQgY2hhcmFjdGVyIGFuZCByZXR1cm4gdGhlIHJldml2ZWQgc3RyaW5nLlxuICAgICAgICAgICAgICAgICAgSW5kZXgrKztcbiAgICAgICAgICAgICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgLy8gVW50ZXJtaW5hdGVkIHN0cmluZy5cbiAgICAgICAgICAgICAgICBhYm9ydCgpO1xuICAgICAgICAgICAgICBkZWZhdWx0OlxuICAgICAgICAgICAgICAgIC8vIFBhcnNlIG51bWJlcnMgYW5kIGxpdGVyYWxzLlxuICAgICAgICAgICAgICAgIGJlZ2luID0gSW5kZXg7XG4gICAgICAgICAgICAgICAgLy8gQWR2YW5jZSBwYXN0IHRoZSBuZWdhdGl2ZSBzaWduLCBpZiBvbmUgaXMgc3BlY2lmaWVkLlxuICAgICAgICAgICAgICAgIGlmIChjaGFyQ29kZSA9PSA0NSkge1xuICAgICAgICAgICAgICAgICAgaXNTaWduZWQgPSB0cnVlO1xuICAgICAgICAgICAgICAgICAgY2hhckNvZGUgPSBzb3VyY2UuY2hhckNvZGVBdCgrK0luZGV4KTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgLy8gUGFyc2UgYW4gaW50ZWdlciBvciBmbG9hdGluZy1wb2ludCB2YWx1ZS5cbiAgICAgICAgICAgICAgICBpZiAoY2hhckNvZGUgPj0gNDggJiYgY2hhckNvZGUgPD0gNTcpIHtcbiAgICAgICAgICAgICAgICAgIC8vIExlYWRpbmcgemVyb2VzIGFyZSBpbnRlcnByZXRlZCBhcyBvY3RhbCBsaXRlcmFscy5cbiAgICAgICAgICAgICAgICAgIGlmIChjaGFyQ29kZSA9PSA0OCAmJiAoKGNoYXJDb2RlID0gc291cmNlLmNoYXJDb2RlQXQoSW5kZXggKyAxKSksIGNoYXJDb2RlID49IDQ4ICYmIGNoYXJDb2RlIDw9IDU3KSkge1xuICAgICAgICAgICAgICAgICAgICAvLyBJbGxlZ2FsIG9jdGFsIGxpdGVyYWwuXG4gICAgICAgICAgICAgICAgICAgIGFib3J0KCk7XG4gICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICBpc1NpZ25lZCA9IGZhbHNlO1xuICAgICAgICAgICAgICAgICAgLy8gUGFyc2UgdGhlIGludGVnZXIgY29tcG9uZW50LlxuICAgICAgICAgICAgICAgICAgZm9yICg7IEluZGV4IDwgbGVuZ3RoICYmICgoY2hhckNvZGUgPSBzb3VyY2UuY2hhckNvZGVBdChJbmRleCkpLCBjaGFyQ29kZSA+PSA0OCAmJiBjaGFyQ29kZSA8PSA1Nyk7IEluZGV4KyspO1xuICAgICAgICAgICAgICAgICAgLy8gRmxvYXRzIGNhbm5vdCBjb250YWluIGEgbGVhZGluZyBkZWNpbWFsIHBvaW50OyBob3dldmVyLCB0aGlzXG4gICAgICAgICAgICAgICAgICAvLyBjYXNlIGlzIGFscmVhZHkgYWNjb3VudGVkIGZvciBieSB0aGUgcGFyc2VyLlxuICAgICAgICAgICAgICAgICAgaWYgKHNvdXJjZS5jaGFyQ29kZUF0KEluZGV4KSA9PSA0Nikge1xuICAgICAgICAgICAgICAgICAgICBwb3NpdGlvbiA9ICsrSW5kZXg7XG4gICAgICAgICAgICAgICAgICAgIC8vIFBhcnNlIHRoZSBkZWNpbWFsIGNvbXBvbmVudC5cbiAgICAgICAgICAgICAgICAgICAgZm9yICg7IHBvc2l0aW9uIDwgbGVuZ3RoICYmICgoY2hhckNvZGUgPSBzb3VyY2UuY2hhckNvZGVBdChwb3NpdGlvbikpLCBjaGFyQ29kZSA+PSA0OCAmJiBjaGFyQ29kZSA8PSA1Nyk7IHBvc2l0aW9uKyspO1xuICAgICAgICAgICAgICAgICAgICBpZiAocG9zaXRpb24gPT0gSW5kZXgpIHtcbiAgICAgICAgICAgICAgICAgICAgICAvLyBJbGxlZ2FsIHRyYWlsaW5nIGRlY2ltYWwuXG4gICAgICAgICAgICAgICAgICAgICAgYWJvcnQoKTtcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICBJbmRleCA9IHBvc2l0aW9uO1xuICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgLy8gUGFyc2UgZXhwb25lbnRzLiBUaGUgYGVgIGRlbm90aW5nIHRoZSBleHBvbmVudCBpc1xuICAgICAgICAgICAgICAgICAgLy8gY2FzZS1pbnNlbnNpdGl2ZS5cbiAgICAgICAgICAgICAgICAgIGNoYXJDb2RlID0gc291cmNlLmNoYXJDb2RlQXQoSW5kZXgpO1xuICAgICAgICAgICAgICAgICAgaWYgKGNoYXJDb2RlID09IDEwMSB8fCBjaGFyQ29kZSA9PSA2OSkge1xuICAgICAgICAgICAgICAgICAgICBjaGFyQ29kZSA9IHNvdXJjZS5jaGFyQ29kZUF0KCsrSW5kZXgpO1xuICAgICAgICAgICAgICAgICAgICAvLyBTa2lwIHBhc3QgdGhlIHNpZ24gZm9sbG93aW5nIHRoZSBleHBvbmVudCwgaWYgb25lIGlzXG4gICAgICAgICAgICAgICAgICAgIC8vIHNwZWNpZmllZC5cbiAgICAgICAgICAgICAgICAgICAgaWYgKGNoYXJDb2RlID09IDQzIHx8IGNoYXJDb2RlID09IDQ1KSB7XG4gICAgICAgICAgICAgICAgICAgICAgSW5kZXgrKztcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICAvLyBQYXJzZSB0aGUgZXhwb25lbnRpYWwgY29tcG9uZW50LlxuICAgICAgICAgICAgICAgICAgICBmb3IgKHBvc2l0aW9uID0gSW5kZXg7IHBvc2l0aW9uIDwgbGVuZ3RoICYmICgoY2hhckNvZGUgPSBzb3VyY2UuY2hhckNvZGVBdChwb3NpdGlvbikpLCBjaGFyQ29kZSA+PSA0OCAmJiBjaGFyQ29kZSA8PSA1Nyk7IHBvc2l0aW9uKyspO1xuICAgICAgICAgICAgICAgICAgICBpZiAocG9zaXRpb24gPT0gSW5kZXgpIHtcbiAgICAgICAgICAgICAgICAgICAgICAvLyBJbGxlZ2FsIGVtcHR5IGV4cG9uZW50LlxuICAgICAgICAgICAgICAgICAgICAgIGFib3J0KCk7XG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAgICAgSW5kZXggPSBwb3NpdGlvbjtcbiAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAgIC8vIENvZXJjZSB0aGUgcGFyc2VkIHZhbHVlIHRvIGEgSmF2YVNjcmlwdCBudW1iZXIuXG4gICAgICAgICAgICAgICAgICByZXR1cm4gK3NvdXJjZS5zbGljZShiZWdpbiwgSW5kZXgpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAvLyBBIG5lZ2F0aXZlIHNpZ24gbWF5IG9ubHkgcHJlY2VkZSBudW1iZXJzLlxuICAgICAgICAgICAgICAgIGlmIChpc1NpZ25lZCkge1xuICAgICAgICAgICAgICAgICAgYWJvcnQoKTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgLy8gYHRydWVgLCBgZmFsc2VgLCBhbmQgYG51bGxgIGxpdGVyYWxzLlxuICAgICAgICAgICAgICAgIGlmIChzb3VyY2Uuc2xpY2UoSW5kZXgsIEluZGV4ICsgNCkgPT0gXCJ0cnVlXCIpIHtcbiAgICAgICAgICAgICAgICAgIEluZGV4ICs9IDQ7XG4gICAgICAgICAgICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICAgICAgICAgICAgICB9IGVsc2UgaWYgKHNvdXJjZS5zbGljZShJbmRleCwgSW5kZXggKyA1KSA9PSBcImZhbHNlXCIpIHtcbiAgICAgICAgICAgICAgICAgIEluZGV4ICs9IDU7XG4gICAgICAgICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgICAgICAgICAgfSBlbHNlIGlmIChzb3VyY2Uuc2xpY2UoSW5kZXgsIEluZGV4ICsgNCkgPT0gXCJudWxsXCIpIHtcbiAgICAgICAgICAgICAgICAgIEluZGV4ICs9IDQ7XG4gICAgICAgICAgICAgICAgICByZXR1cm4gbnVsbDtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgLy8gVW5yZWNvZ25pemVkIHRva2VuLlxuICAgICAgICAgICAgICAgIGFib3J0KCk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICAgIC8vIFJldHVybiB0aGUgc2VudGluZWwgYCRgIGNoYXJhY3RlciBpZiB0aGUgcGFyc2VyIGhhcyByZWFjaGVkIHRoZSBlbmRcbiAgICAgICAgICAvLyBvZiB0aGUgc291cmNlIHN0cmluZy5cbiAgICAgICAgICByZXR1cm4gXCIkXCI7XG4gICAgICAgIH07XG5cbiAgICAgICAgLy8gSW50ZXJuYWw6IFBhcnNlcyBhIEpTT04gYHZhbHVlYCB0b2tlbi5cbiAgICAgICAgdmFyIGdldCA9IGZ1bmN0aW9uICh2YWx1ZSkge1xuICAgICAgICAgIHZhciByZXN1bHRzLCBoYXNNZW1iZXJzO1xuICAgICAgICAgIGlmICh2YWx1ZSA9PSBcIiRcIikge1xuICAgICAgICAgICAgLy8gVW5leHBlY3RlZCBlbmQgb2YgaW5wdXQuXG4gICAgICAgICAgICBhYm9ydCgpO1xuICAgICAgICAgIH1cbiAgICAgICAgICBpZiAodHlwZW9mIHZhbHVlID09IFwic3RyaW5nXCIpIHtcbiAgICAgICAgICAgIGlmICgoY2hhckluZGV4QnVnZ3kgPyB2YWx1ZS5jaGFyQXQoMCkgOiB2YWx1ZVswXSkgPT0gXCJAXCIpIHtcbiAgICAgICAgICAgICAgLy8gUmVtb3ZlIHRoZSBzZW50aW5lbCBgQGAgY2hhcmFjdGVyLlxuICAgICAgICAgICAgICByZXR1cm4gdmFsdWUuc2xpY2UoMSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAvLyBQYXJzZSBvYmplY3QgYW5kIGFycmF5IGxpdGVyYWxzLlxuICAgICAgICAgICAgaWYgKHZhbHVlID09IFwiW1wiKSB7XG4gICAgICAgICAgICAgIC8vIFBhcnNlcyBhIEpTT04gYXJyYXksIHJldHVybmluZyBhIG5ldyBKYXZhU2NyaXB0IGFycmF5LlxuICAgICAgICAgICAgICByZXN1bHRzID0gW107XG4gICAgICAgICAgICAgIGZvciAoOzsgaGFzTWVtYmVycyB8fCAoaGFzTWVtYmVycyA9IHRydWUpKSB7XG4gICAgICAgICAgICAgICAgdmFsdWUgPSBsZXgoKTtcbiAgICAgICAgICAgICAgICAvLyBBIGNsb3Npbmcgc3F1YXJlIGJyYWNrZXQgbWFya3MgdGhlIGVuZCBvZiB0aGUgYXJyYXkgbGl0ZXJhbC5cbiAgICAgICAgICAgICAgICBpZiAodmFsdWUgPT0gXCJdXCIpIHtcbiAgICAgICAgICAgICAgICAgIGJyZWFrO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAvLyBJZiB0aGUgYXJyYXkgbGl0ZXJhbCBjb250YWlucyBlbGVtZW50cywgdGhlIGN1cnJlbnQgdG9rZW5cbiAgICAgICAgICAgICAgICAvLyBzaG91bGQgYmUgYSBjb21tYSBzZXBhcmF0aW5nIHRoZSBwcmV2aW91cyBlbGVtZW50IGZyb20gdGhlXG4gICAgICAgICAgICAgICAgLy8gbmV4dC5cbiAgICAgICAgICAgICAgICBpZiAoaGFzTWVtYmVycykge1xuICAgICAgICAgICAgICAgICAgaWYgKHZhbHVlID09IFwiLFwiKSB7XG4gICAgICAgICAgICAgICAgICAgIHZhbHVlID0gbGV4KCk7XG4gICAgICAgICAgICAgICAgICAgIGlmICh2YWx1ZSA9PSBcIl1cIikge1xuICAgICAgICAgICAgICAgICAgICAgIC8vIFVuZXhwZWN0ZWQgdHJhaWxpbmcgYCxgIGluIGFycmF5IGxpdGVyYWwuXG4gICAgICAgICAgICAgICAgICAgICAgYWJvcnQoKTtcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgLy8gQSBgLGAgbXVzdCBzZXBhcmF0ZSBlYWNoIGFycmF5IGVsZW1lbnQuXG4gICAgICAgICAgICAgICAgICAgIGFib3J0KCk7XG4gICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIC8vIEVsaXNpb25zIGFuZCBsZWFkaW5nIGNvbW1hcyBhcmUgbm90IHBlcm1pdHRlZC5cbiAgICAgICAgICAgICAgICBpZiAodmFsdWUgPT0gXCIsXCIpIHtcbiAgICAgICAgICAgICAgICAgIGFib3J0KCk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIHJlc3VsdHMucHVzaChnZXQodmFsdWUpKTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICByZXR1cm4gcmVzdWx0cztcbiAgICAgICAgICAgIH0gZWxzZSBpZiAodmFsdWUgPT0gXCJ7XCIpIHtcbiAgICAgICAgICAgICAgLy8gUGFyc2VzIGEgSlNPTiBvYmplY3QsIHJldHVybmluZyBhIG5ldyBKYXZhU2NyaXB0IG9iamVjdC5cbiAgICAgICAgICAgICAgcmVzdWx0cyA9IHt9O1xuICAgICAgICAgICAgICBmb3IgKDs7IGhhc01lbWJlcnMgfHwgKGhhc01lbWJlcnMgPSB0cnVlKSkge1xuICAgICAgICAgICAgICAgIHZhbHVlID0gbGV4KCk7XG4gICAgICAgICAgICAgICAgLy8gQSBjbG9zaW5nIGN1cmx5IGJyYWNlIG1hcmtzIHRoZSBlbmQgb2YgdGhlIG9iamVjdCBsaXRlcmFsLlxuICAgICAgICAgICAgICAgIGlmICh2YWx1ZSA9PSBcIn1cIikge1xuICAgICAgICAgICAgICAgICAgYnJlYWs7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIC8vIElmIHRoZSBvYmplY3QgbGl0ZXJhbCBjb250YWlucyBtZW1iZXJzLCB0aGUgY3VycmVudCB0b2tlblxuICAgICAgICAgICAgICAgIC8vIHNob3VsZCBiZSBhIGNvbW1hIHNlcGFyYXRvci5cbiAgICAgICAgICAgICAgICBpZiAoaGFzTWVtYmVycykge1xuICAgICAgICAgICAgICAgICAgaWYgKHZhbHVlID09IFwiLFwiKSB7XG4gICAgICAgICAgICAgICAgICAgIHZhbHVlID0gbGV4KCk7XG4gICAgICAgICAgICAgICAgICAgIGlmICh2YWx1ZSA9PSBcIn1cIikge1xuICAgICAgICAgICAgICAgICAgICAgIC8vIFVuZXhwZWN0ZWQgdHJhaWxpbmcgYCxgIGluIG9iamVjdCBsaXRlcmFsLlxuICAgICAgICAgICAgICAgICAgICAgIGFib3J0KCk7XG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgICAgICAgIC8vIEEgYCxgIG11c3Qgc2VwYXJhdGUgZWFjaCBvYmplY3QgbWVtYmVyLlxuICAgICAgICAgICAgICAgICAgICBhYm9ydCgpO1xuICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAvLyBMZWFkaW5nIGNvbW1hcyBhcmUgbm90IHBlcm1pdHRlZCwgb2JqZWN0IHByb3BlcnR5IG5hbWVzIG11c3QgYmVcbiAgICAgICAgICAgICAgICAvLyBkb3VibGUtcXVvdGVkIHN0cmluZ3MsIGFuZCBhIGA6YCBtdXN0IHNlcGFyYXRlIGVhY2ggcHJvcGVydHlcbiAgICAgICAgICAgICAgICAvLyBuYW1lIGFuZCB2YWx1ZS5cbiAgICAgICAgICAgICAgICBpZiAodmFsdWUgPT0gXCIsXCIgfHwgdHlwZW9mIHZhbHVlICE9IFwic3RyaW5nXCIgfHwgKGNoYXJJbmRleEJ1Z2d5ID8gdmFsdWUuY2hhckF0KDApIDogdmFsdWVbMF0pICE9IFwiQFwiIHx8IGxleCgpICE9IFwiOlwiKSB7XG4gICAgICAgICAgICAgICAgICBhYm9ydCgpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICByZXN1bHRzW3ZhbHVlLnNsaWNlKDEpXSA9IGdldChsZXgoKSk7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgcmV0dXJuIHJlc3VsdHM7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAvLyBVbmV4cGVjdGVkIHRva2VuIGVuY291bnRlcmVkLlxuICAgICAgICAgICAgYWJvcnQoKTtcbiAgICAgICAgICB9XG4gICAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgICAgICB9O1xuXG4gICAgICAgIC8vIEludGVybmFsOiBVcGRhdGVzIGEgdHJhdmVyc2VkIG9iamVjdCBtZW1iZXIuXG4gICAgICAgIHZhciB1cGRhdGUgPSBmdW5jdGlvbiAoc291cmNlLCBwcm9wZXJ0eSwgY2FsbGJhY2spIHtcbiAgICAgICAgICB2YXIgZWxlbWVudCA9IHdhbGsoc291cmNlLCBwcm9wZXJ0eSwgY2FsbGJhY2spO1xuICAgICAgICAgIGlmIChlbGVtZW50ID09PSB1bmRlZikge1xuICAgICAgICAgICAgZGVsZXRlIHNvdXJjZVtwcm9wZXJ0eV07XG4gICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgIHNvdXJjZVtwcm9wZXJ0eV0gPSBlbGVtZW50O1xuICAgICAgICAgIH1cbiAgICAgICAgfTtcblxuICAgICAgICAvLyBJbnRlcm5hbDogUmVjdXJzaXZlbHkgdHJhdmVyc2VzIGEgcGFyc2VkIEpTT04gb2JqZWN0LCBpbnZva2luZyB0aGVcbiAgICAgICAgLy8gYGNhbGxiYWNrYCBmdW5jdGlvbiBmb3IgZWFjaCB2YWx1ZS4gVGhpcyBpcyBhbiBpbXBsZW1lbnRhdGlvbiBvZiB0aGVcbiAgICAgICAgLy8gYFdhbGsoaG9sZGVyLCBuYW1lKWAgb3BlcmF0aW9uIGRlZmluZWQgaW4gRVMgNS4xIHNlY3Rpb24gMTUuMTIuMi5cbiAgICAgICAgdmFyIHdhbGsgPSBmdW5jdGlvbiAoc291cmNlLCBwcm9wZXJ0eSwgY2FsbGJhY2spIHtcbiAgICAgICAgICB2YXIgdmFsdWUgPSBzb3VyY2VbcHJvcGVydHldLCBsZW5ndGg7XG4gICAgICAgICAgaWYgKHR5cGVvZiB2YWx1ZSA9PSBcIm9iamVjdFwiICYmIHZhbHVlKSB7XG4gICAgICAgICAgICAvLyBgZm9yRWFjaGAgY2FuJ3QgYmUgdXNlZCB0byB0cmF2ZXJzZSBhbiBhcnJheSBpbiBPcGVyYSA8PSA4LjU0XG4gICAgICAgICAgICAvLyBiZWNhdXNlIGl0cyBgT2JqZWN0I2hhc093blByb3BlcnR5YCBpbXBsZW1lbnRhdGlvbiByZXR1cm5zIGBmYWxzZWBcbiAgICAgICAgICAgIC8vIGZvciBhcnJheSBpbmRpY2VzIChlLmcuLCBgIVsxLCAyLCAzXS5oYXNPd25Qcm9wZXJ0eShcIjBcIilgKS5cbiAgICAgICAgICAgIGlmIChnZXRDbGFzcy5jYWxsKHZhbHVlKSA9PSBhcnJheUNsYXNzKSB7XG4gICAgICAgICAgICAgIGZvciAobGVuZ3RoID0gdmFsdWUubGVuZ3RoOyBsZW5ndGgtLTspIHtcbiAgICAgICAgICAgICAgICB1cGRhdGUodmFsdWUsIGxlbmd0aCwgY2FsbGJhY2spO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICBmb3JFYWNoKHZhbHVlLCBmdW5jdGlvbiAocHJvcGVydHkpIHtcbiAgICAgICAgICAgICAgICB1cGRhdGUodmFsdWUsIHByb3BlcnR5LCBjYWxsYmFjayk7XG4gICAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgICByZXR1cm4gY2FsbGJhY2suY2FsbChzb3VyY2UsIHByb3BlcnR5LCB2YWx1ZSk7XG4gICAgICAgIH07XG5cbiAgICAgICAgLy8gUHVibGljOiBgSlNPTi5wYXJzZWAuIFNlZSBFUyA1LjEgc2VjdGlvbiAxNS4xMi4yLlxuICAgICAgICBleHBvcnRzLnBhcnNlID0gZnVuY3Rpb24gKHNvdXJjZSwgY2FsbGJhY2spIHtcbiAgICAgICAgICB2YXIgcmVzdWx0LCB2YWx1ZTtcbiAgICAgICAgICBJbmRleCA9IDA7XG4gICAgICAgICAgU291cmNlID0gXCJcIiArIHNvdXJjZTtcbiAgICAgICAgICByZXN1bHQgPSBnZXQobGV4KCkpO1xuICAgICAgICAgIC8vIElmIGEgSlNPTiBzdHJpbmcgY29udGFpbnMgbXVsdGlwbGUgdG9rZW5zLCBpdCBpcyBpbnZhbGlkLlxuICAgICAgICAgIGlmIChsZXgoKSAhPSBcIiRcIikge1xuICAgICAgICAgICAgYWJvcnQoKTtcbiAgICAgICAgICB9XG4gICAgICAgICAgLy8gUmVzZXQgdGhlIHBhcnNlciBzdGF0ZS5cbiAgICAgICAgICBJbmRleCA9IFNvdXJjZSA9IG51bGw7XG4gICAgICAgICAgcmV0dXJuIGNhbGxiYWNrICYmIGdldENsYXNzLmNhbGwoY2FsbGJhY2spID09IGZ1bmN0aW9uQ2xhc3MgPyB3YWxrKCh2YWx1ZSA9IHt9LCB2YWx1ZVtcIlwiXSA9IHJlc3VsdCwgdmFsdWUpLCBcIlwiLCBjYWxsYmFjaykgOiByZXN1bHQ7XG4gICAgICAgIH07XG4gICAgICB9XG4gICAgfVxuXG4gICAgZXhwb3J0c1tcInJ1bkluQ29udGV4dFwiXSA9IHJ1bkluQ29udGV4dDtcbiAgICByZXR1cm4gZXhwb3J0cztcbiAgfVxuXG4gIGlmIChmcmVlRXhwb3J0cyAmJiAhaXNMb2FkZXIpIHtcbiAgICAvLyBFeHBvcnQgZm9yIENvbW1vbkpTIGVudmlyb25tZW50cy5cbiAgICBydW5JbkNvbnRleHQocm9vdCwgZnJlZUV4cG9ydHMpO1xuICB9IGVsc2Uge1xuICAgIC8vIEV4cG9ydCBmb3Igd2ViIGJyb3dzZXJzIGFuZCBKYXZhU2NyaXB0IGVuZ2luZXMuXG4gICAgdmFyIG5hdGl2ZUpTT04gPSByb290LkpTT04sXG4gICAgICAgIHByZXZpb3VzSlNPTiA9IHJvb3RbXCJKU09OM1wiXSxcbiAgICAgICAgaXNSZXN0b3JlZCA9IGZhbHNlO1xuXG4gICAgdmFyIEpTT04zID0gcnVuSW5Db250ZXh0KHJvb3QsIChyb290W1wiSlNPTjNcIl0gPSB7XG4gICAgICAvLyBQdWJsaWM6IFJlc3RvcmVzIHRoZSBvcmlnaW5hbCB2YWx1ZSBvZiB0aGUgZ2xvYmFsIGBKU09OYCBvYmplY3QgYW5kXG4gICAgICAvLyByZXR1cm5zIGEgcmVmZXJlbmNlIHRvIHRoZSBgSlNPTjNgIG9iamVjdC5cbiAgICAgIFwibm9Db25mbGljdFwiOiBmdW5jdGlvbiAoKSB7XG4gICAgICAgIGlmICghaXNSZXN0b3JlZCkge1xuICAgICAgICAgIGlzUmVzdG9yZWQgPSB0cnVlO1xuICAgICAgICAgIHJvb3QuSlNPTiA9IG5hdGl2ZUpTT047XG4gICAgICAgICAgcm9vdFtcIkpTT04zXCJdID0gcHJldmlvdXNKU09OO1xuICAgICAgICAgIG5hdGl2ZUpTT04gPSBwcmV2aW91c0pTT04gPSBudWxsO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiBKU09OMztcbiAgICAgIH1cbiAgICB9KSk7XG5cbiAgICByb290LkpTT04gPSB7XG4gICAgICBcInBhcnNlXCI6IEpTT04zLnBhcnNlLFxuICAgICAgXCJzdHJpbmdpZnlcIjogSlNPTjMuc3RyaW5naWZ5XG4gICAgfTtcbiAgfVxuXG4gIC8vIEV4cG9ydCBmb3IgYXN5bmNocm9ub3VzIG1vZHVsZSBsb2FkZXJzLlxuICBpZiAoaXNMb2FkZXIpIHtcbiAgICBkZWZpbmUoZnVuY3Rpb24gKCkge1xuICAgICAgcmV0dXJuIEpTT04zO1xuICAgIH0pO1xuICB9XG59KS5jYWxsKHRoaXMpO1xuIiwiLyoqXHJcbiAqIEpTT04gcGFyc2UuXHJcbiAqXHJcbiAqIEBzZWUgQmFzZWQgb24galF1ZXJ5I3BhcnNlSlNPTiAoTUlUKSBhbmQgSlNPTjJcclxuICogQGFwaSBwcml2YXRlXHJcbiAqL1xyXG5cclxudmFyIHJ2YWxpZGNoYXJzID0gL15bXFxdLDp7fVxcc10qJC87XHJcbnZhciBydmFsaWRlc2NhcGUgPSAvXFxcXCg/OltcIlxcXFxcXC9iZm5ydF18dVswLTlhLWZBLUZdezR9KS9nO1xyXG52YXIgcnZhbGlkdG9rZW5zID0gL1wiW15cIlxcXFxcXG5cXHJdKlwifHRydWV8ZmFsc2V8bnVsbHwtP1xcZCsoPzpcXC5cXGQqKT8oPzpbZUVdWytcXC1dP1xcZCspPy9nO1xyXG52YXIgcnZhbGlkYnJhY2VzID0gLyg/Ol58OnwsKSg/OlxccypcXFspKy9nO1xyXG52YXIgcnRyaW1MZWZ0ID0gL15cXHMrLztcclxudmFyIHJ0cmltUmlnaHQgPSAvXFxzKyQvO1xyXG5cclxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiBwYXJzZWpzb24oZGF0YSkge1xyXG4gIGlmICgnc3RyaW5nJyAhPSB0eXBlb2YgZGF0YSB8fCAhZGF0YSkge1xyXG4gICAgcmV0dXJuIG51bGw7XHJcbiAgfVxyXG5cclxuICBkYXRhID0gZGF0YS5yZXBsYWNlKHJ0cmltTGVmdCwgJycpLnJlcGxhY2UocnRyaW1SaWdodCwgJycpO1xyXG5cclxuICAvLyBBdHRlbXB0IHRvIHBhcnNlIHVzaW5nIHRoZSBuYXRpdmUgSlNPTiBwYXJzZXIgZmlyc3RcclxuICBpZiAoZ2xvYmFsLkpTT04gJiYgSlNPTi5wYXJzZSkge1xyXG4gICAgcmV0dXJuIEpTT04ucGFyc2UoZGF0YSk7XHJcbiAgfVxyXG5cclxuICBpZiAocnZhbGlkY2hhcnMudGVzdChkYXRhLnJlcGxhY2UocnZhbGlkZXNjYXBlLCAnQCcpXHJcbiAgICAgIC5yZXBsYWNlKHJ2YWxpZHRva2VucywgJ10nKVxyXG4gICAgICAucmVwbGFjZShydmFsaWRicmFjZXMsICcnKSkpIHtcclxuICAgIHJldHVybiAobmV3IEZ1bmN0aW9uKCdyZXR1cm4gJyArIGRhdGEpKSgpO1xyXG4gIH1cclxufTsiLCIvKipcclxuICogQ29tcGlsZXMgYSBxdWVyeXN0cmluZ1xyXG4gKiBSZXR1cm5zIHN0cmluZyByZXByZXNlbnRhdGlvbiBvZiB0aGUgb2JqZWN0XHJcbiAqXHJcbiAqIEBwYXJhbSB7T2JqZWN0fVxyXG4gKiBAYXBpIHByaXZhdGVcclxuICovXHJcblxyXG5leHBvcnRzLmVuY29kZSA9IGZ1bmN0aW9uIChvYmopIHtcclxuICB2YXIgc3RyID0gJyc7XHJcblxyXG4gIGZvciAodmFyIGkgaW4gb2JqKSB7XHJcbiAgICBpZiAob2JqLmhhc093blByb3BlcnR5KGkpKSB7XHJcbiAgICAgIGlmIChzdHIubGVuZ3RoKSBzdHIgKz0gJyYnO1xyXG4gICAgICBzdHIgKz0gZW5jb2RlVVJJQ29tcG9uZW50KGkpICsgJz0nICsgZW5jb2RlVVJJQ29tcG9uZW50KG9ialtpXSk7XHJcbiAgICB9XHJcbiAgfVxyXG5cclxuICByZXR1cm4gc3RyO1xyXG59O1xyXG5cclxuLyoqXHJcbiAqIFBhcnNlcyBhIHNpbXBsZSBxdWVyeXN0cmluZyBpbnRvIGFuIG9iamVjdFxyXG4gKlxyXG4gKiBAcGFyYW0ge1N0cmluZ30gcXNcclxuICogQGFwaSBwcml2YXRlXHJcbiAqL1xyXG5cclxuZXhwb3J0cy5kZWNvZGUgPSBmdW5jdGlvbihxcyl7XHJcbiAgdmFyIHFyeSA9IHt9O1xyXG4gIHZhciBwYWlycyA9IHFzLnNwbGl0KCcmJyk7XHJcbiAgZm9yICh2YXIgaSA9IDAsIGwgPSBwYWlycy5sZW5ndGg7IGkgPCBsOyBpKyspIHtcclxuICAgIHZhciBwYWlyID0gcGFpcnNbaV0uc3BsaXQoJz0nKTtcclxuICAgIHFyeVtkZWNvZGVVUklDb21wb25lbnQocGFpclswXSldID0gZGVjb2RlVVJJQ29tcG9uZW50KHBhaXJbMV0pO1xyXG4gIH1cclxuICByZXR1cm4gcXJ5O1xyXG59O1xyXG4iLCIvKipcclxuICogUGFyc2VzIGFuIFVSSVxyXG4gKlxyXG4gKiBAYXV0aG9yIFN0ZXZlbiBMZXZpdGhhbiA8c3RldmVubGV2aXRoYW4uY29tPiAoTUlUIGxpY2Vuc2UpXHJcbiAqIEBhcGkgcHJpdmF0ZVxyXG4gKi9cclxuXHJcbnZhciByZSA9IC9eKD86KD8hW146QF0rOlteOkBcXC9dKkApKGh0dHB8aHR0cHN8d3N8d3NzKTpcXC9cXC8pPygoPzooKFteOkBdKikoPzo6KFteOkBdKikpPyk/QCk/KCg/OlthLWYwLTldezAsNH06KXsyLDd9W2EtZjAtOV17MCw0fXxbXjpcXC8/I10qKSg/OjooXFxkKikpPykoKChcXC8oPzpbXj8jXSg/IVtePyNcXC9dKlxcLltePyNcXC8uXSsoPzpbPyNdfCQpKSkqXFwvPyk/KFtePyNcXC9dKikpKD86XFw/KFteI10qKSk/KD86IyguKikpPykvO1xyXG5cclxudmFyIHBhcnRzID0gW1xyXG4gICAgJ3NvdXJjZScsICdwcm90b2NvbCcsICdhdXRob3JpdHknLCAndXNlckluZm8nLCAndXNlcicsICdwYXNzd29yZCcsICdob3N0JywgJ3BvcnQnLCAncmVsYXRpdmUnLCAncGF0aCcsICdkaXJlY3RvcnknLCAnZmlsZScsICdxdWVyeScsICdhbmNob3InXHJcbl07XHJcblxyXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uIHBhcnNldXJpKHN0cikge1xyXG4gICAgdmFyIHNyYyA9IHN0cixcclxuICAgICAgICBiID0gc3RyLmluZGV4T2YoJ1snKSxcclxuICAgICAgICBlID0gc3RyLmluZGV4T2YoJ10nKTtcclxuXHJcbiAgICBpZiAoYiAhPSAtMSAmJiBlICE9IC0xKSB7XHJcbiAgICAgICAgc3RyID0gc3RyLnN1YnN0cmluZygwLCBiKSArIHN0ci5zdWJzdHJpbmcoYiwgZSkucmVwbGFjZSgvOi9nLCAnOycpICsgc3RyLnN1YnN0cmluZyhlLCBzdHIubGVuZ3RoKTtcclxuICAgIH1cclxuXHJcbiAgICB2YXIgbSA9IHJlLmV4ZWMoc3RyIHx8ICcnKSxcclxuICAgICAgICB1cmkgPSB7fSxcclxuICAgICAgICBpID0gMTQ7XHJcblxyXG4gICAgd2hpbGUgKGktLSkge1xyXG4gICAgICAgIHVyaVtwYXJ0c1tpXV0gPSBtW2ldIHx8ICcnO1xyXG4gICAgfVxyXG5cclxuICAgIGlmIChiICE9IC0xICYmIGUgIT0gLTEpIHtcclxuICAgICAgICB1cmkuc291cmNlID0gc3JjO1xyXG4gICAgICAgIHVyaS5ob3N0ID0gdXJpLmhvc3Quc3Vic3RyaW5nKDEsIHVyaS5ob3N0Lmxlbmd0aCAtIDEpLnJlcGxhY2UoLzsvZywgJzonKTtcclxuICAgICAgICB1cmkuYXV0aG9yaXR5ID0gdXJpLmF1dGhvcml0eS5yZXBsYWNlKCdbJywgJycpLnJlcGxhY2UoJ10nLCAnJykucmVwbGFjZSgvOy9nLCAnOicpO1xyXG4gICAgICAgIHVyaS5pcHY2dXJpID0gdHJ1ZTtcclxuICAgIH1cclxuXHJcbiAgICByZXR1cm4gdXJpO1xyXG59O1xyXG4iLCIvLyBzaGltIGZvciB1c2luZyBwcm9jZXNzIGluIGJyb3dzZXJcbnZhciBwcm9jZXNzID0gbW9kdWxlLmV4cG9ydHMgPSB7fTtcblxuLy8gY2FjaGVkIGZyb20gd2hhdGV2ZXIgZ2xvYmFsIGlzIHByZXNlbnQgc28gdGhhdCB0ZXN0IHJ1bm5lcnMgdGhhdCBzdHViIGl0XG4vLyBkb24ndCBicmVhayB0aGluZ3MuICBCdXQgd2UgbmVlZCB0byB3cmFwIGl0IGluIGEgdHJ5IGNhdGNoIGluIGNhc2UgaXQgaXNcbi8vIHdyYXBwZWQgaW4gc3RyaWN0IG1vZGUgY29kZSB3aGljaCBkb2Vzbid0IGRlZmluZSBhbnkgZ2xvYmFscy4gIEl0J3MgaW5zaWRlIGFcbi8vIGZ1bmN0aW9uIGJlY2F1c2UgdHJ5L2NhdGNoZXMgZGVvcHRpbWl6ZSBpbiBjZXJ0YWluIGVuZ2luZXMuXG5cbnZhciBjYWNoZWRTZXRUaW1lb3V0O1xudmFyIGNhY2hlZENsZWFyVGltZW91dDtcblxuZnVuY3Rpb24gZGVmYXVsdFNldFRpbW91dCgpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ3NldFRpbWVvdXQgaGFzIG5vdCBiZWVuIGRlZmluZWQnKTtcbn1cbmZ1bmN0aW9uIGRlZmF1bHRDbGVhclRpbWVvdXQgKCkge1xuICAgIHRocm93IG5ldyBFcnJvcignY2xlYXJUaW1lb3V0IGhhcyBub3QgYmVlbiBkZWZpbmVkJyk7XG59XG4oZnVuY3Rpb24gKCkge1xuICAgIHRyeSB7XG4gICAgICAgIGlmICh0eXBlb2Ygc2V0VGltZW91dCA9PT0gJ2Z1bmN0aW9uJykge1xuICAgICAgICAgICAgY2FjaGVkU2V0VGltZW91dCA9IHNldFRpbWVvdXQ7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICBjYWNoZWRTZXRUaW1lb3V0ID0gZGVmYXVsdFNldFRpbW91dDtcbiAgICAgICAgfVxuICAgIH0gY2F0Y2ggKGUpIHtcbiAgICAgICAgY2FjaGVkU2V0VGltZW91dCA9IGRlZmF1bHRTZXRUaW1vdXQ7XG4gICAgfVxuICAgIHRyeSB7XG4gICAgICAgIGlmICh0eXBlb2YgY2xlYXJUaW1lb3V0ID09PSAnZnVuY3Rpb24nKSB7XG4gICAgICAgICAgICBjYWNoZWRDbGVhclRpbWVvdXQgPSBjbGVhclRpbWVvdXQ7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICBjYWNoZWRDbGVhclRpbWVvdXQgPSBkZWZhdWx0Q2xlYXJUaW1lb3V0O1xuICAgICAgICB9XG4gICAgfSBjYXRjaCAoZSkge1xuICAgICAgICBjYWNoZWRDbGVhclRpbWVvdXQgPSBkZWZhdWx0Q2xlYXJUaW1lb3V0O1xuICAgIH1cbn0gKCkpXG5mdW5jdGlvbiBydW5UaW1lb3V0KGZ1bikge1xuICAgIGlmIChjYWNoZWRTZXRUaW1lb3V0ID09PSBzZXRUaW1lb3V0KSB7XG4gICAgICAgIC8vbm9ybWFsIGVudmlyb21lbnRzIGluIHNhbmUgc2l0dWF0aW9uc1xuICAgICAgICByZXR1cm4gc2V0VGltZW91dChmdW4sIDApO1xuICAgIH1cbiAgICAvLyBpZiBzZXRUaW1lb3V0IHdhc24ndCBhdmFpbGFibGUgYnV0IHdhcyBsYXR0ZXIgZGVmaW5lZFxuICAgIGlmICgoY2FjaGVkU2V0VGltZW91dCA9PT0gZGVmYXVsdFNldFRpbW91dCB8fCAhY2FjaGVkU2V0VGltZW91dCkgJiYgc2V0VGltZW91dCkge1xuICAgICAgICBjYWNoZWRTZXRUaW1lb3V0ID0gc2V0VGltZW91dDtcbiAgICAgICAgcmV0dXJuIHNldFRpbWVvdXQoZnVuLCAwKTtcbiAgICB9XG4gICAgdHJ5IHtcbiAgICAgICAgLy8gd2hlbiB3aGVuIHNvbWVib2R5IGhhcyBzY3Jld2VkIHdpdGggc2V0VGltZW91dCBidXQgbm8gSS5FLiBtYWRkbmVzc1xuICAgICAgICByZXR1cm4gY2FjaGVkU2V0VGltZW91dChmdW4sIDApO1xuICAgIH0gY2F0Y2goZSl7XG4gICAgICAgIHRyeSB7XG4gICAgICAgICAgICAvLyBXaGVuIHdlIGFyZSBpbiBJLkUuIGJ1dCB0aGUgc2NyaXB0IGhhcyBiZWVuIGV2YWxlZCBzbyBJLkUuIGRvZXNuJ3QgdHJ1c3QgdGhlIGdsb2JhbCBvYmplY3Qgd2hlbiBjYWxsZWQgbm9ybWFsbHlcbiAgICAgICAgICAgIHJldHVybiBjYWNoZWRTZXRUaW1lb3V0LmNhbGwobnVsbCwgZnVuLCAwKTtcbiAgICAgICAgfSBjYXRjaChlKXtcbiAgICAgICAgICAgIC8vIHNhbWUgYXMgYWJvdmUgYnV0IHdoZW4gaXQncyBhIHZlcnNpb24gb2YgSS5FLiB0aGF0IG11c3QgaGF2ZSB0aGUgZ2xvYmFsIG9iamVjdCBmb3IgJ3RoaXMnLCBob3BmdWxseSBvdXIgY29udGV4dCBjb3JyZWN0IG90aGVyd2lzZSBpdCB3aWxsIHRocm93IGEgZ2xvYmFsIGVycm9yXG4gICAgICAgICAgICByZXR1cm4gY2FjaGVkU2V0VGltZW91dC5jYWxsKHRoaXMsIGZ1biwgMCk7XG4gICAgICAgIH1cbiAgICB9XG5cblxufVxuZnVuY3Rpb24gcnVuQ2xlYXJUaW1lb3V0KG1hcmtlcikge1xuICAgIGlmIChjYWNoZWRDbGVhclRpbWVvdXQgPT09IGNsZWFyVGltZW91dCkge1xuICAgICAgICAvL25vcm1hbCBlbnZpcm9tZW50cyBpbiBzYW5lIHNpdHVhdGlvbnNcbiAgICAgICAgcmV0dXJuIGNsZWFyVGltZW91dChtYXJrZXIpO1xuICAgIH1cbiAgICAvLyBpZiBjbGVhclRpbWVvdXQgd2Fzbid0IGF2YWlsYWJsZSBidXQgd2FzIGxhdHRlciBkZWZpbmVkXG4gICAgaWYgKChjYWNoZWRDbGVhclRpbWVvdXQgPT09IGRlZmF1bHRDbGVhclRpbWVvdXQgfHwgIWNhY2hlZENsZWFyVGltZW91dCkgJiYgY2xlYXJUaW1lb3V0KSB7XG4gICAgICAgIGNhY2hlZENsZWFyVGltZW91dCA9IGNsZWFyVGltZW91dDtcbiAgICAgICAgcmV0dXJuIGNsZWFyVGltZW91dChtYXJrZXIpO1xuICAgIH1cbiAgICB0cnkge1xuICAgICAgICAvLyB3aGVuIHdoZW4gc29tZWJvZHkgaGFzIHNjcmV3ZWQgd2l0aCBzZXRUaW1lb3V0IGJ1dCBubyBJLkUuIG1hZGRuZXNzXG4gICAgICAgIHJldHVybiBjYWNoZWRDbGVhclRpbWVvdXQobWFya2VyKTtcbiAgICB9IGNhdGNoIChlKXtcbiAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgIC8vIFdoZW4gd2UgYXJlIGluIEkuRS4gYnV0IHRoZSBzY3JpcHQgaGFzIGJlZW4gZXZhbGVkIHNvIEkuRS4gZG9lc24ndCAgdHJ1c3QgdGhlIGdsb2JhbCBvYmplY3Qgd2hlbiBjYWxsZWQgbm9ybWFsbHlcbiAgICAgICAgICAgIHJldHVybiBjYWNoZWRDbGVhclRpbWVvdXQuY2FsbChudWxsLCBtYXJrZXIpO1xuICAgICAgICB9IGNhdGNoIChlKXtcbiAgICAgICAgICAgIC8vIHNhbWUgYXMgYWJvdmUgYnV0IHdoZW4gaXQncyBhIHZlcnNpb24gb2YgSS5FLiB0aGF0IG11c3QgaGF2ZSB0aGUgZ2xvYmFsIG9iamVjdCBmb3IgJ3RoaXMnLCBob3BmdWxseSBvdXIgY29udGV4dCBjb3JyZWN0IG90aGVyd2lzZSBpdCB3aWxsIHRocm93IGEgZ2xvYmFsIGVycm9yLlxuICAgICAgICAgICAgLy8gU29tZSB2ZXJzaW9ucyBvZiBJLkUuIGhhdmUgZGlmZmVyZW50IHJ1bGVzIGZvciBjbGVhclRpbWVvdXQgdnMgc2V0VGltZW91dFxuICAgICAgICAgICAgcmV0dXJuIGNhY2hlZENsZWFyVGltZW91dC5jYWxsKHRoaXMsIG1hcmtlcik7XG4gICAgICAgIH1cbiAgICB9XG5cblxuXG59XG52YXIgcXVldWUgPSBbXTtcbnZhciBkcmFpbmluZyA9IGZhbHNlO1xudmFyIGN1cnJlbnRRdWV1ZTtcbnZhciBxdWV1ZUluZGV4ID0gLTE7XG5cbmZ1bmN0aW9uIGNsZWFuVXBOZXh0VGljaygpIHtcbiAgICBpZiAoIWRyYWluaW5nIHx8ICFjdXJyZW50UXVldWUpIHtcbiAgICAgICAgcmV0dXJuO1xuICAgIH1cbiAgICBkcmFpbmluZyA9IGZhbHNlO1xuICAgIGlmIChjdXJyZW50UXVldWUubGVuZ3RoKSB7XG4gICAgICAgIHF1ZXVlID0gY3VycmVudFF1ZXVlLmNvbmNhdChxdWV1ZSk7XG4gICAgfSBlbHNlIHtcbiAgICAgICAgcXVldWVJbmRleCA9IC0xO1xuICAgIH1cbiAgICBpZiAocXVldWUubGVuZ3RoKSB7XG4gICAgICAgIGRyYWluUXVldWUoKTtcbiAgICB9XG59XG5cbmZ1bmN0aW9uIGRyYWluUXVldWUoKSB7XG4gICAgaWYgKGRyYWluaW5nKSB7XG4gICAgICAgIHJldHVybjtcbiAgICB9XG4gICAgdmFyIHRpbWVvdXQgPSBydW5UaW1lb3V0KGNsZWFuVXBOZXh0VGljayk7XG4gICAgZHJhaW5pbmcgPSB0cnVlO1xuXG4gICAgdmFyIGxlbiA9IHF1ZXVlLmxlbmd0aDtcbiAgICB3aGlsZShsZW4pIHtcbiAgICAgICAgY3VycmVudFF1ZXVlID0gcXVldWU7XG4gICAgICAgIHF1ZXVlID0gW107XG4gICAgICAgIHdoaWxlICgrK3F1ZXVlSW5kZXggPCBsZW4pIHtcbiAgICAgICAgICAgIGlmIChjdXJyZW50UXVldWUpIHtcbiAgICAgICAgICAgICAgICBjdXJyZW50UXVldWVbcXVldWVJbmRleF0ucnVuKCk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgcXVldWVJbmRleCA9IC0xO1xuICAgICAgICBsZW4gPSBxdWV1ZS5sZW5ndGg7XG4gICAgfVxuICAgIGN1cnJlbnRRdWV1ZSA9IG51bGw7XG4gICAgZHJhaW5pbmcgPSBmYWxzZTtcbiAgICBydW5DbGVhclRpbWVvdXQodGltZW91dCk7XG59XG5cbnByb2Nlc3MubmV4dFRpY2sgPSBmdW5jdGlvbiAoZnVuKSB7XG4gICAgdmFyIGFyZ3MgPSBuZXcgQXJyYXkoYXJndW1lbnRzLmxlbmd0aCAtIDEpO1xuICAgIGlmIChhcmd1bWVudHMubGVuZ3RoID4gMSkge1xuICAgICAgICBmb3IgKHZhciBpID0gMTsgaSA8IGFyZ3VtZW50cy5sZW5ndGg7IGkrKykge1xuICAgICAgICAgICAgYXJnc1tpIC0gMV0gPSBhcmd1bWVudHNbaV07XG4gICAgICAgIH1cbiAgICB9XG4gICAgcXVldWUucHVzaChuZXcgSXRlbShmdW4sIGFyZ3MpKTtcbiAgICBpZiAocXVldWUubGVuZ3RoID09PSAxICYmICFkcmFpbmluZykge1xuICAgICAgICBydW5UaW1lb3V0KGRyYWluUXVldWUpO1xuICAgIH1cbn07XG5cbi8vIHY4IGxpa2VzIHByZWRpY3RpYmxlIG9iamVjdHNcbmZ1bmN0aW9uIEl0ZW0oZnVuLCBhcnJheSkge1xuICAgIHRoaXMuZnVuID0gZnVuO1xuICAgIHRoaXMuYXJyYXkgPSBhcnJheTtcbn1cbkl0ZW0ucHJvdG90eXBlLnJ1biA9IGZ1bmN0aW9uICgpIHtcbiAgICB0aGlzLmZ1bi5hcHBseShudWxsLCB0aGlzLmFycmF5KTtcbn07XG5wcm9jZXNzLnRpdGxlID0gJ2Jyb3dzZXInO1xucHJvY2Vzcy5icm93c2VyID0gdHJ1ZTtcbnByb2Nlc3MuZW52ID0ge307XG5wcm9jZXNzLmFyZ3YgPSBbXTtcbnByb2Nlc3MudmVyc2lvbiA9ICcnOyAvLyBlbXB0eSBzdHJpbmcgdG8gYXZvaWQgcmVnZXhwIGlzc3Vlc1xucHJvY2Vzcy52ZXJzaW9ucyA9IHt9O1xuXG5mdW5jdGlvbiBub29wKCkge31cblxucHJvY2Vzcy5vbiA9IG5vb3A7XG5wcm9jZXNzLmFkZExpc3RlbmVyID0gbm9vcDtcbnByb2Nlc3Mub25jZSA9IG5vb3A7XG5wcm9jZXNzLm9mZiA9IG5vb3A7XG5wcm9jZXNzLnJlbW92ZUxpc3RlbmVyID0gbm9vcDtcbnByb2Nlc3MucmVtb3ZlQWxsTGlzdGVuZXJzID0gbm9vcDtcbnByb2Nlc3MuZW1pdCA9IG5vb3A7XG5cbnByb2Nlc3MuYmluZGluZyA9IGZ1bmN0aW9uIChuYW1lKSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKCdwcm9jZXNzLmJpbmRpbmcgaXMgbm90IHN1cHBvcnRlZCcpO1xufTtcblxucHJvY2Vzcy5jd2QgPSBmdW5jdGlvbiAoKSB7IHJldHVybiAnLycgfTtcbnByb2Nlc3MuY2hkaXIgPSBmdW5jdGlvbiAoZGlyKSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKCdwcm9jZXNzLmNoZGlyIGlzIG5vdCBzdXBwb3J0ZWQnKTtcbn07XG5wcm9jZXNzLnVtYXNrID0gZnVuY3Rpb24oKSB7IHJldHVybiAwOyB9O1xuIiwiIWZ1bmN0aW9uKGUsdCl7XCJvYmplY3RcIj09dHlwZW9mIGV4cG9ydHMmJlwib2JqZWN0XCI9PXR5cGVvZiBtb2R1bGU/bW9kdWxlLmV4cG9ydHM9dCgpOlwiZnVuY3Rpb25cIj09dHlwZW9mIGRlZmluZSYmZGVmaW5lLmFtZD9kZWZpbmUoW10sdCk6XCJvYmplY3RcIj09dHlwZW9mIGV4cG9ydHM/ZXhwb3J0cy5QdWJOdWI9dCgpOmUuUHViTnViPXQoKX0odGhpcyxmdW5jdGlvbigpe3JldHVybiBmdW5jdGlvbihlKXtmdW5jdGlvbiB0KHIpe2lmKG5bcl0pcmV0dXJuIG5bcl0uZXhwb3J0czt2YXIgaT1uW3JdPXtleHBvcnRzOnt9LGlkOnIsbG9hZGVkOiExfTtyZXR1cm4gZVtyXS5jYWxsKGkuZXhwb3J0cyxpLGkuZXhwb3J0cyx0KSxpLmxvYWRlZD0hMCxpLmV4cG9ydHN9dmFyIG49e307cmV0dXJuIHQubT1lLHQuYz1uLHQucD1cIlwiLHQoMCl9KFtmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaShlLHQpe2lmKCEoZSBpbnN0YW5jZW9mIHQpKXRocm93IG5ldyBUeXBlRXJyb3IoXCJDYW5ub3QgY2FsbCBhIGNsYXNzIGFzIGEgZnVuY3Rpb25cIil9ZnVuY3Rpb24gbyhlLHQpe2lmKCFlKXRocm93IG5ldyBSZWZlcmVuY2VFcnJvcihcInRoaXMgaGFzbid0IGJlZW4gaW5pdGlhbGlzZWQgLSBzdXBlcigpIGhhc24ndCBiZWVuIGNhbGxlZFwiKTtyZXR1cm4hdHx8XCJvYmplY3RcIiE9dHlwZW9mIHQmJlwiZnVuY3Rpb25cIiE9dHlwZW9mIHQ/ZTp0fWZ1bmN0aW9uIHMoZSx0KXtpZihcImZ1bmN0aW9uXCIhPXR5cGVvZiB0JiZudWxsIT09dCl0aHJvdyBuZXcgVHlwZUVycm9yKFwiU3VwZXIgZXhwcmVzc2lvbiBtdXN0IGVpdGhlciBiZSBudWxsIG9yIGEgZnVuY3Rpb24sIG5vdCBcIit0eXBlb2YgdCk7ZS5wcm90b3R5cGU9T2JqZWN0LmNyZWF0ZSh0JiZ0LnByb3RvdHlwZSx7Y29uc3RydWN0b3I6e3ZhbHVlOmUsZW51bWVyYWJsZTohMSx3cml0YWJsZTohMCxjb25maWd1cmFibGU6ITB9fSksdCYmKE9iamVjdC5zZXRQcm90b3R5cGVPZj9PYmplY3Quc2V0UHJvdG90eXBlT2YoZSx0KTplLl9fcHJvdG9fXz10KX1mdW5jdGlvbiBhKGUpe2lmKCFuYXZpZ2F0b3J8fCFuYXZpZ2F0b3Iuc2VuZEJlYWNvbilyZXR1cm4hMTtuYXZpZ2F0b3Iuc2VuZEJlYWNvbihlKX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KTt2YXIgdT1uKDEpLGM9cih1KSxsPW4oNDApLGg9cihsKSxmPW4oNDEpLGQ9cihmKSxwPW4oNDIpLGc9KG4oOCksZnVuY3Rpb24oZSl7ZnVuY3Rpb24gdChlKXtpKHRoaXMsdCk7dmFyIG49ZS5saXN0ZW5Ub0Jyb3dzZXJOZXR3b3JrRXZlbnRzLHI9dm9pZCAwPT09bnx8bjtlLmRiPWQuZGVmYXVsdCxlLnNka0ZhbWlseT1cIldlYlwiLGUubmV0d29ya2luZz1uZXcgaC5kZWZhdWx0KHtnZXQ6cC5nZXQscG9zdDpwLnBvc3Qsc2VuZEJlYWNvbjphfSk7dmFyIHM9byh0aGlzLCh0Ll9fcHJvdG9fX3x8T2JqZWN0LmdldFByb3RvdHlwZU9mKHQpKS5jYWxsKHRoaXMsZSkpO3JldHVybiByJiYod2luZG93LmFkZEV2ZW50TGlzdGVuZXIoXCJvZmZsaW5lXCIsZnVuY3Rpb24oKXtzLm5ldHdvcmtEb3duRGV0ZWN0ZWQoKX0pLHdpbmRvdy5hZGRFdmVudExpc3RlbmVyKFwib25saW5lXCIsZnVuY3Rpb24oKXtzLm5ldHdvcmtVcERldGVjdGVkKCl9KSksc31yZXR1cm4gcyh0LGUpLHR9KGMuZGVmYXVsdCkpO3QuZGVmYXVsdD1nLGUuZXhwb3J0cz10LmRlZmF1bHR9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKGUpe2lmKGUmJmUuX19lc01vZHVsZSlyZXR1cm4gZTt2YXIgdD17fTtpZihudWxsIT1lKWZvcih2YXIgbiBpbiBlKU9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHkuY2FsbChlLG4pJiYodFtuXT1lW25dKTtyZXR1cm4gdC5kZWZhdWx0PWUsdH1mdW5jdGlvbiBpKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX1mdW5jdGlvbiBvKGUsdCl7aWYoIShlIGluc3RhbmNlb2YgdCkpdGhyb3cgbmV3IFR5cGVFcnJvcihcIkNhbm5vdCBjYWxsIGEgY2xhc3MgYXMgYSBmdW5jdGlvblwiKX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KTt2YXIgcz1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoZSx0KXtmb3IodmFyIG49MDtuPHQubGVuZ3RoO24rKyl7dmFyIHI9dFtuXTtyLmVudW1lcmFibGU9ci5lbnVtZXJhYmxlfHwhMSxyLmNvbmZpZ3VyYWJsZT0hMCxcInZhbHVlXCJpbiByJiYoci53cml0YWJsZT0hMCksT2JqZWN0LmRlZmluZVByb3BlcnR5KGUsci5rZXkscil9fXJldHVybiBmdW5jdGlvbih0LG4scil7cmV0dXJuIG4mJmUodC5wcm90b3R5cGUsbiksciYmZSh0LHIpLHR9fSgpLGE9bigyKSx1PWkoYSksYz1uKDcpLGw9aShjKSxoPW4oOSksZj1pKGgpLGQ9bigxMSkscD1pKGQpLGc9bigxMikseT1pKGcpLHY9bigxOCksYj1pKHYpLF89bigxOSksbT1yKF8pLGs9bigyMCksUD1yKGspLFM9bigyMSksTz1yKFMpLHc9bigyMiksVD1yKHcpLEM9bigyMyksTT1yKEMpLHg9bigyNCksRT1yKHgpLE49bigyNSksUj1yKE4pLEs9bigyNiksQT1yKEspLGo9bigyNyksRD1yKGopLEc9bigyOCksVT1yKEcpLEI9bigyOSksST1yKEIpLEg9bigzMCksTD1yKEgpLHE9bigzMSksRj1yKHEpLHo9bigzMiksWD1yKHopLFc9bigzMyksVj1yKFcpLEo9bigzNCksJD1yKEopLFE9bigzNSksWT1yKFEpLFo9bigzNiksZWU9cihaKSx0ZT1uKDM3KSxuZT1yKHRlKSxyZT1uKDM4KSxpZT1yKHJlKSxvZT1uKDE1KSxzZT1yKG9lKSxhZT1uKDM5KSx1ZT1yKGFlKSxjZT1uKDE2KSxsZT1pKGNlKSxoZT1uKDEzKSxmZT1pKGhlKSxkZT0obig4KSxmdW5jdGlvbigpe2Z1bmN0aW9uIGUodCl7dmFyIG49dGhpcztvKHRoaXMsZSk7dmFyIHI9dC5kYixpPXQubmV0d29ya2luZyxzPXRoaXMuX2NvbmZpZz1uZXcgbC5kZWZhdWx0KHtzZXR1cDp0LGRiOnJ9KSxhPW5ldyBmLmRlZmF1bHQoe2NvbmZpZzpzfSk7aS5pbml0KHMpO3ZhciB1PXtjb25maWc6cyxuZXR3b3JraW5nOmksY3J5cHRvOmF9LGM9Yi5kZWZhdWx0LmJpbmQodGhpcyx1LHNlKSxoPWIuZGVmYXVsdC5iaW5kKHRoaXMsdSxVKSxkPWIuZGVmYXVsdC5iaW5kKHRoaXMsdSxMKSxnPWIuZGVmYXVsdC5iaW5kKHRoaXMsdSxYKSx2PWIuZGVmYXVsdC5iaW5kKHRoaXMsdSx1ZSksXz10aGlzLl9saXN0ZW5lck1hbmFnZXI9bmV3IHkuZGVmYXVsdCxrPW5ldyBwLmRlZmF1bHQoe3RpbWVFbmRwb2ludDpjLGxlYXZlRW5kcG9pbnQ6aCxoZWFydGJlYXRFbmRwb2ludDpkLHNldFN0YXRlRW5kcG9pbnQ6ZyxzdWJzY3JpYmVFbmRwb2ludDp2LGNyeXB0bzp1LmNyeXB0byxjb25maWc6dS5jb25maWcsbGlzdGVuZXJNYW5hZ2VyOl99KTt0aGlzLmFkZExpc3RlbmVyPV8uYWRkTGlzdGVuZXIuYmluZChfKSx0aGlzLnJlbW92ZUxpc3RlbmVyPV8ucmVtb3ZlTGlzdGVuZXIuYmluZChfKSx0aGlzLnJlbW92ZUFsbExpc3RlbmVycz1fLnJlbW92ZUFsbExpc3RlbmVycy5iaW5kKF8pLHRoaXMuY2hhbm5lbEdyb3Vwcz17bGlzdEdyb3VwczpiLmRlZmF1bHQuYmluZCh0aGlzLHUsVCksbGlzdENoYW5uZWxzOmIuZGVmYXVsdC5iaW5kKHRoaXMsdSxNKSxhZGRDaGFubmVsczpiLmRlZmF1bHQuYmluZCh0aGlzLHUsbSkscmVtb3ZlQ2hhbm5lbHM6Yi5kZWZhdWx0LmJpbmQodGhpcyx1LFApLGRlbGV0ZUdyb3VwOmIuZGVmYXVsdC5iaW5kKHRoaXMsdSxPKX0sdGhpcy5wdXNoPXthZGRDaGFubmVsczpiLmRlZmF1bHQuYmluZCh0aGlzLHUsRSkscmVtb3ZlQ2hhbm5lbHM6Yi5kZWZhdWx0LmJpbmQodGhpcyx1LFIpLGRlbGV0ZURldmljZTpiLmRlZmF1bHQuYmluZCh0aGlzLHUsRCksbGlzdENoYW5uZWxzOmIuZGVmYXVsdC5iaW5kKHRoaXMsdSxBKX0sdGhpcy5oZXJlTm93PWIuZGVmYXVsdC5iaW5kKHRoaXMsdSxWKSx0aGlzLndoZXJlTm93PWIuZGVmYXVsdC5iaW5kKHRoaXMsdSxJKSx0aGlzLmdldFN0YXRlPWIuZGVmYXVsdC5iaW5kKHRoaXMsdSxGKSx0aGlzLnNldFN0YXRlPWsuYWRhcHRTdGF0ZUNoYW5nZS5iaW5kKGspLHRoaXMuZ3JhbnQ9Yi5kZWZhdWx0LmJpbmQodGhpcyx1LFkpLHRoaXMuYXVkaXQ9Yi5kZWZhdWx0LmJpbmQodGhpcyx1LCQpLHRoaXMucHVibGlzaD1iLmRlZmF1bHQuYmluZCh0aGlzLHUsZWUpLHRoaXMuZmlyZT1mdW5jdGlvbihlLHQpe2UucmVwbGljYXRlPSExLGUuc3RvcmVJbkhpc3Rvcnk9ITEsbi5wdWJsaXNoKGUsdCl9LHRoaXMuaGlzdG9yeT1iLmRlZmF1bHQuYmluZCh0aGlzLHUsbmUpLHRoaXMuZmV0Y2hNZXNzYWdlcz1iLmRlZmF1bHQuYmluZCh0aGlzLHUsaWUpLHRoaXMudGltZT1jLHRoaXMuc3Vic2NyaWJlPWsuYWRhcHRTdWJzY3JpYmVDaGFuZ2UuYmluZChrKSx0aGlzLnVuc3Vic2NyaWJlPWsuYWRhcHRVbnN1YnNjcmliZUNoYW5nZS5iaW5kKGspLHRoaXMuZGlzY29ubmVjdD1rLmRpc2Nvbm5lY3QuYmluZChrKSx0aGlzLnJlY29ubmVjdD1rLnJlY29ubmVjdC5iaW5kKGspLHRoaXMuZGVzdHJveT1mdW5jdGlvbihlKXtrLnVuc3Vic2NyaWJlQWxsKGUpLGsuZGlzY29ubmVjdCgpfSx0aGlzLnN0b3A9dGhpcy5kZXN0cm95LHRoaXMudW5zdWJzY3JpYmVBbGw9ay51bnN1YnNjcmliZUFsbC5iaW5kKGspLHRoaXMuZ2V0U3Vic2NyaWJlZENoYW5uZWxzPWsuZ2V0U3Vic2NyaWJlZENoYW5uZWxzLmJpbmQoayksdGhpcy5nZXRTdWJzY3JpYmVkQ2hhbm5lbEdyb3Vwcz1rLmdldFN1YnNjcmliZWRDaGFubmVsR3JvdXBzLmJpbmQoayksdGhpcy5lbmNyeXB0PWEuZW5jcnlwdC5iaW5kKGEpLHRoaXMuZGVjcnlwdD1hLmRlY3J5cHQuYmluZChhKSx0aGlzLmdldEF1dGhLZXk9dS5jb25maWcuZ2V0QXV0aEtleS5iaW5kKHUuY29uZmlnKSx0aGlzLnNldEF1dGhLZXk9dS5jb25maWcuc2V0QXV0aEtleS5iaW5kKHUuY29uZmlnKSx0aGlzLnNldENpcGhlcktleT11LmNvbmZpZy5zZXRDaXBoZXJLZXkuYmluZCh1LmNvbmZpZyksdGhpcy5nZXRVVUlEPXUuY29uZmlnLmdldFVVSUQuYmluZCh1LmNvbmZpZyksdGhpcy5zZXRVVUlEPXUuY29uZmlnLnNldFVVSUQuYmluZCh1LmNvbmZpZyksdGhpcy5nZXRGaWx0ZXJFeHByZXNzaW9uPXUuY29uZmlnLmdldEZpbHRlckV4cHJlc3Npb24uYmluZCh1LmNvbmZpZyksdGhpcy5zZXRGaWx0ZXJFeHByZXNzaW9uPXUuY29uZmlnLnNldEZpbHRlckV4cHJlc3Npb24uYmluZCh1LmNvbmZpZyl9cmV0dXJuIHMoZSxbe2tleTpcImdldFZlcnNpb25cIix2YWx1ZTpmdW5jdGlvbigpe3JldHVybiB0aGlzLl9jb25maWcuZ2V0VmVyc2lvbigpfX0se2tleTpcIm5ldHdvcmtEb3duRGV0ZWN0ZWRcIix2YWx1ZTpmdW5jdGlvbigpe3RoaXMuX2xpc3RlbmVyTWFuYWdlci5hbm5vdW5jZU5ldHdvcmtEb3duKCksdGhpcy5fY29uZmlnLnJlc3RvcmU/dGhpcy5kaXNjb25uZWN0KCk6dGhpcy5kZXN0cm95KCEwKX19LHtrZXk6XCJuZXR3b3JrVXBEZXRlY3RlZFwiLHZhbHVlOmZ1bmN0aW9uKCl7dGhpcy5fbGlzdGVuZXJNYW5hZ2VyLmFubm91bmNlTmV0d29ya1VwKCksdGhpcy5yZWNvbm5lY3QoKX19XSxbe2tleTpcImdlbmVyYXRlVVVJRFwiLHZhbHVlOmZ1bmN0aW9uKCl7cmV0dXJuIHUuZGVmYXVsdC52NCgpfX1dKSxlfSgpKTtkZS5PUEVSQVRJT05TPWxlLmRlZmF1bHQsZGUuQ0FURUdPUklFUz1mZS5kZWZhdWx0LHQuZGVmYXVsdD1kZSxlLmV4cG9ydHM9dC5kZWZhdWx0fSxmdW5jdGlvbihlLHQsbil7dmFyIHI9bigzKSxpPW4oNiksbz1pO28udjE9cixvLnY0PWksZS5leHBvcnRzPW99LGZ1bmN0aW9uKGUsdCxuKXtmdW5jdGlvbiByKGUsdCxuKXt2YXIgcj10JiZufHwwLGk9dHx8W107ZT1lfHx7fTt2YXIgcz12b2lkIDAhPT1lLmNsb2Nrc2VxP2UuY2xvY2tzZXE6dSxoPXZvaWQgMCE9PWUubXNlY3M/ZS5tc2VjczoobmV3IERhdGUpLmdldFRpbWUoKSxmPXZvaWQgMCE9PWUubnNlY3M/ZS5uc2VjczpsKzEsZD1oLWMrKGYtbCkvMWU0O2lmKGQ8MCYmdm9pZCAwPT09ZS5jbG9ja3NlcSYmKHM9cysxJjE2MzgzKSwoZDwwfHxoPmMpJiZ2b2lkIDA9PT1lLm5zZWNzJiYoZj0wKSxmPj0xZTQpdGhyb3cgbmV3IEVycm9yKFwidXVpZC52MSgpOiBDYW4ndCBjcmVhdGUgbW9yZSB0aGFuIDEwTSB1dWlkcy9zZWNcIik7Yz1oLGw9Zix1PXMsaCs9MTIyMTkyOTI4ZTU7dmFyIHA9KDFlNCooMjY4NDM1NDU1JmgpK2YpJTQyOTQ5NjcyOTY7aVtyKytdPXA+Pj4yNCYyNTUsaVtyKytdPXA+Pj4xNiYyNTUsaVtyKytdPXA+Pj44JjI1NSxpW3IrK109MjU1JnA7dmFyIGc9aC80Mjk0OTY3Mjk2KjFlNCYyNjg0MzU0NTU7aVtyKytdPWc+Pj44JjI1NSxpW3IrK109MjU1JmcsaVtyKytdPWc+Pj4yNCYxNXwxNixpW3IrK109Zz4+PjE2JjI1NSxpW3IrK109cz4+Pjh8MTI4LGlbcisrXT0yNTUmcztmb3IodmFyIHk9ZS5ub2RlfHxhLHY9MDt2PDY7Kyt2KWlbcit2XT15W3ZdO3JldHVybiB0P3Q6byhpKX12YXIgaT1uKDQpLG89big1KSxzPWkoKSxhPVsxfHNbMF0sc1sxXSxzWzJdLHNbM10sc1s0XSxzWzVdXSx1PTE2MzgzJihzWzZdPDw4fHNbN10pLGM9MCxsPTA7ZS5leHBvcnRzPXJ9LGZ1bmN0aW9uKGUsdCl7KGZ1bmN0aW9uKHQpe3ZhciBuLHI9dC5jcnlwdG98fHQubXNDcnlwdG87aWYociYmci5nZXRSYW5kb21WYWx1ZXMpe3ZhciBpPW5ldyBVaW50OEFycmF5KDE2KTtuPWZ1bmN0aW9uKCl7cmV0dXJuIHIuZ2V0UmFuZG9tVmFsdWVzKGkpLGl9fWlmKCFuKXt2YXIgbz1uZXcgQXJyYXkoMTYpO249ZnVuY3Rpb24oKXtmb3IodmFyIGUsdD0wO3Q8MTY7dCsrKTA9PSgzJnQpJiYoZT00Mjk0OTY3Mjk2Kk1hdGgucmFuZG9tKCkpLG9bdF09ZT4+PigoMyZ0KTw8MykmMjU1O3JldHVybiBvfX1lLmV4cG9ydHM9bn0pLmNhbGwodCxmdW5jdGlvbigpe3JldHVybiB0aGlzfSgpKX0sZnVuY3Rpb24oZSx0KXtmdW5jdGlvbiBuKGUsdCl7dmFyIG49dHx8MCxpPXI7cmV0dXJuIGlbZVtuKytdXStpW2VbbisrXV0raVtlW24rK11dK2lbZVtuKytdXStcIi1cIitpW2VbbisrXV0raVtlW24rK11dK1wiLVwiK2lbZVtuKytdXStpW2VbbisrXV0rXCItXCIraVtlW24rK11dK2lbZVtuKytdXStcIi1cIitpW2VbbisrXV0raVtlW24rK11dK2lbZVtuKytdXStpW2VbbisrXV0raVtlW24rK11dK2lbZVtuKytdXX1mb3IodmFyIHI9W10saT0wO2k8MjU2OysraSlyW2ldPShpKzI1NikudG9TdHJpbmcoMTYpLnN1YnN0cigxKTtlLmV4cG9ydHM9bn0sZnVuY3Rpb24oZSx0LG4pe2Z1bmN0aW9uIHIoZSx0LG4pe3ZhciByPXQmJm58fDA7XCJzdHJpbmdcIj09dHlwZW9mIGUmJih0PVwiYmluYXJ5XCI9PWU/bmV3IEFycmF5KDE2KTpudWxsLGU9bnVsbCksZT1lfHx7fTt2YXIgcz1lLnJhbmRvbXx8KGUucm5nfHxpKSgpO2lmKHNbNl09MTUmc1s2XXw2NCxzWzhdPTYzJnNbOF18MTI4LHQpZm9yKHZhciBhPTA7YTwxNjsrK2EpdFtyK2FdPXNbYV07cmV0dXJuIHR8fG8ocyl9dmFyIGk9big0KSxvPW4oNSk7ZS5leHBvcnRzPXJ9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKGUsdCl7aWYoIShlIGluc3RhbmNlb2YgdCkpdGhyb3cgbmV3IFR5cGVFcnJvcihcIkNhbm5vdCBjYWxsIGEgY2xhc3MgYXMgYSBmdW5jdGlvblwiKX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KTt2YXIgaT1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoZSx0KXtmb3IodmFyIG49MDtuPHQubGVuZ3RoO24rKyl7dmFyIHI9dFtuXTtyLmVudW1lcmFibGU9ci5lbnVtZXJhYmxlfHwhMSxyLmNvbmZpZ3VyYWJsZT0hMCxcInZhbHVlXCJpbiByJiYoci53cml0YWJsZT0hMCksT2JqZWN0LmRlZmluZVByb3BlcnR5KGUsci5rZXkscil9fXJldHVybiBmdW5jdGlvbih0LG4scil7cmV0dXJuIG4mJmUodC5wcm90b3R5cGUsbiksciYmZSh0LHIpLHR9fSgpLG89bigyKSxzPWZ1bmN0aW9uKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX0obyksYT0obig4KSxmdW5jdGlvbigpe2Z1bmN0aW9uIGUodCl7dmFyIG49dC5zZXR1cCxpPXQuZGI7cih0aGlzLGUpLHRoaXMuX2RiPWksdGhpcy5pbnN0YW5jZUlkPVwicG4tXCIrcy5kZWZhdWx0LnY0KCksdGhpcy5zZWNyZXRLZXk9bi5zZWNyZXRLZXl8fG4uc2VjcmV0X2tleSx0aGlzLnN1YnNjcmliZUtleT1uLnN1YnNjcmliZUtleXx8bi5zdWJzY3JpYmVfa2V5LHRoaXMucHVibGlzaEtleT1uLnB1Ymxpc2hLZXl8fG4ucHVibGlzaF9rZXksdGhpcy5zZGtGYW1pbHk9bi5zZGtGYW1pbHksdGhpcy5wYXJ0bmVySWQ9bi5wYXJ0bmVySWQsdGhpcy5zZXRBdXRoS2V5KG4uYXV0aEtleSksdGhpcy5zZXRDaXBoZXJLZXkobi5jaXBoZXJLZXkpLHRoaXMuc2V0RmlsdGVyRXhwcmVzc2lvbihuLmZpbHRlckV4cHJlc3Npb24pLHRoaXMub3JpZ2luPW4ub3JpZ2lufHxcInB1YnN1Yi5wdWJudWIuY29tXCIsdGhpcy5zZWN1cmU9bi5zc2x8fCExLHRoaXMucmVzdG9yZT1uLnJlc3RvcmV8fCExLHRoaXMucHJveHk9bi5wcm94eSx0aGlzLmtlZXBBbGl2ZT1uLmtlZXBBbGl2ZSx0aGlzLmtlZXBBbGl2ZVNldHRpbmdzPW4ua2VlcEFsaXZlU2V0dGluZ3MsXCJ1bmRlZmluZWRcIiE9dHlwZW9mIGxvY2F0aW9uJiZcImh0dHBzOlwiPT09bG9jYXRpb24ucHJvdG9jb2wmJih0aGlzLnNlY3VyZT0hMCksdGhpcy5sb2dWZXJib3NpdHk9bi5sb2dWZXJib3NpdHl8fCExLHRoaXMuc3VwcHJlc3NMZWF2ZUV2ZW50cz1uLnN1cHByZXNzTGVhdmVFdmVudHN8fCExLHRoaXMuYW5ub3VuY2VGYWlsZWRIZWFydGJlYXRzPW4uYW5ub3VuY2VGYWlsZWRIZWFydGJlYXRzfHwhMCx0aGlzLmFubm91bmNlU3VjY2Vzc2Z1bEhlYXJ0YmVhdHM9bi5hbm5vdW5jZVN1Y2Nlc3NmdWxIZWFydGJlYXRzfHwhMSx0aGlzLnVzZUluc3RhbmNlSWQ9bi51c2VJbnN0YW5jZUlkfHwhMSx0aGlzLnVzZVJlcXVlc3RJZD1uLnVzZVJlcXVlc3RJZHx8ITEsdGhpcy5yZXF1ZXN0TWVzc2FnZUNvdW50VGhyZXNob2xkPW4ucmVxdWVzdE1lc3NhZ2VDb3VudFRocmVzaG9sZCx0aGlzLnNldFRyYW5zYWN0aW9uVGltZW91dChuLnRyYW5zYWN0aW9uYWxSZXF1ZXN0VGltZW91dHx8MTVlMyksdGhpcy5zZXRTdWJzY3JpYmVUaW1lb3V0KG4uc3Vic2NyaWJlUmVxdWVzdFRpbWVvdXR8fDMxZTQpLHRoaXMuc2V0U2VuZEJlYWNvbkNvbmZpZyhuLnVzZVNlbmRCZWFjb258fCEwKSx0aGlzLnNldFByZXNlbmNlVGltZW91dChuLnByZXNlbmNlVGltZW91dHx8MzAwKSxuLmhlYXJ0YmVhdEludGVydmFsJiZ0aGlzLnNldEhlYXJ0YmVhdEludGVydmFsKG4uaGVhcnRiZWF0SW50ZXJ2YWwpLHRoaXMuc2V0VVVJRCh0aGlzLl9kZWNpZGVVVUlEKG4udXVpZCkpfXJldHVybiBpKGUsW3trZXk6XCJnZXRBdXRoS2V5XCIsdmFsdWU6ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5hdXRoS2V5fX0se2tleTpcInNldEF1dGhLZXlcIix2YWx1ZTpmdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5hdXRoS2V5PWUsdGhpc319LHtrZXk6XCJzZXRDaXBoZXJLZXlcIix2YWx1ZTpmdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5jaXBoZXJLZXk9ZSx0aGlzfX0se2tleTpcImdldFVVSURcIix2YWx1ZTpmdW5jdGlvbigpe3JldHVybiB0aGlzLlVVSUR9fSx7a2V5Olwic2V0VVVJRFwiLHZhbHVlOmZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLl9kYiYmdGhpcy5fZGIuc2V0JiZ0aGlzLl9kYi5zZXQodGhpcy5zdWJzY3JpYmVLZXkrXCJ1dWlkXCIsZSksdGhpcy5VVUlEPWUsdGhpc319LHtrZXk6XCJnZXRGaWx0ZXJFeHByZXNzaW9uXCIsdmFsdWU6ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5maWx0ZXJFeHByZXNzaW9ufX0se2tleTpcInNldEZpbHRlckV4cHJlc3Npb25cIix2YWx1ZTpmdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5maWx0ZXJFeHByZXNzaW9uPWUsdGhpc319LHtrZXk6XCJnZXRQcmVzZW5jZVRpbWVvdXRcIix2YWx1ZTpmdW5jdGlvbigpe3JldHVybiB0aGlzLl9wcmVzZW5jZVRpbWVvdXR9fSx7a2V5Olwic2V0UHJlc2VuY2VUaW1lb3V0XCIsdmFsdWU6ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX3ByZXNlbmNlVGltZW91dD1lLHRoaXMuc2V0SGVhcnRiZWF0SW50ZXJ2YWwodGhpcy5fcHJlc2VuY2VUaW1lb3V0LzItMSksdGhpc319LHtrZXk6XCJnZXRIZWFydGJlYXRJbnRlcnZhbFwiLHZhbHVlOmZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuX2hlYXJ0YmVhdEludGVydmFsfX0se2tleTpcInNldEhlYXJ0YmVhdEludGVydmFsXCIsdmFsdWU6ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX2hlYXJ0YmVhdEludGVydmFsPWUsdGhpc319LHtrZXk6XCJnZXRTdWJzY3JpYmVUaW1lb3V0XCIsdmFsdWU6ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5fc3Vic2NyaWJlUmVxdWVzdFRpbWVvdXR9fSx7a2V5Olwic2V0U3Vic2NyaWJlVGltZW91dFwiLHZhbHVlOmZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLl9zdWJzY3JpYmVSZXF1ZXN0VGltZW91dD1lLHRoaXN9fSx7a2V5OlwiZ2V0VHJhbnNhY3Rpb25UaW1lb3V0XCIsdmFsdWU6ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5fdHJhbnNhY3Rpb25hbFJlcXVlc3RUaW1lb3V0fX0se2tleTpcInNldFRyYW5zYWN0aW9uVGltZW91dFwiLHZhbHVlOmZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLl90cmFuc2FjdGlvbmFsUmVxdWVzdFRpbWVvdXQ9ZSx0aGlzfX0se2tleTpcImlzU2VuZEJlYWNvbkVuYWJsZWRcIix2YWx1ZTpmdW5jdGlvbigpe3JldHVybiB0aGlzLl91c2VTZW5kQmVhY29ufX0se2tleTpcInNldFNlbmRCZWFjb25Db25maWdcIix2YWx1ZTpmdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fdXNlU2VuZEJlYWNvbj1lLHRoaXN9fSx7a2V5OlwiZ2V0VmVyc2lvblwiLHZhbHVlOmZ1bmN0aW9uKCl7cmV0dXJuXCI0LjguMFwifX0se2tleTpcIl9kZWNpZGVVVUlEXCIsdmFsdWU6ZnVuY3Rpb24oZSl7cmV0dXJuIGU/ZTp0aGlzLl9kYiYmdGhpcy5fZGIuZ2V0JiZ0aGlzLl9kYi5nZXQodGhpcy5zdWJzY3JpYmVLZXkrXCJ1dWlkXCIpP3RoaXMuX2RiLmdldCh0aGlzLnN1YnNjcmliZUtleStcInV1aWRcIik6XCJwbi1cIitzLmRlZmF1bHQudjQoKX19XSksZX0oKSk7dC5kZWZhdWx0PWEsZS5leHBvcnRzPXQuZGVmYXVsdH0sZnVuY3Rpb24oZSx0KXtcInVzZSBzdHJpY3RcIjtlLmV4cG9ydHM9e319LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX1mdW5jdGlvbiBpKGUsdCl7aWYoIShlIGluc3RhbmNlb2YgdCkpdGhyb3cgbmV3IFR5cGVFcnJvcihcIkNhbm5vdCBjYWxsIGEgY2xhc3MgYXMgYSBmdW5jdGlvblwiKX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KTt2YXIgbz1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoZSx0KXtmb3IodmFyIG49MDtuPHQubGVuZ3RoO24rKyl7dmFyIHI9dFtuXTtyLmVudW1lcmFibGU9ci5lbnVtZXJhYmxlfHwhMSxyLmNvbmZpZ3VyYWJsZT0hMCxcInZhbHVlXCJpbiByJiYoci53cml0YWJsZT0hMCksT2JqZWN0LmRlZmluZVByb3BlcnR5KGUsci5rZXkscil9fXJldHVybiBmdW5jdGlvbih0LG4scil7cmV0dXJuIG4mJmUodC5wcm90b3R5cGUsbiksciYmZSh0LHIpLHR9fSgpLHM9big3KSxhPShyKHMpLG4oMTApKSx1PXIoYSksYz1mdW5jdGlvbigpe2Z1bmN0aW9uIGUodCl7dmFyIG49dC5jb25maWc7aSh0aGlzLGUpLHRoaXMuX2NvbmZpZz1uLHRoaXMuX2l2PVwiMDEyMzQ1Njc4OTAxMjM0NVwiLHRoaXMuX2FsbG93ZWRLZXlFbmNvZGluZ3M9W1wiaGV4XCIsXCJ1dGY4XCIsXCJiYXNlNjRcIixcImJpbmFyeVwiXSx0aGlzLl9hbGxvd2VkS2V5TGVuZ3Rocz1bMTI4LDI1Nl0sdGhpcy5fYWxsb3dlZE1vZGVzPVtcImVjYlwiLFwiY2JjXCJdLHRoaXMuX2RlZmF1bHRPcHRpb25zPXtlbmNyeXB0S2V5OiEwLGtleUVuY29kaW5nOlwidXRmOFwiLGtleUxlbmd0aDoyNTYsbW9kZTpcImNiY1wifX1yZXR1cm4gbyhlLFt7a2V5OlwiSE1BQ1NIQTI1NlwiLHZhbHVlOmZ1bmN0aW9uKGUpe3JldHVybiB1LmRlZmF1bHQuSG1hY1NIQTI1NihlLHRoaXMuX2NvbmZpZy5zZWNyZXRLZXkpLnRvU3RyaW5nKHUuZGVmYXVsdC5lbmMuQmFzZTY0KX19LHtrZXk6XCJTSEEyNTZcIix2YWx1ZTpmdW5jdGlvbihlKXtyZXR1cm4gdS5kZWZhdWx0LlNIQTI1NihlKS50b1N0cmluZyh1LmRlZmF1bHQuZW5jLkhleCl9fSx7a2V5OlwiX3BhcnNlT3B0aW9uc1wiLHZhbHVlOmZ1bmN0aW9uKGUpe3ZhciB0PWV8fHt9O3JldHVybiB0Lmhhc093blByb3BlcnR5KFwiZW5jcnlwdEtleVwiKXx8KHQuZW5jcnlwdEtleT10aGlzLl9kZWZhdWx0T3B0aW9ucy5lbmNyeXB0S2V5KSx0Lmhhc093blByb3BlcnR5KFwia2V5RW5jb2RpbmdcIil8fCh0LmtleUVuY29kaW5nPXRoaXMuX2RlZmF1bHRPcHRpb25zLmtleUVuY29kaW5nKSx0Lmhhc093blByb3BlcnR5KFwia2V5TGVuZ3RoXCIpfHwodC5rZXlMZW5ndGg9dGhpcy5fZGVmYXVsdE9wdGlvbnMua2V5TGVuZ3RoKSx0Lmhhc093blByb3BlcnR5KFwibW9kZVwiKXx8KHQubW9kZT10aGlzLl9kZWZhdWx0T3B0aW9ucy5tb2RlKSx0aGlzLl9hbGxvd2VkS2V5RW5jb2RpbmdzLmluZGV4T2YodC5rZXlFbmNvZGluZy50b0xvd2VyQ2FzZSgpKT09PS0xJiYodC5rZXlFbmNvZGluZz10aGlzLl9kZWZhdWx0T3B0aW9ucy5rZXlFbmNvZGluZyksdGhpcy5fYWxsb3dlZEtleUxlbmd0aHMuaW5kZXhPZihwYXJzZUludCh0LmtleUxlbmd0aCwxMCkpPT09LTEmJih0LmtleUxlbmd0aD10aGlzLl9kZWZhdWx0T3B0aW9ucy5rZXlMZW5ndGgpLHRoaXMuX2FsbG93ZWRNb2Rlcy5pbmRleE9mKHQubW9kZS50b0xvd2VyQ2FzZSgpKT09PS0xJiYodC5tb2RlPXRoaXMuX2RlZmF1bHRPcHRpb25zLm1vZGUpLHR9fSx7a2V5OlwiX2RlY29kZUtleVwiLHZhbHVlOmZ1bmN0aW9uKGUsdCl7cmV0dXJuXCJiYXNlNjRcIj09PXQua2V5RW5jb2Rpbmc/dS5kZWZhdWx0LmVuYy5CYXNlNjQucGFyc2UoZSk6XCJoZXhcIj09PXQua2V5RW5jb2Rpbmc/dS5kZWZhdWx0LmVuYy5IZXgucGFyc2UoZSk6ZX19LHtrZXk6XCJfZ2V0UGFkZGVkS2V5XCIsdmFsdWU6ZnVuY3Rpb24oZSx0KXtyZXR1cm4gZT10aGlzLl9kZWNvZGVLZXkoZSx0KSx0LmVuY3J5cHRLZXk/dS5kZWZhdWx0LmVuYy5VdGY4LnBhcnNlKHRoaXMuU0hBMjU2KGUpLnNsaWNlKDAsMzIpKTplfX0se2tleTpcIl9nZXRNb2RlXCIsdmFsdWU6ZnVuY3Rpb24oZSl7cmV0dXJuXCJlY2JcIj09PWUubW9kZT91LmRlZmF1bHQubW9kZS5FQ0I6dS5kZWZhdWx0Lm1vZGUuQ0JDfX0se2tleTpcIl9nZXRJVlwiLHZhbHVlOmZ1bmN0aW9uKGUpe3JldHVyblwiY2JjXCI9PT1lLm1vZGU/dS5kZWZhdWx0LmVuYy5VdGY4LnBhcnNlKHRoaXMuX2l2KTpudWxsfX0se2tleTpcImVuY3J5cHRcIix2YWx1ZTpmdW5jdGlvbihlLHQsbil7aWYoIXQmJiF0aGlzLl9jb25maWcuY2lwaGVyS2V5KXJldHVybiBlO249dGhpcy5fcGFyc2VPcHRpb25zKG4pO3ZhciByPXRoaXMuX2dldElWKG4pLGk9dGhpcy5fZ2V0TW9kZShuKSxvPXRoaXMuX2dldFBhZGRlZEtleSh0fHx0aGlzLl9jb25maWcuY2lwaGVyS2V5LG4pO3JldHVybiB1LmRlZmF1bHQuQUVTLmVuY3J5cHQoZSxvLHtpdjpyLG1vZGU6aX0pLmNpcGhlcnRleHQudG9TdHJpbmcodS5kZWZhdWx0LmVuYy5CYXNlNjQpfHxlfX0se2tleTpcImRlY3J5cHRcIix2YWx1ZTpmdW5jdGlvbihlLHQsbil7aWYoIXQmJiF0aGlzLl9jb25maWcuY2lwaGVyS2V5KXJldHVybiBlO249dGhpcy5fcGFyc2VPcHRpb25zKG4pO3ZhciByPXRoaXMuX2dldElWKG4pLGk9dGhpcy5fZ2V0TW9kZShuKSxvPXRoaXMuX2dldFBhZGRlZEtleSh0fHx0aGlzLl9jb25maWcuY2lwaGVyS2V5LG4pO3RyeXt2YXIgcz11LmRlZmF1bHQuZW5jLkJhc2U2NC5wYXJzZShlKSxhPXUuZGVmYXVsdC5BRVMuZGVjcnlwdCh7Y2lwaGVydGV4dDpzfSxvLHtpdjpyLG1vZGU6aX0pLnRvU3RyaW5nKHUuZGVmYXVsdC5lbmMuVXRmOCk7cmV0dXJuIEpTT04ucGFyc2UoYSl9Y2F0Y2goZSl7cmV0dXJuIG51bGx9fX1dKSxlfSgpO3QuZGVmYXVsdD1jLGUuZXhwb3J0cz10LmRlZmF1bHR9LGZ1bmN0aW9uKGUsdCl7XCJ1c2Ugc3RyaWN0XCI7dmFyIG49bnx8ZnVuY3Rpb24oZSx0KXt2YXIgbj17fSxyPW4ubGliPXt9LGk9ZnVuY3Rpb24oKXt9LG89ci5CYXNlPXtleHRlbmQ6ZnVuY3Rpb24oZSl7aS5wcm90b3R5cGU9dGhpczt2YXIgdD1uZXcgaTtyZXR1cm4gZSYmdC5taXhJbihlKSx0Lmhhc093blByb3BlcnR5KFwiaW5pdFwiKXx8KHQuaW5pdD1mdW5jdGlvbigpe3QuJHN1cGVyLmluaXQuYXBwbHkodGhpcyxhcmd1bWVudHMpfSksdC5pbml0LnByb3RvdHlwZT10LHQuJHN1cGVyPXRoaXMsdH0sY3JlYXRlOmZ1bmN0aW9uKCl7dmFyIGU9dGhpcy5leHRlbmQoKTtyZXR1cm4gZS5pbml0LmFwcGx5KGUsYXJndW1lbnRzKSxlfSxpbml0OmZ1bmN0aW9uKCl7fSxtaXhJbjpmdW5jdGlvbihlKXtmb3IodmFyIHQgaW4gZSllLmhhc093blByb3BlcnR5KHQpJiYodGhpc1t0XT1lW3RdKTtlLmhhc093blByb3BlcnR5KFwidG9TdHJpbmdcIikmJih0aGlzLnRvU3RyaW5nPWUudG9TdHJpbmcpfSxjbG9uZTpmdW5jdGlvbigpe3JldHVybiB0aGlzLmluaXQucHJvdG90eXBlLmV4dGVuZCh0aGlzKX19LHM9ci5Xb3JkQXJyYXk9by5leHRlbmQoe2luaXQ6ZnVuY3Rpb24oZSx0KXtlPXRoaXMud29yZHM9ZXx8W10sdGhpcy5zaWdCeXRlcz12b2lkIDAhPXQ/dDo0KmUubGVuZ3RofSx0b1N0cmluZzpmdW5jdGlvbihlKXtyZXR1cm4oZXx8dSkuc3RyaW5naWZ5KHRoaXMpfSxjb25jYXQ6ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy53b3JkcyxuPWUud29yZHMscj10aGlzLnNpZ0J5dGVzO2lmKGU9ZS5zaWdCeXRlcyx0aGlzLmNsYW1wKCksciU0KWZvcih2YXIgaT0wO2k8ZTtpKyspdFtyK2k+Pj4yXXw9KG5baT4+PjJdPj4+MjQtaSU0KjgmMjU1KTw8MjQtKHIraSklNCo4O2Vsc2UgaWYoNjU1MzU8bi5sZW5ndGgpZm9yKGk9MDtpPGU7aSs9NCl0W3IraT4+PjJdPW5baT4+PjJdO2Vsc2UgdC5wdXNoLmFwcGx5KHQsbik7cmV0dXJuIHRoaXMuc2lnQnl0ZXMrPWUsdGhpc30sY2xhbXA6ZnVuY3Rpb24oKXt2YXIgdD10aGlzLndvcmRzLG49dGhpcy5zaWdCeXRlczt0W24+Pj4yXSY9NDI5NDk2NzI5NTw8MzItbiU0KjgsdC5sZW5ndGg9ZS5jZWlsKG4vNCl9LGNsb25lOmZ1bmN0aW9uKCl7dmFyIGU9by5jbG9uZS5jYWxsKHRoaXMpO3JldHVybiBlLndvcmRzPXRoaXMud29yZHMuc2xpY2UoMCksZX0scmFuZG9tOmZ1bmN0aW9uKHQpe2Zvcih2YXIgbj1bXSxyPTA7cjx0O3IrPTQpbi5wdXNoKDQyOTQ5NjcyOTYqZS5yYW5kb20oKXwwKTtyZXR1cm4gbmV3IHMuaW5pdChuLHQpfX0pLGE9bi5lbmM9e30sdT1hLkhleD17c3RyaW5naWZ5OmZ1bmN0aW9uKGUpe3ZhciB0PWUud29yZHM7ZT1lLnNpZ0J5dGVzO2Zvcih2YXIgbj1bXSxyPTA7cjxlO3IrKyl7dmFyIGk9dFtyPj4+Ml0+Pj4yNC1yJTQqOCYyNTU7bi5wdXNoKChpPj4+NCkudG9TdHJpbmcoMTYpKSxuLnB1c2goKDE1JmkpLnRvU3RyaW5nKDE2KSl9cmV0dXJuIG4uam9pbihcIlwiKX0scGFyc2U6ZnVuY3Rpb24oZSl7Zm9yKHZhciB0PWUubGVuZ3RoLG49W10scj0wO3I8dDtyKz0yKW5bcj4+PjNdfD1wYXJzZUludChlLnN1YnN0cihyLDIpLDE2KTw8MjQtciU4KjQ7cmV0dXJuIG5ldyBzLmluaXQobix0LzIpfX0sYz1hLkxhdGluMT17c3RyaW5naWZ5OmZ1bmN0aW9uKGUpe3ZhciB0PWUud29yZHM7ZT1lLnNpZ0J5dGVzO2Zvcih2YXIgbj1bXSxyPTA7cjxlO3IrKyluLnB1c2goU3RyaW5nLmZyb21DaGFyQ29kZSh0W3I+Pj4yXT4+PjI0LXIlNCo4JjI1NSkpO3JldHVybiBuLmpvaW4oXCJcIil9LHBhcnNlOmZ1bmN0aW9uKGUpe2Zvcih2YXIgdD1lLmxlbmd0aCxuPVtdLHI9MDtyPHQ7cisrKW5bcj4+PjJdfD0oMjU1JmUuY2hhckNvZGVBdChyKSk8PDI0LXIlNCo4O3JldHVybiBuZXcgcy5pbml0KG4sdCl9fSxsPWEuVXRmOD17c3RyaW5naWZ5OmZ1bmN0aW9uKGUpe3RyeXtyZXR1cm4gZGVjb2RlVVJJQ29tcG9uZW50KGVzY2FwZShjLnN0cmluZ2lmeShlKSkpfWNhdGNoKGUpe3Rocm93IEVycm9yKFwiTWFsZm9ybWVkIFVURi04IGRhdGFcIil9fSxwYXJzZTpmdW5jdGlvbihlKXtyZXR1cm4gYy5wYXJzZSh1bmVzY2FwZShlbmNvZGVVUklDb21wb25lbnQoZSkpKX19LGg9ci5CdWZmZXJlZEJsb2NrQWxnb3JpdGhtPW8uZXh0ZW5kKHtyZXNldDpmdW5jdGlvbigpe3RoaXMuX2RhdGE9bmV3IHMuaW5pdCx0aGlzLl9uRGF0YUJ5dGVzPTB9LF9hcHBlbmQ6ZnVuY3Rpb24oZSl7XCJzdHJpbmdcIj09dHlwZW9mIGUmJihlPWwucGFyc2UoZSkpLHRoaXMuX2RhdGEuY29uY2F0KGUpLHRoaXMuX25EYXRhQnl0ZXMrPWUuc2lnQnl0ZXN9LF9wcm9jZXNzOmZ1bmN0aW9uKHQpe3ZhciBuPXRoaXMuX2RhdGEscj1uLndvcmRzLGk9bi5zaWdCeXRlcyxvPXRoaXMuYmxvY2tTaXplLGE9aS8oNCpvKSxhPXQ/ZS5jZWlsKGEpOmUubWF4KCgwfGEpLXRoaXMuX21pbkJ1ZmZlclNpemUsMCk7aWYodD1hKm8saT1lLm1pbig0KnQsaSksdCl7Zm9yKHZhciB1PTA7dTx0O3UrPW8pdGhpcy5fZG9Qcm9jZXNzQmxvY2socix1KTt1PXIuc3BsaWNlKDAsdCksbi5zaWdCeXRlcy09aX1yZXR1cm4gbmV3IHMuaW5pdCh1LGkpfSxjbG9uZTpmdW5jdGlvbigpe3ZhciBlPW8uY2xvbmUuY2FsbCh0aGlzKTtyZXR1cm4gZS5fZGF0YT10aGlzLl9kYXRhLmNsb25lKCksZX0sX21pbkJ1ZmZlclNpemU6MH0pO3IuSGFzaGVyPWguZXh0ZW5kKHtjZmc6by5leHRlbmQoKSxpbml0OmZ1bmN0aW9uKGUpe3RoaXMuY2ZnPXRoaXMuY2ZnLmV4dGVuZChlKSx0aGlzLnJlc2V0KCl9LHJlc2V0OmZ1bmN0aW9uKCl7aC5yZXNldC5jYWxsKHRoaXMpLHRoaXMuX2RvUmVzZXQoKX0sdXBkYXRlOmZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLl9hcHBlbmQoZSksdGhpcy5fcHJvY2VzcygpLHRoaXN9LGZpbmFsaXplOmZ1bmN0aW9uKGUpe3JldHVybiBlJiZ0aGlzLl9hcHBlbmQoZSksdGhpcy5fZG9GaW5hbGl6ZSgpfSxibG9ja1NpemU6MTYsX2NyZWF0ZUhlbHBlcjpmdW5jdGlvbihlKXtyZXR1cm4gZnVuY3Rpb24odCxuKXtyZXR1cm4gbmV3IGUuaW5pdChuKS5maW5hbGl6ZSh0KX19LF9jcmVhdGVIbWFjSGVscGVyOmZ1bmN0aW9uKGUpe3JldHVybiBmdW5jdGlvbih0LG4pe3JldHVybiBuZXcgZi5ITUFDLmluaXQoZSxuKS5maW5hbGl6ZSh0KX19fSk7dmFyIGY9bi5hbGdvPXt9O3JldHVybiBufShNYXRoKTshZnVuY3Rpb24oZSl7Zm9yKHZhciB0PW4scj10LmxpYixpPXIuV29yZEFycmF5LG89ci5IYXNoZXIscj10LmFsZ28scz1bXSxhPVtdLHU9ZnVuY3Rpb24oZSl7cmV0dXJuIDQyOTQ5NjcyOTYqKGUtKDB8ZSkpfDB9LGM9MixsPTA7NjQ+bDspe3ZhciBoO2U6e2g9Yztmb3IodmFyIGY9ZS5zcXJ0KGgpLGQ9MjtkPD1mO2QrKylpZighKGglZCkpe2g9ITE7YnJlYWsgZX1oPSEwfWgmJig4PmwmJihzW2xdPXUoZS5wb3coYywuNSkpKSxhW2xdPXUoZS5wb3coYywxLzMpKSxsKyspLGMrK312YXIgcD1bXSxyPXIuU0hBMjU2PW8uZXh0ZW5kKHtfZG9SZXNldDpmdW5jdGlvbigpe3RoaXMuX2hhc2g9bmV3IGkuaW5pdChzLnNsaWNlKDApKX0sX2RvUHJvY2Vzc0Jsb2NrOmZ1bmN0aW9uKGUsdCl7Zm9yKHZhciBuPXRoaXMuX2hhc2gud29yZHMscj1uWzBdLGk9blsxXSxvPW5bMl0scz1uWzNdLHU9bls0XSxjPW5bNV0sbD1uWzZdLGg9bls3XSxmPTA7NjQ+ZjtmKyspe2lmKDE2PmYpcFtmXT0wfGVbdCtmXTtlbHNle3ZhciBkPXBbZi0xNV0sZz1wW2YtMl07cFtmXT0oKGQ8PDI1fGQ+Pj43KV4oZDw8MTR8ZD4+PjE4KV5kPj4+MykrcFtmLTddKygoZzw8MTV8Zz4+PjE3KV4oZzw8MTN8Zz4+PjE5KV5nPj4+MTApK3BbZi0xNl19ZD1oKygodTw8MjZ8dT4+PjYpXih1PDwyMXx1Pj4+MTEpXih1PDw3fHU+Pj4yNSkpKyh1JmNefnUmbCkrYVtmXStwW2ZdLGc9KChyPDwzMHxyPj4+MileKHI8PDE5fHI+Pj4xMyleKHI8PDEwfHI+Pj4yMikpKyhyJmleciZvXmkmbyksaD1sLGw9YyxjPXUsdT1zK2R8MCxzPW8sbz1pLGk9cixyPWQrZ3wwfW5bMF09blswXStyfDAsblsxXT1uWzFdK2l8MCxuWzJdPW5bMl0rb3wwLG5bM109blszXStzfDAsbls0XT1uWzRdK3V8MCxuWzVdPW5bNV0rY3wwLG5bNl09bls2XStsfDAsbls3XT1uWzddK2h8MH0sX2RvRmluYWxpemU6ZnVuY3Rpb24oKXt2YXIgdD10aGlzLl9kYXRhLG49dC53b3JkcyxyPTgqdGhpcy5fbkRhdGFCeXRlcyxpPTgqdC5zaWdCeXRlcztyZXR1cm4gbltpPj4+NV18PTEyODw8MjQtaSUzMixuWzE0KyhpKzY0Pj4+OTw8NCldPWUuZmxvb3Ioci80Mjk0OTY3Mjk2KSxuWzE1KyhpKzY0Pj4+OTw8NCldPXIsdC5zaWdCeXRlcz00Km4ubGVuZ3RoLHRoaXMuX3Byb2Nlc3MoKSx0aGlzLl9oYXNofSxjbG9uZTpmdW5jdGlvbigpe3ZhciBlPW8uY2xvbmUuY2FsbCh0aGlzKTtyZXR1cm4gZS5faGFzaD10aGlzLl9oYXNoLmNsb25lKCksZX19KTt0LlNIQTI1Nj1vLl9jcmVhdGVIZWxwZXIociksdC5IbWFjU0hBMjU2PW8uX2NyZWF0ZUhtYWNIZWxwZXIocil9KE1hdGgpLGZ1bmN0aW9uKCl7dmFyIGU9bix0PWUuZW5jLlV0Zjg7ZS5hbGdvLkhNQUM9ZS5saWIuQmFzZS5leHRlbmQoe2luaXQ6ZnVuY3Rpb24oZSxuKXtlPXRoaXMuX2hhc2hlcj1uZXcgZS5pbml0LFwic3RyaW5nXCI9PXR5cGVvZiBuJiYobj10LnBhcnNlKG4pKTt2YXIgcj1lLmJsb2NrU2l6ZSxpPTQqcjtuLnNpZ0J5dGVzPmkmJihuPWUuZmluYWxpemUobikpLG4uY2xhbXAoKTtmb3IodmFyIG89dGhpcy5fb0tleT1uLmNsb25lKCkscz10aGlzLl9pS2V5PW4uY2xvbmUoKSxhPW8ud29yZHMsdT1zLndvcmRzLGM9MDtjPHI7YysrKWFbY11ePTE1NDk1NTY4MjgsdVtjXV49OTA5NTIyNDg2O28uc2lnQnl0ZXM9cy5zaWdCeXRlcz1pLHRoaXMucmVzZXQoKX0scmVzZXQ6ZnVuY3Rpb24oKXt2YXIgZT10aGlzLl9oYXNoZXI7ZS5yZXNldCgpLGUudXBkYXRlKHRoaXMuX2lLZXkpfSx1cGRhdGU6ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX2hhc2hlci51cGRhdGUoZSksdGhpc30sZmluYWxpemU6ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy5faGFzaGVyO3JldHVybiBlPXQuZmluYWxpemUoZSksdC5yZXNldCgpLHQuZmluYWxpemUodGhpcy5fb0tleS5jbG9uZSgpLmNvbmNhdChlKSl9fSl9KCksZnVuY3Rpb24oKXt2YXIgZT1uLHQ9ZS5saWIuV29yZEFycmF5O2UuZW5jLkJhc2U2ND17c3RyaW5naWZ5OmZ1bmN0aW9uKGUpe3ZhciB0PWUud29yZHMsbj1lLnNpZ0J5dGVzLHI9dGhpcy5fbWFwO2UuY2xhbXAoKSxlPVtdO2Zvcih2YXIgaT0wO2k8bjtpKz0zKWZvcih2YXIgbz0odFtpPj4+Ml0+Pj4yNC1pJTQqOCYyNTUpPDwxNnwodFtpKzE+Pj4yXT4+PjI0LShpKzEpJTQqOCYyNTUpPDw4fHRbaSsyPj4+Ml0+Pj4yNC0oaSsyKSU0KjgmMjU1LHM9MDs0PnMmJmkrLjc1KnM8bjtzKyspZS5wdXNoKHIuY2hhckF0KG8+Pj42KigzLXMpJjYzKSk7aWYodD1yLmNoYXJBdCg2NCkpZm9yKDtlLmxlbmd0aCU0OyllLnB1c2godCk7cmV0dXJuIGUuam9pbihcIlwiKX0scGFyc2U6ZnVuY3Rpb24oZSl7dmFyIG49ZS5sZW5ndGgscj10aGlzLl9tYXAsaT1yLmNoYXJBdCg2NCk7aSYmLTEhPShpPWUuaW5kZXhPZihpKSkmJihuPWkpO2Zvcih2YXIgaT1bXSxvPTAscz0wO3M8bjtzKyspaWYocyU0KXt2YXIgYT1yLmluZGV4T2YoZS5jaGFyQXQocy0xKSk8PHMlNCoyLHU9ci5pbmRleE9mKGUuY2hhckF0KHMpKT4+PjYtcyU0KjI7aVtvPj4+Ml18PShhfHUpPDwyNC1vJTQqOCxvKyt9cmV0dXJuIHQuY3JlYXRlKGksbyl9LF9tYXA6XCJBQkNERUZHSElKS0xNTk9QUVJTVFVWV1hZWmFiY2RlZmdoaWprbG1ub3BxcnN0dXZ3eHl6MDEyMzQ1Njc4OSsvPVwifX0oKSxmdW5jdGlvbihlKXtmdW5jdGlvbiB0KGUsdCxuLHIsaSxvLHMpe3JldHVybigoZT1lKyh0Jm58fnQmcikraStzKTw8b3xlPj4+MzItbykrdH1mdW5jdGlvbiByKGUsdCxuLHIsaSxvLHMpe3JldHVybigoZT1lKyh0JnJ8biZ+cikraStzKTw8b3xlPj4+MzItbykrdH1mdW5jdGlvbiBpKGUsdCxuLHIsaSxvLHMpe3JldHVybigoZT1lKyh0Xm5ecikraStzKTw8b3xlPj4+MzItbykrdH1mdW5jdGlvbiBvKGUsdCxuLHIsaSxvLHMpe3JldHVybigoZT1lKyhuXih0fH5yKSkraStzKTw8b3xlPj4+MzItbykrdH1mb3IodmFyIHM9bixhPXMubGliLHU9YS5Xb3JkQXJyYXksYz1hLkhhc2hlcixhPXMuYWxnbyxsPVtdLGg9MDs2ND5oO2grKylsW2hdPTQyOTQ5NjcyOTYqZS5hYnMoZS5zaW4oaCsxKSl8MDthPWEuTUQ1PWMuZXh0ZW5kKHtfZG9SZXNldDpmdW5jdGlvbigpe3RoaXMuX2hhc2g9bmV3IHUuaW5pdChbMTczMjU4NDE5Myw0MDIzMjMzNDE3LDI1NjIzODMxMDIsMjcxNzMzODc4XSl9LF9kb1Byb2Nlc3NCbG9jazpmdW5jdGlvbihlLG4pe2Zvcih2YXIgcz0wOzE2PnM7cysrKXt2YXIgYT1uK3MsdT1lW2FdO2VbYV09MTY3MTE5MzUmKHU8PDh8dT4+PjI0KXw0Mjc4MjU1MzYwJih1PDwyNHx1Pj4+OCl9dmFyIHM9dGhpcy5faGFzaC53b3JkcyxhPWVbbiswXSx1PWVbbisxXSxjPWVbbisyXSxoPWVbbiszXSxmPWVbbis0XSxkPWVbbis1XSxwPWVbbis2XSxnPWVbbis3XSx5PWVbbis4XSx2PWVbbis5XSxiPWVbbisxMF0sXz1lW24rMTFdLG09ZVtuKzEyXSxrPWVbbisxM10sUD1lW24rMTRdLFM9ZVtuKzE1XSxPPXNbMF0sdz1zWzFdLFQ9c1syXSxDPXNbM10sTz10KE8sdyxULEMsYSw3LGxbMF0pLEM9dChDLE8sdyxULHUsMTIsbFsxXSksVD10KFQsQyxPLHcsYywxNyxsWzJdKSx3PXQodyxULEMsTyxoLDIyLGxbM10pLE89dChPLHcsVCxDLGYsNyxsWzRdKSxDPXQoQyxPLHcsVCxkLDEyLGxbNV0pLFQ9dChULEMsTyx3LHAsMTcsbFs2XSksdz10KHcsVCxDLE8sZywyMixsWzddKSxPPXQoTyx3LFQsQyx5LDcsbFs4XSksQz10KEMsTyx3LFQsdiwxMixsWzldKSxUPXQoVCxDLE8sdyxiLDE3LGxbMTBdKSx3PXQodyxULEMsTyxfLDIyLGxbMTFdKSxPPXQoTyx3LFQsQyxtLDcsbFsxMl0pLEM9dChDLE8sdyxULGssMTIsbFsxM10pLFQ9dChULEMsTyx3LFAsMTcsbFsxNF0pLHc9dCh3LFQsQyxPLFMsMjIsbFsxNV0pLE89cihPLHcsVCxDLHUsNSxsWzE2XSksQz1yKEMsTyx3LFQscCw5LGxbMTddKSxUPXIoVCxDLE8sdyxfLDE0LGxbMThdKSx3PXIodyxULEMsTyxhLDIwLGxbMTldKSxPPXIoTyx3LFQsQyxkLDUsbFsyMF0pLEM9cihDLE8sdyxULGIsOSxsWzIxXSksVD1yKFQsQyxPLHcsUywxNCxsWzIyXSksdz1yKHcsVCxDLE8sZiwyMCxsWzIzXSksTz1yKE8sdyxULEMsdiw1LGxbMjRdKSxDPXIoQyxPLHcsVCxQLDksbFsyNV0pLFQ9cihULEMsTyx3LGgsMTQsbFsyNl0pLHc9cih3LFQsQyxPLHksMjAsbFsyN10pLE89cihPLHcsVCxDLGssNSxsWzI4XSksQz1yKEMsTyx3LFQsYyw5LGxbMjldKSxUPXIoVCxDLE8sdyxnLDE0LGxbMzBdKSx3PXIodyxULEMsTyxtLDIwLGxbMzFdKSxPPWkoTyx3LFQsQyxkLDQsbFszMl0pLEM9aShDLE8sdyxULHksMTEsbFszM10pLFQ9aShULEMsTyx3LF8sMTYsbFszNF0pLHc9aSh3LFQsQyxPLFAsMjMsbFszNV0pLE89aShPLHcsVCxDLHUsNCxsWzM2XSksQz1pKEMsTyx3LFQsZiwxMSxsWzM3XSksVD1pKFQsQyxPLHcsZywxNixsWzM4XSksdz1pKHcsVCxDLE8sYiwyMyxsWzM5XSksTz1pKE8sdyxULEMsayw0LGxbNDBdKSxDPWkoQyxPLHcsVCxhLDExLGxbNDFdKSxUPWkoVCxDLE8sdyxoLDE2LGxbNDJdKSx3PWkodyxULEMsTyxwLDIzLGxbNDNdKSxPPWkoTyx3LFQsQyx2LDQsbFs0NF0pLEM9aShDLE8sdyxULG0sMTEsbFs0NV0pLFQ9aShULEMsTyx3LFMsMTYsbFs0Nl0pLHc9aSh3LFQsQyxPLGMsMjMsbFs0N10pLE89byhPLHcsVCxDLGEsNixsWzQ4XSksQz1vKEMsTyx3LFQsZywxMCxsWzQ5XSksVD1vKFQsQyxPLHcsUCwxNSxsWzUwXSksdz1vKHcsVCxDLE8sZCwyMSxsWzUxXSksTz1vKE8sdyxULEMsbSw2LGxbNTJdKSxDPW8oQyxPLHcsVCxoLDEwLGxbNTNdKSxUPW8oVCxDLE8sdyxiLDE1LGxbNTRdKSx3PW8odyxULEMsTyx1LDIxLGxbNTVdKSxPPW8oTyx3LFQsQyx5LDYsbFs1Nl0pLEM9byhDLE8sdyxULFMsMTAsbFs1N10pLFQ9byhULEMsTyx3LHAsMTUsbFs1OF0pLHc9byh3LFQsQyxPLGssMjEsbFs1OV0pLE89byhPLHcsVCxDLGYsNixsWzYwXSksQz1vKEMsTyx3LFQsXywxMCxsWzYxXSksVD1vKFQsQyxPLHcsYywxNSxsWzYyXSksdz1vKHcsVCxDLE8sdiwyMSxsWzYzXSk7c1swXT1zWzBdK098MCxzWzFdPXNbMV0rd3wwLHNbMl09c1syXStUfDAsc1szXT1zWzNdK0N8MH0sX2RvRmluYWxpemU6ZnVuY3Rpb24oKXt2YXIgdD10aGlzLl9kYXRhLG49dC53b3JkcyxyPTgqdGhpcy5fbkRhdGFCeXRlcyxpPTgqdC5zaWdCeXRlcztuW2k+Pj41XXw9MTI4PDwyNC1pJTMyO3ZhciBvPWUuZmxvb3Ioci80Mjk0OTY3Mjk2KTtmb3IoblsxNSsoaSs2ND4+Pjk8PDQpXT0xNjcxMTkzNSYobzw8OHxvPj4+MjQpfDQyNzgyNTUzNjAmKG88PDI0fG8+Pj44KSxuWzE0KyhpKzY0Pj4+OTw8NCldPTE2NzExOTM1JihyPDw4fHI+Pj4yNCl8NDI3ODI1NTM2MCYocjw8MjR8cj4+PjgpLHQuc2lnQnl0ZXM9NCoobi5sZW5ndGgrMSksdGhpcy5fcHJvY2VzcygpLHQ9dGhpcy5faGFzaCxuPXQud29yZHMscj0wOzQ+cjtyKyspaT1uW3JdLG5bcl09MTY3MTE5MzUmKGk8PDh8aT4+PjI0KXw0Mjc4MjU1MzYwJihpPDwyNHxpPj4+OCk7cmV0dXJuIHR9LGNsb25lOmZ1bmN0aW9uKCl7dmFyIGU9Yy5jbG9uZS5jYWxsKHRoaXMpO3JldHVybiBlLl9oYXNoPXRoaXMuX2hhc2guY2xvbmUoKSxlfX0pLHMuTUQ1PWMuX2NyZWF0ZUhlbHBlcihhKSxzLkhtYWNNRDU9Yy5fY3JlYXRlSG1hY0hlbHBlcihhKX0oTWF0aCksZnVuY3Rpb24oKXt2YXIgZT1uLHQ9ZS5saWIscj10LkJhc2UsaT10LldvcmRBcnJheSx0PWUuYWxnbyxvPXQuRXZwS0RGPXIuZXh0ZW5kKHtjZmc6ci5leHRlbmQoe2tleVNpemU6NCxoYXNoZXI6dC5NRDUsaXRlcmF0aW9uczoxfSksaW5pdDpmdW5jdGlvbihlKXt0aGlzLmNmZz10aGlzLmNmZy5leHRlbmQoZSl9LGNvbXB1dGU6ZnVuY3Rpb24oZSx0KXtmb3IodmFyIG49dGhpcy5jZmcscj1uLmhhc2hlci5jcmVhdGUoKSxvPWkuY3JlYXRlKCkscz1vLndvcmRzLGE9bi5rZXlTaXplLG49bi5pdGVyYXRpb25zO3MubGVuZ3RoPGE7KXt1JiZyLnVwZGF0ZSh1KTt2YXIgdT1yLnVwZGF0ZShlKS5maW5hbGl6ZSh0KTtyLnJlc2V0KCk7Zm9yKHZhciBjPTE7YzxuO2MrKyl1PXIuZmluYWxpemUodSksci5yZXNldCgpO28uY29uY2F0KHUpfXJldHVybiBvLnNpZ0J5dGVzPTQqYSxvfX0pO2UuRXZwS0RGPWZ1bmN0aW9uKGUsdCxuKXtyZXR1cm4gby5jcmVhdGUobikuY29tcHV0ZShlLHQpfX0oKSxuLmxpYi5DaXBoZXJ8fGZ1bmN0aW9uKGUpe3ZhciB0PW4scj10LmxpYixpPXIuQmFzZSxvPXIuV29yZEFycmF5LHM9ci5CdWZmZXJlZEJsb2NrQWxnb3JpdGhtLGE9dC5lbmMuQmFzZTY0LHU9dC5hbGdvLkV2cEtERixjPXIuQ2lwaGVyPXMuZXh0ZW5kKHtjZmc6aS5leHRlbmQoKSxjcmVhdGVFbmNyeXB0b3I6ZnVuY3Rpb24oZSx0KXtyZXR1cm4gdGhpcy5jcmVhdGUodGhpcy5fRU5DX1hGT1JNX01PREUsZSx0KX0sY3JlYXRlRGVjcnlwdG9yOmZ1bmN0aW9uKGUsdCl7cmV0dXJuIHRoaXMuY3JlYXRlKHRoaXMuX0RFQ19YRk9STV9NT0RFLGUsdCl9LGluaXQ6ZnVuY3Rpb24oZSx0LG4pe3RoaXMuY2ZnPXRoaXMuY2ZnLmV4dGVuZChuKSx0aGlzLl94Zm9ybU1vZGU9ZSx0aGlzLl9rZXk9dCx0aGlzLnJlc2V0KCl9LHJlc2V0OmZ1bmN0aW9uKCl7cy5yZXNldC5jYWxsKHRoaXMpLHRoaXMuX2RvUmVzZXQoKX0scHJvY2VzczpmdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fYXBwZW5kKGUpLHRoaXMuX3Byb2Nlc3MoKX0sZmluYWxpemU6ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJnRoaXMuX2FwcGVuZChlKSx0aGlzLl9kb0ZpbmFsaXplKCl9LGtleVNpemU6NCxpdlNpemU6NCxfRU5DX1hGT1JNX01PREU6MSxfREVDX1hGT1JNX01PREU6MixfY3JlYXRlSGVscGVyOmZ1bmN0aW9uKGUpe3JldHVybntlbmNyeXB0OmZ1bmN0aW9uKHQsbixyKXtyZXR1cm4oXCJzdHJpbmdcIj09dHlwZW9mIG4/ZzpwKS5lbmNyeXB0KGUsdCxuLHIpfSxkZWNyeXB0OmZ1bmN0aW9uKHQsbixyKXtyZXR1cm4oXCJzdHJpbmdcIj09dHlwZW9mIG4/ZzpwKS5kZWNyeXB0KGUsdCxuLHIpfX19fSk7ci5TdHJlYW1DaXBoZXI9Yy5leHRlbmQoe19kb0ZpbmFsaXplOmZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuX3Byb2Nlc3MoITApfSxibG9ja1NpemU6MX0pO3ZhciBsPXQubW9kZT17fSxoPWZ1bmN0aW9uKGUsdCxuKXt2YXIgcj10aGlzLl9pdjtyP3RoaXMuX2l2PXZvaWQgMDpyPXRoaXMuX3ByZXZCbG9jaztmb3IodmFyIGk9MDtpPG47aSsrKWVbdCtpXV49cltpXX0sZj0oci5CbG9ja0NpcGhlck1vZGU9aS5leHRlbmQoe2NyZWF0ZUVuY3J5cHRvcjpmdW5jdGlvbihlLHQpe3JldHVybiB0aGlzLkVuY3J5cHRvci5jcmVhdGUoZSx0KX0sY3JlYXRlRGVjcnlwdG9yOmZ1bmN0aW9uKGUsdCl7cmV0dXJuIHRoaXMuRGVjcnlwdG9yLmNyZWF0ZShlLHQpfSxpbml0OmZ1bmN0aW9uKGUsdCl7dGhpcy5fY2lwaGVyPWUsdGhpcy5faXY9dH19KSkuZXh0ZW5kKCk7Zi5FbmNyeXB0b3I9Zi5leHRlbmQoe3Byb2Nlc3NCbG9jazpmdW5jdGlvbihlLHQpe3ZhciBuPXRoaXMuX2NpcGhlcixyPW4uYmxvY2tTaXplO2guY2FsbCh0aGlzLGUsdCxyKSxuLmVuY3J5cHRCbG9jayhlLHQpLHRoaXMuX3ByZXZCbG9jaz1lLnNsaWNlKHQsdCtyKX19KSxmLkRlY3J5cHRvcj1mLmV4dGVuZCh7cHJvY2Vzc0Jsb2NrOmZ1bmN0aW9uKGUsdCl7dmFyIG49dGhpcy5fY2lwaGVyLHI9bi5ibG9ja1NpemUsaT1lLnNsaWNlKHQsdCtyKTtuLmRlY3J5cHRCbG9jayhlLHQpLGguY2FsbCh0aGlzLGUsdCxyKSx0aGlzLl9wcmV2QmxvY2s9aX19KSxsPWwuQ0JDPWYsZj0odC5wYWQ9e30pLlBrY3M3PXtwYWQ6ZnVuY3Rpb24oZSx0KXtmb3IodmFyIG49NCp0LG49bi1lLnNpZ0J5dGVzJW4scj1uPDwyNHxuPDwxNnxuPDw4fG4saT1bXSxzPTA7czxuO3MrPTQpaS5wdXNoKHIpO249by5jcmVhdGUoaSxuKSxlLmNvbmNhdChuKX0sdW5wYWQ6ZnVuY3Rpb24oZSl7ZS5zaWdCeXRlcy09MjU1JmUud29yZHNbZS5zaWdCeXRlcy0xPj4+Ml19fSxyLkJsb2NrQ2lwaGVyPWMuZXh0ZW5kKHtjZmc6Yy5jZmcuZXh0ZW5kKHttb2RlOmwscGFkZGluZzpmfSkscmVzZXQ6ZnVuY3Rpb24oKXtjLnJlc2V0LmNhbGwodGhpcyk7dmFyIGU9dGhpcy5jZmcsdD1lLml2LGU9ZS5tb2RlO2lmKHRoaXMuX3hmb3JtTW9kZT09dGhpcy5fRU5DX1hGT1JNX01PREUpdmFyIG49ZS5jcmVhdGVFbmNyeXB0b3I7ZWxzZSBuPWUuY3JlYXRlRGVjcnlwdG9yLHRoaXMuX21pbkJ1ZmZlclNpemU9MTt0aGlzLl9tb2RlPW4uY2FsbChlLHRoaXMsdCYmdC53b3Jkcyl9LF9kb1Byb2Nlc3NCbG9jazpmdW5jdGlvbihlLHQpe3RoaXMuX21vZGUucHJvY2Vzc0Jsb2NrKGUsdCl9LF9kb0ZpbmFsaXplOmZ1bmN0aW9uKCl7dmFyIGU9dGhpcy5jZmcucGFkZGluZztpZih0aGlzLl94Zm9ybU1vZGU9PXRoaXMuX0VOQ19YRk9STV9NT0RFKXtlLnBhZCh0aGlzLl9kYXRhLHRoaXMuYmxvY2tTaXplKTt2YXIgdD10aGlzLl9wcm9jZXNzKCEwKX1lbHNlIHQ9dGhpcy5fcHJvY2VzcyghMCksZS51bnBhZCh0KTtyZXR1cm4gdH0sYmxvY2tTaXplOjR9KTt2YXIgZD1yLkNpcGhlclBhcmFtcz1pLmV4dGVuZCh7aW5pdDpmdW5jdGlvbihlKXt0aGlzLm1peEluKGUpfSx0b1N0cmluZzpmdW5jdGlvbihlKXtyZXR1cm4oZXx8dGhpcy5mb3JtYXR0ZXIpLnN0cmluZ2lmeSh0aGlzKX19KSxsPSh0LmZvcm1hdD17fSkuT3BlblNTTD17c3RyaW5naWZ5OmZ1bmN0aW9uKGUpe3ZhciB0PWUuY2lwaGVydGV4dDtyZXR1cm4gZT1lLnNhbHQsKGU/by5jcmVhdGUoWzEzOTg4OTM2ODQsMTcwMTA3NjgzMV0pLmNvbmNhdChlKS5jb25jYXQodCk6dCkudG9TdHJpbmcoYSl9LHBhcnNlOmZ1bmN0aW9uKGUpe2U9YS5wYXJzZShlKTt2YXIgdD1lLndvcmRzO2lmKDEzOTg4OTM2ODQ9PXRbMF0mJjE3MDEwNzY4MzE9PXRbMV0pe3ZhciBuPW8uY3JlYXRlKHQuc2xpY2UoMiw0KSk7dC5zcGxpY2UoMCw0KSxlLnNpZ0J5dGVzLT0xNn1yZXR1cm4gZC5jcmVhdGUoe2NpcGhlcnRleHQ6ZSxzYWx0Om59KX19LHA9ci5TZXJpYWxpemFibGVDaXBoZXI9aS5leHRlbmQoe2NmZzppLmV4dGVuZCh7Zm9ybWF0Omx9KSxlbmNyeXB0OmZ1bmN0aW9uKGUsdCxuLHIpe3I9dGhpcy5jZmcuZXh0ZW5kKHIpO3ZhciBpPWUuY3JlYXRlRW5jcnlwdG9yKG4scik7cmV0dXJuIHQ9aS5maW5hbGl6ZSh0KSxpPWkuY2ZnLGQuY3JlYXRlKHtjaXBoZXJ0ZXh0OnQsa2V5Om4saXY6aS5pdixhbGdvcml0aG06ZSxtb2RlOmkubW9kZSxwYWRkaW5nOmkucGFkZGluZyxibG9ja1NpemU6ZS5ibG9ja1NpemUsZm9ybWF0dGVyOnIuZm9ybWF0fSl9LGRlY3J5cHQ6ZnVuY3Rpb24oZSx0LG4scil7cmV0dXJuIHI9dGhpcy5jZmcuZXh0ZW5kKHIpLHQ9dGhpcy5fcGFyc2UodCxyLmZvcm1hdCksZS5jcmVhdGVEZWNyeXB0b3IobixyKS5maW5hbGl6ZSh0LmNpcGhlcnRleHQpfSxfcGFyc2U6ZnVuY3Rpb24oZSx0KXtyZXR1cm5cInN0cmluZ1wiPT10eXBlb2YgZT90LnBhcnNlKGUsdGhpcyk6ZX19KSx0PSh0LmtkZj17fSkuT3BlblNTTD17ZXhlY3V0ZTpmdW5jdGlvbihlLHQsbixyKXtyZXR1cm4gcnx8KHI9by5yYW5kb20oOCkpLGU9dS5jcmVhdGUoe2tleVNpemU6dCtufSkuY29tcHV0ZShlLHIpLG49by5jcmVhdGUoZS53b3Jkcy5zbGljZSh0KSw0Km4pLGUuc2lnQnl0ZXM9NCp0LGQuY3JlYXRlKHtrZXk6ZSxpdjpuLHNhbHQ6cn0pfX0sZz1yLlBhc3N3b3JkQmFzZWRDaXBoZXI9cC5leHRlbmQoe2NmZzpwLmNmZy5leHRlbmQoe2tkZjp0fSksZW5jcnlwdDpmdW5jdGlvbihlLHQsbixyKXtyZXR1cm4gcj10aGlzLmNmZy5leHRlbmQociksbj1yLmtkZi5leGVjdXRlKG4sZS5rZXlTaXplLGUuaXZTaXplKSxyLml2PW4uaXYsZT1wLmVuY3J5cHQuY2FsbCh0aGlzLGUsdCxuLmtleSxyKSxlLm1peEluKG4pLGV9LGRlY3J5cHQ6ZnVuY3Rpb24oZSx0LG4scil7cmV0dXJuIHI9dGhpcy5jZmcuZXh0ZW5kKHIpLHQ9dGhpcy5fcGFyc2UodCxyLmZvcm1hdCksbj1yLmtkZi5leGVjdXRlKG4sZS5rZXlTaXplLGUuaXZTaXplLHQuc2FsdCksci5pdj1uLml2LHAuZGVjcnlwdC5jYWxsKHRoaXMsZSx0LG4ua2V5LHIpfX0pfSgpLGZ1bmN0aW9uKCl7Zm9yKHZhciBlPW4sdD1lLmxpYi5CbG9ja0NpcGhlcixyPWUuYWxnbyxpPVtdLG89W10scz1bXSxhPVtdLHU9W10sYz1bXSxsPVtdLGg9W10sZj1bXSxkPVtdLHA9W10sZz0wOzI1Nj5nO2crKylwW2ddPTEyOD5nP2c8PDE6Zzw8MV4yODM7Zm9yKHZhciB5PTAsdj0wLGc9MDsyNTY+ZztnKyspe3ZhciBiPXZedjw8MV52PDwyXnY8PDNedjw8NCxiPWI+Pj44XjI1NSZiXjk5O2lbeV09YixvW2JdPXk7dmFyIF89cFt5XSxtPXBbX10saz1wW21dLFA9MjU3KnBbYl1eMTY4NDMwMDgqYjtzW3ldPVA8PDI0fFA+Pj44LGFbeV09UDw8MTZ8UD4+PjE2LHVbeV09UDw8OHxQPj4+MjQsY1t5XT1QLFA9MTY4NDMwMDkqa142NTUzNyptXjI1NypfXjE2ODQzMDA4KnksbFtiXT1QPDwyNHxQPj4+OCxoW2JdPVA8PDE2fFA+Pj4xNixmW2JdPVA8PDh8UD4+PjI0LGRbYl09UCx5Pyh5PV9ecFtwW3Bba15fXV1dLHZePXBbcFt2XV0pOnk9dj0xfXZhciBTPVswLDEsMiw0LDgsMTYsMzIsNjQsMTI4LDI3LDU0XSxyPXIuQUVTPXQuZXh0ZW5kKHtfZG9SZXNldDpmdW5jdGlvbigpe2Zvcih2YXIgZT10aGlzLl9rZXksdD1lLndvcmRzLG49ZS5zaWdCeXRlcy80LGU9NCooKHRoaXMuX25Sb3VuZHM9bis2KSsxKSxyPXRoaXMuX2tleVNjaGVkdWxlPVtdLG89MDtvPGU7bysrKWlmKG88bilyW29dPXRbb107ZWxzZXt2YXIgcz1yW28tMV07byVuPzY8biYmND09byVuJiYocz1pW3M+Pj4yNF08PDI0fGlbcz4+PjE2JjI1NV08PDE2fGlbcz4+PjgmMjU1XTw8OHxpWzI1NSZzXSk6KHM9czw8OHxzPj4+MjQscz1pW3M+Pj4yNF08PDI0fGlbcz4+PjE2JjI1NV08PDE2fGlbcz4+PjgmMjU1XTw8OHxpWzI1NSZzXSxzXj1TW28vbnwwXTw8MjQpLHJbb109cltvLW5dXnN9Zm9yKHQ9dGhpcy5faW52S2V5U2NoZWR1bGU9W10sbj0wO248ZTtuKyspbz1lLW4scz1uJTQ/cltvXTpyW28tNF0sdFtuXT00Pm58fDQ+PW8/czpsW2lbcz4+PjI0XV1eaFtpW3M+Pj4xNiYyNTVdXV5mW2lbcz4+PjgmMjU1XV1eZFtpWzI1NSZzXV19LGVuY3J5cHRCbG9jazpmdW5jdGlvbihlLHQpe3RoaXMuX2RvQ3J5cHRCbG9jayhlLHQsdGhpcy5fa2V5U2NoZWR1bGUscyxhLHUsYyxpKX0sZGVjcnlwdEJsb2NrOmZ1bmN0aW9uKGUsdCl7dmFyIG49ZVt0KzFdO2VbdCsxXT1lW3QrM10sZVt0KzNdPW4sdGhpcy5fZG9DcnlwdEJsb2NrKGUsdCx0aGlzLl9pbnZLZXlTY2hlZHVsZSxsLGgsZixkLG8pLG49ZVt0KzFdLGVbdCsxXT1lW3QrM10sZVt0KzNdPW59LF9kb0NyeXB0QmxvY2s6ZnVuY3Rpb24oZSx0LG4scixpLG8scyxhKXtmb3IodmFyIHU9dGhpcy5fblJvdW5kcyxjPWVbdF1eblswXSxsPWVbdCsxXV5uWzFdLGg9ZVt0KzJdXm5bMl0sZj1lW3QrM11eblszXSxkPTQscD0xO3A8dTtwKyspdmFyIGc9cltjPj4+MjRdXmlbbD4+PjE2JjI1NV1eb1toPj4+OCYyNTVdXnNbMjU1JmZdXm5bZCsrXSx5PXJbbD4+PjI0XV5pW2g+Pj4xNiYyNTVdXm9bZj4+PjgmMjU1XV5zWzI1NSZjXV5uW2QrK10sdj1yW2g+Pj4yNF1eaVtmPj4+MTYmMjU1XV5vW2M+Pj44JjI1NV1ec1syNTUmbF1ebltkKytdLGY9cltmPj4+MjRdXmlbYz4+PjE2JjI1NV1eb1tsPj4+OCYyNTVdXnNbMjU1JmhdXm5bZCsrXSxjPWcsbD15LGg9djtnPShhW2M+Pj4yNF08PDI0fGFbbD4+PjE2JjI1NV08PDE2fGFbaD4+PjgmMjU1XTw8OHxhWzI1NSZmXSlebltkKytdLHk9KGFbbD4+PjI0XTw8MjR8YVtoPj4+MTYmMjU1XTw8MTZ8YVtmPj4+OCYyNTVdPDw4fGFbMjU1JmNdKV5uW2QrK10sdj0oYVtoPj4+MjRdPDwyNHxhW2Y+Pj4xNiYyNTVdPDwxNnxhW2M+Pj44JjI1NV08PDh8YVsyNTUmbF0pXm5bZCsrXSxmPShhW2Y+Pj4yNF08PDI0fGFbYz4+PjE2JjI1NV08PDE2fGFbbD4+PjgmMjU1XTw8OHxhWzI1NSZoXSlebltkKytdLGVbdF09ZyxlW3QrMV09eSxlW3QrMl09dixlW3QrM109Zn0sa2V5U2l6ZTo4fSk7ZS5BRVM9dC5fY3JlYXRlSGVscGVyKHIpfSgpLG4ubW9kZS5FQ0I9ZnVuY3Rpb24oKXt2YXIgZT1uLmxpYi5CbG9ja0NpcGhlck1vZGUuZXh0ZW5kKCk7cmV0dXJuIGUuRW5jcnlwdG9yPWUuZXh0ZW5kKHtwcm9jZXNzQmxvY2s6ZnVuY3Rpb24oZSx0KXt0aGlzLl9jaXBoZXIuZW5jcnlwdEJsb2NrKGUsdCl9fSksZS5EZWNyeXB0b3I9ZS5leHRlbmQoe3Byb2Nlc3NCbG9jazpmdW5jdGlvbihlLHQpe3RoaXMuX2NpcGhlci5kZWNyeXB0QmxvY2soZSx0KX19KSxlfSgpLGUuZXhwb3J0cz1ufSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaShlLHQpe2lmKCEoZSBpbnN0YW5jZW9mIHQpKXRocm93IG5ldyBUeXBlRXJyb3IoXCJDYW5ub3QgY2FsbCBhIGNsYXNzIGFzIGEgZnVuY3Rpb25cIil9T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSk7dmFyIG89ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKGUsdCl7Zm9yKHZhciBuPTA7bjx0Lmxlbmd0aDtuKyspe3ZhciByPXRbbl07ci5lbnVtZXJhYmxlPXIuZW51bWVyYWJsZXx8ITEsci5jb25maWd1cmFibGU9ITAsXCJ2YWx1ZVwiaW4gciYmKHIud3JpdGFibGU9ITApLE9iamVjdC5kZWZpbmVQcm9wZXJ0eShlLHIua2V5LHIpfX1yZXR1cm4gZnVuY3Rpb24odCxuLHIpe3JldHVybiBuJiZlKHQucHJvdG90eXBlLG4pLHImJmUodCxyKSx0fX0oKSxzPW4oOSksYT0ocihzKSxuKDcpKSx1PShyKGEpLG4oMTIpKSxjPShyKHUpLG4oMTQpKSxsPXIoYyksaD1uKDE3KSxmPXIoaCksZD0obig4KSxuKDEzKSkscD1yKGQpLGc9ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKHQpe3ZhciBuPXQuc3Vic2NyaWJlRW5kcG9pbnQscj10LmxlYXZlRW5kcG9pbnQsbz10LmhlYXJ0YmVhdEVuZHBvaW50LHM9dC5zZXRTdGF0ZUVuZHBvaW50LGE9dC50aW1lRW5kcG9pbnQsdT10LmNvbmZpZyxjPXQuY3J5cHRvLGg9dC5saXN0ZW5lck1hbmFnZXI7aSh0aGlzLGUpLHRoaXMuX2xpc3RlbmVyTWFuYWdlcj1oLHRoaXMuX2NvbmZpZz11LHRoaXMuX2xlYXZlRW5kcG9pbnQ9cix0aGlzLl9oZWFydGJlYXRFbmRwb2ludD1vLHRoaXMuX3NldFN0YXRlRW5kcG9pbnQ9cyx0aGlzLl9zdWJzY3JpYmVFbmRwb2ludD1uLHRoaXMuX2NyeXB0bz1jLHRoaXMuX2NoYW5uZWxzPXt9LHRoaXMuX3ByZXNlbmNlQ2hhbm5lbHM9e30sdGhpcy5fY2hhbm5lbEdyb3Vwcz17fSx0aGlzLl9wcmVzZW5jZUNoYW5uZWxHcm91cHM9e30sdGhpcy5fcGVuZGluZ0NoYW5uZWxTdWJzY3JpcHRpb25zPVtdLHRoaXMuX3BlbmRpbmdDaGFubmVsR3JvdXBTdWJzY3JpcHRpb25zPVtdLHRoaXMuX2N1cnJlbnRUaW1ldG9rZW49MCx0aGlzLl9sYXN0VGltZXRva2VuPTAsdGhpcy5fc3Vic2NyaXB0aW9uU3RhdHVzQW5ub3VuY2VkPSExLHRoaXMuX3JlY29ubmVjdGlvbk1hbmFnZXI9bmV3IGwuZGVmYXVsdCh7dGltZUVuZHBvaW50OmF9KX1yZXR1cm4gbyhlLFt7a2V5OlwiYWRhcHRTdGF0ZUNoYW5nZVwiLHZhbHVlOmZ1bmN0aW9uKGUsdCl7dmFyIG49dGhpcyxyPWUuc3RhdGUsaT1lLmNoYW5uZWxzLG89dm9pZCAwPT09aT9bXTppLHM9ZS5jaGFubmVsR3JvdXBzLGE9dm9pZCAwPT09cz9bXTpzO3JldHVybiBvLmZvckVhY2goZnVuY3Rpb24oZSl7ZSBpbiBuLl9jaGFubmVscyYmKG4uX2NoYW5uZWxzW2VdLnN0YXRlPXIpfSksYS5mb3JFYWNoKGZ1bmN0aW9uKGUpe2UgaW4gbi5fY2hhbm5lbEdyb3VwcyYmKG4uX2NoYW5uZWxHcm91cHNbZV0uc3RhdGU9cil9KSx0aGlzLl9zZXRTdGF0ZUVuZHBvaW50KHtzdGF0ZTpyLGNoYW5uZWxzOm8sY2hhbm5lbEdyb3VwczphfSx0KX19LHtrZXk6XCJhZGFwdFN1YnNjcmliZUNoYW5nZVwiLHZhbHVlOmZ1bmN0aW9uKGUpe3ZhciB0PXRoaXMsbj1lLnRpbWV0b2tlbixyPWUuY2hhbm5lbHMsaT12b2lkIDA9PT1yP1tdOnIsbz1lLmNoYW5uZWxHcm91cHMscz12b2lkIDA9PT1vP1tdOm8sYT1lLndpdGhQcmVzZW5jZSx1PXZvaWQgMCE9PWEmJmE7aWYoIXRoaXMuX2NvbmZpZy5zdWJzY3JpYmVLZXl8fFwiXCI9PT10aGlzLl9jb25maWcuc3Vic2NyaWJlS2V5KXJldHVybiB2b2lkKGNvbnNvbGUmJmNvbnNvbGUubG9nJiZjb25zb2xlLmxvZyhcInN1YnNjcmliZSBrZXkgbWlzc2luZzsgYWJvcnRpbmcgc3Vic2NyaWJlXCIpKTtuJiYodGhpcy5fbGFzdFRpbWV0b2tlbj10aGlzLl9jdXJyZW50VGltZXRva2VuLHRoaXMuX2N1cnJlbnRUaW1ldG9rZW49biksaS5mb3JFYWNoKGZ1bmN0aW9uKGUpe3QuX2NoYW5uZWxzW2VdPXtzdGF0ZTp7fX0sdSYmKHQuX3ByZXNlbmNlQ2hhbm5lbHNbZV09e30pLHQuX3BlbmRpbmdDaGFubmVsU3Vic2NyaXB0aW9ucy5wdXNoKGUpfSkscy5mb3JFYWNoKGZ1bmN0aW9uKGUpe3QuX2NoYW5uZWxHcm91cHNbZV09e3N0YXRlOnt9fSx1JiYodC5fcHJlc2VuY2VDaGFubmVsR3JvdXBzW2VdPXt9KSx0Ll9wZW5kaW5nQ2hhbm5lbEdyb3VwU3Vic2NyaXB0aW9ucy5wdXNoKGUpfSksdGhpcy5fc3Vic2NyaXB0aW9uU3RhdHVzQW5ub3VuY2VkPSExLHRoaXMucmVjb25uZWN0KCl9fSx7a2V5OlwiYWRhcHRVbnN1YnNjcmliZUNoYW5nZVwiLHZhbHVlOmZ1bmN0aW9uKGUsdCl7dmFyIG49dGhpcyxyPWUuY2hhbm5lbHMsaT12b2lkIDA9PT1yP1tdOnIsbz1lLmNoYW5uZWxHcm91cHMscz12b2lkIDA9PT1vP1tdOm87aS5mb3JFYWNoKGZ1bmN0aW9uKGUpe2UgaW4gbi5fY2hhbm5lbHMmJmRlbGV0ZSBuLl9jaGFubmVsc1tlXSxlIGluIG4uX3ByZXNlbmNlQ2hhbm5lbHMmJmRlbGV0ZSBuLl9wcmVzZW5jZUNoYW5uZWxzW2VdfSkscy5mb3JFYWNoKGZ1bmN0aW9uKGUpe2UgaW4gbi5fY2hhbm5lbEdyb3VwcyYmZGVsZXRlIG4uX2NoYW5uZWxHcm91cHNbZV0sZSBpbiBuLl9wcmVzZW5jZUNoYW5uZWxHcm91cHMmJmRlbGV0ZSBuLl9jaGFubmVsR3JvdXBzW2VdfSksdGhpcy5fY29uZmlnLnN1cHByZXNzTGVhdmVFdmVudHMhPT0hMXx8dHx8dGhpcy5fbGVhdmVFbmRwb2ludCh7Y2hhbm5lbHM6aSxjaGFubmVsR3JvdXBzOnN9LGZ1bmN0aW9uKGUpe2UuYWZmZWN0ZWRDaGFubmVscz1pLGUuYWZmZWN0ZWRDaGFubmVsR3JvdXBzPXMsZS5jdXJyZW50VGltZXRva2VuPW4uX2N1cnJlbnRUaW1ldG9rZW4sXG5lLmxhc3RUaW1ldG9rZW49bi5fbGFzdFRpbWV0b2tlbixuLl9saXN0ZW5lck1hbmFnZXIuYW5ub3VuY2VTdGF0dXMoZSl9KSwwPT09T2JqZWN0LmtleXModGhpcy5fY2hhbm5lbHMpLmxlbmd0aCYmMD09PU9iamVjdC5rZXlzKHRoaXMuX3ByZXNlbmNlQ2hhbm5lbHMpLmxlbmd0aCYmMD09PU9iamVjdC5rZXlzKHRoaXMuX2NoYW5uZWxHcm91cHMpLmxlbmd0aCYmMD09PU9iamVjdC5rZXlzKHRoaXMuX3ByZXNlbmNlQ2hhbm5lbEdyb3VwcykubGVuZ3RoJiYodGhpcy5fbGFzdFRpbWV0b2tlbj0wLHRoaXMuX2N1cnJlbnRUaW1ldG9rZW49MCx0aGlzLl9yZWdpb249bnVsbCx0aGlzLl9yZWNvbm5lY3Rpb25NYW5hZ2VyLnN0b3BQb2xsaW5nKCkpLHRoaXMucmVjb25uZWN0KCl9fSx7a2V5OlwidW5zdWJzY3JpYmVBbGxcIix2YWx1ZTpmdW5jdGlvbihlKXt0aGlzLmFkYXB0VW5zdWJzY3JpYmVDaGFuZ2Uoe2NoYW5uZWxzOnRoaXMuZ2V0U3Vic2NyaWJlZENoYW5uZWxzKCksY2hhbm5lbEdyb3Vwczp0aGlzLmdldFN1YnNjcmliZWRDaGFubmVsR3JvdXBzKCl9LGUpfX0se2tleTpcImdldFN1YnNjcmliZWRDaGFubmVsc1wiLHZhbHVlOmZ1bmN0aW9uKCl7cmV0dXJuIE9iamVjdC5rZXlzKHRoaXMuX2NoYW5uZWxzKX19LHtrZXk6XCJnZXRTdWJzY3JpYmVkQ2hhbm5lbEdyb3Vwc1wiLHZhbHVlOmZ1bmN0aW9uKCl7cmV0dXJuIE9iamVjdC5rZXlzKHRoaXMuX2NoYW5uZWxHcm91cHMpfX0se2tleTpcInJlY29ubmVjdFwiLHZhbHVlOmZ1bmN0aW9uKCl7dGhpcy5fc3RhcnRTdWJzY3JpYmVMb29wKCksdGhpcy5fcmVnaXN0ZXJIZWFydGJlYXRUaW1lcigpfX0se2tleTpcImRpc2Nvbm5lY3RcIix2YWx1ZTpmdW5jdGlvbigpe3RoaXMuX3N0b3BTdWJzY3JpYmVMb29wKCksdGhpcy5fc3RvcEhlYXJ0YmVhdFRpbWVyKCksdGhpcy5fcmVjb25uZWN0aW9uTWFuYWdlci5zdG9wUG9sbGluZygpfX0se2tleTpcIl9yZWdpc3RlckhlYXJ0YmVhdFRpbWVyXCIsdmFsdWU6ZnVuY3Rpb24oKXt0aGlzLl9zdG9wSGVhcnRiZWF0VGltZXIoKSx0aGlzLl9wZXJmb3JtSGVhcnRiZWF0TG9vcCgpLHRoaXMuX2hlYXJ0YmVhdFRpbWVyPXNldEludGVydmFsKHRoaXMuX3BlcmZvcm1IZWFydGJlYXRMb29wLmJpbmQodGhpcyksMWUzKnRoaXMuX2NvbmZpZy5nZXRIZWFydGJlYXRJbnRlcnZhbCgpKX19LHtrZXk6XCJfc3RvcEhlYXJ0YmVhdFRpbWVyXCIsdmFsdWU6ZnVuY3Rpb24oKXt0aGlzLl9oZWFydGJlYXRUaW1lciYmKGNsZWFySW50ZXJ2YWwodGhpcy5faGVhcnRiZWF0VGltZXIpLHRoaXMuX2hlYXJ0YmVhdFRpbWVyPW51bGwpfX0se2tleTpcIl9wZXJmb3JtSGVhcnRiZWF0TG9vcFwiLHZhbHVlOmZ1bmN0aW9uKCl7dmFyIGU9dGhpcyx0PU9iamVjdC5rZXlzKHRoaXMuX2NoYW5uZWxzKSxuPU9iamVjdC5rZXlzKHRoaXMuX2NoYW5uZWxHcm91cHMpLHI9e307aWYoMCE9PXQubGVuZ3RofHwwIT09bi5sZW5ndGgpe3QuZm9yRWFjaChmdW5jdGlvbih0KXt2YXIgbj1lLl9jaGFubmVsc1t0XS5zdGF0ZTtPYmplY3Qua2V5cyhuKS5sZW5ndGgmJihyW3RdPW4pfSksbi5mb3JFYWNoKGZ1bmN0aW9uKHQpe3ZhciBuPWUuX2NoYW5uZWxHcm91cHNbdF0uc3RhdGU7T2JqZWN0LmtleXMobikubGVuZ3RoJiYoclt0XT1uKX0pO3ZhciBpPWZ1bmN0aW9uKHQpe3QuZXJyb3ImJmUuX2NvbmZpZy5hbm5vdW5jZUZhaWxlZEhlYXJ0YmVhdHMmJmUuX2xpc3RlbmVyTWFuYWdlci5hbm5vdW5jZVN0YXR1cyh0KSwhdC5lcnJvciYmZS5fY29uZmlnLmFubm91bmNlU3VjY2Vzc2Z1bEhlYXJ0YmVhdHMmJmUuX2xpc3RlbmVyTWFuYWdlci5hbm5vdW5jZVN0YXR1cyh0KX07dGhpcy5faGVhcnRiZWF0RW5kcG9pbnQoe2NoYW5uZWxzOnQsY2hhbm5lbEdyb3VwczpuLHN0YXRlOnJ9LGkuYmluZCh0aGlzKSl9fX0se2tleTpcIl9zdGFydFN1YnNjcmliZUxvb3BcIix2YWx1ZTpmdW5jdGlvbigpe3RoaXMuX3N0b3BTdWJzY3JpYmVMb29wKCk7dmFyIGU9W10sdD1bXTtpZihPYmplY3Qua2V5cyh0aGlzLl9jaGFubmVscykuZm9yRWFjaChmdW5jdGlvbih0KXtyZXR1cm4gZS5wdXNoKHQpfSksT2JqZWN0LmtleXModGhpcy5fcHJlc2VuY2VDaGFubmVscykuZm9yRWFjaChmdW5jdGlvbih0KXtyZXR1cm4gZS5wdXNoKHQrXCItcG5wcmVzXCIpfSksT2JqZWN0LmtleXModGhpcy5fY2hhbm5lbEdyb3VwcykuZm9yRWFjaChmdW5jdGlvbihlKXtyZXR1cm4gdC5wdXNoKGUpfSksT2JqZWN0LmtleXModGhpcy5fcHJlc2VuY2VDaGFubmVsR3JvdXBzKS5mb3JFYWNoKGZ1bmN0aW9uKGUpe3JldHVybiB0LnB1c2goZStcIi1wbnByZXNcIil9KSwwIT09ZS5sZW5ndGh8fDAhPT10Lmxlbmd0aCl7dmFyIG49e2NoYW5uZWxzOmUsY2hhbm5lbEdyb3Vwczp0LHRpbWV0b2tlbjp0aGlzLl9jdXJyZW50VGltZXRva2VuLGZpbHRlckV4cHJlc3Npb246dGhpcy5fY29uZmlnLmZpbHRlckV4cHJlc3Npb24scmVnaW9uOnRoaXMuX3JlZ2lvbn07dGhpcy5fc3Vic2NyaWJlQ2FsbD10aGlzLl9zdWJzY3JpYmVFbmRwb2ludChuLHRoaXMuX3Byb2Nlc3NTdWJzY3JpYmVSZXNwb25zZS5iaW5kKHRoaXMpKX19fSx7a2V5OlwiX3Byb2Nlc3NTdWJzY3JpYmVSZXNwb25zZVwiLHZhbHVlOmZ1bmN0aW9uKGUsdCl7dmFyIG49dGhpcztpZihlLmVycm9yKXJldHVybiB2b2lkKGUuY2F0ZWdvcnk9PT1wLmRlZmF1bHQuUE5UaW1lb3V0Q2F0ZWdvcnk/dGhpcy5fc3RhcnRTdWJzY3JpYmVMb29wKCk6ZS5jYXRlZ29yeT09PXAuZGVmYXVsdC5QTk5ldHdvcmtJc3N1ZXNDYXRlZ29yeT8odGhpcy5kaXNjb25uZWN0KCksdGhpcy5fcmVjb25uZWN0aW9uTWFuYWdlci5vblJlY29ubmVjdGlvbihmdW5jdGlvbigpe24ucmVjb25uZWN0KCksbi5fc3Vic2NyaXB0aW9uU3RhdHVzQW5ub3VuY2VkPSEwO3ZhciB0PXtjYXRlZ29yeTpwLmRlZmF1bHQuUE5SZWNvbm5lY3RlZENhdGVnb3J5LG9wZXJhdGlvbjplLm9wZXJhdGlvbixsYXN0VGltZXRva2VuOm4uX2xhc3RUaW1ldG9rZW4sY3VycmVudFRpbWV0b2tlbjpuLl9jdXJyZW50VGltZXRva2VufTtuLl9saXN0ZW5lck1hbmFnZXIuYW5ub3VuY2VTdGF0dXModCl9KSx0aGlzLl9yZWNvbm5lY3Rpb25NYW5hZ2VyLnN0YXJ0UG9sbGluZygpLHRoaXMuX2xpc3RlbmVyTWFuYWdlci5hbm5vdW5jZVN0YXR1cyhlKSk6dGhpcy5fbGlzdGVuZXJNYW5hZ2VyLmFubm91bmNlU3RhdHVzKGUpKTtpZih0aGlzLl9sYXN0VGltZXRva2VuPXRoaXMuX2N1cnJlbnRUaW1ldG9rZW4sdGhpcy5fY3VycmVudFRpbWV0b2tlbj10Lm1ldGFkYXRhLnRpbWV0b2tlbiwhdGhpcy5fc3Vic2NyaXB0aW9uU3RhdHVzQW5ub3VuY2VkKXt2YXIgcj17fTtyLmNhdGVnb3J5PXAuZGVmYXVsdC5QTkNvbm5lY3RlZENhdGVnb3J5LHIub3BlcmF0aW9uPWUub3BlcmF0aW9uLHIuYWZmZWN0ZWRDaGFubmVscz10aGlzLl9wZW5kaW5nQ2hhbm5lbFN1YnNjcmlwdGlvbnMsci5hZmZlY3RlZENoYW5uZWxHcm91cHM9dGhpcy5fcGVuZGluZ0NoYW5uZWxHcm91cFN1YnNjcmlwdGlvbnMsci5sYXN0VGltZXRva2VuPXRoaXMuX2xhc3RUaW1ldG9rZW4sci5jdXJyZW50VGltZXRva2VuPXRoaXMuX2N1cnJlbnRUaW1ldG9rZW4sdGhpcy5fc3Vic2NyaXB0aW9uU3RhdHVzQW5ub3VuY2VkPSEwLHRoaXMuX2xpc3RlbmVyTWFuYWdlci5hbm5vdW5jZVN0YXR1cyhyKSx0aGlzLl9wZW5kaW5nQ2hhbm5lbFN1YnNjcmlwdGlvbnM9W10sdGhpcy5fcGVuZGluZ0NoYW5uZWxHcm91cFN1YnNjcmlwdGlvbnM9W119dmFyIGk9dC5tZXNzYWdlc3x8W10sbz10aGlzLl9jb25maWcucmVxdWVzdE1lc3NhZ2VDb3VudFRocmVzaG9sZDtpZihvJiZpLmxlbmd0aD49byl7dmFyIHM9e307cy5jYXRlZ29yeT1wLmRlZmF1bHQuUE5SZXF1ZXN0TWVzc2FnZUNvdW50RXhjZWVkZWRDYXRlZ29yeSxzLm9wZXJhdGlvbj1lLm9wZXJhdGlvbix0aGlzLl9saXN0ZW5lck1hbmFnZXIuYW5ub3VuY2VTdGF0dXMocyl9aS5mb3JFYWNoKGZ1bmN0aW9uKGUpe3ZhciB0PWUuY2hhbm5lbCxyPWUuc3Vic2NyaXB0aW9uTWF0Y2gsaT1lLnB1Ymxpc2hNZXRhRGF0YTtpZih0PT09ciYmKHI9bnVsbCksZi5kZWZhdWx0LmVuZHNXaXRoKGUuY2hhbm5lbCxcIi1wbnByZXNcIikpe3ZhciBvPXt9O28uY2hhbm5lbD1udWxsLG8uc3Vic2NyaXB0aW9uPW51bGwsby5hY3R1YWxDaGFubmVsPW51bGwhPXI/dDpudWxsLG8uc3Vic2NyaWJlZENoYW5uZWw9bnVsbCE9cj9yOnQsdCYmKG8uY2hhbm5lbD10LnN1YnN0cmluZygwLHQubGFzdEluZGV4T2YoXCItcG5wcmVzXCIpKSksciYmKG8uc3Vic2NyaXB0aW9uPXIuc3Vic3RyaW5nKDAsci5sYXN0SW5kZXhPZihcIi1wbnByZXNcIikpKSxvLmFjdGlvbj1lLnBheWxvYWQuYWN0aW9uLG8uc3RhdGU9ZS5wYXlsb2FkLmRhdGEsby50aW1ldG9rZW49aS5wdWJsaXNoVGltZXRva2VuLG8ub2NjdXBhbmN5PWUucGF5bG9hZC5vY2N1cGFuY3ksby51dWlkPWUucGF5bG9hZC51dWlkLG8udGltZXN0YW1wPWUucGF5bG9hZC50aW1lc3RhbXAsZS5wYXlsb2FkLmpvaW4mJihvLmpvaW49ZS5wYXlsb2FkLmpvaW4pLGUucGF5bG9hZC5sZWF2ZSYmKG8ubGVhdmU9ZS5wYXlsb2FkLmxlYXZlKSxlLnBheWxvYWQudGltZW91dCYmKG8udGltZW91dD1lLnBheWxvYWQudGltZW91dCksbi5fbGlzdGVuZXJNYW5hZ2VyLmFubm91bmNlUHJlc2VuY2Uobyl9ZWxzZXt2YXIgcz17fTtzLmNoYW5uZWw9bnVsbCxzLnN1YnNjcmlwdGlvbj1udWxsLHMuYWN0dWFsQ2hhbm5lbD1udWxsIT1yP3Q6bnVsbCxzLnN1YnNjcmliZWRDaGFubmVsPW51bGwhPXI/cjp0LHMuY2hhbm5lbD10LHMuc3Vic2NyaXB0aW9uPXIscy50aW1ldG9rZW49aS5wdWJsaXNoVGltZXRva2VuLHMucHVibGlzaGVyPWUuaXNzdWluZ0NsaWVudElkLG4uX2NvbmZpZy5jaXBoZXJLZXk/cy5tZXNzYWdlPW4uX2NyeXB0by5kZWNyeXB0KGUucGF5bG9hZCk6cy5tZXNzYWdlPWUucGF5bG9hZCxuLl9saXN0ZW5lck1hbmFnZXIuYW5ub3VuY2VNZXNzYWdlKHMpfX0pLHRoaXMuX3JlZ2lvbj10Lm1ldGFkYXRhLnJlZ2lvbix0aGlzLl9zdGFydFN1YnNjcmliZUxvb3AoKX19LHtrZXk6XCJfc3RvcFN1YnNjcmliZUxvb3BcIix2YWx1ZTpmdW5jdGlvbigpe3RoaXMuX3N1YnNjcmliZUNhbGwmJih0aGlzLl9zdWJzY3JpYmVDYWxsLmFib3J0KCksdGhpcy5fc3Vic2NyaWJlQ2FsbD1udWxsKX19XSksZX0oKTt0LmRlZmF1bHQ9ZyxlLmV4cG9ydHM9dC5kZWZhdWx0fSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlLHQpe2lmKCEoZSBpbnN0YW5jZW9mIHQpKXRocm93IG5ldyBUeXBlRXJyb3IoXCJDYW5ub3QgY2FsbCBhIGNsYXNzIGFzIGEgZnVuY3Rpb25cIil9T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSk7dmFyIGk9ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKGUsdCl7Zm9yKHZhciBuPTA7bjx0Lmxlbmd0aDtuKyspe3ZhciByPXRbbl07ci5lbnVtZXJhYmxlPXIuZW51bWVyYWJsZXx8ITEsci5jb25maWd1cmFibGU9ITAsXCJ2YWx1ZVwiaW4gciYmKHIud3JpdGFibGU9ITApLE9iamVjdC5kZWZpbmVQcm9wZXJ0eShlLHIua2V5LHIpfX1yZXR1cm4gZnVuY3Rpb24odCxuLHIpe3JldHVybiBuJiZlKHQucHJvdG90eXBlLG4pLHImJmUodCxyKSx0fX0oKSxvPShuKDgpLG4oMTMpKSxzPWZ1bmN0aW9uKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX0obyksYT1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXtyKHRoaXMsZSksdGhpcy5fbGlzdGVuZXJzPVtdfXJldHVybiBpKGUsW3trZXk6XCJhZGRMaXN0ZW5lclwiLHZhbHVlOmZ1bmN0aW9uKGUpe3RoaXMuX2xpc3RlbmVycy5wdXNoKGUpfX0se2tleTpcInJlbW92ZUxpc3RlbmVyXCIsdmFsdWU6ZnVuY3Rpb24oZSl7dmFyIHQ9W107dGhpcy5fbGlzdGVuZXJzLmZvckVhY2goZnVuY3Rpb24obil7biE9PWUmJnQucHVzaChuKX0pLHRoaXMuX2xpc3RlbmVycz10fX0se2tleTpcInJlbW92ZUFsbExpc3RlbmVyc1wiLHZhbHVlOmZ1bmN0aW9uKCl7dGhpcy5fbGlzdGVuZXJzPVtdfX0se2tleTpcImFubm91bmNlUHJlc2VuY2VcIix2YWx1ZTpmdW5jdGlvbihlKXt0aGlzLl9saXN0ZW5lcnMuZm9yRWFjaChmdW5jdGlvbih0KXt0LnByZXNlbmNlJiZ0LnByZXNlbmNlKGUpfSl9fSx7a2V5OlwiYW5ub3VuY2VTdGF0dXNcIix2YWx1ZTpmdW5jdGlvbihlKXt0aGlzLl9saXN0ZW5lcnMuZm9yRWFjaChmdW5jdGlvbih0KXt0LnN0YXR1cyYmdC5zdGF0dXMoZSl9KX19LHtrZXk6XCJhbm5vdW5jZU1lc3NhZ2VcIix2YWx1ZTpmdW5jdGlvbihlKXt0aGlzLl9saXN0ZW5lcnMuZm9yRWFjaChmdW5jdGlvbih0KXt0Lm1lc3NhZ2UmJnQubWVzc2FnZShlKX0pfX0se2tleTpcImFubm91bmNlTmV0d29ya1VwXCIsdmFsdWU6ZnVuY3Rpb24oKXt2YXIgZT17fTtlLmNhdGVnb3J5PXMuZGVmYXVsdC5QTk5ldHdvcmtVcENhdGVnb3J5LHRoaXMuYW5ub3VuY2VTdGF0dXMoZSl9fSx7a2V5OlwiYW5ub3VuY2VOZXR3b3JrRG93blwiLHZhbHVlOmZ1bmN0aW9uKCl7dmFyIGU9e307ZS5jYXRlZ29yeT1zLmRlZmF1bHQuUE5OZXR3b3JrRG93bkNhdGVnb3J5LHRoaXMuYW5ub3VuY2VTdGF0dXMoZSl9fV0pLGV9KCk7dC5kZWZhdWx0PWEsZS5leHBvcnRzPXQuZGVmYXVsdH0sZnVuY3Rpb24oZSx0KXtcInVzZSBzdHJpY3RcIjtPYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmRlZmF1bHQ9e1BOTmV0d29ya1VwQ2F0ZWdvcnk6XCJQTk5ldHdvcmtVcENhdGVnb3J5XCIsUE5OZXR3b3JrRG93bkNhdGVnb3J5OlwiUE5OZXR3b3JrRG93bkNhdGVnb3J5XCIsUE5OZXR3b3JrSXNzdWVzQ2F0ZWdvcnk6XCJQTk5ldHdvcmtJc3N1ZXNDYXRlZ29yeVwiLFBOVGltZW91dENhdGVnb3J5OlwiUE5UaW1lb3V0Q2F0ZWdvcnlcIixQTkJhZFJlcXVlc3RDYXRlZ29yeTpcIlBOQmFkUmVxdWVzdENhdGVnb3J5XCIsUE5BY2Nlc3NEZW5pZWRDYXRlZ29yeTpcIlBOQWNjZXNzRGVuaWVkQ2F0ZWdvcnlcIixQTlVua25vd25DYXRlZ29yeTpcIlBOVW5rbm93bkNhdGVnb3J5XCIsUE5SZWNvbm5lY3RlZENhdGVnb3J5OlwiUE5SZWNvbm5lY3RlZENhdGVnb3J5XCIsUE5Db25uZWN0ZWRDYXRlZ29yeTpcIlBOQ29ubmVjdGVkQ2F0ZWdvcnlcIixQTlJlcXVlc3RNZXNzYWdlQ291bnRFeGNlZWRlZENhdGVnb3J5OlwiUE5SZXF1ZXN0TWVzc2FnZUNvdW50RXhjZWVkZWRDYXRlZ29yeVwifSxlLmV4cG9ydHM9dC5kZWZhdWx0fSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlLHQpe2lmKCEoZSBpbnN0YW5jZW9mIHQpKXRocm93IG5ldyBUeXBlRXJyb3IoXCJDYW5ub3QgY2FsbCBhIGNsYXNzIGFzIGEgZnVuY3Rpb25cIil9T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSk7dmFyIGk9ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKGUsdCl7Zm9yKHZhciBuPTA7bjx0Lmxlbmd0aDtuKyspe3ZhciByPXRbbl07ci5lbnVtZXJhYmxlPXIuZW51bWVyYWJsZXx8ITEsci5jb25maWd1cmFibGU9ITAsXCJ2YWx1ZVwiaW4gciYmKHIud3JpdGFibGU9ITApLE9iamVjdC5kZWZpbmVQcm9wZXJ0eShlLHIua2V5LHIpfX1yZXR1cm4gZnVuY3Rpb24odCxuLHIpe3JldHVybiBuJiZlKHQucHJvdG90eXBlLG4pLHImJmUodCxyKSx0fX0oKSxvPW4oMTUpLHM9KGZ1bmN0aW9uKGUpe2UmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fShvKSxuKDgpLGZ1bmN0aW9uKCl7ZnVuY3Rpb24gZSh0KXt2YXIgbj10LnRpbWVFbmRwb2ludDtyKHRoaXMsZSksdGhpcy5fdGltZUVuZHBvaW50PW59cmV0dXJuIGkoZSxbe2tleTpcIm9uUmVjb25uZWN0aW9uXCIsdmFsdWU6ZnVuY3Rpb24oZSl7dGhpcy5fcmVjb25uZWN0aW9uQ2FsbGJhY2s9ZX19LHtrZXk6XCJzdGFydFBvbGxpbmdcIix2YWx1ZTpmdW5jdGlvbigpe3RoaXMuX3RpbWVUaW1lcj1zZXRJbnRlcnZhbCh0aGlzLl9wZXJmb3JtVGltZUxvb3AuYmluZCh0aGlzKSwzZTMpfX0se2tleTpcInN0b3BQb2xsaW5nXCIsdmFsdWU6ZnVuY3Rpb24oKXtjbGVhckludGVydmFsKHRoaXMuX3RpbWVUaW1lcil9fSx7a2V5OlwiX3BlcmZvcm1UaW1lTG9vcFwiLHZhbHVlOmZ1bmN0aW9uKCl7dmFyIGU9dGhpczt0aGlzLl90aW1lRW5kcG9pbnQoZnVuY3Rpb24odCl7dC5lcnJvcnx8KGNsZWFySW50ZXJ2YWwoZS5fdGltZVRpbWVyKSxlLl9yZWNvbm5lY3Rpb25DYWxsYmFjaygpKX0pfX1dKSxlfSgpKTt0LmRlZmF1bHQ9cyxlLmV4cG9ydHM9dC5kZWZhdWx0fSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcigpe3JldHVybiBoLmRlZmF1bHQuUE5UaW1lT3BlcmF0aW9ufWZ1bmN0aW9uIGkoKXtyZXR1cm5cIi90aW1lLzBcIn1mdW5jdGlvbiBvKGUpe3JldHVybiBlLmNvbmZpZy5nZXRUcmFuc2FjdGlvblRpbWVvdXQoKX1mdW5jdGlvbiBzKCl7cmV0dXJue319ZnVuY3Rpb24gYSgpe3JldHVybiExfWZ1bmN0aW9uIHUoZSx0KXtyZXR1cm57dGltZXRva2VuOnRbMF19fWZ1bmN0aW9uIGMoKXt9T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249cix0LmdldFVSTD1pLHQuZ2V0UmVxdWVzdFRpbWVvdXQ9byx0LnByZXBhcmVQYXJhbXM9cyx0LmlzQXV0aFN1cHBvcnRlZD1hLHQuaGFuZGxlUmVzcG9uc2U9dSx0LnZhbGlkYXRlUGFyYW1zPWM7dmFyIGw9KG4oOCksbigxNikpLGg9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fShsKX0sZnVuY3Rpb24oZSx0KXtcInVzZSBzdHJpY3RcIjtPYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmRlZmF1bHQ9e1BOVGltZU9wZXJhdGlvbjpcIlBOVGltZU9wZXJhdGlvblwiLFBOSGlzdG9yeU9wZXJhdGlvbjpcIlBOSGlzdG9yeU9wZXJhdGlvblwiLFBORmV0Y2hNZXNzYWdlc09wZXJhdGlvbjpcIlBORmV0Y2hNZXNzYWdlc09wZXJhdGlvblwiLFBOU3Vic2NyaWJlT3BlcmF0aW9uOlwiUE5TdWJzY3JpYmVPcGVyYXRpb25cIixQTlVuc3Vic2NyaWJlT3BlcmF0aW9uOlwiUE5VbnN1YnNjcmliZU9wZXJhdGlvblwiLFBOUHVibGlzaE9wZXJhdGlvbjpcIlBOUHVibGlzaE9wZXJhdGlvblwiLFBOUHVzaE5vdGlmaWNhdGlvbkVuYWJsZWRDaGFubmVsc09wZXJhdGlvbjpcIlBOUHVzaE5vdGlmaWNhdGlvbkVuYWJsZWRDaGFubmVsc09wZXJhdGlvblwiLFBOUmVtb3ZlQWxsUHVzaE5vdGlmaWNhdGlvbnNPcGVyYXRpb246XCJQTlJlbW92ZUFsbFB1c2hOb3RpZmljYXRpb25zT3BlcmF0aW9uXCIsUE5XaGVyZU5vd09wZXJhdGlvbjpcIlBOV2hlcmVOb3dPcGVyYXRpb25cIixQTlNldFN0YXRlT3BlcmF0aW9uOlwiUE5TZXRTdGF0ZU9wZXJhdGlvblwiLFBOSGVyZU5vd09wZXJhdGlvbjpcIlBOSGVyZU5vd09wZXJhdGlvblwiLFBOR2V0U3RhdGVPcGVyYXRpb246XCJQTkdldFN0YXRlT3BlcmF0aW9uXCIsUE5IZWFydGJlYXRPcGVyYXRpb246XCJQTkhlYXJ0YmVhdE9wZXJhdGlvblwiLFBOQ2hhbm5lbEdyb3Vwc09wZXJhdGlvbjpcIlBOQ2hhbm5lbEdyb3Vwc09wZXJhdGlvblwiLFBOUmVtb3ZlR3JvdXBPcGVyYXRpb246XCJQTlJlbW92ZUdyb3VwT3BlcmF0aW9uXCIsUE5DaGFubmVsc0Zvckdyb3VwT3BlcmF0aW9uOlwiUE5DaGFubmVsc0Zvckdyb3VwT3BlcmF0aW9uXCIsUE5BZGRDaGFubmVsc1RvR3JvdXBPcGVyYXRpb246XCJQTkFkZENoYW5uZWxzVG9Hcm91cE9wZXJhdGlvblwiLFBOUmVtb3ZlQ2hhbm5lbHNGcm9tR3JvdXBPcGVyYXRpb246XCJQTlJlbW92ZUNoYW5uZWxzRnJvbUdyb3VwT3BlcmF0aW9uXCIsUE5BY2Nlc3NNYW5hZ2VyR3JhbnQ6XCJQTkFjY2Vzc01hbmFnZXJHcmFudFwiLFBOQWNjZXNzTWFuYWdlckF1ZGl0OlwiUE5BY2Nlc3NNYW5hZ2VyQXVkaXRcIn0sZS5leHBvcnRzPXQuZGVmYXVsdH0sZnVuY3Rpb24oZSx0KXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiBuKGUpe3ZhciB0PVtdO3JldHVybiBPYmplY3Qua2V5cyhlKS5mb3JFYWNoKGZ1bmN0aW9uKGUpe3JldHVybiB0LnB1c2goZSl9KSx0fWZ1bmN0aW9uIHIoZSl7cmV0dXJuIGVuY29kZVVSSUNvbXBvbmVudChlKS5yZXBsYWNlKC9bIX4qJygpXS9nLGZ1bmN0aW9uKGUpe3JldHVyblwiJVwiK2UuY2hhckNvZGVBdCgwKS50b1N0cmluZygxNikudG9VcHBlckNhc2UoKX0pfWZ1bmN0aW9uIGkoZSl7cmV0dXJuIG4oZSkuc29ydCgpfWZ1bmN0aW9uIG8oZSl7cmV0dXJuIGkoZSkubWFwKGZ1bmN0aW9uKHQpe3JldHVybiB0K1wiPVwiK3IoZVt0XSl9KS5qb2luKFwiJlwiKX1mdW5jdGlvbiBzKGUsdCl7cmV0dXJuIGUuaW5kZXhPZih0LHRoaXMubGVuZ3RoLXQubGVuZ3RoKSE9PS0xfWZ1bmN0aW9uIGEoKXt2YXIgZT12b2lkIDAsdD12b2lkIDA7cmV0dXJue3Byb21pc2U6bmV3IFByb21pc2UoZnVuY3Rpb24obixyKXtlPW4sdD1yfSkscmVqZWN0OnQsZnVsZmlsbDplfX1lLmV4cG9ydHM9e3NpZ25QYW1Gcm9tUGFyYW1zOm8sZW5kc1dpdGg6cyxjcmVhdGVQcm9taXNlOmEsZW5jb2RlU3RyaW5nOnJ9fSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaShlLHQpe2lmKCEoZSBpbnN0YW5jZW9mIHQpKXRocm93IG5ldyBUeXBlRXJyb3IoXCJDYW5ub3QgY2FsbCBhIGNsYXNzIGFzIGEgZnVuY3Rpb25cIil9ZnVuY3Rpb24gbyhlLHQpe2lmKCFlKXRocm93IG5ldyBSZWZlcmVuY2VFcnJvcihcInRoaXMgaGFzbid0IGJlZW4gaW5pdGlhbGlzZWQgLSBzdXBlcigpIGhhc24ndCBiZWVuIGNhbGxlZFwiKTtyZXR1cm4hdHx8XCJvYmplY3RcIiE9dHlwZW9mIHQmJlwiZnVuY3Rpb25cIiE9dHlwZW9mIHQ/ZTp0fWZ1bmN0aW9uIHMoZSx0KXtpZihcImZ1bmN0aW9uXCIhPXR5cGVvZiB0JiZudWxsIT09dCl0aHJvdyBuZXcgVHlwZUVycm9yKFwiU3VwZXIgZXhwcmVzc2lvbiBtdXN0IGVpdGhlciBiZSBudWxsIG9yIGEgZnVuY3Rpb24sIG5vdCBcIit0eXBlb2YgdCk7ZS5wcm90b3R5cGU9T2JqZWN0LmNyZWF0ZSh0JiZ0LnByb3RvdHlwZSx7Y29uc3RydWN0b3I6e3ZhbHVlOmUsZW51bWVyYWJsZTohMSx3cml0YWJsZTohMCxjb25maWd1cmFibGU6ITB9fSksdCYmKE9iamVjdC5zZXRQcm90b3R5cGVPZj9PYmplY3Quc2V0UHJvdG90eXBlT2YoZSx0KTplLl9fcHJvdG9fXz10KX1mdW5jdGlvbiBhKGUsdCl7cmV0dXJuIGUudHlwZT10LGUuZXJyb3I9ITAsZX1mdW5jdGlvbiB1KGUpe3JldHVybiBhKHttZXNzYWdlOmV9LFwidmFsaWRhdGlvbkVycm9yXCIpfWZ1bmN0aW9uIGMoZSx0LG4pe3JldHVybiBlLnVzZVBvc3QmJmUudXNlUG9zdCh0LG4pP2UucG9zdFVSTCh0LG4pOmUuZ2V0VVJMKHQsbil9ZnVuY3Rpb24gbChlKXt2YXIgdD1cIlB1Yk51Yi1KUy1cIitlLnNka0ZhbWlseTtyZXR1cm4gZS5wYXJ0bmVySWQmJih0Kz1cIi1cIitlLnBhcnRuZXJJZCksdCs9XCIvXCIrZS5nZXRWZXJzaW9uKCl9ZnVuY3Rpb24gaChlLHQsbil7dmFyIHI9ZS5jb25maWcsaT1lLmNyeXB0bztuLnRpbWVzdGFtcD1NYXRoLmZsb29yKChuZXcgRGF0ZSkuZ2V0VGltZSgpLzFlMyk7dmFyIG89ci5zdWJzY3JpYmVLZXkrXCJcXG5cIityLnB1Ymxpc2hLZXkrXCJcXG5cIit0K1wiXFxuXCI7bys9Zy5kZWZhdWx0LnNpZ25QYW1Gcm9tUGFyYW1zKG4pO3ZhciBzPWkuSE1BQ1NIQTI1NihvKTtzPXMucmVwbGFjZSgvXFwrL2csXCItXCIpLHM9cy5yZXBsYWNlKC9cXC8vZyxcIl9cIiksbi5zaWduYXR1cmU9c31PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmRlZmF1bHQ9ZnVuY3Rpb24oZSx0KXt2YXIgbj1lLm5ldHdvcmtpbmcscj1lLmNvbmZpZyxpPW51bGwsbz1udWxsLHM9e307dC5nZXRPcGVyYXRpb24oKT09PWIuZGVmYXVsdC5QTlRpbWVPcGVyYXRpb258fHQuZ2V0T3BlcmF0aW9uKCk9PT1iLmRlZmF1bHQuUE5DaGFubmVsR3JvdXBzT3BlcmF0aW9uP2k9YXJndW1lbnRzLmxlbmd0aDw9Mj92b2lkIDA6YXJndW1lbnRzWzJdOihzPWFyZ3VtZW50cy5sZW5ndGg8PTI/dm9pZCAwOmFyZ3VtZW50c1syXSxpPWFyZ3VtZW50cy5sZW5ndGg8PTM/dm9pZCAwOmFyZ3VtZW50c1szXSksXCJ1bmRlZmluZWRcIj09dHlwZW9mIFByb21pc2V8fGl8fChvPWcuZGVmYXVsdC5jcmVhdGVQcm9taXNlKCkpO3ZhciBhPXQudmFsaWRhdGVQYXJhbXMoZSxzKTtpZighYSl7dmFyIGY9dC5wcmVwYXJlUGFyYW1zKGUscykscD1jKHQsZSxzKSx5PXZvaWQgMCx2PXt1cmw6cCxvcGVyYXRpb246dC5nZXRPcGVyYXRpb24oKSx0aW1lb3V0OnQuZ2V0UmVxdWVzdFRpbWVvdXQoZSl9O2YudXVpZD1yLlVVSUQsZi5wbnNkaz1sKHIpLHIudXNlSW5zdGFuY2VJZCYmKGYuaW5zdGFuY2VpZD1yLmluc3RhbmNlSWQpLHIudXNlUmVxdWVzdElkJiYoZi5yZXF1ZXN0aWQ9ZC5kZWZhdWx0LnY0KCkpLHQuaXNBdXRoU3VwcG9ydGVkKCkmJnIuZ2V0QXV0aEtleSgpJiYoZi5hdXRoPXIuZ2V0QXV0aEtleSgpKSxyLnNlY3JldEtleSYmaChlLHAsZik7dmFyIG09ZnVuY3Rpb24obixyKXtpZihuLmVycm9yKXJldHVybiB2b2lkKGk/aShuKTpvJiZvLnJlamVjdChuZXcgXyhcIlB1Yk51YiBjYWxsIGZhaWxlZCwgY2hlY2sgc3RhdHVzIGZvciBkZXRhaWxzXCIsbikpKTt2YXIgYT10LmhhbmRsZVJlc3BvbnNlKGUscixzKTtpP2kobixhKTpvJiZvLmZ1bGZpbGwoYSl9O2lmKHQudXNlUG9zdCYmdC51c2VQb3N0KGUscykpe3ZhciBrPXQucG9zdFBheWxvYWQoZSxzKTt5PW4uUE9TVChmLGssdixtKX1lbHNlIHk9bi5HRVQoZix2LG0pO3JldHVybiB0LmdldE9wZXJhdGlvbigpPT09Yi5kZWZhdWx0LlBOU3Vic2NyaWJlT3BlcmF0aW9uP3k6bz9vLnByb21pc2U6dm9pZCAwfXJldHVybiBpP2kodShhKSk6bz8oby5yZWplY3QobmV3IF8oXCJWYWxpZGF0aW9uIGZhaWxlZCwgY2hlY2sgc3RhdHVzIGZvciBkZXRhaWxzXCIsdShhKSkpLG8ucHJvbWlzZSk6dm9pZCAwfTt2YXIgZj1uKDIpLGQ9cihmKSxwPShuKDgpLG4oMTcpKSxnPXIocCkseT1uKDcpLHY9KHIoeSksbigxNikpLGI9cih2KSxfPWZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHQoZSxuKXtpKHRoaXMsdCk7dmFyIHI9byh0aGlzLCh0Ll9fcHJvdG9fX3x8T2JqZWN0LmdldFByb3RvdHlwZU9mKHQpKS5jYWxsKHRoaXMsZSkpO3JldHVybiByLm5hbWU9ci5jb25zdHJ1Y3Rvci5uYW1lLHIuc3RhdHVzPW4sci5tZXNzYWdlPWUscn1yZXR1cm4gcyh0LGUpLHR9KEVycm9yKTtlLmV4cG9ydHM9dC5kZWZhdWx0fSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaSgpe3JldHVybiBmLmRlZmF1bHQuUE5BZGRDaGFubmVsc1RvR3JvdXBPcGVyYXRpb259ZnVuY3Rpb24gbyhlLHQpe3ZhciBuPXQuY2hhbm5lbHMscj10LmNoYW5uZWxHcm91cCxpPWUuY29uZmlnO3JldHVybiByP24mJjAhPT1uLmxlbmd0aD9pLnN1YnNjcmliZUtleT92b2lkIDA6XCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIjpcIk1pc3NpbmcgQ2hhbm5lbHNcIjpcIk1pc3NpbmcgQ2hhbm5lbCBHcm91cFwifWZ1bmN0aW9uIHMoZSx0KXt2YXIgbj10LmNoYW5uZWxHcm91cDtyZXR1cm5cIi92MS9jaGFubmVsLXJlZ2lzdHJhdGlvbi9zdWIta2V5L1wiK2UuY29uZmlnLnN1YnNjcmliZUtleStcIi9jaGFubmVsLWdyb3VwL1wiK3AuZGVmYXVsdC5lbmNvZGVTdHJpbmcobil9ZnVuY3Rpb24gYShlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gdSgpe3JldHVybiEwfWZ1bmN0aW9uIGMoZSx0KXt2YXIgbj10LmNoYW5uZWxzO3JldHVybnthZGQ6KHZvaWQgMD09PW4/W106bikuam9pbihcIixcIil9fWZ1bmN0aW9uIGwoKXtyZXR1cm57fX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmdldE9wZXJhdGlvbj1pLHQudmFsaWRhdGVQYXJhbXM9byx0LmdldFVSTD1zLHQuZ2V0UmVxdWVzdFRpbWVvdXQ9YSx0LmlzQXV0aFN1cHBvcnRlZD11LHQucHJlcGFyZVBhcmFtcz1jLHQuaGFuZGxlUmVzcG9uc2U9bDt2YXIgaD0obig4KSxuKDE2KSksZj1yKGgpLGQ9bigxNykscD1yKGQpfSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaSgpe3JldHVybiBmLmRlZmF1bHQuUE5SZW1vdmVDaGFubmVsc0Zyb21Hcm91cE9wZXJhdGlvbn1mdW5jdGlvbiBvKGUsdCl7dmFyIG49dC5jaGFubmVscyxyPXQuY2hhbm5lbEdyb3VwLGk9ZS5jb25maWc7cmV0dXJuIHI/biYmMCE9PW4ubGVuZ3RoP2kuc3Vic2NyaWJlS2V5P3ZvaWQgMDpcIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwiOlwiTWlzc2luZyBDaGFubmVsc1wiOlwiTWlzc2luZyBDaGFubmVsIEdyb3VwXCJ9ZnVuY3Rpb24gcyhlLHQpe3ZhciBuPXQuY2hhbm5lbEdyb3VwO3JldHVyblwiL3YxL2NoYW5uZWwtcmVnaXN0cmF0aW9uL3N1Yi1rZXkvXCIrZS5jb25maWcuc3Vic2NyaWJlS2V5K1wiL2NoYW5uZWwtZ3JvdXAvXCIrcC5kZWZhdWx0LmVuY29kZVN0cmluZyhuKX1mdW5jdGlvbiBhKGUpe3JldHVybiBlLmNvbmZpZy5nZXRUcmFuc2FjdGlvblRpbWVvdXQoKX1mdW5jdGlvbiB1KCl7cmV0dXJuITB9ZnVuY3Rpb24gYyhlLHQpe3ZhciBuPXQuY2hhbm5lbHM7cmV0dXJue3JlbW92ZToodm9pZCAwPT09bj9bXTpuKS5qb2luKFwiLFwiKX19ZnVuY3Rpb24gbCgpe3JldHVybnt9fU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0T3BlcmF0aW9uPWksdC52YWxpZGF0ZVBhcmFtcz1vLHQuZ2V0VVJMPXMsdC5nZXRSZXF1ZXN0VGltZW91dD1hLHQuaXNBdXRoU3VwcG9ydGVkPXUsdC5wcmVwYXJlUGFyYW1zPWMsdC5oYW5kbGVSZXNwb25zZT1sO3ZhciBoPShuKDgpLG4oMTYpKSxmPXIoaCksZD1uKDE3KSxwPXIoZCl9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX1mdW5jdGlvbiBpKCl7cmV0dXJuIGYuZGVmYXVsdC5QTlJlbW92ZUdyb3VwT3BlcmF0aW9ufWZ1bmN0aW9uIG8oZSx0KXt2YXIgbj10LmNoYW5uZWxHcm91cCxyPWUuY29uZmlnO3JldHVybiBuP3Iuc3Vic2NyaWJlS2V5P3ZvaWQgMDpcIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwiOlwiTWlzc2luZyBDaGFubmVsIEdyb3VwXCJ9ZnVuY3Rpb24gcyhlLHQpe3ZhciBuPXQuY2hhbm5lbEdyb3VwO3JldHVyblwiL3YxL2NoYW5uZWwtcmVnaXN0cmF0aW9uL3N1Yi1rZXkvXCIrZS5jb25maWcuc3Vic2NyaWJlS2V5K1wiL2NoYW5uZWwtZ3JvdXAvXCIrcC5kZWZhdWx0LmVuY29kZVN0cmluZyhuKStcIi9yZW1vdmVcIn1mdW5jdGlvbiBhKCl7cmV0dXJuITB9ZnVuY3Rpb24gdShlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gYygpe3JldHVybnt9fWZ1bmN0aW9uIGwoKXtyZXR1cm57fX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmdldE9wZXJhdGlvbj1pLHQudmFsaWRhdGVQYXJhbXM9byx0LmdldFVSTD1zLHQuaXNBdXRoU3VwcG9ydGVkPWEsdC5nZXRSZXF1ZXN0VGltZW91dD11LHQucHJlcGFyZVBhcmFtcz1jLHQuaGFuZGxlUmVzcG9uc2U9bDt2YXIgaD0obig4KSxuKDE2KSksZj1yKGgpLGQ9bigxNykscD1yKGQpfSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcigpe3JldHVybiBoLmRlZmF1bHQuUE5DaGFubmVsR3JvdXBzT3BlcmF0aW9ufWZ1bmN0aW9uIGkoZSl7aWYoIWUuY29uZmlnLnN1YnNjcmliZUtleSlyZXR1cm5cIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwifWZ1bmN0aW9uIG8oZSl7cmV0dXJuXCIvdjEvY2hhbm5lbC1yZWdpc3RyYXRpb24vc3ViLWtleS9cIitlLmNvbmZpZy5zdWJzY3JpYmVLZXkrXCIvY2hhbm5lbC1ncm91cFwifWZ1bmN0aW9uIHMoZSl7cmV0dXJuIGUuY29uZmlnLmdldFRyYW5zYWN0aW9uVGltZW91dCgpfWZ1bmN0aW9uIGEoKXtyZXR1cm4hMH1mdW5jdGlvbiB1KCl7cmV0dXJue319ZnVuY3Rpb24gYyhlLHQpe3JldHVybntncm91cHM6dC5wYXlsb2FkLmdyb3Vwc319T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249cix0LnZhbGlkYXRlUGFyYW1zPWksdC5nZXRVUkw9byx0LmdldFJlcXVlc3RUaW1lb3V0PXMsdC5pc0F1dGhTdXBwb3J0ZWQ9YSx0LnByZXBhcmVQYXJhbXM9dSx0LmhhbmRsZVJlc3BvbnNlPWM7dmFyIGw9KG4oOCksbigxNikpLGg9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fShsKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fWZ1bmN0aW9uIGkoKXtyZXR1cm4gZi5kZWZhdWx0LlBOQ2hhbm5lbHNGb3JHcm91cE9wZXJhdGlvbn1mdW5jdGlvbiBvKGUsdCl7dmFyIG49dC5jaGFubmVsR3JvdXAscj1lLmNvbmZpZztyZXR1cm4gbj9yLnN1YnNjcmliZUtleT92b2lkIDA6XCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIjpcIk1pc3NpbmcgQ2hhbm5lbCBHcm91cFwifWZ1bmN0aW9uIHMoZSx0KXt2YXIgbj10LmNoYW5uZWxHcm91cDtyZXR1cm5cIi92MS9jaGFubmVsLXJlZ2lzdHJhdGlvbi9zdWIta2V5L1wiK2UuY29uZmlnLnN1YnNjcmliZUtleStcIi9jaGFubmVsLWdyb3VwL1wiK3AuZGVmYXVsdC5lbmNvZGVTdHJpbmcobil9ZnVuY3Rpb24gYShlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gdSgpe3JldHVybiEwfWZ1bmN0aW9uIGMoKXtyZXR1cm57fX1mdW5jdGlvbiBsKGUsdCl7cmV0dXJue2NoYW5uZWxzOnQucGF5bG9hZC5jaGFubmVsc319T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249aSx0LnZhbGlkYXRlUGFyYW1zPW8sdC5nZXRVUkw9cyx0LmdldFJlcXVlc3RUaW1lb3V0PWEsdC5pc0F1dGhTdXBwb3J0ZWQ9dSx0LnByZXBhcmVQYXJhbXM9Yyx0LmhhbmRsZVJlc3BvbnNlPWw7dmFyIGg9KG4oOCksbigxNikpLGY9cihoKSxkPW4oMTcpLHA9cihkKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoKXtyZXR1cm4gaC5kZWZhdWx0LlBOUHVzaE5vdGlmaWNhdGlvbkVuYWJsZWRDaGFubmVsc09wZXJhdGlvbn1mdW5jdGlvbiBpKGUsdCl7dmFyIG49dC5kZXZpY2Uscj10LnB1c2hHYXRld2F5LGk9dC5jaGFubmVscyxvPWUuY29uZmlnO3JldHVybiBuP3I/aSYmMCE9PWkubGVuZ3RoP28uc3Vic2NyaWJlS2V5P3ZvaWQgMDpcIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwiOlwiTWlzc2luZyBDaGFubmVsc1wiOlwiTWlzc2luZyBHVyBUeXBlIChwdXNoR2F0ZXdheTogZ2NtIG9yIGFwbnMpXCI6XCJNaXNzaW5nIERldmljZSBJRCAoZGV2aWNlKVwifWZ1bmN0aW9uIG8oZSx0KXt2YXIgbj10LmRldmljZTtyZXR1cm5cIi92MS9wdXNoL3N1Yi1rZXkvXCIrZS5jb25maWcuc3Vic2NyaWJlS2V5K1wiL2RldmljZXMvXCIrbn1mdW5jdGlvbiBzKGUpe3JldHVybiBlLmNvbmZpZy5nZXRUcmFuc2FjdGlvblRpbWVvdXQoKX1mdW5jdGlvbiBhKCl7cmV0dXJuITB9ZnVuY3Rpb24gdShlLHQpe3ZhciBuPXQucHVzaEdhdGV3YXkscj10LmNoYW5uZWxzO3JldHVybnt0eXBlOm4sYWRkOih2b2lkIDA9PT1yP1tdOnIpLmpvaW4oXCIsXCIpfX1mdW5jdGlvbiBjKCl7cmV0dXJue319T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249cix0LnZhbGlkYXRlUGFyYW1zPWksdC5nZXRVUkw9byx0LmdldFJlcXVlc3RUaW1lb3V0PXMsdC5pc0F1dGhTdXBwb3J0ZWQ9YSx0LnByZXBhcmVQYXJhbXM9dSx0LmhhbmRsZVJlc3BvbnNlPWM7dmFyIGw9KG4oOCksbigxNikpLGg9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fShsKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoKXtyZXR1cm4gaC5kZWZhdWx0LlBOUHVzaE5vdGlmaWNhdGlvbkVuYWJsZWRDaGFubmVsc09wZXJhdGlvbn1mdW5jdGlvbiBpKGUsdCl7dmFyIG49dC5kZXZpY2Uscj10LnB1c2hHYXRld2F5LGk9dC5jaGFubmVscyxvPWUuY29uZmlnO3JldHVybiBuP3I/aSYmMCE9PWkubGVuZ3RoP28uc3Vic2NyaWJlS2V5P3ZvaWQgMDpcIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwiOlwiTWlzc2luZyBDaGFubmVsc1wiOlwiTWlzc2luZyBHVyBUeXBlIChwdXNoR2F0ZXdheTogZ2NtIG9yIGFwbnMpXCI6XCJNaXNzaW5nIERldmljZSBJRCAoZGV2aWNlKVwifWZ1bmN0aW9uIG8oZSx0KXt2YXIgbj10LmRldmljZTtyZXR1cm5cIi92MS9wdXNoL3N1Yi1rZXkvXCIrZS5jb25maWcuc3Vic2NyaWJlS2V5K1wiL2RldmljZXMvXCIrbn1mdW5jdGlvbiBzKGUpe3JldHVybiBlLmNvbmZpZy5nZXRUcmFuc2FjdGlvblRpbWVvdXQoKX1mdW5jdGlvbiBhKCl7cmV0dXJuITB9ZnVuY3Rpb24gdShlLHQpe3ZhciBuPXQucHVzaEdhdGV3YXkscj10LmNoYW5uZWxzO3JldHVybnt0eXBlOm4scmVtb3ZlOih2b2lkIDA9PT1yP1tdOnIpLmpvaW4oXCIsXCIpfX1mdW5jdGlvbiBjKCl7cmV0dXJue319T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249cix0LnZhbGlkYXRlUGFyYW1zPWksdC5nZXRVUkw9byx0LmdldFJlcXVlc3RUaW1lb3V0PXMsdC5pc0F1dGhTdXBwb3J0ZWQ9YSx0LnByZXBhcmVQYXJhbXM9dSx0LmhhbmRsZVJlc3BvbnNlPWM7dmFyIGw9KG4oOCksbigxNikpLGg9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fShsKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoKXtyZXR1cm4gaC5kZWZhdWx0LlBOUHVzaE5vdGlmaWNhdGlvbkVuYWJsZWRDaGFubmVsc09wZXJhdGlvbn1mdW5jdGlvbiBpKGUsdCl7dmFyIG49dC5kZXZpY2Uscj10LnB1c2hHYXRld2F5LGk9ZS5jb25maWc7cmV0dXJuIG4/cj9pLnN1YnNjcmliZUtleT92b2lkIDA6XCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIjpcIk1pc3NpbmcgR1cgVHlwZSAocHVzaEdhdGV3YXk6IGdjbSBvciBhcG5zKVwiOlwiTWlzc2luZyBEZXZpY2UgSUQgKGRldmljZSlcIn1mdW5jdGlvbiBvKGUsdCl7dmFyIG49dC5kZXZpY2U7cmV0dXJuXCIvdjEvcHVzaC9zdWIta2V5L1wiK2UuY29uZmlnLnN1YnNjcmliZUtleStcIi9kZXZpY2VzL1wiK259ZnVuY3Rpb24gcyhlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gYSgpe3JldHVybiEwfWZ1bmN0aW9uIHUoZSx0KXtyZXR1cm57dHlwZTp0LnB1c2hHYXRld2F5fX1mdW5jdGlvbiBjKGUsdCl7cmV0dXJue2NoYW5uZWxzOnR9fU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0T3BlcmF0aW9uPXIsdC52YWxpZGF0ZVBhcmFtcz1pLHQuZ2V0VVJMPW8sdC5nZXRSZXF1ZXN0VGltZW91dD1zLHQuaXNBdXRoU3VwcG9ydGVkPWEsdC5wcmVwYXJlUGFyYW1zPXUsdC5oYW5kbGVSZXNwb25zZT1jO3ZhciBsPShuKDgpLG4oMTYpKSxoPWZ1bmN0aW9uKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX0obCl9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKCl7cmV0dXJuIGguZGVmYXVsdC5QTlJlbW92ZUFsbFB1c2hOb3RpZmljYXRpb25zT3BlcmF0aW9ufWZ1bmN0aW9uIGkoZSx0KXt2YXIgbj10LmRldmljZSxyPXQucHVzaEdhdGV3YXksaT1lLmNvbmZpZztyZXR1cm4gbj9yP2kuc3Vic2NyaWJlS2V5P3ZvaWQgMDpcIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwiOlwiTWlzc2luZyBHVyBUeXBlIChwdXNoR2F0ZXdheTogZ2NtIG9yIGFwbnMpXCI6XCJNaXNzaW5nIERldmljZSBJRCAoZGV2aWNlKVwifWZ1bmN0aW9uIG8oZSx0KXt2YXIgbj10LmRldmljZTtyZXR1cm5cIi92MS9wdXNoL3N1Yi1rZXkvXCIrZS5jb25maWcuc3Vic2NyaWJlS2V5K1wiL2RldmljZXMvXCIrbitcIi9yZW1vdmVcIn1mdW5jdGlvbiBzKGUpe3JldHVybiBlLmNvbmZpZy5nZXRUcmFuc2FjdGlvblRpbWVvdXQoKX1mdW5jdGlvbiBhKCl7cmV0dXJuITB9ZnVuY3Rpb24gdShlLHQpe3JldHVybnt0eXBlOnQucHVzaEdhdGV3YXl9fWZ1bmN0aW9uIGMoKXtyZXR1cm57fX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmdldE9wZXJhdGlvbj1yLHQudmFsaWRhdGVQYXJhbXM9aSx0LmdldFVSTD1vLHQuZ2V0UmVxdWVzdFRpbWVvdXQ9cyx0LmlzQXV0aFN1cHBvcnRlZD1hLHQucHJlcGFyZVBhcmFtcz11LHQuaGFuZGxlUmVzcG9uc2U9Yzt2YXIgbD0obig4KSxuKDE2KSksaD1mdW5jdGlvbihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19KGwpfSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaSgpe3JldHVybiBmLmRlZmF1bHQuUE5VbnN1YnNjcmliZU9wZXJhdGlvbn1mdW5jdGlvbiBvKGUpe2lmKCFlLmNvbmZpZy5zdWJzY3JpYmVLZXkpcmV0dXJuXCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIn1mdW5jdGlvbiBzKGUsdCl7dmFyIG49ZS5jb25maWcscj10LmNoYW5uZWxzLGk9dm9pZCAwPT09cj9bXTpyLG89aS5sZW5ndGg+MD9pLmpvaW4oXCIsXCIpOlwiLFwiO3JldHVyblwiL3YyL3ByZXNlbmNlL3N1Yi1rZXkvXCIrbi5zdWJzY3JpYmVLZXkrXCIvY2hhbm5lbC9cIitwLmRlZmF1bHQuZW5jb2RlU3RyaW5nKG8pK1wiL2xlYXZlXCJ9ZnVuY3Rpb24gYShlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gdSgpe3JldHVybiEwfWZ1bmN0aW9uIGMoZSx0KXt2YXIgbj10LmNoYW5uZWxHcm91cHMscj12b2lkIDA9PT1uP1tdOm4saT17fTtyZXR1cm4gci5sZW5ndGg+MCYmKGlbXCJjaGFubmVsLWdyb3VwXCJdPXIuam9pbihcIixcIikpLGl9ZnVuY3Rpb24gbCgpe3JldHVybnt9fU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0T3BlcmF0aW9uPWksdC52YWxpZGF0ZVBhcmFtcz1vLHQuZ2V0VVJMPXMsdC5nZXRSZXF1ZXN0VGltZW91dD1hLHQuaXNBdXRoU3VwcG9ydGVkPXUsdC5wcmVwYXJlUGFyYW1zPWMsdC5oYW5kbGVSZXNwb25zZT1sO3ZhciBoPShuKDgpLG4oMTYpKSxmPXIoaCksZD1uKDE3KSxwPXIoZCl9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKCl7cmV0dXJuIGguZGVmYXVsdC5QTldoZXJlTm93T3BlcmF0aW9ufWZ1bmN0aW9uIGkoZSl7aWYoIWUuY29uZmlnLnN1YnNjcmliZUtleSlyZXR1cm5cIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwifWZ1bmN0aW9uIG8oZSx0KXt2YXIgbj1lLmNvbmZpZyxyPXQudXVpZCxpPXZvaWQgMD09PXI/bi5VVUlEOnI7cmV0dXJuXCIvdjIvcHJlc2VuY2Uvc3ViLWtleS9cIituLnN1YnNjcmliZUtleStcIi91dWlkL1wiK2l9ZnVuY3Rpb24gcyhlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gYSgpe3JldHVybiEwfWZ1bmN0aW9uIHUoKXtyZXR1cm57fX1mdW5jdGlvbiBjKGUsdCl7cmV0dXJue2NoYW5uZWxzOnQucGF5bG9hZC5jaGFubmVsc319T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249cix0LnZhbGlkYXRlUGFyYW1zPWksdC5nZXRVUkw9byx0LmdldFJlcXVlc3RUaW1lb3V0PXMsdC5pc0F1dGhTdXBwb3J0ZWQ9YSx0LnByZXBhcmVQYXJhbXM9dSx0LmhhbmRsZVJlc3BvbnNlPWM7dmFyIGw9KG4oOCksbigxNikpLGg9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fShsKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fWZ1bmN0aW9uIGkoKXtyZXR1cm4gZi5kZWZhdWx0LlBOSGVhcnRiZWF0T3BlcmF0aW9ufWZ1bmN0aW9uIG8oZSl7aWYoIWUuY29uZmlnLnN1YnNjcmliZUtleSlyZXR1cm5cIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwifWZ1bmN0aW9uIHMoZSx0KXt2YXIgbj1lLmNvbmZpZyxyPXQuY2hhbm5lbHMsaT12b2lkIDA9PT1yP1tdOnIsbz1pLmxlbmd0aD4wP2kuam9pbihcIixcIik6XCIsXCI7cmV0dXJuXCIvdjIvcHJlc2VuY2Uvc3ViLWtleS9cIituLnN1YnNjcmliZUtleStcIi9jaGFubmVsL1wiK3AuZGVmYXVsdC5lbmNvZGVTdHJpbmcobykrXCIvaGVhcnRiZWF0XCJ9ZnVuY3Rpb24gYSgpe3JldHVybiEwfWZ1bmN0aW9uIHUoZSl7cmV0dXJuIGUuY29uZmlnLmdldFRyYW5zYWN0aW9uVGltZW91dCgpfWZ1bmN0aW9uIGMoZSx0KXt2YXIgbj10LmNoYW5uZWxHcm91cHMscj12b2lkIDA9PT1uP1tdOm4saT10LnN0YXRlLG89dm9pZCAwPT09aT97fTppLHM9ZS5jb25maWcsYT17fTtyZXR1cm4gci5sZW5ndGg+MCYmKGFbXCJjaGFubmVsLWdyb3VwXCJdPXIuam9pbihcIixcIikpLGEuc3RhdGU9SlNPTi5zdHJpbmdpZnkobyksYS5oZWFydGJlYXQ9cy5nZXRQcmVzZW5jZVRpbWVvdXQoKSxhfWZ1bmN0aW9uIGwoKXtyZXR1cm57fX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmdldE9wZXJhdGlvbj1pLHQudmFsaWRhdGVQYXJhbXM9byx0LmdldFVSTD1zLHQuaXNBdXRoU3VwcG9ydGVkPWEsdC5nZXRSZXF1ZXN0VGltZW91dD11LHQucHJlcGFyZVBhcmFtcz1jLHQuaGFuZGxlUmVzcG9uc2U9bDt2YXIgaD0obig4KSxuKDE2KSksZj1yKGgpLGQ9bigxNykscD1yKGQpfSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaSgpe3JldHVybiBmLmRlZmF1bHQuUE5HZXRTdGF0ZU9wZXJhdGlvbn1mdW5jdGlvbiBvKGUpe2lmKCFlLmNvbmZpZy5zdWJzY3JpYmVLZXkpcmV0dXJuXCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIn1mdW5jdGlvbiBzKGUsdCl7dmFyIG49ZS5jb25maWcscj10LnV1aWQsaT12b2lkIDA9PT1yP24uVVVJRDpyLG89dC5jaGFubmVscyxzPXZvaWQgMD09PW8/W106byxhPXMubGVuZ3RoPjA/cy5qb2luKFwiLFwiKTpcIixcIjtyZXR1cm5cIi92Mi9wcmVzZW5jZS9zdWIta2V5L1wiK24uc3Vic2NyaWJlS2V5K1wiL2NoYW5uZWwvXCIrcC5kZWZhdWx0LmVuY29kZVN0cmluZyhhKStcIi91dWlkL1wiK2l9ZnVuY3Rpb24gYShlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gdSgpe3JldHVybiEwfWZ1bmN0aW9uIGMoZSx0KXt2YXIgbj10LmNoYW5uZWxHcm91cHMscj12b2lkIDA9PT1uP1tdOm4saT17fTtyZXR1cm4gci5sZW5ndGg+MCYmKGlbXCJjaGFubmVsLWdyb3VwXCJdPXIuam9pbihcIixcIikpLGl9ZnVuY3Rpb24gbChlLHQsbil7dmFyIHI9bi5jaGFubmVscyxpPXZvaWQgMD09PXI/W106cixvPW4uY2hhbm5lbEdyb3VwcyxzPXZvaWQgMD09PW8/W106byxhPXt9O3JldHVybiAxPT09aS5sZW5ndGgmJjA9PT1zLmxlbmd0aD9hW2lbMF1dPXQucGF5bG9hZDphPXQucGF5bG9hZCx7Y2hhbm5lbHM6YX19T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249aSx0LnZhbGlkYXRlUGFyYW1zPW8sdC5nZXRVUkw9cyx0LmdldFJlcXVlc3RUaW1lb3V0PWEsdC5pc0F1dGhTdXBwb3J0ZWQ9dSx0LnByZXBhcmVQYXJhbXM9Yyx0LmhhbmRsZVJlc3BvbnNlPWw7dmFyIGg9KG4oOCksbigxNikpLGY9cihoKSxkPW4oMTcpLHA9cihkKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fWZ1bmN0aW9uIGkoKXtyZXR1cm4gZi5kZWZhdWx0LlBOU2V0U3RhdGVPcGVyYXRpb259ZnVuY3Rpb24gbyhlLHQpe3ZhciBuPWUuY29uZmlnLHI9dC5zdGF0ZSxpPXQuY2hhbm5lbHMsbz12b2lkIDA9PT1pP1tdOmkscz10LmNoYW5uZWxHcm91cHMsYT12b2lkIDA9PT1zP1tdOnM7cmV0dXJuIHI/bi5zdWJzY3JpYmVLZXk/MD09PW8ubGVuZ3RoJiYwPT09YS5sZW5ndGg/XCJQbGVhc2UgcHJvdmlkZSBhIGxpc3Qgb2YgY2hhbm5lbHMgYW5kL29yIGNoYW5uZWwtZ3JvdXBzXCI6dm9pZCAwOlwiTWlzc2luZyBTdWJzY3JpYmUgS2V5XCI6XCJNaXNzaW5nIFN0YXRlXCJ9ZnVuY3Rpb24gcyhlLHQpe3ZhciBuPWUuY29uZmlnLHI9dC5jaGFubmVscyxpPXZvaWQgMD09PXI/W106cixvPWkubGVuZ3RoPjA/aS5qb2luKFwiLFwiKTpcIixcIjtyZXR1cm5cIi92Mi9wcmVzZW5jZS9zdWIta2V5L1wiK24uc3Vic2NyaWJlS2V5K1wiL2NoYW5uZWwvXCIrcC5kZWZhdWx0LmVuY29kZVN0cmluZyhvKStcIi91dWlkL1wiK24uVVVJRCtcIi9kYXRhXCJ9ZnVuY3Rpb24gYShlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gdSgpe3JldHVybiEwfWZ1bmN0aW9uIGMoZSx0KXt2YXIgbj10LnN0YXRlLHI9dC5jaGFubmVsR3JvdXBzLGk9dm9pZCAwPT09cj9bXTpyLG89e307cmV0dXJuIG8uc3RhdGU9SlNPTi5zdHJpbmdpZnkobiksaS5sZW5ndGg+MCYmKG9bXCJjaGFubmVsLWdyb3VwXCJdPWkuam9pbihcIixcIikpLG99ZnVuY3Rpb24gbChlLHQpe3JldHVybntzdGF0ZTp0LnBheWxvYWR9fU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0T3BlcmF0aW9uPWksdC52YWxpZGF0ZVBhcmFtcz1vLHQuZ2V0VVJMPXMsdC5nZXRSZXF1ZXN0VGltZW91dD1hLHQuaXNBdXRoU3VwcG9ydGVkPXUsdC5wcmVwYXJlUGFyYW1zPWMsdC5oYW5kbGVSZXNwb25zZT1sO3ZhciBoPShuKDgpLG4oMTYpKSxmPXIoaCksZD1uKDE3KSxwPXIoZCl9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX1mdW5jdGlvbiBpKCl7cmV0dXJuIGYuZGVmYXVsdC5QTkhlcmVOb3dPcGVyYXRpb259ZnVuY3Rpb24gbyhlKXtpZighZS5jb25maWcuc3Vic2NyaWJlS2V5KXJldHVyblwiTWlzc2luZyBTdWJzY3JpYmUgS2V5XCJ9ZnVuY3Rpb24gcyhlLHQpe3ZhciBuPWUuY29uZmlnLHI9dC5jaGFubmVscyxpPXZvaWQgMD09PXI/W106cixvPXQuY2hhbm5lbEdyb3VwcyxzPXZvaWQgMD09PW8/W106byxhPVwiL3YyL3ByZXNlbmNlL3N1Yi1rZXkvXCIrbi5zdWJzY3JpYmVLZXk7aWYoaS5sZW5ndGg+MHx8cy5sZW5ndGg+MCl7dmFyIHU9aS5sZW5ndGg+MD9pLmpvaW4oXCIsXCIpOlwiLFwiO2ErPVwiL2NoYW5uZWwvXCIrcC5kZWZhdWx0LmVuY29kZVN0cmluZyh1KX1yZXR1cm4gYX1mdW5jdGlvbiBhKGUpe3JldHVybiBlLmNvbmZpZy5nZXRUcmFuc2FjdGlvblRpbWVvdXQoKX1mdW5jdGlvbiB1KCl7cmV0dXJuITB9ZnVuY3Rpb24gYyhlLHQpe3ZhciBuPXQuY2hhbm5lbEdyb3VwcyxyPXZvaWQgMD09PW4/W106bixpPXQuaW5jbHVkZVVVSURzLG89dm9pZCAwPT09aXx8aSxzPXQuaW5jbHVkZVN0YXRlLGE9dm9pZCAwIT09cyYmcyx1PXt9O3JldHVybiBvfHwodS5kaXNhYmxlX3V1aWRzPTEpLGEmJih1LnN0YXRlPTEpLHIubGVuZ3RoPjAmJih1W1wiY2hhbm5lbC1ncm91cFwiXT1yLmpvaW4oXCIsXCIpKSx1fWZ1bmN0aW9uIGwoZSx0LG4pe3ZhciByPW4uY2hhbm5lbHMsaT12b2lkIDA9PT1yP1tdOnIsbz1uLmNoYW5uZWxHcm91cHMscz12b2lkIDA9PT1vP1tdOm8sYT1uLmluY2x1ZGVVVUlEcyx1PXZvaWQgMD09PWF8fGEsYz1uLmluY2x1ZGVTdGF0ZSxsPXZvaWQgMCE9PWMmJmM7cmV0dXJuIGkubGVuZ3RoPjF8fHMubGVuZ3RoPjB8fDA9PT1zLmxlbmd0aCYmMD09PWkubGVuZ3RoP2Z1bmN0aW9uKCl7dmFyIGU9e307cmV0dXJuIGUudG90YWxDaGFubmVscz10LnBheWxvYWQudG90YWxfY2hhbm5lbHMsZS50b3RhbE9jY3VwYW5jeT10LnBheWxvYWQudG90YWxfb2NjdXBhbmN5LGUuY2hhbm5lbHM9e30sT2JqZWN0LmtleXModC5wYXlsb2FkLmNoYW5uZWxzKS5mb3JFYWNoKGZ1bmN0aW9uKG4pe3ZhciByPXQucGF5bG9hZC5jaGFubmVsc1tuXSxpPVtdO3JldHVybiBlLmNoYW5uZWxzW25dPXtvY2N1cGFudHM6aSxuYW1lOm4sb2NjdXBhbmN5OnIub2NjdXBhbmN5fSx1JiZyLnV1aWRzLmZvckVhY2goZnVuY3Rpb24oZSl7bD9pLnB1c2goe3N0YXRlOmUuc3RhdGUsdXVpZDplLnV1aWR9KTppLnB1c2goe3N0YXRlOm51bGwsdXVpZDplfSl9KSxlfSksZX0oKTpmdW5jdGlvbigpe3ZhciBlPXt9LG49W107cmV0dXJuIGUudG90YWxDaGFubmVscz0xLGUudG90YWxPY2N1cGFuY3k9dC5vY2N1cGFuY3ksZS5jaGFubmVscz17fSxlLmNoYW5uZWxzW2lbMF1dPXtvY2N1cGFudHM6bixuYW1lOmlbMF0sb2NjdXBhbmN5OnQub2NjdXBhbmN5fSx1JiZ0LnV1aWRzLmZvckVhY2goZnVuY3Rpb24oZSl7bD9uLnB1c2goe3N0YXRlOmUuc3RhdGUsdXVpZDplLnV1aWR9KTpuLnB1c2goe3N0YXRlOm51bGwsdXVpZDplfSl9KSxlfSgpfU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0T3BlcmF0aW9uPWksdC52YWxpZGF0ZVBhcmFtcz1vLHQuZ2V0VVJMPXMsdC5nZXRSZXF1ZXN0VGltZW91dD1hLHQuaXNBdXRoU3VwcG9ydGVkPXUsdC5wcmVwYXJlUGFyYW1zPWMsdC5oYW5kbGVSZXNwb25zZT1sO3ZhciBoPShuKDgpLG4oMTYpKSxmPXIoaCksZD1uKDE3KSxwPXIoZCl9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKCl7cmV0dXJuIGguZGVmYXVsdC5QTkFjY2Vzc01hbmFnZXJBdWRpdH1mdW5jdGlvbiBpKGUpe2lmKCFlLmNvbmZpZy5zdWJzY3JpYmVLZXkpcmV0dXJuXCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIn1mdW5jdGlvbiBvKGUpe3JldHVyblwiL3YyL2F1dGgvYXVkaXQvc3ViLWtleS9cIitlLmNvbmZpZy5zdWJzY3JpYmVLZXl9ZnVuY3Rpb24gcyhlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gYSgpe3JldHVybiExfWZ1bmN0aW9uIHUoZSx0KXt2YXIgbj10LmNoYW5uZWwscj10LmNoYW5uZWxHcm91cCxpPXQuYXV0aEtleXMsbz12b2lkIDA9PT1pP1tdOmkscz17fTtyZXR1cm4gbiYmKHMuY2hhbm5lbD1uKSxyJiYoc1tcImNoYW5uZWwtZ3JvdXBcIl09ciksby5sZW5ndGg+MCYmKHMuYXV0aD1vLmpvaW4oXCIsXCIpKSxzfWZ1bmN0aW9uIGMoZSx0KXtyZXR1cm4gdC5wYXlsb2FkfU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0T3BlcmF0aW9uPXIsdC52YWxpZGF0ZVBhcmFtcz1pLHQuZ2V0VVJMPW8sdC5nZXRSZXF1ZXN0VGltZW91dD1zLHQuaXNBdXRoU3VwcG9ydGVkPWEsdC5wcmVwYXJlUGFyYW1zPXUsdC5oYW5kbGVSZXNwb25zZT1jO3ZhciBsPShuKDgpLG4oMTYpKSxoPWZ1bmN0aW9uKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX0obCl9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKCl7cmV0dXJuIGguZGVmYXVsdC5QTkFjY2Vzc01hbmFnZXJHcmFudH1mdW5jdGlvbiBpKGUpe3ZhciB0PWUuY29uZmlnO3JldHVybiB0LnN1YnNjcmliZUtleT90LnB1Ymxpc2hLZXk/dC5zZWNyZXRLZXk/dm9pZCAwOlwiTWlzc2luZyBTZWNyZXQgS2V5XCI6XCJNaXNzaW5nIFB1Ymxpc2ggS2V5XCI6XCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIn1mdW5jdGlvbiBvKGUpe3JldHVyblwiL3YyL2F1dGgvZ3JhbnQvc3ViLWtleS9cIitlLmNvbmZpZy5zdWJzY3JpYmVLZXl9ZnVuY3Rpb24gcyhlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gYSgpe3JldHVybiExfWZ1bmN0aW9uIHUoZSx0KXt2YXIgbj10LmNoYW5uZWxzLHI9dm9pZCAwPT09bj9bXTpuLGk9dC5jaGFubmVsR3JvdXBzLG89dm9pZCAwPT09aT9bXTppLHM9dC50dGwsYT10LnJlYWQsdT12b2lkIDAhPT1hJiZhLGM9dC53cml0ZSxsPXZvaWQgMCE9PWMmJmMsaD10Lm1hbmFnZSxmPXZvaWQgMCE9PWgmJmgsZD10LmF1dGhLZXlzLHA9dm9pZCAwPT09ZD9bXTpkLGc9e307cmV0dXJuIGcucj11P1wiMVwiOlwiMFwiLGcudz1sP1wiMVwiOlwiMFwiLGcubT1mP1wiMVwiOlwiMFwiLHIubGVuZ3RoPjAmJihnLmNoYW5uZWw9ci5qb2luKFwiLFwiKSksby5sZW5ndGg+MCYmKGdbXCJjaGFubmVsLWdyb3VwXCJdPW8uam9pbihcIixcIikpLHAubGVuZ3RoPjAmJihnLmF1dGg9cC5qb2luKFwiLFwiKSksKHN8fDA9PT1zKSYmKGcudHRsPXMpLGd9ZnVuY3Rpb24gYygpe3JldHVybnt9fU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0T3BlcmF0aW9uPXIsdC52YWxpZGF0ZVBhcmFtcz1pLHQuZ2V0VVJMPW8sdC5nZXRSZXF1ZXN0VGltZW91dD1zLHQuaXNBdXRoU3VwcG9ydGVkPWEsdC5wcmVwYXJlUGFyYW1zPXUsdC5oYW5kbGVSZXNwb25zZT1jO3ZhciBsPShuKDgpLG4oMTYpKSxoPWZ1bmN0aW9uKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX0obCl9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX1mdW5jdGlvbiBpKGUsdCl7dmFyIG49ZS5jcnlwdG8scj1lLmNvbmZpZyxpPUpTT04uc3RyaW5naWZ5KHQpO3JldHVybiByLmNpcGhlcktleSYmKGk9bi5lbmNyeXB0KGkpLGk9SlNPTi5zdHJpbmdpZnkoaSkpLGl9ZnVuY3Rpb24gbygpe3JldHVybiB2LmRlZmF1bHQuUE5QdWJsaXNoT3BlcmF0aW9ufWZ1bmN0aW9uIHMoZSx0KXt2YXIgbj1lLmNvbmZpZyxyPXQubWVzc2FnZTtyZXR1cm4gdC5jaGFubmVsP3I/bi5zdWJzY3JpYmVLZXk/dm9pZCAwOlwiTWlzc2luZyBTdWJzY3JpYmUgS2V5XCI6XCJNaXNzaW5nIE1lc3NhZ2VcIjpcIk1pc3NpbmcgQ2hhbm5lbFwifWZ1bmN0aW9uIGEoZSx0KXt2YXIgbj10LnNlbmRCeVBvc3Q7cmV0dXJuIHZvaWQgMCE9PW4mJm59ZnVuY3Rpb24gdShlLHQpe3ZhciBuPWUuY29uZmlnLHI9dC5jaGFubmVsLG89dC5tZXNzYWdlLHM9aShlLG8pO3JldHVyblwiL3B1Ymxpc2gvXCIrbi5wdWJsaXNoS2V5K1wiL1wiK24uc3Vic2NyaWJlS2V5K1wiLzAvXCIrXy5kZWZhdWx0LmVuY29kZVN0cmluZyhyKStcIi8wL1wiK18uZGVmYXVsdC5lbmNvZGVTdHJpbmcocyl9ZnVuY3Rpb24gYyhlLHQpe3ZhciBuPWUuY29uZmlnLHI9dC5jaGFubmVsO3JldHVyblwiL3B1Ymxpc2gvXCIrbi5wdWJsaXNoS2V5K1wiL1wiK24uc3Vic2NyaWJlS2V5K1wiLzAvXCIrXy5kZWZhdWx0LmVuY29kZVN0cmluZyhyKStcIi8wXCJ9ZnVuY3Rpb24gbChlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gaCgpe3JldHVybiEwfWZ1bmN0aW9uIGYoZSx0KXtyZXR1cm4gaShlLHQubWVzc2FnZSl9ZnVuY3Rpb24gZChlLHQpe3ZhciBuPXQubWV0YSxyPXQucmVwbGljYXRlLGk9dm9pZCAwPT09cnx8cixvPXQuc3RvcmVJbkhpc3Rvcnkscz10LnR0bCxhPXt9O3JldHVybiBudWxsIT1vJiYoYS5zdG9yZT1vP1wiMVwiOlwiMFwiKSxzJiYoYS50dGw9cyksaT09PSExJiYoYS5ub3JlcD1cInRydWVcIiksbiYmXCJvYmplY3RcIj09PSh2b2lkIDA9PT1uP1widW5kZWZpbmVkXCI6ZyhuKSkmJihhLm1ldGE9SlNPTi5zdHJpbmdpZnkobikpLGF9ZnVuY3Rpb24gcChlLHQpe3JldHVybnt0aW1ldG9rZW46dFsyXX19T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSk7dmFyIGc9XCJmdW5jdGlvblwiPT10eXBlb2YgU3ltYm9sJiZcInN5bWJvbFwiPT10eXBlb2YgU3ltYm9sLml0ZXJhdG9yP2Z1bmN0aW9uKGUpe3JldHVybiB0eXBlb2YgZX06ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJlwiZnVuY3Rpb25cIj09dHlwZW9mIFN5bWJvbCYmZS5jb25zdHJ1Y3Rvcj09PVN5bWJvbCYmZSE9PVN5bWJvbC5wcm90b3R5cGU/XCJzeW1ib2xcIjp0eXBlb2YgZX07dC5nZXRPcGVyYXRpb249byx0LnZhbGlkYXRlUGFyYW1zPXMsdC51c2VQb3N0PWEsdC5nZXRVUkw9dSx0LnBvc3RVUkw9Yyx0LmdldFJlcXVlc3RUaW1lb3V0PWwsdC5pc0F1dGhTdXBwb3J0ZWQ9aCx0LnBvc3RQYXlsb2FkPWYsdC5wcmVwYXJlUGFyYW1zPWQsdC5oYW5kbGVSZXNwb25zZT1wO3ZhciB5PShuKDgpLG4oMTYpKSx2PXIoeSksYj1uKDE3KSxfPXIoYil9LGZ1bmN0aW9uKGUsdCxuKXtcInVzZSBzdHJpY3RcIjtmdW5jdGlvbiByKGUpe3JldHVybiBlJiZlLl9fZXNNb2R1bGU/ZTp7ZGVmYXVsdDplfX1mdW5jdGlvbiBpKGUsdCl7dmFyIG49ZS5jb25maWcscj1lLmNyeXB0bztpZighbi5jaXBoZXJLZXkpcmV0dXJuIHQ7dHJ5e3JldHVybiByLmRlY3J5cHQodCl9Y2F0Y2goZSl7cmV0dXJuIHR9fWZ1bmN0aW9uIG8oKXtyZXR1cm4gZC5kZWZhdWx0LlBOSGlzdG9yeU9wZXJhdGlvbn1mdW5jdGlvbiBzKGUsdCl7dmFyIG49dC5jaGFubmVsLHI9ZS5jb25maWc7cmV0dXJuIG4/ci5zdWJzY3JpYmVLZXk/dm9pZCAwOlwiTWlzc2luZyBTdWJzY3JpYmUgS2V5XCI6XCJNaXNzaW5nIGNoYW5uZWxcIn1mdW5jdGlvbiBhKGUsdCl7dmFyIG49dC5jaGFubmVsO3JldHVyblwiL3YyL2hpc3Rvcnkvc3ViLWtleS9cIitlLmNvbmZpZy5zdWJzY3JpYmVLZXkrXCIvY2hhbm5lbC9cIitnLmRlZmF1bHQuZW5jb2RlU3RyaW5nKG4pfWZ1bmN0aW9uIHUoZSl7cmV0dXJuIGUuY29uZmlnLmdldFRyYW5zYWN0aW9uVGltZW91dCgpfWZ1bmN0aW9uIGMoKXtyZXR1cm4hMH1mdW5jdGlvbiBsKGUsdCl7dmFyIG49dC5zdGFydCxyPXQuZW5kLGk9dC5yZXZlcnNlLG89dC5jb3VudCxzPXZvaWQgMD09PW8/MTAwOm8sYT10LnN0cmluZ2lmaWVkVGltZVRva2VuLHU9dm9pZCAwIT09YSYmYSxjPXtpbmNsdWRlX3Rva2VuOlwidHJ1ZVwifTtyZXR1cm4gYy5jb3VudD1zLG4mJihjLnN0YXJ0PW4pLHImJihjLmVuZD1yKSx1JiYoYy5zdHJpbmdfbWVzc2FnZV90b2tlbj1cInRydWVcIiksbnVsbCE9aSYmKGMucmV2ZXJzZT1pLnRvU3RyaW5nKCkpLGN9ZnVuY3Rpb24gaChlLHQpe3ZhciBuPXttZXNzYWdlczpbXSxzdGFydFRpbWVUb2tlbjp0WzFdLGVuZFRpbWVUb2tlbjp0WzJdfTtyZXR1cm4gdFswXS5mb3JFYWNoKGZ1bmN0aW9uKHQpe3ZhciByPXt0aW1ldG9rZW46dC50aW1ldG9rZW4sZW50cnk6aShlLHQubWVzc2FnZSl9O24ubWVzc2FnZXMucHVzaChyKX0pLG59T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249byx0LnZhbGlkYXRlUGFyYW1zPXMsdC5nZXRVUkw9YSx0LmdldFJlcXVlc3RUaW1lb3V0PXUsdC5pc0F1dGhTdXBwb3J0ZWQ9Yyx0LnByZXBhcmVQYXJhbXM9bCx0LmhhbmRsZVJlc3BvbnNlPWg7dmFyIGY9KG4oOCksbigxNikpLGQ9cihmKSxwPW4oMTcpLGc9cihwKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fWZ1bmN0aW9uIGkoZSx0KXt2YXIgbj1lLmNvbmZpZyxyPWUuY3J5cHRvO2lmKCFuLmNpcGhlcktleSlyZXR1cm4gdDt0cnl7cmV0dXJuIHIuZGVjcnlwdCh0KX1jYXRjaChlKXtyZXR1cm4gdH19ZnVuY3Rpb24gbygpe3JldHVybiBkLmRlZmF1bHQuUE5GZXRjaE1lc3NhZ2VzT3BlcmF0aW9ufWZ1bmN0aW9uIHMoZSx0KXt2YXIgbj10LmNoYW5uZWxzLHI9ZS5jb25maWc7cmV0dXJuIG4mJjAhPT1uLmxlbmd0aD9yLnN1YnNjcmliZUtleT92b2lkIDA6XCJNaXNzaW5nIFN1YnNjcmliZSBLZXlcIjpcIk1pc3NpbmcgY2hhbm5lbHNcIn1mdW5jdGlvbiBhKGUsdCl7dmFyIG49dC5jaGFubmVscyxyPXZvaWQgMD09PW4/W106bixpPWUuY29uZmlnLG89ci5sZW5ndGg+MD9yLmpvaW4oXCIsXCIpOlwiLFwiO3JldHVyblwiL3YzL2hpc3Rvcnkvc3ViLWtleS9cIitpLnN1YnNjcmliZUtleStcIi9jaGFubmVsL1wiK2cuZGVmYXVsdC5lbmNvZGVTdHJpbmcobyl9ZnVuY3Rpb24gdShlKXtyZXR1cm4gZS5jb25maWcuZ2V0VHJhbnNhY3Rpb25UaW1lb3V0KCl9ZnVuY3Rpb24gYygpe3JldHVybiEwfWZ1bmN0aW9uIGwoZSx0KXt2YXIgbj10LnN0YXJ0LHI9dC5lbmQsaT10LmNvdW50LG89e307cmV0dXJuIGkmJihvLm1heD1pKSxuJiYoby5zdGFydD1uKSxyJiYoby5lbmQ9ciksb31mdW5jdGlvbiBoKGUsdCl7dmFyIG49e2NoYW5uZWxzOnt9fVxuO3JldHVybiBPYmplY3Qua2V5cyh0LmNoYW5uZWxzfHx7fSkuZm9yRWFjaChmdW5jdGlvbihyKXtuLmNoYW5uZWxzW3JdPVtdLCh0LmNoYW5uZWxzW3JdfHxbXSkuZm9yRWFjaChmdW5jdGlvbih0KXt2YXIgbz17fTtvLmNoYW5uZWw9cixvLnN1YnNjcmlwdGlvbj1udWxsLG8udGltZXRva2VuPXQudGltZXRva2VuLG8ubWVzc2FnZT1pKGUsdC5tZXNzYWdlKSxuLmNoYW5uZWxzW3JdLnB1c2gobyl9KX0pLG59T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5nZXRPcGVyYXRpb249byx0LnZhbGlkYXRlUGFyYW1zPXMsdC5nZXRVUkw9YSx0LmdldFJlcXVlc3RUaW1lb3V0PXUsdC5pc0F1dGhTdXBwb3J0ZWQ9Yyx0LnByZXBhcmVQYXJhbXM9bCx0LmhhbmRsZVJlc3BvbnNlPWg7dmFyIGY9KG4oOCksbigxNikpLGQ9cihmKSxwPW4oMTcpLGc9cihwKX0sZnVuY3Rpb24oZSx0LG4pe1widXNlIHN0cmljdFwiO2Z1bmN0aW9uIHIoZSl7cmV0dXJuIGUmJmUuX19lc01vZHVsZT9lOntkZWZhdWx0OmV9fWZ1bmN0aW9uIGkoKXtyZXR1cm4gZi5kZWZhdWx0LlBOU3Vic2NyaWJlT3BlcmF0aW9ufWZ1bmN0aW9uIG8oZSl7aWYoIWUuY29uZmlnLnN1YnNjcmliZUtleSlyZXR1cm5cIk1pc3NpbmcgU3Vic2NyaWJlIEtleVwifWZ1bmN0aW9uIHMoZSx0KXt2YXIgbj1lLmNvbmZpZyxyPXQuY2hhbm5lbHMsaT12b2lkIDA9PT1yP1tdOnIsbz1pLmxlbmd0aD4wP2kuam9pbihcIixcIik6XCIsXCI7cmV0dXJuXCIvdjIvc3Vic2NyaWJlL1wiK24uc3Vic2NyaWJlS2V5K1wiL1wiK3AuZGVmYXVsdC5lbmNvZGVTdHJpbmcobykrXCIvMFwifWZ1bmN0aW9uIGEoZSl7cmV0dXJuIGUuY29uZmlnLmdldFN1YnNjcmliZVRpbWVvdXQoKX1mdW5jdGlvbiB1KCl7cmV0dXJuITB9ZnVuY3Rpb24gYyhlLHQpe3ZhciBuPWUuY29uZmlnLHI9dC5jaGFubmVsR3JvdXBzLGk9dm9pZCAwPT09cj9bXTpyLG89dC50aW1ldG9rZW4scz10LmZpbHRlckV4cHJlc3Npb24sYT10LnJlZ2lvbix1PXtoZWFydGJlYXQ6bi5nZXRQcmVzZW5jZVRpbWVvdXQoKX07cmV0dXJuIGkubGVuZ3RoPjAmJih1W1wiY2hhbm5lbC1ncm91cFwiXT1pLmpvaW4oXCIsXCIpKSxzJiZzLmxlbmd0aD4wJiYodVtcImZpbHRlci1leHByXCJdPXMpLG8mJih1LnR0PW8pLGEmJih1LnRyPWEpLHV9ZnVuY3Rpb24gbChlLHQpe3ZhciBuPVtdO3QubS5mb3JFYWNoKGZ1bmN0aW9uKGUpe3ZhciB0PXtwdWJsaXNoVGltZXRva2VuOmUucC50LHJlZ2lvbjplLnAucn0scj17c2hhcmQ6cGFyc2VJbnQoZS5hLDEwKSxzdWJzY3JpcHRpb25NYXRjaDplLmIsY2hhbm5lbDplLmMscGF5bG9hZDplLmQsZmxhZ3M6ZS5mLGlzc3VpbmdDbGllbnRJZDplLmksc3Vic2NyaWJlS2V5OmUuayxvcmlnaW5hdGlvblRpbWV0b2tlbjplLm8scHVibGlzaE1ldGFEYXRhOnR9O24ucHVzaChyKX0pO3ZhciByPXt0aW1ldG9rZW46dC50LnQscmVnaW9uOnQudC5yfTtyZXR1cm57bWVzc2FnZXM6bixtZXRhZGF0YTpyfX1PYmplY3QuZGVmaW5lUHJvcGVydHkodCxcIl9fZXNNb2R1bGVcIix7dmFsdWU6ITB9KSx0LmdldE9wZXJhdGlvbj1pLHQudmFsaWRhdGVQYXJhbXM9byx0LmdldFVSTD1zLHQuZ2V0UmVxdWVzdFRpbWVvdXQ9YSx0LmlzQXV0aFN1cHBvcnRlZD11LHQucHJlcGFyZVBhcmFtcz1jLHQuaGFuZGxlUmVzcG9uc2U9bDt2YXIgaD0obig4KSxuKDE2KSksZj1yKGgpLGQ9bigxNykscD1yKGQpfSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19ZnVuY3Rpb24gaShlLHQpe2lmKCEoZSBpbnN0YW5jZW9mIHQpKXRocm93IG5ldyBUeXBlRXJyb3IoXCJDYW5ub3QgY2FsbCBhIGNsYXNzIGFzIGEgZnVuY3Rpb25cIil9T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSk7dmFyIG89ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKGUsdCl7Zm9yKHZhciBuPTA7bjx0Lmxlbmd0aDtuKyspe3ZhciByPXRbbl07ci5lbnVtZXJhYmxlPXIuZW51bWVyYWJsZXx8ITEsci5jb25maWd1cmFibGU9ITAsXCJ2YWx1ZVwiaW4gciYmKHIud3JpdGFibGU9ITApLE9iamVjdC5kZWZpbmVQcm9wZXJ0eShlLHIua2V5LHIpfX1yZXR1cm4gZnVuY3Rpb24odCxuLHIpe3JldHVybiBuJiZlKHQucHJvdG90eXBlLG4pLHImJmUodCxyKSx0fX0oKSxzPW4oNyksYT0ocihzKSxuKDEzKSksdT1yKGEpLGM9KG4oOCksZnVuY3Rpb24oKXtmdW5jdGlvbiBlKHQpe3ZhciBuPXRoaXM7aSh0aGlzLGUpLHRoaXMuX21vZHVsZXM9e30sT2JqZWN0LmtleXModCkuZm9yRWFjaChmdW5jdGlvbihlKXtuLl9tb2R1bGVzW2VdPXRbZV0uYmluZChuKX0pfXJldHVybiBvKGUsW3trZXk6XCJpbml0XCIsdmFsdWU6ZnVuY3Rpb24oZSl7dGhpcy5fY29uZmlnPWUsdGhpcy5fbWF4U3ViRG9tYWluPTIwLHRoaXMuX2N1cnJlbnRTdWJEb21haW49TWF0aC5mbG9vcihNYXRoLnJhbmRvbSgpKnRoaXMuX21heFN1YkRvbWFpbiksdGhpcy5fcHJvdmlkZWRGUUROPSh0aGlzLl9jb25maWcuc2VjdXJlP1wiaHR0cHM6Ly9cIjpcImh0dHA6Ly9cIikrdGhpcy5fY29uZmlnLm9yaWdpbix0aGlzLl9jb3JlUGFyYW1zPXt9LHRoaXMuc2hpZnRTdGFuZGFyZE9yaWdpbigpfX0se2tleTpcIm5leHRPcmlnaW5cIix2YWx1ZTpmdW5jdGlvbigpe2lmKHRoaXMuX3Byb3ZpZGVkRlFETi5pbmRleE9mKFwicHVic3ViLlwiKT09PS0xKXJldHVybiB0aGlzLl9wcm92aWRlZEZRRE47dmFyIGU9dm9pZCAwO3JldHVybiB0aGlzLl9jdXJyZW50U3ViRG9tYWluPXRoaXMuX2N1cnJlbnRTdWJEb21haW4rMSx0aGlzLl9jdXJyZW50U3ViRG9tYWluPj10aGlzLl9tYXhTdWJEb21haW4mJih0aGlzLl9jdXJyZW50U3ViRG9tYWluPTEpLGU9dGhpcy5fY3VycmVudFN1YkRvbWFpbi50b1N0cmluZygpLHRoaXMuX3Byb3ZpZGVkRlFETi5yZXBsYWNlKFwicHVic3ViXCIsXCJwc1wiK2UpfX0se2tleTpcInNoaWZ0U3RhbmRhcmRPcmlnaW5cIix2YWx1ZTpmdW5jdGlvbigpe3ZhciBlPWFyZ3VtZW50cy5sZW5ndGg+MCYmdm9pZCAwIT09YXJndW1lbnRzWzBdJiZhcmd1bWVudHNbMF07cmV0dXJuIHRoaXMuX3N0YW5kYXJkT3JpZ2luPXRoaXMubmV4dE9yaWdpbihlKSx0aGlzLl9zdGFuZGFyZE9yaWdpbn19LHtrZXk6XCJnZXRTdGFuZGFyZE9yaWdpblwiLHZhbHVlOmZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuX3N0YW5kYXJkT3JpZ2lufX0se2tleTpcIlBPU1RcIix2YWx1ZTpmdW5jdGlvbihlLHQsbixyKXtyZXR1cm4gdGhpcy5fbW9kdWxlcy5wb3N0KGUsdCxuLHIpfX0se2tleTpcIkdFVFwiLHZhbHVlOmZ1bmN0aW9uKGUsdCxuKXtyZXR1cm4gdGhpcy5fbW9kdWxlcy5nZXQoZSx0LG4pfX0se2tleTpcIl9kZXRlY3RFcnJvckNhdGVnb3J5XCIsdmFsdWU6ZnVuY3Rpb24oZSl7aWYoXCJFTk9URk9VTkRcIj09PWUuY29kZSlyZXR1cm4gdS5kZWZhdWx0LlBOTmV0d29ya0lzc3Vlc0NhdGVnb3J5O2lmKFwiRUNPTk5SRUZVU0VEXCI9PT1lLmNvZGUpcmV0dXJuIHUuZGVmYXVsdC5QTk5ldHdvcmtJc3N1ZXNDYXRlZ29yeTtpZihcIkVDT05OUkVTRVRcIj09PWUuY29kZSlyZXR1cm4gdS5kZWZhdWx0LlBOTmV0d29ya0lzc3Vlc0NhdGVnb3J5O2lmKFwiRUFJX0FHQUlOXCI9PT1lLmNvZGUpcmV0dXJuIHUuZGVmYXVsdC5QTk5ldHdvcmtJc3N1ZXNDYXRlZ29yeTtpZigwPT09ZS5zdGF0dXN8fGUuaGFzT3duUHJvcGVydHkoXCJzdGF0dXNcIikmJnZvaWQgMD09PWUuc3RhdHVzKXJldHVybiB1LmRlZmF1bHQuUE5OZXR3b3JrSXNzdWVzQ2F0ZWdvcnk7aWYoZS50aW1lb3V0KXJldHVybiB1LmRlZmF1bHQuUE5UaW1lb3V0Q2F0ZWdvcnk7aWYoZS5yZXNwb25zZSl7aWYoZS5yZXNwb25zZS5iYWRSZXF1ZXN0KXJldHVybiB1LmRlZmF1bHQuUE5CYWRSZXF1ZXN0Q2F0ZWdvcnk7aWYoZS5yZXNwb25zZS5mb3JiaWRkZW4pcmV0dXJuIHUuZGVmYXVsdC5QTkFjY2Vzc0RlbmllZENhdGVnb3J5fXJldHVybiB1LmRlZmF1bHQuUE5Vbmtub3duQ2F0ZWdvcnl9fV0pLGV9KCkpO3QuZGVmYXVsdD1jLGUuZXhwb3J0cz10LmRlZmF1bHR9LGZ1bmN0aW9uKGUsdCl7XCJ1c2Ugc3RyaWN0XCI7T2JqZWN0LmRlZmluZVByb3BlcnR5KHQsXCJfX2VzTW9kdWxlXCIse3ZhbHVlOiEwfSksdC5kZWZhdWx0PXtnZXQ6ZnVuY3Rpb24oZSl7dHJ5e3JldHVybiBsb2NhbFN0b3JhZ2UuZ2V0SXRlbShlKX1jYXRjaChlKXtyZXR1cm4gbnVsbH19LHNldDpmdW5jdGlvbihlLHQpe3RyeXtyZXR1cm4gbG9jYWxTdG9yYWdlLnNldEl0ZW0oZSx0KX1jYXRjaChlKXtyZXR1cm4gbnVsbH19fSxlLmV4cG9ydHM9dC5kZWZhdWx0fSxmdW5jdGlvbihlLHQsbil7XCJ1c2Ugc3RyaWN0XCI7ZnVuY3Rpb24gcihlKXt2YXIgdD0obmV3IERhdGUpLmdldFRpbWUoKSxuPShuZXcgRGF0ZSkudG9JU09TdHJpbmcoKSxyPWZ1bmN0aW9uKCl7cmV0dXJuIGNvbnNvbGUmJmNvbnNvbGUubG9nP2NvbnNvbGU6d2luZG93JiZ3aW5kb3cuY29uc29sZSYmd2luZG93LmNvbnNvbGUubG9nP3dpbmRvdy5jb25zb2xlOmNvbnNvbGV9KCk7ci5sb2coXCI8PDw8PFwiKSxyLmxvZyhcIltcIituK1wiXVwiLFwiXFxuXCIsZS51cmwsXCJcXG5cIixlLnFzKSxyLmxvZyhcIi0tLS0tXCIpLGUub24oXCJyZXNwb25zZVwiLGZ1bmN0aW9uKG4pe3ZhciBpPShuZXcgRGF0ZSkuZ2V0VGltZSgpLG89aS10LHM9KG5ldyBEYXRlKS50b0lTT1N0cmluZygpO3IubG9nKFwiPj4+Pj4+XCIpLHIubG9nKFwiW1wiK3MrXCIgLyBcIitvK1wiXVwiLFwiXFxuXCIsZS51cmwsXCJcXG5cIixlLnFzLFwiXFxuXCIsbi50ZXh0KSxyLmxvZyhcIi0tLS0tXCIpfSl9ZnVuY3Rpb24gaShlLHQsbil7dmFyIGk9dGhpcztyZXR1cm4gdGhpcy5fY29uZmlnLmxvZ1ZlcmJvc2l0eSYmKGU9ZS51c2UocikpLHRoaXMuX2NvbmZpZy5wcm94eSYmdGhpcy5fbW9kdWxlcy5wcm94eSYmKGU9dGhpcy5fbW9kdWxlcy5wcm94eS5jYWxsKHRoaXMsZSkpLHRoaXMuX2NvbmZpZy5rZWVwQWxpdmUmJnRoaXMuX21vZHVsZXMua2VlcEFsaXZlJiYoZT10aGlzLl9tb2R1bGUua2VlcEFsaXZlKGUpKSxlLnRpbWVvdXQodC50aW1lb3V0KS5lbmQoZnVuY3Rpb24oZSxyKXt2YXIgbz17fTtpZihvLmVycm9yPW51bGwhPT1lLG8ub3BlcmF0aW9uPXQub3BlcmF0aW9uLHImJnIuc3RhdHVzJiYoby5zdGF0dXNDb2RlPXIuc3RhdHVzKSxlKXJldHVybiBvLmVycm9yRGF0YT1lLG8uY2F0ZWdvcnk9aS5fZGV0ZWN0RXJyb3JDYXRlZ29yeShlKSxuKG8sbnVsbCk7dmFyIHM9SlNPTi5wYXJzZShyLnRleHQpO3JldHVybiBuKG8scyl9KX1mdW5jdGlvbiBvKGUsdCxuKXt2YXIgcj11LmRlZmF1bHQuZ2V0KHRoaXMuZ2V0U3RhbmRhcmRPcmlnaW4oKSt0LnVybCkucXVlcnkoZSk7cmV0dXJuIGkuY2FsbCh0aGlzLHIsdCxuKX1mdW5jdGlvbiBzKGUsdCxuLHIpe3ZhciBvPXUuZGVmYXVsdC5wb3N0KHRoaXMuZ2V0U3RhbmRhcmRPcmlnaW4oKStuLnVybCkucXVlcnkoZSkuc2VuZCh0KTtyZXR1cm4gaS5jYWxsKHRoaXMsbyxuLHIpfU9iamVjdC5kZWZpbmVQcm9wZXJ0eSh0LFwiX19lc01vZHVsZVwiLHt2YWx1ZTohMH0pLHQuZ2V0PW8sdC5wb3N0PXM7dmFyIGE9big0MyksdT1mdW5jdGlvbihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlP2U6e2RlZmF1bHQ6ZX19KGEpO24oOCl9LGZ1bmN0aW9uKGUsdCxuKXtmdW5jdGlvbiByKCl7fWZ1bmN0aW9uIGkoZSl7aWYoIXYoZSkpcmV0dXJuIGU7dmFyIHQ9W107Zm9yKHZhciBuIGluIGUpbyh0LG4sZVtuXSk7cmV0dXJuIHQuam9pbihcIiZcIil9ZnVuY3Rpb24gbyhlLHQsbil7aWYobnVsbCE9bilpZihBcnJheS5pc0FycmF5KG4pKW4uZm9yRWFjaChmdW5jdGlvbihuKXtvKGUsdCxuKX0pO2Vsc2UgaWYodihuKSlmb3IodmFyIHIgaW4gbilvKGUsdCtcIltcIityK1wiXVwiLG5bcl0pO2Vsc2UgZS5wdXNoKGVuY29kZVVSSUNvbXBvbmVudCh0KStcIj1cIitlbmNvZGVVUklDb21wb25lbnQobikpO2Vsc2UgbnVsbD09PW4mJmUucHVzaChlbmNvZGVVUklDb21wb25lbnQodCkpfWZ1bmN0aW9uIHMoZSl7Zm9yKHZhciB0LG4scj17fSxpPWUuc3BsaXQoXCImXCIpLG89MCxzPWkubGVuZ3RoO288czsrK28pdD1pW29dLG49dC5pbmRleE9mKFwiPVwiKSxuPT0tMT9yW2RlY29kZVVSSUNvbXBvbmVudCh0KV09XCJcIjpyW2RlY29kZVVSSUNvbXBvbmVudCh0LnNsaWNlKDAsbikpXT1kZWNvZGVVUklDb21wb25lbnQodC5zbGljZShuKzEpKTtyZXR1cm4gcn1mdW5jdGlvbiBhKGUpe3ZhciB0LG4scixpLG89ZS5zcGxpdCgvXFxyP1xcbi8pLHM9e307by5wb3AoKTtmb3IodmFyIGE9MCx1PW8ubGVuZ3RoO2E8dTsrK2Epbj1vW2FdLHQ9bi5pbmRleE9mKFwiOlwiKSxyPW4uc2xpY2UoMCx0KS50b0xvd2VyQ2FzZSgpLGk9XyhuLnNsaWNlKHQrMSkpLHNbcl09aTtyZXR1cm4gc31mdW5jdGlvbiB1KGUpe3JldHVybi9bXFwvK11qc29uXFxiLy50ZXN0KGUpfWZ1bmN0aW9uIGMoZSl7cmV0dXJuIGUuc3BsaXQoLyAqOyAqLykuc2hpZnQoKX1mdW5jdGlvbiBsKGUpe3JldHVybiBlLnNwbGl0KC8gKjsgKi8pLnJlZHVjZShmdW5jdGlvbihlLHQpe3ZhciBuPXQuc3BsaXQoLyAqPSAqLykscj1uLnNoaWZ0KCksaT1uLnNoaWZ0KCk7cmV0dXJuIHImJmkmJihlW3JdPWkpLGV9LHt9KX1mdW5jdGlvbiBoKGUsdCl7dD10fHx7fSx0aGlzLnJlcT1lLHRoaXMueGhyPXRoaXMucmVxLnhocix0aGlzLnRleHQ9XCJIRUFEXCIhPXRoaXMucmVxLm1ldGhvZCYmKFwiXCI9PT10aGlzLnhoci5yZXNwb25zZVR5cGV8fFwidGV4dFwiPT09dGhpcy54aHIucmVzcG9uc2VUeXBlKXx8dm9pZCAwPT09dGhpcy54aHIucmVzcG9uc2VUeXBlP3RoaXMueGhyLnJlc3BvbnNlVGV4dDpudWxsLHRoaXMuc3RhdHVzVGV4dD10aGlzLnJlcS54aHIuc3RhdHVzVGV4dCx0aGlzLl9zZXRTdGF0dXNQcm9wZXJ0aWVzKHRoaXMueGhyLnN0YXR1cyksdGhpcy5oZWFkZXI9dGhpcy5oZWFkZXJzPWEodGhpcy54aHIuZ2V0QWxsUmVzcG9uc2VIZWFkZXJzKCkpLHRoaXMuaGVhZGVyW1wiY29udGVudC10eXBlXCJdPXRoaXMueGhyLmdldFJlc3BvbnNlSGVhZGVyKFwiY29udGVudC10eXBlXCIpLHRoaXMuX3NldEhlYWRlclByb3BlcnRpZXModGhpcy5oZWFkZXIpLHRoaXMuYm9keT1cIkhFQURcIiE9dGhpcy5yZXEubWV0aG9kP3RoaXMuX3BhcnNlQm9keSh0aGlzLnRleHQ/dGhpcy50ZXh0OnRoaXMueGhyLnJlc3BvbnNlKTpudWxsfWZ1bmN0aW9uIGYoZSx0KXt2YXIgbj10aGlzO3RoaXMuX3F1ZXJ5PXRoaXMuX3F1ZXJ5fHxbXSx0aGlzLm1ldGhvZD1lLHRoaXMudXJsPXQsdGhpcy5oZWFkZXI9e30sdGhpcy5faGVhZGVyPXt9LHRoaXMub24oXCJlbmRcIixmdW5jdGlvbigpe3ZhciBlPW51bGwsdD1udWxsO3RyeXt0PW5ldyBoKG4pfWNhdGNoKHQpe3JldHVybiBlPW5ldyBFcnJvcihcIlBhcnNlciBpcyB1bmFibGUgdG8gcGFyc2UgdGhlIHJlc3BvbnNlXCIpLGUucGFyc2U9ITAsZS5vcmlnaW5hbD10LGUucmF3UmVzcG9uc2U9bi54aHImJm4ueGhyLnJlc3BvbnNlVGV4dD9uLnhoci5yZXNwb25zZVRleHQ6bnVsbCxlLnN0YXR1c0NvZGU9bi54aHImJm4ueGhyLnN0YXR1cz9uLnhoci5zdGF0dXM6bnVsbCxuLmNhbGxiYWNrKGUpfW4uZW1pdChcInJlc3BvbnNlXCIsdCk7dmFyIHI7dHJ5eyh0LnN0YXR1czwyMDB8fHQuc3RhdHVzPj0zMDApJiYocj1uZXcgRXJyb3IodC5zdGF0dXNUZXh0fHxcIlVuc3VjY2Vzc2Z1bCBIVFRQIHJlc3BvbnNlXCIpLHIub3JpZ2luYWw9ZSxyLnJlc3BvbnNlPXQsci5zdGF0dXM9dC5zdGF0dXMpfWNhdGNoKGUpe3I9ZX1yP24uY2FsbGJhY2socix0KTpuLmNhbGxiYWNrKG51bGwsdCl9KX1mdW5jdGlvbiBkKGUsdCl7dmFyIG49YihcIkRFTEVURVwiLGUpO3JldHVybiB0JiZuLmVuZCh0KSxufXZhciBwO1widW5kZWZpbmVkXCIhPXR5cGVvZiB3aW5kb3c/cD13aW5kb3c6XCJ1bmRlZmluZWRcIiE9dHlwZW9mIHNlbGY/cD1zZWxmOihjb25zb2xlLndhcm4oXCJVc2luZyBicm93c2VyLW9ubHkgdmVyc2lvbiBvZiBzdXBlcmFnZW50IGluIG5vbi1icm93c2VyIGVudmlyb25tZW50XCIpLHA9dGhpcyk7dmFyIGc9big0NCkseT1uKDQ1KSx2PW4oNDYpLGI9ZS5leHBvcnRzPW4oNDcpLmJpbmQobnVsbCxmKTtiLmdldFhIUj1mdW5jdGlvbigpe2lmKCEoIXAuWE1MSHR0cFJlcXVlc3R8fHAubG9jYXRpb24mJlwiZmlsZTpcIj09cC5sb2NhdGlvbi5wcm90b2NvbCYmcC5BY3RpdmVYT2JqZWN0KSlyZXR1cm4gbmV3IFhNTEh0dHBSZXF1ZXN0O3RyeXtyZXR1cm4gbmV3IEFjdGl2ZVhPYmplY3QoXCJNaWNyb3NvZnQuWE1MSFRUUFwiKX1jYXRjaChlKXt9dHJ5e3JldHVybiBuZXcgQWN0aXZlWE9iamVjdChcIk1zeG1sMi5YTUxIVFRQLjYuMFwiKX1jYXRjaChlKXt9dHJ5e3JldHVybiBuZXcgQWN0aXZlWE9iamVjdChcIk1zeG1sMi5YTUxIVFRQLjMuMFwiKX1jYXRjaChlKXt9dHJ5e3JldHVybiBuZXcgQWN0aXZlWE9iamVjdChcIk1zeG1sMi5YTUxIVFRQXCIpfWNhdGNoKGUpe310aHJvdyBFcnJvcihcIkJyb3dzZXItb25seSB2ZXJpc29uIG9mIHN1cGVyYWdlbnQgY291bGQgbm90IGZpbmQgWEhSXCIpfTt2YXIgXz1cIlwiLnRyaW0/ZnVuY3Rpb24oZSl7cmV0dXJuIGUudHJpbSgpfTpmdW5jdGlvbihlKXtyZXR1cm4gZS5yZXBsYWNlKC8oXlxccyp8XFxzKiQpL2csXCJcIil9O2Iuc2VyaWFsaXplT2JqZWN0PWksYi5wYXJzZVN0cmluZz1zLGIudHlwZXM9e2h0bWw6XCJ0ZXh0L2h0bWxcIixqc29uOlwiYXBwbGljYXRpb24vanNvblwiLHhtbDpcImFwcGxpY2F0aW9uL3htbFwiLHVybGVuY29kZWQ6XCJhcHBsaWNhdGlvbi94LXd3dy1mb3JtLXVybGVuY29kZWRcIixmb3JtOlwiYXBwbGljYXRpb24veC13d3ctZm9ybS11cmxlbmNvZGVkXCIsXCJmb3JtLWRhdGFcIjpcImFwcGxpY2F0aW9uL3gtd3d3LWZvcm0tdXJsZW5jb2RlZFwifSxiLnNlcmlhbGl6ZT17XCJhcHBsaWNhdGlvbi94LXd3dy1mb3JtLXVybGVuY29kZWRcIjppLFwiYXBwbGljYXRpb24vanNvblwiOkpTT04uc3RyaW5naWZ5fSxiLnBhcnNlPXtcImFwcGxpY2F0aW9uL3gtd3d3LWZvcm0tdXJsZW5jb2RlZFwiOnMsXCJhcHBsaWNhdGlvbi9qc29uXCI6SlNPTi5wYXJzZX0saC5wcm90b3R5cGUuZ2V0PWZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLmhlYWRlcltlLnRvTG93ZXJDYXNlKCldfSxoLnByb3RvdHlwZS5fc2V0SGVhZGVyUHJvcGVydGllcz1mdW5jdGlvbihlKXt2YXIgdD10aGlzLmhlYWRlcltcImNvbnRlbnQtdHlwZVwiXXx8XCJcIjt0aGlzLnR5cGU9Yyh0KTt2YXIgbj1sKHQpO2Zvcih2YXIgciBpbiBuKXRoaXNbcl09bltyXX0saC5wcm90b3R5cGUuX3BhcnNlQm9keT1mdW5jdGlvbihlKXt2YXIgdD1iLnBhcnNlW3RoaXMudHlwZV07cmV0dXJuIXQmJnUodGhpcy50eXBlKSYmKHQ9Yi5wYXJzZVtcImFwcGxpY2F0aW9uL2pzb25cIl0pLHQmJmUmJihlLmxlbmd0aHx8ZSBpbnN0YW5jZW9mIE9iamVjdCk/dChlKTpudWxsfSxoLnByb3RvdHlwZS5fc2V0U3RhdHVzUHJvcGVydGllcz1mdW5jdGlvbihlKXsxMjIzPT09ZSYmKGU9MjA0KTt2YXIgdD1lLzEwMHwwO3RoaXMuc3RhdHVzPXRoaXMuc3RhdHVzQ29kZT1lLHRoaXMuc3RhdHVzVHlwZT10LHRoaXMuaW5mbz0xPT10LHRoaXMub2s9Mj09dCx0aGlzLmNsaWVudEVycm9yPTQ9PXQsdGhpcy5zZXJ2ZXJFcnJvcj01PT10LHRoaXMuZXJyb3I9KDQ9PXR8fDU9PXQpJiZ0aGlzLnRvRXJyb3IoKSx0aGlzLmFjY2VwdGVkPTIwMj09ZSx0aGlzLm5vQ29udGVudD0yMDQ9PWUsdGhpcy5iYWRSZXF1ZXN0PTQwMD09ZSx0aGlzLnVuYXV0aG9yaXplZD00MDE9PWUsdGhpcy5ub3RBY2NlcHRhYmxlPTQwNj09ZSx0aGlzLm5vdEZvdW5kPTQwND09ZSx0aGlzLmZvcmJpZGRlbj00MDM9PWV9LGgucHJvdG90eXBlLnRvRXJyb3I9ZnVuY3Rpb24oKXt2YXIgZT10aGlzLnJlcSx0PWUubWV0aG9kLG49ZS51cmwscj1cImNhbm5vdCBcIit0K1wiIFwiK24rXCIgKFwiK3RoaXMuc3RhdHVzK1wiKVwiLGk9bmV3IEVycm9yKHIpO3JldHVybiBpLnN0YXR1cz10aGlzLnN0YXR1cyxpLm1ldGhvZD10LGkudXJsPW4saX0sYi5SZXNwb25zZT1oLGcoZi5wcm90b3R5cGUpO2Zvcih2YXIgbSBpbiB5KWYucHJvdG90eXBlW21dPXlbbV07Zi5wcm90b3R5cGUudHlwZT1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5zZXQoXCJDb250ZW50LVR5cGVcIixiLnR5cGVzW2VdfHxlKSx0aGlzfSxmLnByb3RvdHlwZS5yZXNwb25zZVR5cGU9ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX3Jlc3BvbnNlVHlwZT1lLHRoaXN9LGYucHJvdG90eXBlLmFjY2VwdD1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5zZXQoXCJBY2NlcHRcIixiLnR5cGVzW2VdfHxlKSx0aGlzfSxmLnByb3RvdHlwZS5hdXRoPWZ1bmN0aW9uKGUsdCxuKXtzd2l0Y2gobnx8KG49e3R5cGU6XCJiYXNpY1wifSksbi50eXBlKXtjYXNlXCJiYXNpY1wiOnZhciByPWJ0b2EoZStcIjpcIit0KTt0aGlzLnNldChcIkF1dGhvcml6YXRpb25cIixcIkJhc2ljIFwiK3IpO2JyZWFrO2Nhc2VcImF1dG9cIjp0aGlzLnVzZXJuYW1lPWUsdGhpcy5wYXNzd29yZD10fXJldHVybiB0aGlzfSxmLnByb3RvdHlwZS5xdWVyeT1mdW5jdGlvbihlKXtyZXR1cm5cInN0cmluZ1wiIT10eXBlb2YgZSYmKGU9aShlKSksZSYmdGhpcy5fcXVlcnkucHVzaChlKSx0aGlzfSxmLnByb3RvdHlwZS5hdHRhY2g9ZnVuY3Rpb24oZSx0LG4pe3JldHVybiB0aGlzLl9nZXRGb3JtRGF0YSgpLmFwcGVuZChlLHQsbnx8dC5uYW1lKSx0aGlzfSxmLnByb3RvdHlwZS5fZ2V0Rm9ybURhdGE9ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5fZm9ybURhdGF8fCh0aGlzLl9mb3JtRGF0YT1uZXcgcC5Gb3JtRGF0YSksdGhpcy5fZm9ybURhdGF9LGYucHJvdG90eXBlLmNhbGxiYWNrPWZ1bmN0aW9uKGUsdCl7dmFyIG49dGhpcy5fY2FsbGJhY2s7dGhpcy5jbGVhclRpbWVvdXQoKSxuKGUsdCl9LGYucHJvdG90eXBlLmNyb3NzRG9tYWluRXJyb3I9ZnVuY3Rpb24oKXt2YXIgZT1uZXcgRXJyb3IoXCJSZXF1ZXN0IGhhcyBiZWVuIHRlcm1pbmF0ZWRcXG5Qb3NzaWJsZSBjYXVzZXM6IHRoZSBuZXR3b3JrIGlzIG9mZmxpbmUsIE9yaWdpbiBpcyBub3QgYWxsb3dlZCBieSBBY2Nlc3MtQ29udHJvbC1BbGxvdy1PcmlnaW4sIHRoZSBwYWdlIGlzIGJlaW5nIHVubG9hZGVkLCBldGMuXCIpO2UuY3Jvc3NEb21haW49ITAsZS5zdGF0dXM9dGhpcy5zdGF0dXMsZS5tZXRob2Q9dGhpcy5tZXRob2QsZS51cmw9dGhpcy51cmwsdGhpcy5jYWxsYmFjayhlKX0sZi5wcm90b3R5cGUuX3RpbWVvdXRFcnJvcj1mdW5jdGlvbigpe3ZhciBlPXRoaXMuX3RpbWVvdXQsdD1uZXcgRXJyb3IoXCJ0aW1lb3V0IG9mIFwiK2UrXCJtcyBleGNlZWRlZFwiKTt0LnRpbWVvdXQ9ZSx0aGlzLmNhbGxiYWNrKHQpfSxmLnByb3RvdHlwZS5fYXBwZW5kUXVlcnlTdHJpbmc9ZnVuY3Rpb24oKXt2YXIgZT10aGlzLl9xdWVyeS5qb2luKFwiJlwiKTtlJiYodGhpcy51cmwrPX50aGlzLnVybC5pbmRleE9mKFwiP1wiKT9cIiZcIitlOlwiP1wiK2UpfSxmLnByb3RvdHlwZS5lbmQ9ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcyxuPXRoaXMueGhyPWIuZ2V0WEhSKCksaT10aGlzLl90aW1lb3V0LG89dGhpcy5fZm9ybURhdGF8fHRoaXMuX2RhdGE7dGhpcy5fY2FsbGJhY2s9ZXx8cixuLm9ucmVhZHlzdGF0ZWNoYW5nZT1mdW5jdGlvbigpe2lmKDQ9PW4ucmVhZHlTdGF0ZSl7dmFyIGU7dHJ5e2U9bi5zdGF0dXN9Y2F0Y2godCl7ZT0wfWlmKDA9PWUpe2lmKHQudGltZWRvdXQpcmV0dXJuIHQuX3RpbWVvdXRFcnJvcigpO2lmKHQuX2Fib3J0ZWQpcmV0dXJuO3JldHVybiB0LmNyb3NzRG9tYWluRXJyb3IoKX10LmVtaXQoXCJlbmRcIil9fTt2YXIgcz1mdW5jdGlvbihlLG4pe24udG90YWw+MCYmKG4ucGVyY2VudD1uLmxvYWRlZC9uLnRvdGFsKjEwMCksbi5kaXJlY3Rpb249ZSx0LmVtaXQoXCJwcm9ncmVzc1wiLG4pfTtpZih0aGlzLmhhc0xpc3RlbmVycyhcInByb2dyZXNzXCIpKXRyeXtuLm9ucHJvZ3Jlc3M9cy5iaW5kKG51bGwsXCJkb3dubG9hZFwiKSxuLnVwbG9hZCYmKG4udXBsb2FkLm9ucHJvZ3Jlc3M9cy5iaW5kKG51bGwsXCJ1cGxvYWRcIikpfWNhdGNoKGUpe31pZihpJiYhdGhpcy5fdGltZXImJih0aGlzLl90aW1lcj1zZXRUaW1lb3V0KGZ1bmN0aW9uKCl7dC50aW1lZG91dD0hMCx0LmFib3J0KCl9LGkpKSx0aGlzLl9hcHBlbmRRdWVyeVN0cmluZygpLHRoaXMudXNlcm5hbWUmJnRoaXMucGFzc3dvcmQ/bi5vcGVuKHRoaXMubWV0aG9kLHRoaXMudXJsLCEwLHRoaXMudXNlcm5hbWUsdGhpcy5wYXNzd29yZCk6bi5vcGVuKHRoaXMubWV0aG9kLHRoaXMudXJsLCEwKSx0aGlzLl93aXRoQ3JlZGVudGlhbHMmJihuLndpdGhDcmVkZW50aWFscz0hMCksXCJHRVRcIiE9dGhpcy5tZXRob2QmJlwiSEVBRFwiIT10aGlzLm1ldGhvZCYmXCJzdHJpbmdcIiE9dHlwZW9mIG8mJiF0aGlzLl9pc0hvc3Qobykpe3ZhciBhPXRoaXMuX2hlYWRlcltcImNvbnRlbnQtdHlwZVwiXSxjPXRoaXMuX3NlcmlhbGl6ZXJ8fGIuc2VyaWFsaXplW2E/YS5zcGxpdChcIjtcIilbMF06XCJcIl07IWMmJnUoYSkmJihjPWIuc2VyaWFsaXplW1wiYXBwbGljYXRpb24vanNvblwiXSksYyYmKG89YyhvKSl9Zm9yKHZhciBsIGluIHRoaXMuaGVhZGVyKW51bGwhPXRoaXMuaGVhZGVyW2xdJiZuLnNldFJlcXVlc3RIZWFkZXIobCx0aGlzLmhlYWRlcltsXSk7cmV0dXJuIHRoaXMuX3Jlc3BvbnNlVHlwZSYmKG4ucmVzcG9uc2VUeXBlPXRoaXMuX3Jlc3BvbnNlVHlwZSksdGhpcy5lbWl0KFwicmVxdWVzdFwiLHRoaXMpLG4uc2VuZCh2b2lkIDAhPT1vP286bnVsbCksdGhpc30sYi5SZXF1ZXN0PWYsYi5nZXQ9ZnVuY3Rpb24oZSx0LG4pe3ZhciByPWIoXCJHRVRcIixlKTtyZXR1cm5cImZ1bmN0aW9uXCI9PXR5cGVvZiB0JiYobj10LHQ9bnVsbCksdCYmci5xdWVyeSh0KSxuJiZyLmVuZChuKSxyfSxiLmhlYWQ9ZnVuY3Rpb24oZSx0LG4pe3ZhciByPWIoXCJIRUFEXCIsZSk7cmV0dXJuXCJmdW5jdGlvblwiPT10eXBlb2YgdCYmKG49dCx0PW51bGwpLHQmJnIuc2VuZCh0KSxuJiZyLmVuZChuKSxyfSxiLm9wdGlvbnM9ZnVuY3Rpb24oZSx0LG4pe3ZhciByPWIoXCJPUFRJT05TXCIsZSk7cmV0dXJuXCJmdW5jdGlvblwiPT10eXBlb2YgdCYmKG49dCx0PW51bGwpLHQmJnIuc2VuZCh0KSxuJiZyLmVuZChuKSxyfSxiLmRlbD1kLGIuZGVsZXRlPWQsYi5wYXRjaD1mdW5jdGlvbihlLHQsbil7dmFyIHI9YihcIlBBVENIXCIsZSk7cmV0dXJuXCJmdW5jdGlvblwiPT10eXBlb2YgdCYmKG49dCx0PW51bGwpLHQmJnIuc2VuZCh0KSxuJiZyLmVuZChuKSxyfSxiLnBvc3Q9ZnVuY3Rpb24oZSx0LG4pe3ZhciByPWIoXCJQT1NUXCIsZSk7cmV0dXJuXCJmdW5jdGlvblwiPT10eXBlb2YgdCYmKG49dCx0PW51bGwpLHQmJnIuc2VuZCh0KSxuJiZyLmVuZChuKSxyfSxiLnB1dD1mdW5jdGlvbihlLHQsbil7dmFyIHI9YihcIlBVVFwiLGUpO3JldHVyblwiZnVuY3Rpb25cIj09dHlwZW9mIHQmJihuPXQsdD1udWxsKSx0JiZyLnNlbmQodCksbiYmci5lbmQobikscn19LGZ1bmN0aW9uKGUsdCxuKXtmdW5jdGlvbiByKGUpe2lmKGUpcmV0dXJuIGkoZSl9ZnVuY3Rpb24gaShlKXtmb3IodmFyIHQgaW4gci5wcm90b3R5cGUpZVt0XT1yLnByb3RvdHlwZVt0XTtyZXR1cm4gZX1lLmV4cG9ydHM9cixyLnByb3RvdHlwZS5vbj1yLnByb3RvdHlwZS5hZGRFdmVudExpc3RlbmVyPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIHRoaXMuX2NhbGxiYWNrcz10aGlzLl9jYWxsYmFja3N8fHt9LCh0aGlzLl9jYWxsYmFja3NbXCIkXCIrZV09dGhpcy5fY2FsbGJhY2tzW1wiJFwiK2VdfHxbXSkucHVzaCh0KSx0aGlzfSxyLnByb3RvdHlwZS5vbmNlPWZ1bmN0aW9uKGUsdCl7ZnVuY3Rpb24gbigpe3RoaXMub2ZmKGUsbiksdC5hcHBseSh0aGlzLGFyZ3VtZW50cyl9cmV0dXJuIG4uZm49dCx0aGlzLm9uKGUsbiksdGhpc30sci5wcm90b3R5cGUub2ZmPXIucHJvdG90eXBlLnJlbW92ZUxpc3RlbmVyPXIucHJvdG90eXBlLnJlbW92ZUFsbExpc3RlbmVycz1yLnByb3RvdHlwZS5yZW1vdmVFdmVudExpc3RlbmVyPWZ1bmN0aW9uKGUsdCl7aWYodGhpcy5fY2FsbGJhY2tzPXRoaXMuX2NhbGxiYWNrc3x8e30sMD09YXJndW1lbnRzLmxlbmd0aClyZXR1cm4gdGhpcy5fY2FsbGJhY2tzPXt9LHRoaXM7dmFyIG49dGhpcy5fY2FsbGJhY2tzW1wiJFwiK2VdO2lmKCFuKXJldHVybiB0aGlzO2lmKDE9PWFyZ3VtZW50cy5sZW5ndGgpcmV0dXJuIGRlbGV0ZSB0aGlzLl9jYWxsYmFja3NbXCIkXCIrZV0sdGhpcztmb3IodmFyIHIsaT0wO2k8bi5sZW5ndGg7aSsrKWlmKChyPW5baV0pPT09dHx8ci5mbj09PXQpe24uc3BsaWNlKGksMSk7YnJlYWt9cmV0dXJuIHRoaXN9LHIucHJvdG90eXBlLmVtaXQ9ZnVuY3Rpb24oZSl7dGhpcy5fY2FsbGJhY2tzPXRoaXMuX2NhbGxiYWNrc3x8e307dmFyIHQ9W10uc2xpY2UuY2FsbChhcmd1bWVudHMsMSksbj10aGlzLl9jYWxsYmFja3NbXCIkXCIrZV07aWYobil7bj1uLnNsaWNlKDApO2Zvcih2YXIgcj0wLGk9bi5sZW5ndGg7cjxpOysrciluW3JdLmFwcGx5KHRoaXMsdCl9cmV0dXJuIHRoaXN9LHIucHJvdG90eXBlLmxpc3RlbmVycz1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fY2FsbGJhY2tzPXRoaXMuX2NhbGxiYWNrc3x8e30sdGhpcy5fY2FsbGJhY2tzW1wiJFwiK2VdfHxbXX0sci5wcm90b3R5cGUuaGFzTGlzdGVuZXJzPWZ1bmN0aW9uKGUpe3JldHVybiEhdGhpcy5saXN0ZW5lcnMoZSkubGVuZ3RofX0sZnVuY3Rpb24oZSx0LG4pe3ZhciByPW4oNDYpO3QuY2xlYXJUaW1lb3V0PWZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuX3RpbWVvdXQ9MCxjbGVhclRpbWVvdXQodGhpcy5fdGltZXIpLHRoaXN9LHQucGFyc2U9ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX3BhcnNlcj1lLHRoaXN9LHQuc2VyaWFsaXplPWZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLl9zZXJpYWxpemVyPWUsdGhpc30sdC50aW1lb3V0PWZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLl90aW1lb3V0PWUsdGhpc30sdC50aGVuPWZ1bmN0aW9uKGUsdCl7aWYoIXRoaXMuX2Z1bGxmaWxsZWRQcm9taXNlKXt2YXIgbj10aGlzO3RoaXMuX2Z1bGxmaWxsZWRQcm9taXNlPW5ldyBQcm9taXNlKGZ1bmN0aW9uKGUsdCl7bi5lbmQoZnVuY3Rpb24obixyKXtuP3Qobik6ZShyKX0pfSl9cmV0dXJuIHRoaXMuX2Z1bGxmaWxsZWRQcm9taXNlLnRoZW4oZSx0KX0sdC5jYXRjaD1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy50aGVuKHZvaWQgMCxlKX0sdC51c2U9ZnVuY3Rpb24oZSl7cmV0dXJuIGUodGhpcyksdGhpc30sdC5nZXQ9ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX2hlYWRlcltlLnRvTG93ZXJDYXNlKCldfSx0LmdldEhlYWRlcj10LmdldCx0LnNldD1mdW5jdGlvbihlLHQpe2lmKHIoZSkpe2Zvcih2YXIgbiBpbiBlKXRoaXMuc2V0KG4sZVtuXSk7cmV0dXJuIHRoaXN9cmV0dXJuIHRoaXMuX2hlYWRlcltlLnRvTG93ZXJDYXNlKCldPXQsdGhpcy5oZWFkZXJbZV09dCx0aGlzfSx0LnVuc2V0PWZ1bmN0aW9uKGUpe3JldHVybiBkZWxldGUgdGhpcy5faGVhZGVyW2UudG9Mb3dlckNhc2UoKV0sZGVsZXRlIHRoaXMuaGVhZGVyW2VdLHRoaXN9LHQuZmllbGQ9ZnVuY3Rpb24oZSx0KXtpZihudWxsPT09ZXx8dm9pZCAwPT09ZSl0aHJvdyBuZXcgRXJyb3IoXCIuZmllbGQobmFtZSwgdmFsKSBuYW1lIGNhbiBub3QgYmUgZW1wdHlcIik7aWYocihlKSl7Zm9yKHZhciBuIGluIGUpdGhpcy5maWVsZChuLGVbbl0pO3JldHVybiB0aGlzfWlmKG51bGw9PT10fHx2b2lkIDA9PT10KXRocm93IG5ldyBFcnJvcihcIi5maWVsZChuYW1lLCB2YWwpIHZhbCBjYW4gbm90IGJlIGVtcHR5XCIpO3JldHVybiB0aGlzLl9nZXRGb3JtRGF0YSgpLmFwcGVuZChlLHQpLHRoaXN9LHQuYWJvcnQ9ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5fYWJvcnRlZD90aGlzOih0aGlzLl9hYm9ydGVkPSEwLHRoaXMueGhyJiZ0aGlzLnhoci5hYm9ydCgpLHRoaXMucmVxJiZ0aGlzLnJlcS5hYm9ydCgpLHRoaXMuY2xlYXJUaW1lb3V0KCksdGhpcy5lbWl0KFwiYWJvcnRcIiksdGhpcyl9LHQud2l0aENyZWRlbnRpYWxzPWZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuX3dpdGhDcmVkZW50aWFscz0hMCx0aGlzfSx0LnJlZGlyZWN0cz1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fbWF4UmVkaXJlY3RzPWUsdGhpc30sdC50b0pTT049ZnVuY3Rpb24oKXtyZXR1cm57bWV0aG9kOnRoaXMubWV0aG9kLHVybDp0aGlzLnVybCxkYXRhOnRoaXMuX2RhdGEsaGVhZGVyczp0aGlzLl9oZWFkZXJ9fSx0Ll9pc0hvc3Q9ZnVuY3Rpb24oZSl7c3dpdGNoKHt9LnRvU3RyaW5nLmNhbGwoZSkpe2Nhc2VcIltvYmplY3QgRmlsZV1cIjpjYXNlXCJbb2JqZWN0IEJsb2JdXCI6Y2FzZVwiW29iamVjdCBGb3JtRGF0YV1cIjpyZXR1cm4hMDtkZWZhdWx0OnJldHVybiExfX0sdC5zZW5kPWZ1bmN0aW9uKGUpe3ZhciB0PXIoZSksbj10aGlzLl9oZWFkZXJbXCJjb250ZW50LXR5cGVcIl07aWYodCYmcih0aGlzLl9kYXRhKSlmb3IodmFyIGkgaW4gZSl0aGlzLl9kYXRhW2ldPWVbaV07ZWxzZVwic3RyaW5nXCI9PXR5cGVvZiBlPyhufHx0aGlzLnR5cGUoXCJmb3JtXCIpLG49dGhpcy5faGVhZGVyW1wiY29udGVudC10eXBlXCJdLHRoaXMuX2RhdGE9XCJhcHBsaWNhdGlvbi94LXd3dy1mb3JtLXVybGVuY29kZWRcIj09bj90aGlzLl9kYXRhP3RoaXMuX2RhdGErXCImXCIrZTplOih0aGlzLl9kYXRhfHxcIlwiKStlKTp0aGlzLl9kYXRhPWU7cmV0dXJuIXR8fHRoaXMuX2lzSG9zdChlKT90aGlzOihufHx0aGlzLnR5cGUoXCJqc29uXCIpLHRoaXMpfX0sZnVuY3Rpb24oZSx0KXtmdW5jdGlvbiBuKGUpe3JldHVybiBudWxsIT09ZSYmXCJvYmplY3RcIj09dHlwZW9mIGV9ZS5leHBvcnRzPW59LGZ1bmN0aW9uKGUsdCl7ZnVuY3Rpb24gbihlLHQsbil7cmV0dXJuXCJmdW5jdGlvblwiPT10eXBlb2Ygbj9uZXcgZShcIkdFVFwiLHQpLmVuZChuKToyPT1hcmd1bWVudHMubGVuZ3RoP25ldyBlKFwiR0VUXCIsdCk6bmV3IGUodCxuKX1lLmV4cG9ydHM9bn1dKX0pOyIsIlxuLyoqXG4gKiBNb2R1bGUgZGVwZW5kZW5jaWVzLlxuICovXG5cbnZhciB1cmwgPSByZXF1aXJlKCcuL3VybCcpO1xudmFyIHBhcnNlciA9IHJlcXVpcmUoJ3NvY2tldC5pby1wYXJzZXInKTtcbnZhciBNYW5hZ2VyID0gcmVxdWlyZSgnLi9tYW5hZ2VyJyk7XG52YXIgZGVidWcgPSByZXF1aXJlKCdkZWJ1ZycpKCdzb2NrZXQuaW8tY2xpZW50Jyk7XG5cbi8qKlxuICogTW9kdWxlIGV4cG9ydHMuXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSBleHBvcnRzID0gbG9va3VwO1xuXG4vKipcbiAqIE1hbmFnZXJzIGNhY2hlLlxuICovXG5cbnZhciBjYWNoZSA9IGV4cG9ydHMubWFuYWdlcnMgPSB7fTtcblxuLyoqXG4gKiBMb29rcyB1cCBhbiBleGlzdGluZyBgTWFuYWdlcmAgZm9yIG11bHRpcGxleGluZy5cbiAqIElmIHRoZSB1c2VyIHN1bW1vbnM6XG4gKlxuICogICBgaW8oJ2h0dHA6Ly9sb2NhbGhvc3QvYScpO2BcbiAqICAgYGlvKCdodHRwOi8vbG9jYWxob3N0L2InKTtgXG4gKlxuICogV2UgcmV1c2UgdGhlIGV4aXN0aW5nIGluc3RhbmNlIGJhc2VkIG9uIHNhbWUgc2NoZW1lL3BvcnQvaG9zdCxcbiAqIGFuZCB3ZSBpbml0aWFsaXplIHNvY2tldHMgZm9yIGVhY2ggbmFtZXNwYWNlLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gbG9va3VwICh1cmksIG9wdHMpIHtcbiAgaWYgKHR5cGVvZiB1cmkgPT09ICdvYmplY3QnKSB7XG4gICAgb3B0cyA9IHVyaTtcbiAgICB1cmkgPSB1bmRlZmluZWQ7XG4gIH1cblxuICBvcHRzID0gb3B0cyB8fCB7fTtcblxuICB2YXIgcGFyc2VkID0gdXJsKHVyaSk7XG4gIHZhciBzb3VyY2UgPSBwYXJzZWQuc291cmNlO1xuICB2YXIgaWQgPSBwYXJzZWQuaWQ7XG4gIHZhciBwYXRoID0gcGFyc2VkLnBhdGg7XG4gIHZhciBzYW1lTmFtZXNwYWNlID0gY2FjaGVbaWRdICYmIHBhdGggaW4gY2FjaGVbaWRdLm5zcHM7XG4gIHZhciBuZXdDb25uZWN0aW9uID0gb3B0cy5mb3JjZU5ldyB8fCBvcHRzWydmb3JjZSBuZXcgY29ubmVjdGlvbiddIHx8XG4gICAgICAgICAgICAgICAgICAgICAgZmFsc2UgPT09IG9wdHMubXVsdGlwbGV4IHx8IHNhbWVOYW1lc3BhY2U7XG5cbiAgdmFyIGlvO1xuXG4gIGlmIChuZXdDb25uZWN0aW9uKSB7XG4gICAgZGVidWcoJ2lnbm9yaW5nIHNvY2tldCBjYWNoZSBmb3IgJXMnLCBzb3VyY2UpO1xuICAgIGlvID0gTWFuYWdlcihzb3VyY2UsIG9wdHMpO1xuICB9IGVsc2Uge1xuICAgIGlmICghY2FjaGVbaWRdKSB7XG4gICAgICBkZWJ1ZygnbmV3IGlvIGluc3RhbmNlIGZvciAlcycsIHNvdXJjZSk7XG4gICAgICBjYWNoZVtpZF0gPSBNYW5hZ2VyKHNvdXJjZSwgb3B0cyk7XG4gICAgfVxuICAgIGlvID0gY2FjaGVbaWRdO1xuICB9XG4gIGlmIChwYXJzZWQucXVlcnkgJiYgIW9wdHMucXVlcnkpIHtcbiAgICBvcHRzLnF1ZXJ5ID0gcGFyc2VkLnF1ZXJ5O1xuICB9IGVsc2UgaWYgKG9wdHMgJiYgJ29iamVjdCcgPT09IHR5cGVvZiBvcHRzLnF1ZXJ5KSB7XG4gICAgb3B0cy5xdWVyeSA9IGVuY29kZVF1ZXJ5U3RyaW5nKG9wdHMucXVlcnkpO1xuICB9XG4gIHJldHVybiBpby5zb2NrZXQocGFyc2VkLnBhdGgsIG9wdHMpO1xufVxuLyoqXG4gKiAgSGVscGVyIG1ldGhvZCB0byBwYXJzZSBxdWVyeSBvYmplY3RzIHRvIHN0cmluZy5cbiAqIEBwYXJhbSB7b2JqZWN0fSBxdWVyeVxuICogQHJldHVybnMge3N0cmluZ31cbiAqL1xuZnVuY3Rpb24gZW5jb2RlUXVlcnlTdHJpbmcgKG9iaikge1xuICB2YXIgc3RyID0gW107XG4gIGZvciAodmFyIHAgaW4gb2JqKSB7XG4gICAgaWYgKG9iai5oYXNPd25Qcm9wZXJ0eShwKSkge1xuICAgICAgc3RyLnB1c2goZW5jb2RlVVJJQ29tcG9uZW50KHApICsgJz0nICsgZW5jb2RlVVJJQ29tcG9uZW50KG9ialtwXSkpO1xuICAgIH1cbiAgfVxuICByZXR1cm4gc3RyLmpvaW4oJyYnKTtcbn1cbi8qKlxuICogUHJvdG9jb2wgdmVyc2lvbi5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmV4cG9ydHMucHJvdG9jb2wgPSBwYXJzZXIucHJvdG9jb2w7XG5cbi8qKlxuICogYGNvbm5lY3RgLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSB1cmlcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5jb25uZWN0ID0gbG9va3VwO1xuXG4vKipcbiAqIEV4cG9zZSBjb25zdHJ1Y3RvcnMgZm9yIHN0YW5kYWxvbmUgYnVpbGQuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5leHBvcnRzLk1hbmFnZXIgPSByZXF1aXJlKCcuL21hbmFnZXInKTtcbmV4cG9ydHMuU29ja2V0ID0gcmVxdWlyZSgnLi9zb2NrZXQnKTtcbiIsIlxuLyoqXG4gKiBNb2R1bGUgZGVwZW5kZW5jaWVzLlxuICovXG5cbnZhciBlaW8gPSByZXF1aXJlKCdlbmdpbmUuaW8tY2xpZW50Jyk7XG52YXIgU29ja2V0ID0gcmVxdWlyZSgnLi9zb2NrZXQnKTtcbnZhciBFbWl0dGVyID0gcmVxdWlyZSgnY29tcG9uZW50LWVtaXR0ZXInKTtcbnZhciBwYXJzZXIgPSByZXF1aXJlKCdzb2NrZXQuaW8tcGFyc2VyJyk7XG52YXIgb24gPSByZXF1aXJlKCcuL29uJyk7XG52YXIgYmluZCA9IHJlcXVpcmUoJ2NvbXBvbmVudC1iaW5kJyk7XG52YXIgZGVidWcgPSByZXF1aXJlKCdkZWJ1ZycpKCdzb2NrZXQuaW8tY2xpZW50Om1hbmFnZXInKTtcbnZhciBpbmRleE9mID0gcmVxdWlyZSgnaW5kZXhvZicpO1xudmFyIEJhY2tvZmYgPSByZXF1aXJlKCdiYWNrbzInKTtcblxuLyoqXG4gKiBJRTYrIGhhc093blByb3BlcnR5XG4gKi9cblxudmFyIGhhcyA9IE9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHk7XG5cbi8qKlxuICogTW9kdWxlIGV4cG9ydHNcbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IE1hbmFnZXI7XG5cbi8qKlxuICogYE1hbmFnZXJgIGNvbnN0cnVjdG9yLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBlbmdpbmUgaW5zdGFuY2Ugb3IgZW5naW5lIHVyaS9vcHRzXG4gKiBAcGFyYW0ge09iamVjdH0gb3B0aW9uc1xuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBNYW5hZ2VyICh1cmksIG9wdHMpIHtcbiAgaWYgKCEodGhpcyBpbnN0YW5jZW9mIE1hbmFnZXIpKSByZXR1cm4gbmV3IE1hbmFnZXIodXJpLCBvcHRzKTtcbiAgaWYgKHVyaSAmJiAoJ29iamVjdCcgPT09IHR5cGVvZiB1cmkpKSB7XG4gICAgb3B0cyA9IHVyaTtcbiAgICB1cmkgPSB1bmRlZmluZWQ7XG4gIH1cbiAgb3B0cyA9IG9wdHMgfHwge307XG5cbiAgb3B0cy5wYXRoID0gb3B0cy5wYXRoIHx8ICcvc29ja2V0LmlvJztcbiAgdGhpcy5uc3BzID0ge307XG4gIHRoaXMuc3VicyA9IFtdO1xuICB0aGlzLm9wdHMgPSBvcHRzO1xuICB0aGlzLnJlY29ubmVjdGlvbihvcHRzLnJlY29ubmVjdGlvbiAhPT0gZmFsc2UpO1xuICB0aGlzLnJlY29ubmVjdGlvbkF0dGVtcHRzKG9wdHMucmVjb25uZWN0aW9uQXR0ZW1wdHMgfHwgSW5maW5pdHkpO1xuICB0aGlzLnJlY29ubmVjdGlvbkRlbGF5KG9wdHMucmVjb25uZWN0aW9uRGVsYXkgfHwgMTAwMCk7XG4gIHRoaXMucmVjb25uZWN0aW9uRGVsYXlNYXgob3B0cy5yZWNvbm5lY3Rpb25EZWxheU1heCB8fCA1MDAwKTtcbiAgdGhpcy5yYW5kb21pemF0aW9uRmFjdG9yKG9wdHMucmFuZG9taXphdGlvbkZhY3RvciB8fCAwLjUpO1xuICB0aGlzLmJhY2tvZmYgPSBuZXcgQmFja29mZih7XG4gICAgbWluOiB0aGlzLnJlY29ubmVjdGlvbkRlbGF5KCksXG4gICAgbWF4OiB0aGlzLnJlY29ubmVjdGlvbkRlbGF5TWF4KCksXG4gICAgaml0dGVyOiB0aGlzLnJhbmRvbWl6YXRpb25GYWN0b3IoKVxuICB9KTtcbiAgdGhpcy50aW1lb3V0KG51bGwgPT0gb3B0cy50aW1lb3V0ID8gMjAwMDAgOiBvcHRzLnRpbWVvdXQpO1xuICB0aGlzLnJlYWR5U3RhdGUgPSAnY2xvc2VkJztcbiAgdGhpcy51cmkgPSB1cmk7XG4gIHRoaXMuY29ubmVjdGluZyA9IFtdO1xuICB0aGlzLmxhc3RQaW5nID0gbnVsbDtcbiAgdGhpcy5lbmNvZGluZyA9IGZhbHNlO1xuICB0aGlzLnBhY2tldEJ1ZmZlciA9IFtdO1xuICB0aGlzLmVuY29kZXIgPSBuZXcgcGFyc2VyLkVuY29kZXIoKTtcbiAgdGhpcy5kZWNvZGVyID0gbmV3IHBhcnNlci5EZWNvZGVyKCk7XG4gIHRoaXMuYXV0b0Nvbm5lY3QgPSBvcHRzLmF1dG9Db25uZWN0ICE9PSBmYWxzZTtcbiAgaWYgKHRoaXMuYXV0b0Nvbm5lY3QpIHRoaXMub3BlbigpO1xufVxuXG4vKipcbiAqIFByb3BhZ2F0ZSBnaXZlbiBldmVudCB0byBzb2NrZXRzIGFuZCBlbWl0IG9uIGB0aGlzYFxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLmVtaXRBbGwgPSBmdW5jdGlvbiAoKSB7XG4gIHRoaXMuZW1pdC5hcHBseSh0aGlzLCBhcmd1bWVudHMpO1xuICBmb3IgKHZhciBuc3AgaW4gdGhpcy5uc3BzKSB7XG4gICAgaWYgKGhhcy5jYWxsKHRoaXMubnNwcywgbnNwKSkge1xuICAgICAgdGhpcy5uc3BzW25zcF0uZW1pdC5hcHBseSh0aGlzLm5zcHNbbnNwXSwgYXJndW1lbnRzKTtcbiAgICB9XG4gIH1cbn07XG5cbi8qKlxuICogVXBkYXRlIGBzb2NrZXQuaWRgIG9mIGFsbCBzb2NrZXRzXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuTWFuYWdlci5wcm90b3R5cGUudXBkYXRlU29ja2V0SWRzID0gZnVuY3Rpb24gKCkge1xuICBmb3IgKHZhciBuc3AgaW4gdGhpcy5uc3BzKSB7XG4gICAgaWYgKGhhcy5jYWxsKHRoaXMubnNwcywgbnNwKSkge1xuICAgICAgdGhpcy5uc3BzW25zcF0uaWQgPSB0aGlzLmVuZ2luZS5pZDtcbiAgICB9XG4gIH1cbn07XG5cbi8qKlxuICogTWl4IGluIGBFbWl0dGVyYC5cbiAqL1xuXG5FbWl0dGVyKE1hbmFnZXIucHJvdG90eXBlKTtcblxuLyoqXG4gKiBTZXRzIHRoZSBgcmVjb25uZWN0aW9uYCBjb25maWcuXG4gKlxuICogQHBhcmFtIHtCb29sZWFufSB0cnVlL2ZhbHNlIGlmIGl0IHNob3VsZCBhdXRvbWF0aWNhbGx5IHJlY29ubmVjdFxuICogQHJldHVybiB7TWFuYWdlcn0gc2VsZiBvciB2YWx1ZVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5NYW5hZ2VyLnByb3RvdHlwZS5yZWNvbm5lY3Rpb24gPSBmdW5jdGlvbiAodikge1xuICBpZiAoIWFyZ3VtZW50cy5sZW5ndGgpIHJldHVybiB0aGlzLl9yZWNvbm5lY3Rpb247XG4gIHRoaXMuX3JlY29ubmVjdGlvbiA9ICEhdjtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIFNldHMgdGhlIHJlY29ubmVjdGlvbiBhdHRlbXB0cyBjb25maWcuXG4gKlxuICogQHBhcmFtIHtOdW1iZXJ9IG1heCByZWNvbm5lY3Rpb24gYXR0ZW1wdHMgYmVmb3JlIGdpdmluZyB1cFxuICogQHJldHVybiB7TWFuYWdlcn0gc2VsZiBvciB2YWx1ZVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5NYW5hZ2VyLnByb3RvdHlwZS5yZWNvbm5lY3Rpb25BdHRlbXB0cyA9IGZ1bmN0aW9uICh2KSB7XG4gIGlmICghYXJndW1lbnRzLmxlbmd0aCkgcmV0dXJuIHRoaXMuX3JlY29ubmVjdGlvbkF0dGVtcHRzO1xuICB0aGlzLl9yZWNvbm5lY3Rpb25BdHRlbXB0cyA9IHY7XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBTZXRzIHRoZSBkZWxheSBiZXR3ZWVuIHJlY29ubmVjdGlvbnMuXG4gKlxuICogQHBhcmFtIHtOdW1iZXJ9IGRlbGF5XG4gKiBAcmV0dXJuIHtNYW5hZ2VyfSBzZWxmIG9yIHZhbHVlXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLnJlY29ubmVjdGlvbkRlbGF5ID0gZnVuY3Rpb24gKHYpIHtcbiAgaWYgKCFhcmd1bWVudHMubGVuZ3RoKSByZXR1cm4gdGhpcy5fcmVjb25uZWN0aW9uRGVsYXk7XG4gIHRoaXMuX3JlY29ubmVjdGlvbkRlbGF5ID0gdjtcbiAgdGhpcy5iYWNrb2ZmICYmIHRoaXMuYmFja29mZi5zZXRNaW4odik7XG4gIHJldHVybiB0aGlzO1xufTtcblxuTWFuYWdlci5wcm90b3R5cGUucmFuZG9taXphdGlvbkZhY3RvciA9IGZ1bmN0aW9uICh2KSB7XG4gIGlmICghYXJndW1lbnRzLmxlbmd0aCkgcmV0dXJuIHRoaXMuX3JhbmRvbWl6YXRpb25GYWN0b3I7XG4gIHRoaXMuX3JhbmRvbWl6YXRpb25GYWN0b3IgPSB2O1xuICB0aGlzLmJhY2tvZmYgJiYgdGhpcy5iYWNrb2ZmLnNldEppdHRlcih2KTtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIFNldHMgdGhlIG1heGltdW0gZGVsYXkgYmV0d2VlbiByZWNvbm5lY3Rpb25zLlxuICpcbiAqIEBwYXJhbSB7TnVtYmVyfSBkZWxheVxuICogQHJldHVybiB7TWFuYWdlcn0gc2VsZiBvciB2YWx1ZVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5NYW5hZ2VyLnByb3RvdHlwZS5yZWNvbm5lY3Rpb25EZWxheU1heCA9IGZ1bmN0aW9uICh2KSB7XG4gIGlmICghYXJndW1lbnRzLmxlbmd0aCkgcmV0dXJuIHRoaXMuX3JlY29ubmVjdGlvbkRlbGF5TWF4O1xuICB0aGlzLl9yZWNvbm5lY3Rpb25EZWxheU1heCA9IHY7XG4gIHRoaXMuYmFja29mZiAmJiB0aGlzLmJhY2tvZmYuc2V0TWF4KHYpO1xuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogU2V0cyB0aGUgY29ubmVjdGlvbiB0aW1lb3V0LiBgZmFsc2VgIHRvIGRpc2FibGVcbiAqXG4gKiBAcmV0dXJuIHtNYW5hZ2VyfSBzZWxmIG9yIHZhbHVlXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLnRpbWVvdXQgPSBmdW5jdGlvbiAodikge1xuICBpZiAoIWFyZ3VtZW50cy5sZW5ndGgpIHJldHVybiB0aGlzLl90aW1lb3V0O1xuICB0aGlzLl90aW1lb3V0ID0gdjtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIFN0YXJ0cyB0cnlpbmcgdG8gcmVjb25uZWN0IGlmIHJlY29ubmVjdGlvbiBpcyBlbmFibGVkIGFuZCB3ZSBoYXZlIG5vdFxuICogc3RhcnRlZCByZWNvbm5lY3RpbmcgeWV0XG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuTWFuYWdlci5wcm90b3R5cGUubWF5YmVSZWNvbm5lY3RPbk9wZW4gPSBmdW5jdGlvbiAoKSB7XG4gIC8vIE9ubHkgdHJ5IHRvIHJlY29ubmVjdCBpZiBpdCdzIHRoZSBmaXJzdCB0aW1lIHdlJ3JlIGNvbm5lY3RpbmdcbiAgaWYgKCF0aGlzLnJlY29ubmVjdGluZyAmJiB0aGlzLl9yZWNvbm5lY3Rpb24gJiYgdGhpcy5iYWNrb2ZmLmF0dGVtcHRzID09PSAwKSB7XG4gICAgLy8ga2VlcHMgcmVjb25uZWN0aW9uIGZyb20gZmlyaW5nIHR3aWNlIGZvciB0aGUgc2FtZSByZWNvbm5lY3Rpb24gbG9vcFxuICAgIHRoaXMucmVjb25uZWN0KCk7XG4gIH1cbn07XG5cbi8qKlxuICogU2V0cyB0aGUgY3VycmVudCB0cmFuc3BvcnQgYHNvY2tldGAuXG4gKlxuICogQHBhcmFtIHtGdW5jdGlvbn0gb3B0aW9uYWwsIGNhbGxiYWNrXG4gKiBAcmV0dXJuIHtNYW5hZ2VyfSBzZWxmXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLm9wZW4gPVxuTWFuYWdlci5wcm90b3R5cGUuY29ubmVjdCA9IGZ1bmN0aW9uIChmbiwgb3B0cykge1xuICBkZWJ1ZygncmVhZHlTdGF0ZSAlcycsIHRoaXMucmVhZHlTdGF0ZSk7XG4gIGlmICh+dGhpcy5yZWFkeVN0YXRlLmluZGV4T2YoJ29wZW4nKSkgcmV0dXJuIHRoaXM7XG5cbiAgZGVidWcoJ29wZW5pbmcgJXMnLCB0aGlzLnVyaSk7XG4gIHRoaXMuZW5naW5lID0gZWlvKHRoaXMudXJpLCB0aGlzLm9wdHMpO1xuICB2YXIgc29ja2V0ID0gdGhpcy5lbmdpbmU7XG4gIHZhciBzZWxmID0gdGhpcztcbiAgdGhpcy5yZWFkeVN0YXRlID0gJ29wZW5pbmcnO1xuICB0aGlzLnNraXBSZWNvbm5lY3QgPSBmYWxzZTtcblxuICAvLyBlbWl0IGBvcGVuYFxuICB2YXIgb3BlblN1YiA9IG9uKHNvY2tldCwgJ29wZW4nLCBmdW5jdGlvbiAoKSB7XG4gICAgc2VsZi5vbm9wZW4oKTtcbiAgICBmbiAmJiBmbigpO1xuICB9KTtcblxuICAvLyBlbWl0IGBjb25uZWN0X2Vycm9yYFxuICB2YXIgZXJyb3JTdWIgPSBvbihzb2NrZXQsICdlcnJvcicsIGZ1bmN0aW9uIChkYXRhKSB7XG4gICAgZGVidWcoJ2Nvbm5lY3RfZXJyb3InKTtcbiAgICBzZWxmLmNsZWFudXAoKTtcbiAgICBzZWxmLnJlYWR5U3RhdGUgPSAnY2xvc2VkJztcbiAgICBzZWxmLmVtaXRBbGwoJ2Nvbm5lY3RfZXJyb3InLCBkYXRhKTtcbiAgICBpZiAoZm4pIHtcbiAgICAgIHZhciBlcnIgPSBuZXcgRXJyb3IoJ0Nvbm5lY3Rpb24gZXJyb3InKTtcbiAgICAgIGVyci5kYXRhID0gZGF0YTtcbiAgICAgIGZuKGVycik7XG4gICAgfSBlbHNlIHtcbiAgICAgIC8vIE9ubHkgZG8gdGhpcyBpZiB0aGVyZSBpcyBubyBmbiB0byBoYW5kbGUgdGhlIGVycm9yXG4gICAgICBzZWxmLm1heWJlUmVjb25uZWN0T25PcGVuKCk7XG4gICAgfVxuICB9KTtcblxuICAvLyBlbWl0IGBjb25uZWN0X3RpbWVvdXRgXG4gIGlmIChmYWxzZSAhPT0gdGhpcy5fdGltZW91dCkge1xuICAgIHZhciB0aW1lb3V0ID0gdGhpcy5fdGltZW91dDtcbiAgICBkZWJ1ZygnY29ubmVjdCBhdHRlbXB0IHdpbGwgdGltZW91dCBhZnRlciAlZCcsIHRpbWVvdXQpO1xuXG4gICAgLy8gc2V0IHRpbWVyXG4gICAgdmFyIHRpbWVyID0gc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICBkZWJ1ZygnY29ubmVjdCBhdHRlbXB0IHRpbWVkIG91dCBhZnRlciAlZCcsIHRpbWVvdXQpO1xuICAgICAgb3BlblN1Yi5kZXN0cm95KCk7XG4gICAgICBzb2NrZXQuY2xvc2UoKTtcbiAgICAgIHNvY2tldC5lbWl0KCdlcnJvcicsICd0aW1lb3V0Jyk7XG4gICAgICBzZWxmLmVtaXRBbGwoJ2Nvbm5lY3RfdGltZW91dCcsIHRpbWVvdXQpO1xuICAgIH0sIHRpbWVvdXQpO1xuXG4gICAgdGhpcy5zdWJzLnB1c2goe1xuICAgICAgZGVzdHJveTogZnVuY3Rpb24gKCkge1xuICAgICAgICBjbGVhclRpbWVvdXQodGltZXIpO1xuICAgICAgfVxuICAgIH0pO1xuICB9XG5cbiAgdGhpcy5zdWJzLnB1c2gob3BlblN1Yik7XG4gIHRoaXMuc3Vicy5wdXNoKGVycm9yU3ViKTtcblxuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogQ2FsbGVkIHVwb24gdHJhbnNwb3J0IG9wZW4uXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuTWFuYWdlci5wcm90b3R5cGUub25vcGVuID0gZnVuY3Rpb24gKCkge1xuICBkZWJ1Zygnb3BlbicpO1xuXG4gIC8vIGNsZWFyIG9sZCBzdWJzXG4gIHRoaXMuY2xlYW51cCgpO1xuXG4gIC8vIG1hcmsgYXMgb3BlblxuICB0aGlzLnJlYWR5U3RhdGUgPSAnb3Blbic7XG4gIHRoaXMuZW1pdCgnb3BlbicpO1xuXG4gIC8vIGFkZCBuZXcgc3Vic1xuICB2YXIgc29ja2V0ID0gdGhpcy5lbmdpbmU7XG4gIHRoaXMuc3Vicy5wdXNoKG9uKHNvY2tldCwgJ2RhdGEnLCBiaW5kKHRoaXMsICdvbmRhdGEnKSkpO1xuICB0aGlzLnN1YnMucHVzaChvbihzb2NrZXQsICdwaW5nJywgYmluZCh0aGlzLCAnb25waW5nJykpKTtcbiAgdGhpcy5zdWJzLnB1c2gob24oc29ja2V0LCAncG9uZycsIGJpbmQodGhpcywgJ29ucG9uZycpKSk7XG4gIHRoaXMuc3Vicy5wdXNoKG9uKHNvY2tldCwgJ2Vycm9yJywgYmluZCh0aGlzLCAnb25lcnJvcicpKSk7XG4gIHRoaXMuc3Vicy5wdXNoKG9uKHNvY2tldCwgJ2Nsb3NlJywgYmluZCh0aGlzLCAnb25jbG9zZScpKSk7XG4gIHRoaXMuc3Vicy5wdXNoKG9uKHRoaXMuZGVjb2RlciwgJ2RlY29kZWQnLCBiaW5kKHRoaXMsICdvbmRlY29kZWQnKSkpO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgdXBvbiBhIHBpbmcuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuTWFuYWdlci5wcm90b3R5cGUub25waW5nID0gZnVuY3Rpb24gKCkge1xuICB0aGlzLmxhc3RQaW5nID0gbmV3IERhdGUoKTtcbiAgdGhpcy5lbWl0QWxsKCdwaW5nJyk7XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIGEgcGFja2V0LlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLm9ucG9uZyA9IGZ1bmN0aW9uICgpIHtcbiAgdGhpcy5lbWl0QWxsKCdwb25nJywgbmV3IERhdGUoKSAtIHRoaXMubGFzdFBpbmcpO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgd2l0aCBkYXRhLlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLm9uZGF0YSA9IGZ1bmN0aW9uIChkYXRhKSB7XG4gIHRoaXMuZGVjb2Rlci5hZGQoZGF0YSk7XG59O1xuXG4vKipcbiAqIENhbGxlZCB3aGVuIHBhcnNlciBmdWxseSBkZWNvZGVzIGEgcGFja2V0LlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLm9uZGVjb2RlZCA9IGZ1bmN0aW9uIChwYWNrZXQpIHtcbiAgdGhpcy5lbWl0KCdwYWNrZXQnLCBwYWNrZXQpO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgdXBvbiBzb2NrZXQgZXJyb3IuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuTWFuYWdlci5wcm90b3R5cGUub25lcnJvciA9IGZ1bmN0aW9uIChlcnIpIHtcbiAgZGVidWcoJ2Vycm9yJywgZXJyKTtcbiAgdGhpcy5lbWl0QWxsKCdlcnJvcicsIGVycik7XG59O1xuXG4vKipcbiAqIENyZWF0ZXMgYSBuZXcgc29ja2V0IGZvciB0aGUgZ2l2ZW4gYG5zcGAuXG4gKlxuICogQHJldHVybiB7U29ja2V0fVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5NYW5hZ2VyLnByb3RvdHlwZS5zb2NrZXQgPSBmdW5jdGlvbiAobnNwLCBvcHRzKSB7XG4gIHZhciBzb2NrZXQgPSB0aGlzLm5zcHNbbnNwXTtcbiAgaWYgKCFzb2NrZXQpIHtcbiAgICBzb2NrZXQgPSBuZXcgU29ja2V0KHRoaXMsIG5zcCwgb3B0cyk7XG4gICAgdGhpcy5uc3BzW25zcF0gPSBzb2NrZXQ7XG4gICAgdmFyIHNlbGYgPSB0aGlzO1xuICAgIHNvY2tldC5vbignY29ubmVjdGluZycsIG9uQ29ubmVjdGluZyk7XG4gICAgc29ja2V0Lm9uKCdjb25uZWN0JywgZnVuY3Rpb24gKCkge1xuICAgICAgc29ja2V0LmlkID0gc2VsZi5lbmdpbmUuaWQ7XG4gICAgfSk7XG5cbiAgICBpZiAodGhpcy5hdXRvQ29ubmVjdCkge1xuICAgICAgLy8gbWFudWFsbHkgY2FsbCBoZXJlIHNpbmNlIGNvbm5lY3RpbmcgZXZuZXQgaXMgZmlyZWQgYmVmb3JlIGxpc3RlbmluZ1xuICAgICAgb25Db25uZWN0aW5nKCk7XG4gICAgfVxuICB9XG5cbiAgZnVuY3Rpb24gb25Db25uZWN0aW5nICgpIHtcbiAgICBpZiAoIX5pbmRleE9mKHNlbGYuY29ubmVjdGluZywgc29ja2V0KSkge1xuICAgICAgc2VsZi5jb25uZWN0aW5nLnB1c2goc29ja2V0KTtcbiAgICB9XG4gIH1cblxuICByZXR1cm4gc29ja2V0O1xufTtcblxuLyoqXG4gKiBDYWxsZWQgdXBvbiBhIHNvY2tldCBjbG9zZS5cbiAqXG4gKiBAcGFyYW0ge1NvY2tldH0gc29ja2V0XG4gKi9cblxuTWFuYWdlci5wcm90b3R5cGUuZGVzdHJveSA9IGZ1bmN0aW9uIChzb2NrZXQpIHtcbiAgdmFyIGluZGV4ID0gaW5kZXhPZih0aGlzLmNvbm5lY3RpbmcsIHNvY2tldCk7XG4gIGlmICh+aW5kZXgpIHRoaXMuY29ubmVjdGluZy5zcGxpY2UoaW5kZXgsIDEpO1xuICBpZiAodGhpcy5jb25uZWN0aW5nLmxlbmd0aCkgcmV0dXJuO1xuXG4gIHRoaXMuY2xvc2UoKTtcbn07XG5cbi8qKlxuICogV3JpdGVzIGEgcGFja2V0LlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBwYWNrZXRcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLnBhY2tldCA9IGZ1bmN0aW9uIChwYWNrZXQpIHtcbiAgZGVidWcoJ3dyaXRpbmcgcGFja2V0ICVqJywgcGFja2V0KTtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICBpZiAocGFja2V0LnF1ZXJ5ICYmIHBhY2tldC50eXBlID09PSAwKSBwYWNrZXQubnNwICs9ICc/JyArIHBhY2tldC5xdWVyeTtcblxuICBpZiAoIXNlbGYuZW5jb2RpbmcpIHtcbiAgICAvLyBlbmNvZGUsIHRoZW4gd3JpdGUgdG8gZW5naW5lIHdpdGggcmVzdWx0XG4gICAgc2VsZi5lbmNvZGluZyA9IHRydWU7XG4gICAgdGhpcy5lbmNvZGVyLmVuY29kZShwYWNrZXQsIGZ1bmN0aW9uIChlbmNvZGVkUGFja2V0cykge1xuICAgICAgZm9yICh2YXIgaSA9IDA7IGkgPCBlbmNvZGVkUGFja2V0cy5sZW5ndGg7IGkrKykge1xuICAgICAgICBzZWxmLmVuZ2luZS53cml0ZShlbmNvZGVkUGFja2V0c1tpXSwgcGFja2V0Lm9wdGlvbnMpO1xuICAgICAgfVxuICAgICAgc2VsZi5lbmNvZGluZyA9IGZhbHNlO1xuICAgICAgc2VsZi5wcm9jZXNzUGFja2V0UXVldWUoKTtcbiAgICB9KTtcbiAgfSBlbHNlIHsgLy8gYWRkIHBhY2tldCB0byB0aGUgcXVldWVcbiAgICBzZWxmLnBhY2tldEJ1ZmZlci5wdXNoKHBhY2tldCk7XG4gIH1cbn07XG5cbi8qKlxuICogSWYgcGFja2V0IGJ1ZmZlciBpcyBub24tZW1wdHksIGJlZ2lucyBlbmNvZGluZyB0aGVcbiAqIG5leHQgcGFja2V0IGluIGxpbmUuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuTWFuYWdlci5wcm90b3R5cGUucHJvY2Vzc1BhY2tldFF1ZXVlID0gZnVuY3Rpb24gKCkge1xuICBpZiAodGhpcy5wYWNrZXRCdWZmZXIubGVuZ3RoID4gMCAmJiAhdGhpcy5lbmNvZGluZykge1xuICAgIHZhciBwYWNrID0gdGhpcy5wYWNrZXRCdWZmZXIuc2hpZnQoKTtcbiAgICB0aGlzLnBhY2tldChwYWNrKTtcbiAgfVxufTtcblxuLyoqXG4gKiBDbGVhbiB1cCB0cmFuc3BvcnQgc3Vic2NyaXB0aW9ucyBhbmQgcGFja2V0IGJ1ZmZlci5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5NYW5hZ2VyLnByb3RvdHlwZS5jbGVhbnVwID0gZnVuY3Rpb24gKCkge1xuICBkZWJ1ZygnY2xlYW51cCcpO1xuXG4gIHZhciBzdWJzTGVuZ3RoID0gdGhpcy5zdWJzLmxlbmd0aDtcbiAgZm9yICh2YXIgaSA9IDA7IGkgPCBzdWJzTGVuZ3RoOyBpKyspIHtcbiAgICB2YXIgc3ViID0gdGhpcy5zdWJzLnNoaWZ0KCk7XG4gICAgc3ViLmRlc3Ryb3koKTtcbiAgfVxuXG4gIHRoaXMucGFja2V0QnVmZmVyID0gW107XG4gIHRoaXMuZW5jb2RpbmcgPSBmYWxzZTtcbiAgdGhpcy5sYXN0UGluZyA9IG51bGw7XG5cbiAgdGhpcy5kZWNvZGVyLmRlc3Ryb3koKTtcbn07XG5cbi8qKlxuICogQ2xvc2UgdGhlIGN1cnJlbnQgc29ja2V0LlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLmNsb3NlID1cbk1hbmFnZXIucHJvdG90eXBlLmRpc2Nvbm5lY3QgPSBmdW5jdGlvbiAoKSB7XG4gIGRlYnVnKCdkaXNjb25uZWN0Jyk7XG4gIHRoaXMuc2tpcFJlY29ubmVjdCA9IHRydWU7XG4gIHRoaXMucmVjb25uZWN0aW5nID0gZmFsc2U7XG4gIGlmICgnb3BlbmluZycgPT09IHRoaXMucmVhZHlTdGF0ZSkge1xuICAgIC8vIGBvbmNsb3NlYCB3aWxsIG5vdCBmaXJlIGJlY2F1c2VcbiAgICAvLyBhbiBvcGVuIGV2ZW50IG5ldmVyIGhhcHBlbmVkXG4gICAgdGhpcy5jbGVhbnVwKCk7XG4gIH1cbiAgdGhpcy5iYWNrb2ZmLnJlc2V0KCk7XG4gIHRoaXMucmVhZHlTdGF0ZSA9ICdjbG9zZWQnO1xuICBpZiAodGhpcy5lbmdpbmUpIHRoaXMuZW5naW5lLmNsb3NlKCk7XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIGVuZ2luZSBjbG9zZS5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5NYW5hZ2VyLnByb3RvdHlwZS5vbmNsb3NlID0gZnVuY3Rpb24gKHJlYXNvbikge1xuICBkZWJ1Zygnb25jbG9zZScpO1xuXG4gIHRoaXMuY2xlYW51cCgpO1xuICB0aGlzLmJhY2tvZmYucmVzZXQoKTtcbiAgdGhpcy5yZWFkeVN0YXRlID0gJ2Nsb3NlZCc7XG4gIHRoaXMuZW1pdCgnY2xvc2UnLCByZWFzb24pO1xuXG4gIGlmICh0aGlzLl9yZWNvbm5lY3Rpb24gJiYgIXRoaXMuc2tpcFJlY29ubmVjdCkge1xuICAgIHRoaXMucmVjb25uZWN0KCk7XG4gIH1cbn07XG5cbi8qKlxuICogQXR0ZW1wdCBhIHJlY29ubmVjdGlvbi5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5NYW5hZ2VyLnByb3RvdHlwZS5yZWNvbm5lY3QgPSBmdW5jdGlvbiAoKSB7XG4gIGlmICh0aGlzLnJlY29ubmVjdGluZyB8fCB0aGlzLnNraXBSZWNvbm5lY3QpIHJldHVybiB0aGlzO1xuXG4gIHZhciBzZWxmID0gdGhpcztcblxuICBpZiAodGhpcy5iYWNrb2ZmLmF0dGVtcHRzID49IHRoaXMuX3JlY29ubmVjdGlvbkF0dGVtcHRzKSB7XG4gICAgZGVidWcoJ3JlY29ubmVjdCBmYWlsZWQnKTtcbiAgICB0aGlzLmJhY2tvZmYucmVzZXQoKTtcbiAgICB0aGlzLmVtaXRBbGwoJ3JlY29ubmVjdF9mYWlsZWQnKTtcbiAgICB0aGlzLnJlY29ubmVjdGluZyA9IGZhbHNlO1xuICB9IGVsc2Uge1xuICAgIHZhciBkZWxheSA9IHRoaXMuYmFja29mZi5kdXJhdGlvbigpO1xuICAgIGRlYnVnKCd3aWxsIHdhaXQgJWRtcyBiZWZvcmUgcmVjb25uZWN0IGF0dGVtcHQnLCBkZWxheSk7XG5cbiAgICB0aGlzLnJlY29ubmVjdGluZyA9IHRydWU7XG4gICAgdmFyIHRpbWVyID0gc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICBpZiAoc2VsZi5za2lwUmVjb25uZWN0KSByZXR1cm47XG5cbiAgICAgIGRlYnVnKCdhdHRlbXB0aW5nIHJlY29ubmVjdCcpO1xuICAgICAgc2VsZi5lbWl0QWxsKCdyZWNvbm5lY3RfYXR0ZW1wdCcsIHNlbGYuYmFja29mZi5hdHRlbXB0cyk7XG4gICAgICBzZWxmLmVtaXRBbGwoJ3JlY29ubmVjdGluZycsIHNlbGYuYmFja29mZi5hdHRlbXB0cyk7XG5cbiAgICAgIC8vIGNoZWNrIGFnYWluIGZvciB0aGUgY2FzZSBzb2NrZXQgY2xvc2VkIGluIGFib3ZlIGV2ZW50c1xuICAgICAgaWYgKHNlbGYuc2tpcFJlY29ubmVjdCkgcmV0dXJuO1xuXG4gICAgICBzZWxmLm9wZW4oZnVuY3Rpb24gKGVycikge1xuICAgICAgICBpZiAoZXJyKSB7XG4gICAgICAgICAgZGVidWcoJ3JlY29ubmVjdCBhdHRlbXB0IGVycm9yJyk7XG4gICAgICAgICAgc2VsZi5yZWNvbm5lY3RpbmcgPSBmYWxzZTtcbiAgICAgICAgICBzZWxmLnJlY29ubmVjdCgpO1xuICAgICAgICAgIHNlbGYuZW1pdEFsbCgncmVjb25uZWN0X2Vycm9yJywgZXJyLmRhdGEpO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgIGRlYnVnKCdyZWNvbm5lY3Qgc3VjY2VzcycpO1xuICAgICAgICAgIHNlbGYub25yZWNvbm5lY3QoKTtcbiAgICAgICAgfVxuICAgICAgfSk7XG4gICAgfSwgZGVsYXkpO1xuXG4gICAgdGhpcy5zdWJzLnB1c2goe1xuICAgICAgZGVzdHJveTogZnVuY3Rpb24gKCkge1xuICAgICAgICBjbGVhclRpbWVvdXQodGltZXIpO1xuICAgICAgfVxuICAgIH0pO1xuICB9XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIHN1Y2Nlc3NmdWwgcmVjb25uZWN0LlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbk1hbmFnZXIucHJvdG90eXBlLm9ucmVjb25uZWN0ID0gZnVuY3Rpb24gKCkge1xuICB2YXIgYXR0ZW1wdCA9IHRoaXMuYmFja29mZi5hdHRlbXB0cztcbiAgdGhpcy5yZWNvbm5lY3RpbmcgPSBmYWxzZTtcbiAgdGhpcy5iYWNrb2ZmLnJlc2V0KCk7XG4gIHRoaXMudXBkYXRlU29ja2V0SWRzKCk7XG4gIHRoaXMuZW1pdEFsbCgncmVjb25uZWN0JywgYXR0ZW1wdCk7XG59O1xuIiwiXG4vKipcbiAqIE1vZHVsZSBleHBvcnRzLlxuICovXG5cbm1vZHVsZS5leHBvcnRzID0gb247XG5cbi8qKlxuICogSGVscGVyIGZvciBzdWJzY3JpcHRpb25zLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fEV2ZW50RW1pdHRlcn0gb2JqIHdpdGggYEVtaXR0ZXJgIG1peGluIG9yIGBFdmVudEVtaXR0ZXJgXG4gKiBAcGFyYW0ge1N0cmluZ30gZXZlbnQgbmFtZVxuICogQHBhcmFtIHtGdW5jdGlvbn0gY2FsbGJhY2tcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gb24gKG9iaiwgZXYsIGZuKSB7XG4gIG9iai5vbihldiwgZm4pO1xuICByZXR1cm4ge1xuICAgIGRlc3Ryb3k6IGZ1bmN0aW9uICgpIHtcbiAgICAgIG9iai5yZW1vdmVMaXN0ZW5lcihldiwgZm4pO1xuICAgIH1cbiAgfTtcbn1cbiIsIlxuLyoqXG4gKiBNb2R1bGUgZGVwZW5kZW5jaWVzLlxuICovXG5cbnZhciBwYXJzZXIgPSByZXF1aXJlKCdzb2NrZXQuaW8tcGFyc2VyJyk7XG52YXIgRW1pdHRlciA9IHJlcXVpcmUoJ2NvbXBvbmVudC1lbWl0dGVyJyk7XG52YXIgdG9BcnJheSA9IHJlcXVpcmUoJ3RvLWFycmF5Jyk7XG52YXIgb24gPSByZXF1aXJlKCcuL29uJyk7XG52YXIgYmluZCA9IHJlcXVpcmUoJ2NvbXBvbmVudC1iaW5kJyk7XG52YXIgZGVidWcgPSByZXF1aXJlKCdkZWJ1ZycpKCdzb2NrZXQuaW8tY2xpZW50OnNvY2tldCcpO1xudmFyIGhhc0JpbiA9IHJlcXVpcmUoJ2hhcy1iaW5hcnknKTtcblxuLyoqXG4gKiBNb2R1bGUgZXhwb3J0cy5cbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IGV4cG9ydHMgPSBTb2NrZXQ7XG5cbi8qKlxuICogSW50ZXJuYWwgZXZlbnRzIChibGFja2xpc3RlZCkuXG4gKiBUaGVzZSBldmVudHMgY2FuJ3QgYmUgZW1pdHRlZCBieSB0aGUgdXNlci5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG52YXIgZXZlbnRzID0ge1xuICBjb25uZWN0OiAxLFxuICBjb25uZWN0X2Vycm9yOiAxLFxuICBjb25uZWN0X3RpbWVvdXQ6IDEsXG4gIGNvbm5lY3Rpbmc6IDEsXG4gIGRpc2Nvbm5lY3Q6IDEsXG4gIGVycm9yOiAxLFxuICByZWNvbm5lY3Q6IDEsXG4gIHJlY29ubmVjdF9hdHRlbXB0OiAxLFxuICByZWNvbm5lY3RfZmFpbGVkOiAxLFxuICByZWNvbm5lY3RfZXJyb3I6IDEsXG4gIHJlY29ubmVjdGluZzogMSxcbiAgcGluZzogMSxcbiAgcG9uZzogMVxufTtcblxuLyoqXG4gKiBTaG9ydGN1dCB0byBgRW1pdHRlciNlbWl0YC5cbiAqL1xuXG52YXIgZW1pdCA9IEVtaXR0ZXIucHJvdG90eXBlLmVtaXQ7XG5cbi8qKlxuICogYFNvY2tldGAgY29uc3RydWN0b3IuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBTb2NrZXQgKGlvLCBuc3AsIG9wdHMpIHtcbiAgdGhpcy5pbyA9IGlvO1xuICB0aGlzLm5zcCA9IG5zcDtcbiAgdGhpcy5qc29uID0gdGhpczsgLy8gY29tcGF0XG4gIHRoaXMuaWRzID0gMDtcbiAgdGhpcy5hY2tzID0ge307XG4gIHRoaXMucmVjZWl2ZUJ1ZmZlciA9IFtdO1xuICB0aGlzLnNlbmRCdWZmZXIgPSBbXTtcbiAgdGhpcy5jb25uZWN0ZWQgPSBmYWxzZTtcbiAgdGhpcy5kaXNjb25uZWN0ZWQgPSB0cnVlO1xuICBpZiAob3B0cyAmJiBvcHRzLnF1ZXJ5KSB7XG4gICAgdGhpcy5xdWVyeSA9IG9wdHMucXVlcnk7XG4gIH1cbiAgaWYgKHRoaXMuaW8uYXV0b0Nvbm5lY3QpIHRoaXMub3BlbigpO1xufVxuXG4vKipcbiAqIE1peCBpbiBgRW1pdHRlcmAuXG4gKi9cblxuRW1pdHRlcihTb2NrZXQucHJvdG90eXBlKTtcblxuLyoqXG4gKiBTdWJzY3JpYmUgdG8gb3BlbiwgY2xvc2UgYW5kIHBhY2tldCBldmVudHNcbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLnN1YkV2ZW50cyA9IGZ1bmN0aW9uICgpIHtcbiAgaWYgKHRoaXMuc3VicykgcmV0dXJuO1xuXG4gIHZhciBpbyA9IHRoaXMuaW87XG4gIHRoaXMuc3VicyA9IFtcbiAgICBvbihpbywgJ29wZW4nLCBiaW5kKHRoaXMsICdvbm9wZW4nKSksXG4gICAgb24oaW8sICdwYWNrZXQnLCBiaW5kKHRoaXMsICdvbnBhY2tldCcpKSxcbiAgICBvbihpbywgJ2Nsb3NlJywgYmluZCh0aGlzLCAnb25jbG9zZScpKVxuICBdO1xufTtcblxuLyoqXG4gKiBcIk9wZW5zXCIgdGhlIHNvY2tldC5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cblNvY2tldC5wcm90b3R5cGUub3BlbiA9XG5Tb2NrZXQucHJvdG90eXBlLmNvbm5lY3QgPSBmdW5jdGlvbiAoKSB7XG4gIGlmICh0aGlzLmNvbm5lY3RlZCkgcmV0dXJuIHRoaXM7XG5cbiAgdGhpcy5zdWJFdmVudHMoKTtcbiAgdGhpcy5pby5vcGVuKCk7IC8vIGVuc3VyZSBvcGVuXG4gIGlmICgnb3BlbicgPT09IHRoaXMuaW8ucmVhZHlTdGF0ZSkgdGhpcy5vbm9wZW4oKTtcbiAgdGhpcy5lbWl0KCdjb25uZWN0aW5nJyk7XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBTZW5kcyBhIGBtZXNzYWdlYCBldmVudC5cbiAqXG4gKiBAcmV0dXJuIHtTb2NrZXR9IHNlbGZcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5zZW5kID0gZnVuY3Rpb24gKCkge1xuICB2YXIgYXJncyA9IHRvQXJyYXkoYXJndW1lbnRzKTtcbiAgYXJncy51bnNoaWZ0KCdtZXNzYWdlJyk7XG4gIHRoaXMuZW1pdC5hcHBseSh0aGlzLCBhcmdzKTtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIE92ZXJyaWRlIGBlbWl0YC5cbiAqIElmIHRoZSBldmVudCBpcyBpbiBgZXZlbnRzYCwgaXQncyBlbWl0dGVkIG5vcm1hbGx5LlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBldmVudCBuYW1lXG4gKiBAcmV0dXJuIHtTb2NrZXR9IHNlbGZcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5lbWl0ID0gZnVuY3Rpb24gKGV2KSB7XG4gIGlmIChldmVudHMuaGFzT3duUHJvcGVydHkoZXYpKSB7XG4gICAgZW1pdC5hcHBseSh0aGlzLCBhcmd1bWVudHMpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgdmFyIGFyZ3MgPSB0b0FycmF5KGFyZ3VtZW50cyk7XG4gIHZhciBwYXJzZXJUeXBlID0gcGFyc2VyLkVWRU5UOyAvLyBkZWZhdWx0XG4gIGlmIChoYXNCaW4oYXJncykpIHsgcGFyc2VyVHlwZSA9IHBhcnNlci5CSU5BUllfRVZFTlQ7IH0gLy8gYmluYXJ5XG4gIHZhciBwYWNrZXQgPSB7IHR5cGU6IHBhcnNlclR5cGUsIGRhdGE6IGFyZ3MgfTtcblxuICBwYWNrZXQub3B0aW9ucyA9IHt9O1xuICBwYWNrZXQub3B0aW9ucy5jb21wcmVzcyA9ICF0aGlzLmZsYWdzIHx8IGZhbHNlICE9PSB0aGlzLmZsYWdzLmNvbXByZXNzO1xuXG4gIC8vIGV2ZW50IGFjayBjYWxsYmFja1xuICBpZiAoJ2Z1bmN0aW9uJyA9PT0gdHlwZW9mIGFyZ3NbYXJncy5sZW5ndGggLSAxXSkge1xuICAgIGRlYnVnKCdlbWl0dGluZyBwYWNrZXQgd2l0aCBhY2sgaWQgJWQnLCB0aGlzLmlkcyk7XG4gICAgdGhpcy5hY2tzW3RoaXMuaWRzXSA9IGFyZ3MucG9wKCk7XG4gICAgcGFja2V0LmlkID0gdGhpcy5pZHMrKztcbiAgfVxuXG4gIGlmICh0aGlzLmNvbm5lY3RlZCkge1xuICAgIHRoaXMucGFja2V0KHBhY2tldCk7XG4gIH0gZWxzZSB7XG4gICAgdGhpcy5zZW5kQnVmZmVyLnB1c2gocGFja2V0KTtcbiAgfVxuXG4gIGRlbGV0ZSB0aGlzLmZsYWdzO1xuXG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBTZW5kcyBhIHBhY2tldC5cbiAqXG4gKiBAcGFyYW0ge09iamVjdH0gcGFja2V0XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLnBhY2tldCA9IGZ1bmN0aW9uIChwYWNrZXQpIHtcbiAgcGFja2V0Lm5zcCA9IHRoaXMubnNwO1xuICB0aGlzLmlvLnBhY2tldChwYWNrZXQpO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgdXBvbiBlbmdpbmUgYG9wZW5gLlxuICpcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25vcGVuID0gZnVuY3Rpb24gKCkge1xuICBkZWJ1ZygndHJhbnNwb3J0IGlzIG9wZW4gLSBjb25uZWN0aW5nJyk7XG5cbiAgLy8gd3JpdGUgY29ubmVjdCBwYWNrZXQgaWYgbmVjZXNzYXJ5XG4gIGlmICgnLycgIT09IHRoaXMubnNwKSB7XG4gICAgaWYgKHRoaXMucXVlcnkpIHtcbiAgICAgIHRoaXMucGFja2V0KHt0eXBlOiBwYXJzZXIuQ09OTkVDVCwgcXVlcnk6IHRoaXMucXVlcnl9KTtcbiAgICB9IGVsc2Uge1xuICAgICAgdGhpcy5wYWNrZXQoe3R5cGU6IHBhcnNlci5DT05ORUNUfSk7XG4gICAgfVxuICB9XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIGVuZ2luZSBgY2xvc2VgLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSByZWFzb25cbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25jbG9zZSA9IGZ1bmN0aW9uIChyZWFzb24pIHtcbiAgZGVidWcoJ2Nsb3NlICglcyknLCByZWFzb24pO1xuICB0aGlzLmNvbm5lY3RlZCA9IGZhbHNlO1xuICB0aGlzLmRpc2Nvbm5lY3RlZCA9IHRydWU7XG4gIGRlbGV0ZSB0aGlzLmlkO1xuICB0aGlzLmVtaXQoJ2Rpc2Nvbm5lY3QnLCByZWFzb24pO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgd2l0aCBzb2NrZXQgcGFja2V0LlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBwYWNrZXRcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25wYWNrZXQgPSBmdW5jdGlvbiAocGFja2V0KSB7XG4gIGlmIChwYWNrZXQubnNwICE9PSB0aGlzLm5zcCkgcmV0dXJuO1xuXG4gIHN3aXRjaCAocGFja2V0LnR5cGUpIHtcbiAgICBjYXNlIHBhcnNlci5DT05ORUNUOlxuICAgICAgdGhpcy5vbmNvbm5lY3QoKTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSBwYXJzZXIuRVZFTlQ6XG4gICAgICB0aGlzLm9uZXZlbnQocGFja2V0KTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSBwYXJzZXIuQklOQVJZX0VWRU5UOlxuICAgICAgdGhpcy5vbmV2ZW50KHBhY2tldCk7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgcGFyc2VyLkFDSzpcbiAgICAgIHRoaXMub25hY2socGFja2V0KTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSBwYXJzZXIuQklOQVJZX0FDSzpcbiAgICAgIHRoaXMub25hY2socGFja2V0KTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSBwYXJzZXIuRElTQ09OTkVDVDpcbiAgICAgIHRoaXMub25kaXNjb25uZWN0KCk7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgcGFyc2VyLkVSUk9SOlxuICAgICAgdGhpcy5lbWl0KCdlcnJvcicsIHBhY2tldC5kYXRhKTtcbiAgICAgIGJyZWFrO1xuICB9XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIGEgc2VydmVyIGV2ZW50LlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBwYWNrZXRcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cblNvY2tldC5wcm90b3R5cGUub25ldmVudCA9IGZ1bmN0aW9uIChwYWNrZXQpIHtcbiAgdmFyIGFyZ3MgPSBwYWNrZXQuZGF0YSB8fCBbXTtcbiAgZGVidWcoJ2VtaXR0aW5nIGV2ZW50ICVqJywgYXJncyk7XG5cbiAgaWYgKG51bGwgIT0gcGFja2V0LmlkKSB7XG4gICAgZGVidWcoJ2F0dGFjaGluZyBhY2sgY2FsbGJhY2sgdG8gZXZlbnQnKTtcbiAgICBhcmdzLnB1c2godGhpcy5hY2socGFja2V0LmlkKSk7XG4gIH1cblxuICBpZiAodGhpcy5jb25uZWN0ZWQpIHtcbiAgICBlbWl0LmFwcGx5KHRoaXMsIGFyZ3MpO1xuICB9IGVsc2Uge1xuICAgIHRoaXMucmVjZWl2ZUJ1ZmZlci5wdXNoKGFyZ3MpO1xuICB9XG59O1xuXG4vKipcbiAqIFByb2R1Y2VzIGFuIGFjayBjYWxsYmFjayB0byBlbWl0IHdpdGggYW4gZXZlbnQuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5hY2sgPSBmdW5jdGlvbiAoaWQpIHtcbiAgdmFyIHNlbGYgPSB0aGlzO1xuICB2YXIgc2VudCA9IGZhbHNlO1xuICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgIC8vIHByZXZlbnQgZG91YmxlIGNhbGxiYWNrc1xuICAgIGlmIChzZW50KSByZXR1cm47XG4gICAgc2VudCA9IHRydWU7XG4gICAgdmFyIGFyZ3MgPSB0b0FycmF5KGFyZ3VtZW50cyk7XG4gICAgZGVidWcoJ3NlbmRpbmcgYWNrICVqJywgYXJncyk7XG5cbiAgICB2YXIgdHlwZSA9IGhhc0JpbihhcmdzKSA/IHBhcnNlci5CSU5BUllfQUNLIDogcGFyc2VyLkFDSztcbiAgICBzZWxmLnBhY2tldCh7XG4gICAgICB0eXBlOiB0eXBlLFxuICAgICAgaWQ6IGlkLFxuICAgICAgZGF0YTogYXJnc1xuICAgIH0pO1xuICB9O1xufTtcblxuLyoqXG4gKiBDYWxsZWQgdXBvbiBhIHNlcnZlciBhY2tub3dsZWdlbWVudC5cbiAqXG4gKiBAcGFyYW0ge09iamVjdH0gcGFja2V0XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLm9uYWNrID0gZnVuY3Rpb24gKHBhY2tldCkge1xuICB2YXIgYWNrID0gdGhpcy5hY2tzW3BhY2tldC5pZF07XG4gIGlmICgnZnVuY3Rpb24nID09PSB0eXBlb2YgYWNrKSB7XG4gICAgZGVidWcoJ2NhbGxpbmcgYWNrICVzIHdpdGggJWonLCBwYWNrZXQuaWQsIHBhY2tldC5kYXRhKTtcbiAgICBhY2suYXBwbHkodGhpcywgcGFja2V0LmRhdGEpO1xuICAgIGRlbGV0ZSB0aGlzLmFja3NbcGFja2V0LmlkXTtcbiAgfSBlbHNlIHtcbiAgICBkZWJ1ZygnYmFkIGFjayAlcycsIHBhY2tldC5pZCk7XG4gIH1cbn07XG5cbi8qKlxuICogQ2FsbGVkIHVwb24gc2VydmVyIGNvbm5lY3QuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5vbmNvbm5lY3QgPSBmdW5jdGlvbiAoKSB7XG4gIHRoaXMuY29ubmVjdGVkID0gdHJ1ZTtcbiAgdGhpcy5kaXNjb25uZWN0ZWQgPSBmYWxzZTtcbiAgdGhpcy5lbWl0KCdjb25uZWN0Jyk7XG4gIHRoaXMuZW1pdEJ1ZmZlcmVkKCk7XG59O1xuXG4vKipcbiAqIEVtaXQgYnVmZmVyZWQgZXZlbnRzIChyZWNlaXZlZCBhbmQgZW1pdHRlZCkuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5lbWl0QnVmZmVyZWQgPSBmdW5jdGlvbiAoKSB7XG4gIHZhciBpO1xuICBmb3IgKGkgPSAwOyBpIDwgdGhpcy5yZWNlaXZlQnVmZmVyLmxlbmd0aDsgaSsrKSB7XG4gICAgZW1pdC5hcHBseSh0aGlzLCB0aGlzLnJlY2VpdmVCdWZmZXJbaV0pO1xuICB9XG4gIHRoaXMucmVjZWl2ZUJ1ZmZlciA9IFtdO1xuXG4gIGZvciAoaSA9IDA7IGkgPCB0aGlzLnNlbmRCdWZmZXIubGVuZ3RoOyBpKyspIHtcbiAgICB0aGlzLnBhY2tldCh0aGlzLnNlbmRCdWZmZXJbaV0pO1xuICB9XG4gIHRoaXMuc2VuZEJ1ZmZlciA9IFtdO1xufTtcblxuLyoqXG4gKiBDYWxsZWQgdXBvbiBzZXJ2ZXIgZGlzY29ubmVjdC5cbiAqXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLm9uZGlzY29ubmVjdCA9IGZ1bmN0aW9uICgpIHtcbiAgZGVidWcoJ3NlcnZlciBkaXNjb25uZWN0ICglcyknLCB0aGlzLm5zcCk7XG4gIHRoaXMuZGVzdHJveSgpO1xuICB0aGlzLm9uY2xvc2UoJ2lvIHNlcnZlciBkaXNjb25uZWN0Jyk7XG59O1xuXG4vKipcbiAqIENhbGxlZCB1cG9uIGZvcmNlZCBjbGllbnQvc2VydmVyIHNpZGUgZGlzY29ubmVjdGlvbnMsXG4gKiB0aGlzIG1ldGhvZCBlbnN1cmVzIHRoZSBtYW5hZ2VyIHN0b3BzIHRyYWNraW5nIHVzIGFuZFxuICogdGhhdCByZWNvbm5lY3Rpb25zIGRvbid0IGdldCB0cmlnZ2VyZWQgZm9yIHRoaXMuXG4gKlxuICogQGFwaSBwcml2YXRlLlxuICovXG5cblNvY2tldC5wcm90b3R5cGUuZGVzdHJveSA9IGZ1bmN0aW9uICgpIHtcbiAgaWYgKHRoaXMuc3Vicykge1xuICAgIC8vIGNsZWFuIHN1YnNjcmlwdGlvbnMgdG8gYXZvaWQgcmVjb25uZWN0aW9uc1xuICAgIGZvciAodmFyIGkgPSAwOyBpIDwgdGhpcy5zdWJzLmxlbmd0aDsgaSsrKSB7XG4gICAgICB0aGlzLnN1YnNbaV0uZGVzdHJveSgpO1xuICAgIH1cbiAgICB0aGlzLnN1YnMgPSBudWxsO1xuICB9XG5cbiAgdGhpcy5pby5kZXN0cm95KHRoaXMpO1xufTtcblxuLyoqXG4gKiBEaXNjb25uZWN0cyB0aGUgc29ja2V0IG1hbnVhbGx5LlxuICpcbiAqIEByZXR1cm4ge1NvY2tldH0gc2VsZlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5Tb2NrZXQucHJvdG90eXBlLmNsb3NlID1cblNvY2tldC5wcm90b3R5cGUuZGlzY29ubmVjdCA9IGZ1bmN0aW9uICgpIHtcbiAgaWYgKHRoaXMuY29ubmVjdGVkKSB7XG4gICAgZGVidWcoJ3BlcmZvcm1pbmcgZGlzY29ubmVjdCAoJXMpJywgdGhpcy5uc3ApO1xuICAgIHRoaXMucGFja2V0KHsgdHlwZTogcGFyc2VyLkRJU0NPTk5FQ1QgfSk7XG4gIH1cblxuICAvLyByZW1vdmUgc29ja2V0IGZyb20gcG9vbFxuICB0aGlzLmRlc3Ryb3koKTtcblxuICBpZiAodGhpcy5jb25uZWN0ZWQpIHtcbiAgICAvLyBmaXJlIGV2ZW50c1xuICAgIHRoaXMub25jbG9zZSgnaW8gY2xpZW50IGRpc2Nvbm5lY3QnKTtcbiAgfVxuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogU2V0cyB0aGUgY29tcHJlc3MgZmxhZy5cbiAqXG4gKiBAcGFyYW0ge0Jvb2xlYW59IGlmIGB0cnVlYCwgY29tcHJlc3NlcyB0aGUgc2VuZGluZyBkYXRhXG4gKiBAcmV0dXJuIHtTb2NrZXR9IHNlbGZcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuU29ja2V0LnByb3RvdHlwZS5jb21wcmVzcyA9IGZ1bmN0aW9uIChjb21wcmVzcykge1xuICB0aGlzLmZsYWdzID0gdGhpcy5mbGFncyB8fCB7fTtcbiAgdGhpcy5mbGFncy5jb21wcmVzcyA9IGNvbXByZXNzO1xuICByZXR1cm4gdGhpcztcbn07XG4iLCJcbi8qKlxuICogTW9kdWxlIGRlcGVuZGVuY2llcy5cbiAqL1xuXG52YXIgcGFyc2V1cmkgPSByZXF1aXJlKCdwYXJzZXVyaScpO1xudmFyIGRlYnVnID0gcmVxdWlyZSgnZGVidWcnKSgnc29ja2V0LmlvLWNsaWVudDp1cmwnKTtcblxuLyoqXG4gKiBNb2R1bGUgZXhwb3J0cy5cbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IHVybDtcblxuLyoqXG4gKiBVUkwgcGFyc2VyLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSB1cmxcbiAqIEBwYXJhbSB7T2JqZWN0fSBBbiBvYmplY3QgbWVhbnQgdG8gbWltaWMgd2luZG93LmxvY2F0aW9uLlxuICogICAgICAgICAgICAgICAgIERlZmF1bHRzIHRvIHdpbmRvdy5sb2NhdGlvbi5cbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gdXJsICh1cmksIGxvYykge1xuICB2YXIgb2JqID0gdXJpO1xuXG4gIC8vIGRlZmF1bHQgdG8gd2luZG93LmxvY2F0aW9uXG4gIGxvYyA9IGxvYyB8fCBnbG9iYWwubG9jYXRpb247XG4gIGlmIChudWxsID09IHVyaSkgdXJpID0gbG9jLnByb3RvY29sICsgJy8vJyArIGxvYy5ob3N0O1xuXG4gIC8vIHJlbGF0aXZlIHBhdGggc3VwcG9ydFxuICBpZiAoJ3N0cmluZycgPT09IHR5cGVvZiB1cmkpIHtcbiAgICBpZiAoJy8nID09PSB1cmkuY2hhckF0KDApKSB7XG4gICAgICBpZiAoJy8nID09PSB1cmkuY2hhckF0KDEpKSB7XG4gICAgICAgIHVyaSA9IGxvYy5wcm90b2NvbCArIHVyaTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHVyaSA9IGxvYy5ob3N0ICsgdXJpO1xuICAgICAgfVxuICAgIH1cblxuICAgIGlmICghL14oaHR0cHM/fHdzcz8pOlxcL1xcLy8udGVzdCh1cmkpKSB7XG4gICAgICBkZWJ1ZygncHJvdG9jb2wtbGVzcyB1cmwgJXMnLCB1cmkpO1xuICAgICAgaWYgKCd1bmRlZmluZWQnICE9PSB0eXBlb2YgbG9jKSB7XG4gICAgICAgIHVyaSA9IGxvYy5wcm90b2NvbCArICcvLycgKyB1cmk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICB1cmkgPSAnaHR0cHM6Ly8nICsgdXJpO1xuICAgICAgfVxuICAgIH1cblxuICAgIC8vIHBhcnNlXG4gICAgZGVidWcoJ3BhcnNlICVzJywgdXJpKTtcbiAgICBvYmogPSBwYXJzZXVyaSh1cmkpO1xuICB9XG5cbiAgLy8gbWFrZSBzdXJlIHdlIHRyZWF0IGBsb2NhbGhvc3Q6ODBgIGFuZCBgbG9jYWxob3N0YCBlcXVhbGx5XG4gIGlmICghb2JqLnBvcnQpIHtcbiAgICBpZiAoL14oaHR0cHx3cykkLy50ZXN0KG9iai5wcm90b2NvbCkpIHtcbiAgICAgIG9iai5wb3J0ID0gJzgwJztcbiAgICB9IGVsc2UgaWYgKC9eKGh0dHB8d3MpcyQvLnRlc3Qob2JqLnByb3RvY29sKSkge1xuICAgICAgb2JqLnBvcnQgPSAnNDQzJztcbiAgICB9XG4gIH1cblxuICBvYmoucGF0aCA9IG9iai5wYXRoIHx8ICcvJztcblxuICB2YXIgaXB2NiA9IG9iai5ob3N0LmluZGV4T2YoJzonKSAhPT0gLTE7XG4gIHZhciBob3N0ID0gaXB2NiA/ICdbJyArIG9iai5ob3N0ICsgJ10nIDogb2JqLmhvc3Q7XG5cbiAgLy8gZGVmaW5lIHVuaXF1ZSBpZFxuICBvYmouaWQgPSBvYmoucHJvdG9jb2wgKyAnOi8vJyArIGhvc3QgKyAnOicgKyBvYmoucG9ydDtcbiAgLy8gZGVmaW5lIGhyZWZcbiAgb2JqLmhyZWYgPSBvYmoucHJvdG9jb2wgKyAnOi8vJyArIGhvc3QgKyAobG9jICYmIGxvYy5wb3J0ID09PSBvYmoucG9ydCA/ICcnIDogKCc6JyArIG9iai5wb3J0KSk7XG5cbiAgcmV0dXJuIG9iajtcbn1cbiIsIlxuLyoqXG4gKiBUaGlzIGlzIHRoZSB3ZWIgYnJvd3NlciBpbXBsZW1lbnRhdGlvbiBvZiBgZGVidWcoKWAuXG4gKlxuICogRXhwb3NlIGBkZWJ1ZygpYCBhcyB0aGUgbW9kdWxlLlxuICovXG5cbmV4cG9ydHMgPSBtb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoJy4vZGVidWcnKTtcbmV4cG9ydHMubG9nID0gbG9nO1xuZXhwb3J0cy5mb3JtYXRBcmdzID0gZm9ybWF0QXJncztcbmV4cG9ydHMuc2F2ZSA9IHNhdmU7XG5leHBvcnRzLmxvYWQgPSBsb2FkO1xuZXhwb3J0cy51c2VDb2xvcnMgPSB1c2VDb2xvcnM7XG5leHBvcnRzLnN0b3JhZ2UgPSAndW5kZWZpbmVkJyAhPSB0eXBlb2YgY2hyb21lXG4gICAgICAgICAgICAgICAmJiAndW5kZWZpbmVkJyAhPSB0eXBlb2YgY2hyb21lLnN0b3JhZ2VcbiAgICAgICAgICAgICAgICAgID8gY2hyb21lLnN0b3JhZ2UubG9jYWxcbiAgICAgICAgICAgICAgICAgIDogbG9jYWxzdG9yYWdlKCk7XG5cbi8qKlxuICogQ29sb3JzLlxuICovXG5cbmV4cG9ydHMuY29sb3JzID0gW1xuICAnbGlnaHRzZWFncmVlbicsXG4gICdmb3Jlc3RncmVlbicsXG4gICdnb2xkZW5yb2QnLFxuICAnZG9kZ2VyYmx1ZScsXG4gICdkYXJrb3JjaGlkJyxcbiAgJ2NyaW1zb24nXG5dO1xuXG4vKipcbiAqIEN1cnJlbnRseSBvbmx5IFdlYktpdC1iYXNlZCBXZWIgSW5zcGVjdG9ycywgRmlyZWZveCA+PSB2MzEsXG4gKiBhbmQgdGhlIEZpcmVidWcgZXh0ZW5zaW9uIChhbnkgRmlyZWZveCB2ZXJzaW9uKSBhcmUga25vd25cbiAqIHRvIHN1cHBvcnQgXCIlY1wiIENTUyBjdXN0b21pemF0aW9ucy5cbiAqXG4gKiBUT0RPOiBhZGQgYSBgbG9jYWxTdG9yYWdlYCB2YXJpYWJsZSB0byBleHBsaWNpdGx5IGVuYWJsZS9kaXNhYmxlIGNvbG9yc1xuICovXG5cbmZ1bmN0aW9uIHVzZUNvbG9ycygpIHtcbiAgLy8gaXMgd2Via2l0PyBodHRwOi8vc3RhY2tvdmVyZmxvdy5jb20vYS8xNjQ1OTYwNi8zNzY3NzNcbiAgLy8gZG9jdW1lbnQgaXMgdW5kZWZpbmVkIGluIHJlYWN0LW5hdGl2ZTogaHR0cHM6Ly9naXRodWIuY29tL2ZhY2Vib29rL3JlYWN0LW5hdGl2ZS9wdWxsLzE2MzJcbiAgcmV0dXJuICh0eXBlb2YgZG9jdW1lbnQgIT09ICd1bmRlZmluZWQnICYmICdXZWJraXRBcHBlYXJhbmNlJyBpbiBkb2N1bWVudC5kb2N1bWVudEVsZW1lbnQuc3R5bGUpIHx8XG4gICAgLy8gaXMgZmlyZWJ1Zz8gaHR0cDovL3N0YWNrb3ZlcmZsb3cuY29tL2EvMzk4MTIwLzM3Njc3M1xuICAgICh3aW5kb3cuY29uc29sZSAmJiAoY29uc29sZS5maXJlYnVnIHx8IChjb25zb2xlLmV4Y2VwdGlvbiAmJiBjb25zb2xlLnRhYmxlKSkpIHx8XG4gICAgLy8gaXMgZmlyZWZveCA+PSB2MzE/XG4gICAgLy8gaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9Ub29scy9XZWJfQ29uc29sZSNTdHlsaW5nX21lc3NhZ2VzXG4gICAgKG5hdmlnYXRvci51c2VyQWdlbnQudG9Mb3dlckNhc2UoKS5tYXRjaCgvZmlyZWZveFxcLyhcXGQrKS8pICYmIHBhcnNlSW50KFJlZ0V4cC4kMSwgMTApID49IDMxKTtcbn1cblxuLyoqXG4gKiBNYXAgJWogdG8gYEpTT04uc3RyaW5naWZ5KClgLCBzaW5jZSBubyBXZWIgSW5zcGVjdG9ycyBkbyB0aGF0IGJ5IGRlZmF1bHQuXG4gKi9cblxuZXhwb3J0cy5mb3JtYXR0ZXJzLmogPSBmdW5jdGlvbih2KSB7XG4gIHRyeSB7XG4gICAgcmV0dXJuIEpTT04uc3RyaW5naWZ5KHYpO1xuICB9IGNhdGNoIChlcnIpIHtcbiAgICByZXR1cm4gJ1tVbmV4cGVjdGVkSlNPTlBhcnNlRXJyb3JdOiAnICsgZXJyLm1lc3NhZ2U7XG4gIH1cbn07XG5cblxuLyoqXG4gKiBDb2xvcml6ZSBsb2cgYXJndW1lbnRzIGlmIGVuYWJsZWQuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBmb3JtYXRBcmdzKCkge1xuICB2YXIgYXJncyA9IGFyZ3VtZW50cztcbiAgdmFyIHVzZUNvbG9ycyA9IHRoaXMudXNlQ29sb3JzO1xuXG4gIGFyZ3NbMF0gPSAodXNlQ29sb3JzID8gJyVjJyA6ICcnKVxuICAgICsgdGhpcy5uYW1lc3BhY2VcbiAgICArICh1c2VDb2xvcnMgPyAnICVjJyA6ICcgJylcbiAgICArIGFyZ3NbMF1cbiAgICArICh1c2VDb2xvcnMgPyAnJWMgJyA6ICcgJylcbiAgICArICcrJyArIGV4cG9ydHMuaHVtYW5pemUodGhpcy5kaWZmKTtcblxuICBpZiAoIXVzZUNvbG9ycykgcmV0dXJuIGFyZ3M7XG5cbiAgdmFyIGMgPSAnY29sb3I6ICcgKyB0aGlzLmNvbG9yO1xuICBhcmdzID0gW2FyZ3NbMF0sIGMsICdjb2xvcjogaW5oZXJpdCddLmNvbmNhdChBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmdzLCAxKSk7XG5cbiAgLy8gdGhlIGZpbmFsIFwiJWNcIiBpcyBzb21ld2hhdCB0cmlja3ksIGJlY2F1c2UgdGhlcmUgY291bGQgYmUgb3RoZXJcbiAgLy8gYXJndW1lbnRzIHBhc3NlZCBlaXRoZXIgYmVmb3JlIG9yIGFmdGVyIHRoZSAlYywgc28gd2UgbmVlZCB0b1xuICAvLyBmaWd1cmUgb3V0IHRoZSBjb3JyZWN0IGluZGV4IHRvIGluc2VydCB0aGUgQ1NTIGludG9cbiAgdmFyIGluZGV4ID0gMDtcbiAgdmFyIGxhc3RDID0gMDtcbiAgYXJnc1swXS5yZXBsYWNlKC8lW2EteiVdL2csIGZ1bmN0aW9uKG1hdGNoKSB7XG4gICAgaWYgKCclJScgPT09IG1hdGNoKSByZXR1cm47XG4gICAgaW5kZXgrKztcbiAgICBpZiAoJyVjJyA9PT0gbWF0Y2gpIHtcbiAgICAgIC8vIHdlIG9ubHkgYXJlIGludGVyZXN0ZWQgaW4gdGhlICpsYXN0KiAlY1xuICAgICAgLy8gKHRoZSB1c2VyIG1heSBoYXZlIHByb3ZpZGVkIHRoZWlyIG93bilcbiAgICAgIGxhc3RDID0gaW5kZXg7XG4gICAgfVxuICB9KTtcblxuICBhcmdzLnNwbGljZShsYXN0QywgMCwgYyk7XG4gIHJldHVybiBhcmdzO1xufVxuXG4vKipcbiAqIEludm9rZXMgYGNvbnNvbGUubG9nKClgIHdoZW4gYXZhaWxhYmxlLlxuICogTm8tb3Agd2hlbiBgY29uc29sZS5sb2dgIGlzIG5vdCBhIFwiZnVuY3Rpb25cIi5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGxvZygpIHtcbiAgLy8gdGhpcyBoYWNrZXJ5IGlzIHJlcXVpcmVkIGZvciBJRTgvOSwgd2hlcmVcbiAgLy8gdGhlIGBjb25zb2xlLmxvZ2AgZnVuY3Rpb24gZG9lc24ndCBoYXZlICdhcHBseSdcbiAgcmV0dXJuICdvYmplY3QnID09PSB0eXBlb2YgY29uc29sZVxuICAgICYmIGNvbnNvbGUubG9nXG4gICAgJiYgRnVuY3Rpb24ucHJvdG90eXBlLmFwcGx5LmNhbGwoY29uc29sZS5sb2csIGNvbnNvbGUsIGFyZ3VtZW50cyk7XG59XG5cbi8qKlxuICogU2F2ZSBgbmFtZXNwYWNlc2AuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IG5hbWVzcGFjZXNcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIHNhdmUobmFtZXNwYWNlcykge1xuICB0cnkge1xuICAgIGlmIChudWxsID09IG5hbWVzcGFjZXMpIHtcbiAgICAgIGV4cG9ydHMuc3RvcmFnZS5yZW1vdmVJdGVtKCdkZWJ1ZycpO1xuICAgIH0gZWxzZSB7XG4gICAgICBleHBvcnRzLnN0b3JhZ2UuZGVidWcgPSBuYW1lc3BhY2VzO1xuICAgIH1cbiAgfSBjYXRjaChlKSB7fVxufVxuXG4vKipcbiAqIExvYWQgYG5hbWVzcGFjZXNgLlxuICpcbiAqIEByZXR1cm4ge1N0cmluZ30gcmV0dXJucyB0aGUgcHJldmlvdXNseSBwZXJzaXN0ZWQgZGVidWcgbW9kZXNcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIGxvYWQoKSB7XG4gIHZhciByO1xuICB0cnkge1xuICAgIHJldHVybiBleHBvcnRzLnN0b3JhZ2UuZGVidWc7XG4gIH0gY2F0Y2goZSkge31cblxuICAvLyBJZiBkZWJ1ZyBpc24ndCBzZXQgaW4gTFMsIGFuZCB3ZSdyZSBpbiBFbGVjdHJvbiwgdHJ5IHRvIGxvYWQgJERFQlVHXG4gIGlmICh0eXBlb2YgcHJvY2VzcyAhPT0gJ3VuZGVmaW5lZCcgJiYgJ2VudicgaW4gcHJvY2Vzcykge1xuICAgIHJldHVybiBwcm9jZXNzLmVudi5ERUJVRztcbiAgfVxufVxuXG4vKipcbiAqIEVuYWJsZSBuYW1lc3BhY2VzIGxpc3RlZCBpbiBgbG9jYWxTdG9yYWdlLmRlYnVnYCBpbml0aWFsbHkuXG4gKi9cblxuZXhwb3J0cy5lbmFibGUobG9hZCgpKTtcblxuLyoqXG4gKiBMb2NhbHN0b3JhZ2UgYXR0ZW1wdHMgdG8gcmV0dXJuIHRoZSBsb2NhbHN0b3JhZ2UuXG4gKlxuICogVGhpcyBpcyBuZWNlc3NhcnkgYmVjYXVzZSBzYWZhcmkgdGhyb3dzXG4gKiB3aGVuIGEgdXNlciBkaXNhYmxlcyBjb29raWVzL2xvY2Fsc3RvcmFnZVxuICogYW5kIHlvdSBhdHRlbXB0IHRvIGFjY2VzcyBpdC5cbiAqXG4gKiBAcmV0dXJuIHtMb2NhbFN0b3JhZ2V9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBsb2NhbHN0b3JhZ2UoKXtcbiAgdHJ5IHtcbiAgICByZXR1cm4gd2luZG93LmxvY2FsU3RvcmFnZTtcbiAgfSBjYXRjaCAoZSkge31cbn1cbiIsIi8qZ2xvYmFsIEJsb2IsRmlsZSovXG5cbi8qKlxuICogTW9kdWxlIHJlcXVpcmVtZW50c1xuICovXG5cbnZhciBpc0FycmF5ID0gcmVxdWlyZSgnaXNhcnJheScpO1xudmFyIGlzQnVmID0gcmVxdWlyZSgnLi9pcy1idWZmZXInKTtcblxuLyoqXG4gKiBSZXBsYWNlcyBldmVyeSBCdWZmZXIgfCBBcnJheUJ1ZmZlciBpbiBwYWNrZXQgd2l0aCBhIG51bWJlcmVkIHBsYWNlaG9sZGVyLlxuICogQW55dGhpbmcgd2l0aCBibG9icyBvciBmaWxlcyBzaG91bGQgYmUgZmVkIHRocm91Z2ggcmVtb3ZlQmxvYnMgYmVmb3JlIGNvbWluZ1xuICogaGVyZS5cbiAqXG4gKiBAcGFyYW0ge09iamVjdH0gcGFja2V0IC0gc29ja2V0LmlvIGV2ZW50IHBhY2tldFxuICogQHJldHVybiB7T2JqZWN0fSB3aXRoIGRlY29uc3RydWN0ZWQgcGFja2V0IGFuZCBsaXN0IG9mIGJ1ZmZlcnNcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5kZWNvbnN0cnVjdFBhY2tldCA9IGZ1bmN0aW9uKHBhY2tldCl7XG4gIHZhciBidWZmZXJzID0gW107XG4gIHZhciBwYWNrZXREYXRhID0gcGFja2V0LmRhdGE7XG5cbiAgZnVuY3Rpb24gX2RlY29uc3RydWN0UGFja2V0KGRhdGEpIHtcbiAgICBpZiAoIWRhdGEpIHJldHVybiBkYXRhO1xuXG4gICAgaWYgKGlzQnVmKGRhdGEpKSB7XG4gICAgICB2YXIgcGxhY2Vob2xkZXIgPSB7IF9wbGFjZWhvbGRlcjogdHJ1ZSwgbnVtOiBidWZmZXJzLmxlbmd0aCB9O1xuICAgICAgYnVmZmVycy5wdXNoKGRhdGEpO1xuICAgICAgcmV0dXJuIHBsYWNlaG9sZGVyO1xuICAgIH0gZWxzZSBpZiAoaXNBcnJheShkYXRhKSkge1xuICAgICAgdmFyIG5ld0RhdGEgPSBuZXcgQXJyYXkoZGF0YS5sZW5ndGgpO1xuICAgICAgZm9yICh2YXIgaSA9IDA7IGkgPCBkYXRhLmxlbmd0aDsgaSsrKSB7XG4gICAgICAgIG5ld0RhdGFbaV0gPSBfZGVjb25zdHJ1Y3RQYWNrZXQoZGF0YVtpXSk7XG4gICAgICB9XG4gICAgICByZXR1cm4gbmV3RGF0YTtcbiAgICB9IGVsc2UgaWYgKCdvYmplY3QnID09IHR5cGVvZiBkYXRhICYmICEoZGF0YSBpbnN0YW5jZW9mIERhdGUpKSB7XG4gICAgICB2YXIgbmV3RGF0YSA9IHt9O1xuICAgICAgZm9yICh2YXIga2V5IGluIGRhdGEpIHtcbiAgICAgICAgbmV3RGF0YVtrZXldID0gX2RlY29uc3RydWN0UGFja2V0KGRhdGFba2V5XSk7XG4gICAgICB9XG4gICAgICByZXR1cm4gbmV3RGF0YTtcbiAgICB9XG4gICAgcmV0dXJuIGRhdGE7XG4gIH1cblxuICB2YXIgcGFjayA9IHBhY2tldDtcbiAgcGFjay5kYXRhID0gX2RlY29uc3RydWN0UGFja2V0KHBhY2tldERhdGEpO1xuICBwYWNrLmF0dGFjaG1lbnRzID0gYnVmZmVycy5sZW5ndGg7IC8vIG51bWJlciBvZiBiaW5hcnkgJ2F0dGFjaG1lbnRzJ1xuICByZXR1cm4ge3BhY2tldDogcGFjaywgYnVmZmVyczogYnVmZmVyc307XG59O1xuXG4vKipcbiAqIFJlY29uc3RydWN0cyBhIGJpbmFyeSBwYWNrZXQgZnJvbSBpdHMgcGxhY2Vob2xkZXIgcGFja2V0IGFuZCBidWZmZXJzXG4gKlxuICogQHBhcmFtIHtPYmplY3R9IHBhY2tldCAtIGV2ZW50IHBhY2tldCB3aXRoIHBsYWNlaG9sZGVyc1xuICogQHBhcmFtIHtBcnJheX0gYnVmZmVycyAtIGJpbmFyeSBidWZmZXJzIHRvIHB1dCBpbiBwbGFjZWhvbGRlciBwb3NpdGlvbnNcbiAqIEByZXR1cm4ge09iamVjdH0gcmVjb25zdHJ1Y3RlZCBwYWNrZXRcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5yZWNvbnN0cnVjdFBhY2tldCA9IGZ1bmN0aW9uKHBhY2tldCwgYnVmZmVycykge1xuICB2YXIgY3VyUGxhY2VIb2xkZXIgPSAwO1xuXG4gIGZ1bmN0aW9uIF9yZWNvbnN0cnVjdFBhY2tldChkYXRhKSB7XG4gICAgaWYgKGRhdGEgJiYgZGF0YS5fcGxhY2Vob2xkZXIpIHtcbiAgICAgIHZhciBidWYgPSBidWZmZXJzW2RhdGEubnVtXTsgLy8gYXBwcm9wcmlhdGUgYnVmZmVyIChzaG91bGQgYmUgbmF0dXJhbCBvcmRlciBhbnl3YXkpXG4gICAgICByZXR1cm4gYnVmO1xuICAgIH0gZWxzZSBpZiAoaXNBcnJheShkYXRhKSkge1xuICAgICAgZm9yICh2YXIgaSA9IDA7IGkgPCBkYXRhLmxlbmd0aDsgaSsrKSB7XG4gICAgICAgIGRhdGFbaV0gPSBfcmVjb25zdHJ1Y3RQYWNrZXQoZGF0YVtpXSk7XG4gICAgICB9XG4gICAgICByZXR1cm4gZGF0YTtcbiAgICB9IGVsc2UgaWYgKGRhdGEgJiYgJ29iamVjdCcgPT0gdHlwZW9mIGRhdGEpIHtcbiAgICAgIGZvciAodmFyIGtleSBpbiBkYXRhKSB7XG4gICAgICAgIGRhdGFba2V5XSA9IF9yZWNvbnN0cnVjdFBhY2tldChkYXRhW2tleV0pO1xuICAgICAgfVxuICAgICAgcmV0dXJuIGRhdGE7XG4gICAgfVxuICAgIHJldHVybiBkYXRhO1xuICB9XG5cbiAgcGFja2V0LmRhdGEgPSBfcmVjb25zdHJ1Y3RQYWNrZXQocGFja2V0LmRhdGEpO1xuICBwYWNrZXQuYXR0YWNobWVudHMgPSB1bmRlZmluZWQ7IC8vIG5vIGxvbmdlciB1c2VmdWxcbiAgcmV0dXJuIHBhY2tldDtcbn07XG5cbi8qKlxuICogQXN5bmNocm9ub3VzbHkgcmVtb3ZlcyBCbG9icyBvciBGaWxlcyBmcm9tIGRhdGEgdmlhXG4gKiBGaWxlUmVhZGVyJ3MgcmVhZEFzQXJyYXlCdWZmZXIgbWV0aG9kLiBVc2VkIGJlZm9yZSBlbmNvZGluZ1xuICogZGF0YSBhcyBtc2dwYWNrLiBDYWxscyBjYWxsYmFjayB3aXRoIHRoZSBibG9ibGVzcyBkYXRhLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBkYXRhXG4gKiBAcGFyYW0ge0Z1bmN0aW9ufSBjYWxsYmFja1xuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZXhwb3J0cy5yZW1vdmVCbG9icyA9IGZ1bmN0aW9uKGRhdGEsIGNhbGxiYWNrKSB7XG4gIGZ1bmN0aW9uIF9yZW1vdmVCbG9icyhvYmosIGN1cktleSwgY29udGFpbmluZ09iamVjdCkge1xuICAgIGlmICghb2JqKSByZXR1cm4gb2JqO1xuXG4gICAgLy8gY29udmVydCBhbnkgYmxvYlxuICAgIGlmICgoZ2xvYmFsLkJsb2IgJiYgb2JqIGluc3RhbmNlb2YgQmxvYikgfHxcbiAgICAgICAgKGdsb2JhbC5GaWxlICYmIG9iaiBpbnN0YW5jZW9mIEZpbGUpKSB7XG4gICAgICBwZW5kaW5nQmxvYnMrKztcblxuICAgICAgLy8gYXN5bmMgZmlsZXJlYWRlclxuICAgICAgdmFyIGZpbGVSZWFkZXIgPSBuZXcgRmlsZVJlYWRlcigpO1xuICAgICAgZmlsZVJlYWRlci5vbmxvYWQgPSBmdW5jdGlvbigpIHsgLy8gdGhpcy5yZXN1bHQgPT0gYXJyYXlidWZmZXJcbiAgICAgICAgaWYgKGNvbnRhaW5pbmdPYmplY3QpIHtcbiAgICAgICAgICBjb250YWluaW5nT2JqZWN0W2N1cktleV0gPSB0aGlzLnJlc3VsdDtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICBibG9ibGVzc0RhdGEgPSB0aGlzLnJlc3VsdDtcbiAgICAgICAgfVxuXG4gICAgICAgIC8vIGlmIG5vdGhpbmcgcGVuZGluZyBpdHMgY2FsbGJhY2sgdGltZVxuICAgICAgICBpZighIC0tcGVuZGluZ0Jsb2JzKSB7XG4gICAgICAgICAgY2FsbGJhY2soYmxvYmxlc3NEYXRhKTtcbiAgICAgICAgfVxuICAgICAgfTtcblxuICAgICAgZmlsZVJlYWRlci5yZWFkQXNBcnJheUJ1ZmZlcihvYmopOyAvLyBibG9iIC0+IGFycmF5YnVmZmVyXG4gICAgfSBlbHNlIGlmIChpc0FycmF5KG9iaikpIHsgLy8gaGFuZGxlIGFycmF5XG4gICAgICBmb3IgKHZhciBpID0gMDsgaSA8IG9iai5sZW5ndGg7IGkrKykge1xuICAgICAgICBfcmVtb3ZlQmxvYnMob2JqW2ldLCBpLCBvYmopO1xuICAgICAgfVxuICAgIH0gZWxzZSBpZiAob2JqICYmICdvYmplY3QnID09IHR5cGVvZiBvYmogJiYgIWlzQnVmKG9iaikpIHsgLy8gYW5kIG9iamVjdFxuICAgICAgZm9yICh2YXIga2V5IGluIG9iaikge1xuICAgICAgICBfcmVtb3ZlQmxvYnMob2JqW2tleV0sIGtleSwgb2JqKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICB2YXIgcGVuZGluZ0Jsb2JzID0gMDtcbiAgdmFyIGJsb2JsZXNzRGF0YSA9IGRhdGE7XG4gIF9yZW1vdmVCbG9icyhibG9ibGVzc0RhdGEpO1xuICBpZiAoIXBlbmRpbmdCbG9icykge1xuICAgIGNhbGxiYWNrKGJsb2JsZXNzRGF0YSk7XG4gIH1cbn07XG4iLCJcbi8qKlxuICogTW9kdWxlIGRlcGVuZGVuY2llcy5cbiAqL1xuXG52YXIgZGVidWcgPSByZXF1aXJlKCdkZWJ1ZycpKCdzb2NrZXQuaW8tcGFyc2VyJyk7XG52YXIganNvbiA9IHJlcXVpcmUoJ2pzb24zJyk7XG52YXIgRW1pdHRlciA9IHJlcXVpcmUoJ2NvbXBvbmVudC1lbWl0dGVyJyk7XG52YXIgYmluYXJ5ID0gcmVxdWlyZSgnLi9iaW5hcnknKTtcbnZhciBpc0J1ZiA9IHJlcXVpcmUoJy4vaXMtYnVmZmVyJyk7XG5cbi8qKlxuICogUHJvdG9jb2wgdmVyc2lvbi5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmV4cG9ydHMucHJvdG9jb2wgPSA0O1xuXG4vKipcbiAqIFBhY2tldCB0eXBlcy5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmV4cG9ydHMudHlwZXMgPSBbXG4gICdDT05ORUNUJyxcbiAgJ0RJU0NPTk5FQ1QnLFxuICAnRVZFTlQnLFxuICAnQUNLJyxcbiAgJ0VSUk9SJyxcbiAgJ0JJTkFSWV9FVkVOVCcsXG4gICdCSU5BUllfQUNLJ1xuXTtcblxuLyoqXG4gKiBQYWNrZXQgdHlwZSBgY29ubmVjdGAuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5leHBvcnRzLkNPTk5FQ1QgPSAwO1xuXG4vKipcbiAqIFBhY2tldCB0eXBlIGBkaXNjb25uZWN0YC5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmV4cG9ydHMuRElTQ09OTkVDVCA9IDE7XG5cbi8qKlxuICogUGFja2V0IHR5cGUgYGV2ZW50YC5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmV4cG9ydHMuRVZFTlQgPSAyO1xuXG4vKipcbiAqIFBhY2tldCB0eXBlIGBhY2tgLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5BQ0sgPSAzO1xuXG4vKipcbiAqIFBhY2tldCB0eXBlIGBlcnJvcmAuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5leHBvcnRzLkVSUk9SID0gNDtcblxuLyoqXG4gKiBQYWNrZXQgdHlwZSAnYmluYXJ5IGV2ZW50J1xuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5CSU5BUllfRVZFTlQgPSA1O1xuXG4vKipcbiAqIFBhY2tldCB0eXBlIGBiaW5hcnkgYWNrYC4gRm9yIGFja3Mgd2l0aCBiaW5hcnkgYXJndW1lbnRzLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5CSU5BUllfQUNLID0gNjtcblxuLyoqXG4gKiBFbmNvZGVyIGNvbnN0cnVjdG9yLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5FbmNvZGVyID0gRW5jb2RlcjtcblxuLyoqXG4gKiBEZWNvZGVyIGNvbnN0cnVjdG9yLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZXhwb3J0cy5EZWNvZGVyID0gRGVjb2RlcjtcblxuLyoqXG4gKiBBIHNvY2tldC5pbyBFbmNvZGVyIGluc3RhbmNlXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBFbmNvZGVyKCkge31cblxuLyoqXG4gKiBFbmNvZGUgYSBwYWNrZXQgYXMgYSBzaW5nbGUgc3RyaW5nIGlmIG5vbi1iaW5hcnksIG9yIGFzIGFcbiAqIGJ1ZmZlciBzZXF1ZW5jZSwgZGVwZW5kaW5nIG9uIHBhY2tldCB0eXBlLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBvYmogLSBwYWNrZXQgb2JqZWN0XG4gKiBAcGFyYW0ge0Z1bmN0aW9ufSBjYWxsYmFjayAtIGZ1bmN0aW9uIHRvIGhhbmRsZSBlbmNvZGluZ3MgKGxpa2VseSBlbmdpbmUud3JpdGUpXG4gKiBAcmV0dXJuIENhbGxzIGNhbGxiYWNrIHdpdGggQXJyYXkgb2YgZW5jb2RpbmdzXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbkVuY29kZXIucHJvdG90eXBlLmVuY29kZSA9IGZ1bmN0aW9uKG9iaiwgY2FsbGJhY2spe1xuICBkZWJ1ZygnZW5jb2RpbmcgcGFja2V0ICVqJywgb2JqKTtcblxuICBpZiAoZXhwb3J0cy5CSU5BUllfRVZFTlQgPT0gb2JqLnR5cGUgfHwgZXhwb3J0cy5CSU5BUllfQUNLID09IG9iai50eXBlKSB7XG4gICAgZW5jb2RlQXNCaW5hcnkob2JqLCBjYWxsYmFjayk7XG4gIH1cbiAgZWxzZSB7XG4gICAgdmFyIGVuY29kaW5nID0gZW5jb2RlQXNTdHJpbmcob2JqKTtcbiAgICBjYWxsYmFjayhbZW5jb2RpbmddKTtcbiAgfVxufTtcblxuLyoqXG4gKiBFbmNvZGUgcGFja2V0IGFzIHN0cmluZy5cbiAqXG4gKiBAcGFyYW0ge09iamVjdH0gcGFja2V0XG4gKiBAcmV0dXJuIHtTdHJpbmd9IGVuY29kZWRcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIGVuY29kZUFzU3RyaW5nKG9iaikge1xuICB2YXIgc3RyID0gJyc7XG4gIHZhciBuc3AgPSBmYWxzZTtcblxuICAvLyBmaXJzdCBpcyB0eXBlXG4gIHN0ciArPSBvYmoudHlwZTtcblxuICAvLyBhdHRhY2htZW50cyBpZiB3ZSBoYXZlIHRoZW1cbiAgaWYgKGV4cG9ydHMuQklOQVJZX0VWRU5UID09IG9iai50eXBlIHx8IGV4cG9ydHMuQklOQVJZX0FDSyA9PSBvYmoudHlwZSkge1xuICAgIHN0ciArPSBvYmouYXR0YWNobWVudHM7XG4gICAgc3RyICs9ICctJztcbiAgfVxuXG4gIC8vIGlmIHdlIGhhdmUgYSBuYW1lc3BhY2Ugb3RoZXIgdGhhbiBgL2BcbiAgLy8gd2UgYXBwZW5kIGl0IGZvbGxvd2VkIGJ5IGEgY29tbWEgYCxgXG4gIGlmIChvYmoubnNwICYmICcvJyAhPSBvYmoubnNwKSB7XG4gICAgbnNwID0gdHJ1ZTtcbiAgICBzdHIgKz0gb2JqLm5zcDtcbiAgfVxuXG4gIC8vIGltbWVkaWF0ZWx5IGZvbGxvd2VkIGJ5IHRoZSBpZFxuICBpZiAobnVsbCAhPSBvYmouaWQpIHtcbiAgICBpZiAobnNwKSB7XG4gICAgICBzdHIgKz0gJywnO1xuICAgICAgbnNwID0gZmFsc2U7XG4gICAgfVxuICAgIHN0ciArPSBvYmouaWQ7XG4gIH1cblxuICAvLyBqc29uIGRhdGFcbiAgaWYgKG51bGwgIT0gb2JqLmRhdGEpIHtcbiAgICBpZiAobnNwKSBzdHIgKz0gJywnO1xuICAgIHN0ciArPSBqc29uLnN0cmluZ2lmeShvYmouZGF0YSk7XG4gIH1cblxuICBkZWJ1ZygnZW5jb2RlZCAlaiBhcyAlcycsIG9iaiwgc3RyKTtcbiAgcmV0dXJuIHN0cjtcbn1cblxuLyoqXG4gKiBFbmNvZGUgcGFja2V0IGFzICdidWZmZXIgc2VxdWVuY2UnIGJ5IHJlbW92aW5nIGJsb2JzLCBhbmRcbiAqIGRlY29uc3RydWN0aW5nIHBhY2tldCBpbnRvIG9iamVjdCB3aXRoIHBsYWNlaG9sZGVycyBhbmRcbiAqIGEgbGlzdCBvZiBidWZmZXJzLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBwYWNrZXRcbiAqIEByZXR1cm4ge0J1ZmZlcn0gZW5jb2RlZFxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZnVuY3Rpb24gZW5jb2RlQXNCaW5hcnkob2JqLCBjYWxsYmFjaykge1xuXG4gIGZ1bmN0aW9uIHdyaXRlRW5jb2RpbmcoYmxvYmxlc3NEYXRhKSB7XG4gICAgdmFyIGRlY29uc3RydWN0aW9uID0gYmluYXJ5LmRlY29uc3RydWN0UGFja2V0KGJsb2JsZXNzRGF0YSk7XG4gICAgdmFyIHBhY2sgPSBlbmNvZGVBc1N0cmluZyhkZWNvbnN0cnVjdGlvbi5wYWNrZXQpO1xuICAgIHZhciBidWZmZXJzID0gZGVjb25zdHJ1Y3Rpb24uYnVmZmVycztcblxuICAgIGJ1ZmZlcnMudW5zaGlmdChwYWNrKTsgLy8gYWRkIHBhY2tldCBpbmZvIHRvIGJlZ2lubmluZyBvZiBkYXRhIGxpc3RcbiAgICBjYWxsYmFjayhidWZmZXJzKTsgLy8gd3JpdGUgYWxsIHRoZSBidWZmZXJzXG4gIH1cblxuICBiaW5hcnkucmVtb3ZlQmxvYnMob2JqLCB3cml0ZUVuY29kaW5nKTtcbn1cblxuLyoqXG4gKiBBIHNvY2tldC5pbyBEZWNvZGVyIGluc3RhbmNlXG4gKlxuICogQHJldHVybiB7T2JqZWN0fSBkZWNvZGVyXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIERlY29kZXIoKSB7XG4gIHRoaXMucmVjb25zdHJ1Y3RvciA9IG51bGw7XG59XG5cbi8qKlxuICogTWl4IGluIGBFbWl0dGVyYCB3aXRoIERlY29kZXIuXG4gKi9cblxuRW1pdHRlcihEZWNvZGVyLnByb3RvdHlwZSk7XG5cbi8qKlxuICogRGVjb2RlcyBhbiBlY29kZWQgcGFja2V0IHN0cmluZyBpbnRvIHBhY2tldCBKU09OLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBvYmogLSBlbmNvZGVkIHBhY2tldFxuICogQHJldHVybiB7T2JqZWN0fSBwYWNrZXRcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuRGVjb2Rlci5wcm90b3R5cGUuYWRkID0gZnVuY3Rpb24ob2JqKSB7XG4gIHZhciBwYWNrZXQ7XG4gIGlmICgnc3RyaW5nJyA9PSB0eXBlb2Ygb2JqKSB7XG4gICAgcGFja2V0ID0gZGVjb2RlU3RyaW5nKG9iaik7XG4gICAgaWYgKGV4cG9ydHMuQklOQVJZX0VWRU5UID09IHBhY2tldC50eXBlIHx8IGV4cG9ydHMuQklOQVJZX0FDSyA9PSBwYWNrZXQudHlwZSkgeyAvLyBiaW5hcnkgcGFja2V0J3MganNvblxuICAgICAgdGhpcy5yZWNvbnN0cnVjdG9yID0gbmV3IEJpbmFyeVJlY29uc3RydWN0b3IocGFja2V0KTtcblxuICAgICAgLy8gbm8gYXR0YWNobWVudHMsIGxhYmVsZWQgYmluYXJ5IGJ1dCBubyBiaW5hcnkgZGF0YSB0byBmb2xsb3dcbiAgICAgIGlmICh0aGlzLnJlY29uc3RydWN0b3IucmVjb25QYWNrLmF0dGFjaG1lbnRzID09PSAwKSB7XG4gICAgICAgIHRoaXMuZW1pdCgnZGVjb2RlZCcsIHBhY2tldCk7XG4gICAgICB9XG4gICAgfSBlbHNlIHsgLy8gbm9uLWJpbmFyeSBmdWxsIHBhY2tldFxuICAgICAgdGhpcy5lbWl0KCdkZWNvZGVkJywgcGFja2V0KTtcbiAgICB9XG4gIH1cbiAgZWxzZSBpZiAoaXNCdWYob2JqKSB8fCBvYmouYmFzZTY0KSB7IC8vIHJhdyBiaW5hcnkgZGF0YVxuICAgIGlmICghdGhpcy5yZWNvbnN0cnVjdG9yKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ2dvdCBiaW5hcnkgZGF0YSB3aGVuIG5vdCByZWNvbnN0cnVjdGluZyBhIHBhY2tldCcpO1xuICAgIH0gZWxzZSB7XG4gICAgICBwYWNrZXQgPSB0aGlzLnJlY29uc3RydWN0b3IudGFrZUJpbmFyeURhdGEob2JqKTtcbiAgICAgIGlmIChwYWNrZXQpIHsgLy8gcmVjZWl2ZWQgZmluYWwgYnVmZmVyXG4gICAgICAgIHRoaXMucmVjb25zdHJ1Y3RvciA9IG51bGw7XG4gICAgICAgIHRoaXMuZW1pdCgnZGVjb2RlZCcsIHBhY2tldCk7XG4gICAgICB9XG4gICAgfVxuICB9XG4gIGVsc2Uge1xuICAgIHRocm93IG5ldyBFcnJvcignVW5rbm93biB0eXBlOiAnICsgb2JqKTtcbiAgfVxufTtcblxuLyoqXG4gKiBEZWNvZGUgYSBwYWNrZXQgU3RyaW5nIChKU09OIGRhdGEpXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IHN0clxuICogQHJldHVybiB7T2JqZWN0fSBwYWNrZXRcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIGRlY29kZVN0cmluZyhzdHIpIHtcbiAgdmFyIHAgPSB7fTtcbiAgdmFyIGkgPSAwO1xuXG4gIC8vIGxvb2sgdXAgdHlwZVxuICBwLnR5cGUgPSBOdW1iZXIoc3RyLmNoYXJBdCgwKSk7XG4gIGlmIChudWxsID09IGV4cG9ydHMudHlwZXNbcC50eXBlXSkgcmV0dXJuIGVycm9yKCk7XG5cbiAgLy8gbG9vayB1cCBhdHRhY2htZW50cyBpZiB0eXBlIGJpbmFyeVxuICBpZiAoZXhwb3J0cy5CSU5BUllfRVZFTlQgPT0gcC50eXBlIHx8IGV4cG9ydHMuQklOQVJZX0FDSyA9PSBwLnR5cGUpIHtcbiAgICB2YXIgYnVmID0gJyc7XG4gICAgd2hpbGUgKHN0ci5jaGFyQXQoKytpKSAhPSAnLScpIHtcbiAgICAgIGJ1ZiArPSBzdHIuY2hhckF0KGkpO1xuICAgICAgaWYgKGkgPT0gc3RyLmxlbmd0aCkgYnJlYWs7XG4gICAgfVxuICAgIGlmIChidWYgIT0gTnVtYmVyKGJ1ZikgfHwgc3RyLmNoYXJBdChpKSAhPSAnLScpIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcignSWxsZWdhbCBhdHRhY2htZW50cycpO1xuICAgIH1cbiAgICBwLmF0dGFjaG1lbnRzID0gTnVtYmVyKGJ1Zik7XG4gIH1cblxuICAvLyBsb29rIHVwIG5hbWVzcGFjZSAoaWYgYW55KVxuICBpZiAoJy8nID09IHN0ci5jaGFyQXQoaSArIDEpKSB7XG4gICAgcC5uc3AgPSAnJztcbiAgICB3aGlsZSAoKytpKSB7XG4gICAgICB2YXIgYyA9IHN0ci5jaGFyQXQoaSk7XG4gICAgICBpZiAoJywnID09IGMpIGJyZWFrO1xuICAgICAgcC5uc3AgKz0gYztcbiAgICAgIGlmIChpID09IHN0ci5sZW5ndGgpIGJyZWFrO1xuICAgIH1cbiAgfSBlbHNlIHtcbiAgICBwLm5zcCA9ICcvJztcbiAgfVxuXG4gIC8vIGxvb2sgdXAgaWRcbiAgdmFyIG5leHQgPSBzdHIuY2hhckF0KGkgKyAxKTtcbiAgaWYgKCcnICE9PSBuZXh0ICYmIE51bWJlcihuZXh0KSA9PSBuZXh0KSB7XG4gICAgcC5pZCA9ICcnO1xuICAgIHdoaWxlICgrK2kpIHtcbiAgICAgIHZhciBjID0gc3RyLmNoYXJBdChpKTtcbiAgICAgIGlmIChudWxsID09IGMgfHwgTnVtYmVyKGMpICE9IGMpIHtcbiAgICAgICAgLS1pO1xuICAgICAgICBicmVhaztcbiAgICAgIH1cbiAgICAgIHAuaWQgKz0gc3RyLmNoYXJBdChpKTtcbiAgICAgIGlmIChpID09IHN0ci5sZW5ndGgpIGJyZWFrO1xuICAgIH1cbiAgICBwLmlkID0gTnVtYmVyKHAuaWQpO1xuICB9XG5cbiAgLy8gbG9vayB1cCBqc29uIGRhdGFcbiAgaWYgKHN0ci5jaGFyQXQoKytpKSkge1xuICAgIHAgPSB0cnlQYXJzZShwLCBzdHIuc3Vic3RyKGkpKTtcbiAgfVxuXG4gIGRlYnVnKCdkZWNvZGVkICVzIGFzICVqJywgc3RyLCBwKTtcbiAgcmV0dXJuIHA7XG59XG5cbmZ1bmN0aW9uIHRyeVBhcnNlKHAsIHN0cikge1xuICB0cnkge1xuICAgIHAuZGF0YSA9IGpzb24ucGFyc2Uoc3RyKTtcbiAgfSBjYXRjaChlKXtcbiAgICByZXR1cm4gZXJyb3IoKTtcbiAgfVxuICByZXR1cm4gcDsgXG59O1xuXG4vKipcbiAqIERlYWxsb2NhdGVzIGEgcGFyc2VyJ3MgcmVzb3VyY2VzXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5EZWNvZGVyLnByb3RvdHlwZS5kZXN0cm95ID0gZnVuY3Rpb24oKSB7XG4gIGlmICh0aGlzLnJlY29uc3RydWN0b3IpIHtcbiAgICB0aGlzLnJlY29uc3RydWN0b3IuZmluaXNoZWRSZWNvbnN0cnVjdGlvbigpO1xuICB9XG59O1xuXG4vKipcbiAqIEEgbWFuYWdlciBvZiBhIGJpbmFyeSBldmVudCdzICdidWZmZXIgc2VxdWVuY2UnLiBTaG91bGRcbiAqIGJlIGNvbnN0cnVjdGVkIHdoZW5ldmVyIGEgcGFja2V0IG9mIHR5cGUgQklOQVJZX0VWRU5UIGlzXG4gKiBkZWNvZGVkLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBwYWNrZXRcbiAqIEByZXR1cm4ge0JpbmFyeVJlY29uc3RydWN0b3J9IGluaXRpYWxpemVkIHJlY29uc3RydWN0b3JcbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIEJpbmFyeVJlY29uc3RydWN0b3IocGFja2V0KSB7XG4gIHRoaXMucmVjb25QYWNrID0gcGFja2V0O1xuICB0aGlzLmJ1ZmZlcnMgPSBbXTtcbn1cblxuLyoqXG4gKiBNZXRob2QgdG8gYmUgY2FsbGVkIHdoZW4gYmluYXJ5IGRhdGEgcmVjZWl2ZWQgZnJvbSBjb25uZWN0aW9uXG4gKiBhZnRlciBhIEJJTkFSWV9FVkVOVCBwYWNrZXQuXG4gKlxuICogQHBhcmFtIHtCdWZmZXIgfCBBcnJheUJ1ZmZlcn0gYmluRGF0YSAtIHRoZSByYXcgYmluYXJ5IGRhdGEgcmVjZWl2ZWRcbiAqIEByZXR1cm4ge251bGwgfCBPYmplY3R9IHJldHVybnMgbnVsbCBpZiBtb3JlIGJpbmFyeSBkYXRhIGlzIGV4cGVjdGVkIG9yXG4gKiAgIGEgcmVjb25zdHJ1Y3RlZCBwYWNrZXQgb2JqZWN0IGlmIGFsbCBidWZmZXJzIGhhdmUgYmVlbiByZWNlaXZlZC5cbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbkJpbmFyeVJlY29uc3RydWN0b3IucHJvdG90eXBlLnRha2VCaW5hcnlEYXRhID0gZnVuY3Rpb24oYmluRGF0YSkge1xuICB0aGlzLmJ1ZmZlcnMucHVzaChiaW5EYXRhKTtcbiAgaWYgKHRoaXMuYnVmZmVycy5sZW5ndGggPT0gdGhpcy5yZWNvblBhY2suYXR0YWNobWVudHMpIHsgLy8gZG9uZSB3aXRoIGJ1ZmZlciBsaXN0XG4gICAgdmFyIHBhY2tldCA9IGJpbmFyeS5yZWNvbnN0cnVjdFBhY2tldCh0aGlzLnJlY29uUGFjaywgdGhpcy5idWZmZXJzKTtcbiAgICB0aGlzLmZpbmlzaGVkUmVjb25zdHJ1Y3Rpb24oKTtcbiAgICByZXR1cm4gcGFja2V0O1xuICB9XG4gIHJldHVybiBudWxsO1xufTtcblxuLyoqXG4gKiBDbGVhbnMgdXAgYmluYXJ5IHBhY2tldCByZWNvbnN0cnVjdGlvbiB2YXJpYWJsZXMuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuQmluYXJ5UmVjb25zdHJ1Y3Rvci5wcm90b3R5cGUuZmluaXNoZWRSZWNvbnN0cnVjdGlvbiA9IGZ1bmN0aW9uKCkge1xuICB0aGlzLnJlY29uUGFjayA9IG51bGw7XG4gIHRoaXMuYnVmZmVycyA9IFtdO1xufTtcblxuZnVuY3Rpb24gZXJyb3IoZGF0YSl7XG4gIHJldHVybiB7XG4gICAgdHlwZTogZXhwb3J0cy5FUlJPUixcbiAgICBkYXRhOiAncGFyc2VyIGVycm9yJ1xuICB9O1xufVxuIiwiXG5tb2R1bGUuZXhwb3J0cyA9IGlzQnVmO1xuXG4vKipcbiAqIFJldHVybnMgdHJ1ZSBpZiBvYmogaXMgYSBidWZmZXIgb3IgYW4gYXJyYXlidWZmZXIuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZnVuY3Rpb24gaXNCdWYob2JqKSB7XG4gIHJldHVybiAoZ2xvYmFsLkJ1ZmZlciAmJiBnbG9iYWwuQnVmZmVyLmlzQnVmZmVyKG9iaikpIHx8XG4gICAgICAgICAoZ2xvYmFsLkFycmF5QnVmZmVyICYmIG9iaiBpbnN0YW5jZW9mIEFycmF5QnVmZmVyKTtcbn1cbiIsIlxuLyoqXG4gKiBFeHBvc2UgYEVtaXR0ZXJgLlxuICovXG5cbm1vZHVsZS5leHBvcnRzID0gRW1pdHRlcjtcblxuLyoqXG4gKiBJbml0aWFsaXplIGEgbmV3IGBFbWl0dGVyYC5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIEVtaXR0ZXIob2JqKSB7XG4gIGlmIChvYmopIHJldHVybiBtaXhpbihvYmopO1xufTtcblxuLyoqXG4gKiBNaXhpbiB0aGUgZW1pdHRlciBwcm9wZXJ0aWVzLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBvYmpcbiAqIEByZXR1cm4ge09iamVjdH1cbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIG1peGluKG9iaikge1xuICBmb3IgKHZhciBrZXkgaW4gRW1pdHRlci5wcm90b3R5cGUpIHtcbiAgICBvYmpba2V5XSA9IEVtaXR0ZXIucHJvdG90eXBlW2tleV07XG4gIH1cbiAgcmV0dXJuIG9iajtcbn1cblxuLyoqXG4gKiBMaXN0ZW4gb24gdGhlIGdpdmVuIGBldmVudGAgd2l0aCBgZm5gLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBldmVudFxuICogQHBhcmFtIHtGdW5jdGlvbn0gZm5cbiAqIEByZXR1cm4ge0VtaXR0ZXJ9XG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbkVtaXR0ZXIucHJvdG90eXBlLm9uID1cbkVtaXR0ZXIucHJvdG90eXBlLmFkZEV2ZW50TGlzdGVuZXIgPSBmdW5jdGlvbihldmVudCwgZm4pe1xuICB0aGlzLl9jYWxsYmFja3MgPSB0aGlzLl9jYWxsYmFja3MgfHwge307XG4gICh0aGlzLl9jYWxsYmFja3NbZXZlbnRdID0gdGhpcy5fY2FsbGJhY2tzW2V2ZW50XSB8fCBbXSlcbiAgICAucHVzaChmbik7XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBBZGRzIGFuIGBldmVudGAgbGlzdGVuZXIgdGhhdCB3aWxsIGJlIGludm9rZWQgYSBzaW5nbGVcbiAqIHRpbWUgdGhlbiBhdXRvbWF0aWNhbGx5IHJlbW92ZWQuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IGV2ZW50XG4gKiBAcGFyYW0ge0Z1bmN0aW9ufSBmblxuICogQHJldHVybiB7RW1pdHRlcn1cbiAqIEBhcGkgcHVibGljXG4gKi9cblxuRW1pdHRlci5wcm90b3R5cGUub25jZSA9IGZ1bmN0aW9uKGV2ZW50LCBmbil7XG4gIHZhciBzZWxmID0gdGhpcztcbiAgdGhpcy5fY2FsbGJhY2tzID0gdGhpcy5fY2FsbGJhY2tzIHx8IHt9O1xuXG4gIGZ1bmN0aW9uIG9uKCkge1xuICAgIHNlbGYub2ZmKGV2ZW50LCBvbik7XG4gICAgZm4uYXBwbHkodGhpcywgYXJndW1lbnRzKTtcbiAgfVxuXG4gIG9uLmZuID0gZm47XG4gIHRoaXMub24oZXZlbnQsIG9uKTtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIFJlbW92ZSB0aGUgZ2l2ZW4gY2FsbGJhY2sgZm9yIGBldmVudGAgb3IgYWxsXG4gKiByZWdpc3RlcmVkIGNhbGxiYWNrcy5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gZXZlbnRcbiAqIEBwYXJhbSB7RnVuY3Rpb259IGZuXG4gKiBAcmV0dXJuIHtFbWl0dGVyfVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5FbWl0dGVyLnByb3RvdHlwZS5vZmYgPVxuRW1pdHRlci5wcm90b3R5cGUucmVtb3ZlTGlzdGVuZXIgPVxuRW1pdHRlci5wcm90b3R5cGUucmVtb3ZlQWxsTGlzdGVuZXJzID1cbkVtaXR0ZXIucHJvdG90eXBlLnJlbW92ZUV2ZW50TGlzdGVuZXIgPSBmdW5jdGlvbihldmVudCwgZm4pe1xuICB0aGlzLl9jYWxsYmFja3MgPSB0aGlzLl9jYWxsYmFja3MgfHwge307XG5cbiAgLy8gYWxsXG4gIGlmICgwID09IGFyZ3VtZW50cy5sZW5ndGgpIHtcbiAgICB0aGlzLl9jYWxsYmFja3MgPSB7fTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIC8vIHNwZWNpZmljIGV2ZW50XG4gIHZhciBjYWxsYmFja3MgPSB0aGlzLl9jYWxsYmFja3NbZXZlbnRdO1xuICBpZiAoIWNhbGxiYWNrcykgcmV0dXJuIHRoaXM7XG5cbiAgLy8gcmVtb3ZlIGFsbCBoYW5kbGVyc1xuICBpZiAoMSA9PSBhcmd1bWVudHMubGVuZ3RoKSB7XG4gICAgZGVsZXRlIHRoaXMuX2NhbGxiYWNrc1tldmVudF07XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICAvLyByZW1vdmUgc3BlY2lmaWMgaGFuZGxlclxuICB2YXIgY2I7XG4gIGZvciAodmFyIGkgPSAwOyBpIDwgY2FsbGJhY2tzLmxlbmd0aDsgaSsrKSB7XG4gICAgY2IgPSBjYWxsYmFja3NbaV07XG4gICAgaWYgKGNiID09PSBmbiB8fCBjYi5mbiA9PT0gZm4pIHtcbiAgICAgIGNhbGxiYWNrcy5zcGxpY2UoaSwgMSk7XG4gICAgICBicmVhaztcbiAgICB9XG4gIH1cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIEVtaXQgYGV2ZW50YCB3aXRoIHRoZSBnaXZlbiBhcmdzLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBldmVudFxuICogQHBhcmFtIHtNaXhlZH0gLi4uXG4gKiBAcmV0dXJuIHtFbWl0dGVyfVxuICovXG5cbkVtaXR0ZXIucHJvdG90eXBlLmVtaXQgPSBmdW5jdGlvbihldmVudCl7XG4gIHRoaXMuX2NhbGxiYWNrcyA9IHRoaXMuX2NhbGxiYWNrcyB8fCB7fTtcbiAgdmFyIGFyZ3MgPSBbXS5zbGljZS5jYWxsKGFyZ3VtZW50cywgMSlcbiAgICAsIGNhbGxiYWNrcyA9IHRoaXMuX2NhbGxiYWNrc1tldmVudF07XG5cbiAgaWYgKGNhbGxiYWNrcykge1xuICAgIGNhbGxiYWNrcyA9IGNhbGxiYWNrcy5zbGljZSgwKTtcbiAgICBmb3IgKHZhciBpID0gMCwgbGVuID0gY2FsbGJhY2tzLmxlbmd0aDsgaSA8IGxlbjsgKytpKSB7XG4gICAgICBjYWxsYmFja3NbaV0uYXBwbHkodGhpcywgYXJncyk7XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIFJldHVybiBhcnJheSBvZiBjYWxsYmFja3MgZm9yIGBldmVudGAuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IGV2ZW50XG4gKiBAcmV0dXJuIHtBcnJheX1cbiAqIEBhcGkgcHVibGljXG4gKi9cblxuRW1pdHRlci5wcm90b3R5cGUubGlzdGVuZXJzID0gZnVuY3Rpb24oZXZlbnQpe1xuICB0aGlzLl9jYWxsYmFja3MgPSB0aGlzLl9jYWxsYmFja3MgfHwge307XG4gIHJldHVybiB0aGlzLl9jYWxsYmFja3NbZXZlbnRdIHx8IFtdO1xufTtcblxuLyoqXG4gKiBDaGVjayBpZiB0aGlzIGVtaXR0ZXIgaGFzIGBldmVudGAgaGFuZGxlcnMuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IGV2ZW50XG4gKiBAcmV0dXJuIHtCb29sZWFufVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5FbWl0dGVyLnByb3RvdHlwZS5oYXNMaXN0ZW5lcnMgPSBmdW5jdGlvbihldmVudCl7XG4gIHJldHVybiAhISB0aGlzLmxpc3RlbmVycyhldmVudCkubGVuZ3RoO1xufTtcbiIsIlxuLyoqXG4gKiBUaGlzIGlzIHRoZSB3ZWIgYnJvd3NlciBpbXBsZW1lbnRhdGlvbiBvZiBgZGVidWcoKWAuXG4gKlxuICogRXhwb3NlIGBkZWJ1ZygpYCBhcyB0aGUgbW9kdWxlLlxuICovXG5cbmV4cG9ydHMgPSBtb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoJy4vZGVidWcnKTtcbmV4cG9ydHMubG9nID0gbG9nO1xuZXhwb3J0cy5mb3JtYXRBcmdzID0gZm9ybWF0QXJncztcbmV4cG9ydHMuc2F2ZSA9IHNhdmU7XG5leHBvcnRzLmxvYWQgPSBsb2FkO1xuZXhwb3J0cy51c2VDb2xvcnMgPSB1c2VDb2xvcnM7XG5leHBvcnRzLnN0b3JhZ2UgPSAndW5kZWZpbmVkJyAhPSB0eXBlb2YgY2hyb21lXG4gICAgICAgICAgICAgICAmJiAndW5kZWZpbmVkJyAhPSB0eXBlb2YgY2hyb21lLnN0b3JhZ2VcbiAgICAgICAgICAgICAgICAgID8gY2hyb21lLnN0b3JhZ2UubG9jYWxcbiAgICAgICAgICAgICAgICAgIDogbG9jYWxzdG9yYWdlKCk7XG5cbi8qKlxuICogQ29sb3JzLlxuICovXG5cbmV4cG9ydHMuY29sb3JzID0gW1xuICAnbGlnaHRzZWFncmVlbicsXG4gICdmb3Jlc3RncmVlbicsXG4gICdnb2xkZW5yb2QnLFxuICAnZG9kZ2VyYmx1ZScsXG4gICdkYXJrb3JjaGlkJyxcbiAgJ2NyaW1zb24nXG5dO1xuXG4vKipcbiAqIEN1cnJlbnRseSBvbmx5IFdlYktpdC1iYXNlZCBXZWIgSW5zcGVjdG9ycywgRmlyZWZveCA+PSB2MzEsXG4gKiBhbmQgdGhlIEZpcmVidWcgZXh0ZW5zaW9uIChhbnkgRmlyZWZveCB2ZXJzaW9uKSBhcmUga25vd25cbiAqIHRvIHN1cHBvcnQgXCIlY1wiIENTUyBjdXN0b21pemF0aW9ucy5cbiAqXG4gKiBUT0RPOiBhZGQgYSBgbG9jYWxTdG9yYWdlYCB2YXJpYWJsZSB0byBleHBsaWNpdGx5IGVuYWJsZS9kaXNhYmxlIGNvbG9yc1xuICovXG5cbmZ1bmN0aW9uIHVzZUNvbG9ycygpIHtcbiAgLy8gaXMgd2Via2l0PyBodHRwOi8vc3RhY2tvdmVyZmxvdy5jb20vYS8xNjQ1OTYwNi8zNzY3NzNcbiAgcmV0dXJuICgnV2Via2l0QXBwZWFyYW5jZScgaW4gZG9jdW1lbnQuZG9jdW1lbnRFbGVtZW50LnN0eWxlKSB8fFxuICAgIC8vIGlzIGZpcmVidWc/IGh0dHA6Ly9zdGFja292ZXJmbG93LmNvbS9hLzM5ODEyMC8zNzY3NzNcbiAgICAod2luZG93LmNvbnNvbGUgJiYgKGNvbnNvbGUuZmlyZWJ1ZyB8fCAoY29uc29sZS5leGNlcHRpb24gJiYgY29uc29sZS50YWJsZSkpKSB8fFxuICAgIC8vIGlzIGZpcmVmb3ggPj0gdjMxP1xuICAgIC8vIGh0dHBzOi8vZGV2ZWxvcGVyLm1vemlsbGEub3JnL2VuLVVTL2RvY3MvVG9vbHMvV2ViX0NvbnNvbGUjU3R5bGluZ19tZXNzYWdlc1xuICAgIChuYXZpZ2F0b3IudXNlckFnZW50LnRvTG93ZXJDYXNlKCkubWF0Y2goL2ZpcmVmb3hcXC8oXFxkKykvKSAmJiBwYXJzZUludChSZWdFeHAuJDEsIDEwKSA+PSAzMSk7XG59XG5cbi8qKlxuICogTWFwICVqIHRvIGBKU09OLnN0cmluZ2lmeSgpYCwgc2luY2Ugbm8gV2ViIEluc3BlY3RvcnMgZG8gdGhhdCBieSBkZWZhdWx0LlxuICovXG5cbmV4cG9ydHMuZm9ybWF0dGVycy5qID0gZnVuY3Rpb24odikge1xuICByZXR1cm4gSlNPTi5zdHJpbmdpZnkodik7XG59O1xuXG5cbi8qKlxuICogQ29sb3JpemUgbG9nIGFyZ3VtZW50cyBpZiBlbmFibGVkLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gZm9ybWF0QXJncygpIHtcbiAgdmFyIGFyZ3MgPSBhcmd1bWVudHM7XG4gIHZhciB1c2VDb2xvcnMgPSB0aGlzLnVzZUNvbG9ycztcblxuICBhcmdzWzBdID0gKHVzZUNvbG9ycyA/ICclYycgOiAnJylcbiAgICArIHRoaXMubmFtZXNwYWNlXG4gICAgKyAodXNlQ29sb3JzID8gJyAlYycgOiAnICcpXG4gICAgKyBhcmdzWzBdXG4gICAgKyAodXNlQ29sb3JzID8gJyVjICcgOiAnICcpXG4gICAgKyAnKycgKyBleHBvcnRzLmh1bWFuaXplKHRoaXMuZGlmZik7XG5cbiAgaWYgKCF1c2VDb2xvcnMpIHJldHVybiBhcmdzO1xuXG4gIHZhciBjID0gJ2NvbG9yOiAnICsgdGhpcy5jb2xvcjtcbiAgYXJncyA9IFthcmdzWzBdLCBjLCAnY29sb3I6IGluaGVyaXQnXS5jb25jYXQoQXJyYXkucHJvdG90eXBlLnNsaWNlLmNhbGwoYXJncywgMSkpO1xuXG4gIC8vIHRoZSBmaW5hbCBcIiVjXCIgaXMgc29tZXdoYXQgdHJpY2t5LCBiZWNhdXNlIHRoZXJlIGNvdWxkIGJlIG90aGVyXG4gIC8vIGFyZ3VtZW50cyBwYXNzZWQgZWl0aGVyIGJlZm9yZSBvciBhZnRlciB0aGUgJWMsIHNvIHdlIG5lZWQgdG9cbiAgLy8gZmlndXJlIG91dCB0aGUgY29ycmVjdCBpbmRleCB0byBpbnNlcnQgdGhlIENTUyBpbnRvXG4gIHZhciBpbmRleCA9IDA7XG4gIHZhciBsYXN0QyA9IDA7XG4gIGFyZ3NbMF0ucmVwbGFjZSgvJVthLXolXS9nLCBmdW5jdGlvbihtYXRjaCkge1xuICAgIGlmICgnJSUnID09PSBtYXRjaCkgcmV0dXJuO1xuICAgIGluZGV4Kys7XG4gICAgaWYgKCclYycgPT09IG1hdGNoKSB7XG4gICAgICAvLyB3ZSBvbmx5IGFyZSBpbnRlcmVzdGVkIGluIHRoZSAqbGFzdCogJWNcbiAgICAgIC8vICh0aGUgdXNlciBtYXkgaGF2ZSBwcm92aWRlZCB0aGVpciBvd24pXG4gICAgICBsYXN0QyA9IGluZGV4O1xuICAgIH1cbiAgfSk7XG5cbiAgYXJncy5zcGxpY2UobGFzdEMsIDAsIGMpO1xuICByZXR1cm4gYXJncztcbn1cblxuLyoqXG4gKiBJbnZva2VzIGBjb25zb2xlLmxvZygpYCB3aGVuIGF2YWlsYWJsZS5cbiAqIE5vLW9wIHdoZW4gYGNvbnNvbGUubG9nYCBpcyBub3QgYSBcImZ1bmN0aW9uXCIuXG4gKlxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBsb2coKSB7XG4gIC8vIHRoaXMgaGFja2VyeSBpcyByZXF1aXJlZCBmb3IgSUU4LzksIHdoZXJlXG4gIC8vIHRoZSBgY29uc29sZS5sb2dgIGZ1bmN0aW9uIGRvZXNuJ3QgaGF2ZSAnYXBwbHknXG4gIHJldHVybiAnb2JqZWN0JyA9PT0gdHlwZW9mIGNvbnNvbGVcbiAgICAmJiBjb25zb2xlLmxvZ1xuICAgICYmIEZ1bmN0aW9uLnByb3RvdHlwZS5hcHBseS5jYWxsKGNvbnNvbGUubG9nLCBjb25zb2xlLCBhcmd1bWVudHMpO1xufVxuXG4vKipcbiAqIFNhdmUgYG5hbWVzcGFjZXNgLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBuYW1lc3BhY2VzXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBzYXZlKG5hbWVzcGFjZXMpIHtcbiAgdHJ5IHtcbiAgICBpZiAobnVsbCA9PSBuYW1lc3BhY2VzKSB7XG4gICAgICBleHBvcnRzLnN0b3JhZ2UucmVtb3ZlSXRlbSgnZGVidWcnKTtcbiAgICB9IGVsc2Uge1xuICAgICAgZXhwb3J0cy5zdG9yYWdlLmRlYnVnID0gbmFtZXNwYWNlcztcbiAgICB9XG4gIH0gY2F0Y2goZSkge31cbn1cblxuLyoqXG4gKiBMb2FkIGBuYW1lc3BhY2VzYC5cbiAqXG4gKiBAcmV0dXJuIHtTdHJpbmd9IHJldHVybnMgdGhlIHByZXZpb3VzbHkgcGVyc2lzdGVkIGRlYnVnIG1vZGVzXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBsb2FkKCkge1xuICB2YXIgcjtcbiAgdHJ5IHtcbiAgICByID0gZXhwb3J0cy5zdG9yYWdlLmRlYnVnO1xuICB9IGNhdGNoKGUpIHt9XG4gIHJldHVybiByO1xufVxuXG4vKipcbiAqIEVuYWJsZSBuYW1lc3BhY2VzIGxpc3RlZCBpbiBgbG9jYWxTdG9yYWdlLmRlYnVnYCBpbml0aWFsbHkuXG4gKi9cblxuZXhwb3J0cy5lbmFibGUobG9hZCgpKTtcblxuLyoqXG4gKiBMb2NhbHN0b3JhZ2UgYXR0ZW1wdHMgdG8gcmV0dXJuIHRoZSBsb2NhbHN0b3JhZ2UuXG4gKlxuICogVGhpcyBpcyBuZWNlc3NhcnkgYmVjYXVzZSBzYWZhcmkgdGhyb3dzXG4gKiB3aGVuIGEgdXNlciBkaXNhYmxlcyBjb29raWVzL2xvY2Fsc3RvcmFnZVxuICogYW5kIHlvdSBhdHRlbXB0IHRvIGFjY2VzcyBpdC5cbiAqXG4gKiBAcmV0dXJuIHtMb2NhbFN0b3JhZ2V9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBsb2NhbHN0b3JhZ2UoKXtcbiAgdHJ5IHtcbiAgICByZXR1cm4gd2luZG93LmxvY2FsU3RvcmFnZTtcbiAgfSBjYXRjaCAoZSkge31cbn1cbiIsIlxuLyoqXG4gKiBUaGlzIGlzIHRoZSBjb21tb24gbG9naWMgZm9yIGJvdGggdGhlIE5vZGUuanMgYW5kIHdlYiBicm93c2VyXG4gKiBpbXBsZW1lbnRhdGlvbnMgb2YgYGRlYnVnKClgLlxuICpcbiAqIEV4cG9zZSBgZGVidWcoKWAgYXMgdGhlIG1vZHVsZS5cbiAqL1xuXG5leHBvcnRzID0gbW9kdWxlLmV4cG9ydHMgPSBkZWJ1ZztcbmV4cG9ydHMuY29lcmNlID0gY29lcmNlO1xuZXhwb3J0cy5kaXNhYmxlID0gZGlzYWJsZTtcbmV4cG9ydHMuZW5hYmxlID0gZW5hYmxlO1xuZXhwb3J0cy5lbmFibGVkID0gZW5hYmxlZDtcbmV4cG9ydHMuaHVtYW5pemUgPSByZXF1aXJlKCdtcycpO1xuXG4vKipcbiAqIFRoZSBjdXJyZW50bHkgYWN0aXZlIGRlYnVnIG1vZGUgbmFtZXMsIGFuZCBuYW1lcyB0byBza2lwLlxuICovXG5cbmV4cG9ydHMubmFtZXMgPSBbXTtcbmV4cG9ydHMuc2tpcHMgPSBbXTtcblxuLyoqXG4gKiBNYXAgb2Ygc3BlY2lhbCBcIiVuXCIgaGFuZGxpbmcgZnVuY3Rpb25zLCBmb3IgdGhlIGRlYnVnIFwiZm9ybWF0XCIgYXJndW1lbnQuXG4gKlxuICogVmFsaWQga2V5IG5hbWVzIGFyZSBhIHNpbmdsZSwgbG93ZXJjYXNlZCBsZXR0ZXIsIGkuZS4gXCJuXCIuXG4gKi9cblxuZXhwb3J0cy5mb3JtYXR0ZXJzID0ge307XG5cbi8qKlxuICogUHJldmlvdXNseSBhc3NpZ25lZCBjb2xvci5cbiAqL1xuXG52YXIgcHJldkNvbG9yID0gMDtcblxuLyoqXG4gKiBQcmV2aW91cyBsb2cgdGltZXN0YW1wLlxuICovXG5cbnZhciBwcmV2VGltZTtcblxuLyoqXG4gKiBTZWxlY3QgYSBjb2xvci5cbiAqXG4gKiBAcmV0dXJuIHtOdW1iZXJ9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBzZWxlY3RDb2xvcigpIHtcbiAgcmV0dXJuIGV4cG9ydHMuY29sb3JzW3ByZXZDb2xvcisrICUgZXhwb3J0cy5jb2xvcnMubGVuZ3RoXTtcbn1cblxuLyoqXG4gKiBDcmVhdGUgYSBkZWJ1Z2dlciB3aXRoIHRoZSBnaXZlbiBgbmFtZXNwYWNlYC5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gbmFtZXNwYWNlXG4gKiBAcmV0dXJuIHtGdW5jdGlvbn1cbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gZGVidWcobmFtZXNwYWNlKSB7XG5cbiAgLy8gZGVmaW5lIHRoZSBgZGlzYWJsZWRgIHZlcnNpb25cbiAgZnVuY3Rpb24gZGlzYWJsZWQoKSB7XG4gIH1cbiAgZGlzYWJsZWQuZW5hYmxlZCA9IGZhbHNlO1xuXG4gIC8vIGRlZmluZSB0aGUgYGVuYWJsZWRgIHZlcnNpb25cbiAgZnVuY3Rpb24gZW5hYmxlZCgpIHtcblxuICAgIHZhciBzZWxmID0gZW5hYmxlZDtcblxuICAgIC8vIHNldCBgZGlmZmAgdGltZXN0YW1wXG4gICAgdmFyIGN1cnIgPSArbmV3IERhdGUoKTtcbiAgICB2YXIgbXMgPSBjdXJyIC0gKHByZXZUaW1lIHx8IGN1cnIpO1xuICAgIHNlbGYuZGlmZiA9IG1zO1xuICAgIHNlbGYucHJldiA9IHByZXZUaW1lO1xuICAgIHNlbGYuY3VyciA9IGN1cnI7XG4gICAgcHJldlRpbWUgPSBjdXJyO1xuXG4gICAgLy8gYWRkIHRoZSBgY29sb3JgIGlmIG5vdCBzZXRcbiAgICBpZiAobnVsbCA9PSBzZWxmLnVzZUNvbG9ycykgc2VsZi51c2VDb2xvcnMgPSBleHBvcnRzLnVzZUNvbG9ycygpO1xuICAgIGlmIChudWxsID09IHNlbGYuY29sb3IgJiYgc2VsZi51c2VDb2xvcnMpIHNlbGYuY29sb3IgPSBzZWxlY3RDb2xvcigpO1xuXG4gICAgdmFyIGFyZ3MgPSBBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmd1bWVudHMpO1xuXG4gICAgYXJnc1swXSA9IGV4cG9ydHMuY29lcmNlKGFyZ3NbMF0pO1xuXG4gICAgaWYgKCdzdHJpbmcnICE9PSB0eXBlb2YgYXJnc1swXSkge1xuICAgICAgLy8gYW55dGhpbmcgZWxzZSBsZXQncyBpbnNwZWN0IHdpdGggJW9cbiAgICAgIGFyZ3MgPSBbJyVvJ10uY29uY2F0KGFyZ3MpO1xuICAgIH1cblxuICAgIC8vIGFwcGx5IGFueSBgZm9ybWF0dGVyc2AgdHJhbnNmb3JtYXRpb25zXG4gICAgdmFyIGluZGV4ID0gMDtcbiAgICBhcmdzWzBdID0gYXJnc1swXS5yZXBsYWNlKC8lKFthLXolXSkvZywgZnVuY3Rpb24obWF0Y2gsIGZvcm1hdCkge1xuICAgICAgLy8gaWYgd2UgZW5jb3VudGVyIGFuIGVzY2FwZWQgJSB0aGVuIGRvbid0IGluY3JlYXNlIHRoZSBhcnJheSBpbmRleFxuICAgICAgaWYgKG1hdGNoID09PSAnJSUnKSByZXR1cm4gbWF0Y2g7XG4gICAgICBpbmRleCsrO1xuICAgICAgdmFyIGZvcm1hdHRlciA9IGV4cG9ydHMuZm9ybWF0dGVyc1tmb3JtYXRdO1xuICAgICAgaWYgKCdmdW5jdGlvbicgPT09IHR5cGVvZiBmb3JtYXR0ZXIpIHtcbiAgICAgICAgdmFyIHZhbCA9IGFyZ3NbaW5kZXhdO1xuICAgICAgICBtYXRjaCA9IGZvcm1hdHRlci5jYWxsKHNlbGYsIHZhbCk7XG5cbiAgICAgICAgLy8gbm93IHdlIG5lZWQgdG8gcmVtb3ZlIGBhcmdzW2luZGV4XWAgc2luY2UgaXQncyBpbmxpbmVkIGluIHRoZSBgZm9ybWF0YFxuICAgICAgICBhcmdzLnNwbGljZShpbmRleCwgMSk7XG4gICAgICAgIGluZGV4LS07XG4gICAgICB9XG4gICAgICByZXR1cm4gbWF0Y2g7XG4gICAgfSk7XG5cbiAgICBpZiAoJ2Z1bmN0aW9uJyA9PT0gdHlwZW9mIGV4cG9ydHMuZm9ybWF0QXJncykge1xuICAgICAgYXJncyA9IGV4cG9ydHMuZm9ybWF0QXJncy5hcHBseShzZWxmLCBhcmdzKTtcbiAgICB9XG4gICAgdmFyIGxvZ0ZuID0gZW5hYmxlZC5sb2cgfHwgZXhwb3J0cy5sb2cgfHwgY29uc29sZS5sb2cuYmluZChjb25zb2xlKTtcbiAgICBsb2dGbi5hcHBseShzZWxmLCBhcmdzKTtcbiAgfVxuICBlbmFibGVkLmVuYWJsZWQgPSB0cnVlO1xuXG4gIHZhciBmbiA9IGV4cG9ydHMuZW5hYmxlZChuYW1lc3BhY2UpID8gZW5hYmxlZCA6IGRpc2FibGVkO1xuXG4gIGZuLm5hbWVzcGFjZSA9IG5hbWVzcGFjZTtcblxuICByZXR1cm4gZm47XG59XG5cbi8qKlxuICogRW5hYmxlcyBhIGRlYnVnIG1vZGUgYnkgbmFtZXNwYWNlcy4gVGhpcyBjYW4gaW5jbHVkZSBtb2Rlc1xuICogc2VwYXJhdGVkIGJ5IGEgY29sb24gYW5kIHdpbGRjYXJkcy5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gbmFtZXNwYWNlc1xuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5mdW5jdGlvbiBlbmFibGUobmFtZXNwYWNlcykge1xuICBleHBvcnRzLnNhdmUobmFtZXNwYWNlcyk7XG5cbiAgdmFyIHNwbGl0ID0gKG5hbWVzcGFjZXMgfHwgJycpLnNwbGl0KC9bXFxzLF0rLyk7XG4gIHZhciBsZW4gPSBzcGxpdC5sZW5ndGg7XG5cbiAgZm9yICh2YXIgaSA9IDA7IGkgPCBsZW47IGkrKykge1xuICAgIGlmICghc3BsaXRbaV0pIGNvbnRpbnVlOyAvLyBpZ25vcmUgZW1wdHkgc3RyaW5nc1xuICAgIG5hbWVzcGFjZXMgPSBzcGxpdFtpXS5yZXBsYWNlKC9cXCovZywgJy4qPycpO1xuICAgIGlmIChuYW1lc3BhY2VzWzBdID09PSAnLScpIHtcbiAgICAgIGV4cG9ydHMuc2tpcHMucHVzaChuZXcgUmVnRXhwKCdeJyArIG5hbWVzcGFjZXMuc3Vic3RyKDEpICsgJyQnKSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIGV4cG9ydHMubmFtZXMucHVzaChuZXcgUmVnRXhwKCdeJyArIG5hbWVzcGFjZXMgKyAnJCcpKTtcbiAgICB9XG4gIH1cbn1cblxuLyoqXG4gKiBEaXNhYmxlIGRlYnVnIG91dHB1dC5cbiAqXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGRpc2FibGUoKSB7XG4gIGV4cG9ydHMuZW5hYmxlKCcnKTtcbn1cblxuLyoqXG4gKiBSZXR1cm5zIHRydWUgaWYgdGhlIGdpdmVuIG1vZGUgbmFtZSBpcyBlbmFibGVkLCBmYWxzZSBvdGhlcndpc2UuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IG5hbWVcbiAqIEByZXR1cm4ge0Jvb2xlYW59XG4gKiBAYXBpIHB1YmxpY1xuICovXG5cbmZ1bmN0aW9uIGVuYWJsZWQobmFtZSkge1xuICB2YXIgaSwgbGVuO1xuICBmb3IgKGkgPSAwLCBsZW4gPSBleHBvcnRzLnNraXBzLmxlbmd0aDsgaSA8IGxlbjsgaSsrKSB7XG4gICAgaWYgKGV4cG9ydHMuc2tpcHNbaV0udGVzdChuYW1lKSkge1xuICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cbiAgfVxuICBmb3IgKGkgPSAwLCBsZW4gPSBleHBvcnRzLm5hbWVzLmxlbmd0aDsgaSA8IGxlbjsgaSsrKSB7XG4gICAgaWYgKGV4cG9ydHMubmFtZXNbaV0udGVzdChuYW1lKSkge1xuICAgICAgcmV0dXJuIHRydWU7XG4gICAgfVxuICB9XG4gIHJldHVybiBmYWxzZTtcbn1cblxuLyoqXG4gKiBDb2VyY2UgYHZhbGAuXG4gKlxuICogQHBhcmFtIHtNaXhlZH0gdmFsXG4gKiBAcmV0dXJuIHtNaXhlZH1cbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIGNvZXJjZSh2YWwpIHtcbiAgaWYgKHZhbCBpbnN0YW5jZW9mIEVycm9yKSByZXR1cm4gdmFsLnN0YWNrIHx8IHZhbC5tZXNzYWdlO1xuICByZXR1cm4gdmFsO1xufVxuIiwiLyoqXG4gKiBIZWxwZXJzLlxuICovXG5cbnZhciBzID0gMTAwMDtcbnZhciBtID0gcyAqIDYwO1xudmFyIGggPSBtICogNjA7XG52YXIgZCA9IGggKiAyNDtcbnZhciB5ID0gZCAqIDM2NS4yNTtcblxuLyoqXG4gKiBQYXJzZSBvciBmb3JtYXQgdGhlIGdpdmVuIGB2YWxgLlxuICpcbiAqIE9wdGlvbnM6XG4gKlxuICogIC0gYGxvbmdgIHZlcmJvc2UgZm9ybWF0dGluZyBbZmFsc2VdXG4gKlxuICogQHBhcmFtIHtTdHJpbmd8TnVtYmVyfSB2YWxcbiAqIEBwYXJhbSB7T2JqZWN0fSBvcHRpb25zXG4gKiBAcmV0dXJuIHtTdHJpbmd8TnVtYmVyfVxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKHZhbCwgb3B0aW9ucyl7XG4gIG9wdGlvbnMgPSBvcHRpb25zIHx8IHt9O1xuICBpZiAoJ3N0cmluZycgPT0gdHlwZW9mIHZhbCkgcmV0dXJuIHBhcnNlKHZhbCk7XG4gIHJldHVybiBvcHRpb25zLmxvbmdcbiAgICA/IGxvbmcodmFsKVxuICAgIDogc2hvcnQodmFsKTtcbn07XG5cbi8qKlxuICogUGFyc2UgdGhlIGdpdmVuIGBzdHJgIGFuZCByZXR1cm4gbWlsbGlzZWNvbmRzLlxuICpcbiAqIEBwYXJhbSB7U3RyaW5nfSBzdHJcbiAqIEByZXR1cm4ge051bWJlcn1cbiAqIEBhcGkgcHJpdmF0ZVxuICovXG5cbmZ1bmN0aW9uIHBhcnNlKHN0cikge1xuICBzdHIgPSAnJyArIHN0cjtcbiAgaWYgKHN0ci5sZW5ndGggPiAxMDAwMCkgcmV0dXJuO1xuICB2YXIgbWF0Y2ggPSAvXigoPzpcXGQrKT9cXC4/XFxkKykgKihtaWxsaXNlY29uZHM/fG1zZWNzP3xtc3xzZWNvbmRzP3xzZWNzP3xzfG1pbnV0ZXM/fG1pbnM/fG18aG91cnM/fGhycz98aHxkYXlzP3xkfHllYXJzP3x5cnM/fHkpPyQvaS5leGVjKHN0cik7XG4gIGlmICghbWF0Y2gpIHJldHVybjtcbiAgdmFyIG4gPSBwYXJzZUZsb2F0KG1hdGNoWzFdKTtcbiAgdmFyIHR5cGUgPSAobWF0Y2hbMl0gfHwgJ21zJykudG9Mb3dlckNhc2UoKTtcbiAgc3dpdGNoICh0eXBlKSB7XG4gICAgY2FzZSAneWVhcnMnOlxuICAgIGNhc2UgJ3llYXInOlxuICAgIGNhc2UgJ3lycyc6XG4gICAgY2FzZSAneXInOlxuICAgIGNhc2UgJ3knOlxuICAgICAgcmV0dXJuIG4gKiB5O1xuICAgIGNhc2UgJ2RheXMnOlxuICAgIGNhc2UgJ2RheSc6XG4gICAgY2FzZSAnZCc6XG4gICAgICByZXR1cm4gbiAqIGQ7XG4gICAgY2FzZSAnaG91cnMnOlxuICAgIGNhc2UgJ2hvdXInOlxuICAgIGNhc2UgJ2hycyc6XG4gICAgY2FzZSAnaHInOlxuICAgIGNhc2UgJ2gnOlxuICAgICAgcmV0dXJuIG4gKiBoO1xuICAgIGNhc2UgJ21pbnV0ZXMnOlxuICAgIGNhc2UgJ21pbnV0ZSc6XG4gICAgY2FzZSAnbWlucyc6XG4gICAgY2FzZSAnbWluJzpcbiAgICBjYXNlICdtJzpcbiAgICAgIHJldHVybiBuICogbTtcbiAgICBjYXNlICdzZWNvbmRzJzpcbiAgICBjYXNlICdzZWNvbmQnOlxuICAgIGNhc2UgJ3NlY3MnOlxuICAgIGNhc2UgJ3NlYyc6XG4gICAgY2FzZSAncyc6XG4gICAgICByZXR1cm4gbiAqIHM7XG4gICAgY2FzZSAnbWlsbGlzZWNvbmRzJzpcbiAgICBjYXNlICdtaWxsaXNlY29uZCc6XG4gICAgY2FzZSAnbXNlY3MnOlxuICAgIGNhc2UgJ21zZWMnOlxuICAgIGNhc2UgJ21zJzpcbiAgICAgIHJldHVybiBuO1xuICB9XG59XG5cbi8qKlxuICogU2hvcnQgZm9ybWF0IGZvciBgbXNgLlxuICpcbiAqIEBwYXJhbSB7TnVtYmVyfSBtc1xuICogQHJldHVybiB7U3RyaW5nfVxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuZnVuY3Rpb24gc2hvcnQobXMpIHtcbiAgaWYgKG1zID49IGQpIHJldHVybiBNYXRoLnJvdW5kKG1zIC8gZCkgKyAnZCc7XG4gIGlmIChtcyA+PSBoKSByZXR1cm4gTWF0aC5yb3VuZChtcyAvIGgpICsgJ2gnO1xuICBpZiAobXMgPj0gbSkgcmV0dXJuIE1hdGgucm91bmQobXMgLyBtKSArICdtJztcbiAgaWYgKG1zID49IHMpIHJldHVybiBNYXRoLnJvdW5kKG1zIC8gcykgKyAncyc7XG4gIHJldHVybiBtcyArICdtcyc7XG59XG5cbi8qKlxuICogTG9uZyBmb3JtYXQgZm9yIGBtc2AuXG4gKlxuICogQHBhcmFtIHtOdW1iZXJ9IG1zXG4gKiBAcmV0dXJuIHtTdHJpbmd9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBsb25nKG1zKSB7XG4gIHJldHVybiBwbHVyYWwobXMsIGQsICdkYXknKVxuICAgIHx8IHBsdXJhbChtcywgaCwgJ2hvdXInKVxuICAgIHx8IHBsdXJhbChtcywgbSwgJ21pbnV0ZScpXG4gICAgfHwgcGx1cmFsKG1zLCBzLCAnc2Vjb25kJylcbiAgICB8fCBtcyArICcgbXMnO1xufVxuXG4vKipcbiAqIFBsdXJhbGl6YXRpb24gaGVscGVyLlxuICovXG5cbmZ1bmN0aW9uIHBsdXJhbChtcywgbiwgbmFtZSkge1xuICBpZiAobXMgPCBuKSByZXR1cm47XG4gIGlmIChtcyA8IG4gKiAxLjUpIHJldHVybiBNYXRoLmZsb29yKG1zIC8gbikgKyAnICcgKyBuYW1lO1xuICByZXR1cm4gTWF0aC5jZWlsKG1zIC8gbikgKyAnICcgKyBuYW1lICsgJ3MnO1xufVxuIiwibW9kdWxlLmV4cG9ydHMgPSB0b0FycmF5XG5cbmZ1bmN0aW9uIHRvQXJyYXkobGlzdCwgaW5kZXgpIHtcbiAgICB2YXIgYXJyYXkgPSBbXVxuXG4gICAgaW5kZXggPSBpbmRleCB8fCAwXG5cbiAgICBmb3IgKHZhciBpID0gaW5kZXggfHwgMDsgaSA8IGxpc3QubGVuZ3RoOyBpKyspIHtcbiAgICAgICAgYXJyYXlbaSAtIGluZGV4XSA9IGxpc3RbaV1cbiAgICB9XG5cbiAgICByZXR1cm4gYXJyYXlcbn1cbiIsIi8qISBodHRwczovL210aHMuYmUvd3RmOCB2MS4wLjAgYnkgQG1hdGhpYXMgKi9cbjsoZnVuY3Rpb24ocm9vdCkge1xuXG5cdC8vIERldGVjdCBmcmVlIHZhcmlhYmxlcyBgZXhwb3J0c2Bcblx0dmFyIGZyZWVFeHBvcnRzID0gdHlwZW9mIGV4cG9ydHMgPT0gJ29iamVjdCcgJiYgZXhwb3J0cztcblxuXHQvLyBEZXRlY3QgZnJlZSB2YXJpYWJsZSBgbW9kdWxlYFxuXHR2YXIgZnJlZU1vZHVsZSA9IHR5cGVvZiBtb2R1bGUgPT0gJ29iamVjdCcgJiYgbW9kdWxlICYmXG5cdFx0bW9kdWxlLmV4cG9ydHMgPT0gZnJlZUV4cG9ydHMgJiYgbW9kdWxlO1xuXG5cdC8vIERldGVjdCBmcmVlIHZhcmlhYmxlIGBnbG9iYWxgLCBmcm9tIE5vZGUuanMgb3IgQnJvd3NlcmlmaWVkIGNvZGUsXG5cdC8vIGFuZCB1c2UgaXQgYXMgYHJvb3RgXG5cdHZhciBmcmVlR2xvYmFsID0gdHlwZW9mIGdsb2JhbCA9PSAnb2JqZWN0JyAmJiBnbG9iYWw7XG5cdGlmIChmcmVlR2xvYmFsLmdsb2JhbCA9PT0gZnJlZUdsb2JhbCB8fCBmcmVlR2xvYmFsLndpbmRvdyA9PT0gZnJlZUdsb2JhbCkge1xuXHRcdHJvb3QgPSBmcmVlR2xvYmFsO1xuXHR9XG5cblx0LyotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSovXG5cblx0dmFyIHN0cmluZ0Zyb21DaGFyQ29kZSA9IFN0cmluZy5mcm9tQ2hhckNvZGU7XG5cblx0Ly8gVGFrZW4gZnJvbSBodHRwczovL210aHMuYmUvcHVueWNvZGVcblx0ZnVuY3Rpb24gdWNzMmRlY29kZShzdHJpbmcpIHtcblx0XHR2YXIgb3V0cHV0ID0gW107XG5cdFx0dmFyIGNvdW50ZXIgPSAwO1xuXHRcdHZhciBsZW5ndGggPSBzdHJpbmcubGVuZ3RoO1xuXHRcdHZhciB2YWx1ZTtcblx0XHR2YXIgZXh0cmE7XG5cdFx0d2hpbGUgKGNvdW50ZXIgPCBsZW5ndGgpIHtcblx0XHRcdHZhbHVlID0gc3RyaW5nLmNoYXJDb2RlQXQoY291bnRlcisrKTtcblx0XHRcdGlmICh2YWx1ZSA+PSAweEQ4MDAgJiYgdmFsdWUgPD0gMHhEQkZGICYmIGNvdW50ZXIgPCBsZW5ndGgpIHtcblx0XHRcdFx0Ly8gaGlnaCBzdXJyb2dhdGUsIGFuZCB0aGVyZSBpcyBhIG5leHQgY2hhcmFjdGVyXG5cdFx0XHRcdGV4dHJhID0gc3RyaW5nLmNoYXJDb2RlQXQoY291bnRlcisrKTtcblx0XHRcdFx0aWYgKChleHRyYSAmIDB4RkMwMCkgPT0gMHhEQzAwKSB7IC8vIGxvdyBzdXJyb2dhdGVcblx0XHRcdFx0XHRvdXRwdXQucHVzaCgoKHZhbHVlICYgMHgzRkYpIDw8IDEwKSArIChleHRyYSAmIDB4M0ZGKSArIDB4MTAwMDApO1xuXHRcdFx0XHR9IGVsc2Uge1xuXHRcdFx0XHRcdC8vIHVubWF0Y2hlZCBzdXJyb2dhdGU7IG9ubHkgYXBwZW5kIHRoaXMgY29kZSB1bml0LCBpbiBjYXNlIHRoZSBuZXh0XG5cdFx0XHRcdFx0Ly8gY29kZSB1bml0IGlzIHRoZSBoaWdoIHN1cnJvZ2F0ZSBvZiBhIHN1cnJvZ2F0ZSBwYWlyXG5cdFx0XHRcdFx0b3V0cHV0LnB1c2godmFsdWUpO1xuXHRcdFx0XHRcdGNvdW50ZXItLTtcblx0XHRcdFx0fVxuXHRcdFx0fSBlbHNlIHtcblx0XHRcdFx0b3V0cHV0LnB1c2godmFsdWUpO1xuXHRcdFx0fVxuXHRcdH1cblx0XHRyZXR1cm4gb3V0cHV0O1xuXHR9XG5cblx0Ly8gVGFrZW4gZnJvbSBodHRwczovL210aHMuYmUvcHVueWNvZGVcblx0ZnVuY3Rpb24gdWNzMmVuY29kZShhcnJheSkge1xuXHRcdHZhciBsZW5ndGggPSBhcnJheS5sZW5ndGg7XG5cdFx0dmFyIGluZGV4ID0gLTE7XG5cdFx0dmFyIHZhbHVlO1xuXHRcdHZhciBvdXRwdXQgPSAnJztcblx0XHR3aGlsZSAoKytpbmRleCA8IGxlbmd0aCkge1xuXHRcdFx0dmFsdWUgPSBhcnJheVtpbmRleF07XG5cdFx0XHRpZiAodmFsdWUgPiAweEZGRkYpIHtcblx0XHRcdFx0dmFsdWUgLT0gMHgxMDAwMDtcblx0XHRcdFx0b3V0cHV0ICs9IHN0cmluZ0Zyb21DaGFyQ29kZSh2YWx1ZSA+Pj4gMTAgJiAweDNGRiB8IDB4RDgwMCk7XG5cdFx0XHRcdHZhbHVlID0gMHhEQzAwIHwgdmFsdWUgJiAweDNGRjtcblx0XHRcdH1cblx0XHRcdG91dHB1dCArPSBzdHJpbmdGcm9tQ2hhckNvZGUodmFsdWUpO1xuXHRcdH1cblx0XHRyZXR1cm4gb3V0cHV0O1xuXHR9XG5cblx0LyotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSovXG5cblx0ZnVuY3Rpb24gY3JlYXRlQnl0ZShjb2RlUG9pbnQsIHNoaWZ0KSB7XG5cdFx0cmV0dXJuIHN0cmluZ0Zyb21DaGFyQ29kZSgoKGNvZGVQb2ludCA+PiBzaGlmdCkgJiAweDNGKSB8IDB4ODApO1xuXHR9XG5cblx0ZnVuY3Rpb24gZW5jb2RlQ29kZVBvaW50KGNvZGVQb2ludCkge1xuXHRcdGlmICgoY29kZVBvaW50ICYgMHhGRkZGRkY4MCkgPT0gMCkgeyAvLyAxLWJ5dGUgc2VxdWVuY2Vcblx0XHRcdHJldHVybiBzdHJpbmdGcm9tQ2hhckNvZGUoY29kZVBvaW50KTtcblx0XHR9XG5cdFx0dmFyIHN5bWJvbCA9ICcnO1xuXHRcdGlmICgoY29kZVBvaW50ICYgMHhGRkZGRjgwMCkgPT0gMCkgeyAvLyAyLWJ5dGUgc2VxdWVuY2Vcblx0XHRcdHN5bWJvbCA9IHN0cmluZ0Zyb21DaGFyQ29kZSgoKGNvZGVQb2ludCA+PiA2KSAmIDB4MUYpIHwgMHhDMCk7XG5cdFx0fVxuXHRcdGVsc2UgaWYgKChjb2RlUG9pbnQgJiAweEZGRkYwMDAwKSA9PSAwKSB7IC8vIDMtYnl0ZSBzZXF1ZW5jZVxuXHRcdFx0c3ltYm9sID0gc3RyaW5nRnJvbUNoYXJDb2RlKCgoY29kZVBvaW50ID4+IDEyKSAmIDB4MEYpIHwgMHhFMCk7XG5cdFx0XHRzeW1ib2wgKz0gY3JlYXRlQnl0ZShjb2RlUG9pbnQsIDYpO1xuXHRcdH1cblx0XHRlbHNlIGlmICgoY29kZVBvaW50ICYgMHhGRkUwMDAwMCkgPT0gMCkgeyAvLyA0LWJ5dGUgc2VxdWVuY2Vcblx0XHRcdHN5bWJvbCA9IHN0cmluZ0Zyb21DaGFyQ29kZSgoKGNvZGVQb2ludCA+PiAxOCkgJiAweDA3KSB8IDB4RjApO1xuXHRcdFx0c3ltYm9sICs9IGNyZWF0ZUJ5dGUoY29kZVBvaW50LCAxMik7XG5cdFx0XHRzeW1ib2wgKz0gY3JlYXRlQnl0ZShjb2RlUG9pbnQsIDYpO1xuXHRcdH1cblx0XHRzeW1ib2wgKz0gc3RyaW5nRnJvbUNoYXJDb2RlKChjb2RlUG9pbnQgJiAweDNGKSB8IDB4ODApO1xuXHRcdHJldHVybiBzeW1ib2w7XG5cdH1cblxuXHRmdW5jdGlvbiB3dGY4ZW5jb2RlKHN0cmluZykge1xuXHRcdHZhciBjb2RlUG9pbnRzID0gdWNzMmRlY29kZShzdHJpbmcpO1xuXHRcdHZhciBsZW5ndGggPSBjb2RlUG9pbnRzLmxlbmd0aDtcblx0XHR2YXIgaW5kZXggPSAtMTtcblx0XHR2YXIgY29kZVBvaW50O1xuXHRcdHZhciBieXRlU3RyaW5nID0gJyc7XG5cdFx0d2hpbGUgKCsraW5kZXggPCBsZW5ndGgpIHtcblx0XHRcdGNvZGVQb2ludCA9IGNvZGVQb2ludHNbaW5kZXhdO1xuXHRcdFx0Ynl0ZVN0cmluZyArPSBlbmNvZGVDb2RlUG9pbnQoY29kZVBvaW50KTtcblx0XHR9XG5cdFx0cmV0dXJuIGJ5dGVTdHJpbmc7XG5cdH1cblxuXHQvKi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tKi9cblxuXHRmdW5jdGlvbiByZWFkQ29udGludWF0aW9uQnl0ZSgpIHtcblx0XHRpZiAoYnl0ZUluZGV4ID49IGJ5dGVDb3VudCkge1xuXHRcdFx0dGhyb3cgRXJyb3IoJ0ludmFsaWQgYnl0ZSBpbmRleCcpO1xuXHRcdH1cblxuXHRcdHZhciBjb250aW51YXRpb25CeXRlID0gYnl0ZUFycmF5W2J5dGVJbmRleF0gJiAweEZGO1xuXHRcdGJ5dGVJbmRleCsrO1xuXG5cdFx0aWYgKChjb250aW51YXRpb25CeXRlICYgMHhDMCkgPT0gMHg4MCkge1xuXHRcdFx0cmV0dXJuIGNvbnRpbnVhdGlvbkJ5dGUgJiAweDNGO1xuXHRcdH1cblxuXHRcdC8vIElmIHdlIGVuZCB1cCBoZXJlLCBpdOKAmXMgbm90IGEgY29udGludWF0aW9uIGJ5dGUuXG5cdFx0dGhyb3cgRXJyb3IoJ0ludmFsaWQgY29udGludWF0aW9uIGJ5dGUnKTtcblx0fVxuXG5cdGZ1bmN0aW9uIGRlY29kZVN5bWJvbCgpIHtcblx0XHR2YXIgYnl0ZTE7XG5cdFx0dmFyIGJ5dGUyO1xuXHRcdHZhciBieXRlMztcblx0XHR2YXIgYnl0ZTQ7XG5cdFx0dmFyIGNvZGVQb2ludDtcblxuXHRcdGlmIChieXRlSW5kZXggPiBieXRlQ291bnQpIHtcblx0XHRcdHRocm93IEVycm9yKCdJbnZhbGlkIGJ5dGUgaW5kZXgnKTtcblx0XHR9XG5cblx0XHRpZiAoYnl0ZUluZGV4ID09IGJ5dGVDb3VudCkge1xuXHRcdFx0cmV0dXJuIGZhbHNlO1xuXHRcdH1cblxuXHRcdC8vIFJlYWQgdGhlIGZpcnN0IGJ5dGUuXG5cdFx0Ynl0ZTEgPSBieXRlQXJyYXlbYnl0ZUluZGV4XSAmIDB4RkY7XG5cdFx0Ynl0ZUluZGV4Kys7XG5cblx0XHQvLyAxLWJ5dGUgc2VxdWVuY2UgKG5vIGNvbnRpbnVhdGlvbiBieXRlcylcblx0XHRpZiAoKGJ5dGUxICYgMHg4MCkgPT0gMCkge1xuXHRcdFx0cmV0dXJuIGJ5dGUxO1xuXHRcdH1cblxuXHRcdC8vIDItYnl0ZSBzZXF1ZW5jZVxuXHRcdGlmICgoYnl0ZTEgJiAweEUwKSA9PSAweEMwKSB7XG5cdFx0XHR2YXIgYnl0ZTIgPSByZWFkQ29udGludWF0aW9uQnl0ZSgpO1xuXHRcdFx0Y29kZVBvaW50ID0gKChieXRlMSAmIDB4MUYpIDw8IDYpIHwgYnl0ZTI7XG5cdFx0XHRpZiAoY29kZVBvaW50ID49IDB4ODApIHtcblx0XHRcdFx0cmV0dXJuIGNvZGVQb2ludDtcblx0XHRcdH0gZWxzZSB7XG5cdFx0XHRcdHRocm93IEVycm9yKCdJbnZhbGlkIGNvbnRpbnVhdGlvbiBieXRlJyk7XG5cdFx0XHR9XG5cdFx0fVxuXG5cdFx0Ly8gMy1ieXRlIHNlcXVlbmNlIChtYXkgaW5jbHVkZSB1bnBhaXJlZCBzdXJyb2dhdGVzKVxuXHRcdGlmICgoYnl0ZTEgJiAweEYwKSA9PSAweEUwKSB7XG5cdFx0XHRieXRlMiA9IHJlYWRDb250aW51YXRpb25CeXRlKCk7XG5cdFx0XHRieXRlMyA9IHJlYWRDb250aW51YXRpb25CeXRlKCk7XG5cdFx0XHRjb2RlUG9pbnQgPSAoKGJ5dGUxICYgMHgwRikgPDwgMTIpIHwgKGJ5dGUyIDw8IDYpIHwgYnl0ZTM7XG5cdFx0XHRpZiAoY29kZVBvaW50ID49IDB4MDgwMCkge1xuXHRcdFx0XHRyZXR1cm4gY29kZVBvaW50O1xuXHRcdFx0fSBlbHNlIHtcblx0XHRcdFx0dGhyb3cgRXJyb3IoJ0ludmFsaWQgY29udGludWF0aW9uIGJ5dGUnKTtcblx0XHRcdH1cblx0XHR9XG5cblx0XHQvLyA0LWJ5dGUgc2VxdWVuY2Vcblx0XHRpZiAoKGJ5dGUxICYgMHhGOCkgPT0gMHhGMCkge1xuXHRcdFx0Ynl0ZTIgPSByZWFkQ29udGludWF0aW9uQnl0ZSgpO1xuXHRcdFx0Ynl0ZTMgPSByZWFkQ29udGludWF0aW9uQnl0ZSgpO1xuXHRcdFx0Ynl0ZTQgPSByZWFkQ29udGludWF0aW9uQnl0ZSgpO1xuXHRcdFx0Y29kZVBvaW50ID0gKChieXRlMSAmIDB4MEYpIDw8IDB4MTIpIHwgKGJ5dGUyIDw8IDB4MEMpIHxcblx0XHRcdFx0KGJ5dGUzIDw8IDB4MDYpIHwgYnl0ZTQ7XG5cdFx0XHRpZiAoY29kZVBvaW50ID49IDB4MDEwMDAwICYmIGNvZGVQb2ludCA8PSAweDEwRkZGRikge1xuXHRcdFx0XHRyZXR1cm4gY29kZVBvaW50O1xuXHRcdFx0fVxuXHRcdH1cblxuXHRcdHRocm93IEVycm9yKCdJbnZhbGlkIFdURi04IGRldGVjdGVkJyk7XG5cdH1cblxuXHR2YXIgYnl0ZUFycmF5O1xuXHR2YXIgYnl0ZUNvdW50O1xuXHR2YXIgYnl0ZUluZGV4O1xuXHRmdW5jdGlvbiB3dGY4ZGVjb2RlKGJ5dGVTdHJpbmcpIHtcblx0XHRieXRlQXJyYXkgPSB1Y3MyZGVjb2RlKGJ5dGVTdHJpbmcpO1xuXHRcdGJ5dGVDb3VudCA9IGJ5dGVBcnJheS5sZW5ndGg7XG5cdFx0Ynl0ZUluZGV4ID0gMDtcblx0XHR2YXIgY29kZVBvaW50cyA9IFtdO1xuXHRcdHZhciB0bXA7XG5cdFx0d2hpbGUgKCh0bXAgPSBkZWNvZGVTeW1ib2woKSkgIT09IGZhbHNlKSB7XG5cdFx0XHRjb2RlUG9pbnRzLnB1c2godG1wKTtcblx0XHR9XG5cdFx0cmV0dXJuIHVjczJlbmNvZGUoY29kZVBvaW50cyk7XG5cdH1cblxuXHQvKi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tKi9cblxuXHR2YXIgd3RmOCA9IHtcblx0XHQndmVyc2lvbic6ICcxLjAuMCcsXG5cdFx0J2VuY29kZSc6IHd0ZjhlbmNvZGUsXG5cdFx0J2RlY29kZSc6IHd0ZjhkZWNvZGVcblx0fTtcblxuXHQvLyBTb21lIEFNRCBidWlsZCBvcHRpbWl6ZXJzLCBsaWtlIHIuanMsIGNoZWNrIGZvciBzcGVjaWZpYyBjb25kaXRpb24gcGF0dGVybnNcblx0Ly8gbGlrZSB0aGUgZm9sbG93aW5nOlxuXHRpZiAoXG5cdFx0dHlwZW9mIGRlZmluZSA9PSAnZnVuY3Rpb24nICYmXG5cdFx0dHlwZW9mIGRlZmluZS5hbWQgPT0gJ29iamVjdCcgJiZcblx0XHRkZWZpbmUuYW1kXG5cdCkge1xuXHRcdGRlZmluZShmdW5jdGlvbigpIHtcblx0XHRcdHJldHVybiB3dGY4O1xuXHRcdH0pO1xuXHR9XHRlbHNlIGlmIChmcmVlRXhwb3J0cyAmJiAhZnJlZUV4cG9ydHMubm9kZVR5cGUpIHtcblx0XHRpZiAoZnJlZU1vZHVsZSkgeyAvLyBpbiBOb2RlLmpzIG9yIFJpbmdvSlMgdjAuOC4wK1xuXHRcdFx0ZnJlZU1vZHVsZS5leHBvcnRzID0gd3RmODtcblx0XHR9IGVsc2UgeyAvLyBpbiBOYXJ3aGFsIG9yIFJpbmdvSlMgdjAuNy4wLVxuXHRcdFx0dmFyIG9iamVjdCA9IHt9O1xuXHRcdFx0dmFyIGhhc093blByb3BlcnR5ID0gb2JqZWN0Lmhhc093blByb3BlcnR5O1xuXHRcdFx0Zm9yICh2YXIga2V5IGluIHd0ZjgpIHtcblx0XHRcdFx0aGFzT3duUHJvcGVydHkuY2FsbCh3dGY4LCBrZXkpICYmIChmcmVlRXhwb3J0c1trZXldID0gd3RmOFtrZXldKTtcblx0XHRcdH1cblx0XHR9XG5cdH0gZWxzZSB7IC8vIGluIFJoaW5vIG9yIGEgd2ViIGJyb3dzZXJcblx0XHRyb290Lnd0ZjggPSB3dGY4O1xuXHR9XG5cbn0odGhpcykpO1xuIiwiJ3VzZSBzdHJpY3QnO1xuXG52YXIgYWxwaGFiZXQgPSAnMDEyMzQ1Njc4OUFCQ0RFRkdISUpLTE1OT1BRUlNUVVZXWFlaYWJjZGVmZ2hpamtsbW5vcHFyc3R1dnd4eXotXycuc3BsaXQoJycpXG4gICwgbGVuZ3RoID0gNjRcbiAgLCBtYXAgPSB7fVxuICAsIHNlZWQgPSAwXG4gICwgaSA9IDBcbiAgLCBwcmV2O1xuXG4vKipcbiAqIFJldHVybiBhIHN0cmluZyByZXByZXNlbnRpbmcgdGhlIHNwZWNpZmllZCBudW1iZXIuXG4gKlxuICogQHBhcmFtIHtOdW1iZXJ9IG51bSBUaGUgbnVtYmVyIHRvIGNvbnZlcnQuXG4gKiBAcmV0dXJucyB7U3RyaW5nfSBUaGUgc3RyaW5nIHJlcHJlc2VudGF0aW9uIG9mIHRoZSBudW1iZXIuXG4gKiBAYXBpIHB1YmxpY1xuICovXG5mdW5jdGlvbiBlbmNvZGUobnVtKSB7XG4gIHZhciBlbmNvZGVkID0gJyc7XG5cbiAgZG8ge1xuICAgIGVuY29kZWQgPSBhbHBoYWJldFtudW0gJSBsZW5ndGhdICsgZW5jb2RlZDtcbiAgICBudW0gPSBNYXRoLmZsb29yKG51bSAvIGxlbmd0aCk7XG4gIH0gd2hpbGUgKG51bSA+IDApO1xuXG4gIHJldHVybiBlbmNvZGVkO1xufVxuXG4vKipcbiAqIFJldHVybiB0aGUgaW50ZWdlciB2YWx1ZSBzcGVjaWZpZWQgYnkgdGhlIGdpdmVuIHN0cmluZy5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gc3RyIFRoZSBzdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtOdW1iZXJ9IFRoZSBpbnRlZ2VyIHZhbHVlIHJlcHJlc2VudGVkIGJ5IHRoZSBzdHJpbmcuXG4gKiBAYXBpIHB1YmxpY1xuICovXG5mdW5jdGlvbiBkZWNvZGUoc3RyKSB7XG4gIHZhciBkZWNvZGVkID0gMDtcblxuICBmb3IgKGkgPSAwOyBpIDwgc3RyLmxlbmd0aDsgaSsrKSB7XG4gICAgZGVjb2RlZCA9IGRlY29kZWQgKiBsZW5ndGggKyBtYXBbc3RyLmNoYXJBdChpKV07XG4gIH1cblxuICByZXR1cm4gZGVjb2RlZDtcbn1cblxuLyoqXG4gKiBZZWFzdDogQSB0aW55IGdyb3dpbmcgaWQgZ2VuZXJhdG9yLlxuICpcbiAqIEByZXR1cm5zIHtTdHJpbmd9IEEgdW5pcXVlIGlkLlxuICogQGFwaSBwdWJsaWNcbiAqL1xuZnVuY3Rpb24geWVhc3QoKSB7XG4gIHZhciBub3cgPSBlbmNvZGUoK25ldyBEYXRlKCkpO1xuXG4gIGlmIChub3cgIT09IHByZXYpIHJldHVybiBzZWVkID0gMCwgcHJldiA9IG5vdztcbiAgcmV0dXJuIG5vdyArJy4nKyBlbmNvZGUoc2VlZCsrKTtcbn1cblxuLy9cbi8vIE1hcCBlYWNoIGNoYXJhY3RlciB0byBpdHMgaW5kZXguXG4vL1xuZm9yICg7IGkgPCBsZW5ndGg7IGkrKykgbWFwW2FscGhhYmV0W2ldXSA9IGk7XG5cbi8vXG4vLyBFeHBvc2UgdGhlIGB5ZWFzdGAsIGBlbmNvZGVgIGFuZCBgZGVjb2RlYCBmdW5jdGlvbnMuXG4vL1xueWVhc3QuZW5jb2RlID0gZW5jb2RlO1xueWVhc3QuZGVjb2RlID0gZGVjb2RlO1xubW9kdWxlLmV4cG9ydHMgPSB5ZWFzdDtcbiIsIlwidXNlIHN0cmljdFwiO1xuXG4vLyB0aGlzIGlzIHdoYXQgaXMgcmV0dXJuZWQgYnkgbmV3IFJsdG0oKVxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihzZXR1cCkge1xuXG4gICAgLy8gdGhlc2UgYXJlIGF2YWlsYWJsZSByZWFsdGltZSBwcm92aWRlcnMgYW5kIHRoZWlyIGRlZmluaXRpb25zXG4gICAgY29uc3Qgc2VydmljZXMgPSB7XG4gICAgICAgIHB1Ym51YjogcmVxdWlyZSgnLi9zZXJ2aWNlcy9wdWJudWInKSxcbiAgICAgICAgc29ja2V0aW86IHJlcXVpcmUoJy4vc2VydmljZXMvc29ja2V0aW8nKSBcbiAgICB9O1xuICAgIFxuICAgIC8vIHJldHVybiBlcnJvciBpZiBzZXJ2aWNlIGlzIG5vdCBzZXRcbiAgICBsZXQgc2VydmljZSA9IHNlcnZpY2VzW3NldHVwLnNlcnZpY2VdO1xuXG4gICAgaWYoIXNldHVwLnNlcnZpY2UpIHtcbiAgICAgICAgdGhyb3cgbmV3IEVycm9yKCdZb3UgbXVzdCBzdXBwbHkgYSBzZXJ2aWNlIHByb3BlcnR5LicpO1xuICAgIH1cbiAgICBcbiAgICBpZighc2VydmljZSkge1xuICAgICAgICB0aHJvdyBuZXcgRXJyb3IoJ1RoZSBzZXJ2aWNlIHlvdSBzdXBwbGllZCBpcyBpbnZhbGlkLicpO1xuICAgIH0gXG4gICAgXG4gICAgLy8gYWRkIGNvbmZpZyBpZiBkb2Vzbid0IGV4aXN0XG4gICAgc2V0dXAuY29uZmlnID0gc2V0dXAuY29uZmlnIHx8IHt9O1xuXG4gICAgLy8gc2V0IGEgZGVmYXVsdCB1dWlkIGlmIGl0IGhhcyBub3QgYmVlbiBzZXQgZm9yIHRoaXMgdXNlclxuICAgIHNldHVwLmNvbmZpZy51dWlkID0gc2V0dXAuY29uZmlnLnV1aWQgfHwgbmV3IERhdGUoKTtcblxuICAgIC8vIHNldCB0aGlzIHV1aWQgaWYgaXQgaXMgbm90IHNldFxuICAgIHNldHVwLmNvbmZpZy5zdGF0ZSA9IHNldHVwLmNvbmZpZy5zdGF0ZSB8fCB7fTtcblxuICAgIC8vIGltbWVkaWF0ZWx5IGludm9rZSBhbmQgcmV0dXJuIHRoZSBtYWluIGZ1bmN0aW9uXG4gICAgcmV0dXJuIG5ldyBzZXJ2aWNlKHNldHVwKTtcblxufTsgXG4iLCJcInVzZSBzdHJpY3RcIjtcblxuLy8gaW5jbHVkZSB0aGUgTm9kZUpTIGV2ZW50IGVtaXR0ZXJcbmNvbnN0IEV2ZW50RW1pdHRlciA9IHJlcXVpcmUoJ2V2ZW50cycpO1xuXG4vLyBpbmNsdWRlIHRoZSBQdWJOdWIgamF2YXNjcmlwdCBzZGsgdjRcbmNvbnN0IFB1Yk51YiA9IHJlcXVpcmUoJ3B1Ym51YicpO1xubGV0IGdsb2JhbFJlYWR5ID0gZmFsc2U7XG5cbi8vIHJlcHJlc2VudHMgYSBjb25uZWN0aW9uIHRvIGEgc2luZ2xlIGNoYW5uZWxcbmNsYXNzIFJvb20gZXh0ZW5kcyBFdmVudEVtaXR0ZXIge1xuXG4gICAgY29uc3RydWN0b3IocHVibnViLCBjaGFubmVsLCB1dWlkLCBzdGF0ZSkge1xuXG4gICAgICAgIC8vIGNhbGwgdGhlIEV2ZW50RW1pdHRlciBjb25zdHJ1Y3RvclxuICAgICAgICBzdXBlcigpO1xuXG4gICAgICAgIC8vIGRldGVybWluZSB0aGUgdXNlcidzIHN0YXRlIFxuICAgICAgICBzdGF0ZSA9IHN0YXRlIHx8IHt9O1xuXG4gICAgICAgIC8vIHN0b3JlIHRoaXMgdXNlcnMgdXVpZFxuICAgICAgICB0aGlzLnV1aWQgPSB1dWlkO1xuXG4gICAgICAgIC8vIGFzc2lnbiB0aGUgY2hhbm5lbCBwYXJhbWV0ZXIgYXMgYSBwcm9wZXJ0eVxuICAgICAgICB0aGlzLmNoYW5uZWwgPSBjaGFubmVsO1xuXG4gICAgICAgIC8vIHNhdmUgcHVibnViIGluIHRoZSBpbnN0YW5jZSBvZiByb29tXG4gICAgICAgIHRoaXMucHVibnViID0gcHVibnViO1xuXG4gICAgICAgIHRoaXMuaXNSZWFkeSA9IGZhbHNlO1xuICAgICAgICBcbiAgICAgICAgLy8gdXNlIHRoZSBQdWJOdWIgbGlicmFyeSB0byBsaXN0ZW4gZm9yIG1lc3NhZ2VzXG4gICAgICAgIHRoaXMucHVibnViLmFkZExpc3RlbmVyKHtcblxuICAgICAgICAgICAgc3RhdHVzOiAoc3RhdHVzRXZlbnQpID0+IHtcblxuICAgICAgICAgICAgICAgIC8vIGRldGVjdCBpZiB0aGlzIGlzIGEgY29ubmVjdGlvbiBldmVudCBvbiB0aGlzIGNoYW5uZWxcbiAgICAgICAgICAgICAgICBpZiAoc3RhdHVzRXZlbnQuY2F0ZWdvcnkgPT09IFwiUE5Db25uZWN0ZWRDYXRlZ29yeVwiIFxuICAgICAgICAgICAgICAgICAgICAmJiAhdGhpcy5pc1JlYWR5XG4gICAgICAgICAgICAgICAgICAgICYmIHN0YXR1c0V2ZW50LmFmZmVjdGVkQ2hhbm5lbHMuaW5kZXhPZihjaGFubmVsKSA+IC0xKSB7XG5cbiAgICAgICAgICAgICAgICAgICAgZ2xvYmFsUmVhZHkgPSB0cnVlO1xuXG4gICAgICAgICAgICAgICAgICAgIC8vIHRlbGwgdGhlIHVzZXIgdGhhdCBmaXJzdCBjb25uZWN0aW9uIG1hZGVcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5vblJlYWR5KCk7XG5cbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9XG4gICAgICAgIH0pO1xuXG4gICAgICAgIHRoaXMucHVibnViLmFkZExpc3RlbmVyKHtcbiAgICAgICAgICAgIG1lc3NhZ2U6IChtKSA9PiB7XG5cbiAgICAgICAgICAgICAgICAvLyBpZiBtZXNzYWdlIGlzIHNlbnQgdG8gdGhpcyBzcGVjaWZpYyBjaGFubmVsXG4gICAgICAgICAgICAgICAgaWYoY2hhbm5lbCA9PSBtLmNoYW5uZWwpIHtcblxuICAgICAgICAgICAgICAgICAgICAvLyBlbWl0IHRoZSBtZXNzYWdlIGFzIGFuIGV2ZW50XG4gICAgICAgICAgICAgICAgICAgIHRoaXMuZW1pdCgnbWVzc2FnZScsIG0ubWVzc2FnZS51dWlkLCBtLm1lc3NhZ2UuZGF0YSk7ICAgXG5cbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9LFxuICAgICAgICAgICAgcHJlc2VuY2U6IChwcmVzZW5jZUV2ZW50KSA9PiB7XG5cbiAgICAgICAgICAgICAgICAvLyBtYWtlIHN1cmUgY2hhbm5lbCBtYXRjaGVzIHRoaXMgY2hhbm5lbFxuICAgICAgICAgICAgICAgIGlmKGNoYW5uZWwgPT0gcHJlc2VuY2VFdmVudC5jaGFubmVsKSB7XG5cbiAgICAgICAgICAgICAgICAgICAgLy8gc29tZW9uZSBqb2lucyBjaGFubmVsXG4gICAgICAgICAgICAgICAgICAgIGlmKHByZXNlbmNlRXZlbnQuYWN0aW9uID09IFwiam9pblwiKSB7XG5cbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuZW1pdCgnam9pbicsIFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIHByZXNlbmNlRXZlbnQudXVpZCwgcHJlc2VuY2VFdmVudC5zdGF0ZSk7XG4gICAgICAgICAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgICAgICAgICAvLyBzb21lb25lIGxlYXZlcyBjaGFubmVsXG4gICAgICAgICAgICAgICAgICAgIGlmKHByZXNlbmNlRXZlbnQuYWN0aW9uID09IFwibGVhdmVcIikge1xuICAgICAgICAgICAgICAgICAgICAgICAgdGhpcy5lbWl0KCdsZWF2ZScsIHByZXNlbmNlRXZlbnQudXVpZCk7XG4gICAgICAgICAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgICAgICAgICAvLyBzb21lb25lIHRpbWVzb3V0XG4gICAgICAgICAgICAgICAgICAgIGlmKHByZXNlbmNlRXZlbnQuYWN0aW9uID09IFwidGltZW91dFwiKSB7XG4gICAgICAgICAgICAgICAgICAgICAgICB0aGlzLmVtaXQoJ2Rpc2Nvbm5lY3QnLCBwcmVzZW5jZUV2ZW50LnV1aWQpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICAgIFxuICAgICAgICAgICAgICAgICAgICAvLyBzb21lb25lJ3Mgc3RhdGUgaXMgdXBkYXRlZFxuICAgICAgICAgICAgICAgICAgICBpZihwcmVzZW5jZUV2ZW50LmFjdGlvbiA9PSBcInN0YXRlLWNoYW5nZVwiKSB7XG4gICAgICAgICAgICAgICAgICAgICAgICB0aGlzLmVtaXQoJ3N0YXRlJywgXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgcHJlc2VuY2VFdmVudC51dWlkLCBwcmVzZW5jZUV2ZW50LnN0YXRlKTtcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICAgICBcbiAgICAgICAgICAgICAgICB9XG5cbiAgICAgICAgICAgIH1cbiAgICAgICAgfSk7XG5cbiAgICAgICAgLy8gdGVsbCBQdWJOdWIgdG8gc3Vic2NyaWJlIHRvIHRoZSBzdXBwbGllZCBjaGFubmVsXG4gICAgICAgIHRoaXMucHVibnViLnN1YnNjcmliZSh7IFxuICAgICAgICAgICAgY2hhbm5lbHM6IFtjaGFubmVsXSxcbiAgICAgICAgICAgIHdpdGhQcmVzZW5jZTogdHJ1ZSxcbiAgICAgICAgICAgIHN0YXRlOiBzdGF0ZVxuICAgICAgICB9KTtcblxuICAgIH1cblxuICAgIC8vIHJlYWR5IGlzIGEgY2FsbGJhY2sgYW5kIG5vdCBhbiBldmVudCBiZWNhdXNlIHB1Ym51YiBtYXkgYmUgcmVhZHlcbiAgICAvLyBpbW1lZGlhdGVseSwgd2hpY2ggZG9lc24ndCBhbGxvdyB0aW1lIHRvIHJlZ2lzdGVyIGFuIGV2ZW50IGhhbmRsZXJcbiAgICAvLyB0aGlzIGNhbiBiZSBzb2x2ZWQgd2l0aCBzZXRUaW1lb3V0KCgpID0+IHt9LCAxMCkgdG8gbGV0IHRoZSBcbiAgICBvblJlYWR5KCkge1xuXG4gICAgICAgIC8vIHdhaXRpbmcgdG8gYmUgYXNzaWduZWQgYnkgdXNlclxuICAgICAgICByZXR1cm47XG5cbiAgICB9XG5cbiAgICByZWFkeSAoZm4pIHtcbiAgICAgICAgXG4gICAgICAgIHRoaXMub25SZWFkeSA9IGZuO1xuXG4gICAgICAgIGlmKGdsb2JhbFJlYWR5KSB7XG4gICAgICAgICAgICB0aGlzLm9uUmVhZHkoKVxuICAgICAgICAgICAgdGhpcy5pc1JlYWR5ID0gdHJ1ZTtcbiAgICAgICAgfVxuXG4gICAgfVxuXG4gICAgbWVzc2FnZSAoZGF0YSkge1xuXG4gICAgICAgIHJldHVybiBuZXcgUHJvbWlzZSgocmVzb2x2ZSwgcmVqZWN0KSA9PiB7XG4gICAgICAgICAgXG4gICAgICAgICAgLy8gcHVibGlzaCB0aGUgZ2l2ZW4gZGF0YSBvdmVyIFB1Yk51YiBjaGFubmVsXG4gICAgICAgICAgdGhpcy5wdWJudWIucHVibGlzaCh7XG4gICAgICAgICAgICAgIGNoYW5uZWw6IHRoaXMuY2hhbm5lbCxcbiAgICAgICAgICAgICAgbWVzc2FnZToge1xuICAgICAgICAgICAgICAgICAgdXVpZDogdGhpcy51dWlkLFxuICAgICAgICAgICAgICAgICAgZGF0YTogZGF0YVxuICAgICAgICAgICAgICB9XG4gICAgICAgICAgfSwgKHN0YXR1cywgcmVzcG9uc2UpID0+IHtcblxuICAgICAgICAgICAgaWYoc3RhdHVzLmVycm9yKSB7XG4gICAgICAgICAgICAgICAgLy8gaWYgdGhlcmUncyBhIHByb2JsZW0gcHVibGlzaGluZywgcmVqZWN0XG4gICAgICAgICAgICAgICAgcmVqZWN0KHN0YXR1cyk7XG4gICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICAgIHJlc29sdmUoKTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgIH0pO1xuXG4gICAgICAgIH0pO1xuXG4gICAgfTtcblxuICAgIGhlcmUoKSB7XG5cbiAgICAgICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICAgICAgXG4gICAgICAgICAgICAvLyBhc2sgUHViTnViIGZvciBpbmZvcm1hdGlvbiBhYm91dCBjb25uZWN0ZWQgdXNlcnMgaW4gdGhpcyBjaGFubmVsXG4gICAgICAgICAgICB0aGlzLnB1Ym51Yi5oZXJlTm93KHtcbiAgICAgICAgICAgICAgICBjaGFubmVsczogW3RoaXMuY2hhbm5lbF0sXG4gICAgICAgICAgICAgICAgaW5jbHVkZVVVSURzOiB0cnVlLFxuICAgICAgICAgICAgICAgIGluY2x1ZGVTdGF0ZTogdHJ1ZVxuICAgICAgICAgICAgfSwgKHN0YXR1cywgcmVzcG9uc2UpID0+IHtcblxuICAgICAgICAgICAgICAgIGlmKHN0YXR1cy5lcnJvcikge1xuICAgICAgICAgICAgICAgICAgICAvLyBpZiB0aGVyZSdzIGEgcHJvYmxlbSB3aXRoIHRoZSByZXF1ZXN0LCByZWplY3RcbiAgICAgICAgICAgICAgICAgICAgcmVqZWN0KHN0YXR1cylcbiAgICAgICAgICAgICAgICB9IGVsc2Uge1xuXG4gICAgICAgICAgICAgICAgICAgIC8vIGJ1aWxkIGEgdXNlcmxpc3QgaW4gcmx0bS5qcyBmb3JtYXRcbiAgICAgICAgICAgICAgICAgICAgbGV0IHVzZXJMaXN0ID0ge307XG5cbiAgICAgICAgICAgICAgICAgICAgLy8gZ2V0IHRoZSBsaXN0IG9mIG9jY3VwYW50cyBpbiB0aGlzIGNoYW5uZWxcbiAgICAgICAgICAgICAgICAgICAgbGV0IG9jY3VwYW50cyA9IHJlc3BvbnNlLmNoYW5uZWxzW3RoaXMuY2hhbm5lbF0ub2NjdXBhbnRzO1xuXG4gICAgICAgICAgICAgICAgICAgIC8vIGZvcm1hdCB0aGUgdXNlckxpc3QgZm9yIHJsdG0uanMgc3RhbmRhcmRcbiAgICAgICAgICAgICAgICAgICAgZm9yKGxldCBpIGluIG9jY3VwYW50cykge1xuICAgICAgICAgICAgICAgICAgICAgICAgdXNlckxpc3Rbb2NjdXBhbnRzW2ldLnV1aWRdID0gb2NjdXBhbnRzW2ldLnN0YXRlO1xuICAgICAgICAgICAgICAgICAgICB9XG5cbiAgICAgICAgICAgICAgICAgICAgLy8gcmVzcG9uZCB3aXRoIGZvcm1hdHRlZCBsaXN0XG4gICAgICAgICAgICAgICAgICAgIHJlc29sdmUodXNlckxpc3QpO1xuXG4gICAgICAgICAgICAgICAgfVxuXG4gICAgICAgICAgICB9KTtcblxuICAgICAgICB9KTtcblxuICAgIH1cblxuICAgIHN0YXRlKHN0YXRlKSB7XG5cbiAgICAgICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICAgICAgICAgIFxuICAgICAgICAgICAgLy8gdXNlIFB1Yk51YiBzdGF0ZSBmdW5jdGlvbiB0byB1cGRhdGUgc3RhdGUgZm9yIGNoYW5uZWxcbiAgICAgICAgICAgIHRoaXMucHVibnViLnNldFN0YXRlKHtcbiAgICAgICAgICAgICAgICBzdGF0ZTogc3RhdGUsXG4gICAgICAgICAgICAgICAgdXVpZDogdGhpcy51dWlkLFxuICAgICAgICAgICAgICAgIGNoYW5uZWxzOiBbdGhpcy5jaGFubmVsXVxuICAgICAgICAgICAgfSwgKHN0YXR1cywgcmVzcG9uc2UpID0+IHtcbiAgICAgICAgICAgICAgICBcbiAgICAgICAgICAgICAgICBpZihzdGF0dXMuZXJyb3IpIHtcbiAgICAgICAgICAgICAgICAgICAgLy8gaWYgdGhlcmUncyBhIHByb2JsZW0gd2l0aCB0aGUgcmVxdWVzdCBsb2cgaXRcbiAgICAgICAgICAgICAgICAgICAgcmVqZWN0KHN0YXR1cyk7ICAgICAgICAgICAgXG4gICAgICAgICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgcmVzb2x2ZSgpO1xuICAgICAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgfSk7XG5cbiAgICAgICAgfSk7XG5cbiAgICB9XG5cbiAgICBoaXN0b3J5KCkge1xuICAgICAgICBcbiAgICAgICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcblxuICAgICAgICAgICAgLy8gcmV0cmlldmVkIHRoZSBtZXNzYWdlIGhpc3Rvcnkgd2l0aCBQdWJOdWJcbiAgICAgICAgICAgIHRoaXMucHVibnViLmhpc3Rvcnkoe1xuICAgICAgICAgICAgICAgIGNoYW5uZWw6IHRoaXMuY2hhbm5lbCxcbiAgICAgICAgICAgICAgICBjb3VudDogMTAwIC8vIGhvdyBtYW55IGl0ZW1zIHRvIGZldGNoXG4gICAgICAgICAgICB9LCAoc3RhdHVzLCByZXNwb25zZSkgPT4ge1xuXG4gICAgICAgICAgICAgICAgaWYoc3RhdHVzLmVycm9yKSB7XG4gICAgICAgICAgICAgICAgICAgIC8vIGlmIHRoZXJlJ3MgYSBwcm9ibGVtIHdpdGggdGhlIHJlcXVlc3QgbG9nIGl0XG4gICAgICAgICAgICAgICAgICAgIHJlamVjdChzdGF0dXMpOyAgICAgICAgICAgIFxuICAgICAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgICAgICAgIFxuICAgICAgICAgICAgICAgICAgICAvLyBjcmVhdGUgb3VyIHJldHVybiBhcnJheVxuICAgICAgICAgICAgICAgICAgICBsZXQgZGF0YSA9IFtdO1xuXG4gICAgICAgICAgICAgICAgICAgIC8vIGxvb3AgdGhyb3VnaCByZXNwb25zZSBhbmQgcHVzaCBkYXRhIHRvIGFycmF5XG4gICAgICAgICAgICAgICAgICAgIGZvcihsZXQgaSBpbiByZXNwb25zZS5tZXNzYWdlcykge1xuICAgICAgICAgICAgICAgICAgICAgICAgZGF0YS5wdXNoKHJlc3BvbnNlLm1lc3NhZ2VzW2ldLmVudHJ5KVxuICAgICAgICAgICAgICAgICAgICB9ICAgXG5cbiAgICAgICAgICAgICAgICAgICAgLy8gcmV2ZXJzZSB0aGUgYXJyYXkgc28gbmV3ZXN0IGFyZSBmaXJzdFxuICAgICAgICAgICAgICAgICAgICBkYXRhID0gZGF0YS5yZXZlcnNlKCk7XG5cbiAgICAgICAgICAgICAgICAgICAgLy8gcmVzcG9uZCB3aXRoIHRoZSBoaXN0b3J5IGRhdGFcbiAgICAgICAgICAgICAgICAgICAgcmVzb2x2ZShkYXRhKTtcblxuICAgICAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgfSk7XG5cbiAgICAgICAgfSk7XG5cbiAgICB9XG5cbiAgICBsZWF2ZSgpIHtcblxuICAgICAgICByZXR1cm4gbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgICAgICAgICAgXG4gICAgICAgICAgICAvLyB0ZWxsIFB1Yk51YiB0byBtYW51YWxseSB1bnN1YnNjcmliZSBmcm9tIHRoaXMgY2hhbm5lbCAgICAgICAgXG4gICAgICAgICAgICB0aGlzLnB1Ym51Yi51bnN1YnNjcmliZSh7XG4gICAgICAgICAgICAgICAgY2hhbm5lbHM6IFt0aGlzLmNoYW5uZWxdLFxuICAgICAgICAgICAgfSk7XG5cbiAgICAgICAgICAgIHJlc29sdmUoKTtcblxuICAgICAgICB9KTtcblxuICAgIH1cbn1cblxuLy8gZXhwb3J0IGEgZ2VuZXJpYyBmdW5jdGlvbiBleHBlY3RlZCBieSBybHRtLmpzXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKHNldHVwKSB7XG5cbiAgICAvLyBjb252ZW5pZW5jZSBtZXRob2QgdG8gYXNzaWduIHRoZSBzZXJ2aWNlIHN0cmluZyBuYW1lIHRvIGl0c2VsZlxuICAgIHRoaXMuc2VydmljZSA9IHNldHVwLnNlcnZpY2U7XG5cbiAgICAvLyBpbml0aWFsaXplIFB1Yk51YiB3aXRoIHN1cHBsaWVkIGNvbmZpZyBpbmZvcm1hdGlvblxuICAgIHRoaXMucHVibnViID0gbmV3IFB1Yk51YihzZXR1cC5jb25maWcpO1xuXG4gICAgLy8gZXhwb3NlIHRoZSBqb2luIG1ldGhvZCB0byBjcmVhdGUgbmV3IHJvb20gY29ubmVjdGlvbnNcbiAgICB0aGlzLmpvaW4gPSAoY2hhbm5lbCwgc3RhdGUpID0+IHtcbiAgICAgICAgcmV0dXJuIG5ldyBSb29tKHRoaXMucHVibnViLCBjaGFubmVsLCBzZXR1cC5jb25maWcudXVpZCwgc3RhdGUpO1xuICAgIH1cblxuICAgIC8vIHJldHVybiB0aGUgaW5zdGFuY2Ugb2YgdGhpcyBzZXJ2aWNlXG4gICAgcmV0dXJuIHRoaXM7XG5cbn07XG4iLCJcInVzZSBzdHJpY3RcIjtcblxuLy8gaW5jbHVkZSBOb2RlSlMgZXZlbnQgZW1pdHRlclxuY29uc3QgRXZlbnRFbWl0dGVyID0gcmVxdWlyZSgnZXZlbnRzJyk7XG5cbi8vIGluY2x1ZGUgdGhlIFNvY2tldC5pbyB1c2VyIGxpYnJhcnlcbmNvbnN0IGlvID0gcmVxdWlyZSgnc29ja2V0LmlvLWNsaWVudCcpO1xuXG4vLyByZXByZXNlbnRzIGEgY29ubmVjdGlvbiB0byBhIHNpbmdsZSBjaGFubmVsXG5jbGFzcyBSb29tIGV4dGVuZHMgRXZlbnRFbWl0dGVyIHtcblxuICAgIGNvbnN0cnVjdG9yKGVuZHBvaW50LCBjaGFubmVsLCB1dWlkLCBzdGF0ZSkge1xuXG4gICAgICAgIC8vIGNhbGwgdGhlIEV2ZW50RW1pdHRlciBjb25zdHJ1Y3RvclxuICAgICAgICBzdXBlcigpO1xuXG4gICAgICAgIC8vIHN0b3JlIHRoaXMgdXNlcnMgdXVpZFxuICAgICAgICB0aGlzLnV1aWQgPSB1dWlkO1xuXG4gICAgICAgIC8vIGFzc2lnbiB0aGUgY2hhbm5lbCBwYXJhbWV0ZXIgYXMgYSBwcm9wZXJ0eVxuICAgICAgICB0aGlzLmNoYW5uZWwgPSBjaGFubmVsO1xuXG4gICAgICAgIHRoaXMuaXNSZWFkeSA9IGZhbHNlO1xuXG4gICAgICAgIC8vIGNyZWF0ZSBhIGNvbm5lY3Rpb24gdG8gdGhlIHNvY2tldGlvIGVuZHBvaW50XG4gICAgICAgIHRoaXMuc29ja2V0ID0gaW8uY29ubmVjdChlbmRwb2ludCwge211bHRpcGxleDogdHJ1ZX0pO1xuXG4gICAgICAgIC8vIHN1YnNjcmliZSB0byB0aGUgc29ja2V0LmlvIGNvbm5lY3Rpb24gZXZlbnRcbiAgICAgICAgdGhpcy5zb2NrZXQub24oJ2Nvbm5lY3QnLCAoKSA9PiB7XG5cbiAgICAgICAgICAgIC8vIHRlbGwgdGhlIHNlcnZlciB0aGF0IHdlIHdhbnQgdG8gam9pbiBhIGNoYW5uZWxcbiAgICAgICAgICAgIHRoaXMuc29ja2V0LmVtaXQoJ2NoYW5uZWwnLCBjaGFubmVsLCB0aGlzLnV1aWQsIHN0YXRlKTtcblxuICAgICAgICAgICAgLy8gdGVsbCB0aGUgdXNlciB0aGUgc2VydmVyIGlzIHJlYWR5XG4gICAgICAgICAgICB0aGlzLm9uUmVhZHkoKTtcbiAgICAgICAgICAgIHRoaXMuaXNSZWFkeSA9IHRydWU7XG5cbiAgICAgICAgfSk7XG5cbiAgICAgICAgLy8gc2VydmVyIHNheXMgc29tZW9uZSBoYXMgam9pbmVkXG4gICAgICAgIHRoaXMuc29ja2V0Lm9uKCdqb2luJywgKGNoYW5uZWwsIHV1aWQsIHN0YXRlKSA9PiB7XG5cbiAgICAgICAgICAgIC8vIG1ha2Ugc3VyZSB0aGUgY2hhbm5lbCBpcyB0aGlzIGNoYW5uZWxcbiAgICAgICAgICAgIGlmKHRoaXMuY2hhbm5lbCA9PSBjaGFubmVsKSB7XG5cbiAgICAgICAgICAgICAgICAvLyBlbWl0IHRoZSAnam9pbicgZXZlbnQgdG8gdGhlIHVzZXJcbiAgICAgICAgICAgICAgICB0aGlzLmVtaXQoJ2pvaW4nLCB1dWlkLCBzdGF0ZSk7XG5cbiAgICAgICAgICAgIH1cblxuICAgICAgICB9KTtcblxuICAgICAgICAvLyBzZXJ2ZXIgc2F5cyBzb21lb25lIGhhcyBsZWZ0XG4gICAgICAgIHRoaXMuc29ja2V0Lm9uKCdsZWF2ZScsIChjaGFubmVsLCB1dWlkKSA9PiB7XG5cbiAgICAgICAgICAgIC8vIG1ha2Ugc3VyZSBpdCdzIG9uIHRoaXMgY2hhbm5lbFxuICAgICAgICAgICAgaWYodGhpcy5jaGFubmVsID09IGNoYW5uZWwpIHtcblxuICAgICAgICAgICAgICAgIC8vIGVtaXQgdGhlICdsZWF2ZScgZXZlbnQgdG8gdGhlIHVzZXJcbiAgICAgICAgICAgICAgICB0aGlzLmVtaXQoJ2xlYXZlJywgdXVpZCk7XG4gICAgICAgICAgICB9XG5cbiAgICAgICAgfSk7XG5cblxuICAgICAgICAvLyBzZXJ2ZXIgc2F5cyBzb21lb25lIGhhcyBkaXNjb25uZWN0ZWRcbiAgICAgICAgdGhpcy5zb2NrZXQub24oJ2Rpc2Nvbm5lY3QnLCAoY2hhbm5lbCwgdXVpZCkgPT4ge1xuXG4gICAgICAgICAgICAvLyBtYWtlIHN1cmUgaXQncyBvbiB0aGlzIGNoYW5uZWxcbiAgICAgICAgICAgIGlmKHRoaXMuY2hhbm5lbCA9PSBjaGFubmVsKSB7XG5cbiAgICAgICAgICAgICAgICAvLyBlbWl0IHRoZSAnbGVhdmUnIGV2ZW50IHRvIHRoZSB1c2VyXG4gICAgICAgICAgICAgICAgdGhpcy5lbWl0KCdkaXNjb25uZWN0JywgdXVpZCk7XG4gICAgICAgICAgICB9XG5cbiAgICAgICAgfSk7XG5cbiAgICAgICAgLy8gYSBtZXNzYWdlIGlzIHNlbnQgZnJvbSB0aGUgc3JldmVyXG4gICAgICAgIHRoaXMuc29ja2V0Lm9uKCdtZXNzYWdlJywgKGNoYW5uZWwsIHV1aWQsIGRhdGEpID0+IHtcblxuICAgICAgICAgICAgLy8gbWFrZSBzdXJlIGl0IGlzIG9uIHRoaXMgY2hhbm5lbFxuICAgICAgICAgICAgaWYodGhpcy5jaGFubmVsID09IGNoYW5uZWwpIHtcblxuICAgICAgICAgICAgICAgIC8vIHRlbGwgdGhlIHVzZXIgb2YgdGhlIG5ldyBtZXNzYWdlXG4gICAgICAgICAgICAgICAgdGhpcy5lbWl0KCdtZXNzYWdlJywgdXVpZCwgZGF0YSk7XG4gICAgICAgICAgICB9XG5cbiAgICAgICAgfSk7XG5cbiAgICAgICAgLy8gYSB1c2VyIHNldHMgdGhlaXIgc3RhdGVcbiAgICAgICAgdGhpcy5zb2NrZXQub24oJ3N0YXRlJywgKGNoYW5uZWwsIHV1aWQsIHN0YXRlKSA9PiB7XG5cbiAgICAgICAgICAgIC8vIG1ha2Ugc3VyZSBpdCBpcyBvbiB0aGlzIGNoYW5uZWxcbiAgICAgICAgICAgIGlmKHRoaXMuY2hhbm5lbCA9PSBjaGFubmVsKSB7XG5cbiAgICAgICAgICAgICAgICAvLyB0ZWxsIHRoZSB1c2VyIG9mIHRoZSBzZXQgc3RhdGVcbiAgICAgICAgICAgICAgICB0aGlzLmVtaXQoJ3N0YXRlJywgdXVpZCwgc3RhdGUpO1xuICAgICAgICAgICAgfVxuXG4gICAgICAgIH0pO1xuXG4gICAgfVxuICAgIHJlYWR5KGZuKSB7XG4gICAgICAgIFxuICAgICAgICB0aGlzLm9uUmVhZHkgPSBmbjtcbiAgICAgICAgXG4gICAgICAgIGlmKHRoaXMuaXNSZWFkeSkge1xuICAgICAgICAgICAgdGhpcy5vblJlYWR5KCk7XG4gICAgICAgIH1cblxuICAgIH1cbiAgICBvblJlYWR5KCkge1xuICAgICAgICAvLyB3YWl0aW5nIHRvIGJlIGFzc2lnbmVkIGJ5IHVzZXJcbiAgICAgICAgcmV0dXJuO1xuICAgIH1cbiAgICBtZXNzYWdlKGRhdGEpIHtcblxuICAgICAgICByZXR1cm4gbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuXG4gICAgICAgICAgICAvLyBwdWJsaXNoIHRoZSBkYXRhIHRvIHRoZSBzb2NrZXQuaW8gc2VydmVyXG4gICAgICAgICAgICB0aGlzLnNvY2tldC5lbWl0KCdwdWJsaXNoJywgdGhpcy5jaGFubmVsLCB0aGlzLnV1aWQsIGRhdGEsICgpID0+e1xuICAgICAgICAgICAgICAgIHJlc29sdmUoKTtcbiAgICAgICAgICAgIH0pO1xuXG4gICAgICAgIH0pO1xuXG4gICAgfVxuICAgIGhlcmUoKSB7XG4gICAgICAgIFxuICAgICAgICAvLyBhc2sgc29ja2V0LmlvLXNlcnZlciBmb3IgYSBsaXN0IG9mIG9ubGluZSB1c2Vyc1xuICAgICAgICByZXR1cm4gbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgICAgICAgICAgXG4gICAgICAgICAgICB0aGlzLnNvY2tldC5lbWl0KCd3aG9zb25saW5lJywgdGhpcy5jaGFubmVsLCBudWxsLCBmdW5jdGlvbih1c2Vycykge1xuXG4gICAgICAgICAgICAgICAgLy8gY2FsbGJhY2sgd2l0aCBhbiBvYmplY3Qgb2YgdXNlcnNcbiAgICAgICAgICAgICAgICByZXNvbHZlKHVzZXJzKTtcblxuICAgICAgICAgICAgfSk7XG5cbiAgICAgICAgfSk7XG5cbiAgICB9XG4gICAgc3RhdGUoc3RhdGUpIHtcbiAgICAgICAgXG4gICAgICAgIHJldHVybiBuZXcgUHJvbWlzZSgocmVzb2x2ZSwgcmVqZWN0KSA9PiB7XG5cbiAgICAgICAgICAgIC8vIHRlbGwgc29ja2V0LmlvLXNlcnZlciB0byB1cGRhdGUgdGhpcyB1c2VyJ3Mgc3RhdGVcbiAgICAgICAgICAgIHRoaXMuc29ja2V0LmVtaXQoJ3NldFN0YXRlJywgdGhpcy5jaGFubmVsLCB0aGlzLnV1aWQsIHN0YXRlLCAoKSA9PiB7XG4gICAgICAgICAgICAgICAgcmVzb2x2ZSgpO1xuICAgICAgICAgICAgfSk7XG5cbiAgICAgICAgfSk7XG5cbiAgICB9XG4gICAgaGlzdG9yeSgpIHtcbiAgICAgICAgXG4gICAgICAgIHJldHVybiBuZXcgUHJvbWlzZSgocmVzb2x2ZSwgcmVqZWN0KSA9PiB7XG4gICAgICAgICAgICAgICAgICAgICAgICBcbiAgICAgICAgICAgIC8vIGFzayBzb2NrZXQuaW8tc2VydmVyIGZvciB0aGUgaGlzdG9yeSBvZiBtZXNzYWdlcyBwdWJsaXNoZWRcbiAgICAgICAgICAgIHRoaXMuc29ja2V0LmVtaXQoJ2hpc3RvcnknLCB0aGlzLmNoYW5uZWwsIChkYXRhKSA9PiB7XG5cbiAgICAgICAgICAgICAgICAvLyBjYWxsYmFjayB3aXRoIGFuIGFycmF5IG9mIG1lc3NhZ2VzXG4gICAgICAgICAgICAgICAgcmVzb2x2ZShkYXRhKTtcblxuICAgICAgICAgICAgfSk7XG5cbiAgICAgICAgfSk7XG5cbiAgICB9XG4gICAgbGVhdmUoY2hhbm5lbCkge1xuICAgICAgICBcbiAgICAgICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcblxuICAgICAgICAgICAgLy8gbWFudWFsbHkgZGlzY29ubmVjdCBmcm9tIHNvY2tldC5pby1zZXJ2ZXJcbiAgICAgICAgICAgIHRoaXMuc29ja2V0LmVtaXQoJ2xlYXZlJywgdGhpcy51dWlkLCBjaGFubmVsLCAoKSA9PiB7XG5cbiAgICAgICAgICAgICAgICByZXNvbHZlKCk7XG5cbiAgICAgICAgICAgIH0pO1xuXG4gICAgICAgIH0pO1xuXG4gICAgfVxuICAgIFxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uIChzZXR1cCkge1xuXG4gICAgLy8gY29udmVuaWVuY2UgbWV0aG9kIHRvIGFzc2lnbiB0aGUgc2VydmljZSBzdHJpbmcgbmFtZSB0byBpdHNlbGZcbiAgICB0aGlzLnNlcnZpY2UgPSBzZXR1cC5zZXJ2aWNlO1xuXG4gICAgdGhpcy5qb2luID0gKGNoYW5uZWwsIHN0YXRlKSA9PiB7XG4gICAgICAgIHJldHVybiBuZXcgUm9vbShzZXR1cC5jb25maWcuZW5kcG9pbnQsIGNoYW5uZWwsIHNldHVwLmNvbmZpZy51dWlkLCBzZXR1cC5jb25maWcuc3RhdGUpO1xuICAgIH07XG5cbiAgICByZXR1cm4gdGhpcztcblxufTtcbiJdfQ==\n"

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1534))

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	module.exports = "/* angularjs Scroll Glue\n * version 2.1.0\n * https://github.com/Luegg/angularjs-scroll-glue\n * An AngularJs directive that automatically scrolls to the bottom of an element on changes in it's scope.\n*/\n\n// Allow module to be loaded via require when using common js. e.g. npm\nif(typeof module === \"object\" && module.exports){\n    module.exports = 'luegg.directives';\n}\n\n(function(angular, undefined){\n    'use strict';\n\n    function createActivationState($parse, attr, scope){\n        function unboundState(initValue){\n            var activated = initValue;\n            return {\n                getValue: function(){\n                    return activated;\n                },\n                setValue: function(value){\n                    activated = value;\n                }\n            };\n        }\n\n        function oneWayBindingState(getter, scope){\n            return {\n                getValue: function(){\n                    return getter(scope);\n                },\n                setValue: function(){}\n            };\n        }\n\n        function twoWayBindingState(getter, setter, scope){\n            return {\n                getValue: function(){\n                    return getter(scope);\n                },\n                setValue: function(value){\n                    if(value !== getter(scope)){\n                        scope.$apply(function(){\n                            setter(scope, value);\n                        });\n                    }\n                }\n            };\n        }\n\n        if(attr !== \"\"){\n            var getter = $parse(attr);\n            if(getter.assign !== undefined){\n                return twoWayBindingState(getter, getter.assign, scope);\n            } else {\n                return oneWayBindingState(getter, scope);\n            }\n        } else {\n            return unboundState(true);\n        }\n    }\n\n    function createDirective(module, attrName, direction){\n        module.directive(attrName, ['$parse', '$window', '$timeout', function($parse, $window, $timeout){\n            return {\n                priority: 1,\n                restrict: 'A',\n                link: function(scope, $el, attrs){\n                    var el = $el[0],\n                        activationState = createActivationState($parse, attrs[attrName], scope);\n\n                    function scrollIfGlued() {\n                        if(activationState.getValue() && !direction.isAttached(el)){\n                            // Ensures scroll after angular template digest\n                            $timeout(function() {\n                              direction.scroll(el);\n                            });\n                        }\n                    }\n\n                    function onScroll() {\n                        activationState.setValue(direction.isAttached(el));\n                    }\n\n                    $timeout(scrollIfGlued, 0, false);\n\n                    if (!$el[0].hasAttribute('force-glue')) {\n                      $el.on('scroll', onScroll);\n                    }\n\n                    var hasAnchor = false;\n                    angular.forEach($el.children(), function(child) {\n                      if (child.hasAttribute('scroll-glue-anchor')) {\n                        hasAnchor = true;\n                        scope.$watch(function() { return child.offsetHeight }, function() {\n                          scrollIfGlued();\n                        });\n                      }\n                    });\n\n                    if (!hasAnchor) {\n                      scope.$watch(scrollIfGlued);\n                      $window.addEventListener('resize', scrollIfGlued, false);\n                    }\n\n                    // Remove listeners on directive destroy\n                    $el.on('$destroy', function() {\n                        $el.unbind('scroll', onScroll);\n                    });\n\n                    scope.$on('$destroy', function() {\n                        $window.removeEventListener('resize', scrollIfGlued, false);\n                    });\n                }\n            };\n        }]);\n    }\n\n    var bottom = {\n        isAttached: function(el){\n            // + 1 catches off by one errors in chrome\n            return el.scrollTop + el.clientHeight + 1 >= el.scrollHeight;\n        },\n        scroll: function(el){\n            el.scrollTop = el.scrollHeight;\n        }\n    };\n\n    var top = {\n        isAttached: function(el){\n            return el.scrollTop <= 1;\n        },\n        scroll: function(el){\n            el.scrollTop = 0;\n        }\n    };\n\n    var right = {\n        isAttached: function(el){\n            return el.scrollLeft + el.clientWidth + 1 >= el.scrollWidth;\n        },\n        scroll: function(el){\n            el.scrollLeft = el.scrollWidth;\n        }\n    };\n\n    var left = {\n        isAttached: function(el){\n            return el.scrollLeft <= 1;\n        },\n        scroll: function(el){\n            el.scrollLeft = 0;\n        }\n    };\n\n    var module = angular.module('luegg.directives', []);\n\n    createDirective(module, 'scrollGlue', bottom);\n    createDirective(module, 'scrollGlueTop', top);\n    createDirective(module, 'scrollGlueBottom', bottom);\n    createDirective(module, 'scrollGlueLeft', left);\n    createDirective(module, 'scrollGlueRight', right);\n}(angular));\n"

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)(__webpack_require__(1536))

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	module.exports = "parcelRequire=function(e,r,t,n){var i,o=\"function\"==typeof parcelRequire&&parcelRequire,u=\"function\"==typeof require&&require;function f(t,n){if(!r[t]){if(!e[t]){var i=\"function\"==typeof parcelRequire&&parcelRequire;if(!n&&i)return i(t,!0);if(o)return o(t,!0);if(u&&\"string\"==typeof t)return u(t);var c=new Error(\"Cannot find module '\"+t+\"'\");throw c.code=\"MODULE_NOT_FOUND\",c}p.resolve=function(r){return e[t][1][r]||r},p.cache={};var l=r[t]=new f.Module(t);e[t][0].call(l.exports,p,l,l.exports,this)}return r[t].exports;function p(e){return f(p.resolve(e))}}f.isParcelRequire=!0,f.Module=function(e){this.id=e,this.bundle=f,this.exports={}},f.modules=e,f.cache=r,f.parent=o,f.register=function(r,t){e[r]=[function(e,r){r.exports=t},{}]};for(var c=0;c<t.length;c++)try{f(t[c])}catch(e){i||(i=e)}if(t.length){var l=f(t[t.length-1]);\"object\"==typeof exports&&\"undefined\"!=typeof module?module.exports=l:\"function\"==typeof define&&define.amd?define(function(){return l}):n&&(this[n]=l)}if(parcelRequire=f,i)throw i;return f}({\"CUYV\":[function(require,module,exports) {\n\"use strict\";function t(t){return a(t)||r(t)||e()}function e(){throw new TypeError(\"Invalid attempt to spread non-iterable instance\")}function r(t){if(Symbol.iterator in Object(t)||\"[object Arguments]\"===Object.prototype.toString.call(t))return Array.from(t)}function a(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}Object.defineProperty(exports,\"__esModule\",{value:!0}),exports.default=void 0;var i=function(){var e,r={parseDomToTable:function(e,r,i){var n,b,g,d,c,s,f=t(r.getElementsByTagName(\"tr\")),A=r.getAttribute(\"data-cols-width\");A&&(A=A.split(\",\").map(function(t){return parseInt(t)}));var p=[];for(n=0;n<f.length;++n){var m=f[n];if(c=n+1,s=1,\"true\"!==m.getAttribute(\"data-exclude\")){if(m.getAttribute(\"data-height\"))e.getRow(c).height=parseFloat(m.getAttribute(\"data-height\"));var h=t(m.children);for(b=0;b<h.length;++b){var v=h[b];if(\"true\"!==v.getAttribute(\"data-exclude\")){for(var y=0;y<p.length;++y){var w=p[y];w.s.c==s&&w.s.r<=c&&c<=w.e.r&&(s=w.e.c+1,y=-1)}var x=e.getCell(o(s,c));if(g=parseInt(v.getAttribute(\"colspan\"))||1,d=parseInt(v.getAttribute(\"rowspan\"))||1,(g>1||d>1)&&p.push({s:{c:s,r:c},e:{c:s+g-1,r:c+d-1}}),s+=g,x.value=u(v),!i.autoStyle){var k=l(v);x.font=k.font||null,x.alignment=k.alignment||null,x.border=k.border||null,x.fill=k.fill||null,x.numFmt=k.numFmt||null}}else h.splice(b,1),b--}}else f.splice(n,1),n--}return A&&A.forEach(function(t,r){e.columns[r].width=t}),a(e,p),e}},a=function(t,e){e.forEach(function(e){t.mergeCells(n(e.s.c)+e.s.r+\":\"+n(e.e.c)+e.e.r)})},i=(e=[[\"nbsp\",\" \"],[\"middot\",\"·\"],[\"quot\",'\"'],[\"apos\",\"'\"],[\"gt\",\">\"],[\"lt\",\"<\"],[\"amp\",\"&\"]].map(function(t){return[new RegExp(\"&\"+t[0]+\";\",\"g\"),t[1]]}),function(t){for(var r=t.trim().replace(/\\s+/g,\" \").replace(/<\\s*[bB][rR]\\s*\\/?>/g,\"\\n\").replace(/<[^>]*>/g,\"\"),a=0;a<e.length;++a)r=r.replace(e[a][0],e[a][1]);return r}),n=function(t){for(var e=\"\",r=1,a=26;(t-=r)>=0;r=a,a*=26)e=String.fromCharCode(parseInt(t%a/r)+65)+e;return e},o=function(t,e){return n(t)+e},u=function(t){var e=t.getAttribute(\"data-t\"),r=i(t.innerHTML);if(e){var a;switch(e){case\"n\":a=Number(r);break;case\"d\":var n=new Date(r);a=new Date(Date.UTC(n.getFullYear(),n.getMonth(),n.getDate(),n.getHours(),n.getMinutes(),n.getSeconds()));break;case\"b\":a=\"true\"===r.toLowerCase()||\"false\"!==r.toLowerCase()&&Boolean(parseInt(r));break;default:a=r}return a}return t.getAttribute(\"data-hyperlink\")?{text:r,hyperlink:t.getAttribute(\"data-hyperlink\")}:t.getAttribute(\"data-error\")?{error:t.getAttribute(\"data-error\")}:r},l=function(t){var e={};t.getAttribute(\"data-f-name\")&&(e.name=t.getAttribute(\"data-f-name\")),t.getAttribute(\"data-f-sz\")&&(e.size=t.getAttribute(\"data-f-sz\")),t.getAttribute(\"data-f-color\")&&(e.color={argb:t.getAttribute(\"data-f-color\")}),\"true\"===t.getAttribute(\"data-f-bold\")&&(e.bold=!0),\"true\"===t.getAttribute(\"data-f-italic\")&&(e.italic=!0),\"true\"===t.getAttribute(\"data-f-underline\")&&(e.underline=!0),\"true\"===t.getAttribute(\"data-f-strike\")&&(e.strike=!0);var r={};t.getAttribute(\"data-a-h\")&&(r.horizontal=t.getAttribute(\"data-a-h\")),t.getAttribute(\"data-a-v\")&&(r.vertical=t.getAttribute(\"data-a-v\")),\"true\"===t.getAttribute(\"data-a-wrap\")&&(r.wrapText=!0),t.getAttribute(\"data-a-text-rotation\")&&(r.textRotation=t.getAttribute(\"data-a-text-rotation\")),t.getAttribute(\"data-a-indent\")&&(r.indent=t.getAttribute(\"data-a-indent\")),\"true\"===t.getAttribute(\"data-a-rtl\")&&(r.readingOrder=\"rtl\");var a,i,n={top:{},left:{},bottom:{},right:{}};if(t.getAttribute(\"data-b-a-s\")){var o=t.getAttribute(\"data-b-a-s\");n.top.style=o,n.left.style=o,n.bottom.style=o,n.right.style=o}if(t.getAttribute(\"data-b-a-c\")){var u={argb:t.getAttribute(\"data-b-a-c\")};n.top.color=u,n.left.color=u,n.bottom.color=u,n.right.color=u}return t.getAttribute(\"data-b-t-s\")&&(n.top.style=t.getAttribute(\"data-b-t-s\"),t.getAttribute(\"data-b-t-c\")&&(n.top.color={argb:t.getAttribute(\"data-b-t-c\")})),t.getAttribute(\"data-b-l-s\")&&(n.left.style=t.getAttribute(\"data-b-l-s\"),t.getAttribute(\"data-b-l-c\")&&(n.left.color={argb:t.getAttribute(\"data-b-t-c\")})),t.getAttribute(\"data-b-b-s\")&&(n.bottom.style=t.getAttribute(\"data-b-b-s\"),t.getAttribute(\"data-b-b-c\")&&(n.bottom.color={argb:t.getAttribute(\"data-b-t-c\")})),t.getAttribute(\"data-b-r-s\")&&(n.right.style=t.getAttribute(\"data-b-r-s\"),t.getAttribute(\"data-b-r-c\")&&(n.right.color={argb:t.getAttribute(\"data-b-t-c\")})),t.getAttribute(\"data-fill-color\")&&(a={type:\"pattern\",pattern:\"solid\",fgColor:{argb:t.getAttribute(\"data-fill-color\")}}),t.getAttribute(\"data-num-fmt\")&&(i=t.getAttribute(\"data-num-fmt\")),{font:e,alignment:r,border:n,fill:a,numFmt:i}};return r}(),n=i;exports.default=n;\n},{}],\"KAEt\":[function(require,module,exports) {\nvar define;\nvar global = arguments[3];\nvar e,t=arguments[3];!function(t,o){\"function\"==typeof e&&e.amd?e([],o):\"undefined\"!=typeof exports?o():(o(),t.FileSaver={})}(this,function(){\"use strict\";function e(e,t,o){var n=new XMLHttpRequest;n.open(\"GET\",e),n.responseType=\"blob\",n.onload=function(){i(n.response,t,o)},n.onerror=function(){console.error(\"could not download file\")},n.send()}function o(e){var t=new XMLHttpRequest;return t.open(\"HEAD\",e,!1),t.send(),200<=t.status&&299>=t.status}function n(t){try{t.dispatchEvent(new MouseEvent(\"click\"))}catch(e){var o=document.createEvent(\"MouseEvents\");o.initMouseEvent(\"click\",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),t.dispatchEvent(o)}}var a=\"object\"==typeof window&&window.window===window?window:\"object\"==typeof self&&self.self===self?self:\"object\"==typeof t&&t.global===t?t:void 0,i=a.saveAs||(\"object\"!=typeof window||window!==a?function(){}:\"download\"in HTMLAnchorElement.prototype?function(t,i,r){var c=a.URL||a.webkitURL,s=document.createElement(\"a\");i=i||t.name||\"download\",s.download=i,s.rel=\"noopener\",\"string\"==typeof t?(s.href=t,s.origin===location.origin?n(s):o(s.href)?e(t,i,r):n(s,s.target=\"_blank\")):(s.href=c.createObjectURL(t),setTimeout(function(){c.revokeObjectURL(s.href)},4e4),setTimeout(function(){n(s)},0))}:\"msSaveOrOpenBlob\"in navigator?function(t,a,i){if(a=a||t.name||\"download\",\"string\"!=typeof t)navigator.msSaveOrOpenBlob(function(e,t){return void 0===t?t={autoBom:!1}:\"object\"!=typeof t&&(console.warn(\"Deprecated: Expected third argument to be a object\"),t={autoBom:!t}),t.autoBom&&/^\\s*(?:text\\/\\S*|application\\/xml|\\S*\\/\\S*\\+xml)\\s*;.*charset\\s*=\\s*utf-8/i.test(e.type)?new Blob([\"\\ufeff\",e],{type:e.type}):e}(t,i),a);else if(o(t))e(t,a,i);else{var r=document.createElement(\"a\");r.href=t,r.target=\"_blank\",setTimeout(function(){n(r)})}}:function(t,o,n,i){if((i=i||open(\"\",\"_blank\"))&&(i.document.title=i.document.body.innerText=\"downloading...\"),\"string\"==typeof t)return e(t,o,n);var r=\"application/octet-stream\"===t.type,c=/constructor/i.test(a.HTMLElement)||a.safari,s=/CriOS\\/[\\d]+/.test(navigator.userAgent);if((s||r&&c)&&\"object\"==typeof FileReader){var l=new FileReader;l.onloadend=function(){var e=l.result;e=s?e:e.replace(/^data:[^;]*;/,\"data:attachment/file;\"),i?i.location.href=e:location=e,i=null},l.readAsDataURL(t)}else{var u=a.URL||a.webkitURL,f=u.createObjectURL(t);i?i.location=f:location.href=f,i=null,setTimeout(function(){u.revokeObjectURL(f)},4e4)}});a.saveAs=i.saveAs=i,\"undefined\"!=typeof module&&(module.exports=i)});\n},{}],\"vJr6\":[function(require,module,exports) {\n\"use strict\";module.exports={Promish:null};\n},{}],\"ssQO\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../utils/promish\");function i(i,s,e){switch(void 0===e&&(e=!0),i.toLowerCase()){case\"promise\":if(!e&&r.Promish)return;r.Promish=s}}module.exports=i;\n},{\"../utils/promish\":\"vJr6\"}],\"pBGv\":[function(require,module,exports) {\n\nvar t,e,n=module.exports={};function r(){throw new Error(\"setTimeout has not been defined\")}function o(){throw new Error(\"clearTimeout has not been defined\")}function i(e){if(t===setTimeout)return setTimeout(e,0);if((t===r||!t)&&setTimeout)return t=setTimeout,setTimeout(e,0);try{return t(e,0)}catch(n){try{return t.call(null,e,0)}catch(n){return t.call(this,e,0)}}}function u(t){if(e===clearTimeout)return clearTimeout(t);if((e===o||!e)&&clearTimeout)return e=clearTimeout,clearTimeout(t);try{return e(t)}catch(n){try{return e.call(null,t)}catch(n){return e.call(this,t)}}}!function(){try{t=\"function\"==typeof setTimeout?setTimeout:r}catch(n){t=r}try{e=\"function\"==typeof clearTimeout?clearTimeout:o}catch(n){e=o}}();var c,s=[],l=!1,a=-1;function f(){l&&c&&(l=!1,c.length?s=c.concat(s):a=-1,s.length&&h())}function h(){if(!l){var t=i(f);l=!0;for(var e=s.length;e;){for(c=s,s=[];++a<e;)c&&c[a].run();a=-1,e=s.length}c=null,l=!1,u(t)}}function m(t,e){this.fun=t,this.array=e}function p(){}n.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];s.push(new m(t,e)),1!==s.length||l||i(h)},m.prototype.run=function(){this.fun.apply(null,this.array)},n.title=\"browser\",n.env={},n.argv=[],n.version=\"\",n.versions={},n.on=p,n.addListener=p,n.once=p,n.off=p,n.removeListener=p,n.removeAllListeners=p,n.emit=p,n.prependListener=p,n.prependOnceListener=p,n.listeners=function(t){return[]},n.binding=function(t){throw new Error(\"process.binding is not supported\")},n.cwd=function(){return\"/\"},n.chdir=function(t){throw new Error(\"process.chdir is not supported\")},n.umask=function(){return 0};\n},{}],\"Zt7E\":[function(require,module,exports) {\nvar process = require(\"process\");\nvar global = arguments[3];\nvar define;\nvar t,e=require(\"process\"),r=arguments[3];(function(){\"use strict\";function n(t){return\"function\"==typeof t}var o,i,s=Array.isArray?Array.isArray:function(t){return\"[object Array]\"===Object.prototype.toString.call(t)},u=0,a=function(t,e){w[u]=t,w[u+1]=e,2===(u+=2)&&(i?i(g):v())};var c=\"undefined\"!=typeof window?window:void 0,l=c||{},f=l.MutationObserver||l.WebKitMutationObserver,h=void 0!==e&&\"[object process]\"==={}.toString.call(e),p=\"undefined\"!=typeof Uint8ClampedArray&&\"undefined\"!=typeof importScripts&&\"undefined\"!=typeof MessageChannel;function _(){return function(){setTimeout(g,1)}}var v,d,y,m,b,w=new Array(1e3);function g(){for(var t=0;t<u;t+=2){(0,w[t])(w[t+1]),w[t]=void 0,w[t+1]=void 0}u=0}function A(){}h?v=function(){e.nextTick(g)}:f?(y=0,m=new f(g),b=document.createTextNode(\"\"),m.observe(b,{characterData:!0}),v=function(){b.data=y=++y%2}):p?((d=new MessageChannel).port1.onmessage=g,v=function(){d.port2.postMessage(0)}):v=void 0===c&&\"function\"==typeof require?function(){try{var t=require(\"vertx\");return o=t.runOnLoop||t.runOnContext,function(){o(g)}}catch(e){return _()}}():_();var E=void 0,j=1,S=2,T=new k;function P(t,e){if(e.constructor===t.constructor)!function(t,e){e._state===j?M(t,e._result):e._state===S?O(t,e._result):q(e,void 0,function(e){x(t,e)},function(e){O(t,e)})}(t,e);else{var r=function(t){try{return t.then}catch(e){return T.error=e,T}}(e);r===T?O(t,T.error):void 0===r?M(t,e):n(r)?function(t,e,r){a(function(t){var n=!1,o=function(t,e,r,n){try{t.call(e,r,n)}catch(o){return o}}(r,e,function(r){n||(n=!0,e!==r?x(t,r):M(t,r))},function(e){n||(n=!0,O(t,e))},t._label);!n&&o&&(n=!0,O(t,o))},t)}(t,e,r):M(t,e)}}function x(t,e){var r;t===e?O(t,new TypeError(\"You cannot resolve a promise with itself\")):\"function\"==typeof(r=e)||\"object\"==typeof r&&null!==r?P(t,e):M(t,e)}function C(t){t._onerror&&t._onerror(t._result),Y(t)}function M(t,e){t._state===E&&(t._result=e,t._state=j,0!==t._subscribers.length&&a(Y,t))}function O(t,e){t._state===E&&(t._state=S,t._result=e,a(C,t))}function q(t,e,r,n){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+j]=r,o[i+S]=n,0===i&&t._state&&a(Y,t)}function Y(t){var e=t._subscribers,r=t._state;if(0!==e.length){for(var n,o,i=t._result,s=0;s<e.length;s+=3)n=e[s],o=e[s+r],n?I(r,n,o,i):o(i);t._subscribers.length=0}}function k(){this.error=null}var F=new k;function I(t,e,r,o){var i,s,u,a,c=n(r);if(c){if((i=function(t,e){try{return t(e)}catch(r){return F.error=r,F}}(r,o))===F?(a=!0,s=i.error,i=null):u=!0,e===i)return void O(e,new TypeError(\"A promises callback cannot return that same promise.\"))}else i=o,u=!0;e._state!==E||(c&&u?x(e,i):a?O(e,s):t===j?M(e,i):t===S&&O(e,i))}function D(t,e){this._instanceConstructor=t,this.promise=new t(A),this._validateInput(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._init(),0===this.length?M(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&M(this.promise,this._result))):O(this.promise,this._validationError())}D.prototype._validateInput=function(t){return s(t)},D.prototype._validationError=function(){return new Error(\"Array Methods must be provided an Array\")},D.prototype._init=function(){this._result=new Array(this.length)};var K=D;D.prototype._enumerate=function(){for(var t=this.length,e=this.promise,r=this._input,n=0;e._state===E&&n<t;n++)this._eachEntry(r[n],n)},D.prototype._eachEntry=function(t,e){var r,n=this._instanceConstructor;\"object\"==typeof(r=t)&&null!==r?t.constructor===n&&t._state!==E?(t._onerror=null,this._settledAt(t._state,e,t._result)):this._willSettleAt(n.resolve(t),e):(this._remaining--,this._result[e]=t)},D.prototype._settledAt=function(t,e,r){var n=this.promise;n._state===E&&(this._remaining--,t===S?O(n,r):this._result[e]=r),0===this._remaining&&M(n,this._result)},D.prototype._willSettleAt=function(t,e){var r=this;q(t,void 0,function(t){r._settledAt(j,e,t)},function(t){r._settledAt(S,e,t)})};var L=function(t){return new K(this,t).promise};var N=function(t){var e=new this(A);if(!s(t))return O(e,new TypeError(\"You must pass an array to race.\")),e;var r=t.length;function n(t){x(e,t)}function o(t){O(e,t)}for(var i=0;e._state===E&&i<r;i++)q(this.resolve(t[i]),void 0,n,o);return e};var U=function(t){if(t&&\"object\"==typeof t&&t.constructor===this)return t;var e=new this(A);return x(e,t),e};var W=function(t){var e=new this(A);return O(e,t),e},z=0;var B=G;function G(t){this._id=z++,this._state=void 0,this._result=void 0,this._subscribers=[],A!==t&&(n(t)||function(){throw new TypeError(\"You must pass a resolver function as the first argument to the promise constructor\")}(),this instanceof G||function(){throw new TypeError(\"Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.\")}(),function(t,e){try{e(function(e){x(t,e)},function(e){O(t,e)})}catch(r){O(t,r)}}(this,t))}G.all=L,G.race=N,G.resolve=U,G.reject=W,G._setScheduler=function(t){i=t},G._setAsap=function(t){a=t},G._asap=a,G.prototype={constructor:G,then:function(t,e){var r=this._state;if(r===j&&!t||r===S&&!e)return this;var n=new this.constructor(A),o=this._result;if(r){var i=arguments[r-1];a(function(){I(r,n,i,o)})}else q(this,n,t,e);return n},catch:function(t){return this.then(null,t)}};var H=function(){var t;if(void 0!==r)t=r;else if(\"undefined\"!=typeof self)t=self;else try{t=Function(\"return this\")()}catch(n){throw new Error(\"polyfill failed because global object is unavailable in this environment\")}var e=t.Promise;e&&\"[object Promise]\"===Object.prototype.toString.call(e.resolve())&&!e.cast||(t.Promise=B)},J={Promise:B,polyfill:H};\"function\"==typeof t&&t.amd?t(function(){return J}):\"undefined\"!=typeof module&&module.exports?module.exports=J:void 0!==this&&(this.ES6Promise=J),H()}).call(this);\n},{\"process\":\"pBGv\"}],\"iBpr\":[function(require,module,exports) {\n\"use strict\";function n(e){return(n=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(n){return typeof n}:function(n){return n&&\"function\"==typeof Symbol&&n.constructor===Symbol&&n!==Symbol.prototype?\"symbol\":typeof n})(e)}var e=function(){function n(n,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(n,r.key,r)}}return function(e,t,r){return t&&n(e.prototype,t),r&&n(e,r),e}}();function t(n,e){if(!(n instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function r(e,t){if(!e)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!t||\"object\"!==n(t)&&\"function\"!=typeof t?e:t}function o(e,t){if(\"function\"!=typeof t&&null!==t)throw new TypeError(\"Super expression must either be null or a function, not \"+n(t));e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function u(n){function u(n){for(;n&&n!==Object;){if(n===Error||n instanceof Error)return!0;n=n.prototype}return!1}return function(i){function f(n){if(t(this,f),n instanceof f)return r(e,n);if(n instanceof Promise||n.then instanceof Function)var e=r(this,(f.__proto__||Object.getPrototypeOf(f)).call(this,function(e,t){return n.then(e,t)}));else if(n instanceof Error)e=r(this,(f.__proto__||Object.getPrototypeOf(f)).call(this,function(e,t){return t(n)}));else if(n instanceof Function)e=r(this,(f.__proto__||Object.getPrototypeOf(f)).call(this,n));else e=r(this,(f.__proto__||Object.getPrototypeOf(f)).call(this,function(e){return e(n)}));return r(e)}return o(f,n),e(f,[{key:\"finally\",value:function(n){return this.then(function(e){return f.resolve(n()).then(function(){return e})},function(e){return f.resolve(n()).then(function(){return f.reject(e)})})}},{key:\"catch\",value:function(){var n=Array.from(arguments),e=n.pop();return this.then(void 0,function(t){if(!n.length)return e(t);for(var r=0;r<n.length;r++){var o=n[r];if(u(o)){if(t instanceof o)return e(t)}else if(o instanceof Function&&o(t))return e(t)}return new f(function(n,e){return e(t)})})}},{key:\"delay\",value:function(n){return this.then(function(e){return new f(function(t){setTimeout(function(){t(e)},n)})})}},{key:\"map\",value:function(n){return this.then(function(e){return f.map(e,n)})}},{key:\"reduce\",value:function(n,e){return this.then(function(t){return f.reduce(t,n,e)})}},{key:\"spread\",value:function(n){return this.then(function(n){return f.all(n)}).then(function(e){return n.apply(void 0,e)})}}],[{key:\"map\",value:function(n,e){return f.all(n.map(function(t,r){return f.resolve(t).then(function(t){return e(t,r,n.length)})}))}},{key:\"reduce\",value:function(n,e,t){var r,o=0;if(void 0!==t)r=f.resolve(t);else{if(!(n.length>1))return f.resolve(n[0]);r=f.resolve(n[o++])}for(;o<n.length;)!function(t){r=r.then(function(r){return f.resolve(n[t]).then(function(n){return e(r,n,t)})})}(o++);return r}},{key:\"delay\",value:function(n,e){return new f(function(t){setTimeout(function(){t(e)},n)})}},{key:\"resolve\",value:function(n){return new f(function(e){e(n)})}},{key:\"reject\",value:function(n){return new f(function(e,t){t(n)})}},{key:\"sequence\",value:function(n,e){for(var t=f.resolve(e),r=0;r<n.length;r++)t=t.then(n[r]);return t}},{key:\"method\",value:function(n){return function(){var e=this,t=Array.from(arguments);return new f(function(r){return r(n.apply(e,t))})}}},{key:\"apply\",value:function(n,e){return e=Array.from(e),new f(function(t,r){e.push(function(){var n=Array.prototype.shift.apply(arguments);n?r(n):1===arguments.length?t(arguments[0]):t(arguments)}),n.apply(void 0,e)})}},{key:\"nfapply\",value:function(n,e){return f.apply(n,e)}},{key:\"call\",value:function(){var n=Array.prototype.shift.apply(arguments);return f.apply(n,arguments)}},{key:\"nfcall\",value:function(){return f.call.apply(null,arguments)}},{key:\"post\",value:function(n,e,t){return f.apply(e.bind(n),t)}},{key:\"npost\",value:function(n,e,t){return f.apply(e.bind(n),t)}},{key:\"invoke\",value:function(){var n=Array.prototype.shift.apply(arguments),e=Array.prototype.shift.apply(arguments);return f.apply(e.bind(n),arguments)}},{key:\"ninvoke\",value:function(){return f.invoke(arguments)}},{key:\"promisify\",value:function(n){return function(){return f.apply(n,arguments)}}},{key:\"denodify\",value:function(n){return f.promisify(n)}},{key:\"nbind\",value:function(n,e){return function(){return f.post(e,n,arguments)}}},{key:\"bind\",value:function(n,e){return function(){return f.post(n,e,arguments)}}},{key:\"promisifyAll\",value:function(n,e){for(var t=(e=e||{}).inPlace||!1,r=e.suffix||(t?\"Async\":\"\"),o={},u=n;u&&u!==Object;){for(var i in u)!o[i+r]&&u[i]instanceof Function&&(o[i+r]=f.bind(n,u[i]));u=Object.getPrototypeOf(u)||u.prototype}if(t){for(var c in o)o[c]instanceof Function&&(n[c]=o[c]);o=n}return o}},{key:\"all\",value:function(n){return new f(Promise.all(n))}},{key:\"some\",value:function(n,e){return new f(function(t,r){var o=[],u=[];n.forEach(function(i){i.then(function(n){o.push(n),o.length>=e&&t(o)}).catch(function(t){u.push(t),u.length>n.length-e&&r(u)})})})}},{key:\"any\",value:function(n){return f.some(n,1).then(function(n){return n[0]})}},{key:\"defer\",value:function(){var n={};return n.promise=new f(function(e,t){n.resolve=e,n.reject=t}),n}},{key:\"spread\",value:function(n,e){return e.apply(void 0,n)}}]),f}()}module.exports=u;\n},{}],\"i/x1\":[function(require,module,exports) {\n\"use strict\";var e=require(\"es6-promise\").Promise,r=require(\"./promish-class\");module.exports=r(e);\n},{\"es6-promise\":\"Zt7E\",\"./promish-class\":\"iBpr\"}],\"h8Mb\":[function(require,module,exports) {\n\"use strict\";function r(e){return(r=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(r){return typeof r}:function(r){return r&&\"function\"==typeof Symbol&&r.constructor===Symbol&&r!==Symbol.prototype?\"symbol\":typeof r})(e)}var e=\"function\"==typeof Symbol&&\"symbol\"===r(Symbol.iterator)?function(e){return r(e)}:function(e){return e&&\"function\"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?\"symbol\":r(e)},t={each:function(r,e){r&&(Array.isArray(r)?r.forEach(e):Object.keys(r).forEach(function(t){e(r[t],t)}))},some:function(r,e){return!!r&&(Array.isArray(r)?r.some(e):Object.keys(r).some(function(t){return e(r[t],t)}))},every:function(r,e){return!r||(Array.isArray(r)?r.every(e):Object.keys(r).every(function(t){return e(r[t],t)}))},map:function(r,e){return r?Array.isArray(r)?r.map(e):Object.keys(r).map(function(t){return e(r[t],t)}):[]},isEqual:function(r,n){var o=void 0===r?\"undefined\":e(r),u=void 0===n?\"undefined\":e(n),y=Array.isArray(r),c=Array.isArray(n);if(o!==u)return!1;switch(void 0===r?\"undefined\":e(r)){case\"object\":return y||c?!(!y||!c)&&(r.length===n.length&&r.every(function(r,e){var o=n[e];return t.isEqual(r,o)})):t.every(r,function(r,e){var o=n[e];return t.isEqual(r,o)});default:return r===n}},escapeHtml:function(r){return r.replace(/&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\").replace(/\"/g,\"&quot;\").replace(/'/g,\"&#039;\")}};module.exports=t;\n},{}],\"oVwW\":[function(require,module,exports) {\n\"use strict\";var t=module.exports={_dictionary:[\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\"],_l2n:{},_n2l:[],_level:function(t){return t<=26?1:t<=676?2:3},_fill:function(t){var r,e,s,o,n,i=1;if(t>=1)for(;i<=26;)r=this._dictionary[i-1],this._n2l[i]=r,this._l2n[r]=i,i++;if(t>=2)for(;i<=702;)s=(e=i-27)%26,o=Math.floor(e/26),r=this._dictionary[o]+this._dictionary[s],this._n2l[i]=r,this._l2n[r]=i,i++;if(t>=3)for(;i<=16384;)s=(e=i-703)%26,o=Math.floor(e/26)%26,n=Math.floor(e/676),r=this._dictionary[n]+this._dictionary[o]+this._dictionary[s],this._n2l[i]=r,this._l2n[r]=i,i++},l2n:function(t){if(this._l2n[t]||this._fill(t.length),!this._l2n[t])throw new Error(\"Out of bounds. Invalid column letter: \"+t);return this._l2n[t]},n2l:function(t){if(t<1||t>16384)throw new Error(t+\" is out of bounds. Excel supports columns from 1 to 16384\");return this._n2l[t]||this._fill(this._level(t)),this._n2l[t]},_hash:{},validateAddress:function(t){if(!t.match(/^[A-Z]+\\d+$/))throw new Error(\"Invalid Address: \"+t);return!0},decodeAddress:function(t){var r=this._hash[t];if(r)return r;var e,s,o=t.match(/[A-Z]+/);o&&(e=o[0],s=this.l2n(e));var n,i,d=t.match(/\\d+/);d&&(n=d[0],i=parseInt(n,10));var h={address:t=(e||\"\")+(n||\"\"),col:s,row:i,$col$row:\"$\"+(e||\"\")+\"$\"+(n||\"\")};return s<=100&&i<=100&&(this._hash[t]=h,this._hash[h.$col$row]=h),h},getAddress:function(t,r){if(r){var e=this.n2l(r)+t;return this.decodeAddress(e)}return this.decodeAddress(t)},decode:function(t){var r=t.split(\":\");if(2===r.length){var e=this.decodeAddress(r[0]),s=this.decodeAddress(r[1]),o={top:Math.min(e.row,s.row),left:Math.min(e.col,s.col),bottom:Math.max(e.row,s.row),right:Math.max(e.col,s.col)};return o.tl=this.n2l(o.left)+o.top,o.br=this.n2l(o.right)+o.bottom,o.dimensions=o.tl+\":\"+o.br,o}return this.decodeAddress(t)},decodeEx:function(t){var r=t.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/),e=r[1]||r[2],s=r[3],o=s.split(\":\");if(o.length>1){var n=this.decodeAddress(o[0]),i=this.decodeAddress(o[1]),d=Math.min(n.row,i.row),h=Math.min(n.col,i.col),l=Math.max(n.row,i.row),a=Math.max(n.col,i.col);return n=this.n2l(h)+d,i=this.n2l(a)+l,{top:d,left:h,bottom:l,right:a,sheetName:e,tl:{address:n,col:h,row:d,$col$row:\"$\"+this.n2l(h)+\"$\"+d,sheetName:e},br:{address:i,col:a,row:l,$col$row:\"$\"+this.n2l(a)+\"$\"+l,sheetName:e},dimensions:n+\":\"+i}}if(s.startsWith(\"#\"))return e?{sheetName:e,error:s}:{error:s};var c=this.decodeAddress(s);return e?Object.assign({sheetName:e},c):c},encodeAddress:function(r,e){return t.n2l(e)+r},encode:function(){switch(arguments.length){case 2:return t.encodeAddress(arguments[0],arguments[1]);case 4:return t.encodeAddress(arguments[0],arguments[1])+\":\"+t.encodeAddress(arguments[2],arguments[3]);default:throw new Error(\"Can only encode with 2 or 4 arguments\")}}};\n},{}],\"PZiO\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./../utils/col-cache\"),e=module.exports=function(){this.decode(arguments)};e.prototype={_set_tlbr:function(t,e,s,o,i){this.model={top:Math.min(t,s),left:Math.min(e,o),bottom:Math.max(t,s),right:Math.max(e,o),sheetName:i}},_set_tl_br:function(e,s,o){e=t.decodeAddress(e),s=t.decodeAddress(s),this._set_tlbr(e.row,e.col,s.row,s.col,o)},decode:function(s){switch(s.length){case 5:this._set_tlbr(s[0],s[1],s[2],s[3],s[4]);break;case 4:this._set_tlbr(s[0],s[1],s[2],s[3]);break;case 3:this._set_tl_br(s[0],s[1],s[2]);break;case 2:this._set_tl_br(s[0],s[1]);break;case 1:var o=s[0];if(o instanceof e)this.model={top:o.model.top,left:o.model.left,bottom:o.model.bottom,right:o.model.right,sheetName:o.sheetName};else if(o instanceof Array)this.decode(o);else if(o.top&&o.left&&o.bottom&&o.right)this.model={top:o.top,left:o.left,bottom:o.bottom,right:o.right,sheetName:o.sheetName};else{var i=t.decodeEx(o);i.top?this.model={top:i.top,left:i.left,bottom:i.bottom,right:i.right,sheetName:i.sheetName}:this.model={top:i.row,left:i.col,bottom:i.row,right:i.col,sheetName:i.sheetName}}break;case 0:this.model={top:0,left:0,bottom:0,right:0};break;default:throw new Error(\"Invalid number of arguments to _getDimensions() - \"+s.length)}},get top(){return this.model.top||1},set top(t){this.model.top=t},get left(){return this.model.left||1},set left(t){this.model.left=t},get bottom(){return this.model.bottom||1},set bottom(t){this.model.bottom=t},get right(){return this.model.right||1},set right(t){this.model.right=t},get sheetName(){return this.model.sheetName},set sheetName(t){this.model.sheetName=t},get _serialisedSheetName(){var t=this.model.sheetName;return t?/^[a-zA-Z0-9]*$/.test(t)?t+\"!\":\"'\"+t+\"'!\":\"\"},expand:function(t,e,s,o){(!this.model.top||t<this.top)&&(this.top=t),(!this.model.left||e<this.left)&&(this.left=e),(!this.model.bottom||s>this.bottom)&&(this.bottom=s),(!this.model.right||o>this.right)&&(this.right=o)},expandRow:function(t){if(t){var e=t.dimensions;e&&this.expand(t.number,e.min,t.number,e.max)}},expandToAddress:function(e){var s=t.decodeEx(e);this.expand(s.row,s.col,s.row,s.col)},get tl(){return t.n2l(this.left)+this.top},get $t$l(){return\"$\"+t.n2l(this.left)+\"$\"+this.top},get br(){return t.n2l(this.right)+this.bottom},get $b$r(){return\"$\"+t.n2l(this.right)+\"$\"+this.bottom},get range(){return this._serialisedSheetName+this.tl+\":\"+this.br},get $range(){return this._serialisedSheetName+this.$t$l+\":\"+this.$b$r},get shortRange(){return this.count>1?this.range:this._serialisedSheetName+this.tl},get $shortRange(){return this.count>1?this.$range:this._serialisedSheetName+this.$t$l},get count(){return(1+this.bottom-this.top)*(1+this.right-this.left)},toString:function(){return this.range},intersects:function(t){return(!t.sheetName||!this.sheetName||t.sheetName===this.sheetName)&&(!(t.bottom<this.top)&&(!(t.top>this.bottom)&&(!(t.right<this.left)&&!(t.left>this.right))))},contains:function(e){var s=t.decodeEx(e);return this.containsEx(s)},containsEx:function(t){return(!t.sheetName||!this.sheetName||t.sheetName===this.sheetName)&&(t.row>=this.top&&t.row<=this.bottom&&t.col>=this.left&&t.col<=this.right)}};\n},{\"./../utils/col-cache\":\"oVwW\"}],\"YmZx\":[function(require,module,exports) {\n\"use strict\";module.exports={ValueType:{Null:0,Merge:1,Number:2,String:3,Date:4,Hyperlink:5,Formula:6,SharedString:7,RichText:8,Boolean:9,Error:10},FormulaType:{None:0,Master:1,Shared:2},RelationshipType:{None:0,OfficeDocument:1,Worksheet:2,CalcChain:3,SharedStrings:4,Styles:5,Theme:6,Hyperlink:7},DocumentType:{Xlsx:1},ReadingOrder:{LeftToRight:1,RightToLeft:2},ErrorValue:{NotApplicable:\"#N/A\",Ref:\"#REF!\",Name:\"#NAME?\",DivZero:\"#DIV/0!\",Null:\"#NULL!\",Value:\"#VALUE!\",Num:\"#NUM!\"}};\n},{}],\"fBoy\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./col-cache\"),r=/(([a-z_\\-0-9]*)!)?([a-z0-9_$]{2,})([(])?/gi,n=/^([$])?([a-z]+)([$])?([1-9][0-9]*)$/i,t=function(t,a,o){var c=e.decode(a),l=e.decode(o);return t.replace(r,function(r,t,a,o,u){if(u)return r;var i=n.exec(o);if(i){var d=i[1],s=i[2].toUpperCase(),f=i[3],p=i[4];if(s.length>3||3===s.length&&s>\"XFD\")return r;var v=e.l2n(s),$=parseInt(p,10);return d||(v+=l.col-c.col),f||($+=l.row-c.row),(t||\"\")+(d||\"\")+e.n2l(v)+(f||\"\")+$}return r})};module.exports={slideFormula:t};\n},{\"./col-cache\":\"oVwW\"}],\"p2/y\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils/col-cache\"),t=require(\"../utils/under-dash\"),r=require(\"./enums\"),s=require(\"../utils/shared-formula\"),l=s.slideFormula,i=module.exports=function(t,r,s){if(!t||!r)throw new Error(\"A Cell needs a Row\");this._row=t,this._column=r,e.validateAddress(s),this._address=s,this._value=c.create(i.Types.Null,this),this.style=this._mergeStyle(t.style,r.style,{}),this._mergeCount=0};i.Types=r.ValueType,i.prototype={get worksheet(){return this._row.worksheet},get workbook(){return this._row.worksheet.workbook},destroy:function(){delete this.style,delete this._value,delete this._row,delete this._column,delete this._address},get numFmt(){return this.style.numFmt},set numFmt(e){this.style.numFmt=e},get font(){return this.style.font},set font(e){this.style.font=e},get alignment(){return this.style.alignment},set alignment(e){this.style.alignment=e},get border(){return this.style.border},set border(e){this.style.border=e},get fill(){return this.style.fill},set fill(e){this.style.fill=e},_mergeStyle:function(e,t,r){var s=e&&e.numFmt||t&&t.numFmt;s&&(r.numFmt=s);var l=e&&e.font||t&&t.font;l&&(r.font=l);var i=e&&e.alignment||t&&t.alignment;i&&(r.alignment=i);var n=e&&e.border||t&&t.border;n&&(r.border=n);var a=e&&e.fill||t&&t.fill;return a&&(r.fill=a),r},get address(){return this._address},get row(){return this._row.number},get col(){return this._column.number},get $col$row(){return\"$\"+this._column.letter+\"$\"+this.row},get type(){return this._value.type},get effectiveType(){return this._value.effectiveType},toCsvString:function(){return this._value.toCsvString()},addMergeRef:function(){this._mergeCount++},releaseMergeRef:function(){this._mergeCount--},get isMerged(){return this._mergeCount>0||this.type===i.Types.Merge},merge:function(e){this._value.release(),this._value=c.create(i.Types.Merge,this,e),this.style=e.style},unmerge:function(){this.type===i.Types.Merge&&(this._value.release(),this._value=c.create(i.Types.Null,this),this.style=this._mergeStyle(this._row.style,this._column.style,{}))},isMergedTo:function(e){return this._value.type===i.Types.Merge&&this._value.isMergedTo(e)},get master(){return this.type===i.Types.Merge?this._value.master:this},get isHyperlink(){return this._value.type===i.Types.Hyperlink},get hyperlink(){return this._value.hyperlink},get value(){return this._value.value},set value(e){this.type!==i.Types.Merge?(this._value.release(),this._value=c.create(c.getType(e),this,e)):this._value.master.value=e},get text(){return this._value.toString()},get html(){return t.escapeHtml(this.text)},toString:function(){return this.text},_upgradeToHyperlink:function(e){this.type===i.Types.String&&(this._value=c.create(i.Types.Hyperlink,this,{text:this._value.value,hyperlink:e}))},get formula(){return this._value.formula},get result(){return this._value.result},get formulaType(){return this._value.formulaType},get fullAddress(){return{sheetName:this._row.worksheet.name,address:this.address,row:this.row,col:this.col}},get name(){return this.names[0]},set name(e){this.names=[e]},get names(){return this.workbook.definedNames.getNamesEx(this.fullAddress)},set names(e){var t=this,r=this.workbook.definedNames;this.workbook.definedNames.removeAllNames(t.fullAddress),e.forEach(function(e){r.addEx(t.fullAddress,e)})},addName:function(e){this.workbook.definedNames.addEx(this.fullAddress,e)},removeName:function(e){this.workbook.definedNames.removeEx(this.fullAddress,e)},removeAllNames:function(){this.workbook.definedNames.removeAllNames(this.fullAddress)},get _dataValidations(){return this.worksheet.dataValidations},get dataValidation(){return this._dataValidations.find(this.address)},set dataValidation(e){this._dataValidations.add(this.address,e)},get model(){var e=this._value.model;return e.style=this.style,e},set model(e){this._value.release(),this._value=c.create(e.type,this),this._value.model=e,e.style?this.style=e.style:this.style={}}};var n=function(e){this.model={address:e.address,type:i.Types.Null}};n.prototype={get value(){return null},set value(e){},get type(){return i.Types.Null},get effectiveType(){return i.Types.Null},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return\"\"},release:function(){},toString:function(){return\"\"}};var a=function(e,t){this.model={address:e.address,type:i.Types.Number,value:t}};a.prototype={get value(){return this.model.value},set value(e){this.model.value=e},get type(){return i.Types.Number},get effectiveType(){return i.Types.Number},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return\"\"+this.model.value},release:function(){},toString:function(){return this.model.value.toString()}};var o=function(e,t){this.model={address:e.address,type:i.Types.String,value:t}};o.prototype={get value(){return this.model.value},set value(e){this.model.value=e},get type(){return i.Types.String},get effectiveType(){return i.Types.String},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return'\"'+this.model.value.replace(/\"/g,'\"\"')+'\"'},release:function(){},toString:function(){return this.model.value}};var u=function(e,t){this.model={address:e.address,type:i.Types.String,value:t}};u.prototype={get value(){return this.model.value},set value(e){this.model.value=e},toString:function(){return this.model.value.richText.map(function(e){return e.text}).join(\"\")},get type(){return i.Types.RichText},get effectiveType(){return i.Types.RichText},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return'\"'+this.text.replace(/\"/g,'\"\"')+'\"'},release:function(){}};var d=function(e,t){this.model={address:e.address,type:i.Types.Date,value:t}};d.prototype={get value(){return this.model.value},set value(e){this.model.value=e},get type(){return i.Types.Date},get effectiveType(){return i.Types.Date},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return this.model.value.toISOString()},release:function(){},toString:function(){return this.model.value.toString()}};var h=function(e,t){this.model=Object.assign({address:e.address,type:i.Types.Hyperlink,text:t?t.text:void 0,hyperlink:t?t.hyperlink:void 0},t&&t.tooltip?{tooltip:t.tooltip}:{})};h.prototype={get value(){return Object.assign({text:this.model.text,hyperlink:this.model.hyperlink},this.model.tooltip?{tooltip:this.model.tooltip}:{})},set value(e){this.model=Object.assign({text:e.text,hyperlink:e.hyperlink},e&&e.tooltip?{tooltip:e.tooltip}:{})},get text(){return this.model.text},set text(e){this.model.text=e},get hyperlink(){return this.model.hyperlink},set hyperlink(e){this.model.hyperlink=e},get type(){return i.Types.Hyperlink},get effectiveType(){return i.Types.Hyperlink},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return this.model.hyperlink},release:function(){},toString:function(){return this.model.text}};var m=function(e,t){this.model={address:e.address,type:i.Types.Merge,master:t?t.address:void 0},this._master=t,t&&t.addMergeRef()};m.prototype={get value(){return this._master.value},set value(e){e instanceof i?(this._master&&this._master.releaseMergeRef(),e.addMergeRef(),this._master=e):this._master.value=e},isMergedTo:function(e){return e===this._master},get master(){return this._master},get type(){return i.Types.Merge},get effectiveType(){return this._master.effectiveType},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return\"\"},release:function(){this._master.releaseMergeRef()},toString:function(){return this.value.toString()}};var p=function(e,t){this.cell=e,this.model={address:e.address,type:i.Types.Formula,formula:t?t.formula:void 0,sharedFormula:t?t.sharedFormula:void 0,result:t?t.result:void 0}};p.prototype={get value(){return this.model.formula?{formula:this.model.formula,result:this.model.result}:{sharedFormula:this.model.sharedFormula,result:this.model.result}},set value(e){this.model.formula=e.formula,this.model.sharedFormula=e.sharedFormula,this.model.result=e.result},validate:function(e){switch(c.getType(e)){case i.Types.Null:case i.Types.String:case i.Types.Number:case i.Types.Date:break;case i.Types.Hyperlink:case i.Types.Formula:default:throw new Error(\"Cannot process that type of result value\")}},get dependencies(){return{ranges:this.formula.match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\\d{1,4}:[A-Z]{1,3}\\d{1,4}/g),cells:this.formula.replace(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\\d{1,4}:[A-Z]{1,3}\\d{1,4}/g,\"\").match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\\d{1,4}/g)}},get formula(){return this.model.formula||this._getTranslatedFormula()},set formula(e){this.model.formula=e},get formulaType(){return this.model.formula?r.FormulaType.Master:this.model.sharedFormula?r.FormulaType.Shared:r.FormulaType.None},get result(){return this.model.result},set result(e){this.model.result=e},get type(){return i.Types.Formula},get effectiveType(){var e=this.model.result;return null==e?r.ValueType.Null:e instanceof String||\"string\"==typeof e?r.ValueType.String:\"number\"==typeof e?r.ValueType.Number:e instanceof Date?r.ValueType.Date:e.text&&e.hyperlink?r.ValueType.Hyperlink:e.formula?r.ValueType.Formula:r.ValueType.Null},get address(){return this.model.address},set address(e){this.model.address=e},_getTranslatedFormula:function(){if(!this._translatedFormula&&this.model.sharedFormula){var e=this.cell.worksheet.findCell(this.model.sharedFormula);this._translatedFormula=e&&l(e.formula,e.address,this.model.address)}return this._translatedFormula},toCsvString:function(){return\"\"+(this.model.result||\"\")},release:function(){},toString:function(){return this.model.result?this.model.result.toString():\"\"}};var y=function(e,t){this.model={address:e.address,type:i.Types.SharedString,value:t}};y.prototype={get value(){return this.model.value},set value(e){this.model.value=e},get type(){return i.Types.SharedString},get effectiveType(){return i.Types.SharedString},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return\"\"+this.model.value},release:function(){},toString:function(){return this.model.value.toString()}};var g=function(e,t){this.model={address:e.address,type:i.Types.Boolean,value:t}};g.prototype={get value(){return this.model.value},set value(e){this.model.value=e},get type(){return i.Types.Boolean},get effectiveType(){return i.Types.Boolean},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return this.model.value?1:0},release:function(){},toString:function(){return this.model.value.toString()}};var f=function(e,t){this.model={address:e.address,type:i.Types.Error,value:t}};f.prototype={get value(){return this.model.value},set value(e){this.model.value=e},get type(){return i.Types.Error},get effectiveType(){return i.Types.Error},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return this.toString()},release:function(){},toString:function(){return this.model.value.error.toString()}};var v=function(e,t){this.model={address:e.address,type:i.Types.String,value:JSON.stringify(t),rawValue:t}};v.prototype={get value(){return this.model.rawValue},set value(e){this.model.rawValue=e,this.model.value=JSON.stringify(e)},get type(){return i.Types.String},get effectiveType(){return i.Types.String},get address(){return this.model.address},set address(e){this.model.address=e},toCsvString:function(){return this.model.value},release:function(){},toString:function(){return this.model.value}};var c={getType:function(e){return null==e?i.Types.Null:e instanceof String||\"string\"==typeof e?i.Types.String:\"number\"==typeof e?i.Types.Number:\"boolean\"==typeof e?i.Types.Boolean:e instanceof Date?i.Types.Date:e.text&&e.hyperlink?i.Types.Hyperlink:e.formula||e.sharedFormula?i.Types.Formula:e.richText?i.Types.RichText:e.sharedString?i.Types.SharedString:e.error?i.Types.Error:i.Types.JSON},types:[{t:i.Types.Null,f:n},{t:i.Types.Number,f:a},{t:i.Types.String,f:o},{t:i.Types.Date,f:d},{t:i.Types.Hyperlink,f:h},{t:i.Types.Formula,f:p},{t:i.Types.Merge,f:m},{t:i.Types.JSON,f:v},{t:i.Types.SharedString,f:y},{t:i.Types.RichText,f:u},{t:i.Types.Boolean,f:g},{t:i.Types.Error,f:f}].reduce(function(e,t){return e[t.t]=t.f,e},[]),create:function(e,t,r){var s=this.types[e];if(!s)throw new Error(\"Could not create Value of type \"+e);return new s(t,r)}};\n},{\"../utils/col-cache\":\"oVwW\",\"../utils/under-dash\":\"h8Mb\",\"./enums\":\"YmZx\",\"../utils/shared-formula\":\"fBoy\"}],\"bgg3\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils/under-dash\"),t=require(\"./enums\"),l=require(\"./../utils/col-cache\"),s=require(\"./cell\"),i=module.exports=function(e,t){this._worksheet=e,this._number=t,this._cells=[],this.style={},this.outlineLevel=0};i.prototype={get number(){return this._number},get worksheet(){return this._worksheet},commit:function(){this._worksheet._commitRow(this)},destroy:function(){delete this._worksheet,delete this._cells,delete this.style},findCell:function(e){return this._cells[e-1]},getCellEx:function(e){var t=this._cells[e.col-1];if(!t){var l=this._worksheet.getColumn(e.col);t=new s(this,l,e.address),this._cells[e.col-1]=t}return t},getCell:function(e){if(\"string\"==typeof e){var t=this._worksheet.getColumnKey(e);e=t?t.number:l.l2n(e)}return this._cells[e-1]||this.getCellEx({address:l.encodeAddress(this._number,e),row:this._number,col:e})},splice:function(e,t){var l=Array.prototype.slice.call(arguments,2),s=e+t,i=l.length-t,r=this._cells.length,n=void 0,h=void 0,o=void 0;if(i<0)for(n=e+l.length;n<=r;n++)o=this._cells[n-1],(h=this._cells[n-i-1])?((o=this.getCell(n)).value=h.value,o.style=h.style):o&&(o.value=null,o.style={});else if(i>0)for(n=r;n>=s;n--)(h=this._cells[n-1])?((o=this.getCell(n+i)).value=h.value,o.style=h.style):this._cells[n+i-1]=void 0;for(n=0;n<l.length;n++)(o=this.getCell(e+n)).value=l[n],o.style={}},eachCell:function(e,l){if(l||(l=e,e=null),e&&e.includeEmpty)for(var s=this._cells.length,i=1;i<=s;i++)l(this.getCell(i),i);else this._cells.forEach(function(e,s){e&&e.type!==t.ValueType.Null&&l(e,s+1)})},addPageBreak:function(e,t){var l=this._worksheet,s=Math.max(0,e-1)||0,i=Math.max(0,t-1)||16838,r={id:this._number,max:i,man:1};s&&(r.min=s),l.rowBreaks.push(r)},get values(){var e=[];return this._cells.forEach(function(l){l&&l.type!==t.ValueType.Null&&(e[l.col]=l.value)}),e},set values(e){var t=this;if(this._cells=[],e)if(e instanceof Array){var s=0;e.hasOwnProperty(\"0\")&&(s=1),e.forEach(function(e,i){void 0!==e&&(t.getCellEx({address:l.encodeAddress(t._number,i+s),row:t._number,col:i+s}).value=e)})}else this._worksheet.eachColumnKey(function(s,i){void 0!==e[i]&&(t.getCellEx({address:l.encodeAddress(t._number,s.number),row:t._number,col:s.number}).value=e[i])});else;},get hasValues(){return e.some(this._cells,function(e){return e&&e.type!==t.ValueType.Null})},get cellCount(){return this._cells.length},get actualCellCount(){var e=0;return this.eachCell(function(){e++}),e},get dimensions(){var e=0,l=0;return this._cells.forEach(function(s){s&&s.type!==t.ValueType.Null&&((!e||e>s.col)&&(e=s.col),l<s.col&&(l=s.col))}),e>0?{min:e,max:l}:null},_applyStyle:function(e,t){return this.style[e]=t,this._cells.forEach(function(l){l&&(l[e]=t)}),t},get numFmt(){return this.style.numFmt},set numFmt(e){this._applyStyle(\"numFmt\",e)},get font(){return this.style.font},set font(e){this._applyStyle(\"font\",e)},get alignment(){return this.style.alignment},set alignment(e){this._applyStyle(\"alignment\",e)},get border(){return this.style.border},set border(e){this._applyStyle(\"border\",e)},get fill(){return this.style.fill},set fill(e){this._applyStyle(\"fill\",e)},get hidden(){return!!this._hidden},set hidden(e){this._hidden=e},get outlineLevel(){return this._outlineLevel||0},set outlineLevel(e){this._outlineLevel=e},get collapsed(){return!!(this._outlineLevel&&this._outlineLevel>=this._worksheet.properties.outlineLevelRow)},get model(){var e=[],t=0,l=0;return this._cells.forEach(function(s){if(s){var i=s.model;i&&((!t||t>s.col)&&(t=s.col),l<s.col&&(l=s.col),e.push(i))}}),this.height||e.length?{cells:e,number:this.number,min:t,max:l,height:this.height,style:this.style,hidden:this.hidden,outlineLevel:this.outlineLevel,collapsed:this.collapsed}:null},set model(e){var t=this;if(e.number!==this._number)throw new Error(\"Invalid row number in model\");this._cells=[];var i=void 0;e.cells.forEach(function(e){switch(e.type){case s.Types.Merge:break;default:var r=void 0;if(e.address)r=l.decodeAddress(e.address);else if(i){var n=i.row,h=i.col+1;r={row:n,col:h,address:l.encodeAddress(n,h),$col$row:\"$\"+l.n2l(h)+\"$\"+n}}i=r,t.getCellEx(r).model=e}}),e.height?this.height=e.height:delete this.height,this.hidden=e.hidden,this.outlineLevel=e.outlineLevel||0,this.style=e.style&&JSON.parse(JSON.stringify(e.style))||{}}};\n},{\"../utils/under-dash\":\"h8Mb\",\"./enums\":\"YmZx\",\"./../utils/col-cache\":\"oVwW\",\"./cell\":\"p2/y\"}],\"NT5F\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils/under-dash\"),t=require(\"./enums\"),i=require(\"../utils/col-cache\"),h=module.exports=function(e,t,i){this._worksheet=e,this._number=t,!1!==i&&(this.defn=i)};h.prototype={get number(){return this._number},get worksheet(){return this._worksheet},get letter(){return i.n2l(this._number)},get isCustomWidth(){return void 0!==this.width&&8!==this.width},get defn(){return{header:this._header,key:this.key,width:this.width,style:this.style,hidden:this.hidden,outlineLevel:this.outlineLevel}},set defn(e){e?(this.key=e.key,this.width=e.width,this.outlineLevel=e.outlineLevel,e.style?this.style=e.style:this.style={},this.header=e.header,this._hidden=!!e.hidden):(delete this._header,delete this.key,delete this.width,this.style={},this.outlineLevel=0)},get headers(){return this._header&&this._header instanceof Array?this._header:[this._header]},get header(){return this._header},set header(e){var t=this;void 0!==e?(this._header=e,this.headers.forEach(function(e,i){t._worksheet.getCell(i+1,t.number).value=e})):this._header=void 0},get key(){return this._key},set key(e){(this._key&&this._worksheet.getColumnKey(this._key))===this&&this._worksheet.deleteColumnKey(this._key),this._key=e,e&&this._worksheet.setColumnKey(this._key,this)},get hidden(){return!!this._hidden},set hidden(e){this._hidden=e},get outlineLevel(){return this._outlineLevel||0},set outlineLevel(e){this._outlineLevel=e},get collapsed(){return!!(this._outlineLevel&&this._outlineLevel>=this._worksheet.properties.outlineLevelCol)},toString:function(){return JSON.stringify({key:this.key,width:this.width,headers:this.headers.length?this.headers:void 0})},equivalentTo:function(t){return this.width===t.width&&this.hidden===t.hidden&&this.outlineLevel===t.outlineLevel&&e.isEqual(this.style,t.style)},get isDefault(){if(this.isCustomWidth)return!1;if(this.hidden)return!1;if(this.outlineLevel)return!1;var e=this.style;return!e||!(e.font||e.numFmt||e.alignment||e.border||e.fill)},get headerCount(){return this.headers.length},eachCell:function(e,t){var i=this.number;t||(t=e,e=null),this._worksheet.eachRow(e,function(e,h){t(e.getCell(i),h)})},get values(){var e=[];return this.eachCell(function(i,h){i&&i.type!==t.ValueType.Null&&(e[h]=i.value)}),e},set values(e){var t=this;if(e){var i=this.number,h=0;e.hasOwnProperty(\"0\")&&(h=1),e.forEach(function(e,s){t._worksheet.getCell(s+h,i).value=e})}},_applyStyle:function(e,t){return this.style[e]=t,this.eachCell(function(i){i[e]=t}),t},get numFmt(){return this.style.numFmt},set numFmt(e){this._applyStyle(\"numFmt\",e)},get font(){return this.style.font},set font(e){this._applyStyle(\"font\",e)},get alignment(){return this.style.alignment},set alignment(e){this._applyStyle(\"alignment\",e)},get border(){return this.style.border},set border(e){this._applyStyle(\"border\",e)},get fill(){return this.style.fill},set fill(e){this._applyStyle(\"fill\",e)}},h.toModel=function(e){var t=[],i=null;return e&&e.forEach(function(e,h){e.isDefault?i&&(i=null):i&&e.equivalentTo(i)?i.max=h+1:(i={min:h+1,max:h+1,width:e.width,style:e.style,isCustomWidth:e.isCustomWidth,hidden:e.hidden,outlineLevel:e.outlineLevel,collapsed:e.collapsed},t.push(i))}),t.length?t:void 0},h.fromModel=function(e,t){t=t||[];for(var i=[],s=1,n=0;n<t.length;){for(var l=t[n++];s<l.min;)i.push(new h(e,s++));for(;s<=l.max;)i.push(new h(e,s++,l))}return i.length?i:null};\n},{\"../utils/under-dash\":\"h8Mb\",\"./enums\":\"YmZx\",\"../utils/col-cache\":\"oVwW\"}],\"gEiC\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../utils/col-cache\"),i=function(i,e){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;if(e)if(\"string\"==typeof e){var h=t.decodeAddress(e);this.nativeCol=h.col+o,this.nativeColOff=0,this.nativeRow=h.row+o,this.nativeRowOff=0}else e.nativeCol?(this.nativeCol=e.nativeCol||0,this.nativeColOff=e.nativeColOff||0,this.nativeRow=e.nativeRow||0,this.nativeRowOff=e.nativeRowOff||0):e.col?(this.col=e.col+o,this.row=e.row+o):(this.nativeCol=0,this.nativeColOff=0,this.nativeRow=0,this.nativeRowOff=0);else this.nativeCol=0,this.nativeColOff=0,this.nativeRow=0,this.nativeRowOff=0;this.worksheet=i};i.asInstance=function(t){return t instanceof i||null==t?t:new i(t)},i.prototype={get col(){return this.nativeCol+Math.min(this.colWidth-1,this.nativeColOff)/this.colWidth},set col(t){this.nativeCol=Math.floor(t),this.nativeColOff=Math.floor((t-this.nativeCol)*this.colWidth)},get row(){return this.nativeRow+Math.min(this.rowHeight-1,this.nativeRowOff)/this.rowHeight},set row(t){this.nativeRow=Math.floor(t),this.nativeRowOff=Math.floor((t-this.nativeRow)*this.rowHeight)},get colWidth(){return this.worksheet&&this.worksheet.getColumn(this.nativeCol+1)&&this.worksheet.getColumn(this.nativeCol+1).isCustomWidth?Math.floor(1e4*this.worksheet.getColumn(this.nativeCol+1).width):64e4},get rowHeight(){return this.worksheet&&this.worksheet.getRow(this.nativeRow+1)&&this.worksheet.getRow(this.nativeRow+1).height?Math.floor(1e4*this.worksheet.getRow(this.nativeRow+1).height):18e4},get model(){return{nativeCol:this.nativeCol,nativeColOff:this.nativeColOff,nativeRow:this.nativeRow,nativeRowOff:this.nativeRowOff}},set model(t){this.nativeCol=t.nativeCol,this.nativeColOff=t.nativeColOff,this.nativeRow=t.nativeRow,this.nativeRowOff=t.nativeRowOff}},module.exports=i;\n},{\"../utils/col-cache\":\"oVwW\"}],\"nFa1\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils/col-cache\"),t=require(\"./anchor\"),r=function(e,t){this.worksheet=e,this.model=t};r.prototype={get model(){switch(this.type){case\"background\":return{type:this.type,imageId:this.imageId};case\"image\":return{type:this.type,imageId:this.imageId,range:{tl:this.range.tl.model,br:this.range.br&&this.range.br.model,ext:this.range.ext}};default:throw new Error(\"Invalid Image Type\")}},set model(r){var i=r.type,s=r.imageId,o=r.range;if(this.type=i,this.imageId=s,\"image\"===i)if(\"string\"==typeof o){var h=e.decode(o);this.range={tl:new t(this.worksheet,{col:h.left,row:h.top},-1),br:new t(this.worksheet,{col:h.right,row:h.bottom},0),editAs:\"oneCell\"}}else this.range={tl:new t(this.worksheet,o.tl,0),br:o.br&&new t(this.worksheet,o.br,0),ext:o.ext,editAs:o.editAs}}},module.exports=r;\n},{\"../utils/col-cache\":\"oVwW\",\"./anchor\":\"gEiC\"}],\"nfdJ\":[function(require,module,exports) {\n\"use strict\";var t=module.exports=function(t){this.model=t||{}};t.prototype={add:function(t,o){return this.model[t]=o},find:function(t){return this.model[t]},remove:function(t){this.model[t]=void 0}};\n},{}],\"BLgy\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils/under-dash\"),t=require(\"./../utils/col-cache\"),r=require(\"./range\"),o=require(\"./row\"),s=require(\"./column\"),i=require(\"./enums\"),n=require(\"./image\"),a=require(\"./data-validations\"),l=function(e){e=e||{},this.id=e.id,this.orderNo=e.orderNo,this.name=e.name||\"Sheet\"+this.id,this.state=e.state||\"visible\",this._rows=[],this._columns=null,this._keys={},this._merges={},this.rowBreaks=[],this._workbook=e.workbook,this.properties=Object.assign({},{defaultRowHeight:15,dyDescent:55,outlineLevelCol:0,outlineLevelRow:0},e.properties),this.pageSetup=Object.assign({},{margins:{left:.7,right:.7,top:.75,bottom:.75,header:.3,footer:.3},orientation:\"portrait\",horizontalDpi:4294967295,verticalDpi:4294967295,fitToPage:!(!e.pageSetup||!e.pageSetup.fitToWidth&&!e.pageSetup.fitToHeight||e.pageSetup.scale),pageOrder:\"downThenOver\",blackAndWhite:!1,draft:!1,cellComments:\"None\",errors:\"displayed\",scale:100,fitToWidth:1,fitToHeight:1,paperSize:void 0,showRowColHeaders:!1,showGridLines:!1,firstPageNumber:void 0,horizontalCentered:!1,verticalCentered:!1,rowBreaks:null,colBreaks:null},e.pageSetup),this.dataValidations=new a,this.views=e.views||[],this.autoFilter=e.autoFilter||null,this._media=[]};l.prototype={get workbook(){return this._workbook},destroy:function(){this._workbook.removeWorksheetEx(this)},get dimensions(){var e=new r;return this._rows.forEach(function(t){if(t){var r=t.dimensions;r&&e.expand(t.number,r.min,t.number,r.max)}}),e},get columns(){return this._columns},set columns(e){var t=this;this._headerRowCount=e.reduce(function(e,t){var r=(t.header?1:t.headers&&t.headers.length)||0;return Math.max(e,r)},0);var r=1,o=this._columns=[];e.forEach(function(e){var i=new s(t,r++,!1);o.push(i),i.defn=e})},getColumnKey:function(e){return this._keys[e]},setColumnKey:function(e,t){this._keys[e]=t},deleteColumnKey:function(e){delete this._keys[e]},eachColumnKey:function(t){e.each(this._keys,t)},getColumn:function(e){if(\"string\"==typeof e){var r=this._keys[e];if(r)return r;e=t.l2n(e)}if(this._columns||(this._columns=[]),e>this._columns.length)for(var o=this._columns.length+1;o<=e;)this._columns.push(new s(this,o++));return this._columns[e-1]},spliceColumns:function(e,t){var r=this,o=Array.prototype.slice.call(arguments,2),s=this._rows.length;if(o.length>0)for(var i=function(s){var i=[e,t];o.forEach(function(e){i.push(e[s]||null)});var n=r.getRow(s+1);n.splice.apply(n,i)},n=0;n<s;n++)i(n);else this._rows.forEach(function(r){r&&r.splice(e,t)});var a=o.length-t,l=e+t,u=this._columns.length;if(a<0)for(n=e+o.length;n<=u;n++)this.getColumn(n).defn=this.getColumn(n-a).defn;else if(a>0)for(var h=u;h>=l;h--)this.getColumn(h+a).defn=this.getColumn(h).defn;for(var c=e;c<e+o.length;c++)this.getColumn(c).defn=null;this.workbook.definedNames.spliceColumns(this.name,e,t,o.length)},get columnCount(){var e=0;return this.eachRow(function(t){e=Math.max(e,t.cellCount)}),e},get actualColumnCount(){var e=[],t=0;return this.eachRow(function(r){r.eachCell(function(r){var o=r.col;e[o]||(e[o]=!0,t++)})}),t},_commitRow:function(){},get _lastRowNumber(){for(var e=this._rows,t=e.length;t>0&&void 0===e[t-1];)t--;return t},get _nextRow(){return this._lastRowNumber+1},get lastRow(){if(this._rows.length)return this._rows[this._rows.length-1]},findRow:function(e){return this._rows[e-1]},get rowCount(){return this._lastRowNumber},get actualRowCount(){var e=0;return this.eachRow(function(){e++}),e},getRow:function(e){var t=this._rows[e-1];return t||(t=this._rows[e-1]=new o(this,e)),t},addRow:function(e){var t=this.getRow(this._nextRow);return t.values=e,t},addRows:function(e){var t=this;e.forEach(function(e){t.addRow(e)})},spliceRows:function(e,t){var r=this,o=Array.prototype.slice.call(arguments,2),s=e+t,i=o.length-t,n=this._rows.length,a=void 0,l=void 0;if(i<0)for(a=s;a<=n;a++)(l=this._rows[a-1])?function(){var e=r.getRow(a+i);e.values=l.values,e.style=l.style,l.eachCell({includeEmpty:!0},function(t,r){e.getCell(r).style=t.style}),r._rows[a-1]=void 0}():this._rows[a+i-1]=void 0;else if(i>0)for(a=n;a>=s;a--)(l=this._rows[a-1])?function(){var e=r.getRow(a+i);e.values=l.values,e.style=l.style,l.eachCell({includeEmpty:!0},function(t,r){e.getCell(r).style=t.style})}():this._rows[a+i-1]=void 0;for(a=0;a<o.length;a++){var u=this.getRow(e+a);u.style={},u.values=o[a]}this.workbook.definedNames.spliceRows(this.name,e,t,o.length)},eachRow:function(e,t){if(t||(t=e,e=void 0),e&&e.includeEmpty)for(var r=this._rows.length,o=1;o<=r;o++)t(this.getRow(o),o);else this._rows.forEach(function(e){e&&e.hasValues&&t(e,e.number)})},getSheetValues:function(){var e=[];return this._rows.forEach(function(t){t&&(e[t.number]=t.values)}),e},findCell:function(e,r){var o=t.getAddress(e,r),s=this._rows[o.row-1];return s?s.findCell(o.col):void 0},getCell:function(e,r){var o=t.getAddress(e,r);return this.getRow(o.row).getCellEx(o)},mergeCells:function(){var t=new r(Array.prototype.slice.call(arguments,0));e.each(this._merges,function(e){if(e.intersects(t))throw new Error(\"Cannot merge already merged cells\")});for(var o=this.getCell(t.top,t.left),s=t.top;s<=t.bottom;s++)for(var i=t.left;i<=t.right;i++)(s>t.top||i>t.left)&&this.getCell(s,i).merge(o);this._merges[o.address]=t},_unMergeMaster:function(e){var t=this._merges[e.address];if(t){for(var r=t.top;r<=t.bottom;r++)for(var o=t.left;o<=t.right;o++)this.getCell(r,o).unmerge();delete this._merges[e.address]}},get hasMerges(){return e.some(this._merges,function(){return!0})},unMergeCells:function(){for(var e=new r(Array.prototype.slice.call(arguments,0)),t=e.top;t<=e.bottom;t++)for(var o=e.left;o<=e.right;o++){var s=this.findCell(t,o);s&&(s.type===i.ValueType.Merge?this._unMergeMaster(s.master):this._merges[s.address]&&this._unMergeMaster(s))}},fillFormula:function(e,r,o){var s=t.decode(e),i=s.top,n=s.left,a=s.bottom,l=s.right,u=l-n+1,h=t.encodeAddress(i,n),c=void 0;c=\"function\"==typeof o?o:Array.isArray(o)?Array.isArray(o[0])?function(e,t){return o[e-i][t-n]}:function(e,t){return o[(e-i)*u+(t-n)]}:function(){};for(var d=!0,f=i;f<=a;f++)for(var g=n;g<=l;g++)d?(this.getCell(f,g).value={formula:r,result:c(f,g)},d=!1):this.getCell(f,g).value={sharedFormula:h,result:c(f,g)}},addImage:function(e,t){var r={type:\"image\",imageId:e,range:t};this._media.push(new n(this,r))},getImages:function(){return this._media.filter(function(e){return\"image\"===e.type})},addBackgroundImage:function(e){var t={type:\"background\",imageId:e};this._media.push(new n(this,t))},getBackgroundImageId:function(){var e=this._media.find(function(e){return\"background\"===e.type});return e&&e.imageId},get tabColor(){return console.trace(\"worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor\"),this.properties.tabColor},set tabColor(e){console.trace(\"worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor\"),this.properties.tabColor=e},get model(){var t={id:this.id,name:this.name,dataValidations:this.dataValidations.model,properties:this.properties,state:this.state,pageSetup:this.pageSetup,rowBreaks:this.rowBreaks,views:this.views,autoFilter:this.autoFilter,media:this._media.map(function(e){return e.model})};t.cols=s.toModel(this.columns);var o=t.rows=[],i=t.dimensions=new r;return this._rows.forEach(function(e){var t=e&&e.model;t&&(i.expand(t.number,t.min,t.number,t.max),o.push(t))}),t.merges=[],e.each(this._merges,function(e){t.merges.push(e.range)}),t},_parseRows:function(e){var t=this;this._rows=[],e.rows.forEach(function(e){var r=new o(t,e.number);t._rows[r.number-1]=r,r.model=e})},_parseMergeCells:function(t){var r=this;e.each(t.mergeCells,function(e){r.mergeCells(e)})},set model(e){var t=this;this.name=e.name,this._columns=s.fromModel(this,e.cols),this._parseRows(e),this._parseMergeCells(e),this.dataValidations=new a(e.dataValidations),this.properties=e.properties,this.pageSetup=e.pageSetup,this.views=e.views,this.autoFilter=e.autoFilter,this._media=e.media.map(function(e){return new n(t,e)})}},module.exports=l;\n},{\"../utils/under-dash\":\"h8Mb\",\"./../utils/col-cache\":\"oVwW\",\"./range\":\"PZiO\",\"./row\":\"bgg3\",\"./column\":\"NT5F\",\"./enums\":\"YmZx\",\"./image\":\"nFa1\",\"./data-validations\":\"nfdJ\"}],\"rGyf\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./under-dash\"),t=require(\"./col-cache\"),i=function(e){this.template=e,this.sheets={}};i.prototype={addCell:function(e){this.addCellEx(t.decodeEx(e))},getCell:function(e){return this.findCellEx(t.decodeEx(e),!0)},findCell:function(e){return this.findCellEx(t.decodeEx(e),!1)},findCellAt:function(e,t,i){var n=this.sheets[e],s=n&&n[t];return s&&s[i]},addCellEx:function(e){if(e.top)for(var t=e.top;t<=e.bottom;t++)for(var i=e.left;i<=e.right;i++)this.getCellAt(e.sheetName,t,i);else this.findCellEx(e,!0)},getCellEx:function(e){return this.findCellEx(e,!0)},findCellEx:function(e,t){var i=this.findSheet(e,t),n=this.findSheetRow(i,e,t);return this.findRowCell(n,e,t)},getCellAt:function(e,i,n){var s=this.sheets[e]||(this.sheets[e]=[]),h=s[i]||(s[i]=[]);return h[n]||(h[n]={sheetName:e,address:t.n2l(n)+i,row:i,col:n})},removeCellEx:function(e){var t=this.findSheet(e);if(t){var i=this.findSheetRow(t,e);i&&delete i[e.col]}},forEachInSheet:function(e,t){var i=this.sheets[e];i&&i.forEach(function(e,i){e&&e.forEach(function(e,n){e&&t(e,i,n)})})},forEach:function(t){var i=this;e.each(this.sheets,function(e,n){i.forEachInSheet(n,t)})},map:function(e){var t=[];return this.forEach(function(i){t.push(e(i))}),t},findSheet:function(e,t){var i=e.sheetName;return this.sheets[i]?this.sheets[i]:t?this.sheets[i]=[]:void 0},findSheetRow:function(e,t,i){var n=t.row;return e&&e[n]?e[n]:i?e[n]=[]:void 0},findRowCell:function(e,t,i){var n=t.col;return e&&e[n]?e[n]:i?e[n]=this.template?Object.assign(t,JSON.parse(JSON.stringify(this.template))):t:void 0},spliceRows:function(e,t,i,n){var s=this.sheets[e];if(s){for(var h=[],o=0;o<n;o++)h.push([]);s.splice.apply(s,[t,i].concat(h))}},spliceColumns:function(t,i,n,s){var h=this.sheets[t];if(h){for(var o=[],r=0;r<s;r++)o.push(null);e.each(h,function(e){e.splice.apply(e,[i,n].concat(o))})}}},module.exports=i;\n},{\"./under-dash\":\"h8Mb\",\"./col-cache\":\"oVwW\"}],\"vAec\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../utils/under-dash\"),r=require(\"../utils/col-cache\"),e=require(\"../utils/cell-matrix\"),n=require(\"./range\"),o=/[$](\\w+)[$](\\d+)(:[$](\\w+)[$](\\d+))?/,a=function(){this.matrixMap={}};a.prototype={getMatrix:function(t){return this.matrixMap[t]||(this.matrixMap[t]=new e)},add:function(t,e){var n=r.decodeEx(t);this.addEx(n,e)},addEx:function(t,e){var n=this.getMatrix(e);if(t.top)for(var o=t.left;o<=t.right;o++)for(var a=t.top;a<=t.bottom;a++){var i={sheetName:t.sheetName,address:r.n2l(o)+a,row:a,col:o};n.addCellEx(i)}else n.addCellEx(t)},remove:function(t,e){var n=r.decodeEx(t);this.removeEx(n,e)},removeEx:function(t,r){this.getMatrix(r).removeCellEx(t)},removeAllNames:function(r){t.each(this.matrixMap,function(t){t.removeCellEx(r)})},forEach:function(r){t.each(this.matrixMap,function(t,e){t.forEach(function(t){r(e,t)})})},getNames:function(t){return this.getNamesEx(r.decodeEx(t))},getNamesEx:function(r){return t.map(this.matrixMap,function(t,e){return t.findCellEx(r)&&e}).filter(Boolean)},_explore:function(t,r){r.mark=!1;var e=r.sheetName,o=new n(r.row,r.col,r.row,r.col,e),a=void 0,i=void 0;function c(n,a){var i=t.findCellAt(e,n,r.col);return!(!i||!i.mark)&&(o[a]=n,i.mark=!1,!0)}for(i=r.row-1;c(i,\"top\");i--);for(i=r.row+1;c(i,\"bottom\");i++);function s(r,n){var a=[];for(i=o.top;i<=o.bottom;i++){var c=t.findCellAt(e,i,r);if(!c||!c.mark)return!1;a.push(c)}o[n]=r;for(var s=0;s<a.length;s++)a[s].mark=!1;return!0}for(a=r.col-1;s(a,\"left\");a--);for(a=r.col+1;s(a,\"right\");a++);return o},getRanges:function(t,r){var e=this;return(r=r||this.matrixMap[t])?(r.forEach(function(t){t.mark=!0}),{name:t,ranges:r.map(function(t){return t.mark&&e._explore(r,t)}).filter(Boolean).map(function(t){return t.$shortRange})}):{name:t,ranges:[]}},normaliseMatrix:function(t,e){t.forEachInSheet(e,function(t,e,n){t&&(t.row===e&&t.col===n||(t.row=e,t.col=n,t.address=r.n2l(n)+e))})},spliceRows:function(r,e,n,o){var a=this;t.each(this.matrixMap,function(t){t.spliceRows(r,e,n,o),a.normaliseMatrix(t,r)})},spliceColumns:function(r,e,n,o){var a=this;t.each(this.matrixMap,function(t){t.spliceColumns(r,e,n,o),a.normaliseMatrix(t,r)})},get model(){var r=this;return t.map(this.matrixMap,function(t,e){return r.getRanges(e,t)}).filter(function(t){return t.ranges.length})},set model(t){var r=this.matrixMap={};t.forEach(function(t){var n=r[t.name]=new e;t.ranges.forEach(function(t){o.test(t.split(\"!\").pop()||\"\")&&n.addCell(t)})})}},module.exports=a;\n},{\"../utils/under-dash\":\"h8Mb\",\"../utils/col-cache\":\"oVwW\",\"../utils/cell-matrix\":\"rGyf\",\"./range\":\"PZiO\"}],\"70rD\":[function(require,module,exports) {\n\n},{}],\"FRpO\":[function(require,module,exports) {\n\"use strict\";var e,t=\"object\"==typeof Reflect?Reflect:null,n=t&&\"function\"==typeof t.apply?t.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};function r(e){console&&console.warn&&console.warn(e)}e=t&&\"function\"==typeof t.ownKeys?t.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var i=Number.isNaN||function(e){return e!=e};function o(){o.init.call(this)}module.exports=o,o.EventEmitter=o,o.prototype._events=void 0,o.prototype._eventsCount=0,o.prototype._maxListeners=void 0;var s=10;function u(e){return void 0===e._maxListeners?o.defaultMaxListeners:e._maxListeners}function f(e,t,n,i){var o,s,f;if(\"function\"!=typeof n)throw new TypeError('The \"listener\" argument must be of type Function. Received type '+typeof n);if(void 0===(s=e._events)?(s=e._events=Object.create(null),e._eventsCount=0):(void 0!==s.newListener&&(e.emit(\"newListener\",t,n.listener?n.listener:n),s=e._events),f=s[t]),void 0===f)f=s[t]=n,++e._eventsCount;else if(\"function\"==typeof f?f=s[t]=i?[n,f]:[f,n]:i?f.unshift(n):f.push(n),(o=u(e))>0&&f.length>o&&!f.warned){f.warned=!0;var p=new Error(\"Possible EventEmitter memory leak detected. \"+f.length+\" \"+String(t)+\" listeners added. Use emitter.setMaxListeners() to increase limit\");p.name=\"MaxListenersExceededWarning\",p.emitter=e,p.type=t,p.count=f.length,r(p)}return e}function p(){for(var e=[],t=0;t<arguments.length;t++)e.push(arguments[t]);this.fired||(this.target.removeListener(this.type,this.wrapFn),this.fired=!0,n(this.listener,this.target,e))}function v(e,t,n){var r={fired:!1,wrapFn:void 0,target:e,type:t,listener:n},i=p.bind(r);return i.listener=n,r.wrapFn=i,i}function h(e,t,n){var r=e._events;if(void 0===r)return[];var i=r[t];return void 0===i?[]:\"function\"==typeof i?n?[i.listener||i]:[i]:n?y(i):c(i,i.length)}function a(e){var t=this._events;if(void 0!==t){var n=t[e];if(\"function\"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function c(e,t){for(var n=new Array(t),r=0;r<t;++r)n[r]=e[r];return n}function l(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}function y(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}Object.defineProperty(o,\"defaultMaxListeners\",{enumerable:!0,get:function(){return s},set:function(e){if(\"number\"!=typeof e||e<0||i(e))throw new RangeError('The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received '+e+\".\");s=e}}),o.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},o.prototype.setMaxListeners=function(e){if(\"number\"!=typeof e||e<0||i(e))throw new RangeError('The value of \"n\" is out of range. It must be a non-negative number. Received '+e+\".\");return this._maxListeners=e,this},o.prototype.getMaxListeners=function(){return u(this)},o.prototype.emit=function(e){for(var t=[],r=1;r<arguments.length;r++)t.push(arguments[r]);var i=\"error\"===e,o=this._events;if(void 0!==o)i=i&&void 0===o.error;else if(!i)return!1;if(i){var s;if(t.length>0&&(s=t[0]),s instanceof Error)throw s;var u=new Error(\"Unhandled error.\"+(s?\" (\"+s.message+\")\":\"\"));throw u.context=s,u}var f=o[e];if(void 0===f)return!1;if(\"function\"==typeof f)n(f,this,t);else{var p=f.length,v=c(f,p);for(r=0;r<p;++r)n(v[r],this,t)}return!0},o.prototype.addListener=function(e,t){return f(this,e,t,!1)},o.prototype.on=o.prototype.addListener,o.prototype.prependListener=function(e,t){return f(this,e,t,!0)},o.prototype.once=function(e,t){if(\"function\"!=typeof t)throw new TypeError('The \"listener\" argument must be of type Function. Received type '+typeof t);return this.on(e,v(this,e,t)),this},o.prototype.prependOnceListener=function(e,t){if(\"function\"!=typeof t)throw new TypeError('The \"listener\" argument must be of type Function. Received type '+typeof t);return this.prependListener(e,v(this,e,t)),this},o.prototype.removeListener=function(e,t){var n,r,i,o,s;if(\"function\"!=typeof t)throw new TypeError('The \"listener\" argument must be of type Function. Received type '+typeof t);if(void 0===(r=this._events))return this;if(void 0===(n=r[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete r[e],r.removeListener&&this.emit(\"removeListener\",e,n.listener||t));else if(\"function\"!=typeof n){for(i=-1,o=n.length-1;o>=0;o--)if(n[o]===t||n[o].listener===t){s=n[o].listener,i=o;break}if(i<0)return this;0===i?n.shift():l(n,i),1===n.length&&(r[e]=n[0]),void 0!==r.removeListener&&this.emit(\"removeListener\",e,s||t)}return this},o.prototype.off=o.prototype.removeListener,o.prototype.removeAllListeners=function(e){var t,n,r;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var i,o=Object.keys(n);for(r=0;r<o.length;++r)\"removeListener\"!==(i=o[r])&&this.removeAllListeners(i);return this.removeAllListeners(\"removeListener\"),this._events=Object.create(null),this._eventsCount=0,this}if(\"function\"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(r=t.length-1;r>=0;r--)this.removeListener(e,t[r]);return this},o.prototype.listeners=function(e){return h(this,e,!0)},o.prototype.rawListeners=function(e){return h(this,e,!1)},o.listenerCount=function(e,t){return\"function\"==typeof e.listenerCount?e.listenerCount(t):a.call(e,t)},o.prototype.listenerCount=a,o.prototype.eventNames=function(){return this._eventsCount>0?e(this._events):[]};\n},{}],\"4Bm0\":[function(require,module,exports) {\n\"function\"==typeof Object.create?module.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:module.exports=function(t,e){t.super_=e;var o=function(){};o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t};\n},{}],\"Yj0v\":[function(require,module,exports) {\nvar process = require(\"process\");\nvar n=require(\"process\");function e(e,r,t,c){if(\"function\"!=typeof e)throw new TypeError('\"callback\" argument must be a function');var i,l,u=arguments.length;switch(u){case 0:case 1:return n.nextTick(e);case 2:return n.nextTick(function(){e.call(null,r)});case 3:return n.nextTick(function(){e.call(null,r,t)});case 4:return n.nextTick(function(){e.call(null,r,t,c)});default:for(i=new Array(u-1),l=0;l<i.length;)i[l++]=arguments[l];return n.nextTick(function(){e.apply(null,i)})}}!n.version||0===n.version.indexOf(\"v0.\")||0===n.version.indexOf(\"v1.\")&&0!==n.version.indexOf(\"v1.8.\")?module.exports={nextTick:e}:module.exports=n;\n},{\"process\":\"pBGv\"}],\"REa7\":[function(require,module,exports) {\nvar r={}.toString;module.exports=Array.isArray||function(t){return\"[object Array]\"==r.call(t)};\n},{}],\"1ExO\":[function(require,module,exports) {\nmodule.exports=require(\"events\").EventEmitter;\n},{\"events\":\"FRpO\"}],\"yh9p\":[function(require,module,exports) {\n\"use strict\";exports.byteLength=u,exports.toByteArray=i,exports.fromByteArray=d;for(var r=[],t=[],e=\"undefined\"!=typeof Uint8Array?Uint8Array:Array,n=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",o=0,a=n.length;o<a;++o)r[o]=n[o],t[n.charCodeAt(o)]=o;function h(r){var t=r.length;if(t%4>0)throw new Error(\"Invalid string. Length must be a multiple of 4\");var e=r.indexOf(\"=\");return-1===e&&(e=t),[e,e===t?0:4-e%4]}function u(r){var t=h(r),e=t[0],n=t[1];return 3*(e+n)/4-n}function c(r,t,e){return 3*(t+e)/4-e}function i(r){for(var n,o=h(r),a=o[0],u=o[1],i=new e(c(r,a,u)),f=0,A=u>0?a-4:a,d=0;d<A;d+=4)n=t[r.charCodeAt(d)]<<18|t[r.charCodeAt(d+1)]<<12|t[r.charCodeAt(d+2)]<<6|t[r.charCodeAt(d+3)],i[f++]=n>>16&255,i[f++]=n>>8&255,i[f++]=255&n;return 2===u&&(n=t[r.charCodeAt(d)]<<2|t[r.charCodeAt(d+1)]>>4,i[f++]=255&n),1===u&&(n=t[r.charCodeAt(d)]<<10|t[r.charCodeAt(d+1)]<<4|t[r.charCodeAt(d+2)]>>2,i[f++]=n>>8&255,i[f++]=255&n),i}function f(t){return r[t>>18&63]+r[t>>12&63]+r[t>>6&63]+r[63&t]}function A(r,t,e){for(var n,o=[],a=t;a<e;a+=3)n=(r[a]<<16&16711680)+(r[a+1]<<8&65280)+(255&r[a+2]),o.push(f(n));return o.join(\"\")}function d(t){for(var e,n=t.length,o=n%3,a=[],h=0,u=n-o;h<u;h+=16383)a.push(A(t,h,h+16383>u?u:h+16383));return 1===o?(e=t[n-1],a.push(r[e>>2]+r[e<<4&63]+\"==\")):2===o&&(e=(t[n-2]<<8)+t[n-1],a.push(r[e>>10]+r[e>>4&63]+r[e<<2&63]+\"=\")),a.join(\"\")}t[\"-\".charCodeAt(0)]=62,t[\"_\".charCodeAt(0)]=63;\n},{}],\"JgNJ\":[function(require,module,exports) {\nexports.read=function(a,o,t,r,h){var M,p,w=8*h-r-1,f=(1<<w)-1,e=f>>1,i=-7,N=t?h-1:0,n=t?-1:1,s=a[o+N];for(N+=n,M=s&(1<<-i)-1,s>>=-i,i+=w;i>0;M=256*M+a[o+N],N+=n,i-=8);for(p=M&(1<<-i)-1,M>>=-i,i+=r;i>0;p=256*p+a[o+N],N+=n,i-=8);if(0===M)M=1-e;else{if(M===f)return p?NaN:1/0*(s?-1:1);p+=Math.pow(2,r),M-=e}return(s?-1:1)*p*Math.pow(2,M-r)},exports.write=function(a,o,t,r,h,M){var p,w,f,e=8*M-h-1,i=(1<<e)-1,N=i>>1,n=23===h?Math.pow(2,-24)-Math.pow(2,-77):0,s=r?0:M-1,u=r?1:-1,l=o<0||0===o&&1/o<0?1:0;for(o=Math.abs(o),isNaN(o)||o===1/0?(w=isNaN(o)?1:0,p=i):(p=Math.floor(Math.log(o)/Math.LN2),o*(f=Math.pow(2,-p))<1&&(p--,f*=2),(o+=p+N>=1?n/f:n*Math.pow(2,1-N))*f>=2&&(p++,f/=2),p+N>=i?(w=0,p=i):p+N>=1?(w=(o*f-1)*Math.pow(2,h),p+=N):(w=o*Math.pow(2,N-1)*Math.pow(2,h),p=0));h>=8;a[t+s]=255&w,s+=u,w/=256,h-=8);for(p=p<<h|w,e+=h;e>0;a[t+s]=255&p,s+=u,p/=256,e-=8);a[t+s-u]|=128*l};\n},{}],\"peL6\":[function(require,module,exports) {\n\nvar global = arguments[3];\nvar t=arguments[3],r=require(\"base64-js\"),e=require(\"ieee754\"),n=require(\"isarray\");function i(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&\"function\"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(r){return!1}}function o(){return f.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function u(t,r){if(o()<r)throw new RangeError(\"Invalid typed array length\");return f.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(r)).__proto__=f.prototype:(null===t&&(t=new f(r)),t.length=r),t}function f(t,r,e){if(!(f.TYPED_ARRAY_SUPPORT||this instanceof f))return new f(t,r,e);if(\"number\"==typeof t){if(\"string\"==typeof r)throw new Error(\"If encoding is specified then the first argument must be a string\");return c(this,t)}return s(this,t,r,e)}function s(t,r,e,n){if(\"number\"==typeof r)throw new TypeError('\"value\" argument must not be a number');return\"undefined\"!=typeof ArrayBuffer&&r instanceof ArrayBuffer?g(t,r,e,n):\"string\"==typeof r?l(t,r,e):y(t,r)}function h(t){if(\"number\"!=typeof t)throw new TypeError('\"size\" argument must be a number');if(t<0)throw new RangeError('\"size\" argument must not be negative')}function a(t,r,e,n){return h(r),r<=0?u(t,r):void 0!==e?\"string\"==typeof n?u(t,r).fill(e,n):u(t,r).fill(e):u(t,r)}function c(t,r){if(h(r),t=u(t,r<0?0:0|w(r)),!f.TYPED_ARRAY_SUPPORT)for(var e=0;e<r;++e)t[e]=0;return t}function l(t,r,e){if(\"string\"==typeof e&&\"\"!==e||(e=\"utf8\"),!f.isEncoding(e))throw new TypeError('\"encoding\" must be a valid string encoding');var n=0|v(r,e),i=(t=u(t,n)).write(r,e);return i!==n&&(t=t.slice(0,i)),t}function p(t,r){var e=r.length<0?0:0|w(r.length);t=u(t,e);for(var n=0;n<e;n+=1)t[n]=255&r[n];return t}function g(t,r,e,n){if(r.byteLength,e<0||r.byteLength<e)throw new RangeError(\"'offset' is out of bounds\");if(r.byteLength<e+(n||0))throw new RangeError(\"'length' is out of bounds\");return r=void 0===e&&void 0===n?new Uint8Array(r):void 0===n?new Uint8Array(r,e):new Uint8Array(r,e,n),f.TYPED_ARRAY_SUPPORT?(t=r).__proto__=f.prototype:t=p(t,r),t}function y(t,r){if(f.isBuffer(r)){var e=0|w(r.length);return 0===(t=u(t,e)).length?t:(r.copy(t,0,0,e),t)}if(r){if(\"undefined\"!=typeof ArrayBuffer&&r.buffer instanceof ArrayBuffer||\"length\"in r)return\"number\"!=typeof r.length||W(r.length)?u(t,0):p(t,r);if(\"Buffer\"===r.type&&n(r.data))return p(t,r.data)}throw new TypeError(\"First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.\")}function w(t){if(t>=o())throw new RangeError(\"Attempt to allocate Buffer larger than maximum size: 0x\"+o().toString(16)+\" bytes\");return 0|t}function d(t){return+t!=t&&(t=0),f.alloc(+t)}function v(t,r){if(f.isBuffer(t))return t.length;if(\"undefined\"!=typeof ArrayBuffer&&\"function\"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;\"string\"!=typeof t&&(t=\"\"+t);var e=t.length;if(0===e)return 0;for(var n=!1;;)switch(r){case\"ascii\":case\"latin1\":case\"binary\":return e;case\"utf8\":case\"utf-8\":case void 0:return $(t).length;case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return 2*e;case\"hex\":return e>>>1;case\"base64\":return K(t).length;default:if(n)return $(t).length;r=(\"\"+r).toLowerCase(),n=!0}}function E(t,r,e){var n=!1;if((void 0===r||r<0)&&(r=0),r>this.length)return\"\";if((void 0===e||e>this.length)&&(e=this.length),e<=0)return\"\";if((e>>>=0)<=(r>>>=0))return\"\";for(t||(t=\"utf8\");;)switch(t){case\"hex\":return x(this,r,e);case\"utf8\":case\"utf-8\":return Y(this,r,e);case\"ascii\":return L(this,r,e);case\"latin1\":case\"binary\":return D(this,r,e);case\"base64\":return S(this,r,e);case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return C(this,r,e);default:if(n)throw new TypeError(\"Unknown encoding: \"+t);t=(t+\"\").toLowerCase(),n=!0}}function b(t,r,e){var n=t[r];t[r]=t[e],t[e]=n}function R(t,r,e,n,i){if(0===t.length)return-1;if(\"string\"==typeof e?(n=e,e=0):e>2147483647?e=2147483647:e<-2147483648&&(e=-2147483648),e=+e,isNaN(e)&&(e=i?0:t.length-1),e<0&&(e=t.length+e),e>=t.length){if(i)return-1;e=t.length-1}else if(e<0){if(!i)return-1;e=0}if(\"string\"==typeof r&&(r=f.from(r,n)),f.isBuffer(r))return 0===r.length?-1:_(t,r,e,n,i);if(\"number\"==typeof r)return r&=255,f.TYPED_ARRAY_SUPPORT&&\"function\"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,r,e):Uint8Array.prototype.lastIndexOf.call(t,r,e):_(t,[r],e,n,i);throw new TypeError(\"val must be string, number or Buffer\")}function _(t,r,e,n,i){var o,u=1,f=t.length,s=r.length;if(void 0!==n&&(\"ucs2\"===(n=String(n).toLowerCase())||\"ucs-2\"===n||\"utf16le\"===n||\"utf-16le\"===n)){if(t.length<2||r.length<2)return-1;u=2,f/=2,s/=2,e/=2}function h(t,r){return 1===u?t[r]:t.readUInt16BE(r*u)}if(i){var a=-1;for(o=e;o<f;o++)if(h(t,o)===h(r,-1===a?0:o-a)){if(-1===a&&(a=o),o-a+1===s)return a*u}else-1!==a&&(o-=o-a),a=-1}else for(e+s>f&&(e=f-s),o=e;o>=0;o--){for(var c=!0,l=0;l<s;l++)if(h(t,o+l)!==h(r,l)){c=!1;break}if(c)return o}return-1}function A(t,r,e,n){e=Number(e)||0;var i=t.length-e;n?(n=Number(n))>i&&(n=i):n=i;var o=r.length;if(o%2!=0)throw new TypeError(\"Invalid hex string\");n>o/2&&(n=o/2);for(var u=0;u<n;++u){var f=parseInt(r.substr(2*u,2),16);if(isNaN(f))return u;t[e+u]=f}return u}function m(t,r,e,n){return Q($(r,t.length-e),t,e,n)}function P(t,r,e,n){return Q(G(r),t,e,n)}function T(t,r,e,n){return P(t,r,e,n)}function B(t,r,e,n){return Q(K(r),t,e,n)}function U(t,r,e,n){return Q(H(r,t.length-e),t,e,n)}function S(t,e,n){return 0===e&&n===t.length?r.fromByteArray(t):r.fromByteArray(t.slice(e,n))}function Y(t,r,e){e=Math.min(t.length,e);for(var n=[],i=r;i<e;){var o,u,f,s,h=t[i],a=null,c=h>239?4:h>223?3:h>191?2:1;if(i+c<=e)switch(c){case 1:h<128&&(a=h);break;case 2:128==(192&(o=t[i+1]))&&(s=(31&h)<<6|63&o)>127&&(a=s);break;case 3:o=t[i+1],u=t[i+2],128==(192&o)&&128==(192&u)&&(s=(15&h)<<12|(63&o)<<6|63&u)>2047&&(s<55296||s>57343)&&(a=s);break;case 4:o=t[i+1],u=t[i+2],f=t[i+3],128==(192&o)&&128==(192&u)&&128==(192&f)&&(s=(15&h)<<18|(63&o)<<12|(63&u)<<6|63&f)>65535&&s<1114112&&(a=s)}null===a?(a=65533,c=1):a>65535&&(a-=65536,n.push(a>>>10&1023|55296),a=56320|1023&a),n.push(a),i+=c}return O(n)}exports.Buffer=f,exports.SlowBuffer=d,exports.INSPECT_MAX_BYTES=50,f.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:i(),exports.kMaxLength=o(),f.poolSize=8192,f._augment=function(t){return t.__proto__=f.prototype,t},f.from=function(t,r,e){return s(null,t,r,e)},f.TYPED_ARRAY_SUPPORT&&(f.prototype.__proto__=Uint8Array.prototype,f.__proto__=Uint8Array,\"undefined\"!=typeof Symbol&&Symbol.species&&f[Symbol.species]===f&&Object.defineProperty(f,Symbol.species,{value:null,configurable:!0})),f.alloc=function(t,r,e){return a(null,t,r,e)},f.allocUnsafe=function(t){return c(null,t)},f.allocUnsafeSlow=function(t){return c(null,t)},f.isBuffer=function(t){return!(null==t||!t._isBuffer)},f.compare=function(t,r){if(!f.isBuffer(t)||!f.isBuffer(r))throw new TypeError(\"Arguments must be Buffers\");if(t===r)return 0;for(var e=t.length,n=r.length,i=0,o=Math.min(e,n);i<o;++i)if(t[i]!==r[i]){e=t[i],n=r[i];break}return e<n?-1:n<e?1:0},f.isEncoding=function(t){switch(String(t).toLowerCase()){case\"hex\":case\"utf8\":case\"utf-8\":case\"ascii\":case\"latin1\":case\"binary\":case\"base64\":case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return!0;default:return!1}},f.concat=function(t,r){if(!n(t))throw new TypeError('\"list\" argument must be an Array of Buffers');if(0===t.length)return f.alloc(0);var e;if(void 0===r)for(r=0,e=0;e<t.length;++e)r+=t[e].length;var i=f.allocUnsafe(r),o=0;for(e=0;e<t.length;++e){var u=t[e];if(!f.isBuffer(u))throw new TypeError('\"list\" argument must be an Array of Buffers');u.copy(i,o),o+=u.length}return i},f.byteLength=v,f.prototype._isBuffer=!0,f.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError(\"Buffer size must be a multiple of 16-bits\");for(var r=0;r<t;r+=2)b(this,r,r+1);return this},f.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError(\"Buffer size must be a multiple of 32-bits\");for(var r=0;r<t;r+=4)b(this,r,r+3),b(this,r+1,r+2);return this},f.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError(\"Buffer size must be a multiple of 64-bits\");for(var r=0;r<t;r+=8)b(this,r,r+7),b(this,r+1,r+6),b(this,r+2,r+5),b(this,r+3,r+4);return this},f.prototype.toString=function(){var t=0|this.length;return 0===t?\"\":0===arguments.length?Y(this,0,t):E.apply(this,arguments)},f.prototype.equals=function(t){if(!f.isBuffer(t))throw new TypeError(\"Argument must be a Buffer\");return this===t||0===f.compare(this,t)},f.prototype.inspect=function(){var t=\"\",r=exports.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString(\"hex\",0,r).match(/.{2}/g).join(\" \"),this.length>r&&(t+=\" ... \")),\"<Buffer \"+t+\">\"},f.prototype.compare=function(t,r,e,n,i){if(!f.isBuffer(t))throw new TypeError(\"Argument must be a Buffer\");if(void 0===r&&(r=0),void 0===e&&(e=t?t.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),r<0||e>t.length||n<0||i>this.length)throw new RangeError(\"out of range index\");if(n>=i&&r>=e)return 0;if(n>=i)return-1;if(r>=e)return 1;if(this===t)return 0;for(var o=(i>>>=0)-(n>>>=0),u=(e>>>=0)-(r>>>=0),s=Math.min(o,u),h=this.slice(n,i),a=t.slice(r,e),c=0;c<s;++c)if(h[c]!==a[c]){o=h[c],u=a[c];break}return o<u?-1:u<o?1:0},f.prototype.includes=function(t,r,e){return-1!==this.indexOf(t,r,e)},f.prototype.indexOf=function(t,r,e){return R(this,t,r,e,!0)},f.prototype.lastIndexOf=function(t,r,e){return R(this,t,r,e,!1)},f.prototype.write=function(t,r,e,n){if(void 0===r)n=\"utf8\",e=this.length,r=0;else if(void 0===e&&\"string\"==typeof r)n=r,e=this.length,r=0;else{if(!isFinite(r))throw new Error(\"Buffer.write(string, encoding, offset[, length]) is no longer supported\");r|=0,isFinite(e)?(e|=0,void 0===n&&(n=\"utf8\")):(n=e,e=void 0)}var i=this.length-r;if((void 0===e||e>i)&&(e=i),t.length>0&&(e<0||r<0)||r>this.length)throw new RangeError(\"Attempt to write outside buffer bounds\");n||(n=\"utf8\");for(var o=!1;;)switch(n){case\"hex\":return A(this,t,r,e);case\"utf8\":case\"utf-8\":return m(this,t,r,e);case\"ascii\":return P(this,t,r,e);case\"latin1\":case\"binary\":return T(this,t,r,e);case\"base64\":return B(this,t,r,e);case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return U(this,t,r,e);default:if(o)throw new TypeError(\"Unknown encoding: \"+n);n=(\"\"+n).toLowerCase(),o=!0}},f.prototype.toJSON=function(){return{type:\"Buffer\",data:Array.prototype.slice.call(this._arr||this,0)}};var I=4096;function O(t){var r=t.length;if(r<=I)return String.fromCharCode.apply(String,t);for(var e=\"\",n=0;n<r;)e+=String.fromCharCode.apply(String,t.slice(n,n+=I));return e}function L(t,r,e){var n=\"\";e=Math.min(t.length,e);for(var i=r;i<e;++i)n+=String.fromCharCode(127&t[i]);return n}function D(t,r,e){var n=\"\";e=Math.min(t.length,e);for(var i=r;i<e;++i)n+=String.fromCharCode(t[i]);return n}function x(t,r,e){var n=t.length;(!r||r<0)&&(r=0),(!e||e<0||e>n)&&(e=n);for(var i=\"\",o=r;o<e;++o)i+=Z(t[o]);return i}function C(t,r,e){for(var n=t.slice(r,e),i=\"\",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function M(t,r,e){if(t%1!=0||t<0)throw new RangeError(\"offset is not uint\");if(t+r>e)throw new RangeError(\"Trying to access beyond buffer length\")}function k(t,r,e,n,i,o){if(!f.isBuffer(t))throw new TypeError('\"buffer\" argument must be a Buffer instance');if(r>i||r<o)throw new RangeError('\"value\" argument is out of bounds');if(e+n>t.length)throw new RangeError(\"Index out of range\")}function N(t,r,e,n){r<0&&(r=65535+r+1);for(var i=0,o=Math.min(t.length-e,2);i<o;++i)t[e+i]=(r&255<<8*(n?i:1-i))>>>8*(n?i:1-i)}function z(t,r,e,n){r<0&&(r=4294967295+r+1);for(var i=0,o=Math.min(t.length-e,4);i<o;++i)t[e+i]=r>>>8*(n?i:3-i)&255}function F(t,r,e,n,i,o){if(e+n>t.length)throw new RangeError(\"Index out of range\");if(e<0)throw new RangeError(\"Index out of range\")}function j(t,r,n,i,o){return o||F(t,r,n,4,3.4028234663852886e38,-3.4028234663852886e38),e.write(t,r,n,i,23,4),n+4}function q(t,r,n,i,o){return o||F(t,r,n,8,1.7976931348623157e308,-1.7976931348623157e308),e.write(t,r,n,i,52,8),n+8}f.prototype.slice=function(t,r){var e,n=this.length;if((t=~~t)<0?(t+=n)<0&&(t=0):t>n&&(t=n),(r=void 0===r?n:~~r)<0?(r+=n)<0&&(r=0):r>n&&(r=n),r<t&&(r=t),f.TYPED_ARRAY_SUPPORT)(e=this.subarray(t,r)).__proto__=f.prototype;else{var i=r-t;e=new f(i,void 0);for(var o=0;o<i;++o)e[o]=this[o+t]}return e},f.prototype.readUIntLE=function(t,r,e){t|=0,r|=0,e||M(t,r,this.length);for(var n=this[t],i=1,o=0;++o<r&&(i*=256);)n+=this[t+o]*i;return n},f.prototype.readUIntBE=function(t,r,e){t|=0,r|=0,e||M(t,r,this.length);for(var n=this[t+--r],i=1;r>0&&(i*=256);)n+=this[t+--r]*i;return n},f.prototype.readUInt8=function(t,r){return r||M(t,1,this.length),this[t]},f.prototype.readUInt16LE=function(t,r){return r||M(t,2,this.length),this[t]|this[t+1]<<8},f.prototype.readUInt16BE=function(t,r){return r||M(t,2,this.length),this[t]<<8|this[t+1]},f.prototype.readUInt32LE=function(t,r){return r||M(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},f.prototype.readUInt32BE=function(t,r){return r||M(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},f.prototype.readIntLE=function(t,r,e){t|=0,r|=0,e||M(t,r,this.length);for(var n=this[t],i=1,o=0;++o<r&&(i*=256);)n+=this[t+o]*i;return n>=(i*=128)&&(n-=Math.pow(2,8*r)),n},f.prototype.readIntBE=function(t,r,e){t|=0,r|=0,e||M(t,r,this.length);for(var n=r,i=1,o=this[t+--n];n>0&&(i*=256);)o+=this[t+--n]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*r)),o},f.prototype.readInt8=function(t,r){return r||M(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},f.prototype.readInt16LE=function(t,r){r||M(t,2,this.length);var e=this[t]|this[t+1]<<8;return 32768&e?4294901760|e:e},f.prototype.readInt16BE=function(t,r){r||M(t,2,this.length);var e=this[t+1]|this[t]<<8;return 32768&e?4294901760|e:e},f.prototype.readInt32LE=function(t,r){return r||M(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},f.prototype.readInt32BE=function(t,r){return r||M(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},f.prototype.readFloatLE=function(t,r){return r||M(t,4,this.length),e.read(this,t,!0,23,4)},f.prototype.readFloatBE=function(t,r){return r||M(t,4,this.length),e.read(this,t,!1,23,4)},f.prototype.readDoubleLE=function(t,r){return r||M(t,8,this.length),e.read(this,t,!0,52,8)},f.prototype.readDoubleBE=function(t,r){return r||M(t,8,this.length),e.read(this,t,!1,52,8)},f.prototype.writeUIntLE=function(t,r,e,n){(t=+t,r|=0,e|=0,n)||k(this,t,r,e,Math.pow(2,8*e)-1,0);var i=1,o=0;for(this[r]=255&t;++o<e&&(i*=256);)this[r+o]=t/i&255;return r+e},f.prototype.writeUIntBE=function(t,r,e,n){(t=+t,r|=0,e|=0,n)||k(this,t,r,e,Math.pow(2,8*e)-1,0);var i=e-1,o=1;for(this[r+i]=255&t;--i>=0&&(o*=256);)this[r+i]=t/o&255;return r+e},f.prototype.writeUInt8=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,1,255,0),f.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[r]=255&t,r+1},f.prototype.writeUInt16LE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,2,65535,0),f.TYPED_ARRAY_SUPPORT?(this[r]=255&t,this[r+1]=t>>>8):N(this,t,r,!0),r+2},f.prototype.writeUInt16BE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,2,65535,0),f.TYPED_ARRAY_SUPPORT?(this[r]=t>>>8,this[r+1]=255&t):N(this,t,r,!1),r+2},f.prototype.writeUInt32LE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,4,4294967295,0),f.TYPED_ARRAY_SUPPORT?(this[r+3]=t>>>24,this[r+2]=t>>>16,this[r+1]=t>>>8,this[r]=255&t):z(this,t,r,!0),r+4},f.prototype.writeUInt32BE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,4,4294967295,0),f.TYPED_ARRAY_SUPPORT?(this[r]=t>>>24,this[r+1]=t>>>16,this[r+2]=t>>>8,this[r+3]=255&t):z(this,t,r,!1),r+4},f.prototype.writeIntLE=function(t,r,e,n){if(t=+t,r|=0,!n){var i=Math.pow(2,8*e-1);k(this,t,r,e,i-1,-i)}var o=0,u=1,f=0;for(this[r]=255&t;++o<e&&(u*=256);)t<0&&0===f&&0!==this[r+o-1]&&(f=1),this[r+o]=(t/u>>0)-f&255;return r+e},f.prototype.writeIntBE=function(t,r,e,n){if(t=+t,r|=0,!n){var i=Math.pow(2,8*e-1);k(this,t,r,e,i-1,-i)}var o=e-1,u=1,f=0;for(this[r+o]=255&t;--o>=0&&(u*=256);)t<0&&0===f&&0!==this[r+o+1]&&(f=1),this[r+o]=(t/u>>0)-f&255;return r+e},f.prototype.writeInt8=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,1,127,-128),f.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[r]=255&t,r+1},f.prototype.writeInt16LE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,2,32767,-32768),f.TYPED_ARRAY_SUPPORT?(this[r]=255&t,this[r+1]=t>>>8):N(this,t,r,!0),r+2},f.prototype.writeInt16BE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,2,32767,-32768),f.TYPED_ARRAY_SUPPORT?(this[r]=t>>>8,this[r+1]=255&t):N(this,t,r,!1),r+2},f.prototype.writeInt32LE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,4,2147483647,-2147483648),f.TYPED_ARRAY_SUPPORT?(this[r]=255&t,this[r+1]=t>>>8,this[r+2]=t>>>16,this[r+3]=t>>>24):z(this,t,r,!0),r+4},f.prototype.writeInt32BE=function(t,r,e){return t=+t,r|=0,e||k(this,t,r,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),f.TYPED_ARRAY_SUPPORT?(this[r]=t>>>24,this[r+1]=t>>>16,this[r+2]=t>>>8,this[r+3]=255&t):z(this,t,r,!1),r+4},f.prototype.writeFloatLE=function(t,r,e){return j(this,t,r,!0,e)},f.prototype.writeFloatBE=function(t,r,e){return j(this,t,r,!1,e)},f.prototype.writeDoubleLE=function(t,r,e){return q(this,t,r,!0,e)},f.prototype.writeDoubleBE=function(t,r,e){return q(this,t,r,!1,e)},f.prototype.copy=function(t,r,e,n){if(e||(e=0),n||0===n||(n=this.length),r>=t.length&&(r=t.length),r||(r=0),n>0&&n<e&&(n=e),n===e)return 0;if(0===t.length||0===this.length)return 0;if(r<0)throw new RangeError(\"targetStart out of bounds\");if(e<0||e>=this.length)throw new RangeError(\"sourceStart out of bounds\");if(n<0)throw new RangeError(\"sourceEnd out of bounds\");n>this.length&&(n=this.length),t.length-r<n-e&&(n=t.length-r+e);var i,o=n-e;if(this===t&&e<r&&r<n)for(i=o-1;i>=0;--i)t[i+r]=this[i+e];else if(o<1e3||!f.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)t[i+r]=this[i+e];else Uint8Array.prototype.set.call(t,this.subarray(e,e+o),r);return o},f.prototype.fill=function(t,r,e,n){if(\"string\"==typeof t){if(\"string\"==typeof r?(n=r,r=0,e=this.length):\"string\"==typeof e&&(n=e,e=this.length),1===t.length){var i=t.charCodeAt(0);i<256&&(t=i)}if(void 0!==n&&\"string\"!=typeof n)throw new TypeError(\"encoding must be a string\");if(\"string\"==typeof n&&!f.isEncoding(n))throw new TypeError(\"Unknown encoding: \"+n)}else\"number\"==typeof t&&(t&=255);if(r<0||this.length<r||this.length<e)throw new RangeError(\"Out of range index\");if(e<=r)return this;var o;if(r>>>=0,e=void 0===e?this.length:e>>>0,t||(t=0),\"number\"==typeof t)for(o=r;o<e;++o)this[o]=t;else{var u=f.isBuffer(t)?t:$(new f(t,n).toString()),s=u.length;for(o=0;o<e-r;++o)this[o+r]=u[o%s]}return this};var V=/[^+\\/0-9A-Za-z-_]/g;function X(t){if((t=J(t).replace(V,\"\")).length<2)return\"\";for(;t.length%4!=0;)t+=\"=\";return t}function J(t){return t.trim?t.trim():t.replace(/^\\s+|\\s+$/g,\"\")}function Z(t){return t<16?\"0\"+t.toString(16):t.toString(16)}function $(t,r){var e;r=r||1/0;for(var n=t.length,i=null,o=[],u=0;u<n;++u){if((e=t.charCodeAt(u))>55295&&e<57344){if(!i){if(e>56319){(r-=3)>-1&&o.push(239,191,189);continue}if(u+1===n){(r-=3)>-1&&o.push(239,191,189);continue}i=e;continue}if(e<56320){(r-=3)>-1&&o.push(239,191,189),i=e;continue}e=65536+(i-55296<<10|e-56320)}else i&&(r-=3)>-1&&o.push(239,191,189);if(i=null,e<128){if((r-=1)<0)break;o.push(e)}else if(e<2048){if((r-=2)<0)break;o.push(e>>6|192,63&e|128)}else if(e<65536){if((r-=3)<0)break;o.push(e>>12|224,e>>6&63|128,63&e|128)}else{if(!(e<1114112))throw new Error(\"Invalid code point\");if((r-=4)<0)break;o.push(e>>18|240,e>>12&63|128,e>>6&63|128,63&e|128)}}return o}function G(t){for(var r=[],e=0;e<t.length;++e)r.push(255&t.charCodeAt(e));return r}function H(t,r){for(var e,n,i,o=[],u=0;u<t.length&&!((r-=2)<0);++u)n=(e=t.charCodeAt(u))>>8,i=e%256,o.push(i),o.push(n);return o}function K(t){return r.toByteArray(X(t))}function Q(t,r,e,n){for(var i=0;i<n&&!(i+e>=r.length||i>=t.length);++i)r[i+e]=t[i];return i}function W(t){return t!=t}\n},{\"base64-js\":\"yh9p\",\"ieee754\":\"JgNJ\",\"isarray\":\"REa7\",\"buffer\":\"peL6\"}],\"38Wu\":[function(require,module,exports) {\n\nvar r=require(\"buffer\"),e=r.Buffer;function n(r,e){for(var n in r)e[n]=r[n]}function o(r,n,o){return e(r,n,o)}e.from&&e.alloc&&e.allocUnsafe&&e.allocUnsafeSlow?module.exports=r:(n(r,exports),exports.Buffer=o),n(e,o),o.from=function(r,n,o){if(\"number\"==typeof r)throw new TypeError(\"Argument must not be a number\");return e(r,n,o)},o.alloc=function(r,n,o){if(\"number\"!=typeof r)throw new TypeError(\"Argument must be a number\");var f=e(r);return void 0!==n?\"string\"==typeof o?f.fill(n,o):f.fill(n):f.fill(0),f},o.allocUnsafe=function(r){if(\"number\"!=typeof r)throw new TypeError(\"Argument must be a number\");return e(r)},o.allocUnsafeSlow=function(e){if(\"number\"!=typeof e)throw new TypeError(\"Argument must be a number\");return r.SlowBuffer(e)};\n},{\"buffer\":\"peL6\"}],\"Q14w\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar r=require(\"buffer\").Buffer;function t(r){return Array.isArray?Array.isArray(r):\"[object Array]\"===a(r)}function e(r){return\"boolean\"==typeof r}function n(r){return null===r}function o(r){return null==r}function i(r){return\"number\"==typeof r}function u(r){return\"string\"==typeof r}function s(r){return\"symbol\"==typeof r}function f(r){return void 0===r}function p(r){return\"[object RegExp]\"===a(r)}function c(r){return\"object\"==typeof r&&null!==r}function l(r){return\"[object Date]\"===a(r)}function y(r){return\"[object Error]\"===a(r)||r instanceof Error}function x(r){return\"function\"==typeof r}function b(r){return null===r||\"boolean\"==typeof r||\"number\"==typeof r||\"string\"==typeof r||\"symbol\"==typeof r||void 0===r}function a(r){return Object.prototype.toString.call(r)}exports.isArray=t,exports.isBoolean=e,exports.isNull=n,exports.isNullOrUndefined=o,exports.isNumber=i,exports.isString=u,exports.isSymbol=s,exports.isUndefined=f,exports.isRegExp=p,exports.isObject=c,exports.isDate=l,exports.isError=y,exports.isFunction=x,exports.isPrimitive=b,exports.isBuffer=r.isBuffer;\n},{\"buffer\":\"peL6\"}],\"wl+m\":[function(require,module,exports) {\n\n\"use strict\";function t(t,n){if(!(t instanceof n))throw new TypeError(\"Cannot call a class as a function\")}var n=require(\"safe-buffer\").Buffer,e=require(\"util\");function i(t,n,e){t.copy(n,e)}module.exports=function(){function e(){t(this,e),this.head=null,this.tail=null,this.length=0}return e.prototype.push=function(t){var n={data:t,next:null};this.length>0?this.tail.next=n:this.head=n,this.tail=n,++this.length},e.prototype.unshift=function(t){var n={data:t,next:this.head};0===this.length&&(this.tail=n),this.head=n,++this.length},e.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},e.prototype.clear=function(){this.head=this.tail=null,this.length=0},e.prototype.join=function(t){if(0===this.length)return\"\";for(var n=this.head,e=\"\"+n.data;n=n.next;)e+=t+n.data;return e},e.prototype.concat=function(t){if(0===this.length)return n.alloc(0);if(1===this.length)return this.head.data;for(var e=n.allocUnsafe(t>>>0),h=this.head,a=0;h;)i(h.data,e,a),a+=h.data.length,h=h.next;return e},e}(),e&&e.inspect&&e.inspect.custom&&(module.exports.prototype[e.inspect.custom]=function(){var t=e.inspect({length:this.length});return this.constructor.name+\" \"+t});\n},{\"safe-buffer\":\"38Wu\",\"util\":\"70rD\"}],\"GRUB\":[function(require,module,exports) {\n\"use strict\";var t=require(\"process-nextick-args\");function e(e,a){var r=this,s=this._readableState&&this._readableState.destroyed,d=this._writableState&&this._writableState.destroyed;return s||d?(a?a(e):!e||this._writableState&&this._writableState.errorEmitted||t.nextTick(i,this,e),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(e||null,function(e){!a&&e?(t.nextTick(i,r,e),r._writableState&&(r._writableState.errorEmitted=!0)):a&&a(e)}),this)}function a(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}function i(t,e){t.emit(\"error\",e)}module.exports={destroy:e,undestroy:a};\n},{\"process-nextick-args\":\"Yj0v\"}],\"yM1o\":[function(require,module,exports) {\nvar global = arguments[3];\nvar r=arguments[3];function t(r,t){if(e(\"noDeprecation\"))return r;var n=!1;return function(){if(!n){if(e(\"throwDeprecation\"))throw new Error(t);e(\"traceDeprecation\")?console.trace(t):console.warn(t),n=!0}return r.apply(this,arguments)}}function e(t){try{if(!r.localStorage)return!1}catch(n){return!1}var e=r.localStorage[t];return null!=e&&\"true\"===String(e).toLowerCase()}module.exports=t;\n},{}],\"WSyY\":[function(require,module,exports) {\nvar process = require(\"process\");\n\nvar global = arguments[3];\nvar e=require(\"process\"),t=arguments[3],n=require(\"process-nextick-args\");function r(e,t,n){this.chunk=e,this.encoding=t,this.callback=n,this.next=null}function i(e){var t=this;this.next=null,this.entry=null,this.finish=function(){W(t,e)}}module.exports=g;var o,s=n.nextTick;g.WritableState=y;var f=require(\"core-util-is\");f.inherits=require(\"inherits\");var u={deprecate:require(\"util-deprecate\")},a=require(\"./internal/streams/stream\"),c=require(\"safe-buffer\").Buffer,l=t.Uint8Array||function(){};function d(e){return c.from(e)}function h(e){return c.isBuffer(e)||e instanceof l}var b,p=require(\"./internal/streams/destroy\");function w(){}function y(e,t){o=o||require(\"./_stream_duplex\"),e=e||{};var n=t instanceof o;this.objectMode=!!e.objectMode,n&&(this.objectMode=this.objectMode||!!e.writableObjectMode);var r=e.highWaterMark,s=e.writableHighWaterMark,f=this.objectMode?16:16384;this.highWaterMark=r||0===r?r:n&&(s||0===s)?s:f,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var u=!1===e.decodeStrings;this.decodeStrings=!u,this.defaultEncoding=e.defaultEncoding||\"utf8\",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(e){S(t,e)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new i(this)}function g(e){if(o=o||require(\"./_stream_duplex\"),!(b.call(g,this)||this instanceof o))return new g(e);this._writableState=new y(e,this),this.writable=!0,e&&(\"function\"==typeof e.write&&(this._write=e.write),\"function\"==typeof e.writev&&(this._writev=e.writev),\"function\"==typeof e.destroy&&(this._destroy=e.destroy),\"function\"==typeof e.final&&(this._final=e.final)),a.call(this)}function k(e,t){var r=new Error(\"write after end\");e.emit(\"error\",r),n.nextTick(t,r)}function v(e,t,r,i){var o=!0,s=!1;return null===r?s=new TypeError(\"May not write null values to stream\"):\"string\"==typeof r||void 0===r||t.objectMode||(s=new TypeError(\"Invalid non-string/buffer chunk\")),s&&(e.emit(\"error\",s),n.nextTick(i,s),o=!1),o}function q(e,t,n){return e.objectMode||!1===e.decodeStrings||\"string\"!=typeof t||(t=c.from(t,n)),t}function _(e,t,n,r,i,o){if(!n){var s=q(t,r,i);r!==s&&(n=!0,i=\"buffer\",r=s)}var f=t.objectMode?1:r.length;t.length+=f;var u=t.length<t.highWaterMark;if(u||(t.needDrain=!0),t.writing||t.corked){var a=t.lastBufferedRequest;t.lastBufferedRequest={chunk:r,encoding:i,isBuf:n,callback:o,next:null},a?a.next=t.lastBufferedRequest:t.bufferedRequest=t.lastBufferedRequest,t.bufferedRequestCount+=1}else m(e,t,!1,f,r,i,o);return u}function m(e,t,n,r,i,o,s){t.writelen=r,t.writecb=s,t.writing=!0,t.sync=!0,n?e._writev(i,t.onwrite):e._write(i,o,t.onwrite),t.sync=!1}function R(e,t,r,i,o){--t.pendingcb,r?(n.nextTick(o,i),n.nextTick(T,e,t),e._writableState.errorEmitted=!0,e.emit(\"error\",i)):(o(i),e._writableState.errorEmitted=!0,e.emit(\"error\",i),T(e,t))}function x(e){e.writing=!1,e.writecb=null,e.length-=e.writelen,e.writelen=0}function S(e,t){var n=e._writableState,r=n.sync,i=n.writecb;if(x(n),t)R(e,n,r,t,i);else{var o=E(n);o||n.corked||n.bufferProcessing||!n.bufferedRequest||j(e,n),r?s(M,e,n,o,i):M(e,n,o,i)}}function M(e,t,n,r){n||B(e,t),t.pendingcb--,r(),T(e,t)}function B(e,t){0===t.length&&t.needDrain&&(t.needDrain=!1,e.emit(\"drain\"))}function j(e,t){t.bufferProcessing=!0;var n=t.bufferedRequest;if(e._writev&&n&&n.next){var r=t.bufferedRequestCount,o=new Array(r),s=t.corkedRequestsFree;s.entry=n;for(var f=0,u=!0;n;)o[f]=n,n.isBuf||(u=!1),n=n.next,f+=1;o.allBuffers=u,m(e,t,!0,t.length,o,\"\",s.finish),t.pendingcb++,t.lastBufferedRequest=null,s.next?(t.corkedRequestsFree=s.next,s.next=null):t.corkedRequestsFree=new i(t),t.bufferedRequestCount=0}else{for(;n;){var a=n.chunk,c=n.encoding,l=n.callback;if(m(e,t,!1,t.objectMode?1:a.length,a,c,l),n=n.next,t.bufferedRequestCount--,t.writing)break}null===n&&(t.lastBufferedRequest=null)}t.bufferedRequest=n,t.bufferProcessing=!1}function E(e){return e.ending&&0===e.length&&null===e.bufferedRequest&&!e.finished&&!e.writing}function C(e,t){e._final(function(n){t.pendingcb--,n&&e.emit(\"error\",n),t.prefinished=!0,e.emit(\"prefinish\"),T(e,t)})}function P(e,t){t.prefinished||t.finalCalled||(\"function\"==typeof e._final?(t.pendingcb++,t.finalCalled=!0,n.nextTick(C,e,t)):(t.prefinished=!0,e.emit(\"prefinish\")))}function T(e,t){var n=E(t);return n&&(P(e,t),0===t.pendingcb&&(t.finished=!0,e.emit(\"finish\"))),n}function F(e,t,r){t.ending=!0,T(e,t),r&&(t.finished?n.nextTick(r):e.once(\"finish\",r)),t.ended=!0,e.writable=!1}function W(e,t,n){var r=e.entry;for(e.entry=null;r;){var i=r.callback;t.pendingcb--,i(n),r=r.next}t.corkedRequestsFree?t.corkedRequestsFree.next=e:t.corkedRequestsFree=e}f.inherits(g,a),y.prototype.getBuffer=function(){for(var e=this.bufferedRequest,t=[];e;)t.push(e),e=e.next;return t},function(){try{Object.defineProperty(y.prototype,\"buffer\",{get:u.deprecate(function(){return this.getBuffer()},\"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.\",\"DEP0003\")})}catch(e){}}(),\"function\"==typeof Symbol&&Symbol.hasInstance&&\"function\"==typeof Function.prototype[Symbol.hasInstance]?(b=Function.prototype[Symbol.hasInstance],Object.defineProperty(g,Symbol.hasInstance,{value:function(e){return!!b.call(this,e)||this===g&&(e&&e._writableState instanceof y)}})):b=function(e){return e instanceof this},g.prototype.pipe=function(){this.emit(\"error\",new Error(\"Cannot pipe, not readable\"))},g.prototype.write=function(e,t,n){var r=this._writableState,i=!1,o=!r.objectMode&&h(e);return o&&!c.isBuffer(e)&&(e=d(e)),\"function\"==typeof t&&(n=t,t=null),o?t=\"buffer\":t||(t=r.defaultEncoding),\"function\"!=typeof n&&(n=w),r.ended?k(this,n):(o||v(this,r,e,n))&&(r.pendingcb++,i=_(this,r,o,e,t,n)),i},g.prototype.cork=function(){this._writableState.corked++},g.prototype.uncork=function(){var e=this._writableState;e.corked&&(e.corked--,e.writing||e.corked||e.finished||e.bufferProcessing||!e.bufferedRequest||j(this,e))},g.prototype.setDefaultEncoding=function(e){if(\"string\"==typeof e&&(e=e.toLowerCase()),!([\"hex\",\"utf8\",\"utf-8\",\"ascii\",\"binary\",\"base64\",\"ucs2\",\"ucs-2\",\"utf16le\",\"utf-16le\",\"raw\"].indexOf((e+\"\").toLowerCase())>-1))throw new TypeError(\"Unknown encoding: \"+e);return this._writableState.defaultEncoding=e,this},Object.defineProperty(g.prototype,\"writableHighWaterMark\",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),g.prototype._write=function(e,t,n){n(new Error(\"_write() is not implemented\"))},g.prototype._writev=null,g.prototype.end=function(e,t,n){var r=this._writableState;\"function\"==typeof e?(n=e,e=null,t=null):\"function\"==typeof t&&(n=t,t=null),null!=e&&this.write(e,t),r.corked&&(r.corked=1,this.uncork()),r.ending||r.finished||F(this,r,n)},Object.defineProperty(g.prototype,\"destroyed\",{get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(e){this._writableState&&(this._writableState.destroyed=e)}}),g.prototype.destroy=p.destroy,g.prototype._undestroy=p.undestroy,g.prototype._destroy=function(e,t){this.end(),t(e)};\n},{\"process-nextick-args\":\"Yj0v\",\"core-util-is\":\"Q14w\",\"inherits\":\"4Bm0\",\"util-deprecate\":\"yM1o\",\"./internal/streams/stream\":\"1ExO\",\"safe-buffer\":\"38Wu\",\"./internal/streams/destroy\":\"GRUB\",\"./_stream_duplex\":\"Hba+\",\"process\":\"pBGv\"}],\"Hba+\":[function(require,module,exports) {\n\"use strict\";var e=require(\"process-nextick-args\"),t=Object.keys||function(e){var t=[];for(var r in e)t.push(r);return t};module.exports=l;var r=require(\"core-util-is\");r.inherits=require(\"inherits\");var i=require(\"./_stream_readable\"),a=require(\"./_stream_writable\");r.inherits(l,i);for(var o=t(a.prototype),s=0;s<o.length;s++){var n=o[s];l.prototype[n]||(l.prototype[n]=a.prototype[n])}function l(e){if(!(this instanceof l))return new l(e);i.call(this,e),a.call(this,e),e&&!1===e.readable&&(this.readable=!1),e&&!1===e.writable&&(this.writable=!1),this.allowHalfOpen=!0,e&&!1===e.allowHalfOpen&&(this.allowHalfOpen=!1),this.once(\"end\",h)}function h(){this.allowHalfOpen||this._writableState.ended||e.nextTick(d,this)}function d(e){e.end()}Object.defineProperty(l.prototype,\"writableHighWaterMark\",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(l.prototype,\"destroyed\",{get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed&&this._writableState.destroyed)},set:function(e){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=e,this._writableState.destroyed=e)}}),l.prototype._destroy=function(t,r){this.push(null),this.end(),e.nextTick(r,t)};\n},{\"process-nextick-args\":\"Yj0v\",\"core-util-is\":\"Q14w\",\"inherits\":\"4Bm0\",\"./_stream_readable\":\"DHrQ\",\"./_stream_writable\":\"WSyY\"}],\"z0rv\":[function(require,module,exports) {\n\n\"use strict\";var t=require(\"safe-buffer\").Buffer,e=t.isEncoding||function(t){switch((t=\"\"+t)&&t.toLowerCase()){case\"hex\":case\"utf8\":case\"utf-8\":case\"ascii\":case\"binary\":case\"base64\":case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":case\"raw\":return!0;default:return!1}};function s(t){if(!t)return\"utf8\";for(var e;;)switch(t){case\"utf8\":case\"utf-8\":return\"utf8\";case\"ucs2\":case\"ucs-2\":case\"utf16le\":case\"utf-16le\":return\"utf16le\";case\"latin1\":case\"binary\":return\"latin1\";case\"base64\":case\"ascii\":case\"hex\":return t;default:if(e)return;t=(\"\"+t).toLowerCase(),e=!0}}function i(i){var a=s(i);if(\"string\"!=typeof a&&(t.isEncoding===e||!e(i)))throw new Error(\"Unknown encoding: \"+i);return a||i}function a(e){var s;switch(this.encoding=i(e),this.encoding){case\"utf16le\":this.text=c,this.end=f,s=4;break;case\"utf8\":this.fillLast=l,s=4;break;case\"base64\":this.text=d,this.end=g,s=3;break;default:return this.write=N,void(this.end=v)}this.lastNeed=0,this.lastTotal=0,this.lastChar=t.allocUnsafe(s)}function r(t){return t<=127?0:t>>5==6?2:t>>4==14?3:t>>3==30?4:t>>6==2?-1:-2}function n(t,e,s){var i=e.length-1;if(i<s)return 0;var a=r(e[i]);return a>=0?(a>0&&(t.lastNeed=a-1),a):--i<s||-2===a?0:(a=r(e[i]))>=0?(a>0&&(t.lastNeed=a-2),a):--i<s||-2===a?0:(a=r(e[i]))>=0?(a>0&&(2===a?a=0:t.lastNeed=a-3),a):0}function h(t,e,s){if(128!=(192&e[0]))return t.lastNeed=0,\"�\";if(t.lastNeed>1&&e.length>1){if(128!=(192&e[1]))return t.lastNeed=1,\"�\";if(t.lastNeed>2&&e.length>2&&128!=(192&e[2]))return t.lastNeed=2,\"�\"}}function l(t){var e=this.lastTotal-this.lastNeed,s=h(this,t,e);return void 0!==s?s:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function u(t,e){var s=n(this,t,e);if(!this.lastNeed)return t.toString(\"utf8\",e);this.lastTotal=s;var i=t.length-(s-this.lastNeed);return t.copy(this.lastChar,0,i),t.toString(\"utf8\",e,i)}function o(t){var e=t&&t.length?this.write(t):\"\";return this.lastNeed?e+\"�\":e}function c(t,e){if((t.length-e)%2==0){var s=t.toString(\"utf16le\",e);if(s){var i=s.charCodeAt(s.length-1);if(i>=55296&&i<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1],s.slice(0,-1)}return s}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString(\"utf16le\",e,t.length-1)}function f(t){var e=t&&t.length?this.write(t):\"\";if(this.lastNeed){var s=this.lastTotal-this.lastNeed;return e+this.lastChar.toString(\"utf16le\",0,s)}return e}function d(t,e){var s=(t.length-e)%3;return 0===s?t.toString(\"base64\",e):(this.lastNeed=3-s,this.lastTotal=3,1===s?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString(\"base64\",e,t.length-s))}function g(t){var e=t&&t.length?this.write(t):\"\";return this.lastNeed?e+this.lastChar.toString(\"base64\",0,3-this.lastNeed):e}function N(t){return t.toString(this.encoding)}function v(t){return t&&t.length?this.write(t):\"\"}exports.StringDecoder=a,a.prototype.write=function(t){if(0===t.length)return\"\";var e,s;if(this.lastNeed){if(void 0===(e=this.fillLast(t)))return\"\";s=this.lastNeed,this.lastNeed=0}else s=0;return s<t.length?e?e+this.text(t,s):this.text(t,s):e||\"\"},a.prototype.end=o,a.prototype.text=u,a.prototype.fillLast=function(t){if(this.lastNeed<=t.length)return t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),this.lastNeed-=t.length};\n},{\"safe-buffer\":\"38Wu\"}],\"DHrQ\":[function(require,module,exports) {\n\nvar global = arguments[3];\nvar process = require(\"process\");\nvar e=arguments[3],t=require(\"process\"),n=require(\"process-nextick-args\");module.exports=_;var r,i=require(\"isarray\");_.ReadableState=w;var a=require(\"events\").EventEmitter,d=function(e,t){return e.listeners(t).length},o=require(\"./internal/streams/stream\"),s=require(\"safe-buffer\").Buffer,u=e.Uint8Array||function(){};function l(e){return s.from(e)}function h(e){return s.isBuffer(e)||e instanceof u}var p=require(\"core-util-is\");p.inherits=require(\"inherits\");var f=require(\"util\"),c=void 0;c=f&&f.debuglog?f.debuglog(\"stream\"):function(){};var g,b=require(\"./internal/streams/BufferList\"),m=require(\"./internal/streams/destroy\");p.inherits(_,o);var v=[\"error\",\"close\",\"destroy\",\"pause\",\"resume\"];function y(e,t,n){if(\"function\"==typeof e.prependListener)return e.prependListener(t,n);e._events&&e._events[t]?i(e._events[t])?e._events[t].unshift(n):e._events[t]=[n,e._events[t]]:e.on(t,n)}function w(e,t){e=e||{};var n=t instanceof(r=r||require(\"./_stream_duplex\"));this.objectMode=!!e.objectMode,n&&(this.objectMode=this.objectMode||!!e.readableObjectMode);var i=e.highWaterMark,a=e.readableHighWaterMark,d=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:n&&(a||0===a)?a:d,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new b,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=e.defaultEncoding||\"utf8\",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,e.encoding&&(g||(g=require(\"string_decoder/\").StringDecoder),this.decoder=new g(e.encoding),this.encoding=e.encoding)}function _(e){if(r=r||require(\"./_stream_duplex\"),!(this instanceof _))return new _(e);this._readableState=new w(e,this),this.readable=!0,e&&(\"function\"==typeof e.read&&(this._read=e.read),\"function\"==typeof e.destroy&&(this._destroy=e.destroy)),o.call(this)}function M(e,t,n,r,i){var a,d=e._readableState;null===t?(d.reading=!1,x(e,d)):(i||(a=k(d,t)),a?e.emit(\"error\",a):d.objectMode||t&&t.length>0?(\"string\"==typeof t||d.objectMode||Object.getPrototypeOf(t)===s.prototype||(t=l(t)),r?d.endEmitted?e.emit(\"error\",new Error(\"stream.unshift() after end event\")):S(e,d,t,!0):d.ended?e.emit(\"error\",new Error(\"stream.push() after EOF\")):(d.reading=!1,d.decoder&&!n?(t=d.decoder.write(t),d.objectMode||0!==t.length?S(e,d,t,!1):C(e,d)):S(e,d,t,!1))):r||(d.reading=!1));return j(d)}function S(e,t,n,r){t.flowing&&0===t.length&&!t.sync?(e.emit(\"data\",n),e.read(0)):(t.length+=t.objectMode?1:n.length,r?t.buffer.unshift(n):t.buffer.push(n),t.needReadable&&q(e)),C(e,t)}function k(e,t){var n;return h(t)||\"string\"==typeof t||void 0===t||e.objectMode||(n=new TypeError(\"Invalid non-string/buffer chunk\")),n}function j(e){return!e.ended&&(e.needReadable||e.length<e.highWaterMark||0===e.length)}Object.defineProperty(_.prototype,\"destroyed\",{get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(e){this._readableState&&(this._readableState.destroyed=e)}}),_.prototype.destroy=m.destroy,_.prototype._undestroy=m.undestroy,_.prototype._destroy=function(e,t){this.push(null),t(e)},_.prototype.push=function(e,t){var n,r=this._readableState;return r.objectMode?n=!0:\"string\"==typeof e&&((t=t||r.defaultEncoding)!==r.encoding&&(e=s.from(e,t),t=\"\"),n=!0),M(this,e,t,!1,n)},_.prototype.unshift=function(e){return M(this,e,null,!0,!1)},_.prototype.isPaused=function(){return!1===this._readableState.flowing},_.prototype.setEncoding=function(e){return g||(g=require(\"string_decoder/\").StringDecoder),this._readableState.decoder=new g(e),this._readableState.encoding=e,this};var R=8388608;function E(e){return e>=R?e=R:(e--,e|=e>>>1,e|=e>>>2,e|=e>>>4,e|=e>>>8,e|=e>>>16,e++),e}function L(e,t){return e<=0||0===t.length&&t.ended?0:t.objectMode?1:e!=e?t.flowing&&t.length?t.buffer.head.data.length:t.length:(e>t.highWaterMark&&(t.highWaterMark=E(e)),e<=t.length?e:t.ended?t.length:(t.needReadable=!0,0))}function x(e,t){if(!t.ended){if(t.decoder){var n=t.decoder.end();n&&n.length&&(t.buffer.push(n),t.length+=t.objectMode?1:n.length)}t.ended=!0,q(e)}}function q(e){var t=e._readableState;t.needReadable=!1,t.emittedReadable||(c(\"emitReadable\",t.flowing),t.emittedReadable=!0,t.sync?n.nextTick(W,e):W(e))}function W(e){c(\"emit readable\"),e.emit(\"readable\"),B(e)}function C(e,t){t.readingMore||(t.readingMore=!0,n.nextTick(D,e,t))}function D(e,t){for(var n=t.length;!t.reading&&!t.flowing&&!t.ended&&t.length<t.highWaterMark&&(c(\"maybeReadMore read 0\"),e.read(0),n!==t.length);)n=t.length;t.readingMore=!1}function O(e){return function(){var t=e._readableState;c(\"pipeOnDrain\",t.awaitDrain),t.awaitDrain&&t.awaitDrain--,0===t.awaitDrain&&d(e,\"data\")&&(t.flowing=!0,B(e))}}function T(e){c(\"readable nexttick read 0\"),e.read(0)}function U(e,t){t.resumeScheduled||(t.resumeScheduled=!0,n.nextTick(P,e,t))}function P(e,t){t.reading||(c(\"resume read 0\"),e.read(0)),t.resumeScheduled=!1,t.awaitDrain=0,e.emit(\"resume\"),B(e),t.flowing&&!t.reading&&e.read(0)}function B(e){var t=e._readableState;for(c(\"flow\",t.flowing);t.flowing&&null!==e.read(););}function H(e,t){return 0===t.length?null:(t.objectMode?n=t.buffer.shift():!e||e>=t.length?(n=t.decoder?t.buffer.join(\"\"):1===t.buffer.length?t.buffer.head.data:t.buffer.concat(t.length),t.buffer.clear()):n=I(e,t.buffer,t.decoder),n);var n}function I(e,t,n){var r;return e<t.head.data.length?(r=t.head.data.slice(0,e),t.head.data=t.head.data.slice(e)):r=e===t.head.data.length?t.shift():n?A(e,t):F(e,t),r}function A(e,t){var n=t.head,r=1,i=n.data;for(e-=i.length;n=n.next;){var a=n.data,d=e>a.length?a.length:e;if(d===a.length?i+=a:i+=a.slice(0,e),0===(e-=d)){d===a.length?(++r,n.next?t.head=n.next:t.head=t.tail=null):(t.head=n,n.data=a.slice(d));break}++r}return t.length-=r,i}function F(e,t){var n=s.allocUnsafe(e),r=t.head,i=1;for(r.data.copy(n),e-=r.data.length;r=r.next;){var a=r.data,d=e>a.length?a.length:e;if(a.copy(n,n.length-e,0,d),0===(e-=d)){d===a.length?(++i,r.next?t.head=r.next:t.head=t.tail=null):(t.head=r,r.data=a.slice(d));break}++i}return t.length-=i,n}function z(e){var t=e._readableState;if(t.length>0)throw new Error('\"endReadable()\" called on non-empty stream');t.endEmitted||(t.ended=!0,n.nextTick(G,t,e))}function G(e,t){e.endEmitted||0!==e.length||(e.endEmitted=!0,t.readable=!1,t.emit(\"end\"))}function J(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1}_.prototype.read=function(e){c(\"read\",e),e=parseInt(e,10);var t=this._readableState,n=e;if(0!==e&&(t.emittedReadable=!1),0===e&&t.needReadable&&(t.length>=t.highWaterMark||t.ended))return c(\"read: emitReadable\",t.length,t.ended),0===t.length&&t.ended?z(this):q(this),null;if(0===(e=L(e,t))&&t.ended)return 0===t.length&&z(this),null;var r,i=t.needReadable;return c(\"need readable\",i),(0===t.length||t.length-e<t.highWaterMark)&&c(\"length less than watermark\",i=!0),t.ended||t.reading?c(\"reading or ended\",i=!1):i&&(c(\"do read\"),t.reading=!0,t.sync=!0,0===t.length&&(t.needReadable=!0),this._read(t.highWaterMark),t.sync=!1,t.reading||(e=L(n,t))),null===(r=e>0?H(e,t):null)?(t.needReadable=!0,e=0):t.length-=e,0===t.length&&(t.ended||(t.needReadable=!0),n!==e&&t.ended&&z(this)),null!==r&&this.emit(\"data\",r),r},_.prototype._read=function(e){this.emit(\"error\",new Error(\"_read() is not implemented\"))},_.prototype.pipe=function(e,r){var i=this,a=this._readableState;switch(a.pipesCount){case 0:a.pipes=e;break;case 1:a.pipes=[a.pipes,e];break;default:a.pipes.push(e)}a.pipesCount+=1,c(\"pipe count=%d opts=%j\",a.pipesCount,r);var o=(!r||!1!==r.end)&&e!==t.stdout&&e!==t.stderr?u:v;function s(t,n){c(\"onunpipe\"),t===i&&n&&!1===n.hasUnpiped&&(n.hasUnpiped=!0,c(\"cleanup\"),e.removeListener(\"close\",b),e.removeListener(\"finish\",m),e.removeListener(\"drain\",l),e.removeListener(\"error\",g),e.removeListener(\"unpipe\",s),i.removeListener(\"end\",u),i.removeListener(\"end\",v),i.removeListener(\"data\",f),h=!0,!a.awaitDrain||e._writableState&&!e._writableState.needDrain||l())}function u(){c(\"onend\"),e.end()}a.endEmitted?n.nextTick(o):i.once(\"end\",o),e.on(\"unpipe\",s);var l=O(i);e.on(\"drain\",l);var h=!1;var p=!1;function f(t){c(\"ondata\"),p=!1,!1!==e.write(t)||p||((1===a.pipesCount&&a.pipes===e||a.pipesCount>1&&-1!==J(a.pipes,e))&&!h&&(c(\"false write response, pause\",i._readableState.awaitDrain),i._readableState.awaitDrain++,p=!0),i.pause())}function g(t){c(\"onerror\",t),v(),e.removeListener(\"error\",g),0===d(e,\"error\")&&e.emit(\"error\",t)}function b(){e.removeListener(\"finish\",m),v()}function m(){c(\"onfinish\"),e.removeListener(\"close\",b),v()}function v(){c(\"unpipe\"),i.unpipe(e)}return i.on(\"data\",f),y(e,\"error\",g),e.once(\"close\",b),e.once(\"finish\",m),e.emit(\"pipe\",i),a.flowing||(c(\"pipe resume\"),i.resume()),e},_.prototype.unpipe=function(e){var t=this._readableState,n={hasUnpiped:!1};if(0===t.pipesCount)return this;if(1===t.pipesCount)return e&&e!==t.pipes?this:(e||(e=t.pipes),t.pipes=null,t.pipesCount=0,t.flowing=!1,e&&e.emit(\"unpipe\",this,n),this);if(!e){var r=t.pipes,i=t.pipesCount;t.pipes=null,t.pipesCount=0,t.flowing=!1;for(var a=0;a<i;a++)r[a].emit(\"unpipe\",this,n);return this}var d=J(t.pipes,e);return-1===d?this:(t.pipes.splice(d,1),t.pipesCount-=1,1===t.pipesCount&&(t.pipes=t.pipes[0]),e.emit(\"unpipe\",this,n),this)},_.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);if(\"data\"===e)!1!==this._readableState.flowing&&this.resume();else if(\"readable\"===e){var i=this._readableState;i.endEmitted||i.readableListening||(i.readableListening=i.needReadable=!0,i.emittedReadable=!1,i.reading?i.length&&q(this):n.nextTick(T,this))}return r},_.prototype.addListener=_.prototype.on,_.prototype.resume=function(){var e=this._readableState;return e.flowing||(c(\"resume\"),e.flowing=!0,U(this,e)),this},_.prototype.pause=function(){return c(\"call pause flowing=%j\",this._readableState.flowing),!1!==this._readableState.flowing&&(c(\"pause\"),this._readableState.flowing=!1,this.emit(\"pause\")),this},_.prototype.wrap=function(e){var t=this,n=this._readableState,r=!1;for(var i in e.on(\"end\",function(){if(c(\"wrapped end\"),n.decoder&&!n.ended){var e=n.decoder.end();e&&e.length&&t.push(e)}t.push(null)}),e.on(\"data\",function(i){(c(\"wrapped data\"),n.decoder&&(i=n.decoder.write(i)),n.objectMode&&null==i)||(n.objectMode||i&&i.length)&&(t.push(i)||(r=!0,e.pause()))}),e)void 0===this[i]&&\"function\"==typeof e[i]&&(this[i]=function(t){return function(){return e[t].apply(e,arguments)}}(i));for(var a=0;a<v.length;a++)e.on(v[a],this.emit.bind(this,v[a]));return this._read=function(t){c(\"wrapped _read\",t),r&&(r=!1,e.resume())},this},Object.defineProperty(_.prototype,\"readableHighWaterMark\",{enumerable:!1,get:function(){return this._readableState.highWaterMark}}),_._fromList=H;\n},{\"process-nextick-args\":\"Yj0v\",\"isarray\":\"REa7\",\"events\":\"FRpO\",\"./internal/streams/stream\":\"1ExO\",\"safe-buffer\":\"38Wu\",\"core-util-is\":\"Q14w\",\"inherits\":\"4Bm0\",\"util\":\"70rD\",\"./internal/streams/BufferList\":\"wl+m\",\"./internal/streams/destroy\":\"GRUB\",\"./_stream_duplex\":\"Hba+\",\"string_decoder/\":\"z0rv\",\"process\":\"pBGv\"}],\"7tlB\":[function(require,module,exports) {\n\"use strict\";module.exports=n;var t=require(\"./_stream_duplex\"),r=require(\"core-util-is\");function e(t,r){var e=this._transformState;e.transforming=!1;var n=e.writecb;if(!n)return this.emit(\"error\",new Error(\"write callback called multiple times\"));e.writechunk=null,e.writecb=null,null!=r&&this.push(r),n(t);var i=this._readableState;i.reading=!1,(i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}function n(r){if(!(this instanceof n))return new n(r);t.call(this,r),this._transformState={afterTransform:e.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,r&&(\"function\"==typeof r.transform&&(this._transform=r.transform),\"function\"==typeof r.flush&&(this._flush=r.flush)),this.on(\"prefinish\",i)}function i(){var t=this;\"function\"==typeof this._flush?this._flush(function(r,e){a(t,r,e)}):a(this,null,null)}function a(t,r,e){if(r)return t.emit(\"error\",r);if(null!=e&&t.push(e),t._writableState.length)throw new Error(\"Calling transform done when ws.length != 0\");if(t._transformState.transforming)throw new Error(\"Calling transform done when still transforming\");return t.push(null)}r.inherits=require(\"inherits\"),r.inherits(n,t),n.prototype.push=function(r,e){return this._transformState.needTransform=!1,t.prototype.push.call(this,r,e)},n.prototype._transform=function(t,r,e){throw new Error(\"_transform() is not implemented\")},n.prototype._write=function(t,r,e){var n=this._transformState;if(n.writecb=e,n.writechunk=t,n.writeencoding=r,!n.transforming){var i=this._readableState;(n.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},n.prototype._read=function(t){var r=this._transformState;null!==r.writechunk&&r.writecb&&!r.transforming?(r.transforming=!0,this._transform(r.writechunk,r.writeencoding,r.afterTransform)):r.needTransform=!0},n.prototype._destroy=function(r,e){var n=this;t.prototype._destroy.call(this,r,function(t){e(t),n.emit(\"close\")})};\n},{\"./_stream_duplex\":\"Hba+\",\"core-util-is\":\"Q14w\",\"inherits\":\"4Bm0\"}],\"nwyA\":[function(require,module,exports) {\n\"use strict\";module.exports=i;var r=require(\"./_stream_transform\"),e=require(\"core-util-is\");function i(e){if(!(this instanceof i))return new i(e);r.call(this,e)}e.inherits=require(\"inherits\"),e.inherits(i,r),i.prototype._transform=function(r,e,i){i(null,r)};\n},{\"./_stream_transform\":\"7tlB\",\"core-util-is\":\"Q14w\",\"inherits\":\"4Bm0\"}],\"tzeh\":[function(require,module,exports) {\nexports=module.exports=require(\"./lib/_stream_readable.js\"),exports.Stream=exports,exports.Readable=exports,exports.Writable=require(\"./lib/_stream_writable.js\"),exports.Duplex=require(\"./lib/_stream_duplex.js\"),exports.Transform=require(\"./lib/_stream_transform.js\"),exports.PassThrough=require(\"./lib/_stream_passthrough.js\");\n},{\"./lib/_stream_readable.js\":\"DHrQ\",\"./lib/_stream_writable.js\":\"WSyY\",\"./lib/_stream_duplex.js\":\"Hba+\",\"./lib/_stream_transform.js\":\"7tlB\",\"./lib/_stream_passthrough.js\":\"nwyA\"}],\"LnjZ\":[function(require,module,exports) {\nmodule.exports=require(\"./lib/_stream_writable.js\");\n},{\"./lib/_stream_writable.js\":\"WSyY\"}],\"kT1X\":[function(require,module,exports) {\nmodule.exports=require(\"./lib/_stream_duplex.js\");\n},{\"./lib/_stream_duplex.js\":\"Hba+\"}],\"A9/K\":[function(require,module,exports) {\nmodule.exports=require(\"./readable\").Transform;\n},{\"./readable\":\"tzeh\"}],\"C6nS\":[function(require,module,exports) {\nmodule.exports=require(\"./readable\").PassThrough;\n},{\"./readable\":\"tzeh\"}],\"fnRj\":[function(require,module,exports) {\nmodule.exports=n;var e=require(\"events\").EventEmitter,r=require(\"inherits\");function n(){e.call(this)}r(n,e),n.Readable=require(\"readable-stream/readable.js\"),n.Writable=require(\"readable-stream/writable.js\"),n.Duplex=require(\"readable-stream/duplex.js\"),n.Transform=require(\"readable-stream/transform.js\"),n.PassThrough=require(\"readable-stream/passthrough.js\"),n.Stream=n,n.prototype.pipe=function(r,n){var o=this;function t(e){r.writable&&!1===r.write(e)&&o.pause&&o.pause()}function s(){o.readable&&o.resume&&o.resume()}o.on(\"data\",t),r.on(\"drain\",s),r._isStdio||n&&!1===n.end||(o.on(\"end\",a),o.on(\"close\",u));var i=!1;function a(){i||(i=!0,r.end())}function u(){i||(i=!0,\"function\"==typeof r.destroy&&r.destroy())}function d(r){if(l(),0===e.listenerCount(this,\"error\"))throw r}function l(){o.removeListener(\"data\",t),r.removeListener(\"drain\",s),o.removeListener(\"end\",a),o.removeListener(\"close\",u),o.removeListener(\"error\",d),r.removeListener(\"error\",d),o.removeListener(\"end\",l),o.removeListener(\"close\",l),r.removeListener(\"close\",l)}return o.on(\"error\",d),r.on(\"error\",d),o.on(\"end\",l),o.on(\"close\",l),r.on(\"close\",l),r.emit(\"pipe\",o),r};\n},{\"events\":\"FRpO\",\"inherits\":\"4Bm0\",\"readable-stream/readable.js\":\"tzeh\",\"readable-stream/writable.js\":\"LnjZ\",\"readable-stream/duplex.js\":\"kT1X\",\"readable-stream/transform.js\":\"A9/K\",\"readable-stream/passthrough.js\":\"C6nS\"}],\"FayP\":[function(require,module,exports) {\nmodule.exports=require(\"stream\");\n},{\"stream\":\"fnRj\"}],\"+8r/\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar e=require(\"buffer\").Buffer;if(exports.base64=!0,exports.array=!0,exports.string=!0,exports.arraybuffer=\"undefined\"!=typeof ArrayBuffer&&\"undefined\"!=typeof Uint8Array,exports.nodebuffer=void 0!==e,exports.uint8array=\"undefined\"!=typeof Uint8Array,\"undefined\"==typeof ArrayBuffer)exports.blob=!1;else{var r=new ArrayBuffer(0);try{exports.blob=0===new Blob([r],{type:\"application/zip\"}).size}catch(a){try{var o=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder,t=new o;t.append(r),exports.blob=0===t.getBlob(\"application/zip\").size}catch(a){exports.blob=!1}}}try{exports.nodestream=!!require(\"readable-stream\").Readable}catch(a){exports.nodestream=!1}\n},{\"readable-stream\":\"FayP\",\"buffer\":\"peL6\"}],\"FafD\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./utils\"),t=require(\"./support\"),e=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\";exports.encode=function(t){for(var a,n,h,c,i,o,A,d=[],l=0,u=t.length,s=u,f=\"string\"!==r.getTypeOf(t);l<t.length;)s=u-l,f?(a=t[l++],n=l<u?t[l++]:0,h=l<u?t[l++]:0):(a=t.charCodeAt(l++),n=l<u?t.charCodeAt(l++):0,h=l<u?t.charCodeAt(l++):0),c=a>>2,i=(3&a)<<4|n>>4,o=s>1?(15&n)<<2|h>>6:64,A=s>2?63&h:64,d.push(e.charAt(c)+e.charAt(i)+e.charAt(o)+e.charAt(A));return d.join(\"\")},exports.decode=function(r){var a,n,h,c,i,o,A=0,d=0;if(\"data:\"===r.substr(0,\"data:\".length))throw new Error(\"Invalid base64 input, it looks like a data url.\");var l,u=3*(r=r.replace(/[^A-Za-z0-9\\+\\/\\=]/g,\"\")).length/4;if(r.charAt(r.length-1)===e.charAt(64)&&u--,r.charAt(r.length-2)===e.charAt(64)&&u--,u%1!=0)throw new Error(\"Invalid base64 input, bad content length.\");for(l=t.uint8array?new Uint8Array(0|u):new Array(0|u);A<r.length;)a=e.indexOf(r.charAt(A++))<<2|(c=e.indexOf(r.charAt(A++)))>>4,n=(15&c)<<4|(i=e.indexOf(r.charAt(A++)))>>2,h=(3&i)<<6|(o=e.indexOf(r.charAt(A++))),l[d++]=a,64!==i&&(l[d++]=n),64!==o&&(l[d++]=h);return l};\n},{\"./utils\":\"rWOW\",\"./support\":\"+8r/\"}],\"5Egw\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar e=require(\"buffer\").Buffer;module.exports={isNode:void 0!==e,newBuffer:function(f,n){return new e(f,n)},isBuffer:function(f){return e.isBuffer(f)},isStream:function(e){return e&&\"function\"==typeof e.on&&\"function\"==typeof e.pause&&\"function\"==typeof e.resume}};\n},{\"buffer\":\"peL6\"}],\"rHgC\":[function(require,module,exports) {\n\nvar e=module.exports=\"undefined\"!=typeof window&&window.Math==Math?window:\"undefined\"!=typeof self&&self.Math==Math?self:Function(\"return this\")();\"number\"==typeof __g&&(__g=e);\n},{}],\"goWO\":[function(require,module,exports) {\nvar e=module.exports={version:\"2.3.0\"};\"number\"==typeof __e&&(__e=e);\n},{}],\"04qM\":[function(require,module,exports) {\nmodule.exports=function(o){if(\"function\"!=typeof o)throw TypeError(o+\" is not a function!\");return o};\n},{}],\"pxuO\":[function(require,module,exports) {\nvar r=require(\"./_a-function\");module.exports=function(n,t,u){if(r(n),void 0===t)return n;switch(u){case 1:return function(r){return n.call(t,r)};case 2:return function(r,u){return n.call(t,r,u)};case 3:return function(r,u,e){return n.call(t,r,u,e)}}return function(){return n.apply(t,arguments)}};\n},{\"./_a-function\":\"04qM\"}],\"h5Nx\":[function(require,module,exports) {\nmodule.exports=function(o){return\"object\"==typeof o?null!==o:\"function\"==typeof o};\n},{}],\"rb/J\":[function(require,module,exports) {\nvar r=require(\"./_is-object\");module.exports=function(e){if(!r(e))throw TypeError(e+\" is not an object!\");return e};\n},{\"./_is-object\":\"h5Nx\"}],\"WVdt\":[function(require,module,exports) {\nmodule.exports=function(r){try{return!!r()}catch(t){return!0}};\n},{}],\"lLbB\":[function(require,module,exports) {\nmodule.exports=!require(\"./_fails\")(function(){return 7!=Object.defineProperty({},\"a\",{get:function(){return 7}}).a});\n},{\"./_fails\":\"WVdt\"}],\"aasK\":[function(require,module,exports) {\nvar e=require(\"./_is-object\"),r=require(\"./_global\").document,t=e(r)&&e(r.createElement);module.exports=function(e){return t?r.createElement(e):{}};\n},{\"./_is-object\":\"h5Nx\",\"./_global\":\"rHgC\"}],\"63Br\":[function(require,module,exports) {\nmodule.exports=!require(\"./_descriptors\")&&!require(\"./_fails\")(function(){return 7!=Object.defineProperty(require(\"./_dom-create\")(\"div\"),\"a\",{get:function(){return 7}}).a});\n},{\"./_descriptors\":\"lLbB\",\"./_fails\":\"WVdt\",\"./_dom-create\":\"aasK\"}],\"mmaY\":[function(require,module,exports) {\nvar t=require(\"./_is-object\");module.exports=function(r,e){if(!t(r))return r;var o,n;if(e&&\"function\"==typeof(o=r.toString)&&!t(n=o.call(r)))return n;if(\"function\"==typeof(o=r.valueOf)&&!t(n=o.call(r)))return n;if(!e&&\"function\"==typeof(o=r.toString)&&!t(n=o.call(r)))return n;throw TypeError(\"Can't convert object to primitive value\")};\n},{\"./_is-object\":\"h5Nx\"}],\"M0w+\":[function(require,module,exports) {\nvar e=require(\"./_an-object\"),r=require(\"./_ie8-dom-define\"),t=require(\"./_to-primitive\"),i=Object.defineProperty;exports.f=require(\"./_descriptors\")?Object.defineProperty:function(o,n,u){if(e(o),n=t(n,!0),e(u),r)try{return i(o,n,u)}catch(c){}if(\"get\"in u||\"set\"in u)throw TypeError(\"Accessors not supported!\");return\"value\"in u&&(o[n]=u.value),o};\n},{\"./_an-object\":\"rb/J\",\"./_ie8-dom-define\":\"63Br\",\"./_to-primitive\":\"mmaY\",\"./_descriptors\":\"lLbB\"}],\"eVJX\":[function(require,module,exports) {\nmodule.exports=function(e,r){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:r}};\n},{}],\"5d6c\":[function(require,module,exports) {\nvar r=require(\"./_object-dp\"),e=require(\"./_property-desc\");module.exports=require(\"./_descriptors\")?function(t,u,o){return r.f(t,u,e(1,o))}:function(r,e,t){return r[e]=t,r};\n},{\"./_object-dp\":\"M0w+\",\"./_property-desc\":\"eVJX\",\"./_descriptors\":\"lLbB\"}],\"dcWE\":[function(require,module,exports) {\n\nvar e=require(\"./_global\"),r=require(\"./_core\"),n=require(\"./_ctx\"),t=require(\"./_hide\"),i=\"prototype\",u=function(o,c,a){var f,l,s,p=o&u.F,v=o&u.G,h=o&u.S,w=o&u.P,q=o&u.B,y=o&u.W,_=v?r:r[c]||(r[c]={}),d=_[i],F=v?e:h?e[c]:(e[c]||{})[i];for(f in v&&(a=c),a)(l=!p&&F&&void 0!==F[f])&&f in _||(s=l?F[f]:a[f],_[f]=v&&\"function\"!=typeof F[f]?a[f]:q&&l?n(s,e):y&&F[f]==s?function(e){var r=function(r,n,t){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(r);case 2:return new e(r,n)}return new e(r,n,t)}return e.apply(this,arguments)};return r[i]=e[i],r}(s):w&&\"function\"==typeof s?n(Function.call,s):s,w&&((_.virtual||(_.virtual={}))[f]=s,o&u.R&&d&&!d[f]&&t(d,f,s)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,module.exports=u;\n},{\"./_global\":\"rHgC\",\"./_core\":\"goWO\",\"./_ctx\":\"pxuO\",\"./_hide\":\"5d6c\"}],\"dEIN\":[function(require,module,exports) {\nmodule.exports=function(e,r,l){var a=void 0===l;switch(r.length){case 0:return a?e():e.call(l);case 1:return a?e(r[0]):e.call(l,r[0]);case 2:return a?e(r[0],r[1]):e.call(l,r[0],r[1]);case 3:return a?e(r[0],r[1],r[2]):e.call(l,r[0],r[1],r[2]);case 4:return a?e(r[0],r[1],r[2],r[3]):e.call(l,r[0],r[1],r[2],r[3])}return e.apply(l,r)};\n},{}],\"gbQ5\":[function(require,module,exports) {\nmodule.exports=require(\"./_global\").document&&document.documentElement;\n},{\"./_global\":\"rHgC\"}],\"5bPM\":[function(require,module,exports) {\nvar r={}.toString;module.exports=function(t){return r.call(t).slice(8,-1)};\n},{}],\"aMXM\":[function(require,module,exports) {\n\n\nvar e,t,n,r=require(\"./_ctx\"),i=require(\"./_invoke\"),o=require(\"./_html\"),s=require(\"./_dom-create\"),a=require(\"./_global\"),c=a.process,u=a.setImmediate,p=a.clearImmediate,f=a.MessageChannel,l=0,d={},m=\"onreadystatechange\",h=function(){var e=+this;if(d.hasOwnProperty(e)){var t=d[e];delete d[e],t()}},g=function(e){h.call(e.data)};u&&p||(u=function(t){for(var n=[],r=1;arguments.length>r;)n.push(arguments[r++]);return d[++l]=function(){i(\"function\"==typeof t?t:Function(t),n)},e(l),l},p=function(e){delete d[e]},\"process\"==require(\"./_cof\")(c)?e=function(e){c.nextTick(r(h,e,1))}:f?(n=(t=new f).port2,t.port1.onmessage=g,e=r(n.postMessage,n,1)):a.addEventListener&&\"function\"==typeof postMessage&&!a.importScripts?(e=function(e){a.postMessage(e+\"\",\"*\")},a.addEventListener(\"message\",g,!1)):e=m in s(\"script\")?function(e){o.appendChild(s(\"script\"))[m]=function(){o.removeChild(this),h.call(e)}}:function(e){setTimeout(r(h,e,1),0)}),module.exports={set:u,clear:p};\n},{\"./_ctx\":\"pxuO\",\"./_invoke\":\"dEIN\",\"./_html\":\"gbQ5\",\"./_dom-create\":\"aasK\",\"./_global\":\"rHgC\",\"./_cof\":\"5bPM\"}],\"ob+r\":[function(require,module,exports) {\nvar e=require(\"./_export\"),r=require(\"./_task\");e(e.G+e.B,{setImmediate:r.set,clearImmediate:r.clear});\n},{\"./_export\":\"dcWE\",\"./_task\":\"aMXM\"}],\"Ehlp\":[function(require,module,exports) {\nrequire(\"../modules/web.immediate\"),module.exports=require(\"../modules/_core\").setImmediate;\n},{\"../modules/web.immediate\":\"ob+r\",\"../modules/_core\":\"goWO\"}],\"uUPe\":[function(require,module,exports) {\nvar global = arguments[3];\nvar e,t,n=arguments[3],a=n.MutationObserver||n.WebKitMutationObserver;if(a){var o=0,r=new a(u),s=n.document.createTextNode(\"\");r.observe(s,{characterData:!0}),e=function(){s.data=o=++o%2}}else if(n.setImmediate||void 0===n.MessageChannel)e=\"document\"in n&&\"onreadystatechange\"in n.document.createElement(\"script\")?function(){var e=n.document.createElement(\"script\");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},n.document.documentElement.appendChild(e)}:function(){setTimeout(u,0)};else{var c=new n.MessageChannel;c.port1.onmessage=u,e=function(){c.port2.postMessage(0)}}var i=[];function u(){var e,n;t=!0;for(var a=i.length;a;){for(n=i,i=[],e=-1;++e<a;)n[e]();a=i.length}t=!1}function d(n){1!==i.push(n)||t||e()}module.exports=d;\n},{}],\"xz3w\":[function(require,module,exports) {\n\"use strict\";var t=require(\"immediate\");function e(){}var r={},n=[\"REJECTED\"],o=[\"FULFILLED\"],i=[\"PENDING\"];function u(t){if(\"function\"!=typeof t)throw new TypeError(\"resolver must be a function\");this.state=i,this.queue=[],this.outcome=void 0,t!==e&&f(this,t)}function c(t,e,r){this.promise=t,\"function\"==typeof e&&(this.onFulfilled=e,this.callFulfilled=this.otherCallFulfilled),\"function\"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function s(e,n,o){t(function(){var t;try{t=n(o)}catch(i){return r.reject(e,i)}t===e?r.reject(e,new TypeError(\"Cannot resolve promise with itself\")):r.resolve(e,t)})}function l(t){var e=t&&t.then;if(t&&(\"object\"==typeof t||\"function\"==typeof t)&&\"function\"==typeof e)return function(){e.apply(t,arguments)}}function f(t,e){var n=!1;function o(e){n||(n=!0,r.reject(t,e))}function i(e){n||(n=!0,r.resolve(t,e))}var u=a(function(){e(i,o)});\"error\"===u.status&&o(u.value)}function a(t,e){var r={};try{r.value=t(e),r.status=\"success\"}catch(n){r.status=\"error\",r.value=n}return r}function h(t){return t instanceof this?t:r.resolve(new this(e),t)}function v(t){var n=new this(e);return r.reject(n,t)}function p(t){var n=this;if(\"[object Array]\"!==Object.prototype.toString.call(t))return this.reject(new TypeError(\"must be an array\"));var o=t.length,i=!1;if(!o)return this.resolve([]);for(var u=new Array(o),c=0,s=-1,l=new this(e);++s<o;)f(t[s],s);return l;function f(t,e){n.resolve(t).then(function(t){u[e]=t,++c!==o||i||(i=!0,r.resolve(l,u))},function(t){i||(i=!0,r.reject(l,t))})}}function y(t){var n=this;if(\"[object Array]\"!==Object.prototype.toString.call(t))return this.reject(new TypeError(\"must be an array\"));var o=t.length,i=!1;if(!o)return this.resolve([]);for(var u,c=-1,s=new this(e);++c<o;)u=t[c],n.resolve(u).then(function(t){i||(i=!0,r.resolve(s,t))},function(t){i||(i=!0,r.reject(s,t))});return s}module.exports=u,u.prototype.catch=function(t){return this.then(null,t)},u.prototype.then=function(t,r){if(\"function\"!=typeof t&&this.state===o||\"function\"!=typeof r&&this.state===n)return this;var u=new this.constructor(e);this.state!==i?s(u,this.state===o?t:r,this.outcome):this.queue.push(new c(u,t,r));return u},c.prototype.callFulfilled=function(t){r.resolve(this.promise,t)},c.prototype.otherCallFulfilled=function(t){s(this.promise,this.onFulfilled,t)},c.prototype.callRejected=function(t){r.reject(this.promise,t)},c.prototype.otherCallRejected=function(t){s(this.promise,this.onRejected,t)},r.resolve=function(t,e){var n=a(l,e);if(\"error\"===n.status)return r.reject(t,n.value);var i=n.value;if(i)f(t,i);else{t.state=o,t.outcome=e;for(var u=-1,c=t.queue.length;++u<c;)t.queue[u].callFulfilled(e)}return t},r.reject=function(t,e){t.state=n,t.outcome=e;for(var r=-1,o=t.queue.length;++r<o;)t.queue[r].callRejected(e);return t},u.resolve=h,u.reject=v,u.all=p,u.race=y;\n},{\"immediate\":\"uUPe\"}],\"ObVN\":[function(require,module,exports) {\n\"use strict\";var e=null;e=\"undefined\"!=typeof Promise?Promise:require(\"lie\"),module.exports={Promise:e};\n},{\"lie\":\"xz3w\"}],\"rWOW\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./support\"),n=require(\"./base64\"),e=require(\"./nodejsUtils\"),t=require(\"core-js/library/fn/set-immediate\"),o=require(\"./external\");function a(n){return f(n,r.uint8array?new Uint8Array(n.length):new Array(n.length))}function u(r){return r}function f(r,n){for(var e=0;e<r.length;++e)n[e]=255&r.charCodeAt(e);return n}exports.newBlob=function(r,n){exports.checkSupport(\"blob\");try{return new Blob(r,{type:n})}catch(o){try{for(var e=new(window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder),t=0;t<r.length;t++)e.append(r[t]);return e.getBlob(n)}catch(o){throw new Error(\"Bug : can't construct the Blob.\")}}};var i={stringifyByChunk:function(r,n,e){var t=[],o=0,a=r.length;if(a<=e)return String.fromCharCode.apply(null,r);for(;o<a;)\"array\"===n||\"nodebuffer\"===n?t.push(String.fromCharCode.apply(null,r.slice(o,Math.min(o+e,a)))):t.push(String.fromCharCode.apply(null,r.subarray(o,Math.min(o+e,a)))),o+=e;return t.join(\"\")},stringifyByChar:function(r){for(var n=\"\",e=0;e<r.length;e++)n+=String.fromCharCode(r[e]);return n},applyCanBeUsed:{uint8array:function(){try{return r.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(n){return!1}}(),nodebuffer:function(){try{return r.nodebuffer&&1===String.fromCharCode.apply(null,e.newBuffer(1)).length}catch(n){return!1}}()}};function y(r){var n=65536,e=exports.getTypeOf(r),t=!0;if(\"uint8array\"===e?t=i.applyCanBeUsed.uint8array:\"nodebuffer\"===e&&(t=i.applyCanBeUsed.nodebuffer),t)for(;n>1;)try{return i.stringifyByChunk(r,e,n)}catch(o){n=Math.floor(n/2)}return i.stringifyByChar(r)}function c(r,n){for(var e=0;e<r.length;e++)n[e]=r[e];return n}exports.applyFromCharCode=y;var p={};p.string={string:u,array:function(r){return f(r,new Array(r.length))},arraybuffer:function(r){return p.string.uint8array(r).buffer},uint8array:function(r){return f(r,new Uint8Array(r.length))},nodebuffer:function(r){return f(r,e.newBuffer(r.length))}},p.array={string:y,array:u,arraybuffer:function(r){return new Uint8Array(r).buffer},uint8array:function(r){return new Uint8Array(r)},nodebuffer:function(r){return e.newBuffer(r)}},p.arraybuffer={string:function(r){return y(new Uint8Array(r))},array:function(r){return c(new Uint8Array(r),new Array(r.byteLength))},arraybuffer:u,uint8array:function(r){return new Uint8Array(r)},nodebuffer:function(r){return e.newBuffer(new Uint8Array(r))}},p.uint8array={string:y,array:function(r){return c(r,new Array(r.length))},arraybuffer:function(r){var n=new Uint8Array(r.length);return r.length&&n.set(r,0),n.buffer},uint8array:u,nodebuffer:function(r){return e.newBuffer(r)}},p.nodebuffer={string:y,array:function(r){return c(r,new Array(r.length))},arraybuffer:function(r){return p.nodebuffer.uint8array(r).buffer},uint8array:function(r){return c(r,new Uint8Array(r.length))},nodebuffer:u},exports.transformTo=function(r,n){if(n||(n=\"\"),!r)return n;exports.checkSupport(r);var e=exports.getTypeOf(n);return p[e][r](n)},exports.getTypeOf=function(n){return\"string\"==typeof n?\"string\":\"[object Array]\"===Object.prototype.toString.call(n)?\"array\":r.nodebuffer&&e.isBuffer(n)?\"nodebuffer\":r.uint8array&&n instanceof Uint8Array?\"uint8array\":r.arraybuffer&&n instanceof ArrayBuffer?\"arraybuffer\":void 0},exports.checkSupport=function(n){if(!r[n.toLowerCase()])throw new Error(n+\" is not supported by this platform\")},exports.MAX_VALUE_16BITS=65535,exports.MAX_VALUE_32BITS=-1,exports.pretty=function(r){var n,e,t=\"\";for(e=0;e<(r||\"\").length;e++)t+=\"\\\\x\"+((n=r.charCodeAt(e))<16?\"0\":\"\")+n.toString(16).toUpperCase();return t},exports.delay=function(r,n,e){t(function(){r.apply(e||null,n||[])})},exports.inherits=function(r,n){var e=function(){};e.prototype=n.prototype,r.prototype=new e},exports.extend=function(){var r,n,e={};for(r=0;r<arguments.length;r++)for(n in arguments[r])arguments[r].hasOwnProperty(n)&&void 0===e[n]&&(e[n]=arguments[r][n]);return e},exports.prepareContent=function(e,t,u,f,i){return o.Promise.resolve(t).then(function(n){return r.blob&&(n instanceof Blob||-1!==[\"[object File]\",\"[object Blob]\"].indexOf(Object.prototype.toString.call(n)))&&\"undefined\"!=typeof FileReader?new o.Promise(function(r,e){var t=new FileReader;t.onload=function(n){r(n.target.result)},t.onerror=function(r){e(r.target.error)},t.readAsArrayBuffer(n)}):n}).then(function(r){var t=exports.getTypeOf(r);return t?(\"arraybuffer\"===t?r=exports.transformTo(\"uint8array\",r):\"string\"===t&&(i?r=n.decode(r):u&&!0!==f&&(r=a(r))),r):o.Promise.reject(new Error(\"The data of '\"+e+\"' is in an unsupported format !\"))})};\n},{\"./support\":\"+8r/\",\"./base64\":\"FafD\",\"./nodejsUtils\":\"5Egw\",\"core-js/library/fn/set-immediate\":\"Ehlp\",\"./external\":\"ObVN\"}],\"g8b7\":[function(require,module,exports) {\n\"use strict\";function t(t){this.name=t||\"default\",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}t.prototype={push:function(t){this.emit(\"data\",t)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit(\"end\"),this.cleanUp(),this.isFinished=!0}catch(t){this.emit(\"error\",t)}return!0},error:function(t){return!this.isFinished&&(this.isPaused?this.generatedError=t:(this.isFinished=!0,this.emit(\"error\",t),this.previous&&this.previous.error(t),this.cleanUp()),!0)},on:function(t,i){return this._listeners[t].push(i),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(t,i){if(this._listeners[t])for(var s=0;s<this._listeners[t].length;s++)this._listeners[t][s].call(this,i)},pipe:function(t){return t.registerPrevious(this)},registerPrevious:function(t){if(this.isLocked)throw new Error(\"The stream '\"+this+\"' has already been used.\");this.streamInfo=t.streamInfo,this.mergeStreamInfo(),this.previous=t;var i=this;return t.on(\"data\",function(t){i.processChunk(t)}),t.on(\"end\",function(){i.end()}),t.on(\"error\",function(t){i.error(t)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;this.isPaused=!1;var t=!1;return this.generatedError&&(this.error(this.generatedError),t=!0),this.previous&&this.previous.resume(),!t},flush:function(){},processChunk:function(t){this.push(t)},withStreamInfo:function(t,i){return this.extraStreamInfo[t]=i,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var t in this.extraStreamInfo)this.extraStreamInfo.hasOwnProperty(t)&&(this.streamInfo[t]=this.extraStreamInfo[t])},lock:function(){if(this.isLocked)throw new Error(\"The stream '\"+this+\"' has already been used.\");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var t=\"Worker \"+this.name;return this.previous?this.previous+\" -> \"+t:t}},module.exports=t;\n},{}],\"JJJK\":[function(require,module,exports) {\n\"use strict\";for(var e=require(\"./utils\"),t=require(\"./support\"),r=require(\"./nodejsUtils\"),n=require(\"./stream/GenericWorker\"),a=new Array(256),o=0;o<256;o++)a[o]=o>=252?6:o>=248?5:o>=240?4:o>=224?3:o>=192?2:1;a[254]=a[254]=1;var f=function(e){var r,n,a,o,f,i=e.length,s=0;for(o=0;o<i;o++)55296==(64512&(n=e.charCodeAt(o)))&&o+1<i&&56320==(64512&(a=e.charCodeAt(o+1)))&&(n=65536+(n-55296<<10)+(a-56320),o++),s+=n<128?1:n<2048?2:n<65536?3:4;for(r=t.uint8array?new Uint8Array(s):new Array(s),f=0,o=0;f<s;o++)55296==(64512&(n=e.charCodeAt(o)))&&o+1<i&&56320==(64512&(a=e.charCodeAt(o+1)))&&(n=65536+(n-55296<<10)+(a-56320),o++),n<128?r[f++]=n:n<2048?(r[f++]=192|n>>>6,r[f++]=128|63&n):n<65536?(r[f++]=224|n>>>12,r[f++]=128|n>>>6&63,r[f++]=128|63&n):(r[f++]=240|n>>>18,r[f++]=128|n>>>12&63,r[f++]=128|n>>>6&63,r[f++]=128|63&n);return r},i=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;r>=0&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+a[e[r]]>t?r:t},s=function(t){var r,n,o,f,i=t.length,s=new Array(2*i);for(n=0,r=0;r<i;)if((o=t[r++])<128)s[n++]=o;else if((f=a[o])>4)s[n++]=65533,r+=f-1;else{for(o&=2===f?31:3===f?15:7;f>1&&r<i;)o=o<<6|63&t[r++],f--;f>1?s[n++]=65533:o<65536?s[n++]=o:(o-=65536,s[n++]=55296|o>>10&1023,s[n++]=56320|1023&o)}return s.length!==n&&(s.subarray?s=s.subarray(0,n):s.length=n),e.applyFromCharCode(s)};function u(){n.call(this,\"utf-8 decode\"),this.leftOver=null}function l(){n.call(this,\"utf-8 encode\")}exports.utf8encode=function(e){return t.nodebuffer?r.newBuffer(e,\"utf-8\"):f(e)},exports.utf8decode=function(r){return t.nodebuffer?e.transformTo(\"nodebuffer\",r).toString(\"utf-8\"):(r=e.transformTo(t.uint8array?\"uint8array\":\"array\",r),s(r))},e.inherits(u,n),u.prototype.processChunk=function(r){var n=e.transformTo(t.uint8array?\"uint8array\":\"array\",r.data);if(this.leftOver&&this.leftOver.length){if(t.uint8array){var a=n;(n=new Uint8Array(a.length+this.leftOver.length)).set(this.leftOver,0),n.set(a,this.leftOver.length)}else n=this.leftOver.concat(n);this.leftOver=null}var o=i(n),f=n;o!==n.length&&(t.uint8array?(f=n.subarray(0,o),this.leftOver=n.subarray(o,n.length)):(f=n.slice(0,o),this.leftOver=n.slice(o,n.length))),this.push({data:exports.utf8decode(f),meta:r.meta})},u.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:exports.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},exports.Utf8DecodeWorker=u,e.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:exports.utf8encode(e.data),meta:e.meta})},exports.Utf8EncodeWorker=l;\n},{\"./utils\":\"rWOW\",\"./support\":\"+8r/\",\"./nodejsUtils\":\"5Egw\",\"./stream/GenericWorker\":\"g8b7\"}],\"RXh3\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./GenericWorker\"),e=require(\"../utils\");function r(e){t.call(this,\"ConvertWorker to \"+e),this.destType=e}e.inherits(r,t),r.prototype.processChunk=function(t){this.push({data:e.transformTo(this.destType,t.data),meta:t.meta})},module.exports=r;\n},{\"./GenericWorker\":\"g8b7\",\"../utils\":\"rWOW\"}],\"vexR\":[function(require,module,exports) {\nmodule.exports=function(o){return o&&\"object\"==typeof o&&\"function\"==typeof o.copy&&\"function\"==typeof o.fill&&\"function\"==typeof o.readUInt8};\n},{}],\"gfUn\":[function(require,module,exports) {\nvar process = require(\"process\");\nvar e=require(\"process\"),t=Object.getOwnPropertyDescriptors||function(e){for(var t=Object.keys(e),r={},n=0;n<t.length;n++)r[t[n]]=Object.getOwnPropertyDescriptor(e,t[n]);return r},r=/%[sdj%]/g;exports.format=function(e){if(!v(e)){for(var t=[],n=0;n<arguments.length;n++)t.push(i(arguments[n]));return t.join(\" \")}n=1;for(var o=arguments,u=o.length,s=String(e).replace(r,function(e){if(\"%%\"===e)return\"%\";if(n>=u)return e;switch(e){case\"%s\":return String(o[n++]);case\"%d\":return Number(o[n++]);case\"%j\":try{return JSON.stringify(o[n++])}catch(t){return\"[Circular]\"}default:return e}}),c=o[n];n<u;c=o[++n])h(c)||!S(c)?s+=\" \"+c:s+=\" \"+i(c);return s},exports.deprecate=function(t,r){if(void 0!==e&&!0===e.noDeprecation)return t;if(void 0===e)return function(){return exports.deprecate(t,r).apply(this,arguments)};var n=!1;return function(){if(!n){if(e.throwDeprecation)throw new Error(r);e.traceDeprecation?console.trace(r):console.error(r),n=!0}return t.apply(this,arguments)}};var n,o={};function i(e,t){var r={seen:[],stylize:s};return arguments.length>=3&&(r.depth=arguments[2]),arguments.length>=4&&(r.colors=arguments[3]),b(t)?r.showHidden=t:t&&exports._extend(r,t),j(r.showHidden)&&(r.showHidden=!1),j(r.depth)&&(r.depth=2),j(r.colors)&&(r.colors=!1),j(r.customInspect)&&(r.customInspect=!0),r.colors&&(r.stylize=u),p(r,e,r.depth)}function u(e,t){var r=i.styles[t];return r?\"\u001b[\"+i.colors[r][0]+\"m\"+e+\"\u001b[\"+i.colors[r][1]+\"m\":e}function s(e,t){return e}function c(e){var t={};return e.forEach(function(e,r){t[e]=!0}),t}function p(e,t,r){if(e.customInspect&&t&&P(t.inspect)&&t.inspect!==exports.inspect&&(!t.constructor||t.constructor.prototype!==t)){var n=t.inspect(r,e);return v(n)||(n=p(e,n,r)),n}var o=l(e,t);if(o)return o;var i=Object.keys(t),u=c(i);if(e.showHidden&&(i=Object.getOwnPropertyNames(t)),E(t)&&(i.indexOf(\"message\")>=0||i.indexOf(\"description\")>=0))return f(t);if(0===i.length){if(P(t)){var s=t.name?\": \"+t.name:\"\";return e.stylize(\"[Function\"+s+\"]\",\"special\")}if(w(t))return e.stylize(RegExp.prototype.toString.call(t),\"regexp\");if(z(t))return e.stylize(Date.prototype.toString.call(t),\"date\");if(E(t))return f(t)}var b,h=\"\",m=!1,x=[\"{\",\"}\"];(d(t)&&(m=!0,x=[\"[\",\"]\"]),P(t))&&(h=\" [Function\"+(t.name?\": \"+t.name:\"\")+\"]\");return w(t)&&(h=\" \"+RegExp.prototype.toString.call(t)),z(t)&&(h=\" \"+Date.prototype.toUTCString.call(t)),E(t)&&(h=\" \"+f(t)),0!==i.length||m&&0!=t.length?r<0?w(t)?e.stylize(RegExp.prototype.toString.call(t),\"regexp\"):e.stylize(\"[Object]\",\"special\"):(e.seen.push(t),b=m?a(e,t,r,u,i):i.map(function(n){return y(e,t,r,u,n,m)}),e.seen.pop(),g(b,h,x)):x[0]+h+x[1]}function l(e,t){if(j(t))return e.stylize(\"undefined\",\"undefined\");if(v(t)){var r=\"'\"+JSON.stringify(t).replace(/^\"|\"$/g,\"\").replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"')+\"'\";return e.stylize(r,\"string\")}return x(t)?e.stylize(\"\"+t,\"number\"):b(t)?e.stylize(\"\"+t,\"boolean\"):h(t)?e.stylize(\"null\",\"null\"):void 0}function f(e){return\"[\"+Error.prototype.toString.call(e)+\"]\"}function a(e,t,r,n,o){for(var i=[],u=0,s=t.length;u<s;++u)A(t,String(u))?i.push(y(e,t,r,n,String(u),!0)):i.push(\"\");return o.forEach(function(o){o.match(/^\\d+$/)||i.push(y(e,t,r,n,o,!0))}),i}function y(e,t,r,n,o,i){var u,s,c;if((c=Object.getOwnPropertyDescriptor(t,o)||{value:t[o]}).get?s=c.set?e.stylize(\"[Getter/Setter]\",\"special\"):e.stylize(\"[Getter]\",\"special\"):c.set&&(s=e.stylize(\"[Setter]\",\"special\")),A(n,o)||(u=\"[\"+o+\"]\"),s||(e.seen.indexOf(c.value)<0?(s=h(r)?p(e,c.value,null):p(e,c.value,r-1)).indexOf(\"\\n\")>-1&&(s=i?s.split(\"\\n\").map(function(e){return\"  \"+e}).join(\"\\n\").substr(2):\"\\n\"+s.split(\"\\n\").map(function(e){return\"   \"+e}).join(\"\\n\")):s=e.stylize(\"[Circular]\",\"special\")),j(u)){if(i&&o.match(/^\\d+$/))return s;(u=JSON.stringify(\"\"+o)).match(/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?(u=u.substr(1,u.length-2),u=e.stylize(u,\"name\")):(u=u.replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"').replace(/(^\"|\"$)/g,\"'\"),u=e.stylize(u,\"string\"))}return u+\": \"+s}function g(e,t,r){return e.reduce(function(e,t){return 0,t.indexOf(\"\\n\")>=0&&0,e+t.replace(/\\u001b\\[\\d\\d?m/g,\"\").length+1},0)>60?r[0]+(\"\"===t?\"\":t+\"\\n \")+\" \"+e.join(\",\\n  \")+\" \"+r[1]:r[0]+t+\" \"+e.join(\", \")+\" \"+r[1]}function d(e){return Array.isArray(e)}function b(e){return\"boolean\"==typeof e}function h(e){return null===e}function m(e){return null==e}function x(e){return\"number\"==typeof e}function v(e){return\"string\"==typeof e}function O(e){return\"symbol\"==typeof e}function j(e){return void 0===e}function w(e){return S(e)&&\"[object RegExp]\"===T(e)}function S(e){return\"object\"==typeof e&&null!==e}function z(e){return S(e)&&\"[object Date]\"===T(e)}function E(e){return S(e)&&(\"[object Error]\"===T(e)||e instanceof Error)}function P(e){return\"function\"==typeof e}function D(e){return null===e||\"boolean\"==typeof e||\"number\"==typeof e||\"string\"==typeof e||\"symbol\"==typeof e||void 0===e}function T(e){return Object.prototype.toString.call(e)}function N(e){return e<10?\"0\"+e.toString(10):e.toString(10)}exports.debuglog=function(t){if(j(n)&&(n=\"\"),t=t.toUpperCase(),!o[t])if(new RegExp(\"\\\\b\"+t+\"\\\\b\",\"i\").test(n)){var r=e.pid;o[t]=function(){var e=exports.format.apply(exports,arguments);console.error(\"%s %d: %s\",t,r,e)}}else o[t]=function(){};return o[t]},exports.inspect=i,i.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},i.styles={special:\"cyan\",number:\"yellow\",boolean:\"yellow\",undefined:\"grey\",null:\"bold\",string:\"green\",date:\"magenta\",regexp:\"red\"},exports.isArray=d,exports.isBoolean=b,exports.isNull=h,exports.isNullOrUndefined=m,exports.isNumber=x,exports.isString=v,exports.isSymbol=O,exports.isUndefined=j,exports.isRegExp=w,exports.isObject=S,exports.isDate=z,exports.isError=E,exports.isFunction=P,exports.isPrimitive=D,exports.isBuffer=require(\"./support/isBuffer\");var F=[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"Jun\",\"Jul\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"];function k(){var e=new Date,t=[N(e.getHours()),N(e.getMinutes()),N(e.getSeconds())].join(\":\");return[e.getDate(),F[e.getMonth()],t].join(\" \")}function A(e,t){return Object.prototype.hasOwnProperty.call(e,t)}exports.log=function(){console.log(\"%s - %s\",k(),exports.format.apply(exports,arguments))},exports.inherits=require(\"inherits\"),exports._extend=function(e,t){if(!t||!S(t))return e;for(var r=Object.keys(t),n=r.length;n--;)e[r[n]]=t[r[n]];return e};var J=\"undefined\"!=typeof Symbol?Symbol(\"util.promisify.custom\"):void 0;function R(e,t){if(!e){var r=new Error(\"Promise was rejected with a falsy value\");r.reason=e,e=r}return t(e)}function H(r){if(\"function\"!=typeof r)throw new TypeError('The \"original\" argument must be of type Function');function n(){for(var t=[],n=0;n<arguments.length;n++)t.push(arguments[n]);var o=t.pop();if(\"function\"!=typeof o)throw new TypeError(\"The last argument must be of type Function\");var i=this,u=function(){return o.apply(i,arguments)};r.apply(this,t).then(function(t){e.nextTick(u,null,t)},function(t){e.nextTick(R,t,u)})}return Object.setPrototypeOf(n,Object.getPrototypeOf(r)),Object.defineProperties(n,t(r)),n}exports.promisify=function(e){if(\"function\"!=typeof e)throw new TypeError('The \"original\" argument must be of type Function');if(J&&e[J]){var r;if(\"function\"!=typeof(r=e[J]))throw new TypeError('The \"util.promisify.custom\" argument must be of type Function');return Object.defineProperty(r,J,{value:r,enumerable:!1,writable:!1,configurable:!0}),r}function r(){for(var t,r,n=new Promise(function(e,n){t=e,r=n}),o=[],i=0;i<arguments.length;i++)o.push(arguments[i]);o.push(function(e,n){e?r(e):t(n)});try{e.apply(this,o)}catch(u){r(u)}return n}return Object.setPrototypeOf(r,Object.getPrototypeOf(e)),J&&Object.defineProperty(r,J,{value:r,enumerable:!1,writable:!1,configurable:!0}),Object.defineProperties(r,t(e))},exports.promisify.custom=J,exports.callbackify=H;\n},{\"./support/isBuffer\":\"vexR\",\"inherits\":\"4Bm0\",\"process\":\"pBGv\"}],\"EISR\":[function(require,module,exports) {\n\"use strict\";var e=require(\"readable-stream\").Readable,r=require(\"util\");function t(r,t,i){e.call(this,t),this._helper=r;var n=this;r.on(\"data\",function(e,r){n.push(e)||n._helper.pause(),i&&i(r)}).on(\"error\",function(e){n.emit(\"error\",e)}).on(\"end\",function(){n.push(null)})}r.inherits(t,e),t.prototype._read=function(){this._helper.resume()},module.exports=t;\n},{\"readable-stream\":\"FayP\",\"util\":\"gfUn\"}],\"0o9N\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar r=require(\"buffer\").Buffer,e=require(\"../utils\"),t=require(\"./ConvertWorker\"),n=require(\"./GenericWorker\"),o=require(\"../base64\"),u=require(\"../support\"),a=require(\"../external\"),i=null;if(u.nodestream)try{i=require(\"../nodejs/NodejsStreamOutputAdapter\")}catch(f){}function s(r,t,n,u){var a=null;switch(r){case\"blob\":return e.newBlob(n,u);case\"base64\":return a=c(t,n),o.encode(a);default:return a=c(t,n),e.transformTo(r,a)}}function c(e,t){var n,o=0,u=null,a=0;for(n=0;n<t.length;n++)a+=t[n].length;switch(e){case\"string\":return t.join(\"\");case\"array\":return Array.prototype.concat.apply([],t);case\"uint8array\":for(u=new Uint8Array(a),n=0;n<t.length;n++)u.set(t[n],o),o+=t[n].length;return u;case\"nodebuffer\":return r.concat(t);default:throw new Error(\"concat : unsupported type '\"+e+\"'\")}}function p(r,e){return new a.Promise(function(t,n){var o=[],u=r._internalType,a=r._outputType,i=r._mimeType;r.on(\"data\",function(r,t){o.push(r),e&&e(t)}).on(\"error\",function(r){o=[],n(r)}).on(\"end\",function(){try{var r=s(a,u,o,i);t(r)}catch(f){n(f)}o=[]}).resume()})}function h(r,o,u){var a=o;switch(o){case\"blob\":a=\"arraybuffer\";break;case\"arraybuffer\":a=\"uint8array\";break;case\"base64\":a=\"string\"}try{this._internalType=a,this._outputType=o,this._mimeType=u,e.checkSupport(a),this._worker=r.pipe(new t(a)),r.lock()}catch(f){this._worker=new n(\"error\"),this._worker.error(f)}}h.prototype={accumulate:function(r){return p(this,r)},on:function(r,t){var n=this;return\"data\"===r?this._worker.on(r,function(r){t.call(n,r.data,r.meta)}):this._worker.on(r,function(){e.delay(t,arguments,n)}),this},resume:function(){return e.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(r){if(e.checkSupport(\"nodestream\"),\"nodebuffer\"!==this._outputType)throw new Error(this._outputType+\" is not supported by this method\");return new i(this,{objectMode:\"nodebuffer\"!==this._outputType},r)}},module.exports=h;\n},{\"../utils\":\"rWOW\",\"./ConvertWorker\":\"RXh3\",\"./GenericWorker\":\"g8b7\",\"../base64\":\"FafD\",\"../support\":\"+8r/\",\"../external\":\"ObVN\",\"../nodejs/NodejsStreamOutputAdapter\":\"EISR\",\"buffer\":\"peL6\"}],\"f+tM\":[function(require,module,exports) {\n\"use strict\";exports.base64=!1,exports.binary=!1,exports.dir=!1,exports.createFolders=!0,exports.date=null,exports.compression=null,exports.compressionOptions=null,exports.comment=null,exports.unixPermissions=null,exports.dosPermissions=null;\n},{}],\"KrEL\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../utils\"),i=require(\"./GenericWorker\"),e=16384;function s(e){i.call(this,\"DataWorker\");var s=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type=\"\",this._tickScheduled=!1,e.then(function(i){s.dataIsReady=!0,s.data=i,s.max=i&&i.length||0,s.type=t.getTypeOf(i),s.isPaused||s._tickAndRepeat()},function(t){s.error(t)})}t.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,t.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(t.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var t=e,i=null,s=Math.min(this.max,this.index+t);if(this.index>=this.max)return this.end();switch(this.type){case\"string\":i=this.data.substring(this.index,s);break;case\"uint8array\":i=this.data.subarray(this.index,s);break;case\"array\":case\"nodebuffer\":i=this.data.slice(this.index,s)}return this.index=s,this.push({data:i,meta:{percent:this.max?this.index/this.max*100:0}})},module.exports=s;\n},{\"../utils\":\"rWOW\",\"./GenericWorker\":\"g8b7\"}],\"MlpB\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../utils\"),e=require(\"./GenericWorker\");function r(t){e.call(this,\"DataLengthProbe for \"+t),this.propName=t,this.withStreamInfo(t,0)}t.inherits(r,e),r.prototype.processChunk=function(t){if(t){var r=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=r+t.data.length}e.prototype.processChunk.call(this,t)},module.exports=r;\n},{\"../utils\":\"rWOW\",\"./GenericWorker\":\"g8b7\"}],\"4G8U\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./utils\");function t(){for(var r,t=[],n=0;n<256;n++){r=n;for(var e=0;e<8;e++)r=1&r?3988292384^r>>>1:r>>>1;t[n]=r}return t}var n=t();function e(r,t,e,o){var u=n,a=o+e;r^=-1;for(var f=o;f<a;f++)r=r>>>8^u[255&(r^t[f])];return-1^r}function o(r,t,e,o){var u=n,a=o+e;r^=-1;for(var f=o;f<a;f++)r=r>>>8^u[255&(r^t.charCodeAt(f))];return-1^r}module.exports=function(t,n){return void 0!==t&&t.length?\"string\"!==r.getTypeOf(t)?e(0|n,t,t.length,0):o(0|n,t,t.length,0):0};\n},{\"./utils\":\"rWOW\"}],\"FBbk\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./GenericWorker\"),e=require(\"../crc32\"),t=require(\"../utils\");function i(){r.call(this,\"Crc32Probe\"),this.withStreamInfo(\"crc32\",0)}t.inherits(i,r),i.prototype.processChunk=function(r){this.streamInfo.crc32=e(r.data,this.streamInfo.crc32||0),this.push(r)},module.exports=i;\n},{\"./GenericWorker\":\"g8b7\",\"../crc32\":\"4G8U\",\"../utils\":\"rWOW\"}],\"NnFM\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./external\"),r=require(\"./stream/DataWorker\"),s=require(\"./stream/DataLengthProbe\"),t=require(\"./stream/Crc32Probe\");s=require(\"./stream/DataLengthProbe\");function o(e,r,s,t,o){this.compressedSize=e,this.uncompressedSize=r,this.crc32=s,this.compression=t,this.compressedContent=o}o.prototype={getContentWorker:function(){var t=new r(e.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new s(\"data_length\")),o=this;return t.on(\"end\",function(){if(this.streamInfo.data_length!==o.uncompressedSize)throw new Error(\"Bug : uncompressed data size mismatch\")}),t},getCompressedWorker:function(){return new r(e.Promise.resolve(this.compressedContent)).withStreamInfo(\"compressedSize\",this.compressedSize).withStreamInfo(\"uncompressedSize\",this.uncompressedSize).withStreamInfo(\"crc32\",this.crc32).withStreamInfo(\"compression\",this.compression)}},o.createWorkerFrom=function(e,r,o){return e.pipe(new t).pipe(new s(\"uncompressedSize\")).pipe(r.compressWorker(o)).pipe(new s(\"compressedSize\")).withStreamInfo(\"compression\",r)},module.exports=o;\n},{\"./external\":\"ObVN\",\"./stream/DataWorker\":\"KrEL\",\"./stream/DataLengthProbe\":\"MlpB\",\"./stream/Crc32Probe\":\"FBbk\"}],\"zqKV\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./stream/StreamHelper\"),r=require(\"./stream/DataWorker\"),t=require(\"./utf8\"),s=require(\"./compressedObject\"),i=require(\"./stream/GenericWorker\"),n=function(e,r,t){this.name=e,this.dir=t.dir,this.date=t.date,this.comment=t.comment,this.unixPermissions=t.unixPermissions,this.dosPermissions=t.dosPermissions,this._data=r,this._dataBinary=t.binary,this.options={compression:t.compression,compressionOptions:t.compressionOptions}};n.prototype={internalStream:function(r){var s=r.toLowerCase(),i=\"string\"===s||\"text\"===s;\"binarystring\"!==s&&\"text\"!==s||(s=\"string\");var n=this._decompressWorker(),o=!this._dataBinary;return o&&!i&&(n=n.pipe(new t.Utf8EncodeWorker)),!o&&i&&(n=n.pipe(new t.Utf8DecodeWorker)),new e(n,s,\"\")},async:function(e,r){return this.internalStream(e).accumulate(r)},nodeStream:function(e,r){return this.internalStream(e||\"nodebuffer\").toNodejsStream(r)},_compressWorker:function(e,r){if(this._data instanceof s&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var i=this._decompressWorker();return this._dataBinary||(i=i.pipe(new t.Utf8EncodeWorker)),s.createWorkerFrom(i,e,r)},_decompressWorker:function(){return this._data instanceof s?this._data.getContentWorker():this._data instanceof i?this._data:new r(this._data)}};for(var o=[\"asText\",\"asBinary\",\"asNodeBuffer\",\"asUint8Array\",\"asArrayBuffer\"],a=function(){throw new Error(\"This method has been removed in JSZip 3.0, please check the upgrade guide.\")},c=0;c<o.length;c++)n.prototype[o[c]]=a;module.exports=n;\n},{\"./stream/StreamHelper\":\"0o9N\",\"./stream/DataWorker\":\"KrEL\",\"./utf8\":\"JJJK\",\"./compressedObject\":\"NnFM\",\"./stream/GenericWorker\":\"g8b7\"}],\"tbG5\":[function(require,module,exports) {\n\"use strict\";var r=\"undefined\"!=typeof Uint8Array&&\"undefined\"!=typeof Uint16Array&&\"undefined\"!=typeof Int32Array;function t(r,t){return Object.prototype.hasOwnProperty.call(r,t)}exports.assign=function(r){for(var e=Array.prototype.slice.call(arguments,1);e.length;){var n=e.shift();if(n){if(\"object\"!=typeof n)throw new TypeError(n+\"must be non-object\");for(var a in n)t(n,a)&&(r[a]=n[a])}}return r},exports.shrinkBuf=function(r,t){return r.length===t?r:r.subarray?r.subarray(0,t):(r.length=t,r)};var e={arraySet:function(r,t,e,n,a){if(t.subarray&&r.subarray)r.set(t.subarray(e,e+n),a);else for(var o=0;o<n;o++)r[a+o]=t[e+o]},flattenChunks:function(r){var t,e,n,a,o,s;for(n=0,t=0,e=r.length;t<e;t++)n+=r[t].length;for(s=new Uint8Array(n),a=0,t=0,e=r.length;t<e;t++)o=r[t],s.set(o,a),a+=o.length;return s}},n={arraySet:function(r,t,e,n,a){for(var o=0;o<n;o++)r[a+o]=t[e+o]},flattenChunks:function(r){return[].concat.apply([],r)}};exports.setTyped=function(r){r?(exports.Buf8=Uint8Array,exports.Buf16=Uint16Array,exports.Buf32=Int32Array,exports.assign(exports,e)):(exports.Buf8=Array,exports.Buf16=Array,exports.Buf32=Array,exports.assign(exports,n))},exports.setTyped(r);\n},{}],\"+sRJ\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils/common\"),t=4,n=0,_=1,r=2;function a(e){for(var t=e.length;--t>=0;)e[t]=0}var i=0,l=1,d=2,f=3,o=258,b=29,s=256,u=s+1+b,c=30,p=19,h=2*u+1,v=15,y=16,x=7,g=256,m=16,w=17,A=18,k=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],q=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],z=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],j=512,B=new Array(2*(u+2));a(B);var C=new Array(2*c);a(C);var D=new Array(j);a(D);var E=new Array(o-f+1);a(E);var F=new Array(b);a(F);var G,H,I,J=new Array(c);function K(e,t,n,_,r){this.static_tree=e,this.extra_bits=t,this.extra_base=n,this.elems=_,this.max_length=r,this.has_stree=e&&e.length}function L(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function M(e){return e<256?D[e]:D[256+(e>>>7)]}function N(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function O(e,t,n){e.bi_valid>y-n?(e.bi_buf|=t<<e.bi_valid&65535,N(e,e.bi_buf),e.bi_buf=t>>y-e.bi_valid,e.bi_valid+=n-y):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=n)}function P(e,t,n){O(e,n[2*t],n[2*t+1])}function Q(e,t){var n=0;do{n|=1&e,e>>>=1,n<<=1}while(--t>0);return n>>>1}function R(e){16===e.bi_valid?(N(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):e.bi_valid>=8&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}function T(e,t){var n,_,r,a,i,l,d=t.dyn_tree,f=t.max_code,o=t.stat_desc.static_tree,b=t.stat_desc.has_stree,s=t.stat_desc.extra_bits,u=t.stat_desc.extra_base,c=t.stat_desc.max_length,p=0;for(a=0;a<=v;a++)e.bl_count[a]=0;for(d[2*e.heap[e.heap_max]+1]=0,n=e.heap_max+1;n<h;n++)(a=d[2*d[2*(_=e.heap[n])+1]+1]+1)>c&&(a=c,p++),d[2*_+1]=a,_>f||(e.bl_count[a]++,i=0,_>=u&&(i=s[_-u]),l=d[2*_],e.opt_len+=l*(a+i),b&&(e.static_len+=l*(o[2*_+1]+i)));if(0!==p){do{for(a=c-1;0===e.bl_count[a];)a--;e.bl_count[a]--,e.bl_count[a+1]+=2,e.bl_count[c]--,p-=2}while(p>0);for(a=c;0!==a;a--)for(_=e.bl_count[a];0!==_;)(r=e.heap[--n])>f||(d[2*r+1]!==a&&(e.opt_len+=(a-d[2*r+1])*d[2*r],d[2*r+1]=a),_--)}}function U(e,t,n){var _,r,a=new Array(v+1),i=0;for(_=1;_<=v;_++)a[_]=i=i+n[_-1]<<1;for(r=0;r<=t;r++){var l=e[2*r+1];0!==l&&(e[2*r]=Q(a[l]++,l))}}function V(){var e,t,n,_,r,a=new Array(v+1);for(n=0,_=0;_<b-1;_++)for(F[_]=n,e=0;e<1<<k[_];e++)E[n++]=_;for(E[n-1]=_,r=0,_=0;_<16;_++)for(J[_]=r,e=0;e<1<<q[_];e++)D[r++]=_;for(r>>=7;_<c;_++)for(J[_]=r<<7,e=0;e<1<<q[_]-7;e++)D[256+r++]=_;for(t=0;t<=v;t++)a[t]=0;for(e=0;e<=143;)B[2*e+1]=8,e++,a[8]++;for(;e<=255;)B[2*e+1]=9,e++,a[9]++;for(;e<=279;)B[2*e+1]=7,e++,a[7]++;for(;e<=287;)B[2*e+1]=8,e++,a[8]++;for(U(B,u+1,a),e=0;e<c;e++)C[2*e+1]=5,C[2*e]=Q(e,5);G=new K(B,k,s+1,u,v),H=new K(C,q,0,c,v),I=new K(new Array(0),z,0,p,x)}function W(e){var t;for(t=0;t<u;t++)e.dyn_ltree[2*t]=0;for(t=0;t<c;t++)e.dyn_dtree[2*t]=0;for(t=0;t<p;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*g]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function X(e){e.bi_valid>8?N(e,e.bi_buf):e.bi_valid>0&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function Y(t,n,_,r){X(t),r&&(N(t,_),N(t,~_)),e.arraySet(t.pending_buf,t.window,n,_,t.pending),t.pending+=_}function Z(e,t,n,_){var r=2*t,a=2*n;return e[r]<e[a]||e[r]===e[a]&&_[t]<=_[n]}function $(e,t,n){for(var _=e.heap[n],r=n<<1;r<=e.heap_len&&(r<e.heap_len&&Z(t,e.heap[r+1],e.heap[r],e.depth)&&r++,!Z(t,_,e.heap[r],e.depth));)e.heap[n]=e.heap[r],n=r,r<<=1;e.heap[n]=_}function ee(e,t,n){var _,r,a,i,l=0;if(0!==e.last_lit)do{_=e.pending_buf[e.d_buf+2*l]<<8|e.pending_buf[e.d_buf+2*l+1],r=e.pending_buf[e.l_buf+l],l++,0===_?P(e,r,t):(P(e,(a=E[r])+s+1,t),0!==(i=k[a])&&O(e,r-=F[a],i),P(e,a=M(--_),n),0!==(i=q[a])&&O(e,_-=J[a],i))}while(l<e.last_lit);P(e,g,t)}function te(e,t){var n,_,r,a=t.dyn_tree,i=t.stat_desc.static_tree,l=t.stat_desc.has_stree,d=t.stat_desc.elems,f=-1;for(e.heap_len=0,e.heap_max=h,n=0;n<d;n++)0!==a[2*n]?(e.heap[++e.heap_len]=f=n,e.depth[n]=0):a[2*n+1]=0;for(;e.heap_len<2;)a[2*(r=e.heap[++e.heap_len]=f<2?++f:0)]=1,e.depth[r]=0,e.opt_len--,l&&(e.static_len-=i[2*r+1]);for(t.max_code=f,n=e.heap_len>>1;n>=1;n--)$(e,a,n);r=d;do{n=e.heap[1],e.heap[1]=e.heap[e.heap_len--],$(e,a,1),_=e.heap[1],e.heap[--e.heap_max]=n,e.heap[--e.heap_max]=_,a[2*r]=a[2*n]+a[2*_],e.depth[r]=(e.depth[n]>=e.depth[_]?e.depth[n]:e.depth[_])+1,a[2*n+1]=a[2*_+1]=r,e.heap[1]=r++,$(e,a,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1],T(e,t),U(a,f,e.bl_count)}function ne(e,t,n){var _,r,a=-1,i=t[1],l=0,d=7,f=4;for(0===i&&(d=138,f=3),t[2*(n+1)+1]=65535,_=0;_<=n;_++)r=i,i=t[2*(_+1)+1],++l<d&&r===i||(l<f?e.bl_tree[2*r]+=l:0!==r?(r!==a&&e.bl_tree[2*r]++,e.bl_tree[2*m]++):l<=10?e.bl_tree[2*w]++:e.bl_tree[2*A]++,l=0,a=r,0===i?(d=138,f=3):r===i?(d=6,f=3):(d=7,f=4))}function _e(e,t,n){var _,r,a=-1,i=t[1],l=0,d=7,f=4;for(0===i&&(d=138,f=3),_=0;_<=n;_++)if(r=i,i=t[2*(_+1)+1],!(++l<d&&r===i)){if(l<f)do{P(e,r,e.bl_tree)}while(0!=--l);else 0!==r?(r!==a&&(P(e,r,e.bl_tree),l--),P(e,m,e.bl_tree),O(e,l-3,2)):l<=10?(P(e,w,e.bl_tree),O(e,l-3,3)):(P(e,A,e.bl_tree),O(e,l-11,7));l=0,a=r,0===i?(d=138,f=3):r===i?(d=6,f=3):(d=7,f=4)}}function re(e){var t;for(ne(e,e.dyn_ltree,e.l_desc.max_code),ne(e,e.dyn_dtree,e.d_desc.max_code),te(e,e.bl_desc),t=p-1;t>=3&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}function ae(e,t,n,_){var r;for(O(e,t-257,5),O(e,n-1,5),O(e,_-4,4),r=0;r<_;r++)O(e,e.bl_tree[2*S[r]+1],3);_e(e,e.dyn_ltree,t-1),_e(e,e.dyn_dtree,n-1)}function ie(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return n;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return _;for(t=32;t<s;t++)if(0!==e.dyn_ltree[2*t])return _;return n}a(J);var le=!1;function de(e){le||(V(),le=!0),e.l_desc=new L(e.dyn_ltree,G),e.d_desc=new L(e.dyn_dtree,H),e.bl_desc=new L(e.bl_tree,I),e.bi_buf=0,e.bi_valid=0,W(e)}function fe(e,t,n,_){O(e,(i<<1)+(_?1:0),3),Y(e,t,n,!0)}function oe(e){O(e,l<<1,3),P(e,g,B),R(e)}function be(e,n,_,a){var i,f,o=0;e.level>0?(e.strm.data_type===r&&(e.strm.data_type=ie(e)),te(e,e.l_desc),te(e,e.d_desc),o=re(e),i=e.opt_len+3+7>>>3,(f=e.static_len+3+7>>>3)<=i&&(i=f)):i=f=_+5,_+4<=i&&-1!==n?fe(e,n,_,a):e.strategy===t||f===i?(O(e,(l<<1)+(a?1:0),3),ee(e,B,C)):(O(e,(d<<1)+(a?1:0),3),ae(e,e.l_desc.max_code+1,e.d_desc.max_code+1,o+1),ee(e,e.dyn_ltree,e.dyn_dtree)),W(e),a&&X(e)}function se(e,t,n){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&n,e.last_lit++,0===t?e.dyn_ltree[2*n]++:(e.matches++,t--,e.dyn_ltree[2*(E[n]+s+1)]++,e.dyn_dtree[2*M(t)]++),e.last_lit===e.lit_bufsize-1}exports._tr_init=de,exports._tr_stored_block=fe,exports._tr_flush_block=be,exports._tr_tally=se,exports._tr_align=oe;\n},{\"../utils/common\":\"tbG5\"}],\"uxo6\":[function(require,module,exports) {\n\"use strict\";function e(e,r,o,t){for(var u=65535&e|0,i=e>>>16&65535|0,n=0;0!==o;){o-=n=o>2e3?2e3:o;do{i=i+(u=u+r[t++]|0)|0}while(--n);u%=65521,i%=65521}return u|i<<16|0}module.exports=e;\n},{}],\"X4kj\":[function(require,module,exports) {\n\"use strict\";function r(){for(var r,o=[],t=0;t<256;t++){r=t;for(var n=0;n<8;n++)r=1&r?3988292384^r>>>1:r>>>1;o[t]=r}return o}var o=r();function t(r,t,n,u){var a=o,e=u+n;r^=-1;for(var f=u;f<e;f++)r=r>>>8^a[255&(r^t[f])];return-1^r}module.exports=t;\n},{}],\"gMAY\":[function(require,module,exports) {\n\"use strict\";module.exports={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"};\n},{}],\"+BLB\":[function(require,module,exports) {\n\"use strict\";var t,a=require(\"../utils/common\"),e=require(\"./trees\"),s=require(\"./adler32\"),i=require(\"./crc32\"),r=require(\"./messages\"),n=0,h=1,l=3,_=4,d=5,o=0,u=1,g=-2,f=-3,c=-5,p=-1,m=1,w=2,v=3,k=4,z=0,b=2,x=8,y=9,B=15,S=8,q=29,I=256,A=I+1+q,C=30,R=19,j=2*A+1,D=15,E=3,H=258,K=H+E+1,N=32,F=42,G=69,J=73,L=91,M=103,O=113,P=666,Q=1,T=2,U=3,V=4,W=3;function X(t,a){return t.msg=r[a],a}function Y(t){return(t<<1)-(t>4?9:0)}function Z(t){for(var a=t.length;--a>=0;)t[a]=0}function $(t){var e=t.state,s=e.pending;s>t.avail_out&&(s=t.avail_out),0!==s&&(a.arraySet(t.output,e.pending_buf,e.pending_out,s,t.next_out),t.next_out+=s,e.pending_out+=s,t.total_out+=s,t.avail_out-=s,e.pending-=s,0===e.pending&&(e.pending_out=0))}function tt(t,a){e._tr_flush_block(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,a),t.block_start=t.strstart,$(t.strm)}function at(t,a){t.pending_buf[t.pending++]=a}function et(t,a){t.pending_buf[t.pending++]=a>>>8&255,t.pending_buf[t.pending++]=255&a}function st(t,e,r,n){var h=t.avail_in;return h>n&&(h=n),0===h?0:(t.avail_in-=h,a.arraySet(e,t.input,t.next_in,h,r),1===t.state.wrap?t.adler=s(t.adler,e,h,r):2===t.state.wrap&&(t.adler=i(t.adler,e,h,r)),t.next_in+=h,t.total_in+=h,h)}function it(t,a){var e,s,i=t.max_chain_length,r=t.strstart,n=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-K?t.strstart-(t.w_size-K):0,_=t.window,d=t.w_mask,o=t.prev,u=t.strstart+H,g=_[r+n-1],f=_[r+n];t.prev_length>=t.good_match&&(i>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(e=a)+n]===f&&_[e+n-1]===g&&_[e]===_[r]&&_[++e]===_[r+1]){r+=2,e++;do{}while(_[++r]===_[++e]&&_[++r]===_[++e]&&_[++r]===_[++e]&&_[++r]===_[++e]&&_[++r]===_[++e]&&_[++r]===_[++e]&&_[++r]===_[++e]&&_[++r]===_[++e]&&r<u);if(s=H-(u-r),r=u-H,s>n){if(t.match_start=a,n=s,s>=h)break;g=_[r+n-1],f=_[r+n]}}}while((a=o[a&d])>l&&0!=--i);return n<=t.lookahead?n:t.lookahead}function rt(t){var e,s,i,r,n,h=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=h+(h-K)){a.arraySet(t.window,t.window,h,h,0),t.match_start-=h,t.strstart-=h,t.block_start-=h,e=s=t.hash_size;do{i=t.head[--e],t.head[e]=i>=h?i-h:0}while(--s);e=s=h;do{i=t.prev[--e],t.prev[e]=i>=h?i-h:0}while(--s);r+=h}if(0===t.strm.avail_in)break;if(s=st(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=s,t.lookahead+t.insert>=E)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=(t.ins_h<<t.hash_shift^t.window[n+1])&t.hash_mask;t.insert&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[n+E-1])&t.hash_mask,t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<E)););}while(t.lookahead<K&&0!==t.strm.avail_in)}function nt(t,a){var e=65535;for(e>t.pending_buf_size-5&&(e=t.pending_buf_size-5);;){if(t.lookahead<=1){if(rt(t),0===t.lookahead&&a===n)return Q;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var s=t.block_start+e;if((0===t.strstart||t.strstart>=s)&&(t.lookahead=t.strstart-s,t.strstart=s,tt(t,!1),0===t.strm.avail_out))return Q;if(t.strstart-t.block_start>=t.w_size-K&&(tt(t,!1),0===t.strm.avail_out))return Q}return t.insert=0,a===_?(tt(t,!0),0===t.strm.avail_out?U:V):(t.strstart>t.block_start&&(tt(t,!1),t.strm.avail_out),Q)}function ht(t,a){for(var s,i;;){if(t.lookahead<K){if(rt(t),t.lookahead<K&&a===n)return Q;if(0===t.lookahead)break}if(s=0,t.lookahead>=E&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+E-1])&t.hash_mask,s=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==s&&t.strstart-s<=t.w_size-K&&(t.match_length=it(t,s)),t.match_length>=E)if(i=e._tr_tally(t,t.strstart-t.match_start,t.match_length-E),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=E){t.match_length--;do{t.strstart++,t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+E-1])&t.hash_mask,s=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+1])&t.hash_mask;else i=e._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(tt(t,!1),0===t.strm.avail_out))return Q}return t.insert=t.strstart<E-1?t.strstart:E-1,a===_?(tt(t,!0),0===t.strm.avail_out?U:V):t.last_lit&&(tt(t,!1),0===t.strm.avail_out)?Q:T}function lt(t,a){for(var s,i,r;;){if(t.lookahead<K){if(rt(t),t.lookahead<K&&a===n)return Q;if(0===t.lookahead)break}if(s=0,t.lookahead>=E&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+E-1])&t.hash_mask,s=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=E-1,0!==s&&t.prev_length<t.max_lazy_match&&t.strstart-s<=t.w_size-K&&(t.match_length=it(t,s),t.match_length<=5&&(t.strategy===m||t.match_length===E&&t.strstart-t.match_start>4096)&&(t.match_length=E-1)),t.prev_length>=E&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-E,i=e._tr_tally(t,t.strstart-1-t.prev_match,t.prev_length-E),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+E-1])&t.hash_mask,s=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=E-1,t.strstart++,i&&(tt(t,!1),0===t.strm.avail_out))return Q}else if(t.match_available){if((i=e._tr_tally(t,0,t.window[t.strstart-1]))&&tt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return Q}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=e._tr_tally(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<E-1?t.strstart:E-1,a===_?(tt(t,!0),0===t.strm.avail_out?U:V):t.last_lit&&(tt(t,!1),0===t.strm.avail_out)?Q:T}function _t(t,a){for(var s,i,r,h,l=t.window;;){if(t.lookahead<=H){if(rt(t),t.lookahead<=H&&a===n)return Q;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=E&&t.strstart>0&&(i=l[r=t.strstart-1])===l[++r]&&i===l[++r]&&i===l[++r]){h=t.strstart+H;do{}while(i===l[++r]&&i===l[++r]&&i===l[++r]&&i===l[++r]&&i===l[++r]&&i===l[++r]&&i===l[++r]&&i===l[++r]&&r<h);t.match_length=H-(h-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=E?(s=e._tr_tally(t,1,t.match_length-E),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(s=e._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),s&&(tt(t,!1),0===t.strm.avail_out))return Q}return t.insert=0,a===_?(tt(t,!0),0===t.strm.avail_out?U:V):t.last_lit&&(tt(t,!1),0===t.strm.avail_out)?Q:T}function dt(t,a){for(var s;;){if(0===t.lookahead&&(rt(t),0===t.lookahead)){if(a===n)return Q;break}if(t.match_length=0,s=e._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,s&&(tt(t,!1),0===t.strm.avail_out))return Q}return t.insert=0,a===_?(tt(t,!0),0===t.strm.avail_out?U:V):t.last_lit&&(tt(t,!1),0===t.strm.avail_out)?Q:T}function ot(t,a,e,s,i){this.good_length=t,this.max_lazy=a,this.nice_length=e,this.max_chain=s,this.func=i}function ut(a){a.window_size=2*a.w_size,Z(a.head),a.max_lazy_match=t[a.level].max_lazy,a.good_match=t[a.level].good_length,a.nice_match=t[a.level].nice_length,a.max_chain_length=t[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=E-1,a.match_available=0,a.ins_h=0}function gt(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=x,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new a.Buf16(2*j),this.dyn_dtree=new a.Buf16(2*(2*C+1)),this.bl_tree=new a.Buf16(2*(2*R+1)),Z(this.dyn_ltree),Z(this.dyn_dtree),Z(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new a.Buf16(D+1),this.heap=new a.Buf16(2*A+1),Z(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new a.Buf16(2*A+1),Z(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function ft(t){var a;return t&&t.state?(t.total_in=t.total_out=0,t.data_type=b,(a=t.state).pending=0,a.pending_out=0,a.wrap<0&&(a.wrap=-a.wrap),a.status=a.wrap?F:O,t.adler=2===a.wrap?0:1,a.last_flush=n,e._tr_init(a),o):X(t,g)}function ct(t){var a=ft(t);return a===o&&ut(t.state),a}function pt(t,a){return t&&t.state?2!==t.state.wrap?g:(t.state.gzhead=a,o):g}function mt(t,e,s,i,r,n){if(!t)return g;var h=1;if(e===p&&(e=6),i<0?(h=0,i=-i):i>15&&(h=2,i-=16),r<1||r>y||s!==x||i<8||i>15||e<0||e>9||n<0||n>k)return X(t,g);8===i&&(i=9);var l=new gt;return t.state=l,l.strm=t,l.wrap=h,l.gzhead=null,l.w_bits=i,l.w_size=1<<l.w_bits,l.w_mask=l.w_size-1,l.hash_bits=r+7,l.hash_size=1<<l.hash_bits,l.hash_mask=l.hash_size-1,l.hash_shift=~~((l.hash_bits+E-1)/E),l.window=new a.Buf8(2*l.w_size),l.head=new a.Buf16(l.hash_size),l.prev=new a.Buf16(l.w_size),l.lit_bufsize=1<<r+6,l.pending_buf_size=4*l.lit_bufsize,l.pending_buf=new a.Buf8(l.pending_buf_size),l.d_buf=1*l.lit_bufsize,l.l_buf=3*l.lit_bufsize,l.level=e,l.strategy=n,l.method=s,ct(t)}function wt(t,a){return mt(t,a,x,B,S,z)}function vt(a,s){var r,f,p,m;if(!a||!a.state||s>d||s<0)return a?X(a,g):g;if(f=a.state,!a.output||!a.input&&0!==a.avail_in||f.status===P&&s!==_)return X(a,0===a.avail_out?c:g);if(f.strm=a,r=f.last_flush,f.last_flush=s,f.status===F)if(2===f.wrap)a.adler=0,at(f,31),at(f,139),at(f,8),f.gzhead?(at(f,(f.gzhead.text?1:0)+(f.gzhead.hcrc?2:0)+(f.gzhead.extra?4:0)+(f.gzhead.name?8:0)+(f.gzhead.comment?16:0)),at(f,255&f.gzhead.time),at(f,f.gzhead.time>>8&255),at(f,f.gzhead.time>>16&255),at(f,f.gzhead.time>>24&255),at(f,9===f.level?2:f.strategy>=w||f.level<2?4:0),at(f,255&f.gzhead.os),f.gzhead.extra&&f.gzhead.extra.length&&(at(f,255&f.gzhead.extra.length),at(f,f.gzhead.extra.length>>8&255)),f.gzhead.hcrc&&(a.adler=i(a.adler,f.pending_buf,f.pending,0)),f.gzindex=0,f.status=G):(at(f,0),at(f,0),at(f,0),at(f,0),at(f,0),at(f,9===f.level?2:f.strategy>=w||f.level<2?4:0),at(f,W),f.status=O);else{var k=x+(f.w_bits-8<<4)<<8;k|=(f.strategy>=w||f.level<2?0:f.level<6?1:6===f.level?2:3)<<6,0!==f.strstart&&(k|=N),k+=31-k%31,f.status=O,et(f,k),0!==f.strstart&&(et(f,a.adler>>>16),et(f,65535&a.adler)),a.adler=1}if(f.status===G)if(f.gzhead.extra){for(p=f.pending;f.gzindex<(65535&f.gzhead.extra.length)&&(f.pending!==f.pending_buf_size||(f.gzhead.hcrc&&f.pending>p&&(a.adler=i(a.adler,f.pending_buf,f.pending-p,p)),$(a),p=f.pending,f.pending!==f.pending_buf_size));)at(f,255&f.gzhead.extra[f.gzindex]),f.gzindex++;f.gzhead.hcrc&&f.pending>p&&(a.adler=i(a.adler,f.pending_buf,f.pending-p,p)),f.gzindex===f.gzhead.extra.length&&(f.gzindex=0,f.status=J)}else f.status=J;if(f.status===J)if(f.gzhead.name){p=f.pending;do{if(f.pending===f.pending_buf_size&&(f.gzhead.hcrc&&f.pending>p&&(a.adler=i(a.adler,f.pending_buf,f.pending-p,p)),$(a),p=f.pending,f.pending===f.pending_buf_size)){m=1;break}m=f.gzindex<f.gzhead.name.length?255&f.gzhead.name.charCodeAt(f.gzindex++):0,at(f,m)}while(0!==m);f.gzhead.hcrc&&f.pending>p&&(a.adler=i(a.adler,f.pending_buf,f.pending-p,p)),0===m&&(f.gzindex=0,f.status=L)}else f.status=L;if(f.status===L)if(f.gzhead.comment){p=f.pending;do{if(f.pending===f.pending_buf_size&&(f.gzhead.hcrc&&f.pending>p&&(a.adler=i(a.adler,f.pending_buf,f.pending-p,p)),$(a),p=f.pending,f.pending===f.pending_buf_size)){m=1;break}m=f.gzindex<f.gzhead.comment.length?255&f.gzhead.comment.charCodeAt(f.gzindex++):0,at(f,m)}while(0!==m);f.gzhead.hcrc&&f.pending>p&&(a.adler=i(a.adler,f.pending_buf,f.pending-p,p)),0===m&&(f.status=M)}else f.status=M;if(f.status===M&&(f.gzhead.hcrc?(f.pending+2>f.pending_buf_size&&$(a),f.pending+2<=f.pending_buf_size&&(at(f,255&a.adler),at(f,a.adler>>8&255),a.adler=0,f.status=O)):f.status=O),0!==f.pending){if($(a),0===a.avail_out)return f.last_flush=-1,o}else if(0===a.avail_in&&Y(s)<=Y(r)&&s!==_)return X(a,c);if(f.status===P&&0!==a.avail_in)return X(a,c);if(0!==a.avail_in||0!==f.lookahead||s!==n&&f.status!==P){var z=f.strategy===w?dt(f,s):f.strategy===v?_t(f,s):t[f.level].func(f,s);if(z!==U&&z!==V||(f.status=P),z===Q||z===U)return 0===a.avail_out&&(f.last_flush=-1),o;if(z===T&&(s===h?e._tr_align(f):s!==d&&(e._tr_stored_block(f,0,0,!1),s===l&&(Z(f.head),0===f.lookahead&&(f.strstart=0,f.block_start=0,f.insert=0))),$(a),0===a.avail_out))return f.last_flush=-1,o}return s!==_?o:f.wrap<=0?u:(2===f.wrap?(at(f,255&a.adler),at(f,a.adler>>8&255),at(f,a.adler>>16&255),at(f,a.adler>>24&255),at(f,255&a.total_in),at(f,a.total_in>>8&255),at(f,a.total_in>>16&255),at(f,a.total_in>>24&255)):(et(f,a.adler>>>16),et(f,65535&a.adler)),$(a),f.wrap>0&&(f.wrap=-f.wrap),0!==f.pending?o:u)}function kt(t){var a;return t&&t.state?(a=t.state.status)!==F&&a!==G&&a!==J&&a!==L&&a!==M&&a!==O&&a!==P?X(t,g):(t.state=null,a===O?X(t,f):o):g}function zt(t,e){var i,r,n,h,l,_,d,u,f=e.length;if(!t||!t.state)return g;if(2===(h=(i=t.state).wrap)||1===h&&i.status!==F||i.lookahead)return g;for(1===h&&(t.adler=s(t.adler,e,f,0)),i.wrap=0,f>=i.w_size&&(0===h&&(Z(i.head),i.strstart=0,i.block_start=0,i.insert=0),u=new a.Buf8(i.w_size),a.arraySet(u,e,f-i.w_size,i.w_size,0),e=u,f=i.w_size),l=t.avail_in,_=t.next_in,d=t.input,t.avail_in=f,t.next_in=0,t.input=e,rt(i);i.lookahead>=E;){r=i.strstart,n=i.lookahead-(E-1);do{i.ins_h=(i.ins_h<<i.hash_shift^i.window[r+E-1])&i.hash_mask,i.prev[r&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=r,r++}while(--n);i.strstart=r,i.lookahead=E-1,rt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=E-1,i.match_available=0,t.next_in=_,t.input=d,t.avail_in=l,i.wrap=h,o}t=[new ot(0,0,0,0,nt),new ot(4,4,8,4,ht),new ot(4,5,16,8,ht),new ot(4,6,32,32,ht),new ot(4,4,16,16,lt),new ot(8,16,32,32,lt),new ot(8,16,128,128,lt),new ot(8,32,128,256,lt),new ot(32,128,258,1024,lt),new ot(32,258,258,4096,lt)],exports.deflateInit=wt,exports.deflateInit2=mt,exports.deflateReset=ct,exports.deflateResetKeep=ft,exports.deflateSetHeader=pt,exports.deflate=vt,exports.deflateEnd=kt,exports.deflateSetDictionary=zt,exports.deflateInfo=\"pako deflate (from Nodeca project)\";\n},{\"../utils/common\":\"tbG5\",\"./trees\":\"+sRJ\",\"./adler32\":\"uxo6\",\"./crc32\":\"X4kj\",\"./messages\":\"gMAY\"}],\"34Q3\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./common\"),n=!0,t=!0;try{String.fromCharCode.apply(null,[0])}catch(u){n=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(u){t=!1}for(var e=new r.Buf8(256),o=0;o<256;o++)e[o]=o>=252?6:o>=248?5:o>=240?4:o>=224?3:o>=192?2:1;function f(e,o){if(o<65534&&(e.subarray&&t||!e.subarray&&n))return String.fromCharCode.apply(null,r.shrinkBuf(e,o));for(var f=\"\",u=0;u<o;u++)f+=String.fromCharCode(e[u]);return f}e[254]=e[254]=1,exports.string2buf=function(n){var t,e,o,f,u,a=n.length,i=0;for(f=0;f<a;f++)55296==(64512&(e=n.charCodeAt(f)))&&f+1<a&&56320==(64512&(o=n.charCodeAt(f+1)))&&(e=65536+(e-55296<<10)+(o-56320),f++),i+=e<128?1:e<2048?2:e<65536?3:4;for(t=new r.Buf8(i),u=0,f=0;u<i;f++)55296==(64512&(e=n.charCodeAt(f)))&&f+1<a&&56320==(64512&(o=n.charCodeAt(f+1)))&&(e=65536+(e-55296<<10)+(o-56320),f++),e<128?t[u++]=e:e<2048?(t[u++]=192|e>>>6,t[u++]=128|63&e):e<65536?(t[u++]=224|e>>>12,t[u++]=128|e>>>6&63,t[u++]=128|63&e):(t[u++]=240|e>>>18,t[u++]=128|e>>>12&63,t[u++]=128|e>>>6&63,t[u++]=128|63&e);return t},exports.buf2binstring=function(r){return f(r,r.length)},exports.binstring2buf=function(n){for(var t=new r.Buf8(n.length),e=0,o=t.length;e<o;e++)t[e]=n.charCodeAt(e);return t},exports.buf2string=function(r,n){var t,o,u,a,i=n||r.length,h=new Array(2*i);for(o=0,t=0;t<i;)if((u=r[t++])<128)h[o++]=u;else if((a=e[u])>4)h[o++]=65533,t+=a-1;else{for(u&=2===a?31:3===a?15:7;a>1&&t<i;)u=u<<6|63&r[t++],a--;a>1?h[o++]=65533:u<65536?h[o++]=u:(u-=65536,h[o++]=55296|u>>10&1023,h[o++]=56320|1023&u)}return f(h,o)},exports.utf8border=function(r,n){var t;for((n=n||r.length)>r.length&&(n=r.length),t=n-1;t>=0&&128==(192&r[t]);)t--;return t<0?n:0===t?n:t+e[r[t]]>n?t:n};\n},{\"./common\":\"tbG5\"}],\"bdtv\":[function(require,module,exports) {\n\"use strict\";function t(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0}module.exports=t;\n},{}],\"nFS2\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./zlib/deflate\"),i=require(\"./utils/common\"),e=require(\"./utils/strings\"),n=require(\"./zlib/messages\"),r=require(\"./zlib/zstream\"),s=Object.prototype.toString,o=0,a=4,u=0,h=1,d=2,l=-1,f=0,p=8;function w(o){if(!(this instanceof w))return new w(o);this.options=i.assign({level:l,method:p,chunkSize:16384,windowBits:15,memLevel:8,strategy:f,to:\"\"},o||{});var a=this.options;a.raw&&a.windowBits>0?a.windowBits=-a.windowBits:a.gzip&&a.windowBits>0&&a.windowBits<16&&(a.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new r,this.strm.avail_out=0;var h=t.deflateInit2(this.strm,a.level,a.method,a.windowBits,a.memLevel,a.strategy);if(h!==u)throw new Error(n[h]);if(a.header&&t.deflateSetHeader(this.strm,a.header),a.dictionary){var d;if(d=\"string\"==typeof a.dictionary?e.string2buf(a.dictionary):\"[object ArrayBuffer]\"===s.call(a.dictionary)?new Uint8Array(a.dictionary):a.dictionary,(h=t.deflateSetDictionary(this.strm,d))!==u)throw new Error(n[h]);this._dict_set=!0}}function c(t,i){var e=new w(i);if(e.push(t,!0),e.err)throw e.msg||n[e.err];return e.result}function m(t,i){return(i=i||{}).raw=!0,c(t,i)}function g(t,i){return(i=i||{}).gzip=!0,c(t,i)}w.prototype.push=function(n,r){var l,f,p=this.strm,w=this.options.chunkSize;if(this.ended)return!1;f=r===~~r?r:!0===r?a:o,\"string\"==typeof n?p.input=e.string2buf(n):\"[object ArrayBuffer]\"===s.call(n)?p.input=new Uint8Array(n):p.input=n,p.next_in=0,p.avail_in=p.input.length;do{if(0===p.avail_out&&(p.output=new i.Buf8(w),p.next_out=0,p.avail_out=w),(l=t.deflate(p,f))!==h&&l!==u)return this.onEnd(l),this.ended=!0,!1;0!==p.avail_out&&(0!==p.avail_in||f!==a&&f!==d)||(\"string\"===this.options.to?this.onData(e.buf2binstring(i.shrinkBuf(p.output,p.next_out))):this.onData(i.shrinkBuf(p.output,p.next_out)))}while((p.avail_in>0||0===p.avail_out)&&l!==h);return f===a?(l=t.deflateEnd(this.strm),this.onEnd(l),this.ended=!0,l===u):f!==d||(this.onEnd(u),p.avail_out=0,!0)},w.prototype.onData=function(t){this.chunks.push(t)},w.prototype.onEnd=function(t){t===u&&(\"string\"===this.options.to?this.result=this.chunks.join(\"\"):this.result=i.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},exports.Deflate=w,exports.deflate=c,exports.deflateRaw=m,exports.gzip=g;\n},{\"./zlib/deflate\":\"+BLB\",\"./utils/common\":\"tbG5\",\"./utils/strings\":\"34Q3\",\"./zlib/messages\":\"gMAY\",\"./zlib/zstream\":\"bdtv\"}],\"LP5M\":[function(require,module,exports) {\n\"use strict\";var i=30,e=12;module.exports=function(o,a){var t,d,n,l,s,f,r,b,c,u,v,m,w,h,k,_,x,g,p,z,j,q,y,A,B;t=o.state,d=o.next_in,A=o.input,n=d+(o.avail_in-5),l=o.next_out,B=o.output,s=l-(a-o.avail_out),f=l+(o.avail_out-257),r=t.dmax,b=t.wsize,c=t.whave,u=t.wnext,v=t.window,m=t.hold,w=t.bits,h=t.lencode,k=t.distcode,_=(1<<t.lenbits)-1,x=(1<<t.distbits)-1;i:do{w<15&&(m+=A[d++]<<w,w+=8,m+=A[d++]<<w,w+=8),g=h[m&_];e:for(;;){if(m>>>=p=g>>>24,w-=p,0===(p=g>>>16&255))B[l++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=h[(65535&g)+(m&(1<<p)-1)];continue e}if(32&p){t.mode=e;break i}o.msg=\"invalid literal/length code\",t.mode=i;break i}z=65535&g,(p&=15)&&(w<p&&(m+=A[d++]<<w,w+=8),z+=m&(1<<p)-1,m>>>=p,w-=p),w<15&&(m+=A[d++]<<w,w+=8,m+=A[d++]<<w,w+=8),g=k[m&x];o:for(;;){if(m>>>=p=g>>>24,w-=p,!(16&(p=g>>>16&255))){if(0==(64&p)){g=k[(65535&g)+(m&(1<<p)-1)];continue o}o.msg=\"invalid distance code\",t.mode=i;break i}if(j=65535&g,w<(p&=15)&&(m+=A[d++]<<w,(w+=8)<p&&(m+=A[d++]<<w,w+=8)),(j+=m&(1<<p)-1)>r){o.msg=\"invalid distance too far back\",t.mode=i;break i}if(m>>>=p,w-=p,j>(p=l-s)){if((p=j-p)>c&&t.sane){o.msg=\"invalid distance too far back\",t.mode=i;break i}if(q=0,y=v,0===u){if(q+=b-p,p<z){z-=p;do{B[l++]=v[q++]}while(--p);q=l-j,y=B}}else if(u<p){if(q+=b+u-p,(p-=u)<z){z-=p;do{B[l++]=v[q++]}while(--p);if(q=0,u<z){z-=p=u;do{B[l++]=v[q++]}while(--p);q=l-j,y=B}}}else if(q+=u-p,p<z){z-=p;do{B[l++]=v[q++]}while(--p);q=l-j,y=B}for(;z>2;)B[l++]=y[q++],B[l++]=y[q++],B[l++]=y[q++],z-=3;z&&(B[l++]=y[q++],z>1&&(B[l++]=y[q++]))}else{q=l-j;do{B[l++]=B[q++],B[l++]=B[q++],B[l++]=B[q++],z-=3}while(z>2);z&&(B[l++]=B[q++],z>1&&(B[l++]=B[q++]))}break}}break}}while(d<n&&l<f);d-=z=w>>3,m&=(1<<(w-=z<<3))-1,o.next_in=d,o.next_out=l,o.avail_in=d<n?n-d+5:5-(d-n),o.avail_out=l<f?f-l+257:257-(l-f),t.hold=m,t.bits=w};\n},{}],\"2u+n\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../utils/common\"),f=15,i=852,o=592,e=0,u=1,t=2,n=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],l=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],s=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],b=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];module.exports=function(a,c,m,w,d,v,B,h){var k,p,q,x,g,j,y,z,A,C=h.bits,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=null,O=0,P=new r.Buf16(f+1),Q=new r.Buf16(f+1),R=null,S=0;for(D=0;D<=f;D++)P[D]=0;for(E=0;E<w;E++)P[c[m+E]]++;for(H=C,G=f;G>=1&&0===P[G];G--);if(H>G&&(H=G),0===G)return d[v++]=20971520,d[v++]=20971520,h.bits=1,0;for(F=1;F<G&&0===P[F];F++);for(H<F&&(H=F),K=1,D=1;D<=f;D++)if(K<<=1,(K-=P[D])<0)return-1;if(K>0&&(a===e||1!==G))return-1;for(Q[1]=0,D=1;D<f;D++)Q[D+1]=Q[D]+P[D];for(E=0;E<w;E++)0!==c[m+E]&&(B[Q[c[m+E]]++]=E);if(a===e?(N=R=B,j=19):a===u?(N=n,O-=257,R=l,S-=257,j=256):(N=s,R=b,j=-1),M=0,E=0,D=F,g=v,I=H,J=0,q=-1,x=(L=1<<H)-1,a===u&&L>i||a===t&&L>o)return 1;for(;;){y=D-J,B[E]<j?(z=0,A=B[E]):B[E]>j?(z=R[S+B[E]],A=N[O+B[E]]):(z=96,A=0),k=1<<D-J,F=p=1<<I;do{d[g+(M>>J)+(p-=k)]=y<<24|z<<16|A|0}while(0!==p);for(k=1<<D-1;M&k;)k>>=1;if(0!==k?(M&=k-1,M+=k):M=0,E++,0==--P[D]){if(D===G)break;D=c[m+B[E]]}if(D>H&&(M&x)!==q){for(0===J&&(J=H),g+=F,K=1<<(I=D-J);I+J<G&&!((K-=P[I+J])<=0);)I++,K<<=1;if(L+=1<<I,a===u&&L>i||a===t&&L>o)return 1;d[q=M&x]=H<<24|I<<16|g-v|0}}return 0!==M&&(d[g+M]=D-J<<24|64<<16|0),h.bits=H,0};\n},{\"../utils/common\":\"tbG5\"}],\"GIDK\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils/common\"),a=require(\"./adler32\"),t=require(\"./crc32\"),i=require(\"./inffast\"),s=require(\"./inftrees\"),n=0,r=1,o=2,d=4,l=5,f=6,c=0,h=1,k=2,b=-2,m=-3,w=-4,u=-5,g=8,v=1,x=2,p=3,_=4,y=5,z=6,B=7,S=8,q=9,C=10,I=11,R=12,j=13,A=14,D=15,E=16,G=17,H=18,K=19,N=20,F=21,J=22,L=23,M=24,O=25,P=26,Q=27,T=28,U=29,V=30,W=31,X=32,Y=852,Z=592,$=15,ee=$;function ae(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function te(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new e.Buf16(320),this.work=new e.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function ie(a){var t;return a&&a.state?(t=a.state,a.total_in=a.total_out=t.total=0,a.msg=\"\",t.wrap&&(a.adler=1&t.wrap),t.mode=v,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new e.Buf32(Y),t.distcode=t.distdyn=new e.Buf32(Z),t.sane=1,t.back=-1,c):b}function se(e){var a;return e&&e.state?((a=e.state).wsize=0,a.whave=0,a.wnext=0,ie(e)):b}function ne(e,a){var t,i;return e&&e.state?(i=e.state,a<0?(t=0,a=-a):(t=1+(a>>4),a<48&&(a&=15)),a&&(a<8||a>15)?b:(null!==i.window&&i.wbits!==a&&(i.window=null),i.wrap=t,i.wbits=a,se(e))):b}function re(e,a){var t,i;return e?(i=new te,e.state=i,i.window=null,(t=ne(e,a))!==c&&(e.state=null),t):b}function oe(e){return re(e,ee)}var de,le,fe=!0;function ce(a){if(fe){var t;for(de=new e.Buf32(512),le=new e.Buf32(32),t=0;t<144;)a.lens[t++]=8;for(;t<256;)a.lens[t++]=9;for(;t<280;)a.lens[t++]=7;for(;t<288;)a.lens[t++]=8;for(s(r,a.lens,0,288,de,0,a.work,{bits:9}),t=0;t<32;)a.lens[t++]=5;s(o,a.lens,0,32,le,0,a.work,{bits:5}),fe=!1}a.lencode=de,a.lenbits=9,a.distcode=le,a.distbits=5}function he(a,t,i,s){var n,r=a.state;return null===r.window&&(r.wsize=1<<r.wbits,r.wnext=0,r.whave=0,r.window=new e.Buf8(r.wsize)),s>=r.wsize?(e.arraySet(r.window,t,i-r.wsize,r.wsize,0),r.wnext=0,r.whave=r.wsize):((n=r.wsize-r.wnext)>s&&(n=s),e.arraySet(r.window,t,i-s,n,r.wnext),(s-=n)?(e.arraySet(r.window,t,i-s,s,0),r.wnext=s,r.whave=r.wsize):(r.wnext+=n,r.wnext===r.wsize&&(r.wnext=0),r.whave<r.wsize&&(r.whave+=n))),0}function ke(Y,Z){var $,ee,te,ie,se,ne,re,oe,de,le,fe,ke,be,me,we,ue,ge,ve,xe,pe,_e,ye,ze,Be,Se=0,qe=new e.Buf8(4),Ce=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!Y||!Y.state||!Y.output||!Y.input&&0!==Y.avail_in)return b;($=Y.state).mode===R&&($.mode=j),se=Y.next_out,te=Y.output,re=Y.avail_out,ie=Y.next_in,ee=Y.input,ne=Y.avail_in,oe=$.hold,de=$.bits,le=ne,fe=re,ye=c;e:for(;;)switch($.mode){case v:if(0===$.wrap){$.mode=j;break}for(;de<16;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if(2&$.wrap&&35615===oe){$.check=0,qe[0]=255&oe,qe[1]=oe>>>8&255,$.check=t($.check,qe,2,0),oe=0,de=0,$.mode=x;break}if($.flags=0,$.head&&($.head.done=!1),!(1&$.wrap)||(((255&oe)<<8)+(oe>>8))%31){Y.msg=\"incorrect header check\",$.mode=V;break}if((15&oe)!==g){Y.msg=\"unknown compression method\",$.mode=V;break}if(de-=4,_e=8+(15&(oe>>>=4)),0===$.wbits)$.wbits=_e;else if(_e>$.wbits){Y.msg=\"invalid window size\",$.mode=V;break}$.dmax=1<<_e,Y.adler=$.check=1,$.mode=512&oe?C:R,oe=0,de=0;break;case x:for(;de<16;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if($.flags=oe,(255&$.flags)!==g){Y.msg=\"unknown compression method\",$.mode=V;break}if(57344&$.flags){Y.msg=\"unknown header flags set\",$.mode=V;break}$.head&&($.head.text=oe>>8&1),512&$.flags&&(qe[0]=255&oe,qe[1]=oe>>>8&255,$.check=t($.check,qe,2,0)),oe=0,de=0,$.mode=p;case p:for(;de<32;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}$.head&&($.head.time=oe),512&$.flags&&(qe[0]=255&oe,qe[1]=oe>>>8&255,qe[2]=oe>>>16&255,qe[3]=oe>>>24&255,$.check=t($.check,qe,4,0)),oe=0,de=0,$.mode=_;case _:for(;de<16;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}$.head&&($.head.xflags=255&oe,$.head.os=oe>>8),512&$.flags&&(qe[0]=255&oe,qe[1]=oe>>>8&255,$.check=t($.check,qe,2,0)),oe=0,de=0,$.mode=y;case y:if(1024&$.flags){for(;de<16;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}$.length=oe,$.head&&($.head.extra_len=oe),512&$.flags&&(qe[0]=255&oe,qe[1]=oe>>>8&255,$.check=t($.check,qe,2,0)),oe=0,de=0}else $.head&&($.head.extra=null);$.mode=z;case z:if(1024&$.flags&&((ke=$.length)>ne&&(ke=ne),ke&&($.head&&(_e=$.head.extra_len-$.length,$.head.extra||($.head.extra=new Array($.head.extra_len)),e.arraySet($.head.extra,ee,ie,ke,_e)),512&$.flags&&($.check=t($.check,ee,ke,ie)),ne-=ke,ie+=ke,$.length-=ke),$.length))break e;$.length=0,$.mode=B;case B:if(2048&$.flags){if(0===ne)break e;ke=0;do{_e=ee[ie+ke++],$.head&&_e&&$.length<65536&&($.head.name+=String.fromCharCode(_e))}while(_e&&ke<ne);if(512&$.flags&&($.check=t($.check,ee,ke,ie)),ne-=ke,ie+=ke,_e)break e}else $.head&&($.head.name=null);$.length=0,$.mode=S;case S:if(4096&$.flags){if(0===ne)break e;ke=0;do{_e=ee[ie+ke++],$.head&&_e&&$.length<65536&&($.head.comment+=String.fromCharCode(_e))}while(_e&&ke<ne);if(512&$.flags&&($.check=t($.check,ee,ke,ie)),ne-=ke,ie+=ke,_e)break e}else $.head&&($.head.comment=null);$.mode=q;case q:if(512&$.flags){for(;de<16;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if(oe!==(65535&$.check)){Y.msg=\"header crc mismatch\",$.mode=V;break}oe=0,de=0}$.head&&($.head.hcrc=$.flags>>9&1,$.head.done=!0),Y.adler=$.check=0,$.mode=R;break;case C:for(;de<32;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}Y.adler=$.check=ae(oe),oe=0,de=0,$.mode=I;case I:if(0===$.havedict)return Y.next_out=se,Y.avail_out=re,Y.next_in=ie,Y.avail_in=ne,$.hold=oe,$.bits=de,k;Y.adler=$.check=1,$.mode=R;case R:if(Z===l||Z===f)break e;case j:if($.last){oe>>>=7&de,de-=7&de,$.mode=Q;break}for(;de<3;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}switch($.last=1&oe,de-=1,3&(oe>>>=1)){case 0:$.mode=A;break;case 1:if(ce($),$.mode=N,Z===f){oe>>>=2,de-=2;break e}break;case 2:$.mode=G;break;case 3:Y.msg=\"invalid block type\",$.mode=V}oe>>>=2,de-=2;break;case A:for(oe>>>=7&de,de-=7&de;de<32;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if((65535&oe)!=(oe>>>16^65535)){Y.msg=\"invalid stored block lengths\",$.mode=V;break}if($.length=65535&oe,oe=0,de=0,$.mode=D,Z===f)break e;case D:$.mode=E;case E:if(ke=$.length){if(ke>ne&&(ke=ne),ke>re&&(ke=re),0===ke)break e;e.arraySet(te,ee,ie,ke,se),ne-=ke,ie+=ke,re-=ke,se+=ke,$.length-=ke;break}$.mode=R;break;case G:for(;de<14;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if($.nlen=257+(31&oe),oe>>>=5,de-=5,$.ndist=1+(31&oe),oe>>>=5,de-=5,$.ncode=4+(15&oe),oe>>>=4,de-=4,$.nlen>286||$.ndist>30){Y.msg=\"too many length or distance symbols\",$.mode=V;break}$.have=0,$.mode=H;case H:for(;$.have<$.ncode;){for(;de<3;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}$.lens[Ce[$.have++]]=7&oe,oe>>>=3,de-=3}for(;$.have<19;)$.lens[Ce[$.have++]]=0;if($.lencode=$.lendyn,$.lenbits=7,ze={bits:$.lenbits},ye=s(n,$.lens,0,19,$.lencode,0,$.work,ze),$.lenbits=ze.bits,ye){Y.msg=\"invalid code lengths set\",$.mode=V;break}$.have=0,$.mode=K;case K:for(;$.have<$.nlen+$.ndist;){for(;ue=(Se=$.lencode[oe&(1<<$.lenbits)-1])>>>16&255,ge=65535&Se,!((we=Se>>>24)<=de);){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if(ge<16)oe>>>=we,de-=we,$.lens[$.have++]=ge;else{if(16===ge){for(Be=we+2;de<Be;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if(oe>>>=we,de-=we,0===$.have){Y.msg=\"invalid bit length repeat\",$.mode=V;break}_e=$.lens[$.have-1],ke=3+(3&oe),oe>>>=2,de-=2}else if(17===ge){for(Be=we+3;de<Be;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}de-=we,_e=0,ke=3+(7&(oe>>>=we)),oe>>>=3,de-=3}else{for(Be=we+7;de<Be;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}de-=we,_e=0,ke=11+(127&(oe>>>=we)),oe>>>=7,de-=7}if($.have+ke>$.nlen+$.ndist){Y.msg=\"invalid bit length repeat\",$.mode=V;break}for(;ke--;)$.lens[$.have++]=_e}}if($.mode===V)break;if(0===$.lens[256]){Y.msg=\"invalid code -- missing end-of-block\",$.mode=V;break}if($.lenbits=9,ze={bits:$.lenbits},ye=s(r,$.lens,0,$.nlen,$.lencode,0,$.work,ze),$.lenbits=ze.bits,ye){Y.msg=\"invalid literal/lengths set\",$.mode=V;break}if($.distbits=6,$.distcode=$.distdyn,ze={bits:$.distbits},ye=s(o,$.lens,$.nlen,$.ndist,$.distcode,0,$.work,ze),$.distbits=ze.bits,ye){Y.msg=\"invalid distances set\",$.mode=V;break}if($.mode=N,Z===f)break e;case N:$.mode=F;case F:if(ne>=6&&re>=258){Y.next_out=se,Y.avail_out=re,Y.next_in=ie,Y.avail_in=ne,$.hold=oe,$.bits=de,i(Y,fe),se=Y.next_out,te=Y.output,re=Y.avail_out,ie=Y.next_in,ee=Y.input,ne=Y.avail_in,oe=$.hold,de=$.bits,$.mode===R&&($.back=-1);break}for($.back=0;ue=(Se=$.lencode[oe&(1<<$.lenbits)-1])>>>16&255,ge=65535&Se,!((we=Se>>>24)<=de);){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if(ue&&0==(240&ue)){for(ve=we,xe=ue,pe=ge;ue=(Se=$.lencode[pe+((oe&(1<<ve+xe)-1)>>ve)])>>>16&255,ge=65535&Se,!(ve+(we=Se>>>24)<=de);){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}oe>>>=ve,de-=ve,$.back+=ve}if(oe>>>=we,de-=we,$.back+=we,$.length=ge,0===ue){$.mode=P;break}if(32&ue){$.back=-1,$.mode=R;break}if(64&ue){Y.msg=\"invalid literal/length code\",$.mode=V;break}$.extra=15&ue,$.mode=J;case J:if($.extra){for(Be=$.extra;de<Be;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}$.length+=oe&(1<<$.extra)-1,oe>>>=$.extra,de-=$.extra,$.back+=$.extra}$.was=$.length,$.mode=L;case L:for(;ue=(Se=$.distcode[oe&(1<<$.distbits)-1])>>>16&255,ge=65535&Se,!((we=Se>>>24)<=de);){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if(0==(240&ue)){for(ve=we,xe=ue,pe=ge;ue=(Se=$.distcode[pe+((oe&(1<<ve+xe)-1)>>ve)])>>>16&255,ge=65535&Se,!(ve+(we=Se>>>24)<=de);){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}oe>>>=ve,de-=ve,$.back+=ve}if(oe>>>=we,de-=we,$.back+=we,64&ue){Y.msg=\"invalid distance code\",$.mode=V;break}$.offset=ge,$.extra=15&ue,$.mode=M;case M:if($.extra){for(Be=$.extra;de<Be;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}$.offset+=oe&(1<<$.extra)-1,oe>>>=$.extra,de-=$.extra,$.back+=$.extra}if($.offset>$.dmax){Y.msg=\"invalid distance too far back\",$.mode=V;break}$.mode=O;case O:if(0===re)break e;if(ke=fe-re,$.offset>ke){if((ke=$.offset-ke)>$.whave&&$.sane){Y.msg=\"invalid distance too far back\",$.mode=V;break}ke>$.wnext?(ke-=$.wnext,be=$.wsize-ke):be=$.wnext-ke,ke>$.length&&(ke=$.length),me=$.window}else me=te,be=se-$.offset,ke=$.length;ke>re&&(ke=re),re-=ke,$.length-=ke;do{te[se++]=me[be++]}while(--ke);0===$.length&&($.mode=F);break;case P:if(0===re)break e;te[se++]=$.length,re--,$.mode=F;break;case Q:if($.wrap){for(;de<32;){if(0===ne)break e;ne--,oe|=ee[ie++]<<de,de+=8}if(fe-=re,Y.total_out+=fe,$.total+=fe,fe&&(Y.adler=$.check=$.flags?t($.check,te,fe,se-fe):a($.check,te,fe,se-fe)),fe=re,($.flags?oe:ae(oe))!==$.check){Y.msg=\"incorrect data check\",$.mode=V;break}oe=0,de=0}$.mode=T;case T:if($.wrap&&$.flags){for(;de<32;){if(0===ne)break e;ne--,oe+=ee[ie++]<<de,de+=8}if(oe!==(4294967295&$.total)){Y.msg=\"incorrect length check\",$.mode=V;break}oe=0,de=0}$.mode=U;case U:ye=h;break e;case V:ye=m;break e;case W:return w;case X:default:return b}return Y.next_out=se,Y.avail_out=re,Y.next_in=ie,Y.avail_in=ne,$.hold=oe,$.bits=de,($.wsize||fe!==Y.avail_out&&$.mode<V&&($.mode<Q||Z!==d))&&he(Y,Y.output,Y.next_out,fe-Y.avail_out)?($.mode=W,w):(le-=Y.avail_in,fe-=Y.avail_out,Y.total_in+=le,Y.total_out+=fe,$.total+=fe,$.wrap&&fe&&(Y.adler=$.check=$.flags?t($.check,te,fe,Y.next_out-fe):a($.check,te,fe,Y.next_out-fe)),Y.data_type=$.bits+($.last?64:0)+($.mode===R?128:0)+($.mode===N||$.mode===D?256:0),(0===le&&0===fe||Z===d)&&ye===c&&(ye=u),ye)}function be(e){if(!e||!e.state)return b;var a=e.state;return a.window&&(a.window=null),e.state=null,c}function me(e,a){var t;return e&&e.state?0==(2&(t=e.state).wrap)?b:(t.head=a,a.done=!1,c):b}function we(e,t){var i,s=t.length;return e&&e.state?0!==(i=e.state).wrap&&i.mode!==I?b:i.mode===I&&a(1,t,s,0)!==i.check?m:he(e,t,s,s)?(i.mode=W,w):(i.havedict=1,c):b}exports.inflateReset=se,exports.inflateReset2=ne,exports.inflateResetKeep=ie,exports.inflateInit=oe,exports.inflateInit2=re,exports.inflate=ke,exports.inflateEnd=be,exports.inflateGetHeader=me,exports.inflateSetDictionary=we,exports.inflateInfo=\"pako inflate (from Nodeca project)\";\n},{\"../utils/common\":\"tbG5\",\"./adler32\":\"uxo6\",\"./crc32\":\"X4kj\",\"./inffast\":\"LP5M\",\"./inftrees\":\"2u+n\"}],\"xUUw\":[function(require,module,exports) {\n\"use strict\";module.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};\n},{}],\"/+WI\":[function(require,module,exports) {\n\"use strict\";function t(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name=\"\",this.comment=\"\",this.hcrc=0,this.done=!1}module.exports=t;\n},{}],\"faQk\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./zlib/inflate\"),i=require(\"./utils/common\"),n=require(\"./utils/strings\"),r=require(\"./zlib/constants\"),s=require(\"./zlib/messages\"),o=require(\"./zlib/zstream\"),e=require(\"./zlib/gzheader\"),a=Object.prototype.toString;function u(h){if(!(this instanceof u))return new u(h);this.options=i.assign({chunkSize:16384,windowBits:0,to:\"\"},h||{});var _=this.options;_.raw&&_.windowBits>=0&&_.windowBits<16&&(_.windowBits=-_.windowBits,0===_.windowBits&&(_.windowBits=-15)),!(_.windowBits>=0&&_.windowBits<16)||h&&h.windowBits||(_.windowBits+=32),_.windowBits>15&&_.windowBits<48&&0==(15&_.windowBits)&&(_.windowBits|=15),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new o,this.strm.avail_out=0;var w=t.inflateInit2(this.strm,_.windowBits);if(w!==r.Z_OK)throw new Error(s[w]);if(this.header=new e,t.inflateGetHeader(this.strm,this.header),_.dictionary&&(\"string\"==typeof _.dictionary?_.dictionary=n.string2buf(_.dictionary):\"[object ArrayBuffer]\"===a.call(_.dictionary)&&(_.dictionary=new Uint8Array(_.dictionary)),_.raw&&(w=t.inflateSetDictionary(this.strm,_.dictionary))!==r.Z_OK))throw new Error(s[w])}function h(t,i){var n=new u(i);if(n.push(t,!0),n.err)throw n.msg||s[n.err];return n.result}function _(t,i){return(i=i||{}).raw=!0,h(t,i)}u.prototype.push=function(s,o){var e,u,h,_,w,d=this.strm,l=this.options.chunkSize,f=this.options.dictionary,p=!1;if(this.ended)return!1;u=o===~~o?o:!0===o?r.Z_FINISH:r.Z_NO_FLUSH,\"string\"==typeof s?d.input=n.binstring2buf(s):\"[object ArrayBuffer]\"===a.call(s)?d.input=new Uint8Array(s):d.input=s,d.next_in=0,d.avail_in=d.input.length;do{if(0===d.avail_out&&(d.output=new i.Buf8(l),d.next_out=0,d.avail_out=l),(e=t.inflate(d,r.Z_NO_FLUSH))===r.Z_NEED_DICT&&f&&(e=t.inflateSetDictionary(this.strm,f)),e===r.Z_BUF_ERROR&&!0===p&&(e=r.Z_OK,p=!1),e!==r.Z_STREAM_END&&e!==r.Z_OK)return this.onEnd(e),this.ended=!0,!1;d.next_out&&(0!==d.avail_out&&e!==r.Z_STREAM_END&&(0!==d.avail_in||u!==r.Z_FINISH&&u!==r.Z_SYNC_FLUSH)||(\"string\"===this.options.to?(h=n.utf8border(d.output,d.next_out),_=d.next_out-h,w=n.buf2string(d.output,h),d.next_out=_,d.avail_out=l-_,_&&i.arraySet(d.output,d.output,h,_,0),this.onData(w)):this.onData(i.shrinkBuf(d.output,d.next_out)))),0===d.avail_in&&0===d.avail_out&&(p=!0)}while((d.avail_in>0||0===d.avail_out)&&e!==r.Z_STREAM_END);return e===r.Z_STREAM_END&&(u=r.Z_FINISH),u===r.Z_FINISH?(e=t.inflateEnd(this.strm),this.onEnd(e),this.ended=!0,e===r.Z_OK):u!==r.Z_SYNC_FLUSH||(this.onEnd(r.Z_OK),d.avail_out=0,!0)},u.prototype.onData=function(t){this.chunks.push(t)},u.prototype.onEnd=function(t){t===r.Z_OK&&(\"string\"===this.options.to?this.result=this.chunks.join(\"\"):this.result=i.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},exports.Inflate=u,exports.inflate=h,exports.inflateRaw=_,exports.ungzip=h;\n},{\"./zlib/inflate\":\"GIDK\",\"./utils/common\":\"tbG5\",\"./utils/strings\":\"34Q3\",\"./zlib/constants\":\"xUUw\",\"./zlib/messages\":\"gMAY\",\"./zlib/zstream\":\"bdtv\",\"./zlib/gzheader\":\"/+WI\"}],\"f4vO\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./lib/utils/common\").assign,i=require(\"./lib/deflate\"),r=require(\"./lib/inflate\"),l=require(\"./lib/zlib/constants\"),s={};e(s,i,r,l),module.exports=s;\n},{\"./lib/utils/common\":\"tbG5\",\"./lib/deflate\":\"nFS2\",\"./lib/inflate\":\"faQk\",\"./lib/zlib/constants\":\"xUUw\"}],\"jK/d\":[function(require,module,exports) {\n\"use strict\";var t=\"undefined\"!=typeof Uint8Array&&\"undefined\"!=typeof Uint16Array&&\"undefined\"!=typeof Uint32Array,e=require(\"pako\"),r=require(\"./utils\"),n=require(\"./stream/GenericWorker\"),o=t?\"uint8array\":\"array\";function a(t,r){n.call(this,\"FlateWorker/\"+t),this._pako=new e[t]({raw:!0,level:r.level||-1}),this.meta={};var o=this;this._pako.onData=function(t){o.push({data:t,meta:o.meta})}}exports.magic=\"\\b\\0\",r.inherits(a,n),a.prototype.processChunk=function(t){this.meta=t.meta,this._pako.push(r.transformTo(o,t.data),!1)},a.prototype.flush=function(){n.prototype.flush.call(this),this._pako.push([],!0)},a.prototype.cleanUp=function(){n.prototype.cleanUp.call(this),this._pako=null},exports.compressWorker=function(t){return new a(\"Deflate\",t)},exports.uncompressWorker=function(){return new a(\"Inflate\",{})};\n},{\"pako\":\"f4vO\",\"./utils\":\"rWOW\",\"./stream/GenericWorker\":\"g8b7\"}],\"K5d+\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./stream/GenericWorker\");exports.STORE={magic:\"\\0\\0\",compressWorker:function(e){return new r(\"STORE compression\")},uncompressWorker:function(){return new r(\"STORE decompression\")}},exports.DEFLATE=require(\"./flate\");\n},{\"./stream/GenericWorker\":\"g8b7\",\"./flate\":\"jK/d\"}],\"Mgtb\":[function(require,module,exports) {\n\"use strict\";exports.LOCAL_FILE_HEADER=\"PK\u0003\u0004\",exports.CENTRAL_FILE_HEADER=\"PK\u0001\u0002\",exports.CENTRAL_DIRECTORY_END=\"PK\u0005\u0006\",exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR=\"PK\u0006\u0007\",exports.ZIP64_CENTRAL_DIRECTORY_END=\"PK\u0006\u0006\",exports.DATA_DESCRIPTOR=\"PK\u0007\\b\";\n},{}],\"kSM5\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils\"),t=require(\"../stream/GenericWorker\"),r=require(\"../utf8\"),s=require(\"../crc32\"),i=require(\"../signature\"),o=function(e,t){var r,s=\"\";for(r=0;r<t;r++)s+=String.fromCharCode(255&e),e>>>=8;return s},n=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16},c=function(e,t){return 63&(e||0)},u=function(t,u,h,a,p,l){var f,d,m=t.file,g=t.compression,v=l!==r.utf8encode,S=e.transformTo(\"string\",l(m.name)),y=e.transformTo(\"string\",r.utf8encode(m.name)),C=m.comment,R=e.transformTo(\"string\",l(C)),F=e.transformTo(\"string\",r.utf8encode(C)),T=y.length!==m.name.length,_=F.length!==C.length,z=\"\",E=\"\",N=\"\",P=m.dir,A=m.date,D={crc32:0,compressedSize:0,uncompressedSize:0};u&&!h||(D.crc32=t.crc32,D.compressedSize=t.compressedSize,D.uncompressedSize=t.uncompressedSize);var I=0;u&&(I|=8),v||!T&&!_||(I|=2048);var O=0,U=0;P&&(O|=16),\"UNIX\"===p?(U=798,O|=n(m.unixPermissions,P)):(U=20,O|=c(m.dosPermissions,P)),f=A.getUTCHours(),f<<=6,f|=A.getUTCMinutes(),f<<=5,f|=A.getUTCSeconds()/2,d=A.getUTCFullYear()-1980,d<<=4,d|=A.getUTCMonth()+1,d<<=5,d|=A.getUTCDate(),T&&(E=o(1,1)+o(s(S),4)+y,z+=\"up\"+o(E.length,2)+E),_&&(N=o(1,1)+o(s(R),4)+F,z+=\"uc\"+o(N.length,2)+N);var W=\"\";return W+=\"\\n\\0\",W+=o(I,2),W+=g.magic,W+=o(f,2),W+=o(d,2),W+=o(D.crc32,4),W+=o(D.compressedSize,4),W+=o(D.uncompressedSize,4),W+=o(S.length,2),W+=o(z.length,2),{fileRecord:i.LOCAL_FILE_HEADER+W+S+z,dirRecord:i.CENTRAL_FILE_HEADER+o(U,2)+W+o(R.length,2)+\"\\0\\0\\0\\0\"+o(O,4)+o(a,4)+S+z+R}},h=function(t,r,s,n,c){var u=e.transformTo(\"string\",c(n));return i.CENTRAL_DIRECTORY_END+\"\\0\\0\\0\\0\"+o(t,2)+o(t,2)+o(r,4)+o(s,4)+o(u.length,2)+u},a=function(e){return i.DATA_DESCRIPTOR+o(e.crc32,4)+o(e.compressedSize,4)+o(e.uncompressedSize,4)};function p(e,r,s,i){t.call(this,\"ZipFileWorker\"),this.bytesWritten=0,this.zipComment=r,this.zipPlatform=s,this.encodeFileName=i,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}e.inherits(p,t),p.prototype.push=function(e){var r=e.meta.percent||0,s=this.entriesCount,i=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,t.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:s?(r+100*(s-i-1))/s:100}}))},p.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=u(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},p.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=u(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:a(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},p.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,s=h(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:s,meta:{percent:100}})},p.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},p.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on(\"data\",function(e){t.processChunk(e)}),e.on(\"end\",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on(\"error\",function(e){t.error(e)}),this},p.prototype.resume=function(){return!!t.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},p.prototype.error=function(e){var r=this._sources;if(!t.prototype.error.call(this,e))return!1;for(var s=0;s<r.length;s++)try{r[s].error(e)}catch(e){}return!0},p.prototype.lock=function(){t.prototype.lock.call(this);for(var e=this._sources,r=0;r<e.length;r++)e[r].lock()},module.exports=p;\n},{\"../utils\":\"rWOW\",\"../stream/GenericWorker\":\"g8b7\",\"../utf8\":\"JJJK\",\"../crc32\":\"4G8U\",\"../signature\":\"Mgtb\"}],\"zlJZ\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../compressions\"),e=require(\"./ZipFileWorker\"),o=function(e,o){var s=e||o,i=r[s];if(!i)throw new Error(s+\" is not a valid compression method !\");return i};exports.generateWorker=function(r,s,i){var n=new e(s.streamFiles,i,s.platform,s.encodeFileName),t=0;try{r.forEach(function(r,e){t++;var i=o(e.options.compression,s.compression),m=e.options.compressionOptions||s.compressionOptions||{},c=e.dir,a=e.date;e._compressWorker(i,m).withStreamInfo(\"file\",{name:r,dir:c,date:a,comment:e.comment||\"\",unixPermissions:e.unixPermissions,dosPermissions:e.dosPermissions}).pipe(n)}),n.entriesCount=t}catch(m){n.error(m)}return n};\n},{\"../compressions\":\"K5d+\",\"./ZipFileWorker\":\"kSM5\"}],\"N8Ig\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../utils\"),t=require(\"../stream/GenericWorker\");function r(e,r){t.call(this,\"Nodejs stream input adapter for \"+e),this._upstreamEnded=!1,this._bindStream(r)}e.inherits(r,t),r.prototype._bindStream=function(e){var t=this;this._stream=e,e.pause(),e.on(\"data\",function(e){t.push({data:e,meta:{percent:0}})}).on(\"error\",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on(\"end\",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},r.prototype.pause=function(){return!!t.prototype.pause.call(this)&&(this._stream.pause(),!0)},r.prototype.resume=function(){return!!t.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},module.exports=r;\n},{\"../utils\":\"rWOW\",\"../stream/GenericWorker\":\"g8b7\"}],\"HN8/\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./utf8\"),r=require(\"./utils\"),t=require(\"./stream/GenericWorker\"),i=require(\"./stream/StreamHelper\"),n=require(\"./defaults\"),s=require(\"./compressedObject\"),o=require(\"./zipObject\"),a=require(\"./generate\"),l=require(\"./nodejsUtils\"),u=require(\"./nodejs/NodejsStreamInputAdapter\"),c=function(e,i,a){var c,m=r.getTypeOf(i),d=r.extend(a||{},n);d.date=d.date||new Date,null!==d.compression&&(d.compression=d.compression.toUpperCase()),\"string\"==typeof d.unixPermissions&&(d.unixPermissions=parseInt(d.unixPermissions,8)),d.unixPermissions&&16384&d.unixPermissions&&(d.dir=!0),d.dosPermissions&&16&d.dosPermissions&&(d.dir=!0),d.dir&&(e=p(e)),d.createFolders&&(c=f(e))&&h.call(this,c,!0);var g=\"string\"===m&&!1===d.binary&&!1===d.base64;a&&void 0!==a.binary||(d.binary=!g),(i instanceof s&&0===i.uncompressedSize||d.dir||!i||0===i.length)&&(d.base64=!1,d.binary=!0,i=\"\",d.compression=\"STORE\",m=\"string\");var y=null;y=i instanceof s||i instanceof t?i:l.isNode&&l.isStream(i)?new u(e,i):r.prepareContent(e,i,d.binary,d.optimizedBinaryString,d.base64);var v=new o(e,y,d);this.files[e]=v},f=function(e){\"/\"===e.slice(-1)&&(e=e.substring(0,e.length-1));var r=e.lastIndexOf(\"/\");return r>0?e.substring(0,r):\"\"},p=function(e){return\"/\"!==e.slice(-1)&&(e+=\"/\"),e},h=function(e,r){return r=void 0!==r?r:n.createFolders,e=p(e),this.files[e]||c.call(this,e,null,{dir:!0,createFolders:r}),this.files[e]};function m(e){return\"[object RegExp]\"===Object.prototype.toString.call(e)}var d={load:function(){throw new Error(\"This method has been removed in JSZip 3.0, please check the upgrade guide.\")},forEach:function(e){var r,t,i;for(r in this.files)this.files.hasOwnProperty(r)&&(i=this.files[r],(t=r.slice(this.root.length,r.length))&&r.slice(0,this.root.length)===this.root&&e(t,i))},filter:function(e){var r=[];return this.forEach(function(t,i){e(t,i)&&r.push(i)}),r},file:function(e,r,t){if(1===arguments.length){if(m(e)){var i=e;return this.filter(function(e,r){return!r.dir&&i.test(e)})}var n=this.files[this.root+e];return n&&!n.dir?n:null}return e=this.root+e,c.call(this,e,r,t),this},folder:function(e){if(!e)return this;if(m(e))return this.filter(function(r,t){return t.dir&&e.test(r)});var r=this.root+e,t=h.call(this,r),i=this.clone();return i.root=t.name,i},remove:function(e){e=this.root+e;var r=this.files[e];if(r||(\"/\"!==e.slice(-1)&&(e+=\"/\"),r=this.files[e]),r&&!r.dir)delete this.files[e];else for(var t=this.filter(function(r,t){return t.name.slice(0,e.length)===e}),i=0;i<t.length;i++)delete this.files[t[i].name];return this},generate:function(e){throw new Error(\"This method has been removed in JSZip 3.0, please check the upgrade guide.\")},generateInternalStream:function(n){var s,o={};try{if((o=r.extend(n||{},{streamFiles:!1,compression:\"STORE\",compressionOptions:null,type:\"\",platform:\"DOS\",comment:null,mimeType:\"application/zip\",encodeFileName:e.utf8encode})).type=o.type.toLowerCase(),o.compression=o.compression.toUpperCase(),\"binarystring\"===o.type&&(o.type=\"string\"),!o.type)throw new Error(\"No output type specified.\");r.checkSupport(o.type),\"darwin\"!==o.platform&&\"freebsd\"!==o.platform&&\"linux\"!==o.platform&&\"sunos\"!==o.platform||(o.platform=\"UNIX\"),\"win32\"===o.platform&&(o.platform=\"DOS\");var l=o.comment||this.comment||\"\";s=a.generateWorker(this,o,l)}catch(u){(s=new t(\"error\")).error(u)}return new i(s,o.type||\"string\",o.mimeType)},generateAsync:function(e,r){return this.generateInternalStream(e).accumulate(r)},generateNodeStream:function(e,r){return(e=e||{}).type||(e.type=\"nodebuffer\"),this.generateInternalStream(e).toNodejsStream(r)}};module.exports=d;\n},{\"./utf8\":\"JJJK\",\"./utils\":\"rWOW\",\"./stream/GenericWorker\":\"g8b7\",\"./stream/StreamHelper\":\"0o9N\",\"./defaults\":\"f+tM\",\"./compressedObject\":\"NnFM\",\"./zipObject\":\"zqKV\",\"./generate\":\"zlJZ\",\"./nodejsUtils\":\"5Egw\",\"./nodejs/NodejsStreamInputAdapter\":\"N8Ig\"}],\"n3OH\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../utils\");function e(t){this.data=t,this.length=t.length,this.index=0,this.zero=0}e.prototype={checkOffset:function(t){this.checkIndex(this.index+t)},checkIndex:function(t){if(this.length<this.zero+t||t<0)throw new Error(\"End of data reached (data length = \"+this.length+\", asked index = \"+t+\"). Corrupted zip ?\")},setIndex:function(t){this.checkIndex(t),this.index=t},skip:function(t){this.setIndex(this.index+t)},byteAt:function(t){},readInt:function(t){var e,n=0;for(this.checkOffset(t),e=this.index+t-1;e>=this.index;e--)n=(n<<8)+this.byteAt(e);return this.index+=t,n},readString:function(e){return t.transformTo(\"string\",this.readData(e))},readData:function(t){},lastIndexOfSignature:function(t){},readAndCheckSignature:function(t){},readDate:function(){var t=this.readInt(4);return new Date(Date.UTC(1980+(t>>25&127),(t>>21&15)-1,t>>16&31,t>>11&31,t>>5&63,(31&t)<<1))}},module.exports=e;\n},{\"../utils\":\"rWOW\"}],\"Iqwn\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./DataReader\"),e=require(\"../utils\");function r(e){t.call(this,e);for(var r=0;r<this.data.length;r++)e[r]=255&e[r]}e.inherits(r,t),r.prototype.byteAt=function(t){return this.data[this.zero+t]},r.prototype.lastIndexOfSignature=function(t){for(var e=t.charCodeAt(0),r=t.charCodeAt(1),a=t.charCodeAt(2),i=t.charCodeAt(3),h=this.length-4;h>=0;--h)if(this.data[h]===e&&this.data[h+1]===r&&this.data[h+2]===a&&this.data[h+3]===i)return h-this.zero;return-1},r.prototype.readAndCheckSignature=function(t){var e=t.charCodeAt(0),r=t.charCodeAt(1),a=t.charCodeAt(2),i=t.charCodeAt(3),h=this.readData(4);return e===h[0]&&r===h[1]&&a===h[2]&&i===h[3]},r.prototype.readData=function(t){if(this.checkOffset(t),0===t)return[];var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},module.exports=r;\n},{\"./DataReader\":\"n3OH\",\"../utils\":\"rWOW\"}],\"HoJ6\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./DataReader\"),e=require(\"../utils\");function r(e){t.call(this,e)}e.inherits(r,t),r.prototype.byteAt=function(t){return this.data.charCodeAt(this.zero+t)},r.prototype.lastIndexOfSignature=function(t){return this.data.lastIndexOf(t)-this.zero},r.prototype.readAndCheckSignature=function(t){return t===this.readData(4)},r.prototype.readData=function(t){this.checkOffset(t);var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},module.exports=r;\n},{\"./DataReader\":\"n3OH\",\"../utils\":\"rWOW\"}],\"HzNe\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./ArrayReader\"),t=require(\"../utils\");function e(t){r.call(this,t)}t.inherits(e,r),e.prototype.readData=function(r){if(this.checkOffset(r),0===r)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+r);return this.index+=r,t},module.exports=e;\n},{\"./ArrayReader\":\"Iqwn\",\"../utils\":\"rWOW\"}],\"Wfae\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./Uint8ArrayReader\"),e=require(\"../utils\");function i(e){t.call(this,e)}e.inherits(i,t),i.prototype.readData=function(t){this.checkOffset(t);var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},module.exports=i;\n},{\"./Uint8ArrayReader\":\"HzNe\",\"../utils\":\"rWOW\"}],\"qqg5\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../utils\"),e=require(\"../support\"),a=require(\"./ArrayReader\"),u=require(\"./StringReader\"),t=require(\"./NodeBufferReader\"),n=require(\"./Uint8ArrayReader\");module.exports=function(i){var o=r.getTypeOf(i);return r.checkSupport(o),\"string\"!==o||e.uint8array?\"nodebuffer\"===o?new t(i):e.uint8array?new n(r.transformTo(\"uint8array\",i)):new a(r.transformTo(\"array\",i)):new u(i)};\n},{\"../utils\":\"rWOW\",\"../support\":\"+8r/\",\"./ArrayReader\":\"Iqwn\",\"./StringReader\":\"HoJ6\",\"./NodeBufferReader\":\"Wfae\",\"./Uint8ArrayReader\":\"HzNe\"}],\"Zj1/\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./reader/readerFor\"),t=require(\"./utils\"),i=require(\"./compressedObject\"),r=require(\"./crc32\"),s=require(\"./utf8\"),n=require(\"./compressions\"),a=require(\"./support\"),d=0,o=3,l=function(e){for(var t in n)if(n.hasOwnProperty(t)&&n[t].magic===e)return n[t];return null};function h(e,t){this.options=e,this.loadOptions=t}h.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var r,s;if(e.skip(22),this.fileNameLength=e.readInt(2),s=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(s),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error(\"Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize === -1 || uncompressedSize === -1)\");if(null===(r=l(this.compressionMethod)))throw new Error(\"Corrupted zip : compression \"+t.pretty(this.compressionMethod)+\" unknown (inner file : \"+t.transformTo(\"string\",this.fileName)+\")\");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,r,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error(\"Encrypted zip are not supported\");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),e===d&&(this.dosPermissions=63&this.externalFileAttributes),e===o&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||\"/\"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(i){if(this.extraFields[1]){var r=e(this.extraFields[1].value);this.uncompressedSize===t.MAX_VALUE_32BITS&&(this.uncompressedSize=r.readInt(8)),this.compressedSize===t.MAX_VALUE_32BITS&&(this.compressedSize=r.readInt(8)),this.localHeaderOffset===t.MAX_VALUE_32BITS&&(this.localHeaderOffset=r.readInt(8)),this.diskNumberStart===t.MAX_VALUE_32BITS&&(this.diskNumberStart=r.readInt(4))}},readExtraFields:function(e){var t,i,r,s=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index<s;)t=e.readInt(2),i=e.readInt(2),r=e.readData(i),this.extraFields[t]={id:t,length:i,value:r}},handleUTF8:function(){var e=a.uint8array?\"uint8array\":\"array\";if(this.useUTF8())this.fileNameStr=s.utf8decode(this.fileName),this.fileCommentStr=s.utf8decode(this.fileComment);else{var i=this.findExtraFieldUnicodePath();if(null!==i)this.fileNameStr=i;else{var r=t.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var d=t.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(d)}}},findExtraFieldUnicodePath:function(){var t=this.extraFields[28789];if(t){var i=e(t.value);return 1!==i.readInt(1)?null:r(this.fileName)!==i.readInt(4)?null:s.utf8decode(i.readData(t.length-5))}return null},findExtraFieldUnicodeComment:function(){var t=this.extraFields[25461];if(t){var i=e(t.value);return 1!==i.readInt(1)?null:r(this.fileComment)!==i.readInt(4)?null:s.utf8decode(i.readData(t.length-5))}return null}},module.exports=h;\n},{\"./reader/readerFor\":\"qqg5\",\"./utils\":\"rWOW\",\"./compressedObject\":\"NnFM\",\"./crc32\":\"4G8U\",\"./utf8\":\"JJJK\",\"./compressions\":\"K5d+\",\"./support\":\"+8r/\"}],\"F/iA\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./reader/readerFor\"),r=require(\"./utils\"),t=require(\"./signature\"),i=require(\"./zipEntry\"),a=require(\"./utf8\"),s=require(\"./support\");function n(e){this.files=[],this.loadOptions=e}n.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error(\"Corrupted zip or bug : unexpected signature (\"+r.pretty(t)+\", expected \"+r.pretty(e)+\")\")}},isSignature:function(e,r){var t=this.reader.index;this.reader.setIndex(e);var i=this.reader.readString(4)===r;return this.reader.setIndex(t),i},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=s.uint8array?\"uint8array\":\"array\",i=r.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(i)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,r,t,i=this.zip64EndOfCentralSize-44;0<i;)e=this.reader.readInt(2),r=this.reader.readInt(4),t=this.reader.readData(r),this.zip64ExtensibleData[e]={id:e,length:r,value:t}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),this.disksCount>1)throw new Error(\"Multi-volumes zip are not supported\")},readLocalFiles:function(){var e,r;for(e=0;e<this.files.length;e++)r=this.files[e],this.reader.setIndex(r.localHeaderOffset),this.checkSignature(t.LOCAL_FILE_HEADER),r.readLocalPart(this.reader),r.handleUTF8(),r.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(t.CENTRAL_FILE_HEADER);)(e=new i({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error(\"Corrupted zip or bug: expected \"+this.centralDirRecords+\" records in central dir, got \"+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(t.CENTRAL_DIRECTORY_END);if(e<0)throw!this.isSignature(0,t.LOCAL_FILE_HEADER)?new Error(\"Can't find end of central directory : is this a zip file ? If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html\"):new Error(\"Corrupted zip : can't find end of central directory\");this.reader.setIndex(e);var i=e;if(this.checkSignature(t.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===r.MAX_VALUE_16BITS||this.diskWithCentralDirStart===r.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===r.MAX_VALUE_16BITS||this.centralDirRecords===r.MAX_VALUE_16BITS||this.centralDirSize===r.MAX_VALUE_32BITS||this.centralDirOffset===r.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(t.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error(\"Corrupted zip : can't find the ZIP64 end of central directory locator\");if(this.reader.setIndex(e),this.checkSignature(t.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,t.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(t.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error(\"Corrupted zip : can't find the ZIP64 end of central directory\");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(t.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var a=this.centralDirOffset+this.centralDirSize;this.zip64&&(a+=20,a+=12+this.zip64EndOfCentralSize);var s=i-a;if(s>0)this.isSignature(i,t.CENTRAL_FILE_HEADER)||(this.reader.zero=s);else if(s<0)throw new Error(\"Corrupted zip: missing \"+Math.abs(s)+\" bytes.\")},prepareReader:function(r){this.reader=e(r)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},module.exports=n;\n},{\"./reader/readerFor\":\"qqg5\",\"./utils\":\"rWOW\",\"./signature\":\"Mgtb\",\"./zipEntry\":\"Zj1/\",\"./utf8\":\"JJJK\",\"./support\":\"+8r/\"}],\"4pYr\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./utils\"),r=require(\"./external\"),i=require(\"./utf8\"),n=(e=require(\"./utils\"),require(\"./zipEntries\")),t=require(\"./stream/Crc32Probe\"),o=require(\"./nodejsUtils\");function s(e){return new r.Promise(function(r,i){var n=e.decompressed.getContentWorker().pipe(new t);n.on(\"error\",function(e){i(e)}).on(\"end\",function(){n.streamInfo.crc32!==e.decompressed.crc32?i(new Error(\"Corrupted zip : CRC32 mismatch\")):r()}).resume()})}module.exports=function(t,a){var m=this;return a=e.extend(a||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:i.utf8decode}),o.isNode&&o.isStream(t)?r.Promise.reject(new Error(\"JSZip can't accept a stream when loading a zip file.\")):e.prepareContent(\"the loaded zip file\",t,!0,a.optimizedBinaryString,a.base64).then(function(e){var r=new n(a);return r.load(e),r}).then(function(e){var i=[r.Promise.resolve(e)],n=e.files;if(a.checkCRC32)for(var t=0;t<n.length;t++)i.push(s(n[t]));return r.Promise.all(i)}).then(function(e){for(var r=e.shift(),i=r.files,n=0;n<i.length;n++){var t=i[n];m.file(t.fileNameStr,t.decompressed,{binary:!0,optimizedBinaryString:!0,date:t.date,dir:t.dir,comment:t.fileCommentStr.length?t.fileCommentStr:null,unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions,createFolders:a.createFolders})}return r.zipComment.length&&(m.comment=r.zipComment),m})};\n},{\"./utils\":\"rWOW\",\"./external\":\"ObVN\",\"./utf8\":\"JJJK\",\"./zipEntries\":\"F/iA\",\"./stream/Crc32Probe\":\"FBbk\",\"./nodejsUtils\":\"5Egw\"}],\"fJ32\":[function(require,module,exports) {\n\"use strict\";function e(){if(!(this instanceof e))return new e;if(arguments.length)throw new Error(\"The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.\");this.files={},this.comment=null,this.root=\"\",this.clone=function(){var t=new e;for(var r in this)\"function\"!=typeof this[r]&&(t[r]=this[r]);return t}}e.prototype=require(\"./object\"),e.prototype.loadAsync=require(\"./load\"),e.support=require(\"./support\"),e.defaults=require(\"./defaults\"),e.version=\"3.1.3\",e.loadAsync=function(t,r){return(new e).loadAsync(t,r)},e.external=require(\"./external\"),module.exports=e;\n},{\"./object\":\"HN8/\",\"./load\":\"4pYr\",\"./support\":\"+8r/\",\"./defaults\":\"f+tM\",\"./external\":\"ObVN\"}],\"gei3\":[function(require,module,exports) {\nvar global = arguments[3];\nvar e=arguments[3],t=require(\"fs\"),r=require(\"./promish\"),n=function(e,t,r,n){e.super_=t,n||(n=r,r=null),r&&Object.keys(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))});var u={constructor:{value:e,enumerable:!1,writable:!1,configurable:!0}};n&&Object.keys(n).forEach(function(e){u[e]=Object.getOwnPropertyDescriptor(n,e)}),e.prototype=Object.create(t.prototype,u)},u=module.exports={nop:function(){},promiseImmediate:function(t){return new r.Promish(function(r){e.setImmediate?setImmediate(function(){r(t)}):setTimeout(function(){r(t)},1)})},inherits:n,dateToExcel:function(e,t){return 25569+e.getTime()/864e5-(t?1462:0)},excelToDate:function(e,t){var r=Math.round(24*(e-25569+(t?1462:0))*3600*1e3);return new Date(r)},parsePath:function(e){var t=e.lastIndexOf(\"/\");return{path:e.substring(0,t),name:e.substring(t+1)}},getRelsPath:function(e){var t=u.parsePath(e);return t.path+\"/_rels/\"+t.name+\".rels\"},xmlEncode:function(e){return e.replace(/[<>&'\"\\x7F\\x00-\\x08\\x0B-\\x0C\\x0E-\\x1F]/g,function(e){switch(e){case\"<\":return\"&lt;\";case\">\":return\"&gt;\";case\"&\":return\"&amp;\";case\"'\":return\"&apos;\";case'\"':return\"&quot;\";default:return\"\"}})},xmlDecode:function(e){return e.replace(/&([a-z]*);/,function(e){switch(e){case\"&lt;\":return\"<\";case\"&gt;\":return\">\";case\"&amp;\":return\"&\";case\"&apos;\":return\"'\";case\"&quot;\":return'\"';default:return e}})},validInt:function(e){var t=parseInt(e,10);return isNaN(t)?0:t},isDateFmt:function(e){return!!e&&null!==(e=(e=e.replace(/\\[[^\\]]*]/g,\"\")).replace(/\"[^\"]*\"/g,\"\")).match(/[ymdhMsb]+/)},fs:{exists:function(e){return new r.Promish(function(r){t.exists(e,function(e){r(e)})})}},toIsoDateString:function(e){return e.toIsoString().subsstr(0,10)}};\n},{\"fs\":\"70rD\",\"./promish\":\"vJr6\"}],\"vq4y\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar t=require(\"buffer\").Buffer,i=module.exports=function(i){this._buf=new t(i&&i.size||16384),this._encoding=i&&i.encoding||\"utf8\",this._inPos=0,this._buffer=void 0};i.prototype={get length(){return this._inPos},get capacity(){return this._buf.length},get buffer(){return this._buf},toBuffer:function(){return this._buffer||(this._buffer=new t(this.length),this._buf.copy(this._buffer,0,0,this.length)),this._buffer},reset:function(t){t=t||0,this._buffer=void 0,this._inPos=t},_grow:function(i){for(var h=2*this._buf.length;h<i;)h*=2;var s=new t(h);this._buf.copy(s,0),this._buf=s},addText:function(t){this._buffer=void 0;for(var i=this._inPos+this._buf.write(t,this._inPos,this._encoding);i>=this._buf.length-4;)this._grow(this._inPos+t.length),i=this._inPos+this._buf.write(t,this._inPos,this._encoding);this._inPos=i},addStringBuf:function(t){t.length&&(this._buffer=void 0,this.length+t.length>this.capacity&&this._grow(this.length+t.length),t._buf.copy(this._buf,this._inPos,0,t.length),this._inPos+=t.length)}};\n},{\"buffer\":\"peL6\"}],\"SWOl\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar process = require(\"process\");\nvar t=require(\"buffer\").Buffer,i=require(\"process\"),e=require(\"stream\"),r=require(\"./promish\"),s=require(\"./utils\"),n=require(\"./string-buf\"),f=function(t,i){this._data=t,this._encoding=i};f.prototype={get length(){return this.toBuffer().length},copy:function(t,i,e,r){return this.toBuffer().copy(t,i,e,r)},toBuffer:function(){return this._buffer||(this._buffer=new t(this._data,this._encoding)),this._buffer}};var u=function(t){this._data=t};u.prototype={get length(){return this._data.length},copy:function(t,i,e,r){return this._data._buf.copy(t,i,e,r)},toBuffer:function(){return this._data.toBuffer()}};var h=function(t){this._data=t};h.prototype={get length(){return this._data.length},copy:function(t,i,e,r){this._data.copy(t,i,e,r)},toBuffer:function(){return this._data}};var o=function(i){this.size=i,this.buffer=new t(i),this.iRead=0,this.iWrite=0};o.prototype={toBuffer:function(){if(0===this.iRead&&this.iWrite===this.size)return this.buffer;var i=new t(this.iWrite-this.iRead);return this.buffer.copy(i,0,this.iRead,this.iWrite),i},get length(){return this.iWrite-this.iRead},get eod(){return this.iRead===this.iWrite},get full(){return this.iWrite===this.size},read:function(i){var e;return 0===i?null:void 0===i||i>=this.length?(e=this.toBuffer(),this.iRead=this.iWrite,e):(e=new t(i),this.buffer.copy(e,0,this.iRead,i),this.iRead+=i,e)},write:function(t,i,e){var r=Math.min(e,this.size-this.iWrite);return t.copy(this.buffer,this.iWrite,i,i+r),this.iWrite+=r,r}};var a=module.exports=function(t){t=t||{},this.bufSize=t.bufSize||1048576,this.buffers=[],this.batch=t.batch||!1,this.corked=!1,this.inPos=0,this.outPos=0,this.pipes=[],this.paused=!1,this.encoding=null};s.inherits(a,e.Duplex,{toBuffer:function(){switch(this.buffers.length){case 0:return null;case 1:return this.buffers[0].toBuffer();default:return t.concat(this.buffers.map(function(t){return t.toBuffer()}))}},_getWritableBuffer:function(){if(this.buffers.length){var t=this.buffers[this.buffers.length-1];if(!t.full)return t}var i=new o(this.bufSize);return this.buffers.push(i),i},_pipe:function(t){var i=this.pipes.map(function(i){return new r.Promish(function(e){i.write(t.toBuffer(),function(){e()})})});return i.length?r.Promish.all(i).then(s.nop):r.Promish.resolve()},_writeToBuffers:function(t){for(var i=0,e=t.length;i<e;){i+=this._getWritableBuffer().write(t,i,e-i)}},write:function(e,r,o){var a;if(r instanceof Function&&(o=r,r=\"utf8\"),o=o||s.nop,a=e instanceof n?new u(e):e instanceof t?new h(e):new f(e,r),this.pipes.length)if(this.batch)for(this._writeToBuffers(a);!this.corked&&this.buffers.length>1;)this._pipe(this.buffers.shift());else this.corked?(this._writeToBuffers(a),i.nextTick(o)):this._pipe(a).then(o);else this.paused||this.emit(\"data\",a.toBuffer()),this._writeToBuffers(a),this.emit(\"readable\");return!0},cork:function(){this.corked=!0},_flush:function(){if(this.pipes.length)for(;this.buffers.length;)this._pipe(this.buffers.shift())},uncork:function(){this.corked=!1,this._flush()},end:function(t,i,e){var r=this,s=function(t){t?e(t):(r._flush(),r.pipes.forEach(function(t){t.end()}),r.emit(\"finish\"))};t?this.write(t,i,s):s()},read:function(i){var e;if(i){for(e=[];i&&this.buffers.length&&!this.buffers[0].eod;){var r=this.buffers[0],s=r.read(i);i-=s.length,e.push(s),r.eod&&r.full&&this.buffers.shift()}return t.concat(e)}return e=this.buffers.map(function(t){return t.toBuffer()}).filter(Boolean),this.buffers=[],t.concat(e)},setEncoding:function(t){this.encoding=t},pause:function(){this.paused=!0},resume:function(){this.paused=!1},isPaused:function(){return!!this.paused},pipe:function(t){this.pipes.push(t),!this.paused&&this.buffers.length&&this.end()},unpipe:function(t){this.pipes=this.pipes.filter(function(i){return i!==t})},unshift:function(){throw new Error(\"Not Implemented\")},wrap:function(){throw new Error(\"Not Implemented\")}});\n},{\"stream\":\"fnRj\",\"./promish\":\"vJr6\",\"./utils\":\"gei3\",\"./string-buf\":\"vq4y\",\"buffer\":\"peL6\",\"process\":\"pBGv\"}],\"EG/7\":[function(require,module,exports) {\n\"use strict\";var t=require(\"events\"),e=require(\"./promish\"),n=require(\"jszip\"),i=require(\"./utils\"),r=require(\"./stream-buf\"),s=function(t){var e=this;this.count=0,this.jsZip=new n,this.stream=new r,this.stream.on(\"finish\",function(){e._process()}),this.getEntryType=t.getEntryType||function(){return\"string\"}};i.inherits(s,t.EventEmitter,{_finished:function(){var t=this;--this.count||e.Promish.resolve().then(function(){t.emit(\"finished\")})},_process:function(){var t=this,e=this.stream.read();this.jsZip.loadAsync(e).then(function(e){e.forEach(function(e,n){n.dir||(t.count++,n.async(t.getEntryType(e)).then(function(n){var i=new r;i.path=e,i.write(n),i.autodrain=function(){t._finished()},i.on(\"finish\",function(){t._finished()}),t.emit(\"entry\",i)}).catch(function(e){t.emit(\"error\",e)}))})}).catch(function(e){t.emit(\"error\",e)})},write:function(t,e,n){if(this.error)throw n&&n(error),error;return this.stream.write(t,e,n)},cork:function(){return this.stream.cork()},uncork:function(){return this.stream.uncork()},end:function(){return this.stream.end()},destroy:function(t){this.emit(\"finished\"),this.error=t}});var u=function(){this.zip=new n,this.stream=new r};i.inherits(u,t.EventEmitter,{append:function(t,e){e.hasOwnProperty(\"base64\")&&e.base64?this.zip.file(e.name,t,{base64:!0}):this.zip.file(e.name,t)},finalize:function(){var t=this;return this.zip.generateAsync({type:\"nodebuffer\",compression:\"DEFLATE\"}).then(function(e){t.stream.end(e),t.emit(\"finish\")})},read:function(t){return this.stream.read(t)},setEncoding:function(t){return this.stream.setEncoding(t)},pause:function(){return this.stream.pause()},resume:function(){return this.stream.resume()},isPaused:function(){return this.stream.isPaused()},pipe:function(t,e){return this.stream.pipe(t,e)},unpipe:function(t){return this.stream.unpipe(t)},unshift:function(t){return this.stream.unshift(t)},wrap:function(t){return this.stream.wrap(t)}}),module.exports={ZipReader:s,ZipWriter:u};\n},{\"events\":\"FRpO\",\"./promish\":\"vJr6\",\"jszip\":\"fJ32\",\"./utils\":\"gei3\",\"./stream-buf\":\"SWOl\"}],\"WHow\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./under-dash\"),s=require(\"./utils\"),i=\"<\",e=\">\",h=\"</\",o=\"/>\",n='=\"',l='\"',c=\" \";function a(t,i,e){t.push(c),t.push(i),t.push(n),t.push(s.xmlEncode(e.toString())),t.push(l)}function p(s,i){i&&t.each(i,function(t,i){void 0!==t&&a(s,i,t)})}var u=module.exports=function(){this._xml=[],this._stack=[],this._rollbacks=[]};u.StdDocAttributes={version:\"1.0\",encoding:\"UTF-8\",standalone:\"yes\"},u.prototype={get tos(){return this._stack.length?this._stack[this._stack.length-1]:void 0},openXml:function(t){var s=this._xml;s.push(\"<?xml\"),p(s,t),s.push(\"?>\\n\")},openNode:function(t,s){var h=this.tos,o=this._xml;h&&this.open&&o.push(e),this._stack.push(t),o.push(i),o.push(t),p(o,s),this.leaf=!0,this.open=!0},addAttribute:function(t,s){if(!this.open)throw new Error(\"Cannot write attributes to node if it is not open\");a(this._xml,t,s)},addAttributes:function(t){if(!this.open)throw new Error(\"Cannot write attributes to node if it is not open\");p(this._xml,t)},writeText:function(t){var i=this._xml;this.open&&(i.push(e),this.open=!1),this.leaf=!1,i.push(s.xmlEncode(t.toString()))},writeXml:function(t){this.open&&(this._xml.push(e),this.open=!1),this.leaf=!1,this._xml.push(t)},closeNode:function(){var t=this._stack.pop(),s=this._xml;this.leaf?s.push(o):(s.push(h),s.push(t),s.push(e)),this.open=!1,this.leaf=!1},leafNode:function(t,s,i){this.openNode(t,s),void 0!==i&&this.writeText(i),this.closeNode()},closeAll:function(){for(;this._stack.length;)this.closeNode()},addRollback:function(){this._rollbacks.push({xml:this._xml.length,stack:this._stack.length,leaf:this.leaf,open:this.open})},commit:function(){this._rollbacks.pop()},rollback:function(){var t=this._rollbacks.pop();this._xml.length>t.xml&&this._xml.splice(t.xml,this._xml.length-t.xml),this._stack.length>t.stack&&this._stack.splice(t.stack,this._stack.length-t.stack),this.leaf=t.leaf,this.open=t.open},get xml(){return this.closeAll(),this._xml.join(\"\")}};\n},{\"./under-dash\":\"h8Mb\",\"./utils\":\"gei3\"}],\"YfFG\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar t=require(\"buffer\").Buffer;!function(e){e.parser=function(t,e){return new a(t,e)},e.SAXParser=a,e.SAXStream=n,e.createStream=function(t,e){return new n(t,e)},e.MAX_BUFFER_LENGTH=65536;var i,s=[\"comment\",\"sgmlDecl\",\"textNode\",\"tagName\",\"doctype\",\"procInstName\",\"procInstBody\",\"entity\",\"attribName\",\"attribValue\",\"cdata\",\"script\"];function a(t,i){if(!(this instanceof a))return new a(t,i);!function(t){for(var e=0,i=s.length;e<i;e++)t[s[e]]=\"\"}(this),this.q=this.c=\"\",this.bufferCheckPosition=e.MAX_BUFFER_LENGTH,this.opt=i||{},this.opt.lowercase=this.opt.lowercase||this.opt.lowercasetags,this.looseCase=this.opt.lowercase?\"toLowerCase\":\"toUpperCase\",this.tags=[],this.closed=this.closedRoot=this.sawRoot=!1,this.tag=this.error=null,this.strict=!!t,this.noscript=!(!t&&!this.opt.noscript),this.state=b.BEGIN,this.strictEntities=this.opt.strictEntities,this.ENTITIES=this.strictEntities?Object.create(e.XML_ENTITIES):Object.create(e.ENTITIES),this.attribList=[],this.opt.xmlns&&(this.ns=Object.create(l)),this.trackPosition=!1!==this.opt.position,this.trackPosition&&(this.position=this.line=this.column=0),O(this,\"onready\")}e.EVENTS=[\"text\",\"processinginstruction\",\"sgmldeclaration\",\"doctype\",\"comment\",\"opentagstart\",\"attribute\",\"opentag\",\"closetag\",\"opencdata\",\"cdata\",\"closecdata\",\"error\",\"end\",\"ready\",\"script\",\"opennamespace\",\"closenamespace\"],Object.create||(Object.create=function(t){function e(){}return e.prototype=t,new e}),Object.keys||(Object.keys=function(t){var e=[];for(var i in t)t.hasOwnProperty(i)&&e.push(i);return e}),a.prototype={end:function(){P(this)},write:function(t){if(this.error)throw this.error;if(this.closed)return R(this,\"Cannot write after close. Assign an onready handler.\");if(null===t)return P(this);\"object\"==typeof t&&(t=t.toString());var i=0,a=\"\";for(;a=V(t,i++),this.c=a,a;)switch(this.trackPosition&&(this.position++,\"\\n\"===a?(this.line++,this.column=0):this.column++),this.state){case b.BEGIN:if(this.state=b.BEGIN_WHITESPACE,\"\\ufeff\"===a)continue;M(this,a);continue;case b.BEGIN_WHITESPACE:M(this,a);continue;case b.TEXT:if(this.sawRoot&&!this.closedRoot){for(var r=i-1;a&&\"<\"!==a&&\"&\"!==a;)(a=V(t,i++))&&this.trackPosition&&(this.position++,\"\\n\"===a?(this.line++,this.column=0):this.column++);this.textNode+=t.substring(r,i-1)}\"<\"!==a||this.sawRoot&&this.closedRoot&&!this.strict?(N(a)||this.sawRoot&&!this.closedRoot||y(this,\"Text data outside of root node.\"),\"&\"===a?this.state=b.TEXT_ENTITY:this.textNode+=a):(this.state=b.OPEN_WAKA,this.startTagPosition=this.position);continue;case b.SCRIPT:\"<\"===a?this.state=b.SCRIPT_ENDING:this.script+=a;continue;case b.SCRIPT_ENDING:\"/\"===a?this.state=b.CLOSE_TAG:(this.script+=\"<\"+a,this.state=b.SCRIPT);continue;case b.OPEN_WAKA:if(\"!\"===a)this.state=b.SGML_DECL,this.sgmlDecl=\"\";else if(N(a));else if(d(T,a))this.state=b.OPEN_TAG,this.tagName=a;else if(\"/\"===a)this.state=b.CLOSE_TAG,this.tagName=\"\";else if(\"?\"===a)this.state=b.PROC_INST,this.procInstName=this.procInstBody=\"\";else{if(y(this,\"Unencoded <\"),this.startTagPosition+1<this.position){var n=this.position-this.startTagPosition;a=new Array(n).join(\" \")+a}this.textNode+=\"<\"+a,this.state=b.TEXT}continue;case b.SGML_DECL:(this.sgmlDecl+a).toUpperCase()===o?(F(this,\"onopencdata\"),this.state=b.CDATA,this.sgmlDecl=\"\",this.cdata=\"\"):this.sgmlDecl+a===\"--\"?(this.state=b.COMMENT,this.comment=\"\",this.sgmlDecl=\"\"):(this.sgmlDecl+a).toUpperCase()===c?(this.state=b.DOCTYPE,(this.doctype||this.sawRoot)&&y(this,\"Inappropriately located doctype declaration\"),this.doctype=\"\",this.sgmlDecl=\"\"):\">\"===a?(F(this,\"onsgmldeclaration\",this.sgmlDecl),this.sgmlDecl=\"\",this.state=b.TEXT):f(a)?(this.state=b.SGML_DECL_QUOTED,this.sgmlDecl+=a):this.sgmlDecl+=a;continue;case b.SGML_DECL_QUOTED:a===this.q&&(this.state=b.SGML_DECL,this.q=\"\"),this.sgmlDecl+=a;continue;case b.DOCTYPE:\">\"===a?(this.state=b.TEXT,F(this,\"ondoctype\",this.doctype),this.doctype=!0):(this.doctype+=a,\"[\"===a?this.state=b.DOCTYPE_DTD:f(a)&&(this.state=b.DOCTYPE_QUOTED,this.q=a));continue;case b.DOCTYPE_QUOTED:this.doctype+=a,a===this.q&&(this.q=\"\",this.state=b.DOCTYPE);continue;case b.DOCTYPE_DTD:this.doctype+=a,\"]\"===a?this.state=b.DOCTYPE:f(a)&&(this.state=b.DOCTYPE_DTD_QUOTED,this.q=a);continue;case b.DOCTYPE_DTD_QUOTED:this.doctype+=a,a===this.q&&(this.state=b.DOCTYPE_DTD,this.q=\"\");continue;case b.COMMENT:\"-\"===a?this.state=b.COMMENT_ENDING:this.comment+=a;continue;case b.COMMENT_ENDING:\"-\"===a?(this.state=b.COMMENT_ENDED,this.comment=v(this.opt,this.comment),this.comment&&F(this,\"oncomment\",this.comment),this.comment=\"\"):(this.comment+=\"-\"+a,this.state=b.COMMENT);continue;case b.COMMENT_ENDED:\">\"!==a?(y(this,\"Malformed comment\"),this.comment+=\"--\"+a,this.state=b.COMMENT):this.state=b.TEXT;continue;case b.CDATA:\"]\"===a?this.state=b.CDATA_ENDING:this.cdata+=a;continue;case b.CDATA_ENDING:\"]\"===a?this.state=b.CDATA_ENDING_2:(this.cdata+=\"]\"+a,this.state=b.CDATA);continue;case b.CDATA_ENDING_2:\">\"===a?(this.cdata&&F(this,\"oncdata\",this.cdata),F(this,\"onclosecdata\"),this.cdata=\"\",this.state=b.TEXT):\"]\"===a?this.cdata+=\"]\":(this.cdata+=\"]]\"+a,this.state=b.CDATA);continue;case b.PROC_INST:\"?\"===a?this.state=b.PROC_INST_ENDING:N(a)?this.state=b.PROC_INST_BODY:this.procInstName+=a;continue;case b.PROC_INST_BODY:if(!this.procInstBody&&N(a))continue;\"?\"===a?this.state=b.PROC_INST_ENDING:this.procInstBody+=a;continue;case b.PROC_INST_ENDING:\">\"===a?(F(this,\"onprocessinginstruction\",{name:this.procInstName,body:this.procInstBody}),this.procInstName=this.procInstBody=\"\",this.state=b.TEXT):(this.procInstBody+=\"?\"+a,this.state=b.PROC_INST_BODY);continue;case b.OPEN_TAG:d(E,a)?this.tagName+=a:(L(this),\">\"===a?x(this):\"/\"===a?this.state=b.OPEN_TAG_SLASH:(N(a)||y(this,\"Invalid character in tag name\"),this.state=b.ATTRIB));continue;case b.OPEN_TAG_SLASH:\">\"===a?(x(this,!0),w(this)):(y(this,\"Forward-slash in opening tag not followed by >\"),this.state=b.ATTRIB);continue;case b.ATTRIB:if(N(a))continue;\">\"===a?x(this):\"/\"===a?this.state=b.OPEN_TAG_SLASH:d(T,a)?(this.attribName=a,this.attribValue=\"\",this.state=b.ATTRIB_NAME):y(this,\"Invalid attribute name\");continue;case b.ATTRIB_NAME:\"=\"===a?this.state=b.ATTRIB_VALUE:\">\"===a?(y(this,\"Attribute without value\"),this.attribValue=this.attribName,B(this),x(this)):N(a)?this.state=b.ATTRIB_NAME_SAW_WHITE:d(E,a)?this.attribName+=a:y(this,\"Invalid attribute name\");continue;case b.ATTRIB_NAME_SAW_WHITE:if(\"=\"===a)this.state=b.ATTRIB_VALUE;else{if(N(a))continue;y(this,\"Attribute without value\"),this.tag.attributes[this.attribName]=\"\",this.attribValue=\"\",F(this,\"onattribute\",{name:this.attribName,value:\"\"}),this.attribName=\"\",\">\"===a?x(this):d(T,a)?(this.attribName=a,this.state=b.ATTRIB_NAME):(y(this,\"Invalid attribute name\"),this.state=b.ATTRIB)}continue;case b.ATTRIB_VALUE:if(N(a))continue;f(a)?(this.q=a,this.state=b.ATTRIB_VALUE_QUOTED):(y(this,\"Unquoted attribute value\"),this.state=b.ATTRIB_VALUE_UNQUOTED,this.attribValue=a);continue;case b.ATTRIB_VALUE_QUOTED:if(a!==this.q){\"&\"===a?this.state=b.ATTRIB_VALUE_ENTITY_Q:this.attribValue+=a;continue}B(this),this.q=\"\",this.state=b.ATTRIB_VALUE_CLOSED;continue;case b.ATTRIB_VALUE_CLOSED:N(a)?this.state=b.ATTRIB:\">\"===a?x(this):\"/\"===a?this.state=b.OPEN_TAG_SLASH:d(T,a)?(y(this,\"No whitespace between attributes\"),this.attribName=a,this.attribValue=\"\",this.state=b.ATTRIB_NAME):y(this,\"Invalid attribute name\");continue;case b.ATTRIB_VALUE_UNQUOTED:if(!_(a)){\"&\"===a?this.state=b.ATTRIB_VALUE_ENTITY_U:this.attribValue+=a;continue}B(this),\">\"===a?x(this):this.state=b.ATTRIB;continue;case b.CLOSE_TAG:if(this.tagName)\">\"===a?w(this):d(E,a)?this.tagName+=a:this.script?(this.script+=\"</\"+this.tagName,this.tagName=\"\",this.state=b.SCRIPT):(N(a)||y(this,\"Invalid tagname in closing tag\"),this.state=b.CLOSE_TAG_SAW_WHITE);else{if(N(a))continue;g(T,a)?this.script?(this.script+=\"</\"+a,this.state=b.SCRIPT):y(this,\"Invalid tagname in closing tag.\"):this.tagName=a}continue;case b.CLOSE_TAG_SAW_WHITE:if(N(a))continue;\">\"===a?w(this):y(this,\"Invalid characters in closing tag\");continue;case b.TEXT_ENTITY:case b.ATTRIB_VALUE_ENTITY_Q:case b.ATTRIB_VALUE_ENTITY_U:var u,h;switch(this.state){case b.TEXT_ENTITY:u=b.TEXT,h=\"textNode\";break;case b.ATTRIB_VALUE_ENTITY_Q:u=b.ATTRIB_VALUE_QUOTED,h=\"attribValue\";break;case b.ATTRIB_VALUE_ENTITY_U:u=b.ATTRIB_VALUE_UNQUOTED,h=\"attribValue\"}\";\"===a?(this[h]+=G(this),this.entity=\"\",this.state=u):d(this.entity.length?m:p,a)?this.entity+=a:(y(this,\"Invalid character in entity name\"),this[h]+=\"&\"+this.entity+a,this.entity=\"\",this.state=u);continue;default:throw new Error(this,\"Unknown state: \"+this.state)}this.position>=this.bufferCheckPosition&&function(t){for(var i=Math.max(e.MAX_BUFFER_LENGTH,10),a=0,r=0,n=s.length;r<n;r++){var o=t[s[r]].length;if(o>i)switch(s[r]){case\"textNode\":S(t);break;case\"cdata\":F(t,\"oncdata\",t.cdata),t.cdata=\"\";break;case\"script\":F(t,\"onscript\",t.script),t.script=\"\";break;default:R(t,\"Max buffer length exceeded: \"+s[r])}a=Math.max(a,o)}var c=e.MAX_BUFFER_LENGTH-a;t.bufferCheckPosition=c+t.position}(this);return this},resume:function(){return this.error=null,this},close:function(){return this.write(null)},flush:function(){var t;S(t=this),\"\"!==t.cdata&&(F(t,\"oncdata\",t.cdata),t.cdata=\"\"),\"\"!==t.script&&(F(t,\"onscript\",t.script),t.script=\"\")}};try{i=require(\"stream\").Stream}catch(Y){i=function(){}}var r=e.EVENTS.filter(function(t){return\"error\"!==t&&\"end\"!==t});function n(t,e){if(!(this instanceof n))return new n(t,e);i.apply(this),this._parser=new a(t,e),this.writable=!0,this.readable=!0;var s=this;this._parser.onend=function(){s.emit(\"end\")},this._parser.onerror=function(t){s.emit(\"error\",t),s._parser.error=null},this._decoder=null,r.forEach(function(t){Object.defineProperty(s,\"on\"+t,{get:function(){return s._parser[\"on\"+t]},set:function(e){if(!e)return s.removeAllListeners(t),s._parser[\"on\"+t]=e,e;s.on(t,e)},enumerable:!0,configurable:!1})})}n.prototype=Object.create(i.prototype,{constructor:{value:n}}),n.prototype.write=function(e){if(\"function\"==typeof t&&\"function\"==typeof t.isBuffer&&t.isBuffer(e)){if(!this._decoder){var i=require(\"string_decoder\").StringDecoder;this._decoder=new i(\"utf8\")}e=this._decoder.write(e)}return this._parser.write(e.toString()),this.emit(\"data\",e),!0},n.prototype.end=function(t){return t&&t.length&&this.write(t),this._parser.end(),!0},n.prototype.on=function(t,e){var s=this;return s._parser[\"on\"+t]||-1===r.indexOf(t)||(s._parser[\"on\"+t]=function(){var e=1===arguments.length?[arguments[0]]:Array.apply(null,arguments);e.splice(0,0,t),s.emit.apply(s,e)}),i.prototype.on.call(s,t,e)};var o=\"[CDATA[\",c=\"DOCTYPE\",u=\"http://www.w3.org/XML/1998/namespace\",h=\"http://www.w3.org/2000/xmlns/\",l={xml:u,xmlns:h},T=/[:_A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD]/,E=/[:_A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\u00B7\\u0300-\\u036F\\u203F-\\u2040.\\d-]/,p=/[#:_A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD]/,m=/[#:_A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\u00B7\\u0300-\\u036F\\u203F-\\u2040.\\d-]/;function N(t){return\" \"===t||\"\\n\"===t||\"\\r\"===t||\"\\t\"===t}function f(t){return'\"'===t||\"'\"===t}function _(t){return\">\"===t||N(t)}function d(t,e){return t.test(e)}function g(t,e){return!d(t,e)}var A,I,D,b=0;for(var C in e.STATE={BEGIN:b++,BEGIN_WHITESPACE:b++,TEXT:b++,TEXT_ENTITY:b++,OPEN_WAKA:b++,SGML_DECL:b++,SGML_DECL_QUOTED:b++,DOCTYPE:b++,DOCTYPE_QUOTED:b++,DOCTYPE_DTD:b++,DOCTYPE_DTD_QUOTED:b++,COMMENT_STARTING:b++,COMMENT:b++,COMMENT_ENDING:b++,COMMENT_ENDED:b++,CDATA:b++,CDATA_ENDING:b++,CDATA_ENDING_2:b++,PROC_INST:b++,PROC_INST_BODY:b++,PROC_INST_ENDING:b++,OPEN_TAG:b++,OPEN_TAG_SLASH:b++,ATTRIB:b++,ATTRIB_NAME:b++,ATTRIB_NAME_SAW_WHITE:b++,ATTRIB_VALUE:b++,ATTRIB_VALUE_QUOTED:b++,ATTRIB_VALUE_CLOSED:b++,ATTRIB_VALUE_UNQUOTED:b++,ATTRIB_VALUE_ENTITY_Q:b++,ATTRIB_VALUE_ENTITY_U:b++,CLOSE_TAG:b++,CLOSE_TAG_SAW_WHITE:b++,SCRIPT:b++,SCRIPT_ENDING:b++},e.XML_ENTITIES={amp:\"&\",gt:\">\",lt:\"<\",quot:'\"',apos:\"'\"},e.ENTITIES={amp:\"&\",gt:\">\",lt:\"<\",quot:'\"',apos:\"'\",AElig:198,Aacute:193,Acirc:194,Agrave:192,Aring:197,Atilde:195,Auml:196,Ccedil:199,ETH:208,Eacute:201,Ecirc:202,Egrave:200,Euml:203,Iacute:205,Icirc:206,Igrave:204,Iuml:207,Ntilde:209,Oacute:211,Ocirc:212,Ograve:210,Oslash:216,Otilde:213,Ouml:214,THORN:222,Uacute:218,Ucirc:219,Ugrave:217,Uuml:220,Yacute:221,aacute:225,acirc:226,aelig:230,agrave:224,aring:229,atilde:227,auml:228,ccedil:231,eacute:233,ecirc:234,egrave:232,eth:240,euml:235,iacute:237,icirc:238,igrave:236,iuml:239,ntilde:241,oacute:243,ocirc:244,ograve:242,oslash:248,otilde:245,ouml:246,szlig:223,thorn:254,uacute:250,ucirc:251,ugrave:249,uuml:252,yacute:253,yuml:255,copy:169,reg:174,nbsp:160,iexcl:161,cent:162,pound:163,curren:164,yen:165,brvbar:166,sect:167,uml:168,ordf:170,laquo:171,not:172,shy:173,macr:175,deg:176,plusmn:177,sup1:185,sup2:178,sup3:179,acute:180,micro:181,para:182,middot:183,cedil:184,ordm:186,raquo:187,frac14:188,frac12:189,frac34:190,iquest:191,times:215,divide:247,OElig:338,oelig:339,Scaron:352,scaron:353,Yuml:376,fnof:402,circ:710,tilde:732,Alpha:913,Beta:914,Gamma:915,Delta:916,Epsilon:917,Zeta:918,Eta:919,Theta:920,Iota:921,Kappa:922,Lambda:923,Mu:924,Nu:925,Xi:926,Omicron:927,Pi:928,Rho:929,Sigma:931,Tau:932,Upsilon:933,Phi:934,Chi:935,Psi:936,Omega:937,alpha:945,beta:946,gamma:947,delta:948,epsilon:949,zeta:950,eta:951,theta:952,iota:953,kappa:954,lambda:955,mu:956,nu:957,xi:958,omicron:959,pi:960,rho:961,sigmaf:962,sigma:963,tau:964,upsilon:965,phi:966,chi:967,psi:968,omega:969,thetasym:977,upsih:978,piv:982,ensp:8194,emsp:8195,thinsp:8201,zwnj:8204,zwj:8205,lrm:8206,rlm:8207,ndash:8211,mdash:8212,lsquo:8216,rsquo:8217,sbquo:8218,ldquo:8220,rdquo:8221,bdquo:8222,dagger:8224,Dagger:8225,bull:8226,hellip:8230,permil:8240,prime:8242,Prime:8243,lsaquo:8249,rsaquo:8250,oline:8254,frasl:8260,euro:8364,image:8465,weierp:8472,real:8476,trade:8482,alefsym:8501,larr:8592,uarr:8593,rarr:8594,darr:8595,harr:8596,crarr:8629,lArr:8656,uArr:8657,rArr:8658,dArr:8659,hArr:8660,forall:8704,part:8706,exist:8707,empty:8709,nabla:8711,isin:8712,notin:8713,ni:8715,prod:8719,sum:8721,minus:8722,lowast:8727,radic:8730,prop:8733,infin:8734,ang:8736,and:8743,or:8744,cap:8745,cup:8746,int:8747,there4:8756,sim:8764,cong:8773,asymp:8776,ne:8800,equiv:8801,le:8804,ge:8805,sub:8834,sup:8835,nsub:8836,sube:8838,supe:8839,oplus:8853,otimes:8855,perp:8869,sdot:8901,lceil:8968,rceil:8969,lfloor:8970,rfloor:8971,lang:9001,rang:9002,loz:9674,spades:9824,clubs:9827,hearts:9829,diams:9830},Object.keys(e.ENTITIES).forEach(function(t){var i=e.ENTITIES[t],s=\"number\"==typeof i?String.fromCharCode(i):i;e.ENTITIES[t]=s}),e.STATE)e.STATE[e.STATE[C]]=C;function O(t,e,i){t[e]&&t[e](i)}function F(t,e,i){t.textNode&&S(t),O(t,e,i)}function S(t){t.textNode=v(t.opt,t.textNode),t.textNode&&O(t,\"ontext\",t.textNode),t.textNode=\"\"}function v(t,e){return t.trim&&(e=e.trim()),t.normalize&&(e=e.replace(/\\s+/g,\" \")),e}function R(t,e){return S(t),t.trackPosition&&(e+=\"\\nLine: \"+t.line+\"\\nColumn: \"+t.column+\"\\nChar: \"+t.c),e=new Error(e),t.error=e,O(t,\"onerror\",e),t}function P(t){return t.sawRoot&&!t.closedRoot&&y(t,\"Unclosed root tag\"),t.state!==b.BEGIN&&t.state!==b.BEGIN_WHITESPACE&&t.state!==b.TEXT&&R(t,\"Unexpected end\"),S(t),t.c=\"\",t.closed=!0,O(t,\"onend\"),a.call(t,t.strict,t.opt),t}function y(t,e){if(\"object\"!=typeof t||!(t instanceof a))throw new Error(\"bad call to strictFail\");t.strict&&R(t,e)}function L(t){t.strict||(t.tagName=t.tagName[t.looseCase]());var e=t.tags[t.tags.length-1]||t,i=t.tag={name:t.tagName,attributes:{}};t.opt.xmlns&&(i.ns=e.ns),t.attribList.length=0,F(t,\"onopentagstart\",i)}function U(t,e){var i=t.indexOf(\":\")<0?[\"\",t]:t.split(\":\"),s=i[0],a=i[1];return e&&\"xmlns\"===t&&(s=\"xmlns\",a=\"\"),{prefix:s,local:a}}function B(t){if(t.strict||(t.attribName=t.attribName[t.looseCase]()),-1!==t.attribList.indexOf(t.attribName)||t.tag.attributes.hasOwnProperty(t.attribName))t.attribName=t.attribValue=\"\";else{if(t.opt.xmlns){var e=U(t.attribName,!0),i=e.prefix,s=e.local;if(\"xmlns\"===i)if(\"xml\"===s&&t.attribValue!==u)y(t,\"xml: prefix must be bound to \"+u+\"\\nActual: \"+t.attribValue);else if(\"xmlns\"===s&&t.attribValue!==h)y(t,\"xmlns: prefix must be bound to \"+h+\"\\nActual: \"+t.attribValue);else{var a=t.tag,r=t.tags[t.tags.length-1]||t;a.ns===r.ns&&(a.ns=Object.create(r.ns)),a.ns[s]=t.attribValue}t.attribList.push([t.attribName,t.attribValue])}else t.tag.attributes[t.attribName]=t.attribValue,F(t,\"onattribute\",{name:t.attribName,value:t.attribValue});t.attribName=t.attribValue=\"\"}}function x(t,e){if(t.opt.xmlns){var i=t.tag,s=U(t.tagName);i.prefix=s.prefix,i.local=s.local,i.uri=i.ns[s.prefix]||\"\",i.prefix&&!i.uri&&(y(t,\"Unbound namespace prefix: \"+JSON.stringify(t.tagName)),i.uri=s.prefix);var a=t.tags[t.tags.length-1]||t;i.ns&&a.ns!==i.ns&&Object.keys(i.ns).forEach(function(e){F(t,\"onopennamespace\",{prefix:e,uri:i.ns[e]})});for(var r=0,n=t.attribList.length;r<n;r++){var o=t.attribList[r],c=o[0],u=o[1],h=U(c,!0),l=h.prefix,T=h.local,E=\"\"===l?\"\":i.ns[l]||\"\",p={name:c,value:u,prefix:l,local:T,uri:E};l&&\"xmlns\"!==l&&!E&&(y(t,\"Unbound namespace prefix: \"+JSON.stringify(l)),p.uri=l),t.tag.attributes[c]=p,F(t,\"onattribute\",p)}t.attribList.length=0}t.tag.isSelfClosing=!!e,t.sawRoot=!0,t.tags.push(t.tag),F(t,\"onopentag\",t.tag),e||(t.noscript||\"script\"!==t.tagName.toLowerCase()?t.state=b.TEXT:t.state=b.SCRIPT,t.tag=null,t.tagName=\"\"),t.attribName=t.attribValue=\"\",t.attribList.length=0}function w(t){if(!t.tagName)return y(t,\"Weird empty close tag.\"),t.textNode+=\"</>\",void(t.state=b.TEXT);if(t.script){if(\"script\"!==t.tagName)return t.script+=\"</\"+t.tagName+\">\",t.tagName=\"\",void(t.state=b.SCRIPT);F(t,\"onscript\",t.script),t.script=\"\"}var e=t.tags.length,i=t.tagName;t.strict||(i=i[t.looseCase]());for(var s=i;e--;){if(t.tags[e].name===s)break;y(t,\"Unexpected close tag\")}if(e<0)return y(t,\"Unmatched closing tag: \"+t.tagName),t.textNode+=\"</\"+t.tagName+\">\",void(t.state=b.TEXT);t.tagName=i;for(var a=t.tags.length;a-- >e;){var r=t.tag=t.tags.pop();t.tagName=t.tag.name,F(t,\"onclosetag\",t.tagName);var n={};for(var o in r.ns)n[o]=r.ns[o];var c=t.tags[t.tags.length-1]||t;t.opt.xmlns&&r.ns!==c.ns&&Object.keys(r.ns).forEach(function(e){var i=r.ns[e];F(t,\"onclosenamespace\",{prefix:e,uri:i})})}0===e&&(t.closedRoot=!0),t.tagName=t.attribValue=t.attribName=\"\",t.attribList.length=0,t.state=b.TEXT}function G(t){var e,i=t.entity,s=i.toLowerCase(),a=\"\";return t.ENTITIES[i]?t.ENTITIES[i]:t.ENTITIES[s]?t.ENTITIES[s]:(\"#\"===(i=s).charAt(0)&&(\"x\"===i.charAt(1)?(i=i.slice(2),a=(e=parseInt(i,16)).toString(16)):(i=i.slice(1),a=(e=parseInt(i,10)).toString(10))),i=i.replace(/^0+/,\"\"),isNaN(e)||a.toLowerCase()!==i?(y(t,\"Invalid character entity\"),\"&\"+t.entity+\";\"):String.fromCodePoint(e))}function M(t,e){\"<\"===e?(t.state=b.OPEN_WAKA,t.startTagPosition=t.position):N(e)||(y(t,\"Non-whitespace before first tag.\"),t.textNode=e,t.state=b.TEXT)}function V(t,e){var i=\"\";return e<t.length&&(i=t.charAt(e)),i}b=e.STATE,String.fromCodePoint||(A=String.fromCharCode,I=Math.floor,D=function(){var t,e,i=[],s=-1,a=arguments.length;if(!a)return\"\";for(var r=\"\";++s<a;){var n=Number(arguments[s]);if(!isFinite(n)||n<0||n>1114111||I(n)!==n)throw RangeError(\"Invalid code point: \"+n);n<=65535?i.push(n):(t=55296+((n-=65536)>>10),e=n%1024+56320,i.push(t,e)),(s+1===a||i.length>16384)&&(r+=A.apply(null,i),i.length=0)}return r},Object.defineProperty?Object.defineProperty(String,\"fromCodePoint\",{value:D,configurable:!0,writable:!0}):String.fromCodePoint=D)}(\"undefined\"==typeof exports?this.sax={}:exports);\n},{\"stream\":\"fnRj\",\"string_decoder\":\"z0rv\",\"buffer\":\"peL6\"}],\"8Kdp\":[function(require,module,exports) {\n\"use strict\";var e=require(\"sax\"),t=require(\"../../utils/promish\"),n=require(\"../../utils/xml-stream\"),r=module.exports=function(){};r.prototype={prepare:function(){},render:function(){},parseOpen:function(){},parseText:function(){},parseClose:function(){},reconcile:function(){},reset:function(){if(this.model=null,this.map)for(var e=Object.keys(this.map),t=0;t<e.length;t++)this.map[e[t]].reset()},mergeModel:function(e){this.model=Object.assign(this.model||{},e)},parse:function(e,n){var r=this;return new t.Promish(function(t,o){function i(t){e.removeAllListeners(),n.unpipe(e),o(t)}e.on(\"opentag\",function(e){try{r.parseOpen(e)}catch(t){i(t)}}),e.on(\"text\",function(e){try{r.parseText(e)}catch(t){i(t)}}),e.on(\"closetag\",function(e){try{r.parseClose(e)||t(r.model)}catch(n){i(n)}}),e.on(\"end\",function(){t(r.model)}),e.on(\"error\",function(e){i(e)})})},parseStream:function(t){var n=e.createStream(!0,{}),r=this.parse(n,t);return t.pipe(n),r},get xml(){return this.toXml(this.model)},toXml:function(e){var t=new n;return this.render(t,e),t.xml}};\n},{\"sax\":\"YfFG\",\"../../utils/promish\":\"vJr6\",\"../../utils/xml-stream\":\"WHow\"}],\"sWkd\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../utils/utils\"),t=require(\"./base-xform\"),r=require(\"../../utils/xml-stream\");function i(e,t){e.openNode(t.tag,t.$),t.c&&t.c.forEach(function(t){i(e,t)}),t.t&&e.writeText(t.t),e.closeNode()}var n=module.exports=function(e){this._model=e};e.inherits(n,t,{render:function(e){if(!this._xml){var t=new r;i(t,this._model),this._xml=t.xml}e.writeXml(this._xml)},parseOpen:function(){return!0},parseText:function(){},parseClose:function(e){switch(e){case this._model.tag:return!1;default:return!0}}});\n},{\"../../utils/utils\":\"gei3\",\"./base-xform\":\"8Kdp\",\"../../utils/xml-stream\":\"WHow\"}],\"+cuX\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../utils/utils\"),e=require(\"./base-xform\"),r=module.exports=function(t){this.tag=t.tag,this.count=t.count,this.empty=t.empty,this.$count=t.$count||\"count\",this.$=t.$,this.childXform=t.childXform,this.maxItems=t.maxItems};t.inherits(r,e,{prepare:function(t,e){var r=this.childXform;t&&t.forEach(function(t){r.prepare(t,e)})},render:function(t,e){if(e&&e.length){t.openNode(this.tag,this.$),this.count&&t.addAttribute(this.$count,e.length);var r=this.childXform;e.forEach(function(e){r.render(t,e)}),t.closeNode()}else this.empty&&t.leafNode(this.tag)},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case this.tag:return this.model=[],!0;default:return!!this.childXform.parseOpen(t)&&(this.parser=this.childXform,!0)}},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){if(this.parser){if(!this.parser.parseClose(t)&&(this.model.push(this.parser.model),this.parser=void 0,this.maxItems&&this.model.length>this.maxItems))throw new Error(\"Max \"+this.childXform.tag+\" count exceeded\");return!0}return!1},reconcile:function(t,e){if(t){var r=this.childXform;t.forEach(function(t){r.reconcile(t,e)})}}});\n},{\"../../utils/utils\":\"gei3\",\"./base-xform\":\"8Kdp\"}],\"YVuT\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),i=module.exports=function(t){this.name=t||\"color\"};t.inherits(i,e,{get tag(){return this.name},render:function(t,e){return!!e&&(t.openNode(this.name),e.argb?t.addAttribute(\"rgb\",e.argb):void 0!==e.theme?(t.addAttribute(\"theme\",e.theme),void 0!==e.tint&&t.addAttribute(\"tint\",e.tint)):void 0!==e.indexed?t.addAttribute(\"indexed\",e.indexed):t.addAttribute(\"auto\",\"1\"),t.closeNode(),!0)},parseOpen:function(t){return t.name===this.name&&(t.attributes.rgb?this.model={argb:t.attributes.rgb}:t.attributes.theme?(this.model={theme:parseInt(t.attributes.theme,10)},t.attributes.tint&&(this.model.tint=parseFloat(t.attributes.tint))):t.attributes.indexed?this.model={indexed:parseInt(t.attributes.indexed,10)}:this.model=void 0,!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"Ym9D\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=module.exports=function(t){this.tag=t.tag,this.attr=t.attr};t.inherits(r,e,{render:function(t,e){e&&(t.openNode(this.tag),t.closeNode())},parseOpen:function(t){t.name===this.tag&&(this.model=!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"kNo+\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),s=require(\"../base-xform\"),e=module.exports=function(t){this.tag=t.tag,this.attr=t.attr,this.attrs=t.attrs,this.zero=t.zero};t.inherits(e,s,{render:function(t,s){(s||this.zero)&&(t.openNode(this.tag),this.attrs&&t.addAttributes(this.attrs),this.attr?t.addAttribute(this.attr,s):t.writeText(s),t.closeNode())},parseOpen:function(t){return t.name===this.tag&&(this.attr?this.model=parseInt(t.attributes[this.attr],10):this.text=[],!0)},parseText:function(t){this.attr||this.text.push(t)},parseClose:function(){return this.attr||(this.model=parseInt(this.text.join(\"\")||0,10)),!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"2V03\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),s=require(\"../base-xform\"),i=module.exports=function(t){this.tag=t.tag,this.attr=t.attr,this.attrs=t.attrs};t.inherits(i,s,{render:function(t,s){void 0!==s&&(t.openNode(this.tag),this.attrs&&t.addAttributes(this.attrs),this.attr?t.addAttribute(this.attr,s):t.writeText(s),t.closeNode())},parseOpen:function(t){t.name===this.tag&&(this.attr?this.model=t.attributes[this.attr]:this.text=[])},parseText:function(t){this.attr||this.text.push(t)},parseClose:function(){return this.attr||(this.model=this.text.join(\"\")),!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"NwWL\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),u=module.exports=function(e){this.model=e};u.Attributes={single:{},double:{val:\"double\"},singleAccounting:{val:\"singleAccounting\"},doubleAccounting:{val:\"doubleAccounting\"}},e.inherits(u,t,{get tag(){return\"u\"},render:function(e,t){if(!0===(t=t||this.model))e.leafNode(\"u\");else{var n=u.Attributes[t];n&&e.leafNode(\"u\",n)}},parseOpen:function(e){\"u\"===e.name&&(this.model=e.attributes.val||!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"KlLO\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./color-xform\"),r=require(\"../simple/boolean-xform\"),t=require(\"../simple/integer-xform\"),a=require(\"../simple/string-xform\"),o=require(\"./underline-xform\"),s=require(\"../../../utils/under-dash\"),i=require(\"../../../utils/utils\"),n=require(\"../base-xform\"),p=module.exports=function(s){this.options=s||p.OPTIONS,this.map={b:{prop:\"bold\",xform:new r({tag:\"b\",attr:\"val\"})},i:{prop:\"italic\",xform:new r({tag:\"i\",attr:\"val\"})},u:{prop:\"underline\",xform:new o},charset:{prop:\"charset\",xform:new t({tag:\"charset\",attr:\"val\"})},color:{prop:\"color\",xform:new e},condense:{prop:\"condense\",xform:new r({tag:\"condense\",attr:\"val\"})},extend:{prop:\"extend\",xform:new r({tag:\"extend\",attr:\"val\"})},family:{prop:\"family\",xform:new t({tag:\"family\",attr:\"val\"})},outline:{prop:\"outline\",xform:new r({tag:\"outline\",attr:\"val\"})},vertAlign:{prop:\"vertAlign\",xform:new a({tag:\"vertAlign\",attr:\"val\"})},scheme:{prop:\"scheme\",xform:new a({tag:\"scheme\",attr:\"val\"})},shadow:{prop:\"shadow\",xform:new r({tag:\"shadow\",attr:\"val\"})},strike:{prop:\"strike\",xform:new r({tag:\"strike\",attr:\"val\"})},sz:{prop:\"size\",xform:new t({tag:\"sz\",attr:\"val\"})}},this.map[this.options.fontNameTag]={prop:\"name\",xform:new a({tag:this.options.fontNameTag,attr:\"val\"})}};p.OPTIONS={tagName:\"font\",fontNameTag:\"name\"},i.inherits(p,n,{get tag(){return this.options.tagName},render:function(e,r){var t=this.map;e.openNode(this.options.tagName),s.each(this.map,function(a,o){t[o].xform.render(e,r[a.prop])}),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;if(this.map[e.name])return this.parser=this.map[e.name].xform,this.parser.parseOpen(e);switch(e.name){case this.options.tagName:return this.model={},!0;default:return!1}},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser&&!this.parser.parseClose(e)){var r=this.map[e];return this.parser.model&&(this.model[r.prop]=this.parser.model),this.parser=void 0,!0}switch(e){case this.options.tagName:return!1;default:return!0}}});\n},{\"./color-xform\":\"YVuT\",\"../simple/boolean-xform\":\"Ym9D\",\"../simple/integer-xform\":\"kNo+\",\"../simple/string-xform\":\"2V03\",\"./underline-xform\":\"NwWL\",\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"AIsy\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=require(\"./color-xform\"),s=function(){this.map={color:new r}};t.inherits(s,e,{get tag(){return\"stop\"},render:function(t,e){t.openNode(\"stop\"),t.addAttribute(\"position\",e.position),this.map.color.render(t,e.color),t.closeNode()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case\"stop\":return this.model={position:parseFloat(t.attributes.position)},!0;case\"color\":return this.parser=this.map.color,this.parser.parseOpen(t),!0;default:return!1}},parseText:function(){},parseClose:function(t){return!!this.parser&&(this.parser.parseClose(t)||(this.model.color=this.parser.model,this.parser=void 0),!0)}});var a=function(){this.map={fgColor:new r(\"fgColor\"),bgColor:new r(\"bgColor\")}};t.inherits(a,e,{get name(){return\"pattern\"},get tag(){return\"patternFill\"},render:function(t,e){t.openNode(\"patternFill\"),t.addAttribute(\"patternType\",e.pattern),e.fgColor&&this.map.fgColor.render(t,e.fgColor),e.bgColor&&this.map.bgColor.render(t,e.bgColor),t.closeNode()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case\"patternFill\":return this.model={type:\"pattern\",pattern:t.attributes.patternType},!0;default:return this.parser=this.map[t.name],!!this.parser&&(this.parser.parseOpen(t),!0)}},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){return!!this.parser&&(this.parser.parseClose(t)||(this.parser.model&&(this.model[t]=this.parser.model),this.parser=void 0),!0)}});var i=function(){this.map={stop:new s}};t.inherits(i,e,{get name(){return\"gradient\"},get tag(){return\"gradientFill\"},render:function(t,e){switch(t.openNode(\"gradientFill\"),e.gradient){case\"angle\":t.addAttribute(\"degree\",e.degree);break;case\"path\":t.addAttribute(\"type\",\"path\"),e.center.left&&(t.addAttribute(\"left\",e.center.left),void 0===e.center.right&&t.addAttribute(\"right\",e.center.left)),e.center.right&&t.addAttribute(\"right\",e.center.right),e.center.top&&(t.addAttribute(\"top\",e.center.top),void 0===e.center.bottom&&t.addAttribute(\"bottom\",e.center.top)),e.center.bottom&&t.addAttribute(\"bottom\",e.center.bottom)}var r=this.map.stop;e.stops.forEach(function(e){r.render(t,e)}),t.closeNode()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case\"gradientFill\":var e=this.model={stops:[]};return t.attributes.degree?(e.gradient=\"angle\",e.degree=parseInt(t.attributes.degree,10)):\"path\"===t.attributes.type&&(e.gradient=\"path\",e.center={left:t.attributes.left?parseFloat(t.attributes.left):0,top:t.attributes.top?parseFloat(t.attributes.top):0},t.attributes.right!==t.attributes.left&&(e.center.right=t.attributes.right?parseFloat(t.attributes.right):0),t.attributes.bottom!==t.attributes.top&&(e.center.bottom=t.attributes.bottom?parseFloat(t.attributes.bottom):0)),!0;case\"stop\":return this.parser=this.map.stop,this.parser.parseOpen(t),!0;default:return!1}},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){return!!this.parser&&(this.parser.parseClose(t)||(this.model.stops.push(this.parser.model),this.parser=void 0),!0)}});var n=module.exports=function(){this.map={patternFill:new a,gradientFill:new i}};t.inherits(n,e,{StopXform:s,PatternFillXform:a,GradientFillXform:i},{get tag(){return\"fill\"},render:function(t,e){switch(t.addRollback(),t.openNode(\"fill\"),e.type){case\"pattern\":this.map.patternFill.render(t,e);break;case\"gradient\":this.map.gradientFill.render(t,e);break;default:return void t.rollback()}t.closeNode(),t.commit()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case\"fill\":return this.model={},!0;default:return this.parser=this.map[t.name],!!this.parser&&(this.parser.parseOpen(t),!0)}},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){return!!this.parser&&(this.parser.parseClose(t)||(this.model=this.parser.model,this.model.type=this.parser.name,this.parser=void 0),!0)},validPatternValues:[\"none\",\"solid\",\"darkVertical\",\"darkGray\",\"mediumGray\",\"lightGray\",\"gray125\",\"gray0625\",\"darkHorizontal\",\"darkVertical\",\"darkDown\",\"darkUp\",\"darkGrid\",\"darkTrellis\",\"lightHorizontal\",\"lightVertical\",\"lightDown\",\"lightUp\",\"lightGrid\",\"lightTrellis\",\"lightGrid\"].reduce(function(t,e){return t[e]=!0,t},{}),validStyle:function(t){return this.validStyleValues[t]}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"./color-xform\":\"YVuT\"}],\"39RA\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=require(\"./color-xform\"),a=function(t){this.name=t,this.map={color:new r}};t.inherits(a,e,{get tag(){return this.name},render:function(t,e,r){var a=e&&e.color||r||this.defaultColor;t.openNode(this.name),e&&e.style&&(t.addAttribute(\"style\",e.style),a&&this.map.color.render(t,a)),t.closeNode()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case this.name:var e=t.attributes.style;return this.model=e?{style:e}:void 0,!0;case\"color\":return this.parser=this.map.color,this.parser.parseOpen(t),!0;default:return!1}},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){return this.parser?(this.parser.parseClose(t)||(this.parser=void 0),!0):(t===this.name&&this.map.color.model&&(this.model||(this.model={}),this.model.color=this.map.color.model),!1)},validStyleValues:[\"thin\",\"dotted\",\"dashDot\",\"hair\",\"dashDotDot\",\"slantDashDot\",\"mediumDashed\",\"mediumDashDotDot\",\"mediumDashDot\",\"medium\",\"double\",\"thick\"].reduce(function(t,e){return t[e]=!0,t},{}),validStyle:function(t){return this.validStyleValues[t]}});var o=module.exports=function(){this.map={top:new a(\"top\"),left:new a(\"left\"),bottom:new a(\"bottom\"),right:new a(\"right\"),diagonal:new a(\"diagonal\")}};t.inherits(o,e,{render:function(t,e){var r=e.color;function a(a,o){a&&!a.color&&e.color&&(a=Object.assign({},a,{color:e.color})),o.render(t,a,r)}t.openNode(\"border\"),e.diagonal&&e.diagonal.style&&(e.diagonal.up&&t.addAttribute(\"diagonalUp\",\"1\"),e.diagonal.down&&t.addAttribute(\"diagonalDown\",\"1\")),a(e.left,this.map.left),a(e.right,this.map.right),a(e.top,this.map.top),a(e.bottom,this.map.bottom),a(e.diagonal,this.map.diagonal),t.closeNode()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case\"border\":return this.reset(),this.diagonalUp=!!t.attributes.diagonalUp,this.diagonalDown=!!t.attributes.diagonalDown,!0;default:return this.parser=this.map[t.name],!!this.parser&&(this.parser.parseOpen(t),!0)}},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){if(this.parser)return this.parser.parseClose(t)||(this.parser=void 0),!0;if(\"border\"===t){var e=this.model={},r=function(t,r,a){r&&(a&&Object.assign(r,a),e[t]=r)};r(\"left\",this.map.left.model),r(\"right\",this.map.right.model),r(\"top\",this.map.top.model),r(\"bottom\",this.map.bottom.model),r(\"diagonal\",this.map.diagonal.model,{up:this.diagonalUp,down:this.diagonalDown})}return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"./color-xform\":\"YVuT\"}],\"NzZu\":[function(require,module,exports) {\n\"use strict\";module.exports={0:{f:\"General\"},1:{f:\"0\"},2:{f:\"0.00\"},3:{f:\"#,##0\"},4:{f:\"#,##0.00\"},9:{f:\"0%\"},10:{f:\"0.00%\"},11:{f:\"0.00E+00\"},12:{f:\"# ?/?\"},13:{f:\"# ??/??\"},14:{f:\"mm-dd-yy\"},15:{f:\"d-mmm-yy\"},16:{f:\"d-mmm\"},17:{f:\"mmm-yy\"},18:{f:\"h:mm AM/PM\"},19:{f:\"h:mm:ss AM/PM\"},20:{f:\"h:mm\"},21:{f:\"h:mm:ss\"},22:{f:'m/d/yy \"h\":mm'},27:{\"zh-tw\":\"[$-404]e/m/d\",\"zh-cn\":'yyyy\"年\"m\"月\"',\"ja-jp\":\"[$-411]ge.m.d\",\"ko-kr\":'yyyy\"年\" mm\"月\" dd\"日\"'},28:{\"zh-tw\":'[$-404]e\"年\"m\"月\"d\"日\"',\"zh-cn\":'m\"月\"d\"日\"',\"ja-jp\":'[$-411]ggge\"年\"m\"月\"d\"日\"',\"ko-kr\":\"mm-dd\"},29:{\"zh-tw\":'[$-404]e\"年\"m\"月\"d\"日\"',\"zh-cn\":'m\"月\"d\"日\"',\"ja-jp\":'[$-411]ggge\"年\"m\"月\"d\"日\"',\"ko-kr\":\"mm-dd\"},30:{\"zh-tw\":\"m/d/yy \",\"zh-cn\":\"m-d-yy\",\"ja-jp\":\"m/d/yy\",\"ko-kr\":\"mm-dd-yy\"},31:{\"zh-tw\":'yyyy\"年\"m\"月\"d\"日\"',\"zh-cn\":'yyyy\"年\"m\"月\"d\"日\"',\"ja-jp\":'yyyy\"年\"m\"月\"d\"日\"',\"ko-kr\":'yyyy\"년\" mm\"월\" dd\"일\"'},32:{\"zh-tw\":'hh\"時\"mm\"分\"',\"zh-cn\":'h\"时\"mm\"分\"',\"ja-jp\":'h\"時\"mm\"分\"',\"ko-kr\":'h\"시\" mm\"분\"'},33:{\"zh-tw\":'hh\"時\"mm\"分\"ss\"秒\"',\"zh-cn\":'h\"时\"mm\"分\"ss\"秒\"',\"ja-jp\":'h\"時\"mm\"分\"ss\"秒\"',\"ko-kr\":'h\"시\" mm\"분\" ss\"초\"'},34:{\"zh-tw\":'上午/下午 hh\"時\"mm\"分\"',\"zh-cn\":'上午/下午 h\"时\"mm\"分\"',\"ja-jp\":'yyyy\"年\"m\"月\"',\"ko-kr\":\"yyyy-mm-dd\"},35:{\"zh-tw\":'上午/下午 hh\"時\"mm\"分\"ss\"秒\"',\"zh-cn\":'上午/下午 h\"时\"mm\"分\"ss\"秒\"',\"ja-jp\":'m\"月\"d\"日\"',\"ko-kr\":\"yyyy-mm-dd\"},36:{\"zh-tw\":\"[$-404]e/m/d\",\"zh-cn\":'yyyy\"年\"m\"月\"',\"ja-jp\":\"[$-411]ge.m.d\",\"ko-kr\":'yyyy\"年\" mm\"月\" dd\"日\"'},37:{f:\"#,##0 ;(#,##0)\"},38:{f:\"#,##0 ;[Red](#,##0)\"},39:{f:\"#,##0.00 ;(#,##0.00)\"},40:{f:\"#,##0.00 ;[Red](#,##0.00)\"},45:{f:\"mm:ss\"},46:{f:\"[h]:mm:ss\"},47:{f:\"mmss.0\"},48:{f:\"##0.0E+0\"},49:{f:\"@\"},50:{\"zh-tw\":\"[$-404]e/m/d\",\"zh-cn\":'yyyy\"年\"m\"月\"',\"ja-jp\":\"[$-411]ge.m.d\",\"ko-kr\":'yyyy\"年\" mm\"月\" dd\"日\"'},51:{\"zh-tw\":'[$-404]e\"年\"m\"月\"d\"日\"',\"zh-cn\":'m\"月\"d\"日\"',\"ja-jp\":'[$-411]ggge\"年\"m\"月\"d\"日\"',\"ko-kr\":\"mm-dd\"},52:{\"zh-tw\":'上午/下午 hh\"時\"mm\"分\"',\"zh-cn\":'yyyy\"年\"m\"月\"',\"ja-jp\":'yyyy\"年\"m\"月\"',\"ko-kr\":\"yyyy-mm-dd\"},53:{\"zh-tw\":'上午/下午 hh\"時\"mm\"分\"ss\"秒\"',\"zh-cn\":'m\"月\"d\"日\"',\"ja-jp\":'m\"月\"d\"日\"',\"ko-kr\":\"yyyy-mm-dd\"},54:{\"zh-tw\":'[$-404]e\"年\"m\"月\"d\"日\"',\"zh-cn\":'m\"月\"d\"日\"',\"ja-jp\":'[$-411]ggge\"年\"m\"月\"d\"日\"',\"ko-kr\":\"mm-dd\"},55:{\"zh-tw\":'上午/下午 hh\"時\"mm\"分\"',\"zh-cn\":'上午/下午 h\"时\"mm\"分\"',\"ja-jp\":'yyyy\"年\"m\"月\"',\"ko-kr\":\"yyyy-mm-dd\"},56:{\"zh-tw\":'上午/下午 hh\"時\"mm\"分\"ss\"秒\"',\"zh-cn\":'上午/下午 h\"时\"mm\"分\"ss\"秒\"',\"ja-jp\":'m\"月\"d\"日\"',\"ko-kr\":\"yyyy-mm-dd\"},57:{\"zh-tw\":\"[$-404]e/m/d\",\"zh-cn\":'yyyy\"年\"m\"月\"',\"ja-jp\":\"[$-411]ge.m.d\",\"ko-kr\":'yyyy\"年\" mm\"月\" dd\"日\"'},58:{\"zh-tw\":'[$-404]e\"年\"m\"月\"d\"日\"',\"zh-cn\":'m\"月\"d\"日\"',\"ja-jp\":'[$-411]ggge\"年\"m\"月\"d\"日\"',\"ko-kr\":\"mm-dd\"},59:{\"th-th\":\"t0\"},60:{\"th-th\":\"t0.00\"},61:{\"th-th\":\"t#,##0\"},62:{\"th-th\":\"t#,##0.00\"},67:{\"th-th\":\"t0%\"},68:{\"th-th\":\"t0.00%\"},69:{\"th-th\":\"t# ?/?\"},70:{\"th-th\":\"t# ??/??\"},81:{\"th-th\":\"d/m/bb\"}};\n},{}],\"wKb1\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/under-dash\"),e=require(\"../../../utils/utils\"),r=require(\"../../defaultnumformats\"),n=require(\"../base-xform\");function u(){var e={};return t.each(r,function(t,r){t.f&&(e[t.f]=parseInt(r,10))}),e}var a=u(),i=module.exports=function(t,e){this.id=t,this.formatCode=e};e.inherits(i,n,{get tag(){return\"numFmt\"},getDefaultFmtId:function(t){return a[t]},getDefaultFmtCode:function(t){return r[t]&&r[t].f}},{render:function(t,e){t.leafNode(\"numFmt\",{numFmtId:e.id,formatCode:e.formatCode})},parseOpen:function(t){switch(t.name){case\"numFmt\":return this.model={id:parseInt(t.attributes.numFmtId,10),formatCode:t.attributes.formatCode.replace(/[\\\\](.)/g,\"$1\")},!0;default:return!1}},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../../defaultnumformats\":\"NzZu\",\"../base-xform\":\"8Kdp\"}],\"kmCA\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../doc/enums\"),r=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),i={horizontalValues:[\"left\",\"center\",\"right\",\"fill\",\"centerContinuous\",\"distributed\",\"justify\"].reduce(function(t,r){return t[r]=!0,t},{}),horizontal:function(t){return this.horizontalValues[t]?t:void 0},verticalValues:[\"top\",\"middle\",\"bottom\",\"distributed\",\"justify\"].reduce(function(t,r){return t[r]=!0,t},{}),vertical:function(t){return\"middle\"===t?\"center\":this.verticalValues[t]?t:void 0},wrapText:function(t){return!!t||void 0},shrinkToFit:function(t){return!!t||void 0},textRotation:function(t){switch(t){case\"vertical\":return t;default:return(t=r.validInt(t))>=-90&&t<=90?t:void 0}},indent:function(t){return t=r.validInt(t),Math.max(0,t)},readingOrder:function(r){switch(r){case\"ltr\":return t.ReadingOrder.LeftToRight;case\"rtl\":return t.ReadingOrder.RightToLeft;default:return}}},n={toXml:function(t){if(t=i.textRotation(t)){if(\"vertical\"===t)return 255;var r=Math.round(t);if(r>=0&&r<=90)return r;if(r<0&&r>=-90)return 90-r}},toModel:function(t){var e=r.validInt(t);if(void 0!==e){if(255===e)return\"vertical\";if(e>=0&&e<=90)return e;if(e>90&&e<=180)return 90-e}}},a=module.exports=function(){};r.inherits(a,e,{get tag(){return\"alignment\"},render:function(t,r){t.addRollback(),t.openNode(\"alignment\");var e=!1;function a(r,i){i&&(t.addAttribute(r,i),e=!0)}a(\"horizontal\",i.horizontal(r.horizontal)),a(\"vertical\",i.vertical(r.vertical)),a(\"wrapText\",!!i.wrapText(r.wrapText)&&\"1\"),a(\"shrinkToFit\",!!i.shrinkToFit(r.shrinkToFit)&&\"1\"),a(\"indent\",i.indent(r.indent)),a(\"textRotation\",n.toXml(r.textRotation)),a(\"readingOrder\",i.readingOrder(r.readingOrder)),t.closeNode(),e?t.commit():t.rollback()},parseOpen:function(t){var r={},e=!1;function i(t,i,n){t&&(r[i]=n,e=!0)}i(t.attributes.horizontal,\"horizontal\",t.attributes.horizontal),i(t.attributes.vertical,\"vertical\",\"center\"===t.attributes.vertical?\"middle\":t.attributes.vertical),i(t.attributes.wrapText,\"wrapText\",!!t.attributes.wrapText),i(t.attributes.shrinkToFit,\"shrinkToFit\",!!t.attributes.shrinkToFit),i(t.attributes.indent,\"indent\",parseInt(t.attributes.indent,10)),i(t.attributes.textRotation,\"textRotation\",n.toModel(t.attributes.textRotation)),i(t.attributes.readingOrder,\"readingOrder\",\"2\"===t.attributes.readingOrder?\"rtl\":\"ltr\"),this.model=e?r:null},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../doc/enums\":\"YmZx\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"PN6C\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=require(\"./alignment-xform\"),i=module.exports=function(t){this.xfId=!(!t||!t.xfId),this.map={alignment:new r}};t.inherits(i,e,{get tag(){return\"xf\"},render:function(t,e){t.openNode(\"xf\",{numFmtId:e.numFmtId||0,fontId:e.fontId||0,fillId:e.fillId||0,borderId:e.borderId||0}),this.xfId&&t.addAttribute(\"xfId\",e.xfId||0),e.numFmtId&&t.addAttribute(\"applyNumberFormat\",\"1\"),e.fontId&&t.addAttribute(\"applyFont\",\"1\"),e.fillId&&t.addAttribute(\"applyFill\",\"1\"),e.borderId&&t.addAttribute(\"applyBorder\",\"1\"),e.alignment&&(t.addAttribute(\"applyAlignment\",\"1\"),this.map.alignment.render(t,e.alignment)),t.closeNode()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;switch(t.name){case\"xf\":return this.model={numFmtId:parseInt(t.attributes.numFmtId,10),fontId:parseInt(t.attributes.fontId,10),fillId:parseInt(t.attributes.fillId,10),borderId:parseInt(t.attributes.borderId,10)},this.xfId&&(this.model.xfId=parseInt(t.attributes.xfId,10)),!0;case\"alignment\":return this.parser=this.map.alignment,this.parser.parseOpen(t),!0;default:return!1}},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){return this.parser?(this.parser.parseClose(t)||(this.model.alignment=this.parser.model,this.parser=void 0),!0):\"xf\"!==t}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"./alignment-xform\":\"kmCA\"}],\"6gbp\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/promish\"),t=require(\"../../../utils/utils\"),s=require(\"../../../doc/enums\"),n=require(\"../../../utils/xml-stream\"),i=require(\"../base-xform\"),l=require(\"../static-xform\"),r=require(\"../list-xform\"),o=require(\"./font-xform\"),m=require(\"./fill-xform\"),d=require(\"./border-xform\"),a=require(\"./numfmt-xform\"),f=require(\"./style-xform\"),h=164,u=module.exports=function(e){this.map={numFmts:new r({tag:\"numFmts\",count:!0,childXform:new a}),fonts:new r({tag:\"fonts\",count:!0,childXform:new o,$:{\"x14ac:knownFonts\":1}}),fills:new r({tag:\"fills\",count:!0,childXform:new m}),borders:new r({tag:\"borders\",count:!0,childXform:new d}),cellStyleXfs:new r({tag:\"cellStyleXfs\",count:!0,childXform:new f}),cellXfs:new r({tag:\"cellXfs\",count:!0,childXform:new f({xfId:!0})}),numFmt:new a,font:new o,fill:new m,border:new d,style:new f({xfId:!0}),cellStyles:u.STATIC_XFORMS.cellStyles,dxfs:u.STATIC_XFORMS.dxfs,tableStyles:u.STATIC_XFORMS.tableStyles,extLst:u.STATIC_XFORMS.extLst},e&&this.init()};t.inherits(u,i,{STYLESHEET_ATTRIBUTES:{xmlns:\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\",\"xmlns:mc\":\"http://schemas.openxmlformats.org/markup-compatibility/2006\",\"mc:Ignorable\":\"x14ac x16r2\",\"xmlns:x14ac\":\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\",\"xmlns:x16r2\":\"http://schemas.microsoft.com/office/spreadsheetml/2015/02/main\"},STATIC_XFORMS:{cellStyles:new l({tag:\"cellStyles\",$:{count:1},c:[{tag:\"cellStyle\",$:{name:\"Normal\",xfId:0,builtinId:0}}]}),dxfs:new l({tag:\"dxfs\",$:{count:0}}),tableStyles:new l({tag:\"tableStyles\",$:{count:0,defaultTableStyle:\"TableStyleMedium2\",defaultPivotStyle:\"PivotStyleLight16\"}}),extLst:new l({tag:\"extLst\",c:[{tag:\"ext\",$:{uri:\"{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}\",\"xmlns:x14\":\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/main\"},c:[{tag:\"x14:slicerStyles\",$:{defaultSlicerStyle:\"SlicerStyleLight1\"}}]},{tag:\"ext\",$:{uri:\"{9260A510-F301-46a8-8635-F512D64BE5F5}\",\"xmlns:x15\":\"http://schemas.microsoft.com/office/spreadsheetml/2010/11/main\"},c:[{tag:\"x15:timelineStyles\",$:{defaultTimelineStyle:\"TimeSlicerStyleLight1\"}}]}]})}},{initIndex:function(){this.index={style:{},numFmt:{},numFmtNextId:164,font:{},border:{},fill:{}}},init:function(){this.model={styles:[],numFmts:[],fonts:[],borders:[],fills:[]},this.initIndex(),this._addFont({size:11,color:{theme:1},name:\"Calibri\",family:2,scheme:\"minor\"}),this._addBorder({}),this._addStyle({numFmtId:0,fontId:0,fillId:0,borderId:0,xfId:0}),this._addFill({type:\"pattern\",pattern:\"none\"}),this._addFill({type:\"pattern\",pattern:\"gray125\"})},render:function(e,t){t=t||this.model,e.openXml(n.StdDocAttributes),e.openNode(\"styleSheet\",u.STYLESHEET_ATTRIBUTES),this.index?(t.numFmts&&t.numFmts.length&&(e.openNode(\"numFmts\",{count:t.numFmts.length}),t.numFmts.forEach(function(t){e.writeXml(t)}),e.closeNode()),e.openNode(\"fonts\",{count:t.fonts.length}),t.fonts.forEach(function(t){e.writeXml(t)}),e.closeNode(),e.openNode(\"fills\",{count:t.fills.length}),t.fills.forEach(function(t){e.writeXml(t)}),e.closeNode(),e.openNode(\"borders\",{count:t.borders.length}),t.borders.forEach(function(t){e.writeXml(t)}),e.closeNode(),this.map.cellStyleXfs.render(e,[{numFmtId:0,fontId:0,fillId:0,borderId:0,xfId:0}]),e.openNode(\"cellXfs\",{count:t.styles.length}),t.styles.forEach(function(t){e.writeXml(t)}),e.closeNode()):(this.map.numFmts.render(e,t.numFmts),this.map.fonts.render(e,t.fonts),this.map.fills.render(e,t.fills),this.map.borders.render(e,t.borders),this.map.cellStyleXfs.render(e,[{numFmtId:0,fontId:0,fillId:0,borderId:0,xfId:0}]),this.map.cellXfs.render(e,t.styles)),u.STATIC_XFORMS.cellStyles.render(e),u.STATIC_XFORMS.dxfs.render(e),u.STATIC_XFORMS.tableStyles.render(e),u.STATIC_XFORMS.extLst.render(e),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case\"styleSheet\":return this.initIndex(),!0;default:return this.parser=this.map[e.name],this.parser&&this.parser.parseOpen(e),!0}},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.parser=void 0),!0;switch(e){case\"styleSheet\":var t=this.model={},s=function(e,s){s.model&&s.model.length&&(t[e]=s.model)};if(s(\"numFmts\",this.map.numFmts),s(\"fonts\",this.map.fonts),s(\"fills\",this.map.fills),s(\"borders\",this.map.borders),s(\"styles\",this.map.cellXfs),this.index={model:[],numFmt:[]},t.numFmts){var n=this.index.numFmt;t.numFmts.forEach(function(e){n[e.id]=e.formatCode})}return!1;default:return!0}},addStyleModel:function(e,t){if(!e)return 0;if(this.weakMap&&this.weakMap.has(e))return this.weakMap.get(e);var n={};if(t=t||s.ValueType.Number,e.numFmt)n.numFmtId=this._addNumFmtStr(e.numFmt);else switch(t){case s.ValueType.Number:n.numFmtId=this._addNumFmtStr(\"General\");break;case s.ValueType.Date:n.numFmtId=this._addNumFmtStr(\"mm-dd-yy\")}e.font&&(n.fontId=this._addFont(e.font)),e.border&&(n.borderId=this._addBorder(e.border)),e.fill&&(n.fillId=this._addFill(e.fill)),e.alignment&&(n.alignment=e.alignment);var i=this._addStyle(n);return this.weakMap&&this.weakMap.set(e,i),i},getStyleModel:function(e){var t=this.model.styles[e];if(!t)return null;var s=this.index.model[e];if(s)return s;if(s=this.index.model[e]={},t.numFmtId){var n=this.index.numFmt[t.numFmtId]||a.getDefaultFmtCode(t.numFmtId);n&&(s.numFmt=n)}function i(e,t,n){if(n){var i=t[n];i&&(s[e]=i)}}return i(\"font\",this.model.fonts,t.fontId),i(\"border\",this.model.borders,t.borderId),i(\"fill\",this.model.fills,t.fillId),t.alignment&&(s.alignment=t.alignment),s},_addStyle:function(e){var t=this.map.style.toXml(e),s=this.index.style[t];return void 0===s&&(s=this.index.style[t]=this.model.styles.length,this.model.styles.push(t)),s},_addNumFmtStr:function(e){var t=a.getDefaultFmtId(e);if(void 0!==t)return t;if(void 0!==(t=this.index.numFmt[e]))return t;t=this.index.numFmt[e]=h+this.model.numFmts.length;var s=this.map.numFmt.toXml({id:t,formatCode:e});return this.model.numFmts.push(s),t},_addFont:function(e){var t=this.map.font.toXml(e),s=this.index.font[t];return void 0===s&&(s=this.index.font[t]=this.model.fonts.length,this.model.fonts.push(t)),s},_addBorder:function(e){var t=this.map.border.toXml(e),s=this.index.border[t];return void 0===s&&(s=this.index.border[t]=this.model.borders.length,this.model.borders.push(t)),s},_addFill:function(e){var t=this.map.fill.toXml(e),s=this.index.fill[t];return void 0===s&&(s=this.index.fill[t]=this.model.fills.length,this.model.fills.push(t)),s}}),u.Mock=function(){u.call(this),this.model={styles:[{numFmtId:0,fontId:0,fillId:0,borderId:0,xfId:0}],numFmts:[],fonts:[{size:11,color:{theme:1},name:\"Calibri\",family:2,scheme:\"minor\"}],borders:[{}],fills:[{type:\"pattern\",pattern:\"none\"},{type:\"pattern\",pattern:\"gray125\"}]}},t.inherits(u.Mock,u,{parseStream:function(t){return t.autodrain(),e.Promish.resolve()},addStyleModel:function(e,t){switch(t){case s.ValueType.Date:return this.dateStyleId;default:return 0}},get dateStyleId(){if(!this._dateStyleId){var e={numFmtId:a.getDefaultFmtId(\"mm-dd-yy\")};this._dateStyleId=this.model.styles.length,this.model.styles.push(e)}return this._dateStyleId},getStyleModel:function(){return{}}});\n},{\"../../../utils/promish\":\"vJr6\",\"../../../utils/utils\":\"gei3\",\"../../../doc/enums\":\"YmZx\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\",\"../static-xform\":\"sWkd\",\"../list-xform\":\"+cuX\",\"./font-xform\":\"KlLO\",\"./fill-xform\":\"AIsy\",\"./border-xform\":\"39RA\",\"./numfmt-xform\":\"wKb1\",\"./style-xform\":\"PN6C\"}],\"gXOj\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),s=module.exports=function(t){this.tag=t.tag,this.attr=t.attr,this.attrs=t.attrs,this._format=t.format||function(t){try{return isNaN(t.getTime())?\"\":t.toISOString()}catch(r){return\"\"}},this._parse=t.parse||function(t){return new Date(t)}};t.inherits(s,r,{render:function(t,r){r&&(t.openNode(this.tag),this.attrs&&t.addAttributes(this.attrs),this.attr?t.addAttribute(this.attr,this._format(r)):t.writeText(this._format(r)),t.closeNode())},parseOpen:function(t){t.name===this.tag&&(this.attr?this.model=this._parse(t.attributes[this.attr]):this.text=[])},parseText:function(t){this.attr||this.text.push(t)},parseClose:function(){return this.attr||(this.model=this._parse(this.text.join(\"\"))),!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"URat\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../../../utils/xml-stream\"),r=require(\"../base-xform\"),i=require(\"../simple/date-xform\"),s=require(\"../simple/string-xform\"),a=require(\"../simple/integer-xform\"),c=module.exports=function(){this.map={\"dc:creator\":new s({tag:\"dc:creator\"}),\"dc:title\":new s({tag:\"dc:title\"}),\"dc:subject\":new s({tag:\"dc:subject\"}),\"dc:description\":new s({tag:\"dc:description\"}),\"dc:identifier\":new s({tag:\"dc:identifier\"}),\"dc:language\":new s({tag:\"dc:language\"}),\"cp:keywords\":new s({tag:\"cp:keywords\"}),\"cp:category\":new s({tag:\"cp:category\"}),\"cp:lastModifiedBy\":new s({tag:\"cp:lastModifiedBy\"}),\"cp:lastPrinted\":new i({tag:\"cp:lastPrinted\",format:c.DateFormat}),\"cp:revision\":new a({tag:\"cp:revision\"}),\"cp:version\":new s({tag:\"cp:version\"}),\"cp:contentStatus\":new s({tag:\"cp:contentStatus\"}),\"cp:contentType\":new s({tag:\"cp:contentType\"}),\"dcterms:created\":new i({tag:\"dcterms:created\",attrs:c.DateAttrs,format:c.DateFormat}),\"dcterms:modified\":new i({tag:\"dcterms:modified\",attrs:c.DateAttrs,format:c.DateFormat})}};c.DateFormat=function(e){return e.toISOString().replace(/[.]\\d{3}/,\"\")},c.DateAttrs={\"xsi:type\":\"dcterms:W3CDTF\"},c.CORE_PROPERTY_ATTRIBUTES={\"xmlns:cp\":\"http://schemas.openxmlformats.org/package/2006/metadata/core-properties\",\"xmlns:dc\":\"http://purl.org/dc/elements/1.1/\",\"xmlns:dcterms\":\"http://purl.org/dc/terms/\",\"xmlns:dcmitype\":\"http://purl.org/dc/dcmitype/\",\"xmlns:xsi\":\"http://www.w3.org/2001/XMLSchema-instance\"},e.inherits(c,r,{render:function(e,r){e.openXml(t.StdDocAttributes),e.openNode(\"cp:coreProperties\",c.CORE_PROPERTY_ATTRIBUTES),this.map[\"dc:creator\"].render(e,r.creator),this.map[\"dc:title\"].render(e,r.title),this.map[\"dc:subject\"].render(e,r.subject),this.map[\"dc:description\"].render(e,r.description),this.map[\"dc:identifier\"].render(e,r.identifier),this.map[\"dc:language\"].render(e,r.language),this.map[\"cp:keywords\"].render(e,r.keywords),this.map[\"cp:category\"].render(e,r.category),this.map[\"cp:lastModifiedBy\"].render(e,r.lastModifiedBy),this.map[\"cp:lastPrinted\"].render(e,r.lastPrinted),this.map[\"cp:revision\"].render(e,r.revision),this.map[\"cp:version\"].render(e,r.version),this.map[\"cp:contentStatus\"].render(e,r.contentStatus),this.map[\"cp:contentType\"].render(e,r.contentType),this.map[\"dcterms:created\"].render(e,r.created),this.map[\"dcterms:modified\"].render(e,r.modified),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case\"cp:coreProperties\":case\"coreProperties\":return!0;default:if(this.parser=this.map[e.name],this.parser)return this.parser.parseOpen(e),!0;throw new Error(\"Unexpected xml node in parseOpen: \"+JSON.stringify(e))}},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.parser=void 0),!0;switch(e){case\"cp:coreProperties\":case\"coreProperties\":return this.model={creator:this.map[\"dc:creator\"].model,title:this.map[\"dc:title\"].model,subject:this.map[\"dc:subject\"].model,description:this.map[\"dc:description\"].model,identifier:this.map[\"dc:identifier\"].model,language:this.map[\"dc:language\"].model,keywords:this.map[\"cp:keywords\"].model,category:this.map[\"cp:category\"].model,lastModifiedBy:this.map[\"cp:lastModifiedBy\"].model,lastPrinted:this.map[\"cp:lastPrinted\"].model,revision:this.map[\"cp:revision\"].model,contentStatus:this.map[\"cp:contentStatus\"].model,contentType:this.map[\"cp:contentType\"].model,created:this.map[\"dcterms:created\"].model,modified:this.map[\"dcterms:modified\"].model},!1;default:throw new Error(\"Unexpected xml node in parseClose: \"+e)}}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\",\"../simple/date-xform\":\"gXOj\",\"../simple/string-xform\":\"2V03\",\"../simple/integer-xform\":\"kNo+\"}],\"2U2i\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,t,{get tag(){return\"t\"},render:function(e,t){e.openNode(\"t\"),\" \"!==t[0]&&\" \"!==t[t.length-1]||e.addAttribute(\"xml:space\",\"preserve\"),e.writeText(t),e.closeNode()},get model(){return this._text.join(\"\").replace(/_x([0-9A-F]{4})_/g,function(e,t){return String.fromCharCode(parseInt(t,16))})},parseOpen:function(e){switch(e.name){case\"t\":return this._text=[],!0;default:return!1}},parseText:function(e){this._text.push(e)},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"Yqg6\":[function(require,module,exports) {\n\"use strict\";var r=require(\"./text-xform\"),e=require(\"../style/font-xform\"),t=require(\"../../../utils/utils\"),s=require(\"../base-xform\"),i=module.exports=function(r){this.model=r};i.FONT_OPTIONS={tagName:\"rPr\",fontNameTag:\"rFont\"},t.inherits(i,s,{get tag(){return\"r\"},get textXform(){return this._textXform||(this._textXform=new r)},get fontXform(){return this._fontXform||(this._fontXform=new e(i.FONT_OPTIONS))},render:function(r,e){e=e||this.model,r.openNode(\"r\"),e.font&&this.fontXform.render(r,e.font),this.textXform.render(r,e.text),r.closeNode()},parseOpen:function(r){if(this.parser)return this.parser.parseOpen(r),!0;switch(r.name){case\"r\":return this.model={},!0;case\"t\":return this.parser=this.textXform,this.parser.parseOpen(r),!0;case\"rPr\":return this.parser=this.fontXform,this.parser.parseOpen(r),!0;default:return!1}},parseText:function(r){this.parser&&this.parser.parseText(r)},parseClose:function(r){switch(r){case\"r\":return!1;case\"t\":return this.model.text=this.parser.model,this.parser=void 0,!0;case\"rPr\":return this.model.font=this.parser.model,this.parser=void 0,!0;default:return this.parser&&this.parser.parseClose(r),!0}}});\n},{\"./text-xform\":\"2U2i\",\"../style/font-xform\":\"KlLO\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"rP1C\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./text-xform\"),r=require(\"./rich-text-xform\"),t=require(\"../../../utils/utils\"),s=require(\"../base-xform\"),i=module.exports=function(){this.map={r:new r,t:new e}};t.inherits(i,s,{get tag(){return\"rPh\"},render:function(e,r){if(e.openNode(this.tag,{sb:r.sb||0,eb:r.eb||0}),r&&r.hasOwnProperty(\"richText\")&&r.richText){var t=this.map.r;r.richText.forEach(function(r){t.render(e,r)})}else r&&this.map.t.render(e,r.text);e.closeNode()},parseOpen:function(e){var r=e.name;return this.parser?(this.parser.parseOpen(e),!0):r===this.tag?(this.model={sb:parseInt(e.attributes.sb,10),eb:parseInt(e.attributes.eb,10)},!0):(this.parser=this.map[r],!!this.parser&&(this.parser.parseOpen(e),!0))},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser){if(!this.parser.parseClose(e)){switch(e){case\"r\":var r=this.model.richText;r||(r=this.model.richText=[]),r.push(this.parser.model);break;case\"t\":this.model.text=this.parser.model}this.parser=void 0}return!0}switch(e){case this.tag:return!1;default:return!0}}});\n},{\"./text-xform\":\"2U2i\",\"./rich-text-xform\":\"Yqg6\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"IhcQ\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./text-xform\"),r=require(\"./rich-text-xform\"),t=require(\"./phonetic-text-xform\"),s=require(\"../../../utils/utils\"),i=require(\"../base-xform\"),a=module.exports=function(s){this.model=s,this.map={r:new r,t:new e,rPh:new t}};s.inherits(a,i,{get tag(){return\"si\"},render:function(e,r){if(e.openNode(this.tag),r&&r.hasOwnProperty(\"richText\")&&r.richText){var t=this.map.r;r.richText.forEach(function(r){t.render(e,r)})}else null!=r&&this.map.t.render(e,r);e.closeNode()},parseOpen:function(e){var r=e.name;return this.parser?(this.parser.parseOpen(e),!0):r===this.tag?(this.model={},!0):(this.parser=this.map[r],!!this.parser&&(this.parser.parseOpen(e),!0))},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser){if(!this.parser.parseClose(e)){switch(e){case\"r\":var r=this.model.richText;r||(r=this.model.richText=[]),r.push(this.parser.model);break;case\"t\":this.model=this.parser.model}this.parser=void 0}return!0}switch(e){case this.tag:return!1;default:return!0}}});\n},{\"./text-xform\":\"2U2i\",\"./rich-text-xform\":\"Yqg6\",\"./phonetic-text-xform\":\"rP1C\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"4BMP\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../../../utils/xml-stream\"),r=require(\"../base-xform\"),s=require(\"./shared-string-xform\"),i=module.exports=function(e){this.model=e||{values:[],count:0},this.hash={},this.rich={}};e.inherits(i,r,{get sharedStringXform(){return this._sharedStringXform||(this._sharedStringXform=new s)},get values(){return this.model.values},get uniqueCount(){return this.model.values.length},get count(){return this.model.count},getString:function(e){return this.model.values[e]},add:function(e){return e.richText?this.addRichText(e):this.addText(e)},addText:function(e){var t=this.hash[e];return void 0===t&&(t=this.hash[e]=this.model.values.length,this.model.values.push(e)),this.model.count++,t},addRichText:function(e){var t=this.sharedStringXform.toXml(e),r=this.rich[t];return void 0===r&&(r=this.rich[t]=this.model.values.length,this.model.values.push(e)),this.model.count++,r},render:function(e,r){r=r||this._values,e.openXml(t.StdDocAttributes),e.openNode(\"sst\",{xmlns:\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\",count:r.count,uniqueCount:r.values.length});var s=this.sharedStringXform;r.values.forEach(function(t){s.render(e,t)}),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case\"sst\":return!0;case\"si\":return this.parser=this.sharedStringXform,this.parser.parseOpen(e),!0;default:throw new Error(\"Unexpected xml node in parseOpen: \"+JSON.stringify(e))}},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.model.values.push(this.parser.model),this.model.count++,this.parser=void 0),!0;switch(e){case\"sst\":return!1;default:throw new Error(\"Unexpected xml node in parseClose: \"+e)}}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\",\"./shared-string-xform\":\"IhcQ\"}],\"uz0/\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,t,{render:function(e,t){e.leafNode(\"Relationship\",t)},parseOpen:function(e){switch(e.name){case\"Relationship\":return this.model=e.attributes,!0;default:return!1}},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"pJDE\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../../../utils/xml-stream\"),s=require(\"../base-xform\"),t=require(\"./relationship-xform\"),i=module.exports=function(){this.map={Relationship:new t}};e.inherits(i,s,{RELATIONSHIPS_ATTRIBUTES:{xmlns:\"http://schemas.openxmlformats.org/package/2006/relationships\"}},{render:function(e,s){s=s||this._values,e.openXml(r.StdDocAttributes),e.openNode(\"Relationships\",i.RELATIONSHIPS_ATTRIBUTES);var t=this;s.forEach(function(r){t.map.Relationship.render(e,r)}),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case\"Relationships\":return this.model=[],!0;default:if(this.parser=this.map[e.name],this.parser)return this.parser.parseOpen(e),!0;throw new Error(\"Unexpected xml node in parseOpen: \"+JSON.stringify(e))}},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.model.push(this.parser.model),this.parser=void 0),!0;switch(e){case\"Relationships\":return!1;default:throw new Error(\"Unexpected xml node in parseClose: \"+e)}}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\",\"./relationship-xform\":\"uz0/\"}],\"V2LX\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../../../utils/xml-stream\"),o=require(\"../base-xform\"),n=module.exports=function(){};e.inherits(n,o,{PROPERTY_ATTRIBUTES:{xmlns:\"http://schemas.openxmlformats.org/package/2006/content-types\"}},{render:function(e,o){e.openXml(t.StdDocAttributes),e.openNode(\"Types\",n.PROPERTY_ATTRIBUTES);var a={};(o.media||[]).forEach(function(t){if(\"image\"===t.type){var o=t.extension;a[o]||(a[o]=!0,e.leafNode(\"Default\",{Extension:o,ContentType:\"image/\"+o}))}}),e.leafNode(\"Default\",{Extension:\"rels\",ContentType:\"application/vnd.openxmlformats-package.relationships+xml\"}),e.leafNode(\"Default\",{Extension:\"xml\",ContentType:\"application/xml\"}),e.leafNode(\"Override\",{PartName:\"/xl/workbook.xml\",ContentType:\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml\"}),o.worksheets.forEach(function(t){var o=\"/xl/worksheets/sheet\"+t.id+\".xml\";e.leafNode(\"Override\",{PartName:o,ContentType:\"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml\"})}),e.leafNode(\"Override\",{PartName:\"/xl/theme/theme1.xml\",ContentType:\"application/vnd.openxmlformats-officedocument.theme+xml\"}),e.leafNode(\"Override\",{PartName:\"/xl/styles.xml\",ContentType:\"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml\"}),o.sharedStrings&&o.sharedStrings.count&&e.leafNode(\"Override\",{PartName:\"/xl/sharedStrings.xml\",ContentType:\"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml\"}),o.drawings&&o.drawings.forEach(function(t){e.leafNode(\"Override\",{PartName:\"/xl/drawings/\"+t.name+\".xml\",ContentType:\"application/vnd.openxmlformats-officedocument.drawing+xml\"})}),e.leafNode(\"Override\",{PartName:\"/docProps/core.xml\",ContentType:\"application/vnd.openxmlformats-package.core-properties+xml\"}),e.leafNode(\"Override\",{PartName:\"/docProps/app.xml\",ContentType:\"application/vnd.openxmlformats-officedocument.extended-properties+xml\"}),e.closeNode()},parseOpen:function(){return!1},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\"}],\"Kdpq\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),o=require(\"../base-xform\"),n=module.exports=function(){};e.inherits(n,o,{render:function(e,o){e.openNode(\"HeadingPairs\"),e.openNode(\"vt:vector\",{size:2,baseType:\"variant\"}),e.openNode(\"vt:variant\"),e.leafNode(\"vt:lpstr\",void 0,\"Worksheets\"),e.closeNode(),e.openNode(\"vt:variant\"),e.leafNode(\"vt:i4\",void 0,o.length),e.closeNode(),e.closeNode(),e.closeNode()},parseOpen:function(e){return\"HeadingPairs\"===e.name},parseText:function(){},parseClose:function(e){return\"HeadingPairs\"!==e}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"doS2\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,t,{render:function(e,t){e.openNode(\"TitlesOfParts\"),e.openNode(\"vt:vector\",{size:t.length,baseType:\"lpstr\"}),t.forEach(function(t){e.leafNode(\"vt:lpstr\",void 0,t.name)}),e.closeNode(),e.closeNode()},parseOpen:function(e){return\"TitlesOfParts\"===e.name},parseText:function(){},parseClose:function(e){return\"TitlesOfParts\"!==e}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"ndMK\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../../../utils/xml-stream\"),s=require(\"../base-xform\"),t=require(\"../simple/string-xform\"),a=require(\"./app-heading-pairs-xform\"),i=require(\"./app-titles-of-parts-xform\"),o=module.exports=function(){this.map={Company:new t({tag:\"Company\"}),Manager:new t({tag:\"Manager\"}),HeadingPairs:new a,TitleOfParts:new i}};o.DateFormat=function(e){return e.toISOString().replace(/[.]\\d{3,6}/,\"\")},o.DateAttrs={\"xsi:type\":\"dcterms:W3CDTF\"},o.PROPERTY_ATTRIBUTES={xmlns:\"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties\",\"xmlns:vt\":\"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes\"},e.inherits(o,s,{render:function(e,s){e.openXml(r.StdDocAttributes),e.openNode(\"Properties\",o.PROPERTY_ATTRIBUTES),e.leafNode(\"Application\",void 0,\"Microsoft Excel\"),e.leafNode(\"DocSecurity\",void 0,\"0\"),e.leafNode(\"ScaleCrop\",void 0,\"false\"),this.map.HeadingPairs.render(e,s.worksheets),this.map.TitleOfParts.render(e,s.worksheets),this.map.Company.render(e,s.company||\"\"),this.map.Manager.render(e,s.manager),e.leafNode(\"LinksUpToDate\",void 0,\"false\"),e.leafNode(\"SharedDoc\",void 0,\"false\"),e.leafNode(\"HyperlinksChanged\",void 0,\"false\"),e.leafNode(\"AppVersion\",void 0,\"16.0300\"),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case\"Properties\":return!0;default:return this.parser=this.map[e.name],!!this.parser&&(this.parser.parseOpen(e),!0)}},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.parser=void 0),!0;switch(e){case\"Properties\":return this.model={worksheets:this.map.TitleOfParts.model,company:this.map.Company.model,manager:this.map.Manager.model},!1;default:return!0}}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\",\"../simple/string-xform\":\"2V03\",\"./app-heading-pairs-xform\":\"Kdpq\",\"./app-titles-of-parts-xform\":\"doS2\"}],\"njDv\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=require(\"../../../utils/col-cache\"),s=module.exports=function(){};function a(e){try{return r.decodeEx(e),!0}catch(t){return!1}}function i(e){var t=[],r=!1,s=\"\";return e.split(\",\").forEach(function(e){if(e){var i=(e.match(/'/g)||[]).length;if(i){var n=i%2==0;!r&&n&&a(e)?t.push(e):r&&!n?(r=!1,a(s+e)&&t.push(s+e),s=\"\"):(r=!0,s+=e+\",\")}else r?s+=e+\",\":a(e)&&t.push(e)}}),t}e.inherits(s,t,{render:function(e,t){e.openNode(\"definedName\",{name:t.name,localSheetId:t.localSheetId}),e.writeText(t.ranges.join(\",\")),e.closeNode()},parseOpen:function(e){switch(e.name){case\"definedName\":return this._parsedName=e.attributes.name,this._parsedLocalSheetId=e.attributes.localSheetId,this._parsedText=[],!0;default:return!1}},parseText:function(e){this._parsedText.push(e)},parseClose:function(){return this.model={name:this._parsedName,ranges:i(this._parsedText.join(\"\"))},void 0!==this._parsedLocalSheetId&&(this.model.localSheetId=parseInt(this._parsedLocalSheetId,10)),!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"../../../utils/col-cache\":\"oVwW\"}],\"M0MU\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,t,{render:function(e,t){e.leafNode(\"sheet\",{sheetId:t.id,name:t.name,state:t.state,\"r:id\":t.rId})},parseOpen:function(t){return\"sheet\"===t.name&&(this.model={name:e.xmlDecode(t.attributes.name),id:parseInt(t.attributes.sheetId,10),state:t.attributes.state,rId:t.attributes[\"r:id\"]},!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"YQY5\":[function(require,module,exports) {\n\"use strict\";var i=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),e=module.exports=function(){};i.inherits(e,t,{render:function(i,t){var e={xWindow:t.x||0,yWindow:t.y||0,windowWidth:t.width||12e3,windowHeight:t.height||24e3,firstSheet:t.firstSheet,activeTab:t.activeTab};t.visibility&&\"visible\"!==t.visibility&&(e.visibility=t.visibility),i.leafNode(\"workbookView\",e)},parseOpen:function(i){if(\"workbookView\"===i.name){var t=this.model={},e=function(i,e,r){var o=void 0!==e?t[i]=parseInt(e,10):r;void 0!==o&&(t[i]=o)};return e(\"x\",i.attributes.xWindow,0),e(\"y\",i.attributes.yWindow,0),e(\"width\",i.attributes.windowWidth,25e3),e(\"height\",i.attributes.windowHeight,1e4),r=\"visibility\",o=i.attributes.visibility,s=\"visible\",void 0!==(n=void 0!==o?t[r]=o:s)&&(t[r]=n),e(\"activeTab\",i.attributes.activeTab,void 0),e(\"firstSheet\",i.attributes.firstSheet,void 0),!0}var r,o,s,n;return!1},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"ySOJ\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),t=module.exports=function(){};e.inherits(t,r,{render:function(e,r){e.leafNode(\"workbookPr\",{date1904:r.date1904?1:void 0,defaultThemeVersion:164011,filterPrivacy:1})},parseOpen:function(e){return\"workbookPr\"===e.name&&(this.model={date1904:\"1\"===e.attributes.date1904},!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"Kf3Z\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/under-dash\"),r=require(\"../../../utils/utils\"),s=require(\"../../../utils/col-cache\"),t=require(\"../../../utils/xml-stream\"),i=require(\"../base-xform\"),a=require(\"../static-xform\"),n=require(\"../list-xform\"),o=require(\"./defined-name-xform\"),p=require(\"./sheet-xform\"),m=require(\"./workbook-view-xform\"),l=require(\"./workbook-properties-xform\"),d=module.exports=function(){this.map={fileVersion:d.STATIC_XFORMS.fileVersion,workbookPr:new l,bookViews:new n({tag:\"bookViews\",count:!1,childXform:new m}),sheets:new n({tag:\"sheets\",count:!1,childXform:new p}),definedNames:new n({tag:\"definedNames\",count:!1,childXform:new o}),calcPr:d.STATIC_XFORMS.calcPr}};r.inherits(d,i,{WORKBOOK_ATTRIBUTES:{xmlns:\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\",\"xmlns:r\":\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\",\"xmlns:mc\":\"http://schemas.openxmlformats.org/markup-compatibility/2006\",\"mc:Ignorable\":\"x15\",\"xmlns:x15\":\"http://schemas.microsoft.com/office/spreadsheetml/2010/11/main\"},STATIC_XFORMS:{fileVersion:new a({tag:\"fileVersion\",$:{appName:\"xl\",lastEdited:5,lowestEdited:5,rupBuild:9303}}),calcPr:new a({tag:\"calcPr\",$:{calcId:171027}})}},{prepare:function(e){e.sheets=e.worksheets;var r=[],s=0;e.sheets.forEach(function(e){if(e.pageSetup&&e.pageSetup.printArea){var t={name:\"_xlnm.Print_Area\",ranges:[e.name+\"!\"+e.pageSetup.printArea],localSheetId:s};r.push(t)}if(e.pageSetup&&e.pageSetup.printTitlesRow){var i=e.pageSetup.printTitlesRow.split(\":\"),a={name:\"_xlnm.Print_Titles\",ranges:[\"'\"+e.name+\"'!$\"+i[0]+\":$\"+i[1]],localSheetId:s};r.push(a)}s++}),r.length&&(e.definedNames=e.definedNames.concat(r)),e.media&&e.media.forEach(function(e,r){e.name=e.type+(r+1)})},render:function(e,r){e.openXml(t.StdDocAttributes),e.openNode(\"workbook\",d.WORKBOOK_ATTRIBUTES),this.map.fileVersion.render(e),this.map.workbookPr.render(e,r.properties),this.map.bookViews.render(e,r.views),this.map.sheets.render(e,r.sheets),this.map.definedNames.render(e,r.definedNames),this.map.calcPr.render(e),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case\"workbook\":return!0;default:return this.parser=this.map[e.name],this.parser&&this.parser.parseOpen(e),!0}},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.parser=void 0),!0;switch(e){case\"workbook\":return this.model={sheets:this.map.sheets.model,properties:this.map.workbookPr.model||{},views:this.map.bookViews.model},this.map.definedNames.model&&(this.model.definedNames=this.map.definedNames.model),!1;default:return!0}},reconcile:function(r){var t,i=(r.workbookRels||[]).reduce(function(e,r){return e[r.Id]=r,e},{}),a=[],n=0;(r.sheets||[]).forEach(function(e){var s=i[e.rId];s&&(t=r.worksheetHash[\"xl/\"+s.Target])&&(t.name=e.name,t.id=e.id,t.state=e.state,a[n++]=t)});var o=[];e.each(r.definedNames,function(e){if(\"_xlnm.Print_Area\"===e.name){if(t=a[e.localSheetId]){t.pageSetup||(t.pageSetup={});var r=s.decodeEx(e.ranges[0]);t.pageSetup.printArea=r.dimensions}}else if(\"_xlnm.Print_Titles\"===e.name){if(t=a[e.localSheetId]){t.pageSetup||(t.pageSetup={});var i=e.ranges[0].split(\"!\"),n=i[i.length-1];t.pageSetup.printTitlesRow=n}}else o.push(e)}),r.definedNames=o,r.media.forEach(function(e,r){e.index=r})}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../../../utils/col-cache\":\"oVwW\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\",\"../static-xform\":\"sWkd\",\"../list-xform\":\"+cuX\",\"./defined-name-xform\":\"njDv\",\"./sheet-xform\":\"M0MU\",\"./workbook-view-xform\":\"YQY5\",\"./workbook-properties-xform\":\"ySOJ\"}],\"18CJ\":[function(require,module,exports) {\n\"use strict\";module.exports={OfficeDocument:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument\",Worksheet:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet\",CalcChain:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain\",SharedStrings:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings\",Styles:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles\",Theme:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme\",Hyperlink:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink\",Image:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image\",CoreProperties:\"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties\",ExtenderProperties:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties\"};\n},{}],\"O5ya\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/under-dash\"),r=require(\"../../../doc/range\"),s=require(\"../../../utils/col-cache\"),t=require(\"../../../doc/enums\"),a=module.exports=function(){this.merges={}};a.prototype={add:function(e){if(this.merges[e.master])this.merges[e.master].expandToAddress(e.address);else{var s=e.master+\":\"+e.address;this.merges[e.master]=new r(s)}},get mergeCells(){return e.map(this.merges,function(e){return e.range})},reconcile:function(r,a){e.each(r,function(e){for(var r=s.decode(e),d=r.top;d<=r.bottom;d++)for(var n=a[d-1],i=r.left;i<=r.right;i++){var o=n.cells[i-1];o?o.type===t.ValueType.Merge&&(o.master=r.tl):n.cells[i]={type:t.ValueType.Null,address:s.encodeAddress(d,i)}}})},getMasterAddress:function(e){var r=this.hash[e];return r&&r.tl}};\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../doc/range\":\"PZiO\",\"../../../utils/col-cache\":\"oVwW\",\"../../../doc/enums\":\"YmZx\"}],\"ZecH\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),t=require(\"../../../doc/enums\"),a=require(\"../../../doc/range\"),l=require(\"../strings/rich-text-xform\");function s(e){if(null==e)return t.ValueType.Null;if(e instanceof String||\"string\"==typeof e)return t.ValueType.String;if(\"number\"==typeof e)return t.ValueType.Number;if(\"boolean\"==typeof e)return t.ValueType.Boolean;if(e instanceof Date)return t.ValueType.Date;if(e.text&&e.hyperlink)return t.ValueType.Hyperlink;if(e.formula)return t.ValueType.Formula;if(e.error)return t.ValueType.Error;throw new Error(\"I could not understand type of value\")}function u(e){switch(e.type){case t.ValueType.Formula:return s(e.result);default:return e.type}}var i=module.exports=function(){this.richTextXForm=new l};e.inherits(i,r,{get tag(){return\"c\"},prepare:function(e,r){var l=r.styles.addStyleModel(e.style||{},u(e));switch(l&&(e.styleId=l),e.type){case t.ValueType.String:r.sharedStrings&&(e.ssId=r.sharedStrings.add(e.value));break;case t.ValueType.Date:r.date1904&&(e.date1904=!0);break;case t.ValueType.Hyperlink:r.sharedStrings&&(e.ssId=r.sharedStrings.add(e.text)),r.hyperlinks.push(Object.assign({address:e.address,target:e.hyperlink},e.tooltip?{tooltip:e.tooltip}:{}));break;case t.ValueType.Merge:r.merges.add(e);break;case t.ValueType.Formula:if(r.date1904&&(e.date1904=!0),e.formula)r.formulae[e.address]=e;else if(e.sharedFormula){var s=r.formulae[e.sharedFormula];if(!s)throw new Error(\"Shared Formula master must exist above and or left of clone\");void 0!==s.si?(e.si=s.si,s.ref.expandToAddress(e.address)):(e.si=s.si=r.siFormulae++,s.ref=new a(s.address,e.address))}}},renderFormula:function(r,a){var l=null;switch(a.ref?l={t:\"shared\",ref:a.ref.range,si:a.si}:void 0!==a.si&&(l={t:\"shared\",si:a.si}),s(a.result)){case t.ValueType.Null:r.leafNode(\"f\",l,a.formula);break;case t.ValueType.String:r.addAttribute(\"t\",\"str\"),r.leafNode(\"f\",l,a.formula),r.leafNode(\"v\",null,a.result);break;case t.ValueType.Number:r.leafNode(\"f\",l,a.formula),r.leafNode(\"v\",null,a.result);break;case t.ValueType.Boolean:r.addAttribute(\"t\",\"b\"),r.leafNode(\"f\",l,a.formula),r.leafNode(\"v\",null,a.result?1:0);break;case t.ValueType.Error:r.addAttribute(\"t\",\"e\"),r.leafNode(\"f\",l,a.formula),r.leafNode(\"v\",null,a.result.error);break;case t.ValueType.Date:r.leafNode(\"f\",l,a.formula),r.leafNode(\"v\",null,e.dateToExcel(a.result,a.date1904));break;default:throw new Error(\"I could not understand type of value\")}},render:function(r,a){if(a.type!==t.ValueType.Null||a.styleId){switch(r.openNode(\"c\"),r.addAttribute(\"r\",a.address),a.styleId&&r.addAttribute(\"s\",a.styleId),a.type){case t.ValueType.Null:break;case t.ValueType.Number:r.leafNode(\"v\",null,a.value);break;case t.ValueType.Boolean:r.addAttribute(\"t\",\"b\"),r.leafNode(\"v\",null,a.value?\"1\":\"0\");break;case t.ValueType.Error:r.addAttribute(\"t\",\"e\"),r.leafNode(\"v\",null,a.value.error);break;case t.ValueType.String:if(void 0!==a.ssId)r.addAttribute(\"t\",\"s\"),r.leafNode(\"v\",null,a.ssId);else if(a.value&&a.value.richText){r.addAttribute(\"t\",\"inlineStr\"),r.openNode(\"is\");var l=this;a.value.richText.forEach(function(e){l.richTextXForm.render(r,e)}),r.closeNode(\"is\")}else r.addAttribute(\"t\",\"str\"),r.leafNode(\"v\",null,a.value);break;case t.ValueType.Date:r.leafNode(\"v\",null,e.dateToExcel(a.value,a.date1904));break;case t.ValueType.Hyperlink:void 0!==a.ssId?(r.addAttribute(\"t\",\"s\"),r.leafNode(\"v\",null,a.ssId)):(r.addAttribute(\"t\",\"str\"),r.leafNode(\"v\",null,a.text));break;case t.ValueType.Formula:this.renderFormula(r,a);break;case t.ValueType.Merge:}r.closeNode()}},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case\"c\":var r=this.model={address:e.attributes.r};return this.t=e.attributes.t,e.attributes.s&&(r.styleId=parseInt(e.attributes.s,10)),!0;case\"f\":return this.currentNode=\"f\",this.model.si=e.attributes.si,\"shared\"===e.attributes.t&&(this.model.sharedFormula=!0),this.model.ref=e.attributes.ref,!0;case\"v\":return this.currentNode=\"v\",!0;case\"t\":return this.currentNode=\"t\",!0;case\"r\":return this.parser=this.richTextXForm,this.parser.parseOpen(e),!0;default:return!1}},parseText:function(e){if(this.parser)this.parser.parseText(e);else switch(this.currentNode){case\"f\":this.model.formula=this.model.formula?this.model.formula+e:e;break;case\"v\":case\"t\":this.model.value&&this.model.value.richText?this.model.value.richText.text=this.model.value.richText.text?this.model.value.richText.text+e:e:this.model.value=this.model.value?this.model.value+e:e}},parseClose:function(r){switch(r){case\"c\":var a=this.model;if(a.formula||a.sharedFormula)a.type=t.ValueType.Formula,a.value&&(\"str\"===this.t?a.result=e.xmlDecode(a.value):\"b\"===this.t?a.result=0!==parseInt(a.value,10):\"e\"===this.t?a.result={error:a.value}:a.result=parseFloat(a.value),a.value=void 0);else if(void 0!==a.value)switch(this.t){case\"s\":a.type=t.ValueType.String,a.value=parseInt(a.value,10);break;case\"str\":a.type=t.ValueType.String,a.value=e.xmlDecode(a.value);break;case\"inlineStr\":a.type=t.ValueType.String;break;case\"b\":a.type=t.ValueType.Boolean,a.value=0!==parseInt(a.value,10);break;case\"e\":a.type=t.ValueType.Error,a.value={error:a.value};break;default:a.type=t.ValueType.Number,a.value=parseFloat(a.value)}else a.styleId?a.type=t.ValueType.Null:a.type=t.ValueType.Merge;return!1;case\"f\":case\"v\":case\"is\":return this.currentNode=void 0,!0;case\"t\":return this.parser?(this.parser.parseClose(r),!0):(this.currentNode=void 0,!0);case\"r\":return this.model.value=this.model.value||{},this.model.value.richText=this.model.value.richText||[],this.model.value.richText.push(this.parser.model),this.parser=void 0,this.currentNode=void 0,!0;default:return!!this.parser&&(this.parser.parseClose(r),!0)}},reconcile:function(r,a){var l=r.styleId&&a.styles.getStyleModel(r.styleId);switch(l&&(r.style=l),void 0!==r.styleId&&(r.styleId=void 0),r.type){case t.ValueType.String:\"number\"==typeof r.value&&(r.value=a.sharedStrings.getString(r.value)),r.value.richText&&(r.type=t.ValueType.RichText);break;case t.ValueType.Number:l&&e.isDateFmt(l.numFmt)&&(r.type=t.ValueType.Date,r.value=e.excelToDate(r.value,a.date1904));break;case t.ValueType.Formula:void 0!==r.result&&l&&e.isDateFmt(l.numFmt)&&(r.result=e.excelToDate(r.result,a.date1904)),r.sharedFormula&&(r.formula?(a.formulae[r.si]=r,delete r.sharedFormula):r.sharedFormula=a.formulae[r.si].address,delete r.si)}var s=a.hyperlinkMap[r.address];s&&(r.type===t.ValueType.Formula?(r.text=r.result,r.result=void 0):(r.text=r.value,r.value=void 0),r.type=t.ValueType.Hyperlink,r.hyperlink=s)}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"../../../doc/enums\":\"YmZx\",\"../../../doc/range\":\"PZiO\",\"../strings/rich-text-xform\":\"Yqg6\"}],\"KjGo\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=require(\"./cell-xform\"),s=module.exports=function(){this.map={c:new r}};t.inherits(s,e,{get tag(){return\"row\"},prepare:function(t,e){var r=e.styles.addStyleModel(t.style);r&&(t.styleId=r);var s=this.map.c;t.cells.forEach(function(t){s.prepare(t,e)})},render:function(t,e,r){t.openNode(\"row\"),t.addAttribute(\"r\",e.number),e.height&&(t.addAttribute(\"ht\",e.height),t.addAttribute(\"customHeight\",\"1\")),e.hidden&&t.addAttribute(\"hidden\",\"1\"),e.min>0&&e.max>0&&e.min<=e.max&&t.addAttribute(\"spans\",e.min+\":\"+e.max),e.styleId&&(t.addAttribute(\"s\",e.styleId),t.addAttribute(\"customFormat\",\"1\")),t.addAttribute(\"x14ac:dyDescent\",\"0.25\"),e.outlineLevel&&t.addAttribute(\"outlineLevel\",e.outlineLevel),e.collapsed&&t.addAttribute(\"collapsed\",\"1\");var s=this.map.c;e.cells.forEach(function(e){s.render(t,e,r)}),t.closeNode()},parseOpen:function(t){if(this.parser)return this.parser.parseOpen(t),!0;if(\"row\"===t.name){this.numRowsSeen+=1;var e=t.attributes.spans?t.attributes.spans.split(\":\").map(function(t){return parseInt(t,10)}):[void 0,void 0],r=this.model={number:parseInt(t.attributes.r,10),min:e[0],max:e[1],cells:[]};return t.attributes.s&&(r.styleId=parseInt(t.attributes.s,10)),t.attributes.hidden&&(r.hidden=!0),t.attributes.bestFit&&(r.bestFit=!0),t.attributes.ht&&(r.height=parseFloat(t.attributes.ht)),t.attributes.outlineLevel&&(r.outlineLevel=parseInt(t.attributes.outlineLevel,10)),t.attributes.collapsed&&(r.collapsed=!0),!0}return this.parser=this.map[t.name],!!this.parser&&(this.parser.parseOpen(t),!0)},parseText:function(t){this.parser&&this.parser.parseText(t)},parseClose:function(t){return!!this.parser&&(this.parser.parseClose(t)||(this.model.cells.push(this.parser.model),this.parser=void 0),!0)},reconcile:function(t,e){t.style=t.styleId?e.styles.getStyleModel(t.styleId):{},void 0!==t.styleId&&(t.styleId=void 0);var r=this.map.c;t.cells.forEach(function(t){r.reconcile(t,e)})}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"./cell-xform\":\"ZecH\"}],\"Ub7i\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),i=module.exports=function(){};t.inherits(i,e,{get tag(){return\"col\"},prepare:function(t,e){var i=e.styles.addStyleModel(t.style||{});i&&(t.styleId=i)},render:function(t,e){t.openNode(\"col\"),t.addAttribute(\"min\",e.min),t.addAttribute(\"max\",e.max),e.width&&t.addAttribute(\"width\",e.width),e.styleId&&t.addAttribute(\"style\",e.styleId),e.hidden&&t.addAttribute(\"hidden\",\"1\"),e.bestFit&&t.addAttribute(\"bestFit\",\"1\"),e.outlineLevel&&t.addAttribute(\"outlineLevel\",e.outlineLevel),e.collapsed&&t.addAttribute(\"collapsed\",\"1\"),t.addAttribute(\"customWidth\",\"1\"),t.closeNode()},parseOpen:function(t){if(\"col\"===t.name){var e=this.model={min:parseInt(t.attributes.min||\"0\",10),max:parseInt(t.attributes.max||\"0\",10),width:void 0===t.attributes.width?void 0:parseFloat(t.attributes.width||\"0\")};return t.attributes.style&&(e.styleId=parseInt(t.attributes.style,10)),t.attributes.hidden&&(e.hidden=!0),t.attributes.bestFit&&(e.bestFit=!0),t.attributes.outlineLevel&&(e.outlineLevel=parseInt(t.attributes.outlineLevel,10)),t.attributes.collapsed&&(e.collapsed=!0),!0}return!1},parseText:function(){},parseClose:function(){return!1},reconcile:function(t,e){t.styleId&&(t.style=e.styles.getStyleModel(t.styleId))}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"awzr\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),n=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,n,{get tag(){return\"dimension\"},render:function(e,n){n&&e.leafNode(\"dimension\",{ref:n})},parseOpen:function(e){return\"dimension\"===e.name&&(this.model=e.attributes.ref,!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"It4E\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=module.exports=function(){};t.inherits(r,e,{get tag(){return\"hyperlink\"},render:function(t,e){t.leafNode(\"hyperlink\",Object.assign({ref:e.address,\"r:id\":e.rId},e.tooltip?{tooltip:e.tooltip}:{}))},parseOpen:function(t){return\"hyperlink\"===t.name&&(this.model=Object.assign({address:t.attributes.ref,rId:t.attributes[\"r:id\"]},t.attributes.tooltip?{tooltip:t.attributes.tooltip}:{}),!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"L1B4\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),t=module.exports=function(){};e.inherits(t,r,{get tag(){return\"mergeCell\"},render:function(e,r){e.leafNode(\"mergeCell\",{ref:r})},parseOpen:function(e){return\"mergeCell\"===e.name&&(this.model=e.attributes.ref,!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"w7f3\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/under-dash\"),t=require(\"../../../utils/utils\"),r=require(\"../base-xform\");function a(e,t,r,a){var o=t[r];void 0!==o?e[r]=o:void 0!==a&&(e[r]=a)}function o(e){switch(e){case\"1\":case\"true\":return!0;default:return!1}}function i(e,t,r,a){var i=t[r];void 0!==i?e[r]=o(i):void 0!==a&&(e[r]=a)}var s=module.exports=function(){};t.inherits(s,r,{get tag(){return\"dataValidations\"},render:function(r,a){var o=a&&Object.keys(a).length;o&&(r.openNode(\"dataValidations\",{count:o}),e.each(a,function(e,a){r.openNode(\"dataValidation\"),\"any\"!==e.type&&(r.addAttribute(\"type\",e.type),e.operator&&\"list\"!==e.type&&\"between\"!==e.operator&&r.addAttribute(\"operator\",e.operator),e.allowBlank&&r.addAttribute(\"allowBlank\",\"1\")),e.showInputMessage&&r.addAttribute(\"showInputMessage\",\"1\"),e.promptTitle&&r.addAttribute(\"promptTitle\",e.promptTitle),e.prompt&&r.addAttribute(\"prompt\",e.prompt),e.showErrorMessage&&r.addAttribute(\"showErrorMessage\",\"1\"),e.errorStyle&&r.addAttribute(\"errorStyle\",e.errorStyle),e.errorTitle&&r.addAttribute(\"errorTitle\",e.errorTitle),e.error&&r.addAttribute(\"error\",e.error),r.addAttribute(\"sqref\",a),(e.formulae||[]).forEach(function(a,o){r.openNode(\"formula\"+(o+1)),\"date\"===e.type?r.writeText(t.dateToExcel(a)):r.writeText(a),r.closeNode()}),r.closeNode()}),r.closeNode())},parseOpen:function(e){switch(e.name){case\"dataValidations\":return this.model={},!0;case\"dataValidation\":this._address=e.attributes.sqref;var t=this._definedName=e.attributes.type?{type:e.attributes.type,formulae:[]}:{type:\"any\"};switch(e.attributes.type&&i(t,e.attributes,\"allowBlank\"),i(t,e.attributes,\"showInputMessage\"),i(t,e.attributes,\"showErrorMessage\"),t.type){case\"any\":case\"list\":case\"custom\":break;default:a(t,e.attributes,\"operator\",\"between\")}return a(t,e.attributes,\"promptTitle\"),a(t,e.attributes,\"prompt\"),a(t,e.attributes,\"errorStyle\"),a(t,e.attributes,\"errorTitle\"),a(t,e.attributes,\"error\"),!0;case\"formula1\":case\"formula2\":return this._formula=[],!0;default:return!1}},parseText:function(e){this._formula.push(e)},parseClose:function(e){switch(e){case\"dataValidations\":return!1;case\"dataValidation\":return this._definedName.formulae&&this._definedName.formulae.length||(delete this._definedName.formulae,delete this._definedName.operator),this.model[this._address]=this._definedName,!0;case\"formula1\":case\"formula2\":var r=this._formula.join(\"\");switch(this._definedName.type){case\"whole\":case\"textLength\":r=parseInt(r,10);break;case\"decimal\":r=parseFloat(r);break;case\"date\":r=t.excelToDate(parseFloat(r))}return this._definedName.formulae.push(r),!0;default:return!0}}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"XZoi\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,t,{get tag(){return\"pageSetUpPr\"},render:function(e,t){return!(!t||!t.fitToPage)&&(e.leafNode(this.tag,{fitToPage:t.fitToPage?\"1\":void 0}),!0)},parseOpen:function(e){return e.name===this.tag&&(this.model={fitToPage:\"1\"===e.attributes.fitToPage},!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"Dd1o\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),t=module.exports=function(){},u=function(r){return void 0!==r};r.inherits(t,e,{get tag(){return\"outlinePr\"},render:function(r,e){return!(!e||!u(e.summaryBelow)&&!u(e.summaryRight))&&(r.leafNode(this.tag,{summaryBelow:u(e.summaryBelow)?Number(e.summaryBelow):void 0,summaryRight:u(e.summaryRight)?Number(e.summaryRight):void 0}),!0)},parseOpen:function(r){return r.name===this.tag&&(this.model={summaryBelow:u(r.attributes.summaryBelow)?Boolean(Number(r.attributes.summaryBelow)):void 0,summaryRight:u(r.attributes.summaryRight)?Boolean(Number(r.attributes.summaryRight)):void 0},!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"QPvQ\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),t=require(\"../style/color-xform\"),s=require(\"./page-setup-properties-xform\"),o=require(\"./outline-properties-xform\"),i=module.exports=function(){this.map={tabColor:new t(\"tabColor\"),pageSetUpPr:new s,outlinePr:new o}};e.inherits(i,r,{get tag(){return\"sheetPr\"},render:function(e,r){if(r){e.addRollback(),e.openNode(\"sheetPr\");var t=!1;t=this.map.tabColor.render(e,r.tabColor)||t,t=this.map.pageSetUpPr.render(e,r.pageSetup)||t,(t=this.map.outlinePr.render(e,r.outlineProperties)||t)?(e.closeNode(),e.commit()):e.rollback()}},parseOpen:function(e){return this.parser?(this.parser.parseOpen(e),!0):e.name===this.tag?(this.reset(),!0):!!this.map[e.name]&&(this.parser=this.map[e.name],this.parser.parseOpen(e),!0)},parseText:function(e){return!!this.parser&&(this.parser.parseText(e),!0)},parseClose:function(e){return this.parser?(this.parser.parseClose(e)||(this.parser=void 0),!0):(this.map.tabColor.model||this.map.pageSetUpPr.model||this.map.outlinePr.model?(this.model={},this.map.tabColor.model&&(this.model.tabColor=this.map.tabColor.model),this.map.pageSetUpPr.model&&(this.model.pageSetup=this.map.pageSetUpPr.model),this.map.outlinePr.model&&(this.model.outlineProperties=this.map.outlinePr.model)):this.model=null,!1)}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"../style/color-xform\":\"YVuT\",\"./page-setup-properties-xform\":\"XZoi\",\"./outline-properties-xform\":\"Dd1o\"}],\"3tF+\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/under-dash\"),t=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),o=module.exports=function(){};t.inherits(o,r,{get tag(){return\"sheetFormatPr\"},render:function(t,r){if(r){var o={defaultRowHeight:r.defaultRowHeight,outlineLevelRow:r.outlineLevelRow,outlineLevelCol:r.outlineLevelCol,\"x14ac:dyDescent\":r.dyDescent};e.some(o,function(e){return void 0!==e})&&t.leafNode(\"sheetFormatPr\",o)}},parseOpen:function(e){return\"sheetFormatPr\"===e.name&&(this.model={defaultRowHeight:parseFloat(e.attributes.defaultRowHeight||\"0\"),dyDescent:parseFloat(e.attributes[\"x14ac:dyDescent\"]||\"0\"),outlineLevelRow:parseInt(e.attributes.outlineLevelRow||\"0\",10),outlineLevelCol:parseInt(e.attributes.outlineLevelCol||\"0\",10)},!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"l3J6\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../../../utils/col-cache\"),i=require(\"../base-xform\"),s={frozen:\"frozen\",frozenSplit:\"frozen\",split:\"split\"},o=module.exports=function(){};e.inherits(o,i,{get tag(){return\"sheetView\"},prepare:function(e){switch(e.state){case\"frozen\":case\"split\":break;default:e.state=\"normal\"}},render:function(e,i){e.openNode(\"sheetView\",{workbookViewId:i.workbookViewId||0});var s,o,l,a,r=function(t,i,s){s&&e.addAttribute(t,i)};switch(r(\"rightToLeft\",\"1\",!0===i.rightToLeft),r(\"tabSelected\",\"1\",i.tabSelected),r(\"showRuler\",\"0\",!1===i.showRuler),r(\"showRowColHeaders\",\"0\",!1===i.showRowColHeaders),r(\"showGridLines\",\"0\",!1===i.showGridLines),r(\"zoomScale\",i.zoomScale,i.zoomScale),r(\"zoomScaleNormal\",i.zoomScaleNormal,i.zoomScaleNormal),r(\"view\",i.style,i.style),i.state){case\"frozen\":o=i.xSplit||0,l=i.ySplit||0,s=i.topLeftCell||t.getAddress(l+1,o+1).address,a=(i.xSplit&&i.ySplit?\"bottomRight\":i.xSplit&&\"topRight\")||\"bottomLeft\",e.leafNode(\"pane\",{xSplit:i.xSplit||void 0,ySplit:i.ySplit||void 0,topLeftCell:s,activePane:a,state:\"frozen\"}),e.leafNode(\"selection\",{pane:a,activeCell:i.activeCell,sqref:i.activeCell});break;case\"split\":\"topLeft\"===i.activePane&&(i.activePane=void 0),e.leafNode(\"pane\",{xSplit:i.xSplit||void 0,ySplit:i.ySplit||void 0,topLeftCell:i.topLeftCell,activePane:i.activePane}),e.leafNode(\"selection\",{pane:i.activePane,activeCell:i.activeCell,sqref:i.activeCell});break;case\"normal\":i.activeCell&&e.leafNode(\"selection\",{activeCell:i.activeCell,sqref:i.activeCell})}e.closeNode()},parseOpen:function(e){switch(e.name){case\"sheetView\":return this.sheetView={workbookViewId:parseInt(e.attributes.workbookViewId,10),rightToLeft:\"1\"===e.attributes.rightToLeft,tabSelected:\"1\"===e.attributes.tabSelected,showRuler:!(\"0\"===e.attributes.showRuler),showRowColHeaders:!(\"0\"===e.attributes.showRowColHeaders),showGridLines:!(\"0\"===e.attributes.showGridLines),zoomScale:parseInt(e.attributes.zoomScale||\"100\",10),zoomScaleNormal:parseInt(e.attributes.zoomScaleNormal||\"100\",10),style:e.attributes.view},this.pane=void 0,this.selections={},!0;case\"pane\":return this.pane={xSplit:parseInt(e.attributes.xSplit||\"0\",10),ySplit:parseInt(e.attributes.ySplit||\"0\",10),topLeftCell:e.attributes.topLeftCell,activePane:e.attributes.activePane||\"topLeft\",state:e.attributes.state},!0;case\"selection\":var t=e.attributes.pane||\"topLeft\";return this.selections[t]={pane:t,activeCell:e.attributes.activeCell},!0;default:return!1}},parseText:function(){},parseClose:function(e){var t,i;switch(e){case\"sheetView\":return this.sheetView&&this.pane?(t=this.model={workbookViewId:this.sheetView.workbookViewId,rightToLeft:this.sheetView.rightToLeft,state:s[this.pane.state]||\"split\",xSplit:this.pane.xSplit,ySplit:this.pane.ySplit,topLeftCell:this.pane.topLeftCell,showRuler:this.sheetView.showRuler,showRowColHeaders:this.sheetView.showRowColHeaders,showGridLines:this.sheetView.showGridLines,zoomScale:this.sheetView.zoomScale,zoomScaleNormal:this.sheetView.zoomScaleNormal},\"split\"===this.model.state&&(t.activePane=this.pane.activePane),(i=this.selections[this.pane.activePane])&&i.activeCell&&(t.activeCell=i.activeCell),this.sheetView.style&&(t.style=this.sheetView.style)):(t=this.model={workbookViewId:this.sheetView.workbookViewId,rightToLeft:this.sheetView.rightToLeft,state:\"normal\",showRuler:this.sheetView.showRuler,showRowColHeaders:this.sheetView.showRowColHeaders,showGridLines:this.sheetView.showGridLines,zoomScale:this.sheetView.zoomScale,zoomScaleNormal:this.sheetView.zoomScaleNormal},(i=this.selections.topLeft)&&i.activeCell&&(t.activeCell=i.activeCell),this.sheetView.style&&(t.style=this.sheetView.style)),!1;default:return!0}},reconcile:function(){}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/col-cache\":\"oVwW\",\"../base-xform\":\"8Kdp\"}],\"QLB7\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/under-dash\"),e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),o=module.exports=function(){};e.inherits(o,r,{get tag(){return\"pageMargins\"},render:function(e,r){if(r){var o={left:r.left,right:r.right,top:r.top,bottom:r.bottom,header:r.header,footer:r.footer};t.some(o,function(t){return void 0!==t})&&e.leafNode(this.tag,o)}},parseOpen:function(t){switch(t.name){case this.tag:return this.model={left:parseFloat(t.attributes.left||.7),right:parseFloat(t.attributes.right||.7),top:parseFloat(t.attributes.top||.75),bottom:parseFloat(t.attributes.bottom||.75),header:parseFloat(t.attributes.header||.3),footer:parseFloat(t.attributes.footer||.3)},!0;default:return!1}},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"59+j\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/under-dash\"),e=require(\"../../../utils/utils\"),r=require(\"../base-xform\");function i(t){return t?\"1\":void 0}function a(t){switch(t){case\"overThenDown\":return t;default:return}}function s(t){switch(t){case\"atEnd\":case\"asDisplyed\":return t;default:return}}function n(t){switch(t){case\"dash\":case\"blank\":case\"NA\":return t;default:return}}function u(t){return void 0!==t?parseInt(t,10):void 0}var o=module.exports=function(){};e.inherits(o,r,{get tag(){return\"pageSetup\"},render:function(e,r){if(r){var u={paperSize:r.paperSize,orientation:r.orientation,horizontalDpi:r.horizontalDpi,verticalDpi:r.verticalDpi,pageOrder:a(r.pageOrder),blackAndWhite:i(r.blackAndWhite),draft:i(r.draft),cellComments:s(r.cellComments),errors:n(r.errors),scale:r.scale,fitToWidth:r.fitToWidth,fitToHeight:r.fitToHeight,firstPageNumber:r.firstPageNumber,useFirstPageNumber:i(r.firstPageNumber),usePrinterDefaults:i(r.usePrinterDefaults),copies:r.copies};t.some(u,function(t){return void 0!==t})&&e.leafNode(this.tag,u)}},parseOpen:function(t){switch(t.name){case this.tag:return this.model={paperSize:u(t.attributes.paperSize),orientation:t.attributes.orientation||\"portrait\",horizontalDpi:parseInt(t.attributes.horizontalDpi||\"4294967295\",10),verticalDpi:parseInt(t.attributes.verticalDpi||\"4294967295\",10),pageOrder:t.attributes.pageOrder||\"downThenOver\",blackAndWhite:\"1\"===t.attributes.blackAndWhite,draft:\"1\"===t.attributes.draft,cellComments:t.attributes.cellComments||\"None\",errors:t.attributes.errors||\"displayed\",scale:parseInt(t.attributes.scale||\"100\",10),fitToWidth:parseInt(t.attributes.fitToWidth||\"1\",10),fitToHeight:parseInt(t.attributes.fitToHeight||\"1\",10),firstPageNumber:parseInt(t.attributes.firstPageNumber||\"1\",10),useFirstPageNumber:\"1\"===t.attributes.useFirstPageNumber,usePrinterDefaults:\"1\"===t.attributes.usePrinterDefaults,copies:parseInt(t.attributes.copies||\"1\",10)},!0;default:return!1}},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"vg1F\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/under-dash\"),t=require(\"../../../utils/utils\"),r=require(\"../base-xform\");function i(e){return e?\"1\":void 0}var n=module.exports=function(){};t.inherits(n,r,{get tag(){return\"printOptions\"},render:function(t,r){if(r){var n={headings:i(r.showRowColHeaders),gridLines:i(r.showGridLines),horizontalCentered:i(r.horizontalCentered),verticalCentered:i(r.verticalCentered)};e.some(n,function(e){return void 0!==e})&&t.leafNode(this.tag,n)}},parseOpen:function(e){switch(e.name){case this.tag:return this.model={showRowColHeaders:\"1\"===e.attributes.headings,showGridLines:\"1\"===e.attributes.gridLines,horizontalCentered:\"1\"===e.attributes.horizontalCentered,verticalCentered:\"1\"===e.attributes.verticalCentered},!0;default:return!1}},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"Gmke\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../../../utils/col-cache\"),t=require(\"../base-xform\"),i=module.exports=function(){};e.inherits(i,t,{get tag(){return\"autoFilter\"},render:function(e,t){if(t)if(\"string\"==typeof t)e.leafNode(\"autoFilter\",{ref:t});else{var i=function(e){return\"string\"==typeof e?e:r.getAddress(e.row,e.column).address},o=i(t.from),u=i(t.to);o&&u&&e.leafNode(\"autoFilter\",{ref:o+\":\"+u})}},parseOpen:function(e){\"autoFilter\"===e.name&&(this.model=e.attributes.ref)}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/col-cache\":\"oVwW\",\"../base-xform\":\"8Kdp\"}],\"YRzL\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,t,{get tag(){return\"picture\"},render:function(e,t){t&&e.leafNode(this.tag,{\"r:id\":t.rId})},parseOpen:function(e){switch(e.name){case this.tag:return this.model={rId:e.attributes[\"r:id\"]},!0;default:return!1}},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"/OEf\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),t=module.exports=function(){};e.inherits(t,r,{get tag(){return\"drawing\"},render:function(e,r){r&&e.leafNode(this.tag,{\"r:id\":r.rId})},parseOpen:function(e){switch(e.name){case this.tag:return this.model={rId:e.attributes[\"r:id\"]},!0;default:return!1}},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"+T7W\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),t=module.exports=function(){};e.inherits(t,r,{get tag(){return\"brk\"},render:function(e,r){e.leafNode(\"brk\",r)},parseOpen:function(e){return\"brk\"===e.name&&(this.model=e.attributes.ref,!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"9cdo\":[function(require,module,exports) {\n\"use strict\";var t=require(\"./page-breaks-xform\"),e=require(\"../../../utils/utils\"),r=require(\"../list-xform\"),i=module.exports=function(){var e={tag:\"rowBreaks\",count:!0,childXform:new t};r.call(this,e)};e.inherits(i,r,{render:function(t,e){if(e&&e.length){t.openNode(this.tag,this.$),this.count&&(t.addAttribute(this.$count,e.length),t.addAttribute(\"manualBreakCount\",e.length));var r=this.childXform;e.forEach(function(e){r.render(t,e)}),t.closeNode()}else this.empty&&t.leafNode(this.tag)}});\n},{\"./page-breaks-xform\":\"+T7W\",\"../../../utils/utils\":\"gei3\",\"../list-xform\":\"+cuX\"}],\"NvfC\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/under-dash\"),r=require(\"../../../utils/utils\"),t=require(\"../../../utils/xml-stream\"),i=require(\"../../rel-type\"),a=require(\"./merges\"),s=require(\"../base-xform\"),o=require(\"../list-xform\"),n=require(\"./row-xform\"),p=require(\"./col-xform\"),m=require(\"./dimension-xform\"),l=require(\"./hyperlink-xform\"),d=require(\"./merge-cell-xform\"),h=require(\"./data-validations-xform\"),u=require(\"./sheet-properties-xform\"),g=require(\"./sheet-format-properties-xform\"),c=require(\"./sheet-view-xform\"),f=require(\"./page-margins-xform\"),w=require(\"./page-setup-xform\"),x=require(\"./print-options-xform\"),k=require(\"./auto-filter-xform\"),v=require(\"./picture-xform\"),I=require(\"./drawing-xform\"),y=require(\"./row-breaks-xform\"),T=module.exports=function(e){var r=e&&e.maxRows;this.map={sheetPr:new u,dimension:new m,sheetViews:new o({tag:\"sheetViews\",count:!1,childXform:new c}),sheetFormatPr:new g,cols:new o({tag:\"cols\",count:!1,childXform:new p}),sheetData:new o({tag:\"sheetData\",count:!1,empty:!0,childXform:new n,maxItems:r}),autoFilter:new k,mergeCells:new o({tag:\"mergeCells\",count:!0,childXform:new d}),rowBreaks:new y,hyperlinks:new o({tag:\"hyperlinks\",count:!1,childXform:new l}),pageMargins:new f,dataValidations:new h,pageSetup:new w,printOptions:new x,picture:new v,drawing:new I}};r.inherits(T,s,{WORKSHEET_ATTRIBUTES:{xmlns:\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\",\"xmlns:r\":\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\",\"xmlns:mc\":\"http://schemas.openxmlformats.org/markup-compatibility/2006\",\"mc:Ignorable\":\"x14ac\",\"xmlns:x14ac\":\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\"}},{prepare:function(e,r){r.merges=new a,e.hyperlinks=r.hyperlinks=[],r.formulae={},r.siFormulae=0,this.map.cols.prepare(e.cols,r),this.map.sheetData.prepare(e.rows,r),e.mergeCells=r.merges.mergeCells;var t,s=e.rels=[];function o(e){return\"rId\"+(e.length+1)}e.hyperlinks.forEach(function(e){t=o(s),e.rId=t,s.push({Id:t,Type:i.Hyperlink,Target:e.target,TargetMode:\"External\"})});var n,p=[];e.media.forEach(function(a){if(\"background\"===a.type)t=o(s),n=r.media[a.imageId],s.push({Id:t,Type:i.Image,Target:\"../media/\"+n.name+\".\"+n.extension}),e.background={rId:t},e.image=r.media[a.imageId];else if(\"image\"===a.type){var m=e.drawing;n=r.media[a.imageId],m||(m=e.drawing={rId:o(s),name:\"drawing\"+ ++r.drawingsCount,anchors:[],rels:[]},r.drawings.push(m),s.push({Id:m.rId,Type:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing\",Target:\"../drawings/\"+m.name+\".xml\"}));var l=p[a.imageId];l||(l=o(m.rels),p[a.imageId]=l,m.rels.push({Id:l,Type:\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image\",Target:\"../media/\"+n.name+\".\"+n.extension})),m.anchors.push({picture:{rId:l},range:a.range})}})},render:function(e,r){e.openXml(t.StdDocAttributes),e.openNode(\"worksheet\",T.WORKSHEET_ATTRIBUTES);var i=r.properties?{defaultRowHeight:r.properties.defaultRowHeight,dyDescent:r.properties.dyDescent,outlineLevelCol:r.properties.outlineLevelCol,outlineLevelRow:r.properties.outlineLevelRow}:void 0,a={outlineProperties:r.properties&&r.properties.outlineProperties,tabColor:r.properties&&r.properties.tabColor,pageSetup:r.pageSetup&&r.pageSetup.fitToPage?{fitToPage:r.pageSetup.fitToPage}:void 0},s=r.pageSetup&&r.pageSetup.margins,o={showRowColHeaders:r.showRowColHeaders,showGridLines:r.showGridLines,horizontalCentered:r.horizontalCentered,verticalCentered:r.verticalCentered};this.map.sheetPr.render(e,a),this.map.dimension.render(e,r.dimensions),this.map.sheetViews.render(e,r.views),this.map.sheetFormatPr.render(e,i),this.map.cols.render(e,r.cols),this.map.sheetData.render(e,r.rows),this.map.autoFilter.render(e,r.autoFilter),this.map.mergeCells.render(e,r.mergeCells),this.map.dataValidations.render(e,r.dataValidations),this.map.hyperlinks.render(e,r.hyperlinks),this.map.pageMargins.render(e,s),this.map.printOptions.render(e,o),this.map.pageSetup.render(e,r.pageSetup),this.map.rowBreaks.render(e,r.rowBreaks),this.map.drawing.render(e,r.drawing),this.map.picture.render(e,r.background),e.closeNode()},parseOpen:function(r){return this.parser?(this.parser.parseOpen(r),!0):\"worksheet\"===r.name?(e.each(this.map,function(e){e.reset()}),!0):(this.parser=this.map[r.name],this.parser&&this.parser.parseOpen(r),!0)},parseText:function(e){this.parser&&this.parser.parseText(e)},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.parser=void 0),!0;switch(e){case\"worksheet\":var r=this.map.sheetFormatPr.model;this.map.sheetPr.model&&this.map.sheetPr.model.tabColor&&(r.tabColor=this.map.sheetPr.model.tabColor),this.map.sheetPr.model&&this.map.sheetPr.model.outlineProperties&&(r.outlineProperties=this.map.sheetPr.model.outlinePropertiesx);var t={fitToPage:this.map.sheetPr.model&&this.map.sheetPr.model.pageSetup&&this.map.sheetPr.model.pageSetup.fitToPage||!1,margins:this.map.pageMargins.model},i=Object.assign(t,this.map.pageSetup.model,this.map.printOptions.model);return this.model={dimensions:this.map.dimension.model,cols:this.map.cols.model,rows:this.map.sheetData.model,mergeCells:this.map.mergeCells.model,hyperlinks:this.map.hyperlinks.model,dataValidations:this.map.dataValidations.model,properties:r,views:this.map.sheetViews.model,pageSetup:i,background:this.map.picture.model,drawing:this.map.drawing.model},this.map.autoFilter.model&&(this.model.autoFilter=this.map.autoFilter.model),!1;default:return!0}},reconcile:function(e,r){var t=(e.relationships||[]).reduce(function(e,r){return e[r.Id]=r,e},{});if(r.hyperlinkMap=(e.hyperlinks||[]).reduce(function(e,r){return r.rId&&(e[r.address]=t[r.rId].Target),e},{}),r.formulae={},e.rows=e.rows&&e.rows.filter(Boolean)||[],e.rows.forEach(function(e){e.cells=e.cells&&e.cells.filter(Boolean)||[]}),this.map.cols.reconcile(e.cols,r),this.map.sheetData.reconcile(e.rows,r),e.media=[],e.drawing){var i=t[e.drawing.rId].Target.match(/\\/drawings\\/([a-zA-Z0-9]+)[.][a-zA-Z]{3,4}$/);if(i){var a=i[1];r.drawings[a].anchors.forEach(function(r){if(r.medium){var t={type:\"image\",imageId:r.medium.index,range:r.range};e.media.push(t)}})}}var s=e.background&&t[e.background.rId];if(s){var o=s.Target.split(\"/media/\")[1],n=r.mediaIndex&&r.mediaIndex[o];void 0!==n&&e.media.push({type:\"background\",imageId:n})}delete e.relationships,delete e.hyperlinks}});\n},{\"../../../utils/under-dash\":\"h8Mb\",\"../../../utils/utils\":\"gei3\",\"../../../utils/xml-stream\":\"WHow\",\"../../rel-type\":\"18CJ\",\"./merges\":\"O5ya\",\"../base-xform\":\"8Kdp\",\"../list-xform\":\"+cuX\",\"./row-xform\":\"KjGo\",\"./col-xform\":\"Ub7i\",\"./dimension-xform\":\"awzr\",\"./hyperlink-xform\":\"It4E\",\"./merge-cell-xform\":\"L1B4\",\"./data-validations-xform\":\"w7f3\",\"./sheet-properties-xform\":\"QPvQ\",\"./sheet-format-properties-xform\":\"3tF+\",\"./sheet-view-xform\":\"l3J6\",\"./page-margins-xform\":\"QLB7\",\"./page-setup-xform\":\"59+j\",\"./print-options-xform\":\"vg1F\",\"./auto-filter-xform\":\"Gmke\",\"./picture-xform\":\"YRzL\",\"./drawing-xform\":\"/OEf\",\"./row-breaks-xform\":\"9cdo\"}],\"sN9K\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),t=function(){};e.inherits(t,r,{parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case this.tag:this.reset(),this.model={range:{editAs:e.attributes.editAs||\"oneCell\"}};break;default:this.parser=this.map[e.name],this.parser&&this.parser.parseOpen(e)}return!0},parseText:function(e){this.parser&&this.parser.parseText(e)},reconcilePicture:function(e,r){if(e&&e.rId){var t=r.rels[e.rId].Target.match(/.*\\/media\\/(.+[.][a-z]{3,4})/);if(t){var s=t[1],i=r.mediaIndex[s];return r.media[i]}}}}),module.exports=t;\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"XD83\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),t=require(\"../simple/integer-xform\"),s=module.exports=function(r){this.tag=r.tag,this.map={\"xdr:col\":new t({tag:\"xdr:col\",zero:!0}),\"xdr:colOff\":new t({tag:\"xdr:colOff\",zero:!0}),\"xdr:row\":new t({tag:\"xdr:row\",zero:!0}),\"xdr:rowOff\":new t({tag:\"xdr:rowOff\",zero:!0})}};r.inherits(s,e,{render:function(r,e){r.openNode(this.tag),this.map[\"xdr:col\"].render(r,e.nativeCol),this.map[\"xdr:colOff\"].render(r,e.nativeColOff),this.map[\"xdr:row\"].render(r,e.nativeRow),this.map[\"xdr:rowOff\"].render(r,e.nativeRowOff),r.closeNode()},parseOpen:function(r){if(this.parser)return this.parser.parseOpen(r),!0;switch(r.name){case this.tag:this.reset();break;default:this.parser=this.map[r.name],this.parser&&this.parser.parseOpen(r)}return!0},parseText:function(r){this.parser&&this.parser.parseText(r)},parseClose:function(r){if(this.parser)return this.parser.parseClose(r)||(this.parser=void 0),!0;switch(r){case this.tag:return this.model={nativeCol:this.map[\"xdr:col\"].model,nativeColOff:this.map[\"xdr:colOff\"].model,nativeRow:this.map[\"xdr:row\"].model,nativeRowOff:this.map[\"xdr:rowOff\"].model},!1;default:return!0}}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"../simple/integer-xform\":\"kNo+\"}],\"8VjZ\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),t=require(\"../base-xform\"),r=module.exports=function(){};e.inherits(r,t,{get tag(){return\"a:blip\"},render:function(e,t){e.leafNode(this.tag,{\"xmlns:r\":\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\",\"r:embed\":t.rId,cstate:\"print\"})},parseOpen:function(e){switch(e.name){case this.tag:return this.model={rId:e.attributes[\"r:embed\"]},!0;default:return!0}},parseText:function(){},parseClose:function(e){switch(e){case this.tag:return!1;default:return!0}}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"wYDB\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"../base-xform\"),s=require(\"./blip-xform\"),t=module.exports=function(){this.map={\"a:blip\":new s}};e.inherits(t,r,{get tag(){return\"xdr:blipFill\"},render:function(e,r){e.openNode(this.tag),this.map[\"a:blip\"].render(e,r),e.openNode(\"a:stretch\"),e.leafNode(\"a:fillRect\"),e.closeNode(),e.closeNode()},parseOpen:function(e){if(this.parser)return this.parser.parseOpen(e),!0;switch(e.name){case this.tag:this.reset();break;default:this.parser=this.map[e.name],this.parser&&this.parser.parseOpen(e)}return!0},parseText:function(){},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.parser=void 0),!0;switch(e){case this.tag:return this.model=this.map[\"a:blip\"].model,!1;default:return!0}}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"./blip-xform\":\"8VjZ\"}],\"4v7f\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=require(\"../static-xform\"),i=module.exports=function(){};t.inherits(i,e,{get tag(){return\"xdr:nvPicPr\"},render:function(t,e){new r({tag:this.tag,c:[{tag:\"xdr:cNvPr\",$:{id:e.index,name:\"Picture \"+e.index},c:[{tag:\"a:extLst\",c:[{tag:\"a:ext\",$:{uri:\"{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}\"},c:[{tag:\"a16:creationId\",$:{\"xmlns:a16\":\"http://schemas.microsoft.com/office/drawing/2014/main\",id:\"{00000000-0008-0000-0000-000002000000}\"}}]}]}]},{tag:\"xdr:cNvPicPr\",c:[{tag:\"a:picLocks\",$:{noChangeAspect:\"1\"}}]}]}).render(t)}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"../static-xform\":\"sWkd\"}],\"RvWg\":[function(require,module,exports) {\n\"use strict\";module.exports={tag:\"xdr:spPr\",c:[{tag:\"a:xfrm\",c:[{tag:\"a:off\",$:{x:\"0\",y:\"0\"}},{tag:\"a:ext\",$:{cx:\"0\",cy:\"0\"}}]},{tag:\"a:prstGeom\",$:{prst:\"rect\"},c:[{tag:\"a:avLst\"}]}]};\n},{}],\"gHTO\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),i=require(\"../static-xform\"),s=require(\"./blip-fill-xform\"),t=require(\"./nv-pic-pr-xform\"),n=require(\"./sp-pr\"),p=module.exports=function(){this.map={\"xdr:nvPicPr\":new t,\"xdr:blipFill\":new s,\"xdr:spPr\":new i(n)}};r.inherits(p,e,{get tag(){return\"xdr:pic\"},prepare:function(r,e){r.index=e.index+1},render:function(r,e){r.openNode(this.tag),this.map[\"xdr:nvPicPr\"].render(r,e),this.map[\"xdr:blipFill\"].render(r,e),this.map[\"xdr:spPr\"].render(r,e),r.closeNode()},parseOpen:function(r){if(this.parser)return this.parser.parseOpen(r),!0;switch(r.name){case this.tag:this.reset();break;default:this.parser=this.map[r.name],this.parser&&this.parser.parseOpen(r)}return!0},parseText:function(){},parseClose:function(r){if(this.parser)return this.parser.parseClose(r)||(this.mergeModel(this.parser.model),this.parser=void 0),!0;switch(r){case this.tag:return!1;default:return!0}}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\",\"../static-xform\":\"sWkd\",\"./blip-fill-xform\":\"wYDB\",\"./nv-pic-pr-xform\":\"4v7f\",\"./sp-pr\":\"RvWg\"}],\"MwU1\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../../../utils/utils\"),e=require(\"./base-cell-anchor-xform\"),t=require(\"../static-xform\"),i=require(\"./cell-position-xform\"),o=require(\"./pic-xform\"),a=function(){this.map={\"xdr:from\":new i({tag:\"xdr:from\"}),\"xdr:to\":new i({tag:\"xdr:to\"}),\"xdr:pic\":new o,\"xdr:clientData\":new t({tag:\"xdr:clientData\"})}};r.inherits(a,e,{get tag(){return\"xdr:twoCellAnchor\"},prepare:function(r,e){this.map[\"xdr:pic\"].prepare(r.picture,e)},render:function(r,e){r.openNode(this.tag,{editAs:e.range.editAs||\"oneCell\"}),this.map[\"xdr:from\"].render(r,e.range.tl),this.map[\"xdr:to\"].render(r,e.range.br),this.map[\"xdr:pic\"].render(r,e.picture),this.map[\"xdr:clientData\"].render(r,{}),r.closeNode()},parseClose:function(r){if(this.parser)return this.parser.parseClose(r)||(this.parser=void 0),!0;switch(r){case this.tag:return this.model.range.tl=this.map[\"xdr:from\"].model,this.model.range.br=this.map[\"xdr:to\"].model,this.model.picture=this.map[\"xdr:pic\"].model,!1;default:return!0}},reconcile:function(r,e){r.medium=this.reconcilePicture(r.picture,e)}}),module.exports=a;\n},{\"../../../utils/utils\":\"gei3\",\"./base-cell-anchor-xform\":\"sN9K\",\"../static-xform\":\"sWkd\",\"./cell-position-xform\":\"XD83\",\"./pic-xform\":\"gHTO\"}],\"6Dm0\":[function(require,module,exports) {\n\"use strict\";var t=require(\"../../../utils/utils\"),e=require(\"../base-xform\"),r=module.exports=function(t){this.tag=t.tag,this.map={}},i=9525;t.inherits(r,e,{render:function(t,e){t.openNode(this.tag);var r=Math.floor(e.width*i),s=Math.floor(e.height*i);t.addAttribute(\"cx\",r),t.addAttribute(\"cy\",s),t.closeNode()},parseOpen:function(t){return t.name===this.tag&&(this.model={width:parseInt(t.attributes.cx||\"0\",10)/i,height:parseInt(t.attributes.cy||\"0\",10)/i},!0)},parseText:function(){},parseClose:function(){return!1}});\n},{\"../../../utils/utils\":\"gei3\",\"../base-xform\":\"8Kdp\"}],\"utxu\":[function(require,module,exports) {\n\"use strict\";var e=require(\"../../../utils/utils\"),r=require(\"./base-cell-anchor-xform\"),t=require(\"../static-xform\"),i=require(\"./cell-position-xform\"),n=require(\"./ext-xform\"),a=require(\"./pic-xform\"),s=function(){this.map={\"xdr:from\":new i({tag:\"xdr:from\"}),\"xdr:ext\":new n({tag:\"xdr:ext\"}),\"xdr:pic\":new a,\"xdr:clientData\":new t({tag:\"xdr:clientData\"})}};e.inherits(s,r,{get tag(){return\"xdr:oneCellAnchor\"},prepare:function(e,r){this.map[\"xdr:pic\"].prepare(e.picture,r)},render:function(e,r){e.openNode(this.tag,{editAs:r.range.editAs||\"oneCell\"}),this.map[\"xdr:from\"].render(e,r.range.tl),this.map[\"xdr:ext\"].render(e,r.range.ext),this.map[\"xdr:pic\"].render(e,r.picture),this.map[\"xdr:clientData\"].render(e,{}),e.closeNode()},parseClose:function(e){if(this.parser)return this.parser.parseClose(e)||(this.parser=void 0),!0;switch(e){case this.tag:return this.model.range.tl=this.map[\"xdr:from\"].model,this.model.range.ext=this.map[\"xdr:ext\"].model,this.model.picture=this.map[\"xdr:pic\"].model,!1;default:return!0}},reconcile:function(e,r){e.medium=this.reconcilePicture(e.picture,r)}}),module.exports=s;\n},{\"../../../utils/utils\":\"gei3\",\"./base-cell-anchor-xform\":\"sN9K\",\"../static-xform\":\"sWkd\",\"./cell-position-xform\":\"XD83\",\"./ext-xform\":\"6Dm0\",\"./pic-xform\":\"gHTO\"}],\"JY1Y\":[function(require,module,exports) {\n\"use strict\";var r=require(\"../../../utils/utils\"),e=require(\"../../../utils/col-cache\"),t=require(\"../../../utils/xml-stream\"),n=require(\"../base-xform\"),s=require(\"./two-cell-anchor-xform\"),a=require(\"./one-cell-anchor-xform\"),o=module.exports=function(){this.map={\"xdr:twoCellAnchor\":new s,\"xdr:oneCellAnchor\":new a}};function i(r){return(\"string\"==typeof r.range?e.decode(r.range):r.range).br?\"xdr:twoCellAnchor\":\"xdr:oneCellAnchor\"}r.inherits(o,n,{DRAWING_ATTRIBUTES:{\"xmlns:xdr\":\"http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing\",\"xmlns:a\":\"http://schemas.openxmlformats.org/drawingml/2006/main\"}},{get tag(){return\"xdr:wsDr\"},prepare:function(r){var e=this;r.anchors.forEach(function(r,t){r.anchorType=i(r),e.map[r.anchorType].prepare(r,{index:t})})},render:function(r,e){var n=this;r.openXml(t.StdDocAttributes),r.openNode(this.tag,o.DRAWING_ATTRIBUTES),e.anchors.forEach(function(e){n.map[e.anchorType].render(r,e)}),r.closeNode()},parseOpen:function(r){if(this.parser)return this.parser.parseOpen(r),!0;switch(r.name){case this.tag:this.reset(),this.model={anchors:[]};break;default:this.parser=this.map[r.name],this.parser&&this.parser.parseOpen(r)}return!0},parseText:function(r){this.parser&&this.parser.parseText(r)},parseClose:function(r){if(this.parser)return this.parser.parseClose(r)||(this.model.anchors.push(this.parser.model),this.parser=void 0),!0;switch(r){case this.tag:return!1;default:return!0}},reconcile:function(r,e){var t=this;r.anchors.forEach(function(r){r.br?t.map[\"xdr:twoCellAnchor\"].reconcile(r,e):t.map[\"xdr:oneCellAnchor\"].reconcile(r,e)})}});\n},{\"../../../utils/utils\":\"gei3\",\"../../../utils/col-cache\":\"oVwW\",\"../../../utils/xml-stream\":\"WHow\",\"../base-xform\":\"8Kdp\",\"./two-cell-anchor-xform\":\"MwU1\",\"./one-cell-anchor-xform\":\"utxu\"}],\"CbYn\":[function(require,module,exports) {\n\"use strict\";module.exports='<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\\n<a:theme xmlns:a=\"http://schemas.openxmlformats.org/drawingml/2006/main\" name=\"Office Theme\"> <a:themeElements> <a:clrScheme name=\"Office\"> <a:dk1> <a:sysClr val=\"windowText\" lastClr=\"000000\"/> </a:dk1> <a:lt1> <a:sysClr val=\"window\" lastClr=\"FFFFFF\"/> </a:lt1> <a:dk2> <a:srgbClr val=\"1F497D\"/> </a:dk2> <a:lt2> <a:srgbClr val=\"EEECE1\"/> </a:lt2> <a:accent1> <a:srgbClr val=\"4F81BD\"/> </a:accent1> <a:accent2> <a:srgbClr val=\"C0504D\"/> </a:accent2> <a:accent3> <a:srgbClr val=\"9BBB59\"/> </a:accent3> <a:accent4> <a:srgbClr val=\"8064A2\"/> </a:accent4> <a:accent5> <a:srgbClr val=\"4BACC6\"/> </a:accent5> <a:accent6> <a:srgbClr val=\"F79646\"/> </a:accent6> <a:hlink> <a:srgbClr val=\"0000FF\"/> </a:hlink> <a:folHlink> <a:srgbClr val=\"800080\"/> </a:folHlink> </a:clrScheme> <a:fontScheme name=\"Office\"> <a:majorFont> <a:latin typeface=\"Cambria\"/> <a:ea typeface=\"\"/> <a:cs typeface=\"\"/> <a:font script=\"Jpan\" typeface=\"ＭＳ Ｐゴシック\"/> <a:font script=\"Hang\" typeface=\"맑은 고딕\"/> <a:font script=\"Hans\" typeface=\"宋体\"/> <a:font script=\"Hant\" typeface=\"新細明體\"/> <a:font script=\"Arab\" typeface=\"Times New Roman\"/> <a:font script=\"Hebr\" typeface=\"Times New Roman\"/> <a:font script=\"Thai\" typeface=\"Tahoma\"/> <a:font script=\"Ethi\" typeface=\"Nyala\"/> <a:font script=\"Beng\" typeface=\"Vrinda\"/> <a:font script=\"Gujr\" typeface=\"Shruti\"/> <a:font script=\"Khmr\" typeface=\"MoolBoran\"/> <a:font script=\"Knda\" typeface=\"Tunga\"/> <a:font script=\"Guru\" typeface=\"Raavi\"/> <a:font script=\"Cans\" typeface=\"Euphemia\"/> <a:font script=\"Cher\" typeface=\"Plantagenet Cherokee\"/> <a:font script=\"Yiii\" typeface=\"Microsoft Yi Baiti\"/> <a:font script=\"Tibt\" typeface=\"Microsoft Himalaya\"/> <a:font script=\"Thaa\" typeface=\"MV Boli\"/> <a:font script=\"Deva\" typeface=\"Mangal\"/> <a:font script=\"Telu\" typeface=\"Gautami\"/> <a:font script=\"Taml\" typeface=\"Latha\"/> <a:font script=\"Syrc\" typeface=\"Estrangelo Edessa\"/> <a:font script=\"Orya\" typeface=\"Kalinga\"/> <a:font script=\"Mlym\" typeface=\"Kartika\"/> <a:font script=\"Laoo\" typeface=\"DokChampa\"/> <a:font script=\"Sinh\" typeface=\"Iskoola Pota\"/> <a:font script=\"Mong\" typeface=\"Mongolian Baiti\"/> <a:font script=\"Viet\" typeface=\"Times New Roman\"/> <a:font script=\"Uigh\" typeface=\"Microsoft Uighur\"/> <a:font script=\"Geor\" typeface=\"Sylfaen\"/> </a:majorFont> <a:minorFont> <a:latin typeface=\"Calibri\"/> <a:ea typeface=\"\"/> <a:cs typeface=\"\"/> <a:font script=\"Jpan\" typeface=\"ＭＳ Ｐゴシック\"/> <a:font script=\"Hang\" typeface=\"맑은 고딕\"/> <a:font script=\"Hans\" typeface=\"宋体\"/> <a:font script=\"Hant\" typeface=\"新細明體\"/> <a:font script=\"Arab\" typeface=\"Arial\"/> <a:font script=\"Hebr\" typeface=\"Arial\"/> <a:font script=\"Thai\" typeface=\"Tahoma\"/> <a:font script=\"Ethi\" typeface=\"Nyala\"/> <a:font script=\"Beng\" typeface=\"Vrinda\"/> <a:font script=\"Gujr\" typeface=\"Shruti\"/> <a:font script=\"Khmr\" typeface=\"DaunPenh\"/> <a:font script=\"Knda\" typeface=\"Tunga\"/> <a:font script=\"Guru\" typeface=\"Raavi\"/> <a:font script=\"Cans\" typeface=\"Euphemia\"/> <a:font script=\"Cher\" typeface=\"Plantagenet Cherokee\"/> <a:font script=\"Yiii\" typeface=\"Microsoft Yi Baiti\"/> <a:font script=\"Tibt\" typeface=\"Microsoft Himalaya\"/> <a:font script=\"Thaa\" typeface=\"MV Boli\"/> <a:font script=\"Deva\" typeface=\"Mangal\"/> <a:font script=\"Telu\" typeface=\"Gautami\"/> <a:font script=\"Taml\" typeface=\"Latha\"/> <a:font script=\"Syrc\" typeface=\"Estrangelo Edessa\"/> <a:font script=\"Orya\" typeface=\"Kalinga\"/> <a:font script=\"Mlym\" typeface=\"Kartika\"/> <a:font script=\"Laoo\" typeface=\"DokChampa\"/> <a:font script=\"Sinh\" typeface=\"Iskoola Pota\"/> <a:font script=\"Mong\" typeface=\"Mongolian Baiti\"/> <a:font script=\"Viet\" typeface=\"Arial\"/> <a:font script=\"Uigh\" typeface=\"Microsoft Uighur\"/> <a:font script=\"Geor\" typeface=\"Sylfaen\"/> </a:minorFont> </a:fontScheme> <a:fmtScheme name=\"Office\"> <a:fillStyleLst> <a:solidFill> <a:schemeClr val=\"phClr\"/> </a:solidFill> <a:gradFill rotWithShape=\"1\"> <a:gsLst> <a:gs pos=\"0\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"50000\"/> <a:satMod val=\"300000\"/> </a:schemeClr> </a:gs> <a:gs pos=\"35000\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"37000\"/> <a:satMod val=\"300000\"/> </a:schemeClr> </a:gs> <a:gs pos=\"100000\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"15000\"/> <a:satMod val=\"350000\"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang=\"16200000\" scaled=\"1\"/> </a:gradFill> <a:gradFill rotWithShape=\"1\"> <a:gsLst> <a:gs pos=\"0\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"100000\"/> <a:shade val=\"100000\"/> <a:satMod val=\"130000\"/> </a:schemeClr> </a:gs> <a:gs pos=\"100000\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"50000\"/> <a:shade val=\"100000\"/> <a:satMod val=\"350000\"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang=\"16200000\" scaled=\"0\"/> </a:gradFill> </a:fillStyleLst> <a:lnStyleLst> <a:ln w=\"9525\" cap=\"flat\" cmpd=\"sng\" algn=\"ctr\"> <a:solidFill> <a:schemeClr val=\"phClr\"> <a:shade val=\"95000\"/> <a:satMod val=\"105000\"/> </a:schemeClr> </a:solidFill> <a:prstDash val=\"solid\"/> </a:ln> <a:ln w=\"25400\" cap=\"flat\" cmpd=\"sng\" algn=\"ctr\"> <a:solidFill> <a:schemeClr val=\"phClr\"/> </a:solidFill> <a:prstDash val=\"solid\"/> </a:ln> <a:ln w=\"38100\" cap=\"flat\" cmpd=\"sng\" algn=\"ctr\"> <a:solidFill> <a:schemeClr val=\"phClr\"/> </a:solidFill> <a:prstDash val=\"solid\"/> </a:ln> </a:lnStyleLst> <a:effectStyleLst> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad=\"40000\" dist=\"20000\" dir=\"5400000\" rotWithShape=\"0\"> <a:srgbClr val=\"000000\"> <a:alpha val=\"38000\"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad=\"40000\" dist=\"23000\" dir=\"5400000\" rotWithShape=\"0\"> <a:srgbClr val=\"000000\"> <a:alpha val=\"35000\"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad=\"40000\" dist=\"23000\" dir=\"5400000\" rotWithShape=\"0\"> <a:srgbClr val=\"000000\"> <a:alpha val=\"35000\"/> </a:srgbClr> </a:outerShdw> </a:effectLst> <a:scene3d> <a:camera prst=\"orthographicFront\"> <a:rot lat=\"0\" lon=\"0\" rev=\"0\"/> </a:camera> <a:lightRig rig=\"threePt\" dir=\"t\"> <a:rot lat=\"0\" lon=\"0\" rev=\"1200000\"/> </a:lightRig> </a:scene3d> <a:sp3d> <a:bevelT w=\"63500\" h=\"25400\"/> </a:sp3d> </a:effectStyle> </a:effectStyleLst> <a:bgFillStyleLst> <a:solidFill> <a:schemeClr val=\"phClr\"/> </a:solidFill> <a:gradFill rotWithShape=\"1\"> <a:gsLst> <a:gs pos=\"0\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"40000\"/> <a:satMod val=\"350000\"/> </a:schemeClr> </a:gs> <a:gs pos=\"40000\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"45000\"/> <a:shade val=\"99000\"/> <a:satMod val=\"350000\"/> </a:schemeClr> </a:gs> <a:gs pos=\"100000\"> <a:schemeClr val=\"phClr\"> <a:shade val=\"20000\"/> <a:satMod val=\"255000\"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path=\"circle\"> <a:fillToRect l=\"50000\" t=\"-80000\" r=\"50000\" b=\"180000\"/> </a:path> </a:gradFill> <a:gradFill rotWithShape=\"1\"> <a:gsLst> <a:gs pos=\"0\"> <a:schemeClr val=\"phClr\"> <a:tint val=\"80000\"/> <a:satMod val=\"300000\"/> </a:schemeClr> </a:gs> <a:gs pos=\"100000\"> <a:schemeClr val=\"phClr\"> <a:shade val=\"30000\"/> <a:satMod val=\"200000\"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path=\"circle\"> <a:fillToRect l=\"50000\" t=\"50000\" r=\"50000\" b=\"50000\"/> </a:path> </a:gradFill> </a:bgFillStyleLst> </a:fmtScheme> </a:themeElements> <a:objectDefaults> <a:spDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx=\"1\"> <a:schemeClr val=\"accent1\"/> </a:lnRef> <a:fillRef idx=\"3\"> <a:schemeClr val=\"accent1\"/> </a:fillRef> <a:effectRef idx=\"2\"> <a:schemeClr val=\"accent1\"/> </a:effectRef> <a:fontRef idx=\"minor\"> <a:schemeClr val=\"lt1\"/> </a:fontRef> </a:style> </a:spDef> <a:lnDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx=\"2\"> <a:schemeClr val=\"accent1\"/> </a:lnRef> <a:fillRef idx=\"0\"> <a:schemeClr val=\"accent1\"/> </a:fillRef> <a:effectRef idx=\"1\"> <a:schemeClr val=\"accent1\"/> </a:effectRef> <a:fontRef idx=\"minor\"> <a:schemeClr val=\"tx1\"/> </a:fontRef> </a:style> </a:lnDef> </a:objectDefaults> <a:extraClrSchemeLst/> </a:theme>';\n},{}],\"RcxM\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar e=require(\"buffer\").Buffer,r=require(\"fs\"),n=require(\"../utils/zip-stream\"),t=require(\"../utils/stream-buf\"),o=require(\"../utils/promish\"),s=require(\"../utils/utils\"),i=require(\"../utils/xml-stream\"),a=require(\"./xform/style/styles-xform\"),d=require(\"./xform/core/core-xform\"),u=require(\"./xform/strings/shared-strings-xform\"),l=require(\"./xform/core/relationships-xform\"),c=require(\"./xform/core/content-types-xform\"),h=require(\"./xform/core/app-xform\"),m=require(\"./xform/book/workbook-xform\"),f=require(\"./xform/sheet/worksheet-xform\"),p=require(\"./xform/drawing/drawing-xform\"),w=require(\"./xml/theme1.js\"),x=module.exports=function(e){this.workbook=e};function g(e,n){return new o.Promish(function(t,o){r.readFile(e,n,function(e,r){e?o(e):t(r)})})}x.RelType=require(\"./rel-type\"),x.prototype={readFile:function(e,n){var t,o=this;return s.fs.exists(e).then(function(s){if(!s)throw new Error(\"File not found: \"+e);return t=r.createReadStream(e),o.read(t,n).catch(function(e){throw t.close(),e})}).then(function(e){return t.close(),e})},parseRels:function(e){return(new l).parseStream(e)},parseWorkbook:function(e){return(new m).parseStream(e)},parseSharedStrings:function(e){return(new u).parseStream(e)},reconcile:function(e,r){var n=new m,t=new f(r),o=new p;n.reconcile(e);var s={media:e.media,mediaIndex:e.mediaIndex};Object.keys(e.drawings).forEach(function(r){var n=e.drawings[r],t=e.drawingRels[r];t&&(s.rels=t.reduce(function(e,r){return e[r.Id]=r,e},{}),o.reconcile(n,s))});var i={styles:e.styles,sharedStrings:e.sharedStrings,media:e.media,mediaIndex:e.mediaIndex,date1904:e.properties&&e.properties.date1904,drawings:e.drawings};e.worksheets.forEach(function(r){r.relationships=e.worksheetRels[r.sheetNo],t.reconcile(r,i)}),delete e.worksheetHash,delete e.worksheetRels,delete e.globalRels,delete e.sharedStrings,delete e.workbookRels,delete e.sheetDefs,delete e.styles,delete e.mediaIndex,delete e.drawings,delete e.drawingRels},processWorksheetEntry:function(e,r,n){var t=e.path.match(/xl\\/worksheets\\/sheet(\\d+)[.]xml/);if(t){var o=t[1];return new f(n).parseStream(e).then(function(n){n.sheetNo=o,r.worksheetHash[e.path]=n,r.worksheets.push(n)})}},processWorksheetRelsEntry:function(e,r){var n=e.path.match(/xl\\/worksheets\\/_rels\\/sheet(\\d+)[.]xml.rels/);if(n){var t=n[1];return(new l).parseStream(e).then(function(e){r.worksheetRels[t]=e})}},processMediaEntry:function(e,r){var n=e.path.match(/xl\\/media\\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/);if(n){var s=n[1],i=s.lastIndexOf(\".\");if(-1===i)return;var a=s.substr(i+1),d=s.substr(0,i);return new o.Promish(function(n,o){var i=new t;i.on(\"finish\",function(){r.mediaIndex[s]=r.media.length,r.mediaIndex[d]=r.media.length;var e={type:\"image\",name:d,extension:a,buffer:i.toBuffer()};r.media.push(e),n()}),e.on(\"error\",function(e){o(e)}),e.pipe(i)})}},processDrawingEntry:function(e,r){var n=e.path.match(/xl\\/drawings\\/([a-zA-Z0-9]+)[.]xml/);if(n){var t=n[1];return(new p).parseStream(e).then(function(e){r.drawings[t]=e})}},processDrawingRelsEntry:function(e,r){var n=e.path.match(/xl\\/drawings\\/_rels\\/([a-zA-Z0-9]+)[.]xml[.]rels/);if(n){var t=n[1];return(new l).parseStream(e).then(function(e){r.drawingRels[t]=e})}},processThemeEntry:function(e,r){var n=e.path.match(/xl\\/theme\\/([a-zA-Z0-9]+)[.]xml/);if(n)return new o.Promish(function(o,s){var i=n[1],a=new t;e.on(\"error\",s),a.on(\"error\",s),a.on(\"finish\",function(){r.themes[i]=a.read().toString(),o()}),e.pipe(a)})},processIgnoreEntry:function(e){e.autodrain()},createInputStream:function(e){var r=this,t={worksheets:[],worksheetHash:{},worksheetRels:[],themes:{},media:[],mediaIndex:{},drawings:{},drawingRels:{}},s=[],i=new n.ZipReader({getEntryType:function(e){return e.match(/xl\\/media\\//)?\"nodebuffer\":\"string\"}});return i.on(\"entry\",function(n){var o=null,l=n.path;switch(\"/\"===l[0]&&(l=l.substr(1)),l){case\"_rels/.rels\":o=r.parseRels(n).then(function(e){t.globalRels=e});break;case\"xl/workbook.xml\":o=r.parseWorkbook(n).then(function(e){t.sheets=e.sheets,t.definedNames=e.definedNames,t.views=e.views,t.properties=e.properties});break;case\"xl/_rels/workbook.xml.rels\":o=r.parseRels(n).then(function(e){t.workbookRels=e});break;case\"xl/sharedStrings.xml\":t.sharedStrings=new u,o=t.sharedStrings.parseStream(n);break;case\"xl/styles.xml\":t.styles=new a,o=t.styles.parseStream(n);break;case\"docProps/app.xml\":o=(new h).parseStream(n).then(function(e){Object.assign(t,{company:e.company,manager:e.manager})});break;case\"docProps/core.xml\":o=(new d).parseStream(n).then(function(e){Object.assign(t,e)});break;default:o=r.processWorksheetEntry(n,t,e)||r.processWorksheetRelsEntry(n,t)||r.processThemeEntry(n,t)||r.processMediaEntry(n,t)||r.processDrawingEntry(n,t)||r.processDrawingRelsEntry(n,t)||r.processIgnoreEntry(n)}o&&(o=o.catch(function(e){throw i.destroy(e),e}),s.push(o),o=null)}),i.on(\"finished\",function(){o.Promish.all(s).then(function(){r.reconcile(t,e),r.workbook.model=t}).then(function(){i.emit(\"done\")}).catch(function(e){i.emit(\"error\",e)})}),i},read:function(e,r){r=r||{};var n=this,t=this.createInputStream(r);return new o.Promish(function(r,o){t.on(\"done\",function(){r(n.workbook)}).on(\"error\",function(e){o(e)}),e.pipe(t)})},load:function(r,n){var t=this;void 0===n&&(n={});var s=this.createInputStream();return new o.Promish(function(o,i){if(s.on(\"done\",function(){o(t.workbook)}).on(\"error\",function(e){i(e)}),n.base64){var a=new e(r.toString(),\"base64\");s.write(a)}else s.write(r);s.end()})},addMedia:function(e,r){return o.Promish.all(r.media.map(function(r){if(\"image\"===r.type){var n=\"xl/media/\"+r.name+\".\"+r.extension;if(r.filename)return g(r.filename).then(function(r){e.append(r,{name:n})});if(r.buffer)return new o.Promish(function(t){e.append(r.buffer,{name:n}),t()});if(r.base64)return new o.Promish(function(t){var o=r.base64,s=o.substring(o.indexOf(\",\")+1);e.append(s,{name:n,base64:!0}),t()})}return o.Promish.reject(new Error(\"Unsupported media\"))}))},addDrawings:function(e,r){var n=new p,t=new l,s=[];return r.worksheets.forEach(function(r){var i=r.drawing;i&&s.push(new o.Promish(function(r){n.prepare(i,{});var o=n.toXml(i);e.append(o,{name:\"xl/drawings/\"+i.name+\".xml\"}),o=t.toXml(i.rels),e.append(o,{name:\"xl/drawings/_rels/\"+i.name+\".xml.rels\"}),r()}))}),o.Promish.all(s)},addContentTypes:function(e,r){return new o.Promish(function(n){var t=(new c).toXml(r);e.append(t,{name:\"[Content_Types].xml\"}),n()})},addApp:function(e,r){return new o.Promish(function(n){var t=(new h).toXml(r);e.append(t,{name:\"docProps/app.xml\"}),n()})},addCore:function(e,r){return new o.Promish(function(n){var t=new d;e.append(t.toXml(r),{name:\"docProps/core.xml\"}),n()})},addThemes:function(e,r){return new o.Promish(function(n){var t=r.themes||{theme1:w};Object.keys(t).forEach(function(r){var n=t[r],o=\"xl/theme/\"+r+\".xml\";e.append(n,{name:o})}),n()})},addOfficeRels:function(e){return new o.Promish(function(r){var n=(new l).toXml([{Id:\"rId1\",Type:x.RelType.OfficeDocument,Target:\"xl/workbook.xml\"},{Id:\"rId2\",Type:x.RelType.CoreProperties,Target:\"docProps/core.xml\"},{Id:\"rId3\",Type:x.RelType.ExtenderProperties,Target:\"docProps/app.xml\"}]);e.append(n,{name:\"_rels/.rels\"}),r()})},addWorkbookRels:function(e,r){var n=1,t=[{Id:\"rId\"+n++,Type:x.RelType.Styles,Target:\"styles.xml\"},{Id:\"rId\"+n++,Type:x.RelType.Theme,Target:\"theme/theme1.xml\"}];return r.sharedStrings.count&&t.push({Id:\"rId\"+n++,Type:x.RelType.SharedStrings,Target:\"sharedStrings.xml\"}),r.worksheets.forEach(function(e){e.rId=\"rId\"+n++,t.push({Id:e.rId,Type:x.RelType.Worksheet,Target:\"worksheets/sheet\"+e.id+\".xml\"})}),new o.Promish(function(r){var n=(new l).toXml(t);e.append(n,{name:\"xl/_rels/workbook.xml.rels\"}),r()})},addSharedStrings:function(e,r){return r.sharedStrings&&r.sharedStrings.count?new o.Promish(function(n){e.append(r.sharedStrings.xml,{name:\"xl/sharedStrings.xml\"}),n()}):o.Promish.resolve()},addStyles:function(e,r){return new o.Promish(function(n){var t=r.styles.xml;t&&e.append(t,{name:\"xl/styles.xml\"}),n()})},addWorkbook:function(e,r){return new o.Promish(function(n){var t=new m;e.append(t.toXml(r),{name:\"xl/workbook.xml\"}),n()})},addWorksheets:function(e,r){return new o.Promish(function(n){var t=new f,o=new l;r.worksheets.forEach(function(r){var n=new i;t.render(n,r),e.append(n.xml,{name:\"xl/worksheets/sheet\"+r.id+\".xml\"}),r.rels&&r.rels.length&&(n=new i,o.render(n,r.rels),e.append(n.xml,{name:\"xl/worksheets/_rels/sheet\"+r.id+\".xml.rels\"}))}),n()})},_finalize:function(e){var r=this;return new o.Promish(function(n,t){e.on(\"finish\",function(){n(r)}),e.on(\"error\",t),e.finalize()})},prepareModel:function(e,r){e.creator=e.creator||\"ExcelJS\",e.lastModifiedBy=e.lastModifiedBy||\"ExcelJS\",e.created=e.created||new Date,e.modified=e.modified||new Date,e.useSharedStrings=void 0===r.useSharedStrings||r.useSharedStrings,e.useStyles=void 0===r.useStyles||r.useStyles,e.sharedStrings=new u,e.styles=e.useStyles?new a(!0):new a.Mock;var n=new m,t=new f;n.prepare(e);var o={sharedStrings:e.sharedStrings,styles:e.styles,date1904:e.properties.date1904,drawingsCount:0,media:e.media};o.drawings=e.drawings=[],e.worksheets.forEach(function(e){t.prepare(e,o)})},write:function(e,r){var t=this;r=r||{};var s=this.workbook.model,i=new n.ZipWriter;return i.pipe(e),this.prepareModel(s,r),o.Promish.resolve().then(function(){return t.addContentTypes(i,s)}).then(function(){return t.addOfficeRels(i,s)}).then(function(){return t.addWorkbookRels(i,s)}).then(function(){return t.addWorksheets(i,s)}).then(function(){return t.addSharedStrings(i,s)}).then(function(){return t.addDrawings(i,s)}).then(function(){var e=[t.addThemes(i,s),t.addStyles(i,s)];return o.Promish.all(e)}).then(function(){return t.addMedia(i,s)}).then(function(){var e=[t.addApp(i,s),t.addCore(i,s)];return o.Promish.all(e)}).then(function(){return t.addWorkbook(i,s)}).then(function(){return t._finalize(i)})},writeFile:function(e,n){var t=this,s=r.createWriteStream(e);return new o.Promish(function(e,r){s.on(\"finish\",function(){e()}),s.on(\"error\",function(e){r(e)}),t.write(s,n).then(function(){s.end()}).catch(function(e){r(e)})})},writeBuffer:function(e){var r=new t;return this.write(r,e).then(function(){return r.read()})}};\n},{\"fs\":\"70rD\",\"../utils/zip-stream\":\"EG/7\",\"../utils/stream-buf\":\"SWOl\",\"../utils/promish\":\"vJr6\",\"../utils/utils\":\"gei3\",\"../utils/xml-stream\":\"WHow\",\"./xform/style/styles-xform\":\"6gbp\",\"./xform/core/core-xform\":\"URat\",\"./xform/strings/shared-strings-xform\":\"4BMP\",\"./xform/core/relationships-xform\":\"pJDE\",\"./xform/core/content-types-xform\":\"V2LX\",\"./xform/core/app-xform\":\"ndMK\",\"./xform/book/workbook-xform\":\"Kf3Z\",\"./xform/sheet/worksheet-xform\":\"NvfC\",\"./xform/drawing/drawing-xform\":\"JY1Y\",\"./xml/theme1.js\":\"CbYn\",\"./rel-type\":\"18CJ\",\"buffer\":\"peL6\"}],\"L6VC\":[function(require,module,exports) {\nvar define;\nvar t;!function(){function e(){var t,e=Array.prototype.slice,r=0,n=new Function,s=/(super)/g;function o(t,r){return r=r||0,e.call(t,r)}function i(t){return\"[object Array]\"===Object.prototype.toString.call(t)}function _(t){return function(t){return null!=t&&\"object\"==typeof t}(t)&&t.constructor===Object}var a=function(t){return\"[object Arguments]\"===Object.prototype.toString.call(t)};function u(t,e){if(t&&t.length)for(var r=0,n=t.length;r<n;r++)if(t[r]===e)return r;return-1}function c(t,e,r){var n,s;for(n in e)e.hasOwnProperty(n)&&-1===u(r,n)&&(s=e[n],n in t&&t[n]===s||(t[n]=s));return t}function p(t,e){var r=this.__meta,n=r.supers,s=n.length,o=r.superMeta,_=o.pos;if(s>_){t=t?a(t)||i(t)?t:[t]:[];var u,c=o.name,p=o.f;do{if(\"function\"==typeof(u=n[_][c])&&(u=u._f||u)!==p)return o.pos=1+_,u.apply(this,t)}while(s>++_)}return null}function f(){var t=this.__meta,e=t.supers,r=e.length,n=t.superMeta,s=n.pos;if(r>s){var o,i=n.name,_=n.f;do{if(\"function\"==typeof(o=e[s][i])&&(o=o._f||o)!==_)return n.pos=1+s,o.bind(this)}while(r>++s)}return null}function l(t){var e=this.__getters__;return e.hasOwnProperty(t)?e[t].apply(this):this[t]}function h(t,e){var r=this.__setters__;if(!_(t))return r.hasOwnProperty(t)?r[t].apply(this,o(arguments,1)):this[t]=e;for(var n in t){var s=t[n];r.hasOwnProperty(n)?r[t].call(this,s):this[n]=s}}function y(){var t=this.__meta||{},e=t.supers,r=e.length,n=t.superMeta,s=n.pos;if(r>s){var o,i=n.name,_=n.f;do{if(\"function\"==typeof(o=e[s][i])&&(o=o._f||o)!==_)return n.pos=1+s,o.apply(this,arguments)}while(r>++s)}return null}function g(t,e){if(t.toString().match(s)){var r=function(){var r,n=this.__meta||{},s=n.superMeta;switch(n.superMeta={f:t,pos:0,name:e},arguments.length){case 0:r=t.call(this);break;case 1:r=t.call(this,arguments[0]);break;case 2:r=t.call(this,arguments[0],arguments[1]);break;case 3:r=t.call(this,arguments[0],arguments[1],arguments[2]);break;default:r=t.apply(this,arguments)}return n.superMeta=s,r};return r._f=t,r}return t._f=t,t}function m(t,e){var r=e.setters||{},n=t.__setters__,s=t.__getters__;for(var o in r)n.hasOwnProperty(o)||(n[o]=r[o]);for(o in r=e.getters||{})s.hasOwnProperty(o)||(s[o]=r[o]);for(var i in e)if(\"getters\"!==i&&\"setters\"!==i){var _=e[i];\"function\"==typeof _?t.hasOwnProperty(i)||(t[i]=g(y,i)):t[i]=_}}function v(){for(var t=o(arguments),e=t.length,r=this.prototype,n=r.__meta,s=this.__meta,i=r.__meta.bases,_=i.slice(),a=s.supers||[],u=n.supers||[],c=0;c<e;c++){var p=t[c],f=p.prototype,l=f.__meta,h=p.__meta;!l&&(l=f.__meta={proto:f||{}}),!h&&(h=p.__meta={proto:p.__proto__||{}}),m(r,l.proto||{}),m(this,h.proto||{}),b(p.prototype,u,i),b(p,a,_)}return this}function b(t,e,n){var s=t.__meta;!s&&(s=t.__meta={});var o=t.__meta.unique;if(!o&&(s.unique=\"declare\"+ ++r),-1===u(n,o)){n.push(o);for(var i=t.__meta.supers||[],_=i.length-1||0;_>=0;)b(i[_--],e,n);e.unshift(t)}}function d(t,e){var r=e.setters,n=t.__setters__,s=t.__getters__;if(r)for(var o in r)n[o]=r[o];if(r=e.getters||{})for(o in r)s[o]=r[o];for(o in e)if(\"getters\"!=o&&\"setters\"!=o){var i=e[o];if(\"function\"==typeof i)(i.__meta||{}).isConstructor?t[o]=i:t[o]=g(i,o);else t[o]=i}}function w(e,s,o){var a={},u=[],l=\"declare\"+ ++r,h=[],m=[],w=[],O=[],P={supers:w,unique:l,bases:h,superMeta:{f:null,pos:0,name:null}},k={supers:O,unique:l,bases:m,isConstructor:!0,superMeta:{f:null,pos:0,name:null}};if(_(s)&&!o&&(o=s,s=t),\"function\"==typeof s||i(s)?(s=(u=i(s)?s:[s]).shift(),e.__meta=k,(a=function(t){n.prototype=t.prototype;var e=new n;return n.prototype=null,e}(s)).__meta=P,a.__getters__=c({},a.__getters__||{}),a.__setters__=c({},a.__setters__||{}),e.__getters__=c({},e.__getters__||{}),e.__setters__=c({},e.__setters__||{}),b(s.prototype,w,h),b(s,O,m)):(e.__meta=k,a.__meta=P,a.__getters__=a.__getters__||{},a.__setters__=a.__setters__||{},e.__getters__=e.__getters__||{},e.__setters__=e.__setters__||{}),e.prototype=a,o){var M=P.proto=o.instance||{},j=k.proto=o.static||{};j.init=j.init||y,d(a,M),d(e,j),M.hasOwnProperty(\"constructor\")?a.constructor=g(M.constructor,\"constructor\"):a.constructor=M.constructor=g(y,\"constructor\")}else P.proto={},k.proto={},e.init=g(y,\"init\"),a.constructor=g(y,\"constructor\");u.length&&v.apply(e,u),s&&c(e,c(c({},s),e)),a._super=e._super=p,a._getSuper=e._getSuper=f,a._static=e}function O(t,e){function r(){switch(arguments.length){case 0:this.constructor.call(this);break;case 1:this.constructor.call(this,arguments[0]);break;case 2:this.constructor.call(this,arguments[0],arguments[1]);break;case 3:this.constructor.call(this,arguments[0],arguments[1],arguments[2]);break;default:this.constructor.apply(this,arguments)}}return w(r,t,e),r.init()||r}return a(arguments)||(a=function(t){return!(!t||!t.hasOwnProperty(\"callee\"))}),t=O({instance:{get:l,set:h},static:{get:l,set:h,mixin:v,extend:function(t){return O(this,t)},as:function(t,e){return t&&e?t[e]=this:t.exports=t=this,this}}}),O.singleton=function(t,e){var r;function n(){return r||(this.constructor.apply(this,arguments),r=this),r}return w(n,t,e),n.init()||n},O}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=e()):\"function\"==typeof t&&t.amd?t(e):this.declare=e()}();\n},{}],\"PITm\":[function(require,module,exports) {\nmodule.exports=require(\"./declare.js\");\n},{\"./declare.js\":\"L6VC\"}],\"O1Yg\":[function(require,module,exports) {\nvar define;\nvar n;(function(){function e(n){var e,t=Array.prototype.slice;function r(n,e){if(n&&n.length)for(var t=0,r=n.length;t<r;t++)if(n[t]===e)return t;return-1}var o=function(){function n(n,e,t){var o,i;for(o in e)e.hasOwnProperty(o)&&-1===r(t,o)&&(i=e[o],o in n&&n[o]===i||(n[o]=i));return n}return function(e){e||(e={});var t=arguments.length,r=arguments[arguments.length-1];!function(n){return\"[object Array]\"===Object.prototype.toString.call(n)}(r)?r=[]:t--;for(var o=1;o<t;o++)n(e,arguments[o],r);return e}}();function i(r){r=r||[];var i=n({instance:{constructor:function(n){this._value=n},value:function(){return this._value},eq:function(n){return this.__extender__(this._value===n)},neq:function(n){return this.__extender__(this._value!==n)},print:function(){return console.log(this._value),this}}}),u=[];function f(n,r,o){if(\"function\"!=typeof o)throw new TypeError(\"when extending type you must provide a function\");var i;i=\"constructor\"===r?function(){this._super(arguments),o.apply(this,arguments)}:function(){var n=t.call(arguments);n.unshift(this._value);var r=o.apply(this,n);return r!==e?this.__extender__(r):this},n[r]=i}function c(n,e,r){if(\"function\"!=typeof r)throw new TypeError(\"when extending type you must provide a function\");var o;o=\"constructor\"===e?function(){this._super(arguments),r.apply(this,arguments)}:function(){var n=t.call(arguments);return n.unshift(this._value),r.apply(this,n)},n[e]=o}function s(n){var e,t,r=n;if(!(n instanceof i)){var o=i;for(e=0,t=u.length;e<t;e++){var f=u[e];f[0](n)&&(o=o.extend({instance:f[1]}))}(r=new o(n)).__extender__=s}return r}function a(){return!0}return s.define=function(n,e){if(arguments.length){\"object\"==typeof n&&(e=n,n=a);var t={};!function n(e,t,r){for(var o in t)t.hasOwnProperty(o)&&(\"getters\"!==o&&\"setters\"!==o?\"noWrap\"===o?n(e,t[o],!0):r?c(e,o,t[o]):f(e,o,t[o]):e[o]=t[o])}(t,e=e||{}),t.hasOwnProperty(\"constructor\")||(e.hasOwnProperty(\"constructor\")?f(t,\"constructor\",e.constructor):t.constructor=function(){this._super(arguments)}),u.push([n,t])}return s},s.extend=function(n){return n&&n.hasOwnProperty(\"__defined__\")&&(s.__defined__=u=u.concat(n.__defined__)),o(s,n,[\"define\",\"extend\",\"expose\",\"__defined__\"]),s},s.expose=function(){for(var n,e=0,t=arguments.length;e<t;e++)\"object\"==typeof(n=arguments[e])&&o(s,n,[\"define\",\"extend\",\"expose\",\"__defined__\"]);return s},s.__defined__=u,s}return{define:function(){return i().define.apply(i,arguments)},extend:function(n){return i().define().extend(n)}}}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=e(require(\"declare.js\"))):\"function\"==typeof n&&n.amd?n([\"declare\"],function(n){return e(n)}):this.extender=e(this.declare)}).call(this);\n},{\"declare.js\":\"PITm\"}],\"WA12\":[function(require,module,exports) {\nmodule.exports=require(\"./extender.js\");\n},{\"./extender.js\":\"O1Yg\"}],\"9zzC\":[function(require,module,exports) {\nvar define;\nvar e;(function(){\"use strict\";function n(e){!function(){function e(e,n){var t,r;for(t in n)n.hasOwnProperty(t)&&(r=n[t],t in e&&e[t]===r||(e[t]=r));return e}}();function n(){return(n=e.define()).expose({register:function(e,t){t||(t=e,e=null);var r=typeof t;if(e)n[e]=t;else if(t&&\"function\"===r)n.extend(t);else{if(\"object\"!==r)throw new TypeError(\"extended.register must be called with an extender function\");n.expose(t)}return n},define:function(){return e.define.apply(e,arguments)}}),n;var n}return n.define=function(){return e.define.apply(e,arguments)},n}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=n(require(\"extender\"))):\"function\"==typeof e&&e.amd?e([\"extender\"],function(e){return n(e)}):this.extended=n(this.extender)}).call(this);\n},{\"extender\":\"WA12\"}],\"8tFl\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar define;\nvar n,t=require(\"buffer\").Buffer;(function(){\"use strict\";function e(n){var e=Array.prototype.slice,r=Object.prototype.hasOwnProperty,i=Object.prototype.toString;function u(n,t){var e=-1,r=0,i=n.length,u=[];for(e+=t=t||0;++e<i;)u[r++]=n[e];return u}function o(n){var t=[];for(var e in n)r.call(n,e)&&t.push(e);return t}function c(n,r){if(n===r)return!0;if(void 0!==t&&t.isBuffer(n)&&t.isBuffer(r)){if(n.length!==r.length)return!1;for(var i=0;i<n.length;i++)if(n[i]!==r[i])return!1;return!0}return v(n)&&v(r)?n.getTime()===r.getTime():y(n)&&y(r)?n.source===r.source&&n.global===r.global&&n.multiline===r.multiline&&n.lastIndex===r.lastIndex&&n.ignoreCase===r.ignoreCase:(!j(n)||!j(r)||n===r)&&(\"object\"!=typeof n&&\"object\"!=typeof r?n===r:function(n,t){var r;if(d(n)||d(t))return!1;if(n.prototype!==t.prototype)return!1;if(g(n))return!!g(t)&&(n=e.call(n),t=e.call(t),c(n,t));try{var i,u=o(n),f=o(t);if(u.length!==f.length)return!1;for(u.sort(),f.sort(),i=u.length-1;i>=0;i--)if(u[i]!==f[i])return!1;for(i=u.length-1;i>=0;i--)if(r=u[i],!c(n[r],t[r]))return!1}catch(s){return!1}return!0}(n,r))}var f,s=function(n){return\"[object Function]\"===i.call(n)};function l(n){return null!==n&&\"object\"==typeof n}function a(n){return!0===n||!1===n||\"[object Boolean]\"===i.call(n)}function h(n){return void 0===n}function d(n){return h(n)||p(n)}function p(n){return null===n}\"undefined\"==typeof window||s(window.alert)||(f=window.alert,s=function(n){return\"[object Function]\"===i.call(n)||n===f});var g=function(n){return\"[object Arguments]\"===i.call(n)};function y(n){return\"[object RegExp]\"===i.call(n)}g(arguments)||(g=function(n){return!(!n||!r.call(n,\"callee\"))});var b=Array.isArray||function(n){return\"[object Array]\"===i.call(n)};function v(n){return\"[object Date]\"===i.call(n)}function j(n){return\"[object String]\"===i.call(n)}function m(n,t){return n==t}function w(n,t){if(b(t)&&Array.prototype.indexOf||j(t))return t.indexOf(n)>-1;if(b(t))for(var e=0,r=t.length;e<r;e++)if(m(n,t[e]))return!0;return!1}function x(n,t){return j(t)?null!==(\"\"+n).match(t):!!y(t)&&t.test(n)}function _(n,t){return r.call(n,t)}var A={isFunction:s,isObject:l,isEmpty:function(n){return g(n)?0===n.length:l(n)?0===o(n).length:!j(n)&&!b(n)||0===n.length},isHash:function(n){return l(n)&&n.constructor===Object&&!n.nodeType&&!n.setInterval},isNumber:function(n){return\"[object Number]\"===i.call(n)},isString:j,isDate:v,isArray:b,isBoolean:a,isUndefined:h,isDefined:function(n){return!h(n)},isUndefinedOrNull:d,isNull:p,isArguments:g,instanceOf:function(n,t){return!!s(t)&&n instanceof t},isRegExp:y,deepEqual:c,isTrue:function(n){return!0===n},isFalse:function(n){return!1===n},isNotNull:function(n){return!p(n)},isEq:m,isNeq:function(n,t){return n!=t},isSeq:function(n,t){return n===t},isSneq:function(n,t){return n!==t},isIn:w,isNotIn:function(n,t){return!w(n,t)},isLt:function(n,t){return n<t},isLte:function(n,t){return n<=t},isGt:function(n,t){return n>t},isGte:function(n,t){return n>=t},isLike:x,isNotLike:function(n,t){return!x(n,t)},contains:function(n,t){return w(t,n)},notContains:function(n,t){return!w(t,n)},has:_,notHas:function(n,t){return!_(n,t)},isLength:function(n,t){return!!_(n,\"length\")&&n.length===t},isNotLength:function(n,t){return!!_(n,\"length\")&&n.length!==t},containsAt:function(n,t,e){return!!(b(n)&&n.length>e)&&m(n[e],t)},notContainsAt:function(n,t,e){return!!b(n)&&!m(n[e],t)}},N={constructor:function(){this._testers=[]},noWrap:{tester:function(){var n=this._testers;return function(t){for(var e=!1,r=0,i=n.length;r<i&&!e;r++)e=n[r](t);return e}}}},O={constructor:function(){this._cases=[],this.__default=null},def:function(n,t){this.__default=t},noWrap:{switcher:function(){var n=this._cases,t=this.__default;return function(){for(var e,r=u(arguments),i=0,o=n.length;i<o;i++)if((e=n[i](r)).length>1&&(e[1]||e[0]))return e[1];if(t)return t.apply(this,r)}}}};function E(n){N[n]=function(){this._testers.push(A[n])}}function q(n){O[n]=function(){var t,e=u(arguments,1),r=A[n],i=!0;if(e.length<=r.length-1)throw new TypeError(\"A handler must be defined when calling using switch\");if(a(t=e.pop())&&(i=t,t=e.pop()),!s(t))throw new TypeError(\"handler must be defined\");this._cases.push(function(n){return r.apply(A,n.concat(e))?[i,t.apply(this,n)]:[!1]})}}for(var L in A)r.call(A,L)&&(q(L),E(L));var T=n.define(A).expose(A);return T.tester=n.define(N),T.switcher=n.define(O),T}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=e(require(\"extended\"))):\"function\"==typeof n&&n.amd?n([\"extended\"],function(n){return e(n)}):this.isExtended=e(this.extended)}).call(this);\n},{\"extended\":\"9zzC\",\"buffer\":\"peL6\"}],\"Hwmr\":[function(require,module,exports) {\nvar define;\nvar e;(function(){\"use strict\";function t(e,t){Array.prototype.slice;var n=t.isArguments;function r(e,t){var n=-1,r=0,d=e.length,i=[];for(n+=t=t||0;++n<d;)i[r++]=e[n];return i}return e.define(n,{toArray:r}).expose({argsToArray:r})}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=t(require(\"extended\"),require(\"is-extended\"))):\"function\"==typeof e&&e.amd?e([\"extended\",\"is-extended\"],function(e,n){return t(e,n)}):this.argumentsExtended=t(this.extended,this.isExtended)}).call(this);\n},{\"extended\":\"9zzC\",\"is-extended\":\"8tFl\"}],\"6f/Y\":[function(require,module,exports) {\nvar define;\nvar r;(function(){\"use strict\";function n(r,n,e){var t=n.isString,u=Array.isArray||n.isArray,i=n.isDate,o=Math.floor,f=Math.abs,c=(Math.max,Math.min),a=Array.prototype,l=(a.indexOf,a.forEach),h=a.map,s=a.reduce,v=a.reduceRight,g=a.filter,p=a.every,d=a.some,y=e.argsToArray;function m(r,n){var e,t,u=[],i=-1;for(t=r.length;++i<t;)-1!==b(n,e=r[i])&&u.push(e);return u}var w,x,E,T=(w=function(r,n){return j(r,n)},x=function(r,n){return r-n},E=function(r,n){return r.getTime()-n.getTime()},function(r,n){var e=[];return u(r)&&(e=r.slice(),n?\"function\"==typeof n?e.sort(n):e.sort(function(r,e){var u=r[n],o=e[n];return t(u)&&t(o)?u>o?1:u<o?-1:0:i(u)&&i(o)?u.getTime()-o.getTime():u-o}):w(e,t)?e.sort():w(e,i)?e.sort(E):e.sort(x)),e});function b(r,n,e){for(var t=(e||0)-1,u=r.length;++t<u;)if(r[t]===n)return t;return-1}function O(r,n,e){if(r&&g&&g===r.filter)return r.filter(n,e);if(!u(r)||\"function\"!=typeof n)throw new TypeError;for(var t=Object(r),i=t.length>>>0,o=[],f=0;f<i;f++)if(f in t){var c=t[f];n.call(e,c,f,t)&&o.push(c)}return o}function A(r,n,e){if(!u(r)||\"function\"!=typeof n)throw new TypeError;if(r&&l&&l===r.forEach)return r.forEach(n,e),r;for(var t=0,i=r.length;t<i;++t)n.call(e||r,r[t],t,r);return r}function j(r,n,e){if(r&&p&&p===r.every)return r.every(n,e);if(!u(r)||\"function\"!=typeof n)throw new TypeError;for(var t=Object(r),i=t.length>>>0,o=0;o<i;o++)if(o in t&&!n.call(e,t[o],o,t))return!1;return!0}function R(r,n,e){if(r&&h&&h===r.map)return r.map(n,e);if(!u(r)||\"function\"!=typeof n)throw new TypeError;for(var t=Object(r),i=t.length>>>0,o=[],f=0;f<i;f++)f in t&&o.push(n.call(e,t[f],f,t));return o}function q(r,n,e){var t=arguments.length>2;if(r&&s&&s===r.reduce)return t?r.reduce(n,e):r.reduce(n);if(!u(r)||\"function\"!=typeof n)throw new TypeError;var i=0,o=r.length>>0;if(arguments.length<3){if(0===o)throw new TypeError(\"Array length is 0 and no second argument\");e=r[0],i=1}else e=arguments[2];for(;i<o;)i in r&&(e=n.call(void 0,e,r[i],i,r)),++i;return e}function M(r,n,e){var t=arguments.length>2;if(r&&v&&v===r.reduceRight)return t?r.reduceRight(n,e):r.reduceRight(n);if(!u(r)||\"function\"!=typeof n)throw new TypeError;var i=Object(r),o=i.length>>>0;if(0===o&&2===arguments.length)throw new TypeError;var f=o-1;if(arguments.length>=3)e=arguments[2];else for(;;)if(f in r){e=r[f--];break}for(;f>=0;)f in i&&(e=n.call(void 0,e,i[f],f,i)),f--;return e}function N(r){var e=[];if(null!==r){var t=y(arguments);if(1===t.length)if(u(r))e=r;else if(n.isHash(r))for(var i in r)r.hasOwnProperty(i)&&e.push([i,r[i]]);else e.push(r);else A(t,function(r){e=e.concat(N(r))})}return e}function k(r){return(r=r||[]).length?q(r,function(r,n){return r+n}):0}function D(r){var n,e=[],t=-1,u=0;if(r)for(n=r.length;++t<n;){var i=r[t];-1===b(e,i)&&(e[u++]=i)}return e}function S(r,n){var e=r.slice();return\"number\"!=typeof n&&(n=1),n&&u(r)?(n>0?(e.push(e.shift()),n--):(e.unshift(e.pop()),n++),S(e,n)):e}function U(r){var n=y(arguments);return q(n.length>1?n:N(r),function(r,n){return r.concat(n)},[])}var z={toArray:N,sum:k,avg:function(r){if((r=r||[]).length){var e=k(r);if(n.isNumber(e))return e/r.length;throw new Error(\"Cannot average an array of non numbers.\")}return 0},sort:function(r,n){return T(r,n)},min:function(r,n){return T(r,n)[0]},max:function(r,n){return T(r,n)[r.length-1]},difference:function(r){var n=r,e=U(y(arguments,1));return u(r)&&(n=O(r,function(r){return-1===b(e,r)})),n},removeDuplicates:D,unique:function(r){return D(r)},rotate:S,permutations:function(r,n){var e=[];if(u(r)){var t=r.slice(0);\"number\"!=typeof n&&(n=r.length),n?n<=r.length&&(e=q(r,function(r,e,u){var i;return i=n>1?function(r,n,e){for(var t=[],u=0;u<n.length;u++)t.push([r].concat(S(n,u)).slice(0,e));return t}(e,S(t,u).slice(1),n):[[e]],r.concat(i)},[])):e=[[]]}return e},zip:function(){var r=[],e=y(arguments);if(e.length>1){var t=e.shift();u(t)&&(r=q(t,function(r,t,i){for(var o=[t],f=0;f<e.length;f++){var c=e[f];u(c)&&!n.isUndefined(c[i])?o.push(c[i]):o.push(null)}return r.push(o),r},[]))}return r},transpose:function(r){var n,e=[];return u(r)&&r.length&&A(r,function(r){!u(r)||n&&r.length!==n.length||(A(r,function(r,n){e[n]||(e[n]=[]),e[n].push(r)}),n=r)}),e},valuesAt:function(r,n){var e=[];if(r=(n=y(arguments)).shift(),u(r)&&n.length)for(var t=0,i=n.length;t<i;t++)e.push(r[n[t]]||null);return e},union:function(){var r=[],n=y(arguments);if(n.length>1){for(var e=0,t=n.length;e<t;e++)r=r.concat(n[e]);r=D(r)}return r},intersect:function(){var r,n,e=[],t=-1;if(r=arguments.length>1?y(arguments):arguments[0],u(r))for(e=r[0],t=0,n=r.length;++t<n;)e=m(e,r[t]);return D(e)},powerSet:function(r){var n=[];return u(r)&&r.length&&(n=q(r,function(r,n){var e=R(r,function(r){return r.concat(n)});return r.concat(e)},[[]])),n},cartesian:function r(n,e){var t,i,o=[];return u(n)&&u(e)&&n.length&&e.length&&(o=(t=n[0],i=e,M(i,function(r,n){return u(n)||(n=[n]),n.unshift(t),r.unshift(n),r},[])).concat(r(n.slice(1),e))),o},compact:function(r){var e=[];return u(r)&&r.length&&(e=O(r,function(r){return!n.isUndefinedOrNull(r)})),e},multiply:function(r,e){(e=n.isNumber(e)?e:1)||(e=1),r=N(r||[]);for(var t=[],u=0;++u<=e;)t=t.concat(r);return t},flatten:U,pluck:function(r,n){n=n.split(\".\");var e=r.slice(0);return A(n,function(r){var n=r.match(/(\\w+)\\(\\)$/);e=R(e,function(e){return n?e[n[1]]():e[r]})}),e},invoke:function(r,n,e){return e=y(arguments,2),R(r,function(r){return(t(n)?r[n]:n).apply(r,e)})},forEach:A,map:R,filter:O,reduce:q,reduceRight:M,some:function(r,n,e){if(r&&d&&d===r.some)return r.some(n,e);if(!u(r)||\"function\"!=typeof n)throw new TypeError;for(var t=Object(r),i=t.length>>>0,o=0;o<i;o++)if(o in t&&n.call(e,t[o],o,t))return!0;return!1},every:j,indexOf:b,lastIndexOf:function(r,n,e){if(!u(r))throw new TypeError;var t=Object(r),i=t.length>>>0;if(0===i)return-1;var a=i;arguments.length>2&&((a=Number(arguments[2]))!=a?a=0:0!==a&&a!==1/0&&a!==-1/0&&(a=(a>0||-1)*o(f(a))));for(var l=a>=0?c(a,i-1):i-f(a);l>=0;l--)if(l in t&&t[l]===n)return l;return-1}};return r.define(u,z).expose(z)}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=n(require(\"extended\"),require(\"is-extended\"),require(\"arguments-extended\"))):\"function\"==typeof r&&r.amd?r([\"extended\",\"is-extended\",\"arguments-extended\"],function(r,e,t){return n(r,e,t)}):this.arrayExtended=n(this.extended,this.isExtended,this.argumentsExtended)}).call(this);\n},{\"extended\":\"9zzC\",\"is-extended\":\"8tFl\",\"arguments-extended\":\"Hwmr\"}],\"3zVL\":[function(require,module,exports) {\nvar define;\nvar e;(function(){\"use strict\";function r(e,r,n){var t=r.deepEqual,o=r.isString,i=r.isHash,u=n.difference,f=Object.prototype.hasOwnProperty,d=r.isFunction;function a(e,r){var n,t;for(n in r)f.call(r,n)&&(t=r[n],n in e&&e[n]===t||(e[n]=t));return e}function c(e,r){var n,o,u;for(n in r)f.call(r,n)&&(o=r[n],u=e[n],t(u,o)||(i(u)&&i(o)?e[n]=c(u,o):i(o)?e[n]=c({},o):e[n]=o));return e}function l(e){e||(e={});for(var r=1,n=arguments.length;r<n;r++)a(e,arguments[r]);return e}function h(e,r){return l(e.prototype||e,r),e}function p(e){if(!i(e))throw new TypeError;var r=[];for(var n in e)f.call(e,n)&&r.push(n);return r}function s(e,r){if(!i(e))throw new TypeError;o(r)&&(r=[r]);for(var n,t=u(p(e),r),f={},d=0,a=t.length;d<a;++d)f[n=t[d]]=e[n];return f}var x={forEach:function(e,r,n){if(!i(e)||!d(r))throw new TypeError;for(var t,o=p(e),u=0,f=o.length;u<f;++u)t=o[u],r.call(n||e,e[t],t,e);return e},filter:function(e,r,n){if(!i(e)||!d(r))throw new TypeError;for(var t,o,u=p(e),f={},a=0,c=u.length;a<c;++a)o=e[t=u[a]],r.call(n||e,o,t,e)&&(f[t]=o);return f},invert:function(e){if(!i(e))throw new TypeError;for(var r,n=p(e),t={},o=0,u=n.length;o<u;++o)t[e[r=n[o]]]=r;return t},values:function(e){if(!i(e))throw new TypeError;for(var r=p(e),n=[],t=0,o=r.length;t<o;++t)n.push(e[r[t]]);return n},toArray:function(e){if(!i(e))throw new TypeError;for(var r,n=p(e),t=[],o=0,u=n.length;o<u;++o)r=n[o],t.push([r,e[r]]);return t},keys:p,omit:s},y={extend:h,merge:l,deepMerge:function(e){e||(e={});for(var r=1,n=arguments.length;r<n;r++)c(e,arguments[r]);return e},omit:s},v=e.define(r.isObject,y).define(i,x).define(r.isFunction,{extend:h}).expose({hash:x}).expose(y),w=v.extend;return v.extend=function(){if(1===arguments.length)return w.extend.apply(v,arguments);h.apply(null,arguments)},v}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=r(require(\"extended\"),require(\"is-extended\"),require(\"array-extended\"))):\"function\"==typeof e&&e.amd?e([\"extended\",\"is-extended\",\"array-extended\"],function(e,n,t){return r(e,n,t)}):this.objectExtended=r(this.extended,this.isExtended,this.arrayExtended)}).call(this);\n},{\"extended\":\"9zzC\",\"is-extended\":\"8tFl\",\"array-extended\":\"6f/Y\"}],\"NFoL\":[function(require,module,exports) {\nvar define;\nvar e;(function(){\"use strict\";function t(e,t,r){function n(e,t,r,n){r=r||\" \";for(var a=(e=\"\"+e).length;a<t;)n?e+=r:e=r+e,a++;return e}var a=function(){var e=Math.floor,t=Math.round,r={day:function(e,t){return[t,\"Date\",!1]},weekday:function(e,t){var r,n,a=t%5,i=e.getDay(),u=0;a?(r=a,n=parseInt(t/5,10)):(r=t>0?5:-5,n=t>0?(t-5)/5:(t+5)/5),6===i&&t>0?u=1:0===i&&t<0&&(u=-1);var o=i+r;return 0!==o&&6!==o||(u=t>0?2:-2),[7*n+r+u,\"Date\",!1]},year:function(e,t){return[t,\"FullYear\",!0]},week:function(e,t){return[7*t,\"Date\",!1]},quarter:function(e,t){return[3*t,\"Month\",!0]},month:function(e,t){return[t,\"Month\",!0]}};var n={quarter:function(t,r,n){var a=r.getFullYear()-t.getFullYear(),i=t[n?\"getUTCMonth\":\"getMonth\"](),u=r[n?\"getUTCMonth\":\"getMonth\"](),o=e(i/3)+1,s=e(u/3)+1;return(s+=4*a)-o},weekday:function(e,t,r){var n,i=a(\"day\",e,t,r),u=i%7;if(0===u)i=5*a(\"week\",e,t,r);else{var o=0,s=e[r?\"getUTCDay\":\"getDay\"](),f=t[r?\"getUTCDay\":\"getDay\"]();n=parseInt(i/7,10);var l=new Date(+e);l.setDate(l[r?\"getUTCDate\":\"getDate\"]()+7*n);var g=l[r?\"getUTCDay\":\"getDay\"]();i>0?6===s||6===f?o=-1:0===s?o=0:(0===f||g+u>5)&&(o=-2):i<0&&(6===s?o=0:0===s||0===f?o=1:(6===f||g+u<0)&&(o=2)),i+=o,i-=2*n}return i},year:function(e,t){return t.getFullYear()-e.getFullYear()},month:function(e,t,r){var n=e[r?\"getUTCMonth\":\"getMonth\"]();return t[r?\"getUTCMonth\":\"getMonth\"]()-n+12*(t.getFullYear()-e.getFullYear())},week:function(e,r,n){return t(a(\"day\",e,r,n)/7)},day:function(e,t){return 1.1574074074074074e-8*(t.getTime()-e.getTime())},hour:function(e,t){return 2.7777777777777776e-7*(t.getTime()-e.getTime())},minute:function(e,t){return 16666666666666667e-21*(t.getTime()-e.getTime())},second:function(e,t){return.001*(t.getTime()-e.getTime())},millisecond:function(e,t){return t.getTime()-e.getTime()}};function a(e,r,a,i){return e=e.replace(/s$/,\"\"),t(n[e](r,a,i))}return{addTransform:function(e,t,n){return e=e.replace(/s$/,\"\"),r.hasOwnProperty(e)?r[e](t,n):[n,\"UTC\"+e.charAt(0).toUpperCase()+e.substring(1)+\"s\",!1]},differenceTransform:a}}(),i=a.addTransform,u=a.differenceTransform,o=Math.floor,s=Math.round,f=Math.min,l=Math.pow,g=Math.ceil,d=Math.abs,c=[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"],h=[\"Jan.\",\"Feb.\",\"Mar.\",\"Apr.\",\"May.\",\"Jun.\",\"Jul.\",\"Aug.\",\"Sep.\",\"Oct.\",\"Nov.\",\"Dec.\"],y=[\"Sunday\",\"Monday\",\"Tuesday\",\"Wednesday\",\"Thursday\",\"Friday\",\"Saturday\"],D=[\"Sun\",\"Mon\",\"Tue\",\"Wed\",\"Thu\",\"Fri\",\"Sat\"],M=[\"Before Christ\",\"Anno Domini\"],p=[\"BC\",\"AD\"];function v(e,t){return T.difference(new Date(e.getFullYear(),0,1,e.getHours()),e,null,t)+1}function m(e){var t=e.toString(),r=\"\",n=t.indexOf(\"(\");return n>-1&&(r=t.substring(++n,t.indexOf(\")\"))),r}var T={getDaysInMonth:function(e){var t=e.getMonth();return 1===t&&T.isLeapYear(e)?29:[31,28,31,30,31,30,31,31,30,31,30,31][t]},isLeapYear:function(e,t){var r=e[t?\"getUTCFullYear\":\"getFullYear\"]();return r%400==0||r%4==0&&r%100!=0},isWeekend:function(e,t){var r=(e||new Date)[t?\"getUTCDay\":\"getDay\"]();return 0===r||6===r},getTimezoneName:m,compare:function(e,t,r){return e=new Date(+e),t=new Date(+(t||new Date)),\"date\"===r?(e.setHours(0,0,0,0),t.setHours(0,0,0,0)):\"time\"===r&&(e.setFullYear(0,0,0),t.setFullYear(0,0,0)),e>t?1:e<t?-1:0},add:function(e,t,r){var n=i(t,e,r||0);r=n[0];var a=n[1],u=new Date(+e),o=n[2];return a&&u[\"set\"+a](u[\"get\"+a]()+r),o&&u.getDate()<e.getDate()&&u.setDate(0),u},difference:function(e,t,r,n){return t=t||new Date,u(r=r||\"day\",e,t,n)},format:function(e,r,a){var i,u,f,T,w,C,x,F;return(a=a||!1)?(i=e.getUTCFullYear(),u=e.getUTCMonth(),f=e.getUTCDay(),T=e.getUTCDate(),w=e.getUTCHours(),C=e.getUTCMinutes(),x=e.getUTCSeconds(),F=e.getUTCMilliseconds()):(i=e.getFullYear(),u=e.getMonth(),T=e.getDate(),f=e.getDay(),w=e.getHours(),C=e.getMinutes(),x=e.getSeconds(),F=e.getMilliseconds()),r.replace(/([A-Za-z])\\1*/g,function(r){var U,Y,A=r.charAt(0),S=r.length;if(\"d\"===A)U=\"\"+T,Y=!0;else if(\"H\"!==A||U)if(\"m\"!==A||U)if(\"s\"===A)U||(U=\"\"+x),Y=!0;else if(\"G\"===A)U=(S<4?p:M)[i<0?0:1];else if(\"y\"===A)U=i,S>1&&(2===S?U=function e(r,n,a){var i=r;if(t.isString(i)){if(r.length>n)if(a){var u=r.length;i=r.substring(u-n,u)}else i=r.substring(0,n)}else i=e(\"\"+i,n);return i}(\"\"+U,2,!0):Y=!0);else if(\"Q\"===A.toUpperCase())U=g((u+1)/3),Y=!0;else if(\"M\"===A)S<3?(U=u+1,Y=!0):U=(3===S?h:c)[u];else if(\"w\"===A)U=function(e,t,r){t=t||0;var n=e[r?\"getUTCFullYear\":\"getFullYear\"](),a=new Date(n,0,1).getDay(),i=(a-t+7)%7,u=o((v(e)+i-1)/7);return a===t&&u++,u}(e,0,a),Y=!0;else if(\"D\"===A)U=v(e,a),Y=!0;else if(\"E\"===A)S<3?(U=f+1,Y=!0):U=(-3===S?D:y)[f];else if(\"a\"===A)U=w<12?\"AM\":\"PM\";else if(\"h\"===A)U=w%12||12,Y=!0;else if(\"K\"===A)U=w%12,Y=!0;else if(\"k\"===A)U=w||24,Y=!0;else if(\"S\"===A)U=s(F*l(10,S-3)),Y=!0;else if(\"z\"===A||\"v\"===A||\"Z\"===A){if(U=m(e),\"z\"!==A&&\"v\"!==A||U||(S=4),!U||\"Z\"===A){var b=e.getTimezoneOffset(),O=[b>=0?\"-\":\"+\",n(o(d(b)/60),2,\"0\"),n(d(b)%60,2,\"0\")];4===S&&(O.splice(0,0,\"GMT\"),O.splice(3,0,\":\")),U=O.join(\"\")}}else U=r;else U=\"\"+C,Y=!0;else U=\"\"+w,Y=!0;return Y&&(U=n(U,S,\"0\")),U})}},w={};function C(e){w[e+\"sFromNow\"]=function(t){return T.add(new Date,e,t)},w[e+\"sAgo\"]=function(t){return T.add(new Date,e,-t)}}for(var x=[\"year\",\"month\",\"day\",\"hour\",\"minute\",\"second\"],F=0,U=x.length;F<U;F++)C(x[F]);var Y={parseDate:function(e,n){if(!n)throw new Error(\"format required when calling dateExtender.parse\");var a=[],i=function(e,t){return e.replace(/([a-z])\\1*/gi,function(e){var r,n=e.charAt(0),a=e.length;return\"y\"===n?r=\"\\\\d{2,4}\":\"M\"===n?r=a>2?\"\\\\S+?\":\"1[0-2]|0?[1-9]\":\"D\"===n?r=\"[12][0-9][0-9]|3[0-5][0-9]|36[0-6]|0{0,2}[1-9][0-9]|0?[1-9]\":\"d\"===n?r=\"3[01]|[12]\\\\d|0?[1-9]\":\"w\"===n?r=\"[1-4][0-9]|5[0-3]|0?[1-9]\":\"E\"===n?r=\"\\\\S+\":\"h\"===n?r=\"1[0-2]|0?[1-9]\":\"K\"===n?r=\"1[01]|0?\\\\d\":\"H\"===n?r=\"1\\\\d|2[0-3]|0?\\\\d\":\"k\"===n?r=\"1\\\\d|2[0-4]|0?[1-9]\":\"m\"===n||\"s\"===n?r=\"[0-5]\\\\d\":\"S\"===n?r=\"\\\\d{\"+a+\"}\":\"a\"===n?(r=\"AM|PM\",\"AM\"!==\"AM\".toLowerCase()&&(r+=\"|\"+\"AM\".toLowerCase()),\"PM\"!==\"PM\".toLowerCase()&&(r+=\"|\"+\"PM\".toLowerCase()),r=r.replace(/\\./g,\"\\\\.\")):r=\"v\"===n||\"z\"===n||\"Z\"===n||\"G\"===n||\"q\"===n||\"Q\"===n?\".*\":\" \"===n?\"\\\\s*\":n+\"*\",t&&t.push(e),\"(\"+r+\")\"}).replace(/[\\xa0 ]/g,\"[\\\\s\\\\xa0]\")}(n,a),u=new RegExp(\"^\"+i+\"$\",\"i\").exec(e);if(!u)return null;var o=[1970,0,1,0,0,0,0],s=\"\";if(function(e,r,n){if(!t.isArray(e)||\"function\"!=typeof r)throw new TypeError;for(var a=Object(e),i=a.length>>>0,u=0;u<i;u++)if(u in a&&!r.call(n,a[u],u,a))return!1;return!0}(u,function(e,t){if(t){var n=a[t-1],i=n.length,u=n.charAt(0);if(\"y\"===u)if(e<100){e=parseInt(e,10);var l=\"\"+(new Date).getFullYear(),g=100*l.substring(0,2),d=f(l.substring(2,4)+20,99);o[0]=e<d?g+e:g-100+e}else o[0]=e;else if(\"M\"===u){if(i>2){var M,p,v=c;3===i&&(v=h),e=e.replace(\".\",\"\").toLowerCase();var m=!1;for(M=0,p=v.length;M<p&&!m;M++){v[M].replace(\".\",\"\").toLocaleLowerCase()===e&&(e=M,m=!0)}if(!m)return!1}else e--;o[1]=e}else if(\"E\"===u||\"e\"===u){var T=y;3===i&&(T=D),e=e.toLowerCase(),T=r.map(T,function(e){return e.toLowerCase()});var w=r.indexOf(T,e);if(-1===w){if(e=parseInt(e,10),isNaN(e)||e>T.length)return!1}else e=w}else if(\"D\"===u||\"d\"===u)\"D\"===u&&(o[1]=0),o[2]=e;else if(\"a\"===u){e=e.replace(/\\./g,\"\").toLowerCase(),s=\"pm\"===e?\"p\":\"am\"===e?\"a\":\"\"}else\"k\"===u||\"h\"===u||\"H\"===u||\"K\"===u?(\"k\"===u&&24==+e&&(e=0),o[3]=e):\"m\"===u?o[4]=e:\"s\"===u?o[5]=e:\"S\"===u&&(o[6]=e)}return!0})){var l=+o[3];\"p\"===s&&l<12?o[3]=l+12:\"a\"===s&&12===l&&(o[3]=0);var g=new Date(o[0],o[1],o[2],o[3],o[4],o[5],o[6]),d=-1!==r.indexOf(a,\"d\"),M=-1!==r.indexOf(a,\"M\"),p=o[1],v=o[2],m=g.getMonth(),T=g.getDate();return M&&m>p||d&&T>v?null:g}return null}},A=e.define(t.isDate,T).define(t.isString,Y).define(t.isNumber,w);for(F in T)T.hasOwnProperty(F)&&(A[F]=T[F]);for(F in Y)Y.hasOwnProperty(F)&&(A[F]=Y[F]);for(F in w)w.hasOwnProperty(F)&&(A[F]=w[F]);return A}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=t(require(\"extended\"),require(\"is-extended\"),require(\"array-extended\"))):\"function\"==typeof e&&e.amd?e([\"extended\",\"is-extended\",\"array-extended\"],function(e,r,n){return t(e,r,n)}):this.dateExtended=t(this.extended,this.isExtended,this.arrayExtended)}).call(this);\n},{\"extended\":\"9zzC\",\"is-extended\":\"8tFl\",\"array-extended\":\"6f/Y\"}],\"Artt\":[function(require,module,exports) {\nvar define;\nvar E;(function(){\"use strict\";function e(E,e,_,r){var t;\"undefined\"==typeof JSON?function(){function E(E){return E<10?\"0\"+E:E}var _=e.tester().isString().isNumber().isBoolean().tester();var r,n,L,T=/[\\\\\\\"\\x00-\\x1f\\x7f-\\x9f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g,O={\"\\b\":\"\\\\b\",\"\\t\":\"\\\\t\",\"\\n\":\"\\\\n\",\"\\f\":\"\\\\f\",\"\\r\":\"\\\\r\",'\"':'\\\\\"',\"\\\\\":\"\\\\\\\\\"};function i(E){return T.lastIndex=0,T.test(E)?'\"'+E.replace(T,function(E){var e=O[E];return\"string\"==typeof e?e:\"\\\\u\"+(\"0000\"+E.charCodeAt(0).toString(16)).slice(-4)})+'\"':'\"'+E+'\"'}function A(t,T){var O,I,u,R,a,o,f=r,s=T[t];switch(s&&(o=s,s=e.isDate(o)?isFinite(o.valueOf())?o.getUTCFullYear()+\"-\"+E(o.getUTCMonth()+1)+\"-\"+E(o.getUTCDate())+\"T\"+E(o.getUTCHours())+\":\"+E(o.getUTCMinutes())+\":\"+E(o.getUTCSeconds())+\"Z\":null:_(o)?o.valueOf():o),\"function\"==typeof L&&(s=L.call(T,t,s)),typeof s){case\"string\":return i(s);case\"number\":return isFinite(s)?String(s):\"null\";case\"boolean\":case\"null\":return String(s);case\"object\":if(!s)return\"null\";if(r+=n,a=[],\"[object Array]\"===Object.prototype.toString.apply(s)){for(R=s.length,O=0;O<R;O+=1)a[O]=A(O,s)||\"null\";return u=0===a.length?\"[]\":r?\"[\\n\"+r+a.join(\",\\n\"+r)+\"\\n\"+f+\"]\":\"[\"+a.join(\",\")+\"]\",r=f,u}if(L&&\"object\"==typeof L)for(R=L.length,O=0;O<R;O+=1)\"string\"==typeof L[O]&&(u=A(I=L[O],s))&&a.push(i(I)+(r?\": \":\":\")+u);else for(I in s)Object.prototype.hasOwnProperty.call(s,I)&&(u=A(I,s))&&a.push(i(I)+(r?\": \":\":\")+u);return u=0===a.length?\"{}\":r?\"{\\n\"+r+a.join(\",\\n\"+r)+\"\\n\"+f+\"}\":\"{\"+a.join(\",\")+\"}\",r=f,u}}t=function(E,e,_){var t;if(r=\"\",n=\"\",\"number\"==typeof _)for(t=0;t<_;t+=1)n+=\" \";else\"string\"==typeof _&&(n=_);if(L=e,e&&\"function\"!=typeof e&&(\"object\"!=typeof e||\"number\"!=typeof e.length))throw new Error(\"JSON.stringify\");return A(\"\",{\"\":E})}}():t=JSON.stringify;var n=e.isHash,L=Array.prototype.slice,T=/%((?:-?\\+?.?\\d*)?|(?:\\[[^\\[|\\]]*\\]))?([sjdDZ])/g,O=/\\{(?:\\[([^\\[|\\]]*)\\])?(\\w+)\\}/g,i=/(-?)(\\+?)([A-Z|a-z|\\W]?)([1-9][0-9]*)?$/,A=/([1-9][0-9]*)$/g;function I(E,e){var _=E;if(i.test(e)){var r=e.match(i),t=r[1],n=r[3],L=r[4];L&&(L=parseInt(L,10),_=_.length<L?o(_,L,n,t):f(_,L))}return _}function u(E,_){var r;if(!e.isNumber(E))throw new Error(\"stringExtended.format : when using %d the parameter must be a number!\");if(r=\"\"+E,i.test(_)){var t=_.match(i),n=t[1],L=t[2],T=t[3],O=t[4];L&&(r=(E>0?\"+\":\"\")+r),O&&(O=parseInt(O,10),r=r.length<O?o(r,O,T||\"0\",n):f(r,O))}return r}function R(E,e){var _,r=e.match(A),n=0;r&&(n=parseInt(r[0],10),isNaN(n)&&(n=0));try{_=t(E,null,n)}catch(L){throw new Error(\"stringExtended.format : Unable to parse json from \",E)}return _}var a={bold:1,bright:1,italic:3,underline:4,blink:5,inverse:7,crossedOut:9,red:31,green:32,yellow:33,blue:34,magenta:35,cyan:36,white:37,redBackground:41,greenBackground:42,yellowBackground:43,blueBackground:44,magentaBackground:45,cyanBackground:46,whiteBackground:47,encircled:52,overlined:53,grey:90,black:90};function o(E,e,_,r){_=_||\" \";for(var t=(E=\"\"+E).length;t<e;)r?E+=_:E=_+E,t++;return E}function f(E,_,r){var t=E;if(e.isString(t)){if(E.length>_)if(r){var n=E.length;t=E.substring(n-_,n)}else t=E.substring(0,_)}else t=f(\"\"+t,_);return t}function s(E,_){var r,t,n;if(_)if(e.isArray(E))for(r=[],t=0,n=E.length;t<n;t++)r.push(s(E[t],_));else if(_ instanceof Array)for(r=E,t=0,n=_.length;t<n;t++)r=s(r,_[t]);else _ in a&&(r=\"\u001b[\"+a[_]+\"m\"+E+\"\u001b[0m\");return r}var N={toArray:function(E,e){var _=[];return E&&(E.indexOf(e)>0?_=E.replace(/\\s+/g,\"\").split(e):_.push(E)),_},pad:o,truncate:f,multiply:function(E,e){var _=[];if(e)for(var r=0;r<e;r++)_.push(E);return _.join(\"\")},format:function E(r,i){if(i instanceof Array){var A=0,a=i.length;return r.replace(T,function(E,e,r){var n,L;if(!(A<a))return E;if(n=i[A++],\"%s\"===E||\"%d\"===E||\"%D\"===E)L=n+\"\";else if(\"%Z\"===E)L=n.toUTCString();else if(\"%j\"===E)try{L=t(n)}catch(T){throw new Error(\"stringExtended.format : Unable to parse json from \",n)}else switch(e=e.replace(/^\\[|\\]$/g,\"\"),r){case\"s\":L=I(n,e);break;case\"d\":L=u(n,e);break;case\"j\":L=R(n,e);break;case\"D\":L=_.format(n,e);break;case\"Z\":L=_.format(n,e,!0)}return L})}return n(i)?r.replace(O,function(E,r,t){if(t=i[t],!e.isUndefined(t)){if(!r)return\"\"+t;if(e.isString(t))return I(t,r);if(e.isNumber(t))return u(t,r);if(e.isDate(t))return _.format(t,r);if(e.isObject(t))return R(t,r)}return E}):E(r,L.call(arguments).slice(1))},style:s,escape:function(E,e){return E.replace(/([\\.$?*|{}\\(\\)\\[\\]\\\\\\/\\+^])/g,function(E){return e&&-1!==r.indexOf(e,E)?E:\"\\\\\"+E})},trim:function(E){return E.replace(/^\\s*|\\s*$/g,\"\")},trimLeft:function(E){return E.replace(/^\\s*/,\"\")},trimRight:function(E){return E.replace(/\\s*$/,\"\")},isEmpty:function(E){return 0===E.length}};return E.define(e.isString,N).define(e.isArray,{style:s}).expose(N).expose({characters:{SMILEY:\"☺\",SOLID_SMILEY:\"☻\",HEART:\"♥\",DIAMOND:\"♦\",CLOVE:\"♣\",SPADE:\"♠\",DOT:\"•\",SQUARE_CIRCLE:\"◘\",CIRCLE:\"○\",FILLED_SQUARE_CIRCLE:\"◙\",MALE:\"♂\",FEMALE:\"♀\",EIGHT_NOTE:\"♪\",DOUBLE_EIGHTH_NOTE:\"♫\",SUN:\"☼\",PLAY:\"►\",REWIND:\"◄\",UP_DOWN:\"↕\",PILCROW:\"¶\",SECTION:\"§\",THICK_MINUS:\"▬\",SMALL_UP_DOWN:\"↨\",UP_ARROW:\"↑\",DOWN_ARROW:\"↓\",RIGHT_ARROW:\"→\",LEFT_ARROW:\"←\",RIGHT_ANGLE:\"∟\",LEFT_RIGHT_ARROW:\"↔\",TRIANGLE:\"▲\",DOWN_TRIANGLE:\"▼\",HOUSE:\"⌂\",C_CEDILLA:\"Ç\",U_UMLAUT:\"ü\",E_ACCENT:\"é\",A_LOWER_CIRCUMFLEX:\"â\",A_LOWER_UMLAUT:\"ä\",A_LOWER_GRAVE_ACCENT:\"à\",A_LOWER_CIRCLE_OVER:\"å\",C_LOWER_CIRCUMFLEX:\"ç\",E_LOWER_CIRCUMFLEX:\"ê\",E_LOWER_UMLAUT:\"ë\",E_LOWER_GRAVE_ACCENT:\"è\",I_LOWER_UMLAUT:\"ï\",I_LOWER_CIRCUMFLEX:\"î\",I_LOWER_GRAVE_ACCENT:\"ì\",A_UPPER_UMLAUT:\"Ä\",A_UPPER_CIRCLE:\"Å\",E_UPPER_ACCENT:\"É\",A_E_LOWER:\"æ\",A_E_UPPER:\"Æ\",O_LOWER_CIRCUMFLEX:\"ô\",O_LOWER_UMLAUT:\"ö\",O_LOWER_GRAVE_ACCENT:\"ò\",U_LOWER_CIRCUMFLEX:\"û\",U_LOWER_GRAVE_ACCENT:\"ù\",Y_LOWER_UMLAUT:\"ÿ\",O_UPPER_UMLAUT:\"Ö\",U_UPPER_UMLAUT:\"Ü\",CENTS:\"¢\",POUND:\"£\",YEN:\"¥\",CURRENCY:\"¤\",PTS:\"₧\",FUNCTION:\"ƒ\",A_LOWER_ACCENT:\"á\",I_LOWER_ACCENT:\"í\",O_LOWER_ACCENT:\"ó\",U_LOWER_ACCENT:\"ú\",N_LOWER_TILDE:\"ñ\",N_UPPER_TILDE:\"Ñ\",A_SUPER:\"ª\",O_SUPER:\"º\",UPSIDEDOWN_QUESTION:\"¿\",SIDEWAYS_L:\"⌐\",NEGATION:\"¬\",ONE_HALF:\"½\",ONE_FOURTH:\"¼\",UPSIDEDOWN_EXCLAMATION:\"¡\",DOUBLE_LEFT:\"«\",DOUBLE_RIGHT:\"»\",LIGHT_SHADED_BOX:\"░\",MEDIUM_SHADED_BOX:\"▒\",DARK_SHADED_BOX:\"▓\",VERTICAL_LINE:\"│\",MAZE__SINGLE_RIGHT_T:\"┤\",MAZE_SINGLE_RIGHT_TOP:\"┐\",MAZE_SINGLE_RIGHT_BOTTOM_SMALL:\"┘\",MAZE_SINGLE_LEFT_TOP_SMALL:\"┌\",MAZE_SINGLE_LEFT_BOTTOM_SMALL:\"└\",MAZE_SINGLE_LEFT_T:\"├\",MAZE_SINGLE_BOTTOM_T:\"┴\",MAZE_SINGLE_TOP_T:\"┬\",MAZE_SINGLE_CENTER:\"┼\",MAZE_SINGLE_HORIZONTAL_LINE:\"─\",MAZE_SINGLE_RIGHT_DOUBLECENTER_T:\"╡\",MAZE_SINGLE_RIGHT_DOUBLE_BL:\"╛\",MAZE_SINGLE_RIGHT_DOUBLE_T:\"╢\",MAZE_SINGLE_RIGHT_DOUBLEBOTTOM_TOP:\"╖\",MAZE_SINGLE_RIGHT_DOUBLELEFT_TOP:\"╕\",MAZE_SINGLE_LEFT_DOUBLE_T:\"╞\",MAZE_SINGLE_BOTTOM_DOUBLE_T:\"╧\",MAZE_SINGLE_TOP_DOUBLE_T:\"╤\",MAZE_SINGLE_TOP_DOUBLECENTER_T:\"╥\",MAZE_SINGLE_BOTTOM_DOUBLECENTER_T:\"╨\",MAZE_SINGLE_LEFT_DOUBLERIGHT_BOTTOM:\"╘\",MAZE_SINGLE_LEFT_DOUBLERIGHT_TOP:\"╒\",MAZE_SINGLE_LEFT_DOUBLEBOTTOM_TOP:\"╓\",MAZE_SINGLE_LEFT_DOUBLETOP_BOTTOM:\"╙\",MAZE_SINGLE_LEFT_TOP:\"Γ\",MAZE_SINGLE_RIGHT_BOTTOM:\"╜\",MAZE_SINGLE_LEFT_CENTER:\"╟\",MAZE_SINGLE_DOUBLECENTER_CENTER:\"╫\",MAZE_SINGLE_DOUBLECROSS_CENTER:\"╪\",MAZE_DOUBLE_LEFT_CENTER:\"╣\",MAZE_DOUBLE_VERTICAL:\"║\",MAZE_DOUBLE_RIGHT_TOP:\"╗\",MAZE_DOUBLE_RIGHT_BOTTOM:\"╝\",MAZE_DOUBLE_LEFT_BOTTOM:\"╚\",MAZE_DOUBLE_LEFT_TOP:\"╔\",MAZE_DOUBLE_BOTTOM_T:\"╩\",MAZE_DOUBLE_TOP_T:\"╦\",MAZE_DOUBLE_LEFT_T:\"╠\",MAZE_DOUBLE_HORIZONTAL:\"═\",MAZE_DOUBLE_CROSS:\"╬\",SOLID_RECTANGLE:\"█\",THICK_LEFT_VERTICAL:\"▌\",THICK_RIGHT_VERTICAL:\"▐\",SOLID_SMALL_RECTANGLE_BOTTOM:\"▄\",SOLID_SMALL_RECTANGLE_TOP:\"▀\",PHI_UPPER:\"Φ\",INFINITY:\"∞\",INTERSECTION:\"∩\",DEFINITION:\"≡\",PLUS_MINUS:\"±\",GT_EQ:\"≥\",LT_EQ:\"≤\",THEREFORE:\"⌠\",SINCE:\"∵\",DOESNOT_EXIST:\"∄\",EXISTS:\"∃\",FOR_ALL:\"∀\",EXCLUSIVE_OR:\"⊕\",BECAUSE:\"⌡\",DIVIDE:\"÷\",APPROX:\"≈\",DEGREE:\"°\",BOLD_DOT:\"∙\",DOT_SMALL:\"·\",CHECK:\"√\",ITALIC_X:\"✗\",SUPER_N:\"ⁿ\",SQUARED:\"²\",CUBED:\"³\",SOLID_BOX:\"■\",PERMILE:\"‰\",REGISTERED_TM:\"®\",COPYRIGHT:\"©\",TRADEMARK:\"™\",BETA:\"β\",GAMMA:\"γ\",ZETA:\"ζ\",ETA:\"η\",IOTA:\"ι\",KAPPA:\"κ\",LAMBDA:\"λ\",NU:\"ν\",XI:\"ξ\",OMICRON:\"ο\",RHO:\"ρ\",UPSILON:\"υ\",CHI_LOWER:\"φ\",CHI_UPPER:\"χ\",PSI:\"ψ\",ALPHA:\"α\",ESZETT:\"ß\",PI:\"π\",SIGMA_UPPER:\"Σ\",SIGMA_LOWER:\"σ\",MU:\"µ\",TAU:\"τ\",THETA:\"Θ\",OMEGA:\"Ω\",DELTA:\"δ\",PHI_LOWER:\"φ\",EPSILON:\"ε\"}})}\"undefined\"!=typeof exports?\"undefined\"!=typeof module&&module.exports&&(module.exports=e(require(\"extended\"),require(\"is-extended\"),require(\"date-extended\"),require(\"array-extended\"))):\"function\"==typeof E&&E.amd?E([\"extended\",\"is-extended\",\"date-extended\",\"array-extended\"],function(E,_,r,t){return e(E,_,r,t)}):this.stringExtended=e(this.extended,this.isExtended,this.dateExtended,this.arrayExtended)}).call(this);\n},{\"extended\":\"9zzC\",\"is-extended\":\"8tFl\",\"date-extended\":\"NFoL\",\"array-extended\":\"6f/Y\"}],\"zv8z\":[function(require,module,exports) {\nexports.endianness=function(){return\"LE\"},exports.hostname=function(){return\"undefined\"!=typeof location?location.hostname:\"\"},exports.loadavg=function(){return[]},exports.uptime=function(){return 0},exports.freemem=function(){return Number.MAX_VALUE},exports.totalmem=function(){return Number.MAX_VALUE},exports.cpus=function(){return[]},exports.type=function(){return\"Browser\"},exports.release=function(){return\"undefined\"!=typeof navigator?navigator.appVersion:\"\"},exports.networkInterfaces=exports.getNetworkInterfaces=function(){return{}},exports.arch=function(){return\"javascript\"},exports.platform=function(){return\"browser\"},exports.tmpdir=exports.tmpDir=function(){return\"/tmp\"},exports.EOL=\"\\n\",exports.homedir=function(){return\"/\"};\n},{}],\"3l4N\":[function(require,module,exports) {\nvar e=require(\"is-extended\"),r=Object.prototype.hasOwnProperty;module.exports=require(\"extended\")().register(e).register(require(\"object-extended\")).register(require(\"string-extended\")).register(\"LINE_BREAK\",require(\"os\").EOL).register(\"asyncEach\",function(e,r,t){!function t(n,a,i,s){++n<a?r(i[n],function(e){e?s(e):n%100==0?setImmediate(function(){t(n,a,i,s)}):t(n,a,i,s)}):s(null,e)}(-1,e.length,e,t)}).register(\"spreadArgs\",function(e,r,t){var n;switch((r||[]).length){case 0:n=e.call(t);break;case 1:n=e.call(t,r[0]);break;case 2:n=e.call(t,r[0],r[1]);break;case 3:n=e.call(t,r[0],r[1],r[2]);break;default:n=e.apply(t,r)}return n}).register(\"keys\",function(e){var t=[];for(var n in e)r.call(e,n)&&t.push(n);return t});\n},{\"is-extended\":\"8tFl\",\"extended\":\"9zzC\",\"object-extended\":\"3zVL\",\"string-extended\":\"Artt\",\"os\":\"zv8z\"}],\"3qPl\":[function(require,module,exports) {\nvar r=require(\"./../extended\"),e=r.has,t=r.isUndefinedOrNull,n=r.trim,s=r.trimLeft,l=r.trimRight;function u(r){var u,i,a=(r=r||{}).delimiter||\",\",o=r.ltrim||!1,f=r.rtrim||!1,c=r.trim||!1,h=e(r,\"quote\")?r.quote:'\"',g=new RegExp(\"([^\"+a+\"'\\\"\\\\s\\\\\\\\]*(?:\\\\s+[^\"+a+\"'\\\"\\\\s\\\\\\\\]+)*)\"),p=new RegExp(\"(?:\\\\n|\\\\r|\"+a+\")\"),b=r.escape||'\"',m=new RegExp(\"([^\\\\s]|\\\\r\\\\n|\\\\n|\\\\r|\"+a+\")\"),d=/(\\r\\n|\\n|\\r)/,w=new RegExp(\"(?!\"+a+\") \");function v(r){return c?r=n(r):o?r=s(r):f&&(r=l(r)),r}function E(r,e,t,n){var s,l=0,u=[],i=!1,o=0,f=r.length,c=b===h;if(f)for(;t<f&&(s=r.charAt(t));){if(s===h)if(i)if(c&&r.charAt(t+1)===h)t++,u[o++]=s;else if(c||u[o-1]!==b){if(!--l){++t;break}}else u[o-1]=s;else l++,i=!0;else u[o++]=s;++t}u=u.join(\"\");var g=R(r,t),m=g.token;if(m&&0===m.search(a))n&&g.cursor+1>=f?t=null:t++;else if(l&&!m){if(!n)throw new Error(\"Parse Error: expected: '\"+h+\"' got: '\"+m+\"'. at '\"+r.substr(t).replace(/[r\\n]/g,\"\\\\n'\"));t=null}else{if(!l&&m&&-1===m.search(p))throw new Error(\"Parse Error: expected: '\"+h+\"' got: '\"+m+\"'. at '\"+r.substr(t,10).replace(/[\\r\\n]/g,\"\\\\n'\"));!n||m&&d.test(m)||(t=null)}return null!==t&&e.push(v(u)),t}function k(r,e,t){var n=r.substr(e).search(d);return n=-1===n?t?null:r.length+1:e+n+1}function x(e,t,n,s){var l=e.substr(n),u=l.search(p);if(-1===u){if(!g.test(l))throw new Error(\"Parse Error: delimiter '\"+a+\"' not found at '\"+l.replace(/\\n/g,\"\\\\n'\"));u=l.length}var i=l.charAt(u);if(-1!==i.search(a))if(s&&n+(u+1)>=e.length)n=null;else{t.push(v(l.substr(0,u))),n+=u+1;var o=e.charAt(n);!r.strictColumnHandling&&(d.test(o)||n>=e.length)&&t.push(\"\"),r.strictColumnHandling||!w.test(o)||s||t.push(o)}else d.test(i)?(t.push(v(l.substr(0,u))),n+=u):s?n=null:(t.push(v(l.substr(0,u))),n+=u+1);return n}function R(r,e){var t,n,s,l=r.substr(e);return-1!==(s=l.search(m))&&(n=l.match(m)[1].length,t=r.substr(e+s,n),e+=s+n-1),{token:t,cursor:e}}return e(r,\"comment\")&&(u=r.comment,i=!0),function(r,e){for(var n,s,l,a=0,o=r.length,f=[],c=[],g=0;a<o;){if(n=(s=R(r,a)).token,t(n)){a=g,l=null;break}if(d.test(n)){if(!((a=s.cursor+1)<o)){\"\\r\"===n&&e&&(a=g,l=null);break}f.push(c),c=[],g=a}else if(i&&n===u){if(null===(l=k(r,a,e))){a=g;break}if(!(l<o)){a=l,l=null;break}g=a=l}else{if(null===(l=n===h?E(r,c,s.cursor,e):x(r,c,a,e))){a=g;break}a=l}}return null!==l&&f.push(c),{line:r.substr(a),rows:f}}}module.exports=u;\n},{\"./../extended\":\"3l4N\"}],\"sh/1\":[function(require,module,exports) {\nvar process = require(\"process\");\nvar e=require(\"process\"),t=require(\"../extended\"),r=t.isUndefined,i=t.spreadArgs,s=require(\"util\"),n=e.stdout,a=require(\"stream\"),o=/^\\s*(?:''|\"\")?\\s*(?:,\\s*(?:''|\"\")?\\s*)*$/,u=\",\",_=require(\"./parser\"),d=require(\"fs\"),h=require(\"string_decoder\").StringDecoder,l=!!a.Transform.prototype.isPaused;function c(e){var r;if((e=e||{}).objectMode=!t.has(e,\"objectMode\")||e.objectMode,a.Transform.call(this,e),this.lines=\"\",this.decoder=new h,this._parsedHeaders=!1,this._rowCount=-1,this._emitData=!1,t.has(e,\"delimiter\")){if((r=e.delimiter).length>1)throw new Error(\"delimiter option must be one character long\");r=t.escape(r)}else r=u;return e.delimiter=r,this.parser=_(e),this._headers=e.headers,this._renameHeaders=e.renameHeaders,this._ignoreEmpty=e.ignoreEmpty,this._discardUnmappedColumns=e.discardUnmappedColumns,this._strictColumnHandling=e.strictColumnHandling,this.__objectMode=e.objectMode,this.__buffered=[],this}s.inherits(c,a.Transform);var f=c.prototype.on,m=c.prototype.emit;t(c).extend({__pausedDone:null,__endEmitted:!1,__emittedData:!1,__handleLine:function(e,r,i,s){var n=this._ignoreEmpty,a=this;return t.isBoolean(n)&&n&&(!e||o.test(e.join(\"\")))?s(null,null):i?s(null,e):void this.__transform(e,function(e,t){e?s(e):a.__validate(t,function(e,i,n){e?s(e):i?s(null,t):(a.emit(\"data-invalid\",t,r,n),s(null,null))})})},__processRows:function(e,r,i){var s,n=this;t.asyncEach(e,function(e,t){e&&n.__handleLine(e,s=++n._rowCount,!1,function(e,r){e?t(e):(r?n.isStreamPaused()?n.__buffered.push([r,s]):n.__emitRecord(r,s):s=--n._rowCount,t())})},function(e){e?i(e):i(null,r.line)})},__processHeaders:function(e,i){var s=this._headers,n=this._renameHeaders,a=this._discardUnmappedColumns,o=this._strictColumnHandling,u=this;function _(e,s){if(e)i(e);else if(t.isArray(s)){var n=s.length,_=u.__transform;u.__transform=function(e,t){var i,d={},h=-1;if(e.length>n){if(!a)return o?(u.emit(\"data-invalid\",e),_(null,t)):(u.emit(\"error\",new Error(\"Unexpected Error: column header mismatch expected: \"+n+\" columns got: \"+e.length)),_(null,t));e.splice(n)}else if(o&&e.length<n)return u.emit(\"data-invalid\",e),_(null,t);for(;++h<n;)r(s[h])||(i=e[h],d[s[h]]=r(i)?\"\":i);return _(d,t)}}u._parsedHeaders=!0,i(null)}n?Array.isArray(s)?(e.shift(),_(null,s)):u.emit(\"error\",new Error(\"Error renaming headers: new headers must be provided in an array\")):t.isBoolean(s)&&s?this.__handleLine(e.shift(),0,!0,_):_(null,s)},_parse:function(e,t,r){var i,s=this;try{e=this.parser(e,t),(i=e.rows).length?this._parsedHeaders?this.__processRows(i,e,r):this.__processHeaders(i,function(t){t?r(t):s.__processRows(i,e,r)}):r(null,e.line)}catch(n){r(n)}},__emitRecord:function(e,t){this._emitData&&this.push(this.__objectMode?e:JSON.stringify(e))},__removeBOM:function(e){return e&&\"string\"==typeof e&&\"0xFEFF\"==e.charCodeAt(0)?e.slice(1):e},_transform:function(e,t,r){var i=this.lines+this.decoder.write(e),s=this;i.length>1?(i=this.__removeBOM(i),this._parse(i,!0,function(e,t){e?r(e):(s.lines=t,s.isStreamPaused()?s.__pausedDone=r:r())})):(this.lines=i,this.isStreamPaused()?this.__pausedDone=r:r())},__doFlush:function(e){try{e()}catch(t){e(t)}},_flush:function(e){var t=this;this.lines?this._parse(this.lines,!1,function(r){r?e(r):t.isStreamPaused()?t.__pausedDone=function(){t.__doFlush(e)}:t.__doFlush(e)}):this.isStreamPaused()?this.__pausedDone=function(){t.__doFlush(e)}:this.__doFlush(e)},__validate:function(e,t){return t(null,!0)},__transform:function(e,t){return t(null,e)},__flushPausedBuffer:function(){var e=this.__buffered;if(e.length){for(var t;e.length;)if(t=e.shift(),this.__emitRecord(t[0],t[1]),this.isStreamPaused())return;e.length=0}if(this.__pausedDone){var r=this.__pausedDone;this.__pausedDone=null,r()}},isStreamPaused:function(){return this.__paused},emit:function(e){\"end\"===e?this.__endEmitted||(this.__endEmitted=!0,i(m,[\"end\",++this._rowCount],this)):(l||(\"pause\"===e?this.__paused=!0:\"resume\"===e&&(this.__paused=!1,this.__flushPausedBuffer())),i(m,arguments,this))},on:function(e){return\"data\"!==e&&\"readable\"!==e||(this._emitData=!0),i(f,arguments,this),this},validate:function(e){return t.isFunction(e)||this.emit(\"error\",new TypeError(\"fast-csv.Parser#validate requires a function\")),2===e.length?this.__validate=e:this.__validate=function(t,r){return r(null,e(t))},this},transform:function(e){return t.isFunction(e)||this.emit(\"error\",new TypeError(\"fast-csv.Parser#transform requires a function\")),2===e.length?this.__transform=e:this.__transform=function(t,r){return r(null,e(t))},this}}),module.exports=c;\n},{\"../extended\":\"3l4N\",\"util\":\"gfUn\",\"stream\":\"fnRj\",\"./parser\":\"3qPl\",\"fs\":\"70rD\",\"string_decoder\":\"z0rv\",\"process\":\"pBGv\"}],\"dJit\":[function(require,module,exports) {\nvar process = require(\"process\");\nvar e=require(\"process\"),r=require(\"../extended\"),n=e.stdout,t=require(\"stream\"),u=require(\"fs\"),i=require(\"./parser_stream\");function a(e){return new i(e)}function o(e,r){return e.pipe(new i(r))}function p(e,r){return u.createReadStream(e).pipe(new i(r))}function s(e,r){var n=new t.Readable;return n.push(e),n.push(null),n.pipe(new i(r))}a.fromStream=o,a.fromPath=p,a.fromString=s,module.exports=a;\n},{\"../extended\":\"3l4N\",\"stream\":\"fnRj\",\"fs\":\"70rD\",\"./parser_stream\":\"sh/1\",\"process\":\"pBGv\"}],\"rE8J\":[function(require,module,exports) {\n\nvar process = require(\"process\");\nvar e,r=require(\"process\"),t=require(\"buffer\"),n=t.Buffer,o={};for(e in t)t.hasOwnProperty(e)&&\"SlowBuffer\"!==e&&\"Buffer\"!==e&&(o[e]=t[e]);var f=o.Buffer={};for(e in n)n.hasOwnProperty(e)&&\"allocUnsafe\"!==e&&\"allocUnsafeSlow\"!==e&&(f[e]=n[e]);if(o.Buffer.prototype=n.prototype,f.from&&f.from!==Uint8Array.from||(f.from=function(e,r,t){if(\"number\"==typeof e)throw new TypeError('The \"value\" argument must not be of type number. Received type '+typeof e);if(e&&void 0===e.length)throw new TypeError(\"The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type \"+typeof e);return n(e,r,t)}),f.alloc||(f.alloc=function(e,r,t){if(\"number\"!=typeof e)throw new TypeError('The \"size\" argument must be of type number. Received type '+typeof e);if(e<0||e>=2*(1<<30))throw new RangeError('The value \"'+e+'\" is invalid for option \"size\"');var o=n(e);return r&&0!==r.length?\"string\"==typeof t?o.fill(r,t):o.fill(r):o.fill(0),o}),!o.kStringMaxLength)try{o.kStringMaxLength=r.binding(\"buffer\").kStringMaxLength}catch(i){}o.constants||(o.constants={MAX_LENGTH:o.kMaxLength},o.kStringMaxLength&&(o.constants.MAX_STRING_LENGTH=o.kStringMaxLength)),module.exports=o;\n},{\"buffer\":\"peL6\",\"process\":\"pBGv\"}],\"ErnM\":[function(require,module,exports) {\n\nvar e=require(\"fs\"),r=require(\"../extended\"),t=require(\"safer-buffer\").Buffer,n=r.has,u=r.isBoolean,o=r.isUndefinedOrNull,a=r.escape,s=r.isArray,i=r.keys,f=require(\"stream\"),h=r.LINE_BREAK;function c(e,r,t){return u(r)?u(t)?function(e,n){return n?t:r}:s(t)?function(e,n){return n?t[e]:r}:function(n,u){return u?t[e.headers[n]]:r}:s(r)?u(t)?function(e,n){return n?t:r[e]}:function(e,n){return n?t[e]:r[e]}:u(t)?function(n,u){return u?t:r[e.headers[n]]}:function(n,u){return u?t[e.headers[n]]:r[e.headers[n]]}}function d(e,r){var t=(e=e||{}).delimiter||\",\",u=new RegExp(\"[\"+t+a(e.rowDelimiter||h)+\"']\"),s=e.quote||'\"',i=e.escape||'\"',f=new RegExp(s,\"g\"),d=!!n(e,\"quoteColumns\")&&e.quoteColumns,l=c(r,d,n(e,\"quoteHeaders\")?e.quoteHeaders:d);function p(e,r,t){var n;return(n=-1!==(e=e.replace(/\\0/g,\"\")).indexOf(s))?(e=e.replace(f,i+s),n=!0):n=-1!==e.search(u),(e=(n=n||l(r,t))?[s+e+s]:[e]).join(\"\")}return function(e,r){for(var n,u=-1,a=e.length,s=[];++u<a;)n=e[u],n=(o(n)?\"\":n)+\"\",s.push(p(n,u,r));return s.join(t)}}function l(e,r){return r(null,e)}function p(e){return s(e)&&s(e[0])&&2===e[0].length}function m(e){var r,t,n;if(p(e))for(t=-1,n=e.length,r=[];++t<n;)r[t]=e[t][0];else r=s(e)?e:i(e);return r}function g(e,r){var n,u=!0;return e.parsedHeaders||(e.parsedHeaders=!0,n=e.headers=m(r),e.headersLength=n.length),e.hasWrittenHeaders||(e.totalCount++,e.push(t.from(e.formatter(e.headers,!0),\"utf8\")),e.hasWrittenHeaders=!0,u=p(r)||!s(r)),u}function q(e,r){var t=[],n=[],u=e.headers,o=-1,a=e.headersLength;for(e.totalCount++&&n.push(e.rowDelimiter);++o<a;)t[o]=r[u[o]];return n.push(e.formatter(t)),n.join(\"\")}function v(e,r,t){var n=[];return e.totalCount++&&n.push(e.rowDelimiter),n.push(e.formatter(r)),n.join(\"\")}function x(e,r){var t=[],n=[],u=-1,o=e.headersLength;for(e.totalCount++&&n.push(e.rowDelimiter);++u<o;)t[u]=r[u][1];return n.push(e.formatter(t)),n.join(\"\")}function H(e,r){return s(r)?p(r)?x(e,r):v(e,r):q(e,r)}exports.createFormatter=d,exports.transformItem=H,exports.checkHeaders=g,exports.defaultTransform=l;\n},{\"fs\":\"70rD\",\"../extended\":\"3l4N\",\"safer-buffer\":\"rE8J\",\"stream\":\"fnRj\"}],\"vzH2\":[function(require,module,exports) {\n\nvar r=require(\"fs\"),e=require(\"util\"),t=require(\"../extended\"),s=require(\"safer-buffer\").Buffer,i=t.escape,n=t.isArray,a=t.has,o=require(\"stream\"),h=o.Transform,f=t.LINE_BREAK,m=require(\"./formatter\"),u=m.createFormatter,d=m.checkHeaders,l=m.transformItem,c=m.defaultTransform;function _(r){(r=r||{}).objectMode=!0,a(r,\"transform\")&&(r.consumerTransform=r.transform,delete r.transform),h.call(this,r),this.formatter=u(r,this),this.rowDelimiter=r.rowDelimiter||\"\\n\";var e=a(r,\"headers\")?!!r.headers:null,t=e&&n(r.headers)?r.headers:null;this.hasHeaders=e,this.headers=t,e&&(t?(this.parsedHeaders=!0,this.headersLength=t.length):this.parsedHeaders=!1),this.hasWrittenHeaders=!e,this.includeEndRowDelimiter=!!r.includeEndRowDelimiter,a(r,\"consumerTransform\")&&this.transform(r.consumerTransform)}e.inherits(_,h),t(_).extend({headers:null,headersLength:0,totalCount:0,_transform:function(r,e,t){var i=this;this.__transform(r,function(r,e){r?t(r):(d(i,e)&&i.push(s.from(l(i,e),\"utf8\")),t())})},__transform:c,transform:function(r){return t.isFunction(r)||this.emit(\"error\",new TypeError(\"fast-csv.FormatterStream#transform requires a function\")),2===r.length?this.__transform=r:this.__transform=function(e,t){t(null,r(e))},this},_flush:function(r){this.includeEndRowDelimiter&&this.push(this.rowDelimiter),r()}}),module.exports=_;\n},{\"fs\":\"70rD\",\"util\":\"gfUn\",\"../extended\":\"3l4N\",\"safer-buffer\":\"rE8J\",\"stream\":\"fnRj\",\"./formatter\":\"ErnM\"}],\"DvyJ\":[function(require,module,exports) {\nvar Buffer = require(\"buffer\").Buffer;\nvar e=require(\"buffer\").Buffer,r=require(\"fs\"),n=require(\"../extended\"),t=n.escape,i=require(\"stream\"),u=n.LINE_BREAK,o=require(\"./formatter_stream\");function f(e){return new o(e)}function c(e,r,t){var i=f(r);e.length;return n.asyncEach(e,function(e,r){i.write(e,null,r)},function(e){e?i.emit(\"error\",e):i.end()}),i}function a(e,r,n){return c(r,n).pipe(e)}function p(e,r,t){n.isFunction(r)&&(t=r,r={});var u=new i.Writable,o=[];u._write=function(e,r,n){o.push(e+\"\"),n()},u.on(\"error\",t).on(\"finish\",function(){t(null,o.join(\"\"))}),c(e,r).pipe(u)}function s(r,t,u){n.isFunction(t)&&(u=t,t={});var o=new i.Writable,f=[];o._write=function(e,r,n){f.push(e),0,n()},o.on(\"error\",u).on(\"finish\",function(){u(null,e.concat(f))}),c(r,t).pipe(o)}function w(e,n,t){var i=r.createWriteStream(e,{encoding:\"utf8\"});return c(n,t).pipe(i)}f.writeToBuffer=s,f.write=c,f.createWriteStream=f,f.writeToString=p,f.writeToPath=w,f.writeToStream=a,module.exports=f;\n},{\"fs\":\"70rD\",\"../extended\":\"3l4N\",\"stream\":\"fnRj\",\"./formatter_stream\":\"vzH2\",\"buffer\":\"peL6\"}],\"zVC0\":[function(require,module,exports) {\nvar r=require(\"fs\"),e=require(\"./parser\"),t=require(\"./formatter\");function a(){return e.apply(void 0,arguments)}a.parse=a,a.fromString=e.fromString,a.fromPath=e.fromPath,a.fromStream=e.fromStream,a.format=t,a.write=t.write,a.writeToStream=t.writeToStream,a.writeToString=t.writeToString,a.writeToBuffer=t.writeToBuffer,a.writeToPath=t.writeToPath,a.createWriteStream=t.createWriteStream,a.createReadStream=t.createWriteStream,module.exports=a;\n},{\"fs\":\"70rD\",\"./parser\":\"dJit\",\"./formatter\":\"DvyJ\"}],\"hw2v\":[function(require,module,exports) {\nmodule.exports=require(\"./lib\");\n},{\"./lib\":\"zVC0\"}],\"a2/B\":[function(require,module,exports) {\nvar define;\nvar global = arguments[3];\nvar e,t=arguments[3];!function(t,n){\"object\"==typeof exports&&\"undefined\"!=typeof module?module.exports=n():\"function\"==typeof e&&e.amd?e(n):t.moment=n()}(this,function(){\"use strict\";var e,t;function n(){return e.apply(null,arguments)}function s(e){return e instanceof Array||\"[object Array]\"===Object.prototype.toString.call(e)}function i(e){return null!=e&&\"[object Object]\"===Object.prototype.toString.call(e)}function r(e){return void 0===e}function a(e){return\"number\"==typeof e||\"[object Number]\"===Object.prototype.toString.call(e)}function o(e){return e instanceof Date||\"[object Date]\"===Object.prototype.toString.call(e)}function u(e,t){var n,s=[];for(n=0;n<e.length;++n)s.push(t(e[n],n));return s}function l(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function h(e,t){for(var n in t)l(t,n)&&(e[n]=t[n]);return l(t,\"toString\")&&(e.toString=t.toString),l(t,\"valueOf\")&&(e.valueOf=t.valueOf),e}function d(e,t,n,s){return bt(e,t,n,s,!0).utc()}function c(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function f(e){if(null==e._isValid){var n=c(e),s=t.call(n.parsedDateParts,function(e){return null!=e}),i=!isNaN(e._d.getTime())&&n.overflow<0&&!n.empty&&!n.invalidMonth&&!n.invalidWeekday&&!n.weekdayMismatch&&!n.nullInput&&!n.invalidFormat&&!n.userInvalidated&&(!n.meridiem||n.meridiem&&s);if(e._strict&&(i=i&&0===n.charsLeftOver&&0===n.unusedTokens.length&&void 0===n.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return i;e._isValid=i}return e._isValid}function m(e){var t=d(NaN);return null!=e?h(c(t),e):c(t).userInvalidated=!0,t}t=Array.prototype.some?Array.prototype.some:function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1};var _=n.momentProperties=[];function y(e,t){var n,s,i;if(r(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),r(t._i)||(e._i=t._i),r(t._f)||(e._f=t._f),r(t._l)||(e._l=t._l),r(t._strict)||(e._strict=t._strict),r(t._tzm)||(e._tzm=t._tzm),r(t._isUTC)||(e._isUTC=t._isUTC),r(t._offset)||(e._offset=t._offset),r(t._pf)||(e._pf=c(t)),r(t._locale)||(e._locale=t._locale),_.length>0)for(n=0;n<_.length;n++)r(i=t[s=_[n]])||(e[s]=i);return e}var g=!1;function v(e){y(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===g&&(g=!0,n.updateOffset(this),g=!1)}function p(e){return e instanceof v||null!=e&&null!=e._isAMomentObject}function w(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function M(e){var t=+e,n=0;return 0!==t&&isFinite(t)&&(n=w(t)),n}function k(e,t,n){var s,i=Math.min(e.length,t.length),r=Math.abs(e.length-t.length),a=0;for(s=0;s<i;s++)(n&&e[s]!==t[s]||!n&&M(e[s])!==M(t[s]))&&a++;return a+r}function S(e){!1===n.suppressDeprecationWarnings&&\"undefined\"!=typeof console&&console.warn&&console.warn(\"Deprecation warning: \"+e)}function D(e,t){var s=!0;return h(function(){if(null!=n.deprecationHandler&&n.deprecationHandler(null,e),s){for(var i,r=[],a=0;a<arguments.length;a++){if(i=\"\",\"object\"==typeof arguments[a]){for(var o in i+=\"\\n[\"+a+\"] \",arguments[0])i+=o+\": \"+arguments[0][o]+\", \";i=i.slice(0,-2)}else i=arguments[a];r.push(i)}S(e+\"\\nArguments: \"+Array.prototype.slice.call(r).join(\"\")+\"\\n\"+(new Error).stack),s=!1}return t.apply(this,arguments)},t)}var Y,O={};function T(e,t){null!=n.deprecationHandler&&n.deprecationHandler(e,t),O[e]||(S(t),O[e]=!0)}function b(e){return e instanceof Function||\"[object Function]\"===Object.prototype.toString.call(e)}function x(e,t){var n,s=h({},e);for(n in t)l(t,n)&&(i(e[n])&&i(t[n])?(s[n]={},h(s[n],e[n]),h(s[n],t[n])):null!=t[n]?s[n]=t[n]:delete s[n]);for(n in e)l(e,n)&&!l(t,n)&&i(e[n])&&(s[n]=h({},s[n]));return s}function P(e){null!=e&&this.set(e)}n.suppressDeprecationWarnings=!1,n.deprecationHandler=null,Y=Object.keys?Object.keys:function(e){var t,n=[];for(t in e)l(e,t)&&n.push(t);return n};var W={};function C(e,t){var n=e.toLowerCase();W[n]=W[n+\"s\"]=W[t]=e}function H(e){return\"string\"==typeof e?W[e]||W[e.toLowerCase()]:void 0}function R(e){var t,n,s={};for(n in e)l(e,n)&&(t=H(n))&&(s[t]=e[n]);return s}var U={};function F(e,t){U[e]=t}function L(e,t,n){var s=\"\"+Math.abs(e),i=t-s.length;return(e>=0?n?\"+\":\"\":\"-\")+Math.pow(10,Math.max(0,i)).toString().substr(1)+s}var N=/(\\[[^\\[]*\\])|(\\\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,G=/(\\[[^\\[]*\\])|(\\\\)?(LTS|LT|LL?L?L?|l{1,4})/g,V={},E={};function I(e,t,n,s){var i=s;\"string\"==typeof s&&(i=function(){return this[s]()}),e&&(E[e]=i),t&&(E[t[0]]=function(){return L(i.apply(this,arguments),t[1],t[2])}),n&&(E[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function A(e,t){return e.isValid()?(t=j(t,e.localeData()),V[t]=V[t]||function(e){var t,n,s,i=e.match(N);for(t=0,n=i.length;t<n;t++)E[i[t]]?i[t]=E[i[t]]:i[t]=(s=i[t]).match(/\\[[\\s\\S]/)?s.replace(/^\\[|\\]$/g,\"\"):s.replace(/\\\\/g,\"\");return function(t){var s,r=\"\";for(s=0;s<n;s++)r+=b(i[s])?i[s].call(t,e):i[s];return r}}(t),V[t](e)):e.localeData().invalidDate()}function j(e,t){var n=5;function s(e){return t.longDateFormat(e)||e}for(G.lastIndex=0;n>=0&&G.test(e);)e=e.replace(G,s),G.lastIndex=0,n-=1;return e}var Z=/\\d/,z=/\\d\\d/,$=/\\d{3}/,q=/\\d{4}/,J=/[+-]?\\d{6}/,B=/\\d\\d?/,Q=/\\d\\d\\d\\d?/,X=/\\d\\d\\d\\d\\d\\d?/,K=/\\d{1,3}/,ee=/\\d{1,4}/,te=/[+-]?\\d{1,6}/,ne=/\\d+/,se=/[+-]?\\d+/,ie=/Z|[+-]\\d\\d:?\\d\\d/gi,re=/Z|[+-]\\d\\d(?::?\\d\\d)?/gi,ae=/[0-9]{0,256}['a-z\\u00A0-\\u05FF\\u0700-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFF07\\uFF10-\\uFFEF]{1,256}|[\\u0600-\\u06FF\\/]{1,256}(\\s*?[\\u0600-\\u06FF]{1,256}){1,2}/i,oe={};function ue(e,t,n){oe[e]=b(t)?t:function(e,s){return e&&n?n:t}}function le(e,t){return l(oe,e)?oe[e](t._strict,t._locale):new RegExp(he(e.replace(\"\\\\\",\"\").replace(/\\\\(\\[)|\\\\(\\])|\\[([^\\]\\[]*)\\]|\\\\(.)/g,function(e,t,n,s,i){return t||n||s||i})))}function he(e){return e.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")}var de={};function ce(e,t){var n,s=t;for(\"string\"==typeof e&&(e=[e]),a(t)&&(s=function(e,n){n[t]=M(e)}),n=0;n<e.length;n++)de[e[n]]=s}function fe(e,t){ce(e,function(e,n,s,i){s._w=s._w||{},t(e,s._w,s,i)})}function me(e,t,n){null!=t&&l(de,e)&&de[e](t,n._a,n,e)}var _e=0,ye=1,ge=2,ve=3,pe=4,we=5,Me=6,ke=7,Se=8;function De(e){return Ye(e)?366:365}function Ye(e){return e%4==0&&e%100!=0||e%400==0}I(\"Y\",0,0,function(){var e=this.year();return e<=9999?\"\"+e:\"+\"+e}),I(0,[\"YY\",2],0,function(){return this.year()%100}),I(0,[\"YYYY\",4],0,\"year\"),I(0,[\"YYYYY\",5],0,\"year\"),I(0,[\"YYYYYY\",6,!0],0,\"year\"),C(\"year\",\"y\"),F(\"year\",1),ue(\"Y\",se),ue(\"YY\",B,z),ue(\"YYYY\",ee,q),ue(\"YYYYY\",te,J),ue(\"YYYYYY\",te,J),ce([\"YYYYY\",\"YYYYYY\"],_e),ce(\"YYYY\",function(e,t){t[_e]=2===e.length?n.parseTwoDigitYear(e):M(e)}),ce(\"YY\",function(e,t){t[_e]=n.parseTwoDigitYear(e)}),ce(\"Y\",function(e,t){t[_e]=parseInt(e,10)}),n.parseTwoDigitYear=function(e){return M(e)+(M(e)>68?1900:2e3)};var Oe,Te=be(\"FullYear\",!0);function be(e,t){return function(s){return null!=s?(Pe(this,e,s),n.updateOffset(this,t),this):xe(this,e)}}function xe(e,t){return e.isValid()?e._d[\"get\"+(e._isUTC?\"UTC\":\"\")+t]():NaN}function Pe(e,t,n){e.isValid()&&!isNaN(n)&&(\"FullYear\"===t&&Ye(e.year())&&1===e.month()&&29===e.date()?e._d[\"set\"+(e._isUTC?\"UTC\":\"\")+t](n,e.month(),We(n,e.month())):e._d[\"set\"+(e._isUTC?\"UTC\":\"\")+t](n))}function We(e,t){if(isNaN(e)||isNaN(t))return NaN;var n,s=(t%(n=12)+n)%n;return e+=(t-s)/12,1===s?Ye(e)?29:28:31-s%7%2}Oe=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1},I(\"M\",[\"MM\",2],\"Mo\",function(){return this.month()+1}),I(\"MMM\",0,0,function(e){return this.localeData().monthsShort(this,e)}),I(\"MMMM\",0,0,function(e){return this.localeData().months(this,e)}),C(\"month\",\"M\"),F(\"month\",8),ue(\"M\",B),ue(\"MM\",B,z),ue(\"MMM\",function(e,t){return t.monthsShortRegex(e)}),ue(\"MMMM\",function(e,t){return t.monthsRegex(e)}),ce([\"M\",\"MM\"],function(e,t){t[ye]=M(e)-1}),ce([\"MMM\",\"MMMM\"],function(e,t,n,s){var i=n._locale.monthsParse(e,s,n._strict);null!=i?t[ye]=i:c(n).invalidMonth=e});var Ce=/D[oD]?(\\[[^\\[\\]]*\\]|\\s)+MMMM?/,He=\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\");var Re=\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\");function Ue(e,t){var n;if(!e.isValid())return e;if(\"string\"==typeof t)if(/^\\d+$/.test(t))t=M(t);else if(!a(t=e.localeData().monthsParse(t)))return e;return n=Math.min(e.date(),We(e.year(),t)),e._d[\"set\"+(e._isUTC?\"UTC\":\"\")+\"Month\"](t,n),e}function Fe(e){return null!=e?(Ue(this,e),n.updateOffset(this,!0),this):xe(this,\"Month\")}var Le=ae;var Ne=ae;function Ge(){function e(e,t){return t.length-e.length}var t,n,s=[],i=[],r=[];for(t=0;t<12;t++)n=d([2e3,t]),s.push(this.monthsShort(n,\"\")),i.push(this.months(n,\"\")),r.push(this.months(n,\"\")),r.push(this.monthsShort(n,\"\"));for(s.sort(e),i.sort(e),r.sort(e),t=0;t<12;t++)s[t]=he(s[t]),i[t]=he(i[t]);for(t=0;t<24;t++)r[t]=he(r[t]);this._monthsRegex=new RegExp(\"^(\"+r.join(\"|\")+\")\",\"i\"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp(\"^(\"+i.join(\"|\")+\")\",\"i\"),this._monthsShortStrictRegex=new RegExp(\"^(\"+s.join(\"|\")+\")\",\"i\")}function Ve(e){var t;if(e<100&&e>=0){var n=Array.prototype.slice.call(arguments);n[0]=e+400,t=new Date(Date.UTC.apply(null,n)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)}else t=new Date(Date.UTC.apply(null,arguments));return t}function Ee(e,t,n){var s=7+t-n;return-((7+Ve(e,0,s).getUTCDay()-t)%7)+s-1}function Ie(e,t,n,s,i){var r,a,o=1+7*(t-1)+(7+n-s)%7+Ee(e,s,i);return o<=0?a=De(r=e-1)+o:o>De(e)?(r=e+1,a=o-De(e)):(r=e,a=o),{year:r,dayOfYear:a}}function Ae(e,t,n){var s,i,r=Ee(e.year(),t,n),a=Math.floor((e.dayOfYear()-r-1)/7)+1;return a<1?s=a+je(i=e.year()-1,t,n):a>je(e.year(),t,n)?(s=a-je(e.year(),t,n),i=e.year()+1):(i=e.year(),s=a),{week:s,year:i}}function je(e,t,n){var s=Ee(e,t,n),i=Ee(e+1,t,n);return(De(e)-s+i)/7}I(\"w\",[\"ww\",2],\"wo\",\"week\"),I(\"W\",[\"WW\",2],\"Wo\",\"isoWeek\"),C(\"week\",\"w\"),C(\"isoWeek\",\"W\"),F(\"week\",5),F(\"isoWeek\",5),ue(\"w\",B),ue(\"ww\",B,z),ue(\"W\",B),ue(\"WW\",B,z),fe([\"w\",\"ww\",\"W\",\"WW\"],function(e,t,n,s){t[s.substr(0,1)]=M(e)});function Ze(e,t){return e.slice(t,7).concat(e.slice(0,t))}I(\"d\",0,\"do\",\"day\"),I(\"dd\",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),I(\"ddd\",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),I(\"dddd\",0,0,function(e){return this.localeData().weekdays(this,e)}),I(\"e\",0,0,\"weekday\"),I(\"E\",0,0,\"isoWeekday\"),C(\"day\",\"d\"),C(\"weekday\",\"e\"),C(\"isoWeekday\",\"E\"),F(\"day\",11),F(\"weekday\",11),F(\"isoWeekday\",11),ue(\"d\",B),ue(\"e\",B),ue(\"E\",B),ue(\"dd\",function(e,t){return t.weekdaysMinRegex(e)}),ue(\"ddd\",function(e,t){return t.weekdaysShortRegex(e)}),ue(\"dddd\",function(e,t){return t.weekdaysRegex(e)}),fe([\"dd\",\"ddd\",\"dddd\"],function(e,t,n,s){var i=n._locale.weekdaysParse(e,s,n._strict);null!=i?t.d=i:c(n).invalidWeekday=e}),fe([\"d\",\"e\",\"E\"],function(e,t,n,s){t[s]=M(e)});var ze=\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\");var $e=\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\");var qe=\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\");var Je=ae;var Be=ae;var Qe=ae;function Xe(){function e(e,t){return t.length-e.length}var t,n,s,i,r,a=[],o=[],u=[],l=[];for(t=0;t<7;t++)n=d([2e3,1]).day(t),s=this.weekdaysMin(n,\"\"),i=this.weekdaysShort(n,\"\"),r=this.weekdays(n,\"\"),a.push(s),o.push(i),u.push(r),l.push(s),l.push(i),l.push(r);for(a.sort(e),o.sort(e),u.sort(e),l.sort(e),t=0;t<7;t++)o[t]=he(o[t]),u[t]=he(u[t]),l[t]=he(l[t]);this._weekdaysRegex=new RegExp(\"^(\"+l.join(\"|\")+\")\",\"i\"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp(\"^(\"+u.join(\"|\")+\")\",\"i\"),this._weekdaysShortStrictRegex=new RegExp(\"^(\"+o.join(\"|\")+\")\",\"i\"),this._weekdaysMinStrictRegex=new RegExp(\"^(\"+a.join(\"|\")+\")\",\"i\")}function Ke(){return this.hours()%12||12}function et(e,t){I(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function tt(e,t){return t._meridiemParse}I(\"H\",[\"HH\",2],0,\"hour\"),I(\"h\",[\"hh\",2],0,Ke),I(\"k\",[\"kk\",2],0,function(){return this.hours()||24}),I(\"hmm\",0,0,function(){return\"\"+Ke.apply(this)+L(this.minutes(),2)}),I(\"hmmss\",0,0,function(){return\"\"+Ke.apply(this)+L(this.minutes(),2)+L(this.seconds(),2)}),I(\"Hmm\",0,0,function(){return\"\"+this.hours()+L(this.minutes(),2)}),I(\"Hmmss\",0,0,function(){return\"\"+this.hours()+L(this.minutes(),2)+L(this.seconds(),2)}),et(\"a\",!0),et(\"A\",!1),C(\"hour\",\"h\"),F(\"hour\",13),ue(\"a\",tt),ue(\"A\",tt),ue(\"H\",B),ue(\"h\",B),ue(\"k\",B),ue(\"HH\",B,z),ue(\"hh\",B,z),ue(\"kk\",B,z),ue(\"hmm\",Q),ue(\"hmmss\",X),ue(\"Hmm\",Q),ue(\"Hmmss\",X),ce([\"H\",\"HH\"],ve),ce([\"k\",\"kk\"],function(e,t,n){var s=M(e);t[ve]=24===s?0:s}),ce([\"a\",\"A\"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),ce([\"h\",\"hh\"],function(e,t,n){t[ve]=M(e),c(n).bigHour=!0}),ce(\"hmm\",function(e,t,n){var s=e.length-2;t[ve]=M(e.substr(0,s)),t[pe]=M(e.substr(s)),c(n).bigHour=!0}),ce(\"hmmss\",function(e,t,n){var s=e.length-4,i=e.length-2;t[ve]=M(e.substr(0,s)),t[pe]=M(e.substr(s,2)),t[we]=M(e.substr(i)),c(n).bigHour=!0}),ce(\"Hmm\",function(e,t,n){var s=e.length-2;t[ve]=M(e.substr(0,s)),t[pe]=M(e.substr(s))}),ce(\"Hmmss\",function(e,t,n){var s=e.length-4,i=e.length-2;t[ve]=M(e.substr(0,s)),t[pe]=M(e.substr(s,2)),t[we]=M(e.substr(i))});var nt,st=be(\"Hours\",!0),it={calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},longDateFormat:{LTS:\"h:mm:ss A\",LT:\"h:mm A\",L:\"MM/DD/YYYY\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY h:mm A\",LLLL:\"dddd, MMMM D, YYYY h:mm A\"},invalidDate:\"Invalid date\",ordinal:\"%d\",dayOfMonthOrdinalParse:/\\d{1,2}/,relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",ss:\"%d seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},months:He,monthsShort:Re,week:{dow:0,doy:6},weekdays:ze,weekdaysMin:qe,weekdaysShort:$e,meridiemParse:/[ap]\\.?m?\\.?/i},rt={},at={};function ot(e){return e?e.toLowerCase().replace(\"_\",\"-\"):e}function ut(e){var t=null;if(!rt[e]&&\"undefined\"!=typeof module&&module&&module.exports)try{t=nt._abbr,require(\"./locale/\"+e),lt(t)}catch(n){}return rt[e]}function lt(e,t){var n;return e&&((n=r(t)?dt(e):ht(e,t))?nt=n:\"undefined\"!=typeof console&&console.warn&&console.warn(\"Locale \"+e+\" not found. Did you forget to load it?\")),nt._abbr}function ht(e,t){if(null!==t){var n,s=it;if(t.abbr=e,null!=rt[e])T(\"defineLocaleOverride\",\"use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.\"),s=rt[e]._config;else if(null!=t.parentLocale)if(null!=rt[t.parentLocale])s=rt[t.parentLocale]._config;else{if(null==(n=ut(t.parentLocale)))return at[t.parentLocale]||(at[t.parentLocale]=[]),at[t.parentLocale].push({name:e,config:t}),null;s=n._config}return rt[e]=new P(x(s,t)),at[e]&&at[e].forEach(function(e){ht(e.name,e.config)}),lt(e),rt[e]}return delete rt[e],null}function dt(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return nt;if(!s(e)){if(t=ut(e))return t;e=[e]}return function(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=ot(e[r]).split(\"-\")).length,n=(n=ot(e[r+1]))?n.split(\"-\"):null;t>0;){if(s=ut(i.slice(0,t).join(\"-\")))return s;if(n&&n.length>=t&&k(i,n,!0)>=t-1)break;t--}r++}return nt}(e)}function ct(e){var t,n=e._a;return n&&-2===c(e).overflow&&(t=n[ye]<0||n[ye]>11?ye:n[ge]<1||n[ge]>We(n[_e],n[ye])?ge:n[ve]<0||n[ve]>24||24===n[ve]&&(0!==n[pe]||0!==n[we]||0!==n[Me])?ve:n[pe]<0||n[pe]>59?pe:n[we]<0||n[we]>59?we:n[Me]<0||n[Me]>999?Me:-1,c(e)._overflowDayOfYear&&(t<_e||t>ge)&&(t=ge),c(e)._overflowWeeks&&-1===t&&(t=ke),c(e)._overflowWeekday&&-1===t&&(t=Se),c(e).overflow=t),e}function ft(e,t,n){return null!=e?e:null!=t?t:n}function mt(e){var t,s,i,r,a,o=[];if(!e._d){for(i=function(e){var t=new Date(n.now());return e._useUTC?[t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()]:[t.getFullYear(),t.getMonth(),t.getDate()]}(e),e._w&&null==e._a[ge]&&null==e._a[ye]&&function(e){var t,n,s,i,r,a,o,u;if(null!=(t=e._w).GG||null!=t.W||null!=t.E)r=1,a=4,n=ft(t.GG,e._a[_e],Ae(xt(),1,4).year),s=ft(t.W,1),((i=ft(t.E,1))<1||i>7)&&(u=!0);else{r=e._locale._week.dow,a=e._locale._week.doy;var l=Ae(xt(),r,a);n=ft(t.gg,e._a[_e],l.year),s=ft(t.w,l.week),null!=t.d?((i=t.d)<0||i>6)&&(u=!0):null!=t.e?(i=t.e+r,(t.e<0||t.e>6)&&(u=!0)):i=r}s<1||s>je(n,r,a)?c(e)._overflowWeeks=!0:null!=u?c(e)._overflowWeekday=!0:(o=Ie(n,s,i,r,a),e._a[_e]=o.year,e._dayOfYear=o.dayOfYear)}(e),null!=e._dayOfYear&&(a=ft(e._a[_e],i[_e]),(e._dayOfYear>De(a)||0===e._dayOfYear)&&(c(e)._overflowDayOfYear=!0),s=Ve(a,0,e._dayOfYear),e._a[ye]=s.getUTCMonth(),e._a[ge]=s.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=o[t]=i[t];for(;t<7;t++)e._a[t]=o[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[ve]&&0===e._a[pe]&&0===e._a[we]&&0===e._a[Me]&&(e._nextDay=!0,e._a[ve]=0),e._d=(e._useUTC?Ve:function(e,t,n,s,i,r,a){var o;return e<100&&e>=0?(o=new Date(e+400,t,n,s,i,r,a),isFinite(o.getFullYear())&&o.setFullYear(e)):o=new Date(e,t,n,s,i,r,a),o}).apply(null,o),r=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[ve]=24),e._w&&void 0!==e._w.d&&e._w.d!==r&&(c(e).weekdayMismatch=!0)}}var _t=/^\\s*((?:[+-]\\d{6}|\\d{4})-(?:\\d\\d-\\d\\d|W\\d\\d-\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?::\\d\\d(?::\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/,yt=/^\\s*((?:[+-]\\d{6}|\\d{4})(?:\\d\\d\\d\\d|W\\d\\d\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?:\\d\\d(?:\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/,gt=/Z|[+-]\\d\\d(?::?\\d\\d)?/,vt=[[\"YYYYYY-MM-DD\",/[+-]\\d{6}-\\d\\d-\\d\\d/],[\"YYYY-MM-DD\",/\\d{4}-\\d\\d-\\d\\d/],[\"GGGG-[W]WW-E\",/\\d{4}-W\\d\\d-\\d/],[\"GGGG-[W]WW\",/\\d{4}-W\\d\\d/,!1],[\"YYYY-DDD\",/\\d{4}-\\d{3}/],[\"YYYY-MM\",/\\d{4}-\\d\\d/,!1],[\"YYYYYYMMDD\",/[+-]\\d{10}/],[\"YYYYMMDD\",/\\d{8}/],[\"GGGG[W]WWE\",/\\d{4}W\\d{3}/],[\"GGGG[W]WW\",/\\d{4}W\\d{2}/,!1],[\"YYYYDDD\",/\\d{7}/]],pt=[[\"HH:mm:ss.SSSS\",/\\d\\d:\\d\\d:\\d\\d\\.\\d+/],[\"HH:mm:ss,SSSS\",/\\d\\d:\\d\\d:\\d\\d,\\d+/],[\"HH:mm:ss\",/\\d\\d:\\d\\d:\\d\\d/],[\"HH:mm\",/\\d\\d:\\d\\d/],[\"HHmmss.SSSS\",/\\d\\d\\d\\d\\d\\d\\.\\d+/],[\"HHmmss,SSSS\",/\\d\\d\\d\\d\\d\\d,\\d+/],[\"HHmmss\",/\\d\\d\\d\\d\\d\\d/],[\"HHmm\",/\\d\\d\\d\\d/],[\"HH\",/\\d\\d/]],wt=/^\\/?Date\\((\\-?\\d+)/i;function Mt(e){var t,n,s,i,r,a,o=e._i,u=_t.exec(o)||yt.exec(o);if(u){for(c(e).iso=!0,t=0,n=vt.length;t<n;t++)if(vt[t][1].exec(u[1])){i=vt[t][0],s=!1!==vt[t][2];break}if(null==i)return void(e._isValid=!1);if(u[3]){for(t=0,n=pt.length;t<n;t++)if(pt[t][1].exec(u[3])){r=(u[2]||\" \")+pt[t][0];break}if(null==r)return void(e._isValid=!1)}if(!s&&null!=r)return void(e._isValid=!1);if(u[4]){if(!gt.exec(u[4]))return void(e._isValid=!1);a=\"Z\"}e._f=i+(r||\"\")+(a||\"\"),Ot(e)}else e._isValid=!1}var kt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\\s)?(\\d{1,2})\\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\s(\\d{2,4})\\s(\\d\\d):(\\d\\d)(?::(\\d\\d))?\\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\\d{4}))$/;function St(e){var t=parseInt(e,10);return t<=49?2e3+t:t<=999?1900+t:t}var Dt={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Yt(e){var t,n,s,i,r,a,o,u=kt.exec(e._i.replace(/\\([^)]*\\)|[\\n\\t]/g,\" \").replace(/(\\s\\s+)/g,\" \").replace(/^\\s\\s*/,\"\").replace(/\\s\\s*$/,\"\"));if(u){var l=(t=u[4],n=u[3],s=u[2],i=u[5],r=u[6],a=u[7],o=[St(t),Re.indexOf(n),parseInt(s,10),parseInt(i,10),parseInt(r,10)],a&&o.push(parseInt(a,10)),o);if(!function(e,t,n){return!e||$e.indexOf(e)===new Date(t[0],t[1],t[2]).getDay()||(c(n).weekdayMismatch=!0,n._isValid=!1,!1)}(u[1],l,e))return;e._a=l,e._tzm=function(e,t,n){if(e)return Dt[e];if(t)return 0;var s=parseInt(n,10),i=s%100;return(s-i)/100*60+i}(u[8],u[9],u[10]),e._d=Ve.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),c(e).rfc2822=!0}else e._isValid=!1}function Ot(e){if(e._f!==n.ISO_8601)if(e._f!==n.RFC_2822){e._a=[],c(e).empty=!0;var t,s,i,r,a,o=\"\"+e._i,u=o.length,l=0;for(i=j(e._f,e._locale).match(N)||[],t=0;t<i.length;t++)r=i[t],(s=(o.match(le(r,e))||[])[0])&&((a=o.substr(0,o.indexOf(s))).length>0&&c(e).unusedInput.push(a),o=o.slice(o.indexOf(s)+s.length),l+=s.length),E[r]?(s?c(e).empty=!1:c(e).unusedTokens.push(r),me(r,s,e)):e._strict&&!s&&c(e).unusedTokens.push(r);c(e).charsLeftOver=u-l,o.length>0&&c(e).unusedInput.push(o),e._a[ve]<=12&&!0===c(e).bigHour&&e._a[ve]>0&&(c(e).bigHour=void 0),c(e).parsedDateParts=e._a.slice(0),c(e).meridiem=e._meridiem,e._a[ve]=function(e,t,n){var s;if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?((s=e.isPM(n))&&t<12&&(t+=12),s||12!==t||(t=0),t):t}(e._locale,e._a[ve],e._meridiem),mt(e),ct(e)}else Yt(e);else Mt(e)}function Tt(e){var t=e._i,l=e._f;return e._locale=e._locale||dt(e._l),null===t||void 0===l&&\"\"===t?m({nullInput:!0}):(\"string\"==typeof t&&(e._i=t=e._locale.preparse(t)),p(t)?new v(ct(t)):(o(t)?e._d=t:s(l)?function(e){var t,n,s,i,r;if(0===e._f.length)return c(e).invalidFormat=!0,void(e._d=new Date(NaN));for(i=0;i<e._f.length;i++)r=0,t=y({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[i],Ot(t),f(t)&&(r+=c(t).charsLeftOver,r+=10*c(t).unusedTokens.length,c(t).score=r,(null==s||r<s)&&(s=r,n=t));h(e,n||t)}(e):l?Ot(e):function(e){var t=e._i;r(t)?e._d=new Date(n.now()):o(t)?e._d=new Date(t.valueOf()):\"string\"==typeof t?function(e){var t=wt.exec(e._i);null===t?(Mt(e),!1===e._isValid&&(delete e._isValid,Yt(e),!1===e._isValid&&(delete e._isValid,n.createFromInputFallback(e)))):e._d=new Date(+t[1])}(e):s(t)?(e._a=u(t.slice(0),function(e){return parseInt(e,10)}),mt(e)):i(t)?function(e){if(!e._d){var t=R(e._i);e._a=u([t.year,t.month,t.day||t.date,t.hour,t.minute,t.second,t.millisecond],function(e){return e&&parseInt(e,10)}),mt(e)}}(e):a(t)?e._d=new Date(t):n.createFromInputFallback(e)}(e),f(e)||(e._d=null),e))}function bt(e,t,n,r,a){var o,u={};return!0!==n&&!1!==n||(r=n,n=void 0),(i(e)&&function(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;var t;for(t in e)if(e.hasOwnProperty(t))return!1;return!0}(e)||s(e)&&0===e.length)&&(e=void 0),u._isAMomentObject=!0,u._useUTC=u._isUTC=a,u._l=n,u._i=e,u._f=t,u._strict=r,(o=new v(ct(Tt(u))))._nextDay&&(o.add(1,\"d\"),o._nextDay=void 0),o}function xt(e,t,n,s){return bt(e,t,n,s,!1)}n.createFromInputFallback=D(\"value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.\",function(e){e._d=new Date(e._i+(e._useUTC?\" UTC\":\"\"))}),n.ISO_8601=function(){},n.RFC_2822=function(){};var Pt=D(\"moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/\",function(){var e=xt.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:m()}),Wt=D(\"moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/\",function(){var e=xt.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:m()});function Ct(e,t){var n,i;if(1===t.length&&s(t[0])&&(t=t[0]),!t.length)return xt();for(n=t[0],i=1;i<t.length;++i)t[i].isValid()&&!t[i][e](n)||(n=t[i]);return n}var Ht=[\"year\",\"quarter\",\"month\",\"week\",\"day\",\"hour\",\"minute\",\"second\",\"millisecond\"];function Rt(e){var t=R(e),n=t.year||0,s=t.quarter||0,i=t.month||0,r=t.week||t.isoWeek||0,a=t.day||0,o=t.hour||0,u=t.minute||0,l=t.second||0,h=t.millisecond||0;this._isValid=function(e){for(var t in e)if(-1===Oe.call(Ht,t)||null!=e[t]&&isNaN(e[t]))return!1;for(var n=!1,s=0;s<Ht.length;++s)if(e[Ht[s]]){if(n)return!1;parseFloat(e[Ht[s]])!==M(e[Ht[s]])&&(n=!0)}return!0}(t),this._milliseconds=+h+1e3*l+6e4*u+1e3*o*60*60,this._days=+a+7*r,this._months=+i+3*s+12*n,this._data={},this._locale=dt(),this._bubble()}function Ut(e){return e instanceof Rt}function Ft(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Lt(e,t){I(e,0,0,function(){var e=this.utcOffset(),n=\"+\";return e<0&&(e=-e,n=\"-\"),n+L(~~(e/60),2)+t+L(~~e%60,2)})}Lt(\"Z\",\":\"),Lt(\"ZZ\",\"\"),ue(\"Z\",re),ue(\"ZZ\",re),ce([\"Z\",\"ZZ\"],function(e,t,n){n._useUTC=!0,n._tzm=Gt(re,e)});var Nt=/([\\+\\-]|\\d\\d)/gi;function Gt(e,t){var n=(t||\"\").match(e);if(null===n)return null;var s=((n[n.length-1]||[])+\"\").match(Nt)||[\"-\",0,0],i=60*s[1]+M(s[2]);return 0===i?0:\"+\"===s[0]?i:-i}function Vt(e,t){var s,i;return t._isUTC?(s=t.clone(),i=(p(e)||o(e)?e.valueOf():xt(e).valueOf())-s.valueOf(),s._d.setTime(s._d.valueOf()+i),n.updateOffset(s,!1),s):xt(e).local()}function Et(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function It(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}n.updateOffset=function(){};var At=/^(\\-|\\+)?(?:(\\d*)[. ])?(\\d+)\\:(\\d+)(?:\\:(\\d+)(\\.\\d*)?)?$/,jt=/^(-|\\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function Zt(e,t){var n,s,i,r=e,o=null;return Ut(e)?r={ms:e._milliseconds,d:e._days,M:e._months}:a(e)?(r={},t?r[t]=e:r.milliseconds=e):(o=At.exec(e))?(n=\"-\"===o[1]?-1:1,r={y:0,d:M(o[ge])*n,h:M(o[ve])*n,m:M(o[pe])*n,s:M(o[we])*n,ms:M(Ft(1e3*o[Me]))*n}):(o=jt.exec(e))?(n=\"-\"===o[1]?-1:1,r={y:zt(o[2],n),M:zt(o[3],n),w:zt(o[4],n),d:zt(o[5],n),h:zt(o[6],n),m:zt(o[7],n),s:zt(o[8],n)}):null==r?r={}:\"object\"==typeof r&&(\"from\"in r||\"to\"in r)&&(i=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Vt(t,e),e.isBefore(t)?n=$t(e,t):((n=$t(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(xt(r.from),xt(r.to)),(r={}).ms=i.milliseconds,r.M=i.months),s=new Rt(r),Ut(e)&&l(e,\"_locale\")&&(s._locale=e._locale),s}function zt(e,t){var n=e&&parseFloat(e.replace(\",\",\".\"));return(isNaN(n)?0:n)*t}function $t(e,t){var n={};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,\"M\").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,\"M\"),n}function qt(e,t){return function(n,s){var i;return null===s||isNaN(+s)||(T(t,\"moment().\"+t+\"(period, number) is deprecated. Please use moment().\"+t+\"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.\"),i=n,n=s,s=i),Jt(this,Zt(n=\"string\"==typeof n?+n:n,s),e),this}}function Jt(e,t,s,i){var r=t._milliseconds,a=Ft(t._days),o=Ft(t._months);e.isValid()&&(i=null==i||i,o&&Ue(e,xe(e,\"Month\")+o*s),a&&Pe(e,\"Date\",xe(e,\"Date\")+a*s),r&&e._d.setTime(e._d.valueOf()+r*s),i&&n.updateOffset(e,a||o))}Zt.fn=Rt.prototype,Zt.invalid=function(){return Zt(NaN)};var Bt=qt(1,\"add\"),Qt=qt(-1,\"subtract\");function Xt(e,t){var n=12*(t.year()-e.year())+(t.month()-e.month()),s=e.clone().add(n,\"months\");return-(n+(t-s<0?(t-s)/(s-e.clone().add(n-1,\"months\")):(t-s)/(e.clone().add(n+1,\"months\")-s)))||0}function Kt(e){var t;return void 0===e?this._locale._abbr:(null!=(t=dt(e))&&(this._locale=t),this)}n.defaultFormat=\"YYYY-MM-DDTHH:mm:ssZ\",n.defaultFormatUtc=\"YYYY-MM-DDTHH:mm:ss[Z]\";var en=D(\"moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.\",function(e){return void 0===e?this.localeData():this.locale(e)});function tn(){return this._locale}var nn=1e3,sn=60*nn,rn=60*sn,an=3506328*rn;function on(e,t){return(e%t+t)%t}function un(e,t,n){return e<100&&e>=0?new Date(e+400,t,n)-an:new Date(e,t,n).valueOf()}function ln(e,t,n){return e<100&&e>=0?Date.UTC(e+400,t,n)-an:Date.UTC(e,t,n)}function hn(e,t){I(0,[e,e.length],0,t)}function dn(e,t,n,s,i){var r;return null==e?Ae(this,s,i).year:(t>(r=je(e,s,i))&&(t=r),function(e,t,n,s,i){var r=Ie(e,t,n,s,i),a=Ve(r.year,0,r.dayOfYear);return this.year(a.getUTCFullYear()),this.month(a.getUTCMonth()),this.date(a.getUTCDate()),this}.call(this,e,t,n,s,i))}I(0,[\"gg\",2],0,function(){return this.weekYear()%100}),I(0,[\"GG\",2],0,function(){return this.isoWeekYear()%100}),hn(\"gggg\",\"weekYear\"),hn(\"ggggg\",\"weekYear\"),hn(\"GGGG\",\"isoWeekYear\"),hn(\"GGGGG\",\"isoWeekYear\"),C(\"weekYear\",\"gg\"),C(\"isoWeekYear\",\"GG\"),F(\"weekYear\",1),F(\"isoWeekYear\",1),ue(\"G\",se),ue(\"g\",se),ue(\"GG\",B,z),ue(\"gg\",B,z),ue(\"GGGG\",ee,q),ue(\"gggg\",ee,q),ue(\"GGGGG\",te,J),ue(\"ggggg\",te,J),fe([\"gggg\",\"ggggg\",\"GGGG\",\"GGGGG\"],function(e,t,n,s){t[s.substr(0,2)]=M(e)}),fe([\"gg\",\"GG\"],function(e,t,s,i){t[i]=n.parseTwoDigitYear(e)}),I(\"Q\",0,\"Qo\",\"quarter\"),C(\"quarter\",\"Q\"),F(\"quarter\",7),ue(\"Q\",Z),ce(\"Q\",function(e,t){t[ye]=3*(M(e)-1)}),I(\"D\",[\"DD\",2],\"Do\",\"date\"),C(\"date\",\"D\"),F(\"date\",9),ue(\"D\",B),ue(\"DD\",B,z),ue(\"Do\",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),ce([\"D\",\"DD\"],ge),ce(\"Do\",function(e,t){t[ge]=M(e.match(B)[0])});var cn=be(\"Date\",!0);I(\"DDD\",[\"DDDD\",3],\"DDDo\",\"dayOfYear\"),C(\"dayOfYear\",\"DDD\"),F(\"dayOfYear\",4),ue(\"DDD\",K),ue(\"DDDD\",$),ce([\"DDD\",\"DDDD\"],function(e,t,n){n._dayOfYear=M(e)}),I(\"m\",[\"mm\",2],0,\"minute\"),C(\"minute\",\"m\"),F(\"minute\",14),ue(\"m\",B),ue(\"mm\",B,z),ce([\"m\",\"mm\"],pe);var fn=be(\"Minutes\",!1);I(\"s\",[\"ss\",2],0,\"second\"),C(\"second\",\"s\"),F(\"second\",15),ue(\"s\",B),ue(\"ss\",B,z),ce([\"s\",\"ss\"],we);var mn,_n=be(\"Seconds\",!1);for(I(\"S\",0,0,function(){return~~(this.millisecond()/100)}),I(0,[\"SS\",2],0,function(){return~~(this.millisecond()/10)}),I(0,[\"SSS\",3],0,\"millisecond\"),I(0,[\"SSSS\",4],0,function(){return 10*this.millisecond()}),I(0,[\"SSSSS\",5],0,function(){return 100*this.millisecond()}),I(0,[\"SSSSSS\",6],0,function(){return 1e3*this.millisecond()}),I(0,[\"SSSSSSS\",7],0,function(){return 1e4*this.millisecond()}),I(0,[\"SSSSSSSS\",8],0,function(){return 1e5*this.millisecond()}),I(0,[\"SSSSSSSSS\",9],0,function(){return 1e6*this.millisecond()}),C(\"millisecond\",\"ms\"),F(\"millisecond\",16),ue(\"S\",K,Z),ue(\"SS\",K,z),ue(\"SSS\",K,$),mn=\"SSSS\";mn.length<=9;mn+=\"S\")ue(mn,ne);function yn(e,t){t[Me]=M(1e3*(\"0.\"+e))}for(mn=\"S\";mn.length<=9;mn+=\"S\")ce(mn,yn);var gn=be(\"Milliseconds\",!1);I(\"z\",0,0,\"zoneAbbr\"),I(\"zz\",0,0,\"zoneName\");var vn=v.prototype;function pn(e){return e}vn.add=Bt,vn.calendar=function(e,t){var s=e||xt(),i=Vt(s,this).startOf(\"day\"),r=n.calendarFormat(this,i)||\"sameElse\",a=t&&(b(t[r])?t[r].call(this,s):t[r]);return this.format(a||this.localeData().calendar(r,this,xt(s)))},vn.clone=function(){return new v(this)},vn.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Vt(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=H(t)){case\"year\":r=Xt(this,s)/12;break;case\"month\":r=Xt(this,s);break;case\"quarter\":r=Xt(this,s)/3;break;case\"second\":r=(this-s)/1e3;break;case\"minute\":r=(this-s)/6e4;break;case\"hour\":r=(this-s)/36e5;break;case\"day\":r=(this-s-i)/864e5;break;case\"week\":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:w(r)},vn.endOf=function(e){var t;if(void 0===(e=H(e))||\"millisecond\"===e||!this.isValid())return this;var s=this._isUTC?ln:un;switch(e){case\"year\":t=s(this.year()+1,0,1)-1;break;case\"quarter\":t=s(this.year(),this.month()-this.month()%3+3,1)-1;break;case\"month\":t=s(this.year(),this.month()+1,1)-1;break;case\"week\":t=s(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case\"isoWeek\":t=s(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case\"day\":case\"date\":t=s(this.year(),this.month(),this.date()+1)-1;break;case\"hour\":t=this._d.valueOf(),t+=rn-on(t+(this._isUTC?0:this.utcOffset()*sn),rn)-1;break;case\"minute\":t=this._d.valueOf(),t+=sn-on(t,sn)-1;break;case\"second\":t=this._d.valueOf(),t+=nn-on(t,nn)-1}return this._d.setTime(t),n.updateOffset(this,!0),this},vn.format=function(e){e||(e=this.isUtc()?n.defaultFormatUtc:n.defaultFormat);var t=A(this,e);return this.localeData().postformat(t)},vn.from=function(e,t){return this.isValid()&&(p(e)&&e.isValid()||xt(e).isValid())?Zt({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},vn.fromNow=function(e){return this.from(xt(),e)},vn.to=function(e,t){return this.isValid()&&(p(e)&&e.isValid()||xt(e).isValid())?Zt({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},vn.toNow=function(e){return this.to(xt(),e)},vn.get=function(e){return b(this[e=H(e)])?this[e]():this},vn.invalidAt=function(){return c(this).overflow},vn.isAfter=function(e,t){var n=p(e)?e:xt(e);return!(!this.isValid()||!n.isValid())&&(\"millisecond\"===(t=H(t)||\"millisecond\")?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(t).valueOf())},vn.isBefore=function(e,t){var n=p(e)?e:xt(e);return!(!this.isValid()||!n.isValid())&&(\"millisecond\"===(t=H(t)||\"millisecond\")?this.valueOf()<n.valueOf():this.clone().endOf(t).valueOf()<n.valueOf())},vn.isBetween=function(e,t,n,s){var i=p(e)?e:xt(e),r=p(t)?t:xt(t);return!!(this.isValid()&&i.isValid()&&r.isValid())&&(\"(\"===(s=s||\"()\")[0]?this.isAfter(i,n):!this.isBefore(i,n))&&(\")\"===s[1]?this.isBefore(r,n):!this.isAfter(r,n))},vn.isSame=function(e,t){var n,s=p(e)?e:xt(e);return!(!this.isValid()||!s.isValid())&&(\"millisecond\"===(t=H(t)||\"millisecond\")?this.valueOf()===s.valueOf():(n=s.valueOf(),this.clone().startOf(t).valueOf()<=n&&n<=this.clone().endOf(t).valueOf()))},vn.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},vn.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},vn.isValid=function(){return f(this)},vn.lang=en,vn.locale=Kt,vn.localeData=tn,vn.max=Wt,vn.min=Pt,vn.parsingFlags=function(){return h({},c(this))},vn.set=function(e,t){if(\"object\"==typeof e)for(var n=function(e){var t=[];for(var n in e)t.push({unit:n,priority:U[n]});return t.sort(function(e,t){return e.priority-t.priority}),t}(e=R(e)),s=0;s<n.length;s++)this[n[s].unit](e[n[s].unit]);else if(b(this[e=H(e)]))return this[e](t);return this},vn.startOf=function(e){var t;if(void 0===(e=H(e))||\"millisecond\"===e||!this.isValid())return this;var s=this._isUTC?ln:un;switch(e){case\"year\":t=s(this.year(),0,1);break;case\"quarter\":t=s(this.year(),this.month()-this.month()%3,1);break;case\"month\":t=s(this.year(),this.month(),1);break;case\"week\":t=s(this.year(),this.month(),this.date()-this.weekday());break;case\"isoWeek\":t=s(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case\"day\":case\"date\":t=s(this.year(),this.month(),this.date());break;case\"hour\":t=this._d.valueOf(),t-=on(t+(this._isUTC?0:this.utcOffset()*sn),rn);break;case\"minute\":t=this._d.valueOf(),t-=on(t,sn);break;case\"second\":t=this._d.valueOf(),t-=on(t,nn)}return this._d.setTime(t),n.updateOffset(this,!0),this},vn.subtract=Qt,vn.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},vn.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},vn.toDate=function(){return new Date(this.valueOf())},vn.toISOString=function(e){if(!this.isValid())return null;var t=!0!==e,n=t?this.clone().utc():this;return n.year()<0||n.year()>9999?A(n,t?\"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]\":\"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ\"):b(Date.prototype.toISOString)?t?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace(\"Z\",A(n,\"Z\")):A(n,t?\"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]\":\"YYYY-MM-DD[T]HH:mm:ss.SSSZ\")},vn.inspect=function(){if(!this.isValid())return\"moment.invalid(/* \"+this._i+\" */)\";var e=\"moment\",t=\"\";this.isLocal()||(e=0===this.utcOffset()?\"moment.utc\":\"moment.parseZone\",t=\"Z\");var n=\"[\"+e+'(\"]',s=0<=this.year()&&this.year()<=9999?\"YYYY\":\"YYYYYY\",i=t+'[\")]';return this.format(n+s+\"-MM-DD[T]HH:mm:ss.SSS\"+i)},vn.toJSON=function(){return this.isValid()?this.toISOString():null},vn.toString=function(){return this.clone().locale(\"en\").format(\"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ\")},vn.unix=function(){return Math.floor(this.valueOf()/1e3)},vn.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},vn.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},vn.year=Te,vn.isLeapYear=function(){return Ye(this.year())},vn.weekYear=function(e){return dn.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)},vn.isoWeekYear=function(e){return dn.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},vn.quarter=vn.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},vn.month=Fe,vn.daysInMonth=function(){return We(this.year(),this.month())},vn.week=vn.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),\"d\")},vn.isoWeek=vn.isoWeeks=function(e){var t=Ae(this,1,4).week;return null==e?t:this.add(7*(e-t),\"d\")},vn.weeksInYear=function(){var e=this.localeData()._week;return je(this.year(),e.dow,e.doy)},vn.isoWeeksInYear=function(){return je(this.year(),1,4)},vn.date=cn,vn.day=vn.days=function(e){if(!this.isValid())return null!=e?this:NaN;var t=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(e=function(e,t){return\"string\"!=typeof e?e:isNaN(e)?\"number\"==typeof(e=t.weekdaysParse(e))?e:null:parseInt(e,10)}(e,this.localeData()),this.add(e-t,\"d\")):t},vn.weekday=function(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,\"d\")},vn.isoWeekday=function(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var t=function(e,t){return\"string\"==typeof e?t.weekdaysParse(e)%7||7:isNaN(e)?null:e}(e,this.localeData());return this.day(this.day()%7?t:t-7)}return this.day()||7},vn.dayOfYear=function(e){var t=Math.round((this.clone().startOf(\"day\")-this.clone().startOf(\"year\"))/864e5)+1;return null==e?t:this.add(e-t,\"d\")},vn.hour=vn.hours=st,vn.minute=vn.minutes=fn,vn.second=vn.seconds=_n,vn.millisecond=vn.milliseconds=gn,vn.utcOffset=function(e,t,s){var i,r=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null!=e){if(\"string\"==typeof e){if(null===(e=Gt(re,e)))return this}else Math.abs(e)<16&&!s&&(e*=60);return!this._isUTC&&t&&(i=Et(this)),this._offset=e,this._isUTC=!0,null!=i&&this.add(i,\"m\"),r!==e&&(!t||this._changeInProgress?Jt(this,Zt(e-r,\"m\"),1,!1):this._changeInProgress||(this._changeInProgress=!0,n.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?r:Et(this)},vn.utc=function(e){return this.utcOffset(0,e)},vn.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(Et(this),\"m\")),this},vn.parseZone=function(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if(\"string\"==typeof this._i){var e=Gt(ie,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this},vn.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?xt(e).utcOffset():0,(this.utcOffset()-e)%60==0)},vn.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},vn.isLocal=function(){return!!this.isValid()&&!this._isUTC},vn.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},vn.isUtc=It,vn.isUTC=It,vn.zoneAbbr=function(){return this._isUTC?\"UTC\":\"\"},vn.zoneName=function(){return this._isUTC?\"Coordinated Universal Time\":\"\"},vn.dates=D(\"dates accessor is deprecated. Use date instead.\",cn),vn.months=D(\"months accessor is deprecated. Use month instead\",Fe),vn.years=D(\"years accessor is deprecated. Use year instead\",Te),vn.zone=D(\"moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/\",function(e,t){return null!=e?(\"string\"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()}),vn.isDSTShifted=D(\"isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information\",function(){if(!r(this._isDSTShifted))return this._isDSTShifted;var e={};if(y(e,this),(e=Tt(e))._a){var t=e._isUTC?d(e._a):xt(e._a);this._isDSTShifted=this.isValid()&&k(e._a,t.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted});var wn=P.prototype;function Mn(e,t,n,s){var i=dt(),r=d().set(s,t);return i[n](r,e)}function kn(e,t,n){if(a(e)&&(t=e,e=void 0),e=e||\"\",null!=t)return Mn(e,t,n,\"month\");var s,i=[];for(s=0;s<12;s++)i[s]=Mn(e,s,n,\"month\");return i}function Sn(e,t,n,s){\"boolean\"==typeof e?(a(t)&&(n=t,t=void 0),t=t||\"\"):(n=t=e,e=!1,a(t)&&(n=t,t=void 0),t=t||\"\");var i,r=dt(),o=e?r._week.dow:0;if(null!=n)return Mn(t,(n+o)%7,s,\"day\");var u=[];for(i=0;i<7;i++)u[i]=Mn(t,(i+o)%7,s,\"day\");return u}wn.calendar=function(e,t,n){var s=this._calendar[e]||this._calendar.sameElse;return b(s)?s.call(t,n):s},wn.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])},wn.invalidDate=function(){return this._invalidDate},wn.ordinal=function(e){return this._ordinal.replace(\"%d\",e)},wn.preparse=pn,wn.postformat=pn,wn.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return b(i)?i(e,t,n,s):i.replace(/%d/i,e)},wn.pastFuture=function(e,t){var n=this._relativeTime[e>0?\"future\":\"past\"];return b(n)?n(t):n.replace(/%s/i,t)},wn.set=function(e){var t,n;for(n in e)b(t=e[n])?this[n]=t:this[\"_\"+n]=t;this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+\"|\"+/\\d{1,2}/.source)},wn.months=function(e,t){return e?s(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||Ce).test(t)?\"format\":\"standalone\"][e.month()]:s(this._months)?this._months:this._months.standalone},wn.monthsShort=function(e,t){return e?s(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[Ce.test(t)?\"format\":\"standalone\"][e.month()]:s(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},wn.monthsParse=function(e,t,n){var s,i,r;if(this._monthsParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=d([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,\"\").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,\"\").toLocaleLowerCase();return n?\"MMM\"===t?-1!==(i=Oe.call(this._shortMonthsParse,a))?i:null:-1!==(i=Oe.call(this._longMonthsParse,a))?i:null:\"MMM\"===t?-1!==(i=Oe.call(this._shortMonthsParse,a))?i:-1!==(i=Oe.call(this._longMonthsParse,a))?i:null:-1!==(i=Oe.call(this._longMonthsParse,a))?i:-1!==(i=Oe.call(this._shortMonthsParse,a))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=d([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp(\"^\"+this.months(i,\"\").replace(\".\",\"\")+\"$\",\"i\"),this._shortMonthsParse[s]=new RegExp(\"^\"+this.monthsShort(i,\"\").replace(\".\",\"\")+\"$\",\"i\")),n||this._monthsParse[s]||(r=\"^\"+this.months(i,\"\")+\"|^\"+this.monthsShort(i,\"\"),this._monthsParse[s]=new RegExp(r.replace(\".\",\"\"),\"i\")),n&&\"MMMM\"===t&&this._longMonthsParse[s].test(e))return s;if(n&&\"MMM\"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},wn.monthsRegex=function(e){return this._monthsParseExact?(l(this,\"_monthsRegex\")||Ge.call(this),e?this._monthsStrictRegex:this._monthsRegex):(l(this,\"_monthsRegex\")||(this._monthsRegex=Ne),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},wn.monthsShortRegex=function(e){return this._monthsParseExact?(l(this,\"_monthsRegex\")||Ge.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(l(this,\"_monthsShortRegex\")||(this._monthsShortRegex=Le),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},wn.week=function(e){return Ae(e,this._week.dow,this._week.doy).week},wn.firstDayOfYear=function(){return this._week.doy},wn.firstDayOfWeek=function(){return this._week.dow},wn.weekdays=function(e,t){var n=s(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?\"format\":\"standalone\"];return!0===e?Ze(n,this._week.dow):e?n[e.day()]:n},wn.weekdaysMin=function(e){return!0===e?Ze(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},wn.weekdaysShort=function(e){return!0===e?Ze(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},wn.weekdaysParse=function(e,t,n){var s,i,r;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=d([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,\"\").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,\"\").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,\"\").toLocaleLowerCase();return n?\"dddd\"===t?-1!==(i=Oe.call(this._weekdaysParse,a))?i:null:\"ddd\"===t?-1!==(i=Oe.call(this._shortWeekdaysParse,a))?i:null:-1!==(i=Oe.call(this._minWeekdaysParse,a))?i:null:\"dddd\"===t?-1!==(i=Oe.call(this._weekdaysParse,a))?i:-1!==(i=Oe.call(this._shortWeekdaysParse,a))?i:-1!==(i=Oe.call(this._minWeekdaysParse,a))?i:null:\"ddd\"===t?-1!==(i=Oe.call(this._shortWeekdaysParse,a))?i:-1!==(i=Oe.call(this._weekdaysParse,a))?i:-1!==(i=Oe.call(this._minWeekdaysParse,a))?i:null:-1!==(i=Oe.call(this._minWeekdaysParse,a))?i:-1!==(i=Oe.call(this._weekdaysParse,a))?i:-1!==(i=Oe.call(this._shortWeekdaysParse,a))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=d([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp(\"^\"+this.weekdays(i,\"\").replace(\".\",\"\\\\.?\")+\"$\",\"i\"),this._shortWeekdaysParse[s]=new RegExp(\"^\"+this.weekdaysShort(i,\"\").replace(\".\",\"\\\\.?\")+\"$\",\"i\"),this._minWeekdaysParse[s]=new RegExp(\"^\"+this.weekdaysMin(i,\"\").replace(\".\",\"\\\\.?\")+\"$\",\"i\")),this._weekdaysParse[s]||(r=\"^\"+this.weekdays(i,\"\")+\"|^\"+this.weekdaysShort(i,\"\")+\"|^\"+this.weekdaysMin(i,\"\"),this._weekdaysParse[s]=new RegExp(r.replace(\".\",\"\"),\"i\")),n&&\"dddd\"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&\"ddd\"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&\"dd\"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},wn.weekdaysRegex=function(e){return this._weekdaysParseExact?(l(this,\"_weekdaysRegex\")||Xe.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(l(this,\"_weekdaysRegex\")||(this._weekdaysRegex=Je),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},wn.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(l(this,\"_weekdaysRegex\")||Xe.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(l(this,\"_weekdaysShortRegex\")||(this._weekdaysShortRegex=Be),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},wn.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(l(this,\"_weekdaysRegex\")||Xe.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(l(this,\"_weekdaysMinRegex\")||(this._weekdaysMinRegex=Qe),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},wn.isPM=function(e){return\"p\"===(e+\"\").toLowerCase().charAt(0)},wn.meridiem=function(e,t,n){return e>11?n?\"pm\":\"PM\":n?\"am\":\"AM\"},lt(\"en\",{dayOfMonthOrdinalParse:/\\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===M(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\")}}),n.lang=D(\"moment.lang is deprecated. Use moment.locale instead.\",lt),n.langData=D(\"moment.langData is deprecated. Use moment.localeData instead.\",dt);var Dn=Math.abs;function Yn(e,t,n,s){var i=Zt(t,n);return e._milliseconds+=s*i._milliseconds,e._days+=s*i._days,e._months+=s*i._months,e._bubble()}function On(e){return e<0?Math.floor(e):Math.ceil(e)}function Tn(e){return 4800*e/146097}function bn(e){return 146097*e/4800}function xn(e){return function(){return this.as(e)}}var Pn=xn(\"ms\"),Wn=xn(\"s\"),Cn=xn(\"m\"),Hn=xn(\"h\"),Rn=xn(\"d\"),Un=xn(\"w\"),Fn=xn(\"M\"),Ln=xn(\"Q\"),Nn=xn(\"y\");function Gn(e){return function(){return this.isValid()?this._data[e]:NaN}}var Vn=Gn(\"milliseconds\"),En=Gn(\"seconds\"),In=Gn(\"minutes\"),An=Gn(\"hours\"),jn=Gn(\"days\"),Zn=Gn(\"months\"),zn=Gn(\"years\");var $n=Math.round,qn={ss:44,s:45,m:45,h:22,d:26,M:11};var Jn=Math.abs;function Bn(e){return(e>0)-(e<0)||+e}function Qn(){if(!this.isValid())return this.localeData().invalidDate();var e,t,n=Jn(this._milliseconds)/1e3,s=Jn(this._days),i=Jn(this._months);e=w(n/60),t=w(e/60),n%=60,e%=60;var r=w(i/12),a=i%=12,o=s,u=t,l=e,h=n?n.toFixed(3).replace(/\\.?0+$/,\"\"):\"\",d=this.asSeconds();if(!d)return\"P0D\";var c=d<0?\"-\":\"\",f=Bn(this._months)!==Bn(d)?\"-\":\"\",m=Bn(this._days)!==Bn(d)?\"-\":\"\",_=Bn(this._milliseconds)!==Bn(d)?\"-\":\"\";return c+\"P\"+(r?f+r+\"Y\":\"\")+(a?f+a+\"M\":\"\")+(o?m+o+\"D\":\"\")+(u||l||h?\"T\":\"\")+(u?_+u+\"H\":\"\")+(l?_+l+\"M\":\"\")+(h?_+h+\"S\":\"\")}var Xn=Rt.prototype;return Xn.isValid=function(){return this._isValid},Xn.abs=function(){var e=this._data;return this._milliseconds=Dn(this._milliseconds),this._days=Dn(this._days),this._months=Dn(this._months),e.milliseconds=Dn(e.milliseconds),e.seconds=Dn(e.seconds),e.minutes=Dn(e.minutes),e.hours=Dn(e.hours),e.months=Dn(e.months),e.years=Dn(e.years),this},Xn.add=function(e,t){return Yn(this,e,t,1)},Xn.subtract=function(e,t){return Yn(this,e,t,-1)},Xn.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if(\"month\"===(e=H(e))||\"quarter\"===e||\"year\"===e)switch(t=this._days+s/864e5,n=this._months+Tn(t),e){case\"month\":return n;case\"quarter\":return n/3;case\"year\":return n/12}else switch(t=this._days+Math.round(bn(this._months)),e){case\"week\":return t/7+s/6048e5;case\"day\":return t+s/864e5;case\"hour\":return 24*t+s/36e5;case\"minute\":return 1440*t+s/6e4;case\"second\":return 86400*t+s/1e3;case\"millisecond\":return Math.floor(864e5*t)+s;default:throw new Error(\"Unknown unit \"+e)}},Xn.asMilliseconds=Pn,Xn.asSeconds=Wn,Xn.asMinutes=Cn,Xn.asHours=Hn,Xn.asDays=Rn,Xn.asWeeks=Un,Xn.asMonths=Fn,Xn.asQuarters=Ln,Xn.asYears=Nn,Xn.valueOf=function(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*M(this._months/12):NaN},Xn._bubble=function(){var e,t,n,s,i,r=this._milliseconds,a=this._days,o=this._months,u=this._data;return r>=0&&a>=0&&o>=0||r<=0&&a<=0&&o<=0||(r+=864e5*On(bn(o)+a),a=0,o=0),u.milliseconds=r%1e3,e=w(r/1e3),u.seconds=e%60,t=w(e/60),u.minutes=t%60,n=w(t/60),u.hours=n%24,a+=w(n/24),o+=i=w(Tn(a)),a-=On(bn(i)),s=w(o/12),o%=12,u.days=a,u.months=o,u.years=s,this},Xn.clone=function(){return Zt(this)},Xn.get=function(e){return e=H(e),this.isValid()?this[e+\"s\"]():NaN},Xn.milliseconds=Vn,Xn.seconds=En,Xn.minutes=In,Xn.hours=An,Xn.days=jn,Xn.weeks=function(){return w(this.days()/7)},Xn.months=Zn,Xn.years=zn,Xn.humanize=function(e){if(!this.isValid())return this.localeData().invalidDate();var t=this.localeData(),n=function(e,t,n){var s=Zt(e).abs(),i=$n(s.as(\"s\")),r=$n(s.as(\"m\")),a=$n(s.as(\"h\")),o=$n(s.as(\"d\")),u=$n(s.as(\"M\")),l=$n(s.as(\"y\")),h=i<=qn.ss&&[\"s\",i]||i<qn.s&&[\"ss\",i]||r<=1&&[\"m\"]||r<qn.m&&[\"mm\",r]||a<=1&&[\"h\"]||a<qn.h&&[\"hh\",a]||o<=1&&[\"d\"]||o<qn.d&&[\"dd\",o]||u<=1&&[\"M\"]||u<qn.M&&[\"MM\",u]||l<=1&&[\"y\"]||[\"yy\",l];return h[2]=t,h[3]=+e>0,h[4]=n,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,h)}(this,!e,t);return e&&(n=t.pastFuture(+this,n)),t.postformat(n)},Xn.toISOString=Qn,Xn.toString=Qn,Xn.toJSON=Qn,Xn.locale=Kt,Xn.localeData=tn,Xn.toIsoString=D(\"toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)\",Qn),Xn.lang=en,I(\"X\",0,0,\"unix\"),I(\"x\",0,0,\"valueOf\"),ue(\"x\",se),ue(\"X\",/[+-]?\\d+(\\.\\d{1,3})?/),ce(\"X\",function(e,t,n){n._d=new Date(1e3*parseFloat(e,10))}),ce(\"x\",function(e,t,n){n._d=new Date(M(e))}),n.version=\"2.24.0\",e=xt,n.fn=vn,n.min=function(){return Ct(\"isBefore\",[].slice.call(arguments,0))},n.max=function(){return Ct(\"isAfter\",[].slice.call(arguments,0))},n.now=function(){return Date.now?Date.now():+new Date},n.utc=d,n.unix=function(e){return xt(1e3*e)},n.months=function(e,t){return kn(e,t,\"months\")},n.isDate=o,n.locale=lt,n.invalid=m,n.duration=Zt,n.isMoment=p,n.weekdays=function(e,t,n){return Sn(e,t,n,\"weekdays\")},n.parseZone=function(){return xt.apply(null,arguments).parseZone()},n.localeData=dt,n.isDuration=Ut,n.monthsShort=function(e,t){return kn(e,t,\"monthsShort\")},n.weekdaysMin=function(e,t,n){return Sn(e,t,n,\"weekdaysMin\")},n.defineLocale=ht,n.updateLocale=function(e,t){if(null!=t){var n,s,i=it;null!=(s=ut(e))&&(i=s._config),(n=new P(t=x(i,t))).parentLocale=rt[e],rt[e]=n,lt(e)}else null!=rt[e]&&(null!=rt[e].parentLocale?rt[e]=rt[e].parentLocale:null!=rt[e]&&delete rt[e]);return rt[e]},n.locales=function(){return Y(rt)},n.weekdaysShort=function(e,t,n){return Sn(e,t,n,\"weekdaysShort\")},n.normalizeUnits=H,n.relativeTimeRounding=function(e){return void 0===e?$n:\"function\"==typeof e&&($n=e,!0)},n.relativeTimeThreshold=function(e,t){return void 0!==qn[e]&&(void 0===t?qn[e]:(qn[e]=t,\"s\"===e&&(qn.ss=t-1),!0))},n.calendarFormat=function(e,t){var n=e.diff(t,\"days\",!0);return n<-6?\"sameElse\":n<-1?\"lastWeek\":n<0?\"lastDay\":n<1?\"sameDay\":n<2?\"nextDay\":n<7?\"nextWeek\":\"sameElse\"},n.prototype=vn,n.HTML5_FMT={DATETIME_LOCAL:\"YYYY-MM-DDTHH:mm\",DATETIME_LOCAL_SECONDS:\"YYYY-MM-DDTHH:mm:ss\",DATETIME_LOCAL_MS:\"YYYY-MM-DDTHH:mm:ss.SSS\",DATE:\"YYYY-MM-DD\",TIME:\"HH:mm\",TIME_SECONDS:\"HH:mm:ss\",TIME_MS:\"HH:mm:ss.SSS\",WEEK:\"GGGG-[W]WW\",MONTH:\"YYYY-MM\"},n});\n},{}],\"VhnK\":[function(require,module,exports) {\n\"use strict\";function r(e){return(r=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(r){return typeof r}:function(r){return r&&\"function\"==typeof Symbol&&r.constructor===Symbol&&r!==Symbol.prototype?\"symbol\":typeof r})(e)}var e=\"function\"==typeof Symbol&&\"symbol\"===r(Symbol.iterator)?function(e){return r(e)}:function(e){return e&&\"function\"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?\"symbol\":r(e)},t=require(\"fs\"),o=require(\"fast-csv\"),n=require(\"moment\"),i=require(\"../utils/promish\"),u=require(\"../utils/stream-buf\"),f=require(\"../utils/utils\"),a=module.exports=function(r){this.workbook=r,this.worksheet=null},s={true:!0,false:!1,\"#N/A\":{error:\"#N/A\"},\"#REF!\":{error:\"#REF!\"},\"#NAME?\":{error:\"#NAME?\"},\"#DIV/0!\":{error:\"#DIV/0!\"},\"#NULL!\":{error:\"#NULL!\"},\"#VALUE!\":{error:\"#VALUE!\"},\"#NUM!\":{error:\"#NUM!\"}};a.prototype={readFile:function(r,e){var o,n=this;return e=e||{},f.fs.exists(r).then(function(i){if(!i)throw new Error(\"File not found: \"+r);return o=t.createReadStream(r),n.read(o,e)}).then(function(r){return o.close(),r})},read:function(r,e){var t=this;return e=e||{},new i.Promish(function(o,n){var i=t.createInputStream(e).on(\"worksheet\",o).on(\"error\",n);r.pipe(i)})},createInputStream:function(r){r=r||{};var e=this.workbook.addWorksheet(r.sheetName),t=r.dateFormats||[n.ISO_8601,\"MM-DD-YYYY\",\"YYYY-MM-DD\"],i=r.map||function(r){if(\"\"===r)return null;if(!isNaN(r))return parseFloat(r);var e=n(r,t,!0);if(e.isValid())return new Date(e.valueOf());var o=s[r];return void 0!==o?o:r},u=o(r).on(\"data\",function(r){e.addRow(r.map(i))}).on(\"end\",function(){u.emit(\"worksheet\",e)});return u},write:function(r,t){var u=this;return new i.Promish(function(i,f){t=t||{};var a=u.workbook.getWorksheet(t.sheetName||t.sheetId),s=o.createWriteStream(t);r.on(\"finish\",function(){i()}),s.on(\"error\",f),s.pipe(r);var c=t.dateFormat,m=t.dateUTC,l=t.map||function(r){if(r){if(r.text||r.hyperlink)return r.hyperlink||r.text||\"\";if(r.formula||r.result)return r.result||\"\";if(r instanceof Date)return c&&(m?n.utc(r).format(c):n(r).format(c)),m?n.utc(r).format():n(r).format();if(r.error)return r.error;if(\"object\"===(void 0===r?\"undefined\":e(r)))return JSON.stringify(r)}return r},p=void 0===t.includeEmptyRows||t.includeEmptyRows,y=1;a&&a.eachRow(function(r,e){if(p)for(;y++<e-1;)s.write([]);var t=r.values;t.shift(),s.write(t.map(l)),y=e}),s.end()})},writeFile:function(r,e){var o={encoding:(e=e||{}).encoding||\"utf8\"},n=t.createWriteStream(r,o);return this.write(n,e)},writeBuffer:function(r){var e=new u;return this.write(e,r).then(function(){return e.read()})}};\n},{\"fs\":\"70rD\",\"fast-csv\":\"hw2v\",\"moment\":\"a2/B\",\"../utils/promish\":\"vJr6\",\"../utils/stream-buf\":\"SWOl\",\"../utils/utils\":\"gei3\"}],\"2xcp\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./worksheet\"),t=require(\"./defined-names\"),s=require(\"./../xlsx/xlsx\"),i=require(\"./../csv/csv\"),r=module.exports=function(){this.created=new Date,this.modified=this.created,this.properties={},this._worksheets=[],this.views=[],this.media=[],this._definedNames=new t};r.prototype={get xlsx(){return this._xlsx||(this._xlsx=new s(this)),this._xlsx},get csv(){return this._csv||(this._csv=new i(this)),this._csv},get nextId(){var e;for(e=1;e<this._worksheets.length;e++)if(!this._worksheets[e])return e;return this._worksheets.length||1},addWorksheet:function(t,s){var i=this.nextId;t=t||\"sheet\"+i,s&&(\"string\"==typeof s?(console.trace('tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { argb: \"rbg value\" } }'),s={properties:{tabColor:{argb:s}}}):(s.argb||s.theme||s.indexed)&&(console.trace(\"tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { ... } }\"),s={properties:{tabColor:s}}));var r=this._worksheets.reduce(function(e,t){return(t&&t.orderNo)>e?t.orderNo:e},0),o=Object.assign({},s,{id:i,name:t,orderNo:r+1,workbook:this}),n=new e(o);return this._worksheets[i]=n,n},removeWorksheetEx:function(e){delete this._worksheets[e.id]},removeWorksheet:function(e){var t=this.getWorksheet(e);t&&t.destroy()},getWorksheet:function(e){return void 0===e?this._worksheets.find(function(e){return e}):\"number\"==typeof e?this._worksheets[e]:\"string\"==typeof e?this._worksheets.find(function(t){return t&&t.name===e}):void 0},get worksheets(){return this._worksheets.slice(1).sort(function(e,t){return e.orderNo-t.orderNo}).filter(Boolean)},eachSheet:function(e){this.worksheets.forEach(function(t){e(t,t.id)})},get definedNames(){return this._definedNames},clearThemes:function(){this._themes=void 0},addImage:function(e){var t=this.media.length;return this.media.push(Object.assign({},e,{type:\"image\"})),t},getImage:function(e){return this.media[e]},get model(){return{creator:this.creator||\"Unknown\",lastModifiedBy:this.lastModifiedBy||\"Unknown\",lastPrinted:this.lastPrinted,created:this.created,modified:this.modified,properties:this.properties,worksheets:this.worksheets.map(function(e){return e.model}),sheets:this.worksheets.map(function(e){return e.model}).filter(Boolean),definedNames:this._definedNames.model,views:this.views,company:this.company,manager:this.manager,title:this.title,subject:this.subject,keywords:this.keywords,category:this.category,description:this.description,language:this.language,revision:this.revision,contentStatus:this.contentStatus,themes:this._themes,media:this.media}},set model(t){var s=this;this.creator=t.creator,this.lastModifiedBy=t.lastModifiedBy,this.lastPrinted=t.lastPrinted,this.created=t.created,this.modified=t.modified,this.company=t.company,this.manager=t.manager,this.title=t.title,this.subject=t.subject,this.keywords=t.keywords,this.category=t.category,this.description=t.description,this.language=t.language,this.revision=t.revision,this.contentStatus=t.contentStatus,this.properties=t.properties,this._worksheets=[],t.worksheets.forEach(function(i){var r=i.id,o=i.name,n=t.sheets.findIndex(function(e){return e.id===r}),h=i.state;(s._worksheets[r]=new e({id:r,name:o,orderNo:n,state:h,workbook:s})).model=i}),this._definedNames.model=t.definedNames,this.views=t.views,this._themes=t.themes,this.media=t.media||[]}};\n},{\"./worksheet\":\"BLgy\",\"./defined-names\":\"vAec\",\"./../xlsx/xlsx\":\"RcxM\",\"./../csv/csv\":\"VhnK\"}],\"oHIO\":[function(require,module,exports) {\n\"use strict\";var e=require(\"./config/set-value\");e(\"promise\",require(\"promish/dist/promish-node\"),!1);var r={Workbook:require(\"./doc/workbook\")},o=require(\"./doc/enums\");Object.keys(o).forEach(function(e){r[e]=o[e]}),module.exports=r;\n},{\"./config/set-value\":\"ssQO\",\"promish/dist/promish-node\":\"i/x1\",\"./doc/workbook\":\"2xcp\",\"./doc/enums\":\"YmZx\"}],\"pN0Q\":[function(require,module,exports) {\n\"use strict\";Object.defineProperty(exports,\"__esModule\",{value:!0}),exports.default=void 0;var e=n(require(\"./parser\")),t=n(require(\"file-saver\")),r=n(require(\"../node_modules/exceljs/dist/es5/exceljs.browser\"));function n(e){return e&&e.__esModule?e:{default:e}}function o(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{},n=Object.keys(r);\"function\"==typeof Object.getOwnPropertySymbols&&(n=n.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),n.forEach(function(t){i(e,t,r[t])})}return e}function i(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}var u=function(e){var n={initWorkBook:function(){return new r.default.Workbook},initSheet:function(e,t){return e.addWorksheet(t)},save:function(e,r){e.xlsx.writeBuffer().then(function(e){(0,t.default)(new Blob([e],{type:\"application/octet-stream\"}),r)})},tableToSheet:function(t,r,n){var o=this.initSheet(t,n.sheet.name);return o=e.parseDomToTable(o,r,n),t},tableToBook:function(e,t){var r=this.initWorkBook();return r=this.tableToSheet(r,e,t)},convert:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};t=o({},{name:\"export.xlsx\",autoStyle:!1,sheet:{name:\"Sheet 1\"}},t);var r=this.tableToBook(e,t);this.save(r,t.name)}};return n}(e.default),a=u;exports.default=a,window.TableToExcel=u;\n},{\"./parser\":\"CUYV\",\"file-saver\":\"KAEt\",\"../node_modules/exceljs/dist/es5/exceljs.browser\":\"oHIO\"}]},{},[\"pN0Q\"], null)\n//# sourceMappingURL=/tableToExcel.js.map"

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./app-rosario.less": 1538,
		"./app-ucentralcolombia.less": 1551,
		"./app-uplanner.less": 1554
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1537;


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1539);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./app-rosario.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./app-rosario.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(364)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700);", ""]);
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Exo:400,400i,500,500i,600,600i,700,700i&subset=latin-ext);", ""]);
	
	// module
	exports.push([module.id, ".bg-primary{background:#002f4b!important;color:#fff!important}.bg-primary-light{background:#005f98!important;color:#fff!important}.bg-primary-dark{background:#000!important;color:#fff!important}.bg-accent{background:#ffaf00!important;color:#000!important}.bg-accent-light{background:#ffc74d!important;color:#000!important}.bg-accent-dark{background:#b37a00!important;color:#fff!important}.bg-info{background:#002f4b!important;color:#fff;color:#fff!important}.bg-info-light{background:#005f98!important;color:#fff!important}.bg-info-dark{background:#000!important;color:#fff!important}.bg-success{background:#a8c329!important;color:#000!important}.bg-success-light{background:#c6dd5c!important;color:#000!important}.bg-success-dark{background:#72841c!important;color:#fff!important}.bg-warning{background:#facb55!important;color:#000!important}.bg-warning-light{background:#fce29f!important;color:#000!important}.bg-warning-dark{background:#f8b40b!important;color:#000!important}.bg-danger{background:#d7634a!important;color:#fff!important}.bg-danger-light{background:#e59989!important;color:#fff!important}.bg-danger-dark{background:#ae3e26!important;color:#fff!important}.bg-light{background:#f7f7f7!important;color:#000!important}.bg-light-light{background:#fff!important;color:#000!important}.bg-light-dark{background:#d1d1d1!important;color:#000!important}.bg-dark{background:#6f6f6e!important;color:#fff!important}.bg-dark-light{background:#959594!important;color:#fff!important}.bg-dark-dark{background:#494948!important;color:#fff!important}.bg-present{background:#4caf50!important;color:#fff!important}.bg-absent{background:#6f6f6e!important;color:#fff!important}.bg-tardy{background:#ffeb3b!important;color:#000!important}.bg-justified{background:#468ac2!important;color:#fff!important}.bg-not-registered{background:#e0e0e0!important;color:#000!important;border:1px solid hsla(0,0%,88%,.1)}.bg-man{background:#afb42b!important}.bg-man,.bg-ret{color:#fff!important}.bg-ret{background:#d7634a!important}.bg-sanc{background:#fab813!important;color:#000!important}.bg-del{background:#3f51b5!important;color:#fff!important}.text-primary{color:#002f4b!important}.text-primary-lt{color:#005f98!important}.text-primary-dk{color:#000!important}.text-accent{color:#ffaf00!important}.text-accent-lt{color:#ffc74d!important}.text-accent-dk{color:#b37a00!important}.text-info{color:#002f4b!important}.text-info-lt{color:#005f98!important}.text-info-dk{color:#000!important}.text-success{color:#a8c329!important}.text-success-lt{color:#c6dd5c!important}.text-success-dk{color:#72841c!important}.text-warning{color:#facb55!important}.text-warning-lt{color:#fce29f!important}.text-warning-dk{color:#f8b40b!important}.text-danger{color:#d7634a!important}.text-danger-lt{color:#e59989!important}.text-danger-dk{color:#ae3e26!important}.text-dark{color:#6f6f6e!important}.text-dark-lt{color:#959594!important}.text-dark-dk{color:#494948!important}.text-light{color:#f7f7f7!important}.text-light-lt{color:#fff!important}.text-light-dk{color:#d1d1d1!important}[ui-view].ng-leave{display:none}[ui-view].ng-leave.smooth{display:block}.smooth.ng-animate{position:absolute;width:100%;height:100%;overflow:hidden}.fade-in-right-big.ng-enter{animation:fadeInRightBig .5s}.fade-in-right-big.ng-leave{animation:fadeOutLeftBig .5s}.fade-in-left-big.ng-enter{animation:fadeInLeftBig .5s}.fade-in-left-big.ng-leave{animation:fadeOutRightBig .5s}.fade-in-up-big.ng-enter{animation:fadeInUpBig .5s}.fade-in-up-big.ng-leave{animation:fadeOutUpBig .5s}.fade-in-down-big.ng-enter{animation:fadeInDownBig .5s}.fade-in-down-big.ng-leave{animation:fadeOutDownBig .5s}.fade-in.ng-enter{animation:fadeIn .5s}.fade-in.ng-leave{animation:fadeOut .5s}.fade-in-right.ng-enter{animation:fadeInRight .5s}.fade-in-right.ng-leave{animation:fadeOutLeft .5s}.fade-in-left.ng-enter{animation:fadeInLeft .5s}.fade-in-left.ng-leave{animation:fadeOutRight .5s}.fade-in-up.ng-enter{animation:fadeInUp .5s}.fade-in-up.ng-leave{animation:fadeOutUp .5s}.fade-in-down.ng-enter{animation:fadeInDown .5s}.fade-in-down.ng-leave{animation:fadeOutDown .5s}html{background-color:#002f4b}body{font-family:Open Sans,sans-serif;font-size:14px;color:#494948;background-color:#f9f9f9;-webkit-font-smoothing:antialiased;line-height:1.42857143}:focus{outline:0!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Exo,sans-serif}.title{font-size:24px!important;color:#353942!important;margin-bottom:10px}.title p{margin:0;font-size:17px;color:#758295;font-weight:300}.title h1,.title h2,.title h3,.title h4,.title h5,.title h6{margin-top:0;font-size:24px!important}.titleSecond{background-color:#f2f5f7}.h1,.h2,.h3,.h4,.h5,.h6{margin:0}a{cursor:pointer;outline:0}a,a:focus,a:hover{color:#ffaf00;text-decoration:none}.well,pre{background-color:#f7f7f7;border-color:#eaeaea}.small,small{font-size:13px}blockquote{border-color:#eaeaea}label{font-weight:400}sup{position:relative;top:-.5em;font-size:75%}.thumbnail{border-color:#eaeaea}@media (min-width:768px) and (max-width:991px){.pull-none-sm{float:none!important}.pull-right-sm{float:right!important}.pull-left-sm{float:left!important}.hidden-sm.show{display:inherit!important}}@media (max-width:767px){.pull-none-xs{float:none!important}.pull-right-xs{float:right!important}.pull-left-xs{float:left!important}.hidden-xs.show{display:inherit!important}}.text-color{color:#494948!important}.text-color-w{color:#fff!important}.badge,.label{font-weight:700;background-color:#b7b7b7}.badge.bg-light,.badge.bg-white,.label.bg-light,.label.bg-white{text-shadow:none;color:#494948}.label{padding:.35em .6em}.badge{padding:3px 6px}.badge.up{position:relative;top:-10px;margin:0 -.5em}.badge-lg{border-radius:20px;font-size:16px;padding:5px 9px}.badge-sm{padding:2px 5px}.badge-xs{padding:1px 4px}.label-lg{font-size:16px;padding:5px 9px}.label-sm{padding:2px 5px}.label-xs{padding:1px 4px}.badge-white{border:1px solid hsla(0,0%,100%,.35);padding:2px 6px}.badge-black,.badge-white{background-color:transparent}.badge-black{border:1px solid rgba(0,0,0,.15);color:inherit}.btn-default{background-color:#fff!important;border-color:#fff;color:#000!important}.btn-default.active,.btn-default.btn-stroke.active,.btn-default.btn-stroke:active,.btn-default.btn-stroke:focus,.btn-default.btn-stroke:hover,.btn-default:active,.btn-default:focus,.btn-default:hover,.open .dropdown-toggle.btn-default{color:#000;background-color:#f2f2f2!important;border-color:#d6d6d6!important}.btn-default.btn-addon>i{border:1px solid #dbdbdb;background-color:#f0f0f0}.btn-default.btn-stroke{color:#fff!important;background-color:transparent}.btn-primary{background-color:#002f4b!important;border-color:#002f4b;color:#fff!important}.btn-primary.active,.btn-primary.btn-stroke.active,.btn-primary.btn-stroke:active,.btn-primary.btn-stroke:focus,.btn-primary.btn-stroke:hover,.btn-primary:active,.btn-primary:focus,.btn-primary:hover,.open .dropdown-toggle.btn-primary{color:#fff;background-color:#001f32!important;border-color:#001522!important}.btn-primary.btn-addon>i{border:1px solid #001c2c;background-color:#001c2c}.btn-primary.btn-stroke{color:#002f4b!important;background-color:transparent}.btn-success{background-color:#a8c329!important;border-color:#a8c329;color:#000!important}.btn-success.active,.btn-success.btn-stroke.active,.btn-success.btn-stroke:active,.btn-success.btn-stroke:focus,.btn-success.btn-stroke:hover,.btn-success:active,.btn-success:focus,.btn-success:hover,.open .dropdown-toggle.btn-success{color:#000;background-color:#96ae25!important;border-color:#8ba122!important}.btn-success.btn-addon>i{border:1px solid #92aa24;background-color:#92aa24}.btn-success.btn-stroke{color:#a8c329!important;background-color:transparent}.btn-info{background-color:#002f4b!important;border-color:#002f4b;color:#fff!important}.btn-info.active,.btn-info.btn-stroke.active,.btn-info.btn-stroke:active,.btn-info.btn-stroke:focus,.btn-info.btn-stroke:hover,.btn-info:active,.btn-info:focus,.btn-info:hover,.open .dropdown-toggle.btn-info{color:#fff;background-color:#001f32!important;border-color:#001522!important}.btn-info.btn-addon>i{border:1px solid #001c2c;background-color:#001c2c}.btn-info.btn-stroke{color:#002f4b!important;background-color:transparent}.btn-warning{background-color:#facb55!important;border-color:#facb55;color:#000!important}.btn-warning.active,.btn-warning.btn-stroke.active,.btn-warning.btn-stroke:active,.btn-warning.btn-stroke:focus,.btn-warning.btn-stroke:hover,.btn-warning:active,.btn-warning:focus,.btn-warning:hover,.open .dropdown-toggle.btn-warning{color:#000;background-color:#f9c33c!important;border-color:#f9bf2d!important}.btn-warning.btn-addon>i{border:1px solid #f9c237;background-color:#f9c237}.btn-warning.btn-stroke{color:#facb55!important;background-color:transparent}.btn-danger{background-color:#d7634a!important;border-color:#d7634a;color:#fff!important}.btn-danger.active,.btn-danger.btn-stroke.active,.btn-danger.btn-stroke:active,.btn-danger.btn-stroke:focus,.btn-danger.btn-stroke:hover,.btn-danger:active,.btn-danger:focus,.btn-danger:hover,.open .dropdown-toggle.btn-danger{color:#fff;background-color:#d25135!important;border-color:#cb492d!important}.btn-danger.btn-addon>i{border:1px solid #d14d31;background-color:#d14d31}.btn-danger.btn-stroke{color:#d7634a!important;background-color:transparent}.btn-accent{background-color:#ffaf00!important;border-color:#ffaf00;color:#000!important}.btn-accent.active,.btn-accent.btn-stroke.active,.btn-accent.btn-stroke:active,.btn-accent.btn-stroke:focus,.btn-accent.btn-stroke:hover,.btn-accent:active,.btn-accent:focus,.btn-accent:hover,.open .dropdown-toggle.btn-accent{color:#000;background-color:#e69d00!important;border-color:#d69300!important}.btn-accent.btn-addon>i{border:1px solid #e09a00;background-color:#e09a00}.btn-accent.btn-stroke{color:#ffaf00!important;background-color:transparent}.btn-dark{background-color:#6f6f6e!important;border-color:#6f6f6e;color:#fff!important}.btn-dark.active,.btn-dark.btn-stroke.active,.btn-dark.btn-stroke:active,.btn-dark.btn-stroke:focus,.btn-dark.btn-stroke:hover,.btn-dark:active,.btn-dark:focus,.btn-dark:hover,.open .dropdown-toggle.btn-dark{color:#fff;background-color:#626261!important;border-color:#5b5b5a!important}.btn-dark.btn-addon>i{border:1px solid #60605f;background-color:#60605f}.btn-dark.btn-stroke{color:#6f6f6e!important;background-color:transparent}.btn-light{background-color:#f7f7f7!important;border-color:#f7f7f7;color:#000!important}.btn-light.active,.btn-light.btn-stroke.active,.btn-light.btn-stroke:active,.btn-light.btn-stroke:focus,.btn-light.btn-stroke:hover,.btn-light:active,.btn-light:focus,.btn-light:hover,.open .dropdown-toggle.btn-light{color:#000;background-color:#eaeaea!important;border-color:#e3e3e3!important}.btn-light.btn-addon>i{border:1px solid #e8e8e8;background-color:#e8e8e8}.btn-light.btn-stroke{color:#f7f7f7!important;background-color:transparent}.btn-horizontal-align{margin-top:38px}.btn{font-weight:500;border-radius:3px;outline:0!important;box-shadow:0 1px 1px rgba(90,90,90,.1);font-family:Exo,sans-serif;font-weight:400}.btn>i.pull-left,.btn>i.pull-right{line-height:1.42857143}.btn-link{color:#494948}.btn-link.active{webkit-box-shadow:none;box-shadow:none}.btn-block{padding-left:12px;padding-right:12px}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:3px}.btn-group-vertical>.btn:last-child:not(:first-child){border-bottom-left-radius:3px}.btn-rounded{border-radius:50px;padding-left:15px;padding-right:15px}.btn-rounded.btn-lg{padding-left:25px;padding-right:25px}.btn-addon i{margin:-7px -12px;margin-right:12px;width:34px;height:34px;line-height:34px;text-align:center;float:left;position:relative;left:-1px;border-radius:3px 0 0 3px}.btn-addon i.pull-right{left:auto;right:-1px;margin-right:-12px;margin-left:12px;border-radius:0 3px 3px 0}.btn-addon.btn-sm i{margin:-6px -10px;margin-right:10px;width:30px;height:30px;line-height:30px}.btn-addon.btn-sm i.pull-right{margin-right:-10px;margin-left:10px}.btn-addon.btn-lg i{margin:-11px -16px;margin-right:16px;width:46px;height:46px;line-height:45px}.btn-addon.btn-lg i.pull-right{margin-right:-16px;margin-left:16px}.btn-clip{border-color:rgba(0,0,0,.1)!important;background-clip:padding-box}.btn-icon{padding-left:0!important;padding-right:0!important;width:34px;height:34px;padding:0;text-align:center;line-height:34px}.btn-icon.btn-sm{width:30px;height:30px;line-height:30px}.btn-icon.btn-lg{width:45px;height:45px;line-height:45px}.btn-groups .btn{margin-bottom:5px}.btn-fw{min-width:120px}.btn-planner:focus,.btn-planner:hover{color:#fff;text-decoration:none}.btn-evaluation{border-style:solid;border-color:#fff;background-color:hsla(0,0%,100%,.4)}.dropdown-menu{background-color:#f7f7f7;border-radius:3px;box-shadow:0 2px 6px rgba(0,0,0,.15);border:1px solid rgba(0,0,0,.1);transform-origin:top left}.dropdown-menu.pull-left{left:100%}.dropdown-menu.pull-right{left:auto!important;transform-origin:top right}.dropdown-menu.pull-up{top:0}.dropup .dropdown-menu{transform-origin:bottom left}.dropup .dropdown-menu.pull-right{transform-origin:bottom right}.dropdown-menu>.panel{border:none;margin:-5px 0}.dropdown-menu>li>a{color:#000!important;padding:8px 16px;margin:0 5px}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover,.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{background-image:none;filter:none;background-color:#d1d1d1!important;color:#000!important}.dropdown-menu.top,.dropdown-menu.top-left,.dropdown-menu.top-right{margin-top:-2px}.dropdown-menu.datepicker{padding-left:5px;padding-right:5px;font-size:12px}.dropdown-menu.datepicker .btn{font-size:12px}.dropdown-menu.timepicker{padding-top:5px;padding-bottom:5px;font-size:12px}.dropdown-menu.timepicker .btn{font-size:12px}.dropdown-menu-scale{display:block;opacity:0;transform:scale(0);transition:all .25s;-webkit-backface-visibility:hidden;backface-visibility:hidden}.open>.dropdown-menu-scale{opacity:1;transform:scale(1)}.dropdown-header{padding:8px 16px}.dropdown-submenu{position:relative}.dropdown-submenu:focus>a,.dropdown-submenu:hover>a{background-color:inherit!important}.dropdown-submenu:focus>.dropdown-menu,.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu.pull-left{float:none!important}.dropdown-submenu.pull-left>.dropdown-menu{left:-100%;margin-left:10px}.dropdown-submenu .dropdown-menu{left:100%;top:0;margin-top:-6px;margin-left:-1px}.dropup .dropdown-submenu>.dropdown-menu{top:auto;bottom:0}@media (max-width:767px){.dropdown-menu.pull-none-xs{left:0}}.form-control{border-color:#eaeaea;border-radius:3px}.form-control,.form-control:focus{box-shadow:none}.form-control:focus{border-color:#b7b7b7}.form-control::-webkit-input-placeholder{color:inherit;opacity:.3}.form-control::-moz-placeholder{color:inherit;opacity:.3}.form-control:-ms-input-placeholder{color:inherit;opacity:.3}.form-control-spin{position:absolute;z-index:2;right:10px;top:50%;margin-top:-7px}.form-horizontal .form-group-lg .form-control,.input-lg{height:45px;border-radius:3px}.input-group-addon{border-color:#eaeaea;background-color:#f7f7f7}.form-group-stack .form-control{margin-top:-1px;position:relative;border-radius:0}.form-group-stack .form-control:active,.form-group-stack .form-control:focus{z-index:1}.form-validation .form-control.ng-dirty.ng-invalid{border-color:#d7634a}.form-validation .form-control.ng-dirty.ng-valid,.form-validation .form-control.ng-dirty.ng-valid:focus{border-color:#a8c329}.form-validation .ui-checks .ng-invalid.ng-dirty+i{border-color:#d7634a}.form-file{position:relative}.form-file input{position:absolute;width:100%;height:100%;opacity:0}@media (max-width:992px){.form-horizontal .form-group{margin-left:-8px;margin-right:-8px}}.list-group{border-radius:3px;background:#fff}.list-group.no-radius .list-group-item{border-radius:0!important}.list-group.no-borders .list-group-item{border:none}.list-group.no-border .list-group-item{border-width:1px 0}.list-group.no-bg .list-group-item{background-color:transparent}.list-group-item,.list-group.list-group-gap{background:transparent}.list-group-item{border-left-color:transparent;border-right-color:transparent;border-color:hsla(210,4%,45%,.045);padding:12px 16px}a.list-group-item{color:inherit}a.list-group-item.hover,a.list-group-item:focus,a.list-group-item:hover{color:inherit;background-color:hsla(210,4%,45%,.075)}.list-group-item.media{margin-top:0}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{color:inherit;background-color:hsla(210,4%,45%,.075);border-color:transparent;border-bottom-color:1px solid hsla(210,4%,45%,.075)}.list-group-item.active:focus a,.list-group-item.active:hover a,.list-group-item.active a{color:inherit}.list-group-alt .list-group-item.active:nth-child(2n+2),.list-group-alt .list-group-item:nth-child(2n+2){background-color:hsla(210,4%,45%,.075)}.list-group-lg .list-group-item{padding:16px 24px}.list-group-md .list-group-item{padding-top:16px;padding-bottom:16px}.list-group-sm .list-group-item{padding:10px 12px}.list-group-gap .list-group-item{margin-bottom:5px;border-radius:3px;background:#fff}.green-bllt li{list-style-image:url(" + __webpack_require__(1540) + ")}.modal.fade .left{transform:translate3d(-100%,0,0)}.modal.fade .left,.modal.fade .right{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal.fade .right{transform:translate3d(100%,0,0)}.modal.fade .top{transform:translate3d(0,-100%,0)}.modal.fade .bottom,.modal.fade .top{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal.fade .bottom{transform:translate3d(0,100%,0)}.modal.in .bottom,.modal.in .left,.modal.in .right,.modal.in .top{transform:translateZ(0)}.modal.inactive{bottom:auto;overflow:visible}.modal>.left{left:0;right:auto}.modal>.left,.modal>.right{position:fixed;z-index:1055;top:0;bottom:0}.modal>.right{left:auto;right:0}.modal>.top{top:0;bottom:auto}.modal>.bottom,.modal>.top{position:fixed;z-index:1055;left:0;right:0}.modal>.bottom{top:auto;bottom:0}.modal-backdrop{background-color:#6f6f6e}.modal-backdrop.in{opacity:.8;filter:alpha(opacity=80)}.modal-over{left:0;right:0;top:0;bottom:0;position:fixed}.modal-center{position:absolute;left:50%;top:50%}.modal-header{border-bottom:none}.modal-backdrop{background-color:#171717}.bottom-modal-btn.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-left-radius:0;border-bottom-right-radius:0;border-top-right-radius:0}.bottom-modal-btn.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-right-radius:0!important;border-bottom-left-radius:0;border-top-left-radius:0}.bottom-modal-btn .btn,.bottom-modal-btn .btn:focus,.bottom-modal-btn .btn:hover{color:#fff}button.md-btn.overflow-button{position:relative;display:block;margin:auto;top:14px}.input-line{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit;text-align:center}.caja-verde{background-color:rgba(170,206,59,.5)}.nav>li>a:focus,.nav>li>a:hover{background-color:#2d3039;color:#fff}.nav>li.active>a{background-color:#353942;color:#ffaf00}#transparentMenu .nav>li>a:focus,#transparentMenu .nav>li>a:hover{background-color:transparent;color:#fff}#transparentMenu .nav>li.active>a{background-color:transparent;color:#ffaf00}.rojo-nav-hover:hover{background-color:#ffaf00!important}.azul-nav-hover:hover{background-color:#002f4b!important}.nav>li>a{padding:10px 16px}.nav.nav-lg>li>a{padding:20px}.nav.nav-md>li>a{padding:16px}.nav.nav-sm>li>a{font-size:13px;padding:6px 12px}.nav.nav-xs>li>a{font-size:12px;padding:4px 10px}.nav.nav-xxs>li>a{font-size:12px;padding:1px 10px}.nav.nav-rounded>li>a{border-radius:20px}.nav.no-radius>li>a{border-radius:0}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:inherit}.nav-pills>li.active>a,.nav-pills>li.active>a:active,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#494948;background-color:#eaeaea}.nav-pills>li.active>a>.text-muted{color:#494948}.nav-tabs{border-color:#eaeaea}.nav-tabs>li>a{border-radius:3px 3px 0 0;border-bottom-color:#eaeaea;color:#2d3039}.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover .nav-tabs>li.active>a:focus,.nav-tabs>li:hover>a{border-color:#eaeaea;background-color:#fff;color:#2d3039}.nav-tabs>li.active>a{border-bottom-color:#fff!important}.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0;border-radius:3px 3px 0 0}.nav-lines{margin-bottom:-1px;border-width:0!important}.nav-lines.nav-justified{border-bottom:2px solid #002f4b;margin-bottom:-2px}.nav-lines>li{float:left;border-color:inherit;opacity:.6}.nav-lines>li:after{content:\"\";position:absolute;left:50%;right:50%;bottom:0;border-bottom-width:2px;border-bottom-style:solid;border-bottom-color:transparent;transition:all .3s cubic-bezier(.35,0,.25,1)}.nav-lines>li>a{background-color:transparent!important;border-width:0!important}.nav-lines>li.active{opacity:1;z-index:5}.nav-lines>li.active:after{left:0;right:0;border-bottom-color:inherit}.nav-lines.nav-lines-top>li:after{bottom:auto;top:0}.nav-lists a{border-bottom:1px solid #eaeaea}.tab-container{margin-bottom:15px}.tab-container .tab-content{padding:15px;background-color:#fff;border:1px solid #eaeaea;border-top-width:0;border-radius:0 0 3px 3px}.navbar{border:none;margin:0;position:relative;z-index:50;min-height:64px}.navbar .navbar-brand,.navbar .navbar-item,.navbar .navbar-nav>li>a,.navbar .navbar-tool>li>a{padding:0 16px;line-height:64px}.navbar .navbar-tool.nav-sm>li>a{padding-left:10px;padding-right:10px}.navbar .navbar-tool>li{float:left}.navbar .navbar-brand{font-size:20px;font-weight:700;display:block;float:none}.navbar .navbar-brand:hover{text-decoration:none}.navbar .navbar-brand img,.navbar .navbar-brand svg{display:inline-block;vertical-align:-10%}@media (max-width:991px){.navbar,.navbar .navbar-brand{min-height:50px}.navbar .navbar-brand,.navbar .navbar-item,.navbar .navbar-nav>li>a,.navbar .navbar-tool>li>a{line-height:50px}}.pagination>li>a{border-color:#eaeaea}.pagination>li>a:focus,.pagination>li>a:hover{border-color:#eaeaea;background-color:#f7f7f7}.panel{border-radius:3px;margin-bottom:8px;box-shadow:none}.panel .accordion-toggle{font-size:14px;display:block;cursor:pointer}.panel .list-group-item{border-color:#f7f7f7}.panel-card,.panel.no-borders,.panel.no-borders .panel-footer,.panel.no-borders .panel-heading{border-width:0}.panel-card{box-shadow:0 1px 2px rgba(0,0,0,.15);border-radius:0}.panel-heading{padding:16px 24px;border-radius:3px 3px 0 0}.panel-default .panel-heading{background-color:#003f65;color:#fff}.panel-default .panel-heading.bg-white{background-color:#fff}.panel-heading.no-border{margin:-1px -1px 0;border:none}.panel-heading .nav{margin:-12px -16px}.panel-heading .list-group{background:transparent}.panel-heading.panel-heading-sm{padding-top:8px;padding-bottom:8px}.panel-heading.panel-heading-xs{padding-top:6px;padding-bottom:6px}.panel-body,.panel-footer{padding:16px 24px}.panel-footer{border-color:#f7f7f7;border-radius:0 0 3px 3px;background-color:#006fb1}.panel-footer.panel-footer-sm{padding-top:8px;padding-bottom:8px}.panel-footer.panel-footer-xs{padding-top:6px;padding-bottom:6px}.panel-group .panel-heading+.panel-collapse .panel-body{border-top:1px solid #f7f7f7}.panel-default{border-color:#eaeaea}.panel-default>.panel-footer,.panel-default>.panel-heading{border-color:#f7f7f7}.panel-primary{border-color:#cad4d9}.panel-primary>.panel-heading{color:#000;background-color:#d9e0e4;border-color:#cad4d9}.panel-info{border-color:#cad4d9}.panel-info>.panel-heading{color:#000;background-color:#d9e0e4;border-color:#cad4d9}.panel-success{border-color:#eaf0cb}.panel-success>.panel-heading{color:#5f6f17;background-color:#f2f6df;border-color:#eaf0cb}.panel-warning{border-color:#fef0cd}.panel-warning>.panel-heading{color:#e2a407;background-color:#fef7e6;border-color:#fef0cd}.panel-danger{border-color:#f4d6cf}.panel-danger>.panel-heading{color:#993722;background-color:#f9e8e4;border-color:#f4d6cf}.panel-dark{border-color:#dddddc}.panel-dark>.panel-heading{color:#3c3c3b;background-color:#e9e9e9;border-color:#dddddc}.detail-box{width:49%;float:left;text-align:center;box-sizing:border-box}.v-line-grey{height:60px;background-color:#ccc;width:1px;display:block;float:left}.box-config .panel-heading{padding:5px;border-radius:3px 3px 0 0}.box-config .panel-body{padding:2px 24px 16px}.box-config h4{font-size:16px!important;font-weight:600;margin-bottom:0}.detail-box p.name{font-size:14px;color:#ccd0db}.detail-box p{font-size:22px;color:#758295;margin-bottom:0}.panel-heading{position:relative;padding:15px 24px}.panel-heading h1,.panel-heading h2,.panel-heading h3,.panel-heading h4,.panel-heading h5,.panel-heading h6{margin:0}.panel-heading small{margin-top:8px;opacity:.5}.progress{background-color:#f7f7f7}.progress-xxxs{height:1px}.progress-xxs{height:2px}.progress-xs{height:6px}.progress-sm{height:12px}.progress-sm .progress-bar{font-size:10px;line-height:12px}.progress,.progress-bar{box-shadow:none}.progress-bar-info,.progress-bar-primary{background-color:#002f4b}.progress-bar-success{background-color:#a8c329}.progress-bar-warning{background-color:#facb55}.progress-bar-danger{background-color:#d7634a}.progress-bar-accent{background-color:#ffaf00}.progress-bar-dark{background-color:#6f6f6e}.progress-bar-white{background-color:#fff}.col-0{clear:left}.row.no-gutter{margin-left:0;margin-right:0}.no-gutter [class*=col]{padding:0}.row-sm{margin-left:-8px;margin-right:-8px}.row-sm>div{padding-left:8px;padding-right:8px}.row-xs{margin-left:-4px;margin-right:-4px}.row-xs>div{padding-left:4px;padding-right:4px}@media (max-width:992px){.row{margin-left:-8px;margin-right:-8px}.row>div{padding-left:8px;padding-right:8px}.row-2 [class*=col]{width:50%;float:left}.row-2 .col-0{clear:none}.row-2 li:nth-child(odd){clear:left;margin-left:0}}@media (max-width:767px){.row{margin-left:-4px;margin-right:-4px}.row>div{padding-left:4px;padding-right:4px}}.gutter-20.row{margin-right:-10px;margin-left:-10px}.gutter-20>[class^=\" col-\"],.gutter-20>[class^=col-]{padding-right:10px;padding-left:10px}.gutter-10.row{margin-right:-5px;margin-left:-5px}.gutter-10>[class^=\" col-\"],.gutter-10>[class^=col-]{padding-right:5px;padding-left:5px}.gutter-0.row{margin-right:0;margin-left:0}.gutter-0>[class^=\" col-\"],.gutter-0>[class^=col-]{padding-right:0;padding-left:0}.panel .table{border-color:#eaeaea!important}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th{border-top:1px solid #ddd}.table>thead>tr>th{border-bottom:1px solid #ddd}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>thead>tr>th{border-color:#eaeaea}.table-striped>tbody>tr:nth-child(odd)>td,.table-striped>tbody>tr:nth-child(odd)>th,.table-striped>thead>th{background-color:#f7f7f7}.table-striped>thead>th{border-right:1px solid #eaeaea}.table-striped>thead>th:last-child{border-right:none}table.table.disabled{opacity:.2;cursor:not-allowed}.align-td{text-align:center}.thead-color{background-color:#d8d8d8}.ngRow.even{background-color:#f2f5f7}.ngRow.odd{background-color:#d8d8d8}.line-down{opacity:.85;text-decoration:underline}.grad-1,.grad-2,.grad-3,.grad-4{background:#002f4b}.grad-white{background:#fcfcfc}.grad-5{background:#002f4b}.grad-oblique-negro-dark{background:#353942;background:linear-gradient(177deg,#353942 78%,transparent 79%)}.grad-oblique-azul{background:#2053d2;background:linear-gradient(177deg,#2053d2 78%,transparent 79%)}.grad-oblique-teal{background:#00bfa5;background:linear-gradient(177deg,#00bfa5 78%,transparent 79%)}.grad-oblique-deep-orange{background:#ff7043;background:linear-gradient(177deg,#ff7043 78%,transparent 79%)}.md-btn,[md-ink-ripple]{position:relative}.md-btn{color:currentColor;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;border:0;border-radius:3px;padding:6px;display:inline-block;background:transparent;white-space:nowrap;text-align:center;font-weight:700;font-style:inherit;font-variant:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-decoration:none;cursor:pointer;overflow:hidden;transition:box-shadow .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),transform .4s cubic-bezier(.25,.8,.25,1)}.md-button{text-transform:none!important}.md-button.md-default-theme.md-primary.md-fab,.md-button.md-default-theme.md-primary.md-raised,.md-button.md-primary.md-fab,.md-button.md-primary.md-raised,a.md-button.md-default-theme.md-primary.md-fab,a.md-button.md-default-theme.md-primary.md-raised,a.md-button.md-primary.md-fab,a.md-button.md-primary.md-raised{background-color:#ffaf00!important;color:#000}md-toolbar.md-default-theme:not(.md-menu-toolbar),md-toolbar:not(.md-menu-toolbar){background-color:#aace3b;color:hsla(0,0%,100%,.87)}md-fab-toolbar{z-index:9999999}.md-btn.md-flat:not([disabled]):focus,.md-btn.md-flat:not([disabled]):hover{background-color:hsla(0,0%,62%,.2)}.md-btn-circle{width:28px;height:28px;border-radius:50%}.md-btn.md-fab[disabled],.md-btn.md-raised[disabled],.md-btn[disabled]{color:rgba(0,0,0,.26);background-color:transparent;cursor:not-allowed}.md-fab{line-height:44px}.md-fab-offset{margin-top:-28px;margin-bottom:-28px}.md-btn:focus{outline:none}.md-btn:hover{text-decoration:none}.md-btn.md-cornered{border-radius:0}.md-btn.md-icon{padding:0;background:none}.md-btn.md-fab,.md-btn.md-raised{transform:translateZ(0)}.md-btn.md-fab{z-index:20;width:56px;height:56px;border-radius:50%;overflow:hidden;transition:.2s linear;transition-property:transform,box-shadow}.md-btn.md-fab,.md-btn.md-raised:not([disabled]){box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-btn.md-fab:not([disabled]):focus,.md-btn.md-fab:not([disabled]):hover,.md-btn.md-raised:not([disabled]):focus,.md-btn.md-raised:not([disabled]):hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.4)}.md-btn.md-fab.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}.md-fab-toolbar.md-fab-bottom-right-2{top:auto;right:20px;bottom:20px;left:0;position:absolute}.md-btn.md-fab.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}.md-btn.md-fab.md-fab-top-right{top:20px;right:20px;bottom:auto;left:auto;position:absolute}.md-btn.md-fab.md-fab-top-left{top:20px;right:auto;bottom:auto;left:20px;position:absolute}.md-btn.md-fab md-icon{margin-top:0}.md-btn.md-fab.md-mini{width:40px;height:40px}.md-btn:not([disabled]).md-fab:focus,.md-btn:not([disabled]).md-fab:hover,.md-btn:not([disabled]).md-raised:focus,.md-btn:not([disabled]).md-raised:hover{transform:translate3d(0,-1px,0)}.md-toast-open-top .md-btn.md-fab-top-left,.md-toast-open-top .md-btn.md-fab-top-right{transform:translate3d(0,42px,0)}.md-toast-open-top .md-btn.md-fab-top-left:not([disabled]):focus,.md-toast-open-top .md-btn.md-fab-top-left:not([disabled]):hover,.md-toast-open-top .md-btn.md-fab-top-right:not([disabled]):focus,.md-toast-open-top .md-btn.md-fab-top-right:not([disabled]):hover{transform:translate3d(0,41px,0)}.md-toast-open-bottom .md-btn.md-fab-bottom-left,.md-toast-open-bottom .md-btn.md-fab-bottom-right{transform:translate3d(0,-42px,0)}.md-toast-open-bottom .md-btn.md-fab-bottom-left:not([disabled]):focus,.md-toast-open-bottom .md-btn.md-fab-bottom-left:not([disabled]):hover,.md-toast-open-bottom .md-btn.md-fab-bottom-right:not([disabled]):focus,.md-toast-open-bottom .md-btn.md-fab-bottom-right:not([disabled]):hover{transform:translate3d(0,-43px,0)}.card{font-family:Open Sans,sans-serif!important;box-shadow:0 1px 2px rgba(0,0,0,.15);background-color:#fff;position:relative;margin-bottom:8px;overflow:hidden}.card.active:hover{box-shadow:0 5px 10px rgba(0,0,0,.5);transition:box-shadow .5s ease}.card a{color:#ffaf00;text-decoration:none}.card-heading{position:relative;padding:15px 24px}.card-heading h1,.card-heading h2,.card-heading h3,.card-heading h4,.card-heading h5,.card-heading h6{margin:0}.card-heading small{margin-top:8px;opacity:.5}.card-body{padding:20px 24px}.card-divider{border-bottom:1px solid hsla(210,4%,45%,.15);margin:0 24px}.card-tools{position:absolute;right:12px;top:12px}.blue-500 small,.blue-600 small,.blue-700 small,.blue-A200 small,.blue-A400 small,.blue-A700 small,.blue-grey-400 small,.blue-grey-500 small,.blue-grey small,.blue small,.brown-300 small,.brown-400 small,.cyan-500 small,.cyan-600 small,.cyan-700 small,.cyan-800 small,.cyan small,.deep-orange-500 small,.deep-orange-600 small,.deep-orange-700 small,.deep-orange-800 small,.deep-orange-900 small,.deep-orange-A400 small,.deep-orange-A700 small,.deep-orange small,.deep-purple-300 small,.deep-purple-400 small,.deep-purple-A200 small,.green-500 small,.green-600 small,.green-700 small,.green small,.indigo-300 small,.indigo-400 small,.indigo-A200 small,.indigo-A400 small,.light-blue-500 small,.light-blue-600 small,.light-blue-700 small,.light-blue-800 small,.light-blue-A700 small,.light-blue small,.light-green-800 small,.light-green-900 small,.lime-900 small,.orange-800 small,.orange-900 small,.pink-500 small,.pink-600 small,.pink-A200 small,.pink-A400 small,.pink-A700 small,.pink small,.purple-300 small,.purple-400 small,.purple-A200 small,.purple-A400 small,.purple-A700 small,.red-500 small,.red-600 small,.red-700 small,.red-A200 small,.red-A400 small,.red-A700 small,.red small,.teal-500 small,.teal-600 small,.teal-700 small,.teal small{color:#fff;opacity:.7}.azul{background-color:#2053d2}.azul-light{background-color:#468ac2}.amarillo{background-color:#fab813}.verde{background-color:#aace3b}.gris-dark{background-color:#91a3bd}.gris-darker{background-color:#758295}.rojo{background-color:#ef7955}.morado{background-color:#7e57c2}.naranjo{background-color:#ff9800}.blanco{background-color:#fff}.gris-light{background-color:#ccd0db}.gris-lighter{background-color:#f2f5f7}.negro-darker{background-color:#2d3039}.negro-dark{background-color:#353942}.gris-base{background-color:#f9f9f9}.cian-light{background-color:#53c3ab}.verde-light-msgs{background-color:#d7e6a7}.text-azul{color:#2053d2}.text-azul-light{color:#468ac2}.text-amarillo{color:#fab813}.text-verde{color:#aace3b}.text-gris-dark{color:#91a3bd}.text-gris-darker{color:#758295}.text-rojo{color:#ef7955}.text-morado{color:#7e57c2}.text-naranja{color:#ff9800}.text-cian{color:#53c3ab}.text-blanco{color:#fff}.text-gris-lighter{color:#f2f5f7}.text-negro-darker{color:#2d3039}.text-negro-dark{color:#353942}.text-negro-opacity{color:rgba(0,0,0,.45)}.text-verde-msgs{color:#667142}.text-rojo-important{color:#ef7955!important}.text-amarillo-important{color:#fab813!important}.text-negro-darker-important{color:#2d3039!important}.alert-manual{background:rgba(250,184,19,.2)}.alert-high{background:rgba(239,121,85,.2)}.bg-azul-light{background:rgba(70,138,194,.3)}.bg-azul{background:rgba(32,83,210,.3)}.bg-verde{background:rgba(170,206,59,.3)}.bg-amarillo{background:rgba(250,184,19,.3)}.bg-rojo{background:rgba(239,121,85,.3)}.bg-morado{background:rgba(126,87,194,.3)}.bg-rojo-dark{background:#ae1f35}.red{background-color:#d7634a}.red-50{background-color:#ffebee}.red-100{background-color:#ffcdd2}.red-200{background-color:#ef9a9a}.red-300{background-color:#e57373}.red-400{background-color:#ef5350}.red-500{background-color:#d7634a}.red-600{background-color:#e53935}.red-700{background-color:#d32f2f}.red-800{background-color:#c62828}.red-900{background-color:#b71c1c}.red-A100{background-color:#ff8a80}.red-A200{background-color:#ff5252}.red-A400{background-color:#ff1744}.red-A700{background-color:#d50000}.pink{background-color:#e91e63}.pink-50{background-color:#fce4ec}.pink-100{background-color:#f8bbd0}.pink-200{background-color:#f48fb1}.pink-300{background-color:#f06292}.pink-400{background-color:#ec407a}.pink-500{background-color:#e91e63}.pink-600{background-color:#d81b60}.pink-700{background-color:#c2185b}.pink-800{background-color:#ad1457}.pink-900{background-color:#880e4f}.pink-A100{background-color:#ff80ab}.pink-A200{background-color:#ff4081}.pink-A400{background-color:#f50057}.pink-A700{background-color:#c51162}.purple{background-color:#9c27b0}.purple-50{background-color:#f3e5f5}.purple-100{background-color:#e1bee7}.purple-200{background-color:#ce93d8}.purple-300{background-color:#ba68c8}.purple-400{background-color:#ab47bc}.purple-500{background-color:#9c27b0}.purple-600{background-color:#8e24aa}.purple-700{background-color:#7b1fa2}.purple-800{background-color:#6a1b9a}.purple-900{background-color:#4a148c}.purple-A100{background-color:#ea80fc}.purple-A200{background-color:#e040fb}.purple-A400{background-color:#d500f9}.purple-A700{background-color:#a0f}.deep-purple{background-color:#673ab7}.deep-purple-50{background-color:#ede7f6}.deep-purple-100{background-color:#d1c4e9}.deep-purple-200{background-color:#b39ddb}.deep-purple-300{background-color:#9575cd}.deep-purple-400{background-color:#7e57c2}.deep-purple-500{background-color:#673ab7}.deep-purple-600{background-color:#5e35b1}.deep-purple-700{background-color:#512da8}.deep-purple-800{background-color:#4527a0}.deep-purple-900{background-color:#311b92}.deep-purple-A100{background-color:#b388ff}.deep-purple-A200{background-color:#7c4dff}.deep-purple-A400{background-color:#651fff}.deep-purple-A700{background-color:#6200ea}.indigo{background-color:#3f51b5}.indigo-50{background-color:#e8eaf6}.indigo-100{background-color:#c5cae9}.indigo-200{background-color:#9fa8da}.indigo-300{background-color:#7986cb}.indigo-400{background-color:#5c6bc0}.indigo-500{background-color:#3f51b5}.indigo-600{background-color:#3949ab}.indigo-700{background-color:#303f9f}.indigo-800{background-color:#283593}.indigo-900{background-color:#1a237e}.indigo-A100{background-color:#8c9eff}.indigo-A200{background-color:#536dfe}.indigo-A400{background-color:#3d5afe}.indigo-A700{background-color:#304ffe}.blue{background-color:#00548a}.blue-50{background-color:#e3f2fd}.blue-100{background-color:#bbdefb}.blue-200{background-color:#90caf9}.blue-300{background-color:#64b5f6}.blue-400{background-color:#42a5f5}.blue-500{background-color:#00548a}.blue-600{background-color:#1e88e5}.blue-700{background-color:#1976d2}.blue-800{background-color:#1565c0}.blue-900{background-color:#0d47a1}.blue-A100{background-color:#82b1ff}.blue-A200{background-color:#448aff}.blue-A400{background-color:#2979ff}.blue-A700{background-color:#2962ff}.light-blue{background-color:#468ac2}.light-blue-50{background-color:#e1f5fe}.light-blue-100{background-color:#b3e5fc}.light-blue-200{background-color:#81d4fa}.light-blue-300{background-color:#4fc3f7}.light-blue-400{background-color:#29b6f6}.light-blue-500{background-color:#468ac2}.light-blue-600{background-color:#039be5}.light-blue-700{background-color:#0288d1}.light-blue-800{background-color:#0277bd}.light-blue-900{background-color:#01579b}.light-blue-A100{background-color:#80d8ff}.light-blue-A200{background-color:#40c4ff}.light-blue-A400{background-color:#00b0ff}.light-blue-A700{background-color:#0091ea}.cyan{background-color:#00bcd4}.cyan-50{background-color:#e0f7fa}.cyan-100{background-color:#b2ebf2}.cyan-200{background-color:#80deea}.cyan-300{background-color:#4dd0e1}.cyan-400{background-color:#26c6da}.cyan-500{background-color:#00bcd4}.cyan-600{background-color:#00acc1}.cyan-700{background-color:#0097a7}.cyan-800{background-color:#00838f}.cyan-900{background-color:#006064}.cyan-A100{background-color:#84ffff}.cyan-A200{background-color:#18ffff}.cyan-A400{background-color:#00e5ff}.cyan-A700{background-color:#00b8d4}.teal{background-color:#009688}.teal-50{background-color:#e0f2f1}.teal-100{background-color:#b2dfdb}.teal-200{background-color:#80cbc4}.teal-300{background-color:#4db6ac}.teal-400{background-color:#26a69a}.teal-500{background-color:#009688}.teal-600{background-color:#00897b}.teal-700{background-color:#00796b}.teal-800{background-color:#00695c}.teal-900{background-color:#004d40}.teal-A100{background-color:#a7ffeb}.teal-A200{background-color:#64ffda}.teal-A400{background-color:#1de9b6}.teal-A700{background-color:#00bfa5}.green{background-color:#4caf50}.green-50{background-color:#e8f5e9}.green-100{background-color:#c8e6c9}.green-200{background-color:#a5d6a7}.green-300{background-color:#81c784}.green-400{background-color:#66bb6a}.green-500{background-color:#4caf50}.green-600{background-color:#43a047}.green-700{background-color:#388e3c}.green-800{background-color:#2e7d32}.green-900{background-color:#1b5e20}.green-A100{background-color:#b9f6ca}.green-A200{background-color:#69f0ae}.green-A400{background-color:#00e676}.green-A700{background-color:#00c853}.light-green{background-color:#8bc34a}.light-green-50{background-color:#f1f8e9}.light-green-100{background-color:#dcedc8}.light-green-200{background-color:#c5e1a5}.light-green-300{background-color:#aed581}.light-green-400{background-color:#9ccc65}.light-green-500{background-color:#8bc34a}.light-green-600{background-color:#7cb342}.light-green-700{background-color:#689f38}.light-green-800{background-color:#558b2f}.light-green-900{background-color:#33691e}.light-green-A100{background-color:#ccff90}.light-green-A200{background-color:#b2ff59}.light-green-A400{background-color:#76ff03}.light-green-A700{background-color:#64dd17}.lime{background-color:#a8c329}.lime-50{background-color:#f9fbe7}.lime-100{background-color:#f0f4c3}.lime-200{background-color:#e6ee9c}.lime-300{background-color:#dce775}.lime-400{background-color:#d4e157}.lime-500{background-color:#a8c329}.lime-600{background-color:#c0ca33}.lime-700{background-color:#afb42b}.lime-800{background-color:#9e9d24}.lime-900{background-color:#827717}.lime-A100{background-color:#f4ff81}.lime-A200{background-color:#eeff41}.lime-A400{background-color:#c6ff00}.lime-A700{background-color:#aeea00}.yellow{background-color:#ffeb3b}.yellow-50{background-color:#fffde7}.yellow-100{background-color:#fff9c4}.yellow-200{background-color:#fff59d}.yellow-300{background-color:#fff176}.yellow-400{background-color:#ffee58}.yellow-500{background-color:#ffeb3b}.yellow-600{background-color:#fdd835}.yellow-700{background-color:#fbc02d}.yellow-800{background-color:#f9a825}.yellow-900{background-color:#f57f17}.yellow-A100{background-color:#ffff8d}.yellow-A200{background-color:#ff0}.yellow-A400{background-color:#ffea00}.yellow-A700{background-color:#ffd600}.amber{background-color:#fab813}.amber-50{background-color:#fff8e1}.amber-100{background-color:#ffecb3}.amber-200{background-color:#ffe082}.amber-300{background-color:#ffd54f}.amber-400{background-color:#ffca28}.amber-500{background-color:#fab813}.amber-600{background-color:#ffb300}.amber-700{background-color:#ffa000}.amber-800{background-color:#ff8f00}.amber-900{background-color:#ff6f00}.amber-A100{background-color:#ffe57f}.amber-A200{background-color:#ffd740}.amber-A400{background-color:#ffc400}.amber-A700{background-color:#ffab00}.orange{background-color:#ff9800}.orange-50{background-color:#fff3e0}.orange-100{background-color:#ffe0b2}.orange-200{background-color:#ffcc80}.orange-300{background-color:#ffb74d}.orange-400{background-color:#ffa726}.orange-500{background-color:#ff9800}.orange-600{background-color:#fb8c00}.orange-700{background-color:#f57c00}.orange-800{background-color:#ef6c00}.orange-900{background-color:#e65100}.orange-A100{background-color:#ffd180}.orange-A200{background-color:#ffab40}.orange-A400{background-color:#ff9100}.orange-A700{background-color:#ff6d00}.deep-orange{background-color:#ff5722}.deep-orange-50{background-color:#fbe9e7}.deep-orange-100{background-color:#ffccbc}.deep-orange-200{background-color:#ffab91}.deep-orange-300{background-color:#ff8a65}.deep-orange-400{background-color:#ff7043}.deep-orange-500{background-color:#ff5722}.deep-orange-600{background-color:#f4511e}.deep-orange-700{background-color:#e64a19}.deep-orange-800{background-color:#d84315}.deep-orange-900{background-color:#bf360c}.deep-orange-A100{background-color:#ff9e80}.deep-orange-A200{background-color:#ff6e40}.deep-orange-A400{background-color:#ff3d00}.deep-orange-A700{background-color:#dd2c00}.brown{background-color:#795548}.brown-50{background-color:#efebe9}.brown-100{background-color:#d7ccc8}.brown-200{background-color:#bcaaa4}.brown-300{background-color:#a1887f}.brown-400{background-color:#8d6e63}.brown-500{background-color:#795548}.brown-600{background-color:#6d4c41}.brown-700{background-color:#5d4037}.brown-800{background-color:#4e342e}.brown-900{background-color:#3e2723}.blue-grey{background-color:#607d8b}.blue-grey-50{background-color:#eceff1}.blue-grey-100{background-color:#cfd8dc}.blue-grey-200{background-color:#b0bec5}.blue-grey-300{background-color:#90a4ae}.blue-grey-400{background-color:#78909c}.blue-grey-500{background-color:#607d8b}.blue-grey-600{background-color:#546e7a}.blue-grey-700{background-color:#455a64}.blue-grey-800{background-color:#37474f}.blue-grey-900{background-color:#263238}.grey{background-color:#6f6f6e}.grey-50{background-color:#fafafa}.grey-100{background-color:#f5f5f5}.grey-200{background-color:#eee}.grey-300{background-color:#e0e0e0}.grey-400{background-color:#bdbdbd}.grey-500{background-color:#6f6f6e}.grey-600{background-color:#757575}.grey-700{background-color:#616161}.grey-800{background-color:#424242}.grey-900{background-color:#212121}.blue,.blue-500,.blue-600,.blue-700,.blue-A200,.blue-A400,.blue-A700,.blue-grey,.blue-grey-400,.blue-grey-500,.brown-300,.brown-400,.cyan,.cyan-500,.cyan-600,.cyan-700,.cyan-800,.deep-orange,.deep-orange-500,.deep-orange-600,.deep-orange-700,.deep-orange-800,.deep-orange-900,.deep-orange-A400,.deep-orange-A700,.deep-purple-300,.deep-purple-400,.deep-purple-A200,.green,.green-500,.green-600,.green-700,.indigo-300,.indigo-400,.indigo-A200,.indigo-A400,.light-blue,.light-blue-500,.light-blue-600,.light-blue-700,.light-blue-800,.light-blue-A700,.light-green-800,.light-green-900,.lime-900,.orange-800,.orange-900,.pink,.pink-500,.pink-600,.pink-A200,.pink-A400,.pink-A700,.purple-300,.purple-400,.purple-A200,.purple-A400,.purple-A700,.red,.red-500,.red-600,.red-700,.red-A200,.red-A400,.red-A700,.teal,.teal-500,.teal-600,.teal-700{color:#fff}.blue-800,.blue-900,.blue-grey-600,.blue-grey-700,.blue-grey-800,.blue-grey-900,.brown,.brown-500,.brown-600,.brown-700,.brown-800,.brown-900,.cyan-900,.deep-purple,.deep-purple-500,.deep-purple-600,.deep-purple-700,.deep-purple-800,.deep-purple-900,.deep-purple-A400,.deep-purple-A700,.green-800,.green-900,.grey-600,.grey-700,.grey-800,.grey-900,.indigo,.indigo-500,.indigo-600,.indigo-700,.indigo-800,.indigo-900,.indigo-A700,.light-blue-900,.pink-700,.pink-800,.pink-900,.purple,.purple-500,.purple-600,.purple-700,.purple-800,.purple-900,.red-800,.red-900,.teal-800,.teal-900{color:hsla(0,0%,100%,.87)}.orange-A700{color:#000}.amarillo,.azul,.azul-light,.gris-dark,.gris-darker,.morado,.negro-dark,.negro-darker,.rojo,.verde{color:#fff}.gris-lighter{color:#000}.bg-azul,.bg-azul-light{color:#303f9f}.md-list{border-radius:3px}.md-list-item{display:block;position:relative;padding:16px}.md-list-item:after{content:\"\";position:absolute;left:0;right:0;bottom:0;border-bottom:1px solid hsla(0,0%,63%,.2)}.md-list-item:last-child.md-list-item:after{border:none}.md-list-item.inset.md-list-item:after{left:72px}.md-list-item-left{width:40px;height:40px;margin-right:16px;float:left;text-align:center;line-height:40px}.md-list-item-content{overflow:hidden}.md-list-item-content h3{margin:0 0 3px;font-weight:400}.md-form-group{padding:18px 0 24px;position:relative}.md-input{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit}.md-input.focus,.md-input:focus{border-color:#002f4b;border-bottom-width:2px;padding-bottom:1px}.md-input.focus~label,.md-input:focus~label{color:#002f4b;opacity:1;top:0!important;font-size:.85em!important}.float-label .md-input~label{top:20px;font-size:1em}.float-label .md-input.has-value~label,.float-label .md-input.ng-dirty~label,.md-input~label{top:0;font-size:.85em}.md-input~label{transition:all .2s;position:absolute;z-index:0;opacity:.5;display:inline-block;left:0}.md-input.disabled,.md-input[disabled]{opacity:.5}textarea.md-input{height:auto}.md-input-white.focus,.md-input-white:focus{border-color:#fff}.md-input-white.focus~label,.md-input-white:focus~label{color:#fff}.md-input-msg{position:absolute;bottom:0;line-height:24px;font-size:.85em}.md-input-msg.right{right:0}.height-input{padding:7px;margin-top:-2px;border:1px solid #d8d8d8}.md-check{cursor:pointer;padding-left:20px;margin:0;display:inline-block;position:relative}.md-check input{position:absolute;cursor:pointer;width:20px;height:20px;z-index:1;opacity:0;margin-left:-20px}.md-check input:checked+i:before{border-width:0;background-color:inherit}.md-check input:checked+span .active{display:inherit}.md-check input[type=radio]+i,.md-check input[type=radio]+i:before{border-radius:50%}.md-check input[type=checkbox]:checked+i:after{transform:rotate(45deg);position:absolute;left:6px;top:2px;display:table;width:6px;height:12px;border:2px solid;border-top:0;border-left:0;content:\" \"}.md-check input[type=radio]:checked+i:after{position:absolute;left:6px;top:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.md-check input[disabled]+i:before,fieldset[disabled] .md-check input+i:before{border-color:rgba(0,0,0,.26)}.md-check input[disabled]:checked+i:before{background-color:rgba(0,0,0,.26)}.md-check>i{width:0;height:18px;line-height:1;margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:28px;position:relative}.md-check>i:before{content:\"\";position:absolute;width:18px;height:100%;border:2px solid rgba(0,0,0,.54);border-radius:2px;transition:all .2s}.md-check>i.no-icon:after{display:none!important}md-checkbox.md-checked.md-green .md-icon{background-color:#aace3b}md-checkbox.md-checked.md-blue .md-icon{background-color:#468ac2}md-checkbox.md-checked.md-blue-2 .md-icon{background-color:#2053d2}.md-switch{cursor:pointer;padding-left:36px;margin:0;min-height:20px}.md-switch input{position:absolute;cursor:pointer;width:36px;height:20px;z-index:1;opacity:0;filter:alpha(opacity=0);margin-left:-36px}.md-switch input:checked+i:before{background:inherit;opacity:.5}.md-switch input:checked+i:after{background:inherit;left:16px}.md-switch input[disabled]+i:before,fieldset[disabled] .md-switch input+i:before{background-color:rgba(0,0,0,.12)}.md-switch input[disabled]+i:after,fieldset[disabled] .md-switch input+i:after{background-color:#bdbdbd}.md-switch i{width:0;height:18px;line-height:1;margin-left:-36px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:44px;position:relative}.md-switch i:before{left:1px;width:34px;top:3px;height:14px;border-radius:8px;background-color:#9e9e9e}.md-switch i:after,.md-switch i:before{content:\"\";position:absolute;transition:all .2s}.md-switch i:after{margin:0;left:0;top:0;outline:none;height:20px;width:20px;border-radius:50%;background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.box-row md-switch.md-checked .md-thumb{background-color:#4caf50}md-switch.md-checked .md-bar{background-color:rgba(76,175,80,.5)}.md-whiteframe-z0{box-shadow:0 1px 3px rgba(0,0,0,.15)}.md-whiteframe-z1{box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-whiteframe-z2{box-shadow:0 8px 17px rgba(0,0,0,.2)}.md-whiteframe-z3{box-shadow:0 17px 50px rgba(0,0,0,.19)}.md-whiteframe-z4{box-shadow:0 16px 28px 0 rgba(0,0,0,.22)}.md-whiteframe-z5{box-shadow:0 27px 24px 0 rgba(0,0,0,.2)}/*!\n * font-awesome-animation - v0.0.9\n * https://github.com/l-lin/font-awesome-animation\n * http://l-lin.github.io/font-awesome-animation/\n * License: MIT\n */@keyframes wrench{0%{transform:rotate(-12deg)}8%{transform:rotate(12deg)}10%{transform:rotate(24deg)}18%{transform:rotate(-24deg)}20%{transform:rotate(-24deg)}28%{transform:rotate(24deg)}30%{transform:rotate(24deg)}38%{transform:rotate(-24deg)}40%{transform:rotate(-24deg)}48%{transform:rotate(24deg)}50%{transform:rotate(24deg)}58%{transform:rotate(-24deg)}60%{transform:rotate(-24deg)}68%{transform:rotate(24deg)}75%,to{transform:rotate(0deg)}}.faa-parent.animated-hover:hover>.faa-wrench,.faa-wrench.animated,.faa-wrench.animated-hover:hover{animation:wrench 2.5s ease infinite;transform-origin-x:90%;transform-origin-y:35%;transform-origin-z:initial}.faa-parent.animated-hover:hover>.faa-wrench.faa-fast,.faa-wrench.animated-hover.faa-fast:hover,.faa-wrench.animated.faa-fast{animation:wrench 1.2s ease infinite}.faa-parent.animated-hover:hover>.faa-wrench.faa-slow,.faa-wrench.animated-hover.faa-slow:hover,.faa-wrench.animated.faa-slow{animation:wrench 3.7s ease infinite}@keyframes ring{0%{transform:rotate(-15deg)}2%{transform:rotate(15deg)}4%{transform:rotate(-18deg)}6%{transform:rotate(18deg)}8%{transform:rotate(-22deg)}10%{transform:rotate(22deg)}12%{transform:rotate(-18deg)}14%{transform:rotate(18deg)}16%{transform:rotate(-12deg)}18%{transform:rotate(12deg)}20%,to{transform:rotate(0deg)}}.faa-parent.animated-hover:hover>.faa-ring,.faa-ring.animated,.faa-ring.animated-hover:hover{animation:ring 2s ease infinite;transform-origin-x:50%;transform-origin-y:0;transform-origin-z:initial}.faa-parent.animated-hover:hover>.faa-ring.faa-fast,.faa-ring.animated-hover.faa-fast:hover,.faa-ring.animated.faa-fast{animation:ring 1s ease infinite}.faa-parent.animated-hover:hover>.faa-ring.faa-slow,.faa-ring.animated-hover.faa-slow:hover,.faa-ring.animated.faa-slow{animation:ring 3s ease infinite}@keyframes vertical{0%{transform:translateY(-3px)}4%{transform:translateY(3px)}8%{transform:translateY(-3px)}12%{transform:translateY(3px)}16%{transform:translateY(-3px)}20%{transform:translateY(3px)}22%,to{transform:translate(0)}}.faa-parent.animated-hover:hover>.faa-vertical,.faa-vertical.animated,.faa-vertical.animated-hover:hover{animation:vertical 2s ease infinite}.faa-parent.animated-hover:hover>.faa-vertical.faa-fast,.faa-vertical.animated-hover.faa-fast:hover,.faa-vertical.animated.faa-fast{animation:vertical 1s ease infinite}.faa-parent.animated-hover:hover>.faa-vertical.faa-slow,.faa-vertical.animated-hover.faa-slow:hover,.faa-vertical.animated.faa-slow{animation:vertical 4s ease infinite}@keyframes horizontal{0%{transform:translate(0)}6%{transform:translate(5px)}12%{transform:translate(0)}18%{transform:translate(5px)}24%{transform:translate(0)}30%{transform:translate(5px)}36%,to{transform:translate(0)}}.faa-horizontal.animated,.faa-horizontal.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-horizontal{animation:horizontal 2s ease infinite}.faa-horizontal.animated-hover.faa-fast:hover,.faa-horizontal.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-horizontal.faa-fast{animation:horizontal 1s ease infinite}.faa-horizontal.animated-hover.faa-slow:hover,.faa-horizontal.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-horizontal.faa-slow{animation:horizontal 3s ease infinite}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.faa-flash.animated,.faa-flash.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-flash{animation:flash 2s ease infinite}.faa-flash.animated-hover.faa-fast:hover,.faa-flash.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-flash.faa-fast{animation:flash 1s ease infinite}.faa-flash.animated-hover.faa-slow:hover,.faa-flash.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-flash.faa-slow{animation:flash 3s ease infinite}@keyframes bounce{0%,10%,20%,50%,80%,to{transform:translateY(0)}40%{transform:translateY(-15px)}60%{transform:translateY(-15px)}}.faa-bounce.animated,.faa-bounce.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-bounce{animation:bounce 2s ease infinite}.faa-bounce.animated-hover.faa-fast:hover,.faa-bounce.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-bounce.faa-fast{animation:bounce 1s ease infinite}.faa-bounce.animated-hover.faa-slow:hover,.faa-bounce.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-bounce.faa-slow{animation:bounce 3s ease infinite}.faa-parent.animated-hover:hover>.faa-spin,.faa-spin.animated,.faa-spin.animated-hover:hover{animation:spin 1.5s linear infinite}.faa-parent.animated-hover:hover>.faa-spin.faa-fast,.faa-spin.animated-hover.faa-fast:hover,.faa-spin.animated.faa-fast{animation:spin .7s linear infinite}.faa-parent.animated-hover:hover>.faa-spin.faa-slow,.faa-spin.animated-hover.faa-slow:hover,.faa-spin.animated.faa-slow{animation:spin 2.2s linear infinite}@keyframes float{0%{transform:translateY(0)}50%{transform:translateY(-6px)}to{transform:translateY(0)}}.faa-float.animated,.faa-float.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-float{animation:float 2s linear infinite}.faa-float.animated-hover.faa-fast:hover,.faa-float.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-float.faa-fast{animation:float 1s linear infinite}.faa-float.animated-hover.faa-slow:hover,.faa-float.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-float.faa-slow{animation:float 3s linear infinite}@keyframes pulse{0%{transform:scale(1.1)}50%{transform:scale(.8)}to{transform:scale(1.1)}}.faa-parent.animated-hover:hover>.faa-pulse,.faa-pulse.animated,.faa-pulse.animated-hover:hover{animation:pulse 2s linear infinite}.faa-parent.animated-hover:hover>.faa-pulse.faa-fast,.faa-pulse.animated-hover.faa-fast:hover,.faa-pulse.animated.faa-fast{animation:pulse 1s linear infinite}.faa-parent.animated-hover:hover>.faa-pulse.faa-slow,.faa-pulse.animated-hover.faa-slow:hover,.faa-pulse.animated.faa-slow{animation:pulse 3s linear infinite}.faa-parent.animated-hover:hover>.faa-shake,.faa-shake.animated,.faa-shake.animated-hover:hover{animation:wrench 2.5s ease infinite}.faa-parent.animated-hover:hover>.faa-shake.faa-fast,.faa-shake.animated-hover.faa-fast:hover,.faa-shake.animated.faa-fast{animation:wrench 1.2s ease infinite}.faa-parent.animated-hover:hover>.faa-shake.faa-slow,.faa-shake.animated-hover.faa-slow:hover,.faa-shake.animated.faa-slow{animation:wrench 3.7s ease infinite}@keyframes tada{0%{transform:scale(1)}10%,20%{transform:scale(.9) rotate(-8deg)}30%,50%,70%{transform:scale(1.3) rotate(8deg)}40%,60%{transform:scale(1.3) rotate(-8deg)}80%,to{transform:scale(1) rotate(0)}}.faa-parent.animated-hover:hover>.faa-tada,.faa-tada.animated,.faa-tada.animated-hover:hover{animation:tada 2s linear infinite}.faa-parent.animated-hover:hover>.faa-tada.faa-fast,.faa-tada.animated-hover.faa-fast:hover,.faa-tada.animated.faa-fast{animation:tada 1s linear infinite}.faa-parent.animated-hover:hover>.faa-tada.faa-slow,.faa-tada.animated-hover.faa-slow:hover,.faa-tada.animated.faa-slow{animation:tada 3s linear infinite}@keyframes passing{0%{transform:translateX(-50%);opacity:0}50%{transform:translateX(0);opacity:1}to{transform:translateX(50%);opacity:0}}.faa-parent.animated-hover:hover>.faa-passing,.faa-passing.animated,.faa-passing.animated-hover:hover{animation:passing 2s linear infinite}.faa-parent.animated-hover:hover>.faa-passing.faa-fast,.faa-passing.animated-hover.faa-fast:hover,.faa-passing.animated.faa-fast{animation:passing 1s linear infinite}.faa-parent.animated-hover:hover>.faa-passing.faa-slow,.faa-passing.animated-hover.faa-slow:hover,.faa-passing.animated.faa-slow{animation:passing 3s linear infinite}@keyframes passing-reverse{0%{transform:translateX(50%);opacity:0}50%{transform:translateX(0);opacity:1}to{transform:translateX(-50%);opacity:0}}.faa-parent.animated-hover:hover>.faa-passing-reverse,.faa-passing-reverse.animated,.faa-passing-reverse.animated-hover:hover{animation:passing-reverse 2s linear infinite}.faa-parent.animated-hover:hover>.faa-passing-reverse.faa-fast,.faa-passing-reverse.animated-hover.faa-fast:hover,.faa-passing-reverse.animated.faa-fast{animation:passing-reverse 1s linear infinite}.faa-parent.animated-hover:hover>.faa-passing-reverse.faa-slow,.faa-passing-reverse.animated-hover.faa-slow:hover,.faa-passing-reverse.animated.faa-slow{animation:passing-reverse 3s linear infinite}@keyframes burst{0%{opacity:.6}50%{transform:scale(1.8);opacity:0}to{opacity:0}}.faa-burst.animated,.faa-burst.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-burst{animation:burst 2s infinite linear}.faa-burst.animated-hover.faa-fast:hover,.faa-burst.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-burst.faa-fast{animation:burst 1s infinite linear}.faa-burst.animated-hover.faa-slow:hover,.faa-burst.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-burst.faa-slow{animation:burst 3s infinite linear}.arrow{position:absolute;z-index:10}.arrow:after,.arrow:before{position:absolute;content:\"\";display:block;width:0;height:0;border:9px solid transparent}.arrow:after{border-width:8px}.arrow.top{top:-9px;left:50%;margin-left:-9px}.arrow.top.pull-in{top:-4px}.arrow.top:before{border-bottom-color:rgba(0,0,0,.1);border-top-width:0}.arrow.top:after{top:1px;left:1px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:inherit;border-left-color:transparent;border-top-width:0}.arrow.right{top:50%;right:0;margin-top:-9px}.arrow.right.pull-in{right:5px}.arrow.right:before{border-left-color:rgba(0,0,0,.1);border-right-width:0}.arrow.right:after{top:1px;left:0;border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:inherit;border-right-width:0}.arrow.bottom{bottom:0;left:50%;margin-left:-9px}.arrow.bottom.pull-in{bottom:5px}.arrow.bottom:before{border-top-color:rgba(0,0,0,.1);border-bottom-width:0}.arrow.bottom:after{top:0;left:1px;border-top-color:inherit;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;border-bottom-width:0}.arrow.left{top:50%;left:-9px;margin-top:-9px}.arrow.left.pull-in{left:-4px}.arrow.left:before{border-right-color:rgba(0,0,0,.1);border-left-width:0}.arrow.left:after{top:1px;left:1px;border-top-color:transparent;border-right-color:inherit;border-bottom-color:transparent;border-left-color:transparent;border-left-width:0}.arrow.pull-left{left:18px}.arrow.pull-right{left:auto;right:26px}.arrow.pull-top{top:18px}.arrow.pull-bottom{top:auto;bottom:26px}.arrow.b-accent:before,.arrow.b-danger:before,.arrow.b-dark:before,.arrow.b-info:before,.arrow.b-primary:before,.arrow.b-success:before,.arrow.b-warning:before{border-color:transparent}.box{display:table;table-layout:fixed;border-spacing:0;width:100%;height:100%}.box .box-row{display:table-row;height:100%}.box .box-row .box-cell{position:relative;height:100%;width:100%;-webkit-overflow-scrolling:touch;overflow-x:hidden;box-sizing:border-box}.box .box-col,.ie .box .box-row .box-cell{display:table-cell}.box .box-col{vertical-align:top}.box .box-inner{position:absolute;top:0;bottom:0;left:0;right:0}.box>[class*=\" col-\"],.box>[class*=col-]{vertical-align:top;height:100%;float:none;padding:0;position:static}.v-m{vertical-align:middle!important}.v-t{vertical-align:top!important}.v-b{vertical-align:bottom!important}.v-c{display:-ms-flexbox;display:flex;align-items:center}@media (min-width:1200px){.box>[class*=\" col-lg\"],.box>[class*=col-lg]{display:table-cell}}@media (min-width:992px){.box>[class*=\" col-md\"],.box>[class*=col-md]{display:table-cell}}@media (min-width:768px){.box>[class*=\" col-sm\"],.box>[class*=col-sm]{display:table-cell}}@media (max-width:767px){.box>[class*=\" col-xs\"],.box>[class*=col-xs]{display:table-cell}}.ui-checks{padding-left:20px;cursor:pointer}.ui-checks input{opacity:0;position:absolute;margin-left:-20px}.ui-checks input:checked+i{border-color:#eaeaea}.ui-checks input:checked+i:before{left:4px;top:4px;width:6px;height:6px;background-color:#002f4b}.ui-checks input:checked+span .active{display:inherit}.ui-checks input[type=radio]+i,.ui-checks input[type=radio]+i:before{border-radius:50%}.ui-checks input[disabled]+i,fieldset[disabled] .ui-checks input+i{border-color:#f7f7f7}.ui-checks input[disabled]+i:before,fieldset[disabled] .ui-checks input+i:before{background-color:#f7f7f7}.ui-checks>i{width:16px;height:16px;line-height:1;border:1px solid #eaeaea;background-color:#fff;margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:4px;position:relative}.ui-checks>i:before{content:\"\";position:absolute;left:50%;top:50%;width:0;height:0;background-color:transparent;transition:all .2s}.ui-checks>span{margin-left:-20px}.ui-checks>span .active{display:none}.ui-checks-md input:checked+i:before{left:5px;top:5px}.ui-checks-md>i{width:18px;height:18px}.ui-checks-lg input:checked+i:before{width:12px;height:12px;left:8px;top:8px}.ui-checks-lg>i{width:30px;height:30px}body,html{width:100%;height:100%}.app,body{overflow:hidden}.app{width:100%;height:100%;position:relative}.modal-open .app{overflow:hidden}.app-aside{background-color:#002f4b;bottom:0;box-shadow:0 64px 5px 0 rgba(0,0,0,.26);color:#fff;height:100%;opacity:1;overflow-x:hidden;overflow-y:auto;position:absolute!important;top:0;z-index:60;-webkit-backface-visibility:hidden;backface-visibility:hidden}.app-aside a{color:#fff}.app-aside .leftbarbg,.app-aside>div.sidebar-menu{background-color:rgba(0,0,0,.15)}.app-aside .leftbarbg{background-image:none}.app-content{position:absolute;top:64px;bottom:30px;left:0;right:0;overflow-y:auto}@media (min-width:992px){.app-aside{display:block!important;width:240px}.app-aside.md-closed.hide{transform:translateZ(0)!important}.app-aside.folded{width:64px}.app-aside.folded~.app-content{margin-left:0;margin-top:0}.app-aside:not(.folded):not(.hide)~.app-content{margin-left:240px}.app-aside.md-sidenav-left{min-width:0}.app-aside .left,.app-aside.md-sidenav-left{transform:translateZ(0)!important}}@media (max-width:991px){.app-aside{display:block!important}.app-aside.modal{z-index:1050}.app-aside .left{max-width:304px}.app-padding{padding:4px}}.folded.active,.folded:focus,body .app-aside.folded,body .folded:hover{width:0}body .folded.active .hidden-folded,body .folded .hidden-folded,body .folded:focus .hidden-folded,body .folded:hover .hidden-folded{display:none}.hidden-folded #nav{margin-top:57px}.menu-right{left:231px}.menu-left,.menu-right{position:absolute;z-index:999}.menu-left{left:0}.menu-right-2{left:350px}.menu-left-2,.menu-right-2{position:absolute;z-index:999}.menu-left-2{left:120px}body .breadcrumb{display:block;width:100%!important;padding-top:0;padding-bottom:0;margin-right:0;list-style:none;background-color:#002f4b;cursor:pointer;transition:all .2s cubic-bezier(.645,.045,.355,1);border-radius:0}ol.breadcrumb{margin:0;padding:0;height:35px;display:flex}ol.breadcrumb a,ol.breadcrumb li{display:inline-flex;align-items:center}ol.breadcrumb a{height:35px;border-bottom:4px solid transparent}div.breadcrumb{height:35px;margin-bottom:0}body .breadcrumb a,body .breadcrumb span{font-size:14px;color:#fff}body .breadcrumb span{border-bottom:4px solid #ffaf00;height:35px;padding-top:6px}.breadcrumb>li+li:before{padding:0 5px;color:transparent;content:\"/\\A0\"}@media (max-width:900px){.folded .hidden-folded{display:none}.app-aside.md-sidenav-left{transform:translateZ(0)!important;min-width:0}.app-aside.folded{width:64px}.folded{transition:width .4s cubic-bezier(.25,.8,.25,1);z-index:60}.app-aside{display:block!important;width:240px}.folded.active,.folded:focus,body .folded:hover{width:234px}.folded .nav li .nav-item span,.folded .nav li a span{display:none}.folded .nav li .nav-item .icon,.folded .nav li a .icon{float:none;line-height:50px;margin-right:0;min-width:0}body #aside{top:64px}body.md-sidenav-left.md-closed,body md-sidenav.md-closed{transform:translateZ(0)}.menu-right{left:0!important}.menu-right-2{left:120px!important}}.blue-link{color:#2053d2;text-decoration:underline}.box-row.content-box .row.title{display:flex;align-items:center}.box-row.content-box .row.title h3{margin-top:0}body nav ul.nav li li li.super_menu_li_sub a{padding-left:68px}.font-small,.menu_title,nav ul.nav li li a{font-size:12px}body nav ul.nav li .nav-item>.icon,body nav ul.nav li a>.icon{margin-right:0;min-width:30px}body nav ul.nav li li a{padding-left:58px;padding-bottom:10px;padding-top:10px;overflow:hidden;height:inherit}.draggable-bar>.col-lg-12>ul>li{display:inline-block;padding-right:6px;padding-left:6px;border-right:1px solid #8493ab}.draggable-bar>.col-lg-12{padding:5px}.draggable-bar>.col-lg-12>ul{list-style-type:none;margin-bottom:0}.draggable-bar>.col-lg-12>ul>li>.drag_div>a{font-size:14px;color:#fff}.draggable-bar>.col-lg-12>ul>li{margin-right:1px;background-color:#91a3bd}.draggable-bar>.col-lg-12>ul>li:last-child{border-right:none}.footer{position:fixed;bottom:0;left:0;right:0;background-color:#758295}nav{overflow-x:hidden;width:100%}nav ul.nav li{position:relative}nav ul.nav li li a{line-height:36px;line-height:19px;border-bottom:1px solid transparent}nav ul.nav li li a .badge,nav ul.nav li li a .label{margin-top:10px}nav ul.nav li li li a{padding-left:88px}nav ul.nav li li li li a{padding-left:106px}nav ul.nav li .nav-item,nav ul.nav li a{font-weight:400;text-transform:none;text-align:left;display:block;padding:0 16px;line-height:19px;padding-bottom:10px;padding-top:15px;position:relative;border-radius:0!important}nav ul.nav li .nav-item .text,nav ul.nav li a .text{margin-left:16px}nav ul.nav li .nav-item .up,nav ul.nav li a .up{margin-left:16px;font-style:normal;z-index:1}nav ul.nav li .nav-item>.pull-right i,nav ul.nav li a>.pull-right i{margin-left:16px;transition:transform .3s ease-in-out}nav ul.nav li .nav-item>.icon,nav ul.nav li a>.icon{float:left;line-height:inherit;margin-right:16px;top:0;min-width:40px}nav ul.nav li .nav-item>.icon:before,nav ul.nav li a>.icon:before{width:24px;display:inline-block;text-align:center;opacity:.75}nav ul.nav li .nav-item:focus,nav ul.nav li .nav-item:hover,nav ul.nav li a:focus,nav ul.nav li a:hover{background-color:rgba(0,0,0,.1)}nav ul.nav li label{display:block}nav ul.nav li label i{margin-left:-16px;margin-right:48px}nav ul.nav li.active,nav ul.nav li.active>a{background-color:transparent}nav ul.nav li.active>a>.pull-right i{transform:rotate(180deg)}nav ul.nav.nav-stacked .nav-header,nav ul.nav.nav-stacked a{padding:0 16px;line-height:30px}nav .nav-header{padding:0 16px;line-height:40px}@media (min-width:992px){.folded{transition:width .4s cubic-bezier(.25,.8,.25,1);z-index:60}.folded .nav li ul{display:none}.folded .nav li .nav-item,.folded .nav li a{text-align:center}.folded .nav li .nav-item span,.folded .nav li a span{display:none}.folded .nav li .nav-item .up,.folded .nav li a .up{position:absolute;top:-8px;right:4px}.folded .nav li .nav-item .icon,.folded .nav li a .icon{float:none;line-height:50px;margin-right:0;min-width:0}.folded .nav li .nav-item label i,.folded .nav li a label i{margin-left:-38px;margin-right:0}.folded .navbar-brand{text-align:center}.folded .hidden-folded{display:none}.folded.active,.folded.active>*,.folded:focus,.folded:focus>*,.folded:hover,.folded:hover>*{width:240px}.folded.active .nav li ul,.folded:focus .nav li ul,.folded:hover .nav li ul{display:inherit}.folded.active .nav li .nav-item,.folded.active .nav li a,.folded:focus .nav li .nav-item,.folded:focus .nav li a,.folded:hover .nav li .nav-item,.folded:hover .nav li a{text-align:left}.folded.active .nav li .nav-item span,.folded.active .nav li a span,.folded:focus .nav li .nav-item span,.folded:focus .nav li a span,.folded:hover .nav li .nav-item span,.folded:hover .nav li a span{display:inline}.folded.active .nav li .nav-item .up,.folded.active .nav li a .up,.folded:focus .nav li .nav-item .up,.folded:focus .nav li a .up,.folded:hover .nav li .nav-item .up,.folded:hover .nav li a .up{position:static}.folded.active .nav li .nav-item .icon,.folded.active .nav li a .icon,.folded:focus .nav li .nav-item .icon,.folded:focus .nav li a .icon,.folded:hover .nav li .nav-item .icon,.folded:hover .nav li a .icon{float:left;line-height:inherit;margin-right:22px}.folded.active .nav li label i,.folded:focus .nav li label i,.folded:hover .nav li label i{margin-left:-16px;margin-right:48px}.folded.active .navbar-brand,.folded:focus .navbar-brand,.folded:hover .navbar-brand{text-align:left}.folded.active .hidden-folded,.folded:focus .hidden-folded,.folded:hover .hidden-folded{display:inherit}.folded.active .hidden-folded.inline,.folded:focus .hidden-folded.inline,.folded:hover .hidden-folded.inline{display:inline-block}}.nav-sub{max-height:0;overflow:hidden;transition:max-height .5s cubic-bezier(.35,0,.25,1)}.nav-sub .md-ripple-container{display:none;visibility:hidden}.active>.nav-sub{max-height:999px}.active>.nav-sub .md-ripple-container{display:block;visibility:visible}.i-12{font-size:12px}.i-12,.i-16{vertical-align:-15%}.i-16{font-size:16px}.i-20{font-size:20px;vertical-align:-19%}.i-24{font-size:24px;vertical-align:-23%}.i-28{font-size:28px;vertical-align:-27%}.i-34{font-size:34px;vertical-align:-19%}.ui-icon{display:inline-block;text-align:center;height:1em;background:transparent!important}.ui-icon:before{position:relative;z-index:1}.ui-icon:after{content:\"\";border-width:1px;border-style:solid;border-color:inherit;border-radius:2em;width:2em;height:2em;top:-1.5em;display:block;position:relative;z-index:0;background-clip:padding-box}.ui-icon.b-2x:after{border-width:2px}.ui-icon.b-3x:after{border-width:3px}.ui-icon.ui-icon-sm:after{width:1.7em;height:1.7em;top:-1.35em}.ui-icon.bg-info:after,.ui-icon.bg-primary:after{background-color:#002f4b}.ui-icon.bg-success:after{background-color:#a8c329}.ui-icon.bg-warning:after{background-color:#facb55}.ui-icon.bg-danger:after{background-color:#d7634a}.ui-icon.bg-accent:after{background-color:#ffaf00}.ui-icon.bg-dark:after{background-color:#6f6f6e}.ui-icon.bg-light:after{background-color:#f7f7f7}.ui-icon.bg-white:after{background-color:#fff}.item{position:relative}.item .top{top:0}.item .bottom,.item .top{position:absolute;left:0;right:0}.item .bottom{bottom:0}.item .center{top:50%}.item-overlay,.item .center{position:absolute;left:0;right:0}.item-overlay{display:none;top:0;bottom:0}.item-overlay.active,.item:hover .item-overlay{display:block}.list-icon i{transition:font-size .2s;margin-right:16px}.list-icon div{white-space:nowrap;overflow:hidden}.jqstooltip{background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;border-radius:3px;padding:5px 10px!important;box-sizing:content-box}.easyPieChart{position:relative;text-align:center;display:table}.easyPieChart>div{display:table-cell;vertical-align:middle;position:relative;z-index:1;line-height:1}.easyPieChart>div img{margin-top:-4px}.easyPieChart canvas{position:absolute;top:0;left:0;z-index:0}#flotTip,.flotTip{padding:4px 10px;background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;z-index:100;font-size:12px;color:#fff;border-radius:3px}.legendColorBox>div{border:none!important;margin:5px}.legendColorBox>div>div{border-radius:10px}.st-sort-ascent:before{content:\"\\25B2\"}.st-sort-descent:before{content:\"\\25BC\"}.st-selected td{background:#f0f9ec!important}.ui-select-bootstrap>.ui-select-choices{overflow-y:scroll}.panel .dataTables_wrapper{padding-top:10px}.panel .dataTables_wrapper>.row{margin:0}.panel .dataTables_wrapper>.row>.col-sm-12{padding:0}.dataTables_wrapper.form-inline .form-control{width:auto}.btn-info .text-info{color:#fff}.ie .ie-show{display:block}.nav a.waves-effect{-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 0)}.highcharts-title{font-size:14px!important}.highcharts-container p,.highcharts-container svg,.highcharts-container text{font-family:Open Sans,sans-serif!important;color:#6f6f6e!important}.highcharts-container a p:hover,.highcharts-container a svg:hover,.highcharts-container a text:hover{color:#ffaf00!important}.streamline{position:relative;border-color:#eaeaea}.streamline .sl-item:after,.streamline:after{content:\"\";position:absolute;background-color:#fff;border-color:inherit;border-width:2px;border-style:solid;border-radius:50%;width:11px;height:11px;margin-left:-6px;bottom:0;left:0}.sl-icon{position:absolute;left:-15px;z-index:1}.sl-icon>i{width:30px;height:30px;text-align:center;display:table-cell;vertical-align:middle}.sl-item{border-color:#eaeaea;position:relative;padding-bottom:1px}.sl-item:after,.sl-item:before{content:\" \";display:table}.sl-item:after{clear:both;top:0;bottom:auto}.sl-item.b-l{margin-left:-1px}.sl-item.sl-item-md:after{top:-10px;width:30px;height:30px;margin-left:-16px}.sl-item.sl-item-md .sl-icon{top:-10px}.sl-content{margin-left:24px;margin-top:-6px;padding-bottom:10px}.ui-switch{cursor:pointer;position:relative;display:inline-block;width:32px;height:18px;border-radius:30px;background-color:#a8c329;margin:0}.ui-switch input{position:absolute;opacity:0;filter:alpha(opacity=0)}.ui-switch input:checked+i:before{top:50%;bottom:50%;left:50%;right:5px;border-width:0;border-radius:5px}.ui-switch input:checked+i:after{margin-left:15px}.ui-switch i:before{top:-1px;bottom:-1px;left:-1px;right:-1px;border:1px solid #f0f0f0;border-radius:30px;transition:all .2s}.ui-switch i:after,.ui-switch i:before{content:\"\";position:absolute;background-color:#fff}.ui-switch i:after{width:16px;top:1px;bottom:1px;border-radius:50%;box-shadow:1px 1px 3px rgba(0,0,0,.25);transition:margin-left .3s}.ui-switch-md{width:40px;height:24px}.ui-switch-md input:checked+i:after{margin-left:17px}.ui-switch-md i:after{width:22px}.ui-switch-lg{width:50px;height:30px}.ui-switch-lg input:checked+i:after{margin-left:21px}.ui-switch-lg i:after{width:28px}.timeline{margin:0;padding:0}.tl-item{display:block}.tl-item:after,.tl-item:before{content:\" \";display:table}.tl-item:after{clear:both}.visible-left{display:none}.tl-wrap{display:block;margin-left:6em;padding:15px 0 15px 20px;border-style:solid;border-color:#eaeaea;border-width:0 0 0 2px}.tl-wrap:after,.tl-wrap:before{content:\" \";display:table}.tl-wrap:after{clear:both}.tl-wrap:before{content:\"\";top:15px;margin-left:-26px;width:10px;height:10px;border-color:inherit;border-width:3px;border-radius:50%;border-style:solid;background:#f7f7f7;box-shadow:0 0 0 4px #002f4b}.tl-date,.tl-wrap:before{position:relative;float:left}.tl-date{top:10px;margin-left:-7.5em;display:block;width:4.5em;text-align:right}.tl-content{display:inline-block;position:relative;padding-top:10px;padding-bottom:10px}.tl-content.block{display:block;width:100%}.tl-content.panel{margin-bottom:0}.tl-header{display:block;width:12em;text-align:center;margin-left:1px}.timeline-center .tl-item{margin-left:50%}.timeline-center .tl-item .tl-wrap{margin-left:-2px}.timeline-center .tl-header{width:auto;margin-left:-1px}.timeline-center .tl-left{margin-left:0;margin-right:50%}.timeline-center .tl-left .hidden-left{display:none!important}.timeline-center .tl-left .visible-left{display:inherit}.timeline-center .tl-left .tl-wrap{float:right;margin-right:0;border-left-width:0;border-right-width:2px;padding-left:0;padding-right:20px}.timeline-center .tl-left .tl-wrap:before{float:right;margin-left:0;margin-right:-26px}.timeline-center .tl-left .tl-date{float:right;margin-left:0;margin-right:-8.5em;text-align:left}.content-circules{display:block;float:left;position:relative;margin:0;padding:8px;box-sizing:border-box;height:200px;width:131px}.content-circules:before{position:absolute;content:\"\";border-right:2px solid #ccd0db;top:0;bottom:0;left:49%;z-index:-1px}.content-circules .big-circule{position:relative;display:block;margin:38px;height:120px;width:120px;border:6px solid #aace3b;border-radius:50%;box-sizing:border-box;padding:0}.content-circules .big-circule:before{content:\"\";position:absolute;height:2px;width:70px;background-color:#aace3b;top:49%;left:100%}.content-circules .big-circule:after{content:\"\";position:absolute;height:16px;width:16px;border-radius:50%;background:#aace3b;top:42%;left:170%}.content-circules .big-circule .middle-circule{position:relative;display:block;border-radius:50%;border:4px solid #ccd0db;margin:15px;width:78px;height:78px;box-sizing:border-box;padding:0}.content-circules .big-circule .middle-circule .small-circule{position:relative;display:inline-block;box-sizing:border-box;border-radius:50%;background:linear-gradient(#aace3b,#fab813);margin:15px;height:40px;width:40px;padding:0}.small.content-circules{display:block;float:left;position:relative;margin:0;padding:8px;box-sizing:border-box;height:200px;width:131px}.small.content-circules:before{position:absolute;content:\"\";border-right:2px solid #ccd0db;top:0;bottom:0;left:49%;z-index:-1px}.small.content-circules .big-circule{position:relative;display:block;margin:62px 38px;height:40px;width:40px;border:6px solid #aace3b;border-radius:50%;box-sizing:border-box;padding:0}.small.content-circules .big-circule:before{content:\"\";position:absolute;height:2px;width:17px;background-color:#aace3b;top:49%;left:158%}.small.content-circules .big-circule:after{content:\"\";position:absolute;height:6px;width:6px;border-radius:50%;background:#aace3b;top:42%;left:215%}.small.content-circules .big-circule .middle-circule{position:relative;display:block;border-radius:50%;border:4px solid #ccd0db;margin:-19px;width:67px;height:67px;box-sizing:border-box;padding:0}.small.content-circules .big-circule .middle-circule .small-circule{position:relative;display:inline-block;box-sizing:border-box;border-radius:50%;background:linear-gradient(#aace3b,#fab813);margin:21px;height:15px;width:15px;padding:0}.item-time-line p{display:inline-block;width:46%;float:right;height:auto;overflow:hidden;font-size:12px;position:relative;top:56px;left:-13px}.item-time-line p span{font-size:20px;color:#aace3b;display:block}.block-p{display:block;width:100%;text-align:right}.morado-theme.content-circules .big-circule{border-color:#7e57c2}.morado-theme.content-circules .big-circule:before{background-color:#7e57c2}.morado-theme.content-circules .big-circule:after{background:#7e57c2}.morado-theme.content-circules .big-circule .middle-circule .small-circule{background:linear-gradient(#7e57c2,#2053d2)}.morado-theme.item-time-line p span{color:#7e57c2}.azul-theme.content-circules .big-circule{border-color:#2053d2}.azul-theme.content-circules .big-circule:before{background-color:#2053d2}.azul-theme.content-circules .big-circule:after{background:#2053d2}.azul-theme.content-circules .big-circule .middle-circule .small-circule{background:linear-gradient(#2053d2,#468ac2)}.azul-theme.item-time-line p span{color:#2053d2}@media (max-width:1500px){.item-time-line p{display:inline-block;width:29%;float:right;height:auto;overflow:hidden;font-size:12px;position:relative;top:33px;left:-13px}}@media (max-width:1299px){.small.content-circules{display:none}.item-time-line p{display:block;width:100%;float:left;height:auto;overflow:hidden;font-size:12px;position:relative;top:43px;left:0;text-align:center}}ol.timeline{display:flex;list-style:none;padding:0;margin:0 34px 40px}ol.timeline li{flex-grow:1}ol.timeline li .item{display:flex;align-items:center}ol.timeline li:last-of-type,ol.timeline li:last-of-type .line{flex-grow:0}ol.timeline .circle{height:30px;width:30px;border-radius:100%;border:6px solid #a4a4a4;background-color:#fff;margin:0}ol.timeline .circle.green{border:6px solid #04b404}ol.timeline .line{height:5px;flex-grow:1;background-color:hsla(0,0%,100%,.6)}ol.timeline .line.green{background-color:#04b404}ol.timeline .label-item{width:100px;position:relative;top:30px;right:40px;text-align:center;color:#fff}@media (max-width:768px){li .item,ol.timeline{flex-direction:column}ol.timeline{padding:0 0 10px}}.pvtAxisContainer{background:hsla(0,0%,100%,.34);border:1px solid #e5e9ec;min-height:20px;min-width:20px;padding:10px}.pvtAxisContainer li span.pvtAttr{-moz-box-shadow:0 5px 10px -3px rgba(0,0,0,.15);-webkit-box-shadow:0 5px 10px -3px rgba(0,0,0,.15);-webkit-text-size-adjust:100%;background:#4caf50;border-radius:4px;border:1px solid #45a749;box-shadow:0 5px 10px -3px rgba(0,0,0,.15);color:#fff;padding:7px 10px;white-space:nowrap}.pvtUi button,.pvtUi input,.pvtUi select,.pvtUi textarea{border:1px solid #e3e3e7;box-sizing:border-box;font-family:inherit;font-size:inherit;line-height:inherit;margin:5px;padding:5px}.pvtVals{background:hsla(0,0%,100%,.34);border:1px solid #e5e9ec;min-height:20px;min-width:20px;padding:10px}.pvtRendererArea{padding:15px}table.pvtTable tr td{background-color:transparent;border:1px solid #d9dde1;color:#252525;padding:15px;text-align:center;vertical-align:middle}table.pvtTable tr th{background-color:#00548a;border:1px solid #5489ab;color:#fff;font-size:9pt;font-weight:300;padding:8px 10px}table.pvtTable tr:nth-child(odd){background-color:rgba(66,139,202,.1)}table.pvtTable tr:hover{background-color:rgba(66,139,202,.35)}.pvtTriangle{color:#fff;cursor:pointer;font-size:17pt;vertical-align:middle}.pivot-box{background-color:#fff;border-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.05);box-sizing:border-box;display:block;float:left;height:auto;margin-bottom:25px;min-width:100%;overflow:visible;padding:15px}.cursor-pointer{cursor:pointer}.carousel_element_text{font-size:46px;color:rgba(0,0,0,.35);text-shadow:0 1px rgba(40,46,49,0);font-weight:300}.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}#form-simular .form-group{margin-bottom:0}#form-simular label{text-transform:uppercase;color:#758295;font-size:13px;font-weight:700;display:inline-block}#form-simular input,#form-simular select{width:30%;display:inline-block;margin:0 1%}.slick-list{width:100%;text-align:center;margin:0 auto}body .slick-prev{left:-1px;z-index:5}body .slick-next{right:1px}.nav-bg{cursor:pointer}.nav-bg li{text-align:center}.nav-bg li a,.nav-bg li div{padding:20px}.nav-bg li.active{background:#7e57c2;color:#fff}.nav-bg li.active:after{top:100%;left:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-color:hsla(0,57%,61%,0);border-top-color:#7e57c2;border-width:12px;margin-left:-12px;z-index:1}.nav-bg li.active .badge{background:#aace3b}.slick-selected{background-color:#7e57c2;color:#fff;background-image:url(" + __webpack_require__(1541) + ");background-repeat:no-repeat;background-size:contain;background-position:50%;font-weight:700}.demandPlan{font-size:20px;text-align:center;padding-bottom:0;font-weight:700}.planName{font-weight:400;text-align:center;padding-top:0}@font-face{font-family:Material-Design-Icons;font-weight:400;font-style:normal;src:url(\"/assets/fonts/Material-Design-Icons.eot?-g7cqhn\");src:url(\"/assets/fonts/Material-Design-Icons.eot?#iefix-g7cqhn\") format(\"embedded-opentype\"),url(\"/assets/fonts/Material-Design-Icons.woff?-g7cqhn\") format(\"woff\"),url(\"/assets/fonts/Material-Design-Icons.ttf?-g7cqhn\") format(\"truetype\"),url(\"/assets/fonts/Material-Design-Icons.svg?-g7cqhn#Material-Design-Icons\") format(\"svg\")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:Material-Design-Icons;font-size:20px;line-height:1;opacity:.75;color:grey;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:\"\\E836\"}[dir=rtl] .slick-prev:before{content:\"\\E837\"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:\"\\E837\"}[dir=rtl] .slick-next:before{content:\"\\E836\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}.footable>tfoot .pagination{margin:10px 0!important}#ahoraPuedes-card{position:fixed;bottom:-12px;right:0;display:block;width:100%;z-index:4;text-align:center;box-sizing:border-box;box-shadow:0 0 10px 0 rgba(0,0,0,.15)}#ahoraPuedes-card h4{display:inline-block;color:#000;font-size:14px;margin-right:20px}#ahoraPuedes-card span{margin:0 10px;font-size:13px;position:relative;bottom:-5px;display:inline-block;overflow:hidden}#ahoraPuedes-card span i{margin-right:5px;font-size:20px;position:relative;top:4px}.title-prog h1,.title-prog h2,.title-prog h3,.title-prog h4,.title-prog h5,.title-prog h6{font-size:21px;color:#2053d2;margin-top:0}.c-cantidad ul{list-style:none;margin-bottom:0;-webkit-padding-start:0}.c-cantidad a{color:#468ac2;text-decoration:none;display:inline-block}.c-detalleProg .panel-body{padding-top:10px}.c-detalleProg .panel-body h3{margin-top:0;font-size:16px}.c-detalleProg .panel-body ul{list-style:none;color:#758295;-webkit-padding-start:0}.c-detalleProg .panel-footer{background-color:rgba(70,138,194,.2);padding:5px 15px}.c-detalleProg .panel-footer h5,.c-detalleProg .panel-footer p{display:block;text-align:center}.c-detalleProg .panel-footer p{color:#468ac2;font-size:25px;margin-bottom:0;font-weight:300}.c-detalleProg .panel-footer h5{color:#758295;font-size:14px;margin-top:0}.lista-prog{list-style:none;-webkit-padding-start:0;height:70vh;display:block;overflow:hidden;overflow-y:scroll}.lista-prog li{border-bottom:1px solid grey;position:relative;width:100%;display:block;overflow:hidden;float:left;min-height:70px;height:120px;max-height:180px}.lista-prog li:hover{border-bottom:1px solid #468ac2}.lista-prog li a{position:absolute;width:100%;height:100%;background-color:transparent;color:#6f6f6e;transition:all .5s ease;top:0;left:0;right:0;padding:15px 5px}.lista-prog li a.active,.lista-prog li a:active,.lista-prog li a:hover{background-color:#468ac2;color:#fff}.lista-prog li a span{display:block;font-size:11px}.lista-items-menu{list-style:none;-webkit-padding-start:0;height:70vh;display:block;overflow:hidden;overflow-y:scroll}.lista-items-menu li{border-bottom:1px solid grey;position:relative;width:100%;display:block;overflow:hidden;float:left;height:90px}.lista-items-menu li:hover{border-bottom:1px solid #468ac2}.lista-items-menu li a{position:absolute;width:100%;height:100%;background-color:transparent;color:#6f6f6e;transition:all .5s ease;top:0;left:0;right:0;padding:15px 5px}.lista-items-menu li a.active,.lista-items-menu li a:active,.lista-items-menu li a:hover{background-color:#468ac2;color:#fff}.lista-items-menu li a span{display:block;font-size:11px}.scroll-50vh{overflow:hidden;overflow-y:scroll;height:50vh}.tile{padding:5px}.half-jornada{display:inline-block;float:left;width:50%;box-sizing:border-box;overflow:hidden}.detSim .card-body{padding:5px 24px}.detSim h4{font-size:12px;text-transform:uppercase;font-weight:700}.detSim hr{border-top:1px solid rgba(204,208,219,.5);margin:0}.filtros-carreras{width:100%!important}.filtros-carreras select{width:20%}.filtros-materias{width:100%!important}.filtros-materias select{width:17%}.form-inline .control-label{margin-right:10px}.btn-group>.popover+.btn,.btn-group>.tooltip+.btn{margin-left:-1px}.btn-group>.btn:last-of-type{-moz-border-top-right-radius:3px!important;border-top-right-radius:3px!important;-moz-border-bottom-right-radius:3px!important;border-bottom-right-radius:3px!important}.loading{padding-top:60px;padding-bottom:60px;margin-bottom:15px;background-color:#f0f0f4;height:200px;overflow:hidden}.show-loader{display:block!important}.arrow-right{width:0;height:0;border-top:15px solid transparent;border-bottom:15px solid transparent;border-left:15px solid #aace3b;display:inline-block;position:absolute;top:56px}.c-resumen-config{height:108px}.week-box{width:100%;overflow:hidden;height:160px;padding:10px;box-sizing:border-box;border:1px solid hsla(0,0%,80%,.46)}.md-select-value>span:not(.md-select-icon) .md-text,.week-box{display:block}.loader{border:8px solid #f3f3f3;border-radius:50%;border-top:8px solid #3498db;width:40px;height:40px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.popover.top>.arrow:after{border-top-color:#2053d2!important}.popover.left>.arrow:after{border-left-color:#2053d2!important}.popover.right>.arrow:after{border-right-color:#2053d2!important}.popover.bottom>.arrow:after{border-bottom-color:#2053d2!important}.popover{color:#fff;font-size:10px;background-color:#2053d2!important;border:1px solid #2053d2!important}.bg-white{background-color:#fff}.bg-light{background-color:#f7f7f7}.bg-light.lt{background-color:#fff!important}.bg-light .lt{background-color:#fff}.bg-light.dk{background-color:#ebe9e9!important}.bg-light .dk{background-color:#ebe9e9}.bg-light.bg{background-color:#f7f7f7!important}.bg-light .bg{background-color:#f7f7f7}.bg-dark{color:hsla(0,0%,100%,.87);background-color:#6f6f6e}.bg-dark.lt{background-color:#7b7b7b!important}.bg-dark .lt{background-color:#7b7b7b}.bg-dark.dk{background-color:#67675c!important}.bg-dark .dk{background-color:#67675c}.bg-dark.bg{background-color:#6f6f6e!important}.bg-dark .bg{background-color:#6f6f6e}.bg-primary{color:hsla(0,0%,100%,.87);background-color:#002f4b}.bg-primary.lt{background-color:#033e62!important}.bg-primary .lt{background-color:#033e62}.bg-primary.dk{background-color:#001f32!important}.bg-primary .dk{background-color:#001f32}.bg-primary.bg{background-color:#002f4b!important}.bg-primary .bg{background-color:#002f4b}.bg-success{color:hsla(0,0%,100%,.87);background-color:#a8c329}.bg-success.lt{background-color:#b3ce38!important}.bg-success .lt{background-color:#b3ce38}.bg-success.dk{background-color:#99b31f!important}.bg-success .dk{background-color:#99b31f}.bg-success.bg{background-color:#a8c329!important}.bg-success .bg{background-color:#a8c329}.bg-info{color:hsla(0,0%,100%,.87);background-color:#002f4b}.bg-info.lt{background-color:#033e62!important}.bg-info .lt{background-color:#033e62}.bg-info.dk{background-color:#001f32!important}.bg-info .dk{background-color:#001f32}.bg-info.bg{background-color:#002f4b!important}.bg-info .bg{background-color:#002f4b}.bg-warning{color:hsla(0,0%,100%,.87);background-color:#facb55}.bg-warning.lt{background-color:#f7d172!important}.bg-warning .lt{background-color:#f7d172}.bg-warning.dk{background-color:#fec637!important}.bg-warning .dk{background-color:#fec637}.bg-warning.bg{background-color:#facb55!important}.bg-warning .bg{background-color:#facb55}.bg-danger{color:hsla(0,0%,100%,.87);background-color:#d7634a}.bg-danger.lt{background-color:#d77864!important}.bg-danger .lt{background-color:#d77864}.bg-danger.dk{background-color:#d94d2f!important}.bg-danger .dk{background-color:#d94d2f}.bg-danger.bg{background-color:#d7634a!important}.bg-danger .bg{background-color:#d7634a}.bg-accent{color:hsla(0,0%,100%,.87);background-color:#ffaf00}.bg-accent.lt{background-color:#f9b51f!important}.bg-accent .lt{background-color:#f9b51f}.bg-accent.dk{background-color:#e69d00!important}.bg-accent .dk{background-color:#e69d00}.bg-accent.bg{background-color:#ffaf00!important}.bg-accent .bg{background-color:#ffaf00}a.bg-primary:hover{background-color:#001f32}a.text-primary:hover{color:#001f32}.text-primary{color:#002f4b}.text-primary-lt{color:#003f65}.text-primary-dk{color:#001f32}a.bg-info:hover{background-color:#001f32}a.text-info:hover{color:#001f32}.text-info{color:#002f4b}.text-info-lt{color:#003f65}.text-info-dk{color:#001f32}a.bg-success:hover{background-color:#96ae25}a.text-success:hover{color:#96ae25}.text-success{color:#a8c329}.text-success-lt{color:#b7d432}.text-success-dk{color:#96ae25}a.bg-warning:hover{background-color:#f9c33c}a.text-warning:hover{color:#f9c33c}.text-warning{color:#facb55}.text-warning-lt{color:#fbd36e}.text-warning-dk{color:#f9c33c}a.bg-danger:hover{background-color:#d25135}a.text-danger:hover{color:#d25135}.text-danger{color:#d7634a}.text-danger-lt{color:#dc755f}.text-danger-dk{color:#d25135}a.bg-accent:hover{background-color:#e69d00}a.text-accent:hover{color:#e69d00}.text-accent{color:#ffaf00}.text-accent-lt{color:#ffb71a}.text-accent-dk{color:#e69d00}a.bg-dark:hover{background-color:#626261}a.text-dark:hover{color:#626261}.text-dark{color:#6f6f6e}.text-dark-lt{color:#7c7c7b}.text-dark-dk{color:#626261}.text-white{color:#fff}.text-white-lt{color:hsla(0,0%,100%,.54)}.text-white-dk{color:hsla(0,0%,100%,.87)}.text-black{color:#000}.text-black-lt{color:rgba(0,0,0,.54)}.text-black-dk{color:rgba(0,0,0,.87)}.text-muted{color:inherit;opacity:.75}.text-muted-dk{color:inherit;opacity:.5}.text-muted-lt{color:inherit;opacity:.25}.text-color{color:#494948}.bg-big:before{content:\"\";position:absolute;width:100%;top:0;bottom:0;z-index:-1;background-color:inherit;border:inherit}.bg-white-overlay{background-color:hsla(0,0%,100%,.8)}.bg-black-overlay{background-color:rgba(32,43,54,.8)}.no-bg{background-color:transparent;color:inherit}@media (min-width:768px){.bg-auto:before{content:\"\";position:absolute;width:inherit;top:0;bottom:0;z-index:-1;background-color:inherit;border:inherit}.bg-auto.b-l:before{margin-left:-1px}.bg-auto.b-r:before{margin-right:-1px}}.ui-grid{border:0 solid #91a3bd}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button>i{color:#fff}.ui-grid-scrollbar-placeholder{background-color:transparent}.ui-grid-cell:not(:last-child) .ui-grid-vertical-bar,.ui-grid-header-cell:last-child .ui-grid-vertical-bar,.ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{background-color:#91a3bd}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:last-child{border-right-color:#4c87ad}.ui-grid-top-panel-background{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0)}.ui-grid-column-menu-button-last-col{margin-right:2px!important}input[type=text].ui-grid-filter-input{padding:0;margin:0;border:0;width:100%;padding:2px 5px;border-radius:3px!important;border:0 solid #91a3bd;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}select.ui-grid-filter-select{border:0 solid #91a3bd;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0}select.ui-grid-filter-select:hover{border:0 solid #91a3bd}.ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:#fff}.ui-grid-row:nth-child(2n) .ui-grid-cell{background-color:rgba(76,135,173,.13)}.ui-grid-row:last-child .ui-grid-cell{border-bottom-color:#91a3bd;border-bottom-style:solid}.ui-grid-no-row-overlay{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0);-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box;border:0 solid #91a3bd;font-size:2em;text-align:center}.ui-grid-no-row-overlay>*{position:absolute;display:table;margin:auto 0;width:100%;top:0;bottom:0;left:0;right:0;opacity:.66}.ui-grid-cell{background-color:inherit;border-right:0 solid;border-color:#91a3bd}.ui-grid-cell:last-child{border-right:0}.ui-grid-cell-contents-hidden{visibility:hidden;width:0;height:0;display:none}.ui-grid-row .ui-grid-cell.ui-grid-row-header-cell{background-color:#e8eff4;border-bottom:0 solid #e8eff4}.ui-grid-footer-panel,.ui-grid-footer-panel-background{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0)}.ui-grid-footer-panel{position:relative;border-bottom:1px solid #91a3bd;border-top:1px solid #91a3bd;overflow:hidden;font-weight:700;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}.ui-grid-footer-cell{background-color:inherit;border-right:0 solid;border-color:#91a3bd}input[type=text].ui-grid-filter-input{background:hsla(0,0%,100%,.3)}input[type=text].ui-grid-filter-input:hover{border:0 solid #91a3bd}.ui-grid-menu-button{cursor:pointer;color:#fff}.ui-grid-menu-button,.ui-grid-menu .ui-grid-menu-inner{background:#4c87ad;border:0 solid #4c87ad}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{color:#333;text-decoration:none}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled],fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled,fieldset[disabled] a.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button{pointer-events:none}.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{color:transparent;background-color:transparent;border-color:transparent}.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active{background-image:none}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled].focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled]:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled]:hover,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{background-color:transparent;border-color:transparent}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button .badge{color:transparent;background-color:transparent}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button>i{opacity:.75;color:#000}.ui-grid-menu .ui-grid-menu-inner ul{margin:0;padding:0;list-style-type:none}.ui-grid-menu .ui-grid-menu-inner ul li{padding:0}.ui-grid-menu .ui-grid-menu-inner ul li button{min-width:100%;padding:8px;text-align:left;background:transparent;border:none}.ui-grid-menu .ui-grid-menu-inner ul li button:focus,.ui-grid-menu .ui-grid-menu-inner ul li button:hover{box-shadow:inset 0 0 14px rgba(0,0,0,.12)}.ui-grid-menu .ui-grid-menu-inner ul li button.ui-grid-menu-item-active{box-shadow:inset 0 0 14px rgba(0,0,0,.12);background-color:#4c87ad}.ui-grid-menu .ui-grid-menu-inner ul li:not(:last-child)>button{border-bottom:0 solid #91a3bd}.ui-grid-sortarrow{right:5px;position:absolute;width:20px;top:0;bottom:0;background-position:50%}.ui-grid-sortarrow.down{transform:rotate(180deg)}[class*=\" ui-grid-icon\"]:before,[class^=ui-grid-icon]:before{font-family:ui-grid;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em}.ui-grid-icon-blank:before{width:1em;content:\" \"}.ui-grid[dir=rtl] .ui-grid-cell,.ui-grid[dir=rtl] .ui-grid-footer-cell,.ui-grid[dir=rtl] .ui-grid-header-cell{float:right!important}.ui-grid[dir=rtl] .ui-grid-column-menu-button{position:absolute;left:1px;top:0;right:inherit}.ui-grid[dir=rtl] .ui-grid-cell:first-child,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child{border-right:0}.ui-grid[dir=rtl] .ui-grid-cell:last-child,.ui-grid[dir=rtl] .ui-grid-header-cell:last-child{border-right:0 solid #e8eff4;border-left:0}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-cell:last-child{box-sizing:border-box;border-right:1px solid;border-width:1px;border-right-color:#e8eff4}.ui-grid[dir=rtl] .ui-grid-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child .ui-grid-vertical-bar{width:0}.ui-grid[dir=rtl] .ui-grid-menu-button{z-index:2;position:absolute;left:0;right:auto;background:#91a3bd;border:0 solid #91a3bd;cursor:pointer;min-height:27px;font-weight:400}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button,.ui-grid[dir=rtl] .ui-grid-menu-button .ui-grid-menu{left:0;right:auto}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button [class^=ui-grid-icon]{right:auto;left:10px}.ui-grid-animate-spin{animation:ui-grid-spin 2s infinite linear;display:inline-block}@keyframes ui-grid-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.light-table .ui-grid-header-cell{position:relative;box-sizing:border-box;background-color:#dcdfef;border-right:1px solid;border-color:#c5cae4;display:table-cell;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:0;color:#333}.light-table .ui-grid-top-panel{position:relative;overflow:hidden;font-weight:700;background-color:#dcdfef}.ui-grid-header{border-bottom:1px solid #c5cae4;box-sizing:border-box}select.ui-grid-filter-select{padding:0;margin:0;border:0;background:hsla(0,0%,100%,.3);padding:5px;border:0 solid #a7abae;background-clip:padding-box;border-radius:3px!important}select.ui-grid-filter-select option{color:#758295}.t-h40 md-switch{margin:0;height:auto}.t-h40 .ui-grid-cell-contents{height:40px}.fc-toolbar h2{color:#468ac2;font-size:18px}.fc-unthemed .fc-divider,.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}td.fc-time,th.fc-day-header{color:#758295}.fc-time-grid .fc-slats td{height:3.5em;border-bottom:0}.fc-state-default{background-color:#fff;background-image:none;background-repeat:repeat-x;border-color:#e6e6e6 #e6e6e6 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#91a3bd;text-shadow:0 1px 1px hsla(0,0%,100%,.75);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05)}.bg-green-web-planner{background:#aace3b}.bg-green-web-planner,.bg-purple-web-planner{border:1px solid #fff;float:left;width:100%;color:#fff;font-size:10px;opacity:.95}.bg-purple-web-planner{background:#6a0888}.tooltip-inner{max-width:500px!important}.werapper_button md-radio-button{display:inline-block;font-size:11px}.hh{width:95%}.u-select-overflow-hide{overflow:hidden}.u-btn-align-label{margin-top:25px}md-input-container{width:100%}body .cal-day-box .cal-day-hour-part .cal-day-hour-part-time{width:20px}.headersidebar{padding-right:0}.headersidebar h5{font-size:12px}mwl-calendar .cal-row-fluid:hover,mwl-calendar [class*=cal-cell]:hover{background-color:#2053d2}.cal-week-box [data-event-class]{white-space:normal!important;height:30px;padding-top:0!important;margin-top:0!important;margin-bottom:0!important;font-size:12px;padding:0 3px!important;line-height:18px;text-align:center;display:flex;align-items:center;border-radius:6px!important;border:1px solid #fff}.capitalize{text-transform:capitalize}.f-none{float:none}.prog.nav-tabs{overflow-x:auto;overflow-y:hidden;display:-webkit-box;display:-moz-box}.prog.nav-tabs>li{float:none}.effect-highlight-purple{transition:all .5s ease}.effect-highlight-purple:hover{background-color:#7e57c2;color:#fff;width:100%;border-radius:3px}.effect-highlight-purple:hover .yellow-hover-icon,.yellow-hover-icon:hover{color:#ff0}.effect-highlight-purple--active{background-color:#7e57c2;color:#fff;width:100%;border-radius:3px}.effect-highlight-purple--active .yellow-hover-icon{color:#ff0}.list-h{display:block;overflow:hidden;padding-left:0}.list-h li{display:inline-block;padding:5px;padding-left:0;padding-right:25px}.list-h li span{color:#468ac2}.tabla-horarios td{border-right:1px solid #e7e8ea;border-bottom:1px solid #e7e8ea}.red-text-table{color:#ef7955}.gris-text-table,.red-text-table{font-weight:700;pointer-events:none}.gris-text-table{color:#787878}.amarillo-text-table{color:#fc0;font-weight:700;cursor:pointer}.green-text-table{color:#aace3b;font-weight:700;pointer-events:none}.visibility{pointer-events:none;cursor:default;text-decoration:none;color:#999}.select2-container{width:100%}.date-picker{width:100%;height:34px;padding-left:5px}.editable-wrap{display:inline-block;white-space:nowrap;margin:0;width:100%}.disabled-style{-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%);-ms-filter:grayscale(100%);-o-filter:grayscale(100%);cursor:not-allowed}.scroll-55vh{height:55vh!important}.scroll-55vh,.scroll-60vh{overflow:hidden;overflow-y:scroll}.scroll-60vh{height:60vh!important}.scroll-65vh{height:65vh!important}.scroll-65vh,.scroll-70vh{overflow:hidden;overflow-y:scroll}.scroll-70vh{height:70vh!important}.scroll-75vh{height:75vh!important}.scroll-75vh,.scroll-80vh{overflow:hidden;overflow-y:scroll}.scroll-80vh{height:80vh!important}.fc-event .fc-content{height:100%}.postit{line-height:1;text-align:center;width:275px;margin:25px;min-height:250px;max-height:250px;position:relative;border:1px solid #e8e8e8;font-size:22px;border-bottom-right-radius:60px 5px;display:inline-block}.postit:after{content:\"\";position:absolute;z-index:-1;right:0;bottom:20px;width:200px;height:25px;background:rgba(0,0,0,.2);box-shadow:2px 15px 5px rgba(0,0,0,.4);transform:matrix(-1,-.1,0,1,0,0)}.yellow{border-top:60px solid #fdfd86;background:#ff8}.purple{border-top:60px solid #9b7cd0;background:#9b7cd0}.red{border-top:60px solid #df826e;background:#df826e}.rotate-3{transform:rotate(-3deg);-webkit-transform:rotate(-3deg);-moz-transform:rotate(-3deg);-o-transform:rotate(-3deg)}.icon-bg{background-image:url(" + __webpack_require__(1542) + ");background-repeat:no-repeat;background-size:initial;background-position:100% 100%}.chevrons{font-family:Material-Design-Icons}.chevrons :after{content:\"\\E89D\"}.chevrons :after,.chevrons :before{display:block;position:absolute;top:50%;right:0;width:10px;height:1px;background-color:#2196f3;transform-origin:50% 50%;will-change:transform;transition:all .25s}.chevrons :before{content:\"\\E89E\"}.panel-heading .accordion-toggle:after{font-family:Material-Design-Icons;content:\"\\E89D\";float:right;color:grey;font-size:24px}.panel-heading .accordion-toggle.collapsed:after{content:\"\\E89E\"}.fade-in-out{transition:all 1s linear;opacity:1}.fade-in-out.ng-hide{opacity:0}.hh{position:absolute;z-index:99999;bottom:0;width:93%}.hover-morado:hover{background-color:#7e57c2;color:#fff}.brd-md,.brd-xl{border-radius:3px}.control-label{margin-top:5px;font-weight:500;font-size:14px}.b-success{border-color:#aace3b!important}.list-horizontal{padding-left:0;list-style:none}.list-vert-trans{list-style:none;-webkit-padding-start:0;height:75vh;overflow-y:auto}.list-vert-trans li{padding:16px 5px;cursor:pointer;background:transparent;transition:all .5s ease;border-left:3px solid transparent;border-bottom:1px solid hsla(0,0%,100%,.2)}.list-vert-trans li:hover{padding:18px 5px;cursor:pointer;background:rgba(0,0,0,.15);border-left:3px solid #468ac2}.list-vert-trans li.active i,.list-vert-trans li:hover i{color:#468ac2}.list-vert-trans li.active{padding:18px 5px;cursor:pointer;border-left:3px solid transparent;background:rgba(0,0,0,.15);font-weight:500}.list-vert-trans li p{padding-left:10px;margin-bottom:0;display:inline-block}.list-vert-trans li p:first-letter{text-transform:capitalize}.no-rows{position:absolute;top:0;bottom:0;width:100%;background:rgba(0,0,0,.4)}.no-rows .msg{position:absolute;top:20%;left:20%;width:60%;height:50%;line-height:200%;background-color:transparent;border:0;text-align:center;font-size:24px;display:table;color:#fff}.no-rows .msg span{display:table-cell;vertical-align:middle}.dpl-b,.w-100{display:block}.w-100{width:100%;overflow:hidden}.text-editable{color:#758295}.pos-rlt{position:relative;z-index:1}.pos-abt{position:absolute}.pos-fix{position:fixed!important}.pos-stc{position:static!important}.block{display:block}.block.hide{display:none}.flex{display:flex}.align-self-end{align-self:flex-end}.align-items-center{align-items:center}.flex-direction-column{flex-direction:column}.flex-wrap-wrap{flex-wrap:wrap}.pull-none{float:none}.inline{display:inline-block}.inline-16{width:16px;height:16px}.inline-24{width:24px;height:24px}.active>.auto .inline,.active>.inline,.none{display:none}.active>.auto .none,.active>.none{display:inline-block}.line{height:1px;margin:10px 0;font-size:0;overflow:hidden}.line-dashed{border-style:dashed!important;background-color:transparent;border-width:0}.pointer{cursor:pointer}.circle,.rounded{border-radius:500px}.clear{display:block;overflow:hidden}.align_center{display:block;margin:auto}.align-calendars{margin-left:-18px}.flex-center{display:flex;align-items:center}.no-border{border-color:transparent;border-width:0}.no-borders{border-width:0!important}.b{border-color:hsla(210,4%,45%,.15)!important}.b-a{border:1px solid #eaeaea}.b-t{border-top:1px solid #eaeaea}.b-r{border-right:1px solid #eaeaea}.b-b{border-bottom:1px solid #eaeaea}.b-l{border-left:1px solid #eaeaea}.b-2x{border-width:2px}.b-3x{border-width:3px}.b-4x{border-width:4px}.b-5x{border-width:5px}.b-t-2x{border-top-width:2px!important}.b-t-3x{border-top-width:3px!important}.b-t-4x{border-top-width:4px!important}.b-t-5x{border-top-width:5px!important}.b-r-2x{border-right-width:2px!important}.b-r-3x{border-right-width:3px!important}.b-r-4x{border-right-width:4px!important}.b-r-5x{border-right-width:5px!important}.b-b-2x{border-bottom-width:2px!important}.b-b-3x{border-bottom-width:3px!important}.b-b-4x{border-bottom-width:4px!important}.b-b-5x{border-bottom-width:5px!important}.b-l-2x{border-left-width:2px!important}.b-l-3x{border-left-width:3px!important}.b-l-4x{border-left-width:4px!important}.b-l-5x{border-left-width:5px!important}.b-light{border-color:#f7f7f7}.b-white{border-color:#fff}.b-primary{border-color:#002f4b}.b-t-primary{border-top-color:#002f4b}.b-r-primary{border-right-color:#002f4b}.b-b-primary{border-bottom-color:#002f4b}.b-l-primary{border-left-color:#002f4b}.b-info{border-color:#002f4b}.b-t-info{border-top-color:#002f4b}.b-r-info{border-right-color:#002f4b}.b-b-info{border-bottom-color:#002f4b}.b-l-info{border-left-color:#002f4b}.b-success{border-color:#a8c329}.b-t-success{border-top-color:#a8c329}.b-r-success{border-right-color:#a8c329}.b-b-success{border-bottom-color:#a8c329}.b-l-success{border-left-color:#a8c329}.b-warning{border-color:#facb55}.b-t-warning{border-top-color:#facb55}.b-r-warning{border-right-color:#facb55}.b-b-warning{border-bottom-color:#facb55}.b-l-warning{border-left-color:#facb55}.b-danger{border-color:#d7634a}.b-t-danger{border-top-color:#d7634a}.b-r-danger{border-right-color:#d7634a}.b-b-danger{border-bottom-color:#d7634a}.b-l-danger{border-left-color:#d7634a}.b-accent{border-color:#ffaf00}.b-t-accent{border-top-color:#ffaf00}.b-r-accent{border-right-color:#ffaf00}.b-b-accent{border-bottom-color:#ffaf00}.b-l-accent{border-left-color:#ffaf00}.b-dark{border-color:#6f6f6e}.b-t-dark{border-top-color:#6f6f6e}.b-r-dark{border-right-color:#6f6f6e}.b-b-dark{border-bottom-color:#6f6f6e}.b-l-dark{border-left-color:#6f6f6e}.no-b-t{border-top-width:0}.no-b-r{border-right-width:0}.no-b-b{border-bottom-width:0}.no-b-l{border-left-width:0}.b-dashed{border-style:dashed!important}.border-radio-left{border-radius:200px 0 10px 200px}@media (max-width:991px){.no-border-sm{border-width:0}}@media (max-width:767px){.no-border-xs{border-width:0}}.b-b-azul{border:2px solid #2053d2;border-bottom:2px solid #2053d2}.b-b-azul-light{border-bottom:2px solid #468ac2}.b-b-amarillo{border-bottom:2px solid #fab813}.b-b-verde{border-bottom:2px solid #aace3b}.b-b-gris-dark{border-bottom:2px solid #91a3bd}.b-t-gris-light{border-top:1px solid #ccd0db}.b-b-gris-darker{border-bottom:2px solid #758295}.b-b-rojo{border-bottom:2px solid #ef7955}.b-b-morado{border-bottom:2px solid #7e57c2}.b-b-blanco{border-bottom:2px solid #fff}.b-b-gris-lighter{border-bottom:2px solid #f2f5f7}.b-b-negro-darker{border-bottom:2px solid #2d3039}.b-r-gris-light{border-right:1px solid #ccd0db}.b-l-gris-light{border-left:1px solid #ccd0db}.b-b-gris-light{border-bottom:1px solid #ccd0db}.hover-action{display:none}.hover-rotate{transition:all .2s ease-in-out .1s}.hover-anchor:active .hover-action,.hover-anchor:focus .hover-action,.hover-anchor:hover .hover-action{display:inherit}.hover-anchor:active .hover-rotate,.hover-anchor:focus .hover-rotate,.hover-anchor:hover .hover-rotate{transform:rotate(45deg)}.hover14 figure{position:relative;overflow:hidden}.hover14 figure:before{position:absolute;top:0;left:-75%;z-index:2;display:block;content:\"\";width:50%;height:100%;background:linear-gradient(90deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,.3));transform:skewX(-25deg)}.hover14 figure:hover:before{animation:shine .75s}@keyframes shine{to{left:125%}}.no-margin{margin:0!important}.m{margin:16px}.m-xs{margin:4px}.m-sm{margin:8px}.m-md{margin:24px}.m-lg{margin:32px}.m-15{margin:15px}.m-v-xs{margin-top:4px;margin-bottom:4px}.m-v-sm{margin-top:8px;margin-bottom:8px}.m-v{margin-top:16px;margin-bottom:16px}.m-v-md{margin-top:24px;margin-bottom:24px}.m-v-lg{margin-top:32px;margin-bottom:32px}.m-h-xs{margin-left:4px;margin-right:4px}.m-h-sm{margin-left:8px;margin-right:8px}.m-h{margin-left:16px;margin-right:16px}.m-h-md{margin-left:24px;margin-right:24px}.m-h-lg{margin-left:32px;margin-right:32px}.m-t{margin-top:16px}.m-t-xs{margin-top:4px}.m-t-sm{margin-top:8px}.m-t-md{margin-top:24px}.m-t-lg{margin-top:32px}.m-t-xlg{margin-top:80px!important}.m-t-radio-execution{margin-top:calc(100% - 60px)!important}.m-r{margin-right:16px}.m-r-xs{margin-right:4px}.m-r-sm{margin-right:8px}.m-r-md{margin-right:24px}.m-r-lg{margin-right:32px}.no-m-r{margin-right:0}.m-r-xl{margin-right:32px}.m-b{margin-bottom:16px}.m-b-xs{margin-bottom:4px}.m-b-sm{margin-bottom:8px}.m-b-md{margin-bottom:24px}.m-b-lg{margin-bottom:32px}.m-b-button{margin-bottom:64px}.m-l{margin-left:16px}.m-l-xs{margin-left:4px}.m-l-sm{margin-left:8px}.m-l-md{margin-left:24px}.m-l-lg{margin-left:32px}.m-l-button{margin-left:147px}.no-m-l{margin-left:0}.m-n{margin:-16px}.m-h-n{margin-left:-16px;margin-right:-16px}.m-v-n{margin-top:-16px;margin-bottom:-16px}.m-l-n{margin-left:-16px}.m-r-n{margin-right:-16px}.m-t-n{margin-top:-16px}.m-t-n-sm{margin-top:-4px}.m-b-n{margin-bottom:-16px}.no-m-t{margin-top:0!important}.no-m-b{margin-bottom:0}.no-m-l{margin-left:0!important}.no-m-r{margin-right:0!important}.no-padding{padding:0!important}.no-padding-h{padding-left:0!important;padding-right:0!important}.no-padding-v{padding-bottom:0!important}.no-padding-t,.no-padding-v,.p-t-0{padding-top:0!important}.no-padding-b,.p-b-0{padding-bottom:0!important}.no-padding-r,.p-r-0{padding-right:0!important}.no-padding-l,.p-l-0{padding-left:0!important}.p-xs{padding:4px}.p-sm{padding:8px}.p{padding:16px}.p-md{padding:24px}.p-lg{padding:32px}.p-r{padding-right:8px}.p-r-md{padding-right:24px}.p-r-lg{padding-right:32px}.p-h{padding-left:16px;padding-right:16px}.p-h-xs{padding-left:4px;padding-right:4px}.p-h-sm{padding-left:8px;padding-right:8px}.p-h-md{padding-left:24px;padding-right:24px}.p-h-lg{padding-left:32px;padding-right:32px}.p-v{padding-top:16px;padding-bottom:16px}.p-v-xs{padding-top:4px;padding-bottom:4px}.p-v-sm{padding-top:8px;padding-bottom:8px}.p-v-md{padding-top:24px;padding-bottom:24px}.p-v-lg{padding-top:32px;padding-bottom:32px}.p-v-xl{padding-bottom:55px}.p-t-xl,.p-v-xl{padding-top:55px}.p-t{padding-top:15px}.p-t-12{padding-top:12px}.p-t-md{padding-top:24px}.p-t-lg{padding-top:32px}.p-t-xs{padding-top:8px}.p-b{padding-bottom:15px}.p-b-md{padding-bottom:24px}.p-b-lg{padding-bottom:32px}.p-b-xs{padding-bottom:8px}.p-t-sm{padding-top:8px}.p-t-ss{padding-top:5px}.p-b-sm{padding-bottom:8px}.p-l{padding-left:16px}.p-l-sm{padding-left:8px}.p-l-md{padding-left:24px!important}.p-l-lg{padding-left:32px}.p-l-cal{padding-left:64px}.p-l-xl{padding-left:35px!important}.no-padding-h{padding-left:0;padding-right:0}.p-btn-lg,.padding-box{padding:15px}.padding{padding:32px}.padding-out{margin:-32px}@media (max-width:992px){.padding{padding:16px}.padding-out{margin:-16px}}@media (max-width:767px){.padding{padding:8px}.padding-out{margin:-8px}}.no-radius{border-radius:0!important}.no-r-t{border-top-left-radius:0}.no-r-r,.no-r-t{border-top-right-radius:0}.no-r-b,.no-r-r{border-bottom-right-radius:0}.no-r-b,.no-r-l{border-bottom-left-radius:0}.no-r-l{border-top-left-radius:0}.r{border-radius:3px}.r-t{border-top-left-radius:3px}.r-r,.r-t{border-top-right-radius:3px}.r-b,.r-r{border-bottom-right-radius:3px}.r-b,.r-l{border-bottom-left-radius:3px}.r-l{border-top-left-radius:3px}.r-2x{border-radius:6px}.r-3x{border-radius:9px}.scrollable{overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}.scrollable.hover{overflow-y:hidden!important}.scrollable.hover>*{margin-top:-1px}.scrollable.hover:hover{overflow:visible!important;overflow-y:auto!important}.smart .scrollable{overflow-y:auto!important}.scroll-x,.scroll-y{overflow:hidden;-webkit-overflow-scrolling:touch}.scroll-y{overflow-y:auto}.scroll-x{overflow-x:auto}.no-shadow{box-shadow:none!important}.box-shadow{box-shadow:0 1px 3px rgba(0,0,0,.05)}.box-shadow-md{box-shadow:0 3px 5px rgba(0,0,0,.05)}.box-shadow-lg{box-shadow:0 5px 10px rgba(0,0,0,.05)}.box-shadow-inset{box-shadow:inset 0 -3px 0 rgba(0,0,0,.15)}.text-shadow{text-shadow:0 4px 0 rgba(0,0,0,.1)}.l-h{line-height:1.42857143}.l-h-1x{line-height:1}.l-h-2x{line-height:2em}.l-s-1x{letter-spacing:1}.l-s-2x{letter-spacing:2}.l-s-3x{letter-spacing:3}.h-1x{height:20px}.h-2x{height:40px}.h-3x{height:60px}.h-4x{height:80px}.font-normal{font-weight:400}.font-thin{font-weight:300}.font-medium{font-weight:500}.font-semibold{font-weight:600}.font-bold{font-weight:700}.font-italic{font-style:italic}.font-test{text-align:justify}.text-4x{font-size:4em}.text-3x{font-size:3em}.text-2x{font-size:2em}.text-xl{font-size:32px}.text-lg{font-size:24px}.text-md{font-size:16px}.text-base{font-size:14px}.text-sm{font-size:13px}.text-sm-important{font-size:13px!important}.text-xs{font-size:12px}.text-xs-important{font-size:12px!important}.text-xxs{font-size:10px}.text-xxs-important{font-size:10px!important}.text-u-c{text-transform:uppercase}.text-l-t{text-decoration:line-through}.text-u-l{text-decoration:underline}.text-16-important{font-size:16px!important}.text-20{font-size:20px}.text-ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.text-fade{position:relative;overflow:hidden}.text-fade:after{content:\"\";text-align:right;position:absolute;bottom:0;right:0;width:70%;height:1.2em;background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff 50%)}.no-select{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (min-width:768px) and (max-width:991px){.text-center-sm{text-align:center}.text-left-sm{text-align:left}.text-right-sm{text-align:right}}@media (max-width:767px){.text-center-xs{text-align:center}.text-left-xs{text-align:left}.text-right-xs{text-align:right}}.text-right{text-align:right!important}.text-left{text-align:left!important}.text-center{text-align:center!important}md-tabs.capitalize md-tab-item span{text-transform:capitalize}.vertical-align-sm{vertical-align:-13%}.h5,h5{font-size:16px}.text-padd{padding-top:4px}.w-16{width:16px;height:16px}.w-20{width:20px;height:20px}.w-24{width:24px;height:24px}.w-32{width:32px;height:32px}.w-40{width:40px;height:40px}.w-48{width:48px;height:48px}.w-56{width:56px;height:56px}.w-64{width:64px;height:64px}.w-xxl{width:60px}.w-xs{width:90px}.w-sm{width:120px}.w{width:180px}.w-md{width:200px}.w-lg{width:240px}.w-xl{width:280px}.w-xxl{width:320px}.w-full{width:100%}.w-auto{width:auto}.h-auto{height:auto}.h-full{height:100%}@media (max-width:991px){.w-auto-sm{width:auto}.w-full-sm{width:100%}}@media (max-width:767px){.w-auto-xs{width:auto}.w-full-xs{width:100%}}md-grid-list{margin-bottom:4px}.panel-heading h3{margin-top:0;margin-bottom:0;font-size:20px}.no-brd{border:transparent}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{vertical-align:middle}.footable.breakpoint>tbody>tr>td>span.footable-toggle{padding-right:12px!important;color:#facb55!important}.footable.breakpoint>tbody>tr>td>span.footable-toggle:before{content:\"\\E011\"}.footable.breakpoint>tbody>tr.footable-detail-show>td>span.footable-toggle:before{content:\"\\E00F\"}.detail{background-image:url(" + __webpack_require__(1541) + ");background-repeat:no-repeat;background-size:contain;background-position:100%}.v-line,div.navbar-brand-top-menu{background-repeat:no-repeat;background-size:contain;background-position:0;display:inline-block}div.navbar-brand-top-menu{background-image:url(" + __webpack_require__(1543) + ");width:128px;margin:10px 20px 0;height:47px}.app-content-header{height:45px;overflow:hidden;color:#f7f7f7}.app-content-header a{color:#f7f7f7}.app-content-header .navbar{background-color:#353942;border-radius:0}.leftbarbg{background-image:url(" + __webpack_require__(1544) + ");background-size:cover}.image_portal{background-image:url(" + __webpack_require__(294) + ");width:64px;height:65px!important;background-size:100%;background-repeat:no-repeat}.image_profile_blog_comments{width:32px;height:32px!important}.image_profile_blog,.image_profile_blog_comments{background-size:100%;background-repeat:no-repeat;margin-top:5px}.image_profile_blog{width:100px;height:100px!important;box-shadow:0 8px 6px -6px #000}.mainActivityDetails .leftActivityDetailsCheck{display:none}body .bg-review .leftActivityDetailsCheck span{color:#dad7d7!important}body .bg-review .leftActivityDetailsCheck .md-check>i:before{border:2px solid #dad7d7!important}.mdi-navigation-menu{font-size:32px}.box-inner{padding-top:0}.background-planning{background-color:#002f4b;background-image:url(" + __webpack_require__(1545) + ");background-repeat:no-repeat;background-position:50%;background-size:cover;color:#fff}.background-planning:before{content:\"\";background:linear-gradient(to bottom right,#000,#005f98);bottom:0;left:0;opacity:.85;position:absolute;right:0;top:0}.fullscreen .app-aside.folded~.app-content{margin-top:0}.grid-workplan{width:100%;min-height:307px!important;max-height:800px!important;border:0;background-color:rgba(212,239,255,.1);border-radius:2px}.grid-workplan .ui-grid-viewport{overflow:auto!important}.grid-workplan .ui-grid-canvas{width:100%!important;margin-right:0}.grid-workplan .ui-grid-cell{height:auto!important}.grid-workplan .ui-grid-row:nth-child(2n) .ui-grid-cell,.grid-workplan .ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent!important}.grid-workplan .ui-grid-header-cell,.grid-workplan .ui-grid-top-panel{background:transparent!important}.grid-workplan .ui-grid-cell-contents{font-family:proxima-nova;font-size:14px;font-weight:300;opacity:.85;letter-spacing:1px;color:#fff}.grid-workplan .ui-grid-row{display:flex;min-height:60px!important;height:auto!important;padding-top:20px;padding-bottom:20px;border-bottom:1px solid hsla(0,0%,100%,.4)}.grid-workplan .ui-grid-header-cell-label{font-family:Exo!important;font-size:16px;font-weight:700;letter-spacing:0!important;opacity:1}.grid-committee{width:100%;min-height:307px!important;max-height:800px!important;border:0;background-color:rgba(212,239,255,.1);border-radius:2px}.grid-committee .ui-grid-render-container-body .ui-grid-viewport{width:100%!important;overflow-x:hidden!important}.grid-committee .ui-grid-canvas{width:100%!important;margin-right:0}.grid-committee .ui-grid-cell{height:auto!important}.grid-committee .ui-grid-row:nth-child(2n) .ui-grid-cell,.grid-committee .ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent!important}.grid-committee .ui-grid-header-cell,.grid-committee .ui-grid-top-panel{background:transparent!important}.grid-committee .ui-grid-cell-contents{font-family:proxima-nova;font-size:14px;font-weight:300;opacity:.85;letter-spacing:1px;color:#fff;text-overflow:ellipsis;overflow-x:hidden}.grid-committee .ui-grid-row{display:flex;min-height:60px!important;height:auto!important;padding-top:20px;padding-bottom:20px;border-bottom:1px solid hsla(0,0%,100%,.4)}.grid-committee .ui-grid-header-cell-label{font-family:Exo!important;font-size:16px;font-weight:700;letter-spacing:0!important;opacity:1}.intro-message{width:60%;margin:0 auto}.intro-message span{display:block;width:70%;margin:0 auto}.intro-message h1{font-size:24px;font-weight:700;line-height:35px;letter-spacing:1px}.btn-fullscreen.btn.btn-success{display:block;letter-spacing:1px;margin:32px auto 0;border-radius:150px}::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px transparent;border-radius:10px;background-color:transparent}::-webkit-scrollbar{width:12px;background-color:transparent}::-webkit-scrollbar-thumb{border-radius:10px;-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.1);background-color:rgba(0,0,0,.3)}::-webkit-scrollbar-corner{background:transparent}#content.content-fullscreen{margin:0!important}.search .btn{border-left-width:0;left:-1px;box-shadow:none;z-index:2;border-color:#e5e5e5}.search .search-btn{padding:5px}.search .input-group-btn>.btn:focus,.search .input-group-btn>.btn:hover{background-color:#fff!important;cursor:auto}.autocomplete input,.autocomplete md-autocomplete,.search-autocomplete input,.search-autocomplete md-autocomplete,.search input{height:36px!important}.autocomplete md-autocomplete,.search-autocomplete md-autocomplete{border:1px solid #e5e5e5}.autocomplete .md-whiteframe-z1,.search-autocomplete .md-whiteframe-z1{box-shadow:none}.search input:focus{border-color:#e5e5e5}.search-autocomplete i,.search .btn i{opacity:.5}md-dialog textarea{min-height:60px!important}.content-activities{display:flex;flex-direction:row;flex-wrap:wrap}.inline-activity{flex:1 50%;display:flex;text-align:left;align-items:flex-start}.search-autocomplete i{position:absolute;right:7px;top:6px}.search-sutocomplete .form-group{position:relative}.datepicker-select{width:200px}.datepicker-select .md-datepicker-input{padding-top:5px}md-autocomplete[md-clear-button=false] button{display:none}.radio-options{display:flex;align-items:center;margin-top:26px;flex-wrap:wrap}.radio-options div{padding:10px 13px 10px 40px;position:relative}.radio-options i{position:relative;display:inline-block;width:0;height:18px;margin-top:-2px;margin-right:28px;margin-left:-20px;line-height:1;vertical-align:middle}.radio-options i:before{position:absolute;width:18px;height:100%;border:2px solid rgba(0,0,0,.54);border-radius:2px;content:\"\";transition:all .2s}.radio-options input{position:absolute;z-index:1;width:20px;height:20px;margin-left:-20px;cursor:pointer;opacity:0}.radio-options input[type=radio]+i,.radio-options input[type=radio]+i:before{border-radius:50%}.radio-options input:checked+i:before{background-color:inherit;border-width:0}.radio-options input[type=radio]:checked+i:after{position:absolute;top:6px;left:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.radio-green{background-color:#aace3b;color:#fff}.categories .mdi-content-add,.categories .mdi-content-remove{opacity:1;padding-right:5px}.select-inline{display:flex;align-items:center}.datepicker-select{padding-left:8px;float:left;border:1px solid #e5e5e5;margin-right:20px;margin-top:10px;width:100%}.datepicker-select .md-datepicker-input{min-width:176px;padding-bottom:2px;width:100%;height:34px}.datepicker-select .md-datepicker-input-container{border:0;width:100%;position:relative;height:30px;padding-left:6px}.datepicker-select .md-datepicker-triangle-button.md-button.md-icon-button{right:9px;top:6px;width:34px;height:34px;padding:0}.btn-cancel{background-color:#f7f7f7;border-color:#eaeaea}md-datepicker .md-button.md-icon-button{margin:0}.form-control{padding-left:4px}.form-control:focus,md-input-container:not(.md-input-invalid).md-input-focused .md-input,textarea.md-input,textarea.md-input:active,textarea.md-input:focus{border:1px solid hsla(0,0%,80%,.86)}.has-error textarea.md-input,.has-error textarea.md-input:active,.has-error textarea.md-input:focus{border:1px solid #a94442}md-input-container.md-default-theme.md-input-invalid .md-char-counter,md-input-container.md-default-theme.md-input-invalid .md-input-message-animation,md-input-container.md-default-theme.md-input-invalid label,md-input-container.md-input-invalid .md-char-counter,md-input-container.md-input-invalid .md-input-message-animation,md-input-container.md-input-invalid label{color:#a94442}md-input-container.md-input-focused .md-input,md-input-container.md-input-resized .md-input,md-input-container .md-input.ng-invalid.ng-dirty{border-width:1px}.slick-track,.slider{height:auto}.slick-next,.slick-prev{width:60px!important;height:60px!important}.slick-next:before,.slick-prev:before{font-size:50px!important;text-shadow:1px 1px 8px rgba(0,0,0,.2)}body .slick-prev{left:-46px!important}body .slick-next{right:-46px!important}@media (min-width:1360px) and (max-width:1919px){.card.horizontal,.slick-slide{height:330px!important}.slick-list{height:340px!important}.slick-oblique .slick-list{height:460px!important}.slick-oblique .slick-list .card{height:478px}.slick-oblique .slick-list .card-heading{min-height:auto}.slick-oblique-medium .slick-list{height:460px!important}.slick-oblique-medium .slick-list .card{height:410px}.slick-oblique-medium .slick-list .card-heading{max-height:140px}.slick-oblique-large .slick-list{height:540px!important}.slick-oblique-large .slick-list .card{height:520px}.slick-oblique-large .slick-list .card-heading{max-height:140px}.long{height:180px}}@media (max-width:1920px){.card.horizontal,.slick-slide{height:330px!important}.slick-list{height:340px!important}.slick-oblique .slick-list{height:484px!important}.slick-oblique .slick-list .card{height:480px}.slick-oblique .slick-list .card-heading{min-height:auto}.slick-oblique-medium .slick-list{height:460px!important}.slick-oblique-medium .slick-list .card{height:410px}.slick-oblique-medium .slick-list .card-heading{max-height:120px}.slick-oblique-large .slick-list{height:540px!important}.slick-oblique-large .slick-list .card{height:520px}.slick-oblique-large .slick-list .card-heading{max-height:125px}}.slick-oblique .hours{position:absolute;border-radius:50px;width:75px;right:7px;bottom:-16px}.slick-oblique .period{height:100px}.slick-oblique-large .hours{position:absolute;border-radius:50px;width:75px;right:7px;bottom:-16px}.slick-oblique .card-body{height:226px}.slick-oblique .card-heading.hidden-content{overflow:hidden}.slick-oblique-large .card-body.long{height:282px;overflow:hidden}.slick-oblique-large .card-heading{height:140px}.slick-oblique-header{height:200px}.card.horizontal{display:flex;box-shadow:0 0 8px rgba(0,0,0,.15);border-radius:15px}.card.horizontal .first-content{overflow:hidden;min-height:110px;display:flex;flex-direction:column;justify-content:center}.card.horizontal .card-heading{display:flex;flex-direction:column;justify-content:center;min-width:200px}.card.horizontal .card-heading p{max-height:150px;overflow:hidden;margin-top:0}.card.horizontal .card-body{text-align:left;padding:16px 24px}.card.horizontal .list-items{list-style:none}.card.horizontal .btn{width:100%}.card-border-radius{box-shadow:0 0 8px rgba(0,0,0,.15);border-radius:20px}@media (min-width:992px){.card.horizontal .list-items{height:160px;overflow:hidden}}@media (min-width:1360px) and (max-width:1919px){.card.horizontal .list-items{height:160px;overflow:hidden}}@media (min-width:1920px){.card.horizontal .list-items{height:160px;overflow:hidden}.color-cards .card-heading{padding:55px}.color-cards .card-body{padding:32px}.color-cards .card-heading .icon{font-size:50px}.color-cards .card-body h5{font-size:16px}}.brd-md{border-radius:20px}.i-40{font-size:40px;vertical-align:-39%}.color-cards .box-shadow{box-shadow:0 2px 14px rgba(0,0,0,.2)}.profile-cards .box-shadow{box-shadow:0 2px 4px #ccc}.profile-cards .fixed-height-300{height:300px;overflow-y:scroll;overflow-x:hidden;position:relative}.profile-cards .fixed-height-800{height:800px;overflow-y:scroll;overflow-x:hidden;position:relative}.profile-cards .grad-white{content:\"\";position:absolute;bottom:0;left:0;right:16px;height:50px;z-index:10;background:transparent;background:-webkit-gradient(color-stop(0,hsla(0,0%,98%,0)),color-stop(100%,#f9f9f9));background:linear-gradient(hsla(0,0%,98%,0),#f9f9f9);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"transparent\",endColorstr=\"#f9f9f9\",GradientType=1)}.blog-statement{box-shadow:0 2px 4px #ccc}.blog-statement .html-text{height:179px;overflow-y:scroll;position:relative}.dialog-statement{height:200px;overflow-y:auto;position:relative;padding:10px 0;color:#6f6f6e!important}.dialog-statement a{color:#ffaf00!important;text-decoration:underline}.dialog-statement.row{text-align:left}.fixed-height-345{height:345px;overflow-y:scroll;position:relative}.fixed-height-250{height:250px;overflow-y:scroll;position:relative}.masonry-cols-2{column-count:2;column-gap:10px}.masonry-cols-4{column-count:4;column-gap:10px}.masonry-break{break-inside:avoid-column;page-break-inside:avoid}md-dialog{max-width:40%;padding-bottom:30px}md-toolbar{background-color:transparent!important;min-height:30px}md-dialog .icon{display:block;color:#263238}md-dialog .add-button .icon{color:#fff}.md-toolbar-tools{flex-direction:row-reverse;padding:0;height:30px}.md-toolbar-tools .md-icon-button{padding:0;height:20px;width:30px;align-self:flex-start}.md-toolbar-tools>.md-button:last-child{margin-right:0}md-dialog .row{text-align:center;padding:5px 20px;margin:0}md-dialog .row h3,md-dialog .row h4{margin:0 0 10px}md-dialog .row1 h3,md-dialog .row1 h4{color:#ef7955;margin:0 0 10px}md-dialog .row1{text-align:center;padding:5px 64px;margin:0}md-dialog a i{font-size:70px;padding:25px;display:block;width:120px;height:120px;border-radius:100%;margin:0 auto;color:#fff!important;margin-bottom:10px}md-dialog .row .create a{color:#aace3b}md-dialog .row .clone a{color:#2053d2}md-dialog .row .create a i{background-color:#aace3b}md-dialog .row .clone a i{background-color:#2053d2}md-dialog .with-bullets{list-style:none}md-dialog .with-bullets li{position:relative}md-dialog .with-bullets li:before{width:8px;height:8px;margin-right:5px;background-color:#2053d2;border-radius:100%;padding:1px;content:\"\";position:absolute;top:5px;left:-14px;right:0;bottom:0}.column-right{text-align:right}.column-center{text-align:center}.column-left{text-align:left}.ui-grid-cell-contents{padding:5px 10px;box-sizing:border-box;white-space:nowrap;-ms-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;height:100%;font-size:12px}.ui-grid-cell-contents a{color:#ffaf00}.ui-grid-header-cell{background-color:#2053d2;color:#fff;border-right:0 solid;border-color:#91a3bd}.ui-grid-top-panel{font-weight:700;background:#2053d2;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0);-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}.grid-btn{margin:0;border-radius:2px;min-height:10px;min-width:130px;padding:0;font-size:12px;height:22px;line-height:1.5;font-weight:400;font-family:proxima-nova!important}.grid-darker-gray .ui-grid-header-cell,.grid-darker-gray .ui-grid-top-panel{background-color:#758295}.grid-darker-gray .ui-grid-row.ui-grid-row-selected>[ui-grid-row]>.ui-grid-cell{background-color:#2053d2;color:#fff}.grid-darker-gray .ui-grid-viewport ng-isolate-scope{border-left:1px solid #f2f5f7}.grid-blue .ui-grid-cell-contents{padding-bottom:0}.grid-blue input[type=text].ui-grid-filter-input{border-radius:0!important}.grid-blue .ui-grid-pager-panel{background-color:#ccd0db;font-size:12px}.grid-blue .ui-grid-pager-panel button{background-color:transparent}.grid-blue .ui-grid-pager-panel .ui-grid-pager-count-container{float:left;margin-left:16px;margin-top:6px}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control input,.grid-blue .ui-grid-pager-panel .ui-grid-pager-row-count-picker select{background-color:hsla(0,0%,100%,.5)}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control .first-triangle{border-width:4px 7.7px 4px 0}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control .last-triangle{border-width:4px 0 4px 7.7px}.grid-blue .cell-button .ui-grid-cell-contents{padding:0!important}.grid-blue .grid-with-button .ui-grid-row{height:35px}.ui-grid-viewport{overflow-anchor:none}.custom-tooltip{font-size:12px;font-weight:700}.custom-s-tooltip,.custom-tooltip{background-color:#000!important;color:#fff!important}.custom-s-tooltip{font-size:10px}.md-toast-content{background:#2053d2!important}.squarerify{border-radius:0!important}.opacity-4{opacity:.4}.transparent{background-color:hsla(0,0%,100%,.2)}.close-text{line-height:12px}.word-wrap{word-wrap:break-word}.custom-autoselect .md-icon{top:35%}.list{border-bottom:1px solid #e5e5e5;overflow:hidden;margin-bottom:8px}.strip-btn{background:none;border:none}.activityTag{border-radius:5px;padding:4px 5px;min-width:68px;cursor:default;text-align:center;max-height:40px;font-size:11px}.w-h-100{width:100%;height:100%}.list-h{height:65vh;overflow-y:auto}.text-block{display:inline-block}.left{float:left}.right{float:right}.bg-review{background:#5700da}.rightDivider{border-right:1px solid #e5e5e5;height:auto}.verticalDivider{border-left:1px solid #e5e5e5;height:50vw}.horizontalDivider,.teacherList{border-bottom:1px solid #e5e5e5}.teacherList{color:#aace3b}.teacherList p{display:inline-block;color:rgba(0,0,0,.87);width:88%}.list a,.teacherList .md-button{color:#e5e5e5}.dark-icon{color:rgba(0,0,0,.87)}.webeditor .btn{padding:5.8px;border:none}.webeditor .btn-toolbar{margin:0}.webeditor .btn-toolbar,.webeditor .text-angular-toolbar{background:rgba(0,0,0,.1)}.webeditor .ta-scroll-window.form-control,.webeditor .ta-scroll-window>.ta-bind{min-height:150px}.webeditor .ta-scroll-window.form-control a,.webeditor .ta-scroll-window>.ta-bind a{color:#ffaf00;text-decoration:underline}.webeditor .ta-toolbar{background-color:#ccd0db}.webeditor .ta-toolbar button{background-color:transparent}.webeditor .ta-toolbar button.active{background-color:#91a3bd!important;box-shadow:none}.webeditor .ta-toolbar button.active i{color:#fff}.webeditor .ta-toolbar i{color:#353942}.long-datepicker input{margin:3px 15px 2px;padding:0}.long-datepicker .md-datepicker-input-container{display:block;border:none!important}.long-datepicker .md-datepicker-input-container .md-datepicker-expand-triangle{left:75%}.tab-title-with-form{background:#f2f5f7;height:75px;align-self:flex-end;border-top-left-radius:16px;border-top-right-radius:16px}.parametersLister{border-top:2px solid #e5e5e5;padding:8px 0}.parametersLister .bullet{margin:0;border-radius:50%;width:15px;height:15px;background:#2053d2}.parametersLister p{display:inline;color:rgba(0,0,0,.87);width:80%;line-height:12px;margin:0}.parametersLister button{float:right}md-tabs.default-tabs.md-default-theme md-ink-bar,md-tabs.default-tabs md-ink-bar{color:#000;background-color:#ffaf00}md-tabs.default-tabs.md-default-theme .md-tab,md-tabs.default-tabs.md-default-theme .md-tab.md-active,md-tabs.default-tabs.md-default-theme .md-tab.md-active md-icon,md-tabs.default-tabs.md-default-theme .md-tab.md-focused,md-tabs.default-tabs.md-default-theme .md-tab.md-focused md-icon,md-tabs.default-tabs .md-tab,md-tabs.default-tabs .md-tab.md-active,md-tabs.default-tabs .md-tab.md-active md-icon,md-tabs.default-tabs .md-tab.md-focused,md-tabs.default-tabs .md-tab.md-focused md-icon{color:#263238;font-weight:400;font-size:14px}md-tabs.md-default-theme .md-tab.md-active,md-tabs.md-default-theme .md-tab.md-active md-icon,md-tabs.md-default-theme .md-tab.md-focused,md-tabs.md-default-theme .md-tab.md-focused md-icon,md-tabs .md-tab.md-active,md-tabs .md-tab.md-active md-icon,md-tabs .md-tab.md-focused,md-tabs .md-tab.md-focused md-icon{color:#263238}md-tabs.md-default-theme md-ink-bar,md-tabs md-ink-bar{color:#263238;background:#aace3b}md-tab-item.md-tab{color:#546e7a;background-color:#fff}.with-bullets,.without-bullets{list-style:none}.with-bullets li{position:relative}.with-bullets li:before{width:8px;height:8px;margin-right:5px;background-color:#aace3b;border-radius:100%;padding:1px;content:\"\";position:absolute;top:16px;left:6px;right:0;bottom:0}.with-bullets.bullets-md li:before{top:8px}textarea{resize:none}.without-bullets li{position:relative;padding:8px 0}.without-bullets li button{position:absolute;right:0}.mdinputcontainerwrapper,.mdinputcontainerwrapper md-input-container{padding-bottom:0;margin-bottom:0}.mdinputcontainerwrapper label{color:#000}.rounded-list .list-title{max-height:42px;overflow:hidden}.rounded-list .detail{max-height:40px;overflow:hidden}.max-height{max-height:130px;overflow:hidden}.div-father{position:relative}.div-gris{background-color:#f2f2f2;width:95%;opacity:.5}.div-green,.div-gris{height:11px;margin-left:15px;position:absolute;border-radius:200px 200px 200px 200px;top:64%;left:0;right:100%;bottom:100%}.div-green{background-color:#04b404;width:150px}.tl-radio{background-color:#a4a4a4;border-radius:50px;bottom:60%;height:30px;top:0;right:0;width:30px}.radio-planification{left:0}.radio-approval{left:33%}.radio-execution{left:66%}.radio-evaluation{left:100%}.radio-white{background-color:#fff;width:18px;height:18px;position:relative;top:19%;left:20%;right:0;bottom:60%;border-radius:50px}.tl-square{background-color:transparent;width:80px;height:30px;position:absolute;top:0;right:0;bottom:100%}.square-planification{left:0}.square-approval{left:33%}.square-execution{left:66%}.square-evaluation{left:95%}.tl-label{margin-left:-22%}.teaching{color:#fff;margin-top:80px}.underscore{text-decoration:underline;cursor:pointer}.disabled{pointer-events:none;cursor:default}.autocomplete{box-shadow:inset 0 1px 1px rgba(0,0,0,.075);height:34px;border:1px solid #ccc}.projectTypeTag{border-radius:5px;padding:0 4px;min-width:68px;cursor:default;height:20px;text-align:center;line-height:20px}.activity_checkbox md-checkbox.md-checked .md-icon,.activity_checkbox md-checkbox.md-default-theme.md-checked .md-icon{background-color:#7abf15}.activity_checkbox{margin-top:10px;text-align:center}.img-container{height:0;display:inline-block;padding:0 25px 0 0;border-right:32px solid transparent;border-bottom:148px solid #4082b9;line-height:50px}.capitalize{text-transform:none}.md-tab,md-tabs.capitalize md-tab-item span{text-transform:inherit}@media (max-width:1753px){.img-container{border-bottom:159px solid #4082b9}}@media (max-width:1700px){.img-container{border-bottom:180px solid #4082b9}.img-container img.img-circle{margin-top:22px;margin-left:10px}}@media (max-width:1430px){.img-container{border-bottom:190px solid #4082b9;padding:0}.img-container img.img-circle{margin-top:22px;margin-left:-33px}}@media (max-width:991px){.img-container{border-bottom:148px solid #4082b9;padding:0}}md-checkbox,md-checkbox.md-checked .md-icon:after{-webkit-backface-visibility:hidden;backface-visibility:hidden}md-checkbox.md-checked .md-icon:after{box-sizing:border-box;transform:rotate(45deg);position:absolute;left:4.66667px;top:.22222px;display:table;width:6.66667px;height:13.33333px;border-width:2px;border-style:solid;border-top:0;border-left:0;content:\"\"}.bg-grey{background:#758295;cursor:not-allowed}.projectVisibilityTag{height:auto}.loading-details{position:absolute;top:0;left:0;height:100%;width:100%;padding-top:20%;z-index:999}table.table.table-no-bordered tr>td{border-top:inherit}tspan{font-size:inherit}md-dialog{max-width:100%;width:60%;max-height:95%}.comments{max-height:390px;overflow-y:auto}.comments .body-comment p,.comments .header-comment p{text-align:left}.comment-response{padding-left:40px}.comment-response .item-comment.ng-scope{border-left:6px solid rgba(64,55,189,.52)}.body-comment .comments-actions>a{margin-left:12px}.card-heigth{height:330px!important}.tooltip-multiline{height:auto}dl{display:grid;grid-gap:10px;grid-template-columns:1fr 1fr;margin-bottom:10px}dl p{margin-bottom:0}#loading-bar .bar{background:#ffaf00;height:3px;border-top:1px solid #ffc74d;border-radius:0 200px 200px 0;border-right:1px solid #ffc74d;box-shadow:0 2px 10px 0 rgba(0,0,0,.5);z-index:10002!important}#loading-bar-spinner{display:none;top:50%;left:50%}#loading-bar-spinner .spinner-icon{width:40px;height:40px;border:3px solid transparent;border-top-color:#ffaf00;border-left-color:#ffaf00;border-radius:50px;animation:loading-bar-spinner .8s linear infinite}.internal-diagram.c100 .bar{position:absolute;border:none;width:1em;height:1em;clip:rect(0,.5em,1em,0);border-radius:50%;transform:rotate(0deg)}.internal-diagram.c100.p51 .fill,.internal-diagram.c100.p52 .fill,.internal-diagram.c100.p53 .fill,.internal-diagram.c100.p54 .fill,.internal-diagram.c100.p55 .fill,.internal-diagram.c100.p56 .fill,.internal-diagram.c100.p57 .fill,.internal-diagram.c100.p58 .fill,.internal-diagram.c100.p59 .fill,.internal-diagram.c100.p60 .fill,.internal-diagram.c100.p61 .fill,.internal-diagram.c100.p62 .fill,.internal-diagram.c100.p63 .fill,.internal-diagram.c100.p64 .fill,.internal-diagram.c100.p65 .fill,.internal-diagram.c100.p66 .fill,.internal-diagram.c100.p67 .fill,.internal-diagram.c100.p68 .fill,.internal-diagram.c100.p69 .fill,.internal-diagram.c100.p70 .fill,.internal-diagram.c100.p71 .fill,.internal-diagram.c100.p72 .fill,.internal-diagram.c100.p73 .fill,.internal-diagram.c100.p74 .fill,.internal-diagram.c100.p75 .fill,.internal-diagram.c100.p76 .fill,.internal-diagram.c100.p77 .fill,.internal-diagram.c100.p78 .fill,.internal-diagram.c100.p79 .fill,.internal-diagram.c100.p80 .fill,.internal-diagram.c100.p81 .fill,.internal-diagram.c100.p82 .fill,.internal-diagram.c100.p83 .fill,.internal-diagram.c100.p84 .fill,.internal-diagram.c100.p85 .fill,.internal-diagram.c100.p86 .fill,.internal-diagram.c100.p87 .fill,.internal-diagram.c100.p88 .fill,.internal-diagram.c100.p89 .fill,.internal-diagram.c100.p90 .fill,.internal-diagram.c100.p91 .fill,.internal-diagram.c100.p92 .fill,.internal-diagram.c100.p93 .fill,.internal-diagram.c100.p94 .fill,.internal-diagram.c100.p95 .fill,.internal-diagram.c100.p96 .fill,.internal-diagram.c100.p97 .fill,.internal-diagram.c100.p98 .fill,.internal-diagram.c100.p99 .fill,.internal-diagram.c100.p100 .fill{width:1em;height:1em;border:none;border-color:inherit}.internal-diagram.c100:hover>span{color:#91a3bd}.principal-diagram.c100{border:.08em solid hsla(0,0%,98%,.3);background-color:transparent;box-shadow:0 0 22px -4px rgba(0,0,0,.75)}.principal-diagram.c100:after{top:-.08em;left:-.08em;background-color:transparent;width:1em;height:1em}.principal-diagram.c100 .slice{top:-.08em;left:-.08em}.principal-diagram.c100 .bar{top:0;left:0;right:0;bottom:0}.principal-diagram.c100>span{left:-.32em;top:-.6em;bottom:-.32em;right:.16em}.c100.big{font-size:190px}.c100.md{font-size:100px}.c100.sm{font-size:65px}.c100.xs{font-size:40px}.disabled.c100.green:hover>span{color:#ccc}.disabled.c100:hover>span{width:5em;line-height:5em;font-size:.2em}@media (min-width:980px) and (max-width:1200px){.c100.big{font-size:135px}.c100.big h4{font-size:10px!important}.c100.big .m-t-radio-execution{margin-top:61%!important}}.bar.b-rojo{border:.08em solid #ef7955}.bar.b-azul{border:.08em solid #2053d2}.bar.b-verde{border:.08em solid #aace3b}.bar.b-morado{border:.08em solid #7e57c2}.bar.b-naranja{border:.08em solid #ff9800}.col-lg-1-5,.col-md-1-5,.col-sm-1-5,.col-xs-1-5{position:relative;min-height:1px;padding-right:10px;padding-left:10px}.col-xs-1-5{width:20%;float:left}.c100.red .bar,.c100.red .fill{border-color:#d7634a!important}.c100.red:hover>span{color:#d7634a}.c100.red.dark .bar,.c100.red.dark .fill{border-color:#b71c1c!important}.c100.red.dark:hover>span{color:#b71c1c}.c100.pink .bar,.c100.pink .fill{border-color:#e91e63!important}.c100.pink:hover>span{color:#e91e63}.c100.pink.dark .bar,.c100.pink.dark .fill{border-color:#880e4f!important}.c100.pink.dark:hover>span{color:#880e4f}.c100.purple .bar,.c100.purple .fill{border-color:#9c27b0!important}.c100.purple:hover>span{color:#9c27b0}.c100.purple.dark .bar,.c100.purple.dark .fill{border-color:#4a148c!important}.c100.purple.dark:hover>span{color:#4a148c}.c100.deep-purple .bar,.c100.deep-purple .fill{border-color:#673ab7!important}.c100.deep-purple:hover>span{color:#673ab7}.c100.deep-purple.dark .bar,.c100.deep-purple.dark .fill{border-color:#311b92!important}.c100.deep-purple.dark:hover>span{color:#311b92}.c100.indigo .bar,.c100.indigo .fill{border-color:#3f51b5!important}.c100.indigo:hover>span{color:#3f51b5}.c100.indigo.dark .bar,.c100.indigo.dark .fill{border-color:#1a237e!important}.c100.indigo.dark:hover>span{color:#1a237e}.c100.blue .bar,.c100.blue .fill{border-color:#00548a!important}.c100.blue:hover>span{color:#00548a}.c100.blue.dark .bar,.c100.blue.dark .fill{border-color:#0d47a1!important}.c100.blue.dark:hover>span{color:#0d47a1}.c100.light-blue .bar,.c100.light-blue .fill{border-color:#468ac2!important}.c100.light-blue:hover>span{color:#468ac2}.c100.light-blue.dark .bar,.c100.light-blue.dark .fill{border-color:#01579b!important}.c100.light-blue.dark:hover>span{color:#01579b}.c100.cyan .bar,.c100.cyan .fill{border-color:#00bcd4!important}.c100.cyan:hover>span{color:#00bcd4}.c100.cyan.dark .bar,.c100.cyan.dark .fill{border-color:#006064!important}.c100.cyan.dark:hover>span{color:#006064}.c100.teal .bar,.c100.teal .fill{border-color:#009688!important}.c100.teal:hover>span{color:#009688}.c100.teal.dark .bar,.c100.teal.dark .fill{border-color:#004d40!important}.c100.teal.dark:hover>span{color:#004d40}.c100.green .bar,.c100.green .fill{border-color:#4caf50!important}.c100.green:hover>span{color:#4caf50}.c100.green.dark .bar,.c100.green.dark .fill{border-color:#1b5e20!important}.c100.green.dark:hover>span{color:#1b5e20}.c100.light-green .bar,.c100.light-green .fill{border-color:#8bc34a!important}.c100.light-green:hover>span{color:#8bc34a}.c100.light-green.dark .bar,.c100.light-green.dark .fill{border-color:#33691e!important}.c100.light-green.dark:hover>span{color:#33691e}.c100.lime .bar,.c100.lime .fill{border-color:#a8c329!important}.c100.lime:hover>span{color:#a8c329}.c100.lime.dark .bar,.c100.lime.dark .fill{border-color:#827717!important}.c100.lime.dark:hover>span{color:#827717}.c100.yellow .bar,.c100.yellow .fill{border-color:#ffeb3b!important}.c100.yellow:hover>span{color:#ffeb3b}.c100.yellow.dark .bar,.c100.yellow.dark .fill{border-color:#f57f17!important}.c100.yellow.dark:hover>span{color:#f57f17}.c100.amber .bar,.c100.amber .fill{border-color:#fab813!important}.c100.amber:hover>span{color:#fab813}.c100.amber.dark .bar,.c100.amber.dark .fill{border-color:#ff6f00!important}.c100.amber.dark:hover>span{color:#ff6f00}.c100.orange .bar,.c100.orange .fill{border-color:#ff9800!important}.c100.orange:hover>span{color:#ff9800}.c100.orange.dark .bar,.c100.orange.dark .fill{border-color:#e65100!important}.c100.orange.dark:hover>span{color:#e65100}.c100.deep-orange .bar,.c100.deep-orange .fill{border-color:#ff5722!important}.c100.deep-orange:hover>span{color:#ff5722}.c100.deep-orange.dark .bar,.c100.deep-orange.dark .fill{border-color:#bf360c!important}.c100.deep-orange.dark:hover>span{color:#bf360c}.c100.brown .bar,.c100.brown .fill{border-color:#795548!important}.c100.brown:hover>span{color:#795548}.c100.brown.dark .bar,.c100.brown.dark .fill{border-color:#3e2723!important}.c100.brown.dark:hover>span{color:#3e2723}.c100.blue-grey .bar,.c100.blue-grey .fill{border-color:#607d8b!important}.c100.blue-grey:hover>span{color:#607d8b}.c100.blue-grey.dark .bar,.c100.blue-grey.dark .fill{border-color:#263238!important}.c100.blue-grey.dark:hover>span{color:#263238}.c100.grey .bar,.c100.grey .fill{border-color:#6f6f6e!important}.c100.grey:hover>span{color:#6f6f6e}.c100.grey.dark .bar,.c100.grey.dark .fill{border-color:#212121!important}.c100.grey.dark:hover>span{color:#212121}@media (min-width:768px){.col-sm-1-5{width:20%;float:left}}@media (min-width:992px){.col-md-1-5{width:20%;float:left}}@media (min-width:1200px){.col-lg-1-5{width:20%;float:left}}@font-face{font-family:Material-Design-Icons;font-style:normal;font-weight:400;src:url(" + __webpack_require__(1546) + ");src:url(" + __webpack_require__(1547) + "?#iefix-g7cqhn) format(\"embedded-opentype\"),url(" + __webpack_require__(1548) + ") format(\"woff\"),url(" + __webpack_require__(1549) + ") format(\"truetype\"),url(" + __webpack_require__(1550) + "#Material-Design-Icons) format(\"svg\")}[class*=\" mdi-\"],[class^=mdi-]{font-family:Material-Design-Icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;line-height:1;text-transform:none;speak:none;font-variant:normal;-moz-osx-font-smoothing:grayscale}.mdi-action-3d-rotation:before{content:\"\\E600\"}.mdi-action-accessibility:before{content:\"\\E601\"}.mdi-action-account-balance:before{content:\"\\E602\"}.mdi-action-account-balance-wallet:before{content:\"\\E603\"}.mdi-action-account-box:before{content:\"\\E604\"}.mdi-action-account-child:before{content:\"\\E605\"}.mdi-action-account-circle:before{content:\"\\E606\"}.mdi-action-add-shopping-cart:before{content:\"\\E607\"}.mdi-action-alarm:before{content:\"\\E608\"}.mdi-action-alarm-add:before{content:\"\\E609\"}.mdi-action-alarm-off:before{content:\"\\E60A\"}.mdi-action-alarm-on:before{content:\"\\E60B\"}.mdi-action-android:before{content:\"\\E60C\"}.mdi-action-announcement:before{content:\"\\E60D\"}.mdi-action-aspect-ratio:before{content:\"\\E60E\"}.mdi-action-assessment:before{content:\"\\E60F\"}.mdi-action-assignment:before{content:\"\\E610\"}.mdi-action-assignment-ind:before{content:\"\\E611\"}.mdi-action-assignment-late:before{content:\"\\E612\"}.mdi-action-assignment-return:before{content:\"\\E613\"}.mdi-action-assignment-returned:before{content:\"\\E614\"}.mdi-action-assignment-turned-in:before{content:\"\\E615\"}.mdi-action-autorenew:before{content:\"\\E616\"}.mdi-action-backup:before{content:\"\\E617\"}.mdi-action-book:before{content:\"\\E618\"}.mdi-action-bookmark:before{content:\"\\E619\"}.mdi-action-bookmark-outline:before{content:\"\\E61A\"}.mdi-action-bug-report:before{content:\"\\E61B\"}.mdi-action-cached:before{content:\"\\E61C\"}.mdi-action-class:before{content:\"\\E61D\"}.mdi-action-credit-card:before{content:\"\\E61E\"}.mdi-action-dashboard:before{content:\"\\E61F\"}.mdi-action-delete:before{content:\"\\E620\"}.mdi-action-description:before{content:\"\\E621\"}.mdi-action-dns:before{content:\"\\E622\"}.mdi-action-done:before{content:\"\\E623\"}.mdi-action-done-all:before{content:\"\\E624\"}.mdi-action-event:before{content:\"\\E625\"}.mdi-action-exit-to-app:before{content:\"\\E626\"}.mdi-action-explore:before{content:\"\\E627\"}.mdi-action-extension:before{content:\"\\E628\"}.mdi-action-face-unlock:before{content:\"\\E629\"}.mdi-action-favorite:before{content:\"\\E62A\"}.mdi-action-favorite-outline:before{content:\"\\E62B\"}.mdi-action-find-in-page:before{content:\"\\E62C\"}.mdi-action-find-replace:before{content:\"\\E62D\"}.mdi-action-flip-to-back:before{content:\"\\E62E\"}.mdi-action-flip-to-front:before{content:\"\\E62F\"}.mdi-action-get-app:before{content:\"\\E630\"}.mdi-action-grade:before{content:\"\\E631\"}.mdi-action-group-work:before{content:\"\\E632\"}.mdi-action-help:before{content:\"\\E633\"}.mdi-action-highlight-remove:before{content:\"\\E634\"}.mdi-action-history:before{content:\"\\E635\"}.mdi-action-home:before{content:\"\\E636\"}.mdi-action-https:before{content:\"\\E637\"}.mdi-action-info:before{content:\"\\E638\"}.mdi-action-info-outline:before{content:\"\\E639\"}.mdi-action-input:before{content:\"\\E63A\"}.mdi-action-invert-colors:before{content:\"\\E63B\"}.mdi-action-label:before{content:\"\\E63C\"}.mdi-action-label-outline:before{content:\"\\E63D\"}.mdi-action-language:before{content:\"\\E63E\"}.mdi-action-launch:before{content:\"\\E63F\"}.mdi-action-list:before{content:\"\\E640\"}.mdi-action-lock:before{content:\"\\E641\"}.mdi-action-lock-open:before{content:\"\\E642\"}.mdi-action-lock-outline:before{content:\"\\E643\"}.mdi-action-loyalty:before{content:\"\\E644\"}.mdi-action-markunread-mailbox:before{content:\"\\E645\"}.mdi-action-note-add:before{content:\"\\E646\"}.mdi-action-open-in-browser:before{content:\"\\E647\"}.mdi-action-open-in-new:before{content:\"\\E648\"}.mdi-action-open-with:before{content:\"\\E649\"}.mdi-action-pageview:before{content:\"\\E64A\"}.mdi-action-payment:before{content:\"\\E64B\"}.mdi-action-perm-camera-mic:before{content:\"\\E64C\"}.mdi-action-perm-contact-cal:before{content:\"\\E64D\"}.mdi-action-perm-data-setting:before{content:\"\\E64E\"}.mdi-action-perm-device-info:before{content:\"\\E64F\"}.mdi-action-perm-identity:before{content:\"\\E650\"}.mdi-action-perm-media:before{content:\"\\E651\"}.mdi-action-perm-phone-msg:before{content:\"\\E652\"}.mdi-action-perm-scan-wifi:before{content:\"\\E653\"}.mdi-action-picture-in-picture:before{content:\"\\E654\"}.mdi-action-polymer:before{content:\"\\E655\"}.mdi-action-print:before{content:\"\\E656\"}.mdi-action-query-builder:before{content:\"\\E657\"}.mdi-action-question-answer:before{content:\"\\E658\"}.mdi-action-receipt:before{content:\"\\E659\"}.mdi-action-redeem:before{content:\"\\E65A\"}.mdi-action-report-problem:before{content:\"\\E65B\"}.mdi-action-restore:before{content:\"\\E65C\"}.mdi-action-room:before{content:\"\\E65D\"}.mdi-action-schedule:before{content:\"\\E65E\"}.mdi-action-search:before{content:\"\\E65F\"}.mdi-action-settings:before{content:\"\\E660\"}.mdi-action-settings-applications:before{content:\"\\E661\"}.mdi-action-settings-backup-restore:before{content:\"\\E662\"}.mdi-action-settings-bluetooth:before{content:\"\\E663\"}.mdi-action-settings-cell:before{content:\"\\E664\"}.mdi-action-settings-display:before{content:\"\\E665\"}.mdi-action-settings-ethernet:before{content:\"\\E666\"}.mdi-action-settings-input-antenna:before{content:\"\\E667\"}.mdi-action-settings-input-component:before{content:\"\\E668\"}.mdi-action-settings-input-composite:before{content:\"\\E669\"}.mdi-action-settings-input-hdmi:before{content:\"\\E66A\"}.mdi-action-settings-input-svideo:before{content:\"\\E66B\"}.mdi-action-settings-overscan:before{content:\"\\E66C\"}.mdi-action-settings-phone:before{content:\"\\E66D\"}.mdi-action-settings-power:before{content:\"\\E66E\"}.mdi-action-settings-remote:before{content:\"\\E66F\"}.mdi-action-settings-voice:before{content:\"\\E670\"}.mdi-action-shop:before{content:\"\\E671\"}.mdi-action-shopping-basket:before{content:\"\\E672\"}.mdi-action-shopping-cart:before{content:\"\\E673\"}.mdi-action-shop-two:before{content:\"\\E674\"}.mdi-action-speaker-notes:before{content:\"\\E675\"}.mdi-action-spellcheck:before{content:\"\\E676\"}.mdi-action-star-rate:before{content:\"\\E677\"}.mdi-action-stars:before{content:\"\\E678\"}.mdi-action-store:before{content:\"\\E679\"}.mdi-action-subject:before{content:\"\\E67A\"}.mdi-action-swap-horiz:before{content:\"\\E67B\"}.mdi-action-swap-vert:before{content:\"\\E67C\"}.mdi-action-swap-vert-circle:before{content:\"\\E67D\"}.mdi-action-system-update-tv:before{content:\"\\E67E\"}.mdi-action-tab:before{content:\"\\E67F\"}.mdi-action-tab-unselected:before{content:\"\\E680\"}.mdi-action-theaters:before{content:\"\\E681\"}.mdi-action-thumb-down:before{content:\"\\E682\"}.mdi-action-thumbs-up-down:before{content:\"\\E683\"}.mdi-action-thumb-up:before{content:\"\\E684\"}.mdi-action-toc:before{content:\"\\E685\"}.mdi-action-today:before{content:\"\\E686\"}.mdi-action-track-changes:before{content:\"\\E687\"}.mdi-action-translate:before{content:\"\\E688\"}.mdi-action-trending-down:before{content:\"\\E689\"}.mdi-action-trending-neutral:before{content:\"\\E68A\"}.mdi-action-trending-up:before{content:\"\\E68B\"}.mdi-action-turned-in:before{content:\"\\E68C\"}.mdi-action-turned-in-not:before{content:\"\\E68D\"}.mdi-action-verified-user:before{content:\"\\E68E\"}.mdi-action-view-agenda:before{content:\"\\E68F\"}.mdi-action-view-array:before{content:\"\\E690\"}.mdi-action-view-carousel:before{content:\"\\E691\"}.mdi-action-view-column:before{content:\"\\E692\"}.mdi-action-view-day:before{content:\"\\E693\"}.mdi-action-view-headline:before{content:\"\\E694\"}.mdi-action-view-list:before{content:\"\\E695\"}.mdi-action-view-module:before{content:\"\\E696\"}.mdi-action-view-quilt:before{content:\"\\E697\"}.mdi-action-view-stream:before{content:\"\\E698\"}.mdi-action-view-week:before{content:\"\\E699\"}.mdi-action-visibility:before{content:\"\\E69A\"}.mdi-action-visibility-off:before{content:\"\\E69B\"}.mdi-action-wallet-giftcard:before{content:\"\\E69C\"}.mdi-action-wallet-membership:before{content:\"\\E69D\"}.mdi-action-wallet-travel:before{content:\"\\E69E\"}.mdi-action-work:before{content:\"\\E69F\"}.mdi-alert-error:before{content:\"\\E6A0\"}.mdi-alert-warning:before{content:\"\\E6A1\"}.mdi-av-album:before{content:\"\\E6A2\"}.mdi-av-timer:before{content:\"\\E6A3\"}.mdi-av-closed-caption:before{content:\"\\E6A4\"}.mdi-av-equalizer:before{content:\"\\E6A5\"}.mdi-av-explicit:before{content:\"\\E6A6\"}.mdi-av-fast-forward:before{content:\"\\E6A7\"}.mdi-av-fast-rewind:before{content:\"\\E6A8\"}.mdi-av-games:before{content:\"\\E6A9\"}.mdi-av-hearing:before{content:\"\\E6AA\"}.mdi-av-high-quality:before{content:\"\\E6AB\"}.mdi-av-loop:before{content:\"\\E6AC\"}.mdi-av-mic:before{content:\"\\E6AD\"}.mdi-av-mic-none:before{content:\"\\E6AE\"}.mdi-av-mic-off:before{content:\"\\E6AF\"}.mdi-av-movie:before{content:\"\\E6B0\"}.mdi-av-my-library-add:before{content:\"\\E6B1\"}.mdi-av-my-library-books:before{content:\"\\E6B2\"}.mdi-av-my-library-music:before{content:\"\\E6B3\"}.mdi-av-new-releases:before{content:\"\\E6B4\"}.mdi-av-not-interested:before{content:\"\\E6B5\"}.mdi-av-pause:before{content:\"\\E6B6\"}.mdi-av-pause-circle-fill:before{content:\"\\E6B7\"}.mdi-av-pause-circle-outline:before{content:\"\\E6B8\"}.mdi-av-play-arrow:before{content:\"\\E6B9\"}.mdi-av-play-circle-fill:before{content:\"\\E6BA\"}.mdi-av-play-circle-outline:before{content:\"\\E6BB\"}.mdi-av-playlist-add:before{content:\"\\E6BC\"}.mdi-av-play-shopping-bag:before{content:\"\\E6BD\"}.mdi-av-queue:before{content:\"\\E6BE\"}.mdi-av-queue-music:before{content:\"\\E6BF\"}.mdi-av-radio:before{content:\"\\E6C0\"}.mdi-av-recent-actors:before{content:\"\\E6C1\"}.mdi-av-repeat:before{content:\"\\E6C2\"}.mdi-av-repeat-one:before{content:\"\\E6C3\"}.mdi-av-replay:before{content:\"\\E6C4\"}.mdi-av-shuffle:before{content:\"\\E6C5\"}.mdi-av-skip-next:before{content:\"\\E6C6\"}.mdi-av-skip-previous:before{content:\"\\E6C7\"}.mdi-av-snooze:before{content:\"\\E6C8\"}.mdi-av-stop:before{content:\"\\E6C9\"}.mdi-av-subtitles:before{content:\"\\E6CA\"}.mdi-av-surround-sound:before{content:\"\\E6CB\"}.mdi-av-videocam:before{content:\"\\E6CC\"}.mdi-av-videocam-off:before{content:\"\\E6CD\"}.mdi-av-video-collection:before{content:\"\\E6CE\"}.mdi-av-volume-down:before{content:\"\\E6CF\"}.mdi-av-volume-mute:before{content:\"\\E6D0\"}.mdi-av-volume-off:before{content:\"\\E6D1\"}.mdi-av-volume-up:before{content:\"\\E6D2\"}.mdi-av-web:before{content:\"\\E6D3\"}.mdi-communication-business:before{content:\"\\E6D4\"}.mdi-communication-call:before{content:\"\\E6D5\"}.mdi-communication-call-end:before{content:\"\\E6D6\"}.mdi-communication-call-made:before{content:\"\\E6D7\"}.mdi-communication-call-merge:before{content:\"\\E6D8\"}.mdi-communication-call-missed:before{content:\"\\E6D9\"}.mdi-communication-call-received:before{content:\"\\E6DA\"}.mdi-communication-call-split:before{content:\"\\E6DB\"}.mdi-communication-chat:before{content:\"\\E6DC\"}.mdi-communication-clear-all:before{content:\"\\E6DD\"}.mdi-communication-comment:before{content:\"\\E6DE\"}.mdi-communication-contacts:before{content:\"\\E6DF\"}.mdi-communication-dialer-sip:before{content:\"\\E6E0\"}.mdi-communication-dialpad:before{content:\"\\E6E1\"}.mdi-communication-dnd-on:before{content:\"\\E6E2\"}.mdi-communication-email:before{content:\"\\E6E3\"}.mdi-communication-forum:before{content:\"\\E6E4\"}.mdi-communication-import-export:before{content:\"\\E6E5\"}.mdi-communication-invert-colors-off:before{content:\"\\E6E6\"}.mdi-communication-invert-colors-on:before{content:\"\\E6E7\"}.mdi-communication-live-help:before{content:\"\\E6E8\"}.mdi-communication-location-off:before{content:\"\\E6E9\"}.mdi-communication-location-on:before{content:\"\\E6EA\"}.mdi-communication-message:before{content:\"\\E6EB\"}.mdi-communication-messenger:before{content:\"\\E6EC\"}.mdi-communication-no-sim:before{content:\"\\E6ED\"}.mdi-communication-phone:before{content:\"\\E6EE\"}.mdi-communication-portable-wifi-off:before{content:\"\\E6EF\"}.mdi-communication-quick-contacts-dialer:before{content:\"\\E6F0\"}.mdi-communication-quick-contacts-mail:before{content:\"\\E6F1\"}.mdi-communication-ring-volume:before{content:\"\\E6F2\"}.mdi-communication-stay-current-landscape:before{content:\"\\E6F3\"}.mdi-communication-stay-current-portrait:before{content:\"\\E6F4\"}.mdi-communication-stay-primary-landscape:before{content:\"\\E6F5\"}.mdi-communication-stay-primary-portrait:before{content:\"\\E6F6\"}.mdi-communication-swap-calls:before{content:\"\\E6F7\"}.mdi-communication-textsms:before{content:\"\\E6F8\"}.mdi-communication-voicemail:before{content:\"\\E6F9\"}.mdi-communication-vpn-key:before{content:\"\\E6FA\"}.mdi-content-add:before{content:\"\\E6FB\"}.mdi-content-add-box:before{content:\"\\E6FC\"}.mdi-content-add-circle:before{content:\"\\E6FD\"}.mdi-content-add-circle-outline:before{content:\"\\E6FE\"}.mdi-content-archive:before{content:\"\\E6FF\"}.mdi-content-backspace:before{content:\"\\E700\"}.mdi-content-block:before{content:\"\\E701\"}.mdi-content-clear:before{content:\"\\E702\"}.mdi-content-content-copy:before{content:\"\\E703\"}.mdi-content-content-cut:before{content:\"\\E704\"}.mdi-content-content-paste:before{content:\"\\E705\"}.mdi-content-create:before{content:\"\\E706\"}.mdi-content-drafts:before{content:\"\\E707\"}.mdi-content-filter-list:before{content:\"\\E708\"}.mdi-content-flag:before{content:\"\\E709\"}.mdi-content-forward:before{content:\"\\E70A\"}.mdi-content-gesture:before{content:\"\\E70B\"}.mdi-content-inbox:before{content:\"\\E70C\"}.mdi-content-link:before{content:\"\\E70D\"}.mdi-content-mail:before{content:\"\\E70E\"}.mdi-content-markunread:before{content:\"\\E70F\"}.mdi-content-redo:before{content:\"\\E710\"}.mdi-content-remove:before{content:\"\\E711\"}.mdi-content-remove-circle:before{content:\"\\E712\"}.mdi-content-remove-circle-outline:before{content:\"\\E713\"}.mdi-content-reply:before{content:\"\\E714\"}.mdi-content-reply-all:before{content:\"\\E715\"}.mdi-content-report:before{content:\"\\E716\"}.mdi-content-save:before{content:\"\\E717\"}.mdi-content-select-all:before{content:\"\\E718\"}.mdi-content-send:before{content:\"\\E719\"}.mdi-content-sort:before{content:\"\\E71A\"}.mdi-content-text-format:before{content:\"\\E71B\"}.mdi-content-undo:before{content:\"\\E71C\"}.mdi-device-access-alarm:before{content:\"\\E71D\"}.mdi-device-access-alarms:before{content:\"\\E71E\"}.mdi-device-access-time:before{content:\"\\E71F\"}.mdi-device-add-alarm:before{content:\"\\E720\"}.mdi-device-airplanemode-off:before{content:\"\\E721\"}.mdi-device-airplanemode-on:before{content:\"\\E722\"}.mdi-device-battery-20:before{content:\"\\E723\"}.mdi-device-battery-30:before{content:\"\\E724\"}.mdi-device-battery-50:before{content:\"\\E725\"}.mdi-device-battery-60:before{content:\"\\E726\"}.mdi-device-battery-80:before{content:\"\\E727\"}.mdi-device-battery-90:before{content:\"\\E728\"}.mdi-device-battery-alert:before{content:\"\\E729\"}.mdi-device-battery-charging-20:before{content:\"\\E72A\"}.mdi-device-battery-charging-30:before{content:\"\\E72B\"}.mdi-device-battery-charging-50:before{content:\"\\E72C\"}.mdi-device-battery-charging-60:before{content:\"\\E72D\"}.mdi-device-battery-charging-80:before{content:\"\\E72E\"}.mdi-device-battery-charging-90:before{content:\"\\E72F\"}.mdi-device-battery-charging-full:before{content:\"\\E730\"}.mdi-device-battery-full:before{content:\"\\E731\"}.mdi-device-battery-std:before{content:\"\\E732\"}.mdi-device-battery-unknown:before{content:\"\\E733\"}.mdi-device-bluetooth:before{content:\"\\E734\"}.mdi-device-bluetooth-connected:before{content:\"\\E735\"}.mdi-device-bluetooth-disabled:before{content:\"\\E736\"}.mdi-device-bluetooth-searching:before{content:\"\\E737\"}.mdi-device-brightness-auto:before{content:\"\\E738\"}.mdi-device-brightness-high:before{content:\"\\E739\"}.mdi-device-brightness-low:before{content:\"\\E73A\"}.mdi-device-brightness-medium:before{content:\"\\E73B\"}.mdi-device-data-usage:before{content:\"\\E73C\"}.mdi-device-developer-mode:before{content:\"\\E73D\"}.mdi-device-devices:before{content:\"\\E73E\"}.mdi-device-dvr:before{content:\"\\E73F\"}.mdi-device-gps-fixed:before{content:\"\\E740\"}.mdi-device-gps-not-fixed:before{content:\"\\E741\"}.mdi-device-gps-off:before{content:\"\\E742\"}.mdi-device-location-disabled:before{content:\"\\E743\"}.mdi-device-location-searching:before{content:\"\\E744\"}.mdi-device-multitrack-audio:before{content:\"\\E745\"}.mdi-device-network-cell:before{content:\"\\E746\"}.mdi-device-network-wifi:before{content:\"\\E747\"}.mdi-device-nfc:before{content:\"\\E748\"}.mdi-device-now-wallpaper:before{content:\"\\E749\"}.mdi-device-now-widgets:before{content:\"\\E74A\"}.mdi-device-screen-lock-landscape:before{content:\"\\E74B\"}.mdi-device-screen-lock-portrait:before{content:\"\\E74C\"}.mdi-device-screen-lock-rotation:before{content:\"\\E74D\"}.mdi-device-screen-rotation:before{content:\"\\E74E\"}.mdi-device-sd-storage:before{content:\"\\E74F\"}.mdi-device-settings-system-daydream:before{content:\"\\E750\"}.mdi-device-signal-cellular-0-bar:before{content:\"\\E751\"}.mdi-device-signal-cellular-1-bar:before{content:\"\\E752\"}.mdi-device-signal-cellular-2-bar:before{content:\"\\E753\"}.mdi-device-signal-cellular-3-bar:before{content:\"\\E754\"}.mdi-device-signal-cellular-4-bar:before{content:\"\\E755\"}.mdi-device-signal-cellular-connected-no-internet-0-bar:before{content:\"\\E756\"}.mdi-device-signal-cellular-connected-no-internet-1-bar:before{content:\"\\E757\"}.mdi-device-signal-cellular-connected-no-internet-2-bar:before{content:\"\\E758\"}.mdi-device-signal-cellular-connected-no-internet-3-bar:before{content:\"\\E759\"}.mdi-device-signal-cellular-connected-no-internet-4-bar:before{content:\"\\E75A\"}.mdi-device-signal-cellular-no-sim:before{content:\"\\E75B\"}.mdi-device-signal-cellular-null:before{content:\"\\E75C\"}.mdi-device-signal-cellular-off:before{content:\"\\E75D\"}.mdi-device-signal-wifi-0-bar:before{content:\"\\E75E\"}.mdi-device-signal-wifi-1-bar:before{content:\"\\E75F\"}.mdi-device-signal-wifi-2-bar:before{content:\"\\E760\"}.mdi-device-signal-wifi-3-bar:before{content:\"\\E761\"}.mdi-device-signal-wifi-4-bar:before{content:\"\\E762\"}.mdi-device-signal-wifi-off:before{content:\"\\E763\"}.mdi-device-storage:before{content:\"\\E764\"}.mdi-device-usb:before{content:\"\\E765\"}.mdi-device-wifi-lock:before{content:\"\\E766\"}.mdi-device-wifi-tethering:before{content:\"\\E767\"}.mdi-editor-attach-file:before{content:\"\\E768\"}.mdi-editor-attach-money:before{content:\"\\E769\"}.mdi-editor-border-all:before{content:\"\\E76A\"}.mdi-editor-border-bottom:before{content:\"\\E76B\"}.mdi-editor-border-clear:before{content:\"\\E76C\"}.mdi-editor-border-color:before{content:\"\\E76D\"}.mdi-editor-border-horizontal:before{content:\"\\E76E\"}.mdi-editor-border-inner:before{content:\"\\E76F\"}.mdi-editor-border-left:before{content:\"\\E770\"}.mdi-editor-border-outer:before{content:\"\\E771\"}.mdi-editor-border-right:before{content:\"\\E772\"}.mdi-editor-border-style:before{content:\"\\E773\"}.mdi-editor-border-top:before{content:\"\\E774\"}.mdi-editor-border-vertical:before{content:\"\\E775\"}.mdi-editor-format-align-center:before{content:\"\\E776\"}.mdi-editor-format-align-justify:before{content:\"\\E777\"}.mdi-editor-format-align-left:before{content:\"\\E778\"}.mdi-editor-format-align-right:before{content:\"\\E779\"}.mdi-editor-format-bold:before{content:\"\\E77A\"}.mdi-editor-format-clear:before{content:\"\\E77B\"}.mdi-editor-format-color-fill:before{content:\"\\E77C\"}.mdi-editor-format-color-reset:before{content:\"\\E77D\"}.mdi-editor-format-color-text:before{content:\"\\E77E\"}.mdi-editor-format-indent-decrease:before{content:\"\\E77F\"}.mdi-editor-format-indent-increase:before{content:\"\\E780\"}.mdi-editor-format-italic:before{content:\"\\E781\"}.mdi-editor-format-line-spacing:before{content:\"\\E782\"}.mdi-editor-format-list-bulleted:before{content:\"\\E783\"}.mdi-editor-format-list-numbered:before{content:\"\\E784\"}.mdi-editor-format-paint:before{content:\"\\E785\"}.mdi-editor-format-quote:before{content:\"\\E786\"}.mdi-editor-format-size:before{content:\"\\E787\"}.mdi-editor-format-strikethrough:before{content:\"\\E788\"}.mdi-editor-format-textdirection-l-to-r:before{content:\"\\E789\"}.mdi-editor-format-textdirection-r-to-l:before{content:\"\\E78A\"}.mdi-editor-format-underline:before{content:\"\\E78B\"}.mdi-editor-functions:before{content:\"\\E78C\"}.mdi-editor-insert-chart:before{content:\"\\E78D\"}.mdi-editor-insert-comment:before{content:\"\\E78E\"}.mdi-editor-insert-drive-file:before{content:\"\\E78F\"}.mdi-editor-insert-emoticon:before{content:\"\\E790\"}.mdi-editor-insert-invitation:before{content:\"\\E791\"}.mdi-editor-insert-link:before{content:\"\\E792\"}.mdi-editor-insert-photo:before{content:\"\\E793\"}.mdi-editor-merge-type:before{content:\"\\E794\"}.mdi-editor-mode-comment:before{content:\"\\E795\"}.mdi-editor-mode-edit:before{content:\"\\E796\"}.mdi-editor-publish:before{content:\"\\E797\"}.mdi-editor-vertical-align-bottom:before{content:\"\\E798\"}.mdi-editor-vertical-align-center:before{content:\"\\E799\"}.mdi-editor-vertical-align-top:before{content:\"\\E79A\"}.mdi-editor-wrap-text:before{content:\"\\E79B\"}.mdi-file-attachment:before{content:\"\\E79C\"}.mdi-file-cloud:before{content:\"\\E79D\"}.mdi-file-cloud-circle:before{content:\"\\E79E\"}.mdi-file-cloud-done:before{content:\"\\E79F\"}.mdi-file-cloud-download:before{content:\"\\E7A0\"}.mdi-file-cloud-off:before{content:\"\\E7A1\"}.mdi-file-cloud-queue:before{content:\"\\E7A2\"}.mdi-file-cloud-upload:before{content:\"\\E7A3\"}.mdi-file-file-download:before{content:\"\\E7A4\"}.mdi-file-file-upload:before{content:\"\\E7A5\"}.mdi-file-folder:before{content:\"\\E7A6\"}.mdi-file-folder-open:before{content:\"\\E7A7\"}.mdi-file-folder-shared:before{content:\"\\E7A8\"}.mdi-hardware-cast:before{content:\"\\E7A9\"}.mdi-hardware-cast-connected:before{content:\"\\E7AA\"}.mdi-hardware-computer:before{content:\"\\E7AB\"}.mdi-hardware-desktop-mac:before{content:\"\\E7AC\"}.mdi-hardware-desktop-windows:before{content:\"\\E7AD\"}.mdi-hardware-dock:before{content:\"\\E7AE\"}.mdi-hardware-gamepad:before{content:\"\\E7AF\"}.mdi-hardware-headset:before{content:\"\\E7B0\"}.mdi-hardware-headset-mic:before{content:\"\\E7B1\"}.mdi-hardware-keyboard:before{content:\"\\E7B2\"}.mdi-hardware-keyboard-alt:before{content:\"\\E7B3\"}.mdi-hardware-keyboard-arrow-down:before{content:\"\\E7B4\"}.mdi-hardware-keyboard-arrow-left:before{content:\"\\E7B5\"}.mdi-hardware-keyboard-arrow-right:before{content:\"\\E7B6\"}.mdi-hardware-keyboard-arrow-up:before{content:\"\\E7B7\"}.mdi-hardware-keyboard-backspace:before{content:\"\\E7B8\"}.mdi-hardware-keyboard-capslock:before{content:\"\\E7B9\"}.mdi-hardware-keyboard-control:before{content:\"\\E7BA\"}.mdi-hardware-keyboard-hide:before{content:\"\\E7BB\"}.mdi-hardware-keyboard-return:before{content:\"\\E7BC\"}.mdi-hardware-keyboard-tab:before{content:\"\\E7BD\"}.mdi-hardware-keyboard-voice:before{content:\"\\E7BE\"}.mdi-hardware-laptop:before{content:\"\\E7BF\"}.mdi-hardware-laptop-chromebook:before{content:\"\\E7C0\"}.mdi-hardware-laptop-mac:before{content:\"\\E7C1\"}.mdi-hardware-laptop-windows:before{content:\"\\E7C2\"}.mdi-hardware-memory:before{content:\"\\E7C3\"}.mdi-hardware-mouse:before{content:\"\\E7C4\"}.mdi-hardware-phone-android:before{content:\"\\E7C5\"}.mdi-hardware-phone-iphone:before{content:\"\\E7C6\"}.mdi-hardware-phonelink:before{content:\"\\E7C7\"}.mdi-hardware-phonelink-off:before{content:\"\\E7C8\"}.mdi-hardware-security:before{content:\"\\E7C9\"}.mdi-hardware-sim-card:before{content:\"\\E7CA\"}.mdi-hardware-smartphone:before{content:\"\\E7CB\"}.mdi-hardware-speaker:before{content:\"\\E7CC\"}.mdi-hardware-tablet:before{content:\"\\E7CD\"}.mdi-hardware-tablet-android:before{content:\"\\E7CE\"}.mdi-hardware-tablet-mac:before{content:\"\\E7CF\"}.mdi-hardware-tv:before{content:\"\\E7D0\"}.mdi-hardware-watch:before{content:\"\\E7D1\"}.mdi-image-add-to-photos:before{content:\"\\E7D2\"}.mdi-image-adjust:before{content:\"\\E7D3\"}.mdi-image-assistant-photo:before{content:\"\\E7D4\"}.mdi-image-audiotrack:before{content:\"\\E7D5\"}.mdi-image-blur-circular:before{content:\"\\E7D6\"}.mdi-image-blur-linear:before{content:\"\\E7D7\"}.mdi-image-blur-off:before{content:\"\\E7D8\"}.mdi-image-blur-on:before{content:\"\\E7D9\"}.mdi-image-brightness-1:before{content:\"\\E7DA\"}.mdi-image-brightness-2:before{content:\"\\E7DB\"}.mdi-image-brightness-3:before{content:\"\\E7DC\"}.mdi-image-brightness-4:before{content:\"\\E7DD\"}.mdi-image-brightness-5:before{content:\"\\E7DE\"}.mdi-image-brightness-6:before{content:\"\\E7DF\"}.mdi-image-brightness-7:before{content:\"\\E7E0\"}.mdi-image-brush:before{content:\"\\E7E1\"}.mdi-image-camera:before{content:\"\\E7E2\"}.mdi-image-camera-alt:before{content:\"\\E7E3\"}.mdi-image-camera-front:before{content:\"\\E7E4\"}.mdi-image-camera-rear:before{content:\"\\E7E5\"}.mdi-image-camera-roll:before{content:\"\\E7E6\"}.mdi-image-center-focus-strong:before{content:\"\\E7E7\"}.mdi-image-center-focus-weak:before{content:\"\\E7E8\"}.mdi-image-collections:before{content:\"\\E7E9\"}.mdi-image-colorize:before{content:\"\\E7EA\"}.mdi-image-color-lens:before{content:\"\\E7EB\"}.mdi-image-compare:before{content:\"\\E7EC\"}.mdi-image-control-point:before{content:\"\\E7ED\"}.mdi-image-control-point-duplicate:before{content:\"\\E7EE\"}.mdi-image-crop:before{content:\"\\E7EF\"}.mdi-image-crop-3-2:before{content:\"\\E7F0\"}.mdi-image-crop-5-4:before{content:\"\\E7F1\"}.mdi-image-crop-7-5:before{content:\"\\E7F2\"}.mdi-image-crop-16-9:before{content:\"\\E7F3\"}.mdi-image-crop-din:before{content:\"\\E7F4\"}.mdi-image-crop-free:before{content:\"\\E7F5\"}.mdi-image-crop-landscape:before{content:\"\\E7F6\"}.mdi-image-crop-original:before{content:\"\\E7F7\"}.mdi-image-crop-portrait:before{content:\"\\E7F8\"}.mdi-image-crop-square:before{content:\"\\E7F9\"}.mdi-image-dehaze:before{content:\"\\E7FA\"}.mdi-image-details:before{content:\"\\E7FB\"}.mdi-image-edit:before{content:\"\\E7FC\"}.mdi-image-exposure:before{content:\"\\E7FD\"}.mdi-image-exposure-minus-1:before{content:\"\\E7FE\"}.mdi-image-exposure-minus-2:before{content:\"\\E7FF\"}.mdi-image-exposure-plus-1:before{content:\"\\E800\"}.mdi-image-exposure-plus-2:before{content:\"\\E801\"}.mdi-image-exposure-zero:before{content:\"\\E802\"}.mdi-image-filter:before{content:\"\\E803\"}.mdi-image-filter-1:before{content:\"\\E804\"}.mdi-image-filter-2:before{content:\"\\E805\"}.mdi-image-filter-3:before{content:\"\\E806\"}.mdi-image-filter-4:before{content:\"\\E807\"}.mdi-image-filter-5:before{content:\"\\E808\"}.mdi-image-filter-6:before{content:\"\\E809\"}.mdi-image-filter-7:before{content:\"\\E80A\"}.mdi-image-filter-8:before{content:\"\\E80B\"}.mdi-image-filter-9:before{content:\"\\E80C\"}.mdi-image-filter-9-plus:before{content:\"\\E80D\"}.mdi-image-filter-b-and-w:before{content:\"\\E80E\"}.mdi-image-filter-center-focus:before{content:\"\\E80F\"}.mdi-image-filter-drama:before{content:\"\\E810\"}.mdi-image-filter-frames:before{content:\"\\E811\"}.mdi-image-filter-hdr:before{content:\"\\E812\"}.mdi-image-filter-none:before{content:\"\\E813\"}.mdi-image-filter-tilt-shift:before{content:\"\\E814\"}.mdi-image-filter-vintage:before{content:\"\\E815\"}.mdi-image-flare:before{content:\"\\E816\"}.mdi-image-flash-auto:before{content:\"\\E817\"}.mdi-image-flash-off:before{content:\"\\E818\"}.mdi-image-flash-on:before{content:\"\\E819\"}.mdi-image-flip:before{content:\"\\E81A\"}.mdi-image-gradient:before{content:\"\\E81B\"}.mdi-image-grain:before{content:\"\\E81C\"}.mdi-image-grid-off:before{content:\"\\E81D\"}.mdi-image-grid-on:before{content:\"\\E81E\"}.mdi-image-hdr-off:before{content:\"\\E81F\"}.mdi-image-hdr-on:before{content:\"\\E820\"}.mdi-image-hdr-strong:before{content:\"\\E821\"}.mdi-image-hdr-weak:before{content:\"\\E822\"}.mdi-image-healing:before{content:\"\\E823\"}.mdi-image-image:before{content:\"\\E824\"}.mdi-image-image-aspect-ratio:before{content:\"\\E825\"}.mdi-image-iso:before{content:\"\\E826\"}.mdi-image-landscape:before{content:\"\\E827\"}.mdi-image-leak-add:before{content:\"\\E828\"}.mdi-image-leak-remove:before{content:\"\\E829\"}.mdi-image-lens:before{content:\"\\E82A\"}.mdi-image-looks:before{content:\"\\E82B\"}.mdi-image-looks-3:before{content:\"\\E82C\"}.mdi-image-looks-4:before{content:\"\\E82D\"}.mdi-image-looks-5:before{content:\"\\E82E\"}.mdi-image-looks-6:before{content:\"\\E82F\"}.mdi-image-looks-one:before{content:\"\\E830\"}.mdi-image-looks-two:before{content:\"\\E831\"}.mdi-image-loupe:before{content:\"\\E832\"}.mdi-image-movie-creation:before{content:\"\\E833\"}.mdi-image-nature:before{content:\"\\E834\"}.mdi-image-nature-people:before{content:\"\\E835\"}.mdi-image-navigate-before:before{content:\"\\E836\"}.mdi-image-navigate-next:before{content:\"\\E837\"}.mdi-image-palette:before{content:\"\\E838\"}.mdi-image-panorama:before{content:\"\\E839\"}.mdi-image-panorama-fisheye:before{content:\"\\E83A\"}.mdi-image-panorama-horizontal:before{content:\"\\E83B\"}.mdi-image-panorama-vertical:before{content:\"\\E83C\"}.mdi-image-panorama-wide-angle:before{content:\"\\E83D\"}.mdi-image-photo:before{content:\"\\E83E\"}.mdi-image-photo-album:before{content:\"\\E83F\"}.mdi-image-photo-camera:before{content:\"\\E840\"}.mdi-image-photo-library:before{content:\"\\E841\"}.mdi-image-portrait:before{content:\"\\E842\"}.mdi-image-remove-red-eye:before{content:\"\\E843\"}.mdi-image-rotate-left:before{content:\"\\E844\"}.mdi-image-rotate-right:before{content:\"\\E845\"}.mdi-image-slideshow:before{content:\"\\E846\"}.mdi-image-straighten:before{content:\"\\E847\"}.mdi-image-style:before{content:\"\\E848\"}.mdi-image-switch-camera:before{content:\"\\E849\"}.mdi-image-switch-video:before{content:\"\\E84A\"}.mdi-image-tag-faces:before{content:\"\\E84B\"}.mdi-image-texture:before{content:\"\\E84C\"}.mdi-image-timelapse:before{content:\"\\E84D\"}.mdi-image-timer:before{content:\"\\E84E\"}.mdi-image-timer-3:before{content:\"\\E84F\"}.mdi-image-timer-10:before{content:\"\\E850\"}.mdi-image-timer-auto:before{content:\"\\E851\"}.mdi-image-timer-off:before{content:\"\\E852\"}.mdi-image-tonality:before{content:\"\\E853\"}.mdi-image-transform:before{content:\"\\E854\"}.mdi-image-tune:before{content:\"\\E855\"}.mdi-image-wb-auto:before{content:\"\\E856\"}.mdi-image-wb-cloudy:before{content:\"\\E857\"}.mdi-image-wb-incandescent:before{content:\"\\E858\"}.mdi-image-wb-irradescent:before{content:\"\\E859\"}.mdi-image-wb-sunny:before{content:\"\\E85A\"}.mdi-maps-beenhere:before{content:\"\\E85B\"}.mdi-maps-directions:before{content:\"\\E85C\"}.mdi-maps-directions-bike:before{content:\"\\E85D\"}.mdi-maps-directions-bus:before{content:\"\\E85E\"}.mdi-maps-directions-car:before{content:\"\\E85F\"}.mdi-maps-directions-ferry:before{content:\"\\E860\"}.mdi-maps-directions-subway:before{content:\"\\E861\"}.mdi-maps-directions-train:before{content:\"\\E862\"}.mdi-maps-directions-transit:before{content:\"\\E863\"}.mdi-maps-directions-walk:before{content:\"\\E864\"}.mdi-maps-flight:before{content:\"\\E865\"}.mdi-maps-hotel:before{content:\"\\E866\"}.mdi-maps-layers:before{content:\"\\E867\"}.mdi-maps-layers-clear:before{content:\"\\E868\"}.mdi-maps-local-airport:before{content:\"\\E869\"}.mdi-maps-local-atm:before{content:\"\\E86A\"}.mdi-maps-local-attraction:before{content:\"\\E86B\"}.mdi-maps-local-bar:before{content:\"\\E86C\"}.mdi-maps-local-cafe:before{content:\"\\E86D\"}.mdi-maps-local-car-wash:before{content:\"\\E86E\"}.mdi-maps-local-convenience-store:before{content:\"\\E86F\"}.mdi-maps-local-drink:before{content:\"\\E870\"}.mdi-maps-local-florist:before{content:\"\\E871\"}.mdi-maps-local-gas-station:before{content:\"\\E872\"}.mdi-maps-local-grocery-store:before{content:\"\\E873\"}.mdi-maps-local-hospital:before{content:\"\\E874\"}.mdi-maps-local-hotel:before{content:\"\\E875\"}.mdi-maps-local-laundry-service:before{content:\"\\E876\"}.mdi-maps-local-library:before{content:\"\\E877\"}.mdi-maps-local-mall:before{content:\"\\E878\"}.mdi-maps-local-movies:before{content:\"\\E879\"}.mdi-maps-local-offer:before{content:\"\\E87A\"}.mdi-maps-local-parking:before{content:\"\\E87B\"}.mdi-maps-local-pharmacy:before{content:\"\\E87C\"}.mdi-maps-local-phone:before{content:\"\\E87D\"}.mdi-maps-local-pizza:before{content:\"\\E87E\"}.mdi-maps-local-play:before{content:\"\\E87F\"}.mdi-maps-local-post-office:before{content:\"\\E880\"}.mdi-maps-local-print-shop:before{content:\"\\E881\"}.mdi-maps-local-restaurant:before{content:\"\\E882\"}.mdi-maps-local-see:before{content:\"\\E883\"}.mdi-maps-local-shipping:before{content:\"\\E884\"}.mdi-maps-local-taxi:before{content:\"\\E885\"}.mdi-maps-location-history:before{content:\"\\E886\"}.mdi-maps-map:before{content:\"\\E887\"}.mdi-maps-my-location:before{content:\"\\E888\"}.mdi-maps-navigation:before{content:\"\\E889\"}.mdi-maps-pin-drop:before{content:\"\\E88A\"}.mdi-maps-place:before{content:\"\\E88B\"}.mdi-maps-rate-review:before{content:\"\\E88C\"}.mdi-maps-restaurant-menu:before{content:\"\\E88D\"}.mdi-maps-satellite:before{content:\"\\E88E\"}.mdi-maps-store-mall-directory:before{content:\"\\E88F\"}.mdi-maps-terrain:before{content:\"\\E890\"}.mdi-maps-traffic:before{content:\"\\E891\"}.mdi-navigation-apps:before{content:\"\\E892\"}.mdi-navigation-arrow-back:before{content:\"\\E893\"}.mdi-navigation-arrow-drop-down:before{content:\"\\E894\"}.mdi-navigation-arrow-drop-down-circle:before{content:\"\\E895\"}.mdi-navigation-arrow-drop-up:before{content:\"\\E896\"}.mdi-navigation-arrow-forward:before{content:\"\\E897\"}.mdi-navigation-cancel:before{content:\"\\E898\"}.mdi-navigation-check:before{content:\"\\E899\"}.mdi-navigation-chevron-left:before{content:\"\\E89A\"}.mdi-navigation-chevron-right:before{content:\"\\E89B\"}.mdi-navigation-close:before{content:\"\\E89C\"}.mdi-navigation-expand-less:before{content:\"\\E89D\"}.mdi-navigation-expand-more:before{content:\"\\E89E\"}.mdi-navigation-fullscreen:before{content:\"\\E89F\"}.mdi-navigation-fullscreen-exit:before{content:\"\\E8A0\"}.mdi-navigation-menu:before{content:\"\\E8A1\"}.mdi-navigation-more-horiz:before{content:\"\\E8A2\"}.mdi-navigation-more-vert:before{content:\"\\E8A3\"}.mdi-navigation-refresh:before{content:\"\\E8A4\"}.mdi-navigation-unfold-less:before{content:\"\\E8A5\"}.mdi-navigation-unfold-more:before{content:\"\\E8A6\"}.mdi-notification-adb:before{content:\"\\E8A7\"}.mdi-notification-bluetooth-audio:before{content:\"\\E8A8\"}.mdi-notification-disc-full:before{content:\"\\E8A9\"}.mdi-notification-dnd-forwardslash:before{content:\"\\E8AA\"}.mdi-notification-do-not-disturb:before{content:\"\\E8AB\"}.mdi-notification-drive-eta:before{content:\"\\E8AC\"}.mdi-notification-event-available:before{content:\"\\E8AD\"}.mdi-notification-event-busy:before{content:\"\\E8AE\"}.mdi-notification-event-note:before{content:\"\\E8AF\"}.mdi-notification-folder-special:before{content:\"\\E8B0\"}.mdi-notification-mms:before{content:\"\\E8B1\"}.mdi-notification-more:before{content:\"\\E8B2\"}.mdi-notification-network-locked:before{content:\"\\E8B3\"}.mdi-notification-phone-bluetooth-speaker:before{content:\"\\E8B4\"}.mdi-notification-phone-forwarded:before{content:\"\\E8B5\"}.mdi-notification-phone-in-talk:before{content:\"\\E8B6\"}.mdi-notification-phone-locked:before{content:\"\\E8B7\"}.mdi-notification-phone-missed:before{content:\"\\E8B8\"}.mdi-notification-phone-paused:before{content:\"\\E8B9\"}.mdi-notification-play-download:before{content:\"\\E8BA\"}.mdi-notification-play-install:before{content:\"\\E8BB\"}.mdi-notification-sd-card:before{content:\"\\E8BC\"}.mdi-notification-sim-card-alert:before{content:\"\\E8BD\"}.mdi-notification-sms:before{content:\"\\E8BE\"}.mdi-notification-sms-failed:before{content:\"\\E8BF\"}.mdi-notification-sync:before{content:\"\\E8C0\"}.mdi-notification-sync-disabled:before{content:\"\\E8C1\"}.mdi-notification-sync-problem:before{content:\"\\E8C2\"}.mdi-notification-system-update:before{content:\"\\E8C3\"}.mdi-notification-tap-and-play:before{content:\"\\E8C4\"}.mdi-notification-time-to-leave:before{content:\"\\E8C5\"}.mdi-notification-vibration:before{content:\"\\E8C6\"}.mdi-notification-voice-chat:before{content:\"\\E8C7\"}.mdi-notification-vpn-lock:before{content:\"\\E8C8\"}.mdi-social-cake:before{content:\"\\E8C9\"}.mdi-social-domain:before{content:\"\\E8CA\"}.mdi-social-group:before{content:\"\\E8CB\"}.mdi-social-group-add:before{content:\"\\E8CC\"}.mdi-social-location-city:before{content:\"\\E8CD\"}.mdi-social-mood:before{content:\"\\E8CE\"}.mdi-social-notifications:before{content:\"\\E8CF\"}.mdi-social-notifications-none:before{content:\"\\E8D0\"}.mdi-social-notifications-off:before{content:\"\\E8D1\"}.mdi-social-notifications-on:before{content:\"\\E8D2\"}.mdi-social-notifications-paused:before{content:\"\\E8D3\"}.mdi-social-pages:before{content:\"\\E8D4\"}.mdi-social-party-mode:before{content:\"\\E8D5\"}.mdi-social-people:before{content:\"\\E8D6\"}.mdi-social-people-outline:before{content:\"\\E8D7\"}.mdi-social-person:before{content:\"\\E8D8\"}.mdi-social-person-add:before{content:\"\\E8D9\"}.mdi-social-person-outline:before{content:\"\\E8DA\"}.mdi-social-plus-one:before{content:\"\\E8DB\"}.mdi-social-poll:before{content:\"\\E8DC\"}.mdi-social-public:before{content:\"\\E8DD\"}.mdi-social-school:before{content:\"\\E8DE\"}.mdi-social-share:before{content:\"\\E8DF\"}.mdi-social-whatshot:before{content:\"\\E8E0\"}.mdi-toggle-check-box:before{content:\"\\E8E1\"}.mdi-toggle-check-box-outline-blank:before{content:\"\\E8E2\"}.mdi-toggle-radio-button-off:before{content:\"\\E8E3\"}.mdi-toggle-radio-button-on:before{content:\"\\E8E4\"}.container_main{visibility:hidden;z-index:10;position:absolute;bottom:0;right:0;overflow-x:hidden;overflow-y:hidden}.container_firts{float:right}.container_contacts{height:397px;float:right;bottom:0;width:230px;position:relative}.container_chats{height:397px;float:left;width:250px;position:relative}.contatcs_child{visibility:visible;position:absolute;bottom:0;right:10px}.name_chatOpened{display:flex;justify-content:space-between}.alert_icon{color:#ccc}.item-count{display:flex;justify-content:center;font-size:20px;color:#fff}.chat_opened{visibility:visible;height:397px;float:left;position:fixed}.list-messageBoxes{list-style-type:none;padding:0}.list-messageBoxes li{font-size:12px;font-family:sans-serif;padding:2px;cursor:pointer;display:flex;justify-content:space-between}.list-messageBoxes li a{padding:0 0 0 9px}.list-messageBoxes li a:hover{font-weight:600}.view-messageBoxes{padding:10px 10px 1px;background:#bdbdbd;background:#faf7f7}.anch-div{width:160px;padding-left:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.time_class{text-align:center;margin-bottom:10px}.t-c,.t-c-con{height:30px;background:#fff;padding-top:5px}.t-c-con{font-size:90%;width:190px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-c-a{padding:4px 8px 0 0}.timeStamp{background:#fff;padding:2px;font-size:10px;font-family:cursive;border-radius:7px;border:1px solid;border-color:#dedede}.delet_pos{margin-left:90%;color:transparent}.t-c-c{width:160px;padding-left:10px;height:30px;background:#fff;padding-top:5px}.t-c-c,.t-c-c-d{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-c-c-d{font-size:90%;cursor:none;width:170px}.f-c{height:30px;background:#6d7c7b;border-radius:1px;padding-top:5px}.msj_new{width:23px}.f-m-n{width:22px;text-align:center}.pos_div{padding:4px 0 0 3px}.f-c-h{height:30px;background:#6d7c7b;border-radius:1px;padding-top:5px;width:40px;float:right}.c-d-c{width:210px}.c-d-c,.c-d-c-c{display:flex;background:#fff}.c-d-f{display:flex}.c-l-c{height:240px;width:100%;background:#faf7f7;overflow-x:hidden;overflow-y:scroll}.c-l-c::-webkit-scrollbar{width:10px}.c-l-c::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.1)}.c-t{height:300px;width:100%;background:#faf7f7}.inf-lab{color:#f8f8f8;font-size:90%}.shadow-body{margin-top:1px;border-radius:2px;margin-right:0!important;margin-left:0!important;box-shadow:0 0 1px 1px #9e9e9e}.icon-load{margin-left:auto;margin-right:45px;margin-bottom:-5px;font-size:10px;color:#999}.truncate{width:170px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.chatbox{width:500px;min-width:390px;height:420px;background:#fff;padding:25px;margin:20px auto}.chatlogs{padding:10px;width:100%;height:300px;overflow-x:hidden;overflow-y:scroll}.chatlogs::-webkit-scrollbar{width:10px}.chatlogs::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.1)}.chat-message i:hover{cursor:pointer;color:#fff}.chat{display:flex;flex-flow:row wrap;align-items:flex-start}.chat .user-photo{width:35px;height:35px;background:#ccc;border-radius:50%;overflow:hidden}.chat .user-photo img{width:100%;height:100%}.chat .chat-message{width:73%;padding:7px;margin:0 5px;border-radius:3px;color:#fff;overflow-wrap:break-word;font-size:12px;line-height:13px}.chat .chat-time{width:73%;margin:0 5px 0 40px;font-size:10px}.friend .chat-message{background:#a9a9a9}.self .chat-message{background:#727272;order:-1}.chat-form{display:flex;align-items:inline-flex}.back-textarea{background:#faf7f7;height:36px}.chat-form-textarea textarea{background:#fbfbfb;width:110%;margin-left:-10px;height:30px;border:2px solid #eee;border-radius:3px;resize:none;padding:2px;font-size:15px;color:#777}.chat-form-textarea textarea:focus{background:#fff}.chat-form-textarea textarea::-webkit-scrollbar{width:10px}.chat-form-textarea textarea::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.2)}.back-button{background:#faf7f7;padding-left:21px}.chat-form-button button{background:#41ba6c;margin-bottom:7px;font-family:Comic Sans MS;padding:6px 14px;font-size:12px;color:#fff;border:none;border-radius:1px;cursor:pointer;margin-left:-33px;-webkit-transition:background .2 ease;-moz-transition:background .2 ease;-o-transition:background .2 ease}.chat-form-button button:hover{background:#13c8d9}.icon-pos{margin-left:-10px;margin-top:25px}.contact{margin-top:7px;cursor:pointer}.nm{width:115px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.nm p{font-size:11.5px;margin-top:-5px}.itms{font-family:Comic Sans MS}.pos-itms{margin-left:10px}.pos-label{padding:1px 0 0 8px;margin-left:-15px}.text-gris{color:#929090}.delete_message{font-size:13px}.delete_message a{padding:10px}.color-text-alert,.text-no,.text-si{font-family:sans-serif}.delete_message,.snackbar{visibility:visible;background-color:#333;color:#fff;text-align:center;border-radius:2px;padding:5px 0 0;bottom:30px;position:fixed;min-width:205px;margin-bottom:37px;box-shadow:0 0 1px 1px #9e9e9e}@keyframes fadein{0%{bottom:0;opacity:0}to{bottom:30px;opacity:1}}@keyframes fadeout{0%{bottom:30px;opacity:1}to{bottom:0;opacity:0}}", ""]);
	
	// exports


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c6d908ef358d9b74d913e492b5def7fe.png";

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9fd5e17501fe0a4159e8a1d429603d71.png";

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b8d47c51ba544d7f320e87994cc7b9c3.png";

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5107e4d7d61b7f1e41df984aa47107d.png";

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "392662c0175e5fc9215cff9d92a42dc8.png";

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "50c787e0afd0999cdbe8e685ac5e0c7b.jpg";

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d23b5163599596ee8fed5e6c4fce824d.eot";

/***/ }),
/* 1547 */
1546,
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0fc5952b2ad99db0fa1a49c2e0fd5928.woff";

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2635ab518b71cfe3d4241741689d8894.ttf";

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "98311456903486ecf6f8f705bee85781.svg";

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1552);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./app-ucentralcolombia.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./app-ucentralcolombia.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(364)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700);", ""]);
	
	// module
	exports.push([module.id, ".bg-primary{background:#636f07!important;color:#fff!important}.bg-primary-light{background:#a3b70c!important;color:#fff!important}.bg-primary-dark{background:#232702!important;color:#fff!important}.bg-accent{background:#e95d0f!important;color:#fff!important}.bg-accent-light{background:#f48b51!important;color:#fff!important}.bg-accent-dark{background:#a1400a!important;color:#fff!important}.bg-info{background:#636f07!important;color:#fff;color:#fff!important}.bg-info-light{background:#a3b70c!important;color:#fff!important}.bg-info-dark{background:#232702!important;color:#fff!important}.bg-success{background:#6abfb2!important;color:#000!important}.bg-success-light{background:#a0d6ce!important;color:#000!important}.bg-success-dark{background:#429a8d!important;color:#fff!important}.bg-warning{background:#fecd1a!important;color:#000!important}.bg-warning-light{background:#fede66!important;color:#000!important}.bg-warning-dark{background:#cb9f01!important;color:#fff!important}.bg-danger{background:#e95d0f!important;color:#fff!important}.bg-danger-light{background:#f48b51!important;color:#fff!important}.bg-danger-dark{background:#a1400a!important;color:#fff!important}.bg-light{background:#f7f7f7!important;color:#000!important}.bg-light-light{background:#fff!important;color:#000!important}.bg-light-dark{background:#d1d1d1!important;color:#000!important}.bg-dark{background:#6f6f6e!important;color:#fff!important}.bg-dark-light{background:#959594!important;color:#fff!important}.bg-dark-dark{background:#494948!important;color:#fff!important}.bg-present{background:#4caf50!important;color:#fff!important}.bg-absent{background:#6f6f6e!important;color:#fff!important}.bg-tardy{background:#ffeb3b!important;color:#000!important}.bg-justified{background:#468ac2!important;color:#fff!important}.bg-not-registered{background:#e0e0e0!important;color:#000!important;border:1px solid hsla(0,0%,88%,.1)}.bg-man{background:#afb42b!important}.bg-man,.bg-ret{color:#fff!important}.bg-ret{background:#d7634a!important}.bg-sanc{background:#fab813!important;color:#000!important}.bg-del{background:#3f51b5!important;color:#fff!important}.text-primary{color:#636f07!important}.text-primary-lt{color:#a3b70c!important}.text-primary-dk{color:#232702!important}.text-accent{color:#e95d0f!important}.text-accent-lt{color:#f48b51!important}.text-accent-dk{color:#a1400a!important}.text-info{color:#636f07!important}.text-info-lt{color:#a3b70c!important}.text-info-dk{color:#232702!important}.text-success{color:#6abfb2!important}.text-success-lt{color:#a0d6ce!important}.text-success-dk{color:#429a8d!important}.text-warning{color:#fecd1a!important}.text-warning-lt{color:#fede66!important}.text-warning-dk{color:#cb9f01!important}.text-danger{color:#e95d0f!important}.text-danger-lt{color:#f48b51!important}.text-danger-dk{color:#a1400a!important}.text-dark{color:#6f6f6e!important}.text-dark-lt{color:#959594!important}.text-dark-dk{color:#494948!important}.text-light{color:#f7f7f7!important}.text-light-lt{color:#fff!important}.text-light-dk{color:#d1d1d1!important}[ui-view].ng-leave{display:none}[ui-view].ng-leave.smooth{display:block}.smooth.ng-animate{position:absolute;width:100%;height:100%;overflow:hidden}.fade-in-right-big.ng-enter{animation:fadeInRightBig .5s}.fade-in-right-big.ng-leave{animation:fadeOutLeftBig .5s}.fade-in-left-big.ng-enter{animation:fadeInLeftBig .5s}.fade-in-left-big.ng-leave{animation:fadeOutRightBig .5s}.fade-in-up-big.ng-enter{animation:fadeInUpBig .5s}.fade-in-up-big.ng-leave{animation:fadeOutUpBig .5s}.fade-in-down-big.ng-enter{animation:fadeInDownBig .5s}.fade-in-down-big.ng-leave{animation:fadeOutDownBig .5s}.fade-in.ng-enter{animation:fadeIn .5s}.fade-in.ng-leave{animation:fadeOut .5s}.fade-in-right.ng-enter{animation:fadeInRight .5s}.fade-in-right.ng-leave{animation:fadeOutLeft .5s}.fade-in-left.ng-enter{animation:fadeInLeft .5s}.fade-in-left.ng-leave{animation:fadeOutRight .5s}.fade-in-up.ng-enter{animation:fadeInUp .5s}.fade-in-up.ng-leave{animation:fadeOutUp .5s}.fade-in-down.ng-enter{animation:fadeInDown .5s}.fade-in-down.ng-leave{animation:fadeOutDown .5s}html{background-color:#232702}body{font-family:Roboto,sans-serif;font-size:14px;color:#494948;background-color:#f9f9f9;-webkit-font-smoothing:antialiased;line-height:1.42857143}:focus{outline:0!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Open Sans,sans-serif}.title{font-size:24px!important;color:#353942!important;margin-bottom:10px}.title p{margin:0;font-size:17px;color:#758295;font-weight:300}.title h1,.title h2,.title h3,.title h4,.title h5,.title h6{margin-top:0;font-size:24px!important}.titleSecond{background-color:#f2f5f7}.h1,.h2,.h3,.h4,.h5,.h6{margin:0}a{cursor:pointer;outline:0}a,a:focus,a:hover{color:#e95d0f;text-decoration:none}.well,pre{background-color:#f7f7f7;border-color:#eaeaea}.small,small{font-size:13px}blockquote{border-color:#eaeaea}label{font-weight:400}sup{position:relative;top:-.5em;font-size:75%}.thumbnail{border-color:#eaeaea}@media (min-width:768px) and (max-width:991px){.pull-none-sm{float:none!important}.pull-right-sm{float:right!important}.pull-left-sm{float:left!important}.hidden-sm.show{display:inherit!important}}@media (max-width:767px){.pull-none-xs{float:none!important}.pull-right-xs{float:right!important}.pull-left-xs{float:left!important}.hidden-xs.show{display:inherit!important}}.text-color{color:#494948!important}.text-color-w{color:#fff!important}.badge,.label{font-weight:700;background-color:#b7b7b7}.badge.bg-light,.badge.bg-white,.label.bg-light,.label.bg-white{text-shadow:none;color:#494948}.label{padding:.35em .6em}.badge{padding:3px 6px}.badge.up{position:relative;top:-10px;margin:0 -.5em}.badge-lg{border-radius:20px;font-size:16px;padding:5px 9px}.badge-sm{padding:2px 5px}.badge-xs{padding:1px 4px}.label-lg{font-size:16px;padding:5px 9px}.label-sm{padding:2px 5px}.label-xs{padding:1px 4px}.badge-white{border:1px solid hsla(0,0%,100%,.35);padding:2px 6px}.badge-black,.badge-white{background-color:transparent}.badge-black{border:1px solid rgba(0,0,0,.15);color:inherit}.btn-default{background-color:#fff!important;border-color:#fff;color:#000!important}.btn-default.active,.btn-default.btn-stroke.active,.btn-default.btn-stroke:active,.btn-default.btn-stroke:focus,.btn-default.btn-stroke:hover,.btn-default:active,.btn-default:focus,.btn-default:hover,.open .dropdown-toggle.btn-default{color:#000;background-color:#f2f2f2!important;border-color:#d6d6d6!important}.btn-default.btn-addon>i{border:1px solid #dbdbdb;background-color:#f0f0f0}.btn-default.btn-stroke{color:#fff!important;background-color:transparent}.btn-primary{background-color:#636f07!important;border-color:#636f07;color:#fff!important}.btn-primary.active,.btn-primary.btn-stroke.active,.btn-primary.btn-stroke:active,.btn-primary.btn-stroke:focus,.btn-primary.btn-stroke:hover,.btn-primary:active,.btn-primary:focus,.btn-primary:hover,.open .dropdown-toggle.btn-primary{color:#fff;background-color:#4e5705!important;border-color:#414905!important}.btn-primary.btn-addon>i{border:1px solid #495205;background-color:#495205}.btn-primary.btn-stroke{color:#636f07!important;background-color:transparent}.btn-success{background-color:#6abfb2!important;border-color:#6abfb2;color:#000!important}.btn-success.active,.btn-success.btn-stroke.active,.btn-success.btn-stroke:active,.btn-success.btn-stroke:focus,.btn-success.btn-stroke:hover,.btn-success:active,.btn-success:focus,.btn-success:hover,.open .dropdown-toggle.btn-success{color:#000;background-color:#58b7a9!important;border-color:#4db3a3!important}.btn-success.btn-addon>i{border:1px solid #55b6a7;background-color:#55b6a7}.btn-success.btn-stroke{color:#6abfb2!important;background-color:transparent}.btn-info{background-color:#636f07!important;border-color:#636f07;color:#fff!important}.btn-info.active,.btn-info.btn-stroke.active,.btn-info.btn-stroke:active,.btn-info.btn-stroke:focus,.btn-info.btn-stroke:hover,.btn-info:active,.btn-info:focus,.btn-info:hover,.open .dropdown-toggle.btn-info{color:#fff;background-color:#4e5705!important;border-color:#414905!important}.btn-info.btn-addon>i{border:1px solid #495205;background-color:#495205}.btn-info.btn-stroke{color:#636f07!important;background-color:transparent}.btn-warning{background-color:#fecd1a!important;border-color:#fecd1a;color:#000!important}.btn-warning.active,.btn-warning.btn-stroke.active,.btn-warning.btn-stroke:active,.btn-warning.btn-stroke:focus,.btn-warning.btn-stroke:hover,.btn-warning:active,.btn-warning:focus,.btn-warning:hover,.open .dropdown-toggle.btn-warning{color:#000;background-color:#fdc701!important;border-color:#eebb01!important}.btn-warning.btn-addon>i{border:1px solid #f8c301;background-color:#f8c301}.btn-warning.btn-stroke{color:#fecd1a!important;background-color:transparent}.btn-danger{background-color:#e95d0f!important;border-color:#e95d0f;color:#fff!important}.btn-danger.active,.btn-danger.btn-stroke.active,.btn-danger.btn-stroke:active,.btn-danger.btn-stroke:focus,.btn-danger.btn-stroke:hover,.btn-danger:active,.btn-danger:focus,.btn-danger:hover,.open .dropdown-toggle.btn-danger{color:#fff;background-color:#d1530d!important;border-color:#c34e0d!important}.btn-danger.btn-addon>i{border:1px solid #cc520d;background-color:#cc520d}.btn-danger.btn-stroke{color:#e95d0f!important;background-color:transparent}.btn-accent{background-color:#e95d0f!important;border-color:#e95d0f;color:#fff!important}.btn-accent.active,.btn-accent.btn-stroke.active,.btn-accent.btn-stroke:active,.btn-accent.btn-stroke:focus,.btn-accent.btn-stroke:hover,.btn-accent:active,.btn-accent:focus,.btn-accent:hover,.open .dropdown-toggle.btn-accent{color:#fff;background-color:#d1530d!important;border-color:#c34e0d!important}.btn-accent.btn-addon>i{border:1px solid #cc520d;background-color:#cc520d}.btn-accent.btn-stroke{color:#e95d0f!important;background-color:transparent}.btn-dark{background-color:#6f6f6e!important;border-color:#6f6f6e;color:#fff!important}.btn-dark.active,.btn-dark.btn-stroke.active,.btn-dark.btn-stroke:active,.btn-dark.btn-stroke:focus,.btn-dark.btn-stroke:hover,.btn-dark:active,.btn-dark:focus,.btn-dark:hover,.open .dropdown-toggle.btn-dark{color:#fff;background-color:#626261!important;border-color:#5b5b5a!important}.btn-dark.btn-addon>i{border:1px solid #60605f;background-color:#60605f}.btn-dark.btn-stroke{color:#6f6f6e!important;background-color:transparent}.btn-light{background-color:#f7f7f7!important;border-color:#f7f7f7;color:#000!important}.btn-light.active,.btn-light.btn-stroke.active,.btn-light.btn-stroke:active,.btn-light.btn-stroke:focus,.btn-light.btn-stroke:hover,.btn-light:active,.btn-light:focus,.btn-light:hover,.open .dropdown-toggle.btn-light{color:#000;background-color:#eaeaea!important;border-color:#e3e3e3!important}.btn-light.btn-addon>i{border:1px solid #e8e8e8;background-color:#e8e8e8}.btn-light.btn-stroke{color:#f7f7f7!important;background-color:transparent}.btn-horizontal-align{margin-top:38px}.btn{font-weight:500;border-radius:3px;outline:0!important;box-shadow:0 1px 1px rgba(90,90,90,.1);font-family:Open Sans,sans-serif;font-weight:400}.btn>i.pull-left,.btn>i.pull-right{line-height:1.42857143}.btn-link{color:#494948}.btn-link.active{webkit-box-shadow:none;box-shadow:none}.btn-block{padding-left:12px;padding-right:12px}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:3px}.btn-group-vertical>.btn:last-child:not(:first-child){border-bottom-left-radius:3px}.btn-rounded{border-radius:50px;padding-left:15px;padding-right:15px}.btn-rounded.btn-lg{padding-left:25px;padding-right:25px}.btn-addon i{margin:-7px -12px;margin-right:12px;width:34px;height:34px;line-height:34px;text-align:center;float:left;position:relative;left:-1px;border-radius:3px 0 0 3px}.btn-addon i.pull-right{left:auto;right:-1px;margin-right:-12px;margin-left:12px;border-radius:0 3px 3px 0}.btn-addon.btn-sm i{margin:-6px -10px;margin-right:10px;width:30px;height:30px;line-height:30px}.btn-addon.btn-sm i.pull-right{margin-right:-10px;margin-left:10px}.btn-addon.btn-lg i{margin:-11px -16px;margin-right:16px;width:46px;height:46px;line-height:45px}.btn-addon.btn-lg i.pull-right{margin-right:-16px;margin-left:16px}.btn-clip{border-color:rgba(0,0,0,.1)!important;background-clip:padding-box}.btn-icon{padding-left:0!important;padding-right:0!important;width:34px;height:34px;padding:0;text-align:center;line-height:34px}.btn-icon.btn-sm{width:30px;height:30px;line-height:30px}.btn-icon.btn-lg{width:45px;height:45px;line-height:45px}.btn-groups .btn{margin-bottom:5px}.btn-fw{min-width:120px}.btn-planner:focus,.btn-planner:hover{color:#fff;text-decoration:none}.btn-evaluation{border-style:solid;border-color:#fff;background-color:hsla(0,0%,100%,.4)}.dropdown-menu{background-color:#f7f7f7;border-radius:3px;box-shadow:0 2px 6px rgba(0,0,0,.15);border:1px solid rgba(0,0,0,.1);transform-origin:top left}.dropdown-menu.pull-left{left:100%}.dropdown-menu.pull-right{left:auto!important;transform-origin:top right}.dropdown-menu.pull-up{top:0}.dropup .dropdown-menu{transform-origin:bottom left}.dropup .dropdown-menu.pull-right{transform-origin:bottom right}.dropdown-menu>.panel{border:none;margin:-5px 0}.dropdown-menu>li>a{color:#000!important;padding:8px 16px;margin:0 5px}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover,.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{background-image:none;filter:none;background-color:#d1d1d1!important;color:#000!important}.dropdown-menu.top,.dropdown-menu.top-left,.dropdown-menu.top-right{margin-top:-2px}.dropdown-menu.datepicker{padding-left:5px;padding-right:5px;font-size:12px}.dropdown-menu.datepicker .btn{font-size:12px}.dropdown-menu.timepicker{padding-top:5px;padding-bottom:5px;font-size:12px}.dropdown-menu.timepicker .btn{font-size:12px}.dropdown-menu-scale{display:block;opacity:0;transform:scale(0);transition:all .25s;-webkit-backface-visibility:hidden;backface-visibility:hidden}.open>.dropdown-menu-scale{opacity:1;transform:scale(1)}.dropdown-header{padding:8px 16px}.dropdown-submenu{position:relative}.dropdown-submenu:focus>a,.dropdown-submenu:hover>a{background-color:inherit!important}.dropdown-submenu:focus>.dropdown-menu,.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu.pull-left{float:none!important}.dropdown-submenu.pull-left>.dropdown-menu{left:-100%;margin-left:10px}.dropdown-submenu .dropdown-menu{left:100%;top:0;margin-top:-6px;margin-left:-1px}.dropup .dropdown-submenu>.dropdown-menu{top:auto;bottom:0}@media (max-width:767px){.dropdown-menu.pull-none-xs{left:0}}.form-control{border-color:#eaeaea;border-radius:3px}.form-control,.form-control:focus{box-shadow:none}.form-control:focus{border-color:#b7b7b7}.form-control::-webkit-input-placeholder{color:inherit;opacity:.3}.form-control::-moz-placeholder{color:inherit;opacity:.3}.form-control:-ms-input-placeholder{color:inherit;opacity:.3}.form-control-spin{position:absolute;z-index:2;right:10px;top:50%;margin-top:-7px}.form-horizontal .form-group-lg .form-control,.input-lg{height:45px;border-radius:3px}.input-group-addon{border-color:#eaeaea;background-color:#f7f7f7}.form-group-stack .form-control{margin-top:-1px;position:relative;border-radius:0}.form-group-stack .form-control:active,.form-group-stack .form-control:focus{z-index:1}.form-validation .form-control.ng-dirty.ng-invalid{border-color:#e95d0f}.form-validation .form-control.ng-dirty.ng-valid,.form-validation .form-control.ng-dirty.ng-valid:focus{border-color:#6abfb2}.form-validation .ui-checks .ng-invalid.ng-dirty+i{border-color:#e95d0f}.form-file{position:relative}.form-file input{position:absolute;width:100%;height:100%;opacity:0}@media (max-width:992px){.form-horizontal .form-group{margin-left:-8px;margin-right:-8px}}.list-group{border-radius:3px;background:#fff}.list-group.no-radius .list-group-item{border-radius:0!important}.list-group.no-borders .list-group-item{border:none}.list-group.no-border .list-group-item{border-width:1px 0}.list-group.no-bg .list-group-item{background-color:transparent}.list-group-item,.list-group.list-group-gap{background:transparent}.list-group-item{border-left-color:transparent;border-right-color:transparent;border-color:hsla(210,4%,45%,.045);padding:12px 16px}a.list-group-item{color:inherit}a.list-group-item.hover,a.list-group-item:focus,a.list-group-item:hover{color:inherit;background-color:hsla(210,4%,45%,.075)}.list-group-item.media{margin-top:0}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{color:inherit;background-color:hsla(210,4%,45%,.075);border-color:transparent;border-bottom-color:1px solid hsla(210,4%,45%,.075)}.list-group-item.active:focus a,.list-group-item.active:hover a,.list-group-item.active a{color:inherit}.list-group-alt .list-group-item.active:nth-child(2n+2),.list-group-alt .list-group-item:nth-child(2n+2){background-color:hsla(210,4%,45%,.075)}.list-group-lg .list-group-item{padding:16px 24px}.list-group-md .list-group-item{padding-top:16px;padding-bottom:16px}.list-group-sm .list-group-item{padding:10px 12px}.list-group-gap .list-group-item{margin-bottom:5px;border-radius:3px;background:#fff}.green-bllt li{list-style-image:url(" + __webpack_require__(1540) + ")}.modal.fade .left{transform:translate3d(-100%,0,0)}.modal.fade .left,.modal.fade .right{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal.fade .right{transform:translate3d(100%,0,0)}.modal.fade .top{transform:translate3d(0,-100%,0)}.modal.fade .bottom,.modal.fade .top{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal.fade .bottom{transform:translate3d(0,100%,0)}.modal.in .bottom,.modal.in .left,.modal.in .right,.modal.in .top{transform:translateZ(0)}.modal.inactive{bottom:auto;overflow:visible}.modal>.left{left:0;right:auto}.modal>.left,.modal>.right{position:fixed;z-index:1055;top:0;bottom:0}.modal>.right{left:auto;right:0}.modal>.top{top:0;bottom:auto}.modal>.bottom,.modal>.top{position:fixed;z-index:1055;left:0;right:0}.modal>.bottom{top:auto;bottom:0}.modal-backdrop{background-color:#6f6f6e}.modal-backdrop.in{opacity:.8;filter:alpha(opacity=80)}.modal-over{left:0;right:0;top:0;bottom:0;position:fixed}.modal-center{position:absolute;left:50%;top:50%}.modal-header{border-bottom:none}.modal-backdrop{background-color:#171717}.bottom-modal-btn.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-left-radius:0;border-bottom-right-radius:0;border-top-right-radius:0}.bottom-modal-btn.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-right-radius:0!important;border-bottom-left-radius:0;border-top-left-radius:0}.bottom-modal-btn .btn,.bottom-modal-btn .btn:focus,.bottom-modal-btn .btn:hover{color:#fff}button.md-btn.overflow-button{position:relative;display:block;margin:auto;top:14px}.input-line{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit;text-align:center}.caja-verde{background-color:rgba(170,206,59,.5)}.nav>li>a:focus,.nav>li>a:hover{background-color:#2d3039;color:#fff}.nav>li.active>a{background-color:#353942;color:#e95d0f}#transparentMenu .nav>li>a:focus,#transparentMenu .nav>li>a:hover{background-color:transparent;color:#fff}#transparentMenu .nav>li.active>a{background-color:transparent;color:#e95d0f}.rojo-nav-hover:hover{background-color:#e95d0f!important}.azul-nav-hover:hover{background-color:#636f07!important}.nav>li>a{padding:10px 16px}.nav.nav-lg>li>a{padding:20px}.nav.nav-md>li>a{padding:16px}.nav.nav-sm>li>a{font-size:13px;padding:6px 12px}.nav.nav-xs>li>a{font-size:12px;padding:4px 10px}.nav.nav-xxs>li>a{font-size:12px;padding:1px 10px}.nav.nav-rounded>li>a{border-radius:20px}.nav.no-radius>li>a{border-radius:0}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:inherit}.nav-pills>li.active>a,.nav-pills>li.active>a:active,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#494948;background-color:#eaeaea}.nav-pills>li.active>a>.text-muted{color:#494948}.nav-tabs{border-color:#eaeaea}.nav-tabs>li>a{border-radius:3px 3px 0 0;border-bottom-color:#eaeaea;color:#2d3039}.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover .nav-tabs>li.active>a:focus,.nav-tabs>li:hover>a{border-color:#eaeaea;background-color:#fff;color:#2d3039}.nav-tabs>li.active>a{border-bottom-color:#fff!important}.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0;border-radius:3px 3px 0 0}.nav-lines{margin-bottom:-1px;border-width:0!important}.nav-lines.nav-justified{border-bottom:2px solid #636f07;margin-bottom:-2px}.nav-lines>li{float:left;border-color:inherit;opacity:.6}.nav-lines>li:after{content:\"\";position:absolute;left:50%;right:50%;bottom:0;border-bottom-width:2px;border-bottom-style:solid;border-bottom-color:transparent;transition:all .3s cubic-bezier(.35,0,.25,1)}.nav-lines>li>a{background-color:transparent!important;border-width:0!important}.nav-lines>li.active{opacity:1;z-index:5}.nav-lines>li.active:after{left:0;right:0;border-bottom-color:inherit}.nav-lines.nav-lines-top>li:after{bottom:auto;top:0}.nav-lists a{border-bottom:1px solid #eaeaea}.tab-container{margin-bottom:15px}.tab-container .tab-content{padding:15px;background-color:#fff;border:1px solid #eaeaea;border-top-width:0;border-radius:0 0 3px 3px}.navbar{border:none;margin:0;position:relative;z-index:50;min-height:64px}.navbar .navbar-brand,.navbar .navbar-item,.navbar .navbar-nav>li>a,.navbar .navbar-tool>li>a{padding:0 16px;line-height:64px}.navbar .navbar-tool.nav-sm>li>a{padding-left:10px;padding-right:10px}.navbar .navbar-tool>li{float:left}.navbar .navbar-brand{font-size:20px;font-weight:700;display:block;float:none}.navbar .navbar-brand:hover{text-decoration:none}.navbar .navbar-brand img,.navbar .navbar-brand svg{display:inline-block;vertical-align:-10%}@media (max-width:991px){.navbar,.navbar .navbar-brand{min-height:50px}.navbar .navbar-brand,.navbar .navbar-item,.navbar .navbar-nav>li>a,.navbar .navbar-tool>li>a{line-height:50px}}.pagination>li>a{border-color:#eaeaea}.pagination>li>a:focus,.pagination>li>a:hover{border-color:#eaeaea;background-color:#f7f7f7}.panel{border-radius:3px;margin-bottom:8px;box-shadow:none}.panel .accordion-toggle{font-size:14px;display:block;cursor:pointer}.panel .list-group-item{border-color:#f7f7f7}.panel-card,.panel.no-borders,.panel.no-borders .panel-footer,.panel.no-borders .panel-heading{border-width:0}.panel-card{box-shadow:0 1px 2px rgba(0,0,0,.15);border-radius:0}.panel-heading{padding:16px 24px;border-radius:3px 3px 0 0}.panel-default .panel-heading{background-color:#788709;color:#fff}.panel-default .panel-heading.bg-white{background-color:#fff}.panel-heading.no-border{margin:-1px -1px 0;border:none}.panel-heading .nav{margin:-12px -16px}.panel-heading .list-group{background:transparent}.panel-heading.panel-heading-sm{padding-top:8px;padding-bottom:8px}.panel-heading.panel-heading-xs{padding-top:6px;padding-bottom:6px}.panel-body,.panel-footer{padding:16px 24px}.panel-footer{border-color:#f7f7f7;border-radius:0 0 3px 3px;background-color:#b9cf0d}.panel-footer.panel-footer-sm{padding-top:8px;padding-bottom:8px}.panel-footer.panel-footer-xs{padding-top:6px;padding-bottom:6px}.panel-group .panel-heading+.panel-collapse .panel-body{border-top:1px solid #f7f7f7}.panel-default{border-color:#eaeaea}.panel-default>.panel-footer,.panel-default>.panel-heading{border-color:#f7f7f7}.panel-primary{border-color:#dde0ca}.panel-primary>.panel-heading{color:#0d0f01;background-color:#e8e9da;border-color:#dde0ca}.panel-info{border-color:#dde0ca}.panel-info>.panel-heading{color:#0d0f01;background-color:#e8e9da;border-color:#dde0ca}.panel-success{border-color:#d7eeea}.panel-success>.panel-heading{color:#3b887d;background-color:#e9f5f3;border-color:#d7eeea}.panel-warning{border-color:#fff2c3}.panel-warning>.panel-heading{color:#b18b01;background-color:#fff8dd;border-color:#fff2c3}.panel-danger{border-color:#fad7c4}.panel-danger>.panel-heading{color:#893709;background-color:#fce7db;border-color:#fad7c4}.panel-dark{border-color:#dddddc}.panel-dark>.panel-heading{color:#3c3c3b;background-color:#e9e9e9;border-color:#dddddc}.detail-box{width:49%;float:left;text-align:center;box-sizing:border-box}.v-line-grey{height:60px;background-color:#ccc;width:1px;display:block;float:left}.box-config .panel-heading{padding:5px;border-radius:3px 3px 0 0}.box-config .panel-body{padding:2px 24px 16px}.box-config h4{font-size:16px!important;font-weight:600;margin-bottom:0}.detail-box p.name{font-size:14px;color:#ccd0db}.detail-box p{font-size:22px;color:#758295;margin-bottom:0}.panel-heading{position:relative;padding:15px 24px}.panel-heading h1,.panel-heading h2,.panel-heading h3,.panel-heading h4,.panel-heading h5,.panel-heading h6{margin:0}.panel-heading small{margin-top:8px;opacity:.5}.progress{background-color:#f7f7f7}.progress-xxxs{height:1px}.progress-xxs{height:2px}.progress-xs{height:6px}.progress-sm{height:12px}.progress-sm .progress-bar{font-size:10px;line-height:12px}.progress,.progress-bar{box-shadow:none}.progress-bar-info,.progress-bar-primary{background-color:#636f07}.progress-bar-success{background-color:#6abfb2}.progress-bar-warning{background-color:#fecd1a}.progress-bar-accent,.progress-bar-danger{background-color:#e95d0f}.progress-bar-dark{background-color:#6f6f6e}.progress-bar-white{background-color:#fff}.col-0{clear:left}.row.no-gutter{margin-left:0;margin-right:0}.no-gutter [class*=col]{padding:0}.row-sm{margin-left:-8px;margin-right:-8px}.row-sm>div{padding-left:8px;padding-right:8px}.row-xs{margin-left:-4px;margin-right:-4px}.row-xs>div{padding-left:4px;padding-right:4px}@media (max-width:992px){.row{margin-left:-8px;margin-right:-8px}.row>div{padding-left:8px;padding-right:8px}.row-2 [class*=col]{width:50%;float:left}.row-2 .col-0{clear:none}.row-2 li:nth-child(odd){clear:left;margin-left:0}}@media (max-width:767px){.row{margin-left:-4px;margin-right:-4px}.row>div{padding-left:4px;padding-right:4px}}.gutter-20.row{margin-right:-10px;margin-left:-10px}.gutter-20>[class^=\" col-\"],.gutter-20>[class^=col-]{padding-right:10px;padding-left:10px}.gutter-10.row{margin-right:-5px;margin-left:-5px}.gutter-10>[class^=\" col-\"],.gutter-10>[class^=col-]{padding-right:5px;padding-left:5px}.gutter-0.row{margin-right:0;margin-left:0}.gutter-0>[class^=\" col-\"],.gutter-0>[class^=col-]{padding-right:0;padding-left:0}.panel .table{border-color:#eaeaea!important}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th{border-top:1px solid #ddd}.table>thead>tr>th{border-bottom:1px solid #ddd}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>thead>tr>th{border-color:#eaeaea}.table-striped>tbody>tr:nth-child(odd)>td,.table-striped>tbody>tr:nth-child(odd)>th,.table-striped>thead>th{background-color:#f7f7f7}.table-striped>thead>th{border-right:1px solid #eaeaea}.table-striped>thead>th:last-child{border-right:none}table.table.disabled{opacity:.2;cursor:not-allowed}.align-td{text-align:center}.thead-color{background-color:#d8d8d8}.ngRow.even{background-color:#f2f5f7}.ngRow.odd{background-color:#d8d8d8}.line-down{opacity:.85;text-decoration:underline}.grad-1,.grad-2,.grad-3,.grad-4{background:#636f07}.grad-white{background:#fcfcfc}.grad-5{background:#636f07}.grad-oblique-negro-dark{background:#353942;background:linear-gradient(177deg,#353942 78%,transparent 79%)}.grad-oblique-azul{background:#2053d2;background:linear-gradient(177deg,#2053d2 78%,transparent 79%)}.grad-oblique-teal{background:#00bfa5;background:linear-gradient(177deg,#00bfa5 78%,transparent 79%)}.grad-oblique-deep-orange{background:#ff7043;background:linear-gradient(177deg,#ff7043 78%,transparent 79%)}.md-btn,[md-ink-ripple]{position:relative}.md-btn{color:currentColor;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;border:0;border-radius:3px;padding:6px;display:inline-block;background:transparent;white-space:nowrap;text-align:center;font-weight:700;font-style:inherit;font-variant:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-decoration:none;cursor:pointer;overflow:hidden;transition:box-shadow .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),transform .4s cubic-bezier(.25,.8,.25,1)}.md-button{text-transform:none!important}.md-button.md-default-theme.md-primary.md-fab,.md-button.md-default-theme.md-primary.md-raised,.md-button.md-primary.md-fab,.md-button.md-primary.md-raised,a.md-button.md-default-theme.md-primary.md-fab,a.md-button.md-default-theme.md-primary.md-raised,a.md-button.md-primary.md-fab,a.md-button.md-primary.md-raised{background-color:#e95d0f!important;color:#fff}md-toolbar.md-default-theme:not(.md-menu-toolbar),md-toolbar:not(.md-menu-toolbar){background-color:#aace3b;color:hsla(0,0%,100%,.87)}md-fab-toolbar{z-index:9999999}.md-btn.md-flat:not([disabled]):focus,.md-btn.md-flat:not([disabled]):hover{background-color:hsla(0,0%,62%,.2)}.md-btn-circle{width:28px;height:28px;border-radius:50%}.md-btn.md-fab[disabled],.md-btn.md-raised[disabled],.md-btn[disabled]{color:rgba(0,0,0,.26);background-color:transparent;cursor:not-allowed}.md-fab{line-height:44px}.md-fab-offset{margin-top:-28px;margin-bottom:-28px}.md-btn:focus{outline:none}.md-btn:hover{text-decoration:none}.md-btn.md-cornered{border-radius:0}.md-btn.md-icon{padding:0;background:none}.md-btn.md-fab,.md-btn.md-raised{transform:translateZ(0)}.md-btn.md-fab{z-index:20;width:56px;height:56px;border-radius:50%;overflow:hidden;transition:.2s linear;transition-property:transform,box-shadow}.md-btn.md-fab,.md-btn.md-raised:not([disabled]){box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-btn.md-fab:not([disabled]):focus,.md-btn.md-fab:not([disabled]):hover,.md-btn.md-raised:not([disabled]):focus,.md-btn.md-raised:not([disabled]):hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.4)}.md-btn.md-fab.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}.md-fab-toolbar.md-fab-bottom-right-2{top:auto;right:20px;bottom:20px;left:0;position:absolute}.md-btn.md-fab.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}.md-btn.md-fab.md-fab-top-right{top:20px;right:20px;bottom:auto;left:auto;position:absolute}.md-btn.md-fab.md-fab-top-left{top:20px;right:auto;bottom:auto;left:20px;position:absolute}.md-btn.md-fab md-icon{margin-top:0}.md-btn.md-fab.md-mini{width:40px;height:40px}.md-btn:not([disabled]).md-fab:focus,.md-btn:not([disabled]).md-fab:hover,.md-btn:not([disabled]).md-raised:focus,.md-btn:not([disabled]).md-raised:hover{transform:translate3d(0,-1px,0)}.md-toast-open-top .md-btn.md-fab-top-left,.md-toast-open-top .md-btn.md-fab-top-right{transform:translate3d(0,42px,0)}.md-toast-open-top .md-btn.md-fab-top-left:not([disabled]):focus,.md-toast-open-top .md-btn.md-fab-top-left:not([disabled]):hover,.md-toast-open-top .md-btn.md-fab-top-right:not([disabled]):focus,.md-toast-open-top .md-btn.md-fab-top-right:not([disabled]):hover{transform:translate3d(0,41px,0)}.md-toast-open-bottom .md-btn.md-fab-bottom-left,.md-toast-open-bottom .md-btn.md-fab-bottom-right{transform:translate3d(0,-42px,0)}.md-toast-open-bottom .md-btn.md-fab-bottom-left:not([disabled]):focus,.md-toast-open-bottom .md-btn.md-fab-bottom-left:not([disabled]):hover,.md-toast-open-bottom .md-btn.md-fab-bottom-right:not([disabled]):focus,.md-toast-open-bottom .md-btn.md-fab-bottom-right:not([disabled]):hover{transform:translate3d(0,-43px,0)}.card{font-family:Roboto,sans-serif!important;box-shadow:0 1px 2px rgba(0,0,0,.15);background-color:#fff;position:relative;margin-bottom:8px;overflow:hidden}.card.active:hover{box-shadow:0 5px 10px rgba(0,0,0,.5);transition:box-shadow .5s ease}.card a{color:#e95d0f;text-decoration:none}.card-heading{position:relative;padding:15px 24px}.card-heading h1,.card-heading h2,.card-heading h3,.card-heading h4,.card-heading h5,.card-heading h6{margin:0}.card-heading small{margin-top:8px;opacity:.5}.card-body{padding:20px 24px}.card-divider{border-bottom:1px solid hsla(210,4%,45%,.15);margin:0 24px}.card-tools{position:absolute;right:12px;top:12px}.blue-500 small,.blue-600 small,.blue-700 small,.blue-A200 small,.blue-A400 small,.blue-A700 small,.blue-grey-400 small,.blue-grey-500 small,.blue-grey small,.blue small,.brown-300 small,.brown-400 small,.cyan-500 small,.cyan-600 small,.cyan-700 small,.cyan-800 small,.cyan small,.deep-orange-500 small,.deep-orange-600 small,.deep-orange-700 small,.deep-orange-800 small,.deep-orange-900 small,.deep-orange-A400 small,.deep-orange-A700 small,.deep-orange small,.deep-purple-300 small,.deep-purple-400 small,.deep-purple-A200 small,.green-500 small,.green-600 small,.green-700 small,.green small,.indigo-300 small,.indigo-400 small,.indigo-A200 small,.indigo-A400 small,.light-blue-500 small,.light-blue-600 small,.light-blue-700 small,.light-blue-800 small,.light-blue-A700 small,.light-blue small,.light-green-800 small,.light-green-900 small,.lime-900 small,.orange-800 small,.orange-900 small,.pink-500 small,.pink-600 small,.pink-A200 small,.pink-A400 small,.pink-A700 small,.pink small,.purple-300 small,.purple-400 small,.purple-A200 small,.purple-A400 small,.purple-A700 small,.red-500 small,.red-600 small,.red-700 small,.red-A200 small,.red-A400 small,.red-A700 small,.red small,.teal-500 small,.teal-600 small,.teal-700 small,.teal small{color:#fff;opacity:.7}.azul{background-color:#2053d2}.azul-light{background-color:#468ac2}.amarillo{background-color:#fab813}.verde{background-color:#aace3b}.gris-dark{background-color:#91a3bd}.gris-darker{background-color:#758295}.rojo{background-color:#ef7955}.morado{background-color:#7e57c2}.naranjo{background-color:#ff9800}.blanco{background-color:#fff}.gris-light{background-color:#ccd0db}.gris-lighter{background-color:#f2f5f7}.negro-darker{background-color:#2d3039}.negro-dark{background-color:#353942}.gris-base{background-color:#f9f9f9}.cian-light{background-color:#53c3ab}.verde-light-msgs{background-color:#d7e6a7}.text-azul{color:#2053d2}.text-azul-light{color:#468ac2}.text-amarillo{color:#fab813}.text-verde{color:#aace3b}.text-gris-dark{color:#91a3bd}.text-gris-darker{color:#758295}.text-rojo{color:#ef7955}.text-morado{color:#7e57c2}.text-naranja{color:#ff9800}.text-cian{color:#53c3ab}.text-blanco{color:#fff}.text-gris-lighter{color:#f2f5f7}.text-negro-darker{color:#2d3039}.text-negro-dark{color:#353942}.text-negro-opacity{color:rgba(0,0,0,.45)}.text-verde-msgs{color:#667142}.text-rojo-important{color:#ef7955!important}.text-amarillo-important{color:#fab813!important}.text-negro-darker-important{color:#2d3039!important}.alert-manual{background:rgba(250,184,19,.2)}.alert-high{background:rgba(239,121,85,.2)}.bg-azul-light{background:rgba(70,138,194,.3)}.bg-azul{background:rgba(32,83,210,.3)}.bg-verde{background:rgba(170,206,59,.3)}.bg-amarillo{background:rgba(250,184,19,.3)}.bg-rojo{background:rgba(239,121,85,.3)}.bg-morado{background:rgba(126,87,194,.3)}.bg-rojo-dark{background:#ae1f35}.red{background-color:#d7634a}.red-50{background-color:#ffebee}.red-100{background-color:#ffcdd2}.red-200{background-color:#ef9a9a}.red-300{background-color:#e57373}.red-400{background-color:#ef5350}.red-500{background-color:#d7634a}.red-600{background-color:#e53935}.red-700{background-color:#d32f2f}.red-800{background-color:#c62828}.red-900{background-color:#b71c1c}.red-A100{background-color:#ff8a80}.red-A200{background-color:#ff5252}.red-A400{background-color:#ff1744}.red-A700{background-color:#d50000}.pink{background-color:#e91e63}.pink-50{background-color:#fce4ec}.pink-100{background-color:#f8bbd0}.pink-200{background-color:#f48fb1}.pink-300{background-color:#f06292}.pink-400{background-color:#ec407a}.pink-500{background-color:#e91e63}.pink-600{background-color:#d81b60}.pink-700{background-color:#c2185b}.pink-800{background-color:#ad1457}.pink-900{background-color:#880e4f}.pink-A100{background-color:#ff80ab}.pink-A200{background-color:#ff4081}.pink-A400{background-color:#f50057}.pink-A700{background-color:#c51162}.purple{background-color:#9c27b0}.purple-50{background-color:#f3e5f5}.purple-100{background-color:#e1bee7}.purple-200{background-color:#ce93d8}.purple-300{background-color:#ba68c8}.purple-400{background-color:#ab47bc}.purple-500{background-color:#9c27b0}.purple-600{background-color:#8e24aa}.purple-700{background-color:#7b1fa2}.purple-800{background-color:#6a1b9a}.purple-900{background-color:#4a148c}.purple-A100{background-color:#ea80fc}.purple-A200{background-color:#e040fb}.purple-A400{background-color:#d500f9}.purple-A700{background-color:#a0f}.deep-purple{background-color:#673ab7}.deep-purple-50{background-color:#ede7f6}.deep-purple-100{background-color:#d1c4e9}.deep-purple-200{background-color:#b39ddb}.deep-purple-300{background-color:#9575cd}.deep-purple-400{background-color:#7e57c2}.deep-purple-500{background-color:#673ab7}.deep-purple-600{background-color:#5e35b1}.deep-purple-700{background-color:#512da8}.deep-purple-800{background-color:#4527a0}.deep-purple-900{background-color:#311b92}.deep-purple-A100{background-color:#b388ff}.deep-purple-A200{background-color:#7c4dff}.deep-purple-A400{background-color:#651fff}.deep-purple-A700{background-color:#6200ea}.indigo{background-color:#3f51b5}.indigo-50{background-color:#e8eaf6}.indigo-100{background-color:#c5cae9}.indigo-200{background-color:#9fa8da}.indigo-300{background-color:#7986cb}.indigo-400{background-color:#5c6bc0}.indigo-500{background-color:#3f51b5}.indigo-600{background-color:#3949ab}.indigo-700{background-color:#303f9f}.indigo-800{background-color:#283593}.indigo-900{background-color:#1a237e}.indigo-A100{background-color:#8c9eff}.indigo-A200{background-color:#536dfe}.indigo-A400{background-color:#3d5afe}.indigo-A700{background-color:#304ffe}.blue{background-color:#00548a}.blue-50{background-color:#e3f2fd}.blue-100{background-color:#bbdefb}.blue-200{background-color:#90caf9}.blue-300{background-color:#64b5f6}.blue-400{background-color:#42a5f5}.blue-500{background-color:#00548a}.blue-600{background-color:#1e88e5}.blue-700{background-color:#1976d2}.blue-800{background-color:#1565c0}.blue-900{background-color:#0d47a1}.blue-A100{background-color:#82b1ff}.blue-A200{background-color:#448aff}.blue-A400{background-color:#2979ff}.blue-A700{background-color:#2962ff}.light-blue{background-color:#468ac2}.light-blue-50{background-color:#e1f5fe}.light-blue-100{background-color:#b3e5fc}.light-blue-200{background-color:#81d4fa}.light-blue-300{background-color:#4fc3f7}.light-blue-400{background-color:#29b6f6}.light-blue-500{background-color:#468ac2}.light-blue-600{background-color:#039be5}.light-blue-700{background-color:#0288d1}.light-blue-800{background-color:#0277bd}.light-blue-900{background-color:#01579b}.light-blue-A100{background-color:#80d8ff}.light-blue-A200{background-color:#40c4ff}.light-blue-A400{background-color:#00b0ff}.light-blue-A700{background-color:#0091ea}.cyan{background-color:#00bcd4}.cyan-50{background-color:#e0f7fa}.cyan-100{background-color:#b2ebf2}.cyan-200{background-color:#80deea}.cyan-300{background-color:#4dd0e1}.cyan-400{background-color:#26c6da}.cyan-500{background-color:#00bcd4}.cyan-600{background-color:#00acc1}.cyan-700{background-color:#0097a7}.cyan-800{background-color:#00838f}.cyan-900{background-color:#006064}.cyan-A100{background-color:#84ffff}.cyan-A200{background-color:#18ffff}.cyan-A400{background-color:#00e5ff}.cyan-A700{background-color:#00b8d4}.teal{background-color:#009688}.teal-50{background-color:#e0f2f1}.teal-100{background-color:#b2dfdb}.teal-200{background-color:#80cbc4}.teal-300{background-color:#4db6ac}.teal-400{background-color:#26a69a}.teal-500{background-color:#009688}.teal-600{background-color:#00897b}.teal-700{background-color:#00796b}.teal-800{background-color:#00695c}.teal-900{background-color:#004d40}.teal-A100{background-color:#a7ffeb}.teal-A200{background-color:#64ffda}.teal-A400{background-color:#1de9b6}.teal-A700{background-color:#00bfa5}.green{background-color:#4caf50}.green-50{background-color:#e8f5e9}.green-100{background-color:#c8e6c9}.green-200{background-color:#a5d6a7}.green-300{background-color:#81c784}.green-400{background-color:#66bb6a}.green-500{background-color:#4caf50}.green-600{background-color:#43a047}.green-700{background-color:#388e3c}.green-800{background-color:#2e7d32}.green-900{background-color:#1b5e20}.green-A100{background-color:#b9f6ca}.green-A200{background-color:#69f0ae}.green-A400{background-color:#00e676}.green-A700{background-color:#00c853}.light-green{background-color:#8bc34a}.light-green-50{background-color:#f1f8e9}.light-green-100{background-color:#dcedc8}.light-green-200{background-color:#c5e1a5}.light-green-300{background-color:#aed581}.light-green-400{background-color:#9ccc65}.light-green-500{background-color:#8bc34a}.light-green-600{background-color:#7cb342}.light-green-700{background-color:#689f38}.light-green-800{background-color:#558b2f}.light-green-900{background-color:#33691e}.light-green-A100{background-color:#ccff90}.light-green-A200{background-color:#b2ff59}.light-green-A400{background-color:#76ff03}.light-green-A700{background-color:#64dd17}.lime{background-color:#a8c329}.lime-50{background-color:#f9fbe7}.lime-100{background-color:#f0f4c3}.lime-200{background-color:#e6ee9c}.lime-300{background-color:#dce775}.lime-400{background-color:#d4e157}.lime-500{background-color:#a8c329}.lime-600{background-color:#c0ca33}.lime-700{background-color:#afb42b}.lime-800{background-color:#9e9d24}.lime-900{background-color:#827717}.lime-A100{background-color:#f4ff81}.lime-A200{background-color:#eeff41}.lime-A400{background-color:#c6ff00}.lime-A700{background-color:#aeea00}.yellow{background-color:#ffeb3b}.yellow-50{background-color:#fffde7}.yellow-100{background-color:#fff9c4}.yellow-200{background-color:#fff59d}.yellow-300{background-color:#fff176}.yellow-400{background-color:#ffee58}.yellow-500{background-color:#ffeb3b}.yellow-600{background-color:#fdd835}.yellow-700{background-color:#fbc02d}.yellow-800{background-color:#f9a825}.yellow-900{background-color:#f57f17}.yellow-A100{background-color:#ffff8d}.yellow-A200{background-color:#ff0}.yellow-A400{background-color:#ffea00}.yellow-A700{background-color:#ffd600}.amber{background-color:#fab813}.amber-50{background-color:#fff8e1}.amber-100{background-color:#ffecb3}.amber-200{background-color:#ffe082}.amber-300{background-color:#ffd54f}.amber-400{background-color:#ffca28}.amber-500{background-color:#fab813}.amber-600{background-color:#ffb300}.amber-700{background-color:#ffa000}.amber-800{background-color:#ff8f00}.amber-900{background-color:#ff6f00}.amber-A100{background-color:#ffe57f}.amber-A200{background-color:#ffd740}.amber-A400{background-color:#ffc400}.amber-A700{background-color:#ffab00}.orange{background-color:#ff9800}.orange-50{background-color:#fff3e0}.orange-100{background-color:#ffe0b2}.orange-200{background-color:#ffcc80}.orange-300{background-color:#ffb74d}.orange-400{background-color:#ffa726}.orange-500{background-color:#ff9800}.orange-600{background-color:#fb8c00}.orange-700{background-color:#f57c00}.orange-800{background-color:#ef6c00}.orange-900{background-color:#e65100}.orange-A100{background-color:#ffd180}.orange-A200{background-color:#ffab40}.orange-A400{background-color:#ff9100}.orange-A700{background-color:#ff6d00}.deep-orange{background-color:#ff5722}.deep-orange-50{background-color:#fbe9e7}.deep-orange-100{background-color:#ffccbc}.deep-orange-200{background-color:#ffab91}.deep-orange-300{background-color:#ff8a65}.deep-orange-400{background-color:#ff7043}.deep-orange-500{background-color:#ff5722}.deep-orange-600{background-color:#f4511e}.deep-orange-700{background-color:#e64a19}.deep-orange-800{background-color:#d84315}.deep-orange-900{background-color:#bf360c}.deep-orange-A100{background-color:#ff9e80}.deep-orange-A200{background-color:#ff6e40}.deep-orange-A400{background-color:#ff3d00}.deep-orange-A700{background-color:#dd2c00}.brown{background-color:#795548}.brown-50{background-color:#efebe9}.brown-100{background-color:#d7ccc8}.brown-200{background-color:#bcaaa4}.brown-300{background-color:#a1887f}.brown-400{background-color:#8d6e63}.brown-500{background-color:#795548}.brown-600{background-color:#6d4c41}.brown-700{background-color:#5d4037}.brown-800{background-color:#4e342e}.brown-900{background-color:#3e2723}.blue-grey{background-color:#607d8b}.blue-grey-50{background-color:#eceff1}.blue-grey-100{background-color:#cfd8dc}.blue-grey-200{background-color:#b0bec5}.blue-grey-300{background-color:#90a4ae}.blue-grey-400{background-color:#78909c}.blue-grey-500{background-color:#607d8b}.blue-grey-600{background-color:#546e7a}.blue-grey-700{background-color:#455a64}.blue-grey-800{background-color:#37474f}.blue-grey-900{background-color:#263238}.grey{background-color:#6f6f6e}.grey-50{background-color:#fafafa}.grey-100{background-color:#f5f5f5}.grey-200{background-color:#eee}.grey-300{background-color:#e0e0e0}.grey-400{background-color:#bdbdbd}.grey-500{background-color:#6f6f6e}.grey-600{background-color:#757575}.grey-700{background-color:#616161}.grey-800{background-color:#424242}.grey-900{background-color:#212121}.blue,.blue-500,.blue-600,.blue-700,.blue-A200,.blue-A400,.blue-A700,.blue-grey,.blue-grey-400,.blue-grey-500,.brown-300,.brown-400,.cyan,.cyan-500,.cyan-600,.cyan-700,.cyan-800,.deep-orange,.deep-orange-500,.deep-orange-600,.deep-orange-700,.deep-orange-800,.deep-orange-900,.deep-orange-A400,.deep-orange-A700,.deep-purple-300,.deep-purple-400,.deep-purple-A200,.green,.green-500,.green-600,.green-700,.indigo-300,.indigo-400,.indigo-A200,.indigo-A400,.light-blue,.light-blue-500,.light-blue-600,.light-blue-700,.light-blue-800,.light-blue-A700,.light-green-800,.light-green-900,.lime-900,.orange-800,.orange-900,.pink,.pink-500,.pink-600,.pink-A200,.pink-A400,.pink-A700,.purple-300,.purple-400,.purple-A200,.purple-A400,.purple-A700,.red,.red-500,.red-600,.red-700,.red-A200,.red-A400,.red-A700,.teal,.teal-500,.teal-600,.teal-700{color:#fff}.blue-800,.blue-900,.blue-grey-600,.blue-grey-700,.blue-grey-800,.blue-grey-900,.brown,.brown-500,.brown-600,.brown-700,.brown-800,.brown-900,.cyan-900,.deep-purple,.deep-purple-500,.deep-purple-600,.deep-purple-700,.deep-purple-800,.deep-purple-900,.deep-purple-A400,.deep-purple-A700,.green-800,.green-900,.grey-600,.grey-700,.grey-800,.grey-900,.indigo,.indigo-500,.indigo-600,.indigo-700,.indigo-800,.indigo-900,.indigo-A700,.light-blue-900,.pink-700,.pink-800,.pink-900,.purple,.purple-500,.purple-600,.purple-700,.purple-800,.purple-900,.red-800,.red-900,.teal-800,.teal-900{color:hsla(0,0%,100%,.87)}.orange-A700{color:#000}.amarillo,.azul,.azul-light,.gris-dark,.gris-darker,.morado,.negro-dark,.negro-darker,.rojo,.verde{color:#fff}.gris-lighter{color:#000}.bg-azul,.bg-azul-light{color:#303f9f}.md-list{border-radius:3px}.md-list-item{display:block;position:relative;padding:16px}.md-list-item:after{content:\"\";position:absolute;left:0;right:0;bottom:0;border-bottom:1px solid hsla(0,0%,63%,.2)}.md-list-item:last-child.md-list-item:after{border:none}.md-list-item.inset.md-list-item:after{left:72px}.md-list-item-left{width:40px;height:40px;margin-right:16px;float:left;text-align:center;line-height:40px}.md-list-item-content{overflow:hidden}.md-list-item-content h3{margin:0 0 3px;font-weight:400}.md-form-group{padding:18px 0 24px;position:relative}.md-input{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit}.md-input.focus,.md-input:focus{border-color:#636f07;border-bottom-width:2px;padding-bottom:1px}.md-input.focus~label,.md-input:focus~label{color:#636f07;opacity:1;top:0!important;font-size:.85em!important}.float-label .md-input~label{top:20px;font-size:1em}.float-label .md-input.has-value~label,.float-label .md-input.ng-dirty~label,.md-input~label{top:0;font-size:.85em}.md-input~label{transition:all .2s;position:absolute;z-index:0;opacity:.5;display:inline-block;left:0}.md-input.disabled,.md-input[disabled]{opacity:.5}textarea.md-input{height:auto}.md-input-white.focus,.md-input-white:focus{border-color:#fff}.md-input-white.focus~label,.md-input-white:focus~label{color:#fff}.md-input-msg{position:absolute;bottom:0;line-height:24px;font-size:.85em}.md-input-msg.right{right:0}.height-input{padding:7px;margin-top:-2px;border:1px solid #d8d8d8}.md-check{cursor:pointer;padding-left:20px;margin:0;display:inline-block;position:relative}.md-check input{position:absolute;cursor:pointer;width:20px;height:20px;z-index:1;opacity:0;margin-left:-20px}.md-check input:checked+i:before{border-width:0;background-color:inherit}.md-check input:checked+span .active{display:inherit}.md-check input[type=radio]+i,.md-check input[type=radio]+i:before{border-radius:50%}.md-check input[type=checkbox]:checked+i:after{transform:rotate(45deg);position:absolute;left:6px;top:2px;display:table;width:6px;height:12px;border:2px solid;border-top:0;border-left:0;content:\" \"}.md-check input[type=radio]:checked+i:after{position:absolute;left:6px;top:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.md-check input[disabled]+i:before,fieldset[disabled] .md-check input+i:before{border-color:rgba(0,0,0,.26)}.md-check input[disabled]:checked+i:before{background-color:rgba(0,0,0,.26)}.md-check>i{width:0;height:18px;line-height:1;margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:28px;position:relative}.md-check>i:before{content:\"\";position:absolute;width:18px;height:100%;border:2px solid rgba(0,0,0,.54);border-radius:2px;transition:all .2s}.md-check>i.no-icon:after{display:none!important}md-checkbox.md-checked.md-green .md-icon{background-color:#aace3b}md-checkbox.md-checked.md-blue .md-icon{background-color:#468ac2}md-checkbox.md-checked.md-blue-2 .md-icon{background-color:#2053d2}.md-switch{cursor:pointer;padding-left:36px;margin:0;min-height:20px}.md-switch input{position:absolute;cursor:pointer;width:36px;height:20px;z-index:1;opacity:0;filter:alpha(opacity=0);margin-left:-36px}.md-switch input:checked+i:before{background:inherit;opacity:.5}.md-switch input:checked+i:after{background:inherit;left:16px}.md-switch input[disabled]+i:before,fieldset[disabled] .md-switch input+i:before{background-color:rgba(0,0,0,.12)}.md-switch input[disabled]+i:after,fieldset[disabled] .md-switch input+i:after{background-color:#bdbdbd}.md-switch i{width:0;height:18px;line-height:1;margin-left:-36px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:44px;position:relative}.md-switch i:before{left:1px;width:34px;top:3px;height:14px;border-radius:8px;background-color:#9e9e9e}.md-switch i:after,.md-switch i:before{content:\"\";position:absolute;transition:all .2s}.md-switch i:after{margin:0;left:0;top:0;outline:none;height:20px;width:20px;border-radius:50%;background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.box-row md-switch.md-checked .md-thumb{background-color:#4caf50}md-switch.md-checked .md-bar{background-color:rgba(76,175,80,.5)}.md-whiteframe-z0{box-shadow:0 1px 3px rgba(0,0,0,.15)}.md-whiteframe-z1{box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-whiteframe-z2{box-shadow:0 8px 17px rgba(0,0,0,.2)}.md-whiteframe-z3{box-shadow:0 17px 50px rgba(0,0,0,.19)}.md-whiteframe-z4{box-shadow:0 16px 28px 0 rgba(0,0,0,.22)}.md-whiteframe-z5{box-shadow:0 27px 24px 0 rgba(0,0,0,.2)}/*!\n * font-awesome-animation - v0.0.9\n * https://github.com/l-lin/font-awesome-animation\n * http://l-lin.github.io/font-awesome-animation/\n * License: MIT\n */@keyframes wrench{0%{transform:rotate(-12deg)}8%{transform:rotate(12deg)}10%{transform:rotate(24deg)}18%{transform:rotate(-24deg)}20%{transform:rotate(-24deg)}28%{transform:rotate(24deg)}30%{transform:rotate(24deg)}38%{transform:rotate(-24deg)}40%{transform:rotate(-24deg)}48%{transform:rotate(24deg)}50%{transform:rotate(24deg)}58%{transform:rotate(-24deg)}60%{transform:rotate(-24deg)}68%{transform:rotate(24deg)}75%,to{transform:rotate(0deg)}}.faa-parent.animated-hover:hover>.faa-wrench,.faa-wrench.animated,.faa-wrench.animated-hover:hover{animation:wrench 2.5s ease infinite;transform-origin-x:90%;transform-origin-y:35%;transform-origin-z:initial}.faa-parent.animated-hover:hover>.faa-wrench.faa-fast,.faa-wrench.animated-hover.faa-fast:hover,.faa-wrench.animated.faa-fast{animation:wrench 1.2s ease infinite}.faa-parent.animated-hover:hover>.faa-wrench.faa-slow,.faa-wrench.animated-hover.faa-slow:hover,.faa-wrench.animated.faa-slow{animation:wrench 3.7s ease infinite}@keyframes ring{0%{transform:rotate(-15deg)}2%{transform:rotate(15deg)}4%{transform:rotate(-18deg)}6%{transform:rotate(18deg)}8%{transform:rotate(-22deg)}10%{transform:rotate(22deg)}12%{transform:rotate(-18deg)}14%{transform:rotate(18deg)}16%{transform:rotate(-12deg)}18%{transform:rotate(12deg)}20%,to{transform:rotate(0deg)}}.faa-parent.animated-hover:hover>.faa-ring,.faa-ring.animated,.faa-ring.animated-hover:hover{animation:ring 2s ease infinite;transform-origin-x:50%;transform-origin-y:0;transform-origin-z:initial}.faa-parent.animated-hover:hover>.faa-ring.faa-fast,.faa-ring.animated-hover.faa-fast:hover,.faa-ring.animated.faa-fast{animation:ring 1s ease infinite}.faa-parent.animated-hover:hover>.faa-ring.faa-slow,.faa-ring.animated-hover.faa-slow:hover,.faa-ring.animated.faa-slow{animation:ring 3s ease infinite}@keyframes vertical{0%{transform:translateY(-3px)}4%{transform:translateY(3px)}8%{transform:translateY(-3px)}12%{transform:translateY(3px)}16%{transform:translateY(-3px)}20%{transform:translateY(3px)}22%,to{transform:translate(0)}}.faa-parent.animated-hover:hover>.faa-vertical,.faa-vertical.animated,.faa-vertical.animated-hover:hover{animation:vertical 2s ease infinite}.faa-parent.animated-hover:hover>.faa-vertical.faa-fast,.faa-vertical.animated-hover.faa-fast:hover,.faa-vertical.animated.faa-fast{animation:vertical 1s ease infinite}.faa-parent.animated-hover:hover>.faa-vertical.faa-slow,.faa-vertical.animated-hover.faa-slow:hover,.faa-vertical.animated.faa-slow{animation:vertical 4s ease infinite}@keyframes horizontal{0%{transform:translate(0)}6%{transform:translate(5px)}12%{transform:translate(0)}18%{transform:translate(5px)}24%{transform:translate(0)}30%{transform:translate(5px)}36%,to{transform:translate(0)}}.faa-horizontal.animated,.faa-horizontal.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-horizontal{animation:horizontal 2s ease infinite}.faa-horizontal.animated-hover.faa-fast:hover,.faa-horizontal.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-horizontal.faa-fast{animation:horizontal 1s ease infinite}.faa-horizontal.animated-hover.faa-slow:hover,.faa-horizontal.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-horizontal.faa-slow{animation:horizontal 3s ease infinite}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.faa-flash.animated,.faa-flash.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-flash{animation:flash 2s ease infinite}.faa-flash.animated-hover.faa-fast:hover,.faa-flash.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-flash.faa-fast{animation:flash 1s ease infinite}.faa-flash.animated-hover.faa-slow:hover,.faa-flash.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-flash.faa-slow{animation:flash 3s ease infinite}@keyframes bounce{0%,10%,20%,50%,80%,to{transform:translateY(0)}40%{transform:translateY(-15px)}60%{transform:translateY(-15px)}}.faa-bounce.animated,.faa-bounce.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-bounce{animation:bounce 2s ease infinite}.faa-bounce.animated-hover.faa-fast:hover,.faa-bounce.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-bounce.faa-fast{animation:bounce 1s ease infinite}.faa-bounce.animated-hover.faa-slow:hover,.faa-bounce.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-bounce.faa-slow{animation:bounce 3s ease infinite}.faa-parent.animated-hover:hover>.faa-spin,.faa-spin.animated,.faa-spin.animated-hover:hover{animation:spin 1.5s linear infinite}.faa-parent.animated-hover:hover>.faa-spin.faa-fast,.faa-spin.animated-hover.faa-fast:hover,.faa-spin.animated.faa-fast{animation:spin .7s linear infinite}.faa-parent.animated-hover:hover>.faa-spin.faa-slow,.faa-spin.animated-hover.faa-slow:hover,.faa-spin.animated.faa-slow{animation:spin 2.2s linear infinite}@keyframes float{0%{transform:translateY(0)}50%{transform:translateY(-6px)}to{transform:translateY(0)}}.faa-float.animated,.faa-float.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-float{animation:float 2s linear infinite}.faa-float.animated-hover.faa-fast:hover,.faa-float.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-float.faa-fast{animation:float 1s linear infinite}.faa-float.animated-hover.faa-slow:hover,.faa-float.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-float.faa-slow{animation:float 3s linear infinite}@keyframes pulse{0%{transform:scale(1.1)}50%{transform:scale(.8)}to{transform:scale(1.1)}}.faa-parent.animated-hover:hover>.faa-pulse,.faa-pulse.animated,.faa-pulse.animated-hover:hover{animation:pulse 2s linear infinite}.faa-parent.animated-hover:hover>.faa-pulse.faa-fast,.faa-pulse.animated-hover.faa-fast:hover,.faa-pulse.animated.faa-fast{animation:pulse 1s linear infinite}.faa-parent.animated-hover:hover>.faa-pulse.faa-slow,.faa-pulse.animated-hover.faa-slow:hover,.faa-pulse.animated.faa-slow{animation:pulse 3s linear infinite}.faa-parent.animated-hover:hover>.faa-shake,.faa-shake.animated,.faa-shake.animated-hover:hover{animation:wrench 2.5s ease infinite}.faa-parent.animated-hover:hover>.faa-shake.faa-fast,.faa-shake.animated-hover.faa-fast:hover,.faa-shake.animated.faa-fast{animation:wrench 1.2s ease infinite}.faa-parent.animated-hover:hover>.faa-shake.faa-slow,.faa-shake.animated-hover.faa-slow:hover,.faa-shake.animated.faa-slow{animation:wrench 3.7s ease infinite}@keyframes tada{0%{transform:scale(1)}10%,20%{transform:scale(.9) rotate(-8deg)}30%,50%,70%{transform:scale(1.3) rotate(8deg)}40%,60%{transform:scale(1.3) rotate(-8deg)}80%,to{transform:scale(1) rotate(0)}}.faa-parent.animated-hover:hover>.faa-tada,.faa-tada.animated,.faa-tada.animated-hover:hover{animation:tada 2s linear infinite}.faa-parent.animated-hover:hover>.faa-tada.faa-fast,.faa-tada.animated-hover.faa-fast:hover,.faa-tada.animated.faa-fast{animation:tada 1s linear infinite}.faa-parent.animated-hover:hover>.faa-tada.faa-slow,.faa-tada.animated-hover.faa-slow:hover,.faa-tada.animated.faa-slow{animation:tada 3s linear infinite}@keyframes passing{0%{transform:translateX(-50%);opacity:0}50%{transform:translateX(0);opacity:1}to{transform:translateX(50%);opacity:0}}.faa-parent.animated-hover:hover>.faa-passing,.faa-passing.animated,.faa-passing.animated-hover:hover{animation:passing 2s linear infinite}.faa-parent.animated-hover:hover>.faa-passing.faa-fast,.faa-passing.animated-hover.faa-fast:hover,.faa-passing.animated.faa-fast{animation:passing 1s linear infinite}.faa-parent.animated-hover:hover>.faa-passing.faa-slow,.faa-passing.animated-hover.faa-slow:hover,.faa-passing.animated.faa-slow{animation:passing 3s linear infinite}@keyframes passing-reverse{0%{transform:translateX(50%);opacity:0}50%{transform:translateX(0);opacity:1}to{transform:translateX(-50%);opacity:0}}.faa-parent.animated-hover:hover>.faa-passing-reverse,.faa-passing-reverse.animated,.faa-passing-reverse.animated-hover:hover{animation:passing-reverse 2s linear infinite}.faa-parent.animated-hover:hover>.faa-passing-reverse.faa-fast,.faa-passing-reverse.animated-hover.faa-fast:hover,.faa-passing-reverse.animated.faa-fast{animation:passing-reverse 1s linear infinite}.faa-parent.animated-hover:hover>.faa-passing-reverse.faa-slow,.faa-passing-reverse.animated-hover.faa-slow:hover,.faa-passing-reverse.animated.faa-slow{animation:passing-reverse 3s linear infinite}@keyframes burst{0%{opacity:.6}50%{transform:scale(1.8);opacity:0}to{opacity:0}}.faa-burst.animated,.faa-burst.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-burst{animation:burst 2s infinite linear}.faa-burst.animated-hover.faa-fast:hover,.faa-burst.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-burst.faa-fast{animation:burst 1s infinite linear}.faa-burst.animated-hover.faa-slow:hover,.faa-burst.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-burst.faa-slow{animation:burst 3s infinite linear}.arrow{position:absolute;z-index:10}.arrow:after,.arrow:before{position:absolute;content:\"\";display:block;width:0;height:0;border:9px solid transparent}.arrow:after{border-width:8px}.arrow.top{top:-9px;left:50%;margin-left:-9px}.arrow.top.pull-in{top:-4px}.arrow.top:before{border-bottom-color:rgba(0,0,0,.1);border-top-width:0}.arrow.top:after{top:1px;left:1px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:inherit;border-left-color:transparent;border-top-width:0}.arrow.right{top:50%;right:0;margin-top:-9px}.arrow.right.pull-in{right:5px}.arrow.right:before{border-left-color:rgba(0,0,0,.1);border-right-width:0}.arrow.right:after{top:1px;left:0;border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:inherit;border-right-width:0}.arrow.bottom{bottom:0;left:50%;margin-left:-9px}.arrow.bottom.pull-in{bottom:5px}.arrow.bottom:before{border-top-color:rgba(0,0,0,.1);border-bottom-width:0}.arrow.bottom:after{top:0;left:1px;border-top-color:inherit;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;border-bottom-width:0}.arrow.left{top:50%;left:-9px;margin-top:-9px}.arrow.left.pull-in{left:-4px}.arrow.left:before{border-right-color:rgba(0,0,0,.1);border-left-width:0}.arrow.left:after{top:1px;left:1px;border-top-color:transparent;border-right-color:inherit;border-bottom-color:transparent;border-left-color:transparent;border-left-width:0}.arrow.pull-left{left:18px}.arrow.pull-right{left:auto;right:26px}.arrow.pull-top{top:18px}.arrow.pull-bottom{top:auto;bottom:26px}.arrow.b-accent:before,.arrow.b-danger:before,.arrow.b-dark:before,.arrow.b-info:before,.arrow.b-primary:before,.arrow.b-success:before,.arrow.b-warning:before{border-color:transparent}.box{display:table;table-layout:fixed;border-spacing:0;width:100%;height:100%}.box .box-row{display:table-row;height:100%}.box .box-row .box-cell{position:relative;height:100%;width:100%;-webkit-overflow-scrolling:touch;overflow-x:hidden;box-sizing:border-box}.box .box-col,.ie .box .box-row .box-cell{display:table-cell}.box .box-col{vertical-align:top}.box .box-inner{position:absolute;top:0;bottom:0;left:0;right:0}.box>[class*=\" col-\"],.box>[class*=col-]{vertical-align:top;height:100%;float:none;padding:0;position:static}.v-m{vertical-align:middle!important}.v-t{vertical-align:top!important}.v-b{vertical-align:bottom!important}.v-c{display:-ms-flexbox;display:flex;align-items:center}@media (min-width:1200px){.box>[class*=\" col-lg\"],.box>[class*=col-lg]{display:table-cell}}@media (min-width:992px){.box>[class*=\" col-md\"],.box>[class*=col-md]{display:table-cell}}@media (min-width:768px){.box>[class*=\" col-sm\"],.box>[class*=col-sm]{display:table-cell}}@media (max-width:767px){.box>[class*=\" col-xs\"],.box>[class*=col-xs]{display:table-cell}}.ui-checks{padding-left:20px;cursor:pointer}.ui-checks input{opacity:0;position:absolute;margin-left:-20px}.ui-checks input:checked+i{border-color:#eaeaea}.ui-checks input:checked+i:before{left:4px;top:4px;width:6px;height:6px;background-color:#636f07}.ui-checks input:checked+span .active{display:inherit}.ui-checks input[type=radio]+i,.ui-checks input[type=radio]+i:before{border-radius:50%}.ui-checks input[disabled]+i,fieldset[disabled] .ui-checks input+i{border-color:#f7f7f7}.ui-checks input[disabled]+i:before,fieldset[disabled] .ui-checks input+i:before{background-color:#f7f7f7}.ui-checks>i{width:16px;height:16px;line-height:1;border:1px solid #eaeaea;background-color:#fff;margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:4px;position:relative}.ui-checks>i:before{content:\"\";position:absolute;left:50%;top:50%;width:0;height:0;background-color:transparent;transition:all .2s}.ui-checks>span{margin-left:-20px}.ui-checks>span .active{display:none}.ui-checks-md input:checked+i:before{left:5px;top:5px}.ui-checks-md>i{width:18px;height:18px}.ui-checks-lg input:checked+i:before{width:12px;height:12px;left:8px;top:8px}.ui-checks-lg>i{width:30px;height:30px}body,html{width:100%;height:100%}.app,body{overflow:hidden}.app{width:100%;height:100%;position:relative}.modal-open .app{overflow:hidden}.app-aside{background-color:#636f07;bottom:0;box-shadow:0 64px 5px 0 rgba(0,0,0,.26);color:#fff;height:100%;opacity:1;overflow-x:hidden;overflow-y:auto;position:absolute!important;top:0;z-index:60;-webkit-backface-visibility:hidden;backface-visibility:hidden}.app-aside a{color:#fff}.app-aside .leftbarbg,.app-aside>div.sidebar-menu{background-color:rgba(0,0,0,.15)}.app-aside .leftbarbg{background-image:none}.app-content{position:absolute;top:64px;bottom:30px;left:0;right:0;overflow-y:auto}@media (min-width:992px){.app-aside{display:block!important;width:240px}.app-aside.md-closed.hide{transform:translateZ(0)!important}.app-aside.folded{width:64px}.app-aside.folded~.app-content{margin-left:0;margin-top:0}.app-aside:not(.folded):not(.hide)~.app-content{margin-left:240px}.app-aside.md-sidenav-left{min-width:0}.app-aside .left,.app-aside.md-sidenav-left{transform:translateZ(0)!important}}@media (max-width:991px){.app-aside{display:block!important}.app-aside.modal{z-index:1050}.app-aside .left{max-width:304px}.app-padding{padding:4px}}.folded.active,.folded:focus,body .app-aside.folded,body .folded:hover{width:0}body .folded.active .hidden-folded,body .folded .hidden-folded,body .folded:focus .hidden-folded,body .folded:hover .hidden-folded{display:none}.hidden-folded #nav{margin-top:57px}.menu-right{left:231px}.menu-left,.menu-right{position:absolute;z-index:999}.menu-left{left:0}.menu-right-2{left:350px}.menu-left-2,.menu-right-2{position:absolute;z-index:999}.menu-left-2{left:120px}body .breadcrumb{display:block;width:100%!important;padding-top:0;padding-bottom:0;margin-right:0;list-style:none;background-color:#636f07;cursor:pointer;transition:all .2s cubic-bezier(.645,.045,.355,1);border-radius:0}ol.breadcrumb{margin:0;padding:0;height:35px;display:flex}ol.breadcrumb a,ol.breadcrumb li{display:inline-flex;align-items:center}ol.breadcrumb a{height:35px;border-bottom:4px solid transparent}div.breadcrumb{height:35px;margin-bottom:0}body .breadcrumb a,body .breadcrumb span{font-size:14px;color:#fff}body .breadcrumb span{border-bottom:4px solid #e95d0f;height:35px;padding-top:6px}.breadcrumb>li+li:before{padding:0 5px;color:transparent;content:\"/\\A0\"}@media (max-width:900px){.folded .hidden-folded{display:none}.app-aside.md-sidenav-left{transform:translateZ(0)!important;min-width:0}.app-aside.folded{width:64px}.folded{transition:width .4s cubic-bezier(.25,.8,.25,1);z-index:60}.app-aside{display:block!important;width:240px}.folded.active,.folded:focus,body .folded:hover{width:234px}.folded .nav li .nav-item span,.folded .nav li a span{display:none}.folded .nav li .nav-item .icon,.folded .nav li a .icon{float:none;line-height:50px;margin-right:0;min-width:0}body #aside{top:64px}body.md-sidenav-left.md-closed,body md-sidenav.md-closed{transform:translateZ(0)}.menu-right{left:0!important}.menu-right-2{left:120px!important}}.blue-link{color:#2053d2;text-decoration:underline}.box-row.content-box .row.title{display:flex;align-items:center}.box-row.content-box .row.title h3{margin-top:0}body nav ul.nav li li li.super_menu_li_sub a{padding-left:68px}.font-small,.menu_title,nav ul.nav li li a{font-size:12px}body nav ul.nav li .nav-item>.icon,body nav ul.nav li a>.icon{margin-right:0;min-width:30px}body nav ul.nav li li a{padding-left:58px;padding-bottom:10px;padding-top:10px;overflow:hidden;height:inherit}.draggable-bar>.col-lg-12>ul>li{display:inline-block;padding-right:6px;padding-left:6px;border-right:1px solid #8493ab}.draggable-bar>.col-lg-12{padding:5px}.draggable-bar>.col-lg-12>ul{list-style-type:none;margin-bottom:0}.draggable-bar>.col-lg-12>ul>li>.drag_div>a{font-size:14px;color:#fff}.draggable-bar>.col-lg-12>ul>li{margin-right:1px;background-color:#91a3bd}.draggable-bar>.col-lg-12>ul>li:last-child{border-right:none}.footer{position:fixed;bottom:0;left:0;right:0;background-color:#758295}nav{overflow-x:hidden;width:100%}nav ul.nav li{position:relative}nav ul.nav li li a{line-height:36px;line-height:19px;border-bottom:1px solid transparent}nav ul.nav li li a .badge,nav ul.nav li li a .label{margin-top:10px}nav ul.nav li li li a{padding-left:88px}nav ul.nav li li li li a{padding-left:106px}nav ul.nav li .nav-item,nav ul.nav li a{font-weight:400;text-transform:none;text-align:left;display:block;padding:0 16px;line-height:19px;padding-bottom:10px;padding-top:15px;position:relative;border-radius:0!important}nav ul.nav li .nav-item .text,nav ul.nav li a .text{margin-left:16px}nav ul.nav li .nav-item .up,nav ul.nav li a .up{margin-left:16px;font-style:normal;z-index:1}nav ul.nav li .nav-item>.pull-right i,nav ul.nav li a>.pull-right i{margin-left:16px;transition:transform .3s ease-in-out}nav ul.nav li .nav-item>.icon,nav ul.nav li a>.icon{float:left;line-height:inherit;margin-right:16px;top:0;min-width:40px}nav ul.nav li .nav-item>.icon:before,nav ul.nav li a>.icon:before{width:24px;display:inline-block;text-align:center;opacity:.75}nav ul.nav li .nav-item:focus,nav ul.nav li .nav-item:hover,nav ul.nav li a:focus,nav ul.nav li a:hover{background-color:rgba(0,0,0,.1)}nav ul.nav li label{display:block}nav ul.nav li label i{margin-left:-16px;margin-right:48px}nav ul.nav li.active,nav ul.nav li.active>a{background-color:transparent}nav ul.nav li.active>a>.pull-right i{transform:rotate(180deg)}nav ul.nav.nav-stacked .nav-header,nav ul.nav.nav-stacked a{padding:0 16px;line-height:30px}nav .nav-header{padding:0 16px;line-height:40px}@media (min-width:992px){.folded{transition:width .4s cubic-bezier(.25,.8,.25,1);z-index:60}.folded .nav li ul{display:none}.folded .nav li .nav-item,.folded .nav li a{text-align:center}.folded .nav li .nav-item span,.folded .nav li a span{display:none}.folded .nav li .nav-item .up,.folded .nav li a .up{position:absolute;top:-8px;right:4px}.folded .nav li .nav-item .icon,.folded .nav li a .icon{float:none;line-height:50px;margin-right:0;min-width:0}.folded .nav li .nav-item label i,.folded .nav li a label i{margin-left:-38px;margin-right:0}.folded .navbar-brand{text-align:center}.folded .hidden-folded{display:none}.folded.active,.folded.active>*,.folded:focus,.folded:focus>*,.folded:hover,.folded:hover>*{width:240px}.folded.active .nav li ul,.folded:focus .nav li ul,.folded:hover .nav li ul{display:inherit}.folded.active .nav li .nav-item,.folded.active .nav li a,.folded:focus .nav li .nav-item,.folded:focus .nav li a,.folded:hover .nav li .nav-item,.folded:hover .nav li a{text-align:left}.folded.active .nav li .nav-item span,.folded.active .nav li a span,.folded:focus .nav li .nav-item span,.folded:focus .nav li a span,.folded:hover .nav li .nav-item span,.folded:hover .nav li a span{display:inline}.folded.active .nav li .nav-item .up,.folded.active .nav li a .up,.folded:focus .nav li .nav-item .up,.folded:focus .nav li a .up,.folded:hover .nav li .nav-item .up,.folded:hover .nav li a .up{position:static}.folded.active .nav li .nav-item .icon,.folded.active .nav li a .icon,.folded:focus .nav li .nav-item .icon,.folded:focus .nav li a .icon,.folded:hover .nav li .nav-item .icon,.folded:hover .nav li a .icon{float:left;line-height:inherit;margin-right:22px}.folded.active .nav li label i,.folded:focus .nav li label i,.folded:hover .nav li label i{margin-left:-16px;margin-right:48px}.folded.active .navbar-brand,.folded:focus .navbar-brand,.folded:hover .navbar-brand{text-align:left}.folded.active .hidden-folded,.folded:focus .hidden-folded,.folded:hover .hidden-folded{display:inherit}.folded.active .hidden-folded.inline,.folded:focus .hidden-folded.inline,.folded:hover .hidden-folded.inline{display:inline-block}}.nav-sub{max-height:0;overflow:hidden;transition:max-height .5s cubic-bezier(.35,0,.25,1)}.nav-sub .md-ripple-container{display:none;visibility:hidden}.active>.nav-sub{max-height:999px}.active>.nav-sub .md-ripple-container{display:block;visibility:visible}.i-12{font-size:12px}.i-12,.i-16{vertical-align:-15%}.i-16{font-size:16px}.i-20{font-size:20px;vertical-align:-19%}.i-24{font-size:24px;vertical-align:-23%}.i-28{font-size:28px;vertical-align:-27%}.i-34{font-size:34px;vertical-align:-19%}.ui-icon{display:inline-block;text-align:center;height:1em;background:transparent!important}.ui-icon:before{position:relative;z-index:1}.ui-icon:after{content:\"\";border-width:1px;border-style:solid;border-color:inherit;border-radius:2em;width:2em;height:2em;top:-1.5em;display:block;position:relative;z-index:0;background-clip:padding-box}.ui-icon.b-2x:after{border-width:2px}.ui-icon.b-3x:after{border-width:3px}.ui-icon.ui-icon-sm:after{width:1.7em;height:1.7em;top:-1.35em}.ui-icon.bg-info:after,.ui-icon.bg-primary:after{background-color:#636f07}.ui-icon.bg-success:after{background-color:#6abfb2}.ui-icon.bg-warning:after{background-color:#fecd1a}.ui-icon.bg-accent:after,.ui-icon.bg-danger:after{background-color:#e95d0f}.ui-icon.bg-dark:after{background-color:#6f6f6e}.ui-icon.bg-light:after{background-color:#f7f7f7}.ui-icon.bg-white:after{background-color:#fff}.item{position:relative}.item .top{top:0}.item .bottom,.item .top{position:absolute;left:0;right:0}.item .bottom{bottom:0}.item .center{top:50%}.item-overlay,.item .center{position:absolute;left:0;right:0}.item-overlay{display:none;top:0;bottom:0}.item-overlay.active,.item:hover .item-overlay{display:block}.list-icon i{transition:font-size .2s;margin-right:16px}.list-icon div{white-space:nowrap;overflow:hidden}.jqstooltip{background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;border-radius:3px;padding:5px 10px!important;box-sizing:content-box}.easyPieChart{position:relative;text-align:center;display:table}.easyPieChart>div{display:table-cell;vertical-align:middle;position:relative;z-index:1;line-height:1}.easyPieChart>div img{margin-top:-4px}.easyPieChart canvas{position:absolute;top:0;left:0;z-index:0}#flotTip,.flotTip{padding:4px 10px;background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;z-index:100;font-size:12px;color:#fff;border-radius:3px}.legendColorBox>div{border:none!important;margin:5px}.legendColorBox>div>div{border-radius:10px}.st-sort-ascent:before{content:\"\\25B2\"}.st-sort-descent:before{content:\"\\25BC\"}.st-selected td{background:#f0f9ec!important}.ui-select-bootstrap>.ui-select-choices{overflow-y:scroll}.panel .dataTables_wrapper{padding-top:10px}.panel .dataTables_wrapper>.row{margin:0}.panel .dataTables_wrapper>.row>.col-sm-12{padding:0}.dataTables_wrapper.form-inline .form-control{width:auto}.btn-info .text-info{color:#fff}.ie .ie-show{display:block}.nav a.waves-effect{-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 0)}.highcharts-title{font-size:14px!important}.highcharts-container p,.highcharts-container svg,.highcharts-container text{font-family:Roboto,sans-serif!important;color:#6f6f6e!important}.highcharts-container a p:hover,.highcharts-container a svg:hover,.highcharts-container a text:hover{color:#e95d0f!important}.streamline{position:relative;border-color:#eaeaea}.streamline .sl-item:after,.streamline:after{content:\"\";position:absolute;background-color:#fff;border-color:inherit;border-width:2px;border-style:solid;border-radius:50%;width:11px;height:11px;margin-left:-6px;bottom:0;left:0}.sl-icon{position:absolute;left:-15px;z-index:1}.sl-icon>i{width:30px;height:30px;text-align:center;display:table-cell;vertical-align:middle}.sl-item{border-color:#eaeaea;position:relative;padding-bottom:1px}.sl-item:after,.sl-item:before{content:\" \";display:table}.sl-item:after{clear:both;top:0;bottom:auto}.sl-item.b-l{margin-left:-1px}.sl-item.sl-item-md:after{top:-10px;width:30px;height:30px;margin-left:-16px}.sl-item.sl-item-md .sl-icon{top:-10px}.sl-content{margin-left:24px;margin-top:-6px;padding-bottom:10px}.ui-switch{cursor:pointer;position:relative;display:inline-block;width:32px;height:18px;border-radius:30px;background-color:#6abfb2;margin:0}.ui-switch input{position:absolute;opacity:0;filter:alpha(opacity=0)}.ui-switch input:checked+i:before{top:50%;bottom:50%;left:50%;right:5px;border-width:0;border-radius:5px}.ui-switch input:checked+i:after{margin-left:15px}.ui-switch i:before{top:-1px;bottom:-1px;left:-1px;right:-1px;border:1px solid #f0f0f0;border-radius:30px;transition:all .2s}.ui-switch i:after,.ui-switch i:before{content:\"\";position:absolute;background-color:#fff}.ui-switch i:after{width:16px;top:1px;bottom:1px;border-radius:50%;box-shadow:1px 1px 3px rgba(0,0,0,.25);transition:margin-left .3s}.ui-switch-md{width:40px;height:24px}.ui-switch-md input:checked+i:after{margin-left:17px}.ui-switch-md i:after{width:22px}.ui-switch-lg{width:50px;height:30px}.ui-switch-lg input:checked+i:after{margin-left:21px}.ui-switch-lg i:after{width:28px}.timeline{margin:0;padding:0}.tl-item{display:block}.tl-item:after,.tl-item:before{content:\" \";display:table}.tl-item:after{clear:both}.visible-left{display:none}.tl-wrap{display:block;margin-left:6em;padding:15px 0 15px 20px;border-style:solid;border-color:#eaeaea;border-width:0 0 0 2px}.tl-wrap:after,.tl-wrap:before{content:\" \";display:table}.tl-wrap:after{clear:both}.tl-wrap:before{content:\"\";top:15px;margin-left:-26px;width:10px;height:10px;border-color:inherit;border-width:3px;border-radius:50%;border-style:solid;background:#f7f7f7;box-shadow:0 0 0 4px #232702}.tl-date,.tl-wrap:before{position:relative;float:left}.tl-date{top:10px;margin-left:-7.5em;display:block;width:4.5em;text-align:right}.tl-content{display:inline-block;position:relative;padding-top:10px;padding-bottom:10px}.tl-content.block{display:block;width:100%}.tl-content.panel{margin-bottom:0}.tl-header{display:block;width:12em;text-align:center;margin-left:1px}.timeline-center .tl-item{margin-left:50%}.timeline-center .tl-item .tl-wrap{margin-left:-2px}.timeline-center .tl-header{width:auto;margin-left:-1px}.timeline-center .tl-left{margin-left:0;margin-right:50%}.timeline-center .tl-left .hidden-left{display:none!important}.timeline-center .tl-left .visible-left{display:inherit}.timeline-center .tl-left .tl-wrap{float:right;margin-right:0;border-left-width:0;border-right-width:2px;padding-left:0;padding-right:20px}.timeline-center .tl-left .tl-wrap:before{float:right;margin-left:0;margin-right:-26px}.timeline-center .tl-left .tl-date{float:right;margin-left:0;margin-right:-8.5em;text-align:left}.content-circules{display:block;float:left;position:relative;margin:0;padding:8px;box-sizing:border-box;height:200px;width:131px}.content-circules:before{position:absolute;content:\"\";border-right:2px solid #ccd0db;top:0;bottom:0;left:49%;z-index:-1px}.content-circules .big-circule{position:relative;display:block;margin:38px;height:120px;width:120px;border:6px solid #aace3b;border-radius:50%;box-sizing:border-box;padding:0}.content-circules .big-circule:before{content:\"\";position:absolute;height:2px;width:70px;background-color:#aace3b;top:49%;left:100%}.content-circules .big-circule:after{content:\"\";position:absolute;height:16px;width:16px;border-radius:50%;background:#aace3b;top:42%;left:170%}.content-circules .big-circule .middle-circule{position:relative;display:block;border-radius:50%;border:4px solid #ccd0db;margin:15px;width:78px;height:78px;box-sizing:border-box;padding:0}.content-circules .big-circule .middle-circule .small-circule{position:relative;display:inline-block;box-sizing:border-box;border-radius:50%;background:linear-gradient(#aace3b,#fab813);margin:15px;height:40px;width:40px;padding:0}.small.content-circules{display:block;float:left;position:relative;margin:0;padding:8px;box-sizing:border-box;height:200px;width:131px}.small.content-circules:before{position:absolute;content:\"\";border-right:2px solid #ccd0db;top:0;bottom:0;left:49%;z-index:-1px}.small.content-circules .big-circule{position:relative;display:block;margin:62px 38px;height:40px;width:40px;border:6px solid #aace3b;border-radius:50%;box-sizing:border-box;padding:0}.small.content-circules .big-circule:before{content:\"\";position:absolute;height:2px;width:17px;background-color:#aace3b;top:49%;left:158%}.small.content-circules .big-circule:after{content:\"\";position:absolute;height:6px;width:6px;border-radius:50%;background:#aace3b;top:42%;left:215%}.small.content-circules .big-circule .middle-circule{position:relative;display:block;border-radius:50%;border:4px solid #ccd0db;margin:-19px;width:67px;height:67px;box-sizing:border-box;padding:0}.small.content-circules .big-circule .middle-circule .small-circule{position:relative;display:inline-block;box-sizing:border-box;border-radius:50%;background:linear-gradient(#aace3b,#fab813);margin:21px;height:15px;width:15px;padding:0}.item-time-line p{display:inline-block;width:46%;float:right;height:auto;overflow:hidden;font-size:12px;position:relative;top:56px;left:-13px}.item-time-line p span{font-size:20px;color:#aace3b;display:block}.block-p{display:block;width:100%;text-align:right}.morado-theme.content-circules .big-circule{border-color:#7e57c2}.morado-theme.content-circules .big-circule:before{background-color:#7e57c2}.morado-theme.content-circules .big-circule:after{background:#7e57c2}.morado-theme.content-circules .big-circule .middle-circule .small-circule{background:linear-gradient(#7e57c2,#2053d2)}.morado-theme.item-time-line p span{color:#7e57c2}.azul-theme.content-circules .big-circule{border-color:#2053d2}.azul-theme.content-circules .big-circule:before{background-color:#2053d2}.azul-theme.content-circules .big-circule:after{background:#2053d2}.azul-theme.content-circules .big-circule .middle-circule .small-circule{background:linear-gradient(#2053d2,#468ac2)}.azul-theme.item-time-line p span{color:#2053d2}@media (max-width:1500px){.item-time-line p{display:inline-block;width:29%;float:right;height:auto;overflow:hidden;font-size:12px;position:relative;top:33px;left:-13px}}@media (max-width:1299px){.small.content-circules{display:none}.item-time-line p{display:block;width:100%;float:left;height:auto;overflow:hidden;font-size:12px;position:relative;top:43px;left:0;text-align:center}}ol.timeline{display:flex;list-style:none;padding:0;margin:0 34px 40px}ol.timeline li{flex-grow:1}ol.timeline li .item{display:flex;align-items:center}ol.timeline li:last-of-type,ol.timeline li:last-of-type .line{flex-grow:0}ol.timeline .circle{height:30px;width:30px;border-radius:100%;border:6px solid #a4a4a4;background-color:#fff;margin:0}ol.timeline .circle.green{border:6px solid #04b404}ol.timeline .line{height:5px;flex-grow:1;background-color:hsla(0,0%,100%,.6)}ol.timeline .line.green{background-color:#04b404}ol.timeline .label-item{width:100px;position:relative;top:30px;right:40px;text-align:center;color:#fff}@media (max-width:768px){li .item,ol.timeline{flex-direction:column}ol.timeline{padding:0 0 10px}}.pvtAxisContainer{background:hsla(0,0%,100%,.34);border:1px solid #e5e9ec;min-height:20px;min-width:20px;padding:10px}.pvtAxisContainer li span.pvtAttr{-moz-box-shadow:0 5px 10px -3px rgba(0,0,0,.15);-webkit-box-shadow:0 5px 10px -3px rgba(0,0,0,.15);-webkit-text-size-adjust:100%;background:#4caf50;border-radius:4px;border:1px solid #45a749;box-shadow:0 5px 10px -3px rgba(0,0,0,.15);color:#fff;padding:7px 10px;white-space:nowrap}.pvtUi button,.pvtUi input,.pvtUi select,.pvtUi textarea{border:1px solid #e3e3e7;box-sizing:border-box;font-family:inherit;font-size:inherit;line-height:inherit;margin:5px;padding:5px}.pvtVals{background:hsla(0,0%,100%,.34);border:1px solid #e5e9ec;min-height:20px;min-width:20px;padding:10px}.pvtRendererArea{padding:15px}table.pvtTable tr td{background-color:transparent;border:1px solid #d9dde1;color:#252525;padding:15px;text-align:center;vertical-align:middle}table.pvtTable tr th{background-color:#00548a;border:1px solid #5489ab;color:#fff;font-size:9pt;font-weight:300;padding:8px 10px}table.pvtTable tr:nth-child(odd){background-color:rgba(66,139,202,.1)}table.pvtTable tr:hover{background-color:rgba(66,139,202,.35)}.pvtTriangle{color:#fff;cursor:pointer;font-size:17pt;vertical-align:middle}.pivot-box{background-color:#fff;border-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.05);box-sizing:border-box;display:block;float:left;height:auto;margin-bottom:25px;min-width:100%;overflow:visible;padding:15px}.cursor-pointer{cursor:pointer}.carousel_element_text{font-size:46px;color:rgba(0,0,0,.35);text-shadow:0 1px rgba(40,46,49,0);font-weight:300}.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}#form-simular .form-group{margin-bottom:0}#form-simular label{text-transform:uppercase;color:#758295;font-size:13px;font-weight:700;display:inline-block}#form-simular input,#form-simular select{width:30%;display:inline-block;margin:0 1%}.slick-list{width:100%;text-align:center;margin:0 auto}body .slick-prev{left:-1px;z-index:5}body .slick-next{right:1px}.nav-bg{cursor:pointer}.nav-bg li{text-align:center}.nav-bg li a,.nav-bg li div{padding:20px}.nav-bg li.active{background:#7e57c2;color:#fff}.nav-bg li.active:after{top:100%;left:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-color:hsla(0,57%,61%,0);border-top-color:#7e57c2;border-width:12px;margin-left:-12px;z-index:1}.nav-bg li.active .badge{background:#aace3b}.slick-selected{background-color:#7e57c2;color:#fff;background-image:url(" + __webpack_require__(1541) + ");background-repeat:no-repeat;background-size:contain;background-position:50%;font-weight:700}.demandPlan{font-size:20px;text-align:center;padding-bottom:0;font-weight:700}.planName{font-weight:400;text-align:center;padding-top:0}@font-face{font-family:Material-Design-Icons;font-weight:400;font-style:normal;src:url(\"/assets/fonts/Material-Design-Icons.eot?-g7cqhn\");src:url(\"/assets/fonts/Material-Design-Icons.eot?#iefix-g7cqhn\") format(\"embedded-opentype\"),url(\"/assets/fonts/Material-Design-Icons.woff?-g7cqhn\") format(\"woff\"),url(\"/assets/fonts/Material-Design-Icons.ttf?-g7cqhn\") format(\"truetype\"),url(\"/assets/fonts/Material-Design-Icons.svg?-g7cqhn#Material-Design-Icons\") format(\"svg\")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:Material-Design-Icons;font-size:20px;line-height:1;opacity:.75;color:grey;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:\"\\E836\"}[dir=rtl] .slick-prev:before{content:\"\\E837\"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:\"\\E837\"}[dir=rtl] .slick-next:before{content:\"\\E836\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}.footable>tfoot .pagination{margin:10px 0!important}#ahoraPuedes-card{position:fixed;bottom:-12px;right:0;display:block;width:100%;z-index:4;text-align:center;box-sizing:border-box;box-shadow:0 0 10px 0 rgba(0,0,0,.15)}#ahoraPuedes-card h4{display:inline-block;color:#000;font-size:14px;margin-right:20px}#ahoraPuedes-card span{margin:0 10px;font-size:13px;position:relative;bottom:-5px;display:inline-block;overflow:hidden}#ahoraPuedes-card span i{margin-right:5px;font-size:20px;position:relative;top:4px}.title-prog h1,.title-prog h2,.title-prog h3,.title-prog h4,.title-prog h5,.title-prog h6{font-size:21px;color:#2053d2;margin-top:0}.c-cantidad ul{list-style:none;margin-bottom:0;-webkit-padding-start:0}.c-cantidad a{color:#468ac2;text-decoration:none;display:inline-block}.c-detalleProg .panel-body{padding-top:10px}.c-detalleProg .panel-body h3{margin-top:0;font-size:16px}.c-detalleProg .panel-body ul{list-style:none;color:#758295;-webkit-padding-start:0}.c-detalleProg .panel-footer{background-color:rgba(70,138,194,.2);padding:5px 15px}.c-detalleProg .panel-footer h5,.c-detalleProg .panel-footer p{display:block;text-align:center}.c-detalleProg .panel-footer p{color:#468ac2;font-size:25px;margin-bottom:0;font-weight:300}.c-detalleProg .panel-footer h5{color:#758295;font-size:14px;margin-top:0}.lista-prog{list-style:none;-webkit-padding-start:0;height:70vh;display:block;overflow:hidden;overflow-y:scroll}.lista-prog li{border-bottom:1px solid grey;position:relative;width:100%;display:block;overflow:hidden;float:left;min-height:70px;height:120px;max-height:180px}.lista-prog li:hover{border-bottom:1px solid #468ac2}.lista-prog li a{position:absolute;width:100%;height:100%;background-color:transparent;color:#6f6f6e;transition:all .5s ease;top:0;left:0;right:0;padding:15px 5px}.lista-prog li a.active,.lista-prog li a:active,.lista-prog li a:hover{background-color:#468ac2;color:#fff}.lista-prog li a span{display:block;font-size:11px}.lista-items-menu{list-style:none;-webkit-padding-start:0;height:70vh;display:block;overflow:hidden;overflow-y:scroll}.lista-items-menu li{border-bottom:1px solid grey;position:relative;width:100%;display:block;overflow:hidden;float:left;height:90px}.lista-items-menu li:hover{border-bottom:1px solid #468ac2}.lista-items-menu li a{position:absolute;width:100%;height:100%;background-color:transparent;color:#6f6f6e;transition:all .5s ease;top:0;left:0;right:0;padding:15px 5px}.lista-items-menu li a.active,.lista-items-menu li a:active,.lista-items-menu li a:hover{background-color:#468ac2;color:#fff}.lista-items-menu li a span{display:block;font-size:11px}.scroll-50vh{overflow:hidden;overflow-y:scroll;height:50vh}.tile{padding:5px}.half-jornada{display:inline-block;float:left;width:50%;box-sizing:border-box;overflow:hidden}.detSim .card-body{padding:5px 24px}.detSim h4{font-size:12px;text-transform:uppercase;font-weight:700}.detSim hr{border-top:1px solid rgba(204,208,219,.5);margin:0}.filtros-carreras{width:100%!important}.filtros-carreras select{width:20%}.filtros-materias{width:100%!important}.filtros-materias select{width:17%}.form-inline .control-label{margin-right:10px}.btn-group>.popover+.btn,.btn-group>.tooltip+.btn{margin-left:-1px}.btn-group>.btn:last-of-type{-moz-border-top-right-radius:3px!important;border-top-right-radius:3px!important;-moz-border-bottom-right-radius:3px!important;border-bottom-right-radius:3px!important}.loading{padding-top:60px;padding-bottom:60px;margin-bottom:15px;background-color:#f0f0f4;height:200px;overflow:hidden}.show-loader{display:block!important}.arrow-right{width:0;height:0;border-top:15px solid transparent;border-bottom:15px solid transparent;border-left:15px solid #aace3b;display:inline-block;position:absolute;top:56px}.c-resumen-config{height:108px}.week-box{width:100%;overflow:hidden;height:160px;padding:10px;box-sizing:border-box;border:1px solid hsla(0,0%,80%,.46)}.md-select-value>span:not(.md-select-icon) .md-text,.week-box{display:block}.loader{border:8px solid #f3f3f3;border-radius:50%;border-top:8px solid #3498db;width:40px;height:40px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.popover.top>.arrow:after{border-top-color:#2053d2!important}.popover.left>.arrow:after{border-left-color:#2053d2!important}.popover.right>.arrow:after{border-right-color:#2053d2!important}.popover.bottom>.arrow:after{border-bottom-color:#2053d2!important}.popover{color:#fff;font-size:10px;background-color:#2053d2!important;border:1px solid #2053d2!important}.bg-white{background-color:#fff}.bg-light{background-color:#f7f7f7}.bg-light.lt{background-color:#fff!important}.bg-light .lt{background-color:#fff}.bg-light.dk{background-color:#ebe9e9!important}.bg-light .dk{background-color:#ebe9e9}.bg-light.bg{background-color:#f7f7f7!important}.bg-light .bg{background-color:#f7f7f7}.bg-dark{color:hsla(0,0%,100%,.87);background-color:#6f6f6e}.bg-dark.lt{background-color:#7b7b7b!important}.bg-dark .lt{background-color:#7b7b7b}.bg-dark.dk{background-color:#67675c!important}.bg-dark .dk{background-color:#67675c}.bg-dark.bg{background-color:#6f6f6e!important}.bg-dark .bg{background-color:#6f6f6e}.bg-primary{color:hsla(0,0%,100%,.87);background-color:#636f07}.bg-primary.lt{background-color:#76830c!important}.bg-primary .lt{background-color:#76830c}.bg-primary.dk{background-color:#4f5903!important}.bg-primary .dk{background-color:#4f5903}.bg-primary.bg{background-color:#636f07!important}.bg-primary .bg{background-color:#636f07}.bg-success{color:hsla(0,0%,100%,.87);background-color:#6abfb2}.bg-success.lt{background-color:#81c2b8!important}.bg-success .lt{background-color:#81c2b8}.bg-success.dk{background-color:#52bdad!important}.bg-success .dk{background-color:#52bdad}.bg-success.bg{background-color:#6abfb2!important}.bg-success .bg{background-color:#6abfb2}.bg-info{color:hsla(0,0%,100%,.87);background-color:#636f07}.bg-info.lt{background-color:#76830c!important}.bg-info .lt{background-color:#76830c}.bg-info.dk{background-color:#4f5903!important}.bg-info .dk{background-color:#4f5903}.bg-info.bg{background-color:#636f07!important}.bg-info .bg{background-color:#636f07}.bg-warning{color:hsla(0,0%,100%,.87);background-color:#fecd1a}.bg-warning.lt{background-color:#f9d039!important}.bg-warning .lt{background-color:#f9d039}.bg-warning.dk{background-color:#ffc800!important}.bg-warning .dk{background-color:#ffc800}.bg-warning.bg{background-color:#fecd1a!important}.bg-warning .bg{background-color:#fecd1a}.bg-danger{color:hsla(0,0%,100%,.87);background-color:#e95d0f}.bg-danger.lt{background-color:#eb6d27!important}.bg-danger .lt{background-color:#eb6d27}.bg-danger.dk{background-color:#d75208!important}.bg-danger .dk{background-color:#d75208}.bg-danger.bg{background-color:#e95d0f!important}.bg-accent,.bg-danger .bg{background-color:#e95d0f}.bg-accent{color:hsla(0,0%,100%,.87)}.bg-accent.lt{background-color:#eb6d27!important}.bg-accent .lt{background-color:#eb6d27}.bg-accent.dk{background-color:#d75208!important}.bg-accent .dk{background-color:#d75208}.bg-accent.bg{background-color:#e95d0f!important}.bg-accent .bg{background-color:#e95d0f}a.bg-primary:hover{background-color:#4e5705}a.text-primary:hover{color:#4e5705}.text-primary{color:#636f07}.text-primary-lt{color:#788709}.text-primary-dk{color:#4e5705}a.bg-info:hover{background-color:#4e5705}a.text-info:hover{color:#4e5705}.text-info{color:#636f07}.text-info-lt{color:#788709}.text-info-dk{color:#4e5705}a.bg-success:hover{background-color:#58b7a9}a.text-success:hover{color:#58b7a9}.text-success{color:#6abfb2}.text-success-lt{color:#7cc7bb}.text-success-dk{color:#58b7a9}a.bg-warning:hover{background-color:#fdc701}a.text-warning:hover{color:#fdc701}.text-warning{color:#fecd1a}.text-warning-lt{color:#fed333}.text-warning-dk{color:#fdc701}a.bg-danger:hover{background-color:#d1530d}a.text-danger:hover{color:#d1530d}.text-danger{color:#e95d0f}.text-danger-lt{color:#f16b21}.text-danger-dk{color:#d1530d}a.bg-accent:hover{background-color:#d1530d}a.text-accent:hover{color:#d1530d}.text-accent{color:#e95d0f}.text-accent-lt{color:#f16b21}.text-accent-dk{color:#d1530d}a.bg-dark:hover{background-color:#626261}a.text-dark:hover{color:#626261}.text-dark{color:#6f6f6e}.text-dark-lt{color:#7c7c7b}.text-dark-dk{color:#626261}.text-white{color:#fff}.text-white-lt{color:hsla(0,0%,100%,.54)}.text-white-dk{color:hsla(0,0%,100%,.87)}.text-black{color:#000}.text-black-lt{color:rgba(0,0,0,.54)}.text-black-dk{color:rgba(0,0,0,.87)}.text-muted{color:inherit;opacity:.75}.text-muted-dk{color:inherit;opacity:.5}.text-muted-lt{color:inherit;opacity:.25}.text-color{color:#494948}.bg-big:before{content:\"\";position:absolute;width:100%;top:0;bottom:0;z-index:-1;background-color:inherit;border:inherit}.bg-white-overlay{background-color:hsla(0,0%,100%,.8)}.bg-black-overlay{background-color:rgba(32,43,54,.8)}.no-bg{background-color:transparent;color:inherit}@media (min-width:768px){.bg-auto:before{content:\"\";position:absolute;width:inherit;top:0;bottom:0;z-index:-1;background-color:inherit;border:inherit}.bg-auto.b-l:before{margin-left:-1px}.bg-auto.b-r:before{margin-right:-1px}}.ui-grid{border:0 solid #91a3bd}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button>i{color:#fff}.ui-grid-scrollbar-placeholder{background-color:transparent}.ui-grid-cell:not(:last-child) .ui-grid-vertical-bar,.ui-grid-header-cell:last-child .ui-grid-vertical-bar,.ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{background-color:#91a3bd}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:last-child{border-right-color:#4c87ad}.ui-grid-top-panel-background{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0)}.ui-grid-column-menu-button-last-col{margin-right:2px!important}input[type=text].ui-grid-filter-input{padding:0;margin:0;border:0;width:100%;padding:2px 5px;border-radius:3px!important;border:0 solid #91a3bd;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}select.ui-grid-filter-select{border:0 solid #91a3bd;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0}select.ui-grid-filter-select:hover{border:0 solid #91a3bd}.ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:#fff}.ui-grid-row:nth-child(2n) .ui-grid-cell{background-color:rgba(76,135,173,.13)}.ui-grid-row:last-child .ui-grid-cell{border-bottom-color:#91a3bd;border-bottom-style:solid}.ui-grid-no-row-overlay{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0);-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box;border:0 solid #91a3bd;font-size:2em;text-align:center}.ui-grid-no-row-overlay>*{position:absolute;display:table;margin:auto 0;width:100%;top:0;bottom:0;left:0;right:0;opacity:.66}.ui-grid-cell{background-color:inherit;border-right:0 solid;border-color:#91a3bd}.ui-grid-cell:last-child{border-right:0}.ui-grid-cell-contents-hidden{visibility:hidden;width:0;height:0;display:none}.ui-grid-row .ui-grid-cell.ui-grid-row-header-cell{background-color:#e8eff4;border-bottom:0 solid #e8eff4}.ui-grid-footer-panel,.ui-grid-footer-panel-background{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0)}.ui-grid-footer-panel{position:relative;border-bottom:1px solid #91a3bd;border-top:1px solid #91a3bd;overflow:hidden;font-weight:700;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}.ui-grid-footer-cell{background-color:inherit;border-right:0 solid;border-color:#91a3bd}input[type=text].ui-grid-filter-input{background:hsla(0,0%,100%,.3)}input[type=text].ui-grid-filter-input:hover{border:0 solid #91a3bd}.ui-grid-menu-button{cursor:pointer;color:#fff}.ui-grid-menu-button,.ui-grid-menu .ui-grid-menu-inner{background:#4c87ad;border:0 solid #4c87ad}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{color:#333;text-decoration:none}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled],fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled,fieldset[disabled] a.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button{pointer-events:none}.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{color:transparent;background-color:transparent;border-color:transparent}.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active{background-image:none}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled].focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled]:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled]:hover,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{background-color:transparent;border-color:transparent}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button .badge{color:transparent;background-color:transparent}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button>i{opacity:.75;color:#000}.ui-grid-menu .ui-grid-menu-inner ul{margin:0;padding:0;list-style-type:none}.ui-grid-menu .ui-grid-menu-inner ul li{padding:0}.ui-grid-menu .ui-grid-menu-inner ul li button{min-width:100%;padding:8px;text-align:left;background:transparent;border:none}.ui-grid-menu .ui-grid-menu-inner ul li button:focus,.ui-grid-menu .ui-grid-menu-inner ul li button:hover{box-shadow:inset 0 0 14px rgba(0,0,0,.12)}.ui-grid-menu .ui-grid-menu-inner ul li button.ui-grid-menu-item-active{box-shadow:inset 0 0 14px rgba(0,0,0,.12);background-color:#4c87ad}.ui-grid-menu .ui-grid-menu-inner ul li:not(:last-child)>button{border-bottom:0 solid #91a3bd}.ui-grid-sortarrow{right:5px;position:absolute;width:20px;top:0;bottom:0;background-position:50%}.ui-grid-sortarrow.down{transform:rotate(180deg)}[class*=\" ui-grid-icon\"]:before,[class^=ui-grid-icon]:before{font-family:ui-grid;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em}.ui-grid-icon-blank:before{width:1em;content:\" \"}.ui-grid[dir=rtl] .ui-grid-cell,.ui-grid[dir=rtl] .ui-grid-footer-cell,.ui-grid[dir=rtl] .ui-grid-header-cell{float:right!important}.ui-grid[dir=rtl] .ui-grid-column-menu-button{position:absolute;left:1px;top:0;right:inherit}.ui-grid[dir=rtl] .ui-grid-cell:first-child,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child{border-right:0}.ui-grid[dir=rtl] .ui-grid-cell:last-child,.ui-grid[dir=rtl] .ui-grid-header-cell:last-child{border-right:0 solid #e8eff4;border-left:0}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-cell:last-child{box-sizing:border-box;border-right:1px solid;border-width:1px;border-right-color:#e8eff4}.ui-grid[dir=rtl] .ui-grid-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child .ui-grid-vertical-bar{width:0}.ui-grid[dir=rtl] .ui-grid-menu-button{z-index:2;position:absolute;left:0;right:auto;background:#91a3bd;border:0 solid #91a3bd;cursor:pointer;min-height:27px;font-weight:400}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button,.ui-grid[dir=rtl] .ui-grid-menu-button .ui-grid-menu{left:0;right:auto}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button [class^=ui-grid-icon]{right:auto;left:10px}.ui-grid-animate-spin{animation:ui-grid-spin 2s infinite linear;display:inline-block}@keyframes ui-grid-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.light-table .ui-grid-header-cell{position:relative;box-sizing:border-box;background-color:#dcdfef;border-right:1px solid;border-color:#c5cae4;display:table-cell;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:0;color:#333}.light-table .ui-grid-top-panel{position:relative;overflow:hidden;font-weight:700;background-color:#dcdfef}.ui-grid-header{border-bottom:1px solid #c5cae4;box-sizing:border-box}select.ui-grid-filter-select{padding:0;margin:0;border:0;background:hsla(0,0%,100%,.3);padding:5px;border:0 solid #a7abae;background-clip:padding-box;border-radius:3px!important}select.ui-grid-filter-select option{color:#758295}.t-h40 md-switch{margin:0;height:auto}.t-h40 .ui-grid-cell-contents{height:40px}.fc-toolbar h2{color:#468ac2;font-size:18px}.fc-unthemed .fc-divider,.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}td.fc-time,th.fc-day-header{color:#758295}.fc-time-grid .fc-slats td{height:3.5em;border-bottom:0}.fc-state-default{background-color:#fff;background-image:none;background-repeat:repeat-x;border-color:#e6e6e6 #e6e6e6 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#91a3bd;text-shadow:0 1px 1px hsla(0,0%,100%,.75);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05)}.bg-green-web-planner{background:#aace3b}.bg-green-web-planner,.bg-purple-web-planner{border:1px solid #fff;float:left;width:100%;color:#fff;font-size:10px;opacity:.95}.bg-purple-web-planner{background:#6a0888}.tooltip-inner{max-width:500px!important}.werapper_button md-radio-button{display:inline-block;font-size:11px}.hh{width:95%}.u-select-overflow-hide{overflow:hidden}.u-btn-align-label{margin-top:25px}md-input-container{width:100%}body .cal-day-box .cal-day-hour-part .cal-day-hour-part-time{width:20px}.headersidebar{padding-right:0}.headersidebar h5{font-size:12px}mwl-calendar .cal-row-fluid:hover,mwl-calendar [class*=cal-cell]:hover{background-color:#2053d2}.cal-week-box [data-event-class]{white-space:normal!important;height:30px;padding-top:0!important;margin-top:0!important;margin-bottom:0!important;font-size:12px;padding:0 3px!important;line-height:18px;text-align:center;display:flex;align-items:center;border-radius:6px!important;border:1px solid #fff}.capitalize{text-transform:capitalize}.f-none{float:none}.prog.nav-tabs{overflow-x:auto;overflow-y:hidden;display:-webkit-box;display:-moz-box}.prog.nav-tabs>li{float:none}.effect-highlight-purple{transition:all .5s ease}.effect-highlight-purple:hover{background-color:#7e57c2;color:#fff;width:100%;border-radius:3px}.effect-highlight-purple:hover .yellow-hover-icon,.yellow-hover-icon:hover{color:#ff0}.effect-highlight-purple--active{background-color:#7e57c2;color:#fff;width:100%;border-radius:3px}.effect-highlight-purple--active .yellow-hover-icon{color:#ff0}.list-h{display:block;overflow:hidden;padding-left:0}.list-h li{display:inline-block;padding:5px;padding-left:0;padding-right:25px}.list-h li span{color:#468ac2}.tabla-horarios td{border-right:1px solid #e7e8ea;border-bottom:1px solid #e7e8ea}.red-text-table{color:#ef7955}.gris-text-table,.red-text-table{font-weight:700;pointer-events:none}.gris-text-table{color:#787878}.amarillo-text-table{color:#fc0;font-weight:700;cursor:pointer}.green-text-table{color:#aace3b;font-weight:700;pointer-events:none}.visibility{pointer-events:none;cursor:default;text-decoration:none;color:#999}.select2-container{width:100%}.date-picker{width:100%;height:34px;padding-left:5px}.editable-wrap{display:inline-block;white-space:nowrap;margin:0;width:100%}.disabled-style{-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%);-ms-filter:grayscale(100%);-o-filter:grayscale(100%);cursor:not-allowed}.scroll-55vh{height:55vh!important}.scroll-55vh,.scroll-60vh{overflow:hidden;overflow-y:scroll}.scroll-60vh{height:60vh!important}.scroll-65vh{height:65vh!important}.scroll-65vh,.scroll-70vh{overflow:hidden;overflow-y:scroll}.scroll-70vh{height:70vh!important}.scroll-75vh{height:75vh!important}.scroll-75vh,.scroll-80vh{overflow:hidden;overflow-y:scroll}.scroll-80vh{height:80vh!important}.fc-event .fc-content{height:100%}.postit{line-height:1;text-align:center;width:275px;margin:25px;min-height:250px;max-height:250px;position:relative;border:1px solid #e8e8e8;font-size:22px;border-bottom-right-radius:60px 5px;display:inline-block}.postit:after{content:\"\";position:absolute;z-index:-1;right:0;bottom:20px;width:200px;height:25px;background:rgba(0,0,0,.2);box-shadow:2px 15px 5px rgba(0,0,0,.4);transform:matrix(-1,-.1,0,1,0,0)}.yellow{border-top:60px solid #fdfd86;background:#ff8}.purple{border-top:60px solid #9b7cd0;background:#9b7cd0}.red{border-top:60px solid #df826e;background:#df826e}.rotate-3{transform:rotate(-3deg);-webkit-transform:rotate(-3deg);-moz-transform:rotate(-3deg);-o-transform:rotate(-3deg)}.icon-bg{background-image:url(" + __webpack_require__(1542) + ");background-repeat:no-repeat;background-size:initial;background-position:100% 100%}.chevrons{font-family:Material-Design-Icons}.chevrons :after{content:\"\\E89D\"}.chevrons :after,.chevrons :before{display:block;position:absolute;top:50%;right:0;width:10px;height:1px;background-color:#2196f3;transform-origin:50% 50%;will-change:transform;transition:all .25s}.chevrons :before{content:\"\\E89E\"}.panel-heading .accordion-toggle:after{font-family:Material-Design-Icons;content:\"\\E89D\";float:right;color:grey;font-size:24px}.panel-heading .accordion-toggle.collapsed:after{content:\"\\E89E\"}.fade-in-out{transition:all 1s linear;opacity:1}.fade-in-out.ng-hide{opacity:0}.hh{position:absolute;z-index:99999;bottom:0;width:93%}.hover-morado:hover{background-color:#7e57c2;color:#fff}.brd-md,.brd-xl{border-radius:3px}.control-label{margin-top:5px;font-weight:500;font-size:14px}.b-success{border-color:#aace3b!important}.list-horizontal{padding-left:0;list-style:none}.list-vert-trans{list-style:none;-webkit-padding-start:0;height:75vh;overflow-y:auto}.list-vert-trans li{padding:16px 5px;cursor:pointer;background:transparent;transition:all .5s ease;border-left:3px solid transparent;border-bottom:1px solid hsla(0,0%,100%,.2)}.list-vert-trans li:hover{padding:18px 5px;cursor:pointer;background:rgba(0,0,0,.15);border-left:3px solid #468ac2}.list-vert-trans li.active i,.list-vert-trans li:hover i{color:#468ac2}.list-vert-trans li.active{padding:18px 5px;cursor:pointer;border-left:3px solid transparent;background:rgba(0,0,0,.15);font-weight:500}.list-vert-trans li p{padding-left:10px;margin-bottom:0;display:inline-block}.list-vert-trans li p:first-letter{text-transform:capitalize}.no-rows{position:absolute;top:0;bottom:0;width:100%;background:rgba(0,0,0,.4)}.no-rows .msg{position:absolute;top:20%;left:20%;width:60%;height:50%;line-height:200%;background-color:transparent;border:0;text-align:center;font-size:24px;display:table;color:#fff}.no-rows .msg span{display:table-cell;vertical-align:middle}.dpl-b,.w-100{display:block}.w-100{width:100%;overflow:hidden}.text-editable{color:#758295}.pos-rlt{position:relative;z-index:1}.pos-abt{position:absolute}.pos-fix{position:fixed!important}.pos-stc{position:static!important}.block{display:block}.block.hide{display:none}.flex{display:flex}.align-self-end{align-self:flex-end}.align-items-center{align-items:center}.flex-direction-column{flex-direction:column}.flex-wrap-wrap{flex-wrap:wrap}.pull-none{float:none}.inline{display:inline-block}.inline-16{width:16px;height:16px}.inline-24{width:24px;height:24px}.active>.auto .inline,.active>.inline,.none{display:none}.active>.auto .none,.active>.none{display:inline-block}.line{height:1px;margin:10px 0;font-size:0;overflow:hidden}.line-dashed{border-style:dashed!important;background-color:transparent;border-width:0}.pointer{cursor:pointer}.circle,.rounded{border-radius:500px}.clear{display:block;overflow:hidden}.align_center{display:block;margin:auto}.align-calendars{margin-left:-18px}.flex-center{display:flex;align-items:center}.no-border{border-color:transparent;border-width:0}.no-borders{border-width:0!important}.b{border-color:hsla(210,4%,45%,.15)!important}.b-a{border:1px solid #eaeaea}.b-t{border-top:1px solid #eaeaea}.b-r{border-right:1px solid #eaeaea}.b-b{border-bottom:1px solid #eaeaea}.b-l{border-left:1px solid #eaeaea}.b-2x{border-width:2px}.b-3x{border-width:3px}.b-4x{border-width:4px}.b-5x{border-width:5px}.b-t-2x{border-top-width:2px!important}.b-t-3x{border-top-width:3px!important}.b-t-4x{border-top-width:4px!important}.b-t-5x{border-top-width:5px!important}.b-r-2x{border-right-width:2px!important}.b-r-3x{border-right-width:3px!important}.b-r-4x{border-right-width:4px!important}.b-r-5x{border-right-width:5px!important}.b-b-2x{border-bottom-width:2px!important}.b-b-3x{border-bottom-width:3px!important}.b-b-4x{border-bottom-width:4px!important}.b-b-5x{border-bottom-width:5px!important}.b-l-2x{border-left-width:2px!important}.b-l-3x{border-left-width:3px!important}.b-l-4x{border-left-width:4px!important}.b-l-5x{border-left-width:5px!important}.b-light{border-color:#f7f7f7}.b-white{border-color:#fff}.b-primary{border-color:#636f07}.b-t-primary{border-top-color:#636f07}.b-r-primary{border-right-color:#636f07}.b-b-primary{border-bottom-color:#636f07}.b-l-primary{border-left-color:#636f07}.b-info{border-color:#636f07}.b-t-info{border-top-color:#636f07}.b-r-info{border-right-color:#636f07}.b-b-info{border-bottom-color:#636f07}.b-l-info{border-left-color:#636f07}.b-success{border-color:#6abfb2}.b-t-success{border-top-color:#6abfb2}.b-r-success{border-right-color:#6abfb2}.b-b-success{border-bottom-color:#6abfb2}.b-l-success{border-left-color:#6abfb2}.b-warning{border-color:#fecd1a}.b-t-warning{border-top-color:#fecd1a}.b-r-warning{border-right-color:#fecd1a}.b-b-warning{border-bottom-color:#fecd1a}.b-l-warning{border-left-color:#fecd1a}.b-danger{border-color:#e95d0f}.b-t-danger{border-top-color:#e95d0f}.b-r-danger{border-right-color:#e95d0f}.b-b-danger{border-bottom-color:#e95d0f}.b-l-danger{border-left-color:#e95d0f}.b-accent{border-color:#e95d0f}.b-t-accent{border-top-color:#e95d0f}.b-r-accent{border-right-color:#e95d0f}.b-b-accent{border-bottom-color:#e95d0f}.b-l-accent{border-left-color:#e95d0f}.b-dark{border-color:#6f6f6e}.b-t-dark{border-top-color:#6f6f6e}.b-r-dark{border-right-color:#6f6f6e}.b-b-dark{border-bottom-color:#6f6f6e}.b-l-dark{border-left-color:#6f6f6e}.no-b-t{border-top-width:0}.no-b-r{border-right-width:0}.no-b-b{border-bottom-width:0}.no-b-l{border-left-width:0}.b-dashed{border-style:dashed!important}.border-radio-left{border-radius:200px 0 10px 200px}@media (max-width:991px){.no-border-sm{border-width:0}}@media (max-width:767px){.no-border-xs{border-width:0}}.b-b-azul{border:2px solid #2053d2;border-bottom:2px solid #2053d2}.b-b-azul-light{border-bottom:2px solid #468ac2}.b-b-amarillo{border-bottom:2px solid #fab813}.b-b-verde{border-bottom:2px solid #aace3b}.b-b-gris-dark{border-bottom:2px solid #91a3bd}.b-t-gris-light{border-top:1px solid #ccd0db}.b-b-gris-darker{border-bottom:2px solid #758295}.b-b-rojo{border-bottom:2px solid #ef7955}.b-b-morado{border-bottom:2px solid #7e57c2}.b-b-blanco{border-bottom:2px solid #fff}.b-b-gris-lighter{border-bottom:2px solid #f2f5f7}.b-b-negro-darker{border-bottom:2px solid #2d3039}.b-r-gris-light{border-right:1px solid #ccd0db}.b-l-gris-light{border-left:1px solid #ccd0db}.b-b-gris-light{border-bottom:1px solid #ccd0db}.hover-action{display:none}.hover-rotate{transition:all .2s ease-in-out .1s}.hover-anchor:active .hover-action,.hover-anchor:focus .hover-action,.hover-anchor:hover .hover-action{display:inherit}.hover-anchor:active .hover-rotate,.hover-anchor:focus .hover-rotate,.hover-anchor:hover .hover-rotate{transform:rotate(45deg)}.hover14 figure{position:relative;overflow:hidden}.hover14 figure:before{position:absolute;top:0;left:-75%;z-index:2;display:block;content:\"\";width:50%;height:100%;background:linear-gradient(90deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,.3));transform:skewX(-25deg)}.hover14 figure:hover:before{animation:shine .75s}@keyframes shine{to{left:125%}}.no-margin{margin:0!important}.m{margin:16px}.m-xs{margin:4px}.m-sm{margin:8px}.m-md{margin:24px}.m-lg{margin:32px}.m-15{margin:15px}.m-v-xs{margin-top:4px;margin-bottom:4px}.m-v-sm{margin-top:8px;margin-bottom:8px}.m-v{margin-top:16px;margin-bottom:16px}.m-v-md{margin-top:24px;margin-bottom:24px}.m-v-lg{margin-top:32px;margin-bottom:32px}.m-h-xs{margin-left:4px;margin-right:4px}.m-h-sm{margin-left:8px;margin-right:8px}.m-h{margin-left:16px;margin-right:16px}.m-h-md{margin-left:24px;margin-right:24px}.m-h-lg{margin-left:32px;margin-right:32px}.m-t{margin-top:16px}.m-t-xs{margin-top:4px}.m-t-sm{margin-top:8px}.m-t-md{margin-top:24px}.m-t-lg{margin-top:32px}.m-t-xlg{margin-top:80px!important}.m-t-radio-execution{margin-top:calc(100% - 60px)!important}.m-r{margin-right:16px}.m-r-xs{margin-right:4px}.m-r-sm{margin-right:8px}.m-r-md{margin-right:24px}.m-r-lg{margin-right:32px}.no-m-r{margin-right:0}.m-r-xl{margin-right:32px}.m-b{margin-bottom:16px}.m-b-xs{margin-bottom:4px}.m-b-sm{margin-bottom:8px}.m-b-md{margin-bottom:24px}.m-b-lg{margin-bottom:32px}.m-b-button{margin-bottom:64px}.m-l{margin-left:16px}.m-l-xs{margin-left:4px}.m-l-sm{margin-left:8px}.m-l-md{margin-left:24px}.m-l-lg{margin-left:32px}.m-l-button{margin-left:147px}.no-m-l{margin-left:0}.m-n{margin:-16px}.m-h-n{margin-left:-16px;margin-right:-16px}.m-v-n{margin-top:-16px;margin-bottom:-16px}.m-l-n{margin-left:-16px}.m-r-n{margin-right:-16px}.m-t-n{margin-top:-16px}.m-t-n-sm{margin-top:-4px}.m-b-n{margin-bottom:-16px}.no-m-t{margin-top:0!important}.no-m-b{margin-bottom:0}.no-m-l{margin-left:0!important}.no-m-r{margin-right:0!important}.no-padding{padding:0!important}.no-padding-h{padding-left:0!important;padding-right:0!important}.no-padding-v{padding-bottom:0!important}.no-padding-t,.no-padding-v,.p-t-0{padding-top:0!important}.no-padding-b,.p-b-0{padding-bottom:0!important}.no-padding-r,.p-r-0{padding-right:0!important}.no-padding-l,.p-l-0{padding-left:0!important}.p-xs{padding:4px}.p-sm{padding:8px}.p{padding:16px}.p-md{padding:24px}.p-lg{padding:32px}.p-r{padding-right:8px}.p-r-md{padding-right:24px}.p-r-lg{padding-right:32px}.p-h{padding-left:16px;padding-right:16px}.p-h-xs{padding-left:4px;padding-right:4px}.p-h-sm{padding-left:8px;padding-right:8px}.p-h-md{padding-left:24px;padding-right:24px}.p-h-lg{padding-left:32px;padding-right:32px}.p-v{padding-top:16px;padding-bottom:16px}.p-v-xs{padding-top:4px;padding-bottom:4px}.p-v-sm{padding-top:8px;padding-bottom:8px}.p-v-md{padding-top:24px;padding-bottom:24px}.p-v-lg{padding-top:32px;padding-bottom:32px}.p-v-xl{padding-bottom:55px}.p-t-xl,.p-v-xl{padding-top:55px}.p-t{padding-top:15px}.p-t-12{padding-top:12px}.p-t-md{padding-top:24px}.p-t-lg{padding-top:32px}.p-t-xs{padding-top:8px}.p-b{padding-bottom:15px}.p-b-md{padding-bottom:24px}.p-b-lg{padding-bottom:32px}.p-b-xs{padding-bottom:8px}.p-t-sm{padding-top:8px}.p-t-ss{padding-top:5px}.p-b-sm{padding-bottom:8px}.p-l{padding-left:16px}.p-l-sm{padding-left:8px}.p-l-md{padding-left:24px!important}.p-l-lg{padding-left:32px}.p-l-cal{padding-left:64px}.p-l-xl{padding-left:35px!important}.no-padding-h{padding-left:0;padding-right:0}.p-btn-lg,.padding-box{padding:15px}.padding{padding:32px}.padding-out{margin:-32px}@media (max-width:992px){.padding{padding:16px}.padding-out{margin:-16px}}@media (max-width:767px){.padding{padding:8px}.padding-out{margin:-8px}}.no-radius{border-radius:0!important}.no-r-t{border-top-left-radius:0}.no-r-r,.no-r-t{border-top-right-radius:0}.no-r-b,.no-r-r{border-bottom-right-radius:0}.no-r-b,.no-r-l{border-bottom-left-radius:0}.no-r-l{border-top-left-radius:0}.r{border-radius:3px}.r-t{border-top-left-radius:3px}.r-r,.r-t{border-top-right-radius:3px}.r-b,.r-r{border-bottom-right-radius:3px}.r-b,.r-l{border-bottom-left-radius:3px}.r-l{border-top-left-radius:3px}.r-2x{border-radius:6px}.r-3x{border-radius:9px}.scrollable{overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}.scrollable.hover{overflow-y:hidden!important}.scrollable.hover>*{margin-top:-1px}.scrollable.hover:hover{overflow:visible!important;overflow-y:auto!important}.smart .scrollable{overflow-y:auto!important}.scroll-x,.scroll-y{overflow:hidden;-webkit-overflow-scrolling:touch}.scroll-y{overflow-y:auto}.scroll-x{overflow-x:auto}.no-shadow{box-shadow:none!important}.box-shadow{box-shadow:0 1px 3px rgba(0,0,0,.05)}.box-shadow-md{box-shadow:0 3px 5px rgba(0,0,0,.05)}.box-shadow-lg{box-shadow:0 5px 10px rgba(0,0,0,.05)}.box-shadow-inset{box-shadow:inset 0 -3px 0 rgba(0,0,0,.15)}.text-shadow{text-shadow:0 4px 0 rgba(0,0,0,.1)}.l-h{line-height:1.42857143}.l-h-1x{line-height:1}.l-h-2x{line-height:2em}.l-s-1x{letter-spacing:1}.l-s-2x{letter-spacing:2}.l-s-3x{letter-spacing:3}.h-1x{height:20px}.h-2x{height:40px}.h-3x{height:60px}.h-4x{height:80px}.font-normal{font-weight:400}.font-thin{font-weight:300}.font-medium{font-weight:500}.font-semibold{font-weight:600}.font-bold{font-weight:700}.font-italic{font-style:italic}.font-test{text-align:justify}.text-4x{font-size:4em}.text-3x{font-size:3em}.text-2x{font-size:2em}.text-xl{font-size:32px}.text-lg{font-size:24px}.text-md{font-size:16px}.text-base{font-size:14px}.text-sm{font-size:13px}.text-sm-important{font-size:13px!important}.text-xs{font-size:12px}.text-xs-important{font-size:12px!important}.text-xxs{font-size:10px}.text-xxs-important{font-size:10px!important}.text-u-c{text-transform:uppercase}.text-l-t{text-decoration:line-through}.text-u-l{text-decoration:underline}.text-16-important{font-size:16px!important}.text-20{font-size:20px}.text-ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.text-fade{position:relative;overflow:hidden}.text-fade:after{content:\"\";text-align:right;position:absolute;bottom:0;right:0;width:70%;height:1.2em;background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff 50%)}.no-select{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (min-width:768px) and (max-width:991px){.text-center-sm{text-align:center}.text-left-sm{text-align:left}.text-right-sm{text-align:right}}@media (max-width:767px){.text-center-xs{text-align:center}.text-left-xs{text-align:left}.text-right-xs{text-align:right}}.text-right{text-align:right!important}.text-left{text-align:left!important}.text-center{text-align:center!important}md-tabs.capitalize md-tab-item span{text-transform:capitalize}.vertical-align-sm{vertical-align:-13%}.h5,h5{font-size:16px}.text-padd{padding-top:4px}.w-16{width:16px;height:16px}.w-20{width:20px;height:20px}.w-24{width:24px;height:24px}.w-32{width:32px;height:32px}.w-40{width:40px;height:40px}.w-48{width:48px;height:48px}.w-56{width:56px;height:56px}.w-64{width:64px;height:64px}.w-xxl{width:60px}.w-xs{width:90px}.w-sm{width:120px}.w{width:180px}.w-md{width:200px}.w-lg{width:240px}.w-xl{width:280px}.w-xxl{width:320px}.w-full{width:100%}.w-auto{width:auto}.h-auto{height:auto}.h-full{height:100%}@media (max-width:991px){.w-auto-sm{width:auto}.w-full-sm{width:100%}}@media (max-width:767px){.w-auto-xs{width:auto}.w-full-xs{width:100%}}md-grid-list{margin-bottom:4px}.panel-heading h3{margin-top:0;margin-bottom:0;font-size:20px}.no-brd{border:transparent}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{vertical-align:middle}.footable.breakpoint>tbody>tr>td>span.footable-toggle{padding-right:12px!important;color:#fecd1a!important}.footable.breakpoint>tbody>tr>td>span.footable-toggle:before{content:\"\\E011\"}.footable.breakpoint>tbody>tr.footable-detail-show>td>span.footable-toggle:before{content:\"\\E00F\"}.detail{background-image:url(" + __webpack_require__(1541) + ");background-repeat:no-repeat;background-size:contain;background-position:100%}.v-line,div.navbar-brand-top-menu{background-repeat:no-repeat;background-size:contain;background-position:0;display:inline-block}div.navbar-brand-top-menu{background-image:url(" + __webpack_require__(1181) + ");width:128px;margin:10px 20px 0;height:47px}.app-content-header{height:45px;overflow:hidden;color:#636f07}.app-content-header a{color:#636f07}.app-content-header .navbar{background-color:#f3e7cc;border-radius:0}.leftbarbg{background-image:url(" + __webpack_require__(1544) + ");background-size:cover}.image_portal{background-image:url(" + __webpack_require__(294) + ");width:64px;height:65px!important;background-size:100%;background-repeat:no-repeat}.image_profile_blog_comments{width:32px;height:32px!important}.image_profile_blog,.image_profile_blog_comments{background-size:100%;background-repeat:no-repeat;margin-top:5px}.image_profile_blog{width:100px;height:100px!important;box-shadow:0 8px 6px -6px #000}.mainActivityDetails .leftActivityDetailsCheck{display:none}body .bg-review .leftActivityDetailsCheck span{color:#dad7d7!important}body .bg-review .leftActivityDetailsCheck .md-check>i:before{border:2px solid #dad7d7!important}.mdi-navigation-menu{font-size:32px}.box-inner{padding-top:0}.background-planning{background-color:#232702;background-image:url(" + __webpack_require__(1553) + ");background-repeat:no-repeat;background-position:50%;background-size:cover;color:#fff}.background-planning:before{content:\"\";background:linear-gradient(to bottom right,#232702,#a3b70c);bottom:0;left:0;opacity:.85;position:absolute;right:0;top:0}.fullscreen .app-aside.folded~.app-content{margin-top:0}.grid-workplan{width:100%;min-height:307px!important;max-height:800px!important;border:0;background-color:rgba(212,239,255,.1);border-radius:2px}.grid-workplan .ui-grid-viewport{overflow:auto!important}.grid-workplan .ui-grid-canvas{width:100%!important;margin-right:0}.grid-workplan .ui-grid-cell{height:auto!important}.grid-workplan .ui-grid-row:nth-child(2n) .ui-grid-cell,.grid-workplan .ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent!important}.grid-workplan .ui-grid-header-cell,.grid-workplan .ui-grid-top-panel{background:transparent!important}.grid-workplan .ui-grid-cell-contents{font-family:proxima-nova;font-size:14px;font-weight:300;opacity:.85;letter-spacing:1px;color:#fff}.grid-workplan .ui-grid-row{display:flex;min-height:60px!important;height:auto!important;padding-top:20px;padding-bottom:20px;border-bottom:1px solid hsla(0,0%,100%,.4)}.grid-workplan .ui-grid-header-cell-label{font-family:Exo!important;font-size:16px;font-weight:700;letter-spacing:0!important;opacity:1}.grid-committee{width:100%;min-height:307px!important;max-height:800px!important;border:0;background-color:rgba(212,239,255,.1);border-radius:2px}.grid-committee .ui-grid-render-container-body .ui-grid-viewport{width:100%!important;overflow-x:hidden!important}.grid-committee .ui-grid-canvas{width:100%!important;margin-right:0}.grid-committee .ui-grid-cell{height:auto!important}.grid-committee .ui-grid-row:nth-child(2n) .ui-grid-cell,.grid-committee .ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent!important}.grid-committee .ui-grid-header-cell,.grid-committee .ui-grid-top-panel{background:transparent!important}.grid-committee .ui-grid-cell-contents{font-family:proxima-nova;font-size:14px;font-weight:300;opacity:.85;letter-spacing:1px;color:#fff;text-overflow:ellipsis;overflow-x:hidden}.grid-committee .ui-grid-row{display:flex;min-height:60px!important;height:auto!important;padding-top:20px;padding-bottom:20px;border-bottom:1px solid hsla(0,0%,100%,.4)}.grid-committee .ui-grid-header-cell-label{font-family:Exo!important;font-size:16px;font-weight:700;letter-spacing:0!important;opacity:1}.intro-message{width:60%;margin:0 auto}.intro-message span{display:block;width:70%;margin:0 auto}.intro-message h1{font-size:24px;font-weight:700;line-height:35px;letter-spacing:1px}.btn-fullscreen.btn.btn-success{display:block;letter-spacing:1px;margin:32px auto 0;border-radius:150px}::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px transparent;border-radius:10px;background-color:transparent}::-webkit-scrollbar{width:12px;background-color:transparent}::-webkit-scrollbar-thumb{border-radius:10px;-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.1);background-color:rgba(0,0,0,.3)}::-webkit-scrollbar-corner{background:transparent}#content.content-fullscreen{margin:0!important}.search .btn{border-left-width:0;left:-1px;box-shadow:none;z-index:2;border-color:#e5e5e5}.search .search-btn{padding:5px}.search .input-group-btn>.btn:focus,.search .input-group-btn>.btn:hover{background-color:#fff!important;cursor:auto}.autocomplete input,.autocomplete md-autocomplete,.search-autocomplete input,.search-autocomplete md-autocomplete,.search input{height:36px!important}.autocomplete md-autocomplete,.search-autocomplete md-autocomplete{border:1px solid #e5e5e5}.autocomplete .md-whiteframe-z1,.search-autocomplete .md-whiteframe-z1{box-shadow:none}.search input:focus{border-color:#e5e5e5}.search-autocomplete i,.search .btn i{opacity:.5}md-dialog textarea{min-height:60px!important}.content-activities{display:flex;flex-direction:row;flex-wrap:wrap}.inline-activity{flex:1 50%;display:flex;text-align:left;align-items:flex-start}.search-autocomplete i{position:absolute;right:7px;top:6px}.search-sutocomplete .form-group{position:relative}.datepicker-select{width:200px}.datepicker-select .md-datepicker-input{padding-top:5px}md-autocomplete[md-clear-button=false] button{display:none}.radio-options{display:flex;align-items:center;margin-top:26px;flex-wrap:wrap}.radio-options div{padding:10px 13px 10px 40px;position:relative}.radio-options i{position:relative;display:inline-block;width:0;height:18px;margin-top:-2px;margin-right:28px;margin-left:-20px;line-height:1;vertical-align:middle}.radio-options i:before{position:absolute;width:18px;height:100%;border:2px solid rgba(0,0,0,.54);border-radius:2px;content:\"\";transition:all .2s}.radio-options input{position:absolute;z-index:1;width:20px;height:20px;margin-left:-20px;cursor:pointer;opacity:0}.radio-options input[type=radio]+i,.radio-options input[type=radio]+i:before{border-radius:50%}.radio-options input:checked+i:before{background-color:inherit;border-width:0}.radio-options input[type=radio]:checked+i:after{position:absolute;top:6px;left:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.radio-green{background-color:#aace3b;color:#fff}.categories .mdi-content-add,.categories .mdi-content-remove{opacity:1;padding-right:5px}.select-inline{display:flex;align-items:center}.datepicker-select{padding-left:8px;float:left;border:1px solid #e5e5e5;margin-right:20px;margin-top:10px;width:100%}.datepicker-select .md-datepicker-input{min-width:176px;padding-bottom:2px;width:100%;height:34px}.datepicker-select .md-datepicker-input-container{border:0;width:100%;position:relative;height:30px;padding-left:6px}.datepicker-select .md-datepicker-triangle-button.md-button.md-icon-button{right:9px;top:6px;width:34px;height:34px;padding:0}.btn-cancel{background-color:#f7f7f7;border-color:#eaeaea}md-datepicker .md-button.md-icon-button{margin:0}.form-control{padding-left:4px}.form-control:focus,md-input-container:not(.md-input-invalid).md-input-focused .md-input,textarea.md-input,textarea.md-input:active,textarea.md-input:focus{border:1px solid hsla(0,0%,80%,.86)}.has-error textarea.md-input,.has-error textarea.md-input:active,.has-error textarea.md-input:focus{border:1px solid #a94442}md-input-container.md-default-theme.md-input-invalid .md-char-counter,md-input-container.md-default-theme.md-input-invalid .md-input-message-animation,md-input-container.md-default-theme.md-input-invalid label,md-input-container.md-input-invalid .md-char-counter,md-input-container.md-input-invalid .md-input-message-animation,md-input-container.md-input-invalid label{color:#a94442}md-input-container.md-input-focused .md-input,md-input-container.md-input-resized .md-input,md-input-container .md-input.ng-invalid.ng-dirty{border-width:1px}.slick-track,.slider{height:auto}.slick-next,.slick-prev{width:60px!important;height:60px!important}.slick-next:before,.slick-prev:before{font-size:50px!important;text-shadow:1px 1px 8px rgba(0,0,0,.2)}body .slick-prev{left:-46px!important}body .slick-next{right:-46px!important}@media (min-width:1360px) and (max-width:1919px){.card.horizontal,.slick-slide{height:330px!important}.slick-list{height:340px!important}.slick-oblique .slick-list{height:460px!important}.slick-oblique .slick-list .card{height:478px}.slick-oblique .slick-list .card-heading{min-height:auto}.slick-oblique-medium .slick-list{height:460px!important}.slick-oblique-medium .slick-list .card{height:410px}.slick-oblique-medium .slick-list .card-heading{max-height:140px}.slick-oblique-large .slick-list{height:540px!important}.slick-oblique-large .slick-list .card{height:520px}.slick-oblique-large .slick-list .card-heading{max-height:140px}.long{height:180px}}@media (max-width:1920px){.card.horizontal,.slick-slide{height:330px!important}.slick-list{height:340px!important}.slick-oblique .slick-list{height:484px!important}.slick-oblique .slick-list .card{height:480px}.slick-oblique .slick-list .card-heading{min-height:auto}.slick-oblique-medium .slick-list{height:460px!important}.slick-oblique-medium .slick-list .card{height:410px}.slick-oblique-medium .slick-list .card-heading{max-height:120px}.slick-oblique-large .slick-list{height:540px!important}.slick-oblique-large .slick-list .card{height:520px}.slick-oblique-large .slick-list .card-heading{max-height:125px}}.slick-oblique .hours{position:absolute;border-radius:50px;width:75px;right:7px;bottom:-16px}.slick-oblique .period{height:100px}.slick-oblique-large .hours{position:absolute;border-radius:50px;width:75px;right:7px;bottom:-16px}.slick-oblique .card-body{height:226px}.slick-oblique .card-heading.hidden-content{overflow:hidden}.slick-oblique-large .card-body.long{height:282px;overflow:hidden}.slick-oblique-large .card-heading{height:140px}.slick-oblique-header{height:200px}.card.horizontal{display:flex;box-shadow:0 0 8px rgba(0,0,0,.15);border-radius:15px}.card.horizontal .first-content{overflow:hidden;min-height:110px;display:flex;flex-direction:column;justify-content:center}.card.horizontal .card-heading{display:flex;flex-direction:column;justify-content:center;min-width:200px}.card.horizontal .card-heading p{max-height:150px;overflow:hidden;margin-top:0}.card.horizontal .card-body{text-align:left;padding:16px 24px}.card.horizontal .list-items{list-style:none}.card.horizontal .btn{width:100%}.card-border-radius{box-shadow:0 0 8px rgba(0,0,0,.15);border-radius:20px}@media (min-width:992px){.card.horizontal .list-items{height:160px;overflow:hidden}}@media (min-width:1360px) and (max-width:1919px){.card.horizontal .list-items{height:160px;overflow:hidden}}@media (min-width:1920px){.card.horizontal .list-items{height:160px;overflow:hidden}.color-cards .card-heading{padding:55px}.color-cards .card-body{padding:32px}.color-cards .card-heading .icon{font-size:50px}.color-cards .card-body h5{font-size:16px}}.brd-md{border-radius:20px}.i-40{font-size:40px;vertical-align:-39%}.color-cards .box-shadow{box-shadow:0 2px 14px rgba(0,0,0,.2)}.profile-cards .box-shadow{box-shadow:0 2px 4px #ccc}.profile-cards .fixed-height-300{height:300px;overflow-y:scroll;overflow-x:hidden;position:relative}.profile-cards .fixed-height-800{height:800px;overflow-y:scroll;overflow-x:hidden;position:relative}.profile-cards .grad-white{content:\"\";position:absolute;bottom:0;left:0;right:16px;height:50px;z-index:10;background:transparent;background:-webkit-gradient(color-stop(0,hsla(0,0%,98%,0)),color-stop(100%,#f9f9f9));background:linear-gradient(hsla(0,0%,98%,0),#f9f9f9);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"transparent\",endColorstr=\"#f9f9f9\",GradientType=1)}.blog-statement{box-shadow:0 2px 4px #ccc}.blog-statement .html-text{height:179px;overflow-y:scroll;position:relative}.dialog-statement{height:200px;overflow-y:auto;position:relative;padding:10px 0;color:#6f6f6e!important}.dialog-statement a{color:#e95d0f!important;text-decoration:underline}.dialog-statement.row{text-align:left}.fixed-height-345{height:345px;overflow-y:scroll;position:relative}.fixed-height-250{height:250px;overflow-y:scroll;position:relative}.masonry-cols-2{column-count:2;column-gap:10px}.masonry-cols-4{column-count:4;column-gap:10px}.masonry-break{break-inside:avoid-column;page-break-inside:avoid}md-dialog{max-width:40%;padding-bottom:30px}md-toolbar{background-color:transparent!important;min-height:30px}md-dialog .icon{display:block;color:#263238}md-dialog .add-button .icon{color:#fff}.md-toolbar-tools{flex-direction:row-reverse;padding:0;height:30px}.md-toolbar-tools .md-icon-button{padding:0;height:20px;width:30px;align-self:flex-start}.md-toolbar-tools>.md-button:last-child{margin-right:0}md-dialog .row{text-align:center;padding:5px 20px;margin:0}md-dialog .row h3,md-dialog .row h4{margin:0 0 10px}md-dialog .row1 h3,md-dialog .row1 h4{color:#ef7955;margin:0 0 10px}md-dialog .row1{text-align:center;padding:5px 64px;margin:0}md-dialog a i{font-size:70px;padding:25px;display:block;width:120px;height:120px;border-radius:100%;margin:0 auto;color:#fff!important;margin-bottom:10px}md-dialog .row .create a{color:#aace3b}md-dialog .row .clone a{color:#2053d2}md-dialog .row .create a i{background-color:#aace3b}md-dialog .row .clone a i{background-color:#2053d2}md-dialog .with-bullets{list-style:none}md-dialog .with-bullets li{position:relative}md-dialog .with-bullets li:before{width:8px;height:8px;margin-right:5px;background-color:#2053d2;border-radius:100%;padding:1px;content:\"\";position:absolute;top:5px;left:-14px;right:0;bottom:0}.column-right{text-align:right}.column-center{text-align:center}.column-left{text-align:left}.ui-grid-cell-contents{padding:5px 10px;box-sizing:border-box;white-space:nowrap;-ms-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;height:100%;font-size:12px}.ui-grid-cell-contents a{color:#e95d0f}.ui-grid-header-cell{background-color:#2053d2;color:#fff;border-right:0 solid;border-color:#91a3bd}.ui-grid-top-panel{font-weight:700;background:#2053d2;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0);-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}.grid-btn{margin:0;border-radius:2px;min-height:10px;min-width:130px;padding:0;font-size:12px;height:22px;line-height:1.5;font-weight:400;font-family:proxima-nova!important}.grid-darker-gray .ui-grid-header-cell,.grid-darker-gray .ui-grid-top-panel{background-color:#758295}.grid-darker-gray .ui-grid-row.ui-grid-row-selected>[ui-grid-row]>.ui-grid-cell{background-color:#2053d2;color:#fff}.grid-darker-gray .ui-grid-viewport ng-isolate-scope{border-left:1px solid #f2f5f7}.grid-blue .ui-grid-cell-contents{padding-bottom:0}.grid-blue input[type=text].ui-grid-filter-input{border-radius:0!important}.grid-blue .ui-grid-pager-panel{background-color:#ccd0db;font-size:12px}.grid-blue .ui-grid-pager-panel button{background-color:transparent}.grid-blue .ui-grid-pager-panel .ui-grid-pager-count-container{float:left;margin-left:16px;margin-top:6px}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control input,.grid-blue .ui-grid-pager-panel .ui-grid-pager-row-count-picker select{background-color:hsla(0,0%,100%,.5)}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control .first-triangle{border-width:4px 7.7px 4px 0}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control .last-triangle{border-width:4px 0 4px 7.7px}.grid-blue .cell-button .ui-grid-cell-contents{padding:0!important}.grid-blue .grid-with-button .ui-grid-row{height:35px}.ui-grid-viewport{overflow-anchor:none}.custom-tooltip{font-size:12px;font-weight:700}.custom-s-tooltip,.custom-tooltip{background-color:#000!important;color:#fff!important}.custom-s-tooltip{font-size:10px}.md-toast-content{background:#2053d2!important}.squarerify{border-radius:0!important}.opacity-4{opacity:.4}.transparent{background-color:hsla(0,0%,100%,.2)}.close-text{line-height:12px}.word-wrap{word-wrap:break-word}.custom-autoselect .md-icon{top:35%}.list{border-bottom:1px solid #e5e5e5;overflow:hidden;margin-bottom:8px}.strip-btn{background:none;border:none}.activityTag{border-radius:5px;padding:4px 5px;min-width:68px;cursor:default;text-align:center;max-height:40px;font-size:11px}.w-h-100{width:100%;height:100%}.list-h{height:65vh;overflow-y:auto}.text-block{display:inline-block}.left{float:left}.right{float:right}.bg-review{background:#5700da}.rightDivider{border-right:1px solid #e5e5e5;height:auto}.verticalDivider{border-left:1px solid #e5e5e5;height:50vw}.horizontalDivider,.teacherList{border-bottom:1px solid #e5e5e5}.teacherList{color:#aace3b}.teacherList p{display:inline-block;color:rgba(0,0,0,.87);width:88%}.list a,.teacherList .md-button{color:#e5e5e5}.dark-icon{color:rgba(0,0,0,.87)}.webeditor .btn{padding:5.8px;border:none}.webeditor .btn-toolbar{margin:0}.webeditor .btn-toolbar,.webeditor .text-angular-toolbar{background:rgba(0,0,0,.1)}.webeditor .ta-scroll-window.form-control,.webeditor .ta-scroll-window>.ta-bind{min-height:150px}.webeditor .ta-scroll-window.form-control a,.webeditor .ta-scroll-window>.ta-bind a{color:#e95d0f;text-decoration:underline}.webeditor .ta-toolbar{background-color:#ccd0db}.webeditor .ta-toolbar button{background-color:transparent}.webeditor .ta-toolbar button.active{background-color:#91a3bd!important;box-shadow:none}.webeditor .ta-toolbar button.active i{color:#fff}.webeditor .ta-toolbar i{color:#353942}.long-datepicker input{margin:3px 15px 2px;padding:0}.long-datepicker .md-datepicker-input-container{display:block;border:none!important}.long-datepicker .md-datepicker-input-container .md-datepicker-expand-triangle{left:75%}.tab-title-with-form{background:#f2f5f7;height:75px;align-self:flex-end;border-top-left-radius:16px;border-top-right-radius:16px}.parametersLister{border-top:2px solid #e5e5e5;padding:8px 0}.parametersLister .bullet{margin:0;border-radius:50%;width:15px;height:15px;background:#2053d2}.parametersLister p{display:inline;color:rgba(0,0,0,.87);width:80%;line-height:12px;margin:0}.parametersLister button{float:right}md-tabs.default-tabs.md-default-theme md-ink-bar,md-tabs.default-tabs md-ink-bar{color:#fff;background-color:#e95d0f}md-tabs.default-tabs.md-default-theme .md-tab,md-tabs.default-tabs.md-default-theme .md-tab.md-active,md-tabs.default-tabs.md-default-theme .md-tab.md-active md-icon,md-tabs.default-tabs.md-default-theme .md-tab.md-focused,md-tabs.default-tabs.md-default-theme .md-tab.md-focused md-icon,md-tabs.default-tabs .md-tab,md-tabs.default-tabs .md-tab.md-active,md-tabs.default-tabs .md-tab.md-active md-icon,md-tabs.default-tabs .md-tab.md-focused,md-tabs.default-tabs .md-tab.md-focused md-icon{color:#263238;font-weight:400;font-size:14px}md-tabs.md-default-theme .md-tab.md-active,md-tabs.md-default-theme .md-tab.md-active md-icon,md-tabs.md-default-theme .md-tab.md-focused,md-tabs.md-default-theme .md-tab.md-focused md-icon,md-tabs .md-tab.md-active,md-tabs .md-tab.md-active md-icon,md-tabs .md-tab.md-focused,md-tabs .md-tab.md-focused md-icon{color:#263238}md-tabs.md-default-theme md-ink-bar,md-tabs md-ink-bar{color:#263238;background:#aace3b}md-tab-item.md-tab{color:#546e7a;background-color:#fff}.with-bullets,.without-bullets{list-style:none}.with-bullets li{position:relative}.with-bullets li:before{width:8px;height:8px;margin-right:5px;background-color:#aace3b;border-radius:100%;padding:1px;content:\"\";position:absolute;top:16px;left:6px;right:0;bottom:0}.with-bullets.bullets-md li:before{top:8px}textarea{resize:none}.without-bullets li{position:relative;padding:8px 0}.without-bullets li button{position:absolute;right:0}.mdinputcontainerwrapper,.mdinputcontainerwrapper md-input-container{padding-bottom:0;margin-bottom:0}.mdinputcontainerwrapper label{color:#000}.rounded-list .list-title{max-height:42px;overflow:hidden}.rounded-list .detail{max-height:40px;overflow:hidden}.max-height{max-height:130px;overflow:hidden}.div-father{position:relative}.div-gris{background-color:#f2f2f2;width:95%;opacity:.5}.div-green,.div-gris{height:11px;margin-left:15px;position:absolute;border-radius:200px 200px 200px 200px;top:64%;left:0;right:100%;bottom:100%}.div-green{background-color:#04b404;width:150px}.tl-radio{background-color:#a4a4a4;border-radius:50px;bottom:60%;height:30px;top:0;right:0;width:30px}.radio-planification{left:0}.radio-approval{left:33%}.radio-execution{left:66%}.radio-evaluation{left:100%}.radio-white{background-color:#fff;width:18px;height:18px;position:relative;top:19%;left:20%;right:0;bottom:60%;border-radius:50px}.tl-square{background-color:transparent;width:80px;height:30px;position:absolute;top:0;right:0;bottom:100%}.square-planification{left:0}.square-approval{left:33%}.square-execution{left:66%}.square-evaluation{left:95%}.tl-label{margin-left:-22%}.teaching{color:#fff;margin-top:80px}.underscore{text-decoration:underline;cursor:pointer}.disabled{pointer-events:none;cursor:default}.autocomplete{box-shadow:inset 0 1px 1px rgba(0,0,0,.075);height:34px;border:1px solid #ccc}.projectTypeTag{border-radius:5px;padding:0 4px;min-width:68px;cursor:default;height:20px;text-align:center;line-height:20px}.activity_checkbox md-checkbox.md-checked .md-icon,.activity_checkbox md-checkbox.md-default-theme.md-checked .md-icon{background-color:#7abf15}.activity_checkbox{margin-top:10px;text-align:center}.img-container{height:0;display:inline-block;padding:0 25px 0 0;border-right:32px solid transparent;border-bottom:148px solid #4082b9;line-height:50px}.capitalize{text-transform:none}.md-tab,md-tabs.capitalize md-tab-item span{text-transform:inherit}@media (max-width:1753px){.img-container{border-bottom:159px solid #4082b9}}@media (max-width:1700px){.img-container{border-bottom:180px solid #4082b9}.img-container img.img-circle{margin-top:22px;margin-left:10px}}@media (max-width:1430px){.img-container{border-bottom:190px solid #4082b9;padding:0}.img-container img.img-circle{margin-top:22px;margin-left:-33px}}@media (max-width:991px){.img-container{border-bottom:148px solid #4082b9;padding:0}}md-checkbox,md-checkbox.md-checked .md-icon:after{-webkit-backface-visibility:hidden;backface-visibility:hidden}md-checkbox.md-checked .md-icon:after{box-sizing:border-box;transform:rotate(45deg);position:absolute;left:4.66667px;top:.22222px;display:table;width:6.66667px;height:13.33333px;border-width:2px;border-style:solid;border-top:0;border-left:0;content:\"\"}.bg-grey{background:#758295;cursor:not-allowed}.projectVisibilityTag{height:auto}.loading-details{position:absolute;top:0;left:0;height:100%;width:100%;padding-top:20%;z-index:999}table.table.table-no-bordered tr>td{border-top:inherit}tspan{font-size:inherit}md-dialog{max-width:100%;width:60%;max-height:95%}.comments{max-height:390px;overflow-y:auto}.comments .body-comment p,.comments .header-comment p{text-align:left}.comment-response{padding-left:40px}.comment-response .item-comment.ng-scope{border-left:6px solid rgba(64,55,189,.52)}.body-comment .comments-actions>a{margin-left:12px}.card-heigth{height:330px!important}.tooltip-multiline{height:auto}dl{display:grid;grid-gap:10px;grid-template-columns:1fr 1fr;margin-bottom:10px}dl p{margin-bottom:0}#loading-bar .bar{background:#e95d0f;height:3px;border-top:1px solid #f48b51;border-radius:0 200px 200px 0;border-right:1px solid #f48b51;box-shadow:0 2px 10px 0 rgba(0,0,0,.5);z-index:10002!important}#loading-bar-spinner{display:none;top:50%;left:50%}#loading-bar-spinner .spinner-icon{width:40px;height:40px;border:3px solid transparent;border-top-color:#e95d0f;border-left-color:#e95d0f;border-radius:50px;animation:loading-bar-spinner .8s linear infinite}.internal-diagram.c100 .bar{position:absolute;border:none;width:1em;height:1em;clip:rect(0,.5em,1em,0);border-radius:50%;transform:rotate(0deg)}.internal-diagram.c100.p51 .fill,.internal-diagram.c100.p52 .fill,.internal-diagram.c100.p53 .fill,.internal-diagram.c100.p54 .fill,.internal-diagram.c100.p55 .fill,.internal-diagram.c100.p56 .fill,.internal-diagram.c100.p57 .fill,.internal-diagram.c100.p58 .fill,.internal-diagram.c100.p59 .fill,.internal-diagram.c100.p60 .fill,.internal-diagram.c100.p61 .fill,.internal-diagram.c100.p62 .fill,.internal-diagram.c100.p63 .fill,.internal-diagram.c100.p64 .fill,.internal-diagram.c100.p65 .fill,.internal-diagram.c100.p66 .fill,.internal-diagram.c100.p67 .fill,.internal-diagram.c100.p68 .fill,.internal-diagram.c100.p69 .fill,.internal-diagram.c100.p70 .fill,.internal-diagram.c100.p71 .fill,.internal-diagram.c100.p72 .fill,.internal-diagram.c100.p73 .fill,.internal-diagram.c100.p74 .fill,.internal-diagram.c100.p75 .fill,.internal-diagram.c100.p76 .fill,.internal-diagram.c100.p77 .fill,.internal-diagram.c100.p78 .fill,.internal-diagram.c100.p79 .fill,.internal-diagram.c100.p80 .fill,.internal-diagram.c100.p81 .fill,.internal-diagram.c100.p82 .fill,.internal-diagram.c100.p83 .fill,.internal-diagram.c100.p84 .fill,.internal-diagram.c100.p85 .fill,.internal-diagram.c100.p86 .fill,.internal-diagram.c100.p87 .fill,.internal-diagram.c100.p88 .fill,.internal-diagram.c100.p89 .fill,.internal-diagram.c100.p90 .fill,.internal-diagram.c100.p91 .fill,.internal-diagram.c100.p92 .fill,.internal-diagram.c100.p93 .fill,.internal-diagram.c100.p94 .fill,.internal-diagram.c100.p95 .fill,.internal-diagram.c100.p96 .fill,.internal-diagram.c100.p97 .fill,.internal-diagram.c100.p98 .fill,.internal-diagram.c100.p99 .fill,.internal-diagram.c100.p100 .fill{width:1em;height:1em;border:none;border-color:inherit}.internal-diagram.c100:hover>span{color:#91a3bd}.principal-diagram.c100{border:.08em solid hsla(0,0%,98%,.3);background-color:transparent;box-shadow:0 0 22px -4px rgba(0,0,0,.75)}.principal-diagram.c100:after{top:-.08em;left:-.08em;background-color:transparent;width:1em;height:1em}.principal-diagram.c100 .slice{top:-.08em;left:-.08em}.principal-diagram.c100 .bar{top:0;left:0;right:0;bottom:0}.principal-diagram.c100>span{left:-.32em;top:-.6em;bottom:-.32em;right:.16em}.c100.big{font-size:190px}.c100.md{font-size:100px}.c100.sm{font-size:65px}.c100.xs{font-size:40px}.disabled.c100.green:hover>span{color:#ccc}.disabled.c100:hover>span{width:5em;line-height:5em;font-size:.2em}@media (min-width:980px) and (max-width:1200px){.c100.big{font-size:135px}.c100.big h4{font-size:10px!important}.c100.big .m-t-radio-execution{margin-top:61%!important}}.bar.b-rojo{border:.08em solid #ef7955}.bar.b-azul{border:.08em solid #2053d2}.bar.b-verde{border:.08em solid #aace3b}.bar.b-morado{border:.08em solid #7e57c2}.bar.b-naranja{border:.08em solid #ff9800}.col-lg-1-5,.col-md-1-5,.col-sm-1-5,.col-xs-1-5{position:relative;min-height:1px;padding-right:10px;padding-left:10px}.col-xs-1-5{width:20%;float:left}.c100.red .bar,.c100.red .fill{border-color:#d7634a!important}.c100.red:hover>span{color:#d7634a}.c100.red.dark .bar,.c100.red.dark .fill{border-color:#b71c1c!important}.c100.red.dark:hover>span{color:#b71c1c}.c100.pink .bar,.c100.pink .fill{border-color:#e91e63!important}.c100.pink:hover>span{color:#e91e63}.c100.pink.dark .bar,.c100.pink.dark .fill{border-color:#880e4f!important}.c100.pink.dark:hover>span{color:#880e4f}.c100.purple .bar,.c100.purple .fill{border-color:#9c27b0!important}.c100.purple:hover>span{color:#9c27b0}.c100.purple.dark .bar,.c100.purple.dark .fill{border-color:#4a148c!important}.c100.purple.dark:hover>span{color:#4a148c}.c100.deep-purple .bar,.c100.deep-purple .fill{border-color:#673ab7!important}.c100.deep-purple:hover>span{color:#673ab7}.c100.deep-purple.dark .bar,.c100.deep-purple.dark .fill{border-color:#311b92!important}.c100.deep-purple.dark:hover>span{color:#311b92}.c100.indigo .bar,.c100.indigo .fill{border-color:#3f51b5!important}.c100.indigo:hover>span{color:#3f51b5}.c100.indigo.dark .bar,.c100.indigo.dark .fill{border-color:#1a237e!important}.c100.indigo.dark:hover>span{color:#1a237e}.c100.blue .bar,.c100.blue .fill{border-color:#00548a!important}.c100.blue:hover>span{color:#00548a}.c100.blue.dark .bar,.c100.blue.dark .fill{border-color:#0d47a1!important}.c100.blue.dark:hover>span{color:#0d47a1}.c100.light-blue .bar,.c100.light-blue .fill{border-color:#468ac2!important}.c100.light-blue:hover>span{color:#468ac2}.c100.light-blue.dark .bar,.c100.light-blue.dark .fill{border-color:#01579b!important}.c100.light-blue.dark:hover>span{color:#01579b}.c100.cyan .bar,.c100.cyan .fill{border-color:#00bcd4!important}.c100.cyan:hover>span{color:#00bcd4}.c100.cyan.dark .bar,.c100.cyan.dark .fill{border-color:#006064!important}.c100.cyan.dark:hover>span{color:#006064}.c100.teal .bar,.c100.teal .fill{border-color:#009688!important}.c100.teal:hover>span{color:#009688}.c100.teal.dark .bar,.c100.teal.dark .fill{border-color:#004d40!important}.c100.teal.dark:hover>span{color:#004d40}.c100.green .bar,.c100.green .fill{border-color:#4caf50!important}.c100.green:hover>span{color:#4caf50}.c100.green.dark .bar,.c100.green.dark .fill{border-color:#1b5e20!important}.c100.green.dark:hover>span{color:#1b5e20}.c100.light-green .bar,.c100.light-green .fill{border-color:#8bc34a!important}.c100.light-green:hover>span{color:#8bc34a}.c100.light-green.dark .bar,.c100.light-green.dark .fill{border-color:#33691e!important}.c100.light-green.dark:hover>span{color:#33691e}.c100.lime .bar,.c100.lime .fill{border-color:#a8c329!important}.c100.lime:hover>span{color:#a8c329}.c100.lime.dark .bar,.c100.lime.dark .fill{border-color:#827717!important}.c100.lime.dark:hover>span{color:#827717}.c100.yellow .bar,.c100.yellow .fill{border-color:#ffeb3b!important}.c100.yellow:hover>span{color:#ffeb3b}.c100.yellow.dark .bar,.c100.yellow.dark .fill{border-color:#f57f17!important}.c100.yellow.dark:hover>span{color:#f57f17}.c100.amber .bar,.c100.amber .fill{border-color:#fab813!important}.c100.amber:hover>span{color:#fab813}.c100.amber.dark .bar,.c100.amber.dark .fill{border-color:#ff6f00!important}.c100.amber.dark:hover>span{color:#ff6f00}.c100.orange .bar,.c100.orange .fill{border-color:#ff9800!important}.c100.orange:hover>span{color:#ff9800}.c100.orange.dark .bar,.c100.orange.dark .fill{border-color:#e65100!important}.c100.orange.dark:hover>span{color:#e65100}.c100.deep-orange .bar,.c100.deep-orange .fill{border-color:#ff5722!important}.c100.deep-orange:hover>span{color:#ff5722}.c100.deep-orange.dark .bar,.c100.deep-orange.dark .fill{border-color:#bf360c!important}.c100.deep-orange.dark:hover>span{color:#bf360c}.c100.brown .bar,.c100.brown .fill{border-color:#795548!important}.c100.brown:hover>span{color:#795548}.c100.brown.dark .bar,.c100.brown.dark .fill{border-color:#3e2723!important}.c100.brown.dark:hover>span{color:#3e2723}.c100.blue-grey .bar,.c100.blue-grey .fill{border-color:#607d8b!important}.c100.blue-grey:hover>span{color:#607d8b}.c100.blue-grey.dark .bar,.c100.blue-grey.dark .fill{border-color:#263238!important}.c100.blue-grey.dark:hover>span{color:#263238}.c100.grey .bar,.c100.grey .fill{border-color:#6f6f6e!important}.c100.grey:hover>span{color:#6f6f6e}.c100.grey.dark .bar,.c100.grey.dark .fill{border-color:#212121!important}.c100.grey.dark:hover>span{color:#212121}@media (min-width:768px){.col-sm-1-5{width:20%;float:left}}@media (min-width:992px){.col-md-1-5{width:20%;float:left}}@media (min-width:1200px){.col-lg-1-5{width:20%;float:left}}@font-face{font-family:Material-Design-Icons;font-style:normal;font-weight:400;src:url(" + __webpack_require__(1546) + ");src:url(" + __webpack_require__(1547) + "?#iefix-g7cqhn) format(\"embedded-opentype\"),url(" + __webpack_require__(1548) + ") format(\"woff\"),url(" + __webpack_require__(1549) + ") format(\"truetype\"),url(" + __webpack_require__(1550) + "#Material-Design-Icons) format(\"svg\")}[class*=\" mdi-\"],[class^=mdi-]{font-family:Material-Design-Icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;line-height:1;text-transform:none;speak:none;font-variant:normal;-moz-osx-font-smoothing:grayscale}.mdi-action-3d-rotation:before{content:\"\\E600\"}.mdi-action-accessibility:before{content:\"\\E601\"}.mdi-action-account-balance:before{content:\"\\E602\"}.mdi-action-account-balance-wallet:before{content:\"\\E603\"}.mdi-action-account-box:before{content:\"\\E604\"}.mdi-action-account-child:before{content:\"\\E605\"}.mdi-action-account-circle:before{content:\"\\E606\"}.mdi-action-add-shopping-cart:before{content:\"\\E607\"}.mdi-action-alarm:before{content:\"\\E608\"}.mdi-action-alarm-add:before{content:\"\\E609\"}.mdi-action-alarm-off:before{content:\"\\E60A\"}.mdi-action-alarm-on:before{content:\"\\E60B\"}.mdi-action-android:before{content:\"\\E60C\"}.mdi-action-announcement:before{content:\"\\E60D\"}.mdi-action-aspect-ratio:before{content:\"\\E60E\"}.mdi-action-assessment:before{content:\"\\E60F\"}.mdi-action-assignment:before{content:\"\\E610\"}.mdi-action-assignment-ind:before{content:\"\\E611\"}.mdi-action-assignment-late:before{content:\"\\E612\"}.mdi-action-assignment-return:before{content:\"\\E613\"}.mdi-action-assignment-returned:before{content:\"\\E614\"}.mdi-action-assignment-turned-in:before{content:\"\\E615\"}.mdi-action-autorenew:before{content:\"\\E616\"}.mdi-action-backup:before{content:\"\\E617\"}.mdi-action-book:before{content:\"\\E618\"}.mdi-action-bookmark:before{content:\"\\E619\"}.mdi-action-bookmark-outline:before{content:\"\\E61A\"}.mdi-action-bug-report:before{content:\"\\E61B\"}.mdi-action-cached:before{content:\"\\E61C\"}.mdi-action-class:before{content:\"\\E61D\"}.mdi-action-credit-card:before{content:\"\\E61E\"}.mdi-action-dashboard:before{content:\"\\E61F\"}.mdi-action-delete:before{content:\"\\E620\"}.mdi-action-description:before{content:\"\\E621\"}.mdi-action-dns:before{content:\"\\E622\"}.mdi-action-done:before{content:\"\\E623\"}.mdi-action-done-all:before{content:\"\\E624\"}.mdi-action-event:before{content:\"\\E625\"}.mdi-action-exit-to-app:before{content:\"\\E626\"}.mdi-action-explore:before{content:\"\\E627\"}.mdi-action-extension:before{content:\"\\E628\"}.mdi-action-face-unlock:before{content:\"\\E629\"}.mdi-action-favorite:before{content:\"\\E62A\"}.mdi-action-favorite-outline:before{content:\"\\E62B\"}.mdi-action-find-in-page:before{content:\"\\E62C\"}.mdi-action-find-replace:before{content:\"\\E62D\"}.mdi-action-flip-to-back:before{content:\"\\E62E\"}.mdi-action-flip-to-front:before{content:\"\\E62F\"}.mdi-action-get-app:before{content:\"\\E630\"}.mdi-action-grade:before{content:\"\\E631\"}.mdi-action-group-work:before{content:\"\\E632\"}.mdi-action-help:before{content:\"\\E633\"}.mdi-action-highlight-remove:before{content:\"\\E634\"}.mdi-action-history:before{content:\"\\E635\"}.mdi-action-home:before{content:\"\\E636\"}.mdi-action-https:before{content:\"\\E637\"}.mdi-action-info:before{content:\"\\E638\"}.mdi-action-info-outline:before{content:\"\\E639\"}.mdi-action-input:before{content:\"\\E63A\"}.mdi-action-invert-colors:before{content:\"\\E63B\"}.mdi-action-label:before{content:\"\\E63C\"}.mdi-action-label-outline:before{content:\"\\E63D\"}.mdi-action-language:before{content:\"\\E63E\"}.mdi-action-launch:before{content:\"\\E63F\"}.mdi-action-list:before{content:\"\\E640\"}.mdi-action-lock:before{content:\"\\E641\"}.mdi-action-lock-open:before{content:\"\\E642\"}.mdi-action-lock-outline:before{content:\"\\E643\"}.mdi-action-loyalty:before{content:\"\\E644\"}.mdi-action-markunread-mailbox:before{content:\"\\E645\"}.mdi-action-note-add:before{content:\"\\E646\"}.mdi-action-open-in-browser:before{content:\"\\E647\"}.mdi-action-open-in-new:before{content:\"\\E648\"}.mdi-action-open-with:before{content:\"\\E649\"}.mdi-action-pageview:before{content:\"\\E64A\"}.mdi-action-payment:before{content:\"\\E64B\"}.mdi-action-perm-camera-mic:before{content:\"\\E64C\"}.mdi-action-perm-contact-cal:before{content:\"\\E64D\"}.mdi-action-perm-data-setting:before{content:\"\\E64E\"}.mdi-action-perm-device-info:before{content:\"\\E64F\"}.mdi-action-perm-identity:before{content:\"\\E650\"}.mdi-action-perm-media:before{content:\"\\E651\"}.mdi-action-perm-phone-msg:before{content:\"\\E652\"}.mdi-action-perm-scan-wifi:before{content:\"\\E653\"}.mdi-action-picture-in-picture:before{content:\"\\E654\"}.mdi-action-polymer:before{content:\"\\E655\"}.mdi-action-print:before{content:\"\\E656\"}.mdi-action-query-builder:before{content:\"\\E657\"}.mdi-action-question-answer:before{content:\"\\E658\"}.mdi-action-receipt:before{content:\"\\E659\"}.mdi-action-redeem:before{content:\"\\E65A\"}.mdi-action-report-problem:before{content:\"\\E65B\"}.mdi-action-restore:before{content:\"\\E65C\"}.mdi-action-room:before{content:\"\\E65D\"}.mdi-action-schedule:before{content:\"\\E65E\"}.mdi-action-search:before{content:\"\\E65F\"}.mdi-action-settings:before{content:\"\\E660\"}.mdi-action-settings-applications:before{content:\"\\E661\"}.mdi-action-settings-backup-restore:before{content:\"\\E662\"}.mdi-action-settings-bluetooth:before{content:\"\\E663\"}.mdi-action-settings-cell:before{content:\"\\E664\"}.mdi-action-settings-display:before{content:\"\\E665\"}.mdi-action-settings-ethernet:before{content:\"\\E666\"}.mdi-action-settings-input-antenna:before{content:\"\\E667\"}.mdi-action-settings-input-component:before{content:\"\\E668\"}.mdi-action-settings-input-composite:before{content:\"\\E669\"}.mdi-action-settings-input-hdmi:before{content:\"\\E66A\"}.mdi-action-settings-input-svideo:before{content:\"\\E66B\"}.mdi-action-settings-overscan:before{content:\"\\E66C\"}.mdi-action-settings-phone:before{content:\"\\E66D\"}.mdi-action-settings-power:before{content:\"\\E66E\"}.mdi-action-settings-remote:before{content:\"\\E66F\"}.mdi-action-settings-voice:before{content:\"\\E670\"}.mdi-action-shop:before{content:\"\\E671\"}.mdi-action-shopping-basket:before{content:\"\\E672\"}.mdi-action-shopping-cart:before{content:\"\\E673\"}.mdi-action-shop-two:before{content:\"\\E674\"}.mdi-action-speaker-notes:before{content:\"\\E675\"}.mdi-action-spellcheck:before{content:\"\\E676\"}.mdi-action-star-rate:before{content:\"\\E677\"}.mdi-action-stars:before{content:\"\\E678\"}.mdi-action-store:before{content:\"\\E679\"}.mdi-action-subject:before{content:\"\\E67A\"}.mdi-action-swap-horiz:before{content:\"\\E67B\"}.mdi-action-swap-vert:before{content:\"\\E67C\"}.mdi-action-swap-vert-circle:before{content:\"\\E67D\"}.mdi-action-system-update-tv:before{content:\"\\E67E\"}.mdi-action-tab:before{content:\"\\E67F\"}.mdi-action-tab-unselected:before{content:\"\\E680\"}.mdi-action-theaters:before{content:\"\\E681\"}.mdi-action-thumb-down:before{content:\"\\E682\"}.mdi-action-thumbs-up-down:before{content:\"\\E683\"}.mdi-action-thumb-up:before{content:\"\\E684\"}.mdi-action-toc:before{content:\"\\E685\"}.mdi-action-today:before{content:\"\\E686\"}.mdi-action-track-changes:before{content:\"\\E687\"}.mdi-action-translate:before{content:\"\\E688\"}.mdi-action-trending-down:before{content:\"\\E689\"}.mdi-action-trending-neutral:before{content:\"\\E68A\"}.mdi-action-trending-up:before{content:\"\\E68B\"}.mdi-action-turned-in:before{content:\"\\E68C\"}.mdi-action-turned-in-not:before{content:\"\\E68D\"}.mdi-action-verified-user:before{content:\"\\E68E\"}.mdi-action-view-agenda:before{content:\"\\E68F\"}.mdi-action-view-array:before{content:\"\\E690\"}.mdi-action-view-carousel:before{content:\"\\E691\"}.mdi-action-view-column:before{content:\"\\E692\"}.mdi-action-view-day:before{content:\"\\E693\"}.mdi-action-view-headline:before{content:\"\\E694\"}.mdi-action-view-list:before{content:\"\\E695\"}.mdi-action-view-module:before{content:\"\\E696\"}.mdi-action-view-quilt:before{content:\"\\E697\"}.mdi-action-view-stream:before{content:\"\\E698\"}.mdi-action-view-week:before{content:\"\\E699\"}.mdi-action-visibility:before{content:\"\\E69A\"}.mdi-action-visibility-off:before{content:\"\\E69B\"}.mdi-action-wallet-giftcard:before{content:\"\\E69C\"}.mdi-action-wallet-membership:before{content:\"\\E69D\"}.mdi-action-wallet-travel:before{content:\"\\E69E\"}.mdi-action-work:before{content:\"\\E69F\"}.mdi-alert-error:before{content:\"\\E6A0\"}.mdi-alert-warning:before{content:\"\\E6A1\"}.mdi-av-album:before{content:\"\\E6A2\"}.mdi-av-timer:before{content:\"\\E6A3\"}.mdi-av-closed-caption:before{content:\"\\E6A4\"}.mdi-av-equalizer:before{content:\"\\E6A5\"}.mdi-av-explicit:before{content:\"\\E6A6\"}.mdi-av-fast-forward:before{content:\"\\E6A7\"}.mdi-av-fast-rewind:before{content:\"\\E6A8\"}.mdi-av-games:before{content:\"\\E6A9\"}.mdi-av-hearing:before{content:\"\\E6AA\"}.mdi-av-high-quality:before{content:\"\\E6AB\"}.mdi-av-loop:before{content:\"\\E6AC\"}.mdi-av-mic:before{content:\"\\E6AD\"}.mdi-av-mic-none:before{content:\"\\E6AE\"}.mdi-av-mic-off:before{content:\"\\E6AF\"}.mdi-av-movie:before{content:\"\\E6B0\"}.mdi-av-my-library-add:before{content:\"\\E6B1\"}.mdi-av-my-library-books:before{content:\"\\E6B2\"}.mdi-av-my-library-music:before{content:\"\\E6B3\"}.mdi-av-new-releases:before{content:\"\\E6B4\"}.mdi-av-not-interested:before{content:\"\\E6B5\"}.mdi-av-pause:before{content:\"\\E6B6\"}.mdi-av-pause-circle-fill:before{content:\"\\E6B7\"}.mdi-av-pause-circle-outline:before{content:\"\\E6B8\"}.mdi-av-play-arrow:before{content:\"\\E6B9\"}.mdi-av-play-circle-fill:before{content:\"\\E6BA\"}.mdi-av-play-circle-outline:before{content:\"\\E6BB\"}.mdi-av-playlist-add:before{content:\"\\E6BC\"}.mdi-av-play-shopping-bag:before{content:\"\\E6BD\"}.mdi-av-queue:before{content:\"\\E6BE\"}.mdi-av-queue-music:before{content:\"\\E6BF\"}.mdi-av-radio:before{content:\"\\E6C0\"}.mdi-av-recent-actors:before{content:\"\\E6C1\"}.mdi-av-repeat:before{content:\"\\E6C2\"}.mdi-av-repeat-one:before{content:\"\\E6C3\"}.mdi-av-replay:before{content:\"\\E6C4\"}.mdi-av-shuffle:before{content:\"\\E6C5\"}.mdi-av-skip-next:before{content:\"\\E6C6\"}.mdi-av-skip-previous:before{content:\"\\E6C7\"}.mdi-av-snooze:before{content:\"\\E6C8\"}.mdi-av-stop:before{content:\"\\E6C9\"}.mdi-av-subtitles:before{content:\"\\E6CA\"}.mdi-av-surround-sound:before{content:\"\\E6CB\"}.mdi-av-videocam:before{content:\"\\E6CC\"}.mdi-av-videocam-off:before{content:\"\\E6CD\"}.mdi-av-video-collection:before{content:\"\\E6CE\"}.mdi-av-volume-down:before{content:\"\\E6CF\"}.mdi-av-volume-mute:before{content:\"\\E6D0\"}.mdi-av-volume-off:before{content:\"\\E6D1\"}.mdi-av-volume-up:before{content:\"\\E6D2\"}.mdi-av-web:before{content:\"\\E6D3\"}.mdi-communication-business:before{content:\"\\E6D4\"}.mdi-communication-call:before{content:\"\\E6D5\"}.mdi-communication-call-end:before{content:\"\\E6D6\"}.mdi-communication-call-made:before{content:\"\\E6D7\"}.mdi-communication-call-merge:before{content:\"\\E6D8\"}.mdi-communication-call-missed:before{content:\"\\E6D9\"}.mdi-communication-call-received:before{content:\"\\E6DA\"}.mdi-communication-call-split:before{content:\"\\E6DB\"}.mdi-communication-chat:before{content:\"\\E6DC\"}.mdi-communication-clear-all:before{content:\"\\E6DD\"}.mdi-communication-comment:before{content:\"\\E6DE\"}.mdi-communication-contacts:before{content:\"\\E6DF\"}.mdi-communication-dialer-sip:before{content:\"\\E6E0\"}.mdi-communication-dialpad:before{content:\"\\E6E1\"}.mdi-communication-dnd-on:before{content:\"\\E6E2\"}.mdi-communication-email:before{content:\"\\E6E3\"}.mdi-communication-forum:before{content:\"\\E6E4\"}.mdi-communication-import-export:before{content:\"\\E6E5\"}.mdi-communication-invert-colors-off:before{content:\"\\E6E6\"}.mdi-communication-invert-colors-on:before{content:\"\\E6E7\"}.mdi-communication-live-help:before{content:\"\\E6E8\"}.mdi-communication-location-off:before{content:\"\\E6E9\"}.mdi-communication-location-on:before{content:\"\\E6EA\"}.mdi-communication-message:before{content:\"\\E6EB\"}.mdi-communication-messenger:before{content:\"\\E6EC\"}.mdi-communication-no-sim:before{content:\"\\E6ED\"}.mdi-communication-phone:before{content:\"\\E6EE\"}.mdi-communication-portable-wifi-off:before{content:\"\\E6EF\"}.mdi-communication-quick-contacts-dialer:before{content:\"\\E6F0\"}.mdi-communication-quick-contacts-mail:before{content:\"\\E6F1\"}.mdi-communication-ring-volume:before{content:\"\\E6F2\"}.mdi-communication-stay-current-landscape:before{content:\"\\E6F3\"}.mdi-communication-stay-current-portrait:before{content:\"\\E6F4\"}.mdi-communication-stay-primary-landscape:before{content:\"\\E6F5\"}.mdi-communication-stay-primary-portrait:before{content:\"\\E6F6\"}.mdi-communication-swap-calls:before{content:\"\\E6F7\"}.mdi-communication-textsms:before{content:\"\\E6F8\"}.mdi-communication-voicemail:before{content:\"\\E6F9\"}.mdi-communication-vpn-key:before{content:\"\\E6FA\"}.mdi-content-add:before{content:\"\\E6FB\"}.mdi-content-add-box:before{content:\"\\E6FC\"}.mdi-content-add-circle:before{content:\"\\E6FD\"}.mdi-content-add-circle-outline:before{content:\"\\E6FE\"}.mdi-content-archive:before{content:\"\\E6FF\"}.mdi-content-backspace:before{content:\"\\E700\"}.mdi-content-block:before{content:\"\\E701\"}.mdi-content-clear:before{content:\"\\E702\"}.mdi-content-content-copy:before{content:\"\\E703\"}.mdi-content-content-cut:before{content:\"\\E704\"}.mdi-content-content-paste:before{content:\"\\E705\"}.mdi-content-create:before{content:\"\\E706\"}.mdi-content-drafts:before{content:\"\\E707\"}.mdi-content-filter-list:before{content:\"\\E708\"}.mdi-content-flag:before{content:\"\\E709\"}.mdi-content-forward:before{content:\"\\E70A\"}.mdi-content-gesture:before{content:\"\\E70B\"}.mdi-content-inbox:before{content:\"\\E70C\"}.mdi-content-link:before{content:\"\\E70D\"}.mdi-content-mail:before{content:\"\\E70E\"}.mdi-content-markunread:before{content:\"\\E70F\"}.mdi-content-redo:before{content:\"\\E710\"}.mdi-content-remove:before{content:\"\\E711\"}.mdi-content-remove-circle:before{content:\"\\E712\"}.mdi-content-remove-circle-outline:before{content:\"\\E713\"}.mdi-content-reply:before{content:\"\\E714\"}.mdi-content-reply-all:before{content:\"\\E715\"}.mdi-content-report:before{content:\"\\E716\"}.mdi-content-save:before{content:\"\\E717\"}.mdi-content-select-all:before{content:\"\\E718\"}.mdi-content-send:before{content:\"\\E719\"}.mdi-content-sort:before{content:\"\\E71A\"}.mdi-content-text-format:before{content:\"\\E71B\"}.mdi-content-undo:before{content:\"\\E71C\"}.mdi-device-access-alarm:before{content:\"\\E71D\"}.mdi-device-access-alarms:before{content:\"\\E71E\"}.mdi-device-access-time:before{content:\"\\E71F\"}.mdi-device-add-alarm:before{content:\"\\E720\"}.mdi-device-airplanemode-off:before{content:\"\\E721\"}.mdi-device-airplanemode-on:before{content:\"\\E722\"}.mdi-device-battery-20:before{content:\"\\E723\"}.mdi-device-battery-30:before{content:\"\\E724\"}.mdi-device-battery-50:before{content:\"\\E725\"}.mdi-device-battery-60:before{content:\"\\E726\"}.mdi-device-battery-80:before{content:\"\\E727\"}.mdi-device-battery-90:before{content:\"\\E728\"}.mdi-device-battery-alert:before{content:\"\\E729\"}.mdi-device-battery-charging-20:before{content:\"\\E72A\"}.mdi-device-battery-charging-30:before{content:\"\\E72B\"}.mdi-device-battery-charging-50:before{content:\"\\E72C\"}.mdi-device-battery-charging-60:before{content:\"\\E72D\"}.mdi-device-battery-charging-80:before{content:\"\\E72E\"}.mdi-device-battery-charging-90:before{content:\"\\E72F\"}.mdi-device-battery-charging-full:before{content:\"\\E730\"}.mdi-device-battery-full:before{content:\"\\E731\"}.mdi-device-battery-std:before{content:\"\\E732\"}.mdi-device-battery-unknown:before{content:\"\\E733\"}.mdi-device-bluetooth:before{content:\"\\E734\"}.mdi-device-bluetooth-connected:before{content:\"\\E735\"}.mdi-device-bluetooth-disabled:before{content:\"\\E736\"}.mdi-device-bluetooth-searching:before{content:\"\\E737\"}.mdi-device-brightness-auto:before{content:\"\\E738\"}.mdi-device-brightness-high:before{content:\"\\E739\"}.mdi-device-brightness-low:before{content:\"\\E73A\"}.mdi-device-brightness-medium:before{content:\"\\E73B\"}.mdi-device-data-usage:before{content:\"\\E73C\"}.mdi-device-developer-mode:before{content:\"\\E73D\"}.mdi-device-devices:before{content:\"\\E73E\"}.mdi-device-dvr:before{content:\"\\E73F\"}.mdi-device-gps-fixed:before{content:\"\\E740\"}.mdi-device-gps-not-fixed:before{content:\"\\E741\"}.mdi-device-gps-off:before{content:\"\\E742\"}.mdi-device-location-disabled:before{content:\"\\E743\"}.mdi-device-location-searching:before{content:\"\\E744\"}.mdi-device-multitrack-audio:before{content:\"\\E745\"}.mdi-device-network-cell:before{content:\"\\E746\"}.mdi-device-network-wifi:before{content:\"\\E747\"}.mdi-device-nfc:before{content:\"\\E748\"}.mdi-device-now-wallpaper:before{content:\"\\E749\"}.mdi-device-now-widgets:before{content:\"\\E74A\"}.mdi-device-screen-lock-landscape:before{content:\"\\E74B\"}.mdi-device-screen-lock-portrait:before{content:\"\\E74C\"}.mdi-device-screen-lock-rotation:before{content:\"\\E74D\"}.mdi-device-screen-rotation:before{content:\"\\E74E\"}.mdi-device-sd-storage:before{content:\"\\E74F\"}.mdi-device-settings-system-daydream:before{content:\"\\E750\"}.mdi-device-signal-cellular-0-bar:before{content:\"\\E751\"}.mdi-device-signal-cellular-1-bar:before{content:\"\\E752\"}.mdi-device-signal-cellular-2-bar:before{content:\"\\E753\"}.mdi-device-signal-cellular-3-bar:before{content:\"\\E754\"}.mdi-device-signal-cellular-4-bar:before{content:\"\\E755\"}.mdi-device-signal-cellular-connected-no-internet-0-bar:before{content:\"\\E756\"}.mdi-device-signal-cellular-connected-no-internet-1-bar:before{content:\"\\E757\"}.mdi-device-signal-cellular-connected-no-internet-2-bar:before{content:\"\\E758\"}.mdi-device-signal-cellular-connected-no-internet-3-bar:before{content:\"\\E759\"}.mdi-device-signal-cellular-connected-no-internet-4-bar:before{content:\"\\E75A\"}.mdi-device-signal-cellular-no-sim:before{content:\"\\E75B\"}.mdi-device-signal-cellular-null:before{content:\"\\E75C\"}.mdi-device-signal-cellular-off:before{content:\"\\E75D\"}.mdi-device-signal-wifi-0-bar:before{content:\"\\E75E\"}.mdi-device-signal-wifi-1-bar:before{content:\"\\E75F\"}.mdi-device-signal-wifi-2-bar:before{content:\"\\E760\"}.mdi-device-signal-wifi-3-bar:before{content:\"\\E761\"}.mdi-device-signal-wifi-4-bar:before{content:\"\\E762\"}.mdi-device-signal-wifi-off:before{content:\"\\E763\"}.mdi-device-storage:before{content:\"\\E764\"}.mdi-device-usb:before{content:\"\\E765\"}.mdi-device-wifi-lock:before{content:\"\\E766\"}.mdi-device-wifi-tethering:before{content:\"\\E767\"}.mdi-editor-attach-file:before{content:\"\\E768\"}.mdi-editor-attach-money:before{content:\"\\E769\"}.mdi-editor-border-all:before{content:\"\\E76A\"}.mdi-editor-border-bottom:before{content:\"\\E76B\"}.mdi-editor-border-clear:before{content:\"\\E76C\"}.mdi-editor-border-color:before{content:\"\\E76D\"}.mdi-editor-border-horizontal:before{content:\"\\E76E\"}.mdi-editor-border-inner:before{content:\"\\E76F\"}.mdi-editor-border-left:before{content:\"\\E770\"}.mdi-editor-border-outer:before{content:\"\\E771\"}.mdi-editor-border-right:before{content:\"\\E772\"}.mdi-editor-border-style:before{content:\"\\E773\"}.mdi-editor-border-top:before{content:\"\\E774\"}.mdi-editor-border-vertical:before{content:\"\\E775\"}.mdi-editor-format-align-center:before{content:\"\\E776\"}.mdi-editor-format-align-justify:before{content:\"\\E777\"}.mdi-editor-format-align-left:before{content:\"\\E778\"}.mdi-editor-format-align-right:before{content:\"\\E779\"}.mdi-editor-format-bold:before{content:\"\\E77A\"}.mdi-editor-format-clear:before{content:\"\\E77B\"}.mdi-editor-format-color-fill:before{content:\"\\E77C\"}.mdi-editor-format-color-reset:before{content:\"\\E77D\"}.mdi-editor-format-color-text:before{content:\"\\E77E\"}.mdi-editor-format-indent-decrease:before{content:\"\\E77F\"}.mdi-editor-format-indent-increase:before{content:\"\\E780\"}.mdi-editor-format-italic:before{content:\"\\E781\"}.mdi-editor-format-line-spacing:before{content:\"\\E782\"}.mdi-editor-format-list-bulleted:before{content:\"\\E783\"}.mdi-editor-format-list-numbered:before{content:\"\\E784\"}.mdi-editor-format-paint:before{content:\"\\E785\"}.mdi-editor-format-quote:before{content:\"\\E786\"}.mdi-editor-format-size:before{content:\"\\E787\"}.mdi-editor-format-strikethrough:before{content:\"\\E788\"}.mdi-editor-format-textdirection-l-to-r:before{content:\"\\E789\"}.mdi-editor-format-textdirection-r-to-l:before{content:\"\\E78A\"}.mdi-editor-format-underline:before{content:\"\\E78B\"}.mdi-editor-functions:before{content:\"\\E78C\"}.mdi-editor-insert-chart:before{content:\"\\E78D\"}.mdi-editor-insert-comment:before{content:\"\\E78E\"}.mdi-editor-insert-drive-file:before{content:\"\\E78F\"}.mdi-editor-insert-emoticon:before{content:\"\\E790\"}.mdi-editor-insert-invitation:before{content:\"\\E791\"}.mdi-editor-insert-link:before{content:\"\\E792\"}.mdi-editor-insert-photo:before{content:\"\\E793\"}.mdi-editor-merge-type:before{content:\"\\E794\"}.mdi-editor-mode-comment:before{content:\"\\E795\"}.mdi-editor-mode-edit:before{content:\"\\E796\"}.mdi-editor-publish:before{content:\"\\E797\"}.mdi-editor-vertical-align-bottom:before{content:\"\\E798\"}.mdi-editor-vertical-align-center:before{content:\"\\E799\"}.mdi-editor-vertical-align-top:before{content:\"\\E79A\"}.mdi-editor-wrap-text:before{content:\"\\E79B\"}.mdi-file-attachment:before{content:\"\\E79C\"}.mdi-file-cloud:before{content:\"\\E79D\"}.mdi-file-cloud-circle:before{content:\"\\E79E\"}.mdi-file-cloud-done:before{content:\"\\E79F\"}.mdi-file-cloud-download:before{content:\"\\E7A0\"}.mdi-file-cloud-off:before{content:\"\\E7A1\"}.mdi-file-cloud-queue:before{content:\"\\E7A2\"}.mdi-file-cloud-upload:before{content:\"\\E7A3\"}.mdi-file-file-download:before{content:\"\\E7A4\"}.mdi-file-file-upload:before{content:\"\\E7A5\"}.mdi-file-folder:before{content:\"\\E7A6\"}.mdi-file-folder-open:before{content:\"\\E7A7\"}.mdi-file-folder-shared:before{content:\"\\E7A8\"}.mdi-hardware-cast:before{content:\"\\E7A9\"}.mdi-hardware-cast-connected:before{content:\"\\E7AA\"}.mdi-hardware-computer:before{content:\"\\E7AB\"}.mdi-hardware-desktop-mac:before{content:\"\\E7AC\"}.mdi-hardware-desktop-windows:before{content:\"\\E7AD\"}.mdi-hardware-dock:before{content:\"\\E7AE\"}.mdi-hardware-gamepad:before{content:\"\\E7AF\"}.mdi-hardware-headset:before{content:\"\\E7B0\"}.mdi-hardware-headset-mic:before{content:\"\\E7B1\"}.mdi-hardware-keyboard:before{content:\"\\E7B2\"}.mdi-hardware-keyboard-alt:before{content:\"\\E7B3\"}.mdi-hardware-keyboard-arrow-down:before{content:\"\\E7B4\"}.mdi-hardware-keyboard-arrow-left:before{content:\"\\E7B5\"}.mdi-hardware-keyboard-arrow-right:before{content:\"\\E7B6\"}.mdi-hardware-keyboard-arrow-up:before{content:\"\\E7B7\"}.mdi-hardware-keyboard-backspace:before{content:\"\\E7B8\"}.mdi-hardware-keyboard-capslock:before{content:\"\\E7B9\"}.mdi-hardware-keyboard-control:before{content:\"\\E7BA\"}.mdi-hardware-keyboard-hide:before{content:\"\\E7BB\"}.mdi-hardware-keyboard-return:before{content:\"\\E7BC\"}.mdi-hardware-keyboard-tab:before{content:\"\\E7BD\"}.mdi-hardware-keyboard-voice:before{content:\"\\E7BE\"}.mdi-hardware-laptop:before{content:\"\\E7BF\"}.mdi-hardware-laptop-chromebook:before{content:\"\\E7C0\"}.mdi-hardware-laptop-mac:before{content:\"\\E7C1\"}.mdi-hardware-laptop-windows:before{content:\"\\E7C2\"}.mdi-hardware-memory:before{content:\"\\E7C3\"}.mdi-hardware-mouse:before{content:\"\\E7C4\"}.mdi-hardware-phone-android:before{content:\"\\E7C5\"}.mdi-hardware-phone-iphone:before{content:\"\\E7C6\"}.mdi-hardware-phonelink:before{content:\"\\E7C7\"}.mdi-hardware-phonelink-off:before{content:\"\\E7C8\"}.mdi-hardware-security:before{content:\"\\E7C9\"}.mdi-hardware-sim-card:before{content:\"\\E7CA\"}.mdi-hardware-smartphone:before{content:\"\\E7CB\"}.mdi-hardware-speaker:before{content:\"\\E7CC\"}.mdi-hardware-tablet:before{content:\"\\E7CD\"}.mdi-hardware-tablet-android:before{content:\"\\E7CE\"}.mdi-hardware-tablet-mac:before{content:\"\\E7CF\"}.mdi-hardware-tv:before{content:\"\\E7D0\"}.mdi-hardware-watch:before{content:\"\\E7D1\"}.mdi-image-add-to-photos:before{content:\"\\E7D2\"}.mdi-image-adjust:before{content:\"\\E7D3\"}.mdi-image-assistant-photo:before{content:\"\\E7D4\"}.mdi-image-audiotrack:before{content:\"\\E7D5\"}.mdi-image-blur-circular:before{content:\"\\E7D6\"}.mdi-image-blur-linear:before{content:\"\\E7D7\"}.mdi-image-blur-off:before{content:\"\\E7D8\"}.mdi-image-blur-on:before{content:\"\\E7D9\"}.mdi-image-brightness-1:before{content:\"\\E7DA\"}.mdi-image-brightness-2:before{content:\"\\E7DB\"}.mdi-image-brightness-3:before{content:\"\\E7DC\"}.mdi-image-brightness-4:before{content:\"\\E7DD\"}.mdi-image-brightness-5:before{content:\"\\E7DE\"}.mdi-image-brightness-6:before{content:\"\\E7DF\"}.mdi-image-brightness-7:before{content:\"\\E7E0\"}.mdi-image-brush:before{content:\"\\E7E1\"}.mdi-image-camera:before{content:\"\\E7E2\"}.mdi-image-camera-alt:before{content:\"\\E7E3\"}.mdi-image-camera-front:before{content:\"\\E7E4\"}.mdi-image-camera-rear:before{content:\"\\E7E5\"}.mdi-image-camera-roll:before{content:\"\\E7E6\"}.mdi-image-center-focus-strong:before{content:\"\\E7E7\"}.mdi-image-center-focus-weak:before{content:\"\\E7E8\"}.mdi-image-collections:before{content:\"\\E7E9\"}.mdi-image-colorize:before{content:\"\\E7EA\"}.mdi-image-color-lens:before{content:\"\\E7EB\"}.mdi-image-compare:before{content:\"\\E7EC\"}.mdi-image-control-point:before{content:\"\\E7ED\"}.mdi-image-control-point-duplicate:before{content:\"\\E7EE\"}.mdi-image-crop:before{content:\"\\E7EF\"}.mdi-image-crop-3-2:before{content:\"\\E7F0\"}.mdi-image-crop-5-4:before{content:\"\\E7F1\"}.mdi-image-crop-7-5:before{content:\"\\E7F2\"}.mdi-image-crop-16-9:before{content:\"\\E7F3\"}.mdi-image-crop-din:before{content:\"\\E7F4\"}.mdi-image-crop-free:before{content:\"\\E7F5\"}.mdi-image-crop-landscape:before{content:\"\\E7F6\"}.mdi-image-crop-original:before{content:\"\\E7F7\"}.mdi-image-crop-portrait:before{content:\"\\E7F8\"}.mdi-image-crop-square:before{content:\"\\E7F9\"}.mdi-image-dehaze:before{content:\"\\E7FA\"}.mdi-image-details:before{content:\"\\E7FB\"}.mdi-image-edit:before{content:\"\\E7FC\"}.mdi-image-exposure:before{content:\"\\E7FD\"}.mdi-image-exposure-minus-1:before{content:\"\\E7FE\"}.mdi-image-exposure-minus-2:before{content:\"\\E7FF\"}.mdi-image-exposure-plus-1:before{content:\"\\E800\"}.mdi-image-exposure-plus-2:before{content:\"\\E801\"}.mdi-image-exposure-zero:before{content:\"\\E802\"}.mdi-image-filter:before{content:\"\\E803\"}.mdi-image-filter-1:before{content:\"\\E804\"}.mdi-image-filter-2:before{content:\"\\E805\"}.mdi-image-filter-3:before{content:\"\\E806\"}.mdi-image-filter-4:before{content:\"\\E807\"}.mdi-image-filter-5:before{content:\"\\E808\"}.mdi-image-filter-6:before{content:\"\\E809\"}.mdi-image-filter-7:before{content:\"\\E80A\"}.mdi-image-filter-8:before{content:\"\\E80B\"}.mdi-image-filter-9:before{content:\"\\E80C\"}.mdi-image-filter-9-plus:before{content:\"\\E80D\"}.mdi-image-filter-b-and-w:before{content:\"\\E80E\"}.mdi-image-filter-center-focus:before{content:\"\\E80F\"}.mdi-image-filter-drama:before{content:\"\\E810\"}.mdi-image-filter-frames:before{content:\"\\E811\"}.mdi-image-filter-hdr:before{content:\"\\E812\"}.mdi-image-filter-none:before{content:\"\\E813\"}.mdi-image-filter-tilt-shift:before{content:\"\\E814\"}.mdi-image-filter-vintage:before{content:\"\\E815\"}.mdi-image-flare:before{content:\"\\E816\"}.mdi-image-flash-auto:before{content:\"\\E817\"}.mdi-image-flash-off:before{content:\"\\E818\"}.mdi-image-flash-on:before{content:\"\\E819\"}.mdi-image-flip:before{content:\"\\E81A\"}.mdi-image-gradient:before{content:\"\\E81B\"}.mdi-image-grain:before{content:\"\\E81C\"}.mdi-image-grid-off:before{content:\"\\E81D\"}.mdi-image-grid-on:before{content:\"\\E81E\"}.mdi-image-hdr-off:before{content:\"\\E81F\"}.mdi-image-hdr-on:before{content:\"\\E820\"}.mdi-image-hdr-strong:before{content:\"\\E821\"}.mdi-image-hdr-weak:before{content:\"\\E822\"}.mdi-image-healing:before{content:\"\\E823\"}.mdi-image-image:before{content:\"\\E824\"}.mdi-image-image-aspect-ratio:before{content:\"\\E825\"}.mdi-image-iso:before{content:\"\\E826\"}.mdi-image-landscape:before{content:\"\\E827\"}.mdi-image-leak-add:before{content:\"\\E828\"}.mdi-image-leak-remove:before{content:\"\\E829\"}.mdi-image-lens:before{content:\"\\E82A\"}.mdi-image-looks:before{content:\"\\E82B\"}.mdi-image-looks-3:before{content:\"\\E82C\"}.mdi-image-looks-4:before{content:\"\\E82D\"}.mdi-image-looks-5:before{content:\"\\E82E\"}.mdi-image-looks-6:before{content:\"\\E82F\"}.mdi-image-looks-one:before{content:\"\\E830\"}.mdi-image-looks-two:before{content:\"\\E831\"}.mdi-image-loupe:before{content:\"\\E832\"}.mdi-image-movie-creation:before{content:\"\\E833\"}.mdi-image-nature:before{content:\"\\E834\"}.mdi-image-nature-people:before{content:\"\\E835\"}.mdi-image-navigate-before:before{content:\"\\E836\"}.mdi-image-navigate-next:before{content:\"\\E837\"}.mdi-image-palette:before{content:\"\\E838\"}.mdi-image-panorama:before{content:\"\\E839\"}.mdi-image-panorama-fisheye:before{content:\"\\E83A\"}.mdi-image-panorama-horizontal:before{content:\"\\E83B\"}.mdi-image-panorama-vertical:before{content:\"\\E83C\"}.mdi-image-panorama-wide-angle:before{content:\"\\E83D\"}.mdi-image-photo:before{content:\"\\E83E\"}.mdi-image-photo-album:before{content:\"\\E83F\"}.mdi-image-photo-camera:before{content:\"\\E840\"}.mdi-image-photo-library:before{content:\"\\E841\"}.mdi-image-portrait:before{content:\"\\E842\"}.mdi-image-remove-red-eye:before{content:\"\\E843\"}.mdi-image-rotate-left:before{content:\"\\E844\"}.mdi-image-rotate-right:before{content:\"\\E845\"}.mdi-image-slideshow:before{content:\"\\E846\"}.mdi-image-straighten:before{content:\"\\E847\"}.mdi-image-style:before{content:\"\\E848\"}.mdi-image-switch-camera:before{content:\"\\E849\"}.mdi-image-switch-video:before{content:\"\\E84A\"}.mdi-image-tag-faces:before{content:\"\\E84B\"}.mdi-image-texture:before{content:\"\\E84C\"}.mdi-image-timelapse:before{content:\"\\E84D\"}.mdi-image-timer:before{content:\"\\E84E\"}.mdi-image-timer-3:before{content:\"\\E84F\"}.mdi-image-timer-10:before{content:\"\\E850\"}.mdi-image-timer-auto:before{content:\"\\E851\"}.mdi-image-timer-off:before{content:\"\\E852\"}.mdi-image-tonality:before{content:\"\\E853\"}.mdi-image-transform:before{content:\"\\E854\"}.mdi-image-tune:before{content:\"\\E855\"}.mdi-image-wb-auto:before{content:\"\\E856\"}.mdi-image-wb-cloudy:before{content:\"\\E857\"}.mdi-image-wb-incandescent:before{content:\"\\E858\"}.mdi-image-wb-irradescent:before{content:\"\\E859\"}.mdi-image-wb-sunny:before{content:\"\\E85A\"}.mdi-maps-beenhere:before{content:\"\\E85B\"}.mdi-maps-directions:before{content:\"\\E85C\"}.mdi-maps-directions-bike:before{content:\"\\E85D\"}.mdi-maps-directions-bus:before{content:\"\\E85E\"}.mdi-maps-directions-car:before{content:\"\\E85F\"}.mdi-maps-directions-ferry:before{content:\"\\E860\"}.mdi-maps-directions-subway:before{content:\"\\E861\"}.mdi-maps-directions-train:before{content:\"\\E862\"}.mdi-maps-directions-transit:before{content:\"\\E863\"}.mdi-maps-directions-walk:before{content:\"\\E864\"}.mdi-maps-flight:before{content:\"\\E865\"}.mdi-maps-hotel:before{content:\"\\E866\"}.mdi-maps-layers:before{content:\"\\E867\"}.mdi-maps-layers-clear:before{content:\"\\E868\"}.mdi-maps-local-airport:before{content:\"\\E869\"}.mdi-maps-local-atm:before{content:\"\\E86A\"}.mdi-maps-local-attraction:before{content:\"\\E86B\"}.mdi-maps-local-bar:before{content:\"\\E86C\"}.mdi-maps-local-cafe:before{content:\"\\E86D\"}.mdi-maps-local-car-wash:before{content:\"\\E86E\"}.mdi-maps-local-convenience-store:before{content:\"\\E86F\"}.mdi-maps-local-drink:before{content:\"\\E870\"}.mdi-maps-local-florist:before{content:\"\\E871\"}.mdi-maps-local-gas-station:before{content:\"\\E872\"}.mdi-maps-local-grocery-store:before{content:\"\\E873\"}.mdi-maps-local-hospital:before{content:\"\\E874\"}.mdi-maps-local-hotel:before{content:\"\\E875\"}.mdi-maps-local-laundry-service:before{content:\"\\E876\"}.mdi-maps-local-library:before{content:\"\\E877\"}.mdi-maps-local-mall:before{content:\"\\E878\"}.mdi-maps-local-movies:before{content:\"\\E879\"}.mdi-maps-local-offer:before{content:\"\\E87A\"}.mdi-maps-local-parking:before{content:\"\\E87B\"}.mdi-maps-local-pharmacy:before{content:\"\\E87C\"}.mdi-maps-local-phone:before{content:\"\\E87D\"}.mdi-maps-local-pizza:before{content:\"\\E87E\"}.mdi-maps-local-play:before{content:\"\\E87F\"}.mdi-maps-local-post-office:before{content:\"\\E880\"}.mdi-maps-local-print-shop:before{content:\"\\E881\"}.mdi-maps-local-restaurant:before{content:\"\\E882\"}.mdi-maps-local-see:before{content:\"\\E883\"}.mdi-maps-local-shipping:before{content:\"\\E884\"}.mdi-maps-local-taxi:before{content:\"\\E885\"}.mdi-maps-location-history:before{content:\"\\E886\"}.mdi-maps-map:before{content:\"\\E887\"}.mdi-maps-my-location:before{content:\"\\E888\"}.mdi-maps-navigation:before{content:\"\\E889\"}.mdi-maps-pin-drop:before{content:\"\\E88A\"}.mdi-maps-place:before{content:\"\\E88B\"}.mdi-maps-rate-review:before{content:\"\\E88C\"}.mdi-maps-restaurant-menu:before{content:\"\\E88D\"}.mdi-maps-satellite:before{content:\"\\E88E\"}.mdi-maps-store-mall-directory:before{content:\"\\E88F\"}.mdi-maps-terrain:before{content:\"\\E890\"}.mdi-maps-traffic:before{content:\"\\E891\"}.mdi-navigation-apps:before{content:\"\\E892\"}.mdi-navigation-arrow-back:before{content:\"\\E893\"}.mdi-navigation-arrow-drop-down:before{content:\"\\E894\"}.mdi-navigation-arrow-drop-down-circle:before{content:\"\\E895\"}.mdi-navigation-arrow-drop-up:before{content:\"\\E896\"}.mdi-navigation-arrow-forward:before{content:\"\\E897\"}.mdi-navigation-cancel:before{content:\"\\E898\"}.mdi-navigation-check:before{content:\"\\E899\"}.mdi-navigation-chevron-left:before{content:\"\\E89A\"}.mdi-navigation-chevron-right:before{content:\"\\E89B\"}.mdi-navigation-close:before{content:\"\\E89C\"}.mdi-navigation-expand-less:before{content:\"\\E89D\"}.mdi-navigation-expand-more:before{content:\"\\E89E\"}.mdi-navigation-fullscreen:before{content:\"\\E89F\"}.mdi-navigation-fullscreen-exit:before{content:\"\\E8A0\"}.mdi-navigation-menu:before{content:\"\\E8A1\"}.mdi-navigation-more-horiz:before{content:\"\\E8A2\"}.mdi-navigation-more-vert:before{content:\"\\E8A3\"}.mdi-navigation-refresh:before{content:\"\\E8A4\"}.mdi-navigation-unfold-less:before{content:\"\\E8A5\"}.mdi-navigation-unfold-more:before{content:\"\\E8A6\"}.mdi-notification-adb:before{content:\"\\E8A7\"}.mdi-notification-bluetooth-audio:before{content:\"\\E8A8\"}.mdi-notification-disc-full:before{content:\"\\E8A9\"}.mdi-notification-dnd-forwardslash:before{content:\"\\E8AA\"}.mdi-notification-do-not-disturb:before{content:\"\\E8AB\"}.mdi-notification-drive-eta:before{content:\"\\E8AC\"}.mdi-notification-event-available:before{content:\"\\E8AD\"}.mdi-notification-event-busy:before{content:\"\\E8AE\"}.mdi-notification-event-note:before{content:\"\\E8AF\"}.mdi-notification-folder-special:before{content:\"\\E8B0\"}.mdi-notification-mms:before{content:\"\\E8B1\"}.mdi-notification-more:before{content:\"\\E8B2\"}.mdi-notification-network-locked:before{content:\"\\E8B3\"}.mdi-notification-phone-bluetooth-speaker:before{content:\"\\E8B4\"}.mdi-notification-phone-forwarded:before{content:\"\\E8B5\"}.mdi-notification-phone-in-talk:before{content:\"\\E8B6\"}.mdi-notification-phone-locked:before{content:\"\\E8B7\"}.mdi-notification-phone-missed:before{content:\"\\E8B8\"}.mdi-notification-phone-paused:before{content:\"\\E8B9\"}.mdi-notification-play-download:before{content:\"\\E8BA\"}.mdi-notification-play-install:before{content:\"\\E8BB\"}.mdi-notification-sd-card:before{content:\"\\E8BC\"}.mdi-notification-sim-card-alert:before{content:\"\\E8BD\"}.mdi-notification-sms:before{content:\"\\E8BE\"}.mdi-notification-sms-failed:before{content:\"\\E8BF\"}.mdi-notification-sync:before{content:\"\\E8C0\"}.mdi-notification-sync-disabled:before{content:\"\\E8C1\"}.mdi-notification-sync-problem:before{content:\"\\E8C2\"}.mdi-notification-system-update:before{content:\"\\E8C3\"}.mdi-notification-tap-and-play:before{content:\"\\E8C4\"}.mdi-notification-time-to-leave:before{content:\"\\E8C5\"}.mdi-notification-vibration:before{content:\"\\E8C6\"}.mdi-notification-voice-chat:before{content:\"\\E8C7\"}.mdi-notification-vpn-lock:before{content:\"\\E8C8\"}.mdi-social-cake:before{content:\"\\E8C9\"}.mdi-social-domain:before{content:\"\\E8CA\"}.mdi-social-group:before{content:\"\\E8CB\"}.mdi-social-group-add:before{content:\"\\E8CC\"}.mdi-social-location-city:before{content:\"\\E8CD\"}.mdi-social-mood:before{content:\"\\E8CE\"}.mdi-social-notifications:before{content:\"\\E8CF\"}.mdi-social-notifications-none:before{content:\"\\E8D0\"}.mdi-social-notifications-off:before{content:\"\\E8D1\"}.mdi-social-notifications-on:before{content:\"\\E8D2\"}.mdi-social-notifications-paused:before{content:\"\\E8D3\"}.mdi-social-pages:before{content:\"\\E8D4\"}.mdi-social-party-mode:before{content:\"\\E8D5\"}.mdi-social-people:before{content:\"\\E8D6\"}.mdi-social-people-outline:before{content:\"\\E8D7\"}.mdi-social-person:before{content:\"\\E8D8\"}.mdi-social-person-add:before{content:\"\\E8D9\"}.mdi-social-person-outline:before{content:\"\\E8DA\"}.mdi-social-plus-one:before{content:\"\\E8DB\"}.mdi-social-poll:before{content:\"\\E8DC\"}.mdi-social-public:before{content:\"\\E8DD\"}.mdi-social-school:before{content:\"\\E8DE\"}.mdi-social-share:before{content:\"\\E8DF\"}.mdi-social-whatshot:before{content:\"\\E8E0\"}.mdi-toggle-check-box:before{content:\"\\E8E1\"}.mdi-toggle-check-box-outline-blank:before{content:\"\\E8E2\"}.mdi-toggle-radio-button-off:before{content:\"\\E8E3\"}.mdi-toggle-radio-button-on:before{content:\"\\E8E4\"}.container_main{visibility:hidden;z-index:10;position:absolute;bottom:0;right:0;overflow-x:hidden;overflow-y:hidden}.container_firts{float:right}.container_contacts{height:397px;float:right;bottom:0;width:230px;position:relative}.container_chats{height:397px;float:left;width:250px;position:relative}.contatcs_child{visibility:visible;position:absolute;bottom:0;right:10px}.name_chatOpened{display:flex;justify-content:space-between}.alert_icon{color:#ccc}.item-count{display:flex;justify-content:center;font-size:20px;color:#fff}.chat_opened{visibility:visible;height:397px;float:left;position:fixed}.list-messageBoxes{list-style-type:none;padding:0}.list-messageBoxes li{font-size:12px;font-family:sans-serif;padding:2px;cursor:pointer;display:flex;justify-content:space-between}.list-messageBoxes li a{padding:0 0 0 9px}.list-messageBoxes li a:hover{font-weight:600}.view-messageBoxes{padding:10px 10px 1px;background:#bdbdbd;background:#faf7f7}.anch-div{width:160px;padding-left:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.time_class{text-align:center;margin-bottom:10px}.t-c,.t-c-con{height:30px;background:#fff;padding-top:5px}.t-c-con{font-size:90%;width:190px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-c-a{padding:4px 8px 0 0}.timeStamp{background:#fff;padding:2px;font-size:10px;font-family:cursive;border-radius:7px;border:1px solid;border-color:#dedede}.delet_pos{margin-left:90%;color:transparent}.t-c-c{width:160px;padding-left:10px;height:30px;background:#fff;padding-top:5px}.t-c-c,.t-c-c-d{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-c-c-d{font-size:90%;cursor:none;width:170px}.f-c{height:30px;background:#6d7c7b;border-radius:1px;padding-top:5px}.msj_new{width:23px}.f-m-n{width:22px;text-align:center}.pos_div{padding:4px 0 0 3px}.f-c-h{height:30px;background:#6d7c7b;border-radius:1px;padding-top:5px;width:40px;float:right}.c-d-c{width:210px}.c-d-c,.c-d-c-c{display:flex;background:#fff}.c-d-f{display:flex}.c-l-c{height:240px;width:100%;background:#faf7f7;overflow-x:hidden;overflow-y:scroll}.c-l-c::-webkit-scrollbar{width:10px}.c-l-c::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.1)}.c-t{height:300px;width:100%;background:#faf7f7}.inf-lab{color:#f8f8f8;font-size:90%}.shadow-body{margin-top:1px;border-radius:2px;margin-right:0!important;margin-left:0!important;box-shadow:0 0 1px 1px #9e9e9e}.icon-load{margin-left:auto;margin-right:45px;margin-bottom:-5px;font-size:10px;color:#999}.truncate{width:170px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.chatbox{width:500px;min-width:390px;height:420px;background:#fff;padding:25px;margin:20px auto}.chatlogs{padding:10px;width:100%;height:300px;overflow-x:hidden;overflow-y:scroll}.chatlogs::-webkit-scrollbar{width:10px}.chatlogs::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.1)}.chat-message i:hover{cursor:pointer;color:#fff}.chat{display:flex;flex-flow:row wrap;align-items:flex-start}.chat .user-photo{width:35px;height:35px;background:#ccc;border-radius:50%;overflow:hidden}.chat .user-photo img{width:100%;height:100%}.chat .chat-message{width:73%;padding:7px;margin:0 5px;border-radius:3px;color:#fff;overflow-wrap:break-word;font-size:12px;line-height:13px}.chat .chat-time{width:73%;margin:0 5px 0 40px;font-size:10px}.friend .chat-message{background:#a9a9a9}.self .chat-message{background:#727272;order:-1}.chat-form{display:flex;align-items:inline-flex}.back-textarea{background:#faf7f7;height:36px}.chat-form-textarea textarea{background:#fbfbfb;width:110%;margin-left:-10px;height:30px;border:2px solid #eee;border-radius:3px;resize:none;padding:2px;font-size:15px;color:#777}.chat-form-textarea textarea:focus{background:#fff}.chat-form-textarea textarea::-webkit-scrollbar{width:10px}.chat-form-textarea textarea::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.2)}.back-button{background:#faf7f7;padding-left:21px}.chat-form-button button{background:#41ba6c;margin-bottom:7px;font-family:Comic Sans MS;padding:6px 14px;font-size:12px;color:#fff;border:none;border-radius:1px;cursor:pointer;margin-left:-33px;-webkit-transition:background .2 ease;-moz-transition:background .2 ease;-o-transition:background .2 ease}.chat-form-button button:hover{background:#13c8d9}.icon-pos{margin-left:-10px;margin-top:25px}.contact{margin-top:7px;cursor:pointer}.nm{width:115px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.nm p{font-size:11.5px;margin-top:-5px}.itms{font-family:Comic Sans MS}.pos-itms{margin-left:10px}.pos-label{padding:1px 0 0 8px;margin-left:-15px}.text-gris{color:#929090}.delete_message{font-size:13px}.delete_message a{padding:10px}.color-text-alert,.text-no,.text-si{font-family:sans-serif}.delete_message,.snackbar{visibility:visible;background-color:#333;color:#fff;text-align:center;border-radius:2px;padding:5px 0 0;bottom:30px;position:fixed;min-width:205px;margin-bottom:37px;box-shadow:0 0 1px 1px #9e9e9e}@keyframes fadein{0%{bottom:0;opacity:0}to{bottom:30px;opacity:1}}@keyframes fadeout{0%{bottom:30px;opacity:1}to{bottom:0;opacity:0}}", ""]);
	
	// exports


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0017fcab5059a50c72c52fb8f2c07192.png";

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1555);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./app-uplanner.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./app-uplanner.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(364)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700);", ""]);
	
	// module
	exports.push([module.id, ".bg-primary{background:#0070c0!important;color:#fff!important}.bg-primary-light{background:#0e9aff!important;color:#fff!important}.bg-primary-dark{background:#004374!important;color:#fff!important}.bg-accent{background:#ffb000!important;color:#000!important}.bg-accent-light{background:#ffc84d!important;color:#000!important}.bg-accent-dark{background:#b37b00!important;color:#fff!important}.bg-info{background:#324654!important;color:#fff;color:#fff!important}.bg-info-light{background:#4f6e84!important;color:#fff!important}.bg-info-dark{background:#151e24!important;color:#fff!important}.bg-success{background:#a8c329!important;color:#000!important}.bg-success-light{background:#c6dd5c!important;color:#000!important}.bg-success-dark{background:#72841c!important;color:#fff!important}.bg-warning{background:#facb55!important;color:#000!important}.bg-warning-light{background:#fce29f!important;color:#000!important}.bg-warning-dark{background:#f8b40b!important;color:#000!important}.bg-danger{background:#d7634a!important;color:#fff!important}.bg-danger-light{background:#e59989!important;color:#fff!important}.bg-danger-dark{background:#ae3e26!important;color:#fff!important}.bg-light{background:#f7f7f7!important;color:#000!important}.bg-light-light{background:#fff!important;color:#000!important}.bg-light-dark{background:#d1d1d1!important;color:#000!important}.bg-dark{background:#6f6f6e!important;color:#fff!important}.bg-dark-light{background:#959594!important;color:#fff!important}.bg-dark-dark{background:#494948!important;color:#fff!important}.bg-present{background:#4caf50!important;color:#fff!important}.bg-absent{background:#6f6f6e!important;color:#fff!important}.bg-tardy{background:#ffeb3b!important;color:#000!important}.bg-justified{background:#468ac2!important;color:#fff!important}.bg-not-registered{background:#e0e0e0!important;color:#000!important;border:1px solid hsla(0,0%,88%,.1)}.bg-man{background:#afb42b!important}.bg-man,.bg-ret{color:#fff!important}.bg-ret{background:#d7634a!important}.bg-sanc{background:#fab813!important;color:#000!important}.bg-del{background:#3f51b5!important;color:#fff!important}.text-primary{color:#0070c0!important}.text-primary-lt{color:#0e9aff!important}.text-primary-dk{color:#004374!important}.text-accent{color:#ffb000!important}.text-accent-lt{color:#ffc84d!important}.text-accent-dk{color:#b37b00!important}.text-info{color:#324654!important}.text-info-lt{color:#4f6e84!important}.text-info-dk{color:#151e24!important}.text-success{color:#a8c329!important}.text-success-lt{color:#c6dd5c!important}.text-success-dk{color:#72841c!important}.text-warning{color:#facb55!important}.text-warning-lt{color:#fce29f!important}.text-warning-dk{color:#f8b40b!important}.text-danger{color:#d7634a!important}.text-danger-lt{color:#e59989!important}.text-danger-dk{color:#ae3e26!important}.text-dark{color:#6f6f6e!important}.text-dark-lt{color:#959594!important}.text-dark-dk{color:#494948!important}.text-light{color:#f7f7f7!important}.text-light-lt{color:#fff!important}.text-light-dk{color:#d1d1d1!important}[ui-view].ng-leave{display:none}[ui-view].ng-leave.smooth{display:block}.smooth.ng-animate{position:absolute;width:100%;height:100%;overflow:hidden}.fade-in-right-big.ng-enter{animation:fadeInRightBig .5s}.fade-in-right-big.ng-leave{animation:fadeOutLeftBig .5s}.fade-in-left-big.ng-enter{animation:fadeInLeftBig .5s}.fade-in-left-big.ng-leave{animation:fadeOutRightBig .5s}.fade-in-up-big.ng-enter{animation:fadeInUpBig .5s}.fade-in-up-big.ng-leave{animation:fadeOutUpBig .5s}.fade-in-down-big.ng-enter{animation:fadeInDownBig .5s}.fade-in-down-big.ng-leave{animation:fadeOutDownBig .5s}.fade-in.ng-enter{animation:fadeIn .5s}.fade-in.ng-leave{animation:fadeOut .5s}.fade-in-right.ng-enter{animation:fadeInRight .5s}.fade-in-right.ng-leave{animation:fadeOutLeft .5s}.fade-in-left.ng-enter{animation:fadeInLeft .5s}.fade-in-left.ng-leave{animation:fadeOutRight .5s}.fade-in-up.ng-enter{animation:fadeInUp .5s}.fade-in-up.ng-leave{animation:fadeOutUp .5s}.fade-in-down.ng-enter{animation:fadeInDown .5s}.fade-in-down.ng-leave{animation:fadeOutDown .5s}html{background-color:#004374}body{font-family:Roboto,sans-serif;font-size:14px;color:#494948;background-color:#f9f9f9;-webkit-font-smoothing:antialiased;line-height:1.42857143}:focus{outline:0!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Open Sans,sans-serif}.title{font-size:24px!important;color:#353942!important;margin-bottom:10px}.title p{margin:0;font-size:17px;color:#758295;font-weight:300}.title h1,.title h2,.title h3,.title h4,.title h5,.title h6{margin-top:0;font-size:24px!important}.titleSecond{background-color:#f2f5f7}.h1,.h2,.h3,.h4,.h5,.h6{margin:0}a{cursor:pointer;outline:0}a,a:focus,a:hover{color:#ffb000;text-decoration:none}.well,pre{background-color:#f7f7f7;border-color:#eaeaea}.small,small{font-size:13px}blockquote{border-color:#eaeaea}label{font-weight:400}sup{position:relative;top:-.5em;font-size:75%}.thumbnail{border-color:#eaeaea}@media (min-width:768px) and (max-width:991px){.pull-none-sm{float:none!important}.pull-right-sm{float:right!important}.pull-left-sm{float:left!important}.hidden-sm.show{display:inherit!important}}@media (max-width:767px){.pull-none-xs{float:none!important}.pull-right-xs{float:right!important}.pull-left-xs{float:left!important}.hidden-xs.show{display:inherit!important}}.text-color{color:#494948!important}.text-color-w{color:#fff!important}.badge,.label{font-weight:700;background-color:#b7b7b7}.badge.bg-light,.badge.bg-white,.label.bg-light,.label.bg-white{text-shadow:none;color:#494948}.label{padding:.35em .6em}.badge{padding:3px 6px}.badge.up{position:relative;top:-10px;margin:0 -.5em}.badge-lg{border-radius:20px;font-size:16px;padding:5px 9px}.badge-sm{padding:2px 5px}.badge-xs{padding:1px 4px}.label-lg{font-size:16px;padding:5px 9px}.label-sm{padding:2px 5px}.label-xs{padding:1px 4px}.badge-white{border:1px solid hsla(0,0%,100%,.35);padding:2px 6px}.badge-black,.badge-white{background-color:transparent}.badge-black{border:1px solid rgba(0,0,0,.15);color:inherit}.btn-default{background-color:#fff!important;border-color:#fff;color:#000!important}.btn-default.active,.btn-default.btn-stroke.active,.btn-default.btn-stroke:active,.btn-default.btn-stroke:focus,.btn-default.btn-stroke:hover,.btn-default:active,.btn-default:focus,.btn-default:hover,.open .dropdown-toggle.btn-default{color:#000;background-color:#f2f2f2!important;border-color:#d6d6d6!important}.btn-default.btn-addon>i{border:1px solid #dbdbdb;background-color:#f0f0f0}.btn-default.btn-stroke{color:#fff!important;background-color:transparent}.btn-primary{background-color:#0070c0!important;border-color:#0070c0;color:#fff!important}.btn-primary.active,.btn-primary.btn-stroke.active,.btn-primary.btn-stroke:active,.btn-primary.btn-stroke:focus,.btn-primary.btn-stroke:hover,.btn-primary:active,.btn-primary:focus,.btn-primary:hover,.open .dropdown-toggle.btn-primary{color:#fff;background-color:#0061a7!important;border-color:#005897!important}.btn-primary.btn-addon>i{border:1px solid #005ea1;background-color:#005ea1}.btn-primary.btn-stroke{color:#0070c0!important;background-color:transparent}.btn-success{background-color:#a8c329!important;border-color:#a8c329;color:#000!important}.btn-success.active,.btn-success.btn-stroke.active,.btn-success.btn-stroke:active,.btn-success.btn-stroke:focus,.btn-success.btn-stroke:hover,.btn-success:active,.btn-success:focus,.btn-success:hover,.open .dropdown-toggle.btn-success{color:#000;background-color:#96ae25!important;border-color:#8ba122!important}.btn-success.btn-addon>i{border:1px solid #92aa24;background-color:#92aa24}.btn-success.btn-stroke{color:#a8c329!important;background-color:transparent}.btn-info{background-color:#324654!important;border-color:#324654;color:#fff!important}.btn-info.active,.btn-info.btn-stroke.active,.btn-info.btn-stroke:active,.btn-info.btn-stroke:focus,.btn-info.btn-stroke:hover,.btn-info:active,.btn-info:focus,.btn-info:hover,.open .dropdown-toggle.btn-info{color:#fff;background-color:#283944!important;border-color:#23313a!important}.btn-info.btn-addon>i{border:1px solid #273641;background-color:#273641}.btn-info.btn-stroke{color:#324654!important;background-color:transparent}.btn-warning{background-color:#facb55!important;border-color:#facb55;color:#000!important}.btn-warning.active,.btn-warning.btn-stroke.active,.btn-warning.btn-stroke:active,.btn-warning.btn-stroke:focus,.btn-warning.btn-stroke:hover,.btn-warning:active,.btn-warning:focus,.btn-warning:hover,.open .dropdown-toggle.btn-warning{color:#000;background-color:#f9c33c!important;border-color:#f9bf2d!important}.btn-warning.btn-addon>i{border:1px solid #f9c237;background-color:#f9c237}.btn-warning.btn-stroke{color:#facb55!important;background-color:transparent}.btn-danger{background-color:#d7634a!important;border-color:#d7634a;color:#fff!important}.btn-danger.active,.btn-danger.btn-stroke.active,.btn-danger.btn-stroke:active,.btn-danger.btn-stroke:focus,.btn-danger.btn-stroke:hover,.btn-danger:active,.btn-danger:focus,.btn-danger:hover,.open .dropdown-toggle.btn-danger{color:#fff;background-color:#d25135!important;border-color:#cb492d!important}.btn-danger.btn-addon>i{border:1px solid #d14d31;background-color:#d14d31}.btn-danger.btn-stroke{color:#d7634a!important;background-color:transparent}.btn-accent{background-color:#ffb000!important;border-color:#ffb000;color:#000!important}.btn-accent.active,.btn-accent.btn-stroke.active,.btn-accent.btn-stroke:active,.btn-accent.btn-stroke:focus,.btn-accent.btn-stroke:hover,.btn-accent:active,.btn-accent:focus,.btn-accent:hover,.open .dropdown-toggle.btn-accent{color:#000;background-color:#e69e00!important;border-color:#d69400!important}.btn-accent.btn-addon>i{border:1px solid #e09b00;background-color:#e09b00}.btn-accent.btn-stroke{color:#ffb000!important;background-color:transparent}.btn-dark{background-color:#6f6f6e!important;border-color:#6f6f6e;color:#fff!important}.btn-dark.active,.btn-dark.btn-stroke.active,.btn-dark.btn-stroke:active,.btn-dark.btn-stroke:focus,.btn-dark.btn-stroke:hover,.btn-dark:active,.btn-dark:focus,.btn-dark:hover,.open .dropdown-toggle.btn-dark{color:#fff;background-color:#626261!important;border-color:#5b5b5a!important}.btn-dark.btn-addon>i{border:1px solid #60605f;background-color:#60605f}.btn-dark.btn-stroke{color:#6f6f6e!important;background-color:transparent}.btn-light{background-color:#f7f7f7!important;border-color:#f7f7f7;color:#000!important}.btn-light.active,.btn-light.btn-stroke.active,.btn-light.btn-stroke:active,.btn-light.btn-stroke:focus,.btn-light.btn-stroke:hover,.btn-light:active,.btn-light:focus,.btn-light:hover,.open .dropdown-toggle.btn-light{color:#000;background-color:#eaeaea!important;border-color:#e3e3e3!important}.btn-light.btn-addon>i{border:1px solid #e8e8e8;background-color:#e8e8e8}.btn-light.btn-stroke{color:#f7f7f7!important;background-color:transparent}.btn-horizontal-align{margin-top:38px}.btn{font-weight:500;border-radius:3px;outline:0!important;box-shadow:0 1px 1px rgba(90,90,90,.1);font-family:Open Sans,sans-serif;font-weight:400}.btn>i.pull-left,.btn>i.pull-right{line-height:1.42857143}.btn-link{color:#494948}.btn-link.active{webkit-box-shadow:none;box-shadow:none}.btn-block{padding-left:12px;padding-right:12px}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:3px}.btn-group-vertical>.btn:last-child:not(:first-child){border-bottom-left-radius:3px}.btn-rounded{border-radius:50px;padding-left:15px;padding-right:15px}.btn-rounded.btn-lg{padding-left:25px;padding-right:25px}.btn-addon i{margin:-7px -12px;margin-right:12px;width:34px;height:34px;line-height:34px;text-align:center;float:left;position:relative;left:-1px;border-radius:3px 0 0 3px}.btn-addon i.pull-right{left:auto;right:-1px;margin-right:-12px;margin-left:12px;border-radius:0 3px 3px 0}.btn-addon.btn-sm i{margin:-6px -10px;margin-right:10px;width:30px;height:30px;line-height:30px}.btn-addon.btn-sm i.pull-right{margin-right:-10px;margin-left:10px}.btn-addon.btn-lg i{margin:-11px -16px;margin-right:16px;width:46px;height:46px;line-height:45px}.btn-addon.btn-lg i.pull-right{margin-right:-16px;margin-left:16px}.btn-clip{border-color:rgba(0,0,0,.1)!important;background-clip:padding-box}.btn-icon{padding-left:0!important;padding-right:0!important;width:34px;height:34px;padding:0;text-align:center;line-height:34px}.btn-icon.btn-sm{width:30px;height:30px;line-height:30px}.btn-icon.btn-lg{width:45px;height:45px;line-height:45px}.btn-groups .btn{margin-bottom:5px}.btn-fw{min-width:120px}.btn-planner:focus,.btn-planner:hover{color:#fff;text-decoration:none}.btn-evaluation{border-style:solid;border-color:#fff;background-color:hsla(0,0%,100%,.4)}.dropdown-menu{background-color:#f7f7f7;border-radius:3px;box-shadow:0 2px 6px rgba(0,0,0,.15);border:1px solid rgba(0,0,0,.1);transform-origin:top left}.dropdown-menu.pull-left{left:100%}.dropdown-menu.pull-right{left:auto!important;transform-origin:top right}.dropdown-menu.pull-up{top:0}.dropup .dropdown-menu{transform-origin:bottom left}.dropup .dropdown-menu.pull-right{transform-origin:bottom right}.dropdown-menu>.panel{border:none;margin:-5px 0}.dropdown-menu>li>a{color:#000!important;padding:8px 16px;margin:0 5px}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover,.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{background-image:none;filter:none;background-color:#d1d1d1!important;color:#000!important}.dropdown-menu.top,.dropdown-menu.top-left,.dropdown-menu.top-right{margin-top:-2px}.dropdown-menu.datepicker{padding-left:5px;padding-right:5px;font-size:12px}.dropdown-menu.datepicker .btn{font-size:12px}.dropdown-menu.timepicker{padding-top:5px;padding-bottom:5px;font-size:12px}.dropdown-menu.timepicker .btn{font-size:12px}.dropdown-menu-scale{display:block;opacity:0;transform:scale(0);transition:all .25s;-webkit-backface-visibility:hidden;backface-visibility:hidden}.open>.dropdown-menu-scale{opacity:1;transform:scale(1)}.dropdown-header{padding:8px 16px}.dropdown-submenu{position:relative}.dropdown-submenu:focus>a,.dropdown-submenu:hover>a{background-color:inherit!important}.dropdown-submenu:focus>.dropdown-menu,.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu.pull-left{float:none!important}.dropdown-submenu.pull-left>.dropdown-menu{left:-100%;margin-left:10px}.dropdown-submenu .dropdown-menu{left:100%;top:0;margin-top:-6px;margin-left:-1px}.dropup .dropdown-submenu>.dropdown-menu{top:auto;bottom:0}@media (max-width:767px){.dropdown-menu.pull-none-xs{left:0}}.form-control{border-color:#eaeaea;border-radius:3px}.form-control,.form-control:focus{box-shadow:none}.form-control:focus{border-color:#b7b7b7}.form-control::-webkit-input-placeholder{color:inherit;opacity:.3}.form-control::-moz-placeholder{color:inherit;opacity:.3}.form-control:-ms-input-placeholder{color:inherit;opacity:.3}.form-control-spin{position:absolute;z-index:2;right:10px;top:50%;margin-top:-7px}.form-horizontal .form-group-lg .form-control,.input-lg{height:45px;border-radius:3px}.input-group-addon{border-color:#eaeaea;background-color:#f7f7f7}.form-group-stack .form-control{margin-top:-1px;position:relative;border-radius:0}.form-group-stack .form-control:active,.form-group-stack .form-control:focus{z-index:1}.form-validation .form-control.ng-dirty.ng-invalid{border-color:#d7634a}.form-validation .form-control.ng-dirty.ng-valid,.form-validation .form-control.ng-dirty.ng-valid:focus{border-color:#a8c329}.form-validation .ui-checks .ng-invalid.ng-dirty+i{border-color:#d7634a}.form-file{position:relative}.form-file input{position:absolute;width:100%;height:100%;opacity:0}@media (max-width:992px){.form-horizontal .form-group{margin-left:-8px;margin-right:-8px}}.list-group{border-radius:3px;background:#fff}.list-group.no-radius .list-group-item{border-radius:0!important}.list-group.no-borders .list-group-item{border:none}.list-group.no-border .list-group-item{border-width:1px 0}.list-group.no-bg .list-group-item{background-color:transparent}.list-group-item,.list-group.list-group-gap{background:transparent}.list-group-item{border-left-color:transparent;border-right-color:transparent;border-color:hsla(210,4%,45%,.045);padding:12px 16px}a.list-group-item{color:inherit}a.list-group-item.hover,a.list-group-item:focus,a.list-group-item:hover{color:inherit;background-color:hsla(210,4%,45%,.075)}.list-group-item.media{margin-top:0}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{color:inherit;background-color:hsla(210,4%,45%,.075);border-color:transparent;border-bottom-color:1px solid hsla(210,4%,45%,.075)}.list-group-item.active:focus a,.list-group-item.active:hover a,.list-group-item.active a{color:inherit}.list-group-alt .list-group-item.active:nth-child(2n+2),.list-group-alt .list-group-item:nth-child(2n+2){background-color:hsla(210,4%,45%,.075)}.list-group-lg .list-group-item{padding:16px 24px}.list-group-md .list-group-item{padding-top:16px;padding-bottom:16px}.list-group-sm .list-group-item{padding:10px 12px}.list-group-gap .list-group-item{margin-bottom:5px;border-radius:3px;background:#fff}.green-bllt li{list-style-image:url(" + __webpack_require__(1540) + ")}.modal.fade .left{transform:translate3d(-100%,0,0)}.modal.fade .left,.modal.fade .right{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal.fade .right{transform:translate3d(100%,0,0)}.modal.fade .top{transform:translate3d(0,-100%,0)}.modal.fade .bottom,.modal.fade .top{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal.fade .bottom{transform:translate3d(0,100%,0)}.modal.in .bottom,.modal.in .left,.modal.in .right,.modal.in .top{transform:translateZ(0)}.modal.inactive{bottom:auto;overflow:visible}.modal>.left{left:0;right:auto}.modal>.left,.modal>.right{position:fixed;z-index:1055;top:0;bottom:0}.modal>.right{left:auto;right:0}.modal>.top{top:0;bottom:auto}.modal>.bottom,.modal>.top{position:fixed;z-index:1055;left:0;right:0}.modal>.bottom{top:auto;bottom:0}.modal-backdrop{background-color:#6f6f6e}.modal-backdrop.in{opacity:.8;filter:alpha(opacity=80)}.modal-over{left:0;right:0;top:0;bottom:0;position:fixed}.modal-center{position:absolute;left:50%;top:50%}.modal-header{border-bottom:none}.modal-backdrop{background-color:#171717}.bottom-modal-btn.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-left-radius:0;border-bottom-right-radius:0;border-top-right-radius:0}.bottom-modal-btn.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-right-radius:0!important;border-bottom-left-radius:0;border-top-left-radius:0}.bottom-modal-btn .btn,.bottom-modal-btn .btn:focus,.bottom-modal-btn .btn:hover{color:#fff}button.md-btn.overflow-button{position:relative;display:block;margin:auto;top:14px}.input-line{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit;text-align:center}.caja-verde{background-color:rgba(170,206,59,.5)}.nav>li>a:focus,.nav>li>a:hover{background-color:#2d3039;color:#fff}.nav>li.active>a{background-color:#353942;color:#ffb000}#transparentMenu .nav>li>a:focus,#transparentMenu .nav>li>a:hover{background-color:transparent;color:#fff}#transparentMenu .nav>li.active>a{background-color:transparent;color:#ffb000}.rojo-nav-hover:hover{background-color:#ffb000!important}.azul-nav-hover:hover{background-color:#0070c0!important}.nav>li>a{padding:10px 16px}.nav.nav-lg>li>a{padding:20px}.nav.nav-md>li>a{padding:16px}.nav.nav-sm>li>a{font-size:13px;padding:6px 12px}.nav.nav-xs>li>a{font-size:12px;padding:4px 10px}.nav.nav-xxs>li>a{font-size:12px;padding:1px 10px}.nav.nav-rounded>li>a{border-radius:20px}.nav.no-radius>li>a{border-radius:0}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:inherit}.nav-pills>li.active>a,.nav-pills>li.active>a:active,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#494948;background-color:#eaeaea}.nav-pills>li.active>a>.text-muted{color:#494948}.nav-tabs{border-color:#eaeaea}.nav-tabs>li>a{border-radius:3px 3px 0 0;border-bottom-color:#eaeaea;color:#2d3039}.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover .nav-tabs>li.active>a:focus,.nav-tabs>li:hover>a{border-color:#eaeaea;background-color:#fff;color:#2d3039}.nav-tabs>li.active>a{border-bottom-color:#fff!important}.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0;border-radius:3px 3px 0 0}.nav-lines{margin-bottom:-1px;border-width:0!important}.nav-lines.nav-justified{border-bottom:2px solid #324654;margin-bottom:-2px}.nav-lines>li{float:left;border-color:inherit;opacity:.6}.nav-lines>li:after{content:\"\";position:absolute;left:50%;right:50%;bottom:0;border-bottom-width:2px;border-bottom-style:solid;border-bottom-color:transparent;transition:all .3s cubic-bezier(.35,0,.25,1)}.nav-lines>li>a{background-color:transparent!important;border-width:0!important}.nav-lines>li.active{opacity:1;z-index:5}.nav-lines>li.active:after{left:0;right:0;border-bottom-color:inherit}.nav-lines.nav-lines-top>li:after{bottom:auto;top:0}.nav-lists a{border-bottom:1px solid #eaeaea}.tab-container{margin-bottom:15px}.tab-container .tab-content{padding:15px;background-color:#fff;border:1px solid #eaeaea;border-top-width:0;border-radius:0 0 3px 3px}.navbar{border:none;margin:0;position:relative;z-index:50;min-height:64px}.navbar .navbar-brand,.navbar .navbar-item,.navbar .navbar-nav>li>a,.navbar .navbar-tool>li>a{padding:0 16px;line-height:64px}.navbar .navbar-tool.nav-sm>li>a{padding-left:10px;padding-right:10px}.navbar .navbar-tool>li{float:left}.navbar .navbar-brand{font-size:20px;font-weight:700;display:block;float:none}.navbar .navbar-brand:hover{text-decoration:none}.navbar .navbar-brand img,.navbar .navbar-brand svg{display:inline-block;vertical-align:-10%}@media (max-width:991px){.navbar,.navbar .navbar-brand{min-height:50px}.navbar .navbar-brand,.navbar .navbar-item,.navbar .navbar-nav>li>a,.navbar .navbar-tool>li>a{line-height:50px}}.pagination>li>a{border-color:#eaeaea}.pagination>li>a:focus,.pagination>li>a:hover{border-color:#eaeaea;background-color:#f7f7f7}.panel{border-radius:3px;margin-bottom:8px;box-shadow:none}.panel .accordion-toggle{font-size:14px;display:block;cursor:pointer}.panel .list-group-item{border-color:#f7f7f7}.panel-card,.panel.no-borders,.panel.no-borders .panel-footer,.panel.no-borders .panel-heading{border-width:0}.panel-card{box-shadow:0 1px 2px rgba(0,0,0,.15);border-radius:0}.panel-heading{padding:16px 24px;border-radius:3px 3px 0 0}.panel-default .panel-heading{background-color:#007fda;color:#fff}.panel-default .panel-heading.bg-white{background-color:#fff}.panel-heading.no-border{margin:-1px -1px 0;border:none}.panel-heading .nav{margin:-12px -16px}.panel-heading .list-group{background:transparent}.panel-heading.panel-heading-sm{padding-top:8px;padding-bottom:8px}.panel-heading.panel-heading-xs{padding-top:6px;padding-bottom:6px}.panel-body,.panel-footer{padding:16px 24px}.panel-footer{border-color:#f7f7f7;border-radius:0 0 3px 3px;background-color:#27a5ff}.panel-footer.panel-footer-sm{padding-top:8px;padding-bottom:8px}.panel-footer.panel-footer-xs{padding-top:6px;padding-bottom:6px}.panel-group .panel-heading+.panel-collapse .panel-body{border-top:1px solid #f7f7f7}.panel-default{border-color:#eaeaea}.panel-default>.panel-footer,.panel-default>.panel-heading{border-color:#f7f7f7}.panel-primary{border-color:#c4def0}.panel-primary>.panel-heading{color:#00345a;background-color:#d9eaf6;border-color:#c4def0}.panel-info{border-color:#d2d7da}.panel-info>.panel-heading{color:#0c1114;background-color:#e0e3e5;border-color:#d2d7da}.panel-success{border-color:#eaf0cb}.panel-success>.panel-heading{color:#5f6f17;background-color:#f2f6df;border-color:#eaf0cb}.panel-warning{border-color:#fef0cd}.panel-warning>.panel-heading{color:#e2a407;background-color:#fef7e6;border-color:#fef0cd}.panel-danger{border-color:#f4d6cf}.panel-danger>.panel-heading{color:#993722;background-color:#f9e8e4;border-color:#f4d6cf}.panel-dark{border-color:#dddddc}.panel-dark>.panel-heading{color:#3c3c3b;background-color:#e9e9e9;border-color:#dddddc}.detail-box{width:49%;float:left;text-align:center;box-sizing:border-box}.v-line-grey{height:60px;background-color:#ccc;width:1px;display:block;float:left}.box-config .panel-heading{padding:5px;border-radius:3px 3px 0 0}.box-config .panel-body{padding:2px 24px 16px}.box-config h4{font-size:16px!important;font-weight:600;margin-bottom:0}.detail-box p.name{font-size:14px;color:#ccd0db}.detail-box p{font-size:22px;color:#758295;margin-bottom:0}.panel-heading{position:relative;padding:15px 24px}.panel-heading h1,.panel-heading h2,.panel-heading h3,.panel-heading h4,.panel-heading h5,.panel-heading h6{margin:0}.panel-heading small{margin-top:8px;opacity:.5}.progress{background-color:#f7f7f7}.progress-xxxs{height:1px}.progress-xxs{height:2px}.progress-xs{height:6px}.progress-sm{height:12px}.progress-sm .progress-bar{font-size:10px;line-height:12px}.progress,.progress-bar{box-shadow:none}.progress-bar-primary{background-color:#0070c0}.progress-bar-info{background-color:#324654}.progress-bar-success{background-color:#a8c329}.progress-bar-warning{background-color:#facb55}.progress-bar-danger{background-color:#d7634a}.progress-bar-accent{background-color:#ffb000}.progress-bar-dark{background-color:#6f6f6e}.progress-bar-white{background-color:#fff}.col-0{clear:left}.row.no-gutter{margin-left:0;margin-right:0}.no-gutter [class*=col]{padding:0}.row-sm{margin-left:-8px;margin-right:-8px}.row-sm>div{padding-left:8px;padding-right:8px}.row-xs{margin-left:-4px;margin-right:-4px}.row-xs>div{padding-left:4px;padding-right:4px}@media (max-width:992px){.row{margin-left:-8px;margin-right:-8px}.row>div{padding-left:8px;padding-right:8px}.row-2 [class*=col]{width:50%;float:left}.row-2 .col-0{clear:none}.row-2 li:nth-child(odd){clear:left;margin-left:0}}@media (max-width:767px){.row{margin-left:-4px;margin-right:-4px}.row>div{padding-left:4px;padding-right:4px}}.gutter-20.row{margin-right:-10px;margin-left:-10px}.gutter-20>[class^=\" col-\"],.gutter-20>[class^=col-]{padding-right:10px;padding-left:10px}.gutter-10.row{margin-right:-5px;margin-left:-5px}.gutter-10>[class^=\" col-\"],.gutter-10>[class^=col-]{padding-right:5px;padding-left:5px}.gutter-0.row{margin-right:0;margin-left:0}.gutter-0>[class^=\" col-\"],.gutter-0>[class^=col-]{padding-right:0;padding-left:0}.panel .table{border-color:#eaeaea!important}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th{border-top:1px solid #ddd}.table>thead>tr>th{border-bottom:1px solid #ddd}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>thead>tr>th{border-color:#eaeaea}.table-striped>tbody>tr:nth-child(odd)>td,.table-striped>tbody>tr:nth-child(odd)>th,.table-striped>thead>th{background-color:#f7f7f7}.table-striped>thead>th{border-right:1px solid #eaeaea}.table-striped>thead>th:last-child{border-right:none}table.table.disabled{opacity:.2;cursor:not-allowed}.align-td{text-align:center}.thead-color{background-color:#d8d8d8}.ngRow.even{background-color:#f2f5f7}.ngRow.odd{background-color:#d8d8d8}.line-down{opacity:.85;text-decoration:underline}.grad-1,.grad-2,.grad-3,.grad-4{background:#0070c0}.grad-white{background:#fcfcfc}.grad-5{background:#0070c0}.grad-oblique-negro-dark{background:#353942;background:linear-gradient(177deg,#353942 78%,transparent 79%)}.grad-oblique-azul{background:#2053d2;background:linear-gradient(177deg,#2053d2 78%,transparent 79%)}.grad-oblique-teal{background:#00bfa5;background:linear-gradient(177deg,#00bfa5 78%,transparent 79%)}.grad-oblique-deep-orange{background:#ff7043;background:linear-gradient(177deg,#ff7043 78%,transparent 79%)}.md-btn,[md-ink-ripple]{position:relative}.md-btn{color:currentColor;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;border:0;border-radius:3px;padding:6px;display:inline-block;background:transparent;white-space:nowrap;text-align:center;font-weight:700;font-style:inherit;font-variant:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-decoration:none;cursor:pointer;overflow:hidden;transition:box-shadow .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),transform .4s cubic-bezier(.25,.8,.25,1)}.md-button{text-transform:none!important}.md-button.md-default-theme.md-primary.md-fab,.md-button.md-default-theme.md-primary.md-raised,.md-button.md-primary.md-fab,.md-button.md-primary.md-raised,a.md-button.md-default-theme.md-primary.md-fab,a.md-button.md-default-theme.md-primary.md-raised,a.md-button.md-primary.md-fab,a.md-button.md-primary.md-raised{background-color:#ffb000!important;color:#000}md-toolbar.md-default-theme:not(.md-menu-toolbar),md-toolbar:not(.md-menu-toolbar){background-color:#aace3b;color:hsla(0,0%,100%,.87)}md-fab-toolbar{z-index:9999999}.md-btn.md-flat:not([disabled]):focus,.md-btn.md-flat:not([disabled]):hover{background-color:hsla(0,0%,62%,.2)}.md-btn-circle{width:28px;height:28px;border-radius:50%}.md-btn.md-fab[disabled],.md-btn.md-raised[disabled],.md-btn[disabled]{color:rgba(0,0,0,.26);background-color:transparent;cursor:not-allowed}.md-fab{line-height:44px}.md-fab-offset{margin-top:-28px;margin-bottom:-28px}.md-btn:focus{outline:none}.md-btn:hover{text-decoration:none}.md-btn.md-cornered{border-radius:0}.md-btn.md-icon{padding:0;background:none}.md-btn.md-fab,.md-btn.md-raised{transform:translateZ(0)}.md-btn.md-fab{z-index:20;width:56px;height:56px;border-radius:50%;overflow:hidden;transition:.2s linear;transition-property:transform,box-shadow}.md-btn.md-fab,.md-btn.md-raised:not([disabled]){box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-btn.md-fab:not([disabled]):focus,.md-btn.md-fab:not([disabled]):hover,.md-btn.md-raised:not([disabled]):focus,.md-btn.md-raised:not([disabled]):hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.4)}.md-btn.md-fab.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}.md-fab-toolbar.md-fab-bottom-right-2{top:auto;right:20px;bottom:20px;left:0;position:absolute}.md-btn.md-fab.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}.md-btn.md-fab.md-fab-top-right{top:20px;right:20px;bottom:auto;left:auto;position:absolute}.md-btn.md-fab.md-fab-top-left{top:20px;right:auto;bottom:auto;left:20px;position:absolute}.md-btn.md-fab md-icon{margin-top:0}.md-btn.md-fab.md-mini{width:40px;height:40px}.md-btn:not([disabled]).md-fab:focus,.md-btn:not([disabled]).md-fab:hover,.md-btn:not([disabled]).md-raised:focus,.md-btn:not([disabled]).md-raised:hover{transform:translate3d(0,-1px,0)}.md-toast-open-top .md-btn.md-fab-top-left,.md-toast-open-top .md-btn.md-fab-top-right{transform:translate3d(0,42px,0)}.md-toast-open-top .md-btn.md-fab-top-left:not([disabled]):focus,.md-toast-open-top .md-btn.md-fab-top-left:not([disabled]):hover,.md-toast-open-top .md-btn.md-fab-top-right:not([disabled]):focus,.md-toast-open-top .md-btn.md-fab-top-right:not([disabled]):hover{transform:translate3d(0,41px,0)}.md-toast-open-bottom .md-btn.md-fab-bottom-left,.md-toast-open-bottom .md-btn.md-fab-bottom-right{transform:translate3d(0,-42px,0)}.md-toast-open-bottom .md-btn.md-fab-bottom-left:not([disabled]):focus,.md-toast-open-bottom .md-btn.md-fab-bottom-left:not([disabled]):hover,.md-toast-open-bottom .md-btn.md-fab-bottom-right:not([disabled]):focus,.md-toast-open-bottom .md-btn.md-fab-bottom-right:not([disabled]):hover{transform:translate3d(0,-43px,0)}.card{font-family:Roboto,sans-serif!important;box-shadow:0 1px 2px rgba(0,0,0,.15);background-color:#fff;position:relative;margin-bottom:8px;overflow:hidden}.card.active:hover{box-shadow:0 5px 10px rgba(0,0,0,.5);transition:box-shadow .5s ease}.card a{color:#ffb000;text-decoration:none}.card-heading{position:relative;padding:15px 24px}.card-heading h1,.card-heading h2,.card-heading h3,.card-heading h4,.card-heading h5,.card-heading h6{margin:0}.card-heading small{margin-top:8px;opacity:.5}.card-body{padding:20px 24px}.card-divider{border-bottom:1px solid hsla(210,4%,45%,.15);margin:0 24px}.card-tools{position:absolute;right:12px;top:12px}.blue-500 small,.blue-600 small,.blue-700 small,.blue-A200 small,.blue-A400 small,.blue-A700 small,.blue-grey-400 small,.blue-grey-500 small,.blue-grey small,.blue small,.brown-300 small,.brown-400 small,.cyan-500 small,.cyan-600 small,.cyan-700 small,.cyan-800 small,.cyan small,.deep-orange-500 small,.deep-orange-600 small,.deep-orange-700 small,.deep-orange-800 small,.deep-orange-900 small,.deep-orange-A400 small,.deep-orange-A700 small,.deep-orange small,.deep-purple-300 small,.deep-purple-400 small,.deep-purple-A200 small,.green-500 small,.green-600 small,.green-700 small,.green small,.indigo-300 small,.indigo-400 small,.indigo-A200 small,.indigo-A400 small,.light-blue-500 small,.light-blue-600 small,.light-blue-700 small,.light-blue-800 small,.light-blue-A700 small,.light-blue small,.light-green-800 small,.light-green-900 small,.lime-900 small,.orange-800 small,.orange-900 small,.pink-500 small,.pink-600 small,.pink-A200 small,.pink-A400 small,.pink-A700 small,.pink small,.purple-300 small,.purple-400 small,.purple-A200 small,.purple-A400 small,.purple-A700 small,.red-500 small,.red-600 small,.red-700 small,.red-A200 small,.red-A400 small,.red-A700 small,.red small,.teal-500 small,.teal-600 small,.teal-700 small,.teal small{color:#fff;opacity:.7}.azul{background-color:#2053d2}.azul-light{background-color:#468ac2}.amarillo{background-color:#fab813}.verde{background-color:#aace3b}.gris-dark{background-color:#91a3bd}.gris-darker{background-color:#758295}.rojo{background-color:#ef7955}.morado{background-color:#7e57c2}.naranjo{background-color:#ff9800}.blanco{background-color:#fff}.gris-light{background-color:#ccd0db}.gris-lighter{background-color:#f2f5f7}.negro-darker{background-color:#2d3039}.negro-dark{background-color:#353942}.gris-base{background-color:#f9f9f9}.cian-light{background-color:#53c3ab}.verde-light-msgs{background-color:#d7e6a7}.text-azul{color:#2053d2}.text-azul-light{color:#468ac2}.text-amarillo{color:#fab813}.text-verde{color:#aace3b}.text-gris-dark{color:#91a3bd}.text-gris-darker{color:#758295}.text-rojo{color:#ef7955}.text-morado{color:#7e57c2}.text-naranja{color:#ff9800}.text-cian{color:#53c3ab}.text-blanco{color:#fff}.text-gris-lighter{color:#f2f5f7}.text-negro-darker{color:#2d3039}.text-negro-dark{color:#353942}.text-negro-opacity{color:rgba(0,0,0,.45)}.text-verde-msgs{color:#667142}.text-rojo-important{color:#ef7955!important}.text-amarillo-important{color:#fab813!important}.text-negro-darker-important{color:#2d3039!important}.alert-manual{background:rgba(250,184,19,.2)}.alert-high{background:rgba(239,121,85,.2)}.bg-azul-light{background:rgba(70,138,194,.3)}.bg-azul{background:rgba(32,83,210,.3)}.bg-verde{background:rgba(170,206,59,.3)}.bg-amarillo{background:rgba(250,184,19,.3)}.bg-rojo{background:rgba(239,121,85,.3)}.bg-morado{background:rgba(126,87,194,.3)}.bg-rojo-dark{background:#ae1f35}.red{background-color:#d7634a}.red-50{background-color:#ffebee}.red-100{background-color:#ffcdd2}.red-200{background-color:#ef9a9a}.red-300{background-color:#e57373}.red-400{background-color:#ef5350}.red-500{background-color:#d7634a}.red-600{background-color:#e53935}.red-700{background-color:#d32f2f}.red-800{background-color:#c62828}.red-900{background-color:#b71c1c}.red-A100{background-color:#ff8a80}.red-A200{background-color:#ff5252}.red-A400{background-color:#ff1744}.red-A700{background-color:#d50000}.pink{background-color:#e91e63}.pink-50{background-color:#fce4ec}.pink-100{background-color:#f8bbd0}.pink-200{background-color:#f48fb1}.pink-300{background-color:#f06292}.pink-400{background-color:#ec407a}.pink-500{background-color:#e91e63}.pink-600{background-color:#d81b60}.pink-700{background-color:#c2185b}.pink-800{background-color:#ad1457}.pink-900{background-color:#880e4f}.pink-A100{background-color:#ff80ab}.pink-A200{background-color:#ff4081}.pink-A400{background-color:#f50057}.pink-A700{background-color:#c51162}.purple{background-color:#9c27b0}.purple-50{background-color:#f3e5f5}.purple-100{background-color:#e1bee7}.purple-200{background-color:#ce93d8}.purple-300{background-color:#ba68c8}.purple-400{background-color:#ab47bc}.purple-500{background-color:#9c27b0}.purple-600{background-color:#8e24aa}.purple-700{background-color:#7b1fa2}.purple-800{background-color:#6a1b9a}.purple-900{background-color:#4a148c}.purple-A100{background-color:#ea80fc}.purple-A200{background-color:#e040fb}.purple-A400{background-color:#d500f9}.purple-A700{background-color:#a0f}.deep-purple{background-color:#673ab7}.deep-purple-50{background-color:#ede7f6}.deep-purple-100{background-color:#d1c4e9}.deep-purple-200{background-color:#b39ddb}.deep-purple-300{background-color:#9575cd}.deep-purple-400{background-color:#7e57c2}.deep-purple-500{background-color:#673ab7}.deep-purple-600{background-color:#5e35b1}.deep-purple-700{background-color:#512da8}.deep-purple-800{background-color:#4527a0}.deep-purple-900{background-color:#311b92}.deep-purple-A100{background-color:#b388ff}.deep-purple-A200{background-color:#7c4dff}.deep-purple-A400{background-color:#651fff}.deep-purple-A700{background-color:#6200ea}.indigo{background-color:#3f51b5}.indigo-50{background-color:#e8eaf6}.indigo-100{background-color:#c5cae9}.indigo-200{background-color:#9fa8da}.indigo-300{background-color:#7986cb}.indigo-400{background-color:#5c6bc0}.indigo-500{background-color:#3f51b5}.indigo-600{background-color:#3949ab}.indigo-700{background-color:#303f9f}.indigo-800{background-color:#283593}.indigo-900{background-color:#1a237e}.indigo-A100{background-color:#8c9eff}.indigo-A200{background-color:#536dfe}.indigo-A400{background-color:#3d5afe}.indigo-A700{background-color:#304ffe}.blue{background-color:#00548a}.blue-50{background-color:#e3f2fd}.blue-100{background-color:#bbdefb}.blue-200{background-color:#90caf9}.blue-300{background-color:#64b5f6}.blue-400{background-color:#42a5f5}.blue-500{background-color:#00548a}.blue-600{background-color:#1e88e5}.blue-700{background-color:#1976d2}.blue-800{background-color:#1565c0}.blue-900{background-color:#0d47a1}.blue-A100{background-color:#82b1ff}.blue-A200{background-color:#448aff}.blue-A400{background-color:#2979ff}.blue-A700{background-color:#2962ff}.light-blue{background-color:#468ac2}.light-blue-50{background-color:#e1f5fe}.light-blue-100{background-color:#b3e5fc}.light-blue-200{background-color:#81d4fa}.light-blue-300{background-color:#4fc3f7}.light-blue-400{background-color:#29b6f6}.light-blue-500{background-color:#468ac2}.light-blue-600{background-color:#039be5}.light-blue-700{background-color:#0288d1}.light-blue-800{background-color:#0277bd}.light-blue-900{background-color:#01579b}.light-blue-A100{background-color:#80d8ff}.light-blue-A200{background-color:#40c4ff}.light-blue-A400{background-color:#00b0ff}.light-blue-A700{background-color:#0091ea}.cyan{background-color:#00bcd4}.cyan-50{background-color:#e0f7fa}.cyan-100{background-color:#b2ebf2}.cyan-200{background-color:#80deea}.cyan-300{background-color:#4dd0e1}.cyan-400{background-color:#26c6da}.cyan-500{background-color:#00bcd4}.cyan-600{background-color:#00acc1}.cyan-700{background-color:#0097a7}.cyan-800{background-color:#00838f}.cyan-900{background-color:#006064}.cyan-A100{background-color:#84ffff}.cyan-A200{background-color:#18ffff}.cyan-A400{background-color:#00e5ff}.cyan-A700{background-color:#00b8d4}.teal{background-color:#009688}.teal-50{background-color:#e0f2f1}.teal-100{background-color:#b2dfdb}.teal-200{background-color:#80cbc4}.teal-300{background-color:#4db6ac}.teal-400{background-color:#26a69a}.teal-500{background-color:#009688}.teal-600{background-color:#00897b}.teal-700{background-color:#00796b}.teal-800{background-color:#00695c}.teal-900{background-color:#004d40}.teal-A100{background-color:#a7ffeb}.teal-A200{background-color:#64ffda}.teal-A400{background-color:#1de9b6}.teal-A700{background-color:#00bfa5}.green{background-color:#4caf50}.green-50{background-color:#e8f5e9}.green-100{background-color:#c8e6c9}.green-200{background-color:#a5d6a7}.green-300{background-color:#81c784}.green-400{background-color:#66bb6a}.green-500{background-color:#4caf50}.green-600{background-color:#43a047}.green-700{background-color:#388e3c}.green-800{background-color:#2e7d32}.green-900{background-color:#1b5e20}.green-A100{background-color:#b9f6ca}.green-A200{background-color:#69f0ae}.green-A400{background-color:#00e676}.green-A700{background-color:#00c853}.light-green{background-color:#8bc34a}.light-green-50{background-color:#f1f8e9}.light-green-100{background-color:#dcedc8}.light-green-200{background-color:#c5e1a5}.light-green-300{background-color:#aed581}.light-green-400{background-color:#9ccc65}.light-green-500{background-color:#8bc34a}.light-green-600{background-color:#7cb342}.light-green-700{background-color:#689f38}.light-green-800{background-color:#558b2f}.light-green-900{background-color:#33691e}.light-green-A100{background-color:#ccff90}.light-green-A200{background-color:#b2ff59}.light-green-A400{background-color:#76ff03}.light-green-A700{background-color:#64dd17}.lime{background-color:#a8c329}.lime-50{background-color:#f9fbe7}.lime-100{background-color:#f0f4c3}.lime-200{background-color:#e6ee9c}.lime-300{background-color:#dce775}.lime-400{background-color:#d4e157}.lime-500{background-color:#a8c329}.lime-600{background-color:#c0ca33}.lime-700{background-color:#afb42b}.lime-800{background-color:#9e9d24}.lime-900{background-color:#827717}.lime-A100{background-color:#f4ff81}.lime-A200{background-color:#eeff41}.lime-A400{background-color:#c6ff00}.lime-A700{background-color:#aeea00}.yellow{background-color:#ffeb3b}.yellow-50{background-color:#fffde7}.yellow-100{background-color:#fff9c4}.yellow-200{background-color:#fff59d}.yellow-300{background-color:#fff176}.yellow-400{background-color:#ffee58}.yellow-500{background-color:#ffeb3b}.yellow-600{background-color:#fdd835}.yellow-700{background-color:#fbc02d}.yellow-800{background-color:#f9a825}.yellow-900{background-color:#f57f17}.yellow-A100{background-color:#ffff8d}.yellow-A200{background-color:#ff0}.yellow-A400{background-color:#ffea00}.yellow-A700{background-color:#ffd600}.amber{background-color:#fab813}.amber-50{background-color:#fff8e1}.amber-100{background-color:#ffecb3}.amber-200{background-color:#ffe082}.amber-300{background-color:#ffd54f}.amber-400{background-color:#ffca28}.amber-500{background-color:#fab813}.amber-600{background-color:#ffb300}.amber-700{background-color:#ffa000}.amber-800{background-color:#ff8f00}.amber-900{background-color:#ff6f00}.amber-A100{background-color:#ffe57f}.amber-A200{background-color:#ffd740}.amber-A400{background-color:#ffc400}.amber-A700{background-color:#ffab00}.orange{background-color:#ff9800}.orange-50{background-color:#fff3e0}.orange-100{background-color:#ffe0b2}.orange-200{background-color:#ffcc80}.orange-300{background-color:#ffb74d}.orange-400{background-color:#ffa726}.orange-500{background-color:#ff9800}.orange-600{background-color:#fb8c00}.orange-700{background-color:#f57c00}.orange-800{background-color:#ef6c00}.orange-900{background-color:#e65100}.orange-A100{background-color:#ffd180}.orange-A200{background-color:#ffab40}.orange-A400{background-color:#ff9100}.orange-A700{background-color:#ff6d00}.deep-orange{background-color:#ff5722}.deep-orange-50{background-color:#fbe9e7}.deep-orange-100{background-color:#ffccbc}.deep-orange-200{background-color:#ffab91}.deep-orange-300{background-color:#ff8a65}.deep-orange-400{background-color:#ff7043}.deep-orange-500{background-color:#ff5722}.deep-orange-600{background-color:#f4511e}.deep-orange-700{background-color:#e64a19}.deep-orange-800{background-color:#d84315}.deep-orange-900{background-color:#bf360c}.deep-orange-A100{background-color:#ff9e80}.deep-orange-A200{background-color:#ff6e40}.deep-orange-A400{background-color:#ff3d00}.deep-orange-A700{background-color:#dd2c00}.brown{background-color:#795548}.brown-50{background-color:#efebe9}.brown-100{background-color:#d7ccc8}.brown-200{background-color:#bcaaa4}.brown-300{background-color:#a1887f}.brown-400{background-color:#8d6e63}.brown-500{background-color:#795548}.brown-600{background-color:#6d4c41}.brown-700{background-color:#5d4037}.brown-800{background-color:#4e342e}.brown-900{background-color:#3e2723}.blue-grey{background-color:#607d8b}.blue-grey-50{background-color:#eceff1}.blue-grey-100{background-color:#cfd8dc}.blue-grey-200{background-color:#b0bec5}.blue-grey-300{background-color:#90a4ae}.blue-grey-400{background-color:#78909c}.blue-grey-500{background-color:#607d8b}.blue-grey-600{background-color:#546e7a}.blue-grey-700{background-color:#455a64}.blue-grey-800{background-color:#37474f}.blue-grey-900{background-color:#263238}.grey{background-color:#6f6f6e}.grey-50{background-color:#fafafa}.grey-100{background-color:#f5f5f5}.grey-200{background-color:#eee}.grey-300{background-color:#e0e0e0}.grey-400{background-color:#bdbdbd}.grey-500{background-color:#6f6f6e}.grey-600{background-color:#757575}.grey-700{background-color:#616161}.grey-800{background-color:#424242}.grey-900{background-color:#212121}.blue,.blue-500,.blue-600,.blue-700,.blue-A200,.blue-A400,.blue-A700,.blue-grey,.blue-grey-400,.blue-grey-500,.brown-300,.brown-400,.cyan,.cyan-500,.cyan-600,.cyan-700,.cyan-800,.deep-orange,.deep-orange-500,.deep-orange-600,.deep-orange-700,.deep-orange-800,.deep-orange-900,.deep-orange-A400,.deep-orange-A700,.deep-purple-300,.deep-purple-400,.deep-purple-A200,.green,.green-500,.green-600,.green-700,.indigo-300,.indigo-400,.indigo-A200,.indigo-A400,.light-blue,.light-blue-500,.light-blue-600,.light-blue-700,.light-blue-800,.light-blue-A700,.light-green-800,.light-green-900,.lime-900,.orange-800,.orange-900,.pink,.pink-500,.pink-600,.pink-A200,.pink-A400,.pink-A700,.purple-300,.purple-400,.purple-A200,.purple-A400,.purple-A700,.red,.red-500,.red-600,.red-700,.red-A200,.red-A400,.red-A700,.teal,.teal-500,.teal-600,.teal-700{color:#fff}.blue-800,.blue-900,.blue-grey-600,.blue-grey-700,.blue-grey-800,.blue-grey-900,.brown,.brown-500,.brown-600,.brown-700,.brown-800,.brown-900,.cyan-900,.deep-purple,.deep-purple-500,.deep-purple-600,.deep-purple-700,.deep-purple-800,.deep-purple-900,.deep-purple-A400,.deep-purple-A700,.green-800,.green-900,.grey-600,.grey-700,.grey-800,.grey-900,.indigo,.indigo-500,.indigo-600,.indigo-700,.indigo-800,.indigo-900,.indigo-A700,.light-blue-900,.pink-700,.pink-800,.pink-900,.purple,.purple-500,.purple-600,.purple-700,.purple-800,.purple-900,.red-800,.red-900,.teal-800,.teal-900{color:hsla(0,0%,100%,.87)}.orange-A700{color:#000}.amarillo,.azul,.azul-light,.gris-dark,.gris-darker,.morado,.negro-dark,.negro-darker,.rojo,.verde{color:#fff}.gris-lighter{color:#000}.bg-azul,.bg-azul-light{color:#303f9f}.md-list{border-radius:3px}.md-list-item{display:block;position:relative;padding:16px}.md-list-item:after{content:\"\";position:absolute;left:0;right:0;bottom:0;border-bottom:1px solid hsla(0,0%,63%,.2)}.md-list-item:last-child.md-list-item:after{border:none}.md-list-item.inset.md-list-item:after{left:72px}.md-list-item-left{width:40px;height:40px;margin-right:16px;float:left;text-align:center;line-height:40px}.md-list-item-content{overflow:hidden}.md-list-item-content h3{margin:0 0 3px;font-weight:400}.md-form-group{padding:18px 0 24px;position:relative}.md-input{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit}.md-input.focus,.md-input:focus{border-color:#0070c0;border-bottom-width:2px;padding-bottom:1px}.md-input.focus~label,.md-input:focus~label{color:#0070c0;opacity:1;top:0!important;font-size:.85em!important}.float-label .md-input~label{top:20px;font-size:1em}.float-label .md-input.has-value~label,.float-label .md-input.ng-dirty~label,.md-input~label{top:0;font-size:.85em}.md-input~label{transition:all .2s;position:absolute;z-index:0;opacity:.5;display:inline-block;left:0}.md-input.disabled,.md-input[disabled]{opacity:.5}textarea.md-input{height:auto}.md-input-white.focus,.md-input-white:focus{border-color:#fff}.md-input-white.focus~label,.md-input-white:focus~label{color:#fff}.md-input-msg{position:absolute;bottom:0;line-height:24px;font-size:.85em}.md-input-msg.right{right:0}.height-input{padding:7px;margin-top:-2px;border:1px solid #d8d8d8}.md-check{cursor:pointer;padding-left:20px;margin:0;display:inline-block;position:relative}.md-check input{position:absolute;cursor:pointer;width:20px;height:20px;z-index:1;opacity:0;margin-left:-20px}.md-check input:checked+i:before{border-width:0;background-color:inherit}.md-check input:checked+span .active{display:inherit}.md-check input[type=radio]+i,.md-check input[type=radio]+i:before{border-radius:50%}.md-check input[type=checkbox]:checked+i:after{transform:rotate(45deg);position:absolute;left:6px;top:2px;display:table;width:6px;height:12px;border:2px solid;border-top:0;border-left:0;content:\" \"}.md-check input[type=radio]:checked+i:after{position:absolute;left:6px;top:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.md-check input[disabled]+i:before,fieldset[disabled] .md-check input+i:before{border-color:rgba(0,0,0,.26)}.md-check input[disabled]:checked+i:before{background-color:rgba(0,0,0,.26)}.md-check>i{width:0;height:18px;line-height:1;margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:28px;position:relative}.md-check>i:before{content:\"\";position:absolute;width:18px;height:100%;border:2px solid rgba(0,0,0,.54);border-radius:2px;transition:all .2s}.md-check>i.no-icon:after{display:none!important}md-checkbox.md-checked.md-green .md-icon{background-color:#aace3b}md-checkbox.md-checked.md-blue .md-icon{background-color:#468ac2}md-checkbox.md-checked.md-blue-2 .md-icon{background-color:#2053d2}.md-switch{cursor:pointer;padding-left:36px;margin:0;min-height:20px}.md-switch input{position:absolute;cursor:pointer;width:36px;height:20px;z-index:1;opacity:0;filter:alpha(opacity=0);margin-left:-36px}.md-switch input:checked+i:before{background:inherit;opacity:.5}.md-switch input:checked+i:after{background:inherit;left:16px}.md-switch input[disabled]+i:before,fieldset[disabled] .md-switch input+i:before{background-color:rgba(0,0,0,.12)}.md-switch input[disabled]+i:after,fieldset[disabled] .md-switch input+i:after{background-color:#bdbdbd}.md-switch i{width:0;height:18px;line-height:1;margin-left:-36px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:44px;position:relative}.md-switch i:before{left:1px;width:34px;top:3px;height:14px;border-radius:8px;background-color:#9e9e9e}.md-switch i:after,.md-switch i:before{content:\"\";position:absolute;transition:all .2s}.md-switch i:after{margin:0;left:0;top:0;outline:none;height:20px;width:20px;border-radius:50%;background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.box-row md-switch.md-checked .md-thumb{background-color:#4caf50}md-switch.md-checked .md-bar{background-color:rgba(76,175,80,.5)}.md-whiteframe-z0{box-shadow:0 1px 3px rgba(0,0,0,.15)}.md-whiteframe-z1{box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-whiteframe-z2{box-shadow:0 8px 17px rgba(0,0,0,.2)}.md-whiteframe-z3{box-shadow:0 17px 50px rgba(0,0,0,.19)}.md-whiteframe-z4{box-shadow:0 16px 28px 0 rgba(0,0,0,.22)}.md-whiteframe-z5{box-shadow:0 27px 24px 0 rgba(0,0,0,.2)}/*!\n * font-awesome-animation - v0.0.9\n * https://github.com/l-lin/font-awesome-animation\n * http://l-lin.github.io/font-awesome-animation/\n * License: MIT\n */@keyframes wrench{0%{transform:rotate(-12deg)}8%{transform:rotate(12deg)}10%{transform:rotate(24deg)}18%{transform:rotate(-24deg)}20%{transform:rotate(-24deg)}28%{transform:rotate(24deg)}30%{transform:rotate(24deg)}38%{transform:rotate(-24deg)}40%{transform:rotate(-24deg)}48%{transform:rotate(24deg)}50%{transform:rotate(24deg)}58%{transform:rotate(-24deg)}60%{transform:rotate(-24deg)}68%{transform:rotate(24deg)}75%,to{transform:rotate(0deg)}}.faa-parent.animated-hover:hover>.faa-wrench,.faa-wrench.animated,.faa-wrench.animated-hover:hover{animation:wrench 2.5s ease infinite;transform-origin-x:90%;transform-origin-y:35%;transform-origin-z:initial}.faa-parent.animated-hover:hover>.faa-wrench.faa-fast,.faa-wrench.animated-hover.faa-fast:hover,.faa-wrench.animated.faa-fast{animation:wrench 1.2s ease infinite}.faa-parent.animated-hover:hover>.faa-wrench.faa-slow,.faa-wrench.animated-hover.faa-slow:hover,.faa-wrench.animated.faa-slow{animation:wrench 3.7s ease infinite}@keyframes ring{0%{transform:rotate(-15deg)}2%{transform:rotate(15deg)}4%{transform:rotate(-18deg)}6%{transform:rotate(18deg)}8%{transform:rotate(-22deg)}10%{transform:rotate(22deg)}12%{transform:rotate(-18deg)}14%{transform:rotate(18deg)}16%{transform:rotate(-12deg)}18%{transform:rotate(12deg)}20%,to{transform:rotate(0deg)}}.faa-parent.animated-hover:hover>.faa-ring,.faa-ring.animated,.faa-ring.animated-hover:hover{animation:ring 2s ease infinite;transform-origin-x:50%;transform-origin-y:0;transform-origin-z:initial}.faa-parent.animated-hover:hover>.faa-ring.faa-fast,.faa-ring.animated-hover.faa-fast:hover,.faa-ring.animated.faa-fast{animation:ring 1s ease infinite}.faa-parent.animated-hover:hover>.faa-ring.faa-slow,.faa-ring.animated-hover.faa-slow:hover,.faa-ring.animated.faa-slow{animation:ring 3s ease infinite}@keyframes vertical{0%{transform:translateY(-3px)}4%{transform:translateY(3px)}8%{transform:translateY(-3px)}12%{transform:translateY(3px)}16%{transform:translateY(-3px)}20%{transform:translateY(3px)}22%,to{transform:translate(0)}}.faa-parent.animated-hover:hover>.faa-vertical,.faa-vertical.animated,.faa-vertical.animated-hover:hover{animation:vertical 2s ease infinite}.faa-parent.animated-hover:hover>.faa-vertical.faa-fast,.faa-vertical.animated-hover.faa-fast:hover,.faa-vertical.animated.faa-fast{animation:vertical 1s ease infinite}.faa-parent.animated-hover:hover>.faa-vertical.faa-slow,.faa-vertical.animated-hover.faa-slow:hover,.faa-vertical.animated.faa-slow{animation:vertical 4s ease infinite}@keyframes horizontal{0%{transform:translate(0)}6%{transform:translate(5px)}12%{transform:translate(0)}18%{transform:translate(5px)}24%{transform:translate(0)}30%{transform:translate(5px)}36%,to{transform:translate(0)}}.faa-horizontal.animated,.faa-horizontal.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-horizontal{animation:horizontal 2s ease infinite}.faa-horizontal.animated-hover.faa-fast:hover,.faa-horizontal.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-horizontal.faa-fast{animation:horizontal 1s ease infinite}.faa-horizontal.animated-hover.faa-slow:hover,.faa-horizontal.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-horizontal.faa-slow{animation:horizontal 3s ease infinite}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.faa-flash.animated,.faa-flash.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-flash{animation:flash 2s ease infinite}.faa-flash.animated-hover.faa-fast:hover,.faa-flash.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-flash.faa-fast{animation:flash 1s ease infinite}.faa-flash.animated-hover.faa-slow:hover,.faa-flash.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-flash.faa-slow{animation:flash 3s ease infinite}@keyframes bounce{0%,10%,20%,50%,80%,to{transform:translateY(0)}40%{transform:translateY(-15px)}60%{transform:translateY(-15px)}}.faa-bounce.animated,.faa-bounce.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-bounce{animation:bounce 2s ease infinite}.faa-bounce.animated-hover.faa-fast:hover,.faa-bounce.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-bounce.faa-fast{animation:bounce 1s ease infinite}.faa-bounce.animated-hover.faa-slow:hover,.faa-bounce.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-bounce.faa-slow{animation:bounce 3s ease infinite}.faa-parent.animated-hover:hover>.faa-spin,.faa-spin.animated,.faa-spin.animated-hover:hover{animation:spin 1.5s linear infinite}.faa-parent.animated-hover:hover>.faa-spin.faa-fast,.faa-spin.animated-hover.faa-fast:hover,.faa-spin.animated.faa-fast{animation:spin .7s linear infinite}.faa-parent.animated-hover:hover>.faa-spin.faa-slow,.faa-spin.animated-hover.faa-slow:hover,.faa-spin.animated.faa-slow{animation:spin 2.2s linear infinite}@keyframes float{0%{transform:translateY(0)}50%{transform:translateY(-6px)}to{transform:translateY(0)}}.faa-float.animated,.faa-float.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-float{animation:float 2s linear infinite}.faa-float.animated-hover.faa-fast:hover,.faa-float.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-float.faa-fast{animation:float 1s linear infinite}.faa-float.animated-hover.faa-slow:hover,.faa-float.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-float.faa-slow{animation:float 3s linear infinite}@keyframes pulse{0%{transform:scale(1.1)}50%{transform:scale(.8)}to{transform:scale(1.1)}}.faa-parent.animated-hover:hover>.faa-pulse,.faa-pulse.animated,.faa-pulse.animated-hover:hover{animation:pulse 2s linear infinite}.faa-parent.animated-hover:hover>.faa-pulse.faa-fast,.faa-pulse.animated-hover.faa-fast:hover,.faa-pulse.animated.faa-fast{animation:pulse 1s linear infinite}.faa-parent.animated-hover:hover>.faa-pulse.faa-slow,.faa-pulse.animated-hover.faa-slow:hover,.faa-pulse.animated.faa-slow{animation:pulse 3s linear infinite}.faa-parent.animated-hover:hover>.faa-shake,.faa-shake.animated,.faa-shake.animated-hover:hover{animation:wrench 2.5s ease infinite}.faa-parent.animated-hover:hover>.faa-shake.faa-fast,.faa-shake.animated-hover.faa-fast:hover,.faa-shake.animated.faa-fast{animation:wrench 1.2s ease infinite}.faa-parent.animated-hover:hover>.faa-shake.faa-slow,.faa-shake.animated-hover.faa-slow:hover,.faa-shake.animated.faa-slow{animation:wrench 3.7s ease infinite}@keyframes tada{0%{transform:scale(1)}10%,20%{transform:scale(.9) rotate(-8deg)}30%,50%,70%{transform:scale(1.3) rotate(8deg)}40%,60%{transform:scale(1.3) rotate(-8deg)}80%,to{transform:scale(1) rotate(0)}}.faa-parent.animated-hover:hover>.faa-tada,.faa-tada.animated,.faa-tada.animated-hover:hover{animation:tada 2s linear infinite}.faa-parent.animated-hover:hover>.faa-tada.faa-fast,.faa-tada.animated-hover.faa-fast:hover,.faa-tada.animated.faa-fast{animation:tada 1s linear infinite}.faa-parent.animated-hover:hover>.faa-tada.faa-slow,.faa-tada.animated-hover.faa-slow:hover,.faa-tada.animated.faa-slow{animation:tada 3s linear infinite}@keyframes passing{0%{transform:translateX(-50%);opacity:0}50%{transform:translateX(0);opacity:1}to{transform:translateX(50%);opacity:0}}.faa-parent.animated-hover:hover>.faa-passing,.faa-passing.animated,.faa-passing.animated-hover:hover{animation:passing 2s linear infinite}.faa-parent.animated-hover:hover>.faa-passing.faa-fast,.faa-passing.animated-hover.faa-fast:hover,.faa-passing.animated.faa-fast{animation:passing 1s linear infinite}.faa-parent.animated-hover:hover>.faa-passing.faa-slow,.faa-passing.animated-hover.faa-slow:hover,.faa-passing.animated.faa-slow{animation:passing 3s linear infinite}@keyframes passing-reverse{0%{transform:translateX(50%);opacity:0}50%{transform:translateX(0);opacity:1}to{transform:translateX(-50%);opacity:0}}.faa-parent.animated-hover:hover>.faa-passing-reverse,.faa-passing-reverse.animated,.faa-passing-reverse.animated-hover:hover{animation:passing-reverse 2s linear infinite}.faa-parent.animated-hover:hover>.faa-passing-reverse.faa-fast,.faa-passing-reverse.animated-hover.faa-fast:hover,.faa-passing-reverse.animated.faa-fast{animation:passing-reverse 1s linear infinite}.faa-parent.animated-hover:hover>.faa-passing-reverse.faa-slow,.faa-passing-reverse.animated-hover.faa-slow:hover,.faa-passing-reverse.animated.faa-slow{animation:passing-reverse 3s linear infinite}@keyframes burst{0%{opacity:.6}50%{transform:scale(1.8);opacity:0}to{opacity:0}}.faa-burst.animated,.faa-burst.animated-hover:hover,.faa-parent.animated-hover:hover>.faa-burst{animation:burst 2s infinite linear}.faa-burst.animated-hover.faa-fast:hover,.faa-burst.animated.faa-fast,.faa-parent.animated-hover:hover>.faa-burst.faa-fast{animation:burst 1s infinite linear}.faa-burst.animated-hover.faa-slow:hover,.faa-burst.animated.faa-slow,.faa-parent.animated-hover:hover>.faa-burst.faa-slow{animation:burst 3s infinite linear}.arrow{position:absolute;z-index:10}.arrow:after,.arrow:before{position:absolute;content:\"\";display:block;width:0;height:0;border:9px solid transparent}.arrow:after{border-width:8px}.arrow.top{top:-9px;left:50%;margin-left:-9px}.arrow.top.pull-in{top:-4px}.arrow.top:before{border-bottom-color:rgba(0,0,0,.1);border-top-width:0}.arrow.top:after{top:1px;left:1px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:inherit;border-left-color:transparent;border-top-width:0}.arrow.right{top:50%;right:0;margin-top:-9px}.arrow.right.pull-in{right:5px}.arrow.right:before{border-left-color:rgba(0,0,0,.1);border-right-width:0}.arrow.right:after{top:1px;left:0;border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:inherit;border-right-width:0}.arrow.bottom{bottom:0;left:50%;margin-left:-9px}.arrow.bottom.pull-in{bottom:5px}.arrow.bottom:before{border-top-color:rgba(0,0,0,.1);border-bottom-width:0}.arrow.bottom:after{top:0;left:1px;border-top-color:inherit;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;border-bottom-width:0}.arrow.left{top:50%;left:-9px;margin-top:-9px}.arrow.left.pull-in{left:-4px}.arrow.left:before{border-right-color:rgba(0,0,0,.1);border-left-width:0}.arrow.left:after{top:1px;left:1px;border-top-color:transparent;border-right-color:inherit;border-bottom-color:transparent;border-left-color:transparent;border-left-width:0}.arrow.pull-left{left:18px}.arrow.pull-right{left:auto;right:26px}.arrow.pull-top{top:18px}.arrow.pull-bottom{top:auto;bottom:26px}.arrow.b-accent:before,.arrow.b-danger:before,.arrow.b-dark:before,.arrow.b-info:before,.arrow.b-primary:before,.arrow.b-success:before,.arrow.b-warning:before{border-color:transparent}.box{display:table;table-layout:fixed;border-spacing:0;width:100%;height:100%}.box .box-row{display:table-row;height:100%}.box .box-row .box-cell{position:relative;height:100%;width:100%;-webkit-overflow-scrolling:touch;overflow-x:hidden;box-sizing:border-box}.box .box-col,.ie .box .box-row .box-cell{display:table-cell}.box .box-col{vertical-align:top}.box .box-inner{position:absolute;top:0;bottom:0;left:0;right:0}.box>[class*=\" col-\"],.box>[class*=col-]{vertical-align:top;height:100%;float:none;padding:0;position:static}.v-m{vertical-align:middle!important}.v-t{vertical-align:top!important}.v-b{vertical-align:bottom!important}.v-c{display:-ms-flexbox;display:flex;align-items:center}@media (min-width:1200px){.box>[class*=\" col-lg\"],.box>[class*=col-lg]{display:table-cell}}@media (min-width:992px){.box>[class*=\" col-md\"],.box>[class*=col-md]{display:table-cell}}@media (min-width:768px){.box>[class*=\" col-sm\"],.box>[class*=col-sm]{display:table-cell}}@media (max-width:767px){.box>[class*=\" col-xs\"],.box>[class*=col-xs]{display:table-cell}}.ui-checks{padding-left:20px;cursor:pointer}.ui-checks input{opacity:0;position:absolute;margin-left:-20px}.ui-checks input:checked+i{border-color:#eaeaea}.ui-checks input:checked+i:before{left:4px;top:4px;width:6px;height:6px;background-color:#324654}.ui-checks input:checked+span .active{display:inherit}.ui-checks input[type=radio]+i,.ui-checks input[type=radio]+i:before{border-radius:50%}.ui-checks input[disabled]+i,fieldset[disabled] .ui-checks input+i{border-color:#f7f7f7}.ui-checks input[disabled]+i:before,fieldset[disabled] .ui-checks input+i:before{background-color:#f7f7f7}.ui-checks>i{width:16px;height:16px;line-height:1;border:1px solid #eaeaea;background-color:#fff;margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:4px;position:relative}.ui-checks>i:before{content:\"\";position:absolute;left:50%;top:50%;width:0;height:0;background-color:transparent;transition:all .2s}.ui-checks>span{margin-left:-20px}.ui-checks>span .active{display:none}.ui-checks-md input:checked+i:before{left:5px;top:5px}.ui-checks-md>i{width:18px;height:18px}.ui-checks-lg input:checked+i:before{width:12px;height:12px;left:8px;top:8px}.ui-checks-lg>i{width:30px;height:30px}body,html{width:100%;height:100%}.app,body{overflow:hidden}.app{width:100%;height:100%;position:relative}.modal-open .app{overflow:hidden}.app-aside{background-color:#004374;bottom:0;box-shadow:0 64px 5px 0 rgba(0,0,0,.26);color:#fff;height:100%;opacity:1;overflow-x:hidden;overflow-y:auto;position:absolute!important;top:0;z-index:60;-webkit-backface-visibility:hidden;backface-visibility:hidden}.app-aside a{color:#fff}.app-aside .leftbarbg,.app-aside>div.sidebar-menu{background-color:rgba(0,0,0,.15)}.app-aside .leftbarbg{background-image:none}.app-content{position:absolute;top:64px;bottom:30px;left:0;right:0;overflow-y:auto}@media (min-width:992px){.app-aside{display:block!important;width:240px}.app-aside.md-closed.hide{transform:translateZ(0)!important}.app-aside.folded{width:64px}.app-aside.folded~.app-content{margin-left:0;margin-top:0}.app-aside:not(.folded):not(.hide)~.app-content{margin-left:240px}.app-aside.md-sidenav-left{min-width:0}.app-aside .left,.app-aside.md-sidenav-left{transform:translateZ(0)!important}}@media (max-width:991px){.app-aside{display:block!important}.app-aside.modal{z-index:1050}.app-aside .left{max-width:304px}.app-padding{padding:4px}}.folded.active,.folded:focus,body .app-aside.folded,body .folded:hover{width:0}body .folded.active .hidden-folded,body .folded .hidden-folded,body .folded:focus .hidden-folded,body .folded:hover .hidden-folded{display:none}.hidden-folded #nav{margin-top:57px}.menu-right{left:231px}.menu-left,.menu-right{position:absolute;z-index:999}.menu-left{left:0}.menu-right-2{left:350px}.menu-left-2,.menu-right-2{position:absolute;z-index:999}.menu-left-2{left:120px}body .breadcrumb{display:block;width:100%!important;padding-top:0;padding-bottom:0;margin-right:0;list-style:none;background-color:#0070c0;cursor:pointer;transition:all .2s cubic-bezier(.645,.045,.355,1);border-radius:0}ol.breadcrumb{margin:0;padding:0;height:35px;display:flex}ol.breadcrumb a,ol.breadcrumb li{display:inline-flex;align-items:center}ol.breadcrumb a{height:35px;border-bottom:4px solid transparent}div.breadcrumb{height:35px;margin-bottom:0}body .breadcrumb a,body .breadcrumb span{font-size:14px;color:#fff}body .breadcrumb span{border-bottom:4px solid #ffb000;height:35px;padding-top:6px}.breadcrumb>li+li:before{padding:0 5px;color:transparent;content:\"/\\A0\"}@media (max-width:900px){.folded .hidden-folded{display:none}.app-aside.md-sidenav-left{transform:translateZ(0)!important;min-width:0}.app-aside.folded{width:64px}.folded{transition:width .4s cubic-bezier(.25,.8,.25,1);z-index:60}.app-aside{display:block!important;width:240px}.folded.active,.folded:focus,body .folded:hover{width:234px}.folded .nav li .nav-item span,.folded .nav li a span{display:none}.folded .nav li .nav-item .icon,.folded .nav li a .icon{float:none;line-height:50px;margin-right:0;min-width:0}body #aside{top:64px}body.md-sidenav-left.md-closed,body md-sidenav.md-closed{transform:translateZ(0)}.menu-right{left:0!important}.menu-right-2{left:120px!important}}.blue-link{color:#2053d2;text-decoration:underline}.box-row.content-box .row.title{display:flex;align-items:center}.box-row.content-box .row.title h3{margin-top:0}body nav ul.nav li li li.super_menu_li_sub a{padding-left:68px}.font-small,.menu_title,nav ul.nav li li a{font-size:12px}body nav ul.nav li .nav-item>.icon,body nav ul.nav li a>.icon{margin-right:0;min-width:30px}body nav ul.nav li li a{padding-left:58px;padding-bottom:10px;padding-top:10px;overflow:hidden;height:inherit}.draggable-bar>.col-lg-12>ul>li{display:inline-block;padding-right:6px;padding-left:6px;border-right:1px solid #8493ab}.draggable-bar>.col-lg-12{padding:5px}.draggable-bar>.col-lg-12>ul{list-style-type:none;margin-bottom:0}.draggable-bar>.col-lg-12>ul>li>.drag_div>a{font-size:14px;color:#fff}.draggable-bar>.col-lg-12>ul>li{margin-right:1px;background-color:#91a3bd}.draggable-bar>.col-lg-12>ul>li:last-child{border-right:none}.footer{position:fixed;bottom:0;left:0;right:0;background-color:#758295}nav{overflow-x:hidden;width:100%}nav ul.nav li{position:relative}nav ul.nav li li a{line-height:36px;line-height:19px;border-bottom:1px solid transparent}nav ul.nav li li a .badge,nav ul.nav li li a .label{margin-top:10px}nav ul.nav li li li a{padding-left:88px}nav ul.nav li li li li a{padding-left:106px}nav ul.nav li .nav-item,nav ul.nav li a{font-weight:400;text-transform:none;text-align:left;display:block;padding:0 16px;line-height:19px;padding-bottom:10px;padding-top:15px;position:relative;border-radius:0!important}nav ul.nav li .nav-item .text,nav ul.nav li a .text{margin-left:16px}nav ul.nav li .nav-item .up,nav ul.nav li a .up{margin-left:16px;font-style:normal;z-index:1}nav ul.nav li .nav-item>.pull-right i,nav ul.nav li a>.pull-right i{margin-left:16px;transition:transform .3s ease-in-out}nav ul.nav li .nav-item>.icon,nav ul.nav li a>.icon{float:left;line-height:inherit;margin-right:16px;top:0;min-width:40px}nav ul.nav li .nav-item>.icon:before,nav ul.nav li a>.icon:before{width:24px;display:inline-block;text-align:center;opacity:.75}nav ul.nav li .nav-item:focus,nav ul.nav li .nav-item:hover,nav ul.nav li a:focus,nav ul.nav li a:hover{background-color:rgba(0,0,0,.1)}nav ul.nav li label{display:block}nav ul.nav li label i{margin-left:-16px;margin-right:48px}nav ul.nav li.active,nav ul.nav li.active>a{background-color:transparent}nav ul.nav li.active>a>.pull-right i{transform:rotate(180deg)}nav ul.nav.nav-stacked .nav-header,nav ul.nav.nav-stacked a{padding:0 16px;line-height:30px}nav .nav-header{padding:0 16px;line-height:40px}@media (min-width:992px){.folded{transition:width .4s cubic-bezier(.25,.8,.25,1);z-index:60}.folded .nav li ul{display:none}.folded .nav li .nav-item,.folded .nav li a{text-align:center}.folded .nav li .nav-item span,.folded .nav li a span{display:none}.folded .nav li .nav-item .up,.folded .nav li a .up{position:absolute;top:-8px;right:4px}.folded .nav li .nav-item .icon,.folded .nav li a .icon{float:none;line-height:50px;margin-right:0;min-width:0}.folded .nav li .nav-item label i,.folded .nav li a label i{margin-left:-38px;margin-right:0}.folded .navbar-brand{text-align:center}.folded .hidden-folded{display:none}.folded.active,.folded.active>*,.folded:focus,.folded:focus>*,.folded:hover,.folded:hover>*{width:240px}.folded.active .nav li ul,.folded:focus .nav li ul,.folded:hover .nav li ul{display:inherit}.folded.active .nav li .nav-item,.folded.active .nav li a,.folded:focus .nav li .nav-item,.folded:focus .nav li a,.folded:hover .nav li .nav-item,.folded:hover .nav li a{text-align:left}.folded.active .nav li .nav-item span,.folded.active .nav li a span,.folded:focus .nav li .nav-item span,.folded:focus .nav li a span,.folded:hover .nav li .nav-item span,.folded:hover .nav li a span{display:inline}.folded.active .nav li .nav-item .up,.folded.active .nav li a .up,.folded:focus .nav li .nav-item .up,.folded:focus .nav li a .up,.folded:hover .nav li .nav-item .up,.folded:hover .nav li a .up{position:static}.folded.active .nav li .nav-item .icon,.folded.active .nav li a .icon,.folded:focus .nav li .nav-item .icon,.folded:focus .nav li a .icon,.folded:hover .nav li .nav-item .icon,.folded:hover .nav li a .icon{float:left;line-height:inherit;margin-right:22px}.folded.active .nav li label i,.folded:focus .nav li label i,.folded:hover .nav li label i{margin-left:-16px;margin-right:48px}.folded.active .navbar-brand,.folded:focus .navbar-brand,.folded:hover .navbar-brand{text-align:left}.folded.active .hidden-folded,.folded:focus .hidden-folded,.folded:hover .hidden-folded{display:inherit}.folded.active .hidden-folded.inline,.folded:focus .hidden-folded.inline,.folded:hover .hidden-folded.inline{display:inline-block}}.nav-sub{max-height:0;overflow:hidden;transition:max-height .5s cubic-bezier(.35,0,.25,1)}.nav-sub .md-ripple-container{display:none;visibility:hidden}.active>.nav-sub{max-height:999px}.active>.nav-sub .md-ripple-container{display:block;visibility:visible}.i-12{font-size:12px}.i-12,.i-16{vertical-align:-15%}.i-16{font-size:16px}.i-20{font-size:20px;vertical-align:-19%}.i-24{font-size:24px;vertical-align:-23%}.i-28{font-size:28px;vertical-align:-27%}.i-34{font-size:34px;vertical-align:-19%}.ui-icon{display:inline-block;text-align:center;height:1em;background:transparent!important}.ui-icon:before{position:relative;z-index:1}.ui-icon:after{content:\"\";border-width:1px;border-style:solid;border-color:inherit;border-radius:2em;width:2em;height:2em;top:-1.5em;display:block;position:relative;z-index:0;background-clip:padding-box}.ui-icon.b-2x:after{border-width:2px}.ui-icon.b-3x:after{border-width:3px}.ui-icon.ui-icon-sm:after{width:1.7em;height:1.7em;top:-1.35em}.ui-icon.bg-primary:after{background-color:#0070c0}.ui-icon.bg-info:after{background-color:#324654}.ui-icon.bg-success:after{background-color:#a8c329}.ui-icon.bg-warning:after{background-color:#facb55}.ui-icon.bg-danger:after{background-color:#d7634a}.ui-icon.bg-accent:after{background-color:#ffb000}.ui-icon.bg-dark:after{background-color:#6f6f6e}.ui-icon.bg-light:after{background-color:#f7f7f7}.ui-icon.bg-white:after{background-color:#fff}.item{position:relative}.item .top{top:0}.item .bottom,.item .top{position:absolute;left:0;right:0}.item .bottom{bottom:0}.item .center{top:50%}.item-overlay,.item .center{position:absolute;left:0;right:0}.item-overlay{display:none;top:0;bottom:0}.item-overlay.active,.item:hover .item-overlay{display:block}.list-icon i{transition:font-size .2s;margin-right:16px}.list-icon div{white-space:nowrap;overflow:hidden}.jqstooltip{background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;border-radius:3px;padding:5px 10px!important;box-sizing:content-box}.easyPieChart{position:relative;text-align:center;display:table}.easyPieChart>div{display:table-cell;vertical-align:middle;position:relative;z-index:1;line-height:1}.easyPieChart>div img{margin-top:-4px}.easyPieChart canvas{position:absolute;top:0;left:0;z-index:0}#flotTip,.flotTip{padding:4px 10px;background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;z-index:100;font-size:12px;color:#fff;border-radius:3px}.legendColorBox>div{border:none!important;margin:5px}.legendColorBox>div>div{border-radius:10px}.st-sort-ascent:before{content:\"\\25B2\"}.st-sort-descent:before{content:\"\\25BC\"}.st-selected td{background:#f0f9ec!important}.ui-select-bootstrap>.ui-select-choices{overflow-y:scroll}.panel .dataTables_wrapper{padding-top:10px}.panel .dataTables_wrapper>.row{margin:0}.panel .dataTables_wrapper>.row>.col-sm-12{padding:0}.dataTables_wrapper.form-inline .form-control{width:auto}.btn-info .text-info{color:#fff}.ie .ie-show{display:block}.nav a.waves-effect{-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 0)}.highcharts-title{font-size:14px!important}.highcharts-container p,.highcharts-container svg,.highcharts-container text{font-family:Roboto,sans-serif!important;color:#6f6f6e!important}.highcharts-container a p:hover,.highcharts-container a svg:hover,.highcharts-container a text:hover{color:#ffb000!important}.streamline{position:relative;border-color:#eaeaea}.streamline .sl-item:after,.streamline:after{content:\"\";position:absolute;background-color:#fff;border-color:inherit;border-width:2px;border-style:solid;border-radius:50%;width:11px;height:11px;margin-left:-6px;bottom:0;left:0}.sl-icon{position:absolute;left:-15px;z-index:1}.sl-icon>i{width:30px;height:30px;text-align:center;display:table-cell;vertical-align:middle}.sl-item{border-color:#eaeaea;position:relative;padding-bottom:1px}.sl-item:after,.sl-item:before{content:\" \";display:table}.sl-item:after{clear:both;top:0;bottom:auto}.sl-item.b-l{margin-left:-1px}.sl-item.sl-item-md:after{top:-10px;width:30px;height:30px;margin-left:-16px}.sl-item.sl-item-md .sl-icon{top:-10px}.sl-content{margin-left:24px;margin-top:-6px;padding-bottom:10px}.ui-switch{cursor:pointer;position:relative;display:inline-block;width:32px;height:18px;border-radius:30px;background-color:#a8c329;margin:0}.ui-switch input{position:absolute;opacity:0;filter:alpha(opacity=0)}.ui-switch input:checked+i:before{top:50%;bottom:50%;left:50%;right:5px;border-width:0;border-radius:5px}.ui-switch input:checked+i:after{margin-left:15px}.ui-switch i:before{top:-1px;bottom:-1px;left:-1px;right:-1px;border:1px solid #f0f0f0;border-radius:30px;transition:all .2s}.ui-switch i:after,.ui-switch i:before{content:\"\";position:absolute;background-color:#fff}.ui-switch i:after{width:16px;top:1px;bottom:1px;border-radius:50%;box-shadow:1px 1px 3px rgba(0,0,0,.25);transition:margin-left .3s}.ui-switch-md{width:40px;height:24px}.ui-switch-md input:checked+i:after{margin-left:17px}.ui-switch-md i:after{width:22px}.ui-switch-lg{width:50px;height:30px}.ui-switch-lg input:checked+i:after{margin-left:21px}.ui-switch-lg i:after{width:28px}.timeline{margin:0;padding:0}.tl-item{display:block}.tl-item:after,.tl-item:before{content:\" \";display:table}.tl-item:after{clear:both}.visible-left{display:none}.tl-wrap{display:block;margin-left:6em;padding:15px 0 15px 20px;border-style:solid;border-color:#eaeaea;border-width:0 0 0 2px}.tl-wrap:after,.tl-wrap:before{content:\" \";display:table}.tl-wrap:after{clear:both}.tl-wrap:before{content:\"\";top:15px;margin-left:-26px;width:10px;height:10px;border-color:inherit;border-width:3px;border-radius:50%;border-style:solid;background:#f7f7f7;box-shadow:0 0 0 4px #004374}.tl-date,.tl-wrap:before{position:relative;float:left}.tl-date{top:10px;margin-left:-7.5em;display:block;width:4.5em;text-align:right}.tl-content{display:inline-block;position:relative;padding-top:10px;padding-bottom:10px}.tl-content.block{display:block;width:100%}.tl-content.panel{margin-bottom:0}.tl-header{display:block;width:12em;text-align:center;margin-left:1px}.timeline-center .tl-item{margin-left:50%}.timeline-center .tl-item .tl-wrap{margin-left:-2px}.timeline-center .tl-header{width:auto;margin-left:-1px}.timeline-center .tl-left{margin-left:0;margin-right:50%}.timeline-center .tl-left .hidden-left{display:none!important}.timeline-center .tl-left .visible-left{display:inherit}.timeline-center .tl-left .tl-wrap{float:right;margin-right:0;border-left-width:0;border-right-width:2px;padding-left:0;padding-right:20px}.timeline-center .tl-left .tl-wrap:before{float:right;margin-left:0;margin-right:-26px}.timeline-center .tl-left .tl-date{float:right;margin-left:0;margin-right:-8.5em;text-align:left}.content-circules{display:block;float:left;position:relative;margin:0;padding:8px;box-sizing:border-box;height:200px;width:131px}.content-circules:before{position:absolute;content:\"\";border-right:2px solid #ccd0db;top:0;bottom:0;left:49%;z-index:-1px}.content-circules .big-circule{position:relative;display:block;margin:38px;height:120px;width:120px;border:6px solid #aace3b;border-radius:50%;box-sizing:border-box;padding:0}.content-circules .big-circule:before{content:\"\";position:absolute;height:2px;width:70px;background-color:#aace3b;top:49%;left:100%}.content-circules .big-circule:after{content:\"\";position:absolute;height:16px;width:16px;border-radius:50%;background:#aace3b;top:42%;left:170%}.content-circules .big-circule .middle-circule{position:relative;display:block;border-radius:50%;border:4px solid #ccd0db;margin:15px;width:78px;height:78px;box-sizing:border-box;padding:0}.content-circules .big-circule .middle-circule .small-circule{position:relative;display:inline-block;box-sizing:border-box;border-radius:50%;background:linear-gradient(#aace3b,#fab813);margin:15px;height:40px;width:40px;padding:0}.small.content-circules{display:block;float:left;position:relative;margin:0;padding:8px;box-sizing:border-box;height:200px;width:131px}.small.content-circules:before{position:absolute;content:\"\";border-right:2px solid #ccd0db;top:0;bottom:0;left:49%;z-index:-1px}.small.content-circules .big-circule{position:relative;display:block;margin:62px 38px;height:40px;width:40px;border:6px solid #aace3b;border-radius:50%;box-sizing:border-box;padding:0}.small.content-circules .big-circule:before{content:\"\";position:absolute;height:2px;width:17px;background-color:#aace3b;top:49%;left:158%}.small.content-circules .big-circule:after{content:\"\";position:absolute;height:6px;width:6px;border-radius:50%;background:#aace3b;top:42%;left:215%}.small.content-circules .big-circule .middle-circule{position:relative;display:block;border-radius:50%;border:4px solid #ccd0db;margin:-19px;width:67px;height:67px;box-sizing:border-box;padding:0}.small.content-circules .big-circule .middle-circule .small-circule{position:relative;display:inline-block;box-sizing:border-box;border-radius:50%;background:linear-gradient(#aace3b,#fab813);margin:21px;height:15px;width:15px;padding:0}.item-time-line p{display:inline-block;width:46%;float:right;height:auto;overflow:hidden;font-size:12px;position:relative;top:56px;left:-13px}.item-time-line p span{font-size:20px;color:#aace3b;display:block}.block-p{display:block;width:100%;text-align:right}.morado-theme.content-circules .big-circule{border-color:#7e57c2}.morado-theme.content-circules .big-circule:before{background-color:#7e57c2}.morado-theme.content-circules .big-circule:after{background:#7e57c2}.morado-theme.content-circules .big-circule .middle-circule .small-circule{background:linear-gradient(#7e57c2,#2053d2)}.morado-theme.item-time-line p span{color:#7e57c2}.azul-theme.content-circules .big-circule{border-color:#2053d2}.azul-theme.content-circules .big-circule:before{background-color:#2053d2}.azul-theme.content-circules .big-circule:after{background:#2053d2}.azul-theme.content-circules .big-circule .middle-circule .small-circule{background:linear-gradient(#2053d2,#468ac2)}.azul-theme.item-time-line p span{color:#2053d2}@media (max-width:1500px){.item-time-line p{display:inline-block;width:29%;float:right;height:auto;overflow:hidden;font-size:12px;position:relative;top:33px;left:-13px}}@media (max-width:1299px){.small.content-circules{display:none}.item-time-line p{display:block;width:100%;float:left;height:auto;overflow:hidden;font-size:12px;position:relative;top:43px;left:0;text-align:center}}ol.timeline{display:flex;list-style:none;padding:0;margin:0 34px 40px}ol.timeline li{flex-grow:1}ol.timeline li .item{display:flex;align-items:center}ol.timeline li:last-of-type,ol.timeline li:last-of-type .line{flex-grow:0}ol.timeline .circle{height:30px;width:30px;border-radius:100%;border:6px solid #a4a4a4;background-color:#fff;margin:0}ol.timeline .circle.green{border:6px solid #04b404}ol.timeline .line{height:5px;flex-grow:1;background-color:hsla(0,0%,100%,.6)}ol.timeline .line.green{background-color:#04b404}ol.timeline .label-item{width:100px;position:relative;top:30px;right:40px;text-align:center;color:#fff}@media (max-width:768px){li .item,ol.timeline{flex-direction:column}ol.timeline{padding:0 0 10px}}.pvtAxisContainer{background:hsla(0,0%,100%,.34);border:1px solid #e5e9ec;min-height:20px;min-width:20px;padding:10px}.pvtAxisContainer li span.pvtAttr{-moz-box-shadow:0 5px 10px -3px rgba(0,0,0,.15);-webkit-box-shadow:0 5px 10px -3px rgba(0,0,0,.15);-webkit-text-size-adjust:100%;background:#4caf50;border-radius:4px;border:1px solid #45a749;box-shadow:0 5px 10px -3px rgba(0,0,0,.15);color:#fff;padding:7px 10px;white-space:nowrap}.pvtUi button,.pvtUi input,.pvtUi select,.pvtUi textarea{border:1px solid #e3e3e7;box-sizing:border-box;font-family:inherit;font-size:inherit;line-height:inherit;margin:5px;padding:5px}.pvtVals{background:hsla(0,0%,100%,.34);border:1px solid #e5e9ec;min-height:20px;min-width:20px;padding:10px}.pvtRendererArea{padding:15px}table.pvtTable tr td{background-color:transparent;border:1px solid #d9dde1;color:#252525;padding:15px;text-align:center;vertical-align:middle}table.pvtTable tr th{background-color:#00548a;border:1px solid #5489ab;color:#fff;font-size:9pt;font-weight:300;padding:8px 10px}table.pvtTable tr:nth-child(odd){background-color:rgba(66,139,202,.1)}table.pvtTable tr:hover{background-color:rgba(66,139,202,.35)}.pvtTriangle{color:#fff;cursor:pointer;font-size:17pt;vertical-align:middle}.pivot-box{background-color:#fff;border-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.05);box-sizing:border-box;display:block;float:left;height:auto;margin-bottom:25px;min-width:100%;overflow:visible;padding:15px}.cursor-pointer{cursor:pointer}.carousel_element_text{font-size:46px;color:rgba(0,0,0,.35);text-shadow:0 1px rgba(40,46,49,0);font-weight:300}.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}#form-simular .form-group{margin-bottom:0}#form-simular label{text-transform:uppercase;color:#758295;font-size:13px;font-weight:700;display:inline-block}#form-simular input,#form-simular select{width:30%;display:inline-block;margin:0 1%}.slick-list{width:100%;text-align:center;margin:0 auto}body .slick-prev{left:-1px;z-index:5}body .slick-next{right:1px}.nav-bg{cursor:pointer}.nav-bg li{text-align:center}.nav-bg li a,.nav-bg li div{padding:20px}.nav-bg li.active{background:#7e57c2;color:#fff}.nav-bg li.active:after{top:100%;left:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-color:hsla(0,57%,61%,0);border-top-color:#7e57c2;border-width:12px;margin-left:-12px;z-index:1}.nav-bg li.active .badge{background:#aace3b}.slick-selected{background-color:#7e57c2;color:#fff;background-image:url(" + __webpack_require__(1541) + ");background-repeat:no-repeat;background-size:contain;background-position:50%;font-weight:700}.demandPlan{font-size:20px;text-align:center;padding-bottom:0;font-weight:700}.planName{font-weight:400;text-align:center;padding-top:0}@font-face{font-family:Material-Design-Icons;font-weight:400;font-style:normal;src:url(\"/assets/fonts/Material-Design-Icons.eot?-g7cqhn\");src:url(\"/assets/fonts/Material-Design-Icons.eot?#iefix-g7cqhn\") format(\"embedded-opentype\"),url(\"/assets/fonts/Material-Design-Icons.woff?-g7cqhn\") format(\"woff\"),url(\"/assets/fonts/Material-Design-Icons.ttf?-g7cqhn\") format(\"truetype\"),url(\"/assets/fonts/Material-Design-Icons.svg?-g7cqhn#Material-Design-Icons\") format(\"svg\")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:Material-Design-Icons;font-size:20px;line-height:1;opacity:.75;color:grey;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:\"\\E836\"}[dir=rtl] .slick-prev:before{content:\"\\E837\"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:\"\\E837\"}[dir=rtl] .slick-next:before{content:\"\\E836\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}.footable>tfoot .pagination{margin:10px 0!important}#ahoraPuedes-card{position:fixed;bottom:-12px;right:0;display:block;width:100%;z-index:4;text-align:center;box-sizing:border-box;box-shadow:0 0 10px 0 rgba(0,0,0,.15)}#ahoraPuedes-card h4{display:inline-block;color:#000;font-size:14px;margin-right:20px}#ahoraPuedes-card span{margin:0 10px;font-size:13px;position:relative;bottom:-5px;display:inline-block;overflow:hidden}#ahoraPuedes-card span i{margin-right:5px;font-size:20px;position:relative;top:4px}.title-prog h1,.title-prog h2,.title-prog h3,.title-prog h4,.title-prog h5,.title-prog h6{font-size:21px;color:#2053d2;margin-top:0}.c-cantidad ul{list-style:none;margin-bottom:0;-webkit-padding-start:0}.c-cantidad a{color:#468ac2;text-decoration:none;display:inline-block}.c-detalleProg .panel-body{padding-top:10px}.c-detalleProg .panel-body h3{margin-top:0;font-size:16px}.c-detalleProg .panel-body ul{list-style:none;color:#758295;-webkit-padding-start:0}.c-detalleProg .panel-footer{background-color:rgba(70,138,194,.2);padding:5px 15px}.c-detalleProg .panel-footer h5,.c-detalleProg .panel-footer p{display:block;text-align:center}.c-detalleProg .panel-footer p{color:#468ac2;font-size:25px;margin-bottom:0;font-weight:300}.c-detalleProg .panel-footer h5{color:#758295;font-size:14px;margin-top:0}.lista-prog{list-style:none;-webkit-padding-start:0;height:70vh;display:block;overflow:hidden;overflow-y:scroll}.lista-prog li{border-bottom:1px solid grey;position:relative;width:100%;display:block;overflow:hidden;float:left;min-height:70px;height:120px;max-height:180px}.lista-prog li:hover{border-bottom:1px solid #468ac2}.lista-prog li a{position:absolute;width:100%;height:100%;background-color:transparent;color:#6f6f6e;transition:all .5s ease;top:0;left:0;right:0;padding:15px 5px}.lista-prog li a.active,.lista-prog li a:active,.lista-prog li a:hover{background-color:#468ac2;color:#fff}.lista-prog li a span{display:block;font-size:11px}.lista-items-menu{list-style:none;-webkit-padding-start:0;height:70vh;display:block;overflow:hidden;overflow-y:scroll}.lista-items-menu li{border-bottom:1px solid grey;position:relative;width:100%;display:block;overflow:hidden;float:left;height:90px}.lista-items-menu li:hover{border-bottom:1px solid #468ac2}.lista-items-menu li a{position:absolute;width:100%;height:100%;background-color:transparent;color:#6f6f6e;transition:all .5s ease;top:0;left:0;right:0;padding:15px 5px}.lista-items-menu li a.active,.lista-items-menu li a:active,.lista-items-menu li a:hover{background-color:#468ac2;color:#fff}.lista-items-menu li a span{display:block;font-size:11px}.scroll-50vh{overflow:hidden;overflow-y:scroll;height:50vh}.tile{padding:5px}.half-jornada{display:inline-block;float:left;width:50%;box-sizing:border-box;overflow:hidden}.detSim .card-body{padding:5px 24px}.detSim h4{font-size:12px;text-transform:uppercase;font-weight:700}.detSim hr{border-top:1px solid rgba(204,208,219,.5);margin:0}.filtros-carreras{width:100%!important}.filtros-carreras select{width:20%}.filtros-materias{width:100%!important}.filtros-materias select{width:17%}.form-inline .control-label{margin-right:10px}.btn-group>.popover+.btn,.btn-group>.tooltip+.btn{margin-left:-1px}.btn-group>.btn:last-of-type{-moz-border-top-right-radius:3px!important;border-top-right-radius:3px!important;-moz-border-bottom-right-radius:3px!important;border-bottom-right-radius:3px!important}.loading{padding-top:60px;padding-bottom:60px;margin-bottom:15px;background-color:#f0f0f4;height:200px;overflow:hidden}.show-loader{display:block!important}.arrow-right{width:0;height:0;border-top:15px solid transparent;border-bottom:15px solid transparent;border-left:15px solid #aace3b;display:inline-block;position:absolute;top:56px}.c-resumen-config{height:108px}.week-box{width:100%;overflow:hidden;height:160px;padding:10px;box-sizing:border-box;border:1px solid hsla(0,0%,80%,.46)}.md-select-value>span:not(.md-select-icon) .md-text,.week-box{display:block}.loader{border:8px solid #f3f3f3;border-radius:50%;border-top:8px solid #3498db;width:40px;height:40px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.popover.top>.arrow:after{border-top-color:#2053d2!important}.popover.left>.arrow:after{border-left-color:#2053d2!important}.popover.right>.arrow:after{border-right-color:#2053d2!important}.popover.bottom>.arrow:after{border-bottom-color:#2053d2!important}.popover{color:#fff;font-size:10px;background-color:#2053d2!important;border:1px solid #2053d2!important}.bg-white{background-color:#fff}.bg-light{background-color:#f7f7f7}.bg-light.lt{background-color:#fff!important}.bg-light .lt{background-color:#fff}.bg-light.dk{background-color:#ebe9e9!important}.bg-light .dk{background-color:#ebe9e9}.bg-light.bg{background-color:#f7f7f7!important}.bg-light .bg{background-color:#f7f7f7}.bg-dark{color:hsla(0,0%,100%,.87);background-color:#6f6f6e}.bg-dark.lt{background-color:#7b7b7b!important}.bg-dark .lt{background-color:#7b7b7b}.bg-dark.dk{background-color:#67675c!important}.bg-dark .dk{background-color:#67675c}.bg-dark.bg{background-color:#6f6f6e!important}.bg-dark .bg{background-color:#6f6f6e}.bg-primary{color:hsla(0,0%,100%,.87);background-color:#0070c0}.bg-primary.lt{background-color:#057ed4!important}.bg-primary .lt{background-color:#057ed4}.bg-primary.dk{background-color:#0061a7!important}.bg-primary .dk{background-color:#0061a7}.bg-primary.bg{background-color:#0070c0!important}.bg-primary .bg{background-color:#0070c0}.bg-success{color:hsla(0,0%,100%,.87);background-color:#a8c329}.bg-success.lt{background-color:#b3ce38!important}.bg-success .lt{background-color:#b3ce38}.bg-success.dk{background-color:#99b31f!important}.bg-success .dk{background-color:#99b31f}.bg-success.bg{background-color:#a8c329!important}.bg-success .bg{background-color:#a8c329}.bg-info{color:hsla(0,0%,100%,.87);background-color:#324654}.bg-info.lt{background-color:#405360!important}.bg-info .lt{background-color:#405360}.bg-info.dk{background-color:#263947!important}.bg-info .dk{background-color:#263947}.bg-info.bg{background-color:#324654!important}.bg-info .bg{background-color:#324654}.bg-warning{color:hsla(0,0%,100%,.87);background-color:#facb55}.bg-warning.lt{background-color:#f7d172!important}.bg-warning .lt{background-color:#f7d172}.bg-warning.dk{background-color:#fec637!important}.bg-warning .dk{background-color:#fec637}.bg-warning.bg{background-color:#facb55!important}.bg-warning .bg{background-color:#facb55}.bg-danger{color:hsla(0,0%,100%,.87);background-color:#d7634a}.bg-danger.lt{background-color:#d77864!important}.bg-danger .lt{background-color:#d77864}.bg-danger.dk{background-color:#d94d2f!important}.bg-danger .dk{background-color:#d94d2f}.bg-danger.bg{background-color:#d7634a!important}.bg-danger .bg{background-color:#d7634a}.bg-accent{color:hsla(0,0%,100%,.87);background-color:#ffb000}.bg-accent.lt{background-color:#f9b61f!important}.bg-accent .lt{background-color:#f9b61f}.bg-accent.dk{background-color:#e69e00!important}.bg-accent .dk{background-color:#e69e00}.bg-accent.bg{background-color:#ffb000!important}.bg-accent .bg{background-color:#ffb000}a.bg-primary:hover{background-color:#0061a7}a.text-primary:hover{color:#0061a7}.text-primary{color:#0070c0}.text-primary-lt{color:#007fda}.text-primary-dk{color:#0061a7}a.bg-info:hover{background-color:#283944}a.text-info:hover{color:#283944}.text-info{color:#324654}.text-info-lt{color:#3c5364}.text-info-dk{color:#283944}a.bg-success:hover{background-color:#96ae25}a.text-success:hover{color:#96ae25}.text-success{color:#a8c329}.text-success-lt{color:#b7d432}.text-success-dk{color:#96ae25}a.bg-warning:hover{background-color:#f9c33c}a.text-warning:hover{color:#f9c33c}.text-warning{color:#facb55}.text-warning-lt{color:#fbd36e}.text-warning-dk{color:#f9c33c}a.bg-danger:hover{background-color:#d25135}a.text-danger:hover{color:#d25135}.text-danger{color:#d7634a}.text-danger-lt{color:#dc755f}.text-danger-dk{color:#d25135}a.bg-accent:hover{background-color:#e69e00}a.text-accent:hover{color:#e69e00}.text-accent{color:#ffb000}.text-accent-lt{color:#ffb81a}.text-accent-dk{color:#e69e00}a.bg-dark:hover{background-color:#626261}a.text-dark:hover{color:#626261}.text-dark{color:#6f6f6e}.text-dark-lt{color:#7c7c7b}.text-dark-dk{color:#626261}.text-white{color:#fff}.text-white-lt{color:hsla(0,0%,100%,.54)}.text-white-dk{color:hsla(0,0%,100%,.87)}.text-black{color:#000}.text-black-lt{color:rgba(0,0,0,.54)}.text-black-dk{color:rgba(0,0,0,.87)}.text-muted{color:inherit;opacity:.75}.text-muted-dk{color:inherit;opacity:.5}.text-muted-lt{color:inherit;opacity:.25}.text-color{color:#494948}.bg-big:before{content:\"\";position:absolute;width:100%;top:0;bottom:0;z-index:-1;background-color:inherit;border:inherit}.bg-white-overlay{background-color:hsla(0,0%,100%,.8)}.bg-black-overlay{background-color:rgba(32,43,54,.8)}.no-bg{background-color:transparent;color:inherit}@media (min-width:768px){.bg-auto:before{content:\"\";position:absolute;width:inherit;top:0;bottom:0;z-index:-1;background-color:inherit;border:inherit}.bg-auto.b-l:before{margin-left:-1px}.bg-auto.b-r:before{margin-right:-1px}}.ui-grid{border:0 solid #91a3bd}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button>i{color:#fff}.ui-grid-scrollbar-placeholder{background-color:transparent}.ui-grid-cell:not(:last-child) .ui-grid-vertical-bar,.ui-grid-header-cell:last-child .ui-grid-vertical-bar,.ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{background-color:#91a3bd}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:last-child{border-right-color:#4c87ad}.ui-grid-top-panel-background{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0)}.ui-grid-column-menu-button-last-col{margin-right:2px!important}input[type=text].ui-grid-filter-input{padding:0;margin:0;border:0;width:100%;padding:2px 5px;border-radius:3px!important;border:0 solid #91a3bd;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}select.ui-grid-filter-select{border:0 solid #91a3bd;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0}select.ui-grid-filter-select:hover{border:0 solid #91a3bd}.ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:#fff}.ui-grid-row:nth-child(2n) .ui-grid-cell{background-color:rgba(76,135,173,.13)}.ui-grid-row:last-child .ui-grid-cell{border-bottom-color:#91a3bd;border-bottom-style:solid}.ui-grid-no-row-overlay{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0);-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box;border:0 solid #91a3bd;font-size:2em;text-align:center}.ui-grid-no-row-overlay>*{position:absolute;display:table;margin:auto 0;width:100%;top:0;bottom:0;left:0;right:0;opacity:.66}.ui-grid-cell{background-color:inherit;border-right:0 solid;border-color:#91a3bd}.ui-grid-cell:last-child{border-right:0}.ui-grid-cell-contents-hidden{visibility:hidden;width:0;height:0;display:none}.ui-grid-row .ui-grid-cell.ui-grid-row-header-cell{background-color:#e8eff4;border-bottom:0 solid #e8eff4}.ui-grid-footer-panel,.ui-grid-footer-panel-background{background:#91a3bd;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0)}.ui-grid-footer-panel{position:relative;border-bottom:1px solid #91a3bd;border-top:1px solid #91a3bd;overflow:hidden;font-weight:700;-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}.ui-grid-footer-cell{background-color:inherit;border-right:0 solid;border-color:#91a3bd}input[type=text].ui-grid-filter-input{background:hsla(0,0%,100%,.3)}input[type=text].ui-grid-filter-input:hover{border:0 solid #91a3bd}.ui-grid-menu-button{cursor:pointer;color:#fff}.ui-grid-menu-button,.ui-grid-menu .ui-grid-menu-inner{background:#4c87ad;border:0 solid #4c87ad}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{color:#333;text-decoration:none}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled],fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled,fieldset[disabled] a.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button{pointer-events:none}.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{color:transparent;background-color:transparent;border-color:transparent}.open>.dropdown-toggle.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.active,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:active{background-image:none}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled.focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.disabled:hover,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled].focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled]:focus,.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button[disabled]:hover,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button.focus,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:focus,fieldset[disabled] .ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button:hover{background-color:transparent;border-color:transparent}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button .badge{color:transparent;background-color:transparent}.ui-grid-menu .ui-grid-menu-inner .ui-grid-menu-close-button>i{opacity:.75;color:#000}.ui-grid-menu .ui-grid-menu-inner ul{margin:0;padding:0;list-style-type:none}.ui-grid-menu .ui-grid-menu-inner ul li{padding:0}.ui-grid-menu .ui-grid-menu-inner ul li button{min-width:100%;padding:8px;text-align:left;background:transparent;border:none}.ui-grid-menu .ui-grid-menu-inner ul li button:focus,.ui-grid-menu .ui-grid-menu-inner ul li button:hover{box-shadow:inset 0 0 14px rgba(0,0,0,.12)}.ui-grid-menu .ui-grid-menu-inner ul li button.ui-grid-menu-item-active{box-shadow:inset 0 0 14px rgba(0,0,0,.12);background-color:#4c87ad}.ui-grid-menu .ui-grid-menu-inner ul li:not(:last-child)>button{border-bottom:0 solid #91a3bd}.ui-grid-sortarrow{right:5px;position:absolute;width:20px;top:0;bottom:0;background-position:50%}.ui-grid-sortarrow.down{transform:rotate(180deg)}[class*=\" ui-grid-icon\"]:before,[class^=ui-grid-icon]:before{font-family:ui-grid;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em}.ui-grid-icon-blank:before{width:1em;content:\" \"}.ui-grid[dir=rtl] .ui-grid-cell,.ui-grid[dir=rtl] .ui-grid-footer-cell,.ui-grid[dir=rtl] .ui-grid-header-cell{float:right!important}.ui-grid[dir=rtl] .ui-grid-column-menu-button{position:absolute;left:1px;top:0;right:inherit}.ui-grid[dir=rtl] .ui-grid-cell:first-child,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child{border-right:0}.ui-grid[dir=rtl] .ui-grid-cell:last-child,.ui-grid[dir=rtl] .ui-grid-header-cell:last-child{border-right:0 solid #e8eff4;border-left:0}.ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-cell:last-child{box-sizing:border-box;border-right:1px solid;border-width:1px;border-right-color:#e8eff4}.ui-grid[dir=rtl] .ui-grid-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-footer-cell:first-child .ui-grid-vertical-bar,.ui-grid[dir=rtl] .ui-grid-header-cell:first-child .ui-grid-vertical-bar{width:0}.ui-grid[dir=rtl] .ui-grid-menu-button{z-index:2;position:absolute;left:0;right:auto;background:#91a3bd;border:0 solid #91a3bd;cursor:pointer;min-height:27px;font-weight:400}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button,.ui-grid[dir=rtl] .ui-grid-menu-button .ui-grid-menu{left:0;right:auto}.ui-grid[dir=rtl] .ui-grid-filter-container .ui-grid-filter-button [class^=ui-grid-icon]{right:auto;left:10px}.ui-grid-animate-spin{animation:ui-grid-spin 2s infinite linear;display:inline-block}@keyframes ui-grid-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.light-table .ui-grid-header-cell{position:relative;box-sizing:border-box;background-color:#dcdfef;border-right:1px solid;border-color:#c5cae4;display:table-cell;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:0;color:#333}.light-table .ui-grid-top-panel{position:relative;overflow:hidden;font-weight:700;background-color:#dcdfef}.ui-grid-header{border-bottom:1px solid #c5cae4;box-sizing:border-box}select.ui-grid-filter-select{padding:0;margin:0;border:0;background:hsla(0,0%,100%,.3);padding:5px;border:0 solid #a7abae;background-clip:padding-box;border-radius:3px!important}select.ui-grid-filter-select option{color:#758295}.t-h40 md-switch{margin:0;height:auto}.t-h40 .ui-grid-cell-contents{height:40px}.fc-toolbar h2{color:#468ac2;font-size:18px}.fc-unthemed .fc-divider,.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}td.fc-time,th.fc-day-header{color:#758295}.fc-time-grid .fc-slats td{height:3.5em;border-bottom:0}.fc-state-default{background-color:#fff;background-image:none;background-repeat:repeat-x;border-color:#e6e6e6 #e6e6e6 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#91a3bd;text-shadow:0 1px 1px hsla(0,0%,100%,.75);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05)}.bg-green-web-planner{background:#aace3b}.bg-green-web-planner,.bg-purple-web-planner{border:1px solid #fff;float:left;width:100%;color:#fff;font-size:10px;opacity:.95}.bg-purple-web-planner{background:#6a0888}.tooltip-inner{max-width:500px!important}.werapper_button md-radio-button{display:inline-block;font-size:11px}.hh{width:95%}.u-select-overflow-hide{overflow:hidden}.u-btn-align-label{margin-top:25px}md-input-container{width:100%}body .cal-day-box .cal-day-hour-part .cal-day-hour-part-time{width:20px}.headersidebar{padding-right:0}.headersidebar h5{font-size:12px}mwl-calendar .cal-row-fluid:hover,mwl-calendar [class*=cal-cell]:hover{background-color:#2053d2}.cal-week-box [data-event-class]{white-space:normal!important;height:30px;padding-top:0!important;margin-top:0!important;margin-bottom:0!important;font-size:12px;padding:0 3px!important;line-height:18px;text-align:center;display:flex;align-items:center;border-radius:6px!important;border:1px solid #fff}.capitalize{text-transform:capitalize}.f-none{float:none}.prog.nav-tabs{overflow-x:auto;overflow-y:hidden;display:-webkit-box;display:-moz-box}.prog.nav-tabs>li{float:none}.effect-highlight-purple{transition:all .5s ease}.effect-highlight-purple:hover{background-color:#7e57c2;color:#fff;width:100%;border-radius:3px}.effect-highlight-purple:hover .yellow-hover-icon,.yellow-hover-icon:hover{color:#ff0}.effect-highlight-purple--active{background-color:#7e57c2;color:#fff;width:100%;border-radius:3px}.effect-highlight-purple--active .yellow-hover-icon{color:#ff0}.list-h{display:block;overflow:hidden;padding-left:0}.list-h li{display:inline-block;padding:5px;padding-left:0;padding-right:25px}.list-h li span{color:#468ac2}.tabla-horarios td{border-right:1px solid #e7e8ea;border-bottom:1px solid #e7e8ea}.red-text-table{color:#ef7955}.gris-text-table,.red-text-table{font-weight:700;pointer-events:none}.gris-text-table{color:#787878}.amarillo-text-table{color:#fc0;font-weight:700;cursor:pointer}.green-text-table{color:#aace3b;font-weight:700;pointer-events:none}.visibility{pointer-events:none;cursor:default;text-decoration:none;color:#999}.select2-container{width:100%}.date-picker{width:100%;height:34px;padding-left:5px}.editable-wrap{display:inline-block;white-space:nowrap;margin:0;width:100%}.disabled-style{-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%);-ms-filter:grayscale(100%);-o-filter:grayscale(100%);cursor:not-allowed}.scroll-55vh{height:55vh!important}.scroll-55vh,.scroll-60vh{overflow:hidden;overflow-y:scroll}.scroll-60vh{height:60vh!important}.scroll-65vh{height:65vh!important}.scroll-65vh,.scroll-70vh{overflow:hidden;overflow-y:scroll}.scroll-70vh{height:70vh!important}.scroll-75vh{height:75vh!important}.scroll-75vh,.scroll-80vh{overflow:hidden;overflow-y:scroll}.scroll-80vh{height:80vh!important}.fc-event .fc-content{height:100%}.postit{line-height:1;text-align:center;width:275px;margin:25px;min-height:250px;max-height:250px;position:relative;border:1px solid #e8e8e8;font-size:22px;border-bottom-right-radius:60px 5px;display:inline-block}.postit:after{content:\"\";position:absolute;z-index:-1;right:0;bottom:20px;width:200px;height:25px;background:rgba(0,0,0,.2);box-shadow:2px 15px 5px rgba(0,0,0,.4);transform:matrix(-1,-.1,0,1,0,0)}.yellow{border-top:60px solid #fdfd86;background:#ff8}.purple{border-top:60px solid #9b7cd0;background:#9b7cd0}.red{border-top:60px solid #df826e;background:#df826e}.rotate-3{transform:rotate(-3deg);-webkit-transform:rotate(-3deg);-moz-transform:rotate(-3deg);-o-transform:rotate(-3deg)}.icon-bg{background-image:url(" + __webpack_require__(1542) + ");background-repeat:no-repeat;background-size:initial;background-position:100% 100%}.chevrons{font-family:Material-Design-Icons}.chevrons :after{content:\"\\E89D\"}.chevrons :after,.chevrons :before{display:block;position:absolute;top:50%;right:0;width:10px;height:1px;background-color:#2196f3;transform-origin:50% 50%;will-change:transform;transition:all .25s}.chevrons :before{content:\"\\E89E\"}.panel-heading .accordion-toggle:after{font-family:Material-Design-Icons;content:\"\\E89D\";float:right;color:grey;font-size:24px}.panel-heading .accordion-toggle.collapsed:after{content:\"\\E89E\"}.fade-in-out{transition:all 1s linear;opacity:1}.fade-in-out.ng-hide{opacity:0}.hh{position:absolute;z-index:99999;bottom:0;width:93%}.hover-morado:hover{background-color:#7e57c2;color:#fff}.brd-md,.brd-xl{border-radius:3px}.control-label{margin-top:5px;font-weight:500;font-size:14px}.b-success{border-color:#aace3b!important}.list-horizontal{padding-left:0;list-style:none}.list-vert-trans{list-style:none;-webkit-padding-start:0;height:75vh;overflow-y:auto}.list-vert-trans li{padding:16px 5px;cursor:pointer;background:transparent;transition:all .5s ease;border-left:3px solid transparent;border-bottom:1px solid hsla(0,0%,100%,.2)}.list-vert-trans li:hover{padding:18px 5px;cursor:pointer;background:rgba(0,0,0,.15);border-left:3px solid #468ac2}.list-vert-trans li.active i,.list-vert-trans li:hover i{color:#468ac2}.list-vert-trans li.active{padding:18px 5px;cursor:pointer;border-left:3px solid transparent;background:rgba(0,0,0,.15);font-weight:500}.list-vert-trans li p{padding-left:10px;margin-bottom:0;display:inline-block}.list-vert-trans li p:first-letter{text-transform:capitalize}.no-rows{position:absolute;top:0;bottom:0;width:100%;background:rgba(0,0,0,.4)}.no-rows .msg{position:absolute;top:20%;left:20%;width:60%;height:50%;line-height:200%;background-color:transparent;border:0;text-align:center;font-size:24px;display:table;color:#fff}.no-rows .msg span{display:table-cell;vertical-align:middle}.dpl-b,.w-100{display:block}.w-100{width:100%;overflow:hidden}.text-editable{color:#758295}.pos-rlt{position:relative;z-index:1}.pos-abt{position:absolute}.pos-fix{position:fixed!important}.pos-stc{position:static!important}.block{display:block}.block.hide{display:none}.flex{display:flex}.align-self-end{align-self:flex-end}.align-items-center{align-items:center}.flex-direction-column{flex-direction:column}.flex-wrap-wrap{flex-wrap:wrap}.pull-none{float:none}.inline{display:inline-block}.inline-16{width:16px;height:16px}.inline-24{width:24px;height:24px}.active>.auto .inline,.active>.inline,.none{display:none}.active>.auto .none,.active>.none{display:inline-block}.line{height:1px;margin:10px 0;font-size:0;overflow:hidden}.line-dashed{border-style:dashed!important;background-color:transparent;border-width:0}.pointer{cursor:pointer}.circle,.rounded{border-radius:500px}.clear{display:block;overflow:hidden}.align_center{display:block;margin:auto}.align-calendars{margin-left:-18px}.flex-center{display:flex;align-items:center}.no-border{border-color:transparent;border-width:0}.no-borders{border-width:0!important}.b{border-color:hsla(210,4%,45%,.15)!important}.b-a{border:1px solid #eaeaea}.b-t{border-top:1px solid #eaeaea}.b-r{border-right:1px solid #eaeaea}.b-b{border-bottom:1px solid #eaeaea}.b-l{border-left:1px solid #eaeaea}.b-2x{border-width:2px}.b-3x{border-width:3px}.b-4x{border-width:4px}.b-5x{border-width:5px}.b-t-2x{border-top-width:2px!important}.b-t-3x{border-top-width:3px!important}.b-t-4x{border-top-width:4px!important}.b-t-5x{border-top-width:5px!important}.b-r-2x{border-right-width:2px!important}.b-r-3x{border-right-width:3px!important}.b-r-4x{border-right-width:4px!important}.b-r-5x{border-right-width:5px!important}.b-b-2x{border-bottom-width:2px!important}.b-b-3x{border-bottom-width:3px!important}.b-b-4x{border-bottom-width:4px!important}.b-b-5x{border-bottom-width:5px!important}.b-l-2x{border-left-width:2px!important}.b-l-3x{border-left-width:3px!important}.b-l-4x{border-left-width:4px!important}.b-l-5x{border-left-width:5px!important}.b-light{border-color:#f7f7f7}.b-white{border-color:#fff}.b-primary{border-color:#0070c0}.b-t-primary{border-top-color:#0070c0}.b-r-primary{border-right-color:#0070c0}.b-b-primary{border-bottom-color:#0070c0}.b-l-primary{border-left-color:#0070c0}.b-info{border-color:#324654}.b-t-info{border-top-color:#324654}.b-r-info{border-right-color:#324654}.b-b-info{border-bottom-color:#324654}.b-l-info{border-left-color:#324654}.b-success{border-color:#a8c329}.b-t-success{border-top-color:#a8c329}.b-r-success{border-right-color:#a8c329}.b-b-success{border-bottom-color:#a8c329}.b-l-success{border-left-color:#a8c329}.b-warning{border-color:#facb55}.b-t-warning{border-top-color:#facb55}.b-r-warning{border-right-color:#facb55}.b-b-warning{border-bottom-color:#facb55}.b-l-warning{border-left-color:#facb55}.b-danger{border-color:#d7634a}.b-t-danger{border-top-color:#d7634a}.b-r-danger{border-right-color:#d7634a}.b-b-danger{border-bottom-color:#d7634a}.b-l-danger{border-left-color:#d7634a}.b-accent{border-color:#ffb000}.b-t-accent{border-top-color:#ffb000}.b-r-accent{border-right-color:#ffb000}.b-b-accent{border-bottom-color:#ffb000}.b-l-accent{border-left-color:#ffb000}.b-dark{border-color:#6f6f6e}.b-t-dark{border-top-color:#6f6f6e}.b-r-dark{border-right-color:#6f6f6e}.b-b-dark{border-bottom-color:#6f6f6e}.b-l-dark{border-left-color:#6f6f6e}.no-b-t{border-top-width:0}.no-b-r{border-right-width:0}.no-b-b{border-bottom-width:0}.no-b-l{border-left-width:0}.b-dashed{border-style:dashed!important}.border-radio-left{border-radius:200px 0 10px 200px}@media (max-width:991px){.no-border-sm{border-width:0}}@media (max-width:767px){.no-border-xs{border-width:0}}.b-b-azul{border:2px solid #2053d2;border-bottom:2px solid #2053d2}.b-b-azul-light{border-bottom:2px solid #468ac2}.b-b-amarillo{border-bottom:2px solid #fab813}.b-b-verde{border-bottom:2px solid #aace3b}.b-b-gris-dark{border-bottom:2px solid #91a3bd}.b-t-gris-light{border-top:1px solid #ccd0db}.b-b-gris-darker{border-bottom:2px solid #758295}.b-b-rojo{border-bottom:2px solid #ef7955}.b-b-morado{border-bottom:2px solid #7e57c2}.b-b-blanco{border-bottom:2px solid #fff}.b-b-gris-lighter{border-bottom:2px solid #f2f5f7}.b-b-negro-darker{border-bottom:2px solid #2d3039}.b-r-gris-light{border-right:1px solid #ccd0db}.b-l-gris-light{border-left:1px solid #ccd0db}.b-b-gris-light{border-bottom:1px solid #ccd0db}.hover-action{display:none}.hover-rotate{transition:all .2s ease-in-out .1s}.hover-anchor:active .hover-action,.hover-anchor:focus .hover-action,.hover-anchor:hover .hover-action{display:inherit}.hover-anchor:active .hover-rotate,.hover-anchor:focus .hover-rotate,.hover-anchor:hover .hover-rotate{transform:rotate(45deg)}.hover14 figure{position:relative;overflow:hidden}.hover14 figure:before{position:absolute;top:0;left:-75%;z-index:2;display:block;content:\"\";width:50%;height:100%;background:linear-gradient(90deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,.3));transform:skewX(-25deg)}.hover14 figure:hover:before{animation:shine .75s}@keyframes shine{to{left:125%}}.no-margin{margin:0!important}.m{margin:16px}.m-xs{margin:4px}.m-sm{margin:8px}.m-md{margin:24px}.m-lg{margin:32px}.m-15{margin:15px}.m-v-xs{margin-top:4px;margin-bottom:4px}.m-v-sm{margin-top:8px;margin-bottom:8px}.m-v{margin-top:16px;margin-bottom:16px}.m-v-md{margin-top:24px;margin-bottom:24px}.m-v-lg{margin-top:32px;margin-bottom:32px}.m-h-xs{margin-left:4px;margin-right:4px}.m-h-sm{margin-left:8px;margin-right:8px}.m-h{margin-left:16px;margin-right:16px}.m-h-md{margin-left:24px;margin-right:24px}.m-h-lg{margin-left:32px;margin-right:32px}.m-t{margin-top:16px}.m-t-xs{margin-top:4px}.m-t-sm{margin-top:8px}.m-t-md{margin-top:24px}.m-t-lg{margin-top:32px}.m-t-xlg{margin-top:80px!important}.m-t-radio-execution{margin-top:calc(100% - 60px)!important}.m-r{margin-right:16px}.m-r-xs{margin-right:4px}.m-r-sm{margin-right:8px}.m-r-md{margin-right:24px}.m-r-lg{margin-right:32px}.no-m-r{margin-right:0}.m-r-xl{margin-right:32px}.m-b{margin-bottom:16px}.m-b-xs{margin-bottom:4px}.m-b-sm{margin-bottom:8px}.m-b-md{margin-bottom:24px}.m-b-lg{margin-bottom:32px}.m-b-button{margin-bottom:64px}.m-l{margin-left:16px}.m-l-xs{margin-left:4px}.m-l-sm{margin-left:8px}.m-l-md{margin-left:24px}.m-l-lg{margin-left:32px}.m-l-button{margin-left:147px}.no-m-l{margin-left:0}.m-n{margin:-16px}.m-h-n{margin-left:-16px;margin-right:-16px}.m-v-n{margin-top:-16px;margin-bottom:-16px}.m-l-n{margin-left:-16px}.m-r-n{margin-right:-16px}.m-t-n{margin-top:-16px}.m-t-n-sm{margin-top:-4px}.m-b-n{margin-bottom:-16px}.no-m-t{margin-top:0!important}.no-m-b{margin-bottom:0}.no-m-l{margin-left:0!important}.no-m-r{margin-right:0!important}.no-padding{padding:0!important}.no-padding-h{padding-left:0!important;padding-right:0!important}.no-padding-v{padding-bottom:0!important}.no-padding-t,.no-padding-v,.p-t-0{padding-top:0!important}.no-padding-b,.p-b-0{padding-bottom:0!important}.no-padding-r,.p-r-0{padding-right:0!important}.no-padding-l,.p-l-0{padding-left:0!important}.p-xs{padding:4px}.p-sm{padding:8px}.p{padding:16px}.p-md{padding:24px}.p-lg{padding:32px}.p-r{padding-right:8px}.p-r-md{padding-right:24px}.p-r-lg{padding-right:32px}.p-h{padding-left:16px;padding-right:16px}.p-h-xs{padding-left:4px;padding-right:4px}.p-h-sm{padding-left:8px;padding-right:8px}.p-h-md{padding-left:24px;padding-right:24px}.p-h-lg{padding-left:32px;padding-right:32px}.p-v{padding-top:16px;padding-bottom:16px}.p-v-xs{padding-top:4px;padding-bottom:4px}.p-v-sm{padding-top:8px;padding-bottom:8px}.p-v-md{padding-top:24px;padding-bottom:24px}.p-v-lg{padding-top:32px;padding-bottom:32px}.p-v-xl{padding-bottom:55px}.p-t-xl,.p-v-xl{padding-top:55px}.p-t{padding-top:15px}.p-t-12{padding-top:12px}.p-t-md{padding-top:24px}.p-t-lg{padding-top:32px}.p-t-xs{padding-top:8px}.p-b{padding-bottom:15px}.p-b-md{padding-bottom:24px}.p-b-lg{padding-bottom:32px}.p-b-xs{padding-bottom:8px}.p-t-sm{padding-top:8px}.p-t-ss{padding-top:5px}.p-b-sm{padding-bottom:8px}.p-l{padding-left:16px}.p-l-sm{padding-left:8px}.p-l-md{padding-left:24px!important}.p-l-lg{padding-left:32px}.p-l-cal{padding-left:64px}.p-l-xl{padding-left:35px!important}.no-padding-h{padding-left:0;padding-right:0}.p-btn-lg,.padding-box{padding:15px}.padding{padding:32px}.padding-out{margin:-32px}@media (max-width:992px){.padding{padding:16px}.padding-out{margin:-16px}}@media (max-width:767px){.padding{padding:8px}.padding-out{margin:-8px}}.no-radius{border-radius:0!important}.no-r-t{border-top-left-radius:0}.no-r-r,.no-r-t{border-top-right-radius:0}.no-r-b,.no-r-r{border-bottom-right-radius:0}.no-r-b,.no-r-l{border-bottom-left-radius:0}.no-r-l{border-top-left-radius:0}.r{border-radius:3px}.r-t{border-top-left-radius:3px}.r-r,.r-t{border-top-right-radius:3px}.r-b,.r-r{border-bottom-right-radius:3px}.r-b,.r-l{border-bottom-left-radius:3px}.r-l{border-top-left-radius:3px}.r-2x{border-radius:6px}.r-3x{border-radius:9px}.scrollable{overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}.scrollable.hover{overflow-y:hidden!important}.scrollable.hover>*{margin-top:-1px}.scrollable.hover:hover{overflow:visible!important;overflow-y:auto!important}.smart .scrollable{overflow-y:auto!important}.scroll-x,.scroll-y{overflow:hidden;-webkit-overflow-scrolling:touch}.scroll-y{overflow-y:auto}.scroll-x{overflow-x:auto}.no-shadow{box-shadow:none!important}.box-shadow{box-shadow:0 1px 3px rgba(0,0,0,.05)}.box-shadow-md{box-shadow:0 3px 5px rgba(0,0,0,.05)}.box-shadow-lg{box-shadow:0 5px 10px rgba(0,0,0,.05)}.box-shadow-inset{box-shadow:inset 0 -3px 0 rgba(0,0,0,.15)}.text-shadow{text-shadow:0 4px 0 rgba(0,0,0,.1)}.l-h{line-height:1.42857143}.l-h-1x{line-height:1}.l-h-2x{line-height:2em}.l-s-1x{letter-spacing:1}.l-s-2x{letter-spacing:2}.l-s-3x{letter-spacing:3}.h-1x{height:20px}.h-2x{height:40px}.h-3x{height:60px}.h-4x{height:80px}.font-normal{font-weight:400}.font-thin{font-weight:300}.font-medium{font-weight:500}.font-semibold{font-weight:600}.font-bold{font-weight:700}.font-italic{font-style:italic}.font-test{text-align:justify}.text-4x{font-size:4em}.text-3x{font-size:3em}.text-2x{font-size:2em}.text-xl{font-size:32px}.text-lg{font-size:24px}.text-md{font-size:16px}.text-base{font-size:14px}.text-sm{font-size:13px}.text-sm-important{font-size:13px!important}.text-xs{font-size:12px}.text-xs-important{font-size:12px!important}.text-xxs{font-size:10px}.text-xxs-important{font-size:10px!important}.text-u-c{text-transform:uppercase}.text-l-t{text-decoration:line-through}.text-u-l{text-decoration:underline}.text-16-important{font-size:16px!important}.text-20{font-size:20px}.text-ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.text-fade{position:relative;overflow:hidden}.text-fade:after{content:\"\";text-align:right;position:absolute;bottom:0;right:0;width:70%;height:1.2em;background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff 50%)}.no-select{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (min-width:768px) and (max-width:991px){.text-center-sm{text-align:center}.text-left-sm{text-align:left}.text-right-sm{text-align:right}}@media (max-width:767px){.text-center-xs{text-align:center}.text-left-xs{text-align:left}.text-right-xs{text-align:right}}.text-right{text-align:right!important}.text-left{text-align:left!important}.text-center{text-align:center!important}md-tabs.capitalize md-tab-item span{text-transform:capitalize}.vertical-align-sm{vertical-align:-13%}.h5,h5{font-size:16px}.text-padd{padding-top:4px}.w-16{width:16px;height:16px}.w-20{width:20px;height:20px}.w-24{width:24px;height:24px}.w-32{width:32px;height:32px}.w-40{width:40px;height:40px}.w-48{width:48px;height:48px}.w-56{width:56px;height:56px}.w-64{width:64px;height:64px}.w-xxl{width:60px}.w-xs{width:90px}.w-sm{width:120px}.w{width:180px}.w-md{width:200px}.w-lg{width:240px}.w-xl{width:280px}.w-xxl{width:320px}.w-full{width:100%}.w-auto{width:auto}.h-auto{height:auto}.h-full{height:100%}@media (max-width:991px){.w-auto-sm{width:auto}.w-full-sm{width:100%}}@media (max-width:767px){.w-auto-xs{width:auto}.w-full-xs{width:100%}}md-grid-list{margin-bottom:4px}.panel-heading h3{margin-top:0;margin-bottom:0;font-size:20px}.no-brd{border:transparent}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{vertical-align:middle}.footable.breakpoint>tbody>tr>td>span.footable-toggle{padding-right:12px!important;color:#facb55!important}.footable.breakpoint>tbody>tr>td>span.footable-toggle:before{content:\"\\E011\"}.footable.breakpoint>tbody>tr.footable-detail-show>td>span.footable-toggle:before{content:\"\\E00F\"}.detail{background-image:url(" + __webpack_require__(1541) + ");background-repeat:no-repeat;background-size:contain;background-position:100%}.v-line,div.navbar-brand-top-menu{background-repeat:no-repeat;background-size:contain;background-position:0;display:inline-block}div.navbar-brand-top-menu{background-image:url(" + __webpack_require__(1556) + ");width:128px;margin:10px 20px 0;height:47px}.app-content-header{height:45px;overflow:hidden;color:#f7f7f7}.app-content-header a{color:#f7f7f7}.app-content-header .navbar{background-color:#004374;border-radius:0}.leftbarbg{background-image:url(" + __webpack_require__(1544) + ");background-size:cover}.image_portal{background-image:url(" + __webpack_require__(294) + ");width:64px;height:65px!important;background-size:100%;background-repeat:no-repeat}.image_profile_blog_comments{width:32px;height:32px!important}.image_profile_blog,.image_profile_blog_comments{background-size:100%;background-repeat:no-repeat;margin-top:5px}.image_profile_blog{width:100px;height:100px!important;box-shadow:0 8px 6px -6px #000}.mainActivityDetails .leftActivityDetailsCheck{display:none}body .bg-review .leftActivityDetailsCheck span{color:#dad7d7!important}body .bg-review .leftActivityDetailsCheck .md-check>i:before{border:2px solid #dad7d7!important}.mdi-navigation-menu{font-size:32px}.box-inner{padding-top:0}.background-planning{background-color:#004374;background-image:url(" + __webpack_require__(1557) + ");background-repeat:no-repeat;background-position:50%;background-size:cover;color:#fff}.background-planning:before{content:\"\";background:linear-gradient(to bottom right,#151e24,#4f6e84);bottom:0;left:0;opacity:.85;position:absolute;right:0;top:0}.fullscreen .app-aside.folded~.app-content{margin-top:0}.grid-workplan{width:100%;min-height:307px!important;max-height:800px!important;border:0;background-color:rgba(212,239,255,.1);border-radius:2px}.grid-workplan .ui-grid-viewport{overflow:auto!important}.grid-workplan .ui-grid-canvas{width:100%!important;margin-right:0}.grid-workplan .ui-grid-cell{height:auto!important}.grid-workplan .ui-grid-row:nth-child(2n) .ui-grid-cell,.grid-workplan .ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent!important}.grid-workplan .ui-grid-header-cell,.grid-workplan .ui-grid-top-panel{background:transparent!important}.grid-workplan .ui-grid-cell-contents{font-family:proxima-nova;font-size:14px;font-weight:300;opacity:.85;letter-spacing:1px;color:#fff}.grid-workplan .ui-grid-row{display:flex;min-height:60px!important;height:auto!important;padding-top:20px;padding-bottom:20px;border-bottom:1px solid hsla(0,0%,100%,.4)}.grid-workplan .ui-grid-header-cell-label{font-family:Exo!important;font-size:16px;font-weight:700;letter-spacing:0!important;opacity:1}.grid-committee{width:100%;min-height:307px!important;max-height:800px!important;border:0;background-color:rgba(212,239,255,.1);border-radius:2px}.grid-committee .ui-grid-render-container-body .ui-grid-viewport{width:100%!important;overflow-x:hidden!important}.grid-committee .ui-grid-canvas{width:100%!important;margin-right:0}.grid-committee .ui-grid-cell{height:auto!important}.grid-committee .ui-grid-row:nth-child(2n) .ui-grid-cell,.grid-committee .ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent!important}.grid-committee .ui-grid-header-cell,.grid-committee .ui-grid-top-panel{background:transparent!important}.grid-committee .ui-grid-cell-contents{font-family:proxima-nova;font-size:14px;font-weight:300;opacity:.85;letter-spacing:1px;color:#fff;text-overflow:ellipsis;overflow-x:hidden}.grid-committee .ui-grid-row{display:flex;min-height:60px!important;height:auto!important;padding-top:20px;padding-bottom:20px;border-bottom:1px solid hsla(0,0%,100%,.4)}.grid-committee .ui-grid-header-cell-label{font-family:Exo!important;font-size:16px;font-weight:700;letter-spacing:0!important;opacity:1}.intro-message{width:60%;margin:0 auto}.intro-message span{display:block;width:70%;margin:0 auto}.intro-message h1{font-size:24px;font-weight:700;line-height:35px;letter-spacing:1px}.btn-fullscreen.btn.btn-success{display:block;letter-spacing:1px;margin:32px auto 0;border-radius:150px}::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px transparent;border-radius:10px;background-color:transparent}::-webkit-scrollbar{width:12px;background-color:transparent}::-webkit-scrollbar-thumb{border-radius:10px;-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.1);background-color:rgba(0,0,0,.3)}::-webkit-scrollbar-corner{background:transparent}#content.content-fullscreen{margin:0!important}.search .btn{border-left-width:0;left:-1px;box-shadow:none;z-index:2;border-color:#e5e5e5}.search .search-btn{padding:5px}.search .input-group-btn>.btn:focus,.search .input-group-btn>.btn:hover{background-color:#fff!important;cursor:auto}.autocomplete input,.autocomplete md-autocomplete,.search-autocomplete input,.search-autocomplete md-autocomplete,.search input{height:36px!important}.autocomplete md-autocomplete,.search-autocomplete md-autocomplete{border:1px solid #e5e5e5}.autocomplete .md-whiteframe-z1,.search-autocomplete .md-whiteframe-z1{box-shadow:none}.search input:focus{border-color:#e5e5e5}.search-autocomplete i,.search .btn i{opacity:.5}md-dialog textarea{min-height:60px!important}.content-activities{display:flex;flex-direction:row;flex-wrap:wrap}.inline-activity{flex:1 50%;display:flex;text-align:left;align-items:flex-start}.search-autocomplete i{position:absolute;right:7px;top:6px}.search-sutocomplete .form-group{position:relative}.datepicker-select{width:200px}.datepicker-select .md-datepicker-input{padding-top:5px}md-autocomplete[md-clear-button=false] button{display:none}.radio-options{display:flex;align-items:center;margin-top:26px;flex-wrap:wrap}.radio-options div{padding:10px 13px 10px 40px;position:relative}.radio-options i{position:relative;display:inline-block;width:0;height:18px;margin-top:-2px;margin-right:28px;margin-left:-20px;line-height:1;vertical-align:middle}.radio-options i:before{position:absolute;width:18px;height:100%;border:2px solid rgba(0,0,0,.54);border-radius:2px;content:\"\";transition:all .2s}.radio-options input{position:absolute;z-index:1;width:20px;height:20px;margin-left:-20px;cursor:pointer;opacity:0}.radio-options input[type=radio]+i,.radio-options input[type=radio]+i:before{border-radius:50%}.radio-options input:checked+i:before{background-color:inherit;border-width:0}.radio-options input[type=radio]:checked+i:after{position:absolute;top:6px;left:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.radio-green{background-color:#aace3b;color:#fff}.categories .mdi-content-add,.categories .mdi-content-remove{opacity:1;padding-right:5px}.select-inline{display:flex;align-items:center}.datepicker-select{padding-left:8px;float:left;border:1px solid #e5e5e5;margin-right:20px;margin-top:10px;width:100%}.datepicker-select .md-datepicker-input{min-width:176px;padding-bottom:2px;width:100%;height:34px}.datepicker-select .md-datepicker-input-container{border:0;width:100%;position:relative;height:30px;padding-left:6px}.datepicker-select .md-datepicker-triangle-button.md-button.md-icon-button{right:9px;top:6px;width:34px;height:34px;padding:0}.btn-cancel{background-color:#f7f7f7;border-color:#eaeaea}md-datepicker .md-button.md-icon-button{margin:0}.form-control{padding-left:4px}.form-control:focus,md-input-container:not(.md-input-invalid).md-input-focused .md-input,textarea.md-input,textarea.md-input:active,textarea.md-input:focus{border:1px solid hsla(0,0%,80%,.86)}.has-error textarea.md-input,.has-error textarea.md-input:active,.has-error textarea.md-input:focus{border:1px solid #a94442}md-input-container.md-default-theme.md-input-invalid .md-char-counter,md-input-container.md-default-theme.md-input-invalid .md-input-message-animation,md-input-container.md-default-theme.md-input-invalid label,md-input-container.md-input-invalid .md-char-counter,md-input-container.md-input-invalid .md-input-message-animation,md-input-container.md-input-invalid label{color:#a94442}md-input-container.md-input-focused .md-input,md-input-container.md-input-resized .md-input,md-input-container .md-input.ng-invalid.ng-dirty{border-width:1px}.slick-track,.slider{height:auto}.slick-next,.slick-prev{width:60px!important;height:60px!important}.slick-next:before,.slick-prev:before{font-size:50px!important;text-shadow:1px 1px 8px rgba(0,0,0,.2)}body .slick-prev{left:-46px!important}body .slick-next{right:-46px!important}@media (min-width:1360px) and (max-width:1919px){.card.horizontal,.slick-slide{height:330px!important}.slick-list{height:340px!important}.slick-oblique .slick-list{height:460px!important}.slick-oblique .slick-list .card{height:478px}.slick-oblique .slick-list .card-heading{min-height:auto}.slick-oblique-medium .slick-list{height:460px!important}.slick-oblique-medium .slick-list .card{height:410px}.slick-oblique-medium .slick-list .card-heading{max-height:140px}.slick-oblique-large .slick-list{height:540px!important}.slick-oblique-large .slick-list .card{height:520px}.slick-oblique-large .slick-list .card-heading{max-height:140px}.long{height:180px}}@media (max-width:1920px){.card.horizontal,.slick-slide{height:330px!important}.slick-list{height:340px!important}.slick-oblique .slick-list{height:484px!important}.slick-oblique .slick-list .card{height:480px}.slick-oblique .slick-list .card-heading{min-height:auto}.slick-oblique-medium .slick-list{height:460px!important}.slick-oblique-medium .slick-list .card{height:410px}.slick-oblique-medium .slick-list .card-heading{max-height:120px}.slick-oblique-large .slick-list{height:540px!important}.slick-oblique-large .slick-list .card{height:520px}.slick-oblique-large .slick-list .card-heading{max-height:125px}}.slick-oblique .hours{position:absolute;border-radius:50px;width:75px;right:7px;bottom:-16px}.slick-oblique .period{height:100px}.slick-oblique-large .hours{position:absolute;border-radius:50px;width:75px;right:7px;bottom:-16px}.slick-oblique .card-body{height:226px}.slick-oblique .card-heading.hidden-content{overflow:hidden}.slick-oblique-large .card-body.long{height:282px;overflow:hidden}.slick-oblique-large .card-heading{height:140px}.slick-oblique-header{height:200px}.card.horizontal{display:flex;box-shadow:0 0 8px rgba(0,0,0,.15);border-radius:15px}.card.horizontal .first-content{overflow:hidden;min-height:110px;display:flex;flex-direction:column;justify-content:center}.card.horizontal .card-heading{display:flex;flex-direction:column;justify-content:center;min-width:200px}.card.horizontal .card-heading p{max-height:150px;overflow:hidden;margin-top:0}.card.horizontal .card-body{text-align:left;padding:16px 24px}.card.horizontal .list-items{list-style:none}.card.horizontal .btn{width:100%}.card-border-radius{box-shadow:0 0 8px rgba(0,0,0,.15);border-radius:20px}@media (min-width:992px){.card.horizontal .list-items{height:160px;overflow:hidden}}@media (min-width:1360px) and (max-width:1919px){.card.horizontal .list-items{height:160px;overflow:hidden}}@media (min-width:1920px){.card.horizontal .list-items{height:160px;overflow:hidden}.color-cards .card-heading{padding:55px}.color-cards .card-body{padding:32px}.color-cards .card-heading .icon{font-size:50px}.color-cards .card-body h5{font-size:16px}}.brd-md{border-radius:20px}.i-40{font-size:40px;vertical-align:-39%}.color-cards .box-shadow{box-shadow:0 2px 14px rgba(0,0,0,.2)}.profile-cards .box-shadow{box-shadow:0 2px 4px #ccc}.profile-cards .fixed-height-300{height:300px;overflow-y:scroll;overflow-x:hidden;position:relative}.profile-cards .fixed-height-800{height:800px;overflow-y:scroll;overflow-x:hidden;position:relative}.profile-cards .grad-white{content:\"\";position:absolute;bottom:0;left:0;right:16px;height:50px;z-index:10;background:transparent;background:-webkit-gradient(color-stop(0,hsla(0,0%,98%,0)),color-stop(100%,#f9f9f9));background:linear-gradient(hsla(0,0%,98%,0),#f9f9f9);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"transparent\",endColorstr=\"#f9f9f9\",GradientType=1)}.blog-statement{box-shadow:0 2px 4px #ccc}.blog-statement .html-text{height:179px;overflow-y:scroll;position:relative}.dialog-statement{height:200px;overflow-y:auto;position:relative;padding:10px 0;color:#6f6f6e!important}.dialog-statement a{color:#ffb000!important;text-decoration:underline}.dialog-statement.row{text-align:left}.fixed-height-345{height:345px;overflow-y:scroll;position:relative}.fixed-height-250{height:250px;overflow-y:scroll;position:relative}.masonry-cols-2{column-count:2;column-gap:10px}.masonry-cols-4{column-count:4;column-gap:10px}.masonry-break{break-inside:avoid-column;page-break-inside:avoid}md-dialog{max-width:40%;padding-bottom:30px}md-toolbar{background-color:transparent!important;min-height:30px}md-dialog .icon{display:block;color:#263238}md-dialog .add-button .icon{color:#fff}.md-toolbar-tools{flex-direction:row-reverse;padding:0;height:30px}.md-toolbar-tools .md-icon-button{padding:0;height:20px;width:30px;align-self:flex-start}.md-toolbar-tools>.md-button:last-child{margin-right:0}md-dialog .row{text-align:center;padding:5px 20px;margin:0}md-dialog .row h3,md-dialog .row h4{margin:0 0 10px}md-dialog .row1 h3,md-dialog .row1 h4{color:#ef7955;margin:0 0 10px}md-dialog .row1{text-align:center;padding:5px 64px;margin:0}md-dialog a i{font-size:70px;padding:25px;display:block;width:120px;height:120px;border-radius:100%;margin:0 auto;color:#fff!important;margin-bottom:10px}md-dialog .row .create a{color:#aace3b}md-dialog .row .clone a{color:#2053d2}md-dialog .row .create a i{background-color:#aace3b}md-dialog .row .clone a i{background-color:#2053d2}md-dialog .with-bullets{list-style:none}md-dialog .with-bullets li{position:relative}md-dialog .with-bullets li:before{width:8px;height:8px;margin-right:5px;background-color:#2053d2;border-radius:100%;padding:1px;content:\"\";position:absolute;top:5px;left:-14px;right:0;bottom:0}.column-right{text-align:right}.column-center{text-align:center}.column-left{text-align:left}.ui-grid-cell-contents{padding:5px 10px;box-sizing:border-box;white-space:nowrap;-ms-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;height:100%;font-size:12px}.ui-grid-cell-contents a{color:#ffb000}.ui-grid-header-cell{background-color:#2053d2;color:#fff;border-right:0 solid;border-color:#91a3bd}.ui-grid-top-panel{font-weight:700;background:#2053d2;background:-o-linear-gradient(none,none);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"none\",endColorstr=\"none\",GradientType=0);-webkit-border-top-right-radius:0;-webkit-border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topright:0;-moz-border-radius-bottomright:0;-moz-border-radius-bottomleft:0;-moz-border-radius-topleft:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-left-radius:0;background-clip:padding-box}.grid-btn{margin:0;border-radius:2px;min-height:10px;min-width:130px;padding:0;font-size:12px;height:22px;line-height:1.5;font-weight:400;font-family:proxima-nova!important}.grid-darker-gray .ui-grid-header-cell,.grid-darker-gray .ui-grid-top-panel{background-color:#758295}.grid-darker-gray .ui-grid-row.ui-grid-row-selected>[ui-grid-row]>.ui-grid-cell{background-color:#2053d2;color:#fff}.grid-darker-gray .ui-grid-viewport ng-isolate-scope{border-left:1px solid #f2f5f7}.grid-blue .ui-grid-cell-contents{padding-bottom:0}.grid-blue input[type=text].ui-grid-filter-input{border-radius:0!important}.grid-blue .ui-grid-pager-panel{background-color:#ccd0db;font-size:12px}.grid-blue .ui-grid-pager-panel button{background-color:transparent}.grid-blue .ui-grid-pager-panel .ui-grid-pager-count-container{float:left;margin-left:16px;margin-top:6px}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control input,.grid-blue .ui-grid-pager-panel .ui-grid-pager-row-count-picker select{background-color:hsla(0,0%,100%,.5)}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control .first-triangle{border-width:4px 7.7px 4px 0}.grid-blue .ui-grid-pager-panel .ui-grid-pager-control .last-triangle{border-width:4px 0 4px 7.7px}.grid-blue .cell-button .ui-grid-cell-contents{padding:0!important}.grid-blue .grid-with-button .ui-grid-row{height:35px}.ui-grid-viewport{overflow-anchor:none}.custom-tooltip{font-size:12px;font-weight:700}.custom-s-tooltip,.custom-tooltip{background-color:#000!important;color:#fff!important}.custom-s-tooltip{font-size:10px}.md-toast-content{background:#2053d2!important}.squarerify{border-radius:0!important}.opacity-4{opacity:.4}.transparent{background-color:hsla(0,0%,100%,.2)}.close-text{line-height:12px}.word-wrap{word-wrap:break-word}.custom-autoselect .md-icon{top:35%}.list{border-bottom:1px solid #e5e5e5;overflow:hidden;margin-bottom:8px}.strip-btn{background:none;border:none}.activityTag{border-radius:5px;padding:4px 5px;min-width:68px;cursor:default;text-align:center;max-height:40px;font-size:11px}.w-h-100{width:100%;height:100%}.list-h{height:65vh;overflow-y:auto}.text-block{display:inline-block}.left{float:left}.right{float:right}.bg-review{background:#5700da}.rightDivider{border-right:1px solid #e5e5e5;height:auto}.verticalDivider{border-left:1px solid #e5e5e5;height:50vw}.horizontalDivider,.teacherList{border-bottom:1px solid #e5e5e5}.teacherList{color:#aace3b}.teacherList p{display:inline-block;color:rgba(0,0,0,.87);width:88%}.list a,.teacherList .md-button{color:#e5e5e5}.dark-icon{color:rgba(0,0,0,.87)}.webeditor .btn{padding:5.8px;border:none}.webeditor .btn-toolbar{margin:0}.webeditor .btn-toolbar,.webeditor .text-angular-toolbar{background:rgba(0,0,0,.1)}.webeditor .ta-scroll-window.form-control,.webeditor .ta-scroll-window>.ta-bind{min-height:150px}.webeditor .ta-scroll-window.form-control a,.webeditor .ta-scroll-window>.ta-bind a{color:#ffb000;text-decoration:underline}.webeditor .ta-toolbar{background-color:#ccd0db}.webeditor .ta-toolbar button{background-color:transparent}.webeditor .ta-toolbar button.active{background-color:#91a3bd!important;box-shadow:none}.webeditor .ta-toolbar button.active i{color:#fff}.webeditor .ta-toolbar i{color:#353942}.long-datepicker input{margin:3px 15px 2px;padding:0}.long-datepicker .md-datepicker-input-container{display:block;border:none!important}.long-datepicker .md-datepicker-input-container .md-datepicker-expand-triangle{left:75%}.tab-title-with-form{background:#f2f5f7;height:75px;align-self:flex-end;border-top-left-radius:16px;border-top-right-radius:16px}.parametersLister{border-top:2px solid #e5e5e5;padding:8px 0}.parametersLister .bullet{margin:0;border-radius:50%;width:15px;height:15px;background:#2053d2}.parametersLister p{display:inline;color:rgba(0,0,0,.87);width:80%;line-height:12px;margin:0}.parametersLister button{float:right}md-tabs.default-tabs.md-default-theme md-ink-bar,md-tabs.default-tabs md-ink-bar{color:#000;background-color:#ffb000}md-tabs.default-tabs.md-default-theme .md-tab,md-tabs.default-tabs.md-default-theme .md-tab.md-active,md-tabs.default-tabs.md-default-theme .md-tab.md-active md-icon,md-tabs.default-tabs.md-default-theme .md-tab.md-focused,md-tabs.default-tabs.md-default-theme .md-tab.md-focused md-icon,md-tabs.default-tabs .md-tab,md-tabs.default-tabs .md-tab.md-active,md-tabs.default-tabs .md-tab.md-active md-icon,md-tabs.default-tabs .md-tab.md-focused,md-tabs.default-tabs .md-tab.md-focused md-icon{color:#263238;font-weight:400;font-size:14px}md-tabs.md-default-theme .md-tab.md-active,md-tabs.md-default-theme .md-tab.md-active md-icon,md-tabs.md-default-theme .md-tab.md-focused,md-tabs.md-default-theme .md-tab.md-focused md-icon,md-tabs .md-tab.md-active,md-tabs .md-tab.md-active md-icon,md-tabs .md-tab.md-focused,md-tabs .md-tab.md-focused md-icon{color:#263238}md-tabs.md-default-theme md-ink-bar,md-tabs md-ink-bar{color:#263238;background:#aace3b}md-tab-item.md-tab{color:#546e7a;background-color:#fff}.with-bullets,.without-bullets{list-style:none}.with-bullets li{position:relative}.with-bullets li:before{width:8px;height:8px;margin-right:5px;background-color:#aace3b;border-radius:100%;padding:1px;content:\"\";position:absolute;top:16px;left:6px;right:0;bottom:0}.with-bullets.bullets-md li:before{top:8px}textarea{resize:none}.without-bullets li{position:relative;padding:8px 0}.without-bullets li button{position:absolute;right:0}.mdinputcontainerwrapper,.mdinputcontainerwrapper md-input-container{padding-bottom:0;margin-bottom:0}.mdinputcontainerwrapper label{color:#000}.rounded-list .list-title{max-height:42px;overflow:hidden}.rounded-list .detail{max-height:40px;overflow:hidden}.max-height{max-height:130px;overflow:hidden}.div-father{position:relative}.div-gris{background-color:#f2f2f2;width:95%;opacity:.5}.div-green,.div-gris{height:11px;margin-left:15px;position:absolute;border-radius:200px 200px 200px 200px;top:64%;left:0;right:100%;bottom:100%}.div-green{background-color:#04b404;width:150px}.tl-radio{background-color:#a4a4a4;border-radius:50px;bottom:60%;height:30px;top:0;right:0;width:30px}.radio-planification{left:0}.radio-approval{left:33%}.radio-execution{left:66%}.radio-evaluation{left:100%}.radio-white{background-color:#fff;width:18px;height:18px;position:relative;top:19%;left:20%;right:0;bottom:60%;border-radius:50px}.tl-square{background-color:transparent;width:80px;height:30px;position:absolute;top:0;right:0;bottom:100%}.square-planification{left:0}.square-approval{left:33%}.square-execution{left:66%}.square-evaluation{left:95%}.tl-label{margin-left:-22%}.teaching{color:#fff;margin-top:80px}.underscore{text-decoration:underline;cursor:pointer}.disabled{pointer-events:none;cursor:default}.autocomplete{box-shadow:inset 0 1px 1px rgba(0,0,0,.075);height:34px;border:1px solid #ccc}.projectTypeTag{border-radius:5px;padding:0 4px;min-width:68px;cursor:default;height:20px;text-align:center;line-height:20px}.activity_checkbox md-checkbox.md-checked .md-icon,.activity_checkbox md-checkbox.md-default-theme.md-checked .md-icon{background-color:#7abf15}.activity_checkbox{margin-top:10px;text-align:center}.img-container{height:0;display:inline-block;padding:0 25px 0 0;border-right:32px solid transparent;border-bottom:148px solid #4082b9;line-height:50px}.capitalize{text-transform:none}.md-tab,md-tabs.capitalize md-tab-item span{text-transform:inherit}@media (max-width:1753px){.img-container{border-bottom:159px solid #4082b9}}@media (max-width:1700px){.img-container{border-bottom:180px solid #4082b9}.img-container img.img-circle{margin-top:22px;margin-left:10px}}@media (max-width:1430px){.img-container{border-bottom:190px solid #4082b9;padding:0}.img-container img.img-circle{margin-top:22px;margin-left:-33px}}@media (max-width:991px){.img-container{border-bottom:148px solid #4082b9;padding:0}}md-checkbox,md-checkbox.md-checked .md-icon:after{-webkit-backface-visibility:hidden;backface-visibility:hidden}md-checkbox.md-checked .md-icon:after{box-sizing:border-box;transform:rotate(45deg);position:absolute;left:4.66667px;top:.22222px;display:table;width:6.66667px;height:13.33333px;border-width:2px;border-style:solid;border-top:0;border-left:0;content:\"\"}.bg-grey{background:#758295;cursor:not-allowed}.projectVisibilityTag{height:auto}.loading-details{position:absolute;top:0;left:0;height:100%;width:100%;padding-top:20%;z-index:999}table.table.table-no-bordered tr>td{border-top:inherit}tspan{font-size:inherit}md-dialog{max-width:100%;width:60%;max-height:95%}.comments{max-height:390px;overflow-y:auto}.comments .body-comment p,.comments .header-comment p{text-align:left}.comment-response{padding-left:40px}.comment-response .item-comment.ng-scope{border-left:6px solid rgba(64,55,189,.52)}.body-comment .comments-actions>a{margin-left:12px}.card-heigth{height:330px!important}.tooltip-multiline{height:auto}dl{display:grid;grid-gap:10px;grid-template-columns:1fr 1fr;margin-bottom:10px}dl p{margin-bottom:0}#loading-bar .bar{background:#ffb000;height:3px;border-top:1px solid #ffc84d;border-radius:0 200px 200px 0;border-right:1px solid #ffc84d;box-shadow:0 2px 10px 0 rgba(0,0,0,.5);z-index:10002!important}#loading-bar-spinner{display:none;top:50%;left:50%}#loading-bar-spinner .spinner-icon{width:40px;height:40px;border:3px solid transparent;border-top-color:#ffb000;border-left-color:#ffb000;border-radius:50px;animation:loading-bar-spinner .8s linear infinite}.internal-diagram.c100 .bar{position:absolute;border:none;width:1em;height:1em;clip:rect(0,.5em,1em,0);border-radius:50%;transform:rotate(0deg)}.internal-diagram.c100.p51 .fill,.internal-diagram.c100.p52 .fill,.internal-diagram.c100.p53 .fill,.internal-diagram.c100.p54 .fill,.internal-diagram.c100.p55 .fill,.internal-diagram.c100.p56 .fill,.internal-diagram.c100.p57 .fill,.internal-diagram.c100.p58 .fill,.internal-diagram.c100.p59 .fill,.internal-diagram.c100.p60 .fill,.internal-diagram.c100.p61 .fill,.internal-diagram.c100.p62 .fill,.internal-diagram.c100.p63 .fill,.internal-diagram.c100.p64 .fill,.internal-diagram.c100.p65 .fill,.internal-diagram.c100.p66 .fill,.internal-diagram.c100.p67 .fill,.internal-diagram.c100.p68 .fill,.internal-diagram.c100.p69 .fill,.internal-diagram.c100.p70 .fill,.internal-diagram.c100.p71 .fill,.internal-diagram.c100.p72 .fill,.internal-diagram.c100.p73 .fill,.internal-diagram.c100.p74 .fill,.internal-diagram.c100.p75 .fill,.internal-diagram.c100.p76 .fill,.internal-diagram.c100.p77 .fill,.internal-diagram.c100.p78 .fill,.internal-diagram.c100.p79 .fill,.internal-diagram.c100.p80 .fill,.internal-diagram.c100.p81 .fill,.internal-diagram.c100.p82 .fill,.internal-diagram.c100.p83 .fill,.internal-diagram.c100.p84 .fill,.internal-diagram.c100.p85 .fill,.internal-diagram.c100.p86 .fill,.internal-diagram.c100.p87 .fill,.internal-diagram.c100.p88 .fill,.internal-diagram.c100.p89 .fill,.internal-diagram.c100.p90 .fill,.internal-diagram.c100.p91 .fill,.internal-diagram.c100.p92 .fill,.internal-diagram.c100.p93 .fill,.internal-diagram.c100.p94 .fill,.internal-diagram.c100.p95 .fill,.internal-diagram.c100.p96 .fill,.internal-diagram.c100.p97 .fill,.internal-diagram.c100.p98 .fill,.internal-diagram.c100.p99 .fill,.internal-diagram.c100.p100 .fill{width:1em;height:1em;border:none;border-color:inherit}.internal-diagram.c100:hover>span{color:#91a3bd}.principal-diagram.c100{border:.08em solid hsla(0,0%,98%,.3);background-color:transparent;box-shadow:0 0 22px -4px rgba(0,0,0,.75)}.principal-diagram.c100:after{top:-.08em;left:-.08em;background-color:transparent;width:1em;height:1em}.principal-diagram.c100 .slice{top:-.08em;left:-.08em}.principal-diagram.c100 .bar{top:0;left:0;right:0;bottom:0}.principal-diagram.c100>span{left:-.32em;top:-.6em;bottom:-.32em;right:.16em}.c100.big{font-size:190px}.c100.md{font-size:100px}.c100.sm{font-size:65px}.c100.xs{font-size:40px}.disabled.c100.green:hover>span{color:#ccc}.disabled.c100:hover>span{width:5em;line-height:5em;font-size:.2em}@media (min-width:980px) and (max-width:1200px){.c100.big{font-size:135px}.c100.big h4{font-size:10px!important}.c100.big .m-t-radio-execution{margin-top:61%!important}}.bar.b-rojo{border:.08em solid #ef7955}.bar.b-azul{border:.08em solid #2053d2}.bar.b-verde{border:.08em solid #aace3b}.bar.b-morado{border:.08em solid #7e57c2}.bar.b-naranja{border:.08em solid #ff9800}.col-lg-1-5,.col-md-1-5,.col-sm-1-5,.col-xs-1-5{position:relative;min-height:1px;padding-right:10px;padding-left:10px}.col-xs-1-5{width:20%;float:left}.c100.red .bar,.c100.red .fill{border-color:#d7634a!important}.c100.red:hover>span{color:#d7634a}.c100.red.dark .bar,.c100.red.dark .fill{border-color:#b71c1c!important}.c100.red.dark:hover>span{color:#b71c1c}.c100.pink .bar,.c100.pink .fill{border-color:#e91e63!important}.c100.pink:hover>span{color:#e91e63}.c100.pink.dark .bar,.c100.pink.dark .fill{border-color:#880e4f!important}.c100.pink.dark:hover>span{color:#880e4f}.c100.purple .bar,.c100.purple .fill{border-color:#9c27b0!important}.c100.purple:hover>span{color:#9c27b0}.c100.purple.dark .bar,.c100.purple.dark .fill{border-color:#4a148c!important}.c100.purple.dark:hover>span{color:#4a148c}.c100.deep-purple .bar,.c100.deep-purple .fill{border-color:#673ab7!important}.c100.deep-purple:hover>span{color:#673ab7}.c100.deep-purple.dark .bar,.c100.deep-purple.dark .fill{border-color:#311b92!important}.c100.deep-purple.dark:hover>span{color:#311b92}.c100.indigo .bar,.c100.indigo .fill{border-color:#3f51b5!important}.c100.indigo:hover>span{color:#3f51b5}.c100.indigo.dark .bar,.c100.indigo.dark .fill{border-color:#1a237e!important}.c100.indigo.dark:hover>span{color:#1a237e}.c100.blue .bar,.c100.blue .fill{border-color:#00548a!important}.c100.blue:hover>span{color:#00548a}.c100.blue.dark .bar,.c100.blue.dark .fill{border-color:#0d47a1!important}.c100.blue.dark:hover>span{color:#0d47a1}.c100.light-blue .bar,.c100.light-blue .fill{border-color:#468ac2!important}.c100.light-blue:hover>span{color:#468ac2}.c100.light-blue.dark .bar,.c100.light-blue.dark .fill{border-color:#01579b!important}.c100.light-blue.dark:hover>span{color:#01579b}.c100.cyan .bar,.c100.cyan .fill{border-color:#00bcd4!important}.c100.cyan:hover>span{color:#00bcd4}.c100.cyan.dark .bar,.c100.cyan.dark .fill{border-color:#006064!important}.c100.cyan.dark:hover>span{color:#006064}.c100.teal .bar,.c100.teal .fill{border-color:#009688!important}.c100.teal:hover>span{color:#009688}.c100.teal.dark .bar,.c100.teal.dark .fill{border-color:#004d40!important}.c100.teal.dark:hover>span{color:#004d40}.c100.green .bar,.c100.green .fill{border-color:#4caf50!important}.c100.green:hover>span{color:#4caf50}.c100.green.dark .bar,.c100.green.dark .fill{border-color:#1b5e20!important}.c100.green.dark:hover>span{color:#1b5e20}.c100.light-green .bar,.c100.light-green .fill{border-color:#8bc34a!important}.c100.light-green:hover>span{color:#8bc34a}.c100.light-green.dark .bar,.c100.light-green.dark .fill{border-color:#33691e!important}.c100.light-green.dark:hover>span{color:#33691e}.c100.lime .bar,.c100.lime .fill{border-color:#a8c329!important}.c100.lime:hover>span{color:#a8c329}.c100.lime.dark .bar,.c100.lime.dark .fill{border-color:#827717!important}.c100.lime.dark:hover>span{color:#827717}.c100.yellow .bar,.c100.yellow .fill{border-color:#ffeb3b!important}.c100.yellow:hover>span{color:#ffeb3b}.c100.yellow.dark .bar,.c100.yellow.dark .fill{border-color:#f57f17!important}.c100.yellow.dark:hover>span{color:#f57f17}.c100.amber .bar,.c100.amber .fill{border-color:#fab813!important}.c100.amber:hover>span{color:#fab813}.c100.amber.dark .bar,.c100.amber.dark .fill{border-color:#ff6f00!important}.c100.amber.dark:hover>span{color:#ff6f00}.c100.orange .bar,.c100.orange .fill{border-color:#ff9800!important}.c100.orange:hover>span{color:#ff9800}.c100.orange.dark .bar,.c100.orange.dark .fill{border-color:#e65100!important}.c100.orange.dark:hover>span{color:#e65100}.c100.deep-orange .bar,.c100.deep-orange .fill{border-color:#ff5722!important}.c100.deep-orange:hover>span{color:#ff5722}.c100.deep-orange.dark .bar,.c100.deep-orange.dark .fill{border-color:#bf360c!important}.c100.deep-orange.dark:hover>span{color:#bf360c}.c100.brown .bar,.c100.brown .fill{border-color:#795548!important}.c100.brown:hover>span{color:#795548}.c100.brown.dark .bar,.c100.brown.dark .fill{border-color:#3e2723!important}.c100.brown.dark:hover>span{color:#3e2723}.c100.blue-grey .bar,.c100.blue-grey .fill{border-color:#607d8b!important}.c100.blue-grey:hover>span{color:#607d8b}.c100.blue-grey.dark .bar,.c100.blue-grey.dark .fill{border-color:#263238!important}.c100.blue-grey.dark:hover>span{color:#263238}.c100.grey .bar,.c100.grey .fill{border-color:#6f6f6e!important}.c100.grey:hover>span{color:#6f6f6e}.c100.grey.dark .bar,.c100.grey.dark .fill{border-color:#212121!important}.c100.grey.dark:hover>span{color:#212121}@media (min-width:768px){.col-sm-1-5{width:20%;float:left}}@media (min-width:992px){.col-md-1-5{width:20%;float:left}}@media (min-width:1200px){.col-lg-1-5{width:20%;float:left}}@font-face{font-family:Material-Design-Icons;font-style:normal;font-weight:400;src:url(" + __webpack_require__(1546) + ");src:url(" + __webpack_require__(1547) + "?#iefix-g7cqhn) format(\"embedded-opentype\"),url(" + __webpack_require__(1548) + ") format(\"woff\"),url(" + __webpack_require__(1549) + ") format(\"truetype\"),url(" + __webpack_require__(1550) + "#Material-Design-Icons) format(\"svg\")}[class*=\" mdi-\"],[class^=mdi-]{font-family:Material-Design-Icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;line-height:1;text-transform:none;speak:none;font-variant:normal;-moz-osx-font-smoothing:grayscale}.mdi-action-3d-rotation:before{content:\"\\E600\"}.mdi-action-accessibility:before{content:\"\\E601\"}.mdi-action-account-balance:before{content:\"\\E602\"}.mdi-action-account-balance-wallet:before{content:\"\\E603\"}.mdi-action-account-box:before{content:\"\\E604\"}.mdi-action-account-child:before{content:\"\\E605\"}.mdi-action-account-circle:before{content:\"\\E606\"}.mdi-action-add-shopping-cart:before{content:\"\\E607\"}.mdi-action-alarm:before{content:\"\\E608\"}.mdi-action-alarm-add:before{content:\"\\E609\"}.mdi-action-alarm-off:before{content:\"\\E60A\"}.mdi-action-alarm-on:before{content:\"\\E60B\"}.mdi-action-android:before{content:\"\\E60C\"}.mdi-action-announcement:before{content:\"\\E60D\"}.mdi-action-aspect-ratio:before{content:\"\\E60E\"}.mdi-action-assessment:before{content:\"\\E60F\"}.mdi-action-assignment:before{content:\"\\E610\"}.mdi-action-assignment-ind:before{content:\"\\E611\"}.mdi-action-assignment-late:before{content:\"\\E612\"}.mdi-action-assignment-return:before{content:\"\\E613\"}.mdi-action-assignment-returned:before{content:\"\\E614\"}.mdi-action-assignment-turned-in:before{content:\"\\E615\"}.mdi-action-autorenew:before{content:\"\\E616\"}.mdi-action-backup:before{content:\"\\E617\"}.mdi-action-book:before{content:\"\\E618\"}.mdi-action-bookmark:before{content:\"\\E619\"}.mdi-action-bookmark-outline:before{content:\"\\E61A\"}.mdi-action-bug-report:before{content:\"\\E61B\"}.mdi-action-cached:before{content:\"\\E61C\"}.mdi-action-class:before{content:\"\\E61D\"}.mdi-action-credit-card:before{content:\"\\E61E\"}.mdi-action-dashboard:before{content:\"\\E61F\"}.mdi-action-delete:before{content:\"\\E620\"}.mdi-action-description:before{content:\"\\E621\"}.mdi-action-dns:before{content:\"\\E622\"}.mdi-action-done:before{content:\"\\E623\"}.mdi-action-done-all:before{content:\"\\E624\"}.mdi-action-event:before{content:\"\\E625\"}.mdi-action-exit-to-app:before{content:\"\\E626\"}.mdi-action-explore:before{content:\"\\E627\"}.mdi-action-extension:before{content:\"\\E628\"}.mdi-action-face-unlock:before{content:\"\\E629\"}.mdi-action-favorite:before{content:\"\\E62A\"}.mdi-action-favorite-outline:before{content:\"\\E62B\"}.mdi-action-find-in-page:before{content:\"\\E62C\"}.mdi-action-find-replace:before{content:\"\\E62D\"}.mdi-action-flip-to-back:before{content:\"\\E62E\"}.mdi-action-flip-to-front:before{content:\"\\E62F\"}.mdi-action-get-app:before{content:\"\\E630\"}.mdi-action-grade:before{content:\"\\E631\"}.mdi-action-group-work:before{content:\"\\E632\"}.mdi-action-help:before{content:\"\\E633\"}.mdi-action-highlight-remove:before{content:\"\\E634\"}.mdi-action-history:before{content:\"\\E635\"}.mdi-action-home:before{content:\"\\E636\"}.mdi-action-https:before{content:\"\\E637\"}.mdi-action-info:before{content:\"\\E638\"}.mdi-action-info-outline:before{content:\"\\E639\"}.mdi-action-input:before{content:\"\\E63A\"}.mdi-action-invert-colors:before{content:\"\\E63B\"}.mdi-action-label:before{content:\"\\E63C\"}.mdi-action-label-outline:before{content:\"\\E63D\"}.mdi-action-language:before{content:\"\\E63E\"}.mdi-action-launch:before{content:\"\\E63F\"}.mdi-action-list:before{content:\"\\E640\"}.mdi-action-lock:before{content:\"\\E641\"}.mdi-action-lock-open:before{content:\"\\E642\"}.mdi-action-lock-outline:before{content:\"\\E643\"}.mdi-action-loyalty:before{content:\"\\E644\"}.mdi-action-markunread-mailbox:before{content:\"\\E645\"}.mdi-action-note-add:before{content:\"\\E646\"}.mdi-action-open-in-browser:before{content:\"\\E647\"}.mdi-action-open-in-new:before{content:\"\\E648\"}.mdi-action-open-with:before{content:\"\\E649\"}.mdi-action-pageview:before{content:\"\\E64A\"}.mdi-action-payment:before{content:\"\\E64B\"}.mdi-action-perm-camera-mic:before{content:\"\\E64C\"}.mdi-action-perm-contact-cal:before{content:\"\\E64D\"}.mdi-action-perm-data-setting:before{content:\"\\E64E\"}.mdi-action-perm-device-info:before{content:\"\\E64F\"}.mdi-action-perm-identity:before{content:\"\\E650\"}.mdi-action-perm-media:before{content:\"\\E651\"}.mdi-action-perm-phone-msg:before{content:\"\\E652\"}.mdi-action-perm-scan-wifi:before{content:\"\\E653\"}.mdi-action-picture-in-picture:before{content:\"\\E654\"}.mdi-action-polymer:before{content:\"\\E655\"}.mdi-action-print:before{content:\"\\E656\"}.mdi-action-query-builder:before{content:\"\\E657\"}.mdi-action-question-answer:before{content:\"\\E658\"}.mdi-action-receipt:before{content:\"\\E659\"}.mdi-action-redeem:before{content:\"\\E65A\"}.mdi-action-report-problem:before{content:\"\\E65B\"}.mdi-action-restore:before{content:\"\\E65C\"}.mdi-action-room:before{content:\"\\E65D\"}.mdi-action-schedule:before{content:\"\\E65E\"}.mdi-action-search:before{content:\"\\E65F\"}.mdi-action-settings:before{content:\"\\E660\"}.mdi-action-settings-applications:before{content:\"\\E661\"}.mdi-action-settings-backup-restore:before{content:\"\\E662\"}.mdi-action-settings-bluetooth:before{content:\"\\E663\"}.mdi-action-settings-cell:before{content:\"\\E664\"}.mdi-action-settings-display:before{content:\"\\E665\"}.mdi-action-settings-ethernet:before{content:\"\\E666\"}.mdi-action-settings-input-antenna:before{content:\"\\E667\"}.mdi-action-settings-input-component:before{content:\"\\E668\"}.mdi-action-settings-input-composite:before{content:\"\\E669\"}.mdi-action-settings-input-hdmi:before{content:\"\\E66A\"}.mdi-action-settings-input-svideo:before{content:\"\\E66B\"}.mdi-action-settings-overscan:before{content:\"\\E66C\"}.mdi-action-settings-phone:before{content:\"\\E66D\"}.mdi-action-settings-power:before{content:\"\\E66E\"}.mdi-action-settings-remote:before{content:\"\\E66F\"}.mdi-action-settings-voice:before{content:\"\\E670\"}.mdi-action-shop:before{content:\"\\E671\"}.mdi-action-shopping-basket:before{content:\"\\E672\"}.mdi-action-shopping-cart:before{content:\"\\E673\"}.mdi-action-shop-two:before{content:\"\\E674\"}.mdi-action-speaker-notes:before{content:\"\\E675\"}.mdi-action-spellcheck:before{content:\"\\E676\"}.mdi-action-star-rate:before{content:\"\\E677\"}.mdi-action-stars:before{content:\"\\E678\"}.mdi-action-store:before{content:\"\\E679\"}.mdi-action-subject:before{content:\"\\E67A\"}.mdi-action-swap-horiz:before{content:\"\\E67B\"}.mdi-action-swap-vert:before{content:\"\\E67C\"}.mdi-action-swap-vert-circle:before{content:\"\\E67D\"}.mdi-action-system-update-tv:before{content:\"\\E67E\"}.mdi-action-tab:before{content:\"\\E67F\"}.mdi-action-tab-unselected:before{content:\"\\E680\"}.mdi-action-theaters:before{content:\"\\E681\"}.mdi-action-thumb-down:before{content:\"\\E682\"}.mdi-action-thumbs-up-down:before{content:\"\\E683\"}.mdi-action-thumb-up:before{content:\"\\E684\"}.mdi-action-toc:before{content:\"\\E685\"}.mdi-action-today:before{content:\"\\E686\"}.mdi-action-track-changes:before{content:\"\\E687\"}.mdi-action-translate:before{content:\"\\E688\"}.mdi-action-trending-down:before{content:\"\\E689\"}.mdi-action-trending-neutral:before{content:\"\\E68A\"}.mdi-action-trending-up:before{content:\"\\E68B\"}.mdi-action-turned-in:before{content:\"\\E68C\"}.mdi-action-turned-in-not:before{content:\"\\E68D\"}.mdi-action-verified-user:before{content:\"\\E68E\"}.mdi-action-view-agenda:before{content:\"\\E68F\"}.mdi-action-view-array:before{content:\"\\E690\"}.mdi-action-view-carousel:before{content:\"\\E691\"}.mdi-action-view-column:before{content:\"\\E692\"}.mdi-action-view-day:before{content:\"\\E693\"}.mdi-action-view-headline:before{content:\"\\E694\"}.mdi-action-view-list:before{content:\"\\E695\"}.mdi-action-view-module:before{content:\"\\E696\"}.mdi-action-view-quilt:before{content:\"\\E697\"}.mdi-action-view-stream:before{content:\"\\E698\"}.mdi-action-view-week:before{content:\"\\E699\"}.mdi-action-visibility:before{content:\"\\E69A\"}.mdi-action-visibility-off:before{content:\"\\E69B\"}.mdi-action-wallet-giftcard:before{content:\"\\E69C\"}.mdi-action-wallet-membership:before{content:\"\\E69D\"}.mdi-action-wallet-travel:before{content:\"\\E69E\"}.mdi-action-work:before{content:\"\\E69F\"}.mdi-alert-error:before{content:\"\\E6A0\"}.mdi-alert-warning:before{content:\"\\E6A1\"}.mdi-av-album:before{content:\"\\E6A2\"}.mdi-av-timer:before{content:\"\\E6A3\"}.mdi-av-closed-caption:before{content:\"\\E6A4\"}.mdi-av-equalizer:before{content:\"\\E6A5\"}.mdi-av-explicit:before{content:\"\\E6A6\"}.mdi-av-fast-forward:before{content:\"\\E6A7\"}.mdi-av-fast-rewind:before{content:\"\\E6A8\"}.mdi-av-games:before{content:\"\\E6A9\"}.mdi-av-hearing:before{content:\"\\E6AA\"}.mdi-av-high-quality:before{content:\"\\E6AB\"}.mdi-av-loop:before{content:\"\\E6AC\"}.mdi-av-mic:before{content:\"\\E6AD\"}.mdi-av-mic-none:before{content:\"\\E6AE\"}.mdi-av-mic-off:before{content:\"\\E6AF\"}.mdi-av-movie:before{content:\"\\E6B0\"}.mdi-av-my-library-add:before{content:\"\\E6B1\"}.mdi-av-my-library-books:before{content:\"\\E6B2\"}.mdi-av-my-library-music:before{content:\"\\E6B3\"}.mdi-av-new-releases:before{content:\"\\E6B4\"}.mdi-av-not-interested:before{content:\"\\E6B5\"}.mdi-av-pause:before{content:\"\\E6B6\"}.mdi-av-pause-circle-fill:before{content:\"\\E6B7\"}.mdi-av-pause-circle-outline:before{content:\"\\E6B8\"}.mdi-av-play-arrow:before{content:\"\\E6B9\"}.mdi-av-play-circle-fill:before{content:\"\\E6BA\"}.mdi-av-play-circle-outline:before{content:\"\\E6BB\"}.mdi-av-playlist-add:before{content:\"\\E6BC\"}.mdi-av-play-shopping-bag:before{content:\"\\E6BD\"}.mdi-av-queue:before{content:\"\\E6BE\"}.mdi-av-queue-music:before{content:\"\\E6BF\"}.mdi-av-radio:before{content:\"\\E6C0\"}.mdi-av-recent-actors:before{content:\"\\E6C1\"}.mdi-av-repeat:before{content:\"\\E6C2\"}.mdi-av-repeat-one:before{content:\"\\E6C3\"}.mdi-av-replay:before{content:\"\\E6C4\"}.mdi-av-shuffle:before{content:\"\\E6C5\"}.mdi-av-skip-next:before{content:\"\\E6C6\"}.mdi-av-skip-previous:before{content:\"\\E6C7\"}.mdi-av-snooze:before{content:\"\\E6C8\"}.mdi-av-stop:before{content:\"\\E6C9\"}.mdi-av-subtitles:before{content:\"\\E6CA\"}.mdi-av-surround-sound:before{content:\"\\E6CB\"}.mdi-av-videocam:before{content:\"\\E6CC\"}.mdi-av-videocam-off:before{content:\"\\E6CD\"}.mdi-av-video-collection:before{content:\"\\E6CE\"}.mdi-av-volume-down:before{content:\"\\E6CF\"}.mdi-av-volume-mute:before{content:\"\\E6D0\"}.mdi-av-volume-off:before{content:\"\\E6D1\"}.mdi-av-volume-up:before{content:\"\\E6D2\"}.mdi-av-web:before{content:\"\\E6D3\"}.mdi-communication-business:before{content:\"\\E6D4\"}.mdi-communication-call:before{content:\"\\E6D5\"}.mdi-communication-call-end:before{content:\"\\E6D6\"}.mdi-communication-call-made:before{content:\"\\E6D7\"}.mdi-communication-call-merge:before{content:\"\\E6D8\"}.mdi-communication-call-missed:before{content:\"\\E6D9\"}.mdi-communication-call-received:before{content:\"\\E6DA\"}.mdi-communication-call-split:before{content:\"\\E6DB\"}.mdi-communication-chat:before{content:\"\\E6DC\"}.mdi-communication-clear-all:before{content:\"\\E6DD\"}.mdi-communication-comment:before{content:\"\\E6DE\"}.mdi-communication-contacts:before{content:\"\\E6DF\"}.mdi-communication-dialer-sip:before{content:\"\\E6E0\"}.mdi-communication-dialpad:before{content:\"\\E6E1\"}.mdi-communication-dnd-on:before{content:\"\\E6E2\"}.mdi-communication-email:before{content:\"\\E6E3\"}.mdi-communication-forum:before{content:\"\\E6E4\"}.mdi-communication-import-export:before{content:\"\\E6E5\"}.mdi-communication-invert-colors-off:before{content:\"\\E6E6\"}.mdi-communication-invert-colors-on:before{content:\"\\E6E7\"}.mdi-communication-live-help:before{content:\"\\E6E8\"}.mdi-communication-location-off:before{content:\"\\E6E9\"}.mdi-communication-location-on:before{content:\"\\E6EA\"}.mdi-communication-message:before{content:\"\\E6EB\"}.mdi-communication-messenger:before{content:\"\\E6EC\"}.mdi-communication-no-sim:before{content:\"\\E6ED\"}.mdi-communication-phone:before{content:\"\\E6EE\"}.mdi-communication-portable-wifi-off:before{content:\"\\E6EF\"}.mdi-communication-quick-contacts-dialer:before{content:\"\\E6F0\"}.mdi-communication-quick-contacts-mail:before{content:\"\\E6F1\"}.mdi-communication-ring-volume:before{content:\"\\E6F2\"}.mdi-communication-stay-current-landscape:before{content:\"\\E6F3\"}.mdi-communication-stay-current-portrait:before{content:\"\\E6F4\"}.mdi-communication-stay-primary-landscape:before{content:\"\\E6F5\"}.mdi-communication-stay-primary-portrait:before{content:\"\\E6F6\"}.mdi-communication-swap-calls:before{content:\"\\E6F7\"}.mdi-communication-textsms:before{content:\"\\E6F8\"}.mdi-communication-voicemail:before{content:\"\\E6F9\"}.mdi-communication-vpn-key:before{content:\"\\E6FA\"}.mdi-content-add:before{content:\"\\E6FB\"}.mdi-content-add-box:before{content:\"\\E6FC\"}.mdi-content-add-circle:before{content:\"\\E6FD\"}.mdi-content-add-circle-outline:before{content:\"\\E6FE\"}.mdi-content-archive:before{content:\"\\E6FF\"}.mdi-content-backspace:before{content:\"\\E700\"}.mdi-content-block:before{content:\"\\E701\"}.mdi-content-clear:before{content:\"\\E702\"}.mdi-content-content-copy:before{content:\"\\E703\"}.mdi-content-content-cut:before{content:\"\\E704\"}.mdi-content-content-paste:before{content:\"\\E705\"}.mdi-content-create:before{content:\"\\E706\"}.mdi-content-drafts:before{content:\"\\E707\"}.mdi-content-filter-list:before{content:\"\\E708\"}.mdi-content-flag:before{content:\"\\E709\"}.mdi-content-forward:before{content:\"\\E70A\"}.mdi-content-gesture:before{content:\"\\E70B\"}.mdi-content-inbox:before{content:\"\\E70C\"}.mdi-content-link:before{content:\"\\E70D\"}.mdi-content-mail:before{content:\"\\E70E\"}.mdi-content-markunread:before{content:\"\\E70F\"}.mdi-content-redo:before{content:\"\\E710\"}.mdi-content-remove:before{content:\"\\E711\"}.mdi-content-remove-circle:before{content:\"\\E712\"}.mdi-content-remove-circle-outline:before{content:\"\\E713\"}.mdi-content-reply:before{content:\"\\E714\"}.mdi-content-reply-all:before{content:\"\\E715\"}.mdi-content-report:before{content:\"\\E716\"}.mdi-content-save:before{content:\"\\E717\"}.mdi-content-select-all:before{content:\"\\E718\"}.mdi-content-send:before{content:\"\\E719\"}.mdi-content-sort:before{content:\"\\E71A\"}.mdi-content-text-format:before{content:\"\\E71B\"}.mdi-content-undo:before{content:\"\\E71C\"}.mdi-device-access-alarm:before{content:\"\\E71D\"}.mdi-device-access-alarms:before{content:\"\\E71E\"}.mdi-device-access-time:before{content:\"\\E71F\"}.mdi-device-add-alarm:before{content:\"\\E720\"}.mdi-device-airplanemode-off:before{content:\"\\E721\"}.mdi-device-airplanemode-on:before{content:\"\\E722\"}.mdi-device-battery-20:before{content:\"\\E723\"}.mdi-device-battery-30:before{content:\"\\E724\"}.mdi-device-battery-50:before{content:\"\\E725\"}.mdi-device-battery-60:before{content:\"\\E726\"}.mdi-device-battery-80:before{content:\"\\E727\"}.mdi-device-battery-90:before{content:\"\\E728\"}.mdi-device-battery-alert:before{content:\"\\E729\"}.mdi-device-battery-charging-20:before{content:\"\\E72A\"}.mdi-device-battery-charging-30:before{content:\"\\E72B\"}.mdi-device-battery-charging-50:before{content:\"\\E72C\"}.mdi-device-battery-charging-60:before{content:\"\\E72D\"}.mdi-device-battery-charging-80:before{content:\"\\E72E\"}.mdi-device-battery-charging-90:before{content:\"\\E72F\"}.mdi-device-battery-charging-full:before{content:\"\\E730\"}.mdi-device-battery-full:before{content:\"\\E731\"}.mdi-device-battery-std:before{content:\"\\E732\"}.mdi-device-battery-unknown:before{content:\"\\E733\"}.mdi-device-bluetooth:before{content:\"\\E734\"}.mdi-device-bluetooth-connected:before{content:\"\\E735\"}.mdi-device-bluetooth-disabled:before{content:\"\\E736\"}.mdi-device-bluetooth-searching:before{content:\"\\E737\"}.mdi-device-brightness-auto:before{content:\"\\E738\"}.mdi-device-brightness-high:before{content:\"\\E739\"}.mdi-device-brightness-low:before{content:\"\\E73A\"}.mdi-device-brightness-medium:before{content:\"\\E73B\"}.mdi-device-data-usage:before{content:\"\\E73C\"}.mdi-device-developer-mode:before{content:\"\\E73D\"}.mdi-device-devices:before{content:\"\\E73E\"}.mdi-device-dvr:before{content:\"\\E73F\"}.mdi-device-gps-fixed:before{content:\"\\E740\"}.mdi-device-gps-not-fixed:before{content:\"\\E741\"}.mdi-device-gps-off:before{content:\"\\E742\"}.mdi-device-location-disabled:before{content:\"\\E743\"}.mdi-device-location-searching:before{content:\"\\E744\"}.mdi-device-multitrack-audio:before{content:\"\\E745\"}.mdi-device-network-cell:before{content:\"\\E746\"}.mdi-device-network-wifi:before{content:\"\\E747\"}.mdi-device-nfc:before{content:\"\\E748\"}.mdi-device-now-wallpaper:before{content:\"\\E749\"}.mdi-device-now-widgets:before{content:\"\\E74A\"}.mdi-device-screen-lock-landscape:before{content:\"\\E74B\"}.mdi-device-screen-lock-portrait:before{content:\"\\E74C\"}.mdi-device-screen-lock-rotation:before{content:\"\\E74D\"}.mdi-device-screen-rotation:before{content:\"\\E74E\"}.mdi-device-sd-storage:before{content:\"\\E74F\"}.mdi-device-settings-system-daydream:before{content:\"\\E750\"}.mdi-device-signal-cellular-0-bar:before{content:\"\\E751\"}.mdi-device-signal-cellular-1-bar:before{content:\"\\E752\"}.mdi-device-signal-cellular-2-bar:before{content:\"\\E753\"}.mdi-device-signal-cellular-3-bar:before{content:\"\\E754\"}.mdi-device-signal-cellular-4-bar:before{content:\"\\E755\"}.mdi-device-signal-cellular-connected-no-internet-0-bar:before{content:\"\\E756\"}.mdi-device-signal-cellular-connected-no-internet-1-bar:before{content:\"\\E757\"}.mdi-device-signal-cellular-connected-no-internet-2-bar:before{content:\"\\E758\"}.mdi-device-signal-cellular-connected-no-internet-3-bar:before{content:\"\\E759\"}.mdi-device-signal-cellular-connected-no-internet-4-bar:before{content:\"\\E75A\"}.mdi-device-signal-cellular-no-sim:before{content:\"\\E75B\"}.mdi-device-signal-cellular-null:before{content:\"\\E75C\"}.mdi-device-signal-cellular-off:before{content:\"\\E75D\"}.mdi-device-signal-wifi-0-bar:before{content:\"\\E75E\"}.mdi-device-signal-wifi-1-bar:before{content:\"\\E75F\"}.mdi-device-signal-wifi-2-bar:before{content:\"\\E760\"}.mdi-device-signal-wifi-3-bar:before{content:\"\\E761\"}.mdi-device-signal-wifi-4-bar:before{content:\"\\E762\"}.mdi-device-signal-wifi-off:before{content:\"\\E763\"}.mdi-device-storage:before{content:\"\\E764\"}.mdi-device-usb:before{content:\"\\E765\"}.mdi-device-wifi-lock:before{content:\"\\E766\"}.mdi-device-wifi-tethering:before{content:\"\\E767\"}.mdi-editor-attach-file:before{content:\"\\E768\"}.mdi-editor-attach-money:before{content:\"\\E769\"}.mdi-editor-border-all:before{content:\"\\E76A\"}.mdi-editor-border-bottom:before{content:\"\\E76B\"}.mdi-editor-border-clear:before{content:\"\\E76C\"}.mdi-editor-border-color:before{content:\"\\E76D\"}.mdi-editor-border-horizontal:before{content:\"\\E76E\"}.mdi-editor-border-inner:before{content:\"\\E76F\"}.mdi-editor-border-left:before{content:\"\\E770\"}.mdi-editor-border-outer:before{content:\"\\E771\"}.mdi-editor-border-right:before{content:\"\\E772\"}.mdi-editor-border-style:before{content:\"\\E773\"}.mdi-editor-border-top:before{content:\"\\E774\"}.mdi-editor-border-vertical:before{content:\"\\E775\"}.mdi-editor-format-align-center:before{content:\"\\E776\"}.mdi-editor-format-align-justify:before{content:\"\\E777\"}.mdi-editor-format-align-left:before{content:\"\\E778\"}.mdi-editor-format-align-right:before{content:\"\\E779\"}.mdi-editor-format-bold:before{content:\"\\E77A\"}.mdi-editor-format-clear:before{content:\"\\E77B\"}.mdi-editor-format-color-fill:before{content:\"\\E77C\"}.mdi-editor-format-color-reset:before{content:\"\\E77D\"}.mdi-editor-format-color-text:before{content:\"\\E77E\"}.mdi-editor-format-indent-decrease:before{content:\"\\E77F\"}.mdi-editor-format-indent-increase:before{content:\"\\E780\"}.mdi-editor-format-italic:before{content:\"\\E781\"}.mdi-editor-format-line-spacing:before{content:\"\\E782\"}.mdi-editor-format-list-bulleted:before{content:\"\\E783\"}.mdi-editor-format-list-numbered:before{content:\"\\E784\"}.mdi-editor-format-paint:before{content:\"\\E785\"}.mdi-editor-format-quote:before{content:\"\\E786\"}.mdi-editor-format-size:before{content:\"\\E787\"}.mdi-editor-format-strikethrough:before{content:\"\\E788\"}.mdi-editor-format-textdirection-l-to-r:before{content:\"\\E789\"}.mdi-editor-format-textdirection-r-to-l:before{content:\"\\E78A\"}.mdi-editor-format-underline:before{content:\"\\E78B\"}.mdi-editor-functions:before{content:\"\\E78C\"}.mdi-editor-insert-chart:before{content:\"\\E78D\"}.mdi-editor-insert-comment:before{content:\"\\E78E\"}.mdi-editor-insert-drive-file:before{content:\"\\E78F\"}.mdi-editor-insert-emoticon:before{content:\"\\E790\"}.mdi-editor-insert-invitation:before{content:\"\\E791\"}.mdi-editor-insert-link:before{content:\"\\E792\"}.mdi-editor-insert-photo:before{content:\"\\E793\"}.mdi-editor-merge-type:before{content:\"\\E794\"}.mdi-editor-mode-comment:before{content:\"\\E795\"}.mdi-editor-mode-edit:before{content:\"\\E796\"}.mdi-editor-publish:before{content:\"\\E797\"}.mdi-editor-vertical-align-bottom:before{content:\"\\E798\"}.mdi-editor-vertical-align-center:before{content:\"\\E799\"}.mdi-editor-vertical-align-top:before{content:\"\\E79A\"}.mdi-editor-wrap-text:before{content:\"\\E79B\"}.mdi-file-attachment:before{content:\"\\E79C\"}.mdi-file-cloud:before{content:\"\\E79D\"}.mdi-file-cloud-circle:before{content:\"\\E79E\"}.mdi-file-cloud-done:before{content:\"\\E79F\"}.mdi-file-cloud-download:before{content:\"\\E7A0\"}.mdi-file-cloud-off:before{content:\"\\E7A1\"}.mdi-file-cloud-queue:before{content:\"\\E7A2\"}.mdi-file-cloud-upload:before{content:\"\\E7A3\"}.mdi-file-file-download:before{content:\"\\E7A4\"}.mdi-file-file-upload:before{content:\"\\E7A5\"}.mdi-file-folder:before{content:\"\\E7A6\"}.mdi-file-folder-open:before{content:\"\\E7A7\"}.mdi-file-folder-shared:before{content:\"\\E7A8\"}.mdi-hardware-cast:before{content:\"\\E7A9\"}.mdi-hardware-cast-connected:before{content:\"\\E7AA\"}.mdi-hardware-computer:before{content:\"\\E7AB\"}.mdi-hardware-desktop-mac:before{content:\"\\E7AC\"}.mdi-hardware-desktop-windows:before{content:\"\\E7AD\"}.mdi-hardware-dock:before{content:\"\\E7AE\"}.mdi-hardware-gamepad:before{content:\"\\E7AF\"}.mdi-hardware-headset:before{content:\"\\E7B0\"}.mdi-hardware-headset-mic:before{content:\"\\E7B1\"}.mdi-hardware-keyboard:before{content:\"\\E7B2\"}.mdi-hardware-keyboard-alt:before{content:\"\\E7B3\"}.mdi-hardware-keyboard-arrow-down:before{content:\"\\E7B4\"}.mdi-hardware-keyboard-arrow-left:before{content:\"\\E7B5\"}.mdi-hardware-keyboard-arrow-right:before{content:\"\\E7B6\"}.mdi-hardware-keyboard-arrow-up:before{content:\"\\E7B7\"}.mdi-hardware-keyboard-backspace:before{content:\"\\E7B8\"}.mdi-hardware-keyboard-capslock:before{content:\"\\E7B9\"}.mdi-hardware-keyboard-control:before{content:\"\\E7BA\"}.mdi-hardware-keyboard-hide:before{content:\"\\E7BB\"}.mdi-hardware-keyboard-return:before{content:\"\\E7BC\"}.mdi-hardware-keyboard-tab:before{content:\"\\E7BD\"}.mdi-hardware-keyboard-voice:before{content:\"\\E7BE\"}.mdi-hardware-laptop:before{content:\"\\E7BF\"}.mdi-hardware-laptop-chromebook:before{content:\"\\E7C0\"}.mdi-hardware-laptop-mac:before{content:\"\\E7C1\"}.mdi-hardware-laptop-windows:before{content:\"\\E7C2\"}.mdi-hardware-memory:before{content:\"\\E7C3\"}.mdi-hardware-mouse:before{content:\"\\E7C4\"}.mdi-hardware-phone-android:before{content:\"\\E7C5\"}.mdi-hardware-phone-iphone:before{content:\"\\E7C6\"}.mdi-hardware-phonelink:before{content:\"\\E7C7\"}.mdi-hardware-phonelink-off:before{content:\"\\E7C8\"}.mdi-hardware-security:before{content:\"\\E7C9\"}.mdi-hardware-sim-card:before{content:\"\\E7CA\"}.mdi-hardware-smartphone:before{content:\"\\E7CB\"}.mdi-hardware-speaker:before{content:\"\\E7CC\"}.mdi-hardware-tablet:before{content:\"\\E7CD\"}.mdi-hardware-tablet-android:before{content:\"\\E7CE\"}.mdi-hardware-tablet-mac:before{content:\"\\E7CF\"}.mdi-hardware-tv:before{content:\"\\E7D0\"}.mdi-hardware-watch:before{content:\"\\E7D1\"}.mdi-image-add-to-photos:before{content:\"\\E7D2\"}.mdi-image-adjust:before{content:\"\\E7D3\"}.mdi-image-assistant-photo:before{content:\"\\E7D4\"}.mdi-image-audiotrack:before{content:\"\\E7D5\"}.mdi-image-blur-circular:before{content:\"\\E7D6\"}.mdi-image-blur-linear:before{content:\"\\E7D7\"}.mdi-image-blur-off:before{content:\"\\E7D8\"}.mdi-image-blur-on:before{content:\"\\E7D9\"}.mdi-image-brightness-1:before{content:\"\\E7DA\"}.mdi-image-brightness-2:before{content:\"\\E7DB\"}.mdi-image-brightness-3:before{content:\"\\E7DC\"}.mdi-image-brightness-4:before{content:\"\\E7DD\"}.mdi-image-brightness-5:before{content:\"\\E7DE\"}.mdi-image-brightness-6:before{content:\"\\E7DF\"}.mdi-image-brightness-7:before{content:\"\\E7E0\"}.mdi-image-brush:before{content:\"\\E7E1\"}.mdi-image-camera:before{content:\"\\E7E2\"}.mdi-image-camera-alt:before{content:\"\\E7E3\"}.mdi-image-camera-front:before{content:\"\\E7E4\"}.mdi-image-camera-rear:before{content:\"\\E7E5\"}.mdi-image-camera-roll:before{content:\"\\E7E6\"}.mdi-image-center-focus-strong:before{content:\"\\E7E7\"}.mdi-image-center-focus-weak:before{content:\"\\E7E8\"}.mdi-image-collections:before{content:\"\\E7E9\"}.mdi-image-colorize:before{content:\"\\E7EA\"}.mdi-image-color-lens:before{content:\"\\E7EB\"}.mdi-image-compare:before{content:\"\\E7EC\"}.mdi-image-control-point:before{content:\"\\E7ED\"}.mdi-image-control-point-duplicate:before{content:\"\\E7EE\"}.mdi-image-crop:before{content:\"\\E7EF\"}.mdi-image-crop-3-2:before{content:\"\\E7F0\"}.mdi-image-crop-5-4:before{content:\"\\E7F1\"}.mdi-image-crop-7-5:before{content:\"\\E7F2\"}.mdi-image-crop-16-9:before{content:\"\\E7F3\"}.mdi-image-crop-din:before{content:\"\\E7F4\"}.mdi-image-crop-free:before{content:\"\\E7F5\"}.mdi-image-crop-landscape:before{content:\"\\E7F6\"}.mdi-image-crop-original:before{content:\"\\E7F7\"}.mdi-image-crop-portrait:before{content:\"\\E7F8\"}.mdi-image-crop-square:before{content:\"\\E7F9\"}.mdi-image-dehaze:before{content:\"\\E7FA\"}.mdi-image-details:before{content:\"\\E7FB\"}.mdi-image-edit:before{content:\"\\E7FC\"}.mdi-image-exposure:before{content:\"\\E7FD\"}.mdi-image-exposure-minus-1:before{content:\"\\E7FE\"}.mdi-image-exposure-minus-2:before{content:\"\\E7FF\"}.mdi-image-exposure-plus-1:before{content:\"\\E800\"}.mdi-image-exposure-plus-2:before{content:\"\\E801\"}.mdi-image-exposure-zero:before{content:\"\\E802\"}.mdi-image-filter:before{content:\"\\E803\"}.mdi-image-filter-1:before{content:\"\\E804\"}.mdi-image-filter-2:before{content:\"\\E805\"}.mdi-image-filter-3:before{content:\"\\E806\"}.mdi-image-filter-4:before{content:\"\\E807\"}.mdi-image-filter-5:before{content:\"\\E808\"}.mdi-image-filter-6:before{content:\"\\E809\"}.mdi-image-filter-7:before{content:\"\\E80A\"}.mdi-image-filter-8:before{content:\"\\E80B\"}.mdi-image-filter-9:before{content:\"\\E80C\"}.mdi-image-filter-9-plus:before{content:\"\\E80D\"}.mdi-image-filter-b-and-w:before{content:\"\\E80E\"}.mdi-image-filter-center-focus:before{content:\"\\E80F\"}.mdi-image-filter-drama:before{content:\"\\E810\"}.mdi-image-filter-frames:before{content:\"\\E811\"}.mdi-image-filter-hdr:before{content:\"\\E812\"}.mdi-image-filter-none:before{content:\"\\E813\"}.mdi-image-filter-tilt-shift:before{content:\"\\E814\"}.mdi-image-filter-vintage:before{content:\"\\E815\"}.mdi-image-flare:before{content:\"\\E816\"}.mdi-image-flash-auto:before{content:\"\\E817\"}.mdi-image-flash-off:before{content:\"\\E818\"}.mdi-image-flash-on:before{content:\"\\E819\"}.mdi-image-flip:before{content:\"\\E81A\"}.mdi-image-gradient:before{content:\"\\E81B\"}.mdi-image-grain:before{content:\"\\E81C\"}.mdi-image-grid-off:before{content:\"\\E81D\"}.mdi-image-grid-on:before{content:\"\\E81E\"}.mdi-image-hdr-off:before{content:\"\\E81F\"}.mdi-image-hdr-on:before{content:\"\\E820\"}.mdi-image-hdr-strong:before{content:\"\\E821\"}.mdi-image-hdr-weak:before{content:\"\\E822\"}.mdi-image-healing:before{content:\"\\E823\"}.mdi-image-image:before{content:\"\\E824\"}.mdi-image-image-aspect-ratio:before{content:\"\\E825\"}.mdi-image-iso:before{content:\"\\E826\"}.mdi-image-landscape:before{content:\"\\E827\"}.mdi-image-leak-add:before{content:\"\\E828\"}.mdi-image-leak-remove:before{content:\"\\E829\"}.mdi-image-lens:before{content:\"\\E82A\"}.mdi-image-looks:before{content:\"\\E82B\"}.mdi-image-looks-3:before{content:\"\\E82C\"}.mdi-image-looks-4:before{content:\"\\E82D\"}.mdi-image-looks-5:before{content:\"\\E82E\"}.mdi-image-looks-6:before{content:\"\\E82F\"}.mdi-image-looks-one:before{content:\"\\E830\"}.mdi-image-looks-two:before{content:\"\\E831\"}.mdi-image-loupe:before{content:\"\\E832\"}.mdi-image-movie-creation:before{content:\"\\E833\"}.mdi-image-nature:before{content:\"\\E834\"}.mdi-image-nature-people:before{content:\"\\E835\"}.mdi-image-navigate-before:before{content:\"\\E836\"}.mdi-image-navigate-next:before{content:\"\\E837\"}.mdi-image-palette:before{content:\"\\E838\"}.mdi-image-panorama:before{content:\"\\E839\"}.mdi-image-panorama-fisheye:before{content:\"\\E83A\"}.mdi-image-panorama-horizontal:before{content:\"\\E83B\"}.mdi-image-panorama-vertical:before{content:\"\\E83C\"}.mdi-image-panorama-wide-angle:before{content:\"\\E83D\"}.mdi-image-photo:before{content:\"\\E83E\"}.mdi-image-photo-album:before{content:\"\\E83F\"}.mdi-image-photo-camera:before{content:\"\\E840\"}.mdi-image-photo-library:before{content:\"\\E841\"}.mdi-image-portrait:before{content:\"\\E842\"}.mdi-image-remove-red-eye:before{content:\"\\E843\"}.mdi-image-rotate-left:before{content:\"\\E844\"}.mdi-image-rotate-right:before{content:\"\\E845\"}.mdi-image-slideshow:before{content:\"\\E846\"}.mdi-image-straighten:before{content:\"\\E847\"}.mdi-image-style:before{content:\"\\E848\"}.mdi-image-switch-camera:before{content:\"\\E849\"}.mdi-image-switch-video:before{content:\"\\E84A\"}.mdi-image-tag-faces:before{content:\"\\E84B\"}.mdi-image-texture:before{content:\"\\E84C\"}.mdi-image-timelapse:before{content:\"\\E84D\"}.mdi-image-timer:before{content:\"\\E84E\"}.mdi-image-timer-3:before{content:\"\\E84F\"}.mdi-image-timer-10:before{content:\"\\E850\"}.mdi-image-timer-auto:before{content:\"\\E851\"}.mdi-image-timer-off:before{content:\"\\E852\"}.mdi-image-tonality:before{content:\"\\E853\"}.mdi-image-transform:before{content:\"\\E854\"}.mdi-image-tune:before{content:\"\\E855\"}.mdi-image-wb-auto:before{content:\"\\E856\"}.mdi-image-wb-cloudy:before{content:\"\\E857\"}.mdi-image-wb-incandescent:before{content:\"\\E858\"}.mdi-image-wb-irradescent:before{content:\"\\E859\"}.mdi-image-wb-sunny:before{content:\"\\E85A\"}.mdi-maps-beenhere:before{content:\"\\E85B\"}.mdi-maps-directions:before{content:\"\\E85C\"}.mdi-maps-directions-bike:before{content:\"\\E85D\"}.mdi-maps-directions-bus:before{content:\"\\E85E\"}.mdi-maps-directions-car:before{content:\"\\E85F\"}.mdi-maps-directions-ferry:before{content:\"\\E860\"}.mdi-maps-directions-subway:before{content:\"\\E861\"}.mdi-maps-directions-train:before{content:\"\\E862\"}.mdi-maps-directions-transit:before{content:\"\\E863\"}.mdi-maps-directions-walk:before{content:\"\\E864\"}.mdi-maps-flight:before{content:\"\\E865\"}.mdi-maps-hotel:before{content:\"\\E866\"}.mdi-maps-layers:before{content:\"\\E867\"}.mdi-maps-layers-clear:before{content:\"\\E868\"}.mdi-maps-local-airport:before{content:\"\\E869\"}.mdi-maps-local-atm:before{content:\"\\E86A\"}.mdi-maps-local-attraction:before{content:\"\\E86B\"}.mdi-maps-local-bar:before{content:\"\\E86C\"}.mdi-maps-local-cafe:before{content:\"\\E86D\"}.mdi-maps-local-car-wash:before{content:\"\\E86E\"}.mdi-maps-local-convenience-store:before{content:\"\\E86F\"}.mdi-maps-local-drink:before{content:\"\\E870\"}.mdi-maps-local-florist:before{content:\"\\E871\"}.mdi-maps-local-gas-station:before{content:\"\\E872\"}.mdi-maps-local-grocery-store:before{content:\"\\E873\"}.mdi-maps-local-hospital:before{content:\"\\E874\"}.mdi-maps-local-hotel:before{content:\"\\E875\"}.mdi-maps-local-laundry-service:before{content:\"\\E876\"}.mdi-maps-local-library:before{content:\"\\E877\"}.mdi-maps-local-mall:before{content:\"\\E878\"}.mdi-maps-local-movies:before{content:\"\\E879\"}.mdi-maps-local-offer:before{content:\"\\E87A\"}.mdi-maps-local-parking:before{content:\"\\E87B\"}.mdi-maps-local-pharmacy:before{content:\"\\E87C\"}.mdi-maps-local-phone:before{content:\"\\E87D\"}.mdi-maps-local-pizza:before{content:\"\\E87E\"}.mdi-maps-local-play:before{content:\"\\E87F\"}.mdi-maps-local-post-office:before{content:\"\\E880\"}.mdi-maps-local-print-shop:before{content:\"\\E881\"}.mdi-maps-local-restaurant:before{content:\"\\E882\"}.mdi-maps-local-see:before{content:\"\\E883\"}.mdi-maps-local-shipping:before{content:\"\\E884\"}.mdi-maps-local-taxi:before{content:\"\\E885\"}.mdi-maps-location-history:before{content:\"\\E886\"}.mdi-maps-map:before{content:\"\\E887\"}.mdi-maps-my-location:before{content:\"\\E888\"}.mdi-maps-navigation:before{content:\"\\E889\"}.mdi-maps-pin-drop:before{content:\"\\E88A\"}.mdi-maps-place:before{content:\"\\E88B\"}.mdi-maps-rate-review:before{content:\"\\E88C\"}.mdi-maps-restaurant-menu:before{content:\"\\E88D\"}.mdi-maps-satellite:before{content:\"\\E88E\"}.mdi-maps-store-mall-directory:before{content:\"\\E88F\"}.mdi-maps-terrain:before{content:\"\\E890\"}.mdi-maps-traffic:before{content:\"\\E891\"}.mdi-navigation-apps:before{content:\"\\E892\"}.mdi-navigation-arrow-back:before{content:\"\\E893\"}.mdi-navigation-arrow-drop-down:before{content:\"\\E894\"}.mdi-navigation-arrow-drop-down-circle:before{content:\"\\E895\"}.mdi-navigation-arrow-drop-up:before{content:\"\\E896\"}.mdi-navigation-arrow-forward:before{content:\"\\E897\"}.mdi-navigation-cancel:before{content:\"\\E898\"}.mdi-navigation-check:before{content:\"\\E899\"}.mdi-navigation-chevron-left:before{content:\"\\E89A\"}.mdi-navigation-chevron-right:before{content:\"\\E89B\"}.mdi-navigation-close:before{content:\"\\E89C\"}.mdi-navigation-expand-less:before{content:\"\\E89D\"}.mdi-navigation-expand-more:before{content:\"\\E89E\"}.mdi-navigation-fullscreen:before{content:\"\\E89F\"}.mdi-navigation-fullscreen-exit:before{content:\"\\E8A0\"}.mdi-navigation-menu:before{content:\"\\E8A1\"}.mdi-navigation-more-horiz:before{content:\"\\E8A2\"}.mdi-navigation-more-vert:before{content:\"\\E8A3\"}.mdi-navigation-refresh:before{content:\"\\E8A4\"}.mdi-navigation-unfold-less:before{content:\"\\E8A5\"}.mdi-navigation-unfold-more:before{content:\"\\E8A6\"}.mdi-notification-adb:before{content:\"\\E8A7\"}.mdi-notification-bluetooth-audio:before{content:\"\\E8A8\"}.mdi-notification-disc-full:before{content:\"\\E8A9\"}.mdi-notification-dnd-forwardslash:before{content:\"\\E8AA\"}.mdi-notification-do-not-disturb:before{content:\"\\E8AB\"}.mdi-notification-drive-eta:before{content:\"\\E8AC\"}.mdi-notification-event-available:before{content:\"\\E8AD\"}.mdi-notification-event-busy:before{content:\"\\E8AE\"}.mdi-notification-event-note:before{content:\"\\E8AF\"}.mdi-notification-folder-special:before{content:\"\\E8B0\"}.mdi-notification-mms:before{content:\"\\E8B1\"}.mdi-notification-more:before{content:\"\\E8B2\"}.mdi-notification-network-locked:before{content:\"\\E8B3\"}.mdi-notification-phone-bluetooth-speaker:before{content:\"\\E8B4\"}.mdi-notification-phone-forwarded:before{content:\"\\E8B5\"}.mdi-notification-phone-in-talk:before{content:\"\\E8B6\"}.mdi-notification-phone-locked:before{content:\"\\E8B7\"}.mdi-notification-phone-missed:before{content:\"\\E8B8\"}.mdi-notification-phone-paused:before{content:\"\\E8B9\"}.mdi-notification-play-download:before{content:\"\\E8BA\"}.mdi-notification-play-install:before{content:\"\\E8BB\"}.mdi-notification-sd-card:before{content:\"\\E8BC\"}.mdi-notification-sim-card-alert:before{content:\"\\E8BD\"}.mdi-notification-sms:before{content:\"\\E8BE\"}.mdi-notification-sms-failed:before{content:\"\\E8BF\"}.mdi-notification-sync:before{content:\"\\E8C0\"}.mdi-notification-sync-disabled:before{content:\"\\E8C1\"}.mdi-notification-sync-problem:before{content:\"\\E8C2\"}.mdi-notification-system-update:before{content:\"\\E8C3\"}.mdi-notification-tap-and-play:before{content:\"\\E8C4\"}.mdi-notification-time-to-leave:before{content:\"\\E8C5\"}.mdi-notification-vibration:before{content:\"\\E8C6\"}.mdi-notification-voice-chat:before{content:\"\\E8C7\"}.mdi-notification-vpn-lock:before{content:\"\\E8C8\"}.mdi-social-cake:before{content:\"\\E8C9\"}.mdi-social-domain:before{content:\"\\E8CA\"}.mdi-social-group:before{content:\"\\E8CB\"}.mdi-social-group-add:before{content:\"\\E8CC\"}.mdi-social-location-city:before{content:\"\\E8CD\"}.mdi-social-mood:before{content:\"\\E8CE\"}.mdi-social-notifications:before{content:\"\\E8CF\"}.mdi-social-notifications-none:before{content:\"\\E8D0\"}.mdi-social-notifications-off:before{content:\"\\E8D1\"}.mdi-social-notifications-on:before{content:\"\\E8D2\"}.mdi-social-notifications-paused:before{content:\"\\E8D3\"}.mdi-social-pages:before{content:\"\\E8D4\"}.mdi-social-party-mode:before{content:\"\\E8D5\"}.mdi-social-people:before{content:\"\\E8D6\"}.mdi-social-people-outline:before{content:\"\\E8D7\"}.mdi-social-person:before{content:\"\\E8D8\"}.mdi-social-person-add:before{content:\"\\E8D9\"}.mdi-social-person-outline:before{content:\"\\E8DA\"}.mdi-social-plus-one:before{content:\"\\E8DB\"}.mdi-social-poll:before{content:\"\\E8DC\"}.mdi-social-public:before{content:\"\\E8DD\"}.mdi-social-school:before{content:\"\\E8DE\"}.mdi-social-share:before{content:\"\\E8DF\"}.mdi-social-whatshot:before{content:\"\\E8E0\"}.mdi-toggle-check-box:before{content:\"\\E8E1\"}.mdi-toggle-check-box-outline-blank:before{content:\"\\E8E2\"}.mdi-toggle-radio-button-off:before{content:\"\\E8E3\"}.mdi-toggle-radio-button-on:before{content:\"\\E8E4\"}.container_main{visibility:hidden;z-index:10;position:absolute;bottom:0;right:0;overflow-x:hidden;overflow-y:hidden}.container_firts{float:right}.container_contacts{height:397px;float:right;bottom:0;width:230px;position:relative}.container_chats{height:397px;float:left;width:250px;position:relative}.contatcs_child{visibility:visible;position:absolute;bottom:0;right:10px}.name_chatOpened{display:flex;justify-content:space-between}.alert_icon{color:#ccc}.item-count{display:flex;justify-content:center;font-size:20px;color:#fff}.chat_opened{visibility:visible;height:397px;float:left;position:fixed}.list-messageBoxes{list-style-type:none;padding:0}.list-messageBoxes li{font-size:12px;font-family:sans-serif;padding:2px;cursor:pointer;display:flex;justify-content:space-between}.list-messageBoxes li a{padding:0 0 0 9px}.list-messageBoxes li a:hover{font-weight:600}.view-messageBoxes{padding:10px 10px 1px;background:#bdbdbd;background:#faf7f7}.anch-div{width:160px;padding-left:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.time_class{text-align:center;margin-bottom:10px}.t-c,.t-c-con{height:30px;background:#fff;padding-top:5px}.t-c-con{font-size:90%;width:190px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-c-a{padding:4px 8px 0 0}.timeStamp{background:#fff;padding:2px;font-size:10px;font-family:cursive;border-radius:7px;border:1px solid;border-color:#dedede}.delet_pos{margin-left:90%;color:transparent}.t-c-c{width:160px;padding-left:10px;height:30px;background:#fff;padding-top:5px}.t-c-c,.t-c-c-d{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-c-c-d{font-size:90%;cursor:none;width:170px}.f-c{height:30px;background:#6d7c7b;border-radius:1px;padding-top:5px}.msj_new{width:23px}.f-m-n{width:22px;text-align:center}.pos_div{padding:4px 0 0 3px}.f-c-h{height:30px;background:#6d7c7b;border-radius:1px;padding-top:5px;width:40px;float:right}.c-d-c{width:210px}.c-d-c,.c-d-c-c{display:flex;background:#fff}.c-d-f{display:flex}.c-l-c{height:240px;width:100%;background:#faf7f7;overflow-x:hidden;overflow-y:scroll}.c-l-c::-webkit-scrollbar{width:10px}.c-l-c::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.1)}.c-t{height:300px;width:100%;background:#faf7f7}.inf-lab{color:#f8f8f8;font-size:90%}.shadow-body{margin-top:1px;border-radius:2px;margin-right:0!important;margin-left:0!important;box-shadow:0 0 1px 1px #9e9e9e}.icon-load{margin-left:auto;margin-right:45px;margin-bottom:-5px;font-size:10px;color:#999}.truncate{width:170px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.chatbox{width:500px;min-width:390px;height:420px;background:#fff;padding:25px;margin:20px auto}.chatlogs{padding:10px;width:100%;height:300px;overflow-x:hidden;overflow-y:scroll}.chatlogs::-webkit-scrollbar{width:10px}.chatlogs::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.1)}.chat-message i:hover{cursor:pointer;color:#fff}.chat{display:flex;flex-flow:row wrap;align-items:flex-start}.chat .user-photo{width:35px;height:35px;background:#ccc;border-radius:50%;overflow:hidden}.chat .user-photo img{width:100%;height:100%}.chat .chat-message{width:73%;padding:7px;margin:0 5px;border-radius:3px;color:#fff;overflow-wrap:break-word;font-size:12px;line-height:13px}.chat .chat-time{width:73%;margin:0 5px 0 40px;font-size:10px}.friend .chat-message{background:#a9a9a9}.self .chat-message{background:#727272;order:-1}.chat-form{display:flex;align-items:inline-flex}.back-textarea{background:#faf7f7;height:36px}.chat-form-textarea textarea{background:#fbfbfb;width:110%;margin-left:-10px;height:30px;border:2px solid #eee;border-radius:3px;resize:none;padding:2px;font-size:15px;color:#777}.chat-form-textarea textarea:focus{background:#fff}.chat-form-textarea textarea::-webkit-scrollbar{width:10px}.chat-form-textarea textarea::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.2)}.back-button{background:#faf7f7;padding-left:21px}.chat-form-button button{background:#41ba6c;margin-bottom:7px;font-family:Comic Sans MS;padding:6px 14px;font-size:12px;color:#fff;border:none;border-radius:1px;cursor:pointer;margin-left:-33px;-webkit-transition:background .2 ease;-moz-transition:background .2 ease;-o-transition:background .2 ease}.chat-form-button button:hover{background:#13c8d9}.icon-pos{margin-left:-10px;margin-top:25px}.contact{margin-top:7px;cursor:pointer}.nm{width:115px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.nm p{font-size:11.5px;margin-top:-5px}.itms{font-family:Comic Sans MS}.pos-itms{margin-left:10px}.pos-label{padding:1px 0 0 8px;margin-left:-15px}.text-gris{color:#929090}.delete_message{font-size:13px}.delete_message a{padding:10px}.color-text-alert,.text-no,.text-si{font-family:sans-serif}.delete_message,.snackbar{visibility:visible;background-color:#333;color:#fff;text-align:center;border-radius:2px;padding:5px 0 0;bottom:30px;position:fixed;min-width:205px;margin-bottom:37px;box-shadow:0 0 1px 1px #9e9e9e}@keyframes fadein{0%{bottom:0;opacity:0}to{bottom:30px;opacity:1}}@keyframes fadeout{0%{bottom:30px;opacity:1}to{bottom:0;opacity:0}}", ""]);
	
	// exports


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89a3515ab59a462f31366909b3e727e2.png";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6c8f67be1c1934a14e0230509631b0c1.png";

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	module.exports = "<nav ui-nav> <ul class=nav id=navtoolkit> <li ng-repeat=\"item in subitems track by $index\" ui-sref-active=active ng-click=menuClick($event,$index) id=parent_li_{{$index}} class=\"parent_li text-gris-dark\" ng-show=item.showif> <a md-ink-ripple ng-if=!item[0].url> <span class=\"pull-right text-muted\" ng-if=item[0].subMenu> <i class=\"fa fa-caret-down\"></i> </span> <i class=\"pull-right up\"><b class=\"badge no-bg\">{{item[0].count}}</b></i> <i class=\"icon {{item[0].icon}} i-20\"></i> <span class=\"font-normal menu_title\">{{item[0].title | translate}}</span> </a> <a md-ink-ripple href={{item[0].url}} target=_blank ng-if=item[0].url> <i class=\"icon {{item[0].icon}} i-20\"></i> <span class=\"font-normal menu_title\">{{item[0].title}}</span> </a> <ul class=\"nav nav-sub\"> <li ng-repeat=\"items in item[0].subMenu track by $index\" ui-sref-active=active ng-click=superMenu($event,$index) id=super_menu_li_{{$index}} class=super_menu_li ng-show=\"items.showif && \n                   validateIfWorkPlanActive(items.showIfWorkplanActive) && \n                   validateSubModule(items.menuRoleId, items.stageId) \"> <a md-ink-ripple ng-if=\"items.url && items.url !== '#'\" ui-sref={{items.url}}> {{items.title | translate}} </a> <a md-ink-ripple ng-if=\"items.url == '#' && items.onclick\" ng-click=callFunction(items.onclick)> {{items.title | translate}} </a> <a md-ink-ripple ng-if=\"items.url =='#' && !items.onclick\" ui-sref={{items.url}}> {{items.title | translate}} </a> <a md-ink-ripple class=super_menu_li_sub_a ng-if=\"items.url === ''\"> {{items.title}} <span class=\"pull-right text-muted\"> <i class=\"fa fa-caret-down\"></i> </span> <i class=\"pull-right up\"></i> </a> <ul class=\"nav nav-sub super_menu_li_sub\"> <li ng-repeat=\"supersubitem in items.superMenu\" class=super_menu_li_sub ui-sref-active=active> <a class=navbar-collapse md-ink-ripple ng-if=supersubitem.url ui-sref={{supersubitem.url}}> {{supersubitem.title}} </a> </li> </ul> </li> </ul> </li> <li class=\"b-b b m-v-sm\"></li> </ul> </nav> ";

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	module.exports = "<ol class=\"breadcrumb text-xs\"> <li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{ active: crumb.active }\"> <a href=\"{{ crumb.route }}\" ng-if=\"!crumb.active && !crumb.hideLink\">{{ crumb.displayName }}</a> <a ng-if=\"!crumb.active && crumb.hideLink\">{{ crumb.displayName }}</a> <span ng-show=crumb.active>{{ crumb.displayName }}</span> </li> </ol>";

/***/ })
]);


// WEBPACK FOOTER //
// app.774d96197f62b8d081e9.js